webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1151);
	module.exports = __webpack_require__(1727);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(97);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return isArray(this._weekdays) ? this._weekdays :
	                this._weekdays['standalone'];
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(1126)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.22.2';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(643);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(642);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(50);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(50);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(165);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(671), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(272);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.3.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2018-01-20T17:24Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};
	
		function DOMEval( code, doc, node ) {
			doc = doc || document;
	
			var i,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
					if ( node[ i ] ) {
						script[ i ] = node[ i ];
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.3.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
			) );
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
			val = curCSS( elem, dimension, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox;
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ dimension ] );
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if ( val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
	
			val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
	
			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
					isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra && boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					);
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && support.scrollboxSize() === styles.position ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1609);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(274)
	var ieee754 = __webpack_require__(317)
	var isArray = __webpack_require__(193)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(38);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1558)();
	}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var DOMProperty = __webpack_require__(92);
	var ReactDOMComponentFlags = __webpack_require__(543);
	
	var invariant = __webpack_require__(11);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function(Math) {
	
	var trimLeft = /^\s+/,
	    trimRight = /\s+$/,
	    tinyCounter = 0,
	    mathRound = Math.round,
	    mathMin = Math.min,
	    mathMax = Math.max,
	    mathRandom = Math.random;
	
	function tinycolor (color, opts) {
	
	    color = (color) ? color : '';
	    opts = opts || { };
	
	    // If input is already a tinycolor, return itself
	    if (color instanceof tinycolor) {
	       return color;
	    }
	    // If we are called as a function, call using new instead
	    if (!(this instanceof tinycolor)) {
	        return new tinycolor(color, opts);
	    }
	
	    var rgb = inputToRGB(color);
	    this._originalInput = color,
	    this._r = rgb.r,
	    this._g = rgb.g,
	    this._b = rgb.b,
	    this._a = rgb.a,
	    this._roundA = mathRound(100*this._a) / 100,
	    this._format = opts.format || rgb.format;
	    this._gradientType = opts.gradientType;
	
	    // Don't let the range of [0,255] come back in [0,1].
	    // Potentially lose a little bit of precision here, but will fix issues where
	    // .5 gets interpreted as half of the total, instead of half of 1
	    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	    if (this._r < 1) { this._r = mathRound(this._r); }
	    if (this._g < 1) { this._g = mathRound(this._g); }
	    if (this._b < 1) { this._b = mathRound(this._b); }
	
	    this._ok = rgb.ok;
	    this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
	    isDark: function() {
	        return this.getBrightness() < 128;
	    },
	    isLight: function() {
	        return !this.isDark();
	    },
	    isValid: function() {
	        return this._ok;
	    },
	    getOriginalInput: function() {
	      return this._originalInput;
	    },
	    getFormat: function() {
	        return this._format;
	    },
	    getAlpha: function() {
	        return this._a;
	    },
	    getBrightness: function() {
	        //http://www.w3.org/TR/AERT#color-contrast
	        var rgb = this.toRgb();
	        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	    },
	    getLuminance: function() {
	        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	        var rgb = this.toRgb();
	        var RsRGB, GsRGB, BsRGB, R, G, B;
	        RsRGB = rgb.r/255;
	        GsRGB = rgb.g/255;
	        BsRGB = rgb.b/255;
	
	        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
	        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
	        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
	        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
	    },
	    setAlpha: function(value) {
	        this._a = boundAlpha(value);
	        this._roundA = mathRound(100*this._a) / 100;
	        return this;
	    },
	    toHsv: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
	    },
	    toHsvString: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
	        return (this._a == 1) ?
	          "hsv("  + h + ", " + s + "%, " + v + "%)" :
	          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
	    },
	    toHsl: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
	    },
	    toHslString: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
	        return (this._a == 1) ?
	          "hsl("  + h + ", " + s + "%, " + l + "%)" :
	          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
	    },
	    toHex: function(allow3Char) {
	        return rgbToHex(this._r, this._g, this._b, allow3Char);
	    },
	    toHexString: function(allow3Char) {
	        return '#' + this.toHex(allow3Char);
	    },
	    toHex8: function(allow4Char) {
	        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	    },
	    toHex8String: function(allow4Char) {
	        return '#' + this.toHex8(allow4Char);
	    },
	    toRgb: function() {
	        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
	    },
	    toRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
	          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
	    },
	    toPercentageRgb: function() {
	        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
	    },
	    toPercentageRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
	          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	    },
	    toName: function() {
	        if (this._a === 0) {
	            return "transparent";
	        }
	
	        if (this._a < 1) {
	            return false;
	        }
	
	        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	    },
	    toFilter: function(secondColor) {
	        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	        var secondHex8String = hex8String;
	        var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
	        if (secondColor) {
	            var s = tinycolor(secondColor);
	            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	        }
	
	        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
	    },
	    toString: function(format) {
	        var formatSet = !!format;
	        format = format || this._format;
	
	        var formattedString = false;
	        var hasAlpha = this._a < 1 && this._a >= 0;
	        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	
	        if (needsAlphaFormat) {
	            // Special case for "transparent", all other non-alpha formats
	            // will return rgba when there is transparency.
	            if (format === "name" && this._a === 0) {
	                return this.toName();
	            }
	            return this.toRgbString();
	        }
	        if (format === "rgb") {
	            formattedString = this.toRgbString();
	        }
	        if (format === "prgb") {
	            formattedString = this.toPercentageRgbString();
	        }
	        if (format === "hex" || format === "hex6") {
	            formattedString = this.toHexString();
	        }
	        if (format === "hex3") {
	            formattedString = this.toHexString(true);
	        }
	        if (format === "hex4") {
	            formattedString = this.toHex8String(true);
	        }
	        if (format === "hex8") {
	            formattedString = this.toHex8String();
	        }
	        if (format === "name") {
	            formattedString = this.toName();
	        }
	        if (format === "hsl") {
	            formattedString = this.toHslString();
	        }
	        if (format === "hsv") {
	            formattedString = this.toHsvString();
	        }
	
	        return formattedString || this.toHexString();
	    },
	    clone: function() {
	        return tinycolor(this.toString());
	    },
	
	    _applyModification: function(fn, args) {
	        var color = fn.apply(null, [this].concat([].slice.call(args)));
	        this._r = color._r;
	        this._g = color._g;
	        this._b = color._b;
	        this.setAlpha(color._a);
	        return this;
	    },
	    lighten: function() {
	        return this._applyModification(lighten, arguments);
	    },
	    brighten: function() {
	        return this._applyModification(brighten, arguments);
	    },
	    darken: function() {
	        return this._applyModification(darken, arguments);
	    },
	    desaturate: function() {
	        return this._applyModification(desaturate, arguments);
	    },
	    saturate: function() {
	        return this._applyModification(saturate, arguments);
	    },
	    greyscale: function() {
	        return this._applyModification(greyscale, arguments);
	    },
	    spin: function() {
	        return this._applyModification(spin, arguments);
	    },
	
	    _applyCombination: function(fn, args) {
	        return fn.apply(null, [this].concat([].slice.call(args)));
	    },
	    analogous: function() {
	        return this._applyCombination(analogous, arguments);
	    },
	    complement: function() {
	        return this._applyCombination(complement, arguments);
	    },
	    monochromatic: function() {
	        return this._applyCombination(monochromatic, arguments);
	    },
	    splitcomplement: function() {
	        return this._applyCombination(splitcomplement, arguments);
	    },
	    triad: function() {
	        return this._applyCombination(triad, arguments);
	    },
	    tetrad: function() {
	        return this._applyCombination(tetrad, arguments);
	    }
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
	    if (typeof color == "object") {
	        var newColor = {};
	        for (var i in color) {
	            if (color.hasOwnProperty(i)) {
	                if (i === "a") {
	                    newColor[i] = color[i];
	                }
	                else {
	                    newColor[i] = convertToPercentage(color[i]);
	                }
	            }
	        }
	        color = newColor;
	    }
	
	    return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//     "red"
	//     "#f00" or "f00"
	//     "#ff0000" or "ff0000"
	//     "#ff000000" or "ff000000"
	//     "rgb 255 0 0" or "rgb (255, 0, 0)"
	//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
	    var rgb = { r: 0, g: 0, b: 0 };
	    var a = 1;
	    var s = null;
	    var v = null;
	    var l = null;
	    var ok = false;
	    var format = false;
	
	    if (typeof color == "string") {
	        color = stringInputToObject(color);
	    }
	
	    if (typeof color == "object") {
	        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	            rgb = rgbToRgb(color.r, color.g, color.b);
	            ok = true;
	            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	            s = convertToPercentage(color.s);
	            v = convertToPercentage(color.v);
	            rgb = hsvToRgb(color.h, s, v);
	            ok = true;
	            format = "hsv";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	            s = convertToPercentage(color.s);
	            l = convertToPercentage(color.l);
	            rgb = hslToRgb(color.h, s, l);
	            ok = true;
	            format = "hsl";
	        }
	
	        if (color.hasOwnProperty("a")) {
	            a = color.a;
	        }
	    }
	
	    a = boundAlpha(a);
	
	    return {
	        ok: ok,
	        format: color.format || format,
	        r: mathMin(255, mathMax(rgb.r, 0)),
	        g: mathMin(255, mathMax(rgb.g, 0)),
	        b: mathMin(255, mathMax(rgb.b, 0)),
	        a: a
	    };
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
	    return {
	        r: bound01(r, 255) * 255,
	        g: bound01(g, 255) * 255,
	        b: bound01(b, 255) * 255
	    };
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, l = (max + min) / 2;
	
	    if(max == min) {
	        h = s = 0; // achromatic
	    }
	    else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	
	        h /= 6;
	    }
	
	    return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
	    var r, g, b;
	
	    h = bound01(h, 360);
	    s = bound01(s, 100);
	    l = bound01(l, 100);
	
	    function hue2rgb(p, q, t) {
	        if(t < 0) t += 1;
	        if(t > 1) t -= 1;
	        if(t < 1/6) return p + (q - p) * 6 * t;
	        if(t < 1/2) return q;
	        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	        return p;
	    }
	
	    if(s === 0) {
	        r = g = b = l; // achromatic
	    }
	    else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1/3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1/3);
	    }
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, v = max;
	
	    var d = max - min;
	    s = max === 0 ? 0 : d / max;
	
	    if(max == min) {
	        h = 0; // achromatic
	    }
	    else {
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	        h /= 6;
	    }
	    return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
	    h = bound01(h, 360) * 6;
	    s = bound01(s, 100);
	    v = bound01(v, 100);
	
	    var i = Math.floor(h),
	        f = h - i,
	        p = v * (1 - s),
	        q = v * (1 - f * s),
	        t = v * (1 - (1 - f) * s),
	        mod = i % 6,
	        r = [v, q, p, p, t, v][mod],
	        g = [t, v, v, q, p, p][mod],
	        b = [p, p, t, v, v, q][mod];
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    // Return a 3 character hex if possible
	    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToHex`
	// Converts an RGBA color plus alpha transparency to hex
	// Assumes r, g, b are contained in the set [0, 255] and
	// a in [0, 1]. Returns a 4 or 8 character rgba hex
	function rgbaToHex(r, g, b, a, allow4Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16)),
	        pad2(convertDecimalToHex(a))
	    ];
	
	    // Return a 4 character hex if possible
	    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToArgbHex`
	// Converts an RGBA color to an ARGB Hex8 string
	// Rarely used, but required for "toFilter()"
	function rgbaToArgbHex(r, g, b, a) {
	
	    var hex = [
	        pad2(convertDecimalToHex(a)),
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    return hex.join("");
	}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
	    if (!color1 || !color2) { return false; }
	    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	
	tinycolor.random = function() {
	    return tinycolor.fromRatio({
	        r: mathRandom(),
	        g: mathRandom(),
	        b: mathRandom()
	    });
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s += amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function greyscale(color) {
	    return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l += amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var rgb = tinycolor(color).toRgb();
	    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
	    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
	    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
	    return tinycolor(rgb);
	}
	
	function darken (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
	    var hsl = tinycolor(color).toHsl();
	    var hue = (hsl.h + amount) % 360;
	    hsl.h = hue < 0 ? 360 + hue : hue;
	    return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
	    var hsl = tinycolor(color).toHsl();
	    hsl.h = (hsl.h + 180) % 360;
	    return tinycolor(hsl);
	}
	
	function triad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function tetrad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function splitcomplement(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
	        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
	    ];
	}
	
	function analogous(color, results, slices) {
	    results = results || 6;
	    slices = slices || 30;
	
	    var hsl = tinycolor(color).toHsl();
	    var part = 360 / slices;
	    var ret = [tinycolor(color)];
	
	    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
	        hsl.h = (hsl.h + part) % 360;
	        ret.push(tinycolor(hsl));
	    }
	    return ret;
	}
	
	function monochromatic(color, results) {
	    results = results || 6;
	    var hsv = tinycolor(color).toHsv();
	    var h = hsv.h, s = hsv.s, v = hsv.v;
	    var ret = [];
	    var modification = 1 / results;
	
	    while (results--) {
	        ret.push(tinycolor({ h: h, s: s, v: v}));
	        v = (v + modification) % 1;
	    }
	
	    return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
	    amount = (amount === 0) ? 0 : (amount || 50);
	
	    var rgb1 = tinycolor(color1).toRgb();
	    var rgb2 = tinycolor(color2).toRgb();
	
	    var p = amount / 100;
	
	    var rgba = {
	        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
	        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
	        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
	        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
	    };
	
	    return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
	    var c1 = tinycolor(color1);
	    var c2 = tinycolor(color2);
	    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//    tinycolor.isReadable("#000", "#111") => false
	//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	tinycolor.isReadable = function(color1, color2, wcag2) {
	    var readability = tinycolor.readability(color1, color2);
	    var wcag2Parms, out;
	
	    out = false;
	
	    wcag2Parms = validateWCAG2Parms(wcag2);
	    switch (wcag2Parms.level + wcag2Parms.size) {
	        case "AAsmall":
	        case "AAAlarge":
	            out = readability >= 4.5;
	            break;
	        case "AAlarge":
	            out = readability >= 3;
	            break;
	        case "AAAsmall":
	            out = readability >= 7;
	            break;
	    }
	    return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	tinycolor.mostReadable = function(baseColor, colorList, args) {
	    var bestColor = null;
	    var bestScore = 0;
	    var readability;
	    var includeFallbackColors, level, size ;
	    args = args || {};
	    includeFallbackColors = args.includeFallbackColors ;
	    level = args.level;
	    size = args.size;
	
	    for (var i= 0; i < colorList.length ; i++) {
	        readability = tinycolor.readability(baseColor, colorList[i]);
	        if (readability > bestScore) {
	            bestScore = readability;
	            bestColor = tinycolor(colorList[i]);
	        }
	    }
	
	    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
	        return bestColor;
	    }
	    else {
	        args.includeFallbackColors=false;
	        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
	    }
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
	    aliceblue: "f0f8ff",
	    antiquewhite: "faebd7",
	    aqua: "0ff",
	    aquamarine: "7fffd4",
	    azure: "f0ffff",
	    beige: "f5f5dc",
	    bisque: "ffe4c4",
	    black: "000",
	    blanchedalmond: "ffebcd",
	    blue: "00f",
	    blueviolet: "8a2be2",
	    brown: "a52a2a",
	    burlywood: "deb887",
	    burntsienna: "ea7e5d",
	    cadetblue: "5f9ea0",
	    chartreuse: "7fff00",
	    chocolate: "d2691e",
	    coral: "ff7f50",
	    cornflowerblue: "6495ed",
	    cornsilk: "fff8dc",
	    crimson: "dc143c",
	    cyan: "0ff",
	    darkblue: "00008b",
	    darkcyan: "008b8b",
	    darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9",
	    darkgreen: "006400",
	    darkgrey: "a9a9a9",
	    darkkhaki: "bdb76b",
	    darkmagenta: "8b008b",
	    darkolivegreen: "556b2f",
	    darkorange: "ff8c00",
	    darkorchid: "9932cc",
	    darkred: "8b0000",
	    darksalmon: "e9967a",
	    darkseagreen: "8fbc8f",
	    darkslateblue: "483d8b",
	    darkslategray: "2f4f4f",
	    darkslategrey: "2f4f4f",
	    darkturquoise: "00ced1",
	    darkviolet: "9400d3",
	    deeppink: "ff1493",
	    deepskyblue: "00bfff",
	    dimgray: "696969",
	    dimgrey: "696969",
	    dodgerblue: "1e90ff",
	    firebrick: "b22222",
	    floralwhite: "fffaf0",
	    forestgreen: "228b22",
	    fuchsia: "f0f",
	    gainsboro: "dcdcdc",
	    ghostwhite: "f8f8ff",
	    gold: "ffd700",
	    goldenrod: "daa520",
	    gray: "808080",
	    green: "008000",
	    greenyellow: "adff2f",
	    grey: "808080",
	    honeydew: "f0fff0",
	    hotpink: "ff69b4",
	    indianred: "cd5c5c",
	    indigo: "4b0082",
	    ivory: "fffff0",
	    khaki: "f0e68c",
	    lavender: "e6e6fa",
	    lavenderblush: "fff0f5",
	    lawngreen: "7cfc00",
	    lemonchiffon: "fffacd",
	    lightblue: "add8e6",
	    lightcoral: "f08080",
	    lightcyan: "e0ffff",
	    lightgoldenrodyellow: "fafad2",
	    lightgray: "d3d3d3",
	    lightgreen: "90ee90",
	    lightgrey: "d3d3d3",
	    lightpink: "ffb6c1",
	    lightsalmon: "ffa07a",
	    lightseagreen: "20b2aa",
	    lightskyblue: "87cefa",
	    lightslategray: "789",
	    lightslategrey: "789",
	    lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0",
	    lime: "0f0",
	    limegreen: "32cd32",
	    linen: "faf0e6",
	    magenta: "f0f",
	    maroon: "800000",
	    mediumaquamarine: "66cdaa",
	    mediumblue: "0000cd",
	    mediumorchid: "ba55d3",
	    mediumpurple: "9370db",
	    mediumseagreen: "3cb371",
	    mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a",
	    mediumturquoise: "48d1cc",
	    mediumvioletred: "c71585",
	    midnightblue: "191970",
	    mintcream: "f5fffa",
	    mistyrose: "ffe4e1",
	    moccasin: "ffe4b5",
	    navajowhite: "ffdead",
	    navy: "000080",
	    oldlace: "fdf5e6",
	    olive: "808000",
	    olivedrab: "6b8e23",
	    orange: "ffa500",
	    orangered: "ff4500",
	    orchid: "da70d6",
	    palegoldenrod: "eee8aa",
	    palegreen: "98fb98",
	    paleturquoise: "afeeee",
	    palevioletred: "db7093",
	    papayawhip: "ffefd5",
	    peachpuff: "ffdab9",
	    peru: "cd853f",
	    pink: "ffc0cb",
	    plum: "dda0dd",
	    powderblue: "b0e0e6",
	    purple: "800080",
	    rebeccapurple: "663399",
	    red: "f00",
	    rosybrown: "bc8f8f",
	    royalblue: "4169e1",
	    saddlebrown: "8b4513",
	    salmon: "fa8072",
	    sandybrown: "f4a460",
	    seagreen: "2e8b57",
	    seashell: "fff5ee",
	    sienna: "a0522d",
	    silver: "c0c0c0",
	    skyblue: "87ceeb",
	    slateblue: "6a5acd",
	    slategray: "708090",
	    slategrey: "708090",
	    snow: "fffafa",
	    springgreen: "00ff7f",
	    steelblue: "4682b4",
	    tan: "d2b48c",
	    teal: "008080",
	    thistle: "d8bfd8",
	    tomato: "ff6347",
	    turquoise: "40e0d0",
	    violet: "ee82ee",
	    wheat: "f5deb3",
	    white: "fff",
	    whitesmoke: "f5f5f5",
	    yellow: "ff0",
	    yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
	    var flipped = { };
	    for (var i in o) {
	        if (o.hasOwnProperty(i)) {
	            flipped[o[i]] = i;
	        }
	    }
	    return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
	    a = parseFloat(a);
	
	    if (isNaN(a) || a < 0 || a > 1) {
	        a = 1;
	    }
	
	    return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
	    if (isOnePointZero(n)) { n = "100%"; }
	
	    var processPercent = isPercentage(n);
	    n = mathMin(max, mathMax(0, parseFloat(n)));
	
	    // Automatically convert percentage into number
	    if (processPercent) {
	        n = parseInt(n * max, 10) / 100;
	    }
	
	    // Handle floating point rounding errors
	    if ((Math.abs(n - max) < 0.000001)) {
	        return 1;
	    }
	
	    // Convert into [0, 1] range if it isn't already
	    return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
	    return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
	    return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
	    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
	    return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
	    return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n) {
	    if (n <= 1) {
	        n = (n * 100) + "%";
	    }
	
	    return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
	    return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
	    return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
	    // <http://www.w3.org/TR/css3-values/#integers>
	    var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	    // <http://www.w3.org/TR/css3-values/#number-value>
	    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	    // Actual matching.
	    // Parentheses and commas are optional, but not required.
	    // Whitespace can take the place of commas or opening paren
	    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
	    return {
	        CSS_UNIT: new RegExp(CSS_UNIT),
	        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	    };
	})();
	
	// `isValidCSSUnit`
	// Take in a single string / number and check to see if it looks like a CSS unit
	// (see `matchers` above for definition).
	function isValidCSSUnit(color) {
	    return !!matchers.CSS_UNIT.exec(color);
	}
	
	// `stringInputToObject`
	// Permissive string parsing.  Take in a number of formats, and output an object
	// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
	    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
	    var named = false;
	    if (names[color]) {
	        color = names[color];
	        named = true;
	    }
	    else if (color == 'transparent') {
	        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
	    }
	
	    // Try to match string input using regular expressions.
	    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	    // Just return an object and let the conversion functions handle that.
	    // This way the result will be the same whether the tinycolor is initialized with string or object.
	    var match;
	    if ((match = matchers.rgb.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3] };
	    }
	    if ((match = matchers.rgba.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsl.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3] };
	    }
	    if ((match = matchers.hsla.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsv.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3] };
	    }
	    if ((match = matchers.hsva.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3], a: match[4] };
	    }
	    if ((match = matchers.hex8.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            a: convertHexToDecimal(match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex6.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	    if ((match = matchers.hex4.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            a: convertHexToDecimal(match[4] + '' + match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex3.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	
	    return false;
	}
	
	function validateWCAG2Parms(parms) {
	    // return valid WCAG2 parms for isReadable.
	    // If input parms are invalid, return {"level":"AA", "size":"small"}
	    var level, size;
	    parms = parms || {"level":"AA", "size":"small"};
	    level = (parms.level || "AA").toUpperCase();
	    size = (parms.size || "small").toLowerCase();
	    if (level !== "AA" && level !== "AAA") {
	        level = "AA";
	    }
	    if (size !== "small" && size !== "large") {
	        size = "small";
	    }
	    return {"level":level, "size":size};
	}
	
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
	    module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// Browser: Expose to window
	else {
	    window.tinycolor = tinycolor;
	}
	
	})(Math);


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(1063);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.types', []).constant('types', {
	    serverErrorCode: {
	        general: 2,
	        authentication: 10,
	        jwtTokenExpired: 11,
	        permissionDenied: 20,
	        invalidArguments: 30,
	        badRequestParams: 31,
	        itemNotFound: 32
	    },
	    entryPoints: {
	        login: "/api/auth/login",
	        tokenRefresh: "/api/auth/token",
	        nonTokenBased: "/api/noauth"
	    },
	    id: {
	        nullUid: "13814000-1dd2-11b2-8080-808080808080"
	    },
	    aggregation: {
	        min: {
	            value: "MIN",
	            name: "aggregation.min"
	        },
	        max: {
	            value: "MAX",
	            name: "aggregation.max"
	        },
	        avg: {
	            value: "AVG",
	            name: "aggregation.avg"
	        },
	        sum: {
	            value: "SUM",
	            name: "aggregation.sum"
	        },
	        count: {
	            value: "COUNT",
	            name: "aggregation.count"
	        },
	        none: {
	            value: "NONE",
	            name: "aggregation.none"
	        }
	    },
	    alarmFields: {
	        createdTime: {
	            keyName: 'createdTime',
	            value: "createdTime",
	            name: "alarm.created-time",
	            time: true
	        },
	        startTime: {
	            keyName: 'startTime',
	            value: "startTs",
	            name: "alarm.start-time",
	            time: true
	        },
	        endTime: {
	            keyName: 'endTime',
	            value: "endTs",
	            name: "alarm.end-time",
	            time: true
	        },
	        ackTime: {
	            keyName: 'ackTime',
	            value: "ackTs",
	            name: "alarm.ack-time",
	            time: true
	        },
	        clearTime: {
	            keyName: 'clearTime',
	            value: "clearTs",
	            name: "alarm.clear-time",
	            time: true
	        },
	        originator: {
	            keyName: 'originator',
	            value: "originatorName",
	            name: "alarm.originator"
	        },
	        originatorType: {
	            keyName: 'originatorType',
	            value: "originator.entityType",
	            name: "alarm.originator-type"
	        },
	        type: {
	            keyName: 'type',
	            value: "type",
	            name: "alarm.type"
	        },
	        severity: {
	            keyName: 'severity',
	            value: "severity",
	            name: "alarm.severity"
	        },
	        status: {
	            keyName: 'status',
	            value: "status",
	            name: "alarm.status"
	        }
	    },
	    alarmStatus: {
	        activeUnack: "ACTIVE_UNACK",
	        activeAck: "ACTIVE_ACK",
	        clearedUnack: "CLEARED_UNACK",
	        clearedAck: "CLEARED_ACK"
	    },
	    alarmSearchStatus: {
	        any: "ANY",
	        active: "ACTIVE",
	        cleared: "CLEARED",
	        ack: "ACK",
	        unack: "UNACK"
	    },
	    alarmSeverity: {
	        "CRITICAL": {
	            name: "alarm.severity-critical",
	            class: "tb-critical",
	            color: "red"
	        },
	        "MAJOR": {
	            name: "alarm.severity-major",
	            class: "tb-major",
	            color: "orange"
	        },
	        "MINOR": {
	            name: "alarm.severity-minor",
	            class: "tb-minor",
	            color: "#ffca3d"
	        },
	        "WARNING": {
	            name: "alarm.severity-warning",
	            class: "tb-warning",
	            color: "#abab00"
	        },
	        "INDETERMINATE": {
	            name: "alarm.severity-indeterminate",
	            class: "tb-indeterminate",
	            color: "green"
	        }
	    },
	    auditLogActionType: {
	        "ADDED": {
	            name: "audit-log.type-added"
	        },
	        "DELETED": {
	            name: "audit-log.type-deleted"
	        },
	        "UPDATED": {
	            name: "audit-log.type-updated"
	        },
	        "ATTRIBUTES_UPDATED": {
	            name: "audit-log.type-attributes-updated"
	        },
	        "ATTRIBUTES_DELETED": {
	            name: "audit-log.type-attributes-deleted"
	        },
	        "RPC_CALL": {
	            name: "audit-log.type-rpc-call"
	        },
	        "CREDENTIALS_UPDATED": {
	            name: "audit-log.type-credentials-updated"
	        },
	        "ASSIGNED_TO_CUSTOMER": {
	            name: "audit-log.type-assigned-to-customer"
	        },
	        "UNASSIGNED_FROM_CUSTOMER": {
	            name: "audit-log.type-unassigned-from-customer"
	        },
	        "ACTIVATED": {
	            name: "audit-log.type-activated"
	        },
	        "SUSPENDED": {
	            name: "audit-log.type-suspended"
	        },
	        "CREDENTIALS_READ": {
	            name: "audit-log.type-credentials-read"
	        },
	        "ATTRIBUTES_READ": {
	            name: "audit-log.type-attributes-read"
	        },
	        "RELATION_ADD_OR_UPDATE": {
	            name: "audit-log.type-relation-add-or-update"
	        },
	        "RELATION_DELETED": {
	            name: "audit-log.type-relation-delete"
	        },
	        "RELATIONS_DELETED": {
	            name: "audit-log.type-relations-delete"
	        },
	        "ALARM_ACK": {
	            name: "audit-log.type-alarm-ack"
	        },
	        "ALARM_CLEAR": {
	            name: "audit-log.type-alarm-clear"
	        }
	    },
	    auditLogActionStatus: {
	        "SUCCESS": {
	            value: "SUCCESS",
	            name: "audit-log.status-success"
	        },
	        "FAILURE": {
	            value: "FAILURE",
	            name: "audit-log.status-failure"
	        }
	    },
	    auditLogMode: {
	        tenant: "tenant",
	        entity: "entity",
	        user: "user",
	        customer: "customer"
	    },
	    aliasFilterType: {
	        singleEntity: {
	            value: 'singleEntity',
	            name: 'alias.filter-type-single-entity'
	        },
	        entityList: {
	            value: 'entityList',
	            name: 'alias.filter-type-entity-list'
	        },
	        entityName: {
	            value: 'entityName',
	            name: 'alias.filter-type-entity-name'
	        },
	        stateEntity: {
	            value: 'stateEntity',
	            name: 'alias.filter-type-state-entity'
	        },
	        assetType: {
	            value: 'assetType',
	            name: 'alias.filter-type-asset-type'
	        },
	        deviceType: {
	            value: 'deviceType',
	            name: 'alias.filter-type-device-type'
	        },
	        entityViewType: {
	            value: 'entityViewType',
	            name: 'alias.filter-type-entity-view-type'
	        },
	        relationsQuery: {
	            value: 'relationsQuery',
	            name: 'alias.filter-type-relations-query'
	        },
	        assetSearchQuery: {
	            value: 'assetSearchQuery',
	            name: 'alias.filter-type-asset-search-query'
	        },
	        deviceSearchQuery: {
	            value: 'deviceSearchQuery',
	            name: 'alias.filter-type-device-search-query'
	        },
	        entityViewSearchQuery: {
	            value: 'entityViewSearchQuery',
	            name: 'alias.filter-type-entity-view-search-query'
	        }
	    },
	    position: {
	        top: {
	            value: "top",
	            name: "position.top"
	        },
	        bottom: {
	            value: "bottom",
	            name: "position.bottom"
	        },
	        left: {
	            value: "left",
	            name: "position.left"
	        },
	        right: {
	            value: "right",
	            name: "position.right"
	        }
	    },
	    datasourceType: {
	        function: "function",
	        entity: "entity"
	    },
	    dataKeyType: {
	        timeseries: "timeseries",
	        attribute: "attribute",
	        function: "function",
	        alarm: "alarm"
	    },
	    contentType: {
	        "JSON": {
	            value: "JSON",
	            name: "content-type.json",
	            code: "json"
	        },
	        "TEXT": {
	            value: "TEXT",
	            name: "content-type.text",
	            code: "text"
	        },
	        "BINARY": {
	            value: "BINARY",
	            name: "content-type.binary",
	            code: "text"
	        }
	    },
	    componentType: {
	        enrichment: "ENRICHMENT",
	        filter: "FILTER",
	        transformation: "TRANSFORMATION",
	        action: "ACTION",
	        external: "EXTERNAL"
	    },
	    entityType: {
	        device: "DEVICE",
	        asset: "ASSET",
	        tenant: "TENANT",
	        customer: "CUSTOMER",
	        user: "USER",
	        dashboard: "DASHBOARD",
	        alarm: "ALARM",
	        rulechain: "RULE_CHAIN",
	        rulenode: "RULE_NODE",
	        entityView: "ENTITY_VIEW"
	    },
	    aliasEntityType: {
	        current_customer: "CURRENT_CUSTOMER"
	    },
	    entityTypeTranslations: {
	        "DEVICE": {
	            type: 'entity.type-device',
	            typePlural: 'entity.type-devices',
	            list: 'entity.list-of-devices',
	            nameStartsWith: 'entity.device-name-starts-with'
	        },
	        "ASSET": {
	            type: 'entity.type-asset',
	            typePlural: 'entity.type-assets',
	            list: 'entity.list-of-assets',
	            nameStartsWith: 'entity.asset-name-starts-with'
	        },
	        "ENTITY_VIEW": {
	            type: 'entity.type-entity-view',
	            typePlural: 'entity.type-entity-views',
	            list: 'entity.list-of-entity-views',
	            nameStartsWith: 'entity.entity-view-name-starts-with'
	        },
	        "TENANT": {
	            type: 'entity.type-tenant',
	            typePlural: 'entity.type-tenants',
	            list: 'entity.list-of-tenants',
	            nameStartsWith: 'entity.tenant-name-starts-with'
	        },
	        "CUSTOMER": {
	            type: 'entity.type-customer',
	            typePlural: 'entity.type-customers',
	            list: 'entity.list-of-customers',
	            nameStartsWith: 'entity.customer-name-starts-with'
	        },
	        "USER": {
	            type: 'entity.type-user',
	            typePlural: 'entity.type-users',
	            list: 'entity.list-of-users',
	            nameStartsWith: 'entity.user-name-starts-with'
	        },
	        "DASHBOARD": {
	            type: 'entity.type-dashboard',
	            typePlural: 'entity.type-dashboards',
	            list: 'entity.list-of-dashboards',
	            nameStartsWith: 'entity.dashboard-name-starts-with'
	        },
	        "ALARM": {
	            type: 'entity.type-alarm',
	            typePlural: 'entity.type-alarms',
	            list: 'entity.list-of-alarms',
	            nameStartsWith: 'entity.alarm-name-starts-with'
	        },
	        "RULE_CHAIN": {
	            type: 'entity.type-rulechain',
	            typePlural: 'entity.type-rulechains',
	            list: 'entity.list-of-rulechains',
	            nameStartsWith: 'entity.rulechain-name-starts-with'
	        },
	        "RULE_NODE": {
	            type: 'entity.type-rulenode',
	            typePlural: 'entity.type-rulenodes',
	            list: 'entity.list-of-rulenodes',
	            nameStartsWith: 'entity.rulenode-name-starts-with'
	        },
	        "CURRENT_CUSTOMER": {
	            type: 'entity.type-current-customer',
	            list: 'entity.type-current-customer'
	        }
	    },
	    entitySearchDirection: {
	        from: "FROM",
	        to: "TO"
	    },
	    entityRelationType: {
	        contains: "Contains",
	        manages: "Manages"
	    },
	    eventType: {
	        error: {
	            value: "ERROR",
	            name: "event.type-error"
	        },
	        lcEvent: {
	            value: "LC_EVENT",
	            name: "event.type-lc-event"
	        },
	        stats: {
	            value: "STATS",
	            name: "event.type-stats"
	        }
	    },
	    debugEventType: {
	        debugRuleNode: {
	            value: "DEBUG_RULE_NODE",
	            name: "event.type-debug-rule-node"
	        },
	        debugRuleChain: {
	            value: "DEBUG_RULE_CHAIN",
	            name: "event.type-debug-rule-chain"
	        }
	    },
	    extensionType: {
	        http: "HTTP",
	        mqtt: "MQTT",
	        opc: "OPC UA",
	        modbus: "MODBUS"
	    },
	    extensionValueType: {
	        string: 'value.string',
	        long: 'value.long',
	        double: 'value.double',
	        boolean: 'value.boolean'
	    },
	    extensionTransformerType: {
	        toDouble: 'extension.to-double',
	        custom: 'extension.custom'
	    },
	    mqttConverterTypes: {
	        json: 'extension.converter-json',
	        custom: 'extension.custom'
	    },
	    mqttCredentialTypes: {
	        anonymous: {
	            value: "anonymous",
	            name: "extension.anonymous"
	        },
	        basic: {
	            value: "basic",
	            name: "extension.basic"
	        },
	        pem: {
	            value: "cert.PEM",
	            name: "extension.pem"
	        }
	    },
	    extensionOpcSecurityTypes: {
	        Basic128Rsa15: "Basic128Rsa15",
	        Basic256: "Basic256",
	        Basic256Sha256: "Basic256Sha256",
	        None: "None"
	    },
	    extensionIdentityType: {
	        anonymous: "extension.anonymous",
	        username: "extension.username"
	    },
	    extensionKeystoreType: {
	        PKCS12: "PKCS12",
	        JKS: "JKS"
	    },
	    extensionModbusFunctionCodes: {
	        1: "Read Coils (1)",
	        2: "Read Discrete Inputs (2)",
	        3: "Read Multiple Holding Registers (3)",
	        4: "Read Input Registers (4)"
	    },
	    extensionModbusTransports: {
	        tcp: "TCP",
	        udp: "UDP",
	        rtu: "RTU"
	    },
	    extensionModbusRtuParities: {
	        none: "none",
	        even: "even",
	        odd: "odd"
	    },
	    extensionModbusRtuEncodings: {
	        ascii: "ascii",
	        rtu: "rtu"
	    },
	    latestTelemetry: {
	        value: "LATEST_TELEMETRY",
	        name: "attribute.scope-latest-telemetry",
	        clientSide: true
	    },
	    attributesScope: {
	        client: {
	            value: "CLIENT_SCOPE",
	            name: "attribute.scope-client",
	            clientSide: true
	        },
	        server: {
	            value: "SERVER_SCOPE",
	            name: "attribute.scope-server",
	            clientSide: false
	        },
	        shared: {
	            value: "SHARED_SCOPE",
	            name: "attribute.scope-shared",
	            clientSide: false
	        }
	    },
	    ruleNodeTypeComponentTypes: ["FILTER", "ENRICHMENT", "TRANSFORMATION", "ACTION", "EXTERNAL"],
	    ruleChainNodeComponent: {
	        type: 'RULE_CHAIN',
	        name: 'rule chain',
	        clazz: 'tb.internal.RuleChain',
	        configurationDescriptor: {
	            nodeDefinition: {
	                description: "",
	                details: "Forwards incoming messages to specified Rule Chain",
	                inEnabled: true,
	                outEnabled: false,
	                relationTypes: [],
	                customRelations: false,
	                defaultConfiguration: {}
	            }
	        }
	    },
	    unknownNodeComponent: {
	        type: 'UNKNOWN',
	        name: 'unknown',
	        clazz: 'tb.internal.Unknown',
	        configurationDescriptor: {
	            nodeDefinition: {
	                description: "",
	                details: "",
	                inEnabled: true,
	                outEnabled: true,
	                relationTypes: [],
	                customRelations: false,
	                defaultConfiguration: {}
	            }
	        }
	    },
	    inputNodeComponent: {
	        type: 'INPUT',
	        name: 'Input',
	        clazz: 'tb.internal.Input'
	    },
	    ruleNodeType: {
	        FILTER: {
	            value: "FILTER",
	            name: "rulenode.type-filter",
	            details: "rulenode.type-filter-details",
	            nodeClass: "tb-filter-type",
	            icon: "filter_list"
	        },
	        ENRICHMENT: {
	            value: "ENRICHMENT",
	            name: "rulenode.type-enrichment",
	            details: "rulenode.type-enrichment-details",
	            nodeClass: "tb-enrichment-type",
	            icon: "playlist_add"
	        },
	        TRANSFORMATION: {
	            value: "TRANSFORMATION",
	            name: "rulenode.type-transformation",
	            details: "rulenode.type-transformation-details",
	            nodeClass: "tb-transformation-type",
	            icon: "transform"
	        },
	        ACTION: {
	            value: "ACTION",
	            name: "rulenode.type-action",
	            details: "rulenode.type-action-details",
	            nodeClass: "tb-action-type",
	            icon: "flash_on"
	        },
	        EXTERNAL: {
	            value: "EXTERNAL",
	            name: "rulenode.type-external",
	            details: "rulenode.type-external-details",
	            nodeClass: "tb-external-type",
	            icon: "cloud_upload"
	        },
	        RULE_CHAIN: {
	            value: "RULE_CHAIN",
	            name: "rulenode.type-rule-chain",
	            details: "rulenode.type-rule-chain-details",
	            nodeClass: "tb-rule-chain-type",
	            icon: "settings_ethernet"
	        },
	        INPUT: {
	            value: "INPUT",
	            name: "rulenode.type-input",
	            details: "rulenode.type-input-details",
	            nodeClass: "tb-input-type",
	            icon: "input",
	            special: true
	        },
	        UNKNOWN: {
	            value: "UNKNOWN",
	            name: "rulenode.type-unknown",
	            details: "rulenode.type-unknown-details",
	            nodeClass: "tb-unknown-type",
	            icon: "help_outline"
	        }
	    },
	    messageType: {
	        'POST_ATTRIBUTES_REQUEST': {
	            name: 'Post attributes',
	            value: 'POST_ATTRIBUTES_REQUEST'
	        },
	        'POST_TELEMETRY_REQUEST': {
	            name: 'Post telemetry',
	            value: 'POST_TELEMETRY_REQUEST'
	        },
	        'TO_SERVER_RPC_REQUEST': {
	            name: 'RPC Request from Device',
	            value: 'TO_SERVER_RPC_REQUEST'
	        },
	        'RPC_CALL_FROM_SERVER_TO_DEVICE': {
	            name: 'RPC Request to Device',
	            value: 'RPC_CALL_FROM_SERVER_TO_DEVICE'
	        },
	        'ACTIVITY_EVENT': {
	            name: 'Activity Event',
	            value: 'ACTIVITY_EVENT'
	        },
	        'INACTIVITY_EVENT': {
	            name: 'Inactivity Event',
	            value: 'INACTIVITY_EVENT'
	        },
	        'CONNECT_EVENT': {
	            name: 'Connect Event',
	            value: 'CONNECT_EVENT'
	        },
	        'DISCONNECT_EVENT': {
	            name: 'Disconnect Event',
	            value: 'DISCONNECT_EVENT'
	        },
	        'ENTITY_CREATED': {
	            name: 'Entity Created',
	            value: 'ENTITY_CREATED'
	        },
	        'ENTITY_UPDATED': {
	            name: 'Entity Updated',
	            value: 'ENTITY_UPDATED'
	        },
	        'ENTITY_DELETED': {
	            name: 'Entity Deleted',
	            value: 'ENTITY_DELETED'
	        },
	        'ENTITY_ASSIGNED': {
	            name: 'Entity Assigned',
	            value: 'ENTITY_ASSIGNED'
	        },
	        'ENTITY_UNASSIGNED': {
	            name: 'Entity Unassigned',
	            value: 'ENTITY_UNASSIGNED'
	        },
	        'ATTRIBUTES_UPDATED': {
	            name: 'Attributes Updated',
	            value: 'ATTRIBUTES_UPDATED'
	        },
	        'ATTRIBUTES_DELETED': {
	            name: 'Attributes Deleted',
	            value: 'ATTRIBUTES_DELETED'
	        }
	    },
	    valueType: {
	        string: {
	            value: "string",
	            name: "value.string",
	            icon: "mdi:format-text"
	        },
	        integer: {
	            value: "integer",
	            name: "value.integer",
	            icon: "mdi:numeric"
	        },
	        double: {
	            value: "double",
	            name: "value.double",
	            icon: "mdi:numeric"
	        },
	        boolean: {
	            value: "boolean",
	            name: "value.boolean",
	            icon: "mdi:checkbox-marked-outline"
	        }
	    },
	    widgetType: {
	        timeseries: {
	            value: "timeseries",
	            name: "widget.timeseries",
	            template: {
	                bundleAlias: "charts",
	                alias: "basic_timeseries"
	            }
	        },
	        latest: {
	            value: "latest",
	            name: "widget.latest-values",
	            template: {
	                bundleAlias: "cards",
	                alias: "attributes_card"
	            }
	        },
	        rpc: {
	            value: "rpc",
	            name: "widget.rpc",
	            template: {
	                bundleAlias: "gpio_widgets",
	                alias: "basic_gpio_control"
	            }
	        },
	        alarm: {
	            value: "alarm",
	            name: "widget.alarm",
	            template: {
	                bundleAlias: "alarm_widgets",
	                alias: "alarms_table"
	            }
	        },
	        static: {
	            value: "static",
	            name: "widget.static",
	            template: {
	                bundleAlias: "cards",
	                alias: "html_card"
	            }
	        }
	    },
	    widgetActionSources: {
	        headerButton: {
	            name: 'widget-action.header-button',
	            value: 'headerButton',
	            multiple: true
	        }
	    },
	    widgetActionTypes: {
	        openDashboardState: {
	            name: 'widget-action.open-dashboard-state',
	            value: 'openDashboardState'
	        },
	        updateDashboardState: {
	            name: 'widget-action.update-dashboard-state',
	            value: 'updateDashboardState'
	        },
	        openDashboard: {
	            name: 'widget-action.open-dashboard',
	            value: 'openDashboard'
	        },
	        custom: {
	            name: 'widget-action.custom',
	            value: 'custom'
	        }
	    },
	    systemBundleAlias: {
	        charts: "charts",
	        cards: "cards"
	    },
	    translate: {
	        customTranslationsPrefix: "custom."
	    }
	}).name;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(1698);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(79);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(572);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.3.2
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    toJson = angular.toJson;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i] || !parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	// issue #2676 #2889
	function silenceUncaughtInPromise (promise) {
	  return promise.then(undefined, function() {}) && promise;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = resolution.promise,
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = invocation.promise;
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
	function $TemplateFactory(  $http,   $templateCache,   $injector) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else return $http
	        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	        .then(function(response) { return response.data; });
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash, optional) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
	      case true:
	        result = result.replace(/\/$/, '');
	        surroundPattern = ['(?:\/(', ')|\/)?'];
	      break;
	      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	    if (regexp) {
	      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	    }
	
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  var param, paramVal;
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    param = this.params[paramName];
	    paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	    param = this.params[paramName];
	    paramVal = searchParams[paramName];
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      var isFinalPathParam = i + 1 === nPath;
	
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	
	      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      if (encoded.length === 0) continue;
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/** Given an encoded string, or a decoded object, returns a decoded object */
	Type.prototype.$normalize = function(val) {
	  return this.is(val) ? val : this.decode(val);
	};
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        if (isArray(val) && val.length === 0) return val;
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	    this.name = type.name;
	    this.$arrayMode = mode;
	  }
	
	  return new ArrayType(this, mode);
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  // Use tildes to pre-encode slashes.
	  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	  // and bidirectional encoding/decoding fails.
	  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	  function valToString(val) { return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return {'~':'~~', '/':'~2F'}[m]; }) : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return {'~~':'~', '~2F':'/'}[m]; }) : val; }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    "string": {
	      encode: valToString,
	      decode: valFromString,
	      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	      // In 0.2.x, string params are optional by default for backwards compat
	      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
	      pattern: /[^/]*/
	    },
	    "int": {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    "bool": {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    "date": {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    "json": {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    "any": { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	
	      if (angular.isString(config.type))
	        return $types[config.type];
	      if (config.type instanceof Type)
	        return config.type;
	      return new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      var defaultValue = injector.invoke(config.$$fn);
	      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
	        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	      return defaultValue;
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
	      for (i = 0; i < keys.length; i++) {
	        param = this[keys[i]];
	        rawVal = paramValues[keys[i]];
	        if ((rawVal === undefined || rawVal === null) && param.isOptional)
	          break; // There was no parameter value, but the param is optional
	        normalized = param.type.$normalize(rawVal);
	        if (!param.type.is(normalized))
	          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	        encoded = param.type.encode(normalized);
	        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
	          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	      }
	      return true;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	      //if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	         var url = urlMatcher.format(params || {});
	
	        // Handle the special hash param, if needed
	        if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	        }
	
	        $location.url(url);
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	
	        isHtml5 = isHtml5 && $sniffer.history;
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	
	        // Handle special hash param, if needed
	        if (url !== null && params && params['#']) {
	          url += '#' + params['#'];
	        }
	
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = inherit(state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSupersededError = new Error('transition superseded');
	
	    var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
	    var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
	    var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
	    var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) {
	          $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
	          return TransitionSuperseded;
	        }
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload(state) {
	      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      // Store the hash param for later (since it will be stripped out by various methods)
	      var hash = toParams['#'];
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      } else if (isString(options.reload) || isObject(options.reload)) {
	        if (isObject(options.reload) && !options.reload.name) {
	          throw new Error('Invalid reload state object');
	        }
	        
	        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	        if (options.reload && !reloadState) {
	          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	        }
	
	        while (state && state === fromPath[keep] && state !== reloadState) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	        if (hash) toParams['#'] = hash;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	        if (options.location && to.navigable && to.navigable.url) {
	          $urlRouter.push(to.navigable.url, toParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	          $urlRouter.update(true);
	        }
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	      
	      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	      if (hash) toParams['#'] = hash;
	      
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	          if ($state.transition == null) $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }).then(null, function (error) {
	        // propagate TransitionSuperseded error without emitting $stateChangeCancel
	        // as it was already emitted in the success handler above
	        if (error === TransitionSupersededError) return TransitionSuperseded;
	
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	          $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      if (!params) { return true; }
	
	      var keys = objectKeys(params);
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i], paramDef = state.params[key];
	        if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
	          return false;
	        }
	      }
	
	      return true;
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      function resolveViews() {
	        var viewsPromises = [];
	
	        // Resolve template and dependencies for all views.
	        forEach(state.views, function (view, name) {
	          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	          injectables.$template = [ function () {
	            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	          }];
	
	          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	            // References to the controller (only instantiated at link time)
	            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	              var injectLocals = angular.extend({}, injectables, dst.globals);
	              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	            } else {
	              result.$$controller = view.controller;
	            }
	            // Provide access to the state itself for internal use
	            result.$$state = state;
	            result.$$controllerAs = view.controllerAs;
	            result.$$resolveAs = view.resolveAs;
	            dst[name] = result;
	          }));
	        });
	
	        return $q.all(viewsPromises).then(function(){
	          return dst.globals;
	        });
	      }
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(resolveViews).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	    // Return true if there are no differences in non-search (path/object) params, false if there are differences
	    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	      function notSearchParam(key) {
	        return fromAndToState.params[key].location != "search";
	      }
	      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	      return nonQueryParamSet.$$equals(fromParams, toParams);
	    }
	
	    // If reload was not explicitly requested
	    // and we're transitioning to the same state we're already in
	    // and    the locals didn't change
	    //     or they changed in a way that doesn't merit reloading
	    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	    // Then return true.
	    if (!options.reload && to === from &&
	      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .factory('$stateParams', function () { return {}; })
	  .constant("$state.runtime", { autoinject: true })
	  .provider('$state', $StateProvider)
	  // Inject $state to initialize when entering runtime. #2574
	  .run(['$injector', function ($injector) {
	    // Allow tests (stateSpec.js) to turn this off by defining this constant
	    if ($injector.get("$state.runtime").autoinject) {
	      $injector.get('$state');
	    }
	  }]);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      return $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 *
	 * @example
	 * A view can be unnamed or named.
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div>
	 *
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div>
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 *
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * But typically you'll only use the views property if you name your view or have more than one view
	 * in the same template. There's not really a compelling reason to name a view if its the only one,
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre>
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div>
	 * <div ui-view="data"></div>
	 * </pre>
	 *
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 *
	 * Resolve data:
	 *
	 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	 *
	 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	 * depends on `$resolve` data.
	 *
	 * Example usage of $resolve in a view template
	 * <pre>
	 * $stateProvider.state('home', {
	 *   template: '<my-component user="$resolve.user"></my-component>',
	 *   resolve: {
	 *     user: function(UserService) { return UserService.fetchUser(); }
	 *   }
	 * });
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate,   $q) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = function() {
	      return {
	        enter: function (element, target, cb) { target.after(element); cb(); },
	        leave: function (element, cb) { element.remove(); cb(); }
	      };
	    };
	
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          if (angular.version.minor > 2) {
	            $animate.enter(element, null, target).then(cb);
	          } else {
	            $animate.enter(element, null, target, cb);
	          }
	        },
	        leave: function(element, cb) {
	          if (angular.version.minor > 2) {
	            $animate.leave(element).then(cb);
	          } else {
	            $animate.leave(element, cb);
	          }
	        }
	      };
	    }
	
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics();
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope),
	            inherited     = $element.inheritedData('$uiView');
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          if (previousEl) {
	            previousEl.remove();
	            previousEl = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	
	          if (currentEl) {
	            var $uiViewData = currentEl.data('$uiViewAnim');
	            renderer.leave(currentEl, function() {
	              $uiViewData.$$animLeave.resolve();
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	            currentEl = null;
	          }
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          newScope.$emit('$viewContentLoading', name);
	
	          var clone = $transclude(newScope, function(clone) {
	            var animEnter = $q.defer(), animLeave = $q.defer();
	            var viewAnimData = {
	              $animEnter: animEnter.promise,
	              $animLeave: animLeave.promise,
	              $$animLeave: animLeave
	            };
	
	            clone.data('$uiViewAnim', viewAnimData);
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              animEnter.resolve();
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          currentScope.$emit('$viewContentLoaded', name);
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var resolveData = angular.extend({}, locals);
	        scope[locals.$$resolveAs] = resolveData;
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          locals.$element = $element;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
	          }
	          if (isFunction(controller.$onInit)) controller.$onInit();
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var uiViewCreatedBy = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	function getTypeInfo(el) {
	  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	  var isForm = el[0].nodeName === "FORM";
	
	  return {
	    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	    isAnchor: el.prop("tagName").toUpperCase() === "A",
	    clickable: !isForm
	  };
	}
	
	function clickHook(el, $state, $timeout, type, current) {
	  return function(e) {
	    var button = e.which || e.button, target = current();
	
	    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	      var transition = $timeout(function() {
	        $state.go(target.state, target.params, target.options);
	      });
	      e.preventDefault();
	
	      // if the state has no URL, ignore one preventDefault from the <a> directive.
	      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;
	
	      e.preventDefault = function() {
	        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	      };
	    }
	  };
	}
	
	function defaultOpts(el, $state) {
	  return { relative: stateContext(el) || $state.$current, inherit: true };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
	      var def    = { state: ref.state, href: null, params: null };
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	      var update = function(val) {
	        if (val) def.params = angular.copy(val);
	        def.href = $state.href(ref.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
	        if (def.href !== null) attrs.$set(type.attr, def.href);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
	        def.params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element[element.on ? 'on' : 'bind']("click", hookFn);
	      scope.$on('$destroy', function() {
	        element[element.off ? 'off' : 'unbind']("click", hookFn);
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	function $StateRefDynamicDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
	      var def    = { state: null, params: null, options: null, href: null };
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      function runStateRefLink (group) {
	        def.state = group[0]; def.params = group[1]; def.options = group[2];
	        def.href = $state.href(def.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
	        if (def.href) attrs.$set(type.attr, def.href);
	      }
	
	      scope.$watch(watch, runStateRefLink, true);
	      runStateRefLink(scope.$eval(watch));
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element[element.on ? 'on' : 'bind']("click", hookFn);
	      scope.$on('$destroy', function() {
	        element[element.off ? 'off' : 'unbind']("click", hookFn);
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	      try {
	        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	      } catch (e) {
	        // Do nothing. uiSrefActive is not a valid expression.
	        // Fall back to using $interpolate below
	      }
	      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	      if (isObject(uiSrefActive)) {
	        forEach(uiSrefActive, function(stateOrName, activeClass) {
	          if (isString(stateOrName)) {
	            var ref = parseStateRef(stateOrName, $state.current.name);
	            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	          }
	        });
	      }
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$addStateInfo = function (newState, newParams) {
	        // we already got an explicit state provided by ui-sref-active, so we
	        // shadow the one that comes from ui-sref
	        if (isObject(uiSrefActive) && states.length > 0) {
	          return;
	        }
	        var deregister = addState(newState, newParams, uiSrefActive);
	        update();
	        return deregister;
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      function addState(stateName, stateParams, activeClass) {
	        var state = $state.get(stateName, stateContext($element));
	        var stateHash = createStateHash(stateName, stateParams);
	
	        var stateInfo = {
	          state: state || { name: stateName },
	          params: stateParams,
	          hash: stateHash
	        };
	
	        states.push(stateInfo);
	        activeClasses[stateHash] = activeClass;
	
	        return function removeState() {
	          var idx = states.indexOf(stateInfo);
	          if (idx !== -1) states.splice(idx, 1);
	        };
	      }
	
	      /**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */
	      function createStateHash(state, params) {
	        if (!isString(state)) {
	          throw new Error('state should be a string');
	        }
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        params = $scope.$eval(params);
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        return state;
	      }
	
	      // Update route state
	      function update() {
	        for (var i = 0; i < states.length; i++) {
	          if (anyMatch(states[i].state, states[i].params)) {
	            addClass($element, activeClasses[states[i].hash]);
	          } else {
	            removeClass($element, activeClasses[states[i].hash]);
	          }
	
	          if (exactMatch(states[i].state, states[i].params)) {
	            addClass($element, activeEqClass);
	          } else {
	            removeClass($element, activeEqClass);
	          }
	        }
	      }
	
	      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
	      function removeClass(el, className) { el.removeClass(className); }
	      function anyMatch(state, params) { return $state.includes(state.name, params); }
	      function exactMatch(state, params) { return $state.is(state.name, params); }
	
	      update();
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective)
	  .directive('uiState', $StateRefDynamicDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state, params) {
	    return $state.is(state, params);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state, params, options) {
	    return $state.includes(state, params, options);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(1044);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UserService.$inject = ["$http", "$q", "$rootScope", "adminService", "dashboardService", "timeService", "loginService", "toast", "store", "jwtHelper", "$translate", "$state", "$location"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _login = __webpack_require__(113);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _angularStorage = __webpack_require__(266);
	
	var _angularStorage2 = _interopRequireDefault(_angularStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.user', [_login2.default, _angularStorage2.default]).factory('userService', UserService).name;
	
	/*@ngInject*/
	
	function UserService($http, $q, $rootScope, adminService, dashboardService, timeService, loginService, toast, store, jwtHelper, $translate, $state, $location) {
	    var currentUser = null,
	        currentUserDetails = null,
	        lastPublicDashboardId = null,
	        allowedDashboardIds = [],
	        userTokenAccessEnabled = false,
	        userLoaded = false;
	
	    var refreshTokenQueue = [];
	
	    var service = {
	        deleteUser: deleteUser,
	        getAuthority: getAuthority,
	        isPublic: isPublic,
	        getPublicId: getPublicId,
	        parsePublicId: parsePublicId,
	        isAuthenticated: isAuthenticated,
	        getCurrentUser: getCurrentUser,
	        getCustomerUsers: getCustomerUsers,
	        getUser: getUser,
	        getTenantAdmins: getTenantAdmins,
	        isUserLoaded: isUserLoaded,
	        saveUser: saveUser,
	        sendActivationEmail: sendActivationEmail,
	        getActivationLink: getActivationLink,
	        setUserFromJwtToken: setUserFromJwtToken,
	        getJwtToken: getJwtToken,
	        clearJwtToken: clearJwtToken,
	        isJwtTokenValid: isJwtTokenValid,
	        validateJwtToken: validateJwtToken,
	        refreshJwtToken: refreshJwtToken,
	        refreshTokenPending: refreshTokenPending,
	        updateAuthorizationHeader: updateAuthorizationHeader,
	        setAuthorizationRequestHeader: setAuthorizationRequestHeader,
	        gotoDefaultPlace: gotoDefaultPlace,
	        forceDefaultPlace: forceDefaultPlace,
	        updateLastPublicDashboardId: updateLastPublicDashboardId,
	        logout: logout,
	        reloadUser: reloadUser,
	        isUserTokenAccessEnabled: isUserTokenAccessEnabled,
	        loginAsUser: loginAsUser
	    };
	
	    reloadUser();
	
	    return service;
	
	    function reloadUser() {
	        userLoaded = false;
	        loadUser(true).then(function success() {
	            notifyUserLoaded();
	        }, function fail() {
	            notifyUserLoaded();
	        });
	    }
	
	    function updateAndValidateToken(token, prefix, notify) {
	        var valid = false;
	        var tokenData = jwtHelper.decodeToken(token);
	        var issuedAt = tokenData.iat;
	        var expTime = tokenData.exp;
	        if (issuedAt && expTime) {
	            var ttl = expTime - issuedAt;
	            if (ttl > 0) {
	                var clientExpiration = new Date().valueOf() + ttl * 1000;
	                store.set(prefix, token);
	                store.set(prefix + '_expiration', clientExpiration);
	                valid = true;
	            }
	        }
	        if (!valid && notify) {
	            $rootScope.$broadcast('unauthenticated');
	        }
	    }
	
	    function clearTokenData() {
	        store.remove('jwt_token');
	        store.remove('jwt_token_expiration');
	        store.remove('refresh_token');
	        store.remove('refresh_token_expiration');
	    }
	
	    function setUserFromJwtToken(jwtToken, refreshToken, notify, doLogout) {
	        currentUser = null;
	        currentUserDetails = null;
	        lastPublicDashboardId = null;
	        userTokenAccessEnabled = false;
	        allowedDashboardIds = [];
	        if (!jwtToken) {
	            clearTokenData();
	            if (notify) {
	                $rootScope.$broadcast('unauthenticated', doLogout);
	            }
	        } else {
	            updateAndValidateToken(jwtToken, 'jwt_token', true);
	            updateAndValidateToken(refreshToken, 'refresh_token', true);
	            if (notify) {
	                loadUser(false).then(function success() {
	                    $rootScope.$broadcast('authenticated');
	                }, function fail() {
	                    $rootScope.$broadcast('unauthenticated');
	                });
	            } else {
	                loadUser(false);
	            }
	        }
	    }
	
	    function isAuthenticated() {
	        return store.get('jwt_token');
	    }
	
	    function getJwtToken() {
	        return store.get('jwt_token');
	    }
	
	    function logout() {
	        clearJwtToken(true);
	    }
	
	    function clearJwtToken(doLogout) {
	        setUserFromJwtToken(null, null, true, doLogout);
	    }
	
	    function isJwtTokenValid() {
	        return isTokenValid('jwt_token');
	    }
	
	    function isTokenValid(prefix) {
	        var clientExpiration = store.get(prefix + '_expiration');
	        return clientExpiration && clientExpiration > new Date().valueOf();
	    }
	
	    function validateJwtToken(doRefresh) {
	        var deferred = $q.defer();
	        if (!isTokenValid('jwt_token')) {
	            if (doRefresh) {
	                refreshJwtToken().then(function success() {
	                    deferred.resolve();
	                }, function fail() {
	                    deferred.reject();
	                });
	            } else {
	                clearJwtToken(false);
	                deferred.reject();
	            }
	        } else {
	            deferred.resolve();
	        }
	        return deferred.promise;
	    }
	
	    function resolveRefreshTokenQueue(data) {
	        for (var q = 0; q < refreshTokenQueue.length; q++) {
	            refreshTokenQueue[q].resolve(data);
	        }
	        refreshTokenQueue = [];
	    }
	
	    function rejectRefreshTokenQueue(message) {
	        for (var q = 0; q < refreshTokenQueue.length; q++) {
	            refreshTokenQueue[q].reject(message);
	        }
	        refreshTokenQueue = [];
	    }
	
	    function refreshTokenPending() {
	        return refreshTokenQueue.length > 0;
	    }
	
	    function refreshJwtToken() {
	        var deferred = $q.defer();
	        refreshTokenQueue.push(deferred);
	        if (refreshTokenQueue.length === 1) {
	            var refreshToken = store.get('refresh_token');
	            var refreshTokenValid = isTokenValid('refresh_token');
	            setUserFromJwtToken(null, null, false, false);
	            if (!refreshTokenValid) {
	                rejectRefreshTokenQueue($translate.instant('access.refresh-token-expired'));
	            } else {
	                var refreshTokenRequest = {
	                    refreshToken: refreshToken
	                };
	                $http.post('/api/auth/token', refreshTokenRequest).then(function success(response) {
	                    var token = response.data.token;
	                    var refreshToken = response.data.refreshToken;
	                    setUserFromJwtToken(token, refreshToken, false);
	                    resolveRefreshTokenQueue(response.data);
	                }, function fail() {
	                    clearJwtToken(false);
	                    rejectRefreshTokenQueue($translate.instant('access.refresh-token-failed'));
	                });
	            }
	        }
	        return deferred.promise;
	    }
	
	    function getCurrentUser() {
	        return currentUser;
	    }
	
	    function getAuthority() {
	        if (currentUser) {
	            return currentUser.authority;
	        } else {
	            return '';
	        }
	    }
	
	    function isPublic() {
	        if (currentUser) {
	            return currentUser.isPublic;
	        } else {
	            return false;
	        }
	    }
	
	    function getPublicId() {
	        if (isPublic()) {
	            return currentUser.sub;
	        } else {
	            return null;
	        }
	    }
	
	    function parsePublicId() {
	        var token = getJwtToken();
	        if (token) {
	            var tokenData = jwtHelper.decodeToken(token);
	            if (tokenData && tokenData.isPublic) {
	                return tokenData.sub;
	            }
	        }
	        return null;
	    }
	
	    function isUserLoaded() {
	        return userLoaded;
	    }
	
	    function loadUser(doTokenRefresh) {
	
	        var deferred = $q.defer();
	
	        function fetchAllowedDashboardIds() {
	            var pageLink = { limit: 100 };
	            var fetchDashboardsPromise;
	            if (currentUser.authority === 'TENANT_ADMIN') {
	                fetchDashboardsPromise = dashboardService.getTenantDashboards(pageLink);
	            } else {
	                fetchDashboardsPromise = dashboardService.getCustomerDashboards(currentUser.customerId, pageLink);
	            }
	            fetchDashboardsPromise.then(function success(result) {
	                var dashboards = result.data;
	                for (var d = 0; d < dashboards.length; d++) {
	                    allowedDashboardIds.push(dashboards[d].id.id);
	                }
	                deferred.resolve();
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	
	        function updateUserLang() {
	            if (currentUserDetails.additionalInfo && currentUserDetails.additionalInfo.lang) {
	                $translate.use(currentUserDetails.additionalInfo.lang);
	            }
	        }
	
	        function procceedJwtTokenValidate() {
	            validateJwtToken(doTokenRefresh).then(function success() {
	                var jwtToken = store.get('jwt_token');
	                currentUser = jwtHelper.decodeToken(jwtToken);
	                if (currentUser && currentUser.scopes && currentUser.scopes.length > 0) {
	                    currentUser.authority = currentUser.scopes[0];
	                } else if (currentUser) {
	                    currentUser.authority = "ANONYMOUS";
	                }
	                var sysParamsPromise = loadSystemParams();
	                if (currentUser.isPublic) {
	                    $rootScope.forceFullscreen = true;
	                    sysParamsPromise.then(function () {
	                        fetchAllowedDashboardIds();
	                    }, function () {
	                        deferred.reject();
	                    });
	                } else if (currentUser.userId) {
	                    getUser(currentUser.userId, true).then(function success(user) {
	                        sysParamsPromise.then(function () {
	                            currentUserDetails = user;
	                            updateUserLang();
	                            $rootScope.forceFullscreen = false;
	                            if (userForceFullscreen()) {
	                                $rootScope.forceFullscreen = true;
	                            }
	                            if ($rootScope.forceFullscreen && (currentUser.authority === 'TENANT_ADMIN' || currentUser.authority === 'CUSTOMER_USER')) {
	                                fetchAllowedDashboardIds();
	                            } else {
	                                deferred.resolve();
	                            }
	                        }, function () {
	                            deferred.reject();
	                            logout();
	                        });
	                    }, function fail() {
	                        deferred.reject();
	                        logout();
	                    });
	                } else {
	                    deferred.reject();
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	
	        if (!currentUser) {
	            var locationSearch = $location.search();
	            if (locationSearch.publicId) {
	                loginService.publicLogin(locationSearch.publicId).then(function success(response) {
	                    var token = response.data.token;
	                    var refreshToken = response.data.refreshToken;
	                    updateAndValidateToken(token, 'jwt_token', false);
	                    updateAndValidateToken(refreshToken, 'refresh_token', false);
	                    procceedJwtTokenValidate();
	                }, function fail() {
	                    $location.search('publicId', null);
	                    deferred.reject();
	                });
	            } else {
	                procceedJwtTokenValidate();
	            }
	        } else {
	            deferred.resolve();
	        }
	        return deferred.promise;
	    }
	
	    function loadIsUserTokenAccessEnabled() {
	        var deferred = $q.defer();
	        if (currentUser.authority === 'SYS_ADMIN' || currentUser.authority === 'TENANT_ADMIN') {
	            var url = '/api/user/tokenAccessEnabled';
	            $http.get(url).then(function success(response) {
	                userTokenAccessEnabled = response.data;
	                deferred.resolve(response.data);
	            }, function fail() {
	                userTokenAccessEnabled = false;
	                deferred.reject();
	            });
	        } else {
	            userTokenAccessEnabled = false;
	            deferred.resolve(false);
	        }
	        return deferred.promise;
	    }
	
	    function loadSystemParams() {
	        var promises = [];
	        promises.push(loadIsUserTokenAccessEnabled());
	        promises.push(timeService.loadMaxDatapointsLimit());
	        return $q.all(promises);
	    }
	
	    function notifyUserLoaded() {
	        if (!userLoaded) {
	            userLoaded = true;
	            $rootScope.$broadcast('userLoaded');
	        }
	    }
	
	    function updateAuthorizationHeader(headers) {
	        var jwtToken = store.get('jwt_token');
	        if (jwtToken) {
	            headers['X-Authorization'] = 'Bearer ' + jwtToken;
	        }
	        return jwtToken;
	    }
	
	    function setAuthorizationRequestHeader(request) {
	        var jwtToken = store.get('jwt_token');
	        if (jwtToken) {
	            request.setRequestHeader('X-Authorization', 'Bearer ' + jwtToken);
	        }
	        return jwtToken;
	    }
	
	    function getTenantAdmins(tenantId, pageLink) {
	        var deferred = $q.defer();
	        var url = '/api/tenant/' + tenantId + '/users?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getCustomerUsers(customerId, pageLink) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/users?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveUser(user, sendActivationMail) {
	        var deferred = $q.defer();
	        var url = '/api/user';
	        if (angular.isDefined(sendActivationMail)) {
	            url += '?sendActivationMail=' + sendActivationMail;
	        }
	        $http.post(url, user).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getUser(userId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/user/' + userId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteUser(userId) {
	        var deferred = $q.defer();
	        var url = '/api/user/' + userId;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function sendActivationEmail(email) {
	        var deferred = $q.defer();
	        var url = '/api/user/sendActivationMail?email=' + email;
	        $http.post(url, null).then(function success(response) {
	            deferred.resolve(response);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getActivationLink(userId) {
	        var deferred = $q.defer();
	        var url = '/api/user/' + userId + '/activationLink';
	        $http.get(url).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function forceDefaultPlace(to, params) {
	        if (currentUser && isAuthenticated()) {
	            if (currentUser.authority === 'TENANT_ADMIN' || currentUser.authority === 'CUSTOMER_USER') {
	                if (userHasDefaultDashboard() && $rootScope.forceFullscreen || isPublic()) {
	                    if (to.name === 'home.profile') {
	                        if (userHasProfile()) {
	                            return false;
	                        } else {
	                            return true;
	                        }
	                    } else if ((to.name === 'home.dashboards.dashboard' || to.name === 'dashboard') && allowedDashboardIds.indexOf(params.dashboardId) > -1) {
	                        return false;
	                    } else {
	                        return true;
	                    }
	                }
	            }
	        }
	        return false;
	    }
	
	    function gotoDefaultPlace(params) {
	        if (currentUser && isAuthenticated()) {
	            var place = 'home.links';
	            if (currentUser.authority === 'TENANT_ADMIN' || currentUser.authority === 'CUSTOMER_USER') {
	                if (userHasDefaultDashboard()) {
	                    place = $rootScope.forceFullscreen ? 'dashboard' : 'home.dashboards.dashboard';
	                    params = { dashboardId: currentUserDetails.additionalInfo.defaultDashboardId };
	                } else if (isPublic()) {
	                    place = 'dashboard';
	                    params = { dashboardId: lastPublicDashboardId };
	                }
	            } else if (currentUser.authority === 'SYS_ADMIN') {
	                adminService.checkUpdates().then(function (updateMessage) {
	                    if (updateMessage && updateMessage.updateAvailable) {
	                        toast.showInfo(updateMessage.message, 0, null, 'bottom right');
	                    }
	                });
	            }
	            $state.go(place, params, { reload: true });
	        } else {
	            $state.go('login', params);
	        }
	    }
	
	    function userHasDefaultDashboard() {
	        return currentUserDetails && currentUserDetails.additionalInfo && currentUserDetails.additionalInfo.defaultDashboardId;
	    }
	
	    function userForceFullscreen() {
	        return currentUser && currentUser.isPublic || currentUserDetails.additionalInfo && currentUserDetails.additionalInfo.defaultDashboardFullscreen && currentUserDetails.additionalInfo.defaultDashboardFullscreen === true;
	    }
	
	    function userHasProfile() {
	        return currentUser && !currentUser.isPublic;
	    }
	
	    function updateLastPublicDashboardId(dashboardId) {
	        if (isPublic()) {
	            lastPublicDashboardId = dashboardId;
	        }
	    }
	
	    function isUserTokenAccessEnabled() {
	        return userTokenAccessEnabled;
	    }
	
	    function loginAsUser(userId) {
	        var url = '/api/user/' + userId + '/token';
	        $http.get(url).then(function success(response) {
	            var token = response.data.token;
	            var refreshToken = response.data.refreshToken;
	            setUserFromJwtToken(token, refreshToken, true);
	        }, function fail() {});
	    }
	}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	ace.define("ace/snippets",["require","exports","module","ace/lib/oop","ace/lib/event_emitter","ace/lib/lang","ace/range","ace/anchor","ace/keyboard/hash_handler","ace/tokenizer","ace/lib/dom","ace/editor"], function(acequire, exports, module) {
	"use strict";
	var oop = acequire("./lib/oop");
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	var lang = acequire("./lib/lang");
	var Range = acequire("./range").Range;
	var Anchor = acequire("./anchor").Anchor;
	var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
	var Tokenizer = acequire("./tokenizer").Tokenizer;
	var comparePoints = Range.comparePoints;
	
	var SnippetManager = function() {
	    this.snippetMap = {};
	    this.snippetNameMap = {};
	};
	
	(function() {
	    oop.implement(this, EventEmitter);
	    
	    this.getTokenizer = function() {
	        function TabstopToken(str, _, stack) {
	            str = str.substr(1);
	            if (/^\d+$/.test(str) && !stack.inFormatString)
	                return [{tabstopId: parseInt(str, 10)}];
	            return [{text: str}];
	        }
	        function escape(ch) {
	            return "(?:[^\\\\" + ch + "]|\\\\.)";
	        }
	        SnippetManager.$tokenizer = new Tokenizer({
	            start: [
	                {regex: /:/, onMatch: function(val, state, stack) {
	                    if (stack.length && stack[0].expectIf) {
	                        stack[0].expectIf = false;
	                        stack[0].elseBranch = stack[0];
	                        return [stack[0]];
	                    }
	                    return ":";
	                }},
	                {regex: /\\./, onMatch: function(val, state, stack) {
	                    var ch = val[1];
	                    if (ch == "}" && stack.length) {
	                        val = ch;
	                    }else if ("`$\\".indexOf(ch) != -1) {
	                        val = ch;
	                    } else if (stack.inFormatString) {
	                        if (ch == "n")
	                            val = "\n";
	                        else if (ch == "t")
	                            val = "\n";
	                        else if ("ulULE".indexOf(ch) != -1) {
	                            val = {changeCase: ch, local: ch > "a"};
	                        }
	                    }
	
	                    return [val];
	                }},
	                {regex: /}/, onMatch: function(val, state, stack) {
	                    return [stack.length ? stack.shift() : val];
	                }},
	                {regex: /\$(?:\d+|\w+)/, onMatch: TabstopToken},
	                {regex: /\$\{[\dA-Z_a-z]+/, onMatch: function(str, state, stack) {
	                    var t = TabstopToken(str.substr(1), state, stack);
	                    stack.unshift(t[0]);
	                    return t;
	                }, next: "snippetVar"},
	                {regex: /\n/, token: "newline", merge: false}
	            ],
	            snippetVar: [
	                {regex: "\\|" + escape("\\|") + "*\\|", onMatch: function(val, state, stack) {
	                    stack[0].choices = val.slice(1, -1).split(",");
	                }, next: "start"},
	                {regex: "/(" + escape("/") + "+)/(?:(" + escape("/") + "*)/)(\\w*):?",
	                 onMatch: function(val, state, stack) {
	                    var ts = stack[0];
	                    ts.fmtString = val;
	
	                    val = this.splitRegex.exec(val);
	                    ts.guard = val[1];
	                    ts.fmt = val[2];
	                    ts.flag = val[3];
	                    return "";
	                }, next: "start"},
	                {regex: "`" + escape("`") + "*`", onMatch: function(val, state, stack) {
	                    stack[0].code = val.splice(1, -1);
	                    return "";
	                }, next: "start"},
	                {regex: "\\?", onMatch: function(val, state, stack) {
	                    if (stack[0])
	                        stack[0].expectIf = true;
	                }, next: "start"},
	                {regex: "([^:}\\\\]|\\\\.)*:?", token: "", next: "start"}
	            ],
	            formatString: [
	                {regex: "/(" + escape("/") + "+)/", token: "regex"},
	                {regex: "", onMatch: function(val, state, stack) {
	                    stack.inFormatString = true;
	                }, next: "start"}
	            ]
	        });
	        SnippetManager.prototype.getTokenizer = function() {
	            return SnippetManager.$tokenizer;
	        };
	        return SnippetManager.$tokenizer;
	    };
	
	    this.tokenizeTmSnippet = function(str, startState) {
	        return this.getTokenizer().getLineTokens(str, startState).tokens.map(function(x) {
	            return x.value || x;
	        });
	    };
	
	    this.$getDefaultValue = function(editor, name) {
	        if (/^[A-Z]\d+$/.test(name)) {
	            var i = name.substr(1);
	            return (this.variables[name[0] + "__"] || {})[i];
	        }
	        if (/^\d+$/.test(name)) {
	            return (this.variables.__ || {})[name];
	        }
	        name = name.replace(/^TM_/, "");
	
	        if (!editor)
	            return;
	        var s = editor.session;
	        switch(name) {
	            case "CURRENT_WORD":
	                var r = s.getWordRange();
	            case "SELECTION":
	            case "SELECTED_TEXT":
	                return s.getTextRange(r);
	            case "CURRENT_LINE":
	                return s.getLine(editor.getCursorPosition().row);
	            case "PREV_LINE": // not possible in textmate
	                return s.getLine(editor.getCursorPosition().row - 1);
	            case "LINE_INDEX":
	                return editor.getCursorPosition().column;
	            case "LINE_NUMBER":
	                return editor.getCursorPosition().row + 1;
	            case "SOFT_TABS":
	                return s.getUseSoftTabs() ? "YES" : "NO";
	            case "TAB_SIZE":
	                return s.getTabSize();
	            case "FILENAME":
	            case "FILEPATH":
	                return "";
	            case "FULLNAME":
	                return "Ace";
	        }
	    };
	    this.variables = {};
	    this.getVariableValue = function(editor, varName) {
	        if (this.variables.hasOwnProperty(varName))
	            return this.variables[varName](editor, varName) || "";
	        return this.$getDefaultValue(editor, varName) || "";
	    };
	    this.tmStrFormat = function(str, ch, editor) {
	        var flag = ch.flag || "";
	        var re = ch.guard;
	        re = new RegExp(re, flag.replace(/[^gi]/, ""));
	        var fmtTokens = this.tokenizeTmSnippet(ch.fmt, "formatString");
	        var _self = this;
	        var formatted = str.replace(re, function() {
	            _self.variables.__ = arguments;
	            var fmtParts = _self.resolveVariables(fmtTokens, editor);
	            var gChangeCase = "E";
	            for (var i  = 0; i < fmtParts.length; i++) {
	                var ch = fmtParts[i];
	                if (typeof ch == "object") {
	                    fmtParts[i] = "";
	                    if (ch.changeCase && ch.local) {
	                        var next = fmtParts[i + 1];
	                        if (next && typeof next == "string") {
	                            if (ch.changeCase == "u")
	                                fmtParts[i] = next[0].toUpperCase();
	                            else
	                                fmtParts[i] = next[0].toLowerCase();
	                            fmtParts[i + 1] = next.substr(1);
	                        }
	                    } else if (ch.changeCase) {
	                        gChangeCase = ch.changeCase;
	                    }
	                } else if (gChangeCase == "U") {
	                    fmtParts[i] = ch.toUpperCase();
	                } else if (gChangeCase == "L") {
	                    fmtParts[i] = ch.toLowerCase();
	                }
	            }
	            return fmtParts.join("");
	        });
	        this.variables.__ = null;
	        return formatted;
	    };
	
	    this.resolveVariables = function(snippet, editor) {
	        var result = [];
	        for (var i = 0; i < snippet.length; i++) {
	            var ch = snippet[i];
	            if (typeof ch == "string") {
	                result.push(ch);
	            } else if (typeof ch != "object") {
	                continue;
	            } else if (ch.skip) {
	                gotoNext(ch);
	            } else if (ch.processed < i) {
	                continue;
	            } else if (ch.text) {
	                var value = this.getVariableValue(editor, ch.text);
	                if (value && ch.fmtString)
	                    value = this.tmStrFormat(value, ch);
	                ch.processed = i;
	                if (ch.expectIf == null) {
	                    if (value) {
	                        result.push(value);
	                        gotoNext(ch);
	                    }
	                } else {
	                    if (value) {
	                        ch.skip = ch.elseBranch;
	                    } else
	                        gotoNext(ch);
	                }
	            } else if (ch.tabstopId != null) {
	                result.push(ch);
	            } else if (ch.changeCase != null) {
	                result.push(ch);
	            }
	        }
	        function gotoNext(ch) {
	            var i1 = snippet.indexOf(ch, i + 1);
	            if (i1 != -1)
	                i = i1;
	        }
	        return result;
	    };
	
	    this.insertSnippetForSelection = function(editor, snippetText) {
	        var cursor = editor.getCursorPosition();
	        var line = editor.session.getLine(cursor.row);
	        var tabString = editor.session.getTabString();
	        var indentString = line.match(/^\s*/)[0];
	        
	        if (cursor.column < indentString.length)
	            indentString = indentString.slice(0, cursor.column);
	
	        snippetText = snippetText.replace(/\r/g, "");
	        var tokens = this.tokenizeTmSnippet(snippetText);
	        tokens = this.resolveVariables(tokens, editor);
	        tokens = tokens.map(function(x) {
	            if (x == "\n")
	                return x + indentString;
	            if (typeof x == "string")
	                return x.replace(/\t/g, tabString);
	            return x;
	        });
	        var tabstops = [];
	        tokens.forEach(function(p, i) {
	            if (typeof p != "object")
	                return;
	            var id = p.tabstopId;
	            var ts = tabstops[id];
	            if (!ts) {
	                ts = tabstops[id] = [];
	                ts.index = id;
	                ts.value = "";
	            }
	            if (ts.indexOf(p) !== -1)
	                return;
	            ts.push(p);
	            var i1 = tokens.indexOf(p, i + 1);
	            if (i1 === -1)
	                return;
	
	            var value = tokens.slice(i + 1, i1);
	            var isNested = value.some(function(t) {return typeof t === "object"});          
	            if (isNested && !ts.value) {
	                ts.value = value;
	            } else if (value.length && (!ts.value || typeof ts.value !== "string")) {
	                ts.value = value.join("");
	            }
	        });
	        tabstops.forEach(function(ts) {ts.length = 0});
	        var expanding = {};
	        function copyValue(val) {
	            var copy = [];
	            for (var i = 0; i < val.length; i++) {
	                var p = val[i];
	                if (typeof p == "object") {
	                    if (expanding[p.tabstopId])
	                        continue;
	                    var j = val.lastIndexOf(p, i - 1);
	                    p = copy[j] || {tabstopId: p.tabstopId};
	                }
	                copy[i] = p;
	            }
	            return copy;
	        }
	        for (var i = 0; i < tokens.length; i++) {
	            var p = tokens[i];
	            if (typeof p != "object")
	                continue;
	            var id = p.tabstopId;
	            var i1 = tokens.indexOf(p, i + 1);
	            if (expanding[id]) {
	                if (expanding[id] === p)
	                    expanding[id] = null;
	                continue;
	            }
	            
	            var ts = tabstops[id];
	            var arg = typeof ts.value == "string" ? [ts.value] : copyValue(ts.value);
	            arg.unshift(i + 1, Math.max(0, i1 - i));
	            arg.push(p);
	            expanding[id] = p;
	            tokens.splice.apply(tokens, arg);
	
	            if (ts.indexOf(p) === -1)
	                ts.push(p);
	        }
	        var row = 0, column = 0;
	        var text = "";
	        tokens.forEach(function(t) {
	            if (typeof t === "string") {
	                var lines = t.split("\n");
	                if (lines.length > 1){
	                    column = lines[lines.length - 1].length;
	                    row += lines.length - 1;
	                } else
	                    column += t.length;
	                text += t;
	            } else {
	                if (!t.start)
	                    t.start = {row: row, column: column};
	                else
	                    t.end = {row: row, column: column};
	            }
	        });
	        var range = editor.getSelectionRange();
	        var end = editor.session.replace(range, text);
	
	        var tabstopManager = new TabstopManager(editor);
	        var selectionId = editor.inVirtualSelectionMode && editor.selection.index;
	        tabstopManager.addTabstops(tabstops, range.start, end, selectionId);
	    };
	    
	    this.insertSnippet = function(editor, snippetText) {
	        var self = this;
	        if (editor.inVirtualSelectionMode)
	            return self.insertSnippetForSelection(editor, snippetText);
	        
	        editor.forEachSelection(function() {
	            self.insertSnippetForSelection(editor, snippetText);
	        }, null, {keepOrder: true});
	        
	        if (editor.tabstopManager)
	            editor.tabstopManager.tabNext();
	    };
	
	    this.$getScope = function(editor) {
	        var scope = editor.session.$mode.$id || "";
	        scope = scope.split("/").pop();
	        if (scope === "html" || scope === "php") {
	            if (scope === "php" && !editor.session.$mode.inlinePhp) 
	                scope = "html";
	            var c = editor.getCursorPosition();
	            var state = editor.session.getState(c.row);
	            if (typeof state === "object") {
	                state = state[0];
	            }
	            if (state.substring) {
	                if (state.substring(0, 3) == "js-")
	                    scope = "javascript";
	                else if (state.substring(0, 4) == "css-")
	                    scope = "css";
	                else if (state.substring(0, 4) == "php-")
	                    scope = "php";
	            }
	        }
	        
	        return scope;
	    };
	
	    this.getActiveScopes = function(editor) {
	        var scope = this.$getScope(editor);
	        var scopes = [scope];
	        var snippetMap = this.snippetMap;
	        if (snippetMap[scope] && snippetMap[scope].includeScopes) {
	            scopes.push.apply(scopes, snippetMap[scope].includeScopes);
	        }
	        scopes.push("_");
	        return scopes;
	    };
	
	    this.expandWithTab = function(editor, options) {
	        var self = this;
	        var result = editor.forEachSelection(function() {
	            return self.expandSnippetForSelection(editor, options);
	        }, null, {keepOrder: true});
	        if (result && editor.tabstopManager)
	            editor.tabstopManager.tabNext();
	        return result;
	    };
	    
	    this.expandSnippetForSelection = function(editor, options) {
	        var cursor = editor.getCursorPosition();
	        var line = editor.session.getLine(cursor.row);
	        var before = line.substring(0, cursor.column);
	        var after = line.substr(cursor.column);
	
	        var snippetMap = this.snippetMap;
	        var snippet;
	        this.getActiveScopes(editor).some(function(scope) {
	            var snippets = snippetMap[scope];
	            if (snippets)
	                snippet = this.findMatchingSnippet(snippets, before, after);
	            return !!snippet;
	        }, this);
	        if (!snippet)
	            return false;
	        if (options && options.dryRun)
	            return true;
	        editor.session.doc.removeInLine(cursor.row,
	            cursor.column - snippet.replaceBefore.length,
	            cursor.column + snippet.replaceAfter.length
	        );
	
	        this.variables.M__ = snippet.matchBefore;
	        this.variables.T__ = snippet.matchAfter;
	        this.insertSnippetForSelection(editor, snippet.content);
	
	        this.variables.M__ = this.variables.T__ = null;
	        return true;
	    };
	
	    this.findMatchingSnippet = function(snippetList, before, after) {
	        for (var i = snippetList.length; i--;) {
	            var s = snippetList[i];
	            if (s.startRe && !s.startRe.test(before))
	                continue;
	            if (s.endRe && !s.endRe.test(after))
	                continue;
	            if (!s.startRe && !s.endRe)
	                continue;
	
	            s.matchBefore = s.startRe ? s.startRe.exec(before) : [""];
	            s.matchAfter = s.endRe ? s.endRe.exec(after) : [""];
	            s.replaceBefore = s.triggerRe ? s.triggerRe.exec(before)[0] : "";
	            s.replaceAfter = s.endTriggerRe ? s.endTriggerRe.exec(after)[0] : "";
	            return s;
	        }
	    };
	
	    this.snippetMap = {};
	    this.snippetNameMap = {};
	    this.register = function(snippets, scope) {
	        var snippetMap = this.snippetMap;
	        var snippetNameMap = this.snippetNameMap;
	        var self = this;
	        
	        if (!snippets) 
	            snippets = [];
	        
	        function wrapRegexp(src) {
	            if (src && !/^\^?\(.*\)\$?$|^\\b$/.test(src))
	                src = "(?:" + src + ")";
	
	            return src || "";
	        }
	        function guardedRegexp(re, guard, opening) {
	            re = wrapRegexp(re);
	            guard = wrapRegexp(guard);
	            if (opening) {
	                re = guard + re;
	                if (re && re[re.length - 1] != "$")
	                    re = re + "$";
	            } else {
	                re = re + guard;
	                if (re && re[0] != "^")
	                    re = "^" + re;
	            }
	            return new RegExp(re);
	        }
	
	        function addSnippet(s) {
	            if (!s.scope)
	                s.scope = scope || "_";
	            scope = s.scope;
	            if (!snippetMap[scope]) {
	                snippetMap[scope] = [];
	                snippetNameMap[scope] = {};
	            }
	
	            var map = snippetNameMap[scope];
	            if (s.name) {
	                var old = map[s.name];
	                if (old)
	                    self.unregister(old);
	                map[s.name] = s;
	            }
	            snippetMap[scope].push(s);
	
	            if (s.tabTrigger && !s.trigger) {
	                if (!s.guard && /^\w/.test(s.tabTrigger))
	                    s.guard = "\\b";
	                s.trigger = lang.escapeRegExp(s.tabTrigger);
	            }
	            
	            if (!s.trigger && !s.guard && !s.endTrigger && !s.endGuard)
	                return;
	            
	            s.startRe = guardedRegexp(s.trigger, s.guard, true);
	            s.triggerRe = new RegExp(s.trigger, "", true);
	
	            s.endRe = guardedRegexp(s.endTrigger, s.endGuard, true);
	            s.endTriggerRe = new RegExp(s.endTrigger, "", true);
	        }
	
	        if (snippets && snippets.content)
	            addSnippet(snippets);
	        else if (Array.isArray(snippets))
	            snippets.forEach(addSnippet);
	        
	        this._signal("registerSnippets", {scope: scope});
	    };
	    this.unregister = function(snippets, scope) {
	        var snippetMap = this.snippetMap;
	        var snippetNameMap = this.snippetNameMap;
	
	        function removeSnippet(s) {
	            var nameMap = snippetNameMap[s.scope||scope];
	            if (nameMap && nameMap[s.name]) {
	                delete nameMap[s.name];
	                var map = snippetMap[s.scope||scope];
	                var i = map && map.indexOf(s);
	                if (i >= 0)
	                    map.splice(i, 1);
	            }
	        }
	        if (snippets.content)
	            removeSnippet(snippets);
	        else if (Array.isArray(snippets))
	            snippets.forEach(removeSnippet);
	    };
	    this.parseSnippetFile = function(str) {
	        str = str.replace(/\r/g, "");
	        var list = [], snippet = {};
	        var re = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm;
	        var m;
	        while (m = re.exec(str)) {
	            if (m[1]) {
	                try {
	                    snippet = JSON.parse(m[1]);
	                    list.push(snippet);
	                } catch (e) {}
	            } if (m[4]) {
	                snippet.content = m[4].replace(/^\t/gm, "");
	                list.push(snippet);
	                snippet = {};
	            } else {
	                var key = m[2], val = m[3];
	                if (key == "regex") {
	                    var guardRe = /\/((?:[^\/\\]|\\.)*)|$/g;
	                    snippet.guard = guardRe.exec(val)[1];
	                    snippet.trigger = guardRe.exec(val)[1];
	                    snippet.endTrigger = guardRe.exec(val)[1];
	                    snippet.endGuard = guardRe.exec(val)[1];
	                } else if (key == "snippet") {
	                    snippet.tabTrigger = val.match(/^\S*/)[0];
	                    if (!snippet.name)
	                        snippet.name = val;
	                } else {
	                    snippet[key] = val;
	                }
	            }
	        }
	        return list;
	    };
	    this.getSnippetByName = function(name, editor) {
	        var snippetMap = this.snippetNameMap;
	        var snippet;
	        this.getActiveScopes(editor).some(function(scope) {
	            var snippets = snippetMap[scope];
	            if (snippets)
	                snippet = snippets[name];
	            return !!snippet;
	        }, this);
	        return snippet;
	    };
	
	}).call(SnippetManager.prototype);
	
	
	var TabstopManager = function(editor) {
	    if (editor.tabstopManager)
	        return editor.tabstopManager;
	    editor.tabstopManager = this;
	    this.$onChange = this.onChange.bind(this);
	    this.$onChangeSelection = lang.delayedCall(this.onChangeSelection.bind(this)).schedule;
	    this.$onChangeSession = this.onChangeSession.bind(this);
	    this.$onAfterExec = this.onAfterExec.bind(this);
	    this.attach(editor);
	};
	(function() {
	    this.attach = function(editor) {
	        this.index = 0;
	        this.ranges = [];
	        this.tabstops = [];
	        this.$openTabstops = null;
	        this.selectedTabstop = null;
	
	        this.editor = editor;
	        this.editor.on("change", this.$onChange);
	        this.editor.on("changeSelection", this.$onChangeSelection);
	        this.editor.on("changeSession", this.$onChangeSession);
	        this.editor.commands.on("afterExec", this.$onAfterExec);
	        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
	    };
	    this.detach = function() {
	        this.tabstops.forEach(this.removeTabstopMarkers, this);
	        this.ranges = null;
	        this.tabstops = null;
	        this.selectedTabstop = null;
	        this.editor.removeListener("change", this.$onChange);
	        this.editor.removeListener("changeSelection", this.$onChangeSelection);
	        this.editor.removeListener("changeSession", this.$onChangeSession);
	        this.editor.commands.removeListener("afterExec", this.$onAfterExec);
	        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
	        this.editor.tabstopManager = null;
	        this.editor = null;
	    };
	
	    this.onChange = function(delta) {
	        var changeRange = delta;
	        var isRemove = delta.action[0] == "r";
	        var start = delta.start;
	        var end = delta.end;
	        var startRow = start.row;
	        var endRow = end.row;
	        var lineDif = endRow - startRow;
	        var colDiff = end.column - start.column;
	
	        if (isRemove) {
	            lineDif = -lineDif;
	            colDiff = -colDiff;
	        }
	        if (!this.$inChange && isRemove) {
	            var ts = this.selectedTabstop;
	            var changedOutside = ts && !ts.some(function(r) {
	                return comparePoints(r.start, start) <= 0 && comparePoints(r.end, end) >= 0;
	            });
	            if (changedOutside)
	                return this.detach();
	        }
	        var ranges = this.ranges;
	        for (var i = 0; i < ranges.length; i++) {
	            var r = ranges[i];
	            if (r.end.row < start.row)
	                continue;
	
	            if (isRemove && comparePoints(start, r.start) < 0 && comparePoints(end, r.end) > 0) {
	                this.removeRange(r);
	                i--;
	                continue;
	            }
	
	            if (r.start.row == startRow && r.start.column > start.column)
	                r.start.column += colDiff;
	            if (r.end.row == startRow && r.end.column >= start.column)
	                r.end.column += colDiff;
	            if (r.start.row >= startRow)
	                r.start.row += lineDif;
	            if (r.end.row >= startRow)
	                r.end.row += lineDif;
	
	            if (comparePoints(r.start, r.end) > 0)
	                this.removeRange(r);
	        }
	        if (!ranges.length)
	            this.detach();
	    };
	    this.updateLinkedFields = function() {
	        var ts = this.selectedTabstop;
	        if (!ts || !ts.hasLinkedRanges)
	            return;
	        this.$inChange = true;
	        var session = this.editor.session;
	        var text = session.getTextRange(ts.firstNonLinked);
	        for (var i = ts.length; i--;) {
	            var range = ts[i];
	            if (!range.linked)
	                continue;
	            var fmt = exports.snippetManager.tmStrFormat(text, range.original);
	            session.replace(range, fmt);
	        }
	        this.$inChange = false;
	    };
	    this.onAfterExec = function(e) {
	        if (e.command && !e.command.readOnly)
	            this.updateLinkedFields();
	    };
	    this.onChangeSelection = function() {
	        if (!this.editor)
	            return;
	        var lead = this.editor.selection.lead;
	        var anchor = this.editor.selection.anchor;
	        var isEmpty = this.editor.selection.isEmpty();
	        for (var i = this.ranges.length; i--;) {
	            if (this.ranges[i].linked)
	                continue;
	            var containsLead = this.ranges[i].contains(lead.row, lead.column);
	            var containsAnchor = isEmpty || this.ranges[i].contains(anchor.row, anchor.column);
	            if (containsLead && containsAnchor)
	                return;
	        }
	        this.detach();
	    };
	    this.onChangeSession = function() {
	        this.detach();
	    };
	    this.tabNext = function(dir) {
	        var max = this.tabstops.length;
	        var index = this.index + (dir || 1);
	        index = Math.min(Math.max(index, 1), max);
	        if (index == max)
	            index = 0;
	        this.selectTabstop(index);
	        if (index === 0)
	            this.detach();
	    };
	    this.selectTabstop = function(index) {
	        this.$openTabstops = null;
	        var ts = this.tabstops[this.index];
	        if (ts)
	            this.addTabstopMarkers(ts);
	        this.index = index;
	        ts = this.tabstops[this.index];
	        if (!ts || !ts.length)
	            return;
	        
	        this.selectedTabstop = ts;
	        if (!this.editor.inVirtualSelectionMode) {        
	            var sel = this.editor.multiSelect;
	            sel.toSingleRange(ts.firstNonLinked.clone());
	            for (var i = ts.length; i--;) {
	                if (ts.hasLinkedRanges && ts[i].linked)
	                    continue;
	                sel.addRange(ts[i].clone(), true);
	            }
	            if (sel.ranges[0])
	                sel.addRange(sel.ranges[0].clone());
	        } else {
	            this.editor.selection.setRange(ts.firstNonLinked);
	        }
	        
	        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
	    };
	    this.addTabstops = function(tabstops, start, end) {
	        if (!this.$openTabstops)
	            this.$openTabstops = [];
	        if (!tabstops[0]) {
	            var p = Range.fromPoints(end, end);
	            moveRelative(p.start, start);
	            moveRelative(p.end, start);
	            tabstops[0] = [p];
	            tabstops[0].index = 0;
	        }
	
	        var i = this.index;
	        var arg = [i + 1, 0];
	        var ranges = this.ranges;
	        tabstops.forEach(function(ts, index) {
	            var dest = this.$openTabstops[index] || ts;
	                
	            for (var i = ts.length; i--;) {
	                var p = ts[i];
	                var range = Range.fromPoints(p.start, p.end || p.start);
	                movePoint(range.start, start);
	                movePoint(range.end, start);
	                range.original = p;
	                range.tabstop = dest;
	                ranges.push(range);
	                if (dest != ts)
	                    dest.unshift(range);
	                else
	                    dest[i] = range;
	                if (p.fmtString) {
	                    range.linked = true;
	                    dest.hasLinkedRanges = true;
	                } else if (!dest.firstNonLinked)
	                    dest.firstNonLinked = range;
	            }
	            if (!dest.firstNonLinked)
	                dest.hasLinkedRanges = false;
	            if (dest === ts) {
	                arg.push(dest);
	                this.$openTabstops[index] = dest;
	            }
	            this.addTabstopMarkers(dest);
	        }, this);
	        
	        if (arg.length > 2) {
	            if (this.tabstops.length)
	                arg.push(arg.splice(2, 1)[0]);
	            this.tabstops.splice.apply(this.tabstops, arg);
	        }
	    };
	
	    this.addTabstopMarkers = function(ts) {
	        var session = this.editor.session;
	        ts.forEach(function(range) {
	            if  (!range.markerId)
	                range.markerId = session.addMarker(range, "ace_snippet-marker", "text");
	        });
	    };
	    this.removeTabstopMarkers = function(ts) {
	        var session = this.editor.session;
	        ts.forEach(function(range) {
	            session.removeMarker(range.markerId);
	            range.markerId = null;
	        });
	    };
	    this.removeRange = function(range) {
	        var i = range.tabstop.indexOf(range);
	        range.tabstop.splice(i, 1);
	        i = this.ranges.indexOf(range);
	        this.ranges.splice(i, 1);
	        this.editor.session.removeMarker(range.markerId);
	        if (!range.tabstop.length) {
	            i = this.tabstops.indexOf(range.tabstop);
	            if (i != -1)
	                this.tabstops.splice(i, 1);
	            if (!this.tabstops.length)
	                this.detach();
	        }
	    };
	
	    this.keyboardHandler = new HashHandler();
	    this.keyboardHandler.bindKeys({
	        "Tab": function(ed) {
	            if (exports.snippetManager && exports.snippetManager.expandWithTab(ed)) {
	                return;
	            }
	
	            ed.tabstopManager.tabNext(1);
	        },
	        "Shift-Tab": function(ed) {
	            ed.tabstopManager.tabNext(-1);
	        },
	        "Esc": function(ed) {
	            ed.tabstopManager.detach();
	        },
	        "Return": function(ed) {
	            return false;
	        }
	    });
	}).call(TabstopManager.prototype);
	
	
	
	var changeTracker = {};
	changeTracker.onChange = Anchor.prototype.onChange;
	changeTracker.setPosition = function(row, column) {
	    this.pos.row = row;
	    this.pos.column = column;
	};
	changeTracker.update = function(pos, delta, $insertRight) {
	    this.$insertRight = $insertRight;
	    this.pos = pos; 
	    this.onChange(delta);
	};
	
	var movePoint = function(point, diff) {
	    if (point.row == 0)
	        point.column += diff.column;
	    point.row += diff.row;
	};
	
	var moveRelative = function(point, start) {
	    if (point.row == start.row)
	        point.column -= start.column;
	    point.row -= start.row;
	};
	
	
	acequire("./lib/dom").importCssString("\
	.ace_snippet-marker {\
	    -moz-box-sizing: border-box;\
	    box-sizing: border-box;\
	    background: rgba(194, 193, 208, 0.09);\
	    border: 1px dotted rgba(211, 208, 235, 0.62);\
	    position: absolute;\
	}");
	
	exports.snippetManager = new SnippetManager();
	
	
	var Editor = acequire("./editor").Editor;
	(function() {
	    this.insertSnippet = function(content, options) {
	        return exports.snippetManager.insertSnippet(this, content, options);
	    };
	    this.expandSnippet = function(options) {
	        return exports.snippetManager.expandWithTab(this, options);
	    };
	}).call(Editor.prototype);
	
	});
	
	ace.define("ace/autocomplete/popup",["require","exports","module","ace/virtual_renderer","ace/editor","ace/range","ace/lib/event","ace/lib/lang","ace/lib/dom"], function(acequire, exports, module) {
	"use strict";
	
	var Renderer = acequire("../virtual_renderer").VirtualRenderer;
	var Editor = acequire("../editor").Editor;
	var Range = acequire("../range").Range;
	var event = acequire("../lib/event");
	var lang = acequire("../lib/lang");
	var dom = acequire("../lib/dom");
	
	var $singleLineEditor = function(el) {
	    var renderer = new Renderer(el);
	
	    renderer.$maxLines = 4;
	
	    var editor = new Editor(renderer);
	
	    editor.setHighlightActiveLine(false);
	    editor.setShowPrintMargin(false);
	    editor.renderer.setShowGutter(false);
	    editor.renderer.setHighlightGutterLine(false);
	
	    editor.$mouseHandler.$focusWaitTimout = 0;
	    editor.$highlightTagPending = true;
	
	    return editor;
	};
	
	var AcePopup = function(parentNode) {
	    var el = dom.createElement("div");
	    var popup = new $singleLineEditor(el);
	
	    if (parentNode)
	        parentNode.appendChild(el);
	    el.style.display = "none";
	    popup.renderer.content.style.cursor = "default";
	    popup.renderer.setStyle("ace_autocomplete");
	
	    popup.setOption("displayIndentGuides", false);
	    popup.setOption("dragDelay", 150);
	
	    var noop = function(){};
	
	    popup.focus = noop;
	    popup.$isFocused = true;
	
	    popup.renderer.$cursorLayer.restartTimer = noop;
	    popup.renderer.$cursorLayer.element.style.opacity = 0;
	
	    popup.renderer.$maxLines = 8;
	    popup.renderer.$keepTextAreaAtCursor = false;
	
	    popup.setHighlightActiveLine(false);
	    popup.session.highlight("");
	    popup.session.$searchHighlight.clazz = "ace_highlight-marker";
	
	    popup.on("mousedown", function(e) {
	        var pos = e.getDocumentPosition();
	        popup.selection.moveToPosition(pos);
	        selectionMarker.start.row = selectionMarker.end.row = pos.row;
	        e.stop();
	    });
	
	    var lastMouseEvent;
	    var hoverMarker = new Range(-1,0,-1,Infinity);
	    var selectionMarker = new Range(-1,0,-1,Infinity);
	    selectionMarker.id = popup.session.addMarker(selectionMarker, "ace_active-line", "fullLine");
	    popup.setSelectOnHover = function(val) {
	        if (!val) {
	            hoverMarker.id = popup.session.addMarker(hoverMarker, "ace_line-hover", "fullLine");
	        } else if (hoverMarker.id) {
	            popup.session.removeMarker(hoverMarker.id);
	            hoverMarker.id = null;
	        }
	    };
	    popup.setSelectOnHover(false);
	    popup.on("mousemove", function(e) {
	        if (!lastMouseEvent) {
	            lastMouseEvent = e;
	            return;
	        }
	        if (lastMouseEvent.x == e.x && lastMouseEvent.y == e.y) {
	            return;
	        }
	        lastMouseEvent = e;
	        lastMouseEvent.scrollTop = popup.renderer.scrollTop;
	        var row = lastMouseEvent.getDocumentPosition().row;
	        if (hoverMarker.start.row != row) {
	            if (!hoverMarker.id)
	                popup.setRow(row);
	            setHoverMarker(row);
	        }
	    });
	    popup.renderer.on("beforeRender", function() {
	        if (lastMouseEvent && hoverMarker.start.row != -1) {
	            lastMouseEvent.$pos = null;
	            var row = lastMouseEvent.getDocumentPosition().row;
	            if (!hoverMarker.id)
	                popup.setRow(row);
	            setHoverMarker(row, true);
	        }
	    });
	    popup.renderer.on("afterRender", function() {
	        var row = popup.getRow();
	        var t = popup.renderer.$textLayer;
	        var selected = t.element.childNodes[row - t.config.firstRow];
	        if (selected == t.selectedNode)
	            return;
	        if (t.selectedNode)
	            dom.removeCssClass(t.selectedNode, "ace_selected");
	        t.selectedNode = selected;
	        if (selected)
	            dom.addCssClass(selected, "ace_selected");
	    });
	    var hideHoverMarker = function() { setHoverMarker(-1) };
	    var setHoverMarker = function(row, suppressRedraw) {
	        if (row !== hoverMarker.start.row) {
	            hoverMarker.start.row = hoverMarker.end.row = row;
	            if (!suppressRedraw)
	                popup.session._emit("changeBackMarker");
	            popup._emit("changeHoverMarker");
	        }
	    };
	    popup.getHoveredRow = function() {
	        return hoverMarker.start.row;
	    };
	
	    event.addListener(popup.container, "mouseout", hideHoverMarker);
	    popup.on("hide", hideHoverMarker);
	    popup.on("changeSelection", hideHoverMarker);
	
	    popup.session.doc.getLength = function() {
	        return popup.data.length;
	    };
	    popup.session.doc.getLine = function(i) {
	        var data = popup.data[i];
	        if (typeof data == "string")
	            return data;
	        return (data && data.value) || "";
	    };
	
	    var bgTokenizer = popup.session.bgTokenizer;
	    bgTokenizer.$tokenizeRow = function(row) {
	        var data = popup.data[row];
	        var tokens = [];
	        if (!data)
	            return tokens;
	        if (typeof data == "string")
	            data = {value: data};
	        if (!data.caption)
	            data.caption = data.value || data.name;
	
	        var last = -1;
	        var flag, c;
	        for (var i = 0; i < data.caption.length; i++) {
	            c = data.caption[i];
	            flag = data.matchMask & (1 << i) ? 1 : 0;
	            if (last !== flag) {
	                tokens.push({type: data.className || "" + ( flag ? "completion-highlight" : ""), value: c});
	                last = flag;
	            } else {
	                tokens[tokens.length - 1].value += c;
	            }
	        }
	
	        if (data.meta) {
	            var maxW = popup.renderer.$size.scrollerWidth / popup.renderer.layerConfig.characterWidth;
	            var metaData = data.meta;
	            if (metaData.length + data.caption.length > maxW - 2) {
	                metaData = metaData.substr(0, maxW - data.caption.length - 3) + "\u2026"
	            }
	            tokens.push({type: "rightAlignedText", value: metaData});
	        }
	        return tokens;
	    };
	    bgTokenizer.$updateOnChange = noop;
	    bgTokenizer.start = noop;
	
	    popup.session.$computeWidth = function() {
	        return this.screenWidth = 0;
	    };
	
	    popup.$blockScrolling = Infinity;
	    popup.isOpen = false;
	    popup.isTopdown = false;
	
	    popup.data = [];
	    popup.setData = function(list) {
	        popup.setValue(lang.stringRepeat("\n", list.length), -1);
	        popup.data = list || [];
	        popup.setRow(0);
	    };
	    popup.getData = function(row) {
	        return popup.data[row];
	    };
	
	    popup.getRow = function() {
	        return selectionMarker.start.row;
	    };
	    popup.setRow = function(line) {
	        line = Math.max(0, Math.min(this.data.length, line));
	        if (selectionMarker.start.row != line) {
	            popup.selection.clearSelection();
	            selectionMarker.start.row = selectionMarker.end.row = line || 0;
	            popup.session._emit("changeBackMarker");
	            popup.moveCursorTo(line || 0, 0);
	            if (popup.isOpen)
	                popup._signal("select");
	        }
	    };
	
	    popup.on("changeSelection", function() {
	        if (popup.isOpen)
	            popup.setRow(popup.selection.lead.row);
	        popup.renderer.scrollCursorIntoView();
	    });
	
	    popup.hide = function() {
	        this.container.style.display = "none";
	        this._signal("hide");
	        popup.isOpen = false;
	    };
	    popup.show = function(pos, lineHeight, topdownOnly) {
	        var el = this.container;
	        var screenHeight = window.innerHeight;
	        var screenWidth = window.innerWidth;
	        var renderer = this.renderer;
	        var maxH = renderer.$maxLines * lineHeight * 1.4;
	        var top = pos.top + this.$borderSize;
	        var allowTopdown = top > screenHeight / 2 && !topdownOnly;
	        if (allowTopdown && top + lineHeight + maxH > screenHeight) {
	            renderer.$maxPixelHeight = top - 2 * this.$borderSize;
	            el.style.top = "";
	            el.style.bottom = screenHeight - top + "px";
	            popup.isTopdown = false;
	        } else {
	            top += lineHeight;
	            renderer.$maxPixelHeight = screenHeight - top - 0.2 * lineHeight;
	            el.style.top = top + "px";
	            el.style.bottom = "";
	            popup.isTopdown = true;
	        }
	
	        el.style.display = "";
	        this.renderer.$textLayer.checkForSizeChanges();
	
	        var left = pos.left;
	        if (left + el.offsetWidth > screenWidth)
	            left = screenWidth - el.offsetWidth;
	
	        el.style.left = left + "px";
	
	        this._signal("show");
	        lastMouseEvent = null;
	        popup.isOpen = true;
	    };
	
	    popup.getTextLeftOffset = function() {
	        return this.$borderSize + this.renderer.$padding + this.$imageSize;
	    };
	
	    popup.$imageSize = 0;
	    popup.$borderSize = 1;
	
	    return popup;
	};
	
	dom.importCssString("\
	.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\
	    background-color: #CAD6FA;\
	    z-index: 1;\
	}\
	.ace_editor.ace_autocomplete .ace_line-hover {\
	    border: 1px solid #abbffe;\
	    margin-top: -1px;\
	    background: rgba(233,233,253,0.4);\
	}\
	.ace_editor.ace_autocomplete .ace_line-hover {\
	    position: absolute;\
	    z-index: 2;\
	}\
	.ace_editor.ace_autocomplete .ace_scroller {\
	   background: none;\
	   border: none;\
	   box-shadow: none;\
	}\
	.ace_rightAlignedText {\
	    color: gray;\
	    display: inline-block;\
	    position: absolute;\
	    right: 4px;\
	    text-align: right;\
	    z-index: -1;\
	}\
	.ace_editor.ace_autocomplete .ace_completion-highlight{\
	    color: #000;\
	    text-shadow: 0 0 0.01em;\
	}\
	.ace_editor.ace_autocomplete {\
	    width: 280px;\
	    z-index: 200000;\
	    background: #fbfbfb;\
	    color: #444;\
	    border: 1px lightgray solid;\
	    position: fixed;\
	    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\
	    line-height: 1.4;\
	}");
	
	exports.AcePopup = AcePopup;
	
	});
	
	ace.define("ace/autocomplete/util",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	exports.parForEach = function(array, fn, callback) {
	    var completed = 0;
	    var arLength = array.length;
	    if (arLength === 0)
	        callback();
	    for (var i = 0; i < arLength; i++) {
	        fn(array[i], function(result, err) {
	            completed++;
	            if (completed === arLength)
	                callback(result, err);
	        });
	    }
	};
	
	var ID_REGEX = /[a-zA-Z_0-9\$\-\u00A2-\uFFFF]/;
	
	exports.retrievePrecedingIdentifier = function(text, pos, regex) {
	    regex = regex || ID_REGEX;
	    var buf = [];
	    for (var i = pos-1; i >= 0; i--) {
	        if (regex.test(text[i]))
	            buf.push(text[i]);
	        else
	            break;
	    }
	    return buf.reverse().join("");
	};
	
	exports.retrieveFollowingIdentifier = function(text, pos, regex) {
	    regex = regex || ID_REGEX;
	    var buf = [];
	    for (var i = pos; i < text.length; i++) {
	        if (regex.test(text[i]))
	            buf.push(text[i]);
	        else
	            break;
	    }
	    return buf;
	};
	
	exports.getCompletionPrefix = function (editor) {
	    var pos = editor.getCursorPosition();
	    var line = editor.session.getLine(pos.row);
	    var prefix;
	    editor.completers.forEach(function(completer) {
	        if (completer.identifierRegexps) {
	            completer.identifierRegexps.forEach(function(identifierRegex) {
	                if (!prefix && identifierRegex)
	                    prefix = this.retrievePrecedingIdentifier(line, pos.column, identifierRegex);
	            }.bind(this));
	        }
	    }.bind(this));
	    return prefix || this.retrievePrecedingIdentifier(line, pos.column);
	};
	
	});
	
	ace.define("ace/autocomplete",["require","exports","module","ace/keyboard/hash_handler","ace/autocomplete/popup","ace/autocomplete/util","ace/lib/event","ace/lib/lang","ace/lib/dom","ace/snippets"], function(acequire, exports, module) {
	"use strict";
	
	var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
	var AcePopup = acequire("./autocomplete/popup").AcePopup;
	var util = acequire("./autocomplete/util");
	var event = acequire("./lib/event");
	var lang = acequire("./lib/lang");
	var dom = acequire("./lib/dom");
	var snippetManager = acequire("./snippets").snippetManager;
	
	var Autocomplete = function() {
	    this.autoInsert = false;
	    this.autoSelect = true;
	    this.exactMatch = false;
	    this.gatherCompletionsId = 0;
	    this.keyboardHandler = new HashHandler();
	    this.keyboardHandler.bindKeys(this.commands);
	
	    this.blurListener = this.blurListener.bind(this);
	    this.changeListener = this.changeListener.bind(this);
	    this.mousedownListener = this.mousedownListener.bind(this);
	    this.mousewheelListener = this.mousewheelListener.bind(this);
	
	    this.changeTimer = lang.delayedCall(function() {
	        this.updateCompletions(true);
	    }.bind(this));
	
	    this.tooltipTimer = lang.delayedCall(this.updateDocTooltip.bind(this), 50);
	};
	
	(function() {
	
	    this.$init = function() {
	        this.popup = new AcePopup(document.body || document.documentElement);
	        this.popup.on("click", function(e) {
	            this.insertMatch();
	            e.stop();
	        }.bind(this));
	        this.popup.focus = this.editor.focus.bind(this.editor);
	        this.popup.on("show", this.tooltipTimer.bind(null, null));
	        this.popup.on("select", this.tooltipTimer.bind(null, null));
	        this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null));
	        return this.popup;
	    };
	
	    this.getPopup = function() {
	        return this.popup || this.$init();
	    };
	
	    this.openPopup = function(editor, prefix, keepPopupPosition) {
	        if (!this.popup)
	            this.$init();
	
	        this.popup.setData(this.completions.filtered);
	
	        editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
	        
	        var renderer = editor.renderer;
	        this.popup.setRow(this.autoSelect ? 0 : -1);
	        if (!keepPopupPosition) {
	            this.popup.setTheme(editor.getTheme());
	            this.popup.setFontSize(editor.getFontSize());
	
	            var lineHeight = renderer.layerConfig.lineHeight;
	
	            var pos = renderer.$cursorLayer.getPixelPosition(this.base, true);
	            pos.left -= this.popup.getTextLeftOffset();
	
	            var rect = editor.container.getBoundingClientRect();
	            pos.top += rect.top - renderer.layerConfig.offset;
	            pos.left += rect.left - editor.renderer.scrollLeft;
	            pos.left += renderer.gutterWidth;
	
	            this.popup.show(pos, lineHeight);
	        } else if (keepPopupPosition && !prefix) {
	            this.detach();
	        }
	    };
	
	    this.detach = function() {
	        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
	        this.editor.off("changeSelection", this.changeListener);
	        this.editor.off("blur", this.blurListener);
	        this.editor.off("mousedown", this.mousedownListener);
	        this.editor.off("mousewheel", this.mousewheelListener);
	        this.changeTimer.cancel();
	        this.hideDocTooltip();
	
	        this.gatherCompletionsId += 1;
	        if (this.popup && this.popup.isOpen)
	            this.popup.hide();
	
	        if (this.base)
	            this.base.detach();
	        this.activated = false;
	        this.completions = this.base = null;
	    };
	
	    this.changeListener = function(e) {
	        var cursor = this.editor.selection.lead;
	        if (cursor.row != this.base.row || cursor.column < this.base.column) {
	            this.detach();
	        }
	        if (this.activated)
	            this.changeTimer.schedule();
	        else
	            this.detach();
	    };
	
	    this.blurListener = function(e) {
	        if (e.relatedTarget && e.relatedTarget.nodeName == "A" && e.relatedTarget.href) {
	            window.open(e.relatedTarget.href, "_blank");
	        }
	        var el = document.activeElement;
	        var text = this.editor.textInput.getElement();
	        var fromTooltip = e.relatedTarget && e.relatedTarget == this.tooltipNode;
	        var container = this.popup && this.popup.container;
	        if (el != text && el.parentNode != container && !fromTooltip
	            && el != this.tooltipNode && e.relatedTarget != text
	        ) {
	            this.detach();
	        }
	    };
	
	    this.mousedownListener = function(e) {
	        this.detach();
	    };
	
	    this.mousewheelListener = function(e) {
	        this.detach();
	    };
	
	    this.goTo = function(where) {
	        var row = this.popup.getRow();
	        var max = this.popup.session.getLength() - 1;
	
	        switch(where) {
	            case "up": row = row <= 0 ? max : row - 1; break;
	            case "down": row = row >= max ? -1 : row + 1; break;
	            case "start": row = 0; break;
	            case "end": row = max; break;
	        }
	
	        this.popup.setRow(row);
	    };
	
	    this.insertMatch = function(data, options) {
	        if (!data)
	            data = this.popup.getData(this.popup.getRow());
	        if (!data)
	            return false;
	
	        if (data.completer && data.completer.insertMatch) {
	            data.completer.insertMatch(this.editor, data);
	        } else {
	            if (this.completions.filterText) {
	                var ranges = this.editor.selection.getAllRanges();
	                for (var i = 0, range; range = ranges[i]; i++) {
	                    range.start.column -= this.completions.filterText.length;
	                    this.editor.session.remove(range);
	                }
	            }
	            if (data.snippet)
	                snippetManager.insertSnippet(this.editor, data.snippet);
	            else
	                this.editor.execCommand("insertstring", data.value || data);
	        }
	        this.detach();
	    };
	
	
	    this.commands = {
	        "Up": function(editor) { editor.completer.goTo("up"); },
	        "Down": function(editor) { editor.completer.goTo("down"); },
	        "Ctrl-Up|Ctrl-Home": function(editor) { editor.completer.goTo("start"); },
	        "Ctrl-Down|Ctrl-End": function(editor) { editor.completer.goTo("end"); },
	
	        "Esc": function(editor) { editor.completer.detach(); },
	        "Return": function(editor) { return editor.completer.insertMatch(); },
	        "Shift-Return": function(editor) { editor.completer.insertMatch(null, {deleteSuffix: true}); },
	        "Tab": function(editor) {
	            var result = editor.completer.insertMatch();
	            if (!result && !editor.tabstopManager)
	                editor.completer.goTo("down");
	            else
	                return result;
	        },
	
	        "PageUp": function(editor) { editor.completer.popup.gotoPageUp(); },
	        "PageDown": function(editor) { editor.completer.popup.gotoPageDown(); }
	    };
	
	    this.gatherCompletions = function(editor, callback) {
	        var session = editor.getSession();
	        var pos = editor.getCursorPosition();
	
	        var line = session.getLine(pos.row);
	        var prefix = util.getCompletionPrefix(editor);
	
	        this.base = session.doc.createAnchor(pos.row, pos.column - prefix.length);
	        this.base.$insertRight = true;
	
	        var matches = [];
	        var total = editor.completers.length;
	        editor.completers.forEach(function(completer, i) {
	            completer.getCompletions(editor, session, pos, prefix, function(err, results) {
	                if (!err && results)
	                    matches = matches.concat(results);
	                var pos = editor.getCursorPosition();
	                var line = session.getLine(pos.row);
	                callback(null, {
	                    prefix: prefix,
	                    matches: matches,
	                    finished: (--total === 0)
	                });
	            });
	        });
	        return true;
	    };
	
	    this.showPopup = function(editor) {
	        if (this.editor)
	            this.detach();
	
	        this.activated = true;
	
	        this.editor = editor;
	        if (editor.completer != this) {
	            if (editor.completer)
	                editor.completer.detach();
	            editor.completer = this;
	        }
	
	        editor.on("changeSelection", this.changeListener);
	        editor.on("blur", this.blurListener);
	        editor.on("mousedown", this.mousedownListener);
	        editor.on("mousewheel", this.mousewheelListener);
	
	        this.updateCompletions();
	    };
	
	    this.updateCompletions = function(keepPopupPosition) {
	        if (keepPopupPosition && this.base && this.completions) {
	            var pos = this.editor.getCursorPosition();
	            var prefix = this.editor.session.getTextRange({start: this.base, end: pos});
	            if (prefix == this.completions.filterText)
	                return;
	            this.completions.setFilter(prefix);
	            if (!this.completions.filtered.length)
	                return this.detach();
	            if (this.completions.filtered.length == 1
	            && this.completions.filtered[0].value == prefix
	            && !this.completions.filtered[0].snippet)
	                return this.detach();
	            this.openPopup(this.editor, prefix, keepPopupPosition);
	            return;
	        }
	        var _id = this.gatherCompletionsId;
	        this.gatherCompletions(this.editor, function(err, results) {
	            var detachIfFinished = function() {
	                if (!results.finished) return;
	                return this.detach();
	            }.bind(this);
	
	            var prefix = results.prefix;
	            var matches = results && results.matches;
	
	            if (!matches || !matches.length)
	                return detachIfFinished();
	            if (prefix.indexOf(results.prefix) !== 0 || _id != this.gatherCompletionsId)
	                return;
	
	            this.completions = new FilteredList(matches);
	
	            if (this.exactMatch)
	                this.completions.exactMatch = true;
	
	            this.completions.setFilter(prefix);
	            var filtered = this.completions.filtered;
	            if (!filtered.length)
	                return detachIfFinished();
	            if (filtered.length == 1 && filtered[0].value == prefix && !filtered[0].snippet)
	                return detachIfFinished();
	            if (this.autoInsert && filtered.length == 1 && results.finished)
	                return this.insertMatch(filtered[0]);
	
	            this.openPopup(this.editor, prefix, keepPopupPosition);
	        }.bind(this));
	    };
	
	    this.cancelContextMenu = function() {
	        this.editor.$mouseHandler.cancelContextMenu();
	    };
	
	    this.updateDocTooltip = function() {
	        var popup = this.popup;
	        var all = popup.data;
	        var selected = all && (all[popup.getHoveredRow()] || all[popup.getRow()]);
	        var doc = null;
	        if (!selected || !this.editor || !this.popup.isOpen)
	            return this.hideDocTooltip();
	        this.editor.completers.some(function(completer) {
	            if (completer.getDocTooltip)
	                doc = completer.getDocTooltip(selected);
	            return doc;
	        });
	        if (!doc)
	            doc = selected;
	
	        if (typeof doc == "string")
	            doc = {docText: doc};
	        if (!doc || !(doc.docHTML || doc.docText))
	            return this.hideDocTooltip();
	        this.showDocTooltip(doc);
	    };
	
	    this.showDocTooltip = function(item) {
	        if (!this.tooltipNode) {
	            this.tooltipNode = dom.createElement("div");
	            this.tooltipNode.className = "ace_tooltip ace_doc-tooltip";
	            this.tooltipNode.style.margin = 0;
	            this.tooltipNode.style.pointerEvents = "auto";
	            this.tooltipNode.tabIndex = -1;
	            this.tooltipNode.onblur = this.blurListener.bind(this);
	        }
	
	        var tooltipNode = this.tooltipNode;
	        if (item.docHTML) {
	            tooltipNode.innerHTML = item.docHTML;
	        } else if (item.docText) {
	            tooltipNode.textContent = item.docText;
	        }
	
	        if (!tooltipNode.parentNode)
	            document.body.appendChild(tooltipNode);
	        var popup = this.popup;
	        var rect = popup.container.getBoundingClientRect();
	        tooltipNode.style.top = popup.container.style.top;
	        tooltipNode.style.bottom = popup.container.style.bottom;
	
	        if (window.innerWidth - rect.right < 320) {
	            tooltipNode.style.right = window.innerWidth - rect.left + "px";
	            tooltipNode.style.left = "";
	        } else {
	            tooltipNode.style.left = (rect.right + 1) + "px";
	            tooltipNode.style.right = "";
	        }
	        tooltipNode.style.display = "block";
	    };
	
	    this.hideDocTooltip = function() {
	        this.tooltipTimer.cancel();
	        if (!this.tooltipNode) return;
	        var el = this.tooltipNode;
	        if (!this.editor.isFocused() && document.activeElement == el)
	            this.editor.focus();
	        this.tooltipNode = null;
	        if (el.parentNode)
	            el.parentNode.removeChild(el);
	    };
	
	}).call(Autocomplete.prototype);
	
	Autocomplete.startCommand = {
	    name: "startAutocomplete",
	    exec: function(editor) {
	        if (!editor.completer)
	            editor.completer = new Autocomplete();
	        editor.completer.autoInsert = false;
	        editor.completer.autoSelect = true;
	        editor.completer.showPopup(editor);
	        editor.completer.cancelContextMenu();
	    },
	    bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
	};
	
	var FilteredList = function(array, filterText) {
	    this.all = array;
	    this.filtered = array;
	    this.filterText = filterText || "";
	    this.exactMatch = false;
	};
	(function(){
	    this.setFilter = function(str) {
	        if (str.length > this.filterText && str.lastIndexOf(this.filterText, 0) === 0)
	            var matches = this.filtered;
	        else
	            var matches = this.all;
	
	        this.filterText = str;
	        matches = this.filterCompletions(matches, this.filterText);
	        matches = matches.sort(function(a, b) {
	            return b.exactMatch - a.exactMatch || b.score - a.score;
	        });
	        var prev = null;
	        matches = matches.filter(function(item){
	            var caption = item.snippet || item.caption || item.value;
	            if (caption === prev) return false;
	            prev = caption;
	            return true;
	        });
	
	        this.filtered = matches;
	    };
	    this.filterCompletions = function(items, needle) {
	        var results = [];
	        var upper = needle.toUpperCase();
	        var lower = needle.toLowerCase();
	        loop: for (var i = 0, item; item = items[i]; i++) {
	            var caption = item.value || item.caption || item.snippet;
	            if (!caption) continue;
	            var lastIndex = -1;
	            var matchMask = 0;
	            var penalty = 0;
	            var index, distance;
	
	            if (this.exactMatch) {
	                if (needle !== caption.substr(0, needle.length))
	                    continue loop;
	            }else{
	                for (var j = 0; j < needle.length; j++) {
	                    var i1 = caption.indexOf(lower[j], lastIndex + 1);
	                    var i2 = caption.indexOf(upper[j], lastIndex + 1);
	                    index = (i1 >= 0) ? ((i2 < 0 || i1 < i2) ? i1 : i2) : i2;
	                    if (index < 0)
	                        continue loop;
	                    distance = index - lastIndex - 1;
	                    if (distance > 0) {
	                        if (lastIndex === -1)
	                            penalty += 10;
	                        penalty += distance;
	                    }
	                    matchMask = matchMask | (1 << index);
	                    lastIndex = index;
	                }
	            }
	            item.matchMask = matchMask;
	            item.exactMatch = penalty ? 0 : 1;
	            item.score = (item.score || 0) - penalty;
	            results.push(item);
	        }
	        return results;
	    };
	}).call(FilteredList.prototype);
	
	exports.Autocomplete = Autocomplete;
	exports.FilteredList = FilteredList;
	
	});
	
	ace.define("ace/autocomplete/text_completer",["require","exports","module","ace/range"], function(acequire, exports, module) {
	    var Range = acequire("../range").Range;
	    
	    var splitRegex = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;
	
	    function getWordIndex(doc, pos) {
	        var textBefore = doc.getTextRange(Range.fromPoints({row: 0, column:0}, pos));
	        return textBefore.split(splitRegex).length - 1;
	    }
	    function wordDistance(doc, pos) {
	        var prefixPos = getWordIndex(doc, pos);
	        var words = doc.getValue().split(splitRegex);
	        var wordScores = Object.create(null);
	        
	        var currentWord = words[prefixPos];
	
	        words.forEach(function(word, idx) {
	            if (!word || word === currentWord) return;
	
	            var distance = Math.abs(prefixPos - idx);
	            var score = words.length - distance;
	            if (wordScores[word]) {
	                wordScores[word] = Math.max(score, wordScores[word]);
	            } else {
	                wordScores[word] = score;
	            }
	        });
	        return wordScores;
	    }
	
	    exports.getCompletions = function(editor, session, pos, prefix, callback) {
	        var wordScore = wordDistance(session, pos, prefix);
	        var wordList = Object.keys(wordScore);
	        callback(null, wordList.map(function(word) {
	            return {
	                caption: word,
	                value: word,
	                score: wordScore[word],
	                meta: "local"
	            };
	        }));
	    };
	});
	
	ace.define("ace/ext/language_tools",["require","exports","module","ace/snippets","ace/autocomplete","ace/config","ace/lib/lang","ace/autocomplete/util","ace/autocomplete/text_completer","ace/editor","ace/config"], function(acequire, exports, module) {
	"use strict";
	
	var snippetManager = acequire("../snippets").snippetManager;
	var Autocomplete = acequire("../autocomplete").Autocomplete;
	var config = acequire("../config");
	var lang = acequire("../lib/lang");
	var util = acequire("../autocomplete/util");
	
	var textCompleter = acequire("../autocomplete/text_completer");
	var keyWordCompleter = {
	    getCompletions: function(editor, session, pos, prefix, callback) {
	        if (session.$mode.completer) {
	            return session.$mode.completer.getCompletions(editor, session, pos, prefix, callback);
	        }
	        var state = editor.session.getState(pos.row);
	        var completions = session.$mode.getCompletions(state, session, pos, prefix);
	        callback(null, completions);
	    }
	};
	
	var snippetCompleter = {
	    getCompletions: function(editor, session, pos, prefix, callback) {
	        var snippetMap = snippetManager.snippetMap;
	        var completions = [];
	        snippetManager.getActiveScopes(editor).forEach(function(scope) {
	            var snippets = snippetMap[scope] || [];
	            for (var i = snippets.length; i--;) {
	                var s = snippets[i];
	                var caption = s.name || s.tabTrigger;
	                if (!caption)
	                    continue;
	                completions.push({
	                    caption: caption,
	                    snippet: s.content,
	                    meta: s.tabTrigger && !s.name ? s.tabTrigger + "\u21E5 " : "snippet",
	                    type: "snippet"
	                });
	            }
	        }, this);
	        callback(null, completions);
	    },
	    getDocTooltip: function(item) {
	        if (item.type == "snippet" && !item.docHTML) {
	            item.docHTML = [
	                "<b>", lang.escapeHTML(item.caption), "</b>", "<hr></hr>",
	                lang.escapeHTML(item.snippet)
	            ].join("");
	        }
	    }
	};
	
	var completers = [snippetCompleter, textCompleter, keyWordCompleter];
	exports.setCompleters = function(val) {
	    completers.length = 0;
	    if (val) completers.push.apply(completers, val);
	};
	exports.addCompleter = function(completer) {
	    completers.push(completer);
	};
	exports.textCompleter = textCompleter;
	exports.keyWordCompleter = keyWordCompleter;
	exports.snippetCompleter = snippetCompleter;
	
	var expandSnippet = {
	    name: "expandSnippet",
	    exec: function(editor) {
	        return snippetManager.expandWithTab(editor);
	    },
	    bindKey: "Tab"
	};
	
	var onChangeMode = function(e, editor) {
	    loadSnippetsForMode(editor.session.$mode);
	};
	
	var loadSnippetsForMode = function(mode) {
	    var id = mode.$id;
	    if (!snippetManager.files)
	        snippetManager.files = {};
	    loadSnippetFile(id);
	    if (mode.modes)
	        mode.modes.forEach(loadSnippetsForMode);
	};
	
	var loadSnippetFile = function(id) {
	    if (!id || snippetManager.files[id])
	        return;
	    var snippetFilePath = id.replace("mode", "snippets");
	    snippetManager.files[id] = {};
	    config.loadModule(snippetFilePath, function(m) {
	        if (m) {
	            snippetManager.files[id] = m;
	            if (!m.snippets && m.snippetText)
	                m.snippets = snippetManager.parseSnippetFile(m.snippetText);
	            snippetManager.register(m.snippets || [], m.scope);
	            if (m.includeScopes) {
	                snippetManager.snippetMap[m.scope].includeScopes = m.includeScopes;
	                m.includeScopes.forEach(function(x) {
	                    loadSnippetFile("ace/mode/" + x);
	                });
	            }
	        }
	    });
	};
	
	var doLiveAutocomplete = function(e) {
	    var editor = e.editor;
	    var hasCompleter = editor.completer && editor.completer.activated;
	    if (e.command.name === "backspace") {
	        if (hasCompleter && !util.getCompletionPrefix(editor))
	            editor.completer.detach();
	    }
	    else if (e.command.name === "insertstring") {
	        var prefix = util.getCompletionPrefix(editor);
	        if (prefix && !hasCompleter) {
	            if (!editor.completer) {
	                editor.completer = new Autocomplete();
	            }
	            editor.completer.autoInsert = false;
	            editor.completer.showPopup(editor);
	        }
	    }
	};
	
	var Editor = acequire("../editor").Editor;
	acequire("../config").defineOptions(Editor.prototype, "editor", {
	    enableBasicAutocompletion: {
	        set: function(val) {
	            if (val) {
	                if (!this.completers)
	                    this.completers = Array.isArray(val)? val: completers;
	                this.commands.addCommand(Autocomplete.startCommand);
	            } else {
	                this.commands.removeCommand(Autocomplete.startCommand);
	            }
	        },
	        value: false
	    },
	    enableLiveAutocompletion: {
	        set: function(val) {
	            if (val) {
	                if (!this.completers)
	                    this.completers = Array.isArray(val)? val: completers;
	                this.commands.on('afterExec', doLiveAutocomplete);
	            } else {
	                this.commands.removeListener('afterExec', doLiveAutocomplete);
	            }
	        },
	        value: false
	    },
	    enableSnippets: {
	        set: function(val) {
	            if (val) {
	                this.commands.addCommand(expandSnippet);
	                this.on("changeMode", onChangeMode);
	                onChangeMode(null, this);
	            } else {
	                this.commands.removeCommand(expandSnippet);
	                this.off("changeMode", onChangeMode);
	            }
	        },
	        value: false
	    }
	});
	});
	                (function() {
	                    ace.acequire(["ace/ext/language_tools"], function() {});
	                })();
	            

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*jshint node:true */
	/* globals define */
	/*
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	
	*/
	
	'use strict';
	
	/**
	The following batches are equivalent:
	
	var beautify_js = require('js-beautify');
	var beautify_js = require('js-beautify').js;
	var beautify_js = require('js-beautify').js_beautify;
	
	var beautify_css = require('js-beautify').css;
	var beautify_css = require('js-beautify').css_beautify;
	
	var beautify_html = require('js-beautify').html;
	var beautify_html = require('js-beautify').html_beautify;
	
	All methods returned accept two arguments, the source string and an options object.
	**/
	
	function get_beautify(js_beautify, css_beautify, html_beautify) {
	  // the default is js
	  var beautify = function(src, config) {
	    return js_beautify.js_beautify(src, config);
	  };
	
	  // short aliases
	  beautify.js = js_beautify.js_beautify;
	  beautify.css = css_beautify.css_beautify;
	  beautify.html = html_beautify.html_beautify;
	
	  // legacy aliases
	  beautify.js_beautify = js_beautify.js_beautify;
	  beautify.css_beautify = css_beautify.css_beautify;
	  beautify.html_beautify = html_beautify.html_beautify;
	
	  return beautify;
	}
	
	if (true) {
	  // Add support for AMD ( https://github.com/amdjs/amdjs-api/wiki/AMD#defineamd-property- )
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(196),
	    __webpack_require__(195),
	    __webpack_require__(888)
	  ], __WEBPACK_AMD_DEFINE_RESULT__ = function(js_beautify, css_beautify, html_beautify) {
	    return get_beautify(js_beautify, css_beautify, html_beautify);
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	  (function(mod) {
	    var beautifier = require('./src/index');
	    beautifier.js_beautify = beautifier.js;
	    beautifier.css_beautify = beautifier.css;
	    beautifier.html_beautify = beautifier.html;
	
	    mod.exports = get_beautify(beautifier, beautifier, beautifier);
	
	  })(module);
	}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 36 */
[1741, 1721, 30],
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(183)('wks');
	var uid = __webpack_require__(126);
	var Symbol = __webpack_require__(63).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(1071);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _childUtils = __webpack_require__(111);
	
	var _events = __webpack_require__(145);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(224);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(376);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.props.onClick(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.refs.enhancedButton.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.focusTimeout);
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity
	        },
	        children
	      ) : undefined;
	
	      return (0, _childUtils.createChildFragment)({
	        focusRipple: focusRipple,
	        touchRipple: touchRipple,
	        children: touchRipple ? undefined : children
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onTouchTap = _props3.onTouchTap,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'onTouchTap', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null
	      }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: 'enhancedButton',
	        disabled: disabled,
	        href: href,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onTouchTap: this.handleTouchTap,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onTouchTap: function onTouchTap() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? EnhancedButton.propTypes = {
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  disableFocusRipple: _react.PropTypes.bool,
	  disableKeyboardFocus: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  focusRippleColor: _react.PropTypes.string,
	  focusRippleOpacity: _react.PropTypes.number,
	  href: _react.PropTypes.string,
	  keyboardFocused: _react.PropTypes.bool,
	  onBlur: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onKeyDown: _react.PropTypes.func,
	  onKeyUp: _react.PropTypes.func,
	  onKeyboardFocus: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  style: _react.PropTypes.object,
	  tabIndex: _react.PropTypes.number,
	  touchRippleColor: _react.PropTypes.string,
	  touchRippleOpacity: _react.PropTypes.number,
	  type: _react.PropTypes.string
	} : void 0;
	exports.default = EnhancedButton;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var horizontal = _react.PropTypes.oneOf(['left', 'middle', 'right']);
	var vertical = _react.PropTypes.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _react.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _react.PropTypes.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _react.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  zDepth: _react.PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(332);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(1036);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var CallbackQueue = __webpack_require__(541);
	var PooledClass = __webpack_require__(76);
	var ReactFeatureFlags = __webpack_require__(546);
	var ReactReconciler = __webpack_require__(95);
	var Transaction = __webpack_require__(156);
	
	var invariant = __webpack_require__(11);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(621);
	module.exports = angular;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSchemaForm = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	exports.default = function (ThingsboardBaseComponent) {
	    return function (_React$Component) {
	        _inherits(_class, _React$Component);
	
	        function _class(props) {
	            _classCallCheck(this, _class);
	
	            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	            _this.onChangeValidate = _this.onChangeValidate.bind(_this);
	            var value = _this.defaultValue();
	            var validationResult = _reactSchemaForm.utils.validate(_this.props.form, value);
	            _this.state = {
	                value: value,
	                valid: !!(validationResult.valid || !value),
	                error: !validationResult.valid && value ? validationResult.error.message : null
	            };
	            return _this;
	        }
	
	        _createClass(_class, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                if (typeof this.state.value !== 'undefined') {
	                    this.props.onChange(this.props.form.key, this.state.value);
	                }
	            }
	        }, {
	            key: 'onChangeValidate',
	            value: function onChangeValidate(e) {
	                var value = null;
	                if (this.props.form.schema.type === 'integer' || this.props.form.schema.type === 'number') {
	                    if (e.target.value === null || e.target.value === '') {
	                        value = undefined;
	                    } else if (e.target.value.indexOf('.') == -1) {
	                        value = parseInt(e.target.value);
	                    } else {
	                        value = parseFloat(e.target.value);
	                    }
	                } else if (this.props.form.schema.type === 'boolean') {
	                    value = e.target.checked;
	                } else if (this.props.form.schema.type === 'date' || this.props.form.schema.type === 'array') {
	                    value = e;
	                } else {
	                    // string
	                    value = e.target.value;
	                }
	                var validationResult = _reactSchemaForm.utils.validate(this.props.form, value);
	                this.setState({
	                    value: value,
	                    valid: validationResult.valid,
	                    error: validationResult.valid ? null : validationResult.error.message
	                });
	                this.props.onChange(this.props.form.key, value);
	            }
	        }, {
	            key: 'defaultValue',
	            value: function defaultValue() {
	                var value = _reactSchemaForm.utils.selectOrSet(this.props.form.key, this.props.model);
	                if (this.props.form.schema.type === 'boolean') {
	                    if (typeof value !== 'boolean' && this.props.form['default']) {
	                        value = this.props.form['default'];
	                    }
	                    if (typeof value !== 'boolean' && this.props.form.schema && this.props.form.schema['default']) {
	                        value = this.props.form.schema['default'];
	                    }
	                    if (typeof value !== 'boolean' && this.props.form.schema && this.props.form.required) {
	                        value = false;
	                    }
	                } else if (this.props.form.schema.type === 'integer' || this.props.form.schema.type === 'number') {
	                    if (typeof value !== 'number' && this.props.form['default']) {
	                        value = this.props.form['default'];
	                    }
	                    if (typeof value !== 'number' && this.props.form.schema && this.props.form.schema['default']) {
	                        value = this.props.form.schema['default'];
	                    }
	                    if (typeof value !== 'number' && this.props.form.titleMap && this.props.form.titleMap[0].value) {
	                        value = this.props.form.titleMap[0].value;
	                    }
	                    if (value && typeof value === 'string') {
	                        if (value.indexOf('.') == -1) {
	                            value = parseInt(value);
	                        } else {
	                            value = parseFloat(value);
	                        }
	                    }
	                } else {
	                    if (!value && this.props.form['default']) {
	                        value = this.props.form['default'];
	                    }
	                    if (!value && this.props.form.schema && this.props.form.schema['default']) {
	                        value = this.props.form.schema['default'];
	                    }
	                    if (!value && this.props.form.titleMap && this.props.form.titleMap[0].value) {
	                        value = this.props.form.titleMap[0].value;
	                    }
	                }
	                return value;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                if (this.props.form && this.props.form.schema) {
	                    return _react2.default.createElement(ThingsboardBaseComponent, _extends({}, this.props, this.state, { onChangeValidate: this.onChangeValidate }));
	                } else {
	                    return _react2.default.createElement('div', null);
	                }
	            }
	        }]);
	
	        return _class;
	    }(_react2.default.Component);
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(645);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(644);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	ace.define("ace/mode/json_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	
	var JsonHighlightRules = function() {
	    this.$rules = {
	        "start" : [
	            {
	                token : "variable", // single line
	                regex : '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'
	            }, {
	                token : "string", // single line
	                regex : '"',
	                next  : "string"
	            }, {
	                token : "constant.numeric", // hex
	                regex : "0[xX][0-9a-fA-F]+\\b"
	            }, {
	                token : "constant.numeric", // float
	                regex : "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
	            }, {
	                token : "constant.language.boolean",
	                regex : "(?:true|false)\\b"
	            }, {
	                token : "invalid.illegal", // single quoted strings are not allowed
	                regex : "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
	            }, {
	                token : "invalid.illegal", // comments are not allowed
	                regex : "\\/\\/.*$"
	            }, {
	                token : "paren.lparen",
	                regex : "[[({]"
	            }, {
	                token : "paren.rparen",
	                regex : "[\\])}]"
	            }, {
	                token : "text",
	                regex : "\\s+"
	            }
	        ],
	        "string" : [
	            {
	                token : "constant.language.escape",
	                regex : /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
	            }, {
	                token : "string",
	                regex : '[^"\\\\]+'
	            }, {
	                token : "string",
	                regex : '"',
	                next  : "start"
	            }, {
	                token : "string",
	                regex : "",
	                next  : "start"
	            }
	        ]
	    };
	    
	};
	
	oop.inherits(JsonHighlightRules, TextHighlightRules);
	
	exports.JsonHighlightRules = JsonHighlightRules;
	});
	
	ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	
	var MatchingBraceOutdent = function() {};
	
	(function() {
	
	    this.checkOutdent = function(line, input) {
	        if (! /^\s+$/.test(line))
	            return false;
	
	        return /^\s*\}/.test(input);
	    };
	
	    this.autoOutdent = function(doc, row) {
	        var line = doc.getLine(row);
	        var match = line.match(/^(\s*\})/);
	
	        if (!match) return 0;
	
	        var column = match[1].length;
	        var openBracePos = doc.findMatchingBracket({row: row, column: column});
	
	        if (!openBracePos || openBracePos.row == row) return 0;
	
	        var indent = this.$getIndent(doc.getLine(openBracePos.row));
	        doc.replace(new Range(row, 0, row, column-1), indent);
	    };
	
	    this.$getIndent = function(line) {
	        return line.match(/^\s*/)[0];
	    };
	
	}).call(MatchingBraceOutdent.prototype);
	
	exports.MatchingBraceOutdent = MatchingBraceOutdent;
	});
	
	ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Range = acequire("../../range").Range;
	var BaseFoldMode = acequire("./fold_mode").FoldMode;
	
	var FoldMode = exports.FoldMode = function(commentRegex) {
	    if (commentRegex) {
	        this.foldingStartMarker = new RegExp(
	            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
	        );
	        this.foldingStopMarker = new RegExp(
	            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
	        );
	    }
	};
	oop.inherits(FoldMode, BaseFoldMode);
	
	(function() {
	    
	    this.foldingStartMarker = /(\{|\[)[^\}\]]*$|^\s*(\/\*)/;
	    this.foldingStopMarker = /^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/;
	    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
	    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
	    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
	    this._getFoldWidgetBase = this.getFoldWidget;
	    this.getFoldWidget = function(session, foldStyle, row) {
	        var line = session.getLine(row);
	    
	        if (this.singleLineBlockCommentRe.test(line)) {
	            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
	                return "";
	        }
	    
	        var fw = this._getFoldWidgetBase(session, foldStyle, row);
	    
	        if (!fw && this.startRegionRe.test(line))
	            return "start"; // lineCommentRegionStart
	    
	        return fw;
	    };
	
	    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
	        var line = session.getLine(row);
	        
	        if (this.startRegionRe.test(line))
	            return this.getCommentRegionBlock(session, line, row);
	        
	        var match = line.match(this.foldingStartMarker);
	        if (match) {
	            var i = match.index;
	
	            if (match[1])
	                return this.openingBracketBlock(session, match[1], row, i);
	                
	            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
	            
	            if (range && !range.isMultiLine()) {
	                if (forceMultiline) {
	                    range = this.getSectionRange(session, row);
	                } else if (foldStyle != "all")
	                    range = null;
	            }
	            
	            return range;
	        }
	
	        if (foldStyle === "markbegin")
	            return;
	
	        var match = line.match(this.foldingStopMarker);
	        if (match) {
	            var i = match.index + match[0].length;
	
	            if (match[1])
	                return this.closingBracketBlock(session, match[1], row, i);
	
	            return session.getCommentFoldRange(row, i, -1);
	        }
	    };
	    
	    this.getSectionRange = function(session, row) {
	        var line = session.getLine(row);
	        var startIndent = line.search(/\S/);
	        var startRow = row;
	        var startColumn = line.length;
	        row = row + 1;
	        var endRow = row;
	        var maxRow = session.getLength();
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var indent = line.search(/\S/);
	            if (indent === -1)
	                continue;
	            if  (startIndent > indent)
	                break;
	            var subRange = this.getFoldWidgetRange(session, "all", row);
	            
	            if (subRange) {
	                if (subRange.start.row <= startRow) {
	                    break;
	                } else if (subRange.isMultiLine()) {
	                    row = subRange.end.row;
	                } else if (startIndent == indent) {
	                    break;
	                }
	            }
	            endRow = row;
	        }
	        
	        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
	    };
	    this.getCommentRegionBlock = function(session, line, row) {
	        var startColumn = line.search(/\s*$/);
	        var maxRow = session.getLength();
	        var startRow = row;
	        
	        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
	        var depth = 1;
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var m = re.exec(line);
	            if (!m) continue;
	            if (m[1]) depth--;
	            else depth++;
	
	            if (!depth) break;
	        }
	
	        var endRow = row;
	        if (endRow > startRow) {
	            return new Range(startRow, startColumn, endRow, line.length);
	        }
	    };
	
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/mode/json",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/json_highlight_rules","ace/mode/matching_brace_outdent","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle","ace/worker/worker_client"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextMode = acequire("./text").Mode;
	var HighlightRules = acequire("./json_highlight_rules").JsonHighlightRules;
	var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
	var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
	var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;
	var WorkerClient = acequire("../worker/worker_client").WorkerClient;
	
	var Mode = function() {
	    this.HighlightRules = HighlightRules;
	    this.$outdent = new MatchingBraceOutdent();
	    this.$behaviour = new CstyleBehaviour();
	    this.foldingRules = new CStyleFoldMode();
	};
	oop.inherits(Mode, TextMode);
	
	(function() {
	
	    this.getNextLineIndent = function(state, line, tab) {
	        var indent = this.$getIndent(line);
	
	        if (state == "start") {
	            var match = line.match(/^.*[\{\(\[]\s*$/);
	            if (match) {
	                indent += tab;
	            }
	        }
	
	        return indent;
	    };
	
	    this.checkOutdent = function(state, line, input) {
	        return this.$outdent.checkOutdent(line, input);
	    };
	
	    this.autoOutdent = function(state, doc, row) {
	        this.$outdent.autoOutdent(doc, row);
	    };
	
	    this.createWorker = function(session) {
	        var worker = new WorkerClient(["ace"], __webpack_require__(653), "JsonWorker");
	        worker.attachToDocument(session.getDocument());
	
	        worker.on("annotate", function(e) {
	            session.setAnnotations(e.data);
	        });
	
	        worker.on("terminate", function() {
	            session.clearAnnotations();
	        });
	
	        return worker;
	    };
	
	
	    this.$id = "ace/mode/json";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(76);
	
	var emptyFunction = __webpack_require__(38);
	var warning = __webpack_require__(16);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(50);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(166);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(272);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(105);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(1661);
	
	var supports = _interopRequireWildcard(_supports);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	/* eslint-disable prefer-spread */
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  if (supports.addEventListener) {
	    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	
	function off(target, eventName, callback, options) {
	  if (supports.removeEventListener) {
	    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);
	
	
	  (0, _keys2.default)(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_Component) {
	  (0, _inherits3.default)(EventListener, _Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react.Component);
	
	 false ? EventListener.propTypes = {
	  /**
	   * You can provide a single child too.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
	} : void 0;
	exports.default = EventListener;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //var React = require('react');
	
	
	var utils = __webpack_require__(77);
	
	var _default = function _default(ComposedComponent) {
	    return function (_React$Component) {
	        _inherits(_class, _React$Component);
	
	        function _class(props) {
	            _classCallCheck(this, _class);
	
	            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	            _this.onChangeValidate = _this.onChangeValidate.bind(_this);
	            var value = _this.defaultValue(_this.props);
	            var validationResult = utils.validate(_this.props.form, value);
	            _this.state = {
	                value: value,
	                valid: !!(validationResult.valid || !value),
	                error: !validationResult.valid && value ? validationResult.error.message : null
	            };
	            return _this;
	        }
	
	        _createClass(_class, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                var value = this.defaultValue(nextProps);
	                var validationResult = utils.validate(nextProps.form, value);
	                this.setState({
	                    value: value,
	                    valid: !!(validationResult.valid || !value),
	                    error: !validationResult.valid && value ? validationResult.error.message : null
	                });
	            }
	
	            /**
	             * Called when <input> value changes.
	             * @param e The input element, or something.
	             */
	
	        }, {
	            key: 'onChangeValidate',
	            value: function onChangeValidate(e) {
	                //console.log('onChangeValidate e', e);
	                var value = null;
	                switch (this.props.form.schema.type) {
	                    case 'integer':
	                    case 'number':
	                        if (e.target.value.indexOf('.') == -1) {
	                            value = parseInt(e.target.value);
	                        } else {
	                            value = parseFloat(e.target.value);
	                        }
	
	                        if (isNaN(value)) {
	                            value = undefined;
	                        }
	                        break;
	                    case 'boolean':
	                        value = e.target.checked;
	                        break;
	                    case 'object':
	                    case 'date':
	                    case 'array':
	                        value = e;
	                        break;
	                    default:
	                        value = e.target.value;
	                }
	                //console.log('onChangeValidate this.props.form, value', this.props.form, value);
	                var validationResult = utils.validate(this.props.form, value);
	                this.setState({
	                    value: value,
	                    valid: validationResult.valid,
	                    error: validationResult.valid ? null : validationResult.error.message
	                });
	                //console.log('conhangeValidate this.props.form.key, value', this.props.form.key, value);
	                this.props.onChange(this.props.form.key, value);
	            }
	        }, {
	            key: 'defaultValue',
	            value: function defaultValue(props) {
	                // check if there is a value in the model, if there is, display it. Otherwise, check if
	                // there is a default value, display it.
	                //console.log('Text.defaultValue key', this.props.form.key);
	                //console.log('Text.defaultValue model', this.props.model);
	                var value = utils.selectOrSet(props.form.key, props.model);
	                //console.log('Text defaultValue value = ', value);
	
	                // check if there is a default value
	                if (!value && props.form['default']) {
	                    value = props.form['default'];
	                }
	
	                if (!value && props.form.schema && props.form.schema['default']) {
	                    value = props.form.schema['default'];
	                }
	
	                // Support for Select
	                // The first value in the option will be the default.
	                if (!value && props.form.titleMap && props.form.titleMap[0].value) {
	                    value = props.form.titleMap[0].value;
	                }
	                //console.log('value', value);
	                return value;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(ComposedComponent, _extends({}, this.props, this.state, { onChangeValidate: this.onChangeValidate }));
	            }
	        }]);
	
	        return _class;
	    }(_react2.default.Component);
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/ComposedComponent.js');
	}();
	
	;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(165);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	ace.define("ace/theme/github",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
	
	exports.isDark = false;
	exports.cssClass = "ace-github";
	exports.cssText = "\
	.ace-github .ace_gutter {\
	background: #e8e8e8;\
	color: #AAA;\
	}\
	.ace-github  {\
	background: #fff;\
	color: #000;\
	}\
	.ace-github .ace_keyword {\
	font-weight: bold;\
	}\
	.ace-github .ace_string {\
	color: #D14;\
	}\
	.ace-github .ace_variable.ace_class {\
	color: teal;\
	}\
	.ace-github .ace_constant.ace_numeric {\
	color: #099;\
	}\
	.ace-github .ace_constant.ace_buildin {\
	color: #0086B3;\
	}\
	.ace-github .ace_support.ace_function {\
	color: #0086B3;\
	}\
	.ace-github .ace_comment {\
	color: #998;\
	font-style: italic;\
	}\
	.ace-github .ace_variable.ace_language  {\
	color: #0086B3;\
	}\
	.ace-github .ace_paren {\
	font-weight: bold;\
	}\
	.ace-github .ace_boolean {\
	font-weight: bold;\
	}\
	.ace-github .ace_string.ace_regexp {\
	color: #009926;\
	font-weight: normal;\
	}\
	.ace-github .ace_variable.ace_instance {\
	color: teal;\
	}\
	.ace-github .ace_constant.ace_language {\
	font-weight: bold;\
	}\
	.ace-github .ace_cursor {\
	color: black;\
	}\
	.ace-github.ace_focus .ace_marker-layer .ace_active-line {\
	background: rgb(255, 255, 204);\
	}\
	.ace-github .ace_marker-layer .ace_active-line {\
	background: rgb(245, 245, 245);\
	}\
	.ace-github .ace_marker-layer .ace_selection {\
	background: rgb(181, 213, 255);\
	}\
	.ace-github.ace_multiselect .ace_selection.ace_start {\
	box-shadow: 0 0 3px 0px white;\
	}\
	.ace-github.ace_nobold .ace_line > span {\
	font-weight: normal !important;\
	}\
	.ace-github .ace_marker-layer .ace_step {\
	background: rgb(252, 255, 0);\
	}\
	.ace-github .ace_marker-layer .ace_stack {\
	background: rgb(164, 229, 101);\
	}\
	.ace-github .ace_marker-layer .ace_bracket {\
	margin: -1px 0 0 -1px;\
	border: 1px solid rgb(192, 192, 192);\
	}\
	.ace-github .ace_gutter-active-line {\
	background-color : rgba(0, 0, 0, 0.07);\
	}\
	.ace-github .ace_marker-layer .ace_selected-word {\
	background: rgb(250, 250, 255);\
	border: 1px solid rgb(200, 200, 250);\
	}\
	.ace-github .ace_invisible {\
	color: #BFBFBF\
	}\
	.ace-github .ace_print-margin {\
	width: 1px;\
	background: #e8e8e8;\
	}\
	.ace-github .ace_indent-guide {\
	background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
	}";
	
	    var dom = acequire("../lib/dom");
	    dom.importCssString(exports.cssText, exports.cssClass);
	});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(63);
	var core = __webpack_require__(27);
	var ctx = __webpack_require__(176);
	var hide = __webpack_require__(82);
	var has = __webpack_require__(68);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(292);
	var toPrimitive = __webpack_require__(185);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(67) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(303);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(81)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _propertyUtils = __webpack_require__(726);
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	var getComputedStyleX = void 0;
	
	// https://stackoverflow.com/a/3485654/3040605
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	  elem.style.display = originalStyle;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box = void 0;
	  var x = void 0;
	  var y = void 0;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	  if (node.nodeType === 9) {
	    return node;
	  }
	  return node.ownerDocument;
	}
	
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = (0, _propertyUtils.getTransitionProperty)(elem) || '';
	    (0, _propertyUtils.setTransitionProperty)(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = presetH + 'px';
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = presetV + 'px';
	  }
	  // force relayout
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  forceRelayout(elem);
	  if ('left' in offset || 'top' in offset) {
	    (0, _propertyUtils.setTransitionProperty)(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	
	function setTransform(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = (0, _propertyUtils.getTransformXY)(elem);
	  var resultXY = { x: originalXY.x, y: originalXY.y };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  (0, _propertyUtils.setTransformXY)(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);
	
	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }
	
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && (0, _propertyUtils.getTransformName)() in document.body.style) {
	    setTransform(elem, offset, option);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = void 0;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = void 0;
	  var j = void 0;
	  var i = void 0;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = '' + prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val = void 0;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i = void 0;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      utils.mix(ret, args[i]);
	    }
	    return ret;
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);
	
	exports['default'] = utils;
	module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(106),
	    getRawTag = __webpack_require__(946),
	    objectToString = __webpack_require__(973);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(915),
	    getValue = __webpack_require__(947);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	GridCardContent.$inject = ["$compile", "$controller"];
	GridController.$inject = ["$scope", "$state", "$mdDialog", "$document", "$q", "$mdUtil", "$timeout", "$translate", "$mdMedia", "$templateCache", "$window", "userService"];
	AddItemController.$inject = ["$scope", "$mdDialog", "saveItemFunction", "helpLinks"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(756);
	
	var _scopeElement = __webpack_require__(1196);
	
	var _scopeElement2 = _interopRequireDefault(_scopeElement);
	
	var _detailsSidenav = __webpack_require__(509);
	
	var _detailsSidenav2 = _interopRequireDefault(_detailsSidenav);
	
	var _gridTpl = __webpack_require__(1399);
	
	var _gridTpl2 = _interopRequireDefault(_gridTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.grid', [_scopeElement2.default, _detailsSidenav2.default]).directive('tbGrid', Grid).controller('AddItemController', AddItemController).controller('ItemCardController', ItemCardController).directive('tbGridCardContent', GridCardContent).filter('range', RangeFilter).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function RangeFilter() {
	    return function (input, total) {
	        total = parseInt(total);
	
	        for (var i = 0; i < total; i++) {
	            input.push(i);
	        }
	
	        return input;
	    };
	}
	
	/*@ngInject*/
	function ItemCardController() {
	
	    var vm = this; //eslint-disable-line
	}
	
	/*@ngInject*/
	function GridCardContent($compile, $controller) {
	    var linker = function linker(scope, element) {
	
	        var controllerInstance = null;
	
	        scope.$watch('itemTemplate', function () {
	            initContent();
	        });
	        scope.$watch('itemController', function () {
	            initContent();
	        });
	        scope.$watch('parentCtl', function () {
	            controllerInstance.parentCtl = scope.parentCtl;
	        });
	        scope.$watch('item', function () {
	            controllerInstance.item = scope.item;
	        });
	
	        function initContent() {
	            if (scope.itemTemplate && scope.itemController && !controllerInstance) {
	                element.html(scope.itemTemplate);
	                var locals = {};
	                angular.extend(locals, { $scope: scope, $element: element });
	                var controller = $controller(scope.itemController, locals, true, 'vm');
	                controller.instance = controller();
	                controllerInstance = controller.instance;
	                controllerInstance.item = scope.item;
	                controllerInstance.parentCtl = scope.parentCtl;
	                $compile(element.contents())(scope);
	            }
	        }
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            parentCtl: "=parentCtl",
	            gridCtl: "=gridCtl",
	            itemTemplate: "=itemTemplate",
	            itemController: "=itemController",
	            item: "=item"
	        }
	    };
	}
	
	/*@ngInject*/
	function Grid() {
	    return {
	        restrict: "E",
	        scope: true,
	        transclude: {
	            detailsButtons: '?detailsButtons'
	        },
	        bindToController: {
	            gridConfiguration: '&?'
	        },
	        controller: GridController,
	        controllerAs: 'vm',
	        templateUrl: _gridTpl2.default
	    };
	}
	
	/*@ngInject*/
	function GridController($scope, $state, $mdDialog, $document, $q, $mdUtil, $timeout, $translate, $mdMedia, $templateCache, $window, userService) {
	
	    var vm = this;
	
	    var columns = 1;
	    if ($mdMedia('md')) {
	        columns = 2;
	    } else if ($mdMedia('lg')) {
	        columns = 3;
	    } else if ($mdMedia('gt-lg')) {
	        columns = 4;
	    }
	
	    var pageSize = 10 * columns;
	
	    vm.columns = columns;
	
	    vm.addItem = addItem;
	    vm.deleteItem = deleteItem;
	    vm.deleteItems = deleteItems;
	    vm.hasData = hasData;
	    vm.isCurrentItem = isCurrentItem;
	    vm.moveToTop = moveToTop;
	    vm.noData = noData;
	    vm.onCloseDetails = onCloseDetails;
	    vm.onToggleDetailsEditMode = onToggleDetailsEditMode;
	    vm.openItem = openItem;
	    vm.operatingItem = operatingItem;
	    vm.refreshList = refreshList;
	    vm.saveItem = saveItem;
	    vm.toggleItemSelection = toggleItemSelection;
	    vm.triggerResize = triggerResize;
	    vm.isTenantAdmin = isTenantAdmin;
	
	    $scope.$watch(function () {
	        return $mdMedia('xs') || $mdMedia('sm');
	    }, function (sm) {
	        if (sm) {
	            columnsUpdated(1);
	        }
	    });
	    $scope.$watch(function () {
	        return $mdMedia('md');
	    }, function (md) {
	        if (md) {
	            columnsUpdated(2);
	        }
	    });
	    $scope.$watch(function () {
	        return $mdMedia('lg');
	    }, function (lg) {
	        if (lg) {
	            columnsUpdated(3);
	        }
	    });
	    $scope.$watch(function () {
	        return $mdMedia('gt-lg');
	    }, function (gtLg) {
	        if (gtLg) {
	            columnsUpdated(4);
	        }
	    });
	
	    initGridConfiguration();
	
	    vm.itemRows = {
	        getItemAtIndex: function getItemAtIndex(index) {
	            if (index >= vm.items.rowData.length) {
	                vm.itemRows.fetchMoreItems_(index);
	                return null;
	            }
	            return vm.items.rowData[index];
	        },
	
	        getLength: function getLength() {
	            if (vm.items.hasNext && !vm.items.pending) {
	                return vm.items.rowData.length + pageSize;
	            } else {
	                return vm.items.rowData.length;
	            }
	        },
	
	        fetchMoreItems_: function fetchMoreItems_() {
	            if (vm.items.hasNext && !vm.items.pending) {
	                var promise = vm.fetchItemsFunc(vm.items.nextPageLink, $scope.searchConfig.searchEntitySubtype);
	                if (promise) {
	                    vm.items.pending = true;
	                    promise.then(function success(items) {
	                        if (vm.items.reloadPending) {
	                            vm.items.pending = false;
	                            reload();
	                        } else {
	                            vm.items.data = vm.items.data.concat(items.data);
	                            var startIndex = vm.items.data.length - items.data.length;
	                            var endIndex = vm.items.data.length;
	                            for (var i = startIndex; i < endIndex; i++) {
	                                var item = vm.items.data[i];
	                                item.index = i;
	                                var row = Math.floor(i / vm.columns);
	                                var itemRow = vm.items.rowData[row];
	                                if (!itemRow) {
	                                    itemRow = [];
	                                    vm.items.rowData.push(itemRow);
	                                }
	                                itemRow.push(item);
	                            }
	                            vm.items.nextPageLink = items.nextPageLink;
	                            vm.items.hasNext = items.hasNext;
	                            if (vm.items.hasNext) {
	                                vm.items.nextPageLink.limit = pageSize;
	                            }
	                            vm.items.pending = false;
	                            if (vm.items.loadCallback) {
	                                vm.items.loadCallback();
	                                vm.items.loadCallback = null;
	                            }
	                        }
	                    }, function fail() {
	                        vm.items.hasNext = false;
	                        vm.items.pending = false;
	                    });
	                } else {
	                    vm.items.hasNext = false;
	                }
	            }
	        }
	    };
	
	    function columnsUpdated(newColumns) {
	        if (vm.columns !== newColumns) {
	            var newTopIndex = Math.ceil(vm.columns * vm.topIndex / newColumns);
	            pageSize = 10 * newColumns;
	            vm.items.rowData = [];
	            if (vm.items.nextPageLink) {
	                vm.items.nextPageLink.limit = pageSize;
	            }
	
	            for (var i = 0; i < vm.items.data.length; i++) {
	                var item = vm.items.data[i];
	                var row = Math.floor(i / newColumns);
	                var itemRow = vm.items.rowData[row];
	                if (!itemRow) {
	                    itemRow = [];
	                    vm.items.rowData.push(itemRow);
	                }
	                itemRow.push(item);
	            }
	
	            vm.columns = newColumns;
	            vm.topIndex = newTopIndex;
	            vm.itemRows.getItemAtIndex(newTopIndex + pageSize);
	            $timeout(function () {
	                moveToIndex(newTopIndex);
	            }, 500);
	        }
	    }
	
	    function initGridConfiguration() {
	        vm.gridConfiguration = vm.gridConfiguration || function () {
	            return {};
	        };
	
	        vm.config = vm.gridConfiguration();
	
	        vm.itemHeight = vm.config.itemHeight || 199;
	
	        vm.refreshParamsFunc = vm.config.refreshParamsFunc || function () {
	            return { "topIndex": vm.topIndex };
	        };
	
	        vm.deleteItemTitleFunc = vm.config.deleteItemTitleFunc || function () {
	            return $translate.instant('grid.delete-item-title');
	        };
	
	        vm.deleteItemContentFunc = vm.config.deleteItemContentFunc || function () {
	            return $translate.instant('grid.delete-item-text');
	        };
	
	        vm.deleteItemsTitleFunc = vm.config.deleteItemsTitleFunc || function () {
	            return $translate.instant('grid.delete-items-title', { count: vm.items.selectedCount }, 'messageformat');
	        };
	
	        vm.deleteItemsActionTitleFunc = vm.config.deleteItemsActionTitleFunc || function (selectedCount) {
	            return $translate.instant('grid.delete-items-action-title', { count: selectedCount }, 'messageformat');
	        };
	
	        vm.deleteItemsContentFunc = vm.config.deleteItemsContentFunc || function () {
	            return $translate.instant('grid.delete-items-text');
	        };
	
	        vm.fetchItemsFunc = vm.config.fetchItemsFunc || function () {
	            return $q.when([]);
	        };
	
	        vm.loadItemDetailsFunc = vm.config.loadItemDetailsFunc || function (item) {
	            return $q.when(item);
	        };
	
	        vm.saveItemFunc = vm.config.saveItemFunc || function (item) {
	            return $q.when(item);
	        };
	
	        vm.deleteItemFunc = vm.config.deleteItemFunc || function () {
	            return $q.when();
	        };
	
	        vm.clickItemFunc = vm.config.clickItemFunc || function ($event, item) {
	            vm.openItem($event, item);
	        };
	
	        vm.itemCardTemplate = '<span></span>';
	        if (vm.config.itemCardTemplate) {
	            vm.itemCardTemplate = vm.config.itemCardTemplate;
	        } else if (vm.config.itemCardTemplateUrl) {
	            vm.itemCardTemplate = $templateCache.get(vm.config.itemCardTemplateUrl);
	        }
	        if (vm.config.itemCardController) {
	            vm.itemCardController = vm.config.itemCardController;
	        } else {
	            vm.itemCardController = 'ItemCardController';
	        }
	        if (vm.config.addItemController) {
	            vm.addItemController = vm.config.addItemController;
	        } else {
	            vm.addItemController = 'AddItemController';
	        }
	
	        vm.parentCtl = vm.config.parentCtl || vm;
	
	        vm.getItemTitleFunc = vm.config.getItemTitleFunc || function () {
	            return '';
	        };
	
	        vm.actionsList = vm.config.actionsList || [];
	
	        for (var i = 0; i < vm.actionsList.length; i++) {
	            var action = vm.actionsList[i];
	            action.isEnabled = action.isEnabled || function () {
	                return true;
	            };
	        }
	
	        vm.groupActionsList = vm.config.groupActionsList || [{
	            onAction: function onAction($event) {
	                deleteItems($event);
	            },
	            name: function name() {
	                return $translate.instant('action.delete');
	            },
	            details: vm.deleteItemsActionTitleFunc,
	            icon: "delete"
	        }];
	
	        vm.addItemText = vm.config.addItemText || function () {
	            return $translate.instant('grid.add-item-text');
	        };
	
	        vm.addItemAction = vm.config.addItemAction || {
	            onAction: function onAction($event) {
	                addItem($event);
	            },
	            name: function name() {
	                return $translate.instant('action.add');
	            },
	            details: function details() {
	                return vm.addItemText();
	            },
	            icon: "add"
	        };
	
	        vm.addItemActionsOpen = false;
	
	        vm.addItemActions = vm.config.addItemActions || [];
	
	        vm.onGridInited = vm.config.onGridInited || function () {};
	
	        vm.addItemTemplateUrl = vm.config.addItemTemplateUrl;
	
	        vm.noItemsText = vm.config.noItemsText || function () {
	            return $translate.instant('grid.no-items-text');
	        };
	
	        vm.itemDetailsText = vm.config.itemDetailsText || function () {
	            return $translate.instant('grid.item-details');
	        };
	
	        vm.isDetailsReadOnly = vm.config.isDetailsReadOnly || function () {
	            return false;
	        };
	
	        vm.isSelectionEnabled = vm.config.isSelectionEnabled || function () {
	            return true;
	        };
	
	        vm.topIndex = vm.config.topIndex || 0;
	
	        vm.items = vm.config.items || {
	            data: [],
	            rowData: [],
	            nextPageLink: {
	                limit: vm.topIndex + pageSize,
	                textSearch: $scope.searchConfig.searchText
	            },
	            selections: {},
	            selectedCount: 0,
	            hasNext: true,
	            pending: false
	        };
	
	        vm.detailsConfig = {
	            isDetailsOpen: false,
	            isDetailsEditMode: false,
	            currentItem: null,
	            editingItem: null
	        };
	    }
	
	    $scope.$on('searchTextUpdated', function () {
	        reload();
	    });
	
	    $scope.$on('searchEntitySubtypeUpdated', function () {
	        reload();
	    });
	
	    vm.onGridInited(vm);
	
	    vm.itemRows.getItemAtIndex(pageSize);
	
	    function reload() {
	        if (vm.items && vm.items.pending) {
	            vm.items.reloadPending = true;
	        } else {
	            vm.items.data.length = 0;
	            vm.items.rowData.length = 0;
	            vm.items.nextPageLink = {
	                limit: pageSize,
	                textSearch: $scope.searchConfig.searchText
	            };
	            vm.items.selections = {};
	            vm.items.selectedCount = 0;
	            vm.items.hasNext = true;
	            vm.items.pending = false;
	            vm.detailsConfig.isDetailsOpen = false;
	            vm.items.reloadPending = false;
	            vm.itemRows.getItemAtIndex(pageSize);
	        }
	    }
	
	    function refreshList() {
	        var preservedTopIndex = vm.topIndex;
	        vm.items.data.length = 0;
	        vm.items.rowData.length = 0;
	        vm.items.nextPageLink = {
	            limit: preservedTopIndex + pageSize,
	            textSearch: $scope.searchConfig.searchText
	        };
	        vm.items.selections = {};
	        vm.items.selectedCount = 0;
	        vm.items.hasNext = true;
	        vm.items.pending = false;
	        vm.detailsConfig.isDetailsOpen = false;
	        vm.items.reloadPending = false;
	        vm.items.loadCallback = function () {
	            $mdUtil.nextTick(function () {
	                moveToIndex(preservedTopIndex);
	            });
	        };
	        vm.itemRows.getItemAtIndex(preservedTopIndex + pageSize);
	    }
	
	    function addItem($event) {
	        $mdDialog.show({
	            controller: vm.addItemController,
	            controllerAs: 'vm',
	            templateUrl: vm.addItemTemplateUrl,
	            parent: angular.element($document[0].body),
	            locals: { saveItemFunction: vm.saveItemFunc },
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function () {
	            refreshList();
	        }, function () {});
	    }
	
	    function openItem($event, item) {
	        $event.stopPropagation();
	        if (vm.detailsConfig.currentItem != null && vm.detailsConfig.currentItem.id.id === item.id.id) {
	            if (vm.detailsConfig.isDetailsOpen) {
	                vm.detailsConfig.isDetailsOpen = false;
	                return;
	            }
	        }
	        vm.loadItemDetailsFunc(item).then(function success(detailsItem) {
	            detailsItem.index = item.index;
	            vm.detailsConfig.currentItem = detailsItem;
	            vm.detailsConfig.isDetailsEditMode = false;
	            vm.detailsConfig.isDetailsOpen = true;
	        });
	    }
	
	    function isCurrentItem(item) {
	        if (item != null && vm.detailsConfig.currentItem != null && vm.detailsConfig.currentItem.id.id === item.id.id) {
	            return vm.detailsConfig.isDetailsOpen;
	        } else {
	            return false;
	        }
	    }
	
	    function onToggleDetailsEditMode(theForm) {
	        if (!vm.detailsConfig.isDetailsEditMode) {
	            theForm.$setPristine();
	        }
	    }
	
	    function onCloseDetails() {
	        vm.detailsConfig.currentItem = null;
	    }
	
	    function operatingItem() {
	        if (!vm.detailsConfig.isDetailsEditMode) {
	            if (vm.detailsConfig.editingItem) {
	                vm.detailsConfig.editingItem = null;
	            }
	            return vm.detailsConfig.currentItem;
	        } else {
	            if (!vm.detailsConfig.editingItem) {
	                vm.detailsConfig.editingItem = angular.copy(vm.detailsConfig.currentItem);
	            }
	            return vm.detailsConfig.editingItem;
	        }
	    }
	
	    function saveItem(theForm) {
	        vm.saveItemFunc(vm.detailsConfig.editingItem).then(function success(item) {
	            theForm.$setPristine();
	            vm.detailsConfig.isDetailsEditMode = false;
	            var index = vm.detailsConfig.currentItem.index;
	            item.index = index;
	            vm.detailsConfig.currentItem = item;
	            vm.items.data[index] = item;
	            var row = Math.floor(index / vm.columns);
	            var itemRow = vm.items.rowData[row];
	            var column = index % vm.columns;
	            itemRow[column] = item;
	        });
	    }
	
	    function deleteItem($event, item) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var confirm = $mdDialog.confirm().targetEvent($event).title(vm.deleteItemTitleFunc(item)).htmlContent(vm.deleteItemContentFunc(item)).ariaLabel($translate.instant('grid.delete-item')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            vm.deleteItemFunc(item.id.id).then(function success() {
	                refreshList();
	            });
	        }, function () {});
	    }
	
	    function deleteItems($event) {
	        var confirm = $mdDialog.confirm().targetEvent($event).title(vm.deleteItemsTitleFunc(vm.items.selectedCount)).htmlContent(vm.deleteItemsContentFunc()).ariaLabel($translate.instant('grid.delete-items')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            var tasks = [];
	            for (var id in vm.items.selections) {
	                tasks.push(vm.deleteItemFunc(id));
	            }
	            $q.all(tasks).then(function () {
	                refreshList();
	            });
	        }, function () {});
	    }
	
	    function toggleItemSelection($event, item) {
	        $event.stopPropagation();
	        var selected = angular.isDefined(item.selected) && item.selected;
	        item.selected = !selected;
	        if (item.selected) {
	            vm.items.selections[item.id.id] = true;
	            vm.items.selectedCount++;
	        } else {
	            delete vm.items.selections[item.id.id];
	            vm.items.selectedCount--;
	        }
	    }
	
	    function triggerResize() {
	        var w = angular.element($window);
	        w.triggerHandler('resize');
	    }
	
	    function isTenantAdmin() {
	        return userService.getAuthority() == 'TENANT_ADMIN';
	    }
	
	    function moveToTop() {
	        moveToIndex(0, true);
	    }
	
	    function moveToIndex(index, animate) {
	        var repeatContainer = $scope.repeatContainer[0];
	        var scrollElement = repeatContainer.children[0];
	        var startY = scrollElement.scrollTop;
	        var stopY = index * vm.itemHeight;
	        if (stopY > 0) {
	            stopY += 16;
	        }
	        var distance = Math.abs(startY - stopY);
	        if (distance < 100 || !animate) {
	            scrollElement.scrollTop = stopY;
	            return;
	        }
	        var upElseDown = stopY < startY;
	        var speed = Math.round(distance / 100);
	        if (speed >= 20) speed = 20;
	        var step = Math.round(distance / 25);
	
	        var leapY = upElseDown ? startY - step : startY + step;
	        var timer = 0;
	        for (var i = startY; upElseDown ? i > stopY : i < stopY; upElseDown ? i -= step : i += step) {
	            $timeout(function (topY) {
	                scrollElement.scrollTop = topY;
	            }, timer * speed, true, leapY);
	            if (upElseDown) {
	                leapY -= step;
	                if (leapY < stopY) {
	                    leapY = stopY;
	                }
	            } else {
	                leapY += step;
	                if (leapY > stopY) {
	                    leapY = stopY;
	                }
	            }
	            timer++;
	        }
	    }
	
	    function noData() {
	        return vm.items.data.length == 0 && !vm.items.hasNext;
	    }
	
	    function hasData() {
	        return vm.items.data.length > 0;
	    }
	}
	
	/*@ngInject*/
	function AddItemController($scope, $mdDialog, saveItemFunction, helpLinks) {
	
	    var vm = this;
	
	    vm.helpLinks = helpLinks;
	    vm.item = {};
	
	    vm.add = add;
	    vm.cancel = cancel;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function add() {
	        saveItemFunction(vm.item).then(function success(item) {
	            vm.item = item;
	            $scope.theForm.$setPristine();
	            $mdDialog.hide();
	        });
	    }
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(819);
	
	var _toast = __webpack_require__(1328);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _toast3 = __webpack_require__(1327);
	
	var _toast4 = _interopRequireDefault(_toast3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.toast', []).factory('toast', _toast2.default).controller('ToastController', _toast4.default).name; /*
	                                                                                                                                                  * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                  *
	                                                                                                                                                  * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                  * you may not use this file except in compliance with the License.
	                                                                                                                                                  * You may obtain a copy of the License at
	                                                                                                                                                  *
	                                                                                                                                                  *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                  *
	                                                                                                                                                  * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                  * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                  * See the License for the specific language governing permissions and
	                                                                                                                                                  * limitations under the License.
	                                                                                                                                                  */

/***/ }),
/* 76 */
[1742, 17],
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(87);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _objectpath = __webpack_require__(526);
	
	var _objectpath2 = _interopRequireDefault(_objectpath);
	
	var _tv = __webpack_require__(1715);
	
	var _tv2 = _interopRequireDefault(_tv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stripNullType(type) {
	    if (Array.isArray(type) && type.length == 2) {
	        if (type[0] === 'null') return type[1];
	        if (type[1] === 'null') return type[0];
	    }
	    return type;
	}
	
	//Creates an default titleMap list from an enum, i.e. a list of strings.
	var enumToTitleMap = function enumToTitleMap(enm) {
	    var titleMap = []; //canonical titleMap format is a list.
	    enm.forEach(function (name) {
	        titleMap.push({ name: name, value: name });
	    });
	    return titleMap;
	};
	
	// Takes a titleMap in either object or list format and returns one in
	// in the list format.
	var canonicalTitleMap = function canonicalTitleMap(titleMap, originalEnum) {
	    if (!_lodash2.default.isArray(titleMap)) {
	        var canonical = [];
	        if (originalEnum) {
	            originalEnum.forEach(function (value) {
	                canonical.push({ name: titleMap[value], value: value });
	            });
	        } else {
	            for (var k in titleMap) {
	                if (titleMap.hasOwnProperty(k)) {
	                    canonical.push({ name: k, value: titleMap[k] });
	                }
	            }
	        }
	        return canonical;
	    }
	    return titleMap;
	};
	
	//Creates a form object with all common properties
	var stdFormObj = function stdFormObj(name, schema, options) {
	    options = options || {};
	    var f = options.global && options.global.formDefaults ? _lodash2.default.cloneDeep(options.global.formDefaults) : {};
	    if (options.global && options.global.supressPropertyTitles === true) {
	        f.title = schema.title;
	    } else {
	        f.title = schema.title || name;
	    }
	
	    if (schema.description) {
	        f.description = schema.description;
	    }
	    if (options.required === true || schema.required === true) {
	        f.required = true;
	    }
	    if (schema.maxLength) {
	        f.maxlength = schema.maxLength;
	    }
	    if (schema.minLength) {
	        f.minlength = schema.minLength;
	    }
	    if (schema.readOnly || schema.readonly) {
	        f.readonly = true;
	    }
	    if (schema.minimum) {
	        f.minimum = schema.minimum + (schema.exclusiveMinimum ? 1 : 0);
	    }
	    if (schema.maximum) {
	        f.maximum = schema.maximum - (schema.exclusiveMaximum ? 1 : 0);
	    }
	
	    // Non standard attributes (DONT USE DEPRECATED)
	    // If you must set stuff like this in the schema use the x-schema-form attribute
	    if (schema.validationMessage) {
	        f.validationMessage = schema.validationMessage;
	    }
	    if (schema.enumNames) {
	        f.titleMap = canonicalTitleMap(schema.enumNames, schema['enum']);
	    }
	    f.schema = schema;
	
	    // Ng model options doesn't play nice with undefined, might be defined
	    // globally though
	    f.ngModelOptions = f.ngModelOptions || {};
	
	    return f;
	};
	
	var text = function text(name, schema, options) {
	    if (stripNullType(schema.type) === 'string' && !schema['enum']) {
	        var f = stdFormObj(name, schema, options);
	        f.key = options.path;
	        f.type = 'text';
	        options.lookup[_objectpath2.default.stringify(options.path)] = f;
	        return f;
	    }
	};
	
	//default in json form for number and integer is a text field
	//input type="number" would be more suitable don't ya think?
	var number = function number(name, schema, options) {
	    if (stripNullType(schema.type) === 'number') {
	        var f = stdFormObj(name, schema, options);
	        f.key = options.path;
	        f.type = 'number';
	        options.lookup[_objectpath2.default.stringify(options.path)] = f;
	        return f;
	    }
	};
	
	var integer = function integer(name, schema, options) {
	    if (stripNullType(schema.type) === 'integer') {
	        var f = stdFormObj(name, schema, options);
	        f.key = options.path;
	        f.type = 'number';
	        options.lookup[_objectpath2.default.stringify(options.path)] = f;
	        return f;
	    }
	};
	
	var date = function date(name, schema, options) {
	    if (stripNullType(schema.type) === 'date') {
	        var f = stdFormObj(name, schema, options);
	        f.key = options.path;
	        f.type = 'date';
	        options.lookup[_objectpath2.default.stringify(options.path)] = f;
	        return f;
	    }
	};
	
	var checkbox = function checkbox(name, schema, options) {
	    if (stripNullType(schema.type) === 'boolean') {
	        var f = stdFormObj(name, schema, options);
	        f.key = options.path;
	        f.type = 'checkbox';
	        options.lookup[_objectpath2.default.stringify(options.path)] = f;
	        return f;
	    }
	};
	
	var select = function select(name, schema, options) {
	    if (stripNullType(schema.type) === 'string' && schema['enum']) {
	        var f = stdFormObj(name, schema, options);
	        f.key = options.path;
	        f.type = 'select';
	        if (!f.titleMap) {
	            f.titleMap = enumToTitleMap(schema['enum']);
	        }
	        options.lookup[_objectpath2.default.stringify(options.path)] = f;
	        return f;
	    }
	};
	
	var checkboxes = function checkboxes(name, schema, options) {
	    if (stripNullType(schema.type) === 'array' && schema.items && schema.items['enum']) {
	        var f = stdFormObj(name, schema, options);
	        f.key = options.path;
	        f.type = 'checkboxes';
	        if (!f.titleMap) {
	            f.titleMap = enumToTitleMap(schema.items['enum']);
	        }
	        options.lookup[_objectpath2.default.stringify(options.path)] = f;
	        return f;
	    }
	};
	
	var fieldset = function fieldset(name, schema, options) {
	    if (stripNullType(schema.type) === 'object') {
	        var f = stdFormObj(name, schema, options);
	        f.type = 'fieldset';
	        f.items = [];
	        options.lookup[_objectpath2.default.stringify(options.path)] = f;
	
	        //recurse down into properties
	        for (var k in schema.properties) {
	            if (schema.properties.hasOwnProperty(k)) {
	                var path = options.path.slice();
	                path.push(k);
	                if (options.ignore[_objectpath2.default.stringify(path)] !== true) {
	                    var required = schema.required && schema.required.indexOf(k) !== -1;
	
	                    var def = defaultFormDefinition(k, schema.properties[k], {
	                        path: path,
	                        required: required || false,
	                        lookup: options.lookup,
	                        ignore: options.ignore,
	                        global: options.global
	                    });
	                    if (def) {
	                        f.items.push(def);
	                    }
	                }
	            }
	        }
	        return f;
	    }
	};
	
	var array = function array(name, schema, options) {
	
	    if (stripNullType(schema.type) === 'array') {
	        var f = stdFormObj(name, schema, options);
	        f.type = 'array';
	        f.key = options.path;
	        options.lookup[_objectpath2.default.stringify(options.path)] = f;
	
	        // don't do anything if items is not defined.
	        if (typeof schema.items !== 'undefined') {
	            var required = schema.required && schema.required.indexOf(options.path[options.path.length - 1]) !== -1;
	
	            // The default is to always just create one child. This works since if the
	            // schemas items declaration is of type: "object" then we get a fieldset.
	            // We also follow json form notatation, adding empty brackets "[]" to
	            // signify arrays.
	
	            var arrPath = options.path.slice();
	            arrPath.push('');
	            var def = defaultFormDefinition(name, schema.items, {
	                path: arrPath,
	                required: required || false,
	                lookup: options.lookup,
	                ignore: options.ignore,
	                global: options.global
	            });
	            if (def) {
	                f.items = [def];
	            } else {
	                // This is the case that item only contains key value pair for rc-select multipel
	                f.items = schema.items;
	            }
	        }
	        return f;
	    }
	};
	
	var defaults = {
	    string: [select, text],
	    object: [fieldset],
	    number: [number],
	    integer: [integer],
	    boolean: [checkbox],
	    array: [checkboxes, array],
	    date: [date]
	};
	
	function defaultFormDefinition(name, schema, options) {
	    //console.log("defaultFormDefinition name, schema", name, schema);
	    var rules = defaults[stripNullType(schema.type)];
	    //console.log('defaultFormDefinition:defaults = ', defaults);
	    //console.log('defaultFormDefinition:rules = ', rules);
	    if (rules) {
	        var def;
	        for (var i = 0; i < rules.length; i++) {
	            def = rules[i](name, schema, options);
	
	            //first handler in list that actually returns something is our handler!
	            if (def) {
	
	                // Do we have form defaults in the schema under the x-schema-form-attribute?
	                if (def.schema['x-schema-form'] && _lodash2.default.isObject(def.schema['x-schema-form'])) {
	                    def = _lodash2.default.extend(def, def.schema['x-schema-form']);
	                }
	                return def;
	            }
	        }
	    }
	}
	
	function getDefaults(schema, ignore, globalOptions) {
	    var form = [];
	    var lookup = {}; //Map path => form obj for fast lookup in merging
	    ignore = ignore || {};
	    globalOptions = globalOptions || {};
	    //console.log('getDefaults:schema.type = ', schema.type);
	    if (stripNullType(schema.type) === 'object') {
	        //console.log('getDefaults:schema.properties = ', schema.properties);
	        for (var k in schema.properties) {
	            if (schema.properties.hasOwnProperty(k)) {
	                if (ignore[k] !== true) {
	                    var required = schema.required && schema.required.indexOf(k) !== -1;
	                    //console.log('getDefaults:required = ', required);
	                    //console.log('getDefaults: k = ', k);
	                    //console.log('getDefaults: v = ', schema.properties[k]);
	                    var def = defaultFormDefinition(k, schema.properties[k], {
	                        path: [k], // Path to this property in bracket notation.
	                        lookup: lookup, // Extra map to register with. Optimization for merger.
	                        ignore: ignore, // The ignore list of paths (sans root level name)
	                        required: required, // Is it required? (v4 json schema style)
	                        global: globalOptions // Global options, including form defaults
	                    });
	                    //console.log('getDefaults:def = ', def);
	                    if (def) {
	                        form.push(def);
	                    }
	                }
	            }
	        }
	    } else {
	        throw new Error('Not implemented. Only type "object" allowed at root level of schema.');
	    }
	    return { form: form, lookup: lookup };
	}
	
	var postProcessFn = function postProcessFn(form) {
	    return form;
	};
	
	/**
	 * Append default form rule
	 * @param {string}   type json schema type
	 * @param {Function} rule a function(propertyName,propertySchema,options) that returns a form
	 *                        definition or undefined
	 */
	function appendRule(type, rule) {
	    if (!defaults[type]) {
	        defaults[type] = [];
	    }
	    defaults[type].push(rule);
	}
	/**
	 * Prepend default form rule
	 * @param {string}   type json schema type
	 * @param {Function} rule a function(propertyName,propertySchema,options) that returns a form
	 *                        definition or undefined
	 */
	function prependRule(type, rule) {
	    if (!defaults[type]) {
	        defaults[type] = [];
	    }
	    defaults[type].unshift(rule);
	}
	
	//Utility functions
	/**
	 * Traverse a schema, applying a function(schema,path) on every sub schema
	 * i.e. every property of an object.
	 */
	function traverseSchema(schema, fn, path, ignoreArrays) {
	    ignoreArrays = typeof ignoreArrays !== 'undefined' ? ignoreArrays : true;
	
	    path = path || [];
	
	    var traverse = function traverse(schema, fn, path) {
	        fn(schema, path);
	        for (var k in schema.properties) {
	            if (schema.properties.hasOwnProperty(k)) {
	                var currentPath = path.slice();
	                currentPath.push(k);
	                traverse(schema.properties[k], fn, currentPath);
	            }
	        }
	        //Only support type "array" which have a schema as "items".
	        if (!ignoreArrays && schema.items) {
	            var arrPath = path.slice();arrPath.push('');
	            traverse(schema.items, fn, arrPath);
	        }
	    };
	
	    traverse(schema, fn, path || []);
	}
	
	function traverseForm(form, fn) {
	    fn(form);
	    if (form.items) {
	        form.items.forEach(function (f) {
	            traverseForm(f, fn);
	        });
	    }
	
	    if (form.tabs) {
	        form.tabs.forEach(function (tab) {
	            tab.items.forEach(function (f) {
	                traverseForm(f, fn);
	            });
	        });
	    }
	}
	
	function merge(schema, form, ignore, options, readonly) {
	    //console.log('merge schema', schema);
	    //console.log('merge form', form);
	    form = form || ['*'];
	    options = options || {};
	
	    // Get readonly from root object
	    readonly = readonly || schema.readonly || schema.readOnly;
	
	    var stdForm = getDefaults(schema, ignore, options);
	    //console.log('merge stdForm', stdForm);
	    //simple case, we have a "*", just put the stdForm there
	    var idx = form.indexOf('*');
	    if (idx !== -1) {
	        form = form.slice(0, idx).concat(stdForm.form).concat(form.slice(idx + 1));
	    }
	
	    //ok let's merge!
	    //We look at the supplied form and extend it with schema standards
	    var lookup = stdForm.lookup;
	    //console.log('form', form);
	    return postProcessFn(form.map(function (obj) {
	
	        //handle the shortcut with just a name
	        if (typeof obj === 'string') {
	            obj = { key: obj };
	        }
	        //console.log('obj', obj);
	        if (obj.key) {
	            if (typeof obj.key === 'string') {
	                obj.key = _objectpath2.default.parse(obj.key);
	            }
	        }
	
	        //If it has a titleMap make sure it's a list
	        if (obj.titleMap) {
	            obj.titleMap = canonicalTitleMap(obj.titleMap);
	        }
	
	        //
	        if (obj.itemForm) {
	            obj.items = [];
	            var str = _objectpath2.default.stringify(obj.key);
	            var stdForm = lookup[str];
	            stdForm.items.forEach(function (item) {
	                var o = _lodash2.default.cloneDeep(obj.itemForm);
	                o.key = item.key;
	                obj.items.push(o);
	            });
	        }
	
	        //extend with std form from schema.
	        if (obj.key) {
	            var strid = _objectpath2.default.stringify(obj.key);
	            if (lookup[strid]) {
	                var schemaDefaults = lookup[strid];
	                for (var k in schemaDefaults) {
	                    if (schemaDefaults.hasOwnProperty(k)) {
	                        if (obj[k] === undefined) {
	                            obj[k] = schemaDefaults[k];
	                        }
	                    }
	                }
	            }
	        }
	
	        // Are we inheriting readonly?
	        if (readonly === true) {
	            // Inheriting false is not cool.
	            obj.readonly = true;
	        }
	
	        //if it's a type with items, merge 'em!
	        if (obj.items && obj.items.length > 0) {
	            //console.log('items is not empty schema', schema);
	            //console.log('items is not empty obj.items', obj.items);
	
	            obj.items = merge(schema, obj.items, ignore, options, obj.readonly);
	        }
	
	        //if its has tabs, merge them also!
	        if (obj.tabs) {
	            obj.tabs.forEach(function (tab) {
	                tab.items = merge(schema, tab.items, ignore, options, obj.readonly);
	            });
	        }
	
	        // Special case: checkbox
	        // Since have to ternary state we need a default
	        if (obj.type === 'checkbox' && _lodash2.default.isUndefined(obj.schema['default'])) {
	            obj.schema['default'] = false;
	        }
	
	        return obj;
	    }));
	}
	
	function selectOrSet(projection, obj, valueToSet) {
	    //console.log('selectOrSet', projection, obj, valueToSet);
	    var numRe = /^\d+$/;
	
	    if (!obj) {
	        obj = this;
	    }
	    //Support [] array syntax
	    var parts = typeof projection === 'string' ? _objectpath2.default.parse(projection) : projection;
	
	    if (typeof valueToSet !== 'undefined' && parts.length === 1) {
	        //special case, just setting one variable
	        obj[parts[0]] = valueToSet;
	        return obj;
	    }
	
	    if (typeof valueToSet !== 'undefined' && typeof obj[parts[0]] === 'undefined') {
	        // We need to look ahead to check if array is appropriate
	        obj[parts[0]] = parts.length > 2 && numRe.test(parts[1]) ? [] : {};
	    }
	
	    var value = obj[parts[0]];
	    for (var i = 1; i < parts.length; i++) {
	        // Special case: We allow JSON Form syntax for arrays using empty brackets
	        // These will of course not work here so we exit if they are found.
	        if (parts[i] === '') {
	            return undefined;
	        }
	        if (typeof valueToSet !== 'undefined') {
	            if (i === parts.length - 1) {
	                //last step. Let's set the value
	                value[parts[i]] = valueToSet;
	                return valueToSet;
	            } else {
	                // Make sure to create new objects on the way if they are not there.
	                // We need to look ahead to check if array is appropriate
	                var tmp = value[parts[i]];
	                if (typeof tmp === 'undefined' || tmp === null) {
	                    tmp = numRe.test(parts[i + 1]) ? [] : {};
	                    value[parts[i]] = tmp;
	                }
	                value = tmp;
	            }
	        } else if (value) {
	            //Just get nex value.
	            value = value[parts[i]];
	        }
	    }
	    return value;
	}
	
	function validateBySchema(schema, value) {
	    return _tv2.default.validateResult(value, schema);
	}
	
	function validate(form, value) {
	    //console.log('utils validate form ', form);
	    if (!form) {
	        return { valid: true };
	    }
	    var schema = form.schema;
	    if (!schema) {
	        return { valid: true };
	    }
	    //console.log('utils validate schema = ', schema);
	    // Input of type text and textareas will give us a viewValue of ''
	    // when empty, this is a valid value in a schema and does not count as something
	    // that breaks validation of 'required'. But for our own sanity an empty field should
	    // not validate if it's required.
	
	    if (value === '') {
	        value = undefined;
	    }
	
	    // Numbers fields will give a null value, which also means empty field
	    if (form.type === 'number' && value === null) {
	        //console.log('utils validate form.type is number');
	        value = undefined;
	    }
	
	    if (form.type === 'number' && isNaN(parseFloat(value))) {
	        value = undefined;
	    }
	
	    // Version 4 of JSON Schema has the required property not on the
	    // property itself but on the wrapping object. Since we like to test
	    // only this property we wrap it in a fake object.
	    var wrap = { type: 'object', 'properties': {} };
	    var propName = form.key[form.key.length - 1];
	    wrap.properties[propName] = schema;
	
	    if (form.required) {
	        wrap.required = [propName];
	    }
	    var valueWrap = {};
	    if (typeof value !== 'undefined') {
	        valueWrap[propName] = value;
	    }
	    //console.log('utils validate value = ', typeof value);
	    //console.log('utils validate valueWrap = ', valueWrap);
	    //console.log('utils validate wrap = ', wrap);
	
	    var tv4Result = _tv2.default.validateResult(valueWrap, wrap);
	    if (tv4Result != null && !tv4Result.valid && form.validationMessage != null && typeof value !== 'undefined') {
	        tv4Result.error.message = form.validationMessage;
	    }
	    return tv4Result;
	}
	
	module.exports = {
	    traverseForm: traverseForm,
	    traverseSchema: traverseSchema,
	    prependRule: prependRule,
	    appendRule: appendRule,
	    postProcessFn: postProcessFn,
	    getDefaults: getDefaults,
	    defaultFormDefinition: defaultFormDefinition,
	    defaults: defaults,
	    array: array,
	    fieldset: fieldset,
	    checkboxes: checkboxes,
	    select: select,
	    checkbox: checkbox,
	    integer: integer,
	    number: number,
	    text: text,
	    stdFormObj: stdFormObj,
	    canonicalTitleMap: canonicalTitleMap,
	    enumToTitleMap: enumToTitleMap,
	    stripNullType: stripNullType,
	    merge: merge,
	    validate: validate,
	    validateBySchema: validateBySchema,
	    selectOrSet: selectOrSet
	};
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(stripNullType, 'stripNullType', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(enumToTitleMap, 'enumToTitleMap', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(canonicalTitleMap, 'canonicalTitleMap', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(stdFormObj, 'stdFormObj', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(text, 'text', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(number, 'number', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(integer, 'integer', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(date, 'date', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(checkbox, 'checkbox', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(select, 'select', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(checkboxes, 'checkboxes', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(fieldset, 'fieldset', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(array, 'array', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(defaults, 'defaults', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(defaultFormDefinition, 'defaultFormDefinition', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(getDefaults, 'getDefaults', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(postProcessFn, 'postProcessFn', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(appendRule, 'appendRule', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(prependRule, 'prependRule', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(traverseSchema, 'traverseSchema', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(traverseForm, 'traverseForm', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(merge, 'merge', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(selectOrSet, 'selectOrSet', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(validateBySchema, 'validateBySchema', 'src/utils.js');
	
	    __REACT_HOT_LOADER__.register(validate, 'validate', 'src/utils.js');
	}();
	
	;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(151);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(104);
	util.inherits = __webpack_require__(30);
	/*</replacement>*/
	
	var Readable = __webpack_require__(567);
	var Writable = __webpack_require__(258);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(105);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// Should already be required, here for clarity
	__webpack_require__(48);
	
	// Load Angular and dependent libs
	__webpack_require__(121);
	__webpack_require__(264);
	
	// Now load Angular Material
	__webpack_require__(607);
	
	// Export namespace
	module.exports = 'ngMaterial';


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(64);
	var createDesc = __webpack_require__(102);
	module.exports = __webpack_require__(67) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(293);
	var defined = __webpack_require__(177);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.11';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(47)(module)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dateTimeFormat = dateTimeFormat;
	exports.addDays = addDays;
	exports.addMonths = addMonths;
	exports.addYears = addYears;
	exports.cloneDate = cloneDate;
	exports.cloneAsDate = cloneAsDate;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getWeekArray = getWeekArray;
	exports.localizedWeekday = localizedWeekday;
	exports.formatIso = formatIso;
	exports.isEqualDate = isEqualDate;
	exports.isBeforeDate = isBeforeDate;
	exports.isAfterDate = isAfterDate;
	exports.isBetweenDates = isBetweenDates;
	exports.monthDiff = monthDiff;
	exports.yearDiff = yearDiff;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
	var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function dateTimeFormat(locale, options) {
	   false ? (0, _warning2.default)(locale === 'en-US', 'Material-UI: The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;
	
	  this.format = function (date) {
	    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
	      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
	    } else if (options.year === 'numeric' && options.month === 'numeric' && options.day === 'numeric') {
	      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
	    } else if (options.year === 'numeric' && options.month === 'long') {
	      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
	    } else if (options.weekday === 'narrow') {
	      return dayAbbreviation[date.getDay()];
	    } else if (options.year === 'numeric') {
	      return date.getFullYear().toString();
	    } else if (options.day === 'numeric') {
	      return date.getDate();
	    } else {
	       false ? (0, _warning2.default)(false, 'Material-UI: Wrong usage of DateTimeFormat') : void 0;
	    }
	  };
	}
	
	function addDays(d, days) {
	  var newDate = cloneDate(d);
	  newDate.setDate(d.getDate() + days);
	  return newDate;
	}
	
	function addMonths(d, months) {
	  var newDate = cloneDate(d);
	  newDate.setMonth(d.getMonth() + months);
	  return newDate;
	}
	
	function addYears(d, years) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(d.getFullYear() + years);
	  return newDate;
	}
	
	function cloneDate(d) {
	  return new Date(d.getTime());
	}
	
	function cloneAsDate(d) {
	  var clonedDate = cloneDate(d);
	  clonedDate.setHours(0, 0, 0, 0);
	  return clonedDate;
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1);
	}
	
	function getFirstDayOfWeek() {
	  var now = new Date();
	  return new Date(now.setDate(now.getDate() - now.getDay()));
	}
	
	function getWeekArray(d, firstDayOfWeek) {
	  var dayArray = [];
	  var daysInMonth = getDaysInMonth(d);
	  var weekArray = [];
	  var week = [];
	
	  for (var i = 1; i <= daysInMonth; i++) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	  }
	
	  var addWeek = function addWeek(week) {
	    var emptyDays = 7 - week.length;
	    for (var _i = 0; _i < emptyDays; ++_i) {
	      week[weekArray.length ? 'push' : 'unshift'](null);
	    }
	    weekArray.push(week);
	  };
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      addWeek(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      addWeek(week);
	    }
	  });
	
	  return weekArray;
	}
	
	function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
	  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
	  var firstDayDate = getFirstDayOfWeek();
	
	  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
	}
	
	// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
	function formatIso(date) {
	  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
	}
	
	function isEqualDate(d1, d2) {
	  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	
	function isBeforeDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() < date2.getTime();
	}
	
	function isAfterDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() > date2.getTime();
	}
	
	function isBetweenDates(dateToCheck, startDate, endDate) {
	  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
	}
	
	function monthDiff(d1, d2) {
	  var m = void 0;
	  m = (d1.getFullYear() - d2.getFullYear()) * 12;
	  m += d1.getMonth();
	  m -= d2.getMonth();
	  return m;
	}
	
	function yearDiff(d1, d2) {
	  return ~~(monthDiff(d1, d2) / 12);
	}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(57);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(374);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _lodash = __webpack_require__(894);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverAnimationDefault = __webpack_require__(1045);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	var _iOSHelpers = __webpack_require__(1118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'none'
	  }
	};
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover(props, context) {
	    (0, _classCallCheck3.default)(this, Popover);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));
	
	    _this.timeout = null;
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props,
	          animated = _this$props.animated,
	          animation = _this$props.animation,
	          anchorEl = _this$props.anchorEl,
	          anchorOrigin = _this$props.anchorOrigin,
	          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
	          canAutoPosition = _this$props.canAutoPosition,
	          children = _this$props.children,
	          onRequestClose = _this$props.onRequestClose,
	          style = _this$props.style,
	          targetOrigin = _this$props.targetOrigin,
	          useLayerForClickAway = _this$props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway']);
	
	
	      var styleRoot = style;
	
	      if (!animated) {
	        styleRoot = {
	          position: 'fixed',
	          zIndex: _this.context.muiTheme.zIndex.popover
	        };
	
	        if (!_this.state.open) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
	          children
	        );
	      }
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	
	      return _react2.default.createElement(
	        Animation,
	        (0, _extends3.default)({
	          targetOrigin: targetOrigin,
	          style: styleRoot
	        }, other, {
	          open: _this.state.open && !_this.state.closing
	        }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function (event) {
	      event.preventDefault();
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (!_this.refs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.refs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          targetOrigin = _this$props2.targetOrigin,
	          anchorOrigin = _this$props2.anchorOrigin;
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = Math.max(0, targetPosition.top) + 'px';
	      targetEl.style.left = Math.max(0, targetPosition.left) + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open !== this.state.open) {
	        if (nextProps.open) {
	          this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	          this.setState({
	            open: true,
	            closing: false
	          });
	        } else {
	          if (nextProps.animated) {
	            if (this.timeout !== null) return;
	            this.setState({ closing: true });
	            this.timeout = setTimeout(function () {
	              _this2.setState({
	                open: false
	              }, function () {
	                _this2.timeout = null;
	              });
	            }, 500);
	          } else {
	            this.setState({
	              open: false
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleScroll.cancel();
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	
	      // The fixed positioning isn't respected on iOS when an input is focused.
	      // We need to compute the position from the top of the page and not the viewport.
	      if ((0, _iOSHelpers.isIOS)() && document.activeElement.tagName === 'INPUT') {
	        a.bottom = (0, _iOSHelpers.getOffsetTop)(el) + a.height;
	      } else {
	        a.bottom = rect.bottom || a.top + a.height;
	      }
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = (0, _extends3.default)({}, anchor);
	      var t = (0, _extends3.default)({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
	          positions = _getPositions.positions,
	          anchorPos = _getPositions.anchorPos;
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) {
	          targetPosition.top = Math.max(0, newTop);
	        } else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) {
	            targetPosition.top = Math.max(0, newTop);
	          }
	        }
	      }
	
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) {
	          targetPosition.left = Math.max(0, newLeft);
	        } else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) {
	            targetPosition.left = Math.max(0, newLeft);
	          }
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: 'layer',
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Popover.propTypes = {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _react.PropTypes.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _react.PropTypes.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _react.PropTypes.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _react.PropTypes.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = Popover;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Utils.$inject = ["$mdColorPalette", "$rootScope", "$window", "$translate", "$q", "$timeout", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _codepoints = __webpack_require__(1565);
	
	var _codepoints2 = _interopRequireDefault(_codepoints);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _jsonSchemaDefaults = __webpack_require__(889);
	
	var _jsonSchemaDefaults2 = _interopRequireDefault(_jsonSchemaDefaults);
	
	var _base64Js = __webpack_require__(274);
	
	var _base64Js2 = _interopRequireDefault(_base64Js);
	
	var _utf8Support = __webpack_require__(1168);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.utils', [_types2.default]).factory('utils', Utils).name;
	
	/* eslint-enable import/no-unresolved, import/default */
	
	var varsRegex = /\$\{([^\}]*)\}/g;
	
	/*@ngInject*/
	function Utils($mdColorPalette, $rootScope, $window, $translate, $q, $timeout, types) {
	
	    var predefinedFunctions = {},
	        predefinedFunctionsList = [],
	        materialColors = [],
	        materialIcons = [];
	
	    var commonMaterialIcons = ['more_horiz', 'more_vert', 'open_in_new', 'visibility', 'play_arrow', 'arrow_back', 'arrow_downward', 'arrow_forward', 'arrow_upwards', 'close', 'refresh', 'menu', 'show_chart', 'multiline_chart', 'pie_chart', 'insert_chart', 'people', 'person', 'domain', 'devices_other', 'now_widgets', 'dashboards', 'map', 'pin_drop', 'my_location', 'extension', 'search', 'settings', 'notifications', 'notifications_active', 'info', 'info_outline', 'warning', 'list', 'file_download', 'import_export', 'share', 'add', 'edit', 'done'];
	
	    predefinedFunctions['Sin'] = "return Math.round(1000*Math.sin(time/5000));";
	    predefinedFunctions['Cos'] = "return Math.round(1000*Math.cos(time/5000));";
	    predefinedFunctions['Random'] = "var value = prevValue + Math.random() * 100 - 50;\n" + "var multiplier = Math.pow(10, 2 || 0);\n" + "var value = Math.round(value * multiplier) / multiplier;\n" + "if (value < -1000) {\n" + "	value = -1000;\n" + "} else if (value > 1000) {\n" + "	value = 1000;\n" + "}\n" + "return value;";
	
	    for (var func in predefinedFunctions) {
	        predefinedFunctionsList.push(func);
	    }
	
	    var colorPalettes = ['blue', 'green', 'red', 'amber', 'blue-grey', 'purple', 'light-green', 'indigo', 'pink', 'yellow', 'light-blue', 'orange', 'deep-purple', 'lime', 'teal', 'brown', 'cyan', 'deep-orange', 'grey'];
	    var colorSpectrum = ['500', 'A700', '600', '700', '800', '900', '300', '400', 'A200', 'A400'];
	
	    angular.forEach($mdColorPalette, function (value, key) {
	        angular.forEach(value, function (color, label) {
	            if (colorSpectrum.indexOf(label) > -1) {
	                var rgb = 'rgb(' + color.value[0] + ',' + color.value[1] + ',' + color.value[2] + ')';
	                color = (0, _tinycolor2.default)(rgb);
	                var isDark = color.isDark();
	                var colorItem = {
	                    value: color.toHexString(),
	                    group: key,
	                    label: label,
	                    isDark: isDark
	                };
	                materialColors.push(colorItem);
	            }
	        });
	    });
	
	    materialColors.sort(function (colorItem1, colorItem2) {
	        var spectrumIndex1 = colorSpectrum.indexOf(colorItem1.label);
	        var spectrumIndex2 = colorSpectrum.indexOf(colorItem2.label);
	        var result = spectrumIndex1 - spectrumIndex2;
	        if (result === 0) {
	            var paletteIndex1 = colorPalettes.indexOf(colorItem1.group);
	            var paletteIndex2 = colorPalettes.indexOf(colorItem2.group);
	            result = paletteIndex1 - paletteIndex2;
	        }
	        return result;
	    });
	
	    var defaultDataKey = {
	        name: 'f(x)',
	        type: types.dataKeyType.function,
	        label: 'Sin',
	        color: getMaterialColor(0),
	        funcBody: getPredefinedFunctionBody('Sin'),
	        settings: {},
	        _hash: Math.random()
	    };
	
	    var defaultDatasource = {
	        type: types.datasourceType.function,
	        name: types.datasourceType.function,
	        dataKeys: [angular.copy(defaultDataKey)]
	    };
	
	    var defaultAlarmFields = [types.alarmFields.createdTime.keyName, types.alarmFields.originator.keyName, types.alarmFields.type.keyName, types.alarmFields.severity.keyName, types.alarmFields.status.keyName];
	
	    var defaultAlarmDataKeys = [];
	    for (var i = 0; i < defaultAlarmFields.length; i++) {
	        var name = defaultAlarmFields[i];
	        var dataKey = {
	            name: name,
	            type: types.dataKeyType.alarm,
	            label: $translate.instant(types.alarmFields[name].name) + '',
	            color: getMaterialColor(i),
	            settings: {},
	            _hash: Math.random()
	        };
	        defaultAlarmDataKeys.push(dataKey);
	    }
	
	    var imageAspectMap = {};
	
	    var service = {
	        getDefaultDatasource: getDefaultDatasource,
	        generateObjectFromJsonSchema: generateObjectFromJsonSchema,
	        getDefaultDatasourceJson: getDefaultDatasourceJson,
	        getDefaultAlarmDataKeys: getDefaultAlarmDataKeys,
	        getMaterialColor: getMaterialColor,
	        getMaterialIcons: getMaterialIcons,
	        getCommonMaterialIcons: getCommonMaterialIcons,
	        getPredefinedFunctionBody: getPredefinedFunctionBody,
	        getPredefinedFunctionsList: getPredefinedFunctionsList,
	        genMaterialColor: genMaterialColor,
	        objectHashCode: objectHashCode,
	        parseException: parseException,
	        processWidgetException: processWidgetException,
	        isDescriptorSchemaNotEmpty: isDescriptorSchemaNotEmpty,
	        filterSearchTextEntities: filterSearchTextEntities,
	        guid: guid,
	        cleanCopy: cleanCopy,
	        isLocalUrl: isLocalUrl,
	        validateDatasources: validateDatasources,
	        createKey: createKey,
	        createLabelFromDatasource: createLabelFromDatasource,
	        insertVariable: insertVariable,
	        customTranslation: customTranslation,
	        objToBase64: objToBase64,
	        base64toObj: base64toObj,
	        loadImageAspect: loadImageAspect
	    };
	
	    return service;
	
	    function getPredefinedFunctionsList() {
	        return predefinedFunctionsList;
	    }
	
	    function getPredefinedFunctionBody(func) {
	        return predefinedFunctions[func];
	    }
	
	    function getMaterialColor(index) {
	        var colorIndex = index % materialColors.length;
	        return materialColors[colorIndex].value;
	    }
	
	    function getMaterialIcons() {
	        var deferred = $q.defer();
	        if (materialIcons.length) {
	            deferred.resolve(materialIcons);
	        } else {
	            $timeout(function () {
	                var codepointsArray = _codepoints2.default.split("\n");
	                codepointsArray.forEach(function (codepoint) {
	                    if (codepoint && codepoint.length) {
	                        var values = codepoint.split(' ');
	                        if (values && values.length == 2) {
	                            materialIcons.push(values[0]);
	                        }
	                    }
	                });
	                deferred.resolve(materialIcons);
	            });
	        }
	        return deferred.promise;
	    }
	
	    function getCommonMaterialIcons() {
	        return commonMaterialIcons;
	    }
	
	    function genMaterialColor(str) {
	        var hash = Math.abs(hashCode(str));
	        return getMaterialColor(hash);
	    }
	
	    function hashCode(str) {
	        var hash = 0;
	        var i, char;
	        if (str.length == 0) return hash;
	        for (i = 0; i < str.length; i++) {
	            char = str.charCodeAt(i);
	            hash = (hash << 5) - hash + char;
	            hash = hash & hash; // Convert to 32bit integer
	        }
	        return hash;
	    }
	
	    function objectHashCode(obj) {
	        var hash = 0;
	        if (obj) {
	            var str = angular.toJson(obj);
	            hash = hashCode(str);
	        }
	        return hash;
	    }
	
	    function parseException(exception, lineOffset) {
	        var data = {};
	        if (exception) {
	            if (angular.isString(exception) || exception instanceof String) {
	                data.message = exception;
	            } else {
	                if (exception.name) {
	                    data.name = exception.name;
	                } else {
	                    data.name = 'UnknownError';
	                }
	                if (exception.message) {
	                    data.message = exception.message;
	                }
	                if (exception.lineNumber) {
	                    data.lineNumber = exception.lineNumber;
	                    if (exception.columnNumber) {
	                        data.columnNumber = exception.columnNumber;
	                    }
	                } else if (exception.stack) {
	                    var lineInfoRegexp = /(.*<anonymous>):(\d*)(:)?(\d*)?/g;
	                    var lineInfoGroups = lineInfoRegexp.exec(exception.stack);
	                    if (lineInfoGroups != null && lineInfoGroups.length >= 3) {
	                        if (angular.isUndefined(lineOffset)) {
	                            lineOffset = -2;
	                        }
	                        data.lineNumber = Number(lineInfoGroups[2]) + lineOffset;
	                        if (lineInfoGroups.length >= 5) {
	                            data.columnNumber = lineInfoGroups[4];
	                        }
	                    }
	                }
	            }
	        }
	        return data;
	    }
	
	    function processWidgetException(exception) {
	        var parentScope = $window.parent.angular.element($window.frameElement).scope();
	        var data = parseException(exception, -5);
	        if ($rootScope.widgetEditMode) {
	            parentScope.$emit('widgetException', data);
	            parentScope.$apply();
	        }
	        return data;
	    }
	
	    function getDefaultDatasource(dataKeySchema) {
	        var datasource = angular.copy(defaultDatasource);
	        if (angular.isDefined(dataKeySchema)) {
	            datasource.dataKeys[0].settings = generateObjectFromJsonSchema(dataKeySchema);
	        }
	        return datasource;
	    }
	
	    function generateObjectFromJsonSchema(schema) {
	        var obj = (0, _jsonSchemaDefaults2.default)(schema);
	        deleteNullProperties(obj);
	        return obj;
	    }
	
	    function deleteNullProperties(obj) {
	        if (angular.isUndefined(obj) || obj == null) {
	            return;
	        }
	        for (var propName in obj) {
	            if (obj[propName] === null || angular.isUndefined(obj[propName])) {
	                delete obj[propName];
	            } else if (angular.isObject(obj[propName])) {
	                deleteNullProperties(obj[propName]);
	            } else if (angular.isArray(obj[propName])) {
	                for (var i = 0; i < obj[propName].length; i++) {
	                    deleteNullProperties(obj[propName][i]);
	                }
	            }
	        }
	    }
	
	    function getDefaultDatasourceJson(dataKeySchema) {
	        return angular.toJson(getDefaultDatasource(dataKeySchema));
	    }
	
	    function getDefaultAlarmDataKeys() {
	        return angular.copy(defaultAlarmDataKeys);
	    }
	
	    function isDescriptorSchemaNotEmpty(descriptor) {
	        if (descriptor && descriptor.schema && descriptor.schema.properties) {
	            for (var prop in descriptor.schema.properties) {
	                if (descriptor.schema.properties.hasOwnProperty(prop)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }
	
	    function filterSearchTextEntities(entities, searchTextField, pageLink, deferred) {
	        var response = {
	            data: [],
	            hasNext: false,
	            nextPageLink: null
	        };
	        var limit = pageLink.limit;
	        var textSearch = '';
	        if (pageLink.textSearch) {
	            textSearch = pageLink.textSearch.toLowerCase();
	        }
	
	        for (var i = 0; i < entities.length; i++) {
	            var entity = entities[i];
	            var text = entity[searchTextField].toLowerCase();
	            var createdTime = entity.createdTime;
	            if (pageLink.textOffset && pageLink.textOffset.length > 0) {
	                var comparison = text.localeCompare(pageLink.textOffset);
	                if (comparison === 0 && createdTime < pageLink.createdTimeOffset) {
	                    response.data.push(entity);
	                    if (response.data.length === limit) {
	                        break;
	                    }
	                } else if (comparison > 0 && text.startsWith(textSearch)) {
	                    response.data.push(entity);
	                    if (response.data.length === limit) {
	                        break;
	                    }
	                }
	            } else if (textSearch.length > 0) {
	                if (text.startsWith(textSearch)) {
	                    response.data.push(entity);
	                    if (response.data.length === limit) {
	                        break;
	                    }
	                }
	            } else {
	                response.data.push(entity);
	                if (response.data.length === limit) {
	                    break;
	                }
	            }
	        }
	        if (response.data.length === limit) {
	            var lastEntity = response.data[limit - 1];
	            response.nextPageLink = {
	                limit: pageLink.limit,
	                textSearch: textSearch,
	                idOffset: lastEntity.id.id,
	                createdTimeOffset: lastEntity.createdTime,
	                textOffset: lastEntity[searchTextField].toLowerCase()
	            };
	            response.hasNext = true;
	        }
	        deferred.resolve(response);
	    }
	
	    function guid() {
	        function s4() {
	            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	        }
	        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	    }
	
	    function cleanCopy(object) {
	        var copy = angular.copy(object);
	        for (var prop in copy) {
	            if (prop && prop.startsWith('$$')) {
	                delete copy[prop];
	            }
	        }
	        return copy;
	    }
	
	    function genNextColor(datasources) {
	        var index = 0;
	        if (datasources) {
	            for (var i = 0; i < datasources.length; i++) {
	                var datasource = datasources[i];
	                index += datasource.dataKeys.length;
	            }
	        }
	        return getMaterialColor(index);
	    }
	
	    function isLocalUrl(url) {
	        var parser = document.createElement('a'); //eslint-disable-line
	        parser.href = url;
	        var host = parser.hostname;
	        if (host === "localhost" || host === "127.0.0.1") {
	            return true;
	        } else {
	            return false;
	        }
	    }
	
	    function validateDatasources(datasources) {
	        datasources.forEach(function (datasource) {
	            if (datasource.type === 'device') {
	                datasource.type = types.datasourceType.entity;
	                datasource.entityType = types.entityType.device;
	                if (datasource.deviceId) {
	                    datasource.entityId = datasource.deviceId;
	                } else if (datasource.deviceAliasId) {
	                    datasource.entityAliasId = datasource.deviceAliasId;
	                }
	                if (datasource.deviceName) {
	                    datasource.entityName = datasource.deviceName;
	                }
	            }
	            if (datasource.type === types.datasourceType.entity && datasource.entityId) {
	                datasource.name = datasource.entityName;
	            }
	        });
	        return datasources;
	    }
	
	    function createKey(keyInfo, type, datasources) {
	        var label;
	        if (type === types.dataKeyType.alarm && !keyInfo.label) {
	            var alarmField = types.alarmFields[keyInfo.name];
	            if (alarmField) {
	                label = $translate.instant(alarmField.name) + '';
	            }
	        }
	        if (!label) {
	            label = keyInfo.label || keyInfo.name;
	        }
	        var dataKey = {
	            name: keyInfo.name,
	            type: type,
	            label: label,
	            funcBody: keyInfo.funcBody,
	            settings: {},
	            _hash: Math.random()
	        };
	        if (keyInfo.units) {
	            dataKey.units = keyInfo.units;
	        }
	        if (angular.isDefined(keyInfo.decimals)) {
	            dataKey.decimals = keyInfo.decimals;
	        }
	        if (keyInfo.color) {
	            dataKey.color = keyInfo.color;
	        } else {
	            dataKey.color = genNextColor(datasources);
	        }
	        if (keyInfo.postFuncBody && keyInfo.postFuncBody.length) {
	            dataKey.usePostProcessing = true;
	            dataKey.postFuncBody = keyInfo.postFuncBody;
	        }
	        return dataKey;
	    }
	
	    function createLabelFromDatasource(datasource, pattern) {
	        var label = angular.copy(pattern);
	        var match = varsRegex.exec(pattern);
	        while (match !== null) {
	            var variable = match[0];
	            var variableName = match[1];
	            if (variableName === 'dsName') {
	                label = label.split(variable).join(datasource.name);
	            } else if (variableName === 'entityName') {
	                label = label.split(variable).join(datasource.entityName);
	            } else if (variableName === 'deviceName') {
	                label = label.split(variable).join(datasource.entityName);
	            } else if (variableName === 'aliasName') {
	                label = label.split(variable).join(datasource.aliasName);
	            }
	            match = varsRegex.exec(pattern);
	        }
	        return label;
	    }
	
	    function insertVariable(pattern, name, value) {
	        var result = angular.copy(pattern);
	        var match = varsRegex.exec(pattern);
	        while (match !== null) {
	            var variable = match[0];
	            var variableName = match[1];
	            if (variableName === name) {
	                result = result.split(variable).join(value);
	            }
	            match = varsRegex.exec(pattern);
	        }
	        return result;
	    }
	
	    function customTranslation(translationValue, defaultValue) {
	        var result = '';
	        var translationId = types.translate.customTranslationsPrefix + translationValue;
	        var translation = $translate.instant(translationId);
	        if (translation != translationId) {
	            result = translation + '';
	        } else {
	            result = defaultValue;
	        }
	        return result;
	    }
	
	    function objToBase64(obj) {
	        var json = angular.toJson(obj);
	        var encoded = (0, _utf8Support.utf8Encode)(json);
	        var b64Encoded = _base64Js2.default.fromByteArray(encoded);
	        return b64Encoded;
	    }
	
	    function base64toObj(b64Encoded) {
	        var encoded = _base64Js2.default.toByteArray(b64Encoded);
	        var json = (0, _utf8Support.utf8Decode)(encoded);
	        var obj = angular.fromJson(json);
	        return obj;
	    }
	
	    function loadImageAspect(imageUrl) {
	        var deferred = $q.defer();
	        if (imageUrl && imageUrl.length) {
	            var urlHashCode = hashCode(imageUrl);
	            var aspect = imageAspectMap[urlHashCode];
	            if (angular.isUndefined(aspect)) {
	                var testImage = document.createElement('img'); // eslint-disable-line
	                testImage.style.position = 'absolute';
	                testImage.style.left = '-99999px';
	                testImage.style.top = '-99999px';
	                testImage.onload = function () {
	                    aspect = testImage.width / testImage.height;
	                    document.body.removeChild(testImage); //eslint-disable-line
	                    imageAspectMap[urlHashCode] = aspect;
	                    deferred.resolve(aspect);
	                };
	                testImage.onerror = function () {
	                    aspect = 0;
	                    imageAspectMap[urlHashCode] = aspect;
	                    deferred.resolve(aspect);
	                };
	                document.body.appendChild(testImage); //eslint-disable-line
	                testImage.src = imageUrl;
	            } else {
	                deferred.resolve(aspect);
	            }
	        } else {
	            deferred.resolve(0);
	        }
	        return deferred.promise;
	    }
	}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(238);
	var setInnerHTML = __webpack_require__(158);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(246);
	var setTextContent = __webpack_require__(558);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(11);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var EventPluginRegistry = __webpack_require__(239);
	var EventPluginUtils = __webpack_require__(153);
	var ReactErrorUtils = __webpack_require__(243);
	
	var accumulateInto = __webpack_require__(551);
	var forEachAccumulated = __webpack_require__(552);
	var invariant = __webpack_require__(11);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(93);
	var EventPluginUtils = __webpack_require__(153);
	
	var accumulateInto = __webpack_require__(551);
	var forEachAccumulated = __webpack_require__(552);
	var warning = __webpack_require__(16);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1632);
	var ReactInstrumentation = __webpack_require__(43);
	
	var warning = __webpack_require__(16);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	var getEventTarget = __webpack_require__(249);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactBaseClasses = __webpack_require__(561);
	var ReactChildren = __webpack_require__(1673);
	var ReactDOMFactories = __webpack_require__(1674);
	var ReactElement = __webpack_require__(98);
	var ReactPropTypes = __webpack_require__(1675);
	var ReactVersion = __webpack_require__(1676);
	
	var createReactClass = __webpack_require__(1677);
	var onlyChild = __webpack_require__(1681);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactCurrentOwner = __webpack_require__(59);
	
	var warning = __webpack_require__(16);
	var canDefineProperty = __webpack_require__(565);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(563);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(270);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 *
	 * @version 2.1.5
	 */
	!function(e){"use strict";function t(e){if(Array.isArray(e)){for(var t=0,i=Array(e.length);t<e.length;t++)i[t]=e[t];return i}return Array.from(e)}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function r(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function n(e,t){if(t||(t="undefined"==typeof window?global:window),void 0!==t[e])return t[e];for(var i=["webkit","moz","ms","o"],r=0,o=i.length,n=e.charAt(0).toUpperCase()+e.substr(1);r<o;r++){var a=t[i[r]+n];if(void 0!==a)return a}return null}function a(e,t,i,r,o,n,l){if("function"!=typeof r)throw new TypeError("Invalid animation rule:",r);var s=e-i,d=s/o,c=0;d>1&&(d=1),1!==d&&(c=r(d),isFinite(c)&&!isNaN(c)&&(d=c)),t&&t(d),s<o?l.frame=ue(function(e){return a(e,t,i,r,o,n,l)}):(n&&n(),l.inProgress=!1)}function l(){Array.prototype.constructor.apply(this,arguments)}function s(e){if(!(e instanceof DOMException&&2152923147===e.result))throw e}function d(e){return e.majorTicks instanceof Array||(e.majorTicks=e.majorTicks?[e.majorTicks]:[]),e.majorTicks.length||(e.majorTicks.push(Te.formatMajorTickNumber(e.minValue,e)),e.majorTicks.push(Te.formatMajorTickNumber(e.maxValue,e))),["right"!==e.tickSide,"left"!==e.tickSide]}function c(e,t,i,r,o,n){e.beginPath(),e.moveTo(t+n,i),e.lineTo(t+r-n,i),e.quadraticCurveTo(t+r,i,t+r,i+n),e.lineTo(t+r,i+o-n),e.quadraticCurveTo(t+r,i+o,t+r-n,i+o),e.lineTo(t+n,i+o),e.quadraticCurveTo(t,i+o,t,i+o-n),e.lineTo(t,i+n),e.quadraticCurveTo(t,i,t+n,i),e.closePath()}function h(e,t){var i=t.valueDec,r=t.valueInt,o=0,n=void 0,a=void 0,l=void 0;if(e=parseFloat(e),l=e<0,e=Math.abs(e),i>0){for(a=e.toFixed(i).toString().split("."),n=r-a[0].length;o<n;++o)a[0]="0"+a[0];a=(l?"-":"")+a[0]+"."+a[1]}else{for(a=Math.round(e).toString(),n=r-a.length;o<n;++o)a="0"+a;a=(l?"-":"")+a}return a}function u(e,t){var i=void 0,r=!1;return i=0===t.majorTicksDec?Math.round(e).toString():e.toFixed(t.majorTicksDec),t.majorTicksInt>1?(r=~i.indexOf("."),~i.indexOf("-")?"-"+[t.majorTicksInt+t.majorTicksDec+2+(r?1:0)-i.length].join("0")+i.replace("-",""):[t.majorTicksInt+t.majorTicksDec+1+(r?1:0)-i.length].join("0")+i):i}function f(e){return e*Math.PI/180}function m(e,t){return{x:-e*Math.sin(t),y:e*Math.cos(t)}}function v(e,t,i,r){var o=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],n=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,a=e.createLinearGradient(o?0:n,o?n:0,o?0:r,o?r:0);return a.addColorStop(0,t),a.addColorStop(1,i),a}function b(e,t){if(arguments.length>2&&void 0!==arguments[2]&&arguments[2])return e.restore(),!0;e.save();var i=t.borderShadowWidth;return i&&(e.shadowBlur=i,e.shadowColor=t.colorBorderShadow),!0}function g(e,t){t.needleShadow&&(e.shadowOffsetX=2,e.shadowOffsetY=2,e.shadowBlur=10,e.shadowColor=t.colorNeedleShadowDown)}function p(e,t,i){return e["font"+t+"Style"]+" "+e["font"+t+"Weight"]+" "+e["font"+t+"Size"]*i+"px "+e["font"+t]}function w(e){e.shadowOffsetX=null,e.shadowOffsetY=null,e.shadowBlur=null,e.shadowColor="",e.strokeStyle=null,e.lineWidth=0,e.save()}function y(e,t,i,r){t.valueTextShadow&&(e.shadowOffsetX=i,e.shadowOffsetY=i,e.shadowBlur=r,e.shadowColor=t.colorValueTextShadow)}function k(e,t,i,r,o,n){if(t.valueBox){w(e);var a=t.valueDec?1+t.valueDec:0,l="9".repeat(Math.max.apply(null,[String(parseInt(i)).length+a].concat(t.majorTicks.map(function(e){return String(parseInt(e,10)).length+a})))),s=t.valueText||h(i,t),d=n/200,u=n/100,f=.4*u,m=1.2*u;e.font=p(t,"Value",d),y(e,t,f,m);var v=e.measureText(t.valueText?s:"-"+h(Number(l),t)).width;w(e);var b=parseFloat(t.fontValueSize)*d+f+m,g=u*parseFloat(t.valueBoxStroke),k=2*n-2*g,x=v+10*u,T=1.1*b+f+m,S=u*t.valueBoxBorderRadius,W=(parseFloat(t.valueBoxWidth)||0)/100*k;W>x&&(x=W),x>k&&(x=k);var O=r-x/2,V=o-T/2,P=o-5.75*u;if(e.beginPath(),S?c(e,O,V,x,T,S):e.rect(O,V,x,T),g){var M=e.createRadialGradient(r,P,10*u,r,P,20*u);M.addColorStop(0,t.colorValueBoxRect),M.addColorStop(1,t.colorValueBoxRectEnd),e.strokeStyle=M,e.lineWidth=g,e.stroke()}t.colorValueBoxShadow&&(e.shadowBlur=1.2*u,e.shadowColor=t.colorValueBoxShadow),t.colorValueBoxBackground&&(e.fillStyle=t.colorValueBoxBackground,e.fill()),e.closePath(),e.restore(),y(e,t,f,m),e.fillStyle=t.colorValueText,e.textAlign="center",e.textBaseline="alphabetic",e.fillText(s,O+x/2,o+T/2-b/3),e.restore()}}function x(e){var t=e.value,i=e.minValue,r=e.maxValue,o=.01*(r-i);return{normal:t<i?i:t>r?r:t,indented:t<i?i-o:t>r?r+o:t}}function T(e,t,i,r,o){i.beginPath(),i.arc(0,0,ye(e),0,2*Se,!0),i.lineWidth=t,i.strokeStyle=o?Te.linearGradient(i,r,o,e):r,i.stroke(),i.closePath()}function S(e,t){var i=be.pixelRatio;return e.maxRadius||(e.maxRadius=e.max-t.borderShadowWidth-t.borderOuterWidth*i-t.borderMiddleWidth*i-t.borderInnerWidth*i+(t.borderOuterWidth?.5:0)+(t.borderMiddleWidth?.5:0)+(t.borderInnerWidth?.5:0)),e.maxRadius}function W(e,t){var i=be.pixelRatio,r=t.borderShadowWidth*i,o=e.max-r-t.borderOuterWidth*i/2,n=o-t.borderOuterWidth*i/2-t.borderMiddleWidth*i/2+.5,a=n-t.borderMiddleWidth*i/2-t.borderInnerWidth*i/2+.5,l=S(e,t),s=void 0,d=!1;e.save(),t.borderOuterWidth&&(d=Te.drawShadow(e,t,d),T(o,t.borderOuterWidth*i,e,t.colorBorderOuter,t.colorBorderOuterEnd)),t.borderMiddleWidth&&(d=Te.drawShadow(e,t,d),T(n,t.borderMiddleWidth*i,e,t.colorBorderMiddle,t.colorBorderMiddleEnd)),t.borderInnerWidth&&(d=Te.drawShadow(e,t,d),T(a,t.borderInnerWidth*i,e,t.colorBorderInner,t.colorBorderInnerEnd)),Te.drawShadow(e,t,d),e.beginPath(),e.arc(0,0,ye(l),0,2*Se,!0),t.colorPlateEnd?(s=e.createRadialGradient(0,0,l/2,0,0,l),s.addColorStop(0,t.colorPlate),s.addColorStop(1,t.colorPlateEnd)):s=t.colorPlate,e.fillStyle=s,e.fill(),e.closePath(),e.restore()}function O(e,t){var i=e.max*(parseFloat(t.highlightsWidth)||0)/100;if(i){var r=ye(P(e,t)-i/2),o=0,n=t.highlights.length,a=(t.maxValue-t.minValue)/t.ticksAngle;for(e.save();o<n;o++){var l=t.highlights[o];e.beginPath(),e.rotate(We),e.arc(0,0,r,Te.radians(t.startAngle+(l.from-t.minValue)/a),Te.radians(t.startAngle+(l.to-t.minValue)/a),!1),e.strokeStyle=l.color,e.lineWidth=i,e.stroke(),e.closePath(),e.restore(),e.save()}}}function V(e,t){var i=P(e,t),r=void 0,o=void 0,n=void 0,a=0,l=0,s=Math.abs(t.minorTicks)||0,d=t.ticksAngle/(t.maxValue-t.minValue);for(e.lineWidth=be.pixelRatio,e.strokeStyle=t.colorMinorTicks||t.colorStrokeTicks,e.save(),t.exactTicks?(o=t.maxValue-t.minValue,r=s?o/s:0,l=(xe.mod(t.majorTicks[0],s)||0)*d):r=s*(t.majorTicks.length-1);a<r;++a)(n=t.startAngle+l+a*(t.ticksAngle/r))<=t.ticksAngle+t.startAngle&&(e.rotate(Te.radians(n)),e.beginPath(),e.moveTo(0,i),e.lineTo(0,i-.075*e.max),B(e))}function P(e,t){var i=e.max/100;return S(e,t)-5*i-(t.barWidth?2*(parseFloat(t.barStrokeWidth)||0)+((parseFloat(t.barWidth)||0)+5)*i:0)}function M(e,t){Te.prepareTicks(t);var i=ye(P(e,t)),r=void 0,o=void 0,n=t.majorTicks.length,a=be.pixelRatio;for(e.lineWidth=2*a,e.save(),o=t.colorMajorTicks instanceof Array?t.colorMajorTicks:new Array(n).fill(t.colorStrokeTicks||t.colorMajorTicks),r=0;r<n;++r)e.strokeStyle=o[r],e.rotate(Te.radians(A(t,t.exactTicks?t.majorTicks[r]:r,n))),e.beginPath(),e.moveTo(0,i),e.lineTo(0,i-.15*e.max),B(e);t.strokeTicks&&(e.strokeStyle=t.colorStrokeTicks||o[0],e.rotate(We),e.beginPath(),e.arc(0,0,i,Te.radians(t.startAngle),Te.radians(t.startAngle+t.ticksAngle),!1),B(e))}function A(e,t,i){if(e.exactTicks){var r=e.ticksAngle/(e.maxValue-e.minValue);return e.startAngle+r*(t-e.minValue)}return e.startAngle+t*(e.ticksAngle/(i-1))}function B(e){e.stroke(),e.restore(),e.closePath(),e.save()}function j(e,t){var i=P(e,t)-.15*e.max,r={},o=0,n=t.majorTicks.length,a="needle"!==t.animationTarget,l=t.colorNumbers instanceof Array?t.colorNumbers:new Array(n).fill(t.colorNumbers),s=a?-(t.value-t.minValue)/(t.maxValue-t.minValue)*t.ticksAngle:0;for(a&&(e.save(),e.rotate(-Te.radians(s))),e.font=Te.font(t,"Numbers",e.max/200),e.lineWidth=0,e.textAlign="center",e.textBaseline="middle";o<n;++o){var d=s+A(t,t.exactTicks?t.majorTicks[o]:o,n),c=e.measureText(t.majorTicks[o]).width,h=t.fontNumbersSize,u=Math.sqrt(c*c+h*h)/2,f=Te.radialPoint(i-u-t.numbersMargin/100*e.max,Te.radians(d));360===d&&(d=0),r[d]||(r[d]=!0,e.fillStyle=l[o],e.fillText(t.majorTicks[o],f.x,f.y))}a&&e.restore()}function C(e,t){t.title&&(e.save(),e.font=Te.font(t,"Title",e.max/200),e.fillStyle=t.colorTitle,e.textAlign="center",e.fillText(t.title,0,-e.max/4.25,.8*e.max),e.restore())}function N(e,t){t.units&&(e.save(),e.font=Te.font(t,"Units",e.max/200),e.fillStyle=t.colorUnits,e.textAlign="center",e.fillText(t.units,0,e.max/3.25,.8*e.max),e.restore())}function E(e,t){if(t.needle){var i=t.ticksAngle<360?Te.normalizedValue(t).indented:t.value,r=S(e,t),o=ye(r/100*t.needleCircleSize),n=ye(r/100*t.needleCircleSize*.75),a=ye(r/100*t.needleEnd),l=ye(t.needleStart?r/100*t.needleStart:0),s=r/100*t.needleWidth,d=r/100*t.needleWidth/2,c=be.pixelRatio,h="needle"!==t.animationTarget;e.save(),Te.drawNeedleShadow(e,t),e.rotate(Te.radians(h?t.startAngle:t.startAngle+(i-t.minValue)/(t.maxValue-t.minValue)*t.ticksAngle)),e.fillStyle=Te.linearGradient(e,t.colorNeedle,t.colorNeedleEnd,a-l),"arrow"===t.needleType?(e.beginPath(),e.moveTo(-d,-l),e.lineTo(-s,0),e.lineTo(-1*c,a),e.lineTo(c,a),e.lineTo(s,0),e.lineTo(d,-l),e.closePath(),e.fill(),e.beginPath(),e.lineTo(-.5*c,a),e.lineTo(-1*c,a),e.lineTo(-s,0),e.lineTo(-d,-l),e.lineTo(d/2*c-2*c,-l),e.closePath(),e.fillStyle=t.colorNeedleShadowUp,e.fill()):(e.beginPath(),e.moveTo(-d,a),e.lineTo(-d,l),e.lineTo(d,l),e.lineTo(d,a),e.closePath(),e.fill()),t.needleCircleSize&&(e.restore(),Te.drawNeedleShadow(e,t),t.needleCircleOuter&&(e.beginPath(),e.arc(0,0,o,0,2*Se,!0),e.fillStyle=Te.linearGradient(e,t.colorNeedleCircleOuter,t.colorNeedleCircleOuterEnd,o),e.fill(),e.closePath()),t.needleCircleInner&&(e.beginPath(),e.arc(0,0,n,0,2*Se,!0),e.fillStyle=Te.linearGradient(e,t.colorNeedleCircleInner,t.colorNeedleCircleInnerEnd,n),e.fill(),e.closePath()),e.restore())}}function _(e,t,i){Te.drawValueBox(e,t,i,0,e.max-.33*e.max,e.max)}function R(e,t){var i=e.max/100,r=S(e,t)-5*i,o=parseFloat(t.barStrokeWidth)||0,n=(parseFloat(t.barWidth)||0)*i,a=r-2*o-n,l=(r-a)/2,s=a+l,d=o/s,c=t.startAngle,h=t.startAngle+t.ticksAngle;e.save(),e.rotate(We),o&&(e.beginPath(),e.arc(0,0,s,Te.radians(c)-d,Te.radians(h)+d,!1),e.strokeStyle=t.colorBarStroke,e.lineWidth=2*l,e.stroke(),e.closePath()),n&&(e.beginPath(),e.arc(0,0,s,Te.radians(c),Te.radians(h),!1),e.strokeStyle=t.colorBar,e.lineWidth=n,e.stroke(),e.closePath(),t.barShadow&&(e.beginPath(),e.arc(0,0,r,Te.radians(c),Te.radians(h),!1),e.clip(),e.beginPath(),e.strokeStyle=t.colorBar,e.lineWidth=1,e.shadowBlur=t.barShadow,e.shadowColor=t.colorBarShadow,e.shadowOffsetX=0,e.shadowOffsetY=0,e.arc(0,0,r,Te.radians(t.startAngle),Te.radians(t.startAngle+t.ticksAngle),!1),e.stroke(),e.closePath(),e.restore(),e.rotate(We)),t.barProgress&&(e.beginPath(),e.arc(0,0,s,Te.radians(c),Te.radians(c+(Te.normalizedValue(t).normal-t.minValue)/(t.maxValue-t.minValue)*t.ticksAngle),!1),e.strokeStyle=t.colorBarProgress,e.lineWidth=n,e.stroke(),e.closePath())),e.restore()}function I(e){return e.options.animatedValue?e.options.value:e.value}function D(e,t,i,r,o,n,a,l){e.beginPath(),e.fillStyle=l?Te.linearGradient(e,a,l,o>n?o:n,n>o,o>n?i:r):a,t>0?Te.roundRect(e,i,r,o,n,t):e.rect(i,r,o,n),e.fill(),e.closePath()}function z(e,t,i,r,o,n,a,l,s){e.beginPath(),e.lineWidth=t,e.strokeStyle=s?Te.linearGradient(e,l,s,a,!0,o):l,i>0?Te.roundRect(e,r,o,n,a,i):e.rect(r,o,n,a),e.stroke(),e.closePath()}function L(e,t,i,r,o,n){var a=be.pixelRatio;e.save();var l=t.borderRadius*a,s=o-t.borderShadowWidth-t.borderOuterWidth*a,d=s-t.borderOuterWidth*a-t.borderMiddleWidth*a,c=d-t.borderMiddleWidth*a-t.borderInnerWidth*a,h=c-t.borderInnerWidth*a,u=n-t.borderShadowWidth-t.borderOuterWidth*a,f=u-t.borderOuterWidth*a-t.borderMiddleWidth*a,m=f-t.borderMiddleWidth*a-t.borderInnerWidth*a,v=m-t.borderInnerWidth*a,b=i-(d-s)/2,g=b-(c-d)/2,p=g-(h-c)/2,w=r-(f-u)/2,y=w-(m-f)/2,k=y-(v-m)/2,x=0,T=!1;return t.borderOuterWidth&&(T=Te.drawShadow(e,t,T),z(e,t.borderOuterWidth*a,l,i+t.borderOuterWidth*a/2-x,r+t.borderOuterWidth*a/2-x,s,u,t.colorBorderOuter,t.colorBorderOuterEnd),x+=.5*a),t.borderMiddleWidth&&(T=Te.drawShadow(e,t,T),z(e,t.borderMiddleWidth*a,l-=1+2*x,b+t.borderMiddleWidth*a/2-x,w+t.borderMiddleWidth*a/2-x,d+2*x,f+2*x,t.colorBorderMiddle,t.colorBorderMiddleEnd),x+=.5*a),t.borderInnerWidth&&(T=Te.drawShadow(e,t,T),z(e,t.borderInnerWidth*a,l-=1+2*x,g+t.borderInnerWidth*a/2-x,y+t.borderInnerWidth*a/2-x,c+2*x,m+2*x,t.colorBorderInner,t.colorBorderInnerEnd),x+=.5*a),Te.drawShadow(e,t,T),D(e,l,p,k,h+2*x,v+2*x,t.colorPlate,t.colorPlateEnd),e.restore(),[p,k,h,v]}function G(e,t,i,r,o,n){var a=be.pixelRatio,l=n>=o,s=l?.85*o:n,d=l?n:o;i=l?we(i+(o-s)/2):i;var c=!!t.title,h=!!t.units,u=!!t.valueBox,f=void 0,m=void 0,v=void 0;l?(m=we(.05*d),f=we(.075*d),v=we(.11*d),c&&(d-=f,r+=f),h&&(d-=m),u&&(d-=v)):(m=f=we(.15*s),c&&(s-=f,r+=f),h&&(s-=m));var b=2*t.barStrokeWidth,g=t.barBeginCircle?we(s*t.barBeginCircle/200-b/2):0,p=we(s*t.barWidth/100-b),w=we(d*t.barLength/100-b),y=we((d-w)/2),k=we(i+(l?s/2:y+g)),x=we(r+(l?d-y-g+b/2:s/2)),T=!l||t.hasLeft&&t.hasRight?0:(t.hasRight?-1:1)*t.ticksWidth/100*s,S=l||t.hasLeft&&t.hasRight?0:(t.hasRight?-1:1)*t.ticksWidth/100*s;return e.barDimensions={isVertical:l,width:s,length:d,barWidth:p,barLength:w,strokeWidth:b,barMargin:y,radius:g,pixelRatio:a,barOffset:null,titleMargin:c?f:0,unitsMargin:h?m:0,get ticksLength(){return this.barLength-this.barOffset-this.strokeWidth},X:i+T,Y:r+S,x0:k+T,y0:x+S,baseX:i,baseY:r,ticksPadding:t.ticksPadding/100},e.barDimensions}function F(e,t,i,r,o,n,a){var l=G(e,t,r,o,n,a),s=l.isVertical,d=l.width,c=l.barWidth,h=l.barLength,u=l.strokeWidth,f=l.barMargin,m=l.radius,v=l.x0,b=l.y0,g=l.X,p=l.Y,w=h;if(e.save(),e.beginPath(),t.barBeginCircle){var y=Te.radians(s?270:0),k=Math.asin(c/2/m),x=Math.cos(k),T=Math.sin(k),S=v+(s?m*T:m*x-u/2),W=s?b-m*x:b+m*T,O=ye(s?W-b:S-v);e.barDimensions.barOffset=we(O+m);var V=s?we(v-m*T):S,P=s?W:we(b-m*T);"progress"===i&&(h=e.barDimensions.barOffset+(h-e.barDimensions.barOffset)*(Te.normalizedValue(t).normal-t.minValue)/(t.maxValue-t.minValue));var M=we(S+h-e.barDimensions.barOffset+u/2),A=we(W-h+e.barDimensions.barOffset-u/2);e.arc(v,b,m,y+k,y-k),s?(e.moveTo(S,P),e.lineTo(S,A),e.lineTo(V,A),e.lineTo(V,P)):(e.moveTo(S,P),e.lineTo(M,P),e.lineTo(M,W),e.lineTo(S,W))}else{var B=we(s?g+(d-c)/2:g+f),j=we(s?p+h+f:p+(d-c)/2);"progress"===i&&(h*=(t.value-t.minValue)/(t.maxValue-t.minValue)),s?e.rect(B,j,c,-h):e.rect(B,j,h,c)}"progress"!==i&&t.barStrokeWidth&&(e.lineWidth=u,e.strokeStyle=t.colorBarStroke,e.stroke()),"progress"!==i&&t.colorBar?(e.fillStyle=t.colorBarEnd?Te.linearGradient(e,t.colorBar,t.colorBarEnd,h,s,s?p:g):t.colorBar,e.fill()):"progress"===i&&t.colorBarProgress&&(e.fillStyle=t.colorBarProgressEnd?Te.linearGradient(e,t.colorBarProgress,t.colorBarProgressEnd,w,s,s?p:g):t.colorBarProgress,e.fill()),e.closePath(),t.barBeginCircle&&(e.barDimensions.radius+=u),e.barDimensions.barWidth+=u,e.barDimensions.barLength+=u}function X(e,t,i,r,o,n){F(e,t,"",i,r,o,n)}function Y(e,t){return t.needleSide!==e||t.tickSide!==e||t.numberSide!==e}function U(e,t,i,r,o,n){t.barProgress&&F(e,t,"progress",i,r,o,n)}function q(e,t){var i=e.barDimensions,r=i.isVertical,o=i.width,n=i.length,a=i.barWidth,l=i.barOffset,s=i.barMargin,d=i.X,c=i.Y,h=i.ticksLength,u=i.ticksPadding,f=o*(parseFloat(t.highlightsWidth)||0)/100;if(t.highlights&&f){var m="right"!==t.tickSide,v="left"!==t.tickSide,b=0,g=t.highlights.length,p=(o-a)/2,w=t.maxValue-t.minValue,y=we(r?d+p:d+s+l),k=f,x=r?c+n-s-l:c+p,T=we((t.ticksWidth/100+u)*o)+(f-t.ticksWidth/100*o),S=we(a+u*o);for(e.save();b<g;b++){var W=t.highlights[b],O=h*ye(t.minValue-W.from)/w,V=h*ye((W.to-W.from)/w);e.beginPath(),e.fillStyle=W.color,r?(m&&e.rect(y-T,x-O,k,-V),v&&e.rect(y+S,x-O,k,-V)):(m&&e.rect(y+O,x-T,V,k),v&&e.rect(y+O,x+S,V,k)),e.fill(),e.closePath()}}}function H(e,t,i,r,o){e.beginPath(),e.moveTo(t,i),e.lineTo(r,o),e.stroke(),e.closePath(),e.save()}function J(e,t,i,r,o,n,a,l,s){var d=e.barDimensions,c=d.isVertical,h=d.length,u=d.barWidth,f=d.barOffset,m=d.barMargin,v=d.pixelRatio,b=d.width,g=d.X,p=d.Y,w=d.ticksLength,y=d.ticksPadding,k=(b-u)/2,x=void 0,T=void 0,S=0,W=i.length,O=void 0,V=s*b,P=k-y*b,M=k+u+V+y*b,A=t instanceof Array?t:new Array(i.length).fill(t);e.lineWidth=l*v,e.save();for(var B=w/(o-r);S<W;S++)O=i[S],e.strokeStyle=A[S],c?(T=p+h-m-f+(r-O)*B,n&&(x=g+P,H(e,x,T,we(x-V),T)),a&&(x=g+M,H(e,x,T,we(x-V),T))):(x=g+m+f-(r-O)*B,n&&(T=p+P,H(e,x,T,x,we(T-V))),a&&(T=p+M,H(e,x,we(T),x,T-V)))}function $(e,t){var i=Te.prepareTicks(t),r=le(i,2),o=r[0],n=r[1],a=2,l=(t.maxValue-t.minValue)/(t.majorTicks.length-1),s=t.colorMajorTicks instanceof Array?t.colorMajorTicks:new Array(t.majorTicks.length).fill(t.colorStrokeTicks||t.colorMajorTicks);if(J(e,s,t.exactTicks?t.majorTicks:t.majorTicks.map(function(e,i){return t.minValue+l*i}),t.minValue,t.maxValue,o,n,a,t.ticksWidth/100),t.strokeTicks){var d=e.barDimensions,c=d.isVertical,h=d.length,u=d.width,f=d.barWidth,m=d.barMargin,v=d.barOffset,b=d.X,g=d.Y,p=d.ticksLength,w=d.pixelRatio,y=d.ticksPadding,k=(u-f)/2+f+y*u,x=(u-f)/2-y*u,T=void 0,S=void 0,W=void 0,O=void 0;e.strokeStyle=t.colorStrokeTicks||s[0],a*=w,c?(S=g+h-m-v+a/2,O=S-p-a,o&&(W=T=we(b+x),Z(e,T,S,W,O)),n&&(W=T=we(b+k),Z(e,T,S,W,O))):(T=b+m+v-a/2,W=T+p+a,o&&(O=S=we(g+x),Z(e,T,S,W,O)),n&&(O=S=we(g+k),Z(e,T,S,W,O)))}}function Z(e,t,i,r,o){e.beginPath(),e.moveTo(t,i),e.lineTo(r,o),e.stroke(),e.closePath()}function K(e,t){var i=Te.prepareTicks(t),r=le(i,2),o=r[0],n=r[1],a=[],l=t.minValue,s=Math.abs(t.minorTicks)||0,d=s?(t.maxValue-t.minValue)/(s*(t.majorTicks.length-1)):0;if(s)if(t.exactTicks)for(var c=xe.mod(t.majorTicks[0],s)||0;l<t.maxValue;l+=s)c+l<t.maxValue&&a.push(c+l);else for(;l<t.maxValue;l+=d)a.push(l);J(e,t.colorMinorTicks||t.colorStrokeTicks,a,t.minValue,t.maxValue,o,n,1,t.ticksWidthMinor/100)}function Q(e,t){var i=e.barDimensions,r=i.isVertical,o=i.length,n=i.width,a=i.barWidth,l=i.barMargin,s=i.barOffset,d=i.X,c=i.Y,h=i.ticksLength,u=i.ticksPadding,f=t.maxValue-t.minValue,m=f/(t.majorTicks.length-1),v=t.exactTicks?t.majorTicks:t.majorTicks.map(function(e,i){return t.minValue+m*i}),b=v.length,g="right"!==t.numberSide,p="left"!==t.numberSide,w=t.fontNumbersSize*n/200,y=0,k=(t.ticksWidth/100+2*u)*n,x=(n-a)/2-k,T=(n-a)/2+a+k,S=void 0,W=void 0,O=void 0,V=void 0,P=t.colorNumbers instanceof Array?t.colorNumbers:new Array(b).fill(t.colorNumbers),M=t.numbersMargin/100*n;for(e.font=Te.font(t,"Numbers",n/200),e.lineWidth=0,e.textAlign="center";y<b;y++)e.fillStyle=P[y],V=t.majorTicks[y],O=t.exactTicks?h*((v[y]-t.minValue)/f):y*h/(b-1),r?(W=c+o-l-s-O+w/3,g&&(e.textAlign="right",e.fillText(V,d+x-M,W)),p&&(e.textAlign="left",e.fillText(V,d+T+M,W))):(e.measureText(V).width,S=d+l+s+O,g&&e.fillText(V,S,c+x-M),p&&e.fillText(V,S,c+T+w+M))}function ee(e,t){if(t.title){var i=e.barDimensions,r=i.isVertical,o=i.width,n=i.length,a=i.baseX,l=i.baseY,s=i.titleMargin,d=t.fontTitleSize*o/200,c=we(a+(r?o:n)/2),h=we(l+s/2-(r?d:d/2)-.025*(r?n:o));e.save(),e.textAlign="center",e.fillStyle=t.colorTitle,e.font=Te.font(t,"Title",o/200),e.lineWidth=0,e.fillText(t.title,c,h,r?o:n)}}function te(e,t){if(t.units){var i=e.barDimensions,r=i.isVertical,o=i.width,n=i.length,a=i.baseX,l=i.baseY,s=i.unitsMargin,d=t.fontUnitsSize*o/200,c=we(a+(r?o:n)/2),h=we(l+(r?n:o)+s/2-d/2);e.save(),e.textAlign="center",e.fillStyle=t.colorUnits,e.font=Te.font(t,"Units",o/200),e.lineWidth=0,e.fillText(t.units,c,h,r?o:n)}}function ie(e,t){if(t.needle){var i=e.barDimensions,r=i.isVertical,o=i.width,n=i.length,a=i.barWidth,l=i.barOffset,s=i.barMargin,d=i.ticksLength,c=i.X,h=i.Y,u=i.ticksPadding,f="right"!==t.needleSide,m="left"!==t.needleSide,v=d*(Te.normalizedValue(t).indented-t.minValue)/(t.maxValue-t.minValue),b=(t.ticksWidth/100+u)*o,g=a/2+b,p=g*(t.needleEnd/100),w=void 0,y=void 0,k=void 0,x=void 0,T="arrow"===t.needleType.toLowerCase()?ne:oe,S=(o-a)/2,W=g*(t.needleStart/100),O=S-b-W,V=S+a+b+W;e.save(),Te.drawNeedleShadow(e,t),r?(k=we(h+n-s-l-v),f&&(w=we(c+O),y=w+p,T(e,t,w,k,y,k,p)),m&&(w=we(c+V),y=w-p,T(e,t,w,k,y,k,p,!0))):(w=we(c+s+l+v),f&&(k=we(h+O),x=k+p,T(e,t,w,k,w,x,p)),m&&(k=we(h+V),x=k-p,T(e,t,w,k,w,x,p,!0))),e.restore()}}function re(e,t,i,r){return t.colorNeedleEnd?Te.linearGradient(e,r?t.colorNeedleEnd:t.colorNeedle,r?t.colorNeedle:t.colorNeedleEnd,i,!e.barDimensions.isVertical):t.colorNeedle}function oe(e,t,i,r,o,n,a,l){e.lineWidth=t.needleWidth,e.strokeStyle=re(e,t,a,l),e.beginPath(),e.moveTo(i,r),e.lineTo(o,n),e.stroke(),e.closePath()}function ne(e,t,i,r,o,n,a,l){var s=we(.4*a),d=a-s,c=i===o,h=t.needleWidth/2;e.fillStyle=re(e,t,a,l),e.beginPath(),c?(r>n&&(d*=-1),e.moveTo(i-h,r),e.lineTo(i+h,r),e.lineTo(i+h,r+d),e.lineTo(i,n),e.lineTo(i-h,r+d),e.lineTo(i-h,r)):(i>o&&(d*=-1),e.moveTo(i,r-h),e.lineTo(i,r+h),e.lineTo(i+d,r+h),e.lineTo(o,r),e.lineTo(i+d,r-h),e.lineTo(i,r-h)),e.fill(),e.closePath()}function ae(e,t,i,r,o,n,a){var l=(parseFloat(t.fontValueSize)||0)*n/200,s=(.11*a-l)/2;e.barDimensions.isVertical&&Te.drawValueBox(e,t,i,r+n/2,o+a-l-s,n)}var le=function(){function e(e,t){var i=[],r=!0,o=!1,n=void 0;try{for(var a,l=e[Symbol.iterator]();!(r=(a=l.next()).done)&&(i.push(a.value),!t||i.length!==t);r=!0);}catch(e){o=!0,n=e}finally{try{!r&&l.return&&l.return()}finally{if(o)throw n}}return i}return function(t,i){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,i);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),se=function e(t,i,r){null===t&&(t=Function.prototype);var o=Object.getOwnPropertyDescriptor(t,i);if(void 0===o){var n=Object.getPrototypeOf(t);return null===n?void 0:e(n,i,r)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(r)},de=function e(t,i,r,o){var n=Object.getOwnPropertyDescriptor(t,i);if(void 0===n){var a=Object.getPrototypeOf(t);null!==a&&e(a,i,r,o)}else if("value"in n&&n.writable)n.value=r;else{var l=n.set;void 0!==l&&l.call(o,r)}return r},ce=function(){function e(e,t){for(var i=0;i<t.length;i++){var r=t[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,i,r){return i&&e(t.prototype,i),r&&e(t,r),t}}();Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:function(e,t){if(void 0===e||null===e)throw new TypeError("Cannot convert first argument to object");for(var i=Object(e),r=1;r<arguments.length;r++){var o=arguments[r];if(void 0!==o&&null!==o)for(var n=Object.keys(Object(o)),a=0,l=n.length;a<l;a++){var s=n[a],d=Object.getOwnPropertyDescriptor(o,s);void 0!==d&&d.enumerable&&(i[s]=o[s])}}return i}}),Array.prototype.indexOf||Object.defineProperty(Array.prototype,"indexOf",{value:function(e,t){var i;if(null===this)throw new TypeError('"this" is null or not defined');var r=Object(this),o=r.length>>>0;if(0===o)return-1;var n=+t||0;if(Math.abs(n)===1/0&&(n=0),n>=o)return-1;for(i=Math.max(n>=0?n:o-Math.abs(n),0);i<o;){if(i in r&&r[i]===e)return i;i++}return-1}}),Array.prototype.fill||Object.defineProperty(Array.prototype,"fill",{value:function(e){if(null===this)throw new TypeError("this is null or not defined");for(var t=Object(this),i=t.length>>>0,r=arguments[1],o=r>>0,n=o<0?Math.max(i+o,0):Math.min(o,i),a=arguments[2],l=void 0===a?i:a>>0,s=l<0?Math.max(i+l,0):Math.min(l,i);n<s;)t[n]=e,n++;return t}}),"undefined"==typeof window&&(window="undefined"==typeof global?{}:global);var he=function(){function e(){o(this,e),this._events={},this.addListener=this.on,this.removeListener=this.off}return ce(e,[{key:"emit",value:function(e){if(this._events[e]){for(var t=0,i=this._events[e].length,r=arguments.length,o=Array(r>1?r-1:0),n=1;n<r;n++)o[n-1]=arguments[n];for(;t<i;t++)this._events[e][t]&&this._events[e][t].apply(this,o)}}},{key:"once",value:function(e){for(var t=arguments.length,i=Array(t>1?t-1:0),r=1;r<t;r++)i[r-1]=arguments[r];for(var o=0,n=i.length,a=this;o<n;o++)!function(){var t=i[o],r=function i(){a.off(e,i),t.apply(a,arguments)};i[o]=r}();this.on.apply(this,[e].concat(i))}},{key:"on",value:function(e){this._events[e]||(this._events[e]=[]);for(var t=0,i=arguments.length<=1?0:arguments.length-1;t<i;t++)this._events[e].push(arguments.length<=t+1?void 0:arguments[t+1])}},{key:"off",value:function(e){if(this._events[e])for(var t=0,i=arguments.length<=1?0:arguments.length-1;t<i;t++)for(var r=arguments.length<=t+1?void 0:arguments[t+1],o=void 0;~(o=this._events[e].indexOf(r));)this._events[e].splice(o,1)}},{key:"removeAllListeners",value:function(e){delete this._events[e]}},{key:"listeners",get:function(){return this._events}}]),e}(),ue=n("requestAnimationFrame")||function(e){return setTimeout(function(){return e((new Date).getTime())},1e3/60)},fe={linear:function(e){return e},quad:function(e){return Math.pow(e,2)},dequad:function(e){return 1-fe.quad(1-e)},quint:function(e){return Math.pow(e,5)},dequint:function(e){return 1-Math.pow(1-e,5)},cycle:function(e){return 1-Math.sin(Math.acos(e))},decycle:function(e){return Math.sin(Math.acos(1-e))},bounce:function(e){return 1-fe.debounce(1-e)},debounce:function(e){for(var t=0,i=1;1;t+=i,i/=2)if(e>=(7-4*t)/11)return-Math.pow((11-6*t-11*e)/4,2)+Math.pow(i,2)},elastic:function(e){return 1-fe.delastic(1-e)},delastic:function(e){return Math.pow(2,10*(e-1))*Math.cos(20*Math.PI*1.5/3*e)}},me=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"linear",i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:250,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:function(){},n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:function(){};if(o(this,e),this.duration=i,this.rule=t,this.draw=r,this.end=n,"function"!=typeof this.draw)throw new TypeError("Invalid animation draw callback:",r);if("function"!=typeof this.end)throw new TypeError("Invalid animation end callback:",n)}return ce(e,[{key:"animate",value:function(e,t){var i=this;this.frame&&this.cancel();var r=window.performance&&window.performance.now?window.performance.now():n("animationStartTime")||Date.now();e=e||this.draw,t=t||this.end,this.draw=e,this.end=t,this.frame=ue(function(o){return a(o,e,r,fe[i.rule]||i.rule,i.duration,t,i)})}},{key:"cancel",value:function(){if(this.frame){(n("cancelAnimationFrame")||function(e){})(this.frame),this.frame=null}}},{key:"destroy",value:function(){this.cancel(),this.draw=null,this.end=null}}]),e}();me.rules=fe;var ve=function(){function t(i,r,n){o(this,t),this.options=i,this.element=r.toLowerCase(),this.type=t.toDashed(n),this.Type=e[n],this.mutationsObserved=!1,this.isObservable=!!window.MutationObserver,window.GAUGES_NO_AUTO_INIT||t.domReady(this.traverse.bind(this))}return ce(t,[{key:"isValidNode",value:function(e){return!(!e.tagName||e.tagName.toLowerCase()!==this.element||e.getAttribute("data-type")!==this.type)}},{key:"traverse",value:function(){for(var e=document.getElementsByTagName(this.element),t=0,i=e.length;t<i;t++)this.process(e[t]);this.isObservable&&!this.mutationsObserved&&(new MutationObserver(this.observe.bind(this)).observe(document.body,{childList:!0,subtree:!0,attributes:!0,characterData:!0,attributeOldValue:!0,characterDataOldValue:!0}),this.mutationsObserved=!0)}},{key:"observe",value:function(e){for(var t=0,i=e.length;t<i;t++){var r=e[t];if("attributes"===r.type&&"data-type"===r.attributeName&&this.isValidNode(r.target)&&r.oldValue!==this.type)setTimeout(this.process.bind(this,r.target));else if(r.addedNodes&&r.addedNodes.length)for(var o=0,n=r.addedNodes.length;o<n;o++)setTimeout(this.process.bind(this,r.addedNodes[o]))}}},{key:"process",value:function(e){var i=this;if(!this.isValidNode(e))return null;var r=void 0,o=JSON.parse(JSON.stringify(this.options)),n=null;for(r in o)if(o.hasOwnProperty(r)){var a=t.toAttributeName(r),l=t.parse(e.getAttribute(a));null!==l&&void 0!==l&&(o[r]=l)}return o.renderTo=e,n=new this.Type(o),n.draw&&n.draw(),this.isObservable?(n.observer=new MutationObserver(function(r){r.forEach(function(r){if("attributes"===r.type){var o=r.attributeName.toLowerCase(),a=e.getAttribute(o).toLowerCase();if("data-type"===o&&a&&a!==i.type)n.observer.disconnect(),delete n.observer,n.destroy&&n.destroy();else if("data-"===o.substr(0,5)){var l=o.substr(5).split("-").map(function(e,t){return t?e.charAt(0).toUpperCase()+e.substr(1):e}).join(""),s={};s[l]=t.parse(e.getAttribute(r.attributeName)),"value"===l?n&&(n.value=s[l]):n.update&&n.update(s)}}})}),n.observer.observe(e,{attributes:!0}),n):n}}],[{key:"parse",value:function(e){if("true"===e)return!0;if("false"===e)return!1;if("undefined"!==e){if("null"===e)return null;if(/^[-+#.\w\d\s]+(?:,[-+#.\w\d\s]*)+$/.test(e))return e.split(",");try{return JSON.parse(e)}catch(e){}return e}}},{key:"toDashed",value:function(e){for(var t=e.split(/(?=[A-Z])/),i=1,r=t.length,o=t[0].toLowerCase();i<r;i++)o+="-"+t[i].toLowerCase();return o}},{key:"toCamelCase",value:function(e){for(var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=e.split(/-/),r=0,o=i.length,n="";r<o;r++)n+=r||t?i[r][0].toUpperCase()+i[r].substr(1).toLowerCase():i[r].toLowerCase();return n}},{key:"toAttributeName",value:function(e){return"data-"+t.toDashed(e)}},{key:"domReady",value:function(e){if(/comp|inter|loaded/.test((window.document||{}).readyState+""))return e();window.addEventListener?window.addEventListener("DOMContentLoaded",e,!1):window.attachEvent&&window.attachEvent("onload",e)}}]),t}(),be=function(){function e(t,i,r){o(this,e),e.collection.push(this),this.width=i||0,this.height=r||0,this.element=t,this.init()}return ce(e,[{key:"init",value:function(){var t=e.pixelRatio;this.element.width=this.width*t,this.element.height=this.height*t,this.element.style.width=this.width+"px",this.element.style.height=this.height+"px",this.elementClone=this.element.cloneNode(!0),this.context=this.element.getContext("2d"),this.contextClone=this.elementClone.getContext("2d"),this.drawWidth=this.element.width,this.drawHeight=this.element.height,this.drawX=this.drawWidth/2,this.drawY=this.drawHeight/2,this.minSide=this.drawX<this.drawY?this.drawX:this.drawY,this.elementClone.initialized=!1,this.contextClone.translate(this.drawX,this.drawY),this.contextClone.save(),this.context.translate(this.drawX,this.drawY),this.context.save(),this.context.max=this.contextClone.max=this.minSide,this.context.maxRadius=this.contextClone.maxRadius=null}},{key:"destroy",value:function(){var t=e.collection.indexOf(this);~t&&e.collection.splice(t,1),this.context.clearRect(-this.drawX,-this.drawY,this.drawWidth,this.drawHeight),this.context.max=null,delete this.context.max,this.context.maxRadius=null,delete this.context.maxRadius,this.context=null,this.contextClone=null,this.elementClone=null,this.element=null,this.onRedraw=null}},{key:"commit",value:function(){var t=e.pixelRatio;return 1!==t&&(this.contextClone.scale(t,t),this.contextClone.save()),this}},{key:"redraw",value:function(){return this.init(),this.onRedraw&&this.onRedraw(),this}}],[{key:"redraw",value:function(){for(var t=0,i=e.collection.length;t<i;t++)e.collection[t].redraw()}},{key:"pixelRatio",get:function(){return window.devicePixelRatio||1}}]),e}();be.collection=[],window.matchMedia&&window.matchMedia("screen and (min-resolution: 2dppx)").addListener(be.redraw);var ge={renderTo:null,width:0,height:0,minValue:0,maxValue:100,value:0,units:!1,exactTicks:!1,majorTicks:[0,20,40,60,80,100],minorTicks:10,strokeTicks:!0,animatedValue:!1,animateOnInit:!1,title:!1,borders:!0,numbersMargin:1,listeners:null,valueInt:3,valueDec:2,majorTicksInt:1,majorTicksDec:0,animation:!0,animationDuration:500,animationRule:"cycle",colorPlate:"#fff",colorPlateEnd:"",colorMajorTicks:"#444",
	colorMinorTicks:"#666",colorStrokeTicks:"",colorTitle:"#888",colorUnits:"#888",colorNumbers:"#444",colorNeedle:"rgba(240,128,128,1)",colorNeedleEnd:"rgba(255,160,122,.9)",colorValueText:"#444",colorValueTextShadow:"rgba(0,0,0,0.3)",colorBorderShadow:"rgba(0,0,0,0.5)",colorBorderOuter:"#ddd",colorBorderOuterEnd:"#aaa",colorBorderMiddle:"#eee",colorBorderMiddleEnd:"#f0f0f0",colorBorderInner:"#fafafa",colorBorderInnerEnd:"#ccc",colorValueBoxRect:"#888",colorValueBoxRectEnd:"#666",colorValueBoxBackground:"#babab2",colorValueBoxShadow:"rgba(0,0,0,1)",colorNeedleShadowUp:"rgba(2,255,255,0.2)",colorNeedleShadowDown:"rgba(188,143,143,0.45)",colorBarStroke:"#222",colorBar:"#ccc",colorBarProgress:"#888",colorBarShadow:"#000",fontNumbers:"Arial",fontTitle:"Arial",fontUnits:"Arial",fontValue:"Arial",fontNumbersSize:20,fontTitleSize:24,fontUnitsSize:22,fontValueSize:26,fontNumbersStyle:"normal",fontTitleStyle:"normal",fontUnitsStyle:"normal",fontValueStyle:"normal",fontNumbersWeight:"normal",fontTitleWeight:"normal",fontUnitsWeight:"normal",fontValueWeight:"normal",needle:!0,needleShadow:!0,needleType:"arrow",needleStart:5,needleEnd:85,needleWidth:4,borderOuterWidth:3,borderMiddleWidth:3,borderInnerWidth:3,borderShadowWidth:3,valueBox:!0,valueBoxStroke:5,valueBoxWidth:0,valueText:"",valueTextShadow:!0,valueBoxBorderRadius:2.5,highlights:[{from:20,to:60,color:"#eee"},{from:60,to:80,color:"#ccc"},{from:80,to:100,color:"#999"}],highlightsWidth:15,barWidth:20,barStrokeWidth:0,barProgress:!0,barShadow:0};l.prototype=Object.create(Array.prototype),l.prototype.constructor=l,l.prototype.get=function(e){if("string"==typeof e)for(var t=0,i=this.length;t<i;t++){var r=this[t].options.renderTo.tagName?this[t].options.renderTo:document.getElementById(this[t].options.renderTo||"");if(r.getAttribute("id")===e)return this[t]}else if("number"==typeof e)return this[e];return null};var pe="2.1.5",we=Math.round,ye=Math.abs,ke=new l;ke.version=pe;var xe=function(t){function n(t){o(this,n);var r=i(this,(n.__proto__||Object.getPrototypeOf(n)).call(this)),a=r.constructor.name;if("BaseGauge"===a)throw new TypeError("Attempt to instantiate abstract class!");if(ke.push(r),t.listeners&&Object.keys(t.listeners).forEach(function(e){(t.listeners[e]instanceof Array?t.listeners[e]:[t.listeners[e]]).forEach(function(t){r.on(e,t)})}),r.version=pe,r.type=e[a]||n,r.initialized=!1,t.minValue=parseFloat(t.minValue),t.maxValue=parseFloat(t.maxValue),t.value=parseFloat(t.value)||0,t.borders||(t.borderInnerWidth=t.borderMiddleWidth=t.borderOuterWidth=0),!t.renderTo)throw TypeError("Canvas element was not specified when creating the Gauge object!");var l=t.renderTo.tagName?t.renderTo:document.getElementById(t.renderTo);if(!(l instanceof HTMLCanvasElement))throw TypeError("Given gauge canvas element is invalid!");return t.width=parseFloat(t.width)||0,t.height=parseFloat(t.height)||0,t.width&&t.height||(t.width||(t.width=l.parentNode?l.parentNode.offsetWidth:l.offsetWidth),t.height||(t.height=l.parentNode?l.parentNode.offsetHeight:l.offsetHeight)),r.options=t||{},r.options.animateOnInit&&(r._value=r.options.value,r.options.value=r.options.minValue),r.canvas=new be(l,t.width,t.height),r.canvas.onRedraw=r.draw.bind(r),r.animation=new me(t.animationRule,t.animationDuration),r}return r(n,t),ce(n,[{key:"update",value:function(e){return Object.assign(this.options,this.type.configure(e||{})),this.canvas.width=this.options.width,this.canvas.height=this.options.height,this.animation.rule=this.options.animationRule,this.animation.duration=this.options.animationDuration,this.canvas.redraw(),this}},{key:"destroy",value:function(){var e=ke.indexOf(this);~e&&ke.splice(e,1),this.canvas.destroy(),this.canvas=null,this.animation.destroy(),this.animation=null,this.emit("destroy")}},{key:"draw",value:function(){return this.options.animateOnInit&&!this.initialized&&(this.value=this._value,this.initialized=!0,this.emit("init")),this.emit("render"),this}},{key:"value",set:function(e){var t=this;e=n.ensureValue(e,this.options.minValue);var i=this.options.value;if(e!==i)if(this.options.animation){if(this.animation.frame&&(this.options.value=this._value,this._value===e))return this.animation.cancel(),void delete this._value;void 0===this._value&&(this._value=e),this.emit("animationStart"),this.animation.animate(function(r){var o=i+(e-i)*r;t.options.animatedValue&&t.emit("value",o,t.value),t.options.value=o,t.draw(),t.emit("animate",r,t.options.value)},function(){void 0!==t._value&&(t.emit("value",t._value,t.value),t.options.value=t._value,delete t._value),t.draw(),t.emit("animationEnd")})}else this.emit("value",e,this.value),this.options.value=e,this.draw()},get:function(){return void 0===this._value?this.options.value:this._value}}],[{key:"configure",value:function(e){return e}},{key:"initialize",value:function(e,t){return new ve(t,"canvas",e)}},{key:"fromElement",value:function(e){var t=ve.toCamelCase(e.getAttribute("data-type")),i=e.attributes,r=0,o=i.length,n={};if(t){for(/Gauge$/.test(t)||(t+="Gauge");r<o;r++)n[ve.toCamelCase(i[r].name.replace(/^data-/,""),!1)]=ve.parse(i[r].value);new ve(n,e.tagName,t).process(e)}}},{key:"ensureValue",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e=parseFloat(e),!isNaN(e)&&isFinite(e)||(e=parseFloat(t)||0),e}},{key:"mod",value:function(e,t){return(e%t+t)%t}},{key:"version",get:function(){return pe}}]),n}(he);void 0!==e&&(e.BaseGauge=xe,e.gauges=(window.document||{}).gauges=ke);var Te={roundRect:c,padValue:h,formatMajorTickNumber:u,radians:f,radialPoint:m,linearGradient:v,drawNeedleShadow:g,drawValueBox:k,verifyError:s,prepareTicks:d,drawShadow:b,font:p,normalizedValue:x},Se=Math.PI,We=Se/2,Oe=Object.assign({},ge,{ticksAngle:270,startAngle:45,colorNeedleCircleOuter:"#f0f0f0",colorNeedleCircleOuterEnd:"#ccc",colorNeedleCircleInner:"#e8e8e8",colorNeedleCircleInnerEnd:"#f5f5f5",needleCircleSize:10,needleCircleInner:!0,needleCircleOuter:!0,needleStart:20,animationTarget:"needle",useMinPath:!1,barWidth:0}),Ve=function(e){function t(e){return o(this,t),e=Object.assign({},Oe,e||{}),i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,t.configure(e)))}return r(t,e),ce(t,[{key:"draw",value:function(){try{var e=this.canvas,i=[-e.drawX,-e.drawY,e.drawWidth,e.drawHeight],r=i[0],o=i[1],n=i[2],a=i[3],l=this.options;if("needle"===l.animationTarget){if(!e.elementClone.initialized){var s=e.contextClone;s.clearRect(r,o,n,a),s.save(),this.emit("beforePlate"),W(s,l),this.emit("beforeHighlights"),O(s,l),this.emit("beforeMinorTicks"),V(s,l),this.emit("beforeMajorTicks"),M(s,l),this.emit("beforeNumbers"),j(s,l),this.emit("beforeTitle"),C(s,l),this.emit("beforeUnits"),N(s,l),e.elementClone.initialized=!0}this.canvas.commit(),e.context.clearRect(r,o,n,a),e.context.save(),e.context.drawImage(e.elementClone,r,o,n,a),e.context.save(),this.emit("beforeProgressBar"),R(e.context,l),this.emit("beforeValueBox"),_(e.context,l,I(this)),this.emit("beforeNeedle"),E(e.context,l)}else{var d=-Te.radians((l.value-l.minValue)/(l.maxValue-l.minValue)*l.ticksAngle);if(e.context.clearRect(r,o,n,a),e.context.save(),this.emit("beforePlate"),W(e.context,l),e.context.rotate(d),this.emit("beforeHighlights"),O(e.context,l),this.emit("beforeMinorTicks"),V(e.context,l),this.emit("beforeMajorTicks"),M(e.context,l),this.emit("beforeNumbers"),j(e.context,l),this.emit("beforeProgressBar"),R(e.context,l),e.context.rotate(-d),e.context.save(),!e.elementClone.initialized){var c=e.contextClone;c.clearRect(r,o,n,a),c.save(),this.emit("beforeTitle"),C(c,l),this.emit("beforeUnits"),N(c,l),this.emit("beforeNeedle"),E(c,l),e.elementClone.initialized=!0}e.context.drawImage(e.elementClone,r,o,n,a)}this.emit("beforeValueBox"),_(e.context,l,I(this)),se(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"draw",this).call(this)}catch(e){Te.verifyError(e)}return this}},{key:"value",set:function(e){e=xe.ensureValue(e,this.options.minValue),this.options.animation&&360===this.options.ticksAngle&&this.options.useMinPath&&(this._value=e,e=this.options.value+((e-this.options.value)%360+540)%360-180),de(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"value",e,this)},get:function(){return se(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"value",this)}}],[{key:"configure",value:function(e){return e.barWidth>50&&(e.barWidth=50),isNaN(e.startAngle)&&(e.startAngle=45),isNaN(e.ticksAngle)&&(e.ticksAngle=270),e.ticksAngle>360&&(e.ticksAngle=360),e.ticksAngle<0&&(e.ticksAngle=0),e.startAngle<0&&(e.startAngle=0),e.startAngle>360&&(e.startAngle=360),e}}]),t}(xe);void 0!==e&&(e.RadialGauge=Ve),xe.initialize("RadialGauge",Oe);var Pe=Object.assign({},ge,{borderRadius:0,barBeginCircle:30,colorBarEnd:"",colorBarProgressEnd:"",needleWidth:6,tickSide:"both",needleSide:"both",numberSide:"both",ticksWidth:10,ticksWidthMinor:5,ticksPadding:5,barLength:85,fontTitleSize:26,highlightsWidth:10}),Me=function(e){function n(e){return o(this,n),e=Object.assign({},Pe,e||{}),i(this,(n.__proto__||Object.getPrototypeOf(n)).call(this,n.configure(e)))}return r(n,e),ce(n,[{key:"draw",value:function(){try{var e=this.canvas,i=[-e.drawX,-e.drawY,e.drawWidth,e.drawHeight],r=i[0],o=i[1],a=i[2],l=i[3],s=this.options;if(!e.elementClone.initialized){var d=e.contextClone;d.clearRect(r,o,a,l),d.save(),this.emit("beforePlate"),this.drawBox=L(d,s,r,o,a,l),this.emit("beforeBar"),X.apply(void 0,[d,s].concat(t(this.drawBox))),e.context.barDimensions=d.barDimensions,this.emit("beforeHighlights"),q(d,s),this.emit("beforeMinorTicks"),K(d,s),this.emit("beforeMajorTicks"),$(d,s),this.emit("beforeNumbers"),Q(d,s),this.emit("beforeTitle"),ee(d,s),this.emit("beforeUnits"),te(d,s),e.elementClone.initialized=!0}this.canvas.commit(),e.context.clearRect(r,o,a,l),e.context.save(),e.context.drawImage(e.elementClone,r,o,a,l),e.context.save(),this.emit("beforeProgressBar"),U.apply(void 0,[e.context,s].concat(t(this.drawBox))),this.emit("beforeNeedle"),ie(e.context,s),this.emit("beforeValueBox"),ae.apply(void 0,[e.context,s,s.animatedValue?this.options.value:this.value].concat(t(this.drawBox))),se(n.prototype.__proto__||Object.getPrototypeOf(n.prototype),"draw",this).call(this)}catch(e){Te.verifyError(e)}return this}}],[{key:"configure",value:function(e){return e.barStrokeWidth>=e.barWidth&&(e.barStrokeWidth=we(e.barWidth/2)),e.hasLeft=Y("right",e),e.hasRight=Y("left",e),e.value>e.maxValue&&(e.value=e.maxValue),e.value<e.minValue&&(e.value=e.minValue),xe.configure(e)}}]),n}(xe);void 0!==e&&(e.LinearGauge=Me),xe.initialize("LinearGauge",Pe),"undefined"!=typeof module&&Object.assign(e,{Collection:l,GenericOptions:ge,Animation:me,BaseGauge:xe,drawings:Te,SmartCanvas:be,DomObserver:ve,vendorize:n})}( true?module.exports:window);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(298);
	var enumBugKeys = __webpack_require__(178);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(177);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(44);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(321),
	    baseKeys = __webpack_require__(919),
	    isArrayLike = __webpack_require__(138);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(1009);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(1029);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addHours = addHours;
	exports.addMinutes = addMinutes;
	exports.addSeconds = addSeconds;
	exports.formatTime = formatTime;
	exports.rad2deg = rad2deg;
	exports.getTouchEventOffsetValues = getTouchEventOffsetValues;
	exports.isInner = isInner;
	function addHours(d, hours) {
	  var newDate = clone(d);
	  newDate.setHours(d.getHours() + hours);
	  return newDate;
	}
	
	function addMinutes(d, minutes) {
	  var newDate = clone(d);
	  newDate.setMinutes(d.getMinutes() + minutes);
	  return newDate;
	}
	
	function addSeconds(d, seconds) {
	  var newDate = clone(d);
	  newDate.setSeconds(d.getMinutes() + seconds);
	  return newDate;
	}
	
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * @param date [Date] A Date object.
	 * @param format [String] One of 'ampm', '24hr', defaults to 'ampm'.
	 * @param pedantic [Boolean] Check time-picker/time-picker.jsx file.
	 *
	 * @return String A string representing the formatted time.
	 */
	function formatTime(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ampm';
	  var pedantic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!date) return '';
	  var hours = date.getHours();
	  var mins = date.getMinutes().toString();
	
	  if (format === 'ampm') {
	    var isAM = hours < 12;
	    hours = hours % 12;
	    var additional = isAM ? ' am' : ' pm';
	    hours = (hours || 12).toString();
	
	    if (mins.length < 2) mins = '0' + mins;
	
	    if (pedantic) {
	      // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	      if (hours === '12' && mins === '00') {
	        return additional === ' pm' ? '12 noon' : '12 midnight';
	      }
	    }
	
	    return hours + (mins === '00' ? '' : ':' + mins) + additional;
	  }
	
	  hours = hours.toString();
	
	  if (hours.length < 2) hours = '0' + hours;
	  if (mins.length < 2) mins = '0' + mins;
	
	  return hours + ':' + mins;
	}
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(event) {
	  var el = event.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  return {
	    offsetX: event.clientX - boundingRect.left,
	    offsetY: event.clientY - boundingRect.top
	  };
	}
	
	function isInner(props) {
	  if (props.type !== 'hour') {
	    return false;
	  }
	  return props.value < 1 || props.value > 12;
	}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createChildFragment = createChildFragment;
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(1594);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createChildFragment(fragments) {
	  var newFragments = {};
	  var validChildrenCount = 0;
	  var firstKey = void 0;
	
	  // Only create non-empty key fragments
	  for (var key in fragments) {
	    var currentChild = fragments[key];
	
	    if (currentChild) {
	      if (validChildrenCount === 0) firstKey = key;
	      newFragments[key] = currentChild;
	      validChildrenCount++;
	    }
	  }
	
	  if (validChildrenCount === 0) return undefined;
	  if (validChildrenCount === 1) return newFragments[firstKey];
	  return (0, _reactAddonsCreateFragment2.default)(newFragments);
	}
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	'use strict';
	
	CustomerService.$inject = ["$http", "$q", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.customer', []).factory('customerService', CustomerService).name;
	
	/*@ngInject*/
	
	function CustomerService($http, $q, types) {
	
	    var service = {
	        getCustomers: getCustomers,
	        getCustomer: getCustomer,
	        getShortCustomerInfo: getShortCustomerInfo,
	        applyAssignedCustomersInfo: applyAssignedCustomersInfo,
	        applyAssignedCustomerInfo: applyAssignedCustomerInfo,
	        deleteCustomer: deleteCustomer,
	        saveCustomer: saveCustomer
	    };
	
	    return service;
	
	    function getCustomers(pageLink, config) {
	        var deferred = $q.defer();
	        var url = '/api/customers?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getCustomer(customerId, config) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId;
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function getShortCustomerInfo(customerId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/shortInfo';
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function applyAssignedCustomersInfo(items) {
	        var deferred = $q.defer();
	        var assignedCustomersMap = {};
	        function loadNextCustomerInfoOrComplete(i) {
	            i++;
	            if (i < items.length) {
	                loadNextCustomerInfo(i);
	            } else {
	                deferred.resolve(items);
	            }
	        }
	
	        function loadNextCustomerInfo(i) {
	            var item = items[i];
	            item.assignedCustomer = {};
	            if (item.customerId && item.customerId.id != types.id.nullUid) {
	                item.assignedCustomer.id = item.customerId.id;
	                var assignedCustomer = assignedCustomersMap[item.customerId.id];
	                if (assignedCustomer) {
	                    item.assignedCustomer = assignedCustomer;
	                    loadNextCustomerInfoOrComplete(i);
	                } else {
	                    getShortCustomerInfo(item.customerId.id).then(function success(info) {
	                        assignedCustomer = {
	                            id: item.customerId.id,
	                            title: info.title,
	                            isPublic: info.isPublic
	                        };
	                        assignedCustomersMap[assignedCustomer.id] = assignedCustomer;
	                        item.assignedCustomer = assignedCustomer;
	                        loadNextCustomerInfoOrComplete(i);
	                    }, function fail() {
	                        loadNextCustomerInfoOrComplete(i);
	                    });
	                }
	            } else {
	                loadNextCustomerInfoOrComplete(i);
	            }
	        }
	        if (items.length > 0) {
	            loadNextCustomerInfo(0);
	        } else {
	            deferred.resolve(items);
	        }
	        return deferred.promise;
	    }
	
	    function applyAssignedCustomerInfo(items, customerId) {
	        var deferred = $q.defer();
	        getShortCustomerInfo(customerId).then(function success(info) {
	            var assignedCustomer = {
	                id: customerId,
	                title: info.title,
	                isPublic: info.isPublic
	            };
	            items.forEach(function (item) {
	                item.assignedCustomer = assignedCustomer;
	            });
	            deferred.resolve(items);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveCustomer(customer) {
	        var deferred = $q.defer();
	        var url = '/api/customer';
	        $http.post(url, customer).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function deleteCustomer(customerId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';
	
	LoginService.$inject = ["$http", "$q"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.login', []).factory('loginService', LoginService).name;
	
	/*@ngInject*/
	
	function LoginService($http, $q) {
	
	    var service = {
	        activate: activate,
	        changePassword: changePassword,
	        hasUser: hasUser,
	        login: login,
	        publicLogin: publicLogin,
	        resetPassword: resetPassword,
	        sendResetPasswordLink: sendResetPasswordLink
	    };
	
	    return service;
	
	    function hasUser() {
	        return true;
	    }
	
	    function login(user) {
	        var deferred = $q.defer();
	        var loginRequest = {
	            username: user.name,
	            password: user.password
	        };
	        $http.post('/api/auth/login', loginRequest).then(function success(response) {
	            deferred.resolve(response);
	        }, function fail(response) {
	            deferred.reject(response);
	        });
	        return deferred.promise;
	    }
	
	    function publicLogin(publicId) {
	        var deferred = $q.defer();
	        var pubilcLoginRequest = {
	            publicId: publicId
	        };
	        $http.post('/api/auth/login/public', pubilcLoginRequest).then(function success(response) {
	            deferred.resolve(response);
	        }, function fail(response) {
	            deferred.reject(response);
	        });
	        return deferred.promise;
	    }
	
	    function sendResetPasswordLink(email) {
	        var deferred = $q.defer();
	        var url = '/api/noauth/resetPasswordByEmail';
	        $http.post(url, { email: email }).then(function success(response) {
	            deferred.resolve(response);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function resetPassword(resetToken, password) {
	        var deferred = $q.defer();
	        var url = '/api/noauth/resetPassword';
	        $http.post(url, { resetToken: resetToken, password: password }).then(function success(response) {
	            deferred.resolve(response);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function activate(activateToken, password) {
	        var deferred = $q.defer();
	        var url = '/api/noauth/activate';
	        $http.post(url, { activateToken: activateToken, password: password }).then(function success(response) {
	            deferred.resolve(response);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function changePassword(currentPassword, newPassword) {
	        var deferred = $q.defer();
	        var url = '/api/auth/changePassword';
	        $http.post(url, { currentPassword: currentPassword, newPassword: newPassword }).then(function success(response) {
	            deferred.resolve(response);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = fixAceEditor;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function fixAceEditor(aceEditor) {
	    aceEditor.$blockScrolling = Infinity;
	    aceEditor.on("showGutterTooltip", function (tooltip) {
	        if (!tooltip.isAttachedToBody) {
	            document.body.appendChild(tooltip.$element); //eslint-disable-line
	            tooltip.isAttachedToBody = true;
	            onElementRemoved(tooltip.$parentNode, function () {
	                if (tooltip.$element.parentNode != null) {
	                    tooltip.$element.parentNode.removeChild(tooltip.$element);
	                }
	            });
	        }
	    });
	}
	
	function onElementRemoved(element, callback) {
	    if (!document.body.contains(element)) {
	        //eslint-disable-line
	        callback();
	    } else {
	        var observer;
	        observer = new MutationObserver(function (mutations) {
	            //eslint-disable-line
	            if (!document.body.contains(element)) {
	                //eslint-disable-line
	                callback();
	                observer.disconnect();
	            }
	        });
	        observer.observe(document.body, { childList: true }); //eslint-disable-line
	    }
	}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @ignore
	 * some key-codes definition and utils from closure-library
	 * @author yiminghe@gmail.com
	 */
	
	var KeyCode = {
	  /**
	   * MAC_ENTER
	   */
	  MAC_ENTER: 3,
	  /**
	   * BACKSPACE
	   */
	  BACKSPACE: 8,
	  /**
	   * TAB
	   */
	  TAB: 9,
	  /**
	   * NUMLOCK on FF/Safari Mac
	   */
	  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
	  /**
	   * ENTER
	   */
	  ENTER: 13,
	  /**
	   * SHIFT
	   */
	  SHIFT: 16,
	  /**
	   * CTRL
	   */
	  CTRL: 17,
	  /**
	   * ALT
	   */
	  ALT: 18,
	  /**
	   * PAUSE
	   */
	  PAUSE: 19,
	  /**
	   * CAPS_LOCK
	   */
	  CAPS_LOCK: 20,
	  /**
	   * ESC
	   */
	  ESC: 27,
	  /**
	   * SPACE
	   */
	  SPACE: 32,
	  /**
	   * PAGE_UP
	   */
	  PAGE_UP: 33, // also NUM_NORTH_EAST
	  /**
	   * PAGE_DOWN
	   */
	  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
	  /**
	   * END
	   */
	  END: 35, // also NUM_SOUTH_WEST
	  /**
	   * HOME
	   */
	  HOME: 36, // also NUM_NORTH_WEST
	  /**
	   * LEFT
	   */
	  LEFT: 37, // also NUM_WEST
	  /**
	   * UP
	   */
	  UP: 38, // also NUM_NORTH
	  /**
	   * RIGHT
	   */
	  RIGHT: 39, // also NUM_EAST
	  /**
	   * DOWN
	   */
	  DOWN: 40, // also NUM_SOUTH
	  /**
	   * PRINT_SCREEN
	   */
	  PRINT_SCREEN: 44,
	  /**
	   * INSERT
	   */
	  INSERT: 45, // also NUM_INSERT
	  /**
	   * DELETE
	   */
	  DELETE: 46, // also NUM_DELETE
	  /**
	   * ZERO
	   */
	  ZERO: 48,
	  /**
	   * ONE
	   */
	  ONE: 49,
	  /**
	   * TWO
	   */
	  TWO: 50,
	  /**
	   * THREE
	   */
	  THREE: 51,
	  /**
	   * FOUR
	   */
	  FOUR: 52,
	  /**
	   * FIVE
	   */
	  FIVE: 53,
	  /**
	   * SIX
	   */
	  SIX: 54,
	  /**
	   * SEVEN
	   */
	  SEVEN: 55,
	  /**
	   * EIGHT
	   */
	  EIGHT: 56,
	  /**
	   * NINE
	   */
	  NINE: 57,
	  /**
	   * QUESTION_MARK
	   */
	  QUESTION_MARK: 63, // needs localization
	  /**
	   * A
	   */
	  A: 65,
	  /**
	   * B
	   */
	  B: 66,
	  /**
	   * C
	   */
	  C: 67,
	  /**
	   * D
	   */
	  D: 68,
	  /**
	   * E
	   */
	  E: 69,
	  /**
	   * F
	   */
	  F: 70,
	  /**
	   * G
	   */
	  G: 71,
	  /**
	   * H
	   */
	  H: 72,
	  /**
	   * I
	   */
	  I: 73,
	  /**
	   * J
	   */
	  J: 74,
	  /**
	   * K
	   */
	  K: 75,
	  /**
	   * L
	   */
	  L: 76,
	  /**
	   * M
	   */
	  M: 77,
	  /**
	   * N
	   */
	  N: 78,
	  /**
	   * O
	   */
	  O: 79,
	  /**
	   * P
	   */
	  P: 80,
	  /**
	   * Q
	   */
	  Q: 81,
	  /**
	   * R
	   */
	  R: 82,
	  /**
	   * S
	   */
	  S: 83,
	  /**
	   * T
	   */
	  T: 84,
	  /**
	   * U
	   */
	  U: 85,
	  /**
	   * V
	   */
	  V: 86,
	  /**
	   * W
	   */
	  W: 87,
	  /**
	   * X
	   */
	  X: 88,
	  /**
	   * Y
	   */
	  Y: 89,
	  /**
	   * Z
	   */
	  Z: 90,
	  /**
	   * META
	   */
	  META: 91, // WIN_KEY_LEFT
	  /**
	   * WIN_KEY_RIGHT
	   */
	  WIN_KEY_RIGHT: 92,
	  /**
	   * CONTEXT_MENU
	   */
	  CONTEXT_MENU: 93,
	  /**
	   * NUM_ZERO
	   */
	  NUM_ZERO: 96,
	  /**
	   * NUM_ONE
	   */
	  NUM_ONE: 97,
	  /**
	   * NUM_TWO
	   */
	  NUM_TWO: 98,
	  /**
	   * NUM_THREE
	   */
	  NUM_THREE: 99,
	  /**
	   * NUM_FOUR
	   */
	  NUM_FOUR: 100,
	  /**
	   * NUM_FIVE
	   */
	  NUM_FIVE: 101,
	  /**
	   * NUM_SIX
	   */
	  NUM_SIX: 102,
	  /**
	   * NUM_SEVEN
	   */
	  NUM_SEVEN: 103,
	  /**
	   * NUM_EIGHT
	   */
	  NUM_EIGHT: 104,
	  /**
	   * NUM_NINE
	   */
	  NUM_NINE: 105,
	  /**
	   * NUM_MULTIPLY
	   */
	  NUM_MULTIPLY: 106,
	  /**
	   * NUM_PLUS
	   */
	  NUM_PLUS: 107,
	  /**
	   * NUM_MINUS
	   */
	  NUM_MINUS: 109,
	  /**
	   * NUM_PERIOD
	   */
	  NUM_PERIOD: 110,
	  /**
	   * NUM_DIVISION
	   */
	  NUM_DIVISION: 111,
	  /**
	   * F1
	   */
	  F1: 112,
	  /**
	   * F2
	   */
	  F2: 113,
	  /**
	   * F3
	   */
	  F3: 114,
	  /**
	   * F4
	   */
	  F4: 115,
	  /**
	   * F5
	   */
	  F5: 116,
	  /**
	   * F6
	   */
	  F6: 117,
	  /**
	   * F7
	   */
	  F7: 118,
	  /**
	   * F8
	   */
	  F8: 119,
	  /**
	   * F9
	   */
	  F9: 120,
	  /**
	   * F10
	   */
	  F10: 121,
	  /**
	   * F11
	   */
	  F11: 122,
	  /**
	   * F12
	   */
	  F12: 123,
	  /**
	   * NUMLOCK
	   */
	  NUMLOCK: 144,
	  /**
	   * SEMICOLON
	   */
	  SEMICOLON: 186, // needs localization
	  /**
	   * DASH
	   */
	  DASH: 189, // needs localization
	  /**
	   * EQUALS
	   */
	  EQUALS: 187, // needs localization
	  /**
	   * COMMA
	   */
	  COMMA: 188, // needs localization
	  /**
	   * PERIOD
	   */
	  PERIOD: 190, // needs localization
	  /**
	   * SLASH
	   */
	  SLASH: 191, // needs localization
	  /**
	   * APOSTROPHE
	   */
	  APOSTROPHE: 192, // needs localization
	  /**
	   * SINGLE_QUOTE
	   */
	  SINGLE_QUOTE: 222, // needs localization
	  /**
	   * OPEN_SQUARE_BRACKET
	   */
	  OPEN_SQUARE_BRACKET: 219, // needs localization
	  /**
	   * BACKSLASH
	   */
	  BACKSLASH: 220, // needs localization
	  /**
	   * CLOSE_SQUARE_BRACKET
	   */
	  CLOSE_SQUARE_BRACKET: 221, // needs localization
	  /**
	   * WIN_KEY
	   */
	  WIN_KEY: 224,
	  /**
	   * MAC_FF_META
	   */
	  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
	  /**
	   * WIN_IME
	   */
	  WIN_IME: 229
	};
	
	/*
	 whether text and modified key is entered at the same time.
	 */
	KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
	  var keyCode = e.keyCode;
	  if (e.altKey && !e.ctrlKey || e.metaKey ||
	  // Function keys don't generate text
	  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
	    return false;
	  }
	
	  // The following keys are quite harmless, even in combination with
	  // CTRL, ALT or SHIFT.
	  switch (keyCode) {
	    case KeyCode.ALT:
	    case KeyCode.CAPS_LOCK:
	    case KeyCode.CONTEXT_MENU:
	    case KeyCode.CTRL:
	    case KeyCode.DOWN:
	    case KeyCode.END:
	    case KeyCode.ESC:
	    case KeyCode.HOME:
	    case KeyCode.INSERT:
	    case KeyCode.LEFT:
	    case KeyCode.MAC_FF_META:
	    case KeyCode.META:
	    case KeyCode.NUMLOCK:
	    case KeyCode.NUM_CENTER:
	    case KeyCode.PAGE_DOWN:
	    case KeyCode.PAGE_UP:
	    case KeyCode.PAUSE:
	    case KeyCode.PRINT_SCREEN:
	    case KeyCode.RIGHT:
	    case KeyCode.SHIFT:
	    case KeyCode.UP:
	    case KeyCode.WIN_KEY:
	    case KeyCode.WIN_KEY_RIGHT:
	      return false;
	    default:
	      return true;
	  }
	};
	
	/*
	 whether character is entered.
	 */
	KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
	  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
	    return true;
	  }
	
	  // Safari sends zero key code for non-latin characters.
	  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
	    return true;
	  }
	
	  switch (keyCode) {
	    case KeyCode.SPACE:
	    case KeyCode.QUESTION_MARK:
	    case KeyCode.NUM_PLUS:
	    case KeyCode.NUM_MINUS:
	    case KeyCode.NUM_PERIOD:
	    case KeyCode.NUM_DIVISION:
	    case KeyCode.SEMICOLON:
	    case KeyCode.DASH:
	    case KeyCode.EQUALS:
	    case KeyCode.COMMA:
	    case KeyCode.PERIOD:
	    case KeyCode.SLASH:
	    case KeyCode.APOSTROPHE:
	    case KeyCode.SINGLE_QUOTE:
	    case KeyCode.OPEN_SQUARE_BRACKET:
	    case KeyCode.BACKSLASH:
	    case KeyCode.CLOSE_SQUARE_BRACKET:
	      return true;
	    default:
	      return false;
	  }
	};
	
	exports['default'] = KeyCode;
	module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(1669);


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.SchemaForm = __webpack_require__(560);
	exports.utils = __webpack_require__(77);
	exports.ComposedComponent = __webpack_require__(58);
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();
	
	;

/***/ }),
/* 119 */
17,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(567);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(258);
	exports.Duplex = __webpack_require__(78);
	exports.Transform = __webpack_require__(568);
	exports.PassThrough = __webpack_require__(1690);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(589);
	module.exports = 'ngAnimate';


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(767);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormBaseComponent = __webpack_require__(49);
	
	var _jsonFormBaseComponent2 = _interopRequireDefault(_jsonFormBaseComponent);
	
	var _reactcss = __webpack_require__(566);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _reactAce = __webpack_require__(1593);
	
	var _reactAce2 = _interopRequireDefault(_reactAce);
	
	var _FlatButton = __webpack_require__(109);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	__webpack_require__(33);
	
	__webpack_require__(61);
	
	var _aceEditorFix = __webpack_require__(114);
	
	var _aceEditorFix2 = _interopRequireDefault(_aceEditorFix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardAceEditor = function (_React$Component) {
	    _inherits(ThingsboardAceEditor, _React$Component);
	
	    function ThingsboardAceEditor(props) {
	        _classCallCheck(this, ThingsboardAceEditor);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardAceEditor.__proto__ || Object.getPrototypeOf(ThingsboardAceEditor)).call(this, props));
	
	        _this.onValueChanged = _this.onValueChanged.bind(_this);
	        _this.onBlur = _this.onBlur.bind(_this);
	        _this.onFocus = _this.onFocus.bind(_this);
	        _this.onTidy = _this.onTidy.bind(_this);
	        _this.onLoad = _this.onLoad.bind(_this);
	        var value = props.value ? props.value + '' : '';
	        _this.state = {
	            value: value,
	            focused: false
	        };
	        return _this;
	    }
	
	    _createClass(ThingsboardAceEditor, [{
	        key: 'onValueChanged',
	        value: function onValueChanged(value) {
	            this.setState({
	                value: value
	            });
	            this.props.onChangeValidate({
	                target: {
	                    value: value
	                }
	            });
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur() {
	            this.setState({ focused: false });
	        }
	    }, {
	        key: 'onFocus',
	        value: function onFocus() {
	            this.setState({ focused: true });
	        }
	    }, {
	        key: 'onTidy',
	        value: function onTidy() {
	            if (!this.props.form.readonly) {
	                var value = this.state.value;
	                value = this.props.onTidy(value);
	                this.setState({
	                    value: value
	                });
	                this.props.onChangeValidate({
	                    target: {
	                        value: value
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'onLoad',
	        value: function onLoad(editor) {
	            (0, _aceEditorFix2.default)(editor);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var styles = (0, _reactcss2.default)({
	                'default': {
	                    tidyButtonStyle: {
	                        color: '#7B7B7B',
	                        minWidth: '32px',
	                        minHeight: '15px',
	                        lineHeight: '15px',
	                        fontSize: '0.800rem',
	                        margin: '0',
	                        padding: '4px',
	                        height: '23px',
	                        borderRadius: '5px',
	                        marginLeft: '5px'
	                    }
	                }
	            });
	
	            var labelClass = "tb-label";
	            if (this.props.form.required) {
	                labelClass += " tb-required";
	            }
	            if (this.props.form.readonly) {
	                labelClass += " tb-readonly";
	            }
	            if (this.state.focused) {
	                labelClass += " tb-focused";
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'tb-container' },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    this.props.form.title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'json-form-ace-editor' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title-panel' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            this.props.mode
	                        ),
	                        _react2.default.createElement(_FlatButton2.default, { style: styles.tidyButtonStyle, className: 'tidy-button', label: 'Tidy', onTouchTap: this.onTidy })
	                    ),
	                    _react2.default.createElement(_reactAce2.default, { mode: this.props.mode,
	                        height: '150px',
	                        width: '300px',
	                        theme: 'github',
	                        onChange: this.onValueChanged,
	                        onFocus: this.onFocus,
	                        onBlur: this.onBlur,
	                        onLoad: this.onLoad,
	                        name: this.props.form.title,
	                        value: this.state.value,
	                        readOnly: this.props.form.readonly,
	                        editorProps: { $blockScrolling: Infinity },
	                        enableBasicAutocompletion: true,
	                        enableSnippets: true,
	                        enableLiveAutocompletion: true,
	                        style: this.props.form.style || { width: '100%' } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'json-form-error',
	                        style: { opacity: this.props.valid ? '0' : '1' } },
	                    this.props.error
	                )
	            );
	        }
	    }]);
	
	    return ThingsboardAceEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _jsonFormBaseComponent2.default)(ThingsboardAceEditor);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(693)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(294)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(959),
	    listCacheDelete = __webpack_require__(960),
	    listCacheGet = __webpack_require__(961),
	    listCacheHas = __webpack_require__(962),
	    listCacheSet = __webpack_require__(963);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(208);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(324),
	    baseAssignValue = __webpack_require__(325);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(957);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(895),
	    Map = __webpack_require__(198),
	    Promise = __webpack_require__(897),
	    Set = __webpack_require__(898),
	    WeakMap = __webpack_require__(900),
	    baseGetTag = __webpack_require__(71),
	    toSource = __webpack_require__(339);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(72);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(212);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(342),
	    isLength = __webpack_require__(211);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(1033);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(217);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toArray2 = __webpack_require__(273);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(79);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(222);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(215);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _menuUtils = __webpack_require__(1043);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var desktop = props.desktop,
	      maxHeight = props.maxHeight,
	      width = props.width;
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div bacause the List scales x faster than it scales y
	      zIndex: muiTheme.zIndex.menu,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    selectedMenuItem: {
	      color: muiTheme.menuItem.selectedTextColor
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu(props, context) {
	    (0, _classCallCheck3.default)(this, Menu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getSelectedIndex(props, filteredChildren);
	
	    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
	      props.onMenuItemFocusChange(null, newFocusIndex);
	    }
	    _this.state = {
	      focusIndex: newFocusIndex,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	      var selectedIndex = this.getSelectedIndex(nextProps, filteredChildren);
	
	      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
	        this.props.onMenuItemFocusChange(null, newFocusIndex);
	      }
	      this.setState({
	        focusIndex: newFocusIndex,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var _props = this.props,
	          desktop = _props.desktop,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle;
	
	
	      var selected = this.isChildSelected(child, this.props);
	      var selectedChildrenStyles = {};
	
	      if (selected) {
	        selectedChildrenStyles = (0, _simpleAssign2.default)(styles.selectedMenuItem, selectedMenuItemStyle);
	      }
	
	      var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, menuItemStyle, selectedChildrenStyles);
	
	      var isFocused = childIndex === this.state.focusIndex;
	      var focusState = 'none';
	      if (isFocused) {
	        focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	      }
	
	      return _react2.default.cloneElement(child, {
	        desktop: desktop,
	        focusState: focusState,
	        onTouchTap: function onTouchTap(event) {
	          _this2.handleMenuItemTouchTap(event, child, index);
	          if (child.props.onTouchTap) child.props.onTouchTap(event);
	        },
	        ref: isFocused ? 'focusedMenuItem' : null,
	        style: mergedChildrenStyles
	      });
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex(event) {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(event, keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && new RegExp('^' + keys, 'i').test(primaryText)) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(event, foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(event, focusIndex, false);
	
	      if (multiple) {
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = (0, _toArray3.default)(menuValue),
	            newMenuValue = _menuValue;
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
	      if (this.props.onMenuItemFocusChange) {
	        // Do this even if `newIndex === this.state.focusIndex` to allow users
	        // to detect up-arrow on the first MenuItem or down-arrow on the last.
	        this.props.onMenuItemFocusChange(event, newIndex);
	      }
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'cancelScrollEvent',
	    value: function cancelScrollEvent(event) {
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          autoWidth = _props2.autoWidth,
	          children = _props2.children,
	          desktop = _props2.desktop,
	          disableAutoFocus = _props2.disableAutoFocus,
	          initiallyKeyboardFocused = _props2.initiallyKeyboardFocused,
	          listStyle = _props2.listStyle,
	          maxHeight = _props2.maxHeight,
	          multiple = _props2.multiple,
	          onItemTouchTap = _props2.onItemTouchTap,
	          onEscKeyDown = _props2.onEscKeyDown,
	          onMenuItemFocusChange = _props2.onMenuItemFocusChange,
	          selectedMenuItemStyle = _props2.selectedMenuItemStyle,
	          menuItemStyle = _props2.menuItemStyle,
	          style = _props2.style,
	          value = _props2.value,
	          valueLink = _props2.valueLink,
	          width = _props2.width,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemTouchTap', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var filteredChildren = this.getFilteredChildren(children);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsDisabled = child.props.disabled;
	        var childName = child.type ? child.type.muiName : '';
	        var newChild = child;
	
	        switch (childName) {
	          case 'MenuItem':
	            newChild = childIsDisabled ? _react2.default.cloneElement(child, { desktop: desktop }) : _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	            break;
	
	          case 'Divider':
	            newChild = _react2.default.cloneElement(child, {
	              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
	            });
	            break;
	        }
	
	        if (childName === 'MenuItem' && !childIsDisabled) {
	          menuItemIndex++;
	        }
	
	        return newChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            onWheel: this.handleOnWheel,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            (0, _extends3.default)({}, other, {
	              ref: 'list',
	              style: mergedListStyles
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    _this5.setFocusIndex(event, -1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex(event);
	        } else {
	          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex(event);
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(event, hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	
	  this.handleOnWheel = function (event) {
	    var scrollContainer = _this5.refs.scrollContainer;
	    // Only scroll lock if the the Menu is scrollable.
	    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;
	
	    var scrollTop = scrollContainer.scrollTop,
	        scrollHeight = scrollContainer.scrollHeight,
	        clientHeight = scrollContainer.clientHeight;
	
	    var wheelDelta = event.deltaY;
	    var isDeltaPositive = wheelDelta > 0;
	
	    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	      scrollContainer.scrollTop = scrollHeight;
	      return _this5.cancelScrollEvent(event);
	    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	      scrollContainer.scrollTop = 0;
	      return _this5.cancelScrollEvent(event);
	    }
	  };
	};
	
	 false ? Menu.propTypes = {
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _react.PropTypes.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when the focus on a `MenuItem` is changed.
	   * There will be some "duplicate" changes reported if two different
	   * focusing event happen, for example if a `MenuItem` is focused via
	   * the keyboard and then it is clicked on.
	   *
	   * @param {object} event The event that triggered the focus change.
	   * The event can be null since the focus can be changed for non-event
	   * reasons such as prop changes.
	   * @param {number} newFocusIndex The index of the newly focused
	   * `MenuItem` or `-1` if focus was lost.
	   */
	  onMenuItemFocusChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _react.PropTypes.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes2.default.stringOrNumber
	} : void 0;
	exports.default = Menu;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(1048);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableRowColumn = context.muiTheme.tableRowColumn;
	
	
	  var styles = {
	    root: {
	      paddingLeft: tableRowColumn.spacing,
	      paddingRight: tableRowColumn.spacing,
	      height: tableRowColumn.height,
	      textAlign: 'left',
	      fontSize: 13,
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis'
	    }
	  };
	
	  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
	    styles.textAlign = 'right';
	  }
	
	  return styles;
	}
	
	var TableRowColumn = function (_Component) {
	  (0, _inherits3.default)(TableRowColumn, _Component);
	
	  function TableRowColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRowColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRowColumn.__proto__ || (0, _getPrototypeOf2.default)(TableRowColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _this.onMouseEnter = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onHover) {
	          _this.props.onHover(event, _this.props.columnNumber);
	        }
	      }
	    }, _this.onMouseLeave = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onHoverExit) {
	          _this.props.onHoverExit(event, _this.props.columnNumber);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRowColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onClick: this.onClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave
	      };
	
	      return _react2.default.createElement(
	        'td',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        children
	      );
	    }
	  }]);
	  return TableRowColumn;
	}(_react.Component);
	
	TableRowColumn.defaultProps = {
	  hoverable: false
	};
	TableRowColumn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableRowColumn.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * @ignore
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _react.PropTypes.number,
	  /**
	   * @ignore
	   * If true, this column responds to hover events.
	   */
	  hoverable: _react.PropTypes.bool,
	  /** @ignore */
	  onClick: _react.PropTypes.func,
	  /** @ignore */
	  onHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Callback function for hover exit event.
	   */
	  onHoverExit: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableRowColumn;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DeviceService.$inject = ["$http", "$q", "$window", "userService", "attributeService", "customerService", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.api.device', [_types2.default]).factory('deviceService', DeviceService).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function DeviceService($http, $q, $window, userService, attributeService, customerService, types) {
	
	    var service = {
	        assignDeviceToCustomer: assignDeviceToCustomer,
	        deleteDevice: deleteDevice,
	        getCustomerDevices: getCustomerDevices,
	        getDevice: getDevice,
	        getDevices: getDevices,
	        getDeviceCredentials: getDeviceCredentials,
	        getTenantDevices: getTenantDevices,
	        saveDevice: saveDevice,
	        saveDeviceCredentials: saveDeviceCredentials,
	        unassignDeviceFromCustomer: unassignDeviceFromCustomer,
	        makeDevicePublic: makeDevicePublic,
	        getDeviceAttributes: getDeviceAttributes,
	        subscribeForDeviceAttributes: subscribeForDeviceAttributes,
	        unsubscribeForDeviceAttributes: unsubscribeForDeviceAttributes,
	        saveDeviceAttributes: saveDeviceAttributes,
	        deleteDeviceAttributes: deleteDeviceAttributes,
	        sendOneWayRpcCommand: sendOneWayRpcCommand,
	        sendTwoWayRpcCommand: sendTwoWayRpcCommand,
	        findByQuery: findByQuery,
	        getDeviceTypes: getDeviceTypes
	    };
	
	    return service;
	
	    function getTenantDevices(pageLink, applyCustomersInfo, config, type) {
	        var deferred = $q.defer();
	        var url = '/api/tenant/devices?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        if (angular.isDefined(type) && type.length) {
	            url += '&type=' + type;
	        }
	        $http.get(url, config).then(function success(response) {
	            if (applyCustomersInfo) {
	                customerService.applyAssignedCustomersInfo(response.data.data).then(function success(data) {
	                    response.data.data = data;
	                    deferred.resolve(response.data);
	                }, function fail() {
	                    deferred.reject();
	                });
	            } else {
	                deferred.resolve(response.data);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getCustomerDevices(customerId, pageLink, applyCustomersInfo, config, type) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/devices?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        if (angular.isDefined(type) && type.length) {
	            url += '&type=' + type;
	        }
	        $http.get(url, config).then(function success(response) {
	            if (applyCustomersInfo) {
	                customerService.applyAssignedCustomerInfo(response.data.data, customerId).then(function success(data) {
	                    response.data.data = data;
	                    deferred.resolve(response.data);
	                }, function fail() {
	                    deferred.reject();
	                });
	            } else {
	                deferred.resolve(response.data);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	
	        return deferred.promise;
	    }
	
	    function getDevice(deviceId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/device/' + deviceId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function getDevices(deviceIds, config) {
	        var deferred = $q.defer();
	        var ids = '';
	        for (var i = 0; i < deviceIds.length; i++) {
	            if (i > 0) {
	                ids += ',';
	            }
	            ids += deviceIds[i];
	        }
	        var url = '/api/devices?deviceIds=' + ids;
	        $http.get(url, config).then(function success(response) {
	            var devices = response.data;
	            devices.sort(function (device1, device2) {
	                var id1 = device1.id.id;
	                var id2 = device2.id.id;
	                var index1 = deviceIds.indexOf(id1);
	                var index2 = deviceIds.indexOf(id2);
	                return index1 - index2;
	            });
	            deferred.resolve(devices);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function saveDevice(device) {
	        var deferred = $q.defer();
	        var url = '/api/device';
	        $http.post(url, device).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteDevice(deviceId) {
	        var deferred = $q.defer();
	        var url = '/api/device/' + deviceId;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getDeviceCredentials(deviceId, sync) {
	        var deferred = $q.defer();
	        var url = '/api/device/' + deviceId + '/credentials';
	        if (sync) {
	            var request = new $window.XMLHttpRequest();
	            request.open('GET', url, false);
	            request.setRequestHeader("Accept", "application/json, text/plain, */*");
	            userService.setAuthorizationRequestHeader(request);
	            request.send(null);
	            if (request.status === 200) {
	                deferred.resolve(angular.fromJson(request.responseText));
	            } else {
	                deferred.reject();
	            }
	        } else {
	            $http.get(url, null).then(function success(response) {
	                deferred.resolve(response.data);
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	
	    function saveDeviceCredentials(deviceCredentials) {
	        var deferred = $q.defer();
	        var url = '/api/device/credentials';
	        $http.post(url, deviceCredentials).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function assignDeviceToCustomer(customerId, deviceId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/device/' + deviceId;
	        $http.post(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function unassignDeviceFromCustomer(deviceId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/device/' + deviceId;
	        $http.delete(url).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function makeDevicePublic(deviceId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/public/device/' + deviceId;
	        $http.post(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getDeviceAttributes(deviceId, attributeScope, query, successCallback, config) {
	        return attributeService.getEntityAttributes(types.entityType.device, deviceId, attributeScope, query, successCallback, config);
	    }
	
	    function subscribeForDeviceAttributes(deviceId, attributeScope) {
	        return attributeService.subscribeForEntityAttributes(types.entityType.device, deviceId, attributeScope);
	    }
	
	    function unsubscribeForDeviceAttributes(subscriptionId) {
	        attributeService.unsubscribeForEntityAttributes(subscriptionId);
	    }
	
	    function saveDeviceAttributes(deviceId, attributeScope, attributes) {
	        return attributeService.saveEntityAttributes(types.entityType.device, deviceId, attributeScope, attributes);
	    }
	
	    function deleteDeviceAttributes(deviceId, attributeScope, attributes) {
	        return attributeService.deleteEntityAttributes(types.entityType.device, deviceId, attributeScope, attributes);
	    }
	
	    function sendOneWayRpcCommand(deviceId, requestBody) {
	        var deferred = $q.defer();
	        var url = '/api/plugins/rpc/oneway/' + deviceId;
	        $http.post(url, requestBody).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(rejection) {
	            deferred.reject(rejection);
	        });
	        return deferred.promise;
	    }
	
	    function sendTwoWayRpcCommand(deviceId, requestBody) {
	        var deferred = $q.defer();
	        var url = '/api/plugins/rpc/twoway/' + deviceId;
	        $http.post(url, requestBody).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(rejection) {
	            deferred.reject(rejection);
	        });
	        return deferred.promise;
	    }
	
	    function findByQuery(query, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/devices';
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.post(url, query, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getDeviceTypes(config) {
	        var deferred = $q.defer();
	        var url = '/api/device/types';
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WidgetService.$inject = ["$rootScope", "$http", "$q", "$filter", "$ocLazyLoad", "$window", "$translate", "types", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _ledLight = __webpack_require__(1185);
	
	var _ledLight2 = _interopRequireDefault(_ledLight);
	
	var _timeseriesTableWidget = __webpack_require__(1357);
	
	var _timeseriesTableWidget2 = _interopRequireDefault(_timeseriesTableWidget);
	
	var _alarmsTableWidget = __webpack_require__(1340);
	
	var _alarmsTableWidget2 = _interopRequireDefault(_alarmsTableWidget);
	
	var _entitiesTableWidget = __webpack_require__(1345);
	
	var _entitiesTableWidget2 = _interopRequireDefault(_entitiesTableWidget);
	
	var _extensionsTableWidget = __webpack_require__(1346);
	
	var _extensionsTableWidget2 = _interopRequireDefault(_extensionsTableWidget);
	
	var _rpc = __webpack_require__(1351);
	
	var _rpc2 = _interopRequireDefault(_rpc);
	
	var _flotWidget = __webpack_require__(1347);
	
	var _flotWidget2 = _interopRequireDefault(_flotWidget);
	
	var _analogueLinearGauge = __webpack_require__(1342);
	
	var _analogueLinearGauge2 = _interopRequireDefault(_analogueLinearGauge);
	
	var _analogueRadialGauge = __webpack_require__(1343);
	
	var _analogueRadialGauge2 = _interopRequireDefault(_analogueRadialGauge);
	
	var _analogueCompass = __webpack_require__(1341);
	
	var _analogueCompass2 = _interopRequireDefault(_analogueCompass);
	
	var _canvasDigitalGauge = __webpack_require__(1344);
	
	var _canvasDigitalGauge2 = _interopRequireDefault(_canvasDigitalGauge);
	
	var _mapWidget = __webpack_require__(1349);
	
	var _mapWidget2 = _interopRequireDefault(_mapWidget);
	
	var _mapWidget3 = __webpack_require__(1350);
	
	var _mapWidget4 = _interopRequireDefault(_mapWidget3);
	
	__webpack_require__(887);
	
	__webpack_require__(737);
	
	__webpack_require__(1547);
	
	var _css = __webpack_require__(149);
	
	var _css2 = _interopRequireDefault(_css);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _utils = __webpack_require__(90);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.widget', ['oc.lazyLoad', _ledLight2.default, _timeseriesTableWidget2.default, _alarmsTableWidget2.default, _entitiesTableWidget2.default, _extensionsTableWidget2.default, _rpc2.default, _types2.default, _utils2.default]).factory('widgetService', WidgetService).name;
	
	/*@ngInject*/
	
	function WidgetService($rootScope, $http, $q, $filter, $ocLazyLoad, $window, $translate, types, utils) {
	
	    $window.$ = _jquery2.default;
	    $window.jQuery = _jquery2.default;
	    $window.moment = _moment2.default;
	    $window.tinycolor = _tinycolor2.default;
	    $window.lazyLoad = $ocLazyLoad;
	
	    $window.TbFlot = _flotWidget2.default;
	    $window.TbAnalogueLinearGauge = _analogueLinearGauge2.default;
	    $window.TbAnalogueRadialGauge = _analogueRadialGauge2.default;
	    $window.TbAnalogueCompass = _analogueCompass2.default;
	    $window.TbCanvasDigitalGauge = _canvasDigitalGauge2.default;
	    $window.TbMapWidget = _mapWidget2.default;
	    $window.TbMapWidgetV2 = _mapWidget4.default;
	
	    $window.cssjs = _css2.default;
	
	    var cssParser = new _css2.default();
	    cssParser.testMode = false;
	
	    var missingWidgetType;
	    var errorWidgetType;
	
	    var editingWidgetType;
	
	    var widgetsInfoInMemoryCache = {};
	    var widgetsTypeFunctionsInMemoryCache = {};
	    var widgetsInfoFetchQueue = {};
	
	    var allWidgetsBundles = undefined;
	    var systemWidgetsBundles = undefined;
	    var tenantWidgetsBundles = undefined;
	
	    $rootScope.widgetServiceStateChangeStartHandle = $rootScope.$on('$stateChangeStart', function () {
	        invalidateWidgetsBundleCache();
	    });
	
	    initEditingWidgetType();
	    initWidgetPlaceholders();
	
	    var service = {
	        getWidgetTemplate: getWidgetTemplate,
	        getSystemWidgetsBundles: getSystemWidgetsBundles,
	        getTenantWidgetsBundles: getTenantWidgetsBundles,
	        getAllWidgetsBundles: getAllWidgetsBundles,
	        getSystemWidgetsBundlesByPageLink: getSystemWidgetsBundlesByPageLink,
	        getTenantWidgetsBundlesByPageLink: getTenantWidgetsBundlesByPageLink,
	        getAllWidgetsBundlesByPageLink: getAllWidgetsBundlesByPageLink,
	        getWidgetsBundleByAlias: getWidgetsBundleByAlias,
	        saveWidgetsBundle: saveWidgetsBundle,
	        getWidgetsBundle: getWidgetsBundle,
	        deleteWidgetsBundle: deleteWidgetsBundle,
	        getBundleWidgetTypes: getBundleWidgetTypes,
	        getWidgetInfo: getWidgetInfo,
	        getWidgetTypeFunction: getWidgetTypeFunction,
	        getInstantWidgetInfo: getInstantWidgetInfo,
	        deleteWidgetType: deleteWidgetType,
	        saveWidgetType: saveWidgetType,
	        saveImportedWidgetType: saveImportedWidgetType,
	        getWidgetType: getWidgetType,
	        getWidgetTypeById: getWidgetTypeById,
	        toWidgetInfo: toWidgetInfo
	    };
	
	    return service;
	
	    function initEditingWidgetType() {
	        if ($rootScope.widgetEditMode) {
	            editingWidgetType = toWidgetType({
	                widgetName: $rootScope.editWidgetInfo.widgetName,
	                alias: 'customWidget',
	                type: $rootScope.editWidgetInfo.type,
	                sizeX: $rootScope.editWidgetInfo.sizeX,
	                sizeY: $rootScope.editWidgetInfo.sizeY,
	                resources: $rootScope.editWidgetInfo.resources,
	                templateHtml: $rootScope.editWidgetInfo.templateHtml,
	                templateCss: $rootScope.editWidgetInfo.templateCss,
	                controllerScript: $rootScope.editWidgetInfo.controllerScript,
	                settingsSchema: $rootScope.editWidgetInfo.settingsSchema,
	                dataKeySettingsSchema: $rootScope.editWidgetInfo.dataKeySettingsSchema,
	                defaultConfig: $rootScope.editWidgetInfo.defaultConfig
	            }, { id: '1' }, { id: types.id.nullUid }, 'customWidgetBundle');
	        }
	    }
	
	    function initWidgetPlaceholders() {
	
	        missingWidgetType = {
	            widgetName: 'Widget type not found',
	            alias: 'undefined',
	            sizeX: 8,
	            sizeY: 6,
	            resources: [],
	            templateHtml: '<div class="tb-widget-error-container"><div translate class="tb-widget-error-msg">widget.widget-type-not-found</div></div>',
	            templateCss: '',
	            controllerScript: 'self.onInit = function() {}',
	            settingsSchema: '{}\n',
	            dataKeySettingsSchema: '{}\n',
	            defaultConfig: '{\n' + '"title": "Widget type not found",\n' + '"datasources": [],\n' + '"settings": {}\n' + '}\n'
	        };
	
	        errorWidgetType = {
	            widgetName: 'Error loading widget',
	            alias: 'error',
	            sizeX: 8,
	            sizeY: 6,
	            resources: [],
	            templateHtml: '<div class="tb-widget-error-container"><div translate class="tb-widget-error-msg">widget.widget-type-load-error</div>',
	            templateCss: '',
	            controllerScript: 'self.onInit = function() {}',
	            settingsSchema: '{}\n',
	            dataKeySettingsSchema: '{}\n',
	            defaultConfig: '{\n' + '"title": "Widget failed to load",\n' + '"datasources": [],\n' + '"settings": {}\n' + '}\n'
	        };
	    }
	
	    function toWidgetInfo(widgetType) {
	
	        var widgetInfo = {
	            widgetName: widgetType.name,
	            alias: widgetType.alias
	        };
	
	        var descriptor = widgetType.descriptor;
	
	        widgetInfo.type = descriptor.type;
	        widgetInfo.sizeX = descriptor.sizeX;
	        widgetInfo.sizeY = descriptor.sizeY;
	        widgetInfo.resources = descriptor.resources;
	        widgetInfo.templateHtml = descriptor.templateHtml;
	        widgetInfo.templateCss = descriptor.templateCss;
	        widgetInfo.controllerScript = descriptor.controllerScript;
	        widgetInfo.settingsSchema = descriptor.settingsSchema;
	        widgetInfo.dataKeySettingsSchema = descriptor.dataKeySettingsSchema;
	        widgetInfo.defaultConfig = descriptor.defaultConfig;
	
	        return widgetInfo;
	    }
	
	    function toWidgetType(widgetInfo, id, tenantId, bundleAlias) {
	        var widgetType = {
	            id: id,
	            tenantId: tenantId,
	            bundleAlias: bundleAlias,
	            alias: widgetInfo.alias,
	            name: widgetInfo.widgetName
	        };
	
	        var descriptor = {
	            type: widgetInfo.type,
	            sizeX: widgetInfo.sizeX,
	            sizeY: widgetInfo.sizeY,
	            resources: widgetInfo.resources,
	            templateHtml: widgetInfo.templateHtml,
	            templateCss: widgetInfo.templateCss,
	            controllerScript: widgetInfo.controllerScript,
	            settingsSchema: widgetInfo.settingsSchema,
	            dataKeySettingsSchema: widgetInfo.dataKeySettingsSchema,
	            defaultConfig: widgetInfo.defaultConfig
	        };
	
	        widgetType.descriptor = descriptor;
	
	        return widgetType;
	    }
	
	    function getWidgetTemplate(type) {
	        var deferred = $q.defer();
	        var templateWidgetType = types.widgetType.timeseries;
	        for (var t in types.widgetType) {
	            var widgetType = types.widgetType[t];
	            if (widgetType.value === type) {
	                templateWidgetType = widgetType;
	                break;
	            }
	        }
	        getWidgetType(templateWidgetType.template.bundleAlias, templateWidgetType.template.alias, true).then(function success(widgetType) {
	            var widgetInfo = toWidgetInfo(widgetType);
	            widgetInfo.alias = undefined;
	            deferred.resolve(widgetInfo);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    /** Cache functions **/
	
	    function createWidgetInfoCacheKey(bundleAlias, widgetTypeAlias, isSystem) {
	        return (isSystem ? 'sys_' : '') + bundleAlias + '_' + widgetTypeAlias;
	    }
	
	    function getWidgetInfoFromCache(bundleAlias, widgetTypeAlias, isSystem) {
	        var key = createWidgetInfoCacheKey(bundleAlias, widgetTypeAlias, isSystem);
	        return widgetsInfoInMemoryCache[key];
	    }
	
	    function getWidgetTypeFunctionFromCache(bundleAlias, widgetTypeAlias, isSystem) {
	        var key = createWidgetInfoCacheKey(bundleAlias, widgetTypeAlias, isSystem);
	        return widgetsTypeFunctionsInMemoryCache[key];
	    }
	
	    function putWidgetInfoToCache(widgetInfo, bundleAlias, widgetTypeAlias, isSystem) {
	        var key = createWidgetInfoCacheKey(bundleAlias, widgetTypeAlias, isSystem);
	        widgetsInfoInMemoryCache[key] = widgetInfo;
	    }
	
	    function putWidgetTypeFunctionToCache(widgetTypeFunction, bundleAlias, widgetTypeAlias, isSystem) {
	        var key = createWidgetInfoCacheKey(bundleAlias, widgetTypeAlias, isSystem);
	        widgetsTypeFunctionsInMemoryCache[key] = widgetTypeFunction;
	    }
	
	    function deleteWidgetInfoFromCache(bundleAlias, widgetTypeAlias, isSystem) {
	        var key = createWidgetInfoCacheKey(bundleAlias, widgetTypeAlias, isSystem);
	        delete widgetsInfoInMemoryCache[key];
	        delete widgetsTypeFunctionsInMemoryCache[key];
	    }
	
	    function deleteWidgetsBundleFromCache(bundleAlias, isSystem) {
	        var key = (isSystem ? 'sys_' : '') + bundleAlias;
	        for (var cacheKey in widgetsInfoInMemoryCache) {
	            if (cacheKey.startsWith(key)) {
	                delete widgetsInfoInMemoryCache[cacheKey];
	                delete widgetsTypeFunctionsInMemoryCache[cacheKey];
	            }
	        }
	    }
	
	    /** Bundle functions **/
	
	    function invalidateWidgetsBundleCache() {
	        allWidgetsBundles = undefined;
	        systemWidgetsBundles = undefined;
	        tenantWidgetsBundles = undefined;
	    }
	
	    function loadWidgetsBundleCache(config) {
	        var deferred = $q.defer();
	        if (!allWidgetsBundles) {
	            var url = '/api/widgetsBundles';
	            $http.get(url, config).then(function success(response) {
	                allWidgetsBundles = response.data;
	                systemWidgetsBundles = [];
	                tenantWidgetsBundles = [];
	                allWidgetsBundles = $filter('orderBy')(allWidgetsBundles, ['+title', '-createdTime']);
	                for (var i = 0; i < allWidgetsBundles.length; i++) {
	                    var widgetsBundle = allWidgetsBundles[i];
	                    if (widgetsBundle.tenantId.id === types.id.nullUid) {
	                        systemWidgetsBundles.push(widgetsBundle);
	                    } else {
	                        tenantWidgetsBundles.push(widgetsBundle);
	                    }
	                }
	                deferred.resolve();
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            deferred.resolve();
	        }
	        return deferred.promise;
	    }
	
	    function getSystemWidgetsBundles(config) {
	        var deferred = $q.defer();
	        loadWidgetsBundleCache(config).then(function success() {
	            deferred.resolve(systemWidgetsBundles);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getTenantWidgetsBundles(config) {
	        var deferred = $q.defer();
	        loadWidgetsBundleCache(config).then(function success() {
	            deferred.resolve(tenantWidgetsBundles);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getAllWidgetsBundles(config) {
	        var deferred = $q.defer();
	        loadWidgetsBundleCache(config).then(function success() {
	            deferred.resolve(allWidgetsBundles);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getSystemWidgetsBundlesByPageLink(pageLink) {
	        var deferred = $q.defer();
	        loadWidgetsBundleCache().then(function success() {
	            utils.filterSearchTextEntities(systemWidgetsBundles, 'title', pageLink, deferred);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getTenantWidgetsBundlesByPageLink(pageLink) {
	        var deferred = $q.defer();
	        loadWidgetsBundleCache().then(function success() {
	            utils.filterSearchTextEntities(tenantWidgetsBundles, 'title', pageLink, deferred);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getAllWidgetsBundlesByPageLink(pageLink) {
	        var deferred = $q.defer();
	        loadWidgetsBundleCache().then(function success() {
	            utils.filterSearchTextEntities(allWidgetsBundles, 'title', pageLink, deferred);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getWidgetsBundleByAlias(bundleAlias) {
	        var deferred = $q.defer();
	        loadWidgetsBundleCache().then(function success() {
	            var widgetsBundles = $filter('filter')(allWidgetsBundles, { alias: bundleAlias });
	            if (widgetsBundles.length > 0) {
	                deferred.resolve(widgetsBundles[0]);
	            } else {
	                deferred.resolve();
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveWidgetsBundle(widgetsBundle) {
	        var deferred = $q.defer();
	        var url = '/api/widgetsBundle';
	        $http.post(url, widgetsBundle).then(function success(response) {
	            invalidateWidgetsBundleCache();
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function getWidgetsBundle(widgetsBundleId) {
	        var deferred = $q.defer();
	
	        var url = '/api/widgetsBundle/' + widgetsBundleId;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	
	        return deferred.promise;
	    }
	
	    function deleteWidgetsBundle(widgetsBundleId) {
	        var deferred = $q.defer();
	
	        getWidgetsBundle(widgetsBundleId).then(function success(response) {
	            var widgetsBundle = response;
	            var url = '/api/widgetsBundle/' + widgetsBundleId;
	            $http.delete(url).then(function success() {
	                invalidateWidgetsBundleCache();
	                deleteWidgetsBundleFromCache(widgetsBundle.alias, widgetsBundle.tenantId.id === types.id.nullUid);
	                deferred.resolve();
	            }, function fail(response) {
	                deferred.reject(response.data);
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	
	        return deferred.promise;
	    }
	
	    function getBundleWidgetTypes(bundleAlias, isSystem) {
	        var deferred = $q.defer();
	        var url = '/api/widgetTypes?isSystem=' + (isSystem ? 'true' : 'false') + '&bundleAlias=' + bundleAlias;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    /** Widget type functions **/
	
	    function getInstantWidgetInfo(widget) {
	        var widgetInfo = getWidgetInfoFromCache(widget.bundleAlias, widget.typeAlias, widget.isSystemType);
	        if (widgetInfo) {
	            return widgetInfo;
	        } else {
	            return {};
	        }
	    }
	
	    function resolveWidgetsInfoFetchQueue(key, widgetInfo) {
	        var fetchQueue = widgetsInfoFetchQueue[key];
	        if (fetchQueue) {
	            for (var q in fetchQueue) {
	                if (isNaN(q)) continue;
	                fetchQueue[q].resolve(widgetInfo);
	            }
	            delete widgetsInfoFetchQueue[key];
	        }
	    }
	
	    function getWidgetInfo(bundleAlias, widgetTypeAlias, isSystem) {
	        var deferred = $q.defer();
	        var widgetInfo = getWidgetInfoFromCache(bundleAlias, widgetTypeAlias, isSystem);
	        if (widgetInfo) {
	            deferred.resolve(widgetInfo);
	        } else {
	            if ($rootScope.widgetEditMode) {
	                loadWidget(editingWidgetType, bundleAlias, isSystem, deferred);
	            } else {
	                var key = createWidgetInfoCacheKey(bundleAlias, widgetTypeAlias, isSystem);
	                var fetchQueue = widgetsInfoFetchQueue[key];
	                if (fetchQueue) {
	                    fetchQueue.push(deferred);
	                } else {
	                    fetchQueue = [];
	                    widgetsInfoFetchQueue[key] = fetchQueue;
	                    getWidgetType(bundleAlias, widgetTypeAlias, isSystem).then(function success(widgetType) {
	                        loadWidget(widgetType, bundleAlias, isSystem, deferred);
	                    }, function fail() {
	                        deferred.resolve(missingWidgetType);
	                        resolveWidgetsInfoFetchQueue(key, missingWidgetType);
	                    });
	                }
	            }
	        }
	        return deferred.promise;
	    }
	
	    function getWidgetTypeFunction(bundleAlias, widgetTypeAlias, isSystem) {
	        var widgetType = getWidgetTypeFunctionFromCache(bundleAlias, widgetTypeAlias, isSystem);
	        return widgetType;
	    }
	
	    function createWidgetTypeFunction(widgetInfo, name) {
	        var widgetTypeFunctionBody = 'return function ' + name + ' (ctx) {\n' + '    var self = this;\n' + '    self.ctx = ctx;\n\n'; /*+
	                                                                                                                                      '    self.onInit = function() {\n\n' +
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '    self.onDataUpdated = function() {\n\n' +
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '    self.useCustomDatasources = function() {\n\n' +
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '    self.typeParameters = function() {\n\n' +
	                                                                                                                                      return {
	                                                                                                                                      useCustomDatasources: false,
	                                                                                                                                      maxDatasources: -1, //unlimited
	                                                                                                                                      maxDataKeys: -1, //unlimited
	                                                                                                                                      dataKeysOptional: false,
	                                                                                                                                      stateData: false
	                                                                                                                                      };
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '    self.actionSources = function() {\n\n' +
	                                                                                                                                      return {
	                                                                                                                                      'headerButton': {
	                                                                                                                                      name: 'Header button',
	                                                                                                                                      multiple: true
	                                                                                                                                      }
	                                                                                                                                      };
	                                                                                                                                      }\n\n' +
	                                                                                                                                      '    self.onResize = function() {\n\n' +
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '    self.onEditModeChanged = function() {\n\n' +
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '    self.onMobileModeChanged = function() {\n\n' +
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '    self.getSettingsSchema = function() {\n\n' +
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '    self.getDataKeySettingsSchema = function() {\n\n' +
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '    self.onDestroy = function() {\n\n' +
	                                                                                                                                      '    }\n\n' +
	                                                                                                                                      '}';*/
	
	        widgetTypeFunctionBody += widgetInfo.controllerScript;
	        widgetTypeFunctionBody += '\n};\n';
	        try {
	            var widgetTypeFunction = new Function(widgetTypeFunctionBody);
	            var widgetType = widgetTypeFunction.apply(this);
	            var widgetTypeInstance = new widgetType();
	            var result = {
	                widgetTypeFunction: widgetType
	            };
	            if (angular.isFunction(widgetTypeInstance.getSettingsSchema)) {
	                result.settingsSchema = widgetTypeInstance.getSettingsSchema();
	            }
	            if (angular.isFunction(widgetTypeInstance.getDataKeySettingsSchema)) {
	                result.dataKeySettingsSchema = widgetTypeInstance.getDataKeySettingsSchema();
	            }
	            if (angular.isFunction(widgetTypeInstance.typeParameters)) {
	                result.typeParameters = widgetTypeInstance.typeParameters();
	            } else {
	                result.typeParameters = {};
	            }
	            if (angular.isFunction(widgetTypeInstance.useCustomDatasources)) {
	                result.typeParameters.useCustomDatasources = widgetTypeInstance.useCustomDatasources();
	            } else {
	                result.typeParameters.useCustomDatasources = false;
	            }
	            if (angular.isUndefined(result.typeParameters.maxDatasources)) {
	                result.typeParameters.maxDatasources = -1;
	            }
	            if (angular.isUndefined(result.typeParameters.maxDataKeys)) {
	                result.typeParameters.maxDataKeys = -1;
	            }
	            if (angular.isUndefined(result.typeParameters.dataKeysOptional)) {
	                result.typeParameters.dataKeysOptional = false;
	            }
	            if (angular.isUndefined(result.typeParameters.stateData)) {
	                result.typeParameters.stateData = false;
	            }
	            if (angular.isFunction(widgetTypeInstance.actionSources)) {
	                result.actionSources = widgetTypeInstance.actionSources();
	            } else {
	                result.actionSources = {};
	            }
	            for (var actionSourceId in types.widgetActionSources) {
	                result.actionSources[actionSourceId] = angular.copy(types.widgetActionSources[actionSourceId]);
	                result.actionSources[actionSourceId].name = $translate.instant(result.actionSources[actionSourceId].name) + '';
	            }
	
	            return result;
	        } catch (e) {
	            utils.processWidgetException(e);
	            throw e;
	        }
	    }
	
	    function processWidgetLoadError(errorMessages, cacheKey, deferred) {
	        var widgetInfo = angular.copy(errorWidgetType);
	        for (var e in errorMessages) {
	            var error = errorMessages[e];
	            widgetInfo.templateHtml += '<div class="tb-widget-error-msg">' + error + '</div>';
	        }
	        widgetInfo.templateHtml += '</div>';
	        deferred.resolve(widgetInfo);
	        resolveWidgetsInfoFetchQueue(cacheKey, widgetInfo);
	    }
	
	    function loadWidget(widgetType, bundleAlias, isSystem, deferred) {
	        var widgetInfo = toWidgetInfo(widgetType);
	        var key = createWidgetInfoCacheKey(bundleAlias, widgetInfo.alias, isSystem);
	        loadWidgetResources(widgetInfo, bundleAlias, isSystem).then(function success() {
	            var widgetType = null;
	            try {
	                widgetType = createWidgetTypeFunction(widgetInfo, key);
	            } catch (e) {
	                var details = utils.parseException(e);
	                var errorMessage = 'Failed to compile widget script. \n Error: ' + details.message;
	                processWidgetLoadError([errorMessage], key, deferred);
	            }
	            if (widgetType) {
	                if (widgetType.settingsSchema) {
	                    widgetInfo.typeSettingsSchema = widgetType.settingsSchema;
	                }
	                if (widgetType.dataKeySettingsSchema) {
	                    widgetInfo.typeDataKeySettingsSchema = widgetType.dataKeySettingsSchema;
	                }
	                widgetInfo.typeParameters = widgetType.typeParameters;
	                widgetInfo.actionSources = widgetType.actionSources;
	                putWidgetInfoToCache(widgetInfo, bundleAlias, widgetInfo.alias, isSystem);
	                putWidgetTypeFunctionToCache(widgetType.widgetTypeFunction, bundleAlias, widgetInfo.alias, isSystem);
	                deferred.resolve(widgetInfo);
	                resolveWidgetsInfoFetchQueue(key, widgetInfo);
	            }
	        }, function fail(errorMessages) {
	            processWidgetLoadError(errorMessages, key, deferred);
	        });
	    }
	
	    function getWidgetType(bundleAlias, widgetTypeAlias, isSystem) {
	        var deferred = $q.defer();
	        var url = '/api/widgetType?isSystem=' + (isSystem ? 'true' : 'false') + '&bundleAlias=' + bundleAlias + '&alias=' + widgetTypeAlias;
	        $http.get(url, null).then(function success(response) {
	            var widgetType = response.data;
	            deferred.resolve(widgetType);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getWidgetTypeById(widgetTypeId) {
	        var deferred = $q.defer();
	        var url = '/api/widgetType/' + widgetTypeId;
	        $http.get(url, null).then(function success(response) {
	            var widgetType = response.data;
	            deferred.resolve(widgetType);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteWidgetType(bundleAlias, widgetTypeAlias, isSystem) {
	        var deferred = $q.defer();
	        getWidgetType(bundleAlias, widgetTypeAlias, isSystem).then(function success(widgetType) {
	            var url = '/api/widgetType/' + widgetType.id.id;
	            $http.delete(url).then(function success() {
	                deleteWidgetInfoFromCache(bundleAlias, widgetTypeAlias, isSystem);
	                deferred.resolve();
	            }, function fail() {
	                deferred.reject();
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveWidgetType(widgetInfo, id, bundleAlias) {
	        var deferred = $q.defer();
	        var widgetType = toWidgetType(widgetInfo, id, undefined, bundleAlias);
	        var url = '/api/widgetType';
	        $http.post(url, widgetType).then(function success(response) {
	            var widgetType = response.data;
	            deleteWidgetInfoFromCache(widgetType.bundleAlias, widgetType.alias, widgetType.tenantId.id === types.id.nullUid);
	            deferred.resolve(widgetType);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveImportedWidgetType(widgetType) {
	        var deferred = $q.defer();
	        var url = '/api/widgetType';
	        $http.post(url, widgetType).then(function success(response) {
	            var widgetType = response.data;
	            deleteWidgetInfoFromCache(widgetType.bundleAlias, widgetType.alias, widgetType.tenantId.id === types.id.nullUid);
	            deferred.resolve(widgetType);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function loadWidgetResources(widgetInfo, bundleAlias, isSystem) {
	
	        var deferred = $q.defer();
	        var errors = [];
	
	        var widgetNamespace = "widget-type-" + (isSystem ? 'sys-' : '') + bundleAlias + '-' + widgetInfo.alias;
	        cssParser.cssPreviewNamespace = widgetNamespace;
	        cssParser.createStyleElement(widgetNamespace, widgetInfo.templateCss);
	
	        function loadNextOrComplete(i) {
	            i++;
	            if (i < widgetInfo.resources.length) {
	                loadNext(i);
	            } else {
	                if (errors.length > 0) {
	                    deferred.reject(errors);
	                } else {
	                    deferred.resolve();
	                }
	            }
	        }
	
	        function loadNext(i) {
	            var resourceUrl = widgetInfo.resources[i].url;
	            if (resourceUrl && resourceUrl.length > 0) {
	                $ocLazyLoad.load(resourceUrl).then(function success() {
	                    loadNextOrComplete(i);
	                }, function fail() {
	                    errors.push('Failed to load widget resource: \'' + resourceUrl + '\'');
	                    loadNextOrComplete(i);
	                });
	            } else {
	                loadNextOrComplete(i);
	            }
	        }
	
	        if (widgetInfo.resources.length > 0) {
	            loadNext(0);
	        } else {
	            deferred.resolve();
	        }
	
	        return deferred.promise;
	    }
	}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Menu.$inject = ["userService", "$state", "$rootScope"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.menu', [_user2.default]).factory('menu', Menu).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function Menu(userService, $state, $rootScope) {
	
	    var authority = '';
	    var sections = [];
	    var homeSections = [];
	
	    if (userService.isUserLoaded() === true) {
	        buildMenu();
	    }
	
	    var authenticatedHandle = $rootScope.$on('authenticated', function () {
	        buildMenu();
	    });
	
	    var service = {
	        authenticatedHandle: authenticatedHandle,
	        getHomeSections: getHomeSections,
	        getSections: getSections,
	        sectionHeight: sectionHeight,
	        sectionActive: sectionActive
	    };
	
	    return service;
	
	    function getSections() {
	        return sections;
	    }
	
	    function getHomeSections() {
	        return homeSections;
	    }
	
	    function buildMenu() {
	        var user = userService.getCurrentUser();
	        if (user) {
	            if (authority !== user.authority) {
	                sections = [];
	                authority = user.authority;
	                if (authority === 'SYS_ADMIN') {
	                    sections = [{
	                        name: 'home.home',
	                        type: 'link',
	                        state: 'home.links',
	                        icon: 'home'
	                    }, {
	                        name: 'tenant.tenants',
	                        type: 'link',
	                        state: 'home.tenants',
	                        icon: 'supervisor_account'
	                    }, {
	                        name: 'widget.widget-library',
	                        type: 'link',
	                        state: 'home.widgets-bundles',
	                        icon: 'now_widgets'
	                    }, {
	                        name: 'admin.system-settings',
	                        type: 'toggle',
	                        state: 'home.settings',
	                        height: '80px',
	                        icon: 'settings',
	                        pages: [{
	                            name: 'admin.general',
	                            type: 'link',
	                            state: 'home.settings.general',
	                            icon: 'settings_applications'
	                        }, {
	                            name: 'admin.outgoing-mail',
	                            type: 'link',
	                            state: 'home.settings.outgoing-mail',
	                            icon: 'mail'
	                        }]
	                    }];
	                    homeSections = [{
	                        name: 'tenant.management',
	                        places: [{
	                            name: 'tenant.tenants',
	                            icon: 'supervisor_account',
	                            state: 'home.tenants'
	                        }]
	                    }, {
	                        name: 'widget.management',
	                        places: [{
	                            name: 'widget.widget-library',
	                            icon: 'now_widgets',
	                            state: 'home.widgets-bundles'
	                        }]
	                    }, {
	                        name: 'admin.system-settings',
	                        places: [{
	                            name: 'admin.general',
	                            icon: 'settings_applications',
	                            state: 'home.settings.general'
	                        }, {
	                            name: 'admin.outgoing-mail',
	                            icon: 'mail',
	                            state: 'home.settings.outgoing-mail'
	                        }]
	                    }];
	                } else if (authority === 'TENANT_ADMIN') {
	                    sections = [{
	                        name: 'home.home',
	                        type: 'link',
	                        state: 'home.links',
	                        icon: 'home'
	                    }, {
	                        name: 'rulechain.rulechains',
	                        type: 'link',
	                        state: 'home.ruleChains',
	                        icon: 'settings_ethernet'
	                    }, {
	                        name: 'customer.customers',
	                        type: 'link',
	                        state: 'home.customers',
	                        icon: 'supervisor_account'
	                    }, {
	                        name: 'asset.assets',
	                        type: 'link',
	                        state: 'home.assets',
	                        icon: 'domain'
	                    }, {
	                        name: 'device.devices',
	                        type: 'link',
	                        state: 'home.devices',
	                        icon: 'devices_other'
	                    }, {
	                        name: 'entity-view.entity-views',
	                        type: 'link',
	                        state: 'home.entityViews',
	                        icon: 'view_quilt'
	                    }, {
	                        name: 'widget.widget-library',
	                        type: 'link',
	                        state: 'home.widgets-bundles',
	                        icon: 'now_widgets'
	                    }, {
	                        name: 'dashboard.dashboards',
	                        type: 'link',
	                        state: 'home.dashboards',
	                        icon: 'dashboards'
	                    }, {
	                        name: 'audit-log.audit-logs',
	                        type: 'link',
	                        state: 'home.auditLogs',
	                        icon: 'track_changes'
	                    }];
	
	                    homeSections = [{
	                        name: 'rulechain.management',
	                        places: [{
	                            name: 'rulechain.rulechains',
	                            icon: 'settings_ethernet',
	                            state: 'home.ruleChains'
	                        }]
	                    }, {
	                        name: 'customer.management',
	                        places: [{
	                            name: 'customer.customers',
	                            icon: 'supervisor_account',
	                            state: 'home.customers'
	                        }]
	                    }, {
	                        name: 'asset.management',
	                        places: [{
	                            name: 'asset.assets',
	                            icon: 'domain',
	                            state: 'home.assets'
	                        }]
	                    }, {
	                        name: 'device.management',
	                        places: [{
	                            name: 'device.devices',
	                            icon: 'devices_other',
	                            state: 'home.devices'
	                        }]
	                    }, {
	                        name: 'entity-view.management',
	                        places: [{
	                            name: 'entity-view.entity-views',
	                            icon: 'view_quilt',
	                            state: 'home.entityViews'
	                        }]
	                    }, {
	                        name: 'dashboard.management',
	                        places: [{
	                            name: 'widget.widget-library',
	                            icon: 'now_widgets',
	                            state: 'home.widgets-bundles'
	                        }, {
	                            name: 'dashboard.dashboards',
	                            icon: 'dashboard',
	                            state: 'home.dashboards'
	                        }]
	                    }, {
	                        name: 'audit-log.audit',
	                        places: [{
	                            name: 'audit-log.audit-logs',
	                            icon: 'track_changes',
	                            state: 'home.auditLogs'
	                        }]
	                    }];
	                } else if (authority === 'CUSTOMER_USER') {
	                    sections = [{
	                        name: 'home.home',
	                        type: 'link',
	                        state: 'home.links',
	                        icon: 'home'
	                    }, {
	                        name: 'asset.assets',
	                        type: 'link',
	                        state: 'home.assets',
	                        icon: 'domain'
	                    }, {
	                        name: 'device.devices',
	                        type: 'link',
	                        state: 'home.devices',
	                        icon: 'devices_other'
	                    }, {
	                        name: 'entity-view.entity-views',
	                        type: 'link',
	                        state: 'home.entityViews',
	                        icon: 'view_quilt'
	                    }, {
	                        name: 'dashboard.dashboards',
	                        type: 'link',
	                        state: 'home.dashboards',
	                        icon: 'dashboard'
	                    }];
	
	                    homeSections = [{
	                        name: 'asset.view-assets',
	                        places: [{
	                            name: 'asset.assets',
	                            icon: 'domain',
	                            state: 'home.assets'
	                        }]
	                    }, {
	                        name: 'device.view-devices',
	                        places: [{
	                            name: 'device.devices',
	                            icon: 'devices_other',
	                            state: 'home.devices'
	                        }]
	                    }, {
	                        name: 'entity-view.management',
	                        places: [{
	                            name: 'entity-view.entity-views',
	                            icon: 'view_quilt',
	                            state: 'home.entityViews'
	                        }]
	                    }, {
	                        name: 'dashboard.view-dashboards',
	                        places: [{
	                            name: 'dashboard.dashboards',
	                            icon: 'dashboard',
	                            state: 'home.dashboards'
	                        }]
	                    }];
	                }
	            }
	        }
	    }
	
	    function sectionHeight(section) {
	        if ($state.includes(section.state)) {
	            return section.height;
	        } else {
	            return '0px';
	        }
	    }
	
	    function sectionActive(section) {
	        return $state.includes(section.state);
	    }
	}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable */
	
	/* jshint unused:false */
	/* global base64_decode, CSSWizardView, window, console, jQuery */
	var fi = function fi() {
	
	    this.cssImportStatements = [];
	    this.cssKeyframeStatements = [];
	
	    this.cssRegex = new RegExp('([\\s\\S]*?){([\\s\\S]*?)}', 'gi');
	    this.cssMediaQueryRegex = '((@media [\\s\\S]*?){([\\s\\S]*?}\\s*?)})';
	    this.cssKeyframeRegex = '((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})';
	    this.combinedCSSRegex = '((\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})'; //to match css & media queries together
	    this.cssCommentsRegex = '(\\/\\*[\\s\\S]*?\\*\\/)';
	    this.cssImportStatementRegex = new RegExp('@import .*?;', 'gi');
	};
	
	/*
	 Strip outs css comments and returns cleaned css string
	
	 @param css, the original css string to be stipped out of comments
	
	 @return cleanedCSS contains no css comments
	 */
	fi.prototype.stripComments = function (cssString) {
	    var regex = new RegExp(this.cssCommentsRegex, 'gi');
	
	    return cssString.replace(regex, '');
	};
	
	/*
	 Parses given css string, and returns css object
	 keys as selectors and values are css rules
	 eliminates all css comments before parsing
	
	 @param source css string to be parsed
	
	 @return object css
	 */
	fi.prototype.parseCSS = function (source) {
	
	    if (source === undefined) {
	        return [];
	    }
	
	    var css = [];
	    //strip out comments
	    //source = this.stripComments(source);
	
	    //get import statements
	
	    while (true) {
	        var imports = this.cssImportStatementRegex.exec(source);
	        if (imports !== null) {
	            this.cssImportStatements.push(imports[0]);
	            css.push({
	                selector: '@imports',
	                type: 'imports',
	                styles: imports[0]
	            });
	        } else {
	            break;
	        }
	    }
	    source = source.replace(this.cssImportStatementRegex, '');
	    //get keyframe statements
	    var keyframesRegex = new RegExp(this.cssKeyframeRegex, 'gi');
	    var arr;
	    while (true) {
	        arr = keyframesRegex.exec(source);
	        if (arr === null) {
	            break;
	        }
	        css.push({
	            selector: '@keyframes',
	            type: 'keyframes',
	            styles: arr[0]
	        });
	    }
	    source = source.replace(keyframesRegex, '');
	
	    //unified regex
	    var unified = new RegExp(this.combinedCSSRegex, 'gi');
	
	    while (true) {
	        arr = unified.exec(source);
	        if (arr === null) {
	            break;
	        }
	        var selector = '';
	        if (arr[2] === undefined) {
	            selector = arr[5].split('\r\n').join('\n').trim();
	        } else {
	            selector = arr[2].split('\r\n').join('\n').trim();
	        }
	
	        /*
	         fetch comments and associate it with current selector
	         */
	        var commentsRegex = new RegExp(this.cssCommentsRegex, 'gi');
	        var comments = commentsRegex.exec(selector);
	        if (comments !== null) {
	            selector = selector.replace(commentsRegex, '').trim();
	        }
	
	        //determine the type
	        if (selector.indexOf('@media') !== -1) {
	            //we have a media query
	            var cssObject = {
	                selector: selector,
	                type: 'media',
	                subStyles: this.parseCSS(arr[3] + '\n}') //recursively parse media query inner css
	            };
	            if (comments !== null) {
	                cssObject.comments = comments[0];
	            }
	            css.push(cssObject);
	        } else {
	            //we have standart css
	            var rules = this.parseRules(arr[6]);
	            var style = {
	                selector: selector,
	                rules: rules
	            };
	            if (selector === '@font-face') {
	                style.type = 'font-face';
	            }
	            if (comments !== null) {
	                style.comments = comments[0];
	            }
	            css.push(style);
	        }
	    }
	
	    return css;
	};
	
	/*
	 parses given string containing css directives
	 and returns an array of objects containing ruleName:ruleValue pairs
	
	 @param rules, css directive string example
	 \n\ncolor:white;\n    font-size:18px;\n
	 */
	fi.prototype.parseRules = function (rules) {
	    //convert all windows style line endings to unix style line endings
	    rules = rules.split('\r\n').join('\n');
	    var ret = [];
	
	    // Split all rules but keep semicolon for base64 url data
	    rules = rules.split(/;(?![^\(]*\))/);
	
	    //proccess rules line by line
	    for (var i = 0; i < rules.length; i++) {
	        var line = rules[i];
	
	        //determine if line is a valid css directive, ie color:white;
	        line = line.trim();
	        if (line.indexOf(':') !== -1) {
	            //line contains :
	            line = line.split(':');
	            var cssDirective = line[0].trim();
	            var cssValue = line.slice(1).join(':').trim();
	
	            //more checks
	            if (cssDirective.length < 1 || cssValue.length < 1) {
	                continue; //there is no css directive or value that is of length 1 or 0
	                // PLAIN WRONG WHAT ABOUT margin:0; ?
	            }
	
	            //push rule
	            ret.push({
	                directive: cssDirective,
	                value: cssValue
	            });
	        } else {
	            //if there is no ':', but what if it was mis splitted value which starts with base64
	            if (line.trim().substr(0, 7) == 'base64,') {
	                //hack :)
	                ret[ret.length - 1].value += line.trim();
	            } else {
	                //add rule, even if it is defective
	                if (line.length > 0) {
	                    ret.push({
	                        directive: '',
	                        value: line,
	                        defective: true
	                    });
	                }
	            }
	        }
	    }
	
	    return ret; //we are done!
	};
	/*
	 just returns the rule having given directive
	 if not found returns false;
	 */
	fi.prototype.findCorrespondingRule = function (rules, directive, value) {
	    if (value === undefined) {
	        value = false;
	    }
	    var ret = false;
	    for (var i = 0; i < rules.length; i++) {
	        if (rules[i].directive == directive) {
	            ret = rules[i];
	            if (value === rules[i].value) {
	                break;
	            }
	        }
	    }
	    return ret;
	};
	
	/*
	 Finds styles that have given selector, compress them,
	 and returns them
	 */
	fi.prototype.findBySelector = function (cssObjectArray, selector, contains) {
	    if (contains === undefined) {
	        contains = false;
	    }
	
	    var found = [];
	    for (var i = 0; i < cssObjectArray.length; i++) {
	        if (contains === false) {
	            if (cssObjectArray[i].selector === selector) {
	                found.push(cssObjectArray[i]);
	            }
	        } else {
	            if (cssObjectArray[i].selector.indexOf(selector) !== -1) {
	                found.push(cssObjectArray[i]);
	            }
	        }
	    }
	    if (found.length < 2) {
	        return found;
	    } else {
	        var base = found[0];
	        for (i = 1; i < found.length; i++) {
	            this.intelligentCSSPush([base], found[i]);
	        }
	        return [base]; //we are done!! all properties merged into base!
	    }
	};
	
	/*
	 deletes cssObjects having given selector, and returns new array
	 */
	fi.prototype.deleteBySelector = function (cssObjectArray, selector) {
	    var ret = [];
	    for (var i = 0; i < cssObjectArray.length; i++) {
	        if (cssObjectArray[i].selector !== selector) {
	            ret.push(cssObjectArray[i]);
	        }
	    }
	    return ret;
	};
	
	/*
	 Compresses given cssObjectArray and tries to minimize
	 selector redundence.
	 */
	fi.prototype.compressCSS = function (cssObjectArray) {
	    var compressed = [];
	    var done = {};
	    for (var i = 0; i < cssObjectArray.length; i++) {
	        var obj = cssObjectArray[i];
	        if (done[obj.selector] === true) {
	            continue;
	        }
	
	        var found = this.findBySelector(cssObjectArray, obj.selector); //found compressed
	        if (found.length !== 0) {
	            compressed.push(found[0]);
	            done[obj.selector] = true;
	        }
	    }
	    return compressed;
	};
	
	/*
	 Received 2 css objects with following structure
	 {
	 rules : [{directive:"", value:""}, {directive:"", value:""}, ...]
	 selector : "SOMESELECTOR"
	 }
	
	 returns the changed(new,removed,updated) values on css1 parameter, on same structure
	
	 if two css objects are the same, then returns false
	
	 if a css directive exists in css1 and     css2, and its value is different, it is included in diff
	 if a css directive exists in css1 and not css2, it is then included in diff
	 if a css directive exists in css2 but not css1, then it is deleted in css1, it would be included in diff but will be marked as type='DELETED'
	
	 @object css1 css object
	 @object css2 css object
	
	 @return diff css object contains changed values in css1 in regards to css2 see test input output in /test/data/css.js
	 */
	fi.prototype.cssDiff = function (css1, css2) {
	    if (css1.selector !== css2.selector) {
	        return false;
	    }
	
	    //if one of them is media query return false, because diff function can not operate on media queries
	    if (css1.type === 'media' || css2.type === 'media') {
	        return false;
	    }
	
	    var diff = {
	        selector: css1.selector,
	        rules: []
	    };
	    var rule1, rule2;
	    for (var i = 0; i < css1.rules.length; i++) {
	        rule1 = css1.rules[i];
	        //find rule2 which has the same directive as rule1
	        rule2 = this.findCorrespondingRule(css2.rules, rule1.directive, rule1.value);
	        if (rule2 === false) {
	            //rule1 is a new rule in css1
	            diff.rules.push(rule1);
	        } else {
	            //rule2 was found only push if its value is different too
	            if (rule1.value !== rule2.value) {
	                diff.rules.push(rule1);
	            }
	        }
	    }
	
	    //now for rules exists in css2 but not in css1, which means deleted rules
	    for (var ii = 0; ii < css2.rules.length; ii++) {
	        rule2 = css2.rules[ii];
	        //find rule2 which has the same directive as rule1
	        rule1 = this.findCorrespondingRule(css1.rules, rule2.directive);
	        if (rule1 === false) {
	            //rule1 is a new rule
	            rule2.type = 'DELETED'; //mark it as a deleted rule, so that other merge operations could be true
	            diff.rules.push(rule2);
	        }
	    }
	
	    if (diff.rules.length === 0) {
	        return false;
	    }
	    return diff;
	};
	
	/*
	 Merges 2 different css objects together
	 using intelligentCSSPush,
	
	 @param cssObjectArray, target css object array
	 @param newArray, source array that will be pushed into cssObjectArray parameter
	 @param reverse, [optional], if given true, first parameter will be traversed on reversed order
	 effectively giving priority to the styles in newArray
	 */
	fi.prototype.intelligentMerge = function (cssObjectArray, newArray, reverse) {
	    if (reverse === undefined) {
	        reverse = false;
	    }
	
	    for (var i = 0; i < newArray.length; i++) {
	        this.intelligentCSSPush(cssObjectArray, newArray[i], reverse);
	    }
	    for (i = 0; i < cssObjectArray.length; i++) {
	        var cobj = cssObjectArray[i];
	        if (cobj.type === 'media' || cobj.type === 'keyframes') {
	            continue;
	        }
	        cobj.rules = this.compactRules(cobj.rules);
	    }
	};
	
	/*
	 inserts new css objects into a bigger css object
	 with same selectors groupped together
	
	 @param cssObjectArray, array of bigger css object to be pushed into
	 @param minimalObject, single css object
	 @param reverse [optional] default is false, if given, cssObjectArray will be reversly traversed
	 resulting more priority in minimalObject's styles
	 */
	fi.prototype.intelligentCSSPush = function (cssObjectArray, minimalObject, reverse) {
	    var pushSelector = minimalObject.selector;
	    //find correct selector if not found just push minimalObject into cssObject
	    var cssObject = false;
	
	    if (reverse === undefined) {
	        reverse = false;
	    }
	
	    if (reverse === false) {
	        for (var i = 0; i < cssObjectArray.length; i++) {
	            if (cssObjectArray[i].selector === minimalObject.selector) {
	                cssObject = cssObjectArray[i];
	                break;
	            }
	        }
	    } else {
	        for (var j = cssObjectArray.length - 1; j > -1; j--) {
	            if (cssObjectArray[j].selector === minimalObject.selector) {
	                cssObject = cssObjectArray[j];
	                break;
	            }
	        }
	    }
	
	    if (cssObject === false) {
	        cssObjectArray.push(minimalObject); //just push, because cssSelector is new
	    } else {
	        if (minimalObject.type !== 'media') {
	            for (var ii = 0; ii < minimalObject.rules.length; ii++) {
	                var rule = minimalObject.rules[ii];
	                //find rule inside cssObject
	                var oldRule = this.findCorrespondingRule(cssObject.rules, rule.directive);
	                if (oldRule === false) {
	                    cssObject.rules.push(rule);
	                } else if (rule.type == 'DELETED') {
	                    oldRule.type = 'DELETED';
	                } else {
	                    //rule found just update value
	
	                    oldRule.value = rule.value;
	                }
	            }
	        } else {
	            cssObject.subStyles = minimalObject.subStyles; //TODO, make this intelligent too
	        }
	    }
	};
	
	/*
	 filter outs rule objects whose type param equal to DELETED
	
	 @param rules, array of rules
	
	 @returns rules array, compacted by deleting all unneccessary rules
	 */
	fi.prototype.compactRules = function (rules) {
	    var newRules = [];
	    for (var i = 0; i < rules.length; i++) {
	        if (rules[i].type !== 'DELETED') {
	            newRules.push(rules[i]);
	        }
	    }
	    return newRules;
	};
	/*
	 computes string for ace editor using this.css or given cssBase optional parameter
	
	 @param [optional] cssBase, if given computes cssString from cssObject array
	 */
	fi.prototype.getCSSForEditor = function (cssBase, depth) {
	    if (depth === undefined) {
	        depth = 0;
	    }
	    var ret = '';
	    if (cssBase === undefined) {
	        cssBase = this.css;
	    }
	    //append imports
	    for (var i = 0; i < cssBase.length; i++) {
	        if (cssBase[i].type == 'imports') {
	            ret += cssBase[i].styles + '\n\n';
	        }
	    }
	    for (i = 0; i < cssBase.length; i++) {
	        var tmp = cssBase[i];
	        if (tmp.selector === undefined) {
	            //temporarily omit media queries
	            continue;
	        }
	        var comments = "";
	        if (tmp.comments !== undefined) {
	            comments = tmp.comments + '\n';
	        }
	
	        if (tmp.type == 'media') {
	            //also put media queries to output
	            ret += comments + tmp.selector + '{\n';
	            ret += this.getCSSForEditor(tmp.subStyles, depth + 1);
	            ret += '}\n\n';
	        } else if (tmp.type !== 'keyframes' && tmp.type !== 'imports') {
	            ret += this.getSpaces(depth) + comments + tmp.selector + ' {\n';
	            ret += this.getCSSOfRules(tmp.rules, depth + 1);
	            ret += this.getSpaces(depth) + '}\n\n';
	        }
	    }
	
	    //append keyFrames
	    for (i = 0; i < cssBase.length; i++) {
	        if (cssBase[i].type == 'keyframes') {
	            ret += cssBase[i].styles + '\n\n';
	        }
	    }
	
	    return ret;
	};
	
	fi.prototype.getImports = function (cssObjectArray) {
	    var imps = [];
	    for (var i = 0; i < cssObjectArray.length; i++) {
	        if (cssObjectArray[i].type == 'imports') {
	            imps.push(cssObjectArray[i].styles);
	        }
	    }
	    return imps;
	};
	/*
	 given rules array, returns visually formatted css string
	 to be used inside editor
	 */
	fi.prototype.getCSSOfRules = function (rules, depth) {
	    var ret = '';
	    for (var i = 0; i < rules.length; i++) {
	        if (rules[i] === undefined) {
	            continue;
	        }
	        if (rules[i].defective === undefined) {
	            ret += this.getSpaces(depth) + rules[i].directive + ' : ' + rules[i].value + ';\n';
	        } else {
	            ret += this.getSpaces(depth) + rules[i].value + ';\n';
	        }
	    }
	    return ret || '\n';
	};
	
	/*
	 A very simple helper function returns number of spaces appended in a single string,
	 the number depends input parameter, namely input*2
	 */
	fi.prototype.getSpaces = function (num) {
	    var ret = '';
	    for (var i = 0; i < num * 4; i++) {
	        ret += ' ';
	    }
	    return ret;
	};
	
	/*
	 Given css string or objectArray, parses it and then for every selector,
	 prepends this.cssPreviewNamespace to prevent css collision issues
	
	 @returns css string in which this.cssPreviewNamespace prepended
	 */
	fi.prototype.applyNamespacing = function (css, forcedNamespace) {
	    var cssObjectArray = css;
	    var namespaceClass = '.' + this.cssPreviewNamespace;
	    if (forcedNamespace !== undefined) {
	        namespaceClass = forcedNamespace;
	    }
	
	    if (typeof css === 'string') {
	        cssObjectArray = this.parseCSS(css);
	    }
	
	    for (var i = 0; i < cssObjectArray.length; i++) {
	        var obj = cssObjectArray[i];
	
	        //bypass namespacing for @font-face @keyframes @import
	        if (obj.selector.indexOf('@font-face') > -1 || obj.selector.indexOf('keyframes') > -1 || obj.selector.indexOf('@import') > -1 || obj.selector.indexOf('.form-all') > -1 || obj.selector.indexOf('#stage') > -1) {
	            continue;
	        }
	
	        if (obj.type !== 'media') {
	            var selector = obj.selector.split(',');
	            var newSelector = [];
	            for (var j = 0; j < selector.length; j++) {
	                if (selector[j].indexOf('.supernova') === -1) {
	                    //do not apply namespacing to selectors including supernova
	                    newSelector.push(namespaceClass + ' ' + selector[j]);
	                } else {
	                    newSelector.push(selector[j]);
	                }
	            }
	            obj.selector = newSelector.join(',');
	        } else {
	            obj.subStyles = this.applyNamespacing(obj.subStyles, forcedNamespace); //handle media queries as well
	        }
	    }
	
	    return cssObjectArray;
	};
	
	/*
	 given css string or object array, clears possible namespacing from
	 all of the selectors inside the css
	 */
	fi.prototype.clearNamespacing = function (css, returnObj) {
	    if (returnObj === undefined) {
	        returnObj = false;
	    }
	    var cssObjectArray = css;
	    var namespaceClass = '.' + this.cssPreviewNamespace;
	    if (typeof css === 'string') {
	        cssObjectArray = this.parseCSS(css);
	    }
	
	    for (var i = 0; i < cssObjectArray.length; i++) {
	        var obj = cssObjectArray[i];
	
	        if (obj.type !== 'media') {
	            var selector = obj.selector.split(',');
	            var newSelector = [];
	            for (var j = 0; j < selector.length; j++) {
	                newSelector.push(selector[j].split(namespaceClass + ' ').join(''));
	            }
	            obj.selector = newSelector.join(',');
	        } else {
	            obj.subStyles = this.clearNamespacing(obj.subStyles, true); //handle media queries as well
	        }
	    }
	    if (returnObj === false) {
	        return this.getCSSForEditor(cssObjectArray);
	    } else {
	        return cssObjectArray;
	    }
	};
	
	/*
	 creates a new style tag (also destroys the previous one)
	 and injects given css string into that css tag
	 */
	fi.prototype.createStyleElement = function (id, css, format) {
	    if (format === undefined) {
	        format = false;
	    }
	
	    if (this.testMode === false && format !== 'nonamespace') {
	        //apply namespacing classes
	        css = this.applyNamespacing(css);
	    }
	
	    if (typeof css != 'string') {
	        css = this.getCSSForEditor(css);
	    }
	    //apply formatting for css
	    if (format === true) {
	        css = this.getCSSForEditor(this.parseCSS(css));
	    }
	
	    if (this.testMode !== false) {
	        return this.testMode('create style #' + id, css); //if test mode, just pass result to callback
	    }
	
	    var __el = document.getElementById(id);
	    if (__el) {
	        __el.parentNode.removeChild(__el);
	    }
	
	    var head = document.head || document.getElementsByTagName('head')[0],
	        style = document.createElement('style');
	
	    style.id = id;
	    style.type = 'text/css';
	
	    head.appendChild(style);
	
	    if (style.styleSheet && !style.sheet) {
	        style.styleSheet.cssText = css;
	    } else {
	        style.appendChild(document.createTextNode(css));
	    }
	};
	
	exports.default = fi;
	
	/* eslint-enable */

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noop = noop;
	exports.getKeyFromChildrenIndex = getKeyFromChildrenIndex;
	exports.loopMenuItem = loopMenuItem;
	exports.loopMenuItemRecusively = loopMenuItemRecusively;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function getKeyFromChildrenIndex(child, menuEventKey, index) {
	  var prefix = menuEventKey || '';
	  return child.key || prefix + 'item_' + index;
	}
	
	function loopMenuItem(children, cb) {
	  var index = -1;
	  _react2['default'].Children.forEach(children, function (c) {
	    index++;
	    if (c && c.type && c.type.isMenuItemGroup) {
	      _react2['default'].Children.forEach(c.props.children, function (c2) {
	        index++;
	        cb(c2, index);
	      });
	    } else {
	      cb(c, index);
	    }
	  });
	}
	
	function loopMenuItemRecusively(children, keys, ret) {
	  if (!children || ret.find) {
	    return;
	  }
	  _react2['default'].Children.forEach(children, function (c) {
	    if (ret.find) {
	      return;
	    }
	    if (c) {
	      var construt = c.type;
	      if (!construt || !(construt.isSubMenu || construt.isMenuItem || construt.isMenuItemGroup)) {
	        return;
	      }
	      if (keys.indexOf(c.key) !== -1) {
	        ret.find = true;
	      } else if (c.props.children) {
	        loopMenuItemRecusively(c.props.children, keys, ret);
	      }
	    }
	  });
	}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactErrorUtils = __webpack_require__(243);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var EventPluginRegistry = __webpack_require__(239);
	var ReactEventEmitterMixin = __webpack_require__(1624);
	var ViewportMetrics = __webpack_require__(245);
	
	var getVendorPrefixedEventName = __webpack_require__(1656);
	var isEventSupported = __webpack_require__(250);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(96);
	var ViewportMetrics = __webpack_require__(245);
	
	var getEventModifierState = __webpack_require__(248);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(11);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	var DOMNamespaces = __webpack_require__(238);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(246);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 20/09/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Help = function (_React$Component) {
	    _inherits(Help, _React$Component);
	
	    function Help() {
	        _classCallCheck(this, Help);
	
	        return _possibleConstructorReturn(this, (Help.__proto__ || Object.getPrototypeOf(Help)).apply(this, arguments));
	    }
	
	    _createClass(Help, [{
	        key: 'render',
	        value: function render() {
	            var classes = (0, _classnames2.default)(this.props.form.htmlClass);
	            //console.log('Help:', this.props);
	            return _react2.default.createElement('div', { className: classes, dangerouslySetInnerHTML: { __html: this.props.form.description } });
	        }
	    }]);
	
	    return Help;
	}(_react2.default.Component);
	
	var _default = Help;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Help, 'Help', 'src/Help.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/Help.js');
	}();
	
	;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(77);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ComposedComponent = __webpack_require__(58);
	
	var _ComposedComponent2 = _interopRequireDefault(_ComposedComponent);
	
	var _RadioButton = __webpack_require__(220);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _RadioButtonGroup = __webpack_require__(219);
	
	var _RadioButtonGroup2 = _interopRequireDefault(_RadioButtonGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radios = function (_React$Component) {
	    _inherits(Radios, _React$Component);
	
	    function Radios() {
	        _classCallCheck(this, Radios);
	
	        return _possibleConstructorReturn(this, (Radios.__proto__ || Object.getPrototypeOf(Radios)).apply(this, arguments));
	    }
	
	    _createClass(Radios, [{
	        key: 'render',
	        value: function render() {
	            var items = this.props.form.titleMap.map(function (item, index) {
	                return _react2.default.createElement(_RadioButton2.default, { label: item.name,
	                    value: item.value,
	                    key: index,
	                    disabled: this.props.form.readonly
	                });
	            }.bind(this));
	
	            return _react2.default.createElement(
	                'span',
	                { className: this.props.form.htmlClass },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'control-lable' },
	                    this.props.form.title
	                ),
	                _react2.default.createElement(
	                    _RadioButtonGroup2.default,
	                    { defaultSelected: this.props.value, name: this.props.form.title, onChange: this.props.onChangeValidate },
	                    items
	                )
	            );
	        }
	    }]);
	
	    return Radios;
	}(_react2.default.Component);
	
	var _default = (0, _ComposedComponent2.default)(Radios);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Radios, 'Radios', 'src/Radios.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/Radios.js');
	}();
	
	;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComposedComponent = __webpack_require__(58);
	
	var _ComposedComponent2 = _interopRequireDefault(_ComposedComponent);
	
	var _MenuItem = __webpack_require__(140);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _SelectField = __webpack_require__(360);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 15/09/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Select = function (_React$Component) {
	    _inherits(Select, _React$Component);
	
	    function Select(props) {
	        _classCallCheck(this, Select);
	
	        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
	        _this.onSelected = _this.onSelected.bind(_this);
	        var possibleValue = _this.getModelKey(_this.props.model, _this.props.form.key);
	        _this.state = {
	            currentValue: _this.props.model !== undefined && possibleValue ? possibleValue : _this.props.form.titleMap != null ? _this.props.form.titleMap[0].value : ''
	        };
	        return _this;
	    }
	
	    _createClass(Select, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.model && nextProps.form.key) {
	                this.setState({
	                    currentValue: this.getModelKey(nextProps.model, nextProps.form.key) || (nextProps.form.titleMap != null ? nextProps.form.titleMap[0].value : '')
	                });
	            }
	        }
	    }, {
	        key: 'getModelKey',
	        value: function getModelKey(model, key) {
	            if (Array.isArray(key)) {
	                return key.reduce(function (cur, nxt) {
	                    return cur[nxt] || {};
	                }, model);
	            } else {
	                return model[key];
	            }
	        }
	    }, {
	        key: 'onSelected',
	        value: function onSelected(event, selectedIndex, menuItem) {
	
	            this.setState({
	                currentValue: menuItem
	            });
	            event.target.value = menuItem;
	            this.props.onChangeValidate(event);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var menuItems = this.props.form.titleMap.map(function (item, idx) {
	                return _react2.default.createElement(_MenuItem2.default, { key: idx,
	                    primaryText: item.name,
	                    value: item.value });
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.form.htmlClass },
	                _react2.default.createElement(
	                    _SelectField2.default,
	                    {
	                        value: this.state.currentValue,
	                        floatingLabelText: this.props.form.title,
	                        disabled: this.props.form.readonly,
	                        onChange: this.onSelected,
	                        fullWidth: true },
	                    menuItems
	                )
	            );
	        }
	    }]);
	
	    return Select;
	}(_react2.default.Component);
	
	// Select.propTypes = {
	//
	// };
	
	var _default = (0, _ComposedComponent2.default)(Select);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Select, 'Select', 'src/Select.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/Select.js');
	}();
	
	;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(174)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	var zlib = __webpack_require__(658);
	
	var AVAILABLE_WINDOW_BITS = [8, 9, 10, 11, 12, 13, 14, 15];
	var DEFAULT_WINDOW_BITS = 15;
	var DEFAULT_MEM_LEVEL = 8;
	
	PerMessageDeflate.extensionName = 'permessage-deflate';
	
	/**
	 * Per-message Compression Extensions implementation
	 */
	
	function PerMessageDeflate(options, isServer,maxPayload) {
	  if (this instanceof PerMessageDeflate === false) {
	    throw new TypeError("Classes can't be function-called");
	  }
	
	  this._options = options || {};
	  this._isServer = !!isServer;
	  this._inflate = null;
	  this._deflate = null;
	  this.params = null;
	  this._maxPayload = maxPayload || 0;
	}
	
	/**
	 * Create extension parameters offer
	 *
	 * @api public
	 */
	
	PerMessageDeflate.prototype.offer = function() {
	  var params = {};
	  if (this._options.serverNoContextTakeover) {
	    params.server_no_context_takeover = true;
	  }
	  if (this._options.clientNoContextTakeover) {
	    params.client_no_context_takeover = true;
	  }
	  if (this._options.serverMaxWindowBits) {
	    params.server_max_window_bits = this._options.serverMaxWindowBits;
	  }
	  if (this._options.clientMaxWindowBits) {
	    params.client_max_window_bits = this._options.clientMaxWindowBits;
	  } else if (this._options.clientMaxWindowBits == null) {
	    params.client_max_window_bits = true;
	  }
	  return params;
	};
	
	/**
	 * Accept extension offer
	 *
	 * @api public
	 */
	
	PerMessageDeflate.prototype.accept = function(paramsList) {
	  paramsList = this.normalizeParams(paramsList);
	
	  var params;
	  if (this._isServer) {
	    params = this.acceptAsServer(paramsList);
	  } else {
	    params = this.acceptAsClient(paramsList);
	  }
	
	  this.params = params;
	  return params;
	};
	
	/**
	 * Releases all resources used by the extension
	 *
	 * @api public
	 */
	
	PerMessageDeflate.prototype.cleanup = function() {
	  if (this._inflate) {
	    if (this._inflate.writeInProgress) {
	      this._inflate.pendingClose = true;
	    } else {
	      if (this._inflate.close) this._inflate.close();
	      this._inflate = null;
	    }
	  }
	  if (this._deflate) {
	    if (this._deflate.writeInProgress) {
	      this._deflate.pendingClose = true;
	    } else {
	      if (this._deflate.close) this._deflate.close();
	      this._deflate = null;
	    }
	  }
	};
	
	/**
	 * Accept extension offer from client
	 *
	 * @api private
	 */
	
	PerMessageDeflate.prototype.acceptAsServer = function(paramsList) {
	  var accepted = {};
	  var result = paramsList.some(function(params) {
	    accepted = {};
	    if (this._options.serverNoContextTakeover === false && params.server_no_context_takeover) {
	      return;
	    }
	    if (this._options.serverMaxWindowBits === false && params.server_max_window_bits) {
	      return;
	    }
	    if (typeof this._options.serverMaxWindowBits === 'number' &&
	        typeof params.server_max_window_bits === 'number' &&
	        this._options.serverMaxWindowBits > params.server_max_window_bits) {
	      return;
	    }
	    if (typeof this._options.clientMaxWindowBits === 'number' && !params.client_max_window_bits) {
	      return;
	    }
	
	    if (this._options.serverNoContextTakeover || params.server_no_context_takeover) {
	      accepted.server_no_context_takeover = true;
	    }
	    if (this._options.clientNoContextTakeover) {
	      accepted.client_no_context_takeover = true;
	    }
	    if (this._options.clientNoContextTakeover !== false && params.client_no_context_takeover) {
	      accepted.client_no_context_takeover = true;
	    }
	    if (typeof this._options.serverMaxWindowBits === 'number') {
	      accepted.server_max_window_bits = this._options.serverMaxWindowBits;
	    } else if (typeof params.server_max_window_bits === 'number') {
	      accepted.server_max_window_bits = params.server_max_window_bits;
	    }
	    if (typeof this._options.clientMaxWindowBits === 'number') {
	      accepted.client_max_window_bits = this._options.clientMaxWindowBits;
	    } else if (this._options.clientMaxWindowBits !== false && typeof params.client_max_window_bits === 'number') {
	      accepted.client_max_window_bits = params.client_max_window_bits;
	    }
	    return true;
	  }, this);
	
	  if (!result) {
	    throw new Error('Doesn\'t support the offered configuration');
	  }
	
	  return accepted;
	};
	
	/**
	 * Accept extension response from server
	 *
	 * @api privaye
	 */
	
	PerMessageDeflate.prototype.acceptAsClient = function(paramsList) {
	  var params = paramsList[0];
	  if (this._options.clientNoContextTakeover != null) {
	    if (this._options.clientNoContextTakeover === false && params.client_no_context_takeover) {
	      throw new Error('Invalid value for "client_no_context_takeover"');
	    }
	  }
	  if (this._options.clientMaxWindowBits != null) {
	    if (this._options.clientMaxWindowBits === false && params.client_max_window_bits) {
	      throw new Error('Invalid value for "client_max_window_bits"');
	    }
	    if (typeof this._options.clientMaxWindowBits === 'number' &&
	        (!params.client_max_window_bits || params.client_max_window_bits > this._options.clientMaxWindowBits)) {
	      throw new Error('Invalid value for "client_max_window_bits"');
	    }
	  }
	  return params;
	};
	
	/**
	 * Normalize extensions parameters
	 *
	 * @api private
	 */
	
	PerMessageDeflate.prototype.normalizeParams = function(paramsList) {
	  return paramsList.map(function(params) {
	    Object.keys(params).forEach(function(key) {
	      var value = params[key];
	      if (value.length > 1) {
	        throw new Error('Multiple extension parameters for ' + key);
	      }
	
	      value = value[0];
	
	      switch (key) {
	      case 'server_no_context_takeover':
	      case 'client_no_context_takeover':
	        if (value !== true) {
	          throw new Error('invalid extension parameter value for ' + key + ' (' + value + ')');
	        }
	        params[key] = true;
	        break;
	      case 'server_max_window_bits':
	      case 'client_max_window_bits':
	        if (typeof value === 'string') {
	          value = parseInt(value, 10);
	          if (!~AVAILABLE_WINDOW_BITS.indexOf(value)) {
	            throw new Error('invalid extension parameter value for ' + key + ' (' + value + ')');
	          }
	        }
	        if (!this._isServer && value === true) {
	          throw new Error('Missing extension parameter value for ' + key);
	        }
	        params[key] = value;
	        break;
	      default:
	        throw new Error('Not defined extension parameter (' + key + ')');
	      }
	    }, this);
	    return params;
	  }, this);
	};
	
	/**
	 * Decompress message
	 *
	 * @api public
	 */
	
	PerMessageDeflate.prototype.decompress = function (data, fin, callback) {
	  var endpoint = this._isServer ? 'client' : 'server';
	
	  if (!this._inflate) {
	    var maxWindowBits = this.params[endpoint + '_max_window_bits'];
	    this._inflate = zlib.createInflateRaw({
	      windowBits: 'number' === typeof maxWindowBits ? maxWindowBits : DEFAULT_WINDOW_BITS
	    });
	  }
	  this._inflate.writeInProgress = true;
	
	  var self = this;
	  var buffers = [];
	  var cumulativeBufferLength=0;
	
	  this._inflate.on('error', onError).on('data', onData);
	  this._inflate.write(data);
	  if (fin) {
	    this._inflate.write(new Buffer([0x00, 0x00, 0xff, 0xff]));
	  }
	  this._inflate.flush(function() {
	    cleanup();
	    callback(null, Buffer.concat(buffers));
	  });
	
	  function onError(err) {
	    cleanup();
	    callback(err);
	  }
	
	  function onData(data) {
	      if(self._maxPayload!==undefined && self._maxPayload!==null && self._maxPayload>0){
	          cumulativeBufferLength+=data.length;
	          if(cumulativeBufferLength>self._maxPayload){
	            buffers=[];
	            cleanup();
	            var err={type:1009};
	            callback(err);
	            return;
	          }
	      }
	      buffers.push(data);
	  }
	
	  function cleanup() {
	    if (!self._inflate) return;
	    self._inflate.removeListener('error', onError);
	    self._inflate.removeListener('data', onData);
	    self._inflate.writeInProgress = false;
	    if ((fin && self.params[endpoint + '_no_context_takeover']) || self._inflate.pendingClose) {
	      if (self._inflate.close) self._inflate.close();
	      self._inflate = null;
	    }
	  }
	};
	
	/**
	 * Compress message
	 *
	 * @api public
	 */
	
	PerMessageDeflate.prototype.compress = function (data, fin, callback) {
	  var endpoint = this._isServer ? 'server' : 'client';
	
	  if (!this._deflate) {
	    var maxWindowBits = this.params[endpoint + '_max_window_bits'];
	    this._deflate = zlib.createDeflateRaw({
	      flush: zlib.Z_SYNC_FLUSH,
	      windowBits: 'number' === typeof maxWindowBits ? maxWindowBits : DEFAULT_WINDOW_BITS,
	      memLevel: this._options.memLevel || DEFAULT_MEM_LEVEL
	    });
	  }
	  this._deflate.writeInProgress = true;
	
	  var self = this;
	  var buffers = [];
	
	  this._deflate.on('error', onError).on('data', onData);
	  this._deflate.write(data);
	  this._deflate.flush(function() {
	    cleanup();
	    var data = Buffer.concat(buffers);
	    if (fin) {
	      data = data.slice(0, data.length - 4);
	    }
	    callback(null, data);
	  });
	
	  function onError(err) {
	    cleanup();
	    callback(err);
	  }
	
	  function onData(data) {
	    buffers.push(data);
	  }
	
	  function cleanup() {
	    if (!self._deflate) return;
	    self._deflate.removeListener('error', onError);
	    self._deflate.removeListener('data', onData);
	    self._deflate.writeInProgress = false;
	    if ((fin && self.params[endpoint + '_no_context_takeover']) || self._deflate.pendingClose) {
	      if (self._deflate.close) self._deflate.close();
	      self._deflate = null;
	    }
	  }
	};
	
	module.exports = PerMessageDeflate;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(608);
	module.exports = 'ngMessages';


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(670), __esModule: true };

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(672), __esModule: true };

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(641);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(271);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/* ***** BEGIN LICENSE BLOCK *****
	 * Distributed under the BSD license:
	 *
	 * Copyright (c) 2010, Ajax.org B.V.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *     * Redistributions of source code must retain the above copyright
	 *       notice, this list of conditions and the following disclaimer.
	 *     * Redistributions in binary form must reproduce the above copyright
	 *       notice, this list of conditions and the following disclaimer in the
	 *       documentation and/or other materials provided with the distribution.
	 *     * Neither the name of Ajax.org B.V. nor the
	 *       names of its contributors may be used to endorse or promote products
	 *       derived from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
	 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
	 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 *
	 * ***** END LICENSE BLOCK ***** */
	
	/**
	 * Define a module along with a payload
	 * @param module a name for the payload
	 * @param payload a function to call with (acequire, exports, module) params
	 */
	
	(function() {
	
	var ACE_NAMESPACE = "ace";
	
	var global = (function() { return this; })();
	if (!global && typeof window != "undefined") global = window; // strict mode
	
	
	if (!ACE_NAMESPACE && typeof acequirejs !== "undefined")
	    return;
	
	
	var define = function(module, deps, payload) {
	    if (typeof module !== "string") {
	        if (define.original)
	            define.original.apply(this, arguments);
	        else {
	            console.error("dropping module because define wasn\'t a string.");
	            console.trace();
	        }
	        return;
	    }
	    if (arguments.length == 2)
	        payload = deps;
	    if (!define.modules[module]) {
	        define.payloads[module] = payload;
	        define.modules[module] = null;
	    }
	};
	
	define.modules = {};
	define.payloads = {};
	
	/**
	 * Get at functionality define()ed using the function above
	 */
	var _acequire = function(parentId, module, callback) {
	    if (typeof module === "string") {
	        var payload = lookup(parentId, module);
	        if (payload != undefined) {
	            callback && callback();
	            return payload;
	        }
	    } else if (Object.prototype.toString.call(module) === "[object Array]") {
	        var params = [];
	        for (var i = 0, l = module.length; i < l; ++i) {
	            var dep = lookup(parentId, module[i]);
	            if (dep == undefined && acequire.original)
	                return;
	            params.push(dep);
	        }
	        return callback && callback.apply(null, params) || true;
	    }
	};
	
	var acequire = function(module, callback) {
	    var packagedModule = _acequire("", module, callback);
	    if (packagedModule == undefined && acequire.original)
	        return acequire.original.apply(this, arguments);
	    return packagedModule;
	};
	
	var normalizeModule = function(parentId, moduleName) {
	    // normalize plugin acequires
	    if (moduleName.indexOf("!") !== -1) {
	        var chunks = moduleName.split("!");
	        return normalizeModule(parentId, chunks[0]) + "!" + normalizeModule(parentId, chunks[1]);
	    }
	    // normalize relative acequires
	    if (moduleName.charAt(0) == ".") {
	        var base = parentId.split("/").slice(0, -1).join("/");
	        moduleName = base + "/" + moduleName;
	
	        while(moduleName.indexOf(".") !== -1 && previous != moduleName) {
	            var previous = moduleName;
	            moduleName = moduleName.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
	        }
	    }
	    return moduleName;
	};
	
	/**
	 * Internal function to lookup moduleNames and resolve them by calling the
	 * definition function if needed.
	 */
	var lookup = function(parentId, moduleName) {
	    moduleName = normalizeModule(parentId, moduleName);
	
	    var module = define.modules[moduleName];
	    if (!module) {
	        module = define.payloads[moduleName];
	        if (typeof module === 'function') {
	            var exports = {};
	            var mod = {
	                id: moduleName,
	                uri: '',
	                exports: exports,
	                packaged: true
	            };
	
	            var req = function(module, callback) {
	                return _acequire(moduleName, module, callback);
	            };
	
	            var returnValue = module(req, exports, mod);
	            exports = returnValue || mod.exports;
	            define.modules[moduleName] = exports;
	            delete define.payloads[moduleName];
	        }
	        module = define.modules[moduleName] = exports || module;
	    }
	    return module;
	};
	
	function exportAce(ns) {
	    var root = global;
	    if (ns) {
	        if (!global[ns])
	            global[ns] = {};
	        root = global[ns];
	    }
	
	    if (!root.define || !root.define.packaged) {
	        define.original = root.define;
	        root.define = define;
	        root.define.packaged = true;
	    }
	
	    if (!root.acequire || !root.acequire.packaged) {
	        acequire.original = root.acequire;
	        root.acequire = acequire;
	        root.acequire.packaged = true;
	    }
	}
	
	exportAce(ACE_NAMESPACE);
	
	})();
	
	ace.define("ace/lib/regexp",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	    var real = {
	            exec: RegExp.prototype.exec,
	            test: RegExp.prototype.test,
	            match: String.prototype.match,
	            replace: String.prototype.replace,
	            split: String.prototype.split
	        },
	        compliantExecNpcg = real.exec.call(/()??/, "")[1] === undefined, // check `exec` handling of nonparticipating capturing groups
	        compliantLastIndexIncrement = function () {
	            var x = /^/g;
	            real.test.call(x, "");
	            return !x.lastIndex;
	        }();
	
	    if (compliantLastIndexIncrement && compliantExecNpcg)
	        return;
	    RegExp.prototype.exec = function (str) {
	        var match = real.exec.apply(this, arguments),
	            name, r2;
	        if ( typeof(str) == 'string' && match) {
	            if (!compliantExecNpcg && match.length > 1 && indexOf(match, "") > -1) {
	                r2 = RegExp(this.source, real.replace.call(getNativeFlags(this), "g", ""));
	                real.replace.call(str.slice(match.index), r2, function () {
	                    for (var i = 1; i < arguments.length - 2; i++) {
	                        if (arguments[i] === undefined)
	                            match[i] = undefined;
	                    }
	                });
	            }
	            if (this._xregexp && this._xregexp.captureNames) {
	                for (var i = 1; i < match.length; i++) {
	                    name = this._xregexp.captureNames[i - 1];
	                    if (name)
	                       match[name] = match[i];
	                }
	            }
	            if (!compliantLastIndexIncrement && this.global && !match[0].length && (this.lastIndex > match.index))
	                this.lastIndex--;
	        }
	        return match;
	    };
	    if (!compliantLastIndexIncrement) {
	        RegExp.prototype.test = function (str) {
	            var match = real.exec.call(this, str);
	            if (match && this.global && !match[0].length && (this.lastIndex > match.index))
	                this.lastIndex--;
	            return !!match;
	        };
	    }
	
	    function getNativeFlags (regex) {
	        return (regex.global     ? "g" : "") +
	               (regex.ignoreCase ? "i" : "") +
	               (regex.multiline  ? "m" : "") +
	               (regex.extended   ? "x" : "") + // Proposed for ES4; included in AS3
	               (regex.sticky     ? "y" : "");
	    }
	
	    function indexOf (array, item, from) {
	        if (Array.prototype.indexOf) // Use the native array method if available
	            return array.indexOf(item, from);
	        for (var i = from || 0; i < array.length; i++) {
	            if (array[i] === item)
	                return i;
	        }
	        return -1;
	    }
	
	});
	
	ace.define("ace/lib/es5-shim",["require","exports","module"], function(acequire, exports, module) {
	
	function Empty() {}
	
	if (!Function.prototype.bind) {
	    Function.prototype.bind = function bind(that) { // .length is 1
	        var target = this;
	        if (typeof target != "function") {
	            throw new TypeError("Function.prototype.bind called on incompatible " + target);
	        }
	        var args = slice.call(arguments, 1); // for normal call
	        var bound = function () {
	
	            if (this instanceof bound) {
	
	                var result = target.apply(
	                    this,
	                    args.concat(slice.call(arguments))
	                );
	                if (Object(result) === result) {
	                    return result;
	                }
	                return this;
	
	            } else {
	                return target.apply(
	                    that,
	                    args.concat(slice.call(arguments))
	                );
	
	            }
	
	        };
	        if(target.prototype) {
	            Empty.prototype = target.prototype;
	            bound.prototype = new Empty();
	            Empty.prototype = null;
	        }
	        return bound;
	    };
	}
	var call = Function.prototype.call;
	var prototypeOfArray = Array.prototype;
	var prototypeOfObject = Object.prototype;
	var slice = prototypeOfArray.slice;
	var _toString = call.bind(prototypeOfObject.toString);
	var owns = call.bind(prototypeOfObject.hasOwnProperty);
	var defineGetter;
	var defineSetter;
	var lookupGetter;
	var lookupSetter;
	var supportsAccessors;
	if ((supportsAccessors = owns(prototypeOfObject, "__defineGetter__"))) {
	    defineGetter = call.bind(prototypeOfObject.__defineGetter__);
	    defineSetter = call.bind(prototypeOfObject.__defineSetter__);
	    lookupGetter = call.bind(prototypeOfObject.__lookupGetter__);
	    lookupSetter = call.bind(prototypeOfObject.__lookupSetter__);
	}
	if ([1,2].splice(0).length != 2) {
	    if(function() { // test IE < 9 to splice bug - see issue #138
	        function makeArray(l) {
	            var a = new Array(l+2);
	            a[0] = a[1] = 0;
	            return a;
	        }
	        var array = [], lengthBefore;
	        
	        array.splice.apply(array, makeArray(20));
	        array.splice.apply(array, makeArray(26));
	
	        lengthBefore = array.length; //46
	        array.splice(5, 0, "XXX"); // add one element
	
	        lengthBefore + 1 == array.length
	
	        if (lengthBefore + 1 == array.length) {
	            return true;// has right splice implementation without bugs
	        }
	    }()) {//IE 6/7
	        var array_splice = Array.prototype.splice;
	        Array.prototype.splice = function(start, deleteCount) {
	            if (!arguments.length) {
	                return [];
	            } else {
	                return array_splice.apply(this, [
	                    start === void 0 ? 0 : start,
	                    deleteCount === void 0 ? (this.length - start) : deleteCount
	                ].concat(slice.call(arguments, 2)))
	            }
	        };
	    } else {//IE8
	        Array.prototype.splice = function(pos, removeCount){
	            var length = this.length;
	            if (pos > 0) {
	                if (pos > length)
	                    pos = length;
	            } else if (pos == void 0) {
	                pos = 0;
	            } else if (pos < 0) {
	                pos = Math.max(length + pos, 0);
	            }
	
	            if (!(pos+removeCount < length))
	                removeCount = length - pos;
	
	            var removed = this.slice(pos, pos+removeCount);
	            var insert = slice.call(arguments, 2);
	            var add = insert.length;            
	            if (pos === length) {
	                if (add) {
	                    this.push.apply(this, insert);
	                }
	            } else {
	                var remove = Math.min(removeCount, length - pos);
	                var tailOldPos = pos + remove;
	                var tailNewPos = tailOldPos + add - remove;
	                var tailCount = length - tailOldPos;
	                var lengthAfterRemove = length - remove;
	
	                if (tailNewPos < tailOldPos) { // case A
	                    for (var i = 0; i < tailCount; ++i) {
	                        this[tailNewPos+i] = this[tailOldPos+i];
	                    }
	                } else if (tailNewPos > tailOldPos) { // case B
	                    for (i = tailCount; i--; ) {
	                        this[tailNewPos+i] = this[tailOldPos+i];
	                    }
	                } // else, add == remove (nothing to do)
	
	                if (add && pos === lengthAfterRemove) {
	                    this.length = lengthAfterRemove; // truncate array
	                    this.push.apply(this, insert);
	                } else {
	                    this.length = lengthAfterRemove + add; // reserves space
	                    for (i = 0; i < add; ++i) {
	                        this[pos+i] = insert[i];
	                    }
	                }
	            }
	            return removed;
	        };
	    }
	}
	if (!Array.isArray) {
	    Array.isArray = function isArray(obj) {
	        return _toString(obj) == "[object Array]";
	    };
	}
	var boxedString = Object("a"),
	    splitString = boxedString[0] != "a" || !(0 in boxedString);
	
	if (!Array.prototype.forEach) {
	    Array.prototype.forEach = function forEach(fun /*, thisp*/) {
	        var object = toObject(this),
	            self = splitString && _toString(this) == "[object String]" ?
	                this.split("") :
	                object,
	            thisp = arguments[1],
	            i = -1,
	            length = self.length >>> 0;
	        if (_toString(fun) != "[object Function]") {
	            throw new TypeError(); // TODO message
	        }
	
	        while (++i < length) {
	            if (i in self) {
	                fun.call(thisp, self[i], i, object);
	            }
	        }
	    };
	}
	if (!Array.prototype.map) {
	    Array.prototype.map = function map(fun /*, thisp*/) {
	        var object = toObject(this),
	            self = splitString && _toString(this) == "[object String]" ?
	                this.split("") :
	                object,
	            length = self.length >>> 0,
	            result = Array(length),
	            thisp = arguments[1];
	        if (_toString(fun) != "[object Function]") {
	            throw new TypeError(fun + " is not a function");
	        }
	
	        for (var i = 0; i < length; i++) {
	            if (i in self)
	                result[i] = fun.call(thisp, self[i], i, object);
	        }
	        return result;
	    };
	}
	if (!Array.prototype.filter) {
	    Array.prototype.filter = function filter(fun /*, thisp */) {
	        var object = toObject(this),
	            self = splitString && _toString(this) == "[object String]" ?
	                this.split("") :
	                    object,
	            length = self.length >>> 0,
	            result = [],
	            value,
	            thisp = arguments[1];
	        if (_toString(fun) != "[object Function]") {
	            throw new TypeError(fun + " is not a function");
	        }
	
	        for (var i = 0; i < length; i++) {
	            if (i in self) {
	                value = self[i];
	                if (fun.call(thisp, value, i, object)) {
	                    result.push(value);
	                }
	            }
	        }
	        return result;
	    };
	}
	if (!Array.prototype.every) {
	    Array.prototype.every = function every(fun /*, thisp */) {
	        var object = toObject(this),
	            self = splitString && _toString(this) == "[object String]" ?
	                this.split("") :
	                object,
	            length = self.length >>> 0,
	            thisp = arguments[1];
	        if (_toString(fun) != "[object Function]") {
	            throw new TypeError(fun + " is not a function");
	        }
	
	        for (var i = 0; i < length; i++) {
	            if (i in self && !fun.call(thisp, self[i], i, object)) {
	                return false;
	            }
	        }
	        return true;
	    };
	}
	if (!Array.prototype.some) {
	    Array.prototype.some = function some(fun /*, thisp */) {
	        var object = toObject(this),
	            self = splitString && _toString(this) == "[object String]" ?
	                this.split("") :
	                object,
	            length = self.length >>> 0,
	            thisp = arguments[1];
	        if (_toString(fun) != "[object Function]") {
	            throw new TypeError(fun + " is not a function");
	        }
	
	        for (var i = 0; i < length; i++) {
	            if (i in self && fun.call(thisp, self[i], i, object)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	if (!Array.prototype.reduce) {
	    Array.prototype.reduce = function reduce(fun /*, initial*/) {
	        var object = toObject(this),
	            self = splitString && _toString(this) == "[object String]" ?
	                this.split("") :
	                object,
	            length = self.length >>> 0;
	        if (_toString(fun) != "[object Function]") {
	            throw new TypeError(fun + " is not a function");
	        }
	        if (!length && arguments.length == 1) {
	            throw new TypeError("reduce of empty array with no initial value");
	        }
	
	        var i = 0;
	        var result;
	        if (arguments.length >= 2) {
	            result = arguments[1];
	        } else {
	            do {
	                if (i in self) {
	                    result = self[i++];
	                    break;
	                }
	                if (++i >= length) {
	                    throw new TypeError("reduce of empty array with no initial value");
	                }
	            } while (true);
	        }
	
	        for (; i < length; i++) {
	            if (i in self) {
	                result = fun.call(void 0, result, self[i], i, object);
	            }
	        }
	
	        return result;
	    };
	}
	if (!Array.prototype.reduceRight) {
	    Array.prototype.reduceRight = function reduceRight(fun /*, initial*/) {
	        var object = toObject(this),
	            self = splitString && _toString(this) == "[object String]" ?
	                this.split("") :
	                object,
	            length = self.length >>> 0;
	        if (_toString(fun) != "[object Function]") {
	            throw new TypeError(fun + " is not a function");
	        }
	        if (!length && arguments.length == 1) {
	            throw new TypeError("reduceRight of empty array with no initial value");
	        }
	
	        var result, i = length - 1;
	        if (arguments.length >= 2) {
	            result = arguments[1];
	        } else {
	            do {
	                if (i in self) {
	                    result = self[i--];
	                    break;
	                }
	                if (--i < 0) {
	                    throw new TypeError("reduceRight of empty array with no initial value");
	                }
	            } while (true);
	        }
	
	        do {
	            if (i in this) {
	                result = fun.call(void 0, result, self[i], i, object);
	            }
	        } while (i--);
	
	        return result;
	    };
	}
	if (!Array.prototype.indexOf || ([0, 1].indexOf(1, 2) != -1)) {
	    Array.prototype.indexOf = function indexOf(sought /*, fromIndex */ ) {
	        var self = splitString && _toString(this) == "[object String]" ?
	                this.split("") :
	                toObject(this),
	            length = self.length >>> 0;
	
	        if (!length) {
	            return -1;
	        }
	
	        var i = 0;
	        if (arguments.length > 1) {
	            i = toInteger(arguments[1]);
	        }
	        i = i >= 0 ? i : Math.max(0, length + i);
	        for (; i < length; i++) {
	            if (i in self && self[i] === sought) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	if (!Array.prototype.lastIndexOf || ([0, 1].lastIndexOf(0, -3) != -1)) {
	    Array.prototype.lastIndexOf = function lastIndexOf(sought /*, fromIndex */) {
	        var self = splitString && _toString(this) == "[object String]" ?
	                this.split("") :
	                toObject(this),
	            length = self.length >>> 0;
	
	        if (!length) {
	            return -1;
	        }
	        var i = length - 1;
	        if (arguments.length > 1) {
	            i = Math.min(i, toInteger(arguments[1]));
	        }
	        i = i >= 0 ? i : length - Math.abs(i);
	        for (; i >= 0; i--) {
	            if (i in self && sought === self[i]) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	if (!Object.getPrototypeOf) {
	    Object.getPrototypeOf = function getPrototypeOf(object) {
	        return object.__proto__ || (
	            object.constructor ?
	            object.constructor.prototype :
	            prototypeOfObject
	        );
	    };
	}
	if (!Object.getOwnPropertyDescriptor) {
	    var ERR_NON_OBJECT = "Object.getOwnPropertyDescriptor called on a " +
	                         "non-object: ";
	    Object.getOwnPropertyDescriptor = function getOwnPropertyDescriptor(object, property) {
	        if ((typeof object != "object" && typeof object != "function") || object === null)
	            throw new TypeError(ERR_NON_OBJECT + object);
	        if (!owns(object, property))
	            return;
	
	        var descriptor, getter, setter;
	        descriptor =  { enumerable: true, configurable: true };
	        if (supportsAccessors) {
	            var prototype = object.__proto__;
	            object.__proto__ = prototypeOfObject;
	
	            var getter = lookupGetter(object, property);
	            var setter = lookupSetter(object, property);
	            object.__proto__ = prototype;
	
	            if (getter || setter) {
	                if (getter) descriptor.get = getter;
	                if (setter) descriptor.set = setter;
	                return descriptor;
	            }
	        }
	        descriptor.value = object[property];
	        return descriptor;
	    };
	}
	if (!Object.getOwnPropertyNames) {
	    Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
	        return Object.keys(object);
	    };
	}
	if (!Object.create) {
	    var createEmpty;
	    if (Object.prototype.__proto__ === null) {
	        createEmpty = function () {
	            return { "__proto__": null };
	        };
	    } else {
	        createEmpty = function () {
	            var empty = {};
	            for (var i in empty)
	                empty[i] = null;
	            empty.constructor =
	            empty.hasOwnProperty =
	            empty.propertyIsEnumerable =
	            empty.isPrototypeOf =
	            empty.toLocaleString =
	            empty.toString =
	            empty.valueOf =
	            empty.__proto__ = null;
	            return empty;
	        }
	    }
	
	    Object.create = function create(prototype, properties) {
	        var object;
	        if (prototype === null) {
	            object = createEmpty();
	        } else {
	            if (typeof prototype != "object")
	                throw new TypeError("typeof prototype["+(typeof prototype)+"] != 'object'");
	            var Type = function () {};
	            Type.prototype = prototype;
	            object = new Type();
	            object.__proto__ = prototype;
	        }
	        if (properties !== void 0)
	            Object.defineProperties(object, properties);
	        return object;
	    };
	}
	
	function doesDefinePropertyWork(object) {
	    try {
	        Object.defineProperty(object, "sentinel", {});
	        return "sentinel" in object;
	    } catch (exception) {
	    }
	}
	if (Object.defineProperty) {
	    var definePropertyWorksOnObject = doesDefinePropertyWork({});
	    var definePropertyWorksOnDom = typeof document == "undefined" ||
	        doesDefinePropertyWork(document.createElement("div"));
	    if (!definePropertyWorksOnObject || !definePropertyWorksOnDom) {
	        var definePropertyFallback = Object.defineProperty;
	    }
	}
	
	if (!Object.defineProperty || definePropertyFallback) {
	    var ERR_NON_OBJECT_DESCRIPTOR = "Property description must be an object: ";
	    var ERR_NON_OBJECT_TARGET = "Object.defineProperty called on non-object: "
	    var ERR_ACCESSORS_NOT_SUPPORTED = "getters & setters can not be defined " +
	                                      "on this javascript engine";
	
	    Object.defineProperty = function defineProperty(object, property, descriptor) {
	        if ((typeof object != "object" && typeof object != "function") || object === null)
	            throw new TypeError(ERR_NON_OBJECT_TARGET + object);
	        if ((typeof descriptor != "object" && typeof descriptor != "function") || descriptor === null)
	            throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR + descriptor);
	        if (definePropertyFallback) {
	            try {
	                return definePropertyFallback.call(Object, object, property, descriptor);
	            } catch (exception) {
	            }
	        }
	        if (owns(descriptor, "value")) {
	
	            if (supportsAccessors && (lookupGetter(object, property) ||
	                                      lookupSetter(object, property)))
	            {
	                var prototype = object.__proto__;
	                object.__proto__ = prototypeOfObject;
	                delete object[property];
	                object[property] = descriptor.value;
	                object.__proto__ = prototype;
	            } else {
	                object[property] = descriptor.value;
	            }
	        } else {
	            if (!supportsAccessors)
	                throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
	            if (owns(descriptor, "get"))
	                defineGetter(object, property, descriptor.get);
	            if (owns(descriptor, "set"))
	                defineSetter(object, property, descriptor.set);
	        }
	
	        return object;
	    };
	}
	if (!Object.defineProperties) {
	    Object.defineProperties = function defineProperties(object, properties) {
	        for (var property in properties) {
	            if (owns(properties, property))
	                Object.defineProperty(object, property, properties[property]);
	        }
	        return object;
	    };
	}
	if (!Object.seal) {
	    Object.seal = function seal(object) {
	        return object;
	    };
	}
	if (!Object.freeze) {
	    Object.freeze = function freeze(object) {
	        return object;
	    };
	}
	try {
	    Object.freeze(function () {});
	} catch (exception) {
	    Object.freeze = (function freeze(freezeObject) {
	        return function freeze(object) {
	            if (typeof object == "function") {
	                return object;
	            } else {
	                return freezeObject(object);
	            }
	        };
	    })(Object.freeze);
	}
	if (!Object.preventExtensions) {
	    Object.preventExtensions = function preventExtensions(object) {
	        return object;
	    };
	}
	if (!Object.isSealed) {
	    Object.isSealed = function isSealed(object) {
	        return false;
	    };
	}
	if (!Object.isFrozen) {
	    Object.isFrozen = function isFrozen(object) {
	        return false;
	    };
	}
	if (!Object.isExtensible) {
	    Object.isExtensible = function isExtensible(object) {
	        if (Object(object) === object) {
	            throw new TypeError(); // TODO message
	        }
	        var name = '';
	        while (owns(object, name)) {
	            name += '?';
	        }
	        object[name] = true;
	        var returnValue = owns(object, name);
	        delete object[name];
	        return returnValue;
	    };
	}
	if (!Object.keys) {
	    var hasDontEnumBug = true,
	        dontEnums = [
	            "toString",
	            "toLocaleString",
	            "valueOf",
	            "hasOwnProperty",
	            "isPrototypeOf",
	            "propertyIsEnumerable",
	            "constructor"
	        ],
	        dontEnumsLength = dontEnums.length;
	
	    for (var key in {"toString": null}) {
	        hasDontEnumBug = false;
	    }
	
	    Object.keys = function keys(object) {
	
	        if (
	            (typeof object != "object" && typeof object != "function") ||
	            object === null
	        ) {
	            throw new TypeError("Object.keys called on a non-object");
	        }
	
	        var keys = [];
	        for (var name in object) {
	            if (owns(object, name)) {
	                keys.push(name);
	            }
	        }
	
	        if (hasDontEnumBug) {
	            for (var i = 0, ii = dontEnumsLength; i < ii; i++) {
	                var dontEnum = dontEnums[i];
	                if (owns(object, dontEnum)) {
	                    keys.push(dontEnum);
	                }
	            }
	        }
	        return keys;
	    };
	
	}
	if (!Date.now) {
	    Date.now = function now() {
	        return new Date().getTime();
	    };
	}
	var ws = "\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003" +
	    "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028" +
	    "\u2029\uFEFF";
	if (!String.prototype.trim || ws.trim()) {
	    ws = "[" + ws + "]";
	    var trimBeginRegexp = new RegExp("^" + ws + ws + "*"),
	        trimEndRegexp = new RegExp(ws + ws + "*$");
	    String.prototype.trim = function trim() {
	        return String(this).replace(trimBeginRegexp, "").replace(trimEndRegexp, "");
	    };
	}
	
	function toInteger(n) {
	    n = +n;
	    if (n !== n) { // isNaN
	        n = 0;
	    } else if (n !== 0 && n !== (1/0) && n !== -(1/0)) {
	        n = (n > 0 || -1) * Math.floor(Math.abs(n));
	    }
	    return n;
	}
	
	function isPrimitive(input) {
	    var type = typeof input;
	    return (
	        input === null ||
	        type === "undefined" ||
	        type === "boolean" ||
	        type === "number" ||
	        type === "string"
	    );
	}
	
	function toPrimitive(input) {
	    var val, valueOf, toString;
	    if (isPrimitive(input)) {
	        return input;
	    }
	    valueOf = input.valueOf;
	    if (typeof valueOf === "function") {
	        val = valueOf.call(input);
	        if (isPrimitive(val)) {
	            return val;
	        }
	    }
	    toString = input.toString;
	    if (typeof toString === "function") {
	        val = toString.call(input);
	        if (isPrimitive(val)) {
	            return val;
	        }
	    }
	    throw new TypeError();
	}
	var toObject = function (o) {
	    if (o == null) { // this matches both null and undefined
	        throw new TypeError("can't convert "+o+" to object");
	    }
	    return Object(o);
	};
	
	});
	
	ace.define("ace/lib/fixoldbrowsers",["require","exports","module","ace/lib/regexp","ace/lib/es5-shim"], function(acequire, exports, module) {
	"use strict";
	
	acequire("./regexp");
	acequire("./es5-shim");
	
	});
	
	ace.define("ace/lib/dom",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	var XHTML_NS = "http://www.w3.org/1999/xhtml";
	
	exports.getDocumentHead = function(doc) {
	    if (!doc)
	        doc = document;
	    return doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
	}
	
	exports.createElement = function(tag, ns) {
	    return document.createElementNS ?
	           document.createElementNS(ns || XHTML_NS, tag) :
	           document.createElement(tag);
	};
	
	exports.hasCssClass = function(el, name) {
	    var classes = (el.className + "").split(/\s+/g);
	    return classes.indexOf(name) !== -1;
	};
	exports.addCssClass = function(el, name) {
	    if (!exports.hasCssClass(el, name)) {
	        el.className += " " + name;
	    }
	};
	exports.removeCssClass = function(el, name) {
	    var classes = el.className.split(/\s+/g);
	    while (true) {
	        var index = classes.indexOf(name);
	        if (index == -1) {
	            break;
	        }
	        classes.splice(index, 1);
	    }
	    el.className = classes.join(" ");
	};
	
	exports.toggleCssClass = function(el, name) {
	    var classes = el.className.split(/\s+/g), add = true;
	    while (true) {
	        var index = classes.indexOf(name);
	        if (index == -1) {
	            break;
	        }
	        add = false;
	        classes.splice(index, 1);
	    }
	    if (add)
	        classes.push(name);
	
	    el.className = classes.join(" ");
	    return add;
	};
	exports.setCssClass = function(node, className, include) {
	    if (include) {
	        exports.addCssClass(node, className);
	    } else {
	        exports.removeCssClass(node, className);
	    }
	};
	
	exports.hasCssString = function(id, doc) {
	    var index = 0, sheets;
	    doc = doc || document;
	
	    if (doc.createStyleSheet && (sheets = doc.styleSheets)) {
	        while (index < sheets.length)
	            if (sheets[index++].owningElement.id === id) return true;
	    } else if ((sheets = doc.getElementsByTagName("style"))) {
	        while (index < sheets.length)
	            if (sheets[index++].id === id) return true;
	    }
	
	    return false;
	};
	
	exports.importCssString = function importCssString(cssText, id, doc) {
	    doc = doc || document;
	    if (id && exports.hasCssString(id, doc))
	        return null;
	    
	    var style;
	    
	    if (id)
	        cssText += "\n/*# sourceURL=ace/css/" + id + " */";
	    
	    if (doc.createStyleSheet) {
	        style = doc.createStyleSheet();
	        style.cssText = cssText;
	        if (id)
	            style.owningElement.id = id;
	    } else {
	        style = exports.createElement("style");
	        style.appendChild(doc.createTextNode(cssText));
	        if (id)
	            style.id = id;
	
	        exports.getDocumentHead(doc).appendChild(style);
	    }
	};
	
	exports.importCssStylsheet = function(uri, doc) {
	    if (doc.createStyleSheet) {
	        doc.createStyleSheet(uri);
	    } else {
	        var link = exports.createElement('link');
	        link.rel = 'stylesheet';
	        link.href = uri;
	
	        exports.getDocumentHead(doc).appendChild(link);
	    }
	};
	
	exports.getInnerWidth = function(element) {
	    return (
	        parseInt(exports.computedStyle(element, "paddingLeft"), 10) +
	        parseInt(exports.computedStyle(element, "paddingRight"), 10) + 
	        element.clientWidth
	    );
	};
	
	exports.getInnerHeight = function(element) {
	    return (
	        parseInt(exports.computedStyle(element, "paddingTop"), 10) +
	        parseInt(exports.computedStyle(element, "paddingBottom"), 10) +
	        element.clientHeight
	    );
	};
	
	exports.scrollbarWidth = function(document) {
	    var inner = exports.createElement("ace_inner");
	    inner.style.width = "100%";
	    inner.style.minWidth = "0px";
	    inner.style.height = "200px";
	    inner.style.display = "block";
	
	    var outer = exports.createElement("ace_outer");
	    var style = outer.style;
	
	    style.position = "absolute";
	    style.left = "-10000px";
	    style.overflow = "hidden";
	    style.width = "200px";
	    style.minWidth = "0px";
	    style.height = "150px";
	    style.display = "block";
	
	    outer.appendChild(inner);
	
	    var body = document.documentElement;
	    body.appendChild(outer);
	
	    var noScrollbar = inner.offsetWidth;
	
	    style.overflow = "scroll";
	    var withScrollbar = inner.offsetWidth;
	
	    if (noScrollbar == withScrollbar) {
	        withScrollbar = outer.clientWidth;
	    }
	
	    body.removeChild(outer);
	
	    return noScrollbar-withScrollbar;
	};
	
	if (typeof document == "undefined") {
	    exports.importCssString = function() {};
	    return;
	}
	
	if (window.pageYOffset !== undefined) {
	    exports.getPageScrollTop = function() {
	        return window.pageYOffset;
	    };
	
	    exports.getPageScrollLeft = function() {
	        return window.pageXOffset;
	    };
	}
	else {
	    exports.getPageScrollTop = function() {
	        return document.body.scrollTop;
	    };
	
	    exports.getPageScrollLeft = function() {
	        return document.body.scrollLeft;
	    };
	}
	
	if (window.getComputedStyle)
	    exports.computedStyle = function(element, style) {
	        if (style)
	            return (window.getComputedStyle(element, "") || {})[style] || "";
	        return window.getComputedStyle(element, "") || {};
	    };
	else
	    exports.computedStyle = function(element, style) {
	        if (style)
	            return element.currentStyle[style];
	        return element.currentStyle;
	    };
	exports.setInnerHtml = function(el, innerHtml) {
	    var element = el.cloneNode(false);//document.createElement("div");
	    element.innerHTML = innerHtml;
	    el.parentNode.replaceChild(element, el);
	    return element;
	};
	
	if ("textContent" in document.documentElement) {
	    exports.setInnerText = function(el, innerText) {
	        el.textContent = innerText;
	    };
	
	    exports.getInnerText = function(el) {
	        return el.textContent;
	    };
	}
	else {
	    exports.setInnerText = function(el, innerText) {
	        el.innerText = innerText;
	    };
	
	    exports.getInnerText = function(el) {
	        return el.innerText;
	    };
	}
	
	exports.getParentWindow = function(document) {
	    return document.defaultView || document.parentWindow;
	};
	
	});
	
	ace.define("ace/lib/oop",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	exports.inherits = function(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	            value: ctor,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        }
	    });
	};
	
	exports.mixin = function(obj, mixin) {
	    for (var key in mixin) {
	        obj[key] = mixin[key];
	    }
	    return obj;
	};
	
	exports.implement = function(proto, mixin) {
	    exports.mixin(proto, mixin);
	};
	
	});
	
	ace.define("ace/lib/keys",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop"], function(acequire, exports, module) {
	"use strict";
	
	acequire("./fixoldbrowsers");
	
	var oop = acequire("./oop");
	var Keys = (function() {
	    var ret = {
	        MODIFIER_KEYS: {
	            16: 'Shift', 17: 'Ctrl', 18: 'Alt', 224: 'Meta'
	        },
	
	        KEY_MODS: {
	            "ctrl": 1, "alt": 2, "option" : 2, "shift": 4,
	            "super": 8, "meta": 8, "command": 8, "cmd": 8
	        },
	
	        FUNCTION_KEYS : {
	            8  : "Backspace",
	            9  : "Tab",
	            13 : "Return",
	            19 : "Pause",
	            27 : "Esc",
	            32 : "Space",
	            33 : "PageUp",
	            34 : "PageDown",
	            35 : "End",
	            36 : "Home",
	            37 : "Left",
	            38 : "Up",
	            39 : "Right",
	            40 : "Down",
	            44 : "Print",
	            45 : "Insert",
	            46 : "Delete",
	            96 : "Numpad0",
	            97 : "Numpad1",
	            98 : "Numpad2",
	            99 : "Numpad3",
	            100: "Numpad4",
	            101: "Numpad5",
	            102: "Numpad6",
	            103: "Numpad7",
	            104: "Numpad8",
	            105: "Numpad9",
	            '-13': "NumpadEnter",
	            112: "F1",
	            113: "F2",
	            114: "F3",
	            115: "F4",
	            116: "F5",
	            117: "F6",
	            118: "F7",
	            119: "F8",
	            120: "F9",
	            121: "F10",
	            122: "F11",
	            123: "F12",
	            144: "Numlock",
	            145: "Scrolllock"
	        },
	
	        PRINTABLE_KEYS: {
	           32: ' ',  48: '0',  49: '1',  50: '2',  51: '3',  52: '4', 53:  '5',
	           54: '6',  55: '7',  56: '8',  57: '9',  59: ';',  61: '=', 65:  'a',
	           66: 'b',  67: 'c',  68: 'd',  69: 'e',  70: 'f',  71: 'g', 72:  'h',
	           73: 'i',  74: 'j',  75: 'k',  76: 'l',  77: 'm',  78: 'n', 79:  'o',
	           80: 'p',  81: 'q',  82: 'r',  83: 's',  84: 't',  85: 'u', 86:  'v',
	           87: 'w',  88: 'x',  89: 'y',  90: 'z', 107: '+', 109: '-', 110: '.',
	          186: ';', 187: '=', 188: ',', 189: '-', 190: '.', 191: '/', 192: '`',
	          219: '[', 220: '\\',221: ']', 222: "'", 111: '/', 106: '*'
	        }
	    };
	    var name, i;
	    for (i in ret.FUNCTION_KEYS) {
	        name = ret.FUNCTION_KEYS[i].toLowerCase();
	        ret[name] = parseInt(i, 10);
	    }
	    for (i in ret.PRINTABLE_KEYS) {
	        name = ret.PRINTABLE_KEYS[i].toLowerCase();
	        ret[name] = parseInt(i, 10);
	    }
	    oop.mixin(ret, ret.MODIFIER_KEYS);
	    oop.mixin(ret, ret.PRINTABLE_KEYS);
	    oop.mixin(ret, ret.FUNCTION_KEYS);
	    ret.enter = ret["return"];
	    ret.escape = ret.esc;
	    ret.del = ret["delete"];
	    ret[173] = '-';
	    
	    (function() {
	        var mods = ["cmd", "ctrl", "alt", "shift"];
	        for (var i = Math.pow(2, mods.length); i--;) {            
	            ret.KEY_MODS[i] = mods.filter(function(x) {
	                return i & ret.KEY_MODS[x];
	            }).join("-") + "-";
	        }
	    })();
	
	    ret.KEY_MODS[0] = "";
	    ret.KEY_MODS[-1] = "input-";
	
	    return ret;
	})();
	oop.mixin(exports, Keys);
	
	exports.keyCodeToString = function(keyCode) {
	    var keyString = Keys[keyCode];
	    if (typeof keyString != "string")
	        keyString = String.fromCharCode(keyCode);
	    return keyString.toLowerCase();
	};
	
	});
	
	ace.define("ace/lib/useragent",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	exports.OS = {
	    LINUX: "LINUX",
	    MAC: "MAC",
	    WINDOWS: "WINDOWS"
	};
	exports.getOS = function() {
	    if (exports.isMac) {
	        return exports.OS.MAC;
	    } else if (exports.isLinux) {
	        return exports.OS.LINUX;
	    } else {
	        return exports.OS.WINDOWS;
	    }
	};
	if (typeof navigator != "object")
	    return;
	
	var os = (navigator.platform.match(/mac|win|linux/i) || ["other"])[0].toLowerCase();
	var ua = navigator.userAgent;
	exports.isWin = (os == "win");
	exports.isMac = (os == "mac");
	exports.isLinux = (os == "linux");
	exports.isIE = 
	    (navigator.appName == "Microsoft Internet Explorer" || navigator.appName.indexOf("MSAppHost") >= 0)
	    ? parseFloat((ua.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1])
	    : parseFloat((ua.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]); // for ie
	    
	exports.isOldIE = exports.isIE && exports.isIE < 9;
	exports.isGecko = exports.isMozilla = (window.Controllers || window.controllers) && window.navigator.product === "Gecko";
	exports.isOldGecko = exports.isGecko && parseInt((ua.match(/rv:(\d+)/)||[])[1], 10) < 4;
	exports.isOpera = window.opera && Object.prototype.toString.call(window.opera) == "[object Opera]";
	exports.isWebKit = parseFloat(ua.split("WebKit/")[1]) || undefined;
	
	exports.isChrome = parseFloat(ua.split(" Chrome/")[1]) || undefined;
	
	exports.isAIR = ua.indexOf("AdobeAIR") >= 0;
	
	exports.isIPad = ua.indexOf("iPad") >= 0;
	
	exports.isTouchPad = ua.indexOf("TouchPad") >= 0;
	
	exports.isChromeOS = ua.indexOf(" CrOS ") >= 0;
	
	});
	
	ace.define("ace/lib/event",["require","exports","module","ace/lib/keys","ace/lib/useragent"], function(acequire, exports, module) {
	"use strict";
	
	var keys = acequire("./keys");
	var useragent = acequire("./useragent");
	
	var pressedKeys = null;
	var ts = 0;
	
	exports.addListener = function(elem, type, callback) {
	    if (elem.addEventListener) {
	        return elem.addEventListener(type, callback, false);
	    }
	    if (elem.attachEvent) {
	        var wrapper = function() {
	            callback.call(elem, window.event);
	        };
	        callback._wrapper = wrapper;
	        elem.attachEvent("on" + type, wrapper);
	    }
	};
	
	exports.removeListener = function(elem, type, callback) {
	    if (elem.removeEventListener) {
	        return elem.removeEventListener(type, callback, false);
	    }
	    if (elem.detachEvent) {
	        elem.detachEvent("on" + type, callback._wrapper || callback);
	    }
	};
	exports.stopEvent = function(e) {
	    exports.stopPropagation(e);
	    exports.preventDefault(e);
	    return false;
	};
	
	exports.stopPropagation = function(e) {
	    if (e.stopPropagation)
	        e.stopPropagation();
	    else
	        e.cancelBubble = true;
	};
	
	exports.preventDefault = function(e) {
	    if (e.preventDefault)
	        e.preventDefault();
	    else
	        e.returnValue = false;
	};
	exports.getButton = function(e) {
	    if (e.type == "dblclick")
	        return 0;
	    if (e.type == "contextmenu" || (useragent.isMac && (e.ctrlKey && !e.altKey && !e.shiftKey)))
	        return 2;
	    if (e.preventDefault) {
	        return e.button;
	    }
	    else {
	        return {1:0, 2:2, 4:1}[e.button];
	    }
	};
	
	exports.capture = function(el, eventHandler, releaseCaptureHandler) {
	    function onMouseUp(e) {
	        eventHandler && eventHandler(e);
	        releaseCaptureHandler && releaseCaptureHandler(e);
	
	        exports.removeListener(document, "mousemove", eventHandler, true);
	        exports.removeListener(document, "mouseup", onMouseUp, true);
	        exports.removeListener(document, "dragstart", onMouseUp, true);
	    }
	
	    exports.addListener(document, "mousemove", eventHandler, true);
	    exports.addListener(document, "mouseup", onMouseUp, true);
	    exports.addListener(document, "dragstart", onMouseUp, true);
	    
	    return onMouseUp;
	};
	
	exports.addTouchMoveListener = function (el, callback) {
	    if ("ontouchmove" in el) {
	        var startx, starty;
	        exports.addListener(el, "touchstart", function (e) {
	            var touchObj = e.changedTouches[0];
	            startx = touchObj.clientX;
	            starty = touchObj.clientY;
	        });
	        exports.addListener(el, "touchmove", function (e) {
	            var factor = 1,
	            touchObj = e.changedTouches[0];
	
	            e.wheelX = -(touchObj.clientX - startx) / factor;
	            e.wheelY = -(touchObj.clientY - starty) / factor;
	
	            startx = touchObj.clientX;
	            starty = touchObj.clientY;
	
	            callback(e);
	        });
	    } 
	};
	
	exports.addMouseWheelListener = function(el, callback) {
	    if ("onmousewheel" in el) {
	        exports.addListener(el, "mousewheel", function(e) {
	            var factor = 8;
	            if (e.wheelDeltaX !== undefined) {
	                e.wheelX = -e.wheelDeltaX / factor;
	                e.wheelY = -e.wheelDeltaY / factor;
	            } else {
	                e.wheelX = 0;
	                e.wheelY = -e.wheelDelta / factor;
	            }
	            callback(e);
	        });
	    } else if ("onwheel" in el) {
	        exports.addListener(el, "wheel",  function(e) {
	            var factor = 0.35;
	            switch (e.deltaMode) {
	                case e.DOM_DELTA_PIXEL:
	                    e.wheelX = e.deltaX * factor || 0;
	                    e.wheelY = e.deltaY * factor || 0;
	                    break;
	                case e.DOM_DELTA_LINE:
	                case e.DOM_DELTA_PAGE:
	                    e.wheelX = (e.deltaX || 0) * 5;
	                    e.wheelY = (e.deltaY || 0) * 5;
	                    break;
	            }
	            
	            callback(e);
	        });
	    } else {
	        exports.addListener(el, "DOMMouseScroll", function(e) {
	            if (e.axis && e.axis == e.HORIZONTAL_AXIS) {
	                e.wheelX = (e.detail || 0) * 5;
	                e.wheelY = 0;
	            } else {
	                e.wheelX = 0;
	                e.wheelY = (e.detail || 0) * 5;
	            }
	            callback(e);
	        });
	    }
	};
	
	exports.addMultiMouseDownListener = function(elements, timeouts, eventHandler, callbackName) {
	    var clicks = 0;
	    var startX, startY, timer; 
	    var eventNames = {
	        2: "dblclick",
	        3: "tripleclick",
	        4: "quadclick"
	    };
	
	    function onMousedown(e) {
	        if (exports.getButton(e) !== 0) {
	            clicks = 0;
	        } else if (e.detail > 1) {
	            clicks++;
	            if (clicks > 4)
	                clicks = 1;
	        } else {
	            clicks = 1;
	        }
	        if (useragent.isIE) {
	            var isNewClick = Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5;
	            if (!timer || isNewClick)
	                clicks = 1;
	            if (timer)
	                clearTimeout(timer);
	            timer = setTimeout(function() {timer = null}, timeouts[clicks - 1] || 600);
	
	            if (clicks == 1) {
	                startX = e.clientX;
	                startY = e.clientY;
	            }
	        }
	        
	        e._clicks = clicks;
	
	        eventHandler[callbackName]("mousedown", e);
	
	        if (clicks > 4)
	            clicks = 0;
	        else if (clicks > 1)
	            return eventHandler[callbackName](eventNames[clicks], e);
	    }
	    function onDblclick(e) {
	        clicks = 2;
	        if (timer)
	            clearTimeout(timer);
	        timer = setTimeout(function() {timer = null}, timeouts[clicks - 1] || 600);
	        eventHandler[callbackName]("mousedown", e);
	        eventHandler[callbackName](eventNames[clicks], e);
	    }
	    if (!Array.isArray(elements))
	        elements = [elements];
	    elements.forEach(function(el) {
	        exports.addListener(el, "mousedown", onMousedown);
	        if (useragent.isOldIE)
	            exports.addListener(el, "dblclick", onDblclick);
	    });
	};
	
	var getModifierHash = useragent.isMac && useragent.isOpera && !("KeyboardEvent" in window)
	    ? function(e) {
	        return 0 | (e.metaKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.ctrlKey ? 8 : 0);
	    }
	    : function(e) {
	        return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
	    };
	
	exports.getModifierString = function(e) {
	    return keys.KEY_MODS[getModifierHash(e)];
	};
	
	function normalizeCommandKeys(callback, e, keyCode) {
	    var hashId = getModifierHash(e);
	
	    if (!useragent.isMac && pressedKeys) {
	        if (e.getModifierState && (e.getModifierState("OS") || e.getModifierState("Win")))
	            hashId |= 8;
	        if (pressedKeys.altGr) {
	            if ((3 & hashId) != 3)
	                pressedKeys.altGr = 0;
	            else
	                return;
	        }
	        if (keyCode === 18 || keyCode === 17) {
	            var location = "location" in e ? e.location : e.keyLocation;
	            if (keyCode === 17 && location === 1) {
	                if (pressedKeys[keyCode] == 1)
	                    ts = e.timeStamp;
	            } else if (keyCode === 18 && hashId === 3 && location === 2) {
	                var dt = e.timeStamp - ts;
	                if (dt < 50)
	                    pressedKeys.altGr = true;
	            }
	        }
	    }
	    
	    if (keyCode in keys.MODIFIER_KEYS) {
	        keyCode = -1;
	    }
	    if (hashId & 8 && (keyCode >= 91 && keyCode <= 93)) {
	        keyCode = -1;
	    }
	    
	    if (!hashId && keyCode === 13) {
	        var location = "location" in e ? e.location : e.keyLocation;
	        if (location === 3) {
	            callback(e, hashId, -keyCode);
	            if (e.defaultPrevented)
	                return;
	        }
	    }
	    
	    if (useragent.isChromeOS && hashId & 8) {
	        callback(e, hashId, keyCode);
	        if (e.defaultPrevented)
	            return;
	        else
	            hashId &= ~8;
	    }
	    if (!hashId && !(keyCode in keys.FUNCTION_KEYS) && !(keyCode in keys.PRINTABLE_KEYS)) {
	        return false;
	    }
	    
	    return callback(e, hashId, keyCode);
	}
	
	
	exports.addCommandKeyListener = function(el, callback) {
	    var addListener = exports.addListener;
	    if (useragent.isOldGecko || (useragent.isOpera && !("KeyboardEvent" in window))) {
	        var lastKeyDownKeyCode = null;
	        addListener(el, "keydown", function(e) {
	            lastKeyDownKeyCode = e.keyCode;
	        });
	        addListener(el, "keypress", function(e) {
	            return normalizeCommandKeys(callback, e, lastKeyDownKeyCode);
	        });
	    } else {
	        var lastDefaultPrevented = null;
	
	        addListener(el, "keydown", function(e) {
	            pressedKeys[e.keyCode] = (pressedKeys[e.keyCode] || 0) + 1;
	            var result = normalizeCommandKeys(callback, e, e.keyCode);
	            lastDefaultPrevented = e.defaultPrevented;
	            return result;
	        });
	
	        addListener(el, "keypress", function(e) {
	            if (lastDefaultPrevented && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey)) {
	                exports.stopEvent(e);
	                lastDefaultPrevented = null;
	            }
	        });
	
	        addListener(el, "keyup", function(e) {
	            pressedKeys[e.keyCode] = null;
	        });
	
	        if (!pressedKeys) {
	            resetPressedKeys();
	            addListener(window, "focus", resetPressedKeys);
	        }
	    }
	};
	function resetPressedKeys() {
	    pressedKeys = Object.create(null);
	}
	
	if (typeof window == "object" && window.postMessage && !useragent.isOldIE) {
	    var postMessageId = 1;
	    exports.nextTick = function(callback, win) {
	        win = win || window;
	        var messageName = "zero-timeout-message-" + postMessageId;
	        exports.addListener(win, "message", function listener(e) {
	            if (e.data == messageName) {
	                exports.stopPropagation(e);
	                exports.removeListener(win, "message", listener);
	                callback();
	            }
	        });
	        win.postMessage(messageName, "*");
	    };
	}
	
	
	exports.nextFrame = typeof window == "object" && (window.requestAnimationFrame
	    || window.mozRequestAnimationFrame
	    || window.webkitRequestAnimationFrame
	    || window.msRequestAnimationFrame
	    || window.oRequestAnimationFrame);
	
	if (exports.nextFrame)
	    exports.nextFrame = exports.nextFrame.bind(window);
	else
	    exports.nextFrame = function(callback) {
	        setTimeout(callback, 17);
	    };
	});
	
	ace.define("ace/lib/lang",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	exports.last = function(a) {
	    return a[a.length - 1];
	};
	
	exports.stringReverse = function(string) {
	    return string.split("").reverse().join("");
	};
	
	exports.stringRepeat = function (string, count) {
	    var result = '';
	    while (count > 0) {
	        if (count & 1)
	            result += string;
	
	        if (count >>= 1)
	            string += string;
	    }
	    return result;
	};
	
	var trimBeginRegexp = /^\s\s*/;
	var trimEndRegexp = /\s\s*$/;
	
	exports.stringTrimLeft = function (string) {
	    return string.replace(trimBeginRegexp, '');
	};
	
	exports.stringTrimRight = function (string) {
	    return string.replace(trimEndRegexp, '');
	};
	
	exports.copyObject = function(obj) {
	    var copy = {};
	    for (var key in obj) {
	        copy[key] = obj[key];
	    }
	    return copy;
	};
	
	exports.copyArray = function(array){
	    var copy = [];
	    for (var i=0, l=array.length; i<l; i++) {
	        if (array[i] && typeof array[i] == "object")
	            copy[i] = this.copyObject(array[i]);
	        else 
	            copy[i] = array[i];
	    }
	    return copy;
	};
	
	exports.deepCopy = function deepCopy(obj) {
	    if (typeof obj !== "object" || !obj)
	        return obj;
	    var copy;
	    if (Array.isArray(obj)) {
	        copy = [];
	        for (var key = 0; key < obj.length; key++) {
	            copy[key] = deepCopy(obj[key]);
	        }
	        return copy;
	    }
	    if (Object.prototype.toString.call(obj) !== "[object Object]")
	        return obj;
	    
	    copy = {};
	    for (var key in obj)
	        copy[key] = deepCopy(obj[key]);
	    return copy;
	};
	
	exports.arrayToMap = function(arr) {
	    var map = {};
	    for (var i=0; i<arr.length; i++) {
	        map[arr[i]] = 1;
	    }
	    return map;
	
	};
	
	exports.createMap = function(props) {
	    var map = Object.create(null);
	    for (var i in props) {
	        map[i] = props[i];
	    }
	    return map;
	};
	exports.arrayRemove = function(array, value) {
	  for (var i = 0; i <= array.length; i++) {
	    if (value === array[i]) {
	      array.splice(i, 1);
	    }
	  }
	};
	
	exports.escapeRegExp = function(str) {
	    return str.replace(/([.*+?^${}()|[\]\/\\])/g, '\\$1');
	};
	
	exports.escapeHTML = function(str) {
	    return str.replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
	};
	
	exports.getMatchOffsets = function(string, regExp) {
	    var matches = [];
	
	    string.replace(regExp, function(str) {
	        matches.push({
	            offset: arguments[arguments.length-2],
	            length: str.length
	        });
	    });
	
	    return matches;
	};
	exports.deferredCall = function(fcn) {
	    var timer = null;
	    var callback = function() {
	        timer = null;
	        fcn();
	    };
	
	    var deferred = function(timeout) {
	        deferred.cancel();
	        timer = setTimeout(callback, timeout || 0);
	        return deferred;
	    };
	
	    deferred.schedule = deferred;
	
	    deferred.call = function() {
	        this.cancel();
	        fcn();
	        return deferred;
	    };
	
	    deferred.cancel = function() {
	        clearTimeout(timer);
	        timer = null;
	        return deferred;
	    };
	    
	    deferred.isPending = function() {
	        return timer;
	    };
	
	    return deferred;
	};
	
	
	exports.delayedCall = function(fcn, defaultTimeout) {
	    var timer = null;
	    var callback = function() {
	        timer = null;
	        fcn();
	    };
	
	    var _self = function(timeout) {
	        if (timer == null)
	            timer = setTimeout(callback, timeout || defaultTimeout);
	    };
	
	    _self.delay = function(timeout) {
	        timer && clearTimeout(timer);
	        timer = setTimeout(callback, timeout || defaultTimeout);
	    };
	    _self.schedule = _self;
	
	    _self.call = function() {
	        this.cancel();
	        fcn();
	    };
	
	    _self.cancel = function() {
	        timer && clearTimeout(timer);
	        timer = null;
	    };
	
	    _self.isPending = function() {
	        return timer;
	    };
	
	    return _self;
	};
	});
	
	ace.define("ace/keyboard/textinput",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/lib/dom","ace/lib/lang"], function(acequire, exports, module) {
	"use strict";
	
	var event = acequire("../lib/event");
	var useragent = acequire("../lib/useragent");
	var dom = acequire("../lib/dom");
	var lang = acequire("../lib/lang");
	var BROKEN_SETDATA = useragent.isChrome < 18;
	var USE_IE_MIME_TYPE =  useragent.isIE;
	
	var TextInput = function(parentNode, host) {
	    var text = dom.createElement("textarea");
	    text.className = "ace_text-input";
	
	    if (useragent.isTouchPad)
	        text.setAttribute("x-palm-disable-auto-cap", true);
	
	    text.setAttribute("wrap", "off");
	    text.setAttribute("autocorrect", "off");
	    text.setAttribute("autocapitalize", "off");
	    text.setAttribute("spellcheck", false);
	
	    text.style.opacity = "0";
	    if (useragent.isOldIE) text.style.top = "-1000px";
	    parentNode.insertBefore(text, parentNode.firstChild);
	
	    var PLACEHOLDER = "\x01\x01";
	
	    var copied = false;
	    var pasted = false;
	    var inComposition = false;
	    var tempStyle = '';
	    var isSelectionEmpty = true;
	    try { var isFocused = document.activeElement === text; } catch(e) {}
	    
	    event.addListener(text, "blur", function(e) {
	        host.onBlur(e);
	        isFocused = false;
	    });
	    event.addListener(text, "focus", function(e) {
	        isFocused = true;
	        host.onFocus(e);
	        resetSelection();
	    });
	    this.focus = function() {
	        if (tempStyle) return text.focus();
	        var top = text.style.top;
	        text.style.position = "fixed";
	        text.style.top = "0px";
	        text.focus();
	        setTimeout(function() {
	            text.style.position = "";
	            if (text.style.top == "0px")
	                text.style.top = top;
	        }, 0);
	    };
	    this.blur = function() {
	        text.blur();
	    };
	    this.isFocused = function() {
	        return isFocused;
	    };
	    var syncSelection = lang.delayedCall(function() {
	        isFocused && resetSelection(isSelectionEmpty);
	    });
	    var syncValue = lang.delayedCall(function() {
	         if (!inComposition) {
	            text.value = PLACEHOLDER;
	            isFocused && resetSelection();
	         }
	    });
	
	    function resetSelection(isEmpty) {
	        if (inComposition)
	            return;
	        inComposition = true;
	        
	        if (inputHandler) {
	            selectionStart = 0;
	            selectionEnd = isEmpty ? 0 : text.value.length - 1;
	        } else {
	            var selectionStart = isEmpty ? 2 : 1;
	            var selectionEnd = 2;
	        }
	        try {
	            text.setSelectionRange(selectionStart, selectionEnd);
	        } catch(e){}
	        
	        inComposition = false;
	    }
	
	    function resetValue() {
	        if (inComposition)
	            return;
	        text.value = PLACEHOLDER;
	        if (useragent.isWebKit)
	            syncValue.schedule();
	    }
	
	    useragent.isWebKit || host.addEventListener('changeSelection', function() {
	        if (host.selection.isEmpty() != isSelectionEmpty) {
	            isSelectionEmpty = !isSelectionEmpty;
	            syncSelection.schedule();
	        }
	    });
	
	    resetValue();
	    if (isFocused)
	        host.onFocus();
	
	
	    var isAllSelected = function(text) {
	        return text.selectionStart === 0 && text.selectionEnd === text.value.length;
	    };
	    if (!text.setSelectionRange && text.createTextRange) {
	        text.setSelectionRange = function(selectionStart, selectionEnd) {
	            var range = this.createTextRange();
	            range.collapse(true);
	            range.moveStart('character', selectionStart);
	            range.moveEnd('character', selectionEnd);
	            range.select();
	        };
	        isAllSelected = function(text) {
	            try {
	                var range = text.ownerDocument.selection.createRange();
	            }catch(e) {}
	            if (!range || range.parentElement() != text) return false;
	                return range.text == text.value;
	        }
	    }
	    if (useragent.isOldIE) {
	        var inPropertyChange = false;
	        var onPropertyChange = function(e){
	            if (inPropertyChange)
	                return;
	            var data = text.value;
	            if (inComposition || !data || data == PLACEHOLDER)
	                return;
	            if (e && data == PLACEHOLDER[0])
	                return syncProperty.schedule();
	
	            sendText(data);
	            inPropertyChange = true;
	            resetValue();
	            inPropertyChange = false;
	        };
	        var syncProperty = lang.delayedCall(onPropertyChange);
	        event.addListener(text, "propertychange", onPropertyChange);
	
	        var keytable = { 13:1, 27:1 };
	        event.addListener(text, "keyup", function (e) {
	            if (inComposition && (!text.value || keytable[e.keyCode]))
	                setTimeout(onCompositionEnd, 0);
	            if ((text.value.charCodeAt(0)||0) < 129) {
	                return syncProperty.call();
	            }
	            inComposition ? onCompositionUpdate() : onCompositionStart();
	        });
	        event.addListener(text, "keydown", function (e) {
	            syncProperty.schedule(50);
	        });
	    }
	
	    var onSelect = function(e) {
	        if (copied) {
	            copied = false;
	        } else if (isAllSelected(text)) {
	            host.selectAll();
	            resetSelection();
	        } else if (inputHandler) {
	            resetSelection(host.selection.isEmpty());
	        }
	    };
	
	    var inputHandler = null;
	    this.setInputHandler = function(cb) {inputHandler = cb};
	    this.getInputHandler = function() {return inputHandler};
	    var afterContextMenu = false;
	    
	    var sendText = function(data) {
	        if (inputHandler) {
	            data = inputHandler(data);
	            inputHandler = null;
	        }
	        if (pasted) {
	            resetSelection();
	            if (data)
	                host.onPaste(data);
	            pasted = false;
	        } else if (data == PLACEHOLDER.charAt(0)) {
	            if (afterContextMenu)
	                host.execCommand("del", {source: "ace"});
	            else // some versions of android do not fire keydown when pressing backspace
	                host.execCommand("backspace", {source: "ace"});
	        } else {
	            if (data.substring(0, 2) == PLACEHOLDER)
	                data = data.substr(2);
	            else if (data.charAt(0) == PLACEHOLDER.charAt(0))
	                data = data.substr(1);
	            else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
	                data = data.slice(0, -1);
	            if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
	                data = data.slice(0, -1);
	            
	            if (data)
	                host.onTextInput(data);
	        }
	        if (afterContextMenu)
	            afterContextMenu = false;
	    };
	    var onInput = function(e) {
	        if (inComposition)
	            return;
	        var data = text.value;
	        sendText(data);
	        resetValue();
	    };
	    
	    var handleClipboardData = function(e, data, forceIEMime) {
	        var clipboardData = e.clipboardData || window.clipboardData;
	        if (!clipboardData || BROKEN_SETDATA)
	            return;
	        var mime = USE_IE_MIME_TYPE || forceIEMime ? "Text" : "text/plain";
	        try {
	            if (data) {
	                return clipboardData.setData(mime, data) !== false;
	            } else {
	                return clipboardData.getData(mime);
	            }
	        } catch(e) {
	            if (!forceIEMime)
	                return handleClipboardData(e, data, true);
	        }
	    };
	
	    var doCopy = function(e, isCut) {
	        var data = host.getCopyText();
	        if (!data)
	            return event.preventDefault(e);
	
	        if (handleClipboardData(e, data)) {
	            isCut ? host.onCut() : host.onCopy();
	            event.preventDefault(e);
	        } else {
	            copied = true;
	            text.value = data;
	            text.select();
	            setTimeout(function(){
	                copied = false;
	                resetValue();
	                resetSelection();
	                isCut ? host.onCut() : host.onCopy();
	            });
	        }
	    };
	    
	    var onCut = function(e) {
	        doCopy(e, true);
	    };
	    
	    var onCopy = function(e) {
	        doCopy(e, false);
	    };
	    
	    var onPaste = function(e) {
	        var data = handleClipboardData(e);
	        if (typeof data == "string") {
	            if (data)
	                host.onPaste(data, e);
	            if (useragent.isIE)
	                setTimeout(resetSelection);
	            event.preventDefault(e);
	        }
	        else {
	            text.value = "";
	            pasted = true;
	        }
	    };
	
	    event.addCommandKeyListener(text, host.onCommandKey.bind(host));
	
	    event.addListener(text, "select", onSelect);
	
	    event.addListener(text, "input", onInput);
	
	    event.addListener(text, "cut", onCut);
	    event.addListener(text, "copy", onCopy);
	    event.addListener(text, "paste", onPaste);
	    if (!('oncut' in text) || !('oncopy' in text) || !('onpaste' in text)){
	        event.addListener(parentNode, "keydown", function(e) {
	            if ((useragent.isMac && !e.metaKey) || !e.ctrlKey)
	                return;
	
	            switch (e.keyCode) {
	                case 67:
	                    onCopy(e);
	                    break;
	                case 86:
	                    onPaste(e);
	                    break;
	                case 88:
	                    onCut(e);
	                    break;
	            }
	        });
	    }
	    var onCompositionStart = function(e) {
	        if (inComposition || !host.onCompositionStart || host.$readOnly) 
	            return;
	        inComposition = {};
	        inComposition.canUndo = host.session.$undoManager;
	        host.onCompositionStart();
	        setTimeout(onCompositionUpdate, 0);
	        host.on("mousedown", onCompositionEnd);
	        if (inComposition.canUndo && !host.selection.isEmpty()) {
	            host.insert("");
	            host.session.markUndoGroup();
	            host.selection.clearSelection();
	        }
	        host.session.markUndoGroup();
	    };
	
	    var onCompositionUpdate = function() {
	        if (!inComposition || !host.onCompositionUpdate || host.$readOnly)
	            return;
	        var val = text.value.replace(/\x01/g, "");
	        if (inComposition.lastValue === val) return;
	        
	        host.onCompositionUpdate(val);
	        if (inComposition.lastValue)
	            host.undo();
	        if (inComposition.canUndo)
	            inComposition.lastValue = val;
	        if (inComposition.lastValue) {
	            var r = host.selection.getRange();
	            host.insert(inComposition.lastValue);
	            host.session.markUndoGroup();
	            inComposition.range = host.selection.getRange();
	            host.selection.setRange(r);
	            host.selection.clearSelection();
	        }
	    };
	
	    var onCompositionEnd = function(e) {
	        if (!host.onCompositionEnd || host.$readOnly) return;
	        var c = inComposition;
	        inComposition = false;
	        var timer = setTimeout(function() {
	            timer = null;
	            var str = text.value.replace(/\x01/g, "");
	            if (inComposition)
	                return;
	            else if (str == c.lastValue)
	                resetValue();
	            else if (!c.lastValue && str) {
	                resetValue();
	                sendText(str);
	            }
	        });
	        inputHandler = function compositionInputHandler(str) {
	            if (timer)
	                clearTimeout(timer);
	            str = str.replace(/\x01/g, "");
	            if (str == c.lastValue)
	                return "";
	            if (c.lastValue && timer)
	                host.undo();
	            return str;
	        };
	        host.onCompositionEnd();
	        host.removeListener("mousedown", onCompositionEnd);
	        if (e.type == "compositionend" && c.range) {
	            host.selection.setRange(c.range);
	        }
	        if (useragent.isChrome && useragent.isChrome >= 53) {
	          onInput();
	        }
	    };
	    
	    
	
	    var syncComposition = lang.delayedCall(onCompositionUpdate, 50);
	
	    event.addListener(text, "compositionstart", onCompositionStart);
	    if (useragent.isGecko) {
	        event.addListener(text, "text", function(){syncComposition.schedule()});
	    } else {
	        event.addListener(text, "keyup", function(){syncComposition.schedule()});
	        event.addListener(text, "keydown", function(){syncComposition.schedule()});
	    }
	    event.addListener(text, "compositionend", onCompositionEnd);
	
	    this.getElement = function() {
	        return text;
	    };
	
	    this.setReadOnly = function(readOnly) {
	       text.readOnly = readOnly;
	    };
	
	    this.onContextMenu = function(e) {
	        afterContextMenu = true;
	        resetSelection(host.selection.isEmpty());
	        host._emit("nativecontextmenu", {target: host, domEvent: e});
	        this.moveToMouse(e, true);
	    };
	    
	    this.moveToMouse = function(e, bringToFront) {
	        if (!bringToFront && useragent.isOldIE)
	            return;
	        if (!tempStyle)
	            tempStyle = text.style.cssText;
	        text.style.cssText = (bringToFront ? "z-index:100000;" : "")
	            + "height:" + text.style.height + ";"
	            + (useragent.isIE ? "opacity:0.1;" : "");
	
	        var rect = host.container.getBoundingClientRect();
	        var style = dom.computedStyle(host.container);
	        var top = rect.top + (parseInt(style.borderTopWidth) || 0);
	        var left = rect.left + (parseInt(rect.borderLeftWidth) || 0);
	        var maxTop = rect.bottom - top - text.clientHeight -2;
	        var move = function(e) {
	            text.style.left = e.clientX - left - 2 + "px";
	            text.style.top = Math.min(e.clientY - top - 2, maxTop) + "px";
	        }; 
	        move(e);
	
	        if (e.type != "mousedown")
	            return;
	
	        if (host.renderer.$keepTextAreaAtCursor)
	            host.renderer.$keepTextAreaAtCursor = null;
	
	        clearTimeout(closeTimeout);
	        if (useragent.isWin && !useragent.isOldIE)
	            event.capture(host.container, move, onContextMenuClose);
	    };
	
	    this.onContextMenuClose = onContextMenuClose;
	    var closeTimeout;
	    function onContextMenuClose() {
	        clearTimeout(closeTimeout);
	        closeTimeout = setTimeout(function () {
	            if (tempStyle) {
	                text.style.cssText = tempStyle;
	                tempStyle = '';
	            }
	            if (host.renderer.$keepTextAreaAtCursor == null) {
	                host.renderer.$keepTextAreaAtCursor = true;
	                host.renderer.$moveTextAreaToCursor();
	            }
	        }, useragent.isOldIE ? 200 : 0);
	    }
	
	    var onContextMenu = function(e) {
	        host.textInput.onContextMenu(e);
	        onContextMenuClose();
	    };
	    event.addListener(text, "mouseup", onContextMenu);
	    event.addListener(text, "mousedown", function(e) {
	        e.preventDefault();
	        onContextMenuClose();
	    });
	    event.addListener(host.renderer.scroller, "contextmenu", onContextMenu);
	    event.addListener(text, "contextmenu", onContextMenu);
	};
	
	exports.TextInput = TextInput;
	});
	
	ace.define("ace/mouse/default_handlers",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
	"use strict";
	
	var dom = acequire("../lib/dom");
	var event = acequire("../lib/event");
	var useragent = acequire("../lib/useragent");
	
	var DRAG_OFFSET = 0; // pixels
	
	function DefaultHandlers(mouseHandler) {
	    mouseHandler.$clickSelection = null;
	
	    var editor = mouseHandler.editor;
	    editor.setDefaultHandler("mousedown", this.onMouseDown.bind(mouseHandler));
	    editor.setDefaultHandler("dblclick", this.onDoubleClick.bind(mouseHandler));
	    editor.setDefaultHandler("tripleclick", this.onTripleClick.bind(mouseHandler));
	    editor.setDefaultHandler("quadclick", this.onQuadClick.bind(mouseHandler));
	    editor.setDefaultHandler("mousewheel", this.onMouseWheel.bind(mouseHandler));
	    editor.setDefaultHandler("touchmove", this.onTouchMove.bind(mouseHandler));
	
	    var exports = ["select", "startSelect", "selectEnd", "selectAllEnd", "selectByWordsEnd",
	        "selectByLinesEnd", "dragWait", "dragWaitEnd", "focusWait"];
	
	    exports.forEach(function(x) {
	        mouseHandler[x] = this[x];
	    }, this);
	
	    mouseHandler.selectByLines = this.extendSelectionBy.bind(mouseHandler, "getLineRange");
	    mouseHandler.selectByWords = this.extendSelectionBy.bind(mouseHandler, "getWordRange");
	}
	
	(function() {
	
	    this.onMouseDown = function(ev) {
	        var inSelection = ev.inSelection();
	        var pos = ev.getDocumentPosition();
	        this.mousedownEvent = ev;
	        var editor = this.editor;
	
	        var button = ev.getButton();
	        if (button !== 0) {
	            var selectionRange = editor.getSelectionRange();
	            var selectionEmpty = selectionRange.isEmpty();
	            editor.$blockScrolling++;
	            if (selectionEmpty || button == 1)
	                editor.selection.moveToPosition(pos);
	            editor.$blockScrolling--;
	            if (button == 2)
	                editor.textInput.onContextMenu(ev.domEvent);
	            return; // stopping event here breaks contextmenu on ff mac
	        }
	
	        this.mousedownEvent.time = Date.now();
	        if (inSelection && !editor.isFocused()) {
	            editor.focus();
	            if (this.$focusTimout && !this.$clickSelection && !editor.inMultiSelectMode) {
	                this.setState("focusWait");
	                this.captureMouse(ev);
	                return;
	            }
	        }
	
	        this.captureMouse(ev);
	        this.startSelect(pos, ev.domEvent._clicks > 1);
	        return ev.preventDefault();
	    };
	
	    this.startSelect = function(pos, waitForClickSelection) {
	        pos = pos || this.editor.renderer.screenToTextCoordinates(this.x, this.y);
	        var editor = this.editor;
	        editor.$blockScrolling++;
	        if (this.mousedownEvent.getShiftKey())
	            editor.selection.selectToPosition(pos);
	        else if (!waitForClickSelection)
	            editor.selection.moveToPosition(pos);
	        if (!waitForClickSelection)
	            this.select();
	        if (editor.renderer.scroller.setCapture) {
	            editor.renderer.scroller.setCapture();
	        }
	        editor.setStyle("ace_selecting");
	        this.setState("select");
	        editor.$blockScrolling--;
	    };
	
	    this.select = function() {
	        var anchor, editor = this.editor;
	        var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
	        editor.$blockScrolling++;
	        if (this.$clickSelection) {
	            var cmp = this.$clickSelection.comparePoint(cursor);
	
	            if (cmp == -1) {
	                anchor = this.$clickSelection.end;
	            } else if (cmp == 1) {
	                anchor = this.$clickSelection.start;
	            } else {
	                var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
	                cursor = orientedRange.cursor;
	                anchor = orientedRange.anchor;
	            }
	            editor.selection.setSelectionAnchor(anchor.row, anchor.column);
	        }
	        editor.selection.selectToPosition(cursor);
	        editor.$blockScrolling--;
	        editor.renderer.scrollCursorIntoView();
	    };
	
	    this.extendSelectionBy = function(unitName) {
	        var anchor, editor = this.editor;
	        var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
	        var range = editor.selection[unitName](cursor.row, cursor.column);
	        editor.$blockScrolling++;
	        if (this.$clickSelection) {
	            var cmpStart = this.$clickSelection.comparePoint(range.start);
	            var cmpEnd = this.$clickSelection.comparePoint(range.end);
	
	            if (cmpStart == -1 && cmpEnd <= 0) {
	                anchor = this.$clickSelection.end;
	                if (range.end.row != cursor.row || range.end.column != cursor.column)
	                    cursor = range.start;
	            } else if (cmpEnd == 1 && cmpStart >= 0) {
	                anchor = this.$clickSelection.start;
	                if (range.start.row != cursor.row || range.start.column != cursor.column)
	                    cursor = range.end;
	            } else if (cmpStart == -1 && cmpEnd == 1) {
	                cursor = range.end;
	                anchor = range.start;
	            } else {
	                var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
	                cursor = orientedRange.cursor;
	                anchor = orientedRange.anchor;
	            }
	            editor.selection.setSelectionAnchor(anchor.row, anchor.column);
	        }
	        editor.selection.selectToPosition(cursor);
	        editor.$blockScrolling--;
	        editor.renderer.scrollCursorIntoView();
	    };
	
	    this.selectEnd =
	    this.selectAllEnd =
	    this.selectByWordsEnd =
	    this.selectByLinesEnd = function() {
	        this.$clickSelection = null;
	        this.editor.unsetStyle("ace_selecting");
	        if (this.editor.renderer.scroller.releaseCapture) {
	            this.editor.renderer.scroller.releaseCapture();
	        }
	    };
	
	    this.focusWait = function() {
	        var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
	        var time = Date.now();
	
	        if (distance > DRAG_OFFSET || time - this.mousedownEvent.time > this.$focusTimout)
	            this.startSelect(this.mousedownEvent.getDocumentPosition());
	    };
	
	    this.onDoubleClick = function(ev) {
	        var pos = ev.getDocumentPosition();
	        var editor = this.editor;
	        var session = editor.session;
	
	        var range = session.getBracketRange(pos);
	        if (range) {
	            if (range.isEmpty()) {
	                range.start.column--;
	                range.end.column++;
	            }
	            this.setState("select");
	        } else {
	            range = editor.selection.getWordRange(pos.row, pos.column);
	            this.setState("selectByWords");
	        }
	        this.$clickSelection = range;
	        this.select();
	    };
	
	    this.onTripleClick = function(ev) {
	        var pos = ev.getDocumentPosition();
	        var editor = this.editor;
	
	        this.setState("selectByLines");
	        var range = editor.getSelectionRange();
	        if (range.isMultiLine() && range.contains(pos.row, pos.column)) {
	            this.$clickSelection = editor.selection.getLineRange(range.start.row);
	            this.$clickSelection.end = editor.selection.getLineRange(range.end.row).end;
	        } else {
	            this.$clickSelection = editor.selection.getLineRange(pos.row);
	        }
	        this.select();
	    };
	
	    this.onQuadClick = function(ev) {
	        var editor = this.editor;
	
	        editor.selectAll();
	        this.$clickSelection = editor.getSelectionRange();
	        this.setState("selectAll");
	    };
	
	    this.onMouseWheel = function(ev) {
	        if (ev.getAccelKey())
	            return;
	        if (ev.getShiftKey() && ev.wheelY && !ev.wheelX) {
	            ev.wheelX = ev.wheelY;
	            ev.wheelY = 0;
	        }
	
	        var t = ev.domEvent.timeStamp;
	        var dt = t - (this.$lastScrollTime||0);
	        
	        var editor = this.editor;
	        var isScrolable = editor.renderer.isScrollableBy(ev.wheelX * ev.speed, ev.wheelY * ev.speed);
	        if (isScrolable || dt < 200) {
	            this.$lastScrollTime = t;
	            editor.renderer.scrollBy(ev.wheelX * ev.speed, ev.wheelY * ev.speed);
	            return ev.stop();
	        }
	    };
	    
	    this.onTouchMove = function (ev) {
	        var t = ev.domEvent.timeStamp;
	        var dt = t - (this.$lastScrollTime || 0);
	
	        var editor = this.editor;
	        var isScrolable = editor.renderer.isScrollableBy(ev.wheelX * ev.speed, ev.wheelY * ev.speed);
	        if (isScrolable || dt < 200) {
	            this.$lastScrollTime = t;
	            editor.renderer.scrollBy(ev.wheelX * ev.speed, ev.wheelY * ev.speed);
	            return ev.stop();
	        }
	    };
	
	}).call(DefaultHandlers.prototype);
	
	exports.DefaultHandlers = DefaultHandlers;
	
	function calcDistance(ax, ay, bx, by) {
	    return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
	}
	
	function calcRangeOrientation(range, cursor) {
	    if (range.start.row == range.end.row)
	        var cmp = 2 * cursor.column - range.start.column - range.end.column;
	    else if (range.start.row == range.end.row - 1 && !range.start.column && !range.end.column)
	        var cmp = cursor.column - 4;
	    else
	        var cmp = 2 * cursor.row - range.start.row - range.end.row;
	
	    if (cmp < 0)
	        return {cursor: range.start, anchor: range.end};
	    else
	        return {cursor: range.end, anchor: range.start};
	}
	
	});
	
	ace.define("ace/tooltip",["require","exports","module","ace/lib/oop","ace/lib/dom"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("./lib/oop");
	var dom = acequire("./lib/dom");
	function Tooltip (parentNode) {
	    this.isOpen = false;
	    this.$element = null;
	    this.$parentNode = parentNode;
	}
	
	(function() {
	    this.$init = function() {
	        this.$element = dom.createElement("div");
	        this.$element.className = "ace_tooltip";
	        this.$element.style.display = "none";
	        this.$parentNode.appendChild(this.$element);
	        return this.$element;
	    };
	    this.getElement = function() {
	        return this.$element || this.$init();
	    };
	    this.setText = function(text) {
	        dom.setInnerText(this.getElement(), text);
	    };
	    this.setHtml = function(html) {
	        this.getElement().innerHTML = html;
	    };
	    this.setPosition = function(x, y) {
	        this.getElement().style.left = x + "px";
	        this.getElement().style.top = y + "px";
	    };
	    this.setClassName = function(className) {
	        dom.addCssClass(this.getElement(), className);
	    };
	    this.show = function(text, x, y) {
	        if (text != null)
	            this.setText(text);
	        if (x != null && y != null)
	            this.setPosition(x, y);
	        if (!this.isOpen) {
	            this.getElement().style.display = "block";
	            this.isOpen = true;
	        }
	    };
	
	    this.hide = function() {
	        if (this.isOpen) {
	            this.getElement().style.display = "none";
	            this.isOpen = false;
	        }
	    };
	    this.getHeight = function() {
	        return this.getElement().offsetHeight;
	    };
	    this.getWidth = function() {
	        return this.getElement().offsetWidth;
	    };
	
	}).call(Tooltip.prototype);
	
	exports.Tooltip = Tooltip;
	});
	
	ace.define("ace/mouse/default_gutter_handler",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/event","ace/tooltip"], function(acequire, exports, module) {
	"use strict";
	var dom = acequire("../lib/dom");
	var oop = acequire("../lib/oop");
	var event = acequire("../lib/event");
	var Tooltip = acequire("../tooltip").Tooltip;
	
	function GutterHandler(mouseHandler) {
	    var editor = mouseHandler.editor;
	    var gutter = editor.renderer.$gutterLayer;
	    var tooltip = new GutterTooltip(editor.container);
	
	    mouseHandler.editor.setDefaultHandler("guttermousedown", function(e) {
	        if (!editor.isFocused() || e.getButton() != 0)
	            return;
	        var gutterRegion = gutter.getRegion(e);
	
	        if (gutterRegion == "foldWidgets")
	            return;
	
	        var row = e.getDocumentPosition().row;
	        var selection = editor.session.selection;
	
	        if (e.getShiftKey())
	            selection.selectTo(row, 0);
	        else {
	            if (e.domEvent.detail == 2) {
	                editor.selectAll();
	                return e.preventDefault();
	            }
	            mouseHandler.$clickSelection = editor.selection.getLineRange(row);
	        }
	        mouseHandler.setState("selectByLines");
	        mouseHandler.captureMouse(e);
	        return e.preventDefault();
	    });
	
	
	    var tooltipTimeout, mouseEvent, tooltipAnnotation;
	
	    function showTooltip() {
	        var row = mouseEvent.getDocumentPosition().row;
	        var annotation = gutter.$annotations[row];
	        if (!annotation)
	            return hideTooltip();
	
	        var maxRow = editor.session.getLength();
	        if (row == maxRow) {
	            var screenRow = editor.renderer.pixelToScreenCoordinates(0, mouseEvent.y).row;
	            var pos = mouseEvent.$pos;
	            if (screenRow > editor.session.documentToScreenRow(pos.row, pos.column))
	                return hideTooltip();
	        }
	
	        if (tooltipAnnotation == annotation)
	            return;
	        tooltipAnnotation = annotation.text.join("<br/>");
	
	        tooltip.setHtml(tooltipAnnotation);
	        tooltip.show();
	        editor._signal("showGutterTooltip", tooltip);
	        editor.on("mousewheel", hideTooltip);
	
	        if (mouseHandler.$tooltipFollowsMouse) {
	            moveTooltip(mouseEvent);
	        } else {
	            var gutterElement = mouseEvent.domEvent.target;
	            var rect = gutterElement.getBoundingClientRect();
	            var style = tooltip.getElement().style;
	            style.left = rect.right + "px";
	            style.top = rect.bottom + "px";
	        }
	    }
	
	    function hideTooltip() {
	        if (tooltipTimeout)
	            tooltipTimeout = clearTimeout(tooltipTimeout);
	        if (tooltipAnnotation) {
	            tooltip.hide();
	            tooltipAnnotation = null;
	            editor._signal("hideGutterTooltip", tooltip);
	            editor.removeEventListener("mousewheel", hideTooltip);
	        }
	    }
	
	    function moveTooltip(e) {
	        tooltip.setPosition(e.x, e.y);
	    }
	
	    mouseHandler.editor.setDefaultHandler("guttermousemove", function(e) {
	        var target = e.domEvent.target || e.domEvent.srcElement;
	        if (dom.hasCssClass(target, "ace_fold-widget"))
	            return hideTooltip();
	
	        if (tooltipAnnotation && mouseHandler.$tooltipFollowsMouse)
	            moveTooltip(e);
	
	        mouseEvent = e;
	        if (tooltipTimeout)
	            return;
	        tooltipTimeout = setTimeout(function() {
	            tooltipTimeout = null;
	            if (mouseEvent && !mouseHandler.isMousePressed)
	                showTooltip();
	            else
	                hideTooltip();
	        }, 50);
	    });
	
	    event.addListener(editor.renderer.$gutter, "mouseout", function(e) {
	        mouseEvent = null;
	        if (!tooltipAnnotation || tooltipTimeout)
	            return;
	
	        tooltipTimeout = setTimeout(function() {
	            tooltipTimeout = null;
	            hideTooltip();
	        }, 50);
	    });
	    
	    editor.on("changeSession", hideTooltip);
	}
	
	function GutterTooltip(parentNode) {
	    Tooltip.call(this, parentNode);
	}
	
	oop.inherits(GutterTooltip, Tooltip);
	
	(function(){
	    this.setPosition = function(x, y) {
	        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
	        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
	        var width = this.getWidth();
	        var height = this.getHeight();
	        x += 15;
	        y += 15;
	        if (x + width > windowWidth) {
	            x -= (x + width) - windowWidth;
	        }
	        if (y + height > windowHeight) {
	            y -= 20 + height;
	        }
	        Tooltip.prototype.setPosition.call(this, x, y);
	    };
	
	}).call(GutterTooltip.prototype);
	
	
	
	exports.GutterHandler = GutterHandler;
	
	});
	
	ace.define("ace/mouse/mouse_event",["require","exports","module","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
	"use strict";
	
	var event = acequire("../lib/event");
	var useragent = acequire("../lib/useragent");
	var MouseEvent = exports.MouseEvent = function(domEvent, editor) {
	    this.domEvent = domEvent;
	    this.editor = editor;
	    
	    this.x = this.clientX = domEvent.clientX;
	    this.y = this.clientY = domEvent.clientY;
	
	    this.$pos = null;
	    this.$inSelection = null;
	    
	    this.propagationStopped = false;
	    this.defaultPrevented = false;
	};
	
	(function() {  
	    
	    this.stopPropagation = function() {
	        event.stopPropagation(this.domEvent);
	        this.propagationStopped = true;
	    };
	    
	    this.preventDefault = function() {
	        event.preventDefault(this.domEvent);
	        this.defaultPrevented = true;
	    };
	    
	    this.stop = function() {
	        this.stopPropagation();
	        this.preventDefault();
	    };
	    this.getDocumentPosition = function() {
	        if (this.$pos)
	            return this.$pos;
	        
	        this.$pos = this.editor.renderer.screenToTextCoordinates(this.clientX, this.clientY);
	        return this.$pos;
	    };
	    this.inSelection = function() {
	        if (this.$inSelection !== null)
	            return this.$inSelection;
	            
	        var editor = this.editor;
	        
	
	        var selectionRange = editor.getSelectionRange();
	        if (selectionRange.isEmpty())
	            this.$inSelection = false;
	        else {
	            var pos = this.getDocumentPosition();
	            this.$inSelection = selectionRange.contains(pos.row, pos.column);
	        }
	
	        return this.$inSelection;
	    };
	    this.getButton = function() {
	        return event.getButton(this.domEvent);
	    };
	    this.getShiftKey = function() {
	        return this.domEvent.shiftKey;
	    };
	    
	    this.getAccelKey = useragent.isMac
	        ? function() { return this.domEvent.metaKey; }
	        : function() { return this.domEvent.ctrlKey; };
	    
	}).call(MouseEvent.prototype);
	
	});
	
	ace.define("ace/mouse/dragdrop_handler",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
	"use strict";
	
	var dom = acequire("../lib/dom");
	var event = acequire("../lib/event");
	var useragent = acequire("../lib/useragent");
	
	var AUTOSCROLL_DELAY = 200;
	var SCROLL_CURSOR_DELAY = 200;
	var SCROLL_CURSOR_HYSTERESIS = 5;
	
	function DragdropHandler(mouseHandler) {
	
	    var editor = mouseHandler.editor;
	
	    var blankImage = dom.createElement("img");
	    blankImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	    if (useragent.isOpera)
	        blankImage.style.cssText = "width:1px;height:1px;position:fixed;top:0;left:0;z-index:2147483647;opacity:0;";
	
	    var exports = ["dragWait", "dragWaitEnd", "startDrag", "dragReadyEnd", "onMouseDrag"];
	
	     exports.forEach(function(x) {
	         mouseHandler[x] = this[x];
	    }, this);
	    editor.addEventListener("mousedown", this.onMouseDown.bind(mouseHandler));
	
	
	    var mouseTarget = editor.container;
	    var dragSelectionMarker, x, y;
	    var timerId, range;
	    var dragCursor, counter = 0;
	    var dragOperation;
	    var isInternal;
	    var autoScrollStartTime;
	    var cursorMovedTime;
	    var cursorPointOnCaretMoved;
	
	    this.onDragStart = function(e) {
	        if (this.cancelDrag || !mouseTarget.draggable) {
	            var self = this;
	            setTimeout(function(){
	                self.startSelect();
	                self.captureMouse(e);
	            }, 0);
	            return e.preventDefault();
	        }
	        range = editor.getSelectionRange();
	
	        var dataTransfer = e.dataTransfer;
	        dataTransfer.effectAllowed = editor.getReadOnly() ? "copy" : "copyMove";
	        if (useragent.isOpera) {
	            editor.container.appendChild(blankImage);
	            blankImage.scrollTop = 0;
	        }
	        dataTransfer.setDragImage && dataTransfer.setDragImage(blankImage, 0, 0);
	        if (useragent.isOpera) {
	            editor.container.removeChild(blankImage);
	        }
	        dataTransfer.clearData();
	        dataTransfer.setData("Text", editor.session.getTextRange());
	
	        isInternal = true;
	        this.setState("drag");
	    };
	
	    this.onDragEnd = function(e) {
	        mouseTarget.draggable = false;
	        isInternal = false;
	        this.setState(null);
	        if (!editor.getReadOnly()) {
	            var dropEffect = e.dataTransfer.dropEffect;
	            if (!dragOperation && dropEffect == "move")
	                editor.session.remove(editor.getSelectionRange());
	            editor.renderer.$cursorLayer.setBlinking(true);
	        }
	        this.editor.unsetStyle("ace_dragging");
	        this.editor.renderer.setCursorStyle("");
	    };
	
	    this.onDragEnter = function(e) {
	        if (editor.getReadOnly() || !canAccept(e.dataTransfer))
	            return;
	        x = e.clientX;
	        y = e.clientY;
	        if (!dragSelectionMarker)
	            addDragMarker();
	        counter++;
	        e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
	        return event.preventDefault(e);
	    };
	
	    this.onDragOver = function(e) {
	        if (editor.getReadOnly() || !canAccept(e.dataTransfer))
	            return;
	        x = e.clientX;
	        y = e.clientY;
	        if (!dragSelectionMarker) {
	            addDragMarker();
	            counter++;
	        }
	        if (onMouseMoveTimer !== null)
	            onMouseMoveTimer = null;
	
	        e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
	        return event.preventDefault(e);
	    };
	
	    this.onDragLeave = function(e) {
	        counter--;
	        if (counter <= 0 && dragSelectionMarker) {
	            clearDragMarker();
	            dragOperation = null;
	            return event.preventDefault(e);
	        }
	    };
	
	    this.onDrop = function(e) {
	        if (!dragCursor)
	            return;
	        var dataTransfer = e.dataTransfer;
	        if (isInternal) {
	            switch (dragOperation) {
	                case "move":
	                    if (range.contains(dragCursor.row, dragCursor.column)) {
	                        range = {
	                            start: dragCursor,
	                            end: dragCursor
	                        };
	                    } else {
	                        range = editor.moveText(range, dragCursor);
	                    }
	                    break;
	                case "copy":
	                    range = editor.moveText(range, dragCursor, true);
	                    break;
	            }
	        } else {
	            var dropData = dataTransfer.getData('Text');
	            range = {
	                start: dragCursor,
	                end: editor.session.insert(dragCursor, dropData)
	            };
	            editor.focus();
	            dragOperation = null;
	        }
	        clearDragMarker();
	        return event.preventDefault(e);
	    };
	
	    event.addListener(mouseTarget, "dragstart", this.onDragStart.bind(mouseHandler));
	    event.addListener(mouseTarget, "dragend", this.onDragEnd.bind(mouseHandler));
	    event.addListener(mouseTarget, "dragenter", this.onDragEnter.bind(mouseHandler));
	    event.addListener(mouseTarget, "dragover", this.onDragOver.bind(mouseHandler));
	    event.addListener(mouseTarget, "dragleave", this.onDragLeave.bind(mouseHandler));
	    event.addListener(mouseTarget, "drop", this.onDrop.bind(mouseHandler));
	
	    function scrollCursorIntoView(cursor, prevCursor) {
	        var now = Date.now();
	        var vMovement = !prevCursor || cursor.row != prevCursor.row;
	        var hMovement = !prevCursor || cursor.column != prevCursor.column;
	        if (!cursorMovedTime || vMovement || hMovement) {
	            editor.$blockScrolling += 1;
	            editor.moveCursorToPosition(cursor);
	            editor.$blockScrolling -= 1;
	            cursorMovedTime = now;
	            cursorPointOnCaretMoved = {x: x, y: y};
	        } else {
	            var distance = calcDistance(cursorPointOnCaretMoved.x, cursorPointOnCaretMoved.y, x, y);
	            if (distance > SCROLL_CURSOR_HYSTERESIS) {
	                cursorMovedTime = null;
	            } else if (now - cursorMovedTime >= SCROLL_CURSOR_DELAY) {
	                editor.renderer.scrollCursorIntoView();
	                cursorMovedTime = null;
	            }
	        }
	    }
	
	    function autoScroll(cursor, prevCursor) {
	        var now = Date.now();
	        var lineHeight = editor.renderer.layerConfig.lineHeight;
	        var characterWidth = editor.renderer.layerConfig.characterWidth;
	        var editorRect = editor.renderer.scroller.getBoundingClientRect();
	        var offsets = {
	           x: {
	               left: x - editorRect.left,
	               right: editorRect.right - x
	           },
	           y: {
	               top: y - editorRect.top,
	               bottom: editorRect.bottom - y
	           }
	        };
	        var nearestXOffset = Math.min(offsets.x.left, offsets.x.right);
	        var nearestYOffset = Math.min(offsets.y.top, offsets.y.bottom);
	        var scrollCursor = {row: cursor.row, column: cursor.column};
	        if (nearestXOffset / characterWidth <= 2) {
	            scrollCursor.column += (offsets.x.left < offsets.x.right ? -3 : +2);
	        }
	        if (nearestYOffset / lineHeight <= 1) {
	            scrollCursor.row += (offsets.y.top < offsets.y.bottom ? -1 : +1);
	        }
	        var vScroll = cursor.row != scrollCursor.row;
	        var hScroll = cursor.column != scrollCursor.column;
	        var vMovement = !prevCursor || cursor.row != prevCursor.row;
	        if (vScroll || (hScroll && !vMovement)) {
	            if (!autoScrollStartTime)
	                autoScrollStartTime = now;
	            else if (now - autoScrollStartTime >= AUTOSCROLL_DELAY)
	                editor.renderer.scrollCursorIntoView(scrollCursor);
	        } else {
	            autoScrollStartTime = null;
	        }
	    }
	
	    function onDragInterval() {
	        var prevCursor = dragCursor;
	        dragCursor = editor.renderer.screenToTextCoordinates(x, y);
	        scrollCursorIntoView(dragCursor, prevCursor);
	        autoScroll(dragCursor, prevCursor);
	    }
	
	    function addDragMarker() {
	        range = editor.selection.toOrientedRange();
	        dragSelectionMarker = editor.session.addMarker(range, "ace_selection", editor.getSelectionStyle());
	        editor.clearSelection();
	        if (editor.isFocused())
	            editor.renderer.$cursorLayer.setBlinking(false);
	        clearInterval(timerId);
	        onDragInterval();
	        timerId = setInterval(onDragInterval, 20);
	        counter = 0;
	        event.addListener(document, "mousemove", onMouseMove);
	    }
	
	    function clearDragMarker() {
	        clearInterval(timerId);
	        editor.session.removeMarker(dragSelectionMarker);
	        dragSelectionMarker = null;
	        editor.$blockScrolling += 1;
	        editor.selection.fromOrientedRange(range);
	        editor.$blockScrolling -= 1;
	        if (editor.isFocused() && !isInternal)
	            editor.renderer.$cursorLayer.setBlinking(!editor.getReadOnly());
	        range = null;
	        dragCursor = null;
	        counter = 0;
	        autoScrollStartTime = null;
	        cursorMovedTime = null;
	        event.removeListener(document, "mousemove", onMouseMove);
	    }
	    var onMouseMoveTimer = null;
	    function onMouseMove() {
	        if (onMouseMoveTimer == null) {
	            onMouseMoveTimer = setTimeout(function() {
	                if (onMouseMoveTimer != null && dragSelectionMarker)
	                    clearDragMarker();
	            }, 20);
	        }
	    }
	
	    function canAccept(dataTransfer) {
	        var types = dataTransfer.types;
	        return !types || Array.prototype.some.call(types, function(type) {
	            return type == 'text/plain' || type == 'Text';
	        });
	    }
	
	    function getDropEffect(e) {
	        var copyAllowed = ['copy', 'copymove', 'all', 'uninitialized'];
	        var moveAllowed = ['move', 'copymove', 'linkmove', 'all', 'uninitialized'];
	
	        var copyModifierState = useragent.isMac ? e.altKey : e.ctrlKey;
	        var effectAllowed = "uninitialized";
	        try {
	            effectAllowed = e.dataTransfer.effectAllowed.toLowerCase();
	        } catch (e) {}
	        var dropEffect = "none";
	
	        if (copyModifierState && copyAllowed.indexOf(effectAllowed) >= 0)
	            dropEffect = "copy";
	        else if (moveAllowed.indexOf(effectAllowed) >= 0)
	            dropEffect = "move";
	        else if (copyAllowed.indexOf(effectAllowed) >= 0)
	            dropEffect = "copy";
	
	        return dropEffect;
	    }
	}
	
	(function() {
	
	    this.dragWait = function() {
	        var interval = Date.now() - this.mousedownEvent.time;
	        if (interval > this.editor.getDragDelay())
	            this.startDrag();
	    };
	
	    this.dragWaitEnd = function() {
	        var target = this.editor.container;
	        target.draggable = false;
	        this.startSelect(this.mousedownEvent.getDocumentPosition());
	        this.selectEnd();
	    };
	
	    this.dragReadyEnd = function(e) {
	        this.editor.renderer.$cursorLayer.setBlinking(!this.editor.getReadOnly());
	        this.editor.unsetStyle("ace_dragging");
	        this.editor.renderer.setCursorStyle("");
	        this.dragWaitEnd();
	    };
	
	    this.startDrag = function(){
	        this.cancelDrag = false;
	        var editor = this.editor;
	        var target = editor.container;
	        target.draggable = true;
	        editor.renderer.$cursorLayer.setBlinking(false);
	        editor.setStyle("ace_dragging");
	        var cursorStyle = useragent.isWin ? "default" : "move";
	        editor.renderer.setCursorStyle(cursorStyle);
	        this.setState("dragReady");
	    };
	
	    this.onMouseDrag = function(e) {
	        var target = this.editor.container;
	        if (useragent.isIE && this.state == "dragReady") {
	            var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
	            if (distance > 3)
	                target.dragDrop();
	        }
	        if (this.state === "dragWait") {
	            var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
	            if (distance > 0) {
	                target.draggable = false;
	                this.startSelect(this.mousedownEvent.getDocumentPosition());
	            }
	        }
	    };
	
	    this.onMouseDown = function(e) {
	        if (!this.$dragEnabled)
	            return;
	        this.mousedownEvent = e;
	        var editor = this.editor;
	
	        var inSelection = e.inSelection();
	        var button = e.getButton();
	        var clickCount = e.domEvent.detail || 1;
	        if (clickCount === 1 && button === 0 && inSelection) {
	            if (e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey()))
	                return;
	            this.mousedownEvent.time = Date.now();
	            var eventTarget = e.domEvent.target || e.domEvent.srcElement;
	            if ("unselectable" in eventTarget)
	                eventTarget.unselectable = "on";
	            if (editor.getDragDelay()) {
	                if (useragent.isWebKit) {
	                    this.cancelDrag = true;
	                    var mouseTarget = editor.container;
	                    mouseTarget.draggable = true;
	                }
	                this.setState("dragWait");
	            } else {
	                this.startDrag();
	            }
	            this.captureMouse(e, this.onMouseDrag.bind(this));
	            e.defaultPrevented = true;
	        }
	    };
	
	}).call(DragdropHandler.prototype);
	
	
	function calcDistance(ax, ay, bx, by) {
	    return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
	}
	
	exports.DragdropHandler = DragdropHandler;
	
	});
	
	ace.define("ace/lib/net",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
	"use strict";
	var dom = acequire("./dom");
	
	exports.get = function (url, callback) {
	    var xhr = new XMLHttpRequest();
	    xhr.open('GET', url, true);
	    xhr.onreadystatechange = function () {
	        if (xhr.readyState === 4) {
	            callback(xhr.responseText);
	        }
	    };
	    xhr.send(null);
	};
	
	exports.loadScript = function(path, callback) {
	    var head = dom.getDocumentHead();
	    var s = document.createElement('script');
	
	    s.src = path;
	    head.appendChild(s);
	
	    s.onload = s.onreadystatechange = function(_, isAbort) {
	        if (isAbort || !s.readyState || s.readyState == "loaded" || s.readyState == "complete") {
	            s = s.onload = s.onreadystatechange = null;
	            if (!isAbort)
	                callback();
	        }
	    };
	};
	exports.qualifyURL = function(url) {
	    var a = document.createElement('a');
	    a.href = url;
	    return a.href;
	}
	
	});
	
	ace.define("ace/lib/event_emitter",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	var EventEmitter = {};
	var stopPropagation = function() { this.propagationStopped = true; };
	var preventDefault = function() { this.defaultPrevented = true; };
	
	EventEmitter._emit =
	EventEmitter._dispatchEvent = function(eventName, e) {
	    this._eventRegistry || (this._eventRegistry = {});
	    this._defaultHandlers || (this._defaultHandlers = {});
	
	    var listeners = this._eventRegistry[eventName] || [];
	    var defaultHandler = this._defaultHandlers[eventName];
	    if (!listeners.length && !defaultHandler)
	        return;
	
	    if (typeof e != "object" || !e)
	        e = {};
	
	    if (!e.type)
	        e.type = eventName;
	    if (!e.stopPropagation)
	        e.stopPropagation = stopPropagation;
	    if (!e.preventDefault)
	        e.preventDefault = preventDefault;
	
	    listeners = listeners.slice();
	    for (var i=0; i<listeners.length; i++) {
	        listeners[i](e, this);
	        if (e.propagationStopped)
	            break;
	    }
	    
	    if (defaultHandler && !e.defaultPrevented)
	        return defaultHandler(e, this);
	};
	
	
	EventEmitter._signal = function(eventName, e) {
	    var listeners = (this._eventRegistry || {})[eventName];
	    if (!listeners)
	        return;
	    listeners = listeners.slice();
	    for (var i=0; i<listeners.length; i++)
	        listeners[i](e, this);
	};
	
	EventEmitter.once = function(eventName, callback) {
	    var _self = this;
	    callback && this.addEventListener(eventName, function newCallback() {
	        _self.removeEventListener(eventName, newCallback);
	        callback.apply(null, arguments);
	    });
	};
	
	
	EventEmitter.setDefaultHandler = function(eventName, callback) {
	    var handlers = this._defaultHandlers
	    if (!handlers)
	        handlers = this._defaultHandlers = {_disabled_: {}};
	    
	    if (handlers[eventName]) {
	        var old = handlers[eventName];
	        var disabled = handlers._disabled_[eventName];
	        if (!disabled)
	            handlers._disabled_[eventName] = disabled = [];
	        disabled.push(old);
	        var i = disabled.indexOf(callback);
	        if (i != -1) 
	            disabled.splice(i, 1);
	    }
	    handlers[eventName] = callback;
	};
	EventEmitter.removeDefaultHandler = function(eventName, callback) {
	    var handlers = this._defaultHandlers
	    if (!handlers)
	        return;
	    var disabled = handlers._disabled_[eventName];
	    
	    if (handlers[eventName] == callback) {
	        var old = handlers[eventName];
	        if (disabled)
	            this.setDefaultHandler(eventName, disabled.pop());
	    } else if (disabled) {
	        var i = disabled.indexOf(callback);
	        if (i != -1)
	            disabled.splice(i, 1);
	    }
	};
	
	EventEmitter.on =
	EventEmitter.addEventListener = function(eventName, callback, capturing) {
	    this._eventRegistry = this._eventRegistry || {};
	
	    var listeners = this._eventRegistry[eventName];
	    if (!listeners)
	        listeners = this._eventRegistry[eventName] = [];
	
	    if (listeners.indexOf(callback) == -1)
	        listeners[capturing ? "unshift" : "push"](callback);
	    return callback;
	};
	
	EventEmitter.off =
	EventEmitter.removeListener =
	EventEmitter.removeEventListener = function(eventName, callback) {
	    this._eventRegistry = this._eventRegistry || {};
	
	    var listeners = this._eventRegistry[eventName];
	    if (!listeners)
	        return;
	
	    var index = listeners.indexOf(callback);
	    if (index !== -1)
	        listeners.splice(index, 1);
	};
	
	EventEmitter.removeAllListeners = function(eventName) {
	    if (this._eventRegistry) this._eventRegistry[eventName] = [];
	};
	
	exports.EventEmitter = EventEmitter;
	
	});
	
	ace.define("ace/lib/app_config",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"], function(acequire, exports, module) {
	"no use strict";
	
	var oop = acequire("./oop");
	var EventEmitter = acequire("./event_emitter").EventEmitter;
	
	var optionsProvider = {
	    setOptions: function(optList) {
	        Object.keys(optList).forEach(function(key) {
	            this.setOption(key, optList[key]);
	        }, this);
	    },
	    getOptions: function(optionNames) {
	        var result = {};
	        if (!optionNames) {
	            optionNames = Object.keys(this.$options);
	        } else if (!Array.isArray(optionNames)) {
	            result = optionNames;
	            optionNames = Object.keys(result);
	        }
	        optionNames.forEach(function(key) {
	            result[key] = this.getOption(key);
	        }, this);
	        return result;
	    },
	    setOption: function(name, value) {
	        if (this["$" + name] === value)
	            return;
	        var opt = this.$options[name];
	        if (!opt) {
	            return warn('misspelled option "' + name + '"');
	        }
	        if (opt.forwardTo)
	            return this[opt.forwardTo] && this[opt.forwardTo].setOption(name, value);
	
	        if (!opt.handlesSet)
	            this["$" + name] = value;
	        if (opt && opt.set)
	            opt.set.call(this, value);
	    },
	    getOption: function(name) {
	        var opt = this.$options[name];
	        if (!opt) {
	            return warn('misspelled option "' + name + '"');
	        }
	        if (opt.forwardTo)
	            return this[opt.forwardTo] && this[opt.forwardTo].getOption(name);
	        return opt && opt.get ? opt.get.call(this) : this["$" + name];
	    }
	};
	
	function warn(message) {
	    if (typeof console != "undefined" && console.warn)
	        console.warn.apply(console, arguments);
	}
	
	function reportError(msg, data) {
	    var e = new Error(msg);
	    e.data = data;
	    if (typeof console == "object" && console.error)
	        console.error(e);
	    setTimeout(function() { throw e; });
	}
	
	var AppConfig = function() {
	    this.$defaultOptions = {};
	};
	
	(function() {
	    oop.implement(this, EventEmitter);
	    this.defineOptions = function(obj, path, options) {
	        if (!obj.$options)
	            this.$defaultOptions[path] = obj.$options = {};
	
	        Object.keys(options).forEach(function(key) {
	            var opt = options[key];
	            if (typeof opt == "string")
	                opt = {forwardTo: opt};
	
	            opt.name || (opt.name = key);
	            obj.$options[opt.name] = opt;
	            if ("initialValue" in opt)
	                obj["$" + opt.name] = opt.initialValue;
	        });
	        oop.implement(obj, optionsProvider);
	
	        return this;
	    };
	
	    this.resetOptions = function(obj) {
	        Object.keys(obj.$options).forEach(function(key) {
	            var opt = obj.$options[key];
	            if ("value" in opt)
	                obj.setOption(key, opt.value);
	        });
	    };
	
	    this.setDefaultValue = function(path, name, value) {
	        var opts = this.$defaultOptions[path] || (this.$defaultOptions[path] = {});
	        if (opts[name]) {
	            if (opts.forwardTo)
	                this.setDefaultValue(opts.forwardTo, name, value);
	            else
	                opts[name].value = value;
	        }
	    };
	
	    this.setDefaultValues = function(path, optionHash) {
	        Object.keys(optionHash).forEach(function(key) {
	            this.setDefaultValue(path, key, optionHash[key]);
	        }, this);
	    };
	    
	    this.warn = warn;
	    this.reportError = reportError;
	    
	}).call(AppConfig.prototype);
	
	exports.AppConfig = AppConfig;
	
	});
	
	ace.define("ace/config",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/lib/net","ace/lib/app_config"], function(acequire, exports, module) {
	"no use strict";
	
	var lang = acequire("./lib/lang");
	var oop = acequire("./lib/oop");
	var net = acequire("./lib/net");
	var AppConfig = acequire("./lib/app_config").AppConfig;
	
	module.exports = exports = new AppConfig();
	
	var global = (function() {
	    return this || typeof window != "undefined" && window;
	})();
	
	var options = {
	    packaged: false,
	    workerPath: null,
	    modePath: null,
	    themePath: null,
	    basePath: "",
	    suffix: ".js",
	    $moduleUrls: {}
	};
	
	exports.get = function(key) {
	    if (!options.hasOwnProperty(key))
	        throw new Error("Unknown config key: " + key);
	
	    return options[key];
	};
	
	exports.set = function(key, value) {
	    if (!options.hasOwnProperty(key))
	        throw new Error("Unknown config key: " + key);
	
	    options[key] = value;
	};
	
	exports.all = function() {
	    return lang.copyObject(options);
	};
	exports.moduleUrl = function(name, component) {
	    if (options.$moduleUrls[name])
	        return options.$moduleUrls[name];
	
	    var parts = name.split("/");
	    component = component || parts[parts.length - 2] || "";
	    var sep = component == "snippets" ? "/" : "-";
	    var base = parts[parts.length - 1];
	    if (component == "worker" && sep == "-") {
	        var re = new RegExp("^" + component + "[\\-_]|[\\-_]" + component + "$", "g");
	        base = base.replace(re, "");
	    }
	
	    if ((!base || base == component) && parts.length > 1)
	        base = parts[parts.length - 2];
	    var path = options[component + "Path"];
	    if (path == null) {
	        path = options.basePath;
	    } else if (sep == "/") {
	        component = sep = "";
	    }
	    if (path && path.slice(-1) != "/")
	        path += "/";
	    return path + component + sep + base + this.get("suffix");
	};
	
	exports.setModuleUrl = function(name, subst) {
	    return options.$moduleUrls[name] = subst;
	};
	
	exports.$loading = {};
	exports.loadModule = function(moduleName, onLoad) {
	    var module, moduleType;
	    if (Array.isArray(moduleName)) {
	        moduleType = moduleName[0];
	        moduleName = moduleName[1];
	    }
	
	    try {
	        module = acequire(moduleName);
	    } catch (e) {}
	    if (module && !exports.$loading[moduleName])
	        return onLoad && onLoad(module);
	
	    if (!exports.$loading[moduleName])
	        exports.$loading[moduleName] = [];
	
	    exports.$loading[moduleName].push(onLoad);
	
	    if (exports.$loading[moduleName].length > 1)
	        return;
	
	    var afterLoad = function() {
	        acequire([moduleName], function(module) {
	            exports._emit("load.module", {name: moduleName, module: module});
	            var listeners = exports.$loading[moduleName];
	            exports.$loading[moduleName] = null;
	            listeners.forEach(function(onLoad) {
	                onLoad && onLoad(module);
	            });
	        });
	    };
	
	    if (!exports.get("packaged"))
	        return afterLoad();
	    net.loadScript(exports.moduleUrl(moduleName, moduleType), afterLoad);
	};
	init(true);function init(packaged) {
	
	    if (!global || !global.document)
	        return;
	    
	    options.packaged = packaged || acequire.packaged || module.packaged || (global.define && __webpack_require__(262).packaged);
	
	    var scriptOptions = {};
	    var scriptUrl = "";
	    var currentScript = (document.currentScript || document._currentScript ); // native or polyfill
	    var currentDocument = currentScript && currentScript.ownerDocument || document;
	    
	    var scripts = currentDocument.getElementsByTagName("script");
	    for (var i=0; i<scripts.length; i++) {
	        var script = scripts[i];
	
	        var src = script.src || script.getAttribute("src");
	        if (!src)
	            continue;
	
	        var attributes = script.attributes;
	        for (var j=0, l=attributes.length; j < l; j++) {
	            var attr = attributes[j];
	            if (attr.name.indexOf("data-ace-") === 0) {
	                scriptOptions[deHyphenate(attr.name.replace(/^data-ace-/, ""))] = attr.value;
	            }
	        }
	
	        var m = src.match(/^(.*)\/ace(\-\w+)?\.js(\?|$)/);
	        if (m)
	            scriptUrl = m[1];
	    }
	
	    if (scriptUrl) {
	        scriptOptions.base = scriptOptions.base || scriptUrl;
	        scriptOptions.packaged = true;
	    }
	
	    scriptOptions.basePath = scriptOptions.base;
	    scriptOptions.workerPath = scriptOptions.workerPath || scriptOptions.base;
	    scriptOptions.modePath = scriptOptions.modePath || scriptOptions.base;
	    scriptOptions.themePath = scriptOptions.themePath || scriptOptions.base;
	    delete scriptOptions.base;
	
	    for (var key in scriptOptions)
	        if (typeof scriptOptions[key] !== "undefined")
	            exports.set(key, scriptOptions[key]);
	}
	
	exports.init = init;
	
	function deHyphenate(str) {
	    return str.replace(/-(.)/g, function(m, m1) { return m1.toUpperCase(); });
	}
	
	});
	
	ace.define("ace/mouse/mouse_handler",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/mouse/default_handlers","ace/mouse/default_gutter_handler","ace/mouse/mouse_event","ace/mouse/dragdrop_handler","ace/config"], function(acequire, exports, module) {
	"use strict";
	
	var event = acequire("../lib/event");
	var useragent = acequire("../lib/useragent");
	var DefaultHandlers = acequire("./default_handlers").DefaultHandlers;
	var DefaultGutterHandler = acequire("./default_gutter_handler").GutterHandler;
	var MouseEvent = acequire("./mouse_event").MouseEvent;
	var DragdropHandler = acequire("./dragdrop_handler").DragdropHandler;
	var config = acequire("../config");
	
	var MouseHandler = function(editor) {
	    var _self = this;
	    this.editor = editor;
	
	    new DefaultHandlers(this);
	    new DefaultGutterHandler(this);
	    new DragdropHandler(this);
	
	    var focusEditor = function(e) {
	        var windowBlurred = !document.hasFocus || !document.hasFocus()
	            || !editor.isFocused() && document.activeElement == (editor.textInput && editor.textInput.getElement())
	        if (windowBlurred)
	            window.focus();
	        editor.focus();
	    };
	
	    var mouseTarget = editor.renderer.getMouseEventTarget();
	    event.addListener(mouseTarget, "click", this.onMouseEvent.bind(this, "click"));
	    event.addListener(mouseTarget, "mousemove", this.onMouseMove.bind(this, "mousemove"));
	    event.addMultiMouseDownListener([
	        mouseTarget,
	        editor.renderer.scrollBarV && editor.renderer.scrollBarV.inner,
	        editor.renderer.scrollBarH && editor.renderer.scrollBarH.inner,
	        editor.textInput && editor.textInput.getElement()
	    ].filter(Boolean), [400, 300, 250], this, "onMouseEvent");
	    event.addMouseWheelListener(editor.container, this.onMouseWheel.bind(this, "mousewheel"));
	    event.addTouchMoveListener(editor.container, this.onTouchMove.bind(this, "touchmove"));
	
	    var gutterEl = editor.renderer.$gutter;
	    event.addListener(gutterEl, "mousedown", this.onMouseEvent.bind(this, "guttermousedown"));
	    event.addListener(gutterEl, "click", this.onMouseEvent.bind(this, "gutterclick"));
	    event.addListener(gutterEl, "dblclick", this.onMouseEvent.bind(this, "gutterdblclick"));
	    event.addListener(gutterEl, "mousemove", this.onMouseEvent.bind(this, "guttermousemove"));
	
	    event.addListener(mouseTarget, "mousedown", focusEditor);
	    event.addListener(gutterEl, "mousedown", focusEditor);
	    if (useragent.isIE && editor.renderer.scrollBarV) {
	        event.addListener(editor.renderer.scrollBarV.element, "mousedown", focusEditor);
	        event.addListener(editor.renderer.scrollBarH.element, "mousedown", focusEditor);
	    }
	
	    editor.on("mousemove", function(e){
	        if (_self.state || _self.$dragDelay || !_self.$dragEnabled)
	            return;
	
	        var character = editor.renderer.screenToTextCoordinates(e.x, e.y);
	        var range = editor.session.selection.getRange();
	        var renderer = editor.renderer;
	
	        if (!range.isEmpty() && range.insideStart(character.row, character.column)) {
	            renderer.setCursorStyle("default");
	        } else {
	            renderer.setCursorStyle("");
	        }
	    });
	};
	
	(function() {
	    this.onMouseEvent = function(name, e) {
	        this.editor._emit(name, new MouseEvent(e, this.editor));
	    };
	
	    this.onMouseMove = function(name, e) {
	        var listeners = this.editor._eventRegistry && this.editor._eventRegistry.mousemove;
	        if (!listeners || !listeners.length)
	            return;
	
	        this.editor._emit(name, new MouseEvent(e, this.editor));
	    };
	
	    this.onMouseWheel = function(name, e) {
	        var mouseEvent = new MouseEvent(e, this.editor);
	        mouseEvent.speed = this.$scrollSpeed * 2;
	        mouseEvent.wheelX = e.wheelX;
	        mouseEvent.wheelY = e.wheelY;
	
	        this.editor._emit(name, mouseEvent);
	    };
	    
	    this.onTouchMove = function (name, e) {
	        var mouseEvent = new MouseEvent(e, this.editor);
	        mouseEvent.speed = 1;//this.$scrollSpeed * 2;
	        mouseEvent.wheelX = e.wheelX;
	        mouseEvent.wheelY = e.wheelY;
	        this.editor._emit(name, mouseEvent);
	    };
	
	    this.setState = function(state) {
	        this.state = state;
	    };
	
	    this.captureMouse = function(ev, mouseMoveHandler) {
	        this.x = ev.x;
	        this.y = ev.y;
	
	        this.isMousePressed = true;
	        var renderer = this.editor.renderer;
	        if (renderer.$keepTextAreaAtCursor)
	            renderer.$keepTextAreaAtCursor = null;
	
	        var self = this;
	        var onMouseMove = function(e) {
	            if (!e) return;
	            if (useragent.isWebKit && !e.which && self.releaseMouse)
	                return self.releaseMouse();
	
	            self.x = e.clientX;
	            self.y = e.clientY;
	            mouseMoveHandler && mouseMoveHandler(e);
	            self.mouseEvent = new MouseEvent(e, self.editor);
	            self.$mouseMoved = true;
	        };
	
	        var onCaptureEnd = function(e) {
	            clearInterval(timerId);
	            onCaptureInterval();
	            self[self.state + "End"] && self[self.state + "End"](e);
	            self.state = "";
	            if (renderer.$keepTextAreaAtCursor == null) {
	                renderer.$keepTextAreaAtCursor = true;
	                renderer.$moveTextAreaToCursor();
	            }
	            self.isMousePressed = false;
	            self.$onCaptureMouseMove = self.releaseMouse = null;
	            e && self.onMouseEvent("mouseup", e);
	        };
	
	        var onCaptureInterval = function() {
	            self[self.state] && self[self.state]();
	            self.$mouseMoved = false;
	        };
	
	        if (useragent.isOldIE && ev.domEvent.type == "dblclick") {
	            return setTimeout(function() {onCaptureEnd(ev);});
	        }
	
	        self.$onCaptureMouseMove = onMouseMove;
	        self.releaseMouse = event.capture(this.editor.container, onMouseMove, onCaptureEnd);
	        var timerId = setInterval(onCaptureInterval, 20);
	    };
	    this.releaseMouse = null;
	    this.cancelContextMenu = function() {
	        var stop = function(e) {
	            if (e && e.domEvent && e.domEvent.type != "contextmenu")
	                return;
	            this.editor.off("nativecontextmenu", stop);
	            if (e && e.domEvent)
	                event.stopEvent(e.domEvent);
	        }.bind(this);
	        setTimeout(stop, 10);
	        this.editor.on("nativecontextmenu", stop);
	    };
	}).call(MouseHandler.prototype);
	
	config.defineOptions(MouseHandler.prototype, "mouseHandler", {
	    scrollSpeed: {initialValue: 2},
	    dragDelay: {initialValue: (useragent.isMac ? 150 : 0)},
	    dragEnabled: {initialValue: true},
	    focusTimout: {initialValue: 0},
	    tooltipFollowsMouse: {initialValue: true}
	});
	
	
	exports.MouseHandler = MouseHandler;
	});
	
	ace.define("ace/mouse/fold_handler",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	function FoldHandler(editor) {
	
	    editor.on("click", function(e) {
	        var position = e.getDocumentPosition();
	        var session = editor.session;
	        var fold = session.getFoldAt(position.row, position.column, 1);
	        if (fold) {
	            if (e.getAccelKey())
	                session.removeFold(fold);
	            else
	                session.expandFold(fold);
	
	            e.stop();
	        }
	    });
	
	    editor.on("gutterclick", function(e) {
	        var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);
	
	        if (gutterRegion == "foldWidgets") {
	            var row = e.getDocumentPosition().row;
	            var session = editor.session;
	            if (session.foldWidgets && session.foldWidgets[row])
	                editor.session.onFoldWidgetClick(row, e);
	            if (!editor.isFocused())
	                editor.focus();
	            e.stop();
	        }
	    });
	
	    editor.on("gutterdblclick", function(e) {
	        var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);
	
	        if (gutterRegion == "foldWidgets") {
	            var row = e.getDocumentPosition().row;
	            var session = editor.session;
	            var data = session.getParentFoldRangeData(row, true);
	            var range = data.range || data.firstRange;
	
	            if (range) {
	                row = range.start.row;
	                var fold = session.getFoldAt(row, session.getLine(row).length, 1);
	
	                if (fold) {
	                    session.removeFold(fold);
	                } else {
	                    session.addFold("...", range);
	                    editor.renderer.scrollCursorIntoView({row: range.start.row, column: 0});
	                }
	            }
	            e.stop();
	        }
	    });
	}
	
	exports.FoldHandler = FoldHandler;
	
	});
	
	ace.define("ace/keyboard/keybinding",["require","exports","module","ace/lib/keys","ace/lib/event"], function(acequire, exports, module) {
	"use strict";
	
	var keyUtil  = acequire("../lib/keys");
	var event = acequire("../lib/event");
	
	var KeyBinding = function(editor) {
	    this.$editor = editor;
	    this.$data = {editor: editor};
	    this.$handlers = [];
	    this.setDefaultHandler(editor.commands);
	};
	
	(function() {
	    this.setDefaultHandler = function(kb) {
	        this.removeKeyboardHandler(this.$defaultHandler);
	        this.$defaultHandler = kb;
	        this.addKeyboardHandler(kb, 0);
	    };
	
	    this.setKeyboardHandler = function(kb) {
	        var h = this.$handlers;
	        if (h[h.length - 1] == kb)
	            return;
	
	        while (h[h.length - 1] && h[h.length - 1] != this.$defaultHandler)
	            this.removeKeyboardHandler(h[h.length - 1]);
	
	        this.addKeyboardHandler(kb, 1);
	    };
	
	    this.addKeyboardHandler = function(kb, pos) {
	        if (!kb)
	            return;
	        if (typeof kb == "function" && !kb.handleKeyboard)
	            kb.handleKeyboard = kb;
	        var i = this.$handlers.indexOf(kb);
	        if (i != -1)
	            this.$handlers.splice(i, 1);
	
	        if (pos == undefined)
	            this.$handlers.push(kb);
	        else
	            this.$handlers.splice(pos, 0, kb);
	
	        if (i == -1 && kb.attach)
	            kb.attach(this.$editor);
	    };
	
	    this.removeKeyboardHandler = function(kb) {
	        var i = this.$handlers.indexOf(kb);
	        if (i == -1)
	            return false;
	        this.$handlers.splice(i, 1);
	        kb.detach && kb.detach(this.$editor);
	        return true;
	    };
	
	    this.getKeyboardHandler = function() {
	        return this.$handlers[this.$handlers.length - 1];
	    };
	    
	    this.getStatusText = function() {
	        var data = this.$data;
	        var editor = data.editor;
	        return this.$handlers.map(function(h) {
	            return h.getStatusText && h.getStatusText(editor, data) || "";
	        }).filter(Boolean).join(" ");
	    };
	
	    this.$callKeyboardHandlers = function(hashId, keyString, keyCode, e) {
	        var toExecute;
	        var success = false;
	        var commands = this.$editor.commands;
	
	        for (var i = this.$handlers.length; i--;) {
	            toExecute = this.$handlers[i].handleKeyboard(
	                this.$data, hashId, keyString, keyCode, e
	            );
	            if (!toExecute || !toExecute.command)
	                continue;
	            if (toExecute.command == "null") {
	                success = true;
	            } else {
	                success = commands.exec(toExecute.command, this.$editor, toExecute.args, e);
	            }
	            if (success && e && hashId != -1 && 
	                toExecute.passEvent != true && toExecute.command.passEvent != true
	            ) {
	                event.stopEvent(e);
	            }
	            if (success)
	                break;
	        }
	        
	        if (!success && hashId == -1) {
	            toExecute = {command: "insertstring"};
	            success = commands.exec("insertstring", this.$editor, keyString);
	        }
	        
	        if (success && this.$editor._signal)
	            this.$editor._signal("keyboardActivity", toExecute);
	        
	        return success;
	    };
	
	    this.onCommandKey = function(e, hashId, keyCode) {
	        var keyString = keyUtil.keyCodeToString(keyCode);
	        this.$callKeyboardHandlers(hashId, keyString, keyCode, e);
	    };
	
	    this.onTextInput = function(text) {
	        this.$callKeyboardHandlers(-1, text);
	    };
	
	}).call(KeyBinding.prototype);
	
	exports.KeyBinding = KeyBinding;
	});
	
	ace.define("ace/range",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	var comparePoints = function(p1, p2) {
	    return p1.row - p2.row || p1.column - p2.column;
	};
	var Range = function(startRow, startColumn, endRow, endColumn) {
	    this.start = {
	        row: startRow,
	        column: startColumn
	    };
	
	    this.end = {
	        row: endRow,
	        column: endColumn
	    };
	};
	
	(function() {
	    this.isEqual = function(range) {
	        return this.start.row === range.start.row &&
	            this.end.row === range.end.row &&
	            this.start.column === range.start.column &&
	            this.end.column === range.end.column;
	    };
	    this.toString = function() {
	        return ("Range: [" + this.start.row + "/" + this.start.column +
	            "] -> [" + this.end.row + "/" + this.end.column + "]");
	    };
	
	    this.contains = function(row, column) {
	        return this.compare(row, column) == 0;
	    };
	    this.compareRange = function(range) {
	        var cmp,
	            end = range.end,
	            start = range.start;
	
	        cmp = this.compare(end.row, end.column);
	        if (cmp == 1) {
	            cmp = this.compare(start.row, start.column);
	            if (cmp == 1) {
	                return 2;
	            } else if (cmp == 0) {
	                return 1;
	            } else {
	                return 0;
	            }
	        } else if (cmp == -1) {
	            return -2;
	        } else {
	            cmp = this.compare(start.row, start.column);
	            if (cmp == -1) {
	                return -1;
	            } else if (cmp == 1) {
	                return 42;
	            } else {
	                return 0;
	            }
	        }
	    };
	    this.comparePoint = function(p) {
	        return this.compare(p.row, p.column);
	    };
	    this.containsRange = function(range) {
	        return this.comparePoint(range.start) == 0 && this.comparePoint(range.end) == 0;
	    };
	    this.intersects = function(range) {
	        var cmp = this.compareRange(range);
	        return (cmp == -1 || cmp == 0 || cmp == 1);
	    };
	    this.isEnd = function(row, column) {
	        return this.end.row == row && this.end.column == column;
	    };
	    this.isStart = function(row, column) {
	        return this.start.row == row && this.start.column == column;
	    };
	    this.setStart = function(row, column) {
	        if (typeof row == "object") {
	            this.start.column = row.column;
	            this.start.row = row.row;
	        } else {
	            this.start.row = row;
	            this.start.column = column;
	        }
	    };
	    this.setEnd = function(row, column) {
	        if (typeof row == "object") {
	            this.end.column = row.column;
	            this.end.row = row.row;
	        } else {
	            this.end.row = row;
	            this.end.column = column;
	        }
	    };
	    this.inside = function(row, column) {
	        if (this.compare(row, column) == 0) {
	            if (this.isEnd(row, column) || this.isStart(row, column)) {
	                return false;
	            } else {
	                return true;
	            }
	        }
	        return false;
	    };
	    this.insideStart = function(row, column) {
	        if (this.compare(row, column) == 0) {
	            if (this.isEnd(row, column)) {
	                return false;
	            } else {
	                return true;
	            }
	        }
	        return false;
	    };
	    this.insideEnd = function(row, column) {
	        if (this.compare(row, column) == 0) {
	            if (this.isStart(row, column)) {
	                return false;
	            } else {
	                return true;
	            }
	        }
	        return false;
	    };
	    this.compare = function(row, column) {
	        if (!this.isMultiLine()) {
	            if (row === this.start.row) {
	                return column < this.start.column ? -1 : (column > this.end.column ? 1 : 0);
	            }
	        }
	
	        if (row < this.start.row)
	            return -1;
	
	        if (row > this.end.row)
	            return 1;
	
	        if (this.start.row === row)
	            return column >= this.start.column ? 0 : -1;
	
	        if (this.end.row === row)
	            return column <= this.end.column ? 0 : 1;
	
	        return 0;
	    };
	    this.compareStart = function(row, column) {
	        if (this.start.row == row && this.start.column == column) {
	            return -1;
	        } else {
	            return this.compare(row, column);
	        }
	    };
	    this.compareEnd = function(row, column) {
	        if (this.end.row == row && this.end.column == column) {
	            return 1;
	        } else {
	            return this.compare(row, column);
	        }
	    };
	    this.compareInside = function(row, column) {
	        if (this.end.row == row && this.end.column == column) {
	            return 1;
	        } else if (this.start.row == row && this.start.column == column) {
	            return -1;
	        } else {
	            return this.compare(row, column);
	        }
	    };
	    this.clipRows = function(firstRow, lastRow) {
	        if (this.end.row > lastRow)
	            var end = {row: lastRow + 1, column: 0};
	        else if (this.end.row < firstRow)
	            var end = {row: firstRow, column: 0};
	
	        if (this.start.row > lastRow)
	            var start = {row: lastRow + 1, column: 0};
	        else if (this.start.row < firstRow)
	            var start = {row: firstRow, column: 0};
	
	        return Range.fromPoints(start || this.start, end || this.end);
	    };
	    this.extend = function(row, column) {
	        var cmp = this.compare(row, column);
	
	        if (cmp == 0)
	            return this;
	        else if (cmp == -1)
	            var start = {row: row, column: column};
	        else
	            var end = {row: row, column: column};
	
	        return Range.fromPoints(start || this.start, end || this.end);
	    };
	
	    this.isEmpty = function() {
	        return (this.start.row === this.end.row && this.start.column === this.end.column);
	    };
	    this.isMultiLine = function() {
	        return (this.start.row !== this.end.row);
	    };
	    this.clone = function() {
	        return Range.fromPoints(this.start, this.end);
	    };
	    this.collapseRows = function() {
	        if (this.end.column == 0)
	            return new Range(this.start.row, 0, Math.max(this.start.row, this.end.row-1), 0)
	        else
	            return new Range(this.start.row, 0, this.end.row, 0)
	    };
	    this.toScreenRange = function(session) {
	        var screenPosStart = session.documentToScreenPosition(this.start);
	        var screenPosEnd = session.documentToScreenPosition(this.end);
	
	        return new Range(
	            screenPosStart.row, screenPosStart.column,
	            screenPosEnd.row, screenPosEnd.column
	        );
	    };
	    this.moveBy = function(row, column) {
	        this.start.row += row;
	        this.start.column += column;
	        this.end.row += row;
	        this.end.column += column;
	    };
	
	}).call(Range.prototype);
	Range.fromPoints = function(start, end) {
	    return new Range(start.row, start.column, end.row, end.column);
	};
	Range.comparePoints = comparePoints;
	
	Range.comparePoints = function(p1, p2) {
	    return p1.row - p2.row || p1.column - p2.column;
	};
	
	
	exports.Range = Range;
	});
	
	ace.define("ace/selection",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("./lib/oop");
	var lang = acequire("./lib/lang");
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	var Range = acequire("./range").Range;
	var Selection = function(session) {
	    this.session = session;
	    this.doc = session.getDocument();
	
	    this.clearSelection();
	    this.lead = this.selectionLead = this.doc.createAnchor(0, 0);
	    this.anchor = this.selectionAnchor = this.doc.createAnchor(0, 0);
	
	    var self = this;
	    this.lead.on("change", function(e) {
	        self._emit("changeCursor");
	        if (!self.$isEmpty)
	            self._emit("changeSelection");
	        if (!self.$keepDesiredColumnOnChange && e.old.column != e.value.column)
	            self.$desiredColumn = null;
	    });
	
	    this.selectionAnchor.on("change", function() {
	        if (!self.$isEmpty)
	            self._emit("changeSelection");
	    });
	};
	
	(function() {
	
	    oop.implement(this, EventEmitter);
	    this.isEmpty = function() {
	        return (this.$isEmpty || (
	            this.anchor.row == this.lead.row &&
	            this.anchor.column == this.lead.column
	        ));
	    };
	    this.isMultiLine = function() {
	        if (this.isEmpty()) {
	            return false;
	        }
	
	        return this.getRange().isMultiLine();
	    };
	    this.getCursor = function() {
	        return this.lead.getPosition();
	    };
	    this.setSelectionAnchor = function(row, column) {
	        this.anchor.setPosition(row, column);
	
	        if (this.$isEmpty) {
	            this.$isEmpty = false;
	            this._emit("changeSelection");
	        }
	    };
	    this.getSelectionAnchor = function() {
	        if (this.$isEmpty)
	            return this.getSelectionLead();
	        else
	            return this.anchor.getPosition();
	    };
	    this.getSelectionLead = function() {
	        return this.lead.getPosition();
	    };
	    this.shiftSelection = function(columns) {
	        if (this.$isEmpty) {
	            this.moveCursorTo(this.lead.row, this.lead.column + columns);
	            return;
	        }
	
	        var anchor = this.getSelectionAnchor();
	        var lead = this.getSelectionLead();
	
	        var isBackwards = this.isBackwards();
	
	        if (!isBackwards || anchor.column !== 0)
	            this.setSelectionAnchor(anchor.row, anchor.column + columns);
	
	        if (isBackwards || lead.column !== 0) {
	            this.$moveSelection(function() {
	                this.moveCursorTo(lead.row, lead.column + columns);
	            });
	        }
	    };
	    this.isBackwards = function() {
	        var anchor = this.anchor;
	        var lead = this.lead;
	        return (anchor.row > lead.row || (anchor.row == lead.row && anchor.column > lead.column));
	    };
	    this.getRange = function() {
	        var anchor = this.anchor;
	        var lead = this.lead;
	
	        if (this.isEmpty())
	            return Range.fromPoints(lead, lead);
	
	        if (this.isBackwards()) {
	            return Range.fromPoints(lead, anchor);
	        }
	        else {
	            return Range.fromPoints(anchor, lead);
	        }
	    };
	    this.clearSelection = function() {
	        if (!this.$isEmpty) {
	            this.$isEmpty = true;
	            this._emit("changeSelection");
	        }
	    };
	    this.selectAll = function() {
	        var lastRow = this.doc.getLength() - 1;
	        this.setSelectionAnchor(0, 0);
	        this.moveCursorTo(lastRow, this.doc.getLine(lastRow).length);
	    };
	    this.setRange =
	    this.setSelectionRange = function(range, reverse) {
	        if (reverse) {
	            this.setSelectionAnchor(range.end.row, range.end.column);
	            this.selectTo(range.start.row, range.start.column);
	        } else {
	            this.setSelectionAnchor(range.start.row, range.start.column);
	            this.selectTo(range.end.row, range.end.column);
	        }
	        if (this.getRange().isEmpty())
	            this.$isEmpty = true;
	        this.$desiredColumn = null;
	    };
	
	    this.$moveSelection = function(mover) {
	        var lead = this.lead;
	        if (this.$isEmpty)
	            this.setSelectionAnchor(lead.row, lead.column);
	
	        mover.call(this);
	    };
	    this.selectTo = function(row, column) {
	        this.$moveSelection(function() {
	            this.moveCursorTo(row, column);
	        });
	    };
	    this.selectToPosition = function(pos) {
	        this.$moveSelection(function() {
	            this.moveCursorToPosition(pos);
	        });
	    };
	    this.moveTo = function(row, column) {
	        this.clearSelection();
	        this.moveCursorTo(row, column);
	    };
	    this.moveToPosition = function(pos) {
	        this.clearSelection();
	        this.moveCursorToPosition(pos);
	    };
	    this.selectUp = function() {
	        this.$moveSelection(this.moveCursorUp);
	    };
	    this.selectDown = function() {
	        this.$moveSelection(this.moveCursorDown);
	    };
	    this.selectRight = function() {
	        this.$moveSelection(this.moveCursorRight);
	    };
	    this.selectLeft = function() {
	        this.$moveSelection(this.moveCursorLeft);
	    };
	    this.selectLineStart = function() {
	        this.$moveSelection(this.moveCursorLineStart);
	    };
	    this.selectLineEnd = function() {
	        this.$moveSelection(this.moveCursorLineEnd);
	    };
	    this.selectFileEnd = function() {
	        this.$moveSelection(this.moveCursorFileEnd);
	    };
	    this.selectFileStart = function() {
	        this.$moveSelection(this.moveCursorFileStart);
	    };
	    this.selectWordRight = function() {
	        this.$moveSelection(this.moveCursorWordRight);
	    };
	    this.selectWordLeft = function() {
	        this.$moveSelection(this.moveCursorWordLeft);
	    };
	    this.getWordRange = function(row, column) {
	        if (typeof column == "undefined") {
	            var cursor = row || this.lead;
	            row = cursor.row;
	            column = cursor.column;
	        }
	        return this.session.getWordRange(row, column);
	    };
	    this.selectWord = function() {
	        this.setSelectionRange(this.getWordRange());
	    };
	    this.selectAWord = function() {
	        var cursor = this.getCursor();
	        var range = this.session.getAWordRange(cursor.row, cursor.column);
	        this.setSelectionRange(range);
	    };
	
	    this.getLineRange = function(row, excludeLastChar) {
	        var rowStart = typeof row == "number" ? row : this.lead.row;
	        var rowEnd;
	
	        var foldLine = this.session.getFoldLine(rowStart);
	        if (foldLine) {
	            rowStart = foldLine.start.row;
	            rowEnd = foldLine.end.row;
	        } else {
	            rowEnd = rowStart;
	        }
	        if (excludeLastChar === true)
	            return new Range(rowStart, 0, rowEnd, this.session.getLine(rowEnd).length);
	        else
	            return new Range(rowStart, 0, rowEnd + 1, 0);
	    };
	    this.selectLine = function() {
	        this.setSelectionRange(this.getLineRange());
	    };
	    this.moveCursorUp = function() {
	        this.moveCursorBy(-1, 0);
	    };
	    this.moveCursorDown = function() {
	        this.moveCursorBy(1, 0);
	    };
	    this.moveCursorLeft = function() {
	        var cursor = this.lead.getPosition(),
	            fold;
	
	        if (fold = this.session.getFoldAt(cursor.row, cursor.column, -1)) {
	            this.moveCursorTo(fold.start.row, fold.start.column);
	        } else if (cursor.column === 0) {
	            if (cursor.row > 0) {
	                this.moveCursorTo(cursor.row - 1, this.doc.getLine(cursor.row - 1).length);
	            }
	        }
	        else {
	            var tabSize = this.session.getTabSize();
	            if (this.session.isTabStop(cursor) && this.doc.getLine(cursor.row).slice(cursor.column-tabSize, cursor.column).split(" ").length-1 == tabSize)
	                this.moveCursorBy(0, -tabSize);
	            else
	                this.moveCursorBy(0, -1);
	        }
	    };
	    this.moveCursorRight = function() {
	        var cursor = this.lead.getPosition(),
	            fold;
	        if (fold = this.session.getFoldAt(cursor.row, cursor.column, 1)) {
	            this.moveCursorTo(fold.end.row, fold.end.column);
	        }
	        else if (this.lead.column == this.doc.getLine(this.lead.row).length) {
	            if (this.lead.row < this.doc.getLength() - 1) {
	                this.moveCursorTo(this.lead.row + 1, 0);
	            }
	        }
	        else {
	            var tabSize = this.session.getTabSize();
	            var cursor = this.lead;
	            if (this.session.isTabStop(cursor) && this.doc.getLine(cursor.row).slice(cursor.column, cursor.column+tabSize).split(" ").length-1 == tabSize)
	                this.moveCursorBy(0, tabSize);
	            else
	                this.moveCursorBy(0, 1);
	        }
	    };
	    this.moveCursorLineStart = function() {
	        var row = this.lead.row;
	        var column = this.lead.column;
	        var screenRow = this.session.documentToScreenRow(row, column);
	        var firstColumnPosition = this.session.screenToDocumentPosition(screenRow, 0);
	        var beforeCursor = this.session.getDisplayLine(
	            row, null, firstColumnPosition.row,
	            firstColumnPosition.column
	        );
	
	        var leadingSpace = beforeCursor.match(/^\s*/);
	        if (leadingSpace[0].length != column && !this.session.$useEmacsStyleLineStart)
	            firstColumnPosition.column += leadingSpace[0].length;
	        this.moveCursorToPosition(firstColumnPosition);
	    };
	    this.moveCursorLineEnd = function() {
	        var lead = this.lead;
	        var lineEnd = this.session.getDocumentLastRowColumnPosition(lead.row, lead.column);
	        if (this.lead.column == lineEnd.column) {
	            var line = this.session.getLine(lineEnd.row);
	            if (lineEnd.column == line.length) {
	                var textEnd = line.search(/\s+$/);
	                if (textEnd > 0)
	                    lineEnd.column = textEnd;
	            }
	        }
	
	        this.moveCursorTo(lineEnd.row, lineEnd.column);
	    };
	    this.moveCursorFileEnd = function() {
	        var row = this.doc.getLength() - 1;
	        var column = this.doc.getLine(row).length;
	        this.moveCursorTo(row, column);
	    };
	    this.moveCursorFileStart = function() {
	        this.moveCursorTo(0, 0);
	    };
	    this.moveCursorLongWordRight = function() {
	        var row = this.lead.row;
	        var column = this.lead.column;
	        var line = this.doc.getLine(row);
	        var rightOfCursor = line.substring(column);
	
	        var match;
	        this.session.nonTokenRe.lastIndex = 0;
	        this.session.tokenRe.lastIndex = 0;
	        var fold = this.session.getFoldAt(row, column, 1);
	        if (fold) {
	            this.moveCursorTo(fold.end.row, fold.end.column);
	            return;
	        }
	        if (match = this.session.nonTokenRe.exec(rightOfCursor)) {
	            column += this.session.nonTokenRe.lastIndex;
	            this.session.nonTokenRe.lastIndex = 0;
	            rightOfCursor = line.substring(column);
	        }
	        if (column >= line.length) {
	            this.moveCursorTo(row, line.length);
	            this.moveCursorRight();
	            if (row < this.doc.getLength() - 1)
	                this.moveCursorWordRight();
	            return;
	        }
	        if (match = this.session.tokenRe.exec(rightOfCursor)) {
	            column += this.session.tokenRe.lastIndex;
	            this.session.tokenRe.lastIndex = 0;
	        }
	
	        this.moveCursorTo(row, column);
	    };
	    this.moveCursorLongWordLeft = function() {
	        var row = this.lead.row;
	        var column = this.lead.column;
	        var fold;
	        if (fold = this.session.getFoldAt(row, column, -1)) {
	            this.moveCursorTo(fold.start.row, fold.start.column);
	            return;
	        }
	
	        var str = this.session.getFoldStringAt(row, column, -1);
	        if (str == null) {
	            str = this.doc.getLine(row).substring(0, column);
	        }
	
	        var leftOfCursor = lang.stringReverse(str);
	        var match;
	        this.session.nonTokenRe.lastIndex = 0;
	        this.session.tokenRe.lastIndex = 0;
	        if (match = this.session.nonTokenRe.exec(leftOfCursor)) {
	            column -= this.session.nonTokenRe.lastIndex;
	            leftOfCursor = leftOfCursor.slice(this.session.nonTokenRe.lastIndex);
	            this.session.nonTokenRe.lastIndex = 0;
	        }
	        if (column <= 0) {
	            this.moveCursorTo(row, 0);
	            this.moveCursorLeft();
	            if (row > 0)
	                this.moveCursorWordLeft();
	            return;
	        }
	        if (match = this.session.tokenRe.exec(leftOfCursor)) {
	            column -= this.session.tokenRe.lastIndex;
	            this.session.tokenRe.lastIndex = 0;
	        }
	
	        this.moveCursorTo(row, column);
	    };
	
	    this.$shortWordEndIndex = function(rightOfCursor) {
	        var match, index = 0, ch;
	        var whitespaceRe = /\s/;
	        var tokenRe = this.session.tokenRe;
	
	        tokenRe.lastIndex = 0;
	        if (match = this.session.tokenRe.exec(rightOfCursor)) {
	            index = this.session.tokenRe.lastIndex;
	        } else {
	            while ((ch = rightOfCursor[index]) && whitespaceRe.test(ch))
	                index ++;
	
	            if (index < 1) {
	                tokenRe.lastIndex = 0;
	                 while ((ch = rightOfCursor[index]) && !tokenRe.test(ch)) {
	                    tokenRe.lastIndex = 0;
	                    index ++;
	                    if (whitespaceRe.test(ch)) {
	                        if (index > 2) {
	                            index--;
	                            break;
	                        } else {
	                            while ((ch = rightOfCursor[index]) && whitespaceRe.test(ch))
	                                index ++;
	                            if (index > 2)
	                                break;
	                        }
	                    }
	                }
	            }
	        }
	        tokenRe.lastIndex = 0;
	
	        return index;
	    };
	
	    this.moveCursorShortWordRight = function() {
	        var row = this.lead.row;
	        var column = this.lead.column;
	        var line = this.doc.getLine(row);
	        var rightOfCursor = line.substring(column);
	
	        var fold = this.session.getFoldAt(row, column, 1);
	        if (fold)
	            return this.moveCursorTo(fold.end.row, fold.end.column);
	
	        if (column == line.length) {
	            var l = this.doc.getLength();
	            do {
	                row++;
	                rightOfCursor = this.doc.getLine(row);
	            } while (row < l && /^\s*$/.test(rightOfCursor));
	
	            if (!/^\s+/.test(rightOfCursor))
	                rightOfCursor = "";
	            column = 0;
	        }
	
	        var index = this.$shortWordEndIndex(rightOfCursor);
	
	        this.moveCursorTo(row, column + index);
	    };
	
	    this.moveCursorShortWordLeft = function() {
	        var row = this.lead.row;
	        var column = this.lead.column;
	
	        var fold;
	        if (fold = this.session.getFoldAt(row, column, -1))
	            return this.moveCursorTo(fold.start.row, fold.start.column);
	
	        var line = this.session.getLine(row).substring(0, column);
	        if (column === 0) {
	            do {
	                row--;
	                line = this.doc.getLine(row);
	            } while (row > 0 && /^\s*$/.test(line));
	
	            column = line.length;
	            if (!/\s+$/.test(line))
	                line = "";
	        }
	
	        var leftOfCursor = lang.stringReverse(line);
	        var index = this.$shortWordEndIndex(leftOfCursor);
	
	        return this.moveCursorTo(row, column - index);
	    };
	
	    this.moveCursorWordRight = function() {
	        if (this.session.$selectLongWords)
	            this.moveCursorLongWordRight();
	        else
	            this.moveCursorShortWordRight();
	    };
	
	    this.moveCursorWordLeft = function() {
	        if (this.session.$selectLongWords)
	            this.moveCursorLongWordLeft();
	        else
	            this.moveCursorShortWordLeft();
	    };
	    this.moveCursorBy = function(rows, chars) {
	        var screenPos = this.session.documentToScreenPosition(
	            this.lead.row,
	            this.lead.column
	        );
	
	        if (chars === 0) {
	            if (this.$desiredColumn)
	                screenPos.column = this.$desiredColumn;
	            else
	                this.$desiredColumn = screenPos.column;
	        }
	
	        var docPos = this.session.screenToDocumentPosition(screenPos.row + rows, screenPos.column);
	        
	        if (rows !== 0 && chars === 0 && docPos.row === this.lead.row && docPos.column === this.lead.column) {
	            if (this.session.lineWidgets && this.session.lineWidgets[docPos.row]) {
	                if (docPos.row > 0 || rows > 0)
	                    docPos.row++;
	            }
	        }
	        this.moveCursorTo(docPos.row, docPos.column + chars, chars === 0);
	    };
	    this.moveCursorToPosition = function(position) {
	        this.moveCursorTo(position.row, position.column);
	    };
	    this.moveCursorTo = function(row, column, keepDesiredColumn) {
	        var fold = this.session.getFoldAt(row, column, 1);
	        if (fold) {
	            row = fold.start.row;
	            column = fold.start.column;
	        }
	
	        this.$keepDesiredColumnOnChange = true;
	        this.lead.setPosition(row, column);
	        this.$keepDesiredColumnOnChange = false;
	
	        if (!keepDesiredColumn)
	            this.$desiredColumn = null;
	    };
	    this.moveCursorToScreen = function(row, column, keepDesiredColumn) {
	        var pos = this.session.screenToDocumentPosition(row, column);
	        this.moveCursorTo(pos.row, pos.column, keepDesiredColumn);
	    };
	    this.detach = function() {
	        this.lead.detach();
	        this.anchor.detach();
	        this.session = this.doc = null;
	    };
	
	    this.fromOrientedRange = function(range) {
	        this.setSelectionRange(range, range.cursor == range.start);
	        this.$desiredColumn = range.desiredColumn || this.$desiredColumn;
	    };
	
	    this.toOrientedRange = function(range) {
	        var r = this.getRange();
	        if (range) {
	            range.start.column = r.start.column;
	            range.start.row = r.start.row;
	            range.end.column = r.end.column;
	            range.end.row = r.end.row;
	        } else {
	            range = r;
	        }
	
	        range.cursor = this.isBackwards() ? range.start : range.end;
	        range.desiredColumn = this.$desiredColumn;
	        return range;
	    };
	    this.getRangeOfMovements = function(func) {
	        var start = this.getCursor();
	        try {
	            func(this);
	            var end = this.getCursor();
	            return Range.fromPoints(start,end);
	        } catch(e) {
	            return Range.fromPoints(start,start);
	        } finally {
	            this.moveCursorToPosition(start);
	        }
	    };
	
	    this.toJSON = function() {
	        if (this.rangeCount) {
	            var data = this.ranges.map(function(r) {
	                var r1 = r.clone();
	                r1.isBackwards = r.cursor == r.start;
	                return r1;
	            });
	        } else {
	            var data = this.getRange();
	            data.isBackwards = this.isBackwards();
	        }
	        return data;
	    };
	
	    this.fromJSON = function(data) {
	        if (data.start == undefined) {
	            if (this.rangeList) {
	                this.toSingleRange(data[0]);
	                for (var i = data.length; i--; ) {
	                    var r = Range.fromPoints(data[i].start, data[i].end);
	                    if (data[i].isBackwards)
	                        r.cursor = r.start;
	                    this.addRange(r, true);
	                }
	                return;
	            } else
	                data = data[0];
	        }
	        if (this.rangeList)
	            this.toSingleRange(data);
	        this.setSelectionRange(data, data.isBackwards);
	    };
	
	    this.isEqual = function(data) {
	        if ((data.length || this.rangeCount) && data.length != this.rangeCount)
	            return false;
	        if (!data.length || !this.ranges)
	            return this.getRange().isEqual(data);
	
	        for (var i = this.ranges.length; i--; ) {
	            if (!this.ranges[i].isEqual(data[i]))
	                return false;
	        }
	        return true;
	    };
	
	}).call(Selection.prototype);
	
	exports.Selection = Selection;
	});
	
	ace.define("ace/tokenizer",["require","exports","module","ace/config"], function(acequire, exports, module) {
	"use strict";
	
	var config = acequire("./config");
	var MAX_TOKEN_COUNT = 2000;
	var Tokenizer = function(rules) {
	    this.states = rules;
	
	    this.regExps = {};
	    this.matchMappings = {};
	    for (var key in this.states) {
	        var state = this.states[key];
	        var ruleRegExps = [];
	        var matchTotal = 0;
	        var mapping = this.matchMappings[key] = {defaultToken: "text"};
	        var flag = "g";
	
	        var splitterRurles = [];
	        for (var i = 0; i < state.length; i++) {
	            var rule = state[i];
	            if (rule.defaultToken)
	                mapping.defaultToken = rule.defaultToken;
	            if (rule.caseInsensitive)
	                flag = "gi";
	            if (rule.regex == null)
	                continue;
	
	            if (rule.regex instanceof RegExp)
	                rule.regex = rule.regex.toString().slice(1, -1);
	            var adjustedregex = rule.regex;
	            var matchcount = new RegExp("(?:(" + adjustedregex + ")|(.))").exec("a").length - 2;
	            if (Array.isArray(rule.token)) {
	                if (rule.token.length == 1 || matchcount == 1) {
	                    rule.token = rule.token[0];
	                } else if (matchcount - 1 != rule.token.length) {
	                    this.reportError("number of classes and regexp groups doesn't match", { 
	                        rule: rule,
	                        groupCount: matchcount - 1
	                    });
	                    rule.token = rule.token[0];
	                } else {
	                    rule.tokenArray = rule.token;
	                    rule.token = null;
	                    rule.onMatch = this.$arrayTokens;
	                }
	            } else if (typeof rule.token == "function" && !rule.onMatch) {
	                if (matchcount > 1)
	                    rule.onMatch = this.$applyToken;
	                else
	                    rule.onMatch = rule.token;
	            }
	
	            if (matchcount > 1) {
	                if (/\\\d/.test(rule.regex)) {
	                    adjustedregex = rule.regex.replace(/\\([0-9]+)/g, function(match, digit) {
	                        return "\\" + (parseInt(digit, 10) + matchTotal + 1);
	                    });
	                } else {
	                    matchcount = 1;
	                    adjustedregex = this.removeCapturingGroups(rule.regex);
	                }
	                if (!rule.splitRegex && typeof rule.token != "string")
	                    splitterRurles.push(rule); // flag will be known only at the very end
	            }
	
	            mapping[matchTotal] = i;
	            matchTotal += matchcount;
	
	            ruleRegExps.push(adjustedregex);
	            if (!rule.onMatch)
	                rule.onMatch = null;
	        }
	        
	        if (!ruleRegExps.length) {
	            mapping[0] = 0;
	            ruleRegExps.push("$");
	        }
	        
	        splitterRurles.forEach(function(rule) {
	            rule.splitRegex = this.createSplitterRegexp(rule.regex, flag);
	        }, this);
	
	        this.regExps[key] = new RegExp("(" + ruleRegExps.join(")|(") + ")|($)", flag);
	    }
	};
	
	(function() {
	    this.$setMaxTokenCount = function(m) {
	        MAX_TOKEN_COUNT = m | 0;
	    };
	    
	    this.$applyToken = function(str) {
	        var values = this.splitRegex.exec(str).slice(1);
	        var types = this.token.apply(this, values);
	        if (typeof types === "string")
	            return [{type: types, value: str}];
	
	        var tokens = [];
	        for (var i = 0, l = types.length; i < l; i++) {
	            if (values[i])
	                tokens[tokens.length] = {
	                    type: types[i],
	                    value: values[i]
	                };
	        }
	        return tokens;
	    };
	
	    this.$arrayTokens = function(str) {
	        if (!str)
	            return [];
	        var values = this.splitRegex.exec(str);
	        if (!values)
	            return "text";
	        var tokens = [];
	        var types = this.tokenArray;
	        for (var i = 0, l = types.length; i < l; i++) {
	            if (values[i + 1])
	                tokens[tokens.length] = {
	                    type: types[i],
	                    value: values[i + 1]
	                };
	        }
	        return tokens;
	    };
	
	    this.removeCapturingGroups = function(src) {
	        var r = src.replace(
	            /\[(?:\\.|[^\]])*?\]|\\.|\(\?[:=!]|(\()/g,
	            function(x, y) {return y ? "(?:" : x;}
	        );
	        return r;
	    };
	
	    this.createSplitterRegexp = function(src, flag) {
	        if (src.indexOf("(?=") != -1) {
	            var stack = 0;
	            var inChClass = false;
	            var lastCapture = {};
	            src.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function(
	                m, esc, parenOpen, parenClose, square, index
	            ) {
	                if (inChClass) {
	                    inChClass = square != "]";
	                } else if (square) {
	                    inChClass = true;
	                } else if (parenClose) {
	                    if (stack == lastCapture.stack) {
	                        lastCapture.end = index+1;
	                        lastCapture.stack = -1;
	                    }
	                    stack--;
	                } else if (parenOpen) {
	                    stack++;
	                    if (parenOpen.length != 1) {
	                        lastCapture.stack = stack
	                        lastCapture.start = index;
	                    }
	                }
	                return m;
	            });
	
	            if (lastCapture.end != null && /^\)*$/.test(src.substr(lastCapture.end)))
	                src = src.substring(0, lastCapture.start) + src.substr(lastCapture.end);
	        }
	        if (src.charAt(0) != "^") src = "^" + src;
	        if (src.charAt(src.length - 1) != "$") src += "$";
	        
	        return new RegExp(src, (flag||"").replace("g", ""));
	    };
	    this.getLineTokens = function(line, startState) {
	        if (startState && typeof startState != "string") {
	            var stack = startState.slice(0);
	            startState = stack[0];
	            if (startState === "#tmp") {
	                stack.shift()
	                startState = stack.shift()
	            }
	        } else
	            var stack = [];
	
	        var currentState = startState || "start";
	        var state = this.states[currentState];
	        if (!state) {
	            currentState = "start";
	            state = this.states[currentState];
	        }
	        var mapping = this.matchMappings[currentState];
	        var re = this.regExps[currentState];
	        re.lastIndex = 0;
	
	        var match, tokens = [];
	        var lastIndex = 0;
	        var matchAttempts = 0;
	
	        var token = {type: null, value: ""};
	
	        while (match = re.exec(line)) {
	            var type = mapping.defaultToken;
	            var rule = null;
	            var value = match[0];
	            var index = re.lastIndex;
	
	            if (index - value.length > lastIndex) {
	                var skipped = line.substring(lastIndex, index - value.length);
	                if (token.type == type) {
	                    token.value += skipped;
	                } else {
	                    if (token.type)
	                        tokens.push(token);
	                    token = {type: type, value: skipped};
	                }
	            }
	
	            for (var i = 0; i < match.length-2; i++) {
	                if (match[i + 1] === undefined)
	                    continue;
	
	                rule = state[mapping[i]];
	
	                if (rule.onMatch)
	                    type = rule.onMatch(value, currentState, stack);
	                else
	                    type = rule.token;
	
	                if (rule.next) {
	                    if (typeof rule.next == "string") {
	                        currentState = rule.next;
	                    } else {
	                        currentState = rule.next(currentState, stack);
	                    }
	                    
	                    state = this.states[currentState];
	                    if (!state) {
	                        this.reportError("state doesn't exist", currentState);
	                        currentState = "start";
	                        state = this.states[currentState];
	                    }
	                    mapping = this.matchMappings[currentState];
	                    lastIndex = index;
	                    re = this.regExps[currentState];
	                    re.lastIndex = index;
	                }
	                break;
	            }
	
	            if (value) {
	                if (typeof type === "string") {
	                    if ((!rule || rule.merge !== false) && token.type === type) {
	                        token.value += value;
	                    } else {
	                        if (token.type)
	                            tokens.push(token);
	                        token = {type: type, value: value};
	                    }
	                } else if (type) {
	                    if (token.type)
	                        tokens.push(token);
	                    token = {type: null, value: ""};
	                    for (var i = 0; i < type.length; i++)
	                        tokens.push(type[i]);
	                }
	            }
	
	            if (lastIndex == line.length)
	                break;
	
	            lastIndex = index;
	
	            if (matchAttempts++ > MAX_TOKEN_COUNT) {
	                if (matchAttempts > 2 * line.length) {
	                    this.reportError("infinite loop with in ace tokenizer", {
	                        startState: startState,
	                        line: line
	                    });
	                }
	                while (lastIndex < line.length) {
	                    if (token.type)
	                        tokens.push(token);
	                    token = {
	                        value: line.substring(lastIndex, lastIndex += 2000),
	                        type: "overflow"
	                    };
	                }
	                currentState = "start";
	                stack = [];
	                break;
	            }
	        }
	
	        if (token.type)
	            tokens.push(token);
	        
	        if (stack.length > 1) {
	            if (stack[0] !== currentState)
	                stack.unshift("#tmp", currentState);
	        }
	        return {
	            tokens : tokens,
	            state : stack.length ? stack : currentState
	        };
	    };
	    
	    this.reportError = config.reportError;
	    
	}).call(Tokenizer.prototype);
	
	exports.Tokenizer = Tokenizer;
	});
	
	ace.define("ace/mode/text_highlight_rules",["require","exports","module","ace/lib/lang"], function(acequire, exports, module) {
	"use strict";
	
	var lang = acequire("../lib/lang");
	
	var TextHighlightRules = function() {
	
	    this.$rules = {
	        "start" : [{
	            token : "empty_line",
	            regex : '^$'
	        }, {
	            defaultToken : "text"
	        }]
	    };
	};
	
	(function() {
	
	    this.addRules = function(rules, prefix) {
	        if (!prefix) {
	            for (var key in rules)
	                this.$rules[key] = rules[key];
	            return;
	        }
	        for (var key in rules) {
	            var state = rules[key];
	            for (var i = 0; i < state.length; i++) {
	                var rule = state[i];
	                if (rule.next || rule.onMatch) {
	                    if (typeof rule.next == "string") {
	                        if (rule.next.indexOf(prefix) !== 0)
	                            rule.next = prefix + rule.next;
	                    }
	                    if (rule.nextState && rule.nextState.indexOf(prefix) !== 0)
	                        rule.nextState = prefix + rule.nextState;
	                }
	            }
	            this.$rules[prefix + key] = state;
	        }
	    };
	
	    this.getRules = function() {
	        return this.$rules;
	    };
	
	    this.embedRules = function (HighlightRules, prefix, escapeRules, states, append) {
	        var embedRules = typeof HighlightRules == "function"
	            ? new HighlightRules().getRules()
	            : HighlightRules;
	        if (states) {
	            for (var i = 0; i < states.length; i++)
	                states[i] = prefix + states[i];
	        } else {
	            states = [];
	            for (var key in embedRules)
	                states.push(prefix + key);
	        }
	
	        this.addRules(embedRules, prefix);
	
	        if (escapeRules) {
	            var addRules = Array.prototype[append ? "push" : "unshift"];
	            for (var i = 0; i < states.length; i++)
	                addRules.apply(this.$rules[states[i]], lang.deepCopy(escapeRules));
	        }
	
	        if (!this.$embeds)
	            this.$embeds = [];
	        this.$embeds.push(prefix);
	    };
	
	    this.getEmbeds = function() {
	        return this.$embeds;
	    };
	
	    var pushState = function(currentState, stack) {
	        if (currentState != "start" || stack.length)
	            stack.unshift(this.nextState, currentState);
	        return this.nextState;
	    };
	    var popState = function(currentState, stack) {
	        stack.shift();
	        return stack.shift() || "start";
	    };
	
	    this.normalizeRules = function() {
	        var id = 0;
	        var rules = this.$rules;
	        function processState(key) {
	            var state = rules[key];
	            state.processed = true;
	            for (var i = 0; i < state.length; i++) {
	                var rule = state[i];
	                var toInsert = null;
	                if (Array.isArray(rule)) {
	                    toInsert = rule;
	                    rule = {};
	                }
	                if (!rule.regex && rule.start) {
	                    rule.regex = rule.start;
	                    if (!rule.next)
	                        rule.next = [];
	                    rule.next.push({
	                        defaultToken: rule.token
	                    }, {
	                        token: rule.token + ".end",
	                        regex: rule.end || rule.start,
	                        next: "pop"
	                    });
	                    rule.token = rule.token + ".start";
	                    rule.push = true;
	                }
	                var next = rule.next || rule.push;
	                if (next && Array.isArray(next)) {
	                    var stateName = rule.stateName;
	                    if (!stateName)  {
	                        stateName = rule.token;
	                        if (typeof stateName != "string")
	                            stateName = stateName[0] || "";
	                        if (rules[stateName])
	                            stateName += id++;
	                    }
	                    rules[stateName] = next;
	                    rule.next = stateName;
	                    processState(stateName);
	                } else if (next == "pop") {
	                    rule.next = popState;
	                }
	
	                if (rule.push) {
	                    rule.nextState = rule.next || rule.push;
	                    rule.next = pushState;
	                    delete rule.push;
	                }
	
	                if (rule.rules) {
	                    for (var r in rule.rules) {
	                        if (rules[r]) {
	                            if (rules[r].push)
	                                rules[r].push.apply(rules[r], rule.rules[r]);
	                        } else {
	                            rules[r] = rule.rules[r];
	                        }
	                    }
	                }
	                var includeName = typeof rule == "string"
	                    ? rule
	                    : typeof rule.include == "string"
	                    ? rule.include
	                    : "";
	                if (includeName) {
	                    toInsert = rules[includeName];
	                }
	
	                if (toInsert) {
	                    var args = [i, 1].concat(toInsert);
	                    if (rule.noEscape)
	                        args = args.filter(function(x) {return !x.next;});
	                    state.splice.apply(state, args);
	                    i--;
	                }
	                
	                if (rule.keywordMap) {
	                    rule.token = this.createKeywordMapper(
	                        rule.keywordMap, rule.defaultToken || "text", rule.caseInsensitive
	                    );
	                    delete rule.defaultToken;
	                }
	            }
	        }
	        Object.keys(rules).forEach(processState, this);
	    };
	
	    this.createKeywordMapper = function(map, defaultToken, ignoreCase, splitChar) {
	        var keywords = Object.create(null);
	        Object.keys(map).forEach(function(className) {
	            var a = map[className];
	            if (ignoreCase)
	                a = a.toLowerCase();
	            var list = a.split(splitChar || "|");
	            for (var i = list.length; i--; )
	                keywords[list[i]] = className;
	        });
	        if (Object.getPrototypeOf(keywords)) {
	            keywords.__proto__ = null;
	        }
	        this.$keywordList = Object.keys(keywords);
	        map = null;
	        return ignoreCase
	            ? function(value) {return keywords[value.toLowerCase()] || defaultToken }
	            : function(value) {return keywords[value] || defaultToken };
	    };
	
	    this.getKeywords = function() {
	        return this.$keywords;
	    };
	
	}).call(TextHighlightRules.prototype);
	
	exports.TextHighlightRules = TextHighlightRules;
	});
	
	ace.define("ace/mode/behaviour",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	var Behaviour = function() {
	   this.$behaviours = {};
	};
	
	(function () {
	
	    this.add = function (name, action, callback) {
	        switch (undefined) {
	          case this.$behaviours:
	              this.$behaviours = {};
	          case this.$behaviours[name]:
	              this.$behaviours[name] = {};
	        }
	        this.$behaviours[name][action] = callback;
	    }
	    
	    this.addBehaviours = function (behaviours) {
	        for (var key in behaviours) {
	            for (var action in behaviours[key]) {
	                this.add(key, action, behaviours[key][action]);
	            }
	        }
	    }
	    
	    this.remove = function (name) {
	        if (this.$behaviours && this.$behaviours[name]) {
	            delete this.$behaviours[name];
	        }
	    }
	    
	    this.inherit = function (mode, filter) {
	        if (typeof mode === "function") {
	            var behaviours = new mode().getBehaviours(filter);
	        } else {
	            var behaviours = mode.getBehaviours(filter);
	        }
	        this.addBehaviours(behaviours);
	    }
	    
	    this.getBehaviours = function (filter) {
	        if (!filter) {
	            return this.$behaviours;
	        } else {
	            var ret = {}
	            for (var i = 0; i < filter.length; i++) {
	                if (this.$behaviours[filter[i]]) {
	                    ret[filter[i]] = this.$behaviours[filter[i]];
	                }
	            }
	            return ret;
	        }
	    }
	
	}).call(Behaviour.prototype);
	
	exports.Behaviour = Behaviour;
	});
	
	ace.define("ace/token_iterator",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	var TokenIterator = function(session, initialRow, initialColumn) {
	    this.$session = session;
	    this.$row = initialRow;
	    this.$rowTokens = session.getTokens(initialRow);
	
	    var token = session.getTokenAt(initialRow, initialColumn);
	    this.$tokenIndex = token ? token.index : -1;
	};
	
	(function() { 
	    this.stepBackward = function() {
	        this.$tokenIndex -= 1;
	        
	        while (this.$tokenIndex < 0) {
	            this.$row -= 1;
	            if (this.$row < 0) {
	                this.$row = 0;
	                return null;
	            }
	                
	            this.$rowTokens = this.$session.getTokens(this.$row);
	            this.$tokenIndex = this.$rowTokens.length - 1;
	        }
	            
	        return this.$rowTokens[this.$tokenIndex];
	    };   
	    this.stepForward = function() {
	        this.$tokenIndex += 1;
	        var rowCount;
	        while (this.$tokenIndex >= this.$rowTokens.length) {
	            this.$row += 1;
	            if (!rowCount)
	                rowCount = this.$session.getLength();
	            if (this.$row >= rowCount) {
	                this.$row = rowCount - 1;
	                return null;
	            }
	
	            this.$rowTokens = this.$session.getTokens(this.$row);
	            this.$tokenIndex = 0;
	        }
	            
	        return this.$rowTokens[this.$tokenIndex];
	    };      
	    this.getCurrentToken = function () {
	        return this.$rowTokens[this.$tokenIndex];
	    };      
	    this.getCurrentTokenRow = function () {
	        return this.$row;
	    };     
	    this.getCurrentTokenColumn = function() {
	        var rowTokens = this.$rowTokens;
	        var tokenIndex = this.$tokenIndex;
	        var column = rowTokens[tokenIndex].start;
	        if (column !== undefined)
	            return column;
	            
	        column = 0;
	        while (tokenIndex > 0) {
	            tokenIndex -= 1;
	            column += rowTokens[tokenIndex].value.length;
	        }
	        
	        return column;  
	    };
	    this.getCurrentTokenPosition = function() {
	        return {row: this.$row, column: this.getCurrentTokenColumn()};
	    };
	            
	}).call(TokenIterator.prototype);
	
	exports.TokenIterator = TokenIterator;
	});
	
	ace.define("ace/mode/behaviour/cstyle",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Behaviour = acequire("../behaviour").Behaviour;
	var TokenIterator = acequire("../../token_iterator").TokenIterator;
	var lang = acequire("../../lib/lang");
	
	var SAFE_INSERT_IN_TOKENS =
	    ["text", "paren.rparen", "punctuation.operator"];
	var SAFE_INSERT_BEFORE_TOKENS =
	    ["text", "paren.rparen", "punctuation.operator", "comment"];
	
	var context;
	var contextCache = {};
	var initContext = function(editor) {
	    var id = -1;
	    if (editor.multiSelect) {
	        id = editor.selection.index;
	        if (contextCache.rangeCount != editor.multiSelect.rangeCount)
	            contextCache = {rangeCount: editor.multiSelect.rangeCount};
	    }
	    if (contextCache[id])
	        return context = contextCache[id];
	    context = contextCache[id] = {
	        autoInsertedBrackets: 0,
	        autoInsertedRow: -1,
	        autoInsertedLineEnd: "",
	        maybeInsertedBrackets: 0,
	        maybeInsertedRow: -1,
	        maybeInsertedLineStart: "",
	        maybeInsertedLineEnd: ""
	    };
	};
	
	var getWrapped = function(selection, selected, opening, closing) {
	    var rowDiff = selection.end.row - selection.start.row;
	    return {
	        text: opening + selected + closing,
	        selection: [
	                0,
	                selection.start.column + 1,
	                rowDiff,
	                selection.end.column + (rowDiff ? 0 : 1)
	            ]
	    };
	};
	
	var CstyleBehaviour = function() {
	    this.add("braces", "insertion", function(state, action, editor, session, text) {
	        var cursor = editor.getCursorPosition();
	        var line = session.doc.getLine(cursor.row);
	        if (text == '{') {
	            initContext(editor);
	            var selection = editor.getSelectionRange();
	            var selected = session.doc.getTextRange(selection);
	            if (selected !== "" && selected !== "{" && editor.getWrapBehavioursEnabled()) {
	                return getWrapped(selection, selected, '{', '}');
	            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
	                if (/[\]\}\)]/.test(line[cursor.column]) || editor.inMultiSelectMode) {
	                    CstyleBehaviour.recordAutoInsert(editor, session, "}");
	                    return {
	                        text: '{}',
	                        selection: [1, 1]
	                    };
	                } else {
	                    CstyleBehaviour.recordMaybeInsert(editor, session, "{");
	                    return {
	                        text: '{',
	                        selection: [1, 1]
	                    };
	                }
	            }
	        } else if (text == '}') {
	            initContext(editor);
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar == '}') {
	                var matching = session.$findOpeningBracket('}', {column: cursor.column + 1, row: cursor.row});
	                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
	                    CstyleBehaviour.popAutoInsertedClosing();
	                    return {
	                        text: '',
	                        selection: [1, 1]
	                    };
	                }
	            }
	        } else if (text == "\n" || text == "\r\n") {
	            initContext(editor);
	            var closing = "";
	            if (CstyleBehaviour.isMaybeInsertedClosing(cursor, line)) {
	                closing = lang.stringRepeat("}", context.maybeInsertedBrackets);
	                CstyleBehaviour.clearMaybeInsertedClosing();
	            }
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar === '}') {
	                var openBracePos = session.findMatchingBracket({row: cursor.row, column: cursor.column+1}, '}');
	                if (!openBracePos)
	                     return null;
	                var next_indent = this.$getIndent(session.getLine(openBracePos.row));
	            } else if (closing) {
	                var next_indent = this.$getIndent(line);
	            } else {
	                CstyleBehaviour.clearMaybeInsertedClosing();
	                return;
	            }
	            var indent = next_indent + session.getTabString();
	
	            return {
	                text: '\n' + indent + '\n' + next_indent + closing,
	                selection: [1, indent.length, 1, indent.length]
	            };
	        } else {
	            CstyleBehaviour.clearMaybeInsertedClosing();
	        }
	    });
	
	    this.add("braces", "deletion", function(state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && selected == '{') {
	            initContext(editor);
	            var line = session.doc.getLine(range.start.row);
	            var rightChar = line.substring(range.end.column, range.end.column + 1);
	            if (rightChar == '}') {
	                range.end.column++;
	                return range;
	            } else {
	                context.maybeInsertedBrackets--;
	            }
	        }
	    });
	
	    this.add("parens", "insertion", function(state, action, editor, session, text) {
	        if (text == '(') {
	            initContext(editor);
	            var selection = editor.getSelectionRange();
	            var selected = session.doc.getTextRange(selection);
	            if (selected !== "" && editor.getWrapBehavioursEnabled()) {
	                return getWrapped(selection, selected, '(', ')');
	            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
	                CstyleBehaviour.recordAutoInsert(editor, session, ")");
	                return {
	                    text: '()',
	                    selection: [1, 1]
	                };
	            }
	        } else if (text == ')') {
	            initContext(editor);
	            var cursor = editor.getCursorPosition();
	            var line = session.doc.getLine(cursor.row);
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar == ')') {
	                var matching = session.$findOpeningBracket(')', {column: cursor.column + 1, row: cursor.row});
	                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
	                    CstyleBehaviour.popAutoInsertedClosing();
	                    return {
	                        text: '',
	                        selection: [1, 1]
	                    };
	                }
	            }
	        }
	    });
	
	    this.add("parens", "deletion", function(state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && selected == '(') {
	            initContext(editor);
	            var line = session.doc.getLine(range.start.row);
	            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
	            if (rightChar == ')') {
	                range.end.column++;
	                return range;
	            }
	        }
	    });
	
	    this.add("brackets", "insertion", function(state, action, editor, session, text) {
	        if (text == '[') {
	            initContext(editor);
	            var selection = editor.getSelectionRange();
	            var selected = session.doc.getTextRange(selection);
	            if (selected !== "" && editor.getWrapBehavioursEnabled()) {
	                return getWrapped(selection, selected, '[', ']');
	            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
	                CstyleBehaviour.recordAutoInsert(editor, session, "]");
	                return {
	                    text: '[]',
	                    selection: [1, 1]
	                };
	            }
	        } else if (text == ']') {
	            initContext(editor);
	            var cursor = editor.getCursorPosition();
	            var line = session.doc.getLine(cursor.row);
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar == ']') {
	                var matching = session.$findOpeningBracket(']', {column: cursor.column + 1, row: cursor.row});
	                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
	                    CstyleBehaviour.popAutoInsertedClosing();
	                    return {
	                        text: '',
	                        selection: [1, 1]
	                    };
	                }
	            }
	        }
	    });
	
	    this.add("brackets", "deletion", function(state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && selected == '[') {
	            initContext(editor);
	            var line = session.doc.getLine(range.start.row);
	            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
	            if (rightChar == ']') {
	                range.end.column++;
	                return range;
	            }
	        }
	    });
	
	    this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
	        if (text == '"' || text == "'") {
	            if (this.lineCommentStart && this.lineCommentStart.indexOf(text) != -1)
	                return;
	            initContext(editor);
	            var quote = text;
	            var selection = editor.getSelectionRange();
	            var selected = session.doc.getTextRange(selection);
	            if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) {
	                return getWrapped(selection, selected, quote, quote);
	            } else if (!selected) {
	                var cursor = editor.getCursorPosition();
	                var line = session.doc.getLine(cursor.row);
	                var leftChar = line.substring(cursor.column-1, cursor.column);
	                var rightChar = line.substring(cursor.column, cursor.column + 1);
	
	                var token = session.getTokenAt(cursor.row, cursor.column);
	                var rightToken = session.getTokenAt(cursor.row, cursor.column + 1);
	                if (leftChar == "\\" && token && /escape/.test(token.type))
	                    return null;
	
	                var stringBefore = token && /string|escape/.test(token.type);
	                var stringAfter = !rightToken || /string|escape/.test(rightToken.type);
	
	                var pair;
	                if (rightChar == quote) {
	                    pair = stringBefore !== stringAfter;
	                    if (pair && /string\.end/.test(rightToken.type))
	                        pair = false;
	                } else {
	                    if (stringBefore && !stringAfter)
	                        return null; // wrap string with different quote
	                    if (stringBefore && stringAfter)
	                        return null; // do not pair quotes inside strings
	                    var wordRe = session.$mode.tokenRe;
	                    wordRe.lastIndex = 0;
	                    var isWordBefore = wordRe.test(leftChar);
	                    wordRe.lastIndex = 0;
	                    var isWordAfter = wordRe.test(leftChar);
	                    if (isWordBefore || isWordAfter)
	                        return null; // before or after alphanumeric
	                    if (rightChar && !/[\s;,.})\]\\]/.test(rightChar))
	                        return null; // there is rightChar and it isn't closing
	                    pair = true;
	                }
	                return {
	                    text: pair ? quote + quote : "",
	                    selection: [1,1]
	                };
	            }
	        }
	    });
	
	    this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
	            initContext(editor);
	            var line = session.doc.getLine(range.start.row);
	            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
	            if (rightChar == selected) {
	                range.end.column++;
	                return range;
	            }
	        }
	    });
	
	};
	
	
	CstyleBehaviour.isSaneInsertion = function(editor, session) {
	    var cursor = editor.getCursorPosition();
	    var iterator = new TokenIterator(session, cursor.row, cursor.column);
	    if (!this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) {
	        var iterator2 = new TokenIterator(session, cursor.row, cursor.column + 1);
	        if (!this.$matchTokenType(iterator2.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS))
	            return false;
	    }
	    iterator.stepForward();
	    return iterator.getCurrentTokenRow() !== cursor.row ||
	        this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_BEFORE_TOKENS);
	};
	
	CstyleBehaviour.$matchTokenType = function(token, types) {
	    return types.indexOf(token.type || token) > -1;
	};
	
	CstyleBehaviour.recordAutoInsert = function(editor, session, bracket) {
	    var cursor = editor.getCursorPosition();
	    var line = session.doc.getLine(cursor.row);
	    if (!this.isAutoInsertedClosing(cursor, line, context.autoInsertedLineEnd[0]))
	        context.autoInsertedBrackets = 0;
	    context.autoInsertedRow = cursor.row;
	    context.autoInsertedLineEnd = bracket + line.substr(cursor.column);
	    context.autoInsertedBrackets++;
	};
	
	CstyleBehaviour.recordMaybeInsert = function(editor, session, bracket) {
	    var cursor = editor.getCursorPosition();
	    var line = session.doc.getLine(cursor.row);
	    if (!this.isMaybeInsertedClosing(cursor, line))
	        context.maybeInsertedBrackets = 0;
	    context.maybeInsertedRow = cursor.row;
	    context.maybeInsertedLineStart = line.substr(0, cursor.column) + bracket;
	    context.maybeInsertedLineEnd = line.substr(cursor.column);
	    context.maybeInsertedBrackets++;
	};
	
	CstyleBehaviour.isAutoInsertedClosing = function(cursor, line, bracket) {
	    return context.autoInsertedBrackets > 0 &&
	        cursor.row === context.autoInsertedRow &&
	        bracket === context.autoInsertedLineEnd[0] &&
	        line.substr(cursor.column) === context.autoInsertedLineEnd;
	};
	
	CstyleBehaviour.isMaybeInsertedClosing = function(cursor, line) {
	    return context.maybeInsertedBrackets > 0 &&
	        cursor.row === context.maybeInsertedRow &&
	        line.substr(cursor.column) === context.maybeInsertedLineEnd &&
	        line.substr(0, cursor.column) == context.maybeInsertedLineStart;
	};
	
	CstyleBehaviour.popAutoInsertedClosing = function() {
	    context.autoInsertedLineEnd = context.autoInsertedLineEnd.substr(1);
	    context.autoInsertedBrackets--;
	};
	
	CstyleBehaviour.clearMaybeInsertedClosing = function() {
	    if (context) {
	        context.maybeInsertedBrackets = 0;
	        context.maybeInsertedRow = -1;
	    }
	};
	
	
	
	oop.inherits(CstyleBehaviour, Behaviour);
	
	exports.CstyleBehaviour = CstyleBehaviour;
	});
	
	ace.define("ace/unicode",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	exports.packages = {};
	
	addUnicodePackage({
	    L:  "0041-005A0061-007A00AA00B500BA00C0-00D600D8-00F600F8-02C102C6-02D102E0-02E402EC02EE0370-037403760377037A-037D03860388-038A038C038E-03A103A3-03F503F7-0481048A-05250531-055605590561-058705D0-05EA05F0-05F20621-064A066E066F0671-06D306D506E506E606EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA07F407F507FA0800-0815081A082408280904-0939093D09500958-0961097109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E460E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EC60EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10A0-10C510D0-10FA10FC1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317D717DC1820-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541AA71B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C7D1CE9-1CEC1CEE-1CF11D00-1DBF1E00-1F151F18-1F1D1F20-1F451F48-1F4D1F50-1F571F591F5B1F5D1F5F-1F7D1F80-1FB41FB6-1FBC1FBE1FC2-1FC41FC6-1FCC1FD0-1FD31FD6-1FDB1FE0-1FEC1FF2-1FF41FF6-1FFC2071207F2090-209421022107210A-211321152119-211D212421262128212A-212D212F-2139213C-213F2145-2149214E218321842C00-2C2E2C30-2C5E2C60-2CE42CEB-2CEE2D00-2D252D30-2D652D6F2D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE2E2F300530063031-3035303B303C3041-3096309D-309F30A1-30FA30FC-30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A48CA4D0-A4FDA500-A60CA610-A61FA62AA62BA640-A65FA662-A66EA67F-A697A6A0-A6E5A717-A71FA722-A788A78BA78CA7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2A9CFAA00-AA28AA40-AA42AA44-AA4BAA60-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADB-AADDABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB00-FB06FB13-FB17FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF21-FF3AFF41-FF5AFF66-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",
	    Ll: "0061-007A00AA00B500BA00DF-00F600F8-00FF01010103010501070109010B010D010F01110113011501170119011B011D011F01210123012501270129012B012D012F01310133013501370138013A013C013E014001420144014601480149014B014D014F01510153015501570159015B015D015F01610163016501670169016B016D016F0171017301750177017A017C017E-0180018301850188018C018D019201950199-019B019E01A101A301A501A801AA01AB01AD01B001B401B601B901BA01BD-01BF01C601C901CC01CE01D001D201D401D601D801DA01DC01DD01DF01E101E301E501E701E901EB01ED01EF01F001F301F501F901FB01FD01FF02010203020502070209020B020D020F02110213021502170219021B021D021F02210223022502270229022B022D022F02310233-0239023C023F0240024202470249024B024D024F-02930295-02AF037103730377037B-037D039003AC-03CE03D003D103D5-03D703D903DB03DD03DF03E103E303E503E703E903EB03ED03EF-03F303F503F803FB03FC0430-045F04610463046504670469046B046D046F04710473047504770479047B047D047F0481048B048D048F04910493049504970499049B049D049F04A104A304A504A704A904AB04AD04AF04B104B304B504B704B904BB04BD04BF04C204C404C604C804CA04CC04CE04CF04D104D304D504D704D904DB04DD04DF04E104E304E504E704E904EB04ED04EF04F104F304F504F704F904FB04FD04FF05010503050505070509050B050D050F05110513051505170519051B051D051F0521052305250561-05871D00-1D2B1D62-1D771D79-1D9A1E011E031E051E071E091E0B1E0D1E0F1E111E131E151E171E191E1B1E1D1E1F1E211E231E251E271E291E2B1E2D1E2F1E311E331E351E371E391E3B1E3D1E3F1E411E431E451E471E491E4B1E4D1E4F1E511E531E551E571E591E5B1E5D1E5F1E611E631E651E671E691E6B1E6D1E6F1E711E731E751E771E791E7B1E7D1E7F1E811E831E851E871E891E8B1E8D1E8F1E911E931E95-1E9D1E9F1EA11EA31EA51EA71EA91EAB1EAD1EAF1EB11EB31EB51EB71EB91EBB1EBD1EBF1EC11EC31EC51EC71EC91ECB1ECD1ECF1ED11ED31ED51ED71ED91EDB1EDD1EDF1EE11EE31EE51EE71EE91EEB1EED1EEF1EF11EF31EF51EF71EF91EFB1EFD1EFF-1F071F10-1F151F20-1F271F30-1F371F40-1F451F50-1F571F60-1F671F70-1F7D1F80-1F871F90-1F971FA0-1FA71FB0-1FB41FB61FB71FBE1FC2-1FC41FC61FC71FD0-1FD31FD61FD71FE0-1FE71FF2-1FF41FF61FF7210A210E210F2113212F21342139213C213D2146-2149214E21842C30-2C5E2C612C652C662C682C6A2C6C2C712C732C742C76-2C7C2C812C832C852C872C892C8B2C8D2C8F2C912C932C952C972C992C9B2C9D2C9F2CA12CA32CA52CA72CA92CAB2CAD2CAF2CB12CB32CB52CB72CB92CBB2CBD2CBF2CC12CC32CC52CC72CC92CCB2CCD2CCF2CD12CD32CD52CD72CD92CDB2CDD2CDF2CE12CE32CE42CEC2CEE2D00-2D25A641A643A645A647A649A64BA64DA64FA651A653A655A657A659A65BA65DA65FA663A665A667A669A66BA66DA681A683A685A687A689A68BA68DA68FA691A693A695A697A723A725A727A729A72BA72DA72F-A731A733A735A737A739A73BA73DA73FA741A743A745A747A749A74BA74DA74FA751A753A755A757A759A75BA75DA75FA761A763A765A767A769A76BA76DA76FA771-A778A77AA77CA77FA781A783A785A787A78CFB00-FB06FB13-FB17FF41-FF5A",
	    Lu: "0041-005A00C0-00D600D8-00DE01000102010401060108010A010C010E01100112011401160118011A011C011E01200122012401260128012A012C012E01300132013401360139013B013D013F0141014301450147014A014C014E01500152015401560158015A015C015E01600162016401660168016A016C016E017001720174017601780179017B017D018101820184018601870189-018B018E-0191019301940196-0198019C019D019F01A001A201A401A601A701A901AC01AE01AF01B1-01B301B501B701B801BC01C401C701CA01CD01CF01D101D301D501D701D901DB01DE01E001E201E401E601E801EA01EC01EE01F101F401F6-01F801FA01FC01FE02000202020402060208020A020C020E02100212021402160218021A021C021E02200222022402260228022A022C022E02300232023A023B023D023E02410243-02460248024A024C024E03700372037603860388-038A038C038E038F0391-03A103A3-03AB03CF03D2-03D403D803DA03DC03DE03E003E203E403E603E803EA03EC03EE03F403F703F903FA03FD-042F04600462046404660468046A046C046E04700472047404760478047A047C047E0480048A048C048E04900492049404960498049A049C049E04A004A204A404A604A804AA04AC04AE04B004B204B404B604B804BA04BC04BE04C004C104C304C504C704C904CB04CD04D004D204D404D604D804DA04DC04DE04E004E204E404E604E804EA04EC04EE04F004F204F404F604F804FA04FC04FE05000502050405060508050A050C050E05100512051405160518051A051C051E0520052205240531-055610A0-10C51E001E021E041E061E081E0A1E0C1E0E1E101E121E141E161E181E1A1E1C1E1E1E201E221E241E261E281E2A1E2C1E2E1E301E321E341E361E381E3A1E3C1E3E1E401E421E441E461E481E4A1E4C1E4E1E501E521E541E561E581E5A1E5C1E5E1E601E621E641E661E681E6A1E6C1E6E1E701E721E741E761E781E7A1E7C1E7E1E801E821E841E861E881E8A1E8C1E8E1E901E921E941E9E1EA01EA21EA41EA61EA81EAA1EAC1EAE1EB01EB21EB41EB61EB81EBA1EBC1EBE1EC01EC21EC41EC61EC81ECA1ECC1ECE1ED01ED21ED41ED61ED81EDA1EDC1EDE1EE01EE21EE41EE61EE81EEA1EEC1EEE1EF01EF21EF41EF61EF81EFA1EFC1EFE1F08-1F0F1F18-1F1D1F28-1F2F1F38-1F3F1F48-1F4D1F591F5B1F5D1F5F1F68-1F6F1FB8-1FBB1FC8-1FCB1FD8-1FDB1FE8-1FEC1FF8-1FFB21022107210B-210D2110-211221152119-211D212421262128212A-212D2130-2133213E213F214521832C00-2C2E2C602C62-2C642C672C692C6B2C6D-2C702C722C752C7E-2C802C822C842C862C882C8A2C8C2C8E2C902C922C942C962C982C9A2C9C2C9E2CA02CA22CA42CA62CA82CAA2CAC2CAE2CB02CB22CB42CB62CB82CBA2CBC2CBE2CC02CC22CC42CC62CC82CCA2CCC2CCE2CD02CD22CD42CD62CD82CDA2CDC2CDE2CE02CE22CEB2CEDA640A642A644A646A648A64AA64CA64EA650A652A654A656A658A65AA65CA65EA662A664A666A668A66AA66CA680A682A684A686A688A68AA68CA68EA690A692A694A696A722A724A726A728A72AA72CA72EA732A734A736A738A73AA73CA73EA740A742A744A746A748A74AA74CA74EA750A752A754A756A758A75AA75CA75EA760A762A764A766A768A76AA76CA76EA779A77BA77DA77EA780A782A784A786A78BFF21-FF3A",
	    Lt: "01C501C801CB01F21F88-1F8F1F98-1F9F1FA8-1FAF1FBC1FCC1FFC",
	    Lm: "02B0-02C102C6-02D102E0-02E402EC02EE0374037A0559064006E506E607F407F507FA081A0824082809710E460EC610FC17D718431AA71C78-1C7D1D2C-1D611D781D9B-1DBF2071207F2090-20942C7D2D6F2E2F30053031-3035303B309D309E30FC-30FEA015A4F8-A4FDA60CA67FA717-A71FA770A788A9CFAA70AADDFF70FF9EFF9F",
	    Lo: "01BB01C0-01C3029405D0-05EA05F0-05F20621-063F0641-064A066E066F0671-06D306D506EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA0800-08150904-0939093D09500958-096109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E450E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10D0-10FA1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317DC1820-18421844-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C771CE9-1CEC1CEE-1CF12135-21382D30-2D652D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE3006303C3041-3096309F30A1-30FA30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A014A016-A48CA4D0-A4F7A500-A60BA610-A61FA62AA62BA66EA6A0-A6E5A7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2AA00-AA28AA40-AA42AA44-AA4BAA60-AA6FAA71-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADBAADCABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF66-FF6FFF71-FF9DFFA0-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",
	    M:  "0300-036F0483-04890591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DE-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0903093C093E-094E0951-0955096209630981-098309BC09BE-09C409C709C809CB-09CD09D709E209E30A01-0A030A3C0A3E-0A420A470A480A4B-0A4D0A510A700A710A750A81-0A830ABC0ABE-0AC50AC7-0AC90ACB-0ACD0AE20AE30B01-0B030B3C0B3E-0B440B470B480B4B-0B4D0B560B570B620B630B820BBE-0BC20BC6-0BC80BCA-0BCD0BD70C01-0C030C3E-0C440C46-0C480C4A-0C4D0C550C560C620C630C820C830CBC0CBE-0CC40CC6-0CC80CCA-0CCD0CD50CD60CE20CE30D020D030D3E-0D440D46-0D480D4A-0D4D0D570D620D630D820D830DCA0DCF-0DD40DD60DD8-0DDF0DF20DF30E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F3E0F3F0F71-0F840F860F870F90-0F970F99-0FBC0FC6102B-103E1056-1059105E-10601062-10641067-106D1071-10741082-108D108F109A-109D135F1712-17141732-1734175217531772177317B6-17D317DD180B-180D18A91920-192B1930-193B19B0-19C019C819C91A17-1A1B1A55-1A5E1A60-1A7C1A7F1B00-1B041B34-1B441B6B-1B731B80-1B821BA1-1BAA1C24-1C371CD0-1CD21CD4-1CE81CED1CF21DC0-1DE61DFD-1DFF20D0-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66F-A672A67CA67DA6F0A6F1A802A806A80BA823-A827A880A881A8B4-A8C4A8E0-A8F1A926-A92DA947-A953A980-A983A9B3-A9C0AA29-AA36AA43AA4CAA4DAA7BAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE3-ABEAABECABEDFB1EFE00-FE0FFE20-FE26",
	    Mn: "0300-036F0483-04870591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DF-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0902093C0941-0948094D0951-095509620963098109BC09C1-09C409CD09E209E30A010A020A3C0A410A420A470A480A4B-0A4D0A510A700A710A750A810A820ABC0AC1-0AC50AC70AC80ACD0AE20AE30B010B3C0B3F0B41-0B440B4D0B560B620B630B820BC00BCD0C3E-0C400C46-0C480C4A-0C4D0C550C560C620C630CBC0CBF0CC60CCC0CCD0CE20CE30D41-0D440D4D0D620D630DCA0DD2-0DD40DD60E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F71-0F7E0F80-0F840F860F870F90-0F970F99-0FBC0FC6102D-10301032-10371039103A103D103E10581059105E-10601071-1074108210851086108D109D135F1712-17141732-1734175217531772177317B7-17BD17C617C9-17D317DD180B-180D18A91920-19221927192819321939-193B1A171A181A561A58-1A5E1A601A621A65-1A6C1A73-1A7C1A7F1B00-1B031B341B36-1B3A1B3C1B421B6B-1B731B801B811BA2-1BA51BA81BA91C2C-1C331C361C371CD0-1CD21CD4-1CE01CE2-1CE81CED1DC0-1DE61DFD-1DFF20D0-20DC20E120E5-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66FA67CA67DA6F0A6F1A802A806A80BA825A826A8C4A8E0-A8F1A926-A92DA947-A951A980-A982A9B3A9B6-A9B9A9BCAA29-AA2EAA31AA32AA35AA36AA43AA4CAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE5ABE8ABEDFB1EFE00-FE0FFE20-FE26",
	    Mc: "0903093E-09400949-094C094E0982098309BE-09C009C709C809CB09CC09D70A030A3E-0A400A830ABE-0AC00AC90ACB0ACC0B020B030B3E0B400B470B480B4B0B4C0B570BBE0BBF0BC10BC20BC6-0BC80BCA-0BCC0BD70C01-0C030C41-0C440C820C830CBE0CC0-0CC40CC70CC80CCA0CCB0CD50CD60D020D030D3E-0D400D46-0D480D4A-0D4C0D570D820D830DCF-0DD10DD8-0DDF0DF20DF30F3E0F3F0F7F102B102C10311038103B103C105610571062-10641067-106D108310841087-108C108F109A-109C17B617BE-17C517C717C81923-19261929-192B193019311933-193819B0-19C019C819C91A19-1A1B1A551A571A611A631A641A6D-1A721B041B351B3B1B3D-1B411B431B441B821BA11BA61BA71BAA1C24-1C2B1C341C351CE11CF2A823A824A827A880A881A8B4-A8C3A952A953A983A9B4A9B5A9BAA9BBA9BD-A9C0AA2FAA30AA33AA34AA4DAA7BABE3ABE4ABE6ABE7ABE9ABEAABEC",
	    Me: "0488048906DE20DD-20E020E2-20E4A670-A672",
	    N:  "0030-003900B200B300B900BC-00BE0660-066906F0-06F907C0-07C90966-096F09E6-09EF09F4-09F90A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BF20C66-0C6F0C78-0C7E0CE6-0CEF0D66-0D750E50-0E590ED0-0ED90F20-0F331040-10491090-10991369-137C16EE-16F017E0-17E917F0-17F91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C5920702074-20792080-20892150-21822185-21892460-249B24EA-24FF2776-27932CFD30073021-30293038-303A3192-31953220-32293251-325F3280-328932B1-32BFA620-A629A6E6-A6EFA830-A835A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",
	    Nd: "0030-00390660-066906F0-06F907C0-07C90966-096F09E6-09EF0A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BEF0C66-0C6F0CE6-0CEF0D66-0D6F0E50-0E590ED0-0ED90F20-0F291040-10491090-109917E0-17E91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C59A620-A629A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",
	    Nl: "16EE-16F02160-21822185-218830073021-30293038-303AA6E6-A6EF",
	    No: "00B200B300B900BC-00BE09F4-09F90BF0-0BF20C78-0C7E0D70-0D750F2A-0F331369-137C17F0-17F920702074-20792080-20892150-215F21892460-249B24EA-24FF2776-27932CFD3192-31953220-32293251-325F3280-328932B1-32BFA830-A835",
	    P:  "0021-00230025-002A002C-002F003A003B003F0040005B-005D005F007B007D00A100AB00B700BB00BF037E0387055A-055F0589058A05BE05C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F3A-0F3D0F850FD0-0FD4104A-104F10FB1361-13681400166D166E169B169C16EB-16ED1735173617D4-17D617D8-17DA1800-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD32010-20272030-20432045-20512053-205E207D207E208D208E2329232A2768-277527C527C627E6-27EF2983-299829D8-29DB29FC29FD2CF9-2CFC2CFE2CFF2E00-2E2E2E302E313001-30033008-30113014-301F3030303D30A030FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFD3EFD3FFE10-FE19FE30-FE52FE54-FE61FE63FE68FE6AFE6BFF01-FF03FF05-FF0AFF0C-FF0FFF1AFF1BFF1FFF20FF3B-FF3DFF3FFF5BFF5DFF5F-FF65",
	    Pd: "002D058A05BE140018062010-20152E172E1A301C303030A0FE31FE32FE58FE63FF0D",
	    Ps: "0028005B007B0F3A0F3C169B201A201E2045207D208D23292768276A276C276E27702772277427C527E627E827EA27EC27EE2983298529872989298B298D298F299129932995299729D829DA29FC2E222E242E262E283008300A300C300E3010301430163018301A301DFD3EFE17FE35FE37FE39FE3BFE3DFE3FFE41FE43FE47FE59FE5BFE5DFF08FF3BFF5BFF5FFF62",
	    Pe: "0029005D007D0F3B0F3D169C2046207E208E232A2769276B276D276F27712773277527C627E727E927EB27ED27EF298429862988298A298C298E2990299229942996299829D929DB29FD2E232E252E272E293009300B300D300F3011301530173019301B301E301FFD3FFE18FE36FE38FE3AFE3CFE3EFE40FE42FE44FE48FE5AFE5CFE5EFF09FF3DFF5DFF60FF63",
	    Pi: "00AB2018201B201C201F20392E022E042E092E0C2E1C2E20",
	    Pf: "00BB2019201D203A2E032E052E0A2E0D2E1D2E21",
	    Pc: "005F203F20402054FE33FE34FE4D-FE4FFF3F",
	    Po: "0021-00230025-0027002A002C002E002F003A003B003F0040005C00A100B700BF037E0387055A-055F058905C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F850FD0-0FD4104A-104F10FB1361-1368166D166E16EB-16ED1735173617D4-17D617D8-17DA1800-18051807-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD3201620172020-20272030-2038203B-203E2041-20432047-205120532055-205E2CF9-2CFC2CFE2CFF2E002E012E06-2E082E0B2E0E-2E162E182E192E1B2E1E2E1F2E2A-2E2E2E302E313001-3003303D30FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFE10-FE16FE19FE30FE45FE46FE49-FE4CFE50-FE52FE54-FE57FE5F-FE61FE68FE6AFE6BFF01-FF03FF05-FF07FF0AFF0CFF0EFF0FFF1AFF1BFF1FFF20FF3CFF61FF64FF65",
	    S:  "0024002B003C-003E005E0060007C007E00A2-00A900AC00AE-00B100B400B600B800D700F702C2-02C502D2-02DF02E5-02EB02ED02EF-02FF03750384038503F604820606-0608060B060E060F06E906FD06FE07F609F209F309FA09FB0AF10B700BF3-0BFA0C7F0CF10CF20D790E3F0F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-139917DB194019E0-19FF1B61-1B6A1B74-1B7C1FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE20442052207A-207C208A-208C20A0-20B8210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B2140-2144214A-214D214F2190-2328232B-23E82400-24262440-244A249C-24E92500-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE27C0-27C427C7-27CA27CC27D0-27E527F0-29822999-29D729DC-29FB29FE-2B4C2B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F309B309C319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A700-A716A720A721A789A78AA828-A82BA836-A839AA77-AA79FB29FDFCFDFDFE62FE64-FE66FE69FF04FF0BFF1C-FF1EFF3EFF40FF5CFF5EFFE0-FFE6FFE8-FFEEFFFCFFFD",
	    Sm: "002B003C-003E007C007E00AC00B100D700F703F60606-060820442052207A-207C208A-208C2140-2144214B2190-2194219A219B21A021A321A621AE21CE21CF21D221D421F4-22FF2308-230B23202321237C239B-23B323DC-23E125B725C125F8-25FF266F27C0-27C427C7-27CA27CC27D0-27E527F0-27FF2900-29822999-29D729DC-29FB29FE-2AFF2B30-2B442B47-2B4CFB29FE62FE64-FE66FF0BFF1C-FF1EFF5CFF5EFFE2FFE9-FFEC",
	    Sc: "002400A2-00A5060B09F209F309FB0AF10BF90E3F17DB20A0-20B8A838FDFCFE69FF04FFE0FFE1FFE5FFE6",
	    Sk: "005E006000A800AF00B400B802C2-02C502D2-02DF02E5-02EB02ED02EF-02FF0375038403851FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE309B309CA700-A716A720A721A789A78AFF3EFF40FFE3",
	    So: "00A600A700A900AE00B000B60482060E060F06E906FD06FE07F609FA0B700BF3-0BF80BFA0C7F0CF10CF20D790F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-1399194019E0-19FF1B61-1B6A1B74-1B7C210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B214A214C214D214F2195-2199219C-219F21A121A221A421A521A7-21AD21AF-21CD21D021D121D321D5-21F32300-2307230C-231F2322-2328232B-237B237D-239A23B4-23DB23E2-23E82400-24262440-244A249C-24E92500-25B625B8-25C025C2-25F72600-266E2670-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE2800-28FF2B00-2B2F2B452B462B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A828-A82BA836A837A839AA77-AA79FDFDFFE4FFE8FFEDFFEEFFFCFFFD",
	    Z:  "002000A01680180E2000-200A20282029202F205F3000",
	    Zs: "002000A01680180E2000-200A202F205F3000",
	    Zl: "2028",
	    Zp: "2029",
	    C:  "0000-001F007F-009F00AD03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-0605061C061D0620065F06DD070E070F074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17B417B517DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF200B-200F202A-202E2060-206F20722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-F8FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFD-FF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFFBFFFEFFFF",
	    Cc: "0000-001F007F-009F",
	    Cf: "00AD0600-060306DD070F17B417B5200B-200F202A-202E2060-2064206A-206FFEFFFFF9-FFFB",
	    Co: "E000-F8FF",
	    Cs: "D800-DFFF",
	    Cn: "03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-05FF06040605061C061D0620065F070E074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF2065-206920722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-D7FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFDFEFEFF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFF8FFFEFFFF"
	});
	
	function addUnicodePackage (pack) {
	    var codePoint = /\w{4}/g;
	    for (var name in pack)
	        exports.packages[name] = pack[name].replace(codePoint, "\\u$&");
	}
	
	});
	
	ace.define("ace/mode/text",["require","exports","module","ace/tokenizer","ace/mode/text_highlight_rules","ace/mode/behaviour/cstyle","ace/unicode","ace/lib/lang","ace/token_iterator","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var Tokenizer = acequire("../tokenizer").Tokenizer;
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
	var unicode = acequire("../unicode");
	var lang = acequire("../lib/lang");
	var TokenIterator = acequire("../token_iterator").TokenIterator;
	var Range = acequire("../range").Range;
	
	var Mode = function() {
	    this.HighlightRules = TextHighlightRules;
	};
	
	(function() {
	    this.$defaultBehaviour = new CstyleBehaviour();
	
	    this.tokenRe = new RegExp("^["
	        + unicode.packages.L
	        + unicode.packages.Mn + unicode.packages.Mc
	        + unicode.packages.Nd
	        + unicode.packages.Pc + "\\$_]+", "g"
	    );
	
	    this.nonTokenRe = new RegExp("^(?:[^"
	        + unicode.packages.L
	        + unicode.packages.Mn + unicode.packages.Mc
	        + unicode.packages.Nd
	        + unicode.packages.Pc + "\\$_]|\\s])+", "g"
	    );
	
	    this.getTokenizer = function() {
	        if (!this.$tokenizer) {
	            this.$highlightRules = this.$highlightRules || new this.HighlightRules(this.$highlightRuleConfig);
	            this.$tokenizer = new Tokenizer(this.$highlightRules.getRules());
	        }
	        return this.$tokenizer;
	    };
	
	    this.lineCommentStart = "";
	    this.blockComment = "";
	
	    this.toggleCommentLines = function(state, session, startRow, endRow) {
	        var doc = session.doc;
	
	        var ignoreBlankLines = true;
	        var shouldRemove = true;
	        var minIndent = Infinity;
	        var tabSize = session.getTabSize();
	        var insertAtTabStop = false;
	
	        if (!this.lineCommentStart) {
	            if (!this.blockComment)
	                return false;
	            var lineCommentStart = this.blockComment.start;
	            var lineCommentEnd = this.blockComment.end;
	            var regexpStart = new RegExp("^(\\s*)(?:" + lang.escapeRegExp(lineCommentStart) + ")");
	            var regexpEnd = new RegExp("(?:" + lang.escapeRegExp(lineCommentEnd) + ")\\s*$");
	
	            var comment = function(line, i) {
	                if (testRemove(line, i))
	                    return;
	                if (!ignoreBlankLines || /\S/.test(line)) {
	                    doc.insertInLine({row: i, column: line.length}, lineCommentEnd);
	                    doc.insertInLine({row: i, column: minIndent}, lineCommentStart);
	                }
	            };
	
	            var uncomment = function(line, i) {
	                var m;
	                if (m = line.match(regexpEnd))
	                    doc.removeInLine(i, line.length - m[0].length, line.length);
	                if (m = line.match(regexpStart))
	                    doc.removeInLine(i, m[1].length, m[0].length);
	            };
	
	            var testRemove = function(line, row) {
	                if (regexpStart.test(line))
	                    return true;
	                var tokens = session.getTokens(row);
	                for (var i = 0; i < tokens.length; i++) {
	                    if (tokens[i].type === "comment")
	                        return true;
	                }
	            };
	        } else {
	            if (Array.isArray(this.lineCommentStart)) {
	                var regexpStart = this.lineCommentStart.map(lang.escapeRegExp).join("|");
	                var lineCommentStart = this.lineCommentStart[0];
	            } else {
	                var regexpStart = lang.escapeRegExp(this.lineCommentStart);
	                var lineCommentStart = this.lineCommentStart;
	            }
	            regexpStart = new RegExp("^(\\s*)(?:" + regexpStart + ") ?");
	            
	            insertAtTabStop = session.getUseSoftTabs();
	
	            var uncomment = function(line, i) {
	                var m = line.match(regexpStart);
	                if (!m) return;
	                var start = m[1].length, end = m[0].length;
	                if (!shouldInsertSpace(line, start, end) && m[0][end - 1] == " ")
	                    end--;
	                doc.removeInLine(i, start, end);
	            };
	            var commentWithSpace = lineCommentStart + " ";
	            var comment = function(line, i) {
	                if (!ignoreBlankLines || /\S/.test(line)) {
	                    if (shouldInsertSpace(line, minIndent, minIndent))
	                        doc.insertInLine({row: i, column: minIndent}, commentWithSpace);
	                    else
	                        doc.insertInLine({row: i, column: minIndent}, lineCommentStart);
	                }
	            };
	            var testRemove = function(line, i) {
	                return regexpStart.test(line);
	            };
	            
	            var shouldInsertSpace = function(line, before, after) {
	                var spaces = 0;
	                while (before-- && line.charAt(before) == " ")
	                    spaces++;
	                if (spaces % tabSize != 0)
	                    return false;
	                var spaces = 0;
	                while (line.charAt(after++) == " ")
	                    spaces++;
	                if (tabSize > 2)
	                    return spaces % tabSize != tabSize - 1;
	                else
	                    return spaces % tabSize == 0;
	                return true;
	            };
	        }
	
	        function iter(fun) {
	            for (var i = startRow; i <= endRow; i++)
	                fun(doc.getLine(i), i);
	        }
	
	
	        var minEmptyLength = Infinity;
	        iter(function(line, i) {
	            var indent = line.search(/\S/);
	            if (indent !== -1) {
	                if (indent < minIndent)
	                    minIndent = indent;
	                if (shouldRemove && !testRemove(line, i))
	                    shouldRemove = false;
	            } else if (minEmptyLength > line.length) {
	                minEmptyLength = line.length;
	            }
	        });
	
	        if (minIndent == Infinity) {
	            minIndent = minEmptyLength;
	            ignoreBlankLines = false;
	            shouldRemove = false;
	        }
	
	        if (insertAtTabStop && minIndent % tabSize != 0)
	            minIndent = Math.floor(minIndent / tabSize) * tabSize;
	
	        iter(shouldRemove ? uncomment : comment);
	    };
	
	    this.toggleBlockComment = function(state, session, range, cursor) {
	        var comment = this.blockComment;
	        if (!comment)
	            return;
	        if (!comment.start && comment[0])
	            comment = comment[0];
	
	        var iterator = new TokenIterator(session, cursor.row, cursor.column);
	        var token = iterator.getCurrentToken();
	
	        var sel = session.selection;
	        var initialRange = session.selection.toOrientedRange();
	        var startRow, colDiff;
	
	        if (token && /comment/.test(token.type)) {
	            var startRange, endRange;
	            while (token && /comment/.test(token.type)) {
	                var i = token.value.indexOf(comment.start);
	                if (i != -1) {
	                    var row = iterator.getCurrentTokenRow();
	                    var column = iterator.getCurrentTokenColumn() + i;
	                    startRange = new Range(row, column, row, column + comment.start.length);
	                    break;
	                }
	                token = iterator.stepBackward();
	            }
	
	            var iterator = new TokenIterator(session, cursor.row, cursor.column);
	            var token = iterator.getCurrentToken();
	            while (token && /comment/.test(token.type)) {
	                var i = token.value.indexOf(comment.end);
	                if (i != -1) {
	                    var row = iterator.getCurrentTokenRow();
	                    var column = iterator.getCurrentTokenColumn() + i;
	                    endRange = new Range(row, column, row, column + comment.end.length);
	                    break;
	                }
	                token = iterator.stepForward();
	            }
	            if (endRange)
	                session.remove(endRange);
	            if (startRange) {
	                session.remove(startRange);
	                startRow = startRange.start.row;
	                colDiff = -comment.start.length;
	            }
	        } else {
	            colDiff = comment.start.length;
	            startRow = range.start.row;
	            session.insert(range.end, comment.end);
	            session.insert(range.start, comment.start);
	        }
	        if (initialRange.start.row == startRow)
	            initialRange.start.column += colDiff;
	        if (initialRange.end.row == startRow)
	            initialRange.end.column += colDiff;
	        session.selection.fromOrientedRange(initialRange);
	    };
	
	    this.getNextLineIndent = function(state, line, tab) {
	        return this.$getIndent(line);
	    };
	
	    this.checkOutdent = function(state, line, input) {
	        return false;
	    };
	
	    this.autoOutdent = function(state, doc, row) {
	    };
	
	    this.$getIndent = function(line) {
	        return line.match(/^\s*/)[0];
	    };
	
	    this.createWorker = function(session) {
	        return null;
	    };
	
	    this.createModeDelegates = function (mapping) {
	        this.$embeds = [];
	        this.$modes = {};
	        for (var i in mapping) {
	            if (mapping[i]) {
	                this.$embeds.push(i);
	                this.$modes[i] = new mapping[i]();
	            }
	        }
	
	        var delegations = ["toggleBlockComment", "toggleCommentLines", "getNextLineIndent", 
	            "checkOutdent", "autoOutdent", "transformAction", "getCompletions"];
	
	        for (var i = 0; i < delegations.length; i++) {
	            (function(scope) {
	              var functionName = delegations[i];
	              var defaultHandler = scope[functionName];
	              scope[delegations[i]] = function() {
	                  return this.$delegator(functionName, arguments, defaultHandler);
	              };
	            }(this));
	        }
	    };
	
	    this.$delegator = function(method, args, defaultHandler) {
	        var state = args[0];
	        if (typeof state != "string")
	            state = state[0];
	        for (var i = 0; i < this.$embeds.length; i++) {
	            if (!this.$modes[this.$embeds[i]]) continue;
	
	            var split = state.split(this.$embeds[i]);
	            if (!split[0] && split[1]) {
	                args[0] = split[1];
	                var mode = this.$modes[this.$embeds[i]];
	                return mode[method].apply(mode, args);
	            }
	        }
	        var ret = defaultHandler.apply(this, args);
	        return defaultHandler ? ret : undefined;
	    };
	
	    this.transformAction = function(state, action, editor, session, param) {
	        if (this.$behaviour) {
	            var behaviours = this.$behaviour.getBehaviours();
	            for (var key in behaviours) {
	                if (behaviours[key][action]) {
	                    var ret = behaviours[key][action].apply(this, arguments);
	                    if (ret) {
	                        return ret;
	                    }
	                }
	            }
	        }
	    };
	    
	    this.getKeywords = function(append) {
	        if (!this.completionKeywords) {
	            var rules = this.$tokenizer.rules;
	            var completionKeywords = [];
	            for (var rule in rules) {
	                var ruleItr = rules[rule];
	                for (var r = 0, l = ruleItr.length; r < l; r++) {
	                    if (typeof ruleItr[r].token === "string") {
	                        if (/keyword|support|storage/.test(ruleItr[r].token))
	                            completionKeywords.push(ruleItr[r].regex);
	                    }
	                    else if (typeof ruleItr[r].token === "object") {
	                        for (var a = 0, aLength = ruleItr[r].token.length; a < aLength; a++) {    
	                            if (/keyword|support|storage/.test(ruleItr[r].token[a])) {
	                                var rule = ruleItr[r].regex.match(/\(.+?\)/g)[a];
	                                completionKeywords.push(rule.substr(1, rule.length - 2));
	                            }
	                        }
	                    }
	                }
	            }
	            this.completionKeywords = completionKeywords;
	        }
	        if (!append)
	            return this.$keywordList;
	        return completionKeywords.concat(this.$keywordList || []);
	    };
	    
	    this.$createKeywordList = function() {
	        if (!this.$highlightRules)
	            this.getTokenizer();
	        return this.$keywordList = this.$highlightRules.$keywordList || [];
	    };
	
	    this.getCompletions = function(state, session, pos, prefix) {
	        var keywords = this.$keywordList || this.$createKeywordList();
	        return keywords.map(function(word) {
	            return {
	                name: word,
	                value: word,
	                score: 0,
	                meta: "keyword"
	            };
	        });
	    };
	
	    this.$id = "ace/mode/text";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	});
	
	ace.define("ace/apply_delta",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	function throwDeltaError(delta, errorText){
	    console.log("Invalid Delta:", delta);
	    throw "Invalid Delta: " + errorText;
	}
	
	function positionInDocument(docLines, position) {
	    return position.row    >= 0 && position.row    <  docLines.length &&
	           position.column >= 0 && position.column <= docLines[position.row].length;
	}
	
	function validateDelta(docLines, delta) {
	    if (delta.action != "insert" && delta.action != "remove")
	        throwDeltaError(delta, "delta.action must be 'insert' or 'remove'");
	    if (!(delta.lines instanceof Array))
	        throwDeltaError(delta, "delta.lines must be an Array");
	    if (!delta.start || !delta.end)
	       throwDeltaError(delta, "delta.start/end must be an present");
	    var start = delta.start;
	    if (!positionInDocument(docLines, delta.start))
	        throwDeltaError(delta, "delta.start must be contained in document");
	    var end = delta.end;
	    if (delta.action == "remove" && !positionInDocument(docLines, end))
	        throwDeltaError(delta, "delta.end must contained in document for 'remove' actions");
	    var numRangeRows = end.row - start.row;
	    var numRangeLastLineChars = (end.column - (numRangeRows == 0 ? start.column : 0));
	    if (numRangeRows != delta.lines.length - 1 || delta.lines[numRangeRows].length != numRangeLastLineChars)
	        throwDeltaError(delta, "delta.range must match delta lines");
	}
	
	exports.applyDelta = function(docLines, delta, doNotValidate) {
	    
	    var row = delta.start.row;
	    var startColumn = delta.start.column;
	    var line = docLines[row] || "";
	    switch (delta.action) {
	        case "insert":
	            var lines = delta.lines;
	            if (lines.length === 1) {
	                docLines[row] = line.substring(0, startColumn) + delta.lines[0] + line.substring(startColumn);
	            } else {
	                var args = [row, 1].concat(delta.lines);
	                docLines.splice.apply(docLines, args);
	                docLines[row] = line.substring(0, startColumn) + docLines[row];
	                docLines[row + delta.lines.length - 1] += line.substring(startColumn);
	            }
	            break;
	        case "remove":
	            var endColumn = delta.end.column;
	            var endRow = delta.end.row;
	            if (row === endRow) {
	                docLines[row] = line.substring(0, startColumn) + line.substring(endColumn);
	            } else {
	                docLines.splice(
	                    row, endRow - row + 1,
	                    line.substring(0, startColumn) + docLines[endRow].substring(endColumn)
	                );
	            }
	            break;
	    }
	}
	});
	
	ace.define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("./lib/oop");
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	
	var Anchor = exports.Anchor = function(doc, row, column) {
	    this.$onChange = this.onChange.bind(this);
	    this.attach(doc);
	    
	    if (typeof column == "undefined")
	        this.setPosition(row.row, row.column);
	    else
	        this.setPosition(row, column);
	};
	
	(function() {
	
	    oop.implement(this, EventEmitter);
	    this.getPosition = function() {
	        return this.$clipPositionToDocument(this.row, this.column);
	    };
	    this.getDocument = function() {
	        return this.document;
	    };
	    this.$insertRight = false;
	    this.onChange = function(delta) {
	        if (delta.start.row == delta.end.row && delta.start.row != this.row)
	            return;
	
	        if (delta.start.row > this.row)
	            return;
	            
	        var point = $getTransformedPoint(delta, {row: this.row, column: this.column}, this.$insertRight);
	        this.setPosition(point.row, point.column, true);
	    };
	    
	    function $pointsInOrder(point1, point2, equalPointsInOrder) {
	        var bColIsAfter = equalPointsInOrder ? point1.column <= point2.column : point1.column < point2.column;
	        return (point1.row < point2.row) || (point1.row == point2.row && bColIsAfter);
	    }
	            
	    function $getTransformedPoint(delta, point, moveIfEqual) {
	        var deltaIsInsert = delta.action == "insert";
	        var deltaRowShift = (deltaIsInsert ? 1 : -1) * (delta.end.row    - delta.start.row);
	        var deltaColShift = (deltaIsInsert ? 1 : -1) * (delta.end.column - delta.start.column);
	        var deltaStart = delta.start;
	        var deltaEnd = deltaIsInsert ? deltaStart : delta.end; // Collapse insert range.
	        if ($pointsInOrder(point, deltaStart, moveIfEqual)) {
	            return {
	                row: point.row,
	                column: point.column
	            };
	        }
	        if ($pointsInOrder(deltaEnd, point, !moveIfEqual)) {
	            return {
	                row: point.row + deltaRowShift,
	                column: point.column + (point.row == deltaEnd.row ? deltaColShift : 0)
	            };
	        }
	        
	        return {
	            row: deltaStart.row,
	            column: deltaStart.column
	        };
	    }
	    this.setPosition = function(row, column, noClip) {
	        var pos;
	        if (noClip) {
	            pos = {
	                row: row,
	                column: column
	            };
	        } else {
	            pos = this.$clipPositionToDocument(row, column);
	        }
	
	        if (this.row == pos.row && this.column == pos.column)
	            return;
	
	        var old = {
	            row: this.row,
	            column: this.column
	        };
	
	        this.row = pos.row;
	        this.column = pos.column;
	        this._signal("change", {
	            old: old,
	            value: pos
	        });
	    };
	    this.detach = function() {
	        this.document.removeEventListener("change", this.$onChange);
	    };
	    this.attach = function(doc) {
	        this.document = doc || this.document;
	        this.document.on("change", this.$onChange);
	    };
	    this.$clipPositionToDocument = function(row, column) {
	        var pos = {};
	
	        if (row >= this.document.getLength()) {
	            pos.row = Math.max(0, this.document.getLength() - 1);
	            pos.column = this.document.getLine(pos.row).length;
	        }
	        else if (row < 0) {
	            pos.row = 0;
	            pos.column = 0;
	        }
	        else {
	            pos.row = row;
	            pos.column = Math.min(this.document.getLine(pos.row).length, Math.max(0, column));
	        }
	
	        if (column < 0)
	            pos.column = 0;
	
	        return pos;
	    };
	
	}).call(Anchor.prototype);
	
	});
	
	ace.define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("./lib/oop");
	var applyDelta = acequire("./apply_delta").applyDelta;
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	var Range = acequire("./range").Range;
	var Anchor = acequire("./anchor").Anchor;
	
	var Document = function(textOrLines) {
	    this.$lines = [""];
	    if (textOrLines.length === 0) {
	        this.$lines = [""];
	    } else if (Array.isArray(textOrLines)) {
	        this.insertMergedLines({row: 0, column: 0}, textOrLines);
	    } else {
	        this.insert({row: 0, column:0}, textOrLines);
	    }
	};
	
	(function() {
	
	    oop.implement(this, EventEmitter);
	    this.setValue = function(text) {
	        var len = this.getLength() - 1;
	        this.remove(new Range(0, 0, len, this.getLine(len).length));
	        this.insert({row: 0, column: 0}, text);
	    };
	    this.getValue = function() {
	        return this.getAllLines().join(this.getNewLineCharacter());
	    };
	    this.createAnchor = function(row, column) {
	        return new Anchor(this, row, column);
	    };
	    if ("aaa".split(/a/).length === 0) {
	        this.$split = function(text) {
	            return text.replace(/\r\n|\r/g, "\n").split("\n");
	        };
	    } else {
	        this.$split = function(text) {
	            return text.split(/\r\n|\r|\n/);
	        };
	    }
	
	
	    this.$detectNewLine = function(text) {
	        var match = text.match(/^.*?(\r\n|\r|\n)/m);
	        this.$autoNewLine = match ? match[1] : "\n";
	        this._signal("changeNewLineMode");
	    };
	    this.getNewLineCharacter = function() {
	        switch (this.$newLineMode) {
	          case "windows":
	            return "\r\n";
	          case "unix":
	            return "\n";
	          default:
	            return this.$autoNewLine || "\n";
	        }
	    };
	
	    this.$autoNewLine = "";
	    this.$newLineMode = "auto";
	    this.setNewLineMode = function(newLineMode) {
	        if (this.$newLineMode === newLineMode)
	            return;
	
	        this.$newLineMode = newLineMode;
	        this._signal("changeNewLineMode");
	    };
	    this.getNewLineMode = function() {
	        return this.$newLineMode;
	    };
	    this.isNewLine = function(text) {
	        return (text == "\r\n" || text == "\r" || text == "\n");
	    };
	    this.getLine = function(row) {
	        return this.$lines[row] || "";
	    };
	    this.getLines = function(firstRow, lastRow) {
	        return this.$lines.slice(firstRow, lastRow + 1);
	    };
	    this.getAllLines = function() {
	        return this.getLines(0, this.getLength());
	    };
	    this.getLength = function() {
	        return this.$lines.length;
	    };
	    this.getTextRange = function(range) {
	        return this.getLinesForRange(range).join(this.getNewLineCharacter());
	    };
	    this.getLinesForRange = function(range) {
	        var lines;
	        if (range.start.row === range.end.row) {
	            lines = [this.getLine(range.start.row).substring(range.start.column, range.end.column)];
	        } else {
	            lines = this.getLines(range.start.row, range.end.row);
	            lines[0] = (lines[0] || "").substring(range.start.column);
	            var l = lines.length - 1;
	            if (range.end.row - range.start.row == l)
	                lines[l] = lines[l].substring(0, range.end.column);
	        }
	        return lines;
	    };
	    this.insertLines = function(row, lines) {
	        console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead.");
	        return this.insertFullLines(row, lines);
	    };
	    this.removeLines = function(firstRow, lastRow) {
	        console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead.");
	        return this.removeFullLines(firstRow, lastRow);
	    };
	    this.insertNewLine = function(position) {
	        console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.");
	        return this.insertMergedLines(position, ["", ""]);
	    };
	    this.insert = function(position, text) {
	        if (this.getLength() <= 1)
	            this.$detectNewLine(text);
	        
	        return this.insertMergedLines(position, this.$split(text));
	    };
	    this.insertInLine = function(position, text) {
	        var start = this.clippedPos(position.row, position.column);
	        var end = this.pos(position.row, position.column + text.length);
	        
	        this.applyDelta({
	            start: start,
	            end: end,
	            action: "insert",
	            lines: [text]
	        }, true);
	        
	        return this.clonePos(end);
	    };
	    
	    this.clippedPos = function(row, column) {
	        var length = this.getLength();
	        if (row === undefined) {
	            row = length;
	        } else if (row < 0) {
	            row = 0;
	        } else if (row >= length) {
	            row = length - 1;
	            column = undefined;
	        }
	        var line = this.getLine(row);
	        if (column == undefined)
	            column = line.length;
	        column = Math.min(Math.max(column, 0), line.length);
	        return {row: row, column: column};
	    };
	    
	    this.clonePos = function(pos) {
	        return {row: pos.row, column: pos.column};
	    };
	    
	    this.pos = function(row, column) {
	        return {row: row, column: column};
	    };
	    
	    this.$clipPosition = function(position) {
	        var length = this.getLength();
	        if (position.row >= length) {
	            position.row = Math.max(0, length - 1);
	            position.column = this.getLine(length - 1).length;
	        } else {
	            position.row = Math.max(0, position.row);
	            position.column = Math.min(Math.max(position.column, 0), this.getLine(position.row).length);
	        }
	        return position;
	    };
	    this.insertFullLines = function(row, lines) {
	        row = Math.min(Math.max(row, 0), this.getLength());
	        var column = 0;
	        if (row < this.getLength()) {
	            lines = lines.concat([""]);
	            column = 0;
	        } else {
	            lines = [""].concat(lines);
	            row--;
	            column = this.$lines[row].length;
	        }
	        this.insertMergedLines({row: row, column: column}, lines);
	    };    
	    this.insertMergedLines = function(position, lines) {
	        var start = this.clippedPos(position.row, position.column);
	        var end = {
	            row: start.row + lines.length - 1,
	            column: (lines.length == 1 ? start.column : 0) + lines[lines.length - 1].length
	        };
	        
	        this.applyDelta({
	            start: start,
	            end: end,
	            action: "insert",
	            lines: lines
	        });
	        
	        return this.clonePos(end);
	    };
	    this.remove = function(range) {
	        var start = this.clippedPos(range.start.row, range.start.column);
	        var end = this.clippedPos(range.end.row, range.end.column);
	        this.applyDelta({
	            start: start,
	            end: end,
	            action: "remove",
	            lines: this.getLinesForRange({start: start, end: end})
	        });
	        return this.clonePos(start);
	    };
	    this.removeInLine = function(row, startColumn, endColumn) {
	        var start = this.clippedPos(row, startColumn);
	        var end = this.clippedPos(row, endColumn);
	        
	        this.applyDelta({
	            start: start,
	            end: end,
	            action: "remove",
	            lines: this.getLinesForRange({start: start, end: end})
	        }, true);
	        
	        return this.clonePos(start);
	    };
	    this.removeFullLines = function(firstRow, lastRow) {
	        firstRow = Math.min(Math.max(0, firstRow), this.getLength() - 1);
	        lastRow  = Math.min(Math.max(0, lastRow ), this.getLength() - 1);
	        var deleteFirstNewLine = lastRow == this.getLength() - 1 && firstRow > 0;
	        var deleteLastNewLine  = lastRow  < this.getLength() - 1;
	        var startRow = ( deleteFirstNewLine ? firstRow - 1                  : firstRow                    );
	        var startCol = ( deleteFirstNewLine ? this.getLine(startRow).length : 0                           );
	        var endRow   = ( deleteLastNewLine  ? lastRow + 1                   : lastRow                     );
	        var endCol   = ( deleteLastNewLine  ? 0                             : this.getLine(endRow).length ); 
	        var range = new Range(startRow, startCol, endRow, endCol);
	        var deletedLines = this.$lines.slice(firstRow, lastRow + 1);
	        
	        this.applyDelta({
	            start: range.start,
	            end: range.end,
	            action: "remove",
	            lines: this.getLinesForRange(range)
	        });
	        return deletedLines;
	    };
	    this.removeNewLine = function(row) {
	        if (row < this.getLength() - 1 && row >= 0) {
	            this.applyDelta({
	                start: this.pos(row, this.getLine(row).length),
	                end: this.pos(row + 1, 0),
	                action: "remove",
	                lines: ["", ""]
	            });
	        }
	    };
	    this.replace = function(range, text) {
	        if (!(range instanceof Range))
	            range = Range.fromPoints(range.start, range.end);
	        if (text.length === 0 && range.isEmpty())
	            return range.start;
	        if (text == this.getTextRange(range))
	            return range.end;
	
	        this.remove(range);
	        var end;
	        if (text) {
	            end = this.insert(range.start, text);
	        }
	        else {
	            end = range.start;
	        }
	        
	        return end;
	    };
	    this.applyDeltas = function(deltas) {
	        for (var i=0; i<deltas.length; i++) {
	            this.applyDelta(deltas[i]);
	        }
	    };
	    this.revertDeltas = function(deltas) {
	        for (var i=deltas.length-1; i>=0; i--) {
	            this.revertDelta(deltas[i]);
	        }
	    };
	    this.applyDelta = function(delta, doNotValidate) {
	        var isInsert = delta.action == "insert";
	        if (isInsert ? delta.lines.length <= 1 && !delta.lines[0]
	            : !Range.comparePoints(delta.start, delta.end)) {
	            return;
	        }
	        
	        if (isInsert && delta.lines.length > 20000)
	            this.$splitAndapplyLargeDelta(delta, 20000);
	        applyDelta(this.$lines, delta, doNotValidate);
	        this._signal("change", delta);
	    };
	    
	    this.$splitAndapplyLargeDelta = function(delta, MAX) {
	        var lines = delta.lines;
	        var l = lines.length;
	        var row = delta.start.row; 
	        var column = delta.start.column;
	        var from = 0, to = 0;
	        do {
	            from = to;
	            to += MAX - 1;
	            var chunk = lines.slice(from, to);
	            if (to > l) {
	                delta.lines = chunk;
	                delta.start.row = row + from;
	                delta.start.column = column;
	                break;
	            }
	            chunk.push("");
	            this.applyDelta({
	                start: this.pos(row + from, column),
	                end: this.pos(row + to, column = 0),
	                action: delta.action,
	                lines: chunk
	            }, true);
	        } while(true);
	    };
	    this.revertDelta = function(delta) {
	        this.applyDelta({
	            start: this.clonePos(delta.start),
	            end: this.clonePos(delta.end),
	            action: (delta.action == "insert" ? "remove" : "insert"),
	            lines: delta.lines.slice()
	        });
	    };
	    this.indexToPosition = function(index, startRow) {
	        var lines = this.$lines || this.getAllLines();
	        var newlineLength = this.getNewLineCharacter().length;
	        for (var i = startRow || 0, l = lines.length; i < l; i++) {
	            index -= lines[i].length + newlineLength;
	            if (index < 0)
	                return {row: i, column: index + lines[i].length + newlineLength};
	        }
	        return {row: l-1, column: lines[l-1].length};
	    };
	    this.positionToIndex = function(pos, startRow) {
	        var lines = this.$lines || this.getAllLines();
	        var newlineLength = this.getNewLineCharacter().length;
	        var index = 0;
	        var row = Math.min(pos.row, lines.length);
	        for (var i = startRow || 0; i < row; ++i)
	            index += lines[i].length + newlineLength;
	
	        return index + pos.column;
	    };
	
	}).call(Document.prototype);
	
	exports.Document = Document;
	});
	
	ace.define("ace/background_tokenizer",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("./lib/oop");
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	
	var BackgroundTokenizer = function(tokenizer, editor) {
	    this.running = false;
	    this.lines = [];
	    this.states = [];
	    this.currentLine = 0;
	    this.tokenizer = tokenizer;
	
	    var self = this;
	
	    this.$worker = function() {
	        if (!self.running) { return; }
	
	        var workerStart = new Date();
	        var currentLine = self.currentLine;
	        var endLine = -1;
	        var doc = self.doc;
	
	        var startLine = currentLine;
	        while (self.lines[currentLine])
	            currentLine++;
	        
	        var len = doc.getLength();
	        var processedLines = 0;
	        self.running = false;
	        while (currentLine < len) {
	            self.$tokenizeRow(currentLine);
	            endLine = currentLine;
	            do {
	                currentLine++;
	            } while (self.lines[currentLine]);
	            processedLines ++;
	            if ((processedLines % 5 === 0) && (new Date() - workerStart) > 20) {                
	                self.running = setTimeout(self.$worker, 20);
	                break;
	            }
	        }
	        self.currentLine = currentLine;
	        
	        if (startLine <= endLine)
	            self.fireUpdateEvent(startLine, endLine);
	    };
	};
	
	(function(){
	
	    oop.implement(this, EventEmitter);
	    this.setTokenizer = function(tokenizer) {
	        this.tokenizer = tokenizer;
	        this.lines = [];
	        this.states = [];
	
	        this.start(0);
	    };
	    this.setDocument = function(doc) {
	        this.doc = doc;
	        this.lines = [];
	        this.states = [];
	
	        this.stop();
	    };
	    this.fireUpdateEvent = function(firstRow, lastRow) {
	        var data = {
	            first: firstRow,
	            last: lastRow
	        };
	        this._signal("update", {data: data});
	    };
	    this.start = function(startRow) {
	        this.currentLine = Math.min(startRow || 0, this.currentLine, this.doc.getLength());
	        this.lines.splice(this.currentLine, this.lines.length);
	        this.states.splice(this.currentLine, this.states.length);
	
	        this.stop();
	        this.running = setTimeout(this.$worker, 700);
	    };
	    
	    this.scheduleStart = function() {
	        if (!this.running)
	            this.running = setTimeout(this.$worker, 700);
	    }
	
	    this.$updateOnChange = function(delta) {
	        var startRow = delta.start.row;
	        var len = delta.end.row - startRow;
	
	        if (len === 0) {
	            this.lines[startRow] = null;
	        } else if (delta.action == "remove") {
	            this.lines.splice(startRow, len + 1, null);
	            this.states.splice(startRow, len + 1, null);
	        } else {
	            var args = Array(len + 1);
	            args.unshift(startRow, 1);
	            this.lines.splice.apply(this.lines, args);
	            this.states.splice.apply(this.states, args);
	        }
	
	        this.currentLine = Math.min(startRow, this.currentLine, this.doc.getLength());
	
	        this.stop();
	    };
	    this.stop = function() {
	        if (this.running)
	            clearTimeout(this.running);
	        this.running = false;
	    };
	    this.getTokens = function(row) {
	        return this.lines[row] || this.$tokenizeRow(row);
	    };
	    this.getState = function(row) {
	        if (this.currentLine == row)
	            this.$tokenizeRow(row);
	        return this.states[row] || "start";
	    };
	
	    this.$tokenizeRow = function(row) {
	        var line = this.doc.getLine(row);
	        var state = this.states[row - 1];
	
	        var data = this.tokenizer.getLineTokens(line, state, row);
	
	        if (this.states[row] + "" !== data.state + "") {
	            this.states[row] = data.state;
	            this.lines[row + 1] = null;
	            if (this.currentLine > row + 1)
	                this.currentLine = row + 1;
	        } else if (this.currentLine == row) {
	            this.currentLine = row + 1;
	        }
	
	        return this.lines[row] = data.tokens;
	    };
	
	}).call(BackgroundTokenizer.prototype);
	
	exports.BackgroundTokenizer = BackgroundTokenizer;
	});
	
	ace.define("ace/search_highlight",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var lang = acequire("./lib/lang");
	var oop = acequire("./lib/oop");
	var Range = acequire("./range").Range;
	
	var SearchHighlight = function(regExp, clazz, type) {
	    this.setRegexp(regExp);
	    this.clazz = clazz;
	    this.type = type || "text";
	};
	
	(function() {
	    this.MAX_RANGES = 500;
	    
	    this.setRegexp = function(regExp) {
	        if (this.regExp+"" == regExp+"")
	            return;
	        this.regExp = regExp;
	        this.cache = [];
	    };
	
	    this.update = function(html, markerLayer, session, config) {
	        if (!this.regExp)
	            return;
	        var start = config.firstRow, end = config.lastRow;
	
	        for (var i = start; i <= end; i++) {
	            var ranges = this.cache[i];
	            if (ranges == null) {
	                ranges = lang.getMatchOffsets(session.getLine(i), this.regExp);
	                if (ranges.length > this.MAX_RANGES)
	                    ranges = ranges.slice(0, this.MAX_RANGES);
	                ranges = ranges.map(function(match) {
	                    return new Range(i, match.offset, i, match.offset + match.length);
	                });
	                this.cache[i] = ranges.length ? ranges : "";
	            }
	
	            for (var j = ranges.length; j --; ) {
	                markerLayer.drawSingleLineMarker(
	                    html, ranges[j].toScreenRange(session), this.clazz, config);
	            }
	        }
	    };
	
	}).call(SearchHighlight.prototype);
	
	exports.SearchHighlight = SearchHighlight;
	});
	
	ace.define("ace/edit_session/fold_line",["require","exports","module","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	function FoldLine(foldData, folds) {
	    this.foldData = foldData;
	    if (Array.isArray(folds)) {
	        this.folds = folds;
	    } else {
	        folds = this.folds = [ folds ];
	    }
	
	    var last = folds[folds.length - 1];
	    this.range = new Range(folds[0].start.row, folds[0].start.column,
	                           last.end.row, last.end.column);
	    this.start = this.range.start;
	    this.end   = this.range.end;
	
	    this.folds.forEach(function(fold) {
	        fold.setFoldLine(this);
	    }, this);
	}
	
	(function() {
	    this.shiftRow = function(shift) {
	        this.start.row += shift;
	        this.end.row += shift;
	        this.folds.forEach(function(fold) {
	            fold.start.row += shift;
	            fold.end.row += shift;
	        });
	    };
	
	    this.addFold = function(fold) {
	        if (fold.sameRow) {
	            if (fold.start.row < this.startRow || fold.endRow > this.endRow) {
	                throw new Error("Can't add a fold to this FoldLine as it has no connection");
	            }
	            this.folds.push(fold);
	            this.folds.sort(function(a, b) {
	                return -a.range.compareEnd(b.start.row, b.start.column);
	            });
	            if (this.range.compareEnd(fold.start.row, fold.start.column) > 0) {
	                this.end.row = fold.end.row;
	                this.end.column =  fold.end.column;
	            } else if (this.range.compareStart(fold.end.row, fold.end.column) < 0) {
	                this.start.row = fold.start.row;
	                this.start.column = fold.start.column;
	            }
	        } else if (fold.start.row == this.end.row) {
	            this.folds.push(fold);
	            this.end.row = fold.end.row;
	            this.end.column = fold.end.column;
	        } else if (fold.end.row == this.start.row) {
	            this.folds.unshift(fold);
	            this.start.row = fold.start.row;
	            this.start.column = fold.start.column;
	        } else {
	            throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
	        }
	        fold.foldLine = this;
	    };
	
	    this.containsRow = function(row) {
	        return row >= this.start.row && row <= this.end.row;
	    };
	
	    this.walk = function(callback, endRow, endColumn) {
	        var lastEnd = 0,
	            folds = this.folds,
	            fold,
	            cmp, stop, isNewRow = true;
	
	        if (endRow == null) {
	            endRow = this.end.row;
	            endColumn = this.end.column;
	        }
	
	        for (var i = 0; i < folds.length; i++) {
	            fold = folds[i];
	
	            cmp = fold.range.compareStart(endRow, endColumn);
	            if (cmp == -1) {
	                callback(null, endRow, endColumn, lastEnd, isNewRow);
	                return;
	            }
	
	            stop = callback(null, fold.start.row, fold.start.column, lastEnd, isNewRow);
	            stop = !stop && callback(fold.placeholder, fold.start.row, fold.start.column, lastEnd);
	            if (stop || cmp === 0) {
	                return;
	            }
	            isNewRow = !fold.sameRow;
	            lastEnd = fold.end.column;
	        }
	        callback(null, endRow, endColumn, lastEnd, isNewRow);
	    };
	
	    this.getNextFoldTo = function(row, column) {
	        var fold, cmp;
	        for (var i = 0; i < this.folds.length; i++) {
	            fold = this.folds[i];
	            cmp = fold.range.compareEnd(row, column);
	            if (cmp == -1) {
	                return {
	                    fold: fold,
	                    kind: "after"
	                };
	            } else if (cmp === 0) {
	                return {
	                    fold: fold,
	                    kind: "inside"
	                };
	            }
	        }
	        return null;
	    };
	
	    this.addRemoveChars = function(row, column, len) {
	        var ret = this.getNextFoldTo(row, column),
	            fold, folds;
	        if (ret) {
	            fold = ret.fold;
	            if (ret.kind == "inside"
	                && fold.start.column != column
	                && fold.start.row != row)
	            {
	                window.console && window.console.log(row, column, fold);
	            } else if (fold.start.row == row) {
	                folds = this.folds;
	                var i = folds.indexOf(fold);
	                if (i === 0) {
	                    this.start.column += len;
	                }
	                for (i; i < folds.length; i++) {
	                    fold = folds[i];
	                    fold.start.column += len;
	                    if (!fold.sameRow) {
	                        return;
	                    }
	                    fold.end.column += len;
	                }
	                this.end.column += len;
	            }
	        }
	    };
	
	    this.split = function(row, column) {
	        var pos = this.getNextFoldTo(row, column);
	        
	        if (!pos || pos.kind == "inside")
	            return null;
	            
	        var fold = pos.fold;
	        var folds = this.folds;
	        var foldData = this.foldData;
	        
	        var i = folds.indexOf(fold);
	        var foldBefore = folds[i - 1];
	        this.end.row = foldBefore.end.row;
	        this.end.column = foldBefore.end.column;
	        folds = folds.splice(i, folds.length - i);
	
	        var newFoldLine = new FoldLine(foldData, folds);
	        foldData.splice(foldData.indexOf(this) + 1, 0, newFoldLine);
	        return newFoldLine;
	    };
	
	    this.merge = function(foldLineNext) {
	        var folds = foldLineNext.folds;
	        for (var i = 0; i < folds.length; i++) {
	            this.addFold(folds[i]);
	        }
	        var foldData = this.foldData;
	        foldData.splice(foldData.indexOf(foldLineNext), 1);
	    };
	
	    this.toString = function() {
	        var ret = [this.range.toString() + ": [" ];
	
	        this.folds.forEach(function(fold) {
	            ret.push("  " + fold.toString());
	        });
	        ret.push("]");
	        return ret.join("\n");
	    };
	
	    this.idxToPosition = function(idx) {
	        var lastFoldEndColumn = 0;
	
	        for (var i = 0; i < this.folds.length; i++) {
	            var fold = this.folds[i];
	
	            idx -= fold.start.column - lastFoldEndColumn;
	            if (idx < 0) {
	                return {
	                    row: fold.start.row,
	                    column: fold.start.column + idx
	                };
	            }
	
	            idx -= fold.placeholder.length;
	            if (idx < 0) {
	                return fold.start;
	            }
	
	            lastFoldEndColumn = fold.end.column;
	        }
	
	        return {
	            row: this.end.row,
	            column: this.end.column + idx
	        };
	    };
	}).call(FoldLine.prototype);
	
	exports.FoldLine = FoldLine;
	});
	
	ace.define("ace/range_list",["require","exports","module","ace/range"], function(acequire, exports, module) {
	"use strict";
	var Range = acequire("./range").Range;
	var comparePoints = Range.comparePoints;
	
	var RangeList = function() {
	    this.ranges = [];
	};
	
	(function() {
	    this.comparePoints = comparePoints;
	
	    this.pointIndex = function(pos, excludeEdges, startIndex) {
	        var list = this.ranges;
	
	        for (var i = startIndex || 0; i < list.length; i++) {
	            var range = list[i];
	            var cmpEnd = comparePoints(pos, range.end);
	            if (cmpEnd > 0)
	                continue;
	            var cmpStart = comparePoints(pos, range.start);
	            if (cmpEnd === 0)
	                return excludeEdges && cmpStart !== 0 ? -i-2 : i;
	            if (cmpStart > 0 || (cmpStart === 0 && !excludeEdges))
	                return i;
	
	            return -i-1;
	        }
	        return -i - 1;
	    };
	
	    this.add = function(range) {
	        var excludeEdges = !range.isEmpty();
	        var startIndex = this.pointIndex(range.start, excludeEdges);
	        if (startIndex < 0)
	            startIndex = -startIndex - 1;
	
	        var endIndex = this.pointIndex(range.end, excludeEdges, startIndex);
	
	        if (endIndex < 0)
	            endIndex = -endIndex - 1;
	        else
	            endIndex++;
	        return this.ranges.splice(startIndex, endIndex - startIndex, range);
	    };
	
	    this.addList = function(list) {
	        var removed = [];
	        for (var i = list.length; i--; ) {
	            removed.push.apply(removed, this.add(list[i]));
	        }
	        return removed;
	    };
	
	    this.substractPoint = function(pos) {
	        var i = this.pointIndex(pos);
	
	        if (i >= 0)
	            return this.ranges.splice(i, 1);
	    };
	    this.merge = function() {
	        var removed = [];
	        var list = this.ranges;
	        
	        list = list.sort(function(a, b) {
	            return comparePoints(a.start, b.start);
	        });
	        
	        var next = list[0], range;
	        for (var i = 1; i < list.length; i++) {
	            range = next;
	            next = list[i];
	            var cmp = comparePoints(range.end, next.start);
	            if (cmp < 0)
	                continue;
	
	            if (cmp == 0 && !range.isEmpty() && !next.isEmpty())
	                continue;
	
	            if (comparePoints(range.end, next.end) < 0) {
	                range.end.row = next.end.row;
	                range.end.column = next.end.column;
	            }
	
	            list.splice(i, 1);
	            removed.push(next);
	            next = range;
	            i--;
	        }
	        
	        this.ranges = list;
	
	        return removed;
	    };
	
	    this.contains = function(row, column) {
	        return this.pointIndex({row: row, column: column}) >= 0;
	    };
	
	    this.containsPoint = function(pos) {
	        return this.pointIndex(pos) >= 0;
	    };
	
	    this.rangeAtPoint = function(pos) {
	        var i = this.pointIndex(pos);
	        if (i >= 0)
	            return this.ranges[i];
	    };
	
	
	    this.clipRows = function(startRow, endRow) {
	        var list = this.ranges;
	        if (list[0].start.row > endRow || list[list.length - 1].start.row < startRow)
	            return [];
	
	        var startIndex = this.pointIndex({row: startRow, column: 0});
	        if (startIndex < 0)
	            startIndex = -startIndex - 1;
	        var endIndex = this.pointIndex({row: endRow, column: 0}, startIndex);
	        if (endIndex < 0)
	            endIndex = -endIndex - 1;
	
	        var clipped = [];
	        for (var i = startIndex; i < endIndex; i++) {
	            clipped.push(list[i]);
	        }
	        return clipped;
	    };
	
	    this.removeAll = function() {
	        return this.ranges.splice(0, this.ranges.length);
	    };
	
	    this.attach = function(session) {
	        if (this.session)
	            this.detach();
	
	        this.session = session;
	        this.onChange = this.$onChange.bind(this);
	
	        this.session.on('change', this.onChange);
	    };
	
	    this.detach = function() {
	        if (!this.session)
	            return;
	        this.session.removeListener('change', this.onChange);
	        this.session = null;
	    };
	
	    this.$onChange = function(delta) {
	        if (delta.action == "insert"){
	            var start = delta.start;
	            var end = delta.end;
	        } else {
	            var end = delta.start;
	            var start = delta.end;
	        }
	        var startRow = start.row;
	        var endRow = end.row;
	        var lineDif = endRow - startRow;
	
	        var colDiff = -start.column + end.column;
	        var ranges = this.ranges;
	
	        for (var i = 0, n = ranges.length; i < n; i++) {
	            var r = ranges[i];
	            if (r.end.row < startRow)
	                continue;
	            if (r.start.row > startRow)
	                break;
	
	            if (r.start.row == startRow && r.start.column >= start.column ) {
	                if (r.start.column == start.column && this.$insertRight) {
	                } else {
	                    r.start.column += colDiff;
	                    r.start.row += lineDif;
	                }
	            }
	            if (r.end.row == startRow && r.end.column >= start.column) {
	                if (r.end.column == start.column && this.$insertRight) {
	                    continue;
	                }
	                if (r.end.column == start.column && colDiff > 0 && i < n - 1) {                
	                    if (r.end.column > r.start.column && r.end.column == ranges[i+1].start.column)
	                        r.end.column -= colDiff;
	                }
	                r.end.column += colDiff;
	                r.end.row += lineDif;
	            }
	        }
	
	        if (lineDif != 0 && i < n) {
	            for (; i < n; i++) {
	                var r = ranges[i];
	                r.start.row += lineDif;
	                r.end.row += lineDif;
	            }
	        }
	    };
	
	}).call(RangeList.prototype);
	
	exports.RangeList = RangeList;
	});
	
	ace.define("ace/edit_session/fold",["require","exports","module","ace/range","ace/range_list","ace/lib/oop"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	var RangeList = acequire("../range_list").RangeList;
	var oop = acequire("../lib/oop")
	var Fold = exports.Fold = function(range, placeholder) {
	    this.foldLine = null;
	    this.placeholder = placeholder;
	    this.range = range;
	    this.start = range.start;
	    this.end = range.end;
	
	    this.sameRow = range.start.row == range.end.row;
	    this.subFolds = this.ranges = [];
	};
	
	oop.inherits(Fold, RangeList);
	
	(function() {
	
	    this.toString = function() {
	        return '"' + this.placeholder + '" ' + this.range.toString();
	    };
	
	    this.setFoldLine = function(foldLine) {
	        this.foldLine = foldLine;
	        this.subFolds.forEach(function(fold) {
	            fold.setFoldLine(foldLine);
	        });
	    };
	
	    this.clone = function() {
	        var range = this.range.clone();
	        var fold = new Fold(range, this.placeholder);
	        this.subFolds.forEach(function(subFold) {
	            fold.subFolds.push(subFold.clone());
	        });
	        fold.collapseChildren = this.collapseChildren;
	        return fold;
	    };
	
	    this.addSubFold = function(fold) {
	        if (this.range.isEqual(fold))
	            return;
	
	        if (!this.range.containsRange(fold))
	            throw new Error("A fold can't intersect already existing fold" + fold.range + this.range);
	        consumeRange(fold, this.start);
	
	        var row = fold.start.row, column = fold.start.column;
	        for (var i = 0, cmp = -1; i < this.subFolds.length; i++) {
	            cmp = this.subFolds[i].range.compare(row, column);
	            if (cmp != 1)
	                break;
	        }
	        var afterStart = this.subFolds[i];
	
	        if (cmp == 0)
	            return afterStart.addSubFold(fold);
	        var row = fold.range.end.row, column = fold.range.end.column;
	        for (var j = i, cmp = -1; j < this.subFolds.length; j++) {
	            cmp = this.subFolds[j].range.compare(row, column);
	            if (cmp != 1)
	                break;
	        }
	        var afterEnd = this.subFolds[j];
	
	        if (cmp == 0)
	            throw new Error("A fold can't intersect already existing fold" + fold.range + this.range);
	
	        var consumedFolds = this.subFolds.splice(i, j - i, fold);
	        fold.setFoldLine(this.foldLine);
	
	        return fold;
	    };
	    
	    this.restoreRange = function(range) {
	        return restoreRange(range, this.start);
	    };
	
	}).call(Fold.prototype);
	
	function consumePoint(point, anchor) {
	    point.row -= anchor.row;
	    if (point.row == 0)
	        point.column -= anchor.column;
	}
	function consumeRange(range, anchor) {
	    consumePoint(range.start, anchor);
	    consumePoint(range.end, anchor);
	}
	function restorePoint(point, anchor) {
	    if (point.row == 0)
	        point.column += anchor.column;
	    point.row += anchor.row;
	}
	function restoreRange(range, anchor) {
	    restorePoint(range.start, anchor);
	    restorePoint(range.end, anchor);
	}
	
	});
	
	ace.define("ace/edit_session/folding",["require","exports","module","ace/range","ace/edit_session/fold_line","ace/edit_session/fold","ace/token_iterator"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	var FoldLine = acequire("./fold_line").FoldLine;
	var Fold = acequire("./fold").Fold;
	var TokenIterator = acequire("../token_iterator").TokenIterator;
	
	function Folding() {
	    this.getFoldAt = function(row, column, side) {
	        var foldLine = this.getFoldLine(row);
	        if (!foldLine)
	            return null;
	
	        var folds = foldLine.folds;
	        for (var i = 0; i < folds.length; i++) {
	            var fold = folds[i];
	            if (fold.range.contains(row, column)) {
	                if (side == 1 && fold.range.isEnd(row, column)) {
	                    continue;
	                } else if (side == -1 && fold.range.isStart(row, column)) {
	                    continue;
	                }
	                return fold;
	            }
	        }
	    };
	    this.getFoldsInRange = function(range) {
	        var start = range.start;
	        var end = range.end;
	        var foldLines = this.$foldData;
	        var foundFolds = [];
	
	        start.column += 1;
	        end.column -= 1;
	
	        for (var i = 0; i < foldLines.length; i++) {
	            var cmp = foldLines[i].range.compareRange(range);
	            if (cmp == 2) {
	                continue;
	            }
	            else if (cmp == -2) {
	                break;
	            }
	
	            var folds = foldLines[i].folds;
	            for (var j = 0; j < folds.length; j++) {
	                var fold = folds[j];
	                cmp = fold.range.compareRange(range);
	                if (cmp == -2) {
	                    break;
	                } else if (cmp == 2) {
	                    continue;
	                } else
	                if (cmp == 42) {
	                    break;
	                }
	                foundFolds.push(fold);
	            }
	        }
	        start.column -= 1;
	        end.column += 1;
	
	        return foundFolds;
	    };
	
	    this.getFoldsInRangeList = function(ranges) {
	        if (Array.isArray(ranges)) {
	            var folds = [];
	            ranges.forEach(function(range) {
	                folds = folds.concat(this.getFoldsInRange(range));
	            }, this);
	        } else {
	            var folds = this.getFoldsInRange(ranges);
	        }
	        return folds;
	    };
	    this.getAllFolds = function() {
	        var folds = [];
	        var foldLines = this.$foldData;
	        
	        for (var i = 0; i < foldLines.length; i++)
	            for (var j = 0; j < foldLines[i].folds.length; j++)
	                folds.push(foldLines[i].folds[j]);
	
	        return folds;
	    };
	    this.getFoldStringAt = function(row, column, trim, foldLine) {
	        foldLine = foldLine || this.getFoldLine(row);
	        if (!foldLine)
	            return null;
	
	        var lastFold = {
	            end: { column: 0 }
	        };
	        var str, fold;
	        for (var i = 0; i < foldLine.folds.length; i++) {
	            fold = foldLine.folds[i];
	            var cmp = fold.range.compareEnd(row, column);
	            if (cmp == -1) {
	                str = this
	                    .getLine(fold.start.row)
	                    .substring(lastFold.end.column, fold.start.column);
	                break;
	            }
	            else if (cmp === 0) {
	                return null;
	            }
	            lastFold = fold;
	        }
	        if (!str)
	            str = this.getLine(fold.start.row).substring(lastFold.end.column);
	
	        if (trim == -1)
	            return str.substring(0, column - lastFold.end.column);
	        else if (trim == 1)
	            return str.substring(column - lastFold.end.column);
	        else
	            return str;
	    };
	
	    this.getFoldLine = function(docRow, startFoldLine) {
	        var foldData = this.$foldData;
	        var i = 0;
	        if (startFoldLine)
	            i = foldData.indexOf(startFoldLine);
	        if (i == -1)
	            i = 0;
	        for (i; i < foldData.length; i++) {
	            var foldLine = foldData[i];
	            if (foldLine.start.row <= docRow && foldLine.end.row >= docRow) {
	                return foldLine;
	            } else if (foldLine.end.row > docRow) {
	                return null;
	            }
	        }
	        return null;
	    };
	    this.getNextFoldLine = function(docRow, startFoldLine) {
	        var foldData = this.$foldData;
	        var i = 0;
	        if (startFoldLine)
	            i = foldData.indexOf(startFoldLine);
	        if (i == -1)
	            i = 0;
	        for (i; i < foldData.length; i++) {
	            var foldLine = foldData[i];
	            if (foldLine.end.row >= docRow) {
	                return foldLine;
	            }
	        }
	        return null;
	    };
	
	    this.getFoldedRowCount = function(first, last) {
	        var foldData = this.$foldData, rowCount = last-first+1;
	        for (var i = 0; i < foldData.length; i++) {
	            var foldLine = foldData[i],
	                end = foldLine.end.row,
	                start = foldLine.start.row;
	            if (end >= last) {
	                if (start < last) {
	                    if (start >= first)
	                        rowCount -= last-start;
	                    else
	                        rowCount = 0; // in one fold
	                }
	                break;
	            } else if (end >= first){
	                if (start >= first) // fold inside range
	                    rowCount -=  end-start;
	                else
	                    rowCount -=  end-first+1;
	            }
	        }
	        return rowCount;
	    };
	
	    this.$addFoldLine = function(foldLine) {
	        this.$foldData.push(foldLine);
	        this.$foldData.sort(function(a, b) {
	            return a.start.row - b.start.row;
	        });
	        return foldLine;
	    };
	    this.addFold = function(placeholder, range) {
	        var foldData = this.$foldData;
	        var added = false;
	        var fold;
	        
	        if (placeholder instanceof Fold)
	            fold = placeholder;
	        else {
	            fold = new Fold(range, placeholder);
	            fold.collapseChildren = range.collapseChildren;
	        }
	        this.$clipRangeToDocument(fold.range);
	
	        var startRow = fold.start.row;
	        var startColumn = fold.start.column;
	        var endRow = fold.end.row;
	        var endColumn = fold.end.column;
	        if (!(startRow < endRow || 
	            startRow == endRow && startColumn <= endColumn - 2))
	            throw new Error("The range has to be at least 2 characters width");
	
	        var startFold = this.getFoldAt(startRow, startColumn, 1);
	        var endFold = this.getFoldAt(endRow, endColumn, -1);
	        if (startFold && endFold == startFold)
	            return startFold.addSubFold(fold);
	
	        if (startFold && !startFold.range.isStart(startRow, startColumn))
	            this.removeFold(startFold);
	        
	        if (endFold && !endFold.range.isEnd(endRow, endColumn))
	            this.removeFold(endFold);
	        var folds = this.getFoldsInRange(fold.range);
	        if (folds.length > 0) {
	            this.removeFolds(folds);
	            folds.forEach(function(subFold) {
	                fold.addSubFold(subFold);
	            });
	        }
	
	        for (var i = 0; i < foldData.length; i++) {
	            var foldLine = foldData[i];
	            if (endRow == foldLine.start.row) {
	                foldLine.addFold(fold);
	                added = true;
	                break;
	            } else if (startRow == foldLine.end.row) {
	                foldLine.addFold(fold);
	                added = true;
	                if (!fold.sameRow) {
	                    var foldLineNext = foldData[i + 1];
	                    if (foldLineNext && foldLineNext.start.row == endRow) {
	                        foldLine.merge(foldLineNext);
	                        break;
	                    }
	                }
	                break;
	            } else if (endRow <= foldLine.start.row) {
	                break;
	            }
	        }
	
	        if (!added)
	            foldLine = this.$addFoldLine(new FoldLine(this.$foldData, fold));
	
	        if (this.$useWrapMode)
	            this.$updateWrapData(foldLine.start.row, foldLine.start.row);
	        else
	            this.$updateRowLengthCache(foldLine.start.row, foldLine.start.row);
	        this.$modified = true;
	        this._signal("changeFold", { data: fold, action: "add" });
	
	        return fold;
	    };
	
	    this.addFolds = function(folds) {
	        folds.forEach(function(fold) {
	            this.addFold(fold);
	        }, this);
	    };
	
	    this.removeFold = function(fold) {
	        var foldLine = fold.foldLine;
	        var startRow = foldLine.start.row;
	        var endRow = foldLine.end.row;
	
	        var foldLines = this.$foldData;
	        var folds = foldLine.folds;
	        if (folds.length == 1) {
	            foldLines.splice(foldLines.indexOf(foldLine), 1);
	        } else
	        if (foldLine.range.isEnd(fold.end.row, fold.end.column)) {
	            folds.pop();
	            foldLine.end.row = folds[folds.length - 1].end.row;
	            foldLine.end.column = folds[folds.length - 1].end.column;
	        } else
	        if (foldLine.range.isStart(fold.start.row, fold.start.column)) {
	            folds.shift();
	            foldLine.start.row = folds[0].start.row;
	            foldLine.start.column = folds[0].start.column;
	        } else
	        if (fold.sameRow) {
	            folds.splice(folds.indexOf(fold), 1);
	        } else
	        {
	            var newFoldLine = foldLine.split(fold.start.row, fold.start.column);
	            folds = newFoldLine.folds;
	            folds.shift();
	            newFoldLine.start.row = folds[0].start.row;
	            newFoldLine.start.column = folds[0].start.column;
	        }
	
	        if (!this.$updating) {
	            if (this.$useWrapMode)
	                this.$updateWrapData(startRow, endRow);
	            else
	                this.$updateRowLengthCache(startRow, endRow);
	        }
	        this.$modified = true;
	        this._signal("changeFold", { data: fold, action: "remove" });
	    };
	
	    this.removeFolds = function(folds) {
	        var cloneFolds = [];
	        for (var i = 0; i < folds.length; i++) {
	            cloneFolds.push(folds[i]);
	        }
	
	        cloneFolds.forEach(function(fold) {
	            this.removeFold(fold);
	        }, this);
	        this.$modified = true;
	    };
	
	    this.expandFold = function(fold) {
	        this.removeFold(fold);
	        fold.subFolds.forEach(function(subFold) {
	            fold.restoreRange(subFold);
	            this.addFold(subFold);
	        }, this);
	        if (fold.collapseChildren > 0) {
	            this.foldAll(fold.start.row+1, fold.end.row, fold.collapseChildren-1);
	        }
	        fold.subFolds = [];
	    };
	
	    this.expandFolds = function(folds) {
	        folds.forEach(function(fold) {
	            this.expandFold(fold);
	        }, this);
	    };
	
	    this.unfold = function(location, expandInner) {
	        var range, folds;
	        if (location == null) {
	            range = new Range(0, 0, this.getLength(), 0);
	            expandInner = true;
	        } else if (typeof location == "number")
	            range = new Range(location, 0, location, this.getLine(location).length);
	        else if ("row" in location)
	            range = Range.fromPoints(location, location);
	        else
	            range = location;
	        
	        folds = this.getFoldsInRangeList(range);
	        if (expandInner) {
	            this.removeFolds(folds);
	        } else {
	            var subFolds = folds;
	            while (subFolds.length) {
	                this.expandFolds(subFolds);
	                subFolds = this.getFoldsInRangeList(range);
	            }
	        }
	        if (folds.length)
	            return folds;
	    };
	    this.isRowFolded = function(docRow, startFoldRow) {
	        return !!this.getFoldLine(docRow, startFoldRow);
	    };
	
	    this.getRowFoldEnd = function(docRow, startFoldRow) {
	        var foldLine = this.getFoldLine(docRow, startFoldRow);
	        return foldLine ? foldLine.end.row : docRow;
	    };
	
	    this.getRowFoldStart = function(docRow, startFoldRow) {
	        var foldLine = this.getFoldLine(docRow, startFoldRow);
	        return foldLine ? foldLine.start.row : docRow;
	    };
	
	    this.getFoldDisplayLine = function(foldLine, endRow, endColumn, startRow, startColumn) {
	        if (startRow == null)
	            startRow = foldLine.start.row;
	        if (startColumn == null)
	            startColumn = 0;
	        if (endRow == null)
	            endRow = foldLine.end.row;
	        if (endColumn == null)
	            endColumn = this.getLine(endRow).length;
	        var doc = this.doc;
	        var textLine = "";
	
	        foldLine.walk(function(placeholder, row, column, lastColumn) {
	            if (row < startRow)
	                return;
	            if (row == startRow) {
	                if (column < startColumn)
	                    return;
	                lastColumn = Math.max(startColumn, lastColumn);
	            }
	
	            if (placeholder != null) {
	                textLine += placeholder;
	            } else {
	                textLine += doc.getLine(row).substring(lastColumn, column);
	            }
	        }, endRow, endColumn);
	        return textLine;
	    };
	
	    this.getDisplayLine = function(row, endColumn, startRow, startColumn) {
	        var foldLine = this.getFoldLine(row);
	
	        if (!foldLine) {
	            var line;
	            line = this.doc.getLine(row);
	            return line.substring(startColumn || 0, endColumn || line.length);
	        } else {
	            return this.getFoldDisplayLine(
	                foldLine, row, endColumn, startRow, startColumn);
	        }
	    };
	
	    this.$cloneFoldData = function() {
	        var fd = [];
	        fd = this.$foldData.map(function(foldLine) {
	            var folds = foldLine.folds.map(function(fold) {
	                return fold.clone();
	            });
	            return new FoldLine(fd, folds);
	        });
	
	        return fd;
	    };
	
	    this.toggleFold = function(tryToUnfold) {
	        var selection = this.selection;
	        var range = selection.getRange();
	        var fold;
	        var bracketPos;
	
	        if (range.isEmpty()) {
	            var cursor = range.start;
	            fold = this.getFoldAt(cursor.row, cursor.column);
	
	            if (fold) {
	                this.expandFold(fold);
	                return;
	            } else if (bracketPos = this.findMatchingBracket(cursor)) {
	                if (range.comparePoint(bracketPos) == 1) {
	                    range.end = bracketPos;
	                } else {
	                    range.start = bracketPos;
	                    range.start.column++;
	                    range.end.column--;
	                }
	            } else if (bracketPos = this.findMatchingBracket({row: cursor.row, column: cursor.column + 1})) {
	                if (range.comparePoint(bracketPos) == 1)
	                    range.end = bracketPos;
	                else
	                    range.start = bracketPos;
	
	                range.start.column++;
	            } else {
	                range = this.getCommentFoldRange(cursor.row, cursor.column) || range;
	            }
	        } else {
	            var folds = this.getFoldsInRange(range);
	            if (tryToUnfold && folds.length) {
	                this.expandFolds(folds);
	                return;
	            } else if (folds.length == 1 ) {
	                fold = folds[0];
	            }
	        }
	
	        if (!fold)
	            fold = this.getFoldAt(range.start.row, range.start.column);
	
	        if (fold && fold.range.toString() == range.toString()) {
	            this.expandFold(fold);
	            return;
	        }
	
	        var placeholder = "...";
	        if (!range.isMultiLine()) {
	            placeholder = this.getTextRange(range);
	            if (placeholder.length < 4)
	                return;
	            placeholder = placeholder.trim().substring(0, 2) + "..";
	        }
	
	        this.addFold(placeholder, range);
	    };
	
	    this.getCommentFoldRange = function(row, column, dir) {
	        var iterator = new TokenIterator(this, row, column);
	        var token = iterator.getCurrentToken();
	        if (token && /^comment|string/.test(token.type)) {
	            var range = new Range();
	            var re = new RegExp(token.type.replace(/\..*/, "\\."));
	            if (dir != 1) {
	                do {
	                    token = iterator.stepBackward();
	                } while (token && re.test(token.type));
	                iterator.stepForward();
	            }
	            
	            range.start.row = iterator.getCurrentTokenRow();
	            range.start.column = iterator.getCurrentTokenColumn() + 2;
	
	            iterator = new TokenIterator(this, row, column);
	            
	            if (dir != -1) {
	                do {
	                    token = iterator.stepForward();
	                } while (token && re.test(token.type));
	                token = iterator.stepBackward();
	            } else
	                token = iterator.getCurrentToken();
	
	            range.end.row = iterator.getCurrentTokenRow();
	            range.end.column = iterator.getCurrentTokenColumn() + token.value.length - 2;
	            return range;
	        }
	    };
	
	    this.foldAll = function(startRow, endRow, depth) {
	        if (depth == undefined)
	            depth = 100000; // JSON.stringify doesn't hanle Infinity
	        var foldWidgets = this.foldWidgets;
	        if (!foldWidgets)
	            return; // mode doesn't support folding
	        endRow = endRow || this.getLength();
	        startRow = startRow || 0;
	        for (var row = startRow; row < endRow; row++) {
	            if (foldWidgets[row] == null)
	                foldWidgets[row] = this.getFoldWidget(row);
	            if (foldWidgets[row] != "start")
	                continue;
	
	            var range = this.getFoldWidgetRange(row);
	            if (range && range.isMultiLine()
	                && range.end.row <= endRow
	                && range.start.row >= startRow
	            ) {
	                row = range.end.row;
	                try {
	                    var fold = this.addFold("...", range);
	                    if (fold)
	                        fold.collapseChildren = depth;
	                } catch(e) {}
	            }
	        }
	    };
	    this.$foldStyles = {
	        "manual": 1,
	        "markbegin": 1,
	        "markbeginend": 1
	    };
	    this.$foldStyle = "markbegin";
	    this.setFoldStyle = function(style) {
	        if (!this.$foldStyles[style])
	            throw new Error("invalid fold style: " + style + "[" + Object.keys(this.$foldStyles).join(", ") + "]");
	        
	        if (this.$foldStyle == style)
	            return;
	
	        this.$foldStyle = style;
	        
	        if (style == "manual")
	            this.unfold();
	        var mode = this.$foldMode;
	        this.$setFolding(null);
	        this.$setFolding(mode);
	    };
	
	    this.$setFolding = function(foldMode) {
	        if (this.$foldMode == foldMode)
	            return;
	            
	        this.$foldMode = foldMode;
	        
	        this.off('change', this.$updateFoldWidgets);
	        this.off('tokenizerUpdate', this.$tokenizerUpdateFoldWidgets);
	        this._signal("changeAnnotation");
	        
	        if (!foldMode || this.$foldStyle == "manual") {
	            this.foldWidgets = null;
	            return;
	        }
	        
	        this.foldWidgets = [];
	        this.getFoldWidget = foldMode.getFoldWidget.bind(foldMode, this, this.$foldStyle);
	        this.getFoldWidgetRange = foldMode.getFoldWidgetRange.bind(foldMode, this, this.$foldStyle);
	        
	        this.$updateFoldWidgets = this.updateFoldWidgets.bind(this);
	        this.$tokenizerUpdateFoldWidgets = this.tokenizerUpdateFoldWidgets.bind(this);
	        this.on('change', this.$updateFoldWidgets);
	        this.on('tokenizerUpdate', this.$tokenizerUpdateFoldWidgets);
	    };
	
	    this.getParentFoldRangeData = function (row, ignoreCurrent) {
	        var fw = this.foldWidgets;
	        if (!fw || (ignoreCurrent && fw[row]))
	            return {};
	
	        var i = row - 1, firstRange;
	        while (i >= 0) {
	            var c = fw[i];
	            if (c == null)
	                c = fw[i] = this.getFoldWidget(i);
	
	            if (c == "start") {
	                var range = this.getFoldWidgetRange(i);
	                if (!firstRange)
	                    firstRange = range;
	                if (range && range.end.row >= row)
	                    break;
	            }
	            i--;
	        }
	
	        return {
	            range: i !== -1 && range,
	            firstRange: firstRange
	        };
	    };
	
	    this.onFoldWidgetClick = function(row, e) {
	        e = e.domEvent;
	        var options = {
	            children: e.shiftKey,
	            all: e.ctrlKey || e.metaKey,
	            siblings: e.altKey
	        };
	        
	        var range = this.$toggleFoldWidget(row, options);
	        if (!range) {
	            var el = (e.target || e.srcElement);
	            if (el && /ace_fold-widget/.test(el.className))
	                el.className += " ace_invalid";
	        }
	    };
	    
	    this.$toggleFoldWidget = function(row, options) {
	        if (!this.getFoldWidget)
	            return;
	        var type = this.getFoldWidget(row);
	        var line = this.getLine(row);
	
	        var dir = type === "end" ? -1 : 1;
	        var fold = this.getFoldAt(row, dir === -1 ? 0 : line.length, dir);
	
	        if (fold) {
	            if (options.children || options.all)
	                this.removeFold(fold);
	            else
	                this.expandFold(fold);
	            return fold;
	        }
	
	        var range = this.getFoldWidgetRange(row, true);
	        if (range && !range.isMultiLine()) {
	            fold = this.getFoldAt(range.start.row, range.start.column, 1);
	            if (fold && range.isEqual(fold.range)) {
	                this.removeFold(fold);
	                return fold;
	            }
	        }
	        
	        if (options.siblings) {
	            var data = this.getParentFoldRangeData(row);
	            if (data.range) {
	                var startRow = data.range.start.row + 1;
	                var endRow = data.range.end.row;
	            }
	            this.foldAll(startRow, endRow, options.all ? 10000 : 0);
	        } else if (options.children) {
	            endRow = range ? range.end.row : this.getLength();
	            this.foldAll(row + 1, endRow, options.all ? 10000 : 0);
	        } else if (range) {
	            if (options.all) 
	                range.collapseChildren = 10000;
	            this.addFold("...", range);
	        }
	        
	        return range;
	    };
	    
	    
	    
	    this.toggleFoldWidget = function(toggleParent) {
	        var row = this.selection.getCursor().row;
	        row = this.getRowFoldStart(row);
	        var range = this.$toggleFoldWidget(row, {});
	        
	        if (range)
	            return;
	        var data = this.getParentFoldRangeData(row, true);
	        range = data.range || data.firstRange;
	        
	        if (range) {
	            row = range.start.row;
	            var fold = this.getFoldAt(row, this.getLine(row).length, 1);
	
	            if (fold) {
	                this.removeFold(fold);
	            } else {
	                this.addFold("...", range);
	            }
	        }
	    };
	
	    this.updateFoldWidgets = function(delta) {
	        var firstRow = delta.start.row;
	        var len = delta.end.row - firstRow;
	
	        if (len === 0) {
	            this.foldWidgets[firstRow] = null;
	        } else if (delta.action == 'remove') {
	            this.foldWidgets.splice(firstRow, len + 1, null);
	        } else {
	            var args = Array(len + 1);
	            args.unshift(firstRow, 1);
	            this.foldWidgets.splice.apply(this.foldWidgets, args);
	        }
	    };
	    this.tokenizerUpdateFoldWidgets = function(e) {
	        var rows = e.data;
	        if (rows.first != rows.last) {
	            if (this.foldWidgets.length > rows.first)
	                this.foldWidgets.splice(rows.first, this.foldWidgets.length);
	        }
	    };
	}
	
	exports.Folding = Folding;
	
	});
	
	ace.define("ace/edit_session/bracket_match",["require","exports","module","ace/token_iterator","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var TokenIterator = acequire("../token_iterator").TokenIterator;
	var Range = acequire("../range").Range;
	
	
	function BracketMatch() {
	
	    this.findMatchingBracket = function(position, chr) {
	        if (position.column == 0) return null;
	
	        var charBeforeCursor = chr || this.getLine(position.row).charAt(position.column-1);
	        if (charBeforeCursor == "") return null;
	
	        var match = charBeforeCursor.match(/([\(\[\{])|([\)\]\}])/);
	        if (!match)
	            return null;
	
	        if (match[1])
	            return this.$findClosingBracket(match[1], position);
	        else
	            return this.$findOpeningBracket(match[2], position);
	    };
	    
	    this.getBracketRange = function(pos) {
	        var line = this.getLine(pos.row);
	        var before = true, range;
	
	        var chr = line.charAt(pos.column-1);
	        var match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
	        if (!match) {
	            chr = line.charAt(pos.column);
	            pos = {row: pos.row, column: pos.column + 1};
	            match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
	            before = false;
	        }
	        if (!match)
	            return null;
	
	        if (match[1]) {
	            var bracketPos = this.$findClosingBracket(match[1], pos);
	            if (!bracketPos)
	                return null;
	            range = Range.fromPoints(pos, bracketPos);
	            if (!before) {
	                range.end.column++;
	                range.start.column--;
	            }
	            range.cursor = range.end;
	        } else {
	            var bracketPos = this.$findOpeningBracket(match[2], pos);
	            if (!bracketPos)
	                return null;
	            range = Range.fromPoints(bracketPos, pos);
	            if (!before) {
	                range.start.column++;
	                range.end.column--;
	            }
	            range.cursor = range.start;
	        }
	        
	        return range;
	    };
	
	    this.$brackets = {
	        ")": "(",
	        "(": ")",
	        "]": "[",
	        "[": "]",
	        "{": "}",
	        "}": "{"
	    };
	
	    this.$findOpeningBracket = function(bracket, position, typeRe) {
	        var openBracket = this.$brackets[bracket];
	        var depth = 1;
	
	        var iterator = new TokenIterator(this, position.row, position.column);
	        var token = iterator.getCurrentToken();
	        if (!token)
	            token = iterator.stepForward();
	        if (!token)
	            return;
	        
	         if (!typeRe){
	            typeRe = new RegExp(
	                "(\\.?" +
	                token.type.replace(".", "\\.").replace("rparen", ".paren")
	                    .replace(/\b(?:end)\b/, "(?:start|begin|end)")
	                + ")+"
	            );
	        }
	        var valueIndex = position.column - iterator.getCurrentTokenColumn() - 2;
	        var value = token.value;
	        
	        while (true) {
	        
	            while (valueIndex >= 0) {
	                var chr = value.charAt(valueIndex);
	                if (chr == openBracket) {
	                    depth -= 1;
	                    if (depth == 0) {
	                        return {row: iterator.getCurrentTokenRow(),
	                            column: valueIndex + iterator.getCurrentTokenColumn()};
	                    }
	                }
	                else if (chr == bracket) {
	                    depth += 1;
	                }
	                valueIndex -= 1;
	            }
	            do {
	                token = iterator.stepBackward();
	            } while (token && !typeRe.test(token.type));
	
	            if (token == null)
	                break;
	                
	            value = token.value;
	            valueIndex = value.length - 1;
	        }
	        
	        return null;
	    };
	
	    this.$findClosingBracket = function(bracket, position, typeRe) {
	        var closingBracket = this.$brackets[bracket];
	        var depth = 1;
	
	        var iterator = new TokenIterator(this, position.row, position.column);
	        var token = iterator.getCurrentToken();
	        if (!token)
	            token = iterator.stepForward();
	        if (!token)
	            return;
	
	        if (!typeRe){
	            typeRe = new RegExp(
	                "(\\.?" +
	                token.type.replace(".", "\\.").replace("lparen", ".paren")
	                    .replace(/\b(?:start|begin)\b/, "(?:start|begin|end)")
	                + ")+"
	            );
	        }
	        var valueIndex = position.column - iterator.getCurrentTokenColumn();
	
	        while (true) {
	
	            var value = token.value;
	            var valueLength = value.length;
	            while (valueIndex < valueLength) {
	                var chr = value.charAt(valueIndex);
	                if (chr == closingBracket) {
	                    depth -= 1;
	                    if (depth == 0) {
	                        return {row: iterator.getCurrentTokenRow(),
	                            column: valueIndex + iterator.getCurrentTokenColumn()};
	                    }
	                }
	                else if (chr == bracket) {
	                    depth += 1;
	                }
	                valueIndex += 1;
	            }
	            do {
	                token = iterator.stepForward();
	            } while (token && !typeRe.test(token.type));
	
	            if (token == null)
	                break;
	
	            valueIndex = 0;
	        }
	        
	        return null;
	    };
	}
	exports.BracketMatch = BracketMatch;
	
	});
	
	ace.define("ace/edit_session",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/config","ace/lib/event_emitter","ace/selection","ace/mode/text","ace/range","ace/document","ace/background_tokenizer","ace/search_highlight","ace/edit_session/folding","ace/edit_session/bracket_match"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("./lib/oop");
	var lang = acequire("./lib/lang");
	var config = acequire("./config");
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	var Selection = acequire("./selection").Selection;
	var TextMode = acequire("./mode/text").Mode;
	var Range = acequire("./range").Range;
	var Document = acequire("./document").Document;
	var BackgroundTokenizer = acequire("./background_tokenizer").BackgroundTokenizer;
	var SearchHighlight = acequire("./search_highlight").SearchHighlight;
	
	var EditSession = function(text, mode) {
	    this.$breakpoints = [];
	    this.$decorations = [];
	    this.$frontMarkers = {};
	    this.$backMarkers = {};
	    this.$markerId = 1;
	    this.$undoSelect = true;
	
	    this.$foldData = [];
	    this.id = "session" + (++EditSession.$uid);
	    this.$foldData.toString = function() {
	        return this.join("\n");
	    };
	    this.on("changeFold", this.onChangeFold.bind(this));
	    this.$onChange = this.onChange.bind(this);
	
	    if (typeof text != "object" || !text.getLine)
	        text = new Document(text);
	
	    this.setDocument(text);
	    this.selection = new Selection(this);
	
	    config.resetOptions(this);
	    this.setMode(mode);
	    config._signal("session", this);
	};
	
	
	(function() {
	
	    oop.implement(this, EventEmitter);
	    this.setDocument = function(doc) {
	        if (this.doc)
	            this.doc.removeListener("change", this.$onChange);
	
	        this.doc = doc;
	        doc.on("change", this.$onChange);
	
	        if (this.bgTokenizer)
	            this.bgTokenizer.setDocument(this.getDocument());
	
	        this.resetCaches();
	    };
	    this.getDocument = function() {
	        return this.doc;
	    };
	    this.$resetRowCache = function(docRow) {
	        if (!docRow) {
	            this.$docRowCache = [];
	            this.$screenRowCache = [];
	            return;
	        }
	        var l = this.$docRowCache.length;
	        var i = this.$getRowCacheIndex(this.$docRowCache, docRow) + 1;
	        if (l > i) {
	            this.$docRowCache.splice(i, l);
	            this.$screenRowCache.splice(i, l);
	        }
	    };
	
	    this.$getRowCacheIndex = function(cacheArray, val) {
	        var low = 0;
	        var hi = cacheArray.length - 1;
	
	        while (low <= hi) {
	            var mid = (low + hi) >> 1;
	            var c = cacheArray[mid];
	
	            if (val > c)
	                low = mid + 1;
	            else if (val < c)
	                hi = mid - 1;
	            else
	                return mid;
	        }
	
	        return low -1;
	    };
	
	    this.resetCaches = function() {
	        this.$modified = true;
	        this.$wrapData = [];
	        this.$rowLengthCache = [];
	        this.$resetRowCache(0);
	        if (this.bgTokenizer)
	            this.bgTokenizer.start(0);
	    };
	
	    this.onChangeFold = function(e) {
	        var fold = e.data;
	        this.$resetRowCache(fold.start.row);
	    };
	
	    this.onChange = function(delta) {
	        this.$modified = true;
	
	        this.$resetRowCache(delta.start.row);
	
	        var removedFolds = this.$updateInternalDataOnChange(delta);
	        if (!this.$fromUndo && this.$undoManager && !delta.ignore) {
	            this.$deltasDoc.push(delta);
	            if (removedFolds && removedFolds.length != 0) {
	                this.$deltasFold.push({
	                    action: "removeFolds",
	                    folds:  removedFolds
	                });
	            }
	
	            this.$informUndoManager.schedule();
	        }
	
	        this.bgTokenizer && this.bgTokenizer.$updateOnChange(delta);
	        this._signal("change", delta);
	    };
	    this.setValue = function(text) {
	        this.doc.setValue(text);
	        this.selection.moveTo(0, 0);
	
	        this.$resetRowCache(0);
	        this.$deltas = [];
	        this.$deltasDoc = [];
	        this.$deltasFold = [];
	        this.setUndoManager(this.$undoManager);
	        this.getUndoManager().reset();
	    };
	    this.getValue =
	    this.toString = function() {
	        return this.doc.getValue();
	    };
	    this.getSelection = function() {
	        return this.selection;
	    };
	    this.getState = function(row) {
	        return this.bgTokenizer.getState(row);
	    };
	    this.getTokens = function(row) {
	        return this.bgTokenizer.getTokens(row);
	    };
	    this.getTokenAt = function(row, column) {
	        var tokens = this.bgTokenizer.getTokens(row);
	        var token, c = 0;
	        if (column == null) {
	            i = tokens.length - 1;
	            c = this.getLine(row).length;
	        } else {
	            for (var i = 0; i < tokens.length; i++) {
	                c += tokens[i].value.length;
	                if (c >= column)
	                    break;
	            }
	        }
	        token = tokens[i];
	        if (!token)
	            return null;
	        token.index = i;
	        token.start = c - token.value.length;
	        return token;
	    };
	    this.setUndoManager = function(undoManager) {
	        this.$undoManager = undoManager;
	        this.$deltas = [];
	        this.$deltasDoc = [];
	        this.$deltasFold = [];
	
	        if (this.$informUndoManager)
	            this.$informUndoManager.cancel();
	
	        if (undoManager) {
	            var self = this;
	
	            this.$syncInformUndoManager = function() {
	                self.$informUndoManager.cancel();
	
	                if (self.$deltasFold.length) {
	                    self.$deltas.push({
	                        group: "fold",
	                        deltas: self.$deltasFold
	                    });
	                    self.$deltasFold = [];
	                }
	
	                if (self.$deltasDoc.length) {
	                    self.$deltas.push({
	                        group: "doc",
	                        deltas: self.$deltasDoc
	                    });
	                    self.$deltasDoc = [];
	                }
	
	                if (self.$deltas.length > 0) {
	                    undoManager.execute({
	                        action: "aceupdate",
	                        args: [self.$deltas, self],
	                        merge: self.mergeUndoDeltas
	                    });
	                }
	                self.mergeUndoDeltas = false;
	                self.$deltas = [];
	            };
	            this.$informUndoManager = lang.delayedCall(this.$syncInformUndoManager);
	        }
	    };
	    this.markUndoGroup = function() {
	        if (this.$syncInformUndoManager)
	            this.$syncInformUndoManager();
	    };
	    
	    this.$defaultUndoManager = {
	        undo: function() {},
	        redo: function() {},
	        reset: function() {}
	    };
	    this.getUndoManager = function() {
	        return this.$undoManager || this.$defaultUndoManager;
	    };
	    this.getTabString = function() {
	        if (this.getUseSoftTabs()) {
	            return lang.stringRepeat(" ", this.getTabSize());
	        } else {
	            return "\t";
	        }
	    };
	    this.setUseSoftTabs = function(val) {
	        this.setOption("useSoftTabs", val);
	    };
	    this.getUseSoftTabs = function() {
	        return this.$useSoftTabs && !this.$mode.$indentWithTabs;
	    };
	    this.setTabSize = function(tabSize) {
	        this.setOption("tabSize", tabSize);
	    };
	    this.getTabSize = function() {
	        return this.$tabSize;
	    };
	    this.isTabStop = function(position) {
	        return this.$useSoftTabs && (position.column % this.$tabSize === 0);
	    };
	
	    this.$overwrite = false;
	    this.setOverwrite = function(overwrite) {
	        this.setOption("overwrite", overwrite);
	    };
	    this.getOverwrite = function() {
	        return this.$overwrite;
	    };
	    this.toggleOverwrite = function() {
	        this.setOverwrite(!this.$overwrite);
	    };
	    this.addGutterDecoration = function(row, className) {
	        if (!this.$decorations[row])
	            this.$decorations[row] = "";
	        this.$decorations[row] += " " + className;
	        this._signal("changeBreakpoint", {});
	    };
	    this.removeGutterDecoration = function(row, className) {
	        this.$decorations[row] = (this.$decorations[row] || "").replace(" " + className, "");
	        this._signal("changeBreakpoint", {});
	    };
	    this.getBreakpoints = function() {
	        return this.$breakpoints;
	    };
	    this.setBreakpoints = function(rows) {
	        this.$breakpoints = [];
	        for (var i=0; i<rows.length; i++) {
	            this.$breakpoints[rows[i]] = "ace_breakpoint";
	        }
	        this._signal("changeBreakpoint", {});
	    };
	    this.clearBreakpoints = function() {
	        this.$breakpoints = [];
	        this._signal("changeBreakpoint", {});
	    };
	    this.setBreakpoint = function(row, className) {
	        if (className === undefined)
	            className = "ace_breakpoint";
	        if (className)
	            this.$breakpoints[row] = className;
	        else
	            delete this.$breakpoints[row];
	        this._signal("changeBreakpoint", {});
	    };
	    this.clearBreakpoint = function(row) {
	        delete this.$breakpoints[row];
	        this._signal("changeBreakpoint", {});
	    };
	    this.addMarker = function(range, clazz, type, inFront) {
	        var id = this.$markerId++;
	
	        var marker = {
	            range : range,
	            type : type || "line",
	            renderer: typeof type == "function" ? type : null,
	            clazz : clazz,
	            inFront: !!inFront,
	            id: id
	        };
	
	        if (inFront) {
	            this.$frontMarkers[id] = marker;
	            this._signal("changeFrontMarker");
	        } else {
	            this.$backMarkers[id] = marker;
	            this._signal("changeBackMarker");
	        }
	
	        return id;
	    };
	    this.addDynamicMarker = function(marker, inFront) {
	        if (!marker.update)
	            return;
	        var id = this.$markerId++;
	        marker.id = id;
	        marker.inFront = !!inFront;
	
	        if (inFront) {
	            this.$frontMarkers[id] = marker;
	            this._signal("changeFrontMarker");
	        } else {
	            this.$backMarkers[id] = marker;
	            this._signal("changeBackMarker");
	        }
	
	        return marker;
	    };
	    this.removeMarker = function(markerId) {
	        var marker = this.$frontMarkers[markerId] || this.$backMarkers[markerId];
	        if (!marker)
	            return;
	
	        var markers = marker.inFront ? this.$frontMarkers : this.$backMarkers;
	        if (marker) {
	            delete (markers[markerId]);
	            this._signal(marker.inFront ? "changeFrontMarker" : "changeBackMarker");
	        }
	    };
	    this.getMarkers = function(inFront) {
	        return inFront ? this.$frontMarkers : this.$backMarkers;
	    };
	
	    this.highlight = function(re) {
	        if (!this.$searchHighlight) {
	            var highlight = new SearchHighlight(null, "ace_selected-word", "text");
	            this.$searchHighlight = this.addDynamicMarker(highlight);
	        }
	        this.$searchHighlight.setRegexp(re);
	    };
	    this.highlightLines = function(startRow, endRow, clazz, inFront) {
	        if (typeof endRow != "number") {
	            clazz = endRow;
	            endRow = startRow;
	        }
	        if (!clazz)
	            clazz = "ace_step";
	
	        var range = new Range(startRow, 0, endRow, Infinity);
	        range.id = this.addMarker(range, clazz, "fullLine", inFront);
	        return range;
	    };
	    this.setAnnotations = function(annotations) {
	        this.$annotations = annotations;
	        this._signal("changeAnnotation", {});
	    };
	    this.getAnnotations = function() {
	        return this.$annotations || [];
	    };
	    this.clearAnnotations = function() {
	        this.setAnnotations([]);
	    };
	    this.$detectNewLine = function(text) {
	        var match = text.match(/^.*?(\r?\n)/m);
	        if (match) {
	            this.$autoNewLine = match[1];
	        } else {
	            this.$autoNewLine = "\n";
	        }
	    };
	    this.getWordRange = function(row, column) {
	        var line = this.getLine(row);
	
	        var inToken = false;
	        if (column > 0)
	            inToken = !!line.charAt(column - 1).match(this.tokenRe);
	
	        if (!inToken)
	            inToken = !!line.charAt(column).match(this.tokenRe);
	
	        if (inToken)
	            var re = this.tokenRe;
	        else if (/^\s+$/.test(line.slice(column-1, column+1)))
	            var re = /\s/;
	        else
	            var re = this.nonTokenRe;
	
	        var start = column;
	        if (start > 0) {
	            do {
	                start--;
	            }
	            while (start >= 0 && line.charAt(start).match(re));
	            start++;
	        }
	
	        var end = column;
	        while (end < line.length && line.charAt(end).match(re)) {
	            end++;
	        }
	
	        return new Range(row, start, row, end);
	    };
	    this.getAWordRange = function(row, column) {
	        var wordRange = this.getWordRange(row, column);
	        var line = this.getLine(wordRange.end.row);
	
	        while (line.charAt(wordRange.end.column).match(/[ \t]/)) {
	            wordRange.end.column += 1;
	        }
	        return wordRange;
	    };
	    this.setNewLineMode = function(newLineMode) {
	        this.doc.setNewLineMode(newLineMode);
	    };
	    this.getNewLineMode = function() {
	        return this.doc.getNewLineMode();
	    };
	    this.setUseWorker = function(useWorker) { this.setOption("useWorker", useWorker); };
	    this.getUseWorker = function() { return this.$useWorker; };
	    this.onReloadTokenizer = function(e) {
	        var rows = e.data;
	        this.bgTokenizer.start(rows.first);
	        this._signal("tokenizerUpdate", e);
	    };
	
	    this.$modes = {};
	    this.$mode = null;
	    this.$modeId = null;
	    this.setMode = function(mode, cb) {
	        if (mode && typeof mode === "object") {
	            if (mode.getTokenizer)
	                return this.$onChangeMode(mode);
	            var options = mode;
	            var path = options.path;
	        } else {
	            path = mode || "ace/mode/text";
	        }
	        if (!this.$modes["ace/mode/text"])
	            this.$modes["ace/mode/text"] = new TextMode();
	
	        if (this.$modes[path] && !options) {
	            this.$onChangeMode(this.$modes[path]);
	            cb && cb();
	            return;
	        }
	        this.$modeId = path;
	        config.loadModule(["mode", path], function(m) {
	            if (this.$modeId !== path)
	                return cb && cb();
	            if (this.$modes[path] && !options) {
	                this.$onChangeMode(this.$modes[path]);
	            } else if (m && m.Mode) {
	                m = new m.Mode(options);
	                if (!options) {
	                    this.$modes[path] = m;
	                    m.$id = path;
	                }
	                this.$onChangeMode(m);
	            }
	            cb && cb();
	        }.bind(this));
	        if (!this.$mode)
	            this.$onChangeMode(this.$modes["ace/mode/text"], true);
	    };
	
	    this.$onChangeMode = function(mode, $isPlaceholder) {
	        if (!$isPlaceholder)
	            this.$modeId = mode.$id;
	        if (this.$mode === mode) 
	            return;
	
	        this.$mode = mode;
	
	        this.$stopWorker();
	
	        if (this.$useWorker)
	            this.$startWorker();
	
	        var tokenizer = mode.getTokenizer();
	
	        if(tokenizer.addEventListener !== undefined) {
	            var onReloadTokenizer = this.onReloadTokenizer.bind(this);
	            tokenizer.addEventListener("update", onReloadTokenizer);
	        }
	
	        if (!this.bgTokenizer) {
	            this.bgTokenizer = new BackgroundTokenizer(tokenizer);
	            var _self = this;
	            this.bgTokenizer.addEventListener("update", function(e) {
	                _self._signal("tokenizerUpdate", e);
	            });
	        } else {
	            this.bgTokenizer.setTokenizer(tokenizer);
	        }
	
	        this.bgTokenizer.setDocument(this.getDocument());
	
	        this.tokenRe = mode.tokenRe;
	        this.nonTokenRe = mode.nonTokenRe;
	
	        
	        if (!$isPlaceholder) {
	            if (mode.attachToSession)
	                mode.attachToSession(this);
	            this.$options.wrapMethod.set.call(this, this.$wrapMethod);
	            this.$setFolding(mode.foldingRules);
	            this.bgTokenizer.start(0);
	            this._emit("changeMode");
	        }
	    };
	
	    this.$stopWorker = function() {
	        if (this.$worker) {
	            this.$worker.terminate();
	            this.$worker = null;
	        }
	    };
	
	    this.$startWorker = function() {
	        try {
	            this.$worker = this.$mode.createWorker(this);
	        } catch (e) {
	            config.warn("Could not load worker", e);
	            this.$worker = null;
	        }
	    };
	    this.getMode = function() {
	        return this.$mode;
	    };
	
	    this.$scrollTop = 0;
	    this.setScrollTop = function(scrollTop) {
	        if (this.$scrollTop === scrollTop || isNaN(scrollTop))
	            return;
	
	        this.$scrollTop = scrollTop;
	        this._signal("changeScrollTop", scrollTop);
	    };
	    this.getScrollTop = function() {
	        return this.$scrollTop;
	    };
	
	    this.$scrollLeft = 0;
	    this.setScrollLeft = function(scrollLeft) {
	        if (this.$scrollLeft === scrollLeft || isNaN(scrollLeft))
	            return;
	
	        this.$scrollLeft = scrollLeft;
	        this._signal("changeScrollLeft", scrollLeft);
	    };
	    this.getScrollLeft = function() {
	        return this.$scrollLeft;
	    };
	    this.getScreenWidth = function() {
	        this.$computeWidth();
	        if (this.lineWidgets) 
	            return Math.max(this.getLineWidgetMaxWidth(), this.screenWidth);
	        return this.screenWidth;
	    };
	    
	    this.getLineWidgetMaxWidth = function() {
	        if (this.lineWidgetsWidth != null) return this.lineWidgetsWidth;
	        var width = 0;
	        this.lineWidgets.forEach(function(w) {
	            if (w && w.screenWidth > width)
	                width = w.screenWidth;
	        });
	        return this.lineWidgetWidth = width;
	    };
	
	    this.$computeWidth = function(force) {
	        if (this.$modified || force) {
	            this.$modified = false;
	
	            if (this.$useWrapMode)
	                return this.screenWidth = this.$wrapLimit;
	
	            var lines = this.doc.getAllLines();
	            var cache = this.$rowLengthCache;
	            var longestScreenLine = 0;
	            var foldIndex = 0;
	            var foldLine = this.$foldData[foldIndex];
	            var foldStart = foldLine ? foldLine.start.row : Infinity;
	            var len = lines.length;
	
	            for (var i = 0; i < len; i++) {
	                if (i > foldStart) {
	                    i = foldLine.end.row + 1;
	                    if (i >= len)
	                        break;
	                    foldLine = this.$foldData[foldIndex++];
	                    foldStart = foldLine ? foldLine.start.row : Infinity;
	                }
	
	                if (cache[i] == null)
	                    cache[i] = this.$getStringScreenWidth(lines[i])[0];
	
	                if (cache[i] > longestScreenLine)
	                    longestScreenLine = cache[i];
	            }
	            this.screenWidth = longestScreenLine;
	        }
	    };
	    this.getLine = function(row) {
	        return this.doc.getLine(row);
	    };
	    this.getLines = function(firstRow, lastRow) {
	        return this.doc.getLines(firstRow, lastRow);
	    };
	    this.getLength = function() {
	        return this.doc.getLength();
	    };
	    this.getTextRange = function(range) {
	        return this.doc.getTextRange(range || this.selection.getRange());
	    };
	    this.insert = function(position, text) {
	        return this.doc.insert(position, text);
	    };
	    this.remove = function(range) {
	        return this.doc.remove(range);
	    };
	    this.removeFullLines = function(firstRow, lastRow){
	        return this.doc.removeFullLines(firstRow, lastRow);
	    };
	    this.undoChanges = function(deltas, dontSelect) {
	        if (!deltas.length)
	            return;
	
	        this.$fromUndo = true;
	        var lastUndoRange = null;
	        for (var i = deltas.length - 1; i != -1; i--) {
	            var delta = deltas[i];
	            if (delta.group == "doc") {
	                this.doc.revertDeltas(delta.deltas);
	                lastUndoRange =
	                    this.$getUndoSelection(delta.deltas, true, lastUndoRange);
	            } else {
	                delta.deltas.forEach(function(foldDelta) {
	                    this.addFolds(foldDelta.folds);
	                }, this);
	            }
	        }
	        this.$fromUndo = false;
	        lastUndoRange &&
	            this.$undoSelect &&
	            !dontSelect &&
	            this.selection.setSelectionRange(lastUndoRange);
	        return lastUndoRange;
	    };
	    this.redoChanges = function(deltas, dontSelect) {
	        if (!deltas.length)
	            return;
	
	        this.$fromUndo = true;
	        var lastUndoRange = null;
	        for (var i = 0; i < deltas.length; i++) {
	            var delta = deltas[i];
	            if (delta.group == "doc") {
	                this.doc.applyDeltas(delta.deltas);
	                lastUndoRange =
	                    this.$getUndoSelection(delta.deltas, false, lastUndoRange);
	            }
	        }
	        this.$fromUndo = false;
	        lastUndoRange &&
	            this.$undoSelect &&
	            !dontSelect &&
	            this.selection.setSelectionRange(lastUndoRange);
	        return lastUndoRange;
	    };
	    this.setUndoSelect = function(enable) {
	        this.$undoSelect = enable;
	    };
	
	    this.$getUndoSelection = function(deltas, isUndo, lastUndoRange) {
	        function isInsert(delta) {
	            return isUndo ? delta.action !== "insert" : delta.action === "insert";
	        }
	
	        var delta = deltas[0];
	        var range, point;
	        var lastDeltaIsInsert = false;
	        if (isInsert(delta)) {
	            range = Range.fromPoints(delta.start, delta.end);
	            lastDeltaIsInsert = true;
	        } else {
	            range = Range.fromPoints(delta.start, delta.start);
	            lastDeltaIsInsert = false;
	        }
	
	        for (var i = 1; i < deltas.length; i++) {
	            delta = deltas[i];
	            if (isInsert(delta)) {
	                point = delta.start;
	                if (range.compare(point.row, point.column) == -1) {
	                    range.setStart(point);
	                }
	                point = delta.end;
	                if (range.compare(point.row, point.column) == 1) {
	                    range.setEnd(point);
	                }
	                lastDeltaIsInsert = true;
	            } else {
	                point = delta.start;
	                if (range.compare(point.row, point.column) == -1) {
	                    range = Range.fromPoints(delta.start, delta.start);
	                }
	                lastDeltaIsInsert = false;
	            }
	        }
	        if (lastUndoRange != null) {
	            if (Range.comparePoints(lastUndoRange.start, range.start) === 0) {
	                lastUndoRange.start.column += range.end.column - range.start.column;
	                lastUndoRange.end.column += range.end.column - range.start.column;
	            }
	
	            var cmp = lastUndoRange.compareRange(range);
	            if (cmp == 1) {
	                range.setStart(lastUndoRange.start);
	            } else if (cmp == -1) {
	                range.setEnd(lastUndoRange.end);
	            }
	        }
	
	        return range;
	    };
	    this.replace = function(range, text) {
	        return this.doc.replace(range, text);
	    };
	    this.moveText = function(fromRange, toPosition, copy) {
	        var text = this.getTextRange(fromRange);
	        var folds = this.getFoldsInRange(fromRange);
	
	        var toRange = Range.fromPoints(toPosition, toPosition);
	        if (!copy) {
	            this.remove(fromRange);
	            var rowDiff = fromRange.start.row - fromRange.end.row;
	            var collDiff = rowDiff ? -fromRange.end.column : fromRange.start.column - fromRange.end.column;
	            if (collDiff) {
	                if (toRange.start.row == fromRange.end.row && toRange.start.column > fromRange.end.column)
	                    toRange.start.column += collDiff;
	                if (toRange.end.row == fromRange.end.row && toRange.end.column > fromRange.end.column)
	                    toRange.end.column += collDiff;
	            }
	            if (rowDiff && toRange.start.row >= fromRange.end.row) {
	                toRange.start.row += rowDiff;
	                toRange.end.row += rowDiff;
	            }
	        }
	
	        toRange.end = this.insert(toRange.start, text);
	        if (folds.length) {
	            var oldStart = fromRange.start;
	            var newStart = toRange.start;
	            var rowDiff = newStart.row - oldStart.row;
	            var collDiff = newStart.column - oldStart.column;
	            this.addFolds(folds.map(function(x) {
	                x = x.clone();
	                if (x.start.row == oldStart.row)
	                    x.start.column += collDiff;
	                if (x.end.row == oldStart.row)
	                    x.end.column += collDiff;
	                x.start.row += rowDiff;
	                x.end.row += rowDiff;
	                return x;
	            }));
	        }
	
	        return toRange;
	    };
	    this.indentRows = function(startRow, endRow, indentString) {
	        indentString = indentString.replace(/\t/g, this.getTabString());
	        for (var row=startRow; row<=endRow; row++)
	            this.doc.insertInLine({row: row, column: 0}, indentString);
	    };
	    this.outdentRows = function (range) {
	        var rowRange = range.collapseRows();
	        var deleteRange = new Range(0, 0, 0, 0);
	        var size = this.getTabSize();
	
	        for (var i = rowRange.start.row; i <= rowRange.end.row; ++i) {
	            var line = this.getLine(i);
	
	            deleteRange.start.row = i;
	            deleteRange.end.row = i;
	            for (var j = 0; j < size; ++j)
	                if (line.charAt(j) != ' ')
	                    break;
	            if (j < size && line.charAt(j) == '\t') {
	                deleteRange.start.column = j;
	                deleteRange.end.column = j + 1;
	            } else {
	                deleteRange.start.column = 0;
	                deleteRange.end.column = j;
	            }
	            this.remove(deleteRange);
	        }
	    };
	
	    this.$moveLines = function(firstRow, lastRow, dir) {
	        firstRow = this.getRowFoldStart(firstRow);
	        lastRow = this.getRowFoldEnd(lastRow);
	        if (dir < 0) {
	            var row = this.getRowFoldStart(firstRow + dir);
	            if (row < 0) return 0;
	            var diff = row-firstRow;
	        } else if (dir > 0) {
	            var row = this.getRowFoldEnd(lastRow + dir);
	            if (row > this.doc.getLength()-1) return 0;
	            var diff = row-lastRow;
	        } else {
	            firstRow = this.$clipRowToDocument(firstRow);
	            lastRow = this.$clipRowToDocument(lastRow);
	            var diff = lastRow - firstRow + 1;
	        }
	
	        var range = new Range(firstRow, 0, lastRow, Number.MAX_VALUE);
	        var folds = this.getFoldsInRange(range).map(function(x){
	            x = x.clone();
	            x.start.row += diff;
	            x.end.row += diff;
	            return x;
	        });
	        
	        var lines = dir == 0
	            ? this.doc.getLines(firstRow, lastRow)
	            : this.doc.removeFullLines(firstRow, lastRow);
	        this.doc.insertFullLines(firstRow+diff, lines);
	        folds.length && this.addFolds(folds);
	        return diff;
	    };
	    this.moveLinesUp = function(firstRow, lastRow) {
	        return this.$moveLines(firstRow, lastRow, -1);
	    };
	    this.moveLinesDown = function(firstRow, lastRow) {
	        return this.$moveLines(firstRow, lastRow, 1);
	    };
	    this.duplicateLines = function(firstRow, lastRow) {
	        return this.$moveLines(firstRow, lastRow, 0);
	    };
	
	
	    this.$clipRowToDocument = function(row) {
	        return Math.max(0, Math.min(row, this.doc.getLength()-1));
	    };
	
	    this.$clipColumnToRow = function(row, column) {
	        if (column < 0)
	            return 0;
	        return Math.min(this.doc.getLine(row).length, column);
	    };
	
	
	    this.$clipPositionToDocument = function(row, column) {
	        column = Math.max(0, column);
	
	        if (row < 0) {
	            row = 0;
	            column = 0;
	        } else {
	            var len = this.doc.getLength();
	            if (row >= len) {
	                row = len - 1;
	                column = this.doc.getLine(len-1).length;
	            } else {
	                column = Math.min(this.doc.getLine(row).length, column);
	            }
	        }
	
	        return {
	            row: row,
	            column: column
	        };
	    };
	
	    this.$clipRangeToDocument = function(range) {
	        if (range.start.row < 0) {
	            range.start.row = 0;
	            range.start.column = 0;
	        } else {
	            range.start.column = this.$clipColumnToRow(
	                range.start.row,
	                range.start.column
	            );
	        }
	
	        var len = this.doc.getLength() - 1;
	        if (range.end.row > len) {
	            range.end.row = len;
	            range.end.column = this.doc.getLine(len).length;
	        } else {
	            range.end.column = this.$clipColumnToRow(
	                range.end.row,
	                range.end.column
	            );
	        }
	        return range;
	    };
	    this.$wrapLimit = 80;
	    this.$useWrapMode = false;
	    this.$wrapLimitRange = {
	        min : null,
	        max : null
	    };
	    this.setUseWrapMode = function(useWrapMode) {
	        if (useWrapMode != this.$useWrapMode) {
	            this.$useWrapMode = useWrapMode;
	            this.$modified = true;
	            this.$resetRowCache(0);
	            if (useWrapMode) {
	                var len = this.getLength();
	                this.$wrapData = Array(len);
	                this.$updateWrapData(0, len - 1);
	            }
	
	            this._signal("changeWrapMode");
	        }
	    };
	    this.getUseWrapMode = function() {
	        return this.$useWrapMode;
	    };
	    this.setWrapLimitRange = function(min, max) {
	        if (this.$wrapLimitRange.min !== min || this.$wrapLimitRange.max !== max) {
	            this.$wrapLimitRange = { min: min, max: max };
	            this.$modified = true;
	            if (this.$useWrapMode)
	                this._signal("changeWrapMode");
	        }
	    };
	    this.adjustWrapLimit = function(desiredLimit, $printMargin) {
	        var limits = this.$wrapLimitRange;
	        if (limits.max < 0)
	            limits = {min: $printMargin, max: $printMargin};
	        var wrapLimit = this.$constrainWrapLimit(desiredLimit, limits.min, limits.max);
	        if (wrapLimit != this.$wrapLimit && wrapLimit > 1) {
	            this.$wrapLimit = wrapLimit;
	            this.$modified = true;
	            if (this.$useWrapMode) {
	                this.$updateWrapData(0, this.getLength() - 1);
	                this.$resetRowCache(0);
	                this._signal("changeWrapLimit");
	            }
	            return true;
	        }
	        return false;
	    };
	
	    this.$constrainWrapLimit = function(wrapLimit, min, max) {
	        if (min)
	            wrapLimit = Math.max(min, wrapLimit);
	
	        if (max)
	            wrapLimit = Math.min(max, wrapLimit);
	
	        return wrapLimit;
	    };
	    this.getWrapLimit = function() {
	        return this.$wrapLimit;
	    };
	    this.setWrapLimit = function (limit) {
	        this.setWrapLimitRange(limit, limit);
	    };
	    this.getWrapLimitRange = function() {
	        return {
	            min : this.$wrapLimitRange.min,
	            max : this.$wrapLimitRange.max
	        };
	    };
	
	    this.$updateInternalDataOnChange = function(delta) {
	        var useWrapMode = this.$useWrapMode;
	        var action = delta.action;
	        var start = delta.start;
	        var end = delta.end;
	        var firstRow = start.row;
	        var lastRow = end.row;
	        var len = lastRow - firstRow;
	        var removedFolds = null;
	        
	        this.$updating = true;
	        if (len != 0) {
	            if (action === "remove") {
	                this[useWrapMode ? "$wrapData" : "$rowLengthCache"].splice(firstRow, len);
	
	                var foldLines = this.$foldData;
	                removedFolds = this.getFoldsInRange(delta);
	                this.removeFolds(removedFolds);
	
	                var foldLine = this.getFoldLine(end.row);
	                var idx = 0;
	                if (foldLine) {
	                    foldLine.addRemoveChars(end.row, end.column, start.column - end.column);
	                    foldLine.shiftRow(-len);
	
	                    var foldLineBefore = this.getFoldLine(firstRow);
	                    if (foldLineBefore && foldLineBefore !== foldLine) {
	                        foldLineBefore.merge(foldLine);
	                        foldLine = foldLineBefore;
	                    }
	                    idx = foldLines.indexOf(foldLine) + 1;
	                }
	
	                for (idx; idx < foldLines.length; idx++) {
	                    var foldLine = foldLines[idx];
	                    if (foldLine.start.row >= end.row) {
	                        foldLine.shiftRow(-len);
	                    }
	                }
	
	                lastRow = firstRow;
	            } else {
	                var args = Array(len);
	                args.unshift(firstRow, 0);
	                var arr = useWrapMode ? this.$wrapData : this.$rowLengthCache
	                arr.splice.apply(arr, args);
	                var foldLines = this.$foldData;
	                var foldLine = this.getFoldLine(firstRow);
	                var idx = 0;
	                if (foldLine) {
	                    var cmp = foldLine.range.compareInside(start.row, start.column);
	                    if (cmp == 0) {
	                        foldLine = foldLine.split(start.row, start.column);
	                        if (foldLine) {
	                            foldLine.shiftRow(len);
	                            foldLine.addRemoveChars(lastRow, 0, end.column - start.column);
	                        }
	                    } else
	                    if (cmp == -1) {
	                        foldLine.addRemoveChars(firstRow, 0, end.column - start.column);
	                        foldLine.shiftRow(len);
	                    }
	                    idx = foldLines.indexOf(foldLine) + 1;
	                }
	
	                for (idx; idx < foldLines.length; idx++) {
	                    var foldLine = foldLines[idx];
	                    if (foldLine.start.row >= firstRow) {
	                        foldLine.shiftRow(len);
	                    }
	                }
	            }
	        } else {
	            len = Math.abs(delta.start.column - delta.end.column);
	            if (action === "remove") {
	                removedFolds = this.getFoldsInRange(delta);
	                this.removeFolds(removedFolds);
	
	                len = -len;
	            }
	            var foldLine = this.getFoldLine(firstRow);
	            if (foldLine) {
	                foldLine.addRemoveChars(firstRow, start.column, len);
	            }
	        }
	
	        if (useWrapMode && this.$wrapData.length != this.doc.getLength()) {
	            console.error("doc.getLength() and $wrapData.length have to be the same!");
	        }
	        this.$updating = false;
	
	        if (useWrapMode)
	            this.$updateWrapData(firstRow, lastRow);
	        else
	            this.$updateRowLengthCache(firstRow, lastRow);
	
	        return removedFolds;
	    };
	
	    this.$updateRowLengthCache = function(firstRow, lastRow, b) {
	        this.$rowLengthCache[firstRow] = null;
	        this.$rowLengthCache[lastRow] = null;
	    };
	
	    this.$updateWrapData = function(firstRow, lastRow) {
	        var lines = this.doc.getAllLines();
	        var tabSize = this.getTabSize();
	        var wrapData = this.$wrapData;
	        var wrapLimit = this.$wrapLimit;
	        var tokens;
	        var foldLine;
	
	        var row = firstRow;
	        lastRow = Math.min(lastRow, lines.length - 1);
	        while (row <= lastRow) {
	            foldLine = this.getFoldLine(row, foldLine);
	            if (!foldLine) {
	                tokens = this.$getDisplayTokens(lines[row]);
	                wrapData[row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
	                row ++;
	            } else {
	                tokens = [];
	                foldLine.walk(function(placeholder, row, column, lastColumn) {
	                        var walkTokens;
	                        if (placeholder != null) {
	                            walkTokens = this.$getDisplayTokens(
	                                            placeholder, tokens.length);
	                            walkTokens[0] = PLACEHOLDER_START;
	                            for (var i = 1; i < walkTokens.length; i++) {
	                                walkTokens[i] = PLACEHOLDER_BODY;
	                            }
	                        } else {
	                            walkTokens = this.$getDisplayTokens(
	                                lines[row].substring(lastColumn, column),
	                                tokens.length);
	                        }
	                        tokens = tokens.concat(walkTokens);
	                    }.bind(this),
	                    foldLine.end.row,
	                    lines[foldLine.end.row].length + 1
	                );
	
	                wrapData[foldLine.start.row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
	                row = foldLine.end.row + 1;
	            }
	        }
	    };
	    var CHAR = 1,
	        CHAR_EXT = 2,
	        PLACEHOLDER_START = 3,
	        PLACEHOLDER_BODY =  4,
	        PUNCTUATION = 9,
	        SPACE = 10,
	        TAB = 11,
	        TAB_SPACE = 12;
	
	
	    this.$computeWrapSplits = function(tokens, wrapLimit, tabSize) {
	        if (tokens.length == 0) {
	            return [];
	        }
	
	        var splits = [];
	        var displayLength = tokens.length;
	        var lastSplit = 0, lastDocSplit = 0;
	
	        var isCode = this.$wrapAsCode;
	
	        var indentedSoftWrap = this.$indentedSoftWrap;
	        var maxIndent = wrapLimit <= Math.max(2 * tabSize, 8)
	            || indentedSoftWrap === false ? 0 : Math.floor(wrapLimit / 2);
	
	        function getWrapIndent() {
	            var indentation = 0;
	            if (maxIndent === 0)
	                return indentation;
	            if (indentedSoftWrap) {
	                for (var i = 0; i < tokens.length; i++) {
	                    var token = tokens[i];
	                    if (token == SPACE)
	                        indentation += 1;
	                    else if (token == TAB)
	                        indentation += tabSize;
	                    else if (token == TAB_SPACE)
	                        continue;
	                    else
	                        break;
	                }
	            }
	            if (isCode && indentedSoftWrap !== false)
	                indentation += tabSize;
	            return Math.min(indentation, maxIndent);
	        }
	        function addSplit(screenPos) {
	            var displayed = tokens.slice(lastSplit, screenPos);
	            var len = displayed.length;
	            displayed.join("")
	                .replace(/12/g, function() {
	                    len -= 1;
	                })
	                .replace(/2/g, function() {
	                    len -= 1;
	                });
	
	            if (!splits.length) {
	                indent = getWrapIndent();
	                splits.indent = indent;
	            }
	            lastDocSplit += len;
	            splits.push(lastDocSplit);
	            lastSplit = screenPos;
	        }
	        var indent = 0;
	        while (displayLength - lastSplit > wrapLimit - indent) {
	            var split = lastSplit + wrapLimit - indent;
	            if (tokens[split - 1] >= SPACE && tokens[split] >= SPACE) {
	                addSplit(split);
	                continue;
	            }
	            if (tokens[split] == PLACEHOLDER_START || tokens[split] == PLACEHOLDER_BODY) {
	                for (split; split != lastSplit - 1; split--) {
	                    if (tokens[split] == PLACEHOLDER_START) {
	                        break;
	                    }
	                }
	                if (split > lastSplit) {
	                    addSplit(split);
	                    continue;
	                }
	                split = lastSplit + wrapLimit;
	                for (split; split < tokens.length; split++) {
	                    if (tokens[split] != PLACEHOLDER_BODY) {
	                        break;
	                    }
	                }
	                if (split == tokens.length) {
	                    break;  // Breaks the while-loop.
	                }
	                addSplit(split);
	                continue;
	            }
	            var minSplit = Math.max(split - (wrapLimit -(wrapLimit>>2)), lastSplit - 1);
	            while (split > minSplit && tokens[split] < PLACEHOLDER_START) {
	                split --;
	            }
	            if (isCode) {
	                while (split > minSplit && tokens[split] < PLACEHOLDER_START) {
	                    split --;
	                }
	                while (split > minSplit && tokens[split] == PUNCTUATION) {
	                    split --;
	                }
	            } else {
	                while (split > minSplit && tokens[split] < SPACE) {
	                    split --;
	                }
	            }
	            if (split > minSplit) {
	                addSplit(++split);
	                continue;
	            }
	            split = lastSplit + wrapLimit;
	            if (tokens[split] == CHAR_EXT)
	                split--;
	            addSplit(split - indent);
	        }
	        return splits;
	    };
	    this.$getDisplayTokens = function(str, offset) {
	        var arr = [];
	        var tabSize;
	        offset = offset || 0;
	
	        for (var i = 0; i < str.length; i++) {
	            var c = str.charCodeAt(i);
	            if (c == 9) {
	                tabSize = this.getScreenTabSize(arr.length + offset);
	                arr.push(TAB);
	                for (var n = 1; n < tabSize; n++) {
	                    arr.push(TAB_SPACE);
	                }
	            }
	            else if (c == 32) {
	                arr.push(SPACE);
	            } else if((c > 39 && c < 48) || (c > 57 && c < 64)) {
	                arr.push(PUNCTUATION);
	            }
	            else if (c >= 0x1100 && isFullWidth(c)) {
	                arr.push(CHAR, CHAR_EXT);
	            } else {
	                arr.push(CHAR);
	            }
	        }
	        return arr;
	    };
	    this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
	        if (maxScreenColumn == 0)
	            return [0, 0];
	        if (maxScreenColumn == null)
	            maxScreenColumn = Infinity;
	        screenColumn = screenColumn || 0;
	
	        var c, column;
	        for (column = 0; column < str.length; column++) {
	            c = str.charCodeAt(column);
	            if (c == 9) {
	                screenColumn += this.getScreenTabSize(screenColumn);
	            }
	            else if (c >= 0x1100 && isFullWidth(c)) {
	                screenColumn += 2;
	            } else {
	                screenColumn += 1;
	            }
	            if (screenColumn > maxScreenColumn) {
	                break;
	            }
	        }
	
	        return [screenColumn, column];
	    };
	
	    this.lineWidgets = null;
	    this.getRowLength = function(row) {
	        if (this.lineWidgets)
	            var h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
	        else 
	            h = 0
	        if (!this.$useWrapMode || !this.$wrapData[row]) {
	            return 1 + h;
	        } else {
	            return this.$wrapData[row].length + 1 + h;
	        }
	    };
	    this.getRowLineCount = function(row) {
	        if (!this.$useWrapMode || !this.$wrapData[row]) {
	            return 1;
	        } else {
	            return this.$wrapData[row].length + 1;
	        }
	    };
	
	    this.getRowWrapIndent = function(screenRow) {
	        if (this.$useWrapMode) {
	            var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
	            var splits = this.$wrapData[pos.row];
	            return splits.length && splits[0] < pos.column ? splits.indent : 0;
	        } else {
	            return 0;
	        }
	    }
	    this.getScreenLastRowColumn = function(screenRow) {
	        var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
	        return this.documentToScreenColumn(pos.row, pos.column);
	    };
	    this.getDocumentLastRowColumn = function(docRow, docColumn) {
	        var screenRow = this.documentToScreenRow(docRow, docColumn);
	        return this.getScreenLastRowColumn(screenRow);
	    };
	    this.getDocumentLastRowColumnPosition = function(docRow, docColumn) {
	        var screenRow = this.documentToScreenRow(docRow, docColumn);
	        return this.screenToDocumentPosition(screenRow, Number.MAX_VALUE / 10);
	    };
	    this.getRowSplitData = function(row) {
	        if (!this.$useWrapMode) {
	            return undefined;
	        } else {
	            return this.$wrapData[row];
	        }
	    };
	    this.getScreenTabSize = function(screenColumn) {
	        return this.$tabSize - screenColumn % this.$tabSize;
	    };
	
	
	    this.screenToDocumentRow = function(screenRow, screenColumn) {
	        return this.screenToDocumentPosition(screenRow, screenColumn).row;
	    };
	
	
	    this.screenToDocumentColumn = function(screenRow, screenColumn) {
	        return this.screenToDocumentPosition(screenRow, screenColumn).column;
	    };
	    this.screenToDocumentPosition = function(screenRow, screenColumn) {
	        if (screenRow < 0)
	            return {row: 0, column: 0};
	
	        var line;
	        var docRow = 0;
	        var docColumn = 0;
	        var column;
	        var row = 0;
	        var rowLength = 0;
	
	        var rowCache = this.$screenRowCache;
	        var i = this.$getRowCacheIndex(rowCache, screenRow);
	        var l = rowCache.length;
	        if (l && i >= 0) {
	            var row = rowCache[i];
	            var docRow = this.$docRowCache[i];
	            var doCache = screenRow > rowCache[l - 1];
	        } else {
	            var doCache = !l;
	        }
	
	        var maxRow = this.getLength() - 1;
	        var foldLine = this.getNextFoldLine(docRow);
	        var foldStart = foldLine ? foldLine.start.row : Infinity;
	
	        while (row <= screenRow) {
	            rowLength = this.getRowLength(docRow);
	            if (row + rowLength > screenRow || docRow >= maxRow) {
	                break;
	            } else {
	                row += rowLength;
	                docRow++;
	                if (docRow > foldStart) {
	                    docRow = foldLine.end.row+1;
	                    foldLine = this.getNextFoldLine(docRow, foldLine);
	                    foldStart = foldLine ? foldLine.start.row : Infinity;
	                }
	            }
	
	            if (doCache) {
	                this.$docRowCache.push(docRow);
	                this.$screenRowCache.push(row);
	            }
	        }
	
	        if (foldLine && foldLine.start.row <= docRow) {
	            line = this.getFoldDisplayLine(foldLine);
	            docRow = foldLine.start.row;
	        } else if (row + rowLength <= screenRow || docRow > maxRow) {
	            return {
	                row: maxRow,
	                column: this.getLine(maxRow).length
	            };
	        } else {
	            line = this.getLine(docRow);
	            foldLine = null;
	        }
	        var wrapIndent = 0;
	        if (this.$useWrapMode) {
	            var splits = this.$wrapData[docRow];
	            if (splits) {
	                var splitIndex = Math.floor(screenRow - row);
	                column = splits[splitIndex];
	                if(splitIndex > 0 && splits.length) {
	                    wrapIndent = splits.indent;
	                    docColumn = splits[splitIndex - 1] || splits[splits.length - 1];
	                    line = line.substring(docColumn);
	                }
	            }
	        }
	
	        docColumn += this.$getStringScreenWidth(line, screenColumn - wrapIndent)[1];
	        if (this.$useWrapMode && docColumn >= column)
	            docColumn = column - 1;
	
	        if (foldLine)
	            return foldLine.idxToPosition(docColumn);
	
	        return {row: docRow, column: docColumn};
	    };
	    this.documentToScreenPosition = function(docRow, docColumn) {
	        if (typeof docColumn === "undefined")
	            var pos = this.$clipPositionToDocument(docRow.row, docRow.column);
	        else
	            pos = this.$clipPositionToDocument(docRow, docColumn);
	
	        docRow = pos.row;
	        docColumn = pos.column;
	
	        var screenRow = 0;
	        var foldStartRow = null;
	        var fold = null;
	        fold = this.getFoldAt(docRow, docColumn, 1);
	        if (fold) {
	            docRow = fold.start.row;
	            docColumn = fold.start.column;
	        }
	
	        var rowEnd, row = 0;
	
	
	        var rowCache = this.$docRowCache;
	        var i = this.$getRowCacheIndex(rowCache, docRow);
	        var l = rowCache.length;
	        if (l && i >= 0) {
	            var row = rowCache[i];
	            var screenRow = this.$screenRowCache[i];
	            var doCache = docRow > rowCache[l - 1];
	        } else {
	            var doCache = !l;
	        }
	
	        var foldLine = this.getNextFoldLine(row);
	        var foldStart = foldLine ?foldLine.start.row :Infinity;
	
	        while (row < docRow) {
	            if (row >= foldStart) {
	                rowEnd = foldLine.end.row + 1;
	                if (rowEnd > docRow)
	                    break;
	                foldLine = this.getNextFoldLine(rowEnd, foldLine);
	                foldStart = foldLine ?foldLine.start.row :Infinity;
	            }
	            else {
	                rowEnd = row + 1;
	            }
	
	            screenRow += this.getRowLength(row);
	            row = rowEnd;
	
	            if (doCache) {
	                this.$docRowCache.push(row);
	                this.$screenRowCache.push(screenRow);
	            }
	        }
	        var textLine = "";
	        if (foldLine && row >= foldStart) {
	            textLine = this.getFoldDisplayLine(foldLine, docRow, docColumn);
	            foldStartRow = foldLine.start.row;
	        } else {
	            textLine = this.getLine(docRow).substring(0, docColumn);
	            foldStartRow = docRow;
	        }
	        var wrapIndent = 0;
	        if (this.$useWrapMode) {
	            var wrapRow = this.$wrapData[foldStartRow];
	            if (wrapRow) {
	                var screenRowOffset = 0;
	                while (textLine.length >= wrapRow[screenRowOffset]) {
	                    screenRow ++;
	                    screenRowOffset++;
	                }
	                textLine = textLine.substring(
	                    wrapRow[screenRowOffset - 1] || 0, textLine.length
	                );
	                wrapIndent = screenRowOffset > 0 ? wrapRow.indent : 0;
	            }
	        }
	
	        return {
	            row: screenRow,
	            column: wrapIndent + this.$getStringScreenWidth(textLine)[0]
	        };
	    };
	    this.documentToScreenColumn = function(row, docColumn) {
	        return this.documentToScreenPosition(row, docColumn).column;
	    };
	    this.documentToScreenRow = function(docRow, docColumn) {
	        return this.documentToScreenPosition(docRow, docColumn).row;
	    };
	    this.getScreenLength = function() {
	        var screenRows = 0;
	        var fold = null;
	        if (!this.$useWrapMode) {
	            screenRows = this.getLength();
	            var foldData = this.$foldData;
	            for (var i = 0; i < foldData.length; i++) {
	                fold = foldData[i];
	                screenRows -= fold.end.row - fold.start.row;
	            }
	        } else {
	            var lastRow = this.$wrapData.length;
	            var row = 0, i = 0;
	            var fold = this.$foldData[i++];
	            var foldStart = fold ? fold.start.row :Infinity;
	
	            while (row < lastRow) {
	                var splits = this.$wrapData[row];
	                screenRows += splits ? splits.length + 1 : 1;
	                row ++;
	                if (row > foldStart) {
	                    row = fold.end.row+1;
	                    fold = this.$foldData[i++];
	                    foldStart = fold ?fold.start.row :Infinity;
	                }
	            }
	        }
	        if (this.lineWidgets)
	            screenRows += this.$getWidgetScreenLength();
	
	        return screenRows;
	    };
	    this.$setFontMetrics = function(fm) {
	        if (!this.$enableVarChar) return;
	        this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
	            if (maxScreenColumn === 0)
	                return [0, 0];
	            if (!maxScreenColumn)
	                maxScreenColumn = Infinity;
	            screenColumn = screenColumn || 0;
	            
	            var c, column;
	            for (column = 0; column < str.length; column++) {
	                c = str.charAt(column);
	                if (c === "\t") {
	                    screenColumn += this.getScreenTabSize(screenColumn);
	                } else {
	                    screenColumn += fm.getCharacterWidth(c);
	                }
	                if (screenColumn > maxScreenColumn) {
	                    break;
	                }
	            }
	            
	            return [screenColumn, column];
	        };
	    };
	    
	    this.destroy = function() {
	        if (this.bgTokenizer) {
	            this.bgTokenizer.setDocument(null);
	            this.bgTokenizer = null;
	        }
	        this.$stopWorker();
	    };
	    function isFullWidth(c) {
	        if (c < 0x1100)
	            return false;
	        return c >= 0x1100 && c <= 0x115F ||
	               c >= 0x11A3 && c <= 0x11A7 ||
	               c >= 0x11FA && c <= 0x11FF ||
	               c >= 0x2329 && c <= 0x232A ||
	               c >= 0x2E80 && c <= 0x2E99 ||
	               c >= 0x2E9B && c <= 0x2EF3 ||
	               c >= 0x2F00 && c <= 0x2FD5 ||
	               c >= 0x2FF0 && c <= 0x2FFB ||
	               c >= 0x3000 && c <= 0x303E ||
	               c >= 0x3041 && c <= 0x3096 ||
	               c >= 0x3099 && c <= 0x30FF ||
	               c >= 0x3105 && c <= 0x312D ||
	               c >= 0x3131 && c <= 0x318E ||
	               c >= 0x3190 && c <= 0x31BA ||
	               c >= 0x31C0 && c <= 0x31E3 ||
	               c >= 0x31F0 && c <= 0x321E ||
	               c >= 0x3220 && c <= 0x3247 ||
	               c >= 0x3250 && c <= 0x32FE ||
	               c >= 0x3300 && c <= 0x4DBF ||
	               c >= 0x4E00 && c <= 0xA48C ||
	               c >= 0xA490 && c <= 0xA4C6 ||
	               c >= 0xA960 && c <= 0xA97C ||
	               c >= 0xAC00 && c <= 0xD7A3 ||
	               c >= 0xD7B0 && c <= 0xD7C6 ||
	               c >= 0xD7CB && c <= 0xD7FB ||
	               c >= 0xF900 && c <= 0xFAFF ||
	               c >= 0xFE10 && c <= 0xFE19 ||
	               c >= 0xFE30 && c <= 0xFE52 ||
	               c >= 0xFE54 && c <= 0xFE66 ||
	               c >= 0xFE68 && c <= 0xFE6B ||
	               c >= 0xFF01 && c <= 0xFF60 ||
	               c >= 0xFFE0 && c <= 0xFFE6;
	    }
	
	}).call(EditSession.prototype);
	
	acequire("./edit_session/folding").Folding.call(EditSession.prototype);
	acequire("./edit_session/bracket_match").BracketMatch.call(EditSession.prototype);
	
	
	config.defineOptions(EditSession.prototype, "session", {
	    wrap: {
	        set: function(value) {
	            if (!value || value == "off")
	                value = false;
	            else if (value == "free")
	                value = true;
	            else if (value == "printMargin")
	                value = -1;
	            else if (typeof value == "string")
	                value = parseInt(value, 10) || false;
	
	            if (this.$wrap == value)
	                return;
	            this.$wrap = value;
	            if (!value) {
	                this.setUseWrapMode(false);
	            } else {
	                var col = typeof value == "number" ? value : null;
	                this.setWrapLimitRange(col, col);
	                this.setUseWrapMode(true);
	            }
	        },
	        get: function() {
	            if (this.getUseWrapMode()) {
	                if (this.$wrap == -1)
	                    return "printMargin";
	                if (!this.getWrapLimitRange().min)
	                    return "free";
	                return this.$wrap;
	            }
	            return "off";
	        },
	        handlesSet: true
	    },    
	    wrapMethod: {
	        set: function(val) {
	            val = val == "auto"
	                ? this.$mode.type != "text"
	                : val != "text";
	            if (val != this.$wrapAsCode) {
	                this.$wrapAsCode = val;
	                if (this.$useWrapMode) {
	                    this.$modified = true;
	                    this.$resetRowCache(0);
	                    this.$updateWrapData(0, this.getLength() - 1);
	                }
	            }
	        },
	        initialValue: "auto"
	    },
	    indentedSoftWrap: { initialValue: true },
	    firstLineNumber: {
	        set: function() {this._signal("changeBreakpoint");},
	        initialValue: 1
	    },
	    useWorker: {
	        set: function(useWorker) {
	            this.$useWorker = useWorker;
	
	            this.$stopWorker();
	            if (useWorker)
	                this.$startWorker();
	        },
	        initialValue: true
	    },
	    useSoftTabs: {initialValue: true},
	    tabSize: {
	        set: function(tabSize) {
	            if (isNaN(tabSize) || this.$tabSize === tabSize) return;
	
	            this.$modified = true;
	            this.$rowLengthCache = [];
	            this.$tabSize = tabSize;
	            this._signal("changeTabSize");
	        },
	        initialValue: 4,
	        handlesSet: true
	    },
	    overwrite: {
	        set: function(val) {this._signal("changeOverwrite");},
	        initialValue: false
	    },
	    newLineMode: {
	        set: function(val) {this.doc.setNewLineMode(val)},
	        get: function() {return this.doc.getNewLineMode()},
	        handlesSet: true
	    },
	    mode: {
	        set: function(val) { this.setMode(val) },
	        get: function() { return this.$modeId }
	    }
	});
	
	exports.EditSession = EditSession;
	});
	
	ace.define("ace/search",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var lang = acequire("./lib/lang");
	var oop = acequire("./lib/oop");
	var Range = acequire("./range").Range;
	
	var Search = function() {
	    this.$options = {};
	};
	
	(function() {
	    this.set = function(options) {
	        oop.mixin(this.$options, options);
	        return this;
	    };
	    this.getOptions = function() {
	        return lang.copyObject(this.$options);
	    };
	    this.setOptions = function(options) {
	        this.$options = options;
	    };
	    this.find = function(session) {
	        var options = this.$options;
	        var iterator = this.$matchIterator(session, options);
	        if (!iterator)
	            return false;
	
	        var firstRange = null;
	        iterator.forEach(function(range, row, offset) {
	            if (!range.start) {
	                var column = range.offset + (offset || 0);
	                firstRange = new Range(row, column, row, column + range.length);
	                if (!range.length && options.start && options.start.start
	                    && options.skipCurrent != false && firstRange.isEqual(options.start)
	                ) {
	                    firstRange = null;
	                    return false;
	                }
	            } else
	                firstRange = range;
	            return true;
	        });
	
	        return firstRange;
	    };
	    this.findAll = function(session) {
	        var options = this.$options;
	        if (!options.needle)
	            return [];
	        this.$assembleRegExp(options);
	
	        var range = options.range;
	        var lines = range
	            ? session.getLines(range.start.row, range.end.row)
	            : session.doc.getAllLines();
	
	        var ranges = [];
	        var re = options.re;
	        if (options.$isMultiLine) {
	            var len = re.length;
	            var maxRow = lines.length - len;
	            var prevRange;
	            outer: for (var row = re.offset || 0; row <= maxRow; row++) {
	                for (var j = 0; j < len; j++)
	                    if (lines[row + j].search(re[j]) == -1)
	                        continue outer;
	                
	                var startLine = lines[row];
	                var line = lines[row + len - 1];
	                var startIndex = startLine.length - startLine.match(re[0])[0].length;
	                var endIndex = line.match(re[len - 1])[0].length;
	                
	                if (prevRange && prevRange.end.row === row &&
	                    prevRange.end.column > startIndex
	                ) {
	                    continue;
	                }
	                ranges.push(prevRange = new Range(
	                    row, startIndex, row + len - 1, endIndex
	                ));
	                if (len > 2)
	                    row = row + len - 2;
	            }
	        } else {
	            for (var i = 0; i < lines.length; i++) {
	                var matches = lang.getMatchOffsets(lines[i], re);
	                for (var j = 0; j < matches.length; j++) {
	                    var match = matches[j];
	                    ranges.push(new Range(i, match.offset, i, match.offset + match.length));
	                }
	            }
	        }
	
	        if (range) {
	            var startColumn = range.start.column;
	            var endColumn = range.start.column;
	            var i = 0, j = ranges.length - 1;
	            while (i < j && ranges[i].start.column < startColumn && ranges[i].start.row == range.start.row)
	                i++;
	
	            while (i < j && ranges[j].end.column > endColumn && ranges[j].end.row == range.end.row)
	                j--;
	            
	            ranges = ranges.slice(i, j + 1);
	            for (i = 0, j = ranges.length; i < j; i++) {
	                ranges[i].start.row += range.start.row;
	                ranges[i].end.row += range.start.row;
	            }
	        }
	
	        return ranges;
	    };
	    this.replace = function(input, replacement) {
	        var options = this.$options;
	
	        var re = this.$assembleRegExp(options);
	        if (options.$isMultiLine)
	            return replacement;
	
	        if (!re)
	            return;
	
	        var match = re.exec(input);
	        if (!match || match[0].length != input.length)
	            return null;
	        
	        replacement = input.replace(re, replacement);
	        if (options.preserveCase) {
	            replacement = replacement.split("");
	            for (var i = Math.min(input.length, input.length); i--; ) {
	                var ch = input[i];
	                if (ch && ch.toLowerCase() != ch)
	                    replacement[i] = replacement[i].toUpperCase();
	                else
	                    replacement[i] = replacement[i].toLowerCase();
	            }
	            replacement = replacement.join("");
	        }
	        
	        return replacement;
	    };
	
	    this.$matchIterator = function(session, options) {
	        var re = this.$assembleRegExp(options);
	        if (!re)
	            return false;
	
	        var callback;
	        if (options.$isMultiLine) {
	            var len = re.length;
	            var matchIterator = function(line, row, offset) {
	                var startIndex = line.search(re[0]);
	                if (startIndex == -1)
	                    return;
	                for (var i = 1; i < len; i++) {
	                    line = session.getLine(row + i);
	                    if (line.search(re[i]) == -1)
	                        return;
	                }
	
	                var endIndex = line.match(re[len - 1])[0].length;
	
	                var range = new Range(row, startIndex, row + len - 1, endIndex);
	                if (re.offset == 1) {
	                    range.start.row--;
	                    range.start.column = Number.MAX_VALUE;
	                } else if (offset)
	                    range.start.column += offset;
	
	                if (callback(range))
	                    return true;
	            };
	        } else if (options.backwards) {
	            var matchIterator = function(line, row, startIndex) {
	                var matches = lang.getMatchOffsets(line, re);
	                for (var i = matches.length-1; i >= 0; i--)
	                    if (callback(matches[i], row, startIndex))
	                        return true;
	            };
	        } else {
	            var matchIterator = function(line, row, startIndex) {
	                var matches = lang.getMatchOffsets(line, re);
	                for (var i = 0; i < matches.length; i++)
	                    if (callback(matches[i], row, startIndex))
	                        return true;
	            };
	        }
	        
	        var lineIterator = this.$lineIterator(session, options);
	
	        return {
	            forEach: function(_callback) {
	                callback = _callback;
	                lineIterator.forEach(matchIterator);
	            }
	        };
	    };
	
	    this.$assembleRegExp = function(options, $disableFakeMultiline) {
	        if (options.needle instanceof RegExp)
	            return options.re = options.needle;
	
	        var needle = options.needle;
	
	        if (!options.needle)
	            return options.re = false;
	
	        if (!options.regExp)
	            needle = lang.escapeRegExp(needle);
	
	        if (options.wholeWord)
	            needle = addWordBoundary(needle, options);
	
	        var modifier = options.caseSensitive ? "gm" : "gmi";
	
	        options.$isMultiLine = !$disableFakeMultiline && /[\n\r]/.test(needle);
	        if (options.$isMultiLine)
	            return options.re = this.$assembleMultilineRegExp(needle, modifier);
	
	        try {
	            var re = new RegExp(needle, modifier);
	        } catch(e) {
	            re = false;
	        }
	        return options.re = re;
	    };
	
	    this.$assembleMultilineRegExp = function(needle, modifier) {
	        var parts = needle.replace(/\r\n|\r|\n/g, "$\n^").split("\n");
	        var re = [];
	        for (var i = 0; i < parts.length; i++) try {
	            re.push(new RegExp(parts[i], modifier));
	        } catch(e) {
	            return false;
	        }
	        if (parts[0] == "") {
	            re.shift();
	            re.offset = 1;
	        } else {
	            re.offset = 0;
	        }
	        return re;
	    };
	
	    this.$lineIterator = function(session, options) {
	        var backwards = options.backwards == true;
	        var skipCurrent = options.skipCurrent != false;
	
	        var range = options.range;
	        var start = options.start;
	        if (!start)
	            start = range ? range[backwards ? "end" : "start"] : session.selection.getRange();
	         
	        if (start.start)
	            start = start[skipCurrent != backwards ? "end" : "start"];
	
	        var firstRow = range ? range.start.row : 0;
	        var lastRow = range ? range.end.row : session.getLength() - 1;
	
	        var forEach = backwards ? function(callback) {
	                var row = start.row;
	
	                var line = session.getLine(row).substring(0, start.column);
	                if (callback(line, row))
	                    return;
	
	                for (row--; row >= firstRow; row--)
	                    if (callback(session.getLine(row), row))
	                        return;
	
	                if (options.wrap == false)
	                    return;
	
	                for (row = lastRow, firstRow = start.row; row >= firstRow; row--)
	                    if (callback(session.getLine(row), row))
	                        return;
	            } : function(callback) {
	                var row = start.row;
	
	                var line = session.getLine(row).substr(start.column);
	                if (callback(line, row, start.column))
	                    return;
	
	                for (row = row+1; row <= lastRow; row++)
	                    if (callback(session.getLine(row), row))
	                        return;
	
	                if (options.wrap == false)
	                    return;
	
	                for (row = firstRow, lastRow = start.row; row <= lastRow; row++)
	                    if (callback(session.getLine(row), row))
	                        return;
	            };
	        
	        return {forEach: forEach};
	    };
	
	}).call(Search.prototype);
	
	function addWordBoundary(needle, options) {
	    function wordBoundary(c) {
	        if (/\w/.test(c) || options.regExp) return "\\b";
	        return "";
	    }
	    return wordBoundary(needle[0]) + needle
	        + wordBoundary(needle[needle.length - 1]);
	}
	
	exports.Search = Search;
	});
	
	ace.define("ace/keyboard/hash_handler",["require","exports","module","ace/lib/keys","ace/lib/useragent"], function(acequire, exports, module) {
	"use strict";
	
	var keyUtil = acequire("../lib/keys");
	var useragent = acequire("../lib/useragent");
	var KEY_MODS = keyUtil.KEY_MODS;
	
	function HashHandler(config, platform) {
	    this.platform = platform || (useragent.isMac ? "mac" : "win");
	    this.commands = {};
	    this.commandKeyBinding = {};
	    this.addCommands(config);
	    this.$singleCommand = true;
	}
	
	function MultiHashHandler(config, platform) {
	    HashHandler.call(this, config, platform);
	    this.$singleCommand = false;
	}
	
	MultiHashHandler.prototype = HashHandler.prototype;
	
	(function() {
	    
	
	    this.addCommand = function(command) {
	        if (this.commands[command.name])
	            this.removeCommand(command);
	
	        this.commands[command.name] = command;
	
	        if (command.bindKey)
	            this._buildKeyHash(command);
	    };
	
	    this.removeCommand = function(command, keepCommand) {
	        var name = command && (typeof command === 'string' ? command : command.name);
	        command = this.commands[name];
	        if (!keepCommand)
	            delete this.commands[name];
	        var ckb = this.commandKeyBinding;
	        for (var keyId in ckb) {
	            var cmdGroup = ckb[keyId];
	            if (cmdGroup == command) {
	                delete ckb[keyId];
	            } else if (Array.isArray(cmdGroup)) {
	                var i = cmdGroup.indexOf(command);
	                if (i != -1) {
	                    cmdGroup.splice(i, 1);
	                    if (cmdGroup.length == 1)
	                        ckb[keyId] = cmdGroup[0];
	                }
	            }
	        }
	    };
	
	    this.bindKey = function(key, command, position) {
	        if (typeof key == "object" && key) {
	            if (position == undefined)
	                position = key.position;
	            key = key[this.platform];
	        }
	        if (!key)
	            return;
	        if (typeof command == "function")
	            return this.addCommand({exec: command, bindKey: key, name: command.name || key});
	        
	        key.split("|").forEach(function(keyPart) {
	            var chain = "";
	            if (keyPart.indexOf(" ") != -1) {
	                var parts = keyPart.split(/\s+/);
	                keyPart = parts.pop();
	                parts.forEach(function(keyPart) {
	                    var binding = this.parseKeys(keyPart);
	                    var id = KEY_MODS[binding.hashId] + binding.key;
	                    chain += (chain ? " " : "") + id;
	                    this._addCommandToBinding(chain, "chainKeys");
	                }, this);
	                chain += " ";
	            }
	            var binding = this.parseKeys(keyPart);
	            var id = KEY_MODS[binding.hashId] + binding.key;
	            this._addCommandToBinding(chain + id, command, position);
	        }, this);
	    };
	    
	    function getPosition(command) {
	        return typeof command == "object" && command.bindKey
	            && command.bindKey.position || 0;
	    }
	    this._addCommandToBinding = function(keyId, command, position) {
	        var ckb = this.commandKeyBinding, i;
	        if (!command) {
	            delete ckb[keyId];
	        } else if (!ckb[keyId] || this.$singleCommand) {
	            ckb[keyId] = command;
	        } else {
	            if (!Array.isArray(ckb[keyId])) {
	                ckb[keyId] = [ckb[keyId]];
	            } else if ((i = ckb[keyId].indexOf(command)) != -1) {
	                ckb[keyId].splice(i, 1);
	            }
	
	            if (typeof position != "number") {
	                if (position || command.isDefault)
	                    position = -100;
	                else
	                   position = getPosition(command);
	            }
	            var commands = ckb[keyId];
	            for (i = 0; i < commands.length; i++) {
	                var other = commands[i];
	                var otherPos = getPosition(other);
	                if (otherPos > position)
	                    break;
	            }
	            commands.splice(i, 0, command);
	        }
	    };
	
	    this.addCommands = function(commands) {
	        commands && Object.keys(commands).forEach(function(name) {
	            var command = commands[name];
	            if (!command)
	                return;
	            
	            if (typeof command === "string")
	                return this.bindKey(command, name);
	
	            if (typeof command === "function")
	                command = { exec: command };
	
	            if (typeof command !== "object")
	                return;
	
	            if (!command.name)
	                command.name = name;
	
	            this.addCommand(command);
	        }, this);
	    };
	
	    this.removeCommands = function(commands) {
	        Object.keys(commands).forEach(function(name) {
	            this.removeCommand(commands[name]);
	        }, this);
	    };
	
	    this.bindKeys = function(keyList) {
	        Object.keys(keyList).forEach(function(key) {
	            this.bindKey(key, keyList[key]);
	        }, this);
	    };
	
	    this._buildKeyHash = function(command) {
	        this.bindKey(command.bindKey, command);
	    };
	    this.parseKeys = function(keys) {
	        var parts = keys.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(x){return x});
	        var key = parts.pop();
	
	        var keyCode = keyUtil[key];
	        if (keyUtil.FUNCTION_KEYS[keyCode])
	            key = keyUtil.FUNCTION_KEYS[keyCode].toLowerCase();
	        else if (!parts.length)
	            return {key: key, hashId: -1};
	        else if (parts.length == 1 && parts[0] == "shift")
	            return {key: key.toUpperCase(), hashId: -1};
	
	        var hashId = 0;
	        for (var i = parts.length; i--;) {
	            var modifier = keyUtil.KEY_MODS[parts[i]];
	            if (modifier == null) {
	                if (typeof console != "undefined")
	                    console.error("invalid modifier " + parts[i] + " in " + keys);
	                return false;
	            }
	            hashId |= modifier;
	        }
	        return {key: key, hashId: hashId};
	    };
	
	    this.findKeyCommand = function findKeyCommand(hashId, keyString) {
	        var key = KEY_MODS[hashId] + keyString;
	        return this.commandKeyBinding[key];
	    };
	
	    this.handleKeyboard = function(data, hashId, keyString, keyCode) {
	        if (keyCode < 0) return;
	        var key = KEY_MODS[hashId] + keyString;
	        var command = this.commandKeyBinding[key];
	        if (data.$keyChain) {
	            data.$keyChain += " " + key;
	            command = this.commandKeyBinding[data.$keyChain] || command;
	        }
	        
	        if (command) {
	            if (command == "chainKeys" || command[command.length - 1] == "chainKeys") {
	                data.$keyChain = data.$keyChain || key;
	                return {command: "null"};
	            }
	        }
	        
	        if (data.$keyChain) {
	            if ((!hashId || hashId == 4) && keyString.length == 1)
	                data.$keyChain = data.$keyChain.slice(0, -key.length - 1); // wait for input
	            else if (hashId == -1 || keyCode > 0)
	                data.$keyChain = ""; // reset keyChain
	        }
	        return {command: command};
	    };
	    
	    this.getStatusText = function(editor, data) {
	        return data.$keyChain || "";
	    };
	
	}).call(HashHandler.prototype);
	
	exports.HashHandler = HashHandler;
	exports.MultiHashHandler = MultiHashHandler;
	});
	
	ace.define("ace/commands/command_manager",["require","exports","module","ace/lib/oop","ace/keyboard/hash_handler","ace/lib/event_emitter"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var MultiHashHandler = acequire("../keyboard/hash_handler").MultiHashHandler;
	var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
	
	var CommandManager = function(platform, commands) {
	    MultiHashHandler.call(this, commands, platform);
	    this.byName = this.commands;
	    this.setDefaultHandler("exec", function(e) {
	        return e.command.exec(e.editor, e.args || {});
	    });
	};
	
	oop.inherits(CommandManager, MultiHashHandler);
	
	(function() {
	
	    oop.implement(this, EventEmitter);
	
	    this.exec = function(command, editor, args) {
	        if (Array.isArray(command)) {
	            for (var i = command.length; i--; ) {
	                if (this.exec(command[i], editor, args)) return true;
	            }
	            return false;
	        }
	        
	        if (typeof command === "string")
	            command = this.commands[command];
	
	        if (!command)
	            return false;
	
	        if (editor && editor.$readOnly && !command.readOnly)
	            return false;
	
	        var e = {editor: editor, command: command, args: args};
	        e.returnValue = this._emit("exec", e);
	        this._signal("afterExec", e);
	
	        return e.returnValue === false ? false : true;
	    };
	
	    this.toggleRecording = function(editor) {
	        if (this.$inReplay)
	            return;
	
	        editor && editor._emit("changeStatus");
	        if (this.recording) {
	            this.macro.pop();
	            this.removeEventListener("exec", this.$addCommandToMacro);
	
	            if (!this.macro.length)
	                this.macro = this.oldMacro;
	
	            return this.recording = false;
	        }
	        if (!this.$addCommandToMacro) {
	            this.$addCommandToMacro = function(e) {
	                this.macro.push([e.command, e.args]);
	            }.bind(this);
	        }
	
	        this.oldMacro = this.macro;
	        this.macro = [];
	        this.on("exec", this.$addCommandToMacro);
	        return this.recording = true;
	    };
	
	    this.replay = function(editor) {
	        if (this.$inReplay || !this.macro)
	            return;
	
	        if (this.recording)
	            return this.toggleRecording(editor);
	
	        try {
	            this.$inReplay = true;
	            this.macro.forEach(function(x) {
	                if (typeof x == "string")
	                    this.exec(x, editor);
	                else
	                    this.exec(x[0], editor, x[1]);
	            }, this);
	        } finally {
	            this.$inReplay = false;
	        }
	    };
	
	    this.trimMacro = function(m) {
	        return m.map(function(x){
	            if (typeof x[0] != "string")
	                x[0] = x[0].name;
	            if (!x[1])
	                x = x[0];
	            return x;
	        });
	    };
	
	}).call(CommandManager.prototype);
	
	exports.CommandManager = CommandManager;
	
	});
	
	ace.define("ace/commands/default_commands",["require","exports","module","ace/lib/lang","ace/config","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var lang = acequire("../lib/lang");
	var config = acequire("../config");
	var Range = acequire("../range").Range;
	
	function bindKey(win, mac) {
	    return {win: win, mac: mac};
	}
	exports.commands = [{
	    name: "showSettingsMenu",
	    bindKey: bindKey("Ctrl-,", "Command-,"),
	    exec: function(editor) {
	        config.loadModule("ace/ext/settings_menu", function(module) {
	            module.init(editor);
	            editor.showSettingsMenu();
	        });
	    },
	    readOnly: true
	}, {
	    name: "goToNextError",
	    bindKey: bindKey("Alt-E", "F4"),
	    exec: function(editor) {
	        config.loadModule("ace/ext/error_marker", function(module) {
	            module.showErrorMarker(editor, 1);
	        });
	    },
	    scrollIntoView: "animate",
	    readOnly: true
	}, {
	    name: "goToPreviousError",
	    bindKey: bindKey("Alt-Shift-E", "Shift-F4"),
	    exec: function(editor) {
	        config.loadModule("ace/ext/error_marker", function(module) {
	            module.showErrorMarker(editor, -1);
	        });
	    },
	    scrollIntoView: "animate",
	    readOnly: true
	}, {
	    name: "selectall",
	    bindKey: bindKey("Ctrl-A", "Command-A"),
	    exec: function(editor) { editor.selectAll(); },
	    readOnly: true
	}, {
	    name: "centerselection",
	    bindKey: bindKey(null, "Ctrl-L"),
	    exec: function(editor) { editor.centerSelection(); },
	    readOnly: true
	}, {
	    name: "gotoline",
	    bindKey: bindKey("Ctrl-L", "Command-L"),
	    exec: function(editor) {
	        var line = parseInt(prompt("Enter line number:"), 10);
	        if (!isNaN(line)) {
	            editor.gotoLine(line);
	        }
	    },
	    readOnly: true
	}, {
	    name: "fold",
	    bindKey: bindKey("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
	    exec: function(editor) { editor.session.toggleFold(false); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "center",
	    readOnly: true
	}, {
	    name: "unfold",
	    bindKey: bindKey("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
	    exec: function(editor) { editor.session.toggleFold(true); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "center",
	    readOnly: true
	}, {
	    name: "toggleFoldWidget",
	    bindKey: bindKey("F2", "F2"),
	    exec: function(editor) { editor.session.toggleFoldWidget(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "center",
	    readOnly: true
	}, {
	    name: "toggleParentFoldWidget",
	    bindKey: bindKey("Alt-F2", "Alt-F2"),
	    exec: function(editor) { editor.session.toggleFoldWidget(true); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "center",
	    readOnly: true
	}, {
	    name: "foldall",
	    bindKey: bindKey(null, "Ctrl-Command-Option-0"),
	    exec: function(editor) { editor.session.foldAll(); },
	    scrollIntoView: "center",
	    readOnly: true
	}, {
	    name: "foldOther",
	    bindKey: bindKey("Alt-0", "Command-Option-0"),
	    exec: function(editor) { 
	        editor.session.foldAll();
	        editor.session.unfold(editor.selection.getAllRanges());
	    },
	    scrollIntoView: "center",
	    readOnly: true
	}, {
	    name: "unfoldall",
	    bindKey: bindKey("Alt-Shift-0", "Command-Option-Shift-0"),
	    exec: function(editor) { editor.session.unfold(); },
	    scrollIntoView: "center",
	    readOnly: true
	}, {
	    name: "findnext",
	    bindKey: bindKey("Ctrl-K", "Command-G"),
	    exec: function(editor) { editor.findNext(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "center",
	    readOnly: true
	}, {
	    name: "findprevious",
	    bindKey: bindKey("Ctrl-Shift-K", "Command-Shift-G"),
	    exec: function(editor) { editor.findPrevious(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "center",
	    readOnly: true
	}, {
	    name: "selectOrFindNext",
	    bindKey: bindKey("Alt-K", "Ctrl-G"),
	    exec: function(editor) {
	        if (editor.selection.isEmpty())
	            editor.selection.selectWord();
	        else
	            editor.findNext(); 
	    },
	    readOnly: true
	}, {
	    name: "selectOrFindPrevious",
	    bindKey: bindKey("Alt-Shift-K", "Ctrl-Shift-G"),
	    exec: function(editor) { 
	        if (editor.selection.isEmpty())
	            editor.selection.selectWord();
	        else
	            editor.findPrevious();
	    },
	    readOnly: true
	}, {
	    name: "find",
	    bindKey: bindKey("Ctrl-F", "Command-F"),
	    exec: function(editor) {
	        config.loadModule("ace/ext/searchbox", function(e) {e.Search(editor)});
	    },
	    readOnly: true
	}, {
	    name: "overwrite",
	    bindKey: "Insert",
	    exec: function(editor) { editor.toggleOverwrite(); },
	    readOnly: true
	}, {
	    name: "selecttostart",
	    bindKey: bindKey("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
	    exec: function(editor) { editor.getSelection().selectFileStart(); },
	    multiSelectAction: "forEach",
	    readOnly: true,
	    scrollIntoView: "animate",
	    aceCommandGroup: "fileJump"
	}, {
	    name: "gotostart",
	    bindKey: bindKey("Ctrl-Home", "Command-Home|Command-Up"),
	    exec: function(editor) { editor.navigateFileStart(); },
	    multiSelectAction: "forEach",
	    readOnly: true,
	    scrollIntoView: "animate",
	    aceCommandGroup: "fileJump"
	}, {
	    name: "selectup",
	    bindKey: bindKey("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
	    exec: function(editor) { editor.getSelection().selectUp(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "golineup",
	    bindKey: bindKey("Up", "Up|Ctrl-P"),
	    exec: function(editor, args) { editor.navigateUp(args.times); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selecttoend",
	    bindKey: bindKey("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
	    exec: function(editor) { editor.getSelection().selectFileEnd(); },
	    multiSelectAction: "forEach",
	    readOnly: true,
	    scrollIntoView: "animate",
	    aceCommandGroup: "fileJump"
	}, {
	    name: "gotoend",
	    bindKey: bindKey("Ctrl-End", "Command-End|Command-Down"),
	    exec: function(editor) { editor.navigateFileEnd(); },
	    multiSelectAction: "forEach",
	    readOnly: true,
	    scrollIntoView: "animate",
	    aceCommandGroup: "fileJump"
	}, {
	    name: "selectdown",
	    bindKey: bindKey("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
	    exec: function(editor) { editor.getSelection().selectDown(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "golinedown",
	    bindKey: bindKey("Down", "Down|Ctrl-N"),
	    exec: function(editor, args) { editor.navigateDown(args.times); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectwordleft",
	    bindKey: bindKey("Ctrl-Shift-Left", "Option-Shift-Left"),
	    exec: function(editor) { editor.getSelection().selectWordLeft(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "gotowordleft",
	    bindKey: bindKey("Ctrl-Left", "Option-Left"),
	    exec: function(editor) { editor.navigateWordLeft(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selecttolinestart",
	    bindKey: bindKey("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
	    exec: function(editor) { editor.getSelection().selectLineStart(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "gotolinestart",
	    bindKey: bindKey("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
	    exec: function(editor) { editor.navigateLineStart(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectleft",
	    bindKey: bindKey("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
	    exec: function(editor) { editor.getSelection().selectLeft(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "gotoleft",
	    bindKey: bindKey("Left", "Left|Ctrl-B"),
	    exec: function(editor, args) { editor.navigateLeft(args.times); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectwordright",
	    bindKey: bindKey("Ctrl-Shift-Right", "Option-Shift-Right"),
	    exec: function(editor) { editor.getSelection().selectWordRight(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "gotowordright",
	    bindKey: bindKey("Ctrl-Right", "Option-Right"),
	    exec: function(editor) { editor.navigateWordRight(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selecttolineend",
	    bindKey: bindKey("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
	    exec: function(editor) { editor.getSelection().selectLineEnd(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "gotolineend",
	    bindKey: bindKey("Alt-Right|End", "Command-Right|End|Ctrl-E"),
	    exec: function(editor) { editor.navigateLineEnd(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectright",
	    bindKey: bindKey("Shift-Right", "Shift-Right"),
	    exec: function(editor) { editor.getSelection().selectRight(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "gotoright",
	    bindKey: bindKey("Right", "Right|Ctrl-F"),
	    exec: function(editor, args) { editor.navigateRight(args.times); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectpagedown",
	    bindKey: "Shift-PageDown",
	    exec: function(editor) { editor.selectPageDown(); },
	    readOnly: true
	}, {
	    name: "pagedown",
	    bindKey: bindKey(null, "Option-PageDown"),
	    exec: function(editor) { editor.scrollPageDown(); },
	    readOnly: true
	}, {
	    name: "gotopagedown",
	    bindKey: bindKey("PageDown", "PageDown|Ctrl-V"),
	    exec: function(editor) { editor.gotoPageDown(); },
	    readOnly: true
	}, {
	    name: "selectpageup",
	    bindKey: "Shift-PageUp",
	    exec: function(editor) { editor.selectPageUp(); },
	    readOnly: true
	}, {
	    name: "pageup",
	    bindKey: bindKey(null, "Option-PageUp"),
	    exec: function(editor) { editor.scrollPageUp(); },
	    readOnly: true
	}, {
	    name: "gotopageup",
	    bindKey: "PageUp",
	    exec: function(editor) { editor.gotoPageUp(); },
	    readOnly: true
	}, {
	    name: "scrollup",
	    bindKey: bindKey("Ctrl-Up", null),
	    exec: function(e) { e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight); },
	    readOnly: true
	}, {
	    name: "scrolldown",
	    bindKey: bindKey("Ctrl-Down", null),
	    exec: function(e) { e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight); },
	    readOnly: true
	}, {
	    name: "selectlinestart",
	    bindKey: "Shift-Home",
	    exec: function(editor) { editor.getSelection().selectLineStart(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectlineend",
	    bindKey: "Shift-End",
	    exec: function(editor) { editor.getSelection().selectLineEnd(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "togglerecording",
	    bindKey: bindKey("Ctrl-Alt-E", "Command-Option-E"),
	    exec: function(editor) { editor.commands.toggleRecording(editor); },
	    readOnly: true
	}, {
	    name: "replaymacro",
	    bindKey: bindKey("Ctrl-Shift-E", "Command-Shift-E"),
	    exec: function(editor) { editor.commands.replay(editor); },
	    readOnly: true
	}, {
	    name: "jumptomatching",
	    bindKey: bindKey("Ctrl-P", "Ctrl-P"),
	    exec: function(editor) { editor.jumpToMatching(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "animate",
	    readOnly: true
	}, {
	    name: "selecttomatching",
	    bindKey: bindKey("Ctrl-Shift-P", "Ctrl-Shift-P"),
	    exec: function(editor) { editor.jumpToMatching(true); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "animate",
	    readOnly: true
	}, {
	    name: "expandToMatching",
	    bindKey: bindKey("Ctrl-Shift-M", "Ctrl-Shift-M"),
	    exec: function(editor) { editor.jumpToMatching(true, true); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "animate",
	    readOnly: true
	}, {
	    name: "passKeysToBrowser",
	    bindKey: bindKey(null, null),
	    exec: function() {},
	    passEvent: true,
	    readOnly: true
	}, {
	    name: "copy",
	    exec: function(editor) {
	    },
	    readOnly: true
	},
	{
	    name: "cut",
	    exec: function(editor) {
	        var range = editor.getSelectionRange();
	        editor._emit("cut", range);
	
	        if (!editor.selection.isEmpty()) {
	            editor.session.remove(range);
	            editor.clearSelection();
	        }
	    },
	    scrollIntoView: "cursor",
	    multiSelectAction: "forEach"
	}, {
	    name: "paste",
	    exec: function(editor, args) {
	        editor.$handlePaste(args);
	    },
	    scrollIntoView: "cursor"
	}, {
	    name: "removeline",
	    bindKey: bindKey("Ctrl-D", "Command-D"),
	    exec: function(editor) { editor.removeLines(); },
	    scrollIntoView: "cursor",
	    multiSelectAction: "forEachLine"
	}, {
	    name: "duplicateSelection",
	    bindKey: bindKey("Ctrl-Shift-D", "Command-Shift-D"),
	    exec: function(editor) { editor.duplicateSelection(); },
	    scrollIntoView: "cursor",
	    multiSelectAction: "forEach"
	}, {
	    name: "sortlines",
	    bindKey: bindKey("Ctrl-Alt-S", "Command-Alt-S"),
	    exec: function(editor) { editor.sortLines(); },
	    scrollIntoView: "selection",
	    multiSelectAction: "forEachLine"
	}, {
	    name: "togglecomment",
	    bindKey: bindKey("Ctrl-/", "Command-/"),
	    exec: function(editor) { editor.toggleCommentLines(); },
	    multiSelectAction: "forEachLine",
	    scrollIntoView: "selectionPart"
	}, {
	    name: "toggleBlockComment",
	    bindKey: bindKey("Ctrl-Shift-/", "Command-Shift-/"),
	    exec: function(editor) { editor.toggleBlockComment(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "selectionPart"
	}, {
	    name: "modifyNumberUp",
	    bindKey: bindKey("Ctrl-Shift-Up", "Alt-Shift-Up"),
	    exec: function(editor) { editor.modifyNumber(1); },
	    scrollIntoView: "cursor",
	    multiSelectAction: "forEach"
	}, {
	    name: "modifyNumberDown",
	    bindKey: bindKey("Ctrl-Shift-Down", "Alt-Shift-Down"),
	    exec: function(editor) { editor.modifyNumber(-1); },
	    scrollIntoView: "cursor",
	    multiSelectAction: "forEach"
	}, {
	    name: "replace",
	    bindKey: bindKey("Ctrl-H", "Command-Option-F"),
	    exec: function(editor) {
	        config.loadModule("ace/ext/searchbox", function(e) {e.Search(editor, true)});
	    }
	}, {
	    name: "undo",
	    bindKey: bindKey("Ctrl-Z", "Command-Z"),
	    exec: function(editor) { editor.undo(); }
	}, {
	    name: "redo",
	    bindKey: bindKey("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
	    exec: function(editor) { editor.redo(); }
	}, {
	    name: "copylinesup",
	    bindKey: bindKey("Alt-Shift-Up", "Command-Option-Up"),
	    exec: function(editor) { editor.copyLinesUp(); },
	    scrollIntoView: "cursor"
	}, {
	    name: "movelinesup",
	    bindKey: bindKey("Alt-Up", "Option-Up"),
	    exec: function(editor) { editor.moveLinesUp(); },
	    scrollIntoView: "cursor"
	}, {
	    name: "copylinesdown",
	    bindKey: bindKey("Alt-Shift-Down", "Command-Option-Down"),
	    exec: function(editor) { editor.copyLinesDown(); },
	    scrollIntoView: "cursor"
	}, {
	    name: "movelinesdown",
	    bindKey: bindKey("Alt-Down", "Option-Down"),
	    exec: function(editor) { editor.moveLinesDown(); },
	    scrollIntoView: "cursor"
	}, {
	    name: "del",
	    bindKey: bindKey("Delete", "Delete|Ctrl-D|Shift-Delete"),
	    exec: function(editor) { editor.remove("right"); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "backspace",
	    bindKey: bindKey(
	        "Shift-Backspace|Backspace",
	        "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"
	    ),
	    exec: function(editor) { editor.remove("left"); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "cut_or_delete",
	    bindKey: bindKey("Shift-Delete", null),
	    exec: function(editor) { 
	        if (editor.selection.isEmpty()) {
	            editor.remove("left");
	        } else {
	            return false;
	        }
	    },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "removetolinestart",
	    bindKey: bindKey("Alt-Backspace", "Command-Backspace"),
	    exec: function(editor) { editor.removeToLineStart(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "removetolineend",
	    bindKey: bindKey("Alt-Delete", "Ctrl-K"),
	    exec: function(editor) { editor.removeToLineEnd(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "removewordleft",
	    bindKey: bindKey("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
	    exec: function(editor) { editor.removeWordLeft(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "removewordright",
	    bindKey: bindKey("Ctrl-Delete", "Alt-Delete"),
	    exec: function(editor) { editor.removeWordRight(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "outdent",
	    bindKey: bindKey("Shift-Tab", "Shift-Tab"),
	    exec: function(editor) { editor.blockOutdent(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "selectionPart"
	}, {
	    name: "indent",
	    bindKey: bindKey("Tab", "Tab"),
	    exec: function(editor) { editor.indent(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "selectionPart"
	}, {
	    name: "blockoutdent",
	    bindKey: bindKey("Ctrl-[", "Ctrl-["),
	    exec: function(editor) { editor.blockOutdent(); },
	    multiSelectAction: "forEachLine",
	    scrollIntoView: "selectionPart"
	}, {
	    name: "blockindent",
	    bindKey: bindKey("Ctrl-]", "Ctrl-]"),
	    exec: function(editor) { editor.blockIndent(); },
	    multiSelectAction: "forEachLine",
	    scrollIntoView: "selectionPart"
	}, {
	    name: "insertstring",
	    exec: function(editor, str) { editor.insert(str); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "inserttext",
	    exec: function(editor, args) {
	        editor.insert(lang.stringRepeat(args.text  || "", args.times || 1));
	    },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "splitline",
	    bindKey: bindKey(null, "Ctrl-O"),
	    exec: function(editor) { editor.splitLine(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "transposeletters",
	    bindKey: bindKey("Ctrl-T", "Ctrl-T"),
	    exec: function(editor) { editor.transposeLetters(); },
	    multiSelectAction: function(editor) {editor.transposeSelections(1); },
	    scrollIntoView: "cursor"
	}, {
	    name: "touppercase",
	    bindKey: bindKey("Ctrl-U", "Ctrl-U"),
	    exec: function(editor) { editor.toUpperCase(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "tolowercase",
	    bindKey: bindKey("Ctrl-Shift-U", "Ctrl-Shift-U"),
	    exec: function(editor) { editor.toLowerCase(); },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor"
	}, {
	    name: "expandtoline",
	    bindKey: bindKey("Ctrl-Shift-L", "Command-Shift-L"),
	    exec: function(editor) {
	        var range = editor.selection.getRange();
	
	        range.start.column = range.end.column = 0;
	        range.end.row++;
	        editor.selection.setRange(range, false);
	    },
	    multiSelectAction: "forEach",
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "joinlines",
	    bindKey: bindKey(null, null),
	    exec: function(editor) {
	        var isBackwards = editor.selection.isBackwards();
	        var selectionStart = isBackwards ? editor.selection.getSelectionLead() : editor.selection.getSelectionAnchor();
	        var selectionEnd = isBackwards ? editor.selection.getSelectionAnchor() : editor.selection.getSelectionLead();
	        var firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length;
	        var selectedText = editor.session.doc.getTextRange(editor.selection.getRange());
	        var selectedCount = selectedText.replace(/\n\s*/, " ").length;
	        var insertLine = editor.session.doc.getLine(selectionStart.row);
	
	        for (var i = selectionStart.row + 1; i <= selectionEnd.row + 1; i++) {
	            var curLine = lang.stringTrimLeft(lang.stringTrimRight(editor.session.doc.getLine(i)));
	            if (curLine.length !== 0) {
	                curLine = " " + curLine;
	            }
	            insertLine += curLine;
	        }
	
	        if (selectionEnd.row + 1 < (editor.session.doc.getLength() - 1)) {
	            insertLine += editor.session.doc.getNewLineCharacter();
	        }
	
	        editor.clearSelection();
	        editor.session.doc.replace(new Range(selectionStart.row, 0, selectionEnd.row + 2, 0), insertLine);
	
	        if (selectedCount > 0) {
	            editor.selection.moveCursorTo(selectionStart.row, selectionStart.column);
	            editor.selection.selectTo(selectionStart.row, selectionStart.column + selectedCount);
	        } else {
	            firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length > firstLineEndCol ? (firstLineEndCol + 1) : firstLineEndCol;
	            editor.selection.moveCursorTo(selectionStart.row, firstLineEndCol);
	        }
	    },
	    multiSelectAction: "forEach",
	    readOnly: true
	}, {
	    name: "invertSelection",
	    bindKey: bindKey(null, null),
	    exec: function(editor) {
	        var endRow = editor.session.doc.getLength() - 1;
	        var endCol = editor.session.doc.getLine(endRow).length;
	        var ranges = editor.selection.rangeList.ranges;
	        var newRanges = [];
	        if (ranges.length < 1) {
	            ranges = [editor.selection.getRange()];
	        }
	
	        for (var i = 0; i < ranges.length; i++) {
	            if (i == (ranges.length - 1)) {
	                if (!(ranges[i].end.row === endRow && ranges[i].end.column === endCol)) {
	                    newRanges.push(new Range(ranges[i].end.row, ranges[i].end.column, endRow, endCol));
	                }
	            }
	
	            if (i === 0) {
	                if (!(ranges[i].start.row === 0 && ranges[i].start.column === 0)) {
	                    newRanges.push(new Range(0, 0, ranges[i].start.row, ranges[i].start.column));
	                }
	            } else {
	                newRanges.push(new Range(ranges[i-1].end.row, ranges[i-1].end.column, ranges[i].start.row, ranges[i].start.column));
	            }
	        }
	
	        editor.exitMultiSelectMode();
	        editor.clearSelection();
	
	        for(var i = 0; i < newRanges.length; i++) {
	            editor.selection.addRange(newRanges[i], false);
	        }
	    },
	    readOnly: true,
	    scrollIntoView: "none"
	}];
	
	});
	
	ace.define("ace/editor",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/keyboard/textinput","ace/mouse/mouse_handler","ace/mouse/fold_handler","ace/keyboard/keybinding","ace/edit_session","ace/search","ace/range","ace/lib/event_emitter","ace/commands/command_manager","ace/commands/default_commands","ace/config","ace/token_iterator"], function(acequire, exports, module) {
	"use strict";
	
	acequire("./lib/fixoldbrowsers");
	
	var oop = acequire("./lib/oop");
	var dom = acequire("./lib/dom");
	var lang = acequire("./lib/lang");
	var useragent = acequire("./lib/useragent");
	var TextInput = acequire("./keyboard/textinput").TextInput;
	var MouseHandler = acequire("./mouse/mouse_handler").MouseHandler;
	var FoldHandler = acequire("./mouse/fold_handler").FoldHandler;
	var KeyBinding = acequire("./keyboard/keybinding").KeyBinding;
	var EditSession = acequire("./edit_session").EditSession;
	var Search = acequire("./search").Search;
	var Range = acequire("./range").Range;
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	var CommandManager = acequire("./commands/command_manager").CommandManager;
	var defaultCommands = acequire("./commands/default_commands").commands;
	var config = acequire("./config");
	var TokenIterator = acequire("./token_iterator").TokenIterator;
	var Editor = function(renderer, session) {
	    var container = renderer.getContainerElement();
	    this.container = container;
	    this.renderer = renderer;
	
	    this.commands = new CommandManager(useragent.isMac ? "mac" : "win", defaultCommands);
	    this.textInput  = new TextInput(renderer.getTextAreaContainer(), this);
	    this.renderer.textarea = this.textInput.getElement();
	    this.keyBinding = new KeyBinding(this);
	    this.$mouseHandler = new MouseHandler(this);
	    new FoldHandler(this);
	
	    this.$blockScrolling = 0;
	    this.$search = new Search().set({
	        wrap: true
	    });
	
	    this.$historyTracker = this.$historyTracker.bind(this);
	    this.commands.on("exec", this.$historyTracker);
	
	    this.$initOperationListeners();
	    
	    this._$emitInputEvent = lang.delayedCall(function() {
	        this._signal("input", {});
	        if (this.session && this.session.bgTokenizer)
	            this.session.bgTokenizer.scheduleStart();
	    }.bind(this));
	    
	    this.on("change", function(_, _self) {
	        _self._$emitInputEvent.schedule(31);
	    });
	
	    this.setSession(session || new EditSession(""));
	    config.resetOptions(this);
	    config._signal("editor", this);
	};
	
	(function(){
	
	    oop.implement(this, EventEmitter);
	
	    this.$initOperationListeners = function() {
	        function last(a) {return a[a.length - 1]}
	
	        this.selections = [];
	        this.commands.on("exec", this.startOperation.bind(this), true);
	        this.commands.on("afterExec", this.endOperation.bind(this), true);
	
	        this.$opResetTimer = lang.delayedCall(this.endOperation.bind(this));
	
	        this.on("change", function() {
	            this.curOp || this.startOperation();
	            this.curOp.docChanged = true;
	        }.bind(this), true);
	
	        this.on("changeSelection", function() {
	            this.curOp || this.startOperation();
	            this.curOp.selectionChanged = true;
	        }.bind(this), true);
	    };
	
	    this.curOp = null;
	    this.prevOp = {};
	    this.startOperation = function(commadEvent) {
	        if (this.curOp) {
	            if (!commadEvent || this.curOp.command)
	                return;
	            this.prevOp = this.curOp;
	        }
	        if (!commadEvent) {
	            this.previousCommand = null;
	            commadEvent = {};
	        }
	
	        this.$opResetTimer.schedule();
	        this.curOp = {
	            command: commadEvent.command || {},
	            args: commadEvent.args,
	            scrollTop: this.renderer.scrollTop
	        };
	        if (this.curOp.command.name && this.curOp.command.scrollIntoView !== undefined)
	            this.$blockScrolling++;
	    };
	
	    this.endOperation = function(e) {
	        if (this.curOp) {
	            if (e && e.returnValue === false)
	                return this.curOp = null;
	            this._signal("beforeEndOperation");
	            var command = this.curOp.command;
	            if (command.name && this.$blockScrolling > 0)
	                this.$blockScrolling--;
	            var scrollIntoView = command && command.scrollIntoView;
	            if (scrollIntoView) {
	                switch (scrollIntoView) {
	                    case "center-animate":
	                        scrollIntoView = "animate";
	                    case "center":
	                        this.renderer.scrollCursorIntoView(null, 0.5);
	                        break;
	                    case "animate":
	                    case "cursor":
	                        this.renderer.scrollCursorIntoView();
	                        break;
	                    case "selectionPart":
	                        var range = this.selection.getRange();
	                        var config = this.renderer.layerConfig;
	                        if (range.start.row >= config.lastRow || range.end.row <= config.firstRow) {
	                            this.renderer.scrollSelectionIntoView(this.selection.anchor, this.selection.lead);
	                        }
	                        break;
	                    default:
	                        break;
	                }
	                if (scrollIntoView == "animate")
	                    this.renderer.animateScrolling(this.curOp.scrollTop);
	            }
	            
	            this.prevOp = this.curOp;
	            this.curOp = null;
	        }
	    };
	    this.$mergeableCommands = ["backspace", "del", "insertstring"];
	    this.$historyTracker = function(e) {
	        if (!this.$mergeUndoDeltas)
	            return;
	
	        var prev = this.prevOp;
	        var mergeableCommands = this.$mergeableCommands;
	        var shouldMerge = prev.command && (e.command.name == prev.command.name);
	        if (e.command.name == "insertstring") {
	            var text = e.args;
	            if (this.mergeNextCommand === undefined)
	                this.mergeNextCommand = true;
	
	            shouldMerge = shouldMerge
	                && this.mergeNextCommand // previous command allows to coalesce with
	                && (!/\s/.test(text) || /\s/.test(prev.args)); // previous insertion was of same type
	
	            this.mergeNextCommand = true;
	        } else {
	            shouldMerge = shouldMerge
	                && mergeableCommands.indexOf(e.command.name) !== -1; // the command is mergeable
	        }
	
	        if (
	            this.$mergeUndoDeltas != "always"
	            && Date.now() - this.sequenceStartTime > 2000
	        ) {
	            shouldMerge = false; // the sequence is too long
	        }
	
	        if (shouldMerge)
	            this.session.mergeUndoDeltas = true;
	        else if (mergeableCommands.indexOf(e.command.name) !== -1)
	            this.sequenceStartTime = Date.now();
	    };
	    this.setKeyboardHandler = function(keyboardHandler, cb) {
	        if (keyboardHandler && typeof keyboardHandler === "string") {
	            this.$keybindingId = keyboardHandler;
	            var _self = this;
	            config.loadModule(["keybinding", keyboardHandler], function(module) {
	                if (_self.$keybindingId == keyboardHandler)
	                    _self.keyBinding.setKeyboardHandler(module && module.handler);
	                cb && cb();
	            });
	        } else {
	            this.$keybindingId = null;
	            this.keyBinding.setKeyboardHandler(keyboardHandler);
	            cb && cb();
	        }
	    };
	    this.getKeyboardHandler = function() {
	        return this.keyBinding.getKeyboardHandler();
	    };
	    this.setSession = function(session) {
	        if (this.session == session)
	            return;
	        if (this.curOp) this.endOperation();
	        this.curOp = {};
	
	        var oldSession = this.session;
	        if (oldSession) {
	            this.session.off("change", this.$onDocumentChange);
	            this.session.off("changeMode", this.$onChangeMode);
	            this.session.off("tokenizerUpdate", this.$onTokenizerUpdate);
	            this.session.off("changeTabSize", this.$onChangeTabSize);
	            this.session.off("changeWrapLimit", this.$onChangeWrapLimit);
	            this.session.off("changeWrapMode", this.$onChangeWrapMode);
	            this.session.off("changeFold", this.$onChangeFold);
	            this.session.off("changeFrontMarker", this.$onChangeFrontMarker);
	            this.session.off("changeBackMarker", this.$onChangeBackMarker);
	            this.session.off("changeBreakpoint", this.$onChangeBreakpoint);
	            this.session.off("changeAnnotation", this.$onChangeAnnotation);
	            this.session.off("changeOverwrite", this.$onCursorChange);
	            this.session.off("changeScrollTop", this.$onScrollTopChange);
	            this.session.off("changeScrollLeft", this.$onScrollLeftChange);
	
	            var selection = this.session.getSelection();
	            selection.off("changeCursor", this.$onCursorChange);
	            selection.off("changeSelection", this.$onSelectionChange);
	        }
	
	        this.session = session;
	        if (session) {
	            this.$onDocumentChange = this.onDocumentChange.bind(this);
	            session.on("change", this.$onDocumentChange);
	            this.renderer.setSession(session);
	    
	            this.$onChangeMode = this.onChangeMode.bind(this);
	            session.on("changeMode", this.$onChangeMode);
	    
	            this.$onTokenizerUpdate = this.onTokenizerUpdate.bind(this);
	            session.on("tokenizerUpdate", this.$onTokenizerUpdate);
	    
	            this.$onChangeTabSize = this.renderer.onChangeTabSize.bind(this.renderer);
	            session.on("changeTabSize", this.$onChangeTabSize);
	    
	            this.$onChangeWrapLimit = this.onChangeWrapLimit.bind(this);
	            session.on("changeWrapLimit", this.$onChangeWrapLimit);
	    
	            this.$onChangeWrapMode = this.onChangeWrapMode.bind(this);
	            session.on("changeWrapMode", this.$onChangeWrapMode);
	    
	            this.$onChangeFold = this.onChangeFold.bind(this);
	            session.on("changeFold", this.$onChangeFold);
	    
	            this.$onChangeFrontMarker = this.onChangeFrontMarker.bind(this);
	            this.session.on("changeFrontMarker", this.$onChangeFrontMarker);
	    
	            this.$onChangeBackMarker = this.onChangeBackMarker.bind(this);
	            this.session.on("changeBackMarker", this.$onChangeBackMarker);
	    
	            this.$onChangeBreakpoint = this.onChangeBreakpoint.bind(this);
	            this.session.on("changeBreakpoint", this.$onChangeBreakpoint);
	    
	            this.$onChangeAnnotation = this.onChangeAnnotation.bind(this);
	            this.session.on("changeAnnotation", this.$onChangeAnnotation);
	    
	            this.$onCursorChange = this.onCursorChange.bind(this);
	            this.session.on("changeOverwrite", this.$onCursorChange);
	    
	            this.$onScrollTopChange = this.onScrollTopChange.bind(this);
	            this.session.on("changeScrollTop", this.$onScrollTopChange);
	    
	            this.$onScrollLeftChange = this.onScrollLeftChange.bind(this);
	            this.session.on("changeScrollLeft", this.$onScrollLeftChange);
	    
	            this.selection = session.getSelection();
	            this.selection.on("changeCursor", this.$onCursorChange);
	    
	            this.$onSelectionChange = this.onSelectionChange.bind(this);
	            this.selection.on("changeSelection", this.$onSelectionChange);
	    
	            this.onChangeMode();
	    
	            this.$blockScrolling += 1;
	            this.onCursorChange();
	            this.$blockScrolling -= 1;
	    
	            this.onScrollTopChange();
	            this.onScrollLeftChange();
	            this.onSelectionChange();
	            this.onChangeFrontMarker();
	            this.onChangeBackMarker();
	            this.onChangeBreakpoint();
	            this.onChangeAnnotation();
	            this.session.getUseWrapMode() && this.renderer.adjustWrapLimit();
	            this.renderer.updateFull();
	        } else {
	            this.selection = null;
	            this.renderer.setSession(session);
	        }
	
	        this._signal("changeSession", {
	            session: session,
	            oldSession: oldSession
	        });
	        
	        this.curOp = null;
	        
	        oldSession && oldSession._signal("changeEditor", {oldEditor: this});
	        session && session._signal("changeEditor", {editor: this});
	    };
	    this.getSession = function() {
	        return this.session;
	    };
	    this.setValue = function(val, cursorPos) {
	        this.session.doc.setValue(val);
	
	        if (!cursorPos)
	            this.selectAll();
	        else if (cursorPos == 1)
	            this.navigateFileEnd();
	        else if (cursorPos == -1)
	            this.navigateFileStart();
	
	        return val;
	    };
	    this.getValue = function() {
	        return this.session.getValue();
	    };
	    this.getSelection = function() {
	        return this.selection;
	    };
	    this.resize = function(force) {
	        this.renderer.onResize(force);
	    };
	    this.setTheme = function(theme, cb) {
	        this.renderer.setTheme(theme, cb);
	    };
	    this.getTheme = function() {
	        return this.renderer.getTheme();
	    };
	    this.setStyle = function(style) {
	        this.renderer.setStyle(style);
	    };
	    this.unsetStyle = function(style) {
	        this.renderer.unsetStyle(style);
	    };
	    this.getFontSize = function () {
	        return this.getOption("fontSize") ||
	           dom.computedStyle(this.container, "fontSize");
	    };
	    this.setFontSize = function(size) {
	        this.setOption("fontSize", size);
	    };
	
	    this.$highlightBrackets = function() {
	        if (this.session.$bracketHighlight) {
	            this.session.removeMarker(this.session.$bracketHighlight);
	            this.session.$bracketHighlight = null;
	        }
	
	        if (this.$highlightPending) {
	            return;
	        }
	        var self = this;
	        this.$highlightPending = true;
	        setTimeout(function() {
	            self.$highlightPending = false;
	            var session = self.session;
	            if (!session || !session.bgTokenizer) return;
	            var pos = session.findMatchingBracket(self.getCursorPosition());
	            if (pos) {
	                var range = new Range(pos.row, pos.column, pos.row, pos.column + 1);
	            } else if (session.$mode.getMatching) {
	                var range = session.$mode.getMatching(self.session);
	            }
	            if (range)
	                session.$bracketHighlight = session.addMarker(range, "ace_bracket", "text");
	        }, 50);
	    };
	    this.$highlightTags = function() {
	        if (this.$highlightTagPending)
	            return;
	        var self = this;
	        this.$highlightTagPending = true;
	        setTimeout(function() {
	            self.$highlightTagPending = false;
	            
	            var session = self.session;
	            if (!session || !session.bgTokenizer) return;
	            
	            var pos = self.getCursorPosition();
	            var iterator = new TokenIterator(self.session, pos.row, pos.column);
	            var token = iterator.getCurrentToken();
	            
	            if (!token || !/\b(?:tag-open|tag-name)/.test(token.type)) {
	                session.removeMarker(session.$tagHighlight);
	                session.$tagHighlight = null;
	                return;
	            }
	            
	            if (token.type.indexOf("tag-open") != -1) {
	                token = iterator.stepForward();
	                if (!token)
	                    return;
	            }
	            
	            var tag = token.value;
	            var depth = 0;
	            var prevToken = iterator.stepBackward();
	            
	            if (prevToken.value == '<'){
	                do {
	                    prevToken = token;
	                    token = iterator.stepForward();
	                    
	                    if (token && token.value === tag && token.type.indexOf('tag-name') !== -1) {
	                        if (prevToken.value === '<'){
	                            depth++;
	                        } else if (prevToken.value === '</'){
	                            depth--;
	                        }
	                    }
	                    
	                } while (token && depth >= 0);
	            } else {
	                do {
	                    token = prevToken;
	                    prevToken = iterator.stepBackward();
	                    
	                    if (token && token.value === tag && token.type.indexOf('tag-name') !== -1) {
	                        if (prevToken.value === '<') {
	                            depth++;
	                        } else if (prevToken.value === '</') {
	                            depth--;
	                        }
	                    }
	                } while (prevToken && depth <= 0);
	                iterator.stepForward();
	            }
	            
	            if (!token) {
	                session.removeMarker(session.$tagHighlight);
	                session.$tagHighlight = null;
	                return;
	            }
	            
	            var row = iterator.getCurrentTokenRow();
	            var column = iterator.getCurrentTokenColumn();
	            var range = new Range(row, column, row, column+token.value.length);
	            var sbm = session.$backMarkers[session.$tagHighlight];
	            if (session.$tagHighlight && sbm != undefined && range.compareRange(sbm.range) !== 0) {
	                session.removeMarker(session.$tagHighlight);
	                session.$tagHighlight = null;
	            }
	            
	            if (range && !session.$tagHighlight)
	                session.$tagHighlight = session.addMarker(range, "ace_bracket", "text");
	        }, 50);
	    };
	    this.focus = function() {
	        var _self = this;
	        setTimeout(function() {
	            _self.textInput.focus();
	        });
	        this.textInput.focus();
	    };
	    this.isFocused = function() {
	        return this.textInput.isFocused();
	    };
	    this.blur = function() {
	        this.textInput.blur();
	    };
	    this.onFocus = function(e) {
	        if (this.$isFocused)
	            return;
	        this.$isFocused = true;
	        this.renderer.showCursor();
	        this.renderer.visualizeFocus();
	        this._emit("focus", e);
	    };
	    this.onBlur = function(e) {
	        if (!this.$isFocused)
	            return;
	        this.$isFocused = false;
	        this.renderer.hideCursor();
	        this.renderer.visualizeBlur();
	        this._emit("blur", e);
	    };
	
	    this.$cursorChange = function() {
	        this.renderer.updateCursor();
	    };
	    this.onDocumentChange = function(delta) {
	        var wrap = this.session.$useWrapMode;
	        var lastRow = (delta.start.row == delta.end.row ? delta.end.row : Infinity);
	        this.renderer.updateLines(delta.start.row, lastRow, wrap);
	
	        this._signal("change", delta);
	        this.$cursorChange();
	        this.$updateHighlightActiveLine();
	    };
	
	    this.onTokenizerUpdate = function(e) {
	        var rows = e.data;
	        this.renderer.updateLines(rows.first, rows.last);
	    };
	
	
	    this.onScrollTopChange = function() {
	        this.renderer.scrollToY(this.session.getScrollTop());
	    };
	
	    this.onScrollLeftChange = function() {
	        this.renderer.scrollToX(this.session.getScrollLeft());
	    };
	    this.onCursorChange = function() {
	        this.$cursorChange();
	
	        if (!this.$blockScrolling) {
	            config.warn("Automatically scrolling cursor into view after selection change",
	                "this will be disabled in the next version",
	                "set editor.$blockScrolling = Infinity to disable this message"
	            );
	            this.renderer.scrollCursorIntoView();
	        }
	
	        this.$highlightBrackets();
	        this.$highlightTags();
	        this.$updateHighlightActiveLine();
	        this._signal("changeSelection");
	    };
	
	    this.$updateHighlightActiveLine = function() {
	        var session = this.getSession();
	
	        var highlight;
	        if (this.$highlightActiveLine) {
	            if ((this.$selectionStyle != "line" || !this.selection.isMultiLine()))
	                highlight = this.getCursorPosition();
	            if (this.renderer.$maxLines && this.session.getLength() === 1 && !(this.renderer.$minLines > 1))
	                highlight = false;
	        }
	
	        if (session.$highlightLineMarker && !highlight) {
	            session.removeMarker(session.$highlightLineMarker.id);
	            session.$highlightLineMarker = null;
	        } else if (!session.$highlightLineMarker && highlight) {
	            var range = new Range(highlight.row, highlight.column, highlight.row, Infinity);
	            range.id = session.addMarker(range, "ace_active-line", "screenLine");
	            session.$highlightLineMarker = range;
	        } else if (highlight) {
	            session.$highlightLineMarker.start.row = highlight.row;
	            session.$highlightLineMarker.end.row = highlight.row;
	            session.$highlightLineMarker.start.column = highlight.column;
	            session._signal("changeBackMarker");
	        }
	    };
	
	    this.onSelectionChange = function(e) {
	        var session = this.session;
	
	        if (session.$selectionMarker) {
	            session.removeMarker(session.$selectionMarker);
	        }
	        session.$selectionMarker = null;
	
	        if (!this.selection.isEmpty()) {
	            var range = this.selection.getRange();
	            var style = this.getSelectionStyle();
	            session.$selectionMarker = session.addMarker(range, "ace_selection", style);
	        } else {
	            this.$updateHighlightActiveLine();
	        }
	
	        var re = this.$highlightSelectedWord && this.$getSelectionHighLightRegexp();
	        this.session.highlight(re);
	
	        this._signal("changeSelection");
	    };
	
	    this.$getSelectionHighLightRegexp = function() {
	        var session = this.session;
	
	        var selection = this.getSelectionRange();
	        if (selection.isEmpty() || selection.isMultiLine())
	            return;
	
	        var startOuter = selection.start.column - 1;
	        var endOuter = selection.end.column + 1;
	        var line = session.getLine(selection.start.row);
	        var lineCols = line.length;
	        var needle = line.substring(Math.max(startOuter, 0),
	                                    Math.min(endOuter, lineCols));
	        if ((startOuter >= 0 && /^[\w\d]/.test(needle)) ||
	            (endOuter <= lineCols && /[\w\d]$/.test(needle)))
	            return;
	
	        needle = line.substring(selection.start.column, selection.end.column);
	        if (!/^[\w\d]+$/.test(needle))
	            return;
	
	        var re = this.$search.$assembleRegExp({
	            wholeWord: true,
	            caseSensitive: true,
	            needle: needle
	        });
	
	        return re;
	    };
	
	
	    this.onChangeFrontMarker = function() {
	        this.renderer.updateFrontMarkers();
	    };
	
	    this.onChangeBackMarker = function() {
	        this.renderer.updateBackMarkers();
	    };
	
	
	    this.onChangeBreakpoint = function() {
	        this.renderer.updateBreakpoints();
	    };
	
	    this.onChangeAnnotation = function() {
	        this.renderer.setAnnotations(this.session.getAnnotations());
	    };
	
	
	    this.onChangeMode = function(e) {
	        this.renderer.updateText();
	        this._emit("changeMode", e);
	    };
	
	
	    this.onChangeWrapLimit = function() {
	        this.renderer.updateFull();
	    };
	
	    this.onChangeWrapMode = function() {
	        this.renderer.onResize(true);
	    };
	
	
	    this.onChangeFold = function() {
	        this.$updateHighlightActiveLine();
	        this.renderer.updateFull();
	    };
	    this.getSelectedText = function() {
	        return this.session.getTextRange(this.getSelectionRange());
	    };
	    this.getCopyText = function() {
	        var text = this.getSelectedText();
	        this._signal("copy", text);
	        return text;
	    };
	    this.onCopy = function() {
	        this.commands.exec("copy", this);
	    };
	    this.onCut = function() {
	        this.commands.exec("cut", this);
	    };
	    this.onPaste = function(text, event) {
	        var e = {text: text, event: event};
	        this.commands.exec("paste", this, e);
	    };
	    
	    this.$handlePaste = function(e) {
	        if (typeof e == "string") 
	            e = {text: e};
	        this._signal("paste", e);
	        var text = e.text;
	        if (!this.inMultiSelectMode || this.inVirtualSelectionMode) {
	            this.insert(text);
	        } else {
	            var lines = text.split(/\r\n|\r|\n/);
	            var ranges = this.selection.rangeList.ranges;
	    
	            if (lines.length > ranges.length || lines.length < 2 || !lines[1])
	                return this.commands.exec("insertstring", this, text);
	    
	            for (var i = ranges.length; i--;) {
	                var range = ranges[i];
	                if (!range.isEmpty())
	                    this.session.remove(range);
	    
	                this.session.insert(range.start, lines[i]);
	            }
	        }
	    };
	
	    this.execCommand = function(command, args) {
	        return this.commands.exec(command, this, args);
	    };
	    this.insert = function(text, pasted) {
	        var session = this.session;
	        var mode = session.getMode();
	        var cursor = this.getCursorPosition();
	
	        if (this.getBehavioursEnabled() && !pasted) {
	            var transform = mode.transformAction(session.getState(cursor.row), 'insertion', this, session, text);
	            if (transform) {
	                if (text !== transform.text) {
	                    this.session.mergeUndoDeltas = false;
	                    this.$mergeNextCommand = false;
	                }
	                text = transform.text;
	
	            }
	        }
	        
	        if (text == "\t")
	            text = this.session.getTabString();
	        if (!this.selection.isEmpty()) {
	            var range = this.getSelectionRange();
	            cursor = this.session.remove(range);
	            this.clearSelection();
	        }
	        else if (this.session.getOverwrite()) {
	            var range = new Range.fromPoints(cursor, cursor);
	            range.end.column += text.length;
	            this.session.remove(range);
	        }
	
	        if (text == "\n" || text == "\r\n") {
	            var line = session.getLine(cursor.row);
	            if (cursor.column > line.search(/\S|$/)) {
	                var d = line.substr(cursor.column).search(/\S|$/);
	                session.doc.removeInLine(cursor.row, cursor.column, cursor.column + d);
	            }
	        }
	        this.clearSelection();
	
	        var start = cursor.column;
	        var lineState = session.getState(cursor.row);
	        var line = session.getLine(cursor.row);
	        var shouldOutdent = mode.checkOutdent(lineState, line, text);
	        var end = session.insert(cursor, text);
	
	        if (transform && transform.selection) {
	            if (transform.selection.length == 2) { // Transform relative to the current column
	                this.selection.setSelectionRange(
	                    new Range(cursor.row, start + transform.selection[0],
	                              cursor.row, start + transform.selection[1]));
	            } else { // Transform relative to the current row.
	                this.selection.setSelectionRange(
	                    new Range(cursor.row + transform.selection[0],
	                              transform.selection[1],
	                              cursor.row + transform.selection[2],
	                              transform.selection[3]));
	            }
	        }
	
	        if (session.getDocument().isNewLine(text)) {
	            var lineIndent = mode.getNextLineIndent(lineState, line.slice(0, cursor.column), session.getTabString());
	
	            session.insert({row: cursor.row+1, column: 0}, lineIndent);
	        }
	        if (shouldOutdent)
	            mode.autoOutdent(lineState, session, cursor.row);
	    };
	
	    this.onTextInput = function(text) {
	        this.keyBinding.onTextInput(text);
	    };
	
	    this.onCommandKey = function(e, hashId, keyCode) {
	        this.keyBinding.onCommandKey(e, hashId, keyCode);
	    };
	    this.setOverwrite = function(overwrite) {
	        this.session.setOverwrite(overwrite);
	    };
	    this.getOverwrite = function() {
	        return this.session.getOverwrite();
	    };
	    this.toggleOverwrite = function() {
	        this.session.toggleOverwrite();
	    };
	    this.setScrollSpeed = function(speed) {
	        this.setOption("scrollSpeed", speed);
	    };
	    this.getScrollSpeed = function() {
	        return this.getOption("scrollSpeed");
	    };
	    this.setDragDelay = function(dragDelay) {
	        this.setOption("dragDelay", dragDelay);
	    };
	    this.getDragDelay = function() {
	        return this.getOption("dragDelay");
	    };
	    this.setSelectionStyle = function(val) {
	        this.setOption("selectionStyle", val);
	    };
	    this.getSelectionStyle = function() {
	        return this.getOption("selectionStyle");
	    };
	    this.setHighlightActiveLine = function(shouldHighlight) {
	        this.setOption("highlightActiveLine", shouldHighlight);
	    };
	    this.getHighlightActiveLine = function() {
	        return this.getOption("highlightActiveLine");
	    };
	    this.setHighlightGutterLine = function(shouldHighlight) {
	        this.setOption("highlightGutterLine", shouldHighlight);
	    };
	
	    this.getHighlightGutterLine = function() {
	        return this.getOption("highlightGutterLine");
	    };
	    this.setHighlightSelectedWord = function(shouldHighlight) {
	        this.setOption("highlightSelectedWord", shouldHighlight);
	    };
	    this.getHighlightSelectedWord = function() {
	        return this.$highlightSelectedWord;
	    };
	
	    this.setAnimatedScroll = function(shouldAnimate){
	        this.renderer.setAnimatedScroll(shouldAnimate);
	    };
	
	    this.getAnimatedScroll = function(){
	        return this.renderer.getAnimatedScroll();
	    };
	    this.setShowInvisibles = function(showInvisibles) {
	        this.renderer.setShowInvisibles(showInvisibles);
	    };
	    this.getShowInvisibles = function() {
	        return this.renderer.getShowInvisibles();
	    };
	
	    this.setDisplayIndentGuides = function(display) {
	        this.renderer.setDisplayIndentGuides(display);
	    };
	
	    this.getDisplayIndentGuides = function() {
	        return this.renderer.getDisplayIndentGuides();
	    };
	    this.setShowPrintMargin = function(showPrintMargin) {
	        this.renderer.setShowPrintMargin(showPrintMargin);
	    };
	    this.getShowPrintMargin = function() {
	        return this.renderer.getShowPrintMargin();
	    };
	    this.setPrintMarginColumn = function(showPrintMargin) {
	        this.renderer.setPrintMarginColumn(showPrintMargin);
	    };
	    this.getPrintMarginColumn = function() {
	        return this.renderer.getPrintMarginColumn();
	    };
	    this.setReadOnly = function(readOnly) {
	        this.setOption("readOnly", readOnly);
	    };
	    this.getReadOnly = function() {
	        return this.getOption("readOnly");
	    };
	    this.setBehavioursEnabled = function (enabled) {
	        this.setOption("behavioursEnabled", enabled);
	    };
	    this.getBehavioursEnabled = function () {
	        return this.getOption("behavioursEnabled");
	    };
	    this.setWrapBehavioursEnabled = function (enabled) {
	        this.setOption("wrapBehavioursEnabled", enabled);
	    };
	    this.getWrapBehavioursEnabled = function () {
	        return this.getOption("wrapBehavioursEnabled");
	    };
	    this.setShowFoldWidgets = function(show) {
	        this.setOption("showFoldWidgets", show);
	
	    };
	    this.getShowFoldWidgets = function() {
	        return this.getOption("showFoldWidgets");
	    };
	
	    this.setFadeFoldWidgets = function(fade) {
	        this.setOption("fadeFoldWidgets", fade);
	    };
	
	    this.getFadeFoldWidgets = function() {
	        return this.getOption("fadeFoldWidgets");
	    };
	    this.remove = function(dir) {
	        if (this.selection.isEmpty()){
	            if (dir == "left")
	                this.selection.selectLeft();
	            else
	                this.selection.selectRight();
	        }
	
	        var range = this.getSelectionRange();
	        if (this.getBehavioursEnabled()) {
	            var session = this.session;
	            var state = session.getState(range.start.row);
	            var new_range = session.getMode().transformAction(state, 'deletion', this, session, range);
	
	            if (range.end.column === 0) {
	                var text = session.getTextRange(range);
	                if (text[text.length - 1] == "\n") {
	                    var line = session.getLine(range.end.row);
	                    if (/^\s+$/.test(line)) {
	                        range.end.column = line.length;
	                    }
	                }
	            }
	            if (new_range)
	                range = new_range;
	        }
	
	        this.session.remove(range);
	        this.clearSelection();
	    };
	    this.removeWordRight = function() {
	        if (this.selection.isEmpty())
	            this.selection.selectWordRight();
	
	        this.session.remove(this.getSelectionRange());
	        this.clearSelection();
	    };
	    this.removeWordLeft = function() {
	        if (this.selection.isEmpty())
	            this.selection.selectWordLeft();
	
	        this.session.remove(this.getSelectionRange());
	        this.clearSelection();
	    };
	    this.removeToLineStart = function() {
	        if (this.selection.isEmpty())
	            this.selection.selectLineStart();
	
	        this.session.remove(this.getSelectionRange());
	        this.clearSelection();
	    };
	    this.removeToLineEnd = function() {
	        if (this.selection.isEmpty())
	            this.selection.selectLineEnd();
	
	        var range = this.getSelectionRange();
	        if (range.start.column == range.end.column && range.start.row == range.end.row) {
	            range.end.column = 0;
	            range.end.row++;
	        }
	
	        this.session.remove(range);
	        this.clearSelection();
	    };
	    this.splitLine = function() {
	        if (!this.selection.isEmpty()) {
	            this.session.remove(this.getSelectionRange());
	            this.clearSelection();
	        }
	
	        var cursor = this.getCursorPosition();
	        this.insert("\n");
	        this.moveCursorToPosition(cursor);
	    };
	    this.transposeLetters = function() {
	        if (!this.selection.isEmpty()) {
	            return;
	        }
	
	        var cursor = this.getCursorPosition();
	        var column = cursor.column;
	        if (column === 0)
	            return;
	
	        var line = this.session.getLine(cursor.row);
	        var swap, range;
	        if (column < line.length) {
	            swap = line.charAt(column) + line.charAt(column-1);
	            range = new Range(cursor.row, column-1, cursor.row, column+1);
	        }
	        else {
	            swap = line.charAt(column-1) + line.charAt(column-2);
	            range = new Range(cursor.row, column-2, cursor.row, column);
	        }
	        this.session.replace(range, swap);
	    };
	    this.toLowerCase = function() {
	        var originalRange = this.getSelectionRange();
	        if (this.selection.isEmpty()) {
	            this.selection.selectWord();
	        }
	
	        var range = this.getSelectionRange();
	        var text = this.session.getTextRange(range);
	        this.session.replace(range, text.toLowerCase());
	        this.selection.setSelectionRange(originalRange);
	    };
	    this.toUpperCase = function() {
	        var originalRange = this.getSelectionRange();
	        if (this.selection.isEmpty()) {
	            this.selection.selectWord();
	        }
	
	        var range = this.getSelectionRange();
	        var text = this.session.getTextRange(range);
	        this.session.replace(range, text.toUpperCase());
	        this.selection.setSelectionRange(originalRange);
	    };
	    this.indent = function() {
	        var session = this.session;
	        var range = this.getSelectionRange();
	
	        if (range.start.row < range.end.row) {
	            var rows = this.$getSelectedRows();
	            session.indentRows(rows.first, rows.last, "\t");
	            return;
	        } else if (range.start.column < range.end.column) {
	            var text = session.getTextRange(range);
	            if (!/^\s+$/.test(text)) {
	                var rows = this.$getSelectedRows();
	                session.indentRows(rows.first, rows.last, "\t");
	                return;
	            }
	        }
	        
	        var line = session.getLine(range.start.row);
	        var position = range.start;
	        var size = session.getTabSize();
	        var column = session.documentToScreenColumn(position.row, position.column);
	
	        if (this.session.getUseSoftTabs()) {
	            var count = (size - column % size);
	            var indentString = lang.stringRepeat(" ", count);
	        } else {
	            var count = column % size;
	            while (line[range.start.column - 1] == " " && count) {
	                range.start.column--;
	                count--;
	            }
	            this.selection.setSelectionRange(range);
	            indentString = "\t";
	        }
	        return this.insert(indentString);
	    };
	    this.blockIndent = function() {
	        var rows = this.$getSelectedRows();
	        this.session.indentRows(rows.first, rows.last, "\t");
	    };
	    this.blockOutdent = function() {
	        var selection = this.session.getSelection();
	        this.session.outdentRows(selection.getRange());
	    };
	    this.sortLines = function() {
	        var rows = this.$getSelectedRows();
	        var session = this.session;
	
	        var lines = [];
	        for (i = rows.first; i <= rows.last; i++)
	            lines.push(session.getLine(i));
	
	        lines.sort(function(a, b) {
	            if (a.toLowerCase() < b.toLowerCase()) return -1;
	            if (a.toLowerCase() > b.toLowerCase()) return 1;
	            return 0;
	        });
	
	        var deleteRange = new Range(0, 0, 0, 0);
	        for (var i = rows.first; i <= rows.last; i++) {
	            var line = session.getLine(i);
	            deleteRange.start.row = i;
	            deleteRange.end.row = i;
	            deleteRange.end.column = line.length;
	            session.replace(deleteRange, lines[i-rows.first]);
	        }
	    };
	    this.toggleCommentLines = function() {
	        var state = this.session.getState(this.getCursorPosition().row);
	        var rows = this.$getSelectedRows();
	        this.session.getMode().toggleCommentLines(state, this.session, rows.first, rows.last);
	    };
	
	    this.toggleBlockComment = function() {
	        var cursor = this.getCursorPosition();
	        var state = this.session.getState(cursor.row);
	        var range = this.getSelectionRange();
	        this.session.getMode().toggleBlockComment(state, this.session, range, cursor);
	    };
	    this.getNumberAt = function(row, column) {
	        var _numberRx = /[\-]?[0-9]+(?:\.[0-9]+)?/g;
	        _numberRx.lastIndex = 0;
	
	        var s = this.session.getLine(row);
	        while (_numberRx.lastIndex < column) {
	            var m = _numberRx.exec(s);
	            if(m.index <= column && m.index+m[0].length >= column){
	                var number = {
	                    value: m[0],
	                    start: m.index,
	                    end: m.index+m[0].length
	                };
	                return number;
	            }
	        }
	        return null;
	    };
	    this.modifyNumber = function(amount) {
	        var row = this.selection.getCursor().row;
	        var column = this.selection.getCursor().column;
	        var charRange = new Range(row, column-1, row, column);
	
	        var c = this.session.getTextRange(charRange);
	        if (!isNaN(parseFloat(c)) && isFinite(c)) {
	            var nr = this.getNumberAt(row, column);
	            if (nr) {
	                var fp = nr.value.indexOf(".") >= 0 ? nr.start + nr.value.indexOf(".") + 1 : nr.end;
	                var decimals = nr.start + nr.value.length - fp;
	
	                var t = parseFloat(nr.value);
	                t *= Math.pow(10, decimals);
	
	
	                if(fp !== nr.end && column < fp){
	                    amount *= Math.pow(10, nr.end - column - 1);
	                } else {
	                    amount *= Math.pow(10, nr.end - column);
	                }
	
	                t += amount;
	                t /= Math.pow(10, decimals);
	                var nnr = t.toFixed(decimals);
	                var replaceRange = new Range(row, nr.start, row, nr.end);
	                this.session.replace(replaceRange, nnr);
	                this.moveCursorTo(row, Math.max(nr.start +1, column + nnr.length - nr.value.length));
	
	            }
	        }
	    };
	    this.removeLines = function() {
	        var rows = this.$getSelectedRows();
	        this.session.removeFullLines(rows.first, rows.last);
	        this.clearSelection();
	    };
	
	    this.duplicateSelection = function() {
	        var sel = this.selection;
	        var doc = this.session;
	        var range = sel.getRange();
	        var reverse = sel.isBackwards();
	        if (range.isEmpty()) {
	            var row = range.start.row;
	            doc.duplicateLines(row, row);
	        } else {
	            var point = reverse ? range.start : range.end;
	            var endPoint = doc.insert(point, doc.getTextRange(range), false);
	            range.start = point;
	            range.end = endPoint;
	
	            sel.setSelectionRange(range, reverse);
	        }
	    };
	    this.moveLinesDown = function() {
	        this.$moveLines(1, false);
	    };
	    this.moveLinesUp = function() {
	        this.$moveLines(-1, false);
	    };
	    this.moveText = function(range, toPosition, copy) {
	        return this.session.moveText(range, toPosition, copy);
	    };
	    this.copyLinesUp = function() {
	        this.$moveLines(-1, true);
	    };
	    this.copyLinesDown = function() {
	        this.$moveLines(1, true);
	    };
	    this.$moveLines = function(dir, copy) {
	        var rows, moved;
	        var selection = this.selection;
	        if (!selection.inMultiSelectMode || this.inVirtualSelectionMode) {
	            var range = selection.toOrientedRange();
	            rows = this.$getSelectedRows(range);
	            moved = this.session.$moveLines(rows.first, rows.last, copy ? 0 : dir);
	            if (copy && dir == -1) moved = 0;
	            range.moveBy(moved, 0);
	            selection.fromOrientedRange(range);
	        } else {
	            var ranges = selection.rangeList.ranges;
	            selection.rangeList.detach(this.session);
	            this.inVirtualSelectionMode = true;
	            
	            var diff = 0;
	            var totalDiff = 0;
	            var l = ranges.length;
	            for (var i = 0; i < l; i++) {
	                var rangeIndex = i;
	                ranges[i].moveBy(diff, 0);
	                rows = this.$getSelectedRows(ranges[i]);
	                var first = rows.first;
	                var last = rows.last;
	                while (++i < l) {
	                    if (totalDiff) ranges[i].moveBy(totalDiff, 0);
	                    var subRows = this.$getSelectedRows(ranges[i]);
	                    if (copy && subRows.first != last)
	                        break;
	                    else if (!copy && subRows.first > last + 1)
	                        break;
	                    last = subRows.last;
	                }
	                i--;
	                diff = this.session.$moveLines(first, last, copy ? 0 : dir);
	                if (copy && dir == -1) rangeIndex = i + 1;
	                while (rangeIndex <= i) {
	                    ranges[rangeIndex].moveBy(diff, 0);
	                    rangeIndex++;
	                }
	                if (!copy) diff = 0;
	                totalDiff += diff;
	            }
	            
	            selection.fromOrientedRange(selection.ranges[0]);
	            selection.rangeList.attach(this.session);
	            this.inVirtualSelectionMode = false;
	        }
	    };
	    this.$getSelectedRows = function(range) {
	        range = (range || this.getSelectionRange()).collapseRows();
	
	        return {
	            first: this.session.getRowFoldStart(range.start.row),
	            last: this.session.getRowFoldEnd(range.end.row)
	        };
	    };
	
	    this.onCompositionStart = function(text) {
	        this.renderer.showComposition(this.getCursorPosition());
	    };
	
	    this.onCompositionUpdate = function(text) {
	        this.renderer.setCompositionText(text);
	    };
	
	    this.onCompositionEnd = function() {
	        this.renderer.hideComposition();
	    };
	    this.getFirstVisibleRow = function() {
	        return this.renderer.getFirstVisibleRow();
	    };
	    this.getLastVisibleRow = function() {
	        return this.renderer.getLastVisibleRow();
	    };
	    this.isRowVisible = function(row) {
	        return (row >= this.getFirstVisibleRow() && row <= this.getLastVisibleRow());
	    };
	    this.isRowFullyVisible = function(row) {
	        return (row >= this.renderer.getFirstFullyVisibleRow() && row <= this.renderer.getLastFullyVisibleRow());
	    };
	    this.$getVisibleRowCount = function() {
	        return this.renderer.getScrollBottomRow() - this.renderer.getScrollTopRow() + 1;
	    };
	
	    this.$moveByPage = function(dir, select) {
	        var renderer = this.renderer;
	        var config = this.renderer.layerConfig;
	        var rows = dir * Math.floor(config.height / config.lineHeight);
	
	        this.$blockScrolling++;
	        if (select === true) {
	            this.selection.$moveSelection(function(){
	                this.moveCursorBy(rows, 0);
	            });
	        } else if (select === false) {
	            this.selection.moveCursorBy(rows, 0);
	            this.selection.clearSelection();
	        }
	        this.$blockScrolling--;
	
	        var scrollTop = renderer.scrollTop;
	
	        renderer.scrollBy(0, rows * config.lineHeight);
	        if (select != null)
	            renderer.scrollCursorIntoView(null, 0.5);
	
	        renderer.animateScrolling(scrollTop);
	    };
	    this.selectPageDown = function() {
	        this.$moveByPage(1, true);
	    };
	    this.selectPageUp = function() {
	        this.$moveByPage(-1, true);
	    };
	    this.gotoPageDown = function() {
	       this.$moveByPage(1, false);
	    };
	    this.gotoPageUp = function() {
	        this.$moveByPage(-1, false);
	    };
	    this.scrollPageDown = function() {
	        this.$moveByPage(1);
	    };
	    this.scrollPageUp = function() {
	        this.$moveByPage(-1);
	    };
	    this.scrollToRow = function(row) {
	        this.renderer.scrollToRow(row);
	    };
	    this.scrollToLine = function(line, center, animate, callback) {
	        this.renderer.scrollToLine(line, center, animate, callback);
	    };
	    this.centerSelection = function() {
	        var range = this.getSelectionRange();
	        var pos = {
	            row: Math.floor(range.start.row + (range.end.row - range.start.row) / 2),
	            column: Math.floor(range.start.column + (range.end.column - range.start.column) / 2)
	        };
	        this.renderer.alignCursor(pos, 0.5);
	    };
	    this.getCursorPosition = function() {
	        return this.selection.getCursor();
	    };
	    this.getCursorPositionScreen = function() {
	        return this.session.documentToScreenPosition(this.getCursorPosition());
	    };
	    this.getSelectionRange = function() {
	        return this.selection.getRange();
	    };
	    this.selectAll = function() {
	        this.$blockScrolling += 1;
	        this.selection.selectAll();
	        this.$blockScrolling -= 1;
	    };
	    this.clearSelection = function() {
	        this.selection.clearSelection();
	    };
	    this.moveCursorTo = function(row, column) {
	        this.selection.moveCursorTo(row, column);
	    };
	    this.moveCursorToPosition = function(pos) {
	        this.selection.moveCursorToPosition(pos);
	    };
	    this.jumpToMatching = function(select, expand) {
	        var cursor = this.getCursorPosition();
	        var iterator = new TokenIterator(this.session, cursor.row, cursor.column);
	        var prevToken = iterator.getCurrentToken();
	        var token = prevToken || iterator.stepForward();
	
	        if (!token) return;
	        var matchType;
	        var found = false;
	        var depth = {};
	        var i = cursor.column - token.start;
	        var bracketType;
	        var brackets = {
	            ")": "(",
	            "(": "(",
	            "]": "[",
	            "[": "[",
	            "{": "{",
	            "}": "{"
	        };
	        
	        do {
	            if (token.value.match(/[{}()\[\]]/g)) {
	                for (; i < token.value.length && !found; i++) {
	                    if (!brackets[token.value[i]]) {
	                        continue;
	                    }
	
	                    bracketType = brackets[token.value[i]] + '.' + token.type.replace("rparen", "lparen");
	
	                    if (isNaN(depth[bracketType])) {
	                        depth[bracketType] = 0;
	                    }
	
	                    switch (token.value[i]) {
	                        case '(':
	                        case '[':
	                        case '{':
	                            depth[bracketType]++;
	                            break;
	                        case ')':
	                        case ']':
	                        case '}':
	                            depth[bracketType]--;
	
	                            if (depth[bracketType] === -1) {
	                                matchType = 'bracket';
	                                found = true;
	                            }
	                        break;
	                    }
	                }
	            }
	            else if (token && token.type.indexOf('tag-name') !== -1) {
	                if (isNaN(depth[token.value])) {
	                    depth[token.value] = 0;
	                }
	                
	                if (prevToken.value === '<') {
	                    depth[token.value]++;
	                }
	                else if (prevToken.value === '</') {
	                    depth[token.value]--;
	                }
	                
	                if (depth[token.value] === -1) {
	                    matchType = 'tag';
	                    found = true;
	                }
	            }
	
	            if (!found) {
	                prevToken = token;
	                token = iterator.stepForward();
	                i = 0;
	            }
	        } while (token && !found);
	        if (!matchType)
	            return;
	
	        var range, pos;
	        if (matchType === 'bracket') {
	            range = this.session.getBracketRange(cursor);
	            if (!range) {
	                range = new Range(
	                    iterator.getCurrentTokenRow(),
	                    iterator.getCurrentTokenColumn() + i - 1,
	                    iterator.getCurrentTokenRow(),
	                    iterator.getCurrentTokenColumn() + i - 1
	                );
	                pos = range.start;
	                if (expand || pos.row === cursor.row && Math.abs(pos.column - cursor.column) < 2)
	                    range = this.session.getBracketRange(pos);
	            }
	        }
	        else if (matchType === 'tag') {
	            if (token && token.type.indexOf('tag-name') !== -1) 
	                var tag = token.value;
	            else
	                return;
	
	            range = new Range(
	                iterator.getCurrentTokenRow(),
	                iterator.getCurrentTokenColumn() - 2,
	                iterator.getCurrentTokenRow(),
	                iterator.getCurrentTokenColumn() - 2
	            );
	            if (range.compare(cursor.row, cursor.column) === 0) {
	                found = false;
	                do {
	                    token = prevToken;
	                    prevToken = iterator.stepBackward();
	                    
	                    if (prevToken) {
	                        if (prevToken.type.indexOf('tag-close') !== -1) {
	                            range.setEnd(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1);
	                        }
	
	                        if (token.value === tag && token.type.indexOf('tag-name') !== -1) {
	                            if (prevToken.value === '<') {
	                                depth[tag]++;
	                            }
	                            else if (prevToken.value === '</') {
	                                depth[tag]--;
	                            }
	                            
	                            if (depth[tag] === 0)
	                                found = true;
	                        }
	                    }
	                } while (prevToken && !found);
	            }
	            if (token && token.type.indexOf('tag-name')) {
	                pos = range.start;
	                if (pos.row == cursor.row && Math.abs(pos.column - cursor.column) < 2)
	                    pos = range.end;
	            }
	        }
	
	        pos = range && range.cursor || pos;
	        if (pos) {
	            if (select) {
	                if (range && expand) {
	                    this.selection.setRange(range);
	                } else if (range && range.isEqual(this.getSelectionRange())) {
	                    this.clearSelection();
	                } else {
	                    this.selection.selectTo(pos.row, pos.column);
	                }
	            } else {
	                this.selection.moveTo(pos.row, pos.column);
	            }
	        }
	    };
	    this.gotoLine = function(lineNumber, column, animate) {
	        this.selection.clearSelection();
	        this.session.unfold({row: lineNumber - 1, column: column || 0});
	
	        this.$blockScrolling += 1;
	        this.exitMultiSelectMode && this.exitMultiSelectMode();
	        this.moveCursorTo(lineNumber - 1, column || 0);
	        this.$blockScrolling -= 1;
	
	        if (!this.isRowFullyVisible(lineNumber - 1))
	            this.scrollToLine(lineNumber - 1, true, animate);
	    };
	    this.navigateTo = function(row, column) {
	        this.selection.moveTo(row, column);
	    };
	    this.navigateUp = function(times) {
	        if (this.selection.isMultiLine() && !this.selection.isBackwards()) {
	            var selectionStart = this.selection.anchor.getPosition();
	            return this.moveCursorToPosition(selectionStart);
	        }
	        this.selection.clearSelection();
	        this.selection.moveCursorBy(-times || -1, 0);
	    };
	    this.navigateDown = function(times) {
	        if (this.selection.isMultiLine() && this.selection.isBackwards()) {
	            var selectionEnd = this.selection.anchor.getPosition();
	            return this.moveCursorToPosition(selectionEnd);
	        }
	        this.selection.clearSelection();
	        this.selection.moveCursorBy(times || 1, 0);
	    };
	    this.navigateLeft = function(times) {
	        if (!this.selection.isEmpty()) {
	            var selectionStart = this.getSelectionRange().start;
	            this.moveCursorToPosition(selectionStart);
	        }
	        else {
	            times = times || 1;
	            while (times--) {
	                this.selection.moveCursorLeft();
	            }
	        }
	        this.clearSelection();
	    };
	    this.navigateRight = function(times) {
	        if (!this.selection.isEmpty()) {
	            var selectionEnd = this.getSelectionRange().end;
	            this.moveCursorToPosition(selectionEnd);
	        }
	        else {
	            times = times || 1;
	            while (times--) {
	                this.selection.moveCursorRight();
	            }
	        }
	        this.clearSelection();
	    };
	    this.navigateLineStart = function() {
	        this.selection.moveCursorLineStart();
	        this.clearSelection();
	    };
	    this.navigateLineEnd = function() {
	        this.selection.moveCursorLineEnd();
	        this.clearSelection();
	    };
	    this.navigateFileEnd = function() {
	        this.selection.moveCursorFileEnd();
	        this.clearSelection();
	    };
	    this.navigateFileStart = function() {
	        this.selection.moveCursorFileStart();
	        this.clearSelection();
	    };
	    this.navigateWordRight = function() {
	        this.selection.moveCursorWordRight();
	        this.clearSelection();
	    };
	    this.navigateWordLeft = function() {
	        this.selection.moveCursorWordLeft();
	        this.clearSelection();
	    };
	    this.replace = function(replacement, options) {
	        if (options)
	            this.$search.set(options);
	
	        var range = this.$search.find(this.session);
	        var replaced = 0;
	        if (!range)
	            return replaced;
	
	        if (this.$tryReplace(range, replacement)) {
	            replaced = 1;
	        }
	        if (range !== null) {
	            this.selection.setSelectionRange(range);
	            this.renderer.scrollSelectionIntoView(range.start, range.end);
	        }
	
	        return replaced;
	    };
	    this.replaceAll = function(replacement, options) {
	        if (options) {
	            this.$search.set(options);
	        }
	
	        var ranges = this.$search.findAll(this.session);
	        var replaced = 0;
	        if (!ranges.length)
	            return replaced;
	
	        this.$blockScrolling += 1;
	
	        var selection = this.getSelectionRange();
	        this.selection.moveTo(0, 0);
	
	        for (var i = ranges.length - 1; i >= 0; --i) {
	            if(this.$tryReplace(ranges[i], replacement)) {
	                replaced++;
	            }
	        }
	
	        this.selection.setSelectionRange(selection);
	        this.$blockScrolling -= 1;
	
	        return replaced;
	    };
	
	    this.$tryReplace = function(range, replacement) {
	        var input = this.session.getTextRange(range);
	        replacement = this.$search.replace(input, replacement);
	        if (replacement !== null) {
	            range.end = this.session.replace(range, replacement);
	            return range;
	        } else {
	            return null;
	        }
	    };
	    this.getLastSearchOptions = function() {
	        return this.$search.getOptions();
	    };
	    this.find = function(needle, options, animate) {
	        if (!options)
	            options = {};
	
	        if (typeof needle == "string" || needle instanceof RegExp)
	            options.needle = needle;
	        else if (typeof needle == "object")
	            oop.mixin(options, needle);
	
	        var range = this.selection.getRange();
	        if (options.needle == null) {
	            needle = this.session.getTextRange(range)
	                || this.$search.$options.needle;
	            if (!needle) {
	                range = this.session.getWordRange(range.start.row, range.start.column);
	                needle = this.session.getTextRange(range);
	            }
	            this.$search.set({needle: needle});
	        }
	
	        this.$search.set(options);
	        if (!options.start)
	            this.$search.set({start: range});
	
	        var newRange = this.$search.find(this.session);
	        if (options.preventScroll)
	            return newRange;
	        if (newRange) {
	            this.revealRange(newRange, animate);
	            return newRange;
	        }
	        if (options.backwards)
	            range.start = range.end;
	        else
	            range.end = range.start;
	        this.selection.setRange(range);
	    };
	    this.findNext = function(options, animate) {
	        this.find({skipCurrent: true, backwards: false}, options, animate);
	    };
	    this.findPrevious = function(options, animate) {
	        this.find(options, {skipCurrent: true, backwards: true}, animate);
	    };
	
	    this.revealRange = function(range, animate) {
	        this.$blockScrolling += 1;
	        this.session.unfold(range);
	        this.selection.setSelectionRange(range);
	        this.$blockScrolling -= 1;
	
	        var scrollTop = this.renderer.scrollTop;
	        this.renderer.scrollSelectionIntoView(range.start, range.end, 0.5);
	        if (animate !== false)
	            this.renderer.animateScrolling(scrollTop);
	    };
	    this.undo = function() {
	        this.$blockScrolling++;
	        this.session.getUndoManager().undo();
	        this.$blockScrolling--;
	        this.renderer.scrollCursorIntoView(null, 0.5);
	    };
	    this.redo = function() {
	        this.$blockScrolling++;
	        this.session.getUndoManager().redo();
	        this.$blockScrolling--;
	        this.renderer.scrollCursorIntoView(null, 0.5);
	    };
	    this.destroy = function() {
	        this.renderer.destroy();
	        this._signal("destroy", this);
	        if (this.session) {
	            this.session.destroy();
	        }
	    };
	    this.setAutoScrollEditorIntoView = function(enable) {
	        if (!enable)
	            return;
	        var rect;
	        var self = this;
	        var shouldScroll = false;
	        if (!this.$scrollAnchor)
	            this.$scrollAnchor = document.createElement("div");
	        var scrollAnchor = this.$scrollAnchor;
	        scrollAnchor.style.cssText = "position:absolute";
	        this.container.insertBefore(scrollAnchor, this.container.firstChild);
	        var onChangeSelection = this.on("changeSelection", function() {
	            shouldScroll = true;
	        });
	        var onBeforeRender = this.renderer.on("beforeRender", function() {
	            if (shouldScroll)
	                rect = self.renderer.container.getBoundingClientRect();
	        });
	        var onAfterRender = this.renderer.on("afterRender", function() {
	            if (shouldScroll && rect && (self.isFocused()
	                || self.searchBox && self.searchBox.isFocused())
	            ) {
	                var renderer = self.renderer;
	                var pos = renderer.$cursorLayer.$pixelPos;
	                var config = renderer.layerConfig;
	                var top = pos.top - config.offset;
	                if (pos.top >= 0 && top + rect.top < 0) {
	                    shouldScroll = true;
	                } else if (pos.top < config.height &&
	                    pos.top + rect.top + config.lineHeight > window.innerHeight) {
	                    shouldScroll = false;
	                } else {
	                    shouldScroll = null;
	                }
	                if (shouldScroll != null) {
	                    scrollAnchor.style.top = top + "px";
	                    scrollAnchor.style.left = pos.left + "px";
	                    scrollAnchor.style.height = config.lineHeight + "px";
	                    scrollAnchor.scrollIntoView(shouldScroll);
	                }
	                shouldScroll = rect = null;
	            }
	        });
	        this.setAutoScrollEditorIntoView = function(enable) {
	            if (enable)
	                return;
	            delete this.setAutoScrollEditorIntoView;
	            this.off("changeSelection", onChangeSelection);
	            this.renderer.off("afterRender", onAfterRender);
	            this.renderer.off("beforeRender", onBeforeRender);
	        };
	    };
	
	
	    this.$resetCursorStyle = function() {
	        var style = this.$cursorStyle || "ace";
	        var cursorLayer = this.renderer.$cursorLayer;
	        if (!cursorLayer)
	            return;
	        cursorLayer.setSmoothBlinking(/smooth/.test(style));
	        cursorLayer.isBlinking = !this.$readOnly && style != "wide";
	        dom.setCssClass(cursorLayer.element, "ace_slim-cursors", /slim/.test(style));
	    };
	
	}).call(Editor.prototype);
	
	
	
	config.defineOptions(Editor.prototype, "editor", {
	    selectionStyle: {
	        set: function(style) {
	            this.onSelectionChange();
	            this._signal("changeSelectionStyle", {data: style});
	        },
	        initialValue: "line"
	    },
	    highlightActiveLine: {
	        set: function() {this.$updateHighlightActiveLine();},
	        initialValue: true
	    },
	    highlightSelectedWord: {
	        set: function(shouldHighlight) {this.$onSelectionChange();},
	        initialValue: true
	    },
	    readOnly: {
	        set: function(readOnly) {
	            this.$resetCursorStyle(); 
	        },
	        initialValue: false
	    },
	    cursorStyle: {
	        set: function(val) { this.$resetCursorStyle(); },
	        values: ["ace", "slim", "smooth", "wide"],
	        initialValue: "ace"
	    },
	    mergeUndoDeltas: {
	        values: [false, true, "always"],
	        initialValue: true
	    },
	    behavioursEnabled: {initialValue: true},
	    wrapBehavioursEnabled: {initialValue: true},
	    autoScrollEditorIntoView: {
	        set: function(val) {this.setAutoScrollEditorIntoView(val)}
	    },
	    keyboardHandler: {
	        set: function(val) { this.setKeyboardHandler(val); },
	        get: function() { return this.keybindingId; },
	        handlesSet: true
	    },
	
	    hScrollBarAlwaysVisible: "renderer",
	    vScrollBarAlwaysVisible: "renderer",
	    highlightGutterLine: "renderer",
	    animatedScroll: "renderer",
	    showInvisibles: "renderer",
	    showPrintMargin: "renderer",
	    printMarginColumn: "renderer",
	    printMargin: "renderer",
	    fadeFoldWidgets: "renderer",
	    showFoldWidgets: "renderer",
	    showLineNumbers: "renderer",
	    showGutter: "renderer",
	    displayIndentGuides: "renderer",
	    fontSize: "renderer",
	    fontFamily: "renderer",
	    maxLines: "renderer",
	    minLines: "renderer",
	    scrollPastEnd: "renderer",
	    fixedWidthGutter: "renderer",
	    theme: "renderer",
	
	    scrollSpeed: "$mouseHandler",
	    dragDelay: "$mouseHandler",
	    dragEnabled: "$mouseHandler",
	    focusTimout: "$mouseHandler",
	    tooltipFollowsMouse: "$mouseHandler",
	
	    firstLineNumber: "session",
	    overwrite: "session",
	    newLineMode: "session",
	    useWorker: "session",
	    useSoftTabs: "session",
	    tabSize: "session",
	    wrap: "session",
	    indentedSoftWrap: "session",
	    foldStyle: "session",
	    mode: "session"
	});
	
	exports.Editor = Editor;
	});
	
	ace.define("ace/undomanager",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	var UndoManager = function() {
	    this.reset();
	};
	
	(function() {
	    this.execute = function(options) {
	        var deltaSets = options.args[0];
	        this.$doc  = options.args[1];
	        if (options.merge && this.hasUndo()){
	            this.dirtyCounter--;
	            deltaSets = this.$undoStack.pop().concat(deltaSets);
	        }
	        this.$undoStack.push(deltaSets);
	        this.$redoStack = [];
	        if (this.dirtyCounter < 0) {
	            this.dirtyCounter = NaN;
	        }
	        this.dirtyCounter++;
	    };
	    this.undo = function(dontSelect) {
	        var deltaSets = this.$undoStack.pop();
	        var undoSelectionRange = null;
	        if (deltaSets) {
	            undoSelectionRange = this.$doc.undoChanges(deltaSets, dontSelect);
	            this.$redoStack.push(deltaSets);
	            this.dirtyCounter--;
	        }
	
	        return undoSelectionRange;
	    };
	    this.redo = function(dontSelect) {
	        var deltaSets = this.$redoStack.pop();
	        var redoSelectionRange = null;
	        if (deltaSets) {
	            redoSelectionRange =
	                this.$doc.redoChanges(this.$deserializeDeltas(deltaSets), dontSelect);
	            this.$undoStack.push(deltaSets);
	            this.dirtyCounter++;
	        }
	        return redoSelectionRange;
	    };
	    this.reset = function() {
	        this.$undoStack = [];
	        this.$redoStack = [];
	        this.dirtyCounter = 0;
	    };
	    this.hasUndo = function() {
	        return this.$undoStack.length > 0;
	    };
	    this.hasRedo = function() {
	        return this.$redoStack.length > 0;
	    };
	    this.markClean = function() {
	        this.dirtyCounter = 0;
	    };
	    this.isClean = function() {
	        return this.dirtyCounter === 0;
	    };
	    this.$serializeDeltas = function(deltaSets) {
	        return cloneDeltaSetsObj(deltaSets, $serializeDelta);
	    };
	    this.$deserializeDeltas = function(deltaSets) {
	        return cloneDeltaSetsObj(deltaSets, $deserializeDelta);
	    };
	    
	    function $serializeDelta(delta){
	        return {
	            action: delta.action,
	            start: delta.start,
	            end: delta.end,
	            lines: delta.lines.length == 1 ? null : delta.lines,
	            text: delta.lines.length == 1 ? delta.lines[0] : null
	        };
	    }
	        
	    function $deserializeDelta(delta) {
	        return {
	            action: delta.action,
	            start: delta.start,
	            end: delta.end,
	            lines: delta.lines || [delta.text]
	        };
	    }
	    
	    function cloneDeltaSetsObj(deltaSets_old, fnGetModifiedDelta) {
	        var deltaSets_new = new Array(deltaSets_old.length);
	        for (var i = 0; i < deltaSets_old.length; i++) {
	            var deltaSet_old = deltaSets_old[i];
	            var deltaSet_new = { group: deltaSet_old.group, deltas: new Array(deltaSet_old.length)};
	            
	            for (var j = 0; j < deltaSet_old.deltas.length; j++) {
	                var delta_old = deltaSet_old.deltas[j];
	                deltaSet_new.deltas[j] = fnGetModifiedDelta(delta_old);
	            }
	            
	            deltaSets_new[i] = deltaSet_new;
	        }
	        return deltaSets_new;
	    }
	    
	}).call(UndoManager.prototype);
	
	exports.UndoManager = UndoManager;
	});
	
	ace.define("ace/layer/gutter",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter"], function(acequire, exports, module) {
	"use strict";
	
	var dom = acequire("../lib/dom");
	var oop = acequire("../lib/oop");
	var lang = acequire("../lib/lang");
	var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
	
	var Gutter = function(parentEl) {
	    this.element = dom.createElement("div");
	    this.element.className = "ace_layer ace_gutter-layer";
	    parentEl.appendChild(this.element);
	    this.setShowFoldWidgets(this.$showFoldWidgets);
	    
	    this.gutterWidth = 0;
	
	    this.$annotations = [];
	    this.$updateAnnotations = this.$updateAnnotations.bind(this);
	
	    this.$cells = [];
	};
	
	(function() {
	
	    oop.implement(this, EventEmitter);
	
	    this.setSession = function(session) {
	        if (this.session)
	            this.session.removeEventListener("change", this.$updateAnnotations);
	        this.session = session;
	        if (session)
	            session.on("change", this.$updateAnnotations);
	    };
	
	    this.addGutterDecoration = function(row, className){
	        if (window.console)
	            console.warn && console.warn("deprecated use session.addGutterDecoration");
	        this.session.addGutterDecoration(row, className);
	    };
	
	    this.removeGutterDecoration = function(row, className){
	        if (window.console)
	            console.warn && console.warn("deprecated use session.removeGutterDecoration");
	        this.session.removeGutterDecoration(row, className);
	    };
	
	    this.setAnnotations = function(annotations) {
	        this.$annotations = [];
	        for (var i = 0; i < annotations.length; i++) {
	            var annotation = annotations[i];
	            var row = annotation.row;
	            var rowInfo = this.$annotations[row];
	            if (!rowInfo)
	                rowInfo = this.$annotations[row] = {text: []};
	           
	            var annoText = annotation.text;
	            annoText = annoText ? lang.escapeHTML(annoText) : annotation.html || "";
	
	            if (rowInfo.text.indexOf(annoText) === -1)
	                rowInfo.text.push(annoText);
	
	            var type = annotation.type;
	            if (type == "error")
	                rowInfo.className = " ace_error";
	            else if (type == "warning" && rowInfo.className != " ace_error")
	                rowInfo.className = " ace_warning";
	            else if (type == "info" && (!rowInfo.className))
	                rowInfo.className = " ace_info";
	        }
	    };
	
	    this.$updateAnnotations = function (delta) {
	        if (!this.$annotations.length)
	            return;
	        var firstRow = delta.start.row;
	        var len = delta.end.row - firstRow;
	        if (len === 0) {
	        } else if (delta.action == 'remove') {
	            this.$annotations.splice(firstRow, len + 1, null);
	        } else {
	            var args = new Array(len + 1);
	            args.unshift(firstRow, 1);
	            this.$annotations.splice.apply(this.$annotations, args);
	        }
	    };
	
	    this.update = function(config) {
	        var session = this.session;
	        var firstRow = config.firstRow;
	        var lastRow = Math.min(config.lastRow + config.gutterOffset,  // needed to compensate for hor scollbar
	            session.getLength() - 1);
	        var fold = session.getNextFoldLine(firstRow);
	        var foldStart = fold ? fold.start.row : Infinity;
	        var foldWidgets = this.$showFoldWidgets && session.foldWidgets;
	        var breakpoints = session.$breakpoints;
	        var decorations = session.$decorations;
	        var firstLineNumber = session.$firstLineNumber;
	        var lastLineNumber = 0;
	        
	        var gutterRenderer = session.gutterRenderer || this.$renderer;
	
	        var cell = null;
	        var index = -1;
	        var row = firstRow;
	        while (true) {
	            if (row > foldStart) {
	                row = fold.end.row + 1;
	                fold = session.getNextFoldLine(row, fold);
	                foldStart = fold ? fold.start.row : Infinity;
	            }
	            if (row > lastRow) {
	                while (this.$cells.length > index + 1) {
	                    cell = this.$cells.pop();
	                    this.element.removeChild(cell.element);
	                }
	                break;
	            }
	
	            cell = this.$cells[++index];
	            if (!cell) {
	                cell = {element: null, textNode: null, foldWidget: null};
	                cell.element = dom.createElement("div");
	                cell.textNode = document.createTextNode('');
	                cell.element.appendChild(cell.textNode);
	                this.element.appendChild(cell.element);
	                this.$cells[index] = cell;
	            }
	
	            var className = "ace_gutter-cell ";
	            if (breakpoints[row])
	                className += breakpoints[row];
	            if (decorations[row])
	                className += decorations[row];
	            if (this.$annotations[row])
	                className += this.$annotations[row].className;
	            if (cell.element.className != className)
	                cell.element.className = className;
	
	            var height = session.getRowLength(row) * config.lineHeight + "px";
	            if (height != cell.element.style.height)
	                cell.element.style.height = height;
	
	            if (foldWidgets) {
	                var c = foldWidgets[row];
	                if (c == null)
	                    c = foldWidgets[row] = session.getFoldWidget(row);
	            }
	
	            if (c) {
	                if (!cell.foldWidget) {
	                    cell.foldWidget = dom.createElement("span");
	                    cell.element.appendChild(cell.foldWidget);
	                }
	                var className = "ace_fold-widget ace_" + c;
	                if (c == "start" && row == foldStart && row < fold.end.row)
	                    className += " ace_closed";
	                else
	                    className += " ace_open";
	                if (cell.foldWidget.className != className)
	                    cell.foldWidget.className = className;
	
	                var height = config.lineHeight + "px";
	                if (cell.foldWidget.style.height != height)
	                    cell.foldWidget.style.height = height;
	            } else {
	                if (cell.foldWidget) {
	                    cell.element.removeChild(cell.foldWidget);
	                    cell.foldWidget = null;
	                }
	            }
	            
	            var text = lastLineNumber = gutterRenderer
	                ? gutterRenderer.getText(session, row)
	                : row + firstLineNumber;
	            if (text != cell.textNode.data)
	                cell.textNode.data = text;
	
	            row++;
	        }
	
	        this.element.style.height = config.minHeight + "px";
	
	        if (this.$fixedWidth || session.$useWrapMode)
	            lastLineNumber = session.getLength() + firstLineNumber;
	
	        var gutterWidth = gutterRenderer 
	            ? gutterRenderer.getWidth(session, lastLineNumber, config)
	            : lastLineNumber.toString().length * config.characterWidth;
	        
	        var padding = this.$padding || this.$computePadding();
	        gutterWidth += padding.left + padding.right;
	        if (gutterWidth !== this.gutterWidth && !isNaN(gutterWidth)) {
	            this.gutterWidth = gutterWidth;
	            this.element.style.width = Math.ceil(this.gutterWidth) + "px";
	            this._emit("changeGutterWidth", gutterWidth);
	        }
	    };
	
	    this.$fixedWidth = false;
	    
	    this.$showLineNumbers = true;
	    this.$renderer = "";
	    this.setShowLineNumbers = function(show) {
	        this.$renderer = !show && {
	            getWidth: function() {return ""},
	            getText: function() {return ""}
	        };
	    };
	    
	    this.getShowLineNumbers = function() {
	        return this.$showLineNumbers;
	    };
	    
	    this.$showFoldWidgets = true;
	    this.setShowFoldWidgets = function(show) {
	        if (show)
	            dom.addCssClass(this.element, "ace_folding-enabled");
	        else
	            dom.removeCssClass(this.element, "ace_folding-enabled");
	
	        this.$showFoldWidgets = show;
	        this.$padding = null;
	    };
	    
	    this.getShowFoldWidgets = function() {
	        return this.$showFoldWidgets;
	    };
	
	    this.$computePadding = function() {
	        if (!this.element.firstChild)
	            return {left: 0, right: 0};
	        var style = dom.computedStyle(this.element.firstChild);
	        this.$padding = {};
	        this.$padding.left = parseInt(style.paddingLeft) + 1 || 0;
	        this.$padding.right = parseInt(style.paddingRight) || 0;
	        return this.$padding;
	    };
	
	    this.getRegion = function(point) {
	        var padding = this.$padding || this.$computePadding();
	        var rect = this.element.getBoundingClientRect();
	        if (point.x < padding.left + rect.left)
	            return "markers";
	        if (this.$showFoldWidgets && point.x > rect.right - padding.right)
	            return "foldWidgets";
	    };
	
	}).call(Gutter.prototype);
	
	exports.Gutter = Gutter;
	
	});
	
	ace.define("ace/layer/marker",["require","exports","module","ace/range","ace/lib/dom"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	var dom = acequire("../lib/dom");
	
	var Marker = function(parentEl) {
	    this.element = dom.createElement("div");
	    this.element.className = "ace_layer ace_marker-layer";
	    parentEl.appendChild(this.element);
	};
	
	(function() {
	
	    this.$padding = 0;
	
	    this.setPadding = function(padding) {
	        this.$padding = padding;
	    };
	    this.setSession = function(session) {
	        this.session = session;
	    };
	    
	    this.setMarkers = function(markers) {
	        this.markers = markers;
	    };
	
	    this.update = function(config) {
	        var config = config || this.config;
	        if (!config)
	            return;
	
	        this.config = config;
	
	
	        var html = [];
	        for (var key in this.markers) {
	            var marker = this.markers[key];
	
	            if (!marker.range) {
	                marker.update(html, this, this.session, config);
	                continue;
	            }
	
	            var range = marker.range.clipRows(config.firstRow, config.lastRow);
	            if (range.isEmpty()) continue;
	
	            range = range.toScreenRange(this.session);
	            if (marker.renderer) {
	                var top = this.$getTop(range.start.row, config);
	                var left = this.$padding + range.start.column * config.characterWidth;
	                marker.renderer(html, range, left, top, config);
	            } else if (marker.type == "fullLine") {
	                this.drawFullLineMarker(html, range, marker.clazz, config);
	            } else if (marker.type == "screenLine") {
	                this.drawScreenLineMarker(html, range, marker.clazz, config);
	            } else if (range.isMultiLine()) {
	                if (marker.type == "text")
	                    this.drawTextMarker(html, range, marker.clazz, config);
	                else
	                    this.drawMultiLineMarker(html, range, marker.clazz, config);
	            } else {
	                this.drawSingleLineMarker(html, range, marker.clazz + " ace_start" + " ace_br15", config);
	            }
	        }
	        this.element.innerHTML = html.join("");
	    };
	
	    this.$getTop = function(row, layerConfig) {
	        return (row - layerConfig.firstRowScreen) * layerConfig.lineHeight;
	    };
	
	    function getBorderClass(tl, tr, br, bl) {
	        return (tl ? 1 : 0) | (tr ? 2 : 0) | (br ? 4 : 0) | (bl ? 8 : 0);
	    }
	    this.drawTextMarker = function(stringBuilder, range, clazz, layerConfig, extraStyle) {
	        var session = this.session;
	        var start = range.start.row;
	        var end = range.end.row;
	        var row = start;
	        var prev = 0; 
	        var curr = 0;
	        var next = session.getScreenLastRowColumn(row);
	        var lineRange = new Range(row, range.start.column, row, curr);
	        for (; row <= end; row++) {
	            lineRange.start.row = lineRange.end.row = row;
	            lineRange.start.column = row == start ? range.start.column : session.getRowWrapIndent(row);
	            lineRange.end.column = next;
	            prev = curr;
	            curr = next;
	            next = row + 1 < end ? session.getScreenLastRowColumn(row + 1) : row == end ? 0 : range.end.column;
	            this.drawSingleLineMarker(stringBuilder, lineRange, 
	                clazz + (row == start  ? " ace_start" : "") + " ace_br"
	                    + getBorderClass(row == start || row == start + 1 && range.start.column, prev < curr, curr > next, row == end),
	                layerConfig, row == end ? 0 : 1, extraStyle);
	        }
	    };
	    this.drawMultiLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
	        var padding = this.$padding;
	        var height = config.lineHeight;
	        var top = this.$getTop(range.start.row, config);
	        var left = padding + range.start.column * config.characterWidth;
	        extraStyle = extraStyle || "";
	
	        stringBuilder.push(
	            "<div class='", clazz, " ace_br1 ace_start' style='",
	            "height:", height, "px;",
	            "right:0;",
	            "top:", top, "px;",
	            "left:", left, "px;", extraStyle, "'></div>"
	        );
	        top = this.$getTop(range.end.row, config);
	        var width = range.end.column * config.characterWidth;
	
	        stringBuilder.push(
	            "<div class='", clazz, " ace_br12' style='",
	            "height:", height, "px;",
	            "width:", width, "px;",
	            "top:", top, "px;",
	            "left:", padding, "px;", extraStyle, "'></div>"
	        );
	        height = (range.end.row - range.start.row - 1) * config.lineHeight;
	        if (height <= 0)
	            return;
	        top = this.$getTop(range.start.row + 1, config);
	        
	        var radiusClass = (range.start.column ? 1 : 0) | (range.end.column ? 0 : 8);
	
	        stringBuilder.push(
	            "<div class='", clazz, (radiusClass ? " ace_br" + radiusClass : ""), "' style='",
	            "height:", height, "px;",
	            "right:0;",
	            "top:", top, "px;",
	            "left:", padding, "px;", extraStyle, "'></div>"
	        );
	    };
	    this.drawSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
	        var height = config.lineHeight;
	        var width = (range.end.column + (extraLength || 0) - range.start.column) * config.characterWidth;
	
	        var top = this.$getTop(range.start.row, config);
	        var left = this.$padding + range.start.column * config.characterWidth;
	
	        stringBuilder.push(
	            "<div class='", clazz, "' style='",
	            "height:", height, "px;",
	            "width:", width, "px;",
	            "top:", top, "px;",
	            "left:", left, "px;", extraStyle || "", "'></div>"
	        );
	    };
	
	    this.drawFullLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
	        var top = this.$getTop(range.start.row, config);
	        var height = config.lineHeight;
	        if (range.start.row != range.end.row)
	            height += this.$getTop(range.end.row, config) - top;
	
	        stringBuilder.push(
	            "<div class='", clazz, "' style='",
	            "height:", height, "px;",
	            "top:", top, "px;",
	            "left:0;right:0;", extraStyle || "", "'></div>"
	        );
	    };
	    
	    this.drawScreenLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
	        var top = this.$getTop(range.start.row, config);
	        var height = config.lineHeight;
	
	        stringBuilder.push(
	            "<div class='", clazz, "' style='",
	            "height:", height, "px;",
	            "top:", top, "px;",
	            "left:0;right:0;", extraStyle || "", "'></div>"
	        );
	    };
	
	}).call(Marker.prototype);
	
	exports.Marker = Marker;
	
	});
	
	ace.define("ace/layer/text",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var dom = acequire("../lib/dom");
	var lang = acequire("../lib/lang");
	var useragent = acequire("../lib/useragent");
	var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
	
	var Text = function(parentEl) {
	    this.element = dom.createElement("div");
	    this.element.className = "ace_layer ace_text-layer";
	    parentEl.appendChild(this.element);
	    this.$updateEolChar = this.$updateEolChar.bind(this);
	};
	
	(function() {
	
	    oop.implement(this, EventEmitter);
	
	    this.EOF_CHAR = "\xB6";
	    this.EOL_CHAR_LF = "\xAC";
	    this.EOL_CHAR_CRLF = "\xa4";
	    this.EOL_CHAR = this.EOL_CHAR_LF;
	    this.TAB_CHAR = "\u2014"; //"\u21E5";
	    this.SPACE_CHAR = "\xB7";
	    this.$padding = 0;
	
	    this.$updateEolChar = function() {
	        var EOL_CHAR = this.session.doc.getNewLineCharacter() == "\n"
	           ? this.EOL_CHAR_LF
	           : this.EOL_CHAR_CRLF;
	        if (this.EOL_CHAR != EOL_CHAR) {
	            this.EOL_CHAR = EOL_CHAR;
	            return true;
	        }
	    }
	
	    this.setPadding = function(padding) {
	        this.$padding = padding;
	        this.element.style.padding = "0 " + padding + "px";
	    };
	
	    this.getLineHeight = function() {
	        return this.$fontMetrics.$characterSize.height || 0;
	    };
	
	    this.getCharacterWidth = function() {
	        return this.$fontMetrics.$characterSize.width || 0;
	    };
	    
	    this.$setFontMetrics = function(measure) {
	        this.$fontMetrics = measure;
	        this.$fontMetrics.on("changeCharacterSize", function(e) {
	            this._signal("changeCharacterSize", e);
	        }.bind(this));
	        this.$pollSizeChanges();
	    }
	
	    this.checkForSizeChanges = function() {
	        this.$fontMetrics.checkForSizeChanges();
	    };
	    this.$pollSizeChanges = function() {
	        return this.$pollSizeChangesTimer = this.$fontMetrics.$pollSizeChanges();
	    };
	    this.setSession = function(session) {
	        this.session = session;
	        if (session)
	            this.$computeTabString();
	    };
	
	    this.showInvisibles = false;
	    this.setShowInvisibles = function(showInvisibles) {
	        if (this.showInvisibles == showInvisibles)
	            return false;
	
	        this.showInvisibles = showInvisibles;
	        this.$computeTabString();
	        return true;
	    };
	
	    this.displayIndentGuides = true;
	    this.setDisplayIndentGuides = function(display) {
	        if (this.displayIndentGuides == display)
	            return false;
	
	        this.displayIndentGuides = display;
	        this.$computeTabString();
	        return true;
	    };
	
	    this.$tabStrings = [];
	    this.onChangeTabSize =
	    this.$computeTabString = function() {
	        var tabSize = this.session.getTabSize();
	        this.tabSize = tabSize;
	        var tabStr = this.$tabStrings = [0];
	        for (var i = 1; i < tabSize + 1; i++) {
	            if (this.showInvisibles) {
	                tabStr.push("<span class='ace_invisible ace_invisible_tab'>"
	                    + lang.stringRepeat(this.TAB_CHAR, i)
	                    + "</span>");
	            } else {
	                tabStr.push(lang.stringRepeat(" ", i));
	            }
	        }
	        if (this.displayIndentGuides) {
	            this.$indentGuideRe =  /\s\S| \t|\t |\s$/;
	            var className = "ace_indent-guide";
	            var spaceClass = "";
	            var tabClass = "";
	            if (this.showInvisibles) {
	                className += " ace_invisible";
	                spaceClass = " ace_invisible_space";
	                tabClass = " ace_invisible_tab";
	                var spaceContent = lang.stringRepeat(this.SPACE_CHAR, this.tabSize);
	                var tabContent = lang.stringRepeat(this.TAB_CHAR, this.tabSize);
	            } else{
	                var spaceContent = lang.stringRepeat(" ", this.tabSize);
	                var tabContent = spaceContent;
	            }
	
	            this.$tabStrings[" "] = "<span class='" + className + spaceClass + "'>" + spaceContent + "</span>";
	            this.$tabStrings["\t"] = "<span class='" + className + tabClass + "'>" + tabContent + "</span>";
	        }
	    };
	
	    this.updateLines = function(config, firstRow, lastRow) {
	        if (this.config.lastRow != config.lastRow ||
	            this.config.firstRow != config.firstRow) {
	            this.scrollLines(config);
	        }
	        this.config = config;
	
	        var first = Math.max(firstRow, config.firstRow);
	        var last = Math.min(lastRow, config.lastRow);
	
	        var lineElements = this.element.childNodes;
	        var lineElementsIdx = 0;
	
	        for (var row = config.firstRow; row < first; row++) {
	            var foldLine = this.session.getFoldLine(row);
	            if (foldLine) {
	                if (foldLine.containsRow(first)) {
	                    first = foldLine.start.row;
	                    break;
	                } else {
	                    row = foldLine.end.row;
	                }
	            }
	            lineElementsIdx ++;
	        }
	
	        var row = first;
	        var foldLine = this.session.getNextFoldLine(row);
	        var foldStart = foldLine ? foldLine.start.row : Infinity;
	
	        while (true) {
	            if (row > foldStart) {
	                row = foldLine.end.row+1;
	                foldLine = this.session.getNextFoldLine(row, foldLine);
	                foldStart = foldLine ? foldLine.start.row :Infinity;
	            }
	            if (row > last)
	                break;
	
	            var lineElement = lineElements[lineElementsIdx++];
	            if (lineElement) {
	                var html = [];
	                this.$renderLine(
	                    html, row, !this.$useLineGroups(), row == foldStart ? foldLine : false
	                );
	                lineElement.style.height = config.lineHeight * this.session.getRowLength(row) + "px";
	                lineElement.innerHTML = html.join("");
	            }
	            row++;
	        }
	    };
	
	    this.scrollLines = function(config) {
	        var oldConfig = this.config;
	        this.config = config;
	
	        if (!oldConfig || oldConfig.lastRow < config.firstRow)
	            return this.update(config);
	
	        if (config.lastRow < oldConfig.firstRow)
	            return this.update(config);
	
	        var el = this.element;
	        if (oldConfig.firstRow < config.firstRow)
	            for (var row=this.session.getFoldedRowCount(oldConfig.firstRow, config.firstRow - 1); row>0; row--)
	                el.removeChild(el.firstChild);
	
	        if (oldConfig.lastRow > config.lastRow)
	            for (var row=this.session.getFoldedRowCount(config.lastRow + 1, oldConfig.lastRow); row>0; row--)
	                el.removeChild(el.lastChild);
	
	        if (config.firstRow < oldConfig.firstRow) {
	            var fragment = this.$renderLinesFragment(config, config.firstRow, oldConfig.firstRow - 1);
	            if (el.firstChild)
	                el.insertBefore(fragment, el.firstChild);
	            else
	                el.appendChild(fragment);
	        }
	
	        if (config.lastRow > oldConfig.lastRow) {
	            var fragment = this.$renderLinesFragment(config, oldConfig.lastRow + 1, config.lastRow);
	            el.appendChild(fragment);
	        }
	    };
	
	    this.$renderLinesFragment = function(config, firstRow, lastRow) {
	        var fragment = this.element.ownerDocument.createDocumentFragment();
	        var row = firstRow;
	        var foldLine = this.session.getNextFoldLine(row);
	        var foldStart = foldLine ? foldLine.start.row : Infinity;
	
	        while (true) {
	            if (row > foldStart) {
	                row = foldLine.end.row+1;
	                foldLine = this.session.getNextFoldLine(row, foldLine);
	                foldStart = foldLine ? foldLine.start.row : Infinity;
	            }
	            if (row > lastRow)
	                break;
	
	            var container = dom.createElement("div");
	
	            var html = [];
	            this.$renderLine(html, row, false, row == foldStart ? foldLine : false);
	            container.innerHTML = html.join("");
	            if (this.$useLineGroups()) {
	                container.className = 'ace_line_group';
	                fragment.appendChild(container);
	                container.style.height = config.lineHeight * this.session.getRowLength(row) + "px";
	
	            } else {
	                while(container.firstChild)
	                    fragment.appendChild(container.firstChild);
	            }
	
	            row++;
	        }
	        return fragment;
	    };
	
	    this.update = function(config) {
	        this.config = config;
	
	        var html = [];
	        var firstRow = config.firstRow, lastRow = config.lastRow;
	
	        var row = firstRow;
	        var foldLine = this.session.getNextFoldLine(row);
	        var foldStart = foldLine ? foldLine.start.row : Infinity;
	
	        while (true) {
	            if (row > foldStart) {
	                row = foldLine.end.row+1;
	                foldLine = this.session.getNextFoldLine(row, foldLine);
	                foldStart = foldLine ? foldLine.start.row :Infinity;
	            }
	            if (row > lastRow)
	                break;
	
	            if (this.$useLineGroups())
	                html.push("<div class='ace_line_group' style='height:", config.lineHeight*this.session.getRowLength(row), "px'>")
	
	            this.$renderLine(html, row, false, row == foldStart ? foldLine : false);
	
	            if (this.$useLineGroups())
	                html.push("</div>"); // end the line group
	
	            row++;
	        }
	        this.element.innerHTML = html.join("");
	    };
	
	    this.$textToken = {
	        "text": true,
	        "rparen": true,
	        "lparen": true
	    };
	
	    this.$renderToken = function(stringBuilder, screenColumn, token, value) {
	        var self = this;
	        var replaceReg = /\t|&|<|>|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\u3000\uFEFF\uFFF9-\uFFFC])|[\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3000-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]/g;
	        var replaceFunc = function(c, a, b, tabIdx, idx4) {
	            if (a) {
	                return self.showInvisibles
	                    ? "<span class='ace_invisible ace_invisible_space'>" + lang.stringRepeat(self.SPACE_CHAR, c.length) + "</span>"
	                    : c;
	            } else if (c == "&") {
	                return "&#38;";
	            } else if (c == "<") {
	                return "&#60;";
	            } else if (c == ">") {
	                return "&#62;";
	            } else if (c == "\t") {
	                var tabSize = self.session.getScreenTabSize(screenColumn + tabIdx);
	                screenColumn += tabSize - 1;
	                return self.$tabStrings[tabSize];
	            } else if (c == "\u3000") {
	                var classToUse = self.showInvisibles ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk";
	                var space = self.showInvisibles ? self.SPACE_CHAR : "";
	                screenColumn += 1;
	                return "<span class='" + classToUse + "' style='width:" +
	                    (self.config.characterWidth * 2) +
	                    "px'>" + space + "</span>";
	            } else if (b) {
	                return "<span class='ace_invisible ace_invisible_space ace_invalid'>" + self.SPACE_CHAR + "</span>";
	            } else {
	                screenColumn += 1;
	                return "<span class='ace_cjk' style='width:" +
	                    (self.config.characterWidth * 2) +
	                    "px'>" + c + "</span>";
	            }
	        };
	
	        var output = value.replace(replaceReg, replaceFunc);
	
	        if (!this.$textToken[token.type]) {
	            var classes = "ace_" + token.type.replace(/\./g, " ace_");
	            var style = "";
	            if (token.type == "fold")
	                style = " style='width:" + (token.value.length * this.config.characterWidth) + "px;' ";
	            stringBuilder.push("<span class='", classes, "'", style, ">", output, "</span>");
	        }
	        else {
	            stringBuilder.push(output);
	        }
	        return screenColumn + value.length;
	    };
	
	    this.renderIndentGuide = function(stringBuilder, value, max) {
	        var cols = value.search(this.$indentGuideRe);
	        if (cols <= 0 || cols >= max)
	            return value;
	        if (value[0] == " ") {
	            cols -= cols % this.tabSize;
	            stringBuilder.push(lang.stringRepeat(this.$tabStrings[" "], cols/this.tabSize));
	            return value.substr(cols);
	        } else if (value[0] == "\t") {
	            stringBuilder.push(lang.stringRepeat(this.$tabStrings["\t"], cols));
	            return value.substr(cols);
	        }
	        return value;
	    };
	
	    this.$renderWrappedLine = function(stringBuilder, tokens, splits, onlyContents) {
	        var chars = 0;
	        var split = 0;
	        var splitChars = splits[0];
	        var screenColumn = 0;
	
	        for (var i = 0; i < tokens.length; i++) {
	            var token = tokens[i];
	            var value = token.value;
	            if (i == 0 && this.displayIndentGuides) {
	                chars = value.length;
	                value = this.renderIndentGuide(stringBuilder, value, splitChars);
	                if (!value)
	                    continue;
	                chars -= value.length;
	            }
	
	            if (chars + value.length < splitChars) {
	                screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
	                chars += value.length;
	            } else {
	                while (chars + value.length >= splitChars) {
	                    screenColumn = this.$renderToken(
	                        stringBuilder, screenColumn,
	                        token, value.substring(0, splitChars - chars)
	                    );
	                    value = value.substring(splitChars - chars);
	                    chars = splitChars;
	
	                    if (!onlyContents) {
	                        stringBuilder.push("</div>",
	                            "<div class='ace_line' style='height:",
	                            this.config.lineHeight, "px'>"
	                        );
	                    }
	
	                    stringBuilder.push(lang.stringRepeat("\xa0", splits.indent));
	
	                    split ++;
	                    screenColumn = 0;
	                    splitChars = splits[split] || Number.MAX_VALUE;
	                }
	                if (value.length != 0) {
	                    chars += value.length;
	                    screenColumn = this.$renderToken(
	                        stringBuilder, screenColumn, token, value
	                    );
	                }
	            }
	        }
	    };
	
	    this.$renderSimpleLine = function(stringBuilder, tokens) {
	        var screenColumn = 0;
	        var token = tokens[0];
	        var value = token.value;
	        if (this.displayIndentGuides)
	            value = this.renderIndentGuide(stringBuilder, value);
	        if (value)
	            screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
	        for (var i = 1; i < tokens.length; i++) {
	            token = tokens[i];
	            value = token.value;
	            screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
	        }
	    };
	    this.$renderLine = function(stringBuilder, row, onlyContents, foldLine) {
	        if (!foldLine && foldLine != false)
	            foldLine = this.session.getFoldLine(row);
	
	        if (foldLine)
	            var tokens = this.$getFoldLineTokens(row, foldLine);
	        else
	            var tokens = this.session.getTokens(row);
	
	
	        if (!onlyContents) {
	            stringBuilder.push(
	                "<div class='ace_line' style='height:", 
	                    this.config.lineHeight * (
	                        this.$useLineGroups() ? 1 :this.session.getRowLength(row)
	                    ), "px'>"
	            );
	        }
	
	        if (tokens.length) {
	            var splits = this.session.getRowSplitData(row);
	            if (splits && splits.length)
	                this.$renderWrappedLine(stringBuilder, tokens, splits, onlyContents);
	            else
	                this.$renderSimpleLine(stringBuilder, tokens);
	        }
	
	        if (this.showInvisibles) {
	            if (foldLine)
	                row = foldLine.end.row
	
	            stringBuilder.push(
	                "<span class='ace_invisible ace_invisible_eol'>",
	                row == this.session.getLength() - 1 ? this.EOF_CHAR : this.EOL_CHAR,
	                "</span>"
	            );
	        }
	        if (!onlyContents)
	            stringBuilder.push("</div>");
	    };
	
	    this.$getFoldLineTokens = function(row, foldLine) {
	        var session = this.session;
	        var renderTokens = [];
	
	        function addTokens(tokens, from, to) {
	            var idx = 0, col = 0;
	            while ((col + tokens[idx].value.length) < from) {
	                col += tokens[idx].value.length;
	                idx++;
	
	                if (idx == tokens.length)
	                    return;
	            }
	            if (col != from) {
	                var value = tokens[idx].value.substring(from - col);
	                if (value.length > (to - from))
	                    value = value.substring(0, to - from);
	
	                renderTokens.push({
	                    type: tokens[idx].type,
	                    value: value
	                });
	
	                col = from + value.length;
	                idx += 1;
	            }
	
	            while (col < to && idx < tokens.length) {
	                var value = tokens[idx].value;
	                if (value.length + col > to) {
	                    renderTokens.push({
	                        type: tokens[idx].type,
	                        value: value.substring(0, to - col)
	                    });
	                } else
	                    renderTokens.push(tokens[idx]);
	                col += value.length;
	                idx += 1;
	            }
	        }
	
	        var tokens = session.getTokens(row);
	        foldLine.walk(function(placeholder, row, column, lastColumn, isNewRow) {
	            if (placeholder != null) {
	                renderTokens.push({
	                    type: "fold",
	                    value: placeholder
	                });
	            } else {
	                if (isNewRow)
	                    tokens = session.getTokens(row);
	
	                if (tokens.length)
	                    addTokens(tokens, lastColumn, column);
	            }
	        }, foldLine.end.row, this.session.getLine(foldLine.end.row).length);
	
	        return renderTokens;
	    };
	
	    this.$useLineGroups = function() {
	        return this.session.getUseWrapMode();
	    };
	
	    this.destroy = function() {
	        clearInterval(this.$pollSizeChangesTimer);
	        if (this.$measureNode)
	            this.$measureNode.parentNode.removeChild(this.$measureNode);
	        delete this.$measureNode;
	    };
	
	}).call(Text.prototype);
	
	exports.Text = Text;
	
	});
	
	ace.define("ace/layer/cursor",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
	"use strict";
	
	var dom = acequire("../lib/dom");
	var isIE8;
	
	var Cursor = function(parentEl) {
	    this.element = dom.createElement("div");
	    this.element.className = "ace_layer ace_cursor-layer";
	    parentEl.appendChild(this.element);
	    
	    if (isIE8 === undefined)
	        isIE8 = !("opacity" in this.element.style);
	
	    this.isVisible = false;
	    this.isBlinking = true;
	    this.blinkInterval = 1000;
	    this.smoothBlinking = false;
	
	    this.cursors = [];
	    this.cursor = this.addCursor();
	    dom.addCssClass(this.element, "ace_hidden-cursors");
	    this.$updateCursors = (isIE8
	        ? this.$updateVisibility
	        : this.$updateOpacity).bind(this);
	};
	
	(function() {
	    
	    this.$updateVisibility = function(val) {
	        var cursors = this.cursors;
	        for (var i = cursors.length; i--; )
	            cursors[i].style.visibility = val ? "" : "hidden";
	    };
	    this.$updateOpacity = function(val) {
	        var cursors = this.cursors;
	        for (var i = cursors.length; i--; )
	            cursors[i].style.opacity = val ? "" : "0";
	    };
	    
	
	    this.$padding = 0;
	    this.setPadding = function(padding) {
	        this.$padding = padding;
	    };
	
	    this.setSession = function(session) {
	        this.session = session;
	    };
	
	    this.setBlinking = function(blinking) {
	        if (blinking != this.isBlinking){
	            this.isBlinking = blinking;
	            this.restartTimer();
	        }
	    };
	
	    this.setBlinkInterval = function(blinkInterval) {
	        if (blinkInterval != this.blinkInterval){
	            this.blinkInterval = blinkInterval;
	            this.restartTimer();
	        }
	    };
	
	    this.setSmoothBlinking = function(smoothBlinking) {
	        if (smoothBlinking != this.smoothBlinking && !isIE8) {
	            this.smoothBlinking = smoothBlinking;
	            dom.setCssClass(this.element, "ace_smooth-blinking", smoothBlinking);
	            this.$updateCursors(true);
	            this.$updateCursors = (this.$updateOpacity).bind(this);
	            this.restartTimer();
	        }
	    };
	
	    this.addCursor = function() {
	        var el = dom.createElement("div");
	        el.className = "ace_cursor";
	        this.element.appendChild(el);
	        this.cursors.push(el);
	        return el;
	    };
	
	    this.removeCursor = function() {
	        if (this.cursors.length > 1) {
	            var el = this.cursors.pop();
	            el.parentNode.removeChild(el);
	            return el;
	        }
	    };
	
	    this.hideCursor = function() {
	        this.isVisible = false;
	        dom.addCssClass(this.element, "ace_hidden-cursors");
	        this.restartTimer();
	    };
	
	    this.showCursor = function() {
	        this.isVisible = true;
	        dom.removeCssClass(this.element, "ace_hidden-cursors");
	        this.restartTimer();
	    };
	
	    this.restartTimer = function() {
	        var update = this.$updateCursors;
	        clearInterval(this.intervalId);
	        clearTimeout(this.timeoutId);
	        if (this.smoothBlinking) {
	            dom.removeCssClass(this.element, "ace_smooth-blinking");
	        }
	        
	        update(true);
	
	        if (!this.isBlinking || !this.blinkInterval || !this.isVisible)
	            return;
	
	        if (this.smoothBlinking) {
	            setTimeout(function(){
	                dom.addCssClass(this.element, "ace_smooth-blinking");
	            }.bind(this));
	        }
	        
	        var blink = function(){
	            this.timeoutId = setTimeout(function() {
	                update(false);
	            }, 0.6 * this.blinkInterval);
	        }.bind(this);
	
	        this.intervalId = setInterval(function() {
	            update(true);
	            blink();
	        }, this.blinkInterval);
	
	        blink();
	    };
	
	    this.getPixelPosition = function(position, onScreen) {
	        if (!this.config || !this.session)
	            return {left : 0, top : 0};
	
	        if (!position)
	            position = this.session.selection.getCursor();
	        var pos = this.session.documentToScreenPosition(position);
	        var cursorLeft = this.$padding + pos.column * this.config.characterWidth;
	        var cursorTop = (pos.row - (onScreen ? this.config.firstRowScreen : 0)) *
	            this.config.lineHeight;
	
	        return {left : cursorLeft, top : cursorTop};
	    };
	
	    this.update = function(config) {
	        this.config = config;
	
	        var selections = this.session.$selectionMarkers;
	        var i = 0, cursorIndex = 0;
	
	        if (selections === undefined || selections.length === 0){
	            selections = [{cursor: null}];
	        }
	
	        for (var i = 0, n = selections.length; i < n; i++) {
	            var pixelPos = this.getPixelPosition(selections[i].cursor, true);
	            if ((pixelPos.top > config.height + config.offset ||
	                 pixelPos.top < 0) && i > 1) {
	                continue;
	            }
	
	            var style = (this.cursors[cursorIndex++] || this.addCursor()).style;
	            
	            if (!this.drawCursor) {
	                style.left = pixelPos.left + "px";
	                style.top = pixelPos.top + "px";
	                style.width = config.characterWidth + "px";
	                style.height = config.lineHeight + "px";
	            } else {
	                this.drawCursor(style, pixelPos, config, selections[i], this.session);
	            }
	        }
	        while (this.cursors.length > cursorIndex)
	            this.removeCursor();
	
	        var overwrite = this.session.getOverwrite();
	        this.$setOverwrite(overwrite);
	        this.$pixelPos = pixelPos;
	        this.restartTimer();
	    };
	    
	    this.drawCursor = null;
	
	    this.$setOverwrite = function(overwrite) {
	        if (overwrite != this.overwrite) {
	            this.overwrite = overwrite;
	            if (overwrite)
	                dom.addCssClass(this.element, "ace_overwrite-cursors");
	            else
	                dom.removeCssClass(this.element, "ace_overwrite-cursors");
	        }
	    };
	
	    this.destroy = function() {
	        clearInterval(this.intervalId);
	        clearTimeout(this.timeoutId);
	    };
	
	}).call(Cursor.prototype);
	
	exports.Cursor = Cursor;
	
	});
	
	ace.define("ace/scrollbar",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("./lib/oop");
	var dom = acequire("./lib/dom");
	var event = acequire("./lib/event");
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	var MAX_SCROLL_H = 0x8000;
	var ScrollBar = function(parent) {
	    this.element = dom.createElement("div");
	    this.element.className = "ace_scrollbar ace_scrollbar" + this.classSuffix;
	
	    this.inner = dom.createElement("div");
	    this.inner.className = "ace_scrollbar-inner";
	    this.element.appendChild(this.inner);
	
	    parent.appendChild(this.element);
	
	    this.setVisible(false);
	    this.skipEvent = false;
	
	    event.addListener(this.element, "scroll", this.onScroll.bind(this));
	    event.addListener(this.element, "mousedown", event.preventDefault);
	};
	
	(function() {
	    oop.implement(this, EventEmitter);
	
	    this.setVisible = function(isVisible) {
	        this.element.style.display = isVisible ? "" : "none";
	        this.isVisible = isVisible;
	        this.coeff = 1;
	    };
	}).call(ScrollBar.prototype);
	var VScrollBar = function(parent, renderer) {
	    ScrollBar.call(this, parent);
	    this.scrollTop = 0;
	    this.scrollHeight = 0;
	    renderer.$scrollbarWidth = 
	    this.width = dom.scrollbarWidth(parent.ownerDocument);
	    this.inner.style.width =
	    this.element.style.width = (this.width || 15) + 5 + "px";
	};
	
	oop.inherits(VScrollBar, ScrollBar);
	
	(function() {
	
	    this.classSuffix = '-v';
	    this.onScroll = function() {
	        if (!this.skipEvent) {
	            this.scrollTop = this.element.scrollTop;
	            if (this.coeff != 1) {
	                var h = this.element.clientHeight / this.scrollHeight;
	                this.scrollTop = this.scrollTop * (1 - h) / (this.coeff - h);
	            }
	            this._emit("scroll", {data: this.scrollTop});
	        }
	        this.skipEvent = false;
	    };
	    this.getWidth = function() {
	        return this.isVisible ? this.width : 0;
	    };
	    this.setHeight = function(height) {
	        this.element.style.height = height + "px";
	    };
	    this.setInnerHeight =
	    this.setScrollHeight = function(height) {
	        this.scrollHeight = height;
	        if (height > MAX_SCROLL_H) {
	            this.coeff = MAX_SCROLL_H / height;
	            height = MAX_SCROLL_H;
	        } else if (this.coeff != 1) {
	            this.coeff = 1
	        }
	        this.inner.style.height = height + "px";
	    };
	    this.setScrollTop = function(scrollTop) {
	        if (this.scrollTop != scrollTop) {
	            this.skipEvent = true;
	            this.scrollTop = scrollTop;
	            this.element.scrollTop = scrollTop * this.coeff;
	        }
	    };
	
	}).call(VScrollBar.prototype);
	var HScrollBar = function(parent, renderer) {
	    ScrollBar.call(this, parent);
	    this.scrollLeft = 0;
	    this.height = renderer.$scrollbarWidth;
	    this.inner.style.height =
	    this.element.style.height = (this.height || 15) + 5 + "px";
	};
	
	oop.inherits(HScrollBar, ScrollBar);
	
	(function() {
	
	    this.classSuffix = '-h';
	    this.onScroll = function() {
	        if (!this.skipEvent) {
	            this.scrollLeft = this.element.scrollLeft;
	            this._emit("scroll", {data: this.scrollLeft});
	        }
	        this.skipEvent = false;
	    };
	    this.getHeight = function() {
	        return this.isVisible ? this.height : 0;
	    };
	    this.setWidth = function(width) {
	        this.element.style.width = width + "px";
	    };
	    this.setInnerWidth = function(width) {
	        this.inner.style.width = width + "px";
	    };
	    this.setScrollWidth = function(width) {
	        this.inner.style.width = width + "px";
	    };
	    this.setScrollLeft = function(scrollLeft) {
	        if (this.scrollLeft != scrollLeft) {
	            this.skipEvent = true;
	            this.scrollLeft = this.element.scrollLeft = scrollLeft;
	        }
	    };
	
	}).call(HScrollBar.prototype);
	
	
	exports.ScrollBar = VScrollBar; // backward compatibility
	exports.ScrollBarV = VScrollBar; // backward compatibility
	exports.ScrollBarH = HScrollBar; // backward compatibility
	
	exports.VScrollBar = VScrollBar;
	exports.HScrollBar = HScrollBar;
	});
	
	ace.define("ace/renderloop",["require","exports","module","ace/lib/event"], function(acequire, exports, module) {
	"use strict";
	
	var event = acequire("./lib/event");
	
	
	var RenderLoop = function(onRender, win) {
	    this.onRender = onRender;
	    this.pending = false;
	    this.changes = 0;
	    this.window = win || window;
	};
	
	(function() {
	
	
	    this.schedule = function(change) {
	        this.changes = this.changes | change;
	        if (!this.pending && this.changes) {
	            this.pending = true;
	            var _self = this;
	            event.nextFrame(function() {
	                _self.pending = false;
	                var changes;
	                while (changes = _self.changes) {
	                    _self.changes = 0;
	                    _self.onRender(changes);
	                }
	            }, this.window);
	        }
	    };
	
	}).call(RenderLoop.prototype);
	
	exports.RenderLoop = RenderLoop;
	});
	
	ace.define("ace/layer/font_metrics",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"], function(acequire, exports, module) {
	
	var oop = acequire("../lib/oop");
	var dom = acequire("../lib/dom");
	var lang = acequire("../lib/lang");
	var useragent = acequire("../lib/useragent");
	var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
	
	var CHAR_COUNT = 0;
	
	var FontMetrics = exports.FontMetrics = function(parentEl) {
	    this.el = dom.createElement("div");
	    this.$setMeasureNodeStyles(this.el.style, true);
	    
	    this.$main = dom.createElement("div");
	    this.$setMeasureNodeStyles(this.$main.style);
	    
	    this.$measureNode = dom.createElement("div");
	    this.$setMeasureNodeStyles(this.$measureNode.style);
	    
	    
	    this.el.appendChild(this.$main);
	    this.el.appendChild(this.$measureNode);
	    parentEl.appendChild(this.el);
	    
	    if (!CHAR_COUNT)
	        this.$testFractionalRect();
	    this.$measureNode.innerHTML = lang.stringRepeat("X", CHAR_COUNT);
	    
	    this.$characterSize = {width: 0, height: 0};
	    this.checkForSizeChanges();
	};
	
	(function() {
	
	    oop.implement(this, EventEmitter);
	        
	    this.$characterSize = {width: 0, height: 0};
	    
	    this.$testFractionalRect = function() {
	        var el = dom.createElement("div");
	        this.$setMeasureNodeStyles(el.style);
	        el.style.width = "0.2px";
	        document.documentElement.appendChild(el);
	        var w = el.getBoundingClientRect().width;
	        if (w > 0 && w < 1)
	            CHAR_COUNT = 50;
	        else
	            CHAR_COUNT = 100;
	        el.parentNode.removeChild(el);
	    };
	    
	    this.$setMeasureNodeStyles = function(style, isRoot) {
	        style.width = style.height = "auto";
	        style.left = style.top = "0px";
	        style.visibility = "hidden";
	        style.position = "absolute";
	        style.whiteSpace = "pre";
	
	        if (useragent.isIE < 8) {
	            style["font-family"] = "inherit";
	        } else {
	            style.font = "inherit";
	        }
	        style.overflow = isRoot ? "hidden" : "visible";
	    };
	
	    this.checkForSizeChanges = function() {
	        var size = this.$measureSizes();
	        if (size && (this.$characterSize.width !== size.width || this.$characterSize.height !== size.height)) {
	            this.$measureNode.style.fontWeight = "bold";
	            var boldSize = this.$measureSizes();
	            this.$measureNode.style.fontWeight = "";
	            this.$characterSize = size;
	            this.charSizes = Object.create(null);
	            this.allowBoldFonts = boldSize && boldSize.width === size.width && boldSize.height === size.height;
	            this._emit("changeCharacterSize", {data: size});
	        }
	    };
	
	    this.$pollSizeChanges = function() {
	        if (this.$pollSizeChangesTimer)
	            return this.$pollSizeChangesTimer;
	        var self = this;
	        return this.$pollSizeChangesTimer = setInterval(function() {
	            self.checkForSizeChanges();
	        }, 500);
	    };
	    
	    this.setPolling = function(val) {
	        if (val) {
	            this.$pollSizeChanges();
	        } else if (this.$pollSizeChangesTimer) {
	            clearInterval(this.$pollSizeChangesTimer);
	            this.$pollSizeChangesTimer = 0;
	        }
	    };
	
	    this.$measureSizes = function() {
	        if (CHAR_COUNT === 50) {
	            var rect = null;
	            try { 
	               rect = this.$measureNode.getBoundingClientRect();
	            } catch(e) {
	               rect = {width: 0, height:0 };
	            }
	            var size = {
	                height: rect.height,
	                width: rect.width / CHAR_COUNT
	            };
	        } else {
	            var size = {
	                height: this.$measureNode.clientHeight,
	                width: this.$measureNode.clientWidth / CHAR_COUNT
	            };
	        }
	        if (size.width === 0 || size.height === 0)
	            return null;
	        return size;
	    };
	
	    this.$measureCharWidth = function(ch) {
	        this.$main.innerHTML = lang.stringRepeat(ch, CHAR_COUNT);
	        var rect = this.$main.getBoundingClientRect();
	        return rect.width / CHAR_COUNT;
	    };
	    
	    this.getCharacterWidth = function(ch) {
	        var w = this.charSizes[ch];
	        if (w === undefined) {
	            w = this.charSizes[ch] = this.$measureCharWidth(ch) / this.$characterSize.width;
	        }
	        return w;
	    };
	
	    this.destroy = function() {
	        clearInterval(this.$pollSizeChangesTimer);
	        if (this.el && this.el.parentNode)
	            this.el.parentNode.removeChild(this.el);
	    };
	
	}).call(FontMetrics.prototype);
	
	});
	
	ace.define("ace/virtual_renderer",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/config","ace/lib/useragent","ace/layer/gutter","ace/layer/marker","ace/layer/text","ace/layer/cursor","ace/scrollbar","ace/scrollbar","ace/renderloop","ace/layer/font_metrics","ace/lib/event_emitter"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("./lib/oop");
	var dom = acequire("./lib/dom");
	var config = acequire("./config");
	var useragent = acequire("./lib/useragent");
	var GutterLayer = acequire("./layer/gutter").Gutter;
	var MarkerLayer = acequire("./layer/marker").Marker;
	var TextLayer = acequire("./layer/text").Text;
	var CursorLayer = acequire("./layer/cursor").Cursor;
	var HScrollBar = acequire("./scrollbar").HScrollBar;
	var VScrollBar = acequire("./scrollbar").VScrollBar;
	var RenderLoop = acequire("./renderloop").RenderLoop;
	var FontMetrics = acequire("./layer/font_metrics").FontMetrics;
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	var editorCss = ".ace_editor {\
	position: relative;\
	overflow: hidden;\
	font: 12px/normal 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;\
	direction: ltr;\
	text-align: left;\
	}\
	.ace_scroller {\
	position: absolute;\
	overflow: hidden;\
	top: 0;\
	bottom: 0;\
	background-color: inherit;\
	-ms-user-select: none;\
	-moz-user-select: none;\
	-webkit-user-select: none;\
	user-select: none;\
	cursor: text;\
	}\
	.ace_content {\
	position: absolute;\
	-moz-box-sizing: border-box;\
	-webkit-box-sizing: border-box;\
	box-sizing: border-box;\
	min-width: 100%;\
	}\
	.ace_dragging .ace_scroller:before{\
	position: absolute;\
	top: 0;\
	left: 0;\
	right: 0;\
	bottom: 0;\
	content: '';\
	background: rgba(250, 250, 250, 0.01);\
	z-index: 1000;\
	}\
	.ace_dragging.ace_dark .ace_scroller:before{\
	background: rgba(0, 0, 0, 0.01);\
	}\
	.ace_selecting, .ace_selecting * {\
	cursor: text !important;\
	}\
	.ace_gutter {\
	position: absolute;\
	overflow : hidden;\
	width: auto;\
	top: 0;\
	bottom: 0;\
	left: 0;\
	cursor: default;\
	z-index: 4;\
	-ms-user-select: none;\
	-moz-user-select: none;\
	-webkit-user-select: none;\
	user-select: none;\
	}\
	.ace_gutter-active-line {\
	position: absolute;\
	left: 0;\
	right: 0;\
	}\
	.ace_scroller.ace_scroll-left {\
	box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\
	}\
	.ace_gutter-cell {\
	padding-left: 19px;\
	padding-right: 6px;\
	background-repeat: no-repeat;\
	}\
	.ace_gutter-cell.ace_error {\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==\");\
	background-repeat: no-repeat;\
	background-position: 2px center;\
	}\
	.ace_gutter-cell.ace_warning {\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==\");\
	background-position: 2px center;\
	}\
	.ace_gutter-cell.ace_info {\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=\");\
	background-position: 2px center;\
	}\
	.ace_dark .ace_gutter-cell.ace_info {\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC\");\
	}\
	.ace_scrollbar {\
	position: absolute;\
	right: 0;\
	bottom: 0;\
	z-index: 6;\
	}\
	.ace_scrollbar-inner {\
	position: absolute;\
	cursor: text;\
	left: 0;\
	top: 0;\
	}\
	.ace_scrollbar-v{\
	overflow-x: hidden;\
	overflow-y: scroll;\
	top: 0;\
	}\
	.ace_scrollbar-h {\
	overflow-x: scroll;\
	overflow-y: hidden;\
	left: 0;\
	}\
	.ace_print-margin {\
	position: absolute;\
	height: 100%;\
	}\
	.ace_text-input {\
	position: absolute;\
	z-index: 0;\
	width: 0.5em;\
	height: 1em;\
	opacity: 0;\
	background: transparent;\
	-moz-appearance: none;\
	appearance: none;\
	border: none;\
	resize: none;\
	outline: none;\
	overflow: hidden;\
	font: inherit;\
	padding: 0 1px;\
	margin: 0 -1px;\
	text-indent: -1em;\
	-ms-user-select: text;\
	-moz-user-select: text;\
	-webkit-user-select: text;\
	user-select: text;\
	white-space: pre!important;\
	}\
	.ace_text-input.ace_composition {\
	background: inherit;\
	color: inherit;\
	z-index: 1000;\
	opacity: 1;\
	text-indent: 0;\
	}\
	.ace_layer {\
	z-index: 1;\
	position: absolute;\
	overflow: hidden;\
	word-wrap: normal;\
	white-space: pre;\
	height: 100%;\
	width: 100%;\
	-moz-box-sizing: border-box;\
	-webkit-box-sizing: border-box;\
	box-sizing: border-box;\
	pointer-events: none;\
	}\
	.ace_gutter-layer {\
	position: relative;\
	width: auto;\
	text-align: right;\
	pointer-events: auto;\
	}\
	.ace_text-layer {\
	font: inherit !important;\
	}\
	.ace_cjk {\
	display: inline-block;\
	text-align: center;\
	}\
	.ace_cursor-layer {\
	z-index: 4;\
	}\
	.ace_cursor {\
	z-index: 4;\
	position: absolute;\
	-moz-box-sizing: border-box;\
	-webkit-box-sizing: border-box;\
	box-sizing: border-box;\
	border-left: 2px solid;\
	transform: translatez(0);\
	}\
	.ace_slim-cursors .ace_cursor {\
	border-left-width: 1px;\
	}\
	.ace_overwrite-cursors .ace_cursor {\
	border-left-width: 0;\
	border-bottom: 1px solid;\
	}\
	.ace_hidden-cursors .ace_cursor {\
	opacity: 0.2;\
	}\
	.ace_smooth-blinking .ace_cursor {\
	-webkit-transition: opacity 0.18s;\
	transition: opacity 0.18s;\
	}\
	.ace_editor.ace_multiselect .ace_cursor {\
	border-left-width: 1px;\
	}\
	.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\
	position: absolute;\
	z-index: 3;\
	}\
	.ace_marker-layer .ace_selection {\
	position: absolute;\
	z-index: 5;\
	}\
	.ace_marker-layer .ace_bracket {\
	position: absolute;\
	z-index: 6;\
	}\
	.ace_marker-layer .ace_active-line {\
	position: absolute;\
	z-index: 2;\
	}\
	.ace_marker-layer .ace_selected-word {\
	position: absolute;\
	z-index: 4;\
	-moz-box-sizing: border-box;\
	-webkit-box-sizing: border-box;\
	box-sizing: border-box;\
	}\
	.ace_line .ace_fold {\
	-moz-box-sizing: border-box;\
	-webkit-box-sizing: border-box;\
	box-sizing: border-box;\
	display: inline-block;\
	height: 11px;\
	margin-top: -2px;\
	vertical-align: middle;\
	background-image:\
	url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\
	url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=\");\
	background-repeat: no-repeat, repeat-x;\
	background-position: center center, top left;\
	color: transparent;\
	border: 1px solid black;\
	border-radius: 2px;\
	cursor: pointer;\
	pointer-events: auto;\
	}\
	.ace_dark .ace_fold {\
	}\
	.ace_fold:hover{\
	background-image:\
	url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\
	url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC\");\
	}\
	.ace_tooltip {\
	background-color: #FFF;\
	background-image: -webkit-linear-gradient(top, transparent, rgba(0, 0, 0, 0.1));\
	background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));\
	border: 1px solid gray;\
	border-radius: 1px;\
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\
	color: black;\
	max-width: 100%;\
	padding: 3px 4px;\
	position: fixed;\
	z-index: 999999;\
	-moz-box-sizing: border-box;\
	-webkit-box-sizing: border-box;\
	box-sizing: border-box;\
	cursor: default;\
	white-space: pre;\
	word-wrap: break-word;\
	line-height: normal;\
	font-style: normal;\
	font-weight: normal;\
	letter-spacing: normal;\
	pointer-events: none;\
	}\
	.ace_folding-enabled > .ace_gutter-cell {\
	padding-right: 13px;\
	}\
	.ace_fold-widget {\
	-moz-box-sizing: border-box;\
	-webkit-box-sizing: border-box;\
	box-sizing: border-box;\
	margin: 0 -12px 0 1px;\
	display: none;\
	width: 11px;\
	vertical-align: top;\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==\");\
	background-repeat: no-repeat;\
	background-position: center;\
	border-radius: 3px;\
	border: 1px solid transparent;\
	cursor: pointer;\
	}\
	.ace_folding-enabled .ace_fold-widget {\
	display: inline-block;   \
	}\
	.ace_fold-widget.ace_end {\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==\");\
	}\
	.ace_fold-widget.ace_closed {\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==\");\
	}\
	.ace_fold-widget:hover {\
	border: 1px solid rgba(0, 0, 0, 0.3);\
	background-color: rgba(255, 255, 255, 0.2);\
	box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\
	}\
	.ace_fold-widget:active {\
	border: 1px solid rgba(0, 0, 0, 0.4);\
	background-color: rgba(0, 0, 0, 0.05);\
	box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\
	}\
	.ace_dark .ace_fold-widget {\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC\");\
	}\
	.ace_dark .ace_fold-widget.ace_end {\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==\");\
	}\
	.ace_dark .ace_fold-widget.ace_closed {\
	background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==\");\
	}\
	.ace_dark .ace_fold-widget:hover {\
	box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\
	background-color: rgba(255, 255, 255, 0.1);\
	}\
	.ace_dark .ace_fold-widget:active {\
	box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\
	}\
	.ace_fold-widget.ace_invalid {\
	background-color: #FFB4B4;\
	border-color: #DE5555;\
	}\
	.ace_fade-fold-widgets .ace_fold-widget {\
	-webkit-transition: opacity 0.4s ease 0.05s;\
	transition: opacity 0.4s ease 0.05s;\
	opacity: 0;\
	}\
	.ace_fade-fold-widgets:hover .ace_fold-widget {\
	-webkit-transition: opacity 0.05s ease 0.05s;\
	transition: opacity 0.05s ease 0.05s;\
	opacity:1;\
	}\
	.ace_underline {\
	text-decoration: underline;\
	}\
	.ace_bold {\
	font-weight: bold;\
	}\
	.ace_nobold .ace_bold {\
	font-weight: normal;\
	}\
	.ace_italic {\
	font-style: italic;\
	}\
	.ace_error-marker {\
	background-color: rgba(255, 0, 0,0.2);\
	position: absolute;\
	z-index: 9;\
	}\
	.ace_highlight-marker {\
	background-color: rgba(255, 255, 0,0.2);\
	position: absolute;\
	z-index: 8;\
	}\
	.ace_br1 {border-top-left-radius    : 3px;}\
	.ace_br2 {border-top-right-radius   : 3px;}\
	.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\
	.ace_br4 {border-bottom-right-radius: 3px;}\
	.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\
	.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\
	.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\
	.ace_br8 {border-bottom-left-radius : 3px;}\
	.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\
	.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\
	.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\
	.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
	.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
	.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
	.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\
	";
	
	dom.importCssString(editorCss, "ace_editor.css");
	
	var VirtualRenderer = function(container, theme) {
	    var _self = this;
	
	    this.container = container || dom.createElement("div");
	    this.$keepTextAreaAtCursor = !useragent.isOldIE;
	
	    dom.addCssClass(this.container, "ace_editor");
	
	    this.setTheme(theme);
	
	    this.$gutter = dom.createElement("div");
	    this.$gutter.className = "ace_gutter";
	    this.container.appendChild(this.$gutter);
	
	    this.scroller = dom.createElement("div");
	    this.scroller.className = "ace_scroller";
	    this.container.appendChild(this.scroller);
	
	    this.content = dom.createElement("div");
	    this.content.className = "ace_content";
	    this.scroller.appendChild(this.content);
	
	    this.$gutterLayer = new GutterLayer(this.$gutter);
	    this.$gutterLayer.on("changeGutterWidth", this.onGutterResize.bind(this));
	
	    this.$markerBack = new MarkerLayer(this.content);
	
	    var textLayer = this.$textLayer = new TextLayer(this.content);
	    this.canvas = textLayer.element;
	
	    this.$markerFront = new MarkerLayer(this.content);
	
	    this.$cursorLayer = new CursorLayer(this.content);
	    this.$horizScroll = false;
	    this.$vScroll = false;
	
	    this.scrollBar = 
	    this.scrollBarV = new VScrollBar(this.container, this);
	    this.scrollBarH = new HScrollBar(this.container, this);
	    this.scrollBarV.addEventListener("scroll", function(e) {
	        if (!_self.$scrollAnimation)
	            _self.session.setScrollTop(e.data - _self.scrollMargin.top);
	    });
	    this.scrollBarH.addEventListener("scroll", function(e) {
	        if (!_self.$scrollAnimation)
	            _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
	    });
	
	    this.scrollTop = 0;
	    this.scrollLeft = 0;
	
	    this.cursorPos = {
	        row : 0,
	        column : 0
	    };
	
	    this.$fontMetrics = new FontMetrics(this.container);
	    this.$textLayer.$setFontMetrics(this.$fontMetrics);
	    this.$textLayer.addEventListener("changeCharacterSize", function(e) {
	        _self.updateCharacterSize();
	        _self.onResize(true, _self.gutterWidth, _self.$size.width, _self.$size.height);
	        _self._signal("changeCharacterSize", e);
	    });
	
	    this.$size = {
	        width: 0,
	        height: 0,
	        scrollerHeight: 0,
	        scrollerWidth: 0,
	        $dirty: true
	    };
	
	    this.layerConfig = {
	        width : 1,
	        padding : 0,
	        firstRow : 0,
	        firstRowScreen: 0,
	        lastRow : 0,
	        lineHeight : 0,
	        characterWidth : 0,
	        minHeight : 1,
	        maxHeight : 1,
	        offset : 0,
	        height : 1,
	        gutterOffset: 1
	    };
	    
	    this.scrollMargin = {
	        left: 0,
	        right: 0,
	        top: 0,
	        bottom: 0,
	        v: 0,
	        h: 0
	    };
	
	    this.$loop = new RenderLoop(
	        this.$renderChanges.bind(this),
	        this.container.ownerDocument.defaultView
	    );
	    this.$loop.schedule(this.CHANGE_FULL);
	
	    this.updateCharacterSize();
	    this.setPadding(4);
	    config.resetOptions(this);
	    config._emit("renderer", this);
	};
	
	(function() {
	
	    this.CHANGE_CURSOR = 1;
	    this.CHANGE_MARKER = 2;
	    this.CHANGE_GUTTER = 4;
	    this.CHANGE_SCROLL = 8;
	    this.CHANGE_LINES = 16;
	    this.CHANGE_TEXT = 32;
	    this.CHANGE_SIZE = 64;
	    this.CHANGE_MARKER_BACK = 128;
	    this.CHANGE_MARKER_FRONT = 256;
	    this.CHANGE_FULL = 512;
	    this.CHANGE_H_SCROLL = 1024;
	
	    oop.implement(this, EventEmitter);
	
	    this.updateCharacterSize = function() {
	        if (this.$textLayer.allowBoldFonts != this.$allowBoldFonts) {
	            this.$allowBoldFonts = this.$textLayer.allowBoldFonts;
	            this.setStyle("ace_nobold", !this.$allowBoldFonts);
	        }
	
	        this.layerConfig.characterWidth =
	        this.characterWidth = this.$textLayer.getCharacterWidth();
	        this.layerConfig.lineHeight =
	        this.lineHeight = this.$textLayer.getLineHeight();
	        this.$updatePrintMargin();
	    };
	    this.setSession = function(session) {
	        if (this.session)
	            this.session.doc.off("changeNewLineMode", this.onChangeNewLineMode);
	            
	        this.session = session;
	        if (session && this.scrollMargin.top && session.getScrollTop() <= 0)
	            session.setScrollTop(-this.scrollMargin.top);
	
	        this.$cursorLayer.setSession(session);
	        this.$markerBack.setSession(session);
	        this.$markerFront.setSession(session);
	        this.$gutterLayer.setSession(session);
	        this.$textLayer.setSession(session);
	        if (!session)
	            return;
	        
	        this.$loop.schedule(this.CHANGE_FULL);
	        this.session.$setFontMetrics(this.$fontMetrics);
	        this.scrollBarV.scrollLeft = this.scrollBarV.scrollTop = null;
	        
	        this.onChangeNewLineMode = this.onChangeNewLineMode.bind(this);
	        this.onChangeNewLineMode()
	        this.session.doc.on("changeNewLineMode", this.onChangeNewLineMode);
	    };
	    this.updateLines = function(firstRow, lastRow, force) {
	        if (lastRow === undefined)
	            lastRow = Infinity;
	
	        if (!this.$changedLines) {
	            this.$changedLines = {
	                firstRow: firstRow,
	                lastRow: lastRow
	            };
	        }
	        else {
	            if (this.$changedLines.firstRow > firstRow)
	                this.$changedLines.firstRow = firstRow;
	
	            if (this.$changedLines.lastRow < lastRow)
	                this.$changedLines.lastRow = lastRow;
	        }
	        if (this.$changedLines.lastRow < this.layerConfig.firstRow) {
	            if (force)
	                this.$changedLines.lastRow = this.layerConfig.lastRow;
	            else
	                return;
	        }
	        if (this.$changedLines.firstRow > this.layerConfig.lastRow)
	            return;
	        this.$loop.schedule(this.CHANGE_LINES);
	    };
	
	    this.onChangeNewLineMode = function() {
	        this.$loop.schedule(this.CHANGE_TEXT);
	        this.$textLayer.$updateEolChar();
	    };
	    
	    this.onChangeTabSize = function() {
	        this.$loop.schedule(this.CHANGE_TEXT | this.CHANGE_MARKER);
	        this.$textLayer.onChangeTabSize();
	    };
	    this.updateText = function() {
	        this.$loop.schedule(this.CHANGE_TEXT);
	    };
	    this.updateFull = function(force) {
	        if (force)
	            this.$renderChanges(this.CHANGE_FULL, true);
	        else
	            this.$loop.schedule(this.CHANGE_FULL);
	    };
	    this.updateFontSize = function() {
	        this.$textLayer.checkForSizeChanges();
	    };
	
	    this.$changes = 0;
	    this.$updateSizeAsync = function() {
	        if (this.$loop.pending)
	            this.$size.$dirty = true;
	        else
	            this.onResize();
	    };
	    this.onResize = function(force, gutterWidth, width, height) {
	        if (this.resizing > 2)
	            return;
	        else if (this.resizing > 0)
	            this.resizing++;
	        else
	            this.resizing = force ? 1 : 0;
	        var el = this.container;
	        if (!height)
	            height = el.clientHeight || el.scrollHeight;
	        if (!width)
	            width = el.clientWidth || el.scrollWidth;
	        var changes = this.$updateCachedSize(force, gutterWidth, width, height);
	
	        
	        if (!this.$size.scrollerHeight || (!width && !height))
	            return this.resizing = 0;
	
	        if (force)
	            this.$gutterLayer.$padding = null;
	
	        if (force)
	            this.$renderChanges(changes | this.$changes, true);
	        else
	            this.$loop.schedule(changes | this.$changes);
	
	        if (this.resizing)
	            this.resizing = 0;
	        this.scrollBarV.scrollLeft = this.scrollBarV.scrollTop = null;
	    };
	    
	    this.$updateCachedSize = function(force, gutterWidth, width, height) {
	        height -= (this.$extraHeight || 0);
	        var changes = 0;
	        var size = this.$size;
	        var oldSize = {
	            width: size.width,
	            height: size.height,
	            scrollerHeight: size.scrollerHeight,
	            scrollerWidth: size.scrollerWidth
	        };
	        if (height && (force || size.height != height)) {
	            size.height = height;
	            changes |= this.CHANGE_SIZE;
	
	            size.scrollerHeight = size.height;
	            if (this.$horizScroll)
	                size.scrollerHeight -= this.scrollBarH.getHeight();
	            this.scrollBarV.element.style.bottom = this.scrollBarH.getHeight() + "px";
	
	            changes = changes | this.CHANGE_SCROLL;
	        }
	
	        if (width && (force || size.width != width)) {
	            changes |= this.CHANGE_SIZE;
	            size.width = width;
	            
	            if (gutterWidth == null)
	                gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
	            
	            this.gutterWidth = gutterWidth;
	            
	            this.scrollBarH.element.style.left = 
	            this.scroller.style.left = gutterWidth + "px";
	            size.scrollerWidth = Math.max(0, width - gutterWidth - this.scrollBarV.getWidth());           
	            
	            this.scrollBarH.element.style.right = 
	            this.scroller.style.right = this.scrollBarV.getWidth() + "px";
	            this.scroller.style.bottom = this.scrollBarH.getHeight() + "px";
	
	            if (this.session && this.session.getUseWrapMode() && this.adjustWrapLimit() || force)
	                changes |= this.CHANGE_FULL;
	        }
	        
	        size.$dirty = !width || !height;
	
	        if (changes)
	            this._signal("resize", oldSize);
	
	        return changes;
	    };
	
	    this.onGutterResize = function() {
	        var gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
	        if (gutterWidth != this.gutterWidth)
	            this.$changes |= this.$updateCachedSize(true, gutterWidth, this.$size.width, this.$size.height);
	
	        if (this.session.getUseWrapMode() && this.adjustWrapLimit()) {
	            this.$loop.schedule(this.CHANGE_FULL);
	        } else if (this.$size.$dirty) {
	            this.$loop.schedule(this.CHANGE_FULL);
	        } else {
	            this.$computeLayerConfig();
	            this.$loop.schedule(this.CHANGE_MARKER);
	        }
	    };
	    this.adjustWrapLimit = function() {
	        var availableWidth = this.$size.scrollerWidth - this.$padding * 2;
	        var limit = Math.floor(availableWidth / this.characterWidth);
	        return this.session.adjustWrapLimit(limit, this.$showPrintMargin && this.$printMarginColumn);
	    };
	    this.setAnimatedScroll = function(shouldAnimate){
	        this.setOption("animatedScroll", shouldAnimate);
	    };
	    this.getAnimatedScroll = function() {
	        return this.$animatedScroll;
	    };
	    this.setShowInvisibles = function(showInvisibles) {
	        this.setOption("showInvisibles", showInvisibles);
	    };
	    this.getShowInvisibles = function() {
	        return this.getOption("showInvisibles");
	    };
	    this.getDisplayIndentGuides = function() {
	        return this.getOption("displayIndentGuides");
	    };
	
	    this.setDisplayIndentGuides = function(display) {
	        this.setOption("displayIndentGuides", display);
	    };
	    this.setShowPrintMargin = function(showPrintMargin) {
	        this.setOption("showPrintMargin", showPrintMargin);
	    };
	    this.getShowPrintMargin = function() {
	        return this.getOption("showPrintMargin");
	    };
	    this.setPrintMarginColumn = function(showPrintMargin) {
	        this.setOption("printMarginColumn", showPrintMargin);
	    };
	    this.getPrintMarginColumn = function() {
	        return this.getOption("printMarginColumn");
	    };
	    this.getShowGutter = function(){
	        return this.getOption("showGutter");
	    };
	    this.setShowGutter = function(show){
	        return this.setOption("showGutter", show);
	    };
	
	    this.getFadeFoldWidgets = function(){
	        return this.getOption("fadeFoldWidgets")
	    };
	
	    this.setFadeFoldWidgets = function(show) {
	        this.setOption("fadeFoldWidgets", show);
	    };
	
	    this.setHighlightGutterLine = function(shouldHighlight) {
	        this.setOption("highlightGutterLine", shouldHighlight);
	    };
	
	    this.getHighlightGutterLine = function() {
	        return this.getOption("highlightGutterLine");
	    };
	
	    this.$updateGutterLineHighlight = function() {
	        var pos = this.$cursorLayer.$pixelPos;
	        var height = this.layerConfig.lineHeight;
	        if (this.session.getUseWrapMode()) {
	            var cursor = this.session.selection.getCursor();
	            cursor.column = 0;
	            pos = this.$cursorLayer.getPixelPosition(cursor, true);
	            height *= this.session.getRowLength(cursor.row);
	        }
	        this.$gutterLineHighlight.style.top = pos.top - this.layerConfig.offset + "px";
	        this.$gutterLineHighlight.style.height = height + "px";
	    };
	
	    this.$updatePrintMargin = function() {
	        if (!this.$showPrintMargin && !this.$printMarginEl)
	            return;
	
	        if (!this.$printMarginEl) {
	            var containerEl = dom.createElement("div");
	            containerEl.className = "ace_layer ace_print-margin-layer";
	            this.$printMarginEl = dom.createElement("div");
	            this.$printMarginEl.className = "ace_print-margin";
	            containerEl.appendChild(this.$printMarginEl);
	            this.content.insertBefore(containerEl, this.content.firstChild);
	        }
	
	        var style = this.$printMarginEl.style;
	        style.left = ((this.characterWidth * this.$printMarginColumn) + this.$padding) + "px";
	        style.visibility = this.$showPrintMargin ? "visible" : "hidden";
	        
	        if (this.session && this.session.$wrap == -1)
	            this.adjustWrapLimit();
	    };
	    this.getContainerElement = function() {
	        return this.container;
	    };
	    this.getMouseEventTarget = function() {
	        return this.scroller;
	    };
	    this.getTextAreaContainer = function() {
	        return this.container;
	    };
	    this.$moveTextAreaToCursor = function() {
	        if (!this.$keepTextAreaAtCursor)
	            return;
	        var config = this.layerConfig;
	        var posTop = this.$cursorLayer.$pixelPos.top;
	        var posLeft = this.$cursorLayer.$pixelPos.left;
	        posTop -= config.offset;
	
	        var style = this.textarea.style;
	        var h = this.lineHeight;
	        if (posTop < 0 || posTop > config.height - h) {
	            style.top = style.left = "0";
	            return;
	        }
	
	        var w = this.characterWidth;
	        if (this.$composition) {
	            var val = this.textarea.value.replace(/^\x01+/, "");
	            w *= (this.session.$getStringScreenWidth(val)[0]+2);
	            h += 2;
	        }
	        posLeft -= this.scrollLeft;
	        if (posLeft > this.$size.scrollerWidth - w)
	            posLeft = this.$size.scrollerWidth - w;
	
	        posLeft += this.gutterWidth;
	        style.height = h + "px";
	        style.width = w + "px";
	        style.left = Math.min(posLeft, this.$size.scrollerWidth - w) + "px";
	        style.top = Math.min(posTop, this.$size.height - h) + "px";
	    };
	    this.getFirstVisibleRow = function() {
	        return this.layerConfig.firstRow;
	    };
	    this.getFirstFullyVisibleRow = function() {
	        return this.layerConfig.firstRow + (this.layerConfig.offset === 0 ? 0 : 1);
	    };
	    this.getLastFullyVisibleRow = function() {
	        var config = this.layerConfig;
	        var lastRow = config.lastRow
	        var top = this.session.documentToScreenRow(lastRow, 0) * config.lineHeight;
	        if (top - this.session.getScrollTop() > config.height - config.lineHeight)
	            return lastRow - 1;
	        return lastRow;
	    };
	    this.getLastVisibleRow = function() {
	        return this.layerConfig.lastRow;
	    };
	
	    this.$padding = null;
	    this.setPadding = function(padding) {
	        this.$padding = padding;
	        this.$textLayer.setPadding(padding);
	        this.$cursorLayer.setPadding(padding);
	        this.$markerFront.setPadding(padding);
	        this.$markerBack.setPadding(padding);
	        this.$loop.schedule(this.CHANGE_FULL);
	        this.$updatePrintMargin();
	    };
	    
	    this.setScrollMargin = function(top, bottom, left, right) {
	        var sm = this.scrollMargin;
	        sm.top = top|0;
	        sm.bottom = bottom|0;
	        sm.right = right|0;
	        sm.left = left|0;
	        sm.v = sm.top + sm.bottom;
	        sm.h = sm.left + sm.right;
	        if (sm.top && this.scrollTop <= 0 && this.session)
	            this.session.setScrollTop(-sm.top);
	        this.updateFull();
	    };
	    this.getHScrollBarAlwaysVisible = function() {
	        return this.$hScrollBarAlwaysVisible;
	    };
	    this.setHScrollBarAlwaysVisible = function(alwaysVisible) {
	        this.setOption("hScrollBarAlwaysVisible", alwaysVisible);
	    };
	    this.getVScrollBarAlwaysVisible = function() {
	        return this.$vScrollBarAlwaysVisible;
	    };
	    this.setVScrollBarAlwaysVisible = function(alwaysVisible) {
	        this.setOption("vScrollBarAlwaysVisible", alwaysVisible);
	    };
	
	    this.$updateScrollBarV = function() {
	        var scrollHeight = this.layerConfig.maxHeight;
	        var scrollerHeight = this.$size.scrollerHeight;
	        if (!this.$maxLines && this.$scrollPastEnd) {
	            scrollHeight -= (scrollerHeight - this.lineHeight) * this.$scrollPastEnd;
	            if (this.scrollTop > scrollHeight - scrollerHeight) {
	                scrollHeight = this.scrollTop + scrollerHeight;
	                this.scrollBarV.scrollTop = null;
	            }
	        }
	        this.scrollBarV.setScrollHeight(scrollHeight + this.scrollMargin.v);
	        this.scrollBarV.setScrollTop(this.scrollTop + this.scrollMargin.top);
	    };
	    this.$updateScrollBarH = function() {
	        this.scrollBarH.setScrollWidth(this.layerConfig.width + 2 * this.$padding + this.scrollMargin.h);
	        this.scrollBarH.setScrollLeft(this.scrollLeft + this.scrollMargin.left);
	    };
	    
	    this.$frozen = false;
	    this.freeze = function() {
	        this.$frozen = true;
	    };
	    
	    this.unfreeze = function() {
	        this.$frozen = false;
	    };
	
	    this.$renderChanges = function(changes, force) {
	        if (this.$changes) {
	            changes |= this.$changes;
	            this.$changes = 0;
	        }
	        if ((!this.session || !this.container.offsetWidth || this.$frozen) || (!changes && !force)) {
	            this.$changes |= changes;
	            return; 
	        } 
	        if (this.$size.$dirty) {
	            this.$changes |= changes;
	            return this.onResize(true);
	        }
	        if (!this.lineHeight) {
	            this.$textLayer.checkForSizeChanges();
	        }
	        
	        this._signal("beforeRender");
	        var config = this.layerConfig;
	        if (changes & this.CHANGE_FULL ||
	            changes & this.CHANGE_SIZE ||
	            changes & this.CHANGE_TEXT ||
	            changes & this.CHANGE_LINES ||
	            changes & this.CHANGE_SCROLL ||
	            changes & this.CHANGE_H_SCROLL
	        ) {
	            changes |= this.$computeLayerConfig();
	            if (config.firstRow != this.layerConfig.firstRow && config.firstRowScreen == this.layerConfig.firstRowScreen) {
	                var st = this.scrollTop + (config.firstRow - this.layerConfig.firstRow) * this.lineHeight;
	                if (st > 0) {
	                    this.scrollTop = st;
	                    changes = changes | this.CHANGE_SCROLL;
	                    changes |= this.$computeLayerConfig();
	                }
	            }
	            config = this.layerConfig;
	            this.$updateScrollBarV();
	            if (changes & this.CHANGE_H_SCROLL)
	                this.$updateScrollBarH();
	            this.$gutterLayer.element.style.marginTop = (-config.offset) + "px";
	            this.content.style.marginTop = (-config.offset) + "px";
	            this.content.style.width = config.width + 2 * this.$padding + "px";
	            this.content.style.height = config.minHeight + "px";
	        }
	        if (changes & this.CHANGE_H_SCROLL) {
	            this.content.style.marginLeft = -this.scrollLeft + "px";
	            this.scroller.className = this.scrollLeft <= 0 ? "ace_scroller" : "ace_scroller ace_scroll-left";
	        }
	        if (changes & this.CHANGE_FULL) {
	            this.$textLayer.update(config);
	            if (this.$showGutter)
	                this.$gutterLayer.update(config);
	            this.$markerBack.update(config);
	            this.$markerFront.update(config);
	            this.$cursorLayer.update(config);
	            this.$moveTextAreaToCursor();
	            this.$highlightGutterLine && this.$updateGutterLineHighlight();
	            this._signal("afterRender");
	            return;
	        }
	        if (changes & this.CHANGE_SCROLL) {
	            if (changes & this.CHANGE_TEXT || changes & this.CHANGE_LINES)
	                this.$textLayer.update(config);
	            else
	                this.$textLayer.scrollLines(config);
	
	            if (this.$showGutter)
	                this.$gutterLayer.update(config);
	            this.$markerBack.update(config);
	            this.$markerFront.update(config);
	            this.$cursorLayer.update(config);
	            this.$highlightGutterLine && this.$updateGutterLineHighlight();
	            this.$moveTextAreaToCursor();
	            this._signal("afterRender");
	            return;
	        }
	
	        if (changes & this.CHANGE_TEXT) {
	            this.$textLayer.update(config);
	            if (this.$showGutter)
	                this.$gutterLayer.update(config);
	        }
	        else if (changes & this.CHANGE_LINES) {
	            if (this.$updateLines() || (changes & this.CHANGE_GUTTER) && this.$showGutter)
	                this.$gutterLayer.update(config);
	        }
	        else if (changes & this.CHANGE_TEXT || changes & this.CHANGE_GUTTER) {
	            if (this.$showGutter)
	                this.$gutterLayer.update(config);
	        }
	
	        if (changes & this.CHANGE_CURSOR) {
	            this.$cursorLayer.update(config);
	            this.$moveTextAreaToCursor();
	            this.$highlightGutterLine && this.$updateGutterLineHighlight();
	        }
	
	        if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_FRONT)) {
	            this.$markerFront.update(config);
	        }
	
	        if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_BACK)) {
	            this.$markerBack.update(config);
	        }
	
	        this._signal("afterRender");
	    };
	
	    
	    this.$autosize = function() {
	        var height = this.session.getScreenLength() * this.lineHeight;
	        var maxHeight = this.$maxLines * this.lineHeight;
	        var desiredHeight = Math.min(maxHeight,
	            Math.max((this.$minLines || 1) * this.lineHeight, height)
	        ) + this.scrollMargin.v + (this.$extraHeight || 0);
	        if (this.$horizScroll)
	            desiredHeight += this.scrollBarH.getHeight();
	        if (this.$maxPixelHeight && desiredHeight > this.$maxPixelHeight)
	            desiredHeight = this.$maxPixelHeight;
	        var vScroll = height > maxHeight;
	        
	        if (desiredHeight != this.desiredHeight ||
	            this.$size.height != this.desiredHeight || vScroll != this.$vScroll) {
	            if (vScroll != this.$vScroll) {
	                this.$vScroll = vScroll;
	                this.scrollBarV.setVisible(vScroll);
	            }
	            
	            var w = this.container.clientWidth;
	            this.container.style.height = desiredHeight + "px";
	            this.$updateCachedSize(true, this.$gutterWidth, w, desiredHeight);
	            this.desiredHeight = desiredHeight;
	            
	            this._signal("autosize");
	        }
	    };
	    
	    this.$computeLayerConfig = function() {
	        var session = this.session;
	        var size = this.$size;
	        
	        var hideScrollbars = size.height <= 2 * this.lineHeight;
	        var screenLines = this.session.getScreenLength();
	        var maxHeight = screenLines * this.lineHeight;
	
	        var longestLine = this.$getLongestLine();
	        
	        var horizScroll = !hideScrollbars && (this.$hScrollBarAlwaysVisible ||
	            size.scrollerWidth - longestLine - 2 * this.$padding < 0);
	
	        var hScrollChanged = this.$horizScroll !== horizScroll;
	        if (hScrollChanged) {
	            this.$horizScroll = horizScroll;
	            this.scrollBarH.setVisible(horizScroll);
	        }
	        var vScrollBefore = this.$vScroll; // autosize can change vscroll value in which case we need to update longestLine
	        if (this.$maxLines && this.lineHeight > 1)
	            this.$autosize();
	
	        var offset = this.scrollTop % this.lineHeight;
	        var minHeight = size.scrollerHeight + this.lineHeight;
	        
	        var scrollPastEnd = !this.$maxLines && this.$scrollPastEnd
	            ? (size.scrollerHeight - this.lineHeight) * this.$scrollPastEnd
	            : 0;
	        maxHeight += scrollPastEnd;
	        
	        var sm = this.scrollMargin;
	        this.session.setScrollTop(Math.max(-sm.top,
	            Math.min(this.scrollTop, maxHeight - size.scrollerHeight + sm.bottom)));
	
	        this.session.setScrollLeft(Math.max(-sm.left, Math.min(this.scrollLeft, 
	            longestLine + 2 * this.$padding - size.scrollerWidth + sm.right)));
	        
	        var vScroll = !hideScrollbars && (this.$vScrollBarAlwaysVisible ||
	            size.scrollerHeight - maxHeight + scrollPastEnd < 0 || this.scrollTop > sm.top);
	        var vScrollChanged = vScrollBefore !== vScroll;
	        if (vScrollChanged) {
	            this.$vScroll = vScroll;
	            this.scrollBarV.setVisible(vScroll);
	        }
	
	        var lineCount = Math.ceil(minHeight / this.lineHeight) - 1;
	        var firstRow = Math.max(0, Math.round((this.scrollTop - offset) / this.lineHeight));
	        var lastRow = firstRow + lineCount;
	        var firstRowScreen, firstRowHeight;
	        var lineHeight = this.lineHeight;
	        firstRow = session.screenToDocumentRow(firstRow, 0);
	        var foldLine = session.getFoldLine(firstRow);
	        if (foldLine) {
	            firstRow = foldLine.start.row;
	        }
	
	        firstRowScreen = session.documentToScreenRow(firstRow, 0);
	        firstRowHeight = session.getRowLength(firstRow) * lineHeight;
	
	        lastRow = Math.min(session.screenToDocumentRow(lastRow, 0), session.getLength() - 1);
	        minHeight = size.scrollerHeight + session.getRowLength(lastRow) * lineHeight +
	                                                firstRowHeight;
	
	        offset = this.scrollTop - firstRowScreen * lineHeight;
	
	        var changes = 0;
	        if (this.layerConfig.width != longestLine) 
	            changes = this.CHANGE_H_SCROLL;
	        if (hScrollChanged || vScrollChanged) {
	            changes = this.$updateCachedSize(true, this.gutterWidth, size.width, size.height);
	            this._signal("scrollbarVisibilityChanged");
	            if (vScrollChanged)
	                longestLine = this.$getLongestLine();
	        }
	        
	        this.layerConfig = {
	            width : longestLine,
	            padding : this.$padding,
	            firstRow : firstRow,
	            firstRowScreen: firstRowScreen,
	            lastRow : lastRow,
	            lineHeight : lineHeight,
	            characterWidth : this.characterWidth,
	            minHeight : minHeight,
	            maxHeight : maxHeight,
	            offset : offset,
	            gutterOffset : lineHeight ? Math.max(0, Math.ceil((offset + size.height - size.scrollerHeight) / lineHeight)) : 0,
	            height : this.$size.scrollerHeight
	        };
	
	        return changes;
	    };
	
	    this.$updateLines = function() {
	        var firstRow = this.$changedLines.firstRow;
	        var lastRow = this.$changedLines.lastRow;
	        this.$changedLines = null;
	
	        var layerConfig = this.layerConfig;
	
	        if (firstRow > layerConfig.lastRow + 1) { return; }
	        if (lastRow < layerConfig.firstRow) { return; }
	        if (lastRow === Infinity) {
	            if (this.$showGutter)
	                this.$gutterLayer.update(layerConfig);
	            this.$textLayer.update(layerConfig);
	            return;
	        }
	        this.$textLayer.updateLines(layerConfig, firstRow, lastRow);
	        return true;
	    };
	
	    this.$getLongestLine = function() {
	        var charCount = this.session.getScreenWidth();
	        if (this.showInvisibles && !this.session.$useWrapMode)
	            charCount += 1;
	
	        return Math.max(this.$size.scrollerWidth - 2 * this.$padding, Math.round(charCount * this.characterWidth));
	    };
	    this.updateFrontMarkers = function() {
	        this.$markerFront.setMarkers(this.session.getMarkers(true));
	        this.$loop.schedule(this.CHANGE_MARKER_FRONT);
	    };
	    this.updateBackMarkers = function() {
	        this.$markerBack.setMarkers(this.session.getMarkers());
	        this.$loop.schedule(this.CHANGE_MARKER_BACK);
	    };
	    this.addGutterDecoration = function(row, className){
	        this.$gutterLayer.addGutterDecoration(row, className);
	    };
	    this.removeGutterDecoration = function(row, className){
	        this.$gutterLayer.removeGutterDecoration(row, className);
	    };
	    this.updateBreakpoints = function(rows) {
	        this.$loop.schedule(this.CHANGE_GUTTER);
	    };
	    this.setAnnotations = function(annotations) {
	        this.$gutterLayer.setAnnotations(annotations);
	        this.$loop.schedule(this.CHANGE_GUTTER);
	    };
	    this.updateCursor = function() {
	        this.$loop.schedule(this.CHANGE_CURSOR);
	    };
	    this.hideCursor = function() {
	        this.$cursorLayer.hideCursor();
	    };
	    this.showCursor = function() {
	        this.$cursorLayer.showCursor();
	    };
	
	    this.scrollSelectionIntoView = function(anchor, lead, offset) {
	        this.scrollCursorIntoView(anchor, offset);
	        this.scrollCursorIntoView(lead, offset);
	    };
	    this.scrollCursorIntoView = function(cursor, offset, $viewMargin) {
	        if (this.$size.scrollerHeight === 0)
	            return;
	
	        var pos = this.$cursorLayer.getPixelPosition(cursor);
	
	        var left = pos.left;
	        var top = pos.top;
	        
	        var topMargin = $viewMargin && $viewMargin.top || 0;
	        var bottomMargin = $viewMargin && $viewMargin.bottom || 0;
	        
	        var scrollTop = this.$scrollAnimation ? this.session.getScrollTop() : this.scrollTop;
	        
	        if (scrollTop + topMargin > top) {
	            if (offset && scrollTop + topMargin > top + this.lineHeight)
	                top -= offset * this.$size.scrollerHeight;
	            if (top === 0)
	                top = -this.scrollMargin.top;
	            this.session.setScrollTop(top);
	        } else if (scrollTop + this.$size.scrollerHeight - bottomMargin < top + this.lineHeight) {
	            if (offset && scrollTop + this.$size.scrollerHeight - bottomMargin < top -  this.lineHeight)
	                top += offset * this.$size.scrollerHeight;
	            this.session.setScrollTop(top + this.lineHeight - this.$size.scrollerHeight);
	        }
	
	        var scrollLeft = this.scrollLeft;
	
	        if (scrollLeft > left) {
	            if (left < this.$padding + 2 * this.layerConfig.characterWidth)
	                left = -this.scrollMargin.left;
	            this.session.setScrollLeft(left);
	        } else if (scrollLeft + this.$size.scrollerWidth < left + this.characterWidth) {
	            this.session.setScrollLeft(Math.round(left + this.characterWidth - this.$size.scrollerWidth));
	        } else if (scrollLeft <= this.$padding && left - scrollLeft < this.characterWidth) {
	            this.session.setScrollLeft(0);
	        }
	    };
	    this.getScrollTop = function() {
	        return this.session.getScrollTop();
	    };
	    this.getScrollLeft = function() {
	        return this.session.getScrollLeft();
	    };
	    this.getScrollTopRow = function() {
	        return this.scrollTop / this.lineHeight;
	    };
	    this.getScrollBottomRow = function() {
	        return Math.max(0, Math.floor((this.scrollTop + this.$size.scrollerHeight) / this.lineHeight) - 1);
	    };
	    this.scrollToRow = function(row) {
	        this.session.setScrollTop(row * this.lineHeight);
	    };
	
	    this.alignCursor = function(cursor, alignment) {
	        if (typeof cursor == "number")
	            cursor = {row: cursor, column: 0};
	
	        var pos = this.$cursorLayer.getPixelPosition(cursor);
	        var h = this.$size.scrollerHeight - this.lineHeight;
	        var offset = pos.top - h * (alignment || 0);
	
	        this.session.setScrollTop(offset);
	        return offset;
	    };
	
	    this.STEPS = 8;
	    this.$calcSteps = function(fromValue, toValue){
	        var i = 0;
	        var l = this.STEPS;
	        var steps = [];
	
	        var func  = function(t, x_min, dx) {
	            return dx * (Math.pow(t - 1, 3) + 1) + x_min;
	        };
	
	        for (i = 0; i < l; ++i)
	            steps.push(func(i / this.STEPS, fromValue, toValue - fromValue));
	
	        return steps;
	    };
	    this.scrollToLine = function(line, center, animate, callback) {
	        var pos = this.$cursorLayer.getPixelPosition({row: line, column: 0});
	        var offset = pos.top;
	        if (center)
	            offset -= this.$size.scrollerHeight / 2;
	
	        var initialScroll = this.scrollTop;
	        this.session.setScrollTop(offset);
	        if (animate !== false)
	            this.animateScrolling(initialScroll, callback);
	    };
	
	    this.animateScrolling = function(fromValue, callback) {
	        var toValue = this.scrollTop;
	        if (!this.$animatedScroll)
	            return;
	        var _self = this;
	        
	        if (fromValue == toValue)
	            return;
	        
	        if (this.$scrollAnimation) {
	            var oldSteps = this.$scrollAnimation.steps;
	            if (oldSteps.length) {
	                fromValue = oldSteps[0];
	                if (fromValue == toValue)
	                    return;
	            }
	        }
	        
	        var steps = _self.$calcSteps(fromValue, toValue);
	        this.$scrollAnimation = {from: fromValue, to: toValue, steps: steps};
	
	        clearInterval(this.$timer);
	
	        _self.session.setScrollTop(steps.shift());
	        _self.session.$scrollTop = toValue;
	        this.$timer = setInterval(function() {
	            if (steps.length) {
	                _self.session.setScrollTop(steps.shift());
	                _self.session.$scrollTop = toValue;
	            } else if (toValue != null) {
	                _self.session.$scrollTop = -1;
	                _self.session.setScrollTop(toValue);
	                toValue = null;
	            } else {
	                _self.$timer = clearInterval(_self.$timer);
	                _self.$scrollAnimation = null;
	                callback && callback();
	            }
	        }, 10);
	    };
	    this.scrollToY = function(scrollTop) {
	        if (this.scrollTop !== scrollTop) {
	            this.$loop.schedule(this.CHANGE_SCROLL);
	            this.scrollTop = scrollTop;
	        }
	    };
	    this.scrollToX = function(scrollLeft) {
	        if (this.scrollLeft !== scrollLeft)
	            this.scrollLeft = scrollLeft;
	        this.$loop.schedule(this.CHANGE_H_SCROLL);
	    };
	    this.scrollTo = function(x, y) {
	        this.session.setScrollTop(y);
	        this.session.setScrollLeft(y);
	    };
	    this.scrollBy = function(deltaX, deltaY) {
	        deltaY && this.session.setScrollTop(this.session.getScrollTop() + deltaY);
	        deltaX && this.session.setScrollLeft(this.session.getScrollLeft() + deltaX);
	    };
	    this.isScrollableBy = function(deltaX, deltaY) {
	        if (deltaY < 0 && this.session.getScrollTop() >= 1 - this.scrollMargin.top)
	           return true;
	        if (deltaY > 0 && this.session.getScrollTop() + this.$size.scrollerHeight
	            - this.layerConfig.maxHeight < -1 + this.scrollMargin.bottom)
	           return true;
	        if (deltaX < 0 && this.session.getScrollLeft() >= 1 - this.scrollMargin.left)
	            return true;
	        if (deltaX > 0 && this.session.getScrollLeft() + this.$size.scrollerWidth
	            - this.layerConfig.width < -1 + this.scrollMargin.right)
	           return true;
	    };
	
	    this.pixelToScreenCoordinates = function(x, y) {
	        var canvasPos = this.scroller.getBoundingClientRect();
	
	        var offset = (x + this.scrollLeft - canvasPos.left - this.$padding) / this.characterWidth;
	        var row = Math.floor((y + this.scrollTop - canvasPos.top) / this.lineHeight);
	        var col = Math.round(offset);
	
	        return {row: row, column: col, side: offset - col > 0 ? 1 : -1};
	    };
	
	    this.screenToTextCoordinates = function(x, y) {
	        var canvasPos = this.scroller.getBoundingClientRect();
	
	        var col = Math.round(
	            (x + this.scrollLeft - canvasPos.left - this.$padding) / this.characterWidth
	        );
	
	        var row = (y + this.scrollTop - canvasPos.top) / this.lineHeight;
	
	        return this.session.screenToDocumentPosition(row, Math.max(col, 0));
	    };
	    this.textToScreenCoordinates = function(row, column) {
	        var canvasPos = this.scroller.getBoundingClientRect();
	        var pos = this.session.documentToScreenPosition(row, column);
	
	        var x = this.$padding + Math.round(pos.column * this.characterWidth);
	        var y = pos.row * this.lineHeight;
	
	        return {
	            pageX: canvasPos.left + x - this.scrollLeft,
	            pageY: canvasPos.top + y - this.scrollTop
	        };
	    };
	    this.visualizeFocus = function() {
	        dom.addCssClass(this.container, "ace_focus");
	    };
	    this.visualizeBlur = function() {
	        dom.removeCssClass(this.container, "ace_focus");
	    };
	    this.showComposition = function(position) {
	        if (!this.$composition)
	            this.$composition = {
	                keepTextAreaAtCursor: this.$keepTextAreaAtCursor,
	                cssText: this.textarea.style.cssText
	            };
	
	        this.$keepTextAreaAtCursor = true;
	        dom.addCssClass(this.textarea, "ace_composition");
	        this.textarea.style.cssText = "";
	        this.$moveTextAreaToCursor();
	    };
	    this.setCompositionText = function(text) {
	        this.$moveTextAreaToCursor();
	    };
	    this.hideComposition = function() {
	        if (!this.$composition)
	            return;
	
	        dom.removeCssClass(this.textarea, "ace_composition");
	        this.$keepTextAreaAtCursor = this.$composition.keepTextAreaAtCursor;
	        this.textarea.style.cssText = this.$composition.cssText;
	        this.$composition = null;
	    };
	    this.setTheme = function(theme, cb) {
	        var _self = this;
	        this.$themeId = theme;
	        _self._dispatchEvent('themeChange',{theme:theme});
	
	        if (!theme || typeof theme == "string") {
	            var moduleName = theme || this.$options.theme.initialValue;
	            config.loadModule(["theme", moduleName], afterLoad);
	        } else {
	            afterLoad(theme);
	        }
	
	        function afterLoad(module) {
	            if (_self.$themeId != theme)
	                return cb && cb();
	            if (!module || !module.cssClass)
	                throw new Error("couldn't load module " + theme + " or it didn't call define");
	            dom.importCssString(
	                module.cssText,
	                module.cssClass,
	                _self.container.ownerDocument
	            );
	
	            if (_self.theme)
	                dom.removeCssClass(_self.container, _self.theme.cssClass);
	
	            var padding = "padding" in module ? module.padding 
	                : "padding" in (_self.theme || {}) ? 4 : _self.$padding;
	            if (_self.$padding && padding != _self.$padding)
	                _self.setPadding(padding);
	            _self.$theme = module.cssClass;
	
	            _self.theme = module;
	            dom.addCssClass(_self.container, module.cssClass);
	            dom.setCssClass(_self.container, "ace_dark", module.isDark);
	            if (_self.$size) {
	                _self.$size.width = 0;
	                _self.$updateSizeAsync();
	            }
	
	            _self._dispatchEvent('themeLoaded', {theme:module});
	            cb && cb();
	        }
	    };
	    this.getTheme = function() {
	        return this.$themeId;
	    };
	    this.setStyle = function(style, include) {
	        dom.setCssClass(this.container, style, include !== false);
	    };
	    this.unsetStyle = function(style) {
	        dom.removeCssClass(this.container, style);
	    };
	    
	    this.setCursorStyle = function(style) {
	        if (this.scroller.style.cursor != style)
	            this.scroller.style.cursor = style;
	    };
	    this.setMouseCursor = function(cursorStyle) {
	        this.scroller.style.cursor = cursorStyle;
	    };
	    this.destroy = function() {
	        this.$textLayer.destroy();
	        this.$cursorLayer.destroy();
	    };
	
	}).call(VirtualRenderer.prototype);
	
	
	config.defineOptions(VirtualRenderer.prototype, "renderer", {
	    animatedScroll: {initialValue: false},
	    showInvisibles: {
	        set: function(value) {
	            if (this.$textLayer.setShowInvisibles(value))
	                this.$loop.schedule(this.CHANGE_TEXT);
	        },
	        initialValue: false
	    },
	    showPrintMargin: {
	        set: function() { this.$updatePrintMargin(); },
	        initialValue: true
	    },
	    printMarginColumn: {
	        set: function() { this.$updatePrintMargin(); },
	        initialValue: 80
	    },
	    printMargin: {
	        set: function(val) {
	            if (typeof val == "number")
	                this.$printMarginColumn = val;
	            this.$showPrintMargin = !!val;
	            this.$updatePrintMargin();
	        },
	        get: function() {
	            return this.$showPrintMargin && this.$printMarginColumn; 
	        }
	    },
	    showGutter: {
	        set: function(show){
	            this.$gutter.style.display = show ? "block" : "none";
	            this.$loop.schedule(this.CHANGE_FULL);
	            this.onGutterResize();
	        },
	        initialValue: true
	    },
	    fadeFoldWidgets: {
	        set: function(show) {
	            dom.setCssClass(this.$gutter, "ace_fade-fold-widgets", show);
	        },
	        initialValue: false
	    },
	    showFoldWidgets: {
	        set: function(show) {this.$gutterLayer.setShowFoldWidgets(show)},
	        initialValue: true
	    },
	    showLineNumbers: {
	        set: function(show) {
	            this.$gutterLayer.setShowLineNumbers(show);
	            this.$loop.schedule(this.CHANGE_GUTTER);
	        },
	        initialValue: true
	    },
	    displayIndentGuides: {
	        set: function(show) {
	            if (this.$textLayer.setDisplayIndentGuides(show))
	                this.$loop.schedule(this.CHANGE_TEXT);
	        },
	        initialValue: true
	    },
	    highlightGutterLine: {
	        set: function(shouldHighlight) {
	            if (!this.$gutterLineHighlight) {
	                this.$gutterLineHighlight = dom.createElement("div");
	                this.$gutterLineHighlight.className = "ace_gutter-active-line";
	                this.$gutter.appendChild(this.$gutterLineHighlight);
	                return;
	            }
	
	            this.$gutterLineHighlight.style.display = shouldHighlight ? "" : "none";
	            if (this.$cursorLayer.$pixelPos)
	                this.$updateGutterLineHighlight();
	        },
	        initialValue: false,
	        value: true
	    },
	    hScrollBarAlwaysVisible: {
	        set: function(val) {
	            if (!this.$hScrollBarAlwaysVisible || !this.$horizScroll)
	                this.$loop.schedule(this.CHANGE_SCROLL);
	        },
	        initialValue: false
	    },
	    vScrollBarAlwaysVisible: {
	        set: function(val) {
	            if (!this.$vScrollBarAlwaysVisible || !this.$vScroll)
	                this.$loop.schedule(this.CHANGE_SCROLL);
	        },
	        initialValue: false
	    },
	    fontSize:  {
	        set: function(size) {
	            if (typeof size == "number")
	                size = size + "px";
	            this.container.style.fontSize = size;
	            this.updateFontSize();
	        },
	        initialValue: 12
	    },
	    fontFamily: {
	        set: function(name) {
	            this.container.style.fontFamily = name;
	            this.updateFontSize();
	        }
	    },
	    maxLines: {
	        set: function(val) {
	            this.updateFull();
	        }
	    },
	    minLines: {
	        set: function(val) {
	            this.updateFull();
	        }
	    },
	    maxPixelHeight: {
	        set: function(val) {
	            this.updateFull();
	        },
	        initialValue: 0
	    },
	    scrollPastEnd: {
	        set: function(val) {
	            val = +val || 0;
	            if (this.$scrollPastEnd == val)
	                return;
	            this.$scrollPastEnd = val;
	            this.$loop.schedule(this.CHANGE_SCROLL);
	        },
	        initialValue: 0,
	        handlesSet: true
	    },
	    fixedWidthGutter: {
	        set: function(val) {
	            this.$gutterLayer.$fixedWidth = !!val;
	            this.$loop.schedule(this.CHANGE_GUTTER);
	        }
	    },
	    theme: {
	        set: function(val) { this.setTheme(val) },
	        get: function() { return this.$themeId || this.theme; },
	        initialValue: "./theme/textmate",
	        handlesSet: true
	    }
	});
	
	exports.VirtualRenderer = VirtualRenderer;
	});
	
	ace.define("ace/worker/worker_client",["require","exports","module","ace/lib/oop","ace/lib/net","ace/lib/event_emitter","ace/config"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var net = acequire("../lib/net");
	var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
	var config = acequire("../config");
	
	var WorkerClient = function(topLevelNamespaces, mod, classname, workerUrl) {
	    this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
	    this.changeListener = this.changeListener.bind(this);
	    this.onMessage = this.onMessage.bind(this);
	    if (acequire.nameToUrl && !acequire.toUrl)
	        acequire.toUrl = acequire.nameToUrl;
	    
	    if (config.get("packaged") || !acequire.toUrl) {
	        workerUrl = workerUrl || config.moduleUrl(mod.id, "worker")
	    } else {
	        var normalizePath = this.$normalizePath;
	        workerUrl = workerUrl || normalizePath(acequire.toUrl("ace/worker/worker.js", null, "_"));
	
	        var tlns = {};
	        topLevelNamespaces.forEach(function(ns) {
	            tlns[ns] = normalizePath(acequire.toUrl(ns, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
	        });
	    }
	
	    try {
	            var workerSrc = mod.src;
	    var Blob = __webpack_require__(1724);
	    var blob = new Blob([ workerSrc ], { type: 'application/javascript' });
	    var blobUrl = (window.URL || window.webkitURL).createObjectURL(blob);
	
	    this.$worker = new Worker(blobUrl);
	
	    } catch(e) {
	        if (e instanceof window.DOMException) {
	            var blob = this.$workerBlob(workerUrl);
	            var URL = window.URL || window.webkitURL;
	            var blobURL = URL.createObjectURL(blob);
	
	            this.$worker = new Worker(blobURL);
	            URL.revokeObjectURL(blobURL);
	        } else {
	            throw e;
	        }
	    }
	    this.$worker.postMessage({
	        init : true,
	        tlns : tlns,
	        module : mod.id,
	        classname : classname
	    });
	
	    this.callbackId = 1;
	    this.callbacks = {};
	
	    this.$worker.onmessage = this.onMessage;
	};
	
	(function(){
	
	    oop.implement(this, EventEmitter);
	
	    this.onMessage = function(e) {
	        var msg = e.data;
	        switch(msg.type) {
	            case "event":
	                this._signal(msg.name, {data: msg.data});
	                break;
	            case "call":
	                var callback = this.callbacks[msg.id];
	                if (callback) {
	                    callback(msg.data);
	                    delete this.callbacks[msg.id];
	                }
	                break;
	            case "error":
	                this.reportError(msg.data);
	                break;
	            case "log":
	                window.console && console.log && console.log.apply(console, msg.data);
	                break;
	        }
	    };
	    
	    this.reportError = function(err) {
	        window.console && console.error && console.error(err);
	    };
	
	    this.$normalizePath = function(path) {
	        return net.qualifyURL(path);
	    };
	
	    this.terminate = function() {
	        this._signal("terminate", {});
	        this.deltaQueue = null;
	        this.$worker.terminate();
	        this.$worker = null;
	        if (this.$doc)
	            this.$doc.off("change", this.changeListener);
	        this.$doc = null;
	    };
	
	    this.send = function(cmd, args) {
	        this.$worker.postMessage({command: cmd, args: args});
	    };
	
	    this.call = function(cmd, args, callback) {
	        if (callback) {
	            var id = this.callbackId++;
	            this.callbacks[id] = callback;
	            args.push(id);
	        }
	        this.send(cmd, args);
	    };
	
	    this.emit = function(event, data) {
	        try {
	            this.$worker.postMessage({event: event, data: {data: data.data}});
	        }
	        catch(ex) {
	            console.error(ex.stack);
	        }
	    };
	
	    this.attachToDocument = function(doc) {
	        if(this.$doc)
	            this.terminate();
	
	        this.$doc = doc;
	        this.call("setValue", [doc.getValue()]);
	        doc.on("change", this.changeListener);
	    };
	
	    this.changeListener = function(delta) {
	        if (!this.deltaQueue) {
	            this.deltaQueue = [];
	            setTimeout(this.$sendDeltaQueue, 0);
	        }
	        if (delta.action == "insert")
	            this.deltaQueue.push(delta.start, delta.lines);
	        else
	            this.deltaQueue.push(delta.start, delta.end);
	    };
	
	    this.$sendDeltaQueue = function() {
	        var q = this.deltaQueue;
	        if (!q) return;
	        this.deltaQueue = null;
	        if (q.length > 50 && q.length > this.$doc.getLength() >> 1) {
	            this.call("setValue", [this.$doc.getValue()]);
	        } else
	            this.emit("change", {data: q});
	    };
	
	    this.$workerBlob = function(workerUrl) {
	        var script = "importScripts('" + net.qualifyURL(workerUrl) + "');";
	        try {
	            return new Blob([script], {"type": "application/javascript"});
	        } catch (e) { // Backwards-compatibility
	            var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
	            var blobBuilder = new BlobBuilder();
	            blobBuilder.append(script);
	            return blobBuilder.getBlob("application/javascript");
	        }
	    };
	
	}).call(WorkerClient.prototype);
	
	
	var UIWorkerClient = function(topLevelNamespaces, mod, classname) {
	    this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
	    this.changeListener = this.changeListener.bind(this);
	    this.callbackId = 1;
	    this.callbacks = {};
	    this.messageBuffer = [];
	
	    var main = null;
	    var emitSync = false;
	    var sender = Object.create(EventEmitter);
	    var _self = this;
	
	    this.$worker = {};
	    this.$worker.terminate = function() {};
	    this.$worker.postMessage = function(e) {
	        _self.messageBuffer.push(e);
	        if (main) {
	            if (emitSync)
	                setTimeout(processNext);
	            else
	                processNext();
	        }
	    };
	    this.setEmitSync = function(val) { emitSync = val };
	
	    var processNext = function() {
	        var msg = _self.messageBuffer.shift();
	        if (msg.command)
	            main[msg.command].apply(main, msg.args);
	        else if (msg.event)
	            sender._signal(msg.event, msg.data);
	    };
	
	    sender.postMessage = function(msg) {
	        _self.onMessage({data: msg});
	    };
	    sender.callback = function(data, callbackId) {
	        this.postMessage({type: "call", id: callbackId, data: data});
	    };
	    sender.emit = function(name, data) {
	        this.postMessage({type: "event", name: name, data: data});
	    };
	
	    config.loadModule(["worker", mod], function(Main) {
	        main = new Main[classname](sender);
	        while (_self.messageBuffer.length)
	            processNext();
	    });
	};
	
	UIWorkerClient.prototype = WorkerClient.prototype;
	
	exports.UIWorkerClient = UIWorkerClient;
	exports.WorkerClient = WorkerClient;
	
	});
	
	ace.define("ace/placeholder",["require","exports","module","ace/range","ace/lib/event_emitter","ace/lib/oop"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("./range").Range;
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	var oop = acequire("./lib/oop");
	
	var PlaceHolder = function(session, length, pos, others, mainClass, othersClass) {
	    var _self = this;
	    this.length = length;
	    this.session = session;
	    this.doc = session.getDocument();
	    this.mainClass = mainClass;
	    this.othersClass = othersClass;
	    this.$onUpdate = this.onUpdate.bind(this);
	    this.doc.on("change", this.$onUpdate);
	    this.$others = others;
	    
	    this.$onCursorChange = function() {
	        setTimeout(function() {
	            _self.onCursorChange();
	        });
	    };
	    
	    this.$pos = pos;
	    var undoStack = session.getUndoManager().$undoStack || session.getUndoManager().$undostack || {length: -1};
	    this.$undoStackDepth = undoStack.length;
	    this.setup();
	
	    session.selection.on("changeCursor", this.$onCursorChange);
	};
	
	(function() {
	
	    oop.implement(this, EventEmitter);
	    this.setup = function() {
	        var _self = this;
	        var doc = this.doc;
	        var session = this.session;
	        
	        this.selectionBefore = session.selection.toJSON();
	        if (session.selection.inMultiSelectMode)
	            session.selection.toSingleRange();
	
	        this.pos = doc.createAnchor(this.$pos.row, this.$pos.column);
	        var pos = this.pos;
	        pos.$insertRight = true;
	        pos.detach();
	        pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column + this.length), this.mainClass, null, false);
	        this.others = [];
	        this.$others.forEach(function(other) {
	            var anchor = doc.createAnchor(other.row, other.column);
	            anchor.$insertRight = true;
	            anchor.detach();
	            _self.others.push(anchor);
	        });
	        session.setUndoSelect(false);
	    };
	    this.showOtherMarkers = function() {
	        if (this.othersActive) return;
	        var session = this.session;
	        var _self = this;
	        this.othersActive = true;
	        this.others.forEach(function(anchor) {
	            anchor.markerId = session.addMarker(new Range(anchor.row, anchor.column, anchor.row, anchor.column+_self.length), _self.othersClass, null, false);
	        });
	    };
	    this.hideOtherMarkers = function() {
	        if (!this.othersActive) return;
	        this.othersActive = false;
	        for (var i = 0; i < this.others.length; i++) {
	            this.session.removeMarker(this.others[i].markerId);
	        }
	    };
	    this.onUpdate = function(delta) {
	        if (this.$updating)
	            return this.updateAnchors(delta);
	            
	        var range = delta;
	        if (range.start.row !== range.end.row) return;
	        if (range.start.row !== this.pos.row) return;
	        this.$updating = true;
	        var lengthDiff = delta.action === "insert" ? range.end.column - range.start.column : range.start.column - range.end.column;
	        var inMainRange = range.start.column >= this.pos.column && range.start.column <= this.pos.column + this.length + 1;
	        var distanceFromStart = range.start.column - this.pos.column;
	        
	        this.updateAnchors(delta);
	        
	        if (inMainRange)
	            this.length += lengthDiff;
	
	        if (inMainRange && !this.session.$fromUndo) {
	            if (delta.action === 'insert') {
	                for (var i = this.others.length - 1; i >= 0; i--) {
	                    var otherPos = this.others[i];
	                    var newPos = {row: otherPos.row, column: otherPos.column + distanceFromStart};
	                    this.doc.insertMergedLines(newPos, delta.lines);
	                }
	            } else if (delta.action === 'remove') {
	                for (var i = this.others.length - 1; i >= 0; i--) {
	                    var otherPos = this.others[i];
	                    var newPos = {row: otherPos.row, column: otherPos.column + distanceFromStart};
	                    this.doc.remove(new Range(newPos.row, newPos.column, newPos.row, newPos.column - lengthDiff));
	                }
	            }
	        }
	        
	        this.$updating = false;
	        this.updateMarkers();
	    };
	    
	    this.updateAnchors = function(delta) {
	        this.pos.onChange(delta);
	        for (var i = this.others.length; i--;)
	            this.others[i].onChange(delta);
	        this.updateMarkers();
	    };
	    
	    this.updateMarkers = function() {
	        if (this.$updating)
	            return;
	        var _self = this;
	        var session = this.session;
	        var updateMarker = function(pos, className) {
	            session.removeMarker(pos.markerId);
	            pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column+_self.length), className, null, false);
	        };
	        updateMarker(this.pos, this.mainClass);
	        for (var i = this.others.length; i--;)
	            updateMarker(this.others[i], this.othersClass);
	    };
	
	    this.onCursorChange = function(event) {
	        if (this.$updating || !this.session) return;
	        var pos = this.session.selection.getCursor();
	        if (pos.row === this.pos.row && pos.column >= this.pos.column && pos.column <= this.pos.column + this.length) {
	            this.showOtherMarkers();
	            this._emit("cursorEnter", event);
	        } else {
	            this.hideOtherMarkers();
	            this._emit("cursorLeave", event);
	        }
	    };    
	    this.detach = function() {
	        this.session.removeMarker(this.pos && this.pos.markerId);
	        this.hideOtherMarkers();
	        this.doc.removeEventListener("change", this.$onUpdate);
	        this.session.selection.removeEventListener("changeCursor", this.$onCursorChange);
	        this.session.setUndoSelect(true);
	        this.session = null;
	    };
	    this.cancel = function() {
	        if (this.$undoStackDepth === -1)
	            return;
	        var undoManager = this.session.getUndoManager();
	        var undosRequired = (undoManager.$undoStack || undoManager.$undostack).length - this.$undoStackDepth;
	        for (var i = 0; i < undosRequired; i++) {
	            undoManager.undo(true);
	        }
	        if (this.selectionBefore)
	            this.session.selection.fromJSON(this.selectionBefore);
	    };
	}).call(PlaceHolder.prototype);
	
	
	exports.PlaceHolder = PlaceHolder;
	});
	
	ace.define("ace/mouse/multi_select_handler",["require","exports","module","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
	
	var event = acequire("../lib/event");
	var useragent = acequire("../lib/useragent");
	function isSamePoint(p1, p2) {
	    return p1.row == p2.row && p1.column == p2.column;
	}
	
	function onMouseDown(e) {
	    var ev = e.domEvent;
	    var alt = ev.altKey;
	    var shift = ev.shiftKey;
	    var ctrl = ev.ctrlKey;
	    var accel = e.getAccelKey();
	    var button = e.getButton();
	    
	    if (ctrl && useragent.isMac)
	        button = ev.button;
	
	    if (e.editor.inMultiSelectMode && button == 2) {
	        e.editor.textInput.onContextMenu(e.domEvent);
	        return;
	    }
	    
	    if (!ctrl && !alt && !accel) {
	        if (button === 0 && e.editor.inMultiSelectMode)
	            e.editor.exitMultiSelectMode();
	        return;
	    }
	    
	    if (button !== 0)
	        return;
	
	    var editor = e.editor;
	    var selection = editor.selection;
	    var isMultiSelect = editor.inMultiSelectMode;
	    var pos = e.getDocumentPosition();
	    var cursor = selection.getCursor();
	    var inSelection = e.inSelection() || (selection.isEmpty() && isSamePoint(pos, cursor));
	
	    var mouseX = e.x, mouseY = e.y;
	    var onMouseSelection = function(e) {
	        mouseX = e.clientX;
	        mouseY = e.clientY;
	    };
	    
	    var session = editor.session;
	    var screenAnchor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
	    var screenCursor = screenAnchor;
	    
	    var selectionMode;
	    if (editor.$mouseHandler.$enableJumpToDef) {
	        if (ctrl && alt || accel && alt)
	            selectionMode = shift ? "block" : "add";
	        else if (alt && editor.$blockSelectEnabled)
	            selectionMode = "block";
	    } else {
	        if (accel && !alt) {
	            selectionMode = "add";
	            if (!isMultiSelect && shift)
	                return;
	        } else if (alt && editor.$blockSelectEnabled) {
	            selectionMode = "block";
	        }
	    }
	    
	    if (selectionMode && useragent.isMac && ev.ctrlKey) {
	        editor.$mouseHandler.cancelContextMenu();
	    }
	
	    if (selectionMode == "add") {
	        if (!isMultiSelect && inSelection)
	            return; // dragging
	
	        if (!isMultiSelect) {
	            var range = selection.toOrientedRange();
	            editor.addSelectionMarker(range);
	        }
	
	        var oldRange = selection.rangeList.rangeAtPoint(pos);
	        
	        
	        editor.$blockScrolling++;
	        editor.inVirtualSelectionMode = true;
	        
	        if (shift) {
	            oldRange = null;
	            range = selection.ranges[0] || range;
	            editor.removeSelectionMarker(range);
	        }
	        editor.once("mouseup", function() {
	            var tmpSel = selection.toOrientedRange();
	
	            if (oldRange && tmpSel.isEmpty() && isSamePoint(oldRange.cursor, tmpSel.cursor))
	                selection.substractPoint(tmpSel.cursor);
	            else {
	                if (shift) {
	                    selection.substractPoint(range.cursor);
	                } else if (range) {
	                    editor.removeSelectionMarker(range);
	                    selection.addRange(range);
	                }
	                selection.addRange(tmpSel);
	            }
	            editor.$blockScrolling--;
	            editor.inVirtualSelectionMode = false;
	        });
	
	    } else if (selectionMode == "block") {
	        e.stop();
	        editor.inVirtualSelectionMode = true;        
	        var initialRange;
	        var rectSel = [];
	        var blockSelect = function() {
	            var newCursor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
	            var cursor = session.screenToDocumentPosition(newCursor.row, newCursor.column);
	
	            if (isSamePoint(screenCursor, newCursor) && isSamePoint(cursor, selection.lead))
	                return;
	            screenCursor = newCursor;
	            
	            editor.$blockScrolling++;
	            editor.selection.moveToPosition(cursor);
	            editor.renderer.scrollCursorIntoView();
	
	            editor.removeSelectionMarkers(rectSel);
	            rectSel = selection.rectangularRangeBlock(screenCursor, screenAnchor);
	            if (editor.$mouseHandler.$clickSelection && rectSel.length == 1 && rectSel[0].isEmpty())
	                rectSel[0] = editor.$mouseHandler.$clickSelection.clone();
	            rectSel.forEach(editor.addSelectionMarker, editor);
	            editor.updateSelectionMarkers();
	            editor.$blockScrolling--;
	        };
	        editor.$blockScrolling++;
	        if (isMultiSelect && !accel) {
	            selection.toSingleRange();
	        } else if (!isMultiSelect && accel) {
	            initialRange = selection.toOrientedRange();
	            editor.addSelectionMarker(initialRange);
	        }
	        
	        if (shift)
	            screenAnchor = session.documentToScreenPosition(selection.lead);            
	        else
	            selection.moveToPosition(pos);
	        editor.$blockScrolling--;
	        
	        screenCursor = {row: -1, column: -1};
	
	        var onMouseSelectionEnd = function(e) {
	            clearInterval(timerId);
	            editor.removeSelectionMarkers(rectSel);
	            if (!rectSel.length)
	                rectSel = [selection.toOrientedRange()];
	            editor.$blockScrolling++;
	            if (initialRange) {
	                editor.removeSelectionMarker(initialRange);
	                selection.toSingleRange(initialRange);
	            }
	            for (var i = 0; i < rectSel.length; i++)
	                selection.addRange(rectSel[i]);
	            editor.inVirtualSelectionMode = false;
	            editor.$mouseHandler.$clickSelection = null;
	            editor.$blockScrolling--;
	        };
	
	        var onSelectionInterval = blockSelect;
	
	        event.capture(editor.container, onMouseSelection, onMouseSelectionEnd);
	        var timerId = setInterval(function() {onSelectionInterval();}, 20);
	
	        return e.preventDefault();
	    }
	}
	
	
	exports.onMouseDown = onMouseDown;
	
	});
	
	ace.define("ace/commands/multi_select_commands",["require","exports","module","ace/keyboard/hash_handler"], function(acequire, exports, module) {
	exports.defaultCommands = [{
	    name: "addCursorAbove",
	    exec: function(editor) { editor.selectMoreLines(-1); },
	    bindKey: {win: "Ctrl-Alt-Up", mac: "Ctrl-Alt-Up"},
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "addCursorBelow",
	    exec: function(editor) { editor.selectMoreLines(1); },
	    bindKey: {win: "Ctrl-Alt-Down", mac: "Ctrl-Alt-Down"},
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "addCursorAboveSkipCurrent",
	    exec: function(editor) { editor.selectMoreLines(-1, true); },
	    bindKey: {win: "Ctrl-Alt-Shift-Up", mac: "Ctrl-Alt-Shift-Up"},
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "addCursorBelowSkipCurrent",
	    exec: function(editor) { editor.selectMoreLines(1, true); },
	    bindKey: {win: "Ctrl-Alt-Shift-Down", mac: "Ctrl-Alt-Shift-Down"},
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectMoreBefore",
	    exec: function(editor) { editor.selectMore(-1); },
	    bindKey: {win: "Ctrl-Alt-Left", mac: "Ctrl-Alt-Left"},
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectMoreAfter",
	    exec: function(editor) { editor.selectMore(1); },
	    bindKey: {win: "Ctrl-Alt-Right", mac: "Ctrl-Alt-Right"},
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectNextBefore",
	    exec: function(editor) { editor.selectMore(-1, true); },
	    bindKey: {win: "Ctrl-Alt-Shift-Left", mac: "Ctrl-Alt-Shift-Left"},
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "selectNextAfter",
	    exec: function(editor) { editor.selectMore(1, true); },
	    bindKey: {win: "Ctrl-Alt-Shift-Right", mac: "Ctrl-Alt-Shift-Right"},
	    scrollIntoView: "cursor",
	    readOnly: true
	}, {
	    name: "splitIntoLines",
	    exec: function(editor) { editor.multiSelect.splitIntoLines(); },
	    bindKey: {win: "Ctrl-Alt-L", mac: "Ctrl-Alt-L"},
	    readOnly: true
	}, {
	    name: "alignCursors",
	    exec: function(editor) { editor.alignCursors(); },
	    bindKey: {win: "Ctrl-Alt-A", mac: "Ctrl-Alt-A"},
	    scrollIntoView: "cursor"
	}, {
	    name: "findAll",
	    exec: function(editor) { editor.findAll(); },
	    bindKey: {win: "Ctrl-Alt-K", mac: "Ctrl-Alt-G"},
	    scrollIntoView: "cursor",
	    readOnly: true
	}];
	exports.multiSelectCommands = [{
	    name: "singleSelection",
	    bindKey: "esc",
	    exec: function(editor) { editor.exitMultiSelectMode(); },
	    scrollIntoView: "cursor",
	    readOnly: true,
	    isAvailable: function(editor) {return editor && editor.inMultiSelectMode}
	}];
	
	var HashHandler = acequire("../keyboard/hash_handler").HashHandler;
	exports.keyboardHandler = new HashHandler(exports.multiSelectCommands);
	
	});
	
	ace.define("ace/multi_select",["require","exports","module","ace/range_list","ace/range","ace/selection","ace/mouse/multi_select_handler","ace/lib/event","ace/lib/lang","ace/commands/multi_select_commands","ace/search","ace/edit_session","ace/editor","ace/config"], function(acequire, exports, module) {
	
	var RangeList = acequire("./range_list").RangeList;
	var Range = acequire("./range").Range;
	var Selection = acequire("./selection").Selection;
	var onMouseDown = acequire("./mouse/multi_select_handler").onMouseDown;
	var event = acequire("./lib/event");
	var lang = acequire("./lib/lang");
	var commands = acequire("./commands/multi_select_commands");
	exports.commands = commands.defaultCommands.concat(commands.multiSelectCommands);
	var Search = acequire("./search").Search;
	var search = new Search();
	
	function find(session, needle, dir) {
	    search.$options.wrap = true;
	    search.$options.needle = needle;
	    search.$options.backwards = dir == -1;
	    return search.find(session);
	}
	var EditSession = acequire("./edit_session").EditSession;
	(function() {
	    this.getSelectionMarkers = function() {
	        return this.$selectionMarkers;
	    };
	}).call(EditSession.prototype);
	(function() {
	    this.ranges = null;
	    this.rangeList = null;
	    this.addRange = function(range, $blockChangeEvents) {
	        if (!range)
	            return;
	
	        if (!this.inMultiSelectMode && this.rangeCount === 0) {
	            var oldRange = this.toOrientedRange();
	            this.rangeList.add(oldRange);
	            this.rangeList.add(range);
	            if (this.rangeList.ranges.length != 2) {
	                this.rangeList.removeAll();
	                return $blockChangeEvents || this.fromOrientedRange(range);
	            }
	            this.rangeList.removeAll();
	            this.rangeList.add(oldRange);
	            this.$onAddRange(oldRange);
	        }
	
	        if (!range.cursor)
	            range.cursor = range.end;
	
	        var removed = this.rangeList.add(range);
	
	        this.$onAddRange(range);
	
	        if (removed.length)
	            this.$onRemoveRange(removed);
	
	        if (this.rangeCount > 1 && !this.inMultiSelectMode) {
	            this._signal("multiSelect");
	            this.inMultiSelectMode = true;
	            this.session.$undoSelect = false;
	            this.rangeList.attach(this.session);
	        }
	
	        return $blockChangeEvents || this.fromOrientedRange(range);
	    };
	
	    this.toSingleRange = function(range) {
	        range = range || this.ranges[0];
	        var removed = this.rangeList.removeAll();
	        if (removed.length)
	            this.$onRemoveRange(removed);
	
	        range && this.fromOrientedRange(range);
	    };
	    this.substractPoint = function(pos) {
	        var removed = this.rangeList.substractPoint(pos);
	        if (removed) {
	            this.$onRemoveRange(removed);
	            return removed[0];
	        }
	    };
	    this.mergeOverlappingRanges = function() {
	        var removed = this.rangeList.merge();
	        if (removed.length)
	            this.$onRemoveRange(removed);
	        else if(this.ranges[0])
	            this.fromOrientedRange(this.ranges[0]);
	    };
	
	    this.$onAddRange = function(range) {
	        this.rangeCount = this.rangeList.ranges.length;
	        this.ranges.unshift(range);
	        this._signal("addRange", {range: range});
	    };
	
	    this.$onRemoveRange = function(removed) {
	        this.rangeCount = this.rangeList.ranges.length;
	        if (this.rangeCount == 1 && this.inMultiSelectMode) {
	            var lastRange = this.rangeList.ranges.pop();
	            removed.push(lastRange);
	            this.rangeCount = 0;
	        }
	
	        for (var i = removed.length; i--; ) {
	            var index = this.ranges.indexOf(removed[i]);
	            this.ranges.splice(index, 1);
	        }
	
	        this._signal("removeRange", {ranges: removed});
	
	        if (this.rangeCount === 0 && this.inMultiSelectMode) {
	            this.inMultiSelectMode = false;
	            this._signal("singleSelect");
	            this.session.$undoSelect = true;
	            this.rangeList.detach(this.session);
	        }
	
	        lastRange = lastRange || this.ranges[0];
	        if (lastRange && !lastRange.isEqual(this.getRange()))
	            this.fromOrientedRange(lastRange);
	    };
	    this.$initRangeList = function() {
	        if (this.rangeList)
	            return;
	
	        this.rangeList = new RangeList();
	        this.ranges = [];
	        this.rangeCount = 0;
	    };
	    this.getAllRanges = function() {
	        return this.rangeCount ? this.rangeList.ranges.concat() : [this.getRange()];
	    };
	
	    this.splitIntoLines = function () {
	        if (this.rangeCount > 1) {
	            var ranges = this.rangeList.ranges;
	            var lastRange = ranges[ranges.length - 1];
	            var range = Range.fromPoints(ranges[0].start, lastRange.end);
	
	            this.toSingleRange();
	            this.setSelectionRange(range, lastRange.cursor == lastRange.start);
	        } else {
	            var range = this.getRange();
	            var isBackwards = this.isBackwards();
	            var startRow = range.start.row;
	            var endRow = range.end.row;
	            if (startRow == endRow) {
	                if (isBackwards)
	                    var start = range.end, end = range.start;
	                else
	                    var start = range.start, end = range.end;
	                
	                this.addRange(Range.fromPoints(end, end));
	                this.addRange(Range.fromPoints(start, start));
	                return;
	            }
	
	            var rectSel = [];
	            var r = this.getLineRange(startRow, true);
	            r.start.column = range.start.column;
	            rectSel.push(r);
	
	            for (var i = startRow + 1; i < endRow; i++)
	                rectSel.push(this.getLineRange(i, true));
	
	            r = this.getLineRange(endRow, true);
	            r.end.column = range.end.column;
	            rectSel.push(r);
	
	            rectSel.forEach(this.addRange, this);
	        }
	    };
	    this.toggleBlockSelection = function () {
	        if (this.rangeCount > 1) {
	            var ranges = this.rangeList.ranges;
	            var lastRange = ranges[ranges.length - 1];
	            var range = Range.fromPoints(ranges[0].start, lastRange.end);
	
	            this.toSingleRange();
	            this.setSelectionRange(range, lastRange.cursor == lastRange.start);
	        } else {
	            var cursor = this.session.documentToScreenPosition(this.selectionLead);
	            var anchor = this.session.documentToScreenPosition(this.selectionAnchor);
	
	            var rectSel = this.rectangularRangeBlock(cursor, anchor);
	            rectSel.forEach(this.addRange, this);
	        }
	    };
	    this.rectangularRangeBlock = function(screenCursor, screenAnchor, includeEmptyLines) {
	        var rectSel = [];
	
	        var xBackwards = screenCursor.column < screenAnchor.column;
	        if (xBackwards) {
	            var startColumn = screenCursor.column;
	            var endColumn = screenAnchor.column;
	        } else {
	            var startColumn = screenAnchor.column;
	            var endColumn = screenCursor.column;
	        }
	
	        var yBackwards = screenCursor.row < screenAnchor.row;
	        if (yBackwards) {
	            var startRow = screenCursor.row;
	            var endRow = screenAnchor.row;
	        } else {
	            var startRow = screenAnchor.row;
	            var endRow = screenCursor.row;
	        }
	
	        if (startColumn < 0)
	            startColumn = 0;
	        if (startRow < 0)
	            startRow = 0;
	
	        if (startRow == endRow)
	            includeEmptyLines = true;
	
	        for (var row = startRow; row <= endRow; row++) {
	            var range = Range.fromPoints(
	                this.session.screenToDocumentPosition(row, startColumn),
	                this.session.screenToDocumentPosition(row, endColumn)
	            );
	            if (range.isEmpty()) {
	                if (docEnd && isSamePoint(range.end, docEnd))
	                    break;
	                var docEnd = range.end;
	            }
	            range.cursor = xBackwards ? range.start : range.end;
	            rectSel.push(range);
	        }
	
	        if (yBackwards)
	            rectSel.reverse();
	
	        if (!includeEmptyLines) {
	            var end = rectSel.length - 1;
	            while (rectSel[end].isEmpty() && end > 0)
	                end--;
	            if (end > 0) {
	                var start = 0;
	                while (rectSel[start].isEmpty())
	                    start++;
	            }
	            for (var i = end; i >= start; i--) {
	                if (rectSel[i].isEmpty())
	                    rectSel.splice(i, 1);
	            }
	        }
	
	        return rectSel;
	    };
	}).call(Selection.prototype);
	var Editor = acequire("./editor").Editor;
	(function() {
	    this.updateSelectionMarkers = function() {
	        this.renderer.updateCursor();
	        this.renderer.updateBackMarkers();
	    };
	    this.addSelectionMarker = function(orientedRange) {
	        if (!orientedRange.cursor)
	            orientedRange.cursor = orientedRange.end;
	
	        var style = this.getSelectionStyle();
	        orientedRange.marker = this.session.addMarker(orientedRange, "ace_selection", style);
	
	        this.session.$selectionMarkers.push(orientedRange);
	        this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
	        return orientedRange;
	    };
	    this.removeSelectionMarker = function(range) {
	        if (!range.marker)
	            return;
	        this.session.removeMarker(range.marker);
	        var index = this.session.$selectionMarkers.indexOf(range);
	        if (index != -1)
	            this.session.$selectionMarkers.splice(index, 1);
	        this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
	    };
	
	    this.removeSelectionMarkers = function(ranges) {
	        var markerList = this.session.$selectionMarkers;
	        for (var i = ranges.length; i--; ) {
	            var range = ranges[i];
	            if (!range.marker)
	                continue;
	            this.session.removeMarker(range.marker);
	            var index = markerList.indexOf(range);
	            if (index != -1)
	                markerList.splice(index, 1);
	        }
	        this.session.selectionMarkerCount = markerList.length;
	    };
	
	    this.$onAddRange = function(e) {
	        this.addSelectionMarker(e.range);
	        this.renderer.updateCursor();
	        this.renderer.updateBackMarkers();
	    };
	
	    this.$onRemoveRange = function(e) {
	        this.removeSelectionMarkers(e.ranges);
	        this.renderer.updateCursor();
	        this.renderer.updateBackMarkers();
	    };
	
	    this.$onMultiSelect = function(e) {
	        if (this.inMultiSelectMode)
	            return;
	        this.inMultiSelectMode = true;
	
	        this.setStyle("ace_multiselect");
	        this.keyBinding.addKeyboardHandler(commands.keyboardHandler);
	        this.commands.setDefaultHandler("exec", this.$onMultiSelectExec);
	
	        this.renderer.updateCursor();
	        this.renderer.updateBackMarkers();
	    };
	
	    this.$onSingleSelect = function(e) {
	        if (this.session.multiSelect.inVirtualMode)
	            return;
	        this.inMultiSelectMode = false;
	
	        this.unsetStyle("ace_multiselect");
	        this.keyBinding.removeKeyboardHandler(commands.keyboardHandler);
	
	        this.commands.removeDefaultHandler("exec", this.$onMultiSelectExec);
	        this.renderer.updateCursor();
	        this.renderer.updateBackMarkers();
	        this._emit("changeSelection");
	    };
	
	    this.$onMultiSelectExec = function(e) {
	        var command = e.command;
	        var editor = e.editor;
	        if (!editor.multiSelect)
	            return;
	        if (!command.multiSelectAction) {
	            var result = command.exec(editor, e.args || {});
	            editor.multiSelect.addRange(editor.multiSelect.toOrientedRange());
	            editor.multiSelect.mergeOverlappingRanges();
	        } else if (command.multiSelectAction == "forEach") {
	            result = editor.forEachSelection(command, e.args);
	        } else if (command.multiSelectAction == "forEachLine") {
	            result = editor.forEachSelection(command, e.args, true);
	        } else if (command.multiSelectAction == "single") {
	            editor.exitMultiSelectMode();
	            result = command.exec(editor, e.args || {});
	        } else {
	            result = command.multiSelectAction(editor, e.args || {});
	        }
	        return result;
	    }; 
	    this.forEachSelection = function(cmd, args, options) {
	        if (this.inVirtualSelectionMode)
	            return;
	        var keepOrder = options && options.keepOrder;
	        var $byLines = options == true || options && options.$byLines
	        var session = this.session;
	        var selection = this.selection;
	        var rangeList = selection.rangeList;
	        var ranges = (keepOrder ? selection : rangeList).ranges;
	        var result;
	        
	        if (!ranges.length)
	            return cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
	        
	        var reg = selection._eventRegistry;
	        selection._eventRegistry = {};
	
	        var tmpSel = new Selection(session);
	        this.inVirtualSelectionMode = true;
	        for (var i = ranges.length; i--;) {
	            if ($byLines) {
	                while (i > 0 && ranges[i].start.row == ranges[i - 1].end.row)
	                    i--;
	            }
	            tmpSel.fromOrientedRange(ranges[i]);
	            tmpSel.index = i;
	            this.selection = session.selection = tmpSel;
	            var cmdResult = cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
	            if (!result && cmdResult !== undefined)
	                result = cmdResult;
	            tmpSel.toOrientedRange(ranges[i]);
	        }
	        tmpSel.detach();
	
	        this.selection = session.selection = selection;
	        this.inVirtualSelectionMode = false;
	        selection._eventRegistry = reg;
	        selection.mergeOverlappingRanges();
	        
	        var anim = this.renderer.$scrollAnimation;
	        this.onCursorChange();
	        this.onSelectionChange();
	        if (anim && anim.from == anim.to)
	            this.renderer.animateScrolling(anim.from);
	        
	        return result;
	    };
	    this.exitMultiSelectMode = function() {
	        if (!this.inMultiSelectMode || this.inVirtualSelectionMode)
	            return;
	        this.multiSelect.toSingleRange();
	    };
	
	    this.getSelectedText = function() {
	        var text = "";
	        if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
	            var ranges = this.multiSelect.rangeList.ranges;
	            var buf = [];
	            for (var i = 0; i < ranges.length; i++) {
	                buf.push(this.session.getTextRange(ranges[i]));
	            }
	            var nl = this.session.getDocument().getNewLineCharacter();
	            text = buf.join(nl);
	            if (text.length == (buf.length - 1) * nl.length)
	                text = "";
	        } else if (!this.selection.isEmpty()) {
	            text = this.session.getTextRange(this.getSelectionRange());
	        }
	        return text;
	    };
	    
	    this.$checkMultiselectChange = function(e, anchor) {
	        if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
	            var range = this.multiSelect.ranges[0];
	            if (this.multiSelect.isEmpty() && anchor == this.multiSelect.anchor)
	                return;
	            var pos = anchor == this.multiSelect.anchor
	                ? range.cursor == range.start ? range.end : range.start
	                : range.cursor;
	            if (pos.row != anchor.row 
	                || this.session.$clipPositionToDocument(pos.row, pos.column).column != anchor.column)
	                this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange());
	        }
	    };
	    this.findAll = function(needle, options, additive) {
	        options = options || {};
	        options.needle = needle || options.needle;
	        if (options.needle == undefined) {
	            var range = this.selection.isEmpty()
	                ? this.selection.getWordRange()
	                : this.selection.getRange();
	            options.needle = this.session.getTextRange(range);
	        }    
	        this.$search.set(options);
	        
	        var ranges = this.$search.findAll(this.session);
	        if (!ranges.length)
	            return 0;
	
	        this.$blockScrolling += 1;
	        var selection = this.multiSelect;
	
	        if (!additive)
	            selection.toSingleRange(ranges[0]);
	
	        for (var i = ranges.length; i--; )
	            selection.addRange(ranges[i], true);
	        if (range && selection.rangeList.rangeAtPoint(range.start))
	            selection.addRange(range, true);
	        
	        this.$blockScrolling -= 1;
	
	        return ranges.length;
	    };
	    this.selectMoreLines = function(dir, skip) {
	        var range = this.selection.toOrientedRange();
	        var isBackwards = range.cursor == range.end;
	
	        var screenLead = this.session.documentToScreenPosition(range.cursor);
	        if (this.selection.$desiredColumn)
	            screenLead.column = this.selection.$desiredColumn;
	
	        var lead = this.session.screenToDocumentPosition(screenLead.row + dir, screenLead.column);
	
	        if (!range.isEmpty()) {
	            var screenAnchor = this.session.documentToScreenPosition(isBackwards ? range.end : range.start);
	            var anchor = this.session.screenToDocumentPosition(screenAnchor.row + dir, screenAnchor.column);
	        } else {
	            var anchor = lead;
	        }
	
	        if (isBackwards) {
	            var newRange = Range.fromPoints(lead, anchor);
	            newRange.cursor = newRange.start;
	        } else {
	            var newRange = Range.fromPoints(anchor, lead);
	            newRange.cursor = newRange.end;
	        }
	
	        newRange.desiredColumn = screenLead.column;
	        if (!this.selection.inMultiSelectMode) {
	            this.selection.addRange(range);
	        } else {
	            if (skip)
	                var toRemove = range.cursor;
	        }
	
	        this.selection.addRange(newRange);
	        if (toRemove)
	            this.selection.substractPoint(toRemove);
	    };
	    this.transposeSelections = function(dir) {
	        var session = this.session;
	        var sel = session.multiSelect;
	        var all = sel.ranges;
	
	        for (var i = all.length; i--; ) {
	            var range = all[i];
	            if (range.isEmpty()) {
	                var tmp = session.getWordRange(range.start.row, range.start.column);
	                range.start.row = tmp.start.row;
	                range.start.column = tmp.start.column;
	                range.end.row = tmp.end.row;
	                range.end.column = tmp.end.column;
	            }
	        }
	        sel.mergeOverlappingRanges();
	
	        var words = [];
	        for (var i = all.length; i--; ) {
	            var range = all[i];
	            words.unshift(session.getTextRange(range));
	        }
	
	        if (dir < 0)
	            words.unshift(words.pop());
	        else
	            words.push(words.shift());
	
	        for (var i = all.length; i--; ) {
	            var range = all[i];
	            var tmp = range.clone();
	            session.replace(range, words[i]);
	            range.start.row = tmp.start.row;
	            range.start.column = tmp.start.column;
	        }
	    };
	    this.selectMore = function(dir, skip, stopAtFirst) {
	        var session = this.session;
	        var sel = session.multiSelect;
	
	        var range = sel.toOrientedRange();
	        if (range.isEmpty()) {
	            range = session.getWordRange(range.start.row, range.start.column);
	            range.cursor = dir == -1 ? range.start : range.end;
	            this.multiSelect.addRange(range);
	            if (stopAtFirst)
	                return;
	        }
	        var needle = session.getTextRange(range);
	
	        var newRange = find(session, needle, dir);
	        if (newRange) {
	            newRange.cursor = dir == -1 ? newRange.start : newRange.end;
	            this.$blockScrolling += 1;
	            this.session.unfold(newRange);
	            this.multiSelect.addRange(newRange);
	            this.$blockScrolling -= 1;
	            this.renderer.scrollCursorIntoView(null, 0.5);
	        }
	        if (skip)
	            this.multiSelect.substractPoint(range.cursor);
	    };
	    this.alignCursors = function() {
	        var session = this.session;
	        var sel = session.multiSelect;
	        var ranges = sel.ranges;
	        var row = -1;
	        var sameRowRanges = ranges.filter(function(r) {
	            if (r.cursor.row == row)
	                return true;
	            row = r.cursor.row;
	        });
	        
	        if (!ranges.length || sameRowRanges.length == ranges.length - 1) {
	            var range = this.selection.getRange();
	            var fr = range.start.row, lr = range.end.row;
	            var guessRange = fr == lr;
	            if (guessRange) {
	                var max = this.session.getLength();
	                var line;
	                do {
	                    line = this.session.getLine(lr);
	                } while (/[=:]/.test(line) && ++lr < max);
	                do {
	                    line = this.session.getLine(fr);
	                } while (/[=:]/.test(line) && --fr > 0);
	                
	                if (fr < 0) fr = 0;
	                if (lr >= max) lr = max - 1;
	            }
	            var lines = this.session.removeFullLines(fr, lr);
	            lines = this.$reAlignText(lines, guessRange);
	            this.session.insert({row: fr, column: 0}, lines.join("\n") + "\n");
	            if (!guessRange) {
	                range.start.column = 0;
	                range.end.column = lines[lines.length - 1].length;
	            }
	            this.selection.setRange(range);
	        } else {
	            sameRowRanges.forEach(function(r) {
	                sel.substractPoint(r.cursor);
	            });
	
	            var maxCol = 0;
	            var minSpace = Infinity;
	            var spaceOffsets = ranges.map(function(r) {
	                var p = r.cursor;
	                var line = session.getLine(p.row);
	                var spaceOffset = line.substr(p.column).search(/\S/g);
	                if (spaceOffset == -1)
	                    spaceOffset = 0;
	
	                if (p.column > maxCol)
	                    maxCol = p.column;
	                if (spaceOffset < minSpace)
	                    minSpace = spaceOffset;
	                return spaceOffset;
	            });
	            ranges.forEach(function(r, i) {
	                var p = r.cursor;
	                var l = maxCol - p.column;
	                var d = spaceOffsets[i] - minSpace;
	                if (l > d)
	                    session.insert(p, lang.stringRepeat(" ", l - d));
	                else
	                    session.remove(new Range(p.row, p.column, p.row, p.column - l + d));
	
	                r.start.column = r.end.column = maxCol;
	                r.start.row = r.end.row = p.row;
	                r.cursor = r.end;
	            });
	            sel.fromOrientedRange(ranges[0]);
	            this.renderer.updateCursor();
	            this.renderer.updateBackMarkers();
	        }
	    };
	
	    this.$reAlignText = function(lines, forceLeft) {
	        var isLeftAligned = true, isRightAligned = true;
	        var startW, textW, endW;
	
	        return lines.map(function(line) {
	            var m = line.match(/(\s*)(.*?)(\s*)([=:].*)/);
	            if (!m)
	                return [line];
	
	            if (startW == null) {
	                startW = m[1].length;
	                textW = m[2].length;
	                endW = m[3].length;
	                return m;
	            }
	
	            if (startW + textW + endW != m[1].length + m[2].length + m[3].length)
	                isRightAligned = false;
	            if (startW != m[1].length)
	                isLeftAligned = false;
	
	            if (startW > m[1].length)
	                startW = m[1].length;
	            if (textW < m[2].length)
	                textW = m[2].length;
	            if (endW > m[3].length)
	                endW = m[3].length;
	
	            return m;
	        }).map(forceLeft ? alignLeft :
	            isLeftAligned ? isRightAligned ? alignRight : alignLeft : unAlign);
	
	        function spaces(n) {
	            return lang.stringRepeat(" ", n);
	        }
	
	        function alignLeft(m) {
	            return !m[2] ? m[0] : spaces(startW) + m[2]
	                + spaces(textW - m[2].length + endW)
	                + m[4].replace(/^([=:])\s+/, "$1 ");
	        }
	        function alignRight(m) {
	            return !m[2] ? m[0] : spaces(startW + textW - m[2].length) + m[2]
	                + spaces(endW, " ")
	                + m[4].replace(/^([=:])\s+/, "$1 ");
	        }
	        function unAlign(m) {
	            return !m[2] ? m[0] : spaces(startW) + m[2]
	                + spaces(endW)
	                + m[4].replace(/^([=:])\s+/, "$1 ");
	        }
	    };
	}).call(Editor.prototype);
	
	
	function isSamePoint(p1, p2) {
	    return p1.row == p2.row && p1.column == p2.column;
	}
	exports.onSessionChange = function(e) {
	    var session = e.session;
	    if (session && !session.multiSelect) {
	        session.$selectionMarkers = [];
	        session.selection.$initRangeList();
	        session.multiSelect = session.selection;
	    }
	    this.multiSelect = session && session.multiSelect;
	
	    var oldSession = e.oldSession;
	    if (oldSession) {
	        oldSession.multiSelect.off("addRange", this.$onAddRange);
	        oldSession.multiSelect.off("removeRange", this.$onRemoveRange);
	        oldSession.multiSelect.off("multiSelect", this.$onMultiSelect);
	        oldSession.multiSelect.off("singleSelect", this.$onSingleSelect);
	        oldSession.multiSelect.lead.off("change", this.$checkMultiselectChange);
	        oldSession.multiSelect.anchor.off("change", this.$checkMultiselectChange);
	    }
	
	    if (session) {
	        session.multiSelect.on("addRange", this.$onAddRange);
	        session.multiSelect.on("removeRange", this.$onRemoveRange);
	        session.multiSelect.on("multiSelect", this.$onMultiSelect);
	        session.multiSelect.on("singleSelect", this.$onSingleSelect);
	        session.multiSelect.lead.on("change", this.$checkMultiselectChange);
	        session.multiSelect.anchor.on("change", this.$checkMultiselectChange);
	    }
	
	    if (session && this.inMultiSelectMode != session.selection.inMultiSelectMode) {
	        if (session.selection.inMultiSelectMode)
	            this.$onMultiSelect();
	        else
	            this.$onSingleSelect();
	    }
	};
	function MultiSelect(editor) {
	    if (editor.$multiselectOnSessionChange)
	        return;
	    editor.$onAddRange = editor.$onAddRange.bind(editor);
	    editor.$onRemoveRange = editor.$onRemoveRange.bind(editor);
	    editor.$onMultiSelect = editor.$onMultiSelect.bind(editor);
	    editor.$onSingleSelect = editor.$onSingleSelect.bind(editor);
	    editor.$multiselectOnSessionChange = exports.onSessionChange.bind(editor);
	    editor.$checkMultiselectChange = editor.$checkMultiselectChange.bind(editor);
	
	    editor.$multiselectOnSessionChange(editor);
	    editor.on("changeSession", editor.$multiselectOnSessionChange);
	
	    editor.on("mousedown", onMouseDown);
	    editor.commands.addCommands(commands.defaultCommands);
	
	    addAltCursorListeners(editor);
	}
	
	function addAltCursorListeners(editor){
	    var el = editor.textInput.getElement();
	    var altCursor = false;
	    event.addListener(el, "keydown", function(e) {
	        var altDown = e.keyCode == 18 && !(e.ctrlKey || e.shiftKey || e.metaKey);
	        if (editor.$blockSelectEnabled && altDown) {
	            if (!altCursor) {
	                editor.renderer.setMouseCursor("crosshair");
	                altCursor = true;
	            }
	        } else if (altCursor) {
	            reset();
	        }
	    });
	
	    event.addListener(el, "keyup", reset);
	    event.addListener(el, "blur", reset);
	    function reset(e) {
	        if (altCursor) {
	            editor.renderer.setMouseCursor("");
	            altCursor = false;
	        }
	    }
	}
	
	exports.MultiSelect = MultiSelect;
	
	
	acequire("./config").defineOptions(Editor.prototype, "editor", {
	    enableMultiselect: {
	        set: function(val) {
	            MultiSelect(this);
	            if (val) {
	                this.on("changeSession", this.$multiselectOnSessionChange);
	                this.on("mousedown", onMouseDown);
	            } else {
	                this.off("changeSession", this.$multiselectOnSessionChange);
	                this.off("mousedown", onMouseDown);
	            }
	        },
	        value: true
	    },
	    enableBlockSelect: {
	        set: function(val) {
	            this.$blockSelectEnabled = val;
	        },
	        value: true
	    }
	});
	
	
	
	});
	
	ace.define("ace/mode/folding/fold_mode",["require","exports","module","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../../range").Range;
	
	var FoldMode = exports.FoldMode = function() {};
	
	(function() {
	
	    this.foldingStartMarker = null;
	    this.foldingStopMarker = null;
	    this.getFoldWidget = function(session, foldStyle, row) {
	        var line = session.getLine(row);
	        if (this.foldingStartMarker.test(line))
	            return "start";
	        if (foldStyle == "markbeginend"
	                && this.foldingStopMarker
	                && this.foldingStopMarker.test(line))
	            return "end";
	        return "";
	    };
	
	    this.getFoldWidgetRange = function(session, foldStyle, row) {
	        return null;
	    };
	
	    this.indentationBlock = function(session, row, column) {
	        var re = /\S/;
	        var line = session.getLine(row);
	        var startLevel = line.search(re);
	        if (startLevel == -1)
	            return;
	
	        var startColumn = column || line.length;
	        var maxRow = session.getLength();
	        var startRow = row;
	        var endRow = row;
	
	        while (++row < maxRow) {
	            var level = session.getLine(row).search(re);
	
	            if (level == -1)
	                continue;
	
	            if (level <= startLevel)
	                break;
	
	            endRow = row;
	        }
	
	        if (endRow > startRow) {
	            var endColumn = session.getLine(endRow).length;
	            return new Range(startRow, startColumn, endRow, endColumn);
	        }
	    };
	
	    this.openingBracketBlock = function(session, bracket, row, column, typeRe) {
	        var start = {row: row, column: column + 1};
	        var end = session.$findClosingBracket(bracket, start, typeRe);
	        if (!end)
	            return;
	
	        var fw = session.foldWidgets[end.row];
	        if (fw == null)
	            fw = session.getFoldWidget(end.row);
	
	        if (fw == "start" && end.row > start.row) {
	            end.row --;
	            end.column = session.getLine(end.row).length;
	        }
	        return Range.fromPoints(start, end);
	    };
	
	    this.closingBracketBlock = function(session, bracket, row, column, typeRe) {
	        var end = {row: row, column: column};
	        var start = session.$findOpeningBracket(bracket, end);
	
	        if (!start)
	            return;
	
	        start.column++;
	        end.column--;
	
	        return  Range.fromPoints(start, end);
	    };
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/theme/textmate",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
	"use strict";
	
	exports.isDark = false;
	exports.cssClass = "ace-tm";
	exports.cssText = ".ace-tm .ace_gutter {\
	background: #f0f0f0;\
	color: #333;\
	}\
	.ace-tm .ace_print-margin {\
	width: 1px;\
	background: #e8e8e8;\
	}\
	.ace-tm .ace_fold {\
	background-color: #6B72E6;\
	}\
	.ace-tm {\
	background-color: #FFFFFF;\
	color: black;\
	}\
	.ace-tm .ace_cursor {\
	color: black;\
	}\
	.ace-tm .ace_invisible {\
	color: rgb(191, 191, 191);\
	}\
	.ace-tm .ace_storage,\
	.ace-tm .ace_keyword {\
	color: blue;\
	}\
	.ace-tm .ace_constant {\
	color: rgb(197, 6, 11);\
	}\
	.ace-tm .ace_constant.ace_buildin {\
	color: rgb(88, 72, 246);\
	}\
	.ace-tm .ace_constant.ace_language {\
	color: rgb(88, 92, 246);\
	}\
	.ace-tm .ace_constant.ace_library {\
	color: rgb(6, 150, 14);\
	}\
	.ace-tm .ace_invalid {\
	background-color: rgba(255, 0, 0, 0.1);\
	color: red;\
	}\
	.ace-tm .ace_support.ace_function {\
	color: rgb(60, 76, 114);\
	}\
	.ace-tm .ace_support.ace_constant {\
	color: rgb(6, 150, 14);\
	}\
	.ace-tm .ace_support.ace_type,\
	.ace-tm .ace_support.ace_class {\
	color: rgb(109, 121, 222);\
	}\
	.ace-tm .ace_keyword.ace_operator {\
	color: rgb(104, 118, 135);\
	}\
	.ace-tm .ace_string {\
	color: rgb(3, 106, 7);\
	}\
	.ace-tm .ace_comment {\
	color: rgb(76, 136, 107);\
	}\
	.ace-tm .ace_comment.ace_doc {\
	color: rgb(0, 102, 255);\
	}\
	.ace-tm .ace_comment.ace_doc.ace_tag {\
	color: rgb(128, 159, 191);\
	}\
	.ace-tm .ace_constant.ace_numeric {\
	color: rgb(0, 0, 205);\
	}\
	.ace-tm .ace_variable {\
	color: rgb(49, 132, 149);\
	}\
	.ace-tm .ace_xml-pe {\
	color: rgb(104, 104, 91);\
	}\
	.ace-tm .ace_entity.ace_name.ace_function {\
	color: #0000A2;\
	}\
	.ace-tm .ace_heading {\
	color: rgb(12, 7, 255);\
	}\
	.ace-tm .ace_list {\
	color:rgb(185, 6, 144);\
	}\
	.ace-tm .ace_meta.ace_tag {\
	color:rgb(0, 22, 142);\
	}\
	.ace-tm .ace_string.ace_regex {\
	color: rgb(255, 0, 0)\
	}\
	.ace-tm .ace_marker-layer .ace_selection {\
	background: rgb(181, 213, 255);\
	}\
	.ace-tm.ace_multiselect .ace_selection.ace_start {\
	box-shadow: 0 0 3px 0px white;\
	}\
	.ace-tm .ace_marker-layer .ace_step {\
	background: rgb(252, 255, 0);\
	}\
	.ace-tm .ace_marker-layer .ace_stack {\
	background: rgb(164, 229, 101);\
	}\
	.ace-tm .ace_marker-layer .ace_bracket {\
	margin: -1px 0 0 -1px;\
	border: 1px solid rgb(192, 192, 192);\
	}\
	.ace-tm .ace_marker-layer .ace_active-line {\
	background: rgba(0, 0, 0, 0.07);\
	}\
	.ace-tm .ace_gutter-active-line {\
	background-color : #dcdcdc;\
	}\
	.ace-tm .ace_marker-layer .ace_selected-word {\
	background: rgb(250, 250, 255);\
	border: 1px solid rgb(200, 200, 250);\
	}\
	.ace-tm .ace_indent-guide {\
	background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
	}\
	";
	
	var dom = acequire("../lib/dom");
	dom.importCssString(exports.cssText, exports.cssClass);
	});
	
	ace.define("ace/line_widgets",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("./lib/oop");
	var dom = acequire("./lib/dom");
	var Range = acequire("./range").Range;
	
	
	function LineWidgets(session) {
	    this.session = session;
	    this.session.widgetManager = this;
	    this.session.getRowLength = this.getRowLength;
	    this.session.$getWidgetScreenLength = this.$getWidgetScreenLength;
	    this.updateOnChange = this.updateOnChange.bind(this);
	    this.renderWidgets = this.renderWidgets.bind(this);
	    this.measureWidgets = this.measureWidgets.bind(this);
	    this.session._changedWidgets = [];
	    this.$onChangeEditor = this.$onChangeEditor.bind(this);
	    
	    this.session.on("change", this.updateOnChange);
	    this.session.on("changeFold", this.updateOnFold);
	    this.session.on("changeEditor", this.$onChangeEditor);
	}
	
	(function() {
	    this.getRowLength = function(row) {
	        var h;
	        if (this.lineWidgets)
	            h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
	        else 
	            h = 0;
	        if (!this.$useWrapMode || !this.$wrapData[row]) {
	            return 1 + h;
	        } else {
	            return this.$wrapData[row].length + 1 + h;
	        }
	    };
	
	    this.$getWidgetScreenLength = function() {
	        var screenRows = 0;
	        this.lineWidgets.forEach(function(w){
	            if (w && w.rowCount && !w.hidden)
	                screenRows += w.rowCount;
	        });
	        return screenRows;
	    };    
	    
	    this.$onChangeEditor = function(e) {
	        this.attach(e.editor);
	    };
	    
	    this.attach = function(editor) {
	        if (editor  && editor.widgetManager && editor.widgetManager != this)
	            editor.widgetManager.detach();
	
	        if (this.editor == editor)
	            return;
	
	        this.detach();
	        this.editor = editor;
	        
	        if (editor) {
	            editor.widgetManager = this;
	            editor.renderer.on("beforeRender", this.measureWidgets);
	            editor.renderer.on("afterRender", this.renderWidgets);
	        }
	    };
	    this.detach = function(e) {
	        var editor = this.editor;
	        if (!editor)
	            return;
	        
	        this.editor = null;
	        editor.widgetManager = null;
	        
	        editor.renderer.off("beforeRender", this.measureWidgets);
	        editor.renderer.off("afterRender", this.renderWidgets);
	        var lineWidgets = this.session.lineWidgets;
	        lineWidgets && lineWidgets.forEach(function(w) {
	            if (w && w.el && w.el.parentNode) {
	                w._inDocument = false;
	                w.el.parentNode.removeChild(w.el);
	            }
	        });
	    };
	
	    this.updateOnFold = function(e, session) {
	        var lineWidgets = session.lineWidgets;
	        if (!lineWidgets || !e.action)
	            return;
	        var fold = e.data;
	        var start = fold.start.row;
	        var end = fold.end.row;
	        var hide = e.action == "add";
	        for (var i = start + 1; i < end; i++) {
	            if (lineWidgets[i])
	                lineWidgets[i].hidden = hide;
	        }
	        if (lineWidgets[end]) {
	            if (hide) {
	                if (!lineWidgets[start])
	                    lineWidgets[start] = lineWidgets[end];
	                else
	                    lineWidgets[end].hidden = hide;
	            } else {
	                if (lineWidgets[start] == lineWidgets[end])
	                    lineWidgets[start] = undefined;
	                lineWidgets[end].hidden = hide;
	            }
	        }
	    };
	    
	    this.updateOnChange = function(delta) {
	        var lineWidgets = this.session.lineWidgets;
	        if (!lineWidgets) return;
	        
	        var startRow = delta.start.row;
	        var len = delta.end.row - startRow;
	
	        if (len === 0) {
	        } else if (delta.action == 'remove') {
	            var removed = lineWidgets.splice(startRow + 1, len);
	            removed.forEach(function(w) {
	                w && this.removeLineWidget(w);
	            }, this);
	            this.$updateRows();
	        } else {
	            var args = new Array(len);
	            args.unshift(startRow, 0);
	            lineWidgets.splice.apply(lineWidgets, args);
	            this.$updateRows();
	        }
	    };
	    
	    this.$updateRows = function() {
	        var lineWidgets = this.session.lineWidgets;
	        if (!lineWidgets) return;
	        var noWidgets = true;
	        lineWidgets.forEach(function(w, i) {
	            if (w) {
	                noWidgets = false;
	                w.row = i;
	                while (w.$oldWidget) {
	                    w.$oldWidget.row = i;
	                    w = w.$oldWidget;
	                }
	            }
	        });
	        if (noWidgets)
	            this.session.lineWidgets = null;
	    };
	
	    this.addLineWidget = function(w) {
	        if (!this.session.lineWidgets)
	            this.session.lineWidgets = new Array(this.session.getLength());
	        
	        var old = this.session.lineWidgets[w.row];
	        if (old) {
	            w.$oldWidget = old;
	            if (old.el && old.el.parentNode) {
	                old.el.parentNode.removeChild(old.el);
	                old._inDocument = false;
	            }
	        }
	            
	        this.session.lineWidgets[w.row] = w;
	        
	        w.session = this.session;
	        
	        var renderer = this.editor.renderer;
	        if (w.html && !w.el) {
	            w.el = dom.createElement("div");
	            w.el.innerHTML = w.html;
	        }
	        if (w.el) {
	            dom.addCssClass(w.el, "ace_lineWidgetContainer");
	            w.el.style.position = "absolute";
	            w.el.style.zIndex = 5;
	            renderer.container.appendChild(w.el);
	            w._inDocument = true;
	        }
	        
	        if (!w.coverGutter) {
	            w.el.style.zIndex = 3;
	        }
	        if (w.pixelHeight == null) {
	            w.pixelHeight = w.el.offsetHeight;
	        }
	        if (w.rowCount == null) {
	            w.rowCount = w.pixelHeight / renderer.layerConfig.lineHeight;
	        }
	        
	        var fold = this.session.getFoldAt(w.row, 0);
	        w.$fold = fold;
	        if (fold) {
	            var lineWidgets = this.session.lineWidgets;
	            if (w.row == fold.end.row && !lineWidgets[fold.start.row])
	                lineWidgets[fold.start.row] = w;
	            else
	                w.hidden = true;
	        }
	            
	        this.session._emit("changeFold", {data:{start:{row: w.row}}});
	        
	        this.$updateRows();
	        this.renderWidgets(null, renderer);
	        this.onWidgetChanged(w);
	        return w;
	    };
	    
	    this.removeLineWidget = function(w) {
	        w._inDocument = false;
	        w.session = null;
	        if (w.el && w.el.parentNode)
	            w.el.parentNode.removeChild(w.el);
	        if (w.editor && w.editor.destroy) try {
	            w.editor.destroy();
	        } catch(e){}
	        if (this.session.lineWidgets) {
	            var w1 = this.session.lineWidgets[w.row]
	            if (w1 == w) {
	                this.session.lineWidgets[w.row] = w.$oldWidget;
	                if (w.$oldWidget)
	                    this.onWidgetChanged(w.$oldWidget);
	            } else {
	                while (w1) {
	                    if (w1.$oldWidget == w) {
	                        w1.$oldWidget = w.$oldWidget;
	                        break;
	                    }
	                    w1 = w1.$oldWidget;
	                }
	            }
	        }
	        this.session._emit("changeFold", {data:{start:{row: w.row}}});
	        this.$updateRows();
	    };
	    
	    this.getWidgetsAtRow = function(row) {
	        var lineWidgets = this.session.lineWidgets;
	        var w = lineWidgets && lineWidgets[row];
	        var list = [];
	        while (w) {
	            list.push(w);
	            w = w.$oldWidget;
	        }
	        return list;
	    };
	    
	    this.onWidgetChanged = function(w) {
	        this.session._changedWidgets.push(w);
	        this.editor && this.editor.renderer.updateFull();
	    };
	    
	    this.measureWidgets = function(e, renderer) {
	        var changedWidgets = this.session._changedWidgets;
	        var config = renderer.layerConfig;
	        
	        if (!changedWidgets || !changedWidgets.length) return;
	        var min = Infinity;
	        for (var i = 0; i < changedWidgets.length; i++) {
	            var w = changedWidgets[i];
	            if (!w || !w.el) continue;
	            if (w.session != this.session) continue;
	            if (!w._inDocument) {
	                if (this.session.lineWidgets[w.row] != w)
	                    continue;
	                w._inDocument = true;
	                renderer.container.appendChild(w.el);
	            }
	            
	            w.h = w.el.offsetHeight;
	            
	            if (!w.fixedWidth) {
	                w.w = w.el.offsetWidth;
	                w.screenWidth = Math.ceil(w.w / config.characterWidth);
	            }
	            
	            var rowCount = w.h / config.lineHeight;
	            if (w.coverLine) {
	                rowCount -= this.session.getRowLineCount(w.row);
	                if (rowCount < 0)
	                    rowCount = 0;
	            }
	            if (w.rowCount != rowCount) {
	                w.rowCount = rowCount;
	                if (w.row < min)
	                    min = w.row;
	            }
	        }
	        if (min != Infinity) {
	            this.session._emit("changeFold", {data:{start:{row: min}}});
	            this.session.lineWidgetWidth = null;
	        }
	        this.session._changedWidgets = [];
	    };
	    
	    this.renderWidgets = function(e, renderer) {
	        var config = renderer.layerConfig;
	        var lineWidgets = this.session.lineWidgets;
	        if (!lineWidgets)
	            return;
	        var first = Math.min(this.firstRow, config.firstRow);
	        var last = Math.max(this.lastRow, config.lastRow, lineWidgets.length);
	        
	        while (first > 0 && !lineWidgets[first])
	            first--;
	        
	        this.firstRow = config.firstRow;
	        this.lastRow = config.lastRow;
	
	        renderer.$cursorLayer.config = config;
	        for (var i = first; i <= last; i++) {
	            var w = lineWidgets[i];
	            if (!w || !w.el) continue;
	            if (w.hidden) {
	                w.el.style.top = -100 - (w.pixelHeight || 0) + "px";
	                continue;
	            }
	            if (!w._inDocument) {
	                w._inDocument = true;
	                renderer.container.appendChild(w.el);
	            }
	            var top = renderer.$cursorLayer.getPixelPosition({row: i, column:0}, true).top;
	            if (!w.coverLine)
	                top += config.lineHeight * this.session.getRowLineCount(w.row);
	            w.el.style.top = top - config.offset + "px";
	            
	            var left = w.coverGutter ? 0 : renderer.gutterWidth;
	            if (!w.fixedWidth)
	                left -= renderer.scrollLeft;
	            w.el.style.left = left + "px";
	            
	            if (w.fullWidth && w.screenWidth) {
	                w.el.style.minWidth = config.width + 2 * config.padding + "px";
	            }
	            
	            if (w.fixedWidth) {
	                w.el.style.right = renderer.scrollBar.getWidth() + "px";
	            } else {
	                w.el.style.right = "";
	            }
	        }
	    };
	    
	}).call(LineWidgets.prototype);
	
	
	exports.LineWidgets = LineWidgets;
	
	});
	
	ace.define("ace/ext/error_marker",["require","exports","module","ace/line_widgets","ace/lib/dom","ace/range"], function(acequire, exports, module) {
	"use strict";
	var LineWidgets = acequire("../line_widgets").LineWidgets;
	var dom = acequire("../lib/dom");
	var Range = acequire("../range").Range;
	
	function binarySearch(array, needle, comparator) {
	    var first = 0;
	    var last = array.length - 1;
	
	    while (first <= last) {
	        var mid = (first + last) >> 1;
	        var c = comparator(needle, array[mid]);
	        if (c > 0)
	            first = mid + 1;
	        else if (c < 0)
	            last = mid - 1;
	        else
	            return mid;
	    }
	    return -(first + 1);
	}
	
	function findAnnotations(session, row, dir) {
	    var annotations = session.getAnnotations().sort(Range.comparePoints);
	    if (!annotations.length)
	        return;
	    
	    var i = binarySearch(annotations, {row: row, column: -1}, Range.comparePoints);
	    if (i < 0)
	        i = -i - 1;
	    
	    if (i >= annotations.length)
	        i = dir > 0 ? 0 : annotations.length - 1;
	    else if (i === 0 && dir < 0)
	        i = annotations.length - 1;
	    
	    var annotation = annotations[i];
	    if (!annotation || !dir)
	        return;
	
	    if (annotation.row === row) {
	        do {
	            annotation = annotations[i += dir];
	        } while (annotation && annotation.row === row);
	        if (!annotation)
	            return annotations.slice();
	    }
	    
	    
	    var matched = [];
	    row = annotation.row;
	    do {
	        matched[dir < 0 ? "unshift" : "push"](annotation);
	        annotation = annotations[i += dir];
	    } while (annotation && annotation.row == row);
	    return matched.length && matched;
	}
	
	exports.showErrorMarker = function(editor, dir) {
	    var session = editor.session;
	    if (!session.widgetManager) {
	        session.widgetManager = new LineWidgets(session);
	        session.widgetManager.attach(editor);
	    }
	    
	    var pos = editor.getCursorPosition();
	    var row = pos.row;
	    var oldWidget = session.widgetManager.getWidgetsAtRow(row).filter(function(w) {
	        return w.type == "errorMarker";
	    })[0];
	    if (oldWidget) {
	        oldWidget.destroy();
	    } else {
	        row -= dir;
	    }
	    var annotations = findAnnotations(session, row, dir);
	    var gutterAnno;
	    if (annotations) {
	        var annotation = annotations[0];
	        pos.column = (annotation.pos && typeof annotation.column != "number"
	            ? annotation.pos.sc
	            : annotation.column) || 0;
	        pos.row = annotation.row;
	        gutterAnno = editor.renderer.$gutterLayer.$annotations[pos.row];
	    } else if (oldWidget) {
	        return;
	    } else {
	        gutterAnno = {
	            text: ["Looks good!"],
	            className: "ace_ok"
	        };
	    }
	    editor.session.unfold(pos.row);
	    editor.selection.moveToPosition(pos);
	    
	    var w = {
	        row: pos.row, 
	        fixedWidth: true,
	        coverGutter: true,
	        el: dom.createElement("div"),
	        type: "errorMarker"
	    };
	    var el = w.el.appendChild(dom.createElement("div"));
	    var arrow = w.el.appendChild(dom.createElement("div"));
	    arrow.className = "error_widget_arrow " + gutterAnno.className;
	    
	    var left = editor.renderer.$cursorLayer
	        .getPixelPosition(pos).left;
	    arrow.style.left = left + editor.renderer.gutterWidth - 5 + "px";
	    
	    w.el.className = "error_widget_wrapper";
	    el.className = "error_widget " + gutterAnno.className;
	    el.innerHTML = gutterAnno.text.join("<br>");
	    
	    el.appendChild(dom.createElement("div"));
	    
	    var kb = function(_, hashId, keyString) {
	        if (hashId === 0 && (keyString === "esc" || keyString === "return")) {
	            w.destroy();
	            return {command: "null"};
	        }
	    };
	    
	    w.destroy = function() {
	        if (editor.$mouseHandler.isMousePressed)
	            return;
	        editor.keyBinding.removeKeyboardHandler(kb);
	        session.widgetManager.removeLineWidget(w);
	        editor.off("changeSelection", w.destroy);
	        editor.off("changeSession", w.destroy);
	        editor.off("mouseup", w.destroy);
	        editor.off("change", w.destroy);
	    };
	    
	    editor.keyBinding.addKeyboardHandler(kb);
	    editor.on("changeSelection", w.destroy);
	    editor.on("changeSession", w.destroy);
	    editor.on("mouseup", w.destroy);
	    editor.on("change", w.destroy);
	    
	    editor.session.widgetManager.addLineWidget(w);
	    
	    w.el.onmousedown = editor.focus.bind(editor);
	    
	    editor.renderer.scrollCursorIntoView(null, 0.5, {bottom: w.el.offsetHeight});
	};
	
	
	dom.importCssString("\
	    .error_widget_wrapper {\
	        background: inherit;\
	        color: inherit;\
	        border:none\
	    }\
	    .error_widget {\
	        border-top: solid 2px;\
	        border-bottom: solid 2px;\
	        margin: 5px 0;\
	        padding: 10px 40px;\
	        white-space: pre-wrap;\
	    }\
	    .error_widget.ace_error, .error_widget_arrow.ace_error{\
	        border-color: #ff5a5a\
	    }\
	    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\
	        border-color: #F1D817\
	    }\
	    .error_widget.ace_info, .error_widget_arrow.ace_info{\
	        border-color: #5a5a5a\
	    }\
	    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\
	        border-color: #5aaa5a\
	    }\
	    .error_widget_arrow {\
	        position: absolute;\
	        border: solid 5px;\
	        border-top-color: transparent!important;\
	        border-right-color: transparent!important;\
	        border-left-color: transparent!important;\
	        top: -5px;\
	    }\
	", "");
	
	});
	
	ace.define("ace/ace",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/dom","ace/lib/event","ace/editor","ace/edit_session","ace/undomanager","ace/virtual_renderer","ace/worker/worker_client","ace/keyboard/hash_handler","ace/placeholder","ace/multi_select","ace/mode/folding/fold_mode","ace/theme/textmate","ace/ext/error_marker","ace/config"], function(acequire, exports, module) {
	"use strict";
	
	acequire("./lib/fixoldbrowsers");
	
	var dom = acequire("./lib/dom");
	var event = acequire("./lib/event");
	
	var Editor = acequire("./editor").Editor;
	var EditSession = acequire("./edit_session").EditSession;
	var UndoManager = acequire("./undomanager").UndoManager;
	var Renderer = acequire("./virtual_renderer").VirtualRenderer;
	acequire("./worker/worker_client");
	acequire("./keyboard/hash_handler");
	acequire("./placeholder");
	acequire("./multi_select");
	acequire("./mode/folding/fold_mode");
	acequire("./theme/textmate");
	acequire("./ext/error_marker");
	
	exports.config = acequire("./config");
	exports.acequire = acequire;
	
	if (true)
	    exports.define = __webpack_require__(262);
	exports.edit = function(el) {
	    if (typeof el == "string") {
	        var _id = el;
	        el = document.getElementById(_id);
	        if (!el)
	            throw new Error("ace.edit can't find div #" + _id);
	    }
	
	    if (el && el.env && el.env.editor instanceof Editor)
	        return el.env.editor;
	
	    var value = "";
	    if (el && /input|textarea/i.test(el.tagName)) {
	        var oldNode = el;
	        value = oldNode.value;
	        el = dom.createElement("pre");
	        oldNode.parentNode.replaceChild(el, oldNode);
	    } else if (el) {
	        value = dom.getInnerText(el);
	        el.innerHTML = "";
	    }
	
	    var doc = exports.createEditSession(value);
	
	    var editor = new Editor(new Renderer(el));
	    editor.setSession(doc);
	
	    var env = {
	        document: doc,
	        editor: editor,
	        onResize: editor.resize.bind(editor, null)
	    };
	    if (oldNode) env.textarea = oldNode;
	    event.addListener(window, "resize", env.onResize);
	    editor.on("destroy", function() {
	        event.removeListener(window, "resize", env.onResize);
	        env.editor.container.env = null; // prevent memory leak on old ie
	    });
	    editor.container.env = editor.env = env;
	    return editor;
	};
	exports.createEditSession = function(text, mode) {
	    var doc = new EditSession(text, mode);
	    doc.setUndoManager(new UndoManager());
	    return doc;
	}
	exports.EditSession = EditSession;
	exports.UndoManager = UndoManager;
	exports.version = "1.2.6";
	});
	            (function() {
	                ace.acequire(["ace/ace"], function(a) {
	                    if (a) {
	                        a.config.init(true);
	                        a.define = ace.define;
	                    }
	                    if (!window.ace)
	                        window.ace = a;
	                    for (var key in a) if (a.hasOwnProperty(key))
	                        window.ace[key] = a[key];
	                });
	            })();
	        
	module.exports = window.ace.acequire("ace/ace");

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/json",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="json"})

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	module.exports.id = 'ace/mode/javascript_worker';
	module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/javascript/jshint\",[\"require\",\"exports\",\"module\"],function(acequire,exports,module){module.exports=function outer(modules,cache,entry){function newRequire(name,jumped){if(!cache[name]){if(!modules[name]){var currentRequire=\"function\"==typeof acequire&&acequire;if(!jumped&&currentRequire)return currentRequire(name,!0);if(previousRequire)return previousRequire(name,!0);var err=Error(\"Cannot find module '\"+name+\"'\");throw err.code=\"MODULE_NOT_FOUND\",err}var m=cache[name]={exports:{}};modules[name][0].call(m.exports,function(x){var id=modules[name][1][x];return newRequire(id?id:x)},m,m.exports,outer,modules,cache,entry)}return cache[name].exports}for(var previousRequire=\"function\"==typeof acequire&&acequire,i=0;entry.length>i;i++)newRequire(entry[i]);return newRequire(entry[0])}({\"/node_modules/browserify/node_modules/events/events.js\":[function(_dereq_,module){function EventEmitter(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function isFunction(arg){return\"function\"==typeof arg}function isNumber(arg){return\"number\"==typeof arg}function isObject(arg){return\"object\"==typeof arg&&null!==arg}function isUndefined(arg){return void 0===arg}module.exports=EventEmitter,EventEmitter.EventEmitter=EventEmitter,EventEmitter.prototype._events=void 0,EventEmitter.prototype._maxListeners=void 0,EventEmitter.defaultMaxListeners=10,EventEmitter.prototype.setMaxListeners=function(n){if(!isNumber(n)||0>n||isNaN(n))throw TypeError(\"n must be a positive number\");return this._maxListeners=n,this},EventEmitter.prototype.emit=function(type){var er,handler,len,args,i,listeners;if(this._events||(this._events={}),\"error\"===type&&(!this._events.error||isObject(this._events.error)&&!this._events.error.length)){if(er=arguments[1],er instanceof Error)throw er;throw TypeError('Uncaught, unspecified \"error\" event.')}if(handler=this._events[type],isUndefined(handler))return!1;if(isFunction(handler))switch(arguments.length){case 1:handler.call(this);break;case 2:handler.call(this,arguments[1]);break;case 3:handler.call(this,arguments[1],arguments[2]);break;default:for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];handler.apply(this,args)}else if(isObject(handler)){for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];for(listeners=handler.slice(),len=listeners.length,i=0;len>i;i++)listeners[i].apply(this,args)}return!0},EventEmitter.prototype.addListener=function(type,listener){var m;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(this._events||(this._events={}),this._events.newListener&&this.emit(\"newListener\",type,isFunction(listener.listener)?listener.listener:listener),this._events[type]?isObject(this._events[type])?this._events[type].push(listener):this._events[type]=[this._events[type],listener]:this._events[type]=listener,isObject(this._events[type])&&!this._events[type].warned){var m;m=isUndefined(this._maxListeners)?EventEmitter.defaultMaxListeners:this._maxListeners,m&&m>0&&this._events[type].length>m&&(this._events[type].warned=!0,console.error(\"(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.\",this._events[type].length),\"function\"==typeof console.trace&&console.trace())}return this},EventEmitter.prototype.on=EventEmitter.prototype.addListener,EventEmitter.prototype.once=function(type,listener){function g(){this.removeListener(type,g),fired||(fired=!0,listener.apply(this,arguments))}if(!isFunction(listener))throw TypeError(\"listener must be a function\");var fired=!1;return g.listener=listener,this.on(type,g),this},EventEmitter.prototype.removeListener=function(type,listener){var list,position,length,i;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(!this._events||!this._events[type])return this;if(list=this._events[type],length=list.length,position=-1,list===listener||isFunction(list.listener)&&list.listener===listener)delete this._events[type],this._events.removeListener&&this.emit(\"removeListener\",type,listener);else if(isObject(list)){for(i=length;i-->0;)if(list[i]===listener||list[i].listener&&list[i].listener===listener){position=i;break}if(0>position)return this;1===list.length?(list.length=0,delete this._events[type]):list.splice(position,1),this._events.removeListener&&this.emit(\"removeListener\",type,listener)}return this},EventEmitter.prototype.removeAllListeners=function(type){var key,listeners;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[type]&&delete this._events[type],this;if(0===arguments.length){for(key in this._events)\"removeListener\"!==key&&this.removeAllListeners(key);return this.removeAllListeners(\"removeListener\"),this._events={},this\n}if(listeners=this._events[type],isFunction(listeners))this.removeListener(type,listeners);else for(;listeners.length;)this.removeListener(type,listeners[listeners.length-1]);return delete this._events[type],this},EventEmitter.prototype.listeners=function(type){var ret;return ret=this._events&&this._events[type]?isFunction(this._events[type])?[this._events[type]]:this._events[type].slice():[]},EventEmitter.listenerCount=function(emitter,type){var ret;return ret=emitter._events&&emitter._events[type]?isFunction(emitter._events[type])?1:emitter._events[type].length:0}},{}],\"/node_modules/jshint/data/ascii-identifier-data.js\":[function(_dereq_,module){for(var identifierStartTable=[],i=0;128>i;i++)identifierStartTable[i]=36===i||i>=65&&90>=i||95===i||i>=97&&122>=i;for(var identifierPartTable=[],i=0;128>i;i++)identifierPartTable[i]=identifierStartTable[i]||i>=48&&57>=i;module.exports={asciiIdentifierStartTable:identifierStartTable,asciiIdentifierPartTable:identifierPartTable}},{}],\"/node_modules/jshint/lodash.js\":[function(_dereq_,module,exports){(function(global){(function(){function baseFindIndex(array,predicate,fromRight){for(var length=array.length,index=fromRight?length:-1;fromRight?index--:length>++index;)if(predicate(array[index],index,array))return index;return-1}function baseIndexOf(array,value,fromIndex){if(value!==value)return indexOfNaN(array,fromIndex);for(var index=fromIndex-1,length=array.length;length>++index;)if(array[index]===value)return index;return-1}function baseIsFunction(value){return\"function\"==typeof value||!1}function baseToString(value){return\"string\"==typeof value?value:null==value?\"\":value+\"\"}function indexOfNaN(array,fromIndex,fromRight){for(var length=array.length,index=fromIndex+(fromRight?0:-1);fromRight?index--:length>++index;){var other=array[index];if(other!==other)return index}return-1}function isObjectLike(value){return!!value&&\"object\"==typeof value}function lodash(){}function arrayCopy(source,array){var index=-1,length=source.length;for(array||(array=Array(length));length>++index;)array[index]=source[index];return array}function arrayEach(array,iteratee){for(var index=-1,length=array.length;length>++index&&iteratee(array[index],index,array)!==!1;);return array}function arrayFilter(array,predicate){for(var index=-1,length=array.length,resIndex=-1,result=[];length>++index;){var value=array[index];predicate(value,index,array)&&(result[++resIndex]=value)}return result}function arrayMap(array,iteratee){for(var index=-1,length=array.length,result=Array(length);length>++index;)result[index]=iteratee(array[index],index,array);return result}function arrayMax(array){for(var index=-1,length=array.length,result=NEGATIVE_INFINITY;length>++index;){var value=array[index];value>result&&(result=value)}return result}function arraySome(array,predicate){for(var index=-1,length=array.length;length>++index;)if(predicate(array[index],index,array))return!0;return!1}function assignWith(object,source,customizer){var props=keys(source);push.apply(props,getSymbols(source));for(var index=-1,length=props.length;length>++index;){var key=props[index],value=object[key],result=customizer(value,source[key],key,object,source);(result===result?result===value:value!==value)&&(value!==undefined||key in object)||(object[key]=result)}return object}function baseCopy(source,props,object){object||(object={});for(var index=-1,length=props.length;length>++index;){var key=props[index];object[key]=source[key]}return object}function baseCallback(func,thisArg,argCount){var type=typeof func;return\"function\"==type?thisArg===undefined?func:bindCallback(func,thisArg,argCount):null==func?identity:\"object\"==type?baseMatches(func):thisArg===undefined?property(func):baseMatchesProperty(func,thisArg)}function baseClone(value,isDeep,customizer,key,object,stackA,stackB){var result;if(customizer&&(result=object?customizer(value,key,object):customizer(value)),result!==undefined)return result;if(!isObject(value))return value;var isArr=isArray(value);if(isArr){if(result=initCloneArray(value),!isDeep)return arrayCopy(value,result)}else{var tag=objToString.call(value),isFunc=tag==funcTag;if(tag!=objectTag&&tag!=argsTag&&(!isFunc||object))return cloneableTags[tag]?initCloneByTag(value,tag,isDeep):object?value:{};if(result=initCloneObject(isFunc?{}:value),!isDeep)return baseAssign(result,value)}stackA||(stackA=[]),stackB||(stackB=[]);for(var length=stackA.length;length--;)if(stackA[length]==value)return stackB[length];return stackA.push(value),stackB.push(result),(isArr?arrayEach:baseForOwn)(value,function(subValue,key){result[key]=baseClone(subValue,isDeep,customizer,key,value,stackA,stackB)}),result}function baseFilter(collection,predicate){var result=[];return baseEach(collection,function(value,index,collection){predicate(value,index,collection)&&result.push(value)}),result}function baseForIn(object,iteratee){return baseFor(object,iteratee,keysIn)}function baseForOwn(object,iteratee){return baseFor(object,iteratee,keys)}function baseGet(object,path,pathKey){if(null!=object){pathKey!==undefined&&pathKey in toObject(object)&&(path=[pathKey]);for(var index=-1,length=path.length;null!=object&&length>++index;)var result=object=object[path[index]];return result}}function baseIsEqual(value,other,customizer,isLoose,stackA,stackB){if(value===other)return 0!==value||1/value==1/other;var valType=typeof value,othType=typeof other;return\"function\"!=valType&&\"object\"!=valType&&\"function\"!=othType&&\"object\"!=othType||null==value||null==other?value!==value&&other!==other:baseIsEqualDeep(value,other,baseIsEqual,customizer,isLoose,stackA,stackB)}function baseIsEqualDeep(object,other,equalFunc,customizer,isLoose,stackA,stackB){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=arrayTag,othTag=arrayTag;objIsArr||(objTag=objToString.call(object),objTag==argsTag?objTag=objectTag:objTag!=objectTag&&(objIsArr=isTypedArray(object))),othIsArr||(othTag=objToString.call(other),othTag==argsTag?othTag=objectTag:othTag!=objectTag&&(othIsArr=isTypedArray(other)));var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&!objIsArr&&!objIsObj)return equalByTag(object,other,objTag);if(!isLoose){var valWrapped=objIsObj&&hasOwnProperty.call(object,\"__wrapped__\"),othWrapped=othIsObj&&hasOwnProperty.call(other,\"__wrapped__\");if(valWrapped||othWrapped)return equalFunc(valWrapped?object.value():object,othWrapped?other.value():other,customizer,isLoose,stackA,stackB)}if(!isSameTag)return!1;stackA||(stackA=[]),stackB||(stackB=[]);for(var length=stackA.length;length--;)if(stackA[length]==object)return stackB[length]==other;stackA.push(object),stackB.push(other);var result=(objIsArr?equalArrays:equalObjects)(object,other,equalFunc,customizer,isLoose,stackA,stackB);return stackA.pop(),stackB.pop(),result}function baseIsMatch(object,props,values,strictCompareFlags,customizer){for(var index=-1,length=props.length,noCustomizer=!customizer;length>++index;)if(noCustomizer&&strictCompareFlags[index]?values[index]!==object[props[index]]:!(props[index]in object))return!1;for(index=-1;length>++index;){var key=props[index],objValue=object[key],srcValue=values[index];if(noCustomizer&&strictCompareFlags[index])var result=objValue!==undefined||key in object;else result=customizer?customizer(objValue,srcValue,key):undefined,result===undefined&&(result=baseIsEqual(srcValue,objValue,customizer,!0));if(!result)return!1}return!0}function baseMatches(source){var props=keys(source),length=props.length;if(!length)return constant(!0);if(1==length){var key=props[0],value=source[key];if(isStrictComparable(value))return function(object){return null==object?!1:object[key]===value&&(value!==undefined||key in toObject(object))}}for(var values=Array(length),strictCompareFlags=Array(length);length--;)value=source[props[length]],values[length]=value,strictCompareFlags[length]=isStrictComparable(value);return function(object){return null!=object&&baseIsMatch(toObject(object),props,values,strictCompareFlags)}}function baseMatchesProperty(path,value){var isArr=isArray(path),isCommon=isKey(path)&&isStrictComparable(value),pathKey=path+\"\";return path=toPath(path),function(object){if(null==object)return!1;var key=pathKey;if(object=toObject(object),!(!isArr&&isCommon||key in object)){if(object=1==path.length?object:baseGet(object,baseSlice(path,0,-1)),null==object)return!1;key=last(path),object=toObject(object)}return object[key]===value?value!==undefined||key in object:baseIsEqual(value,object[key],null,!0)}}function baseMerge(object,source,customizer,stackA,stackB){if(!isObject(object))return object;var isSrcArr=isLength(source.length)&&(isArray(source)||isTypedArray(source));if(!isSrcArr){var props=keys(source);push.apply(props,getSymbols(source))}return arrayEach(props||source,function(srcValue,key){if(props&&(key=srcValue,srcValue=source[key]),isObjectLike(srcValue))stackA||(stackA=[]),stackB||(stackB=[]),baseMergeDeep(object,source,key,baseMerge,customizer,stackA,stackB);else{var value=object[key],result=customizer?customizer(value,srcValue,key,object,source):undefined,isCommon=result===undefined;isCommon&&(result=srcValue),!isSrcArr&&result===undefined||!isCommon&&(result===result?result===value:value!==value)||(object[key]=result)}}),object}function baseMergeDeep(object,source,key,mergeFunc,customizer,stackA,stackB){for(var length=stackA.length,srcValue=source[key];length--;)if(stackA[length]==srcValue)return object[key]=stackB[length],undefined;var value=object[key],result=customizer?customizer(value,srcValue,key,object,source):undefined,isCommon=result===undefined;isCommon&&(result=srcValue,isLength(srcValue.length)&&(isArray(srcValue)||isTypedArray(srcValue))?result=isArray(value)?value:getLength(value)?arrayCopy(value):[]:isPlainObject(srcValue)||isArguments(srcValue)?result=isArguments(value)?toPlainObject(value):isPlainObject(value)?value:{}:isCommon=!1),stackA.push(srcValue),stackB.push(result),isCommon?object[key]=mergeFunc(result,srcValue,customizer,stackA,stackB):(result===result?result!==value:value===value)&&(object[key]=result)}function baseProperty(key){return function(object){return null==object?undefined:object[key]}}function basePropertyDeep(path){var pathKey=path+\"\";return path=toPath(path),function(object){return baseGet(object,path,pathKey)}}function baseSlice(array,start,end){var index=-1,length=array.length;start=null==start?0:+start||0,0>start&&(start=-start>length?0:length+start),end=end===undefined||end>length?length:+end||0,0>end&&(end+=length),length=start>end?0:end-start>>>0,start>>>=0;for(var result=Array(length);length>++index;)result[index]=array[index+start];return result}function baseSome(collection,predicate){var result;return baseEach(collection,function(value,index,collection){return result=predicate(value,index,collection),!result}),!!result}function baseValues(object,props){for(var index=-1,length=props.length,result=Array(length);length>++index;)result[index]=object[props[index]];return result}function binaryIndex(array,value,retHighest){var low=0,high=array?array.length:low;if(\"number\"==typeof value&&value===value&&HALF_MAX_ARRAY_LENGTH>=high){for(;high>low;){var mid=low+high>>>1,computed=array[mid];(retHighest?value>=computed:value>computed)?low=mid+1:high=mid}return high}return binaryIndexBy(array,value,identity,retHighest)}function binaryIndexBy(array,value,iteratee,retHighest){value=iteratee(value);for(var low=0,high=array?array.length:0,valIsNaN=value!==value,valIsUndef=value===undefined;high>low;){var mid=floor((low+high)/2),computed=iteratee(array[mid]),isReflexive=computed===computed;if(valIsNaN)var setLow=isReflexive||retHighest;else setLow=valIsUndef?isReflexive&&(retHighest||computed!==undefined):retHighest?value>=computed:value>computed;setLow?low=mid+1:high=mid}return nativeMin(high,MAX_ARRAY_INDEX)}function bindCallback(func,thisArg,argCount){if(\"function\"!=typeof func)return identity;if(thisArg===undefined)return func;switch(argCount){case 1:return function(value){return func.call(thisArg,value)};case 3:return function(value,index,collection){return func.call(thisArg,value,index,collection)};case 4:return function(accumulator,value,index,collection){return func.call(thisArg,accumulator,value,index,collection)};case 5:return function(value,other,key,object,source){return func.call(thisArg,value,other,key,object,source)}}return function(){return func.apply(thisArg,arguments)}}function bufferClone(buffer){return bufferSlice.call(buffer,0)}function createAssigner(assigner){return restParam(function(object,sources){var index=-1,length=null==object?0:sources.length,customizer=length>2&&sources[length-2],guard=length>2&&sources[2],thisArg=length>1&&sources[length-1];for(\"function\"==typeof customizer?(customizer=bindCallback(customizer,thisArg,5),length-=2):(customizer=\"function\"==typeof thisArg?thisArg:null,length-=customizer?1:0),guard&&isIterateeCall(sources[0],sources[1],guard)&&(customizer=3>length?null:customizer,length=1);length>++index;){var source=sources[index];source&&assigner(object,source,customizer)}return object})}function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){var length=collection?getLength(collection):0;if(!isLength(length))return eachFunc(collection,iteratee);for(var index=fromRight?length:-1,iterable=toObject(collection);(fromRight?index--:length>++index)&&iteratee(iterable[index],index,iterable)!==!1;);return collection}}function createBaseFor(fromRight){return function(object,iteratee,keysFunc){for(var iterable=toObject(object),props=keysFunc(object),length=props.length,index=fromRight?length:-1;fromRight?index--:length>++index;){var key=props[index];if(iteratee(iterable[key],key,iterable)===!1)break}return object}}function createFindIndex(fromRight){return function(array,predicate,thisArg){return array&&array.length?(predicate=getCallback(predicate,thisArg,3),baseFindIndex(array,predicate,fromRight)):-1}}function createForEach(arrayFunc,eachFunc){return function(collection,iteratee,thisArg){return\"function\"==typeof iteratee&&thisArg===undefined&&isArray(collection)?arrayFunc(collection,iteratee):eachFunc(collection,bindCallback(iteratee,thisArg,3))}}function equalArrays(array,other,equalFunc,customizer,isLoose,stackA,stackB){var index=-1,arrLength=array.length,othLength=other.length,result=!0;if(arrLength!=othLength&&!(isLoose&&othLength>arrLength))return!1;for(;result&&arrLength>++index;){var arrValue=array[index],othValue=other[index];if(result=undefined,customizer&&(result=isLoose?customizer(othValue,arrValue,index):customizer(arrValue,othValue,index)),result===undefined)if(isLoose)for(var othIndex=othLength;othIndex--&&(othValue=other[othIndex],!(result=arrValue&&arrValue===othValue||equalFunc(arrValue,othValue,customizer,isLoose,stackA,stackB))););else result=arrValue&&arrValue===othValue||equalFunc(arrValue,othValue,customizer,isLoose,stackA,stackB)}return!!result}function equalByTag(object,other,tag){switch(tag){case boolTag:case dateTag:return+object==+other;case errorTag:return object.name==other.name&&object.message==other.message;case numberTag:return object!=+object?other!=+other:0==object?1/object==1/other:object==+other;case regexpTag:case stringTag:return object==other+\"\"}return!1}function equalObjects(object,other,equalFunc,customizer,isLoose,stackA,stackB){var objProps=keys(object),objLength=objProps.length,othProps=keys(other),othLength=othProps.length;if(objLength!=othLength&&!isLoose)return!1;for(var skipCtor=isLoose,index=-1;objLength>++index;){var key=objProps[index],result=isLoose?key in other:hasOwnProperty.call(other,key);if(result){var objValue=object[key],othValue=other[key];result=undefined,customizer&&(result=isLoose?customizer(othValue,objValue,key):customizer(objValue,othValue,key)),result===undefined&&(result=objValue&&objValue===othValue||equalFunc(objValue,othValue,customizer,isLoose,stackA,stackB))}if(!result)return!1;skipCtor||(skipCtor=\"constructor\"==key)}if(!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;if(objCtor!=othCtor&&\"constructor\"in object&&\"constructor\"in other&&!(\"function\"==typeof objCtor&&objCtor instanceof objCtor&&\"function\"==typeof othCtor&&othCtor instanceof othCtor))return!1}return!0}function getCallback(func,thisArg,argCount){var result=lodash.callback||callback;return result=result===callback?baseCallback:result,argCount?result(func,thisArg,argCount):result}function getIndexOf(collection,target,fromIndex){var result=lodash.indexOf||indexOf;return result=result===indexOf?baseIndexOf:result,collection?result(collection,target,fromIndex):result}function initCloneArray(array){var length=array.length,result=new array.constructor(length);return length&&\"string\"==typeof array[0]&&hasOwnProperty.call(array,\"index\")&&(result.index=array.index,result.input=array.input),result}function initCloneObject(object){var Ctor=object.constructor;return\"function\"==typeof Ctor&&Ctor instanceof Ctor||(Ctor=Object),new Ctor}function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return bufferClone(object);case boolTag:case dateTag:return new Ctor(+object);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:var buffer=object.buffer;return new Ctor(isDeep?bufferClone(buffer):buffer,object.byteOffset,object.length);case numberTag:case stringTag:return new Ctor(object);case regexpTag:var result=new Ctor(object.source,reFlags.exec(object));result.lastIndex=object.lastIndex}return result}function isIndex(value,length){return value=+value,length=null==length?MAX_SAFE_INTEGER:length,value>-1&&0==value%1&&length>value}function isIterateeCall(value,index,object){if(!isObject(object))return!1;var type=typeof index;if(\"number\"==type)var length=getLength(object),prereq=isLength(length)&&isIndex(index,length);else prereq=\"string\"==type&&index in object;if(prereq){var other=object[index];return value===value?value===other:other!==other}return!1}function isKey(value,object){var type=typeof value;if(\"string\"==type&&reIsPlainProp.test(value)||\"number\"==type)return!0;if(isArray(value))return!1;var result=!reIsDeepProp.test(value);return result||null!=object&&value in toObject(object)}function isLength(value){return\"number\"==typeof value&&value>-1&&0==value%1&&MAX_SAFE_INTEGER>=value}function isStrictComparable(value){return value===value&&(0===value?1/value>0:!isObject(value))}function shimIsPlainObject(value){var Ctor;if(lodash.support,!isObjectLike(value)||objToString.call(value)!=objectTag||!hasOwnProperty.call(value,\"constructor\")&&(Ctor=value.constructor,\"function\"==typeof Ctor&&!(Ctor instanceof Ctor)))return!1;var result;return baseForIn(value,function(subValue,key){result=key}),result===undefined||hasOwnProperty.call(value,result)}function shimKeys(object){for(var props=keysIn(object),propsLength=props.length,length=propsLength&&object.length,support=lodash.support,allowIndexes=length&&isLength(length)&&(isArray(object)||support.nonEnumArgs&&isArguments(object)),index=-1,result=[];propsLength>++index;){var key=props[index];(allowIndexes&&isIndex(key,length)||hasOwnProperty.call(object,key))&&result.push(key)}return result}function toObject(value){return isObject(value)?value:Object(value)}function toPath(value){if(isArray(value))return value;var result=[];return baseToString(value).replace(rePropName,function(match,number,quote,string){result.push(quote?string.replace(reEscapeChar,\"$1\"):number||match)}),result}function indexOf(array,value,fromIndex){var length=array?array.length:0;if(!length)return-1;if(\"number\"==typeof fromIndex)fromIndex=0>fromIndex?nativeMax(length+fromIndex,0):fromIndex;else if(fromIndex){var index=binaryIndex(array,value),other=array[index];return(value===value?value===other:other!==other)?index:-1}return baseIndexOf(array,value,fromIndex||0)}function last(array){var length=array?array.length:0;return length?array[length-1]:undefined}function slice(array,start,end){var length=array?array.length:0;return length?(end&&\"number\"!=typeof end&&isIterateeCall(array,start,end)&&(start=0,end=length),baseSlice(array,start,end)):[]}function unzip(array){for(var index=-1,length=(array&&array.length&&arrayMax(arrayMap(array,getLength)))>>>0,result=Array(length);length>++index;)result[index]=arrayMap(array,baseProperty(index));return result}function includes(collection,target,fromIndex,guard){var length=collection?getLength(collection):0;return isLength(length)||(collection=values(collection),length=collection.length),length?(fromIndex=\"number\"!=typeof fromIndex||guard&&isIterateeCall(target,fromIndex,guard)?0:0>fromIndex?nativeMax(length+fromIndex,0):fromIndex||0,\"string\"==typeof collection||!isArray(collection)&&isString(collection)?length>fromIndex&&collection.indexOf(target,fromIndex)>-1:getIndexOf(collection,target,fromIndex)>-1):!1}function reject(collection,predicate,thisArg){var func=isArray(collection)?arrayFilter:baseFilter;return predicate=getCallback(predicate,thisArg,3),func(collection,function(value,index,collection){return!predicate(value,index,collection)})}function some(collection,predicate,thisArg){var func=isArray(collection)?arraySome:baseSome;return thisArg&&isIterateeCall(collection,predicate,thisArg)&&(predicate=null),(\"function\"!=typeof predicate||thisArg!==undefined)&&(predicate=getCallback(predicate,thisArg,3)),func(collection,predicate)}function restParam(func,start){if(\"function\"!=typeof func)throw new TypeError(FUNC_ERROR_TEXT);return start=nativeMax(start===undefined?func.length-1:+start||0,0),function(){for(var args=arguments,index=-1,length=nativeMax(args.length-start,0),rest=Array(length);length>++index;)rest[index]=args[start+index];switch(start){case 0:return func.call(this,rest);case 1:return func.call(this,args[0],rest);case 2:return func.call(this,args[0],args[1],rest)}var otherArgs=Array(start+1);for(index=-1;start>++index;)otherArgs[index]=args[index];return otherArgs[start]=rest,func.apply(this,otherArgs)}}function clone(value,isDeep,customizer,thisArg){return isDeep&&\"boolean\"!=typeof isDeep&&isIterateeCall(value,isDeep,customizer)?isDeep=!1:\"function\"==typeof isDeep&&(thisArg=customizer,customizer=isDeep,isDeep=!1),customizer=\"function\"==typeof customizer&&bindCallback(customizer,thisArg,1),baseClone(value,isDeep,customizer)}function isArguments(value){var length=isObjectLike(value)?value.length:undefined;return isLength(length)&&objToString.call(value)==argsTag}function isEmpty(value){if(null==value)return!0;var length=getLength(value);return isLength(length)&&(isArray(value)||isString(value)||isArguments(value)||isObjectLike(value)&&isFunction(value.splice))?!length:!keys(value).length}function isObject(value){var type=typeof value;return\"function\"==type||!!value&&\"object\"==type}function isNative(value){return null==value?!1:objToString.call(value)==funcTag?reIsNative.test(fnToString.call(value)):isObjectLike(value)&&reIsHostCtor.test(value)}function isNumber(value){return\"number\"==typeof value||isObjectLike(value)&&objToString.call(value)==numberTag}function isString(value){return\"string\"==typeof value||isObjectLike(value)&&objToString.call(value)==stringTag}function isTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[objToString.call(value)]}function toPlainObject(value){return baseCopy(value,keysIn(value))}function has(object,path){if(null==object)return!1;var result=hasOwnProperty.call(object,path);return result||isKey(path)||(path=toPath(path),object=1==path.length?object:baseGet(object,baseSlice(path,0,-1)),path=last(path),result=null!=object&&hasOwnProperty.call(object,path)),result}function keysIn(object){if(null==object)return[];isObject(object)||(object=Object(object));var length=object.length;length=length&&isLength(length)&&(isArray(object)||support.nonEnumArgs&&isArguments(object))&&length||0;for(var Ctor=object.constructor,index=-1,isProto=\"function\"==typeof Ctor&&Ctor.prototype===object,result=Array(length),skipIndexes=length>0;length>++index;)result[index]=index+\"\";for(var key in object)skipIndexes&&isIndex(key,length)||\"constructor\"==key&&(isProto||!hasOwnProperty.call(object,key))||result.push(key);return result}function values(object){return baseValues(object,keys(object))}function escapeRegExp(string){return string=baseToString(string),string&&reHasRegExpChars.test(string)?string.replace(reRegExpChars,\"\\\\$&\"):string}function callback(func,thisArg,guard){return guard&&isIterateeCall(func,thisArg,guard)&&(thisArg=null),baseCallback(func,thisArg)}function constant(value){return function(){return value}}function identity(value){return value}function property(path){return isKey(path)?baseProperty(path):basePropertyDeep(path)}var undefined,VERSION=\"3.7.0\",FUNC_ERROR_TEXT=\"Expected a function\",argsTag=\"[object Arguments]\",arrayTag=\"[object Array]\",boolTag=\"[object Boolean]\",dateTag=\"[object Date]\",errorTag=\"[object Error]\",funcTag=\"[object Function]\",mapTag=\"[object Map]\",numberTag=\"[object Number]\",objectTag=\"[object Object]\",regexpTag=\"[object RegExp]\",setTag=\"[object Set]\",stringTag=\"[object String]\",weakMapTag=\"[object WeakMap]\",arrayBufferTag=\"[object ArrayBuffer]\",float32Tag=\"[object Float32Array]\",float64Tag=\"[object Float64Array]\",int8Tag=\"[object Int8Array]\",int16Tag=\"[object Int16Array]\",int32Tag=\"[object Int32Array]\",uint8Tag=\"[object Uint8Array]\",uint8ClampedTag=\"[object Uint8ClampedArray]\",uint16Tag=\"[object Uint16Array]\",uint32Tag=\"[object Uint32Array]\",reIsDeepProp=/\\.|\\[(?:[^[\\]]+|([\"'])(?:(?!\\1)[^\\n\\\\]|\\\\.)*?)\\1\\]/,reIsPlainProp=/^\\w*$/,rePropName=/[^.[\\]]+|\\[(?:(-?\\d+(?:\\.\\d+)?)|([\"'])((?:(?!\\2)[^\\n\\\\]|\\\\.)*?)\\2)\\]/g,reRegExpChars=/[.*+?^${}()|[\\]\\/\\\\]/g,reHasRegExpChars=RegExp(reRegExpChars.source),reEscapeChar=/\\\\(\\\\)?/g,reFlags=/\\w*$/,reIsHostCtor=/^\\[object .+?Constructor\\]$/,typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=!0,typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=!1;var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[stringTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=!0,cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[mapTag]=cloneableTags[setTag]=cloneableTags[weakMapTag]=!1;var objectTypes={\"function\":!0,object:!0},freeExports=objectTypes[typeof exports]&&exports&&!exports.nodeType&&exports,freeModule=objectTypes[typeof module]&&module&&!module.nodeType&&module,freeGlobal=freeExports&&freeModule&&\"object\"==typeof global&&global&&global.Object&&global,freeSelf=objectTypes[typeof self]&&self&&self.Object&&self,freeWindow=objectTypes[typeof window]&&window&&window.Object&&window,moduleExports=freeModule&&freeModule.exports===freeExports&&freeExports,root=freeGlobal||freeWindow!==(this&&this.window)&&freeWindow||freeSelf||this,arrayProto=Array.prototype,objectProto=Object.prototype,fnToString=Function.prototype.toString,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString,reIsNative=RegExp(\"^\"+escapeRegExp(objToString).replace(/toString|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,\"$1.*?\")+\"$\"),ArrayBuffer=isNative(ArrayBuffer=root.ArrayBuffer)&&ArrayBuffer,bufferSlice=isNative(bufferSlice=ArrayBuffer&&new ArrayBuffer(0).slice)&&bufferSlice,floor=Math.floor,getOwnPropertySymbols=isNative(getOwnPropertySymbols=Object.getOwnPropertySymbols)&&getOwnPropertySymbols,getPrototypeOf=isNative(getPrototypeOf=Object.getPrototypeOf)&&getPrototypeOf,push=arrayProto.push,preventExtensions=isNative(Object.preventExtensions=Object.preventExtensions)&&preventExtensions,propertyIsEnumerable=objectProto.propertyIsEnumerable,Uint8Array=isNative(Uint8Array=root.Uint8Array)&&Uint8Array,Float64Array=function(){try{var func=isNative(func=root.Float64Array)&&func,result=new func(new ArrayBuffer(10),0,1)&&func}catch(e){}return result}(),nativeAssign=function(){var object={1:0},func=preventExtensions&&isNative(func=Object.assign)&&func;try{func(preventExtensions(object),\"xo\")}catch(e){}return!object[1]&&func}(),nativeIsArray=isNative(nativeIsArray=Array.isArray)&&nativeIsArray,nativeKeys=isNative(nativeKeys=Object.keys)&&nativeKeys,nativeMax=Math.max,nativeMin=Math.min,NEGATIVE_INFINITY=Number.NEGATIVE_INFINITY,MAX_ARRAY_LENGTH=Math.pow(2,32)-1,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1,FLOAT64_BYTES_PER_ELEMENT=Float64Array?Float64Array.BYTES_PER_ELEMENT:0,MAX_SAFE_INTEGER=Math.pow(2,53)-1,support=lodash.support={};(function(x){var Ctor=function(){this.x=x},props=[];Ctor.prototype={valueOf:x,y:x};for(var key in new Ctor)props.push(key);support.funcDecomp=/\\bthis\\b/.test(function(){return this}),support.funcNames=\"string\"==typeof Function.name;try{support.nonEnumArgs=!propertyIsEnumerable.call(arguments,1)}catch(e){support.nonEnumArgs=!0}})(1,0);var baseAssign=nativeAssign||function(object,source){return null==source?object:baseCopy(source,getSymbols(source),baseCopy(source,keys(source),object))},baseEach=createBaseEach(baseForOwn),baseFor=createBaseFor();bufferSlice||(bufferClone=ArrayBuffer&&Uint8Array?function(buffer){var byteLength=buffer.byteLength,floatLength=Float64Array?floor(byteLength/FLOAT64_BYTES_PER_ELEMENT):0,offset=floatLength*FLOAT64_BYTES_PER_ELEMENT,result=new ArrayBuffer(byteLength);if(floatLength){var view=new Float64Array(result,0,floatLength);view.set(new Float64Array(buffer,0,floatLength))}return byteLength!=offset&&(view=new Uint8Array(result,offset),view.set(new Uint8Array(buffer,offset))),result}:constant(null));var getLength=baseProperty(\"length\"),getSymbols=getOwnPropertySymbols?function(object){return getOwnPropertySymbols(toObject(object))}:constant([]),findLastIndex=createFindIndex(!0),zip=restParam(unzip),forEach=createForEach(arrayEach,baseEach),isArray=nativeIsArray||function(value){return isObjectLike(value)&&isLength(value.length)&&objToString.call(value)==arrayTag},isFunction=baseIsFunction(/x/)||Uint8Array&&!baseIsFunction(Uint8Array)?function(value){return objToString.call(value)==funcTag}:baseIsFunction,isPlainObject=getPrototypeOf?function(value){if(!value||objToString.call(value)!=objectTag)return!1;var valueOf=value.valueOf,objProto=isNative(valueOf)&&(objProto=getPrototypeOf(valueOf))&&getPrototypeOf(objProto);return objProto?value==objProto||getPrototypeOf(value)==objProto:shimIsPlainObject(value)}:shimIsPlainObject,assign=createAssigner(function(object,source,customizer){return customizer?assignWith(object,source,customizer):baseAssign(object,source)}),keys=nativeKeys?function(object){if(object)var Ctor=object.constructor,length=object.length;return\"function\"==typeof Ctor&&Ctor.prototype===object||\"function\"!=typeof object&&isLength(length)?shimKeys(object):isObject(object)?nativeKeys(object):[]}:shimKeys,merge=createAssigner(baseMerge);lodash.assign=assign,lodash.callback=callback,lodash.constant=constant,lodash.forEach=forEach,lodash.keys=keys,lodash.keysIn=keysIn,lodash.merge=merge,lodash.property=property,lodash.reject=reject,lodash.restParam=restParam,lodash.slice=slice,lodash.toPlainObject=toPlainObject,lodash.unzip=unzip,lodash.values=values,lodash.zip=zip,lodash.each=forEach,lodash.extend=assign,lodash.iteratee=callback,lodash.clone=clone,lodash.escapeRegExp=escapeRegExp,lodash.findLastIndex=findLastIndex,lodash.has=has,lodash.identity=identity,lodash.includes=includes,lodash.indexOf=indexOf,lodash.isArguments=isArguments,lodash.isArray=isArray,lodash.isEmpty=isEmpty,lodash.isFunction=isFunction,lodash.isNative=isNative,lodash.isNumber=isNumber,lodash.isObject=isObject,lodash.isPlainObject=isPlainObject,lodash.isString=isString,lodash.isTypedArray=isTypedArray,lodash.last=last,lodash.some=some,lodash.any=some,lodash.contains=includes,lodash.include=includes,lodash.VERSION=VERSION,freeExports&&freeModule?moduleExports?(freeModule.exports=lodash)._=lodash:freeExports._=lodash:root._=lodash\n}).call(this)}).call(this,\"undefined\"!=typeof global?global:\"undefined\"!=typeof self?self:\"undefined\"!=typeof window?window:{})},{}],\"/node_modules/jshint/src/jshint.js\":[function(_dereq_,module,exports){var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),vars=_dereq_(\"./vars.js\"),messages=_dereq_(\"./messages.js\"),Lexer=_dereq_(\"./lex.js\").Lexer,reg=_dereq_(\"./reg.js\"),state=_dereq_(\"./state.js\").state,style=_dereq_(\"./style.js\"),options=_dereq_(\"./options.js\"),scopeManager=_dereq_(\"./scope-manager.js\"),JSHINT=function(){\"use strict\";function checkOption(name,t){return name=name.trim(),/^[+-]W\\d{3}$/g.test(name)?!0:-1!==options.validNames.indexOf(name)||\"jslint\"===t.type||_.has(options.removed,name)?!0:(error(\"E001\",t,name),!1)}function isString(obj){return\"[object String]\"===Object.prototype.toString.call(obj)}function isIdentifier(tkn,value){return tkn?tkn.identifier&&tkn.value===value?!0:!1:!1}function isReserved(token){if(!token.reserved)return!1;var meta=token.meta;if(meta&&meta.isFutureReservedWord&&state.inES5()){if(!meta.es5)return!1;if(meta.strictOnly&&!state.option.strict&&!state.isStrict())return!1;if(token.isProperty)return!1}return!0}function supplant(str,data){return str.replace(/\\{([^{}]*)\\}/g,function(a,b){var r=data[b];return\"string\"==typeof r||\"number\"==typeof r?r:a})}function combine(dest,src){Object.keys(src).forEach(function(name){_.has(JSHINT.blacklist,name)||(dest[name]=src[name])})}function processenforceall(){if(state.option.enforceall){for(var enforceopt in options.bool.enforcing)void 0!==state.option[enforceopt]||options.noenforceall[enforceopt]||(state.option[enforceopt]=!0);for(var relaxopt in options.bool.relaxing)void 0===state.option[relaxopt]&&(state.option[relaxopt]=!1)}}function assume(){processenforceall(),state.option.esversion||state.option.moz||(state.option.esversion=state.option.es3?3:state.option.esnext?6:5),state.inES5()&&combine(predefined,vars.ecmaIdentifiers[5]),state.inES6()&&combine(predefined,vars.ecmaIdentifiers[6]),state.option.module&&(state.option.strict===!0&&(state.option.strict=\"global\"),state.inES6()||warning(\"W134\",state.tokens.next,\"module\",6)),state.option.couch&&combine(predefined,vars.couch),state.option.qunit&&combine(predefined,vars.qunit),state.option.rhino&&combine(predefined,vars.rhino),state.option.shelljs&&(combine(predefined,vars.shelljs),combine(predefined,vars.node)),state.option.typed&&combine(predefined,vars.typed),state.option.phantom&&(combine(predefined,vars.phantom),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.prototypejs&&combine(predefined,vars.prototypejs),state.option.node&&(combine(predefined,vars.node),combine(predefined,vars.typed),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.devel&&combine(predefined,vars.devel),state.option.dojo&&combine(predefined,vars.dojo),state.option.browser&&(combine(predefined,vars.browser),combine(predefined,vars.typed)),state.option.browserify&&(combine(predefined,vars.browser),combine(predefined,vars.typed),combine(predefined,vars.browserify),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.nonstandard&&combine(predefined,vars.nonstandard),state.option.jasmine&&combine(predefined,vars.jasmine),state.option.jquery&&combine(predefined,vars.jquery),state.option.mootools&&combine(predefined,vars.mootools),state.option.worker&&combine(predefined,vars.worker),state.option.wsh&&combine(predefined,vars.wsh),state.option.globalstrict&&state.option.strict!==!1&&(state.option.strict=\"global\"),state.option.yui&&combine(predefined,vars.yui),state.option.mocha&&combine(predefined,vars.mocha)}function quit(code,line,chr){var percentage=Math.floor(100*(line/state.lines.length)),message=messages.errors[code].desc;throw{name:\"JSHintError\",line:line,character:chr,message:message+\" (\"+percentage+\"% scanned).\",raw:message,code:code}}function removeIgnoredMessages(){var ignored=state.ignoredLines;_.isEmpty(ignored)||(JSHINT.errors=_.reject(JSHINT.errors,function(err){return ignored[err.line]}))}function warning(code,t,a,b,c,d){var ch,l,w,msg;if(/^W\\d{3}$/.test(code)){if(state.ignored[code])return;msg=messages.warnings[code]}else/E\\d{3}/.test(code)?msg=messages.errors[code]:/I\\d{3}/.test(code)&&(msg=messages.info[code]);return t=t||state.tokens.next||{},\"(end)\"===t.id&&(t=state.tokens.curr),l=t.line||0,ch=t.from||0,w={id:\"(error)\",raw:msg.desc,code:msg.code,evidence:state.lines[l-1]||\"\",line:l,character:ch,scope:JSHINT.scope,a:a,b:b,c:c,d:d},w.reason=supplant(msg.desc,w),JSHINT.errors.push(w),removeIgnoredMessages(),JSHINT.errors.length>=state.option.maxerr&&quit(\"E043\",l,ch),w}function warningAt(m,l,ch,a,b,c,d){return warning(m,{line:l,from:ch},a,b,c,d)}function error(m,t,a,b,c,d){warning(m,t,a,b,c,d)}function errorAt(m,l,ch,a,b,c,d){return error(m,{line:l,from:ch},a,b,c,d)}function addInternalSrc(elem,src){var i;return i={id:\"(internal)\",elem:elem,value:src},JSHINT.internals.push(i),i}function doOption(){var nt=state.tokens.next,body=nt.body.match(/(-\\s+)?[^\\s,:]+(?:\\s*:\\s*(-\\s+)?[^\\s,]+)?/g)||[],predef={};if(\"globals\"===nt.type){body.forEach(function(g,idx){g=g.split(\":\");var key=(g[0]||\"\").trim(),val=(g[1]||\"\").trim();if(\"-\"===key||!key.length){if(idx>0&&idx===body.length-1)return;return error(\"E002\",nt),void 0}\"-\"===key.charAt(0)?(key=key.slice(1),val=!1,JSHINT.blacklist[key]=key,delete predefined[key]):predef[key]=\"true\"===val}),combine(predefined,predef);for(var key in predef)_.has(predef,key)&&(declared[key]=nt)}\"exported\"===nt.type&&body.forEach(function(e,idx){if(!e.length){if(idx>0&&idx===body.length-1)return;return error(\"E002\",nt),void 0}state.funct[\"(scope)\"].addExported(e)}),\"members\"===nt.type&&(membersOnly=membersOnly||{},body.forEach(function(m){var ch1=m.charAt(0),ch2=m.charAt(m.length-1);ch1!==ch2||'\"'!==ch1&&\"'\"!==ch1||(m=m.substr(1,m.length-2).replace('\\\\\"','\"')),membersOnly[m]=!1}));var numvals=[\"maxstatements\",\"maxparams\",\"maxdepth\",\"maxcomplexity\",\"maxerr\",\"maxlen\",\"indent\"];(\"jshint\"===nt.type||\"jslint\"===nt.type)&&(body.forEach(function(g){g=g.split(\":\");var key=(g[0]||\"\").trim(),val=(g[1]||\"\").trim();if(checkOption(key,nt))if(numvals.indexOf(key)>=0)if(\"false\"!==val){if(val=+val,\"number\"!=typeof val||!isFinite(val)||0>=val||Math.floor(val)!==val)return error(\"E032\",nt,g[1].trim()),void 0;state.option[key]=val}else state.option[key]=\"indent\"===key?4:!1;else{if(\"validthis\"===key)return state.funct[\"(global)\"]?void error(\"E009\"):\"true\"!==val&&\"false\"!==val?void error(\"E002\",nt):(state.option.validthis=\"true\"===val,void 0);if(\"quotmark\"!==key)if(\"shadow\"!==key)if(\"unused\"!==key)if(\"latedef\"!==key)if(\"ignore\"!==key)if(\"strict\"!==key){\"module\"===key&&(hasParsedCode(state.funct)||error(\"E055\",state.tokens.next,\"module\"));var esversions={es3:3,es5:5,esnext:6};if(!_.has(esversions,key)){if(\"esversion\"===key){switch(val){case\"5\":state.inES5(!0)&&warning(\"I003\");case\"3\":case\"6\":state.option.moz=!1,state.option.esversion=+val;break;case\"2015\":state.option.moz=!1,state.option.esversion=6;break;default:error(\"E002\",nt)}return hasParsedCode(state.funct)||error(\"E055\",state.tokens.next,\"esversion\"),void 0}var match=/^([+-])(W\\d{3})$/g.exec(key);if(match)return state.ignored[match[2]]=\"-\"===match[1],void 0;var tn;return\"true\"===val||\"false\"===val?(\"jslint\"===nt.type?(tn=options.renamed[key]||key,state.option[tn]=\"true\"===val,void 0!==options.inverted[tn]&&(state.option[tn]=!state.option[tn])):state.option[key]=\"true\"===val,\"newcap\"===key&&(state.option[\"(explicitNewcap)\"]=!0),void 0):(error(\"E002\",nt),void 0)}switch(val){case\"true\":state.option.moz=!1,state.option.esversion=esversions[key];break;case\"false\":state.option.moz||(state.option.esversion=5);break;default:error(\"E002\",nt)}}else switch(val){case\"true\":state.option.strict=!0;break;case\"false\":state.option.strict=!1;break;case\"func\":case\"global\":case\"implied\":state.option.strict=val;break;default:error(\"E002\",nt)}else switch(val){case\"line\":state.ignoredLines[nt.line]=!0,removeIgnoredMessages();break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.latedef=!0;break;case\"false\":state.option.latedef=!1;break;case\"nofunc\":state.option.latedef=\"nofunc\";break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.unused=!0;break;case\"false\":state.option.unused=!1;break;case\"vars\":case\"strict\":state.option.unused=val;break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.shadow=!0;break;case\"outer\":state.option.shadow=\"outer\";break;case\"false\":case\"inner\":state.option.shadow=\"inner\";break;default:error(\"E002\",nt)}else switch(val){case\"true\":case\"false\":state.option.quotmark=\"true\"===val;break;case\"double\":case\"single\":state.option.quotmark=val;break;default:error(\"E002\",nt)}}}),assume())}function peek(p){var t,i=p||0,j=lookahead.length;if(j>i)return lookahead[i];for(;i>=j;)t=lookahead[j],t||(t=lookahead[j]=lex.token()),j+=1;return t||\"(end)\"!==state.tokens.next.id?t:state.tokens.next}function peekIgnoreEOL(){var t,i=0;do t=peek(i++);while(\"(endline)\"===t.id);return t}function advance(id,t){switch(state.tokens.curr.id){case\"(number)\":\".\"===state.tokens.next.id&&warning(\"W005\",state.tokens.curr);break;case\"-\":(\"-\"===state.tokens.next.id||\"--\"===state.tokens.next.id)&&warning(\"W006\");break;case\"+\":(\"+\"===state.tokens.next.id||\"++\"===state.tokens.next.id)&&warning(\"W007\")}for(id&&state.tokens.next.id!==id&&(t?\"(end)\"===state.tokens.next.id?error(\"E019\",t,t.id):error(\"E020\",state.tokens.next,id,t.id,t.line,state.tokens.next.value):(\"(identifier)\"!==state.tokens.next.type||state.tokens.next.value!==id)&&warning(\"W116\",state.tokens.next,id,state.tokens.next.value)),state.tokens.prev=state.tokens.curr,state.tokens.curr=state.tokens.next;;){if(state.tokens.next=lookahead.shift()||lex.token(),state.tokens.next||quit(\"E041\",state.tokens.curr.line),\"(end)\"===state.tokens.next.id||\"(error)\"===state.tokens.next.id)return;if(state.tokens.next.check&&state.tokens.next.check(),state.tokens.next.isSpecial)\"falls through\"===state.tokens.next.type?state.tokens.curr.caseFallsThrough=!0:doOption();else if(\"(endline)\"!==state.tokens.next.id)break}}function isInfix(token){return token.infix||!token.identifier&&!token.template&&!!token.led}function isEndOfExpr(){var curr=state.tokens.curr,next=state.tokens.next;return\";\"===next.id||\"}\"===next.id||\":\"===next.id?!0:isInfix(next)===isInfix(curr)||\"yield\"===curr.id&&state.inMoz()?curr.line!==startLine(next):!1}function isBeginOfExpr(prev){return!prev.left&&\"unary\"!==prev.arity}function expression(rbp,initial){var left,isArray=!1,isObject=!1,isLetExpr=!1;state.nameStack.push(),initial||\"let\"!==state.tokens.next.value||\"(\"!==peek(0).value||(state.inMoz()||warning(\"W118\",state.tokens.next,\"let expressions\"),isLetExpr=!0,state.funct[\"(scope)\"].stack(),advance(\"let\"),advance(\"(\"),state.tokens.prev.fud(),advance(\")\")),\"(end)\"===state.tokens.next.id&&error(\"E006\",state.tokens.curr);var isDangerous=state.option.asi&&state.tokens.prev.line!==startLine(state.tokens.curr)&&_.contains([\"]\",\")\"],state.tokens.prev.id)&&_.contains([\"[\",\"(\"],state.tokens.curr.id);if(isDangerous&&warning(\"W014\",state.tokens.curr,state.tokens.curr.id),advance(),initial&&(state.funct[\"(verb)\"]=state.tokens.curr.value,state.tokens.curr.beginsStmt=!0),initial===!0&&state.tokens.curr.fud)left=state.tokens.curr.fud();else for(state.tokens.curr.nud?left=state.tokens.curr.nud():error(\"E030\",state.tokens.curr,state.tokens.curr.id);(state.tokens.next.lbp>rbp||\"(template)\"===state.tokens.next.type)&&!isEndOfExpr();)isArray=\"Array\"===state.tokens.curr.value,isObject=\"Object\"===state.tokens.curr.value,left&&(left.value||left.first&&left.first.value)&&(\"new\"!==left.value||left.first&&left.first.value&&\".\"===left.first.value)&&(isArray=!1,left.value!==state.tokens.curr.value&&(isObject=!1)),advance(),isArray&&\"(\"===state.tokens.curr.id&&\")\"===state.tokens.next.id&&warning(\"W009\",state.tokens.curr),isObject&&\"(\"===state.tokens.curr.id&&\")\"===state.tokens.next.id&&warning(\"W010\",state.tokens.curr),left&&state.tokens.curr.led?left=state.tokens.curr.led(left):error(\"E033\",state.tokens.curr,state.tokens.curr.id);return isLetExpr&&state.funct[\"(scope)\"].unstack(),state.nameStack.pop(),left}function startLine(token){return token.startLine||token.line}function nobreaknonadjacent(left,right){left=left||state.tokens.curr,right=right||state.tokens.next,state.option.laxbreak||left.line===startLine(right)||warning(\"W014\",right,right.value)}function nolinebreak(t){t=t||state.tokens.curr,t.line!==startLine(state.tokens.next)&&warning(\"E022\",t,t.value)}function nobreakcomma(left,right){left.line!==startLine(right)&&(state.option.laxcomma||(comma.first&&(warning(\"I001\"),comma.first=!1),warning(\"W014\",left,right.value)))}function comma(opts){if(opts=opts||{},opts.peek?nobreakcomma(state.tokens.prev,state.tokens.curr):(nobreakcomma(state.tokens.curr,state.tokens.next),advance(\",\")),state.tokens.next.identifier&&(!opts.property||!state.inES5()))switch(state.tokens.next.value){case\"break\":case\"case\":case\"catch\":case\"continue\":case\"default\":case\"do\":case\"else\":case\"finally\":case\"for\":case\"if\":case\"in\":case\"instanceof\":case\"return\":case\"switch\":case\"throw\":case\"try\":case\"var\":case\"let\":case\"while\":case\"with\":return error(\"E024\",state.tokens.next,state.tokens.next.value),!1}if(\"(punctuator)\"===state.tokens.next.type)switch(state.tokens.next.value){case\"}\":case\"]\":case\",\":if(opts.allowTrailing)return!0;case\")\":return error(\"E024\",state.tokens.next,state.tokens.next.value),!1}return!0}function symbol(s,p){var x=state.syntax[s];return x&&\"object\"==typeof x||(state.syntax[s]=x={id:s,lbp:p,value:s}),x}function delim(s){var x=symbol(s,0);return x.delim=!0,x}function stmt(s,f){var x=delim(s);return x.identifier=x.reserved=!0,x.fud=f,x}function blockstmt(s,f){var x=stmt(s,f);return x.block=!0,x}function reserveName(x){var c=x.id.charAt(0);return(c>=\"a\"&&\"z\">=c||c>=\"A\"&&\"Z\">=c)&&(x.identifier=x.reserved=!0),x}function prefix(s,f){var x=symbol(s,150);return reserveName(x),x.nud=\"function\"==typeof f?f:function(){return this.arity=\"unary\",this.right=expression(150),(\"++\"===this.id||\"--\"===this.id)&&(state.option.plusplus?warning(\"W016\",this,this.id):!this.right||this.right.identifier&&!isReserved(this.right)||\".\"===this.right.id||\"[\"===this.right.id||warning(\"W017\",this),this.right&&this.right.isMetaProperty?error(\"E031\",this):this.right&&this.right.identifier&&state.funct[\"(scope)\"].block.modify(this.right.value,this)),this},x}function type(s,f){var x=delim(s);return x.type=s,x.nud=f,x}function reserve(name,func){var x=type(name,func);return x.identifier=!0,x.reserved=!0,x}function FutureReservedWord(name,meta){var x=type(name,meta&&meta.nud||function(){return this});return meta=meta||{},meta.isFutureReservedWord=!0,x.value=name,x.identifier=!0,x.reserved=!0,x.meta=meta,x}function reservevar(s,v){return reserve(s,function(){return\"function\"==typeof v&&v(this),this})}function infix(s,f,p,w){var x=symbol(s,p);return reserveName(x),x.infix=!0,x.led=function(left){return w||nobreaknonadjacent(state.tokens.prev,state.tokens.curr),\"in\"!==s&&\"instanceof\"!==s||\"!\"!==left.id||warning(\"W018\",left,\"!\"),\"function\"==typeof f?f(left,this):(this.left=left,this.right=expression(p),this)},x}function application(s){var x=symbol(s,42);return x.led=function(left){return nobreaknonadjacent(state.tokens.prev,state.tokens.curr),this.left=left,this.right=doFunction({type:\"arrow\",loneArg:left}),this},x}function relation(s,f){var x=symbol(s,100);return x.led=function(left){nobreaknonadjacent(state.tokens.prev,state.tokens.curr),this.left=left;var right=this.right=expression(100);return isIdentifier(left,\"NaN\")||isIdentifier(right,\"NaN\")?warning(\"W019\",this):f&&f.apply(this,[left,right]),left&&right||quit(\"E041\",state.tokens.curr.line),\"!\"===left.id&&warning(\"W018\",left,\"!\"),\"!\"===right.id&&warning(\"W018\",right,\"!\"),this},x}function isPoorRelation(node){return node&&(\"(number)\"===node.type&&0===+node.value||\"(string)\"===node.type&&\"\"===node.value||\"null\"===node.type&&!state.option.eqnull||\"true\"===node.type||\"false\"===node.type||\"undefined\"===node.type)}function isTypoTypeof(left,right,state){var values;return state.option.notypeof?!1:left&&right?(values=state.inES6()?typeofValues.es6:typeofValues.es3,\"(identifier)\"===right.type&&\"typeof\"===right.value&&\"(string)\"===left.type?!_.contains(values,left.value):!1):!1}function isGlobalEval(left,state){var isGlobal=!1;return\"this\"===left.type&&null===state.funct[\"(context)\"]?isGlobal=!0:\"(identifier)\"===left.type&&(state.option.node&&\"global\"===left.value?isGlobal=!0:!state.option.browser||\"window\"!==left.value&&\"document\"!==left.value||(isGlobal=!0)),isGlobal}function findNativePrototype(left){function walkPrototype(obj){return\"object\"==typeof obj?\"prototype\"===obj.right?obj:walkPrototype(obj.left):void 0}function walkNative(obj){for(;!obj.identifier&&\"object\"==typeof obj.left;)obj=obj.left;return obj.identifier&&natives.indexOf(obj.value)>=0?obj.value:void 0}var natives=[\"Array\",\"ArrayBuffer\",\"Boolean\",\"Collator\",\"DataView\",\"Date\",\"DateTimeFormat\",\"Error\",\"EvalError\",\"Float32Array\",\"Float64Array\",\"Function\",\"Infinity\",\"Intl\",\"Int16Array\",\"Int32Array\",\"Int8Array\",\"Iterator\",\"Number\",\"NumberFormat\",\"Object\",\"RangeError\",\"ReferenceError\",\"RegExp\",\"StopIteration\",\"String\",\"SyntaxError\",\"TypeError\",\"Uint16Array\",\"Uint32Array\",\"Uint8Array\",\"Uint8ClampedArray\",\"URIError\"],prototype=walkPrototype(left);return prototype?walkNative(prototype):void 0}function checkLeftSideAssign(left,assignToken,options){var allowDestructuring=options&&options.allowDestructuring;if(assignToken=assignToken||left,state.option.freeze){var nativeObject=findNativePrototype(left);nativeObject&&warning(\"W121\",left,nativeObject)}return left.identifier&&!left.isMetaProperty&&state.funct[\"(scope)\"].block.reassign(left.value,left),\".\"===left.id?((!left.left||\"arguments\"===left.left.value&&!state.isStrict())&&warning(\"E031\",assignToken),state.nameStack.set(state.tokens.prev),!0):\"{\"===left.id||\"[\"===left.id?(allowDestructuring&&state.tokens.curr.left.destructAssign?state.tokens.curr.left.destructAssign.forEach(function(t){t.id&&state.funct[\"(scope)\"].block.modify(t.id,t.token)}):\"{\"!==left.id&&left.left?\"arguments\"!==left.left.value||state.isStrict()||warning(\"E031\",assignToken):warning(\"E031\",assignToken),\"[\"===left.id&&state.nameStack.set(left.right),!0):left.isMetaProperty?(error(\"E031\",assignToken),!0):left.identifier&&!isReserved(left)?(\"exception\"===state.funct[\"(scope)\"].labeltype(left.value)&&warning(\"W022\",left),state.nameStack.set(left),!0):(left===state.syntax[\"function\"]&&warning(\"W023\",state.tokens.curr),!1)}function assignop(s,f,p){var x=infix(s,\"function\"==typeof f?f:function(left,that){return that.left=left,left&&checkLeftSideAssign(left,that,{allowDestructuring:!0})?(that.right=expression(10),that):(error(\"E031\",that),void 0)},p);return x.exps=!0,x.assign=!0,x}function bitwise(s,f,p){var x=symbol(s,p);return reserveName(x),x.led=\"function\"==typeof f?f:function(left){return state.option.bitwise&&warning(\"W016\",this,this.id),this.left=left,this.right=expression(p),this},x}function bitwiseassignop(s){return assignop(s,function(left,that){return state.option.bitwise&&warning(\"W016\",that,that.id),left&&checkLeftSideAssign(left,that)?(that.right=expression(10),that):(error(\"E031\",that),void 0)},20)}function suffix(s){var x=symbol(s,150);return x.led=function(left){return state.option.plusplus?warning(\"W016\",this,this.id):left.identifier&&!isReserved(left)||\".\"===left.id||\"[\"===left.id||warning(\"W017\",this),left.isMetaProperty?error(\"E031\",this):left&&left.identifier&&state.funct[\"(scope)\"].block.modify(left.value,left),this.left=left,this},x}function optionalidentifier(fnparam,prop,preserve){if(state.tokens.next.identifier){preserve||advance();var curr=state.tokens.curr,val=state.tokens.curr.value;return isReserved(curr)?prop&&state.inES5()?val:fnparam&&\"undefined\"===val?val:(warning(\"W024\",state.tokens.curr,state.tokens.curr.id),val):val}}function identifier(fnparam,prop){var i=optionalidentifier(fnparam,prop,!1);if(i)return i;if(\"...\"===state.tokens.next.value){if(state.inES6(!0)||warning(\"W119\",state.tokens.next,\"spread/rest operator\",\"6\"),advance(),checkPunctuator(state.tokens.next,\"...\"))for(warning(\"E024\",state.tokens.next,\"...\");checkPunctuator(state.tokens.next,\"...\");)advance();return state.tokens.next.identifier?identifier(fnparam,prop):(warning(\"E024\",state.tokens.curr,\"...\"),void 0)}error(\"E030\",state.tokens.next,state.tokens.next.value),\";\"!==state.tokens.next.id&&advance()}function reachable(controlToken){var t,i=0;if(\";\"===state.tokens.next.id&&!controlToken.inBracelessBlock)for(;;){do t=peek(i),i+=1;while(\"(end)\"!==t.id&&\"(comment)\"===t.id);if(t.reach)return;if(\"(endline)\"!==t.id){if(\"function\"===t.id){state.option.latedef===!0&&warning(\"W026\",t);break}warning(\"W027\",t,t.value,controlToken.value);break}}}function parseFinalSemicolon(){if(\";\"!==state.tokens.next.id){if(state.tokens.next.isUnclosed)return advance();var sameLine=startLine(state.tokens.next)===state.tokens.curr.line&&\"(end)\"!==state.tokens.next.id,blockEnd=checkPunctuator(state.tokens.next,\"}\");sameLine&&!blockEnd?errorAt(\"E058\",state.tokens.curr.line,state.tokens.curr.character):state.option.asi||(blockEnd&&!state.option.lastsemic||!sameLine)&&warningAt(\"W033\",state.tokens.curr.line,state.tokens.curr.character)}else advance(\";\")}function statement(){var r,i=indent,t=state.tokens.next,hasOwnScope=!1;if(\";\"===t.id)return advance(\";\"),void 0;var res=isReserved(t);if(res&&t.meta&&t.meta.isFutureReservedWord&&\":\"===peek().id&&(warning(\"W024\",t,t.id),res=!1),t.identifier&&!res&&\":\"===peek().id&&(advance(),advance(\":\"),hasOwnScope=!0,state.funct[\"(scope)\"].stack(),state.funct[\"(scope)\"].block.addBreakLabel(t.value,{token:state.tokens.curr}),state.tokens.next.labelled||\"{\"===state.tokens.next.value||warning(\"W028\",state.tokens.next,t.value,state.tokens.next.value),state.tokens.next.label=t.value,t=state.tokens.next),\"{\"===t.id){var iscase=\"case\"===state.funct[\"(verb)\"]&&\":\"===state.tokens.curr.value;return block(!0,!0,!1,!1,iscase),void 0}return r=expression(0,!0),!r||r.identifier&&\"function\"===r.value||\"(punctuator)\"===r.type&&r.left&&r.left.identifier&&\"function\"===r.left.value||state.isStrict()||\"global\"!==state.option.strict||warning(\"E007\"),t.block||(state.option.expr||r&&r.exps?state.option.nonew&&r&&r.left&&\"(\"===r.id&&\"new\"===r.left.id&&warning(\"W031\",t):warning(\"W030\",state.tokens.curr),parseFinalSemicolon()),indent=i,hasOwnScope&&state.funct[\"(scope)\"].unstack(),r}function statements(){for(var p,a=[];!state.tokens.next.reach&&\"(end)\"!==state.tokens.next.id;)\";\"===state.tokens.next.id?(p=peek(),(!p||\"(\"!==p.id&&\"[\"!==p.id)&&warning(\"W032\"),advance(\";\")):a.push(statement());return a}function directives(){for(var i,p,pn;\"(string)\"===state.tokens.next.id;){if(p=peek(0),\"(endline)\"===p.id){i=1;do pn=peek(i++);while(\"(endline)\"===pn.id);if(\";\"===pn.id)p=pn;else{if(\"[\"===pn.value||\".\"===pn.value)break;state.option.asi&&\"(\"!==pn.value||warning(\"W033\",state.tokens.next)}}else{if(\".\"===p.id||\"[\"===p.id)break;\";\"!==p.id&&warning(\"W033\",p)}advance();var directive=state.tokens.curr.value;(state.directive[directive]||\"use strict\"===directive&&\"implied\"===state.option.strict)&&warning(\"W034\",state.tokens.curr,directive),state.directive[directive]=!0,\";\"===p.id&&advance(\";\")}state.isStrict()&&(state.option[\"(explicitNewcap)\"]||(state.option.newcap=!0),state.option.undef=!0)}function block(ordinary,stmt,isfunc,isfatarrow,iscase){var a,m,t,line,d,b=inblock,old_indent=indent;inblock=ordinary,t=state.tokens.next;var metrics=state.funct[\"(metrics)\"];if(metrics.nestedBlockDepth+=1,metrics.verifyMaxNestedBlockDepthPerFunction(),\"{\"===state.tokens.next.id){if(advance(\"{\"),state.funct[\"(scope)\"].stack(),line=state.tokens.curr.line,\"}\"!==state.tokens.next.id){for(indent+=state.option.indent;!ordinary&&state.tokens.next.from>indent;)indent+=state.option.indent;if(isfunc){m={};for(d in state.directive)_.has(state.directive,d)&&(m[d]=state.directive[d]);directives(),state.option.strict&&state.funct[\"(context)\"][\"(global)\"]&&(m[\"use strict\"]||state.isStrict()||warning(\"E007\"))}a=statements(),metrics.statementCount+=a.length,indent-=state.option.indent}advance(\"}\",t),isfunc&&(state.funct[\"(scope)\"].validateParams(),m&&(state.directive=m)),state.funct[\"(scope)\"].unstack(),indent=old_indent}else if(ordinary)state.funct[\"(noblockscopedvar)\"]=\"for\"!==state.tokens.next.id,state.funct[\"(scope)\"].stack(),(!stmt||state.option.curly)&&warning(\"W116\",state.tokens.next,\"{\",state.tokens.next.value),state.tokens.next.inBracelessBlock=!0,indent+=state.option.indent,a=[statement()],indent-=state.option.indent,state.funct[\"(scope)\"].unstack(),delete state.funct[\"(noblockscopedvar)\"];else if(isfunc){if(state.funct[\"(scope)\"].stack(),m={},!stmt||isfatarrow||state.inMoz()||error(\"W118\",state.tokens.curr,\"function closure expressions\"),!stmt)for(d in state.directive)_.has(state.directive,d)&&(m[d]=state.directive[d]);expression(10),state.option.strict&&state.funct[\"(context)\"][\"(global)\"]&&(m[\"use strict\"]||state.isStrict()||warning(\"E007\")),state.funct[\"(scope)\"].unstack()}else error(\"E021\",state.tokens.next,\"{\",state.tokens.next.value);switch(state.funct[\"(verb)\"]){case\"break\":case\"continue\":case\"return\":case\"throw\":if(iscase)break;default:state.funct[\"(verb)\"]=null}return inblock=b,!ordinary||!state.option.noempty||a&&0!==a.length||warning(\"W035\",state.tokens.prev),metrics.nestedBlockDepth-=1,a}function countMember(m){membersOnly&&\"boolean\"!=typeof membersOnly[m]&&warning(\"W036\",state.tokens.curr,m),\"number\"==typeof member[m]?member[m]+=1:member[m]=1}function comprehensiveArrayExpression(){var res={};res.exps=!0,state.funct[\"(comparray)\"].stack();var reversed=!1;return\"for\"!==state.tokens.next.value&&(reversed=!0,state.inMoz()||warning(\"W116\",state.tokens.next,\"for\",state.tokens.next.value),state.funct[\"(comparray)\"].setState(\"use\"),res.right=expression(10)),advance(\"for\"),\"each\"===state.tokens.next.value&&(advance(\"each\"),state.inMoz()||warning(\"W118\",state.tokens.curr,\"for each\")),advance(\"(\"),state.funct[\"(comparray)\"].setState(\"define\"),res.left=expression(130),_.contains([\"in\",\"of\"],state.tokens.next.value)?advance():error(\"E045\",state.tokens.curr),state.funct[\"(comparray)\"].setState(\"generate\"),expression(10),advance(\")\"),\"if\"===state.tokens.next.value&&(advance(\"if\"),advance(\"(\"),state.funct[\"(comparray)\"].setState(\"filter\"),res.filter=expression(10),advance(\")\")),reversed||(state.funct[\"(comparray)\"].setState(\"use\"),res.right=expression(10)),advance(\"]\"),state.funct[\"(comparray)\"].unstack(),res}function isMethod(){return state.funct[\"(statement)\"]&&\"class\"===state.funct[\"(statement)\"].type||state.funct[\"(context)\"]&&\"class\"===state.funct[\"(context)\"][\"(verb)\"]}function isPropertyName(token){return token.identifier||\"(string)\"===token.id||\"(number)\"===token.id}function propertyName(preserveOrToken){var id,preserve=!0;return\"object\"==typeof preserveOrToken?id=preserveOrToken:(preserve=preserveOrToken,id=optionalidentifier(!1,!0,preserve)),id?\"object\"==typeof id&&(\"(string)\"===id.id||\"(identifier)\"===id.id?id=id.value:\"(number)\"===id.id&&(id=\"\"+id.value)):\"(string)\"===state.tokens.next.id?(id=state.tokens.next.value,preserve||advance()):\"(number)\"===state.tokens.next.id&&(id=\"\"+state.tokens.next.value,preserve||advance()),\"hasOwnProperty\"===id&&warning(\"W001\"),id}function functionparams(options){function addParam(addParamArgs){state.funct[\"(scope)\"].addParam.apply(state.funct[\"(scope)\"],addParamArgs)}var next,ident,t,paramsIds=[],tokens=[],pastDefault=!1,pastRest=!1,arity=0,loneArg=options&&options.loneArg;if(loneArg&&loneArg.identifier===!0)return state.funct[\"(scope)\"].addParam(loneArg.value,loneArg),{arity:1,params:[loneArg.value]};if(next=state.tokens.next,options&&options.parsedOpening||advance(\"(\"),\")\"===state.tokens.next.id)return advance(\")\"),void 0;for(;;){arity++;var currentParams=[];if(_.contains([\"{\",\"[\"],state.tokens.next.id)){tokens=destructuringPattern();for(t in tokens)t=tokens[t],t.id&&(paramsIds.push(t.id),currentParams.push([t.id,t.token]))}else if(checkPunctuator(state.tokens.next,\"...\")&&(pastRest=!0),ident=identifier(!0))paramsIds.push(ident),currentParams.push([ident,state.tokens.curr]);else for(;!checkPunctuators(state.tokens.next,[\",\",\")\"]);)advance();if(pastDefault&&\"=\"!==state.tokens.next.id&&error(\"W138\",state.tokens.current),\"=\"===state.tokens.next.id&&(state.inES6()||warning(\"W119\",state.tokens.next,\"default parameters\",\"6\"),advance(\"=\"),pastDefault=!0,expression(10)),currentParams.forEach(addParam),\",\"!==state.tokens.next.id)return advance(\")\",next),{arity:arity,params:paramsIds};pastRest&&warning(\"W131\",state.tokens.next),comma()}}function functor(name,token,overwrites){var funct={\"(name)\":name,\"(breakage)\":0,\"(loopage)\":0,\"(tokens)\":{},\"(properties)\":{},\"(catch)\":!1,\"(global)\":!1,\"(line)\":null,\"(character)\":null,\"(metrics)\":null,\"(statement)\":null,\"(context)\":null,\"(scope)\":null,\"(comparray)\":null,\"(generator)\":null,\"(arrow)\":null,\"(params)\":null};return token&&_.extend(funct,{\"(line)\":token.line,\"(character)\":token.character,\"(metrics)\":createMetrics(token)}),_.extend(funct,overwrites),funct[\"(context)\"]&&(funct[\"(scope)\"]=funct[\"(context)\"][\"(scope)\"],funct[\"(comparray)\"]=funct[\"(context)\"][\"(comparray)\"]),funct}function isFunctor(token){return\"(scope)\"in token}function hasParsedCode(funct){return funct[\"(global)\"]&&!funct[\"(verb)\"]}function doTemplateLiteral(left){function end(){if(state.tokens.curr.template&&state.tokens.curr.tail&&state.tokens.curr.context===ctx)return!0;var complete=state.tokens.next.template&&state.tokens.next.tail&&state.tokens.next.context===ctx;return complete&&advance(),complete||state.tokens.next.isUnclosed}var ctx=this.context,noSubst=this.noSubst,depth=this.depth;if(!noSubst)for(;!end();)!state.tokens.next.template||state.tokens.next.depth>depth?expression(0):advance();return{id:\"(template)\",type:\"(template)\",tag:left}}function doFunction(options){var f,token,name,statement,classExprBinding,isGenerator,isArrow,ignoreLoopFunc,oldOption=state.option,oldIgnored=state.ignored;options&&(name=options.name,statement=options.statement,classExprBinding=options.classExprBinding,isGenerator=\"generator\"===options.type,isArrow=\"arrow\"===options.type,ignoreLoopFunc=options.ignoreLoopFunc),state.option=Object.create(state.option),state.ignored=Object.create(state.ignored),state.funct=functor(name||state.nameStack.infer(),state.tokens.next,{\"(statement)\":statement,\"(context)\":state.funct,\"(arrow)\":isArrow,\"(generator)\":isGenerator}),f=state.funct,token=state.tokens.curr,token.funct=state.funct,functions.push(state.funct),state.funct[\"(scope)\"].stack(\"functionouter\");var internallyAccessibleName=name||classExprBinding;internallyAccessibleName&&state.funct[\"(scope)\"].block.add(internallyAccessibleName,classExprBinding?\"class\":\"function\",state.tokens.curr,!1),state.funct[\"(scope)\"].stack(\"functionparams\");var paramsInfo=functionparams(options);return paramsInfo?(state.funct[\"(params)\"]=paramsInfo.params,state.funct[\"(metrics)\"].arity=paramsInfo.arity,state.funct[\"(metrics)\"].verifyMaxParametersPerFunction()):state.funct[\"(metrics)\"].arity=0,isArrow&&(state.inES6(!0)||warning(\"W119\",state.tokens.curr,\"arrow function syntax (=>)\",\"6\"),options.loneArg||advance(\"=>\")),block(!1,!0,!0,isArrow),!state.option.noyield&&isGenerator&&\"yielded\"!==state.funct[\"(generator)\"]&&warning(\"W124\",state.tokens.curr),state.funct[\"(metrics)\"].verifyMaxStatementsPerFunction(),state.funct[\"(metrics)\"].verifyMaxComplexityPerFunction(),state.funct[\"(unusedOption)\"]=state.option.unused,state.option=oldOption,state.ignored=oldIgnored,state.funct[\"(last)\"]=state.tokens.curr.line,state.funct[\"(lastcharacter)\"]=state.tokens.curr.character,state.funct[\"(scope)\"].unstack(),state.funct[\"(scope)\"].unstack(),state.funct=state.funct[\"(context)\"],ignoreLoopFunc||state.option.loopfunc||!state.funct[\"(loopage)\"]||f[\"(isCapturing)\"]&&warning(\"W083\",token),f}function createMetrics(functionStartToken){return{statementCount:0,nestedBlockDepth:-1,ComplexityCount:1,arity:0,verifyMaxStatementsPerFunction:function(){state.option.maxstatements&&this.statementCount>state.option.maxstatements&&warning(\"W071\",functionStartToken,this.statementCount)\n},verifyMaxParametersPerFunction:function(){_.isNumber(state.option.maxparams)&&this.arity>state.option.maxparams&&warning(\"W072\",functionStartToken,this.arity)},verifyMaxNestedBlockDepthPerFunction:function(){state.option.maxdepth&&this.nestedBlockDepth>0&&this.nestedBlockDepth===state.option.maxdepth+1&&warning(\"W073\",null,this.nestedBlockDepth)},verifyMaxComplexityPerFunction:function(){var max=state.option.maxcomplexity,cc=this.ComplexityCount;max&&cc>max&&warning(\"W074\",functionStartToken,cc)}}}function increaseComplexityCount(){state.funct[\"(metrics)\"].ComplexityCount+=1}function checkCondAssignment(expr){var id,paren;switch(expr&&(id=expr.id,paren=expr.paren,\",\"===id&&(expr=expr.exprs[expr.exprs.length-1])&&(id=expr.id,paren=paren||expr.paren)),id){case\"=\":case\"+=\":case\"-=\":case\"*=\":case\"%=\":case\"&=\":case\"|=\":case\"^=\":case\"/=\":paren||state.option.boss||warning(\"W084\")}}function checkProperties(props){if(state.inES5())for(var name in props)props[name]&&props[name].setterToken&&!props[name].getterToken&&warning(\"W078\",props[name].setterToken)}function metaProperty(name,c){if(checkPunctuator(state.tokens.next,\".\")){var left=state.tokens.curr.id;advance(\".\");var id=identifier();return state.tokens.curr.isMetaProperty=!0,name!==id?error(\"E057\",state.tokens.prev,left,id):c(),state.tokens.curr}}function destructuringPattern(options){var isAssignment=options&&options.assignment;return state.inES6()||warning(\"W104\",state.tokens.curr,isAssignment?\"destructuring assignment\":\"destructuring binding\",\"6\"),destructuringPatternRecursive(options)}function destructuringPatternRecursive(options){var ids,identifiers=[],openingParsed=options&&options.openingParsed,isAssignment=options&&options.assignment,recursiveOptions=isAssignment?{assignment:isAssignment}:null,firstToken=openingParsed?state.tokens.curr:state.tokens.next,nextInnerDE=function(){var ident;if(checkPunctuators(state.tokens.next,[\"[\",\"{\"])){ids=destructuringPatternRecursive(recursiveOptions);for(var id in ids)id=ids[id],identifiers.push({id:id.id,token:id.token})}else if(checkPunctuator(state.tokens.next,\",\"))identifiers.push({id:null,token:state.tokens.curr});else{if(!checkPunctuator(state.tokens.next,\"(\")){var is_rest=checkPunctuator(state.tokens.next,\"...\");if(isAssignment){var identifierToken=is_rest?peek(0):state.tokens.next;identifierToken.identifier||warning(\"E030\",identifierToken,identifierToken.value);var assignTarget=expression(155);assignTarget&&(checkLeftSideAssign(assignTarget),assignTarget.identifier&&(ident=assignTarget.value))}else ident=identifier();return ident&&identifiers.push({id:ident,token:state.tokens.curr}),is_rest}advance(\"(\"),nextInnerDE(),advance(\")\")}return!1},assignmentProperty=function(){var id;checkPunctuator(state.tokens.next,\"[\")?(advance(\"[\"),expression(10),advance(\"]\"),advance(\":\"),nextInnerDE()):\"(string)\"===state.tokens.next.id||\"(number)\"===state.tokens.next.id?(advance(),advance(\":\"),nextInnerDE()):(id=identifier(),checkPunctuator(state.tokens.next,\":\")?(advance(\":\"),nextInnerDE()):id&&(isAssignment&&checkLeftSideAssign(state.tokens.curr),identifiers.push({id:id,token:state.tokens.curr})))};if(checkPunctuator(firstToken,\"[\")){openingParsed||advance(\"[\"),checkPunctuator(state.tokens.next,\"]\")&&warning(\"W137\",state.tokens.curr);for(var element_after_rest=!1;!checkPunctuator(state.tokens.next,\"]\");)nextInnerDE()&&!element_after_rest&&checkPunctuator(state.tokens.next,\",\")&&(warning(\"W130\",state.tokens.next),element_after_rest=!0),checkPunctuator(state.tokens.next,\"=\")&&(checkPunctuator(state.tokens.prev,\"...\")?advance(\"]\"):advance(\"=\"),\"undefined\"===state.tokens.next.id&&warning(\"W080\",state.tokens.prev,state.tokens.prev.value),expression(10)),checkPunctuator(state.tokens.next,\"]\")||advance(\",\");advance(\"]\")}else if(checkPunctuator(firstToken,\"{\")){for(openingParsed||advance(\"{\"),checkPunctuator(state.tokens.next,\"}\")&&warning(\"W137\",state.tokens.curr);!checkPunctuator(state.tokens.next,\"}\")&&(assignmentProperty(),checkPunctuator(state.tokens.next,\"=\")&&(advance(\"=\"),\"undefined\"===state.tokens.next.id&&warning(\"W080\",state.tokens.prev,state.tokens.prev.value),expression(10)),checkPunctuator(state.tokens.next,\"}\")||(advance(\",\"),!checkPunctuator(state.tokens.next,\"}\"))););advance(\"}\")}return identifiers}function destructuringPatternMatch(tokens,value){var first=value.first;first&&_.zip(tokens,Array.isArray(first)?first:[first]).forEach(function(val){var token=val[0],value=val[1];token&&value?token.first=value:token&&token.first&&!value&&warning(\"W080\",token.first,token.first.value)})}function blockVariableStatement(type,statement,context){var tokens,lone,value,letblock,prefix=context&&context.prefix,inexport=context&&context.inexport,isLet=\"let\"===type,isConst=\"const\"===type;for(state.inES6()||warning(\"W104\",state.tokens.curr,type,\"6\"),isLet&&\"(\"===state.tokens.next.value?(state.inMoz()||warning(\"W118\",state.tokens.next,\"let block\"),advance(\"(\"),state.funct[\"(scope)\"].stack(),letblock=!0):state.funct[\"(noblockscopedvar)\"]&&error(\"E048\",state.tokens.curr,isConst?\"Const\":\"Let\"),statement.first=[];;){var names=[];_.contains([\"{\",\"[\"],state.tokens.next.value)?(tokens=destructuringPattern(),lone=!1):(tokens=[{id:identifier(),token:state.tokens.curr}],lone=!0),!prefix&&isConst&&\"=\"!==state.tokens.next.id&&warning(\"E012\",state.tokens.curr,state.tokens.curr.value);for(var t in tokens)tokens.hasOwnProperty(t)&&(t=tokens[t],state.funct[\"(scope)\"].block.isGlobal()&&predefined[t.id]===!1&&warning(\"W079\",t.token,t.id),t.id&&!state.funct[\"(noblockscopedvar)\"]&&(state.funct[\"(scope)\"].addlabel(t.id,{type:type,token:t.token}),names.push(t.token),lone&&inexport&&state.funct[\"(scope)\"].setExported(t.token.value,t.token)));if(\"=\"===state.tokens.next.id&&(advance(\"=\"),prefix||\"undefined\"!==state.tokens.next.id||warning(\"W080\",state.tokens.prev,state.tokens.prev.value),!prefix&&\"=\"===peek(0).id&&state.tokens.next.identifier&&warning(\"W120\",state.tokens.next,state.tokens.next.value),value=expression(prefix?120:10),lone?tokens[0].first=value:destructuringPatternMatch(names,value)),statement.first=statement.first.concat(names),\",\"!==state.tokens.next.id)break;comma()}return letblock&&(advance(\")\"),block(!0,!0),statement.block=!0,state.funct[\"(scope)\"].unstack()),statement}function classdef(isStatement){return state.inES6()||warning(\"W104\",state.tokens.curr,\"class\",\"6\"),isStatement?(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"class\",token:state.tokens.curr})):state.tokens.next.identifier&&\"extends\"!==state.tokens.next.value?(this.name=identifier(),this.namedExpr=!0):this.name=state.nameStack.infer(),classtail(this),this}function classtail(c){var wasInClassBody=state.inClassBody;\"extends\"===state.tokens.next.value&&(advance(\"extends\"),c.heritage=expression(10)),state.inClassBody=!0,advance(\"{\"),c.body=classbody(c),advance(\"}\"),state.inClassBody=wasInClassBody}function classbody(c){for(var name,isStatic,isGenerator,getset,computed,props=Object.create(null),staticProps=Object.create(null),i=0;\"}\"!==state.tokens.next.id;++i)if(name=state.tokens.next,isStatic=!1,isGenerator=!1,getset=null,\";\"!==name.id){if(\"*\"===name.id&&(isGenerator=!0,advance(\"*\"),name=state.tokens.next),\"[\"===name.id)name=computedPropertyName(),computed=!0;else{if(!isPropertyName(name)){warning(\"W052\",state.tokens.next,state.tokens.next.value||state.tokens.next.type),advance();continue}advance(),computed=!1,name.identifier&&\"static\"===name.value&&(checkPunctuator(state.tokens.next,\"*\")&&(isGenerator=!0,advance(\"*\")),(isPropertyName(state.tokens.next)||\"[\"===state.tokens.next.id)&&(computed=\"[\"===state.tokens.next.id,isStatic=!0,name=state.tokens.next,\"[\"===state.tokens.next.id?name=computedPropertyName():advance())),!name.identifier||\"get\"!==name.value&&\"set\"!==name.value||(isPropertyName(state.tokens.next)||\"[\"===state.tokens.next.id)&&(computed=\"[\"===state.tokens.next.id,getset=name,name=state.tokens.next,\"[\"===state.tokens.next.id?name=computedPropertyName():advance())}if(!checkPunctuator(state.tokens.next,\"(\")){for(error(\"E054\",state.tokens.next,state.tokens.next.value);\"}\"!==state.tokens.next.id&&!checkPunctuator(state.tokens.next,\"(\");)advance();\"(\"!==state.tokens.next.value&&doFunction({statement:c})}if(computed||(getset?saveAccessor(getset.value,isStatic?staticProps:props,name.value,name,!0,isStatic):(\"constructor\"===name.value?state.nameStack.set(c):state.nameStack.set(name),saveProperty(isStatic?staticProps:props,name.value,name,!0,isStatic))),getset&&\"constructor\"===name.value){var propDesc=\"get\"===getset.value?\"class getter method\":\"class setter method\";error(\"E049\",name,propDesc,\"constructor\")}else\"prototype\"===name.value&&error(\"E049\",name,\"class method\",\"prototype\");propertyName(name),doFunction({statement:c,type:isGenerator?\"generator\":null,classExprBinding:c.namedExpr?c.name:null})}else warning(\"W032\"),advance(\";\");checkProperties(props)}function saveProperty(props,name,tkn,isClass,isStatic){var msg=[\"key\",\"class method\",\"static class method\"];msg=msg[(isClass||!1)+(isStatic||!1)],tkn.identifier&&(name=tkn.value),props[name]&&\"__proto__\"!==name?warning(\"W075\",state.tokens.next,msg,name):props[name]=Object.create(null),props[name].basic=!0,props[name].basictkn=tkn}function saveAccessor(accessorType,props,name,tkn,isClass,isStatic){var flagName=\"get\"===accessorType?\"getterToken\":\"setterToken\",msg=\"\";isClass?(isStatic&&(msg+=\"static \"),msg+=accessorType+\"ter method\"):msg=\"key\",state.tokens.curr.accessorType=accessorType,state.nameStack.set(tkn),props[name]?(props[name].basic||props[name][flagName])&&\"__proto__\"!==name&&warning(\"W075\",state.tokens.next,msg,name):props[name]=Object.create(null),props[name][flagName]=tkn}function computedPropertyName(){advance(\"[\"),state.inES6()||warning(\"W119\",state.tokens.curr,\"computed property names\",\"6\");var value=expression(10);return advance(\"]\"),value}function checkPunctuators(token,values){return\"(punctuator)\"===token.type?_.contains(values,token.value):!1}function checkPunctuator(token,value){return\"(punctuator)\"===token.type&&token.value===value}function destructuringAssignOrJsonValue(){var block=lookupBlockType();block.notJson?(!state.inES6()&&block.isDestAssign&&warning(\"W104\",state.tokens.curr,\"destructuring assignment\",\"6\"),statements()):(state.option.laxbreak=!0,state.jsonMode=!0,jsonValue())}function jsonValue(){function jsonObject(){var o={},t=state.tokens.next;if(advance(\"{\"),\"}\"!==state.tokens.next.id)for(;;){if(\"(end)\"===state.tokens.next.id)error(\"E026\",state.tokens.next,t.line);else{if(\"}\"===state.tokens.next.id){warning(\"W094\",state.tokens.curr);break}\",\"===state.tokens.next.id?error(\"E028\",state.tokens.next):\"(string)\"!==state.tokens.next.id&&warning(\"W095\",state.tokens.next,state.tokens.next.value)}if(o[state.tokens.next.value]===!0?warning(\"W075\",state.tokens.next,\"key\",state.tokens.next.value):\"__proto__\"===state.tokens.next.value&&!state.option.proto||\"__iterator__\"===state.tokens.next.value&&!state.option.iterator?warning(\"W096\",state.tokens.next,state.tokens.next.value):o[state.tokens.next.value]=!0,advance(),advance(\":\"),jsonValue(),\",\"!==state.tokens.next.id)break;advance(\",\")}advance(\"}\")}function jsonArray(){var t=state.tokens.next;if(advance(\"[\"),\"]\"!==state.tokens.next.id)for(;;){if(\"(end)\"===state.tokens.next.id)error(\"E027\",state.tokens.next,t.line);else{if(\"]\"===state.tokens.next.id){warning(\"W094\",state.tokens.curr);break}\",\"===state.tokens.next.id&&error(\"E028\",state.tokens.next)}if(jsonValue(),\",\"!==state.tokens.next.id)break;advance(\",\")}advance(\"]\")}switch(state.tokens.next.id){case\"{\":jsonObject();break;case\"[\":jsonArray();break;case\"true\":case\"false\":case\"null\":case\"(number)\":case\"(string)\":advance();break;case\"-\":advance(\"-\"),advance(\"(number)\");break;default:error(\"E003\",state.tokens.next)}}var api,declared,functions,inblock,indent,lookahead,lex,member,membersOnly,predefined,stack,urls,bang={\"<\":!0,\"<=\":!0,\"==\":!0,\"===\":!0,\"!==\":!0,\"!=\":!0,\">\":!0,\">=\":!0,\"+\":!0,\"-\":!0,\"*\":!0,\"/\":!0,\"%\":!0},functionicity=[\"closure\",\"exception\",\"global\",\"label\",\"outer\",\"unused\",\"var\"],extraModules=[],emitter=new events.EventEmitter,typeofValues={};typeofValues.legacy=[\"xml\",\"unknown\"],typeofValues.es3=[\"undefined\",\"boolean\",\"number\",\"string\",\"function\",\"object\"],typeofValues.es3=typeofValues.es3.concat(typeofValues.legacy),typeofValues.es6=typeofValues.es3.concat(\"symbol\"),type(\"(number)\",function(){return this}),type(\"(string)\",function(){return this}),state.syntax[\"(identifier)\"]={type:\"(identifier)\",lbp:0,identifier:!0,nud:function(){var v=this.value;return\"=>\"===state.tokens.next.id?this:(state.funct[\"(comparray)\"].check(v)||state.funct[\"(scope)\"].block.use(v,state.tokens.curr),this)},led:function(){error(\"E033\",state.tokens.next,state.tokens.next.value)}};var baseTemplateSyntax={lbp:0,identifier:!1,template:!0};state.syntax[\"(template)\"]=_.extend({type:\"(template)\",nud:doTemplateLiteral,led:doTemplateLiteral,noSubst:!1},baseTemplateSyntax),state.syntax[\"(template middle)\"]=_.extend({type:\"(template middle)\",middle:!0,noSubst:!1},baseTemplateSyntax),state.syntax[\"(template tail)\"]=_.extend({type:\"(template tail)\",tail:!0,noSubst:!1},baseTemplateSyntax),state.syntax[\"(no subst template)\"]=_.extend({type:\"(template)\",nud:doTemplateLiteral,led:doTemplateLiteral,noSubst:!0,tail:!0},baseTemplateSyntax),type(\"(regexp)\",function(){return this}),delim(\"(endline)\"),delim(\"(begin)\"),delim(\"(end)\").reach=!0,delim(\"(error)\").reach=!0,delim(\"}\").reach=!0,delim(\")\"),delim(\"]\"),delim('\"').reach=!0,delim(\"'\").reach=!0,delim(\";\"),delim(\":\").reach=!0,delim(\"#\"),reserve(\"else\"),reserve(\"case\").reach=!0,reserve(\"catch\"),reserve(\"default\").reach=!0,reserve(\"finally\"),reservevar(\"arguments\",function(x){state.isStrict()&&state.funct[\"(global)\"]&&warning(\"E008\",x)}),reservevar(\"eval\"),reservevar(\"false\"),reservevar(\"Infinity\"),reservevar(\"null\"),reservevar(\"this\",function(x){state.isStrict()&&!isMethod()&&!state.option.validthis&&(state.funct[\"(statement)\"]&&state.funct[\"(name)\"].charAt(0)>\"Z\"||state.funct[\"(global)\"])&&warning(\"W040\",x)}),reservevar(\"true\"),reservevar(\"undefined\"),assignop(\"=\",\"assign\",20),assignop(\"+=\",\"assignadd\",20),assignop(\"-=\",\"assignsub\",20),assignop(\"*=\",\"assignmult\",20),assignop(\"/=\",\"assigndiv\",20).nud=function(){error(\"E014\")},assignop(\"%=\",\"assignmod\",20),bitwiseassignop(\"&=\"),bitwiseassignop(\"|=\"),bitwiseassignop(\"^=\"),bitwiseassignop(\"<<=\"),bitwiseassignop(\">>=\"),bitwiseassignop(\">>>=\"),infix(\",\",function(left,that){var expr;if(that.exprs=[left],state.option.nocomma&&warning(\"W127\"),!comma({peek:!0}))return that;for(;;){if(!(expr=expression(10)))break;if(that.exprs.push(expr),\",\"!==state.tokens.next.value||!comma())break}return that},10,!0),infix(\"?\",function(left,that){return increaseComplexityCount(),that.left=left,that.right=expression(10),advance(\":\"),that[\"else\"]=expression(10),that},30);var orPrecendence=40;infix(\"||\",function(left,that){return increaseComplexityCount(),that.left=left,that.right=expression(orPrecendence),that},orPrecendence),infix(\"&&\",\"and\",50),bitwise(\"|\",\"bitor\",70),bitwise(\"^\",\"bitxor\",80),bitwise(\"&\",\"bitand\",90),relation(\"==\",function(left,right){var eqnull=state.option.eqnull&&(\"null\"===(left&&left.value)||\"null\"===(right&&right.value));switch(!0){case!eqnull&&state.option.eqeqeq:this.from=this.character,warning(\"W116\",this,\"===\",\"==\");break;case isPoorRelation(left):warning(\"W041\",this,\"===\",left.value);break;case isPoorRelation(right):warning(\"W041\",this,\"===\",right.value);break;case isTypoTypeof(right,left,state):warning(\"W122\",this,right.value);break;case isTypoTypeof(left,right,state):warning(\"W122\",this,left.value)}return this}),relation(\"===\",function(left,right){return isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"!=\",function(left,right){var eqnull=state.option.eqnull&&(\"null\"===(left&&left.value)||\"null\"===(right&&right.value));return!eqnull&&state.option.eqeqeq?(this.from=this.character,warning(\"W116\",this,\"!==\",\"!=\")):isPoorRelation(left)?warning(\"W041\",this,\"!==\",left.value):isPoorRelation(right)?warning(\"W041\",this,\"!==\",right.value):isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"!==\",function(left,right){return isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"<\"),relation(\">\"),relation(\"<=\"),relation(\">=\"),bitwise(\"<<\",\"shiftleft\",120),bitwise(\">>\",\"shiftright\",120),bitwise(\">>>\",\"shiftrightunsigned\",120),infix(\"in\",\"in\",120),infix(\"instanceof\",\"instanceof\",120),infix(\"+\",function(left,that){var right;return that.left=left,that.right=right=expression(130),left&&right&&\"(string)\"===left.id&&\"(string)\"===right.id?(left.value+=right.value,left.character=right.character,!state.option.scripturl&&reg.javascriptURL.test(left.value)&&warning(\"W050\",left),left):that},130),prefix(\"+\",\"num\"),prefix(\"+++\",function(){return warning(\"W007\"),this.arity=\"unary\",this.right=expression(150),this}),infix(\"+++\",function(left){return warning(\"W007\"),this.left=left,this.right=expression(130),this},130),infix(\"-\",\"sub\",130),prefix(\"-\",\"neg\"),prefix(\"---\",function(){return warning(\"W006\"),this.arity=\"unary\",this.right=expression(150),this}),infix(\"---\",function(left){return warning(\"W006\"),this.left=left,this.right=expression(130),this},130),infix(\"*\",\"mult\",140),infix(\"/\",\"div\",140),infix(\"%\",\"mod\",140),suffix(\"++\"),prefix(\"++\",\"preinc\"),state.syntax[\"++\"].exps=!0,suffix(\"--\"),prefix(\"--\",\"predec\"),state.syntax[\"--\"].exps=!0,prefix(\"delete\",function(){var p=expression(10);return p?(\".\"!==p.id&&\"[\"!==p.id&&warning(\"W051\"),this.first=p,p.identifier&&!state.isStrict()&&(p.forgiveUndef=!0),this):this}).exps=!0,prefix(\"~\",function(){return state.option.bitwise&&warning(\"W016\",this,\"~\"),this.arity=\"unary\",this.right=expression(150),this}),prefix(\"...\",function(){return state.inES6(!0)||warning(\"W119\",this,\"spread/rest operator\",\"6\"),state.tokens.next.identifier||\"(string)\"===state.tokens.next.type||checkPunctuators(state.tokens.next,[\"[\",\"(\"])||error(\"E030\",state.tokens.next,state.tokens.next.value),expression(150),this}),prefix(\"!\",function(){return this.arity=\"unary\",this.right=expression(150),this.right||quit(\"E041\",this.line||0),bang[this.right.id]===!0&&warning(\"W018\",this,\"!\"),this}),prefix(\"typeof\",function(){var p=expression(150);return this.first=this.right=p,p||quit(\"E041\",this.line||0,this.character||0),p.identifier&&(p.forgiveUndef=!0),this}),prefix(\"new\",function(){var mp=metaProperty(\"target\",function(){state.inES6(!0)||warning(\"W119\",state.tokens.prev,\"new.target\",\"6\");for(var inFunction,c=state.funct;c&&(inFunction=!c[\"(global)\"],c[\"(arrow)\"]);)c=c[\"(context)\"];inFunction||warning(\"W136\",state.tokens.prev,\"new.target\")});if(mp)return mp;var i,c=expression(155);if(c&&\"function\"!==c.id)if(c.identifier)switch(c[\"new\"]=!0,c.value){case\"Number\":case\"String\":case\"Boolean\":case\"Math\":case\"JSON\":warning(\"W053\",state.tokens.prev,c.value);break;case\"Symbol\":state.inES6()&&warning(\"W053\",state.tokens.prev,c.value);break;case\"Function\":state.option.evil||warning(\"W054\");break;case\"Date\":case\"RegExp\":case\"this\":break;default:\"function\"!==c.id&&(i=c.value.substr(0,1),state.option.newcap&&(\"A\">i||i>\"Z\")&&!state.funct[\"(scope)\"].isPredefined(c.value)&&warning(\"W055\",state.tokens.curr))}else\".\"!==c.id&&\"[\"!==c.id&&\"(\"!==c.id&&warning(\"W056\",state.tokens.curr);else state.option.supernew||warning(\"W057\",this);return\"(\"===state.tokens.next.id||state.option.supernew||warning(\"W058\",state.tokens.curr,state.tokens.curr.value),this.first=this.right=c,this}),state.syntax[\"new\"].exps=!0,prefix(\"void\").exps=!0,infix(\".\",function(left,that){var m=identifier(!1,!0);return\"string\"==typeof m&&countMember(m),that.left=left,that.right=m,m&&\"hasOwnProperty\"===m&&\"=\"===state.tokens.next.value&&warning(\"W001\"),!left||\"arguments\"!==left.value||\"callee\"!==m&&\"caller\"!==m?state.option.evil||!left||\"document\"!==left.value||\"write\"!==m&&\"writeln\"!==m||warning(\"W060\",left):state.option.noarg?warning(\"W059\",left,m):state.isStrict()&&error(\"E008\"),state.option.evil||\"eval\"!==m&&\"execScript\"!==m||isGlobalEval(left,state)&&warning(\"W061\"),that},160,!0),infix(\"(\",function(left,that){state.option.immed&&left&&!left.immed&&\"function\"===left.id&&warning(\"W062\");var n=0,p=[];if(left&&\"(identifier)\"===left.type&&left.value.match(/^[A-Z]([A-Z0-9_$]*[a-z][A-Za-z0-9_$]*)?$/)&&-1===\"Array Number String Boolean Date Object Error Symbol\".indexOf(left.value)&&(\"Math\"===left.value?warning(\"W063\",left):state.option.newcap&&warning(\"W064\",left)),\")\"!==state.tokens.next.id)for(;p[p.length]=expression(10),n+=1,\",\"===state.tokens.next.id;)comma();return advance(\")\"),\"object\"==typeof left&&(state.inES5()||\"parseInt\"!==left.value||1!==n||warning(\"W065\",state.tokens.curr),state.option.evil||(\"eval\"===left.value||\"Function\"===left.value||\"execScript\"===left.value?(warning(\"W061\",left),p[0]&&\"(string)\"===[0].id&&addInternalSrc(left,p[0].value)):!p[0]||\"(string)\"!==p[0].id||\"setTimeout\"!==left.value&&\"setInterval\"!==left.value?!p[0]||\"(string)\"!==p[0].id||\".\"!==left.value||\"window\"!==left.left.value||\"setTimeout\"!==left.right&&\"setInterval\"!==left.right||(warning(\"W066\",left),addInternalSrc(left,p[0].value)):(warning(\"W066\",left),addInternalSrc(left,p[0].value))),left.identifier||\".\"===left.id||\"[\"===left.id||\"=>\"===left.id||\"(\"===left.id||\"&&\"===left.id||\"||\"===left.id||\"?\"===left.id||state.inES6()&&left[\"(name)\"]||warning(\"W067\",that)),that.left=left,that},155,!0).exps=!0,prefix(\"(\",function(){var pn1,ret,triggerFnExpr,first,last,pn=state.tokens.next,i=-1,parens=1,opening=state.tokens.curr,preceeding=state.tokens.prev,isNecessary=!state.option.singleGroups;do\"(\"===pn.value?parens+=1:\")\"===pn.value&&(parens-=1),i+=1,pn1=pn,pn=peek(i);while((0!==parens||\")\"!==pn1.value)&&\";\"!==pn.value&&\"(end)\"!==pn.type);if(\"function\"===state.tokens.next.id&&(triggerFnExpr=state.tokens.next.immed=!0),\"=>\"===pn.value)return doFunction({type:\"arrow\",parsedOpening:!0});var exprs=[];if(\")\"!==state.tokens.next.id)for(;exprs.push(expression(10)),\",\"===state.tokens.next.id;)state.option.nocomma&&warning(\"W127\"),comma();return advance(\")\",this),state.option.immed&&exprs[0]&&\"function\"===exprs[0].id&&\"(\"!==state.tokens.next.id&&\".\"!==state.tokens.next.id&&\"[\"!==state.tokens.next.id&&warning(\"W068\",this),exprs.length?(exprs.length>1?(ret=Object.create(state.syntax[\",\"]),ret.exprs=exprs,first=exprs[0],last=exprs[exprs.length-1],isNecessary||(isNecessary=preceeding.assign||preceeding.delim)):(ret=first=last=exprs[0],isNecessary||(isNecessary=opening.beginsStmt&&(\"{\"===ret.id||triggerFnExpr||isFunctor(ret))||triggerFnExpr&&(!isEndOfExpr()||\"}\"!==state.tokens.prev.id)||isFunctor(ret)&&!isEndOfExpr()||\"{\"===ret.id&&\"=>\"===preceeding.id||\"(number)\"===ret.type&&checkPunctuator(pn,\".\")&&/^\\d+$/.test(ret.value))),ret&&(!isNecessary&&(first.left||first.right||ret.exprs)&&(isNecessary=!isBeginOfExpr(preceeding)&&first.lbp<=preceeding.lbp||!isEndOfExpr()&&last.lbp<state.tokens.next.lbp),isNecessary||warning(\"W126\",opening),ret.paren=!0),ret):void 0}),application(\"=>\"),infix(\"[\",function(left,that){var s,e=expression(10);return e&&\"(string)\"===e.type&&(state.option.evil||\"eval\"!==e.value&&\"execScript\"!==e.value||isGlobalEval(left,state)&&warning(\"W061\"),countMember(e.value),!state.option.sub&&reg.identifier.test(e.value)&&(s=state.syntax[e.value],s&&isReserved(s)||warning(\"W069\",state.tokens.prev,e.value))),advance(\"]\",that),e&&\"hasOwnProperty\"===e.value&&\"=\"===state.tokens.next.value&&warning(\"W001\"),that.left=left,that.right=e,that},160,!0),prefix(\"[\",function(){var blocktype=lookupBlockType();if(blocktype.isCompArray)return state.option.esnext||state.inMoz()||warning(\"W118\",state.tokens.curr,\"array comprehension\"),comprehensiveArrayExpression();if(blocktype.isDestAssign)return this.destructAssign=destructuringPattern({openingParsed:!0,assignment:!0}),this;var b=state.tokens.curr.line!==startLine(state.tokens.next);for(this.first=[],b&&(indent+=state.option.indent,state.tokens.next.from===indent+state.option.indent&&(indent+=state.option.indent));\"(end)\"!==state.tokens.next.id;){for(;\",\"===state.tokens.next.id;){if(!state.option.elision){if(state.inES5()){warning(\"W128\");do advance(\",\");while(\",\"===state.tokens.next.id);continue}warning(\"W070\")}advance(\",\")}if(\"]\"===state.tokens.next.id)break;if(this.first.push(expression(10)),\",\"!==state.tokens.next.id)break;if(comma({allowTrailing:!0}),\"]\"===state.tokens.next.id&&!state.inES5()){warning(\"W070\",state.tokens.curr);break}}return b&&(indent-=state.option.indent),advance(\"]\",this),this}),function(x){x.nud=function(){var b,f,i,p,t,nextVal,isGeneratorMethod=!1,props=Object.create(null);b=state.tokens.curr.line!==startLine(state.tokens.next),b&&(indent+=state.option.indent,state.tokens.next.from===indent+state.option.indent&&(indent+=state.option.indent));var blocktype=lookupBlockType();if(blocktype.isDestAssign)return this.destructAssign=destructuringPattern({openingParsed:!0,assignment:!0}),this;for(;\"}\"!==state.tokens.next.id;){if(nextVal=state.tokens.next.value,!state.tokens.next.identifier||\",\"!==peekIgnoreEOL().id&&\"}\"!==peekIgnoreEOL().id)if(\":\"===peek().id||\"get\"!==nextVal&&\"set\"!==nextVal){if(\"*\"===state.tokens.next.value&&\"(punctuator)\"===state.tokens.next.type?(state.inES6()||warning(\"W104\",state.tokens.next,\"generator functions\",\"6\"),advance(\"*\"),isGeneratorMethod=!0):isGeneratorMethod=!1,\"[\"===state.tokens.next.id)i=computedPropertyName(),state.nameStack.set(i);else if(state.nameStack.set(state.tokens.next),i=propertyName(),saveProperty(props,i,state.tokens.next),\"string\"!=typeof i)break;\"(\"===state.tokens.next.value?(state.inES6()||warning(\"W104\",state.tokens.curr,\"concise methods\",\"6\"),doFunction({type:isGeneratorMethod?\"generator\":null})):(advance(\":\"),expression(10))}else advance(nextVal),state.inES5()||error(\"E034\"),i=propertyName(),i||state.inES6()||error(\"E035\"),i&&saveAccessor(nextVal,props,i,state.tokens.curr),t=state.tokens.next,f=doFunction(),p=f[\"(params)\"],\"get\"===nextVal&&i&&p?warning(\"W076\",t,p[0],i):\"set\"!==nextVal||!i||p&&1===p.length||warning(\"W077\",t,i);else state.inES6()||warning(\"W104\",state.tokens.next,\"object short notation\",\"6\"),i=propertyName(!0),saveProperty(props,i,state.tokens.next),expression(10);if(countMember(i),\",\"!==state.tokens.next.id)break;comma({allowTrailing:!0,property:!0}),\",\"===state.tokens.next.id?warning(\"W070\",state.tokens.curr):\"}\"!==state.tokens.next.id||state.inES5()||warning(\"W070\",state.tokens.curr)}return b&&(indent-=state.option.indent),advance(\"}\",this),checkProperties(props),this},x.fud=function(){error(\"E036\",state.tokens.curr)}}(delim(\"{\"));var conststatement=stmt(\"const\",function(context){return blockVariableStatement(\"const\",this,context)});conststatement.exps=!0;var letstatement=stmt(\"let\",function(context){return blockVariableStatement(\"let\",this,context)});letstatement.exps=!0;var varstatement=stmt(\"var\",function(context){var tokens,lone,value,prefix=context&&context.prefix,inexport=context&&context.inexport,implied=context&&context.implied,report=!(context&&context.ignore);for(this.first=[];;){var names=[];_.contains([\"{\",\"[\"],state.tokens.next.value)?(tokens=destructuringPattern(),lone=!1):(tokens=[{id:identifier(),token:state.tokens.curr}],lone=!0),prefix&&implied||!report||!state.option.varstmt||warning(\"W132\",this),this.first=this.first.concat(names);for(var t in tokens)tokens.hasOwnProperty(t)&&(t=tokens[t],!implied&&state.funct[\"(global)\"]&&(predefined[t.id]===!1?warning(\"W079\",t.token,t.id):state.option.futurehostile===!1&&(!state.inES5()&&vars.ecmaIdentifiers[5][t.id]===!1||!state.inES6()&&vars.ecmaIdentifiers[6][t.id]===!1)&&warning(\"W129\",t.token,t.id)),t.id&&(\"for\"===implied?(state.funct[\"(scope)\"].has(t.id)||report&&warning(\"W088\",t.token,t.id),state.funct[\"(scope)\"].block.use(t.id,t.token)):(state.funct[\"(scope)\"].addlabel(t.id,{type:\"var\",token:t.token}),lone&&inexport&&state.funct[\"(scope)\"].setExported(t.id,t.token)),names.push(t.token)));if(\"=\"===state.tokens.next.id&&(state.nameStack.set(state.tokens.curr),advance(\"=\"),prefix||!report||state.funct[\"(loopage)\"]||\"undefined\"!==state.tokens.next.id||warning(\"W080\",state.tokens.prev,state.tokens.prev.value),\"=\"===peek(0).id&&state.tokens.next.identifier&&(!prefix&&report&&!state.funct[\"(params)\"]||-1===state.funct[\"(params)\"].indexOf(state.tokens.next.value))&&warning(\"W120\",state.tokens.next,state.tokens.next.value),value=expression(prefix?120:10),lone?tokens[0].first=value:destructuringPatternMatch(names,value)),\",\"!==state.tokens.next.id)break;comma()}return this});varstatement.exps=!0,blockstmt(\"class\",function(){return classdef.call(this,!0)}),blockstmt(\"function\",function(context){var inexport=context&&context.inexport,generator=!1;\"*\"===state.tokens.next.value&&(advance(\"*\"),state.inES6({strict:!0})?generator=!0:warning(\"W119\",state.tokens.curr,\"function*\",\"6\")),inblock&&warning(\"W082\",state.tokens.curr);var i=optionalidentifier();return state.funct[\"(scope)\"].addlabel(i,{type:\"function\",token:state.tokens.curr}),void 0===i?warning(\"W025\"):inexport&&state.funct[\"(scope)\"].setExported(i,state.tokens.prev),doFunction({name:i,statement:this,type:generator?\"generator\":null,ignoreLoopFunc:inblock}),\"(\"===state.tokens.next.id&&state.tokens.next.line===state.tokens.curr.line&&error(\"E039\"),this}),prefix(\"function\",function(){var generator=!1;\"*\"===state.tokens.next.value&&(state.inES6()||warning(\"W119\",state.tokens.curr,\"function*\",\"6\"),advance(\"*\"),generator=!0);var i=optionalidentifier();return doFunction({name:i,type:generator?\"generator\":null}),this}),blockstmt(\"if\",function(){var t=state.tokens.next;increaseComplexityCount(),state.condition=!0,advance(\"(\");var expr=expression(0);checkCondAssignment(expr);var forinifcheck=null;state.option.forin&&state.forinifcheckneeded&&(state.forinifcheckneeded=!1,forinifcheck=state.forinifchecks[state.forinifchecks.length-1],forinifcheck.type=\"(punctuator)\"===expr.type&&\"!\"===expr.value?\"(negative)\":\"(positive)\"),advance(\")\",t),state.condition=!1;var s=block(!0,!0);return forinifcheck&&\"(negative)\"===forinifcheck.type&&s&&s[0]&&\"(identifier)\"===s[0].type&&\"continue\"===s[0].value&&(forinifcheck.type=\"(negative-with-continue)\"),\"else\"===state.tokens.next.id&&(advance(\"else\"),\"if\"===state.tokens.next.id||\"switch\"===state.tokens.next.id?statement():block(!0,!0)),this}),blockstmt(\"try\",function(){function doCatch(){if(advance(\"catch\"),advance(\"(\"),state.funct[\"(scope)\"].stack(\"catchparams\"),checkPunctuators(state.tokens.next,[\"[\",\"{\"])){var tokens=destructuringPattern();_.each(tokens,function(token){token.id&&state.funct[\"(scope)\"].addParam(token.id,token,\"exception\")})}else\"(identifier)\"!==state.tokens.next.type?warning(\"E030\",state.tokens.next,state.tokens.next.value):state.funct[\"(scope)\"].addParam(identifier(),state.tokens.curr,\"exception\");\"if\"===state.tokens.next.value&&(state.inMoz()||warning(\"W118\",state.tokens.curr,\"catch filter\"),advance(\"if\"),expression(0)),advance(\")\"),block(!1),state.funct[\"(scope)\"].unstack()}var b;for(block(!0);\"catch\"===state.tokens.next.id;)increaseComplexityCount(),b&&!state.inMoz()&&warning(\"W118\",state.tokens.next,\"multiple catch blocks\"),doCatch(),b=!0;return\"finally\"===state.tokens.next.id?(advance(\"finally\"),block(!0),void 0):(b||error(\"E021\",state.tokens.next,\"catch\",state.tokens.next.value),this)}),blockstmt(\"while\",function(){var t=state.tokens.next;return state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,increaseComplexityCount(),advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),block(!0,!0),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1,this}).labelled=!0,blockstmt(\"with\",function(){var t=state.tokens.next;return state.isStrict()?error(\"E010\",state.tokens.curr):state.option.withstmt||warning(\"W085\",state.tokens.curr),advance(\"(\"),expression(0),advance(\")\",t),block(!0,!0),this}),blockstmt(\"switch\",function(){var t=state.tokens.next,g=!1,noindent=!1;\nfor(state.funct[\"(breakage)\"]+=1,advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),t=state.tokens.next,advance(\"{\"),state.tokens.next.from===indent&&(noindent=!0),noindent||(indent+=state.option.indent),this.cases=[];;)switch(state.tokens.next.id){case\"case\":switch(state.funct[\"(verb)\"]){case\"yield\":case\"break\":case\"case\":case\"continue\":case\"return\":case\"switch\":case\"throw\":break;default:state.tokens.curr.caseFallsThrough||warning(\"W086\",state.tokens.curr,\"case\")}advance(\"case\"),this.cases.push(expression(0)),increaseComplexityCount(),g=!0,advance(\":\"),state.funct[\"(verb)\"]=\"case\";break;case\"default\":switch(state.funct[\"(verb)\"]){case\"yield\":case\"break\":case\"continue\":case\"return\":case\"throw\":break;default:this.cases.length&&(state.tokens.curr.caseFallsThrough||warning(\"W086\",state.tokens.curr,\"default\"))}advance(\"default\"),g=!0,advance(\":\");break;case\"}\":return noindent||(indent-=state.option.indent),advance(\"}\",t),state.funct[\"(breakage)\"]-=1,state.funct[\"(verb)\"]=void 0,void 0;case\"(end)\":return error(\"E023\",state.tokens.next,\"}\"),void 0;default:if(indent+=state.option.indent,g)switch(state.tokens.curr.id){case\",\":return error(\"E040\"),void 0;case\":\":g=!1,statements();break;default:return error(\"E025\",state.tokens.curr),void 0}else{if(\":\"!==state.tokens.curr.id)return error(\"E021\",state.tokens.next,\"case\",state.tokens.next.value),void 0;advance(\":\"),error(\"E024\",state.tokens.curr,\":\"),statements()}indent-=state.option.indent}return this}).labelled=!0,stmt(\"debugger\",function(){return state.option.debug||warning(\"W087\",this),this}).exps=!0,function(){var x=stmt(\"do\",function(){state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,increaseComplexityCount(),this.first=block(!0,!0),advance(\"while\");var t=state.tokens.next;return advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1,this});x.labelled=!0,x.exps=!0}(),blockstmt(\"for\",function(){var s,t=state.tokens.next,letscope=!1,foreachtok=null;\"each\"===t.value&&(foreachtok=t,advance(\"each\"),state.inMoz()||warning(\"W118\",state.tokens.curr,\"for each\")),increaseComplexityCount(),advance(\"(\");var nextop,comma,initializer,i=0,inof=[\"in\",\"of\"],level=0;checkPunctuators(state.tokens.next,[\"{\",\"[\"])&&++level;do{if(nextop=peek(i),++i,checkPunctuators(nextop,[\"{\",\"[\"])?++level:checkPunctuators(nextop,[\"}\",\"]\"])&&--level,0>level)break;0===level&&(!comma&&checkPunctuator(nextop,\",\")?comma=nextop:!initializer&&checkPunctuator(nextop,\"=\")&&(initializer=nextop))}while(level>0||!_.contains(inof,nextop.value)&&\";\"!==nextop.value&&\"(end)\"!==nextop.type);if(_.contains(inof,nextop.value)){state.inES6()||\"of\"!==nextop.value||warning(\"W104\",nextop,\"for of\",\"6\");var ok=!(initializer||comma);if(initializer&&error(\"W133\",comma,nextop.value,\"initializer is forbidden\"),comma&&error(\"W133\",comma,nextop.value,\"more than one ForBinding\"),\"var\"===state.tokens.next.id?(advance(\"var\"),state.tokens.curr.fud({prefix:!0})):\"let\"===state.tokens.next.id||\"const\"===state.tokens.next.id?(advance(state.tokens.next.id),letscope=!0,state.funct[\"(scope)\"].stack(),state.tokens.curr.fud({prefix:!0})):Object.create(varstatement).fud({prefix:!0,implied:\"for\",ignore:!ok}),advance(nextop.value),expression(20),advance(\")\",t),\"in\"===nextop.value&&state.option.forin&&(state.forinifcheckneeded=!0,void 0===state.forinifchecks&&(state.forinifchecks=[]),state.forinifchecks.push({type:\"(none)\"})),state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,s=block(!0,!0),\"in\"===nextop.value&&state.option.forin){if(state.forinifchecks&&state.forinifchecks.length>0){var check=state.forinifchecks.pop();(s&&s.length>0&&(\"object\"!=typeof s[0]||\"if\"!==s[0].value)||\"(positive)\"===check.type&&s.length>1||\"(negative)\"===check.type)&&warning(\"W089\",this)}state.forinifcheckneeded=!1}state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1}else{if(foreachtok&&error(\"E045\",foreachtok),\";\"!==state.tokens.next.id)if(\"var\"===state.tokens.next.id)advance(\"var\"),state.tokens.curr.fud();else if(\"let\"===state.tokens.next.id)advance(\"let\"),letscope=!0,state.funct[\"(scope)\"].stack(),state.tokens.curr.fud();else for(;expression(0,\"for\"),\",\"===state.tokens.next.id;)comma();if(nolinebreak(state.tokens.curr),advance(\";\"),state.funct[\"(loopage)\"]+=1,\";\"!==state.tokens.next.id&&checkCondAssignment(expression(0)),nolinebreak(state.tokens.curr),advance(\";\"),\";\"===state.tokens.next.id&&error(\"E021\",state.tokens.next,\")\",\";\"),\")\"!==state.tokens.next.id)for(;expression(0,\"for\"),\",\"===state.tokens.next.id;)comma();advance(\")\",t),state.funct[\"(breakage)\"]+=1,block(!0,!0),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1}return letscope&&state.funct[\"(scope)\"].unstack(),this}).labelled=!0,stmt(\"break\",function(){var v=state.tokens.next.value;return state.option.asi||nolinebreak(this),\";\"===state.tokens.next.id||state.tokens.next.reach||state.tokens.curr.line!==startLine(state.tokens.next)?0===state.funct[\"(breakage)\"]&&warning(\"W052\",state.tokens.next,this.value):(state.funct[\"(scope)\"].funct.hasBreakLabel(v)||warning(\"W090\",state.tokens.next,v),this.first=state.tokens.next,advance()),reachable(this),this}).exps=!0,stmt(\"continue\",function(){var v=state.tokens.next.value;return 0===state.funct[\"(breakage)\"]&&warning(\"W052\",state.tokens.next,this.value),state.funct[\"(loopage)\"]||warning(\"W052\",state.tokens.next,this.value),state.option.asi||nolinebreak(this),\";\"===state.tokens.next.id||state.tokens.next.reach||state.tokens.curr.line===startLine(state.tokens.next)&&(state.funct[\"(scope)\"].funct.hasBreakLabel(v)||warning(\"W090\",state.tokens.next,v),this.first=state.tokens.next,advance()),reachable(this),this}).exps=!0,stmt(\"return\",function(){return this.line===startLine(state.tokens.next)?\";\"===state.tokens.next.id||state.tokens.next.reach||(this.first=expression(0),!this.first||\"(punctuator)\"!==this.first.type||\"=\"!==this.first.value||this.first.paren||state.option.boss||warningAt(\"W093\",this.first.line,this.first.character)):\"(punctuator)\"===state.tokens.next.type&&[\"[\",\"{\",\"+\",\"-\"].indexOf(state.tokens.next.value)>-1&&nolinebreak(this),reachable(this),this}).exps=!0,function(x){x.exps=!0,x.lbp=25}(prefix(\"yield\",function(){var prev=state.tokens.prev;state.inES6(!0)&&!state.funct[\"(generator)\"]?\"(catch)\"===state.funct[\"(name)\"]&&state.funct[\"(context)\"][\"(generator)\"]||error(\"E046\",state.tokens.curr,\"yield\"):state.inES6()||warning(\"W104\",state.tokens.curr,\"yield\",\"6\"),state.funct[\"(generator)\"]=\"yielded\";var delegatingYield=!1;return\"*\"===state.tokens.next.value&&(delegatingYield=!0,advance(\"*\")),this.line!==startLine(state.tokens.next)&&state.inMoz()?state.option.asi||nolinebreak(this):((delegatingYield||\";\"!==state.tokens.next.id&&!state.option.asi&&!state.tokens.next.reach&&state.tokens.next.nud)&&(nobreaknonadjacent(state.tokens.curr,state.tokens.next),this.first=expression(10),\"(punctuator)\"!==this.first.type||\"=\"!==this.first.value||this.first.paren||state.option.boss||warningAt(\"W093\",this.first.line,this.first.character)),state.inMoz()&&\")\"!==state.tokens.next.id&&(prev.lbp>30||!prev.assign&&!isEndOfExpr()||\"yield\"===prev.id)&&error(\"E050\",this)),this})),stmt(\"throw\",function(){return nolinebreak(this),this.first=expression(20),reachable(this),this}).exps=!0,stmt(\"import\",function(){if(state.inES6()||warning(\"W119\",state.tokens.curr,\"import\",\"6\"),\"(string)\"===state.tokens.next.type)return advance(\"(string)\"),this;if(state.tokens.next.identifier){if(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"const\",token:state.tokens.curr}),\",\"!==state.tokens.next.value)return advance(\"from\"),advance(\"(string)\"),this;advance(\",\")}if(\"*\"===state.tokens.next.id)advance(\"*\"),advance(\"as\"),state.tokens.next.identifier&&(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"const\",token:state.tokens.curr}));else for(advance(\"{\");;){if(\"}\"===state.tokens.next.value){advance(\"}\");break}var importName;if(\"default\"===state.tokens.next.type?(importName=\"default\",advance(\"default\")):importName=identifier(),\"as\"===state.tokens.next.value&&(advance(\"as\"),importName=identifier()),state.funct[\"(scope)\"].addlabel(importName,{type:\"const\",token:state.tokens.curr}),\",\"!==state.tokens.next.value){if(\"}\"===state.tokens.next.value){advance(\"}\");break}error(\"E024\",state.tokens.next,state.tokens.next.value);break}advance(\",\")}return advance(\"from\"),advance(\"(string)\"),this}).exps=!0,stmt(\"export\",function(){var token,identifier,ok=!0;if(state.inES6()||(warning(\"W119\",state.tokens.curr,\"export\",\"6\"),ok=!1),state.funct[\"(scope)\"].block.isGlobal()||(error(\"E053\",state.tokens.curr),ok=!1),\"*\"===state.tokens.next.value)return advance(\"*\"),advance(\"from\"),advance(\"(string)\"),this;if(\"default\"===state.tokens.next.type){state.nameStack.set(state.tokens.next),advance(\"default\");var exportType=state.tokens.next.id;return(\"function\"===exportType||\"class\"===exportType)&&(this.block=!0),token=peek(),expression(10),identifier=token.value,this.block&&(state.funct[\"(scope)\"].addlabel(identifier,{type:exportType,token:token}),state.funct[\"(scope)\"].setExported(identifier,token)),this}if(\"{\"===state.tokens.next.value){advance(\"{\");for(var exportedTokens=[];;){if(state.tokens.next.identifier||error(\"E030\",state.tokens.next,state.tokens.next.value),advance(),exportedTokens.push(state.tokens.curr),\"as\"===state.tokens.next.value&&(advance(\"as\"),state.tokens.next.identifier||error(\"E030\",state.tokens.next,state.tokens.next.value),advance()),\",\"!==state.tokens.next.value){if(\"}\"===state.tokens.next.value){advance(\"}\");break}error(\"E024\",state.tokens.next,state.tokens.next.value);break}advance(\",\")}return\"from\"===state.tokens.next.value?(advance(\"from\"),advance(\"(string)\")):ok&&exportedTokens.forEach(function(token){state.funct[\"(scope)\"].setExported(token.value,token)}),this}if(\"var\"===state.tokens.next.id)advance(\"var\"),state.tokens.curr.fud({inexport:!0});else if(\"let\"===state.tokens.next.id)advance(\"let\"),state.tokens.curr.fud({inexport:!0});else if(\"const\"===state.tokens.next.id)advance(\"const\"),state.tokens.curr.fud({inexport:!0});else if(\"function\"===state.tokens.next.id)this.block=!0,advance(\"function\"),state.syntax[\"function\"].fud({inexport:!0});else if(\"class\"===state.tokens.next.id){this.block=!0,advance(\"class\");var classNameToken=state.tokens.next;state.syntax[\"class\"].fud(),state.funct[\"(scope)\"].setExported(classNameToken.value,classNameToken)}else error(\"E024\",state.tokens.next,state.tokens.next.value);return this}).exps=!0,FutureReservedWord(\"abstract\"),FutureReservedWord(\"boolean\"),FutureReservedWord(\"byte\"),FutureReservedWord(\"char\"),FutureReservedWord(\"class\",{es5:!0,nud:classdef}),FutureReservedWord(\"double\"),FutureReservedWord(\"enum\",{es5:!0}),FutureReservedWord(\"export\",{es5:!0}),FutureReservedWord(\"extends\",{es5:!0}),FutureReservedWord(\"final\"),FutureReservedWord(\"float\"),FutureReservedWord(\"goto\"),FutureReservedWord(\"implements\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"import\",{es5:!0}),FutureReservedWord(\"int\"),FutureReservedWord(\"interface\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"long\"),FutureReservedWord(\"native\"),FutureReservedWord(\"package\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"private\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"protected\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"public\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"short\"),FutureReservedWord(\"static\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"super\",{es5:!0}),FutureReservedWord(\"synchronized\"),FutureReservedWord(\"transient\"),FutureReservedWord(\"volatile\");var lookupBlockType=function(){var pn,pn1,prev,i=-1,bracketStack=0,ret={};checkPunctuators(state.tokens.curr,[\"[\",\"{\"])&&(bracketStack+=1);do{if(prev=-1===i?state.tokens.curr:pn,pn=-1===i?state.tokens.next:peek(i),pn1=peek(i+1),i+=1,checkPunctuators(pn,[\"[\",\"{\"])?bracketStack+=1:checkPunctuators(pn,[\"]\",\"}\"])&&(bracketStack-=1),1===bracketStack&&pn.identifier&&\"for\"===pn.value&&!checkPunctuator(prev,\".\")){ret.isCompArray=!0,ret.notJson=!0;break}if(0===bracketStack&&checkPunctuators(pn,[\"}\",\"]\"])){if(\"=\"===pn1.value){ret.isDestAssign=!0,ret.notJson=!0;break}if(\".\"===pn1.value){ret.notJson=!0;break}}checkPunctuator(pn,\";\")&&(ret.isBlock=!0,ret.notJson=!0)}while(bracketStack>0&&\"(end)\"!==pn.id);return ret},arrayComprehension=function(){function declare(v){var l=_current.variables.filter(function(elt){return elt.value===v?(elt.undef=!1,v):void 0}).length;return 0!==l}function use(v){var l=_current.variables.filter(function(elt){return elt.value!==v||elt.undef?void 0:(elt.unused===!0&&(elt.unused=!1),v)}).length;return 0===l}var _current,CompArray=function(){this.mode=\"use\",this.variables=[]},_carrays=[];return{stack:function(){_current=new CompArray,_carrays.push(_current)},unstack:function(){_current.variables.filter(function(v){v.unused&&warning(\"W098\",v.token,v.raw_text||v.value),v.undef&&state.funct[\"(scope)\"].block.use(v.value,v.token)}),_carrays.splice(-1,1),_current=_carrays[_carrays.length-1]},setState:function(s){_.contains([\"use\",\"define\",\"generate\",\"filter\"],s)&&(_current.mode=s)},check:function(v){return _current?_current&&\"use\"===_current.mode?(use(v)&&_current.variables.push({funct:state.funct,token:state.tokens.curr,value:v,undef:!0,unused:!1}),!0):_current&&\"define\"===_current.mode?(declare(v)||_current.variables.push({funct:state.funct,token:state.tokens.curr,value:v,undef:!1,unused:!0}),!0):_current&&\"generate\"===_current.mode?(state.funct[\"(scope)\"].block.use(v,state.tokens.curr),!0):_current&&\"filter\"===_current.mode?(use(v)&&state.funct[\"(scope)\"].block.use(v,state.tokens.curr),!0):!1:void 0}}},escapeRegex=function(str){return str.replace(/[-\\/\\\\^$*+?.()|[\\]{}]/g,\"\\\\$&\")},itself=function(s,o,g){function each(obj,cb){obj&&(Array.isArray(obj)||\"object\"!=typeof obj||(obj=Object.keys(obj)),obj.forEach(cb))}var i,k,x,reIgnoreStr,reIgnore,optionKeys,newOptionObj={},newIgnoredObj={};o=_.clone(o),state.reset(),o&&o.scope?JSHINT.scope=o.scope:(JSHINT.errors=[],JSHINT.undefs=[],JSHINT.internals=[],JSHINT.blacklist={},JSHINT.scope=\"(main)\"),predefined=Object.create(null),combine(predefined,vars.ecmaIdentifiers[3]),combine(predefined,vars.reservedVars),combine(predefined,g||{}),declared=Object.create(null);var exported=Object.create(null);if(o)for(each(o.predef||null,function(item){var slice,prop;\"-\"===item[0]?(slice=item.slice(1),JSHINT.blacklist[slice]=slice,delete predefined[slice]):(prop=Object.getOwnPropertyDescriptor(o.predef,item),predefined[item]=prop?prop.value:!1)}),each(o.exported||null,function(item){exported[item]=!0}),delete o.predef,delete o.exported,optionKeys=Object.keys(o),x=0;optionKeys.length>x;x++)if(/^-W\\d{3}$/g.test(optionKeys[x]))newIgnoredObj[optionKeys[x].slice(1)]=!0;else{var optionKey=optionKeys[x];newOptionObj[optionKey]=o[optionKey],(\"esversion\"===optionKey&&5===o[optionKey]||\"es5\"===optionKey&&o[optionKey])&&warning(\"I003\"),\"newcap\"===optionKeys[x]&&o[optionKey]===!1&&(newOptionObj[\"(explicitNewcap)\"]=!0)}state.option=newOptionObj,state.ignored=newIgnoredObj,state.option.indent=state.option.indent||4,state.option.maxerr=state.option.maxerr||50,indent=1;var scopeManagerInst=scopeManager(state,predefined,exported,declared);if(scopeManagerInst.on(\"warning\",function(ev){warning.apply(null,[ev.code,ev.token].concat(ev.data))}),scopeManagerInst.on(\"error\",function(ev){error.apply(null,[ev.code,ev.token].concat(ev.data))}),state.funct=functor(\"(global)\",null,{\"(global)\":!0,\"(scope)\":scopeManagerInst,\"(comparray)\":arrayComprehension(),\"(metrics)\":createMetrics(state.tokens.next)}),functions=[state.funct],urls=[],stack=null,member={},membersOnly=null,inblock=!1,lookahead=[],!isString(s)&&!Array.isArray(s))return errorAt(\"E004\",0),!1;api={get isJSON(){return state.jsonMode},getOption:function(name){return state.option[name]||null},getCache:function(name){return state.cache[name]},setCache:function(name,value){state.cache[name]=value},warn:function(code,data){warningAt.apply(null,[code,data.line,data.char].concat(data.data))},on:function(names,listener){names.split(\" \").forEach(function(name){emitter.on(name,listener)}.bind(this))}},emitter.removeAllListeners(),(extraModules||[]).forEach(function(func){func(api)}),state.tokens.prev=state.tokens.curr=state.tokens.next=state.syntax[\"(begin)\"],o&&o.ignoreDelimiters&&(Array.isArray(o.ignoreDelimiters)||(o.ignoreDelimiters=[o.ignoreDelimiters]),o.ignoreDelimiters.forEach(function(delimiterPair){delimiterPair.start&&delimiterPair.end&&(reIgnoreStr=escapeRegex(delimiterPair.start)+\"[\\\\s\\\\S]*?\"+escapeRegex(delimiterPair.end),reIgnore=RegExp(reIgnoreStr,\"ig\"),s=s.replace(reIgnore,function(match){return match.replace(/./g,\" \")}))})),lex=new Lexer(s),lex.on(\"warning\",function(ev){warningAt.apply(null,[ev.code,ev.line,ev.character].concat(ev.data))}),lex.on(\"error\",function(ev){errorAt.apply(null,[ev.code,ev.line,ev.character].concat(ev.data))}),lex.on(\"fatal\",function(ev){quit(\"E041\",ev.line,ev.from)}),lex.on(\"Identifier\",function(ev){emitter.emit(\"Identifier\",ev)}),lex.on(\"String\",function(ev){emitter.emit(\"String\",ev)}),lex.on(\"Number\",function(ev){emitter.emit(\"Number\",ev)}),lex.start();for(var name in o)_.has(o,name)&&checkOption(name,state.tokens.curr);assume(),combine(predefined,g||{}),comma.first=!0;try{switch(advance(),state.tokens.next.id){case\"{\":case\"[\":destructuringAssignOrJsonValue();break;default:directives(),state.directive[\"use strict\"]&&\"global\"!==state.option.strict&&warning(\"W097\",state.tokens.prev),statements()}\"(end)\"!==state.tokens.next.id&&quit(\"E041\",state.tokens.curr.line),state.funct[\"(scope)\"].unstack()}catch(err){if(!err||\"JSHintError\"!==err.name)throw err;var nt=state.tokens.next||{};JSHINT.errors.push({scope:\"(main)\",raw:err.raw,code:err.code,reason:err.message,line:err.line||nt.line,character:err.character||nt.from},null)}if(\"(main)\"===JSHINT.scope)for(o=o||{},i=0;JSHINT.internals.length>i;i+=1)k=JSHINT.internals[i],o.scope=k.elem,itself(k.value,o,g);return 0===JSHINT.errors.length};return itself.addModule=function(func){extraModules.push(func)},itself.addModule(style.register),itself.data=function(){var fu,f,i,j,n,globals,data={functions:[],options:state.option};itself.errors.length&&(data.errors=itself.errors),state.jsonMode&&(data.json=!0);var impliedGlobals=state.funct[\"(scope)\"].getImpliedGlobals();for(impliedGlobals.length>0&&(data.implieds=impliedGlobals),urls.length>0&&(data.urls=urls),globals=state.funct[\"(scope)\"].getUsedOrDefinedGlobals(),globals.length>0&&(data.globals=globals),i=1;functions.length>i;i+=1){for(f=functions[i],fu={},j=0;functionicity.length>j;j+=1)fu[functionicity[j]]=[];for(j=0;functionicity.length>j;j+=1)0===fu[functionicity[j]].length&&delete fu[functionicity[j]];fu.name=f[\"(name)\"],fu.param=f[\"(params)\"],fu.line=f[\"(line)\"],fu.character=f[\"(character)\"],fu.last=f[\"(last)\"],fu.lastcharacter=f[\"(lastcharacter)\"],fu.metrics={complexity:f[\"(metrics)\"].ComplexityCount,parameters:f[\"(metrics)\"].arity,statements:f[\"(metrics)\"].statementCount},data.functions.push(fu)}var unuseds=state.funct[\"(scope)\"].getUnuseds();unuseds.length>0&&(data.unused=unuseds);for(n in member)if(\"number\"==typeof member[n]){data.member=member;break}return data},itself.jshint=itself,itself}();\"object\"==typeof exports&&exports&&(exports.JSHINT=JSHINT)},{\"../lodash\":\"/node_modules/jshint/lodash.js\",\"./lex.js\":\"/node_modules/jshint/src/lex.js\",\"./messages.js\":\"/node_modules/jshint/src/messages.js\",\"./options.js\":\"/node_modules/jshint/src/options.js\",\"./reg.js\":\"/node_modules/jshint/src/reg.js\",\"./scope-manager.js\":\"/node_modules/jshint/src/scope-manager.js\",\"./state.js\":\"/node_modules/jshint/src/state.js\",\"./style.js\":\"/node_modules/jshint/src/style.js\",\"./vars.js\":\"/node_modules/jshint/src/vars.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/lex.js\":[function(_dereq_,module,exports){\"use strict\";function asyncTrigger(){var _checks=[];return{push:function(fn){_checks.push(fn)},check:function(){for(var check=0;_checks.length>check;++check)_checks[check]();_checks.splice(0,_checks.length)}}}function Lexer(source){var lines=source;\"string\"==typeof lines&&(lines=lines.replace(/\\r\\n/g,\"\\n\").replace(/\\r/g,\"\\n\").split(\"\\n\")),lines[0]&&\"#!\"===lines[0].substr(0,2)&&(-1!==lines[0].indexOf(\"node\")&&(state.option.node=!0),lines[0]=\"\"),this.emitter=new events.EventEmitter,this.source=source,this.setLines(lines),this.prereg=!0,this.line=0,this.char=1,this.from=1,this.input=\"\",this.inComment=!1,this.context=[],this.templateStarts=[];for(var i=0;state.option.indent>i;i+=1)state.tab+=\" \";this.ignoreLinterErrors=!1}var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),reg=_dereq_(\"./reg.js\"),state=_dereq_(\"./state.js\").state,unicodeData=_dereq_(\"../data/ascii-identifier-data.js\"),asciiIdentifierStartTable=unicodeData.asciiIdentifierStartTable,asciiIdentifierPartTable=unicodeData.asciiIdentifierPartTable,Token={Identifier:1,Punctuator:2,NumericLiteral:3,StringLiteral:4,Comment:5,Keyword:6,NullLiteral:7,BooleanLiteral:8,RegExp:9,TemplateHead:10,TemplateMiddle:11,TemplateTail:12,NoSubstTemplate:13},Context={Block:1,Template:2};Lexer.prototype={_lines:[],inContext:function(ctxType){return this.context.length>0&&this.context[this.context.length-1].type===ctxType},pushContext:function(ctxType){this.context.push({type:ctxType})},popContext:function(){return this.context.pop()},isContext:function(context){return this.context.length>0&&this.context[this.context.length-1]===context},currentContext:function(){return this.context.length>0&&this.context[this.context.length-1]},getLines:function(){return this._lines=state.lines,this._lines},setLines:function(val){this._lines=val,state.lines=this._lines},peek:function(i){return this.input.charAt(i||0)},skip:function(i){i=i||1,this.char+=i,this.input=this.input.slice(i)},on:function(names,listener){names.split(\" \").forEach(function(name){this.emitter.on(name,listener)}.bind(this))},trigger:function(){this.emitter.emit.apply(this.emitter,Array.prototype.slice.call(arguments))},triggerAsync:function(type,args,checks,fn){checks.push(function(){fn()&&this.trigger(type,args)}.bind(this))},scanPunctuator:function(){var ch2,ch3,ch4,ch1=this.peek();switch(ch1){case\".\":if(/^[0-9]$/.test(this.peek(1)))return null;if(\".\"===this.peek(1)&&\".\"===this.peek(2))return{type:Token.Punctuator,value:\"...\"};case\"(\":case\")\":case\";\":case\",\":case\"[\":case\"]\":case\":\":case\"~\":case\"?\":return{type:Token.Punctuator,value:ch1};case\"{\":return this.pushContext(Context.Block),{type:Token.Punctuator,value:ch1};case\"}\":return this.inContext(Context.Block)&&this.popContext(),{type:Token.Punctuator,value:ch1};case\"#\":return{type:Token.Punctuator,value:ch1};case\"\":return null}return ch2=this.peek(1),ch3=this.peek(2),ch4=this.peek(3),\">\"===ch1&&\">\"===ch2&&\">\"===ch3&&\"=\"===ch4?{type:Token.Punctuator,value:\">>>=\"}:\"=\"===ch1&&\"=\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"===\"}:\"!\"===ch1&&\"=\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"!==\"}:\">\"===ch1&&\">\"===ch2&&\">\"===ch3?{type:Token.Punctuator,value:\">>>\"}:\"<\"===ch1&&\"<\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"<<=\"}:\">\"===ch1&&\">\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\">>=\"}:\"=\"===ch1&&\">\"===ch2?{type:Token.Punctuator,value:ch1+ch2}:ch1===ch2&&\"+-<>&|\".indexOf(ch1)>=0?{type:Token.Punctuator,value:ch1+ch2}:\"<>=!+-*%&|^\".indexOf(ch1)>=0?\"=\"===ch2?{type:Token.Punctuator,value:ch1+ch2}:{type:Token.Punctuator,value:ch1}:\"/\"===ch1?\"=\"===ch2?{type:Token.Punctuator,value:\"/=\"}:{type:Token.Punctuator,value:\"/\"}:null},scanComments:function(){function commentToken(label,body,opt){var special=[\"jshint\",\"jslint\",\"members\",\"member\",\"globals\",\"global\",\"exported\"],isSpecial=!1,value=label+body,commentType=\"plain\";return opt=opt||{},opt.isMultiline&&(value+=\"*/\"),body=body.replace(/\\n/g,\" \"),\"/*\"===label&&reg.fallsThrough.test(body)&&(isSpecial=!0,commentType=\"falls through\"),special.forEach(function(str){if(!isSpecial&&(\"//\"!==label||\"jshint\"===str)&&(\" \"===body.charAt(str.length)&&body.substr(0,str.length)===str&&(isSpecial=!0,label+=str,body=body.substr(str.length)),isSpecial||\" \"!==body.charAt(0)||\" \"!==body.charAt(str.length+1)||body.substr(1,str.length)!==str||(isSpecial=!0,label=label+\" \"+str,body=body.substr(str.length+1)),isSpecial))switch(str){case\"member\":commentType=\"members\";break;case\"global\":commentType=\"globals\";break;default:var options=body.split(\":\").map(function(v){return v.replace(/^\\s+/,\"\").replace(/\\s+$/,\"\")});if(2===options.length)switch(options[0]){case\"ignore\":switch(options[1]){case\"start\":self.ignoringLinterErrors=!0,isSpecial=!1;break;case\"end\":self.ignoringLinterErrors=!1,isSpecial=!1}}commentType=str}}),{type:Token.Comment,commentType:commentType,value:value,body:body,isSpecial:isSpecial,isMultiline:opt.isMultiline||!1,isMalformed:opt.isMalformed||!1}}var ch1=this.peek(),ch2=this.peek(1),rest=this.input.substr(2),startLine=this.line,startChar=this.char,self=this;if(\"*\"===ch1&&\"/\"===ch2)return this.trigger(\"error\",{code:\"E018\",line:startLine,character:startChar}),this.skip(2),null;if(\"/\"!==ch1||\"*\"!==ch2&&\"/\"!==ch2)return null;if(\"/\"===ch2)return this.skip(this.input.length),commentToken(\"//\",rest);var body=\"\";if(\"*\"===ch2){for(this.inComment=!0,this.skip(2);\"*\"!==this.peek()||\"/\"!==this.peek(1);)if(\"\"===this.peek()){if(body+=\"\\n\",!this.nextLine())return this.trigger(\"error\",{code:\"E017\",line:startLine,character:startChar}),this.inComment=!1,commentToken(\"/*\",body,{isMultiline:!0,isMalformed:!0})}else body+=this.peek(),this.skip();return this.skip(2),this.inComment=!1,commentToken(\"/*\",body,{isMultiline:!0})}},scanKeyword:function(){var result=/^[a-zA-Z_$][a-zA-Z0-9_$]*/.exec(this.input),keywords=[\"if\",\"in\",\"do\",\"var\",\"for\",\"new\",\"try\",\"let\",\"this\",\"else\",\"case\",\"void\",\"with\",\"enum\",\"while\",\"break\",\"catch\",\"throw\",\"const\",\"yield\",\"class\",\"super\",\"return\",\"typeof\",\"delete\",\"switch\",\"export\",\"import\",\"default\",\"finally\",\"extends\",\"function\",\"continue\",\"debugger\",\"instanceof\"];return result&&keywords.indexOf(result[0])>=0?{type:Token.Keyword,value:result[0]}:null},scanIdentifier:function(){function isNonAsciiIdentifierStart(code){return code>256}function isNonAsciiIdentifierPart(code){return code>256}function isHexDigit(str){return/^[0-9a-fA-F]$/.test(str)}function removeEscapeSequences(id){return id.replace(/\\\\u([0-9a-fA-F]{4})/g,function(m0,codepoint){return String.fromCharCode(parseInt(codepoint,16))})}var type,char,id=\"\",index=0,readUnicodeEscapeSequence=function(){if(index+=1,\"u\"!==this.peek(index))return null;var code,ch1=this.peek(index+1),ch2=this.peek(index+2),ch3=this.peek(index+3),ch4=this.peek(index+4);return isHexDigit(ch1)&&isHexDigit(ch2)&&isHexDigit(ch3)&&isHexDigit(ch4)?(code=parseInt(ch1+ch2+ch3+ch4,16),asciiIdentifierPartTable[code]||isNonAsciiIdentifierPart(code)?(index+=5,\"\\\\u\"+ch1+ch2+ch3+ch4):null):null}.bind(this),getIdentifierStart=function(){var chr=this.peek(index),code=chr.charCodeAt(0);return 92===code?readUnicodeEscapeSequence():128>code?asciiIdentifierStartTable[code]?(index+=1,chr):null:isNonAsciiIdentifierStart(code)?(index+=1,chr):null}.bind(this),getIdentifierPart=function(){var chr=this.peek(index),code=chr.charCodeAt(0);return 92===code?readUnicodeEscapeSequence():128>code?asciiIdentifierPartTable[code]?(index+=1,chr):null:isNonAsciiIdentifierPart(code)?(index+=1,chr):null}.bind(this);if(char=getIdentifierStart(),null===char)return null;for(id=char;char=getIdentifierPart(),null!==char;)id+=char;switch(id){case\"true\":case\"false\":type=Token.BooleanLiteral;break;case\"null\":type=Token.NullLiteral;break;default:type=Token.Identifier}return{type:type,value:removeEscapeSequences(id),text:id,tokenLength:id.length}},scanNumericLiteral:function(){function isDecimalDigit(str){return/^[0-9]$/.test(str)}function isOctalDigit(str){return/^[0-7]$/.test(str)}function isBinaryDigit(str){return/^[01]$/.test(str)}function isHexDigit(str){return/^[0-9a-fA-F]$/.test(str)}function isIdentifierStart(ch){return\"$\"===ch||\"_\"===ch||\"\\\\\"===ch||ch>=\"a\"&&\"z\">=ch||ch>=\"A\"&&\"Z\">=ch}var bad,index=0,value=\"\",length=this.input.length,char=this.peek(index),isAllowedDigit=isDecimalDigit,base=10,isLegacy=!1;if(\".\"!==char&&!isDecimalDigit(char))return null;if(\".\"!==char){for(value=this.peek(index),index+=1,char=this.peek(index),\"0\"===value&&((\"x\"===char||\"X\"===char)&&(isAllowedDigit=isHexDigit,base=16,index+=1,value+=char),(\"o\"===char||\"O\"===char)&&(isAllowedDigit=isOctalDigit,base=8,state.inES6(!0)||this.trigger(\"warning\",{code:\"W119\",line:this.line,character:this.char,data:[\"Octal integer literal\",\"6\"]}),index+=1,value+=char),(\"b\"===char||\"B\"===char)&&(isAllowedDigit=isBinaryDigit,base=2,state.inES6(!0)||this.trigger(\"warning\",{code:\"W119\",line:this.line,character:this.char,data:[\"Binary integer literal\",\"6\"]}),index+=1,value+=char),isOctalDigit(char)&&(isAllowedDigit=isOctalDigit,base=8,isLegacy=!0,bad=!1,index+=1,value+=char),!isOctalDigit(char)&&isDecimalDigit(char)&&(index+=1,value+=char));length>index;){if(char=this.peek(index),isLegacy&&isDecimalDigit(char))bad=!0;else if(!isAllowedDigit(char))break;value+=char,index+=1}if(isAllowedDigit!==isDecimalDigit)return!isLegacy&&2>=value.length?{type:Token.NumericLiteral,value:value,isMalformed:!0}:length>index&&(char=this.peek(index),isIdentifierStart(char))?null:{type:Token.NumericLiteral,value:value,base:base,isLegacy:isLegacy,isMalformed:!1}}if(\".\"===char)for(value+=char,index+=1;length>index&&(char=this.peek(index),isDecimalDigit(char));)value+=char,index+=1;if(\"e\"===char||\"E\"===char){if(value+=char,index+=1,char=this.peek(index),(\"+\"===char||\"-\"===char)&&(value+=this.peek(index),index+=1),char=this.peek(index),!isDecimalDigit(char))return null;for(value+=char,index+=1;length>index&&(char=this.peek(index),isDecimalDigit(char));)value+=char,index+=1}return length>index&&(char=this.peek(index),isIdentifierStart(char))?null:{type:Token.NumericLiteral,value:value,base:base,isMalformed:!isFinite(value)}},scanEscapeSequence:function(checks){var allowNewLine=!1,jump=1;this.skip();var char=this.peek();switch(char){case\"'\":this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\'\"]},checks,function(){return state.jsonMode});break;case\"b\":char=\"\\\\b\";break;case\"f\":char=\"\\\\f\";break;case\"n\":char=\"\\\\n\";break;case\"r\":char=\"\\\\r\";break;case\"t\":char=\"\\\\t\";break;case\"0\":char=\"\\\\0\";var n=parseInt(this.peek(1),10);this.triggerAsync(\"warning\",{code:\"W115\",line:this.line,character:this.char},checks,function(){return n>=0&&7>=n&&state.isStrict()});break;case\"u\":var hexCode=this.input.substr(1,4),code=parseInt(hexCode,16);isNaN(code)&&this.trigger(\"warning\",{code:\"W052\",line:this.line,character:this.char,data:[\"u\"+hexCode]}),char=String.fromCharCode(code),jump=5;break;case\"v\":this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\v\"]},checks,function(){return state.jsonMode}),char=\"\u000b\";break;case\"x\":var x=parseInt(this.input.substr(1,2),16);this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\x-\"]},checks,function(){return state.jsonMode}),char=String.fromCharCode(x),jump=3;break;case\"\\\\\":char=\"\\\\\\\\\";break;case'\"':char='\\\\\"';break;case\"/\":break;case\"\":allowNewLine=!0,char=\"\"}return{\"char\":char,jump:jump,allowNewLine:allowNewLine}},scanTemplateLiteral:function(checks){var tokenType,ch,value=\"\",startLine=this.line,startChar=this.char,depth=this.templateStarts.length;if(!state.inES6(!0))return null;if(\"`\"===this.peek())tokenType=Token.TemplateHead,this.templateStarts.push({line:this.line,\"char\":this.char}),depth=this.templateStarts.length,this.skip(1),this.pushContext(Context.Template);else{if(!this.inContext(Context.Template)||\"}\"!==this.peek())return null;tokenType=Token.TemplateMiddle}for(;\"`\"!==this.peek();){for(;\"\"===(ch=this.peek());)if(value+=\"\\n\",!this.nextLine()){var startPos=this.templateStarts.pop();return this.trigger(\"error\",{code:\"E052\",line:startPos.line,character:startPos.char}),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!0,depth:depth,context:this.popContext()}}if(\"$\"===ch&&\"{\"===this.peek(1))return value+=\"${\",this.skip(2),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,depth:depth,context:this.currentContext()};\nif(\"\\\\\"===ch){var escape=this.scanEscapeSequence(checks);value+=escape.char,this.skip(escape.jump)}else\"`\"!==ch&&(value+=ch,this.skip(1))}return tokenType=tokenType===Token.TemplateHead?Token.NoSubstTemplate:Token.TemplateTail,this.skip(1),this.templateStarts.pop(),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,depth:depth,context:this.popContext()}},scanStringLiteral:function(checks){var quote=this.peek();if('\"'!==quote&&\"'\"!==quote)return null;this.triggerAsync(\"warning\",{code:\"W108\",line:this.line,character:this.char},checks,function(){return state.jsonMode&&'\"'!==quote});var value=\"\",startLine=this.line,startChar=this.char,allowNewLine=!1;for(this.skip();this.peek()!==quote;)if(\"\"===this.peek()){if(allowNewLine?(allowNewLine=!1,this.triggerAsync(\"warning\",{code:\"W043\",line:this.line,character:this.char},checks,function(){return!state.option.multistr}),this.triggerAsync(\"warning\",{code:\"W042\",line:this.line,character:this.char},checks,function(){return state.jsonMode&&state.option.multistr})):this.trigger(\"warning\",{code:\"W112\",line:this.line,character:this.char}),!this.nextLine())return this.trigger(\"error\",{code:\"E029\",line:startLine,character:startChar}),{type:Token.StringLiteral,value:value,startLine:startLine,startChar:startChar,isUnclosed:!0,quote:quote}}else{allowNewLine=!1;var char=this.peek(),jump=1;if(\" \">char&&this.trigger(\"warning\",{code:\"W113\",line:this.line,character:this.char,data:[\"<non-printable>\"]}),\"\\\\\"===char){var parsed=this.scanEscapeSequence(checks);char=parsed.char,jump=parsed.jump,allowNewLine=parsed.allowNewLine}value+=char,this.skip(jump)}return this.skip(),{type:Token.StringLiteral,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,quote:quote}},scanRegExp:function(){var terminated,index=0,length=this.input.length,char=this.peek(),value=char,body=\"\",flags=[],malformed=!1,isCharSet=!1,scanUnexpectedChars=function(){\" \">char&&(malformed=!0,this.trigger(\"warning\",{code:\"W048\",line:this.line,character:this.char})),\"<\"===char&&(malformed=!0,this.trigger(\"warning\",{code:\"W049\",line:this.line,character:this.char,data:[char]}))}.bind(this);if(!this.prereg||\"/\"!==char)return null;for(index+=1,terminated=!1;length>index;)if(char=this.peek(index),value+=char,body+=char,isCharSet)\"]\"===char&&(\"\\\\\"!==this.peek(index-1)||\"\\\\\"===this.peek(index-2))&&(isCharSet=!1),\"\\\\\"===char&&(index+=1,char=this.peek(index),body+=char,value+=char,scanUnexpectedChars()),index+=1;else{if(\"\\\\\"===char){if(index+=1,char=this.peek(index),body+=char,value+=char,scanUnexpectedChars(),\"/\"===char){index+=1;continue}if(\"[\"===char){index+=1;continue}}if(\"[\"!==char){if(\"/\"===char){body=body.substr(0,body.length-1),terminated=!0,index+=1;break}index+=1}else isCharSet=!0,index+=1}if(!terminated)return this.trigger(\"error\",{code:\"E015\",line:this.line,character:this.from}),void this.trigger(\"fatal\",{line:this.line,from:this.from});for(;length>index&&(char=this.peek(index),/[gim]/.test(char));)flags.push(char),value+=char,index+=1;try{RegExp(body,flags.join(\"\"))}catch(err){malformed=!0,this.trigger(\"error\",{code:\"E016\",line:this.line,character:this.char,data:[err.message]})}return{type:Token.RegExp,value:value,flags:flags,isMalformed:malformed}},scanNonBreakingSpaces:function(){return state.option.nonbsp?this.input.search(/(\\u00A0)/):-1},scanUnsafeChars:function(){return this.input.search(reg.unsafeChars)},next:function(checks){this.from=this.char;var start;if(/\\s/.test(this.peek()))for(start=this.char;/\\s/.test(this.peek());)this.from+=1,this.skip();var match=this.scanComments()||this.scanStringLiteral(checks)||this.scanTemplateLiteral(checks);return match?match:(match=this.scanRegExp()||this.scanPunctuator()||this.scanKeyword()||this.scanIdentifier()||this.scanNumericLiteral(),match?(this.skip(match.tokenLength||match.value.length),match):null)},nextLine:function(){var char;if(this.line>=this.getLines().length)return!1;this.input=this.getLines()[this.line],this.line+=1,this.char=1,this.from=1;var inputTrimmed=this.input.trim(),startsWith=function(){return _.some(arguments,function(prefix){return 0===inputTrimmed.indexOf(prefix)})},endsWith=function(){return _.some(arguments,function(suffix){return-1!==inputTrimmed.indexOf(suffix,inputTrimmed.length-suffix.length)})};if(this.ignoringLinterErrors===!0&&(startsWith(\"/*\",\"//\")||this.inComment&&endsWith(\"*/\")||(this.input=\"\")),char=this.scanNonBreakingSpaces(),char>=0&&this.trigger(\"warning\",{code:\"W125\",line:this.line,character:char+1}),this.input=this.input.replace(/\\t/g,state.tab),char=this.scanUnsafeChars(),char>=0&&this.trigger(\"warning\",{code:\"W100\",line:this.line,character:char}),!this.ignoringLinterErrors&&state.option.maxlen&&state.option.maxlen<this.input.length){var inComment=this.inComment||startsWith.call(inputTrimmed,\"//\")||startsWith.call(inputTrimmed,\"/*\"),shouldTriggerError=!inComment||!reg.maxlenException.test(inputTrimmed);shouldTriggerError&&this.trigger(\"warning\",{code:\"W101\",line:this.line,character:this.input.length})}return!0},start:function(){this.nextLine()},token:function(){function isReserved(token,isProperty){if(!token.reserved)return!1;var meta=token.meta;if(meta&&meta.isFutureReservedWord&&state.inES5()){if(!meta.es5)return!1;if(meta.strictOnly&&!state.option.strict&&!state.isStrict())return!1;if(isProperty)return!1}return!0}for(var token,checks=asyncTrigger(),create=function(type,value,isProperty,token){var obj;if(\"(endline)\"!==type&&\"(end)\"!==type&&(this.prereg=!1),\"(punctuator)\"===type){switch(value){case\".\":case\")\":case\"~\":case\"#\":case\"]\":case\"++\":case\"--\":this.prereg=!1;break;default:this.prereg=!0}obj=Object.create(state.syntax[value]||state.syntax[\"(error)\"])}return\"(identifier)\"===type&&((\"return\"===value||\"case\"===value||\"typeof\"===value)&&(this.prereg=!0),_.has(state.syntax,value)&&(obj=Object.create(state.syntax[value]||state.syntax[\"(error)\"]),isReserved(obj,isProperty&&\"(identifier)\"===type)||(obj=null))),obj||(obj=Object.create(state.syntax[type])),obj.identifier=\"(identifier)\"===type,obj.type=obj.type||type,obj.value=value,obj.line=this.line,obj.character=this.char,obj.from=this.from,obj.identifier&&token&&(obj.raw_text=token.text||token.value),token&&token.startLine&&token.startLine!==this.line&&(obj.startLine=token.startLine),token&&token.context&&(obj.context=token.context),token&&token.depth&&(obj.depth=token.depth),token&&token.isUnclosed&&(obj.isUnclosed=token.isUnclosed),isProperty&&obj.identifier&&(obj.isProperty=isProperty),obj.check=checks.check,obj}.bind(this);;){if(!this.input.length)return this.nextLine()?create(\"(endline)\",\"\"):this.exhausted?null:(this.exhausted=!0,create(\"(end)\",\"\"));if(token=this.next(checks))switch(token.type){case Token.StringLiteral:return this.triggerAsync(\"String\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value,quote:token.quote},checks,function(){return!0}),create(\"(string)\",token.value,null,token);case Token.TemplateHead:return this.trigger(\"TemplateHead\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template)\",token.value,null,token);case Token.TemplateMiddle:return this.trigger(\"TemplateMiddle\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template middle)\",token.value,null,token);case Token.TemplateTail:return this.trigger(\"TemplateTail\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template tail)\",token.value,null,token);case Token.NoSubstTemplate:return this.trigger(\"NoSubstTemplate\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(no subst template)\",token.value,null,token);case Token.Identifier:this.triggerAsync(\"Identifier\",{line:this.line,\"char\":this.char,from:this.form,name:token.value,raw_name:token.text,isProperty:\".\"===state.tokens.curr.id},checks,function(){return!0});case Token.Keyword:case Token.NullLiteral:case Token.BooleanLiteral:return create(\"(identifier)\",token.value,\".\"===state.tokens.curr.id,token);case Token.NumericLiteral:return token.isMalformed&&this.trigger(\"warning\",{code:\"W045\",line:this.line,character:this.char,data:[token.value]}),this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"0x-\"]},checks,function(){return 16===token.base&&state.jsonMode}),this.triggerAsync(\"warning\",{code:\"W115\",line:this.line,character:this.char},checks,function(){return state.isStrict()&&8===token.base&&token.isLegacy}),this.trigger(\"Number\",{line:this.line,\"char\":this.char,from:this.from,value:token.value,base:token.base,isMalformed:token.malformed}),create(\"(number)\",token.value);case Token.RegExp:return create(\"(regexp)\",token.value);case Token.Comment:if(state.tokens.curr.comment=!0,token.isSpecial)return{id:\"(comment)\",value:token.value,body:token.body,type:token.commentType,isSpecial:token.isSpecial,line:this.line,character:this.char,from:this.from};break;case\"\":break;default:return create(\"(punctuator)\",token.value)}else this.input.length&&(this.trigger(\"error\",{code:\"E024\",line:this.line,character:this.char,data:[this.peek()]}),this.input=\"\")}}},exports.Lexer=Lexer,exports.Context=Context},{\"../data/ascii-identifier-data.js\":\"/node_modules/jshint/data/ascii-identifier-data.js\",\"../lodash\":\"/node_modules/jshint/lodash.js\",\"./reg.js\":\"/node_modules/jshint/src/reg.js\",\"./state.js\":\"/node_modules/jshint/src/state.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/messages.js\":[function(_dereq_,module,exports){\"use strict\";var _=_dereq_(\"../lodash\"),errors={E001:\"Bad option: '{a}'.\",E002:\"Bad option value.\",E003:\"Expected a JSON value.\",E004:\"Input is neither a string nor an array of strings.\",E005:\"Input is empty.\",E006:\"Unexpected early end of program.\",E007:'Missing \"use strict\" statement.',E008:\"Strict violation.\",E009:\"Option 'validthis' can't be used in a global scope.\",E010:\"'with' is not allowed in strict mode.\",E011:\"'{a}' has already been declared.\",E012:\"const '{a}' is initialized to 'undefined'.\",E013:\"Attempting to override '{a}' which is a constant.\",E014:\"A regular expression literal can be confused with '/='.\",E015:\"Unclosed regular expression.\",E016:\"Invalid regular expression.\",E017:\"Unclosed comment.\",E018:\"Unbegun comment.\",E019:\"Unmatched '{a}'.\",E020:\"Expected '{a}' to match '{b}' from line {c} and instead saw '{d}'.\",E021:\"Expected '{a}' and instead saw '{b}'.\",E022:\"Line breaking error '{a}'.\",E023:\"Missing '{a}'.\",E024:\"Unexpected '{a}'.\",E025:\"Missing ':' on a case clause.\",E026:\"Missing '}' to match '{' from line {a}.\",E027:\"Missing ']' to match '[' from line {a}.\",E028:\"Illegal comma.\",E029:\"Unclosed string.\",E030:\"Expected an identifier and instead saw '{a}'.\",E031:\"Bad assignment.\",E032:\"Expected a small integer or 'false' and instead saw '{a}'.\",E033:\"Expected an operator and instead saw '{a}'.\",E034:\"get/set are ES5 features.\",E035:\"Missing property name.\",E036:\"Expected to see a statement and instead saw a block.\",E037:null,E038:null,E039:\"Function declarations are not invocable. Wrap the whole function invocation in parens.\",E040:\"Each value should have its own case label.\",E041:\"Unrecoverable syntax error.\",E042:\"Stopping.\",E043:\"Too many errors.\",E044:null,E045:\"Invalid for each loop.\",E046:\"A yield statement shall be within a generator function (with syntax: `function*`)\",E047:null,E048:\"{a} declaration not directly within block.\",E049:\"A {a} cannot be named '{b}'.\",E050:\"Mozilla acequires the yield expression to be parenthesized here.\",E051:null,E052:\"Unclosed template literal.\",E053:\"Export declaration must be in global scope.\",E054:\"Class properties must be methods. Expected '(' but instead saw '{a}'.\",E055:\"The '{a}' option cannot be set after any executable code.\",E056:\"'{a}' was used before it was declared, which is illegal for '{b}' variables.\",E057:\"Invalid meta property: '{a}.{b}'.\",E058:\"Missing semicolon.\"},warnings={W001:\"'hasOwnProperty' is a really bad name.\",W002:\"Value of '{a}' may be overwritten in IE 8 and earlier.\",W003:\"'{a}' was used before it was defined.\",W004:\"'{a}' is already defined.\",W005:\"A dot following a number can be confused with a decimal point.\",W006:\"Confusing minuses.\",W007:\"Confusing plusses.\",W008:\"A leading decimal point can be confused with a dot: '{a}'.\",W009:\"The array literal notation [] is preferable.\",W010:\"The object literal notation {} is preferable.\",W011:null,W012:null,W013:null,W014:\"Bad line breaking before '{a}'.\",W015:null,W016:\"Unexpected use of '{a}'.\",W017:\"Bad operand.\",W018:\"Confusing use of '{a}'.\",W019:\"Use the isNaN function to compare with NaN.\",W020:\"Read only.\",W021:\"Reassignment of '{a}', which is is a {b}. Use 'var' or 'let' to declare bindings that may change.\",W022:\"Do not assign to the exception parameter.\",W023:\"Expected an identifier in an assignment and instead saw a function invocation.\",W024:\"Expected an identifier and instead saw '{a}' (a reserved word).\",W025:\"Missing name in function declaration.\",W026:\"Inner functions should be listed at the top of the outer function.\",W027:\"Unreachable '{a}' after '{b}'.\",W028:\"Label '{a}' on {b} statement.\",W030:\"Expected an assignment or function call and instead saw an expression.\",W031:\"Do not use 'new' for side effects.\",W032:\"Unnecessary semicolon.\",W033:\"Missing semicolon.\",W034:'Unnecessary directive \"{a}\".',W035:\"Empty block.\",W036:\"Unexpected /*member '{a}'.\",W037:\"'{a}' is a statement label.\",W038:\"'{a}' used out of scope.\",W039:\"'{a}' is not allowed.\",W040:\"Possible strict violation.\",W041:\"Use '{a}' to compare with '{b}'.\",W042:\"Avoid EOL escaping.\",W043:\"Bad escaping of EOL. Use option multistr if needed.\",W044:\"Bad or unnecessary escaping.\",W045:\"Bad number '{a}'.\",W046:\"Don't use extra leading zeros '{a}'.\",W047:\"A trailing decimal point can be confused with a dot: '{a}'.\",W048:\"Unexpected control character in regular expression.\",W049:\"Unexpected escaped character '{a}' in regular expression.\",W050:\"JavaScript URL.\",W051:\"Variables should not be deleted.\",W052:\"Unexpected '{a}'.\",W053:\"Do not use {a} as a constructor.\",W054:\"The Function constructor is a form of eval.\",W055:\"A constructor name should start with an uppercase letter.\",W056:\"Bad constructor.\",W057:\"Weird construction. Is 'new' necessary?\",W058:\"Missing '()' invoking a constructor.\",W059:\"Avoid arguments.{a}.\",W060:\"document.write can be a form of eval.\",W061:\"eval can be harmful.\",W062:\"Wrap an immediate function invocation in parens to assist the reader in understanding that the expression is the result of a function, and not the function itself.\",W063:\"Math is not a function.\",W064:\"Missing 'new' prefix when invoking a constructor.\",W065:\"Missing radix parameter.\",W066:\"Implied eval. Consider passing a function instead of a string.\",W067:\"Bad invocation.\",W068:\"Wrapping non-IIFE function literals in parens is unnecessary.\",W069:\"['{a}'] is better written in dot notation.\",W070:\"Extra comma. (it breaks older versions of IE)\",W071:\"This function has too many statements. ({a})\",W072:\"This function has too many parameters. ({a})\",W073:\"Blocks are nested too deeply. ({a})\",W074:\"This function's cyclomatic complexity is too high. ({a})\",W075:\"Duplicate {a} '{b}'.\",W076:\"Unexpected parameter '{a}' in get {b} function.\",W077:\"Expected a single parameter in set {a} function.\",W078:\"Setter is defined without getter.\",W079:\"Redefinition of '{a}'.\",W080:\"It's not necessary to initialize '{a}' to 'undefined'.\",W081:null,W082:\"Function declarations should not be placed in blocks. Use a function expression or move the statement to the top of the outer function.\",W083:\"Don't make functions within a loop.\",W084:\"Assignment in conditional expression\",W085:\"Don't use 'with'.\",W086:\"Expected a 'break' statement before '{a}'.\",W087:\"Forgotten 'debugger' statement?\",W088:\"Creating global 'for' variable. Should be 'for (var {a} ...'.\",W089:\"The body of a for in should be wrapped in an if statement to filter unwanted properties from the prototype.\",W090:\"'{a}' is not a statement label.\",W091:null,W093:\"Did you mean to return a conditional instead of an assignment?\",W094:\"Unexpected comma.\",W095:\"Expected a string and instead saw {a}.\",W096:\"The '{a}' key may produce unexpected results.\",W097:'Use the function form of \"use strict\".',W098:\"'{a}' is defined but never used.\",W099:null,W100:\"This character may get silently deleted by one or more browsers.\",W101:\"Line is too long.\",W102:null,W103:\"The '{a}' property is deprecated.\",W104:\"'{a}' is available in ES{b} (use 'esversion: {b}') or Mozilla JS extensions (use moz).\",W105:\"Unexpected {a} in '{b}'.\",W106:\"Identifier '{a}' is not in camel case.\",W107:\"Script URL.\",W108:\"Strings must use doublequote.\",W109:\"Strings must use singlequote.\",W110:\"Mixed double and single quotes.\",W112:\"Unclosed string.\",W113:\"Control character in string: {a}.\",W114:\"Avoid {a}.\",W115:\"Octal literals are not allowed in strict mode.\",W116:\"Expected '{a}' and instead saw '{b}'.\",W117:\"'{a}' is not defined.\",W118:\"'{a}' is only available in Mozilla JavaScript extensions (use moz option).\",W119:\"'{a}' is only available in ES{b} (use 'esversion: {b}').\",W120:\"You might be leaking a variable ({a}) here.\",W121:\"Extending prototype of native object: '{a}'.\",W122:\"Invalid typeof value '{a}'\",W123:\"'{a}' is already defined in outer scope.\",W124:\"A generator function shall contain a yield statement.\",W125:\"This line contains non-breaking spaces: http://jshint.com/doc/options/#nonbsp\",W126:\"Unnecessary grouping operator.\",W127:\"Unexpected use of a comma operator.\",W128:\"Empty array elements acequire elision=true.\",W129:\"'{a}' is defined in a future version of JavaScript. Use a different variable name to avoid migration issues.\",W130:\"Invalid element after rest element.\",W131:\"Invalid parameter after rest parameter.\",W132:\"`var` declarations are forbidden. Use `let` or `const` instead.\",W133:\"Invalid for-{a} loop left-hand-side: {b}.\",W134:\"The '{a}' option is only available when linting ECMAScript {b} code.\",W135:\"{a} may not be supported by non-browser environments.\",W136:\"'{a}' must be in function scope.\",W137:\"Empty destructuring.\",W138:\"Regular parameters should not come after default parameters.\"},info={I001:\"Comma warnings can be turned off with 'laxcomma'.\",I002:null,I003:\"ES5 option is now set per default\"};exports.errors={},exports.warnings={},exports.info={},_.each(errors,function(desc,code){exports.errors[code]={code:code,desc:desc}}),_.each(warnings,function(desc,code){exports.warnings[code]={code:code,desc:desc}}),_.each(info,function(desc,code){exports.info[code]={code:code,desc:desc}})},{\"../lodash\":\"/node_modules/jshint/lodash.js\"}],\"/node_modules/jshint/src/name-stack.js\":[function(_dereq_,module){\"use strict\";function NameStack(){this._stack=[]}Object.defineProperty(NameStack.prototype,\"length\",{get:function(){return this._stack.length}}),NameStack.prototype.push=function(){this._stack.push(null)},NameStack.prototype.pop=function(){this._stack.pop()},NameStack.prototype.set=function(token){this._stack[this.length-1]=token},NameStack.prototype.infer=function(){var type,nameToken=this._stack[this.length-1],prefix=\"\";return nameToken&&\"class\"!==nameToken.type||(nameToken=this._stack[this.length-2]),nameToken?(type=nameToken.type,\"(string)\"!==type&&\"(number)\"!==type&&\"(identifier)\"!==type&&\"default\"!==type?\"(expression)\":(nameToken.accessorType&&(prefix=nameToken.accessorType+\" \"),prefix+nameToken.value)):\"(empty)\"},module.exports=NameStack},{}],\"/node_modules/jshint/src/options.js\":[function(_dereq_,module,exports){\"use strict\";exports.bool={enforcing:{bitwise:!0,freeze:!0,camelcase:!0,curly:!0,eqeqeq:!0,futurehostile:!0,notypeof:!0,es3:!0,es5:!0,forin:!0,funcscope:!0,immed:!0,iterator:!0,newcap:!0,noarg:!0,nocomma:!0,noempty:!0,nonbsp:!0,nonew:!0,undef:!0,singleGroups:!1,varstmt:!1,enforceall:!1},relaxing:{asi:!0,multistr:!0,debug:!0,boss:!0,evil:!0,globalstrict:!0,plusplus:!0,proto:!0,scripturl:!0,sub:!0,supernew:!0,laxbreak:!0,laxcomma:!0,validthis:!0,withstmt:!0,moz:!0,noyield:!0,eqnull:!0,lastsemic:!0,loopfunc:!0,expr:!0,esnext:!0,elision:!0},environments:{mootools:!0,couch:!0,jasmine:!0,jquery:!0,node:!0,qunit:!0,rhino:!0,shelljs:!0,prototypejs:!0,yui:!0,mocha:!0,module:!0,wsh:!0,worker:!0,nonstandard:!0,browser:!0,browserify:!0,devel:!0,dojo:!0,typed:!0,phantom:!0},obsolete:{onecase:!0,regexp:!0,regexdash:!0}},exports.val={maxlen:!1,indent:!1,maxerr:!1,predef:!1,globals:!1,quotmark:!1,scope:!1,maxstatements:!1,maxdepth:!1,maxparams:!1,maxcomplexity:!1,shadow:!1,strict:!0,unused:!0,latedef:!1,ignore:!1,ignoreDelimiters:!1,esversion:5},exports.inverted={bitwise:!0,forin:!0,newcap:!0,plusplus:!0,regexp:!0,undef:!0,eqeqeq:!0,strict:!0},exports.validNames=Object.keys(exports.val).concat(Object.keys(exports.bool.relaxing)).concat(Object.keys(exports.bool.enforcing)).concat(Object.keys(exports.bool.obsolete)).concat(Object.keys(exports.bool.environments)),exports.renamed={eqeq:\"eqeqeq\",windows:\"wsh\",sloppy:\"strict\"},exports.removed={nomen:!0,onevar:!0,passfail:!0,white:!0,gcl:!0,smarttabs:!0,trailing:!0},exports.noenforceall={varstmt:!0,strict:!0}},{}],\"/node_modules/jshint/src/reg.js\":[function(_dereq_,module,exports){\"use strict\";exports.unsafeString=/@cc|<\\/?|script|\\]\\s*\\]|<\\s*!|&lt/i,exports.unsafeChars=/[\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/,exports.needEsc=/[\\u0000-\\u001f&<\"\\/\\\\\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/,exports.needEscGlobal=/[\\u0000-\\u001f&<\"\\/\\\\\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/g,exports.starSlash=/\\*\\//,exports.identifier=/^([a-zA-Z_$][a-zA-Z0-9_$]*)$/,exports.javascriptURL=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\\s*:/i,exports.fallsThrough=/^\\s*falls?\\sthrough\\s*$/,exports.maxlenException=/^(?:(?:\\/\\/|\\/\\*|\\*) ?)?[^ ]+$/},{}],\"/node_modules/jshint/src/scope-manager.js\":[function(_dereq_,module){\"use strict\";var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),marker={},scopeManager=function(state,predefined,exported,declared){function _newScope(type){_current={\"(labels)\":Object.create(null),\"(usages)\":Object.create(null),\"(breakLabels)\":Object.create(null),\"(parent)\":_current,\"(type)\":type,\"(params)\":\"functionparams\"===type||\"catchparams\"===type?[]:null},_scopeStack.push(_current)}function warning(code,token){emitter.emit(\"warning\",{code:code,token:token,data:_.slice(arguments,2)})}function error(code,token){emitter.emit(\"warning\",{code:code,token:token,data:_.slice(arguments,2)})}function _setupUsages(labelName){_current[\"(usages)\"][labelName]||(_current[\"(usages)\"][labelName]={\"(modified)\":[],\"(reassigned)\":[],\"(tokens)\":[]})}function _checkForUnused(){if(\"functionparams\"===_current[\"(type)\"])return _checkParams(),void 0;var curentLabels=_current[\"(labels)\"];for(var labelName in curentLabels)curentLabels[labelName]&&\"exception\"!==curentLabels[labelName][\"(type)\"]&&curentLabels[labelName][\"(unused)\"]&&_warnUnused(labelName,curentLabels[labelName][\"(token)\"],\"var\")}function _checkParams(){var params=_current[\"(params)\"];if(params)for(var unused_opt,param=params.pop();param;){var label=_current[\"(labels)\"][param];if(unused_opt=_getUnusedOption(state.funct[\"(unusedOption)\"]),\"undefined\"===param)return;if(label[\"(unused)\"])_warnUnused(param,label[\"(token)\"],\"param\",state.funct[\"(unusedOption)\"]);else if(\"last-param\"===unused_opt)return;param=params.pop()}}function _getLabel(labelName){for(var i=_scopeStack.length-1;i>=0;--i){var scopeLabels=_scopeStack[i][\"(labels)\"];if(scopeLabels[labelName])return scopeLabels}}function usedSoFarInCurrentFunction(labelName){for(var i=_scopeStack.length-1;i>=0;i--){var current=_scopeStack[i];if(current[\"(usages)\"][labelName])return current[\"(usages)\"][labelName];if(current===_currentFunctBody)break}return!1}function _checkOuterShadow(labelName,token){if(\"outer\"===state.option.shadow)for(var isGlobal=\"global\"===_currentFunctBody[\"(type)\"],isNewFunction=\"functionparams\"===_current[\"(type)\"],outsideCurrentFunction=!isGlobal,i=0;_scopeStack.length>i;i++){var stackItem=_scopeStack[i];isNewFunction||_scopeStack[i+1]!==_currentFunctBody||(outsideCurrentFunction=!1),outsideCurrentFunction&&stackItem[\"(labels)\"][labelName]&&warning(\"W123\",token,labelName),stackItem[\"(breakLabels)\"][labelName]&&warning(\"W123\",token,labelName)}}function _latedefWarning(type,labelName,token){state.option.latedef&&(state.option.latedef===!0&&\"function\"===type||\"function\"!==type)&&warning(\"W003\",token,labelName)}var _current,_scopeStack=[];_newScope(\"global\"),_current[\"(predefined)\"]=predefined;var _currentFunctBody=_current,usedPredefinedAndGlobals=Object.create(null),impliedGlobals=Object.create(null),unuseds=[],emitter=new events.EventEmitter,_getUnusedOption=function(unused_opt){return void 0===unused_opt&&(unused_opt=state.option.unused),unused_opt===!0&&(unused_opt=\"last-param\"),unused_opt},_warnUnused=function(name,tkn,type,unused_opt){var line=tkn.line,chr=tkn.from,raw_name=tkn.raw_text||name;unused_opt=_getUnusedOption(unused_opt);var warnable_types={vars:[\"var\"],\"last-param\":[\"var\",\"param\"],strict:[\"var\",\"param\",\"last-param\"]};unused_opt&&warnable_types[unused_opt]&&-1!==warnable_types[unused_opt].indexOf(type)&&warning(\"W098\",{line:line,from:chr},raw_name),(unused_opt||\"var\"===type)&&unuseds.push({name:name,line:line,character:chr})},scopeManagerInst={on:function(names,listener){names.split(\" \").forEach(function(name){emitter.on(name,listener)})},isPredefined:function(labelName){return!this.has(labelName)&&_.has(_scopeStack[0][\"(predefined)\"],labelName)},stack:function(type){var previousScope=_current;_newScope(type),type||\"functionparams\"!==previousScope[\"(type)\"]||(_current[\"(isFuncBody)\"]=!0,_current[\"(context)\"]=_currentFunctBody,_currentFunctBody=_current)},unstack:function(){var i,j,subScope=_scopeStack.length>1?_scopeStack[_scopeStack.length-2]:null,isUnstackingFunctionBody=_current===_currentFunctBody,isUnstackingFunctionParams=\"functionparams\"===_current[\"(type)\"],isUnstackingFunctionOuter=\"functionouter\"===_current[\"(type)\"],currentUsages=_current[\"(usages)\"],currentLabels=_current[\"(labels)\"],usedLabelNameList=Object.keys(currentUsages);for(currentUsages.__proto__&&-1===usedLabelNameList.indexOf(\"__proto__\")&&usedLabelNameList.push(\"__proto__\"),i=0;usedLabelNameList.length>i;i++){var usedLabelName=usedLabelNameList[i],usage=currentUsages[usedLabelName],usedLabel=currentLabels[usedLabelName];if(usedLabel){var usedLabelType=usedLabel[\"(type)\"];if(usedLabel[\"(useOutsideOfScope)\"]&&!state.option.funcscope){var usedTokens=usage[\"(tokens)\"];if(usedTokens)for(j=0;usedTokens.length>j;j++)usedLabel[\"(function)\"]===usedTokens[j][\"(function)\"]&&error(\"W038\",usedTokens[j],usedLabelName)}if(_current[\"(labels)\"][usedLabelName][\"(unused)\"]=!1,\"const\"===usedLabelType&&usage[\"(modified)\"])for(j=0;usage[\"(modified)\"].length>j;j++)error(\"E013\",usage[\"(modified)\"][j],usedLabelName);if((\"function\"===usedLabelType||\"class\"===usedLabelType)&&usage[\"(reassigned)\"])for(j=0;usage[\"(reassigned)\"].length>j;j++)error(\"W021\",usage[\"(reassigned)\"][j],usedLabelName,usedLabelType)}else if(isUnstackingFunctionOuter&&(state.funct[\"(isCapturing)\"]=!0),subScope)if(subScope[\"(usages)\"][usedLabelName]){var subScopeUsage=subScope[\"(usages)\"][usedLabelName];subScopeUsage[\"(modified)\"]=subScopeUsage[\"(modified)\"].concat(usage[\"(modified)\"]),subScopeUsage[\"(tokens)\"]=subScopeUsage[\"(tokens)\"].concat(usage[\"(tokens)\"]),subScopeUsage[\"(reassigned)\"]=subScopeUsage[\"(reassigned)\"].concat(usage[\"(reassigned)\"]),subScopeUsage[\"(onlyUsedSubFunction)\"]=!1}else subScope[\"(usages)\"][usedLabelName]=usage,isUnstackingFunctionBody&&(subScope[\"(usages)\"][usedLabelName][\"(onlyUsedSubFunction)\"]=!0);else if(\"boolean\"==typeof _current[\"(predefined)\"][usedLabelName]){if(delete declared[usedLabelName],usedPredefinedAndGlobals[usedLabelName]=marker,_current[\"(predefined)\"][usedLabelName]===!1&&usage[\"(reassigned)\"])for(j=0;usage[\"(reassigned)\"].length>j;j++)warning(\"W020\",usage[\"(reassigned)\"][j])}else if(usage[\"(tokens)\"])for(j=0;usage[\"(tokens)\"].length>j;j++){var undefinedToken=usage[\"(tokens)\"][j];undefinedToken.forgiveUndef||(state.option.undef&&!undefinedToken.ignoreUndef&&warning(\"W117\",undefinedToken,usedLabelName),impliedGlobals[usedLabelName]?impliedGlobals[usedLabelName].line.push(undefinedToken.line):impliedGlobals[usedLabelName]={name:usedLabelName,line:[undefinedToken.line]})}}if(subScope||Object.keys(declared).forEach(function(labelNotUsed){_warnUnused(labelNotUsed,declared[labelNotUsed],\"var\")}),subScope&&!isUnstackingFunctionBody&&!isUnstackingFunctionParams&&!isUnstackingFunctionOuter){var labelNames=Object.keys(currentLabels);for(i=0;labelNames.length>i;i++){var defLabelName=labelNames[i];currentLabels[defLabelName][\"(blockscoped)\"]||\"exception\"===currentLabels[defLabelName][\"(type)\"]||this.funct.has(defLabelName,{excludeCurrent:!0})||(subScope[\"(labels)\"][defLabelName]=currentLabels[defLabelName],\"global\"!==_currentFunctBody[\"(type)\"]&&(subScope[\"(labels)\"][defLabelName][\"(useOutsideOfScope)\"]=!0),delete currentLabels[defLabelName])}}_checkForUnused(),_scopeStack.pop(),isUnstackingFunctionBody&&(_currentFunctBody=_scopeStack[_.findLastIndex(_scopeStack,function(scope){return scope[\"(isFuncBody)\"]||\"global\"===scope[\"(type)\"]})]),_current=subScope},addParam:function(labelName,token,type){if(type=type||\"param\",\"exception\"===type){var previouslyDefinedLabelType=this.funct.labeltype(labelName);previouslyDefinedLabelType&&\"exception\"!==previouslyDefinedLabelType&&(state.option.node||warning(\"W002\",state.tokens.next,labelName))}if(_.has(_current[\"(labels)\"],labelName)?_current[\"(labels)\"][labelName].duplicated=!0:(_checkOuterShadow(labelName,token,type),_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":token,\"(unused)\":!0},_current[\"(params)\"].push(labelName)),_.has(_current[\"(usages)\"],labelName)){var usage=_current[\"(usages)\"][labelName];usage[\"(onlyUsedSubFunction)\"]?_latedefWarning(type,labelName,token):warning(\"E056\",token,labelName,type)}},validateParams:function(){if(\"global\"!==_currentFunctBody[\"(type)\"]){var isStrict=state.isStrict(),currentFunctParamScope=_currentFunctBody[\"(parent)\"];currentFunctParamScope[\"(params)\"]&&currentFunctParamScope[\"(params)\"].forEach(function(labelName){var label=currentFunctParamScope[\"(labels)\"][labelName];label&&label.duplicated&&(isStrict?warning(\"E011\",label[\"(token)\"],labelName):state.option.shadow!==!0&&warning(\"W004\",label[\"(token)\"],labelName))})}},getUsedOrDefinedGlobals:function(){var list=Object.keys(usedPredefinedAndGlobals);return usedPredefinedAndGlobals.__proto__===marker&&-1===list.indexOf(\"__proto__\")&&list.push(\"__proto__\"),list},getImpliedGlobals:function(){var values=_.values(impliedGlobals),hasProto=!1;return impliedGlobals.__proto__&&(hasProto=values.some(function(value){return\"__proto__\"===value.name}),hasProto||values.push(impliedGlobals.__proto__)),values},getUnuseds:function(){return unuseds},has:function(labelName){return Boolean(_getLabel(labelName))},labeltype:function(labelName){var scopeLabels=_getLabel(labelName);return scopeLabels?scopeLabels[labelName][\"(type)\"]:null},addExported:function(labelName){var globalLabels=_scopeStack[0][\"(labels)\"];if(_.has(declared,labelName))delete declared[labelName];else if(_.has(globalLabels,labelName))globalLabels[labelName][\"(unused)\"]=!1;else{for(var i=1;_scopeStack.length>i;i++){var scope=_scopeStack[i];if(scope[\"(type)\"])break;if(_.has(scope[\"(labels)\"],labelName)&&!scope[\"(labels)\"][labelName][\"(blockscoped)\"])return scope[\"(labels)\"][labelName][\"(unused)\"]=!1,void 0}exported[labelName]=!0}},setExported:function(labelName,token){this.block.use(labelName,token)\n},addlabel:function(labelName,opts){var type=opts.type,token=opts.token,isblockscoped=\"let\"===type||\"const\"===type||\"class\"===type,isexported=\"global\"===(isblockscoped?_current:_currentFunctBody)[\"(type)\"]&&_.has(exported,labelName);if(_checkOuterShadow(labelName,token,type),isblockscoped){var declaredInCurrentScope=_current[\"(labels)\"][labelName];if(declaredInCurrentScope||_current!==_currentFunctBody||\"global\"===_current[\"(type)\"]||(declaredInCurrentScope=!!_currentFunctBody[\"(parent)\"][\"(labels)\"][labelName]),!declaredInCurrentScope&&_current[\"(usages)\"][labelName]){var usage=_current[\"(usages)\"][labelName];usage[\"(onlyUsedSubFunction)\"]?_latedefWarning(type,labelName,token):warning(\"E056\",token,labelName,type)}declaredInCurrentScope?warning(\"E011\",token,labelName):\"outer\"===state.option.shadow&&scopeManagerInst.funct.has(labelName)&&warning(\"W004\",token,labelName),scopeManagerInst.block.add(labelName,type,token,!isexported)}else{var declaredInCurrentFunctionScope=scopeManagerInst.funct.has(labelName);!declaredInCurrentFunctionScope&&usedSoFarInCurrentFunction(labelName)&&_latedefWarning(type,labelName,token),scopeManagerInst.funct.has(labelName,{onlyBlockscoped:!0})?warning(\"E011\",token,labelName):state.option.shadow!==!0&&declaredInCurrentFunctionScope&&\"__proto__\"!==labelName&&\"global\"!==_currentFunctBody[\"(type)\"]&&warning(\"W004\",token,labelName),scopeManagerInst.funct.add(labelName,type,token,!isexported),\"global\"===_currentFunctBody[\"(type)\"]&&(usedPredefinedAndGlobals[labelName]=marker)}},funct:{labeltype:function(labelName,options){for(var onlyBlockscoped=options&&options.onlyBlockscoped,excludeParams=options&&options.excludeParams,currentScopeIndex=_scopeStack.length-(options&&options.excludeCurrent?2:1),i=currentScopeIndex;i>=0;i--){var current=_scopeStack[i];if(current[\"(labels)\"][labelName]&&(!onlyBlockscoped||current[\"(labels)\"][labelName][\"(blockscoped)\"]))return current[\"(labels)\"][labelName][\"(type)\"];var scopeCheck=excludeParams?_scopeStack[i-1]:current;if(scopeCheck&&\"functionparams\"===scopeCheck[\"(type)\"])return null}return null},hasBreakLabel:function(labelName){for(var i=_scopeStack.length-1;i>=0;i--){var current=_scopeStack[i];if(current[\"(breakLabels)\"][labelName])return!0;if(\"functionparams\"===current[\"(type)\"])return!1}return!1},has:function(labelName,options){return Boolean(this.labeltype(labelName,options))},add:function(labelName,type,tok,unused){_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":tok,\"(blockscoped)\":!1,\"(function)\":_currentFunctBody,\"(unused)\":unused}}},block:{isGlobal:function(){return\"global\"===_current[\"(type)\"]},use:function(labelName,token){var paramScope=_currentFunctBody[\"(parent)\"];paramScope&&paramScope[\"(labels)\"][labelName]&&\"param\"===paramScope[\"(labels)\"][labelName][\"(type)\"]&&(scopeManagerInst.funct.has(labelName,{excludeParams:!0,onlyBlockscoped:!0})||(paramScope[\"(labels)\"][labelName][\"(unused)\"]=!1)),token&&(state.ignored.W117||state.option.undef===!1)&&(token.ignoreUndef=!0),_setupUsages(labelName),token&&(token[\"(function)\"]=_currentFunctBody,_current[\"(usages)\"][labelName][\"(tokens)\"].push(token))},reassign:function(labelName,token){this.modify(labelName,token),_current[\"(usages)\"][labelName][\"(reassigned)\"].push(token)},modify:function(labelName,token){_setupUsages(labelName),_current[\"(usages)\"][labelName][\"(modified)\"].push(token)},add:function(labelName,type,tok,unused){_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":tok,\"(blockscoped)\":!0,\"(unused)\":unused}},addBreakLabel:function(labelName,opts){var token=opts.token;scopeManagerInst.funct.hasBreakLabel(labelName)?warning(\"E011\",token,labelName):\"outer\"===state.option.shadow&&(scopeManagerInst.funct.has(labelName)?warning(\"W004\",token,labelName):_checkOuterShadow(labelName,token)),_current[\"(breakLabels)\"][labelName]=token}}};return scopeManagerInst};module.exports=scopeManager},{\"../lodash\":\"/node_modules/jshint/lodash.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/state.js\":[function(_dereq_,module,exports){\"use strict\";var NameStack=_dereq_(\"./name-stack.js\"),state={syntax:{},isStrict:function(){return this.directive[\"use strict\"]||this.inClassBody||this.option.module||\"implied\"===this.option.strict},inMoz:function(){return this.option.moz},inES6:function(){return this.option.moz||this.option.esversion>=6},inES5:function(strict){return strict?!(this.option.esversion&&5!==this.option.esversion||this.option.moz):!this.option.esversion||this.option.esversion>=5||this.option.moz},reset:function(){this.tokens={prev:null,next:null,curr:null},this.option={},this.funct=null,this.ignored={},this.directive={},this.jsonMode=!1,this.jsonWarnings=[],this.lines=[],this.tab=\"\",this.cache={},this.ignoredLines={},this.forinifcheckneeded=!1,this.nameStack=new NameStack,this.inClassBody=!1}};exports.state=state},{\"./name-stack.js\":\"/node_modules/jshint/src/name-stack.js\"}],\"/node_modules/jshint/src/style.js\":[function(_dereq_,module,exports){\"use strict\";exports.register=function(linter){linter.on(\"Identifier\",function(data){linter.getOption(\"proto\")||\"__proto__\"===data.name&&linter.warn(\"W103\",{line:data.line,\"char\":data.char,data:[data.name,\"6\"]})}),linter.on(\"Identifier\",function(data){linter.getOption(\"iterator\")||\"__iterator__\"===data.name&&linter.warn(\"W103\",{line:data.line,\"char\":data.char,data:[data.name]})}),linter.on(\"Identifier\",function(data){linter.getOption(\"camelcase\")&&data.name.replace(/^_+|_+$/g,\"\").indexOf(\"_\")>-1&&!data.name.match(/^[A-Z0-9_]*$/)&&linter.warn(\"W106\",{line:data.line,\"char\":data.from,data:[data.name]})}),linter.on(\"String\",function(data){var code,quotmark=linter.getOption(\"quotmark\");quotmark&&(\"single\"===quotmark&&\"'\"!==data.quote&&(code=\"W109\"),\"double\"===quotmark&&'\"'!==data.quote&&(code=\"W108\"),quotmark===!0&&(linter.getCache(\"quotmark\")||linter.setCache(\"quotmark\",data.quote),linter.getCache(\"quotmark\")!==data.quote&&(code=\"W110\")),code&&linter.warn(code,{line:data.line,\"char\":data.char}))}),linter.on(\"Number\",function(data){\".\"===data.value.charAt(0)&&linter.warn(\"W008\",{line:data.line,\"char\":data.char,data:[data.value]}),\".\"===data.value.substr(data.value.length-1)&&linter.warn(\"W047\",{line:data.line,\"char\":data.char,data:[data.value]}),/^00+/.test(data.value)&&linter.warn(\"W046\",{line:data.line,\"char\":data.char,data:[data.value]})}),linter.on(\"String\",function(data){var re=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\\s*:/i;linter.getOption(\"scripturl\")||re.test(data.value)&&linter.warn(\"W107\",{line:data.line,\"char\":data.char})})}},{}],\"/node_modules/jshint/src/vars.js\":[function(_dereq_,module,exports){\"use strict\";exports.reservedVars={arguments:!1,NaN:!1},exports.ecmaIdentifiers={3:{Array:!1,Boolean:!1,Date:!1,decodeURI:!1,decodeURIComponent:!1,encodeURI:!1,encodeURIComponent:!1,Error:!1,eval:!1,EvalError:!1,Function:!1,hasOwnProperty:!1,isFinite:!1,isNaN:!1,Math:!1,Number:!1,Object:!1,parseInt:!1,parseFloat:!1,RangeError:!1,ReferenceError:!1,RegExp:!1,String:!1,SyntaxError:!1,TypeError:!1,URIError:!1},5:{JSON:!1},6:{Map:!1,Promise:!1,Proxy:!1,Reflect:!1,Set:!1,Symbol:!1,WeakMap:!1,WeakSet:!1}},exports.browser={Audio:!1,Blob:!1,addEventListener:!1,applicationCache:!1,atob:!1,blur:!1,btoa:!1,cancelAnimationFrame:!1,CanvasGradient:!1,CanvasPattern:!1,CanvasRenderingContext2D:!1,CSS:!1,clearInterval:!1,clearTimeout:!1,close:!1,closed:!1,Comment:!1,CustomEvent:!1,DOMParser:!1,defaultStatus:!1,Document:!1,document:!1,DocumentFragment:!1,Element:!1,ElementTimeControl:!1,Event:!1,event:!1,fetch:!1,FileReader:!1,FormData:!1,focus:!1,frames:!1,getComputedStyle:!1,HTMLElement:!1,HTMLAnchorElement:!1,HTMLBaseElement:!1,HTMLBlockquoteElement:!1,HTMLBodyElement:!1,HTMLBRElement:!1,HTMLButtonElement:!1,HTMLCanvasElement:!1,HTMLCollection:!1,HTMLDirectoryElement:!1,HTMLDivElement:!1,HTMLDListElement:!1,HTMLFieldSetElement:!1,HTMLFontElement:!1,HTMLFormElement:!1,HTMLFrameElement:!1,HTMLFrameSetElement:!1,HTMLHeadElement:!1,HTMLHeadingElement:!1,HTMLHRElement:!1,HTMLHtmlElement:!1,HTMLIFrameElement:!1,HTMLImageElement:!1,HTMLInputElement:!1,HTMLIsIndexElement:!1,HTMLLabelElement:!1,HTMLLayerElement:!1,HTMLLegendElement:!1,HTMLLIElement:!1,HTMLLinkElement:!1,HTMLMapElement:!1,HTMLMenuElement:!1,HTMLMetaElement:!1,HTMLModElement:!1,HTMLObjectElement:!1,HTMLOListElement:!1,HTMLOptGroupElement:!1,HTMLOptionElement:!1,HTMLParagraphElement:!1,HTMLParamElement:!1,HTMLPreElement:!1,HTMLQuoteElement:!1,HTMLScriptElement:!1,HTMLSelectElement:!1,HTMLStyleElement:!1,HTMLTableCaptionElement:!1,HTMLTableCellElement:!1,HTMLTableColElement:!1,HTMLTableElement:!1,HTMLTableRowElement:!1,HTMLTableSectionElement:!1,HTMLTemplateElement:!1,HTMLTextAreaElement:!1,HTMLTitleElement:!1,HTMLUListElement:!1,HTMLVideoElement:!1,history:!1,Image:!1,Intl:!1,length:!1,localStorage:!1,location:!1,matchMedia:!1,MessageChannel:!1,MessageEvent:!1,MessagePort:!1,MouseEvent:!1,moveBy:!1,moveTo:!1,MutationObserver:!1,name:!1,Node:!1,NodeFilter:!1,NodeList:!1,Notification:!1,navigator:!1,onbeforeunload:!0,onblur:!0,onerror:!0,onfocus:!0,onload:!0,onresize:!0,onunload:!0,open:!1,openDatabase:!1,opener:!1,Option:!1,parent:!1,performance:!1,print:!1,Range:!1,requestAnimationFrame:!1,removeEventListener:!1,resizeBy:!1,resizeTo:!1,screen:!1,scroll:!1,scrollBy:!1,scrollTo:!1,sessionStorage:!1,setInterval:!1,setTimeout:!1,SharedWorker:!1,status:!1,SVGAElement:!1,SVGAltGlyphDefElement:!1,SVGAltGlyphElement:!1,SVGAltGlyphItemElement:!1,SVGAngle:!1,SVGAnimateColorElement:!1,SVGAnimateElement:!1,SVGAnimateMotionElement:!1,SVGAnimateTransformElement:!1,SVGAnimatedAngle:!1,SVGAnimatedBoolean:!1,SVGAnimatedEnumeration:!1,SVGAnimatedInteger:!1,SVGAnimatedLength:!1,SVGAnimatedLengthList:!1,SVGAnimatedNumber:!1,SVGAnimatedNumberList:!1,SVGAnimatedPathData:!1,SVGAnimatedPoints:!1,SVGAnimatedPreserveAspectRatio:!1,SVGAnimatedRect:!1,SVGAnimatedString:!1,SVGAnimatedTransformList:!1,SVGAnimationElement:!1,SVGCSSRule:!1,SVGCircleElement:!1,SVGClipPathElement:!1,SVGColor:!1,SVGColorProfileElement:!1,SVGColorProfileRule:!1,SVGComponentTransferFunctionElement:!1,SVGCursorElement:!1,SVGDefsElement:!1,SVGDescElement:!1,SVGDocument:!1,SVGElement:!1,SVGElementInstance:!1,SVGElementInstanceList:!1,SVGEllipseElement:!1,SVGExternalResourcesRequired:!1,SVGFEBlendElement:!1,SVGFEColorMatrixElement:!1,SVGFEComponentTransferElement:!1,SVGFECompositeElement:!1,SVGFEConvolveMatrixElement:!1,SVGFEDiffuseLightingElement:!1,SVGFEDisplacementMapElement:!1,SVGFEDistantLightElement:!1,SVGFEFloodElement:!1,SVGFEFuncAElement:!1,SVGFEFuncBElement:!1,SVGFEFuncGElement:!1,SVGFEFuncRElement:!1,SVGFEGaussianBlurElement:!1,SVGFEImageElement:!1,SVGFEMergeElement:!1,SVGFEMergeNodeElement:!1,SVGFEMorphologyElement:!1,SVGFEOffsetElement:!1,SVGFEPointLightElement:!1,SVGFESpecularLightingElement:!1,SVGFESpotLightElement:!1,SVGFETileElement:!1,SVGFETurbulenceElement:!1,SVGFilterElement:!1,SVGFilterPrimitiveStandardAttributes:!1,SVGFitToViewBox:!1,SVGFontElement:!1,SVGFontFaceElement:!1,SVGFontFaceFormatElement:!1,SVGFontFaceNameElement:!1,SVGFontFaceSrcElement:!1,SVGFontFaceUriElement:!1,SVGForeignObjectElement:!1,SVGGElement:!1,SVGGlyphElement:!1,SVGGlyphRefElement:!1,SVGGradientElement:!1,SVGHKernElement:!1,SVGICCColor:!1,SVGImageElement:!1,SVGLangSpace:!1,SVGLength:!1,SVGLengthList:!1,SVGLineElement:!1,SVGLinearGradientElement:!1,SVGLocatable:!1,SVGMPathElement:!1,SVGMarkerElement:!1,SVGMaskElement:!1,SVGMatrix:!1,SVGMetadataElement:!1,SVGMissingGlyphElement:!1,SVGNumber:!1,SVGNumberList:!1,SVGPaint:!1,SVGPathElement:!1,SVGPathSeg:!1,SVGPathSegArcAbs:!1,SVGPathSegArcRel:!1,SVGPathSegClosePath:!1,SVGPathSegCurvetoCubicAbs:!1,SVGPathSegCurvetoCubicRel:!1,SVGPathSegCurvetoCubicSmoothAbs:!1,SVGPathSegCurvetoCubicSmoothRel:!1,SVGPathSegCurvetoQuadraticAbs:!1,SVGPathSegCurvetoQuadraticRel:!1,SVGPathSegCurvetoQuadraticSmoothAbs:!1,SVGPathSegCurvetoQuadraticSmoothRel:!1,SVGPathSegLinetoAbs:!1,SVGPathSegLinetoHorizontalAbs:!1,SVGPathSegLinetoHorizontalRel:!1,SVGPathSegLinetoRel:!1,SVGPathSegLinetoVerticalAbs:!1,SVGPathSegLinetoVerticalRel:!1,SVGPathSegList:!1,SVGPathSegMovetoAbs:!1,SVGPathSegMovetoRel:!1,SVGPatternElement:!1,SVGPoint:!1,SVGPointList:!1,SVGPolygonElement:!1,SVGPolylineElement:!1,SVGPreserveAspectRatio:!1,SVGRadialGradientElement:!1,SVGRect:!1,SVGRectElement:!1,SVGRenderingIntent:!1,SVGSVGElement:!1,SVGScriptElement:!1,SVGSetElement:!1,SVGStopElement:!1,SVGStringList:!1,SVGStylable:!1,SVGStyleElement:!1,SVGSwitchElement:!1,SVGSymbolElement:!1,SVGTRefElement:!1,SVGTSpanElement:!1,SVGTests:!1,SVGTextContentElement:!1,SVGTextElement:!1,SVGTextPathElement:!1,SVGTextPositioningElement:!1,SVGTitleElement:!1,SVGTransform:!1,SVGTransformList:!1,SVGTransformable:!1,SVGURIReference:!1,SVGUnitTypes:!1,SVGUseElement:!1,SVGVKernElement:!1,SVGViewElement:!1,SVGViewSpec:!1,SVGZoomAndPan:!1,Text:!1,TextDecoder:!1,TextEncoder:!1,TimeEvent:!1,top:!1,URL:!1,WebGLActiveInfo:!1,WebGLBuffer:!1,WebGLContextEvent:!1,WebGLFramebuffer:!1,WebGLProgram:!1,WebGLRenderbuffer:!1,WebGLRenderingContext:!1,WebGLShader:!1,WebGLShaderPrecisionFormat:!1,WebGLTexture:!1,WebGLUniformLocation:!1,WebSocket:!1,window:!1,Window:!1,Worker:!1,XDomainRequest:!1,XMLHttpRequest:!1,XMLSerializer:!1,XPathEvaluator:!1,XPathException:!1,XPathExpression:!1,XPathNamespace:!1,XPathNSResolver:!1,XPathResult:!1},exports.devel={alert:!1,confirm:!1,console:!1,Debug:!1,opera:!1,prompt:!1},exports.worker={importScripts:!0,postMessage:!0,self:!0,FileReaderSync:!0},exports.nonstandard={escape:!1,unescape:!1},exports.couch={require:!1,respond:!1,getRow:!1,emit:!1,send:!1,start:!1,sum:!1,log:!1,exports:!1,module:!1,provides:!1},exports.node={__filename:!1,__dirname:!1,GLOBAL:!1,global:!1,module:!1,acequire:!1,Buffer:!0,console:!0,exports:!0,process:!0,setTimeout:!0,clearTimeout:!0,setInterval:!0,clearInterval:!0,setImmediate:!0,clearImmediate:!0},exports.browserify={__filename:!1,__dirname:!1,global:!1,module:!1,acequire:!1,Buffer:!0,exports:!0,process:!0},exports.phantom={phantom:!0,acequire:!0,WebPage:!0,console:!0,exports:!0},exports.qunit={asyncTest:!1,deepEqual:!1,equal:!1,expect:!1,module:!1,notDeepEqual:!1,notEqual:!1,notPropEqual:!1,notStrictEqual:!1,ok:!1,propEqual:!1,QUnit:!1,raises:!1,start:!1,stop:!1,strictEqual:!1,test:!1,\"throws\":!1},exports.rhino={defineClass:!1,deserialize:!1,gc:!1,help:!1,importClass:!1,importPackage:!1,java:!1,load:!1,loadClass:!1,Packages:!1,print:!1,quit:!1,readFile:!1,readUrl:!1,runCommand:!1,seal:!1,serialize:!1,spawn:!1,sync:!1,toint32:!1,version:!1},exports.shelljs={target:!1,echo:!1,exit:!1,cd:!1,pwd:!1,ls:!1,find:!1,cp:!1,rm:!1,mv:!1,mkdir:!1,test:!1,cat:!1,sed:!1,grep:!1,which:!1,dirs:!1,pushd:!1,popd:!1,env:!1,exec:!1,chmod:!1,config:!1,error:!1,tempdir:!1},exports.typed={ArrayBuffer:!1,ArrayBufferView:!1,DataView:!1,Float32Array:!1,Float64Array:!1,Int16Array:!1,Int32Array:!1,Int8Array:!1,Uint16Array:!1,Uint32Array:!1,Uint8Array:!1,Uint8ClampedArray:!1},exports.wsh={ActiveXObject:!0,Enumerator:!0,GetObject:!0,ScriptEngine:!0,ScriptEngineBuildVersion:!0,ScriptEngineMajorVersion:!0,ScriptEngineMinorVersion:!0,VBArray:!0,WSH:!0,WScript:!0,XDomainRequest:!0},exports.dojo={dojo:!1,dijit:!1,dojox:!1,define:!1,require:!1},exports.jquery={$:!1,jQuery:!1},exports.mootools={$:!1,$$:!1,Asset:!1,Browser:!1,Chain:!1,Class:!1,Color:!1,Cookie:!1,Core:!1,Document:!1,DomReady:!1,DOMEvent:!1,DOMReady:!1,Drag:!1,Element:!1,Elements:!1,Event:!1,Events:!1,Fx:!1,Group:!1,Hash:!1,HtmlTable:!1,IFrame:!1,IframeShim:!1,InputValidator:!1,instanceOf:!1,Keyboard:!1,Locale:!1,Mask:!1,MooTools:!1,Native:!1,Options:!1,OverText:!1,Request:!1,Scroller:!1,Slick:!1,Slider:!1,Sortables:!1,Spinner:!1,Swiff:!1,Tips:!1,Type:!1,typeOf:!1,URI:!1,Window:!1},exports.prototypejs={$:!1,$$:!1,$A:!1,$F:!1,$H:!1,$R:!1,$break:!1,$continue:!1,$w:!1,Abstract:!1,Ajax:!1,Class:!1,Enumerable:!1,Element:!1,Event:!1,Field:!1,Form:!1,Hash:!1,Insertion:!1,ObjectRange:!1,PeriodicalExecuter:!1,Position:!1,Prototype:!1,Selector:!1,Template:!1,Toggle:!1,Try:!1,Autocompleter:!1,Builder:!1,Control:!1,Draggable:!1,Draggables:!1,Droppables:!1,Effect:!1,Sortable:!1,SortableObserver:!1,Sound:!1,Scriptaculous:!1},exports.yui={YUI:!1,Y:!1,YUI_config:!1},exports.mocha={mocha:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,context:!1,xcontext:!1,before:!1,after:!1,beforeEach:!1,afterEach:!1,suite:!1,test:!1,setup:!1,teardown:!1,suiteSetup:!1,suiteTeardown:!1},exports.jasmine={jasmine:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,beforeEach:!1,afterEach:!1,setFixtures:!1,loadFixtures:!1,spyOn:!1,expect:!1,runs:!1,waitsFor:!1,waits:!1,beforeAll:!1,afterAll:!1,fail:!1,fdescribe:!1,fit:!1,pending:!1}},{}]},{},[\"/node_modules/jshint/src/jshint.js\"])}),ace.define(\"ace/mode/javascript_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/worker/mirror\",\"ace/mode/javascript/jshint\"],function(acequire,exports,module){\"use strict\";function startRegex(arr){return RegExp(\"^(\"+arr.join(\"|\")+\")\")}var oop=acequire(\"../lib/oop\"),Mirror=acequire(\"../worker/mirror\").Mirror,lint=acequire(\"./javascript/jshint\").JSHINT,disabledWarningsRe=startRegex([\"Bad for in variable '(.+)'.\",'Missing \"use strict\"']),errorsRe=startRegex([\"Unexpected\",\"Expected \",\"Confusing (plus|minus)\",\"\\\\{a\\\\} unterminated regular expression\",\"Unclosed \",\"Unmatched \",\"Unbegun comment\",\"Bad invocation\",\"Missing space after\",\"Missing operator at\"]),infoRe=startRegex([\"Expected an assignment\",\"Bad escapement of EOL\",\"Unexpected comma\",\"Unexpected space\",\"Missing radix parameter.\",\"A leading decimal point can\",\"\\\\['{a}'\\\\] is better written in dot notation.\",\"'{a}' used out of scope\"]),JavaScriptWorker=exports.JavaScriptWorker=function(sender){Mirror.call(this,sender),this.setTimeout(500),this.setOptions()};oop.inherits(JavaScriptWorker,Mirror),function(){this.setOptions=function(options){this.options=options||{esnext:!0,moz:!0,devel:!0,browser:!0,node:!0,laxcomma:!0,laxbreak:!0,lastsemic:!0,onevar:!1,passfail:!1,maxerr:100,expr:!0,multistr:!0,globalstrict:!0},this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.changeOptions=function(newOptions){oop.mixin(this.options,newOptions),this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.isValidJS=function(str){try{eval(\"throw 0;\"+str)}catch(e){if(0===e)return!0}return!1},this.onUpdate=function(){var value=this.doc.getValue();if(value=value.replace(/^#!.*\\n/,\"\\n\"),!value)return this.sender.emit(\"annotate\",[]);var errors=[],maxErrorLevel=this.isValidJS(value)?\"warning\":\"error\";lint(value,this.options,this.options.globals);for(var results=lint.errors,errorAdded=!1,i=0;results.length>i;i++){var error=results[i];if(error){var raw=error.raw,type=\"warning\";if(\"Missing semicolon.\"==raw){var str=error.evidence.substr(error.character);str=str.charAt(str.search(/\\S/)),\"error\"==maxErrorLevel&&str&&/[\\w\\d{(['\"]/.test(str)?(error.reason='Missing \";\" before statement',type=\"error\"):type=\"info\"}else{if(disabledWarningsRe.test(raw))continue;infoRe.test(raw)?type=\"info\":errorsRe.test(raw)?(errorAdded=!0,type=maxErrorLevel):\"'{a}' is not defined.\"==raw?type=\"warning\":\"'{a}' is defined but never used.\"==raw&&(type=\"info\")}errors.push({row:error.line-1,column:error.character-1,text:error.reason,type:type,raw:raw})}}this.sender.emit(\"annotate\",errors)}}.call(JavaScriptWorker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(575).Transform;
	var inherits = __webpack_require__(30);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(659)
	var ieee754 = __webpack_require__(317)
	var isArray = __webpack_require__(193)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	Buffer.poolSize = 8192 // not used by this implementation
	
	var rootParent = {}
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
	 *     on objects.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	function typedArraySupport () {
	  function Bar () {}
	  try {
	    var arr = new Uint8Array(1)
	    arr.foo = function () { return 42 }
	    arr.constructor = Bar
	    return arr.foo() === 42 && // typed array instances can be augmented
	        arr.constructor === Bar && // constructor can be set
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	/**
	 * Class: Buffer
	 * =============
	 *
	 * The Buffer constructor returns instances of `Uint8Array` that are augmented
	 * with function properties for all the node `Buffer` API functions. We use
	 * `Uint8Array` so that square bracket notation works as expected -- it returns
	 * a single octet.
	 *
	 * By augmenting the instances, we can avoid modifying the `Uint8Array`
	 * prototype.
	 */
	function Buffer (arg) {
	  if (!(this instanceof Buffer)) {
	    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
	    if (arguments.length > 1) return new Buffer(arg, arguments[1])
	    return new Buffer(arg)
	  }
	
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    this.length = 0
	    this.parent = undefined
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    return fromNumber(this, arg)
	  }
	
	  // Slightly less common case.
	  if (typeof arg === 'string') {
	    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
	  }
	
	  // Unusual.
	  return fromObject(this, arg)
	}
	
	function fromNumber (that, length) {
	  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < length; i++) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'
	
	  // Assumption: byteLength() return value is always < kMaxLength.
	  var length = byteLength(string, encoding) | 0
	  that = allocate(that, length)
	
	  that.write(string, encoding)
	  return that
	}
	
	function fromObject (that, object) {
	  if (Buffer.isBuffer(object)) return fromBuffer(that, object)
	
	  if (isArray(object)) return fromArray(that, object)
	
	  if (object == null) {
	    throw new TypeError('must start with number, buffer, array or string')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined') {
	    if (object.buffer instanceof ArrayBuffer) {
	      return fromTypedArray(that, object)
	    }
	    if (object instanceof ArrayBuffer) {
	      return fromArrayBuffer(that, object)
	    }
	  }
	
	  if (object.length) return fromArrayLike(that, object)
	
	  return fromJsonObject(that, object)
	}
	
	function fromBuffer (that, buffer) {
	  var length = checked(buffer.length) | 0
	  that = allocate(that, length)
	  buffer.copy(that, 0, 0, length)
	  return that
	}
	
	function fromArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Duplicate of fromArray() to keep fromArray() monomorphic.
	function fromTypedArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  // Truncating the elements is probably not what people expect from typed
	  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
	  // of the old Buffer constructor.
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    array.byteLength
	    that = Buffer._augment(new Uint8Array(array))
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromTypedArray(that, new Uint8Array(array))
	  }
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
	// Returns a zero-length buffer for inputs that don't conform to the spec.
	function fromJsonObject (that, object) {
	  var array
	  var length = 0
	
	  if (object.type === 'Buffer' && isArray(object.data)) {
	    array = object.data
	    length = checked(array.length) | 0
	  }
	  that = allocate(that, length)
	
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	} else {
	  // pre-set for values that may exist in the future
	  Buffer.prototype.length = undefined
	  Buffer.prototype.parent = undefined
	}
	
	function allocate (that, length) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = Buffer._augment(new Uint8Array(length))
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that.length = length
	    that._isBuffer = true
	  }
	
	  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
	  if (fromPool) that.parent = rootParent
	
	  return that
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (subject, encoding) {
	  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)
	
	  var buf = new Buffer(subject, encoding)
	  delete buf.parent
	  return buf
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  var i = 0
	  var len = Math.min(x, y)
	  while (i < len) {
	    if (a[i] !== b[i]) break
	
	    ++i
	  }
	
	  if (i !== len) {
	    x = a[i]
	    y = b[i]
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'binary':
	    case 'base64':
	    case 'raw':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')
	
	  if (list.length === 0) {
	    return new Buffer(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; i++) {
	      length += list[i].length
	    }
	  }
	
	  var buf = new Buffer(length)
	  var pos = 0
	  for (i = 0; i < list.length; i++) {
	    var item = list[i]
	    item.copy(buf, pos)
	    pos += item.length
	  }
	  return buf
	}
	
	function byteLength (string, encoding) {
	  if (typeof string !== 'string') string = '' + string
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'binary':
	      // Deprecated
	      case 'raw':
	      case 'raws':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  start = start | 0
	  end = end === undefined || end === Infinity ? this.length : end | 0
	
	  if (!encoding) encoding = 'utf8'
	  if (start < 0) start = 0
	  if (end > this.length) end = this.length
	  if (end <= start) return ''
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'binary':
	        return binarySlice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return 0
	  return Buffer.compare(this, b)
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
	  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
	  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
	  byteOffset >>= 0
	
	  if (this.length === 0) return -1
	  if (byteOffset >= this.length) return -1
	
	  // Negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)
	
	  if (typeof val === 'string') {
	    if (val.length === 0) return -1 // special case: looking for empty string always fails
	    return String.prototype.indexOf.call(this, val, byteOffset)
	  }
	  if (Buffer.isBuffer(val)) {
	    return arrayIndexOf(this, val, byteOffset)
	  }
	  if (typeof val === 'number') {
	    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
	      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
	    }
	    return arrayIndexOf(this, [ val ], byteOffset)
	  }
	
	  function arrayIndexOf (arr, val, byteOffset) {
	    var foundIndex = -1
	    for (var i = 0; byteOffset + i < arr.length; i++) {
	      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
	      } else {
	        foundIndex = -1
	      }
	    }
	    return -1
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	// `get` is deprecated
	Buffer.prototype.get = function get (offset) {
	  console.log('.get() is deprecated. Access using array indexes instead.')
	  return this.readUInt8(offset)
	}
	
	// `set` is deprecated
	Buffer.prototype.set = function set (v, offset) {
	  console.log('.set() is deprecated. Access using array indexes instead.')
	  return this.writeUInt8(v, offset)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new Error('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; i++) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) throw new Error('Invalid hex string')
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function binaryWrite (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    var swap = encoding
	    encoding = offset
	    offset = length | 0
	    length = swap
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'binary':
	        return binaryWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function binarySlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; i++) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = Buffer._augment(this.subarray(start, end))
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; i++) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  if (newBuf.length) newBuf.parent = this.parent || this
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	  if (offset < 0) throw new RangeError('index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; i--) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; i++) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    target._set(this.subarray(start, start + len), targetStart)
	  }
	
	  return len
	}
	
	// fill(value, start=0, end=buffer.length)
	Buffer.prototype.fill = function fill (value, start, end) {
	  if (!value) value = 0
	  if (!start) start = 0
	  if (!end) end = this.length
	
	  if (end < start) throw new RangeError('end < start')
	
	  // Fill 0 bytes; we're done
	  if (end === start) return
	  if (this.length === 0) return
	
	  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
	  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')
	
	  var i
	  if (typeof value === 'number') {
	    for (i = start; i < end; i++) {
	      this[i] = value
	    }
	  } else {
	    var bytes = utf8ToBytes(value.toString())
	    var len = bytes.length
	    for (i = start; i < end; i++) {
	      this[i] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	/**
	 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
	 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
	 */
	Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
	  if (typeof Uint8Array !== 'undefined') {
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      return (new Buffer(this)).buffer
	    } else {
	      var buf = new Uint8Array(this.length)
	      for (var i = 0, len = buf.length; i < len; i += 1) {
	        buf[i] = this[i]
	      }
	      return buf.buffer
	    }
	  } else {
	    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
	  }
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var BP = Buffer.prototype
	
	/**
	 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
	 */
	Buffer._augment = function _augment (arr) {
	  arr.constructor = Buffer
	  arr._isBuffer = true
	
	  // save reference to original Uint8Array set method before overwriting
	  arr._set = arr.set
	
	  // deprecated
	  arr.get = BP.get
	  arr.set = BP.set
	
	  arr.write = BP.write
	  arr.toString = BP.toString
	  arr.toLocaleString = BP.toString
	  arr.toJSON = BP.toJSON
	  arr.equals = BP.equals
	  arr.compare = BP.compare
	  arr.indexOf = BP.indexOf
	  arr.copy = BP.copy
	  arr.slice = BP.slice
	  arr.readUIntLE = BP.readUIntLE
	  arr.readUIntBE = BP.readUIntBE
	  arr.readUInt8 = BP.readUInt8
	  arr.readUInt16LE = BP.readUInt16LE
	  arr.readUInt16BE = BP.readUInt16BE
	  arr.readUInt32LE = BP.readUInt32LE
	  arr.readUInt32BE = BP.readUInt32BE
	  arr.readIntLE = BP.readIntLE
	  arr.readIntBE = BP.readIntBE
	  arr.readInt8 = BP.readInt8
	  arr.readInt16LE = BP.readInt16LE
	  arr.readInt16BE = BP.readInt16BE
	  arr.readInt32LE = BP.readInt32LE
	  arr.readInt32BE = BP.readInt32BE
	  arr.readFloatLE = BP.readFloatLE
	  arr.readFloatBE = BP.readFloatBE
	  arr.readDoubleLE = BP.readDoubleLE
	  arr.readDoubleBE = BP.readDoubleBE
	  arr.writeUInt8 = BP.writeUInt8
	  arr.writeUIntLE = BP.writeUIntLE
	  arr.writeUIntBE = BP.writeUIntBE
	  arr.writeUInt16LE = BP.writeUInt16LE
	  arr.writeUInt16BE = BP.writeUInt16BE
	  arr.writeUInt32LE = BP.writeUInt32LE
	  arr.writeUInt32BE = BP.writeUInt32BE
	  arr.writeIntLE = BP.writeIntLE
	  arr.writeIntBE = BP.writeIntBE
	  arr.writeInt8 = BP.writeInt8
	  arr.writeInt16LE = BP.writeInt16LE
	  arr.writeInt16BE = BP.writeInt16BE
	  arr.writeInt32LE = BP.writeInt32LE
	  arr.writeInt32BE = BP.writeInt32BE
	  arr.writeFloatLE = BP.writeFloatLE
	  arr.writeFloatBE = BP.writeFloatBE
	  arr.writeDoubleLE = BP.writeDoubleLE
	  arr.writeDoubleBE = BP.writeDoubleBE
	  arr.fill = BP.fill
	  arr.inspect = BP.inspect
	  arr.toArrayBuffer = BP.toArrayBuffer
	
	  return arr
	}
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; i++) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; i++) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer, (function() { return this; }())))

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(676);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(66);
	var dPs = __webpack_require__(690);
	var enumBugKeys = __webpack_require__(178);
	var IE_PROTO = __webpack_require__(182)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(291)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(681).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 180 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(64).f;
	var has = __webpack_require__(68);
	var TAG = __webpack_require__(37)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(183)('keys');
	var uid = __webpack_require__(126);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(27);
	var global = __webpack_require__(63);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(124) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(83);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(63);
	var core = __webpack_require__(27);
	var LIBRARY = __webpack_require__(124);
	var wksExt = __webpack_require__(187);
	var defineProperty = __webpack_require__(64).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(37);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(698);
	var global = __webpack_require__(63);
	var hide = __webpack_require__(82);
	var Iterators = __webpack_require__(84);
	var TO_STRING_TAG = __webpack_require__(37)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(713)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(304)
	
	exports.createHmac = __webpack_require__(709)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(712)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(656)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 190 */
128,
/* 191 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	/**
	* Detect Element Resize
	*
	* https://github.com/sdecima/javascript-detect-element-resize
	* Sebastian Decima
	*
	* version: 0.5.3
	**/
	
	(function () {
		var attachEvent = document.attachEvent,
			stylesCreated = false;
		
		if (!attachEvent) {
			var requestFrame = (function(){
				var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
									function(fn){ return window.setTimeout(fn, 20); };
				return function(fn){ return raf(fn); };
			})();
			
			var cancelFrame = (function(){
				var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame ||
									   window.clearTimeout;
			  return function(id){ return cancel(id); };
			})();
	
			function resetTriggers(element){
				var triggers = element.__resizeTriggers__,
					expand = triggers.firstElementChild,
					contract = triggers.lastElementChild,
					expandChild = expand.firstElementChild;
				contract.scrollLeft = contract.scrollWidth;
				contract.scrollTop = contract.scrollHeight;
				expandChild.style.width = expand.offsetWidth + 1 + 'px';
				expandChild.style.height = expand.offsetHeight + 1 + 'px';
				expand.scrollLeft = expand.scrollWidth;
				expand.scrollTop = expand.scrollHeight;
			};
	
			function checkTriggers(element){
				return element.offsetWidth != element.__resizeLast__.width ||
							 element.offsetHeight != element.__resizeLast__.height;
			}
			
			function scrollListener(e){
				var element = this;
				resetTriggers(this);
				if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
				this.__resizeRAF__ = requestFrame(function(){
					if (checkTriggers(element)) {
						element.__resizeLast__.width = element.offsetWidth;
						element.__resizeLast__.height = element.offsetHeight;
						element.__resizeListeners__.forEach(function(fn){
							fn.call(element, e);
						});
					}
				});
			};
			
			/* Detect CSS Animations support to detect element display/re-attach */
			var animation = false,
				animationstring = 'animation',
				keyframeprefix = '',
				animationstartevent = 'animationstart',
				domPrefixes = 'Webkit Moz O ms'.split(' '),
				startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
				pfx  = '';
			{
				var elm = document.createElement('fakeelement');
				if( elm.style.animationName !== undefined ) { animation = true; }    
				
				if( animation === false ) {
					for( var i = 0; i < domPrefixes.length; i++ ) {
						if( elm.style[ domPrefixes[i] + 'AnimationName' ] !== undefined ) {
							pfx = domPrefixes[ i ];
							animationstring = pfx + 'Animation';
							keyframeprefix = '-' + pfx.toLowerCase() + '-';
							animationstartevent = startEvents[ i ];
							animation = true;
							break;
						}
					}
				}
			}
			
			var animationName = 'resizeanim';
			var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
			var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
		}
		
		function createStyles() {
			if (!stylesCreated) {
				//opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
				var css = (animationKeyframes ? animationKeyframes : '') +
						'.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' +
						'.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
					head = document.head || document.getElementsByTagName('head')[0],
					style = document.createElement('style');
				
				style.type = 'text/css';
				if (style.styleSheet) {
					style.styleSheet.cssText = css;
				} else {
					style.appendChild(document.createTextNode(css));
				}
	
				head.appendChild(style);
				stylesCreated = true;
			}
		}
		
		window.addResizeListener = function(element, fn){
			if (attachEvent) element.attachEvent('onresize', fn);
			else {
				if (!element.__resizeTriggers__) {
					if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
					createStyles();
					element.__resizeLast__ = {};
					element.__resizeListeners__ = [];
					(element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
					element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' +
																							'<div class="contract-trigger"></div>';
					element.appendChild(element.__resizeTriggers__);
					resetTriggers(element);
					element.addEventListener('scroll', scrollListener, true);
					
					/* Listen for a css animation to detect element display/re-attach */
					animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function(e) {
						if(e.animationName == animationName)
							resetTriggers(element);
					});
				}
				element.__resizeListeners__.push(fn);
			}
		};
		
		window.removeResizeListener = function(element, fn){
			if (attachEvent) element.detachEvent('onresize', fn);
			else {
				element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
				if (!element.__resizeListeners__.length) {
						element.removeEventListener('scroll', scrollListener);
						element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
				}
			}
		}
	})();

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* AUTO-GENERATED. DO NOT MODIFY. */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	
	
	 CSS Beautifier
	---------------
	
	    Written by Harutyun Amirjanyan, (amirjanyan@gmail.com)
	
	    Based on code initially developed by: Einar Lielmanis, <einar@beautifier.io>
	        https://beautifier.io/
	
	    Usage:
	        css_beautify(source_text);
	        css_beautify(source_text, options);
	
	    The options are (default in brackets):
	        indent_size (4)                         — indentation size,
	        indent_char (space)                     — character to indent with,
	        selector_separator_newline (true)       - separate selectors with newline or
	                                                  not (e.g. "a,\nbr" or "a, br")
	        end_with_newline (false)                - end with a newline
	        newline_between_rules (true)            - add a new line after every css rule
	        space_around_selector_separator (false) - ensure space around selector separators:
	                                                  '>', '+', '~' (e.g. "a>b" -> "a > b")
	    e.g
	
	    css_beautify(css_source_text, {
	      'indent_size': 1,
	      'indent_char': '\t',
	      'selector_separator': ' ',
	      'end_with_newline': false,
	      'newline_between_rules': true,
	      'space_around_selector_separator': true
	    });
	*/
	
	// http://www.w3.org/TR/CSS21/syndata.html#tokenization
	// http://www.w3.org/TR/css3-syntax/
	
	(function() {
	
	/* GENERATED_BUILD_OUTPUT */
	var legacy_beautify_css =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 12);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */,
	/* 1 */,
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function OutputLine(parent) {
	  this.__parent = parent;
	  this.__character_count = 0;
	  // use indent_count as a marker for this.__lines that have preserved indentation
	  this.__indent_count = -1;
	  this.__alignment_count = 0;
	
	  this.__items = [];
	}
	
	OutputLine.prototype.item = function(index) {
	  if (index < 0) {
	    return this.__items[this.__items.length + index];
	  } else {
	    return this.__items[index];
	  }
	};
	
	OutputLine.prototype.has_match = function(pattern) {
	  for (var lastCheckedOutput = this.__items.length - 1; lastCheckedOutput >= 0; lastCheckedOutput--) {
	    if (this.__items[lastCheckedOutput].match(pattern)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	OutputLine.prototype.set_indent = function(indent, alignment) {
	  this.__indent_count = indent || 0;
	  this.__alignment_count = alignment || 0;
	  this.__character_count = this.__parent.baseIndentLength + this.__alignment_count + this.__indent_count * this.__parent.indent_length;
	};
	
	OutputLine.prototype.get_character_count = function() {
	  return this.__character_count;
	};
	
	OutputLine.prototype.is_empty = function() {
	  return this.__items.length === 0;
	};
	
	OutputLine.prototype.last = function() {
	  if (!this.is_empty()) {
	    return this.__items[this.__items.length - 1];
	  } else {
	    return null;
	  }
	};
	
	OutputLine.prototype.push = function(item) {
	  this.__items.push(item);
	  this.__character_count += item.length;
	};
	
	OutputLine.prototype.push_raw = function(item) {
	  this.push(item);
	  var last_newline_index = item.lastIndexOf('\n');
	  if (last_newline_index !== -1) {
	    this.__character_count = item.length - last_newline_index;
	  }
	};
	
	OutputLine.prototype.pop = function() {
	  var item = null;
	  if (!this.is_empty()) {
	    item = this.__items.pop();
	    this.__character_count -= item.length;
	  }
	  return item;
	};
	
	OutputLine.prototype.remove_indent = function() {
	  if (this.__indent_count > 0) {
	    this.__indent_count -= 1;
	    this.__character_count -= this.__parent.indent_length;
	  }
	};
	
	OutputLine.prototype.trim = function() {
	  while (this.last() === ' ') {
	    this.__items.pop();
	    this.__character_count -= 1;
	  }
	};
	
	OutputLine.prototype.toString = function() {
	  var result = '';
	  if (!this.is_empty()) {
	    if (this.__indent_count >= 0) {
	      result = this.__parent.get_indent_string(this.__indent_count);
	    }
	    if (this.__alignment_count >= 0) {
	      result += this.__parent.get_alignment_string(this.__alignment_count);
	    }
	    result += this.__items.join('');
	  }
	  return result;
	};
	
	function IndentCache(base_string, level_string) {
	  this.__cache = [base_string];
	  this.__level_string = level_string;
	}
	
	IndentCache.prototype.__ensure_cache = function(level) {
	  while (level >= this.__cache.length) {
	    this.__cache.push(this.__cache[this.__cache.length - 1] + this.__level_string);
	  }
	};
	
	IndentCache.prototype.get_level_string = function(level) {
	  this.__ensure_cache(level);
	  return this.__cache[level];
	};
	
	
	function Output(options, baseIndentString) {
	  var indent_string = options.indent_char;
	  if (options.indent_size > 1) {
	    indent_string = new Array(options.indent_size + 1).join(options.indent_char);
	  }
	
	  // Set to null to continue support for auto detection of base indent level.
	  baseIndentString = baseIndentString || '';
	  if (options.indent_level > 0) {
	    baseIndentString = new Array(options.indent_level + 1).join(indent_string);
	  }
	
	  this.__indent_cache = new IndentCache(baseIndentString, indent_string);
	  this.__alignment_cache = new IndentCache('', ' ');
	  this.baseIndentLength = baseIndentString.length;
	  this.indent_length = indent_string.length;
	  this.raw = false;
	  this._end_with_newline = options.end_with_newline;
	
	  this.__lines = [];
	  this.previous_line = null;
	  this.current_line = null;
	  this.space_before_token = false;
	  // initialize
	  this.__add_outputline();
	}
	
	Output.prototype.__add_outputline = function() {
	  this.previous_line = this.current_line;
	  this.current_line = new OutputLine(this);
	  this.__lines.push(this.current_line);
	};
	
	Output.prototype.get_line_number = function() {
	  return this.__lines.length;
	};
	
	Output.prototype.get_indent_string = function(level) {
	  return this.__indent_cache.get_level_string(level);
	};
	
	Output.prototype.get_alignment_string = function(level) {
	  return this.__alignment_cache.get_level_string(level);
	};
	
	Output.prototype.is_empty = function() {
	  return !this.previous_line && this.current_line.is_empty();
	};
	
	Output.prototype.add_new_line = function(force_newline) {
	  // never newline at the start of file
	  // otherwise, newline only if we didn't just add one or we're forced
	  if (this.is_empty() ||
	    (!force_newline && this.just_added_newline())) {
	    return false;
	  }
	
	  // if raw output is enabled, don't print additional newlines,
	  // but still return True as though you had
	  if (!this.raw) {
	    this.__add_outputline();
	  }
	  return true;
	};
	
	Output.prototype.get_code = function(eol) {
	  var sweet_code = this.__lines.join('\n').replace(/[\r\n\t ]+$/, '');
	
	  if (this._end_with_newline) {
	    sweet_code += '\n';
	  }
	
	  if (eol !== '\n') {
	    sweet_code = sweet_code.replace(/[\n]/g, eol);
	  }
	
	  return sweet_code;
	};
	
	Output.prototype.set_indent = function(indent, alignment) {
	  indent = indent || 0;
	  alignment = alignment || 0;
	
	  // Never indent your first output indent at the start of the file
	  if (this.__lines.length > 1) {
	    this.current_line.set_indent(indent, alignment);
	    return true;
	  }
	  this.current_line.set_indent();
	  return false;
	};
	
	Output.prototype.add_raw_token = function(token) {
	  for (var x = 0; x < token.newlines; x++) {
	    this.__add_outputline();
	  }
	  this.current_line.push(token.whitespace_before);
	  this.current_line.push_raw(token.text);
	  this.space_before_token = false;
	};
	
	Output.prototype.add_token = function(printable_token) {
	  this.add_space_before_token();
	  this.current_line.push(printable_token);
	};
	
	Output.prototype.add_space_before_token = function() {
	  if (this.space_before_token && !this.just_added_newline()) {
	    this.current_line.push(' ');
	  }
	  this.space_before_token = false;
	};
	
	Output.prototype.remove_indent = function(index) {
	  var output_length = this.__lines.length;
	  while (index < output_length) {
	    this.__lines[index].remove_indent();
	    index++;
	  }
	};
	
	Output.prototype.trim = function(eat_newlines) {
	  eat_newlines = (eat_newlines === undefined) ? false : eat_newlines;
	
	  this.current_line.trim(this.indent_string, this.baseIndentString);
	
	  while (eat_newlines && this.__lines.length > 1 &&
	    this.current_line.is_empty()) {
	    this.__lines.pop();
	    this.current_line = this.__lines[this.__lines.length - 1];
	    this.current_line.trim();
	  }
	
	  this.previous_line = this.__lines.length > 1 ?
	    this.__lines[this.__lines.length - 2] : null;
	};
	
	Output.prototype.just_added_newline = function() {
	  return this.current_line.is_empty();
	};
	
	Output.prototype.just_added_blankline = function() {
	  return this.is_empty() ||
	    (this.current_line.is_empty() && this.previous_line.is_empty());
	};
	
	Output.prototype.ensure_empty_line_above = function(starts_with, ends_with) {
	  var index = this.__lines.length - 2;
	  while (index >= 0) {
	    var potentialEmptyLine = this.__lines[index];
	    if (potentialEmptyLine.is_empty()) {
	      break;
	    } else if (potentialEmptyLine.item(0).indexOf(starts_with) !== 0 &&
	      potentialEmptyLine.item(-1) !== ends_with) {
	      this.__lines.splice(index + 1, 0, new OutputLine(this));
	      this.previous_line = this.__lines[this.__lines.length - 2];
	      break;
	    }
	    index--;
	  }
	};
	
	module.exports.Output = Output;
	
	
	/***/ }),
	/* 3 */,
	/* 4 */,
	/* 5 */,
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function Options(options, merge_child_field) {
	  this.raw_options = _mergeOpts(options, merge_child_field);
	
	  // Support passing the source text back with no change
	  this.disabled = this._get_boolean('disabled');
	
	  this.eol = this._get_characters('eol', 'auto');
	  this.end_with_newline = this._get_boolean('end_with_newline');
	  this.indent_size = this._get_number('indent_size', 4);
	  this.indent_char = this._get_characters('indent_char', ' ');
	  this.indent_level = this._get_number('indent_level');
	
	  this.preserve_newlines = this._get_boolean('preserve_newlines', true);
	  this.max_preserve_newlines = this._get_number('max_preserve_newlines', 32786);
	  if (!this.preserve_newlines) {
	    this.max_preserve_newlines = 0;
	  }
	
	  this.indent_with_tabs = this._get_boolean('indent_with_tabs');
	  if (this.indent_with_tabs) {
	    this.indent_char = '\t';
	    this.indent_size = 1;
	  }
	
	  // Backwards compat with 1.3.x
	  this.wrap_line_length = this._get_number('wrap_line_length', this._get_number('max_char'));
	
	}
	
	Options.prototype._get_array = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  var result = default_value || [];
	  if (typeof option_value === 'object') {
	    if (option_value !== null && typeof option_value.concat === 'function') {
	      result = option_value.concat();
	    }
	  } else if (typeof option_value === 'string') {
	    result = option_value.split(/[^a-zA-Z0-9_\/\-]+/);
	  }
	  return result;
	};
	
	Options.prototype._get_boolean = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  var result = option_value === undefined ? !!default_value : !!option_value;
	  return result;
	};
	
	Options.prototype._get_characters = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  var result = default_value || '';
	  if (typeof option_value === 'string') {
	    result = option_value.replace(/\\r/, '\r').replace(/\\n/, '\n').replace(/\\t/, '\t');
	  }
	  return result;
	};
	
	Options.prototype._get_number = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  default_value = parseInt(default_value, 10);
	  if (isNaN(default_value)) {
	    default_value = 0;
	  }
	  var result = parseInt(option_value, 10);
	  if (isNaN(result)) {
	    result = default_value;
	  }
	  return result;
	};
	
	Options.prototype._get_selection = function(name, selection_list, default_value) {
	  var result = this._get_selection_list(name, selection_list, default_value);
	  if (result.length !== 1) {
	    throw new Error(
	      "Invalid Option Value: The option '" + name + "' can only be one of the following values:\n" +
	      selection_list + "\nYou passed in: '" + this.raw_options[name] + "'");
	  }
	
	  return result[0];
	};
	
	
	Options.prototype._get_selection_list = function(name, selection_list, default_value) {
	  if (!selection_list || selection_list.length === 0) {
	    throw new Error("Selection list cannot be empty.");
	  }
	
	  default_value = default_value || [selection_list[0]];
	  if (!this._is_valid_selection(default_value, selection_list)) {
	    throw new Error("Invalid Default Value!");
	  }
	
	  var result = this._get_array(name, default_value);
	  if (!this._is_valid_selection(result, selection_list)) {
	    throw new Error(
	      "Invalid Option Value: The option '" + name + "' can contain only the following values:\n" +
	      selection_list + "\nYou passed in: '" + this.raw_options[name] + "'");
	  }
	
	  return result;
	};
	
	Options.prototype._is_valid_selection = function(result, selection_list) {
	  return result.length && selection_list.length &&
	    !result.some(function(item) { return selection_list.indexOf(item) === -1; });
	};
	
	
	// merges child options up with the parent options object
	// Example: obj = {a: 1, b: {a: 2}}
	//          mergeOpts(obj, 'b')
	//
	//          Returns: {a: 2}
	function _mergeOpts(allOptions, childFieldName) {
	  var finalOpts = {};
	  allOptions = _normalizeOpts(allOptions);
	  var name;
	
	  for (name in allOptions) {
	    if (name !== childFieldName) {
	      finalOpts[name] = allOptions[name];
	    }
	  }
	
	  //merge in the per type settings for the childFieldName
	  if (childFieldName && allOptions[childFieldName]) {
	    for (name in allOptions[childFieldName]) {
	      finalOpts[name] = allOptions[childFieldName][name];
	    }
	  }
	  return finalOpts;
	}
	
	function _normalizeOpts(options) {
	  var convertedOpts = {};
	  var key;
	
	  for (key in options) {
	    var newKey = key.replace(/-/g, "_");
	    convertedOpts[newKey] = options[key];
	  }
	  return convertedOpts;
	}
	
	module.exports.Options = Options;
	module.exports.normalizeOpts = _normalizeOpts;
	module.exports.mergeOpts = _mergeOpts;
	
	
	/***/ }),
	/* 7 */,
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function InputScanner(input_string) {
	  this.__input = input_string || '';
	  this.__input_length = this.__input.length;
	  this.__position = 0;
	}
	
	InputScanner.prototype.restart = function() {
	  this.__position = 0;
	};
	
	InputScanner.prototype.back = function() {
	  if (this.__position > 0) {
	    this.__position -= 1;
	  }
	};
	
	InputScanner.prototype.hasNext = function() {
	  return this.__position < this.__input_length;
	};
	
	InputScanner.prototype.next = function() {
	  var val = null;
	  if (this.hasNext()) {
	    val = this.__input.charAt(this.__position);
	    this.__position += 1;
	  }
	  return val;
	};
	
	InputScanner.prototype.peek = function(index) {
	  var val = null;
	  index = index || 0;
	  index += this.__position;
	  if (index >= 0 && index < this.__input_length) {
	    val = this.__input.charAt(index);
	  }
	  return val;
	};
	
	InputScanner.prototype.test = function(pattern, index) {
	  index = index || 0;
	  index += this.__position;
	  pattern.lastIndex = index;
	
	  if (index >= 0 && index < this.__input_length) {
	    var pattern_match = pattern.exec(this.__input);
	    return pattern_match && pattern_match.index === index;
	  } else {
	    return false;
	  }
	};
	
	InputScanner.prototype.testChar = function(pattern, index) {
	  // test one character regex match
	  var val = this.peek(index);
	  return val !== null && pattern.test(val);
	};
	
	InputScanner.prototype.match = function(pattern) {
	  pattern.lastIndex = this.__position;
	  var pattern_match = pattern.exec(this.__input);
	  if (pattern_match && pattern_match.index === this.__position) {
	    this.__position += pattern_match[0].length;
	  } else {
	    pattern_match = null;
	  }
	  return pattern_match;
	};
	
	InputScanner.prototype.read = function(pattern) {
	  var val = '';
	  var match = this.match(pattern);
	  if (match) {
	    val = match[0];
	  }
	  return val;
	};
	
	InputScanner.prototype.readUntil = function(pattern, include_match) {
	  var val = '';
	  var match_index = this.__position;
	  pattern.lastIndex = this.__position;
	  var pattern_match = pattern.exec(this.__input);
	  if (pattern_match) {
	    if (include_match) {
	      match_index = pattern_match.index + pattern_match[0].length;
	    } else {
	      match_index = pattern_match.index;
	    }
	  } else {
	    match_index = this.__input_length;
	  }
	
	  val = this.__input.substring(this.__position, match_index);
	  this.__position = match_index;
	  return val;
	};
	
	InputScanner.prototype.readUntilAfter = function(pattern) {
	  return this.readUntil(pattern, true);
	};
	
	/* css beautifier legacy helpers */
	InputScanner.prototype.peekUntilAfter = function(pattern) {
	  var start = this.__position;
	  var val = this.readUntilAfter(pattern);
	  this.__position = start;
	  return val;
	};
	
	InputScanner.prototype.lookBack = function(testVal) {
	  var start = this.__position - 1;
	  return start >= testVal.length && this.__input.substring(start - testVal.length, start)
	    .toLowerCase() === testVal;
	};
	
	
	module.exports.InputScanner = InputScanner;
	
	
	/***/ }),
	/* 9 */,
	/* 10 */,
	/* 11 */,
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var Beautifier = __webpack_require__(13).Beautifier;
	
	function css_beautify(source_text, options) {
	  var beautifier = new Beautifier(source_text, options);
	  return beautifier.beautify();
	}
	
	module.exports = css_beautify;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var Options = __webpack_require__(14).Options;
	var Output = __webpack_require__(2).Output;
	var InputScanner = __webpack_require__(8).InputScanner;
	
	var lineBreak = /\r\n|[\r\n]/;
	var allLineBreaks = /\r\n|[\r\n]/g;
	
	// tokenizer
	var whitespaceChar = /\s/;
	var whitespacePattern = /(?:\s|\n)+/g;
	var block_comment_pattern = /\/\*(?:[\s\S]*?)((?:\*\/)|$)/g;
	var comment_pattern = /\/\/(?:[^\n\r\u2028\u2029]*)/g;
	
	function Beautifier(source_text, options) {
	  this._source_text = source_text || '';
	  // Allow the setting of language/file-type specific options
	  // with inheritance of overall settings
	  this._options = new Options(options);
	  this._ch = null;
	  this._input = null;
	
	  // https://developer.mozilla.org/en-US/docs/Web/CSS/At-rule
	  this.NESTED_AT_RULE = {
	    "@page": true,
	    "@font-face": true,
	    "@keyframes": true,
	    // also in CONDITIONAL_GROUP_RULE below
	    "@media": true,
	    "@supports": true,
	    "@document": true
	  };
	  this.CONDITIONAL_GROUP_RULE = {
	    "@media": true,
	    "@supports": true,
	    "@document": true
	  };
	
	}
	
	Beautifier.prototype.eatString = function(endChars) {
	  var result = '';
	  this._ch = this._input.next();
	  while (this._ch) {
	    result += this._ch;
	    if (this._ch === "\\") {
	      result += this._input.next();
	    } else if (endChars.indexOf(this._ch) !== -1 || this._ch === "\n") {
	      break;
	    }
	    this._ch = this._input.next();
	  }
	  return result;
	};
	
	// Skips any white space in the source text from the current position.
	// When allowAtLeastOneNewLine is true, will output new lines for each
	// newline character found; if the user has preserve_newlines off, only
	// the first newline will be output
	Beautifier.prototype.eatWhitespace = function(allowAtLeastOneNewLine) {
	  var result = whitespaceChar.test(this._input.peek());
	  var isFirstNewLine = true;
	
	  while (whitespaceChar.test(this._input.peek())) {
	    this._ch = this._input.next();
	    if (allowAtLeastOneNewLine && this._ch === '\n') {
	      if (this._options.preserve_newlines || isFirstNewLine) {
	        isFirstNewLine = false;
	        this._output.add_new_line(true);
	      }
	    }
	  }
	  return result;
	};
	
	// Nested pseudo-class if we are insideRule
	// and the next special character found opens
	// a new block
	Beautifier.prototype.foundNestedPseudoClass = function() {
	  var openParen = 0;
	  var i = 1;
	  var ch = this._input.peek(i);
	  while (ch) {
	    if (ch === "{") {
	      return true;
	    } else if (ch === '(') {
	      // pseudoclasses can contain ()
	      openParen += 1;
	    } else if (ch === ')') {
	      if (openParen === 0) {
	        return false;
	      }
	      openParen -= 1;
	    } else if (ch === ";" || ch === "}") {
	      return false;
	    }
	    i++;
	    ch = this._input.peek(i);
	  }
	  return false;
	};
	
	Beautifier.prototype.print_string = function(output_string) {
	  if (this._output.just_added_newline()) {
	    this._output.set_indent(this._indentLevel);
	  }
	  this._output.add_token(output_string);
	};
	
	Beautifier.prototype.preserveSingleSpace = function(isAfterSpace) {
	  if (isAfterSpace) {
	    this._output.space_before_token = true;
	  }
	};
	
	Beautifier.prototype.indent = function() {
	  this._indentLevel++;
	};
	
	Beautifier.prototype.outdent = function() {
	  if (this._indentLevel > 0) {
	    this._indentLevel--;
	  }
	};
	
	/*_____________________--------------------_____________________*/
	
	Beautifier.prototype.beautify = function() {
	  if (this._options.disabled) {
	    return this._source_text;
	  }
	
	  var source_text = this._source_text;
	  var eol = this._options.eol;
	  if (eol === 'auto') {
	    eol = '\n';
	    if (source_text && lineBreak.test(source_text || '')) {
	      eol = source_text.match(lineBreak)[0];
	    }
	  }
	
	
	  // HACK: newline parsing inconsistent. This brute force normalizes the this._input.
	  source_text = source_text.replace(allLineBreaks, '\n');
	
	  // reset
	  var baseIndentString = source_text.match(/^[\t ]*/)[0];
	
	  this._output = new Output(this._options, baseIndentString);
	  this._input = new InputScanner(source_text);
	  this._indentLevel = 0;
	  this._nestedLevel = 0;
	
	  this._ch = null;
	  var parenLevel = 0;
	
	  var insideRule = false;
	  // This is the value side of a property value pair (blue in the following ex)
	  // label { content: blue }
	  var insidePropertyValue = false;
	  var enteringConditionalGroup = false;
	  var insideAtExtend = false;
	  var insideAtImport = false;
	  var topCharacter = this._ch;
	
	  while (true) {
	    var whitespace = this._input.read(whitespacePattern);
	    var isAfterSpace = whitespace !== '';
	    var previous_ch = topCharacter;
	    this._ch = this._input.next();
	    topCharacter = this._ch;
	
	    if (!this._ch) {
	      break;
	    } else if (this._ch === '/' && this._input.peek() === '*') {
	      // /* css comment */
	      // Always start block comments on a new line.
	      // This handles scenarios where a block comment immediately
	      // follows a property definition on the same line or where
	      // minified code is being beautified.
	      this._output.add_new_line();
	      this._input.back();
	      this.print_string(this._input.read(block_comment_pattern));
	
	      // Ensures any new lines following the comment are preserved
	      this.eatWhitespace(true);
	
	      // Block comments are followed by a new line so they don't
	      // share a line with other properties
	      this._output.add_new_line();
	    } else if (this._ch === '/' && this._input.peek() === '/') {
	      // // single line comment
	      // Preserves the space before a comment
	      // on the same line as a rule
	      this._output.space_before_token = true;
	      this._input.back();
	      this.print_string(this._input.read(comment_pattern));
	
	      // Ensures any new lines following the comment are preserved
	      this.eatWhitespace(true);
	    } else if (this._ch === '@') {
	      this.preserveSingleSpace(isAfterSpace);
	
	      // deal with less propery mixins @{...}
	      if (this._input.peek() === '{') {
	        this.print_string(this._ch + this.eatString('}'));
	      } else {
	        this.print_string(this._ch);
	
	        // strip trailing space, if present, for hash property checks
	        var variableOrRule = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);
	
	        if (variableOrRule.match(/[ :]$/)) {
	          // we have a variable or pseudo-class, add it and insert one space before continuing
	          variableOrRule = this.eatString(": ").replace(/\s$/, '');
	          this.print_string(variableOrRule);
	          this._output.space_before_token = true;
	        }
	
	        variableOrRule = variableOrRule.replace(/\s$/, '');
	
	        if (variableOrRule === 'extend') {
	          insideAtExtend = true;
	        } else if (variableOrRule === 'import') {
	          insideAtImport = true;
	        }
	
	        // might be a nesting at-rule
	        if (variableOrRule in this.NESTED_AT_RULE) {
	          this._nestedLevel += 1;
	          if (variableOrRule in this.CONDITIONAL_GROUP_RULE) {
	            enteringConditionalGroup = true;
	          }
	          // might be less variable
	        } else if (!insideRule && parenLevel === 0 && variableOrRule.indexOf(':') !== -1) {
	          insidePropertyValue = true;
	          this.indent();
	        }
	      }
	    } else if (this._ch === '#' && this._input.peek() === '{') {
	      this.preserveSingleSpace(isAfterSpace);
	      this.print_string(this._ch + this.eatString('}'));
	    } else if (this._ch === '{') {
	      if (insidePropertyValue) {
	        insidePropertyValue = false;
	        this.outdent();
	      }
	      this.indent();
	      this._output.space_before_token = true;
	      this.print_string(this._ch);
	
	      // when entering conditional groups, only rulesets are allowed
	      if (enteringConditionalGroup) {
	        enteringConditionalGroup = false;
	        insideRule = (this._indentLevel > this._nestedLevel);
	      } else {
	        // otherwise, declarations are also allowed
	        insideRule = (this._indentLevel >= this._nestedLevel);
	      }
	      if (this._options.newline_between_rules && insideRule) {
	        if (this._output.previous_line && this._output.previous_line.item(-1) !== '{') {
	          this._output.ensure_empty_line_above('/', ',');
	        }
	      }
	      this.eatWhitespace(true);
	      this._output.add_new_line();
	    } else if (this._ch === '}') {
	      this.outdent();
	      this._output.add_new_line();
	      if (previous_ch === '{') {
	        this._output.trim(true);
	      }
	      insideAtImport = false;
	      insideAtExtend = false;
	      if (insidePropertyValue) {
	        this.outdent();
	        insidePropertyValue = false;
	      }
	      this.print_string(this._ch);
	      insideRule = false;
	      if (this._nestedLevel) {
	        this._nestedLevel--;
	      }
	
	      this.eatWhitespace(true);
	      this._output.add_new_line();
	
	      if (this._options.newline_between_rules && !this._output.just_added_blankline()) {
	        if (this._input.peek() !== '}') {
	          this._output.add_new_line(true);
	        }
	      }
	    } else if (this._ch === ":") {
	      if ((insideRule || enteringConditionalGroup) && !(this._input.lookBack("&") || this.foundNestedPseudoClass()) && !this._input.lookBack("(") && !insideAtExtend) {
	        // 'property: value' delimiter
	        // which could be in a conditional group query
	        this.print_string(':');
	        if (!insidePropertyValue) {
	          insidePropertyValue = true;
	          this._output.space_before_token = true;
	          this.eatWhitespace(true);
	          this.indent();
	        }
	      } else {
	        // sass/less parent reference don't use a space
	        // sass nested pseudo-class don't use a space
	
	        // preserve space before pseudoclasses/pseudoelements, as it means "in any child"
	        if (this._input.lookBack(" ")) {
	          this._output.space_before_token = true;
	        }
	        if (this._input.peek() === ":") {
	          // pseudo-element
	          this._ch = this._input.next();
	          this.print_string("::");
	        } else {
	          // pseudo-class
	          this.print_string(':');
	        }
	      }
	    } else if (this._ch === '"' || this._ch === '\'') {
	      this.preserveSingleSpace(isAfterSpace);
	      this.print_string(this._ch + this.eatString(this._ch));
	      this.eatWhitespace(true);
	    } else if (this._ch === ';') {
	      if (insidePropertyValue) {
	        this.outdent();
	        insidePropertyValue = false;
	      }
	      insideAtExtend = false;
	      insideAtImport = false;
	      this.print_string(this._ch);
	      this.eatWhitespace(true);
	
	      // This maintains single line comments on the same
	      // line. Block comments are also affected, but
	      // a new line is always output before one inside
	      // that section
	      if (this._input.peek() !== '/') {
	        this._output.add_new_line();
	      }
	    } else if (this._ch === '(') { // may be a url
	      if (this._input.lookBack("url")) {
	        this.print_string(this._ch);
	        this.eatWhitespace();
	        this._ch = this._input.next();
	        if (this._ch === ')' || this._ch === '"' || this._ch === '\'') {
	          this._input.back();
	          parenLevel++;
	        } else if (this._ch) {
	          this.print_string(this._ch + this.eatString(')'));
	        }
	      } else {
	        parenLevel++;
	        this.preserveSingleSpace(isAfterSpace);
	        this.print_string(this._ch);
	        this.eatWhitespace();
	      }
	    } else if (this._ch === ')') {
	      this.print_string(this._ch);
	      parenLevel--;
	    } else if (this._ch === ',') {
	      this.print_string(this._ch);
	      this.eatWhitespace(true);
	      if (this._options.selector_separator_newline && !insidePropertyValue && parenLevel < 1 && !insideAtImport) {
	        this._output.add_new_line();
	      } else {
	        this._output.space_before_token = true;
	      }
	    } else if ((this._ch === '>' || this._ch === '+' || this._ch === '~') && !insidePropertyValue && parenLevel < 1) {
	      //handle combinator spacing
	      if (this._options.space_around_combinator) {
	        this._output.space_before_token = true;
	        this.print_string(this._ch);
	        this._output.space_before_token = true;
	      } else {
	        this.print_string(this._ch);
	        this.eatWhitespace();
	        // squash extra whitespace
	        if (this._ch && whitespaceChar.test(this._ch)) {
	          this._ch = '';
	        }
	      }
	    } else if (this._ch === ']') {
	      this.print_string(this._ch);
	    } else if (this._ch === '[') {
	      this.preserveSingleSpace(isAfterSpace);
	      this.print_string(this._ch);
	    } else if (this._ch === '=') { // no whitespace before or after
	      this.eatWhitespace();
	      this.print_string('=');
	      if (whitespaceChar.test(this._ch)) {
	        this._ch = '';
	      }
	    } else if (this._ch === '!') { // !important
	      this.print_string(' ');
	      this.print_string(this._ch);
	    } else {
	      this.preserveSingleSpace(isAfterSpace);
	      this.print_string(this._ch);
	    }
	  }
	
	  var sweetCode = this._output.get_code(eol);
	
	  return sweetCode;
	};
	
	module.exports.Beautifier = Beautifier;
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var BaseOptions = __webpack_require__(6).Options;
	
	function Options(options) {
	  BaseOptions.call(this, options, 'css');
	
	  this.selector_separator_newline = this._get_boolean('selector_separator_newline', true);
	  this.newline_between_rules = this._get_boolean('newline_between_rules', true);
	  var space_around_selector_separator = this._get_boolean('space_around_selector_separator');
	  this.space_around_combinator = this._get_boolean('space_around_combinator') || space_around_selector_separator;
	
	}
	Options.prototype = new BaseOptions();
	
	
	
	module.exports.Options = Options;
	
	
	/***/ })
	/******/ ]);
	var css_beautify = legacy_beautify_css;
	/* Footer */
	if (true) {
	    // Add support for AMD ( https://github.com/amdjs/amdjs-api/wiki/AMD#defineamd-property- )
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return {
	            css_beautify: css_beautify
	        };
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== "undefined") {
	    // Add support for CommonJS. Just put this file somewhere on your require.paths
	    // and you will be able to `var html_beautify = require("beautify").html_beautify`.
	    exports.css_beautify = css_beautify;
	} else if (typeof window !== "undefined") {
	    // If we're running a web page and don't have either of the above, add our one global
	    window.css_beautify = css_beautify;
	} else if (typeof global !== "undefined") {
	    // If we don't even have window, try global.
	    global.css_beautify = css_beautify;
	}
	
	}());


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* AUTO-GENERATED. DO NOT MODIFY. */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	
	 JS Beautifier
	---------------
	
	
	  Written by Einar Lielmanis, <einar@beautifier.io>
	      https://beautifier.io/
	
	  Originally converted to javascript by Vital, <vital76@gmail.com>
	  "End braces on own line" added by Chris J. Shull, <chrisjshull@gmail.com>
	  Parsing improvements for brace-less statements by Liam Newman <bitwiseman@beautifier.io>
	
	
	  Usage:
	    js_beautify(js_source_text);
	    js_beautify(js_source_text, options);
	
	  The options are:
	    indent_size (default 4)          - indentation size,
	    indent_char (default space)      - character to indent with,
	    preserve_newlines (default true) - whether existing line breaks should be preserved,
	    max_preserve_newlines (default unlimited) - maximum number of line breaks to be preserved in one chunk,
	
	    jslint_happy (default false) - if true, then jslint-stricter mode is enforced.
	
	            jslint_happy        !jslint_happy
	            ---------------------------------
	            function ()         function()
	
	            switch () {         switch() {
	            case 1:               case 1:
	              break;                break;
	            }                   }
	
	    space_after_anon_function (default false) - should the space before an anonymous function's parens be added, "function()" vs "function ()",
	          NOTE: This option is overriden by jslint_happy (i.e. if jslint_happy is true, space_after_anon_function is true by design)
	
	    brace_style (default "collapse") - "collapse" | "expand" | "end-expand" | "none" | any of the former + ",preserve-inline"
	            put braces on the same line as control statements (default), or put braces on own line (Allman / ANSI style), or just put end braces on own line, or attempt to keep them where they are.
	            preserve-inline will try to preserve inline blocks of curly braces
	
	    space_before_conditional (default true) - should the space before conditional statement be added, "if(true)" vs "if (true)",
	
	    unescape_strings (default false) - should printable characters in strings encoded in \xNN notation be unescaped, "example" vs "\x65\x78\x61\x6d\x70\x6c\x65"
	
	    wrap_line_length (default unlimited) - lines should wrap at next opportunity after this number of characters.
	          NOTE: This is not a hard limit. Lines will continue until a point where a newline would
	                be preserved if it were present.
	
	    end_with_newline (default false)  - end output with a newline
	
	
	    e.g
	
	    js_beautify(js_source_text, {
	      'indent_size': 1,
	      'indent_char': '\t'
	    });
	
	*/
	
	(function() {
	
	/* GENERATED_BUILD_OUTPUT */
	var legacy_beautify_js =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var Beautifier = __webpack_require__(1).Beautifier;
	
	function js_beautify(js_source_text, options) {
	  var beautifier = new Beautifier(js_source_text, options);
	  return beautifier.beautify();
	}
	
	module.exports = js_beautify;
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var Output = __webpack_require__(2).Output;
	var Token = __webpack_require__(3).Token;
	var acorn = __webpack_require__(4);
	var Options = __webpack_require__(5).Options;
	var Tokenizer = __webpack_require__(7).Tokenizer;
	var line_starters = __webpack_require__(7).line_starters;
	var positionable_operators = __webpack_require__(7).positionable_operators;
	var TOKEN = __webpack_require__(7).TOKEN;
	
	function remove_redundant_indentation(output, frame) {
	  // This implementation is effective but has some issues:
	  //     - can cause line wrap to happen too soon due to indent removal
	  //           after wrap points are calculated
	  // These issues are minor compared to ugly indentation.
	
	  if (frame.multiline_frame ||
	    frame.mode === MODE.ForInitializer ||
	    frame.mode === MODE.Conditional) {
	    return;
	  }
	
	  // remove one indent from each line inside this section
	  output.remove_indent(frame.start_line_index);
	}
	
	function in_array(what, arr) {
	  return arr.indexOf(what) !== -1;
	}
	
	function ltrim(s) {
	  return s.replace(/^\s+/g, '');
	}
	
	function generateMapFromStrings(list) {
	  var result = {};
	  for (var x = 0; x < list.length; x++) {
	    // make the mapped names underscored instead of dash
	    result[list[x].replace(/-/g, '_')] = list[x];
	  }
	  return result;
	}
	
	function reserved_word(token, word) {
	  return token && token.type === TOKEN.RESERVED && token.text === word;
	}
	
	function reserved_array(token, words) {
	  return token && token.type === TOKEN.RESERVED && in_array(token.text, words);
	}
	// Unsure of what they mean, but they work. Worth cleaning up in future.
	var special_words = ['case', 'return', 'do', 'if', 'throw', 'else', 'await', 'break', 'continue', 'async'];
	
	var validPositionValues = ['before-newline', 'after-newline', 'preserve-newline'];
	
	// Generate map from array
	var OPERATOR_POSITION = generateMapFromStrings(validPositionValues);
	
	var OPERATOR_POSITION_BEFORE_OR_PRESERVE = [OPERATOR_POSITION.before_newline, OPERATOR_POSITION.preserve_newline];
	
	var MODE = {
	  BlockStatement: 'BlockStatement', // 'BLOCK'
	  Statement: 'Statement', // 'STATEMENT'
	  ObjectLiteral: 'ObjectLiteral', // 'OBJECT',
	  ArrayLiteral: 'ArrayLiteral', //'[EXPRESSION]',
	  ForInitializer: 'ForInitializer', //'(FOR-EXPRESSION)',
	  Conditional: 'Conditional', //'(COND-EXPRESSION)',
	  Expression: 'Expression' //'(EXPRESSION)'
	};
	
	// we could use just string.split, but
	// IE doesn't like returning empty strings
	function split_linebreaks(s) {
	  //return s.split(/\x0d\x0a|\x0a/);
	
	  s = s.replace(acorn.allLineBreaks, '\n');
	  var out = [],
	    idx = s.indexOf("\n");
	  while (idx !== -1) {
	    out.push(s.substring(0, idx));
	    s = s.substring(idx + 1);
	    idx = s.indexOf("\n");
	  }
	  if (s.length) {
	    out.push(s);
	  }
	  return out;
	}
	
	function is_array(mode) {
	  return mode === MODE.ArrayLiteral;
	}
	
	function is_expression(mode) {
	  return in_array(mode, [MODE.Expression, MODE.ForInitializer, MODE.Conditional]);
	}
	
	function all_lines_start_with(lines, c) {
	  for (var i = 0; i < lines.length; i++) {
	    var line = lines[i].trim();
	    if (line.charAt(0) !== c) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function each_line_matches_indent(lines, indent) {
	  var i = 0,
	    len = lines.length,
	    line;
	  for (; i < len; i++) {
	    line = lines[i];
	    // allow empty lines to pass through
	    if (line && line.indexOf(indent) !== 0) {
	      return false;
	    }
	  }
	  return true;
	}
	
	
	function Beautifier(source_text, options) {
	  options = options || {};
	  this._source_text = source_text || '';
	
	  this._output = null;
	  this._tokens = null;
	  this._last_last_text = null;
	  this._flags = null;
	  this._previous_flags = null;
	
	  this._flag_store = null;
	  this._options = new Options(options);
	}
	
	Beautifier.prototype.create_flags = function(flags_base, mode) {
	  var next_indent_level = 0;
	  if (flags_base) {
	    next_indent_level = flags_base.indentation_level;
	    if (!this._output.just_added_newline() &&
	      flags_base.line_indent_level > next_indent_level) {
	      next_indent_level = flags_base.line_indent_level;
	    }
	  }
	
	  var next_flags = {
	    mode: mode,
	    parent: flags_base,
	    last_token: flags_base ? flags_base.last_token : new Token(TOKEN.START_BLOCK, ''), // last token text
	    last_word: flags_base ? flags_base.last_word : '', // last TOKEN.WORD passed
	    declaration_statement: false,
	    declaration_assignment: false,
	    multiline_frame: false,
	    inline_frame: false,
	    if_block: false,
	    else_block: false,
	    do_block: false,
	    do_while: false,
	    import_block: false,
	    in_case_statement: false, // switch(..){ INSIDE HERE }
	    in_case: false, // we're on the exact line with "case 0:"
	    case_body: false, // the indented case-action block
	    indentation_level: next_indent_level,
	    line_indent_level: flags_base ? flags_base.line_indent_level : next_indent_level,
	    start_line_index: this._output.get_line_number(),
	    ternary_depth: 0
	  };
	  return next_flags;
	};
	
	Beautifier.prototype._reset = function(source_text) {
	  var baseIndentString = source_text.match(/^[\t ]*/)[0];
	
	  this._last_last_text = ''; // pre-last token text
	  this._output = new Output(this._options, baseIndentString);
	
	  // If testing the ignore directive, start with output disable set to true
	  this._output.raw = this._options.test_output_raw;
	
	
	  // Stack of parsing/formatting states, including MODE.
	  // We tokenize, parse, and output in an almost purely a forward-only stream of token input
	  // and formatted output.  This makes the beautifier less accurate than full parsers
	  // but also far more tolerant of syntax errors.
	  //
	  // For example, the default mode is MODE.BlockStatement. If we see a '{' we push a new frame of type
	  // MODE.BlockStatement on the the stack, even though it could be object literal.  If we later
	  // encounter a ":", we'll switch to to MODE.ObjectLiteral.  If we then see a ";",
	  // most full parsers would die, but the beautifier gracefully falls back to
	  // MODE.BlockStatement and continues on.
	  this._flag_store = [];
	  this.set_mode(MODE.BlockStatement);
	  var tokenizer = new Tokenizer(source_text, this._options);
	  this._tokens = tokenizer.tokenize();
	  return source_text;
	};
	
	Beautifier.prototype.beautify = function() {
	  // if disabled, return the input unchanged.
	  if (this._options.disabled) {
	    return this._source_text;
	  }
	
	  var sweet_code;
	  var source_text = this._reset(this._source_text);
	
	  var eol = this._options.eol;
	  if (this._options.eol === 'auto') {
	    eol = '\n';
	    if (source_text && acorn.lineBreak.test(source_text || '')) {
	      eol = source_text.match(acorn.lineBreak)[0];
	    }
	  }
	
	  var current_token = this._tokens.next();
	  while (current_token) {
	    this.handle_token(current_token);
	
	    this._last_last_text = this._flags.last_token.text;
	    this._flags.last_token = current_token;
	
	    current_token = this._tokens.next();
	  }
	
	  sweet_code = this._output.get_code(eol);
	
	  return sweet_code;
	};
	
	Beautifier.prototype.handle_token = function(current_token, preserve_statement_flags) {
	  if (current_token.type === TOKEN.START_EXPR) {
	    this.handle_start_expr(current_token);
	  } else if (current_token.type === TOKEN.END_EXPR) {
	    this.handle_end_expr(current_token);
	  } else if (current_token.type === TOKEN.START_BLOCK) {
	    this.handle_start_block(current_token);
	  } else if (current_token.type === TOKEN.END_BLOCK) {
	    this.handle_end_block(current_token);
	  } else if (current_token.type === TOKEN.WORD) {
	    this.handle_word(current_token);
	  } else if (current_token.type === TOKEN.RESERVED) {
	    this.handle_word(current_token);
	  } else if (current_token.type === TOKEN.SEMICOLON) {
	    this.handle_semicolon(current_token);
	  } else if (current_token.type === TOKEN.STRING) {
	    this.handle_string(current_token);
	  } else if (current_token.type === TOKEN.EQUALS) {
	    this.handle_equals(current_token);
	  } else if (current_token.type === TOKEN.OPERATOR) {
	    this.handle_operator(current_token);
	  } else if (current_token.type === TOKEN.COMMA) {
	    this.handle_comma(current_token);
	  } else if (current_token.type === TOKEN.BLOCK_COMMENT) {
	    this.handle_block_comment(current_token, preserve_statement_flags);
	  } else if (current_token.type === TOKEN.COMMENT) {
	    this.handle_comment(current_token, preserve_statement_flags);
	  } else if (current_token.type === TOKEN.DOT) {
	    this.handle_dot(current_token);
	  } else if (current_token.type === TOKEN.EOF) {
	    this.handle_eof(current_token);
	  } else if (current_token.type === TOKEN.UNKNOWN) {
	    this.handle_unknown(current_token, preserve_statement_flags);
	  } else {
	    this.handle_unknown(current_token, preserve_statement_flags);
	  }
	};
	
	Beautifier.prototype.handle_whitespace_and_comments = function(current_token, preserve_statement_flags) {
	  var newlines = current_token.newlines;
	  var keep_whitespace = this._options.keep_array_indentation && is_array(this._flags.mode);
	
	  if (current_token.comments_before) {
	    var comment_token = current_token.comments_before.next();
	    while (comment_token) {
	      // The cleanest handling of inline comments is to treat them as though they aren't there.
	      // Just continue formatting and the behavior should be logical.
	      // Also ignore unknown tokens.  Again, this should result in better behavior.
	      this.handle_whitespace_and_comments(comment_token, preserve_statement_flags);
	      this.handle_token(comment_token, preserve_statement_flags);
	      comment_token = current_token.comments_before.next();
	    }
	  }
	
	  if (keep_whitespace) {
	    for (var i = 0; i < newlines; i += 1) {
	      this.print_newline(i > 0, preserve_statement_flags);
	    }
	  } else {
	    if (this._options.max_preserve_newlines && newlines > this._options.max_preserve_newlines) {
	      newlines = this._options.max_preserve_newlines;
	    }
	
	    if (this._options.preserve_newlines) {
	      if (newlines > 1) {
	        this.print_newline(false, preserve_statement_flags);
	        for (var j = 1; j < newlines; j += 1) {
	          this.print_newline(true, preserve_statement_flags);
	        }
	      }
	    }
	  }
	
	};
	
	var newline_restricted_tokens = ['async', 'break', 'continue', 'return', 'throw', 'yield'];
	
	Beautifier.prototype.allow_wrap_or_preserved_newline = function(current_token, force_linewrap) {
	  force_linewrap = (force_linewrap === undefined) ? false : force_linewrap;
	
	  // Never wrap the first token on a line
	  if (this._output.just_added_newline()) {
	    return;
	  }
	
	  var shouldPreserveOrForce = (this._options.preserve_newlines && current_token.newlines) || force_linewrap;
	  var operatorLogicApplies = in_array(this._flags.last_token.text, positionable_operators) ||
	    in_array(current_token.text, positionable_operators);
	
	  if (operatorLogicApplies) {
	    var shouldPrintOperatorNewline = (
	        in_array(this._flags.last_token.text, positionable_operators) &&
	        in_array(this._options.operator_position, OPERATOR_POSITION_BEFORE_OR_PRESERVE)
	      ) ||
	      in_array(current_token.text, positionable_operators);
	    shouldPreserveOrForce = shouldPreserveOrForce && shouldPrintOperatorNewline;
	  }
	
	  if (shouldPreserveOrForce) {
	    this.print_newline(false, true);
	  } else if (this._options.wrap_line_length) {
	    if (reserved_array(this._flags.last_token, newline_restricted_tokens)) {
	      // These tokens should never have a newline inserted
	      // between them and the following expression.
	      return;
	    }
	    var proposed_line_length = this._output.current_line.get_character_count() + current_token.text.length +
	      (this._output.space_before_token ? 1 : 0);
	    if (proposed_line_length >= this._options.wrap_line_length) {
	      this.print_newline(false, true);
	    }
	  }
	};
	
	Beautifier.prototype.print_newline = function(force_newline, preserve_statement_flags) {
	  if (!preserve_statement_flags) {
	    if (this._flags.last_token.text !== ';' && this._flags.last_token.text !== ',' && this._flags.last_token.text !== '=' && (this._flags.last_token.type !== TOKEN.OPERATOR || this._flags.last_token.text === '--' || this._flags.last_token.text === '++')) {
	      var next_token = this._tokens.peek();
	      while (this._flags.mode === MODE.Statement &&
	        !(this._flags.if_block && reserved_word(next_token, 'else')) &&
	        !this._flags.do_block) {
	        this.restore_mode();
	      }
	    }
	  }
	
	  if (this._output.add_new_line(force_newline)) {
	    this._flags.multiline_frame = true;
	  }
	};
	
	Beautifier.prototype.print_token_line_indentation = function(current_token) {
	  if (this._output.just_added_newline()) {
	    if (this._options.keep_array_indentation && is_array(this._flags.mode) && current_token.newlines) {
	      this._output.current_line.push(current_token.whitespace_before);
	      this._output.space_before_token = false;
	    } else if (this._output.set_indent(this._flags.indentation_level)) {
	      this._flags.line_indent_level = this._flags.indentation_level;
	    }
	  }
	};
	
	Beautifier.prototype.print_token = function(current_token, printable_token) {
	  if (this._output.raw) {
	    this._output.add_raw_token(current_token);
	    return;
	  }
	
	  if (this._options.comma_first && current_token.previous && current_token.previous.type === TOKEN.COMMA &&
	    this._output.just_added_newline()) {
	    if (this._output.previous_line.last() === ',') {
	      var popped = this._output.previous_line.pop();
	      // if the comma was already at the start of the line,
	      // pull back onto that line and reprint the indentation
	      if (this._output.previous_line.is_empty()) {
	        this._output.previous_line.push(popped);
	        this._output.trim(true);
	        this._output.current_line.pop();
	        this._output.trim();
	      }
	
	      // add the comma in front of the next token
	      this.print_token_line_indentation(current_token);
	      this._output.add_token(',');
	      this._output.space_before_token = true;
	    }
	  }
	
	  printable_token = printable_token || current_token.text;
	  this.print_token_line_indentation(current_token);
	  this._output.add_token(printable_token);
	};
	
	Beautifier.prototype.indent = function() {
	  this._flags.indentation_level += 1;
	};
	
	Beautifier.prototype.deindent = function() {
	  if (this._flags.indentation_level > 0 &&
	    ((!this._flags.parent) || this._flags.indentation_level > this._flags.parent.indentation_level)) {
	    this._flags.indentation_level -= 1;
	
	  }
	};
	
	Beautifier.prototype.set_mode = function(mode) {
	  if (this._flags) {
	    this._flag_store.push(this._flags);
	    this._previous_flags = this._flags;
	  } else {
	    this._previous_flags = this.create_flags(null, mode);
	  }
	
	  this._flags = this.create_flags(this._previous_flags, mode);
	};
	
	
	Beautifier.prototype.restore_mode = function() {
	  if (this._flag_store.length > 0) {
	    this._previous_flags = this._flags;
	    this._flags = this._flag_store.pop();
	    if (this._previous_flags.mode === MODE.Statement) {
	      remove_redundant_indentation(this._output, this._previous_flags);
	    }
	  }
	};
	
	Beautifier.prototype.start_of_object_property = function() {
	  return this._flags.parent.mode === MODE.ObjectLiteral && this._flags.mode === MODE.Statement && (
	    (this._flags.last_token.text === ':' && this._flags.ternary_depth === 0) || (reserved_array(this._flags.last_token, ['get', 'set'])));
	};
	
	Beautifier.prototype.start_of_statement = function(current_token) {
	  var start = false;
	  start = start || reserved_array(this._flags.last_token, ['var', 'let', 'const']) && current_token.type === TOKEN.WORD;
	  start = start || reserved_word(this._flags.last_token, 'do');
	  start = start || (!(this._flags.parent.mode === MODE.ObjectLiteral && this._flags.mode === MODE.Statement)) && reserved_array(this._flags.last_token, newline_restricted_tokens) && !current_token.newlines;
	  start = start || reserved_word(this._flags.last_token, 'else') &&
	    !(reserved_word(current_token, 'if') && !current_token.comments_before);
	  start = start || (this._flags.last_token.type === TOKEN.END_EXPR && (this._previous_flags.mode === MODE.ForInitializer || this._previous_flags.mode === MODE.Conditional));
	  start = start || (this._flags.last_token.type === TOKEN.WORD && this._flags.mode === MODE.BlockStatement &&
	    !this._flags.in_case &&
	    !(current_token.text === '--' || current_token.text === '++') &&
	    this._last_last_text !== 'function' &&
	    current_token.type !== TOKEN.WORD && current_token.type !== TOKEN.RESERVED);
	  start = start || (this._flags.mode === MODE.ObjectLiteral && (
	    (this._flags.last_token.text === ':' && this._flags.ternary_depth === 0) || reserved_array(this._flags.last_token, ['get', 'set'])));
	
	  if (start) {
	    this.set_mode(MODE.Statement);
	    this.indent();
	
	    this.handle_whitespace_and_comments(current_token, true);
	
	    // Issue #276:
	    // If starting a new statement with [if, for, while, do], push to a new line.
	    // if (a) if (b) if(c) d(); else e(); else f();
	    if (!this.start_of_object_property()) {
	      this.allow_wrap_or_preserved_newline(current_token,
	        reserved_array(current_token, ['do', 'for', 'if', 'while']));
	    }
	    return true;
	  }
	  return false;
	};
	
	Beautifier.prototype.handle_start_expr = function(current_token) {
	  // The conditional starts the statement if appropriate.
	  if (!this.start_of_statement(current_token)) {
	    this.handle_whitespace_and_comments(current_token);
	  }
	
	  var next_mode = MODE.Expression;
	  if (current_token.text === '[') {
	
	    if (this._flags.last_token.type === TOKEN.WORD || this._flags.last_token.text === ')') {
	      // this is array index specifier, break immediately
	      // a[x], fn()[x]
	      if (reserved_array(this._flags.last_token, line_starters)) {
	        this._output.space_before_token = true;
	      }
	      this.set_mode(next_mode);
	      this.print_token(current_token);
	      this.indent();
	      if (this._options.space_in_paren) {
	        this._output.space_before_token = true;
	      }
	      return;
	    }
	
	    next_mode = MODE.ArrayLiteral;
	    if (is_array(this._flags.mode)) {
	      if (this._flags.last_token.text === '[' ||
	        (this._flags.last_token.text === ',' && (this._last_last_text === ']' || this._last_last_text === '}'))) {
	        // ], [ goes to new line
	        // }, [ goes to new line
	        if (!this._options.keep_array_indentation) {
	          this.print_newline();
	        }
	      }
	    }
	
	    if (!in_array(this._flags.last_token.type, [TOKEN.START_EXPR, TOKEN.END_EXPR, TOKEN.WORD, TOKEN.OPERATOR])) {
	      this._output.space_before_token = true;
	    }
	  } else {
	    if (this._flags.last_token.type === TOKEN.RESERVED) {
	      if (this._flags.last_token.text === 'for') {
	        this._output.space_before_token = this._options.space_before_conditional;
	        next_mode = MODE.ForInitializer;
	      } else if (in_array(this._flags.last_token.text, ['if', 'while'])) {
	        this._output.space_before_token = this._options.space_before_conditional;
	        next_mode = MODE.Conditional;
	      } else if (in_array(this._flags.last_word, ['await', 'async'])) {
	        // Should be a space between await and an IIFE, or async and an arrow function
	        this._output.space_before_token = true;
	      } else if (this._flags.last_token.text === 'import' && current_token.whitespace_before === '') {
	        this._output.space_before_token = false;
	      } else if (in_array(this._flags.last_token.text, line_starters) || this._flags.last_token.text === 'catch') {
	        this._output.space_before_token = true;
	      }
	    } else if (this._flags.last_token.type === TOKEN.EQUALS || this._flags.last_token.type === TOKEN.OPERATOR) {
	      // Support of this kind of newline preservation.
	      // a = (b &&
	      //     (c || d));
	      if (!this.start_of_object_property()) {
	        this.allow_wrap_or_preserved_newline(current_token);
	      }
	    } else if (this._flags.last_token.type === TOKEN.WORD) {
	      this._output.space_before_token = false;
	
	      // function name() vs function name ()
	      // function* name() vs function* name ()
	      // async name() vs async name ()
	      if (this._options.space_after_named_function) {
	        // peek starts at next character so -1 is current token
	        var peek_back_three = this._tokens.peek(-4);
	        var peek_back_two = this._tokens.peek(-3);
	        if (reserved_array(peek_back_two, ['async', 'function']) ||
	          (reserved_array(peek_back_three, ['async', 'function']) && peek_back_two.text === '*')) {
	          this._output.space_before_token = true;
	        }
	      }
	    } else {
	      // Support preserving wrapped arrow function expressions
	      // a.b('c',
	      //     () => d.e
	      // )
	      this.allow_wrap_or_preserved_newline(current_token);
	    }
	
	    // function() vs function ()
	    // yield*() vs yield* ()
	    // function*() vs function* ()
	    if ((this._flags.last_token.type === TOKEN.RESERVED && (this._flags.last_word === 'function' || this._flags.last_word === 'typeof')) ||
	      (this._flags.last_token.text === '*' &&
	        (in_array(this._last_last_text, ['function', 'yield']) ||
	          (this._flags.mode === MODE.ObjectLiteral && in_array(this._last_last_text, ['{', ',']))))) {
	
	      this._output.space_before_token = this._options.space_after_anon_function;
	    }
	
	  }
	
	  if (this._flags.last_token.text === ';' || this._flags.last_token.type === TOKEN.START_BLOCK) {
	    this.print_newline();
	  } else if (this._flags.last_token.type === TOKEN.END_EXPR || this._flags.last_token.type === TOKEN.START_EXPR || this._flags.last_token.type === TOKEN.END_BLOCK || this._flags.last_token.text === '.' || this._flags.last_token.type === TOKEN.COMMA) {
	    // do nothing on (( and )( and ][ and ]( and .(
	    // TODO: Consider whether forcing this is required.  Review failing tests when removed.
	    this.allow_wrap_or_preserved_newline(current_token, current_token.newlines);
	  }
	
	  this.set_mode(next_mode);
	  this.print_token(current_token);
	  if (this._options.space_in_paren) {
	    this._output.space_before_token = true;
	  }
	
	  // In all cases, if we newline while inside an expression it should be indented.
	  this.indent();
	};
	
	Beautifier.prototype.handle_end_expr = function(current_token) {
	  // statements inside expressions are not valid syntax, but...
	  // statements must all be closed when their container closes
	  while (this._flags.mode === MODE.Statement) {
	    this.restore_mode();
	  }
	
	  this.handle_whitespace_and_comments(current_token);
	
	  if (this._flags.multiline_frame) {
	    this.allow_wrap_or_preserved_newline(current_token,
	      current_token.text === ']' && is_array(this._flags.mode) && !this._options.keep_array_indentation);
	  }
	
	  if (this._options.space_in_paren) {
	    if (this._flags.last_token.type === TOKEN.START_EXPR && !this._options.space_in_empty_paren) {
	      // () [] no inner space in empty parens like these, ever, ref #320
	      this._output.trim();
	      this._output.space_before_token = false;
	    } else {
	      this._output.space_before_token = true;
	    }
	  }
	  if (current_token.text === ']' && this._options.keep_array_indentation) {
	    this.print_token(current_token);
	    this.restore_mode();
	  } else {
	    this.restore_mode();
	    this.print_token(current_token);
	  }
	  remove_redundant_indentation(this._output, this._previous_flags);
	
	  // do {} while () // no statement required after
	  if (this._flags.do_while && this._previous_flags.mode === MODE.Conditional) {
	    this._previous_flags.mode = MODE.Expression;
	    this._flags.do_block = false;
	    this._flags.do_while = false;
	
	  }
	};
	
	Beautifier.prototype.handle_start_block = function(current_token) {
	  this.handle_whitespace_and_comments(current_token);
	
	  // Check if this is should be treated as a ObjectLiteral
	  var next_token = this._tokens.peek();
	  var second_token = this._tokens.peek(1);
	  if (this._flags.last_word === 'switch' && this._flags.last_token.type === TOKEN.END_EXPR) {
	    this.set_mode(MODE.BlockStatement);
	    this._flags.in_case_statement = true;
	  } else if (second_token && (
	      (in_array(second_token.text, [':', ',']) && in_array(next_token.type, [TOKEN.STRING, TOKEN.WORD, TOKEN.RESERVED])) ||
	      (in_array(next_token.text, ['get', 'set', '...']) && in_array(second_token.type, [TOKEN.WORD, TOKEN.RESERVED]))
	    )) {
	    // We don't support TypeScript,but we didn't break it for a very long time.
	    // We'll try to keep not breaking it.
	    if (!in_array(this._last_last_text, ['class', 'interface'])) {
	      this.set_mode(MODE.ObjectLiteral);
	    } else {
	      this.set_mode(MODE.BlockStatement);
	    }
	  } else if (this._flags.last_token.type === TOKEN.OPERATOR && this._flags.last_token.text === '=>') {
	    // arrow function: (param1, paramN) => { statements }
	    this.set_mode(MODE.BlockStatement);
	  } else if (in_array(this._flags.last_token.type, [TOKEN.EQUALS, TOKEN.START_EXPR, TOKEN.COMMA, TOKEN.OPERATOR]) ||
	    reserved_array(this._flags.last_token, ['return', 'throw', 'import', 'default'])
	  ) {
	    // Detecting shorthand function syntax is difficult by scanning forward,
	    //     so check the surrounding context.
	    // If the block is being returned, imported, export default, passed as arg,
	    //     assigned with = or assigned in a nested object, treat as an ObjectLiteral.
	    this.set_mode(MODE.ObjectLiteral);
	  } else {
	    this.set_mode(MODE.BlockStatement);
	  }
	
	  var empty_braces = !next_token.comments_before && next_token.text === '}';
	  var empty_anonymous_function = empty_braces && this._flags.last_word === 'function' &&
	    this._flags.last_token.type === TOKEN.END_EXPR;
	
	  if (this._options.brace_preserve_inline) // check for inline, set inline_frame if so
	  {
	    // search forward for a newline wanted inside this block
	    var index = 0;
	    var check_token = null;
	    this._flags.inline_frame = true;
	    do {
	      index += 1;
	      check_token = this._tokens.peek(index - 1);
	      if (check_token.newlines) {
	        this._flags.inline_frame = false;
	        break;
	      }
	    } while (check_token.type !== TOKEN.EOF &&
	      !(check_token.type === TOKEN.END_BLOCK && check_token.opened === current_token));
	  }
	
	  if ((this._options.brace_style === "expand" ||
	      (this._options.brace_style === "none" && current_token.newlines)) &&
	    !this._flags.inline_frame) {
	    if (this._flags.last_token.type !== TOKEN.OPERATOR &&
	      (empty_anonymous_function ||
	        this._flags.last_token.type === TOKEN.EQUALS ||
	        (reserved_array(this._flags.last_token, special_words) && this._flags.last_token.text !== 'else'))) {
	      this._output.space_before_token = true;
	    } else {
	      this.print_newline(false, true);
	    }
	  } else { // collapse || inline_frame
	    if (is_array(this._previous_flags.mode) && (this._flags.last_token.type === TOKEN.START_EXPR || this._flags.last_token.type === TOKEN.COMMA)) {
	      if (this._flags.last_token.type === TOKEN.COMMA || this._options.space_in_paren) {
	        this._output.space_before_token = true;
	      }
	
	      if (this._flags.last_token.type === TOKEN.COMMA || (this._flags.last_token.type === TOKEN.START_EXPR && this._flags.inline_frame)) {
	        this.allow_wrap_or_preserved_newline(current_token);
	        this._previous_flags.multiline_frame = this._previous_flags.multiline_frame || this._flags.multiline_frame;
	        this._flags.multiline_frame = false;
	      }
	    }
	    if (this._flags.last_token.type !== TOKEN.OPERATOR && this._flags.last_token.type !== TOKEN.START_EXPR) {
	      if (this._flags.last_token.type === TOKEN.START_BLOCK && !this._flags.inline_frame) {
	        this.print_newline();
	      } else {
	        this._output.space_before_token = true;
	      }
	    }
	  }
	  this.print_token(current_token);
	  this.indent();
	};
	
	Beautifier.prototype.handle_end_block = function(current_token) {
	  // statements must all be closed when their container closes
	  this.handle_whitespace_and_comments(current_token);
	
	  while (this._flags.mode === MODE.Statement) {
	    this.restore_mode();
	  }
	
	  var empty_braces = this._flags.last_token.type === TOKEN.START_BLOCK;
	
	  if (this._flags.inline_frame && !empty_braces) { // try inline_frame (only set if this._options.braces-preserve-inline) first
	    this._output.space_before_token = true;
	  } else if (this._options.brace_style === "expand") {
	    if (!empty_braces) {
	      this.print_newline();
	    }
	  } else {
	    // skip {}
	    if (!empty_braces) {
	      if (is_array(this._flags.mode) && this._options.keep_array_indentation) {
	        // we REALLY need a newline here, but newliner would skip that
	        this._options.keep_array_indentation = false;
	        this.print_newline();
	        this._options.keep_array_indentation = true;
	
	      } else {
	        this.print_newline();
	      }
	    }
	  }
	  this.restore_mode();
	  this.print_token(current_token);
	};
	
	Beautifier.prototype.handle_word = function(current_token) {
	  if (current_token.type === TOKEN.RESERVED) {
	    if (in_array(current_token.text, ['set', 'get']) && this._flags.mode !== MODE.ObjectLiteral) {
	      current_token.type = TOKEN.WORD;
	    } else if (current_token.text === 'import' && this._tokens.peek().text === '(') {
	      current_token.type = TOKEN.WORD;
	    } else if (in_array(current_token.text, ['as', 'from']) && !this._flags.import_block) {
	      current_token.type = TOKEN.WORD;
	    } else if (this._flags.mode === MODE.ObjectLiteral) {
	      var next_token = this._tokens.peek();
	      if (next_token.text === ':') {
	        current_token.type = TOKEN.WORD;
	      }
	    }
	  }
	
	  if (this.start_of_statement(current_token)) {
	    // The conditional starts the statement if appropriate.
	    if (reserved_array(this._flags.last_token, ['var', 'let', 'const']) && current_token.type === TOKEN.WORD) {
	      this._flags.declaration_statement = true;
	    }
	  } else if (current_token.newlines && !is_expression(this._flags.mode) &&
	    (this._flags.last_token.type !== TOKEN.OPERATOR || (this._flags.last_token.text === '--' || this._flags.last_token.text === '++')) &&
	    this._flags.last_token.type !== TOKEN.EQUALS &&
	    (this._options.preserve_newlines || !reserved_array(this._flags.last_token, ['var', 'let', 'const', 'set', 'get']))) {
	    this.handle_whitespace_and_comments(current_token);
	    this.print_newline();
	  } else {
	    this.handle_whitespace_and_comments(current_token);
	  }
	
	  if (this._flags.do_block && !this._flags.do_while) {
	    if (reserved_word(current_token, 'while')) {
	      // do {} ## while ()
	      this._output.space_before_token = true;
	      this.print_token(current_token);
	      this._output.space_before_token = true;
	      this._flags.do_while = true;
	      return;
	    } else {
	      // do {} should always have while as the next word.
	      // if we don't see the expected while, recover
	      this.print_newline();
	      this._flags.do_block = false;
	    }
	  }
	
	  // if may be followed by else, or not
	  // Bare/inline ifs are tricky
	  // Need to unwind the modes correctly: if (a) if (b) c(); else d(); else e();
	  if (this._flags.if_block) {
	    if (!this._flags.else_block && reserved_word(current_token, 'else')) {
	      this._flags.else_block = true;
	    } else {
	      while (this._flags.mode === MODE.Statement) {
	        this.restore_mode();
	      }
	      this._flags.if_block = false;
	      this._flags.else_block = false;
	    }
	  }
	
	  if (this._flags.in_case_statement && reserved_array(current_token, ['case', 'default'])) {
	    this.print_newline();
	    if (this._flags.case_body || this._options.jslint_happy) {
	      // switch cases following one another
	      this.deindent();
	      this._flags.case_body = false;
	    }
	    this.print_token(current_token);
	    this._flags.in_case = true;
	    return;
	  }
	
	  if (this._flags.last_token.type === TOKEN.COMMA || this._flags.last_token.type === TOKEN.START_EXPR || this._flags.last_token.type === TOKEN.EQUALS || this._flags.last_token.type === TOKEN.OPERATOR) {
	    if (!this.start_of_object_property()) {
	      this.allow_wrap_or_preserved_newline(current_token);
	    }
	  }
	
	  if (reserved_word(current_token, 'function')) {
	    if (in_array(this._flags.last_token.text, ['}', ';']) ||
	      (this._output.just_added_newline() && !(in_array(this._flags.last_token.text, ['(', '[', '{', ':', '=', ',']) || this._flags.last_token.type === TOKEN.OPERATOR))) {
	      // make sure there is a nice clean space of at least one blank line
	      // before a new function definition
	      if (!this._output.just_added_blankline() && !current_token.comments_before) {
	        this.print_newline();
	        this.print_newline(true);
	      }
	    }
	    if (this._flags.last_token.type === TOKEN.RESERVED || this._flags.last_token.type === TOKEN.WORD) {
	      if (reserved_array(this._flags.last_token, ['get', 'set', 'new', 'export']) ||
	        reserved_array(this._flags.last_token, newline_restricted_tokens)) {
	        this._output.space_before_token = true;
	      } else if (reserved_word(this._flags.last_token, 'default') && this._last_last_text === 'export') {
	        this._output.space_before_token = true;
	      } else if (this._flags.last_token.text === 'declare') {
	        // accomodates Typescript declare function formatting
	        this._output.space_before_token = true;
	      } else {
	        this.print_newline();
	      }
	    } else if (this._flags.last_token.type === TOKEN.OPERATOR || this._flags.last_token.text === '=') {
	      // foo = function
	      this._output.space_before_token = true;
	    } else if (!this._flags.multiline_frame && (is_expression(this._flags.mode) || is_array(this._flags.mode))) {
	      // (function
	    } else {
	      this.print_newline();
	    }
	
	    this.print_token(current_token);
	    this._flags.last_word = current_token.text;
	    return;
	  }
	
	  var prefix = 'NONE';
	
	  if (this._flags.last_token.type === TOKEN.END_BLOCK) {
	
	    if (this._previous_flags.inline_frame) {
	      prefix = 'SPACE';
	    } else if (!reserved_array(current_token, ['else', 'catch', 'finally', 'from'])) {
	      prefix = 'NEWLINE';
	    } else {
	      if (this._options.brace_style === "expand" ||
	        this._options.brace_style === "end-expand" ||
	        (this._options.brace_style === "none" && current_token.newlines)) {
	        prefix = 'NEWLINE';
	      } else {
	        prefix = 'SPACE';
	        this._output.space_before_token = true;
	      }
	    }
	  } else if (this._flags.last_token.type === TOKEN.SEMICOLON && this._flags.mode === MODE.BlockStatement) {
	    // TODO: Should this be for STATEMENT as well?
	    prefix = 'NEWLINE';
	  } else if (this._flags.last_token.type === TOKEN.SEMICOLON && is_expression(this._flags.mode)) {
	    prefix = 'SPACE';
	  } else if (this._flags.last_token.type === TOKEN.STRING) {
	    prefix = 'NEWLINE';
	  } else if (this._flags.last_token.type === TOKEN.RESERVED || this._flags.last_token.type === TOKEN.WORD ||
	    (this._flags.last_token.text === '*' &&
	      (in_array(this._last_last_text, ['function', 'yield']) ||
	        (this._flags.mode === MODE.ObjectLiteral && in_array(this._last_last_text, ['{', ',']))))) {
	    prefix = 'SPACE';
	  } else if (this._flags.last_token.type === TOKEN.START_BLOCK) {
	    if (this._flags.inline_frame) {
	      prefix = 'SPACE';
	    } else {
	      prefix = 'NEWLINE';
	    }
	  } else if (this._flags.last_token.type === TOKEN.END_EXPR) {
	    this._output.space_before_token = true;
	    prefix = 'NEWLINE';
	  }
	
	  if (reserved_array(current_token, line_starters) && this._flags.last_token.text !== ')') {
	    if (this._flags.inline_frame || this._flags.last_token.text === 'else' || this._flags.last_token.text === 'export') {
	      prefix = 'SPACE';
	    } else {
	      prefix = 'NEWLINE';
	    }
	
	  }
	
	  if (reserved_array(current_token, ['else', 'catch', 'finally'])) {
	    if ((!(this._flags.last_token.type === TOKEN.END_BLOCK && this._previous_flags.mode === MODE.BlockStatement) ||
	        this._options.brace_style === "expand" ||
	        this._options.brace_style === "end-expand" ||
	        (this._options.brace_style === "none" && current_token.newlines)) &&
	      !this._flags.inline_frame) {
	      this.print_newline();
	    } else {
	      this._output.trim(true);
	      var line = this._output.current_line;
	      // If we trimmed and there's something other than a close block before us
	      // put a newline back in.  Handles '} // comment' scenario.
	      if (line.last() !== '}') {
	        this.print_newline();
	      }
	      this._output.space_before_token = true;
	    }
	  } else if (prefix === 'NEWLINE') {
	    if (reserved_array(this._flags.last_token, special_words)) {
	      // no newline between 'return nnn'
	      this._output.space_before_token = true;
	    } else if (this._flags.last_token.text === 'declare' && reserved_array(current_token, ['var', 'let', 'const'])) {
	      // accomodates Typescript declare formatting
	      this._output.space_before_token = true;
	    } else if (this._flags.last_token.type !== TOKEN.END_EXPR) {
	      if ((this._flags.last_token.type !== TOKEN.START_EXPR || !reserved_array(current_token, ['var', 'let', 'const'])) && this._flags.last_token.text !== ':') {
	        // no need to force newline on 'var': for (var x = 0...)
	        if (reserved_word(current_token, 'if') && reserved_word(current_token.previous, 'else')) {
	          // no newline for } else if {
	          this._output.space_before_token = true;
	        } else {
	          this.print_newline();
	        }
	      }
	    } else if (reserved_array(current_token, line_starters) && this._flags.last_token.text !== ')') {
	      this.print_newline();
	    }
	  } else if (this._flags.multiline_frame && is_array(this._flags.mode) && this._flags.last_token.text === ',' && this._last_last_text === '}') {
	    this.print_newline(); // }, in lists get a newline treatment
	  } else if (prefix === 'SPACE') {
	    this._output.space_before_token = true;
	  }
	  if (current_token.previous && (current_token.previous.type === TOKEN.WORD || current_token.previous.type === TOKEN.RESERVED)) {
	    this._output.space_before_token = true;
	  }
	  this.print_token(current_token);
	  this._flags.last_word = current_token.text;
	
	  if (current_token.type === TOKEN.RESERVED) {
	    if (current_token.text === 'do') {
	      this._flags.do_block = true;
	    } else if (current_token.text === 'if') {
	      this._flags.if_block = true;
	    } else if (current_token.text === 'import') {
	      this._flags.import_block = true;
	    } else if (this._flags.import_block && reserved_word(current_token, 'from')) {
	      this._flags.import_block = false;
	    }
	  }
	};
	
	Beautifier.prototype.handle_semicolon = function(current_token) {
	  if (this.start_of_statement(current_token)) {
	    // The conditional starts the statement if appropriate.
	    // Semicolon can be the start (and end) of a statement
	    this._output.space_before_token = false;
	  } else {
	    this.handle_whitespace_and_comments(current_token);
	  }
	
	  var next_token = this._tokens.peek();
	  while (this._flags.mode === MODE.Statement &&
	    !(this._flags.if_block && reserved_word(next_token, 'else')) &&
	    !this._flags.do_block) {
	    this.restore_mode();
	  }
	
	  // hacky but effective for the moment
	  if (this._flags.import_block) {
	    this._flags.import_block = false;
	  }
	  this.print_token(current_token);
	};
	
	Beautifier.prototype.handle_string = function(current_token) {
	  if (this.start_of_statement(current_token)) {
	    // The conditional starts the statement if appropriate.
	    // One difference - strings want at least a space before
	    this._output.space_before_token = true;
	  } else {
	    this.handle_whitespace_and_comments(current_token);
	    if (this._flags.last_token.type === TOKEN.RESERVED || this._flags.last_token.type === TOKEN.WORD || this._flags.inline_frame) {
	      this._output.space_before_token = true;
	    } else if (this._flags.last_token.type === TOKEN.COMMA || this._flags.last_token.type === TOKEN.START_EXPR || this._flags.last_token.type === TOKEN.EQUALS || this._flags.last_token.type === TOKEN.OPERATOR) {
	      if (!this.start_of_object_property()) {
	        this.allow_wrap_or_preserved_newline(current_token);
	      }
	    } else {
	      this.print_newline();
	    }
	  }
	  this.print_token(current_token);
	};
	
	Beautifier.prototype.handle_equals = function(current_token) {
	  if (this.start_of_statement(current_token)) {
	    // The conditional starts the statement if appropriate.
	  } else {
	    this.handle_whitespace_and_comments(current_token);
	  }
	
	  if (this._flags.declaration_statement) {
	    // just got an '=' in a var-line, different formatting/line-breaking, etc will now be done
	    this._flags.declaration_assignment = true;
	  }
	  this._output.space_before_token = true;
	  this.print_token(current_token);
	  this._output.space_before_token = true;
	};
	
	Beautifier.prototype.handle_comma = function(current_token) {
	  this.handle_whitespace_and_comments(current_token, true);
	
	  this.print_token(current_token);
	  this._output.space_before_token = true;
	  if (this._flags.declaration_statement) {
	    if (is_expression(this._flags.parent.mode)) {
	      // do not break on comma, for(var a = 1, b = 2)
	      this._flags.declaration_assignment = false;
	    }
	
	    if (this._flags.declaration_assignment) {
	      this._flags.declaration_assignment = false;
	      this.print_newline(false, true);
	    } else if (this._options.comma_first) {
	      // for comma-first, we want to allow a newline before the comma
	      // to turn into a newline after the comma, which we will fixup later
	      this.allow_wrap_or_preserved_newline(current_token);
	    }
	  } else if (this._flags.mode === MODE.ObjectLiteral ||
	    (this._flags.mode === MODE.Statement && this._flags.parent.mode === MODE.ObjectLiteral)) {
	    if (this._flags.mode === MODE.Statement) {
	      this.restore_mode();
	    }
	
	    if (!this._flags.inline_frame) {
	      this.print_newline();
	    }
	  } else if (this._options.comma_first) {
	    // EXPR or DO_BLOCK
	    // for comma-first, we want to allow a newline before the comma
	    // to turn into a newline after the comma, which we will fixup later
	    this.allow_wrap_or_preserved_newline(current_token);
	  }
	};
	
	Beautifier.prototype.handle_operator = function(current_token) {
	  var isGeneratorAsterisk = current_token.text === '*' &&
	    (reserved_array(this._flags.last_token, ['function', 'yield']) ||
	      (in_array(this._flags.last_token.type, [TOKEN.START_BLOCK, TOKEN.COMMA, TOKEN.END_BLOCK, TOKEN.SEMICOLON]))
	    );
	  var isUnary = in_array(current_token.text, ['-', '+']) && (
	    in_array(this._flags.last_token.type, [TOKEN.START_BLOCK, TOKEN.START_EXPR, TOKEN.EQUALS, TOKEN.OPERATOR]) ||
	    in_array(this._flags.last_token.text, line_starters) ||
	    this._flags.last_token.text === ','
	  );
	
	  if (this.start_of_statement(current_token)) {
	    // The conditional starts the statement if appropriate.
	  } else {
	    var preserve_statement_flags = !isGeneratorAsterisk;
	    this.handle_whitespace_and_comments(current_token, preserve_statement_flags);
	  }
	
	  if (reserved_array(this._flags.last_token, special_words)) {
	    // "return" had a special handling in TK_WORD. Now we need to return the favor
	    this._output.space_before_token = true;
	    this.print_token(current_token);
	    return;
	  }
	
	  // hack for actionscript's import .*;
	  if (current_token.text === '*' && this._flags.last_token.type === TOKEN.DOT) {
	    this.print_token(current_token);
	    return;
	  }
	
	  if (current_token.text === '::') {
	    // no spaces around exotic namespacing syntax operator
	    this.print_token(current_token);
	    return;
	  }
	
	  // Allow line wrapping between operators when operator_position is
	  //   set to before or preserve
	  if (this._flags.last_token.type === TOKEN.OPERATOR && in_array(this._options.operator_position, OPERATOR_POSITION_BEFORE_OR_PRESERVE)) {
	    this.allow_wrap_or_preserved_newline(current_token);
	  }
	
	  if (current_token.text === ':' && this._flags.in_case) {
	    this._flags.case_body = true;
	    this.indent();
	    this.print_token(current_token);
	    this.print_newline();
	    this._flags.in_case = false;
	    return;
	  }
	
	  var space_before = true;
	  var space_after = true;
	  var in_ternary = false;
	  if (current_token.text === ':') {
	    if (this._flags.ternary_depth === 0) {
	      // Colon is invalid javascript outside of ternary and object, but do our best to guess what was meant.
	      space_before = false;
	    } else {
	      this._flags.ternary_depth -= 1;
	      in_ternary = true;
	    }
	  } else if (current_token.text === '?') {
	    this._flags.ternary_depth += 1;
	  }
	
	  // let's handle the operator_position option prior to any conflicting logic
	  if (!isUnary && !isGeneratorAsterisk && this._options.preserve_newlines && in_array(current_token.text, positionable_operators)) {
	    var isColon = current_token.text === ':';
	    var isTernaryColon = (isColon && in_ternary);
	    var isOtherColon = (isColon && !in_ternary);
	
	    switch (this._options.operator_position) {
	      case OPERATOR_POSITION.before_newline:
	        // if the current token is : and it's not a ternary statement then we set space_before to false
	        this._output.space_before_token = !isOtherColon;
	
	        this.print_token(current_token);
	
	        if (!isColon || isTernaryColon) {
	          this.allow_wrap_or_preserved_newline(current_token);
	        }
	
	        this._output.space_before_token = true;
	        return;
	
	      case OPERATOR_POSITION.after_newline:
	        // if the current token is anything but colon, or (via deduction) it's a colon and in a ternary statement,
	        //   then print a newline.
	
	        this._output.space_before_token = true;
	
	        if (!isColon || isTernaryColon) {
	          if (this._tokens.peek().newlines) {
	            this.print_newline(false, true);
	          } else {
	            this.allow_wrap_or_preserved_newline(current_token);
	          }
	        } else {
	          this._output.space_before_token = false;
	        }
	
	        this.print_token(current_token);
	
	        this._output.space_before_token = true;
	        return;
	
	      case OPERATOR_POSITION.preserve_newline:
	        if (!isOtherColon) {
	          this.allow_wrap_or_preserved_newline(current_token);
	        }
	
	        // if we just added a newline, or the current token is : and it's not a ternary statement,
	        //   then we set space_before to false
	        space_before = !(this._output.just_added_newline() || isOtherColon);
	
	        this._output.space_before_token = space_before;
	        this.print_token(current_token);
	        this._output.space_before_token = true;
	        return;
	    }
	  }
	
	  if (isGeneratorAsterisk) {
	    this.allow_wrap_or_preserved_newline(current_token);
	    space_before = false;
	    var next_token = this._tokens.peek();
	    space_after = next_token && in_array(next_token.type, [TOKEN.WORD, TOKEN.RESERVED]);
	  } else if (current_token.text === '...') {
	    this.allow_wrap_or_preserved_newline(current_token);
	    space_before = this._flags.last_token.type === TOKEN.START_BLOCK;
	    space_after = false;
	  } else if (in_array(current_token.text, ['--', '++', '!', '~']) || isUnary) {
	    // unary operators (and binary +/- pretending to be unary) special cases
	    if (this._flags.last_token.type === TOKEN.COMMA || this._flags.last_token.type === TOKEN.START_EXPR) {
	      this.allow_wrap_or_preserved_newline(current_token);
	    }
	
	    space_before = false;
	    space_after = false;
	
	    // http://www.ecma-international.org/ecma-262/5.1/#sec-7.9.1
	    // if there is a newline between -- or ++ and anything else we should preserve it.
	    if (current_token.newlines && (current_token.text === '--' || current_token.text === '++')) {
	      this.print_newline(false, true);
	    }
	
	    if (this._flags.last_token.text === ';' && is_expression(this._flags.mode)) {
	      // for (;; ++i)
	      //        ^^^
	      space_before = true;
	    }
	
	    if (this._flags.last_token.type === TOKEN.RESERVED) {
	      space_before = true;
	    } else if (this._flags.last_token.type === TOKEN.END_EXPR) {
	      space_before = !(this._flags.last_token.text === ']' && (current_token.text === '--' || current_token.text === '++'));
	    } else if (this._flags.last_token.type === TOKEN.OPERATOR) {
	      // a++ + ++b;
	      // a - -b
	      space_before = in_array(current_token.text, ['--', '-', '++', '+']) && in_array(this._flags.last_token.text, ['--', '-', '++', '+']);
	      // + and - are not unary when preceeded by -- or ++ operator
	      // a-- + b
	      // a * +b
	      // a - -b
	      if (in_array(current_token.text, ['+', '-']) && in_array(this._flags.last_token.text, ['--', '++'])) {
	        space_after = true;
	      }
	    }
	
	
	    if (((this._flags.mode === MODE.BlockStatement && !this._flags.inline_frame) || this._flags.mode === MODE.Statement) &&
	      (this._flags.last_token.text === '{' || this._flags.last_token.text === ';')) {
	      // { foo; --i }
	      // foo(); --bar;
	      this.print_newline();
	    }
	  }
	
	  this._output.space_before_token = this._output.space_before_token || space_before;
	  this.print_token(current_token);
	  this._output.space_before_token = space_after;
	};
	
	Beautifier.prototype.handle_block_comment = function(current_token, preserve_statement_flags) {
	  if (this._output.raw) {
	    this._output.add_raw_token(current_token);
	    if (current_token.directives && current_token.directives.preserve === 'end') {
	      // If we're testing the raw output behavior, do not allow a directive to turn it off.
	      this._output.raw = this._options.test_output_raw;
	    }
	    return;
	  }
	
	  if (current_token.directives) {
	    this.print_newline(false, preserve_statement_flags);
	    this.print_token(current_token);
	    if (current_token.directives.preserve === 'start') {
	      this._output.raw = true;
	    }
	    this.print_newline(false, true);
	    return;
	  }
	
	  // inline block
	  if (!acorn.newline.test(current_token.text) && !current_token.newlines) {
	    this._output.space_before_token = true;
	    this.print_token(current_token);
	    this._output.space_before_token = true;
	    return;
	  }
	
	  var lines = split_linebreaks(current_token.text);
	  var j; // iterator for this case
	  var javadoc = false;
	  var starless = false;
	  var lastIndent = current_token.whitespace_before;
	  var lastIndentLength = lastIndent.length;
	
	  // block comment starts with a new line
	  this.print_newline(false, preserve_statement_flags);
	  if (lines.length > 1) {
	    javadoc = all_lines_start_with(lines.slice(1), '*');
	    starless = each_line_matches_indent(lines.slice(1), lastIndent);
	  }
	
	  // first line always indented
	  this.print_token(current_token, lines[0]);
	  for (j = 1; j < lines.length; j++) {
	    this.print_newline(false, true);
	    if (javadoc) {
	      // javadoc: reformat and re-indent
	      this.print_token(current_token, ' ' + ltrim(lines[j]));
	    } else if (starless && lines[j].length > lastIndentLength) {
	      // starless: re-indent non-empty content, avoiding trim
	      this.print_token(current_token, lines[j].substring(lastIndentLength));
	    } else {
	      // normal comments output raw
	      this._output.add_token(lines[j]);
	    }
	  }
	
	  // for comments of more than one line, make sure there's a new line after
	  this.print_newline(false, preserve_statement_flags);
	};
	
	Beautifier.prototype.handle_comment = function(current_token, preserve_statement_flags) {
	  if (current_token.newlines) {
	    this.print_newline(false, preserve_statement_flags);
	  } else {
	    this._output.trim(true);
	  }
	
	  this._output.space_before_token = true;
	  this.print_token(current_token);
	  this.print_newline(false, preserve_statement_flags);
	};
	
	Beautifier.prototype.handle_dot = function(current_token) {
	  if (this.start_of_statement(current_token)) {
	    // The conditional starts the statement if appropriate.
	  } else {
	    this.handle_whitespace_and_comments(current_token, true);
	  }
	
	  if (reserved_array(this._flags.last_token, special_words)) {
	    this._output.space_before_token = false;
	  } else {
	    // allow preserved newlines before dots in general
	    // force newlines on dots after close paren when break_chained - for bar().baz()
	    this.allow_wrap_or_preserved_newline(current_token,
	      this._flags.last_token.text === ')' && this._options.break_chained_methods);
	  }
	
	  // Only unindent chained method dot if this dot starts a new line.
	  // Otherwise the automatic extra indentation removal will handle the over indent
	  if (this._options.unindent_chained_methods && this._output.just_added_newline()) {
	    this.deindent();
	  }
	
	  this.print_token(current_token);
	};
	
	Beautifier.prototype.handle_unknown = function(current_token, preserve_statement_flags) {
	  this.print_token(current_token);
	
	  if (current_token.text[current_token.text.length - 1] === '\n') {
	    this.print_newline(false, preserve_statement_flags);
	  }
	};
	
	Beautifier.prototype.handle_eof = function(current_token) {
	  // Unwind any open statements
	  while (this._flags.mode === MODE.Statement) {
	    this.restore_mode();
	  }
	  this.handle_whitespace_and_comments(current_token);
	};
	
	module.exports.Beautifier = Beautifier;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function OutputLine(parent) {
	  this.__parent = parent;
	  this.__character_count = 0;
	  // use indent_count as a marker for this.__lines that have preserved indentation
	  this.__indent_count = -1;
	  this.__alignment_count = 0;
	
	  this.__items = [];
	}
	
	OutputLine.prototype.item = function(index) {
	  if (index < 0) {
	    return this.__items[this.__items.length + index];
	  } else {
	    return this.__items[index];
	  }
	};
	
	OutputLine.prototype.has_match = function(pattern) {
	  for (var lastCheckedOutput = this.__items.length - 1; lastCheckedOutput >= 0; lastCheckedOutput--) {
	    if (this.__items[lastCheckedOutput].match(pattern)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	OutputLine.prototype.set_indent = function(indent, alignment) {
	  this.__indent_count = indent || 0;
	  this.__alignment_count = alignment || 0;
	  this.__character_count = this.__parent.baseIndentLength + this.__alignment_count + this.__indent_count * this.__parent.indent_length;
	};
	
	OutputLine.prototype.get_character_count = function() {
	  return this.__character_count;
	};
	
	OutputLine.prototype.is_empty = function() {
	  return this.__items.length === 0;
	};
	
	OutputLine.prototype.last = function() {
	  if (!this.is_empty()) {
	    return this.__items[this.__items.length - 1];
	  } else {
	    return null;
	  }
	};
	
	OutputLine.prototype.push = function(item) {
	  this.__items.push(item);
	  this.__character_count += item.length;
	};
	
	OutputLine.prototype.push_raw = function(item) {
	  this.push(item);
	  var last_newline_index = item.lastIndexOf('\n');
	  if (last_newline_index !== -1) {
	    this.__character_count = item.length - last_newline_index;
	  }
	};
	
	OutputLine.prototype.pop = function() {
	  var item = null;
	  if (!this.is_empty()) {
	    item = this.__items.pop();
	    this.__character_count -= item.length;
	  }
	  return item;
	};
	
	OutputLine.prototype.remove_indent = function() {
	  if (this.__indent_count > 0) {
	    this.__indent_count -= 1;
	    this.__character_count -= this.__parent.indent_length;
	  }
	};
	
	OutputLine.prototype.trim = function() {
	  while (this.last() === ' ') {
	    this.__items.pop();
	    this.__character_count -= 1;
	  }
	};
	
	OutputLine.prototype.toString = function() {
	  var result = '';
	  if (!this.is_empty()) {
	    if (this.__indent_count >= 0) {
	      result = this.__parent.get_indent_string(this.__indent_count);
	    }
	    if (this.__alignment_count >= 0) {
	      result += this.__parent.get_alignment_string(this.__alignment_count);
	    }
	    result += this.__items.join('');
	  }
	  return result;
	};
	
	function IndentCache(base_string, level_string) {
	  this.__cache = [base_string];
	  this.__level_string = level_string;
	}
	
	IndentCache.prototype.__ensure_cache = function(level) {
	  while (level >= this.__cache.length) {
	    this.__cache.push(this.__cache[this.__cache.length - 1] + this.__level_string);
	  }
	};
	
	IndentCache.prototype.get_level_string = function(level) {
	  this.__ensure_cache(level);
	  return this.__cache[level];
	};
	
	
	function Output(options, baseIndentString) {
	  var indent_string = options.indent_char;
	  if (options.indent_size > 1) {
	    indent_string = new Array(options.indent_size + 1).join(options.indent_char);
	  }
	
	  // Set to null to continue support for auto detection of base indent level.
	  baseIndentString = baseIndentString || '';
	  if (options.indent_level > 0) {
	    baseIndentString = new Array(options.indent_level + 1).join(indent_string);
	  }
	
	  this.__indent_cache = new IndentCache(baseIndentString, indent_string);
	  this.__alignment_cache = new IndentCache('', ' ');
	  this.baseIndentLength = baseIndentString.length;
	  this.indent_length = indent_string.length;
	  this.raw = false;
	  this._end_with_newline = options.end_with_newline;
	
	  this.__lines = [];
	  this.previous_line = null;
	  this.current_line = null;
	  this.space_before_token = false;
	  // initialize
	  this.__add_outputline();
	}
	
	Output.prototype.__add_outputline = function() {
	  this.previous_line = this.current_line;
	  this.current_line = new OutputLine(this);
	  this.__lines.push(this.current_line);
	};
	
	Output.prototype.get_line_number = function() {
	  return this.__lines.length;
	};
	
	Output.prototype.get_indent_string = function(level) {
	  return this.__indent_cache.get_level_string(level);
	};
	
	Output.prototype.get_alignment_string = function(level) {
	  return this.__alignment_cache.get_level_string(level);
	};
	
	Output.prototype.is_empty = function() {
	  return !this.previous_line && this.current_line.is_empty();
	};
	
	Output.prototype.add_new_line = function(force_newline) {
	  // never newline at the start of file
	  // otherwise, newline only if we didn't just add one or we're forced
	  if (this.is_empty() ||
	    (!force_newline && this.just_added_newline())) {
	    return false;
	  }
	
	  // if raw output is enabled, don't print additional newlines,
	  // but still return True as though you had
	  if (!this.raw) {
	    this.__add_outputline();
	  }
	  return true;
	};
	
	Output.prototype.get_code = function(eol) {
	  var sweet_code = this.__lines.join('\n').replace(/[\r\n\t ]+$/, '');
	
	  if (this._end_with_newline) {
	    sweet_code += '\n';
	  }
	
	  if (eol !== '\n') {
	    sweet_code = sweet_code.replace(/[\n]/g, eol);
	  }
	
	  return sweet_code;
	};
	
	Output.prototype.set_indent = function(indent, alignment) {
	  indent = indent || 0;
	  alignment = alignment || 0;
	
	  // Never indent your first output indent at the start of the file
	  if (this.__lines.length > 1) {
	    this.current_line.set_indent(indent, alignment);
	    return true;
	  }
	  this.current_line.set_indent();
	  return false;
	};
	
	Output.prototype.add_raw_token = function(token) {
	  for (var x = 0; x < token.newlines; x++) {
	    this.__add_outputline();
	  }
	  this.current_line.push(token.whitespace_before);
	  this.current_line.push_raw(token.text);
	  this.space_before_token = false;
	};
	
	Output.prototype.add_token = function(printable_token) {
	  this.add_space_before_token();
	  this.current_line.push(printable_token);
	};
	
	Output.prototype.add_space_before_token = function() {
	  if (this.space_before_token && !this.just_added_newline()) {
	    this.current_line.push(' ');
	  }
	  this.space_before_token = false;
	};
	
	Output.prototype.remove_indent = function(index) {
	  var output_length = this.__lines.length;
	  while (index < output_length) {
	    this.__lines[index].remove_indent();
	    index++;
	  }
	};
	
	Output.prototype.trim = function(eat_newlines) {
	  eat_newlines = (eat_newlines === undefined) ? false : eat_newlines;
	
	  this.current_line.trim(this.indent_string, this.baseIndentString);
	
	  while (eat_newlines && this.__lines.length > 1 &&
	    this.current_line.is_empty()) {
	    this.__lines.pop();
	    this.current_line = this.__lines[this.__lines.length - 1];
	    this.current_line.trim();
	  }
	
	  this.previous_line = this.__lines.length > 1 ?
	    this.__lines[this.__lines.length - 2] : null;
	};
	
	Output.prototype.just_added_newline = function() {
	  return this.current_line.is_empty();
	};
	
	Output.prototype.just_added_blankline = function() {
	  return this.is_empty() ||
	    (this.current_line.is_empty() && this.previous_line.is_empty());
	};
	
	Output.prototype.ensure_empty_line_above = function(starts_with, ends_with) {
	  var index = this.__lines.length - 2;
	  while (index >= 0) {
	    var potentialEmptyLine = this.__lines[index];
	    if (potentialEmptyLine.is_empty()) {
	      break;
	    } else if (potentialEmptyLine.item(0).indexOf(starts_with) !== 0 &&
	      potentialEmptyLine.item(-1) !== ends_with) {
	      this.__lines.splice(index + 1, 0, new OutputLine(this));
	      this.previous_line = this.__lines[this.__lines.length - 2];
	      break;
	    }
	    index--;
	  }
	};
	
	module.exports.Output = Output;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function Token(type, text, newlines, whitespace_before) {
	  this.type = type;
	  this.text = text;
	
	  // comments_before are
	  // comments that have a new line before them
	  // and may or may not have a newline after
	  // this is a set of comments before
	  this.comments_before = null; /* inline comment*/
	
	
	  // this.comments_after =  new TokenStream(); // no new line before and newline after
	  this.newlines = newlines || 0;
	  this.whitespace_before = whitespace_before || '';
	  this.parent = null;
	  this.next = null;
	  this.previous = null;
	  this.opened = null;
	  this.closed = null;
	  this.directives = null;
	}
	
	
	module.exports.Token = Token;
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* jshint node: true, curly: false */
	// Parts of this section of code is taken from acorn.
	//
	// Acorn was written by Marijn Haverbeke and released under an MIT
	// license. The Unicode regexps (for identifiers and whitespace) were
	// taken from [Esprima](http://esprima.org) by Ariya Hidayat.
	//
	// Git repositories for Acorn are available at
	//
	//     http://marijnhaverbeke.nl/git/acorn
	//     https://github.com/marijnh/acorn.git
	
	// ## Character categories
	
	
	
	
	// acorn used char codes to squeeze the last bit of performance out
	// Beautifier is okay without that, so we're using regex
	// permit $ (36) and @ (64). @ is used in ES7 decorators.
	// 65 through 91 are uppercase letters.
	// permit _ (95).
	// 97 through 123 are lowercase letters.
	var baseASCIIidentifierStartChars = "\x24\x40\x41-\x5a\x5f\x61-\x7a";
	
	// inside an identifier @ is not allowed but 0-9 are.
	var baseASCIIidentifierChars = "\x24\x30-\x39\x41-\x5a\x5f\x61-\x7a";
	
	// Big ugly regular expressions that match characters in the
	// whitespace, identifier, and identifier-start categories. These
	// are only applied when a character is found to actually have a
	// code point above 128.
	var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
	var nonASCIIidentifierChars = "\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";
	//var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
	//var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
	
	var identifierStart = "[" + baseASCIIidentifierStartChars + nonASCIIidentifierStartChars + "]";
	var identifierChars = "[" + baseASCIIidentifierChars + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]*";
	
	exports.identifier = new RegExp(identifierStart + identifierChars, 'g');
	
	
	var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/; // jshint ignore:line
	
	// Whether a single character denotes a newline.
	
	exports.newline = /[\n\r\u2028\u2029]/;
	
	// Matches a whole line break (where CRLF is considered a single
	// line break). Used to count lines.
	
	// in javascript, these two differ
	// in python they are the same, different methods are called on them
	exports.lineBreak = new RegExp('\r\n|' + exports.newline.source);
	exports.allLineBreaks = new RegExp(exports.lineBreak.source, 'g');
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var BaseOptions = __webpack_require__(6).Options;
	
	var validPositionValues = ['before-newline', 'after-newline', 'preserve-newline'];
	
	function Options(options) {
	  BaseOptions.call(this, options, 'js');
	
	  // compatibility, re
	  var raw_brace_style = this.raw_options.brace_style || null;
	  if (raw_brace_style === "expand-strict") { //graceful handling of deprecated option
	    this.raw_options.brace_style = "expand";
	  } else if (raw_brace_style === "collapse-preserve-inline") { //graceful handling of deprecated option
	    this.raw_options.brace_style = "collapse,preserve-inline";
	  } else if (this.raw_options.braces_on_own_line !== undefined) { //graceful handling of deprecated option
	    this.raw_options.brace_style = this.raw_options.braces_on_own_line ? "expand" : "collapse";
	    // } else if (!raw_brace_style) { //Nothing exists to set it
	    //   raw_brace_style = "collapse";
	  }
	
	  //preserve-inline in delimited string will trigger brace_preserve_inline, everything
	  //else is considered a brace_style and the last one only will have an effect
	
	  var brace_style_split = this._get_selection_list('brace_style', ['collapse', 'expand', 'end-expand', 'none', 'preserve-inline']);
	
	  this.brace_preserve_inline = false; //Defaults in case one or other was not specified in meta-option
	  this.brace_style = "collapse";
	
	  for (var bs = 0; bs < brace_style_split.length; bs++) {
	    if (brace_style_split[bs] === "preserve-inline") {
	      this.brace_preserve_inline = true;
	    } else {
	      this.brace_style = brace_style_split[bs];
	    }
	  }
	
	  this.unindent_chained_methods = this._get_boolean('unindent_chained_methods');
	  this.break_chained_methods = this._get_boolean('break_chained_methods');
	  this.space_in_paren = this._get_boolean('space_in_paren');
	  this.space_in_empty_paren = this._get_boolean('space_in_empty_paren');
	  this.jslint_happy = this._get_boolean('jslint_happy');
	  this.space_after_anon_function = this._get_boolean('space_after_anon_function');
	  this.space_after_named_function = this._get_boolean('space_after_named_function');
	  this.keep_array_indentation = this._get_boolean('keep_array_indentation');
	  this.space_before_conditional = this._get_boolean('space_before_conditional', true);
	  this.unescape_strings = this._get_boolean('unescape_strings');
	  this.e4x = this._get_boolean('e4x');
	  this.comma_first = this._get_boolean('comma_first');
	  this.operator_position = this._get_selection('operator_position', validPositionValues);
	
	  // For testing of beautify preserve:start directive
	  this.test_output_raw = this._get_boolean('test_output_raw');
	
	  // force this._options.space_after_anon_function to true if this._options.jslint_happy
	  if (this.jslint_happy) {
	    this.space_after_anon_function = true;
	  }
	
	}
	Options.prototype = new BaseOptions();
	
	
	
	module.exports.Options = Options;
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function Options(options, merge_child_field) {
	  this.raw_options = _mergeOpts(options, merge_child_field);
	
	  // Support passing the source text back with no change
	  this.disabled = this._get_boolean('disabled');
	
	  this.eol = this._get_characters('eol', 'auto');
	  this.end_with_newline = this._get_boolean('end_with_newline');
	  this.indent_size = this._get_number('indent_size', 4);
	  this.indent_char = this._get_characters('indent_char', ' ');
	  this.indent_level = this._get_number('indent_level');
	
	  this.preserve_newlines = this._get_boolean('preserve_newlines', true);
	  this.max_preserve_newlines = this._get_number('max_preserve_newlines', 32786);
	  if (!this.preserve_newlines) {
	    this.max_preserve_newlines = 0;
	  }
	
	  this.indent_with_tabs = this._get_boolean('indent_with_tabs');
	  if (this.indent_with_tabs) {
	    this.indent_char = '\t';
	    this.indent_size = 1;
	  }
	
	  // Backwards compat with 1.3.x
	  this.wrap_line_length = this._get_number('wrap_line_length', this._get_number('max_char'));
	
	}
	
	Options.prototype._get_array = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  var result = default_value || [];
	  if (typeof option_value === 'object') {
	    if (option_value !== null && typeof option_value.concat === 'function') {
	      result = option_value.concat();
	    }
	  } else if (typeof option_value === 'string') {
	    result = option_value.split(/[^a-zA-Z0-9_\/\-]+/);
	  }
	  return result;
	};
	
	Options.prototype._get_boolean = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  var result = option_value === undefined ? !!default_value : !!option_value;
	  return result;
	};
	
	Options.prototype._get_characters = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  var result = default_value || '';
	  if (typeof option_value === 'string') {
	    result = option_value.replace(/\\r/, '\r').replace(/\\n/, '\n').replace(/\\t/, '\t');
	  }
	  return result;
	};
	
	Options.prototype._get_number = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  default_value = parseInt(default_value, 10);
	  if (isNaN(default_value)) {
	    default_value = 0;
	  }
	  var result = parseInt(option_value, 10);
	  if (isNaN(result)) {
	    result = default_value;
	  }
	  return result;
	};
	
	Options.prototype._get_selection = function(name, selection_list, default_value) {
	  var result = this._get_selection_list(name, selection_list, default_value);
	  if (result.length !== 1) {
	    throw new Error(
	      "Invalid Option Value: The option '" + name + "' can only be one of the following values:\n" +
	      selection_list + "\nYou passed in: '" + this.raw_options[name] + "'");
	  }
	
	  return result[0];
	};
	
	
	Options.prototype._get_selection_list = function(name, selection_list, default_value) {
	  if (!selection_list || selection_list.length === 0) {
	    throw new Error("Selection list cannot be empty.");
	  }
	
	  default_value = default_value || [selection_list[0]];
	  if (!this._is_valid_selection(default_value, selection_list)) {
	    throw new Error("Invalid Default Value!");
	  }
	
	  var result = this._get_array(name, default_value);
	  if (!this._is_valid_selection(result, selection_list)) {
	    throw new Error(
	      "Invalid Option Value: The option '" + name + "' can contain only the following values:\n" +
	      selection_list + "\nYou passed in: '" + this.raw_options[name] + "'");
	  }
	
	  return result;
	};
	
	Options.prototype._is_valid_selection = function(result, selection_list) {
	  return result.length && selection_list.length &&
	    !result.some(function(item) { return selection_list.indexOf(item) === -1; });
	};
	
	
	// merges child options up with the parent options object
	// Example: obj = {a: 1, b: {a: 2}}
	//          mergeOpts(obj, 'b')
	//
	//          Returns: {a: 2}
	function _mergeOpts(allOptions, childFieldName) {
	  var finalOpts = {};
	  allOptions = _normalizeOpts(allOptions);
	  var name;
	
	  for (name in allOptions) {
	    if (name !== childFieldName) {
	      finalOpts[name] = allOptions[name];
	    }
	  }
	
	  //merge in the per type settings for the childFieldName
	  if (childFieldName && allOptions[childFieldName]) {
	    for (name in allOptions[childFieldName]) {
	      finalOpts[name] = allOptions[childFieldName][name];
	    }
	  }
	  return finalOpts;
	}
	
	function _normalizeOpts(options) {
	  var convertedOpts = {};
	  var key;
	
	  for (key in options) {
	    var newKey = key.replace(/-/g, "_");
	    convertedOpts[newKey] = options[key];
	  }
	  return convertedOpts;
	}
	
	module.exports.Options = Options;
	module.exports.normalizeOpts = _normalizeOpts;
	module.exports.mergeOpts = _mergeOpts;
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var InputScanner = __webpack_require__(8).InputScanner;
	var BaseTokenizer = __webpack_require__(9).Tokenizer;
	var BASETOKEN = __webpack_require__(9).TOKEN;
	var Directives = __webpack_require__(11).Directives;
	var acorn = __webpack_require__(4);
	
	function in_array(what, arr) {
	  return arr.indexOf(what) !== -1;
	}
	
	
	var TOKEN = {
	  START_EXPR: 'TK_START_EXPR',
	  END_EXPR: 'TK_END_EXPR',
	  START_BLOCK: 'TK_START_BLOCK',
	  END_BLOCK: 'TK_END_BLOCK',
	  WORD: 'TK_WORD',
	  RESERVED: 'TK_RESERVED',
	  SEMICOLON: 'TK_SEMICOLON',
	  STRING: 'TK_STRING',
	  EQUALS: 'TK_EQUALS',
	  OPERATOR: 'TK_OPERATOR',
	  COMMA: 'TK_COMMA',
	  BLOCK_COMMENT: 'TK_BLOCK_COMMENT',
	  COMMENT: 'TK_COMMENT',
	  DOT: 'TK_DOT',
	  UNKNOWN: 'TK_UNKNOWN',
	  START: BASETOKEN.START,
	  RAW: BASETOKEN.RAW,
	  EOF: BASETOKEN.EOF
	};
	
	
	var directives_core = new Directives(/\/\*/, /\*\//);
	
	var number_pattern = /0[xX][0123456789abcdefABCDEF]*|0[oO][01234567]*|0[bB][01]*|\d+n|(?:\.\d+|\d+\.?\d*)(?:[eE][+-]?\d+)?/g;
	
	var digit = /[0-9]/;
	
	// Dot "." must be distinguished from "..." and decimal
	var dot_pattern = /[^\d\.]/;
	
	var positionable_operators = (
	  ">>> === !== " +
	  "<< && >= ** != == <= >> || " +
	  "< / - + > : & % ? ^ | *").split(' ');
	
	// IMPORTANT: this must be sorted longest to shortest or tokenizing many not work.
	// Also, you must update possitionable operators separately from punct
	var punct =
	  ">>>= " +
	  "... >>= <<= === >>> !== **= " +
	  "=> ^= :: /= << <= == && -= >= >> != -- += ** || ++ %= &= *= |= " +
	  "= ! ? > < : / ^ - + * & % ~ |";
	
	punct = punct.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&");
	punct = punct.replace(/ /g, '|');
	
	var punct_pattern = new RegExp(punct, 'g');
	var shebang_pattern = /#![^\n\r\u2028\u2029]*(?:\r\n|[\n\r\u2028\u2029])?/g;
	var include_pattern = /#include[^\n\r\u2028\u2029]*(?:\r\n|[\n\r\u2028\u2029])?/g;
	
	// words which should always start on new line.
	var line_starters = 'continue,try,throw,return,var,let,const,if,switch,case,default,for,while,break,function,import,export'.split(',');
	var reserved_words = line_starters.concat(['do', 'in', 'of', 'else', 'get', 'set', 'new', 'catch', 'finally', 'typeof', 'yield', 'async', 'await', 'from', 'as']);
	var reserved_word_pattern = new RegExp('^(?:' + reserved_words.join('|') + ')$');
	
	//  /* ... */ comment ends with nearest */ or end of file
	var block_comment_pattern = /\/\*(?:[\s\S]*?)((?:\*\/)|$)/g;
	
	// comment ends just before nearest linefeed or end of file
	var comment_pattern = /\/\/(?:[^\n\r\u2028\u2029]*)/g;
	
	var template_pattern = /(?:(?:<\?php|<\?=)[\s\S]*?\?>)|(?:<%[\s\S]*?%>)/g;
	
	var in_html_comment;
	
	var Tokenizer = function(input_string, options) {
	  BaseTokenizer.call(this, input_string, options);
	
	  this._whitespace_pattern = /[\n\r\u2028\u2029\t\u000B\u00A0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff ]+/g;
	  this._newline_pattern = /([^\n\r\u2028\u2029]*)(\r\n|[\n\r\u2028\u2029])?/g;
	};
	Tokenizer.prototype = new BaseTokenizer();
	
	Tokenizer.prototype._is_comment = function(current_token) {
	  return current_token.type === TOKEN.COMMENT || current_token.type === TOKEN.BLOCK_COMMENT || current_token.type === TOKEN.UNKNOWN;
	};
	
	Tokenizer.prototype._is_opening = function(current_token) {
	  return current_token.type === TOKEN.START_BLOCK || current_token.type === TOKEN.START_EXPR;
	};
	
	Tokenizer.prototype._is_closing = function(current_token, open_token) {
	  return (current_token.type === TOKEN.END_BLOCK || current_token.type === TOKEN.END_EXPR) &&
	    (open_token && (
	      (current_token.text === ']' && open_token.text === '[') ||
	      (current_token.text === ')' && open_token.text === '(') ||
	      (current_token.text === '}' && open_token.text === '{')));
	};
	
	Tokenizer.prototype._reset = function() {
	  in_html_comment = false;
	};
	
	Tokenizer.prototype._get_next_token = function(previous_token, open_token) { // jshint unused:false
	  this._readWhitespace();
	  var token = null;
	  var c = this._input.peek();
	
	  token = token || this._read_singles(c);
	  token = token || this._read_word(previous_token);
	  token = token || this._read_comment(c);
	  token = token || this._read_string(c);
	  token = token || this._read_regexp(c, previous_token);
	  token = token || this._read_xml(c, previous_token);
	  token = token || this._read_non_javascript(c);
	  token = token || this._read_punctuation();
	  token = token || this._create_token(TOKEN.UNKNOWN, this._input.next());
	
	  return token;
	};
	
	Tokenizer.prototype._read_word = function(previous_token) {
	  var resulting_string;
	  resulting_string = this._input.read(acorn.identifier);
	  if (resulting_string !== '') {
	    if (!(previous_token.type === TOKEN.DOT ||
	        (previous_token.type === TOKEN.RESERVED && (previous_token.text === 'set' || previous_token.text === 'get'))) &&
	      reserved_word_pattern.test(resulting_string)) {
	      if (resulting_string === 'in' || resulting_string === 'of') { // hack for 'in' and 'of' operators
	        return this._create_token(TOKEN.OPERATOR, resulting_string);
	      }
	      return this._create_token(TOKEN.RESERVED, resulting_string);
	    }
	
	    return this._create_token(TOKEN.WORD, resulting_string);
	  }
	
	  resulting_string = this._input.read(number_pattern);
	  if (resulting_string !== '') {
	    return this._create_token(TOKEN.WORD, resulting_string);
	  }
	};
	
	Tokenizer.prototype._read_singles = function(c) {
	  var token = null;
	  if (c === null) {
	    token = this._create_token(TOKEN.EOF, '');
	  } else if (c === '(' || c === '[') {
	    token = this._create_token(TOKEN.START_EXPR, c);
	  } else if (c === ')' || c === ']') {
	    token = this._create_token(TOKEN.END_EXPR, c);
	  } else if (c === '{') {
	    token = this._create_token(TOKEN.START_BLOCK, c);
	  } else if (c === '}') {
	    token = this._create_token(TOKEN.END_BLOCK, c);
	  } else if (c === ';') {
	    token = this._create_token(TOKEN.SEMICOLON, c);
	  } else if (c === '.' && dot_pattern.test(this._input.peek(1))) {
	    token = this._create_token(TOKEN.DOT, c);
	  } else if (c === ',') {
	    token = this._create_token(TOKEN.COMMA, c);
	  }
	
	  if (token) {
	    this._input.next();
	  }
	  return token;
	};
	
	Tokenizer.prototype._read_punctuation = function() {
	  var resulting_string = this._input.read(punct_pattern);
	
	  if (resulting_string !== '') {
	    if (resulting_string === '=') {
	      return this._create_token(TOKEN.EQUALS, resulting_string);
	    } else {
	      return this._create_token(TOKEN.OPERATOR, resulting_string);
	    }
	  }
	};
	
	Tokenizer.prototype._read_non_javascript = function(c) {
	  var resulting_string = '';
	
	  if (c === '#') {
	    if (this._is_first_token()) {
	      resulting_string = this._input.read(shebang_pattern);
	
	      if (resulting_string) {
	        return this._create_token(TOKEN.UNKNOWN, resulting_string.trim() + '\n');
	      }
	    }
	
	    // handles extendscript #includes
	    resulting_string = this._input.read(include_pattern);
	
	    if (resulting_string) {
	      return this._create_token(TOKEN.UNKNOWN, resulting_string.trim() + '\n');
	    }
	
	    c = this._input.next();
	
	    // Spidermonkey-specific sharp variables for circular references. Considered obsolete.
	    var sharp = '#';
	    if (this._input.hasNext() && this._input.testChar(digit)) {
	      do {
	        c = this._input.next();
	        sharp += c;
	      } while (this._input.hasNext() && c !== '#' && c !== '=');
	      if (c === '#') {
	        //
	      } else if (this._input.peek() === '[' && this._input.peek(1) === ']') {
	        sharp += '[]';
	        this._input.next();
	        this._input.next();
	      } else if (this._input.peek() === '{' && this._input.peek(1) === '}') {
	        sharp += '{}';
	        this._input.next();
	        this._input.next();
	      }
	      return this._create_token(TOKEN.WORD, sharp);
	    }
	
	    this._input.back();
	
	  } else if (c === '<') {
	    if (this._input.peek(1) === '?' || this._input.peek(1) === '%') {
	      resulting_string = this._input.read(template_pattern);
	      if (resulting_string) {
	        resulting_string = resulting_string.replace(acorn.allLineBreaks, '\n');
	        return this._create_token(TOKEN.STRING, resulting_string);
	      }
	    } else if (this._input.match(/<\!--/g)) {
	      c = '<!--';
	      while (this._input.hasNext() && !this._input.testChar(acorn.newline)) {
	        c += this._input.next();
	      }
	      in_html_comment = true;
	      return this._create_token(TOKEN.COMMENT, c);
	    }
	  } else if (c === '-' && in_html_comment && this._input.match(/-->/g)) {
	    in_html_comment = false;
	    return this._create_token(TOKEN.COMMENT, '-->');
	  }
	
	  return null;
	};
	
	Tokenizer.prototype._read_comment = function(c) {
	  var token = null;
	  if (c === '/') {
	    var comment = '';
	    if (this._input.peek(1) === '*') {
	      // peek for comment /* ... */
	      comment = this._input.read(block_comment_pattern);
	      var directives = directives_core.get_directives(comment);
	      if (directives && directives.ignore === 'start') {
	        comment += directives_core.readIgnored(this._input);
	      }
	      comment = comment.replace(acorn.allLineBreaks, '\n');
	      token = this._create_token(TOKEN.BLOCK_COMMENT, comment);
	      token.directives = directives;
	    } else if (this._input.peek(1) === '/') {
	      // peek for comment // ...
	      comment = this._input.read(comment_pattern);
	      token = this._create_token(TOKEN.COMMENT, comment);
	    }
	  }
	  return token;
	};
	
	Tokenizer.prototype._read_string = function(c) {
	  if (c === '`' || c === "'" || c === '"') {
	    var resulting_string = this._input.next();
	    this.has_char_escapes = false;
	
	    if (c === '`') {
	      resulting_string += this._read_string_recursive('`', true, '${');
	    } else {
	      resulting_string += this._read_string_recursive(c);
	    }
	
	    if (this.has_char_escapes && this._options.unescape_strings) {
	      resulting_string = unescape_string(resulting_string);
	    }
	    if (this._input.peek() === c) {
	      resulting_string += this._input.next();
	    }
	
	    return this._create_token(TOKEN.STRING, resulting_string);
	  }
	
	  return null;
	};
	
	Tokenizer.prototype._allow_regexp_or_xml = function(previous_token) {
	  // regex and xml can only appear in specific locations during parsing
	  return (previous_token.type === TOKEN.RESERVED && in_array(previous_token.text, ['return', 'case', 'throw', 'else', 'do', 'typeof', 'yield'])) ||
	    (previous_token.type === TOKEN.END_EXPR && previous_token.text === ')' &&
	      previous_token.opened.previous.type === TOKEN.RESERVED && in_array(previous_token.opened.previous.text, ['if', 'while', 'for'])) ||
	    (in_array(previous_token.type, [TOKEN.COMMENT, TOKEN.START_EXPR, TOKEN.START_BLOCK, TOKEN.START,
	      TOKEN.END_BLOCK, TOKEN.OPERATOR, TOKEN.EQUALS, TOKEN.EOF, TOKEN.SEMICOLON, TOKEN.COMMA
	    ]));
	};
	
	Tokenizer.prototype._read_regexp = function(c, previous_token) {
	
	  if (c === '/' && this._allow_regexp_or_xml(previous_token)) {
	    // handle regexp
	    //
	    var resulting_string = this._input.next();
	    var esc = false;
	
	    var in_char_class = false;
	    while (this._input.hasNext() &&
	      ((esc || in_char_class || this._input.peek() !== c) &&
	        !this._input.testChar(acorn.newline))) {
	      resulting_string += this._input.peek();
	      if (!esc) {
	        esc = this._input.peek() === '\\';
	        if (this._input.peek() === '[') {
	          in_char_class = true;
	        } else if (this._input.peek() === ']') {
	          in_char_class = false;
	        }
	      } else {
	        esc = false;
	      }
	      this._input.next();
	    }
	
	    if (this._input.peek() === c) {
	      resulting_string += this._input.next();
	
	      // regexps may have modifiers /regexp/MOD , so fetch those, too
	      // Only [gim] are valid, but if the user puts in garbage, do what we can to take it.
	      resulting_string += this._input.read(acorn.identifier);
	    }
	    return this._create_token(TOKEN.STRING, resulting_string);
	  }
	  return null;
	};
	
	
	var startXmlRegExp = /<()([-a-zA-Z:0-9_.]+|{[\s\S]+?}|!\[CDATA\[[\s\S]*?\]\])(\s+{[\s\S]+?}|\s+[-a-zA-Z:0-9_.]+|\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{[\s\S]+?}))*\s*(\/?)\s*>/g;
	var xmlRegExp = /[\s\S]*?<(\/?)([-a-zA-Z:0-9_.]+|{[\s\S]+?}|!\[CDATA\[[\s\S]*?\]\])(\s+{[\s\S]+?}|\s+[-a-zA-Z:0-9_.]+|\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{[\s\S]+?}))*\s*(\/?)\s*>/g;
	
	Tokenizer.prototype._read_xml = function(c, previous_token) {
	
	  if (this._options.e4x && c === "<" && this._input.test(startXmlRegExp) && this._allow_regexp_or_xml(previous_token)) {
	    // handle e4x xml literals
	    //
	    var xmlStr = '';
	    var match = this._input.match(startXmlRegExp);
	    if (match) {
	      // Trim root tag to attempt to
	      var rootTag = match[2].replace(/^{\s+/, '{').replace(/\s+}$/, '}');
	      var isCurlyRoot = rootTag.indexOf('{') === 0;
	      var depth = 0;
	      while (match) {
	        var isEndTag = !!match[1];
	        var tagName = match[2];
	        var isSingletonTag = (!!match[match.length - 1]) || (tagName.slice(0, 8) === "![CDATA[");
	        if (!isSingletonTag &&
	          (tagName === rootTag || (isCurlyRoot && tagName.replace(/^{\s+/, '{').replace(/\s+}$/, '}')))) {
	          if (isEndTag) {
	            --depth;
	          } else {
	            ++depth;
	          }
	        }
	        xmlStr += match[0];
	        if (depth <= 0) {
	          break;
	        }
	        match = this._input.match(xmlRegExp);
	      }
	      // if we didn't close correctly, keep unformatted.
	      if (!match) {
	        xmlStr += this._input.match(/[\s\S]*/g)[0];
	      }
	      xmlStr = xmlStr.replace(acorn.allLineBreaks, '\n');
	      return this._create_token(TOKEN.STRING, xmlStr);
	    }
	  }
	
	  return null;
	};
	
	function unescape_string(s) {
	  // You think that a regex would work for this
	  // return s.replace(/\\x([0-9a-f]{2})/gi, function(match, val) {
	  //         return String.fromCharCode(parseInt(val, 16));
	  //     })
	  // However, dealing with '\xff', '\\xff', '\\\xff' makes this more fun.
	  var out = '',
	    escaped = 0;
	
	  var input_scan = new InputScanner(s);
	  var matched = null;
	
	  while (input_scan.hasNext()) {
	    // Keep any whitespace, non-slash characters
	    // also keep slash pairs.
	    matched = input_scan.match(/([\s]|[^\\]|\\\\)+/g);
	
	    if (matched) {
	      out += matched[0];
	    }
	
	    if (input_scan.peek() === '\\') {
	      input_scan.next();
	      if (input_scan.peek() === 'x') {
	        matched = input_scan.match(/x([0-9A-Fa-f]{2})/g);
	      } else if (input_scan.peek() === 'u') {
	        matched = input_scan.match(/u([0-9A-Fa-f]{4})/g);
	      } else {
	        out += '\\';
	        if (input_scan.hasNext()) {
	          out += input_scan.next();
	        }
	        continue;
	      }
	
	      // If there's some error decoding, return the original string
	      if (!matched) {
	        return s;
	      }
	
	      escaped = parseInt(matched[1], 16);
	
	      if (escaped > 0x7e && escaped <= 0xff && matched[0].indexOf('x') === 0) {
	        // we bail out on \x7f..\xff,
	        // leaving whole string escaped,
	        // as it's probably completely binary
	        return s;
	      } else if (escaped >= 0x00 && escaped < 0x20) {
	        // leave 0x00...0x1f escaped
	        out += '\\' + matched[0];
	        continue;
	      } else if (escaped === 0x22 || escaped === 0x27 || escaped === 0x5c) {
	        // single-quote, apostrophe, backslash - escape these
	        out += '\\' + String.fromCharCode(escaped);
	      } else {
	        out += String.fromCharCode(escaped);
	      }
	    }
	  }
	
	  return out;
	}
	
	// handle string
	//
	Tokenizer.prototype._read_string_recursive = function(delimiter, allow_unescaped_newlines, start_sub) {
	  // Template strings can travers lines without escape characters.
	  // Other strings cannot
	  var current_char;
	  var resulting_string = '';
	  var esc = false;
	  while (this._input.hasNext()) {
	    current_char = this._input.peek();
	    if (!(esc || (current_char !== delimiter &&
	        (allow_unescaped_newlines || !acorn.newline.test(current_char))))) {
	      break;
	    }
	
	    // Handle \r\n linebreaks after escapes or in template strings
	    if ((esc || allow_unescaped_newlines) && acorn.newline.test(current_char)) {
	      if (current_char === '\r' && this._input.peek(1) === '\n') {
	        this._input.next();
	        current_char = this._input.peek();
	      }
	      resulting_string += '\n';
	    } else {
	      resulting_string += current_char;
	    }
	
	    if (esc) {
	      if (current_char === 'x' || current_char === 'u') {
	        this.has_char_escapes = true;
	      }
	      esc = false;
	    } else {
	      esc = current_char === '\\';
	    }
	
	    this._input.next();
	
	    if (start_sub && resulting_string.indexOf(start_sub, resulting_string.length - start_sub.length) !== -1) {
	      if (delimiter === '`') {
	        resulting_string += this._read_string_recursive('}', allow_unescaped_newlines, '`');
	      } else {
	        resulting_string += this._read_string_recursive('`', allow_unescaped_newlines, '${');
	      }
	
	      if (this._input.hasNext()) {
	        resulting_string += this._input.next();
	      }
	    }
	  }
	
	  return resulting_string;
	};
	
	module.exports.Tokenizer = Tokenizer;
	module.exports.TOKEN = TOKEN;
	module.exports.positionable_operators = positionable_operators.slice();
	module.exports.line_starters = line_starters.slice();
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function InputScanner(input_string) {
	  this.__input = input_string || '';
	  this.__input_length = this.__input.length;
	  this.__position = 0;
	}
	
	InputScanner.prototype.restart = function() {
	  this.__position = 0;
	};
	
	InputScanner.prototype.back = function() {
	  if (this.__position > 0) {
	    this.__position -= 1;
	  }
	};
	
	InputScanner.prototype.hasNext = function() {
	  return this.__position < this.__input_length;
	};
	
	InputScanner.prototype.next = function() {
	  var val = null;
	  if (this.hasNext()) {
	    val = this.__input.charAt(this.__position);
	    this.__position += 1;
	  }
	  return val;
	};
	
	InputScanner.prototype.peek = function(index) {
	  var val = null;
	  index = index || 0;
	  index += this.__position;
	  if (index >= 0 && index < this.__input_length) {
	    val = this.__input.charAt(index);
	  }
	  return val;
	};
	
	InputScanner.prototype.test = function(pattern, index) {
	  index = index || 0;
	  index += this.__position;
	  pattern.lastIndex = index;
	
	  if (index >= 0 && index < this.__input_length) {
	    var pattern_match = pattern.exec(this.__input);
	    return pattern_match && pattern_match.index === index;
	  } else {
	    return false;
	  }
	};
	
	InputScanner.prototype.testChar = function(pattern, index) {
	  // test one character regex match
	  var val = this.peek(index);
	  return val !== null && pattern.test(val);
	};
	
	InputScanner.prototype.match = function(pattern) {
	  pattern.lastIndex = this.__position;
	  var pattern_match = pattern.exec(this.__input);
	  if (pattern_match && pattern_match.index === this.__position) {
	    this.__position += pattern_match[0].length;
	  } else {
	    pattern_match = null;
	  }
	  return pattern_match;
	};
	
	InputScanner.prototype.read = function(pattern) {
	  var val = '';
	  var match = this.match(pattern);
	  if (match) {
	    val = match[0];
	  }
	  return val;
	};
	
	InputScanner.prototype.readUntil = function(pattern, include_match) {
	  var val = '';
	  var match_index = this.__position;
	  pattern.lastIndex = this.__position;
	  var pattern_match = pattern.exec(this.__input);
	  if (pattern_match) {
	    if (include_match) {
	      match_index = pattern_match.index + pattern_match[0].length;
	    } else {
	      match_index = pattern_match.index;
	    }
	  } else {
	    match_index = this.__input_length;
	  }
	
	  val = this.__input.substring(this.__position, match_index);
	  this.__position = match_index;
	  return val;
	};
	
	InputScanner.prototype.readUntilAfter = function(pattern) {
	  return this.readUntil(pattern, true);
	};
	
	/* css beautifier legacy helpers */
	InputScanner.prototype.peekUntilAfter = function(pattern) {
	  var start = this.__position;
	  var val = this.readUntilAfter(pattern);
	  this.__position = start;
	  return val;
	};
	
	InputScanner.prototype.lookBack = function(testVal) {
	  var start = this.__position - 1;
	  return start >= testVal.length && this.__input.substring(start - testVal.length, start)
	    .toLowerCase() === testVal;
	};
	
	
	module.exports.InputScanner = InputScanner;
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var InputScanner = __webpack_require__(8).InputScanner;
	var Token = __webpack_require__(3).Token;
	var TokenStream = __webpack_require__(10).TokenStream;
	
	var TOKEN = {
	  START: 'TK_START',
	  RAW: 'TK_RAW',
	  EOF: 'TK_EOF'
	};
	
	var Tokenizer = function(input_string, options) {
	  this._input = new InputScanner(input_string);
	  this._options = options || {};
	  this.__tokens = null;
	  this.__newline_count = 0;
	  this.__whitespace_before_token = '';
	
	  this._whitespace_pattern = /[\n\r\t ]+/g;
	  this._newline_pattern = /([^\n\r]*)(\r\n|[\n\r])?/g;
	};
	
	Tokenizer.prototype.tokenize = function() {
	  this._input.restart();
	  this.__tokens = new TokenStream();
	
	  this._reset();
	
	  var current;
	  var previous = new Token(TOKEN.START, '');
	  var open_token = null;
	  var open_stack = [];
	  var comments = new TokenStream();
	
	  while (previous.type !== TOKEN.EOF) {
	    current = this._get_next_token(previous, open_token);
	    while (this._is_comment(current)) {
	      comments.add(current);
	      current = this._get_next_token(previous, open_token);
	    }
	
	    if (!comments.isEmpty()) {
	      current.comments_before = comments;
	      comments = new TokenStream();
	    }
	
	    current.parent = open_token;
	
	    if (this._is_opening(current)) {
	      open_stack.push(open_token);
	      open_token = current;
	    } else if (open_token && this._is_closing(current, open_token)) {
	      current.opened = open_token;
	      open_token.closed = current;
	      open_token = open_stack.pop();
	      current.parent = open_token;
	    }
	
	    current.previous = previous;
	    previous.next = current;
	
	    this.__tokens.add(current);
	    previous = current;
	  }
	
	  return this.__tokens;
	};
	
	
	Tokenizer.prototype._is_first_token = function() {
	  return this.__tokens.isEmpty();
	};
	
	Tokenizer.prototype._reset = function() {};
	
	Tokenizer.prototype._get_next_token = function(previous_token, open_token) { // jshint unused:false
	  this._readWhitespace();
	  var resulting_string = this._input.read(/.+/g);
	  if (resulting_string) {
	    return this._create_token(TOKEN.RAW, resulting_string);
	  } else {
	    return this._create_token(TOKEN.EOF, '');
	  }
	};
	
	Tokenizer.prototype._is_comment = function(current_token) { // jshint unused:false
	  return false;
	};
	
	Tokenizer.prototype._is_opening = function(current_token) { // jshint unused:false
	  return false;
	};
	
	Tokenizer.prototype._is_closing = function(current_token, open_token) { // jshint unused:false
	  return false;
	};
	
	Tokenizer.prototype._create_token = function(type, text) {
	  var token = new Token(type, text, this.__newline_count, this.__whitespace_before_token);
	  this.__newline_count = 0;
	  this.__whitespace_before_token = '';
	  return token;
	};
	
	Tokenizer.prototype._readWhitespace = function() {
	  var resulting_string = this._input.read(this._whitespace_pattern);
	  if (resulting_string === ' ') {
	    this.__whitespace_before_token = resulting_string;
	  } else if (resulting_string !== '') {
	    this._newline_pattern.lastIndex = 0;
	    var nextMatch = this._newline_pattern.exec(resulting_string);
	    while (nextMatch[2]) {
	      this.__newline_count += 1;
	      nextMatch = this._newline_pattern.exec(resulting_string);
	    }
	    this.__whitespace_before_token = nextMatch[1];
	  }
	};
	
	
	
	module.exports.Tokenizer = Tokenizer;
	module.exports.TOKEN = TOKEN;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function TokenStream(parent_token) {
	  // private
	  this.__tokens = [];
	  this.__tokens_length = this.__tokens.length;
	  this.__position = 0;
	  this.__parent_token = parent_token;
	}
	
	TokenStream.prototype.restart = function() {
	  this.__position = 0;
	};
	
	TokenStream.prototype.isEmpty = function() {
	  return this.__tokens_length === 0;
	};
	
	TokenStream.prototype.hasNext = function() {
	  return this.__position < this.__tokens_length;
	};
	
	TokenStream.prototype.next = function() {
	  var val = null;
	  if (this.hasNext()) {
	    val = this.__tokens[this.__position];
	    this.__position += 1;
	  }
	  return val;
	};
	
	TokenStream.prototype.peek = function(index) {
	  var val = null;
	  index = index || 0;
	  index += this.__position;
	  if (index >= 0 && index < this.__tokens_length) {
	    val = this.__tokens[index];
	  }
	  return val;
	};
	
	TokenStream.prototype.add = function(token) {
	  if (this.__parent_token) {
	    token.parent = this.__parent_token;
	  }
	  this.__tokens.push(token);
	  this.__tokens_length += 1;
	};
	
	module.exports.TokenStream = TokenStream;
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function Directives(start_block_pattern, end_block_pattern) {
	  start_block_pattern = typeof start_block_pattern === 'string' ? start_block_pattern : start_block_pattern.source;
	  end_block_pattern = typeof end_block_pattern === 'string' ? end_block_pattern : end_block_pattern.source;
	  this.__directives_block_pattern = new RegExp(start_block_pattern + / beautify( \w+[:]\w+)+ /.source + end_block_pattern, 'g');
	  this.__directive_pattern = / (\w+)[:](\w+)/g;
	
	  this.__directives_end_ignore_pattern = new RegExp('(?:[\\s\\S]*?)((?:' + start_block_pattern + /\sbeautify\signore:end\s/.source + end_block_pattern + ')|$)', 'g');
	}
	
	Directives.prototype.get_directives = function(text) {
	  if (!text.match(this.__directives_block_pattern)) {
	    return null;
	  }
	
	  var directives = {};
	  this.__directive_pattern.lastIndex = 0;
	  var directive_match = this.__directive_pattern.exec(text);
	
	  while (directive_match) {
	    directives[directive_match[1]] = directive_match[2];
	    directive_match = this.__directive_pattern.exec(text);
	  }
	
	  return directives;
	};
	
	Directives.prototype.readIgnored = function(input) {
	  return input.read(this.__directives_end_ignore_pattern);
	};
	
	
	module.exports.Directives = Directives;
	
	
	/***/ })
	/******/ ]);
	var js_beautify = legacy_beautify_js;
	/* Footer */
	if (true) {
	    // Add support for AMD ( https://github.com/amdjs/amdjs-api/wiki/AMD#defineamd-property- )
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return { js_beautify: js_beautify };
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== "undefined") {
	    // Add support for CommonJS. Just put this file somewhere on your require.paths
	    // and you will be able to `var js_beautify = require("beautify").js_beautify`.
	    exports.js_beautify = js_beautify;
	} else if (typeof window !== "undefined") {
	    // If we're running a web page and don't have either of the above, add our one global
	    window.js_beautify = js_beautify;
	} else if (typeof global !== "undefined") {
	    // If we don't even have window, try global.
	    global.js_beautify = js_beautify;
	}
	
	}());
	


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/* @preserve
	 * Leaflet 1.3.4, a JS library for interactive maps. http://leafletjs.com
	 * (c) 2010-2018 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.L = {})));
	}(this, (function (exports) { 'use strict';
	
	var version = "1.3.4";
	
	/*
	 * @namespace Util
	 *
	 * Various utility functions, used by Leaflet internally.
	 */
	
	var freeze = Object.freeze;
	Object.freeze = function (obj) { return obj; };
	
	// @function extend(dest: Object, src?: Object): Object
	// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	function extend(dest) {
		var i, j, len, src;
	
		for (j = 1, len = arguments.length; j < len; j++) {
			src = arguments[j];
			for (i in src) {
				dest[i] = src[i];
			}
		}
		return dest;
	}
	
	// @function create(proto: Object, properties?: Object): Object
	// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	var create = Object.create || (function () {
		function F() {}
		return function (proto) {
			F.prototype = proto;
			return new F();
		};
	})();
	
	// @function bind(fn: Function, …): Function
	// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	// Has a `L.bind()` shortcut.
	function bind(fn, obj) {
		var slice = Array.prototype.slice;
	
		if (fn.bind) {
			return fn.bind.apply(fn, slice.call(arguments, 1));
		}
	
		var args = slice.call(arguments, 2);
	
		return function () {
			return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
		};
	}
	
	// @property lastId: Number
	// Last unique ID used by [`stamp()`](#util-stamp)
	var lastId = 0;
	
	// @function stamp(obj: Object): Number
	// Returns the unique ID of an object, assigning it one if it doesn't have it.
	function stamp(obj) {
		/*eslint-disable */
		obj._leaflet_id = obj._leaflet_id || ++lastId;
		return obj._leaflet_id;
		/* eslint-enable */
	}
	
	// @function throttle(fn: Function, time: Number, context: Object): Function
	// Returns a function which executes function `fn` with the given scope `context`
	// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	// `fn` will be called no more than one time per given amount of `time`. The arguments
	// received by the bound function will be any arguments passed when binding the
	// function, followed by any arguments passed when invoking the bound function.
	// Has an `L.throttle` shortcut.
	function throttle(fn, time, context) {
		var lock, args, wrapperFn, later;
	
		later = function () {
			// reset lock and call if queued
			lock = false;
			if (args) {
				wrapperFn.apply(context, args);
				args = false;
			}
		};
	
		wrapperFn = function () {
			if (lock) {
				// called too soon, queue to call later
				args = arguments;
	
			} else {
				// call and lock until later
				fn.apply(context, arguments);
				setTimeout(later, time);
				lock = true;
			}
		};
	
		return wrapperFn;
	}
	
	// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	// Returns the number `num` modulo `range` in such a way so it lies within
	// `range[0]` and `range[1]`. The returned value will be always smaller than
	// `range[1]` unless `includeMax` is set to `true`.
	function wrapNum(x, range, includeMax) {
		var max = range[1],
		    min = range[0],
		    d = max - min;
		return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	}
	
	// @function falseFn(): Function
	// Returns a function which always returns `false`.
	function falseFn() { return false; }
	
	// @function formatNum(num: Number, digits?: Number): Number
	// Returns the number `num` rounded to `digits` decimals, or to 6 decimals by default.
	function formatNum(num, digits) {
		var pow = Math.pow(10, (digits === undefined ? 6 : digits));
		return Math.round(num * pow) / pow;
	}
	
	// @function trim(str: String): String
	// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	function trim(str) {
		return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	// @function splitWords(str: String): String[]
	// Trims and splits the string on whitespace and returns the array of parts.
	function splitWords(str) {
		return trim(str).split(/\s+/);
	}
	
	// @function setOptions(obj: Object, options: Object): Object
	// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	function setOptions(obj, options) {
		if (!obj.hasOwnProperty('options')) {
			obj.options = obj.options ? create(obj.options) : {};
		}
		for (var i in options) {
			obj.options[i] = options[i];
		}
		return obj.options;
	}
	
	// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	// be appended at the end. If `uppercase` is `true`, the parameter names will
	// be uppercased (e.g. `'?A=foo&B=bar'`)
	function getParamString(obj, existingUrl, uppercase) {
		var params = [];
		for (var i in obj) {
			params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
		}
		return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	}
	
	var templateRe = /\{ *([\w_-]+) *\}/g;
	
	// @function template(str: String, data: Object): String
	// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	// `('Hello foo, bar')`. You can also specify functions instead of strings for
	// data values — they will be evaluated passing `data` as an argument.
	function template(str, data) {
		return str.replace(templateRe, function (str, key) {
			var value = data[key];
	
			if (value === undefined) {
				throw new Error('No value provided for variable ' + str);
	
			} else if (typeof value === 'function') {
				value = value(data);
			}
			return value;
		});
	}
	
	// @function isArray(obj): Boolean
	// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	var isArray = Array.isArray || function (obj) {
		return (Object.prototype.toString.call(obj) === '[object Array]');
	};
	
	// @function indexOf(array: Array, el: Object): Number
	// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	function indexOf(array, el) {
		for (var i = 0; i < array.length; i++) {
			if (array[i] === el) { return i; }
		}
		return -1;
	}
	
	// @property emptyImageUrl: String
	// Data URI string containing a base64-encoded empty GIF image.
	// Used as a hack to free memory from unused images on WebKit-powered
	// mobile devices (by setting image `src` to this string).
	var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
	
	// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
	function getPrefixed(name) {
		return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	}
	
	var lastTime = 0;
	
	// fallback for IE 7-8
	function timeoutDefer(fn) {
		var time = +new Date(),
		    timeToCall = Math.max(0, 16 - (time - lastTime));
	
		lastTime = time + timeToCall;
		return window.setTimeout(fn, timeToCall);
	}
	
	var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
	var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
			getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	// `context` if given. When `immediate` is set, `fn` is called immediately if
	// the browser doesn't have native support for
	// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	function requestAnimFrame(fn, context, immediate) {
		if (immediate && requestFn === timeoutDefer) {
			fn.call(context);
		} else {
			return requestFn.call(window, bind(fn, context));
		}
	}
	
	// @function cancelAnimFrame(id: Number): undefined
	// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	function cancelAnimFrame(id) {
		if (id) {
			cancelFn.call(window, id);
		}
	}
	
	
	var Util = (Object.freeze || Object)({
		freeze: freeze,
		extend: extend,
		create: create,
		bind: bind,
		lastId: lastId,
		stamp: stamp,
		throttle: throttle,
		wrapNum: wrapNum,
		falseFn: falseFn,
		formatNum: formatNum,
		trim: trim,
		splitWords: splitWords,
		setOptions: setOptions,
		getParamString: getParamString,
		template: template,
		isArray: isArray,
		indexOf: indexOf,
		emptyImageUrl: emptyImageUrl,
		requestFn: requestFn,
		cancelFn: cancelFn,
		requestAnimFrame: requestAnimFrame,
		cancelAnimFrame: cancelAnimFrame
	});
	
	// @class Class
	// @aka L.Class
	
	// @section
	// @uninheritable
	
	// Thanks to John Resig and Dean Edwards for inspiration!
	
	function Class() {}
	
	Class.extend = function (props) {
	
		// @function extend(props: Object): Function
		// [Extends the current class](#class-inheritance) given the properties to be included.
		// Returns a Javascript function that is a class constructor (to be called with `new`).
		var NewClass = function () {
	
			// call the constructor
			if (this.initialize) {
				this.initialize.apply(this, arguments);
			}
	
			// call all constructor hooks
			this.callInitHooks();
		};
	
		var parentProto = NewClass.__super__ = this.prototype;
	
		var proto = create(parentProto);
		proto.constructor = NewClass;
	
		NewClass.prototype = proto;
	
		// inherit parent's statics
		for (var i in this) {
			if (this.hasOwnProperty(i) && i !== 'prototype' && i !== '__super__') {
				NewClass[i] = this[i];
			}
		}
	
		// mix static properties into the class
		if (props.statics) {
			extend(NewClass, props.statics);
			delete props.statics;
		}
	
		// mix includes into the prototype
		if (props.includes) {
			checkDeprecatedMixinEvents(props.includes);
			extend.apply(null, [proto].concat(props.includes));
			delete props.includes;
		}
	
		// merge options
		if (proto.options) {
			props.options = extend(create(proto.options), props.options);
		}
	
		// mix given properties into the prototype
		extend(proto, props);
	
		proto._initHooks = [];
	
		// add method for calling all hooks
		proto.callInitHooks = function () {
	
			if (this._initHooksCalled) { return; }
	
			if (parentProto.callInitHooks) {
				parentProto.callInitHooks.call(this);
			}
	
			this._initHooksCalled = true;
	
			for (var i = 0, len = proto._initHooks.length; i < len; i++) {
				proto._initHooks[i].call(this);
			}
		};
	
		return NewClass;
	};
	
	
	// @function include(properties: Object): this
	// [Includes a mixin](#class-includes) into the current class.
	Class.include = function (props) {
		extend(this.prototype, props);
		return this;
	};
	
	// @function mergeOptions(options: Object): this
	// [Merges `options`](#class-options) into the defaults of the class.
	Class.mergeOptions = function (options) {
		extend(this.prototype.options, options);
		return this;
	};
	
	// @function addInitHook(fn: Function): this
	// Adds a [constructor hook](#class-constructor-hooks) to the class.
	Class.addInitHook = function (fn) { // (Function) || (String, args...)
		var args = Array.prototype.slice.call(arguments, 1);
	
		var init = typeof fn === 'function' ? fn : function () {
			this[fn].apply(this, args);
		};
	
		this.prototype._initHooks = this.prototype._initHooks || [];
		this.prototype._initHooks.push(init);
		return this;
	};
	
	function checkDeprecatedMixinEvents(includes) {
		if (typeof L === 'undefined' || !L || !L.Mixin) { return; }
	
		includes = isArray(includes) ? includes : [includes];
	
		for (var i = 0; i < includes.length; i++) {
			if (includes[i] === L.Mixin.Events) {
				console.warn('Deprecated include of L.Mixin.Events: ' +
					'this property will be removed in future releases, ' +
					'please inherit from L.Evented instead.', new Error().stack);
			}
		}
	}
	
	/*
	 * @class Evented
	 * @aka L.Evented
	 * @inherits Class
	 *
	 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	 *
	 * @example
	 *
	 * ```js
	 * map.on('click', function(e) {
	 * 	alert(e.latlng);
	 * } );
	 * ```
	 *
	 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	 *
	 * ```js
	 * function onClick(e) { ... }
	 *
	 * map.on('click', onClick);
	 * map.off('click', onClick);
	 * ```
	 */
	
	var Events = {
		/* @method on(type: String, fn: Function, context?: Object): this
		 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
		 *
		 * @alternative
		 * @method on(eventMap: Object): this
		 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		 */
		on: function (types, fn, context) {
	
			// types can be a map of types/handlers
			if (typeof types === 'object') {
				for (var type in types) {
					// we don't process space-separated events here for performance;
					// it's a hot path since Layer uses the on(obj) syntax
					this._on(type, types[type], fn);
				}
	
			} else {
				// types can be a string of space-separated words
				types = splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		/* @method off(type: String, fn?: Function, context?: Object): this
		 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
		 *
		 * @alternative
		 * @method off(eventMap: Object): this
		 * Removes a set of type/listener pairs.
		 *
		 * @alternative
		 * @method off: this
		 * Removes all listeners to all events on the object.
		 */
		off: function (types, fn, context) {
	
			if (!types) {
				// clear all listeners if called without arguments
				delete this._events;
	
			} else if (typeof types === 'object') {
				for (var type in types) {
					this._off(type, types[type], fn);
				}
	
			} else {
				types = splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// attach listener (without syntactic sugar now)
		_on: function (type, fn, context) {
			this._events = this._events || {};
	
			/* get/init listeners for type */
			var typeListeners = this._events[type];
			if (!typeListeners) {
				typeListeners = [];
				this._events[type] = typeListeners;
			}
	
			if (context === this) {
				// Less memory footprint.
				context = undefined;
			}
			var newListener = {fn: fn, ctx: context},
			    listeners = typeListeners;
	
			// check if fn already there
			for (var i = 0, len = listeners.length; i < len; i++) {
				if (listeners[i].fn === fn && listeners[i].ctx === context) {
					return;
				}
			}
	
			listeners.push(newListener);
		},
	
		_off: function (type, fn, context) {
			var listeners,
			    i,
			    len;
	
			if (!this._events) { return; }
	
			listeners = this._events[type];
	
			if (!listeners) {
				return;
			}
	
			if (!fn) {
				// Set all removed listeners to noop so they are not called if remove happens in fire
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].fn = falseFn;
				}
				// clear all listeners for a type if function isn't specified
				delete this._events[type];
				return;
			}
	
			if (context === this) {
				context = undefined;
			}
	
			if (listeners) {
	
				// find fn and remove it
				for (i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					if (l.ctx !== context) { continue; }
					if (l.fn === fn) {
	
						// set the removed listener to noop so that's not called if remove happens in fire
						l.fn = falseFn;
	
						if (this._firingCount) {
							/* copy array in case events are being fired */
							this._events[type] = listeners = listeners.slice();
						}
						listeners.splice(i, 1);
	
						return;
					}
				}
			}
		},
	
		// @method fire(type: String, data?: Object, propagate?: Boolean): this
		// Fires an event of the specified type. You can optionally provide an data
		// object — the first argument of the listener function will contain its
		// properties. The event can optionally be propagated to event parents.
		fire: function (type, data, propagate) {
			if (!this.listens(type, propagate)) { return this; }
	
			var event = extend({}, data, {
				type: type,
				target: this,
				sourceTarget: data && data.sourceTarget || this
			});
	
			if (this._events) {
				var listeners = this._events[type];
	
				if (listeners) {
					this._firingCount = (this._firingCount + 1) || 1;
					for (var i = 0, len = listeners.length; i < len; i++) {
						var l = listeners[i];
						l.fn.call(l.ctx || this, event);
					}
	
					this._firingCount--;
				}
			}
	
			if (propagate) {
				// propagate the event to parents (set with addEventParent)
				this._propagateEvent(event);
			}
	
			return this;
		},
	
		// @method listens(type: String): Boolean
		// Returns `true` if a particular event type has any listeners attached to it.
		listens: function (type, propagate) {
			var listeners = this._events && this._events[type];
			if (listeners && listeners.length) { return true; }
	
			if (propagate) {
				// also check parents for listeners if event propagates
				for (var id in this._eventParents) {
					if (this._eventParents[id].listens(type, propagate)) { return true; }
				}
			}
			return false;
		},
	
		// @method once(…): this
		// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
		once: function (types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this.once(type, types[type], fn);
				}
				return this;
			}
	
			var handler = bind(function () {
				this
				    .off(types, fn, context)
				    .off(types, handler, context);
			}, this);
	
			// add a listener that's executed once and removed after that
			return this
			    .on(types, fn, context)
			    .on(types, handler, context);
		},
	
		// @method addEventParent(obj: Evented): this
		// Adds an event parent - an `Evented` that will receive propagated events
		addEventParent: function (obj) {
			this._eventParents = this._eventParents || {};
			this._eventParents[stamp(obj)] = obj;
			return this;
		},
	
		// @method removeEventParent(obj: Evented): this
		// Removes an event parent, so it will stop receiving propagated events
		removeEventParent: function (obj) {
			if (this._eventParents) {
				delete this._eventParents[stamp(obj)];
			}
			return this;
		},
	
		_propagateEvent: function (e) {
			for (var id in this._eventParents) {
				this._eventParents[id].fire(e.type, extend({
					layer: e.target,
					propagatedFrom: e.target
				}, e), true);
			}
		}
	};
	
	// aliases; we should ditch those eventually
	
	// @method addEventListener(…): this
	// Alias to [`on(…)`](#evented-on)
	Events.addEventListener = Events.on;
	
	// @method removeEventListener(…): this
	// Alias to [`off(…)`](#evented-off)
	
	// @method clearAllEventListeners(…): this
	// Alias to [`off()`](#evented-off)
	Events.removeEventListener = Events.clearAllEventListeners = Events.off;
	
	// @method addOneTimeEventListener(…): this
	// Alias to [`once(…)`](#evented-once)
	Events.addOneTimeEventListener = Events.once;
	
	// @method fireEvent(…): this
	// Alias to [`fire(…)`](#evented-fire)
	Events.fireEvent = Events.fire;
	
	// @method hasEventListeners(…): Boolean
	// Alias to [`listens(…)`](#evented-listens)
	Events.hasEventListeners = Events.listens;
	
	var Evented = Class.extend(Events);
	
	/*
	 * @class Point
	 * @aka L.Point
	 *
	 * Represents a point with `x` and `y` coordinates in pixels.
	 *
	 * @example
	 *
	 * ```js
	 * var point = L.point(200, 300);
	 * ```
	 *
	 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```js
	 * map.panBy([200, 300]);
	 * map.panBy(L.point(200, 300));
	 * ```
	 *
	 * Note that `Point` does not inherit from Leafet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function Point(x, y, round) {
		// @property x: Number; The `x` coordinate of the point
		this.x = (round ? Math.round(x) : x);
		// @property y: Number; The `y` coordinate of the point
		this.y = (round ? Math.round(y) : y);
	}
	
	var trunc = Math.trunc || function (v) {
		return v > 0 ? Math.floor(v) : Math.ceil(v);
	};
	
	Point.prototype = {
	
		// @method clone(): Point
		// Returns a copy of the current point.
		clone: function () {
			return new Point(this.x, this.y);
		},
	
		// @method add(otherPoint: Point): Point
		// Returns the result of addition of the current and the given points.
		add: function (point) {
			// non-destructive, returns a new point
			return this.clone()._add(toPoint(point));
		},
	
		_add: function (point) {
			// destructive, used directly for performance in situations where it's safe to modify existing point
			this.x += point.x;
			this.y += point.y;
			return this;
		},
	
		// @method subtract(otherPoint: Point): Point
		// Returns the result of subtraction of the given point from the current.
		subtract: function (point) {
			return this.clone()._subtract(toPoint(point));
		},
	
		_subtract: function (point) {
			this.x -= point.x;
			this.y -= point.y;
			return this;
		},
	
		// @method divideBy(num: Number): Point
		// Returns the result of division of the current point by the given number.
		divideBy: function (num) {
			return this.clone()._divideBy(num);
		},
	
		_divideBy: function (num) {
			this.x /= num;
			this.y /= num;
			return this;
		},
	
		// @method multiplyBy(num: Number): Point
		// Returns the result of multiplication of the current point by the given number.
		multiplyBy: function (num) {
			return this.clone()._multiplyBy(num);
		},
	
		_multiplyBy: function (num) {
			this.x *= num;
			this.y *= num;
			return this;
		},
	
		// @method scaleBy(scale: Point): Point
		// Multiply each coordinate of the current point by each coordinate of
		// `scale`. In linear algebra terms, multiply the point by the
		// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
		// defined by `scale`.
		scaleBy: function (point) {
			return new Point(this.x * point.x, this.y * point.y);
		},
	
		// @method unscaleBy(scale: Point): Point
		// Inverse of `scaleBy`. Divide each coordinate of the current point by
		// each coordinate of `scale`.
		unscaleBy: function (point) {
			return new Point(this.x / point.x, this.y / point.y);
		},
	
		// @method round(): Point
		// Returns a copy of the current point with rounded coordinates.
		round: function () {
			return this.clone()._round();
		},
	
		_round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this;
		},
	
		// @method floor(): Point
		// Returns a copy of the current point with floored coordinates (rounded down).
		floor: function () {
			return this.clone()._floor();
		},
	
		_floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this;
		},
	
		// @method ceil(): Point
		// Returns a copy of the current point with ceiled coordinates (rounded up).
		ceil: function () {
			return this.clone()._ceil();
		},
	
		_ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			return this;
		},
	
		// @method trunc(): Point
		// Returns a copy of the current point with truncated coordinates (rounded towards zero).
		trunc: function () {
			return this.clone()._trunc();
		},
	
		_trunc: function () {
			this.x = trunc(this.x);
			this.y = trunc(this.y);
			return this;
		},
	
		// @method distanceTo(otherPoint: Point): Number
		// Returns the cartesian distance between the current and the given points.
		distanceTo: function (point) {
			point = toPoint(point);
	
			var x = point.x - this.x,
			    y = point.y - this.y;
	
			return Math.sqrt(x * x + y * y);
		},
	
		// @method equals(otherPoint: Point): Boolean
		// Returns `true` if the given point has the same coordinates.
		equals: function (point) {
			point = toPoint(point);
	
			return point.x === this.x &&
			       point.y === this.y;
		},
	
		// @method contains(otherPoint: Point): Boolean
		// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
		contains: function (point) {
			point = toPoint(point);
	
			return Math.abs(point.x) <= Math.abs(this.x) &&
			       Math.abs(point.y) <= Math.abs(this.y);
		},
	
		// @method toString(): String
		// Returns a string representation of the point for debugging purposes.
		toString: function () {
			return 'Point(' +
			        formatNum(this.x) + ', ' +
			        formatNum(this.y) + ')';
		}
	};
	
	// @factory L.point(x: Number, y: Number, round?: Boolean)
	// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	// @alternative
	// @factory L.point(coords: Number[])
	// Expects an array of the form `[x, y]` instead.
	
	// @alternative
	// @factory L.point(coords: Object)
	// Expects a plain object of the form `{x: Number, y: Number}` instead.
	function toPoint(x, y, round) {
		if (x instanceof Point) {
			return x;
		}
		if (isArray(x)) {
			return new Point(x[0], x[1]);
		}
		if (x === undefined || x === null) {
			return x;
		}
		if (typeof x === 'object' && 'x' in x && 'y' in x) {
			return new Point(x.x, x.y);
		}
		return new Point(x, y, round);
	}
	
	/*
	 * @class Bounds
	 * @aka L.Bounds
	 *
	 * Represents a rectangular area in pixel coordinates.
	 *
	 * @example
	 *
	 * ```js
	 * var p1 = L.point(10, 10),
	 * p2 = L.point(40, 60),
	 * bounds = L.bounds(p1, p2);
	 * ```
	 *
	 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * otherBounds.intersects([[10, 10], [40, 60]]);
	 * ```
	 *
	 * Note that `Bounds` does not inherit from Leafet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function Bounds(a, b) {
		if (!a) { return; }
	
		var points = b ? [a, b] : a;
	
		for (var i = 0, len = points.length; i < len; i++) {
			this.extend(points[i]);
		}
	}
	
	Bounds.prototype = {
		// @method extend(point: Point): this
		// Extends the bounds to contain the given point.
		extend: function (point) { // (Point)
			point = toPoint(point);
	
			// @property min: Point
			// The top left corner of the rectangle.
			// @property max: Point
			// The bottom right corner of the rectangle.
			if (!this.min && !this.max) {
				this.min = point.clone();
				this.max = point.clone();
			} else {
				this.min.x = Math.min(point.x, this.min.x);
				this.max.x = Math.max(point.x, this.max.x);
				this.min.y = Math.min(point.y, this.min.y);
				this.max.y = Math.max(point.y, this.max.y);
			}
			return this;
		},
	
		// @method getCenter(round?: Boolean): Point
		// Returns the center point of the bounds.
		getCenter: function (round) {
			return new Point(
			        (this.min.x + this.max.x) / 2,
			        (this.min.y + this.max.y) / 2, round);
		},
	
		// @method getBottomLeft(): Point
		// Returns the bottom-left point of the bounds.
		getBottomLeft: function () {
			return new Point(this.min.x, this.max.y);
		},
	
		// @method getTopRight(): Point
		// Returns the top-right point of the bounds.
		getTopRight: function () { // -> Point
			return new Point(this.max.x, this.min.y);
		},
	
		// @method getTopLeft(): Point
		// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
		getTopLeft: function () {
			return this.min; // left, top
		},
	
		// @method getBottomRight(): Point
		// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
		getBottomRight: function () {
			return this.max; // right, bottom
		},
	
		// @method getSize(): Point
		// Returns the size of the given bounds
		getSize: function () {
			return this.max.subtract(this.min);
		},
	
		// @method contains(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle contains the given one.
		// @alternative
		// @method contains(point: Point): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) {
			var min, max;
	
			if (typeof obj[0] === 'number' || obj instanceof Point) {
				obj = toPoint(obj);
			} else {
				obj = toBounds(obj);
			}
	
			if (obj instanceof Bounds) {
				min = obj.min;
				max = obj.max;
			} else {
				min = max = obj;
			}
	
			return (min.x >= this.min.x) &&
			       (max.x <= this.max.x) &&
			       (min.y >= this.min.y) &&
			       (max.y <= this.max.y);
		},
	
		// @method intersects(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds
		// intersect if they have at least one point in common.
		intersects: function (bounds) { // (Bounds) -> Boolean
			bounds = toBounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
			    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
			return xIntersects && yIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds
		// overlap if their intersection is an area.
		overlaps: function (bounds) { // (Bounds) -> Boolean
			bounds = toBounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
			    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
			return xOverlaps && yOverlaps;
		},
	
		isValid: function () {
			return !!(this.min && this.max);
		}
	};
	
	
	// @factory L.bounds(corner1: Point, corner2: Point)
	// Creates a Bounds object from two corners coordinate pairs.
	// @alternative
	// @factory L.bounds(points: Point[])
	// Creates a Bounds object from the given array of points.
	function toBounds(a, b) {
		if (!a || a instanceof Bounds) {
			return a;
		}
		return new Bounds(a, b);
	}
	
	/*
	 * @class LatLngBounds
	 * @aka L.LatLngBounds
	 *
	 * Represents a rectangular geographical area on a map.
	 *
	 * @example
	 *
	 * ```js
	 * var corner1 = L.latLng(40.712, -74.227),
	 * corner2 = L.latLng(40.774, -74.125),
	 * bounds = L.latLngBounds(corner1, corner2);
	 * ```
	 *
	 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * map.fitBounds([
	 * 	[40.712, -74.227],
	 * 	[40.774, -74.125]
	 * ]);
	 * ```
	 *
	 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	 *
	 * Note that `LatLngBounds` does not inherit from Leafet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
		if (!corner1) { return; }
	
		var latlngs = corner2 ? [corner1, corner2] : corner1;
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			this.extend(latlngs[i]);
		}
	}
	
	LatLngBounds.prototype = {
	
		// @method extend(latlng: LatLng): this
		// Extend the bounds to contain the given point
	
		// @alternative
		// @method extend(otherBounds: LatLngBounds): this
		// Extend the bounds to contain the given bounds
		extend: function (obj) {
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof LatLng) {
				sw2 = obj;
				ne2 = obj;
	
			} else if (obj instanceof LatLngBounds) {
				sw2 = obj._southWest;
				ne2 = obj._northEast;
	
				if (!sw2 || !ne2) { return this; }
	
			} else {
				return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
			}
	
			if (!sw && !ne) {
				this._southWest = new LatLng(sw2.lat, sw2.lng);
				this._northEast = new LatLng(ne2.lat, ne2.lng);
			} else {
				sw.lat = Math.min(sw2.lat, sw.lat);
				sw.lng = Math.min(sw2.lng, sw.lng);
				ne.lat = Math.max(ne2.lat, ne.lat);
				ne.lng = Math.max(ne2.lng, ne.lng);
			}
	
			return this;
		},
	
		// @method pad(bufferRatio: Number): LatLngBounds
		// Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
		// For example, a ratio of 0.5 extends the bounds by 50% in each direction.
		// Negative values will retract the bounds.
		pad: function (bufferRatio) {
			var sw = this._southWest,
			    ne = this._northEast,
			    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
			    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
			return new LatLngBounds(
			        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
			        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
		},
	
		// @method getCenter(): LatLng
		// Returns the center point of the bounds.
		getCenter: function () {
			return new LatLng(
			        (this._southWest.lat + this._northEast.lat) / 2,
			        (this._southWest.lng + this._northEast.lng) / 2);
		},
	
		// @method getSouthWest(): LatLng
		// Returns the south-west point of the bounds.
		getSouthWest: function () {
			return this._southWest;
		},
	
		// @method getNorthEast(): LatLng
		// Returns the north-east point of the bounds.
		getNorthEast: function () {
			return this._northEast;
		},
	
		// @method getNorthWest(): LatLng
		// Returns the north-west point of the bounds.
		getNorthWest: function () {
			return new LatLng(this.getNorth(), this.getWest());
		},
	
		// @method getSouthEast(): LatLng
		// Returns the south-east point of the bounds.
		getSouthEast: function () {
			return new LatLng(this.getSouth(), this.getEast());
		},
	
		// @method getWest(): Number
		// Returns the west longitude of the bounds
		getWest: function () {
			return this._southWest.lng;
		},
	
		// @method getSouth(): Number
		// Returns the south latitude of the bounds
		getSouth: function () {
			return this._southWest.lat;
		},
	
		// @method getEast(): Number
		// Returns the east longitude of the bounds
		getEast: function () {
			return this._northEast.lng;
		},
	
		// @method getNorth(): Number
		// Returns the north latitude of the bounds
		getNorth: function () {
			return this._northEast.lat;
		},
	
		// @method contains(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle contains the given one.
	
		// @alternative
		// @method contains (latlng: LatLng): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
			if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
				obj = toLatLng(obj);
			} else {
				obj = toLatLngBounds(obj);
			}
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof LatLngBounds) {
				sw2 = obj.getSouthWest();
				ne2 = obj.getNorthEast();
			} else {
				sw2 = ne2 = obj;
			}
	
			return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
			       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
		},
	
		// @method intersects(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
		intersects: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
			    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
			return latIntersects && lngIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
		overlaps: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
			    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
			return latOverlaps && lngOverlaps;
		},
	
		// @method toBBoxString(): String
		// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
		toBBoxString: function () {
			return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
		},
	
		// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
		// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
		equals: function (bounds, maxMargin) {
			if (!bounds) { return false; }
	
			bounds = toLatLngBounds(bounds);
	
			return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
			       this._northEast.equals(bounds.getNorthEast(), maxMargin);
		},
	
		// @method isValid(): Boolean
		// Returns `true` if the bounds are properly initialized.
		isValid: function () {
			return !!(this._southWest && this._northEast);
		}
	};
	
	// TODO International date line?
	
	// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	// @alternative
	// @factory L.latLngBounds(latlngs: LatLng[])
	// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	function toLatLngBounds(a, b) {
		if (a instanceof LatLngBounds) {
			return a;
		}
		return new LatLngBounds(a, b);
	}
	
	/* @class LatLng
	 * @aka L.LatLng
	 *
	 * Represents a geographical point with a certain latitude and longitude.
	 *
	 * @example
	 *
	 * ```
	 * var latlng = L.latLng(50.5, 30.5);
	 * ```
	 *
	 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```
	 * map.panTo([50, 30]);
	 * map.panTo({lon: 30, lat: 50});
	 * map.panTo({lat: 50, lng: 30});
	 * map.panTo(L.latLng(50, 30));
	 * ```
	 *
	 * Note that `LatLng` does not inherit from Leaflet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function LatLng(lat, lng, alt) {
		if (isNaN(lat) || isNaN(lng)) {
			throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
		}
	
		// @property lat: Number
		// Latitude in degrees
		this.lat = +lat;
	
		// @property lng: Number
		// Longitude in degrees
		this.lng = +lng;
	
		// @property alt: Number
		// Altitude in meters (optional)
		if (alt !== undefined) {
			this.alt = +alt;
		}
	}
	
	LatLng.prototype = {
		// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
		// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
		equals: function (obj, maxMargin) {
			if (!obj) { return false; }
	
			obj = toLatLng(obj);
	
			var margin = Math.max(
			        Math.abs(this.lat - obj.lat),
			        Math.abs(this.lng - obj.lng));
	
			return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
		},
	
		// @method toString(): String
		// Returns a string representation of the point (for debugging purposes).
		toString: function (precision) {
			return 'LatLng(' +
			        formatNum(this.lat, precision) + ', ' +
			        formatNum(this.lng, precision) + ')';
		},
	
		// @method distanceTo(otherLatLng: LatLng): Number
		// Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
		distanceTo: function (other) {
			return Earth.distance(this, toLatLng(other));
		},
	
		// @method wrap(): LatLng
		// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
		wrap: function () {
			return Earth.wrapLatLng(this);
		},
	
		// @method toBounds(sizeInMeters: Number): LatLngBounds
		// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
		toBounds: function (sizeInMeters) {
			var latAccuracy = 180 * sizeInMeters / 40075017,
			    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
			return toLatLngBounds(
			        [this.lat - latAccuracy, this.lng - lngAccuracy],
			        [this.lat + latAccuracy, this.lng + lngAccuracy]);
		},
	
		clone: function () {
			return new LatLng(this.lat, this.lng, this.alt);
		}
	};
	
	
	
	// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	// @alternative
	// @factory L.latLng(coords: Array): LatLng
	// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	// @alternative
	// @factory L.latLng(coords: Object): LatLng
	// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	function toLatLng(a, b, c) {
		if (a instanceof LatLng) {
			return a;
		}
		if (isArray(a) && typeof a[0] !== 'object') {
			if (a.length === 3) {
				return new LatLng(a[0], a[1], a[2]);
			}
			if (a.length === 2) {
				return new LatLng(a[0], a[1]);
			}
			return null;
		}
		if (a === undefined || a === null) {
			return a;
		}
		if (typeof a === 'object' && 'lat' in a) {
			return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
		}
		if (b === undefined) {
			return null;
		}
		return new LatLng(a, b, c);
	}
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Base
	 * Object that defines coordinate reference systems for projecting
	 * geographical points into pixel (screen) coordinates and back (and to
	 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
	 *
	 * Leaflet defines the most usual CRSs by default. If you want to use a
	 * CRS not defined by default, take a look at the
	 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	 *
	 * Note that the CRS instances do not inherit from Leafet's `Class` object,
	 * and can't be instantiated. Also, new classes can't inherit from them,
	 * and methods can't be added to them with the `include` function.
	 */
	
	var CRS = {
		// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
		// Projects geographical coordinates into pixel coordinates for a given zoom.
		latLngToPoint: function (latlng, zoom) {
			var projectedPoint = this.projection.project(latlng),
			    scale = this.scale(zoom);
	
			return this.transformation._transform(projectedPoint, scale);
		},
	
		// @method pointToLatLng(point: Point, zoom: Number): LatLng
		// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
		// zoom into geographical coordinates.
		pointToLatLng: function (point, zoom) {
			var scale = this.scale(zoom),
			    untransformedPoint = this.transformation.untransform(point, scale);
	
			return this.projection.unproject(untransformedPoint);
		},
	
		// @method project(latlng: LatLng): Point
		// Projects geographical coordinates into coordinates in units accepted for
		// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
		project: function (latlng) {
			return this.projection.project(latlng);
		},
	
		// @method unproject(point: Point): LatLng
		// Given a projected coordinate returns the corresponding LatLng.
		// The inverse of `project`.
		unproject: function (point) {
			return this.projection.unproject(point);
		},
	
		// @method scale(zoom: Number): Number
		// Returns the scale used when transforming projected coordinates into
		// pixel coordinates for a particular zoom. For example, it returns
		// `256 * 2^zoom` for Mercator-based CRS.
		scale: function (zoom) {
			return 256 * Math.pow(2, zoom);
		},
	
		// @method zoom(scale: Number): Number
		// Inverse of `scale()`, returns the zoom level corresponding to a scale
		// factor of `scale`.
		zoom: function (scale) {
			return Math.log(scale / 256) / Math.LN2;
		},
	
		// @method getProjectedBounds(zoom: Number): Bounds
		// Returns the projection's bounds scaled and transformed for the provided `zoom`.
		getProjectedBounds: function (zoom) {
			if (this.infinite) { return null; }
	
			var b = this.projection.bounds,
			    s = this.scale(zoom),
			    min = this.transformation.transform(b.min, s),
			    max = this.transformation.transform(b.max, s);
	
			return new Bounds(min, max);
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates.
	
		// @property code: String
		// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
		//
		// @property wrapLng: Number[]
		// An array of two numbers defining whether the longitude (horizontal) coordinate
		// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
		// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
		//
		// @property wrapLat: Number[]
		// Like `wrapLng`, but for the latitude (vertical) axis.
	
		// wrapLng: [min, max],
		// wrapLat: [min, max],
	
		// @property infinite: Boolean
		// If true, the coordinate space will be unbounded (infinite in both axes)
		infinite: false,
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where lat and lng has been wrapped according to the
		// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
		wrapLatLng: function (latlng) {
			var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
			    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
			    alt = latlng.alt;
	
			return new LatLng(lat, lng, alt);
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring
		// that its center is within the CRS's bounds.
		// Only accepts actual `L.LatLngBounds` instances, not arrays.
		wrapLatLngBounds: function (bounds) {
			var center = bounds.getCenter(),
			    newCenter = this.wrapLatLng(center),
			    latShift = center.lat - newCenter.lat,
			    lngShift = center.lng - newCenter.lng;
	
			if (latShift === 0 && lngShift === 0) {
				return bounds;
			}
	
			var sw = bounds.getSouthWest(),
			    ne = bounds.getNorthEast(),
			    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
			    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
	
			return new LatLngBounds(newSw, newNe);
		}
	};
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Earth
	 *
	 * Serves as the base for CRS that are global such that they cover the earth.
	 * Can only be used as the base for other CRS and cannot be used directly,
	 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	 * meters.
	 */
	
	var Earth = extend({}, CRS, {
		wrapLng: [-180, 180],
	
		// Mean Earth Radius, as recommended for use by
		// the International Union of Geodesy and Geophysics,
		// see http://rosettacode.org/wiki/Haversine_formula
		R: 6371000,
	
		// distance between two geographical points using spherical law of cosines approximation
		distance: function (latlng1, latlng2) {
			var rad = Math.PI / 180,
			    lat1 = latlng1.lat * rad,
			    lat2 = latlng2.lat * rad,
			    sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2),
			    sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2),
			    a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
			    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			return this.R * c;
		}
	});
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.SphericalMercator
	 *
	 * Spherical Mercator projection — the most common projection for online maps,
	 * used by almost all free and commercial tile providers. Assumes that Earth is
	 * a sphere. Used by the `EPSG:3857` CRS.
	 */
	
	var SphericalMercator = {
	
		R: 6378137,
		MAX_LATITUDE: 85.0511287798,
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    sin = Math.sin(lat * d);
	
			return new Point(
				this.R * latlng.lng * d,
				this.R * Math.log((1 + sin) / (1 - sin)) / 2);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI;
	
			return new LatLng(
				(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
				point.x * d / this.R);
		},
	
		bounds: (function () {
			var d = 6378137 * Math.PI;
			return new Bounds([-d, -d], [d, d]);
		})()
	};
	
	/*
	 * @class Transformation
	 * @aka L.Transformation
	 *
	 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	 * the reverse. Used by Leaflet in its projections code.
	 *
	 * @example
	 *
	 * ```js
	 * var transformation = L.transformation(2, 5, -1, 10),
	 * 	p = L.point(1, 2),
	 * 	p2 = transformation.transform(p), //  L.point(7, 8)
	 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	 * ```
	 */
	
	
	// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	// Creates a `Transformation` object with the given coefficients.
	function Transformation(a, b, c, d) {
		if (isArray(a)) {
			// use array properties
			this._a = a[0];
			this._b = a[1];
			this._c = a[2];
			this._d = a[3];
			return;
		}
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
	}
	
	Transformation.prototype = {
		// @method transform(point: Point, scale?: Number): Point
		// Returns a transformed point, optionally multiplied by the given scale.
		// Only accepts actual `L.Point` instances, not arrays.
		transform: function (point, scale) { // (Point, Number) -> Point
			return this._transform(point.clone(), scale);
		},
	
		// destructive transform (faster)
		_transform: function (point, scale) {
			scale = scale || 1;
			point.x = scale * (this._a * point.x + this._b);
			point.y = scale * (this._c * point.y + this._d);
			return point;
		},
	
		// @method untransform(point: Point, scale?: Number): Point
		// Returns the reverse transformation of the given point, optionally divided
		// by the given scale. Only accepts actual `L.Point` instances, not arrays.
		untransform: function (point, scale) {
			scale = scale || 1;
			return new Point(
			        (point.x / scale - this._b) / this._a,
			        (point.y / scale - this._d) / this._c);
		}
	};
	
	// factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	
	// @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	// Instantiates a Transformation object with the given coefficients.
	
	// @alternative
	// @factory L.transformation(coefficients: Array): Transformation
	// Expects an coefficients array of the form
	// `[a: Number, b: Number, c: Number, d: Number]`.
	
	function toTransformation(a, b, c, d) {
		return new Transformation(a, b, c, d);
	}
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3857
	 *
	 * The most common CRS for online maps, used by almost all free and commercial
	 * tile providers. Uses Spherical Mercator projection. Set in by default in
	 * Map's `crs` option.
	 */
	
	var EPSG3857 = extend({}, Earth, {
		code: 'EPSG:3857',
		projection: SphericalMercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * SphericalMercator.R);
			return toTransformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	var EPSG900913 = extend({}, EPSG3857, {
		code: 'EPSG:900913'
	});
	
	// @namespace SVG; @section
	// There are several static functions which can be called without instantiating L.SVG:
	
	// @function create(name: String): SVGElement
	// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	// corresponding to the class name passed. For example, using 'line' will return
	// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	function svgCreate(name) {
		return document.createElementNS('http://www.w3.org/2000/svg', name);
	}
	
	// @function pointsToPath(rings: Point[], closed: Boolean): String
	// Generates a SVG path string for multiple rings, with each ring turning
	// into "M..L..L.." instructions
	function pointsToPath(rings, closed) {
		var str = '',
		i, j, len, len2, points, p;
	
		for (i = 0, len = rings.length; i < len; i++) {
			points = rings[i];
	
			for (j = 0, len2 = points.length; j < len2; j++) {
				p = points[j];
				str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
			}
	
			// closes the ring for polygons; "x" is VML syntax
			str += closed ? (svg ? 'z' : 'x') : '';
		}
	
		// SVG complains about empty path strings
		return str || 'M0 0';
	}
	
	/*
	 * @namespace Browser
	 * @aka L.Browser
	 *
	 * A namespace with static properties for browser/feature detection used by Leaflet internally.
	 *
	 * @example
	 *
	 * ```js
	 * if (L.Browser.ielt9) {
	 *   alert('Upgrade your browser, dude!');
	 * }
	 * ```
	 */
	
	var style$1 = document.documentElement.style;
	
	// @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
	var ie = 'ActiveXObject' in window;
	
	// @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
	var ielt9 = ie && !document.addEventListener;
	
	// @property edge: Boolean; `true` for the Edge web browser.
	var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
	
	// @property webkit: Boolean;
	// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
	var webkit = userAgentContains('webkit');
	
	// @property android: Boolean
	// `true` for any browser running on an Android platform.
	var android = userAgentContains('android');
	
	// @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
	var android23 = userAgentContains('android 2') || userAgentContains('android 3');
	
	/* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */
	var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
	// @property androidStock: Boolean; `true` for the Android stock browser (i.e. not Chrome)
	var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
	
	// @property opera: Boolean; `true` for the Opera browser
	var opera = !!window.opera;
	
	// @property chrome: Boolean; `true` for the Chrome browser.
	var chrome = userAgentContains('chrome');
	
	// @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
	var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
	
	// @property safari: Boolean; `true` for the Safari browser.
	var safari = !chrome && userAgentContains('safari');
	
	var phantom = userAgentContains('phantom');
	
	// @property opera12: Boolean
	// `true` for the Opera browser supporting CSS transforms (version 12 or later).
	var opera12 = 'OTransition' in style$1;
	
	// @property win: Boolean; `true` when the browser is running in a Windows platform
	var win = navigator.platform.indexOf('Win') === 0;
	
	// @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
	var ie3d = ie && ('transition' in style$1);
	
	// @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
	var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;
	
	// @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
	var gecko3d = 'MozPerspective' in style$1;
	
	// @property any3d: Boolean
	// `true` for all browsers supporting CSS transforms.
	var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
	
	// @property mobile: Boolean; `true` for all browsers running in a mobile device.
	var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
	
	// @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
	var mobileWebkit = mobile && webkit;
	
	// @property mobileWebkit3d: Boolean
	// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
	var mobileWebkit3d = mobile && webkit3d;
	
	// @property msPointer: Boolean
	// `true` for browsers implementing the Microsoft touch events model (notably IE10).
	var msPointer = !window.PointerEvent && window.MSPointerEvent;
	
	// @property pointer: Boolean
	// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
	var pointer = !!(window.PointerEvent || msPointer);
	
	// @property touch: Boolean
	// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
	// This does not necessarily mean that the browser is running in a computer with
	// a touchscreen, it only means that the browser is capable of understanding
	// touch events.
	var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
			(window.DocumentTouch && document instanceof window.DocumentTouch));
	
	// @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
	var mobileOpera = mobile && opera;
	
	// @property mobileGecko: Boolean
	// `true` for gecko-based browsers running in a mobile device.
	var mobileGecko = mobile && gecko;
	
	// @property retina: Boolean
	// `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
	var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;
	
	
	// @property canvas: Boolean
	// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	var canvas = (function () {
		return !!document.createElement('canvas').getContext;
	}());
	
	// @property svg: Boolean
	// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);
	
	// @property vml: Boolean
	// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	var vml = !svg && (function () {
		try {
			var div = document.createElement('div');
			div.innerHTML = '<v:shape adj="1"/>';
	
			var shape = div.firstChild;
			shape.style.behavior = 'url(#default#VML)';
	
			return shape && (typeof shape.adj === 'object');
	
		} catch (e) {
			return false;
		}
	}());
	
	
	function userAgentContains(str) {
		return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
	}
	
	
	var Browser = (Object.freeze || Object)({
		ie: ie,
		ielt9: ielt9,
		edge: edge,
		webkit: webkit,
		android: android,
		android23: android23,
		androidStock: androidStock,
		opera: opera,
		chrome: chrome,
		gecko: gecko,
		safari: safari,
		phantom: phantom,
		opera12: opera12,
		win: win,
		ie3d: ie3d,
		webkit3d: webkit3d,
		gecko3d: gecko3d,
		any3d: any3d,
		mobile: mobile,
		mobileWebkit: mobileWebkit,
		mobileWebkit3d: mobileWebkit3d,
		msPointer: msPointer,
		pointer: pointer,
		touch: touch,
		mobileOpera: mobileOpera,
		mobileGecko: mobileGecko,
		retina: retina,
		canvas: canvas,
		svg: svg,
		vml: vml
	});
	
	/*
	 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	 */
	
	
	var POINTER_DOWN =   msPointer ? 'MSPointerDown'   : 'pointerdown';
	var POINTER_MOVE =   msPointer ? 'MSPointerMove'   : 'pointermove';
	var POINTER_UP =     msPointer ? 'MSPointerUp'     : 'pointerup';
	var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
	var TAG_WHITE_LIST = ['INPUT', 'SELECT', 'OPTION'];
	
	var _pointers = {};
	var _pointerDocListener = false;
	
	// DomEvent.DoubleTap needs to know about this
	var _pointersCount = 0;
	
	// Provides a touch events wrapper for (ms)pointer events.
	// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
	function addPointerListener(obj, type, handler, id) {
		if (type === 'touchstart') {
			_addPointerStart(obj, handler, id);
	
		} else if (type === 'touchmove') {
			_addPointerMove(obj, handler, id);
	
		} else if (type === 'touchend') {
			_addPointerEnd(obj, handler, id);
		}
	
		return this;
	}
	
	function removePointerListener(obj, type, id) {
		var handler = obj['_leaflet_' + type + id];
	
		if (type === 'touchstart') {
			obj.removeEventListener(POINTER_DOWN, handler, false);
	
		} else if (type === 'touchmove') {
			obj.removeEventListener(POINTER_MOVE, handler, false);
	
		} else if (type === 'touchend') {
			obj.removeEventListener(POINTER_UP, handler, false);
			obj.removeEventListener(POINTER_CANCEL, handler, false);
		}
	
		return this;
	}
	
	function _addPointerStart(obj, handler, id) {
		var onDown = bind(function (e) {
			if (e.pointerType !== 'mouse' && e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
				// In IE11, some touch events needs to fire for form controls, or
				// the controls will stop working. We keep a whitelist of tag names that
				// need these events. For other target tags, we prevent default on the event.
				if (TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
					preventDefault(e);
				} else {
					return;
				}
			}
	
			_handlePointer(e, handler);
		});
	
		obj['_leaflet_touchstart' + id] = onDown;
		obj.addEventListener(POINTER_DOWN, onDown, false);
	
		// need to keep track of what pointers and how many are active to provide e.touches emulation
		if (!_pointerDocListener) {
			// we listen documentElement as any drags that end by moving the touch off the screen get fired there
			document.documentElement.addEventListener(POINTER_DOWN, _globalPointerDown, true);
			document.documentElement.addEventListener(POINTER_MOVE, _globalPointerMove, true);
			document.documentElement.addEventListener(POINTER_UP, _globalPointerUp, true);
			document.documentElement.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
	
			_pointerDocListener = true;
		}
	}
	
	function _globalPointerDown(e) {
		_pointers[e.pointerId] = e;
		_pointersCount++;
	}
	
	function _globalPointerMove(e) {
		if (_pointers[e.pointerId]) {
			_pointers[e.pointerId] = e;
		}
	}
	
	function _globalPointerUp(e) {
		delete _pointers[e.pointerId];
		_pointersCount--;
	}
	
	function _handlePointer(e, handler) {
		e.touches = [];
		for (var i in _pointers) {
			e.touches.push(_pointers[i]);
		}
		e.changedTouches = [e];
	
		handler(e);
	}
	
	function _addPointerMove(obj, handler, id) {
		var onMove = function (e) {
			// don't fire touch moves when mouse isn't down
			if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }
	
			_handlePointer(e, handler);
		};
	
		obj['_leaflet_touchmove' + id] = onMove;
		obj.addEventListener(POINTER_MOVE, onMove, false);
	}
	
	function _addPointerEnd(obj, handler, id) {
		var onUp = function (e) {
			_handlePointer(e, handler);
		};
	
		obj['_leaflet_touchend' + id] = onUp;
		obj.addEventListener(POINTER_UP, onUp, false);
		obj.addEventListener(POINTER_CANCEL, onUp, false);
	}
	
	/*
	 * Extends the event handling code with double tap support for mobile browsers.
	 */
	
	var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
	var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
	var _pre = '_leaflet_';
	
	// inspired by Zepto touch code by Thomas Fuchs
	function addDoubleTapListener(obj, handler, id) {
		var last, touch$$1,
		    doubleTap = false,
		    delay = 250;
	
		function onTouchStart(e) {
			var count;
	
			if (pointer) {
				if ((!edge) || e.pointerType === 'mouse') { return; }
				count = _pointersCount;
			} else {
				count = e.touches.length;
			}
	
			if (count > 1) { return; }
	
			var now = Date.now(),
			    delta = now - (last || now);
	
			touch$$1 = e.touches ? e.touches[0] : e;
			doubleTap = (delta > 0 && delta <= delay);
			last = now;
		}
	
		function onTouchEnd(e) {
			if (doubleTap && !touch$$1.cancelBubble) {
				if (pointer) {
					if ((!edge) || e.pointerType === 'mouse') { return; }
					// work around .type being readonly with MSPointer* events
					var newTouch = {},
					    prop, i;
	
					for (i in touch$$1) {
						prop = touch$$1[i];
						newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
					}
					touch$$1 = newTouch;
				}
				touch$$1.type = 'dblclick';
				handler(touch$$1);
				last = null;
			}
		}
	
		obj[_pre + _touchstart + id] = onTouchStart;
		obj[_pre + _touchend + id] = onTouchEnd;
		obj[_pre + 'dblclick' + id] = handler;
	
		obj.addEventListener(_touchstart, onTouchStart, false);
		obj.addEventListener(_touchend, onTouchEnd, false);
	
		// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
		// the browser doesn't fire touchend/pointerup events but does fire
		// native dblclicks. See #4127.
		// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
		obj.addEventListener('dblclick', handler, false);
	
		return this;
	}
	
	function removeDoubleTapListener(obj, id) {
		var touchstart = obj[_pre + _touchstart + id],
		    touchend = obj[_pre + _touchend + id],
		    dblclick = obj[_pre + 'dblclick' + id];
	
		obj.removeEventListener(_touchstart, touchstart, false);
		obj.removeEventListener(_touchend, touchend, false);
		if (!edge) {
			obj.removeEventListener('dblclick', dblclick, false);
		}
	
		return this;
	}
	
	/*
	 * @namespace DomUtil
	 *
	 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	 * tree, used by Leaflet internally.
	 *
	 * Most functions expecting or returning a `HTMLElement` also work for
	 * SVG elements. The only difference is that classes refer to CSS classes
	 * in HTML and SVG classes in SVG.
	 */
	
	
	// @property TRANSFORM: String
	// Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
	var TRANSFORM = testProp(
		['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	// webkitTransition comes first because some browser versions that drop vendor prefix don't do
	// the same for the transitionend event, in particular the Android 4.1 stock browser
	
	// @property TRANSITION: String
	// Vendor-prefixed transition style name.
	var TRANSITION = testProp(
		['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
	// @property TRANSITION_END: String
	// Vendor-prefixed transitionend event name.
	var TRANSITION_END =
		TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
	
	
	// @function get(id: String|HTMLElement): HTMLElement
	// Returns an element given its DOM id, or returns the element itself
	// if it was passed directly.
	function get(id) {
		return typeof id === 'string' ? document.getElementById(id) : id;
	}
	
	// @function getStyle(el: HTMLElement, styleAttrib: String): String
	// Returns the value for a certain style attribute on an element,
	// including computed values or values set through CSS.
	function getStyle(el, style) {
		var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
		if ((!value || value === 'auto') && document.defaultView) {
			var css = document.defaultView.getComputedStyle(el, null);
			value = css ? css[style] : null;
		}
		return value === 'auto' ? null : value;
	}
	
	// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	function create$1(tagName, className, container) {
		var el = document.createElement(tagName);
		el.className = className || '';
	
		if (container) {
			container.appendChild(el);
		}
		return el;
	}
	
	// @function remove(el: HTMLElement)
	// Removes `el` from its parent element
	function remove(el) {
		var parent = el.parentNode;
		if (parent) {
			parent.removeChild(el);
		}
	}
	
	// @function empty(el: HTMLElement)
	// Removes all of `el`'s children elements from `el`
	function empty(el) {
		while (el.firstChild) {
			el.removeChild(el.firstChild);
		}
	}
	
	// @function toFront(el: HTMLElement)
	// Makes `el` the last child of its parent, so it renders in front of the other children.
	function toFront(el) {
		var parent = el.parentNode;
		if (parent.lastChild !== el) {
			parent.appendChild(el);
		}
	}
	
	// @function toBack(el: HTMLElement)
	// Makes `el` the first child of its parent, so it renders behind the other children.
	function toBack(el) {
		var parent = el.parentNode;
		if (parent.firstChild !== el) {
			parent.insertBefore(el, parent.firstChild);
		}
	}
	
	// @function hasClass(el: HTMLElement, name: String): Boolean
	// Returns `true` if the element's class attribute contains `name`.
	function hasClass(el, name) {
		if (el.classList !== undefined) {
			return el.classList.contains(name);
		}
		var className = getClass(el);
		return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	}
	
	// @function addClass(el: HTMLElement, name: String)
	// Adds `name` to the element's class attribute.
	function addClass(el, name) {
		if (el.classList !== undefined) {
			var classes = splitWords(name);
			for (var i = 0, len = classes.length; i < len; i++) {
				el.classList.add(classes[i]);
			}
		} else if (!hasClass(el, name)) {
			var className = getClass(el);
			setClass(el, (className ? className + ' ' : '') + name);
		}
	}
	
	// @function removeClass(el: HTMLElement, name: String)
	// Removes `name` from the element's class attribute.
	function removeClass(el, name) {
		if (el.classList !== undefined) {
			el.classList.remove(name);
		} else {
			setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
		}
	}
	
	// @function setClass(el: HTMLElement, name: String)
	// Sets the element's class.
	function setClass(el, name) {
		if (el.className.baseVal === undefined) {
			el.className = name;
		} else {
			// in case of SVG element
			el.className.baseVal = name;
		}
	}
	
	// @function getClass(el: HTMLElement): String
	// Returns the element's class.
	function getClass(el) {
		return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	}
	
	// @function setOpacity(el: HTMLElement, opacity: Number)
	// Set the opacity of an element (including old IE support).
	// `opacity` must be a number from `0` to `1`.
	function setOpacity(el, value) {
		if ('opacity' in el.style) {
			el.style.opacity = value;
		} else if ('filter' in el.style) {
			_setOpacityIE(el, value);
		}
	}
	
	function _setOpacityIE(el, value) {
		var filter = false,
		    filterName = 'DXImageTransform.Microsoft.Alpha';
	
		// filters collection throws an error if we try to retrieve a filter that doesn't exist
		try {
			filter = el.filters.item(filterName);
		} catch (e) {
			// don't set opacity to 1 if we haven't already set an opacity,
			// it isn't needed and breaks transparent pngs.
			if (value === 1) { return; }
		}
	
		value = Math.round(value * 100);
	
		if (filter) {
			filter.Enabled = (value !== 100);
			filter.Opacity = value;
		} else {
			el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
		}
	}
	
	// @function testProp(props: String[]): String|false
	// Goes through the array of style names and returns the first name
	// that is a valid style name for an element. If no such name is found,
	// it returns false. Useful for vendor-prefixed styles like `transform`.
	function testProp(props) {
		var style = document.documentElement.style;
	
		for (var i = 0; i < props.length; i++) {
			if (props[i] in style) {
				return props[i];
			}
		}
		return false;
	}
	
	// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	// and optionally scaled by `scale`. Does not have an effect if the
	// browser doesn't support 3D CSS transforms.
	function setTransform(el, offset, scale) {
		var pos = offset || new Point(0, 0);
	
		el.style[TRANSFORM] =
			(ie3d ?
				'translate(' + pos.x + 'px,' + pos.y + 'px)' :
				'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
			(scale ? ' scale(' + scale + ')' : '');
	}
	
	// @function setPosition(el: HTMLElement, position: Point)
	// Sets the position of `el` to coordinates specified by `position`,
	// using CSS translate or top/left positioning depending on the browser
	// (used by Leaflet internally to position its layers).
	function setPosition(el, point) {
	
		/*eslint-disable */
		el._leaflet_pos = point;
		/* eslint-enable */
	
		if (any3d) {
			setTransform(el, point);
		} else {
			el.style.left = point.x + 'px';
			el.style.top = point.y + 'px';
		}
	}
	
	// @function getPosition(el: HTMLElement): Point
	// Returns the coordinates of an element previously positioned with setPosition.
	function getPosition(el) {
		// this method is only used for elements previously positioned using setPosition,
		// so it's safe to cache the position for performance
	
		return el._leaflet_pos || new Point(0, 0);
	}
	
	// @function disableTextSelection()
	// Prevents the user from generating `selectstart` DOM events, usually generated
	// when the user drags the mouse through a page with text. Used internally
	// by Leaflet to override the behaviour of any click-and-drag interaction on
	// the map. Affects drag interactions on the whole document.
	
	// @function enableTextSelection()
	// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	var disableTextSelection;
	var enableTextSelection;
	var _userSelect;
	if ('onselectstart' in document) {
		disableTextSelection = function () {
			on(window, 'selectstart', preventDefault);
		};
		enableTextSelection = function () {
			off(window, 'selectstart', preventDefault);
		};
	} else {
		var userSelectProperty = testProp(
			['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
		disableTextSelection = function () {
			if (userSelectProperty) {
				var style = document.documentElement.style;
				_userSelect = style[userSelectProperty];
				style[userSelectProperty] = 'none';
			}
		};
		enableTextSelection = function () {
			if (userSelectProperty) {
				document.documentElement.style[userSelectProperty] = _userSelect;
				_userSelect = undefined;
			}
		};
	}
	
	// @function disableImageDrag()
	// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	// for `dragstart` DOM events, usually generated when the user drags an image.
	function disableImageDrag() {
		on(window, 'dragstart', preventDefault);
	}
	
	// @function enableImageDrag()
	// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	function enableImageDrag() {
		off(window, 'dragstart', preventDefault);
	}
	
	var _outlineElement;
	var _outlineStyle;
	// @function preventOutline(el: HTMLElement)
	// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	// of the element `el` invisible. Used internally by Leaflet to prevent
	// focusable elements from displaying an outline when the user performs a
	// drag interaction on them.
	function preventOutline(element) {
		while (element.tabIndex === -1) {
			element = element.parentNode;
		}
		if (!element.style) { return; }
		restoreOutline();
		_outlineElement = element;
		_outlineStyle = element.style.outline;
		element.style.outline = 'none';
		on(window, 'keydown', restoreOutline);
	}
	
	// @function restoreOutline()
	// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	function restoreOutline() {
		if (!_outlineElement) { return; }
		_outlineElement.style.outline = _outlineStyle;
		_outlineElement = undefined;
		_outlineStyle = undefined;
		off(window, 'keydown', restoreOutline);
	}
	
	// @function getSizedParentNode(el: HTMLElement): HTMLElement
	// Finds the closest parent node which size (width and height) is not null.
	function getSizedParentNode(element) {
		do {
			element = element.parentNode;
		} while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
		return element;
	}
	
	// @function getScale(el: HTMLElement): Object
	// Computes the CSS scale currently applied on the element.
	// Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
	// and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
	function getScale(element) {
		var rect = element.getBoundingClientRect(); // Read-only in old browsers.
	
		return {
			x: rect.width / element.offsetWidth || 1,
			y: rect.height / element.offsetHeight || 1,
			boundingClientRect: rect
		};
	}
	
	
	var DomUtil = (Object.freeze || Object)({
		TRANSFORM: TRANSFORM,
		TRANSITION: TRANSITION,
		TRANSITION_END: TRANSITION_END,
		get: get,
		getStyle: getStyle,
		create: create$1,
		remove: remove,
		empty: empty,
		toFront: toFront,
		toBack: toBack,
		hasClass: hasClass,
		addClass: addClass,
		removeClass: removeClass,
		setClass: setClass,
		getClass: getClass,
		setOpacity: setOpacity,
		testProp: testProp,
		setTransform: setTransform,
		setPosition: setPosition,
		getPosition: getPosition,
		disableTextSelection: disableTextSelection,
		enableTextSelection: enableTextSelection,
		disableImageDrag: disableImageDrag,
		enableImageDrag: enableImageDrag,
		preventOutline: preventOutline,
		restoreOutline: restoreOutline,
		getSizedParentNode: getSizedParentNode,
		getScale: getScale
	});
	
	/*
	 * @namespace DomEvent
	 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	 */
	
	// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Adds a listener function (`fn`) to a particular DOM event type of the
	// element `el`. You can optionally specify the context of the listener
	// (object the `this` keyword will point to). You can also pass several
	// space-separated types (e.g. `'click dblclick'`).
	
	// @alternative
	// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	function on(obj, types, fn, context) {
	
		if (typeof types === 'object') {
			for (var type in types) {
				addOne(obj, type, types[type], fn);
			}
		} else {
			types = splitWords(types);
	
			for (var i = 0, len = types.length; i < len; i++) {
				addOne(obj, types[i], fn, context);
			}
		}
	
		return this;
	}
	
	var eventsKey = '_leaflet_events';
	
	// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Removes a previously added listener function.
	// Note that if you passed a custom context to on, you must pass the same
	// context to `off` in order to remove the listener.
	
	// @alternative
	// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	function off(obj, types, fn, context) {
	
		if (typeof types === 'object') {
			for (var type in types) {
				removeOne(obj, type, types[type], fn);
			}
		} else if (types) {
			types = splitWords(types);
	
			for (var i = 0, len = types.length; i < len; i++) {
				removeOne(obj, types[i], fn, context);
			}
		} else {
			for (var j in obj[eventsKey]) {
				removeOne(obj, j, obj[eventsKey][j]);
			}
			delete obj[eventsKey];
		}
	
		return this;
	}
	
	function addOne(obj, type, fn, context) {
		var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
	
		if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
		var handler = function (e) {
			return fn.call(context || obj, e || window.event);
		};
	
		var originalHandler = handler;
	
		if (pointer && type.indexOf('touch') === 0) {
			// Needs DomEvent.Pointer.js
			addPointerListener(obj, type, handler, id);
	
		} else if (touch && (type === 'dblclick') && addDoubleTapListener &&
		           !(pointer && chrome)) {
			// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
			// See #5180
			addDoubleTapListener(obj, handler, id);
	
		} else if ('addEventListener' in obj) {
	
			if (type === 'mousewheel') {
				obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
			} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
				handler = function (e) {
					e = e || window.event;
					if (isExternalTarget(obj, e)) {
						originalHandler(e);
					}
				};
				obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);
	
			} else {
				if (type === 'click' && android) {
					handler = function (e) {
						filterClick(e, originalHandler);
					};
				}
				obj.addEventListener(type, handler, false);
			}
	
		} else if ('attachEvent' in obj) {
			obj.attachEvent('on' + type, handler);
		}
	
		obj[eventsKey] = obj[eventsKey] || {};
		obj[eventsKey][id] = handler;
	}
	
	function removeOne(obj, type, fn, context) {
	
		var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''),
		    handler = obj[eventsKey] && obj[eventsKey][id];
	
		if (!handler) { return this; }
	
		if (pointer && type.indexOf('touch') === 0) {
			removePointerListener(obj, type, id);
	
		} else if (touch && (type === 'dblclick') && removeDoubleTapListener &&
		           !(pointer && chrome)) {
			removeDoubleTapListener(obj, id);
	
		} else if ('removeEventListener' in obj) {
	
			if (type === 'mousewheel') {
				obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
			} else {
				obj.removeEventListener(
					type === 'mouseenter' ? 'mouseover' :
					type === 'mouseleave' ? 'mouseout' : type, handler, false);
			}
	
		} else if ('detachEvent' in obj) {
			obj.detachEvent('on' + type, handler);
		}
	
		obj[eventsKey][id] = null;
	}
	
	// @function stopPropagation(ev: DOMEvent): this
	// Stop the given event from propagation to parent elements. Used inside the listener functions:
	// ```js
	// L.DomEvent.on(div, 'click', function (ev) {
	// 	L.DomEvent.stopPropagation(ev);
	// });
	// ```
	function stopPropagation(e) {
	
		if (e.stopPropagation) {
			e.stopPropagation();
		} else if (e.originalEvent) {  // In case of Leaflet event.
			e.originalEvent._stopped = true;
		} else {
			e.cancelBubble = true;
		}
		skipped(e);
	
		return this;
	}
	
	// @function disableScrollPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
	function disableScrollPropagation(el) {
		addOne(el, 'mousewheel', stopPropagation);
		return this;
	}
	
	// @function disableClickPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
	// `'mousedown'` and `'touchstart'` events (plus browser variants).
	function disableClickPropagation(el) {
		on(el, 'mousedown touchstart dblclick', stopPropagation);
		addOne(el, 'click', fakeStop);
		return this;
	}
	
	// @function preventDefault(ev: DOMEvent): this
	// Prevents the default action of the DOM Event `ev` from happening (such as
	// following a link in the href of the a element, or doing a POST request
	// with page reload when a `<form>` is submitted).
	// Use it inside listener functions.
	function preventDefault(e) {
		if (e.preventDefault) {
			e.preventDefault();
		} else {
			e.returnValue = false;
		}
		return this;
	}
	
	// @function stop(ev: DOMEvent): this
	// Does `stopPropagation` and `preventDefault` at the same time.
	function stop(e) {
		preventDefault(e);
		stopPropagation(e);
		return this;
	}
	
	// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	// Gets normalized mouse position from a DOM event relative to the
	// `container` (border excluded) or to the whole page if not specified.
	function getMousePosition(e, container) {
		if (!container) {
			return new Point(e.clientX, e.clientY);
		}
	
		var scale = getScale(container),
		    offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
	
		return new Point(
			// offset.left/top values are in page scale (like clientX/Y),
			// whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
			(e.clientX - offset.left) / scale.x - container.clientLeft,
			(e.clientY - offset.top) / scale.y - container.clientTop
		);
	}
	
	// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
	// and Firefox scrolls device pixels, not CSS pixels
	var wheelPxFactor =
		(win && chrome) ? 2 * window.devicePixelRatio :
		gecko ? window.devicePixelRatio : 1;
	
	// @function getWheelDelta(ev: DOMEvent): Number
	// Gets normalized wheel delta from a mousewheel DOM event, in vertical
	// pixels scrolled (negative if scrolling down).
	// Events from pointing devices without precise scrolling are mapped to
	// a best guess of 60 pixels.
	function getWheelDelta(e) {
		return (edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
		       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
		       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
		       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
		       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
		       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
		       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
		       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
		       0;
	}
	
	var skipEvents = {};
	
	function fakeStop(e) {
		// fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
		skipEvents[e.type] = true;
	}
	
	function skipped(e) {
		var events = skipEvents[e.type];
		// reset when checking, as it's only used in map container and propagates outside of the map
		skipEvents[e.type] = false;
		return events;
	}
	
	// check if element really left/entered the event target (for mouseenter/mouseleave)
	function isExternalTarget(el, e) {
	
		var related = e.relatedTarget;
	
		if (!related) { return true; }
	
		try {
			while (related && (related !== el)) {
				related = related.parentNode;
			}
		} catch (err) {
			return false;
		}
		return (related !== el);
	}
	
	var lastClick;
	
	// this is a horrible workaround for a bug in Android where a single touch triggers two click events
	function filterClick(e, handler) {
		var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
		    elapsed = lastClick && (timeStamp - lastClick);
	
		// are they closer together than 500ms yet more than 100ms?
		// Android typically triggers them ~300ms apart while multiple listeners
		// on the same event should be triggered far faster;
		// or check if click is simulated on the element, and if it is, reject any non-simulated events
	
		if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
			stop(e);
			return;
		}
		lastClick = timeStamp;
	
		handler(e);
	}
	
	
	
	
	var DomEvent = (Object.freeze || Object)({
		on: on,
		off: off,
		stopPropagation: stopPropagation,
		disableScrollPropagation: disableScrollPropagation,
		disableClickPropagation: disableClickPropagation,
		preventDefault: preventDefault,
		stop: stop,
		getMousePosition: getMousePosition,
		getWheelDelta: getWheelDelta,
		fakeStop: fakeStop,
		skipped: skipped,
		isExternalTarget: isExternalTarget,
		addListener: on,
		removeListener: off
	});
	
	/*
	 * @class PosAnimation
	 * @aka L.PosAnimation
	 * @inherits Evented
	 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	 *
	 * @example
	 * ```js
	 * var fx = new L.PosAnimation();
	 * fx.run(el, [300, 500], 0.5);
	 * ```
	 *
	 * @constructor L.PosAnimation()
	 * Creates a `PosAnimation` object.
	 *
	 */
	
	var PosAnimation = Evented.extend({
	
		// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
		// Run an animation of a given element to a new position, optionally setting
		// duration in seconds (`0.25` by default) and easing linearity factor (3rd
		// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
		// `0.5` by default).
		run: function (el, newPos, duration, easeLinearity) {
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._duration = duration || 0.25;
			this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
			this._startPos = getPosition(el);
			this._offset = newPos.subtract(this._startPos);
			this._startTime = +new Date();
	
			// @event start: Event
			// Fired when the animation starts
			this.fire('start');
	
			this._animate();
		},
	
		// @method stop()
		// Stops the animation (if currently running).
		stop: function () {
			if (!this._inProgress) { return; }
	
			this._step(true);
			this._complete();
		},
	
		_animate: function () {
			// animation loop
			this._animId = requestAnimFrame(this._animate, this);
			this._step();
		},
	
		_step: function (round) {
			var elapsed = (+new Date()) - this._startTime,
			    duration = this._duration * 1000;
	
			if (elapsed < duration) {
				this._runFrame(this._easeOut(elapsed / duration), round);
			} else {
				this._runFrame(1);
				this._complete();
			}
		},
	
		_runFrame: function (progress, round) {
			var pos = this._startPos.add(this._offset.multiplyBy(progress));
			if (round) {
				pos._round();
			}
			setPosition(this._el, pos);
	
			// @event step: Event
			// Fired continuously during the animation.
			this.fire('step');
		},
	
		_complete: function () {
			cancelAnimFrame(this._animId);
	
			this._inProgress = false;
			// @event end: Event
			// Fired when the animation ends.
			this.fire('end');
		},
	
		_easeOut: function (t) {
			return 1 - Math.pow(1 - t, this._easeOutPower);
		}
	});
	
	/*
	 * @class Map
	 * @aka L.Map
	 * @inherits Evented
	 *
	 * The central class of the API — it is used to create a map on a page and manipulate it.
	 *
	 * @example
	 *
	 * ```js
	 * // initialize the map on the "map" div with a given center and zoom
	 * var map = L.map('map', {
	 * 	center: [51.505, -0.09],
	 * 	zoom: 13
	 * });
	 * ```
	 *
	 */
	
	var Map = Evented.extend({
	
		options: {
			// @section Map State Options
			// @option crs: CRS = L.CRS.EPSG3857
			// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
			// sure what it means.
			crs: EPSG3857,
	
			// @option center: LatLng = undefined
			// Initial geographic center of the map
			center: undefined,
	
			// @option zoom: Number = undefined
			// Initial map zoom level
			zoom: undefined,
	
			// @option minZoom: Number = *
			// Minimum zoom level of the map.
			// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
			// the lowest of their `minZoom` options will be used instead.
			minZoom: undefined,
	
			// @option maxZoom: Number = *
			// Maximum zoom level of the map.
			// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
			// the highest of their `maxZoom` options will be used instead.
			maxZoom: undefined,
	
			// @option layers: Layer[] = []
			// Array of layers that will be added to the map initially
			layers: [],
	
			// @option maxBounds: LatLngBounds = null
			// When this option is set, the map restricts the view to the given
			// geographical bounds, bouncing the user back if the user tries to pan
			// outside the view. To set the restriction dynamically, use
			// [`setMaxBounds`](#map-setmaxbounds) method.
			maxBounds: undefined,
	
			// @option renderer: Renderer = *
			// The default method for drawing vector layers on the map. `L.SVG`
			// or `L.Canvas` by default depending on browser support.
			renderer: undefined,
	
	
			// @section Animation Options
			// @option zoomAnimation: Boolean = true
			// Whether the map zoom animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			zoomAnimation: true,
	
			// @option zoomAnimationThreshold: Number = 4
			// Won't animate zoom if the zoom difference exceeds this value.
			zoomAnimationThreshold: 4,
	
			// @option fadeAnimation: Boolean = true
			// Whether the tile fade animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			fadeAnimation: true,
	
			// @option markerZoomAnimation: Boolean = true
			// Whether markers animate their zoom with the zoom animation, if disabled
			// they will disappear for the length of the animation. By default it's
			// enabled in all browsers that support CSS3 Transitions except Android.
			markerZoomAnimation: true,
	
			// @option transform3DLimit: Number = 2^23
			// Defines the maximum size of a CSS translation transform. The default
			// value should not be changed unless a web browser positions layers in
			// the wrong place after doing a large `panBy`.
			transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
			// @section Interaction Options
			// @option zoomSnap: Number = 1
			// Forces the map's zoom level to always be a multiple of this, particularly
			// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
			// By default, the zoom level snaps to the nearest integer; lower values
			// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
			// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
			zoomSnap: 1,
	
			// @option zoomDelta: Number = 1
			// Controls how much the map's zoom level will change after a
			// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
			// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
			// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
			zoomDelta: 1,
	
			// @option trackResize: Boolean = true
			// Whether the map automatically handles browser window resize to update itself.
			trackResize: true
		},
	
		initialize: function (id, options) { // (HTMLElement or String, Object)
			options = setOptions(this, options);
	
			this._initContainer(id);
			this._initLayout();
	
			// hack for https://github.com/Leaflet/Leaflet/issues/1980
			this._onResize = bind(this._onResize, this);
	
			this._initEvents();
	
			if (options.maxBounds) {
				this.setMaxBounds(options.maxBounds);
			}
	
			if (options.zoom !== undefined) {
				this._zoom = this._limitZoom(options.zoom);
			}
	
			if (options.center && options.zoom !== undefined) {
				this.setView(toLatLng(options.center), options.zoom, {reset: true});
			}
	
			this._handlers = [];
			this._layers = {};
			this._zoomBoundLayers = {};
			this._sizeChanged = true;
	
			this.callInitHooks();
	
			// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
			this._zoomAnimated = TRANSITION && any3d && !mobileOpera &&
					this.options.zoomAnimation;
	
			// zoom transitions run with the same duration for all layers, so if one of transitionend events
			// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
			if (this._zoomAnimated) {
				this._createAnimProxy();
				on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
			}
	
			this._addLayers(this.options.layers);
		},
	
	
		// @section Methods for modifying map state
	
		// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) with the given
		// animation options.
		setView: function (center, zoom, options) {
	
			zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
			center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
			options = options || {};
	
			this._stop();
	
			if (this._loaded && !options.reset && options !== true) {
	
				if (options.animate !== undefined) {
					options.zoom = extend({animate: options.animate}, options.zoom);
					options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
				}
	
				// try animating pan or zoom
				var moved = (this._zoom !== zoom) ?
					this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
					this._tryAnimatedPan(center, options.pan);
	
				if (moved) {
					// prevent resize handler call, the view will refresh after animation anyway
					clearTimeout(this._sizeTimer);
					return this;
				}
			}
	
			// animation didn't start, just reset the map view
			this._resetView(center, zoom);
	
			return this;
		},
	
		// @method setZoom(zoom: Number, options?: Zoom/pan options): this
		// Sets the zoom of the map.
		setZoom: function (zoom, options) {
			if (!this._loaded) {
				this._zoom = zoom;
				return this;
			}
			return this.setView(this.getCenter(), zoom, {zoom: options});
		},
	
		// @method zoomIn(delta?: Number, options?: Zoom options): this
		// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomIn: function (delta, options) {
			delta = delta || (any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom + delta, options);
		},
	
		// @method zoomOut(delta?: Number, options?: Zoom options): this
		// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomOut: function (delta, options) {
			delta = delta || (any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom - delta, options);
		},
	
		// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified geographical point on the map
		// stationary (e.g. used internally for scroll zoom and double-click zoom).
		// @alternative
		// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
		setZoomAround: function (latlng, zoom, options) {
			var scale = this.getZoomScale(zoom),
			    viewHalf = this.getSize().divideBy(2),
			    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),
	
			    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
			    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
			return this.setView(newCenter, zoom, {zoom: options});
		},
	
		_getBoundsCenterZoom: function (bounds, options) {
	
			options = options || {};
			bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
	
			var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	
			    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
			zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
			if (zoom === Infinity) {
				return {
					center: bounds.getCenter(),
					zoom: zoom
				};
			}
	
			var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
			    swPoint = this.project(bounds.getSouthWest(), zoom),
			    nePoint = this.project(bounds.getNorthEast(), zoom),
			    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
			return {
				center: center,
				zoom: zoom
			};
		},
	
		// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets a map view that contains the given geographical bounds with the
		// maximum zoom level possible.
		fitBounds: function (bounds, options) {
	
			bounds = toLatLngBounds(bounds);
	
			if (!bounds.isValid()) {
				throw new Error('Bounds are not valid.');
			}
	
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.setView(target.center, target.zoom, options);
		},
	
		// @method fitWorld(options?: fitBounds options): this
		// Sets a map view that mostly contains the whole world with the maximum
		// zoom level possible.
		fitWorld: function (options) {
			return this.fitBounds([[-90, -180], [90, 180]], options);
		},
	
		// @method panTo(latlng: LatLng, options?: Pan options): this
		// Pans the map to a given center.
		panTo: function (center, options) { // (LatLng)
			return this.setView(center, this._zoom, {pan: options});
		},
	
		// @method panBy(offset: Point, options?: Pan options): this
		// Pans the map by a given number of pixels (animated).
		panBy: function (offset, options) {
			offset = toPoint(offset).round();
			options = options || {};
	
			if (!offset.x && !offset.y) {
				return this.fire('moveend');
			}
			// If we pan too far, Chrome gets issues with tiles
			// and makes them disappear or appear in the wrong place (slightly offset) #2602
			if (options.animate !== true && !this.getSize().contains(offset)) {
				this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
				return this;
			}
	
			if (!this._panAnim) {
				this._panAnim = new PosAnimation();
	
				this._panAnim.on({
					'step': this._onPanTransitionStep,
					'end': this._onPanTransitionEnd
				}, this);
			}
	
			// don't fire movestart if animating inertia
			if (!options.noMoveStart) {
				this.fire('movestart');
			}
	
			// animate pan unless animate: false specified
			if (options.animate !== false) {
				addClass(this._mapPane, 'leaflet-pan-anim');
	
				var newPos = this._getMapPanePos().subtract(offset).round();
				this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
			} else {
				this._rawPanBy(offset);
				this.fire('move').fire('moveend');
			}
	
			return this;
		},
	
		// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) performing a smooth
		// pan-zoom animation.
		flyTo: function (targetCenter, targetZoom, options) {
	
			options = options || {};
			if (options.animate === false || !any3d) {
				return this.setView(targetCenter, targetZoom, options);
			}
	
			this._stop();
	
			var from = this.project(this.getCenter()),
			    to = this.project(targetCenter),
			    size = this.getSize(),
			    startZoom = this._zoom;
	
			targetCenter = toLatLng(targetCenter);
			targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
			var w0 = Math.max(size.x, size.y),
			    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
			    u1 = (to.distanceTo(from)) || 1,
			    rho = 1.42,
			    rho2 = rho * rho;
	
			function r(i) {
				var s1 = i ? -1 : 1,
				    s2 = i ? w1 : w0,
				    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
				    b1 = 2 * s2 * rho2 * u1,
				    b = t1 / b1,
				    sq = Math.sqrt(b * b + 1) - b;
	
				    // workaround for floating point precision bug when sq = 0, log = -Infinite,
				    // thus triggering an infinite loop in flyTo
				    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
				return log;
			}
	
			function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
			function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
			function tanh(n) { return sinh(n) / cosh(n); }
	
			var r0 = r(0);
	
			function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
			function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
			function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
			var start = Date.now(),
			    S = (r(1) - r0) / rho,
			    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
			function frame() {
				var t = (Date.now() - start) / duration,
				    s = easeOut(t) * S;
	
				if (t <= 1) {
					this._flyToFrame = requestAnimFrame(frame, this);
	
					this._move(
						this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
						this.getScaleZoom(w0 / w(s), startZoom),
						{flyTo: true});
	
				} else {
					this
						._move(targetCenter, targetZoom)
						._moveEnd(true);
				}
			}
	
			this._moveStart(true, options.noMoveStart);
	
			frame.call(this);
			return this;
		},
	
		// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
		// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
		flyToBounds: function (bounds, options) {
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.flyTo(target.center, target.zoom, options);
		},
	
		// @method setMaxBounds(bounds: Bounds): this
		// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
		setMaxBounds: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			if (!bounds.isValid()) {
				this.options.maxBounds = null;
				return this.off('moveend', this._panInsideMaxBounds);
			} else if (this.options.maxBounds) {
				this.off('moveend', this._panInsideMaxBounds);
			}
	
			this.options.maxBounds = bounds;
	
			if (this._loaded) {
				this._panInsideMaxBounds();
			}
	
			return this.on('moveend', this._panInsideMaxBounds);
		},
	
		// @method setMinZoom(zoom: Number): this
		// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
		setMinZoom: function (zoom) {
			var oldZoom = this.options.minZoom;
			this.options.minZoom = zoom;
	
			if (this._loaded && oldZoom !== zoom) {
				this.fire('zoomlevelschange');
	
				if (this.getZoom() < this.options.minZoom) {
					return this.setZoom(zoom);
				}
			}
	
			return this;
		},
	
		// @method setMaxZoom(zoom: Number): this
		// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
		setMaxZoom: function (zoom) {
			var oldZoom = this.options.maxZoom;
			this.options.maxZoom = zoom;
	
			if (this._loaded && oldZoom !== zoom) {
				this.fire('zoomlevelschange');
	
				if (this.getZoom() > this.options.maxZoom) {
					return this.setZoom(zoom);
				}
			}
	
			return this;
		},
	
		// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
		// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
		panInsideBounds: function (bounds, options) {
			this._enforcingBounds = true;
			var center = this.getCenter(),
			    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
	
			if (!center.equals(newCenter)) {
				this.panTo(newCenter, options);
			}
	
			this._enforcingBounds = false;
			return this;
		},
	
		// @method invalidateSize(options: Zoom/pan options): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default. If `options.pan` is `false`, panning will not occur.
		// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
		// that it doesn't happen often even if the method is called many
		// times in a row.
	
		// @alternative
		// @method invalidateSize(animate: Boolean): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default.
		invalidateSize: function (options) {
			if (!this._loaded) { return this; }
	
			options = extend({
				animate: false,
				pan: true
			}, options === true ? {animate: true} : options);
	
			var oldSize = this.getSize();
			this._sizeChanged = true;
			this._lastCenter = null;
	
			var newSize = this.getSize(),
			    oldCenter = oldSize.divideBy(2).round(),
			    newCenter = newSize.divideBy(2).round(),
			    offset = oldCenter.subtract(newCenter);
	
			if (!offset.x && !offset.y) { return this; }
	
			if (options.animate && options.pan) {
				this.panBy(offset);
	
			} else {
				if (options.pan) {
					this._rawPanBy(offset);
				}
	
				this.fire('move');
	
				if (options.debounceMoveend) {
					clearTimeout(this._sizeTimer);
					this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
				} else {
					this.fire('moveend');
				}
			}
	
			// @section Map state change events
			// @event resize: ResizeEvent
			// Fired when the map is resized.
			return this.fire('resize', {
				oldSize: oldSize,
				newSize: newSize
			});
		},
	
		// @section Methods for modifying map state
		// @method stop(): this
		// Stops the currently running `panTo` or `flyTo` animation, if any.
		stop: function () {
			this.setZoom(this._limitZoom(this._zoom));
			if (!this.options.zoomSnap) {
				this.fire('viewreset');
			}
			return this._stop();
		},
	
		// @section Geolocation methods
		// @method locate(options?: Locate options): this
		// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
		// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
		// and optionally sets the map view to the user's location with respect to
		// detection accuracy (or to the world view if geolocation failed).
		// Note that, if your page doesn't use HTTPS, this method will fail in
		// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
		// See `Locate options` for more details.
		locate: function (options) {
	
			options = this._locateOptions = extend({
				timeout: 10000,
				watch: false
				// setView: false
				// maxZoom: <Number>
				// maximumAge: 0
				// enableHighAccuracy: false
			}, options);
	
			if (!('geolocation' in navigator)) {
				this._handleGeolocationError({
					code: 0,
					message: 'Geolocation not supported.'
				});
				return this;
			}
	
			var onResponse = bind(this._handleGeolocationResponse, this),
			    onError = bind(this._handleGeolocationError, this);
	
			if (options.watch) {
				this._locationWatchId =
				        navigator.geolocation.watchPosition(onResponse, onError, options);
			} else {
				navigator.geolocation.getCurrentPosition(onResponse, onError, options);
			}
			return this;
		},
	
		// @method stopLocate(): this
		// Stops watching location previously initiated by `map.locate({watch: true})`
		// and aborts resetting the map view if map.locate was called with
		// `{setView: true}`.
		stopLocate: function () {
			if (navigator.geolocation && navigator.geolocation.clearWatch) {
				navigator.geolocation.clearWatch(this._locationWatchId);
			}
			if (this._locateOptions) {
				this._locateOptions.setView = false;
			}
			return this;
		},
	
		_handleGeolocationError: function (error) {
			var c = error.code,
			    message = error.message ||
			            (c === 1 ? 'permission denied' :
			            (c === 2 ? 'position unavailable' : 'timeout'));
	
			if (this._locateOptions.setView && !this._loaded) {
				this.fitWorld();
			}
	
			// @section Location events
			// @event locationerror: ErrorEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
			this.fire('locationerror', {
				code: c,
				message: 'Geolocation error: ' + message + '.'
			});
		},
	
		_handleGeolocationResponse: function (pos) {
			var lat = pos.coords.latitude,
			    lng = pos.coords.longitude,
			    latlng = new LatLng(lat, lng),
			    bounds = latlng.toBounds(pos.coords.accuracy * 2),
			    options = this._locateOptions;
	
			if (options.setView) {
				var zoom = this.getBoundsZoom(bounds);
				this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
			}
	
			var data = {
				latlng: latlng,
				bounds: bounds,
				timestamp: pos.timestamp
			};
	
			for (var i in pos.coords) {
				if (typeof pos.coords[i] === 'number') {
					data[i] = pos.coords[i];
				}
			}
	
			// @event locationfound: LocationEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method)
			// went successfully.
			this.fire('locationfound', data);
		},
	
		// TODO Appropriate docs section?
		// @section Other Methods
		// @method addHandler(name: String, HandlerClass: Function): this
		// Adds a new `Handler` to the map, given its name and constructor function.
		addHandler: function (name, HandlerClass) {
			if (!HandlerClass) { return this; }
	
			var handler = this[name] = new HandlerClass(this);
	
			this._handlers.push(handler);
	
			if (this.options[name]) {
				handler.enable();
			}
	
			return this;
		},
	
		// @method remove(): this
		// Destroys the map and clears all related event listeners.
		remove: function () {
	
			this._initEvents(true);
	
			if (this._containerId !== this._container._leaflet_id) {
				throw new Error('Map container is being reused by another instance');
			}
	
			try {
				// throws error in IE6-8
				delete this._container._leaflet_id;
				delete this._containerId;
			} catch (e) {
				/*eslint-disable */
				this._container._leaflet_id = undefined;
				/* eslint-enable */
				this._containerId = undefined;
			}
	
			if (this._locationWatchId !== undefined) {
				this.stopLocate();
			}
	
			this._stop();
	
			remove(this._mapPane);
	
			if (this._clearControlPos) {
				this._clearControlPos();
			}
			if (this._resizeRequest) {
				cancelAnimFrame(this._resizeRequest);
				this._resizeRequest = null;
			}
	
			this._clearHandlers();
	
			if (this._loaded) {
				// @section Map state change events
				// @event unload: Event
				// Fired when the map is destroyed with [remove](#map-remove) method.
				this.fire('unload');
			}
	
			var i;
			for (i in this._layers) {
				this._layers[i].remove();
			}
			for (i in this._panes) {
				remove(this._panes[i]);
			}
	
			this._layers = [];
			this._panes = [];
			delete this._mapPane;
			delete this._renderer;
	
			return this;
		},
	
		// @section Other Methods
		// @method createPane(name: String, container?: HTMLElement): HTMLElement
		// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
		// then returns it. The pane is created as a child of `container`, or
		// as a child of the main map pane if not set.
		createPane: function (name, container) {
			var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
			    pane = create$1('div', className, container || this._mapPane);
	
			if (name) {
				this._panes[name] = pane;
			}
			return pane;
		},
	
		// @section Methods for Getting Map State
	
		// @method getCenter(): LatLng
		// Returns the geographical center of the map view
		getCenter: function () {
			this._checkIfLoaded();
	
			if (this._lastCenter && !this._moved()) {
				return this._lastCenter;
			}
			return this.layerPointToLatLng(this._getCenterLayerPoint());
		},
	
		// @method getZoom(): Number
		// Returns the current zoom level of the map view
		getZoom: function () {
			return this._zoom;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the geographical bounds visible in the current map view
		getBounds: function () {
			var bounds = this.getPixelBounds(),
			    sw = this.unproject(bounds.getBottomLeft()),
			    ne = this.unproject(bounds.getTopRight());
	
			return new LatLngBounds(sw, ne);
		},
	
		// @method getMinZoom(): Number
		// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
		getMinZoom: function () {
			return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
		},
	
		// @method getMaxZoom(): Number
		// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
		getMaxZoom: function () {
			return this.options.maxZoom === undefined ?
				(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
				this.options.maxZoom;
		},
	
		// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
		// Returns the maximum zoom level on which the given bounds fit to the map
		// view in its entirety. If `inside` (optional) is set to `true`, the method
		// instead returns the minimum zoom level on which the map view fits into
		// the given bounds in its entirety.
		getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
			bounds = toLatLngBounds(bounds);
			padding = toPoint(padding || [0, 0]);
	
			var zoom = this.getZoom() || 0,
			    min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    nw = bounds.getNorthWest(),
			    se = bounds.getSouthEast(),
			    size = this.getSize().subtract(padding),
			    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
			    snap = any3d ? this.options.zoomSnap : 1,
			    scalex = size.x / boundsSize.x,
			    scaley = size.y / boundsSize.y,
			    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
	
			zoom = this.getScaleZoom(scale, zoom);
	
			if (snap) {
				zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
				zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
			}
	
			return Math.max(min, Math.min(max, zoom));
		},
	
		// @method getSize(): Point
		// Returns the current size of the map container (in pixels).
		getSize: function () {
			if (!this._size || this._sizeChanged) {
				this._size = new Point(
					this._container.clientWidth || 0,
					this._container.clientHeight || 0);
	
				this._sizeChanged = false;
			}
			return this._size.clone();
		},
	
		// @method getPixelBounds(): Bounds
		// Returns the bounds of the current map view in projected pixel
		// coordinates (sometimes useful in layer and overlay implementations).
		getPixelBounds: function (center, zoom) {
			var topLeftPoint = this._getTopLeftPoint(center, zoom);
			return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
		},
	
		// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
		// the map pane? "left point of the map layer" can be confusing, specially
		// since there can be negative offsets.
		// @method getPixelOrigin(): Point
		// Returns the projected pixel coordinates of the top left point of
		// the map layer (useful in custom layer and overlay implementations).
		getPixelOrigin: function () {
			this._checkIfLoaded();
			return this._pixelOrigin;
		},
	
		// @method getPixelWorldBounds(zoom?: Number): Bounds
		// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
		// If `zoom` is omitted, the map's current zoom level is used.
		getPixelWorldBounds: function (zoom) {
			return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
		},
	
		// @section Other Methods
	
		// @method getPane(pane: String|HTMLElement): HTMLElement
		// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
		getPane: function (pane) {
			return typeof pane === 'string' ? this._panes[pane] : pane;
		},
	
		// @method getPanes(): Object
		// Returns a plain object containing the names of all [panes](#map-pane) as keys and
		// the panes as values.
		getPanes: function () {
			return this._panes;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the map.
		getContainer: function () {
			return this._container;
		},
	
	
		// @section Conversion Methods
	
		// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
		// Returns the scale factor to be applied to a map transition from zoom level
		// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
		getZoomScale: function (toZoom, fromZoom) {
			// TODO replace with universal implementation after refactoring projections
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			return crs.scale(toZoom) / crs.scale(fromZoom);
		},
	
		// @method getScaleZoom(scale: Number, fromZoom: Number): Number
		// Returns the zoom level that the map would end up at, if it is at `fromZoom`
		// level and everything is scaled by a factor of `scale`. Inverse of
		// [`getZoomScale`](#map-getZoomScale).
		getScaleZoom: function (scale, fromZoom) {
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			var zoom = crs.zoom(scale * crs.scale(fromZoom));
			return isNaN(zoom) ? Infinity : zoom;
		},
	
		// @method project(latlng: LatLng, zoom: Number): Point
		// Projects a geographical coordinate `LatLng` according to the projection
		// of the map's CRS, then scales it according to `zoom` and the CRS's
		// `Transformation`. The result is pixel coordinate relative to
		// the CRS origin.
		project: function (latlng, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
		},
	
		// @method unproject(point: Point, zoom: Number): LatLng
		// Inverse of [`project`](#map-project).
		unproject: function (point, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.pointToLatLng(toPoint(point), zoom);
		},
	
		// @method layerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding geographical coordinate (for the current zoom level).
		layerPointToLatLng: function (point) {
			var projectedPoint = toPoint(point).add(this.getPixelOrigin());
			return this.unproject(projectedPoint);
		},
	
		// @method latLngToLayerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the [origin pixel](#map-getpixelorigin).
		latLngToLayerPoint: function (latlng) {
			var projectedPoint = this.project(toLatLng(latlng))._round();
			return projectedPoint._subtract(this.getPixelOrigin());
		},
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
		// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
		// CRS's bounds.
		// By default this means longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees.
		wrapLatLng: function (latlng) {
			return this.options.crs.wrapLatLng(toLatLng(latlng));
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring that
		// its center is within the CRS's bounds.
		// By default this means the center longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees, and the majority of the bounds
		// overlaps the CRS's bounds.
		wrapLatLngBounds: function (latlng) {
			return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates according to
		// the map's CRS. By default this measures distance in meters.
		distance: function (latlng1, latlng2) {
			return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
		},
	
		// @method containerPointToLayerPoint(point: Point): Point
		// Given a pixel coordinate relative to the map container, returns the corresponding
		// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
		containerPointToLayerPoint: function (point) { // (Point)
			return toPoint(point).subtract(this._getMapPanePos());
		},
	
		// @method layerPointToContainerPoint(point: Point): Point
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding pixel coordinate relative to the map container.
		layerPointToContainerPoint: function (point) { // (Point)
			return toPoint(point).add(this._getMapPanePos());
		},
	
		// @method containerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the map container, returns
		// the corresponding geographical coordinate (for the current zoom level).
		containerPointToLatLng: function (point) {
			var layerPoint = this.containerPointToLayerPoint(toPoint(point));
			return this.layerPointToLatLng(layerPoint);
		},
	
		// @method latLngToContainerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the map container.
		latLngToContainerPoint: function (latlng) {
			return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
		},
	
		// @method mouseEventToContainerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to the
		// map container where the event took place.
		mouseEventToContainerPoint: function (e) {
			return getMousePosition(e, this._container);
		},
	
		// @method mouseEventToLayerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to
		// the [origin pixel](#map-getpixelorigin) where the event took place.
		mouseEventToLayerPoint: function (e) {
			return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
		},
	
		// @method mouseEventToLatLng(ev: MouseEvent): LatLng
		// Given a MouseEvent object, returns geographical coordinate where the
		// event took place.
		mouseEventToLatLng: function (e) { // (MouseEvent)
			return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
		},
	
	
		// map initialization methods
	
		_initContainer: function (id) {
			var container = this._container = get(id);
	
			if (!container) {
				throw new Error('Map container not found.');
			} else if (container._leaflet_id) {
				throw new Error('Map container is already initialized.');
			}
	
			on(container, 'scroll', this._onScroll, this);
			this._containerId = stamp(container);
		},
	
		_initLayout: function () {
			var container = this._container;
	
			this._fadeAnimated = this.options.fadeAnimation && any3d;
	
			addClass(container, 'leaflet-container' +
				(touch ? ' leaflet-touch' : '') +
				(retina ? ' leaflet-retina' : '') +
				(ielt9 ? ' leaflet-oldie' : '') +
				(safari ? ' leaflet-safari' : '') +
				(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
			var position = getStyle(container, 'position');
	
			if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
				container.style.position = 'relative';
			}
	
			this._initPanes();
	
			if (this._initControlPos) {
				this._initControlPos();
			}
		},
	
		_initPanes: function () {
			var panes = this._panes = {};
			this._paneRenderers = {};
	
			// @section
			//
			// Panes are DOM elements used to control the ordering of layers on the map. You
			// can access panes with [`map.getPane`](#map-getpane) or
			// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
			// [`map.createPane`](#map-createpane) method.
			//
			// Every map has the following default panes that differ only in zIndex.
			//
			// @pane mapPane: HTMLElement = 'auto'
			// Pane that contains all other map panes
	
			this._mapPane = this.createPane('mapPane', this._container);
			setPosition(this._mapPane, new Point(0, 0));
	
			// @pane tilePane: HTMLElement = 200
			// Pane for `GridLayer`s and `TileLayer`s
			this.createPane('tilePane');
			// @pane overlayPane: HTMLElement = 400
			// Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
			this.createPane('shadowPane');
			// @pane shadowPane: HTMLElement = 500
			// Pane for overlay shadows (e.g. `Marker` shadows)
			this.createPane('overlayPane');
			// @pane markerPane: HTMLElement = 600
			// Pane for `Icon`s of `Marker`s
			this.createPane('markerPane');
			// @pane tooltipPane: HTMLElement = 650
			// Pane for `Tooltip`s.
			this.createPane('tooltipPane');
			// @pane popupPane: HTMLElement = 700
			// Pane for `Popup`s.
			this.createPane('popupPane');
	
			if (!this.options.markerZoomAnimation) {
				addClass(panes.markerPane, 'leaflet-zoom-hide');
				addClass(panes.shadowPane, 'leaflet-zoom-hide');
			}
		},
	
	
		// private methods that modify map state
	
		// @section Map state change events
		_resetView: function (center, zoom) {
			setPosition(this._mapPane, new Point(0, 0));
	
			var loading = !this._loaded;
			this._loaded = true;
			zoom = this._limitZoom(zoom);
	
			this.fire('viewprereset');
	
			var zoomChanged = this._zoom !== zoom;
			this
				._moveStart(zoomChanged, false)
				._move(center, zoom)
				._moveEnd(zoomChanged);
	
			// @event viewreset: Event
			// Fired when the map needs to redraw its content (this usually happens
			// on map zoom or load). Very useful for creating custom overlays.
			this.fire('viewreset');
	
			// @event load: Event
			// Fired when the map is initialized (when its center and zoom are set
			// for the first time).
			if (loading) {
				this.fire('load');
			}
		},
	
		_moveStart: function (zoomChanged, noMoveStart) {
			// @event zoomstart: Event
			// Fired when the map zoom is about to change (e.g. before zoom animation).
			// @event movestart: Event
			// Fired when the view of the map starts changing (e.g. user starts dragging the map).
			if (zoomChanged) {
				this.fire('zoomstart');
			}
			if (!noMoveStart) {
				this.fire('movestart');
			}
			return this;
		},
	
		_move: function (center, zoom, data) {
			if (zoom === undefined) {
				zoom = this._zoom;
			}
			var zoomChanged = this._zoom !== zoom;
	
			this._zoom = zoom;
			this._lastCenter = center;
			this._pixelOrigin = this._getNewPixelOrigin(center);
	
			// @event zoom: Event
			// Fired repeatedly during any change in zoom level, including zoom
			// and fly animations.
			if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
				this.fire('zoom', data);
			}
	
			// @event move: Event
			// Fired repeatedly during any movement of the map, including pan and
			// fly animations.
			return this.fire('move', data);
		},
	
		_moveEnd: function (zoomChanged) {
			// @event zoomend: Event
			// Fired when the map has changed, after any animations.
			if (zoomChanged) {
				this.fire('zoomend');
			}
	
			// @event moveend: Event
			// Fired when the center of the map stops changing (e.g. user stopped
			// dragging the map).
			return this.fire('moveend');
		},
	
		_stop: function () {
			cancelAnimFrame(this._flyToFrame);
			if (this._panAnim) {
				this._panAnim.stop();
			}
			return this;
		},
	
		_rawPanBy: function (offset) {
			setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
		},
	
		_getZoomSpan: function () {
			return this.getMaxZoom() - this.getMinZoom();
		},
	
		_panInsideMaxBounds: function () {
			if (!this._enforcingBounds) {
				this.panInsideBounds(this.options.maxBounds);
			}
		},
	
		_checkIfLoaded: function () {
			if (!this._loaded) {
				throw new Error('Set map center and zoom first.');
			}
		},
	
		// DOM event handling
	
		// @section Interaction events
		_initEvents: function (remove$$1) {
			this._targets = {};
			this._targets[stamp(this._container)] = this;
	
			var onOff = remove$$1 ? off : on;
	
			// @event click: MouseEvent
			// Fired when the user clicks (or taps) the map.
			// @event dblclick: MouseEvent
			// Fired when the user double-clicks (or double-taps) the map.
			// @event mousedown: MouseEvent
			// Fired when the user pushes the mouse button on the map.
			// @event mouseup: MouseEvent
			// Fired when the user releases the mouse button on the map.
			// @event mouseover: MouseEvent
			// Fired when the mouse enters the map.
			// @event mouseout: MouseEvent
			// Fired when the mouse leaves the map.
			// @event mousemove: MouseEvent
			// Fired while the mouse moves over the map.
			// @event contextmenu: MouseEvent
			// Fired when the user pushes the right mouse button on the map, prevents
			// default browser context menu from showing if there are listeners on
			// this event. Also fired on mobile when the user holds a single touch
			// for a second (also called long press).
			// @event keypress: KeyboardEvent
			// Fired when the user presses a key from the keyboard while the map is focused.
			onOff(this._container, 'click dblclick mousedown mouseup ' +
				'mouseover mouseout mousemove contextmenu keypress', this._handleDOMEvent, this);
	
			if (this.options.trackResize) {
				onOff(window, 'resize', this._onResize, this);
			}
	
			if (any3d && this.options.transform3DLimit) {
				(remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
			}
		},
	
		_onResize: function () {
			cancelAnimFrame(this._resizeRequest);
			this._resizeRequest = requestAnimFrame(
			        function () { this.invalidateSize({debounceMoveend: true}); }, this);
		},
	
		_onScroll: function () {
			this._container.scrollTop  = 0;
			this._container.scrollLeft = 0;
		},
	
		_onMoveEnd: function () {
			var pos = this._getMapPanePos();
			if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
				// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
				// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
				this._resetView(this.getCenter(), this.getZoom());
			}
		},
	
		_findEventTargets: function (e, type) {
			var targets = [],
			    target,
			    isHover = type === 'mouseout' || type === 'mouseover',
			    src = e.target || e.srcElement,
			    dragging = false;
	
			while (src) {
				target = this._targets[stamp(src)];
				if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
					// Prevent firing click after you just dragged an object.
					dragging = true;
					break;
				}
				if (target && target.listens(type, true)) {
					if (isHover && !isExternalTarget(src, e)) { break; }
					targets.push(target);
					if (isHover) { break; }
				}
				if (src === this._container) { break; }
				src = src.parentNode;
			}
			if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
				targets = [this];
			}
			return targets;
		},
	
		_handleDOMEvent: function (e) {
			if (!this._loaded || skipped(e)) { return; }
	
			var type = e.type;
	
			if (type === 'mousedown' || type === 'keypress') {
				// prevents outline when clicking on keyboard-focusable element
				preventOutline(e.target || e.srcElement);
			}
	
			this._fireDOMEvent(e, type);
		},
	
		_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],
	
		_fireDOMEvent: function (e, type, targets) {
	
			if (e.type === 'click') {
				// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
				// @event preclick: MouseEvent
				// Fired before mouse click on the map (sometimes useful when you
				// want something to happen on click before any existing click
				// handlers start running).
				var synth = extend({}, e);
				synth.type = 'preclick';
				this._fireDOMEvent(synth, synth.type, targets);
			}
	
			if (e._stopped) { return; }
	
			// Find the layer the event is propagating from and its parents.
			targets = (targets || []).concat(this._findEventTargets(e, type));
	
			if (!targets.length) { return; }
	
			var target = targets[0];
			if (type === 'contextmenu' && target.listens(type, true)) {
				preventDefault(e);
			}
	
			var data = {
				originalEvent: e
			};
	
			if (e.type !== 'keypress') {
				var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
				data.containerPoint = isMarker ?
					this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
				data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
				data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
			}
	
			for (var i = 0; i < targets.length; i++) {
				targets[i].fire(type, data, true);
				if (data.originalEvent._stopped ||
					(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
			}
		},
	
		_draggableMoved: function (obj) {
			obj = obj.dragging && obj.dragging.enabled() ? obj : this;
			return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
		},
	
		_clearHandlers: function () {
			for (var i = 0, len = this._handlers.length; i < len; i++) {
				this._handlers[i].disable();
			}
		},
	
		// @section Other Methods
	
		// @method whenReady(fn: Function, context?: Object): this
		// Runs the given function `fn` when the map gets initialized with
		// a view (center and zoom) and at least one layer, or immediately
		// if it's already initialized, optionally passing a function context.
		whenReady: function (callback, context) {
			if (this._loaded) {
				callback.call(context || this, {target: this});
			} else {
				this.on('load', callback, context);
			}
			return this;
		},
	
	
		// private methods for getting map state
	
		_getMapPanePos: function () {
			return getPosition(this._mapPane) || new Point(0, 0);
		},
	
		_moved: function () {
			var pos = this._getMapPanePos();
			return pos && !pos.equals([0, 0]);
		},
	
		_getTopLeftPoint: function (center, zoom) {
			var pixelOrigin = center && zoom !== undefined ?
				this._getNewPixelOrigin(center, zoom) :
				this.getPixelOrigin();
			return pixelOrigin.subtract(this._getMapPanePos());
		},
	
		_getNewPixelOrigin: function (center, zoom) {
			var viewHalf = this.getSize()._divideBy(2);
			return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
		},
	
		_latLngToNewLayerPoint: function (latlng, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return this.project(latlng, zoom)._subtract(topLeft);
		},
	
		_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return toBounds([
				this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
			]);
		},
	
		// layer point of the current center
		_getCenterLayerPoint: function () {
			return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
		},
	
		// offset of the specified place to the current center in pixels
		_getCenterOffset: function (latlng) {
			return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
		},
	
		// adjust center for view to get inside bounds
		_limitCenter: function (center, zoom, bounds) {
	
			if (!bounds) { return center; }
	
			var centerPoint = this.project(center, zoom),
			    viewHalf = this.getSize().divideBy(2),
			    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
			    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
			// If offset is less than a pixel, ignore.
			// This prevents unstable projections from getting into
			// an infinite loop of tiny offsets.
			if (offset.round().equals([0, 0])) {
				return center;
			}
	
			return this.unproject(centerPoint.add(offset), zoom);
		},
	
		// adjust offset for view to get inside bounds
		_limitOffset: function (offset, bounds) {
			if (!bounds) { return offset; }
	
			var viewBounds = this.getPixelBounds(),
			    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
			return offset.add(this._getBoundsOffset(newBounds, bounds));
		},
	
		// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
		_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
			var projectedMaxBounds = toBounds(
			        this.project(maxBounds.getNorthEast(), zoom),
			        this.project(maxBounds.getSouthWest(), zoom)
			    ),
			    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
			    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
			    dx = this._rebound(minOffset.x, -maxOffset.x),
			    dy = this._rebound(minOffset.y, -maxOffset.y);
	
			return new Point(dx, dy);
		},
	
		_rebound: function (left, right) {
			return left + right > 0 ?
				Math.round(left - right) / 2 :
				Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
		},
	
		_limitZoom: function (zoom) {
			var min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    snap = any3d ? this.options.zoomSnap : 1;
			if (snap) {
				zoom = Math.round(zoom / snap) * snap;
			}
			return Math.max(min, Math.min(max, zoom));
		},
	
		_onPanTransitionStep: function () {
			this.fire('move');
		},
	
		_onPanTransitionEnd: function () {
			removeClass(this._mapPane, 'leaflet-pan-anim');
			this.fire('moveend');
		},
	
		_tryAnimatedPan: function (center, options) {
			// difference between the new and current centers in pixels
			var offset = this._getCenterOffset(center)._trunc();
	
			// don't animate too far unless animate: true specified in options
			if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
			this.panBy(offset, options);
	
			return true;
		},
	
		_createAnimProxy: function () {
	
			var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
			this._panes.mapPane.appendChild(proxy);
	
			this.on('zoomanim', function (e) {
				var prop = TRANSFORM,
				    transform = this._proxy.style[prop];
	
				setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
				// workaround for case when transform is the same and so transitionend event is not fired
				if (transform === this._proxy.style[prop] && this._animatingZoom) {
					this._onZoomTransitionEnd();
				}
			}, this);
	
			this.on('load moveend', function () {
				var c = this.getCenter(),
				    z = this.getZoom();
				setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
			}, this);
	
			this._on('unload', this._destroyAnimProxy, this);
		},
	
		_destroyAnimProxy: function () {
			remove(this._proxy);
			delete this._proxy;
		},
	
		_catchTransitionEnd: function (e) {
			if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
				this._onZoomTransitionEnd();
			}
		},
	
		_nothingToAnimate: function () {
			return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
		},
	
		_tryAnimatedZoom: function (center, zoom, options) {
	
			if (this._animatingZoom) { return true; }
	
			options = options || {};
	
			// don't animate if disabled, not supported or zoom difference is too large
			if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
			        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
			// offset is the pixel coords of the zoom origin relative to the current center
			var scale = this.getZoomScale(zoom),
			    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
			// don't animate if the zoom origin isn't within one screen from the current center, unless forced
			if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
			requestAnimFrame(function () {
				this
				    ._moveStart(true, false)
				    ._animateZoom(center, zoom, true);
			}, this);
	
			return true;
		},
	
		_animateZoom: function (center, zoom, startAnim, noUpdate) {
			if (!this._mapPane) { return; }
	
			if (startAnim) {
				this._animatingZoom = true;
	
				// remember what center/zoom to set after animation
				this._animateToCenter = center;
				this._animateToZoom = zoom;
	
				addClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			// @event zoomanim: ZoomAnimEvent
			// Fired on every frame of a zoom animation
			this.fire('zoomanim', {
				center: center,
				zoom: zoom,
				noUpdate: noUpdate
			});
	
			// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
			setTimeout(bind(this._onZoomTransitionEnd, this), 250);
		},
	
		_onZoomTransitionEnd: function () {
			if (!this._animatingZoom) { return; }
	
			if (this._mapPane) {
				removeClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			this._animatingZoom = false;
	
			this._move(this._animateToCenter, this._animateToZoom);
	
			// This anim frame should prevent an obscure iOS webkit tile loading race condition.
			requestAnimFrame(function () {
				this._moveEnd(true);
			}, this);
		}
	});
	
	// @section
	
	// @factory L.map(id: String, options?: Map options)
	// Instantiates a map object given the DOM ID of a `<div>` element
	// and optionally an object literal with `Map options`.
	//
	// @alternative
	// @factory L.map(el: HTMLElement, options?: Map options)
	// Instantiates a map object given an instance of a `<div>` HTML element
	// and optionally an object literal with `Map options`.
	function createMap(id, options) {
		return new Map(id, options);
	}
	
	/*
	 * @class Control
	 * @aka L.Control
	 * @inherits Class
	 *
	 * L.Control is a base class for implementing map controls. Handles positioning.
	 * All other controls extend from this class.
	 */
	
	var Control = Class.extend({
		// @section
		// @aka Control options
		options: {
			// @option position: String = 'topright'
			// The position of the control (one of the map corners). Possible values are `'topleft'`,
			// `'topright'`, `'bottomleft'` or `'bottomright'`
			position: 'topright'
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		/* @section
		 * Classes extending L.Control will inherit the following methods:
		 *
		 * @method getPosition: string
		 * Returns the position of the control.
		 */
		getPosition: function () {
			return this.options.position;
		},
	
		// @method setPosition(position: string): this
		// Sets the position of the control.
		setPosition: function (position) {
			var map = this._map;
	
			if (map) {
				map.removeControl(this);
			}
	
			this.options.position = position;
	
			if (map) {
				map.addControl(this);
			}
	
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTMLElement that contains the control.
		getContainer: function () {
			return this._container;
		},
	
		// @method addTo(map: Map): this
		// Adds the control to the given map.
		addTo: function (map) {
			this.remove();
			this._map = map;
	
			var container = this._container = this.onAdd(map),
			    pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			addClass(container, 'leaflet-control');
	
			if (pos.indexOf('bottom') !== -1) {
				corner.insertBefore(container, corner.firstChild);
			} else {
				corner.appendChild(container);
			}
	
			return this;
		},
	
		// @method remove: this
		// Removes the control from the map it is currently active on.
		remove: function () {
			if (!this._map) {
				return this;
			}
	
			remove(this._container);
	
			if (this.onRemove) {
				this.onRemove(this._map);
			}
	
			this._map = null;
	
			return this;
		},
	
		_refocusOnMap: function (e) {
			// if map exists and event is not a keyboard event
			if (this._map && e && e.screenX > 0 && e.screenY > 0) {
				this._map.getContainer().focus();
			}
		}
	});
	
	var control = function (options) {
		return new Control(options);
	};
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every control should extend from `L.Control` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): HTMLElement
	 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	 *
	 * @method onRemove(map: Map)
	 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	 */
	
	/* @namespace Map
	 * @section Methods for Layers and Controls
	 */
	Map.include({
		// @method addControl(control: Control): this
		// Adds the given control to the map
		addControl: function (control) {
			control.addTo(this);
			return this;
		},
	
		// @method removeControl(control: Control): this
		// Removes the given control from the map
		removeControl: function (control) {
			control.remove();
			return this;
		},
	
		_initControlPos: function () {
			var corners = this._controlCorners = {},
			    l = 'leaflet-',
			    container = this._controlContainer =
			            create$1('div', l + 'control-container', this._container);
	
			function createCorner(vSide, hSide) {
				var className = l + vSide + ' ' + l + hSide;
	
				corners[vSide + hSide] = create$1('div', className, container);
			}
	
			createCorner('top', 'left');
			createCorner('top', 'right');
			createCorner('bottom', 'left');
			createCorner('bottom', 'right');
		},
	
		_clearControlPos: function () {
			for (var i in this._controlCorners) {
				remove(this._controlCorners[i]);
			}
			remove(this._controlContainer);
			delete this._controlCorners;
			delete this._controlContainer;
		}
	});
	
	/*
	 * @class Control.Layers
	 * @aka L.Control.Layers
	 * @inherits Control
	 *
	 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * var baseLayers = {
	 * 	"Mapbox": mapbox,
	 * 	"OpenStreetMap": osm
	 * };
	 *
	 * var overlays = {
	 * 	"Marker": marker,
	 * 	"Roads": roadsLayer
	 * };
	 *
	 * L.control.layers(baseLayers, overlays).addTo(map);
	 * ```
	 *
	 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	 *
	 * ```js
	 * {
	 *     "<someName1>": layer1,
	 *     "<someName2>": layer2
	 * }
	 * ```
	 *
	 * The layer names can contain HTML, which allows you to add additional styling to the items:
	 *
	 * ```js
	 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	 * ```
	 */
	
	var Layers = Control.extend({
		// @section
		// @aka Control.Layers options
		options: {
			// @option collapsed: Boolean = true
			// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
			collapsed: true,
			position: 'topright',
	
			// @option autoZIndex: Boolean = true
			// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
			autoZIndex: true,
	
			// @option hideSingleBase: Boolean = false
			// If `true`, the base layers in the control will be hidden when there is only one.
			hideSingleBase: false,
	
			// @option sortLayers: Boolean = false
			// Whether to sort the layers. When `false`, layers will keep the order
			// in which they were added to the control.
			sortLayers: false,
	
			// @option sortFunction: Function = *
			// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
			// that will be used for sorting the layers, when `sortLayers` is `true`.
			// The function receives both the `L.Layer` instances and their names, as in
			// `sortFunction(layerA, layerB, nameA, nameB)`.
			// By default, it sorts layers alphabetically by their name.
			sortFunction: function (layerA, layerB, nameA, nameB) {
				return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
			}
		},
	
		initialize: function (baseLayers, overlays, options) {
			setOptions(this, options);
	
			this._layerControlInputs = [];
			this._layers = [];
			this._lastZIndex = 0;
			this._handlingClick = false;
	
			for (var i in baseLayers) {
				this._addLayer(baseLayers[i], i);
			}
	
			for (i in overlays) {
				this._addLayer(overlays[i], i, true);
			}
		},
	
		onAdd: function (map) {
			this._initLayout();
			this._update();
	
			this._map = map;
			map.on('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.on('add remove', this._onLayerChange, this);
			}
	
			return this._container;
		},
	
		addTo: function (map) {
			Control.prototype.addTo.call(this, map);
			// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
			return this._expandIfNotCollapsed();
		},
	
		onRemove: function () {
			this._map.off('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.off('add remove', this._onLayerChange, this);
			}
		},
	
		// @method addBaseLayer(layer: Layer, name: String): this
		// Adds a base layer (radio button entry) with the given name to the control.
		addBaseLayer: function (layer, name) {
			this._addLayer(layer, name);
			return (this._map) ? this._update() : this;
		},
	
		// @method addOverlay(layer: Layer, name: String): this
		// Adds an overlay (checkbox entry) with the given name to the control.
		addOverlay: function (layer, name) {
			this._addLayer(layer, name, true);
			return (this._map) ? this._update() : this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Remove the given layer from the control.
		removeLayer: function (layer) {
			layer.off('add remove', this._onLayerChange, this);
	
			var obj = this._getLayer(stamp(layer));
			if (obj) {
				this._layers.splice(this._layers.indexOf(obj), 1);
			}
			return (this._map) ? this._update() : this;
		},
	
		// @method expand(): this
		// Expand the control container if collapsed.
		expand: function () {
			addClass(this._container, 'leaflet-control-layers-expanded');
			this._form.style.height = null;
			var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
			if (acceptableHeight < this._form.clientHeight) {
				addClass(this._form, 'leaflet-control-layers-scrollbar');
				this._form.style.height = acceptableHeight + 'px';
			} else {
				removeClass(this._form, 'leaflet-control-layers-scrollbar');
			}
			this._checkDisabledLayers();
			return this;
		},
	
		// @method collapse(): this
		// Collapse the control container if expanded.
		collapse: function () {
			removeClass(this._container, 'leaflet-control-layers-expanded');
			return this;
		},
	
		_initLayout: function () {
			var className = 'leaflet-control-layers',
			    container = this._container = create$1('div', className),
			    collapsed = this.options.collapsed;
	
			// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
			container.setAttribute('aria-haspopup', true);
	
			disableClickPropagation(container);
			disableScrollPropagation(container);
	
			var form = this._form = create$1('form', className + '-list');
	
			if (collapsed) {
				this._map.on('click', this.collapse, this);
	
				if (!android) {
					on(container, {
						mouseenter: this.expand,
						mouseleave: this.collapse
					}, this);
				}
			}
	
			var link = this._layersLink = create$1('a', className + '-toggle', container);
			link.href = '#';
			link.title = 'Layers';
	
			if (touch) {
				on(link, 'click', stop);
				on(link, 'click', this.expand, this);
			} else {
				on(link, 'focus', this.expand, this);
			}
	
			if (!collapsed) {
				this.expand();
			}
	
			this._baseLayersList = create$1('div', className + '-base', form);
			this._separator = create$1('div', className + '-separator', form);
			this._overlaysList = create$1('div', className + '-overlays', form);
	
			container.appendChild(form);
		},
	
		_getLayer: function (id) {
			for (var i = 0; i < this._layers.length; i++) {
	
				if (this._layers[i] && stamp(this._layers[i].layer) === id) {
					return this._layers[i];
				}
			}
		},
	
		_addLayer: function (layer, name, overlay) {
			if (this._map) {
				layer.on('add remove', this._onLayerChange, this);
			}
	
			this._layers.push({
				layer: layer,
				name: name,
				overlay: overlay
			});
	
			if (this.options.sortLayers) {
				this._layers.sort(bind(function (a, b) {
					return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
				}, this));
			}
	
			if (this.options.autoZIndex && layer.setZIndex) {
				this._lastZIndex++;
				layer.setZIndex(this._lastZIndex);
			}
	
			this._expandIfNotCollapsed();
		},
	
		_update: function () {
			if (!this._container) { return this; }
	
			empty(this._baseLayersList);
			empty(this._overlaysList);
	
			this._layerControlInputs = [];
			var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
			for (i = 0; i < this._layers.length; i++) {
				obj = this._layers[i];
				this._addItem(obj);
				overlaysPresent = overlaysPresent || obj.overlay;
				baseLayersPresent = baseLayersPresent || !obj.overlay;
				baseLayersCount += !obj.overlay ? 1 : 0;
			}
	
			// Hide base layers section if there's only one layer.
			if (this.options.hideSingleBase) {
				baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
				this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
			}
	
			this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
			return this;
		},
	
		_onLayerChange: function (e) {
			if (!this._handlingClick) {
				this._update();
			}
	
			var obj = this._getLayer(stamp(e.target));
	
			// @namespace Map
			// @section Layer events
			// @event baselayerchange: LayersControlEvent
			// Fired when the base layer is changed through the [layer control](#control-layers).
			// @event overlayadd: LayersControlEvent
			// Fired when an overlay is selected through the [layer control](#control-layers).
			// @event overlayremove: LayersControlEvent
			// Fired when an overlay is deselected through the [layer control](#control-layers).
			// @namespace Control.Layers
			var type = obj.overlay ?
				(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
				(e.type === 'add' ? 'baselayerchange' : null);
	
			if (type) {
				this._map.fire(type, obj);
			}
		},
	
		// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
		_createRadioElement: function (name, checked) {
	
			var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
					name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
			var radioFragment = document.createElement('div');
			radioFragment.innerHTML = radioHtml;
	
			return radioFragment.firstChild;
		},
	
		_addItem: function (obj) {
			var label = document.createElement('label'),
			    checked = this._map.hasLayer(obj.layer),
			    input;
	
			if (obj.overlay) {
				input = document.createElement('input');
				input.type = 'checkbox';
				input.className = 'leaflet-control-layers-selector';
				input.defaultChecked = checked;
			} else {
				input = this._createRadioElement('leaflet-base-layers', checked);
			}
	
			this._layerControlInputs.push(input);
			input.layerId = stamp(obj.layer);
	
			on(input, 'click', this._onInputClick, this);
	
			var name = document.createElement('span');
			name.innerHTML = ' ' + obj.name;
	
			// Helps from preventing layer control flicker when checkboxes are disabled
			// https://github.com/Leaflet/Leaflet/issues/2771
			var holder = document.createElement('div');
	
			label.appendChild(holder);
			holder.appendChild(input);
			holder.appendChild(name);
	
			var container = obj.overlay ? this._overlaysList : this._baseLayersList;
			container.appendChild(label);
	
			this._checkDisabledLayers();
			return label;
		},
	
		_onInputClick: function () {
			var inputs = this._layerControlInputs,
			    input, layer;
			var addedLayers = [],
			    removedLayers = [];
	
			this._handlingClick = true;
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
	
				if (input.checked) {
					addedLayers.push(layer);
				} else if (!input.checked) {
					removedLayers.push(layer);
				}
			}
	
			// Bugfix issue 2318: Should remove all old layers before readding new ones
			for (i = 0; i < removedLayers.length; i++) {
				if (this._map.hasLayer(removedLayers[i])) {
					this._map.removeLayer(removedLayers[i]);
				}
			}
			for (i = 0; i < addedLayers.length; i++) {
				if (!this._map.hasLayer(addedLayers[i])) {
					this._map.addLayer(addedLayers[i]);
				}
			}
	
			this._handlingClick = false;
	
			this._refocusOnMap();
		},
	
		_checkDisabledLayers: function () {
			var inputs = this._layerControlInputs,
			    input,
			    layer,
			    zoom = this._map.getZoom();
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
				                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
			}
		},
	
		_expandIfNotCollapsed: function () {
			if (this._map && !this.options.collapsed) {
				this.expand();
			}
			return this;
		},
	
		_expand: function () {
			// Backward compatibility, remove me in 1.1.
			return this.expand();
		},
	
		_collapse: function () {
			// Backward compatibility, remove me in 1.1.
			return this.collapse();
		}
	
	});
	
	
	// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	var layers = function (baseLayers, overlays, options) {
		return new Layers(baseLayers, overlays, options);
	};
	
	/*
	 * @class Control.Zoom
	 * @aka L.Control.Zoom
	 * @inherits Control
	 *
	 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	 */
	
	var Zoom = Control.extend({
		// @section
		// @aka Control.Zoom options
		options: {
			position: 'topleft',
	
			// @option zoomInText: String = '+'
			// The text set on the 'zoom in' button.
			zoomInText: '+',
	
			// @option zoomInTitle: String = 'Zoom in'
			// The title set on the 'zoom in' button.
			zoomInTitle: 'Zoom in',
	
			// @option zoomOutText: String = '&#x2212;'
			// The text set on the 'zoom out' button.
			zoomOutText: '&#x2212;',
	
			// @option zoomOutTitle: String = 'Zoom out'
			// The title set on the 'zoom out' button.
			zoomOutTitle: 'Zoom out'
		},
	
		onAdd: function (map) {
			var zoomName = 'leaflet-control-zoom',
			    container = create$1('div', zoomName + ' leaflet-bar'),
			    options = this.options;
	
			this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
			        zoomName + '-in',  container, this._zoomIn);
			this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
			        zoomName + '-out', container, this._zoomOut);
	
			this._updateDisabled();
			map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off('zoomend zoomlevelschange', this._updateDisabled, this);
		},
	
		disable: function () {
			this._disabled = true;
			this._updateDisabled();
			return this;
		},
	
		enable: function () {
			this._disabled = false;
			this._updateDisabled();
			return this;
		},
	
		_zoomIn: function (e) {
			if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
				this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_zoomOut: function (e) {
			if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
				this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_createButton: function (html, title, className, container, fn) {
			var link = create$1('a', className, container);
			link.innerHTML = html;
			link.href = '#';
			link.title = title;
	
			/*
			 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
			 */
			link.setAttribute('role', 'button');
			link.setAttribute('aria-label', title);
	
			disableClickPropagation(link);
			on(link, 'click', stop);
			on(link, 'click', fn, this);
			on(link, 'click', this._refocusOnMap, this);
	
			return link;
		},
	
		_updateDisabled: function () {
			var map = this._map,
			    className = 'leaflet-disabled';
	
			removeClass(this._zoomInButton, className);
			removeClass(this._zoomOutButton, className);
	
			if (this._disabled || map._zoom === map.getMinZoom()) {
				addClass(this._zoomOutButton, className);
			}
			if (this._disabled || map._zoom === map.getMaxZoom()) {
				addClass(this._zoomInButton, className);
			}
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option zoomControl: Boolean = true
	// Whether a [zoom control](#control-zoom) is added to the map by default.
	Map.mergeOptions({
		zoomControl: true
	});
	
	Map.addInitHook(function () {
		if (this.options.zoomControl) {
			// @section Controls
			// @property zoomControl: Control.Zoom
			// The default zoom control (only available if the
			// [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
			this.zoomControl = new Zoom();
			this.addControl(this.zoomControl);
		}
	});
	
	// @namespace Control.Zoom
	// @factory L.control.zoom(options: Control.Zoom options)
	// Creates a zoom control
	var zoom = function (options) {
		return new Zoom(options);
	};
	
	/*
	 * @class Control.Scale
	 * @aka L.Control.Scale
	 * @inherits Control
	 *
	 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * L.control.scale().addTo(map);
	 * ```
	 */
	
	var Scale = Control.extend({
		// @section
		// @aka Control.Scale options
		options: {
			position: 'bottomleft',
	
			// @option maxWidth: Number = 100
			// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
			maxWidth: 100,
	
			// @option metric: Boolean = True
			// Whether to show the metric scale line (m/km).
			metric: true,
	
			// @option imperial: Boolean = True
			// Whether to show the imperial scale line (mi/ft).
			imperial: true
	
			// @option updateWhenIdle: Boolean = false
			// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
		},
	
		onAdd: function (map) {
			var className = 'leaflet-control-scale',
			    container = create$1('div', className),
			    options = this.options;
	
			this._addScales(options, className + '-line', container);
	
			map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
			map.whenReady(this._update, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		},
	
		_addScales: function (options, className, container) {
			if (options.metric) {
				this._mScale = create$1('div', className, container);
			}
			if (options.imperial) {
				this._iScale = create$1('div', className, container);
			}
		},
	
		_update: function () {
			var map = this._map,
			    y = map.getSize().y / 2;
	
			var maxMeters = map.distance(
				map.containerPointToLatLng([0, y]),
				map.containerPointToLatLng([this.options.maxWidth, y]));
	
			this._updateScales(maxMeters);
		},
	
		_updateScales: function (maxMeters) {
			if (this.options.metric && maxMeters) {
				this._updateMetric(maxMeters);
			}
			if (this.options.imperial && maxMeters) {
				this._updateImperial(maxMeters);
			}
		},
	
		_updateMetric: function (maxMeters) {
			var meters = this._getRoundNum(maxMeters),
			    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
			this._updateScale(this._mScale, label, meters / maxMeters);
		},
	
		_updateImperial: function (maxMeters) {
			var maxFeet = maxMeters * 3.2808399,
			    maxMiles, miles, feet;
	
			if (maxFeet > 5280) {
				maxMiles = maxFeet / 5280;
				miles = this._getRoundNum(maxMiles);
				this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
			} else {
				feet = this._getRoundNum(maxFeet);
				this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
			}
		},
	
		_updateScale: function (scale, text, ratio) {
			scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
			scale.innerHTML = text;
		},
	
		_getRoundNum: function (num) {
			var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
			    d = num / pow10;
	
			d = d >= 10 ? 10 :
			    d >= 5 ? 5 :
			    d >= 3 ? 3 :
			    d >= 2 ? 2 : 1;
	
			return pow10 * d;
		}
	});
	
	
	// @factory L.control.scale(options?: Control.Scale options)
	// Creates an scale control with the given options.
	var scale = function (options) {
		return new Scale(options);
	};
	
	/*
	 * @class Control.Attribution
	 * @aka L.Control.Attribution
	 * @inherits Control
	 *
	 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	 */
	
	var Attribution = Control.extend({
		// @section
		// @aka Control.Attribution options
		options: {
			position: 'bottomright',
	
			// @option prefix: String = 'Leaflet'
			// The HTML text shown before the attributions. Pass `false` to disable.
			prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
		},
	
		initialize: function (options) {
			setOptions(this, options);
	
			this._attributions = {};
		},
	
		onAdd: function (map) {
			map.attributionControl = this;
			this._container = create$1('div', 'leaflet-control-attribution');
			disableClickPropagation(this._container);
	
			// TODO ugly, refactor
			for (var i in map._layers) {
				if (map._layers[i].getAttribution) {
					this.addAttribution(map._layers[i].getAttribution());
				}
			}
	
			this._update();
	
			return this._container;
		},
	
		// @method setPrefix(prefix: String): this
		// Sets the text before the attributions.
		setPrefix: function (prefix) {
			this.options.prefix = prefix;
			this._update();
			return this;
		},
	
		// @method addAttribution(text: String): this
		// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
		addAttribution: function (text) {
			if (!text) { return this; }
	
			if (!this._attributions[text]) {
				this._attributions[text] = 0;
			}
			this._attributions[text]++;
	
			this._update();
	
			return this;
		},
	
		// @method removeAttribution(text: String): this
		// Removes an attribution text.
		removeAttribution: function (text) {
			if (!text) { return this; }
	
			if (this._attributions[text]) {
				this._attributions[text]--;
				this._update();
			}
	
			return this;
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			var attribs = [];
	
			for (var i in this._attributions) {
				if (this._attributions[i]) {
					attribs.push(i);
				}
			}
	
			var prefixAndAttribs = [];
	
			if (this.options.prefix) {
				prefixAndAttribs.push(this.options.prefix);
			}
			if (attribs.length) {
				prefixAndAttribs.push(attribs.join(', '));
			}
	
			this._container.innerHTML = prefixAndAttribs.join(' | ');
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option attributionControl: Boolean = true
	// Whether a [attribution control](#control-attribution) is added to the map by default.
	Map.mergeOptions({
		attributionControl: true
	});
	
	Map.addInitHook(function () {
		if (this.options.attributionControl) {
			new Attribution().addTo(this);
		}
	});
	
	// @namespace Control.Attribution
	// @factory L.control.attribution(options: Control.Attribution options)
	// Creates an attribution control.
	var attribution = function (options) {
		return new Attribution(options);
	};
	
	Control.Layers = Layers;
	Control.Zoom = Zoom;
	Control.Scale = Scale;
	Control.Attribution = Attribution;
	
	control.layers = layers;
	control.zoom = zoom;
	control.scale = scale;
	control.attribution = attribution;
	
	/*
		L.Handler is a base class for handler classes that are used internally to inject
		interaction features like dragging to classes like Map and Marker.
	*/
	
	// @class Handler
	// @aka L.Handler
	// Abstract class for map interaction handlers
	
	var Handler = Class.extend({
		initialize: function (map) {
			this._map = map;
		},
	
		// @method enable(): this
		// Enables the handler
		enable: function () {
			if (this._enabled) { return this; }
	
			this._enabled = true;
			this.addHooks();
			return this;
		},
	
		// @method disable(): this
		// Disables the handler
		disable: function () {
			if (!this._enabled) { return this; }
	
			this._enabled = false;
			this.removeHooks();
			return this;
		},
	
		// @method enabled(): Boolean
		// Returns `true` if the handler is enabled
		enabled: function () {
			return !!this._enabled;
		}
	
		// @section Extension methods
		// Classes inheriting from `Handler` must implement the two following methods:
		// @method addHooks()
		// Called when the handler is enabled, should add event hooks.
		// @method removeHooks()
		// Called when the handler is disabled, should remove the event hooks added previously.
	});
	
	// @section There is static function which can be called without instantiating L.Handler:
	// @function addTo(map: Map, name: String): this
	// Adds a new Handler to the given map with the given name.
	Handler.addTo = function (map, name) {
		map.addHandler(name, this);
		return this;
	};
	
	var Mixin = {Events: Events};
	
	/*
	 * @class Draggable
	 * @aka L.Draggable
	 * @inherits Evented
	 *
	 * A class for making DOM elements draggable (including touch support).
	 * Used internally for map and marker dragging. Only works for elements
	 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	 *
	 * @example
	 * ```js
	 * var draggable = new L.Draggable(elementToDrag);
	 * draggable.enable();
	 * ```
	 */
	
	var START = touch ? 'touchstart mousedown' : 'mousedown';
	var END = {
		mousedown: 'mouseup',
		touchstart: 'touchend',
		pointerdown: 'touchend',
		MSPointerDown: 'touchend'
	};
	var MOVE = {
		mousedown: 'mousemove',
		touchstart: 'touchmove',
		pointerdown: 'touchmove',
		MSPointerDown: 'touchmove'
	};
	
	
	var Draggable = Evented.extend({
	
		options: {
			// @section
			// @aka Draggable options
			// @option clickTolerance: Number = 3
			// The max number of pixels a user can shift the mouse pointer during a click
			// for it to be considered a valid click (as opposed to a mouse drag).
			clickTolerance: 3
		},
	
		// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
		// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
		initialize: function (element, dragStartTarget, preventOutline$$1, options) {
			setOptions(this, options);
	
			this._element = element;
			this._dragStartTarget = dragStartTarget || element;
			this._preventOutline = preventOutline$$1;
		},
	
		// @method enable()
		// Enables the dragging ability
		enable: function () {
			if (this._enabled) { return; }
	
			on(this._dragStartTarget, START, this._onDown, this);
	
			this._enabled = true;
		},
	
		// @method disable()
		// Disables the dragging ability
		disable: function () {
			if (!this._enabled) { return; }
	
			// If we're currently dragging this draggable,
			// disabling it counts as first ending the drag.
			if (Draggable._dragging === this) {
				this.finishDrag();
			}
	
			off(this._dragStartTarget, START, this._onDown, this);
	
			this._enabled = false;
			this._moved = false;
		},
	
		_onDown: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			this._moved = false;
	
			if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
			if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
			Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
			if (this._preventOutline) {
				preventOutline(this._element);
			}
	
			disableImageDrag();
			disableTextSelection();
	
			if (this._moving) { return; }
	
			// @event down: Event
			// Fired when a drag is about to start.
			this.fire('down');
	
			var first = e.touches ? e.touches[0] : e,
			    sizedParent = getSizedParentNode(this._element);
	
			this._startPoint = new Point(first.clientX, first.clientY);
	
			// Cache the scale, so that we can continuously compensate for it during drag (_onMove).
			this._parentScale = getScale(sizedParent);
	
			on(document, MOVE[e.type], this._onMove, this);
			on(document, END[e.type], this._onUp, this);
		},
	
		_onMove: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			if (e.touches && e.touches.length > 1) {
				this._moved = true;
				return;
			}
	
			var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
			    offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
	
			if (!offset.x && !offset.y) { return; }
			if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
			// We assume that the parent container's position, border and scale do not change for the duration of the drag.
			// Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
			// and we can use the cached value for the scale.
			offset.x /= this._parentScale.x;
			offset.y /= this._parentScale.y;
	
			preventDefault(e);
	
			if (!this._moved) {
				// @event dragstart: Event
				// Fired when a drag starts
				this.fire('dragstart');
	
				this._moved = true;
				this._startPos = getPosition(this._element).subtract(offset);
	
				addClass(document.body, 'leaflet-dragging');
	
				this._lastTarget = e.target || e.srcElement;
				// IE and Edge do not give the <use> element, so fetch it
				// if necessary
				if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
					this._lastTarget = this._lastTarget.correspondingUseElement;
				}
				addClass(this._lastTarget, 'leaflet-drag-target');
			}
	
			this._newPos = this._startPos.add(offset);
			this._moving = true;
	
			cancelAnimFrame(this._animRequest);
			this._lastEvent = e;
			this._animRequest = requestAnimFrame(this._updatePosition, this, true);
		},
	
		_updatePosition: function () {
			var e = {originalEvent: this._lastEvent};
	
			// @event predrag: Event
			// Fired continuously during dragging *before* each corresponding
			// update of the element's position.
			this.fire('predrag', e);
			setPosition(this._element, this._newPos);
	
			// @event drag: Event
			// Fired continuously during dragging.
			this.fire('drag', e);
		},
	
		_onUp: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
			this.finishDrag();
		},
	
		finishDrag: function () {
			removeClass(document.body, 'leaflet-dragging');
	
			if (this._lastTarget) {
				removeClass(this._lastTarget, 'leaflet-drag-target');
				this._lastTarget = null;
			}
	
			for (var i in MOVE) {
				off(document, MOVE[i], this._onMove, this);
				off(document, END[i], this._onUp, this);
			}
	
			enableImageDrag();
			enableTextSelection();
	
			if (this._moved && this._moving) {
				// ensure drag is not fired after dragend
				cancelAnimFrame(this._animRequest);
	
				// @event dragend: DragEndEvent
				// Fired when the drag ends.
				this.fire('dragend', {
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
	
			this._moving = false;
			Draggable._dragging = false;
		}
	
	});
	
	/*
	 * @namespace LineUtil
	 *
	 * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
	 */
	
	// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	// Improves rendering performance dramatically by lessening the number of points to draw.
	
	// @function simplify(points: Point[], tolerance: Number): Point[]
	// Dramatically reduces the number of points in a polyline while retaining
	// its shape and returns a new array of simplified points, using the
	// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
	// Used for a huge performance boost when processing/displaying Leaflet polylines for
	// each zoom level and also reducing visual noise. tolerance affects the amount of
	// simplification (lesser value means higher quality but slower and with more points).
	// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
	function simplify(points, tolerance) {
		if (!tolerance || !points.length) {
			return points.slice();
		}
	
		var sqTolerance = tolerance * tolerance;
	
		    // stage 1: vertex reduction
		    points = _reducePoints(points, sqTolerance);
	
		    // stage 2: Douglas-Peucker simplification
		    points = _simplifyDP(points, sqTolerance);
	
		return points;
	}
	
	// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	// Returns the distance between point `p` and segment `p1` to `p2`.
	function pointToSegmentDistance(p, p1, p2) {
		return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
	}
	
	// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	// Returns the closest point from a point `p` on a segment `p1` to `p2`.
	function closestPointOnSegment(p, p1, p2) {
		return _sqClosestPointOnSegment(p, p1, p2);
	}
	
	// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
	function _simplifyDP(points, sqTolerance) {
	
		var len = points.length,
		    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
		    markers = new ArrayConstructor(len);
	
		    markers[0] = markers[len - 1] = 1;
	
		_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
		var i,
		    newPoints = [];
	
		for (i = 0; i < len; i++) {
			if (markers[i]) {
				newPoints.push(points[i]);
			}
		}
	
		return newPoints;
	}
	
	function _simplifyDPStep(points, markers, sqTolerance, first, last) {
	
		var maxSqDist = 0,
		index, i, sqDist;
	
		for (i = first + 1; i <= last - 1; i++) {
			sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
			if (sqDist > maxSqDist) {
				index = i;
				maxSqDist = sqDist;
			}
		}
	
		if (maxSqDist > sqTolerance) {
			markers[index] = 1;
	
			_simplifyDPStep(points, markers, sqTolerance, first, index);
			_simplifyDPStep(points, markers, sqTolerance, index, last);
		}
	}
	
	// reduce points that are too close to each other to a single point
	function _reducePoints(points, sqTolerance) {
		var reducedPoints = [points[0]];
	
		for (var i = 1, prev = 0, len = points.length; i < len; i++) {
			if (_sqDist(points[i], points[prev]) > sqTolerance) {
				reducedPoints.push(points[i]);
				prev = i;
			}
		}
		if (prev < len - 1) {
			reducedPoints.push(points[len - 1]);
		}
		return reducedPoints;
	}
	
	var _lastCode;
	
	// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	// Clips the segment a to b by rectangular bounds with the
	// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	// (modifying the segment points directly!). Used by Leaflet to only show polyline
	// points that are on the screen or near, increasing performance.
	function clipSegment(a, b, bounds, useLastCode, round) {
		var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
		    codeB = _getBitCode(b, bounds),
	
		    codeOut, p, newCode;
	
		    // save 2nd code to avoid calculating it on the next segment
		    _lastCode = codeB;
	
		while (true) {
			// if a,b is inside the clip window (trivial accept)
			if (!(codeA | codeB)) {
				return [a, b];
			}
	
			// if a,b is outside the clip window (trivial reject)
			if (codeA & codeB) {
				return false;
			}
	
			// other cases
			codeOut = codeA || codeB;
			p = _getEdgeIntersection(a, b, codeOut, bounds, round);
			newCode = _getBitCode(p, bounds);
	
			if (codeOut === codeA) {
				a = p;
				codeA = newCode;
			} else {
				b = p;
				codeB = newCode;
			}
		}
	}
	
	function _getEdgeIntersection(a, b, code, bounds, round) {
		var dx = b.x - a.x,
		    dy = b.y - a.y,
		    min = bounds.min,
		    max = bounds.max,
		    x, y;
	
		if (code & 8) { // top
			x = a.x + dx * (max.y - a.y) / dy;
			y = max.y;
	
		} else if (code & 4) { // bottom
			x = a.x + dx * (min.y - a.y) / dy;
			y = min.y;
	
		} else if (code & 2) { // right
			x = max.x;
			y = a.y + dy * (max.x - a.x) / dx;
	
		} else if (code & 1) { // left
			x = min.x;
			y = a.y + dy * (min.x - a.x) / dx;
		}
	
		return new Point(x, y, round);
	}
	
	function _getBitCode(p, bounds) {
		var code = 0;
	
		if (p.x < bounds.min.x) { // left
			code |= 1;
		} else if (p.x > bounds.max.x) { // right
			code |= 2;
		}
	
		if (p.y < bounds.min.y) { // bottom
			code |= 4;
		} else if (p.y > bounds.max.y) { // top
			code |= 8;
		}
	
		return code;
	}
	
	// square distance (to avoid unnecessary Math.sqrt calls)
	function _sqDist(p1, p2) {
		var dx = p2.x - p1.x,
		    dy = p2.y - p1.y;
		return dx * dx + dy * dy;
	}
	
	// return closest point on segment or distance to that point
	function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
		var x = p1.x,
		    y = p1.y,
		    dx = p2.x - x,
		    dy = p2.y - y,
		    dot = dx * dx + dy * dy,
		    t;
	
		if (dot > 0) {
			t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
			if (t > 1) {
				x = p2.x;
				y = p2.y;
			} else if (t > 0) {
				x += dx * t;
				y += dy * t;
			}
		}
	
		dx = p.x - x;
		dy = p.y - y;
	
		return sqDist ? dx * dx + dy * dy : new Point(x, y);
	}
	
	
	// @function isFlat(latlngs: LatLng[]): Boolean
	// Returns true if `latlngs` is a flat array, false is nested.
	function isFlat(latlngs) {
		return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	}
	
	function _flat(latlngs) {
		console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
		return isFlat(latlngs);
	}
	
	
	var LineUtil = (Object.freeze || Object)({
		simplify: simplify,
		pointToSegmentDistance: pointToSegmentDistance,
		closestPointOnSegment: closestPointOnSegment,
		clipSegment: clipSegment,
		_getEdgeIntersection: _getEdgeIntersection,
		_getBitCode: _getBitCode,
		_sqClosestPointOnSegment: _sqClosestPointOnSegment,
		isFlat: isFlat,
		_flat: _flat
	});
	
	/*
	 * @namespace PolyUtil
	 * Various utility functions for polygon geometries.
	 */
	
	/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	 * performance. Note that polygon points needs different algorithm for clipping
	 * than polyline, so there's a separate method for it.
	 */
	function clipPolygon(points, bounds, round) {
		var clippedPoints,
		    edges = [1, 4, 2, 8],
		    i, j, k,
		    a, b,
		    len, edge, p;
	
		for (i = 0, len = points.length; i < len; i++) {
			points[i]._code = _getBitCode(points[i], bounds);
		}
	
		// for each edge (left, bottom, right, top)
		for (k = 0; k < 4; k++) {
			edge = edges[k];
			clippedPoints = [];
	
			for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
				a = points[i];
				b = points[j];
	
				// if a is inside the clip window
				if (!(a._code & edge)) {
					// if b is outside the clip window (a->b goes out of screen)
					if (b._code & edge) {
						p = _getEdgeIntersection(b, a, edge, bounds, round);
						p._code = _getBitCode(p, bounds);
						clippedPoints.push(p);
					}
					clippedPoints.push(a);
	
				// else if b is inside the clip window (a->b enters the screen)
				} else if (!(b._code & edge)) {
					p = _getEdgeIntersection(b, a, edge, bounds, round);
					p._code = _getBitCode(p, bounds);
					clippedPoints.push(p);
				}
			}
			points = clippedPoints;
		}
	
		return points;
	}
	
	
	var PolyUtil = (Object.freeze || Object)({
		clipPolygon: clipPolygon
	});
	
	/*
	 * @namespace Projection
	 * @section
	 * Leaflet comes with a set of already defined Projections out of the box:
	 *
	 * @projection L.Projection.LonLat
	 *
	 * Equirectangular, or Plate Carree projection — the most simple projection,
	 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	 * `EPSG:4326` and `Simple` CRS.
	 */
	
	var LonLat = {
		project: function (latlng) {
			return new Point(latlng.lng, latlng.lat);
		},
	
		unproject: function (point) {
			return new LatLng(point.y, point.x);
		},
	
		bounds: new Bounds([-180, -90], [180, 90])
	};
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.Mercator
	 *
	 * Elliptical Mercator projection — more complex than Spherical Mercator. Takes into account that Earth is a geoid, not a perfect sphere. Used by the EPSG:3395 CRS.
	 */
	
	var Mercator = {
		R: 6378137,
		R_MINOR: 6356752.314245179,
	
		bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    r = this.R,
			    y = latlng.lat * d,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    con = e * Math.sin(y);
	
			var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
			y = -r * Math.log(Math.max(ts, 1E-10));
	
			return new Point(latlng.lng * d * r, y);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI,
			    r = this.R,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    ts = Math.exp(-point.y / r),
			    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
			for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
				con = e * Math.sin(phi);
				con = Math.pow((1 - con) / (1 + con), e / 2);
				dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
				phi += dphi;
			}
	
			return new LatLng(phi * d, point.x * d / r);
		}
	};
	
	/*
	 * @class Projection
	
	 * An object with methods for projecting geographical coordinates of the world onto
	 * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).
	
	 * @property bounds: Bounds
	 * The bounds (specified in CRS units) where the projection is valid
	
	 * @method project(latlng: LatLng): Point
	 * Projects geographical coordinates into a 2D point.
	 * Only accepts actual `L.LatLng` instances, not arrays.
	
	 * @method unproject(point: Point): LatLng
	 * The inverse of `project`. Projects a 2D point into a geographical location.
	 * Only accepts actual `L.Point` instances, not arrays.
	
	 * Note that the projection instances do not inherit from Leafet's `Class` object,
	 * and can't be instantiated. Also, new classes can't inherit from them,
	 * and methods can't be added to them with the `include` function.
	
	 */
	
	
	
	
	var index = (Object.freeze || Object)({
		LonLat: LonLat,
		Mercator: Mercator,
		SphericalMercator: SphericalMercator
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3395
	 *
	 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	 */
	var EPSG3395 = extend({}, Earth, {
		code: 'EPSG:3395',
		projection: Mercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * Mercator.R);
			return toTransformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG4326
	 *
	 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	 *
	 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	 */
	
	var EPSG4326 = extend({}, Earth, {
		code: 'EPSG:4326',
		projection: LonLat,
		transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Simple
	 *
	 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	 * axis should still be inverted (going from bottom to top). `distance()` returns
	 * simple euclidean distance.
	 */
	
	var Simple = extend({}, CRS, {
		projection: LonLat,
		transformation: toTransformation(1, 0, -1, 0),
	
		scale: function (zoom) {
			return Math.pow(2, zoom);
		},
	
		zoom: function (scale) {
			return Math.log(scale) / Math.LN2;
		},
	
		distance: function (latlng1, latlng2) {
			var dx = latlng2.lng - latlng1.lng,
			    dy = latlng2.lat - latlng1.lat;
	
			return Math.sqrt(dx * dx + dy * dy);
		},
	
		infinite: true
	});
	
	CRS.Earth = Earth;
	CRS.EPSG3395 = EPSG3395;
	CRS.EPSG3857 = EPSG3857;
	CRS.EPSG900913 = EPSG900913;
	CRS.EPSG4326 = EPSG4326;
	CRS.Simple = Simple;
	
	/*
	 * @class Layer
	 * @inherits Evented
	 * @aka L.Layer
	 * @aka ILayer
	 *
	 * A set of methods from the Layer base class that all Leaflet layers use.
	 * Inherits all methods, options and events from `L.Evented`.
	 *
	 * @example
	 *
	 * ```js
	 * var layer = L.Marker(latlng).addTo(map);
	 * layer.addTo(map);
	 * layer.remove();
	 * ```
	 *
	 * @event add: Event
	 * Fired after the layer is added to a map
	 *
	 * @event remove: Event
	 * Fired after the layer is removed from a map
	 */
	
	
	var Layer = Evented.extend({
	
		// Classes extending `L.Layer` will inherit the following options:
		options: {
			// @option pane: String = 'overlayPane'
			// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
			pane: 'overlayPane',
	
			// @option attribution: String = null
			// String to be shown in the attribution control, describes the layer data, e.g. "© Mapbox".
			attribution: null,
	
			bubblingMouseEvents: true
		},
	
		/* @section
		 * Classes extending `L.Layer` will inherit the following methods:
		 *
		 * @method addTo(map: Map|LayerGroup): this
		 * Adds the layer to the given map or layer group.
		 */
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		// @method remove: this
		// Removes the layer from the map it is currently active on.
		remove: function () {
			return this.removeFrom(this._map || this._mapToAdd);
		},
	
		// @method removeFrom(map: Map): this
		// Removes the layer from the given map
		removeFrom: function (obj) {
			if (obj) {
				obj.removeLayer(this);
			}
			return this;
		},
	
		// @method getPane(name? : String): HTMLElement
		// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
		getPane: function (name) {
			return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
		},
	
		addInteractiveTarget: function (targetEl) {
			this._map._targets[stamp(targetEl)] = this;
			return this;
		},
	
		removeInteractiveTarget: function (targetEl) {
			delete this._map._targets[stamp(targetEl)];
			return this;
		},
	
		// @method getAttribution: String
		// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
		getAttribution: function () {
			return this.options.attribution;
		},
	
		_layerAdd: function (e) {
			var map = e.target;
	
			// check in case layer gets added and then removed before the map is ready
			if (!map.hasLayer(this)) { return; }
	
			this._map = map;
			this._zoomAnimated = map._zoomAnimated;
	
			if (this.getEvents) {
				var events = this.getEvents();
				map.on(events, this);
				this.once('remove', function () {
					map.off(events, this);
				}, this);
			}
	
			this.onAdd(map);
	
			if (this.getAttribution && map.attributionControl) {
				map.attributionControl.addAttribution(this.getAttribution());
			}
	
			this.fire('add');
			map.fire('layeradd', {layer: this});
		}
	});
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): this
	 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	 *
	 * @method onRemove(map: Map): this
	 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	 *
	 * @method getEvents(): Object
	 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	 *
	 * @method getAttribution(): String
	 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	 *
	 * @method beforeAdd(map: Map): this
	 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	 */
	
	
	/* @namespace Map
	 * @section Layer events
	 *
	 * @event layeradd: LayerEvent
	 * Fired when a new layer is added to the map.
	 *
	 * @event layerremove: LayerEvent
	 * Fired when some layer is removed from the map
	 *
	 * @section Methods for Layers and Controls
	 */
	Map.include({
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the map
		addLayer: function (layer) {
			if (!layer._layerAdd) {
				throw new Error('The provided object is not a Layer.');
			}
	
			var id = stamp(layer);
			if (this._layers[id]) { return this; }
			this._layers[id] = layer;
	
			layer._mapToAdd = this;
	
			if (layer.beforeAdd) {
				layer.beforeAdd(this);
			}
	
			this.whenReady(layer._layerAdd, layer);
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the map.
		removeLayer: function (layer) {
			var id = stamp(layer);
	
			if (!this._layers[id]) { return this; }
	
			if (this._loaded) {
				layer.onRemove(this);
			}
	
			if (layer.getAttribution && this.attributionControl) {
				this.attributionControl.removeAttribution(layer.getAttribution());
			}
	
			delete this._layers[id];
	
			if (this._loaded) {
				this.fire('layerremove', {layer: layer});
				layer.fire('remove');
			}
	
			layer._map = layer._mapToAdd = null;
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the map
		hasLayer: function (layer) {
			return !!layer && (stamp(layer) in this._layers);
		},
	
		/* @method eachLayer(fn: Function, context?: Object): this
		 * Iterates over the layers of the map, optionally specifying context of the iterator function.
		 * ```
		 * map.eachLayer(function(layer){
		 *     layer.bindPopup('Hello');
		 * });
		 * ```
		 */
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		_addLayers: function (layers) {
			layers = layers ? (isArray(layers) ? layers : [layers]) : [];
	
			for (var i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		},
	
		_addZoomLimit: function (layer) {
			if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
				this._zoomBoundLayers[stamp(layer)] = layer;
				this._updateZoomLevels();
			}
		},
	
		_removeZoomLimit: function (layer) {
			var id = stamp(layer);
	
			if (this._zoomBoundLayers[id]) {
				delete this._zoomBoundLayers[id];
				this._updateZoomLevels();
			}
		},
	
		_updateZoomLevels: function () {
			var minZoom = Infinity,
			    maxZoom = -Infinity,
			    oldZoomSpan = this._getZoomSpan();
	
			for (var i in this._zoomBoundLayers) {
				var options = this._zoomBoundLayers[i].options;
	
				minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
				maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
			}
	
			this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
			this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
			// @section Map state change events
			// @event zoomlevelschange: Event
			// Fired when the number of zoomlevels on the map is changed due
			// to adding or removing a layer.
			if (oldZoomSpan !== this._getZoomSpan()) {
				this.fire('zoomlevelschange');
			}
	
			if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
				this.setZoom(this._layersMaxZoom);
			}
			if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
				this.setZoom(this._layersMinZoom);
			}
		}
	});
	
	/*
	 * @class LayerGroup
	 * @aka L.LayerGroup
	 * @inherits Layer
	 *
	 * Used to group several layers and handle them as one. If you add it to the map,
	 * any layers added or removed from the group will be added/removed on the map as
	 * well. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.layerGroup([marker1, marker2])
	 * 	.addLayer(polyline)
	 * 	.addTo(map);
	 * ```
	 */
	
	var LayerGroup = Layer.extend({
	
		initialize: function (layers, options) {
			setOptions(this, options);
	
			this._layers = {};
	
			var i, len;
	
			if (layers) {
				for (i = 0, len = layers.length; i < len; i++) {
					this.addLayer(layers[i]);
				}
			}
		},
	
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the group.
		addLayer: function (layer) {
			var id = this.getLayerId(layer);
	
			this._layers[id] = layer;
	
			if (this._map) {
				this._map.addLayer(layer);
			}
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the group.
		// @alternative
		// @method removeLayer(id: Number): this
		// Removes the layer with the given internal ID from the group.
		removeLayer: function (layer) {
			var id = layer in this._layers ? layer : this.getLayerId(layer);
	
			if (this._map && this._layers[id]) {
				this._map.removeLayer(this._layers[id]);
			}
	
			delete this._layers[id];
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the group.
		// @alternative
		// @method hasLayer(id: Number): Boolean
		// Returns `true` if the given internal ID is currently added to the group.
		hasLayer: function (layer) {
			return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
		},
	
		// @method clearLayers(): this
		// Removes all the layers from the group.
		clearLayers: function () {
			return this.eachLayer(this.removeLayer, this);
		},
	
		// @method invoke(methodName: String, …): this
		// Calls `methodName` on every layer contained in this group, passing any
		// additional parameters. Has no effect if the layers contained do not
		// implement `methodName`.
		invoke: function (methodName) {
			var args = Array.prototype.slice.call(arguments, 1),
			    i, layer;
	
			for (i in this._layers) {
				layer = this._layers[i];
	
				if (layer[methodName]) {
					layer[methodName].apply(layer, args);
				}
			}
	
			return this;
		},
	
		onAdd: function (map) {
			this.eachLayer(map.addLayer, map);
		},
	
		onRemove: function (map) {
			this.eachLayer(map.removeLayer, map);
		},
	
		// @method eachLayer(fn: Function, context?: Object): this
		// Iterates over the layers of the group, optionally specifying context of the iterator function.
		// ```js
		// group.eachLayer(function (layer) {
		// 	layer.bindPopup('Hello');
		// });
		// ```
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		// @method getLayer(id: Number): Layer
		// Returns the layer with the given internal ID.
		getLayer: function (id) {
			return this._layers[id];
		},
	
		// @method getLayers(): Layer[]
		// Returns an array of all the layers added to the group.
		getLayers: function () {
			var layers = [];
			this.eachLayer(layers.push, layers);
			return layers;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Calls `setZIndex` on every layer contained in this group, passing the z-index.
		setZIndex: function (zIndex) {
			return this.invoke('setZIndex', zIndex);
		},
	
		// @method getLayerId(layer: Layer): Number
		// Returns the internal ID for a layer
		getLayerId: function (layer) {
			return stamp(layer);
		}
	});
	
	
	// @factory L.layerGroup(layers?: Layer[], options?: Object)
	// Create a layer group, optionally given an initial set of layers and an `options` object.
	var layerGroup = function (layers, options) {
		return new LayerGroup(layers, options);
	};
	
	/*
	 * @class FeatureGroup
	 * @aka L.FeatureGroup
	 * @inherits LayerGroup
	 *
	 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	 * handler, it will handle events from any of the layers. This includes mouse events
	 * and custom events.
	 *  * Has `layeradd` and `layerremove` events
	 *
	 * @example
	 *
	 * ```js
	 * L.featureGroup([marker1, marker2, polyline])
	 * 	.bindPopup('Hello world!')
	 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	 * 	.addTo(map);
	 * ```
	 */
	
	var FeatureGroup = LayerGroup.extend({
	
		addLayer: function (layer) {
			if (this.hasLayer(layer)) {
				return this;
			}
	
			layer.addEventParent(this);
	
			LayerGroup.prototype.addLayer.call(this, layer);
	
			// @event layeradd: LayerEvent
			// Fired when a layer is added to this `FeatureGroup`
			return this.fire('layeradd', {layer: layer});
		},
	
		removeLayer: function (layer) {
			if (!this.hasLayer(layer)) {
				return this;
			}
			if (layer in this._layers) {
				layer = this._layers[layer];
			}
	
			layer.removeEventParent(this);
	
			LayerGroup.prototype.removeLayer.call(this, layer);
	
			// @event layerremove: LayerEvent
			// Fired when a layer is removed from this `FeatureGroup`
			return this.fire('layerremove', {layer: layer});
		},
	
		// @method setStyle(style: Path options): this
		// Sets the given path options to each layer of the group that has a `setStyle` method.
		setStyle: function (style) {
			return this.invoke('setStyle', style);
		},
	
		// @method bringToFront(): this
		// Brings the layer group to the top of all other layers
		bringToFront: function () {
			return this.invoke('bringToFront');
		},
	
		// @method bringToBack(): this
		// Brings the layer group to the back of all other layers
		bringToBack: function () {
			return this.invoke('bringToBack');
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
		getBounds: function () {
			var bounds = new LatLngBounds();
	
			for (var id in this._layers) {
				var layer = this._layers[id];
				bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
			}
			return bounds;
		}
	});
	
	// @factory L.featureGroup(layers: Layer[])
	// Create a feature group, optionally given an initial set of layers.
	var featureGroup = function (layers) {
		return new FeatureGroup(layers);
	};
	
	/*
	 * @class Icon
	 * @aka L.Icon
	 *
	 * Represents an icon to provide when creating a marker.
	 *
	 * @example
	 *
	 * ```js
	 * var myIcon = L.icon({
	 *     iconUrl: 'my-icon.png',
	 *     iconRetinaUrl: 'my-icon@2x.png',
	 *     iconSize: [38, 95],
	 *     iconAnchor: [22, 94],
	 *     popupAnchor: [-3, -76],
	 *     shadowUrl: 'my-icon-shadow.png',
	 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	 *     shadowSize: [68, 95],
	 *     shadowAnchor: [22, 94]
	 * });
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	 *
	 */
	
	var Icon = Class.extend({
	
		/* @section
		 * @aka Icon options
		 *
		 * @option iconUrl: String = null
		 * **(required)** The URL to the icon image (absolute or relative to your script path).
		 *
		 * @option iconRetinaUrl: String = null
		 * The URL to a retina sized version of the icon image (absolute or relative to your
		 * script path). Used for Retina screen devices.
		 *
		 * @option iconSize: Point = null
		 * Size of the icon image in pixels.
		 *
		 * @option iconAnchor: Point = null
		 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
		 * will be aligned so that this point is at the marker's geographical location. Centered
		 * by default if size is specified, also can be set in CSS with negative margins.
		 *
		 * @option popupAnchor: Point = [0, 0]
		 * The coordinates of the point from which popups will "open", relative to the icon anchor.
		 *
		 * @option tooltipAnchor: Point = [0, 0]
		 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
		 *
		 * @option shadowUrl: String = null
		 * The URL to the icon shadow image. If not specified, no shadow image will be created.
		 *
		 * @option shadowRetinaUrl: String = null
		 *
		 * @option shadowSize: Point = null
		 * Size of the shadow image in pixels.
		 *
		 * @option shadowAnchor: Point = null
		 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
		 * as iconAnchor if not specified).
		 *
		 * @option className: String = ''
		 * A custom class name to assign to both icon and shadow images. Empty by default.
		 */
	
		options: {
			popupAnchor: [0, 0],
			tooltipAnchor: [0, 0]
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		// @method createIcon(oldIcon?: HTMLElement): HTMLElement
		// Called internally when the icon has to be shown, returns a `<img>` HTML element
		// styled according to the options.
		createIcon: function (oldIcon) {
			return this._createIcon('icon', oldIcon);
		},
	
		// @method createShadow(oldIcon?: HTMLElement): HTMLElement
		// As `createIcon`, but for the shadow beneath it.
		createShadow: function (oldIcon) {
			return this._createIcon('shadow', oldIcon);
		},
	
		_createIcon: function (name, oldIcon) {
			var src = this._getIconUrl(name);
	
			if (!src) {
				if (name === 'icon') {
					throw new Error('iconUrl not set in Icon options (see the docs).');
				}
				return null;
			}
	
			var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
			this._setIconStyles(img, name);
	
			return img;
		},
	
		_setIconStyles: function (img, name) {
			var options = this.options;
			var sizeOption = options[name + 'Size'];
	
			if (typeof sizeOption === 'number') {
				sizeOption = [sizeOption, sizeOption];
			}
	
			var size = toPoint(sizeOption),
			    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
			            size && size.divideBy(2, true));
	
			img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
			if (anchor) {
				img.style.marginLeft = (-anchor.x) + 'px';
				img.style.marginTop  = (-anchor.y) + 'px';
			}
	
			if (size) {
				img.style.width  = size.x + 'px';
				img.style.height = size.y + 'px';
			}
		},
	
		_createImg: function (src, el) {
			el = el || document.createElement('img');
			el.src = src;
			return el;
		},
	
		_getIconUrl: function (name) {
			return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
		}
	});
	
	
	// @factory L.icon(options: Icon options)
	// Creates an icon instance with the given options.
	function icon(options) {
		return new Icon(options);
	}
	
	/*
	 * @miniclass Icon.Default (Icon)
	 * @aka L.Icon.Default
	 * @section
	 *
	 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	 * no icon is specified. Points to the blue marker image distributed with Leaflet
	 * releases.
	 *
	 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	 * (which is a set of `Icon options`).
	 *
	 * If you want to _completely_ replace the default icon, override the
	 * `L.Marker.prototype.options.icon` with your own icon instead.
	 */
	
	var IconDefault = Icon.extend({
	
		options: {
			iconUrl:       'marker-icon.png',
			iconRetinaUrl: 'marker-icon-2x.png',
			shadowUrl:     'marker-shadow.png',
			iconSize:    [25, 41],
			iconAnchor:  [12, 41],
			popupAnchor: [1, -34],
			tooltipAnchor: [16, -28],
			shadowSize:  [41, 41]
		},
	
		_getIconUrl: function (name) {
			if (!IconDefault.imagePath) {	// Deprecated, backwards-compatibility only
				IconDefault.imagePath = this._detectIconPath();
			}
	
			// @option imagePath: String
			// `Icon.Default` will try to auto-detect the location of the
			// blue icon images. If you are placing these images in a non-standard
			// way, set this option to point to the right path.
			return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
		},
	
		_detectIconPath: function () {
			var el = create$1('div',  'leaflet-default-icon-path', document.body);
			var path = getStyle(el, 'background-image') ||
			           getStyle(el, 'backgroundImage');	// IE8
	
			document.body.removeChild(el);
	
			if (path === null || path.indexOf('url') !== 0) {
				path = '';
			} else {
				path = path.replace(/^url\(["']?/, '').replace(/marker-icon\.png["']?\)$/, '');
			}
	
			return path;
		}
	});
	
	/*
	 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	 */
	
	
	/* @namespace Marker
	 * @section Interaction handlers
	 *
	 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	 *
	 * ```js
	 * marker.dragging.disable();
	 * ```
	 *
	 * @property dragging: Handler
	 * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
	 */
	
	var MarkerDrag = Handler.extend({
		initialize: function (marker) {
			this._marker = marker;
		},
	
		addHooks: function () {
			var icon = this._marker._icon;
	
			if (!this._draggable) {
				this._draggable = new Draggable(icon, icon, true);
			}
	
			this._draggable.on({
				dragstart: this._onDragStart,
				predrag: this._onPreDrag,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).enable();
	
			addClass(icon, 'leaflet-marker-draggable');
		},
	
		removeHooks: function () {
			this._draggable.off({
				dragstart: this._onDragStart,
				predrag: this._onPreDrag,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).disable();
	
			if (this._marker._icon) {
				removeClass(this._marker._icon, 'leaflet-marker-draggable');
			}
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_adjustPan: function (e) {
			var marker = this._marker,
			    map = marker._map,
			    speed = this._marker.options.autoPanSpeed,
			    padding = this._marker.options.autoPanPadding,
			    iconPos = getPosition(marker._icon),
			    bounds = map.getPixelBounds(),
			    origin = map.getPixelOrigin();
	
			var panBounds = toBounds(
				bounds.min._subtract(origin).add(padding),
				bounds.max._subtract(origin).subtract(padding)
			);
	
			if (!panBounds.contains(iconPos)) {
				// Compute incremental movement
				var movement = toPoint(
					(Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) -
					(Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x),
	
					(Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) -
					(Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)
				).multiplyBy(speed);
	
				map.panBy(movement, {animate: false});
	
				this._draggable._newPos._add(movement);
				this._draggable._startPos._add(movement);
	
				setPosition(marker._icon, this._draggable._newPos);
				this._onDrag(e);
	
				this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
			}
		},
	
		_onDragStart: function () {
			// @section Dragging events
			// @event dragstart: Event
			// Fired when the user starts dragging the marker.
	
			// @event movestart: Event
			// Fired when the marker starts moving (because of dragging).
	
			this._oldLatLng = this._marker.getLatLng();
			this._marker
			    .closePopup()
			    .fire('movestart')
			    .fire('dragstart');
		},
	
		_onPreDrag: function (e) {
			if (this._marker.options.autoPan) {
				cancelAnimFrame(this._panRequest);
				this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
			}
		},
	
		_onDrag: function (e) {
			var marker = this._marker,
			    shadow = marker._shadow,
			    iconPos = getPosition(marker._icon),
			    latlng = marker._map.layerPointToLatLng(iconPos);
	
			// update shadow position
			if (shadow) {
				setPosition(shadow, iconPos);
			}
	
			marker._latlng = latlng;
			e.latlng = latlng;
			e.oldLatLng = this._oldLatLng;
	
			// @event drag: Event
			// Fired repeatedly while the user drags the marker.
			marker
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onDragEnd: function (e) {
			// @event dragend: DragEndEvent
			// Fired when the user stops dragging the marker.
	
			 cancelAnimFrame(this._panRequest);
	
			// @event moveend: Event
			// Fired when the marker stops moving (because of dragging).
			delete this._oldLatLng;
			this._marker
			    .fire('moveend')
			    .fire('dragend', e);
		}
	});
	
	/*
	 * @class Marker
	 * @inherits Interactive layer
	 * @aka L.Marker
	 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.marker([50.5, 30.5]).addTo(map);
	 * ```
	 */
	
	var Marker = Layer.extend({
	
		// @section
		// @aka Marker options
		options: {
			// @option icon: Icon = *
			// Icon instance to use for rendering the marker.
			// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
			// If not specified, a common instance of `L.Icon.Default` is used.
			icon: new IconDefault(),
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option keyboard: Boolean = true
			// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
			keyboard: true,
	
			// @option title: String = ''
			// Text for the browser tooltip that appear on marker hover (no tooltip by default).
			title: '',
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the icon image (useful for accessibility).
			alt: '',
	
			// @option zIndexOffset: Number = 0
			// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
			zIndexOffset: 0,
	
			// @option opacity: Number = 1.0
			// The opacity of the marker.
			opacity: 1,
	
			// @option riseOnHover: Boolean = false
			// If `true`, the marker will get on top of others when you hover the mouse over it.
			riseOnHover: false,
	
			// @option riseOffset: Number = 250
			// The z-index offset used for the `riseOnHover` feature.
			riseOffset: 250,
	
			// @option pane: String = 'markerPane'
			// `Map pane` where the markers icon will be added.
			pane: 'markerPane',
	
			// @option bubblingMouseEvents: Boolean = false
			// When `true`, a mouse event on this marker will trigger the same event on the map
			// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
			bubblingMouseEvents: false,
	
			// @section Draggable marker options
			// @option draggable: Boolean = false
			// Whether the marker is draggable with mouse/touch or not.
			draggable: false,
	
			// @option autoPan: Boolean = false
			// Whether to pan the map when dragging this marker near its edge or not.
			autoPan: false,
	
			// @option autoPanPadding: Point = Point(50, 50)
			// Distance (in pixels to the left/right and to the top/bottom) of the
			// map edge to start panning the map.
			autoPanPadding: [50, 50],
	
			// @option autoPanSpeed: Number = 10
			// Number of pixels the map should pan by.
			autoPanSpeed: 10
		},
	
		/* @section
		 *
		 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
		 */
	
		initialize: function (latlng, options) {
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
		},
	
		onAdd: function (map) {
			this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
			if (this._zoomAnimated) {
				map.on('zoomanim', this._animateZoom, this);
			}
	
			this._initIcon();
			this.update();
		},
	
		onRemove: function (map) {
			if (this.dragging && this.dragging.enabled()) {
				this.options.draggable = true;
				this.dragging.removeHooks();
			}
			delete this.dragging;
	
			if (this._zoomAnimated) {
				map.off('zoomanim', this._animateZoom, this);
			}
	
			this._removeIcon();
			this._removeShadow();
		},
	
		getEvents: function () {
			return {
				zoom: this.update,
				viewreset: this.update
			};
		},
	
		// @method getLatLng: LatLng
		// Returns the current geographical position of the marker.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Changes the marker position to the given point.
		setLatLng: function (latlng) {
			var oldLatLng = this._latlng;
			this._latlng = toLatLng(latlng);
			this.update();
	
			// @event move: Event
			// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
			return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
		},
	
		// @method setZIndexOffset(offset: Number): this
		// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
		setZIndexOffset: function (offset) {
			this.options.zIndexOffset = offset;
			return this.update();
		},
	
		// @method setIcon(icon: Icon): this
		// Changes the marker icon.
		setIcon: function (icon) {
	
			this.options.icon = icon;
	
			if (this._map) {
				this._initIcon();
				this.update();
			}
	
			if (this._popup) {
				this.bindPopup(this._popup, this._popup.options);
			}
	
			return this;
		},
	
		getElement: function () {
			return this._icon;
		},
	
		update: function () {
	
			if (this._icon && this._map) {
				var pos = this._map.latLngToLayerPoint(this._latlng).round();
				this._setPos(pos);
			}
	
			return this;
		},
	
		_initIcon: function () {
			var options = this.options,
			    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			var icon = options.icon.createIcon(this._icon),
			    addIcon = false;
	
			// if we're not reusing the icon, remove the old one and init new one
			if (icon !== this._icon) {
				if (this._icon) {
					this._removeIcon();
				}
				addIcon = true;
	
				if (options.title) {
					icon.title = options.title;
				}
	
				if (icon.tagName === 'IMG') {
					icon.alt = options.alt || '';
				}
			}
	
			addClass(icon, classToAdd);
	
			if (options.keyboard) {
				icon.tabIndex = '0';
			}
	
			this._icon = icon;
	
			if (options.riseOnHover) {
				this.on({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			var newShadow = options.icon.createShadow(this._shadow),
			    addShadow = false;
	
			if (newShadow !== this._shadow) {
				this._removeShadow();
				addShadow = true;
			}
	
			if (newShadow) {
				addClass(newShadow, classToAdd);
				newShadow.alt = '';
			}
			this._shadow = newShadow;
	
	
			if (options.opacity < 1) {
				this._updateOpacity();
			}
	
	
			if (addIcon) {
				this.getPane().appendChild(this._icon);
			}
			this._initInteraction();
			if (newShadow && addShadow) {
				this.getPane('shadowPane').appendChild(this._shadow);
			}
		},
	
		_removeIcon: function () {
			if (this.options.riseOnHover) {
				this.off({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			remove(this._icon);
			this.removeInteractiveTarget(this._icon);
	
			this._icon = null;
		},
	
		_removeShadow: function () {
			if (this._shadow) {
				remove(this._shadow);
			}
			this._shadow = null;
		},
	
		_setPos: function (pos) {
			setPosition(this._icon, pos);
	
			if (this._shadow) {
				setPosition(this._shadow, pos);
			}
	
			this._zIndex = pos.y + this.options.zIndexOffset;
	
			this._resetZIndex();
		},
	
		_updateZIndex: function (offset) {
			this._icon.style.zIndex = this._zIndex + offset;
		},
	
		_animateZoom: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
			this._setPos(pos);
		},
	
		_initInteraction: function () {
	
			if (!this.options.interactive) { return; }
	
			addClass(this._icon, 'leaflet-interactive');
	
			this.addInteractiveTarget(this._icon);
	
			if (MarkerDrag) {
				var draggable = this.options.draggable;
				if (this.dragging) {
					draggable = this.dragging.enabled();
					this.dragging.disable();
				}
	
				this.dragging = new MarkerDrag(this);
	
				if (draggable) {
					this.dragging.enable();
				}
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the opacity of the marker.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		_updateOpacity: function () {
			var opacity = this.options.opacity;
	
			setOpacity(this._icon, opacity);
	
			if (this._shadow) {
				setOpacity(this._shadow, opacity);
			}
		},
	
		_bringToFront: function () {
			this._updateZIndex(this.options.riseOffset);
		},
	
		_resetZIndex: function () {
			this._updateZIndex(0);
		},
	
		_getPopupAnchor: function () {
			return this.options.icon.options.popupAnchor;
		},
	
		_getTooltipAnchor: function () {
			return this.options.icon.options.tooltipAnchor;
		}
	});
	
	
	// factory L.marker(latlng: LatLng, options? : Marker options)
	
	// @factory L.marker(latlng: LatLng, options? : Marker options)
	// Instantiates a Marker object given a geographical point and optionally an options object.
	function marker(latlng, options) {
		return new Marker(latlng, options);
	}
	
	/*
	 * @class Path
	 * @aka L.Path
	 * @inherits Interactive layer
	 *
	 * An abstract class that contains options and constants shared between vector
	 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	 */
	
	var Path = Layer.extend({
	
		// @section
		// @aka Path options
		options: {
			// @option stroke: Boolean = true
			// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
			stroke: true,
	
			// @option color: String = '#3388ff'
			// Stroke color
			color: '#3388ff',
	
			// @option weight: Number = 3
			// Stroke width in pixels
			weight: 3,
	
			// @option opacity: Number = 1.0
			// Stroke opacity
			opacity: 1,
	
			// @option lineCap: String= 'round'
			// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
			lineCap: 'round',
	
			// @option lineJoin: String = 'round'
			// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
			lineJoin: 'round',
	
			// @option dashArray: String = null
			// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashArray: null,
	
			// @option dashOffset: String = null
			// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashOffset: null,
	
			// @option fill: Boolean = depends
			// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
			fill: false,
	
			// @option fillColor: String = *
			// Fill color. Defaults to the value of the [`color`](#path-color) option
			fillColor: null,
	
			// @option fillOpacity: Number = 0.2
			// Fill opacity.
			fillOpacity: 0.2,
	
			// @option fillRule: String = 'evenodd'
			// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
			fillRule: 'evenodd',
	
			// className: '',
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option bubblingMouseEvents: Boolean = true
			// When `true`, a mouse event on this path will trigger the same event on the map
			// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
			bubblingMouseEvents: true
		},
	
		beforeAdd: function (map) {
			// Renderer is set here because we need to call renderer.getEvents
			// before this.getEvents.
			this._renderer = map.getRenderer(this);
		},
	
		onAdd: function () {
			this._renderer._initPath(this);
			this._reset();
			this._renderer._addPath(this);
		},
	
		onRemove: function () {
			this._renderer._removePath(this);
		},
	
		// @method redraw(): this
		// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
		redraw: function () {
			if (this._map) {
				this._renderer._updatePath(this);
			}
			return this;
		},
	
		// @method setStyle(style: Path options): this
		// Changes the appearance of a Path based on the options in the `Path options` object.
		setStyle: function (style) {
			setOptions(this, style);
			if (this._renderer) {
				this._renderer._updateStyle(this);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all path layers.
		bringToFront: function () {
			if (this._renderer) {
				this._renderer._bringToFront(this);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all path layers.
		bringToBack: function () {
			if (this._renderer) {
				this._renderer._bringToBack(this);
			}
			return this;
		},
	
		getElement: function () {
			return this._path;
		},
	
		_reset: function () {
			// defined in child classes
			this._project();
			this._update();
		},
	
		_clickTolerance: function () {
			// used when doing hit detection for Canvas layers
			return (this.options.stroke ? this.options.weight / 2 : 0) + this._renderer.options.tolerance;
		}
	});
	
	/*
	 * @class CircleMarker
	 * @aka L.CircleMarker
	 * @inherits Path
	 *
	 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	 */
	
	var CircleMarker = Path.extend({
	
		// @section
		// @aka CircleMarker options
		options: {
			fill: true,
	
			// @option radius: Number = 10
			// Radius of the circle marker, in pixels
			radius: 10
		},
	
		initialize: function (latlng, options) {
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
			this._radius = this.options.radius;
		},
	
		// @method setLatLng(latLng: LatLng): this
		// Sets the position of a circle marker to a new location.
		setLatLng: function (latlng) {
			this._latlng = toLatLng(latlng);
			this.redraw();
			return this.fire('move', {latlng: this._latlng});
		},
	
		// @method getLatLng(): LatLng
		// Returns the current geographical position of the circle marker
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle marker. Units are in pixels.
		setRadius: function (radius) {
			this.options.radius = this._radius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of the circle
		getRadius: function () {
			return this._radius;
		},
	
		setStyle : function (options) {
			var radius = options && options.radius || this._radius;
			Path.prototype.setStyle.call(this, options);
			this.setRadius(radius);
			return this;
		},
	
		_project: function () {
			this._point = this._map.latLngToLayerPoint(this._latlng);
			this._updateBounds();
		},
	
		_updateBounds: function () {
			var r = this._radius,
			    r2 = this._radiusY || r,
			    w = this._clickTolerance(),
			    p = [r + w, r2 + w];
			this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
		},
	
		_update: function () {
			if (this._map) {
				this._updatePath();
			}
		},
	
		_updatePath: function () {
			this._renderer._updateCircle(this);
		},
	
		_empty: function () {
			return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p) {
			return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
		}
	});
	
	
	// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	// Instantiates a circle marker object given a geographical point, and an optional options object.
	function circleMarker(latlng, options) {
		return new CircleMarker(latlng, options);
	}
	
	/*
	 * @class Circle
	 * @aka L.Circle
	 * @inherits CircleMarker
	 *
	 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	 *
	 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	 *
	 * @example
	 *
	 * ```js
	 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	 * ```
	 */
	
	var Circle = CircleMarker.extend({
	
		initialize: function (latlng, options, legacyOptions) {
			if (typeof options === 'number') {
				// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
				options = extend({}, legacyOptions, {radius: options});
			}
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
	
			if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
			// @section
			// @aka Circle options
			// @option radius: Number; Radius of the circle, in meters.
			this._mRadius = this.options.radius;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle. Units are in meters.
		setRadius: function (radius) {
			this._mRadius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of a circle. Units are in meters.
		getRadius: function () {
			return this._mRadius;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			var half = [this._radius, this._radiusY || this._radius];
	
			return new LatLngBounds(
				this._map.layerPointToLatLng(this._point.subtract(half)),
				this._map.layerPointToLatLng(this._point.add(half)));
		},
	
		setStyle: Path.prototype.setStyle,
	
		_project: function () {
	
			var lng = this._latlng.lng,
			    lat = this._latlng.lat,
			    map = this._map,
			    crs = map.options.crs;
	
			if (crs.distance === Earth.distance) {
				var d = Math.PI / 180,
				    latR = (this._mRadius / Earth.R) / d,
				    top = map.project([lat + latR, lng]),
				    bottom = map.project([lat - latR, lng]),
				    p = top.add(bottom).divideBy(2),
				    lat2 = map.unproject(p).lat,
				    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
				            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
				if (isNaN(lngR) || lngR === 0) {
					lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
				}
	
				this._point = p.subtract(map.getPixelOrigin());
				this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
				this._radiusY = p.y - top.y;
	
			} else {
				var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
				this._point = map.latLngToLayerPoint(this._latlng);
				this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
			}
	
			this._updateBounds();
		}
	});
	
	// @factory L.circle(latlng: LatLng, options?: Circle options)
	// Instantiates a circle object given a geographical point, and an options object
	// which contains the circle radius.
	// @alternative
	// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	// Do not use in new applications or plugins.
	function circle(latlng, options, legacyOptions) {
		return new Circle(latlng, options, legacyOptions);
	}
	
	/*
	 * @class Polyline
	 * @aka L.Polyline
	 * @inherits Path
	 *
	 * A class for drawing polyline overlays on a map. Extends `Path`.
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polyline from an array of LatLng points
	 * var latlngs = [
	 * 	[45.51, -122.68],
	 * 	[37.77, -122.43],
	 * 	[34.04, -118.2]
	 * ];
	 *
	 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polyline
	 * map.fitBounds(polyline.getBounds());
	 * ```
	 *
	 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	 *
	 * ```js
	 * // create a red polyline from an array of arrays of LatLng points
	 * var latlngs = [
	 * 	[[45.51, -122.68],
	 * 	 [37.77, -122.43],
	 * 	 [34.04, -118.2]],
	 * 	[[40.78, -73.91],
	 * 	 [41.83, -87.62],
	 * 	 [32.76, -96.72]]
	 * ];
	 * ```
	 */
	
	
	var Polyline = Path.extend({
	
		// @section
		// @aka Polyline options
		options: {
			// @option smoothFactor: Number = 1.0
			// How much to simplify the polyline on each zoom level. More means
			// better performance and smoother look, and less means more accurate representation.
			smoothFactor: 1.0,
	
			// @option noClip: Boolean = false
			// Disable polyline clipping.
			noClip: false
		},
	
		initialize: function (latlngs, options) {
			setOptions(this, options);
			this._setLatLngs(latlngs);
		},
	
		// @method getLatLngs(): LatLng[]
		// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
		getLatLngs: function () {
			return this._latlngs;
		},
	
		// @method setLatLngs(latlngs: LatLng[]): this
		// Replaces all the points in the polyline with the given array of geographical points.
		setLatLngs: function (latlngs) {
			this._setLatLngs(latlngs);
			return this.redraw();
		},
	
		// @method isEmpty(): Boolean
		// Returns `true` if the Polyline has no LatLngs.
		isEmpty: function () {
			return !this._latlngs.length;
		},
	
		// @method closestLayerPoint(p: Point): Point
		// Returns the point closest to `p` on the Polyline.
		closestLayerPoint: function (p) {
			var minDistance = Infinity,
			    minPoint = null,
			    closest = _sqClosestPointOnSegment,
			    p1, p2;
	
			for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
				var points = this._parts[j];
	
				for (var i = 1, len = points.length; i < len; i++) {
					p1 = points[i - 1];
					p2 = points[i];
	
					var sqDist = closest(p, p1, p2, true);
	
					if (sqDist < minDistance) {
						minDistance = sqDist;
						minPoint = closest(p, p1, p2);
					}
				}
			}
			if (minPoint) {
				minPoint.distance = Math.sqrt(minDistance);
			}
			return minPoint;
		},
	
		// @method getCenter(): LatLng
		// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, halfDist, segDist, dist, p1, p2, ratio,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polyline centroid algorithm; only uses the first ring if there are multiple
	
			for (i = 0, halfDist = 0; i < len - 1; i++) {
				halfDist += points[i].distanceTo(points[i + 1]) / 2;
			}
	
			// The line is so small in the current view that all points are on the same pixel.
			if (halfDist === 0) {
				return this._map.layerPointToLatLng(points[0]);
			}
	
			for (i = 0, dist = 0; i < len - 1; i++) {
				p1 = points[i];
				p2 = points[i + 1];
				segDist = p1.distanceTo(p2);
				dist += segDist;
	
				if (dist > halfDist) {
					ratio = (dist - halfDist) / segDist;
					return this._map.layerPointToLatLng([
						p2.x - ratio * (p2.x - p1.x),
						p2.y - ratio * (p2.y - p1.y)
					]);
				}
			}
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			return this._bounds;
		},
	
		// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
		// Adds a given point to the polyline. By default, adds to the first ring of
		// the polyline in case of a multi-polyline, but can be overridden by passing
		// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
		addLatLng: function (latlng, latlngs) {
			latlngs = latlngs || this._defaultShape();
			latlng = toLatLng(latlng);
			latlngs.push(latlng);
			this._bounds.extend(latlng);
			return this.redraw();
		},
	
		_setLatLngs: function (latlngs) {
			this._bounds = new LatLngBounds();
			this._latlngs = this._convertLatLngs(latlngs);
		},
	
		_defaultShape: function () {
			return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
		},
	
		// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
		_convertLatLngs: function (latlngs) {
			var result = [],
			    flat = isFlat(latlngs);
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				if (flat) {
					result[i] = toLatLng(latlngs[i]);
					this._bounds.extend(result[i]);
				} else {
					result[i] = this._convertLatLngs(latlngs[i]);
				}
			}
	
			return result;
		},
	
		_project: function () {
			var pxBounds = new Bounds();
			this._rings = [];
			this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
			var w = this._clickTolerance(),
			    p = new Point(w, w);
	
			if (this._bounds.isValid() && pxBounds.isValid()) {
				pxBounds.min._subtract(p);
				pxBounds.max._add(p);
				this._pxBounds = pxBounds;
			}
		},
	
		// recursively turns latlngs into a set of rings with projected coordinates
		_projectLatlngs: function (latlngs, result, projectedBounds) {
			var flat = latlngs[0] instanceof LatLng,
			    len = latlngs.length,
			    i, ring;
	
			if (flat) {
				ring = [];
				for (i = 0; i < len; i++) {
					ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
					projectedBounds.extend(ring[i]);
				}
				result.push(ring);
			} else {
				for (i = 0; i < len; i++) {
					this._projectLatlngs(latlngs[i], result, projectedBounds);
				}
			}
		},
	
		// clip polyline by renderer bounds so that we have less to render for performance
		_clipPoints: function () {
			var bounds = this._renderer._bounds;
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			var parts = this._parts,
			    i, j, k, len, len2, segment, points;
	
			for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
				points = this._rings[i];
	
				for (j = 0, len2 = points.length; j < len2 - 1; j++) {
					segment = clipSegment(points[j], points[j + 1], bounds, j, true);
	
					if (!segment) { continue; }
	
					parts[k] = parts[k] || [];
					parts[k].push(segment[0]);
	
					// if segment goes out of screen, or it's the last one, it's the end of the line part
					if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
						parts[k].push(segment[1]);
						k++;
					}
				}
			}
		},
	
		// simplify each clipped part of the polyline for performance
		_simplifyPoints: function () {
			var parts = this._parts,
			    tolerance = this.options.smoothFactor;
	
			for (var i = 0, len = parts.length; i < len; i++) {
				parts[i] = simplify(parts[i], tolerance);
			}
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			this._clipPoints();
			this._simplifyPoints();
			this._updatePath();
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p, closed) {
			var i, j, k, len, len2, part,
			    w = this._clickTolerance();
	
			if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
			// hit detection for polylines
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					if (!closed && (j === 0)) { continue; }
	
					if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
						return true;
					}
				}
			}
			return false;
		}
	});
	
	// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	// Instantiates a polyline object given an array of geographical points and
	// optionally an options object. You can create a `Polyline` object with
	// multiple separate lines (`MultiPolyline`) by passing an array of arrays
	// of geographic points.
	function polyline(latlngs, options) {
		return new Polyline(latlngs, options);
	}
	
	// Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
	Polyline._flat = _flat;
	
	/*
	 * @class Polygon
	 * @aka L.Polygon
	 * @inherits Polyline
	 *
	 * A class for drawing polygon overlays on a map. Extends `Polyline`.
	 *
	 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	 *
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polygon from an array of LatLng points
	 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	 *
	 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polygon
	 * map.fitBounds(polygon.getBounds());
	 * ```
	 *
	 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	 *
	 * ```js
	 * var latlngs = [
	 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 * ];
	 * ```
	 *
	 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	 *
	 * ```js
	 * var latlngs = [
	 *   [ // first polygon
	 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 *   ],
	 *   [ // second polygon
	 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	 *   ]
	 * ];
	 * ```
	 */
	
	var Polygon = Polyline.extend({
	
		options: {
			fill: true
		},
	
		isEmpty: function () {
			return !this._latlngs.length || !this._latlngs[0].length;
		},
	
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, j, p1, p2, f, area, x, y, center,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polygon centroid algorithm; only uses the first ring if there are multiple
	
			area = x = y = 0;
	
			for (i = 0, j = len - 1; i < len; j = i++) {
				p1 = points[i];
				p2 = points[j];
	
				f = p1.y * p2.x - p2.y * p1.x;
				x += (p1.x + p2.x) * f;
				y += (p1.y + p2.y) * f;
				area += f * 3;
			}
	
			if (area === 0) {
				// Polygon is so small that all points are on same pixel.
				center = points[0];
			} else {
				center = [x / area, y / area];
			}
			return this._map.layerPointToLatLng(center);
		},
	
		_convertLatLngs: function (latlngs) {
			var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
			    len = result.length;
	
			// remove last point if it equals first one
			if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
				result.pop();
			}
			return result;
		},
	
		_setLatLngs: function (latlngs) {
			Polyline.prototype._setLatLngs.call(this, latlngs);
			if (isFlat(this._latlngs)) {
				this._latlngs = [this._latlngs];
			}
		},
	
		_defaultShape: function () {
			return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
		},
	
		_clipPoints: function () {
			// polygons need a different clipping algorithm so we redefine that
	
			var bounds = this._renderer._bounds,
			    w = this.options.weight,
			    p = new Point(w, w);
	
			// increase clip padding by stroke width to avoid stroke on clip edges
			bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
				clipped = clipPolygon(this._rings[i], bounds, true);
				if (clipped.length) {
					this._parts.push(clipped);
				}
			}
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this, true);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p) {
			var inside = false,
			    part, p1, p2, i, j, k, len, len2;
	
			if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
			// ray casting algorithm for detecting if point is in polygon
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					p1 = part[j];
					p2 = part[k];
	
					if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
						inside = !inside;
					}
				}
			}
	
			// also check if it's on polygon stroke
			return inside || Polyline.prototype._containsPoint.call(this, p, true);
		}
	
	});
	
	
	// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	function polygon(latlngs, options) {
		return new Polygon(latlngs, options);
	}
	
	/*
	 * @class GeoJSON
	 * @aka L.GeoJSON
	 * @inherits FeatureGroup
	 *
	 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	 *
	 * @example
	 *
	 * ```js
	 * L.geoJSON(data, {
	 * 	style: function (feature) {
	 * 		return {color: feature.properties.color};
	 * 	}
	 * }).bindPopup(function (layer) {
	 * 	return layer.feature.properties.description;
	 * }).addTo(map);
	 * ```
	 */
	
	var GeoJSON = FeatureGroup.extend({
	
		/* @section
		 * @aka GeoJSON options
		 *
		 * @option pointToLayer: Function = *
		 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
		 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
		 * The default is to spawn a default `Marker`:
		 * ```js
		 * function(geoJsonPoint, latlng) {
		 * 	return L.marker(latlng);
		 * }
		 * ```
		 *
		 * @option style: Function = *
		 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
		 * called internally when data is added.
		 * The default value is to not override any defaults:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return {}
		 * }
		 * ```
		 *
		 * @option onEachFeature: Function = *
		 * A `Function` that will be called once for each created `Feature`, after it has
		 * been created and styled. Useful for attaching events and popups to features.
		 * The default is to do nothing with the newly created layers:
		 * ```js
		 * function (feature, layer) {}
		 * ```
		 *
		 * @option filter: Function = *
		 * A `Function` that will be used to decide whether to include a feature or not.
		 * The default is to include all features:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return true;
		 * }
		 * ```
		 * Note: dynamically changing the `filter` option will have effect only on newly
		 * added data. It will _not_ re-evaluate already included features.
		 *
		 * @option coordsToLatLng: Function = *
		 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
		 * The default is the `coordsToLatLng` static method.
		 */
	
		initialize: function (geojson, options) {
			setOptions(this, options);
	
			this._layers = {};
	
			if (geojson) {
				this.addData(geojson);
			}
		},
	
		// @method addData( <GeoJSON> data ): this
		// Adds a GeoJSON object to the layer.
		addData: function (geojson) {
			var features = isArray(geojson) ? geojson : geojson.features,
			    i, len, feature;
	
			if (features) {
				for (i = 0, len = features.length; i < len; i++) {
					// only add this if geometry or geometries are set and not null
					feature = features[i];
					if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
						this.addData(feature);
					}
				}
				return this;
			}
	
			var options = this.options;
	
			if (options.filter && !options.filter(geojson)) { return this; }
	
			var layer = geometryToLayer(geojson, options);
			if (!layer) {
				return this;
			}
			layer.feature = asFeature(geojson);
	
			layer.defaultOptions = layer.options;
			this.resetStyle(layer);
	
			if (options.onEachFeature) {
				options.onEachFeature(geojson, layer);
			}
	
			return this.addLayer(layer);
		},
	
		// @method resetStyle( <Path> layer ): this
		// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
		resetStyle: function (layer) {
			// reset any custom styles
			layer.options = extend({}, layer.defaultOptions);
			this._setLayerStyle(layer, this.options.style);
			return this;
		},
	
		// @method setStyle( <Function> style ): this
		// Changes styles of GeoJSON vector layers with the given style function.
		setStyle: function (style) {
			return this.eachLayer(function (layer) {
				this._setLayerStyle(layer, style);
			}, this);
		},
	
		_setLayerStyle: function (layer, style) {
			if (typeof style === 'function') {
				style = style(layer.feature);
			}
			if (layer.setStyle) {
				layer.setStyle(style);
			}
		}
	});
	
	// @section
	// There are several static functions which can be called without instantiating L.GeoJSON:
	
	// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	// Creates a `Layer` from a given GeoJSON feature. Can use a custom
	// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	// functions if provided as options.
	function geometryToLayer(geojson, options) {
	
		var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
		    coords = geometry ? geometry.coordinates : null,
		    layers = [],
		    pointToLayer = options && options.pointToLayer,
		    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
		    latlng, latlngs, i, len;
	
		if (!coords && !geometry) {
			return null;
		}
	
		switch (geometry.type) {
		case 'Point':
			latlng = _coordsToLatLng(coords);
			return pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng);
	
		case 'MultiPoint':
			for (i = 0, len = coords.length; i < len; i++) {
				latlng = _coordsToLatLng(coords[i]);
				layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng));
			}
			return new FeatureGroup(layers);
	
		case 'LineString':
		case 'MultiLineString':
			latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
			return new Polyline(latlngs, options);
	
		case 'Polygon':
		case 'MultiPolygon':
			latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
			return new Polygon(latlngs, options);
	
		case 'GeometryCollection':
			for (i = 0, len = geometry.geometries.length; i < len; i++) {
				var layer = geometryToLayer({
					geometry: geometry.geometries[i],
					type: 'Feature',
					properties: geojson.properties
				}, options);
	
				if (layer) {
					layers.push(layer);
				}
			}
			return new FeatureGroup(layers);
	
		default:
			throw new Error('Invalid GeoJSON object.');
		}
	}
	
	// @function coordsToLatLng(coords: Array): LatLng
	// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	function coordsToLatLng(coords) {
		return new LatLng(coords[1], coords[0], coords[2]);
	}
	
	// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
		var latlngs = [];
	
		for (var i = 0, len = coords.length, latlng; i < len; i++) {
			latlng = levelsDeep ?
				coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
				(_coordsToLatLng || coordsToLatLng)(coords[i]);
	
			latlngs.push(latlng);
		}
	
		return latlngs;
	}
	
	// @function latLngToCoords(latlng: LatLng, precision?: Number): Array
	// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	function latLngToCoords(latlng, precision) {
		precision = typeof precision === 'number' ? precision : 6;
		return latlng.alt !== undefined ?
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
	}
	
	// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
	// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
		var coords = [];
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			coords.push(levelsDeep ?
				latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) :
				latLngToCoords(latlngs[i], precision));
		}
	
		if (!levelsDeep && closed) {
			coords.push(coords[0]);
		}
	
		return coords;
	}
	
	function getFeature(layer, newGeometry) {
		return layer.feature ?
			extend({}, layer.feature, {geometry: newGeometry}) :
			asFeature(newGeometry);
	}
	
	// @function asFeature(geojson: Object): Object
	// Normalize GeoJSON geometries/features into GeoJSON features.
	function asFeature(geojson) {
		if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
			return geojson;
		}
	
		return {
			type: 'Feature',
			properties: {},
			geometry: geojson
		};
	}
	
	var PointToGeoJSON = {
		toGeoJSON: function (precision) {
			return getFeature(this, {
				type: 'Point',
				coordinates: latLngToCoords(this.getLatLng(), precision)
			});
		}
	};
	
	// @namespace Marker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	Marker.include(PointToGeoJSON);
	
	// @namespace CircleMarker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	Circle.include(PointToGeoJSON);
	CircleMarker.include(PointToGeoJSON);
	
	
	// @namespace Polyline
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	Polyline.include({
		toGeoJSON: function (precision) {
			var multi = !isFlat(this._latlngs);
	
			var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
	
			return getFeature(this, {
				type: (multi ? 'Multi' : '') + 'LineString',
				coordinates: coords
			});
		}
	});
	
	// @namespace Polygon
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	Polygon.include({
		toGeoJSON: function (precision) {
			var holes = !isFlat(this._latlngs),
			    multi = holes && !isFlat(this._latlngs[0]);
	
			var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
	
			if (!holes) {
				coords = [coords];
			}
	
			return getFeature(this, {
				type: (multi ? 'Multi' : '') + 'Polygon',
				coordinates: coords
			});
		}
	});
	
	
	// @namespace LayerGroup
	LayerGroup.include({
		toMultiPoint: function (precision) {
			var coords = [];
	
			this.eachLayer(function (layer) {
				coords.push(layer.toGeoJSON(precision).geometry.coordinates);
			});
	
			return getFeature(this, {
				type: 'MultiPoint',
				coordinates: coords
			});
		},
	
		// @method toGeoJSON(): Object
		// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
		toGeoJSON: function (precision) {
	
			var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
			if (type === 'MultiPoint') {
				return this.toMultiPoint(precision);
			}
	
			var isGeometryCollection = type === 'GeometryCollection',
			    jsons = [];
	
			this.eachLayer(function (layer) {
				if (layer.toGeoJSON) {
					var json = layer.toGeoJSON(precision);
					if (isGeometryCollection) {
						jsons.push(json.geometry);
					} else {
						var feature = asFeature(json);
						// Squash nested feature collections
						if (feature.type === 'FeatureCollection') {
							jsons.push.apply(jsons, feature.features);
						} else {
							jsons.push(feature);
						}
					}
				}
			});
	
			if (isGeometryCollection) {
				return getFeature(this, {
					geometries: jsons,
					type: 'GeometryCollection'
				});
			}
	
			return {
				type: 'FeatureCollection',
				features: jsons
			};
		}
	});
	
	// @namespace GeoJSON
	// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	// Creates a GeoJSON layer. Optionally accepts an object in
	// [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
	// (you can alternatively add it later with `addData` method) and an `options` object.
	function geoJSON(geojson, options) {
		return new GeoJSON(geojson, options);
	}
	
	// Backward compatibility.
	var geoJson = geoJSON;
	
	/*
	 * @class ImageOverlay
	 * @aka L.ImageOverlay
	 * @inherits Interactive layer
	 *
	 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	 * ```
	 */
	
	var ImageOverlay = Layer.extend({
	
		// @section
		// @aka ImageOverlay options
		options: {
			// @option opacity: Number = 1.0
			// The opacity of the image overlay.
			opacity: 1,
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the image (useful for accessibility).
			alt: '',
	
			// @option interactive: Boolean = false
			// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
			interactive: false,
	
			// @option crossOrigin: Boolean|String = false
			// Whether the crossOrigin attribute will be added to the image.
			// If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
			// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
			crossOrigin: false,
	
			// @option errorOverlayUrl: String = ''
			// URL to the overlay image to show in place of the overlay that failed to load.
			errorOverlayUrl: '',
	
			// @option zIndex: Number = 1
			// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
			zIndex: 1,
	
			// @option className: String = ''
			// A custom class name to assign to the image. Empty by default.
			className: ''
		},
	
		initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
			this._url = url;
			this._bounds = toLatLngBounds(bounds);
	
			setOptions(this, options);
		},
	
		onAdd: function () {
			if (!this._image) {
				this._initImage();
	
				if (this.options.opacity < 1) {
					this._updateOpacity();
				}
			}
	
			if (this.options.interactive) {
				addClass(this._image, 'leaflet-interactive');
				this.addInteractiveTarget(this._image);
			}
	
			this.getPane().appendChild(this._image);
			this._reset();
		},
	
		onRemove: function () {
			remove(this._image);
			if (this.options.interactive) {
				this.removeInteractiveTarget(this._image);
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Sets the opacity of the overlay.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._image) {
				this._updateOpacity();
			}
			return this;
		},
	
		setStyle: function (styleOpts) {
			if (styleOpts.opacity) {
				this.setOpacity(styleOpts.opacity);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all overlays.
		bringToFront: function () {
			if (this._map) {
				toFront(this._image);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all overlays.
		bringToBack: function () {
			if (this._map) {
				toBack(this._image);
			}
			return this;
		},
	
		// @method setUrl(url: String): this
		// Changes the URL of the image.
		setUrl: function (url) {
			this._url = url;
	
			if (this._image) {
				this._image.src = url;
			}
			return this;
		},
	
		// @method setBounds(bounds: LatLngBounds): this
		// Update the bounds that this ImageOverlay covers
		setBounds: function (bounds) {
			this._bounds = toLatLngBounds(bounds);
	
			if (this._map) {
				this._reset();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				zoom: this._reset,
				viewreset: this._reset
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @method setZIndex(value: Number): this
		// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
		setZIndex: function (value) {
			this.options.zIndex = value;
			this._updateZIndex();
			return this;
		},
	
		// @method getBounds(): LatLngBounds
		// Get the bounds that this ImageOverlay covers
		getBounds: function () {
			return this._bounds;
		},
	
		// @method getElement(): HTMLElement
		// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
		// used by this overlay.
		getElement: function () {
			return this._image;
		},
	
		_initImage: function () {
			var wasElementSupplied = this._url.tagName === 'IMG';
			var img = this._image = wasElementSupplied ? this._url : create$1('img');
	
			addClass(img, 'leaflet-image-layer');
			if (this._zoomAnimated) { addClass(img, 'leaflet-zoom-animated'); }
			if (this.options.className) { addClass(img, this.options.className); }
	
			img.onselectstart = falseFn;
			img.onmousemove = falseFn;
	
			// @event load: Event
			// Fired when the ImageOverlay layer has loaded its image
			img.onload = bind(this.fire, this, 'load');
			img.onerror = bind(this._overlayOnError, this, 'error');
	
			if (this.options.crossOrigin || this.options.crossOrigin === '') {
				img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
			}
	
			if (this.options.zIndex) {
				this._updateZIndex();
			}
	
			if (wasElementSupplied) {
				this._url = img.src;
				return;
			}
	
			img.src = this._url;
			img.alt = this.options.alt;
		},
	
		_animateZoom: function (e) {
			var scale = this._map.getZoomScale(e.zoom),
			    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
			setTransform(this._image, offset, scale);
		},
	
		_reset: function () {
			var image = this._image,
			    bounds = new Bounds(
			        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
			        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
			    size = bounds.getSize();
	
			setPosition(image, bounds.min);
	
			image.style.width  = size.x + 'px';
			image.style.height = size.y + 'px';
		},
	
		_updateOpacity: function () {
			setOpacity(this._image, this.options.opacity);
		},
	
		_updateZIndex: function () {
			if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._image.style.zIndex = this.options.zIndex;
			}
		},
	
		_overlayOnError: function () {
			// @event error: Event
			// Fired when the ImageOverlay layer fails to load its image
			this.fire('error');
	
			var errorUrl = this.options.errorOverlayUrl;
			if (errorUrl && this._url !== errorUrl) {
				this._url = errorUrl;
				this._image.src = errorUrl;
			}
		}
	});
	
	// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	// Instantiates an image overlay object given the URL of the image and the
	// geographical bounds it is tied to.
	var imageOverlay = function (url, bounds, options) {
		return new ImageOverlay(url, bounds, options);
	};
	
	/*
	 * @class VideoOverlay
	 * @aka L.VideoOverlay
	 * @inherits ImageOverlay
	 *
	 * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
	 *
	 * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
	 * HTML5 element.
	 *
	 * @example
	 *
	 * ```js
	 * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
	 * 	videoBounds = [[ 32, -130], [ 13, -100]];
	 * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
	 * ```
	 */
	
	var VideoOverlay = ImageOverlay.extend({
	
		// @section
		// @aka VideoOverlay options
		options: {
			// @option autoplay: Boolean = true
			// Whether the video starts playing automatically when loaded.
			autoplay: true,
	
			// @option loop: Boolean = true
			// Whether the video will loop back to the beginning when played.
			loop: true
		},
	
		_initImage: function () {
			var wasElementSupplied = this._url.tagName === 'VIDEO';
			var vid = this._image = wasElementSupplied ? this._url : create$1('video');
	
			addClass(vid, 'leaflet-image-layer');
			if (this._zoomAnimated) { addClass(vid, 'leaflet-zoom-animated'); }
	
			vid.onselectstart = falseFn;
			vid.onmousemove = falseFn;
	
			// @event load: Event
			// Fired when the video has finished loading the first frame
			vid.onloadeddata = bind(this.fire, this, 'load');
	
			if (wasElementSupplied) {
				var sourceElements = vid.getElementsByTagName('source');
				var sources = [];
				for (var j = 0; j < sourceElements.length; j++) {
					sources.push(sourceElements[j].src);
				}
	
				this._url = (sourceElements.length > 0) ? sources : [vid.src];
				return;
			}
	
			if (!isArray(this._url)) { this._url = [this._url]; }
	
			vid.autoplay = !!this.options.autoplay;
			vid.loop = !!this.options.loop;
			for (var i = 0; i < this._url.length; i++) {
				var source = create$1('source');
				source.src = this._url[i];
				vid.appendChild(source);
			}
		}
	
		// @method getElement(): HTMLVideoElement
		// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
		// used by this overlay.
	});
	
	
	// @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
	// Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
	// geographical bounds it is tied to.
	
	function videoOverlay(video, bounds, options) {
		return new VideoOverlay(video, bounds, options);
	}
	
	/*
	 * @class DivOverlay
	 * @inherits Layer
	 * @aka L.DivOverlay
	 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
	 */
	
	// @namespace DivOverlay
	var DivOverlay = Layer.extend({
	
		// @section
		// @aka DivOverlay options
		options: {
			// @option offset: Point = Point(0, 7)
			// The offset of the popup position. Useful to control the anchor
			// of the popup when opening it on some overlays.
			offset: [0, 7],
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: '',
	
			// @option pane: String = 'popupPane'
			// `Map pane` where the popup will be added.
			pane: 'popupPane'
		},
	
		initialize: function (options, source) {
			setOptions(this, options);
	
			this._source = source;
		},
	
		onAdd: function (map) {
			this._zoomAnimated = map._zoomAnimated;
	
			if (!this._container) {
				this._initLayout();
			}
	
			if (map._fadeAnimated) {
				setOpacity(this._container, 0);
			}
	
			clearTimeout(this._removeTimeout);
			this.getPane().appendChild(this._container);
			this.update();
	
			if (map._fadeAnimated) {
				setOpacity(this._container, 1);
			}
	
			this.bringToFront();
		},
	
		onRemove: function (map) {
			if (map._fadeAnimated) {
				setOpacity(this._container, 0);
				this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
			} else {
				remove(this._container);
			}
		},
	
		// @namespace Popup
		// @method getLatLng: LatLng
		// Returns the geographical point of popup.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Sets the geographical point where the popup will open.
		setLatLng: function (latlng) {
			this._latlng = toLatLng(latlng);
			if (this._map) {
				this._updatePosition();
				this._adjustPan();
			}
			return this;
		},
	
		// @method getContent: String|HTMLElement
		// Returns the content of the popup.
		getContent: function () {
			return this._content;
		},
	
		// @method setContent(htmlContent: String|HTMLElement|Function): this
		// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
		setContent: function (content) {
			this._content = content;
			this.update();
			return this;
		},
	
		// @method getElement: String|HTMLElement
		// Alias for [getContent()](#popup-getcontent)
		getElement: function () {
			return this._container;
		},
	
		// @method update: null
		// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
		update: function () {
			if (!this._map) { return; }
	
			this._container.style.visibility = 'hidden';
	
			this._updateContent();
			this._updateLayout();
			this._updatePosition();
	
			this._container.style.visibility = '';
	
			this._adjustPan();
		},
	
		getEvents: function () {
			var events = {
				zoom: this._updatePosition,
				viewreset: this._updatePosition
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
			return events;
		},
	
		// @method isOpen: Boolean
		// Returns `true` when the popup is visible on the map.
		isOpen: function () {
			return !!this._map && this._map.hasLayer(this);
		},
	
		// @method bringToFront: this
		// Brings this popup in front of other popups (in the same map pane).
		bringToFront: function () {
			if (this._map) {
				toFront(this._container);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings this popup to the back of other popups (in the same map pane).
		bringToBack: function () {
			if (this._map) {
				toBack(this._container);
			}
			return this;
		},
	
		_updateContent: function () {
			if (!this._content) { return; }
	
			var node = this._contentNode;
			var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
			if (typeof content === 'string') {
				node.innerHTML = content;
			} else {
				while (node.hasChildNodes()) {
					node.removeChild(node.firstChild);
				}
				node.appendChild(content);
			}
			this.fire('contentupdate');
		},
	
		_updatePosition: function () {
			if (!this._map) { return; }
	
			var pos = this._map.latLngToLayerPoint(this._latlng),
			    offset = toPoint(this.options.offset),
			    anchor = this._getAnchor();
	
			if (this._zoomAnimated) {
				setPosition(this._container, pos.add(anchor));
			} else {
				offset = offset.add(pos).add(anchor);
			}
	
			var bottom = this._containerBottom = -offset.y,
			    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
			// bottom position the popup in case the height of the popup changes (images loading etc)
			this._container.style.bottom = bottom + 'px';
			this._container.style.left = left + 'px';
		},
	
		_getAnchor: function () {
			return [0, 0];
		}
	
	});
	
	/*
	 * @class Popup
	 * @inherits DivOverlay
	 * @aka L.Popup
	 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	 * open popups while making sure that only one popup is open at one time
	 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	 *
	 * @example
	 *
	 * If you want to just bind a popup to marker click and then open it, it's really easy:
	 *
	 * ```js
	 * marker.bindPopup(popupContent).openPopup();
	 * ```
	 * Path overlays like polylines also have a `bindPopup` method.
	 * Here's a more complicated way to open a popup on a map:
	 *
	 * ```js
	 * var popup = L.popup()
	 * 	.setLatLng(latlng)
	 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	 * 	.openOn(map);
	 * ```
	 */
	
	
	// @namespace Popup
	var Popup = DivOverlay.extend({
	
		// @section
		// @aka Popup options
		options: {
			// @option maxWidth: Number = 300
			// Max width of the popup, in pixels.
			maxWidth: 300,
	
			// @option minWidth: Number = 50
			// Min width of the popup, in pixels.
			minWidth: 50,
	
			// @option maxHeight: Number = null
			// If set, creates a scrollable container of the given height
			// inside a popup if its content exceeds it.
			maxHeight: null,
	
			// @option autoPan: Boolean = true
			// Set it to `false` if you don't want the map to do panning animation
			// to fit the opened popup.
			autoPan: true,
	
			// @option autoPanPaddingTopLeft: Point = null
			// The margin between the popup and the top left corner of the map
			// view after autopanning was performed.
			autoPanPaddingTopLeft: null,
	
			// @option autoPanPaddingBottomRight: Point = null
			// The margin between the popup and the bottom right corner of the map
			// view after autopanning was performed.
			autoPanPaddingBottomRight: null,
	
			// @option autoPanPadding: Point = Point(5, 5)
			// Equivalent of setting both top left and bottom right autopan padding to the same value.
			autoPanPadding: [5, 5],
	
			// @option keepInView: Boolean = false
			// Set it to `true` if you want to prevent users from panning the popup
			// off of the screen while it is open.
			keepInView: false,
	
			// @option closeButton: Boolean = true
			// Controls the presence of a close button in the popup.
			closeButton: true,
	
			// @option autoClose: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the popup closing when another popup is opened.
			autoClose: true,
	
			// @option closeOnEscapeKey: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the ESC key for closing of the popup.
			closeOnEscapeKey: true,
	
			// @option closeOnClick: Boolean = *
			// Set it if you want to override the default behavior of the popup closing when user clicks
			// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: ''
		},
	
		// @namespace Popup
		// @method openOn(map: Map): this
		// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
		openOn: function (map) {
			map.openPopup(this);
			return this;
		},
	
		onAdd: function (map) {
			DivOverlay.prototype.onAdd.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup is opened in the map
			map.fire('popupopen', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupopen: PopupEvent
				// Fired when a popup bound to this layer is opened
				this._source.fire('popupopen', {popup: this}, true);
				// For non-path layers, we toggle the popup when clicking
				// again the layer, so prevent the map to reopen it.
				if (!(this._source instanceof Path)) {
					this._source.on('preclick', stopPropagation);
				}
			}
		},
	
		onRemove: function (map) {
			DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup in the map is closed
			map.fire('popupclose', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupclose: PopupEvent
				// Fired when a popup bound to this layer is closed
				this._source.fire('popupclose', {popup: this}, true);
				if (!(this._source instanceof Path)) {
					this._source.off('preclick', stopPropagation);
				}
			}
		},
	
		getEvents: function () {
			var events = DivOverlay.prototype.getEvents.call(this);
	
			if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
				events.preclick = this._close;
			}
	
			if (this.options.keepInView) {
				events.moveend = this._adjustPan;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closePopup(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-popup',
			    container = this._container = create$1('div',
				prefix + ' ' + (this.options.className || '') +
				' leaflet-zoom-animated');
	
			var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
			this._contentNode = create$1('div', prefix + '-content', wrapper);
	
			disableClickPropagation(wrapper);
			disableScrollPropagation(this._contentNode);
			on(wrapper, 'contextmenu', stopPropagation);
	
			this._tipContainer = create$1('div', prefix + '-tip-container', container);
			this._tip = create$1('div', prefix + '-tip', this._tipContainer);
	
			if (this.options.closeButton) {
				var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
				closeButton.href = '#close';
				closeButton.innerHTML = '&#215;';
	
				on(closeButton, 'click', this._onCloseButtonClick, this);
			}
		},
	
		_updateLayout: function () {
			var container = this._contentNode,
			    style = container.style;
	
			style.width = '';
			style.whiteSpace = 'nowrap';
	
			var width = container.offsetWidth;
			width = Math.min(width, this.options.maxWidth);
			width = Math.max(width, this.options.minWidth);
	
			style.width = (width + 1) + 'px';
			style.whiteSpace = '';
	
			style.height = '';
	
			var height = container.offsetHeight,
			    maxHeight = this.options.maxHeight,
			    scrolledClass = 'leaflet-popup-scrolled';
	
			if (maxHeight && height > maxHeight) {
				style.height = maxHeight + 'px';
				addClass(container, scrolledClass);
			} else {
				removeClass(container, scrolledClass);
			}
	
			this._containerWidth = this._container.offsetWidth;
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
			    anchor = this._getAnchor();
			setPosition(this._container, pos.add(anchor));
		},
	
		_adjustPan: function () {
			if (!this.options.autoPan || (this._map._panAnim && this._map._panAnim._inProgress)) { return; }
	
			var map = this._map,
			    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
			    containerHeight = this._container.offsetHeight + marginBottom,
			    containerWidth = this._containerWidth,
			    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
	
			layerPos._add(getPosition(this._container));
	
			var containerPos = map.layerPointToContainerPoint(layerPos),
			    padding = toPoint(this.options.autoPanPadding),
			    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
			    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
			    size = map.getSize(),
			    dx = 0,
			    dy = 0;
	
			if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
				dx = containerPos.x + containerWidth - size.x + paddingBR.x;
			}
			if (containerPos.x - dx - paddingTL.x < 0) { // left
				dx = containerPos.x - paddingTL.x;
			}
			if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
				dy = containerPos.y + containerHeight - size.y + paddingBR.y;
			}
			if (containerPos.y - dy - paddingTL.y < 0) { // top
				dy = containerPos.y - paddingTL.y;
			}
	
			// @namespace Map
			// @section Popup events
			// @event autopanstart: Event
			// Fired when the map starts autopanning when opening a popup.
			if (dx || dy) {
				map
				    .fire('autopanstart')
				    .panBy([dx, dy]);
			}
		},
	
		_onCloseButtonClick: function (e) {
			this._close();
			stop(e);
		},
	
		_getAnchor: function () {
			// Where should we anchor the popup on the source layer?
			return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Popup
	// @factory L.popup(options?: Popup options, source?: Layer)
	// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	var popup = function (options, source) {
		return new Popup(options, source);
	};
	
	
	/* @namespace Map
	 * @section Interaction Options
	 * @option closePopupOnClick: Boolean = true
	 * Set it to `false` if you don't want popups to close when user clicks the map.
	 */
	Map.mergeOptions({
		closePopupOnClick: true
	});
	
	
	// @namespace Map
	// @section Methods for Layers and Controls
	Map.include({
		// @method openPopup(popup: Popup): this
		// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
		// @alternative
		// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
		// Creates a popup with the specified content and options and opens it in the given point on a map.
		openPopup: function (popup, latlng, options) {
			if (!(popup instanceof Popup)) {
				popup = new Popup(options).setContent(popup);
			}
	
			if (latlng) {
				popup.setLatLng(latlng);
			}
	
			if (this.hasLayer(popup)) {
				return this;
			}
	
			if (this._popup && this._popup.options.autoClose) {
				this.closePopup();
			}
	
			this._popup = popup;
			return this.addLayer(popup);
		},
	
		// @method closePopup(popup?: Popup): this
		// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
		closePopup: function (popup) {
			if (!popup || popup === this._popup) {
				popup = this._popup;
				this._popup = null;
			}
			if (popup) {
				this.removeLayer(popup);
			}
			return this;
		}
	});
	
	/*
	 * @namespace Layer
	 * @section Popup methods example
	 *
	 * All layers share a set of methods convenient for binding popups to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	 * layer.openPopup();
	 * layer.closePopup();
	 * ```
	 *
	 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	 */
	
	// @section Popup methods
	Layer.include({
	
		// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
		// Binds a popup to the layer with the passed `content` and sets up the
		// necessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindPopup: function (content, options) {
	
			if (content instanceof Popup) {
				setOptions(content, options);
				this._popup = content;
				content._source = this;
			} else {
				if (!this._popup || options) {
					this._popup = new Popup(options, this);
				}
				this._popup.setContent(content);
			}
	
			if (!this._popupHandlersAdded) {
				this.on({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = true;
			}
	
			return this;
		},
	
		// @method unbindPopup(): this
		// Removes the popup previously bound with `bindPopup`.
		unbindPopup: function () {
			if (this._popup) {
				this.off({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = false;
				this._popup = null;
			}
			return this;
		},
	
		// @method openPopup(latlng?: LatLng): this
		// Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
		openPopup: function (layer, latlng) {
			if (!(layer instanceof Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._popup && this._map) {
				// set popup source to this layer
				this._popup._source = layer;
	
				// update the popup (content, layout, ect...)
				this._popup.update();
	
				// open the popup on the map
				this._map.openPopup(this._popup, latlng);
			}
	
			return this;
		},
	
		// @method closePopup(): this
		// Closes the popup bound to this layer if it is open.
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		// @method togglePopup(): this
		// Opens or closes the popup bound to this layer depending on its current state.
		togglePopup: function (target) {
			if (this._popup) {
				if (this._popup._map) {
					this.closePopup();
				} else {
					this.openPopup(target);
				}
			}
			return this;
		},
	
		// @method isPopupOpen(): boolean
		// Returns `true` if the popup bound to this layer is currently open.
		isPopupOpen: function () {
			return (this._popup ? this._popup.isOpen() : false);
		},
	
		// @method setPopupContent(content: String|HTMLElement|Popup): this
		// Sets the content of the popup bound to this layer.
		setPopupContent: function (content) {
			if (this._popup) {
				this._popup.setContent(content);
			}
			return this;
		},
	
		// @method getPopup(): Popup
		// Returns the popup bound to this layer.
		getPopup: function () {
			return this._popup;
		},
	
		_openPopup: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._popup) {
				return;
			}
	
			if (!this._map) {
				return;
			}
	
			// prevent map click
			stop(e);
	
			// if this inherits from Path its a vector and we can just
			// open the popup at the new location
			if (layer instanceof Path) {
				this.openPopup(e.layer || e.target, e.latlng);
				return;
			}
	
			// otherwise treat it like a marker and figure out
			// if we should toggle it open/closed
			if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
				this.closePopup();
			} else {
				this.openPopup(layer, e.latlng);
			}
		},
	
		_movePopup: function (e) {
			this._popup.setLatLng(e.latlng);
		},
	
		_onKeyPress: function (e) {
			if (e.originalEvent.keyCode === 13) {
				this._openPopup(e);
			}
		}
	});
	
	/*
	 * @class Tooltip
	 * @inherits DivOverlay
	 * @aka L.Tooltip
	 * Used to display small texts on top of map layers.
	 *
	 * @example
	 *
	 * ```js
	 * marker.bindTooltip("my tooltip text").openTooltip();
	 * ```
	 * Note about tooltip offset. Leaflet takes two options in consideration
	 * for computing tooltip offsetting:
	 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	 *   move it to the bottom. Negatives will move to the left and top.
	 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	 *   should adapt this value if you use a custom icon.
	 */
	
	
	// @namespace Tooltip
	var Tooltip = DivOverlay.extend({
	
		// @section
		// @aka Tooltip options
		options: {
			// @option pane: String = 'tooltipPane'
			// `Map pane` where the tooltip will be added.
			pane: 'tooltipPane',
	
			// @option offset: Point = Point(0, 0)
			// Optional offset of the tooltip position.
			offset: [0, 0],
	
			// @option direction: String = 'auto'
			// Direction where to open the tooltip. Possible values are: `right`, `left`,
			// `top`, `bottom`, `center`, `auto`.
			// `auto` will dynamically switch between `right` and `left` according to the tooltip
			// position on the map.
			direction: 'auto',
	
			// @option permanent: Boolean = false
			// Whether to open the tooltip permanently or only on mouseover.
			permanent: false,
	
			// @option sticky: Boolean = false
			// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
			sticky: false,
	
			// @option interactive: Boolean = false
			// If true, the tooltip will listen to the feature events.
			interactive: false,
	
			// @option opacity: Number = 0.9
			// Tooltip container opacity.
			opacity: 0.9
		},
	
		onAdd: function (map) {
			DivOverlay.prototype.onAdd.call(this, map);
			this.setOpacity(this.options.opacity);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip is opened in the map.
			map.fire('tooltipopen', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipopen: TooltipEvent
				// Fired when a tooltip bound to this layer is opened.
				this._source.fire('tooltipopen', {tooltip: this}, true);
			}
		},
	
		onRemove: function (map) {
			DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip in the map is closed.
			map.fire('tooltipclose', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipclose: TooltipEvent
				// Fired when a tooltip bound to this layer is closed.
				this._source.fire('tooltipclose', {tooltip: this}, true);
			}
		},
	
		getEvents: function () {
			var events = DivOverlay.prototype.getEvents.call(this);
	
			if (touch && !this.options.permanent) {
				events.preclick = this._close;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closeTooltip(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-tooltip',
			    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			this._contentNode = this._container = create$1('div', className);
		},
	
		_updateLayout: function () {},
	
		_adjustPan: function () {},
	
		_setPosition: function (pos) {
			var map = this._map,
			    container = this._container,
			    centerPoint = map.latLngToContainerPoint(map.getCenter()),
			    tooltipPoint = map.layerPointToContainerPoint(pos),
			    direction = this.options.direction,
			    tooltipWidth = container.offsetWidth,
			    tooltipHeight = container.offsetHeight,
			    offset = toPoint(this.options.offset),
			    anchor = this._getAnchor();
	
			if (direction === 'top') {
				pos = pos.add(toPoint(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
			} else if (direction === 'bottom') {
				pos = pos.subtract(toPoint(tooltipWidth / 2 - offset.x, -offset.y, true));
			} else if (direction === 'center') {
				pos = pos.subtract(toPoint(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
			} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
				direction = 'right';
				pos = pos.add(toPoint(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
			} else {
				direction = 'left';
				pos = pos.subtract(toPoint(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
			}
	
			removeClass(container, 'leaflet-tooltip-right');
			removeClass(container, 'leaflet-tooltip-left');
			removeClass(container, 'leaflet-tooltip-top');
			removeClass(container, 'leaflet-tooltip-bottom');
			addClass(container, 'leaflet-tooltip-' + direction);
			setPosition(container, pos);
		},
	
		_updatePosition: function () {
			var pos = this._map.latLngToLayerPoint(this._latlng);
			this._setPosition(pos);
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._container) {
				setOpacity(this._container, opacity);
			}
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
			this._setPosition(pos);
		},
	
		_getAnchor: function () {
			// Where should we anchor the tooltip on the source layer?
			return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Tooltip
	// @factory L.tooltip(options?: Tooltip options, source?: Layer)
	// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	var tooltip = function (options, source) {
		return new Tooltip(options, source);
	};
	
	// @namespace Map
	// @section Methods for Layers and Controls
	Map.include({
	
		// @method openTooltip(tooltip: Tooltip): this
		// Opens the specified tooltip.
		// @alternative
		// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
		// Creates a tooltip with the specified content and options and open it.
		openTooltip: function (tooltip, latlng, options) {
			if (!(tooltip instanceof Tooltip)) {
				tooltip = new Tooltip(options).setContent(tooltip);
			}
	
			if (latlng) {
				tooltip.setLatLng(latlng);
			}
	
			if (this.hasLayer(tooltip)) {
				return this;
			}
	
			return this.addLayer(tooltip);
		},
	
		// @method closeTooltip(tooltip?: Tooltip): this
		// Closes the tooltip given as parameter.
		closeTooltip: function (tooltip) {
			if (tooltip) {
				this.removeLayer(tooltip);
			}
			return this;
		}
	
	});
	
	/*
	 * @namespace Layer
	 * @section Tooltip methods example
	 *
	 * All layers share a set of methods convenient for binding tooltips to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	 * layer.openTooltip();
	 * layer.closeTooltip();
	 * ```
	 */
	
	// @section Tooltip methods
	Layer.include({
	
		// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
		// Binds a tooltip to the layer with the passed `content` and sets up the
		// necessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindTooltip: function (content, options) {
	
			if (content instanceof Tooltip) {
				setOptions(content, options);
				this._tooltip = content;
				content._source = this;
			} else {
				if (!this._tooltip || options) {
					this._tooltip = new Tooltip(options, this);
				}
				this._tooltip.setContent(content);
	
			}
	
			this._initTooltipInteractions();
	
			if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
				this.openTooltip();
			}
	
			return this;
		},
	
		// @method unbindTooltip(): this
		// Removes the tooltip previously bound with `bindTooltip`.
		unbindTooltip: function () {
			if (this._tooltip) {
				this._initTooltipInteractions(true);
				this.closeTooltip();
				this._tooltip = null;
			}
			return this;
		},
	
		_initTooltipInteractions: function (remove$$1) {
			if (!remove$$1 && this._tooltipHandlersAdded) { return; }
			var onOff = remove$$1 ? 'off' : 'on',
			    events = {
				remove: this.closeTooltip,
				move: this._moveTooltip
			    };
			if (!this._tooltip.options.permanent) {
				events.mouseover = this._openTooltip;
				events.mouseout = this.closeTooltip;
				if (this._tooltip.options.sticky) {
					events.mousemove = this._moveTooltip;
				}
				if (touch) {
					events.click = this._openTooltip;
				}
			} else {
				events.add = this._openTooltip;
			}
			this[onOff](events);
			this._tooltipHandlersAdded = !remove$$1;
		},
	
		// @method openTooltip(latlng?: LatLng): this
		// Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
		openTooltip: function (layer, latlng) {
			if (!(layer instanceof Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._tooltip && this._map) {
	
				// set tooltip source to this layer
				this._tooltip._source = layer;
	
				// update the tooltip (content, layout, ect...)
				this._tooltip.update();
	
				// open the tooltip on the map
				this._map.openTooltip(this._tooltip, latlng);
	
				// Tooltip container may not be defined if not permanent and never
				// opened.
				if (this._tooltip.options.interactive && this._tooltip._container) {
					addClass(this._tooltip._container, 'leaflet-clickable');
					this.addInteractiveTarget(this._tooltip._container);
				}
			}
	
			return this;
		},
	
		// @method closeTooltip(): this
		// Closes the tooltip bound to this layer if it is open.
		closeTooltip: function () {
			if (this._tooltip) {
				this._tooltip._close();
				if (this._tooltip.options.interactive && this._tooltip._container) {
					removeClass(this._tooltip._container, 'leaflet-clickable');
					this.removeInteractiveTarget(this._tooltip._container);
				}
			}
			return this;
		},
	
		// @method toggleTooltip(): this
		// Opens or closes the tooltip bound to this layer depending on its current state.
		toggleTooltip: function (target) {
			if (this._tooltip) {
				if (this._tooltip._map) {
					this.closeTooltip();
				} else {
					this.openTooltip(target);
				}
			}
			return this;
		},
	
		// @method isTooltipOpen(): boolean
		// Returns `true` if the tooltip bound to this layer is currently open.
		isTooltipOpen: function () {
			return this._tooltip.isOpen();
		},
	
		// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
		// Sets the content of the tooltip bound to this layer.
		setTooltipContent: function (content) {
			if (this._tooltip) {
				this._tooltip.setContent(content);
			}
			return this;
		},
	
		// @method getTooltip(): Tooltip
		// Returns the tooltip bound to this layer.
		getTooltip: function () {
			return this._tooltip;
		},
	
		_openTooltip: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._tooltip || !this._map) {
				return;
			}
			this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
		},
	
		_moveTooltip: function (e) {
			var latlng = e.latlng, containerPoint, layerPoint;
			if (this._tooltip.options.sticky && e.originalEvent) {
				containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
				layerPoint = this._map.containerPointToLayerPoint(containerPoint);
				latlng = this._map.layerPointToLatLng(layerPoint);
			}
			this._tooltip.setLatLng(latlng);
		}
	});
	
	/*
	 * @class DivIcon
	 * @aka L.DivIcon
	 * @inherits Icon
	 *
	 * Represents a lightweight icon for markers that uses a simple `<div>`
	 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	 *
	 * @example
	 * ```js
	 * var myIcon = L.divIcon({className: 'my-div-icon'});
	 * // you can set .my-div-icon styles in CSS
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	 */
	
	var DivIcon = Icon.extend({
		options: {
			// @section
			// @aka DivIcon options
			iconSize: [12, 12], // also can be set through CSS
	
			// iconAnchor: (Point),
			// popupAnchor: (Point),
	
			// @option html: String = ''
			// Custom HTML code to put inside the div element, empty by default.
			html: false,
	
			// @option bgPos: Point = [0, 0]
			// Optional relative position of the background, in pixels
			bgPos: null,
	
			className: 'leaflet-div-icon'
		},
	
		createIcon: function (oldIcon) {
			var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
			    options = this.options;
	
			div.innerHTML = options.html !== false ? options.html : '';
	
			if (options.bgPos) {
				var bgPos = toPoint(options.bgPos);
				div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
			}
			this._setIconStyles(div, 'icon');
	
			return div;
		},
	
		createShadow: function () {
			return null;
		}
	});
	
	// @factory L.divIcon(options: DivIcon options)
	// Creates a `DivIcon` instance with the given options.
	function divIcon(options) {
		return new DivIcon(options);
	}
	
	Icon.Default = IconDefault;
	
	/*
	 * @class GridLayer
	 * @inherits Layer
	 * @aka L.GridLayer
	 *
	 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	 *
	 *
	 * @section Synchronous usage
	 * @example
	 *
	 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords){
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	 *         var ctx = tile.getContext('2d');
	 *
	 *         // return the tile so it can be rendered on screen
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section Asynchronous usage
	 * @example
	 *
	 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords, done){
	 *         var error;
	 *
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // draw something asynchronously and pass the tile to the done() callback
	 *         setTimeout(function() {
	 *             done(error, tile);
	 *         }, 1000);
	 *
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section
	 */
	
	
	var GridLayer = Layer.extend({
	
		// @section
		// @aka GridLayer options
		options: {
			// @option tileSize: Number|Point = 256
			// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
			tileSize: 256,
	
			// @option opacity: Number = 1.0
			// Opacity of the tiles. Can be used in the `createTile()` function.
			opacity: 1,
	
			// @option updateWhenIdle: Boolean = (depends)
			// Load new tiles only when panning ends.
			// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
			// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
			// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
			updateWhenIdle: mobile,
	
			// @option updateWhenZooming: Boolean = true
			// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
			updateWhenZooming: true,
	
			// @option updateInterval: Number = 200
			// Tiles will not update more than once every `updateInterval` milliseconds when panning.
			updateInterval: 200,
	
			// @option zIndex: Number = 1
			// The explicit zIndex of the tile layer.
			zIndex: 1,
	
			// @option bounds: LatLngBounds = undefined
			// If set, tiles will only be loaded inside the set `LatLngBounds`.
			bounds: null,
	
			// @option minZoom: Number = 0
			// The minimum zoom level down to which this layer will be displayed (inclusive).
			minZoom: 0,
	
			// @option maxZoom: Number = undefined
			// The maximum zoom level up to which this layer will be displayed (inclusive).
			maxZoom: undefined,
	
			// @option maxNativeZoom: Number = undefined
			// Maximum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
			// from `maxNativeZoom` level and auto-scaled.
			maxNativeZoom: undefined,
	
			// @option minNativeZoom: Number = undefined
			// Minimum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
			// from `minNativeZoom` level and auto-scaled.
			minNativeZoom: undefined,
	
			// @option noWrap: Boolean = false
			// Whether the layer is wrapped around the antimeridian. If `true`, the
			// GridLayer will only be displayed once at low zoom levels. Has no
			// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
			// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
			// tiles outside the CRS limits.
			noWrap: false,
	
			// @option pane: String = 'tilePane'
			// `Map pane` where the grid layer will be added.
			pane: 'tilePane',
	
			// @option className: String = ''
			// A custom class name to assign to the tile layer. Empty by default.
			className: '',
	
			// @option keepBuffer: Number = 2
			// When panning the map, keep this many rows and columns of tiles before unloading them.
			keepBuffer: 2
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		onAdd: function () {
			this._initContainer();
	
			this._levels = {};
			this._tiles = {};
	
			this._resetView();
			this._update();
		},
	
		beforeAdd: function (map) {
			map._addZoomLimit(this);
		},
	
		onRemove: function (map) {
			this._removeAllTiles();
			remove(this._container);
			map._removeZoomLimit(this);
			this._container = null;
			this._tileZoom = undefined;
		},
	
		// @method bringToFront: this
		// Brings the tile layer to the top of all tile layers.
		bringToFront: function () {
			if (this._map) {
				toFront(this._container);
				this._setAutoZIndex(Math.max);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings the tile layer to the bottom of all tile layers.
		bringToBack: function () {
			if (this._map) {
				toBack(this._container);
				this._setAutoZIndex(Math.min);
			}
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the tiles for this layer.
		getContainer: function () {
			return this._container;
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the [opacity](#gridlayer-opacity) of the grid layer.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			this._updateOpacity();
			return this;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
		setZIndex: function (zIndex) {
			this.options.zIndex = zIndex;
			this._updateZIndex();
	
			return this;
		},
	
		// @method isLoading: Boolean
		// Returns `true` if any tile in the grid layer has not finished loading.
		isLoading: function () {
			return this._loading;
		},
	
		// @method redraw: this
		// Causes the layer to clear all the tiles and request them again.
		redraw: function () {
			if (this._map) {
				this._removeAllTiles();
				this._update();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				viewprereset: this._invalidateAll,
				viewreset: this._resetView,
				zoom: this._resetView,
				moveend: this._onMoveEnd
			};
	
			if (!this.options.updateWhenIdle) {
				// update tiles on move, but not more often than once per given interval
				if (!this._onMove) {
					this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
				}
	
				events.move = this._onMove;
			}
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @section Extension methods
		// Layers extending `GridLayer` shall reimplement the following method.
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, must be overridden by classes extending `GridLayer`.
		// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
		// is specified, it must be called when the tile has finished loading and drawing.
		createTile: function () {
			return document.createElement('div');
		},
	
		// @section
		// @method getTileSize: Point
		// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
		getTileSize: function () {
			var s = this.options.tileSize;
			return s instanceof Point ? s : new Point(s, s);
		},
	
		_updateZIndex: function () {
			if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._container.style.zIndex = this.options.zIndex;
			}
		},
	
		_setAutoZIndex: function (compare) {
			// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
			var layers = this.getPane().children,
			    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
			for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
				zIndex = layers[i].style.zIndex;
	
				if (layers[i] !== this._container && zIndex) {
					edgeZIndex = compare(edgeZIndex, +zIndex);
				}
			}
	
			if (isFinite(edgeZIndex)) {
				this.options.zIndex = edgeZIndex + compare(-1, 1);
				this._updateZIndex();
			}
		},
	
		_updateOpacity: function () {
			if (!this._map) { return; }
	
			// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
			if (ielt9) { return; }
	
			setOpacity(this._container, this.options.opacity);
	
			var now = +new Date(),
			    nextFrame = false,
			    willPrune = false;
	
			for (var key in this._tiles) {
				var tile = this._tiles[key];
				if (!tile.current || !tile.loaded) { continue; }
	
				var fade = Math.min(1, (now - tile.loaded) / 200);
	
				setOpacity(tile.el, fade);
				if (fade < 1) {
					nextFrame = true;
				} else {
					if (tile.active) {
						willPrune = true;
					} else {
						this._onOpaqueTile(tile);
					}
					tile.active = true;
				}
			}
	
			if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
			if (nextFrame) {
				cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
			}
		},
	
		_onOpaqueTile: falseFn,
	
		_initContainer: function () {
			if (this._container) { return; }
	
			this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
			this._updateZIndex();
	
			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
	
			this.getPane().appendChild(this._container);
		},
	
		_updateLevels: function () {
	
			var zoom = this._tileZoom,
			    maxZoom = this.options.maxZoom;
	
			if (zoom === undefined) { return undefined; }
	
			for (var z in this._levels) {
				if (this._levels[z].el.children.length || z === zoom) {
					this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
					this._onUpdateLevel(z);
				} else {
					remove(this._levels[z].el);
					this._removeTilesAtZoom(z);
					this._onRemoveLevel(z);
					delete this._levels[z];
				}
			}
	
			var level = this._levels[zoom],
			    map = this._map;
	
			if (!level) {
				level = this._levels[zoom] = {};
	
				level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
				level.el.style.zIndex = maxZoom;
	
				level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
				level.zoom = zoom;
	
				this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
				// force the browser to consider the newly added element for transition
				falseFn(level.el.offsetWidth);
	
				this._onCreateLevel(level);
			}
	
			this._level = level;
	
			return level;
		},
	
		_onUpdateLevel: falseFn,
	
		_onRemoveLevel: falseFn,
	
		_onCreateLevel: falseFn,
	
		_pruneTiles: function () {
			if (!this._map) {
				return;
			}
	
			var key, tile;
	
			var zoom = this._map.getZoom();
			if (zoom > this.options.maxZoom ||
				zoom < this.options.minZoom) {
				this._removeAllTiles();
				return;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				tile.retain = tile.current;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				if (tile.current && !tile.active) {
					var coords = tile.coords;
					if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
						this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
					}
				}
			}
	
			for (key in this._tiles) {
				if (!this._tiles[key].retain) {
					this._removeTile(key);
				}
			}
		},
	
		_removeTilesAtZoom: function (zoom) {
			for (var key in this._tiles) {
				if (this._tiles[key].coords.z !== zoom) {
					continue;
				}
				this._removeTile(key);
			}
		},
	
		_removeAllTiles: function () {
			for (var key in this._tiles) {
				this._removeTile(key);
			}
		},
	
		_invalidateAll: function () {
			for (var z in this._levels) {
				remove(this._levels[z].el);
				this._onRemoveLevel(z);
				delete this._levels[z];
			}
			this._removeAllTiles();
	
			this._tileZoom = undefined;
		},
	
		_retainParent: function (x, y, z, minZoom) {
			var x2 = Math.floor(x / 2),
			    y2 = Math.floor(y / 2),
			    z2 = z - 1,
			    coords2 = new Point(+x2, +y2);
			coords2.z = +z2;
	
			var key = this._tileCoordsToKey(coords2),
			    tile = this._tiles[key];
	
			if (tile && tile.active) {
				tile.retain = true;
				return true;
	
			} else if (tile && tile.loaded) {
				tile.retain = true;
			}
	
			if (z2 > minZoom) {
				return this._retainParent(x2, y2, z2, minZoom);
			}
	
			return false;
		},
	
		_retainChildren: function (x, y, z, maxZoom) {
	
			for (var i = 2 * x; i < 2 * x + 2; i++) {
				for (var j = 2 * y; j < 2 * y + 2; j++) {
	
					var coords = new Point(i, j);
					coords.z = z + 1;
	
					var key = this._tileCoordsToKey(coords),
					    tile = this._tiles[key];
	
					if (tile && tile.active) {
						tile.retain = true;
						continue;
	
					} else if (tile && tile.loaded) {
						tile.retain = true;
					}
	
					if (z + 1 < maxZoom) {
						this._retainChildren(i, j, z + 1, maxZoom);
					}
				}
			}
		},
	
		_resetView: function (e) {
			var animating = e && (e.pinch || e.flyTo);
			this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
		},
	
		_animateZoom: function (e) {
			this._setView(e.center, e.zoom, true, e.noUpdate);
		},
	
		_clampZoom: function (zoom) {
			var options = this.options;
	
			if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
				return options.minNativeZoom;
			}
	
			if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
				return options.maxNativeZoom;
			}
	
			return zoom;
		},
	
		_setView: function (center, zoom, noPrune, noUpdate) {
			var tileZoom = this._clampZoom(Math.round(zoom));
			if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
			    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
				tileZoom = undefined;
			}
	
			var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
			if (!noUpdate || tileZoomChanged) {
	
				this._tileZoom = tileZoom;
	
				if (this._abortLoading) {
					this._abortLoading();
				}
	
				this._updateLevels();
				this._resetGrid();
	
				if (tileZoom !== undefined) {
					this._update(center);
				}
	
				if (!noPrune) {
					this._pruneTiles();
				}
	
				// Flag to prevent _updateOpacity from pruning tiles during
				// a zoom anim or a pinch gesture
				this._noPrune = !!noPrune;
			}
	
			this._setZoomTransforms(center, zoom);
		},
	
		_setZoomTransforms: function (center, zoom) {
			for (var i in this._levels) {
				this._setZoomTransform(this._levels[i], center, zoom);
			}
		},
	
		_setZoomTransform: function (level, center, zoom) {
			var scale = this._map.getZoomScale(zoom, level.zoom),
			    translate = level.origin.multiplyBy(scale)
			        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
			if (any3d) {
				setTransform(level.el, translate, scale);
			} else {
				setPosition(level.el, translate);
			}
		},
	
		_resetGrid: function () {
			var map = this._map,
			    crs = map.options.crs,
			    tileSize = this._tileSize = this.getTileSize(),
			    tileZoom = this._tileZoom;
	
			var bounds = this._map.getPixelWorldBounds(this._tileZoom);
			if (bounds) {
				this._globalTileRange = this._pxBoundsToTileRange(bounds);
			}
	
			this._wrapX = crs.wrapLng && !this.options.noWrap && [
				Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
				Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
			];
			this._wrapY = crs.wrapLat && !this.options.noWrap && [
				Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
				Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
			];
		},
	
		_onMoveEnd: function () {
			if (!this._map || this._map._animatingZoom) { return; }
	
			this._update();
		},
	
		_getTiledPixelBounds: function (center) {
			var map = this._map,
			    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
			    scale = map.getZoomScale(mapZoom, this._tileZoom),
			    pixelCenter = map.project(center, this._tileZoom).floor(),
			    halfSize = map.getSize().divideBy(scale * 2);
	
			return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
		},
	
		// Private method to load tiles in the grid's active zoom level according to map bounds
		_update: function (center) {
			var map = this._map;
			if (!map) { return; }
			var zoom = this._clampZoom(map.getZoom());
	
			if (center === undefined) { center = map.getCenter(); }
			if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
			var pixelBounds = this._getTiledPixelBounds(center),
			    tileRange = this._pxBoundsToTileRange(pixelBounds),
			    tileCenter = tileRange.getCenter(),
			    queue = [],
			    margin = this.options.keepBuffer,
			    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
			                              tileRange.getTopRight().add([margin, -margin]));
	
			// Sanity check: panic if the tile range contains Infinity somewhere.
			if (!(isFinite(tileRange.min.x) &&
			      isFinite(tileRange.min.y) &&
			      isFinite(tileRange.max.x) &&
			      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }
	
			for (var key in this._tiles) {
				var c = this._tiles[key].coords;
				if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
					this._tiles[key].current = false;
				}
			}
	
			// _update just loads more tiles. If the tile zoom level differs too much
			// from the map's, let _setView reset levels and prune old tiles.
			if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
			// create a queue of coordinates to load tiles from
			for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
				for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
					var coords = new Point(i, j);
					coords.z = this._tileZoom;
	
					if (!this._isValidTile(coords)) { continue; }
	
					var tile = this._tiles[this._tileCoordsToKey(coords)];
					if (tile) {
						tile.current = true;
					} else {
						queue.push(coords);
					}
				}
			}
	
			// sort tile queue to load tiles in order of their distance to center
			queue.sort(function (a, b) {
				return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
			});
	
			if (queue.length !== 0) {
				// if it's the first batch of tiles to load
				if (!this._loading) {
					this._loading = true;
					// @event loading: Event
					// Fired when the grid layer starts loading tiles.
					this.fire('loading');
				}
	
				// create DOM fragment to append tiles in one batch
				var fragment = document.createDocumentFragment();
	
				for (i = 0; i < queue.length; i++) {
					this._addTile(queue[i], fragment);
				}
	
				this._level.el.appendChild(fragment);
			}
		},
	
		_isValidTile: function (coords) {
			var crs = this._map.options.crs;
	
			if (!crs.infinite) {
				// don't load tile if it's out of bounds and not wrapped
				var bounds = this._globalTileRange;
				if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
				    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
			}
	
			if (!this.options.bounds) { return true; }
	
			// don't load tile if it doesn't intersect the bounds in options
			var tileBounds = this._tileCoordsToBounds(coords);
			return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
		},
	
		_keyToBounds: function (key) {
			return this._tileCoordsToBounds(this._keyToTileCoords(key));
		},
	
		_tileCoordsToNwSe: function (coords) {
			var map = this._map,
			    tileSize = this.getTileSize(),
			    nwPoint = coords.scaleBy(tileSize),
			    sePoint = nwPoint.add(tileSize),
			    nw = map.unproject(nwPoint, coords.z),
			    se = map.unproject(sePoint, coords.z);
			return [nw, se];
		},
	
		// converts tile coordinates to its geographical bounds
		_tileCoordsToBounds: function (coords) {
			var bp = this._tileCoordsToNwSe(coords),
			    bounds = new LatLngBounds(bp[0], bp[1]);
	
			if (!this.options.noWrap) {
				bounds = this._map.wrapLatLngBounds(bounds);
			}
			return bounds;
		},
		// converts tile coordinates to key for the tile cache
		_tileCoordsToKey: function (coords) {
			return coords.x + ':' + coords.y + ':' + coords.z;
		},
	
		// converts tile cache key to coordinates
		_keyToTileCoords: function (key) {
			var k = key.split(':'),
			    coords = new Point(+k[0], +k[1]);
			coords.z = +k[2];
			return coords;
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			remove(tile.el);
	
			delete this._tiles[key];
	
			// @event tileunload: TileEvent
			// Fired when a tile is removed (e.g. when a tile goes off the screen).
			this.fire('tileunload', {
				tile: tile.el,
				coords: this._keyToTileCoords(key)
			});
		},
	
		_initTile: function (tile) {
			addClass(tile, 'leaflet-tile');
	
			var tileSize = this.getTileSize();
			tile.style.width = tileSize.x + 'px';
			tile.style.height = tileSize.y + 'px';
	
			tile.onselectstart = falseFn;
			tile.onmousemove = falseFn;
	
			// update opacity on tiles in IE7-8 because of filter inheritance problems
			if (ielt9 && this.options.opacity < 1) {
				setOpacity(tile, this.options.opacity);
			}
	
			// without this hack, tiles disappear after zoom on Chrome for Android
			// https://github.com/Leaflet/Leaflet/issues/2078
			if (android && !android23) {
				tile.style.WebkitBackfaceVisibility = 'hidden';
			}
		},
	
		_addTile: function (coords, container) {
			var tilePos = this._getTilePos(coords),
			    key = this._tileCoordsToKey(coords);
	
			var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
	
			this._initTile(tile);
	
			// if createTile is defined with a second argument ("done" callback),
			// we know that tile is async and will be ready later; otherwise
			if (this.createTile.length < 2) {
				// mark tile as ready, but delay one frame for opacity animation to happen
				requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
			}
	
			setPosition(tile, tilePos);
	
			// save tile in cache
			this._tiles[key] = {
				el: tile,
				coords: coords,
				current: true
			};
	
			container.appendChild(tile);
			// @event tileloadstart: TileEvent
			// Fired when a tile is requested and starts loading.
			this.fire('tileloadstart', {
				tile: tile,
				coords: coords
			});
		},
	
		_tileReady: function (coords, err, tile) {
			if (err) {
				// @event tileerror: TileErrorEvent
				// Fired when there is an error loading a tile.
				this.fire('tileerror', {
					error: err,
					tile: tile,
					coords: coords
				});
			}
	
			var key = this._tileCoordsToKey(coords);
	
			tile = this._tiles[key];
			if (!tile) { return; }
	
			tile.loaded = +new Date();
			if (this._map._fadeAnimated) {
				setOpacity(tile.el, 0);
				cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
			} else {
				tile.active = true;
				this._pruneTiles();
			}
	
			if (!err) {
				addClass(tile.el, 'leaflet-tile-loaded');
	
				// @event tileload: TileEvent
				// Fired when a tile loads.
				this.fire('tileload', {
					tile: tile.el,
					coords: coords
				});
			}
	
			if (this._noTilesToLoad()) {
				this._loading = false;
				// @event load: Event
				// Fired when the grid layer loaded all visible tiles.
				this.fire('load');
	
				if (ielt9 || !this._map._fadeAnimated) {
					requestAnimFrame(this._pruneTiles, this);
				} else {
					// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
					// to trigger a pruning.
					setTimeout(bind(this._pruneTiles, this), 250);
				}
			}
		},
	
		_getTilePos: function (coords) {
			return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
		},
	
		_wrapCoords: function (coords) {
			var newCoords = new Point(
				this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
				this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
			newCoords.z = coords.z;
			return newCoords;
		},
	
		_pxBoundsToTileRange: function (bounds) {
			var tileSize = this.getTileSize();
			return new Bounds(
				bounds.min.unscaleBy(tileSize).floor(),
				bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
		},
	
		_noTilesToLoad: function () {
			for (var key in this._tiles) {
				if (!this._tiles[key].loaded) { return false; }
			}
			return true;
		}
	});
	
	// @factory L.gridLayer(options?: GridLayer options)
	// Creates a new instance of GridLayer with the supplied options.
	function gridLayer(options) {
		return new GridLayer(options);
	}
	
	/*
	 * @class TileLayer
	 * @inherits GridLayer
	 * @aka L.TileLayer
	 * Used to load and display tile layers on the map. Extends `GridLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar'}).addTo(map);
	 * ```
	 *
	 * @section URL template
	 * @example
	 *
	 * A string of the following form:
	 *
	 * ```
	 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	 * ```
	 *
	 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
	 *
	 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	 *
	 * ```
	 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	 * ```
	 */
	
	
	var TileLayer = GridLayer.extend({
	
		// @section
		// @aka TileLayer options
		options: {
			// @option minZoom: Number = 0
			// The minimum zoom level down to which this layer will be displayed (inclusive).
			minZoom: 0,
	
			// @option maxZoom: Number = 18
			// The maximum zoom level up to which this layer will be displayed (inclusive).
			maxZoom: 18,
	
			// @option subdomains: String|String[] = 'abc'
			// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
			subdomains: 'abc',
	
			// @option errorTileUrl: String = ''
			// URL to the tile image to show in place of the tile that failed to load.
			errorTileUrl: '',
	
			// @option zoomOffset: Number = 0
			// The zoom number used in tile URLs will be offset with this value.
			zoomOffset: 0,
	
			// @option tms: Boolean = false
			// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
			tms: false,
	
			// @option zoomReverse: Boolean = false
			// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
			zoomReverse: false,
	
			// @option detectRetina: Boolean = false
			// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
			detectRetina: false,
	
			// @option crossOrigin: Boolean|String = false
			// Whether the crossOrigin attribute will be added to the tiles.
			// If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
			// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
			crossOrigin: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			options = setOptions(this, options);
	
			// detecting retina displays, adjusting tileSize and zoom levels
			if (options.detectRetina && retina && options.maxZoom > 0) {
	
				options.tileSize = Math.floor(options.tileSize / 2);
	
				if (!options.zoomReverse) {
					options.zoomOffset++;
					options.maxZoom--;
				} else {
					options.zoomOffset--;
					options.minZoom++;
				}
	
				options.minZoom = Math.max(0, options.minZoom);
			}
	
			if (typeof options.subdomains === 'string') {
				options.subdomains = options.subdomains.split('');
			}
	
			// for https://github.com/Leaflet/Leaflet/issues/137
			if (!android) {
				this.on('tileunload', this._onTileRemove);
			}
		},
	
		// @method setUrl(url: String, noRedraw?: Boolean): this
		// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
		setUrl: function (url, noRedraw) {
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
			return this;
		},
	
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
		// to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
		// callback is called when the tile has been loaded.
		createTile: function (coords, done) {
			var tile = document.createElement('img');
	
			on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
			on(tile, 'error', bind(this._tileOnError, this, done, tile));
	
			if (this.options.crossOrigin || this.options.crossOrigin === '') {
				tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
			}
	
			/*
			 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
			 http://www.w3.org/TR/WCAG20-TECHS/H67
			*/
			tile.alt = '';
	
			/*
			 Set role="presentation" to force screen readers to ignore this
			 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
			*/
			tile.setAttribute('role', 'presentation');
	
			tile.src = this.getTileUrl(coords);
	
			return tile;
		},
	
		// @section Extension methods
		// @uninheritable
		// Layers extending `TileLayer` might reimplement the following method.
		// @method getTileUrl(coords: Object): String
		// Called only internally, returns the URL for a tile given its coordinates.
		// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
		getTileUrl: function (coords) {
			var data = {
				r: retina ? '@2x' : '',
				s: this._getSubdomain(coords),
				x: coords.x,
				y: coords.y,
				z: this._getZoomForUrl()
			};
			if (this._map && !this._map.options.crs.infinite) {
				var invertedY = this._globalTileRange.max.y - coords.y;
				if (this.options.tms) {
					data['y'] = invertedY;
				}
				data['-y'] = invertedY;
			}
	
			return template(this._url, extend(data, this.options));
		},
	
		_tileOnLoad: function (done, tile) {
			// For https://github.com/Leaflet/Leaflet/issues/3332
			if (ielt9) {
				setTimeout(bind(done, this, null, tile), 0);
			} else {
				done(null, tile);
			}
		},
	
		_tileOnError: function (done, tile, e) {
			var errorUrl = this.options.errorTileUrl;
			if (errorUrl && tile.getAttribute('src') !== errorUrl) {
				tile.src = errorUrl;
			}
			done(e, tile);
		},
	
		_onTileRemove: function (e) {
			e.tile.onload = null;
		},
	
		_getZoomForUrl: function () {
			var zoom = this._tileZoom,
			maxZoom = this.options.maxZoom,
			zoomReverse = this.options.zoomReverse,
			zoomOffset = this.options.zoomOffset;
	
			if (zoomReverse) {
				zoom = maxZoom - zoom;
			}
	
			return zoom + zoomOffset;
		},
	
		_getSubdomain: function (tilePoint) {
			var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
			return this.options.subdomains[index];
		},
	
		// stops loading all tiles in the background layer
		_abortLoading: function () {
			var i, tile;
			for (i in this._tiles) {
				if (this._tiles[i].coords.z !== this._tileZoom) {
					tile = this._tiles[i].el;
	
					tile.onload = falseFn;
					tile.onerror = falseFn;
	
					if (!tile.complete) {
						tile.src = emptyImageUrl;
						remove(tile);
						delete this._tiles[i];
					}
				}
			}
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			// Cancels any pending http requests associated with the tile
			// unless we're on Android's stock browser,
			// see https://github.com/Leaflet/Leaflet/issues/137
			if (!androidStock) {
				tile.el.setAttribute('src', emptyImageUrl);
			}
	
			return GridLayer.prototype._removeTile.call(this, key);
		},
	
		_tileReady: function (coords, err, tile) {
			if (!this._map || (tile && tile.getAttribute('src') === emptyImageUrl)) {
				return;
			}
	
			return GridLayer.prototype._tileReady.call(this, coords, err, tile);
		}
	});
	
	
	// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	// Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	function tileLayer(url, options) {
		return new TileLayer(url, options);
	}
	
	/*
	 * @class TileLayer.WMS
	 * @inherits TileLayer
	 * @aka L.TileLayer.WMS
	 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	 * 	layers: 'nexrad-n0r-900913',
	 * 	format: 'image/png',
	 * 	transparent: true,
	 * 	attribution: "Weather data © 2012 IEM Nexrad"
	 * });
	 * ```
	 */
	
	var TileLayerWMS = TileLayer.extend({
	
		// @section
		// @aka TileLayer.WMS options
		// If any custom options not documented here are used, they will be sent to the
		// WMS server as extra parameters in each request URL. This can be useful for
		// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
		defaultWmsParams: {
			service: 'WMS',
			request: 'GetMap',
	
			// @option layers: String = ''
			// **(required)** Comma-separated list of WMS layers to show.
			layers: '',
	
			// @option styles: String = ''
			// Comma-separated list of WMS styles.
			styles: '',
	
			// @option format: String = 'image/jpeg'
			// WMS image format (use `'image/png'` for layers with transparency).
			format: 'image/jpeg',
	
			// @option transparent: Boolean = false
			// If `true`, the WMS service will return images with transparency.
			transparent: false,
	
			// @option version: String = '1.1.1'
			// Version of the WMS service to use
			version: '1.1.1'
		},
	
		options: {
			// @option crs: CRS = null
			// Coordinate Reference System to use for the WMS requests, defaults to
			// map CRS. Don't change this if you're not sure what it means.
			crs: null,
	
			// @option uppercase: Boolean = false
			// If `true`, WMS request parameter keys will be uppercase.
			uppercase: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			var wmsParams = extend({}, this.defaultWmsParams);
	
			// all keys that are not TileLayer options go to WMS params
			for (var i in options) {
				if (!(i in this.options)) {
					wmsParams[i] = options[i];
				}
			}
	
			options = setOptions(this, options);
	
			var realRetina = options.detectRetina && retina ? 2 : 1;
			var tileSize = this.getTileSize();
			wmsParams.width = tileSize.x * realRetina;
			wmsParams.height = tileSize.y * realRetina;
	
			this.wmsParams = wmsParams;
		},
	
		onAdd: function (map) {
	
			this._crs = this.options.crs || map.options.crs;
			this._wmsVersion = parseFloat(this.wmsParams.version);
	
			var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
			this.wmsParams[projectionKey] = this._crs.code;
	
			TileLayer.prototype.onAdd.call(this, map);
		},
	
		getTileUrl: function (coords) {
	
			var tileBounds = this._tileCoordsToNwSe(coords),
			    crs = this._crs,
			    bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])),
			    min = bounds.min,
			    max = bounds.max,
			    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
			    [min.y, min.x, max.y, max.x] :
			    [min.x, min.y, max.x, max.y]).join(','),
			    url = TileLayer.prototype.getTileUrl.call(this, coords);
			return url +
				getParamString(this.wmsParams, url, this.options.uppercase) +
				(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
		},
	
		// @method setParams(params: Object, noRedraw?: Boolean): this
		// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
		setParams: function (params, noRedraw) {
	
			extend(this.wmsParams, params);
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		}
	});
	
	
	// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	function tileLayerWMS(url, options) {
		return new TileLayerWMS(url, options);
	}
	
	TileLayer.WMS = TileLayerWMS;
	tileLayer.wms = tileLayerWMS;
	
	/*
	 * @class Renderer
	 * @inherits Layer
	 * @aka L.Renderer
	 *
	 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	 * DOM container of the renderer, its bounds, and its zoom animation.
	 *
	 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	 * itself can be added or removed to the map. All paths use a renderer, which can
	 * be implicit (the map will decide the type of renderer and use it automatically)
	 * or explicit (using the [`renderer`](#path-renderer) option of the path).
	 *
	 * Do not use this class directly, use `SVG` and `Canvas` instead.
	 *
	 * @event update: Event
	 * Fired when the renderer updates its bounds, center and zoom, for example when
	 * its map has moved
	 */
	
	var Renderer = Layer.extend({
	
		// @section
		// @aka Renderer options
		options: {
			// @option padding: Number = 0.1
			// How much to extend the clip area around the map view (relative to its size)
			// e.g. 0.1 would be 10% of map view in each direction
			padding: 0.1,
	
			// @option tolerance: Number = 0
			// How much to extend click tolerance round a path/object on the map
			tolerance : 0
		},
	
		initialize: function (options) {
			setOptions(this, options);
			stamp(this);
			this._layers = this._layers || {};
		},
	
		onAdd: function () {
			if (!this._container) {
				this._initContainer(); // defined by renderer implementations
	
				if (this._zoomAnimated) {
					addClass(this._container, 'leaflet-zoom-animated');
				}
			}
	
			this.getPane().appendChild(this._container);
			this._update();
			this.on('update', this._updatePaths, this);
		},
	
		onRemove: function () {
			this.off('update', this._updatePaths, this);
			this._destroyContainer();
		},
	
		getEvents: function () {
			var events = {
				viewreset: this._reset,
				zoom: this._onZoom,
				moveend: this._update,
				zoomend: this._onZoomEnd
			};
			if (this._zoomAnimated) {
				events.zoomanim = this._onAnimZoom;
			}
			return events;
		},
	
		_onAnimZoom: function (ev) {
			this._updateTransform(ev.center, ev.zoom);
		},
	
		_onZoom: function () {
			this._updateTransform(this._map.getCenter(), this._map.getZoom());
		},
	
		_updateTransform: function (center, zoom) {
			var scale = this._map.getZoomScale(zoom, this._zoom),
			    position = getPosition(this._container),
			    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
			    currentCenterPoint = this._map.project(this._center, zoom),
			    destCenterPoint = this._map.project(center, zoom),
			    centerOffset = destCenterPoint.subtract(currentCenterPoint),
	
			    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
	
			if (any3d) {
				setTransform(this._container, topLeftOffset, scale);
			} else {
				setPosition(this._container, topLeftOffset);
			}
		},
	
		_reset: function () {
			this._update();
			this._updateTransform(this._center, this._zoom);
	
			for (var id in this._layers) {
				this._layers[id]._reset();
			}
		},
	
		_onZoomEnd: function () {
			for (var id in this._layers) {
				this._layers[id]._project();
			}
		},
	
		_updatePaths: function () {
			for (var id in this._layers) {
				this._layers[id]._update();
			}
		},
	
		_update: function () {
			// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
			// Subclasses are responsible of firing the 'update' event.
			var p = this.options.padding,
			    size = this._map.getSize(),
			    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
			this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
			this._center = this._map.getCenter();
			this._zoom = this._map.getZoom();
		}
	});
	
	/*
	 * @class Canvas
	 * @inherits Renderer
	 * @aka L.Canvas
	 *
	 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
	 * available in all web browsers, notably IE8, and overlapping geometries might
	 * not display properly in some edge cases.
	 *
	 * @example
	 *
	 * Use Canvas by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.canvas()
	 * });
	 * ```
	 *
	 * Use a Canvas renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.canvas({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	var Canvas = Renderer.extend({
		getEvents: function () {
			var events = Renderer.prototype.getEvents.call(this);
			events.viewprereset = this._onViewPreReset;
			return events;
		},
	
		_onViewPreReset: function () {
			// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
			this._postponeUpdatePaths = true;
		},
	
		onAdd: function () {
			Renderer.prototype.onAdd.call(this);
	
			// Redraw vectors since canvas is cleared upon removal,
			// in case of removing the renderer itself from the map.
			this._draw();
		},
	
		_initContainer: function () {
			var container = this._container = document.createElement('canvas');
	
			on(container, 'mousemove', throttle(this._onMouseMove, 32, this), this);
			on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
			on(container, 'mouseout', this._handleMouseOut, this);
	
			this._ctx = container.getContext('2d');
		},
	
		_destroyContainer: function () {
			cancelAnimFrame(this._redrawRequest);
			delete this._ctx;
			remove(this._container);
			off(this._container);
			delete this._container;
		},
	
		_updatePaths: function () {
			if (this._postponeUpdatePaths) { return; }
	
			var layer;
			this._redrawBounds = null;
			for (var id in this._layers) {
				layer = this._layers[id];
				layer._update();
			}
			this._redraw();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			this._drawnLayers = {};
	
			Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    container = this._container,
			    size = b.getSize(),
			    m = retina ? 2 : 1;
	
			setPosition(container, b.min);
	
			// set canvas size (also clearing it); use double size on retina
			container.width = m * size.x;
			container.height = m * size.y;
			container.style.width = size.x + 'px';
			container.style.height = size.y + 'px';
	
			if (retina) {
				this._ctx.scale(2, 2);
			}
	
			// translate so we use the same path coordinates after canvas element moves
			this._ctx.translate(-b.min.x, -b.min.y);
	
			// Tell paths to redraw themselves
			this.fire('update');
		},
	
		_reset: function () {
			Renderer.prototype._reset.call(this);
	
			if (this._postponeUpdatePaths) {
				this._postponeUpdatePaths = false;
				this._updatePaths();
			}
		},
	
		_initPath: function (layer) {
			this._updateDashArray(layer);
			this._layers[stamp(layer)] = layer;
	
			var order = layer._order = {
				layer: layer,
				prev: this._drawLast,
				next: null
			};
			if (this._drawLast) { this._drawLast.next = order; }
			this._drawLast = order;
			this._drawFirst = this._drawFirst || this._drawLast;
		},
	
		_addPath: function (layer) {
			this._requestRedraw(layer);
		},
	
		_removePath: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				this._drawLast = prev;
			}
			if (prev) {
				prev.next = next;
			} else {
				this._drawFirst = next;
			}
	
			delete this._drawnLayers[layer._leaflet_id];
	
			delete layer._order;
	
			delete this._layers[stamp(layer)];
	
			this._requestRedraw(layer);
		},
	
		_updatePath: function (layer) {
			// Redraw the union of the layer's old pixel
			// bounds and the new pixel bounds.
			this._extendRedrawBounds(layer);
			layer._project();
			layer._update();
			// The redraw will extend the redraw bounds
			// with the new pixel bounds.
			this._requestRedraw(layer);
		},
	
		_updateStyle: function (layer) {
			this._updateDashArray(layer);
			this._requestRedraw(layer);
		},
	
		_updateDashArray: function (layer) {
			if (typeof layer.options.dashArray === 'string') {
				var parts = layer.options.dashArray.split(/[, ]+/),
				    dashArray = [],
				    i;
				for (i = 0; i < parts.length; i++) {
					dashArray.push(Number(parts[i]));
				}
				layer.options._dashArray = dashArray;
			} else {
				layer.options._dashArray = layer.options.dashArray;
			}
		},
	
		_requestRedraw: function (layer) {
			if (!this._map) { return; }
	
			this._extendRedrawBounds(layer);
			this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
		},
	
		_extendRedrawBounds: function (layer) {
			if (layer._pxBounds) {
				var padding = (layer.options.weight || 0) + 1;
				this._redrawBounds = this._redrawBounds || new Bounds();
				this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
				this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
			}
		},
	
		_redraw: function () {
			this._redrawRequest = null;
	
			if (this._redrawBounds) {
				this._redrawBounds.min._floor();
				this._redrawBounds.max._ceil();
			}
	
			this._clear(); // clear layers in redraw bounds
			this._draw(); // draw layers
	
			this._redrawBounds = null;
		},
	
		_clear: function () {
			var bounds = this._redrawBounds;
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
			} else {
				this._ctx.clearRect(0, 0, this._container.width, this._container.height);
			}
		},
	
		_draw: function () {
			var layer, bounds = this._redrawBounds;
			this._ctx.save();
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.beginPath();
				this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
				this._ctx.clip();
			}
	
			this._drawing = true;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
					layer._updatePath();
				}
			}
	
			this._drawing = false;
	
			this._ctx.restore();  // Restore state before clipping.
		},
	
		_updatePoly: function (layer, closed) {
			if (!this._drawing) { return; }
	
			var i, j, len2, p,
			    parts = layer._parts,
			    len = parts.length,
			    ctx = this._ctx;
	
			if (!len) { return; }
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			ctx.beginPath();
	
			for (i = 0; i < len; i++) {
				for (j = 0, len2 = parts[i].length; j < len2; j++) {
					p = parts[i][j];
					ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
				}
				if (closed) {
					ctx.closePath();
				}
			}
	
			this._fillStroke(ctx, layer);
	
			// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
		},
	
		_updateCircle: function (layer) {
	
			if (!this._drawing || layer._empty()) { return; }
	
			var p = layer._point,
			    ctx = this._ctx,
			    r = Math.max(Math.round(layer._radius), 1),
			    s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			if (s !== 1) {
				ctx.save();
				ctx.scale(1, s);
			}
	
			ctx.beginPath();
			ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
			if (s !== 1) {
				ctx.restore();
			}
	
			this._fillStroke(ctx, layer);
		},
	
		_fillStroke: function (ctx, layer) {
			var options = layer.options;
	
			if (options.fill) {
				ctx.globalAlpha = options.fillOpacity;
				ctx.fillStyle = options.fillColor || options.color;
				ctx.fill(options.fillRule || 'evenodd');
			}
	
			if (options.stroke && options.weight !== 0) {
				if (ctx.setLineDash) {
					ctx.setLineDash(layer.options && layer.options._dashArray || []);
				}
				ctx.globalAlpha = options.opacity;
				ctx.lineWidth = options.weight;
				ctx.strokeStyle = options.color;
				ctx.lineCap = options.lineCap;
				ctx.lineJoin = options.lineJoin;
				ctx.stroke();
			}
		},
	
		// Canvas obviously doesn't have mouse events for individual drawn objects,
		// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
		_onClick: function (e) {
			var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
					clickedLayer = layer;
				}
			}
			if (clickedLayer)  {
				fakeStop(e);
				this._fireEvent([clickedLayer], e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
			var point = this._map.mouseEventToLayerPoint(e);
			this._handleMouseHover(e, point);
		},
	
	
		_handleMouseOut: function (e) {
			var layer = this._hoveredLayer;
			if (layer) {
				// if we're leaving the layer, fire mouseout
				removeClass(this._container, 'leaflet-interactive');
				this._fireEvent([layer], e, 'mouseout');
				this._hoveredLayer = null;
			}
		},
	
		_handleMouseHover: function (e, point) {
			var layer, candidateHoveredLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point)) {
					candidateHoveredLayer = layer;
				}
			}
	
			if (candidateHoveredLayer !== this._hoveredLayer) {
				this._handleMouseOut(e);
	
				if (candidateHoveredLayer) {
					addClass(this._container, 'leaflet-interactive'); // change cursor
					this._fireEvent([candidateHoveredLayer], e, 'mouseover');
					this._hoveredLayer = candidateHoveredLayer;
				}
			}
	
			if (this._hoveredLayer) {
				this._fireEvent([this._hoveredLayer], e);
			}
		},
	
		_fireEvent: function (layers, e, type) {
			this._map._fireDOMEvent(e, type || e.type, layers);
		},
	
		_bringToFront: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				// Already last
				return;
			}
			if (prev) {
				prev.next = next;
			} else if (next) {
				// Update first entry unless this is the
				// single entry
				this._drawFirst = next;
			}
	
			order.prev = this._drawLast;
			this._drawLast.next = order;
	
			order.next = null;
			this._drawLast = order;
	
			this._requestRedraw(layer);
		},
	
		_bringToBack: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (prev) {
				prev.next = next;
			} else {
				// Already first
				return;
			}
			if (next) {
				next.prev = prev;
			} else if (prev) {
				// Update last entry unless this is the
				// single entry
				this._drawLast = prev;
			}
	
			order.prev = null;
	
			order.next = this._drawFirst;
			this._drawFirst.prev = order;
			this._drawFirst = order;
	
			this._requestRedraw(layer);
		}
	});
	
	// @factory L.canvas(options?: Renderer options)
	// Creates a Canvas renderer with the given options.
	function canvas$1(options) {
		return canvas ? new Canvas(options) : null;
	}
	
	/*
	 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	 */
	
	
	var vmlCreate = (function () {
		try {
			document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
			return function (name) {
				return document.createElement('<lvml:' + name + ' class="lvml">');
			};
		} catch (e) {
			return function (name) {
				return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
			};
		}
	})();
	
	
	/*
	 * @class SVG
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language), and the SVG renderer will fall back to VML in this case.
	 *
	 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	 * with old versions of Internet Explorer.
	 */
	
	// mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
	var vmlMixin = {
	
		_initContainer: function () {
			this._container = create$1('div', 'leaflet-vml-container');
		},
	
		_update: function () {
			if (this._map._animatingZoom) { return; }
			Renderer.prototype._update.call(this);
			this.fire('update');
		},
	
		_initPath: function (layer) {
			var container = layer._container = vmlCreate('shape');
	
			addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
			container.coordsize = '1 1';
	
			layer._path = vmlCreate('path');
			container.appendChild(layer._path);
	
			this._updateStyle(layer);
			this._layers[stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			var container = layer._container;
			this._container.appendChild(container);
	
			if (layer.options.interactive) {
				layer.addInteractiveTarget(container);
			}
		},
	
		_removePath: function (layer) {
			var container = layer._container;
			remove(container);
			layer.removeInteractiveTarget(container);
			delete this._layers[stamp(layer)];
		},
	
		_updateStyle: function (layer) {
			var stroke = layer._stroke,
			    fill = layer._fill,
			    options = layer.options,
			    container = layer._container;
	
			container.stroked = !!options.stroke;
			container.filled = !!options.fill;
	
			if (options.stroke) {
				if (!stroke) {
					stroke = layer._stroke = vmlCreate('stroke');
				}
				container.appendChild(stroke);
				stroke.weight = options.weight + 'px';
				stroke.color = options.color;
				stroke.opacity = options.opacity;
	
				if (options.dashArray) {
					stroke.dashStyle = isArray(options.dashArray) ?
					    options.dashArray.join(' ') :
					    options.dashArray.replace(/( *, *)/g, ' ');
				} else {
					stroke.dashStyle = '';
				}
				stroke.endcap = options.lineCap.replace('butt', 'flat');
				stroke.joinstyle = options.lineJoin;
	
			} else if (stroke) {
				container.removeChild(stroke);
				layer._stroke = null;
			}
	
			if (options.fill) {
				if (!fill) {
					fill = layer._fill = vmlCreate('fill');
				}
				container.appendChild(fill);
				fill.color = options.fillColor || options.color;
				fill.opacity = options.fillOpacity;
	
			} else if (fill) {
				container.removeChild(fill);
				layer._fill = null;
			}
		},
	
		_updateCircle: function (layer) {
			var p = layer._point.round(),
			    r = Math.round(layer._radius),
			    r2 = Math.round(layer._radiusY || r);
	
			this._setPath(layer, layer._empty() ? 'M0 0' :
				'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
		},
	
		_setPath: function (layer, path) {
			layer._path.v = path;
		},
	
		_bringToFront: function (layer) {
			toFront(layer._container);
		},
	
		_bringToBack: function (layer) {
			toBack(layer._container);
		}
	};
	
	var create$2 = vml ? vmlCreate : svgCreate;
	
	/*
	 * @class SVG
	 * @inherits Renderer
	 * @aka L.SVG
	 *
	 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
	 * available in all web browsers, notably Android 2.x and 3.x.
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support
	 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	 * (a now deprecated technology), and the SVG renderer will fall back to VML in
	 * this case.
	 *
	 * @example
	 *
	 * Use SVG by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.svg()
	 * });
	 * ```
	 *
	 * Use a SVG renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.svg({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	var SVG = Renderer.extend({
	
		getEvents: function () {
			var events = Renderer.prototype.getEvents.call(this);
			events.zoomstart = this._onZoomStart;
			return events;
		},
	
		_initContainer: function () {
			this._container = create$2('svg');
	
			// makes it possible to click through svg root; we'll reset it back in individual paths
			this._container.setAttribute('pointer-events', 'none');
	
			this._rootGroup = create$2('g');
			this._container.appendChild(this._rootGroup);
		},
	
		_destroyContainer: function () {
			remove(this._container);
			off(this._container);
			delete this._container;
			delete this._rootGroup;
			delete this._svgSize;
		},
	
		_onZoomStart: function () {
			// Drag-then-pinch interactions might mess up the center and zoom.
			// In this case, the easiest way to prevent this is re-do the renderer
			//   bounds and padding when the zooming starts.
			this._update();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    size = b.getSize(),
			    container = this._container;
	
			// set size of svg-container if changed
			if (!this._svgSize || !this._svgSize.equals(size)) {
				this._svgSize = size;
				container.setAttribute('width', size.x);
				container.setAttribute('height', size.y);
			}
	
			// movement: update container viewBox so that we don't have to change coordinates of individual layers
			setPosition(container, b.min);
			container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
			this.fire('update');
		},
	
		// methods below are called by vector layers implementations
	
		_initPath: function (layer) {
			var path = layer._path = create$2('path');
	
			// @namespace Path
			// @option className: String = null
			// Custom class name set on an element. Only for SVG renderer.
			if (layer.options.className) {
				addClass(path, layer.options.className);
			}
	
			if (layer.options.interactive) {
				addClass(path, 'leaflet-interactive');
			}
	
			this._updateStyle(layer);
			this._layers[stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			if (!this._rootGroup) { this._initContainer(); }
			this._rootGroup.appendChild(layer._path);
			layer.addInteractiveTarget(layer._path);
		},
	
		_removePath: function (layer) {
			remove(layer._path);
			layer.removeInteractiveTarget(layer._path);
			delete this._layers[stamp(layer)];
		},
	
		_updatePath: function (layer) {
			layer._project();
			layer._update();
		},
	
		_updateStyle: function (layer) {
			var path = layer._path,
			    options = layer.options;
	
			if (!path) { return; }
	
			if (options.stroke) {
				path.setAttribute('stroke', options.color);
				path.setAttribute('stroke-opacity', options.opacity);
				path.setAttribute('stroke-width', options.weight);
				path.setAttribute('stroke-linecap', options.lineCap);
				path.setAttribute('stroke-linejoin', options.lineJoin);
	
				if (options.dashArray) {
					path.setAttribute('stroke-dasharray', options.dashArray);
				} else {
					path.removeAttribute('stroke-dasharray');
				}
	
				if (options.dashOffset) {
					path.setAttribute('stroke-dashoffset', options.dashOffset);
				} else {
					path.removeAttribute('stroke-dashoffset');
				}
			} else {
				path.setAttribute('stroke', 'none');
			}
	
			if (options.fill) {
				path.setAttribute('fill', options.fillColor || options.color);
				path.setAttribute('fill-opacity', options.fillOpacity);
				path.setAttribute('fill-rule', options.fillRule || 'evenodd');
			} else {
				path.setAttribute('fill', 'none');
			}
		},
	
		_updatePoly: function (layer, closed) {
			this._setPath(layer, pointsToPath(layer._parts, closed));
		},
	
		_updateCircle: function (layer) {
			var p = layer._point,
			    r = Math.max(Math.round(layer._radius), 1),
			    r2 = Math.max(Math.round(layer._radiusY), 1) || r,
			    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
			// drawing a circle with two half-arcs
			var d = layer._empty() ? 'M0 0' :
				'M' + (p.x - r) + ',' + p.y +
				arc + (r * 2) + ',0 ' +
				arc + (-r * 2) + ',0 ';
	
			this._setPath(layer, d);
		},
	
		_setPath: function (layer, path) {
			layer._path.setAttribute('d', path);
		},
	
		// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
		_bringToFront: function (layer) {
			toFront(layer._path);
		},
	
		_bringToBack: function (layer) {
			toBack(layer._path);
		}
	});
	
	if (vml) {
		SVG.include(vmlMixin);
	}
	
	// @namespace SVG
	// @factory L.svg(options?: Renderer options)
	// Creates a SVG renderer with the given options.
	function svg$1(options) {
		return svg || vml ? new SVG(options) : null;
	}
	
	Map.include({
		// @namespace Map; @method getRenderer(layer: Path): Renderer
		// Returns the instance of `Renderer` that should be used to render the given
		// `Path`. It will ensure that the `renderer` options of the map and paths
		// are respected, and that the renderers do exist on the map.
		getRenderer: function (layer) {
			// @namespace Path; @option renderer: Renderer
			// Use this specific instance of `Renderer` for this path. Takes
			// precedence over the map's [default renderer](#map-renderer).
			var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
			if (!renderer) {
				renderer = this._renderer = this._createRenderer();
			}
	
			if (!this.hasLayer(renderer)) {
				this.addLayer(renderer);
			}
			return renderer;
		},
	
		_getPaneRenderer: function (name) {
			if (name === 'overlayPane' || name === undefined) {
				return false;
			}
	
			var renderer = this._paneRenderers[name];
			if (renderer === undefined) {
				renderer = this._createRenderer({pane: name});
				this._paneRenderers[name] = renderer;
			}
			return renderer;
		},
	
		_createRenderer: function (options) {
			// @namespace Map; @option preferCanvas: Boolean = false
			// Whether `Path`s should be rendered on a `Canvas` renderer.
			// By default, all `Path`s are rendered in a `SVG` renderer.
			return (this.options.preferCanvas && canvas$1(options)) || svg$1(options);
		}
	});
	
	/*
	 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	 */
	
	/*
	 * @class Rectangle
	 * @aka L.Rectangle
	 * @inherits Polygon
	 *
	 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	 *
	 * @example
	 *
	 * ```js
	 * // define rectangle geographical bounds
	 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	 *
	 * // create an orange rectangle
	 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	 *
	 * // zoom the map to the rectangle bounds
	 * map.fitBounds(bounds);
	 * ```
	 *
	 */
	
	
	var Rectangle = Polygon.extend({
		initialize: function (latLngBounds, options) {
			Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
		},
	
		// @method setBounds(latLngBounds: LatLngBounds): this
		// Redraws the rectangle with the passed bounds.
		setBounds: function (latLngBounds) {
			return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
		},
	
		_boundsToLatLngs: function (latLngBounds) {
			latLngBounds = toLatLngBounds(latLngBounds);
			return [
				latLngBounds.getSouthWest(),
				latLngBounds.getNorthWest(),
				latLngBounds.getNorthEast(),
				latLngBounds.getSouthEast()
			];
		}
	});
	
	
	// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	function rectangle(latLngBounds, options) {
		return new Rectangle(latLngBounds, options);
	}
	
	SVG.create = create$2;
	SVG.pointsToPath = pointsToPath;
	
	GeoJSON.geometryToLayer = geometryToLayer;
	GeoJSON.coordsToLatLng = coordsToLatLng;
	GeoJSON.coordsToLatLngs = coordsToLatLngs;
	GeoJSON.latLngToCoords = latLngToCoords;
	GeoJSON.latLngsToCoords = latLngsToCoords;
	GeoJSON.getFeature = getFeature;
	GeoJSON.asFeature = asFeature;
	
	/*
	 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	 * (zoom to a selected bounding box), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @option boxZoom: Boolean = true
		// Whether the map can be zoomed to a rectangular area specified by
		// dragging the mouse while pressing the shift key.
		boxZoom: true
	});
	
	var BoxZoom = Handler.extend({
		initialize: function (map) {
			this._map = map;
			this._container = map._container;
			this._pane = map._panes.overlayPane;
			this._resetStateTimeout = 0;
			map.on('unload', this._destroy, this);
		},
	
		addHooks: function () {
			on(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		removeHooks: function () {
			off(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		moved: function () {
			return this._moved;
		},
	
		_destroy: function () {
			remove(this._pane);
			delete this._pane;
		},
	
		_resetState: function () {
			this._resetStateTimeout = 0;
			this._moved = false;
		},
	
		_clearDeferredResetState: function () {
			if (this._resetStateTimeout !== 0) {
				clearTimeout(this._resetStateTimeout);
				this._resetStateTimeout = 0;
			}
		},
	
		_onMouseDown: function (e) {
			if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
			// Clear the deferred resetState if it hasn't executed yet, otherwise it
			// will interrupt the interaction and orphan a box element in the container.
			this._clearDeferredResetState();
			this._resetState();
	
			disableTextSelection();
			disableImageDrag();
	
			this._startPoint = this._map.mouseEventToContainerPoint(e);
	
			on(document, {
				contextmenu: stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseMove: function (e) {
			if (!this._moved) {
				this._moved = true;
	
				this._box = create$1('div', 'leaflet-zoom-box', this._container);
				addClass(this._container, 'leaflet-crosshair');
	
				this._map.fire('boxzoomstart');
			}
	
			this._point = this._map.mouseEventToContainerPoint(e);
	
			var bounds = new Bounds(this._point, this._startPoint),
			    size = bounds.getSize();
	
			setPosition(this._box, bounds.min);
	
			this._box.style.width  = size.x + 'px';
			this._box.style.height = size.y + 'px';
		},
	
		_finish: function () {
			if (this._moved) {
				remove(this._box);
				removeClass(this._container, 'leaflet-crosshair');
			}
	
			enableTextSelection();
			enableImageDrag();
	
			off(document, {
				contextmenu: stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseUp: function (e) {
			if ((e.which !== 1) && (e.button !== 1)) { return; }
	
			this._finish();
	
			if (!this._moved) { return; }
			// Postpone to next JS tick so internal click event handling
			// still see it as "moved".
			this._clearDeferredResetState();
			this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
	
			var bounds = new LatLngBounds(
			        this._map.containerPointToLatLng(this._startPoint),
			        this._map.containerPointToLatLng(this._point));
	
			this._map
				.fitBounds(bounds)
				.fire('boxzoomend', {boxZoomBounds: bounds});
		},
	
		_onKeyDown: function (e) {
			if (e.keyCode === 27) {
				this._finish();
			}
		}
	});
	
	// @section Handlers
	// @property boxZoom: Handler
	// Box (shift-drag with mouse) zoom handler.
	Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
	
	/*
	 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	
	Map.mergeOptions({
		// @option doubleClickZoom: Boolean|String = true
		// Whether the map can be zoomed in by double clicking on it and
		// zoomed out by double clicking while holding shift. If passed
		// `'center'`, double-click zoom will zoom to the center of the
		//  view regardless of where the mouse was.
		doubleClickZoom: true
	});
	
	var DoubleClickZoom = Handler.extend({
		addHooks: function () {
			this._map.on('dblclick', this._onDoubleClick, this);
		},
	
		removeHooks: function () {
			this._map.off('dblclick', this._onDoubleClick, this);
		},
	
		_onDoubleClick: function (e) {
			var map = this._map,
			    oldZoom = map.getZoom(),
			    delta = map.options.zoomDelta,
			    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
			if (map.options.doubleClickZoom === 'center') {
				map.setZoom(zoom);
			} else {
				map.setZoomAround(e.containerPoint, zoom);
			}
		}
	});
	
	// @section Handlers
	//
	// Map properties include interaction handlers that allow you to control
	// interaction behavior in runtime, enabling or disabling certain features such
	// as dragging or touch zoom (see `Handler` methods). For example:
	//
	// ```js
	// map.doubleClickZoom.disable();
	// ```
	//
	// @property doubleClickZoom: Handler
	// Double click zoom handler.
	Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
	
	/*
	 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @option dragging: Boolean = true
		// Whether the map be draggable with mouse/touch or not.
		dragging: true,
	
		// @section Panning Inertia Options
		// @option inertia: Boolean = *
		// If enabled, panning of the map will have an inertia effect where
		// the map builds momentum while dragging and continues moving in
		// the same direction for some time. Feels especially nice on touch
		// devices. Enabled by default unless running on old Android devices.
		inertia: !android23,
	
		// @option inertiaDeceleration: Number = 3000
		// The rate with which the inertial movement slows down, in pixels/second².
		inertiaDeceleration: 3400, // px/s^2
	
		// @option inertiaMaxSpeed: Number = Infinity
		// Max speed of the inertial movement, in pixels/second.
		inertiaMaxSpeed: Infinity, // px/s
	
		// @option easeLinearity: Number = 0.2
		easeLinearity: 0.2,
	
		// TODO refactor, move to CRS
		// @option worldCopyJump: Boolean = false
		// With this option enabled, the map tracks when you pan to another "copy"
		// of the world and seamlessly jumps to the original one so that all overlays
		// like markers and vector layers are still visible.
		worldCopyJump: false,
	
		// @option maxBoundsViscosity: Number = 0.0
		// If `maxBounds` is set, this option will control how solid the bounds
		// are when dragging the map around. The default value of `0.0` allows the
		// user to drag outside the bounds at normal speed, higher values will
		// slow down map dragging outside bounds, and `1.0` makes the bounds fully
		// solid, preventing the user from dragging outside the bounds.
		maxBoundsViscosity: 0.0
	});
	
	var Drag = Handler.extend({
		addHooks: function () {
			if (!this._draggable) {
				var map = this._map;
	
				this._draggable = new Draggable(map._mapPane, map._container);
	
				this._draggable.on({
					dragstart: this._onDragStart,
					drag: this._onDrag,
					dragend: this._onDragEnd
				}, this);
	
				this._draggable.on('predrag', this._onPreDragLimit, this);
				if (map.options.worldCopyJump) {
					this._draggable.on('predrag', this._onPreDragWrap, this);
					map.on('zoomend', this._onZoomEnd, this);
	
					map.whenReady(this._onZoomEnd, this);
				}
			}
			addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
			this._draggable.enable();
			this._positions = [];
			this._times = [];
		},
	
		removeHooks: function () {
			removeClass(this._map._container, 'leaflet-grab');
			removeClass(this._map._container, 'leaflet-touch-drag');
			this._draggable.disable();
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		moving: function () {
			return this._draggable && this._draggable._moving;
		},
	
		_onDragStart: function () {
			var map = this._map;
	
			map._stop();
			if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
				var bounds = toLatLngBounds(this._map.options.maxBounds);
	
				this._offsetLimit = toBounds(
					this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
					this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
						.add(this._map.getSize()));
	
				this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
			} else {
				this._offsetLimit = null;
			}
	
			map
			    .fire('movestart')
			    .fire('dragstart');
	
			if (map.options.inertia) {
				this._positions = [];
				this._times = [];
			}
		},
	
		_onDrag: function (e) {
			if (this._map.options.inertia) {
				var time = this._lastTime = +new Date(),
				    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
				this._positions.push(pos);
				this._times.push(time);
	
				this._prunePositions(time);
			}
	
			this._map
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_prunePositions: function (time) {
			while (this._positions.length > 1 && time - this._times[0] > 50) {
				this._positions.shift();
				this._times.shift();
			}
		},
	
		_onZoomEnd: function () {
			var pxCenter = this._map.getSize().divideBy(2),
			    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
			this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
			this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
		},
	
		_viscousLimit: function (value, threshold) {
			return value - (value - threshold) * this._viscosity;
		},
	
		_onPreDragLimit: function () {
			if (!this._viscosity || !this._offsetLimit) { return; }
	
			var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
			var limit = this._offsetLimit;
			if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
			if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
			if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
			if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
			this._draggable._newPos = this._draggable._startPos.add(offset);
		},
	
		_onPreDragWrap: function () {
			// TODO refactor to be able to adjust map pane position after zoom
			var worldWidth = this._worldWidth,
			    halfWidth = Math.round(worldWidth / 2),
			    dx = this._initialWorldOffset,
			    x = this._draggable._newPos.x,
			    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
			    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
			    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
			this._draggable._absPos = this._draggable._newPos.clone();
			this._draggable._newPos.x = newX;
		},
	
		_onDragEnd: function (e) {
			var map = this._map,
			    options = map.options,
	
			    noInertia = !options.inertia || this._times.length < 2;
	
			map.fire('dragend', e);
	
			if (noInertia) {
				map.fire('moveend');
	
			} else {
				this._prunePositions(+new Date());
	
				var direction = this._lastPos.subtract(this._positions[0]),
				    duration = (this._lastTime - this._times[0]) / 1000,
				    ease = options.easeLinearity,
	
				    speedVector = direction.multiplyBy(ease / duration),
				    speed = speedVector.distanceTo([0, 0]),
	
				    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
				    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
				    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
				    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
				if (!offset.x && !offset.y) {
					map.fire('moveend');
	
				} else {
					offset = map._limitOffset(offset, map.options.maxBounds);
	
					requestAnimFrame(function () {
						map.panBy(offset, {
							duration: decelerationDuration,
							easeLinearity: ease,
							noMoveStart: true,
							animate: true
						});
					});
				}
			}
		}
	});
	
	// @section Handlers
	// @property dragging: Handler
	// Map dragging handler (by both mouse and touch).
	Map.addInitHook('addHandler', 'dragging', Drag);
	
	/*
	 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Keyboard Navigation Options
	Map.mergeOptions({
		// @option keyboard: Boolean = true
		// Makes the map focusable and allows users to navigate the map with keyboard
		// arrows and `+`/`-` keys.
		keyboard: true,
	
		// @option keyboardPanDelta: Number = 80
		// Amount of pixels to pan when pressing an arrow key.
		keyboardPanDelta: 80
	});
	
	var Keyboard = Handler.extend({
	
		keyCodes: {
			left:    [37],
			right:   [39],
			down:    [40],
			up:      [38],
			zoomIn:  [187, 107, 61, 171],
			zoomOut: [189, 109, 54, 173]
		},
	
		initialize: function (map) {
			this._map = map;
	
			this._setPanDelta(map.options.keyboardPanDelta);
			this._setZoomDelta(map.options.zoomDelta);
		},
	
		addHooks: function () {
			var container = this._map._container;
	
			// make the container focusable by tabbing
			if (container.tabIndex <= 0) {
				container.tabIndex = '0';
			}
	
			on(container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.on({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		removeHooks: function () {
			this._removeHooks();
	
			off(this._map._container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.off({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		_onMouseDown: function () {
			if (this._focused) { return; }
	
			var body = document.body,
			    docEl = document.documentElement,
			    top = body.scrollTop || docEl.scrollTop,
			    left = body.scrollLeft || docEl.scrollLeft;
	
			this._map._container.focus();
	
			window.scrollTo(left, top);
		},
	
		_onFocus: function () {
			this._focused = true;
			this._map.fire('focus');
		},
	
		_onBlur: function () {
			this._focused = false;
			this._map.fire('blur');
		},
	
		_setPanDelta: function (panDelta) {
			var keys = this._panKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.left.length; i < len; i++) {
				keys[codes.left[i]] = [-1 * panDelta, 0];
			}
			for (i = 0, len = codes.right.length; i < len; i++) {
				keys[codes.right[i]] = [panDelta, 0];
			}
			for (i = 0, len = codes.down.length; i < len; i++) {
				keys[codes.down[i]] = [0, panDelta];
			}
			for (i = 0, len = codes.up.length; i < len; i++) {
				keys[codes.up[i]] = [0, -1 * panDelta];
			}
		},
	
		_setZoomDelta: function (zoomDelta) {
			var keys = this._zoomKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.zoomIn.length; i < len; i++) {
				keys[codes.zoomIn[i]] = zoomDelta;
			}
			for (i = 0, len = codes.zoomOut.length; i < len; i++) {
				keys[codes.zoomOut[i]] = -zoomDelta;
			}
		},
	
		_addHooks: function () {
			on(document, 'keydown', this._onKeyDown, this);
		},
	
		_removeHooks: function () {
			off(document, 'keydown', this._onKeyDown, this);
		},
	
		_onKeyDown: function (e) {
			if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
			var key = e.keyCode,
			    map = this._map,
			    offset;
	
			if (key in this._panKeys) {
				if (!map._panAnim || !map._panAnim._inProgress) {
					offset = this._panKeys[key];
					if (e.shiftKey) {
						offset = toPoint(offset).multiplyBy(3);
					}
	
					map.panBy(offset);
	
					if (map.options.maxBounds) {
						map.panInsideBounds(map.options.maxBounds);
					}
				}
			} else if (key in this._zoomKeys) {
				map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
			} else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
				map.closePopup();
	
			} else {
				return;
			}
	
			stop(e);
		}
	});
	
	// @section Handlers
	// @section Handlers
	// @property keyboard: Handler
	// Keyboard navigation handler.
	Map.addInitHook('addHandler', 'keyboard', Keyboard);
	
	/*
	 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Mousewheel options
		// @option scrollWheelZoom: Boolean|String = true
		// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
		// it will zoom to the center of the view regardless of where the mouse was.
		scrollWheelZoom: true,
	
		// @option wheelDebounceTime: Number = 40
		// Limits the rate at which a wheel can fire (in milliseconds). By default
		// user can't zoom via wheel more often than once per 40 ms.
		wheelDebounceTime: 40,
	
		// @option wheelPxPerZoomLevel: Number = 60
		// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
		// mean a change of one full zoom level. Smaller values will make wheel-zooming
		// faster (and vice versa).
		wheelPxPerZoomLevel: 60
	});
	
	var ScrollWheelZoom = Handler.extend({
		addHooks: function () {
			on(this._map._container, 'mousewheel', this._onWheelScroll, this);
	
			this._delta = 0;
		},
	
		removeHooks: function () {
			off(this._map._container, 'mousewheel', this._onWheelScroll, this);
		},
	
		_onWheelScroll: function (e) {
			var delta = getWheelDelta(e);
	
			var debounce = this._map.options.wheelDebounceTime;
	
			this._delta += delta;
			this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
			if (!this._startTime) {
				this._startTime = +new Date();
			}
	
			var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
			clearTimeout(this._timer);
			this._timer = setTimeout(bind(this._performZoom, this), left);
	
			stop(e);
		},
	
		_performZoom: function () {
			var map = this._map,
			    zoom = map.getZoom(),
			    snap = this._map.options.zoomSnap || 0;
	
			map._stop(); // stop panning and fly animations if any
	
			// map the delta with a sigmoid function to -4..4 range leaning on -1..1
			var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
			    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
			    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
			    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
			this._delta = 0;
			this._startTime = null;
	
			if (!delta) { return; }
	
			if (map.options.scrollWheelZoom === 'center') {
				map.setZoom(zoom + delta);
			} else {
				map.setZoomAround(this._lastMousePos, zoom + delta);
			}
		}
	});
	
	// @section Handlers
	// @property scrollWheelZoom: Handler
	// Scroll wheel zoom handler.
	Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
	
	/*
	 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Touch interaction options
		// @option tap: Boolean = true
		// Enables mobile hacks for supporting instant taps (fixing 200ms click
		// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
		tap: true,
	
		// @option tapTolerance: Number = 15
		// The max number of pixels a user can shift his finger during touch
		// for it to be considered a valid tap.
		tapTolerance: 15
	});
	
	var Tap = Handler.extend({
		addHooks: function () {
			on(this._map._container, 'touchstart', this._onDown, this);
		},
	
		removeHooks: function () {
			off(this._map._container, 'touchstart', this._onDown, this);
		},
	
		_onDown: function (e) {
			if (!e.touches) { return; }
	
			preventDefault(e);
	
			this._fireClick = true;
	
			// don't simulate click or track longpress if more than 1 touch
			if (e.touches.length > 1) {
				this._fireClick = false;
				clearTimeout(this._holdTimeout);
				return;
			}
	
			var first = e.touches[0],
			    el = first.target;
	
			this._startPos = this._newPos = new Point(first.clientX, first.clientY);
	
			// if touching a link, highlight it
			if (el.tagName && el.tagName.toLowerCase() === 'a') {
				addClass(el, 'leaflet-active');
			}
	
			// simulate long hold but setting a timeout
			this._holdTimeout = setTimeout(bind(function () {
				if (this._isTapValid()) {
					this._fireClick = false;
					this._onUp();
					this._simulateEvent('contextmenu', first);
				}
			}, this), 1000);
	
			this._simulateEvent('mousedown', first);
	
			on(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
		},
	
		_onUp: function (e) {
			clearTimeout(this._holdTimeout);
	
			off(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
	
			if (this._fireClick && e && e.changedTouches) {
	
				var first = e.changedTouches[0],
				    el = first.target;
	
				if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
					removeClass(el, 'leaflet-active');
				}
	
				this._simulateEvent('mouseup', first);
	
				// simulate click if the touch didn't move too much
				if (this._isTapValid()) {
					this._simulateEvent('click', first);
				}
			}
		},
	
		_isTapValid: function () {
			return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
		},
	
		_onMove: function (e) {
			var first = e.touches[0];
			this._newPos = new Point(first.clientX, first.clientY);
			this._simulateEvent('mousemove', first);
		},
	
		_simulateEvent: function (type, e) {
			var simulatedEvent = document.createEvent('MouseEvents');
	
			simulatedEvent._simulated = true;
			e.target._simulatedClick = true;
	
			simulatedEvent.initMouseEvent(
			        type, true, true, window, 1,
			        e.screenX, e.screenY,
			        e.clientX, e.clientY,
			        false, false, false, false, 0, null);
	
			e.target.dispatchEvent(simulatedEvent);
		}
	});
	
	// @section Handlers
	// @property tap: Handler
	// Mobile touch hacks (quick tap and touch hold) handler.
	if (touch && !pointer) {
		Map.addInitHook('addHandler', 'tap', Tap);
	}
	
	/*
	 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Touch interaction options
		// @option touchZoom: Boolean|String = *
		// Whether the map can be zoomed by touch-dragging with two fingers. If
		// passed `'center'`, it will zoom to the center of the view regardless of
		// where the touch events (fingers) were. Enabled for touch-capable web
		// browsers except for old Androids.
		touchZoom: touch && !android23,
	
		// @option bounceAtZoomLimits: Boolean = true
		// Set it to false if you don't want the map to zoom beyond min/max zoom
		// and then bounce back when pinch-zooming.
		bounceAtZoomLimits: true
	});
	
	var TouchZoom = Handler.extend({
		addHooks: function () {
			addClass(this._map._container, 'leaflet-touch-zoom');
			on(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		removeHooks: function () {
			removeClass(this._map._container, 'leaflet-touch-zoom');
			off(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		_onTouchStart: function (e) {
			var map = this._map;
			if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
			var p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
			this._centerPoint = map.getSize()._divideBy(2);
			this._startLatLng = map.containerPointToLatLng(this._centerPoint);
			if (map.options.touchZoom !== 'center') {
				this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
			}
	
			this._startDist = p1.distanceTo(p2);
			this._startZoom = map.getZoom();
	
			this._moved = false;
			this._zooming = true;
	
			map._stop();
	
			on(document, 'touchmove', this._onTouchMove, this);
			on(document, 'touchend', this._onTouchEnd, this);
	
			preventDefault(e);
		},
	
		_onTouchMove: function (e) {
			if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
			var map = this._map,
			    p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]),
			    scale = p1.distanceTo(p2) / this._startDist;
	
			this._zoom = map.getScaleZoom(scale, this._startZoom);
	
			if (!map.options.bounceAtZoomLimits && (
				(this._zoom < map.getMinZoom() && scale < 1) ||
				(this._zoom > map.getMaxZoom() && scale > 1))) {
				this._zoom = map._limitZoom(this._zoom);
			}
	
			if (map.options.touchZoom === 'center') {
				this._center = this._startLatLng;
				if (scale === 1) { return; }
			} else {
				// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
				var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
				if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
				this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
			}
	
			if (!this._moved) {
				map._moveStart(true, false);
				this._moved = true;
			}
	
			cancelAnimFrame(this._animRequest);
	
			var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
			this._animRequest = requestAnimFrame(moveFn, this, true);
	
			preventDefault(e);
		},
	
		_onTouchEnd: function () {
			if (!this._moved || !this._zooming) {
				this._zooming = false;
				return;
			}
	
			this._zooming = false;
			cancelAnimFrame(this._animRequest);
	
			off(document, 'touchmove', this._onTouchMove);
			off(document, 'touchend', this._onTouchEnd);
	
			// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
			if (this._map.options.zoomAnimation) {
				this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
			} else {
				this._map._resetView(this._center, this._map._limitZoom(this._zoom));
			}
		}
	});
	
	// @section Handlers
	// @property touchZoom: Handler
	// Touch zoom handler.
	Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
	
	Map.BoxZoom = BoxZoom;
	Map.DoubleClickZoom = DoubleClickZoom;
	Map.Drag = Drag;
	Map.Keyboard = Keyboard;
	Map.ScrollWheelZoom = ScrollWheelZoom;
	Map.Tap = Tap;
	Map.TouchZoom = TouchZoom;
	
	Object.freeze = freeze;
	
	exports.version = version;
	exports.Control = Control;
	exports.control = control;
	exports.Browser = Browser;
	exports.Evented = Evented;
	exports.Mixin = Mixin;
	exports.Util = Util;
	exports.Class = Class;
	exports.Handler = Handler;
	exports.extend = extend;
	exports.bind = bind;
	exports.stamp = stamp;
	exports.setOptions = setOptions;
	exports.DomEvent = DomEvent;
	exports.DomUtil = DomUtil;
	exports.PosAnimation = PosAnimation;
	exports.Draggable = Draggable;
	exports.LineUtil = LineUtil;
	exports.PolyUtil = PolyUtil;
	exports.Point = Point;
	exports.point = toPoint;
	exports.Bounds = Bounds;
	exports.bounds = toBounds;
	exports.Transformation = Transformation;
	exports.transformation = toTransformation;
	exports.Projection = index;
	exports.LatLng = LatLng;
	exports.latLng = toLatLng;
	exports.LatLngBounds = LatLngBounds;
	exports.latLngBounds = toLatLngBounds;
	exports.CRS = CRS;
	exports.GeoJSON = GeoJSON;
	exports.geoJSON = geoJSON;
	exports.geoJson = geoJson;
	exports.Layer = Layer;
	exports.LayerGroup = LayerGroup;
	exports.layerGroup = layerGroup;
	exports.FeatureGroup = FeatureGroup;
	exports.featureGroup = featureGroup;
	exports.ImageOverlay = ImageOverlay;
	exports.imageOverlay = imageOverlay;
	exports.VideoOverlay = VideoOverlay;
	exports.videoOverlay = videoOverlay;
	exports.DivOverlay = DivOverlay;
	exports.Popup = Popup;
	exports.popup = popup;
	exports.Tooltip = Tooltip;
	exports.tooltip = tooltip;
	exports.Icon = Icon;
	exports.icon = icon;
	exports.DivIcon = DivIcon;
	exports.divIcon = divIcon;
	exports.Marker = Marker;
	exports.marker = marker;
	exports.TileLayer = TileLayer;
	exports.tileLayer = tileLayer;
	exports.GridLayer = GridLayer;
	exports.gridLayer = gridLayer;
	exports.SVG = SVG;
	exports.svg = svg$1;
	exports.Renderer = Renderer;
	exports.Canvas = Canvas;
	exports.canvas = canvas$1;
	exports.Path = Path;
	exports.CircleMarker = CircleMarker;
	exports.circleMarker = circleMarker;
	exports.Circle = Circle;
	exports.circle = circle;
	exports.Polyline = Polyline;
	exports.polyline = polyline;
	exports.Polygon = Polygon;
	exports.polygon = polygon;
	exports.Rectangle = Rectangle;
	exports.rectangle = rectangle;
	exports.Map = Map;
	exports.map = createMap;
	
	var oldL = window.L;
	exports.noConflict = function() {
		window.L = oldL;
		return this;
	}
	
	// Always export us to window global (see #2364)
	window.L = exports;
	
	})));
	//# sourceMappingURL=leaflet-src.js.map


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(72),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(964),
	    mapCacheDelete = __webpack_require__(965),
	    mapCacheGet = __webpack_require__(966),
	    mapCacheHas = __webpack_require__(967),
	    mapCacheSet = __webpack_require__(968);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(131),
	    stackClear = __webpack_require__(977),
	    stackDelete = __webpack_require__(978),
	    stackGet = __webpack_require__(979),
	    stackHas = __webpack_require__(980),
	    stackSet = __webpack_require__(981);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(320);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(338);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(902),
	    stubArray = __webpack_require__(345);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(39),
	    isSymbol = __webpack_require__(212);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(332);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module)))

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(326),
	    castFunction = __webpack_require__(929);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(44),
	    stubFalse = __webpack_require__(993);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module)))

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateUtils = __webpack_require__(88);
	
	var _DatePickerDialog = __webpack_require__(1020);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _TextField = __webpack_require__(40);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePicker = function (_Component) {
	  (0, _inherits3.default)(DatePicker, _Component);
	
	  function DatePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      date: undefined
	    }, _this.handleAccept = function (date) {
	      if (!_this.isControlled()) {
	        _this.setState({
	          date: date
	        });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(null, date);
	      }
	    }, _this.handleFocus = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	
	      if (!_this.props.disabled) {
	        setTimeout(function () {
	          _this.openDialog();
	        }, 0);
	      }
	    }, _this.formatDate = function (date) {
	      if (_this.props.locale) {
	        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
	        return new DateTimeFormat(_this.props.locale, {
	          day: 'numeric',
	          month: 'numeric',
	          year: 'numeric'
	        }).format(date);
	      } else {
	        return (0, _dateUtils.formatIso)(date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isControlled()) {
	        var newDate = this.getControlledDate(nextProps);
	        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
	          this.setState({
	            date: newDate
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate() {
	      return this.state.date;
	    }
	
	    /**
	     * Open the date-picker dialog programmatically from a parent.
	     */
	
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      /**
	       * if the date is not selected then set it to new date
	       * (get the current system date while doing so)
	       * else set it to the currently selected date
	       */
	      if (this.state.date !== undefined) {
	        this.setState({
	          dialogDate: this.getDate()
	        }, this.refs.dialogWindow.show);
	      } else {
	        this.setState({
	          dialogDate: new Date()
	        }, this.refs.dialogWindow.show);
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'getControlledDate',
	    value: function getControlledDate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      if (props.value instanceof Date) {
	        return props.value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          className = _props.className,
	          container = _props.container,
	          defaultDate = _props.defaultDate,
	          dialogContainerStyle = _props.dialogContainerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          formatDateProp = _props.formatDate,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onDismiss = _props.onDismiss,
	          onFocus = _props.onFocus,
	          onShow = _props.onShow,
	          onTouchTap = _props.onTouchTap,
	          shouldDisableDate = _props.shouldDisableDate,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onTouchTap', 'shouldDisableDate', 'style', 'textFieldStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var formatDate = formatDateProp || this.formatDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          onFocus: this.handleFocus,
	          onTouchTap: this.handleTouchTap,
	          ref: 'input',
	          style: textFieldStyle,
	          value: this.state.date ? formatDate(this.state.date) : ''
	        })),
	        _react2.default.createElement(_DatePickerDialog2.default, {
	          DateTimeFormat: DateTimeFormat,
	          autoOk: autoOk,
	          cancelLabel: cancelLabel,
	          container: container,
	          containerStyle: dialogContainerStyle,
	          disableYearSelection: disableYearSelection,
	          firstDayOfWeek: firstDayOfWeek,
	          initialDate: this.state.dialogDate,
	          locale: locale,
	          maxDate: maxDate,
	          minDate: minDate,
	          mode: mode,
	          okLabel: okLabel,
	          onAccept: this.handleAccept,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          ref: 'dialogWindow',
	          shouldDisableDate: shouldDisableDate
	        })
	      );
	    }
	  }]);
	  return DatePicker;
	}(_react.Component);
	
	DatePicker.defaultProps = {
	  autoOk: false,
	  container: 'dialog',
	  disabled: false,
	  disableYearSelection: false,
	  firstDayOfWeek: 1,
	  style: {}
	};
	DatePicker.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DatePicker.propTypes = {
	  /**
	   * Constructor for date formatting for the specified `locale`.
	   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
	   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
	   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
	   *
	   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
	   */
	  DateTimeFormat: _react.PropTypes.func,
	  /**
	   * If true, automatically accept and close the picker on select a date.
	   */
	  autoOk: _react.PropTypes.bool,
	  /**
	   * Override the default text of the 'Cancel' button.
	   */
	  cancelLabel: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Used to control how the Date Picker will be displayed when the input field is focused.
	   * `dialog` (default) displays the DatePicker as a dialog with a modal.
	   * `inline` displays the DatePicker below the input field (similar to auto complete).
	   */
	  container: _react.PropTypes.oneOf(['dialog', 'inline']),
	  /**
	   * This is the initial date value of the component.
	   * If either `value` or `valueLink` is provided they will override this
	   * prop with `value` taking precedence.
	   */
	  defaultDate: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of DatePickerDialog's Container element.
	   */
	  dialogContainerStyle: _react.PropTypes.object,
	  /**
	   * Disables the year selection in the date picker.
	   */
	  disableYearSelection: _react.PropTypes.bool,
	  /**
	   * Disables the DatePicker.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Used to change the first day of week. It varies from
	   * Saturday to Monday between different locales.
	   * The allowed range is 0 (Sunday) to 6 (Saturday).
	   * The default is `1`, Monday, as per ISO 8601.
	   */
	  firstDayOfWeek: _react.PropTypes.number,
	  /**
	   * This function is called to format the date displayed in the input field, and should return a string.
	   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
	   *
	   * @param {object} date Date object to be formatted.
	   * @returns {any} The formatted date.
	   */
	  formatDate: _react.PropTypes.func,
	  /**
	   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
	   * must provide a `DateTimeFormat` that supports the chosen `locale`.
	   */
	  locale: _react.PropTypes.string,
	  /**
	   * The ending of a range of valid dates. The range includes the endDate.
	   * The default value is current date + 100 years.
	   */
	  maxDate: _react.PropTypes.object,
	  /**
	   * The beginning of a range of valid dates. The range includes the startDate.
	   * The default value is current date - 100 years.
	   */
	  minDate: _react.PropTypes.object,
	  /**
	   * Tells the component to display the picker in portrait or landscape mode.
	   */
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  /**
	   * Override the default text of the 'OK' button.
	   */
	  okLabel: _react.PropTypes.node,
	  /**
	   * Callback function that is fired when the date value changes.
	   *
	   * @param {null} null Since there is no particular event associated with the change,
	   * the first argument will always be null.
	   * @param {object} date The new date.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is dismissed.
	   */
	  onDismiss: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's `TextField` gains focus.
	   */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is shown.
	   */
	  onShow: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when a touch tap event occurs on the Date Picker's `TextField`.
	   *
	   * @param {object} event TouchTap event targeting the `TextField`.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function used to determine if a day's entry should be disabled on the calendar.
	   *
	   * @param {object} day Date object of a day.
	   * @returns {boolean} Indicates whether the day should be disabled.
	   */
	  shouldDisableDate: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of DatePicker's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object,
	  /**
	   * Sets the date for the Date Picker programmatically.
	   */
	  value: _react.PropTypes.object
	} : void 0;
	exports.default = DatePicker;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(1024);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Subheader = __webpack_require__(362);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var hasSubheader = false;
	
	      var firstChild = _react.Children.toArray(children)[0];
	      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	        hasSubheader = true;
	      }
	
	      var styles = {
	        root: {
	          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? List.propTypes = {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = List;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(79);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(55);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(45);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(1108);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(1109);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(1041);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var insetChildren = props.insetChildren,
	      leftAvatar = props.leftAvatar,
	      leftCheckbox = props.leftCheckbox,
	      leftIcon = props.leftIcon,
	      nestedLevel = props.nestedLevel,
	      rightAvatar = props.rightAvatar,
	      rightIcon = props.rightIcon,
	      rightIconButton = props.rightIconButton,
	      rightToggle = props.rightToggle,
	      secondaryText = props.secondaryText,
	      secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var styles = {
	    root: {
	      backgroundColor: (state.isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleNestedListToggle = function (event) {
	      event.stopPropagation();
	
	      if (_this.props.open === null) {
	        _this.setState({ open: !_this.state.open }, function () {
	          _this.props.onNestedListToggle(_this);
	        });
	      } else {
	        // Exposing `this` in the callback is quite a bad API.
	        // I'm doing a one level deep clone to expose a fake state.open.
	        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
	          state: {
	            open: !_this.state.open
	          }
	        }));
	      }
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchEnd(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      var button = this.refs.enhancedButton;
	
	      if (button) {
	        var buttonEl = _reactDom2.default.findDOMNode(button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props,
	          innerDivStyle = _props.innerDivStyle,
	          style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props,
	          innerDivStyle = _props2.innerDivStyle,
	          style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
	          children = _props3.children,
	          disabled = _props3.disabled,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          hoverColor = _props3.hoverColor,
	          initiallyOpen = _props3.initiallyOpen,
	          innerDivStyle = _props3.innerDivStyle,
	          insetChildren = _props3.insetChildren,
	          leftAvatar = _props3.leftAvatar,
	          leftCheckbox = _props3.leftCheckbox,
	          leftIcon = _props3.leftIcon,
	          nestedItems = _props3.nestedItems,
	          nestedLevel = _props3.nestedLevel,
	          nestedListStyle = _props3.nestedListStyle,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onNestedListToggle = _props3.onNestedListToggle,
	          onTouchStart = _props3.onTouchStart,
	          onTouchTap = _props3.onTouchTap,
	          rightAvatar = _props3.rightAvatar,
	          rightIcon = _props3.rightIcon,
	          rightIconButton = _props3.rightIconButton,
	          rightToggle = _props3.rightToggle,
	          primaryText = _props3.primaryText,
	          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
	          secondaryText = _props3.secondaryText,
	          secondaryTextLines = _props3.secondaryTextLines,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onTouchTap: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onTouchTap = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({
	            containerElement: 'span'
	          }, other, {
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchEnd: this.handleTouchEnd,
	            onTouchTap: primaryTogglesNestedList ? this.handleNestedListToggle : onTouchTap,
	            ref: 'enhancedButton',
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ListItem.propTypes = {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _react.PropTypes.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _react.PropTypes.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	  * Override the hover background color.
	  */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _react.PropTypes.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Callbak function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /** @ignore */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _react.PropTypes.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _react.PropTypes.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _react.PropTypes.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ListItem;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(79);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(89);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(1105);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(216);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(141);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      minHeight: props.desktop ? '32px' : '48px',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
	      paddingRight: props.rightIcon ? indent : sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onTouchTap: function onTouchTap(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onTouchTap) {
	            item.props.onTouchTap(event);
	          }
	        }
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          animation = _props.animation,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'value']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: { horizontal: 'right', vertical: 'top' },
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onTouchTap = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          hoverColor: this.context.muiTheme.menuItem.hoverColor,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.defaultProps = {
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false
	};
	MenuItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? MenuItem.propTypes = {
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _react.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _react.PropTypes.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the menu item.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = MenuItem;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? PopoverAnimationVertical.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin.isRequired,
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationVertical;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RadioButton = __webpack_require__(220);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioButtonGroup = function (_Component) {
	  (0, _inherits3.default)(RadioButtonGroup, _Component);
	
	  function RadioButtonGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButtonGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      numberCheckedRadioButtons: 0,
	      selected: ''
	    }, _this.handleChange = function (event, newSelection) {
	      _this.updateRadioButtons(newSelection);
	
	      // Successful update
	      if (_this.state.numberCheckedRadioButtons === 0) {
	        if (_this.props.onChange) _this.props.onChange(event, newSelection);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RadioButtonGroup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var cnt = 0;
	      var selected = '';
	      var _props = this.props,
	          valueSelected = _props.valueSelected,
	          defaultSelected = _props.defaultSelected;
	
	      if (valueSelected !== undefined) {
	        selected = valueSelected;
	      } else if (defaultSelected !== undefined) {
	        selected = defaultSelected;
	      }
	
	      _react2.default.Children.forEach(this.props.children, function (option) {
	        if (_this2.hasCheckAttribute(option)) cnt++;
	      }, this);
	
	      this.setState({
	        numberCheckedRadioButtons: cnt,
	        selected: selected
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasOwnProperty('valueSelected')) {
	        this.setState({
	          selected: nextProps.valueSelected
	        });
	      }
	    }
	  }, {
	    key: 'hasCheckAttribute',
	    value: function hasCheckAttribute(radioButton) {
	      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	    }
	  }, {
	    key: 'updateRadioButtons',
	    value: function updateRadioButtons(newSelection) {
	      if (this.state.numberCheckedRadioButtons === 0) {
	        this.setState({ selected: newSelection });
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
	      }
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue() {
	      return this.state.selected;
	    }
	  }, {
	    key: 'setSelectedValue',
	    value: function setSelectedValue(newSelectionValue) {
	      this.updateRadioButtons(newSelectionValue);
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setSelectedValue('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var options = _react2.default.Children.map(this.props.children, function (option) {
	        var _option$props = option.props,
	            name = _option$props.name,
	            value = _option$props.value,
	            label = _option$props.label,
	            onCheck = _option$props.onCheck,
	            other = (0, _objectWithoutProperties3.default)(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	
	        return _react2.default.createElement(_RadioButton2.default, (0, _extends3.default)({}, other, {
	          ref: option.props.value,
	          name: _this3.props.name,
	          key: option.props.value,
	          value: option.props.value,
	          label: option.props.label,
	          labelPosition: _this3.props.labelPosition,
	          onCheck: _this3.handleChange,
	          checked: option.props.value === _this3.state.selected
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
	          className: this.props.className
	        },
	        options
	      );
	    }
	  }]);
	  return RadioButtonGroup;
	}(_react.Component);
	
	RadioButtonGroup.defaultProps = {
	  style: {}
	};
	RadioButtonGroup.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RadioButtonGroup.propTypes = {
	  /**
	   * Should be used to pass `RadioButton` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `value` property of the radio button that will be
	   * selected by default. This takes precedence over the `checked` property
	   * of the `RadioButton` elements.
	   */
	  defaultSelected: _react.PropTypes.any,
	  /**
	   * Where the label will be placed for all child radio buttons.
	   * This takes precedence over the `labelPosition` property of the
	   * `RadioButton` elements.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * The name that will be applied to all child radio buttons.
	   */
	  name: _react.PropTypes.string.isRequired,
	  /**
	   * Callback function that is fired when a radio button has
	   * been checked.
	   *
	   * @param {object} event `change` event targeting the selected
	   * radio button.
	   * @param {*} value The `value` of the selected radio button.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The `value` of the currently selected radio button.
	   */
	  valueSelected: _react.PropTypes.any
	} : void 0;
	exports.default = RadioButtonGroup;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;
	
	var _RadioButton2 = __webpack_require__(1047);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(219);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.default = _RadioButton3.default;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(375);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;
	
	
	  return {
	    root: {
	      fontWeight: 'normal',
	      fontSize: 12,
	      paddingLeft: tableHeaderColumn.spacing,
	      paddingRight: tableHeaderColumn.spacing,
	      height: tableHeaderColumn.height,
	      textAlign: 'left',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      color: tableHeaderColumn.textColor,
	      position: 'relative'
	    },
	    tooltip: {
	      boxSizing: 'border-box',
	      marginTop: tableHeaderColumn.height / 2
	    }
	  };
	}
	
	var TableHeaderColumn = function (_Component) {
	  (0, _inherits3.default)(TableHeaderColumn, _Component);
	
	  function TableHeaderColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeaderColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderColumn.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onMouseEnter = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: true });
	      }
	    }, _this.onMouseLeave = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: false });
	      }
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeaderColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipStyle = _props.tooltipStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onClick: this.onClick
	      };
	
	      var tooltipNode = void 0;
	
	      if (tooltip !== undefined) {
	        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
	          label: tooltip,
	          show: this.state.hovered,
	          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
	        });
	      }
	
	      return _react2.default.createElement(
	        'th',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        tooltipNode,
	        children
	      );
	    }
	  }]);
	  return TableHeaderColumn;
	}(_react.Component);
	
	TableHeaderColumn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableHeaderColumn.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _react.PropTypes.number,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  hoverable: _react.PropTypes.bool,
	  /** @ignore */
	  onClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHoverExit: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The string to supply to the tooltip. If not
	   * string is supplied no tooltip will be shown.
	   */
	  tooltip: _react.PropTypes.string,
	  /**
	   * Additional styling that can be applied to the tooltip.
	   */
	  tooltipStyle: _react.PropTypes.object
	} : void 0;
	exports.default = TableHeaderColumn;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(145);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  (0, _inherits3.default)(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.Component);
	
	 false ? ClickAwayListener.propTypes = {
	  children: _react.PropTypes.element,
	  onClickAway: _react.PropTypes.func
	} : void 0;
	exports.default = ClickAwayListener;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(57);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(224);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(376);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      position: 'relative',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: 'inherit',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  (0, _inherits3.default)(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedSwitch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasToggledProp = nextProps.hasOwnProperty('toggled');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasToggledProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.toggled || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          iconStyle = _props.iconStyle,
	          inputStyle = _props.inputStyle,
	          inputType = _props.inputType,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onSwitch = _props.onSwitch,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onParentShouldUpdate = _props.onParentShouldUpdate,
	          disabled = _props.disabled,
	          disableTouchRipple = _props.disableTouchRipple,
	          disableFocusRipple = _props.disableFocusRipple,
	          className = _props.className,
	          rippleColor = _props.rippleColor,
	          rippleStyle = _props.rippleStyle,
	          style = _props.style,
	          switched = _props.switched,
	          switchElement = _props.switchElement,
	          thumbStyle = _props.thumbStyle,
	          trackStyle = _props.trackStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange,
	        onMouseUp: showTouchRipple && this.handleMouseUp,
	        onMouseDown: showTouchRipple && this.handleMouseDown,
	        onMouseLeave: showTouchRipple && this.handleMouseLeave,
	        onTouchStart: showTouchRipple && this.handleTouchStart,
	        onTouchEnd: showTouchRipple && this.handleTouchEnd
	      }));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? EnhancedSwitch.propTypes = {
	  checked: _react.PropTypes.bool,
	  className: _react.PropTypes.string,
	  defaultChecked: _react.PropTypes.bool,
	  disableFocusRipple: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  iconStyle: _react.PropTypes.object,
	  inputStyle: _react.PropTypes.object,
	  inputType: _react.PropTypes.string.isRequired,
	  label: _react.PropTypes.node,
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  labelStyle: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  onBlur: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onMouseUp: _react.PropTypes.func,
	  onParentShouldUpdate: _react.PropTypes.func,
	  onSwitch: _react.PropTypes.func,
	  onTouchEnd: _react.PropTypes.func,
	  onTouchStart: _react.PropTypes.func,
	  rippleColor: _react.PropTypes.string,
	  rippleStyle: _react.PropTypes.object,
	  style: _react.PropTypes.object,
	  switchElement: _react.PropTypes.element.isRequired,
	  switched: _react.PropTypes.bool.isRequired,
	  thumbStyle: _react.PropTypes.object,
	  trackStyle: _react.PropTypes.object,
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = EnhancedSwitch;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(79);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(73);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(1093);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FocusRipple.propTypes = {
	  color: _react.PropTypes.string,
	  innerStyle: _react.PropTypes.object,
	  opacity: _react.PropTypes.number,
	  show: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FocusRipple;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(116);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _SlideInChild = __webpack_require__(1095);
	
	var _SlideInChild2 = _interopRequireDefault(_SlideInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideIn = function (_Component) {
	  (0, _inherits3.default)(SlideIn, _Component);
	
	  function SlideIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SlideIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call.apply(_ref, [this].concat(args))), _this), _this.getLeaveDirection = function () {
	      return _this.props.direction;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SlideIn, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          direction = _props.direction,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _SlideInChild2.default,
	          {
	            key: child.key,
	            direction: direction,
	            enterDelay: enterDelay,
	            getLeaveDirection: _this2.getLeaveDirection,
	            style: childStyle
	          },
	          child
	        );
	      }, this);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return SlideIn;
	}(_react.Component);
	
	SlideIn.defaultProps = {
	  enterDelay: 0,
	  direction: 'left'
	};
	SlideIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SlideIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  direction: _react.PropTypes.oneOf(['left', 'right', 'up', 'down']),
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = SlideIn;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(tinycolor) {/**
	 * md-color-picker - Angular-Material inspired color picker.
	 * @version v0.2.6
	 * @link https://github.com/brianpkelley/md-color-picker
	 * @license MIT
	 */
	!function(e,t,o){!function(e,t,r){"use strict";var l=function(e,o){this.type=e,this.restrictX=o,this.offset={x:null,y:null},this.height=255,this.$scope=null,this.$element=null,this.get=t.bind(this,function(e,o,r){this.$scope=e,this.$element=o,this.canvas=this.$element.children()[0],this.marker=this.$element.children()[1],this.context=this.canvas.getContext("2d"),this.currentColor=this.$scope.color.toRgb(),this.currentHue=this.$scope.color.toHsv().h,this.$element.on("mousedown",t.bind(this,this.onMouseDown)),this.$scope.$on("mdColorPicker:colorSet",t.bind(this,this.onColorSet)),this.extra&&this.extra(),this.draw()})};l.prototype.$window=t.element(e),l.prototype.getColorByMouse=function(e){var t=e.pageX-this.offset.x,o=e.pageY-this.offset.y;return this.getColorByPoint(t,o)},l.prototype.setMarkerCenter=function(e,o){var l=-1*this.marker.offsetWidth/2,a=-1*this.marker.offsetHeight/2;o===r?(o=e+a,o=Math.max(Math.min(this.height-1+a,o),Math.ceil(a)),e=0):(e+=l,o+=a,e=Math.max(Math.min(this.height+l,e),Math.ceil(l)),o=Math.max(Math.min(this.height+a,o),Math.ceil(a))),t.element(this.marker).css({left:e+"px"}),t.element(this.marker).css({top:o+"px"})},l.prototype.getMarkerCenter=function(){var e={x:this.marker.offsetLeft+Math.floor(this.marker.offsetWidth/2),y:this.marker.offsetTop+Math.floor(this.marker.offsetHeight/2)};return e},l.prototype.getImageData=function(e,t){e=Math.max(0,Math.min(e,this.canvas.width-1)),t=Math.max(0,Math.min(t,this.canvas.height-1));var o=this.context.getImageData(e,t,1,1).data;return o},l.prototype.onMouseDown=function(e){e.preventDefault(),e.stopImmediatePropagation(),this.$scope.previewUnfocus(),this.$element.css({cursor:"none"}),this.offset.x=this.canvas.getBoundingClientRect().left+1,this.offset.y=this.canvas.getBoundingClientRect().top;var o=t.bind(this,function(e){switch(this.type){case"hue":var t=this.getColorByMouse(e);this.$scope.$broadcast("mdColorPicker:spectrumHueChange",{hue:t});break;case"alpha":var o=this.getColorByMouse(e);this.$scope.color.setAlpha(o),this.$scope.alpha=o,this.$scope.$apply();break;case"spectrum":var r=this.getColorByMouse(e);this.setColor(r)}});this.$window.on("mousemove",o),this.$window.one("mouseup",t.bind(this,function(e){this.$window.off("mousemove",o),this.$element.css({cursor:"crosshair"})})),o(e)},l.prototype.setColor=function(e){this.$scope.color._r=e.r,this.$scope.color._g=e.g,this.$scope.color._b=e.b,this.$scope.$apply(),this.$scope.$broadcast("mdColorPicker:spectrumColorChange",{color:e})},l.prototype.onColorSet=function(e,t){switch(this.type){case"hue":var o=this.$scope.color.toHsv();this.setMarkerCenter(this.canvas.height-this.canvas.height*(o.h/360));break;case"alpha":this.currentColor=t.color.toRgb(),this.draw();var r=t.color.getAlpha(),l=this.canvas.height-this.canvas.height*r;this.setMarkerCenter(l);break;case"spectrum":var o=t.color.toHsv();this.currentHue=o.h,this.draw();var a=this.canvas.width*o.s,n=this.canvas.height-this.canvas.height*o.v;this.setMarkerCenter(a,n)}};var a=new l("hue",!0);a.getColorByPoint=function(e,t){var r=this.getImageData(e,t);this.setMarkerCenter(t);var l=new o({r:r[0],g:r[1],b:r[2]});return l.toHsl().h},a.draw=function(){this.$element.css({height:this.height+"px"}),this.canvas.height=this.height,this.canvas.width=this.height;var e=this.context.createLinearGradient(90,0,90,this.height);e.addColorStop(.01,"rgba(255, 0, 0, 1.000)"),e.addColorStop(.167,"rgba(255, 0, 255, 1.000)"),e.addColorStop(.333,"rgba(0, 0, 255, 1.000)"),e.addColorStop(.5,"rgba(0, 255, 255, 1.000)"),e.addColorStop(.666,"rgba(0, 255, 0, 1.000)"),e.addColorStop(.828,"rgba(255, 255, 0, 1.000)"),e.addColorStop(.999,"rgba(255, 0, 0, 1.000)"),this.context.fillStyle=e,this.context.fillRect(0,0,this.canvas.width,this.height)};var n=new l("alpha",!0);n.getColorByPoint=function(e,t){var o=this.getImageData(e,t);return this.setMarkerCenter(t),o[3]/255},n.draw=function(){this.$element.css({height:this.height+"px"}),this.canvas.height=this.height,this.canvas.width=this.height;var e=this.context.createLinearGradient(90,0,90,this.height);e.addColorStop(.01,"rgba("+this.currentColor.r+","+this.currentColor.g+","+this.currentColor.b+", 1.000)"),e.addColorStop(.999,"rgba("+this.currentColor.r+","+this.currentColor.g+","+this.currentColor.b+", 0.000)"),this.context.fillStyle=e,this.context.fillRect(0,0,this.canvas.width,this.height)},n.extra=function(){this.$scope.$on("mdColorPicker:spectrumColorChange",t.bind(this,function(e,t){this.currentColor=t.color,this.draw()}))};var i=new l("spectrum",!1);i.getColorByPoint=function(e,t){var o=this.getImageData(e,t);return this.setMarkerCenter(e,t),{r:o[0],g:o[1],b:o[2]}},i.draw=function(){this.canvas.height=this.height,this.canvas.width=this.height,this.context.clearRect(0,0,this.canvas.width,this.canvas.height);var e=this.context.createLinearGradient(0,0,this.canvas.width,0);e.addColorStop(0,"rgba(255, 255, 255, 1.000)"),e.addColorStop(1,"rgba(255, 255, 255, 0.000)");var t=this.context.createLinearGradient(0,0,0,this.canvas.height);t.addColorStop(0,"rgba(0, 0, 0, 0.000)"),t.addColorStop(1,"rgba(0, 0, 0, 1.000)"),this.context.fillStyle="hsl( "+this.currentHue+", 100%, 50%)",this.context.fillRect(0,0,this.canvas.width,this.canvas.height),this.context.fillStyle=e,this.context.fillRect(0,0,this.canvas.width,this.canvas.height),this.context.fillStyle=t,this.context.fillRect(0,0,this.canvas.width,this.canvas.height)},i.extra=function(){this.$scope.$on("mdColorPicker:spectrumHueChange",t.bind(this,function(e,t){this.currentHue=t.hue,this.draw();var o=this.getMarkerCenter(),r=this.getColorByPoint(o.x,o.y);this.setColor(r)}))},t.module("mdColorPicker",[]).run(["$templateCache",function(e){var t={clear:'<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>',gradient:'<path d="M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"/>',tune:'<path d="M13 21v-2h8v-2h-8v-2h-2v6h2zM3 17v2h6v-2H3z"/><path d="M21 13v-2H11v2h10zM7 9v2H3v2h4v2h2V9H7z"/><path d="M15 9h2V7h4V5h-4V3h-2v6zM3 5v2h10V5H3z"/>',view_module:'<path d="M4 11h5V5H4v6z"/><path d="M4 18h5v-6H4v6z"/><path d="M10 18h5v-6h-5v6z"/><path d="M16 18h5v-6h-5v6z"/><path d="M10 11h5V5h-5v6z"/><path d="M16 5v6h5V5h-5z"/>',view_headline:'<path d="M4 15h17v-2H4v2z"/><path d="M4 19h17v-2H4v2z"/><path d="M4 11h17V9H4v2z"/><path d="M4 5v2h17V5H4z"/>',history:'<path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M12 8v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>',clear_all:'<path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"/>'};for(var o in t)t.hasOwnProperty(o)&&e.put([o,"svg"].join("."),['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">',t[o],"</svg>"].join(""))}]).factory("mdColorPickerHistory",["$injector",function(e){var t=[],r=[],l=!1;try{l=e.get("$cookies")}catch(a){}if(l)for(var n=l.getObject("mdColorPickerHistory")||[],i=0;i<n.length;i++)t.push(o(n[i])),r.push(n[i]);var c=40;return{length:function(){return arguments[0]?void(c=arguments[0]):t.length},add:function(e){for(var o=0;o<t.length;o++)t[o].toRgbString()===e.toRgbString()&&(t.splice(o,1),r.splice(o,1));t.unshift(e),r.unshift(e.toRgbString()),t.length>c&&(t.pop(),r.pop()),l&&l.putObject("mdColorPickerHistory",r)},get:function(){return t},reset:function(){t=[],r=[],l&&l.putObject("mdColorPickerHistory",r)}}}]).directive("mdColorPicker",["$timeout","mdColorPickerHistory",function(e,t){return{templateUrl:"mdColorPicker.tpl.html",require:"^ngModel",scope:{options:"=mdColorPicker",type:"@",label:"@",icon:"@",random:"@","default":"@",openOnInput:"@",hasBackdrop:"@",clickOutsideToClose:"@",skipHide:"@",preserveScope:"@",mdColorClearButton:"=?",mdColorPreview:"=?",mdColorAlphaChannel:"=?",mdColorSpectrum:"=?",mdColorSliders:"=?",mdColorGenericPalette:"=?",mdColorMaterialPalette:"=?",mdColorHistory:"=?",mdColorDefaultTab:"=?"},controller:["$scope","$element","$attrs","$mdDialog","$mdColorPicker",function(e,t,o,l,a){var n=!1;if(e.options!==r)for(var i in e.options)if(e.options.hasOwnProperty(i)){var c=r;e.hasOwnProperty(i)?c=i:e.hasOwnProperty("mdColor"+i.slice(0,1).toUpperCase()+i.slice(1))&&(c="mdColor"+i.slice(0,1).toUpperCase()+i.slice(1)),c&&e[c]===r&&(e[c]=e.options[i])}var s=t.controller("ngModel"),d=function(t){e.value=t||s.$viewValue||""};e.mdColorClearButton=e.mdColorClearButton===r?!0:e.mdColorClearButton,e.mdColorPreview=e.mdColorPreview===r?!0:e.mdColorPreview,e.mdColorAlphaChannel=e.mdColorAlphaChannel===r?!0:e.mdColorAlphaChannel,e.mdColorSpectrum=e.mdColorSpectrum===r?!0:e.mdColorSpectrum,e.mdColorSliders=e.mdColorSliders===r?!0:e.mdColorSliders,e.mdColorGenericPalette=e.mdColorGenericPalette===r?!0:e.mdColorGenericPalette,e.mdColorMaterialPalette=e.mdColorMaterialPalette===r?!0:e.mdColorMaterialPalette,e.mdColorHistory=e.mdColorHistory===r?!0:e.mdColorHistory,d(),e.$watch(function(){return s.$modelValue},function(e){d(e)}),e.$watch("value",function(e,t){""!==e&&"undefined"!=typeof e&&e&&e!==t&&s.$setViewValue(e)}),e.clearValue=function(){e.value=""},e.showColorPicker=function(t){n||a.show({value:e.value,defaultValue:e["default"],random:e.random,clickOutsideToClose:e.clickOutsideToClose,hasBackdrop:e.hasBackdrop,skipHide:e.skipHide,preserveScope:e.preserveScope,mdColorAlphaChannel:e.mdColorAlphaChannel,mdColorSpectrum:e.mdColorSpectrum,mdColorSliders:e.mdColorSliders,mdColorGenericPalette:e.mdColorGenericPalette,mdColorMaterialPalette:e.mdColorMaterialPalette,mdColorHistory:e.mdColorHistory,mdColorDefaultTab:e.mdColorDefaultTab,$event:t}).then(function(t){e.value=t})}}],compile:function(e,t){t.type=t.type!==r?t.type:0}}}]).directive("mdColorPickerContainer",["$compile","$timeout","$mdColorPalette","mdColorPickerHistory",function(e,r,l,a){return{templateUrl:"mdColorPickerContainer.tpl.html",scope:{value:"=?","default":"@",random:"@",ok:"=?",mdColorAlphaChannel:"=",mdColorSpectrum:"=",mdColorSliders:"=",mdColorGenericPalette:"=",mdColorMaterialPalette:"=",mdColorHistory:"=",mdColorDefaultTab:"="},controller:["$scope","$element","$attrs",function(e,n,i){function c(t){var o=0;if(t&&"string"==typeof t){for(var r="mdColor"+t.slice(0,1).toUpperCase()+t.slice(1),l=["mdColorSpectrum","mdColorSliders","mdColorGenericPalette","mdColorMaterialPalette","mdColorHistory"],a=0;a<l.length;a++)if(l[a]==r&&e[r]){o=a;break}}else t&&"number"==typeof t&&(o=t);return o}var s=t.element(n[0].querySelector(".md-color-picker-container")),d=(t.element(s[0].querySelector(".md-color-picker-result")),t.element(n[0].querySelector(".md-color-picker-preview-input"))),h=["toHexString","toRgbString","toHslString"];e["default"]=e["default"]?e["default"]:e.random?o.random():"rgb(255,255,255)",e.value.search("#")>=0?e.type=0:e.value.search("rgb")>=0?e.type=1:e.value.search("hsl")>=0&&(e.type=2),e.color=new o(e.value||e["default"]),e.alpha=e.color.getAlpha(),e.history=a,e.materialFamily=[],e.whichPane=c(e.mdColorDefaultTab),e.inputFocus=!1;var m=9;2*Math.PI/m;e.palette=[["rgb(255, 204, 204)","rgb(255, 230, 204)","rgb(255, 255, 204)","rgb(204, 255, 204)","rgb(204, 255, 230)","rgb(204, 255, 255)","rgb(204, 230, 255)","rgb(204, 204, 255)","rgb(230, 204, 255)","rgb(255, 204, 255)"],["rgb(255, 153, 153)","rgb(255, 204, 153)","rgb(255, 255, 153)","rgb(153, 255, 153)","rgb(153, 255, 204)","rgb(153, 255, 255)","rgb(153, 204, 255)","rgb(153, 153, 255)","rgb(204, 153, 255)","rgb(255, 153, 255)"],["rgb(255, 102, 102)","rgb(255, 179, 102)","rgb(255, 255, 102)","rgb(102, 255, 102)","rgb(102, 255, 179)","rgb(102, 255, 255)","rgb(102, 179, 255)","rgb(102, 102, 255)","rgb(179, 102, 255)","rgb(255, 102, 255)"],["rgb(255, 51, 51)","rgb(255, 153, 51)","rgb(255, 255, 51)","rgb(51, 255, 51)","rgb(51, 255, 153)","rgb(51, 255, 255)","rgb(51, 153, 255)","rgb(51, 51, 255)","rgb(153, 51, 255)","rgb(255, 51, 255)"],["rgb(255, 0, 0)","rgb(255, 128, 0)","rgb(255, 255, 0)","rgb(0, 255, 0)","rgb(0, 255, 128)","rgb(0, 255, 255)","rgb(0, 128, 255)","rgb(0, 0, 255)","rgb(128, 0, 255)","rgb(255, 0, 255)"],["rgb(245, 0, 0)","rgb(245, 123, 0)","rgb(245, 245, 0)","rgb(0, 245, 0)","rgb(0, 245, 123)","rgb(0, 245, 245)","rgb(0, 123, 245)","rgb(0, 0, 245)","rgb(123, 0, 245)","rgb(245, 0, 245)"],["rgb(214, 0, 0)","rgb(214, 108, 0)","rgb(214, 214, 0)","rgb(0, 214, 0)","rgb(0, 214, 108)","rgb(0, 214, 214)","rgb(0, 108, 214)","rgb(0, 0, 214)","rgb(108, 0, 214)","rgb(214, 0, 214)"],["rgb(163, 0, 0)","rgb(163, 82, 0)","rgb(163, 163, 0)","rgb(0, 163, 0)","rgb(0, 163, 82)","rgb(0, 163, 163)","rgb(0, 82, 163)","rgb(0, 0, 163)","rgb(82, 0, 163)","rgb(163, 0, 163)"],["rgb(92, 0, 0)","rgb(92, 46, 0)","rgb(92, 92, 0)","rgb(0, 92, 0)","rgb(0, 92, 46)","rgb(0, 92, 92)","rgb(0, 46, 92)","rgb(0, 0, 92)","rgb(46, 0, 92)","rgb(92, 0, 92)"],["rgb(255, 255, 255)","rgb(205, 205, 205)","rgb(178, 178, 178)","rgb(153, 153, 153)","rgb(127, 127, 127)","rgb(102, 102, 102)","rgb(76, 76, 76)","rgb(51, 51, 51)","rgb(25, 25, 25)","rgb(0, 0, 0)"]],e.materialPalette=l,e.isDark=function(e){return t.isArray(e)?o({r:e[0],g:e[1],b:e[2]}).isDark():o(e).isDark()},e.previewFocus=function(){e.inputFocus=!0,r(function(){d[0].setSelectionRange(0,d[0].value.length)})},e.previewUnfocus=function(){e.inputFocus=!1,d[0].blur()},e.previewBlur=function(){e.inputFocus=!1,e.setValue()},e.previewKeyDown=function(t){13==t.keyCode&&e.ok&&e.ok()},e.setPaletteColor=function(t){r(function(){e.color=o(t.target.style.backgroundColor)})},e.setValue=function(){e.color&&e.color&&h[e.type]&&"rgba(0, 0, 0, 0)"!==e.color.toRgbString()&&(e.value=e.color[h[e.type]]())},e.changeValue=function(){e.color=o(e.value),e.$broadcast("mdColorPicker:colorSet",{color:e.color})},e.$watch("color._a",function(t){e.color.setAlpha(t)},!0),e.$watch("whichPane",function(t){e.$broadcast("mdColorPicker:colorSet",{color:e.color})}),e.$watch("type",function(){d.removeClass("switch"),r(function(){d.addClass("switch")})}),e.$watchGroup(["color.toRgbString()","type"],function(t){e.inputFocus||e.setValue()}),r(function(){e.$broadcast("mdColorPicker:colorSet",{color:e.color}),d.focus(),e.previewFocus()})}],link:function(e,o,l){function a(){var r=t.element(o[0].querySelector(".md-color-picker-palette")),l=t.element(o[0].querySelector(".md-color-picker-material-palette")),a=t.element('<div class="flex-15 layout-fill layout-row layout-align-space-between" layout-align="space-between" layout="row" layout-fill"></div>'),n=t.element('<div class="flex-10"></div>'),i=t.element('<div class="md-color-picker-material-title"></div>'),c=t.element('<div class="md-color-picker-with-label"></div>');t.forEach(e.palette,function(o,l){var i=a.clone();t.forEach(o,function(t){var o=n.clone();o.css({height:"25.5px",backgroundColor:t}),o.bind("click",e.setPaletteColor),i.append(o)}),r.append(i)}),t.forEach(e.materialPalette,function(o,r){var a=i.clone();a.html("<span>"+r.replace("-"," ")+"</span>"),a.css({height:"75px",backgroundColor:"rgb("+o[500].value[0]+","+o[500].value[1]+","+o[500].value[2]+")"}),e.isDark(o[500].value)&&a.addClass("dark"),l.append(a),t.forEach(o,function(t,o){var r=c.clone();r.css({height:"33px",backgroundColor:"rgb("+t.value[0]+","+t.value[1]+","+t.value[2]+")"}),e.isDark(t.value)&&r.addClass("dark"),r.html("<span>"+o+"</span>"),r.bind("click",e.setPaletteColor),l.append(r)})})}o[0].getElementsByTagName("md-tab");r(function(){a()})}}}]).directive("mdColorPickerHue",[function(){return{template:'<canvas width="100%" height="100%"></canvas><div class="md-color-picker-marker"></div>',link:a.get,controller:function(){}}}]).directive("mdColorPickerAlpha",[function(){return{template:'<canvas width="100%" height="100%"></canvas><div class="md-color-picker-marker"></div>',link:n.get,controller:function(){}}}]).directive("mdColorPickerSpectrum",[function(){return{template:'<canvas width="100%" height="100%"></canvas><div class="md-color-picker-marker"></div>{{hue}}',link:i.get,controller:function(){}}}]).factory("$mdColorPicker",["$q","$mdDialog","mdColorPickerHistory",function(e,t,l){var a;return{show:function(e){return e===r&&(e={}),e.hasBackdrop=e.hasBackdrop===r?!0:e.hasBackdrop,e.clickOutsideToClose=e.clickOutsideToClose===r?!0:e.clickOutsideToClose,e.defaultValue=e.defaultValue===r?"#FFFFFF":e.defaultValue,e.focusOnOpen=e.focusOnOpen===r?!1:e.focusOnOpen,e.preserveScope=e.preserveScope===r?!0:e.preserveScope,e.skipHide=e.skipHide===r?!0:e.skipHide,e.mdColorAlphaChannel=e.mdColorAlphaChannel===r?!1:e.mdColorAlphaChannel,e.mdColorSpectrum=e.mdColorSpectrum===r?!0:e.mdColorSpectrum,e.mdColorSliders=e.mdColorSliders===r?!0:e.mdColorSliders,e.mdColorGenericPalette=e.mdColorGenericPalette===r?!0:e.mdColorGenericPalette,e.mdColorMaterialPalette=e.mdColorMaterialPalette===r?!0:e.mdColorMaterialPalette,e.mdColorHistory=e.mdColorHistory===r?!0:e.mdColorHistory,a=t.show({templateUrl:"mdColorPickerDialog.tpl.html",hasBackdrop:e.hasBackdrop,clickOutsideToClose:e.clickOutsideToClose,controller:["$scope","options",function(e,o){e.close=function(){t.cancel()},e.ok=function(){t.hide(e.value)},e.hide=e.ok,e.value=o.value,e["default"]=o.defaultValue,e.random=o.random,e.mdColorAlphaChannel=o.mdColorAlphaChannel,e.mdColorSpectrum=o.mdColorSpectrum,e.mdColorSliders=o.mdColorSliders,e.mdColorGenericPalette=o.mdColorGenericPalette,e.mdColorMaterialPalette=o.mdColorMaterialPalette,e.mdColorHistory=o.mdColorHistory,e.mdColorDefaultTab=o.mdColorDefaultTab}],locals:{options:e},preserveScope:e.preserveScope,skipHide:e.skipHide,targetEvent:e.$event,focusOnOpen:e.focusOnOpen,autoWrap:!1,onShowing:function(){},onComplete:function(){}}),a.then(function(e){l.add(new o(e))},function(){}),a},hide:function(){return a.hide()},cancel:function(){return a.cancel()}}}])}(t,t.angular),e.module("mdColorPicker").run(["$templateCache",function(e){e.put("mdColorPicker.tpl.html",'<div class="md-color-picker-input-container" layout="row">\n	<div class="md-color-picker-preview md-color-picker-checkered-bg" ng-click="showColorPicker($event)" ng-if="mdColorPreview">\n		<div class="md-color-picker-result" ng-style="{background: value}"></div>\n	</div>\n	<md-input-container flex>\n		<label><md-icon ng-if="icon">{{icon}}</md-icon>{{label}}</label>\n		<input type="input" ng-model="value" class=\'md-color-picker-input\'  ng-mousedown="(openOnInput || !mdColorPreview) && showColorPicker($event)"/>\n	</md-input-container>\n	<md-button class="md-icon-button md-color-picker-clear" ng-if="mdColorClearButton && value" ng-click="clearValue();" aria-label="Clear Color">\n		<md-icon md-svg-icon="clear.svg"></md-icon>\n	</md-button>\n</div>\n'),e.put("mdColorPickerContainer.tpl.html",'<div class="md-color-picker-container in" layout="column">\n	<div class="md-color-picker-arrow" ng-style="{\'border-bottom-color\': color.toRgbString() }"></div>\n\n	<div class="md-color-picker-preview md-color-picker-checkered-bg" ng-class="{\'dark\': !color.isDark() || color.getAlpha() < .45}" flex="1" layout="column">\n\n		<div class="md-color-picker-result" ng-style="{\'background\': color.toRgbString()}" flex="100" layout="column" layout-fill layout-align="center center" ng-click="focusPreviewInput( $event )">\n			<!--<span flex  layout="column" layout-align="center center">{{value}}</span>-->\n			<div flex  layout="row" layout-align="center center">\n				<input class="md-color-picker-preview-input" type="text" ng-model="value" ng-focus="previewFocus($event);" ng-blur="previewBlur()" ng-change="changeValue()" ng-keypress="previewKeyDown($event)" layout-fill />\n			</div>\n			<div class="md-color-picker-tabs" style="width: 100%">\n				<md-tabs md-selected="type" md-stretch-tabs="always" md-no-bar md-no-ink md-no-pagination="true" >\n					<md-tab label="Hex" ng-disabled="color.getAlpha() !== 1" md-ink-ripple="#ffffff"></md-tab>\n					<md-tab label="RGB"></md-tab>\n					<md-tab label="HSL"></md-tab>\n					<!--<md-tab label="HSV"></md-tab>\n					<md-tab label="VEC"></md-tab>-->\n				</md-tabs>\n			</div>\n		</div>\n	</div>\n\n	<div class="md-color-picker-tabs md-color-picker-colors">\n		<md-tabs md-stretch-tabs="always" md-align-tabs="bottom"  md-selected="whichPane" md-no-pagination>\n			<md-tab ng-if="mdColorSpectrum">\n				<md-tab-label>\n					<md-icon md-svg-icon="gradient.svg"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout="row" layout-align="space-between" style="height: 255px">\n						<div md-color-picker-spectrum></div>\n						<div md-color-picker-hue ng-class="{\'md-color-picker-wide\': !mdColorAlphaChannel}"></div>\n						<div md-color-picker-alpha class="md-color-picker-checkered-bg" ng-if="mdColorAlphaChannel"></div>\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab ng-if="mdColorSliders">\n				<md-tab-label>\n					<md-icon md-svg-icon="tune.svg"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout="column" flex="100" layout-fill layout-align="space-between start center" class="md-color-picker-sliders">\n						<div layout="row" layout-align="start center" layout-wrap flex layout-fill>\n							<div flex="10" layout layout-align="center center">\n								<span class="md-body-1">R</span>\n							</div>\n							<md-slider flex="65" min="0" max="255" ng-model="color._r" aria-label="red" class="red-slider"></md-slider>\n							<span flex></span>\n							<div flex="20" layout layout-align="center center">\n								<input style="width: 100%;" min="0" max="255" type="number" ng-model="color._r" aria-label="red" aria-controls="red-slider">\n							</div>\n						</div>\n						<div layout="row" layout-align="start center" layout-wrap flex layout-fill>\n							<div flex="10" layout layout-align="center center">\n								<span class="md-body-1">G</span>\n							</div>\n							<md-slider flex="65" min="0" max="255" ng-model="color._g" aria-label="green" class="green-slider"></md-slider>\n							<span flex></span>\n							<div flex="20" layout layout-align="center center">\n								<input style="width: 100%;" min="0" max="255" type="number" ng-model="color._g" aria-label="green" aria-controls="green-slider">\n							</div>\n						</div>\n						<div layout="row" layout-align="start center" layout-wrap flex layout-fill>\n							<div flex="10" layout layout-align="center center">\n								<span class="md-body-1">B</span>\n							</div>\n							<md-slider flex="65" min="0" max="255" ng-model="color._b" aria-label="blue" class="blue-slider"></md-slider>\n							<span flex></span>\n							<div flex="20" layout layout-align="center center" >\n								<input style="width: 100%;" min="0" max="255" type="number" ng-model="color._b" aria-label="blue" aria-controls="blue-slider">\n							</div>\n						</div>\n						<div layout="row" layout-align="start center" layout-wrap flex layout-fill ng-if="!mdColorAlphaChannel">\n							<div flex="10" layout layout-align="center center">\n								<span class="md-body-1">A</span>\n							</div>\n							<md-slider flex="65" min="0" max="1" step=".01" ng-model="color._a" aria-label="alpha" class="md-primary"></md-slider>\n							<span flex></span>\n							<div flex="20" layout layout-align="center center" >\n								<input style="width: 100%;" min="0" max="1" step=".01" type="number" ng-model="color._a" aria-label="alpha" aria-controls="alpha-slider">\n							</div>\n						</div>\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab ng-if="mdColorGenericPalette">\n				<md-tab-label>\n					<md-icon md-svg-icon="view_module.svg"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout="column" layout-align="space-between start center" flex class="md-color-picker-palette">\n\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab  ng-if="mdColorMaterialPalette">\n				<md-tab-label>\n					<md-icon md-svg-icon="view_headline.svg"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout="column" layout-fill flex class="md-color-picker-material-palette">\n\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab ng-if="mdColorHistory">\n				<md-tab-label>\n					<md-icon md-svg-icon="history.svg"></md-icon>\n				</md-tab-label>\n				<md-tab-body layout="row" layout-fill>\n					<div layout="column" flex layout-align="space-between start" layout-wrap layout-fill class="md-color-picker-history">\n						<div layout="row" flex="80" layout-align="space-between start start" layout-wrap  layout-fill>\n							<div flex="10" ng-repeat="historyColor in history.get() track by $index">\n								<div  ng-style="{\'background\': historyColor.toRgbString()}" ng-click="setPaletteColor($event)"></div>\n							</div>\n						</div>\n\n\n						<md-button flex-end ng-click="history.reset()" class="md-mini" aria-label="Clear History">\n							<md-icon md-svg-icon="clear_all.svg"></md-icon>\n						</md-button>\n					</div>\n				</md-tab-body>\n			</md-tab>\n		</md-tabs>\n	</div>\n\n</div>\n'),e.put("mdColorPickerDialog.tpl.html",'<md-dialog class="md-color-picker-dialog">\n	<div md-color-picker-container\n		value="value"\n		default="{{defaultValue}}"\n		random="{{random}}"\n		ok="ok"\n		md-color-alpha-channel="mdColorAlphaChannel"\n		md-color-spectrum="mdColorSpectrum"\n		md-color-sliders="mdColorSliders"\n		md-color-generic-palette="mdColorGenericPalette"\n		md-color-material-palette="mdColorMaterialPalette"\n		md-color-history="mdColorHistory"\n		md-color-default-tab="mdColorDefaultTab"\n	></div>\n	<md-actions layout="row">\n		<md-button class="md-mini" ng-click="close()" style="width: 50%;">Cancel</md-button>\n		<md-button class="md-mini" ng-click="ok()" style="width: 50%;">Select</md-button>\n	</md-actions>\n</md-dialog>\n')}])}(angular,window,tinycolor);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var AliasController = function () {
	    function AliasController($scope, $q, $filter, utils, types, entityService, stateController, entityAliases) {
	        _classCallCheck(this, AliasController);
	
	        this.$scope = $scope;
	        this.$q = $q;
	        this.$filter = $filter;
	        this.utils = utils;
	        this.types = types;
	        this.entityService = entityService;
	        this.stateController = stateController;
	        this.entityAliases = angular.copy(entityAliases);
	        this.resolvedAliases = {};
	        this.resolvedAliasesPromise = {};
	        this.resolvedAliasesToStateEntities = {};
	    }
	
	    _createClass(AliasController, [{
	        key: 'updateEntityAliases',
	        value: function updateEntityAliases(newEntityAliases) {
	            var changedAliasIds = [];
	            for (var aliasId in newEntityAliases) {
	                var newEntityAlias = newEntityAliases[aliasId];
	                var prevEntityAlias = this.entityAliases[aliasId];
	                if (!angular.equals(newEntityAlias, prevEntityAlias)) {
	                    changedAliasIds.push(aliasId);
	                    this.setAliasUnresolved(aliasId);
	                }
	            }
	            for (aliasId in this.entityAliases) {
	                if (!newEntityAliases[aliasId]) {
	                    changedAliasIds.push(aliasId);
	                    this.setAliasUnresolved(aliasId);
	                }
	            }
	            this.entityAliases = angular.copy(newEntityAliases);
	            if (changedAliasIds.length) {
	                this.$scope.$broadcast('entityAliasesChanged', changedAliasIds);
	            }
	        }
	    }, {
	        key: 'dashboardStateChanged',
	        value: function dashboardStateChanged() {
	            var changedAliasIds = [];
	            for (var aliasId in this.resolvedAliasesToStateEntities) {
	                var stateEntityInfo = this.resolvedAliasesToStateEntities[aliasId];
	                var newEntityId = this.stateController.getEntityId(stateEntityInfo.entityParamName);
	                var prevEntityId = stateEntityInfo.entityId;
	                if (!angular.equals(newEntityId, prevEntityId)) {
	                    changedAliasIds.push(aliasId);
	                    this.setAliasUnresolved(aliasId);
	                }
	            }
	            if (changedAliasIds.length) {
	                this.$scope.$broadcast('entityAliasesChanged', changedAliasIds);
	            }
	        }
	    }, {
	        key: 'setAliasUnresolved',
	        value: function setAliasUnresolved(aliasId) {
	            delete this.resolvedAliases[aliasId];
	            delete this.resolvedAliasesPromise[aliasId];
	            delete this.resolvedAliasesToStateEntities[aliasId];
	        }
	    }, {
	        key: 'getEntityAliases',
	        value: function getEntityAliases() {
	            return this.entityAliases;
	        }
	    }, {
	        key: 'getEntityAliasId',
	        value: function getEntityAliasId(aliasName) {
	            for (var aliasId in this.entityAliases) {
	                var alias = this.entityAliases[aliasId];
	                if (alias.alias == aliasName) {
	                    return aliasId;
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getAliasInfo',
	        value: function getAliasInfo(aliasId) {
	            var deferred = this.$q.defer();
	            var aliasInfo = this.resolvedAliases[aliasId];
	            if (aliasInfo) {
	                deferred.resolve(aliasInfo);
	                return deferred.promise;
	            } else if (this.resolvedAliasesPromise[aliasId]) {
	                return this.resolvedAliasesPromise[aliasId];
	            } else {
	                this.resolvedAliasesPromise[aliasId] = deferred.promise;
	                var aliasCtrl = this;
	                var entityAlias = this.entityAliases[aliasId];
	                if (entityAlias) {
	                    this.entityService.resolveAlias(entityAlias, this.stateController.getStateParams()).then(function success(aliasInfo) {
	                        aliasCtrl.resolvedAliases[aliasId] = aliasInfo;
	                        delete aliasCtrl.resolvedAliasesPromise[aliasId];
	                        if (aliasInfo.stateEntity) {
	                            var stateEntityInfo = {
	                                entityParamName: aliasInfo.entityParamName,
	                                entityId: aliasCtrl.stateController.getEntityId(aliasInfo.entityParamName)
	                            };
	                            aliasCtrl.resolvedAliasesToStateEntities[aliasId] = stateEntityInfo;
	                        }
	                        aliasCtrl.$scope.$broadcast('entityAliasResolved', aliasId);
	                        deferred.resolve(aliasInfo);
	                    }, function fail() {
	                        deferred.reject();
	                        delete aliasCtrl.resolvedAliasesPromise[aliasId];
	                    });
	                } else {
	                    deferred.reject();
	                    delete aliasCtrl.resolvedAliasesPromise[aliasId];
	                }
	                return this.resolvedAliasesPromise[aliasId];
	            }
	        }
	    }, {
	        key: 'resolveDatasource',
	        value: function resolveDatasource(datasource, isSingle) {
	            var deferred = this.$q.defer();
	            if (datasource.type === this.types.datasourceType.entity) {
	                if (datasource.entityAliasId) {
	                    this.getAliasInfo(datasource.entityAliasId).then(function success(aliasInfo) {
	                        datasource.aliasName = aliasInfo.alias;
	                        if (aliasInfo.resolveMultiple && !isSingle) {
	                            var newDatasource;
	                            var resolvedEntities = aliasInfo.resolvedEntities;
	                            if (resolvedEntities && resolvedEntities.length) {
	                                var datasources = [];
	                                for (var i = 0; i < resolvedEntities.length; i++) {
	                                    var resolvedEntity = resolvedEntities[i];
	                                    newDatasource = angular.copy(datasource);
	                                    newDatasource.entityId = resolvedEntity.id;
	                                    newDatasource.entityType = resolvedEntity.entityType;
	                                    newDatasource.entityName = resolvedEntity.name;
	                                    newDatasource.entityDescription = resolvedEntity.entityDescription;
	                                    newDatasource.name = resolvedEntity.name;
	                                    newDatasource.generated = i > 0 ? true : false;
	                                    datasources.push(newDatasource);
	                                }
	                                deferred.resolve(datasources);
	                            } else {
	                                if (aliasInfo.stateEntity) {
	                                    newDatasource = angular.copy(datasource);
	                                    newDatasource.unresolvedStateEntity = true;
	                                    deferred.resolve([newDatasource]);
	                                } else {
	                                    deferred.reject();
	                                }
	                            }
	                        } else {
	                            var entity = aliasInfo.currentEntity;
	                            if (entity) {
	                                datasource.entityId = entity.id;
	                                datasource.entityType = entity.entityType;
	                                datasource.entityName = entity.name;
	                                datasource.name = entity.name;
	                                datasource.entityDescription = entity.entityDescription;
	                                deferred.resolve([datasource]);
	                            } else {
	                                if (aliasInfo.stateEntity) {
	                                    datasource.unresolvedStateEntity = true;
	                                    deferred.resolve([datasource]);
	                                } else {
	                                    deferred.reject();
	                                }
	                            }
	                        }
	                    }, function fail() {
	                        deferred.reject();
	                    });
	                } else {
	                    // entityId
	                    datasource.aliasName = datasource.entityName;
	                    datasource.name = datasource.entityName;
	                    deferred.resolve([datasource]);
	                }
	            } else {
	                // function
	                deferred.resolve([datasource]);
	            }
	            return deferred.promise;
	        }
	    }, {
	        key: 'resolveAlarmSource',
	        value: function resolveAlarmSource(alarmSource) {
	            var deferred = this.$q.defer();
	            var aliasCtrl = this;
	            this.resolveDatasource(alarmSource, true).then(function success(datasources) {
	                var datasource = datasources[0];
	                if (datasource.type === aliasCtrl.types.datasourceType.function) {
	                    var name;
	                    if (datasource.name && datasource.name.length) {
	                        name = datasource.name;
	                    } else {
	                        name = aliasCtrl.types.datasourceType.function;
	                    }
	                    datasource.name = name;
	                    datasource.aliasName = name;
	                    datasource.entityName = name;
	                } else if (datasource.unresolvedStateEntity) {
	                    datasource.name = "NÃO DEFINIDO";
	                    datasource.entityName = "NÃO DEFINIDO";
	                }
	                deferred.resolve(datasource);
	            }, function fail() {
	                deferred.reject();
	            });
	            return deferred.promise;
	        }
	    }, {
	        key: 'resolveDatasources',
	        value: function resolveDatasources(datasources) {
	
	            var aliasCtrl = this;
	
	            function updateDataKeyLabel(dataKey, datasource) {
	                if (!dataKey.pattern) {
	                    dataKey.pattern = angular.copy(dataKey.label);
	                }
	                dataKey.label = aliasCtrl.utils.createLabelFromDatasource(datasource, dataKey.pattern);
	            }
	
	            function updateDatasourceKeyLabels(datasource) {
	                for (var dk = 0; dk < datasource.dataKeys.length; dk++) {
	                    updateDataKeyLabel(datasource.dataKeys[dk], datasource);
	                }
	            }
	
	            var deferred = this.$q.defer();
	            var newDatasources = angular.copy(datasources);
	            var datasorceResolveTasks = [];
	
	            newDatasources.forEach(function (datasource) {
	                var resolveDatasourceTask = aliasCtrl.resolveDatasource(datasource);
	                datasorceResolveTasks.push(resolveDatasourceTask);
	            });
	            this.$q.all(datasorceResolveTasks).then(function success(datasourcesArrays) {
	                var datasources = [].concat.apply([], datasourcesArrays);
	                datasources = aliasCtrl.$filter('orderBy')(datasources, '+generated');
	                var index = 0;
	                var functionIndex = 0;
	                datasources.forEach(function (datasource) {
	                    if (datasource.type === aliasCtrl.types.datasourceType.function) {
	                        var name;
	                        if (datasource.name && datasource.name.length) {
	                            name = datasource.name;
	                        } else {
	                            functionIndex++;
	                            name = aliasCtrl.types.datasourceType.function;
	                            if (functionIndex > 1) {
	                                name += ' ' + functionIndex;
	                            }
	                        }
	                        datasource.name = name;
	                        datasource.aliasName = name;
	                        datasource.entityName = name;
	                    } else if (datasource.unresolvedStateEntity) {
	                        datasource.name = "NÃO DEFINIDO";
	                        datasource.entityName = "NÃO DEFINIDO";
	                    }
	                    datasource.dataKeys.forEach(function (dataKey) {
	                        if (datasource.generated) {
	                            dataKey._hash = Math.random();
	                            dataKey.color = aliasCtrl.utils.getMaterialColor(index);
	                        }
	                        index++;
	                    });
	                    updateDatasourceKeyLabels(datasource);
	                });
	                deferred.resolve(datasources);
	            }, function fail() {
	                deferred.reject();
	            });
	            return deferred.promise;
	        }
	    }, {
	        key: 'getInstantAliasInfo',
	        value: function getInstantAliasInfo(aliasId) {
	            return this.resolvedAliases[aliasId];
	        }
	    }, {
	        key: 'updateCurrentAliasEntity',
	        value: function updateCurrentAliasEntity(aliasId, currentEntity) {
	            var aliasInfo = this.resolvedAliases[aliasId];
	            if (aliasInfo) {
	                var prevCurrentEntity = aliasInfo.currentEntity;
	                if (!angular.equals(currentEntity, prevCurrentEntity)) {
	                    aliasInfo.currentEntity = currentEntity;
	                    this.$scope.$broadcast('entityAliasesChanged', [aliasId]);
	                }
	            }
	        }
	    }]);
	
	    return AliasController;
	}();
	
	exports.default = AliasController;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	DashboardService.$inject = ["$rootScope", "$http", "$q", "$location", "$filter"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.dashboard', []).factory('dashboardService', DashboardService).name;
	
	/*@ngInject*/
	
	function DashboardService($rootScope, $http, $q, $location, $filter) {
	
	    var stDiffPromise;
	
	    $rootScope.dadshboardServiceStateChangeStartHandle = $rootScope.$on('$stateChangeStart', function () {
	        stDiffPromise = undefined;
	    });
	
	    var service = {
	        assignDashboardToCustomer: assignDashboardToCustomer,
	        getCustomerDashboards: getCustomerDashboards,
	        getServerTimeDiff: getServerTimeDiff,
	        getDashboard: getDashboard,
	        getDashboardInfo: getDashboardInfo,
	        getTenantDashboardsByTenantId: getTenantDashboardsByTenantId,
	        getTenantDashboards: getTenantDashboards,
	        deleteDashboard: deleteDashboard,
	        saveDashboard: saveDashboard,
	        unassignDashboardFromCustomer: unassignDashboardFromCustomer,
	        updateDashboardCustomers: updateDashboardCustomers,
	        addDashboardCustomers: addDashboardCustomers,
	        removeDashboardCustomers: removeDashboardCustomers,
	        makeDashboardPublic: makeDashboardPublic,
	        makeDashboardPrivate: makeDashboardPrivate,
	        getPublicDashboardLink: getPublicDashboardLink
	    };
	
	    return service;
	
	    function getTenantDashboardsByTenantId(tenantId, pageLink, config) {
	        var deferred = $q.defer();
	        var url = '/api/tenant/' + tenantId + '/dashboards?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(prepareDashboards(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getTenantDashboards(pageLink, config) {
	        var deferred = $q.defer();
	        var url = '/api/tenant/dashboards?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(prepareDashboards(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getCustomerDashboards(customerId, pageLink, config) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/dashboards?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&offset=' + pageLink.idOffset;
	        }
	        $http.get(url, config).then(function success(response) {
	            response.data = prepareDashboards(response.data);
	            if (pageLink.textSearch) {
	                response.data.data = $filter('filter')(response.data.data, { title: pageLink.textSearch });
	            }
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getServerTimeDiff() {
	        if (stDiffPromise) {
	            return stDiffPromise;
	        } else {
	            var deferred = $q.defer();
	            stDiffPromise = deferred.promise;
	            var url = '/api/dashboard/serverTime';
	            var ct1 = Date.now();
	            $http.get(url, { ignoreLoading: true }).then(function success(response) {
	                var ct2 = Date.now();
	                var st = response.data;
	                var stDiff = Math.ceil(st - (ct1 + ct2) / 2);
	                deferred.resolve(stDiff);
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return stDiffPromise;
	    }
	
	    function getDashboard(dashboardId) {
	        var deferred = $q.defer();
	        var url = '/api/dashboard/' + dashboardId;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getDashboardInfo(dashboardId, config) {
	        var deferred = $q.defer();
	        var url = '/api/dashboard/info/' + dashboardId;
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveDashboard(dashboard) {
	        var deferred = $q.defer();
	        var url = '/api/dashboard';
	        $http.post(url, cleanDashboard(dashboard)).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteDashboard(dashboardId) {
	        var deferred = $q.defer();
	        var url = '/api/dashboard/' + dashboardId;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function assignDashboardToCustomer(customerId, dashboardId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/dashboard/' + dashboardId;
	        $http.post(url, null).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function unassignDashboardFromCustomer(customerId, dashboardId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/dashboard/' + dashboardId;
	        $http.delete(url).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function updateDashboardCustomers(dashboardId, customerIds) {
	        var deferred = $q.defer();
	        var url = '/api/dashboard/' + dashboardId + '/customers';
	        $http.post(url, customerIds).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function addDashboardCustomers(dashboardId, customerIds) {
	        var deferred = $q.defer();
	        var url = '/api/dashboard/' + dashboardId + '/customers/add';
	        $http.post(url, customerIds).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function removeDashboardCustomers(dashboardId, customerIds) {
	        var deferred = $q.defer();
	        var url = '/api/dashboard/' + dashboardId + '/customers/remove';
	        $http.post(url, customerIds).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function makeDashboardPublic(dashboardId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/public/dashboard/' + dashboardId;
	        $http.post(url, null).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function makeDashboardPrivate(dashboardId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/public/dashboard/' + dashboardId;
	        $http.delete(url).then(function success(response) {
	            deferred.resolve(prepareDashboard(response.data));
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getPublicDashboardLink(dashboard) {
	        var url = $location.protocol() + '://' + $location.host();
	        var port = $location.port();
	        if (port != 80 && port != 443) {
	            url += ":" + port;
	        }
	        url += "/dashboard/" + dashboard.id.id + "?publicId=" + dashboard.publicCustomerId;
	        return url;
	    }
	
	    function prepareDashboards(dashboardsData) {
	        if (dashboardsData.data) {
	            for (var i = 0; i < dashboardsData.data.length; i++) {
	                dashboardsData.data[i] = prepareDashboard(dashboardsData.data[i]);
	            }
	        }
	        return dashboardsData;
	    }
	
	    function prepareDashboard(dashboard) {
	        dashboard.publicCustomerId = null;
	        dashboard.assignedCustomersText = "";
	        dashboard.assignedCustomersIds = [];
	        if (dashboard.assignedCustomers && dashboard.assignedCustomers.length) {
	            var assignedCustomersTitles = [];
	            for (var i = 0; i < dashboard.assignedCustomers.length; i++) {
	                var assignedCustomer = dashboard.assignedCustomers[i];
	                dashboard.assignedCustomersIds.push(assignedCustomer.customerId.id);
	                if (assignedCustomer.public) {
	                    dashboard.publicCustomerId = assignedCustomer.customerId.id;
	                } else {
	                    assignedCustomersTitles.push(assignedCustomer.title);
	                }
	            }
	            dashboard.assignedCustomersText = assignedCustomersTitles.join(', ');
	        }
	        return dashboard;
	    }
	
	    function cleanDashboard(dashboard) {
	        delete dashboard.publicCustomerId;
	        delete dashboard.assignedCustomersText;
	        delete dashboard.assignedCustomersIds;
	        return dashboard;
	    }
	}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';
	
	ConfirmOnExit.$inject = ["$state", "$mdDialog", "$window", "$filter", "$parse", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.confirmOnExit', []).directive('tbConfirmOnExit', ConfirmOnExit).name;
	
	/*@ngInject*/
	
	function ConfirmOnExit($state, $mdDialog, $window, $filter, $parse, userService) {
	    return {
	        link: function link($scope, $element, $attributes) {
	            $scope.confirmForm = $scope.$eval($attributes.confirmForm);
	            $window.onbeforeunload = function () {
	                if (userService.isAuthenticated() && ($scope.confirmForm && $scope.confirmForm.$dirty || $scope.$eval($attributes.isDirty))) {
	                    return $filter('translate')('confirm-on-exit.message');
	                }
	            };
	            $scope.$on('$stateChangeStart', function (event, next, current, params) {
	                if (userService.isAuthenticated() && ($scope.confirmForm && $scope.confirmForm.$dirty || $scope.$eval($attributes.isDirty))) {
	                    event.preventDefault();
	                    var confirm = $mdDialog.confirm().title($filter('translate')('confirm-on-exit.title')).htmlContent($filter('translate')('confirm-on-exit.html-message')).ariaLabel($filter('translate')('confirm-on-exit.title')).cancel($filter('translate')('action.cancel')).ok($filter('translate')('action.ok'));
	                    $mdDialog.show(confirm).then(function () {
	                        if ($scope.confirmForm) {
	                            $scope.confirmForm.$setPristine();
	                        } else {
	                            var remoteSetter = $parse($attributes.isDirty).assign;
	                            remoteSetter($scope, false);
	                            //$scope.isDirty = false;
	                        }
	                        $state.go(next.name, params);
	                    }, function () {});
	                }
	            });
	        },
	        scope: false
	    };
	}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DatakeyConfigDialogController.$inject = ["$scope", "$mdDialog", "$q", "entityService", "dataKey", "dataKeySettingsSchema", "entityAlias", "aliasController"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datakeyConfig = __webpack_require__(1173);
	
	var _datakeyConfig2 = _interopRequireDefault(_datakeyConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.dialogs.datakeyConfigDialog', [_datakeyConfig2.default]).controller('DatakeyConfigDialogController', DatakeyConfigDialogController).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function DatakeyConfigDialogController($scope, $mdDialog, $q, entityService, dataKey, dataKeySettingsSchema, entityAlias, aliasController) {
	
	    var vm = this;
	
	    vm.dataKey = dataKey;
	    vm.dataKeySettingsSchema = dataKeySettingsSchema;
	    vm.entityAlias = entityAlias;
	    vm.aliasController = aliasController;
	
	    vm.hide = function () {
	        $mdDialog.hide();
	    };
	
	    vm.cancel = function () {
	        $mdDialog.cancel();
	    };
	
	    vm.fetchEntityKeys = function (entityAliasId, query, type) {
	        var deferred = $q.defer();
	        vm.aliasController.getAliasInfo(entityAliasId).then(function success(aliasInfo) {
	            var entity = aliasInfo.currentEntity;
	            if (entity) {
	                entityService.getEntityKeys(entity.entityType, entity.id, query, type, { ignoreLoading: true }).then(function success(keys) {
	                    deferred.resolve(keys);
	                }, function fail() {
	                    deferred.resolve([]);
	                });
	            } else {
	                deferred.resolve([]);
	            }
	        }, function fail() {
	            deferred.resolve([]);
	        });
	        return deferred.promise;
	    };
	
	    vm.save = function () {
	        $scope.$broadcast('form-submit');
	        if ($scope.theForm.$valid) {
	            $scope.theForm.$setPristine();
	            $mdDialog.hide(vm.dataKey);
	        }
	    };
	}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ExpandFullscreen.$inject = ["$compile", "$document", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(755);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.expandFullscreen', []).directive('tbExpandFullscreen', ExpandFullscreen).name;
	
	/* eslint-disable angular/angularelement */
	
	/*@ngInject*/
	
	function ExpandFullscreen($compile, $document, $timeout) {
	
	    var uniqueId = 1;
	    var linker = function linker(scope, element, attrs) {
	
	        scope.body = angular.element($document.find('body').eq(0));
	        scope.fullscreenParentId = 'fullscreen-parent' + uniqueId;
	        scope.fullscreenParent = (0, _jquery2.default)('#' + scope.fullscreenParentId, scope.body)[0];
	        if (!scope.fullscreenParent) {
	            uniqueId++;
	            var fullscreenParent = angular.element('<div id=\'' + scope.fullscreenParentId + '\' class=\'tb-fullscreen-parent\'></div>');
	            scope.body.append(fullscreenParent);
	            scope.fullscreenParent = (0, _jquery2.default)('#' + scope.fullscreenParentId, scope.body)[0];
	            scope.fullscreenParent = angular.element(scope.fullscreenParent);
	            scope.fullscreenParent.css('display', 'none');
	        } else {
	            scope.fullscreenParent = angular.element(scope.fullscreenParent);
	        }
	
	        scope.$on('$destroy', function () {
	            scope.fullscreenParent.remove();
	        });
	
	        scope.elementParent = null;
	        scope.expanded = false;
	        scope.fullscreenZindex = scope.fullscreenZindex();
	
	        if (!scope.fullscreenZindex) {
	            scope.fullscreenZindex = '70';
	        }
	
	        scope.$watch('expanded', function (newExpanded, prevExpanded) {
	            if (newExpanded != prevExpanded) {
	                if (scope.expanded) {
	                    scope.elementParent = element.parent();
	                    element.detach();
	                    if (scope.backgroundStyle) {
	                        scope.fullscreenParent.attr("ng-style", "backgroundStyle");
	                        $compile(scope.fullscreenParent)(scope);
	                    }
	                    scope.fullscreenParent.append(element);
	                    scope.fullscreenParent.css('display', '');
	                    scope.fullscreenParent.css('z-index', scope.fullscreenZindex);
	                    element.addClass('tb-fullscreen');
	                } else {
	                    if (scope.elementParent) {
	                        element.detach();
	                        scope.elementParent.append(element);
	                        scope.elementParent = null;
	                    }
	                    element.removeClass('tb-fullscreen');
	                    scope.fullscreenParent.css('display', 'none');
	                    scope.fullscreenParent.css('z-index', '');
	                }
	                if (scope.onFullscreenChanged) {
	                    scope.onFullscreenChanged({ expanded: scope.expanded });
	                }
	            }
	        });
	
	        scope.$watch(function () {
	            return scope.expand();
	        }, function (newExpanded) {
	            scope.expanded = newExpanded;
	        });
	
	        scope.toggleExpand = function ($event) {
	            if ($event) {
	                $event.stopPropagation();
	            }
	            scope.expanded = !scope.expanded;
	        };
	
	        var buttonSize;
	        if (attrs.expandButtonSize) {
	            buttonSize = attrs.expandButtonSize;
	        }
	
	        var tooltipDirection = angular.isDefined(attrs.expandTooltipDirection) ? attrs.expandTooltipDirection : 'top';
	
	        var html = '<md-tooltip md-direction="{{expanded ? \'bottom\' : \'' + tooltipDirection + '\'}}">' + '{{(expanded ? \'fullscreen.exit\' : \'fullscreen.expand\') | translate}}' + '</md-tooltip>' + '<ng-md-icon ' + (buttonSize ? 'size="' + buttonSize + '" ' : '') + 'icon="{{expanded ? \'fullscreen_exit\' : \'fullscreen\'}}" ' + 'options=\'{"easing": "circ-in-out", "duration": 375, "rotation": "none"}\'>' + '</ng-md-icon>';
	
	        if (attrs.expandButtonId) {
	            $timeout(function () {
	                var expandButton = (0, _jquery2.default)('#' + attrs.expandButtonId, element)[0];
	                renderExpandButton(expandButton);
	            });
	        } else {
	            renderExpandButton();
	        }
	
	        function renderExpandButton(expandButton) {
	            if (expandButton) {
	                expandButton = angular.element(expandButton);
	                if (scope.hideExpandButton()) {
	                    expandButton.remove();
	                } else {
	                    expandButton.attr('md-ink-ripple', 'false');
	                    expandButton.append(html);
	
	                    $compile(expandButton.contents())(scope);
	
	                    expandButton.on("click", scope.toggleExpand);
	                }
	            } else if (!scope.hideExpandButton()) {
	                var button = angular.element('<md-button class="tb-fullscreen-button-style tb-fullscreen-button-pos md-icon-button" ' + 'md-ink-ripple="false" ng-click="toggleExpand($event)">' + html + '</md-button>');
	
	                $compile(button)(scope);
	
	                element.prepend(button);
	            }
	        }
	    };
	
	    return {
	        restrict: "A",
	        link: linker,
	        scope: {
	            expand: "&tbExpandFullscreen",
	            hideExpandButton: "&hideExpandButton",
	            onFullscreenChanged: "&onFullscreenChanged",
	            fullscreenZindex: "&fullscreenZindex",
	            backgroundStyle: "=?fullscreenBackgroundStyle"
	        }
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	JsonForm.$inject = ["$compile", "$templateCache", "$mdColorPicker"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(759);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _objectpath = __webpack_require__(526);
	
	var _objectpath2 = _interopRequireDefault(_objectpath);
	
	var _schemaInspector = __webpack_require__(1703);
	
	var _schemaInspector2 = _interopRequireDefault(_schemaInspector);
	
	var _jsonFormReact = __webpack_require__(638);
	
	var _jsonFormReact2 = _interopRequireDefault(_jsonFormReact);
	
	var _jsonFormTpl = __webpack_require__(1402);
	
	var _jsonFormTpl2 = _interopRequireDefault(_jsonFormTpl);
	
	var _reactSchemaForm = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.directives.jsonForm', []).directive('tbJsonForm', JsonForm).value('ReactSchemaForm', _jsonFormReact2.default).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function JsonForm($compile, $templateCache, $mdColorPicker) {
	
	    var linker = function linker(scope, element) {
	
	        var template = $templateCache.get(_jsonFormTpl2.default);
	
	        element.html(template);
	
	        var childScope;
	
	        var destroyModelChangeWatches = function destroyModelChangeWatches() {
	            if (scope.modelWatchHandle) {
	                scope.modelWatchHandle();
	            }
	            if (scope.modelRefWatchHandle) {
	                scope.modelRefWatchHandle();
	            }
	        };
	
	        var initModelChangeWatches = function initModelChangeWatches() {
	            scope.modelWatchHandle = scope.$watch('model', function (newValue, prevValue) {
	                if (newValue && prevValue && !angular.equals(newValue, prevValue)) {
	                    scope.validate();
	                    if (scope.formControl) {
	                        scope.formControl.$setDirty();
	                    }
	                }
	            }, true);
	            scope.modelRefWatchHandle = scope.$watch('model', function (newValue, prevValue) {
	                if (newValue && newValue != prevValue) {
	                    scope.updateValues();
	                }
	            });
	        };
	
	        var recompile = function recompile() {
	            if (childScope) {
	                childScope.$destroy();
	            }
	            childScope = scope.$new();
	            $compile(element.contents())(childScope);
	        };
	
	        scope.formProps = {
	            option: {
	                formDefaults: {
	                    startEmpty: true
	                }
	            },
	            onModelChange: function onModelChange(key, val) {
	                if (angular.isString(val) && val === '') {
	                    val = undefined;
	                }
	                selectOrSet(key, scope.model, val);
	                scope.formProps.model = scope.model;
	            },
	            onColorClick: function onColorClick(event, key, val) {
	                scope.showColorPicker(event, val);
	            }
	        };
	
	        scope.showColorPicker = function (event, color) {
	            $mdColorPicker.show({
	                value: (0, _tinycolor2.default)(color).toRgbString(),
	                defaultValue: '#fff',
	                random: _tinycolor2.default.random(),
	                clickOutsideToClose: false,
	                hasBackdrop: false,
	                skipHide: true,
	                preserveScope: false,
	
	                mdColorAlphaChannel: true,
	                mdColorSpectrum: true,
	                mdColorSliders: true,
	                mdColorGenericPalette: false,
	                mdColorMaterialPalette: true,
	                mdColorHistory: false,
	                mdColorDefaultTab: 2,
	
	                $event: event
	
	            }).then(function (color) {
	                if (event.data && event.data.onValueChanged) {
	                    event.data.onValueChanged((0, _tinycolor2.default)(color).toRgb());
	                }
	            });
	        };
	
	        scope.validate = function () {
	            if (scope.schema && scope.model) {
	                var result = _reactSchemaForm.utils.validateBySchema(scope.schema, scope.model);
	                if (scope.formControl) {
	                    scope.formControl.$setValidity('jsonForm', result.valid);
	                }
	            }
	        };
	
	        scope.updateValues = function (skipRerender) {
	            destroyModelChangeWatches();
	            if (!skipRerender) {
	                element.html(template);
	            }
	            var readonly = scope.readonly && scope.readonly === true ? true : false;
	            var schema = scope.schema ? angular.copy(scope.schema) : {
	                type: 'object'
	            };
	            schema.strict = true;
	            var form = scope.form ? angular.copy(scope.form) : ["*"];
	            var model = scope.model || {};
	            scope.model = _schemaInspector2.default.sanitize(schema, model).data;
	            scope.formProps.option.formDefaults.readonly = readonly;
	            scope.formProps.schema = schema;
	            scope.formProps.form = form;
	            scope.formProps.model = angular.copy(scope.model);
	            if (!skipRerender) {
	                recompile();
	            }
	            initModelChangeWatches();
	        };
	
	        scope.updateValues(true);
	
	        scope.$watch('readonly', function () {
	            scope.updateValues();
	        });
	
	        scope.$watch('schema', function (newValue, prevValue) {
	            if (newValue && newValue != prevValue) {
	                scope.updateValues();
	                scope.validate();
	            }
	        });
	
	        scope.$watch('form', function (newValue, prevValue) {
	            if (newValue && newValue != prevValue) {
	                scope.updateValues();
	            }
	        });
	
	        scope.validate();
	
	        recompile();
	    };
	
	    return {
	        restrict: "E",
	        scope: {
	            schema: '=',
	            form: '=',
	            model: '=',
	            formControl: '=',
	            readonly: '='
	        },
	        link: linker
	    };
	}
	
	function setValue(obj, key, val) {
	    var changed = false;
	    if (obj) {
	        if (angular.isUndefined(val)) {
	            if (angular.isDefined(obj[key])) {
	                delete obj[key];
	                changed = true;
	            }
	        } else {
	            changed = !angular.equals(obj[key], val);
	            obj[key] = val;
	        }
	    }
	    return changed;
	}
	
	function selectOrSet(projection, obj, valueToSet) {
	    var numRe = /^\d+$/;
	
	    if (!obj) {
	        obj = this;
	    }
	
	    if (!obj) {
	        return false;
	    }
	
	    var parts = angular.isString(projection) ? _objectpath2.default.parse(projection) : projection;
	
	    if (parts.length === 1) {
	        return setValue(obj, parts[0], valueToSet);
	    }
	
	    if (angular.isUndefined(obj[parts[0]])) {
	        obj[parts[0]] = parts.length > 2 && numRe.test(parts[1]) ? [] : {};
	    }
	
	    var value = obj[parts[0]];
	    for (var i = 1; i < parts.length; i++) {
	        if (parts[i] === '') {
	            return false;
	        }
	        if (i === parts.length - 1) {
	            return setValue(value, parts[i], valueToSet);
	        } else {
	            var tmp = value[parts[i]];
	            if (angular.isUndefined(tmp) || tmp === null) {
	                tmp = numRe.test(parts[i + 1]) ? [] : {};
	                value[parts[i]] = tmp;
	            }
	            value = tmp;
	        }
	    }
	    return value;
	}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	var path = 'entity/alias/entity-alias-dialog.tpl.html';
	var html = " <md-dialog class=tb-entity-alias-dialog style=width:600px aria-label=\"{{ (vm.isAdd ? 'alias.add' : 'alias.edit') | translate  }}\"> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2>{{ (vm.isAdd ? 'alias.add' : 'alias.edit') | translate }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=$root.loading> <div flex layout=column> <div layout=row> <md-input-container flex class=md-block> <label translate>alias.name</label> <input required name=aliasName ng-model=vm.alias.alias aria-label=\"{{ 'alias.name' | translate }}\"> <div ng-messages=theForm.aliasName.$error> <div ng-message=required translate>alias.name-required</div> <div ng-message=duplicateAliasName translate>alias.duplicate-alias</div> </div> </md-input-container> <section class=tb-resolve-multiple-switch layout=column layout-align=\"start center\"> <label class=\"tb-small resolve-multiple-label\" translate>alias.resolve-multiple</label> <md-switch class=resolve-multiple-switch ng-model=vm.alias.filter.resolveMultiple aria-label=\"{{ 'alias.resolve-multiple' | translate }}\"> </md-switch> </section> </div> <tb-entity-filter ng-model=vm.alias.filter allowed-entity-types=vm.allowedEntityTypes the-form=theForm> </tb-entity-filter> <div class=tb-error-messages ng-messages=theForm.$error role=alert> <div translate ng-message=entityFilter class=tb-error-message>alias.entity-filter-no-entity-matched</div> </div> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ (vm.isAdd ? 'action.add' : 'action.save') | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ChildrenUtils = __webpack_require__(1571);
	
	var _AnimateChild = __webpack_require__(1569);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _CSSMotion = __webpack_require__(1570);
	
	var _CSSMotion2 = _interopRequireDefault(_CSSMotion);
	
	var _animate = __webpack_require__(533);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  } // eslint-disable-line
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.CSSMotion = _CSSMotion2['default'];
	Animate.propTypes = {
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = Animate;
	module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_STYLE = undefined;
	exports.getValuePropValue = getValuePropValue;
	exports.getPropValue = getPropValue;
	exports.isCombobox = isCombobox;
	exports.isMultipleOrTags = isMultipleOrTags;
	exports.isMultipleOrTagsOrCombobox = isMultipleOrTagsOrCombobox;
	exports.isSingleMode = isSingleMode;
	exports.toArray = toArray;
	exports.preventDefaultEvent = preventDefaultEvent;
	exports.findIndexInValueByKey = findIndexInValueByKey;
	exports.findIndexInValueByLabel = findIndexInValueByLabel;
	exports.getSelectKeys = getSelectKeys;
	exports.findFirstMenuItem = findFirstMenuItem;
	exports.includesSeparators = includesSeparators;
	exports.splitBySeparators = splitBySeparators;
	exports.defaultFilterFn = defaultFilterFn;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getValuePropValue(child) {
	  var props = child.props;
	  if ('value' in props) {
	    return props.value;
	  }
	  if (child.key) {
	    return child.key;
	  }
	  if (child.type && child.type.isSelectOptGroup && props.label) {
	    return props.label;
	  }
	  throw new Error('Need at least a key or a value or a label (only for OptGroup) for ' + child);
	}
	
	function getPropValue(child, prop) {
	  if (prop === 'value') {
	    return getValuePropValue(child);
	  }
	  return child.props[prop];
	}
	
	function isCombobox(props) {
	  return props.combobox;
	}
	
	function isMultipleOrTags(props) {
	  return props.multiple || props.tags;
	}
	
	function isMultipleOrTagsOrCombobox(props) {
	  return isMultipleOrTags(props) || isCombobox(props);
	}
	
	function isSingleMode(props) {
	  return !isMultipleOrTagsOrCombobox(props);
	}
	
	function toArray(value) {
	  var ret = value;
	  if (value === undefined) {
	    ret = [];
	  } else if (!Array.isArray(value)) {
	    ret = [value];
	  }
	  return ret;
	}
	
	function preventDefaultEvent(e) {
	  e.preventDefault();
	}
	
	function findIndexInValueByKey(value, key) {
	  var index = -1;
	  for (var i = 0; i < value.length; i++) {
	    if (value[i].key === key) {
	      index = i;
	      break;
	    }
	  }
	  return index;
	}
	
	function findIndexInValueByLabel(value, label) {
	  var index = -1;
	  for (var i = 0; i < value.length; i++) {
	    if (toArray(value[i].label).join('') === label) {
	      index = i;
	      break;
	    }
	  }
	  return index;
	}
	
	function getSelectKeys(menuItems, value) {
	  if (value === null || value === undefined) {
	    return [];
	  }
	  var selectedKeys = [];
	  _react2['default'].Children.forEach(menuItems, function (item) {
	    if (item.type.isMenuItemGroup) {
	      selectedKeys = selectedKeys.concat(getSelectKeys(item.props.children, value));
	    } else {
	      var itemValue = getValuePropValue(item);
	      var itemKey = item.key;
	      if (findIndexInValueByKey(value, itemValue) !== -1 && itemKey) {
	        selectedKeys.push(itemKey);
	      }
	    }
	  });
	  return selectedKeys;
	}
	
	var UNSELECTABLE_STYLE = exports.UNSELECTABLE_STYLE = {
	  userSelect: 'none',
	  WebkitUserSelect: 'none'
	};
	
	var UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_ATTRIBUTE = {
	  unselectable: 'unselectable'
	};
	
	function findFirstMenuItem(children) {
	  for (var i = 0; i < children.length; i++) {
	    var child = children[i];
	    if (child.type.isMenuItemGroup) {
	      var found = findFirstMenuItem(child.props.children);
	      if (found) {
	        return found;
	      }
	    } else if (!child.props.disabled) {
	      return child;
	    }
	  }
	  return null;
	}
	
	function includesSeparators(string, separators) {
	  for (var i = 0; i < separators.length; ++i) {
	    if (string.lastIndexOf(separators[i]) > 0) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function splitBySeparators(string, separators) {
	  var reg = new RegExp('[' + separators.join() + ']');
	  return string.split(reg).filter(function (token) {
	    return token;
	  });
	}
	
	function defaultFilterFn(input, child) {
	  return String(getPropValue(child, this.props.optionFilterProp)).indexOf(input) > -1;
	}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = addEventListenerWrap;
	
	var _addDomEventListener = __webpack_require__(588);
	
	var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function addEventListenerWrap(target, eventType, cb, option) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom2['default'].unstable_batchedUpdates ? function run(e) {
	    _reactDom2['default'].unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener2['default'])(target, eventType, callback, option);
	}
	module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(91);
	var Danger = __webpack_require__(1600);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInstrumentation = __webpack_require__(43);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(246);
	var setInnerHTML = __webpack_require__(158);
	var setTextContent = __webpack_require__(558);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactPropTypesSecret = __webpack_require__(1630);
	var propTypesFactory = __webpack_require__(531);
	
	var React = __webpack_require__(97);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(11);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(59);
	var ReactInstanceMap = __webpack_require__(117);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(46);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var emptyFunction = __webpack_require__(38);
	var warning = __webpack_require__(16);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComposedComponent = __webpack_require__(58);
	
	var _ComposedComponent2 = _interopRequireDefault(_ComposedComponent);
	
	var _Checkbox = __webpack_require__(108);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 20/09/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Checkbox2 = function (_React$Component) {
	    _inherits(Checkbox2, _React$Component);
	
	    function Checkbox2() {
	        _classCallCheck(this, Checkbox2);
	
	        return _possibleConstructorReturn(this, (Checkbox2.__proto__ || Object.getPrototypeOf(Checkbox2)).apply(this, arguments));
	    }
	
	    _createClass(Checkbox2, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.form.className },
	                _react2.default.createElement(_Checkbox2.default, {
	                    name: this.props.form.key.slice(-1)[0],
	                    value: this.props.form.key.slice(-1)[0],
	                    checked: this.props.value || false,
	                    label: this.props.form.title,
	                    disabled: this.props.form.readonly,
	                    onCheck: function onCheck(e, checked) {
	                        _this2.props.onChangeValidate(e);
	                    }
	                })
	            );
	        }
	    }]);
	
	    return Checkbox2;
	}(_react2.default.Component);
	
	var _default = (0, _ComposedComponent2.default)(Checkbox2);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Checkbox2, 'Checkbox2', 'src/Checkbox.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/Checkbox.js');
	}();
	
	;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComposedComponent = __webpack_require__(58);
	
	var _ComposedComponent2 = _interopRequireDefault(_ComposedComponent);
	
	var _DatePicker = __webpack_require__(213);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 22/12/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var utils = __webpack_require__(77);
	var classNames = __webpack_require__(52);
	
	/**
	 * There is no default number picker as part of Material-UI.
	 * Instead, use a TextField and validate.
	 */
	var Date = function (_React$Component) {
	    _inherits(Date, _React$Component);
	
	    function Date(props) {
	        _classCallCheck(this, Date);
	
	        var _this = _possibleConstructorReturn(this, (Date.__proto__ || Object.getPrototypeOf(Date)).call(this, props));
	
	        _this.onDatePicked = _this.onDatePicked.bind(_this);
	        return _this;
	    }
	
	    _createClass(Date, [{
	        key: 'onDatePicked',
	        value: function onDatePicked(empty, date) {
	            this.props.onChangeValidate(date);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var value = null;
	            if (this.props && this.props.value) {
	                value = this.props.value;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { style: { width: '100%', display: 'block' }, className: this.props.form.htmlClass },
	                _react2.default.createElement(_DatePicker2.default, {
	                    mode: 'landscape',
	                    autoOk: true,
	                    floatingLabelText: this.props.form.title,
	                    hintText: this.props.form.title,
	                    onChange: this.onDatePicked,
	                    onShow: null,
	                    onDismiss: null,
	                    value: value,
	                    disabled: this.props.form.readonly,
	                    style: this.props.form.style || { width: '100%' } })
	            );
	        }
	    }]);
	
	    return Date;
	}(_react2.default.Component);
	
	var _default = (0, _ComposedComponent2.default)(Date);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Date, 'Date', 'src/Date.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/Date.js');
	}();
	
	;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComposedComponent = __webpack_require__(58);
	
	var _ComposedComponent2 = _interopRequireDefault(_ComposedComponent);
	
	var _TextField = __webpack_require__(40);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 15/09/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * There is no default number picker as part of Material-UI.
	 * Instead, use a TextField and validate.
	 */
	var Number = function (_React$Component) {
	    _inherits(Number, _React$Component);
	
	    function Number(props) {
	        _classCallCheck(this, Number);
	
	        var _this = _possibleConstructorReturn(this, (Number.__proto__ || Object.getPrototypeOf(Number)).call(this, props));
	
	        _this.preValidationCheck = _this.preValidationCheck.bind(_this);
	        _this.state = {
	            lastSuccessfulValue: _this.props.value
	        };
	        return _this;
	    }
	
	    _createClass(Number, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                lastSuccessfulValue: nextProps.value
	            });
	        }
	    }, {
	        key: 'isNumeric',
	        value: function isNumeric(n) {
	            return !isNaN(parseFloat(n)) && isFinite(n);
	        }
	
	        /**
	         * Prevent the field from accepting non-numeric characters.
	         * @param e
	         */
	
	    }, {
	        key: 'preValidationCheck',
	        value: function preValidationCheck(e) {
	            if (this.isNumeric(e.target.value)) {
	                this.setState({
	                    lastSuccessfulValue: e.target.value
	                });
	                this.props.onChangeValidate(e);
	            } else {
	                this.refs.numberField.value = this.state.lastSuccessfulValue;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.form.htmlClass },
	                _react2.default.createElement(_TextField2.default, {
	                    type: this.props.form.type,
	                    floatingLabelText: this.props.form.title,
	                    hintText: this.props.form.placeholder,
	                    errorText: this.props.error,
	                    onChange: this.preValidationCheck,
	                    value: this.state.lastSuccessfulValue,
	                    ref: 'numberField',
	                    disabled: this.props.form.readonly,
	                    style: this.props.form.style || { width: '100%' } })
	            );
	        }
	    }]);
	
	    return Number;
	}(_react2.default.Component);
	
	var _default = (0, _ComposedComponent2.default)(Number);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Number, 'Number', 'src/Number.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/Number.js');
	}();
	
	;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComposedComponent = __webpack_require__(58);
	
	var _ComposedComponent2 = _interopRequireDefault(_ComposedComponent);
	
	var _TextField = __webpack_require__(40);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 15/09/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Text = function (_React$Component) {
	    _inherits(Text, _React$Component);
	
	    function Text() {
	        _classCallCheck(this, Text);
	
	        return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
	    }
	
	    _createClass(Text, [{
	        key: 'render',
	        value: function render() {
	            //console.log('Text props', this.props.form.readonly);
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.form.htmlClass },
	                _react2.default.createElement(_TextField2.default, {
	                    type: this.props.form.type,
	                    floatingLabelText: this.props.form.title,
	                    hintText: this.props.form.placeholder,
	                    errorText: this.props.error,
	                    onChange: this.props.onChangeValidate,
	                    defaultValue: this.props.value,
	                    disabled: this.props.form.readonly,
	                    style: this.props.form.style || { width: '100%' } })
	            );
	        }
	    }]);
	
	    return Text;
	}(_react2.default.Component);
	
	var _default = (0, _ComposedComponent2.default)(Text);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Text, 'Text', 'src/Text.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/Text.js');
	}();
	
	;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComposedComponent = __webpack_require__(58);
	
	var _ComposedComponent2 = _interopRequireDefault(_ComposedComponent);
	
	var _TextField = __webpack_require__(40);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 15/09/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var TextArea = function (_React$Component) {
	    _inherits(TextArea, _React$Component);
	
	    function TextArea() {
	        _classCallCheck(this, TextArea);
	
	        return _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));
	    }
	
	    _createClass(TextArea, [{
	        key: 'render',
	        value: function render() {
	            // FIXME: Obviously fix rowsMax eventually..
	            //console.log('TextArea', this.props.form);
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.form.htmlClass },
	                _react2.default.createElement(_TextField2.default, {
	                    type: this.props.form.type,
	                    floatingLabelText: this.props.form.title,
	                    hintText: this.props.form.placeholder,
	                    onChange: this.props.onChangeValidate,
	                    errorText: this.props.error,
	                    defaultValue: this.props.value,
	                    multiLine: true,
	                    rows: this.props.form.rows,
	                    rowsMax: this.props.form.rowsMax,
	                    disabled: this.props.form.readonly,
	                    style: this.props.form.style || { width: '100%' }
	                })
	            );
	        }
	    }]);
	
	    return TextArea;
	}(_react2.default.Component);
	
	var _default = (0, _ComposedComponent2.default)(TextArea);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(TextArea, 'TextArea', 'src/TextArea.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/TextArea.js');
	}();
	
	;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(151);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(104);
	util.inherits = __webpack_require__(30);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1720)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(570);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(162).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(569);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(78);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(78);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(260).setImmediate, (function() { return this; }())))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var ClientRequest = __webpack_require__(1711)
	var response = __webpack_require__(577)
	var extend = __webpack_require__(1737)
	var statusCodes = __webpack_require__(660)
	var url = __webpack_require__(261)
	
	var http = exports
	
	http.request = function (opts, cb) {
		if (typeof opts === 'string')
			opts = url.parse(opts)
		else
			opts = extend(opts)
	
		// Normally, the page is loaded from http or https, so not specifying a protocol
		// will result in a (valid) protocol-relative url. However, this won't work if
		// the protocol is something else, like 'file:'
		var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''
	
		var protocol = opts.protocol || defaultProtocol
		var host = opts.hostname || opts.host
		var port = opts.port
		var path = opts.path || '/'
	
		// Necessary for IPv6 addresses
		if (host && host.indexOf(':') !== -1)
			host = '[' + host + ']'
	
		// This may be a relative url. The browser should always be able to interpret it correctly.
		opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
		opts.method = (opts.method || 'GET').toUpperCase()
		opts.headers = opts.headers || {}
	
		// Also valid opts.auth, opts.mode
	
		var req = new ClientRequest(opts)
		if (cb)
			req.on('response', cb)
		return req
	}
	
	http.get = function get (opts, cb) {
		var req = http.request(opts, cb)
		req.end()
		return req
	}
	
	http.ClientRequest = ClientRequest
	http.IncomingMessage = response.IncomingMessage
	
	http.Agent = function () {}
	http.Agent.defaultMaxSockets = 4
	
	http.globalAgent = new http.Agent()
	
	http.STATUS_CODES = statusCodes
	
	http.METHODS = [
		'CHECKOUT',
		'CONNECT',
		'COPY',
		'DELETE',
		'GET',
		'HEAD',
		'LOCK',
		'M-SEARCH',
		'MERGE',
		'MKACTIVITY',
		'MKCOL',
		'MOVE',
		'NOTIFY',
		'OPTIONS',
		'PATCH',
		'POST',
		'PROPFIND',
		'PROPPATCH',
		'PURGE',
		'PUT',
		'REPORT',
		'SEARCH',
		'SUBSCRIBE',
		'TRACE',
		'UNLOCK',
		'UNSUBSCRIBE'
	]
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1705);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(1718);
	var util = __webpack_require__(1719);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(1562);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {/*! @flowjs/ng-flow 2.7.8 */
	!function(a,b,c){"use strict";function d(b){if(this.support=!("undefined"==typeof File||"undefined"==typeof Blob||"undefined"==typeof FileList||!Blob.prototype.slice&&!Blob.prototype.webkitSlice&&!Blob.prototype.mozSlice),this.support){this.supportDirectory=/Chrome/.test(a.navigator.userAgent)||/Firefox/.test(a.navigator.userAgent)||/Edge/.test(a.navigator.userAgent),this.files=[],this.defaults={chunkSize:1048576,forceChunkSize:!1,simultaneousUploads:3,singleFile:!1,fileParameterName:"file",progressCallbacksInterval:500,speedSmoothingFactor:.1,query:{},headers:{},withCredentials:!1,preprocess:null,method:"multipart",testMethod:"GET",uploadMethod:"POST",prioritizeFirstAndLastChunk:!1,allowDuplicateUploads:!1,target:"/",testChunks:!0,generateUniqueIdentifier:null,maxChunkRetries:0,chunkRetryInterval:null,permanentErrors:[404,413,415,500,501],successStatuses:[200,201,202],onDropStopPropagation:!1,initFileFn:null,readFileFn:f},this.opts={},this.events={};var c=this;this.onDrop=function(a){c.opts.onDropStopPropagation&&a.stopPropagation(),a.preventDefault();var b=a.dataTransfer;b.items&&b.items[0]&&b.items[0].webkitGetAsEntry?c.webkitReadDataTransfer(a):c.addFiles(b.files,a)},this.preventEvent=function(a){a.preventDefault()},this.opts=d.extend({},this.defaults,b||{})}}function e(a,b,d){this.flowObj=a,this.bytes=null,this.file=b,this.name=b.fileName||b.name,this.size=b.size,this.relativePath=b.relativePath||b.webkitRelativePath||this.name,this.uniqueIdentifier=d===c?a.generateUniqueIdentifier(b):d,this.chunks=[],this.paused=!1,this.error=!1,this.averageSpeed=0,this.currentSpeed=0,this._lastProgressCallback=Date.now(),this._prevUploadedSize=0,this._prevProgress=0,this.bootstrap()}function f(a,b,c,d,e){var f="slice";a.file.slice?f="slice":a.file.mozSlice?f="mozSlice":a.file.webkitSlice&&(f="webkitSlice"),e.readFinished(a.file[f](b,c,d))}function g(a,b,c){this.flowObj=a,this.fileObj=b,this.offset=c,this.tested=!1,this.retries=0,this.pendingRetry=!1,this.preprocessState=0,this.readState=0,this.loaded=0,this.total=0,this.chunkSize=this.flowObj.opts.chunkSize,this.startByte=this.offset*this.chunkSize,this.computeEndByte=function(){var a=Math.min(this.fileObj.size,(this.offset+1)*this.chunkSize);return this.fileObj.size-a<this.chunkSize&&!this.flowObj.opts.forceChunkSize&&(a=this.fileObj.size),a},this.endByte=this.computeEndByte(),this.xhr=null;var d=this;this.event=function(a,b){b=Array.prototype.slice.call(arguments),b.unshift(d),d.fileObj.chunkEvent.apply(d.fileObj,b)},this.progressHandler=function(a){a.lengthComputable&&(d.loaded=a.loaded,d.total=a.total),d.event("progress",a)},this.testHandler=function(a){var b=d.status(!0);"error"===b?(d.event(b,d.message()),d.flowObj.uploadNextChunk()):"success"===b?(d.tested=!0,d.event(b,d.message()),d.flowObj.uploadNextChunk()):d.fileObj.paused||(d.tested=!0,d.send())},this.doneHandler=function(a){var b=d.status();if("success"===b||"error"===b)delete this.data,d.event(b,d.message()),d.flowObj.uploadNextChunk();else{d.event("retry",d.message()),d.pendingRetry=!0,d.abort(),d.retries++;var c=d.flowObj.opts.chunkRetryInterval;null!==c?setTimeout(function(){d.send()},c):d.send()}}}function h(a,b){var c=a.indexOf(b);c>-1&&a.splice(c,1)}function i(a,b){return"function"==typeof a&&(b=Array.prototype.slice.call(arguments),a=a.apply(null,b.slice(1))),a}function j(a,b){setTimeout(a.bind(b),0)}function k(a,b){return l(arguments,function(b){b!==a&&l(b,function(b,c){a[c]=b})}),a}function l(a,b,c){if(a){var d;if("undefined"!=typeof a.length){for(d=0;d<a.length;d++)if(b.call(c,a[d],d)===!1)return}else for(d in a)if(a.hasOwnProperty(d)&&b.call(c,a[d],d)===!1)return}}var m=a.navigator.msPointerEnabled;d.prototype={on:function(a,b){a=a.toLowerCase(),this.events.hasOwnProperty(a)||(this.events[a]=[]),this.events[a].push(b)},off:function(a,b){a!==c?(a=a.toLowerCase(),b!==c?this.events.hasOwnProperty(a)&&h(this.events[a],b):delete this.events[a]):this.events={}},fire:function(a,b){b=Array.prototype.slice.call(arguments),a=a.toLowerCase();var c=!1;return this.events.hasOwnProperty(a)&&l(this.events[a],function(a){c=a.apply(this,b.slice(1))===!1||c},this),"catchall"!=a&&(b.unshift("catchAll"),c=this.fire.apply(this,b)===!1||c),!c},webkitReadDataTransfer:function(a){function b(a){a.readEntries(function(f){f.length?(g+=f.length,l(f,function(a){if(a.isFile){var e=a.fullPath;a.file(function(a){c(a,e)},d)}else a.isDirectory&&b(a.createReader())}),b(a)):e()},d)}function c(a,b){a.relativePath=b.substring(1),h.push(a),e()}function d(a){throw a}function e(){0==--g&&f.addFiles(h,a)}var f=this,g=a.dataTransfer.items.length,h=[];l(a.dataTransfer.items,function(a){var d=a.webkitGetAsEntry();return d?void(d.isFile?c(a.getAsFile(),d.fullPath):b(d.createReader())):void e()})},generateUniqueIdentifier:function(a){var b=this.opts.generateUniqueIdentifier;if("function"==typeof b)return b(a);var c=a.relativePath||a.webkitRelativePath||a.fileName||a.name;return a.size+"-"+c.replace(/[^0-9a-zA-Z_-]/gim,"")},uploadNextChunk:function(a){var b=!1;if(this.opts.prioritizeFirstAndLastChunk&&(l(this.files,function(a){return!a.paused&&a.chunks.length&&"pending"===a.chunks[0].status()?(a.chunks[0].send(),b=!0,!1):!a.paused&&a.chunks.length>1&&"pending"===a.chunks[a.chunks.length-1].status()?(a.chunks[a.chunks.length-1].send(),b=!0,!1):void 0}),b))return b;if(l(this.files,function(a){return a.paused||l(a.chunks,function(a){return"pending"===a.status()?(a.send(),b=!0,!1):void 0}),b?!1:void 0}),b)return!0;var c=!1;return l(this.files,function(a){return a.isComplete()?void 0:(c=!0,!1)}),c||a||j(function(){this.fire("complete")},this),!1},assignBrowse:function(a,c,d,e){a instanceof Element&&(a=[a]),l(a,function(a){var f;"INPUT"===a.tagName&&"file"===a.type?f=a:(f=b.createElement("input"),f.setAttribute("type","file"),k(f.style,{visibility:"hidden",position:"absolute",width:"1px",height:"1px"}),a.appendChild(f),a.addEventListener("click",function(){f.click()},!1)),this.opts.singleFile||d||f.setAttribute("multiple","multiple"),c&&f.setAttribute("webkitdirectory","webkitdirectory"),l(e,function(a,b){f.setAttribute(b,a)});var g=this;f.addEventListener("change",function(a){a.target.value&&(g.addFiles(a.target.files,a),a.target.value="")},!1)},this)},assignDrop:function(a){"undefined"==typeof a.length&&(a=[a]),l(a,function(a){a.addEventListener("dragover",this.preventEvent,!1),a.addEventListener("dragenter",this.preventEvent,!1),a.addEventListener("drop",this.onDrop,!1)},this)},unAssignDrop:function(a){"undefined"==typeof a.length&&(a=[a]),l(a,function(a){a.removeEventListener("dragover",this.preventEvent),a.removeEventListener("dragenter",this.preventEvent),a.removeEventListener("drop",this.onDrop)},this)},isUploading:function(){var a=!1;return l(this.files,function(b){return b.isUploading()?(a=!0,!1):void 0}),a},_shouldUploadNext:function(){var a=0,b=!0,c=this.opts.simultaneousUploads;return l(this.files,function(d){l(d.chunks,function(d){return"uploading"===d.status()&&(a++,a>=c)?(b=!1,!1):void 0})}),b&&a},upload:function(){var a=this._shouldUploadNext();if(a!==!1){this.fire("uploadStart");for(var b=!1,c=1;c<=this.opts.simultaneousUploads-a;c++)b=this.uploadNextChunk(!0)||b;b||j(function(){this.fire("complete")},this)}},resume:function(){l(this.files,function(a){a.isComplete()||a.resume()})},pause:function(){l(this.files,function(a){a.pause()})},cancel:function(){for(var a=this.files.length-1;a>=0;a--)this.files[a].cancel()},progress:function(){var a=0,b=0;return l(this.files,function(c){a+=c.progress()*c.size,b+=c.size}),b>0?a/b:0},addFile:function(a,b){this.addFiles([a],b)},addFiles:function(a,b){var c=[];l(a,function(a){if((!m||m&&a.size>0)&&(a.size%4096!==0||"."!==a.name&&"."!==a.fileName)){var d=this.generateUniqueIdentifier(a);if(this.opts.allowDuplicateUploads||!this.getFromUniqueIdentifier(d)){var f=new e(this,a,d);this.fire("fileAdded",f,b)&&c.push(f)}}},this),this.fire("filesAdded",c,b)&&(l(c,function(a){this.opts.singleFile&&this.files.length>0&&this.removeFile(this.files[0]),this.files.push(a)},this),this.fire("filesSubmitted",c,b))},removeFile:function(a){for(var b=this.files.length-1;b>=0;b--)this.files[b]===a&&(this.files.splice(b,1),a.abort(),this.fire("fileRemoved",a))},getFromUniqueIdentifier:function(a){var b=!1;return l(this.files,function(c){c.uniqueIdentifier===a&&(b=c)}),b},getSize:function(){var a=0;return l(this.files,function(b){a+=b.size}),a},sizeUploaded:function(){var a=0;return l(this.files,function(b){a+=b.sizeUploaded()}),a},timeRemaining:function(){var a=0,b=0;return l(this.files,function(c){c.paused||c.error||(a+=c.size-c.sizeUploaded(),b+=c.averageSpeed)}),a&&!b?Number.POSITIVE_INFINITY:a||b?Math.floor(a/b):0}},e.prototype={measureSpeed:function(){var a=Date.now()-this._lastProgressCallback;if(a){var b=this.flowObj.opts.speedSmoothingFactor,c=this.sizeUploaded();this.currentSpeed=Math.max((c-this._prevUploadedSize)/a*1e3,0),this.averageSpeed=b*this.currentSpeed+(1-b)*this.averageSpeed,this._prevUploadedSize=c}},chunkEvent:function(a,b,c){switch(b){case"progress":if(Date.now()-this._lastProgressCallback<this.flowObj.opts.progressCallbacksInterval)break;this.measureSpeed(),this.flowObj.fire("fileProgress",this,a),this.flowObj.fire("progress"),this._lastProgressCallback=Date.now();break;case"error":this.error=!0,this.abort(!0),this.flowObj.fire("fileError",this,c,a),this.flowObj.fire("error",c,this,a);break;case"success":if(this.error)return;this.measureSpeed(),this.flowObj.fire("fileProgress",this,a),this.flowObj.fire("progress"),this._lastProgressCallback=Date.now(),this.isComplete()&&(this.currentSpeed=0,this.averageSpeed=0,this.flowObj.fire("fileSuccess",this,c,a));break;case"retry":this.flowObj.fire("fileRetry",this,a)}},pause:function(){this.paused=!0,this.abort()},resume:function(){this.paused=!1,this.flowObj.upload()},abort:function(a){this.currentSpeed=0,this.averageSpeed=0;var b=this.chunks;a&&(this.chunks=[]),l(b,function(a){"uploading"===a.status()&&(a.abort(),this.flowObj.uploadNextChunk())},this)},cancel:function(){this.flowObj.removeFile(this)},retry:function(){this.bootstrap(),this.flowObj.upload()},bootstrap:function(){"function"==typeof this.flowObj.opts.initFileFn&&this.flowObj.opts.initFileFn(this),this.abort(!0),this.error=!1,this._prevProgress=0;for(var a=this.flowObj.opts.forceChunkSize?Math.ceil:Math.floor,b=Math.max(a(this.size/this.flowObj.opts.chunkSize),1),c=0;b>c;c++)this.chunks.push(new g(this.flowObj,this,c))},progress:function(){if(this.error)return 1;if(1===this.chunks.length)return this._prevProgress=Math.max(this._prevProgress,this.chunks[0].progress()),this._prevProgress;var a=0;l(this.chunks,function(b){a+=b.progress()*(b.endByte-b.startByte)});var b=a/this.size;return this._prevProgress=Math.max(this._prevProgress,b>.9999?1:b),this._prevProgress},isUploading:function(){var a=!1;return l(this.chunks,function(b){return"uploading"===b.status()?(a=!0,!1):void 0}),a},isComplete:function(){var a=!1;return l(this.chunks,function(b){var c=b.status();return"pending"===c||"uploading"===c||"reading"===c||1===b.preprocessState||1===b.readState?(a=!0,!1):void 0}),!a},sizeUploaded:function(){var a=0;return l(this.chunks,function(b){a+=b.sizeUploaded()}),a},timeRemaining:function(){if(this.paused||this.error)return 0;var a=this.size-this.sizeUploaded();return a&&!this.averageSpeed?Number.POSITIVE_INFINITY:a||this.averageSpeed?Math.floor(a/this.averageSpeed):0},getType:function(){return this.file.type&&this.file.type.split("/")[1]},getExtension:function(){return this.name.substr((~-this.name.lastIndexOf(".")>>>0)+2).toLowerCase()}},g.prototype={getParams:function(){return{flowChunkNumber:this.offset+1,flowChunkSize:this.flowObj.opts.chunkSize,flowCurrentChunkSize:this.endByte-this.startByte,flowTotalSize:this.fileObj.size,flowIdentifier:this.fileObj.uniqueIdentifier,flowFilename:this.fileObj.name,flowRelativePath:this.fileObj.relativePath,flowTotalChunks:this.fileObj.chunks.length}},getTarget:function(a,b){return a+=a.indexOf("?")<0?"?":"&",a+b.join("&")},test:function(){this.xhr=new XMLHttpRequest,this.xhr.addEventListener("load",this.testHandler,!1),this.xhr.addEventListener("error",this.testHandler,!1);var a=i(this.flowObj.opts.testMethod,this.fileObj,this),b=this.prepareXhrRequest(a,!0);this.xhr.send(b)},preprocessFinished:function(){this.endByte=this.computeEndByte(),this.preprocessState=2,this.send()},readFinished:function(a){this.readState=2,this.bytes=a,this.send()},send:function(){var a=this.flowObj.opts.preprocess,b=this.flowObj.opts.readFileFn;if("function"==typeof a)switch(this.preprocessState){case 0:return this.preprocessState=1,void a(this);case 1:return}switch(this.readState){case 0:return this.readState=1,void b(this.fileObj,this.startByte,this.endByte,this.fileObj.file.type,this);case 1:return}if(this.flowObj.opts.testChunks&&!this.tested)return void this.test();this.loaded=0,this.total=0,this.pendingRetry=!1,this.xhr=new XMLHttpRequest,this.xhr.upload.addEventListener("progress",this.progressHandler,!1),this.xhr.addEventListener("load",this.doneHandler,!1),this.xhr.addEventListener("error",this.doneHandler,!1);var c=i(this.flowObj.opts.uploadMethod,this.fileObj,this),d=this.prepareXhrRequest(c,!1,this.flowObj.opts.method,this.bytes);this.xhr.send(d)},abort:function(){var a=this.xhr;this.xhr=null,a&&a.abort()},status:function(a){return 1===this.readState?"reading":this.pendingRetry||1===this.preprocessState?"uploading":this.xhr?this.xhr.readyState<4?"uploading":this.flowObj.opts.successStatuses.indexOf(this.xhr.status)>-1?"success":this.flowObj.opts.permanentErrors.indexOf(this.xhr.status)>-1||!a&&this.retries>=this.flowObj.opts.maxChunkRetries?"error":(this.abort(),"pending"):"pending"},message:function(){return this.xhr?this.xhr.responseText:""},progress:function(){if(this.pendingRetry)return 0;var a=this.status();return"success"===a||"error"===a?1:"pending"===a?0:this.total>0?this.loaded/this.total:0},sizeUploaded:function(){var a=this.endByte-this.startByte;return"success"!==this.status()&&(a=this.progress()*a),a},prepareXhrRequest:function(a,b,c,d){var e=i(this.flowObj.opts.query,this.fileObj,this,b);e=k(e,this.getParams());var f=i(this.flowObj.opts.target,this.fileObj,this,b),g=null;if("GET"===a||"octet"===c){var h=[];l(e,function(a,b){h.push([encodeURIComponent(b),encodeURIComponent(a)].join("="))}),f=this.getTarget(f,h),g=d||null}else g=new FormData,l(e,function(a,b){g.append(b,a)}),"undefined"!=typeof d&&g.append(this.flowObj.opts.fileParameterName,d,this.fileObj.file.name);return this.xhr.open(a,f,!0),this.xhr.withCredentials=this.flowObj.opts.withCredentials,l(i(this.flowObj.opts.headers,this.fileObj,this,b),function(a,b){this.xhr.setRequestHeader(b,a)},this),g}},d.evalOpts=i,d.extend=k,d.each=l,d.FlowFile=e,d.FlowChunk=g,d.version="2.13.0","object"==typeof module&&module&&"object"==typeof module.exports?module.exports=d:(a.Flow=d,"function"=="function"&&__webpack_require__(1728)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return d}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)))}(window,document),angular.module("flow.provider",[]).provider("flowFactory",function(){"use strict";this.defaults={},this.factory=function(a){return new Flow(a)},this.events=[],this.on=function(a,b){this.events.push([a,b])},this.$get=function(){var a=this.factory,b=this.defaults,c=this.events;return{create:function(d){var e=a(angular.extend({},b,d));return angular.forEach(c,function(a){e.on(a[0],a[1])}),e}}}}),angular.module("flow.init",["flow.provider"]).controller("flowCtrl",["$scope","$attrs","$parse","flowFactory",function(a,b,c,d){var e=angular.extend({},a.$eval(b.flowInit)),f=a.$eval(b.flowObject)||d.create(e),g=function(b){var c=Array.prototype.slice.call(arguments);c.shift();var d=a.$broadcast.apply(a,["flow::"+b,f].concat(c));return{progress:1,filesSubmitted:1,fileSuccess:1,fileError:1,complete:1}[b]&&a.$applyAsync(),d.defaultPrevented?!1:void 0};f.on("catchAll",g),a.$on("$destroy",function(){f.off("catchAll",g)}),a.$flow=f,b.hasOwnProperty("flowName")&&(c(b.flowName).assign(a,f),a.$on("$destroy",function(){c(b.flowName).assign(a)}))}]).directive("flowInit",[function(){return{scope:!0,controller:"flowCtrl"}}]),angular.module("flow.btn",["flow.init"]).directive("flowBtn",[function(){return{restrict:"EA",scope:!1,require:"^flowInit",link:function(a,b,c){var d=c.hasOwnProperty("flowDirectory"),e=c.hasOwnProperty("flowSingleFile"),f=c.hasOwnProperty("flowAttrs")&&a.$eval(c.flowAttrs);a.$flow.assignBrowse(b,d,e,f)}}}]),angular.module("flow.dragEvents",["flow.init"]).directive("flowPreventDrop",function(){return{scope:!1,link:function(a,b,c){b.bind("drop dragover",function(a){a.preventDefault()})}}}).directive("flowDragEnter",["$timeout",function(a){return{scope:!1,link:function(b,c,d){function e(a){var b=!1,c=a.dataTransfer||a.originalEvent.dataTransfer;return angular.forEach(c&&c.types,function(a){"Files"===a&&(b=!0)}),b}var f,g=!1;c.bind("dragover",function(c){e(c)&&(g||(b.$apply(d.flowDragEnter),g=!0),a.cancel(f),c.preventDefault())}),c.bind("dragleave drop",function(c){a.cancel(f),f=a(function(){b.$eval(d.flowDragLeave),f=null,g=!1},100)})}}}]),angular.module("flow.drop",["flow.init"]).directive("flowDrop",function(){return{scope:!1,require:"^flowInit",link:function(a,b,c){function d(){a.$flow.assignDrop(b)}function e(){a.$flow.unAssignDrop(b)}c.flowDropEnabled?a.$watch(c.flowDropEnabled,function(a){a?d():e()}):d()}}}),!function(a){"use strict";function b(a){return a.charAt(0).toUpperCase()+a.slice(1)}var c=a.module("flow.events",["flow.init"]),d={fileSuccess:["$file","$message"],fileProgress:["$file"],fileAdded:["$file","$event"],filesAdded:["$files","$event"],filesSubmitted:["$files","$event"],fileRetry:["$file"],fileRemoved:["$file"],fileError:["$file","$message"],uploadStart:[],complete:[],progress:[],error:["$message","$file"]};a.forEach(d,function(d,e){var f="flow"+b(e);"flowUploadStart"==f&&(f="flowUploadStarted"),c.directive(f,[function(){return{require:"^flowInit",controller:["$scope","$attrs",function(b,c){b.$on("flow::"+e,function(){var e=Array.prototype.slice.call(arguments),g=e.shift();if(b.$flow===e.shift()){var h={};a.forEach(d,function(a,b){h[a]=e[b]}),b.$eval(c[f],h)===!1&&g.preventDefault()}})}]}}])})}(angular),angular.module("flow.img",["flow.init"]).directive("flowImg",[function(){return{scope:!1,require:"^flowInit",link:function(a,b,c){var d=c.flowImg;a.$watch(d,function(b){if(b){var d=new FileReader;d.readAsDataURL(b.file),d.onload=function(b){a.$apply(function(){c.$set("src",b.target.result)})}}})}}}]),angular.module("flow.transfers",["flow.init"]).directive("flowTransfers",[function(){return{scope:!0,require:"^flowInit",link:function(a){a.transfers=a.$flow.files}}}]),angular.module("flow",["flow.provider","flow.init","flow.events","flow.btn","flow.drop","flow.transfers","flow.img","flow.dragEvents"]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module)))

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(590);
	module.exports = 'ngAria';


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(609);
	module.exports = 'ngSanitize';


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(612);
	module.exports = 'angular-storage';
	


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Binds a ACE Editor widget
	 */
	angular.module('ui.ace', [])
	  .constant('uiAceConfig', {})
	  .directive('uiAce', ['uiAceConfig', function (uiAceConfig) {
	
	    if (angular.isUndefined(window.ace)) {
	      throw new Error('ui-ace need ace to work... (o rly?)');
	    }
	
	    /**
	     * Sets editor options such as the wrapping mode or the syntax checker.
	     *
	     * The supported options are:
	     *
	     *   <ul>
	     *     <li>showGutter</li>
	     *     <li>useWrapMode</li>
	     *     <li>onLoad</li>
	     *     <li>theme</li>
	     *     <li>mode</li>
	     *   </ul>
	     *
	     * @param acee
	     * @param session ACE editor session
	     * @param {object} opts Options to be set
	     */
	    var setOptions = function(acee, session, opts) {
	
	      // sets the ace worker path, if running from concatenated
	      // or minified source
	      if (angular.isDefined(opts.workerPath)) {
	        var config = window.ace.require('ace/config');
	        config.set('workerPath', opts.workerPath);
	      }
	      // ace requires loading
	      if (angular.isDefined(opts.require)) {
	        opts.require.forEach(function (n) {
	            window.ace.require(n);
	        });
	      }
	      // Boolean options
	      if (angular.isDefined(opts.showGutter)) {
	        acee.renderer.setShowGutter(opts.showGutter);
	      }
	      if (angular.isDefined(opts.useWrapMode)) {
	        session.setUseWrapMode(opts.useWrapMode);
	      }
	      if (angular.isDefined(opts.showInvisibles)) {
	        acee.renderer.setShowInvisibles(opts.showInvisibles);
	      }
	      if (angular.isDefined(opts.showIndentGuides)) {
	        acee.renderer.setDisplayIndentGuides(opts.showIndentGuides);
	      }
	      if (angular.isDefined(opts.useSoftTabs)) {
	        session.setUseSoftTabs(opts.useSoftTabs);
	      }
	      if (angular.isDefined(opts.showPrintMargin)) {
	        acee.setShowPrintMargin(opts.showPrintMargin);
	      }
	
	      // commands
	      if (angular.isDefined(opts.disableSearch) && opts.disableSearch) {
	        acee.commands.addCommands([
	          {
	            name: 'unfind',
	            bindKey: {
	              win: 'Ctrl-F',
	              mac: 'Command-F'
	            },
	            exec: function () {
	              return false;
	            },
	            readOnly: true
	          }
	        ]);
	      }
	
	      // Basic options
	      if (angular.isString(opts.theme)) {
	        acee.setTheme('ace/theme/' + opts.theme);
	      }
	      if (angular.isString(opts.mode)) {
	        session.setMode('ace/mode/' + opts.mode);
	      }
	      // Advanced options
	      if (angular.isDefined(opts.firstLineNumber)) {
	        if (angular.isNumber(opts.firstLineNumber)) {
	          session.setOption('firstLineNumber', opts.firstLineNumber);
	        } else if (angular.isFunction(opts.firstLineNumber)) {
	          session.setOption('firstLineNumber', opts.firstLineNumber());
	        }
	      }
	
	      // advanced options
	      var key, obj;
	      if (angular.isDefined(opts.advanced)) {
	          for (key in opts.advanced) {
	              // create a javascript object with the key and value
	              obj = { name: key, value: opts.advanced[key] };
	              // try to assign the option to the ace editor
	              acee.setOption(obj.name, obj.value);
	          }
	      }
	
	      // advanced options for the renderer
	      if (angular.isDefined(opts.rendererOptions)) {
	          for (key in opts.rendererOptions) {
	              // create a javascript object with the key and value
	              obj = { name: key, value: opts.rendererOptions[key] };
	              // try to assign the option to the ace editor
	              acee.renderer.setOption(obj.name, obj.value);
	          }
	      }
	
	      // onLoad callbacks
	      angular.forEach(opts.callbacks, function (cb) {
	        if (angular.isFunction(cb)) {
	          cb(acee);
	        }
	      });
	    };
	
	    return {
	      restrict: 'EA',
	      require: '?ngModel',
	      link: function (scope, elm, attrs, ngModel) {
	
	        /**
	         * Corresponds the uiAceConfig ACE configuration.
	         * @type object
	         */
	        var options = uiAceConfig.ace || {};
	
	        /**
	         * uiAceConfig merged with user options via json in attribute or data binding
	         * @type object
	         */
	        var opts = angular.extend({}, options, scope.$eval(attrs.uiAce));
	
	        /**
	         * ACE editor
	         * @type object
	         */
	        var acee = window.ace.edit(elm[0]);
	
	        /**
	         * ACE editor session.
	         * @type object
	         * @see [EditSession]{@link http://ace.c9.io/#nav=api&api=edit_session}
	         */
	        var session = acee.getSession();
	
	        /**
	         * Reference to a change listener created by the listener factory.
	         * @function
	         * @see listenerFactory.onChange
	         */
	        var onChangeListener;
	
	        /**
	         * Reference to a blur listener created by the listener factory.
	         * @function
	         * @see listenerFactory.onBlur
	         */
	        var onBlurListener;
	
	        /**
	         * Calls a callback by checking its existing. The argument list
	         * is variable and thus this function is relying on the arguments
	         * object.
	         * @throws {Error} If the callback isn't a function
	         */
	        var executeUserCallback = function () {
	
	          /**
	           * The callback function grabbed from the array-like arguments
	           * object. The first argument should always be the callback.
	           *
	           * @see [arguments]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions_and_function_scope/arguments}
	           * @type {*}
	           */
	          var callback = arguments[0];
	
	          /**
	           * Arguments to be passed to the callback. These are taken
	           * from the array-like arguments object. The first argument
	           * is stripped because that should be the callback function.
	           *
	           * @see [arguments]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions_and_function_scope/arguments}
	           * @type {Array}
	           */
	          var args = Array.prototype.slice.call(arguments, 1);
	
	          if (angular.isDefined(callback)) {
	            scope.$evalAsync(function () {
	              if (angular.isFunction(callback)) {
	                callback(args);
	              } else {
	                throw new Error('ui-ace use a function as callback.');
	              }
	            });
	          }
	        };
	
	        /**
	         * Listener factory. Until now only change listeners can be created.
	         * @type object
	         */
	        var listenerFactory = {
	          /**
	           * Creates a change listener which propagates the change event
	           * and the editor session to the callback from the user option
	           * onChange. It might be exchanged during runtime, if this
	           * happens the old listener will be unbound.
	           *
	           * @param callback callback function defined in the user options
	           * @see onChangeListener
	           */
	          onChange: function (callback) {
	            return function (e) {
	              var newValue = session.getValue();
	
	              if (ngModel && newValue !== ngModel.$viewValue &&
	                  // HACK make sure to only trigger the apply outside of the
	                  // digest loop 'cause ACE is actually using this callback
	                  // for any text transformation !
	                  !scope.$$phase && !scope.$root.$$phase) {
	                scope.$evalAsync(function () {
	                  ngModel.$setViewValue(newValue);
	                });
	              }
	
	              executeUserCallback(callback, e, acee);
	            };
	          },
	          /**
	           * Creates a blur listener which propagates the editor session
	           * to the callback from the user option onBlur. It might be
	           * exchanged during runtime, if this happens the old listener
	           * will be unbound.
	           *
	           * @param callback callback function defined in the user options
	           * @see onBlurListener
	           */
	          onBlur: function (callback) {
	            return function () {
	              executeUserCallback(callback, acee);
	            };
	          }
	        };
	
	        attrs.$observe('readonly', function (value) {
	          acee.setReadOnly(!!value || value === '');
	        });
	
	        // Value Blind
	        if (ngModel) {
	          ngModel.$formatters.push(function (value) {
	            if (angular.isUndefined(value) || value === null) {
	              return '';
	            }
	            else if (angular.isObject(value) || angular.isArray(value)) {
	              throw new Error('ui-ace cannot use an object or an array as a model');
	            }
	            return value;
	          });
	
	          ngModel.$render = function () {
	            session.setValue(ngModel.$viewValue);
	          };
	        }
	
	        // Listen for option updates
	        var updateOptions = function (current, previous) {
	          if (current === previous) return;
	          opts = angular.extend({}, options, scope.$eval(attrs.uiAce));
	
	          opts.callbacks = [ opts.onLoad ];
	          if (opts.onLoad !== options.onLoad) {
	            // also call the global onLoad handler
	            opts.callbacks.unshift(options.onLoad);
	          }
	
	          // EVENTS
	
	          // unbind old change listener
	          session.removeListener('change', onChangeListener);
	
	          // bind new change listener
	          onChangeListener = listenerFactory.onChange(opts.onChange);
	          session.on('change', onChangeListener);
	
	          // unbind old blur listener
	          //session.removeListener('blur', onBlurListener);
	          acee.removeListener('blur', onBlurListener);
	
	          // bind new blur listener
	          onBlurListener = listenerFactory.onBlur(opts.onBlur);
	          acee.on('blur', onBlurListener);
	
	          setOptions(acee, session, opts);
	        };
	
	        scope.$watch(attrs.uiAce, updateOptions, /* deep watch */ true);
	
	        // set the options here, even if we try to watch later, if this
	        // line is missing things go wrong (and the tests will also fail)
	        updateOptions(options);
	
	        elm.on('$destroy', function () {
	          acee.session.$stopWorker();
	          acee.destroy();
	        });
	
	        scope.$watch(function() {
	          return [elm[0].offsetWidth, elm[0].offsetHeight];
	        }, function() {
	          acee.resize();
	          acee.renderer.updateFull();
	        }, true);
	
	      }
	    };
	  }]);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(48), __webpack_require__(1729)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(module, exports, require('angular'), require('ws'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod, mod.exports, global.angular, global.ws);
	    global.angularWebsocket = mod.exports;
	  }
	})(this, function (module, exports, _angular, ws) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _angular2 = _interopRequireDefault(_angular);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	  };
	
	  var Socket;
	
	  if (typeof window === 'undefined') {
	    try {
	
	      Socket = ws.Client || ws.client || ws;
	    } catch (e) {}
	  }
	
	  // Browser
	  Socket = Socket || window.WebSocket || window.MozWebSocket;
	
	  var noop = _angular2.default.noop;
	  var objectFreeze = Object.freeze ? Object.freeze : noop;
	  var objectDefineProperty = Object.defineProperty;
	  var isString = _angular2.default.isString;
	  var isFunction = _angular2.default.isFunction;
	  var isDefined = _angular2.default.isDefined;
	  var isObject = _angular2.default.isObject;
	  var isArray = _angular2.default.isArray;
	  var forEach = _angular2.default.forEach;
	  var arraySlice = Array.prototype.slice;
	  // ie8 wat
	  if (!Array.prototype.indexOf) {
	    Array.prototype.indexOf = function (elt /*, from*/) {
	      var len = this.length >>> 0;
	      var from = Number(arguments[1]) || 0;
	      from = from < 0 ? Math.ceil(from) : Math.floor(from);
	      if (from < 0) {
	        from += len;
	      }
	
	      for (; from < len; from++) {
	        if (from in this && this[from] === elt) {
	          return from;
	        }
	      }
	      return -1;
	    };
	  }
	
	  // $WebSocketProvider.$inject = ['$rootScope', '$q', '$timeout', '$websocketBackend'];
	  function $WebSocketProvider($rootScope, $q, $timeout, $websocketBackend) {
	
	    function $WebSocket(url, protocols, options) {
	      if (!options && isObject(protocols) && !isArray(protocols)) {
	        options = protocols;
	        protocols = undefined;
	      }
	
	      this.protocols = protocols;
	      this.url = url || 'Missing URL';
	      this.ssl = /(wss)/i.test(this.url);
	
	      // this.binaryType = '';
	      // this.extensions = '';
	      // this.bufferedAmount = 0;
	      // this.trasnmitting = false;
	      // this.buffer = [];
	
	      // TODO: refactor options to use isDefined
	      this.scope = options && options.scope || $rootScope;
	      this.rootScopeFailover = options && options.rootScopeFailover && true;
	      this.useApplyAsync = options && options.useApplyAsync || false;
	      this.initialTimeout = options && options.initialTimeout || 500; // 500ms
	      this.maxTimeout = options && options.maxTimeout || 5 * 60 * 1000; // 5 minutes
	      this.reconnectIfNotNormalClose = options && options.reconnectIfNotNormalClose || false;
	      this.binaryType = options && options.binaryType || 'blob';
	
	      this._reconnectAttempts = 0;
	      this.sendQueue = [];
	      this.onOpenCallbacks = [];
	      this.onMessageCallbacks = [];
	      this.onErrorCallbacks = [];
	      this.onCloseCallbacks = [];
	
	      objectFreeze(this._readyStateConstants);
	
	      if (url) {
	        this._connect();
	      } else {
	        this._setInternalState(0);
	      }
	    }
	
	    $WebSocket.prototype._readyStateConstants = {
	      'CONNECTING': 0,
	      'OPEN': 1,
	      'CLOSING': 2,
	      'CLOSED': 3,
	      'RECONNECT_ABORTED': 4
	    };
	
	    $WebSocket.prototype._normalCloseCode = 1000;
	
	    $WebSocket.prototype._reconnectableStatusCodes = [4000];
	
	    $WebSocket.prototype.safeDigest = function safeDigest(autoApply) {
	      if (autoApply && !this.scope.$$phase) {
	        this.scope.$digest();
	      }
	    };
	
	    $WebSocket.prototype.bindToScope = function bindToScope(scope) {
	      var self = this;
	      if (scope) {
	        this.scope = scope;
	        if (this.rootScopeFailover) {
	          this.scope.$on('$destroy', function () {
	            self.scope = $rootScope;
	          });
	        }
	      }
	      return self;
	    };
	
	    $WebSocket.prototype._connect = function _connect(force) {
	      if (force || !this.socket || this.socket.readyState !== this._readyStateConstants.OPEN) {
	        this.socket = $websocketBackend.create(this.url, this.protocols);
	        this.socket.onmessage = _angular2.default.bind(this, this._onMessageHandler);
	        this.socket.onopen = _angular2.default.bind(this, this._onOpenHandler);
	        this.socket.onerror = _angular2.default.bind(this, this._onErrorHandler);
	        this.socket.onclose = _angular2.default.bind(this, this._onCloseHandler);
	        this.socket.binaryType = this.binaryType;
	      }
	    };
	
	    $WebSocket.prototype.fireQueue = function fireQueue() {
	      while (this.sendQueue.length && this.socket.readyState === this._readyStateConstants.OPEN) {
	        var data = this.sendQueue.shift();
	
	        this.socket.send(isString(data.message) || this.binaryType != 'blob' ? data.message : JSON.stringify(data.message));
	        data.deferred.resolve();
	      }
	    };
	
	    $WebSocket.prototype.notifyOpenCallbacks = function notifyOpenCallbacks(event) {
	      for (var i = 0; i < this.onOpenCallbacks.length; i++) {
	        this.onOpenCallbacks[i].call(this, event);
	      }
	    };
	
	    $WebSocket.prototype.notifyCloseCallbacks = function notifyCloseCallbacks(event) {
	      for (var i = 0; i < this.onCloseCallbacks.length; i++) {
	        this.onCloseCallbacks[i].call(this, event);
	      }
	    };
	
	    $WebSocket.prototype.notifyErrorCallbacks = function notifyErrorCallbacks(event) {
	      for (var i = 0; i < this.onErrorCallbacks.length; i++) {
	        this.onErrorCallbacks[i].call(this, event);
	      }
	    };
	
	    $WebSocket.prototype.onOpen = function onOpen(cb) {
	      this.onOpenCallbacks.push(cb);
	      return this;
	    };
	
	    $WebSocket.prototype.onClose = function onClose(cb) {
	      this.onCloseCallbacks.push(cb);
	      return this;
	    };
	
	    $WebSocket.prototype.onError = function onError(cb) {
	      this.onErrorCallbacks.push(cb);
	      return this;
	    };
	
	    $WebSocket.prototype.onMessage = function onMessage(callback, options) {
	      if (!isFunction(callback)) {
	        throw new Error('Callback must be a function');
	      }
	
	      if (options && isDefined(options.filter) && !isString(options.filter) && !(options.filter instanceof RegExp)) {
	        throw new Error('Pattern must be a string or regular expression');
	      }
	
	      this.onMessageCallbacks.push({
	        fn: callback,
	        pattern: options ? options.filter : undefined,
	        autoApply: options ? options.autoApply : true
	      });
	      return this;
	    };
	
	    $WebSocket.prototype._onOpenHandler = function _onOpenHandler(event) {
	      this._reconnectAttempts = 0;
	      this.notifyOpenCallbacks(event);
	      this.fireQueue();
	    };
	
	    $WebSocket.prototype._onCloseHandler = function _onCloseHandler(event) {
	      var self = this;
	      if (self.useApplyAsync) {
	        self.scope.$applyAsync(function () {
	          self.notifyCloseCallbacks(event);
	        });
	      } else {
	        self.notifyCloseCallbacks(event);
	        self.safeDigest(true);
	      }
	      if (this.reconnectIfNotNormalClose && event.code !== this._normalCloseCode || this._reconnectableStatusCodes.indexOf(event.code) > -1) {
	        this.reconnect();
	      }
	    };
	
	    $WebSocket.prototype._onErrorHandler = function _onErrorHandler(event) {
	      var self = this;
	      if (self.useApplyAsync) {
	        self.scope.$applyAsync(function () {
	          self.notifyErrorCallbacks(event);
	        });
	      } else {
	        self.notifyErrorCallbacks(event);
	        self.safeDigest(true);
	      }
	    };
	
	    $WebSocket.prototype._onMessageHandler = function _onMessageHandler(message) {
	      var pattern;
	      var self = this;
	      var currentCallback;
	      for (var i = 0; i < self.onMessageCallbacks.length; i++) {
	        currentCallback = self.onMessageCallbacks[i];
	        pattern = currentCallback.pattern;
	        if (pattern) {
	          if (isString(pattern) && message.data === pattern) {
	            applyAsyncOrDigest(currentCallback.fn, currentCallback.autoApply, message);
	          } else if (pattern instanceof RegExp && pattern.exec(message.data)) {
	            applyAsyncOrDigest(currentCallback.fn, currentCallback.autoApply, message);
	          }
	        } else {
	          applyAsyncOrDigest(currentCallback.fn, currentCallback.autoApply, message);
	        }
	      }
	
	      function applyAsyncOrDigest(callback, autoApply, args) {
	        args = arraySlice.call(arguments, 2);
	        if (self.useApplyAsync) {
	          self.scope.$applyAsync(function () {
	            callback.apply(self, args);
	          });
	        } else {
	          callback.apply(self, args);
	          self.safeDigest(autoApply);
	        }
	      }
	    };
	
	    $WebSocket.prototype.close = function close(force) {
	      if (force || !this.socket.bufferedAmount) {
	        this.socket.close();
	      }
	      return this;
	    };
	
	    $WebSocket.prototype.send = function send(data) {
	      var deferred = $q.defer();
	      var self = this;
	      var promise = cancelableify(deferred.promise);
	
	      if (self.readyState === self._readyStateConstants.RECONNECT_ABORTED) {
	        deferred.reject('Socket connection has been closed');
	      } else {
	        self.sendQueue.push({
	          message: data,
	          deferred: deferred
	        });
	        self.fireQueue();
	      }
	
	      // Credit goes to @btford
	      function cancelableify(promise) {
	        promise.cancel = cancel;
	        var then = promise.then;
	        promise.then = function () {
	          var newPromise = then.apply(this, arguments);
	          return cancelableify(newPromise);
	        };
	        return promise;
	      }
	
	      function cancel(reason) {
	        self.sendQueue.splice(self.sendQueue.indexOf(data), 1);
	        deferred.reject(reason);
	        return self;
	      }
	
	      if ($websocketBackend.isMocked && $websocketBackend.isMocked() && $websocketBackend.isConnected(this.url)) {
	        this._onMessageHandler($websocketBackend.mockSend());
	      }
	
	      return promise;
	    };
	
	    $WebSocket.prototype.reconnect = function reconnect() {
	      this.close();
	
	      var backoffDelay = this._getBackoffDelay(++this._reconnectAttempts);
	
	      var backoffDelaySeconds = backoffDelay / 1000;
	      console.log('Reconnecting in ' + backoffDelaySeconds + ' seconds');
	
	      $timeout(_angular2.default.bind(this, this._connect), backoffDelay);
	
	      return this;
	    };
	    // Exponential Backoff Formula by Prof. Douglas Thain
	    // http://dthain.blogspot.co.uk/2009/02/exponential-backoff-in-distributed.html
	    $WebSocket.prototype._getBackoffDelay = function _getBackoffDelay(attempt) {
	      var R = Math.random() + 1;
	      var T = this.initialTimeout;
	      var F = 2;
	      var N = attempt;
	      var M = this.maxTimeout;
	
	      return Math.floor(Math.min(R * T * Math.pow(F, N), M));
	    };
	
	    $WebSocket.prototype._setInternalState = function _setInternalState(state) {
	      if (Math.floor(state) !== state || state < 0 || state > 4) {
	        throw new Error('state must be an integer between 0 and 4, got: ' + state);
	      }
	
	      // ie8 wat
	      if (!objectDefineProperty) {
	        this.readyState = state || this.socket.readyState;
	      }
	      this._internalConnectionState = state;
	
	      forEach(this.sendQueue, function (pending) {
	        pending.deferred.reject('Message cancelled due to closed socket connection');
	      });
	    };
	
	    // Read only .readyState
	    if (objectDefineProperty) {
	      objectDefineProperty($WebSocket.prototype, 'readyState', {
	        get: function get() {
	          return this._internalConnectionState || this.socket.readyState;
	        },
	        set: function set() {
	          throw new Error('The readyState property is read-only');
	        }
	      });
	    }
	
	    return function (url, protocols, options) {
	      return new $WebSocket(url, protocols, options);
	    };
	  }
	
	  // $WebSocketBackendProvider.$inject = ['$log'];
	  function $WebSocketBackendProvider($log) {
	    this.create = function create(url, protocols) {
	      var match = /wss?:\/\//.exec(url);
	
	      if (!match) {
	        throw new Error('Invalid url provided');
	      }
	
	      if (protocols) {
	        return new Socket(url, protocols);
	      }
	
	      return new Socket(url);
	    };
	
	    this.createWebSocketBackend = function createWebSocketBackend(url, protocols) {
	      $log.warn('Deprecated: Please use .create(url, protocols)');
	      return this.create(url, protocols);
	    };
	  }
	
	  _angular2.default.module('ngWebSocket', []).factory('$websocket', ['$rootScope', '$q', '$timeout', '$websocketBackend', $WebSocketProvider]).factory('WebSocket', ['$rootScope', '$q', '$timeout', 'WebsocketBackend', $WebSocketProvider]).service('$websocketBackend', ['$log', $WebSocketBackendProvider]).service('WebSocketBackend', ['$log', $WebSocketBackendProvider]);
	
	  _angular2.default.module('angular-websocket', ['ngWebSocket']);
	
	  exports.default = _angular2.default.module('ngWebSocket');
	  module.exports = exports['default'];
	});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(624);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(665), __esModule: true };

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(666), __esModule: true };

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(668), __esModule: true };

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(270);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	ace.define("ace/mode/css_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var lang = acequire("../lib/lang");
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	var supportType = exports.supportType = "align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-repeat|background-size|border|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-shadow|box-sizing|caption-side|clear|clip|color|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|font|font-family|font-size|font-size-adjust|font-stretch|font-style|font-variant|font-weight|hanging-punctuation|height|justify-content|left|letter-spacing|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|min-height|min-width|nav-down|nav-index|nav-left|nav-right|nav-up|opacity|order|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-x|overflow-y|padding|padding-bottom|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|perspective|perspective-origin|position|quotes|resize|right|tab-size|table-layout|text-align|text-align-last|text-decoration|text-decoration-color|text-decoration-line|text-decoration-style|text-indent|text-justify|text-overflow|text-shadow|text-transform|top|transform|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|unicode-bidi|vertical-align|visibility|white-space|width|word-break|word-spacing|word-wrap|z-index";
	var supportFunction = exports.supportFunction = "rgb|rgba|url|attr|counter|counters";
	var supportConstant = exports.supportConstant = "absolute|after-edge|after|all-scroll|all|alphabetic|always|antialiased|armenian|auto|avoid-column|avoid-page|avoid|balance|baseline|before-edge|before|below|bidi-override|block-line-height|block|bold|bolder|border-box|both|bottom|box|break-all|break-word|capitalize|caps-height|caption|center|central|char|circle|cjk-ideographic|clone|close-quote|col-resize|collapse|column|consider-shifts|contain|content-box|cover|crosshair|cubic-bezier|dashed|decimal-leading-zero|decimal|default|disabled|disc|disregard-shifts|distribute-all-lines|distribute-letter|distribute-space|distribute|dotted|double|e-resize|ease-in|ease-in-out|ease-out|ease|ellipsis|end|exclude-ruby|fill|fixed|georgian|glyphs|grid-height|groove|hand|hanging|hebrew|help|hidden|hiragana-iroha|hiragana|horizontal|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|include-ruby|inherit|initial|inline-block|inline-box|inline-line-height|inline-table|inline|inset|inside|inter-ideograph|inter-word|invert|italic|justify|katakana-iroha|katakana|keep-all|last|left|lighter|line-edge|line-through|line|linear|list-item|local|loose|lower-alpha|lower-greek|lower-latin|lower-roman|lowercase|lr-tb|ltr|mathematical|max-height|max-size|medium|menu|message-box|middle|move|n-resize|ne-resize|newspaper|no-change|no-close-quote|no-drop|no-open-quote|no-repeat|none|normal|not-allowed|nowrap|nw-resize|oblique|open-quote|outset|outside|overline|padding-box|page|pointer|pre-line|pre-wrap|pre|preserve-3d|progress|relative|repeat-x|repeat-y|repeat|replaced|reset-size|ridge|right|round|row-resize|rtl|s-resize|scroll|se-resize|separate|slice|small-caps|small-caption|solid|space|square|start|static|status-bar|step-end|step-start|steps|stretch|strict|sub|super|sw-resize|table-caption|table-cell|table-column-group|table-column|table-footer-group|table-header-group|table-row-group|table-row|table|tb-rl|text-after-edge|text-before-edge|text-bottom|text-size|text-top|text|thick|thin|transparent|underline|upper-alpha|upper-latin|upper-roman|uppercase|use-script|vertical-ideographic|vertical-text|visible|w-resize|wait|whitespace|z-index|zero";
	var supportConstantColor = exports.supportConstantColor = "aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow";
	var supportConstantFonts = exports.supportConstantFonts = "arial|century|comic|courier|cursive|fantasy|garamond|georgia|helvetica|impact|lucida|symbol|system|tahoma|times|trebuchet|utopia|verdana|webdings|sans-serif|serif|monospace";
	
	var numRe = exports.numRe = "\\-?(?:(?:[0-9]+)|(?:[0-9]*\\.[0-9]+))";
	var pseudoElements = exports.pseudoElements = "(\\:+)\\b(after|before|first-letter|first-line|moz-selection|selection)\\b";
	var pseudoClasses  = exports.pseudoClasses =  "(:)\\b(active|checked|disabled|empty|enabled|first-child|first-of-type|focus|hover|indeterminate|invalid|last-child|last-of-type|link|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|only-child|only-of-type|acequired|root|target|valid|visited)\\b";
	
	var CssHighlightRules = function() {
	
	    var keywordMapper = this.createKeywordMapper({
	        "support.function": supportFunction,
	        "support.constant": supportConstant,
	        "support.type": supportType,
	        "support.constant.color": supportConstantColor,
	        "support.constant.fonts": supportConstantFonts
	    }, "text", true);
	
	    this.$rules = {
	        "start" : [{
	            token : "comment", // multi line comment
	            regex : "\\/\\*",
	            push : "comment"
	        }, {
	            token: "paren.lparen",
	            regex: "\\{",
	            push:  "ruleset"
	        }, {
	            token: "string",
	            regex: "@.*?{",
	            push:  "media"
	        }, {
	            token: "keyword",
	            regex: "#[a-z0-9-_]+"
	        }, {
	            token: "variable",
	            regex: "\\.[a-z0-9-_]+"
	        }, {
	            token: "string",
	            regex: ":[a-z0-9-_]+"
	        }, {
	            token: "constant",
	            regex: "[a-z0-9-_]+"
	        }, {
	            caseInsensitive: true
	        }],
	
	        "media" : [{
	            token : "comment", // multi line comment
	            regex : "\\/\\*",
	            push : "comment"
	        }, {
	            token: "paren.lparen",
	            regex: "\\{",
	            push:  "ruleset"
	        }, {
	            token: "string",
	            regex: "\\}",
	            next:  "pop"
	        }, {
	            token: "keyword",
	            regex: "#[a-z0-9-_]+"
	        }, {
	            token: "variable",
	            regex: "\\.[a-z0-9-_]+"
	        }, {
	            token: "string",
	            regex: ":[a-z0-9-_]+"
	        }, {
	            token: "constant",
	            regex: "[a-z0-9-_]+"
	        }, {
	            caseInsensitive: true
	        }],
	
	        "comment" : [{
	            token : "comment",
	            regex : "\\*\\/",
	            next : "pop"
	        }, {
	            defaultToken : "comment"
	        }],
	
	        "ruleset" : [
	        {
	            token : "paren.rparen",
	            regex : "\\}",
	            next:   "pop"
	        }, {
	            token : "comment", // multi line comment
	            regex : "\\/\\*",
	            push : "comment"
	        }, {
	            token : "string", // single line
	            regex : '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
	        }, {
	            token : "string", // single line
	            regex : "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
	        }, {
	            token : ["constant.numeric", "keyword"],
	            regex : "(" + numRe + ")(ch|cm|deg|em|ex|fr|gd|grad|Hz|in|kHz|mm|ms|pc|pt|px|rad|rem|s|turn|vh|vm|vw|%)"
	        }, {
	            token : "constant.numeric",
	            regex : numRe
	        }, {
	            token : "constant.numeric",  // hex6 color
	            regex : "#[a-f0-9]{6}"
	        }, {
	            token : "constant.numeric", // hex3 color
	            regex : "#[a-f0-9]{3}"
	        }, {
	            token : ["punctuation", "entity.other.attribute-name.pseudo-element.css"],
	            regex : pseudoElements
	        }, {
	            token : ["punctuation", "entity.other.attribute-name.pseudo-class.css"],
	            regex : pseudoClasses
	        }, {
	            token : ["support.function", "string", "support.function"],
	            regex : "(url\\()(.*)(\\))"
	        }, {
	            token : keywordMapper,
	            regex : "\\-?[a-zA-Z_][a-zA-Z0-9_\\-]*"
	        }, {
	            caseInsensitive: true
	        }]
	    };
	
	    this.normalizeRules();
	};
	
	oop.inherits(CssHighlightRules, TextHighlightRules);
	
	exports.CssHighlightRules = CssHighlightRules;
	
	});
	
	ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	
	var MatchingBraceOutdent = function() {};
	
	(function() {
	
	    this.checkOutdent = function(line, input) {
	        if (! /^\s+$/.test(line))
	            return false;
	
	        return /^\s*\}/.test(input);
	    };
	
	    this.autoOutdent = function(doc, row) {
	        var line = doc.getLine(row);
	        var match = line.match(/^(\s*\})/);
	
	        if (!match) return 0;
	
	        var column = match[1].length;
	        var openBracePos = doc.findMatchingBracket({row: row, column: column});
	
	        if (!openBracePos || openBracePos.row == row) return 0;
	
	        var indent = this.$getIndent(doc.getLine(openBracePos.row));
	        doc.replace(new Range(row, 0, row, column-1), indent);
	    };
	
	    this.$getIndent = function(line) {
	        return line.match(/^\s*/)[0];
	    };
	
	}).call(MatchingBraceOutdent.prototype);
	
	exports.MatchingBraceOutdent = MatchingBraceOutdent;
	});
	
	ace.define("ace/mode/css_completions",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	var propertyMap = {
	    "background": {"#$0": 1},
	    "background-color": {"#$0": 1, "transparent": 1, "fixed": 1},
	    "background-image": {"url('/$0')": 1},
	    "background-repeat": {"repeat": 1, "repeat-x": 1, "repeat-y": 1, "no-repeat": 1, "inherit": 1},
	    "background-position": {"bottom":2, "center":2, "left":2, "right":2, "top":2, "inherit":2},
	    "background-attachment": {"scroll": 1, "fixed": 1},
	    "background-size": {"cover": 1, "contain": 1},
	    "background-clip": {"border-box": 1, "padding-box": 1, "content-box": 1},
	    "background-origin": {"border-box": 1, "padding-box": 1, "content-box": 1},
	    "border": {"solid $0": 1, "dashed $0": 1, "dotted $0": 1, "#$0": 1},
	    "border-color": {"#$0": 1},
	    "border-style": {"solid":2, "dashed":2, "dotted":2, "double":2, "groove":2, "hidden":2, "inherit":2, "inset":2, "none":2, "outset":2, "ridged":2},
	    "border-collapse": {"collapse": 1, "separate": 1},
	    "bottom": {"px": 1, "em": 1, "%": 1},
	    "clear": {"left": 1, "right": 1, "both": 1, "none": 1},
	    "color": {"#$0": 1, "rgb(#$00,0,0)": 1},
	    "cursor": {"default": 1, "pointer": 1, "move": 1, "text": 1, "wait": 1, "help": 1, "progress": 1, "n-resize": 1, "ne-resize": 1, "e-resize": 1, "se-resize": 1, "s-resize": 1, "sw-resize": 1, "w-resize": 1, "nw-resize": 1},
	    "display": {"none": 1, "block": 1, "inline": 1, "inline-block": 1, "table-cell": 1},
	    "empty-cells": {"show": 1, "hide": 1},
	    "float": {"left": 1, "right": 1, "none": 1},
	    "font-family": {"Arial":2,"Comic Sans MS":2,"Consolas":2,"Courier New":2,"Courier":2,"Georgia":2,"Monospace":2,"Sans-Serif":2, "Segoe UI":2,"Tahoma":2,"Times New Roman":2,"Trebuchet MS":2,"Verdana": 1},
	    "font-size": {"px": 1, "em": 1, "%": 1},
	    "font-weight": {"bold": 1, "normal": 1},
	    "font-style": {"italic": 1, "normal": 1},
	    "font-variant": {"normal": 1, "small-caps": 1},
	    "height": {"px": 1, "em": 1, "%": 1},
	    "left": {"px": 1, "em": 1, "%": 1},
	    "letter-spacing": {"normal": 1},
	    "line-height": {"normal": 1},
	    "list-style-type": {"none": 1, "disc": 1, "circle": 1, "square": 1, "decimal": 1, "decimal-leading-zero": 1, "lower-roman": 1, "upper-roman": 1, "lower-greek": 1, "lower-latin": 1, "upper-latin": 1, "georgian": 1, "lower-alpha": 1, "upper-alpha": 1},
	    "margin": {"px": 1, "em": 1, "%": 1},
	    "margin-right": {"px": 1, "em": 1, "%": 1},
	    "margin-left": {"px": 1, "em": 1, "%": 1},
	    "margin-top": {"px": 1, "em": 1, "%": 1},
	    "margin-bottom": {"px": 1, "em": 1, "%": 1},
	    "max-height": {"px": 1, "em": 1, "%": 1},
	    "max-width": {"px": 1, "em": 1, "%": 1},
	    "min-height": {"px": 1, "em": 1, "%": 1},
	    "min-width": {"px": 1, "em": 1, "%": 1},
	    "overflow": {"hidden": 1, "visible": 1, "auto": 1, "scroll": 1},
	    "overflow-x": {"hidden": 1, "visible": 1, "auto": 1, "scroll": 1},
	    "overflow-y": {"hidden": 1, "visible": 1, "auto": 1, "scroll": 1},
	    "padding": {"px": 1, "em": 1, "%": 1},
	    "padding-top": {"px": 1, "em": 1, "%": 1},
	    "padding-right": {"px": 1, "em": 1, "%": 1},
	    "padding-bottom": {"px": 1, "em": 1, "%": 1},
	    "padding-left": {"px": 1, "em": 1, "%": 1},
	    "page-break-after": {"auto": 1, "always": 1, "avoid": 1, "left": 1, "right": 1},
	    "page-break-before": {"auto": 1, "always": 1, "avoid": 1, "left": 1, "right": 1},
	    "position": {"absolute": 1, "relative": 1, "fixed": 1, "static": 1},
	    "right": {"px": 1, "em": 1, "%": 1},
	    "table-layout": {"fixed": 1, "auto": 1},
	    "text-decoration": {"none": 1, "underline": 1, "line-through": 1, "blink": 1},
	    "text-align": {"left": 1, "right": 1, "center": 1, "justify": 1},
	    "text-transform": {"capitalize": 1, "uppercase": 1, "lowercase": 1, "none": 1},
	    "top": {"px": 1, "em": 1, "%": 1},
	    "vertical-align": {"top": 1, "bottom": 1},
	    "visibility": {"hidden": 1, "visible": 1},
	    "white-space": {"nowrap": 1, "normal": 1, "pre": 1, "pre-line": 1, "pre-wrap": 1},
	    "width": {"px": 1, "em": 1, "%": 1},
	    "word-spacing": {"normal": 1},
	    "filter": {"alpha(opacity=$0100)": 1},
	
	    "text-shadow": {"$02px 2px 2px #777": 1},
	    "text-overflow": {"ellipsis-word": 1, "clip": 1, "ellipsis": 1},
	    "-moz-border-radius": 1,
	    "-moz-border-radius-topright": 1,
	    "-moz-border-radius-bottomright": 1,
	    "-moz-border-radius-topleft": 1,
	    "-moz-border-radius-bottomleft": 1,
	    "-webkit-border-radius": 1,
	    "-webkit-border-top-right-radius": 1,
	    "-webkit-border-top-left-radius": 1,
	    "-webkit-border-bottom-right-radius": 1,
	    "-webkit-border-bottom-left-radius": 1,
	    "-moz-box-shadow": 1,
	    "-webkit-box-shadow": 1,
	    "transform": {"rotate($00deg)": 1, "skew($00deg)": 1},
	    "-moz-transform": {"rotate($00deg)": 1, "skew($00deg)": 1},
	    "-webkit-transform": {"rotate($00deg)": 1, "skew($00deg)": 1 }
	};
	
	var CssCompletions = function() {
	
	};
	
	(function() {
	
	    this.completionsDefined = false;
	
	    this.defineCompletions = function() {
	        if (document) {
	            var style = document.createElement('c').style;
	
	            for (var i in style) {
	                if (typeof style[i] !== 'string')
	                    continue;
	
	                var name = i.replace(/[A-Z]/g, function(x) {
	                    return '-' + x.toLowerCase();
	                });
	
	                if (!propertyMap.hasOwnProperty(name))
	                    propertyMap[name] = 1;
	            }
	        }
	
	        this.completionsDefined = true;
	    }
	
	    this.getCompletions = function(state, session, pos, prefix) {
	        if (!this.completionsDefined) {
	            this.defineCompletions();
	        }
	
	        var token = session.getTokenAt(pos.row, pos.column);
	
	        if (!token)
	            return [];
	        if (state==='ruleset'){
	            var line = session.getLine(pos.row).substr(0, pos.column);
	            if (/:[^;]+$/.test(line)) {
	                /([\w\-]+):[^:]*$/.test(line);
	
	                return this.getPropertyValueCompletions(state, session, pos, prefix);
	            } else {
	                return this.getPropertyCompletions(state, session, pos, prefix);
	            }
	        }
	
	        return [];
	    };
	
	    this.getPropertyCompletions = function(state, session, pos, prefix) {
	        var properties = Object.keys(propertyMap);
	        return properties.map(function(property){
	            return {
	                caption: property,
	                snippet: property + ': $0',
	                meta: "property",
	                score: Number.MAX_VALUE
	            };
	        });
	    };
	
	    this.getPropertyValueCompletions = function(state, session, pos, prefix) {
	        var line = session.getLine(pos.row).substr(0, pos.column);
	        var property = (/([\w\-]+):[^:]*$/.exec(line) || {})[1];
	
	        if (!property)
	            return [];
	        var values = [];
	        if (property in propertyMap && typeof propertyMap[property] === "object") {
	            values = Object.keys(propertyMap[property]);
	        }
	        return values.map(function(value){
	            return {
	                caption: value,
	                snippet: value,
	                meta: "property value",
	                score: Number.MAX_VALUE
	            };
	        });
	    };
	
	}).call(CssCompletions.prototype);
	
	exports.CssCompletions = CssCompletions;
	});
	
	ace.define("ace/mode/behaviour/css",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/mode/behaviour/cstyle","ace/token_iterator"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Behaviour = acequire("../behaviour").Behaviour;
	var CstyleBehaviour = acequire("./cstyle").CstyleBehaviour;
	var TokenIterator = acequire("../../token_iterator").TokenIterator;
	
	var CssBehaviour = function () {
	
	    this.inherit(CstyleBehaviour);
	
	    this.add("colon", "insertion", function (state, action, editor, session, text) {
	        if (text === ':') {
	            var cursor = editor.getCursorPosition();
	            var iterator = new TokenIterator(session, cursor.row, cursor.column);
	            var token = iterator.getCurrentToken();
	            if (token && token.value.match(/\s+/)) {
	                token = iterator.stepBackward();
	            }
	            if (token && token.type === 'support.type') {
	                var line = session.doc.getLine(cursor.row);
	                var rightChar = line.substring(cursor.column, cursor.column + 1);
	                if (rightChar === ':') {
	                    return {
	                       text: '',
	                       selection: [1, 1]
	                    }
	                }
	                if (!line.substring(cursor.column).match(/^\s*;/)) {
	                    return {
	                       text: ':;',
	                       selection: [1, 1]
	                    }
	                }
	            }
	        }
	    });
	
	    this.add("colon", "deletion", function (state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && selected === ':') {
	            var cursor = editor.getCursorPosition();
	            var iterator = new TokenIterator(session, cursor.row, cursor.column);
	            var token = iterator.getCurrentToken();
	            if (token && token.value.match(/\s+/)) {
	                token = iterator.stepBackward();
	            }
	            if (token && token.type === 'support.type') {
	                var line = session.doc.getLine(range.start.row);
	                var rightChar = line.substring(range.end.column, range.end.column + 1);
	                if (rightChar === ';') {
	                    range.end.column ++;
	                    return range;
	                }
	            }
	        }
	    });
	
	    this.add("semicolon", "insertion", function (state, action, editor, session, text) {
	        if (text === ';') {
	            var cursor = editor.getCursorPosition();
	            var line = session.doc.getLine(cursor.row);
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar === ';') {
	                return {
	                   text: '',
	                   selection: [1, 1]
	                }
	            }
	        }
	    });
	
	}
	oop.inherits(CssBehaviour, CstyleBehaviour);
	
	exports.CssBehaviour = CssBehaviour;
	});
	
	ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Range = acequire("../../range").Range;
	var BaseFoldMode = acequire("./fold_mode").FoldMode;
	
	var FoldMode = exports.FoldMode = function(commentRegex) {
	    if (commentRegex) {
	        this.foldingStartMarker = new RegExp(
	            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
	        );
	        this.foldingStopMarker = new RegExp(
	            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
	        );
	    }
	};
	oop.inherits(FoldMode, BaseFoldMode);
	
	(function() {
	    
	    this.foldingStartMarker = /(\{|\[)[^\}\]]*$|^\s*(\/\*)/;
	    this.foldingStopMarker = /^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/;
	    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
	    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
	    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
	    this._getFoldWidgetBase = this.getFoldWidget;
	    this.getFoldWidget = function(session, foldStyle, row) {
	        var line = session.getLine(row);
	    
	        if (this.singleLineBlockCommentRe.test(line)) {
	            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
	                return "";
	        }
	    
	        var fw = this._getFoldWidgetBase(session, foldStyle, row);
	    
	        if (!fw && this.startRegionRe.test(line))
	            return "start"; // lineCommentRegionStart
	    
	        return fw;
	    };
	
	    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
	        var line = session.getLine(row);
	        
	        if (this.startRegionRe.test(line))
	            return this.getCommentRegionBlock(session, line, row);
	        
	        var match = line.match(this.foldingStartMarker);
	        if (match) {
	            var i = match.index;
	
	            if (match[1])
	                return this.openingBracketBlock(session, match[1], row, i);
	                
	            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
	            
	            if (range && !range.isMultiLine()) {
	                if (forceMultiline) {
	                    range = this.getSectionRange(session, row);
	                } else if (foldStyle != "all")
	                    range = null;
	            }
	            
	            return range;
	        }
	
	        if (foldStyle === "markbegin")
	            return;
	
	        var match = line.match(this.foldingStopMarker);
	        if (match) {
	            var i = match.index + match[0].length;
	
	            if (match[1])
	                return this.closingBracketBlock(session, match[1], row, i);
	
	            return session.getCommentFoldRange(row, i, -1);
	        }
	    };
	    
	    this.getSectionRange = function(session, row) {
	        var line = session.getLine(row);
	        var startIndent = line.search(/\S/);
	        var startRow = row;
	        var startColumn = line.length;
	        row = row + 1;
	        var endRow = row;
	        var maxRow = session.getLength();
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var indent = line.search(/\S/);
	            if (indent === -1)
	                continue;
	            if  (startIndent > indent)
	                break;
	            var subRange = this.getFoldWidgetRange(session, "all", row);
	            
	            if (subRange) {
	                if (subRange.start.row <= startRow) {
	                    break;
	                } else if (subRange.isMultiLine()) {
	                    row = subRange.end.row;
	                } else if (startIndent == indent) {
	                    break;
	                }
	            }
	            endRow = row;
	        }
	        
	        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
	    };
	    this.getCommentRegionBlock = function(session, line, row) {
	        var startColumn = line.search(/\s*$/);
	        var maxRow = session.getLength();
	        var startRow = row;
	        
	        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
	        var depth = 1;
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var m = re.exec(line);
	            if (!m) continue;
	            if (m[1]) depth--;
	            else depth++;
	
	            if (!depth) break;
	        }
	
	        var endRow = row;
	        if (endRow > startRow) {
	            return new Range(startRow, startColumn, endRow, line.length);
	        }
	    };
	
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/mode/css",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/css_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/css_completions","ace/mode/behaviour/css","ace/mode/folding/cstyle"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextMode = acequire("./text").Mode;
	var CssHighlightRules = acequire("./css_highlight_rules").CssHighlightRules;
	var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
	var WorkerClient = acequire("../worker/worker_client").WorkerClient;
	var CssCompletions = acequire("./css_completions").CssCompletions;
	var CssBehaviour = acequire("./behaviour/css").CssBehaviour;
	var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;
	
	var Mode = function() {
	    this.HighlightRules = CssHighlightRules;
	    this.$outdent = new MatchingBraceOutdent();
	    this.$behaviour = new CssBehaviour();
	    this.$completer = new CssCompletions();
	    this.foldingRules = new CStyleFoldMode();
	};
	oop.inherits(Mode, TextMode);
	
	(function() {
	
	    this.foldingRules = "cStyle";
	    this.blockComment = {start: "/*", end: "*/"};
	
	    this.getNextLineIndent = function(state, line, tab) {
	        var indent = this.$getIndent(line);
	        var tokens = this.getTokenizer().getLineTokens(line, state).tokens;
	        if (tokens.length && tokens[tokens.length-1].type == "comment") {
	            return indent;
	        }
	
	        var match = line.match(/^.*\{\s*$/);
	        if (match) {
	            indent += tab;
	        }
	
	        return indent;
	    };
	
	    this.checkOutdent = function(state, line, input) {
	        return this.$outdent.checkOutdent(line, input);
	    };
	
	    this.autoOutdent = function(state, doc, row) {
	        this.$outdent.autoOutdent(doc, row);
	    };
	
	    this.getCompletions = function(state, session, pos, prefix) {
	        return this.$completer.getCompletions(state, session, pos, prefix);
	    };
	
	    this.createWorker = function(session) {
	        var worker = new WorkerClient(["ace"], __webpack_require__(280), "Worker");
	        worker.attachToDocument(session.getDocument());
	
	        worker.on("annotate", function(e) {
	            session.setAnnotations(e.data);
	        });
	
	        worker.on("terminate", function() {
	            session.clearAnnotations();
	        });
	
	        return worker;
	    };
	
	    this.$id = "ace/mode/css";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	
	});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	
	var DocCommentHighlightRules = function() {
	    this.$rules = {
	        "start" : [ {
	            token : "comment.doc.tag",
	            regex : "@[\\w\\d_]+" // TODO: fix email addresses
	        }, 
	        DocCommentHighlightRules.getTagRule(),
	        {
	            defaultToken : "comment.doc",
	            caseInsensitive: true
	        }]
	    };
	};
	
	oop.inherits(DocCommentHighlightRules, TextHighlightRules);
	
	DocCommentHighlightRules.getTagRule = function(start) {
	    return {
	        token : "comment.doc.tag.storage.type",
	        regex : "\\b(?:TODO|FIXME|XXX|HACK)\\b"
	    };
	}
	
	DocCommentHighlightRules.getStartRule = function(start) {
	    return {
	        token : "comment.doc", // doc comment
	        regex : "\\/\\*(?=\\*)",
	        next  : start
	    };
	};
	
	DocCommentHighlightRules.getEndRule = function (start) {
	    return {
	        token : "comment.doc", // closing comment
	        regex : "\\*\\/",
	        next  : start
	    };
	};
	
	
	exports.DocCommentHighlightRules = DocCommentHighlightRules;
	
	});
	
	ace.define("ace/mode/javascript_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	var identifierRe = "[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*";
	
	var JavaScriptHighlightRules = function(options) {
	    var keywordMapper = this.createKeywordMapper({
	        "variable.language":
	            "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|"  + // Constructors
	            "Namespace|QName|XML|XMLList|"                                             + // E4X
	            "ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|"   +
	            "Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|"                    +
	            "Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|"   + // Errors
	            "SyntaxError|TypeError|URIError|"                                          +
	            "decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|" + // Non-constructor functions
	            "isNaN|parseFloat|parseInt|"                                               +
	            "JSON|Math|"                                                               + // Other
	            "this|arguments|prototype|window|document"                                 , // Pseudo
	        "keyword":
	            "const|yield|import|get|set|async|await|" +
	            "break|case|catch|continue|default|delete|do|else|finally|for|function|" +
	            "if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|" +
	            "__parent__|__count__|escape|unescape|with|__proto__|" +
	            "class|enum|extends|super|export|implements|private|public|interface|package|protected|static",
	        "storage.type":
	            "const|let|var|function",
	        "constant.language":
	            "null|Infinity|NaN|undefined",
	        "support.function":
	            "alert",
	        "constant.language.boolean": "true|false"
	    }, "identifier");
	    var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
	
	    var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|" + // hex
	        "u[0-9a-fA-F]{4}|" + // unicode
	        "u{[0-9a-fA-F]{1,6}}|" + // es6 unicode
	        "[0-2][0-7]{0,2}|" + // oct
	        "3[0-7][0-7]?|" + // oct
	        "[4-7][0-7]?|" + //oct
	        ".)";
	
	    this.$rules = {
	        "no_regex" : [
	            DocCommentHighlightRules.getStartRule("doc-start"),
	            comments("no_regex"),
	            {
	                token : "string",
	                regex : "'(?=.)",
	                next  : "qstring"
	            }, {
	                token : "string",
	                regex : '"(?=.)',
	                next  : "qqstring"
	            }, {
	                token : "constant.numeric", // hex
	                regex : /0(?:[xX][0-9a-fA-F]+|[bB][01]+)\b/
	            }, {
	                token : "constant.numeric", // float
	                regex : /[+-]?\d[\d_]*(?:(?:\.\d*)?(?:[eE][+-]?\d+)?)?\b/
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "support.function",
	                    "punctuation.operator", "entity.name.function", "text","keyword.operator"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(prototype)(\\.)(" + identifierRe +")(\\s*)(=)",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "entity.name.function", "text",
	                    "keyword.operator", "text", "storage.type", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "entity.name.function", "text", "keyword.operator", "text", "storage.type",
	                    "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "entity.name.function", "text",
	                    "keyword.operator", "text",
	                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
	                ],
	                regex : "(function)(\\s+)(" + identifierRe + ")(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "entity.name.function", "text", "punctuation.operator",
	                    "text", "storage.type", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "text", "text", "storage.type", "text", "paren.lparen"
	                ],
	                regex : "(:)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : "keyword",
	                regex : "(?:" + kwBeforeRe + ")\\b",
	                next : "start"
	            }, {
	                token : ["support.constant"],
	                regex : /that\b/
	            }, {
	                token : ["storage.type", "punctuation.operator", "support.function.firebug"],
	                regex : /(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/
	            }, {
	                token : keywordMapper,
	                regex : identifierRe
	            }, {
	                token : "punctuation.operator",
	                regex : /[.](?![.])/,
	                next  : "property"
	            }, {
	                token : "keyword.operator",
	                regex : /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
	                next  : "start"
	            }, {
	                token : "punctuation.operator",
	                regex : /[?:,;.]/,
	                next  : "start"
	            }, {
	                token : "paren.lparen",
	                regex : /[\[({]/,
	                next  : "start"
	            }, {
	                token : "paren.rparen",
	                regex : /[\])}]/
	            }, {
	                token: "comment",
	                regex: /^#!.*$/
	            }
	        ],
	        property: [{
	                token : "text",
	                regex : "\\s+"
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "entity.name.function", "text",
	                    "keyword.operator", "text",
	                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : "punctuation.operator",
	                regex : /[.](?![.])/
	            }, {
	                token : "support.function",
	                regex : /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
	            }, {
	                token : "support.function.dom",
	                regex : /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
	            }, {
	                token :  "support.constant",
	                regex : /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
	            }, {
	                token : "identifier",
	                regex : identifierRe
	            }, {
	                regex: "",
	                token: "empty",
	                next: "no_regex"
	            }
	        ],
	        "start": [
	            DocCommentHighlightRules.getStartRule("doc-start"),
	            comments("start"),
	            {
	                token: "string.regexp",
	                regex: "\\/",
	                next: "regex"
	            }, {
	                token : "text",
	                regex : "\\s+|^$",
	                next : "start"
	            }, {
	                token: "empty",
	                regex: "",
	                next: "no_regex"
	            }
	        ],
	        "regex": [
	            {
	                token: "regexp.keyword.operator",
	                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
	            }, {
	                token: "string.regexp",
	                regex: "/[sxngimy]*",
	                next: "no_regex"
	            }, {
	                token : "invalid",
	                regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
	            }, {
	                token : "constant.language.escape",
	                regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
	            }, {
	                token : "constant.language.delimiter",
	                regex: /\|/
	            }, {
	                token: "constant.language.escape",
	                regex: /\[\^?/,
	                next: "regex_character_class"
	            }, {
	                token: "empty",
	                regex: "$",
	                next: "no_regex"
	            }, {
	                defaultToken: "string.regexp"
	            }
	        ],
	        "regex_character_class": [
	            {
	                token: "regexp.charclass.keyword.operator",
	                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
	            }, {
	                token: "constant.language.escape",
	                regex: "]",
	                next: "regex"
	            }, {
	                token: "constant.language.escape",
	                regex: "-"
	            }, {
	                token: "empty",
	                regex: "$",
	                next: "no_regex"
	            }, {
	                defaultToken: "string.regexp.charachterclass"
	            }
	        ],
	        "function_arguments": [
	            {
	                token: "variable.parameter",
	                regex: identifierRe
	            }, {
	                token: "punctuation.operator",
	                regex: "[, ]+"
	            }, {
	                token: "punctuation.operator",
	                regex: "$"
	            }, {
	                token: "empty",
	                regex: "",
	                next: "no_regex"
	            }
	        ],
	        "qqstring" : [
	            {
	                token : "constant.language.escape",
	                regex : escapedRe
	            }, {
	                token : "string",
	                regex : "\\\\$",
	                next  : "qqstring"
	            }, {
	                token : "string",
	                regex : '"|$',
	                next  : "no_regex"
	            }, {
	                defaultToken: "string"
	            }
	        ],
	        "qstring" : [
	            {
	                token : "constant.language.escape",
	                regex : escapedRe
	            }, {
	                token : "string",
	                regex : "\\\\$",
	                next  : "qstring"
	            }, {
	                token : "string",
	                regex : "'|$",
	                next  : "no_regex"
	            }, {
	                defaultToken: "string"
	            }
	        ]
	    };
	    
	    
	    if (!options || !options.noES6) {
	        this.$rules.no_regex.unshift({
	            regex: "[{}]", onMatch: function(val, state, stack) {
	                this.next = val == "{" ? this.nextState : "";
	                if (val == "{" && stack.length) {
	                    stack.unshift("start", state);
	                }
	                else if (val == "}" && stack.length) {
	                    stack.shift();
	                    this.next = stack.shift();
	                    if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1)
	                        return "paren.quasi.end";
	                }
	                return val == "{" ? "paren.lparen" : "paren.rparen";
	            },
	            nextState: "start"
	        }, {
	            token : "string.quasi.start",
	            regex : /`/,
	            push  : [{
	                token : "constant.language.escape",
	                regex : escapedRe
	            }, {
	                token : "paren.quasi.start",
	                regex : /\${/,
	                push  : "start"
	            }, {
	                token : "string.quasi.end",
	                regex : /`/,
	                next  : "pop"
	            }, {
	                defaultToken: "string.quasi"
	            }]
	        });
	        
	        if (!options || options.jsx != false)
	            JSX.call(this);
	    }
	    
	    this.embedRules(DocCommentHighlightRules, "doc-",
	        [ DocCommentHighlightRules.getEndRule("no_regex") ]);
	    
	    this.normalizeRules();
	};
	
	oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
	
	function JSX() {
	    var tagRegex = identifierRe.replace("\\d", "\\d\\-");
	    var jsxTag = {
	        onMatch : function(val, state, stack) {
	            var offset = val.charAt(1) == "/" ? 2 : 1;
	            if (offset == 1) {
	                if (state != this.nextState)
	                    stack.unshift(this.next, this.nextState, 0);
	                else
	                    stack.unshift(this.next);
	                stack[2]++;
	            } else if (offset == 2) {
	                if (state == this.nextState) {
	                    stack[1]--;
	                    if (!stack[1] || stack[1] < 0) {
	                        stack.shift();
	                        stack.shift();
	                    }
	                }
	            }
	            return [{
	                type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
	                value: val.slice(0, offset)
	            }, {
	                type: "meta.tag.tag-name.xml",
	                value: val.substr(offset)
	            }];
	        },
	        regex : "</?" + tagRegex + "",
	        next: "jsxAttributes",
	        nextState: "jsx"
	    };
	    this.$rules.start.unshift(jsxTag);
	    var jsxJsRule = {
	        regex: "{",
	        token: "paren.quasi.start",
	        push: "start"
	    };
	    this.$rules.jsx = [
	        jsxJsRule,
	        jsxTag,
	        {include : "reference"},
	        {defaultToken: "string"}
	    ];
	    this.$rules.jsxAttributes = [{
	        token : "meta.tag.punctuation.tag-close.xml", 
	        regex : "/?>", 
	        onMatch : function(value, currentState, stack) {
	            if (currentState == stack[0])
	                stack.shift();
	            if (value.length == 2) {
	                if (stack[0] == this.nextState)
	                    stack[1]--;
	                if (!stack[1] || stack[1] < 0) {
	                    stack.splice(0, 2);
	                }
	            }
	            this.next = stack[0] || "start";
	            return [{type: this.token, value: value}];
	        },
	        nextState: "jsx"
	    }, 
	    jsxJsRule,
	    comments("jsxAttributes"),
	    {
	        token : "entity.other.attribute-name.xml",
	        regex : tagRegex
	    }, {
	        token : "keyword.operator.attribute-equals.xml",
	        regex : "="
	    }, {
	        token : "text.tag-whitespace.xml",
	        regex : "\\s+"
	    }, {
	        token : "string.attribute-value.xml",
	        regex : "'",
	        stateName : "jsx_attr_q",
	        push : [
	            {token : "string.attribute-value.xml", regex: "'", next: "pop"},
	            {include : "reference"},
	            {defaultToken : "string.attribute-value.xml"}
	        ]
	    }, {
	        token : "string.attribute-value.xml",
	        regex : '"',
	        stateName : "jsx_attr_qq",
	        push : [
	            {token : "string.attribute-value.xml", regex: '"', next: "pop"},
	            {include : "reference"},
	            {defaultToken : "string.attribute-value.xml"}
	        ]
	    },
	    jsxTag
	    ];
	    this.$rules.reference = [{
	        token : "constant.language.escape.reference.xml",
	        regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
	    }];
	}
	
	function comments(next) {
	    return [
	        {
	            token : "comment", // multi line comment
	            regex : /\/\*/,
	            next: [
	                DocCommentHighlightRules.getTagRule(),
	                {token : "comment", regex : "\\*\\/", next : next || "pop"},
	                {defaultToken : "comment", caseInsensitive: true}
	            ]
	        }, {
	            token : "comment",
	            regex : "\\/\\/",
	            next: [
	                DocCommentHighlightRules.getTagRule(),
	                {token : "comment", regex : "$|^", next : next || "pop"},
	                {defaultToken : "comment", caseInsensitive: true}
	            ]
	        }
	    ];
	}
	exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
	});
	
	ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	
	var MatchingBraceOutdent = function() {};
	
	(function() {
	
	    this.checkOutdent = function(line, input) {
	        if (! /^\s+$/.test(line))
	            return false;
	
	        return /^\s*\}/.test(input);
	    };
	
	    this.autoOutdent = function(doc, row) {
	        var line = doc.getLine(row);
	        var match = line.match(/^(\s*\})/);
	
	        if (!match) return 0;
	
	        var column = match[1].length;
	        var openBracePos = doc.findMatchingBracket({row: row, column: column});
	
	        if (!openBracePos || openBracePos.row == row) return 0;
	
	        var indent = this.$getIndent(doc.getLine(openBracePos.row));
	        doc.replace(new Range(row, 0, row, column-1), indent);
	    };
	
	    this.$getIndent = function(line) {
	        return line.match(/^\s*/)[0];
	    };
	
	}).call(MatchingBraceOutdent.prototype);
	
	exports.MatchingBraceOutdent = MatchingBraceOutdent;
	});
	
	ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Range = acequire("../../range").Range;
	var BaseFoldMode = acequire("./fold_mode").FoldMode;
	
	var FoldMode = exports.FoldMode = function(commentRegex) {
	    if (commentRegex) {
	        this.foldingStartMarker = new RegExp(
	            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
	        );
	        this.foldingStopMarker = new RegExp(
	            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
	        );
	    }
	};
	oop.inherits(FoldMode, BaseFoldMode);
	
	(function() {
	    
	    this.foldingStartMarker = /(\{|\[)[^\}\]]*$|^\s*(\/\*)/;
	    this.foldingStopMarker = /^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/;
	    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
	    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
	    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
	    this._getFoldWidgetBase = this.getFoldWidget;
	    this.getFoldWidget = function(session, foldStyle, row) {
	        var line = session.getLine(row);
	    
	        if (this.singleLineBlockCommentRe.test(line)) {
	            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
	                return "";
	        }
	    
	        var fw = this._getFoldWidgetBase(session, foldStyle, row);
	    
	        if (!fw && this.startRegionRe.test(line))
	            return "start"; // lineCommentRegionStart
	    
	        return fw;
	    };
	
	    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
	        var line = session.getLine(row);
	        
	        if (this.startRegionRe.test(line))
	            return this.getCommentRegionBlock(session, line, row);
	        
	        var match = line.match(this.foldingStartMarker);
	        if (match) {
	            var i = match.index;
	
	            if (match[1])
	                return this.openingBracketBlock(session, match[1], row, i);
	                
	            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
	            
	            if (range && !range.isMultiLine()) {
	                if (forceMultiline) {
	                    range = this.getSectionRange(session, row);
	                } else if (foldStyle != "all")
	                    range = null;
	            }
	            
	            return range;
	        }
	
	        if (foldStyle === "markbegin")
	            return;
	
	        var match = line.match(this.foldingStopMarker);
	        if (match) {
	            var i = match.index + match[0].length;
	
	            if (match[1])
	                return this.closingBracketBlock(session, match[1], row, i);
	
	            return session.getCommentFoldRange(row, i, -1);
	        }
	    };
	    
	    this.getSectionRange = function(session, row) {
	        var line = session.getLine(row);
	        var startIndent = line.search(/\S/);
	        var startRow = row;
	        var startColumn = line.length;
	        row = row + 1;
	        var endRow = row;
	        var maxRow = session.getLength();
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var indent = line.search(/\S/);
	            if (indent === -1)
	                continue;
	            if  (startIndent > indent)
	                break;
	            var subRange = this.getFoldWidgetRange(session, "all", row);
	            
	            if (subRange) {
	                if (subRange.start.row <= startRow) {
	                    break;
	                } else if (subRange.isMultiLine()) {
	                    row = subRange.end.row;
	                } else if (startIndent == indent) {
	                    break;
	                }
	            }
	            endRow = row;
	        }
	        
	        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
	    };
	    this.getCommentRegionBlock = function(session, line, row) {
	        var startColumn = line.search(/\s*$/);
	        var maxRow = session.getLength();
	        var startRow = row;
	        
	        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
	        var depth = 1;
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var m = re.exec(line);
	            if (!m) continue;
	            if (m[1]) depth--;
	            else depth++;
	
	            if (!depth) break;
	        }
	
	        var endRow = row;
	        if (endRow > startRow) {
	            return new Range(startRow, startColumn, endRow, line.length);
	        }
	    };
	
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/mode/javascript",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextMode = acequire("./text").Mode;
	var JavaScriptHighlightRules = acequire("./javascript_highlight_rules").JavaScriptHighlightRules;
	var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
	var WorkerClient = acequire("../worker/worker_client").WorkerClient;
	var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
	var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;
	
	var Mode = function() {
	    this.HighlightRules = JavaScriptHighlightRules;
	    
	    this.$outdent = new MatchingBraceOutdent();
	    this.$behaviour = new CstyleBehaviour();
	    this.foldingRules = new CStyleFoldMode();
	};
	oop.inherits(Mode, TextMode);
	
	(function() {
	
	    this.lineCommentStart = "//";
	    this.blockComment = {start: "/*", end: "*/"};
	
	    this.getNextLineIndent = function(state, line, tab) {
	        var indent = this.$getIndent(line);
	
	        var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
	        var tokens = tokenizedLine.tokens;
	        var endState = tokenizedLine.state;
	
	        if (tokens.length && tokens[tokens.length-1].type == "comment") {
	            return indent;
	        }
	
	        if (state == "start" || state == "no_regex") {
	            var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
	            if (match) {
	                indent += tab;
	            }
	        } else if (state == "doc-start") {
	            if (endState == "start" || endState == "no_regex") {
	                return "";
	            }
	            var match = line.match(/^\s*(\/?)\*/);
	            if (match) {
	                if (match[1]) {
	                    indent += " ";
	                }
	                indent += "* ";
	            }
	        }
	
	        return indent;
	    };
	
	    this.checkOutdent = function(state, line, input) {
	        return this.$outdent.checkOutdent(line, input);
	    };
	
	    this.autoOutdent = function(state, doc, row) {
	        this.$outdent.autoOutdent(doc, row);
	    };
	
	    this.createWorker = function(session) {
	        var worker = new WorkerClient(["ace"], __webpack_require__(170), "JavaScriptWorker");
	        worker.attachToDocument(session.getDocument());
	
	        worker.on("annotate", function(results) {
	            session.setAnnotations(results.data);
	        });
	
	        worker.on("terminate", function() {
	            session.clearAnnotations();
	        });
	
	        return worker;
	    };
	
	    this.$id = "ace/mode/javascript";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	});
	
	ace.define("ace/mode/css_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var lang = acequire("../lib/lang");
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	var supportType = exports.supportType = "align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-repeat|background-size|border|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-shadow|box-sizing|caption-side|clear|clip|color|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|font|font-family|font-size|font-size-adjust|font-stretch|font-style|font-variant|font-weight|hanging-punctuation|height|justify-content|left|letter-spacing|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|min-height|min-width|nav-down|nav-index|nav-left|nav-right|nav-up|opacity|order|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-x|overflow-y|padding|padding-bottom|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|perspective|perspective-origin|position|quotes|resize|right|tab-size|table-layout|text-align|text-align-last|text-decoration|text-decoration-color|text-decoration-line|text-decoration-style|text-indent|text-justify|text-overflow|text-shadow|text-transform|top|transform|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|unicode-bidi|vertical-align|visibility|white-space|width|word-break|word-spacing|word-wrap|z-index";
	var supportFunction = exports.supportFunction = "rgb|rgba|url|attr|counter|counters";
	var supportConstant = exports.supportConstant = "absolute|after-edge|after|all-scroll|all|alphabetic|always|antialiased|armenian|auto|avoid-column|avoid-page|avoid|balance|baseline|before-edge|before|below|bidi-override|block-line-height|block|bold|bolder|border-box|both|bottom|box|break-all|break-word|capitalize|caps-height|caption|center|central|char|circle|cjk-ideographic|clone|close-quote|col-resize|collapse|column|consider-shifts|contain|content-box|cover|crosshair|cubic-bezier|dashed|decimal-leading-zero|decimal|default|disabled|disc|disregard-shifts|distribute-all-lines|distribute-letter|distribute-space|distribute|dotted|double|e-resize|ease-in|ease-in-out|ease-out|ease|ellipsis|end|exclude-ruby|fill|fixed|georgian|glyphs|grid-height|groove|hand|hanging|hebrew|help|hidden|hiragana-iroha|hiragana|horizontal|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|include-ruby|inherit|initial|inline-block|inline-box|inline-line-height|inline-table|inline|inset|inside|inter-ideograph|inter-word|invert|italic|justify|katakana-iroha|katakana|keep-all|last|left|lighter|line-edge|line-through|line|linear|list-item|local|loose|lower-alpha|lower-greek|lower-latin|lower-roman|lowercase|lr-tb|ltr|mathematical|max-height|max-size|medium|menu|message-box|middle|move|n-resize|ne-resize|newspaper|no-change|no-close-quote|no-drop|no-open-quote|no-repeat|none|normal|not-allowed|nowrap|nw-resize|oblique|open-quote|outset|outside|overline|padding-box|page|pointer|pre-line|pre-wrap|pre|preserve-3d|progress|relative|repeat-x|repeat-y|repeat|replaced|reset-size|ridge|right|round|row-resize|rtl|s-resize|scroll|se-resize|separate|slice|small-caps|small-caption|solid|space|square|start|static|status-bar|step-end|step-start|steps|stretch|strict|sub|super|sw-resize|table-caption|table-cell|table-column-group|table-column|table-footer-group|table-header-group|table-row-group|table-row|table|tb-rl|text-after-edge|text-before-edge|text-bottom|text-size|text-top|text|thick|thin|transparent|underline|upper-alpha|upper-latin|upper-roman|uppercase|use-script|vertical-ideographic|vertical-text|visible|w-resize|wait|whitespace|z-index|zero";
	var supportConstantColor = exports.supportConstantColor = "aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow";
	var supportConstantFonts = exports.supportConstantFonts = "arial|century|comic|courier|cursive|fantasy|garamond|georgia|helvetica|impact|lucida|symbol|system|tahoma|times|trebuchet|utopia|verdana|webdings|sans-serif|serif|monospace";
	
	var numRe = exports.numRe = "\\-?(?:(?:[0-9]+)|(?:[0-9]*\\.[0-9]+))";
	var pseudoElements = exports.pseudoElements = "(\\:+)\\b(after|before|first-letter|first-line|moz-selection|selection)\\b";
	var pseudoClasses  = exports.pseudoClasses =  "(:)\\b(active|checked|disabled|empty|enabled|first-child|first-of-type|focus|hover|indeterminate|invalid|last-child|last-of-type|link|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|only-child|only-of-type|acequired|root|target|valid|visited)\\b";
	
	var CssHighlightRules = function() {
	
	    var keywordMapper = this.createKeywordMapper({
	        "support.function": supportFunction,
	        "support.constant": supportConstant,
	        "support.type": supportType,
	        "support.constant.color": supportConstantColor,
	        "support.constant.fonts": supportConstantFonts
	    }, "text", true);
	
	    this.$rules = {
	        "start" : [{
	            token : "comment", // multi line comment
	            regex : "\\/\\*",
	            push : "comment"
	        }, {
	            token: "paren.lparen",
	            regex: "\\{",
	            push:  "ruleset"
	        }, {
	            token: "string",
	            regex: "@.*?{",
	            push:  "media"
	        }, {
	            token: "keyword",
	            regex: "#[a-z0-9-_]+"
	        }, {
	            token: "variable",
	            regex: "\\.[a-z0-9-_]+"
	        }, {
	            token: "string",
	            regex: ":[a-z0-9-_]+"
	        }, {
	            token: "constant",
	            regex: "[a-z0-9-_]+"
	        }, {
	            caseInsensitive: true
	        }],
	
	        "media" : [{
	            token : "comment", // multi line comment
	            regex : "\\/\\*",
	            push : "comment"
	        }, {
	            token: "paren.lparen",
	            regex: "\\{",
	            push:  "ruleset"
	        }, {
	            token: "string",
	            regex: "\\}",
	            next:  "pop"
	        }, {
	            token: "keyword",
	            regex: "#[a-z0-9-_]+"
	        }, {
	            token: "variable",
	            regex: "\\.[a-z0-9-_]+"
	        }, {
	            token: "string",
	            regex: ":[a-z0-9-_]+"
	        }, {
	            token: "constant",
	            regex: "[a-z0-9-_]+"
	        }, {
	            caseInsensitive: true
	        }],
	
	        "comment" : [{
	            token : "comment",
	            regex : "\\*\\/",
	            next : "pop"
	        }, {
	            defaultToken : "comment"
	        }],
	
	        "ruleset" : [
	        {
	            token : "paren.rparen",
	            regex : "\\}",
	            next:   "pop"
	        }, {
	            token : "comment", // multi line comment
	            regex : "\\/\\*",
	            push : "comment"
	        }, {
	            token : "string", // single line
	            regex : '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
	        }, {
	            token : "string", // single line
	            regex : "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
	        }, {
	            token : ["constant.numeric", "keyword"],
	            regex : "(" + numRe + ")(ch|cm|deg|em|ex|fr|gd|grad|Hz|in|kHz|mm|ms|pc|pt|px|rad|rem|s|turn|vh|vm|vw|%)"
	        }, {
	            token : "constant.numeric",
	            regex : numRe
	        }, {
	            token : "constant.numeric",  // hex6 color
	            regex : "#[a-f0-9]{6}"
	        }, {
	            token : "constant.numeric", // hex3 color
	            regex : "#[a-f0-9]{3}"
	        }, {
	            token : ["punctuation", "entity.other.attribute-name.pseudo-element.css"],
	            regex : pseudoElements
	        }, {
	            token : ["punctuation", "entity.other.attribute-name.pseudo-class.css"],
	            regex : pseudoClasses
	        }, {
	            token : ["support.function", "string", "support.function"],
	            regex : "(url\\()(.*)(\\))"
	        }, {
	            token : keywordMapper,
	            regex : "\\-?[a-zA-Z_][a-zA-Z0-9_\\-]*"
	        }, {
	            caseInsensitive: true
	        }]
	    };
	
	    this.normalizeRules();
	};
	
	oop.inherits(CssHighlightRules, TextHighlightRules);
	
	exports.CssHighlightRules = CssHighlightRules;
	
	});
	
	ace.define("ace/mode/css_completions",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	var propertyMap = {
	    "background": {"#$0": 1},
	    "background-color": {"#$0": 1, "transparent": 1, "fixed": 1},
	    "background-image": {"url('/$0')": 1},
	    "background-repeat": {"repeat": 1, "repeat-x": 1, "repeat-y": 1, "no-repeat": 1, "inherit": 1},
	    "background-position": {"bottom":2, "center":2, "left":2, "right":2, "top":2, "inherit":2},
	    "background-attachment": {"scroll": 1, "fixed": 1},
	    "background-size": {"cover": 1, "contain": 1},
	    "background-clip": {"border-box": 1, "padding-box": 1, "content-box": 1},
	    "background-origin": {"border-box": 1, "padding-box": 1, "content-box": 1},
	    "border": {"solid $0": 1, "dashed $0": 1, "dotted $0": 1, "#$0": 1},
	    "border-color": {"#$0": 1},
	    "border-style": {"solid":2, "dashed":2, "dotted":2, "double":2, "groove":2, "hidden":2, "inherit":2, "inset":2, "none":2, "outset":2, "ridged":2},
	    "border-collapse": {"collapse": 1, "separate": 1},
	    "bottom": {"px": 1, "em": 1, "%": 1},
	    "clear": {"left": 1, "right": 1, "both": 1, "none": 1},
	    "color": {"#$0": 1, "rgb(#$00,0,0)": 1},
	    "cursor": {"default": 1, "pointer": 1, "move": 1, "text": 1, "wait": 1, "help": 1, "progress": 1, "n-resize": 1, "ne-resize": 1, "e-resize": 1, "se-resize": 1, "s-resize": 1, "sw-resize": 1, "w-resize": 1, "nw-resize": 1},
	    "display": {"none": 1, "block": 1, "inline": 1, "inline-block": 1, "table-cell": 1},
	    "empty-cells": {"show": 1, "hide": 1},
	    "float": {"left": 1, "right": 1, "none": 1},
	    "font-family": {"Arial":2,"Comic Sans MS":2,"Consolas":2,"Courier New":2,"Courier":2,"Georgia":2,"Monospace":2,"Sans-Serif":2, "Segoe UI":2,"Tahoma":2,"Times New Roman":2,"Trebuchet MS":2,"Verdana": 1},
	    "font-size": {"px": 1, "em": 1, "%": 1},
	    "font-weight": {"bold": 1, "normal": 1},
	    "font-style": {"italic": 1, "normal": 1},
	    "font-variant": {"normal": 1, "small-caps": 1},
	    "height": {"px": 1, "em": 1, "%": 1},
	    "left": {"px": 1, "em": 1, "%": 1},
	    "letter-spacing": {"normal": 1},
	    "line-height": {"normal": 1},
	    "list-style-type": {"none": 1, "disc": 1, "circle": 1, "square": 1, "decimal": 1, "decimal-leading-zero": 1, "lower-roman": 1, "upper-roman": 1, "lower-greek": 1, "lower-latin": 1, "upper-latin": 1, "georgian": 1, "lower-alpha": 1, "upper-alpha": 1},
	    "margin": {"px": 1, "em": 1, "%": 1},
	    "margin-right": {"px": 1, "em": 1, "%": 1},
	    "margin-left": {"px": 1, "em": 1, "%": 1},
	    "margin-top": {"px": 1, "em": 1, "%": 1},
	    "margin-bottom": {"px": 1, "em": 1, "%": 1},
	    "max-height": {"px": 1, "em": 1, "%": 1},
	    "max-width": {"px": 1, "em": 1, "%": 1},
	    "min-height": {"px": 1, "em": 1, "%": 1},
	    "min-width": {"px": 1, "em": 1, "%": 1},
	    "overflow": {"hidden": 1, "visible": 1, "auto": 1, "scroll": 1},
	    "overflow-x": {"hidden": 1, "visible": 1, "auto": 1, "scroll": 1},
	    "overflow-y": {"hidden": 1, "visible": 1, "auto": 1, "scroll": 1},
	    "padding": {"px": 1, "em": 1, "%": 1},
	    "padding-top": {"px": 1, "em": 1, "%": 1},
	    "padding-right": {"px": 1, "em": 1, "%": 1},
	    "padding-bottom": {"px": 1, "em": 1, "%": 1},
	    "padding-left": {"px": 1, "em": 1, "%": 1},
	    "page-break-after": {"auto": 1, "always": 1, "avoid": 1, "left": 1, "right": 1},
	    "page-break-before": {"auto": 1, "always": 1, "avoid": 1, "left": 1, "right": 1},
	    "position": {"absolute": 1, "relative": 1, "fixed": 1, "static": 1},
	    "right": {"px": 1, "em": 1, "%": 1},
	    "table-layout": {"fixed": 1, "auto": 1},
	    "text-decoration": {"none": 1, "underline": 1, "line-through": 1, "blink": 1},
	    "text-align": {"left": 1, "right": 1, "center": 1, "justify": 1},
	    "text-transform": {"capitalize": 1, "uppercase": 1, "lowercase": 1, "none": 1},
	    "top": {"px": 1, "em": 1, "%": 1},
	    "vertical-align": {"top": 1, "bottom": 1},
	    "visibility": {"hidden": 1, "visible": 1},
	    "white-space": {"nowrap": 1, "normal": 1, "pre": 1, "pre-line": 1, "pre-wrap": 1},
	    "width": {"px": 1, "em": 1, "%": 1},
	    "word-spacing": {"normal": 1},
	    "filter": {"alpha(opacity=$0100)": 1},
	
	    "text-shadow": {"$02px 2px 2px #777": 1},
	    "text-overflow": {"ellipsis-word": 1, "clip": 1, "ellipsis": 1},
	    "-moz-border-radius": 1,
	    "-moz-border-radius-topright": 1,
	    "-moz-border-radius-bottomright": 1,
	    "-moz-border-radius-topleft": 1,
	    "-moz-border-radius-bottomleft": 1,
	    "-webkit-border-radius": 1,
	    "-webkit-border-top-right-radius": 1,
	    "-webkit-border-top-left-radius": 1,
	    "-webkit-border-bottom-right-radius": 1,
	    "-webkit-border-bottom-left-radius": 1,
	    "-moz-box-shadow": 1,
	    "-webkit-box-shadow": 1,
	    "transform": {"rotate($00deg)": 1, "skew($00deg)": 1},
	    "-moz-transform": {"rotate($00deg)": 1, "skew($00deg)": 1},
	    "-webkit-transform": {"rotate($00deg)": 1, "skew($00deg)": 1 }
	};
	
	var CssCompletions = function() {
	
	};
	
	(function() {
	
	    this.completionsDefined = false;
	
	    this.defineCompletions = function() {
	        if (document) {
	            var style = document.createElement('c').style;
	
	            for (var i in style) {
	                if (typeof style[i] !== 'string')
	                    continue;
	
	                var name = i.replace(/[A-Z]/g, function(x) {
	                    return '-' + x.toLowerCase();
	                });
	
	                if (!propertyMap.hasOwnProperty(name))
	                    propertyMap[name] = 1;
	            }
	        }
	
	        this.completionsDefined = true;
	    }
	
	    this.getCompletions = function(state, session, pos, prefix) {
	        if (!this.completionsDefined) {
	            this.defineCompletions();
	        }
	
	        var token = session.getTokenAt(pos.row, pos.column);
	
	        if (!token)
	            return [];
	        if (state==='ruleset'){
	            var line = session.getLine(pos.row).substr(0, pos.column);
	            if (/:[^;]+$/.test(line)) {
	                /([\w\-]+):[^:]*$/.test(line);
	
	                return this.getPropertyValueCompletions(state, session, pos, prefix);
	            } else {
	                return this.getPropertyCompletions(state, session, pos, prefix);
	            }
	        }
	
	        return [];
	    };
	
	    this.getPropertyCompletions = function(state, session, pos, prefix) {
	        var properties = Object.keys(propertyMap);
	        return properties.map(function(property){
	            return {
	                caption: property,
	                snippet: property + ': $0',
	                meta: "property",
	                score: Number.MAX_VALUE
	            };
	        });
	    };
	
	    this.getPropertyValueCompletions = function(state, session, pos, prefix) {
	        var line = session.getLine(pos.row).substr(0, pos.column);
	        var property = (/([\w\-]+):[^:]*$/.exec(line) || {})[1];
	
	        if (!property)
	            return [];
	        var values = [];
	        if (property in propertyMap && typeof propertyMap[property] === "object") {
	            values = Object.keys(propertyMap[property]);
	        }
	        return values.map(function(value){
	            return {
	                caption: value,
	                snippet: value,
	                meta: "property value",
	                score: Number.MAX_VALUE
	            };
	        });
	    };
	
	}).call(CssCompletions.prototype);
	
	exports.CssCompletions = CssCompletions;
	});
	
	ace.define("ace/mode/behaviour/css",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/mode/behaviour/cstyle","ace/token_iterator"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Behaviour = acequire("../behaviour").Behaviour;
	var CstyleBehaviour = acequire("./cstyle").CstyleBehaviour;
	var TokenIterator = acequire("../../token_iterator").TokenIterator;
	
	var CssBehaviour = function () {
	
	    this.inherit(CstyleBehaviour);
	
	    this.add("colon", "insertion", function (state, action, editor, session, text) {
	        if (text === ':') {
	            var cursor = editor.getCursorPosition();
	            var iterator = new TokenIterator(session, cursor.row, cursor.column);
	            var token = iterator.getCurrentToken();
	            if (token && token.value.match(/\s+/)) {
	                token = iterator.stepBackward();
	            }
	            if (token && token.type === 'support.type') {
	                var line = session.doc.getLine(cursor.row);
	                var rightChar = line.substring(cursor.column, cursor.column + 1);
	                if (rightChar === ':') {
	                    return {
	                       text: '',
	                       selection: [1, 1]
	                    }
	                }
	                if (!line.substring(cursor.column).match(/^\s*;/)) {
	                    return {
	                       text: ':;',
	                       selection: [1, 1]
	                    }
	                }
	            }
	        }
	    });
	
	    this.add("colon", "deletion", function (state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && selected === ':') {
	            var cursor = editor.getCursorPosition();
	            var iterator = new TokenIterator(session, cursor.row, cursor.column);
	            var token = iterator.getCurrentToken();
	            if (token && token.value.match(/\s+/)) {
	                token = iterator.stepBackward();
	            }
	            if (token && token.type === 'support.type') {
	                var line = session.doc.getLine(range.start.row);
	                var rightChar = line.substring(range.end.column, range.end.column + 1);
	                if (rightChar === ';') {
	                    range.end.column ++;
	                    return range;
	                }
	            }
	        }
	    });
	
	    this.add("semicolon", "insertion", function (state, action, editor, session, text) {
	        if (text === ';') {
	            var cursor = editor.getCursorPosition();
	            var line = session.doc.getLine(cursor.row);
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar === ';') {
	                return {
	                   text: '',
	                   selection: [1, 1]
	                }
	            }
	        }
	    });
	
	}
	oop.inherits(CssBehaviour, CstyleBehaviour);
	
	exports.CssBehaviour = CssBehaviour;
	});
	
	ace.define("ace/mode/css",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/css_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/css_completions","ace/mode/behaviour/css","ace/mode/folding/cstyle"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextMode = acequire("./text").Mode;
	var CssHighlightRules = acequire("./css_highlight_rules").CssHighlightRules;
	var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
	var WorkerClient = acequire("../worker/worker_client").WorkerClient;
	var CssCompletions = acequire("./css_completions").CssCompletions;
	var CssBehaviour = acequire("./behaviour/css").CssBehaviour;
	var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;
	
	var Mode = function() {
	    this.HighlightRules = CssHighlightRules;
	    this.$outdent = new MatchingBraceOutdent();
	    this.$behaviour = new CssBehaviour();
	    this.$completer = new CssCompletions();
	    this.foldingRules = new CStyleFoldMode();
	};
	oop.inherits(Mode, TextMode);
	
	(function() {
	
	    this.foldingRules = "cStyle";
	    this.blockComment = {start: "/*", end: "*/"};
	
	    this.getNextLineIndent = function(state, line, tab) {
	        var indent = this.$getIndent(line);
	        var tokens = this.getTokenizer().getLineTokens(line, state).tokens;
	        if (tokens.length && tokens[tokens.length-1].type == "comment") {
	            return indent;
	        }
	
	        var match = line.match(/^.*\{\s*$/);
	        if (match) {
	            indent += tab;
	        }
	
	        return indent;
	    };
	
	    this.checkOutdent = function(state, line, input) {
	        return this.$outdent.checkOutdent(line, input);
	    };
	
	    this.autoOutdent = function(state, doc, row) {
	        this.$outdent.autoOutdent(doc, row);
	    };
	
	    this.getCompletions = function(state, session, pos, prefix) {
	        return this.$completer.getCompletions(state, session, pos, prefix);
	    };
	
	    this.createWorker = function(session) {
	        var worker = new WorkerClient(["ace"], __webpack_require__(280), "Worker");
	        worker.attachToDocument(session.getDocument());
	
	        worker.on("annotate", function(e) {
	            session.setAnnotations(e.data);
	        });
	
	        worker.on("terminate", function() {
	            session.clearAnnotations();
	        });
	
	        return worker;
	    };
	
	    this.$id = "ace/mode/css";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	
	});
	
	ace.define("ace/mode/xml_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	
	var XmlHighlightRules = function(normalize) {
	    var tagRegex = "[_:a-zA-Z\xc0-\uffff][-_:.a-zA-Z0-9\xc0-\uffff]*";
	
	    this.$rules = {
	        start : [
	            {token : "string.cdata.xml", regex : "<\\!\\[CDATA\\[", next : "cdata"},
	            {
	                token : ["punctuation.xml-decl.xml", "keyword.xml-decl.xml"],
	                regex : "(<\\?)(xml)(?=[\\s])", next : "xml_decl", caseInsensitive: true
	            },
	            {
	                token : ["punctuation.instruction.xml", "keyword.instruction.xml"],
	                regex : "(<\\?)(" + tagRegex + ")", next : "processing_instruction"
	            },
	            {token : "comment.xml", regex : "<\\!--", next : "comment"},
	            {
	                token : ["xml-pe.doctype.xml", "xml-pe.doctype.xml"],
	                regex : "(<\\!)(DOCTYPE)(?=[\\s])", next : "doctype", caseInsensitive: true
	            },
	            {include : "tag"},
	            {token : "text.end-tag-open.xml", regex: "</"},
	            {token : "text.tag-open.xml", regex: "<"},
	            {include : "reference"},
	            {defaultToken : "text.xml"}
	        ],
	
	        xml_decl : [{
	            token : "entity.other.attribute-name.decl-attribute-name.xml",
	            regex : "(?:" + tagRegex + ":)?" + tagRegex + ""
	        }, {
	            token : "keyword.operator.decl-attribute-equals.xml",
	            regex : "="
	        }, {
	            include: "whitespace"
	        }, {
	            include: "string"
	        }, {
	            token : "punctuation.xml-decl.xml",
	            regex : "\\?>",
	            next : "start"
	        }],
	
	        processing_instruction : [
	            {token : "punctuation.instruction.xml", regex : "\\?>", next : "start"},
	            {defaultToken : "instruction.xml"}
	        ],
	
	        doctype : [
	            {include : "whitespace"},
	            {include : "string"},
	            {token : "xml-pe.doctype.xml", regex : ">", next : "start"},
	            {token : "xml-pe.xml", regex : "[-_a-zA-Z0-9:]+"},
	            {token : "punctuation.int-subset", regex : "\\[", push : "int_subset"}
	        ],
	
	        int_subset : [{
	            token : "text.xml",
	            regex : "\\s+"
	        }, {
	            token: "punctuation.int-subset.xml",
	            regex: "]",
	            next: "pop"
	        }, {
	            token : ["punctuation.markup-decl.xml", "keyword.markup-decl.xml"],
	            regex : "(<\\!)(" + tagRegex + ")",
	            push : [{
	                token : "text",
	                regex : "\\s+"
	            },
	            {
	                token : "punctuation.markup-decl.xml",
	                regex : ">",
	                next : "pop"
	            },
	            {include : "string"}]
	        }],
	
	        cdata : [
	            {token : "string.cdata.xml", regex : "\\]\\]>", next : "start"},
	            {token : "text.xml", regex : "\\s+"},
	            {token : "text.xml", regex : "(?:[^\\]]|\\](?!\\]>))+"}
	        ],
	
	        comment : [
	            {token : "comment.xml", regex : "-->", next : "start"},
	            {defaultToken : "comment.xml"}
	        ],
	
	        reference : [{
	            token : "constant.language.escape.reference.xml",
	            regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
	        }],
	
	        attr_reference : [{
	            token : "constant.language.escape.reference.attribute-value.xml",
	            regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
	        }],
	
	        tag : [{
	            token : ["meta.tag.punctuation.tag-open.xml", "meta.tag.punctuation.end-tag-open.xml", "meta.tag.tag-name.xml"],
	            regex : "(?:(<)|(</))((?:" + tagRegex + ":)?" + tagRegex + ")",
	            next: [
	                {include : "attributes"},
	                {token : "meta.tag.punctuation.tag-close.xml", regex : "/?>", next : "start"}
	            ]
	        }],
	
	        tag_whitespace : [
	            {token : "text.tag-whitespace.xml", regex : "\\s+"}
	        ],
	        whitespace : [
	            {token : "text.whitespace.xml", regex : "\\s+"}
	        ],
	        string: [{
	            token : "string.xml",
	            regex : "'",
	            push : [
	                {token : "string.xml", regex: "'", next: "pop"},
	                {defaultToken : "string.xml"}
	            ]
	        }, {
	            token : "string.xml",
	            regex : '"',
	            push : [
	                {token : "string.xml", regex: '"', next: "pop"},
	                {defaultToken : "string.xml"}
	            ]
	        }],
	
	        attributes: [{
	            token : "entity.other.attribute-name.xml",
	            regex : "(?:" + tagRegex + ":)?" + tagRegex + ""
	        }, {
	            token : "keyword.operator.attribute-equals.xml",
	            regex : "="
	        }, {
	            include: "tag_whitespace"
	        }, {
	            include: "attribute_value"
	        }],
	
	        attribute_value: [{
	            token : "string.attribute-value.xml",
	            regex : "'",
	            push : [
	                {token : "string.attribute-value.xml", regex: "'", next: "pop"},
	                {include : "attr_reference"},
	                {defaultToken : "string.attribute-value.xml"}
	            ]
	        }, {
	            token : "string.attribute-value.xml",
	            regex : '"',
	            push : [
	                {token : "string.attribute-value.xml", regex: '"', next: "pop"},
	                {include : "attr_reference"},
	                {defaultToken : "string.attribute-value.xml"}
	            ]
	        }]
	    };
	
	    if (this.constructor === XmlHighlightRules)
	        this.normalizeRules();
	};
	
	
	(function() {
	
	    this.embedTagRules = function(HighlightRules, prefix, tag){
	        this.$rules.tag.unshift({
	            token : ["meta.tag.punctuation.tag-open.xml", "meta.tag." + tag + ".tag-name.xml"],
	            regex : "(<)(" + tag + "(?=\\s|>|$))",
	            next: [
	                {include : "attributes"},
	                {token : "meta.tag.punctuation.tag-close.xml", regex : "/?>", next : prefix + "start"}
	            ]
	        });
	
	        this.$rules[tag + "-end"] = [
	            {include : "attributes"},
	            {token : "meta.tag.punctuation.tag-close.xml", regex : "/?>",  next: "start",
	                onMatch : function(value, currentState, stack) {
	                    stack.splice(0);
	                    return this.token;
	            }}
	        ]
	
	        this.embedRules(HighlightRules, prefix, [{
	            token: ["meta.tag.punctuation.end-tag-open.xml", "meta.tag." + tag + ".tag-name.xml"],
	            regex : "(</)(" + tag + "(?=\\s|>|$))",
	            next: tag + "-end"
	        }, {
	            token: "string.cdata.xml",
	            regex : "<\\!\\[CDATA\\["
	        }, {
	            token: "string.cdata.xml",
	            regex : "\\]\\]>"
	        }]);
	    };
	
	}).call(TextHighlightRules.prototype);
	
	oop.inherits(XmlHighlightRules, TextHighlightRules);
	
	exports.XmlHighlightRules = XmlHighlightRules;
	});
	
	ace.define("ace/mode/html_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/css_highlight_rules","ace/mode/javascript_highlight_rules","ace/mode/xml_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var lang = acequire("../lib/lang");
	var CssHighlightRules = acequire("./css_highlight_rules").CssHighlightRules;
	var JavaScriptHighlightRules = acequire("./javascript_highlight_rules").JavaScriptHighlightRules;
	var XmlHighlightRules = acequire("./xml_highlight_rules").XmlHighlightRules;
	
	var tagMap = lang.createMap({
	    a           : 'anchor',
	    button 	    : 'form',
	    form        : 'form',
	    img         : 'image',
	    input       : 'form',
	    label       : 'form',
	    option      : 'form',
	    script      : 'script',
	    select      : 'form',
	    textarea    : 'form',
	    style       : 'style',
	    table       : 'table',
	    tbody       : 'table',
	    td          : 'table',
	    tfoot       : 'table',
	    th          : 'table',
	    tr          : 'table'
	});
	
	var HtmlHighlightRules = function() {
	    XmlHighlightRules.call(this);
	
	    this.addRules({
	        attributes: [{
	            include : "tag_whitespace"
	        }, {
	            token : "entity.other.attribute-name.xml",
	            regex : "[-_a-zA-Z0-9:.]+"
	        }, {
	            token : "keyword.operator.attribute-equals.xml",
	            regex : "=",
	            push : [{
	                include: "tag_whitespace"
	            }, {
	                token : "string.unquoted.attribute-value.html",
	                regex : "[^<>='\"`\\s]+",
	                next : "pop"
	            }, {
	                token : "empty",
	                regex : "",
	                next : "pop"
	            }]
	        }, {
	            include : "attribute_value"
	        }],
	        tag: [{
	            token : function(start, tag) {
	                var group = tagMap[tag];
	                return ["meta.tag.punctuation." + (start == "<" ? "" : "end-") + "tag-open.xml",
	                    "meta.tag" + (group ? "." + group : "") + ".tag-name.xml"];
	            },
	            regex : "(</?)([-_a-zA-Z0-9:.]+)",
	            next: "tag_stuff"
	        }],
	        tag_stuff: [
	            {include : "attributes"},
	            {token : "meta.tag.punctuation.tag-close.xml", regex : "/?>", next : "start"}
	        ]
	    });
	
	    this.embedTagRules(CssHighlightRules, "css-", "style");
	    this.embedTagRules(new JavaScriptHighlightRules({jsx: false}).getRules(), "js-", "script");
	
	    if (this.constructor === HtmlHighlightRules)
	        this.normalizeRules();
	};
	
	oop.inherits(HtmlHighlightRules, XmlHighlightRules);
	
	exports.HtmlHighlightRules = HtmlHighlightRules;
	});
	
	ace.define("ace/mode/behaviour/xml",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Behaviour = acequire("../behaviour").Behaviour;
	var TokenIterator = acequire("../../token_iterator").TokenIterator;
	var lang = acequire("../../lib/lang");
	
	function is(token, type) {
	    return token.type.lastIndexOf(type + ".xml") > -1;
	}
	
	var XmlBehaviour = function () {
	
	    this.add("string_dquotes", "insertion", function (state, action, editor, session, text) {
	        if (text == '"' || text == "'") {
	            var quote = text;
	            var selected = session.doc.getTextRange(editor.getSelectionRange());
	            if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) {
	                return {
	                    text: quote + selected + quote,
	                    selection: false
	                };
	            }
	
	            var cursor = editor.getCursorPosition();
	            var line = session.doc.getLine(cursor.row);
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            var iterator = new TokenIterator(session, cursor.row, cursor.column);
	            var token = iterator.getCurrentToken();
	
	            if (rightChar == quote && (is(token, "attribute-value") || is(token, "string"))) {
	                return {
	                    text: "",
	                    selection: [1, 1]
	                };
	            }
	
	            if (!token)
	                token = iterator.stepBackward();
	
	            if (!token)
	                return;
	
	            while (is(token, "tag-whitespace") || is(token, "whitespace")) {
	                token = iterator.stepBackward();
	            }
	            var rightSpace = !rightChar || rightChar.match(/\s/);
	            if (is(token, "attribute-equals") && (rightSpace || rightChar == '>') || (is(token, "decl-attribute-equals") && (rightSpace || rightChar == '?'))) {
	                return {
	                    text: quote + quote,
	                    selection: [1, 1]
	                };
	            }
	        }
	    });
	
	    this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
	            var line = session.doc.getLine(range.start.row);
	            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
	            if (rightChar == selected) {
	                range.end.column++;
	                return range;
	            }
	        }
	    });
	
	    this.add("autoclosing", "insertion", function (state, action, editor, session, text) {
	        if (text == '>') {
	            var position = editor.getSelectionRange().start;
	            var iterator = new TokenIterator(session, position.row, position.column);
	            var token = iterator.getCurrentToken() || iterator.stepBackward();
	            if (!token || !(is(token, "tag-name") || is(token, "tag-whitespace") || is(token, "attribute-name") || is(token, "attribute-equals") || is(token, "attribute-value")))
	                return;
	            if (is(token, "reference.attribute-value"))
	                return;
	            if (is(token, "attribute-value")) {
	                var firstChar = token.value.charAt(0);
	                if (firstChar == '"' || firstChar == "'") {
	                    var lastChar = token.value.charAt(token.value.length - 1);
	                    var tokenEnd = iterator.getCurrentTokenColumn() + token.value.length;
	                    if (tokenEnd > position.column || tokenEnd == position.column && firstChar != lastChar)
	                        return;
	                }
	            }
	            while (!is(token, "tag-name")) {
	                token = iterator.stepBackward();
	                if (token.value == "<") {
	                    token = iterator.stepForward();
	                    break;
	                }
	            }
	
	            var tokenRow = iterator.getCurrentTokenRow();
	            var tokenColumn = iterator.getCurrentTokenColumn();
	            if (is(iterator.stepBackward(), "end-tag-open"))
	                return;
	
	            var element = token.value;
	            if (tokenRow == position.row)
	                element = element.substring(0, position.column - tokenColumn);
	
	            if (this.voidElements.hasOwnProperty(element.toLowerCase()))
	                 return;
	
	            return {
	               text: ">" + "</" + element + ">",
	               selection: [1, 1]
	            };
	        }
	    });
	
	    this.add("autoindent", "insertion", function (state, action, editor, session, text) {
	        if (text == "\n") {
	            var cursor = editor.getCursorPosition();
	            var line = session.getLine(cursor.row);
	            var iterator = new TokenIterator(session, cursor.row, cursor.column);
	            var token = iterator.getCurrentToken();
	
	            if (token && token.type.indexOf("tag-close") !== -1) {
	                if (token.value == "/>")
	                    return;
	                while (token && token.type.indexOf("tag-name") === -1) {
	                    token = iterator.stepBackward();
	                }
	
	                if (!token) {
	                    return;
	                }
	
	                var tag = token.value;
	                var row = iterator.getCurrentTokenRow();
	                token = iterator.stepBackward();
	                if (!token || token.type.indexOf("end-tag") !== -1) {
	                    return;
	                }
	
	                if (this.voidElements && !this.voidElements[tag]) {
	                    var nextToken = session.getTokenAt(cursor.row, cursor.column+1);
	                    var line = session.getLine(row);
	                    var nextIndent = this.$getIndent(line);
	                    var indent = nextIndent + session.getTabString();
	
	                    if (nextToken && nextToken.value === "</") {
	                        return {
	                            text: "\n" + indent + "\n" + nextIndent,
	                            selection: [1, indent.length, 1, indent.length]
	                        };
	                    } else {
	                        return {
	                            text: "\n" + indent
	                        };
	                    }
	                }
	            }
	        }
	    });
	
	};
	
	oop.inherits(XmlBehaviour, Behaviour);
	
	exports.XmlBehaviour = XmlBehaviour;
	});
	
	ace.define("ace/mode/folding/mixed",["require","exports","module","ace/lib/oop","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var BaseFoldMode = acequire("./fold_mode").FoldMode;
	
	var FoldMode = exports.FoldMode = function(defaultMode, subModes) {
	    this.defaultMode = defaultMode;
	    this.subModes = subModes;
	};
	oop.inherits(FoldMode, BaseFoldMode);
	
	(function() {
	
	
	    this.$getMode = function(state) {
	        if (typeof state != "string") 
	            state = state[0];
	        for (var key in this.subModes) {
	            if (state.indexOf(key) === 0)
	                return this.subModes[key];
	        }
	        return null;
	    };
	    
	    this.$tryMode = function(state, session, foldStyle, row) {
	        var mode = this.$getMode(state);
	        return (mode ? mode.getFoldWidget(session, foldStyle, row) : "");
	    };
	
	    this.getFoldWidget = function(session, foldStyle, row) {
	        return (
	            this.$tryMode(session.getState(row-1), session, foldStyle, row) ||
	            this.$tryMode(session.getState(row), session, foldStyle, row) ||
	            this.defaultMode.getFoldWidget(session, foldStyle, row)
	        );
	    };
	
	    this.getFoldWidgetRange = function(session, foldStyle, row) {
	        var mode = this.$getMode(session.getState(row-1));
	        
	        if (!mode || !mode.getFoldWidget(session, foldStyle, row))
	            mode = this.$getMode(session.getState(row));
	        
	        if (!mode || !mode.getFoldWidget(session, foldStyle, row))
	            mode = this.defaultMode;
	        
	        return mode.getFoldWidgetRange(session, foldStyle, row);
	    };
	
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/mode/folding/xml",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/range","ace/mode/folding/fold_mode","ace/token_iterator"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var lang = acequire("../../lib/lang");
	var Range = acequire("../../range").Range;
	var BaseFoldMode = acequire("./fold_mode").FoldMode;
	var TokenIterator = acequire("../../token_iterator").TokenIterator;
	
	var FoldMode = exports.FoldMode = function(voidElements, optionalEndTags) {
	    BaseFoldMode.call(this);
	    this.voidElements = voidElements || {};
	    this.optionalEndTags = oop.mixin({}, this.voidElements);
	    if (optionalEndTags)
	        oop.mixin(this.optionalEndTags, optionalEndTags);
	    
	};
	oop.inherits(FoldMode, BaseFoldMode);
	
	var Tag = function() {
	    this.tagName = "";
	    this.closing = false;
	    this.selfClosing = false;
	    this.start = {row: 0, column: 0};
	    this.end = {row: 0, column: 0};
	};
	
	function is(token, type) {
	    return token.type.lastIndexOf(type + ".xml") > -1;
	}
	
	(function() {
	
	    this.getFoldWidget = function(session, foldStyle, row) {
	        var tag = this._getFirstTagInLine(session, row);
	
	        if (!tag)
	            return "";
	
	        if (tag.closing || (!tag.tagName && tag.selfClosing))
	            return foldStyle == "markbeginend" ? "end" : "";
	
	        if (!tag.tagName || tag.selfClosing || this.voidElements.hasOwnProperty(tag.tagName.toLowerCase()))
	            return "";
	
	        if (this._findEndTagInLine(session, row, tag.tagName, tag.end.column))
	            return "";
	
	        return "start";
	    };
	    this._getFirstTagInLine = function(session, row) {
	        var tokens = session.getTokens(row);
	        var tag = new Tag();
	
	        for (var i = 0; i < tokens.length; i++) {
	            var token = tokens[i];
	            if (is(token, "tag-open")) {
	                tag.end.column = tag.start.column + token.value.length;
	                tag.closing = is(token, "end-tag-open");
	                token = tokens[++i];
	                if (!token)
	                    return null;
	                tag.tagName = token.value;
	                tag.end.column += token.value.length;
	                for (i++; i < tokens.length; i++) {
	                    token = tokens[i];
	                    tag.end.column += token.value.length;
	                    if (is(token, "tag-close")) {
	                        tag.selfClosing = token.value == '/>';
	                        break;
	                    }
	                }
	                return tag;
	            } else if (is(token, "tag-close")) {
	                tag.selfClosing = token.value == '/>';
	                return tag;
	            }
	            tag.start.column += token.value.length;
	        }
	
	        return null;
	    };
	
	    this._findEndTagInLine = function(session, row, tagName, startColumn) {
	        var tokens = session.getTokens(row);
	        var column = 0;
	        for (var i = 0; i < tokens.length; i++) {
	            var token = tokens[i];
	            column += token.value.length;
	            if (column < startColumn)
	                continue;
	            if (is(token, "end-tag-open")) {
	                token = tokens[i + 1];
	                if (token && token.value == tagName)
	                    return true;
	            }
	        }
	        return false;
	    };
	    this._readTagForward = function(iterator) {
	        var token = iterator.getCurrentToken();
	        if (!token)
	            return null;
	
	        var tag = new Tag();
	        do {
	            if (is(token, "tag-open")) {
	                tag.closing = is(token, "end-tag-open");
	                tag.start.row = iterator.getCurrentTokenRow();
	                tag.start.column = iterator.getCurrentTokenColumn();
	            } else if (is(token, "tag-name")) {
	                tag.tagName = token.value;
	            } else if (is(token, "tag-close")) {
	                tag.selfClosing = token.value == "/>";
	                tag.end.row = iterator.getCurrentTokenRow();
	                tag.end.column = iterator.getCurrentTokenColumn() + token.value.length;
	                iterator.stepForward();
	                return tag;
	            }
	        } while(token = iterator.stepForward());
	
	        return null;
	    };
	    
	    this._readTagBackward = function(iterator) {
	        var token = iterator.getCurrentToken();
	        if (!token)
	            return null;
	
	        var tag = new Tag();
	        do {
	            if (is(token, "tag-open")) {
	                tag.closing = is(token, "end-tag-open");
	                tag.start.row = iterator.getCurrentTokenRow();
	                tag.start.column = iterator.getCurrentTokenColumn();
	                iterator.stepBackward();
	                return tag;
	            } else if (is(token, "tag-name")) {
	                tag.tagName = token.value;
	            } else if (is(token, "tag-close")) {
	                tag.selfClosing = token.value == "/>";
	                tag.end.row = iterator.getCurrentTokenRow();
	                tag.end.column = iterator.getCurrentTokenColumn() + token.value.length;
	            }
	        } while(token = iterator.stepBackward());
	
	        return null;
	    };
	    
	    this._pop = function(stack, tag) {
	        while (stack.length) {
	            
	            var top = stack[stack.length-1];
	            if (!tag || top.tagName == tag.tagName) {
	                return stack.pop();
	            }
	            else if (this.optionalEndTags.hasOwnProperty(top.tagName)) {
	                stack.pop();
	                continue;
	            } else {
	                return null;
	            }
	        }
	    };
	    
	    this.getFoldWidgetRange = function(session, foldStyle, row) {
	        var firstTag = this._getFirstTagInLine(session, row);
	        
	        if (!firstTag)
	            return null;
	        
	        var isBackward = firstTag.closing || firstTag.selfClosing;
	        var stack = [];
	        var tag;
	        
	        if (!isBackward) {
	            var iterator = new TokenIterator(session, row, firstTag.start.column);
	            var start = {
	                row: row,
	                column: firstTag.start.column + firstTag.tagName.length + 2
	            };
	            if (firstTag.start.row == firstTag.end.row)
	                start.column = firstTag.end.column;
	            while (tag = this._readTagForward(iterator)) {
	                if (tag.selfClosing) {
	                    if (!stack.length) {
	                        tag.start.column += tag.tagName.length + 2;
	                        tag.end.column -= 2;
	                        return Range.fromPoints(tag.start, tag.end);
	                    } else
	                        continue;
	                }
	                
	                if (tag.closing) {
	                    this._pop(stack, tag);
	                    if (stack.length == 0)
	                        return Range.fromPoints(start, tag.start);
	                }
	                else {
	                    stack.push(tag);
	                }
	            }
	        }
	        else {
	            var iterator = new TokenIterator(session, row, firstTag.end.column);
	            var end = {
	                row: row,
	                column: firstTag.start.column
	            };
	            
	            while (tag = this._readTagBackward(iterator)) {
	                if (tag.selfClosing) {
	                    if (!stack.length) {
	                        tag.start.column += tag.tagName.length + 2;
	                        tag.end.column -= 2;
	                        return Range.fromPoints(tag.start, tag.end);
	                    } else
	                        continue;
	                }
	                
	                if (!tag.closing) {
	                    this._pop(stack, tag);
	                    if (stack.length == 0) {
	                        tag.start.column += tag.tagName.length + 2;
	                        if (tag.start.row == tag.end.row && tag.start.column < tag.end.column)
	                            tag.start.column = tag.end.column;
	                        return Range.fromPoints(tag.start, end);
	                    }
	                }
	                else {
	                    stack.push(tag);
	                }
	            }
	        }
	        
	    };
	
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/mode/folding/html",["require","exports","module","ace/lib/oop","ace/mode/folding/mixed","ace/mode/folding/xml","ace/mode/folding/cstyle"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var MixedFoldMode = acequire("./mixed").FoldMode;
	var XmlFoldMode = acequire("./xml").FoldMode;
	var CStyleFoldMode = acequire("./cstyle").FoldMode;
	
	var FoldMode = exports.FoldMode = function(voidElements, optionalTags) {
	    MixedFoldMode.call(this, new XmlFoldMode(voidElements, optionalTags), {
	        "js-": new CStyleFoldMode(),
	        "css-": new CStyleFoldMode()
	    });
	};
	
	oop.inherits(FoldMode, MixedFoldMode);
	
	});
	
	ace.define("ace/mode/html_completions",["require","exports","module","ace/token_iterator"], function(acequire, exports, module) {
	"use strict";
	
	var TokenIterator = acequire("../token_iterator").TokenIterator;
	
	var commonAttributes = [
	    "accesskey",
	    "class",
	    "contenteditable",
	    "contextmenu",
	    "dir",
	    "draggable",
	    "dropzone",
	    "hidden",
	    "id",
	    "inert",
	    "itemid",
	    "itemprop",
	    "itemref",
	    "itemscope",
	    "itemtype",
	    "lang",
	    "spellcheck",
	    "style",
	    "tabindex",
	    "title",
	    "translate"
	];
	
	var eventAttributes = [
	    "onabort",
	    "onblur",
	    "oncancel",
	    "oncanplay",
	    "oncanplaythrough",
	    "onchange",
	    "onclick",
	    "onclose",
	    "oncontextmenu",
	    "oncuechange",
	    "ondblclick",
	    "ondrag",
	    "ondragend",
	    "ondragenter",
	    "ondragleave",
	    "ondragover",
	    "ondragstart",
	    "ondrop",
	    "ondurationchange",
	    "onemptied",
	    "onended",
	    "onerror",
	    "onfocus",
	    "oninput",
	    "oninvalid",
	    "onkeydown",
	    "onkeypress",
	    "onkeyup",
	    "onload",
	    "onloadeddata",
	    "onloadedmetadata",
	    "onloadstart",
	    "onmousedown",
	    "onmousemove",
	    "onmouseout",
	    "onmouseover",
	    "onmouseup",
	    "onmousewheel",
	    "onpause",
	    "onplay",
	    "onplaying",
	    "onprogress",
	    "onratechange",
	    "onreset",
	    "onscroll",
	    "onseeked",
	    "onseeking",
	    "onselect",
	    "onshow",
	    "onstalled",
	    "onsubmit",
	    "onsuspend",
	    "ontimeupdate",
	    "onvolumechange",
	    "onwaiting"
	];
	
	var globalAttributes = commonAttributes.concat(eventAttributes);
	
	var attributeMap = {
	    "html": {"manifest": 1},
	    "head": {},
	    "title": {},
	    "base": {"href": 1, "target": 1},
	    "link": {"href": 1, "hreflang": 1, "rel": {"stylesheet": 1, "icon": 1}, "media": {"all": 1, "screen": 1, "print": 1}, "type": {"text/css": 1, "image/png": 1, "image/jpeg": 1, "image/gif": 1}, "sizes": 1},
	    "meta": {"http-equiv": {"content-type": 1}, "name": {"description": 1, "keywords": 1}, "content": {"text/html; charset=UTF-8": 1}, "charset": 1},
	    "style": {"type": 1, "media": {"all": 1, "screen": 1, "print": 1}, "scoped": 1},
	    "script": {"charset": 1, "type": {"text/javascript": 1}, "src": 1, "defer": 1, "async": 1},
	    "noscript": {"href": 1},
	    "body": {"onafterprint": 1, "onbeforeprint": 1, "onbeforeunload": 1, "onhashchange": 1, "onmessage": 1, "onoffline": 1, "onpopstate": 1, "onredo": 1, "onresize": 1, "onstorage": 1, "onundo": 1, "onunload": 1},
	    "section": {},
	    "nav": {},
	    "article": {"pubdate": 1},
	    "aside": {},
	    "h1": {},
	    "h2": {},
	    "h3": {},
	    "h4": {},
	    "h5": {},
	    "h6": {},
	    "header": {},
	    "footer": {},
	    "address": {},
	    "main": {},
	    "p": {},
	    "hr": {},
	    "pre": {},
	    "blockquote": {"cite": 1},
	    "ol": {"start": 1, "reversed": 1},
	    "ul": {},
	    "li": {"value": 1},
	    "dl": {},
	    "dt": {},
	    "dd": {},
	    "figure": {},
	    "figcaption": {},
	    "div": {},
	    "a": {"href": 1, "target": {"_blank": 1, "top": 1}, "ping": 1, "rel": {"nofollow": 1, "alternate": 1, "author": 1, "bookmark": 1, "help": 1, "license": 1, "next": 1, "noreferrer": 1, "prefetch": 1, "prev": 1, "search": 1, "tag": 1}, "media": 1, "hreflang": 1, "type": 1},
	    "em": {},
	    "strong": {},
	    "small": {},
	    "s": {},
	    "cite": {},
	    "q": {"cite": 1},
	    "dfn": {},
	    "abbr": {},
	    "data": {},
	    "time": {"datetime": 1},
	    "code": {},
	    "var": {},
	    "samp": {},
	    "kbd": {},
	    "sub": {},
	    "sup": {},
	    "i": {},
	    "b": {},
	    "u": {},
	    "mark": {},
	    "ruby": {},
	    "rt": {},
	    "rp": {},
	    "bdi": {},
	    "bdo": {},
	    "span": {},
	    "br": {},
	    "wbr": {},
	    "ins": {"cite": 1, "datetime": 1},
	    "del": {"cite": 1, "datetime": 1},
	    "img": {"alt": 1, "src": 1, "height": 1, "width": 1, "usemap": 1, "ismap": 1},
	    "iframe": {"name": 1, "src": 1, "height": 1, "width": 1, "sandbox": {"allow-same-origin": 1, "allow-top-navigation": 1, "allow-forms": 1, "allow-scripts": 1}, "seamless": {"seamless": 1}},
	    "embed": {"src": 1, "height": 1, "width": 1, "type": 1},
	    "object": {"param": 1, "data": 1, "type": 1, "height" : 1, "width": 1, "usemap": 1, "name": 1, "form": 1, "classid": 1},
	    "param": {"name": 1, "value": 1},
	    "video": {"src": 1, "autobuffer": 1, "autoplay": {"autoplay": 1}, "loop": {"loop": 1}, "controls": {"controls": 1}, "width": 1, "height": 1, "poster": 1, "muted": {"muted": 1}, "preload": {"auto": 1, "metadata": 1, "none": 1}},
	    "audio": {"src": 1, "autobuffer": 1, "autoplay": {"autoplay": 1}, "loop": {"loop": 1}, "controls": {"controls": 1}, "muted": {"muted": 1}, "preload": {"auto": 1, "metadata": 1, "none": 1 }},
	    "source": {"src": 1, "type": 1, "media": 1},
	    "track": {"kind": 1, "src": 1, "srclang": 1, "label": 1, "default": 1},
	    "canvas": {"width": 1, "height": 1},
	    "map": {"name": 1},
	    "area": {"shape": 1, "coords": 1, "href": 1, "hreflang": 1, "alt": 1, "target": 1, "media": 1, "rel": 1, "ping": 1, "type": 1},
	    "svg": {},
	    "math": {},
	    "table": {"summary": 1},
	    "caption": {},
	    "colgroup": {"span": 1},
	    "col": {"span": 1},
	    "tbody": {},
	    "thead": {},
	    "tfoot": {},
	    "tr": {},
	    "td": {"headers": 1, "rowspan": 1, "colspan": 1},
	    "th": {"headers": 1, "rowspan": 1, "colspan": 1, "scope": 1},
	    "form": {"accept-charset": 1, "action": 1, "autocomplete": 1, "enctype": {"multipart/form-data": 1, "application/x-www-form-urlencoded": 1}, "method": {"get": 1, "post": 1}, "name": 1, "novalidate": 1, "target": {"_blank": 1, "top": 1}},
	    "fieldset": {"disabled": 1, "form": 1, "name": 1},
	    "legend": {},
	    "label": {"form": 1, "for": 1},
	    "input": {
	        "type": {"text": 1, "password": 1, "hidden": 1, "checkbox": 1, "submit": 1, "radio": 1, "file": 1, "button": 1, "reset": 1, "image": 31, "color": 1, "date": 1, "datetime": 1, "datetime-local": 1, "email": 1, "month": 1, "number": 1, "range": 1, "search": 1, "tel": 1, "time": 1, "url": 1, "week": 1},
	        "accept": 1, "alt": 1, "autocomplete": {"on": 1, "off": 1}, "autofocus": {"autofocus": 1}, "checked": {"checked": 1}, "disabled": {"disabled": 1}, "form": 1, "formaction": 1, "formenctype": {"application/x-www-form-urlencoded": 1, "multipart/form-data": 1, "text/plain": 1}, "formmethod": {"get": 1, "post": 1}, "formnovalidate": {"formnovalidate": 1}, "formtarget": {"_blank": 1, "_self": 1, "_parent": 1, "_top": 1}, "height": 1, "list": 1, "max": 1, "maxlength": 1, "min": 1, "multiple": {"multiple": 1}, "name": 1, "pattern": 1, "placeholder": 1, "readonly": {"readonly": 1}, "acequired": {"acequired": 1}, "size": 1, "src": 1, "step": 1, "width": 1, "files": 1, "value": 1},
	    "button": {"autofocus": 1, "disabled": {"disabled": 1}, "form": 1, "formaction": 1, "formenctype": 1, "formmethod": 1, "formnovalidate": 1, "formtarget": 1, "name": 1, "value": 1, "type": {"button": 1, "submit": 1}},
	    "select": {"autofocus": 1, "disabled": 1, "form": 1, "multiple": {"multiple": 1}, "name": 1, "size": 1, "readonly":{"readonly": 1}},
	    "datalist": {},
	    "optgroup": {"disabled": 1, "label": 1},
	    "option": {"disabled": 1, "selected": 1, "label": 1, "value": 1},
	    "textarea": {"autofocus": {"autofocus": 1}, "disabled": {"disabled": 1}, "form": 1, "maxlength": 1, "name": 1, "placeholder": 1, "readonly": {"readonly": 1}, "acequired": {"acequired": 1}, "rows": 1, "cols": 1, "wrap": {"on": 1, "off": 1, "hard": 1, "soft": 1}},
	    "keygen": {"autofocus": 1, "challenge": {"challenge": 1}, "disabled": {"disabled": 1}, "form": 1, "keytype": {"rsa": 1, "dsa": 1, "ec": 1}, "name": 1},
	    "output": {"for": 1, "form": 1, "name": 1},
	    "progress": {"value": 1, "max": 1},
	    "meter": {"value": 1, "min": 1, "max": 1, "low": 1, "high": 1, "optimum": 1},
	    "details": {"open": 1},
	    "summary": {},
	    "command": {"type": 1, "label": 1, "icon": 1, "disabled": 1, "checked": 1, "radiogroup": 1, "command": 1},
	    "menu": {"type": 1, "label": 1},
	    "dialog": {"open": 1}
	};
	
	var elements = Object.keys(attributeMap);
	
	function is(token, type) {
	    return token.type.lastIndexOf(type + ".xml") > -1;
	}
	
	function findTagName(session, pos) {
	    var iterator = new TokenIterator(session, pos.row, pos.column);
	    var token = iterator.getCurrentToken();
	    while (token && !is(token, "tag-name")){
	        token = iterator.stepBackward();
	    }
	    if (token)
	        return token.value;
	}
	
	function findAttributeName(session, pos) {
	    var iterator = new TokenIterator(session, pos.row, pos.column);
	    var token = iterator.getCurrentToken();
	    while (token && !is(token, "attribute-name")){
	        token = iterator.stepBackward();
	    }
	    if (token)
	        return token.value;
	}
	
	var HtmlCompletions = function() {
	
	};
	
	(function() {
	
	    this.getCompletions = function(state, session, pos, prefix) {
	        var token = session.getTokenAt(pos.row, pos.column);
	
	        if (!token)
	            return [];
	        if (is(token, "tag-name") || is(token, "tag-open") || is(token, "end-tag-open"))
	            return this.getTagCompletions(state, session, pos, prefix);
	        if (is(token, "tag-whitespace") || is(token, "attribute-name"))
	            return this.getAttributeCompletions(state, session, pos, prefix);
	        if (is(token, "attribute-value"))
	            return this.getAttributeValueCompletions(state, session, pos, prefix);
	        var line = session.getLine(pos.row).substr(0, pos.column);
	        if (/&[a-z]*$/i.test(line))
	            return this.getHTMLEntityCompletions(state, session, pos, prefix);
	
	        return [];
	    };
	
	    this.getTagCompletions = function(state, session, pos, prefix) {
	        return elements.map(function(element){
	            return {
	                value: element,
	                meta: "tag",
	                score: Number.MAX_VALUE
	            };
	        });
	    };
	
	    this.getAttributeCompletions = function(state, session, pos, prefix) {
	        var tagName = findTagName(session, pos);
	        if (!tagName)
	            return [];
	        var attributes = globalAttributes;
	        if (tagName in attributeMap) {
	            attributes = attributes.concat(Object.keys(attributeMap[tagName]));
	        }
	        return attributes.map(function(attribute){
	            return {
	                caption: attribute,
	                snippet: attribute + '="$0"',
	                meta: "attribute",
	                score: Number.MAX_VALUE
	            };
	        });
	    };
	
	    this.getAttributeValueCompletions = function(state, session, pos, prefix) {
	        var tagName = findTagName(session, pos);
	        var attributeName = findAttributeName(session, pos);
	        
	        if (!tagName)
	            return [];
	        var values = [];
	        if (tagName in attributeMap && attributeName in attributeMap[tagName] && typeof attributeMap[tagName][attributeName] === "object") {
	            values = Object.keys(attributeMap[tagName][attributeName]);
	        }
	        return values.map(function(value){
	            return {
	                caption: value,
	                snippet: value,
	                meta: "attribute value",
	                score: Number.MAX_VALUE
	            };
	        });
	    };
	
	    this.getHTMLEntityCompletions = function(state, session, pos, prefix) {
	        var values = ['Aacute;', 'aacute;', 'Acirc;', 'acirc;', 'acute;', 'AElig;', 'aelig;', 'Agrave;', 'agrave;', 'alefsym;', 'Alpha;', 'alpha;', 'amp;', 'and;', 'ang;', 'Aring;', 'aring;', 'asymp;', 'Atilde;', 'atilde;', 'Auml;', 'auml;', 'bdquo;', 'Beta;', 'beta;', 'brvbar;', 'bull;', 'cap;', 'Ccedil;', 'ccedil;', 'cedil;', 'cent;', 'Chi;', 'chi;', 'circ;', 'clubs;', 'cong;', 'copy;', 'crarr;', 'cup;', 'curren;', 'Dagger;', 'dagger;', 'dArr;', 'darr;', 'deg;', 'Delta;', 'delta;', 'diams;', 'divide;', 'Eacute;', 'eacute;', 'Ecirc;', 'ecirc;', 'Egrave;', 'egrave;', 'empty;', 'emsp;', 'ensp;', 'Epsilon;', 'epsilon;', 'equiv;', 'Eta;', 'eta;', 'ETH;', 'eth;', 'Euml;', 'euml;', 'euro;', 'exist;', 'fnof;', 'forall;', 'frac12;', 'frac14;', 'frac34;', 'frasl;', 'Gamma;', 'gamma;', 'ge;', 'gt;', 'hArr;', 'harr;', 'hearts;', 'hellip;', 'Iacute;', 'iacute;', 'Icirc;', 'icirc;', 'iexcl;', 'Igrave;', 'igrave;', 'image;', 'infin;', 'int;', 'Iota;', 'iota;', 'iquest;', 'isin;', 'Iuml;', 'iuml;', 'Kappa;', 'kappa;', 'Lambda;', 'lambda;', 'lang;', 'laquo;', 'lArr;', 'larr;', 'lceil;', 'ldquo;', 'le;', 'lfloor;', 'lowast;', 'loz;', 'lrm;', 'lsaquo;', 'lsquo;', 'lt;', 'macr;', 'mdash;', 'micro;', 'middot;', 'minus;', 'Mu;', 'mu;', 'nabla;', 'nbsp;', 'ndash;', 'ne;', 'ni;', 'not;', 'notin;', 'nsub;', 'Ntilde;', 'ntilde;', 'Nu;', 'nu;', 'Oacute;', 'oacute;', 'Ocirc;', 'ocirc;', 'OElig;', 'oelig;', 'Ograve;', 'ograve;', 'oline;', 'Omega;', 'omega;', 'Omicron;', 'omicron;', 'oplus;', 'or;', 'ordf;', 'ordm;', 'Oslash;', 'oslash;', 'Otilde;', 'otilde;', 'otimes;', 'Ouml;', 'ouml;', 'para;', 'part;', 'permil;', 'perp;', 'Phi;', 'phi;', 'Pi;', 'pi;', 'piv;', 'plusmn;', 'pound;', 'Prime;', 'prime;', 'prod;', 'prop;', 'Psi;', 'psi;', 'quot;', 'radic;', 'rang;', 'raquo;', 'rArr;', 'rarr;', 'rceil;', 'rdquo;', 'real;', 'reg;', 'rfloor;', 'Rho;', 'rho;', 'rlm;', 'rsaquo;', 'rsquo;', 'sbquo;', 'Scaron;', 'scaron;', 'sdot;', 'sect;', 'shy;', 'Sigma;', 'sigma;', 'sigmaf;', 'sim;', 'spades;', 'sub;', 'sube;', 'sum;', 'sup;', 'sup1;', 'sup2;', 'sup3;', 'supe;', 'szlig;', 'Tau;', 'tau;', 'there4;', 'Theta;', 'theta;', 'thetasym;', 'thinsp;', 'THORN;', 'thorn;', 'tilde;', 'times;', 'trade;', 'Uacute;', 'uacute;', 'uArr;', 'uarr;', 'Ucirc;', 'ucirc;', 'Ugrave;', 'ugrave;', 'uml;', 'upsih;', 'Upsilon;', 'upsilon;', 'Uuml;', 'uuml;', 'weierp;', 'Xi;', 'xi;', 'Yacute;', 'yacute;', 'yen;', 'Yuml;', 'yuml;', 'Zeta;', 'zeta;', 'zwj;', 'zwnj;'];
	
	        return values.map(function(value){
	            return {
	                caption: value,
	                snippet: value,
	                meta: "html entity",
	                score: Number.MAX_VALUE
	            };
	        });
	    };
	
	}).call(HtmlCompletions.prototype);
	
	exports.HtmlCompletions = HtmlCompletions;
	});
	
	ace.define("ace/mode/html",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text","ace/mode/javascript","ace/mode/css","ace/mode/html_highlight_rules","ace/mode/behaviour/xml","ace/mode/folding/html","ace/mode/html_completions","ace/worker/worker_client"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var lang = acequire("../lib/lang");
	var TextMode = acequire("./text").Mode;
	var JavaScriptMode = acequire("./javascript").Mode;
	var CssMode = acequire("./css").Mode;
	var HtmlHighlightRules = acequire("./html_highlight_rules").HtmlHighlightRules;
	var XmlBehaviour = acequire("./behaviour/xml").XmlBehaviour;
	var HtmlFoldMode = acequire("./folding/html").FoldMode;
	var HtmlCompletions = acequire("./html_completions").HtmlCompletions;
	var WorkerClient = acequire("../worker/worker_client").WorkerClient;
	var voidElements = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "meta", "menuitem", "param", "source", "track", "wbr"];
	var optionalEndTags = ["li", "dt", "dd", "p", "rt", "rp", "optgroup", "option", "colgroup", "td", "th"];
	
	var Mode = function(options) {
	    this.fragmentContext = options && options.fragmentContext;
	    this.HighlightRules = HtmlHighlightRules;
	    this.$behaviour = new XmlBehaviour();
	    this.$completer = new HtmlCompletions();
	    
	    this.createModeDelegates({
	        "js-": JavaScriptMode,
	        "css-": CssMode
	    });
	    
	    this.foldingRules = new HtmlFoldMode(this.voidElements, lang.arrayToMap(optionalEndTags));
	};
	oop.inherits(Mode, TextMode);
	
	(function() {
	
	    this.blockComment = {start: "<!--", end: "-->"};
	
	    this.voidElements = lang.arrayToMap(voidElements);
	
	    this.getNextLineIndent = function(state, line, tab) {
	        return this.$getIndent(line);
	    };
	
	    this.checkOutdent = function(state, line, input) {
	        return false;
	    };
	
	    this.getCompletions = function(state, session, pos, prefix) {
	        return this.$completer.getCompletions(state, session, pos, prefix);
	    };
	
	    this.createWorker = function(session) {
	        if (this.constructor != Mode)
	            return;
	        var worker = new WorkerClient(["ace"], __webpack_require__(652), "Worker");
	        worker.attachToDocument(session.getDocument());
	
	        if (this.fragmentContext)
	            worker.call("setOptions", [{context: this.fragmentContext}]);
	
	        worker.on("error", function(e) {
	            session.setAnnotations(e.data);
	        });
	
	        worker.on("terminate", function() {
	            session.clearAnnotations();
	        });
	
	        return worker;
	    };
	
	    this.$id = "ace/mode/html";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	
	var DocCommentHighlightRules = function() {
	    this.$rules = {
	        "start" : [ {
	            token : "comment.doc.tag",
	            regex : "@[\\w\\d_]+" // TODO: fix email addresses
	        }, 
	        DocCommentHighlightRules.getTagRule(),
	        {
	            defaultToken : "comment.doc",
	            caseInsensitive: true
	        }]
	    };
	};
	
	oop.inherits(DocCommentHighlightRules, TextHighlightRules);
	
	DocCommentHighlightRules.getTagRule = function(start) {
	    return {
	        token : "comment.doc.tag.storage.type",
	        regex : "\\b(?:TODO|FIXME|XXX|HACK)\\b"
	    };
	}
	
	DocCommentHighlightRules.getStartRule = function(start) {
	    return {
	        token : "comment.doc", // doc comment
	        regex : "\\/\\*(?=\\*)",
	        next  : start
	    };
	};
	
	DocCommentHighlightRules.getEndRule = function (start) {
	    return {
	        token : "comment.doc", // closing comment
	        regex : "\\*\\/",
	        next  : start
	    };
	};
	
	
	exports.DocCommentHighlightRules = DocCommentHighlightRules;
	
	});
	
	ace.define("ace/mode/javascript_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	var identifierRe = "[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*";
	
	var JavaScriptHighlightRules = function(options) {
	    var keywordMapper = this.createKeywordMapper({
	        "variable.language":
	            "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|"  + // Constructors
	            "Namespace|QName|XML|XMLList|"                                             + // E4X
	            "ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|"   +
	            "Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|"                    +
	            "Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|"   + // Errors
	            "SyntaxError|TypeError|URIError|"                                          +
	            "decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|" + // Non-constructor functions
	            "isNaN|parseFloat|parseInt|"                                               +
	            "JSON|Math|"                                                               + // Other
	            "this|arguments|prototype|window|document"                                 , // Pseudo
	        "keyword":
	            "const|yield|import|get|set|async|await|" +
	            "break|case|catch|continue|default|delete|do|else|finally|for|function|" +
	            "if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|" +
	            "__parent__|__count__|escape|unescape|with|__proto__|" +
	            "class|enum|extends|super|export|implements|private|public|interface|package|protected|static",
	        "storage.type":
	            "const|let|var|function",
	        "constant.language":
	            "null|Infinity|NaN|undefined",
	        "support.function":
	            "alert",
	        "constant.language.boolean": "true|false"
	    }, "identifier");
	    var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
	
	    var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|" + // hex
	        "u[0-9a-fA-F]{4}|" + // unicode
	        "u{[0-9a-fA-F]{1,6}}|" + // es6 unicode
	        "[0-2][0-7]{0,2}|" + // oct
	        "3[0-7][0-7]?|" + // oct
	        "[4-7][0-7]?|" + //oct
	        ".)";
	
	    this.$rules = {
	        "no_regex" : [
	            DocCommentHighlightRules.getStartRule("doc-start"),
	            comments("no_regex"),
	            {
	                token : "string",
	                regex : "'(?=.)",
	                next  : "qstring"
	            }, {
	                token : "string",
	                regex : '"(?=.)',
	                next  : "qqstring"
	            }, {
	                token : "constant.numeric", // hex
	                regex : /0(?:[xX][0-9a-fA-F]+|[bB][01]+)\b/
	            }, {
	                token : "constant.numeric", // float
	                regex : /[+-]?\d[\d_]*(?:(?:\.\d*)?(?:[eE][+-]?\d+)?)?\b/
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "support.function",
	                    "punctuation.operator", "entity.name.function", "text","keyword.operator"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(prototype)(\\.)(" + identifierRe +")(\\s*)(=)",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "entity.name.function", "text",
	                    "keyword.operator", "text", "storage.type", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "entity.name.function", "text", "keyword.operator", "text", "storage.type",
	                    "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "entity.name.function", "text",
	                    "keyword.operator", "text",
	                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
	                ],
	                regex : "(function)(\\s+)(" + identifierRe + ")(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "entity.name.function", "text", "punctuation.operator",
	                    "text", "storage.type", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "text", "text", "storage.type", "text", "paren.lparen"
	                ],
	                regex : "(:)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : "keyword",
	                regex : "(?:" + kwBeforeRe + ")\\b",
	                next : "start"
	            }, {
	                token : ["support.constant"],
	                regex : /that\b/
	            }, {
	                token : ["storage.type", "punctuation.operator", "support.function.firebug"],
	                regex : /(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/
	            }, {
	                token : keywordMapper,
	                regex : identifierRe
	            }, {
	                token : "punctuation.operator",
	                regex : /[.](?![.])/,
	                next  : "property"
	            }, {
	                token : "keyword.operator",
	                regex : /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
	                next  : "start"
	            }, {
	                token : "punctuation.operator",
	                regex : /[?:,;.]/,
	                next  : "start"
	            }, {
	                token : "paren.lparen",
	                regex : /[\[({]/,
	                next  : "start"
	            }, {
	                token : "paren.rparen",
	                regex : /[\])}]/
	            }, {
	                token: "comment",
	                regex: /^#!.*$/
	            }
	        ],
	        property: [{
	                token : "text",
	                regex : "\\s+"
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "entity.name.function", "text",
	                    "keyword.operator", "text",
	                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : "punctuation.operator",
	                regex : /[.](?![.])/
	            }, {
	                token : "support.function",
	                regex : /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
	            }, {
	                token : "support.function.dom",
	                regex : /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
	            }, {
	                token :  "support.constant",
	                regex : /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
	            }, {
	                token : "identifier",
	                regex : identifierRe
	            }, {
	                regex: "",
	                token: "empty",
	                next: "no_regex"
	            }
	        ],
	        "start": [
	            DocCommentHighlightRules.getStartRule("doc-start"),
	            comments("start"),
	            {
	                token: "string.regexp",
	                regex: "\\/",
	                next: "regex"
	            }, {
	                token : "text",
	                regex : "\\s+|^$",
	                next : "start"
	            }, {
	                token: "empty",
	                regex: "",
	                next: "no_regex"
	            }
	        ],
	        "regex": [
	            {
	                token: "regexp.keyword.operator",
	                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
	            }, {
	                token: "string.regexp",
	                regex: "/[sxngimy]*",
	                next: "no_regex"
	            }, {
	                token : "invalid",
	                regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
	            }, {
	                token : "constant.language.escape",
	                regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
	            }, {
	                token : "constant.language.delimiter",
	                regex: /\|/
	            }, {
	                token: "constant.language.escape",
	                regex: /\[\^?/,
	                next: "regex_character_class"
	            }, {
	                token: "empty",
	                regex: "$",
	                next: "no_regex"
	            }, {
	                defaultToken: "string.regexp"
	            }
	        ],
	        "regex_character_class": [
	            {
	                token: "regexp.charclass.keyword.operator",
	                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
	            }, {
	                token: "constant.language.escape",
	                regex: "]",
	                next: "regex"
	            }, {
	                token: "constant.language.escape",
	                regex: "-"
	            }, {
	                token: "empty",
	                regex: "$",
	                next: "no_regex"
	            }, {
	                defaultToken: "string.regexp.charachterclass"
	            }
	        ],
	        "function_arguments": [
	            {
	                token: "variable.parameter",
	                regex: identifierRe
	            }, {
	                token: "punctuation.operator",
	                regex: "[, ]+"
	            }, {
	                token: "punctuation.operator",
	                regex: "$"
	            }, {
	                token: "empty",
	                regex: "",
	                next: "no_regex"
	            }
	        ],
	        "qqstring" : [
	            {
	                token : "constant.language.escape",
	                regex : escapedRe
	            }, {
	                token : "string",
	                regex : "\\\\$",
	                next  : "qqstring"
	            }, {
	                token : "string",
	                regex : '"|$',
	                next  : "no_regex"
	            }, {
	                defaultToken: "string"
	            }
	        ],
	        "qstring" : [
	            {
	                token : "constant.language.escape",
	                regex : escapedRe
	            }, {
	                token : "string",
	                regex : "\\\\$",
	                next  : "qstring"
	            }, {
	                token : "string",
	                regex : "'|$",
	                next  : "no_regex"
	            }, {
	                defaultToken: "string"
	            }
	        ]
	    };
	    
	    
	    if (!options || !options.noES6) {
	        this.$rules.no_regex.unshift({
	            regex: "[{}]", onMatch: function(val, state, stack) {
	                this.next = val == "{" ? this.nextState : "";
	                if (val == "{" && stack.length) {
	                    stack.unshift("start", state);
	                }
	                else if (val == "}" && stack.length) {
	                    stack.shift();
	                    this.next = stack.shift();
	                    if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1)
	                        return "paren.quasi.end";
	                }
	                return val == "{" ? "paren.lparen" : "paren.rparen";
	            },
	            nextState: "start"
	        }, {
	            token : "string.quasi.start",
	            regex : /`/,
	            push  : [{
	                token : "constant.language.escape",
	                regex : escapedRe
	            }, {
	                token : "paren.quasi.start",
	                regex : /\${/,
	                push  : "start"
	            }, {
	                token : "string.quasi.end",
	                regex : /`/,
	                next  : "pop"
	            }, {
	                defaultToken: "string.quasi"
	            }]
	        });
	        
	        if (!options || options.jsx != false)
	            JSX.call(this);
	    }
	    
	    this.embedRules(DocCommentHighlightRules, "doc-",
	        [ DocCommentHighlightRules.getEndRule("no_regex") ]);
	    
	    this.normalizeRules();
	};
	
	oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
	
	function JSX() {
	    var tagRegex = identifierRe.replace("\\d", "\\d\\-");
	    var jsxTag = {
	        onMatch : function(val, state, stack) {
	            var offset = val.charAt(1) == "/" ? 2 : 1;
	            if (offset == 1) {
	                if (state != this.nextState)
	                    stack.unshift(this.next, this.nextState, 0);
	                else
	                    stack.unshift(this.next);
	                stack[2]++;
	            } else if (offset == 2) {
	                if (state == this.nextState) {
	                    stack[1]--;
	                    if (!stack[1] || stack[1] < 0) {
	                        stack.shift();
	                        stack.shift();
	                    }
	                }
	            }
	            return [{
	                type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
	                value: val.slice(0, offset)
	            }, {
	                type: "meta.tag.tag-name.xml",
	                value: val.substr(offset)
	            }];
	        },
	        regex : "</?" + tagRegex + "",
	        next: "jsxAttributes",
	        nextState: "jsx"
	    };
	    this.$rules.start.unshift(jsxTag);
	    var jsxJsRule = {
	        regex: "{",
	        token: "paren.quasi.start",
	        push: "start"
	    };
	    this.$rules.jsx = [
	        jsxJsRule,
	        jsxTag,
	        {include : "reference"},
	        {defaultToken: "string"}
	    ];
	    this.$rules.jsxAttributes = [{
	        token : "meta.tag.punctuation.tag-close.xml", 
	        regex : "/?>", 
	        onMatch : function(value, currentState, stack) {
	            if (currentState == stack[0])
	                stack.shift();
	            if (value.length == 2) {
	                if (stack[0] == this.nextState)
	                    stack[1]--;
	                if (!stack[1] || stack[1] < 0) {
	                    stack.splice(0, 2);
	                }
	            }
	            this.next = stack[0] || "start";
	            return [{type: this.token, value: value}];
	        },
	        nextState: "jsx"
	    }, 
	    jsxJsRule,
	    comments("jsxAttributes"),
	    {
	        token : "entity.other.attribute-name.xml",
	        regex : tagRegex
	    }, {
	        token : "keyword.operator.attribute-equals.xml",
	        regex : "="
	    }, {
	        token : "text.tag-whitespace.xml",
	        regex : "\\s+"
	    }, {
	        token : "string.attribute-value.xml",
	        regex : "'",
	        stateName : "jsx_attr_q",
	        push : [
	            {token : "string.attribute-value.xml", regex: "'", next: "pop"},
	            {include : "reference"},
	            {defaultToken : "string.attribute-value.xml"}
	        ]
	    }, {
	        token : "string.attribute-value.xml",
	        regex : '"',
	        stateName : "jsx_attr_qq",
	        push : [
	            {token : "string.attribute-value.xml", regex: '"', next: "pop"},
	            {include : "reference"},
	            {defaultToken : "string.attribute-value.xml"}
	        ]
	    },
	    jsxTag
	    ];
	    this.$rules.reference = [{
	        token : "constant.language.escape.reference.xml",
	        regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
	    }];
	}
	
	function comments(next) {
	    return [
	        {
	            token : "comment", // multi line comment
	            regex : /\/\*/,
	            next: [
	                DocCommentHighlightRules.getTagRule(),
	                {token : "comment", regex : "\\*\\/", next : next || "pop"},
	                {defaultToken : "comment", caseInsensitive: true}
	            ]
	        }, {
	            token : "comment",
	            regex : "\\/\\/",
	            next: [
	                DocCommentHighlightRules.getTagRule(),
	                {token : "comment", regex : "$|^", next : next || "pop"},
	                {defaultToken : "comment", caseInsensitive: true}
	            ]
	        }
	    ];
	}
	exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
	});
	
	ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	
	var MatchingBraceOutdent = function() {};
	
	(function() {
	
	    this.checkOutdent = function(line, input) {
	        if (! /^\s+$/.test(line))
	            return false;
	
	        return /^\s*\}/.test(input);
	    };
	
	    this.autoOutdent = function(doc, row) {
	        var line = doc.getLine(row);
	        var match = line.match(/^(\s*\})/);
	
	        if (!match) return 0;
	
	        var column = match[1].length;
	        var openBracePos = doc.findMatchingBracket({row: row, column: column});
	
	        if (!openBracePos || openBracePos.row == row) return 0;
	
	        var indent = this.$getIndent(doc.getLine(openBracePos.row));
	        doc.replace(new Range(row, 0, row, column-1), indent);
	    };
	
	    this.$getIndent = function(line) {
	        return line.match(/^\s*/)[0];
	    };
	
	}).call(MatchingBraceOutdent.prototype);
	
	exports.MatchingBraceOutdent = MatchingBraceOutdent;
	});
	
	ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Range = acequire("../../range").Range;
	var BaseFoldMode = acequire("./fold_mode").FoldMode;
	
	var FoldMode = exports.FoldMode = function(commentRegex) {
	    if (commentRegex) {
	        this.foldingStartMarker = new RegExp(
	            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
	        );
	        this.foldingStopMarker = new RegExp(
	            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
	        );
	    }
	};
	oop.inherits(FoldMode, BaseFoldMode);
	
	(function() {
	    
	    this.foldingStartMarker = /(\{|\[)[^\}\]]*$|^\s*(\/\*)/;
	    this.foldingStopMarker = /^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/;
	    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
	    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
	    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
	    this._getFoldWidgetBase = this.getFoldWidget;
	    this.getFoldWidget = function(session, foldStyle, row) {
	        var line = session.getLine(row);
	    
	        if (this.singleLineBlockCommentRe.test(line)) {
	            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
	                return "";
	        }
	    
	        var fw = this._getFoldWidgetBase(session, foldStyle, row);
	    
	        if (!fw && this.startRegionRe.test(line))
	            return "start"; // lineCommentRegionStart
	    
	        return fw;
	    };
	
	    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
	        var line = session.getLine(row);
	        
	        if (this.startRegionRe.test(line))
	            return this.getCommentRegionBlock(session, line, row);
	        
	        var match = line.match(this.foldingStartMarker);
	        if (match) {
	            var i = match.index;
	
	            if (match[1])
	                return this.openingBracketBlock(session, match[1], row, i);
	                
	            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
	            
	            if (range && !range.isMultiLine()) {
	                if (forceMultiline) {
	                    range = this.getSectionRange(session, row);
	                } else if (foldStyle != "all")
	                    range = null;
	            }
	            
	            return range;
	        }
	
	        if (foldStyle === "markbegin")
	            return;
	
	        var match = line.match(this.foldingStopMarker);
	        if (match) {
	            var i = match.index + match[0].length;
	
	            if (match[1])
	                return this.closingBracketBlock(session, match[1], row, i);
	
	            return session.getCommentFoldRange(row, i, -1);
	        }
	    };
	    
	    this.getSectionRange = function(session, row) {
	        var line = session.getLine(row);
	        var startIndent = line.search(/\S/);
	        var startRow = row;
	        var startColumn = line.length;
	        row = row + 1;
	        var endRow = row;
	        var maxRow = session.getLength();
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var indent = line.search(/\S/);
	            if (indent === -1)
	                continue;
	            if  (startIndent > indent)
	                break;
	            var subRange = this.getFoldWidgetRange(session, "all", row);
	            
	            if (subRange) {
	                if (subRange.start.row <= startRow) {
	                    break;
	                } else if (subRange.isMultiLine()) {
	                    row = subRange.end.row;
	                } else if (startIndent == indent) {
	                    break;
	                }
	            }
	            endRow = row;
	        }
	        
	        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
	    };
	    this.getCommentRegionBlock = function(session, line, row) {
	        var startColumn = line.search(/\s*$/);
	        var maxRow = session.getLength();
	        var startRow = row;
	        
	        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
	        var depth = 1;
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var m = re.exec(line);
	            if (!m) continue;
	            if (m[1]) depth--;
	            else depth++;
	
	            if (!depth) break;
	        }
	
	        var endRow = row;
	        if (endRow > startRow) {
	            return new Range(startRow, startColumn, endRow, line.length);
	        }
	    };
	
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/mode/javascript",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextMode = acequire("./text").Mode;
	var JavaScriptHighlightRules = acequire("./javascript_highlight_rules").JavaScriptHighlightRules;
	var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
	var WorkerClient = acequire("../worker/worker_client").WorkerClient;
	var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
	var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;
	
	var Mode = function() {
	    this.HighlightRules = JavaScriptHighlightRules;
	    
	    this.$outdent = new MatchingBraceOutdent();
	    this.$behaviour = new CstyleBehaviour();
	    this.foldingRules = new CStyleFoldMode();
	};
	oop.inherits(Mode, TextMode);
	
	(function() {
	
	    this.lineCommentStart = "//";
	    this.blockComment = {start: "/*", end: "*/"};
	
	    this.getNextLineIndent = function(state, line, tab) {
	        var indent = this.$getIndent(line);
	
	        var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
	        var tokens = tokenizedLine.tokens;
	        var endState = tokenizedLine.state;
	
	        if (tokens.length && tokens[tokens.length-1].type == "comment") {
	            return indent;
	        }
	
	        if (state == "start" || state == "no_regex") {
	            var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
	            if (match) {
	                indent += tab;
	            }
	        } else if (state == "doc-start") {
	            if (endState == "start" || endState == "no_regex") {
	                return "";
	            }
	            var match = line.match(/^\s*(\/?)\*/);
	            if (match) {
	                if (match[1]) {
	                    indent += " ";
	                }
	                indent += "* ";
	            }
	        }
	
	        return indent;
	    };
	
	    this.checkOutdent = function(state, line, input) {
	        return this.$outdent.checkOutdent(line, input);
	    };
	
	    this.autoOutdent = function(state, doc, row) {
	        this.$outdent.autoOutdent(doc, row);
	    };
	
	    this.createWorker = function(session) {
	        var worker = new WorkerClient(["ace"], __webpack_require__(170), "JavaScriptWorker");
	        worker.attachToDocument(session.getDocument());
	
	        worker.on("annotate", function(results) {
	            session.setAnnotations(results.data);
	        });
	
	        worker.on("terminate", function() {
	            session.clearAnnotations();
	        });
	
	        return worker;
	    };
	
	    this.$id = "ace/mode/javascript";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	});
	
	ace.define("ace/mode/java_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	
	var JavaHighlightRules = function() {
	    var keywords = (
	    "abstract|continue|for|new|switch|" +
	    "assert|default|goto|package|synchronized|" +
	    "boolean|do|if|private|this|" +
	    "break|double|implements|protected|throw|" +
	    "byte|else|import|public|throws|" +
	    "case|enum|instanceof|return|transient|" +
	    "catch|extends|int|short|try|" +
	    "char|final|interface|static|void|" +
	    "class|finally|long|strictfp|volatile|" +
	    "const|float|native|super|while"
	    );
	
	    var buildinConstants = ("null|Infinity|NaN|undefined");
	
	
	    var langClasses = (
	        "AbstractMethodError|AssertionError|ClassCircularityError|"+
	        "ClassFormatError|Deprecated|EnumConstantNotPresentException|"+
	        "ExceptionInInitializerError|IllegalAccessError|"+
	        "IllegalThreadStateException|InstantiationError|InternalError|"+
	        "NegativeArraySizeException|NoSuchFieldError|Override|Process|"+
	        "ProcessBuilder|SecurityManager|StringIndexOutOfBoundsException|"+
	        "SuppressWarnings|TypeNotPresentException|UnknownError|"+
	        "UnsatisfiedLinkError|UnsupportedClassVersionError|VerifyError|"+
	        "InstantiationException|IndexOutOfBoundsException|"+
	        "ArrayIndexOutOfBoundsException|CloneNotSupportedException|"+
	        "NoSuchFieldException|IllegalArgumentException|NumberFormatException|"+
	        "SecurityException|Void|InheritableThreadLocal|IllegalStateException|"+
	        "InterruptedException|NoSuchMethodException|IllegalAccessException|"+
	        "UnsupportedOperationException|Enum|StrictMath|Package|Compiler|"+
	        "Readable|Runtime|StringBuilder|Math|IncompatibleClassChangeError|"+
	        "NoSuchMethodError|ThreadLocal|RuntimePermission|ArithmeticException|"+
	        "NullPointerException|Long|Integer|Short|Byte|Double|Number|Float|"+
	        "Character|Boolean|StackTraceElement|Appendable|StringBuffer|"+
	        "Iterable|ThreadGroup|Runnable|Thread|IllegalMonitorStateException|"+
	        "StackOverflowError|OutOfMemoryError|VirtualMachineError|"+
	        "ArrayStoreException|ClassCastException|LinkageError|"+
	        "NoClassDefFoundError|ClassNotFoundException|RuntimeException|"+
	        "Exception|ThreadDeath|Error|Throwable|System|ClassLoader|"+
	        "Cloneable|Class|CharSequence|Comparable|String|Object"
	    );
	
	    var keywordMapper = this.createKeywordMapper({
	        "variable.language": "this",
	        "keyword": keywords,
	        "constant.language": buildinConstants,
	        "support.function": langClasses
	    }, "identifier");
	
	    this.$rules = {
	        "start" : [
	            {
	                token : "comment",
	                regex : "\\/\\/.*$"
	            },
	            DocCommentHighlightRules.getStartRule("doc-start"),
	            {
	                token : "comment", // multi line comment
	                regex : "\\/\\*",
	                next : "comment"
	            }, {
	                token : "string", // single line
	                regex : '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
	            }, {
	                token : "string", // single line
	                regex : "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
	            }, {
	                token : "constant.numeric", // hex
	                regex : /0(?:[xX][0-9a-fA-F][0-9a-fA-F_]*|[bB][01][01_]*)[LlSsDdFfYy]?\b/
	            }, {
	                token : "constant.numeric", // float
	                regex : /[+-]?\d[\d_]*(?:(?:\.[\d_]*)?(?:[eE][+-]?[\d_]+)?)?[LlSsDdFfYy]?\b/
	            }, {
	                token : "constant.language.boolean",
	                regex : "(?:true|false)\\b"
	            }, {
	                token : keywordMapper,
	                regex : "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
	            }, {
	                token : "keyword.operator",
	                regex : "!|\\$|%|&|\\*|\\-\\-|\\-|\\+\\+|\\+|~|===|==|=|!=|!==|<=|>=|<<=|>>=|>>>=|<>|<|>|!|&&|\\|\\||\\?\\:|\\*=|%=|\\+=|\\-=|&=|\\^=|\\b(?:in|instanceof|new|delete|typeof|void)"
	            }, {
	                token : "lparen",
	                regex : "[[({]"
	            }, {
	                token : "rparen",
	                regex : "[\\])}]"
	            }, {
	                token : "text",
	                regex : "\\s+"
	            }
	        ],
	        "comment" : [
	            {
	                token : "comment", // closing comment
	                regex : ".*?\\*\\/",
	                next : "start"
	            }, {
	                token : "comment", // comment spanning whole line
	                regex : ".+"
	            }
	        ]
	    };
	
	    this.embedRules(DocCommentHighlightRules, "doc-",
	        [ DocCommentHighlightRules.getEndRule("start") ]);
	};
	
	oop.inherits(JavaHighlightRules, TextHighlightRules);
	
	exports.JavaHighlightRules = JavaHighlightRules;
	});
	
	ace.define("ace/mode/java",["require","exports","module","ace/lib/oop","ace/mode/javascript","ace/mode/java_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var JavaScriptMode = acequire("./javascript").Mode;
	var JavaHighlightRules = acequire("./java_highlight_rules").JavaHighlightRules;
	
	var Mode = function() {
	    JavaScriptMode.call(this);
	    this.HighlightRules = JavaHighlightRules;
	};
	oop.inherits(Mode, JavaScriptMode);
	
	(function() {
	    
	    this.createWorker = function(session) {
	        return null;
	    };
	
	    this.$id = "ace/mode/java";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	
	var DocCommentHighlightRules = function() {
	    this.$rules = {
	        "start" : [ {
	            token : "comment.doc.tag",
	            regex : "@[\\w\\d_]+" // TODO: fix email addresses
	        }, 
	        DocCommentHighlightRules.getTagRule(),
	        {
	            defaultToken : "comment.doc",
	            caseInsensitive: true
	        }]
	    };
	};
	
	oop.inherits(DocCommentHighlightRules, TextHighlightRules);
	
	DocCommentHighlightRules.getTagRule = function(start) {
	    return {
	        token : "comment.doc.tag.storage.type",
	        regex : "\\b(?:TODO|FIXME|XXX|HACK)\\b"
	    };
	}
	
	DocCommentHighlightRules.getStartRule = function(start) {
	    return {
	        token : "comment.doc", // doc comment
	        regex : "\\/\\*(?=\\*)",
	        next  : start
	    };
	};
	
	DocCommentHighlightRules.getEndRule = function (start) {
	    return {
	        token : "comment.doc", // closing comment
	        regex : "\\*\\/",
	        next  : start
	    };
	};
	
	
	exports.DocCommentHighlightRules = DocCommentHighlightRules;
	
	});
	
	ace.define("ace/mode/javascript_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	var identifierRe = "[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*";
	
	var JavaScriptHighlightRules = function(options) {
	    var keywordMapper = this.createKeywordMapper({
	        "variable.language":
	            "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|"  + // Constructors
	            "Namespace|QName|XML|XMLList|"                                             + // E4X
	            "ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|"   +
	            "Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|"                    +
	            "Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|"   + // Errors
	            "SyntaxError|TypeError|URIError|"                                          +
	            "decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|" + // Non-constructor functions
	            "isNaN|parseFloat|parseInt|"                                               +
	            "JSON|Math|"                                                               + // Other
	            "this|arguments|prototype|window|document"                                 , // Pseudo
	        "keyword":
	            "const|yield|import|get|set|async|await|" +
	            "break|case|catch|continue|default|delete|do|else|finally|for|function|" +
	            "if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|" +
	            "__parent__|__count__|escape|unescape|with|__proto__|" +
	            "class|enum|extends|super|export|implements|private|public|interface|package|protected|static",
	        "storage.type":
	            "const|let|var|function",
	        "constant.language":
	            "null|Infinity|NaN|undefined",
	        "support.function":
	            "alert",
	        "constant.language.boolean": "true|false"
	    }, "identifier");
	    var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
	
	    var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|" + // hex
	        "u[0-9a-fA-F]{4}|" + // unicode
	        "u{[0-9a-fA-F]{1,6}}|" + // es6 unicode
	        "[0-2][0-7]{0,2}|" + // oct
	        "3[0-7][0-7]?|" + // oct
	        "[4-7][0-7]?|" + //oct
	        ".)";
	
	    this.$rules = {
	        "no_regex" : [
	            DocCommentHighlightRules.getStartRule("doc-start"),
	            comments("no_regex"),
	            {
	                token : "string",
	                regex : "'(?=.)",
	                next  : "qstring"
	            }, {
	                token : "string",
	                regex : '"(?=.)',
	                next  : "qqstring"
	            }, {
	                token : "constant.numeric", // hex
	                regex : /0(?:[xX][0-9a-fA-F]+|[bB][01]+)\b/
	            }, {
	                token : "constant.numeric", // float
	                regex : /[+-]?\d[\d_]*(?:(?:\.\d*)?(?:[eE][+-]?\d+)?)?\b/
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "support.function",
	                    "punctuation.operator", "entity.name.function", "text","keyword.operator"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(prototype)(\\.)(" + identifierRe +")(\\s*)(=)",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "entity.name.function", "text",
	                    "keyword.operator", "text", "storage.type", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "entity.name.function", "text", "keyword.operator", "text", "storage.type",
	                    "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "entity.name.function", "text",
	                    "keyword.operator", "text",
	                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
	                ],
	                regex : "(function)(\\s+)(" + identifierRe + ")(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "entity.name.function", "text", "punctuation.operator",
	                    "text", "storage.type", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : [
	                    "text", "text", "storage.type", "text", "paren.lparen"
	                ],
	                regex : "(:)(\\s*)(function)(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : "keyword",
	                regex : "(?:" + kwBeforeRe + ")\\b",
	                next : "start"
	            }, {
	                token : ["support.constant"],
	                regex : /that\b/
	            }, {
	                token : ["storage.type", "punctuation.operator", "support.function.firebug"],
	                regex : /(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/
	            }, {
	                token : keywordMapper,
	                regex : identifierRe
	            }, {
	                token : "punctuation.operator",
	                regex : /[.](?![.])/,
	                next  : "property"
	            }, {
	                token : "keyword.operator",
	                regex : /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
	                next  : "start"
	            }, {
	                token : "punctuation.operator",
	                regex : /[?:,;.]/,
	                next  : "start"
	            }, {
	                token : "paren.lparen",
	                regex : /[\[({]/,
	                next  : "start"
	            }, {
	                token : "paren.rparen",
	                regex : /[\])}]/
	            }, {
	                token: "comment",
	                regex: /^#!.*$/
	            }
	        ],
	        property: [{
	                token : "text",
	                regex : "\\s+"
	            }, {
	                token : [
	                    "storage.type", "punctuation.operator", "entity.name.function", "text",
	                    "keyword.operator", "text",
	                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
	                ],
	                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",
	                next: "function_arguments"
	            }, {
	                token : "punctuation.operator",
	                regex : /[.](?![.])/
	            }, {
	                token : "support.function",
	                regex : /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
	            }, {
	                token : "support.function.dom",
	                regex : /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
	            }, {
	                token :  "support.constant",
	                regex : /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
	            }, {
	                token : "identifier",
	                regex : identifierRe
	            }, {
	                regex: "",
	                token: "empty",
	                next: "no_regex"
	            }
	        ],
	        "start": [
	            DocCommentHighlightRules.getStartRule("doc-start"),
	            comments("start"),
	            {
	                token: "string.regexp",
	                regex: "\\/",
	                next: "regex"
	            }, {
	                token : "text",
	                regex : "\\s+|^$",
	                next : "start"
	            }, {
	                token: "empty",
	                regex: "",
	                next: "no_regex"
	            }
	        ],
	        "regex": [
	            {
	                token: "regexp.keyword.operator",
	                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
	            }, {
	                token: "string.regexp",
	                regex: "/[sxngimy]*",
	                next: "no_regex"
	            }, {
	                token : "invalid",
	                regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
	            }, {
	                token : "constant.language.escape",
	                regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
	            }, {
	                token : "constant.language.delimiter",
	                regex: /\|/
	            }, {
	                token: "constant.language.escape",
	                regex: /\[\^?/,
	                next: "regex_character_class"
	            }, {
	                token: "empty",
	                regex: "$",
	                next: "no_regex"
	            }, {
	                defaultToken: "string.regexp"
	            }
	        ],
	        "regex_character_class": [
	            {
	                token: "regexp.charclass.keyword.operator",
	                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
	            }, {
	                token: "constant.language.escape",
	                regex: "]",
	                next: "regex"
	            }, {
	                token: "constant.language.escape",
	                regex: "-"
	            }, {
	                token: "empty",
	                regex: "$",
	                next: "no_regex"
	            }, {
	                defaultToken: "string.regexp.charachterclass"
	            }
	        ],
	        "function_arguments": [
	            {
	                token: "variable.parameter",
	                regex: identifierRe
	            }, {
	                token: "punctuation.operator",
	                regex: "[, ]+"
	            }, {
	                token: "punctuation.operator",
	                regex: "$"
	            }, {
	                token: "empty",
	                regex: "",
	                next: "no_regex"
	            }
	        ],
	        "qqstring" : [
	            {
	                token : "constant.language.escape",
	                regex : escapedRe
	            }, {
	                token : "string",
	                regex : "\\\\$",
	                next  : "qqstring"
	            }, {
	                token : "string",
	                regex : '"|$',
	                next  : "no_regex"
	            }, {
	                defaultToken: "string"
	            }
	        ],
	        "qstring" : [
	            {
	                token : "constant.language.escape",
	                regex : escapedRe
	            }, {
	                token : "string",
	                regex : "\\\\$",
	                next  : "qstring"
	            }, {
	                token : "string",
	                regex : "'|$",
	                next  : "no_regex"
	            }, {
	                defaultToken: "string"
	            }
	        ]
	    };
	    
	    
	    if (!options || !options.noES6) {
	        this.$rules.no_regex.unshift({
	            regex: "[{}]", onMatch: function(val, state, stack) {
	                this.next = val == "{" ? this.nextState : "";
	                if (val == "{" && stack.length) {
	                    stack.unshift("start", state);
	                }
	                else if (val == "}" && stack.length) {
	                    stack.shift();
	                    this.next = stack.shift();
	                    if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1)
	                        return "paren.quasi.end";
	                }
	                return val == "{" ? "paren.lparen" : "paren.rparen";
	            },
	            nextState: "start"
	        }, {
	            token : "string.quasi.start",
	            regex : /`/,
	            push  : [{
	                token : "constant.language.escape",
	                regex : escapedRe
	            }, {
	                token : "paren.quasi.start",
	                regex : /\${/,
	                push  : "start"
	            }, {
	                token : "string.quasi.end",
	                regex : /`/,
	                next  : "pop"
	            }, {
	                defaultToken: "string.quasi"
	            }]
	        });
	        
	        if (!options || options.jsx != false)
	            JSX.call(this);
	    }
	    
	    this.embedRules(DocCommentHighlightRules, "doc-",
	        [ DocCommentHighlightRules.getEndRule("no_regex") ]);
	    
	    this.normalizeRules();
	};
	
	oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
	
	function JSX() {
	    var tagRegex = identifierRe.replace("\\d", "\\d\\-");
	    var jsxTag = {
	        onMatch : function(val, state, stack) {
	            var offset = val.charAt(1) == "/" ? 2 : 1;
	            if (offset == 1) {
	                if (state != this.nextState)
	                    stack.unshift(this.next, this.nextState, 0);
	                else
	                    stack.unshift(this.next);
	                stack[2]++;
	            } else if (offset == 2) {
	                if (state == this.nextState) {
	                    stack[1]--;
	                    if (!stack[1] || stack[1] < 0) {
	                        stack.shift();
	                        stack.shift();
	                    }
	                }
	            }
	            return [{
	                type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
	                value: val.slice(0, offset)
	            }, {
	                type: "meta.tag.tag-name.xml",
	                value: val.substr(offset)
	            }];
	        },
	        regex : "</?" + tagRegex + "",
	        next: "jsxAttributes",
	        nextState: "jsx"
	    };
	    this.$rules.start.unshift(jsxTag);
	    var jsxJsRule = {
	        regex: "{",
	        token: "paren.quasi.start",
	        push: "start"
	    };
	    this.$rules.jsx = [
	        jsxJsRule,
	        jsxTag,
	        {include : "reference"},
	        {defaultToken: "string"}
	    ];
	    this.$rules.jsxAttributes = [{
	        token : "meta.tag.punctuation.tag-close.xml", 
	        regex : "/?>", 
	        onMatch : function(value, currentState, stack) {
	            if (currentState == stack[0])
	                stack.shift();
	            if (value.length == 2) {
	                if (stack[0] == this.nextState)
	                    stack[1]--;
	                if (!stack[1] || stack[1] < 0) {
	                    stack.splice(0, 2);
	                }
	            }
	            this.next = stack[0] || "start";
	            return [{type: this.token, value: value}];
	        },
	        nextState: "jsx"
	    }, 
	    jsxJsRule,
	    comments("jsxAttributes"),
	    {
	        token : "entity.other.attribute-name.xml",
	        regex : tagRegex
	    }, {
	        token : "keyword.operator.attribute-equals.xml",
	        regex : "="
	    }, {
	        token : "text.tag-whitespace.xml",
	        regex : "\\s+"
	    }, {
	        token : "string.attribute-value.xml",
	        regex : "'",
	        stateName : "jsx_attr_q",
	        push : [
	            {token : "string.attribute-value.xml", regex: "'", next: "pop"},
	            {include : "reference"},
	            {defaultToken : "string.attribute-value.xml"}
	        ]
	    }, {
	        token : "string.attribute-value.xml",
	        regex : '"',
	        stateName : "jsx_attr_qq",
	        push : [
	            {token : "string.attribute-value.xml", regex: '"', next: "pop"},
	            {include : "reference"},
	            {defaultToken : "string.attribute-value.xml"}
	        ]
	    },
	    jsxTag
	    ];
	    this.$rules.reference = [{
	        token : "constant.language.escape.reference.xml",
	        regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
	    }];
	}
	
	function comments(next) {
	    return [
	        {
	            token : "comment", // multi line comment
	            regex : /\/\*/,
	            next: [
	                DocCommentHighlightRules.getTagRule(),
	                {token : "comment", regex : "\\*\\/", next : next || "pop"},
	                {defaultToken : "comment", caseInsensitive: true}
	            ]
	        }, {
	            token : "comment",
	            regex : "\\/\\/",
	            next: [
	                DocCommentHighlightRules.getTagRule(),
	                {token : "comment", regex : "$|^", next : next || "pop"},
	                {defaultToken : "comment", caseInsensitive: true}
	            ]
	        }
	    ];
	}
	exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
	});
	
	ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	
	var MatchingBraceOutdent = function() {};
	
	(function() {
	
	    this.checkOutdent = function(line, input) {
	        if (! /^\s+$/.test(line))
	            return false;
	
	        return /^\s*\}/.test(input);
	    };
	
	    this.autoOutdent = function(doc, row) {
	        var line = doc.getLine(row);
	        var match = line.match(/^(\s*\})/);
	
	        if (!match) return 0;
	
	        var column = match[1].length;
	        var openBracePos = doc.findMatchingBracket({row: row, column: column});
	
	        if (!openBracePos || openBracePos.row == row) return 0;
	
	        var indent = this.$getIndent(doc.getLine(openBracePos.row));
	        doc.replace(new Range(row, 0, row, column-1), indent);
	    };
	
	    this.$getIndent = function(line) {
	        return line.match(/^\s*/)[0];
	    };
	
	}).call(MatchingBraceOutdent.prototype);
	
	exports.MatchingBraceOutdent = MatchingBraceOutdent;
	});
	
	ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Range = acequire("../../range").Range;
	var BaseFoldMode = acequire("./fold_mode").FoldMode;
	
	var FoldMode = exports.FoldMode = function(commentRegex) {
	    if (commentRegex) {
	        this.foldingStartMarker = new RegExp(
	            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
	        );
	        this.foldingStopMarker = new RegExp(
	            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
	        );
	    }
	};
	oop.inherits(FoldMode, BaseFoldMode);
	
	(function() {
	    
	    this.foldingStartMarker = /(\{|\[)[^\}\]]*$|^\s*(\/\*)/;
	    this.foldingStopMarker = /^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/;
	    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
	    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
	    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
	    this._getFoldWidgetBase = this.getFoldWidget;
	    this.getFoldWidget = function(session, foldStyle, row) {
	        var line = session.getLine(row);
	    
	        if (this.singleLineBlockCommentRe.test(line)) {
	            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
	                return "";
	        }
	    
	        var fw = this._getFoldWidgetBase(session, foldStyle, row);
	    
	        if (!fw && this.startRegionRe.test(line))
	            return "start"; // lineCommentRegionStart
	    
	        return fw;
	    };
	
	    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
	        var line = session.getLine(row);
	        
	        if (this.startRegionRe.test(line))
	            return this.getCommentRegionBlock(session, line, row);
	        
	        var match = line.match(this.foldingStartMarker);
	        if (match) {
	            var i = match.index;
	
	            if (match[1])
	                return this.openingBracketBlock(session, match[1], row, i);
	                
	            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
	            
	            if (range && !range.isMultiLine()) {
	                if (forceMultiline) {
	                    range = this.getSectionRange(session, row);
	                } else if (foldStyle != "all")
	                    range = null;
	            }
	            
	            return range;
	        }
	
	        if (foldStyle === "markbegin")
	            return;
	
	        var match = line.match(this.foldingStopMarker);
	        if (match) {
	            var i = match.index + match[0].length;
	
	            if (match[1])
	                return this.closingBracketBlock(session, match[1], row, i);
	
	            return session.getCommentFoldRange(row, i, -1);
	        }
	    };
	    
	    this.getSectionRange = function(session, row) {
	        var line = session.getLine(row);
	        var startIndent = line.search(/\S/);
	        var startRow = row;
	        var startColumn = line.length;
	        row = row + 1;
	        var endRow = row;
	        var maxRow = session.getLength();
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var indent = line.search(/\S/);
	            if (indent === -1)
	                continue;
	            if  (startIndent > indent)
	                break;
	            var subRange = this.getFoldWidgetRange(session, "all", row);
	            
	            if (subRange) {
	                if (subRange.start.row <= startRow) {
	                    break;
	                } else if (subRange.isMultiLine()) {
	                    row = subRange.end.row;
	                } else if (startIndent == indent) {
	                    break;
	                }
	            }
	            endRow = row;
	        }
	        
	        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
	    };
	    this.getCommentRegionBlock = function(session, line, row) {
	        var startColumn = line.search(/\s*$/);
	        var maxRow = session.getLength();
	        var startRow = row;
	        
	        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
	        var depth = 1;
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var m = re.exec(line);
	            if (!m) continue;
	            if (m[1]) depth--;
	            else depth++;
	
	            if (!depth) break;
	        }
	
	        var endRow = row;
	        if (endRow > startRow) {
	            return new Range(startRow, startColumn, endRow, line.length);
	        }
	    };
	
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/mode/javascript",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextMode = acequire("./text").Mode;
	var JavaScriptHighlightRules = acequire("./javascript_highlight_rules").JavaScriptHighlightRules;
	var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
	var WorkerClient = acequire("../worker/worker_client").WorkerClient;
	var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
	var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;
	
	var Mode = function() {
	    this.HighlightRules = JavaScriptHighlightRules;
	    
	    this.$outdent = new MatchingBraceOutdent();
	    this.$behaviour = new CstyleBehaviour();
	    this.foldingRules = new CStyleFoldMode();
	};
	oop.inherits(Mode, TextMode);
	
	(function() {
	
	    this.lineCommentStart = "//";
	    this.blockComment = {start: "/*", end: "*/"};
	
	    this.getNextLineIndent = function(state, line, tab) {
	        var indent = this.$getIndent(line);
	
	        var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
	        var tokens = tokenizedLine.tokens;
	        var endState = tokenizedLine.state;
	
	        if (tokens.length && tokens[tokens.length-1].type == "comment") {
	            return indent;
	        }
	
	        if (state == "start" || state == "no_regex") {
	            var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
	            if (match) {
	                indent += tab;
	            }
	        } else if (state == "doc-start") {
	            if (endState == "start" || endState == "no_regex") {
	                return "";
	            }
	            var match = line.match(/^\s*(\/?)\*/);
	            if (match) {
	                if (match[1]) {
	                    indent += " ";
	                }
	                indent += "* ";
	            }
	        }
	
	        return indent;
	    };
	
	    this.checkOutdent = function(state, line, input) {
	        return this.$outdent.checkOutdent(line, input);
	    };
	
	    this.autoOutdent = function(state, doc, row) {
	        this.$outdent.autoOutdent(doc, row);
	    };
	
	    this.createWorker = function(session) {
	        var worker = new WorkerClient(["ace"], __webpack_require__(170), "JavaScriptWorker");
	        worker.attachToDocument(session.getDocument());
	
	        worker.on("annotate", function(results) {
	            session.setAnnotations(results.data);
	        });
	
	        worker.on("terminate", function() {
	            session.clearAnnotations();
	        });
	
	        return worker;
	    };
	
	    this.$id = "ace/mode/javascript";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	});


/***/ }),
/* 279 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/text",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="text"})

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	module.exports.id = 'ace/mode/css_worker';
	module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/css/csslint\",[\"require\",\"exports\",\"module\"],function(acequire,exports,module){function objectToString(o){return Object.prototype.toString.call(o)}function clone(parent,circular,depth,prototype){function _clone(parent,depth){if(null===parent)return null;if(0==depth)return parent;var child;if(\"object\"!=typeof parent)return parent;if(util.isArray(parent))child=[];else if(util.isRegExp(parent))child=RegExp(parent.source,util.getRegExpFlags(parent)),parent.lastIndex&&(child.lastIndex=parent.lastIndex);else if(util.isDate(parent))child=new Date(parent.getTime());else{if(useBuffer&&Buffer.isBuffer(parent))return child=new Buffer(parent.length),parent.copy(child),child;child=prototype===void 0?Object.create(Object.getPrototypeOf(parent)):Object.create(prototype)}if(circular){var index=allParents.indexOf(parent);if(-1!=index)return allChildren[index];allParents.push(parent),allChildren.push(child)}for(var i in parent)child[i]=_clone(parent[i],depth-1);return child}var allParents=[],allChildren=[],useBuffer=\"undefined\"!=typeof Buffer;return circular===void 0&&(circular=!0),depth===void 0&&(depth=1/0),_clone(parent,depth)}function Reporter(lines,ruleset){this.messages=[],this.stats=[],this.lines=lines,this.ruleset=ruleset}var parserlib={};(function(){function EventTarget(){this._listeners={}}function StringReader(text){this._input=text.replace(/\\n\\r?/g,\"\\n\"),this._line=1,this._col=1,this._cursor=0}function SyntaxError(message,line,col){this.col=col,this.line=line,this.message=message}function SyntaxUnit(text,line,col,type){this.col=col,this.line=line,this.text=text,this.type=type}function TokenStreamBase(input,tokenData){this._reader=input?new StringReader(\"\"+input):null,this._token=null,this._tokenData=tokenData,this._lt=[],this._ltIndex=0,this._ltIndexCache=[]}EventTarget.prototype={constructor:EventTarget,addListener:function(type,listener){this._listeners[type]||(this._listeners[type]=[]),this._listeners[type].push(listener)},fire:function(event){if(\"string\"==typeof event&&(event={type:event}),event.target!==void 0&&(event.target=this),event.type===void 0)throw Error(\"Event object missing 'type' property.\");if(this._listeners[event.type])for(var listeners=this._listeners[event.type].concat(),i=0,len=listeners.length;len>i;i++)listeners[i].call(this,event)},removeListener:function(type,listener){if(this._listeners[type])for(var listeners=this._listeners[type],i=0,len=listeners.length;len>i;i++)if(listeners[i]===listener){listeners.splice(i,1);break}}},StringReader.prototype={constructor:StringReader,getCol:function(){return this._col},getLine:function(){return this._line},eof:function(){return this._cursor==this._input.length},peek:function(count){var c=null;return count=count===void 0?1:count,this._cursor<this._input.length&&(c=this._input.charAt(this._cursor+count-1)),c},read:function(){var c=null;return this._cursor<this._input.length&&(\"\\n\"==this._input.charAt(this._cursor)?(this._line++,this._col=1):this._col++,c=this._input.charAt(this._cursor++)),c},mark:function(){this._bookmark={cursor:this._cursor,line:this._line,col:this._col}},reset:function(){this._bookmark&&(this._cursor=this._bookmark.cursor,this._line=this._bookmark.line,this._col=this._bookmark.col,delete this._bookmark)},readTo:function(pattern){for(var c,buffer=\"\";buffer.length<pattern.length||buffer.lastIndexOf(pattern)!=buffer.length-pattern.length;){if(c=this.read(),!c)throw Error('Expected \"'+pattern+'\" at line '+this._line+\", col \"+this._col+\".\");buffer+=c}return buffer},readWhile:function(filter){for(var buffer=\"\",c=this.read();null!==c&&filter(c);)buffer+=c,c=this.read();return buffer},readMatch:function(matcher){var source=this._input.substring(this._cursor),value=null;return\"string\"==typeof matcher?0===source.indexOf(matcher)&&(value=this.readCount(matcher.length)):matcher instanceof RegExp&&matcher.test(source)&&(value=this.readCount(RegExp.lastMatch.length)),value},readCount:function(count){for(var buffer=\"\";count--;)buffer+=this.read();return buffer}},SyntaxError.prototype=Error(),SyntaxUnit.fromToken=function(token){return new SyntaxUnit(token.value,token.startLine,token.startCol)},SyntaxUnit.prototype={constructor:SyntaxUnit,valueOf:function(){return this.text},toString:function(){return this.text}},TokenStreamBase.createTokenData=function(tokens){var nameMap=[],typeMap={},tokenData=tokens.concat([]),i=0,len=tokenData.length+1;for(tokenData.UNKNOWN=-1,tokenData.unshift({name:\"EOF\"});len>i;i++)nameMap.push(tokenData[i].name),tokenData[tokenData[i].name]=i,tokenData[i].text&&(typeMap[tokenData[i].text]=i);return tokenData.name=function(tt){return nameMap[tt]},tokenData.type=function(c){return typeMap[c]},tokenData},TokenStreamBase.prototype={constructor:TokenStreamBase,match:function(tokenTypes,channel){tokenTypes instanceof Array||(tokenTypes=[tokenTypes]);\nfor(var tt=this.get(channel),i=0,len=tokenTypes.length;len>i;)if(tt==tokenTypes[i++])return!0;return this.unget(),!1},mustMatch:function(tokenTypes){var token;if(tokenTypes instanceof Array||(tokenTypes=[tokenTypes]),!this.match.apply(this,arguments))throw token=this.LT(1),new SyntaxError(\"Expected \"+this._tokenData[tokenTypes[0]].name+\" at line \"+token.startLine+\", col \"+token.startCol+\".\",token.startLine,token.startCol)},advance:function(tokenTypes,channel){for(;0!==this.LA(0)&&!this.match(tokenTypes,channel);)this.get();return this.LA(0)},get:function(channel){var token,info,tokenInfo=this._tokenData,i=(this._reader,0);if(tokenInfo.length,this._lt.length&&this._ltIndex>=0&&this._ltIndex<this._lt.length){for(i++,this._token=this._lt[this._ltIndex++],info=tokenInfo[this._token.type];void 0!==info.channel&&channel!==info.channel&&this._ltIndex<this._lt.length;)this._token=this._lt[this._ltIndex++],info=tokenInfo[this._token.type],i++;if((void 0===info.channel||channel===info.channel)&&this._ltIndex<=this._lt.length)return this._ltIndexCache.push(i),this._token.type}return token=this._getToken(),token.type>-1&&!tokenInfo[token.type].hide&&(token.channel=tokenInfo[token.type].channel,this._token=token,this._lt.push(token),this._ltIndexCache.push(this._lt.length-this._ltIndex+i),this._lt.length>5&&this._lt.shift(),this._ltIndexCache.length>5&&this._ltIndexCache.shift(),this._ltIndex=this._lt.length),info=tokenInfo[token.type],info&&(info.hide||void 0!==info.channel&&channel!==info.channel)?this.get(channel):token.type},LA:function(index){var tt,total=index;if(index>0){if(index>5)throw Error(\"Too much lookahead.\");for(;total;)tt=this.get(),total--;for(;index>total;)this.unget(),total++}else if(0>index){if(!this._lt[this._ltIndex+index])throw Error(\"Too much lookbehind.\");tt=this._lt[this._ltIndex+index].type}else tt=this._token.type;return tt},LT:function(index){return this.LA(index),this._lt[this._ltIndex+index-1]},peek:function(){return this.LA(1)},token:function(){return this._token},tokenName:function(tokenType){return 0>tokenType||tokenType>this._tokenData.length?\"UNKNOWN_TOKEN\":this._tokenData[tokenType].name},tokenType:function(tokenName){return this._tokenData[tokenName]||-1},unget:function(){if(!this._ltIndexCache.length)throw Error(\"Too much lookahead.\");this._ltIndex-=this._ltIndexCache.pop(),this._token=this._lt[this._ltIndex-1]}},parserlib.util={StringReader:StringReader,SyntaxError:SyntaxError,SyntaxUnit:SyntaxUnit,EventTarget:EventTarget,TokenStreamBase:TokenStreamBase}})(),function(){function Combinator(text,line,col){SyntaxUnit.call(this,text,line,col,Parser.COMBINATOR_TYPE),this.type=\"unknown\",/^\\s+$/.test(text)?this.type=\"descendant\":\">\"==text?this.type=\"child\":\"+\"==text?this.type=\"adjacent-sibling\":\"~\"==text&&(this.type=\"sibling\")}function MediaFeature(name,value){SyntaxUnit.call(this,\"(\"+name+(null!==value?\":\"+value:\"\")+\")\",name.startLine,name.startCol,Parser.MEDIA_FEATURE_TYPE),this.name=name,this.value=value}function MediaQuery(modifier,mediaType,features,line,col){SyntaxUnit.call(this,(modifier?modifier+\" \":\"\")+(mediaType?mediaType:\"\")+(mediaType&&features.length>0?\" and \":\"\")+features.join(\" and \"),line,col,Parser.MEDIA_QUERY_TYPE),this.modifier=modifier,this.mediaType=mediaType,this.features=features}function Parser(options){EventTarget.call(this),this.options=options||{},this._tokenStream=null}function PropertyName(text,hack,line,col){SyntaxUnit.call(this,text,line,col,Parser.PROPERTY_NAME_TYPE),this.hack=hack}function PropertyValue(parts,line,col){SyntaxUnit.call(this,parts.join(\" \"),line,col,Parser.PROPERTY_VALUE_TYPE),this.parts=parts}function PropertyValueIterator(value){this._i=0,this._parts=value.parts,this._marks=[],this.value=value}function PropertyValuePart(text,line,col){SyntaxUnit.call(this,text,line,col,Parser.PROPERTY_VALUE_PART_TYPE),this.type=\"unknown\";var temp;if(/^([+\\-]?[\\d\\.]+)([a-z]+)$/i.test(text))switch(this.type=\"dimension\",this.value=+RegExp.$1,this.units=RegExp.$2,this.units.toLowerCase()){case\"em\":case\"rem\":case\"ex\":case\"px\":case\"cm\":case\"mm\":case\"in\":case\"pt\":case\"pc\":case\"ch\":case\"vh\":case\"vw\":case\"vmax\":case\"vmin\":this.type=\"length\";break;case\"deg\":case\"rad\":case\"grad\":this.type=\"angle\";break;case\"ms\":case\"s\":this.type=\"time\";break;case\"hz\":case\"khz\":this.type=\"frequency\";break;case\"dpi\":case\"dpcm\":this.type=\"resolution\"}else/^([+\\-]?[\\d\\.]+)%$/i.test(text)?(this.type=\"percentage\",this.value=+RegExp.$1):/^([+\\-]?\\d+)$/i.test(text)?(this.type=\"integer\",this.value=+RegExp.$1):/^([+\\-]?[\\d\\.]+)$/i.test(text)?(this.type=\"number\",this.value=+RegExp.$1):/^#([a-f0-9]{3,6})/i.test(text)?(this.type=\"color\",temp=RegExp.$1,3==temp.length?(this.red=parseInt(temp.charAt(0)+temp.charAt(0),16),this.green=parseInt(temp.charAt(1)+temp.charAt(1),16),this.blue=parseInt(temp.charAt(2)+temp.charAt(2),16)):(this.red=parseInt(temp.substring(0,2),16),this.green=parseInt(temp.substring(2,4),16),this.blue=parseInt(temp.substring(4,6),16))):/^rgb\\(\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*\\)/i.test(text)?(this.type=\"color\",this.red=+RegExp.$1,this.green=+RegExp.$2,this.blue=+RegExp.$3):/^rgb\\(\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*\\)/i.test(text)?(this.type=\"color\",this.red=255*+RegExp.$1/100,this.green=255*+RegExp.$2/100,this.blue=255*+RegExp.$3/100):/^rgba\\(\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*([\\d\\.]+)\\s*\\)/i.test(text)?(this.type=\"color\",this.red=+RegExp.$1,this.green=+RegExp.$2,this.blue=+RegExp.$3,this.alpha=+RegExp.$4):/^rgba\\(\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*,\\s*([\\d\\.]+)\\s*\\)/i.test(text)?(this.type=\"color\",this.red=255*+RegExp.$1/100,this.green=255*+RegExp.$2/100,this.blue=255*+RegExp.$3/100,this.alpha=+RegExp.$4):/^hsl\\(\\s*(\\d+)\\s*,\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*\\)/i.test(text)?(this.type=\"color\",this.hue=+RegExp.$1,this.saturation=+RegExp.$2/100,this.lightness=+RegExp.$3/100):/^hsla\\(\\s*(\\d+)\\s*,\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*,\\s*([\\d\\.]+)\\s*\\)/i.test(text)?(this.type=\"color\",this.hue=+RegExp.$1,this.saturation=+RegExp.$2/100,this.lightness=+RegExp.$3/100,this.alpha=+RegExp.$4):/^url\\([\"']?([^\\)\"']+)[\"']?\\)/i.test(text)?(this.type=\"uri\",this.uri=RegExp.$1):/^([^\\(]+)\\(/i.test(text)?(this.type=\"function\",this.name=RegExp.$1,this.value=text):/^[\"'][^\"']*[\"']/.test(text)?(this.type=\"string\",this.value=eval(text)):Colors[text.toLowerCase()]?(this.type=\"color\",temp=Colors[text.toLowerCase()].substring(1),this.red=parseInt(temp.substring(0,2),16),this.green=parseInt(temp.substring(2,4),16),this.blue=parseInt(temp.substring(4,6),16)):/^[\\,\\/]$/.test(text)?(this.type=\"operator\",this.value=text):/^[a-z\\-_\\u0080-\\uFFFF][a-z0-9\\-_\\u0080-\\uFFFF]*$/i.test(text)&&(this.type=\"identifier\",this.value=text)}function Selector(parts,line,col){SyntaxUnit.call(this,parts.join(\" \"),line,col,Parser.SELECTOR_TYPE),this.parts=parts,this.specificity=Specificity.calculate(this)}function SelectorPart(elementName,modifiers,text,line,col){SyntaxUnit.call(this,text,line,col,Parser.SELECTOR_PART_TYPE),this.elementName=elementName,this.modifiers=modifiers}function SelectorSubPart(text,type,line,col){SyntaxUnit.call(this,text,line,col,Parser.SELECTOR_SUB_PART_TYPE),this.type=type,this.args=[]}function Specificity(a,b,c,d){this.a=a,this.b=b,this.c=c,this.d=d}function isHexDigit(c){return null!==c&&h.test(c)}function isDigit(c){return null!==c&&/\\d/.test(c)}function isWhitespace(c){return null!==c&&/\\s/.test(c)}function isNewLine(c){return null!==c&&nl.test(c)}function isNameStart(c){return null!==c&&/[a-z_\\u0080-\\uFFFF\\\\]/i.test(c)}function isNameChar(c){return null!==c&&(isNameStart(c)||/[0-9\\-\\\\]/.test(c))}function isIdentStart(c){return null!==c&&(isNameStart(c)||/\\-\\\\/.test(c))}function mix(receiver,supplier){for(var prop in supplier)supplier.hasOwnProperty(prop)&&(receiver[prop]=supplier[prop]);return receiver}function TokenStream(input){TokenStreamBase.call(this,input,Tokens)}function ValidationError(message,line,col){this.col=col,this.line=line,this.message=message}var EventTarget=parserlib.util.EventTarget,TokenStreamBase=parserlib.util.TokenStreamBase,StringReader=parserlib.util.StringReader,SyntaxError=parserlib.util.SyntaxError,SyntaxUnit=parserlib.util.SyntaxUnit,Colors={aliceblue:\"#f0f8ff\",antiquewhite:\"#faebd7\",aqua:\"#00ffff\",aquamarine:\"#7fffd4\",azure:\"#f0ffff\",beige:\"#f5f5dc\",bisque:\"#ffe4c4\",black:\"#000000\",blanchedalmond:\"#ffebcd\",blue:\"#0000ff\",blueviolet:\"#8a2be2\",brown:\"#a52a2a\",burlywood:\"#deb887\",cadetblue:\"#5f9ea0\",chartreuse:\"#7fff00\",chocolate:\"#d2691e\",coral:\"#ff7f50\",cornflowerblue:\"#6495ed\",cornsilk:\"#fff8dc\",crimson:\"#dc143c\",cyan:\"#00ffff\",darkblue:\"#00008b\",darkcyan:\"#008b8b\",darkgoldenrod:\"#b8860b\",darkgray:\"#a9a9a9\",darkgrey:\"#a9a9a9\",darkgreen:\"#006400\",darkkhaki:\"#bdb76b\",darkmagenta:\"#8b008b\",darkolivegreen:\"#556b2f\",darkorange:\"#ff8c00\",darkorchid:\"#9932cc\",darkred:\"#8b0000\",darksalmon:\"#e9967a\",darkseagreen:\"#8fbc8f\",darkslateblue:\"#483d8b\",darkslategray:\"#2f4f4f\",darkslategrey:\"#2f4f4f\",darkturquoise:\"#00ced1\",darkviolet:\"#9400d3\",deeppink:\"#ff1493\",deepskyblue:\"#00bfff\",dimgray:\"#696969\",dimgrey:\"#696969\",dodgerblue:\"#1e90ff\",firebrick:\"#b22222\",floralwhite:\"#fffaf0\",forestgreen:\"#228b22\",fuchsia:\"#ff00ff\",gainsboro:\"#dcdcdc\",ghostwhite:\"#f8f8ff\",gold:\"#ffd700\",goldenrod:\"#daa520\",gray:\"#808080\",grey:\"#808080\",green:\"#008000\",greenyellow:\"#adff2f\",honeydew:\"#f0fff0\",hotpink:\"#ff69b4\",indianred:\"#cd5c5c\",indigo:\"#4b0082\",ivory:\"#fffff0\",khaki:\"#f0e68c\",lavender:\"#e6e6fa\",lavenderblush:\"#fff0f5\",lawngreen:\"#7cfc00\",lemonchiffon:\"#fffacd\",lightblue:\"#add8e6\",lightcoral:\"#f08080\",lightcyan:\"#e0ffff\",lightgoldenrodyellow:\"#fafad2\",lightgray:\"#d3d3d3\",lightgrey:\"#d3d3d3\",lightgreen:\"#90ee90\",lightpink:\"#ffb6c1\",lightsalmon:\"#ffa07a\",lightseagreen:\"#20b2aa\",lightskyblue:\"#87cefa\",lightslategray:\"#778899\",lightslategrey:\"#778899\",lightsteelblue:\"#b0c4de\",lightyellow:\"#ffffe0\",lime:\"#00ff00\",limegreen:\"#32cd32\",linen:\"#faf0e6\",magenta:\"#ff00ff\",maroon:\"#800000\",mediumaquamarine:\"#66cdaa\",mediumblue:\"#0000cd\",mediumorchid:\"#ba55d3\",mediumpurple:\"#9370d8\",mediumseagreen:\"#3cb371\",mediumslateblue:\"#7b68ee\",mediumspringgreen:\"#00fa9a\",mediumturquoise:\"#48d1cc\",mediumvioletred:\"#c71585\",midnightblue:\"#191970\",mintcream:\"#f5fffa\",mistyrose:\"#ffe4e1\",moccasin:\"#ffe4b5\",navajowhite:\"#ffdead\",navy:\"#000080\",oldlace:\"#fdf5e6\",olive:\"#808000\",olivedrab:\"#6b8e23\",orange:\"#ffa500\",orangered:\"#ff4500\",orchid:\"#da70d6\",palegoldenrod:\"#eee8aa\",palegreen:\"#98fb98\",paleturquoise:\"#afeeee\",palevioletred:\"#d87093\",papayawhip:\"#ffefd5\",peachpuff:\"#ffdab9\",peru:\"#cd853f\",pink:\"#ffc0cb\",plum:\"#dda0dd\",powderblue:\"#b0e0e6\",purple:\"#800080\",red:\"#ff0000\",rosybrown:\"#bc8f8f\",royalblue:\"#4169e1\",saddlebrown:\"#8b4513\",salmon:\"#fa8072\",sandybrown:\"#f4a460\",seagreen:\"#2e8b57\",seashell:\"#fff5ee\",sienna:\"#a0522d\",silver:\"#c0c0c0\",skyblue:\"#87ceeb\",slateblue:\"#6a5acd\",slategray:\"#708090\",slategrey:\"#708090\",snow:\"#fffafa\",springgreen:\"#00ff7f\",steelblue:\"#4682b4\",tan:\"#d2b48c\",teal:\"#008080\",thistle:\"#d8bfd8\",tomato:\"#ff6347\",turquoise:\"#40e0d0\",violet:\"#ee82ee\",wheat:\"#f5deb3\",white:\"#ffffff\",whitesmoke:\"#f5f5f5\",yellow:\"#ffff00\",yellowgreen:\"#9acd32\",activeBorder:\"Active window border.\",activecaption:\"Active window caption.\",appworkspace:\"Background color of multiple document interface.\",background:\"Desktop background.\",buttonface:\"The face background color for 3-D elements that appear 3-D due to one layer of surrounding border.\",buttonhighlight:\"The color of the border facing the light source for 3-D elements that appear 3-D due to one layer of surrounding border.\",buttonshadow:\"The color of the border away from the light source for 3-D elements that appear 3-D due to one layer of surrounding border.\",buttontext:\"Text on push buttons.\",captiontext:\"Text in caption, size box, and scrollbar arrow box.\",graytext:\"Grayed (disabled) text. This color is set to #000 if the current display driver does not support a solid gray color.\",greytext:\"Greyed (disabled) text. This color is set to #000 if the current display driver does not support a solid grey color.\",highlight:\"Item(s) selected in a control.\",highlighttext:\"Text of item(s) selected in a control.\",inactiveborder:\"Inactive window border.\",inactivecaption:\"Inactive window caption.\",inactivecaptiontext:\"Color of text in an inactive caption.\",infobackground:\"Background color for tooltip controls.\",infotext:\"Text color for tooltip controls.\",menu:\"Menu background.\",menutext:\"Text in menus.\",scrollbar:\"Scroll bar gray area.\",threeddarkshadow:\"The color of the darker (generally outer) of the two borders away from the light source for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",threedface:\"The face background color for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",threedhighlight:\"The color of the lighter (generally outer) of the two borders facing the light source for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",threedlightshadow:\"The color of the darker (generally inner) of the two borders facing the light source for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",threedshadow:\"The color of the lighter (generally inner) of the two borders away from the light source for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",window:\"Window background.\",windowframe:\"Window frame.\",windowtext:\"Text in windows.\"};Combinator.prototype=new SyntaxUnit,Combinator.prototype.constructor=Combinator,MediaFeature.prototype=new SyntaxUnit,MediaFeature.prototype.constructor=MediaFeature,MediaQuery.prototype=new SyntaxUnit,MediaQuery.prototype.constructor=MediaQuery,Parser.DEFAULT_TYPE=0,Parser.COMBINATOR_TYPE=1,Parser.MEDIA_FEATURE_TYPE=2,Parser.MEDIA_QUERY_TYPE=3,Parser.PROPERTY_NAME_TYPE=4,Parser.PROPERTY_VALUE_TYPE=5,Parser.PROPERTY_VALUE_PART_TYPE=6,Parser.SELECTOR_TYPE=7,Parser.SELECTOR_PART_TYPE=8,Parser.SELECTOR_SUB_PART_TYPE=9,Parser.prototype=function(){var prop,proto=new EventTarget,additions={constructor:Parser,DEFAULT_TYPE:0,COMBINATOR_TYPE:1,MEDIA_FEATURE_TYPE:2,MEDIA_QUERY_TYPE:3,PROPERTY_NAME_TYPE:4,PROPERTY_VALUE_TYPE:5,PROPERTY_VALUE_PART_TYPE:6,SELECTOR_TYPE:7,SELECTOR_PART_TYPE:8,SELECTOR_SUB_PART_TYPE:9,_stylesheet:function(){var count,token,tt,tokenStream=this._tokenStream;for(this.fire(\"startstylesheet\"),this._charset(),this._skipCruft();tokenStream.peek()==Tokens.IMPORT_SYM;)this._import(),this._skipCruft();for(;tokenStream.peek()==Tokens.NAMESPACE_SYM;)this._namespace(),this._skipCruft();for(tt=tokenStream.peek();tt>Tokens.EOF;){try{switch(tt){case Tokens.MEDIA_SYM:this._media(),this._skipCruft();break;case Tokens.PAGE_SYM:this._page(),this._skipCruft();break;case Tokens.FONT_FACE_SYM:this._font_face(),this._skipCruft();break;case Tokens.KEYFRAMES_SYM:this._keyframes(),this._skipCruft();break;case Tokens.VIEWPORT_SYM:this._viewport(),this._skipCruft();break;case Tokens.UNKNOWN_SYM:if(tokenStream.get(),this.options.strict)throw new SyntaxError(\"Unknown @ rule.\",tokenStream.LT(0).startLine,tokenStream.LT(0).startCol);for(this.fire({type:\"error\",error:null,message:\"Unknown @ rule: \"+tokenStream.LT(0).value+\".\",line:tokenStream.LT(0).startLine,col:tokenStream.LT(0).startCol}),count=0;tokenStream.advance([Tokens.LBRACE,Tokens.RBRACE])==Tokens.LBRACE;)count++;for(;count;)tokenStream.advance([Tokens.RBRACE]),count--;break;case Tokens.S:this._readWhitespace();break;default:if(!this._ruleset())switch(tt){case Tokens.CHARSET_SYM:throw token=tokenStream.LT(1),this._charset(!1),new SyntaxError(\"@charset not allowed here.\",token.startLine,token.startCol);case Tokens.IMPORT_SYM:throw token=tokenStream.LT(1),this._import(!1),new SyntaxError(\"@import not allowed here.\",token.startLine,token.startCol);case Tokens.NAMESPACE_SYM:throw token=tokenStream.LT(1),this._namespace(!1),new SyntaxError(\"@namespace not allowed here.\",token.startLine,token.startCol);default:tokenStream.get(),this._unexpectedToken(tokenStream.token())}}}catch(ex){if(!(ex instanceof SyntaxError)||this.options.strict)throw ex;this.fire({type:\"error\",error:ex,message:ex.message,line:ex.line,col:ex.col})}tt=tokenStream.peek()}tt!=Tokens.EOF&&this._unexpectedToken(tokenStream.token()),this.fire(\"endstylesheet\")},_charset:function(emit){var charset,token,line,col,tokenStream=this._tokenStream;tokenStream.match(Tokens.CHARSET_SYM)&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),tokenStream.mustMatch(Tokens.STRING),token=tokenStream.token(),charset=token.value,this._readWhitespace(),tokenStream.mustMatch(Tokens.SEMICOLON),emit!==!1&&this.fire({type:\"charset\",charset:charset,line:line,col:col}))},_import:function(emit){var uri,importToken,tokenStream=this._tokenStream,mediaList=[];tokenStream.mustMatch(Tokens.IMPORT_SYM),importToken=tokenStream.token(),this._readWhitespace(),tokenStream.mustMatch([Tokens.STRING,Tokens.URI]),uri=tokenStream.token().value.replace(/^(?:url\\()?[\"']?([^\"']+?)[\"']?\\)?$/,\"$1\"),this._readWhitespace(),mediaList=this._media_query_list(),tokenStream.mustMatch(Tokens.SEMICOLON),this._readWhitespace(),emit!==!1&&this.fire({type:\"import\",uri:uri,media:mediaList,line:importToken.startLine,col:importToken.startCol})},_namespace:function(emit){var line,col,prefix,uri,tokenStream=this._tokenStream;tokenStream.mustMatch(Tokens.NAMESPACE_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),tokenStream.match(Tokens.IDENT)&&(prefix=tokenStream.token().value,this._readWhitespace()),tokenStream.mustMatch([Tokens.STRING,Tokens.URI]),uri=tokenStream.token().value.replace(/(?:url\\()?[\"']([^\"']+)[\"']\\)?/,\"$1\"),this._readWhitespace(),tokenStream.mustMatch(Tokens.SEMICOLON),this._readWhitespace(),emit!==!1&&this.fire({type:\"namespace\",prefix:prefix,uri:uri,line:line,col:col})},_media:function(){var line,col,mediaList,tokenStream=this._tokenStream;for(tokenStream.mustMatch(Tokens.MEDIA_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),mediaList=this._media_query_list(),tokenStream.mustMatch(Tokens.LBRACE),this._readWhitespace(),this.fire({type:\"startmedia\",media:mediaList,line:line,col:col});;)if(tokenStream.peek()==Tokens.PAGE_SYM)this._page();else if(tokenStream.peek()==Tokens.FONT_FACE_SYM)this._font_face();else if(tokenStream.peek()==Tokens.VIEWPORT_SYM)this._viewport();else if(!this._ruleset())break;tokenStream.mustMatch(Tokens.RBRACE),this._readWhitespace(),this.fire({type:\"endmedia\",media:mediaList,line:line,col:col})},_media_query_list:function(){var tokenStream=this._tokenStream,mediaList=[];for(this._readWhitespace(),(tokenStream.peek()==Tokens.IDENT||tokenStream.peek()==Tokens.LPAREN)&&mediaList.push(this._media_query());tokenStream.match(Tokens.COMMA);)this._readWhitespace(),mediaList.push(this._media_query());return mediaList},_media_query:function(){var tokenStream=this._tokenStream,type=null,ident=null,token=null,expressions=[];if(tokenStream.match(Tokens.IDENT)&&(ident=tokenStream.token().value.toLowerCase(),\"only\"!=ident&&\"not\"!=ident?(tokenStream.unget(),ident=null):token=tokenStream.token()),this._readWhitespace(),tokenStream.peek()==Tokens.IDENT?(type=this._media_type(),null===token&&(token=tokenStream.token())):tokenStream.peek()==Tokens.LPAREN&&(null===token&&(token=tokenStream.LT(1)),expressions.push(this._media_expression())),null===type&&0===expressions.length)return null;for(this._readWhitespace();tokenStream.match(Tokens.IDENT);)\"and\"!=tokenStream.token().value.toLowerCase()&&this._unexpectedToken(tokenStream.token()),this._readWhitespace(),expressions.push(this._media_expression());return new MediaQuery(ident,type,expressions,token.startLine,token.startCol)},_media_type:function(){return this._media_feature()},_media_expression:function(){var token,tokenStream=this._tokenStream,feature=null,expression=null;return tokenStream.mustMatch(Tokens.LPAREN),feature=this._media_feature(),this._readWhitespace(),tokenStream.match(Tokens.COLON)&&(this._readWhitespace(),token=tokenStream.LT(1),expression=this._expression()),tokenStream.mustMatch(Tokens.RPAREN),this._readWhitespace(),new MediaFeature(feature,expression?new SyntaxUnit(expression,token.startLine,token.startCol):null)},_media_feature:function(){var tokenStream=this._tokenStream;return tokenStream.mustMatch(Tokens.IDENT),SyntaxUnit.fromToken(tokenStream.token())},_page:function(){var line,col,tokenStream=this._tokenStream,identifier=null,pseudoPage=null;tokenStream.mustMatch(Tokens.PAGE_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),tokenStream.match(Tokens.IDENT)&&(identifier=tokenStream.token().value,\"auto\"===identifier.toLowerCase()&&this._unexpectedToken(tokenStream.token())),tokenStream.peek()==Tokens.COLON&&(pseudoPage=this._pseudo_page()),this._readWhitespace(),this.fire({type:\"startpage\",id:identifier,pseudo:pseudoPage,line:line,col:col}),this._readDeclarations(!0,!0),this.fire({type:\"endpage\",id:identifier,pseudo:pseudoPage,line:line,col:col})},_margin:function(){var line,col,tokenStream=this._tokenStream,marginSym=this._margin_sym();return marginSym?(line=tokenStream.token().startLine,col=tokenStream.token().startCol,this.fire({type:\"startpagemargin\",margin:marginSym,line:line,col:col}),this._readDeclarations(!0),this.fire({type:\"endpagemargin\",margin:marginSym,line:line,col:col}),!0):!1},_margin_sym:function(){var tokenStream=this._tokenStream;return tokenStream.match([Tokens.TOPLEFTCORNER_SYM,Tokens.TOPLEFT_SYM,Tokens.TOPCENTER_SYM,Tokens.TOPRIGHT_SYM,Tokens.TOPRIGHTCORNER_SYM,Tokens.BOTTOMLEFTCORNER_SYM,Tokens.BOTTOMLEFT_SYM,Tokens.BOTTOMCENTER_SYM,Tokens.BOTTOMRIGHT_SYM,Tokens.BOTTOMRIGHTCORNER_SYM,Tokens.LEFTTOP_SYM,Tokens.LEFTMIDDLE_SYM,Tokens.LEFTBOTTOM_SYM,Tokens.RIGHTTOP_SYM,Tokens.RIGHTMIDDLE_SYM,Tokens.RIGHTBOTTOM_SYM])?SyntaxUnit.fromToken(tokenStream.token()):null},_pseudo_page:function(){var tokenStream=this._tokenStream;return tokenStream.mustMatch(Tokens.COLON),tokenStream.mustMatch(Tokens.IDENT),tokenStream.token().value},_font_face:function(){var line,col,tokenStream=this._tokenStream;tokenStream.mustMatch(Tokens.FONT_FACE_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),this.fire({type:\"startfontface\",line:line,col:col}),this._readDeclarations(!0),this.fire({type:\"endfontface\",line:line,col:col})},_viewport:function(){var line,col,tokenStream=this._tokenStream;tokenStream.mustMatch(Tokens.VIEWPORT_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),this.fire({type:\"startviewport\",line:line,col:col}),this._readDeclarations(!0),this.fire({type:\"endviewport\",line:line,col:col})},_operator:function(inFunction){var tokenStream=this._tokenStream,token=null;return(tokenStream.match([Tokens.SLASH,Tokens.COMMA])||inFunction&&tokenStream.match([Tokens.PLUS,Tokens.STAR,Tokens.MINUS]))&&(token=tokenStream.token(),this._readWhitespace()),token?PropertyValuePart.fromToken(token):null},_combinator:function(){var token,tokenStream=this._tokenStream,value=null;return tokenStream.match([Tokens.PLUS,Tokens.GREATER,Tokens.TILDE])&&(token=tokenStream.token(),value=new Combinator(token.value,token.startLine,token.startCol),this._readWhitespace()),value},_unary_operator:function(){var tokenStream=this._tokenStream;return tokenStream.match([Tokens.MINUS,Tokens.PLUS])?tokenStream.token().value:null},_property:function(){var tokenValue,token,line,col,tokenStream=this._tokenStream,value=null,hack=null;return tokenStream.peek()==Tokens.STAR&&this.options.starHack&&(tokenStream.get(),token=tokenStream.token(),hack=token.value,line=token.startLine,col=token.startCol),tokenStream.match(Tokens.IDENT)&&(token=tokenStream.token(),tokenValue=token.value,\"_\"==tokenValue.charAt(0)&&this.options.underscoreHack&&(hack=\"_\",tokenValue=tokenValue.substring(1)),value=new PropertyName(tokenValue,hack,line||token.startLine,col||token.startCol),this._readWhitespace()),value},_ruleset:function(){var tt,selectors,tokenStream=this._tokenStream;try{selectors=this._selectors_group()}catch(ex){if(!(ex instanceof SyntaxError)||this.options.strict)throw ex;if(this.fire({type:\"error\",error:ex,message:ex.message,line:ex.line,col:ex.col}),tt=tokenStream.advance([Tokens.RBRACE]),tt!=Tokens.RBRACE)throw ex;return!0}return selectors&&(this.fire({type:\"startrule\",selectors:selectors,line:selectors[0].line,col:selectors[0].col}),this._readDeclarations(!0),this.fire({type:\"endrule\",selectors:selectors,line:selectors[0].line,col:selectors[0].col})),selectors},_selectors_group:function(){var selector,tokenStream=this._tokenStream,selectors=[];if(selector=this._selector(),null!==selector)for(selectors.push(selector);tokenStream.match(Tokens.COMMA);)this._readWhitespace(),selector=this._selector(),null!==selector?selectors.push(selector):this._unexpectedToken(tokenStream.LT(1));return selectors.length?selectors:null},_selector:function(){var tokenStream=this._tokenStream,selector=[],nextSelector=null,combinator=null,ws=null;if(nextSelector=this._simple_selector_sequence(),null===nextSelector)return null;for(selector.push(nextSelector);;)if(combinator=this._combinator(),null!==combinator)selector.push(combinator),nextSelector=this._simple_selector_sequence(),null===nextSelector?this._unexpectedToken(tokenStream.LT(1)):selector.push(nextSelector);else{if(!this._readWhitespace())break;ws=new Combinator(tokenStream.token().value,tokenStream.token().startLine,tokenStream.token().startCol),combinator=this._combinator(),nextSelector=this._simple_selector_sequence(),null===nextSelector?null!==combinator&&this._unexpectedToken(tokenStream.LT(1)):(null!==combinator?selector.push(combinator):selector.push(ws),selector.push(nextSelector))}return new Selector(selector,selector[0].line,selector[0].col)},_simple_selector_sequence:function(){var line,col,tokenStream=this._tokenStream,elementName=null,modifiers=[],selectorText=\"\",components=[function(){return tokenStream.match(Tokens.HASH)?new SelectorSubPart(tokenStream.token().value,\"id\",tokenStream.token().startLine,tokenStream.token().startCol):null},this._class,this._attrib,this._pseudo,this._negation],i=0,len=components.length,component=null;for(line=tokenStream.LT(1).startLine,col=tokenStream.LT(1).startCol,elementName=this._type_selector(),elementName||(elementName=this._universal()),null!==elementName&&(selectorText+=elementName);;){if(tokenStream.peek()===Tokens.S)break;for(;len>i&&null===component;)component=components[i++].call(this);if(null===component){if(\"\"===selectorText)return null;break}i=0,modifiers.push(component),selectorText+=\"\"+component,component=null}return\"\"!==selectorText?new SelectorPart(elementName,modifiers,selectorText,line,col):null},_type_selector:function(){var tokenStream=this._tokenStream,ns=this._namespace_prefix(),elementName=this._element_name();return elementName?(ns&&(elementName.text=ns+elementName.text,elementName.col-=ns.length),elementName):(ns&&(tokenStream.unget(),ns.length>1&&tokenStream.unget()),null)},_class:function(){var token,tokenStream=this._tokenStream;return tokenStream.match(Tokens.DOT)?(tokenStream.mustMatch(Tokens.IDENT),token=tokenStream.token(),new SelectorSubPart(\".\"+token.value,\"class\",token.startLine,token.startCol-1)):null},_element_name:function(){var token,tokenStream=this._tokenStream;return tokenStream.match(Tokens.IDENT)?(token=tokenStream.token(),new SelectorSubPart(token.value,\"elementName\",token.startLine,token.startCol)):null},_namespace_prefix:function(){var tokenStream=this._tokenStream,value=\"\";return(tokenStream.LA(1)===Tokens.PIPE||tokenStream.LA(2)===Tokens.PIPE)&&(tokenStream.match([Tokens.IDENT,Tokens.STAR])&&(value+=tokenStream.token().value),tokenStream.mustMatch(Tokens.PIPE),value+=\"|\"),value.length?value:null},_universal:function(){var ns,tokenStream=this._tokenStream,value=\"\";return ns=this._namespace_prefix(),ns&&(value+=ns),tokenStream.match(Tokens.STAR)&&(value+=\"*\"),value.length?value:null},_attrib:function(){var ns,token,tokenStream=this._tokenStream,value=null;return tokenStream.match(Tokens.LBRACKET)?(token=tokenStream.token(),value=token.value,value+=this._readWhitespace(),ns=this._namespace_prefix(),ns&&(value+=ns),tokenStream.mustMatch(Tokens.IDENT),value+=tokenStream.token().value,value+=this._readWhitespace(),tokenStream.match([Tokens.PREFIXMATCH,Tokens.SUFFIXMATCH,Tokens.SUBSTRINGMATCH,Tokens.EQUALS,Tokens.INCLUDES,Tokens.DASHMATCH])&&(value+=tokenStream.token().value,value+=this._readWhitespace(),tokenStream.mustMatch([Tokens.IDENT,Tokens.STRING]),value+=tokenStream.token().value,value+=this._readWhitespace()),tokenStream.mustMatch(Tokens.RBRACKET),new SelectorSubPart(value+\"]\",\"attribute\",token.startLine,token.startCol)):null},_pseudo:function(){var line,col,tokenStream=this._tokenStream,pseudo=null,colons=\":\";return tokenStream.match(Tokens.COLON)&&(tokenStream.match(Tokens.COLON)&&(colons+=\":\"),tokenStream.match(Tokens.IDENT)?(pseudo=tokenStream.token().value,line=tokenStream.token().startLine,col=tokenStream.token().startCol-colons.length):tokenStream.peek()==Tokens.FUNCTION&&(line=tokenStream.LT(1).startLine,col=tokenStream.LT(1).startCol-colons.length,pseudo=this._functional_pseudo()),pseudo&&(pseudo=new SelectorSubPart(colons+pseudo,\"pseudo\",line,col))),pseudo},_functional_pseudo:function(){var tokenStream=this._tokenStream,value=null;return tokenStream.match(Tokens.FUNCTION)&&(value=tokenStream.token().value,value+=this._readWhitespace(),value+=this._expression(),tokenStream.mustMatch(Tokens.RPAREN),value+=\")\"),value},_expression:function(){for(var tokenStream=this._tokenStream,value=\"\";tokenStream.match([Tokens.PLUS,Tokens.MINUS,Tokens.DIMENSION,Tokens.NUMBER,Tokens.STRING,Tokens.IDENT,Tokens.LENGTH,Tokens.FREQ,Tokens.ANGLE,Tokens.TIME,Tokens.RESOLUTION,Tokens.SLASH]);)value+=tokenStream.token().value,value+=this._readWhitespace();return value.length?value:null},_negation:function(){var line,col,arg,tokenStream=this._tokenStream,value=\"\",subpart=null;return tokenStream.match(Tokens.NOT)&&(value=tokenStream.token().value,line=tokenStream.token().startLine,col=tokenStream.token().startCol,value+=this._readWhitespace(),arg=this._negation_arg(),value+=arg,value+=this._readWhitespace(),tokenStream.match(Tokens.RPAREN),value+=tokenStream.token().value,subpart=new SelectorSubPart(value,\"not\",line,col),subpart.args.push(arg)),subpart},_negation_arg:function(){var line,col,part,tokenStream=this._tokenStream,args=[this._type_selector,this._universal,function(){return tokenStream.match(Tokens.HASH)?new SelectorSubPart(tokenStream.token().value,\"id\",tokenStream.token().startLine,tokenStream.token().startCol):null},this._class,this._attrib,this._pseudo],arg=null,i=0,len=args.length;for(line=tokenStream.LT(1).startLine,col=tokenStream.LT(1).startCol;len>i&&null===arg;)arg=args[i].call(this),i++;return null===arg&&this._unexpectedToken(tokenStream.LT(1)),part=\"elementName\"==arg.type?new SelectorPart(arg,[],\"\"+arg,line,col):new SelectorPart(null,[arg],\"\"+arg,line,col)},_declaration:function(){var tokenStream=this._tokenStream,property=null,expr=null,prio=null,invalid=null,propertyName=\"\";if(property=this._property(),null!==property){tokenStream.mustMatch(Tokens.COLON),this._readWhitespace(),expr=this._expr(),expr&&0!==expr.length||this._unexpectedToken(tokenStream.LT(1)),prio=this._prio(),propertyName=\"\"+property,(this.options.starHack&&\"*\"==property.hack||this.options.underscoreHack&&\"_\"==property.hack)&&(propertyName=property.text);try{this._validateProperty(propertyName,expr)}catch(ex){invalid=ex}return this.fire({type:\"property\",property:property,value:expr,important:prio,line:property.line,col:property.col,invalid:invalid}),!0}return!1},_prio:function(){var tokenStream=this._tokenStream,result=tokenStream.match(Tokens.IMPORTANT_SYM);return this._readWhitespace(),result},_expr:function(inFunction){var values=(this._tokenStream,[]),value=null,operator=null;if(value=this._term(inFunction),null!==value)for(values.push(value);;){if(operator=this._operator(inFunction),operator&&values.push(operator),value=this._term(inFunction),null===value)break;\nvalues.push(value)}return values.length>0?new PropertyValue(values,values[0].line,values[0].col):null},_term:function(inFunction){var token,line,col,tokenStream=this._tokenStream,unary=null,value=null,endChar=null;return unary=this._unary_operator(),null!==unary&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol),tokenStream.peek()==Tokens.IE_FUNCTION&&this.options.ieFilters?(value=this._ie_function(),null===unary&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol)):inFunction&&tokenStream.match([Tokens.LPAREN,Tokens.LBRACE,Tokens.LBRACKET])?(token=tokenStream.token(),endChar=token.endChar,value=token.value+this._expr(inFunction).text,null===unary&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol),tokenStream.mustMatch(Tokens.type(endChar)),value+=endChar,this._readWhitespace()):tokenStream.match([Tokens.NUMBER,Tokens.PERCENTAGE,Tokens.LENGTH,Tokens.ANGLE,Tokens.TIME,Tokens.FREQ,Tokens.STRING,Tokens.IDENT,Tokens.URI,Tokens.UNICODE_RANGE])?(value=tokenStream.token().value,null===unary&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol),this._readWhitespace()):(token=this._hexcolor(),null===token?(null===unary&&(line=tokenStream.LT(1).startLine,col=tokenStream.LT(1).startCol),null===value&&(value=tokenStream.LA(3)==Tokens.EQUALS&&this.options.ieFilters?this._ie_function():this._function())):(value=token.value,null===unary&&(line=token.startLine,col=token.startCol))),null!==value?new PropertyValuePart(null!==unary?unary+value:value,line,col):null},_function:function(){var lt,tokenStream=this._tokenStream,functionText=null,expr=null;if(tokenStream.match(Tokens.FUNCTION)){if(functionText=tokenStream.token().value,this._readWhitespace(),expr=this._expr(!0),functionText+=expr,this.options.ieFilters&&tokenStream.peek()==Tokens.EQUALS)do for(this._readWhitespace()&&(functionText+=tokenStream.token().value),tokenStream.LA(0)==Tokens.COMMA&&(functionText+=tokenStream.token().value),tokenStream.match(Tokens.IDENT),functionText+=tokenStream.token().value,tokenStream.match(Tokens.EQUALS),functionText+=tokenStream.token().value,lt=tokenStream.peek();lt!=Tokens.COMMA&&lt!=Tokens.S&&lt!=Tokens.RPAREN;)tokenStream.get(),functionText+=tokenStream.token().value,lt=tokenStream.peek();while(tokenStream.match([Tokens.COMMA,Tokens.S]));tokenStream.match(Tokens.RPAREN),functionText+=\")\",this._readWhitespace()}return functionText},_ie_function:function(){var lt,tokenStream=this._tokenStream,functionText=null;if(tokenStream.match([Tokens.IE_FUNCTION,Tokens.FUNCTION])){functionText=tokenStream.token().value;do for(this._readWhitespace()&&(functionText+=tokenStream.token().value),tokenStream.LA(0)==Tokens.COMMA&&(functionText+=tokenStream.token().value),tokenStream.match(Tokens.IDENT),functionText+=tokenStream.token().value,tokenStream.match(Tokens.EQUALS),functionText+=tokenStream.token().value,lt=tokenStream.peek();lt!=Tokens.COMMA&&lt!=Tokens.S&&lt!=Tokens.RPAREN;)tokenStream.get(),functionText+=tokenStream.token().value,lt=tokenStream.peek();while(tokenStream.match([Tokens.COMMA,Tokens.S]));tokenStream.match(Tokens.RPAREN),functionText+=\")\",this._readWhitespace()}return functionText},_hexcolor:function(){var color,tokenStream=this._tokenStream,token=null;if(tokenStream.match(Tokens.HASH)){if(token=tokenStream.token(),color=token.value,!/#[a-f0-9]{3,6}/i.test(color))throw new SyntaxError(\"Expected a hex color but found '\"+color+\"' at line \"+token.startLine+\", col \"+token.startCol+\".\",token.startLine,token.startCol);this._readWhitespace()}return token},_keyframes:function(){var token,tt,name,tokenStream=this._tokenStream,prefix=\"\";for(tokenStream.mustMatch(Tokens.KEYFRAMES_SYM),token=tokenStream.token(),/^@\\-([^\\-]+)\\-/.test(token.value)&&(prefix=RegExp.$1),this._readWhitespace(),name=this._keyframe_name(),this._readWhitespace(),tokenStream.mustMatch(Tokens.LBRACE),this.fire({type:\"startkeyframes\",name:name,prefix:prefix,line:token.startLine,col:token.startCol}),this._readWhitespace(),tt=tokenStream.peek();tt==Tokens.IDENT||tt==Tokens.PERCENTAGE;)this._keyframe_rule(),this._readWhitespace(),tt=tokenStream.peek();this.fire({type:\"endkeyframes\",name:name,prefix:prefix,line:token.startLine,col:token.startCol}),this._readWhitespace(),tokenStream.mustMatch(Tokens.RBRACE)},_keyframe_name:function(){var tokenStream=this._tokenStream;return tokenStream.mustMatch([Tokens.IDENT,Tokens.STRING]),SyntaxUnit.fromToken(tokenStream.token())},_keyframe_rule:function(){var keyList=(this._tokenStream,this._key_list());this.fire({type:\"startkeyframerule\",keys:keyList,line:keyList[0].line,col:keyList[0].col}),this._readDeclarations(!0),this.fire({type:\"endkeyframerule\",keys:keyList,line:keyList[0].line,col:keyList[0].col})},_key_list:function(){var tokenStream=this._tokenStream,keyList=[];for(keyList.push(this._key()),this._readWhitespace();tokenStream.match(Tokens.COMMA);)this._readWhitespace(),keyList.push(this._key()),this._readWhitespace();return keyList},_key:function(){var token,tokenStream=this._tokenStream;if(tokenStream.match(Tokens.PERCENTAGE))return SyntaxUnit.fromToken(tokenStream.token());if(tokenStream.match(Tokens.IDENT)){if(token=tokenStream.token(),/from|to/i.test(token.value))return SyntaxUnit.fromToken(token);tokenStream.unget()}this._unexpectedToken(tokenStream.LT(1))},_skipCruft:function(){for(;this._tokenStream.match([Tokens.S,Tokens.CDO,Tokens.CDC]););},_readDeclarations:function(checkStart,readMargins){var tt,tokenStream=this._tokenStream;this._readWhitespace(),checkStart&&tokenStream.mustMatch(Tokens.LBRACE),this._readWhitespace();try{for(;;){if(tokenStream.match(Tokens.SEMICOLON)||readMargins&&this._margin());else{if(!this._declaration())break;if(!tokenStream.match(Tokens.SEMICOLON))break}this._readWhitespace()}tokenStream.mustMatch(Tokens.RBRACE),this._readWhitespace()}catch(ex){if(!(ex instanceof SyntaxError)||this.options.strict)throw ex;if(this.fire({type:\"error\",error:ex,message:ex.message,line:ex.line,col:ex.col}),tt=tokenStream.advance([Tokens.SEMICOLON,Tokens.RBRACE]),tt==Tokens.SEMICOLON)this._readDeclarations(!1,readMargins);else if(tt!=Tokens.RBRACE)throw ex}},_readWhitespace:function(){for(var tokenStream=this._tokenStream,ws=\"\";tokenStream.match(Tokens.S);)ws+=tokenStream.token().value;return ws},_unexpectedToken:function(token){throw new SyntaxError(\"Unexpected token '\"+token.value+\"' at line \"+token.startLine+\", col \"+token.startCol+\".\",token.startLine,token.startCol)},_verifyEnd:function(){this._tokenStream.LA(1)!=Tokens.EOF&&this._unexpectedToken(this._tokenStream.LT(1))},_validateProperty:function(property,value){Validation.validate(property,value)},parse:function(input){this._tokenStream=new TokenStream(input,Tokens),this._stylesheet()},parseStyleSheet:function(input){return this.parse(input)},parseMediaQuery:function(input){this._tokenStream=new TokenStream(input,Tokens);var result=this._media_query();return this._verifyEnd(),result},parsePropertyValue:function(input){this._tokenStream=new TokenStream(input,Tokens),this._readWhitespace();var result=this._expr();return this._readWhitespace(),this._verifyEnd(),result},parseRule:function(input){this._tokenStream=new TokenStream(input,Tokens),this._readWhitespace();var result=this._ruleset();return this._readWhitespace(),this._verifyEnd(),result},parseSelector:function(input){this._tokenStream=new TokenStream(input,Tokens),this._readWhitespace();var result=this._selector();return this._readWhitespace(),this._verifyEnd(),result},parseStyleAttribute:function(input){input+=\"}\",this._tokenStream=new TokenStream(input,Tokens),this._readDeclarations()}};for(prop in additions)additions.hasOwnProperty(prop)&&(proto[prop]=additions[prop]);return proto}();var Properties={\"align-items\":\"flex-start | flex-end | center | baseline | stretch\",\"align-content\":\"flex-start | flex-end | center | space-between | space-around | stretch\",\"align-self\":\"auto | flex-start | flex-end | center | baseline | stretch\",\"-webkit-align-items\":\"flex-start | flex-end | center | baseline | stretch\",\"-webkit-align-content\":\"flex-start | flex-end | center | space-between | space-around | stretch\",\"-webkit-align-self\":\"auto | flex-start | flex-end | center | baseline | stretch\",\"alignment-adjust\":\"auto | baseline | before-edge | text-before-edge | middle | central | after-edge | text-after-edge | ideographic | alphabetic | hanging | mathematical | <percentage> | <length>\",\"alignment-baseline\":\"baseline | use-script | before-edge | text-before-edge | after-edge | text-after-edge | central | middle | ideographic | alphabetic | hanging | mathematical\",animation:1,\"animation-delay\":{multi:\"<time>\",comma:!0},\"animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"animation-duration\":{multi:\"<time>\",comma:!0},\"animation-fill-mode\":{multi:\"none | forwards | backwards | both\",comma:!0},\"animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"animation-name\":{multi:\"none | <ident>\",comma:!0},\"animation-play-state\":{multi:\"running | paused\",comma:!0},\"animation-timing-function\":1,\"-moz-animation-delay\":{multi:\"<time>\",comma:!0},\"-moz-animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"-moz-animation-duration\":{multi:\"<time>\",comma:!0},\"-moz-animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"-moz-animation-name\":{multi:\"none | <ident>\",comma:!0},\"-moz-animation-play-state\":{multi:\"running | paused\",comma:!0},\"-ms-animation-delay\":{multi:\"<time>\",comma:!0},\"-ms-animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"-ms-animation-duration\":{multi:\"<time>\",comma:!0},\"-ms-animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"-ms-animation-name\":{multi:\"none | <ident>\",comma:!0},\"-ms-animation-play-state\":{multi:\"running | paused\",comma:!0},\"-webkit-animation-delay\":{multi:\"<time>\",comma:!0},\"-webkit-animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"-webkit-animation-duration\":{multi:\"<time>\",comma:!0},\"-webkit-animation-fill-mode\":{multi:\"none | forwards | backwards | both\",comma:!0},\"-webkit-animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"-webkit-animation-name\":{multi:\"none | <ident>\",comma:!0},\"-webkit-animation-play-state\":{multi:\"running | paused\",comma:!0},\"-o-animation-delay\":{multi:\"<time>\",comma:!0},\"-o-animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"-o-animation-duration\":{multi:\"<time>\",comma:!0},\"-o-animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"-o-animation-name\":{multi:\"none | <ident>\",comma:!0},\"-o-animation-play-state\":{multi:\"running | paused\",comma:!0},appearance:\"icon | window | desktop | workspace | document | tooltip | dialog | button | push-button | hyperlink | radio-button | checkbox | menu-item | tab | menu | menubar | pull-down-menu | pop-up-menu | list-menu | radio-group | checkbox-group | outline-tree | range | field | combo-box | signature | password | normal | none | inherit\",azimuth:function(expression){var part,simple=\"<angle> | leftwards | rightwards | inherit\",direction=\"left-side | far-left | left | center-left | center | center-right | right | far-right | right-side\",behind=!1,valid=!1;if(ValidationTypes.isAny(expression,simple)||(ValidationTypes.isAny(expression,\"behind\")&&(behind=!0,valid=!0),ValidationTypes.isAny(expression,direction)&&(valid=!0,behind||ValidationTypes.isAny(expression,\"behind\"))),expression.hasNext())throw part=expression.next(),valid?new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col):new ValidationError(\"Expected (<'azimuth'>) but found '\"+part+\"'.\",part.line,part.col)},\"backface-visibility\":\"visible | hidden\",background:1,\"background-attachment\":{multi:\"<attachment>\",comma:!0},\"background-clip\":{multi:\"<box>\",comma:!0},\"background-color\":\"<color> | inherit\",\"background-image\":{multi:\"<bg-image>\",comma:!0},\"background-origin\":{multi:\"<box>\",comma:!0},\"background-position\":{multi:\"<bg-position>\",comma:!0},\"background-repeat\":{multi:\"<repeat-style>\"},\"background-size\":{multi:\"<bg-size>\",comma:!0},\"baseline-shift\":\"baseline | sub | super | <percentage> | <length>\",behavior:1,binding:1,bleed:\"<length>\",\"bookmark-label\":\"<content> | <attr> | <string>\",\"bookmark-level\":\"none | <integer>\",\"bookmark-state\":\"open | closed\",\"bookmark-target\":\"none | <uri> | <attr>\",border:\"<border-width> || <border-style> || <color>\",\"border-bottom\":\"<border-width> || <border-style> || <color>\",\"border-bottom-color\":\"<color> | inherit\",\"border-bottom-left-radius\":\"<x-one-radius>\",\"border-bottom-right-radius\":\"<x-one-radius>\",\"border-bottom-style\":\"<border-style>\",\"border-bottom-width\":\"<border-width>\",\"border-collapse\":\"collapse | separate | inherit\",\"border-color\":{multi:\"<color> | inherit\",max:4},\"border-image\":1,\"border-image-outset\":{multi:\"<length> | <number>\",max:4},\"border-image-repeat\":{multi:\"stretch | repeat | round\",max:2},\"border-image-slice\":function(expression){var part,valid=!1,numeric=\"<number> | <percentage>\",fill=!1,count=0,max=4;for(ValidationTypes.isAny(expression,\"fill\")&&(fill=!0,valid=!0);expression.hasNext()&&max>count&&(valid=ValidationTypes.isAny(expression,numeric));)count++;if(fill?valid=!0:ValidationTypes.isAny(expression,\"fill\"),expression.hasNext())throw part=expression.next(),valid?new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col):new ValidationError(\"Expected ([<number> | <percentage>]{1,4} && fill?) but found '\"+part+\"'.\",part.line,part.col)},\"border-image-source\":\"<image> | none\",\"border-image-width\":{multi:\"<length> | <percentage> | <number> | auto\",max:4},\"border-left\":\"<border-width> || <border-style> || <color>\",\"border-left-color\":\"<color> | inherit\",\"border-left-style\":\"<border-style>\",\"border-left-width\":\"<border-width>\",\"border-radius\":function(expression){for(var part,valid=!1,simple=\"<length> | <percentage> | inherit\",slash=!1,count=0,max=8;expression.hasNext()&&max>count;){if(valid=ValidationTypes.isAny(expression,simple),!valid){if(!(\"/\"==expression.peek()&&count>0)||slash)break;slash=!0,max=count+5,expression.next()}count++}if(expression.hasNext())throw part=expression.next(),valid?new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col):new ValidationError(\"Expected (<'border-radius'>) but found '\"+part+\"'.\",part.line,part.col)},\"border-right\":\"<border-width> || <border-style> || <color>\",\"border-right-color\":\"<color> | inherit\",\"border-right-style\":\"<border-style>\",\"border-right-width\":\"<border-width>\",\"border-spacing\":{multi:\"<length> | inherit\",max:2},\"border-style\":{multi:\"<border-style>\",max:4},\"border-top\":\"<border-width> || <border-style> || <color>\",\"border-top-color\":\"<color> | inherit\",\"border-top-left-radius\":\"<x-one-radius>\",\"border-top-right-radius\":\"<x-one-radius>\",\"border-top-style\":\"<border-style>\",\"border-top-width\":\"<border-width>\",\"border-width\":{multi:\"<border-width>\",max:4},bottom:\"<margin-width> | inherit\",\"-moz-box-align\":\"start | end | center | baseline | stretch\",\"-moz-box-decoration-break\":\"slice |clone\",\"-moz-box-direction\":\"normal | reverse | inherit\",\"-moz-box-flex\":\"<number>\",\"-moz-box-flex-group\":\"<integer>\",\"-moz-box-lines\":\"single | multiple\",\"-moz-box-ordinal-group\":\"<integer>\",\"-moz-box-orient\":\"horizontal | vertical | inline-axis | block-axis | inherit\",\"-moz-box-pack\":\"start | end | center | justify\",\"-webkit-box-align\":\"start | end | center | baseline | stretch\",\"-webkit-box-decoration-break\":\"slice |clone\",\"-webkit-box-direction\":\"normal | reverse | inherit\",\"-webkit-box-flex\":\"<number>\",\"-webkit-box-flex-group\":\"<integer>\",\"-webkit-box-lines\":\"single | multiple\",\"-webkit-box-ordinal-group\":\"<integer>\",\"-webkit-box-orient\":\"horizontal | vertical | inline-axis | block-axis | inherit\",\"-webkit-box-pack\":\"start | end | center | justify\",\"box-shadow\":function(expression){var part;if(ValidationTypes.isAny(expression,\"none\")){if(expression.hasNext())throw part=expression.next(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)}else Validation.multiProperty(\"<shadow>\",expression,!0,1/0)},\"box-sizing\":\"content-box | border-box | inherit\",\"break-after\":\"auto | always | avoid | left | right | page | column | avoid-page | avoid-column\",\"break-before\":\"auto | always | avoid | left | right | page | column | avoid-page | avoid-column\",\"break-inside\":\"auto | avoid | avoid-page | avoid-column\",\"caption-side\":\"top | bottom | inherit\",clear:\"none | right | left | both | inherit\",clip:1,color:\"<color> | inherit\",\"color-profile\":1,\"column-count\":\"<integer> | auto\",\"column-fill\":\"auto | balance\",\"column-gap\":\"<length> | normal\",\"column-rule\":\"<border-width> || <border-style> || <color>\",\"column-rule-color\":\"<color>\",\"column-rule-style\":\"<border-style>\",\"column-rule-width\":\"<border-width>\",\"column-span\":\"none | all\",\"column-width\":\"<length> | auto\",columns:1,content:1,\"counter-increment\":1,\"counter-reset\":1,crop:\"<shape> | auto\",cue:\"cue-after | cue-before | inherit\",\"cue-after\":1,\"cue-before\":1,cursor:1,direction:\"ltr | rtl | inherit\",display:\"inline | block | list-item | inline-block | table | inline-table | table-row-group | table-header-group | table-footer-group | table-row | table-column-group | table-column | table-cell | table-caption | grid | inline-grid | none | inherit | -moz-box | -moz-inline-block | -moz-inline-box | -moz-inline-grid | -moz-inline-stack | -moz-inline-table | -moz-grid | -moz-grid-group | -moz-grid-line | -moz-groupbox | -moz-deck | -moz-popup | -moz-stack | -moz-marker | -webkit-box | -webkit-inline-box | -ms-flexbox | -ms-inline-flexbox | flex | -webkit-flex | inline-flex | -webkit-inline-flex\",\"dominant-baseline\":1,\"drop-initial-after-adjust\":\"central | middle | after-edge | text-after-edge | ideographic | alphabetic | mathematical | <percentage> | <length>\",\"drop-initial-after-align\":\"baseline | use-script | before-edge | text-before-edge | after-edge | text-after-edge | central | middle | ideographic | alphabetic | hanging | mathematical\",\"drop-initial-before-adjust\":\"before-edge | text-before-edge | central | middle | hanging | mathematical | <percentage> | <length>\",\"drop-initial-before-align\":\"caps-height | baseline | use-script | before-edge | text-before-edge | after-edge | text-after-edge | central | middle | ideographic | alphabetic | hanging | mathematical\",\"drop-initial-size\":\"auto | line | <length> | <percentage>\",\"drop-initial-value\":\"initial | <integer>\",elevation:\"<angle> | below | level | above | higher | lower | inherit\",\"empty-cells\":\"show | hide | inherit\",filter:1,fit:\"fill | hidden | meet | slice\",\"fit-position\":1,flex:\"<flex>\",\"flex-basis\":\"<width>\",\"flex-direction\":\"row | row-reverse | column | column-reverse\",\"flex-flow\":\"<flex-direction> || <flex-wrap>\",\"flex-grow\":\"<number>\",\"flex-shrink\":\"<number>\",\"flex-wrap\":\"nowrap | wrap | wrap-reverse\",\"-webkit-flex\":\"<flex>\",\"-webkit-flex-basis\":\"<width>\",\"-webkit-flex-direction\":\"row | row-reverse | column | column-reverse\",\"-webkit-flex-flow\":\"<flex-direction> || <flex-wrap>\",\"-webkit-flex-grow\":\"<number>\",\"-webkit-flex-shrink\":\"<number>\",\"-webkit-flex-wrap\":\"nowrap | wrap | wrap-reverse\",\"-ms-flex\":\"<flex>\",\"-ms-flex-align\":\"start | end | center | stretch | baseline\",\"-ms-flex-direction\":\"row | row-reverse | column | column-reverse | inherit\",\"-ms-flex-order\":\"<number>\",\"-ms-flex-pack\":\"start | end | center | justify\",\"-ms-flex-wrap\":\"nowrap | wrap | wrap-reverse\",\"float\":\"left | right | none | inherit\",\"float-offset\":1,font:1,\"font-family\":1,\"font-size\":\"<absolute-size> | <relative-size> | <length> | <percentage> | inherit\",\"font-size-adjust\":\"<number> | none | inherit\",\"font-stretch\":\"normal | ultra-condensed | extra-condensed | condensed | semi-condensed | semi-expanded | expanded | extra-expanded | ultra-expanded | inherit\",\"font-style\":\"normal | italic | oblique | inherit\",\"font-variant\":\"normal | small-caps | inherit\",\"font-weight\":\"normal | bold | bolder | lighter | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | inherit\",\"grid-cell-stacking\":\"columns | rows | layer\",\"grid-column\":1,\"grid-columns\":1,\"grid-column-align\":\"start | end | center | stretch\",\"grid-column-sizing\":1,\"grid-column-span\":\"<integer>\",\"grid-flow\":\"none | rows | columns\",\"grid-layer\":\"<integer>\",\"grid-row\":1,\"grid-rows\":1,\"grid-row-align\":\"start | end | center | stretch\",\"grid-row-span\":\"<integer>\",\"grid-row-sizing\":1,\"hanging-punctuation\":1,height:\"<margin-width> | <content-sizing> | inherit\",\"hyphenate-after\":\"<integer> | auto\",\"hyphenate-before\":\"<integer> | auto\",\"hyphenate-character\":\"<string> | auto\",\"hyphenate-lines\":\"no-limit | <integer>\",\"hyphenate-resource\":1,hyphens:\"none | manual | auto\",icon:1,\"image-orientation\":\"angle | auto\",\"image-rendering\":1,\"image-resolution\":1,\"inline-box-align\":\"initial | last | <integer>\",\"justify-content\":\"flex-start | flex-end | center | space-between | space-around\",\"-webkit-justify-content\":\"flex-start | flex-end | center | space-between | space-around\",left:\"<margin-width> | inherit\",\"letter-spacing\":\"<length> | normal | inherit\",\"line-height\":\"<number> | <length> | <percentage> | normal | inherit\",\"line-break\":\"auto | loose | normal | strict\",\"line-stacking\":1,\"line-stacking-ruby\":\"exclude-ruby | include-ruby\",\"line-stacking-shift\":\"consider-shifts | disregard-shifts\",\"line-stacking-strategy\":\"inline-line-height | block-line-height | max-height | grid-height\",\"list-style\":1,\"list-style-image\":\"<uri> | none | inherit\",\"list-style-position\":\"inside | outside | inherit\",\"list-style-type\":\"disc | circle | square | decimal | decimal-leading-zero | lower-roman | upper-roman | lower-greek | lower-latin | upper-latin | armenian | georgian | lower-alpha | upper-alpha | none | inherit\",margin:{multi:\"<margin-width> | inherit\",max:4},\"margin-bottom\":\"<margin-width> | inherit\",\"margin-left\":\"<margin-width> | inherit\",\"margin-right\":\"<margin-width> | inherit\",\"margin-top\":\"<margin-width> | inherit\",mark:1,\"mark-after\":1,\"mark-before\":1,marks:1,\"marquee-direction\":1,\"marquee-play-count\":1,\"marquee-speed\":1,\"marquee-style\":1,\"max-height\":\"<length> | <percentage> | <content-sizing> | none | inherit\",\"max-width\":\"<length> | <percentage> | <content-sizing> | none | inherit\",\"min-height\":\"<length> | <percentage> | <content-sizing> | contain-floats | -moz-contain-floats | -webkit-contain-floats | inherit\",\"min-width\":\"<length> | <percentage> | <content-sizing> | contain-floats | -moz-contain-floats | -webkit-contain-floats | inherit\",\"move-to\":1,\"nav-down\":1,\"nav-index\":1,\"nav-left\":1,\"nav-right\":1,\"nav-up\":1,opacity:\"<number> | inherit\",order:\"<integer>\",\"-webkit-order\":\"<integer>\",orphans:\"<integer> | inherit\",outline:1,\"outline-color\":\"<color> | invert | inherit\",\"outline-offset\":1,\"outline-style\":\"<border-style> | inherit\",\"outline-width\":\"<border-width> | inherit\",overflow:\"visible | hidden | scroll | auto | inherit\",\"overflow-style\":1,\"overflow-wrap\":\"normal | break-word\",\"overflow-x\":1,\"overflow-y\":1,padding:{multi:\"<padding-width> | inherit\",max:4},\"padding-bottom\":\"<padding-width> | inherit\",\"padding-left\":\"<padding-width> | inherit\",\"padding-right\":\"<padding-width> | inherit\",\"padding-top\":\"<padding-width> | inherit\",page:1,\"page-break-after\":\"auto | always | avoid | left | right | inherit\",\"page-break-before\":\"auto | always | avoid | left | right | inherit\",\"page-break-inside\":\"auto | avoid | inherit\",\"page-policy\":1,pause:1,\"pause-after\":1,\"pause-before\":1,perspective:1,\"perspective-origin\":1,phonemes:1,pitch:1,\"pitch-range\":1,\"play-during\":1,\"pointer-events\":\"auto | none | visiblePainted | visibleFill | visibleStroke | visible | painted | fill | stroke | all | inherit\",position:\"static | relative | absolute | fixed | inherit\",\"presentation-level\":1,\"punctuation-trim\":1,quotes:1,\"rendering-intent\":1,resize:1,rest:1,\"rest-after\":1,\"rest-before\":1,richness:1,right:\"<margin-width> | inherit\",rotation:1,\"rotation-point\":1,\"ruby-align\":1,\"ruby-overhang\":1,\"ruby-position\":1,\"ruby-span\":1,size:1,speak:\"normal | none | spell-out | inherit\",\"speak-header\":\"once | always | inherit\",\"speak-numeral\":\"digits | continuous | inherit\",\"speak-punctuation\":\"code | none | inherit\",\"speech-rate\":1,src:1,stress:1,\"string-set\":1,\"table-layout\":\"auto | fixed | inherit\",\"tab-size\":\"<integer> | <length>\",target:1,\"target-name\":1,\"target-new\":1,\"target-position\":1,\"text-align\":\"left | right | center | justify | inherit\",\"text-align-last\":1,\"text-decoration\":1,\"text-emphasis\":1,\"text-height\":1,\"text-indent\":\"<length> | <percentage> | inherit\",\"text-justify\":\"auto | none | inter-word | inter-ideograph | inter-cluster | distribute | kashida\",\"text-outline\":1,\"text-overflow\":1,\"text-rendering\":\"auto | optimizeSpeed | optimizeLegibility | geometricPrecision | inherit\",\"text-shadow\":1,\"text-transform\":\"capitalize | uppercase | lowercase | none | inherit\",\"text-wrap\":\"normal | none | avoid\",top:\"<margin-width> | inherit\",\"-ms-touch-action\":\"auto | none | pan-x | pan-y\",\"touch-action\":\"auto | none | pan-x | pan-y\",transform:1,\"transform-origin\":1,\"transform-style\":1,transition:1,\"transition-delay\":1,\"transition-duration\":1,\"transition-property\":1,\"transition-timing-function\":1,\"unicode-bidi\":\"normal | embed | isolate | bidi-override | isolate-override | plaintext | inherit\",\"user-modify\":\"read-only | read-write | write-only | inherit\",\"user-select\":\"none | text | toggle | element | elements | all | inherit\",\"vertical-align\":\"auto | use-script | baseline | sub | super | top | text-top | central | middle | bottom | text-bottom | <percentage> | <length>\",visibility:\"visible | hidden | collapse | inherit\",\"voice-balance\":1,\"voice-duration\":1,\"voice-family\":1,\"voice-pitch\":1,\"voice-pitch-range\":1,\"voice-rate\":1,\"voice-stress\":1,\"voice-volume\":1,volume:1,\"white-space\":\"normal | pre | nowrap | pre-wrap | pre-line | inherit | -pre-wrap | -o-pre-wrap | -moz-pre-wrap | -hp-pre-wrap\",\"white-space-collapse\":1,widows:\"<integer> | inherit\",width:\"<length> | <percentage> | <content-sizing> | auto | inherit\",\"word-break\":\"normal | keep-all | break-all\",\"word-spacing\":\"<length> | normal | inherit\",\"word-wrap\":\"normal | break-word\",\"writing-mode\":\"horizontal-tb | vertical-rl | vertical-lr | lr-tb | rl-tb | tb-rl | bt-rl | tb-lr | bt-lr | lr-bt | rl-bt | lr | rl | tb | inherit\",\"z-index\":\"<integer> | auto | inherit\",zoom:\"<number> | <percentage> | normal\"};PropertyName.prototype=new SyntaxUnit,PropertyName.prototype.constructor=PropertyName,PropertyName.prototype.toString=function(){return(this.hack?this.hack:\"\")+this.text},PropertyValue.prototype=new SyntaxUnit,PropertyValue.prototype.constructor=PropertyValue,PropertyValueIterator.prototype.count=function(){return this._parts.length},PropertyValueIterator.prototype.isFirst=function(){return 0===this._i},PropertyValueIterator.prototype.hasNext=function(){return this._i<this._parts.length},PropertyValueIterator.prototype.mark=function(){this._marks.push(this._i)},PropertyValueIterator.prototype.peek=function(count){return this.hasNext()?this._parts[this._i+(count||0)]:null},PropertyValueIterator.prototype.next=function(){return this.hasNext()?this._parts[this._i++]:null},PropertyValueIterator.prototype.previous=function(){return this._i>0?this._parts[--this._i]:null},PropertyValueIterator.prototype.restore=function(){this._marks.length&&(this._i=this._marks.pop())},PropertyValuePart.prototype=new SyntaxUnit,PropertyValuePart.prototype.constructor=PropertyValuePart,PropertyValuePart.fromToken=function(token){return new PropertyValuePart(token.value,token.startLine,token.startCol)};var Pseudos={\":first-letter\":1,\":first-line\":1,\":before\":1,\":after\":1};Pseudos.ELEMENT=1,Pseudos.CLASS=2,Pseudos.isElement=function(pseudo){return 0===pseudo.indexOf(\"::\")||Pseudos[pseudo.toLowerCase()]==Pseudos.ELEMENT},Selector.prototype=new SyntaxUnit,Selector.prototype.constructor=Selector,SelectorPart.prototype=new SyntaxUnit,SelectorPart.prototype.constructor=SelectorPart,SelectorSubPart.prototype=new SyntaxUnit,SelectorSubPart.prototype.constructor=SelectorSubPart,Specificity.prototype={constructor:Specificity,compare:function(other){var i,len,comps=[\"a\",\"b\",\"c\",\"d\"];for(i=0,len=comps.length;len>i;i++){if(this[comps[i]]<other[comps[i]])return-1;if(this[comps[i]]>other[comps[i]])return 1}return 0},valueOf:function(){return 1e3*this.a+100*this.b+10*this.c+this.d},toString:function(){return this.a+\",\"+this.b+\",\"+this.c+\",\"+this.d}},Specificity.calculate=function(selector){function updateValues(part){var i,j,len,num,modifier,elementName=part.elementName?part.elementName.text:\"\";for(elementName&&\"*\"!=elementName.charAt(elementName.length-1)&&d++,i=0,len=part.modifiers.length;len>i;i++)switch(modifier=part.modifiers[i],modifier.type){case\"class\":case\"attribute\":c++;break;case\"id\":b++;break;case\"pseudo\":Pseudos.isElement(modifier.text)?d++:c++;break;case\"not\":for(j=0,num=modifier.args.length;num>j;j++)updateValues(modifier.args[j])}}var i,len,part,b=0,c=0,d=0;for(i=0,len=selector.parts.length;len>i;i++)part=selector.parts[i],part instanceof SelectorPart&&updateValues(part);return new Specificity(0,b,c,d)};var h=/^[0-9a-fA-F]$/,nonascii=/^[\\u0080-\\uFFFF]$/,nl=/\\n|\\r\\n|\\r|\\f/;TokenStream.prototype=mix(new TokenStreamBase,{_getToken:function(){var c,reader=this._reader,token=null,startLine=reader.getLine(),startCol=reader.getCol();for(c=reader.read();c;){switch(c){case\"/\":token=\"*\"==reader.peek()?this.commentToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case\"|\":case\"~\":case\"^\":case\"$\":case\"*\":token=\"=\"==reader.peek()?this.comparisonToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case'\"':case\"'\":token=this.stringToken(c,startLine,startCol);break;case\"#\":token=isNameChar(reader.peek())?this.hashToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case\".\":token=isDigit(reader.peek())?this.numberToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case\"-\":token=\"-\"==reader.peek()?this.htmlCommentEndToken(c,startLine,startCol):isNameStart(reader.peek())?this.identOrFunctionToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case\"!\":token=this.importantToken(c,startLine,startCol);break;case\"@\":token=this.atRuleToken(c,startLine,startCol);break;case\":\":token=this.notToken(c,startLine,startCol);break;case\"<\":token=this.htmlCommentStartToken(c,startLine,startCol);break;case\"U\":case\"u\":if(\"+\"==reader.peek()){token=this.unicodeRangeToken(c,startLine,startCol);break}default:token=isDigit(c)?this.numberToken(c,startLine,startCol):isWhitespace(c)?this.whitespaceToken(c,startLine,startCol):isIdentStart(c)?this.identOrFunctionToken(c,startLine,startCol):this.charToken(c,startLine,startCol)}break}return token||null!==c||(token=this.createToken(Tokens.EOF,null,startLine,startCol)),token},createToken:function(tt,value,startLine,startCol,options){var reader=this._reader;return options=options||{},{value:value,type:tt,channel:options.channel,endChar:options.endChar,hide:options.hide||!1,startLine:startLine,startCol:startCol,endLine:reader.getLine(),endCol:reader.getCol()}},atRuleToken:function(first,startLine,startCol){var ident,rule=first,reader=this._reader,tt=Tokens.CHAR;return reader.mark(),ident=this.readName(),rule=first+ident,tt=Tokens.type(rule.toLowerCase()),(tt==Tokens.CHAR||tt==Tokens.UNKNOWN)&&(rule.length>1?tt=Tokens.UNKNOWN_SYM:(tt=Tokens.CHAR,rule=first,reader.reset())),this.createToken(tt,rule,startLine,startCol)},charToken:function(c,startLine,startCol){var tt=Tokens.type(c),opts={};return-1==tt?tt=Tokens.CHAR:opts.endChar=Tokens[tt].endChar,this.createToken(tt,c,startLine,startCol,opts)},commentToken:function(first,startLine,startCol){var comment=(this._reader,this.readComment(first));return this.createToken(Tokens.COMMENT,comment,startLine,startCol)},comparisonToken:function(c,startLine,startCol){var reader=this._reader,comparison=c+reader.read(),tt=Tokens.type(comparison)||Tokens.CHAR;return this.createToken(tt,comparison,startLine,startCol)\n},hashToken:function(first,startLine,startCol){var name=(this._reader,this.readName(first));return this.createToken(Tokens.HASH,name,startLine,startCol)},htmlCommentStartToken:function(first,startLine,startCol){var reader=this._reader,text=first;return reader.mark(),text+=reader.readCount(3),\"<!--\"==text?this.createToken(Tokens.CDO,text,startLine,startCol):(reader.reset(),this.charToken(first,startLine,startCol))},htmlCommentEndToken:function(first,startLine,startCol){var reader=this._reader,text=first;return reader.mark(),text+=reader.readCount(2),\"-->\"==text?this.createToken(Tokens.CDC,text,startLine,startCol):(reader.reset(),this.charToken(first,startLine,startCol))},identOrFunctionToken:function(first,startLine,startCol){var reader=this._reader,ident=this.readName(first),tt=Tokens.IDENT;return\"(\"==reader.peek()?(ident+=reader.read(),\"url(\"==ident.toLowerCase()?(tt=Tokens.URI,ident=this.readURI(ident),\"url(\"==ident.toLowerCase()&&(tt=Tokens.FUNCTION)):tt=Tokens.FUNCTION):\":\"==reader.peek()&&\"progid\"==ident.toLowerCase()&&(ident+=reader.readTo(\"(\"),tt=Tokens.IE_FUNCTION),this.createToken(tt,ident,startLine,startCol)},importantToken:function(first,startLine,startCol){var temp,c,reader=this._reader,important=first,tt=Tokens.CHAR;for(reader.mark(),c=reader.read();c;){if(\"/\"==c){if(\"*\"!=reader.peek())break;if(temp=this.readComment(c),\"\"===temp)break}else{if(!isWhitespace(c)){if(/i/i.test(c)){temp=reader.readCount(8),/mportant/i.test(temp)&&(important+=c+temp,tt=Tokens.IMPORTANT_SYM);break}break}important+=c+this.readWhitespace()}c=reader.read()}return tt==Tokens.CHAR?(reader.reset(),this.charToken(first,startLine,startCol)):this.createToken(tt,important,startLine,startCol)},notToken:function(first,startLine,startCol){var reader=this._reader,text=first;return reader.mark(),text+=reader.readCount(4),\":not(\"==text.toLowerCase()?this.createToken(Tokens.NOT,text,startLine,startCol):(reader.reset(),this.charToken(first,startLine,startCol))},numberToken:function(first,startLine,startCol){var ident,reader=this._reader,value=this.readNumber(first),tt=Tokens.NUMBER,c=reader.peek();return isIdentStart(c)?(ident=this.readName(reader.read()),value+=ident,tt=/^em$|^ex$|^px$|^gd$|^rem$|^vw$|^vh$|^vmax$|^vmin$|^ch$|^cm$|^mm$|^in$|^pt$|^pc$/i.test(ident)?Tokens.LENGTH:/^deg|^rad$|^grad$/i.test(ident)?Tokens.ANGLE:/^ms$|^s$/i.test(ident)?Tokens.TIME:/^hz$|^khz$/i.test(ident)?Tokens.FREQ:/^dpi$|^dpcm$/i.test(ident)?Tokens.RESOLUTION:Tokens.DIMENSION):\"%\"==c&&(value+=reader.read(),tt=Tokens.PERCENTAGE),this.createToken(tt,value,startLine,startCol)},stringToken:function(first,startLine,startCol){for(var delim=first,string=first,reader=this._reader,prev=first,tt=Tokens.STRING,c=reader.read();c&&(string+=c,c!=delim||\"\\\\\"==prev);){if(isNewLine(reader.peek())&&\"\\\\\"!=c){tt=Tokens.INVALID;break}prev=c,c=reader.read()}return null===c&&(tt=Tokens.INVALID),this.createToken(tt,string,startLine,startCol)},unicodeRangeToken:function(first,startLine,startCol){var temp,reader=this._reader,value=first,tt=Tokens.CHAR;return\"+\"==reader.peek()&&(reader.mark(),value+=reader.read(),value+=this.readUnicodeRangePart(!0),2==value.length?reader.reset():(tt=Tokens.UNICODE_RANGE,-1==value.indexOf(\"?\")&&\"-\"==reader.peek()&&(reader.mark(),temp=reader.read(),temp+=this.readUnicodeRangePart(!1),1==temp.length?reader.reset():value+=temp))),this.createToken(tt,value,startLine,startCol)},whitespaceToken:function(first,startLine,startCol){var value=(this._reader,first+this.readWhitespace());return this.createToken(Tokens.S,value,startLine,startCol)},readUnicodeRangePart:function(allowQuestionMark){for(var reader=this._reader,part=\"\",c=reader.peek();isHexDigit(c)&&6>part.length;)reader.read(),part+=c,c=reader.peek();if(allowQuestionMark)for(;\"?\"==c&&6>part.length;)reader.read(),part+=c,c=reader.peek();return part},readWhitespace:function(){for(var reader=this._reader,whitespace=\"\",c=reader.peek();isWhitespace(c);)reader.read(),whitespace+=c,c=reader.peek();return whitespace},readNumber:function(first){for(var reader=this._reader,number=first,hasDot=\".\"==first,c=reader.peek();c;){if(isDigit(c))number+=reader.read();else{if(\".\"!=c)break;if(hasDot)break;hasDot=!0,number+=reader.read()}c=reader.peek()}return number},readString:function(){for(var reader=this._reader,delim=reader.read(),string=delim,prev=delim,c=reader.peek();c&&(c=reader.read(),string+=c,c!=delim||\"\\\\\"==prev);){if(isNewLine(reader.peek())&&\"\\\\\"!=c){string=\"\";break}prev=c,c=reader.peek()}return null===c&&(string=\"\"),string},readURI:function(first){var reader=this._reader,uri=first,inner=\"\",c=reader.peek();for(reader.mark();c&&isWhitespace(c);)reader.read(),c=reader.peek();for(inner=\"'\"==c||'\"'==c?this.readString():this.readURL(),c=reader.peek();c&&isWhitespace(c);)reader.read(),c=reader.peek();return\"\"===inner||\")\"!=c?(uri=first,reader.reset()):uri+=inner+reader.read(),uri},readURL:function(){for(var reader=this._reader,url=\"\",c=reader.peek();/^[!#$%&\\\\*-~]$/.test(c);)url+=reader.read(),c=reader.peek();return url},readName:function(first){for(var reader=this._reader,ident=first||\"\",c=reader.peek();;)if(\"\\\\\"==c)ident+=this.readEscape(reader.read()),c=reader.peek();else{if(!c||!isNameChar(c))break;ident+=reader.read(),c=reader.peek()}return ident},readEscape:function(first){var reader=this._reader,cssEscape=first||\"\",i=0,c=reader.peek();if(isHexDigit(c))do cssEscape+=reader.read(),c=reader.peek();while(c&&isHexDigit(c)&&6>++i);return 3==cssEscape.length&&/\\s/.test(c)||7==cssEscape.length||1==cssEscape.length?reader.read():c=\"\",cssEscape+c},readComment:function(first){var reader=this._reader,comment=first||\"\",c=reader.read();if(\"*\"==c){for(;c;){if(comment+=c,comment.length>2&&\"*\"==c&&\"/\"==reader.peek()){comment+=reader.read();break}c=reader.read()}return comment}return\"\"}});var Tokens=[{name:\"CDO\"},{name:\"CDC\"},{name:\"S\",whitespace:!0},{name:\"COMMENT\",comment:!0,hide:!0,channel:\"comment\"},{name:\"INCLUDES\",text:\"~=\"},{name:\"DASHMATCH\",text:\"|=\"},{name:\"PREFIXMATCH\",text:\"^=\"},{name:\"SUFFIXMATCH\",text:\"$=\"},{name:\"SUBSTRINGMATCH\",text:\"*=\"},{name:\"STRING\"},{name:\"IDENT\"},{name:\"HASH\"},{name:\"IMPORT_SYM\",text:\"@import\"},{name:\"PAGE_SYM\",text:\"@page\"},{name:\"MEDIA_SYM\",text:\"@media\"},{name:\"FONT_FACE_SYM\",text:\"@font-face\"},{name:\"CHARSET_SYM\",text:\"@charset\"},{name:\"NAMESPACE_SYM\",text:\"@namespace\"},{name:\"VIEWPORT_SYM\",text:[\"@viewport\",\"@-ms-viewport\"]},{name:\"UNKNOWN_SYM\"},{name:\"KEYFRAMES_SYM\",text:[\"@keyframes\",\"@-webkit-keyframes\",\"@-moz-keyframes\",\"@-o-keyframes\"]},{name:\"IMPORTANT_SYM\"},{name:\"LENGTH\"},{name:\"ANGLE\"},{name:\"TIME\"},{name:\"FREQ\"},{name:\"DIMENSION\"},{name:\"PERCENTAGE\"},{name:\"NUMBER\"},{name:\"URI\"},{name:\"FUNCTION\"},{name:\"UNICODE_RANGE\"},{name:\"INVALID\"},{name:\"PLUS\",text:\"+\"},{name:\"GREATER\",text:\">\"},{name:\"COMMA\",text:\",\"},{name:\"TILDE\",text:\"~\"},{name:\"NOT\"},{name:\"TOPLEFTCORNER_SYM\",text:\"@top-left-corner\"},{name:\"TOPLEFT_SYM\",text:\"@top-left\"},{name:\"TOPCENTER_SYM\",text:\"@top-center\"},{name:\"TOPRIGHT_SYM\",text:\"@top-right\"},{name:\"TOPRIGHTCORNER_SYM\",text:\"@top-right-corner\"},{name:\"BOTTOMLEFTCORNER_SYM\",text:\"@bottom-left-corner\"},{name:\"BOTTOMLEFT_SYM\",text:\"@bottom-left\"},{name:\"BOTTOMCENTER_SYM\",text:\"@bottom-center\"},{name:\"BOTTOMRIGHT_SYM\",text:\"@bottom-right\"},{name:\"BOTTOMRIGHTCORNER_SYM\",text:\"@bottom-right-corner\"},{name:\"LEFTTOP_SYM\",text:\"@left-top\"},{name:\"LEFTMIDDLE_SYM\",text:\"@left-middle\"},{name:\"LEFTBOTTOM_SYM\",text:\"@left-bottom\"},{name:\"RIGHTTOP_SYM\",text:\"@right-top\"},{name:\"RIGHTMIDDLE_SYM\",text:\"@right-middle\"},{name:\"RIGHTBOTTOM_SYM\",text:\"@right-bottom\"},{name:\"RESOLUTION\",state:\"media\"},{name:\"IE_FUNCTION\"},{name:\"CHAR\"},{name:\"PIPE\",text:\"|\"},{name:\"SLASH\",text:\"/\"},{name:\"MINUS\",text:\"-\"},{name:\"STAR\",text:\"*\"},{name:\"LBRACE\",endChar:\"}\",text:\"{\"},{name:\"RBRACE\",text:\"}\"},{name:\"LBRACKET\",endChar:\"]\",text:\"[\"},{name:\"RBRACKET\",text:\"]\"},{name:\"EQUALS\",text:\"=\"},{name:\"COLON\",text:\":\"},{name:\"SEMICOLON\",text:\";\"},{name:\"LPAREN\",endChar:\")\",text:\"(\"},{name:\"RPAREN\",text:\")\"},{name:\"DOT\",text:\".\"}];(function(){var nameMap=[],typeMap={};Tokens.UNKNOWN=-1,Tokens.unshift({name:\"EOF\"});for(var i=0,len=Tokens.length;len>i;i++)if(nameMap.push(Tokens[i].name),Tokens[Tokens[i].name]=i,Tokens[i].text)if(Tokens[i].text instanceof Array)for(var j=0;Tokens[i].text.length>j;j++)typeMap[Tokens[i].text[j]]=i;else typeMap[Tokens[i].text]=i;Tokens.name=function(tt){return nameMap[tt]},Tokens.type=function(c){return typeMap[c]||-1}})();var Validation={validate:function(property,value){var name=(\"\"+property).toLowerCase(),expression=(value.parts,new PropertyValueIterator(value)),spec=Properties[name];if(spec)\"number\"!=typeof spec&&(\"string\"==typeof spec?spec.indexOf(\"||\")>-1?this.groupProperty(spec,expression):this.singleProperty(spec,expression,1):spec.multi?this.multiProperty(spec.multi,expression,spec.comma,spec.max||1/0):\"function\"==typeof spec&&spec(expression));else if(0!==name.indexOf(\"-\"))throw new ValidationError(\"Unknown property '\"+property+\"'.\",property.line,property.col)},singleProperty:function(types,expression,max){for(var part,result=!1,value=expression.value,count=0;expression.hasNext()&&max>count&&(result=ValidationTypes.isAny(expression,types));)count++;if(!result)throw expression.hasNext()&&!expression.isFirst()?(part=expression.peek(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)):new ValidationError(\"Expected (\"+types+\") but found '\"+value+\"'.\",value.line,value.col);if(expression.hasNext())throw part=expression.next(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)},multiProperty:function(types,expression,comma,max){for(var part,result=!1,value=expression.value,count=0;expression.hasNext()&&!result&&max>count&&ValidationTypes.isAny(expression,types);)if(count++,expression.hasNext()){if(comma){if(\",\"!=expression.peek())break;part=expression.next()}}else result=!0;if(!result)throw expression.hasNext()&&!expression.isFirst()?(part=expression.peek(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)):(part=expression.previous(),comma&&\",\"==part?new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col):new ValidationError(\"Expected (\"+types+\") but found '\"+value+\"'.\",value.line,value.col));if(expression.hasNext())throw part=expression.next(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)},groupProperty:function(types,expression){for(var name,part,result=!1,value=expression.value,typeCount=types.split(\"||\").length,groups={count:0},partial=!1;expression.hasNext()&&!result&&(name=ValidationTypes.isAnyOfGroup(expression,types))&&!groups[name];)groups[name]=1,groups.count++,partial=!0,groups.count!=typeCount&&expression.hasNext()||(result=!0);if(!result)throw partial&&expression.hasNext()?(part=expression.peek(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)):new ValidationError(\"Expected (\"+types+\") but found '\"+value+\"'.\",value.line,value.col);if(expression.hasNext())throw part=expression.next(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)}};ValidationError.prototype=Error();var ValidationTypes={isLiteral:function(part,literals){var i,len,text=(\"\"+part.text).toLowerCase(),args=literals.split(\" | \"),found=!1;for(i=0,len=args.length;len>i&&!found;i++)text==args[i].toLowerCase()&&(found=!0);return found},isSimple:function(type){return!!this.simple[type]},isComplex:function(type){return!!this.complex[type]},isAny:function(expression,types){var i,len,args=types.split(\" | \"),found=!1;for(i=0,len=args.length;len>i&&!found&&expression.hasNext();i++)found=this.isType(expression,args[i]);return found},isAnyOfGroup:function(expression,types){var i,len,args=types.split(\" || \"),found=!1;for(i=0,len=args.length;len>i&&!found;i++)found=this.isType(expression,args[i]);return found?args[i-1]:!1},isType:function(expression,type){var part=expression.peek(),result=!1;return\"<\"!=type.charAt(0)?(result=this.isLiteral(part,type),result&&expression.next()):this.simple[type]?(result=this.simple[type](part),result&&expression.next()):result=this.complex[type](expression),result},simple:{\"<absolute-size>\":function(part){return ValidationTypes.isLiteral(part,\"xx-small | x-small | small | medium | large | x-large | xx-large\")},\"<attachment>\":function(part){return ValidationTypes.isLiteral(part,\"scroll | fixed | local\")},\"<attr>\":function(part){return\"function\"==part.type&&\"attr\"==part.name},\"<bg-image>\":function(part){return this[\"<image>\"](part)||this[\"<gradient>\"](part)||\"none\"==part},\"<gradient>\":function(part){return\"function\"==part.type&&/^(?:\\-(?:ms|moz|o|webkit)\\-)?(?:repeating\\-)?(?:radial\\-|linear\\-)?gradient/i.test(part)},\"<box>\":function(part){return ValidationTypes.isLiteral(part,\"padding-box | border-box | content-box\")},\"<content>\":function(part){return\"function\"==part.type&&\"content\"==part.name},\"<relative-size>\":function(part){return ValidationTypes.isLiteral(part,\"smaller | larger\")},\"<ident>\":function(part){return\"identifier\"==part.type},\"<length>\":function(part){return\"function\"==part.type&&/^(?:\\-(?:ms|moz|o|webkit)\\-)?calc/i.test(part)?!0:\"length\"==part.type||\"number\"==part.type||\"integer\"==part.type||\"0\"==part},\"<color>\":function(part){return\"color\"==part.type||\"transparent\"==part},\"<number>\":function(part){return\"number\"==part.type||this[\"<integer>\"](part)},\"<integer>\":function(part){return\"integer\"==part.type},\"<line>\":function(part){return\"integer\"==part.type},\"<angle>\":function(part){return\"angle\"==part.type},\"<uri>\":function(part){return\"uri\"==part.type},\"<image>\":function(part){return this[\"<uri>\"](part)},\"<percentage>\":function(part){return\"percentage\"==part.type||\"0\"==part},\"<border-width>\":function(part){return this[\"<length>\"](part)||ValidationTypes.isLiteral(part,\"thin | medium | thick\")},\"<border-style>\":function(part){return ValidationTypes.isLiteral(part,\"none | hidden | dotted | dashed | solid | double | groove | ridge | inset | outset\")},\"<content-sizing>\":function(part){return ValidationTypes.isLiteral(part,\"fill-available | -moz-available | -webkit-fill-available | max-content | -moz-max-content | -webkit-max-content | min-content | -moz-min-content | -webkit-min-content | fit-content | -moz-fit-content | -webkit-fit-content\")},\"<margin-width>\":function(part){return this[\"<length>\"](part)||this[\"<percentage>\"](part)||ValidationTypes.isLiteral(part,\"auto\")},\"<padding-width>\":function(part){return this[\"<length>\"](part)||this[\"<percentage>\"](part)},\"<shape>\":function(part){return\"function\"==part.type&&(\"rect\"==part.name||\"inset-rect\"==part.name)},\"<time>\":function(part){return\"time\"==part.type},\"<flex-grow>\":function(part){return this[\"<number>\"](part)},\"<flex-shrink>\":function(part){return this[\"<number>\"](part)},\"<width>\":function(part){return this[\"<margin-width>\"](part)},\"<flex-basis>\":function(part){return this[\"<width>\"](part)},\"<flex-direction>\":function(part){return ValidationTypes.isLiteral(part,\"row | row-reverse | column | column-reverse\")},\"<flex-wrap>\":function(part){return ValidationTypes.isLiteral(part,\"nowrap | wrap | wrap-reverse\")}},complex:{\"<bg-position>\":function(expression){for(var result=!1,numeric=\"<percentage> | <length>\",xDir=\"left | right\",yDir=\"top | bottom\",count=0;expression.peek(count)&&\",\"!=expression.peek(count);)count++;return 3>count?ValidationTypes.isAny(expression,xDir+\" | center | \"+numeric)?(result=!0,ValidationTypes.isAny(expression,yDir+\" | center | \"+numeric)):ValidationTypes.isAny(expression,yDir)&&(result=!0,ValidationTypes.isAny(expression,xDir+\" | center\")):ValidationTypes.isAny(expression,xDir)?ValidationTypes.isAny(expression,yDir)?(result=!0,ValidationTypes.isAny(expression,numeric)):ValidationTypes.isAny(expression,numeric)&&(ValidationTypes.isAny(expression,yDir)?(result=!0,ValidationTypes.isAny(expression,numeric)):ValidationTypes.isAny(expression,\"center\")&&(result=!0)):ValidationTypes.isAny(expression,yDir)?ValidationTypes.isAny(expression,xDir)?(result=!0,ValidationTypes.isAny(expression,numeric)):ValidationTypes.isAny(expression,numeric)&&(ValidationTypes.isAny(expression,xDir)?(result=!0,ValidationTypes.isAny(expression,numeric)):ValidationTypes.isAny(expression,\"center\")&&(result=!0)):ValidationTypes.isAny(expression,\"center\")&&ValidationTypes.isAny(expression,xDir+\" | \"+yDir)&&(result=!0,ValidationTypes.isAny(expression,numeric)),result},\"<bg-size>\":function(expression){var result=!1,numeric=\"<percentage> | <length> | auto\";return ValidationTypes.isAny(expression,\"cover | contain\")?result=!0:ValidationTypes.isAny(expression,numeric)&&(result=!0,ValidationTypes.isAny(expression,numeric)),result},\"<repeat-style>\":function(expression){var part,result=!1,values=\"repeat | space | round | no-repeat\";return expression.hasNext()&&(part=expression.next(),ValidationTypes.isLiteral(part,\"repeat-x | repeat-y\")?result=!0:ValidationTypes.isLiteral(part,values)&&(result=!0,expression.hasNext()&&ValidationTypes.isLiteral(expression.peek(),values)&&expression.next())),result},\"<shadow>\":function(expression){var result=!1,count=0,inset=!1,color=!1;if(expression.hasNext()){for(ValidationTypes.isAny(expression,\"inset\")&&(inset=!0),ValidationTypes.isAny(expression,\"<color>\")&&(color=!0);ValidationTypes.isAny(expression,\"<length>\")&&4>count;)count++;expression.hasNext()&&(color||ValidationTypes.isAny(expression,\"<color>\"),inset||ValidationTypes.isAny(expression,\"inset\")),result=count>=2&&4>=count}return result},\"<x-one-radius>\":function(expression){var result=!1,simple=\"<length> | <percentage> | inherit\";return ValidationTypes.isAny(expression,simple)&&(result=!0,ValidationTypes.isAny(expression,simple)),result},\"<flex>\":function(expression){var part,result=!1;if(ValidationTypes.isAny(expression,\"none | inherit\")?result=!0:ValidationTypes.isType(expression,\"<flex-grow>\")?expression.peek()?ValidationTypes.isType(expression,\"<flex-shrink>\")?result=expression.peek()?ValidationTypes.isType(expression,\"<flex-basis>\"):!0:ValidationTypes.isType(expression,\"<flex-basis>\")&&(result=null===expression.peek()):result=!0:ValidationTypes.isType(expression,\"<flex-basis>\")&&(result=!0),!result)throw part=expression.peek(),new ValidationError(\"Expected (none | [ <flex-grow> <flex-shrink>? || <flex-basis> ]) but found '\"+expression.value.text+\"'.\",part.line,part.col);return result}}};parserlib.css={Colors:Colors,Combinator:Combinator,Parser:Parser,PropertyName:PropertyName,PropertyValue:PropertyValue,PropertyValuePart:PropertyValuePart,MediaFeature:MediaFeature,MediaQuery:MediaQuery,Selector:Selector,SelectorPart:SelectorPart,SelectorSubPart:SelectorSubPart,Specificity:Specificity,TokenStream:TokenStream,Tokens:Tokens,ValidationError:ValidationError}}(),function(){for(var prop in parserlib)exports[prop]=parserlib[prop]}();var util={isArray:function(ar){return Array.isArray(ar)||\"object\"==typeof ar&&\"[object Array]\"===objectToString(ar)},isDate:function(d){return\"object\"==typeof d&&\"[object Date]\"===objectToString(d)},isRegExp:function(re){return\"object\"==typeof re&&\"[object RegExp]\"===objectToString(re)},getRegExpFlags:function(re){var flags=\"\";return re.global&&(flags+=\"g\"),re.ignoreCase&&(flags+=\"i\"),re.multiline&&(flags+=\"m\"),flags}};\"object\"==typeof module&&(module.exports=clone),clone.clonePrototype=function(parent){if(null===parent)return null;var c=function(){};return c.prototype=parent,new c};var CSSLint=function(){function applyEmbeddedRuleset(text,ruleset){var valueMap,embedded=text&&text.match(embeddedRuleset),rules=embedded&&embedded[1];return rules&&(valueMap={\"true\":2,\"\":1,\"false\":0,2:2,1:1,0:0},rules.toLowerCase().split(\",\").forEach(function(rule){var pair=rule.split(\":\"),property=pair[0]||\"\",value=pair[1]||\"\";ruleset[property.trim()]=valueMap[value.trim()]})),ruleset}var rules=[],formatters=[],embeddedRuleset=/\\/\\*csslint([^\\*]*)\\*\\//,api=new parserlib.util.EventTarget;return api.version=\"@VERSION@\",api.addRule=function(rule){rules.push(rule),rules[rule.id]=rule},api.clearRules=function(){rules=[]},api.getRules=function(){return[].concat(rules).sort(function(a,b){return a.id>b.id?1:0})},api.getRuleset=function(){for(var ruleset={},i=0,len=rules.length;len>i;)ruleset[rules[i++].id]=1;return ruleset},api.addFormatter=function(formatter){formatters[formatter.id]=formatter},api.getFormatter=function(formatId){return formatters[formatId]},api.format=function(results,filename,formatId,options){var formatter=this.getFormatter(formatId),result=null;return formatter&&(result=formatter.startFormat(),result+=formatter.formatResults(results,filename,options||{}),result+=formatter.endFormat()),result},api.hasFormat=function(formatId){return formatters.hasOwnProperty(formatId)},api.verify=function(text,ruleset){var reporter,lines,report,i=0,parser=new parserlib.css.Parser({starHack:!0,ieFilters:!0,underscoreHack:!0,strict:!1});lines=text.replace(/\\n\\r?/g,\"$split$\").split(\"$split$\"),ruleset||(ruleset=this.getRuleset()),embeddedRuleset.test(text)&&(ruleset=clone(ruleset),ruleset=applyEmbeddedRuleset(text,ruleset)),reporter=new Reporter(lines,ruleset),ruleset.errors=2;for(i in ruleset)ruleset.hasOwnProperty(i)&&ruleset[i]&&rules[i]&&rules[i].init(parser,reporter);try{parser.parse(text)}catch(ex){reporter.error(\"Fatal error, cannot continue: \"+ex.message,ex.line,ex.col,{})}return report={messages:reporter.messages,stats:reporter.stats,ruleset:reporter.ruleset},report.messages.sort(function(a,b){return a.rollup&&!b.rollup?1:!a.rollup&&b.rollup?-1:a.line-b.line}),report},api}();Reporter.prototype={constructor:Reporter,error:function(message,line,col,rule){this.messages.push({type:\"error\",line:line,col:col,message:message,evidence:this.lines[line-1],rule:rule||{}})},warn:function(message,line,col,rule){this.report(message,line,col,rule)},report:function(message,line,col,rule){this.messages.push({type:2===this.ruleset[rule.id]?\"error\":\"warning\",line:line,col:col,message:message,evidence:this.lines[line-1],rule:rule})},info:function(message,line,col,rule){this.messages.push({type:\"info\",line:line,col:col,message:message,evidence:this.lines[line-1],rule:rule})},rollupError:function(message,rule){this.messages.push({type:\"error\",rollup:!0,message:message,rule:rule})},rollupWarn:function(message,rule){this.messages.push({type:\"warning\",rollup:!0,message:message,rule:rule})},stat:function(name,value){this.stats[name]=value}},CSSLint._Reporter=Reporter,CSSLint.Util={mix:function(receiver,supplier){var prop;for(prop in supplier)supplier.hasOwnProperty(prop)&&(receiver[prop]=supplier[prop]);return prop},indexOf:function(values,value){if(values.indexOf)return values.indexOf(value);for(var i=0,len=values.length;len>i;i++)if(values[i]===value)return i;return-1},forEach:function(values,func){if(values.forEach)return values.forEach(func);for(var i=0,len=values.length;len>i;i++)func(values[i],i,values)}},CSSLint.addRule({id:\"adjoining-classes\",name:\"Disallow adjoining classes\",desc:\"Don't use adjoining classes.\",browsers:\"IE6\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,modifier,classCount,i,j,k,selectors=event.selectors;for(i=0;selectors.length>i;i++)for(selector=selectors[i],j=0;selector.parts.length>j;j++)if(part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE)for(classCount=0,k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],\"class\"===modifier.type&&classCount++,classCount>1&&reporter.report(\"Don't use adjoining classes.\",part.line,part.col,rule)})}}),CSSLint.addRule({id:\"box-model\",name:\"Beware of broken box size\",desc:\"Don't use width or height when using padding or border.\",browsers:\"All\",init:function(parser,reporter){function startRule(){properties={},boxSizing=!1}function endRule(){var prop,value;if(!boxSizing){if(properties.height)for(prop in heightProperties)heightProperties.hasOwnProperty(prop)&&properties[prop]&&(value=properties[prop].value,(\"padding\"!==prop||2!==value.parts.length||0!==value.parts[0].value)&&reporter.report(\"Using height with \"+prop+\" can sometimes make elements larger than you expect.\",properties[prop].line,properties[prop].col,rule));if(properties.width)for(prop in widthProperties)widthProperties.hasOwnProperty(prop)&&properties[prop]&&(value=properties[prop].value,(\"padding\"!==prop||2!==value.parts.length||0!==value.parts[1].value)&&reporter.report(\"Using width with \"+prop+\" can sometimes make elements larger than you expect.\",properties[prop].line,properties[prop].col,rule))}}var properties,rule=this,widthProperties={border:1,\"border-left\":1,\"border-right\":1,padding:1,\"padding-left\":1,\"padding-right\":1},heightProperties={border:1,\"border-bottom\":1,\"border-top\":1,padding:1,\"padding-bottom\":1,\"padding-top\":1},boxSizing=!1;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase();heightProperties[name]||widthProperties[name]?/^0\\S*$/.test(event.value)||\"border\"===name&&\"none\"==\"\"+event.value||(properties[name]={line:event.property.line,col:event.property.col,value:event.value}):/^(width|height)/i.test(name)&&/^(length|percentage)/.test(event.value.parts[0].type)?properties[name]=1:\"box-sizing\"===name&&(boxSizing=!0)}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule),parser.addListener(\"endpage\",endRule),parser.addListener(\"endpagemargin\",endRule),parser.addListener(\"endkeyframerule\",endRule)}}),CSSLint.addRule({id:\"box-sizing\",name:\"Disallow use of box-sizing\",desc:\"The box-sizing properties isn't supported in IE6 and IE7.\",browsers:\"IE6, IE7\",tags:[\"Compatibility\"],init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase();\"box-sizing\"===name&&reporter.report(\"The box-sizing property isn't supported in IE6 and IE7.\",event.line,event.col,rule)})}}),CSSLint.addRule({id:\"bulletproof-font-face\",name:\"Use the bulletproof @font-face syntax\",desc:\"Use the bulletproof @font-face syntax to avoid 404's in old IE (http://www.fontspring.com/blog/the-new-bulletproof-font-face-syntax).\",browsers:\"All\",init:function(parser,reporter){var line,col,rule=this,fontFaceRule=!1,firstSrc=!0,ruleFailed=!1;parser.addListener(\"startfontface\",function(){fontFaceRule=!0}),parser.addListener(\"property\",function(event){if(fontFaceRule){var propertyName=(\"\"+event.property).toLowerCase(),value=\"\"+event.value;if(line=event.line,col=event.col,\"src\"===propertyName){var regex=/^\\s?url\\(['\"].+\\.eot\\?.*['\"]\\)\\s*format\\(['\"]embedded-opentype['\"]\\).*$/i;!value.match(regex)&&firstSrc?(ruleFailed=!0,firstSrc=!1):value.match(regex)&&!firstSrc&&(ruleFailed=!1)}}}),parser.addListener(\"endfontface\",function(){fontFaceRule=!1,ruleFailed&&reporter.report(\"@font-face declaration doesn't follow the fontspring bulletproof syntax.\",line,col,rule)})}}),CSSLint.addRule({id:\"compatible-vendor-prefixes\",name:\"Require compatible vendor prefixes\",desc:\"Include all compatible vendor prefixes to reach a wider range of users.\",browsers:\"All\",init:function(parser,reporter){var compatiblePrefixes,properties,prop,variations,prefixed,i,len,rule=this,inKeyFrame=!1,arrayPush=Array.prototype.push,applyTo=[];compatiblePrefixes={animation:\"webkit moz\",\"animation-delay\":\"webkit moz\",\"animation-direction\":\"webkit moz\",\"animation-duration\":\"webkit moz\",\"animation-fill-mode\":\"webkit moz\",\"animation-iteration-count\":\"webkit moz\",\"animation-name\":\"webkit moz\",\"animation-play-state\":\"webkit moz\",\"animation-timing-function\":\"webkit moz\",appearance:\"webkit moz\",\"border-end\":\"webkit moz\",\"border-end-color\":\"webkit moz\",\"border-end-style\":\"webkit moz\",\"border-end-width\":\"webkit moz\",\"border-image\":\"webkit moz o\",\"border-radius\":\"webkit\",\"border-start\":\"webkit moz\",\"border-start-color\":\"webkit moz\",\"border-start-style\":\"webkit moz\",\"border-start-width\":\"webkit moz\",\"box-align\":\"webkit moz ms\",\"box-direction\":\"webkit moz ms\",\"box-flex\":\"webkit moz ms\",\"box-lines\":\"webkit ms\",\"box-ordinal-group\":\"webkit moz ms\",\"box-orient\":\"webkit moz ms\",\"box-pack\":\"webkit moz ms\",\"box-sizing\":\"webkit moz\",\"box-shadow\":\"webkit moz\",\"column-count\":\"webkit moz ms\",\"column-gap\":\"webkit moz ms\",\"column-rule\":\"webkit moz ms\",\"column-rule-color\":\"webkit moz ms\",\"column-rule-style\":\"webkit moz ms\",\"column-rule-width\":\"webkit moz ms\",\"column-width\":\"webkit moz ms\",hyphens:\"epub moz\",\"line-break\":\"webkit ms\",\"margin-end\":\"webkit moz\",\"margin-start\":\"webkit moz\",\"marquee-speed\":\"webkit wap\",\"marquee-style\":\"webkit wap\",\"padding-end\":\"webkit moz\",\"padding-start\":\"webkit moz\",\"tab-size\":\"moz o\",\"text-size-adjust\":\"webkit ms\",transform:\"webkit moz ms o\",\"transform-origin\":\"webkit moz ms o\",transition:\"webkit moz o\",\"transition-delay\":\"webkit moz o\",\"transition-duration\":\"webkit moz o\",\"transition-property\":\"webkit moz o\",\"transition-timing-function\":\"webkit moz o\",\"user-modify\":\"webkit moz\",\"user-select\":\"webkit moz ms\",\"word-break\":\"epub ms\",\"writing-mode\":\"epub ms\"};for(prop in compatiblePrefixes)if(compatiblePrefixes.hasOwnProperty(prop)){for(variations=[],prefixed=compatiblePrefixes[prop].split(\" \"),i=0,len=prefixed.length;len>i;i++)variations.push(\"-\"+prefixed[i]+\"-\"+prop);compatiblePrefixes[prop]=variations,arrayPush.apply(applyTo,variations)}parser.addListener(\"startrule\",function(){properties=[]}),parser.addListener(\"startkeyframes\",function(event){inKeyFrame=event.prefix||!0}),parser.addListener(\"endkeyframes\",function(){inKeyFrame=!1}),parser.addListener(\"property\",function(event){var name=event.property;CSSLint.Util.indexOf(applyTo,name.text)>-1&&(inKeyFrame&&\"string\"==typeof inKeyFrame&&0===name.text.indexOf(\"-\"+inKeyFrame+\"-\")||properties.push(name))}),parser.addListener(\"endrule\",function(){if(properties.length){var i,len,name,prop,variations,value,full,actual,item,propertiesSpecified,propertyGroups={};for(i=0,len=properties.length;len>i;i++){name=properties[i];for(prop in compatiblePrefixes)compatiblePrefixes.hasOwnProperty(prop)&&(variations=compatiblePrefixes[prop],CSSLint.Util.indexOf(variations,name.text)>-1&&(propertyGroups[prop]||(propertyGroups[prop]={full:variations.slice(0),actual:[],actualNodes:[]}),-1===CSSLint.Util.indexOf(propertyGroups[prop].actual,name.text)&&(propertyGroups[prop].actual.push(name.text),propertyGroups[prop].actualNodes.push(name))))}for(prop in propertyGroups)if(propertyGroups.hasOwnProperty(prop)&&(value=propertyGroups[prop],full=value.full,actual=value.actual,full.length>actual.length))for(i=0,len=full.length;len>i;i++)item=full[i],-1===CSSLint.Util.indexOf(actual,item)&&(propertiesSpecified=1===actual.length?actual[0]:2===actual.length?actual.join(\" and \"):actual.join(\", \"),reporter.report(\"The property \"+item+\" is compatible with \"+propertiesSpecified+\" and should be included as well.\",value.actualNodes[0].line,value.actualNodes[0].col,rule))}})}}),CSSLint.addRule({id:\"display-property-grouping\",name:\"Require properties appropriate for display\",desc:\"Certain properties shouldn't be used with certain display property values.\",browsers:\"All\",init:function(parser,reporter){function reportProperty(name,display,msg){properties[name]&&(\"string\"!=typeof propertiesToCheck[name]||properties[name].value.toLowerCase()!==propertiesToCheck[name])&&reporter.report(msg||name+\" can't be used with display: \"+display+\".\",properties[name].line,properties[name].col,rule)}function startRule(){properties={}}function endRule(){var display=properties.display?properties.display.value:null;if(display)switch(display){case\"inline\":reportProperty(\"height\",display),reportProperty(\"width\",display),reportProperty(\"margin\",display),reportProperty(\"margin-top\",display),reportProperty(\"margin-bottom\",display),reportProperty(\"float\",display,\"display:inline has no effect on floated elements (but may be used to fix the IE6 double-margin bug).\");break;case\"block\":reportProperty(\"vertical-align\",display);\nbreak;case\"inline-block\":reportProperty(\"float\",display);break;default:0===display.indexOf(\"table-\")&&(reportProperty(\"margin\",display),reportProperty(\"margin-left\",display),reportProperty(\"margin-right\",display),reportProperty(\"margin-top\",display),reportProperty(\"margin-bottom\",display),reportProperty(\"float\",display))}}var properties,rule=this,propertiesToCheck={display:1,\"float\":\"none\",height:1,width:1,margin:1,\"margin-left\":1,\"margin-right\":1,\"margin-bottom\":1,\"margin-top\":1,padding:1,\"padding-left\":1,\"padding-right\":1,\"padding-bottom\":1,\"padding-top\":1,\"vertical-align\":1};parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase();propertiesToCheck[name]&&(properties[name]={value:event.value.text,line:event.property.line,col:event.property.col})}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule),parser.addListener(\"endkeyframerule\",endRule),parser.addListener(\"endpagemargin\",endRule),parser.addListener(\"endpage\",endRule)}}),CSSLint.addRule({id:\"duplicate-background-images\",name:\"Disallow duplicate background images\",desc:\"Every background-image should be unique. Use a common class for e.g. sprites.\",browsers:\"All\",init:function(parser,reporter){var rule=this,stack={};parser.addListener(\"property\",function(event){var i,len,name=event.property.text,value=event.value;if(name.match(/background/i))for(i=0,len=value.parts.length;len>i;i++)\"uri\"===value.parts[i].type&&(stack[value.parts[i].uri]===void 0?stack[value.parts[i].uri]=event:reporter.report(\"Background image '\"+value.parts[i].uri+\"' was used multiple times, first declared at line \"+stack[value.parts[i].uri].line+\", col \"+stack[value.parts[i].uri].col+\".\",event.line,event.col,rule))})}}),CSSLint.addRule({id:\"duplicate-properties\",name:\"Disallow duplicate properties\",desc:\"Duplicate properties must appear one after the other.\",browsers:\"All\",init:function(parser,reporter){function startRule(){properties={}}var properties,lastProperty,rule=this;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var property=event.property,name=property.text.toLowerCase();!properties[name]||lastProperty===name&&properties[name]!==event.value.text||reporter.report(\"Duplicate property '\"+event.property+\"' found.\",event.line,event.col,rule),properties[name]=event.value.text,lastProperty=name})}}),CSSLint.addRule({id:\"empty-rules\",name:\"Disallow empty rules\",desc:\"Rules without any properties specified should be removed.\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"startrule\",function(){count=0}),parser.addListener(\"property\",function(){count++}),parser.addListener(\"endrule\",function(event){var selectors=event.selectors;0===count&&reporter.report(\"Rule is empty.\",selectors[0].line,selectors[0].col,rule)})}}),CSSLint.addRule({id:\"errors\",name:\"Parsing Errors\",desc:\"This rule looks for recoverable syntax errors.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"error\",function(event){reporter.error(event.message,event.line,event.col,rule)})}}),CSSLint.addRule({id:\"fallback-colors\",name:\"Require fallback colors\",desc:\"For older browsers that don't support RGBA, HSL, or HSLA, provide a fallback color.\",browsers:\"IE6,IE7,IE8\",init:function(parser,reporter){function startRule(){properties={},lastProperty=null}var lastProperty,properties,rule=this,propertiesToCheck={color:1,background:1,\"border-color\":1,\"border-top-color\":1,\"border-right-color\":1,\"border-bottom-color\":1,\"border-left-color\":1,border:1,\"border-top\":1,\"border-right\":1,\"border-bottom\":1,\"border-left\":1,\"background-color\":1};parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var property=event.property,name=property.text.toLowerCase(),parts=event.value.parts,i=0,colorType=\"\",len=parts.length;if(propertiesToCheck[name])for(;len>i;)\"color\"===parts[i].type&&(\"alpha\"in parts[i]||\"hue\"in parts[i]?(/([^\\)]+)\\(/.test(parts[i])&&(colorType=RegExp.$1.toUpperCase()),lastProperty&&lastProperty.property.text.toLowerCase()===name&&\"compat\"===lastProperty.colorType||reporter.report(\"Fallback \"+name+\" (hex or RGB) should precede \"+colorType+\" \"+name+\".\",event.line,event.col,rule)):event.colorType=\"compat\"),i++;lastProperty=event})}}),CSSLint.addRule({id:\"floats\",name:\"Disallow too many floats\",desc:\"This rule tests if the float property is used too many times\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"property\",function(event){\"float\"===event.property.text.toLowerCase()&&\"none\"!==event.value.text.toLowerCase()&&count++}),parser.addListener(\"endstylesheet\",function(){reporter.stat(\"floats\",count),count>=10&&reporter.rollupWarn(\"Too many floats (\"+count+\"), you're probably using them for layout. Consider using a grid system instead.\",rule)})}}),CSSLint.addRule({id:\"font-faces\",name:\"Don't use too many web fonts\",desc:\"Too many different web fonts in the same stylesheet.\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"startfontface\",function(){count++}),parser.addListener(\"endstylesheet\",function(){count>5&&reporter.rollupWarn(\"Too many @font-face declarations (\"+count+\").\",rule)})}}),CSSLint.addRule({id:\"font-sizes\",name:\"Disallow too many font sizes\",desc:\"Checks the number of font-size declarations.\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"property\",function(event){\"font-size\"==\"\"+event.property&&count++}),parser.addListener(\"endstylesheet\",function(){reporter.stat(\"font-sizes\",count),count>=10&&reporter.rollupWarn(\"Too many font-size declarations (\"+count+\"), abstraction needed.\",rule)})}}),CSSLint.addRule({id:\"gradients\",name:\"Require all gradient definitions\",desc:\"When using a vendor-prefixed gradient, make sure to use them all.\",browsers:\"All\",init:function(parser,reporter){var gradients,rule=this;parser.addListener(\"startrule\",function(){gradients={moz:0,webkit:0,oldWebkit:0,o:0}}),parser.addListener(\"property\",function(event){/\\-(moz|o|webkit)(?:\\-(?:linear|radial))\\-gradient/i.test(event.value)?gradients[RegExp.$1]=1:/\\-webkit\\-gradient/i.test(event.value)&&(gradients.oldWebkit=1)}),parser.addListener(\"endrule\",function(event){var missing=[];gradients.moz||missing.push(\"Firefox 3.6+\"),gradients.webkit||missing.push(\"Webkit (Safari 5+, Chrome)\"),gradients.oldWebkit||missing.push(\"Old Webkit (Safari 4+, Chrome)\"),gradients.o||missing.push(\"Opera 11.1+\"),missing.length&&4>missing.length&&reporter.report(\"Missing vendor-prefixed CSS gradients for \"+missing.join(\", \")+\".\",event.selectors[0].line,event.selectors[0].col,rule)})}}),CSSLint.addRule({id:\"ids\",name:\"Disallow IDs in selectors\",desc:\"Selectors should not contain IDs.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,modifier,idCount,i,j,k,selectors=event.selectors;for(i=0;selectors.length>i;i++){for(selector=selectors[i],idCount=0,j=0;selector.parts.length>j;j++)if(part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE)for(k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],\"id\"===modifier.type&&idCount++;1===idCount?reporter.report(\"Don't use IDs in selectors.\",selector.line,selector.col,rule):idCount>1&&reporter.report(idCount+\" IDs in the selector, really?\",selector.line,selector.col,rule)}})}}),CSSLint.addRule({id:\"import\",name:\"Disallow @import\",desc:\"Don't use @import, use <link> instead.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"import\",function(event){reporter.report(\"@import prevents parallel downloads, use <link> instead.\",event.line,event.col,rule)})}}),CSSLint.addRule({id:\"important\",name:\"Disallow !important\",desc:\"Be careful when using !important declaration\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"property\",function(event){event.important===!0&&(count++,reporter.report(\"Use of !important\",event.line,event.col,rule))}),parser.addListener(\"endstylesheet\",function(){reporter.stat(\"important\",count),count>=10&&reporter.rollupWarn(\"Too many !important declarations (\"+count+\"), try to use less than 10 to avoid specificity issues.\",rule)})}}),CSSLint.addRule({id:\"known-properties\",name:\"Require use of known properties\",desc:\"Properties should be known (listed in CSS3 specification) or be a vendor-prefixed property.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){event.invalid&&reporter.report(event.invalid.message,event.line,event.col,rule)})}}),CSSLint.addRule({id:\"order-alphabetical\",name:\"Alphabetical order\",desc:\"Assure properties are in alphabetical order\",browsers:\"All\",init:function(parser,reporter){var properties,rule=this,startRule=function(){properties=[]};parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text,lowerCasePrefixLessName=name.toLowerCase().replace(/^-.*?-/,\"\");properties.push(lowerCasePrefixLessName)}),parser.addListener(\"endrule\",function(event){var currentProperties=properties.join(\",\"),expectedProperties=properties.sort().join(\",\");currentProperties!==expectedProperties&&reporter.report(\"Rule doesn't have all its properties in alphabetical ordered.\",event.line,event.col,rule)})}}),CSSLint.addRule({id:\"outline-none\",name:\"Disallow outline: none\",desc:\"Use of outline: none or outline: 0 should be limited to :focus rules.\",browsers:\"All\",tags:[\"Accessibility\"],init:function(parser,reporter){function startRule(event){lastRule=event.selectors?{line:event.line,col:event.col,selectors:event.selectors,propCount:0,outline:!1}:null}function endRule(){lastRule&&lastRule.outline&&(-1===(\"\"+lastRule.selectors).toLowerCase().indexOf(\":focus\")?reporter.report(\"Outlines should only be modified using :focus.\",lastRule.line,lastRule.col,rule):1===lastRule.propCount&&reporter.report(\"Outlines shouldn't be hidden unless other visual changes are made.\",lastRule.line,lastRule.col,rule))}var lastRule,rule=this;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase(),value=event.value;lastRule&&(lastRule.propCount++,\"outline\"!==name||\"none\"!=\"\"+value&&\"0\"!=\"\"+value||(lastRule.outline=!0))}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule),parser.addListener(\"endpage\",endRule),parser.addListener(\"endpagemargin\",endRule),parser.addListener(\"endkeyframerule\",endRule)}}),CSSLint.addRule({id:\"overqualified-elements\",name:\"Disallow overqualified elements\",desc:\"Don't use classes or IDs with elements (a.foo or a#foo).\",browsers:\"All\",init:function(parser,reporter){var rule=this,classes={};parser.addListener(\"startrule\",function(event){var selector,part,modifier,i,j,k,selectors=event.selectors;for(i=0;selectors.length>i;i++)for(selector=selectors[i],j=0;selector.parts.length>j;j++)if(part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE)for(k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],part.elementName&&\"id\"===modifier.type?reporter.report(\"Element (\"+part+\") is overqualified, just use \"+modifier+\" without element name.\",part.line,part.col,rule):\"class\"===modifier.type&&(classes[modifier]||(classes[modifier]=[]),classes[modifier].push({modifier:modifier,part:part}))}),parser.addListener(\"endstylesheet\",function(){var prop;for(prop in classes)classes.hasOwnProperty(prop)&&1===classes[prop].length&&classes[prop][0].part.elementName&&reporter.report(\"Element (\"+classes[prop][0].part+\") is overqualified, just use \"+classes[prop][0].modifier+\" without element name.\",classes[prop][0].part.line,classes[prop][0].part.col,rule)})}}),CSSLint.addRule({id:\"qualified-headings\",name:\"Disallow qualified headings\",desc:\"Headings should not be qualified (namespaced).\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,i,j,selectors=event.selectors;for(i=0;selectors.length>i;i++)for(selector=selectors[i],j=0;selector.parts.length>j;j++)part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE&&part.elementName&&/h[1-6]/.test(\"\"+part.elementName)&&j>0&&reporter.report(\"Heading (\"+part.elementName+\") should not be qualified.\",part.line,part.col,rule)})}}),CSSLint.addRule({id:\"regex-selectors\",name:\"Disallow selectors that look like regexs\",desc:\"Selectors that look like regular expressions are slow and should be avoided.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,modifier,i,j,k,selectors=event.selectors;for(i=0;selectors.length>i;i++)for(selector=selectors[i],j=0;selector.parts.length>j;j++)if(part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE)for(k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],\"attribute\"===modifier.type&&/([\\~\\|\\^\\$\\*]=)/.test(modifier)&&reporter.report(\"Attribute selectors with \"+RegExp.$1+\" are slow!\",modifier.line,modifier.col,rule)})}}),CSSLint.addRule({id:\"rules-count\",name:\"Rules Count\",desc:\"Track how many rules there are.\",browsers:\"All\",init:function(parser,reporter){var count=0;parser.addListener(\"startrule\",function(){count++}),parser.addListener(\"endstylesheet\",function(){reporter.stat(\"rule-count\",count)})}}),CSSLint.addRule({id:\"selector-max-approaching\",name:\"Warn when approaching the 4095 selector limit for IE\",desc:\"Will warn when selector count is >= 3800 selectors.\",browsers:\"IE\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"startrule\",function(event){count+=event.selectors.length}),parser.addListener(\"endstylesheet\",function(){count>=3800&&reporter.report(\"You have \"+count+\" selectors. Internet Explorer supports a maximum of 4095 selectors per stylesheet. Consider refactoring.\",0,0,rule)})}}),CSSLint.addRule({id:\"selector-max\",name:\"Error when past the 4095 selector limit for IE\",desc:\"Will error when selector count is > 4095.\",browsers:\"IE\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"startrule\",function(event){count+=event.selectors.length}),parser.addListener(\"endstylesheet\",function(){count>4095&&reporter.report(\"You have \"+count+\" selectors. Internet Explorer supports a maximum of 4095 selectors per stylesheet. Consider refactoring.\",0,0,rule)})}}),CSSLint.addRule({id:\"selector-newline\",name:\"Disallow new-line characters in selectors\",desc:\"New-line characters in selectors are usually a forgotten comma and not a descendant combinator.\",browsers:\"All\",init:function(parser,reporter){function startRule(event){var i,len,selector,p,n,pLen,part,part2,type,currentLine,nextLine,selectors=event.selectors;for(i=0,len=selectors.length;len>i;i++)for(selector=selectors[i],p=0,pLen=selector.parts.length;pLen>p;p++)for(n=p+1;pLen>n;n++)part=selector.parts[p],part2=selector.parts[n],type=part.type,currentLine=part.line,nextLine=part2.line,\"descendant\"===type&&nextLine>currentLine&&reporter.report(\"newline character found in selector (forgot a comma?)\",currentLine,selectors[i].parts[0].col,rule)}var rule=this;parser.addListener(\"startrule\",startRule)}}),CSSLint.addRule({id:\"shorthand\",name:\"Require shorthand properties\",desc:\"Use shorthand properties where possible.\",browsers:\"All\",init:function(parser,reporter){function startRule(){properties={}}function endRule(event){var prop,i,len,total;for(prop in mapping)if(mapping.hasOwnProperty(prop)){for(total=0,i=0,len=mapping[prop].length;len>i;i++)total+=properties[mapping[prop][i]]?1:0;total===mapping[prop].length&&reporter.report(\"The properties \"+mapping[prop].join(\", \")+\" can be replaced by \"+prop+\".\",event.line,event.col,rule)}}var prop,i,len,properties,rule=this,propertiesToCheck={},mapping={margin:[\"margin-top\",\"margin-bottom\",\"margin-left\",\"margin-right\"],padding:[\"padding-top\",\"padding-bottom\",\"padding-left\",\"padding-right\"]};for(prop in mapping)if(mapping.hasOwnProperty(prop))for(i=0,len=mapping[prop].length;len>i;i++)propertiesToCheck[mapping[prop][i]]=prop;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"property\",function(event){var name=(\"\"+event.property).toLowerCase();propertiesToCheck[name]&&(properties[name]=1)}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule)}}),CSSLint.addRule({id:\"star-property-hack\",name:\"Disallow properties with a star prefix\",desc:\"Checks for the star property hack (targets IE6/7)\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){var property=event.property;\"*\"===property.hack&&reporter.report(\"Property with star prefix found.\",event.property.line,event.property.col,rule)})}}),CSSLint.addRule({id:\"text-indent\",name:\"Disallow negative text-indent\",desc:\"Checks for text indent less than -99px\",browsers:\"All\",init:function(parser,reporter){function startRule(){textIndent=!1,direction=\"inherit\"}function endRule(){textIndent&&\"ltr\"!==direction&&reporter.report(\"Negative text-indent doesn't work well with RTL. If you use text-indent for image replacement explicitly set direction for that item to ltr.\",textIndent.line,textIndent.col,rule)}var textIndent,direction,rule=this;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"property\",function(event){var name=(\"\"+event.property).toLowerCase(),value=event.value;\"text-indent\"===name&&-99>value.parts[0].value?textIndent=event.property:\"direction\"===name&&\"ltr\"==\"\"+value&&(direction=\"ltr\")}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule)}}),CSSLint.addRule({id:\"underscore-property-hack\",name:\"Disallow properties with an underscore prefix\",desc:\"Checks for the underscore property hack (targets IE6)\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){var property=event.property;\"_\"===property.hack&&reporter.report(\"Property with underscore prefix found.\",event.property.line,event.property.col,rule)})}}),CSSLint.addRule({id:\"unique-headings\",name:\"Headings should only be defined once\",desc:\"Headings should be defined only once.\",browsers:\"All\",init:function(parser,reporter){var rule=this,headings={h1:0,h2:0,h3:0,h4:0,h5:0,h6:0};parser.addListener(\"startrule\",function(event){var selector,part,pseudo,i,j,selectors=event.selectors;for(i=0;selectors.length>i;i++)if(selector=selectors[i],part=selector.parts[selector.parts.length-1],part.elementName&&/(h[1-6])/i.test(\"\"+part.elementName)){for(j=0;part.modifiers.length>j;j++)if(\"pseudo\"===part.modifiers[j].type){pseudo=!0;break}pseudo||(headings[RegExp.$1]++,headings[RegExp.$1]>1&&reporter.report(\"Heading (\"+part.elementName+\") has already been defined.\",part.line,part.col,rule))}}),parser.addListener(\"endstylesheet\",function(){var prop,messages=[];for(prop in headings)headings.hasOwnProperty(prop)&&headings[prop]>1&&messages.push(headings[prop]+\" \"+prop+\"s\");messages.length&&reporter.rollupWarn(\"You have \"+messages.join(\", \")+\" defined in this stylesheet.\",rule)})}}),CSSLint.addRule({id:\"universal-selector\",name:\"Disallow universal selector\",desc:\"The universal selector (*) is known to be slow.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,i,selectors=event.selectors;for(i=0;selectors.length>i;i++)selector=selectors[i],part=selector.parts[selector.parts.length-1],\"*\"===part.elementName&&reporter.report(rule.desc,part.line,part.col,rule)})}}),CSSLint.addRule({id:\"unqualified-attributes\",name:\"Disallow unqualified attribute selectors\",desc:\"Unqualified attribute selectors are known to be slow.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,modifier,i,k,selectors=event.selectors;for(i=0;selectors.length>i;i++)if(selector=selectors[i],part=selector.parts[selector.parts.length-1],part.type===parser.SELECTOR_PART_TYPE)for(k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],\"attribute\"!==modifier.type||part.elementName&&\"*\"!==part.elementName||reporter.report(rule.desc,part.line,part.col,rule)})}}),CSSLint.addRule({id:\"vendor-prefix\",name:\"Require standard property with vendor prefix\",desc:\"When using a vendor-prefixed property, make sure to include the standard one.\",browsers:\"All\",init:function(parser,reporter){function startRule(){properties={},num=1}function endRule(){var prop,i,len,needed,actual,needsStandard=[];for(prop in properties)propertiesToCheck[prop]&&needsStandard.push({actual:prop,needed:propertiesToCheck[prop]});for(i=0,len=needsStandard.length;len>i;i++)needed=needsStandard[i].needed,actual=needsStandard[i].actual,properties[needed]?properties[needed][0].pos<properties[actual][0].pos&&reporter.report(\"Standard property '\"+needed+\"' should come after vendor-prefixed property '\"+actual+\"'.\",properties[actual][0].name.line,properties[actual][0].name.col,rule):reporter.report(\"Missing standard property '\"+needed+\"' to go along with '\"+actual+\"'.\",properties[actual][0].name.line,properties[actual][0].name.col,rule)}var properties,num,rule=this,propertiesToCheck={\"-webkit-border-radius\":\"border-radius\",\"-webkit-border-top-left-radius\":\"border-top-left-radius\",\"-webkit-border-top-right-radius\":\"border-top-right-radius\",\"-webkit-border-bottom-left-radius\":\"border-bottom-left-radius\",\"-webkit-border-bottom-right-radius\":\"border-bottom-right-radius\",\"-o-border-radius\":\"border-radius\",\"-o-border-top-left-radius\":\"border-top-left-radius\",\"-o-border-top-right-radius\":\"border-top-right-radius\",\"-o-border-bottom-left-radius\":\"border-bottom-left-radius\",\"-o-border-bottom-right-radius\":\"border-bottom-right-radius\",\"-moz-border-radius\":\"border-radius\",\"-moz-border-radius-topleft\":\"border-top-left-radius\",\"-moz-border-radius-topright\":\"border-top-right-radius\",\"-moz-border-radius-bottomleft\":\"border-bottom-left-radius\",\"-moz-border-radius-bottomright\":\"border-bottom-right-radius\",\"-moz-column-count\":\"column-count\",\"-webkit-column-count\":\"column-count\",\"-moz-column-gap\":\"column-gap\",\"-webkit-column-gap\":\"column-gap\",\"-moz-column-rule\":\"column-rule\",\"-webkit-column-rule\":\"column-rule\",\"-moz-column-rule-style\":\"column-rule-style\",\"-webkit-column-rule-style\":\"column-rule-style\",\"-moz-column-rule-color\":\"column-rule-color\",\"-webkit-column-rule-color\":\"column-rule-color\",\"-moz-column-rule-width\":\"column-rule-width\",\"-webkit-column-rule-width\":\"column-rule-width\",\"-moz-column-width\":\"column-width\",\"-webkit-column-width\":\"column-width\",\"-webkit-column-span\":\"column-span\",\"-webkit-columns\":\"columns\",\"-moz-box-shadow\":\"box-shadow\",\"-webkit-box-shadow\":\"box-shadow\",\"-moz-transform\":\"transform\",\"-webkit-transform\":\"transform\",\"-o-transform\":\"transform\",\"-ms-transform\":\"transform\",\"-moz-transform-origin\":\"transform-origin\",\"-webkit-transform-origin\":\"transform-origin\",\"-o-transform-origin\":\"transform-origin\",\"-ms-transform-origin\":\"transform-origin\",\"-moz-box-sizing\":\"box-sizing\",\"-webkit-box-sizing\":\"box-sizing\"};parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase();properties[name]||(properties[name]=[]),properties[name].push({name:event.property,value:event.value,pos:num++})}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule),parser.addListener(\"endpage\",endRule),parser.addListener(\"endpagemargin\",endRule),parser.addListener(\"endkeyframerule\",endRule)}}),CSSLint.addRule({id:\"zero-units\",name:\"Disallow units for 0 values\",desc:\"You don't need to specify units when a value is 0.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){for(var parts=event.value.parts,i=0,len=parts.length;len>i;)!parts[i].units&&\"percentage\"!==parts[i].type||0!==parts[i].value||\"time\"===parts[i].type||reporter.report(\"Values of 0 shouldn't have units specified.\",parts[i].line,parts[i].col,rule),i++})}}),function(){var xmlEscape=function(str){return str&&str.constructor===String?str.replace(/[\\\"&><]/g,function(match){switch(match){case'\"':return\"&quot;\";case\"&\":return\"&amp;\";case\"<\":return\"&lt;\";case\">\":return\"&gt;\"}}):\"\"};CSSLint.addFormatter({id:\"checkstyle-xml\",name:\"Checkstyle XML format\",startFormat:function(){return'<?xml version=\"1.0\" encoding=\"utf-8\"?><checkstyle>'},endFormat:function(){return\"</checkstyle>\"},readError:function(filename,message){return'<file name=\"'+xmlEscape(filename)+'\"><error line=\"0\" column=\"0\" severty=\"error\" message=\"'+xmlEscape(message)+'\"></error></file>'},formatResults:function(results,filename){var messages=results.messages,output=[],generateSource=function(rule){return rule&&\"name\"in rule?\"net.csslint.\"+rule.name.replace(/\\s/g,\"\"):\"\"};return messages.length>0&&(output.push('<file name=\"'+filename+'\">'),CSSLint.Util.forEach(messages,function(message){message.rollup||output.push('<error line=\"'+message.line+'\" column=\"'+message.col+'\" severity=\"'+message.type+'\"'+' message=\"'+xmlEscape(message.message)+'\" source=\"'+generateSource(message.rule)+'\"/>')}),output.push(\"</file>\")),output.join(\"\")}})}(),CSSLint.addFormatter({id:\"compact\",name:\"Compact, 'porcelain' format\",startFormat:function(){return\"\"},endFormat:function(){return\"\"},formatResults:function(results,filename,options){var messages=results.messages,output=\"\";options=options||{};var capitalize=function(str){return str.charAt(0).toUpperCase()+str.slice(1)};return 0===messages.length?options.quiet?\"\":filename+\": Lint Free!\":(CSSLint.Util.forEach(messages,function(message){output+=message.rollup?filename+\": \"+capitalize(message.type)+\" - \"+message.message+\"\\n\":filename+\": \"+\"line \"+message.line+\", col \"+message.col+\", \"+capitalize(message.type)+\" - \"+message.message+\" (\"+message.rule.id+\")\\n\"}),output)}}),CSSLint.addFormatter({id:\"csslint-xml\",name:\"CSSLint XML format\",startFormat:function(){return'<?xml version=\"1.0\" encoding=\"utf-8\"?><csslint>'},endFormat:function(){return\"</csslint>\"},formatResults:function(results,filename){var messages=results.messages,output=[],escapeSpecialCharacters=function(str){return str&&str.constructor===String?str.replace(/\\\"/g,\"'\").replace(/&/g,\"&amp;\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\"):\"\"};return messages.length>0&&(output.push('<file name=\"'+filename+'\">'),CSSLint.Util.forEach(messages,function(message){message.rollup?output.push('<issue severity=\"'+message.type+'\" reason=\"'+escapeSpecialCharacters(message.message)+'\" evidence=\"'+escapeSpecialCharacters(message.evidence)+'\"/>'):output.push('<issue line=\"'+message.line+'\" char=\"'+message.col+'\" severity=\"'+message.type+'\"'+' reason=\"'+escapeSpecialCharacters(message.message)+'\" evidence=\"'+escapeSpecialCharacters(message.evidence)+'\"/>')}),output.push(\"</file>\")),output.join(\"\")}}),CSSLint.addFormatter({id:\"junit-xml\",name:\"JUNIT XML format\",startFormat:function(){return'<?xml version=\"1.0\" encoding=\"utf-8\"?><testsuites>'},endFormat:function(){return\"</testsuites>\"},formatResults:function(results,filename){var messages=results.messages,output=[],tests={error:0,failure:0},generateSource=function(rule){return rule&&\"name\"in rule?\"net.csslint.\"+rule.name.replace(/\\s/g,\"\"):\"\"},escapeSpecialCharacters=function(str){return str&&str.constructor===String?str.replace(/\\\"/g,\"'\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\"):\"\"};return messages.length>0&&(messages.forEach(function(message){var type=\"warning\"===message.type?\"error\":message.type;message.rollup||(output.push('<testcase time=\"0\" name=\"'+generateSource(message.rule)+'\">'),output.push(\"<\"+type+' message=\"'+escapeSpecialCharacters(message.message)+'\"><![CDATA['+message.line+\":\"+message.col+\":\"+escapeSpecialCharacters(message.evidence)+\"]]></\"+type+\">\"),output.push(\"</testcase>\"),tests[type]+=1)}),output.unshift('<testsuite time=\"0\" tests=\"'+messages.length+'\" skipped=\"0\" errors=\"'+tests.error+'\" failures=\"'+tests.failure+'\" package=\"net.csslint\" name=\"'+filename+'\">'),output.push(\"</testsuite>\")),output.join(\"\")}}),CSSLint.addFormatter({id:\"lint-xml\",name:\"Lint XML format\",startFormat:function(){return'<?xml version=\"1.0\" encoding=\"utf-8\"?><lint>'},endFormat:function(){return\"</lint>\"},formatResults:function(results,filename){var messages=results.messages,output=[],escapeSpecialCharacters=function(str){return str&&str.constructor===String?str.replace(/\\\"/g,\"'\").replace(/&/g,\"&amp;\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\"):\"\"};return messages.length>0&&(output.push('<file name=\"'+filename+'\">'),CSSLint.Util.forEach(messages,function(message){message.rollup?output.push('<issue severity=\"'+message.type+'\" reason=\"'+escapeSpecialCharacters(message.message)+'\" evidence=\"'+escapeSpecialCharacters(message.evidence)+'\"/>'):output.push('<issue line=\"'+message.line+'\" char=\"'+message.col+'\" severity=\"'+message.type+'\"'+' reason=\"'+escapeSpecialCharacters(message.message)+'\" evidence=\"'+escapeSpecialCharacters(message.evidence)+'\"/>')}),output.push(\"</file>\")),output.join(\"\")}}),CSSLint.addFormatter({id:\"text\",name:\"Plain Text\",startFormat:function(){return\"\"},endFormat:function(){return\"\"},formatResults:function(results,filename,options){var messages=results.messages,output=\"\";if(options=options||{},0===messages.length)return options.quiet?\"\":\"\\n\\ncsslint: No errors in \"+filename+\".\";output=\"\\n\\ncsslint: There \",output+=1===messages.length?\"is 1 problem\":\"are \"+messages.length+\" problems\",output+=\" in \"+filename+\".\";var pos=filename.lastIndexOf(\"/\"),shortFilename=filename;return-1===pos&&(pos=filename.lastIndexOf(\"\\\\\")),pos>-1&&(shortFilename=filename.substring(pos+1)),CSSLint.Util.forEach(messages,function(message,i){output=output+\"\\n\\n\"+shortFilename,message.rollup?(output+=\"\\n\"+(i+1)+\": \"+message.type,output+=\"\\n\"+message.message):(output+=\"\\n\"+(i+1)+\": \"+message.type+\" at line \"+message.line+\", col \"+message.col,output+=\"\\n\"+message.message,output+=\"\\n\"+message.evidence)}),output}}),module.exports.CSSLint=CSSLint}),ace.define(\"ace/mode/css_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/lang\",\"ace/worker/mirror\",\"ace/mode/css/csslint\"],function(acequire,exports){\"use strict\";var oop=acequire(\"../lib/oop\"),lang=acequire(\"../lib/lang\"),Mirror=acequire(\"../worker/mirror\").Mirror,CSSLint=acequire(\"./css/csslint\").CSSLint,Worker=exports.Worker=function(sender){Mirror.call(this,sender),this.setTimeout(400),this.ruleset=null,this.setDisabledRules(\"ids|order-alphabetical\"),this.setInfoRules(\"adjoining-classes|qualified-headings|zero-units|gradients|import|outline-none|vendor-prefix\")};oop.inherits(Worker,Mirror),function(){this.setInfoRules=function(ruleNames){\"string\"==typeof ruleNames&&(ruleNames=ruleNames.split(\"|\")),this.infoRules=lang.arrayToMap(ruleNames),this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.setDisabledRules=function(ruleNames){if(ruleNames){\"string\"==typeof ruleNames&&(ruleNames=ruleNames.split(\"|\"));\nvar all={};CSSLint.getRules().forEach(function(x){all[x.id]=!0}),ruleNames.forEach(function(x){delete all[x]}),this.ruleset=all}else this.ruleset=null;this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.onUpdate=function(){var value=this.doc.getValue();if(!value)return this.sender.emit(\"annotate\",[]);var infoRules=this.infoRules,result=CSSLint.verify(value,this.ruleset);this.sender.emit(\"annotate\",result.messages.map(function(msg){return{row:msg.line-1,column:msg.col-1,text:msg.message,type:infoRules[msg.rule.id]?\"info\":msg.type,rule:msg.rule.name}}))}}.call(Worker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(123);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(123);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(123);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(123);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(171);
	var Transform = __webpack_require__(172);
	var inherits = __webpack_require__(30);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(289);
	} catch (err) {
	  var index = __webpack_require__(289);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(175);
	var TAG = __webpack_require__(37)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83);
	var document = __webpack_require__(63).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(67) && !__webpack_require__(81)(function () {
	  return Object.defineProperty(__webpack_require__(291)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(175);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(124);
	var $export = __webpack_require__(62);
	var redefine = __webpack_require__(300);
	var hide = __webpack_require__(82);
	var Iterators = __webpack_require__(84);
	var $iterCreate = __webpack_require__(685);
	var setToStringTag = __webpack_require__(181);
	var getPrototypeOf = __webpack_require__(297);
	var ITERATOR = __webpack_require__(37)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(125);
	var createDesc = __webpack_require__(102);
	var toIObject = __webpack_require__(85);
	var toPrimitive = __webpack_require__(185);
	var has = __webpack_require__(68);
	var IE8_DOM_DEFINE = __webpack_require__(292);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(67) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(298);
	var hiddenKeys = __webpack_require__(178).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(68);
	var toObject = __webpack_require__(103);
	var IE_PROTO = __webpack_require__(182)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(68);
	var toIObject = __webpack_require__(85);
	var arrayIndexOf = __webpack_require__(678)(false);
	var IE_PROTO = __webpack_require__(182)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(62);
	var core = __webpack_require__(27);
	var fails = __webpack_require__(81);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(82);


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(184);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(290);
	var ITERATOR = __webpack_require__(37)('iterator');
	var Iterators = __webpack_require__(84);
	module.exports = __webpack_require__(27).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var emptyObject = __webpack_require__(129);
	var _invariant = __webpack_require__(11);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(1707)
	
	var md5 = toConstructor(__webpack_require__(711))
	var rmd160 = toConstructor(__webpack_require__(1702))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(69);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getVisibleRectForElement = __webpack_require__(308);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _adjustForViewport = __webpack_require__(719);
	
	var _adjustForViewport2 = _interopRequireDefault(_adjustForViewport);
	
	var _getRegion = __webpack_require__(307);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	var _getElFuturePos = __webpack_require__(723);
	
	var _getElFuturePos2 = _interopRequireDefault(_getElFuturePos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// http://yiminghe.iteye.com/blog/1124720
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	} /**
	   * align dom node flexibly
	   * @author yiminghe@gmail.com
	   */
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  _utils2['default'].each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n = void 0;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */
	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  // 当前节点可以被放置的显示区域
	  var visibleRect = (0, _getVisibleRectForElement2['default'])(source);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = (0, _getRegion2['default'])(source);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = _utils2['default'].merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/ig, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
	
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/ig, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
	
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, points, offset, targetOffset);
	      _utils2['default'].mix(newElRegion, elFuturePos);
	    }
	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
	    // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数
	    if (isStillFailX || isStillFailY) {
	      points = align.points;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    }
	    // 2. 只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = (0, _adjustForViewport2['default'])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    _utils2['default'].css(source, 'width', _utils2['default'].width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    _utils2['default'].css(source, 'height', _utils2['default'].height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  _utils2['default'].offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	
	exports['default'] = doAlign;
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	module.exports = exports['default'];

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(69);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	function getOffsetParent(element) {
	  if (_utils2['default'].isWindow(element) || element.nodeType === 9) {
	    return null;
	  }
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = _utils2['default'].getDocument(element);
	  var body = doc.body;
	  var parent = void 0;
	  var positionStyle = _utils2['default'].css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
	  }
	
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    positionStyle = _utils2['default'].css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	exports['default'] = getOffsetParent;
	module.exports = exports['default'];

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(69);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getRegion(node) {
	  var offset = void 0;
	  var w = void 0;
	  var h = void 0;
	  if (!_utils2['default'].isWindow(node) && node.nodeType !== 9) {
	    offset = _utils2['default'].offset(node);
	    w = _utils2['default'].outerWidth(node);
	    h = _utils2['default'].outerHeight(node);
	  } else {
	    var win = _utils2['default'].getWindow(node);
	    offset = {
	      left: _utils2['default'].getWindowScrollLeft(win),
	      top: _utils2['default'].getWindowScrollTop(win)
	    };
	    w = _utils2['default'].viewportWidth(win);
	    h = _utils2['default'].viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	exports['default'] = getRegion;
	module.exports = exports['default'];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(69);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(306);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _isAncestorFixed = __webpack_require__(725);
	
	var _isAncestorFixed2 = _interopRequireDefault(_isAncestorFixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = (0, _getOffsetParent2['default'])(element);
	  var doc = _utils2['default'].getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && _utils2['default'].css(el, 'overflow') !== 'visible') {
	      var pos = _utils2['default'].offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = (0, _getOffsetParent2['default'])(el);
	  }
	
	  // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	  var originalPosition = null;
	  if (!_utils2['default'].isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = _utils2['default'].css(element, 'position');
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	
	  var scrollX = _utils2['default'].getWindowScrollLeft(win);
	  var scrollY = _utils2['default'].getWindowScrollTop(win);
	  var viewportWidth = _utils2['default'].viewportWidth(win);
	  var viewportHeight = _utils2['default'].viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight;
	
	  // Reset element position after calculate the visible area
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	
	  if ((0, _isAncestorFixed2['default'])(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	exports['default'] = getVisibleRectForElement;
	module.exports = exports['default'];

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(727);

/***/ }),
/* 310 */
128,
/* 311 */
128,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(38);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var is = __webpack_require__(859);
	var delegate = __webpack_require__(718);
	
	/**
	 * Validates all params and calls the right
	 * listener function based on its target type.
	 *
	 * @param {String|HTMLElement|HTMLCollection|NodeList} target
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listen(target, type, callback) {
	    if (!target && !type && !callback) {
	        throw new Error('Missing required arguments');
	    }
	
	    if (!is.string(type)) {
	        throw new TypeError('Second argument must be a String');
	    }
	
	    if (!is.fn(callback)) {
	        throw new TypeError('Third argument must be a Function');
	    }
	
	    if (is.node(target)) {
	        return listenNode(target, type, callback);
	    }
	    else if (is.nodeList(target)) {
	        return listenNodeList(target, type, callback);
	    }
	    else if (is.string(target)) {
	        return listenSelector(target, type, callback);
	    }
	    else {
	        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
	    }
	}
	
	/**
	 * Adds an event listener to a HTML element
	 * and returns a remove listener function.
	 *
	 * @param {HTMLElement} node
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNode(node, type, callback) {
	    node.addEventListener(type, callback);
	
	    return {
	        destroy: function() {
	            node.removeEventListener(type, callback);
	        }
	    }
	}
	
	/**
	 * Add an event listener to a list of HTML elements
	 * and returns a remove listener function.
	 *
	 * @param {NodeList|HTMLCollection} nodeList
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNodeList(nodeList, type, callback) {
	    Array.prototype.forEach.call(nodeList, function(node) {
	        node.addEventListener(type, callback);
	    });
	
	    return {
	        destroy: function() {
	            Array.prototype.forEach.call(nodeList, function(node) {
	                node.removeEventListener(type, callback);
	            });
	        }
	    }
	}
	
	/**
	 * Add an event listener to a selector
	 * and returns a remove listener function.
	 *
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenSelector(selector, type, callback) {
	    return delegate(document.body, selector, type, callback);
	}
	
	module.exports = listen;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 318 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = __webpack_require__(885);
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(44);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(926),
	    isArguments = __webpack_require__(341),
	    isArray = __webpack_require__(39),
	    isBuffer = __webpack_require__(210),
	    isIndex = __webpack_require__(335),
	    isTypedArray = __webpack_require__(343);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(325),
	    eq = __webpack_require__(208);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(941);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(909),
	    keys = __webpack_require__(107);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(330),
	    toKey = __webpack_require__(137);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(323),
	    isArray = __webpack_require__(39);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(912),
	    isObjectLike = __webpack_require__(54);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(39),
	    isKey = __webpack_require__(205),
	    stringToPath = __webpack_require__(982),
	    toString = __webpack_require__(994);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(899),
	    arraySome = __webpack_require__(903),
	    cacheHas = __webpack_require__(928);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(328),
	    getSymbols = __webpack_require__(204),
	    keys = __webpack_require__(107);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(323),
	    getPrototype = __webpack_require__(203),
	    getSymbols = __webpack_require__(204),
	    stubArray = __webpack_require__(345);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(86);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(911),
	    isObjectLike = __webpack_require__(54);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    isObject = __webpack_require__(86);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(917),
	    baseUnary = __webpack_require__(201),
	    nodeUtil = __webpack_require__(207);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(321),
	    baseKeysIn = __webpack_require__(920),
	    isArrayLike = __webpack_require__(138);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(19);
	var TextField_1 = __webpack_require__(40);
	var ObjectAssign = __webpack_require__(18);
	var bind_decorator_1 = __webpack_require__(646);
	var errorNames;
	(function (errorNames) {
	    errorNames.none = 'none';
	    errorNames.invalidSymbol = 'invalidSymbol';
	    errorNames.incompleteNumber = 'incompleteNumber';
	    errorNames.singleMinus = 'singleMinus';
	    errorNames.singleFloatingPoint = 'singleFloatingPoint';
	    errorNames.singleZero = 'singleZero';
	    errorNames.min = 'min';
	    errorNames.max = 'max';
	    errorNames.required = 'required';
	    errorNames.clean = 'clean';
	    errorNames.allow = 'allow';
	    errorNames.limit = 'limit';
	})(errorNames || (errorNames = {}));
	var strategies;
	(function (strategies) {
	    strategies.ignore = 'ignore';
	    strategies.warn = 'warn';
	    strategies.allow = 'allow';
	})(strategies || (strategies = {}));
	var typeofs;
	(function (typeofs) {
	    typeofs.stringType = 'string';
	    typeofs.numberType = 'number';
	})(typeofs || (typeofs = {}));
	var constants;
	(function (constants) {
	    constants.emptyString = '';
	    constants.dash = '-';
	    constants.dot = '.';
	    constants.zero = 0;
	    constants.one = 1;
	    constants.text = 'text';
	    constants.zeroString = '0';
	    constants.minusOne = -1;
	    constants.boolTrue = true;
	    constants.boolFalse = false;
	})(constants || (constants = {}));
	var NumberInput = (function (_super) {
	    __extends(NumberInput, _super);
	    function NumberInput(props) {
	        var _this = _super.call(this, props) || this;
	        _this.constProps = {
	            type: constants.text,
	            onChange: _this.onChange,
	            onBlur: _this.onBlur,
	            ref: _this.refTextField
	        };
	        return _this;
	    }
	    NumberInput.getValidValue = function (value) {
	        var match = value.match(NumberInput.allowed);
	        return match !== null ? (match.index === constants.zero ? match[constants.zero] : match.join(constants.emptyString)) : constants.emptyString;
	    };
	    NumberInput.deleteOwnProps = function (props) {
	        var prop;
	        for (var index = 0; index < NumberInput.deleteProps.length; ++index) {
	            prop = NumberInput.deleteProps[index];
	            if (props.hasOwnProperty(prop)) {
	                delete props[prop];
	            }
	        }
	    };
	    NumberInput.validateNumberValue = function (value, props) {
	        var max = props.max, min = props.min;
	        if ((typeof max === typeofs.numberType) && (value > max)) {
	            return constants.one;
	        }
	        if ((typeof min === typeofs.numberType) && (value < min)) {
	            return constants.minusOne;
	        }
	        return constants.zero;
	    };
	    NumberInput.validateValue = function (value, props) {
	        var required = props.required, strategy = props.strategy, min = props.min;
	        if (value === constants.emptyString) {
	            return required ? errorNames.required : errorNames.clean;
	        }
	        else {
	            if (value.match(NumberInput.validSymbols)) {
	                if (value.match(NumberInput.stricAllowed)) {
	                    if (value.match(NumberInput.validNumber)) {
	                        var numberValue = Number(value);
	                        var floatingPoint = value.indexOf(constants.dot);
	                        var decimal = floatingPoint > constants.minusOne;
	                        var whole = decimal ? Number(value.substring(constants.zero, floatingPoint)) : min;
	                        switch (NumberInput.validateNumberValue(numberValue, props)) {
	                            case constants.one: return errorNames.max;
	                            case constants.minusOne: return ((strategy !== strategies.allow) && (min > constants.zero) && (numberValue > constants.zero) && (!decimal || (decimal && (whole > min)))) ? errorNames.allow : errorNames.min;
	                            default: return errorNames.none;
	                        }
	                    }
	                    else {
	                        return (strategy !== strategies.allow) && (value === constants.dash) && (min >= constants.zero)
	                            ? errorNames.limit : (min < 0 ? errorNames.allow : errorNames.incompleteNumber);
	                    }
	                }
	                else {
	                    switch (value[value.length - constants.one]) {
	                        case constants.dash: return errorNames.singleMinus;
	                        case constants.dot: return errorNames.singleFloatingPoint;
	                        case constants.zeroString: return errorNames.singleZero;
	                        default: return errorNames.invalidSymbol;
	                    }
	                }
	            }
	            else {
	                return errorNames.invalidSymbol;
	            }
	        }
	    };
	    NumberInput.overrideRequestedValue = function (error, value, props) {
	        switch (error) {
	            case errorNames.min: return String(props.min);
	            case errorNames.max: return String(props.max);
	            default: return props.strategy !== strategies.allow && value === constants.dash && props.min >= 0 ? constants.emptyString : value;
	        }
	    };
	    NumberInput.overrideError = function (error, props) {
	        switch (error) {
	            case errorNames.allow: return errorNames.none;
	            case errorNames.limit: return props.required ? errorNames.required : errorNames.clean;
	            default: return error;
	        }
	    };
	    NumberInput.revertAllowToMin = function (error) {
	        return error === errorNames.allow ? errorNames.min : error;
	    };
	    NumberInput.emitValid = function (error, overridenError) {
	        return (error !== errorNames.allow) && (overridenError === errorNames.none);
	    };
	    NumberInput.prototype.emitEvents = function (nextError, value, valid, props) {
	        var onError = props.onError, onValid = props.onValid;
	        if ((this.error !== nextError) && (props.strategy !== strategies.ignore)) {
	            if (onError) {
	                onError(nextError);
	            }
	            this.error = nextError;
	        }
	        if (onValid && valid && (this.lastValid !== value)) {
	            onValid(Number(value));
	            this.lastValid = value;
	        }
	    };
	    NumberInput.prototype.takeActionForValue = function (value, props) {
	        var strategy = props.strategy, onRequestValue = props.onRequestValue, propsValue = props.value;
	        var error = NumberInput.validateValue(value, props);
	        var valid = NumberInput.overrideRequestedValue(error, NumberInput.getValidValue(value), props);
	        var overridenError = NumberInput.overrideError(error, props);
	        var emitValid = NumberInput.emitValid(error, overridenError);
	        this.emitEvents(overridenError, valid, emitValid, props);
	        if ((strategy !== strategies.allow) && (valid !== value)) {
	            if (typeof propsValue !== typeofs.stringType) {
	                this.getInputNode().value = valid;
	            }
	            else if (onRequestValue) {
	                onRequestValue(valid);
	            }
	        }
	    };
	    NumberInput.prototype.shouldTakeActionForValue = function (props) {
	        var _a = this.props, min = _a.min, max = _a.max, required = _a.required, strategy = _a.strategy;
	        return (min !== props.min) || (max !== props.max) || (required !== props.required) || (strategy !== props.strategy);
	    };
	    NumberInput.prototype.refTextField = function (textField) {
	        this.textField = textField;
	    };
	    NumberInput.prototype.onChange = function (event) {
	        var value = event.currentTarget.value;
	        var onChange = this.props.onChange;
	        if (onChange) {
	            onChange(event, value);
	        }
	        if (typeof this.props.value !== typeofs.stringType) {
	            this.takeActionForValue(value, this.props);
	        }
	    };
	    NumberInput.prototype.onBlur = function (event) {
	        var value = event.currentTarget.value;
	        var props = this.props;
	        var onBlur = props.onBlur;
	        var error = NumberInput.overrideError(NumberInput.revertAllowToMin(NumberInput.validateValue(value, props)), props);
	        this.emitEvents(error, value, constants.boolFalse, props);
	        if (onBlur) {
	            onBlur(event);
	        }
	    };
	    NumberInput.prototype.getInputNode = function () {
	        return this.textField.getInputNode();
	    };
	    NumberInput.prototype.getTextField = function () {
	        return this.textField;
	    };
	    NumberInput.prototype.componentDidMount = function () {
	        var props = this.props;
	        var value = props.value;
	        this.takeActionForValue(typeof value === typeofs.stringType ? value : this.getInputNode().value, props);
	    };
	    NumberInput.prototype.componentWillReceiveProps = function (props) {
	        var value = props.value;
	        if ((value !== this.props.value) || this.shouldTakeActionForValue(props)) {
	            this.takeActionForValue(value, props);
	        }
	    };
	    NumberInput.prototype.render = function () {
	        var _a = this, props = _a.props, constProps = _a.constProps;
	        var value = props.value, defaultValue = props.defaultValue;
	        var inputProps = ObjectAssign({}, props, constProps, {
	            defaultValue: typeof defaultValue === typeofs.numberType ? String(defaultValue) : undefined,
	            value: value,
	        });
	        if (typeof inputProps.value !== typeofs.stringType) {
	            delete inputProps.value;
	        }
	        if (inputProps.defaultValue === undefined) {
	            delete inputProps.defaultValue;
	        }
	        NumberInput.deleteOwnProps(inputProps);
	        return React.createElement(TextField_1.default, inputProps);
	    };
	    NumberInput.validSymbols = /(\-|\.|\d)+/;
	    NumberInput.stricAllowed = /^-?((0|([1-9]\d{0,}))(\.\d{0,})?)?$/;
	    NumberInput.validNumber = /^-?((0(\.\d+)?)|([1-9]\d{0,}(\.\d+)?))$/;
	    NumberInput.allowed = /-?((0|([1-9]\d{0,}))(\.\d{0,})?)?/;
	    NumberInput.deleteProps = ['strategy', 'onError', 'onValid', 'onRequestValue'];
	    NumberInput.propTypes = {
	        className: PropTypes.string,
	        disabled: PropTypes.bool,
	        errorStyle: PropTypes.object,
	        errorText: PropTypes.node,
	        floatingLabelFixed: PropTypes.bool,
	        floatingLabelFocusStyle: PropTypes.object,
	        floatingLabelStyle: PropTypes.object,
	        floatingLabelText: PropTypes.node,
	        fullWidth: PropTypes.bool,
	        hintStyle: PropTypes.object,
	        hintText: PropTypes.node,
	        id: PropTypes.string,
	        inputStyle: PropTypes.object,
	        name: PropTypes.string,
	        onBlur: PropTypes.func,
	        onChange: PropTypes.func,
	        onFocus: PropTypes.func,
	        onValid: PropTypes.func,
	        onError: PropTypes.func,
	        onRequestValue: PropTypes.func,
	        onKeyDown: PropTypes.func,
	        style: PropTypes.object,
	        underlineDisabledStyle: PropTypes.object,
	        underlineFocusStyle: PropTypes.object,
	        underlineShow: PropTypes.bool,
	        underlineStyle: PropTypes.object,
	        defaultValue: PropTypes.number,
	        min: PropTypes.number,
	        max: PropTypes.number,
	        required: PropTypes.bool,
	        strategy: PropTypes.oneOf([
	            strategies.ignore,
	            strategies.warn,
	            strategies.allow
	        ]),
	        value: PropTypes.string
	    };
	    NumberInput.defaultProps = {
	        required: constants.boolFalse,
	        strategy: strategies.allow
	    };
	    __decorate([
	        bind_decorator_1.default
	    ], NumberInput.prototype, "refTextField", null);
	    __decorate([
	        bind_decorator_1.default
	    ], NumberInput.prototype, "onChange", null);
	    __decorate([
	        bind_decorator_1.default
	    ], NumberInput.prototype, "onBlur", null);
	    return NumberInput;
	}(React.Component));
	exports.NumberInput = NumberInput;
	exports.default = NumberInput;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Avatar = __webpack_require__(1002);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var selected = props.selected;
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var color = selected ? bottomNavigation.selectedColor : bottomNavigation.unselectedColor;
	
	  var styles = {
	    root: {
	      transition: 'padding-top 0.3s',
	      paddingTop: selected ? 6 : 8,
	      paddingBottom: 10,
	      paddingLeft: 12,
	      paddingRight: 12,
	      minWidth: 80,
	      maxWidth: 168
	    },
	    label: {
	      fontSize: selected ? bottomNavigation.selectedFontSize : bottomNavigation.unselectedFontSize,
	      transition: 'color 0.3s, font-size 0.3s',
	      color: color
	    },
	    icon: {
	      display: 'block',
	      /**
	       * Used to ensure SVG icons are centered
	       */
	      width: '100%'
	    },
	    iconColor: color
	  };
	
	  return styles;
	}
	
	var BottomNavigationItem = function BottomNavigationItem(props, context) {
	  var label = props.label,
	      icon = props.icon,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['label', 'icon', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var styledIcon = (0, _react.cloneElement)(icon, {
	    style: (0, _simpleAssign2.default)({}, styles.icon, icon.props.style),
	    color: icon.props.color || styles.iconColor
	  });
	
	  return _react2.default.createElement(
	    _EnhancedButton2.default,
	    (0, _extends3.default)({}, other, { style: (0, _simpleAssign2.default)({}, styles.root, style) }),
	    styledIcon,
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles(styles.label) },
	      label
	    )
	  );
	};
	
	 false ? BottomNavigationItem.propTypes = {
	  /**
	   * Set the icon representing the view for this item.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Set the label describing the view for this item.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	BottomNavigationItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = BottomNavigationItem;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      padding: 8,
	      position: 'relative'
	    },
	    action: {
	      marginRight: 8
	    }
	  };
	}
	
	var CardActions = function (_Component) {
	  (0, _inherits3.default)(CardActions, _Component);
	
	  function CardActions() {
	    (0, _classCallCheck3.default)(this, CardActions);
	    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        styledChildren
	      );
	    }
	  }]);
	  return CardActions;
	}(_react.Component);
	
	CardActions.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardActions.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Action.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardActions;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keyboardArrowUp = __webpack_require__(1102);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(1101);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _IconButton = __webpack_require__(45);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      top: 0,
	      bottom: 0,
	      right: 4,
	      margin: 'auto',
	      position: 'absolute'
	    }
	  };
	}
	
	var CardExpandable = function (_Component) {
	  (0, _inherits3.default)(CardExpandable, _Component);
	
	  function CardExpandable() {
	    (0, _classCallCheck3.default)(this, CardExpandable);
	    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardExpandable, [{
	    key: 'render',
	    value: function render() {
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          onTouchTap: this.props.onExpanding
	        },
	        this.props.expanded ? this.props.openIcon : this.props.closeIcon
	      );
	    }
	  }]);
	  return CardExpandable;
	}(_react.Component);
	
	CardExpandable.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	CardExpandable.defaultProps = {
	  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
	  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
	};
	 false ? CardExpandable.propTypes = {
	  closeIcon: _react.PropTypes.node,
	  expanded: _react.PropTypes.bool,
	  onExpanding: _react.PropTypes.func.isRequired,
	  openIcon: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardExpandable;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(347);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontWeight: card.fontWeight,
	      boxSizing: 'border-box',
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    text: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      whiteSpace: 'normal',
	      paddingRight: '90px'
	    },
	    avatar: {
	      marginRight: 16
	    },
	    title: {
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      fontSize: 15
	    },
	    subtitle: {
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block',
	      fontSize: 14
	    }
	  };
	}
	
	var CardHeader = function (_Component) {
	  (0, _inherits3.default)(CardHeader, _Component);
	
	  function CardHeader() {
	    (0, _classCallCheck3.default)(this, CardHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          avatarProp = _props.avatar,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          openIcon = _props.openIcon,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          textStyle = _props.textStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var avatar = avatarProp;
	
	      if ((0, _react.isValidElement)(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatar, {
	          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
	        });
	      } else if (avatar !== null) {
	        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        avatar,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	            subtitle
	          )
	        ),
	        children
	      );
	    }
	  }]);
	  return CardHeader;
	}(_react.Component);
	
	CardHeader.muiName = 'CardHeader';
	CardHeader.defaultProps = {
	  avatar: null
	};
	CardHeader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardHeader.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
	   * If `avatar` is an `Avatar` or other element, it will be rendered.
	   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
	   */
	  avatar: _react.PropTypes.node,
	  /**
	   * Can be used to render elements inside the Card Header.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
	   */
	  openIcon: _react.PropTypes.node,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in Card Header.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the text.
	   */
	  textStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in Card Header.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = CardHeader;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardMedia = context.muiTheme.cardMedia;
	
	
	  return {
	    root: {
	      position: 'relative'
	    },
	    overlayContainer: {
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0
	    },
	    overlay: {
	      height: '100%',
	      position: 'relative'
	    },
	    overlayContent: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      left: 0,
	      paddingTop: 8,
	      background: cardMedia.overlayContentBackground
	    },
	    media: {},
	    mediaChild: {
	      verticalAlign: 'top',
	      maxWidth: '100%',
	      minWidth: '100%',
	      width: '100%'
	    }
	  };
	}
	
	var CardMedia = function (_Component) {
	  (0, _inherits3.default)(CardMedia, _Component);
	
	  function CardMedia() {
	    (0, _classCallCheck3.default)(this, CardMedia);
	    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          mediaStyle = _props.mediaStyle,
	          overlay = _props.overlay,
	          overlayContainerStyle = _props.overlayContainerStyle,
	          overlayContentStyle = _props.overlayContentStyle,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
	      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
	      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
	      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      var titleColor = this.context.muiTheme.cardMedia.titleColor;
	      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
	      var color = this.context.muiTheme.cardMedia.color;
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.cloneElement(child, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
	        });
	      });
	
	      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
	        if (child.type.muiName === 'CardHeader' || child.type.muiName === 'CardTitle') {
	          return _react2.default.cloneElement(child, {
	            titleColor: titleColor,
	            subtitleColor: subtitleColor
	          });
	        } else if (child.type.muiName === 'CardText') {
	          return _react2.default.cloneElement(child, {
	            color: color
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedMediaStyle) },
	          styledChildren
	        ),
	        overlay ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedOverlayContainerStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(extendedOverlayStyle) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(extendedOverlayContentStyle) },
	              overlayChildren
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	  return CardMedia;
	}(_react.Component);
	
	CardMedia.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardMedia.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Media.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the Card Media.
	   */
	  mediaStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render overlay element in Card Media.
	   */
	  overlay: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the overlay container.
	   */
	  overlayContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay content.
	   */
	  overlayContentStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay element.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardMedia;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardText = context.muiTheme.cardText;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontSize: 14,
	      color: props.color || cardText.textColor
	    }
	  };
	}
	
	var CardText = function (_Component) {
	  (0, _inherits3.default)(CardText, _Component);
	
	  function CardText() {
	    (0, _classCallCheck3.default)(this, CardText);
	    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          color = _props.color,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        children
	      );
	    }
	  }]);
	  return CardText;
	}(_react.Component);
	
	CardText.muiName = 'CardText';
	CardText.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardText.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Text.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the CardText color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardText;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      position: 'relative'
	    },
	    title: {
	      fontSize: 24,
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      lineHeight: '36px'
	    },
	    subtitle: {
	      fontSize: 14,
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block'
	    }
	  };
	}
	
	var CardTitle = function (_Component) {
	  (0, _inherits3.default)(CardTitle, _Component);
	
	  function CardTitle() {
	    (0, _classCallCheck3.default)(this, CardTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
	      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
	      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedTitleStyle) },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedSubtitleStyle) },
	          subtitle
	        ),
	        children
	      );
	    }
	  }]);
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.muiName = 'CardTitle';
	CardTitle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardTitle.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Title.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in the Card Title.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in the Card Title.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = CardTitle;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(1025);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(1028);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(217);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _titleBar;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      gridTile = _context$muiTheme.gridTile;
	
	
	  var actionPos = props.actionIcon && props.actionPosition;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'block',
	      height: '100%',
	      overflow: 'hidden'
	    },
	    titleBar: (_titleBar = {
	      position: 'absolute',
	      left: 0,
	      right: 0
	    }, (0, _defineProperty3.default)(_titleBar, props.titlePosition, 0), (0, _defineProperty3.default)(_titleBar, 'height', props.subtitle ? 68 : 48), (0, _defineProperty3.default)(_titleBar, 'background', props.titleBackground), (0, _defineProperty3.default)(_titleBar, 'display', 'flex'), (0, _defineProperty3.default)(_titleBar, 'alignItems', 'center'), _titleBar),
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: actionPos !== 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginRight: actionPos === 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      color: gridTile.textColor,
	      overflow: 'hidden'
	    },
	    title: {
	      fontSize: '16px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: '12px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {
	      order: actionPos === 'left' ? -1 : 1
	    },
	    childImg: {
	      height: '100%',
	      transform: 'translateX(-50%)',
	      position: 'relative',
	      left: '50%'
	    }
	  };
	  return styles;
	}
	
	var GridTile = function (_Component) {
	  (0, _inherits3.default)(GridTile, _Component);
	
	  function GridTile() {
	    (0, _classCallCheck3.default)(this, GridTile);
	    return (0, _possibleConstructorReturn3.default)(this, (GridTile.__proto__ || (0, _getPrototypeOf2.default)(GridTile)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridTile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'ensureImageCover',
	    value: function ensureImageCover() {
	      var _this2 = this;
	
	      var imgEl = this.refs.img;
	
	      if (imgEl) {
	        (function () {
	          var fit = function fit() {
	            if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
	              var isRtl = _this2.context.muiTheme.isRtl;
	
	              imgEl.style.height = 'auto';
	              if (isRtl) {
	                imgEl.style.right = '0';
	              } else {
	                imgEl.style.left = '0';
	              }
	              imgEl.style.width = '100%';
	              imgEl.style.top = '50%';
	              imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
	            }
	            imgEl.removeEventListener('load', fit);
	            imgEl = null; // prevent closure memory leak
	          };
	          if (imgEl.complete) {
	            fit();
	          } else {
	            imgEl.addEventListener('load', fit);
	          }
	        })();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          subtitle = _props.subtitle,
	          titlePosition = _props.titlePosition,
	          titleBackground = _props.titleBackground,
	          titleStyle = _props.titleStyle,
	          actionIcon = _props.actionIcon,
	          actionPosition = _props.actionPosition,
	          style = _props.style,
	          children = _props.children,
	          containerElement = _props.containerElement,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'titleStyle', 'actionIcon', 'actionPosition', 'style', 'children', 'containerElement']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var titleBar = null;
	
	      if (title) {
	        titleBar = _react2.default.createElement(
	          'div',
	          { key: 'titlebar', style: prepareStyles(styles.titleBar) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.titleWrap) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	              title
	            ),
	            subtitle ? _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.subtitle) },
	              subtitle
	            ) : null
	          ),
	          actionIcon ? _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.actionIcon) },
	            actionIcon
	          ) : null
	        );
	      }
	
	      var newChildren = children;
	
	      // if there is a single image passed as children
	      // clone it and add our styles
	      if (_react2.default.Children.count(children) === 1) {
	        newChildren = _react2.default.Children.map(children, function (child) {
	          if (child.type === 'img') {
	            return _react2.default.cloneElement(child, {
	              key: 'img',
	              ref: 'img',
	              style: prepareStyles((0, _simpleAssign2.default)({}, styles.childImg, child.props.style))
	            });
	          } else {
	            return child;
	          }
	        });
	      }
	
	      var containerProps = (0, _extends3.default)({
	        style: prepareStyles(mergedRootStyles)
	      }, other);
	
	      return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, containerProps, [newChildren, titleBar]) : _react2.default.createElement(containerElement, containerProps, [newChildren, titleBar]);
	    }
	  }]);
	  return GridTile;
	}(_react.Component);
	
	GridTile.defaultProps = {
	  titlePosition: 'bottom',
	  titleBackground: 'rgba(0, 0, 0, 0.4)',
	  actionPosition: 'right',
	  cols: 1,
	  rows: 1,
	  containerElement: 'div'
	};
	GridTile.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? GridTile.propTypes = {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _react.PropTypes.element,
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in whichcase GridTile takes care of making the image "cover" available space
	   * (similar to background-size: cover or to object-fit:cover).
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _react.PropTypes.number,
	  /**
	   * Either a string used as tag name for the tile root element, or a ReactElement.
	   * This is useful when you have, for example, a custom implementation of
	   * a navigation link (that knows about your routes) and you want to use it as the primary tile action.
	   * In case you pass a ReactElement, please ensure that it passes all props,
	   * accepts styles overrides and render it's children.
	   */
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Style used for title bar background.
	   * Useful for setting custom gradients for example
	   */
	  titleBackground: _react.PropTypes.string,
	  /**
	   * Position of the title bar (container of title, subtitle and action icon).
	   */
	  titlePosition: _react.PropTypes.oneOf(['top', 'bottom']),
	  /**
	   * Override the inline-styles of the title element.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = GridTile;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelectable = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colorManipulator = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeSelectable = exports.makeSelectable = function makeSelectable(MyComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(_class, _Component);
	
	    function _class() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3.default)(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
	        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
	        }
	        return previousValue || _this.isChildSelected(child, _this.props);
	      }, _this.handleItemTouchTap = function (event, item) {
	        var itemValue = item.props.value;
	
	        if (itemValue !== _this.props.value) {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, itemValue);
	          }
	        }
	      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(_class, [{
	      key: 'extendChild',
	      value: function extendChild(child, styles, selectedItemStyle) {
	        var _this2 = this;
	
	        if (child && child.type && child.type.muiName === 'ListItem') {
	          var selected = this.isChildSelected(child, this.props);
	          var selectedChildrenStyles = void 0;
	          if (selected) {
	            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
	          }
	
	          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	          this.keyIndex += 1;
	
	          return _react2.default.cloneElement(child, {
	            onTouchTap: function onTouchTap(event) {
	              _this2.handleItemTouchTap(event, child);
	              if (child.props.onTouchTap) {
	                child.props.onTouchTap(event);
	              }
	            },
	            key: this.keyIndex,
	            style: mergedChildrenStyles,
	            nestedItems: child.props.nestedItems.map(function (child) {
	              return _this2.extendChild(child, styles, selectedItemStyle);
	            }),
	            initiallyOpen: this.isInitiallyOpen(child)
	          });
	        } else {
	          return child;
	        }
	      }
	    }, {
	      key: 'isInitiallyOpen',
	      value: function isInitiallyOpen(child) {
	        if (child.props.initiallyOpen) {
	          return child.props.initiallyOpen;
	        }
	        return this.hasSelectedDescendant(false, child);
	      }
	    }, {
	      key: 'isChildSelected',
	      value: function isChildSelected(child, props) {
	        return props.value === child.props.value;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            selectedItemStyle = _props.selectedItemStyle,
	            other = (0, _objectWithoutProperties3.default)(_props, ['children', 'selectedItemStyle']);
	
	
	        this.keyIndex = 0;
	        var styles = {};
	
	        if (!selectedItemStyle) {
	          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
	          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
	        }
	
	        return _react2.default.createElement(
	          MyComponent,
	          (0, _extends3.default)({}, other, this.state),
	          _react.Children.map(children, function (child) {
	            return _this3.extendChild(child, styles, selectedItemStyle);
	          })
	        );
	      }
	    }]);
	    return _class;
	  }(_react.Component), _class.propTypes = {
	    children: _react.PropTypes.node,
	    onChange: _react.PropTypes.func,
	    selectedItemStyle: _react.PropTypes.object,
	    value: _react.PropTypes.any
	  }, _class.contextTypes = {
	    muiTheme: _react.PropTypes.object.isRequired
	  }, _temp2;
	};
	
	exports.default = makeSelectable;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(141);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(140);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _Menu3.default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(1051);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _typeof2 = __webpack_require__(50);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkCircle = __webpack_require__(1100);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active,
	      completed = _ref.completed,
	      disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme,
	      stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper,
	      textColor = _muiTheme$stepper.textColor,
	      disabledTextColor = _muiTheme$stepper.disabledTextColor,
	      iconColor = _muiTheme$stepper.iconColor,
	      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      paddingRight: 8
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'not-allowed';
	  }
	
	  return styles;
	};
	
	var renderIcon = function renderIcon(completed, icon, styles) {
	  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);
	
	  if (iconType === 'number' || iconType === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_checkCircle2.default, {
	        color: styles.icon.color,
	        style: styles.icon
	      });
	    }
	
	    return _react2.default.createElement(
	      _SvgIcon2.default,
	      { color: styles.icon.color, style: styles.icon },
	      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: '12',
	          y: '16',
	          textAnchor: 'middle',
	          fontSize: '12',
	          fill: '#fff'
	        },
	        icon
	      )
	    );
	  }
	
	  return icon;
	};
	
	var StepLabel = function StepLabel(props, context) {
	  var active = props.active,
	      children = props.children,
	      completed = props.completed,
	      userIcon = props.icon,
	      iconContainerStyle = props.iconContainerStyle,
	      last = props.last,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	  var icon = renderIcon(completed, userIcon, styles);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	    icon && _react2.default.createElement(
	      'span',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
	      icon
	    ),
	    children
	  );
	};
	
	StepLabel.muiName = 'StepLabel';
	
	 false ? StepLabel.propTypes = {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * The label text node
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	StepLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	exports.default = StepLabel;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(1062);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(271);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(50);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(108);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableRowColumn = __webpack_require__(143);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _ClickAwayListener = __webpack_require__(222);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableBody = function (_Component) {
	  (0, _inherits3.default)(TableBody, _Component);
	
	  function TableBody() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedRows: []
	    }, _this.handleClickAway = function () {
	      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length) {
	        _this.setState({
	          selectedRows: []
	        });
	        if (_this.props.onRowSelection) {
	          _this.props.onRowSelection([]);
	        }
	      }
	    }, _this.onRowClick = function (event, rowNumber) {
	      event.stopPropagation();
	
	      if (_this.props.selectable) {
	        // Prevent text selection while selecting rows.
	        window.getSelection().removeAllRanges();
	        _this.processRowSelection(event, rowNumber);
	      }
	    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
	      event.stopPropagation();
	      if (_this.props.onCellClick) {
	        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHover) {
	        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHover(event, rowNumber);
	    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHoverExit) {
	        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHoverExit(event, rowNumber);
	    }, _this.onRowHover = function (event, rowNumber) {
	      if (_this.props.onRowHover) {
	        _this.props.onRowHover(rowNumber);
	      }
	    }, _this.onRowHoverExit = function (event, rowNumber) {
	      if (_this.props.onRowHoverExit) {
	        _this.props.onRowHoverExit(rowNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableBody, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ selectedRows: this.calculatePreselectedRows(this.props) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        if (!nextProps.allRowsSelected) {
	          this.setState({
	            selectedRows: []
	          });
	        } else {
	          this.setState({
	            selectedRows: this.calculatePreselectedRows(nextProps)
	          });
	        }
	      }
	    }
	  }, {
	    key: 'createRows',
	    value: function createRows() {
	      var _this2 = this;
	
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var rowNumber = 0;
	      var handlers = {
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowClick: this.onRowClick
	      };
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          var _ret2 = function () {
	            var props = {
	              hoverable: _this2.props.showRowHover,
	              selected: _this2.isRowSelected(rowNumber),
	              striped: _this2.props.stripedRows && rowNumber % 2 === 0,
	              rowNumber: rowNumber++
	            };
	
	            if (rowNumber === numChildren) {
	              props.displayBorder = false;
	            }
	
	            var children = [_this2.createRowCheckboxColumn(props)];
	
	            _react2.default.Children.forEach(child.props.children, function (child) {
	              children.push(child);
	            });
	
	            return {
	              v: _react2.default.cloneElement(child, (0, _extends3.default)({}, props, handlers), children)
	            };
	          }();
	
	          if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
	        }
	      });
	    }
	  }, {
	    key: 'createRowCheckboxColumn',
	    value: function createRowCheckboxColumn(rowProps) {
	      if (!this.props.displayRowCheckbox) {
	        return null;
	      }
	
	      var key = rowProps.rowNumber + '-cb';
	      var disabled = !this.props.selectable;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        ref: 'rowSelectCB',
	        name: key,
	        value: 'selected',
	        disabled: disabled,
	        checked: rowProps.selected
	      });
	
	      return _react2.default.createElement(
	        _TableRowColumn2.default,
	        {
	          key: key,
	          columnNumber: 0,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'calculatePreselectedRows',
	    value: function calculatePreselectedRows(props) {
	      // Determine what rows are 'pre-selected'.
	      var preSelectedRows = [];
	
	      if (props.selectable && props.preScanRows) {
	        (function () {
	          var index = 0;
	          _react2.default.Children.forEach(props.children, function (child) {
	            if (_react2.default.isValidElement(child)) {
	              if (child.props.selected && (preSelectedRows.length === 0 || props.multiSelectable)) {
	                preSelectedRows.push(index);
	              }
	
	              index++;
	            }
	          });
	        })();
	      }
	
	      return preSelectedRows;
	    }
	  }, {
	    key: 'isRowSelected',
	    value: function isRowSelected(rowNumber) {
	      if (this.props.allRowsSelected) {
	        return true;
	      }
	
	      for (var i = 0; i < this.state.selectedRows.length; i++) {
	        var selection = this.state.selectedRows[i];
	
	        if ((typeof selection === 'undefined' ? 'undefined' : (0, _typeof3.default)(selection)) === 'object') {
	          if (this.isValueInRange(rowNumber, selection)) return true;
	        } else {
	          if (selection === rowNumber) return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isValueInRange',
	    value: function isValueInRange(value, range) {
	      if (!range) return false;
	
	      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'processRowSelection',
	    value: function processRowSelection(event, rowNumber) {
	      var selectedRows = this.state.selectedRows;
	
	      if (event.shiftKey && this.props.multiSelectable && selectedRows.length) {
	        var lastIndex = selectedRows.length - 1;
	        var lastSelection = selectedRows[lastIndex];
	
	        if ((typeof lastSelection === 'undefined' ? 'undefined' : (0, _typeof3.default)(lastSelection)) === 'object') {
	          lastSelection.end = rowNumber;
	        } else {
	          selectedRows.splice(lastIndex, 1, { start: lastSelection, end: rowNumber });
	        }
	      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
	        var idx = selectedRows.indexOf(rowNumber);
	        if (idx < 0) {
	          var foundRange = false;
	          for (var i = 0; i < selectedRows.length; i++) {
	            var range = selectedRows[i];
	            if ((typeof range === 'undefined' ? 'undefined' : (0, _typeof3.default)(range)) !== 'object') continue;
	
	            if (this.isValueInRange(rowNumber, range)) {
	              var _selectedRows;
	
	              foundRange = true;
	              var values = this.splitRange(range, rowNumber);
	              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat((0, _toConsumableArray3.default)(values)));
	            }
	          }
	
	          if (!foundRange) selectedRows.push(rowNumber);
	        } else {
	          selectedRows.splice(idx, 1);
	        }
	      } else {
	        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	          selectedRows = [];
	        } else {
	          selectedRows = [rowNumber];
	        }
	      }
	
	      this.setState({ selectedRows: selectedRows });
	      if (this.props.onRowSelection) this.props.onRowSelection(this.flattenRanges(selectedRows));
	    }
	  }, {
	    key: 'splitRange',
	    value: function splitRange(range, splitPoint) {
	      var splitValues = [];
	      var startOffset = range.start - splitPoint;
	      var endOffset = range.end - splitPoint;
	
	      // Process start half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, startOffset)));
	
	      // Process end half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, endOffset)));
	
	      return splitValues;
	    }
	  }, {
	    key: 'genRangeOfValues',
	    value: function genRangeOfValues(start, offset) {
	      var values = [];
	      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	      while (offset !== 0) {
	        values.push(start + offset);
	        offset += dir;
	      }
	
	      return values;
	    }
	  }, {
	    key: 'flattenRanges',
	    value: function flattenRanges(selectedRows) {
	      var rows = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(selectedRows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var selection = _step.value;
	
	          if ((typeof selection === 'undefined' ? 'undefined' : (0, _typeof3.default)(selection)) === 'object') {
	            var values = this.genRangeOfValues(selection.end, selection.start - selection.end);
	            rows.push.apply(rows, [selection.end].concat((0, _toConsumableArray3.default)(values)));
	          } else {
	            rows.push(selection);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return rows.sort();
	    }
	  }, {
	    key: 'getColumnId',
	    value: function getColumnId(columnNumber) {
	      var columnId = columnNumber;
	      if (this.props.displayRowCheckbox) {
	        columnId--;
	      }
	
	      return columnId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'tbody',
	          { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	          this.createRows()
	        )
	      );
	    }
	  }]);
	  return TableBody;
	}(_react.Component);
	
	TableBody.muiName = 'TableBody';
	TableBody.defaultProps = {
	  allRowsSelected: false,
	  deselectOnClickaway: true,
	  displayRowCheckbox: true,
	  multiSelectable: false,
	  preScanRows: true,
	  selectable: true,
	  style: {}
	};
	TableBody.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableBody.propTypes = {
	  /**
	   * @ignore
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _react.PropTypes.bool,
	  /**
	   * Children passed to table body.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Controls whether or not to deselect all selected
	   * rows after clicking outside the table.
	   */
	  deselectOnClickaway: _react.PropTypes.bool,
	  /**
	   * Controls the display of the row checkbox. The default value is true.
	   */
	  displayRowCheckbox: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Callback function for when a cell is clicked.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered. rowNumber
	   * is the row number of the hovered row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer
	   * hovered. rowNumber is the row number of the row
	   * that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a row is selected. selectedRows is an
	   * array of all row selections. IF all rows have been selected,
	   * the string "all" will be returned instead to indicate that
	   * all rows have been selected.
	   */
	  onRowSelection: _react.PropTypes.func,
	  /**
	   * Controls whether or not the rows are pre-scanned to determine
	   * initial state. If your table has a large number of rows and
	   * you are experiencing a delay in rendering, turn off this property.
	   */
	  preScanRows: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * If true, table rows can be selected. If multiple
	   * row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * If true, table rows will be highlighted when
	   * the cursor is hovering over the row. The default
	   * value is false.
	   */
	  showRowHover: _react.PropTypes.bool,
	  /**
	   * If true, every other table row starting
	   * with the first row will be striped. The default value is false.
	   */
	  stripedRows: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableBody;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableRowColumn = __webpack_require__(143);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableFooter = context.muiTheme.tableFooter;
	
	
	  return {
	    cell: {
	      borderTop: '1px solid ' + tableFooter.borderColor,
	      verticalAlign: 'bottom',
	      padding: 20,
	      textAlign: 'left',
	      whiteSpace: 'nowrap'
	    }
	  };
	}
	
	var TableFooter = function (_Component) {
	  (0, _inherits3.default)(TableFooter, _Component);
	
	  function TableFooter() {
	    (0, _classCallCheck3.default)(this, TableFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          adjustForCheckbox = _props.adjustForCheckbox,
	          children = _props.children,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
	        var newChildProps = {
	          displayBorder: false,
	          key: 'f-' + rowNumber,
	          rowNumber: rowNumber,
	          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	        };
	
	        var newDescendants = void 0;
	
	        if (adjustForCheckbox) {
	          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat((0, _toConsumableArray3.default)(_react2.default.Children.toArray(child.props.children)));
	        } else {
	          newDescendants = child.props.children;
	        }
	
	        return _react2.default.cloneElement(child, newChildProps, newDescendants);
	      });
	
	      return _react2.default.createElement(
	        'tfoot',
	        (0, _extends3.default)({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        footerRows
	      );
	    }
	  }]);
	  return TableFooter;
	}(_react.Component);
	
	TableFooter.muiName = 'TableFooter';
	TableFooter.defaultProps = {
	  adjustForCheckbox: true,
	  style: {}
	};
	TableFooter.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableFooter.propTypes = {
	  /**
	   * @ignore
	   * Controls whether or not header rows should be adjusted
	   * for a checkbox column. If the select all checkbox is true,
	   * this property will not influence the number of columns.
	   * This is mainly useful for "super header" rows so that
	   * the checkbox column does not create an offset that needs
	   * to be accounted for manually.
	   */
	  adjustForCheckbox: _react.PropTypes.bool,
	  /**
	   * Children passed to table footer.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableFooter;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(108);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableHeaderColumn = __webpack_require__(221);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeader = context.muiTheme.tableHeader;
	
	
	  return {
	    root: {
	      borderBottom: '1px solid ' + tableHeader.borderColor
	    }
	  };
	}
	
	var TableHeader = function (_Component) {
	  (0, _inherits3.default)(TableHeader, _Component);
	
	  function TableHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
	      if (_this.props.onSelectAll) {
	        _this.props.onSelectAll(checked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeader, [{
	    key: 'createSuperHeaderRows',
	    value: function createSuperHeaderRows() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      if (numChildren === 1) return undefined;
	
	      var superHeaders = [];
	      for (var index = 0; index < numChildren - 1; index++) {
	        var child = this.props.children[index];
	
	        if (!_react2.default.isValidElement(child)) continue;
	
	        var props = {
	          key: 'sh' + index,
	          rowNumber: index
	        };
	        superHeaders.push(this.createSuperHeaderRow(child, props));
	      }
	
	      if (superHeaders.length) return superHeaders;
	    }
	  }, {
	    key: 'createSuperHeaderRow',
	    value: function createSuperHeaderRow(child, props) {
	      var children = [];
	      if (this.props.adjustForCheckbox) {
	        children.push(this.getCheckboxPlaceholder(props));
	      }
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'createBaseHeaderRow',
	    value: function createBaseHeaderRow() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var child = numChildren === 1 ? this.props.children : this.props.children[numChildren - 1];
	      var props = {
	        key: 'h' + numChildren,
	        rowNumber: numChildren
	      };
	
	      var children = [this.getSelectAllCheckboxColumn(props)];
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'getCheckboxPlaceholder',
	    value: function getCheckboxPlaceholder(props) {
	      if (!this.props.adjustForCheckbox) return null;
	
	      var disabled = !this.props.enableSelectAll;
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(_TableHeaderColumn2.default, {
	        key: key,
	        style: {
	          width: 24,
	          cursor: disabled ? 'not-allowed' : 'inherit'
	        }
	      });
	    }
	  }, {
	    key: 'getSelectAllCheckboxColumn',
	    value: function getSelectAllCheckboxColumn(props) {
	      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);
	
	      var disabled = !this.props.enableSelectAll;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        key: 'selectallcb',
	        name: 'selectallcb',
	        value: 'selected',
	        disabled: disabled,
	        checked: this.props.selectAllSelected,
	        onCheck: this.handleCheckAll
	      });
	
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(
	        _TableHeaderColumn2.default,
	        {
	          key: key,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var superHeaderRows = this.createSuperHeaderRows();
	      var baseHeaderRow = this.createBaseHeaderRow();
	
	      return _react2.default.createElement(
	        'thead',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        superHeaderRows,
	        baseHeaderRow
	      );
	    }
	  }]);
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.muiName = 'TableHeader';
	TableHeader.defaultProps = {
	  adjustForCheckbox: true,
	  displaySelectAll: true,
	  enableSelectAll: true,
	  selectAllSelected: false
	};
	TableHeader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableHeader.propTypes = {
	  /**
	   * Controls whether or not header rows should be
	   * adjusted for a checkbox column. If the select all
	   * checkbox is true, this property will not influence
	   * the number of columns. This is mainly useful for
	   * "super header" rows so that the checkbox column
	   * does not create an offset that needs to be accounted
	   * for manually.
	   */
	  adjustForCheckbox: _react.PropTypes.bool,
	  /**
	   * Children passed to table header.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Controls whether or not the select all checkbox is displayed.
	   */
	  displaySelectAll: _react.PropTypes.bool,
	  /**
	   * If set to true, the select all button will be interactable.
	   * If set to false, the button will not be interactable.
	   * To hide the checkbox, set displaySelectAll to false.
	   */
	  enableSelectAll: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Callback when select all has been checked.
	   */
	  onSelectAll: _react.PropTypes.func,
	  /**
	   * @ignore
	   * True when select all has been checked.
	   */
	  selectAllSelected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableHeader;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var tableRow = context.muiTheme.tableRow;
	
	
	  var cellBgColor = 'inherit';
	  if (props.hovered || state.hovered) {
	    cellBgColor = tableRow.hoverColor;
	  } else if (props.selected) {
	    cellBgColor = tableRow.selectedColor;
	  } else if (props.striped) {
	    cellBgColor = tableRow.stripeColor;
	  }
	
	  return {
	    root: {
	      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
	      color: tableRow.textColor,
	      height: tableRow.height
	    },
	    cell: {
	      backgroundColor: cellBgColor
	    }
	  };
	}
	
	var TableRow = function (_Component) {
	  (0, _inherits3.default)(TableRow, _Component);
	
	  function TableRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onCellClick = function (event, columnIndex) {
	      if (_this.props.selectable && _this.props.onCellClick) {
	        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
	      }
	      event.ctrlKey = true;
	      _this.onRowClick(event);
	    }, _this.onCellHover = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHover(event);
	      }
	    }, _this.onCellHoverExit = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHoverExit(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRow, [{
	    key: 'onRowClick',
	    value: function onRowClick(event) {
	      if (this.props.selectable && this.props.onRowClick) this.props.onRowClick(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHover',
	    value: function onRowHover(event) {
	      if (this.props.onRowHover) this.props.onRowHover(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHoverExit',
	    value: function onRowHoverExit(event) {
	      if (this.props.onRowHoverExit) this.props.onRowHoverExit(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          displayBorder = _props.displayBorder,
	          hoverable = _props.hoverable,
	          hovered = _props.hovered,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowClick = _props.onRowClick,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          rowNumber = _props.rowNumber,
	          selectable = _props.selectable,
	          selected = _props.selected,
	          striped = _props.striped,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            columnNumber: columnNumber,
	            hoverable: _this2.props.hoverable,
	            key: _this2.props.rowNumber + '-' + columnNumber,
	            onClick: _this2.onCellClick,
	            onHover: _this2.onCellHover,
	            onHoverExit: _this2.onCellHoverExit,
	            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other),
	        rowColumns
	      );
	    }
	  }]);
	  return TableRow;
	}(_react.Component);
	
	TableRow.defaultProps = {
	  displayBorder: true,
	  hoverable: false,
	  hovered: false,
	  selectable: true,
	  selected: false,
	  striped: false
	};
	TableRow.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableRow.propTypes = {
	  /**
	   * Children passed to table row.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, row border will be displayed for the row.
	   * If false, no border will be drawn.
	   */
	  displayBorder: _react.PropTypes.bool,
	  /**
	   * Controls whether or not the row reponseds to hover events.
	   */
	  hoverable: _react.PropTypes.bool,
	  /**
	   * Controls whether or not the row should be rendered as being
	   * hovered. This property is evaluated in addition to this.state.hovered
	   * and can be used to synchronize the hovered state with some other
	   * external events.
	   */
	  hovered: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when row is clicked.
	   */
	  onRowClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * Number to identify the row. This property is
	   * automatically populated when used with the TableBody component.
	   */
	  rowNumber: _react.PropTypes.number,
	  /**
	   * If true, table rows can be selected. If multiple row
	   * selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * Indicates that a particular row is selected.
	   * This property can be used to programmatically select rows.
	   */
	  selected: _react.PropTypes.bool,
	  /**
	   * Indicates whether or not the row is striped.
	   */
	  striped: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableRow;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    root: {
	      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: props.width,
	      textTransform: 'uppercase',
	      padding: 0
	    },
	    button: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: props.label && props.icon ? 72 : 48
	    }
	  };
	}
	
	var Tab = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(_this.props.value, event, _this);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          index = _props.index,
	          onActive = _props.onActive,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          label = _props.label,
	          buttonStyle = _props.buttonStyle,
	          style = _props.style,
	          value = _props.value,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onTouchTap', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (icon && _react2.default.isValidElement(icon)) {
	        var iconProps = {
	          style: {
	            fontSize: 24,
	            color: styles.root.color,
	            marginBottom: label ? 5 : 0
	          }
	        };
	        // If it's svg icon set color via props
	        if (icon.type.muiName !== 'FontIcon') {
	          iconProps.color = styles.root.color;
	        }
	        iconElement = _react2.default.cloneElement(icon, iconProps);
	      }
	
	      var rippleOpacity = 0.3;
	      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity,
	          onTouchTap: this.handleTouchTap
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
	          iconElement,
	          label
	        )
	      );
	    }
	  }]);
	  return Tab;
	}(_react.Component);
	
	Tab.muiName = 'Tab';
	Tab.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Tab.propTypes = {
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _react.PropTypes.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  index: _react.PropTypes.any,
	  /**
	   * Sets the text value of the tab item to the string specified.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * Fired when the active tab changes by touch or tap.
	   * Use this event to specify any functionality when an active tab changes.
	   * For example - we are using this to route to home when the third tab becomes active.
	   * This function will always recieve the active tab as it\'s first argument.
	   */
	  onActive: _react.PropTypes.func,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Defines if the current tab is selected or not.
	   * The Tabs component is responsible for setting this property.
	   */
	  selected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If value prop passed to Tabs component, this value prop is also required.
	   * It assigns a value to the tab so that it can be selected by the Tabs.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  width: _react.PropTypes.string
	} : void 0;
	exports.default = Tab;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _slicedToArray2 = __webpack_require__(167);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timeUtils = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var styles = {
	    root: {
	      directionInvariant: true,
	      display: 'inline-block',
	      position: 'absolute',
	      width: 32,
	      height: 32,
	      borderRadius: '100%',
	      left: 'calc(50% - 16px)',
	      top: 10,
	      textAlign: 'center',
	      paddingTop: 5,
	      userSelect: 'none', /* Chrome all / Safari all */
	      fontSize: '1.1em',
	      pointerEvents: 'none',
	      boxSizing: 'border-box'
	    }
	  };
	
	  var muiTheme = context.muiTheme;
	
	
	  var pos = props.value;
	
	  if (props.type === 'hour') {
	    pos %= 12;
	  } else {
	    pos = pos / 5;
	  }
	
	  var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	  var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	  if (props.isSelected) {
	    styles.root.backgroundColor = muiTheme.timePicker.accentColor;
	    styles.root.color = muiTheme.timePicker.selectTextColor;
	  }
	
	  var transformPos = positions[pos];
	
	  if ((0, _timeUtils.isInner)(props)) {
	    styles.root.width = 28;
	    styles.root.height = 28;
	    styles.root.left = 'calc(50% - 14px)';
	    transformPos = innerPositions[pos];
	  }
	
	  var _transformPos = transformPos,
	      _transformPos2 = (0, _slicedToArray3.default)(_transformPos, 2),
	      x = _transformPos2[0],
	      y = _transformPos2[1];
	
	  styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	  return styles;
	}
	
	var ClockNumber = function (_Component) {
	  (0, _inherits3.default)(ClockNumber, _Component);
	
	  function ClockNumber() {
	    (0, _classCallCheck3.default)(this, ClockNumber);
	    return (0, _possibleConstructorReturn3.default)(this, (ClockNumber.__proto__ || (0, _getPrototypeOf2.default)(ClockNumber)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ClockNumber, [{
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var clockNumber = this.props.value === 0 ? '00' : this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles(styles.root) },
	        clockNumber
	      );
	    }
	  }]);
	  return ClockNumber;
	}(_react.Component);
	
	ClockNumber.defaultProps = {
	  value: 0,
	  type: 'minute',
	  isSelected: false
	};
	ClockNumber.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ClockNumber.propTypes = {
	  isSelected: _react.PropTypes.bool,
	  onSelected: _react.PropTypes.func,
	  type: _react.PropTypes.oneOf(['hour', 'minute']),
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = ClockNumber;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timeUtils = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcAngle(value, base) {
	  value %= base;
	  var angle = 360 / base * value;
	  return angle;
	}
	
	function getStyles(props, context, state) {
	  var hasSelected = props.hasSelected,
	      type = props.type,
	      value = props.value;
	  var inner = state.inner;
	  var timePicker = context.muiTheme.timePicker;
	
	  var angle = type === 'hour' ? calcAngle(value, 12) : calcAngle(value, 60);
	
	  var styles = {
	    root: {
	      height: inner ? '30%' : '40%',
	      background: timePicker.accentColor,
	      width: 2,
	      left: 'calc(50% - 1px)',
	      position: 'absolute',
	      bottom: '50%',
	      transformOrigin: 'bottom',
	      pointerEvents: 'none',
	      transform: 'rotateZ(' + angle + 'deg)'
	    },
	    mark: {
	      boxSizing: 'content-box',
	      background: timePicker.selectTextColor,
	      border: '4px solid ' + timePicker.accentColor,
	      display: hasSelected && 'none',
	      width: 7,
	      height: 7,
	      position: 'absolute',
	      top: -5,
	      left: -6,
	      borderRadius: '100%'
	    }
	  };
	
	  return styles;
	}
	
	var ClockPointer = function (_Component) {
	  (0, _inherits3.default)(ClockPointer, _Component);
	
	  function ClockPointer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockPointer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockPointer.__proto__ || (0, _getPrototypeOf2.default)(ClockPointer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inner: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockPointer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(this.props)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(nextProps)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.value === null) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement('div', { style: prepareStyles(styles.mark) })
	      );
	    }
	  }]);
	  return ClockPointer;
	}(_react.Component);
	
	ClockPointer.defaultProps = {
	  hasSelected: false,
	  value: null,
	  type: 'minute'
	};
	ClockPointer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ClockPointer.propTypes = {
	  hasSelected: _react.PropTypes.bool,
	  type: _react.PropTypes.oneOf(['hour', 'minute']),
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = ClockPointer;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var firstChild = props.firstChild,
	      lastChild = props.lastChild;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  var marginHorizontal = baseTheme.spacing.desktopGutter;
	  var marginVertical = (toolbar.height - button.height) / 2;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      marginLeft: firstChild ? -marginHorizontal : undefined,
	      marginRight: lastChild ? -marginHorizontal : undefined,
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center'
	    },
	    dropDownMenu: {
	      root: {
	        color: toolbar.color, // removes hover color change, we want to keep it
	        marginRight: baseTheme.spacing.desktopGutter,
	        flex: 1,
	        whiteSpace: 'nowrap'
	      },
	      controlBg: {
	        backgroundColor: toolbar.menuHoverColor,
	        borderRadius: 0
	      },
	      underline: {
	        display: 'none'
	      }
	    },
	    button: {
	      margin: marginVertical + 'px ' + marginHorizontal + 'px',
	      position: 'relative'
	    },
	    icon: {
	      root: {
	        cursor: 'pointer',
	        lineHeight: toolbar.height + 'px',
	        paddingLeft: baseTheme.spacing.desktopGutter
	      }
	    },
	    span: {
	      color: toolbar.iconColor,
	      lineHeight: toolbar.height + 'px'
	    }
	  };
	
	  return styles;
	}
	
	var ToolbarGroup = function (_Component) {
	  (0, _inherits3.default)(ToolbarGroup, _Component);
	
	  function ToolbarGroup() {
	    (0, _classCallCheck3.default)(this, ToolbarGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarGroup, [{
	    key: 'handleMouseLeaveFontIcon',
	    value: function handleMouseLeaveFontIcon(style) {
	      return function (event) {
	        event.target.style.zIndex = 'auto';
	        event.target.style.color = style.root.color;
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          firstChild = _props.firstChild,
	          lastChild = _props.lastChild,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (!currentChild) {
	          return null;
	        }
	        if (!currentChild.type) {
	          return currentChild;
	        }
	        switch (currentChild.type.muiName) {
	          case 'DropDownMenu':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
	              underlineStyle: styles.dropDownMenu.underline
	            });
	          case 'RaisedButton':
	          case 'FlatButton':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
	            });
	          case 'FontIcon':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
	              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
	              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
	            });
	          case 'ToolbarSeparator':
	          case 'ToolbarTitle':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
	            });
	          default:
	            return currentChild;
	        }
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        newChildren
	      );
	    }
	  }]);
	  return ToolbarGroup;
	}(_react.Component);
	
	ToolbarGroup.defaultProps = {
	  firstChild: false,
	  lastChild: false
	};
	ToolbarGroup.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ToolbarGroup.propTypes = {
	  /**
	   * Can be any node or number of nodes.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
	   * to prevent setting the left gap.
	   */
	  firstChild: _react.PropTypes.bool,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
	   * to prevent setting the right gap.
	   */
	  lastChild: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ToolbarGroup;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      backgroundColor: toolbar.separatorColor,
	      display: 'block',
	      height: baseTheme.spacing.desktopGutterMore,
	      marginLeft: baseTheme.spacing.desktopGutter,
	      width: 1
	    }
	  };
	}
	
	var ToolbarSeparator = function (_Component) {
	  (0, _inherits3.default)(ToolbarSeparator, _Component);
	
	  function ToolbarSeparator() {
	    (0, _classCallCheck3.default)(this, ToolbarSeparator);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	    }
	  }]);
	  return ToolbarSeparator;
	}(_react.Component);
	
	ToolbarSeparator.muiName = 'ToolbarSeparator';
	ToolbarSeparator.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ToolbarSeparator.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ToolbarSeparator;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      lineHeight: toolbar.height + 'px',
	      fontSize: toolbar.titleFontSize,
	      fontFamily: baseTheme.fontFamily,
	      position: 'relative',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    }
	  };
	}
	
	var ToolbarTitle = function (_Component) {
	  (0, _inherits3.default)(ToolbarTitle, _Component);
	
	  function ToolbarTitle() {
	    (0, _classCallCheck3.default)(this, ToolbarTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          text = _props.text,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style', 'text']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        text
	      );
	    }
	  }]);
	  return ToolbarTitle;
	}(_react.Component);
	
	ToolbarTitle.muiName = 'ToolbarTitle';
	ToolbarTitle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ToolbarTitle.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to be displayed.
	   */
	  text: _react.PropTypes.string
	} : void 0;
	exports.default = ToolbarTitle;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(1087);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  (0, _inherits3.default)(Overlay, _Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoLockScrolling = _props.autoLockScrolling,
	          show = _props.show,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	  return Overlay;
	}(_react.Component);
	
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Overlay.propTypes = {
	  autoLockScrolling: _react.PropTypes.bool,
	  show: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  transitionEnabled: _react.PropTypes.bool
	} : void 0;
	exports.default = Overlay;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(14);
	
	var _dom = __webpack_require__(379);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  (0, _inherits3.default)(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props,
	          open = _props.open,
	          render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RenderToLayer.propTypes = {
	  componentClickAway: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  render: _react.PropTypes.func.isRequired,
	  useLayerForClickAway: _react.PropTypes.bool
	} : void 0;
	exports.default = RenderToLayer;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      zIndex = _context$muiTheme.zIndex,
	      tooltip = _context$muiTheme.tooltip;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: 2,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: 0.9,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          horizontalPosition = _props.horizontalPosition,
	          label = _props.label,
	          show = _props.show,
	          touch = _props.touch,
	          verticalPosition = _props.verticalPosition,
	          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Tooltip.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  horizontalPosition: _react.PropTypes.oneOf(['left', 'right', 'center']),
	  label: _react.PropTypes.node.isRequired,
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  touch: _react.PropTypes.bool,
	  verticalPosition: _react.PropTypes.oneOf(['top', 'bottom'])
	} : void 0;
	exports.default = Tooltip;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(273);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsTransitionGroup = __webpack_require__(116);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _dom = __webpack_require__(379);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(1089);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none'
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TouchRipple.propTypes = {
	  abortOnScroll: _react.PropTypes.bool,
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TouchRipple;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(893);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(55);
	
	var _lightBaseTheme = __webpack_require__(1097);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(1099);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(1115);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(1116);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(1119);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(1694);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(1098);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var reserved = __webpack_require__(1700);
	var parse = __webpack_require__(1123).parse;
	
	
	/** Creates a new message compiler. Called internally from {@link MessageFormat#compile}.
	 *
	 * @class
	 * @param {MessageFormat} mf - A MessageFormat instance
	 * @property {object} locales - The locale identifiers that are used by the compiled functions
	 * @property {object} runtime - Names of the core runtime functions that are used by the compiled functions
	 * @property {object} formatters - The formatter functions that are used by the compiled functions 
	 */
	function Compiler(mf) {
	    this.mf = mf;
	    this.lc = null;
	    this.locales = {};
	    this.runtime = {};
	    this.formatters = {};
	}
	
	module.exports = Compiler;
	
	
	/** Utility function for quoting an Object's key value iff required
	 *
	 *  Quotes the key if it contains invalid characters or is an
	 *  ECMAScript 3rd Edition reserved word (for IE8).
	 */
	Compiler.propname = function(key, obj) {
	  if (/^[A-Z_$][0-9A-Z_$]*$/i.test(key) &&
	     ['break', 'continue', 'delete', 'else', 'for', 'function', 'if', 'in', 'new',
	      'return', 'this', 'typeof', 'var', 'void', 'while', 'with', 'case', 'catch',
	      'default', 'do', 'finally', 'instanceof', 'switch', 'throw', 'try'].indexOf(key) < 0) {
	    return obj ? obj + '.' + key : key;
	  } else {
	    var jkey = JSON.stringify(key);
	    return obj ? obj + '[' + jkey + ']' : jkey;
	  }
	}
	
	
	/** Utility function for escaping a function name iff required
	 */
	Compiler.funcname = function(key) {
	  var fn = key.trim().replace(/\W+/g, '_');
	  return reserved.check(fn, 'es2015', true) || /^\d/.test(fn) ? '_' + fn : fn;
	}
	
	
	/** Utility formatter function for enforcing Bidi Structured Text by using UCC
	 *
	 *  List inlined from data extracted from CLDR v27 & v28
	 *  To verify/recreate, use the following:
	 *
	 *     git clone https://github.com/unicode-cldr/cldr-misc-full.git
	 *     cd cldr-misc-full/main/
	 *     grep characterOrder -r . | tr '"/' '\t' | cut -f2,6 | grep -C4 right-to-left
	 */
	Compiler.bidiMarkText = function(text, locale) {
	  function isLocaleRTL(locale) {
	    var rtlLanguages = ['ar', 'ckb', 'fa', 'he', 'ks($|[^bfh])', 'lrc', 'mzn',
	                        'pa-Arab', 'ps', 'ug', 'ur', 'uz-Arab', 'yi'];
	    return new RegExp('^' + rtlLanguages.join('|^')).test(locale);
	  }
	  var mark = JSON.stringify(isLocaleRTL(locale) ? '\u200F' : '\u200E');
	  return mark + ' + ' + text + ' + ' + mark;
	}
	
	
	/** @private */
	Compiler.prototype.cases = function(token, plural) {
	  var needOther = true;
	  var r = token.cases.map(function(c) {
	    if (c.key === 'other') needOther = false;
	    var s = c.tokens.map(function(tok) { return this.token(tok, plural); }, this);
	    return Compiler.propname(c.key) + ': ' + (s.join(' + ') || '""');
	  }, this);
	  if (needOther) throw new Error("No 'other' form found in " + JSON.stringify(token));
	  return '{ ' + r.join(', ') + ' }';
	}
	
	
	/** @private */
	Compiler.prototype.token = function(token, plural) {
	  if (typeof token == 'string') return JSON.stringify(token);
	
	  var fn, args = [ Compiler.propname(token.arg, 'd') ];
	  switch (token.type) {
	    case 'argument':
	      return this.mf.bidiSupport ? Compiler.bidiMarkText(args[0], this.lc) : args[0];
	
	    case 'select':
	      fn = 'select';
	      args.push(this.cases(token, this.mf.strictNumberSign ? null : plural));
	      this.runtime.select = true;
	      break;
	
	    case 'selectordinal':
	      fn = 'plural';
	      args.push(0, Compiler.funcname(this.lc), this.cases(token, token), 1);
	      this.locales[this.lc] = true;
	      this.runtime.plural = true;
	      break;
	
	    case 'plural':
	      fn = 'plural';
	      args.push(token.offset || 0, Compiler.funcname(this.lc), this.cases(token, token));
	      this.locales[this.lc] = true;
	      this.runtime.plural = true;
	      break;
	
	    case 'function':
	      if (this.mf.intlSupport && !(token.key in this.mf.fmt) && (token.key in this.mf.constructor.formatters)) {
	        var fmt = this.mf.constructor.formatters[token.key];
	        this.mf.fmt[token.key] = (typeof fmt(this.mf) == 'function') ? fmt(this.mf) : fmt;
	      }
	      if (!this.mf.fmt[token.key]) throw new Error('Formatting function ' + JSON.stringify(token.key) + ' not found!');
	      args.push(JSON.stringify(this.lc));
	      if (token.params) switch (token.params.length) {
	          case 0:   break;
	          case 1:   args.push(JSON.stringify(token.params[0])); break;
	          default:  args.push(JSON.stringify(token.params)); break;
	      }
	      fn = Compiler.propname(token.key, 'fmt');
	      this.formatters[token.key] = true;
	      break;
	
	    case 'octothorpe':
	      if (!plural) return '"#"';
	      fn = 'number';
	      args = [ Compiler.propname(plural.arg, 'd'), JSON.stringify(plural.arg) ];
	      if (plural.offset) args.push(plural.offset);
	      this.runtime.number = true;
	      break;
	  }
	
	  if (!fn) throw new Error('Parser error for token ' + JSON.stringify(token));
	  return fn + '(' + args.join(', ') + ')';
	};
	
	
	/** Recursively compile a string or a tree of strings to JavaScript function sources
	 *
	 *  If `src` is an object with a key that is also present in `plurals`, the key
	 *  in question will be used as the locale identifier for its value. To disable
	 *  the compile-time checks for plural & selectordinal keys while maintaining
	 *  multi-locale support, use falsy values in `plurals`.
	 *
	 * @param {string|object} src - the source for which the JS code should be generated
	 * @param {string} lc - the default locale
	 * @param {object} plurals - a map of pluralization keys for all available locales
	 */
	Compiler.prototype.compile = function(src, lc, plurals) {
	  if (typeof src != 'object') {
	    this.lc = lc;
	    var pc = plurals[lc] || { cardinal: [], ordinal: [] };
	    var r = parse(src, pc).map(function(token) { return this.token(token); }, this);
	    return 'function(d) { return ' + (r.join(' + ') || '""') + '; }';
	  } else {
	    var result = {};
	    for (var key in src) {
	      var lcKey = plurals.hasOwnProperty(key) ? key : lc;
	      result[key] = this.compile(src[key], lcKey, plurals);
	    }
	    return result;
	  }
	}


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'MMMM [de] D [de] YYYY',
	            LLL : 'MMMM [de] D [de] YYYY h:mm A',
	            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka horan', 'ek hor'],
	            'hh': [number + ' horanim', number + ' horam'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 504 */
/***/ (function(module, exports) {

	'use strict';
	
	AssetService.$inject = ["$http", "$q", "customerService", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.asset', []).factory('assetService', AssetService).name;
	
	/*@ngInject*/
	
	function AssetService($http, $q, customerService, userService) {
	
	    var service = {
	        getAsset: getAsset,
	        getAssets: getAssets,
	        saveAsset: saveAsset,
	        deleteAsset: deleteAsset,
	        assignAssetToCustomer: assignAssetToCustomer,
	        unassignAssetFromCustomer: unassignAssetFromCustomer,
	        makeAssetPublic: makeAssetPublic,
	        getTenantAssets: getTenantAssets,
	        getCustomerAssets: getCustomerAssets,
	        findByQuery: findByQuery,
	        fetchAssetsByNameFilter: fetchAssetsByNameFilter,
	        getAssetTypes: getAssetTypes
	    };
	
	    return service;
	
	    function getAsset(assetId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/asset/' + assetId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getAssets(assetIds, config) {
	        var deferred = $q.defer();
	        var ids = '';
	        for (var i = 0; i < assetIds.length; i++) {
	            if (i > 0) {
	                ids += ',';
	            }
	            ids += assetIds[i];
	        }
	        var url = '/api/assets?assetIds=' + ids;
	        $http.get(url, config).then(function success(response) {
	            var assets = response.data;
	            assets.sort(function (asset1, asset2) {
	                var id1 = asset1.id.id;
	                var id2 = asset2.id.id;
	                var index1 = assetIds.indexOf(id1);
	                var index2 = assetIds.indexOf(id2);
	                return index1 - index2;
	            });
	            deferred.resolve(assets);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveAsset(asset, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/asset';
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.post(url, asset, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteAsset(assetId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/asset/' + assetId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.delete(url, config).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function assignAssetToCustomer(customerId, assetId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/asset/' + assetId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.post(url, null, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function unassignAssetFromCustomer(assetId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/customer/asset/' + assetId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.delete(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function makeAssetPublic(assetId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/customer/public/asset/' + assetId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.post(url, null, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getTenantAssets(pageLink, applyCustomersInfo, config, type) {
	        var deferred = $q.defer();
	        var url = '/api/tenant/assets?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        if (angular.isDefined(type) && type.length) {
	            url += '&type=' + type;
	        }
	        $http.get(url, config).then(function success(response) {
	            if (applyCustomersInfo) {
	                customerService.applyAssignedCustomersInfo(response.data.data).then(function success(data) {
	                    response.data.data = data;
	                    deferred.resolve(response.data);
	                }, function fail() {
	                    deferred.reject();
	                });
	            } else {
	                deferred.resolve(response.data);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getCustomerAssets(customerId, pageLink, applyCustomersInfo, config, type) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/assets?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        if (angular.isDefined(type) && type.length) {
	            url += '&type=' + type;
	        }
	        $http.get(url, config).then(function success(response) {
	            if (applyCustomersInfo) {
	                customerService.applyAssignedCustomerInfo(response.data.data, customerId).then(function success(data) {
	                    response.data.data = data;
	                    deferred.resolve(response.data);
	                }, function fail() {
	                    deferred.reject();
	                });
	            } else {
	                deferred.resolve(response.data);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	
	        return deferred.promise;
	    }
	
	    function findByQuery(query, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/assets';
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.post(url, query, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function fetchAssetsByNameFilter(assetNameFilter, limit, applyCustomersInfo, config) {
	        var deferred = $q.defer();
	        var user = userService.getCurrentUser();
	        var promise;
	        var pageLink = { limit: limit, textSearch: assetNameFilter };
	        if (user.authority === 'CUSTOMER_USER') {
	            var customerId = user.customerId;
	            promise = getCustomerAssets(customerId, pageLink, applyCustomersInfo, config);
	        } else {
	            promise = getTenantAssets(pageLink, applyCustomersInfo, config);
	        }
	        promise.then(function success(result) {
	            if (result.data && result.data.length > 0) {
	                deferred.resolve(result.data);
	            } else {
	                deferred.resolve(null);
	            }
	        }, function fail() {
	            deferred.resolve(null);
	        });
	        return deferred.promise;
	    }
	
	    function getAssetTypes(config) {
	        var deferred = $q.defer();
	        var url = '/api/asset/types';
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityViewService.$inject = ["$http", "$q", "$window", "userService", "attributeService", "customerService", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.api.entityView', [_types2.default]).factory('entityViewService', EntityViewService).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function EntityViewService($http, $q, $window, userService, attributeService, customerService, types) {
	
	    var service = {
	        assignEntityViewToCustomer: assignEntityViewToCustomer,
	        deleteEntityView: deleteEntityView,
	        getCustomerEntityViews: getCustomerEntityViews,
	        getEntityView: getEntityView,
	        getTenantEntityViews: getTenantEntityViews,
	        saveEntityView: saveEntityView,
	        unassignEntityViewFromCustomer: unassignEntityViewFromCustomer,
	        getEntityViewAttributes: getEntityViewAttributes,
	        subscribeForEntityViewAttributes: subscribeForEntityViewAttributes,
	        unsubscribeForEntityViewAttributes: unsubscribeForEntityViewAttributes,
	        findByQuery: findByQuery,
	        getEntityViewTypes: getEntityViewTypes
	    };
	
	    return service;
	
	    function getTenantEntityViews(pageLink, applyCustomersInfo, config, type) {
	        var deferred = $q.defer();
	        var url = '/api/tenant/entityViews?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        if (angular.isDefined(type) && type.length) {
	            url += '&type=' + type;
	        }
	        $http.get(url, config).then(function success(response) {
	            if (applyCustomersInfo) {
	                customerService.applyAssignedCustomersInfo(response.data.data).then(function success(data) {
	                    response.data.data = data;
	                    deferred.resolve(response.data);
	                }, function fail() {
	                    deferred.reject();
	                });
	            } else {
	                deferred.resolve(response.data);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getCustomerEntityViews(customerId, pageLink, applyCustomersInfo, config, type) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/entityViews?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        if (angular.isDefined(type) && type.length) {
	            url += '&type=' + type;
	        }
	        $http.get(url, config).then(function success(response) {
	            if (applyCustomersInfo) {
	                customerService.applyAssignedCustomerInfo(response.data.data, customerId).then(function success(data) {
	                    response.data.data = data;
	                    deferred.resolve(response.data);
	                }, function fail() {
	                    deferred.reject();
	                });
	            } else {
	                deferred.resolve(response.data);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	
	        return deferred.promise;
	    }
	
	    function getEntityView(entityViewId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/entityView/' + entityViewId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function saveEntityView(entityView) {
	        var deferred = $q.defer();
	        var url = '/api/entityView';
	
	        $http.post(url, entityView).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteEntityView(entityViewId) {
	        var deferred = $q.defer();
	        var url = '/api/entityView/' + entityViewId;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function assignEntityViewToCustomer(customerId, entityViewId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/' + customerId + '/entityView/' + entityViewId;
	        $http.post(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function unassignEntityViewFromCustomer(entityViewId) {
	        var deferred = $q.defer();
	        var url = '/api/customer/entityView/' + entityViewId;
	        $http.delete(url).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getEntityViewAttributes(entityViewId, attributeScope, query, successCallback, config) {
	        return attributeService.getEntityAttributes(types.entityType.entityView, entityViewId, attributeScope, query, successCallback, config);
	    }
	
	    function subscribeForEntityViewAttributes(entityViewId, attributeScope) {
	        return attributeService.subscribeForEntityAttributes(types.entityType.entityView, entityViewId, attributeScope);
	    }
	
	    function unsubscribeForEntityViewAttributes(subscriptionId) {
	        attributeService.unsubscribeForEntityAttributes(subscriptionId);
	    }
	
	    function findByQuery(query, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/entityViews';
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.post(url, query, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getEntityViewTypes(config) {
	        var deferred = $q.defer();
	        var url = '/api/entityView/types';
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	'use strict';
	
	ContactShort.$inject = ["$filter"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.filters.contactShort', []).filter('contactShort', ContactShort).name;
	
	/*@ngInject*/
	
	function ContactShort($filter) {
	    return function (contact) {
	        var contactShort = '';
	        if (contact) {
	            if (contact.address) {
	                contactShort += contact.address;
	                contactShort += ' ';
	            }
	            if (contact.address2) {
	                contactShort += contact.address2;
	                contactShort += ' ';
	            }
	            if (contact.city) {
	                contactShort += contact.city;
	                contactShort += ' ';
	            }
	            if (contact.state) {
	                contactShort += contact.state;
	                contactShort += ' ';
	            }
	            if (contact.zip) {
	                contactShort += contact.zip;
	                contactShort += ' ';
	            }
	            if (contact.country) {
	                contactShort += contact.country;
	            }
	        }
	        if (contactShort === '') {
	            contactShort = $filter('translate')('contact.no-address');
	        }
	        return contactShort;
	    };
	}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Contact.$inject = ["$compile", "$templateCache"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _contactTpl = __webpack_require__(1387);
	
	var _contactTpl2 = _interopRequireDefault(_contactTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.directives.contact', []).directive('tbContact', Contact).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function Contact($compile, $templateCache) {
	    var countries = ["Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, The Democratic Republic of the", "Cook Islands", "Costa Rica", "Côte d'Ivoire", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic of", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia, Republic Of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French Part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch Part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Viet Nam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"];
	
	    var postalCodePatterns = {
	        "United States": "(\\d{5}([\\-]\\d{4})?)",
	        "Australia": "[0-9]{4}",
	        "Austria": "[0-9]{4}",
	        "Belgium": "[0-9]{4}",
	        "Brazil": "[0-9]{5}[\\-]?[0-9]{3}",
	        "Canada": "[A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]",
	        "Denmark": "[0-9]{3,4}",
	        "Faroe Islands": "[0-9]{3,4}",
	        "Netherlands": "[1-9][0-9]{3}\\s?[a-zA-Z]{2}",
	        "Germany": "[0-9]{5}",
	        "Hungary": "[0-9]{4}",
	        "Italy": "[0-9]{5}",
	        "Japan": "\\d{3}-\\d{4}",
	        "Luxembourg": "(L\\s*(-|—|–))\\s*?[\\d]{4}",
	        "Poland": "[0-9]{2}\\-[0-9]{3}",
	        "Spain": "((0[1-9]|5[0-2])|[1-4][0-9])[0-9]{3}",
	        "Sweden": "\\d{3}\\s?\\d{2}",
	        "United Kingdom": "[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}"
	    };
	
	    var linker = function linker(scope, element) {
	
	        scope.countries = countries;
	
	        scope.postalCodePatterns = postalCodePatterns;
	
	        var template = $templateCache.get(_contactTpl2.default);
	
	        element.html(template);
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            contact: '=',
	            isEdit: '=',
	            theForm: '='
	        }
	    };
	}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DashboardController.$inject = ["$scope", "$rootScope", "$element", "$timeout", "$mdMedia", "$mdUtil", "$q", "timeService", "types", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(747);
	
	__webpack_require__(194);
	
	var _angularGridster = __webpack_require__(597);
	
	var _angularGridster2 = _interopRequireDefault(_angularGridster);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _widget = __webpack_require__(147);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	var _widget3 = __webpack_require__(1207);
	
	var _widget4 = _interopRequireDefault(_widget3);
	
	var _toast = __webpack_require__(75);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _timewindow = __webpack_require__(510);
	
	var _timewindow2 = _interopRequireDefault(_timewindow);
	
	var _tbEventDirectives = __webpack_require__(1199);
	
	var _tbEventDirectives2 = _interopRequireDefault(_tbEventDirectives);
	
	var _mousepointMenu = __webpack_require__(1192);
	
	var _mousepointMenu2 = _interopRequireDefault(_mousepointMenu);
	
	var _dashboardTpl = __webpack_require__(1391);
	
	var _dashboardTpl2 = _interopRequireDefault(_dashboardTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable angular/angularelement */
	
	exports.default = angular.module('thingsboard.directives.dashboard', [_types2.default, _toast2.default, _widget2.default, _widget4.default, _timewindow2.default, _tbEventDirectives2.default, _mousepointMenu2.default, _angularGridster2.default.name]).directive('tbDashboard', Dashboard).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function Dashboard() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            widgets: '=',
	            widgetLayouts: '=?',
	            aliasController: '=',
	            stateController: '=',
	            dashboardTimewindow: '=?',
	            columns: '=',
	            margins: '=',
	            isEdit: '=',
	            autofillHeight: '=',
	            mobileAutofillHeight: '=?',
	            mobileRowHeight: '=?',
	            isMobile: '=',
	            isMobileDisabled: '=?',
	            isEditActionEnabled: '=',
	            isExportActionEnabled: '=',
	            isRemoveActionEnabled: '=',
	            onEditWidget: '&?',
	            onExportWidget: '&?',
	            onRemoveWidget: '&?',
	            onWidgetMouseDown: '&?',
	            onWidgetClicked: '&?',
	            prepareDashboardContextMenu: '&?',
	            prepareWidgetContextMenu: '&?',
	            loadWidgets: '&?',
	            onInit: '&?',
	            onInitFailed: '&?',
	            dashboardStyle: '=?',
	            dashboardClass: '=?',
	            ignoreLoading: '=?'
	        },
	        controller: DashboardController,
	        controllerAs: 'vm',
	        templateUrl: _dashboardTpl2.default
	    };
	}
	
	/*@ngInject*/
	function DashboardController($scope, $rootScope, $element, $timeout, $mdMedia, $mdUtil, $q, timeService, types, utils) {
	
	    var highlightedMode = false;
	    var highlightedWidget = null;
	    var selectedWidget = null;
	
	    var gridsterParent = angular.element('#gridster-parent', $element);
	    var gridsterElement = angular.element('#gridster-child', gridsterParent);
	
	    var vm = this;
	
	    vm.gridster = null;
	
	    vm.isMobileDisabled = angular.isDefined(vm.isMobileDisabled) ? vm.isMobileDisabled : false;
	
	    vm.isMobileSize = false;
	
	    if (!('dashboardTimewindow' in vm)) {
	        vm.dashboardTimewindow = timeService.defaultTimewindow();
	    }
	
	    vm.dashboardLoading = true;
	    vm.visibleRect = {
	        top: 0,
	        bottom: 0,
	        left: 0,
	        right: 0
	    };
	    vm.gridsterOpts = {
	        pushing: false,
	        floating: false,
	        swapping: false,
	        maxRows: 100,
	        columns: vm.columns ? vm.columns : 24,
	        margins: vm.margins ? vm.margins : [10, 10],
	        minSizeX: 1,
	        minSizeY: 1,
	        defaultSizeX: 8,
	        defaultSizeY: 6,
	        resizable: {
	            enabled: vm.isEdit
	        },
	        draggable: {
	            enabled: vm.isEdit
	        },
	        saveGridItemCalculatedHeightInMobile: true
	    };
	
	    updateMobileOpts();
	
	    vm.widgetLayoutInfo = {};
	
	    vm.widgetIds = [];
	
	    vm.widgetItemMap = {
	        sizeX: 'vm.widgetLayoutInfo[widget.id].sizeX',
	        sizeY: 'vm.widgetLayoutInfo[widget.id].sizeY',
	        row: 'vm.widgetLayoutInfo[widget.id].row',
	        col: 'vm.widgetLayoutInfo[widget.id].col',
	        minSizeY: 'widget.minSizeY',
	        maxSizeY: 'widget.maxSizeY'
	    };
	
	    /*vm.widgetItemMap = {
	        sizeX: 'vm.widgetSizeX(widget)',
	        sizeY: 'vm.widgetSizeY(widget)',
	        row: 'vm.widgetRow(widget)',
	        col: 'vm.widgetCol(widget)',
	        minSizeY: 'widget.minSizeY',
	        maxSizeY: 'widget.maxSizeY'
	    };*/
	
	    vm.isWidgetExpanded = false;
	    vm.isHighlighted = isHighlighted;
	    vm.isNotHighlighted = isNotHighlighted;
	    vm.selectWidget = selectWidget;
	    vm.getSelectedWidget = getSelectedWidget;
	    vm.highlightWidget = highlightWidget;
	    vm.resetHighlight = resetHighlight;
	
	    vm.onWidgetFullscreenChanged = onWidgetFullscreenChanged;
	
	    vm.isAutofillHeight = autofillHeight;
	
	    vm.widgetMouseDown = widgetMouseDown;
	    vm.widgetClicked = widgetClicked;
	
	    vm.widgetSizeX = widgetSizeX;
	    vm.widgetSizeY = widgetSizeY;
	    vm.widgetRow = widgetRow;
	    vm.widgetCol = widgetCol;
	    vm.widgetStyle = widgetStyle;
	    vm.showWidgetTitle = showWidgetTitle;
	    vm.hasWidgetTitleTemplate = hasWidgetTitleTemplate;
	    vm.widgetTitleTemplate = widgetTitleTemplate;
	    vm.showWidgetTitlePanel = showWidgetTitlePanel;
	    vm.showWidgetActions = showWidgetActions;
	    vm.widgetTitleStyle = widgetTitleStyle;
	    vm.widgetTitle = widgetTitle;
	    vm.customWidgetHeaderActions = customWidgetHeaderActions;
	    vm.widgetActions = widgetActions;
	    vm.dropWidgetShadow = dropWidgetShadow;
	    vm.enableWidgetFullscreen = enableWidgetFullscreen;
	    vm.hasTimewindow = hasTimewindow;
	    vm.hasAggregation = hasAggregation;
	    vm.editWidget = editWidget;
	    vm.exportWidget = exportWidget;
	    vm.removeWidget = removeWidget;
	    vm.loading = loading;
	
	    vm.openDashboardContextMenu = openDashboardContextMenu;
	    vm.openWidgetContextMenu = openWidgetContextMenu;
	
	    vm.getEventGridPosition = getEventGridPosition;
	    vm.reload = reload;
	
	    vm.contextMenuItems = [];
	    vm.contextMenuEvent = null;
	
	    vm.widgetContextMenuItems = [];
	    vm.widgetContextMenuEvent = null;
	
	    vm.dashboardTimewindowApi = {
	        onResetTimewindow: function onResetTimewindow() {
	            $timeout(function () {
	                if (vm.originalDashboardTimewindow) {
	                    vm.dashboardTimewindow = angular.copy(vm.originalDashboardTimewindow);
	                    vm.originalDashboardTimewindow = null;
	                }
	            }, 0);
	        },
	        onUpdateTimewindow: function onUpdateTimewindow(startTimeMs, endTimeMs) {
	            if (!vm.originalDashboardTimewindow) {
	                vm.originalDashboardTimewindow = angular.copy(vm.dashboardTimewindow);
	            }
	            $timeout(function () {
	                vm.dashboardTimewindow = timeService.toHistoryTimewindow(vm.dashboardTimewindow, startTimeMs, endTimeMs);
	            }, 0);
	        }
	    };
	
	    addResizeListener(gridsterParent[0], onGridsterParentResize); // eslint-disable-line no-undef
	
	    $scope.$on("$destroy", function () {
	        removeResizeListener(gridsterParent[0], onGridsterParentResize); // eslint-disable-line no-undef
	    });
	
	    function onGridsterParentResize() {
	        if (gridsterParent.height() && autofillHeight()) {
	            updateMobileOpts();
	        }
	    }
	
	    //TODO: widgets visibility
	    /*gridsterParent.scroll(function () {
	        updateVisibleRect();
	    });
	     gridsterParent.resize(function () {
	        updateVisibleRect();
	    });*/
	
	    function updateMobileOpts() {
	        var isMobileDisabled = vm.isMobileDisabled === true;
	        var isMobile = vm.isMobile === true && !isMobileDisabled;
	        var mobileBreakPoint = isMobileDisabled ? 0 : isMobile ? 20000 : 960;
	
	        if (!isMobile && !isMobileDisabled) {
	            isMobile = !$mdMedia('gt-sm');
	        }
	
	        if (vm.gridsterOpts.isMobile != isMobile) {
	            vm.gridsterOpts.isMobile = isMobile;
	            vm.gridsterOpts.mobileModeEnabled = isMobile;
	        }
	        if (vm.gridsterOpts.mobileBreakPoint != mobileBreakPoint) {
	            vm.gridsterOpts.mobileBreakPoint = mobileBreakPoint;
	        }
	        detectRowSize(isMobile).then(function (rowHeight) {
	            if (vm.gridsterOpts.rowHeight != rowHeight) {
	                vm.gridsterOpts.rowHeight = rowHeight;
	            }
	        });
	        vm.isMobileSize = checkIsMobileSize();
	    }
	
	    function checkIsMobileSize() {
	        var isMobileDisabled = vm.isMobileDisabled === true;
	        var isMobileSize = vm.isMobile === true && !isMobileDisabled;
	        if (!isMobileSize && !isMobileDisabled) {
	            isMobileSize = !$mdMedia('gt-sm');
	        }
	        return isMobileSize;
	    }
	
	    $scope.$watch('vm.columns', function () {
	        var columns = vm.columns ? vm.columns : 24;
	        if (vm.gridsterOpts.columns != columns) {
	            vm.gridsterOpts.columns = columns;
	            if (vm.gridster) {
	                vm.gridster.columns = vm.columns;
	                updateGridsterParams();
	            }
	            //TODO: widgets visibility
	            //updateVisibleRect();
	        }
	    });
	
	    $scope.$watch(function () {
	        return $mdMedia('gt-sm') + ',' + vm.isMobile + ',' + vm.isMobileDisabled;
	    }, function () {
	        updateMobileOpts();
	        sortWidgets();
	    });
	
	    $scope.$watch(function () {
	        return vm.autofillHeight + ',' + vm.mobileAutofillHeight + ',' + vm.mobileRowHeight;
	    }, function () {
	        updateMobileOpts();
	    });
	
	    $scope.$watch('vm.margins', function () {
	        var margins = vm.margins ? vm.margins : [10, 10];
	        if (!angular.equals(vm.gridsterOpts.margins, margins)) {
	            vm.gridsterOpts.margins = margins;
	            updateMobileOpts();
	            if (vm.gridster) {
	                vm.gridster.margins = vm.margins;
	                updateGridsterParams();
	            }
	            //TODO: widgets visibility
	            //updateVisibleRect();
	        }
	    });
	
	    $scope.$watch('vm.isEdit', function () {
	        vm.gridsterOpts.resizable.enabled = vm.isEdit;
	        vm.gridsterOpts.draggable.enabled = vm.isEdit;
	        $scope.$broadcast('toggleDashboardEditMode', vm.isEdit);
	    });
	
	    $scope.$watch('vm.isMobileSize', function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal)) {
	            $scope.$broadcast('mobileModeChanged', vm.isMobileSize);
	        }
	    });
	
	    $scope.$watchCollection('vm.widgets', function () {
	        var ids = [];
	        for (var i = 0; i < vm.widgets.length; i++) {
	            var widget = vm.widgets[i];
	            if (!widget.id) {
	                widget.id = utils.guid();
	            }
	            ids.push(widget.id);
	        }
	        ids.sort(function (id1, id2) {
	            return id1.localeCompare(id2);
	        });
	        if (angular.equals(ids, vm.widgetIds)) {
	            return;
	        }
	        vm.widgetIds = ids;
	        for (i = 0; i < vm.widgets.length; i++) {
	            widget = vm.widgets[i];
	            var layoutInfoObject = vm.widgetLayoutInfo[widget.id];
	            if (!layoutInfoObject) {
	                layoutInfoObject = {
	                    widget: widget
	                };
	                Object.defineProperty(layoutInfoObject, 'sizeX', {
	                    get: function get() {
	                        return widgetSizeX(this.widget);
	                    },
	                    set: function set(newSizeX) {
	                        setWidgetSizeX(this.widget, newSizeX);
	                    }
	                });
	                Object.defineProperty(layoutInfoObject, 'sizeY', {
	                    get: function get() {
	                        return widgetSizeY(this.widget);
	                    },
	                    set: function set(newSizeY) {
	                        setWidgetSizeY(this.widget, newSizeY);
	                    }
	                });
	                Object.defineProperty(layoutInfoObject, 'row', {
	                    get: function get() {
	                        return widgetRow(this.widget);
	                    },
	                    set: function set(newRow) {
	                        setWidgetRow(this.widget, newRow);
	                    }
	                });
	                Object.defineProperty(layoutInfoObject, 'col', {
	                    get: function get() {
	                        return widgetCol(this.widget);
	                    },
	                    set: function set(newCol) {
	                        setWidgetCol(this.widget, newCol);
	                    }
	                });
	                vm.widgetLayoutInfo[widget.id] = layoutInfoObject;
	            }
	        }
	        for (var widgetId in vm.widgetLayoutInfo) {
	            if (ids.indexOf(widgetId) === -1) {
	                delete vm.widgetLayoutInfo[widgetId];
	            }
	        }
	        sortWidgets();
	        $mdUtil.nextTick(function () {
	            if (autofillHeight()) {
	                updateMobileOpts();
	            }
	        });
	    });
	
	    $scope.$watch('vm.widgetLayouts', function () {
	        updateMobileOpts();
	        sortWidgets();
	    });
	
	    $scope.$on('gridster-resized', function (event, sizes, theGridster) {
	        if (checkIsLocalGridsterElement(theGridster)) {
	            vm.gridster = theGridster;
	            setupGridster(vm.gridster);
	            vm.isResizing = false;
	            //TODO: widgets visibility
	            //updateVisibleRect(false, true);
	        }
	    });
	
	    $scope.$on('gridster-mobile-changed', function (event, theGridster) {
	        if (checkIsLocalGridsterElement(theGridster)) {
	            vm.gridster = theGridster;
	            setupGridster(vm.gridster);
	            detectRowSize(vm.gridster.isMobile).then(function (rowHeight) {
	                if (vm.gridsterOpts.rowHeight != rowHeight) {
	                    vm.gridsterOpts.rowHeight = rowHeight;
	                    updateGridsterParams();
	                }
	            });
	            vm.isMobileSize = checkIsMobileSize();
	
	            //TODO: widgets visibility
	            /*$timeout(function () {
	                updateVisibleRect(true);
	            }, 500, false);*/
	        }
	    });
	
	    function autofillHeight() {
	        if (vm.gridsterOpts.isMobile) {
	            return angular.isDefined(vm.mobileAutofillHeight) ? vm.mobileAutofillHeight : false;
	        } else {
	            return angular.isDefined(vm.autofillHeight) ? vm.autofillHeight : false;
	        }
	    }
	
	    function detectViewportHeight() {
	        var deferred = $q.defer();
	        var viewportHeight = gridsterParent.height();
	        if (viewportHeight) {
	            deferred.resolve(viewportHeight);
	        } else {
	            $scope.viewportHeightWatch = $scope.$watch(function () {
	                return gridsterParent.height();
	            }, function (viewportHeight) {
	                if (viewportHeight) {
	                    $scope.viewportHeightWatch();
	                    deferred.resolve(viewportHeight);
	                }
	            });
	        }
	        return deferred.promise;
	    }
	
	    function detectRowSize(isMobile) {
	        var deferred = $q.defer();
	        var rowHeight;
	        if (autofillHeight()) {
	            detectViewportHeight().then(function (viewportHeight) {
	                var totalRows = 0;
	                for (var i = 0; i < vm.widgets.length; i++) {
	                    var w = vm.widgets[i];
	                    var sizeY = widgetSizeY(w);
	                    if (isMobile) {
	                        totalRows += sizeY;
	                    } else {
	                        var row = widgetRow(w);
	                        var bottom = row + sizeY;
	                        totalRows = Math.max(totalRows, bottom);
	                    }
	                }
	                rowHeight = (viewportHeight - vm.gridsterOpts.margins[1] * (vm.widgets.length + 1) + vm.gridsterOpts.margins[0] * vm.widgets.length) / totalRows;
	                deferred.resolve(rowHeight);
	            });
	        } else if (isMobile) {
	            rowHeight = angular.isDefined(vm.mobileRowHeight) ? vm.mobileRowHeight : 70;
	            deferred.resolve(rowHeight);
	        } else {
	            rowHeight = 'match';
	            deferred.resolve(rowHeight);
	        }
	        return deferred.promise;
	    }
	
	    function widgetOrder(widget) {
	        var order;
	        var hasLayout = vm.widgetLayouts && vm.widgetLayouts[widget.id];
	        if (hasLayout && angular.isDefined(vm.widgetLayouts[widget.id].mobileOrder) && vm.widgetLayouts[widget.id].mobileOrder >= 0) {
	            order = vm.widgetLayouts[widget.id].mobileOrder;
	        } else if (angular.isDefined(widget.config.mobileOrder) && widget.config.mobileOrder >= 0) {
	            order = widget.config.mobileOrder;
	        } else if (hasLayout) {
	            order = vm.widgetLayouts[widget.id].row;
	        } else {
	            order = widget.row;
	        }
	        return order;
	    }
	
	    $scope.$on('widgetPositionChanged', function () {
	        sortWidgets();
	    });
	
	    loadDashboard();
	
	    function sortWidgets() {
	        vm.widgets.sort(function (widget1, widget2) {
	            var row1 = widgetOrder(widget1);
	            var row2 = widgetOrder(widget2);
	            var res = row1 - row2;
	            if (res === 0) {
	                res = widgetCol(widget1) - widgetCol(widget2);
	            }
	            return res;
	        });
	    }
	
	    function reload() {
	        loadDashboard();
	    }
	
	    function loadDashboard() {
	        $timeout(function () {
	            if (vm.loadWidgets) {
	                var promise = vm.loadWidgets();
	                if (promise) {
	                    promise.then(function () {
	                        dashboardLoaded();
	                    }, function () {
	                        dashboardLoaded();
	                    });
	                } else {
	                    dashboardLoaded();
	                }
	            } else {
	                dashboardLoaded();
	            }
	        }, 0, false);
	    }
	
	    function updateGridsterParams() {
	        if (vm.gridster) {
	            if (vm.gridster.colWidth === 'auto') {
	                vm.gridster.curColWidth = (vm.gridster.curWidth + (vm.gridster.outerMargin ? -vm.gridster.margins[1] : vm.gridster.margins[1])) / vm.gridster.columns;
	            } else {
	                vm.gridster.curColWidth = vm.gridster.colWidth;
	            }
	            vm.gridster.curRowHeight = vm.gridster.rowHeight;
	            if (angular.isString(vm.gridster.rowHeight)) {
	                if (vm.gridster.rowHeight === 'match') {
	                    vm.gridster.curRowHeight = Math.round(vm.gridster.curColWidth);
	                } else if (vm.gridster.rowHeight.indexOf('*') !== -1) {
	                    vm.gridster.curRowHeight = Math.round(vm.gridster.curColWidth * vm.gridster.rowHeight.replace('*', '').replace(' ', ''));
	                } else if (vm.gridster.rowHeight.indexOf('/') !== -1) {
	                    vm.gridster.curRowHeight = Math.round(vm.gridster.curColWidth / vm.gridster.rowHeight.replace('/', '').replace(' ', ''));
	                }
	            }
	        }
	    }
	
	    //TODO: widgets visibility
	    /*function updateVisibleRect (force, containerResized) {
	        if (vm.gridster) {
	            var position = $(vm.gridster.$element).position()
	            if (position) {
	                var viewportWidth = gridsterParent.width();
	                var viewportHeight = gridsterParent.height();
	                var top = -position.top;
	                var bottom = top + viewportHeight;
	                var left = -position.left;
	                var right = left + viewportWidth;
	                 var newVisibleRect = {
	                    top: vm.gridster.pixelsToRows(top),
	                    topPx: top,
	                    bottom: vm.gridster.pixelsToRows(bottom),
	                    bottomPx: bottom,
	                    left: vm.gridster.pixelsToColumns(left),
	                    right: vm.gridster.pixelsToColumns(right),
	                    isMobile: vm.gridster.isMobile,
	                    curRowHeight: vm.gridster.curRowHeight,
	                    containerResized: containerResized
	                };
	                 if (force ||
	                    newVisibleRect.top != vm.visibleRect.top ||
	                    newVisibleRect.topPx != vm.visibleRect.topPx ||
	                    newVisibleRect.bottom != vm.visibleRect.bottom ||
	                    newVisibleRect.bottomPx != vm.visibleRect.bottomPx ||
	                    newVisibleRect.left != vm.visibleRect.left ||
	                    newVisibleRect.right != vm.visibleRect.right ||
	                    newVisibleRect.isMobile != vm.visibleRect.isMobile ||
	                    newVisibleRect.curRowHeight != vm.visibleRect.curRowHeight ||
	                    newVisibleRect.containerResized != vm.visibleRect.containerResized) {
	                    vm.visibleRect = newVisibleRect;
	                    $scope.$broadcast('visibleRectChanged', vm.visibleRect);
	                }
	            }
	        }
	    }*/
	
	    function checkIsLocalGridsterElement(gridster) {
	        return gridsterElement && gridsterElement[0] === gridster.$element[0];
	    }
	
	    function onWidgetFullscreenChanged(expanded, widget) {
	        vm.isWidgetExpanded = expanded;
	        $scope.$broadcast('onWidgetFullscreenChanged', vm.isWidgetExpanded, widget);
	    }
	
	    function widgetMouseDown($event, widget) {
	        if (vm.onWidgetMouseDown) {
	            vm.onWidgetMouseDown({ event: $event, widget: widget });
	        }
	    }
	
	    function widgetClicked($event, widget) {
	        if (vm.onWidgetClicked) {
	            vm.onWidgetClicked({ event: $event, widget: widget });
	        }
	    }
	
	    function openDashboardContextMenu($event, $mdOpenMousepointMenu) {
	        if (vm.prepareDashboardContextMenu) {
	            vm.contextMenuItems = vm.prepareDashboardContextMenu();
	            if (vm.contextMenuItems && vm.contextMenuItems.length > 0) {
	                vm.contextMenuEvent = $event;
	                $mdOpenMousepointMenu($event);
	            }
	        }
	    }
	
	    function openWidgetContextMenu($event, widget, $mdOpenMousepointMenu) {
	        if (vm.prepareWidgetContextMenu) {
	            vm.widgetContextMenuItems = vm.prepareWidgetContextMenu({ widget: widget });
	            if (vm.widgetContextMenuItems && vm.widgetContextMenuItems.length > 0) {
	                vm.widgetContextMenuEvent = $event;
	                $mdOpenMousepointMenu($event);
	            }
	        }
	    }
	
	    function getEventGridPosition(event) {
	        var pos = {
	            row: 0,
	            column: 0
	        };
	        if (!gridsterParent) {
	            return pos;
	        }
	        var offset = gridsterParent.offset();
	        var x = event.pageX - offset.left + gridsterParent.scrollLeft();
	        var y = event.pageY - offset.top + gridsterParent.scrollTop();
	        if (vm.gridster) {
	            pos.row = vm.gridster.pixelsToRows(y);
	            pos.column = vm.gridster.pixelsToColumns(x);
	        }
	        return pos;
	    }
	
	    function editWidget($event, widget) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.isEditActionEnabled && vm.onEditWidget) {
	            vm.onEditWidget({ event: $event, widget: widget });
	        }
	    }
	
	    function exportWidget($event, widget) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.isExportActionEnabled && vm.onExportWidget) {
	            vm.onExportWidget({ event: $event, widget: widget });
	        }
	    }
	
	    function removeWidget($event, widget) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.isRemoveActionEnabled && vm.onRemoveWidget) {
	            vm.onRemoveWidget({ event: $event, widget: widget });
	        }
	    }
	
	    function highlightWidget(widget, delay) {
	        if (!highlightedMode || highlightedWidget != widget) {
	            highlightedMode = true;
	            highlightedWidget = widget;
	            scrollToWidget(widget, delay);
	        }
	    }
	
	    function selectWidget(widget, delay) {
	        if (selectedWidget != widget) {
	            selectedWidget = widget;
	            scrollToWidget(widget, delay);
	        }
	    }
	
	    function scrollToWidget(widget, delay) {
	        if (vm.gridster) {
	            var item = angular.element('.gridster-item', vm.gridster.$element)[vm.widgets.indexOf(widget)];
	            if (item) {
	                var height = angular.element(item).outerHeight(true);
	                var rectHeight = gridsterParent.height();
	                var offset = (rectHeight - height) / 2;
	                var scrollTop = item.offsetTop;
	                if (offset > 0) {
	                    scrollTop -= offset;
	                }
	                gridsterParent.animate({
	                    scrollTop: scrollTop
	                }, delay);
	            }
	        }
	    }
	
	    function getSelectedWidget() {
	        return selectedWidget;
	    }
	
	    function resetHighlight() {
	        highlightedMode = false;
	        highlightedWidget = null;
	        selectedWidget = null;
	    }
	
	    function isHighlighted(widget) {
	        return highlightedMode && highlightedWidget === widget || selectedWidget === widget;
	    }
	
	    function isNotHighlighted(widget) {
	        return highlightedMode && highlightedWidget != widget;
	    }
	
	    function widgetSizeX(widget) {
	        if (vm.widgetLayouts && vm.widgetLayouts[widget.id]) {
	            return vm.widgetLayouts[widget.id].sizeX;
	        } else {
	            return widget.sizeX;
	        }
	    }
	
	    function setWidgetSizeX(widget, sizeX) {
	        if (!vm.gridsterOpts.isMobile) {
	            if (vm.widgetLayouts && vm.widgetLayouts[widget.id]) {
	                vm.widgetLayouts[widget.id].sizeX = sizeX;
	            } else {
	                widget.sizeX = sizeX;
	            }
	        }
	    }
	
	    function widgetSizeY(widget) {
	        if (vm.gridsterOpts.isMobile && !vm.mobileAutofillHeight) {
	            var mobileHeight;
	            if (vm.widgetLayouts && vm.widgetLayouts[widget.id]) {
	                mobileHeight = vm.widgetLayouts[widget.id].mobileHeight;
	            }
	            if (!mobileHeight && widget.config.mobileHeight) {
	                mobileHeight = widget.config.mobileHeight;
	            }
	            if (mobileHeight) {
	                return mobileHeight;
	            } else {
	                return widget.sizeY * 24 / vm.gridsterOpts.columns;
	            }
	        } else {
	            if (vm.widgetLayouts && vm.widgetLayouts[widget.id]) {
	                return vm.widgetLayouts[widget.id].sizeY;
	            } else {
	                return widget.sizeY;
	            }
	        }
	    }
	
	    function setWidgetSizeY(widget, sizeY) {
	        if (!vm.gridsterOpts.isMobile && !vm.autofillHeight) {
	            if (vm.widgetLayouts && vm.widgetLayouts[widget.id]) {
	                vm.widgetLayouts[widget.id].sizeY = sizeY;
	            } else {
	                widget.sizeY = sizeY;
	            }
	        }
	    }
	
	    function widgetRow(widget) {
	        if (vm.widgetLayouts && vm.widgetLayouts[widget.id]) {
	            return vm.widgetLayouts[widget.id].row;
	        } else {
	            return widget.row;
	        }
	    }
	
	    function setWidgetRow(widget, row) {
	        if (!vm.gridsterOpts.isMobile) {
	            if (vm.widgetLayouts && vm.widgetLayouts[widget.id]) {
	                vm.widgetLayouts[widget.id].row = row;
	            } else {
	                widget.row = row;
	            }
	        }
	    }
	
	    function widgetCol(widget) {
	        if (vm.widgetLayouts && vm.widgetLayouts[widget.id]) {
	            return vm.widgetLayouts[widget.id].col;
	        } else {
	            return widget.col;
	        }
	    }
	
	    function setWidgetCol(widget, col) {
	        if (!vm.gridsterOpts.isMobile) {
	            if (vm.widgetLayouts && vm.widgetLayouts[widget.id]) {
	                vm.widgetLayouts[widget.id].col = col;
	            } else {
	                widget.col = col;
	            }
	        }
	    }
	
	    function widgetStyle(widget) {
	        var style = { cursor: 'pointer',
	            color: widgetColor(widget),
	            backgroundColor: widgetBackgroundColor(widget),
	            padding: widgetPadding(widget),
	            margin: widgetMargin(widget) };
	        if (angular.isDefined(widget.config.widgetStyle)) {
	            Object.assign(style, widget.config.widgetStyle);
	        }
	        return style;
	    }
	
	    function widgetColor(widget) {
	        if (widget.config.color) {
	            return widget.config.color;
	        } else {
	            return 'rgba(0, 0, 0, 0.87)';
	        }
	    }
	
	    function widgetBackgroundColor(widget) {
	        if (widget.config.backgroundColor) {
	            return widget.config.backgroundColor;
	        } else {
	            return '#fff';
	        }
	    }
	
	    function widgetPadding(widget) {
	        if (widget.config.padding) {
	            return widget.config.padding;
	        } else {
	            return '8px';
	        }
	    }
	
	    function widgetMargin(widget) {
	        if (widget.config.margin) {
	            return widget.config.margin;
	        } else {
	            return '0px';
	        }
	    }
	
	    function showWidgetTitle(widget) {
	        if (angular.isDefined(widget.config.showTitle)) {
	            return widget.config.showTitle;
	        } else {
	            return true;
	        }
	    }
	
	    function hasWidgetTitleTemplate(widget) {
	        var ctx = widgetContext(widget);
	        if (ctx && ctx.widgetTitleTemplate) {
	            return true;
	        } else {
	            return false;
	        }
	    }
	
	    function widgetTitleTemplate(widget) {
	        var ctx = widgetContext(widget);
	        if (ctx && ctx.widgetTitleTemplate) {
	            return ctx.widgetTitleTemplate;
	        } else {
	            return '';
	        }
	    }
	
	    function showWidgetTitlePanel(widget) {
	        var ctx = widgetContext(widget);
	        if (ctx && ctx.hideTitlePanel) {
	            return false;
	        } else {
	            return hasWidgetTitleTemplate(widget) || showWidgetTitle(widget) || hasTimewindow(widget);
	        }
	    }
	
	    function showWidgetActions(widget) {
	        var ctx = widgetContext(widget);
	        if (ctx && ctx.hideTitlePanel) {
	            return false;
	        } else {
	            return true;
	        }
	    }
	
	    function widgetTitleStyle(widget) {
	        if (angular.isDefined(widget.config.titleStyle)) {
	            return widget.config.titleStyle;
	        } else {
	            return {};
	        }
	    }
	
	    function widgetTitle(widget) {
	        var ctx = widgetContext(widget);
	        if (ctx && ctx.widgetTitle && ctx.widgetTitle.length) {
	            return ctx.widgetTitle;
	        } else {
	            return widget.config.title;
	        }
	    }
	
	    function customWidgetHeaderActions(widget) {
	        var ctx = widgetContext(widget);
	        if (ctx && ctx.customHeaderActions && ctx.customHeaderActions.length) {
	            return ctx.customHeaderActions;
	        } else {
	            return [];
	        }
	    }
	
	    function widgetActions(widget) {
	        var ctx = widgetContext(widget);
	        if (ctx && ctx.widgetActions && ctx.widgetActions.length) {
	            return ctx.widgetActions;
	        } else {
	            return [];
	        }
	    }
	
	    function widgetContext(widget) {
	        var context;
	        if (widget.$ctx) {
	            context = widget.$ctx();
	        }
	        return context;
	    }
	
	    function dropWidgetShadow(widget) {
	        if (angular.isDefined(widget.config.dropShadow)) {
	            return widget.config.dropShadow;
	        } else {
	            return true;
	        }
	    }
	
	    function enableWidgetFullscreen(widget) {
	        if (angular.isDefined(widget.config.enableFullscreen)) {
	            return widget.config.enableFullscreen;
	        } else {
	            return true;
	        }
	    }
	
	    function hasTimewindow(widget) {
	        if (widget.type === types.widgetType.timeseries.value || widget.type === types.widgetType.alarm.value) {
	            return angular.isDefined(widget.config.useDashboardTimewindow) ? !widget.config.useDashboardTimewindow : false;
	        } else {
	            return false;
	        }
	    }
	
	    function hasAggregation(widget) {
	        return widget.type === types.widgetType.timeseries.value;
	    }
	
	    function adoptMaxRows() {
	        if (vm.widgets) {
	            var maxRows = vm.gridsterOpts.maxRows;
	            for (var i = 0; i < vm.widgets.length; i++) {
	                var w = vm.widgets[i];
	                var bottom = widgetRow(w) + widgetSizeY(w);
	                maxRows = Math.max(maxRows, bottom);
	            }
	            vm.gridsterOpts.maxRows = Math.max(maxRows, vm.gridsterOpts.maxRows);
	        }
	    }
	
	    function dashboardLoaded() {
	        $mdUtil.nextTick(function () {
	            if (vm.dashboardTimewindowWatch) {
	                vm.dashboardTimewindowWatch();
	                vm.dashboardTimewindowWatch = null;
	            }
	            vm.dashboardTimewindowWatch = $scope.$watch('vm.dashboardTimewindow', function () {
	                $scope.$broadcast('dashboardTimewindowChanged', vm.dashboardTimewindow);
	            }, true);
	            adoptMaxRows();
	            vm.dashboardLoading = false;
	            if ($scope.gridsterScopeWatcher) {
	                $scope.gridsterScopeWatcher();
	            }
	            $scope.gridsterScopeWatcher = $scope.$watch(function () {
	                var hasScope = gridsterElement.scope() ? true : false;
	                return hasScope;
	            }, function (hasScope) {
	                if (hasScope) {
	                    $scope.gridsterScopeWatcher();
	                    $scope.gridsterScopeWatcher = null;
	                    var gridsterScope = gridsterElement.scope();
	                    vm.gridster = gridsterScope.gridster;
	                    setupGridster(vm.gridster);
	                    if (vm.onInit) {
	                        vm.onInit({ dashboard: vm });
	                    }
	                }
	            });
	        });
	    }
	
	    function setupGridster(gridster) {
	        if (gridster) {
	            if (!gridster.origMoveOverlappingItems) {
	                gridster.origMoveOverlappingItems = gridster.moveOverlappingItems;
	                gridster.moveOverlappingItems = function () {};
	            }
	        }
	    }
	
	    function loading() {
	        return !vm.ignoreLoading && $rootScope.loading;
	    }
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DetailsSidenav.$inject = ["$timeout", "$mdUtil", "$q", "$animate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(753);
	
	var _detailsSidenavTpl = __webpack_require__(1397);
	
	var _detailsSidenavTpl2 = _interopRequireDefault(_detailsSidenavTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.detailsSidenav', []).directive('tbDetailsSidenav', DetailsSidenav).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function DetailsSidenav($timeout, $mdUtil, $q, $animate) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        if (angular.isUndefined(attrs.isReadOnly)) {
	            attrs.isReadOnly = false;
	        }
	
	        if (angular.isUndefined(scope.headerHeightPx)) {
	            scope.headerHeightPx = 100;
	        }
	
	        if (angular.isDefined(attrs.isAlwaysEdit) && attrs.isAlwaysEdit) {
	            scope.isEdit = true;
	        }
	
	        var backdrop;
	        var previousContainerStyles;
	
	        if (attrs.hasOwnProperty('tbEnableBackdrop')) {
	            backdrop = $mdUtil.createBackdrop(scope, "md-sidenav-backdrop md-opaque ng-enter");
	            element.on('$destroy', function () {
	                backdrop && backdrop.remove();
	            });
	            scope.$on('$destroy', function () {
	                backdrop && backdrop.remove();
	            });
	            scope.$watch('isOpen', updateIsOpen);
	        }
	
	        function updateIsOpen(isOpen) {
	            backdrop[isOpen ? 'on' : 'off']('click', function (ev) {
	                ev.preventDefault();
	                scope.isOpen = false;
	                scope.$apply();
	            });
	            var parent = element.parent();
	            var restorePositioning = updateContainerPositions(parent, isOpen);
	
	            return $q.all([isOpen && backdrop ? $animate.enter(backdrop, parent) : backdrop ? $animate.leave(backdrop) : $q.when(true)]).then(function () {
	                restorePositioning && restorePositioning();
	            });
	        }
	
	        function updateContainerPositions(parent, willOpen) {
	            var drawerEl = element[0];
	            var scrollTop = parent[0].scrollTop;
	            if (willOpen && scrollTop) {
	                previousContainerStyles = {
	                    top: drawerEl.style.top,
	                    bottom: drawerEl.style.bottom,
	                    height: drawerEl.style.height
	                };
	                var positionStyle = {
	                    top: scrollTop + 'px',
	                    bottom: 'auto',
	                    height: parent[0].clientHeight + 'px'
	                };
	                backdrop.css(positionStyle);
	            }
	            if (!willOpen && previousContainerStyles) {
	                return function () {
	                    backdrop[0].style.top = null;
	                    backdrop[0].style.bottom = null;
	                    backdrop[0].style.height = null;
	                    previousContainerStyles = null;
	                };
	            }
	        }
	
	        scope.toggleDetailsEditMode = function () {
	            if (!scope.isAlwaysEdit) {
	                if (!scope.isEdit) {
	                    scope.isEdit = true;
	                } else {
	                    scope.isEdit = false;
	                }
	            }
	            $timeout(function () {
	                scope.onToggleDetailsEditMode();
	            });
	        };
	
	        scope.detailsApply = function () {
	            $timeout(function () {
	                scope.onApplyDetails();
	            });
	        };
	
	        scope.closeDetails = function () {
	            scope.isOpen = false;
	            $timeout(function () {
	                scope.onCloseDetails();
	            });
	        };
	    };
	
	    return {
	        restrict: "E",
	        transclude: {
	            headerPane: '?headerPane',
	            detailsButtons: '?detailsButtons'
	        },
	        scope: {
	            headerTitle: '@',
	            headerSubtitle: '@',
	            headerHeightPx: '@',
	            isReadOnly: '=',
	            isOpen: '=',
	            isEdit: '=?',
	            isAlwaysEdit: '=?',
	            theForm: '=',
	            onCloseDetails: '&',
	            onToggleDetailsEditMode: '&',
	            onApplyDetails: '&'
	        },
	        link: linker,
	        templateUrl: _detailsSidenavTpl2.default
	    };
	}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Timewindow.$inject = ["$compile", "$templateCache", "$filter", "$mdPanel", "$document", "$mdMedia", "$translate", "timeService"];
	MillisecondsToTimeString.$inject = ["$translate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(774);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _timeinterval = __webpack_require__(1200);
	
	var _timeinterval2 = _interopRequireDefault(_timeinterval);
	
	var _datetimePeriod = __webpack_require__(1177);
	
	var _datetimePeriod2 = _interopRequireDefault(_datetimePeriod);
	
	var _timewindowButtonTpl = __webpack_require__(1416);
	
	var _timewindowButtonTpl2 = _interopRequireDefault(_timewindowButtonTpl);
	
	var _timewindowTpl = __webpack_require__(1418);
	
	var _timewindowTpl2 = _interopRequireDefault(_timewindowTpl);
	
	var _timewindowPanelTpl = __webpack_require__(1417);
	
	var _timewindowPanelTpl2 = _interopRequireDefault(_timewindowPanelTpl);
	
	var _timewindowPanel = __webpack_require__(1201);
	
	var _timewindowPanel2 = _interopRequireDefault(_timewindowPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.timewindow', [_timeinterval2.default, _datetimePeriod2.default]).controller('TimewindowPanelController', _timewindowPanel2.default).directive('tbTimewindow', Timewindow).filter('milliSecondsToTimeString', MillisecondsToTimeString).name;
	
	/* eslint-disable angular/angularelement */
	/*@ngInject*/
	
	
	/* eslint-enable import/no-unresolved, import/default */
	
	function Timewindow($compile, $templateCache, $filter, $mdPanel, $document, $mdMedia, $translate, timeService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        /* tbTimewindow (ng-model)
	         * {
	         * 	  realtime: {
	         * 	        interval: 0,
	         * 			timewindowMs: 0
	         * 	  },
	         * 	  history: {
	         * 	        interval: 0,
	         * 			timewindowMs: 0,
	         * 			fixedTimewindow: {
	         * 				startTimeMs: 0,
	         * 				endTimeMs: 0
	         * 			}
	         * 	  },
	         * 	  aggregation: {
	         * 	        type: types.aggregation.avg.value,
	         * 	        limit: 200
	         * 	  }
	         * }
	         */
	
	        scope.historyOnly = angular.isDefined(attrs.historyOnly);
	
	        scope.aggregation = scope.$eval(attrs.aggregation);
	
	        scope.isToolbar = angular.isDefined(attrs.isToolbar);
	
	        scope.hideLabel = function () {
	            return scope.isToolbar && !$mdMedia('gt-md');
	        };
	
	        var translationPending = false;
	
	        $translate.onReady(function () {
	            if (translationPending) {
	                scope.updateDisplayValue();
	                translationPending = false;
	            }
	        });
	
	        var template;
	        if (scope.asButton) {
	            template = $templateCache.get(_timewindowButtonTpl2.default);
	        } else {
	            scope.direction = angular.isDefined(attrs.direction) ? attrs.direction : 'left';
	            scope.tooltipDirection = angular.isDefined(attrs.tooltipDirection) ? attrs.tooltipDirection : 'top';
	            template = $templateCache.get(_timewindowTpl2.default);
	        }
	        element.html(template);
	
	        scope.openEditMode = function (event) {
	            if (scope.disabled) {
	                return;
	            }
	            var position;
	            var isGtSm = $mdMedia('gt-sm');
	            if (isGtSm) {
	                var panelHeight = 375;
	                var panelWidth = 417;
	                var offset = element[0].getBoundingClientRect();
	                var bottomY = offset.bottom - (0, _jquery2.default)(window).scrollTop(); //eslint-disable-line
	                var leftX = offset.left - (0, _jquery2.default)(window).scrollLeft(); //eslint-disable-line
	                var yPosition;
	                var xPosition;
	                if (bottomY + panelHeight > (0, _jquery2.default)(window).height()) {
	                    //eslint-disable-line
	                    yPosition = $mdPanel.yPosition.ABOVE;
	                } else {
	                    yPosition = $mdPanel.yPosition.BELOW;
	                }
	                if (leftX + panelWidth > (0, _jquery2.default)(window).width()) {
	                    //eslint-disable-line
	                    xPosition = $mdPanel.xPosition.ALIGN_END;
	                } else {
	                    xPosition = $mdPanel.xPosition.ALIGN_START;
	                }
	                position = $mdPanel.newPanelPosition().relativeTo(element).addPanelPosition(xPosition, yPosition);
	            } else {
	                position = $mdPanel.newPanelPosition().absolute().top('0%').left('0%');
	            }
	            var config = {
	                attachTo: angular.element($document[0].body),
	                controller: 'TimewindowPanelController',
	                controllerAs: 'vm',
	                templateUrl: _timewindowPanelTpl2.default,
	                panelClass: 'tb-timewindow-panel',
	                position: position,
	                fullscreen: !isGtSm,
	                locals: {
	                    'timewindow': angular.copy(scope.model),
	                    'historyOnly': scope.historyOnly,
	                    'aggregation': scope.aggregation,
	                    'onTimewindowUpdate': function onTimewindowUpdate(timewindow) {
	                        scope.model = timewindow;
	                        scope.updateView();
	                    }
	                },
	                openFrom: event,
	                clickOutsideToClose: true,
	                escapeToClose: true,
	                focusOnOpen: false
	            };
	            $mdPanel.open(config);
	        };
	
	        scope.updateView = function () {
	            var value = {};
	            var model = scope.model;
	            if (model.selectedTab === 0) {
	                value.realtime = {
	                    interval: model.realtime.interval,
	                    timewindowMs: model.realtime.timewindowMs
	                };
	            } else {
	                if (model.history.historyType === 0) {
	                    value.history = {
	                        interval: model.history.interval,
	                        timewindowMs: model.history.timewindowMs
	                    };
	                } else {
	                    value.history = {
	                        interval: model.history.interval,
	                        fixedTimewindow: {
	                            startTimeMs: model.history.fixedTimewindow.startTimeMs,
	                            endTimeMs: model.history.fixedTimewindow.endTimeMs
	                        }
	                    };
	                }
	            }
	            value.aggregation = {
	                type: model.aggregation.type,
	                limit: model.aggregation.limit
	            };
	            ngModelCtrl.$setViewValue(value);
	            scope.updateDisplayValue();
	        };
	
	        scope.updateDisplayValue = function () {
	            if ($translate.isReady()) {
	                if (scope.model.selectedTab === 0 && !scope.historyOnly) {
	                    scope.model.displayValue = $translate.instant('timewindow.realtime') + ' - ' + $translate.instant('timewindow.last-prefix') + ' ' + $filter('milliSecondsToTimeString')(scope.model.realtime.timewindowMs);
	                } else {
	                    scope.model.displayValue = !scope.historyOnly ? $translate.instant('timewindow.history') + ' - ' : '';
	                    if (scope.model.history.historyType === 0) {
	                        scope.model.displayValue += $translate.instant('timewindow.last-prefix') + ' ' + $filter('milliSecondsToTimeString')(scope.model.history.timewindowMs);
	                    } else {
	                        var startString = $filter('date')(scope.model.history.fixedTimewindow.startTimeMs, 'yyyy-MM-dd HH:mm:ss');
	                        var endString = $filter('date')(scope.model.history.fixedTimewindow.endTimeMs, 'yyyy-MM-dd HH:mm:ss');
	                        scope.model.displayValue += $translate.instant('timewindow.period', { startTime: startString, endTime: endString });
	                    }
	                }
	            } else {
	                translationPending = true;
	            }
	        };
	
	        ngModelCtrl.$render = function () {
	            scope.model = timeService.defaultTimewindow();
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                var model = scope.model;
	                if (angular.isDefined(value.realtime)) {
	                    model.selectedTab = 0;
	                    model.realtime.interval = value.realtime.interval;
	                    model.realtime.timewindowMs = value.realtime.timewindowMs;
	                } else {
	                    model.selectedTab = 1;
	                    model.history.interval = value.history.interval;
	                    if (angular.isDefined(value.history.timewindowMs)) {
	                        model.history.historyType = 0;
	                        model.history.timewindowMs = value.history.timewindowMs;
	                    } else {
	                        model.history.historyType = 1;
	                        model.history.fixedTimewindow.startTimeMs = value.history.fixedTimewindow.startTimeMs;
	                        model.history.fixedTimewindow.endTimeMs = value.history.fixedTimewindow.endTimeMs;
	                    }
	                }
	                if (angular.isDefined(value.aggregation)) {
	                    if (angular.isDefined(value.aggregation.type) && value.aggregation.type.length > 0) {
	                        model.aggregation.type = value.aggregation.type;
	                    }
	                    model.aggregation.limit = value.aggregation.limit || Math.floor(timeService.getMaxDatapointsLimit() / 2);
	                }
	            }
	            scope.updateDisplayValue();
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            asButton: '=asButton',
	            disabled: '=ngDisabled'
	        },
	        link: linker
	    };
	}
	
	/*@ngInject*/
	function MillisecondsToTimeString($translate) {
	    return function (millseconds) {
	        var seconds = Math.floor(millseconds / 1000);
	        var days = Math.floor(seconds / 86400);
	        var hours = Math.floor(seconds % 86400 / 3600);
	        var minutes = Math.floor(seconds % 86400 % 3600 / 60);
	        seconds = seconds % 60;
	        var timeString = '';
	        if (days > 0) timeString += $translate.instant('timewindow.days', { days: days }, 'messageformat');
	        if (hours > 0) {
	            if (timeString.length === 0 && hours === 1) {
	                hours = 0;
	            }
	            timeString += $translate.instant('timewindow.hours', { hours: hours }, 'messageformat');
	        }
	        if (minutes > 0) {
	            if (timeString.length === 0 && minutes === 1) {
	                minutes = 0;
	            }
	            timeString += $translate.instant('timewindow.minutes', { minutes: minutes }, 'messageformat');
	        }
	        if (seconds > 0) {
	            if (timeString.length === 0 && seconds === 1) {
	                seconds = 0;
	            }
	            timeString += $translate.instant('timewindow.seconds', { seconds: seconds }, 'messageformat');
	        }
	        return timeString;
	    };
	}
	/* eslint-enable angular/angularelement */

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	ExtensionDialogController.$inject = ["$scope", "$mdDialog", "$translate", "isAdd", "allExtensions", "entityId", "entityType", "extension", "types", "attributeService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ExtensionDialogController;
	exports.ParseToNull = ParseToNull;
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var js_beautify = _jsBeautify2.default.js;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function ExtensionDialogController($scope, $mdDialog, $translate, isAdd, allExtensions, entityId, entityType, extension, types, attributeService) {
	
	    var vm = this;
	
	    vm.types = types;
	    vm.isAdd = isAdd;
	    vm.entityType = entityType;
	    vm.entityId = entityId;
	    vm.allExtensions = allExtensions;
	
	    if (extension) {
	        vm.extension = angular.copy(extension);
	        editTransformers(vm.extension);
	    } else {
	        vm.extension = {};
	    }
	
	    vm.extensionTypeChange = function () {
	
	        if (vm.extension.type === "HTTP") {
	            vm.extension.configuration = {
	                "converterConfigurations": []
	            };
	        }
	        if (vm.extension.type === "MQTT") {
	            vm.extension.configuration = {
	                "brokers": []
	            };
	        }
	        if (vm.extension.type === "OPC UA" || vm.extension.type === "MODBUS") {
	            vm.extension.configuration = {
	                "servers": []
	            };
	        }
	    };
	
	    vm.cancel = cancel;
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    vm.save = save;
	    function save() {
	        var $errorElement = angular.element('[name=theForm]').find('.ng-invalid');
	
	        if ($errorElement.length) {
	
	            var $mdDialogScroll = angular.element('md-dialog-content').scrollTop();
	            var $mdDialogTop = angular.element('md-dialog-content').offset().top;
	            var $errorElementTop = angular.element('[name=theForm]').find('.ng-invalid').eq(0).offset().top;
	
	            if ($errorElementTop !== $mdDialogTop) {
	                angular.element('md-dialog-content').animate({
	                    scrollTop: $mdDialogScroll + ($errorElementTop - $mdDialogTop) - 50
	                }, 500);
	                $errorElement.eq(0).focus();
	            }
	        } else {
	
	            if (vm.isAdd) {
	                vm.allExtensions.push(vm.extension);
	            } else {
	                var index = vm.allExtensions.indexOf(extension);
	                if (index > -1) {
	                    vm.allExtensions[index] = vm.extension;
	                }
	            }
	
	            $mdDialog.hide();
	            saveTransformers();
	
	            var editedValue = angular.toJson(vm.allExtensions);
	
	            attributeService.saveEntityAttributes(vm.entityType, vm.entityId, types.attributesScope.shared.value, [{ key: "configuration", value: editedValue }]).then(function success() {});
	        }
	    }
	
	    vm.validateId = function () {
	        var coincidenceArray = vm.allExtensions.filter(function (ext) {
	            return ext.id == vm.extension.id;
	        });
	        if (coincidenceArray.length) {
	            if (!vm.isAdd) {
	                if (coincidenceArray[0].id == extension.id) {
	                    $scope.theForm.extensionId.$setValidity('uniqueIdValidation', true);
	                } else {
	                    $scope.theForm.extensionId.$setValidity('uniqueIdValidation', false);
	                }
	            } else {
	                $scope.theForm.extensionId.$setValidity('uniqueIdValidation', false);
	            }
	        } else {
	            $scope.theForm.extensionId.$setValidity('uniqueIdValidation', true);
	        }
	    };
	
	    function saveTransformers() {
	        if (vm.extension.type == types.extensionType.http) {
	            var config = vm.extension.configuration.converterConfigurations;
	            if (config && config.length > 0) {
	                for (var i = 0; i < config.length; i++) {
	                    for (var j = 0; j < config[i].converters.length; j++) {
	                        for (var k = 0; k < config[i].converters[j].attributes.length; k++) {
	                            if (config[i].converters[j].attributes[k].transformerType == "toDouble") {
	                                config[i].converters[j].attributes[k].transformer = { type: "intToDouble" };
	                            }
	                            delete config[i].converters[j].attributes[k].transformerType;
	                        }
	                        for (var l = 0; l < config[i].converters[j].timeseries.length; l++) {
	                            if (config[i].converters[j].timeseries[l].transformerType == "toDouble") {
	                                config[i].converters[j].timeseries[l].transformer = { type: "intToDouble" };
	                            }
	                            delete config[i].converters[j].timeseries[l].transformerType;
	                        }
	                    }
	                }
	            }
	        }
	        if (vm.extension.type == types.extensionType.mqtt) {
	            var brokers = vm.extension.configuration.brokers;
	            if (brokers && brokers.length > 0) {
	                for (var _i = 0; _i < brokers.length; _i++) {
	                    if (brokers[_i].mapping && brokers[_i].mapping.length > 0) {
	                        for (var _j = 0; _j < brokers[_i].mapping.length; _j++) {
	                            if (brokers[_i].mapping[_j].converterType == "json") {
	                                delete brokers[_i].mapping[_j].converter.nameExp;
	                                delete brokers[_i].mapping[_j].converter.typeExp;
	                            }
	                            delete brokers[_i].mapping[_j].converterType;
	                        }
	                    }
	                    if (brokers[_i].connectRequests && brokers[_i].connectRequests.length > 0) {
	                        for (var _j2 = 0; _j2 < brokers[_i].connectRequests.length; _j2++) {
	                            delete brokers[_i].connectRequests[_j2].nameExp;
	                        }
	                    }
	                    if (brokers[_i].disconnectRequests && brokers[_i].disconnectRequests.length > 0) {
	                        for (var _j3 = 0; _j3 < brokers[_i].disconnectRequests.length; _j3++) {
	                            delete brokers[_i].disconnectRequests[_j3].nameExp;
	                        }
	                    }
	                    if (brokers[_i].attributeRequests && brokers[_i].attributeRequests.length > 0) {
	                        for (var _j4 = 0; _j4 < brokers[_i].attributeRequests.length; _j4++) {
	                            delete brokers[_i].attributeRequests[_j4].nameExp;
	                        }
	                        for (var _j5 = 0; _j5 < brokers[_i].attributeRequests.length; _j5++) {
	                            delete brokers[_i].attributeRequests[_j5].attrKey;
	                        }
	                        for (var _j6 = 0; _j6 < brokers[_i].attributeRequests.length; _j6++) {
	                            delete brokers[_i].attributeRequests[_j6].requestId;
	                        }
	                    }
	                }
	            }
	        }
	    }
	
	    function editTransformers(extension) {
	        if (extension.type == types.extensionType.http) {
	            var config = extension.configuration.converterConfigurations;
	            for (var i = 0; i < config.length; i++) {
	                for (var j = 0; j < config[i].converters.length; j++) {
	                    for (var k = 0; k < config[i].converters[j].attributes.length; k++) {
	                        if (config[i].converters[j].attributes[k].transformer) {
	                            if (config[i].converters[j].attributes[k].transformer.type == "intToDouble") {
	                                config[i].converters[j].attributes[k].transformerType = "toDouble";
	                            } else {
	                                config[i].converters[j].attributes[k].transformerType = "custom";
	                                config[i].converters[j].attributes[k].transformer = js_beautify(config[i].converters[j].attributes[k].transformer, { indent_size: 4 });
	                            }
	                        }
	                    }
	                    for (var l = 0; l < config[i].converters[j].timeseries.length; l++) {
	                        if (config[i].converters[j].timeseries[l].transformer) {
	                            if (config[i].converters[j].timeseries[l].transformer.type == "intToDouble") {
	                                config[i].converters[j].timeseries[l].transformerType = "toDouble";
	                            } else {
	                                config[i].converters[j].timeseries[l].transformerType = "custom";
	                                config[i].converters[j].timeseries[l].transformer = js_beautify(config[i].converters[j].timeseries[l].transformer, { indent_size: 4 });
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        if (extension.type == types.extensionType.mqtt) {
	            var brokers = extension.configuration.brokers;
	            for (var _i2 = 0; _i2 < brokers.length; _i2++) {
	                if (brokers[_i2].mapping && brokers[_i2].mapping.length > 0) {
	                    for (var _j7 = 0; _j7 < brokers[_i2].mapping.length; _j7++) {
	                        if (brokers[_i2].mapping[_j7].converter.type == "json") {
	                            if (brokers[_i2].mapping[_j7].converter.deviceNameTopicExpression) {
	                                brokers[_i2].mapping[_j7].converter.nameExp = "deviceNameTopicExpression";
	                            } else {
	                                brokers[_i2].mapping[_j7].converter.nameExp = "deviceNameJsonExpression";
	                            }
	                            if (brokers[_i2].mapping[_j7].converter.deviceTypeTopicExpression) {
	                                brokers[_i2].mapping[_j7].converter.typeExp = "deviceTypeTopicExpression";
	                            } else {
	                                brokers[_i2].mapping[_j7].converter.typeExp = "deviceTypeJsonExpression";
	                            }
	                            brokers[_i2].mapping[_j7].converterType = "json";
	                        } else {
	                            brokers[_i2].mapping[_j7].converterType = "custom";
	                        }
	                    }
	                }
	                if (brokers[_i2].connectRequests && brokers[_i2].connectRequests.length > 0) {
	                    for (var _j8 = 0; _j8 < brokers[_i2].connectRequests.length; _j8++) {
	                        if (brokers[_i2].connectRequests[_j8].deviceNameTopicExpression) {
	                            brokers[_i2].connectRequests[_j8].nameExp = "deviceNameTopicExpression";
	                        } else {
	                            brokers[_i2].connectRequests[_j8].nameExp = "deviceNameJsonExpression";
	                        }
	                    }
	                }
	                if (brokers[_i2].disconnectRequests && brokers[_i2].disconnectRequests.length > 0) {
	                    for (var _j9 = 0; _j9 < brokers[_i2].disconnectRequests.length; _j9++) {
	                        if (brokers[_i2].disconnectRequests[_j9].deviceNameTopicExpression) {
	                            brokers[_i2].disconnectRequests[_j9].nameExp = "deviceNameTopicExpression";
	                        } else {
	                            brokers[_i2].disconnectRequests[_j9].nameExp = "deviceNameJsonExpression";
	                        }
	                    }
	                }
	                if (brokers[_i2].attributeRequests && brokers[_i2].attributeRequests.length > 0) {
	                    for (var _j10 = 0; _j10 < brokers[_i2].attributeRequests.length; _j10++) {
	                        if (brokers[_i2].attributeRequests[_j10].deviceNameTopicExpression) {
	                            brokers[_i2].attributeRequests[_j10].nameExp = "deviceNameTopicExpression";
	                        } else {
	                            brokers[_i2].attributeRequests[_j10].nameExp = "deviceNameJsonExpression";
	                        }
	                        if (brokers[_i2].attributeRequests[_j10].attributeKeyTopicExpression) {
	                            brokers[_i2].attributeRequests[_j10].attrKey = "attributeKeyTopicExpression";
	                        } else {
	                            brokers[_i2].attributeRequests[_j10].attrKey = "attributeKeyJsonExpression";
	                        }
	                        if (brokers[_i2].attributeRequests[_j10].requestIdTopicExpression) {
	                            brokers[_i2].attributeRequests[_j10].requestId = "requestIdTopicExpression";
	                        } else {
	                            brokers[_i2].attributeRequests[_j10].requestId = "requestIdJsonExpression";
	                        }
	                    }
	                }
	            }
	        }
	    }
	}
	
	/*@ngInject*/
	function ParseToNull() {
	    var linker = function linker(scope, elem, attrs, ngModel) {
	        ngModel.$parsers.push(function (value) {
	            if (value === "") {
	                return null;
	            }
	            return value;
	        });
	    };
	    return {
	        restrict: "A",
	        link: linker,
	        require: "ngModel"
	    };
	}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = UrlHandler;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function UrlHandler($injector, $location) {
	    var userService = $injector.get('userService');
	    if (userService.isUserLoaded() === true) {
	        userService.gotoDefaultPlace();
	    } else {
	        var $rootScope = $injector.get('$rootScope');
	        if ($rootScope.userLoadedHandle) {
	            $rootScope.userLoadedHandle();
	        }
	        $rootScope.userLoadedHandle = $rootScope.$on('userLoaded', function () {
	            $rootScope.userLoadedHandle();
	            UrlHandler($injector, $location);
	        });
	    }
	}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _canvasGauges = __webpack_require__(100);
	
	var _canvasGauges2 = _interopRequireDefault(_canvasGauges);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/* eslint-disable angular/angularelement */
	
	var defaultDigitalGaugeOptions = Object.assign({}, _canvasGauges2.default.GenericOptions, {
	    gaugeType: 'arc',
	    gaugeWithScale: 0.75,
	    dashThickness: 0,
	    roundedLineCap: false,
	
	    gaugeColor: '#777',
	    levelColors: ['blue'],
	
	    symbol: '',
	    label: '',
	    hideValue: false,
	    hideMinMax: false,
	
	    fontTitle: 'Roboto',
	
	    fontValue: 'Roboto',
	
	    fontMinMaxSize: 10,
	    fontMinMaxStyle: 'normal',
	    fontMinMaxWeight: '500',
	    colorMinMax: '#eee',
	    fontMinMax: 'Roboto',
	
	    fontLabelSize: 8,
	    fontLabelStyle: 'normal',
	    fontLabelWeight: '500',
	    colorLabel: '#eee',
	    fontLabel: 'Roboto',
	
	    neonGlowBrightness: 0,
	
	    isMobile: false
	
	});
	
	var round = Math.round;
	
	var CanvasDigitalGauge = function (_canvasGauges$BaseGau) {
	    _inherits(CanvasDigitalGauge, _canvasGauges$BaseGau);
	
	    function CanvasDigitalGauge(options) {
	        _classCallCheck(this, CanvasDigitalGauge);
	
	        _canvasGauges2.default.performance = window.performance; // eslint-disable-line no-undef, angular/window-service
	        options = Object.assign({}, defaultDigitalGaugeOptions, options || {});
	
	        var _this = _possibleConstructorReturn(this, (CanvasDigitalGauge.__proto__ || Object.getPrototypeOf(CanvasDigitalGauge)).call(this, CanvasDigitalGauge.configure(options)));
	
	        _this.initValueClone();
	        return _this;
	    }
	
	    _createClass(CanvasDigitalGauge, [{
	        key: 'initValueClone',
	        value: function initValueClone() {
	            var canvas = this.canvas;
	            this.elementValueClone = canvas.element.cloneNode(true);
	            this.contextValueClone = this.elementValueClone.getContext('2d');
	            this.elementValueClone.initialized = false;
	
	            this.contextValueClone.translate(canvas.drawX, canvas.drawY);
	            this.contextValueClone.save();
	
	            this.elementProgressClone = canvas.element.cloneNode(true);
	            this.contextProgressClone = this.elementProgressClone.getContext('2d');
	            this.elementProgressClone.initialized = false;
	
	            this.contextProgressClone.translate(canvas.drawX, canvas.drawY);
	            this.contextProgressClone.save();
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.contextValueClone = null;
	            this.elementValueClone = null;
	            this.contextProgressClone = null;
	            this.elementProgressClone = null;
	            _get(CanvasDigitalGauge.prototype.__proto__ || Object.getPrototypeOf(CanvasDigitalGauge.prototype), 'destroy', this).call(this);
	        }
	    }, {
	        key: 'update',
	        value: function update(options) {
	            this.canvas.onRedraw = null;
	            var result = _get(CanvasDigitalGauge.prototype.__proto__ || Object.getPrototypeOf(CanvasDigitalGauge.prototype), 'update', this).call(this, options);
	            this.initValueClone();
	            this.canvas.onRedraw = this.draw.bind(this);
	            this.draw();
	            return result;
	        }
	    }, {
	        key: 'draw',
	        value: function draw() {
	            try {
	
	                var canvas = this.canvas;
	
	                if (!canvas.drawWidth || !canvas.drawHeight) {
	                    return this;
	                }
	
	                var _ref = [-canvas.drawX, -canvas.drawY, canvas.drawWidth, canvas.drawHeight],
	                    x = _ref[0],
	                    y = _ref[1],
	                    w = _ref[2],
	                    h = _ref[3];
	
	                var options = this.options;
	                if (!canvas.elementClone.initialized) {
	                    var context = canvas.contextClone;
	
	                    // clear the cache
	                    context.clearRect(x, y, w, h);
	                    context.save();
	
	                    canvas.context.barDimensions = barDimensions(context, options, x, y, w, h);
	                    this.contextValueClone.barDimensions = canvas.context.barDimensions;
	                    this.contextProgressClone.barDimensions = canvas.context.barDimensions;
	
	                    drawBackground(context, options);
	
	                    drawDigitalTitle(context, options);
	
	                    if (!options.showTimestamp) {
	                        drawDigitalLabel(context, options);
	                    }
	
	                    drawDigitalMinMax(context, options);
	
	                    canvas.elementClone.initialized = true;
	                }
	
	                var valueChanged = false;
	                if (!this.elementValueClone.initialized || angular.isDefined(this._value) && this.elementValueClone.renderedValue !== this._value || options.showTimestamp && this.elementValueClone.renderedTimestamp !== this.timestamp) {
	                    if (angular.isDefined(this._value)) {
	                        this.elementValueClone.renderedValue = this._value;
	                    }
	                    if (angular.isUndefined(this.elementValueClone.renderedValue)) {
	                        this.elementValueClone.renderedValue = this.value;
	                    }
	                    var _context = this.contextValueClone;
	                    // clear the cache
	                    _context.clearRect(x, y, w, h);
	                    _context.save();
	
	                    _context.drawImage(canvas.elementClone, x, y, w, h);
	                    _context.save();
	
	                    drawDigitalValue(_context, options, this.elementValueClone.renderedValue);
	
	                    if (options.showTimestamp) {
	                        drawDigitalLabel(_context, options);
	                        this.elementValueClone.renderedTimestamp = this.timestamp;
	                    }
	
	                    this.elementValueClone.initialized = true;
	
	                    valueChanged = true;
	                }
	
	                var progress = (_canvasGauges2.default.drawings.normalizedValue(options).normal - options.minValue) / (options.maxValue - options.minValue);
	
	                var fixedProgress = progress.toFixed(3);
	
	                if (!this.elementProgressClone.initialized || this.elementProgressClone.renderedProgress !== fixedProgress || valueChanged) {
	                    var _context2 = this.contextProgressClone;
	                    // clear the cache
	                    _context2.clearRect(x, y, w, h);
	                    _context2.save();
	
	                    _context2.drawImage(this.elementValueClone, x, y, w, h);
	                    _context2.save();
	
	                    if (Number(fixedProgress) > 0) {
	                        drawProgress(_context2, options, progress);
	                    }
	
	                    this.elementProgressClone.initialized = true;
	                    this.elementProgressClone.renderedProgress = fixedProgress;
	                }
	
	                this.canvas.commit();
	
	                // clear the canvas
	                canvas.context.clearRect(x, y, w, h);
	                canvas.context.save();
	
	                canvas.context.drawImage(this.elementProgressClone, x, y, w, h);
	                canvas.context.save();
	
	                _get(CanvasDigitalGauge.prototype.__proto__ || Object.getPrototypeOf(CanvasDigitalGauge.prototype), 'draw', this).call(this);
	            } catch (err) {
	                _canvasGauges2.default.drawings.verifyError(err);
	            }
	            return this;
	        }
	    }, {
	        key: 'getValueColor',
	        value: function getValueColor() {
	            if (this.contextProgressClone) {
	                var color = this.contextProgressClone.currentColor;
	                if (!color) {
	                    if (this.options.neonGlowBrightness) {
	                        color = getProgressColor(0, this.options.neonColorsRange);
	                    } else {
	                        color = getProgressColor(0, this.options.colorsRange);
	                    }
	                }
	                return color;
	            } else {
	                return '#000';
	            }
	        }
	    }, {
	        key: 'timestamp',
	        set: function set(timestamp) {
	            this.options.timestamp = timestamp;
	            this.draw();
	        },
	        get: function get() {
	            return this.options.timestamp;
	        }
	    }], [{
	        key: 'configure',
	        value: function configure(options) {
	
	            if (options.value > options.maxValue) {
	                options.value = options.maxValue;
	            }
	
	            if (options.value < options.minValue) {
	                options.value = options.minValue;
	            }
	
	            if (options.gaugeType === 'donut') {
	                if (!options.donutStartAngle) {
	                    options.donutStartAngle = 1.5 * Math.PI;
	                }
	                if (!options.donutEndAngle) {
	                    options.donutEndAngle = options.donutStartAngle + 2 * Math.PI;
	                }
	            }
	
	            var colorsCount = options.levelColors.length;
	            var inc = colorsCount > 1 ? 1 / (colorsCount - 1) : 1;
	            options.colorsRange = [];
	            if (options.neonGlowBrightness) {
	                options.neonColorsRange = [];
	            }
	            for (var i = 0; i < options.levelColors.length; i++) {
	                var percentage = inc * i;
	                var tColor = (0, _tinycolor2.default)(options.levelColors[i]);
	                options.colorsRange[i] = {
	                    pct: percentage,
	                    color: tColor.toRgb(),
	                    rgbString: tColor.toRgbString()
	                };
	                if (options.neonGlowBrightness) {
	                    tColor = (0, _tinycolor2.default)(options.levelColors[i]).brighten(options.neonGlowBrightness);
	                    options.neonColorsRange[i] = {
	                        pct: percentage,
	                        color: tColor.toRgb(),
	                        rgbString: tColor.toRgbString()
	                    };
	                }
	            }
	
	            if (options.neonGlowBrightness) {
	                options.neonColorTitle = (0, _tinycolor2.default)(options.colorTitle).brighten(options.neonGlowBrightness).toHexString();
	                options.neonColorLabel = (0, _tinycolor2.default)(options.colorLabel).brighten(options.neonGlowBrightness).toHexString();
	                options.neonColorValue = (0, _tinycolor2.default)(options.colorValue).brighten(options.neonGlowBrightness).toHexString();
	                options.neonColorMinMax = (0, _tinycolor2.default)(options.colorMinMax).brighten(options.neonGlowBrightness).toHexString();
	            }
	
	            return _canvasGauges2.default.BaseGauge.configure(options);
	        }
	    }]);
	
	    return CanvasDigitalGauge;
	}(_canvasGauges2.default.BaseGauge);
	
	/* eslint-disable angular/document-service */
	/* eslint-disable no-undef */
	
	
	exports.default = CanvasDigitalGauge;
	function determineFontHeight(options, target, baseSize) {
	    var fontStyleStr = 'font-style:' + options['font' + target + 'Style'] + ';font-weight:' + options['font' + target + 'Weight'] + ';font-size:' + options['font' + target + 'Size'] * baseSize + 'px;font-family:' + options['font' + target];
	    var result = CanvasDigitalGauge.heightCache[fontStyleStr];
	    if (!result) {
	        var fontStyle = {
	            fontFamily: options['font' + target],
	            fontSize: options['font' + target + 'Size'] * baseSize + 'px',
	            fontWeight: options['font' + target + 'Weight'],
	            fontStyle: options['font' + target + 'Style']
	        };
	
	        var text = (0, _jquery2.default)('<span>Hg</span>').css(fontStyle);
	        var block = (0, _jquery2.default)('<div style="display: inline-block; width: 1px; height: 0px;"></div>');
	
	        var div = (0, _jquery2.default)('<div></div>');
	        div.append(text, block);
	
	        var body = (0, _jquery2.default)('body');
	        body.append(div);
	
	        try {
	            result = {};
	            block.css({ verticalAlign: 'baseline' });
	            result.ascent = block.offset().top - text.offset().top;
	            block.css({ verticalAlign: 'bottom' });
	            result.height = block.offset().top - text.offset().top;
	            result.descent = result.height - result.ascent;
	        } finally {
	            div.remove();
	        }
	        CanvasDigitalGauge.heightCache[fontStyleStr] = result;
	    }
	    return result;
	}
	
	/* eslint-enable angular/document-service */
	/* eslint-enable no-undef */
	
	function barDimensions(context, options, x, y, w, h) {
	
	    context.barDimensions = {
	        baseX: x,
	        baseY: y,
	        width: w,
	        height: h
	    };
	
	    var bd = context.barDimensions;
	
	    var aspect = 1;
	
	    if (options.gaugeType === 'horizontalBar') {
	        aspect = options.title === '' ? 2.5 : 2;
	    } else if (options.gaugeType === 'verticalBar') {
	        aspect = options.hideMinMax ? 0.35 : 0.5;
	    } else if (options.gaugeType === 'arc') {
	        aspect = 1.5;
	    }
	
	    var currentAspect = w / h;
	    if (currentAspect > aspect) {
	        bd.width = h * aspect;
	        bd.height = h;
	    } else {
	        bd.width = w;
	        bd.height = w / aspect;
	    }
	
	    bd.origBaseX = bd.baseX;
	    bd.origBaseY = bd.baseY;
	    bd.baseX += (w - bd.width) / 2;
	    bd.baseY += (h - bd.height) / 2;
	
	    if (options.gaugeType === 'donut') {
	        bd.fontSizeFactor = Math.max(bd.width, bd.height) / 125;
	    } else if (options.gaugeType === 'verticalBar' || options.gaugeType === 'arc' && options.title === '') {
	        bd.fontSizeFactor = Math.max(bd.width, bd.height) / 150;
	    } else {
	        bd.fontSizeFactor = Math.max(bd.width, bd.height) / 200;
	    }
	
	    var gws = options.gaugeWidthScale;
	
	    if (options.neonGlowBrightness) {
	        options.fontTitleHeight = determineFontHeight(options, 'Title', bd.fontSizeFactor);
	        options.fontLabelHeight = determineFontHeight(options, 'Label', bd.fontSizeFactor);
	        options.fontValueHeight = determineFontHeight(options, 'Value', bd.fontSizeFactor);
	        options.fontMinMaxHeight = determineFontHeight(options, 'MinMax', bd.fontSizeFactor);
	    }
	
	    if (options.gaugeType === 'donut') {
	        bd.Ro = bd.width / 2 - bd.width / 20;
	        bd.Cy = bd.baseY + bd.height / 2;
	        if (options.title && options.title.length > 0) {
	            var titleOffset = determineFontHeight(options, 'Title', bd.fontSizeFactor).height;
	            titleOffset += bd.fontSizeFactor * 2;
	            bd.titleY = bd.baseY + titleOffset;
	            titleOffset += bd.fontSizeFactor * 2;
	            bd.Cy += titleOffset / 2;
	            bd.Ro -= titleOffset / 2;
	        }
	        bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws * 1.2;
	        bd.Cx = bd.baseX + bd.width / 2;
	    } else if (options.gaugeType === 'arc') {
	        if (options.title && options.title.length > 0) {
	            bd.Ro = bd.width / 2 - bd.width / 7;
	            bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws;
	        } else {
	            bd.Ro = bd.width / 2 - bd.fontSizeFactor * 4;
	            bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws * 1.2;
	        }
	        bd.Cx = bd.baseX + bd.width / 2;
	        bd.Cy = bd.baseY + bd.height / 1.25;
	    } else if (options.gaugeType === 'verticalBar') {
	        bd.Ro = bd.width / 2 - bd.width / 10;
	        bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws * (options.hideMinMax ? 4 : 2.5);
	    } else {
	        //horizontalBar
	        bd.Ro = bd.width / 2 - bd.width / 10;
	        bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws;
	    }
	
	    bd.strokeWidth = bd.Ro - bd.Ri;
	    bd.Rm = bd.Ri + bd.strokeWidth * 0.5;
	
	    bd.fontValueBaseline = 'alphabetic';
	    bd.fontMinMaxBaseline = 'alphabetic';
	    bd.fontMinMaxAlign = 'center';
	
	    if (options.gaugeType === 'donut') {
	        bd.fontValueBaseline = 'middle';
	        if (options.label && options.label.length > 0) {
	            var valueHeight = determineFontHeight(options, 'Value', bd.fontSizeFactor).height;
	            var labelHeight = determineFontHeight(options, 'Label', bd.fontSizeFactor).height;
	            var total = valueHeight + labelHeight;
	            bd.labelY = bd.Cy + total / 2;
	            bd.valueY = bd.Cy - total / 2 + valueHeight / 2;
	        } else {
	            bd.valueY = bd.Cy;
	        }
	    } else if (options.gaugeType === 'arc') {
	        bd.titleY = bd.Cy - bd.Ro - 12 * bd.fontSizeFactor;
	        bd.valueY = bd.Cy;
	        bd.labelY = bd.Cy + (8 + options.fontLabelSize) * bd.fontSizeFactor;
	        bd.minY = bd.maxY = bd.labelY;
	        if (options.roundedLineCap) {
	            bd.minY += bd.strokeWidth / 2;
	            bd.maxY += bd.strokeWidth / 2;
	        }
	        bd.minX = bd.Cx - bd.Rm;
	        bd.maxX = bd.Cx + bd.Rm;
	    } else if (options.gaugeType === 'horizontalBar') {
	        bd.titleY = bd.baseY + 4 * bd.fontSizeFactor + (options.title === '' ? 0 : options.fontTitleSize * bd.fontSizeFactor);
	        bd.titleBottom = bd.titleY + (options.title === '' ? 0 : 4) * bd.fontSizeFactor;
	
	        bd.valueY = bd.titleBottom + (options.hideValue ? 0 : options.fontValueSize * bd.fontSizeFactor);
	
	        bd.barTop = bd.valueY + 8 * bd.fontSizeFactor;
	        bd.barBottom = bd.barTop + bd.strokeWidth;
	
	        if (options.hideMinMax && options.label === '') {
	            bd.labelY = bd.barBottom;
	            bd.barLeft = bd.origBaseX + options.fontMinMaxSize / 3 * bd.fontSizeFactor;
	            bd.barRight = bd.origBaseX + w + /*bd.width*/-options.fontMinMaxSize / 3 * bd.fontSizeFactor;
	        } else {
	            context.font = _canvasGauges2.default.drawings.font(options, 'MinMax', bd.fontSizeFactor);
	            var minTextWidth = context.measureText(options.minValue + '').width;
	            var maxTextWidth = context.measureText(options.maxValue + '').width;
	            var maxW = Math.max(minTextWidth, maxTextWidth);
	            bd.minX = bd.origBaseX + maxW / 2 + options.fontMinMaxSize / 3 * bd.fontSizeFactor;
	            bd.maxX = bd.origBaseX + w + /*bd.width*/-maxW / 2 - options.fontMinMaxSize / 3 * bd.fontSizeFactor;
	            bd.barLeft = bd.minX;
	            bd.barRight = bd.maxX;
	            bd.labelY = bd.barBottom + (8 + options.fontLabelSize) * bd.fontSizeFactor;
	            bd.minY = bd.maxY = bd.labelY;
	        }
	    } else if (options.gaugeType === 'verticalBar') {
	        bd.titleY = bd.baseY + ((options.title === '' ? 0 : options.fontTitleSize) + 8) * bd.fontSizeFactor;
	        bd.titleBottom = bd.titleY + (options.title === '' ? 0 : 4) * bd.fontSizeFactor;
	
	        bd.valueY = bd.titleBottom + (options.hideValue ? 0 : options.fontValueSize * bd.fontSizeFactor);
	        bd.barTop = bd.valueY + 8 * bd.fontSizeFactor;
	
	        bd.labelY = bd.baseY + bd.height - 16;
	        if (options.label === '') {
	            bd.barBottom = bd.labelY;
	        } else {
	            bd.barBottom = bd.labelY - (8 + options.fontLabelSize) * bd.fontSizeFactor;
	        }
	        bd.minX = bd.maxX = bd.baseX + bd.width / 2 + bd.strokeWidth / 2 + options.fontMinMaxSize / 3 * bd.fontSizeFactor;
	        bd.minY = bd.barBottom;
	        bd.maxY = bd.barTop;
	        bd.fontMinMaxBaseline = 'middle';
	        bd.fontMinMaxAlign = 'left';
	    }
	
	    if (options.dashThickness) {
	        var circumference;
	        if (options.gaugeType === 'donut') {
	            circumference = Math.PI * bd.Rm * 2;
	        } else if (options.gaugeType === 'arc') {
	            circumference = Math.PI * bd.Rm;
	        } else if (options.gaugeType === 'horizontalBar') {
	            circumference = bd.barRight - bd.barLeft;
	        } else if (options.gaugeType === 'verticalBar') {
	            circumference = bd.barBottom - bd.barTop;
	        }
	        var dashCount = Math.floor(circumference / (options.dashThickness * bd.fontSizeFactor));
	        if (options.gaugeType === 'donut') {
	            dashCount = (dashCount | 1) - 1;
	        } else {
	            dashCount = dashCount - 1 | 1;
	        }
	        bd.dashLength = Math.ceil(circumference / dashCount);
	    }
	
	    return bd;
	}
	
	function drawBackground(context, options) {
	    var _context$barDimension = context.barDimensions,
	        barLeft = _context$barDimension.barLeft,
	        barRight = _context$barDimension.barRight,
	        barTop = _context$barDimension.barTop,
	        barBottom = _context$barDimension.barBottom,
	        width = _context$barDimension.width,
	        baseX = _context$barDimension.baseX,
	        strokeWidth = _context$barDimension.strokeWidth;
	
	    if (context.barDimensions.dashLength) {
	        context.setLineDash([context.barDimensions.dashLength]);
	    }
	    context.beginPath();
	    context.strokeStyle = options.gaugeColor;
	    context.lineWidth = strokeWidth;
	    if (options.roundedLineCap) {
	        context.lineCap = 'round';
	    }
	    if (options.gaugeType === 'donut') {
	        context.arc(context.barDimensions.Cx, context.barDimensions.Cy, context.barDimensions.Rm, options.donutStartAngle, options.donutEndAngle);
	        context.stroke();
	    } else if (options.gaugeType === 'arc') {
	        context.arc(context.barDimensions.Cx, context.barDimensions.Cy, context.barDimensions.Rm, Math.PI, 2 * Math.PI);
	        context.stroke();
	    } else if (options.gaugeType === 'horizontalBar') {
	        context.moveTo(barLeft, barTop + strokeWidth / 2);
	        context.lineTo(barRight, barTop + strokeWidth / 2);
	        context.stroke();
	    } else if (options.gaugeType === 'verticalBar') {
	        context.moveTo(baseX + width / 2, barBottom);
	        context.lineTo(baseX + width / 2, barTop);
	        context.stroke();
	    }
	}
	
	function drawText(context, options, target, text, textX, textY) {
	    context.fillStyle = options[(options.neonGlowBrightness ? 'neonColor' : 'color') + target];
	    context.fillText(text, textX, textY);
	}
	
	function drawDigitalTitle(context, options) {
	    if (!options.title) return;
	
	    var _context$barDimension2 = context.barDimensions,
	        titleY = _context$barDimension2.titleY,
	        width = _context$barDimension2.width,
	        baseX = _context$barDimension2.baseX,
	        fontSizeFactor = _context$barDimension2.fontSizeFactor;
	
	
	    var textX = round(baseX + width / 2);
	    var textY = titleY;
	
	    context.save();
	    context.textAlign = 'center';
	    context.font = _canvasGauges2.default.drawings.font(options, 'Title', fontSizeFactor);
	    context.lineWidth = 0;
	    drawText(context, options, 'Title', options.title.toUpperCase(), textX, textY);
	}
	
	function drawDigitalLabel(context, options) {
	    if (!options.label || options.label === '') return;
	
	    var _context$barDimension3 = context.barDimensions,
	        labelY = _context$barDimension3.labelY,
	        baseX = _context$barDimension3.baseX,
	        width = _context$barDimension3.width,
	        fontSizeFactor = _context$barDimension3.fontSizeFactor;
	
	
	    var textX = round(baseX + width / 2);
	    var textY = labelY;
	
	    context.save();
	    context.textAlign = 'center';
	    context.font = _canvasGauges2.default.drawings.font(options, 'Label', fontSizeFactor);
	    context.lineWidth = 0;
	    drawText(context, options, 'Label', options.label.toUpperCase(), textX, textY);
	}
	
	function drawDigitalMinMax(context, options) {
	    if (options.hideMinMax || options.gaugeType === 'donut') return;
	
	    var _context$barDimension4 = context.barDimensions,
	        minY = _context$barDimension4.minY,
	        maxY = _context$barDimension4.maxY,
	        minX = _context$barDimension4.minX,
	        maxX = _context$barDimension4.maxX,
	        fontSizeFactor = _context$barDimension4.fontSizeFactor,
	        fontMinMaxAlign = _context$barDimension4.fontMinMaxAlign,
	        fontMinMaxBaseline = _context$barDimension4.fontMinMaxBaseline;
	
	
	    context.save();
	    context.textAlign = fontMinMaxAlign;
	    context.textBaseline = fontMinMaxBaseline;
	    context.font = _canvasGauges2.default.drawings.font(options, 'MinMax', fontSizeFactor);
	    context.lineWidth = 0;
	    drawText(context, options, 'MinMax', options.minValue + '', minX, minY);
	    drawText(context, options, 'MinMax', options.maxValue + '', maxX, maxY);
	}
	
	function padValue(val, options) {
	    var dec = options.valueDec;
	    var strVal = void 0,
	        n = void 0;
	
	    val = parseFloat(val);
	    n = val < 0;
	    val = Math.abs(val);
	
	    if (dec > 0) {
	        strVal = val.toFixed(dec).toString();
	    } else {
	        strVal = round(val).toString();
	    }
	    strVal = (n ? '-' : '') + strVal;
	    return strVal;
	}
	
	function drawDigitalValue(context, options, value) {
	    if (options.hideValue) return;
	
	    var _context$barDimension5 = context.barDimensions,
	        valueY = _context$barDimension5.valueY,
	        baseX = _context$barDimension5.baseX,
	        width = _context$barDimension5.width,
	        fontSizeFactor = _context$barDimension5.fontSizeFactor,
	        fontValueBaseline = _context$barDimension5.fontValueBaseline;
	
	
	    var textX = round(baseX + width / 2);
	    var textY = valueY;
	
	    var text = options.valueText || padValue(value, options);
	    text += options.symbol;
	
	    context.save();
	    context.textAlign = 'center';
	    context.textBaseline = fontValueBaseline;
	    context.font = _canvasGauges2.default.drawings.font(options, 'Value', fontSizeFactor);
	    context.lineWidth = 0;
	    drawText(context, options, 'Value', text, textX, textY);
	}
	
	function getProgressColor(progress, colorsRange) {
	
	    var lower, upper, range, rangePct, pctLower, pctUpper, color;
	
	    if (progress === 0 || colorsRange.length === 1) {
	        return colorsRange[0].rgbString;
	    }
	
	    for (var j = 0; j < colorsRange.length; j++) {
	        if (progress <= colorsRange[j].pct) {
	            lower = colorsRange[j - 1];
	            upper = colorsRange[j];
	            range = upper.pct - lower.pct;
	            rangePct = (progress - lower.pct) / range;
	            pctLower = 1 - rangePct;
	            pctUpper = rangePct;
	            color = (0, _tinycolor2.default)({
	                r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
	                g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
	                b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
	            });
	            return color.toRgbString();
	        }
	    }
	}
	
	function drawArcGlow(context, Cx, Cy, Ri, Rm, Ro, color, progress, isDonut, donutStartAngle, donutEndAngle) {
	    context.setLineDash([]);
	    var strokeWidth = Ro - Ri;
	    var blur = 0.55;
	    var edge = strokeWidth * blur;
	    context.lineWidth = strokeWidth + edge;
	    var stop = blur / (2 * blur + 2);
	    var glowGradient = context.createRadialGradient(Cx, Cy, Ri - edge / 2, Cx, Cy, Ro + edge / 2);
	    var color1 = (0, _tinycolor2.default)(color).setAlpha(0.5).toRgbString();
	    var color2 = (0, _tinycolor2.default)(color).setAlpha(0).toRgbString();
	    glowGradient.addColorStop(0, color2);
	    glowGradient.addColorStop(stop, color1);
	    glowGradient.addColorStop(1.0 - stop, color1);
	    glowGradient.addColorStop(1, color2);
	    context.strokeStyle = glowGradient;
	    context.beginPath();
	    var e = 0.01 * Math.PI;
	    if (isDonut) {
	        context.arc(Cx, Cy, Rm, donutStartAngle - e, donutStartAngle + (donutEndAngle - donutStartAngle) * progress + e);
	    } else {
	        context.arc(Cx, Cy, Rm, Math.PI - e, Math.PI + Math.PI * progress + e);
	    }
	    context.stroke();
	}
	
	function drawBarGlow(context, startX, startY, endX, endY, color, strokeWidth, isVertical) {
	    context.setLineDash([]);
	    var blur = 0.55;
	    var edge = strokeWidth * blur;
	    context.lineWidth = strokeWidth + edge;
	    var stop = blur / (2 * blur + 2);
	    var gradientStartX = isVertical ? startX - context.lineWidth / 2 : 0;
	    var gradientStartY = isVertical ? 0 : startY - context.lineWidth / 2;
	    var gradientStopX = isVertical ? startX + context.lineWidth / 2 : 0;
	    var gradientStopY = isVertical ? 0 : startY + context.lineWidth / 2;
	
	    var glowGradient = context.createLinearGradient(gradientStartX, gradientStartY, gradientStopX, gradientStopY);
	    var color1 = (0, _tinycolor2.default)(color).setAlpha(0.5).toRgbString();
	    var color2 = (0, _tinycolor2.default)(color).setAlpha(0).toRgbString();
	    glowGradient.addColorStop(0, color2);
	    glowGradient.addColorStop(stop, color1);
	    glowGradient.addColorStop(1.0 - stop, color1);
	    glowGradient.addColorStop(1, color2);
	    context.strokeStyle = glowGradient;
	    var dx = isVertical ? 0 : 0.05 * context.lineWidth;
	    var dy = isVertical ? 0.05 * context.lineWidth : 0;
	    context.beginPath();
	    context.moveTo(startX - dx, startY + dy);
	    context.lineTo(endX + dx, endY - dy);
	    context.stroke();
	}
	
	function drawProgress(context, options, progress) {
	    var neonColor;
	    if (options.neonGlowBrightness) {
	        context.currentColor = neonColor = getProgressColor(progress, options.neonColorsRange);
	    } else {
	        context.currentColor = context.strokeStyle = getProgressColor(progress, options.colorsRange);
	    }
	
	    var _context$barDimension6 = context.barDimensions,
	        barLeft = _context$barDimension6.barLeft,
	        barRight = _context$barDimension6.barRight,
	        barTop = _context$barDimension6.barTop,
	        baseX = _context$barDimension6.baseX,
	        width = _context$barDimension6.width,
	        barBottom = _context$barDimension6.barBottom,
	        Cx = _context$barDimension6.Cx,
	        Cy = _context$barDimension6.Cy,
	        Rm = _context$barDimension6.Rm,
	        Ro = _context$barDimension6.Ro,
	        Ri = _context$barDimension6.Ri,
	        strokeWidth = _context$barDimension6.strokeWidth;
	
	
	    if (context.barDimensions.dashLength) {
	        context.setLineDash([context.barDimensions.dashLength]);
	    }
	    context.lineWidth = strokeWidth;
	    if (options.roundedLineCap) {
	        context.lineCap = 'round';
	    } else {
	        context.lineCap = 'butt';
	    }
	    if (options.gaugeType === 'donut') {
	        if (options.neonGlowBrightness) {
	            context.strokeStyle = neonColor;
	        }
	        context.beginPath();
	        context.arc(Cx, Cy, Rm, options.donutStartAngle, options.donutStartAngle + (options.donutEndAngle - options.donutStartAngle) * progress);
	        context.stroke();
	        if (options.neonGlowBrightness && !options.isMobile) {
	            drawArcGlow(context, Cx, Cy, Ri, Rm, Ro, neonColor, progress, true, options.donutStartAngle, options.donutEndAngle);
	        }
	    } else if (options.gaugeType === 'arc') {
	        if (options.neonGlowBrightness) {
	            context.strokeStyle = neonColor;
	        }
	        context.beginPath();
	        context.arc(Cx, Cy, Rm, Math.PI, Math.PI + Math.PI * progress);
	        context.stroke();
	        if (options.neonGlowBrightness && !options.isMobile) {
	            drawArcGlow(context, Cx, Cy, Ri, Rm, Ro, neonColor, progress, false);
	        }
	    } else if (options.gaugeType === 'horizontalBar') {
	        if (options.neonGlowBrightness) {
	            context.strokeStyle = neonColor;
	        }
	        context.beginPath();
	        context.moveTo(barLeft, barTop + strokeWidth / 2);
	        context.lineTo(barLeft + (barRight - barLeft) * progress, barTop + strokeWidth / 2);
	        context.stroke();
	        if (options.neonGlowBrightness && !options.isMobile) {
	            drawBarGlow(context, barLeft, barTop + strokeWidth / 2, barLeft + (barRight - barLeft) * progress, barTop + strokeWidth / 2, neonColor, strokeWidth, false);
	        }
	    } else if (options.gaugeType === 'verticalBar') {
	        if (options.neonGlowBrightness) {
	            context.strokeStyle = neonColor;
	        }
	        context.beginPath();
	        context.moveTo(baseX + width / 2, barBottom);
	        context.lineTo(baseX + width / 2, barBottom - (barBottom - barTop) * progress);
	        context.stroke();
	        if (options.neonGlowBrightness && !options.isMobile) {
	            drawBarGlow(context, baseX + width / 2, barBottom, baseX + width / 2, barBottom - (barBottom - barTop) * progress, neonColor, strokeWidth, true);
	        }
	    }
	}
	
	CanvasDigitalGauge.heightCache = [];
	
	_canvasGauges2.default.BaseGauge.initialize('CanvasDigitalGauge', defaultDigitalGaugeOptions);
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var gmGlobals = {
	    loadingGmId: null,
	    gmApiKeys: {}
	};
	
	var TbGoogleMap = function () {
	    function TbGoogleMap($containerElement, utils, initCallback, defaultZoomLevel, dontFitMapBounds, minZoomLevel, gmApiKey, gmDefaultMapType) {
	        _classCallCheck(this, TbGoogleMap);
	
	        var tbMap = this;
	        this.utils = utils;
	        this.defaultZoomLevel = defaultZoomLevel;
	        this.dontFitMapBounds = dontFitMapBounds;
	        this.minZoomLevel = minZoomLevel;
	        this.tooltips = [];
	        this.defaultMapType = gmDefaultMapType;
	
	        function clearGlobalId() {
	            if (gmGlobals.loadingGmId && gmGlobals.loadingGmId === tbMap.mapId) {
	                gmGlobals.loadingGmId = null;
	            }
	        }
	
	        function displayError(message) {
	            $containerElement.html( // eslint-disable-line angular/angularelement
	            "<div class='error'>" + message + "</div>");
	        }
	
	        function initGoogleMap() {
	
	            tbMap.map = new google.maps.Map($containerElement[0], { // eslint-disable-line no-undef
	                scrollwheel: true,
	                mapTypeId: getGoogleMapTypeId(tbMap.defaultMapType),
	                zoom: tbMap.defaultZoomLevel || 8
	            });
	
	            if (initCallback) {
	                initCallback();
	            }
	        }
	
	        /* eslint-disable no-undef */
	
	        function getGoogleMapTypeId(mapType) {
	            var mapTypeId = google.maps.MapTypeId.ROADMAP;
	            if (mapType) {
	                if (mapType === 'hybrid') {
	                    mapTypeId = google.maps.MapTypeId.HYBRID;
	                } else if (mapType === 'satellite') {
	                    mapTypeId = google.maps.MapTypeId.SATELLITE;
	                } else if (mapType === 'terrain') {
	                    mapTypeId = google.maps.MapTypeId.TERRAIN;
	                }
	            }
	            return mapTypeId;
	        }
	
	        /* eslint-enable no-undef */
	
	        this.mapId = '' + Math.random().toString(36).substr(2, 9);
	        this.apiKey = gmApiKey || '';
	
	        window.gm_authFailure = function () {
	            // eslint-disable-line no-undef, angular/window-service
	            if (gmGlobals.loadingGmId && gmGlobals.loadingGmId === tbMap.mapId) {
	                gmGlobals.loadingGmId = null;
	                gmGlobals.gmApiKeys[tbMap.apiKey].error = 'Unable to authentificate for Google Map API.</br>Please check your API key.';
	                displayError(gmGlobals.gmApiKeys[tbMap.apiKey].error);
	            }
	        };
	
	        this.initMapFunctionName = 'initGoogleMap_' + this.mapId;
	
	        window[this.initMapFunctionName] = function () {
	            // eslint-disable-line no-undef, angular/window-service
	            lazyLoad.load({ type: 'js', path: 'https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js' }).then( // eslint-disable-line no-undef
	            function success() {
	                gmGlobals.gmApiKeys[tbMap.apiKey].loaded = true;
	                initGoogleMap();
	                for (var p = 0; p < gmGlobals.gmApiKeys[tbMap.apiKey].pendingInits.length; p++) {
	                    var pendingInit = gmGlobals.gmApiKeys[tbMap.apiKey].pendingInits[p];
	                    pendingInit();
	                }
	                gmGlobals.gmApiKeys[tbMap.apiKey].pendingInits = [];
	            }, function fail(e) {
	                clearGlobalId();
	                gmGlobals.gmApiKeys[tbMap.apiKey].error = 'Google map api load failed!</br>' + e;
	                displayError(gmGlobals.gmApiKeys[tbMap.apiKey].error);
	            });
	        };
	
	        if (this.apiKey && this.apiKey.length > 0) {
	            if (gmGlobals.gmApiKeys[this.apiKey]) {
	                if (gmGlobals.gmApiKeys[this.apiKey].error) {
	                    displayError(gmGlobals.gmApiKeys[this.apiKey].error);
	                } else if (gmGlobals.gmApiKeys[this.apiKey].loaded) {
	                    initGoogleMap();
	                } else {
	                    gmGlobals.gmApiKeys[this.apiKey].pendingInits.push(initGoogleMap);
	                }
	            } else {
	                gmGlobals.gmApiKeys[this.apiKey] = {
	                    loaded: false,
	                    pendingInits: []
	                };
	                var googleMapScriptRes = 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey + '&callback=' + this.initMapFunctionName;
	
	                gmGlobals.loadingGmId = this.mapId;
	                lazyLoad.load({ type: 'js', path: googleMapScriptRes }).then( // eslint-disable-line no-undef
	                function success() {
	                    setTimeout(clearGlobalId, 2000); // eslint-disable-line no-undef, angular/timeout-service
	                }, function fail(e) {
	                    clearGlobalId();
	                    gmGlobals.gmApiKeys[tbMap.apiKey].error = 'Google map api load failed!</br>' + e;
	                    displayError(gmGlobals.gmApiKeys[tbMap.apiKey].error);
	                });
	            }
	        } else {
	            displayError('No Google Map Api Key provided!');
	        }
	    }
	
	    _createClass(TbGoogleMap, [{
	        key: "inited",
	        value: function inited() {
	            return angular.isDefined(this.map);
	        }
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "updateMarkerLabel",
	        value: function updateMarkerLabel(marker, settings) {
	            marker.set('labelContent', '<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>');
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "updateMarkerColor",
	        value: function updateMarkerColor(marker, color) {
	            this.createDefaultMarkerIcon(marker, color, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	            });
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "updateMarkerIcon",
	        value: function updateMarkerIcon(marker, settings) {
	            this.createMarkerIcon(marker, settings, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	                if (settings.showLabel) {
	                    marker.set('labelAnchor', new google.maps.Point(100, iconInfo.size[1] + 20));
	                }
	            });
	        }
	        /* eslint-disable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createMarkerIcon",
	        value: function createMarkerIcon(marker, settings, onMarkerIconReady) {
	            var currentImage = settings.currentImage;
	            var gMap = this;
	            if (currentImage && currentImage.url) {
	                this.utils.loadImageAspect(currentImage.url).then(function (aspect) {
	                    if (aspect) {
	                        var width;
	                        var height;
	                        if (aspect > 1) {
	                            width = currentImage.size;
	                            height = currentImage.size / aspect;
	                        } else {
	                            width = currentImage.size * aspect;
	                            height = currentImage.size;
	                        }
	                        var icon = {
	                            url: currentImage.url,
	                            scaledSize: new google.maps.Size(width, height)
	                        };
	                        var iconInfo = {
	                            size: [width, height],
	                            icon: icon
	                        };
	                        onMarkerIconReady(iconInfo);
	                    } else {
	                        gMap.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
	                    }
	                });
	            } else {
	                this.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
	            }
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createDefaultMarkerIcon",
	        value: function createDefaultMarkerIcon(marker, color, onMarkerIconReady) {
	            var pinColor = color.substr(1);
	            var icon = new google.maps.MarkerImage("https://chart.apis.google.com/chart?chst=d_map_pin_letter_withshadow&chld=%E2%80%A2|" + pinColor, new google.maps.Size(40, 37), new google.maps.Point(0, 0), new google.maps.Point(10, 37));
	            var iconInfo = {
	                size: [40, 37],
	                icon: icon
	            };
	            onMarkerIconReady(iconInfo);
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createMarker",
	        value: function createMarker(location, settings, onClickListener, markerArgs) {
	            var marker;
	            if (settings.showLabel) {
	                marker = new MarkerWithLabel({
	                    position: location,
	                    labelContent: '<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>',
	                    labelClass: "tb-labels"
	                });
	            } else {
	                marker = new google.maps.Marker({
	                    position: location
	                });
	            }
	            var gMap = this;
	            this.createMarkerIcon(marker, settings, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	                if (settings.showLabel) {
	                    marker.set('labelAnchor', new google.maps.Point(100, iconInfo.size[1] + 20));
	                }
	                marker.setMap(gMap.map);
	            });
	
	            if (settings.displayTooltip) {
	                this.createTooltip(marker, settings.tooltipPattern, settings.tooltipReplaceInfo, settings.autocloseTooltip, markerArgs);
	            }
	
	            if (onClickListener) {
	                marker.addListener('click', onClickListener);
	            }
	
	            return marker;
	        }
	    }, {
	        key: "removeMarker",
	        value: function removeMarker(marker) {
	            marker.setMap(null);
	        }
	
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createTooltip",
	        value: function createTooltip(marker, pattern, replaceInfo, autoClose, markerArgs) {
	            var popup = new google.maps.InfoWindow({
	                content: ''
	            });
	            var map = this;
	            marker.addListener('click', function () {
	                if (autoClose) {
	                    map.tooltips.forEach(function (tooltip) {
	                        tooltip.popup.close();
	                    });
	                }
	                popup.open(this.map, marker);
	            });
	            this.tooltips.push({
	                markerArgs: markerArgs,
	                popup: popup,
	                pattern: pattern,
	                replaceInfo: replaceInfo
	            });
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "updatePolylineColor",
	        value: function updatePolylineColor(polyline, settings, color) {
	            var options = {
	                path: polyline.getPath(),
	                strokeColor: color,
	                strokeOpacity: settings.strokeOpacity,
	                strokeWeight: settings.strokeWeight,
	                map: this.map
	            };
	            polyline.setOptions(options);
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createPolyline",
	        value: function createPolyline(locations, settings) {
	            var polyline = new google.maps.Polyline({
	                path: locations,
	                strokeColor: settings.color,
	                strokeOpacity: settings.strokeOpacity,
	                strokeWeight: settings.strokeWeight,
	                map: this.map
	            });
	
	            return polyline;
	        }
	        /* eslint-enable no-undef */
	
	    }, {
	        key: "removePolyline",
	        value: function removePolyline(polyline) {
	            polyline.setMap(null);
	        }
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "fitBounds",
	        value: function fitBounds(bounds) {
	            if (this.dontFitMapBounds && this.defaultZoomLevel) {
	                this.map.setZoom(this.defaultZoomLevel);
	                this.map.setCenter(bounds.getCenter());
	            } else {
	                var tbMap = this;
	                google.maps.event.addListenerOnce(this.map, 'bounds_changed', function () {
	                    // eslint-disable-line no-undef
	                    if (!tbMap.defaultZoomLevel && tbMap.map.getZoom() > tbMap.minZoomLevel) {
	                        tbMap.map.setZoom(tbMap.minZoomLevel);
	                    }
	                });
	                this.map.fitBounds(bounds);
	            }
	        }
	        /* eslint-enable no-undef */
	
	    }, {
	        key: "createLatLng",
	        value: function createLatLng(lat, lng) {
	            return new google.maps.LatLng(lat, lng); // eslint-disable-line no-undef
	        }
	    }, {
	        key: "extendBoundsWithMarker",
	        value: function extendBoundsWithMarker(bounds, marker) {
	            bounds.extend(marker.getPosition());
	        }
	    }, {
	        key: "getMarkerPosition",
	        value: function getMarkerPosition(marker) {
	            return marker.getPosition();
	        }
	    }, {
	        key: "setMarkerPosition",
	        value: function setMarkerPosition(marker, latLng) {
	            marker.setPosition(latLng);
	        }
	    }, {
	        key: "getPolylineLatLngs",
	        value: function getPolylineLatLngs(polyline) {
	            return polyline.getPath().getArray();
	        }
	    }, {
	        key: "setPolylineLatLngs",
	        value: function setPolylineLatLngs(polyline, latLngs) {
	            polyline.setPath(latLngs);
	        }
	    }, {
	        key: "createBounds",
	        value: function createBounds() {
	            return new google.maps.LatLngBounds(); // eslint-disable-line no-undef
	        }
	    }, {
	        key: "extendBounds",
	        value: function extendBounds(bounds, polyline) {
	            if (polyline && polyline.getPath()) {
	                var locations = polyline.getPath();
	                for (var i = 0; i < locations.getLength(); i++) {
	                    bounds.extend(locations.getAt(i));
	                }
	            }
	        }
	    }, {
	        key: "invalidateSize",
	        value: function invalidateSize() {
	            google.maps.event.trigger(this.map, "resize"); // eslint-disable-line no-undef
	        }
	    }, {
	        key: "getTooltips",
	        value: function getTooltips() {
	            return this.tooltips;
	        }
	    }]);
	
	    return TbGoogleMap;
	}();
	
	exports.default = TbGoogleMap;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	__webpack_require__(310);
	
	var _leaflet = __webpack_require__(197);
	
	var L = _interopRequireWildcard(_leaflet);
	
	__webpack_require__(891);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TbOpenStreetMap = function () {
	    function TbOpenStreetMap($containerElement, utils, initCallback, defaultZoomLevel, dontFitMapBounds, minZoomLevel, mapProvider) {
	        _classCallCheck(this, TbOpenStreetMap);
	
	        this.utils = utils;
	        this.defaultZoomLevel = defaultZoomLevel;
	        this.dontFitMapBounds = dontFitMapBounds;
	        this.minZoomLevel = minZoomLevel;
	        this.tooltips = [];
	
	        if (!mapProvider) {
	            mapProvider = "OpenStreetMap.Mapnik";
	        }
	
	        this.map = L.map($containerElement[0]).setView([0, 0], this.defaultZoomLevel || 8);
	
	        var tileLayer = L.tileLayer.provider(mapProvider);
	
	        tileLayer.addTo(this.map);
	
	        if (initCallback) {
	            setTimeout(initCallback, 0); //eslint-disable-line
	        }
	    }
	
	    _createClass(TbOpenStreetMap, [{
	        key: 'inited',
	        value: function inited() {
	            return angular.isDefined(this.map);
	        }
	    }, {
	        key: 'updateMarkerLabel',
	        value: function updateMarkerLabel(marker, settings) {
	            marker.unbindTooltip();
	            marker.bindTooltip('<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>', { className: 'tb-marker-label', permanent: true, direction: 'top', offset: marker.tooltipOffset });
	        }
	    }, {
	        key: 'updateMarkerColor',
	        value: function updateMarkerColor(marker, color) {
	            this.createDefaultMarkerIcon(marker, color, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	            });
	        }
	    }, {
	        key: 'updateMarkerIcon',
	        value: function updateMarkerIcon(marker, settings) {
	            this.createMarkerIcon(marker, settings, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	                if (settings.showLabel) {
	                    marker.unbindTooltip();
	                    marker.tooltipOffset = [0, -iconInfo.size[1] + 10];
	                    marker.bindTooltip('<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>', { className: 'tb-marker-label', permanent: true, direction: 'top', offset: marker.tooltipOffset });
	                }
	            });
	        }
	    }, {
	        key: 'createMarkerIcon',
	        value: function createMarkerIcon(marker, settings, onMarkerIconReady) {
	            var currentImage = settings.currentImage;
	            var opMap = this;
	            if (currentImage && currentImage.url) {
	                this.utils.loadImageAspect(currentImage.url).then(function (aspect) {
	                    if (aspect) {
	                        var width;
	                        var height;
	                        if (aspect > 1) {
	                            width = currentImage.size;
	                            height = currentImage.size / aspect;
	                        } else {
	                            width = currentImage.size * aspect;
	                            height = currentImage.size;
	                        }
	                        var icon = L.icon({
	                            iconUrl: currentImage.url,
	                            iconSize: [width, height],
	                            iconAnchor: [width / 2, height],
	                            popupAnchor: [0, -height]
	                        });
	                        var iconInfo = {
	                            size: [width, height],
	                            icon: icon
	                        };
	                        onMarkerIconReady(iconInfo);
	                    } else {
	                        opMap.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
	                    }
	                });
	            } else {
	                this.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
	            }
	        }
	    }, {
	        key: 'createDefaultMarkerIcon',
	        value: function createDefaultMarkerIcon(marker, color, onMarkerIconReady) {
	            var pinColor = color.substr(1);
	            var icon = L.icon({
	                iconUrl: 'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|' + pinColor,
	                iconSize: [21, 34],
	                iconAnchor: [10, 34],
	                popupAnchor: [0, -34],
	                shadowUrl: 'https://chart.apis.google.com/chart?chst=d_map_pin_shadow',
	                shadowSize: [40, 37],
	                shadowAnchor: [12, 35]
	            });
	            var iconInfo = {
	                size: [21, 34],
	                icon: icon
	            };
	            onMarkerIconReady(iconInfo);
	        }
	    }, {
	        key: 'createMarker',
	        value: function createMarker(location, settings, onClickListener, markerArgs) {
	            var marker = L.marker(location, {});
	            var opMap = this;
	            this.createMarkerIcon(marker, settings, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	                if (settings.showLabel) {
	                    marker.tooltipOffset = [0, -iconInfo.size[1] + 10];
	                    marker.bindTooltip('<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>', { className: 'tb-marker-label', permanent: true, direction: 'top', offset: marker.tooltipOffset });
	                }
	                marker.addTo(opMap.map);
	            });
	
	            if (settings.displayTooltip) {
	                this.createTooltip(marker, settings.tooltipPattern, settings.tooltipReplaceInfo, settings.autocloseTooltip, markerArgs);
	            }
	
	            if (onClickListener) {
	                marker.on('click', onClickListener);
	            }
	
	            return marker;
	        }
	    }, {
	        key: 'removeMarker',
	        value: function removeMarker(marker) {
	            this.map.removeLayer(marker);
	        }
	    }, {
	        key: 'createTooltip',
	        value: function createTooltip(marker, pattern, replaceInfo, autoClose, markerArgs) {
	            var popup = L.popup();
	            popup.setContent('');
	            marker.bindPopup(popup, { autoClose: autoClose, closeOnClick: false });
	            this.tooltips.push({
	                markerArgs: markerArgs,
	                popup: popup,
	                pattern: pattern,
	                replaceInfo: replaceInfo
	            });
	        }
	    }, {
	        key: 'updatePolylineColor',
	        value: function updatePolylineColor(polyline, settings, color) {
	            var style = {
	                color: color,
	                opacity: settings.strokeOpacity,
	                weight: settings.strokeWeight
	            };
	            polyline.setStyle(style);
	        }
	    }, {
	        key: 'createPolyline',
	        value: function createPolyline(locations, settings) {
	            var polyline = L.polyline(locations, {
	                color: settings.color,
	                opacity: settings.strokeOpacity,
	                weight: settings.strokeWeight
	            }).addTo(this.map);
	            return polyline;
	        }
	    }, {
	        key: 'removePolyline',
	        value: function removePolyline(polyline) {
	            this.map.removeLayer(polyline);
	        }
	    }, {
	        key: 'fitBounds',
	        value: function fitBounds(bounds) {
	            if (bounds.isValid()) {
	                if (this.dontFitMapBounds && this.defaultZoomLevel) {
	                    this.map.setZoom(this.defaultZoomLevel, { animate: false });
	                    this.map.panTo(bounds.getCenter(), { animate: false });
	                } else {
	                    var tbMap = this;
	                    this.map.once('zoomend', function () {
	                        if (!tbMap.defaultZoomLevel && tbMap.map.getZoom() > tbMap.minZoomLevel) {
	                            tbMap.map.setZoom(tbMap.minZoomLevel, { animate: false });
	                        }
	                    });
	                    this.map.fitBounds(bounds, { padding: [50, 50], animate: false });
	                }
	            }
	        }
	    }, {
	        key: 'createLatLng',
	        value: function createLatLng(lat, lng) {
	            return L.latLng(lat, lng);
	        }
	    }, {
	        key: 'extendBoundsWithMarker',
	        value: function extendBoundsWithMarker(bounds, marker) {
	            bounds.extend(marker.getLatLng());
	        }
	    }, {
	        key: 'getMarkerPosition',
	        value: function getMarkerPosition(marker) {
	            return marker.getLatLng();
	        }
	    }, {
	        key: 'setMarkerPosition',
	        value: function setMarkerPosition(marker, latLng) {
	            marker.setLatLng(latLng);
	        }
	    }, {
	        key: 'getPolylineLatLngs',
	        value: function getPolylineLatLngs(polyline) {
	            return polyline.getLatLngs();
	        }
	    }, {
	        key: 'setPolylineLatLngs',
	        value: function setPolylineLatLngs(polyline, latLngs) {
	            polyline.setLatLngs(latLngs);
	        }
	    }, {
	        key: 'createBounds',
	        value: function createBounds() {
	            return L.latLngBounds();
	        }
	    }, {
	        key: 'extendBounds',
	        value: function extendBounds(bounds, polyline) {
	            if (polyline && polyline.getLatLngs()) {
	                bounds.extend(polyline.getBounds());
	            }
	        }
	    }, {
	        key: 'invalidateSize',
	        value: function invalidateSize() {
	            this.map.invalidateSize(true);
	        }
	    }, {
	        key: 'getTooltips',
	        value: function getTooltips() {
	            return this.tooltips;
	        }
	    }]);
	
	    return TbOpenStreetMap;
	}();
	
	exports.default = TbOpenStreetMap;

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.processPattern = processPattern;
	exports.fillPattern = fillPattern;
	exports.fillPatternWithActions = fillPatternWithActions;
	exports.toLabelValueMap = toLabelValueMap;
	exports.isNumber = isNumber;
	exports.padValue = padValue;
	exports.arraysEqual = arraysEqual;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var varsRegex = /\$\{([^\}]*)\}/g;
	
	var linkActionRegex = /\<link-act name=['"]([^['"]*)['"]\>([^\<]*)\<\/link-act\>/g;
	var buttonActionRegex = /\<button-act name=['"]([^['"]*)['"]\>([^\<]*)\<\/button-act\>/g;
	
	function processPattern(pattern, datasources, dsIndex) {
	    var match = varsRegex.exec(pattern);
	    var replaceInfo = {};
	    replaceInfo.variables = [];
	    while (match !== null) {
	        var variableInfo = {};
	        variableInfo.dataKeyIndex = -1;
	        var variable = match[0];
	        var label = match[1];
	        var valDec = 2;
	        var splitVals = label.split(':');
	        if (splitVals.length > 1) {
	            label = splitVals[0];
	            valDec = parseFloat(splitVals[1]);
	        }
	        variableInfo.variable = variable;
	        variableInfo.valDec = valDec;
	
	        var keyIndex = -1;
	
	        if (label.startsWith('#')) {
	            var keyIndexStr = label.substring(1);
	            var n = Math.floor(Number(keyIndexStr));
	            if (String(n) === keyIndexStr && n >= 0) {
	                keyIndex = n;
	            }
	        }
	        var offset = 0;
	        for (var i = 0; i < datasources.length; i++) {
	            var datasource = datasources[i];
	            if (dsIndex == i) {
	                if (keyIndex > -1) {
	                    if (keyIndex < datasource.dataKeys.length) {
	                        variableInfo.dataKeyIndex = offset + keyIndex;
	                    }
	                } else {
	                    for (var k = 0; k < datasource.dataKeys.length; k++) {
	                        var dataKey = datasource.dataKeys[k];
	                        if (dataKey.label === label) {
	                            variableInfo.dataKeyIndex = offset + k;
	                            break;
	                        }
	                    }
	                }
	            }
	            offset += datasource.dataKeys.length;
	        }
	        replaceInfo.variables.push(variableInfo);
	        match = varsRegex.exec(pattern);
	    }
	    return replaceInfo;
	}
	
	function fillPattern(pattern, replaceInfo, data) {
	    var text = angular.copy(pattern);
	    for (var v = 0; v < replaceInfo.variables.length; v++) {
	        var variableInfo = replaceInfo.variables[v];
	        var txtVal = '';
	        if (variableInfo.dataKeyIndex > -1 && data[variableInfo.dataKeyIndex]) {
	            var varData = data[variableInfo.dataKeyIndex].data;
	            if (varData.length > 0) {
	                var val = varData[varData.length - 1][1];
	                if (isNumber(val)) {
	                    txtVal = padValue(val, variableInfo.valDec, 0);
	                } else {
	                    txtVal = val;
	                }
	            }
	        }
	        text = text.split(variableInfo.variable).join(txtVal);
	    }
	    return text;
	}
	
	function createLink(actionName, actionText, actionCallbackName, additionalArgs) {
	    var args = 'event,\'' + actionName + '\'';
	    if (additionalArgs && additionalArgs.length) {
	        args += ',' + additionalArgs.join();
	    }
	    return '<a href="#" onclick="angular.element(this).scope().' + actionCallbackName + '(' + args + '); return false;">' + actionText + '</a>';
	}
	
	function createButton(actionName, actionText, actionCallbackName, additionalArgs) {
	    var args = 'event,\'' + actionName + '\'';
	    if (additionalArgs && additionalArgs.length) {
	        args += ',' + additionalArgs.join();
	    }
	    return '<button onclick="angular.element(this).scope().' + actionCallbackName + '(' + args + '); return false;">' + actionText + '</button>';
	}
	
	function fillPatternWithActions(pattern, actionCallbackName, additionalArgs) {
	    var text = angular.copy(pattern);
	    var match = linkActionRegex.exec(pattern);
	    var actionTags;
	    var actionName;
	    var actionText;
	    var actionHtml;
	    while (match !== null) {
	        actionTags = match[0];
	        actionName = match[1];
	        actionText = match[2];
	        actionHtml = createLink(actionName, actionText, actionCallbackName, additionalArgs);
	        text = text.split(actionTags).join(actionHtml);
	        match = linkActionRegex.exec(pattern);
	    }
	    match = buttonActionRegex.exec(pattern);
	    while (match !== null) {
	        actionTags = match[0];
	        actionName = match[1];
	        actionText = match[2];
	        actionHtml = createButton(actionName, actionText, actionCallbackName, additionalArgs);
	        text = text.split(actionTags).join(actionHtml);
	        match = buttonActionRegex.exec(pattern);
	    }
	    return text;
	}
	
	function toLabelValueMap(data, datasources) {
	    var dataMap = {};
	    var dsDataMap = [];
	    for (var d = 0; d < datasources.length; d++) {
	        dsDataMap[d] = {};
	    }
	    for (var i = 0; i < data.length; i++) {
	        var dataKey = data[i].dataKey;
	        var label = dataKey.label;
	        var keyData = data[i].data;
	        var ts = null;
	        var val = null;
	        if (keyData.length > 0) {
	            ts = keyData[keyData.length - 1][0];
	            val = keyData[keyData.length - 1][1];
	        }
	        dataMap[label + '|ts'] = ts;
	        dataMap[label] = val;
	        var dsIndex = datasources.indexOf(data[i].datasource);
	        dsDataMap[dsIndex][label + '|ts'] = ts;
	        dsDataMap[dsIndex][label] = val;
	    }
	    return {
	        dataMap: dataMap,
	        dsDataMap: dsDataMap
	    };
	}
	
	function isNumber(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	function padValue(val, dec, int) {
	    var i = 0;
	    var s, strVal, n;
	
	    val = parseFloat(val);
	    n = val < 0;
	    val = Math.abs(val);
	
	    if (dec > 0) {
	        strVal = val.toFixed(dec).toString().split('.');
	        s = int - strVal[0].length;
	
	        for (; i < s; ++i) {
	            strVal[0] = '0' + strVal[0];
	        }
	
	        strVal = (n ? '-' : '') + strVal[0] + '.' + strVal[1];
	    } else {
	        strVal = Math.round(val).toString();
	        s = int - strVal.length;
	
	        for (; i < s; ++i) {
	            strVal = '0' + strVal;
	        }
	
	        strVal = (n ? '-' : '') + strVal;
	    }
	
	    return strVal;
	}
	
	function arraysEqual(a, b) {
	    if (a === b) return true;
	    if (a === null || b === null) return false;
	    if (a.length != b.length) return false;
	
	    for (var i = 0; i < a.length; ++i) {
	        if (!a[i].equals(b[i])) return false;
	    }
	    return true;
	}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	var path = 'alarm/alarm-details-dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'alarm.alarm-details' | translate }}\"> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>alarm.alarm-details</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.close()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content layout=column> <div layout=row> <md-input-container class=md-block> <label translate>alarm.created-time</label> <input ng-model=vm.createdTime readonly=readonly> </md-input-container> <md-input-container flex class=md-block> <label translate>alarm.originator</label> <input ng-model=vm.alarm.originatorName readonly=readonly> </md-input-container> </div> <div layout=row ng-if=\"vm.startTime || vm.endTime\"> <md-input-container ng-if=vm.startTime flex class=md-block> <label translate>alarm.start-time</label> <input ng-model=vm.startTime readonly=readonly> </md-input-container> <md-input-container ng-if=vm.endTime flex class=md-block> <label translate>alarm.end-time</label> <input ng-model=vm.endTime readonly=readonly> </md-input-container> <span flex ng-if=\"!vm.startTime || !vm.endTime\"></span> </div> <div layout=row ng-if=\"vm.ackTime || vm.clearTime\"> <md-input-container ng-if=vm.ackTime flex class=md-block> <label translate>alarm.ack-time</label> <input ng-model=vm.ackTime readonly=readonly> </md-input-container> <md-input-container ng-if=vm.clearTime flex class=md-block> <label translate>alarm.clear-time</label> <input ng-model=vm.clearTime readonly=readonly> </md-input-container> <span flex ng-if=\"!vm.ackTime || !vm.clearTime\"></span> </div> <div layout=row> <md-input-container flex class=md-block> <label translate>alarm.type</label> <input ng-model=vm.alarm.type readonly=readonly> </md-input-container> <md-input-container flex class=md-block> <label translate>alarm.severity</label> <input class=tb-severity ng-class=vm.types.alarmSeverity[vm.alarm.severity].class ng-model=vm.alarmSeverity readonly=readonly> </md-input-container> <md-input-container flex class=md-block> <label translate>alarm.status</label> <input ng-model=vm.alarmStatus readonly=readonly> </md-input-container> </div> <div ng-show=vm.displayDetails class=md-caption style=padding-left:3px;padding-bottom:10px;color:rgba(0,0,0,.57) translate>alarm.details</div> <div ng-show=vm.displayDetails flex class=tb-alarm-details-panel layout=column> <div flex id=tb-alarm-details readonly=readonly ui-ace=vm.alarmDetailsOptions ng-model=vm.alarmDetails> </div> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-if=\"vm.allowAcknowledgment && (vm.alarm.status==vm.types.alarmStatus.activeUnack ||\n                          vm.alarm.status==vm.types.alarmStatus.clearedUnack)\" class=\"md-raised md-primary\" ng-disabled=$root.loading ng-click=vm.acknowledge() style=margin-right:20px>{{ 'alarm.acknowledge' | translate }} </md-button> <md-button ng-if=\"vm.allowClear && (vm.alarm.status==vm.types.alarmStatus.activeAck ||\n                          vm.alarm.status==vm.types.alarmStatus.activeUnack)\" class=\"md-raised md-primary\" ng-disabled=$root.loading ng-click=vm.clear()>{{ 'alarm.clear' | translate }} </md-button> <span flex></span> <md-button ng-disabled=$root.loading ng-click=vm.close() style=margin-right:20px>{{ 'action.close' | translate }} </md-button> </md-dialog-actions> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	var path = 'components/datakey-config-dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'datakey.configuration' | translate }}\" style=width:600px> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>datakey.configuration</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <tb-datakey-config ng-model=vm.dataKey fetch-entity-keys=\"vm.fetchEntityKeys(entityAliasId, query, type)\" entity-alias=vm.entityAlias datakey-settings-schema=vm.dataKeySettingsSchema> </tb-datakey-config> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.save' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	var path = 'dashboard/dashboard-settings.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'dashboard.settings' | translate }}\"> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{vm.settings ? 'dashboard.settings' : 'layout.settings'}}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=$root.loading> <div ng-show=vm.settings> <md-input-container class=md-block> <label translate>dashboard.state-controller</label> <md-select aria-label=\"{{ 'dashboard.state-controller' | translate }}\" ng-model=vm.settings.stateControllerId ng-change=vm.stateControllerIdChanged()> <md-option ng-repeat=\"(stateControllerId, stateController) in vm.stateControllers\" ng-value=stateControllerId> {{stateControllerId}} </md-option> </md-select> </md-input-container> <div layout=row layout-align=\"start center\"> <md-checkbox flex aria-label=\"{{ 'dashboard.toolbar-always-open' | translate }}\" ng-model=vm.settings.toolbarAlwaysOpen>{{ 'dashboard.toolbar-always-open' | translate }} </md-checkbox> <md-checkbox flex aria-label=\"{{ 'dashboard.display-title' | translate }}\" ng-model=vm.settings.showTitle>{{ 'dashboard.display-title' | translate }} </md-checkbox> <div flex ng-required=false md-color-picker ng-model=vm.settings.titleColor label=\"{{ 'dashboard.title-color' | translate }}\" icon=format_color_fill default=\"rgba(0, 0, 0, 0.870588)\" md-color-clear-button=false open-on-input=true md-color-generic-palette=false md-color-history=false></div> </div> <div layout=row layout-align=\"start center\"> <md-checkbox flex aria-label=\"{{ 'dashboard.display-dashboards-selection' | translate }}\" ng-model=vm.settings.showDashboardsSelect>{{ 'dashboard.display-dashboards-selection' | translate }} </md-checkbox> <md-checkbox flex aria-label=\"{{ 'dashboard.display-entities-selection' | translate }}\" ng-model=vm.settings.showEntitiesSelect>{{ 'dashboard.display-entities-selection' | translate }} </md-checkbox> <md-checkbox flex aria-label=\"{{ 'dashboard.display-dashboard-timewindow' | translate }}\" ng-model=vm.settings.showDashboardTimewindow>{{ 'dashboard.display-dashboard-timewindow' | translate }} </md-checkbox> <md-checkbox flex aria-label=\"{{ 'dashboard.display-dashboard-export' | translate }}\" ng-model=vm.settings.showDashboardExport>{{ 'dashboard.display-dashboard-export' | translate }} </md-checkbox> </div> </div> <div ng-show=vm.gridSettings> <div flex ng-required=false md-color-picker ng-model=vm.gridSettings.color label=\"{{ 'layout.color' | translate }}\" icon=format_color_fill default=\"rgba(0, 0, 0, 0.870588)\" md-color-clear-button=false open-on-input=true md-color-generic-palette=false md-color-history=false></div> <md-input-container class=md-block> <label translate>dashboard.columns-count</label> <input ng-required=vm.gridSettings type=number step=any name=columns ng-model=vm.gridSettings.columns min=10 max=1000> <div ng-messages=theForm.columns.$error multiple=multiple md-auto-hide=false> <div ng-message=required translate>dashboard.columns-count-required</div> <div ng-message=min translate>dashboard.min-columns-count-message</div> <div ng-message=max>dashboard.max-columns-count-message</div> </div> </md-input-container> <small translate>dashboard.widgets-margins</small> <div flex layout=row> <md-input-container flex class=md-block> <label translate>dashboard.horizontal-margin</label> <input ng-required=vm.gridSettings type=number step=any name=hMargin ng-model=vm.hMargin min=0 max=50> <div ng-messages=theForm.hMargin.$error multiple=multiple md-auto-hide=false> <div ng-message=required translate>dashboard.horizontal-margin-required</div> <div ng-message=min translate>dashboard.min-horizontal-margin-message</div> <div ng-message=max translate>dashboard.max-horizontal-margin-message</div> </div> </md-input-container> <md-input-container flex class=md-block> <label translate>dashboard.vertical-margin</label> <input ng-required=vm.gridSettings type=number step=any name=vMargin ng-model=vm.vMargin min=0 max=50> <div ng-messages=theForm.vMargin.$error multiple=multiple md-auto-hide=false> <div ng-message=required translate>dashboard.vertical-margin-required</div> <div ng-message=min translate>dashboard.min-vertical-margin-message</div> <div ng-message=max translate>dashboard.max-vertical-margin-message</div> </div> </md-input-container> </div> <md-checkbox flex aria-label=\"{{ 'dashboard.autofill-height' | translate }}\" ng-model=vm.gridSettings.autoFillHeight>{{ 'dashboard.autofill-height' | translate }} </md-checkbox> <div flex ng-required=false md-color-picker ng-model=vm.gridSettings.backgroundColor label=\"{{ 'dashboard.background-color' | translate }}\" icon=format_color_fill default=rgba(0,0,0,0) md-color-clear-button=false open-on-input=true md-color-generic-palette=false md-color-history=false></div> <div class=tb-container> <label class=tb-label translate>dashboard.background-image</label> <div flow-init={singleFile:true} flow-file-added=\"vm.imageAdded( $file )\" class=tb-image-select-container> <div class=tb-image-preview-container> <div ng-show=!vm.gridSettings.backgroundImageUrl translate>dashboard.no-image</div> <img ng-show=vm.gridSettings.backgroundImageUrl class=tb-image-preview src={{vm.gridSettings.backgroundImageUrl}}> </div> <div class=tb-image-clear-container> <md-button ng-click=vm.clearImage() class=\"tb-image-clear-btn md-icon-button md-primary\" aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.remove' | translate }}\" class=material-icons> close </md-icon> </md-button> </div> <div class=\"alert tb-flow-drop\" flow-drop> <label for=select translate>dashboard.drop-image</label> <input class=file-input flow-btn flow-attrs=\"{accept:'image/*'}\" id=select> </div> </div> </div> <md-input-container class=md-block> <label translate>dashboard.background-size-mode</label> <md-select ng-model=vm.gridSettings.backgroundSizeMode placeholder=\"{{ 'dashboard.background-size-mode' | translate }}\"> <md-option value=100%>Fit width</md-option> <md-option value=\"auto 100%\">Fit height</md-option> <md-option value=cover>Cover</md-option> <md-option value=contain>Contain</md-option> <md-option value=auto>Original size</md-option> </md-select> </md-input-container> <small translate>dashboard.mobile-layout</small> <div flex layout=row layout-align=\"start center\"> <md-checkbox flex aria-label=\"{{ 'dashboard.autofill-height' | translate }}\" ng-model=vm.gridSettings.mobileAutoFillHeight>{{ 'dashboard.autofill-height' | translate }} </md-checkbox> <md-input-container flex class=md-block> <label translate>dashboard.mobile-row-height</label> <input ng-required=vm.gridSettings type=number step=any name=mobileRowHeight ng-model=vm.gridSettings.mobileRowHeight min=5 max=200> <div ng-messages=theForm.mobileRowHeight.$error multiple=multiple md-auto-hide=false> <div ng-message=required translate>dashboard.mobile-row-height-required</div> <div ng-message=min translate>dashboard.min-mobile-row-height-message</div> <div ng-message=max translate>dashboard.max-mobile-row-height-message</div> </div> </md-input-container> </div> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || !theForm.$dirty || !theForm.$valid\" type=submit class=\"md-raised md-primary\"> {{ 'action.save' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	var path = 'dashboard/dashboard.tpl.html';
	var html = " <md-content style=padding-top:150px flex tb-expand-fullscreen=\"vm.widgetEditMode || vm.iframeMode || forceFullscreen\" expand-button-id=dashboard-expand-button hide-expand-button=vm.hideFullscreenButton() expand-tooltip-direction=bottom ng-if=vm.dashboard> <section class=tb-dashboard-toolbar ng-show=vm.showDashboardToolbar() ng-class=\"{ 'tb-dashboard-toolbar-opened': vm.toolbarOpened, 'tb-dashboard-toolbar-closed': !vm.toolbarOpened }\"> <tb-dashboard-toolbar ng-show=!vm.widgetEditMode force-fullscreen=forceFullscreen toolbar-opened=vm.toolbarOpened on-trigger-click=vm.openToolbar()> <div class=tb-dashboard-action-panels layout-gt-sm=row layout-align-gt-sm=\"space-between center\" layout=column layout-align=\"center stretch\"> <div class=tb-dashboard-action-panel flex-md=30 layout=row layout-align-gt-sm=\"start center\" layout-align=\"space-between center\"> <md-button ng-show=vm.showCloseToolbar() aria-label=close-toolbar class=\"md-icon-button close-action\" ng-click=vm.closeToolbar()> <md-tooltip md-direction=bottom> {{ 'dashboard.close-toolbar' | translate }} </md-tooltip> <md-icon aria-label=close-toolbar class=material-icons>arrow_forward</md-icon> </md-button> <tb-user-menu ng-if=\"!vm.isPublicUser() && forceFullscreen\" hide-xs hide-sm display-user-info=true> </tb-user-menu> <md-button ng-show=vm.showRightLayoutSwitch() aria-label=switch-layouts class=md-icon-button ng-click=vm.toggleLayouts()> <ng-md-icon icon=\"{{vm.isRightLayoutOpened ? 'arrow_back' : 'menu'}}\" options='{\"easing\": \"circ-in-out\", \"duration\": 375, \"rotation\": \"none\"}'></ng-md-icon> <md-tooltip md-direction=bottom> {{ (vm.isRightLayoutOpened ? 'dashboard.hide-details' : 'dashboard.show-details') | translate }} </md-tooltip> </md-button> <md-button id=dashboard-expand-button aria-label=\"{{ 'fullscreen.fullscreen' | translate }}\" class=md-icon-button> </md-button> <md-button ng-show=\"vm.isEdit || vm.displayExport()\" aria-label=\"{{ 'action.export' | translate }}\" class=md-icon-button ng-click=vm.exportDashboard($event)> <md-tooltip md-direction=bottom> {{ 'dashboard.export' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.export' | translate }}\" class=material-icons>file_download</md-icon> </md-button> <tb-timewindow ng-show=\"vm.isEdit || vm.displayDashboardTimewindow()\" is-toolbar direction=left tooltip-direction=bottom aggregation=true ng-model=vm.dashboardCtx.dashboardTimewindow> </tb-timewindow> <tb-aliases-entity-select ng-show=\"!vm.isEdit && vm.displayEntitiesSelect()\" tooltip-direction=bottom alias-controller=vm.dashboardCtx.aliasController> </tb-aliases-entity-select> <md-button ng-show=vm.isEdit aria-label=\"{{ 'entity.aliases' | translate }}\" class=md-icon-button ng-click=vm.openEntityAliases($event)> <md-tooltip md-direction=bottom> {{ 'entity.aliases' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'entity.aliases' | translate }}\" class=material-icons>devices_other</md-icon> </md-button> <md-button ng-show=vm.isEdit aria-label=\"{{ 'dashboard.settings' | translate }}\" class=md-icon-button ng-click=vm.openDashboardSettings($event)> <md-tooltip md-direction=bottom> {{ 'dashboard.settings' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'dashboard.settings' | translate }}\" class=material-icons>settings</md-icon> </md-button> <tb-dashboard-select ng-show=\"!vm.isEdit && !vm.widgetEditMode && vm.displayDashboardsSelect()\" ng-model=vm.currentDashboardId dashboards-scope={{vm.currentDashboardScope}} customer-id=vm.currentCustomerId> </tb-dashboard-select> </div> <div class=tb-dashboard-action-panel flex-md=70 layout=row layout-align-gt-sm=\"end center\" layout-align=\"space-between center\"> <tb-user-menu ng-if=\"!vm.isPublicUser() && forceFullscreen\" hide-gt-sm display-user-info=true> </tb-user-menu> <div flex-xs flex-sm layout=row layout-align-gt-sm=\"start center\" layout-align=\"space-between center\" ng-show=vm.isEdit> <md-button aria-label=\"{{ 'dashboard.manage-states' | translate }}\" class=md-icon-button ng-click=vm.manageDashboardStates($event)> <md-tooltip md-direction=bottom> {{ 'dashboard.manage-states' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'dashboard.manage-states' | translate }}\" class=material-icons>layers</md-icon> </md-button> <md-button aria-label=\"{{ 'layout.manage' | translate }}\" class=md-icon-button ng-click=vm.manageDashboardLayouts($event)> <md-tooltip md-direction=bottom> {{ 'layout.manage' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'layout.manage' | translate }}\" class=material-icons>view_compact</md-icon> </md-button> </div> <tb-states-component flex-xs flex-sm ng-if=vm.isEdit states-controller-id=\"'default'\" dashboard-ctrl=vm states=vm.dashboardConfiguration.states> </tb-states-component> <tb-states-component flex-xs flex-sm ng-if=!vm.isEdit states-controller-id=vm.dashboardConfiguration.settings.stateControllerId dashboard-ctrl=vm states=vm.dashboardConfiguration.states> </tb-states-component> </div> </div> </tb-dashboard-toolbar> </section> <section class=\"tb-dashboard-container tb-absolute-fill\" ng-class=\"{ 'is-fullscreen': forceFullscreen, 'tb-dashboard-toolbar-opened': vm.toolbarOpened, 'tb-dashboard-toolbar-closed': !vm.toolbarOpened }\"> <section ng-show=\"!$root.loading && vm.dashboardConfigurationError()\" layout-align=\"center center\" ng-style=\"{'color': vm.dashboard.configuration.settings.titleColor}\" ng-class=\"{'tb-padded' : !vm.widgetEditMode}\" style=text-transform:uppercase;display:flex;z-index:1 class=\"md-headline tb-absolute-fill\"> <span translate> dashboard.configuration-error </span> </section> <section ng-if=!vm.widgetEditMode class=tb-dashboard-title layout=row layout-align=\"center center\" ng-style=\"{'color': vm.dashboard.configuration.settings.titleColor}\"> <h3 ng-show=\"!vm.isEdit && vm.displayTitle()\">{{ vm.dashboard.title }}</h3> <md-input-container ng-show=vm.isEdit class=md-block style=height:30px> <label translate ng-style=\"{'color': vm.dashboard.configuration.settings.titleColor}\">dashboard.title</label> <input class=tb-dashboard-title ng-style=\"{'color': vm.dashboard.configuration.settings.titleColor}\" required name=title ng-model=vm.dashboard.title> </md-input-container> </section> <div class=\"tb-absolute-fill tb-dashboard-layouts\" layout=\"{{vm.forceDashboardMobileMode ? 'column' : 'row'}}\" ng-class=\"{ 'tb-padded' : !vm.widgetEditMode && (vm.isEdit || vm.displayTitle()), 'tb-shrinked' : vm.isEditingWidget }\"> <div ng-show=vm.layouts.main.show id=tb-main-layout ng-style=\"{width: vm.mainLayoutWidth(),\n                            height: vm.mainLayoutHeight()}\"> <tb-dashboard-layout layout-ctx=vm.layouts.main.layoutCtx dashboard-ctx=vm.dashboardCtx is-edit=vm.isEdit is-mobile=vm.forceDashboardMobileMode widget-edit-mode=vm.widgetEditMode> </tb-dashboard-layout> </div> <md-sidenav ng-if=vm.layouts.right.show id=tb-right-layout class=md-sidenav-right ng-style=\"{minWidth: vm.rightLayoutWidth(),\n                                   maxWidth: vm.rightLayoutWidth(),\n                                   height: vm.rightLayoutHeight(),\n                                   zIndex: 25}\" md-component-id=right-dashboard-layout aria-label=\"Right dashboard layout\" md-is-open=vm.rightLayoutOpened md-is-locked-open=!vm.isMobile> <tb-dashboard-layout style=height:100% layout-ctx=vm.layouts.right.layoutCtx dashboard-ctx=vm.dashboardCtx is-edit=vm.isEdit is-mobile=vm.forceDashboardMobileMode widget-edit-mode=vm.widgetEditMode> </tb-dashboard-layout> </md-sidenav> </div> <tb-details-sidenav class=tb-widget-details-sidenav header-title={{vm.editingWidget.config.title}} header-subtitle={{vm.editingWidgetSubtitle}} is-read-only=false is-open=vm.isEditingWidget is-always-edit=true on-close-details=vm.onEditWidgetClosed() on-toggle-details-edit-mode=vm.onRevertWidgetEdit(vm.widgetForm) on-apply-details=vm.saveWidget(vm.widgetForm) the-form=vm.widgetForm> <details-buttons tb-help=vm.helpLinkIdForWidgetType() help-container-id=help-container> <div id=help-container></div> </details-buttons> <form name=vm.widgetForm ng-if=vm.isEditingWidget> <tb-edit-widget dashboard=vm.dashboard alias-controller=vm.dashboardCtx.aliasController widget-edit-mode=vm.widgetEditMode widget=vm.editingWidget widget-layout=vm.editingWidgetLayout the-form=vm.widgetForm> </tb-edit-widget> </form> </tb-details-sidenav> <tb-details-sidenav ng-if=!vm.widgetEditMode class=tb-select-widget-sidenav header-title=\"{{'dashboard.select-widget-title' | translate}}\" header-height-px=120 is-read-only=true is-open=vm.isAddingWidget is-edit=false on-close-details=vm.onAddWidgetClosed()> <header-pane ng-if=vm.isAddingWidget> <div layout=row> <span class=tb-details-subtitle>{{ 'widgets-bundle.current' | translate }}</span> <tb-widgets-bundle-select flex-offset=5 flex ng-model=vm.widgetsBundle tb-required=true select-first-bundle=false> </tb-widgets-bundle-select> </div> </header-pane> <div ng-if=vm.isAddingWidget> <md-tabs ng-if=\"vm.timeseriesWidgetTypes.length > 0 || vm.latestWidgetTypes.length > 0 ||\n                                vm.rpcWidgetTypes.length > 0 || vm.alarmWidgetTypes.length > 0 ||\n                                vm.staticWidgetTypes.length > 0\" flex class=tb-absolute-fill md-border-bottom> <md-tab ng-if=\"vm.timeseriesWidgetTypes.length > 0\" style=height:100% label=\"{{ 'widget.timeseries' | translate }}\"> <tb-dashboard alias-controller=vm.dashboardCtx.aliasController widgets=vm.timeseriesWidgetTypes is-edit=false is-mobile=true is-edit-action-enabled=false is-remove-action-enabled=false on-widget-clicked=\"vm.addWidgetFromType(event, widget)\"> </tb-dashboard> </md-tab> <md-tab ng-if=\"vm.latestWidgetTypes.length > 0\" style=height:100% label=\"{{ 'widget.latest-values' | translate }}\"> <tb-dashboard alias-controller=vm.dashboardCtx.aliasController widgets=vm.latestWidgetTypes is-edit=false is-mobile=true is-edit-action-enabled=false is-remove-action-enabled=false on-widget-clicked=\"vm.addWidgetFromType(event, widget)\"> </tb-dashboard> </md-tab> <md-tab ng-if=\"vm.rpcWidgetTypes.length > 0\" style=height:100% label=\"{{ 'widget.rpc' | translate }}\"> <tb-dashboard alias-controller=vm.dashboardCtx.aliasController widgets=vm.rpcWidgetTypes is-edit=false is-mobile=true is-edit-action-enabled=false is-remove-action-enabled=false on-widget-clicked=\"vm.addWidgetFromType(event, widget)\"> </tb-dashboard> </md-tab> <md-tab ng-if=\"vm.alarmWidgetTypes.length > 0\" style=height:100% label=\"{{ 'widget.alarm' | translate }}\"> <tb-dashboard alias-controller=vm.dashboardCtx.aliasController widgets=vm.alarmWidgetTypes is-edit=false is-mobile=true is-edit-action-enabled=false is-remove-action-enabled=false on-widget-clicked=\"vm.addWidgetFromType(event, widget)\"> </tb-dashboard> </md-tab> <md-tab ng-if=\"vm.staticWidgetTypes.length > 0\" style=height:100% label=\"{{ 'widget.static' | translate }}\"> <tb-dashboard alias-controller=vm.dashboardCtx.aliasController widgets=vm.staticWidgetTypes is-edit=false is-mobile=true is-edit-action-enabled=false is-remove-action-enabled=false on-widget-clicked=\"vm.addWidgetFromType(event, widget)\"> </tb-dashboard> </md-tab> </md-tabs> <span translate ng-if=\"vm.timeseriesWidgetTypes.length === 0 && vm.latestWidgetTypes.length === 0 &&\n                                       vm.rpcWidgetTypes.length === 0 && vm.alarmWidgetTypes.length === 0 &&\n                                       vm.staticWidgetTypes.length === 0 && vm.widgetsBundle\" layout-align=\"center center\" style=text-transform:uppercase;display:flex class=\"md-headline tb-absolute-fill\">widgets-bundle.empty</span> <span translate ng-if=!vm.widgetsBundle layout-align=\"center center\" style=text-transform:uppercase;display:flex class=\"md-headline tb-absolute-fill\">widget.select-widgets-bundle</span> </div> </tb-details-sidenav> <section layout=row layout-wrap class=\"tb-footer-buttons md-fab\" layout-align=\"start end\"> <md-fab-speed-dial ng-disabled=$root.loading ng-show=\"!vm.isAddingWidget && vm.isEdit && !vm.widgetEditMode\" md-open=vm.addItemActionsOpen class=md-scale md-direction=up> <md-fab-trigger> <md-button ng-disabled=$root.loading class=\"tb-btn-footer md-accent md-hue-2 md-fab\" aria-label=\"{{ 'dashboard.add-widget' | translate }}\"> <md-tooltip md-direction=top> {{ 'dashboard.add-widget' | translate }} </md-tooltip> <ng-md-icon icon=add></ng-md-icon> </md-button> </md-fab-trigger> <md-fab-actions> <md-button ng-disabled=$root.loading class=\"tmd-accent md-hue-2 md-fab\" ng-click=vm.addWidget($event) aria-label=\"{{ 'action.create' | translate }}\"> <md-tooltip md-direction=top> {{ 'dashboard.create-new-widget' | translate }} </md-tooltip> <ng-md-icon icon=insert_drive_file></ng-md-icon> </md-button> <md-button ng-disabled=$root.loading class=\"tmd-accent md-hue-2 md-fab\" ng-click=vm.importWidget($event) aria-label=\"{{ 'action.import' | translate }}\"> <md-tooltip md-direction=top> {{ 'dashboard.import-widget' | translate }} </md-tooltip> <ng-md-icon icon=file_upload></ng-md-icon> </md-button> </md-fab-actions> </md-fab-speed-dial> <md-button ng-if=\"(vm.isTenantAdmin() || vm.isSystemAdmin()) && !forceFullscreen\" ng-show=\"vm.isEdit && !vm.isAddingWidget && !$root.loading\" ng-disabled=$root.loading class=\"tb-btn-footer md-accent md-hue-2 md-fab\" aria-label=\"{{ 'action.apply' | translate }}\" ng-click=vm.saveDashboard()> <md-tooltip md-direction=top> {{ 'action.apply-changes' | translate }} </md-tooltip> <ng-md-icon icon=done></ng-md-icon> </md-button> <md-button ng-show=\"!vm.isAddingWidget && !$root.loading\" ng-if=\"(vm.isTenantAdmin() || vm.isSystemAdmin()) && !forceFullscreen\" ng-disabled=$root.loading class=\"tb-btn-footer md-accent md-hue-2 md-fab\" aria-label=\"{{ 'action.edit-mode' | translate }}\" ng-click=vm.toggleDashboardEditMode()> <md-tooltip md-direction=top> {{ (vm.isEdit ? 'action.decline-changes' : 'action.enter-edit-mode') | translate }} </md-tooltip> <ng-md-icon icon=\"{{vm.isEdit ? 'close' : 'edit'}}\" options='{\"easing\": \"circ-in-out\", \"duration\": 375, \"rotation\": \"none\"}'></ng-md-icon> </md-button> </section> </section> <section class=tb-powered-by-footer ng-style=\"{'color': vm.dashboard.configuration.settings.titleColor}\"> <span>Powered by <a href=https://thingsboard.io target=_blank>Thingsboard v.{{ vm.thingsboardVersion }}</a></span> </section> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	var path = 'dashboard/layouts/select-target-layout.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'layout.select' | translate }}\"> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{ 'layout.select' }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=$root.loading> <div layout=row layout-align=\"start center\"> <md-button flex class=\"tb-layout-button md-raised md-primary\" layout=column ng-click=\"vm.selectLayout($event, 'main')\"> <span translate>layout.main</span> </md-button> <md-button flex class=\"tb-layout-button md-raised md-primary\" layout=column ng-click=\"vm.selectLayout($event, 'right')\"> <span translate>layout.right</span> </md-button> </div> </fieldset> </div> </md-dialog-content> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	var path = 'entity/alias/entity-aliases.tpl.html';
	var html = " <md-dialog class=tb-aliases-dialog style=width:700px aria-label=\"{{ vm.title | translate }}\"> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2>{{ vm.title | translate }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <div class=tb-aliases-header flex layout=row layout-align=\"start center\"> <span flex=5></span> <div flex layout=row layout-align=\"start center\"> <span class=tb-header-label translate flex=20 style=min-width:150px>alias.name</span> <span class=tb-header-label translate flex=70 style=padding-left:10px>alias.entity-filter</span> <span class=tb-header-label translate flex=10 style=padding-left:10px;min-width:120px>alias.resolve-multiple</span> <span style=min-width:80px></span> </div> </div> <md-divider></md-divider> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=$root.loading> <div ng-form name=aliasForm flex layout=row layout-align=\"start center\" ng-repeat=\"entityAlias in vm.entityAliases track by $index\"> <span flex=5>{{$index + 1}}.</span> <div class=\"md-whiteframe-4dp tb-alias\" flex layout=row layout-align=\"start center\"> <md-input-container flex=20 style=min-width:150px md-no-float class=md-block> <input required name=alias placeholder=\"{{ 'entity.alias' | translate }}\" ng-model=entityAlias.alias> <div ng-messages=aliasForm.alias.$error> <div translate ng-message=required>entity.alias-required</div> </div> </md-input-container> <tb-entity-filter-view flex=70 style=padding-left:10px ng-model=entityAlias.filter> </tb-entity-filter-view> <section flex=10 style=padding-left:10px;min-width:120px class=tb-resolve-multiple-switch layout=column layout-align=\"center center\"> <md-switch class=resolve-multiple-switch ng-model=entityAlias.filter.resolveMultiple aria-label=resolve-multiple-switcher> </md-switch> </section> <md-button ng-disabled=$root.loading class=\"md-icon-button md-primary\" style=min-width:40px ng-click=\"vm.editAlias($event, entityAlias)\" aria-label=\"{{ 'action.edit' | translate }}\"> <md-tooltip md-direction=top> {{ 'alias.edit' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'alias.edit' | translate }}\" class=material-icons> edit </md-icon> </md-button> <md-button ng-disabled=$root.loading class=\"md-icon-button md-primary\" style=min-width:40px ng-click=\"vm.removeAlias($event, entityAlias)\" aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'entity.remove-alias' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.delete' | translate }}\" class=material-icons> close </md-icon> </md-button> </div> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-show=!vm.disableAdd ng-disabled=$root.loading class=\"md-primary md-raised\" ng-click=vm.addAlias($event) aria-label=\"{{ 'alias.add' | translate }}\"> <md-tooltip md-direction=top> {{ 'alias.add' | translate }} </md-tooltip> <span translate>alias.add</span> </md-button> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.save' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	var path = 'user/activation-link.dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'user.activation-link' | translate }}\" style=min-width:400px> <form> <md-toolbar> <div class=md-toolbar-tools> <h2 translate=user.activation-link></h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.close()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div id=activation-link-dialog-content class=md-dialog-content> <md-content class=md-padding layout=column> <span translate=user.activation-link-text translate-values=\"{activationLink: vm.activationLink}\"></span> <div layout=row layout-align=\"start center\"> <pre class=tb-highlight flex><code>{{ vm.activationLink }}</code></pre> <md-button class=md-icon-button ngclipboard data-clipboard-text=\"{{ vm.activationLink }}\" ngclipboard-success=vm.onActivationLinkCopied(e)> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <md-tooltip md-direction=top> {{ 'user.copy-activation-link' | translate }} </md-tooltip> </md-button> </div> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-click=vm.close()>{{ 'action.ok' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	var path = 'widget/lib/display-columns-panel.tpl.html';
	var html = " <md-content style=height:100% flex layout=column class=md-padding> <label class=tb-title translate>entity.columns-to-display</label> <md-checkbox aria-label=\"{{ 'entity.columns-to-display' | translate }}\" ng-repeat=\"column in vm.columns\" ng-model=column.display>{{ column.title }} </md-checkbox> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 525 */
/***/ (function(module, exports) {



/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1546).ObjectPath;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var fs = __webpack_require__(525);
	
	function Options(defaults) {
	  var internalValues = {};
	  var values = this.value = {};
	  Object.keys(defaults).forEach(function(key) {
	    internalValues[key] = defaults[key];
	    Object.defineProperty(values, key, {
	      get: function() { return internalValues[key]; },
	      configurable: false,
	      enumerable: true
	    });
	  });
	  this.reset = function() {
	    Object.keys(defaults).forEach(function(key) {
	      internalValues[key] = defaults[key];
	    });
	    return this;
	  };
	  this.merge = function(options, required) {
	    options = options || {};
	    if (Object.prototype.toString.call(required) === '[object Array]') {
	      var missing = [];
	      for (var i = 0, l = required.length; i < l; ++i) {
	        var key = required[i];
	        if (!(key in options)) {
	          missing.push(key);
	        }
	      }
	      if (missing.length > 0) {
	        if (missing.length > 1) {
	          throw new Error('options ' +
	            missing.slice(0, missing.length - 1).join(', ') + ' and ' +
	            missing[missing.length - 1] + ' must be defined');
	        }
	        else throw new Error('option ' + missing[0] + ' must be defined');
	      }
	    }
	    Object.keys(options).forEach(function(key) {
	      if (key in internalValues) {
	        internalValues[key] = options[key];
	      }
	    });
	    return this;
	  };
	  this.copy = function(keys) {
	    var obj = {};
	    Object.keys(defaults).forEach(function(key) {
	      if (keys.indexOf(key) !== -1) {
	        obj[key] = values[key];
	      }
	    });
	    return obj;
	  };
	  this.read = function(filename, cb) {
	    if (typeof cb == 'function') {
	      var self = this;
	      fs.readFile(filename, function(error, data) {
	        if (error) return cb(error);
	        var conf = JSON.parse(data);
	        self.merge(conf);
	        cb();
	      });
	    }
	    else {
	      var conf = JSON.parse(fs.readFileSync(filename));
	      this.merge(conf);
	    }
	    return this;
	  };
	  this.isDefined = function(key) {
	    return typeof values[key] != 'undefined';
	  };
	  this.isDefinedAndNonNull = function(key) {
	    return typeof values[key] != 'undefined' && values[key] !== null;
	  };
	  Object.freeze(values);
	  Object.freeze(this);
	}
	
	module.exports = Options;


/***/ }),
/* 528 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1559);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 533 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _KeyCode = __webpack_require__(115);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _createChainedFunction = __webpack_require__(1591);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domScrollIntoView = __webpack_require__(309);
	
	var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);
	
	var _util = __webpack_require__(152);
	
	var _DOMWrap = __webpack_require__(1573);
	
	var _DOMWrap2 = _interopRequireDefault(_DOMWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function allDisabled(arr) {
	  if (!arr.length) {
	    return true;
	  }
	  return arr.every(function (c) {
	    return !!c.props.disabled;
	  });
	}
	
	function getActiveKey(props, originalActiveKey) {
	  var activeKey = originalActiveKey;
	  var children = props.children,
	      eventKey = props.eventKey;
	
	  if (activeKey) {
	    var found = void 0;
	    (0, _util.loopMenuItem)(children, function (c, i) {
	      if (c && !c.props.disabled && activeKey === (0, _util.getKeyFromChildrenIndex)(c, eventKey, i)) {
	        found = true;
	      }
	    });
	    if (found) {
	      return activeKey;
	    }
	  }
	  activeKey = null;
	  if (props.defaultActiveFirst) {
	    (0, _util.loopMenuItem)(children, function (c, i) {
	      if (!activeKey && c && !c.props.disabled) {
	        activeKey = (0, _util.getKeyFromChildrenIndex)(c, eventKey, i);
	      }
	    });
	    return activeKey;
	  }
	  return activeKey;
	}
	
	function saveRef(index, subIndex, c) {
	  if (c) {
	    if (subIndex !== undefined) {
	      this.instanceArray[index] = this.instanceArray[index] || [];
	      this.instanceArray[index][subIndex] = c;
	    } else {
	      this.instanceArray[index] = c;
	    }
	  }
	}
	
	var MenuMixin = {
	  propTypes: {
	    focusable: _propTypes2['default'].bool,
	    multiple: _propTypes2['default'].bool,
	    style: _propTypes2['default'].object,
	    defaultActiveFirst: _propTypes2['default'].bool,
	    visible: _propTypes2['default'].bool,
	    activeKey: _propTypes2['default'].string,
	    selectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    defaultSelectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    defaultOpenKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    openKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    children: _propTypes2['default'].any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-menu',
	      className: '',
	      mode: 'vertical',
	      level: 1,
	      inlineIndent: 24,
	      visible: true,
	      focusable: true,
	      style: {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    return {
	      activeKey: getActiveKey(props, props.activeKey)
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var props = void 0;
	    if ('activeKey' in nextProps) {
	      props = {
	        activeKey: getActiveKey(nextProps, nextProps.activeKey)
	      };
	    } else {
	      var originalActiveKey = this.state.activeKey;
	      var activeKey = getActiveKey(nextProps, originalActiveKey);
	      // fix: this.setState(), parent.render(),
	      if (activeKey !== originalActiveKey) {
	        props = {
	          activeKey: activeKey
	        };
	      }
	    }
	    if (props) {
	      this.setState(props);
	    }
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return this.props.visible || nextProps.visible;
	  },
	  componentWillMount: function componentWillMount() {
	    this.instanceArray = [];
	  },
	
	
	  // all keyboard events callbacks run from here at first
	  onKeyDown: function onKeyDown(e, callback) {
	    var _this = this;
	
	    var keyCode = e.keyCode;
	    var handled = void 0;
	    this.getFlatInstanceArray().forEach(function (obj) {
	      if (obj && obj.props.active) {
	        handled = obj.onKeyDown(e);
	      }
	    });
	    if (handled) {
	      return 1;
	    }
	    var activeItem = null;
	    if (keyCode === _KeyCode2['default'].UP || keyCode === _KeyCode2['default'].DOWN) {
	      activeItem = this.step(keyCode === _KeyCode2['default'].UP ? -1 : 1);
	    }
	    if (activeItem) {
	      e.preventDefault();
	      this.setState({
	        activeKey: activeItem.props.eventKey
	      }, function () {
	        (0, _domScrollIntoView2['default'])(_reactDom2['default'].findDOMNode(activeItem), _reactDom2['default'].findDOMNode(_this), {
	          onlyScrollIfNeeded: true
	        });
	        if (callback) {
	          callback(activeItem);
	        }
	      });
	      return 1;
	    } else if (activeItem === undefined) {
	      e.preventDefault();
	      this.setState({
	        activeKey: null
	      });
	      return 1;
	    }
	  },
	  getOpenChangesOnItemHover: function getOpenChangesOnItemHover(e) {
	    var mode = this.props.mode;
	    var key = e.key,
	        hover = e.hover,
	        trigger = e.trigger;
	
	    var activeKey = this.state.activeKey;
	    if (!trigger || hover || this.props.closeSubMenuOnMouseLeave || !e.item.isSubMenu || mode === 'inline') {
	      this.setState({
	        activeKey: hover ? key : null
	      });
	    } else {}
	    // keep active for sub menu for click active
	    // empty
	
	    // clear last open status
	    if (hover && mode !== 'inline') {
	      var activeItem = this.getFlatInstanceArray().filter(function (c) {
	        return c && c.props.eventKey === activeKey;
	      })[0];
	      if (activeItem && activeItem.isSubMenu && activeItem.props.eventKey !== key) {
	        return {
	          item: activeItem,
	          originalEvent: e,
	          key: activeItem.props.eventKey,
	          open: false
	        };
	      }
	    }
	    return [];
	  },
	  getFlatInstanceArray: function getFlatInstanceArray() {
	    var instanceArray = this.instanceArray;
	    var hasInnerArray = instanceArray.some(function (a) {
	      return Array.isArray(a);
	    });
	    if (hasInnerArray) {
	      instanceArray = [];
	      this.instanceArray.forEach(function (a) {
	        if (Array.isArray(a)) {
	          instanceArray.push.apply(instanceArray, a);
	        } else {
	          instanceArray.push(a);
	        }
	      });
	      this.instanceArray = instanceArray;
	    }
	    return instanceArray;
	  },
	  renderCommonMenuItem: function renderCommonMenuItem(child, i, subIndex, extraProps) {
	    var state = this.state;
	    var props = this.props;
	    var key = (0, _util.getKeyFromChildrenIndex)(child, props.eventKey, i);
	    var childProps = child.props;
	    var isActive = key === state.activeKey;
	    var newChildProps = (0, _extends3['default'])({
	      mode: props.mode,
	      level: props.level,
	      inlineIndent: props.inlineIndent,
	      renderMenuItem: this.renderMenuItem,
	      rootPrefixCls: props.prefixCls,
	      index: i,
	      parentMenu: this,
	      ref: childProps.disabled ? undefined : (0, _createChainedFunction2['default'])(child.ref, saveRef.bind(this, i, subIndex)),
	      eventKey: key,
	      closeSubMenuOnMouseLeave: props.closeSubMenuOnMouseLeave,
	      onItemHover: this.onItemHover,
	      active: !childProps.disabled && isActive,
	      multiple: props.multiple,
	      onClick: this.onClick,
	      openTransitionName: this.getOpenTransitionName(),
	      openAnimation: props.openAnimation,
	      onOpenChange: this.onOpenChange,
	      onDeselect: this.onDeselect,
	      onDestroy: this.onDestroy,
	      onSelect: this.onSelect
	    }, extraProps);
	    if (props.mode === 'inline') {
	      newChildProps.closeSubMenuOnMouseLeave = newChildProps.openSubMenuOnMouseEnter = false;
	    }
	    return _react2['default'].cloneElement(child, newChildProps);
	  },
	  renderRoot: function renderRoot(props) {
	    var _classes;
	
	    this.instanceArray = [];
	    var classes = (_classes = {}, (0, _defineProperty3['default'])(_classes, props.prefixCls, 1), (0, _defineProperty3['default'])(_classes, props.prefixCls + '-' + props.mode, 1), (0, _defineProperty3['default'])(_classes, props.className, !!props.className), _classes);
	    var domProps = {
	      className: (0, _classnames2['default'])(classes),
	      role: 'menu',
	      'aria-activedescendant': ''
	    };
	    if (props.id) {
	      domProps.id = props.id;
	    }
	    if (props.focusable) {
	      domProps.tabIndex = '0';
	      domProps.onKeyDown = this.onKeyDown;
	    }
	    return (
	      // ESLint is not smart enough to know that the type of `children` was checked.
	      /* eslint-disable */
	      _react2['default'].createElement(
	        _DOMWrap2['default'],
	        (0, _extends3['default'])({
	          style: props.style,
	          tag: 'ul',
	          hiddenClassName: props.prefixCls + '-hidden',
	          visible: props.visible
	        }, domProps),
	        _react2['default'].Children.map(props.children, this.renderMenuItem)
	      )
	      /*eslint-enable */
	
	    );
	  },
	  step: function step(direction) {
	    var children = this.getFlatInstanceArray();
	    var activeKey = this.state.activeKey;
	    var len = children.length;
	    if (!len) {
	      return null;
	    }
	    if (direction < 0) {
	      children = children.concat().reverse();
	    }
	    // find current activeIndex
	    var activeIndex = -1;
	    children.every(function (c, ci) {
	      if (c && c.props.eventKey === activeKey) {
	        activeIndex = ci;
	        return false;
	      }
	      return true;
	    });
	    if (!this.props.defaultActiveFirst && activeIndex !== -1) {
	      if (allDisabled(children.slice(activeIndex, len - 1))) {
	        return undefined;
	      }
	    }
	    var start = (activeIndex + 1) % len;
	    var i = start;
	    for (;;) {
	      var child = children[i];
	      if (!child || child.props.disabled) {
	        i = (i + 1 + len) % len;
	        // complete a loop
	        if (i === start) {
	          return null;
	        }
	      } else {
	        return child;
	      }
	    }
	  }
	};
	
	exports['default'] = MenuMixin;
	module.exports = exports['default'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Divider = exports.ItemGroup = exports.MenuItemGroup = exports.MenuItem = exports.Item = exports.SubMenu = undefined;
	
	var _Menu = __webpack_require__(1575);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _SubMenu = __webpack_require__(1578);
	
	var _SubMenu2 = _interopRequireDefault(_SubMenu);
	
	var _MenuItem = __webpack_require__(1576);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuItemGroup = __webpack_require__(1577);
	
	var _MenuItemGroup2 = _interopRequireDefault(_MenuItemGroup);
	
	var _Divider = __webpack_require__(1574);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.SubMenu = _SubMenu2['default'];
	exports.Item = _MenuItem2['default'];
	exports.MenuItem = _MenuItem2['default'];
	exports.MenuItemGroup = _MenuItemGroup2['default'];
	exports.ItemGroup = _MenuItemGroup2['default'];
	exports.Divider = _Divider2['default'];
	exports['default'] = _Menu2['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectPropTypes = undefined;
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function valueType(props, propName, componentName) {
	  var labelInValueShape = _propTypes2['default'].shape({
	    key: _propTypes2['default'].string.isRequired,
	    label: _propTypes2['default'].string
	  });
	  if (props.labelInValue) {
	    var validate = _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(labelInValueShape), labelInValueShape]);
	    var error = validate.apply(undefined, arguments);
	    if (error) {
	      return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, ' + ('when you set `labelInValue` to `true`, `' + propName + '` should in ') + 'shape of `{ key: string, label?: string }`.');
	    }
	  } else if ((props.mode === 'multiple' || props.mode === 'tags' || props.multiple || props.tags) && props[propName] === '') {
	    return new Error('Invalid prop `' + propName + '` of type `string` supplied to `' + componentName + '`, ' + 'expected `array` when `multiple` or `tags` is `true`.');
	  } else {
	    var _validate = _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].string), _propTypes2['default'].string]);
	    return _validate.apply(undefined, arguments);
	  }
	}
	
	var SelectPropTypes = exports.SelectPropTypes = {
	  defaultActiveFirstOption: _propTypes2['default'].bool,
	  multiple: _propTypes2['default'].bool,
	  filterOption: _propTypes2['default'].any,
	  children: _propTypes2['default'].any,
	  showSearch: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  allowClear: _propTypes2['default'].bool,
	  showArrow: _propTypes2['default'].bool,
	  tags: _propTypes2['default'].bool,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].string,
	  optionLabelProp: _propTypes2['default'].string,
	  optionFilterProp: _propTypes2['default'].string,
	  animation: _propTypes2['default'].string,
	  choiceTransitionName: _propTypes2['default'].string,
	  onChange: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  onSearch: _propTypes2['default'].func,
	  placeholder: _propTypes2['default'].any,
	  onDeselect: _propTypes2['default'].func,
	  labelInValue: _propTypes2['default'].bool,
	  value: valueType,
	  defaultValue: valueType,
	  dropdownStyle: _propTypes2['default'].object,
	  maxTagTextLength: _propTypes2['default'].number,
	  tokenSeparators: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  getInputElement: _propTypes2['default'].func
	};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_Component) {
	  (0, _inherits3['default'])(LazyRenderBox, _Component);
	
	  function LazyRenderBox() {
	    (0, _classCallCheck3['default'])(this, LazyRenderBox);
	    return (0, _possibleConstructorReturn3['default'])(this, (LazyRenderBox.__proto__ || Object.getPrototypeOf(LazyRenderBox)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(LazyRenderBox, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.hiddenClassName || nextProps.visible;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hiddenClassName = _props.hiddenClassName,
	          visible = _props.visible,
	          props = (0, _objectWithoutProperties3['default'])(_props, ['hiddenClassName', 'visible']);
	
	
	      if (hiddenClassName || _react2['default'].Children.count(props.children) > 1) {
	        if (!visible && hiddenClassName) {
	          props.className += ' ' + hiddenClassName;
	        }
	        return _react2['default'].createElement('div', props);
	      }
	
	      return _react2['default'].Children.only(props.children);
	    }
	  }]);
	  return LazyRenderBox;
	}(_react.Component);
	
	LazyRenderBox.propTypes = {
	  children: _propTypes2['default'].any,
	  className: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool,
	  hiddenClassName: _propTypes2['default'].string
	};
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getPopupClassNameFromAlign = getPopupClassNameFromAlign;
	exports.saveRef = saveRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isPointsEq(a1, a2) {
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3['default'])({}, baseAlign, align);
	}
	
	function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}
	
	function saveRef(name, component) {
	  this[name] = component;
	}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = contains;
	function contains(root, n) {
	  var node = n;
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(76);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(92);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInstrumentation = __webpack_require__(43);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1657);
	var warning = __webpack_require__(16);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var LinkedValueUtils = __webpack_require__(241);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(46);
	
	var warning = __webpack_require__(16);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(11);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1617);
	
	var containsNode = __webpack_require__(840);
	var focusNode = __webpack_require__(313);
	var getActiveElement = __webpack_require__(314);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var DOMLazyTree = __webpack_require__(91);
	var DOMProperty = __webpack_require__(92);
	var React = __webpack_require__(97);
	var ReactBrowserEventEmitter = __webpack_require__(154);
	var ReactCurrentOwner = __webpack_require__(59);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMContainerInfo = __webpack_require__(1611);
	var ReactDOMFeatureFlags = __webpack_require__(1613);
	var ReactFeatureFlags = __webpack_require__(546);
	var ReactInstanceMap = __webpack_require__(117);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactMarkupChecksum = __webpack_require__(1627);
	var ReactReconciler = __webpack_require__(95);
	var ReactUpdateQueue = __webpack_require__(244);
	var ReactUpdates = __webpack_require__(46);
	
	var emptyObject = __webpack_require__(129);
	var instantiateReactComponent = __webpack_require__(556);
	var invariant = __webpack_require__(11);
	var setInnerHTML = __webpack_require__(158);
	var shouldUpdateReactComponent = __webpack_require__(251);
	var warning = __webpack_require__(16);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var React = __webpack_require__(97);
	
	var invariant = __webpack_require__(11);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(550);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(20);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var ReactCompositeComponent = __webpack_require__(1608);
	var ReactEmptyComponent = __webpack_require__(545);
	var ReactHostComponent = __webpack_require__(547);
	
	var getNextDebugID = __webpack_require__(1679);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	var escapeTextContentForBrowser = __webpack_require__(157);
	var setInnerHTML = __webpack_require__(158);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(59);
	var REACT_ELEMENT_TYPE = __webpack_require__(1623);
	
	var getIteratorFn = __webpack_require__(1654);
	var invariant = __webpack_require__(11);
	var KeyEscapeUtils = __webpack_require__(240);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(77);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _Number = __webpack_require__(255);
	
	var _Number2 = _interopRequireDefault(_Number);
	
	var _Text = __webpack_require__(256);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextArea = __webpack_require__(257);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	var _Select = __webpack_require__(161);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Radios = __webpack_require__(160);
	
	var _Radios2 = _interopRequireDefault(_Radios);
	
	var _Date = __webpack_require__(254);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	var _Checkbox = __webpack_require__(253);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Help = __webpack_require__(159);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _Array = __webpack_require__(1663);
	
	var _Array2 = _interopRequireDefault(_Array);
	
	var _FieldSet = __webpack_require__(1664);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _lodash = __webpack_require__(87);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 11/09/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var SchemaForm = function (_React$Component) {
	    _inherits(SchemaForm, _React$Component);
	
	    function SchemaForm(props) {
	        _classCallCheck(this, SchemaForm);
	
	        var _this = _possibleConstructorReturn(this, (SchemaForm.__proto__ || Object.getPrototypeOf(SchemaForm)).call(this, props));
	
	        _this.mapper = {
	            'number': _Number2.default,
	            'text': _Text2.default,
	            'password': _Text2.default,
	            'textarea': _TextArea2.default,
	            'select': _Select2.default,
	            'radios': _Radios2.default,
	            'date': _Date2.default,
	            'checkbox': _Checkbox2.default,
	            'help': _Help2.default,
	            'array': _Array2.default,
	            'fieldset': _FieldSet2.default
	        };
	
	        _this.onChange = _this.onChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(SchemaForm, [{
	        key: 'onChange',
	        value: function onChange(key, val) {
	            //console.log('SchemaForm.onChange', key, val);
	            this.props.onModelChange(key, val);
	        }
	    }, {
	        key: 'builder',
	        value: function builder(form, model, index, onChange, mapper) {
	            var type = form.type;
	            var Field = this.mapper[type];
	            if (!Field) {
	                console.log('Invalid field: \"' + form.key[0] + '\"!');
	                return null;
	            }
	            if (form.condition && eval(form.condition) === false) {
	                return null;
	            }
	            return _react2.default.createElement(Field, { model: model, form: form, key: index, onChange: onChange, mapper: mapper, builder: this.builder });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var merged = _utils2.default.merge(this.props.schema, this.props.form, this.props.ignore, this.props.option);
	            //console.log('SchemaForm merged = ', JSON.stringify(merged, undefined, 2));
	            var mapper = this.mapper;
	            if (this.props.mapper) {
	                mapper = _lodash2.default.merge(this.mapper, this.props.mapper);
	            }
	            var forms = merged.map(function (form, index) {
	                return this.builder(form, this.props.model, index, this.onChange, mapper);
	            }.bind(this));
	
	            return _react2.default.createElement(
	                'div',
	                { style: { width: '100%' }, className: 'SchemaForm ' + this.props.className },
	                forms
	            );
	        }
	    }]);
	
	    return SchemaForm;
	}(_react2.default.Component);
	
	module.exports = SchemaForm;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(SchemaForm, 'SchemaForm', 'src/SchemaForm.js');
	}();
	
	;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(119),
	    _assign = __webpack_require__(18);
	
	var ReactNoopUpdateQueue = __webpack_require__(564);
	
	var canDefineProperty = __webpack_require__(565);
	var emptyObject = __webpack_require__(129);
	var invariant = __webpack_require__(11);
	var lowPriorityWarning = __webpack_require__(1680);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(119);
	
	var ReactCurrentOwner = __webpack_require__(59);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(16);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
	
	var _flattenNames = __webpack_require__(1686);
	
	var _flattenNames2 = _interopRequireDefault(_flattenNames);
	
	var _mergeClasses = __webpack_require__(1688);
	
	var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
	
	var _autoprefix = __webpack_require__(1683);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _hover2 = __webpack_require__(1685);
	
	var _hover3 = _interopRequireDefault(_hover2);
	
	var _active = __webpack_require__(1684);
	
	var _active2 = _interopRequireDefault(_active);
	
	var _loop2 = __webpack_require__(1687);
	
	var _loop3 = _interopRequireDefault(_loop2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.hover = _hover3.default;
	exports.handleHover = _hover3.default;
	exports.handleActive = _active2.default;
	exports.loop = _loop3.default;
	var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
	  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    activations[_key - 1] = arguments[_key];
	  }
	
	  var activeNames = (0, _flattenNames2.default)(activations);
	  var merged = (0, _mergeClasses2.default)(classes, activeNames);
	  return (0, _autoprefix2.default)(merged);
	};
	
	exports.default = ReactCSS;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(151);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(193);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(70).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(570);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(162).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(104);
	util.inherits = __webpack_require__(30);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1739);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1691);
	var destroyImpl = __webpack_require__(569);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(78);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(578).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(78);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(578).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(28)))

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(78);
	
	/*<replacement>*/
	var util = __webpack_require__(104);
	util.inherits = __webpack_require__(30);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(151);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(70).EventEmitter;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(120).Transform


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (false) {
	    var _ret = function () {
	      /* eslint-disable global-require */
	      var wrapDisplayName = require('./wrapDisplayName').default;
	      /* eslint-enable global-require */
	
	      if (noArgs) {
	        return {
	          v: function v(BaseComponent) {
	            var Component = func(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          }
	        };
	      }
	
	      return {
	        v: function v() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          return function (BaseComponent) {
	            var Component = func.apply(undefined, args)(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          };
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  return func;
	};
	
	exports.default = createHelper;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	function select(element) {
	    var selectedText;
	
	    if (element.nodeName === 'SELECT') {
	        element.focus();
	
	        selectedText = element.value;
	    }
	    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	        var isReadOnly = element.hasAttribute('readonly');
	
	        if (!isReadOnly) {
	            element.setAttribute('readonly', '');
	        }
	
	        element.select();
	        element.setSelectionRange(0, element.value.length);
	
	        if (!isReadOnly) {
	            element.removeAttribute('readonly');
	        }
	
	        selectedText = element.value;
	    }
	    else {
	        if (element.hasAttribute('contenteditable')) {
	            element.focus();
	        }
	
	        var selection = window.getSelection();
	        var range = document.createRange();
	
	        range.selectNodeContents(element);
	        selection.removeAllRanges();
	        selection.addRange(range);
	
	        selectedText = selection.toString();
	    }
	
	    return selectedText;
	}
	
	module.exports = select;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	/*! Split.js - v1.5.7 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.Split = factory());
	}(this, (function () { 'use strict';
	
	    // The programming goals of Split.js are to deliver readable, understandable and
	    // maintainable code, while at the same time manually optimizing for tiny minified file size,
	    // browser compatibility without additional requirements, graceful fallback (IE8 is supported)
	    // and very few assumptions about the user's page layout.
	    var global = window;
	    var document = global.document;
	
	    // Save a couple long function names that are used frequently.
	    // This optimization saves around 400 bytes.
	    var addEventListener = 'addEventListener';
	    var removeEventListener = 'removeEventListener';
	    var getBoundingClientRect = 'getBoundingClientRect';
	    var gutterStartDragging = '_a';
	    var aGutterSize = '_b';
	    var bGutterSize = '_c';
	    var HORIZONTAL = 'horizontal';
	    var NOOP = function () { return false; };
	
	    // Figure out if we're in IE8 or not. IE8 will still render correctly,
	    // but will be static instead of draggable.
	    var isIE8 = global.attachEvent && !global[addEventListener];
	
	    // Helper function determines which prefixes of CSS calc we need.
	    // We only need to do this once on startup, when this anonymous function is called.
	    //
	    // Tests -webkit, -moz and -o prefixes. Modified from StackOverflow:
	    // http://stackoverflow.com/questions/16625140/js-feature-detection-to-detect-the-usage-of-webkit-calc-over-calc/16625167#16625167
	    var calc = (['', '-webkit-', '-moz-', '-o-'].filter(function (prefix) {
	        var el = document.createElement('div');
	        el.style.cssText = "width:" + prefix + "calc(9px)";
	
	        return (!!el.style.length)
	    }).shift()) + "calc";
	
	    // Helper function checks if its argument is a string-like type
	    var isString = function (v) { return (typeof v === 'string' || v instanceof String); };
	
	    // Helper function allows elements and string selectors to be used
	    // interchangeably. In either case an element is returned. This allows us to
	    // do `Split([elem1, elem2])` as well as `Split(['#id1', '#id2'])`.
	    var elementOrSelector = function (el) {
	        if (isString(el)) {
	            var ele = document.querySelector(el);
	            if (!ele) {
	                throw new Error(("Selector " + el + " did not match a DOM element"))
	            }
	            return ele
	        }
	
	        return el
	    };
	
	    // Helper function gets a property from the properties object, with a default fallback
	    var getOption = function (options, propName, def) {
	        var value = options[propName];
	        if (value !== undefined) {
	            return value
	        }
	        return def
	    };
	
	    var getGutterSize = function (gutterSize, isFirst, isLast, gutterAlign) {
	        if (isFirst) {
	            if (gutterAlign === 'end') {
	                return 0
	            } else if (gutterAlign === 'center') {
	                return gutterSize / 2
	            }
	        } else if (isLast) {
	            if (gutterAlign === 'start') {
	                return 0
	            } else if (gutterAlign === 'center') {
	                return gutterSize / 2
	            }
	        }
	
	        return gutterSize
	    };
	
	    // Default options
	    var defaultGutterFn = function (i, gutterDirection) {
	        var gut = document.createElement('div');
	        gut.className = "gutter gutter-" + gutterDirection;
	        return gut
	    };
	
	    var defaultElementStyleFn = function (dim, size, gutSize) {
	        var style = {};
	
	        if (!isString(size)) {
	            if (!isIE8) {
	                style[dim] = calc + "(" + size + "% - " + gutSize + "px)";
	            } else {
	                style[dim] = size + "%";
	            }
	        } else {
	            style[dim] = size;
	        }
	
	        return style
	    };
	
	    var defaultGutterStyleFn = function (dim, gutSize) {
	        var obj;
	
	        return (( obj = {}, obj[dim] = (gutSize + "px"), obj ));
	    };
	
	    // The main function to initialize a split. Split.js thinks about each pair
	    // of elements as an independant pair. Dragging the gutter between two elements
	    // only changes the dimensions of elements in that pair. This is key to understanding
	    // how the following functions operate, since each function is bound to a pair.
	    //
	    // A pair object is shaped like this:
	    //
	    // {
	    //     a: DOM element,
	    //     b: DOM element,
	    //     aMin: Number,
	    //     bMin: Number,
	    //     dragging: Boolean,
	    //     parent: DOM element,
	    //     direction: 'horizontal' | 'vertical'
	    // }
	    //
	    // The basic sequence:
	    //
	    // 1. Set defaults to something sane. `options` doesn't have to be passed at all.
	    // 2. Initialize a bunch of strings based on the direction we're splitting.
	    //    A lot of the behavior in the rest of the library is paramatized down to
	    //    rely on CSS strings and classes.
	    // 3. Define the dragging helper functions, and a few helpers to go with them.
	    // 4. Loop through the elements while pairing them off. Every pair gets an
	    //    `pair` object and a gutter.
	    // 5. Actually size the pair elements, insert gutters and attach event listeners.
	    var Split = function (idsOption, options) {
	        if ( options === void 0 ) options = {};
	
	        var ids = idsOption;
	        var dimension;
	        var clientAxis;
	        var position;
	        var positionEnd;
	        var clientSize;
	        var elements;
	
	        // Allow HTMLCollection to be used as an argument when supported
	        if (Array.from) {
	            ids = Array.from(ids);
	        }
	
	        // All DOM elements in the split should have a common parent. We can grab
	        // the first elements parent and hope users read the docs because the
	        // behavior will be whacky otherwise.
	        var firstElement = elementOrSelector(ids[0]);
	        var parent = firstElement.parentNode;
	        var parentFlexDirection = getComputedStyle ? getComputedStyle(parent).flexDirection : null;
	
	        // Set default options.sizes to equal percentages of the parent element.
	        var sizes = getOption(options, 'sizes') || ids.map(function () { return 100 / ids.length; });
	
	        // Standardize minSize to an array if it isn't already. This allows minSize
	        // to be passed as a number.
	        var minSize = getOption(options, 'minSize', 100);
	        var minSizes = Array.isArray(minSize) ? minSize : ids.map(function () { return minSize; });
	
	        // Get other options
	        var expandToMin = getOption(options, 'expandToMin', false);
	        var gutterSize = getOption(options, 'gutterSize', 10);
	        var gutterAlign = getOption(options, 'gutterAlign', 'center');
	        var snapOffset = getOption(options, 'snapOffset', 30);
	        var dragInterval = getOption(options, 'dragInterval', 1);
	        var direction = getOption(options, 'direction', HORIZONTAL);
	        var cursor = getOption(options, 'cursor', direction === HORIZONTAL ? 'col-resize' : 'row-resize');
	        var gutter = getOption(options, 'gutter', defaultGutterFn);
	        var elementStyle = getOption(options, 'elementStyle', defaultElementStyleFn);
	        var gutterStyle = getOption(options, 'gutterStyle', defaultGutterStyleFn);
	
	        // 2. Initialize a bunch of strings based on the direction we're splitting.
	        // A lot of the behavior in the rest of the library is paramatized down to
	        // rely on CSS strings and classes.
	        if (direction === HORIZONTAL) {
	            dimension = 'width';
	            clientAxis = 'clientX';
	            position = 'left';
	            positionEnd = 'right';
	            clientSize = 'clientWidth';
	        } else if (direction === 'vertical') {
	            dimension = 'height';
	            clientAxis = 'clientY';
	            position = 'top';
	            positionEnd = 'bottom';
	            clientSize = 'clientHeight';
	        }
	
	        // 3. Define the dragging helper functions, and a few helpers to go with them.
	        // Each helper is bound to a pair object that contains its metadata. This
	        // also makes it easy to store references to listeners that that will be
	        // added and removed.
	        //
	        // Even though there are no other functions contained in them, aliasing
	        // this to self saves 50 bytes or so since it's used so frequently.
	        //
	        // The pair object saves metadata like dragging state, position and
	        // event listener references.
	
	        function setElementSize (el, size, gutSize, i) {
	            // Split.js allows setting sizes via numbers (ideally), or if you must,
	            // by string, like '300px'. This is less than ideal, because it breaks
	            // the fluid layout that `calc(% - px)` provides. You're on your own if you do that,
	            // make sure you calculate the gutter size by hand.
	            var style = elementStyle(dimension, size, gutSize, i);
	
	            // eslint-disable-next-line no-param-reassign
	            Object.keys(style).forEach(function (prop) {
	                el.style[prop] = style[prop];
	            });
	        }
	
	        function setGutterSize (gutterElement, gutSize, i) {
	            var style = gutterStyle(dimension, gutSize, i);
	
	            // eslint-disable-next-line no-param-reassign
	            Object.keys(style).forEach(function (prop) {
	                gutterElement.style[prop] = style[prop];
	            });
	        }
	
	        function getSizes () {
	            return elements.map(function (element) { return element.size; })
	        }
	
	        // Supports touch events, but not multitouch, so only the first
	        // finger `touches[0]` is counted.
	        function getMousePosition (e) {
	            if ('touches' in e) { return e.touches[0][clientAxis] }
	            return e[clientAxis]
	        }
	
	        // Actually adjust the size of elements `a` and `b` to `offset` while dragging.
	        // calc is used to allow calc(percentage + gutterpx) on the whole split instance,
	        // which allows the viewport to be resized without additional logic.
	        // Element a's size is the same as offset. b's size is total size - a size.
	        // Both sizes are calculated from the initial parent percentage,
	        // then the gutter size is subtracted.
	        function adjust (offset) {
	            var a = elements[this.a];
	            var b = elements[this.b];
	            var percentage = a.size + b.size;
	
	            a.size = (offset / this.size) * percentage;
	            b.size = (percentage - ((offset / this.size) * percentage));
	
	            setElementSize(a.element, a.size, this[aGutterSize], a.i);
	            setElementSize(b.element, b.size, this[bGutterSize], b.i);
	        }
	
	        // drag, where all the magic happens. The logic is really quite simple:
	        //
	        // 1. Ignore if the pair is not dragging.
	        // 2. Get the offset of the event.
	        // 3. Snap offset to min if within snappable range (within min + snapOffset).
	        // 4. Actually adjust each element in the pair to offset.
	        //
	        // ---------------------------------------------------------------------
	        // |    | <- a.minSize               ||              b.minSize -> |    |
	        // |    |  | <- this.snapOffset      ||     this.snapOffset -> |  |    |
	        // |    |  |                         ||                        |  |    |
	        // |    |  |                         ||                        |  |    |
	        // ---------------------------------------------------------------------
	        // | <- this.start                                        this.size -> |
	        function drag (e) {
	            var offset;
	            var a = elements[this.a];
	            var b = elements[this.b];
	
	            if (!this.dragging) { return }
	
	            // Get the offset of the event from the first side of the
	            // pair `this.start`. Then offset by the initial position of the
	            // mouse compared to the gutter size.
	            offset = (getMousePosition(e) - this.start) + (this[aGutterSize] - this.dragOffset);
	
	            if (dragInterval > 1) {
	                offset = Math.round(offset / dragInterval) * dragInterval;
	            }
	
	            // If within snapOffset of min or max, set offset to min or max.
	            // snapOffset buffers a.minSize and b.minSize, so logic is opposite for both.
	            // Include the appropriate gutter sizes to prevent overflows.
	            if (offset <= a.minSize + snapOffset + this[aGutterSize]) {
	                offset = a.minSize + this[aGutterSize];
	            } else if (offset >= this.size - (b.minSize + snapOffset + this[bGutterSize])) {
	                offset = this.size - (b.minSize + this[bGutterSize]);
	            }
	
	            // Actually adjust the size.
	            adjust.call(this, offset);
	
	            // Call the drag callback continously. Don't do anything too intensive
	            // in this callback.
	            getOption(options, 'onDrag', NOOP)();
	        }
	
	        // Cache some important sizes when drag starts, so we don't have to do that
	        // continously:
	        //
	        // `size`: The total size of the pair. First + second + first gutter + second gutter.
	        // `start`: The leading side of the first element.
	        //
	        // ------------------------------------------------
	        // |      aGutterSize -> |||                      |
	        // |                     |||                      |
	        // |                     |||                      |
	        // |                     ||| <- bGutterSize       |
	        // ------------------------------------------------
	        // | <- start                             size -> |
	        function calculateSizes () {
	            // Figure out the parent size minus padding.
	            var a = elements[this.a].element;
	            var b = elements[this.b].element;
	
	            var aBounds = a[getBoundingClientRect]();
	            var bBounds = b[getBoundingClientRect]();
	
	            this.size = aBounds[dimension] + bBounds[dimension] + this[aGutterSize] + this[bGutterSize];
	            this.start = aBounds[position];
	            this.end = aBounds[positionEnd];
	        }
	
	        function innerSize (element) {
	            // Return nothing if getComputedStyle is not supported (< IE9)
	            if (!getComputedStyle) { return null }
	
	            var computedStyle = getComputedStyle(element);
	            var size = element[clientSize];
	
	            if (direction === HORIZONTAL) {
	                size -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
	            } else {
	                size -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
	            }
	
	            return size
	        }
	
	        // When specifying percentage sizes that are less than the computed
	        // size of the element minus the gutter, the lesser percentages must be increased
	        // (and decreased from the other elements) to make space for the pixels
	        // subtracted by the gutters.
	        function trimToMin (sizesToTrim) {
	            // Try to get inner size of parent element.
	            // If it's no supported, return original sizes.
	            var parentSize = innerSize(parent);
	            if (parentSize === null) {
	                return sizesToTrim
	            }
	
	            // Keep track of the excess pixels, the amount of pixels over the desired percentage
	            // Also keep track of the elements with pixels to spare, to decrease after if needed
	            var excessPixels = 0;
	            var toSpare = [];
	
	            var pixelSizes = sizesToTrim.map(function (size, i) {
	                // Convert requested percentages to pixel sizes
	                var pixelSize = (parentSize * size) / 100;
	                var elementGutterSize = getGutterSize(
	                    gutterSize,
	                    i === 0,
	                    i === sizesToTrim.length - 1,
	                    gutterAlign
	                );
	                var elementMinSize = minSizes[i] + elementGutterSize;
	
	                // If element is too smal, increase excess pixels by the difference
	                // and mark that it has no pixels to spare
	                if (pixelSize < elementMinSize) {
	                    excessPixels += (elementMinSize - pixelSize);
	                    toSpare.push(0);
	                    return elementMinSize
	                }
	
	                // Otherwise, mark the pixels it has to spare and return it's original size
	                toSpare.push(pixelSize - elementMinSize);
	                return pixelSize
	            });
	
	            // If nothing was adjusted, return the original sizes
	            if (excessPixels === 0) {
	                return sizesToTrim
	            }
	
	            return pixelSizes.map(function (pixelSize, i) {
	                var newPixelSize = pixelSize;
	
	                // While there's still pixels to take, and there's enough pixels to spare,
	                // take as many as possible up to the total excess pixels
	                if ((excessPixels > 0) && (toSpare[i] - excessPixels) > 0) {
	                    var takenPixels = Math.min(excessPixels, (toSpare[i] - excessPixels));
	
	                    // Subtract the amount taken for the next iteration
	                    excessPixels -= takenPixels;
	                    newPixelSize = pixelSize - takenPixels;
	                }
	
	                // Return the pixel size adjusted as a percentage
	                return (newPixelSize / parentSize) * 100
	            })
	        }
	
	        // stopDragging is very similar to startDragging in reverse.
	        function stopDragging () {
	            var self = this;
	            var a = elements[self.a].element;
	            var b = elements[self.b].element;
	
	            if (self.dragging) {
	                getOption(options, 'onDragEnd', NOOP)(getSizes());
	            }
	
	            self.dragging = false;
	
	            // Remove the stored event listeners. This is why we store them.
	            global[removeEventListener]('mouseup', self.stop);
	            global[removeEventListener]('touchend', self.stop);
	            global[removeEventListener]('touchcancel', self.stop);
	            global[removeEventListener]('mousemove', self.move);
	            global[removeEventListener]('touchmove', self.move);
	
	            // Clear bound function references
	            self.stop = null;
	            self.move = null;
	
	            a[removeEventListener]('selectstart', NOOP);
	            a[removeEventListener]('dragstart', NOOP);
	            b[removeEventListener]('selectstart', NOOP);
	            b[removeEventListener]('dragstart', NOOP);
	
	            a.style.userSelect = '';
	            a.style.webkitUserSelect = '';
	            a.style.MozUserSelect = '';
	            a.style.pointerEvents = '';
	
	            b.style.userSelect = '';
	            b.style.webkitUserSelect = '';
	            b.style.MozUserSelect = '';
	            b.style.pointerEvents = '';
	
	            self.gutter.style.cursor = '';
	            self.parent.style.cursor = '';
	            document.body.style.cursor = '';
	        }
	
	        // startDragging calls `calculateSizes` to store the inital size in the pair object.
	        // It also adds event listeners for mouse/touch events,
	        // and prevents selection while dragging so avoid the selecting text.
	        function startDragging (e) {
	            // Right-clicking can't start dragging.
	            if ('button' in e && e.button !== 0) {
	                return
	            }
	
	            // Alias frequently used variables to save space. 200 bytes.
	            var self = this;
	            var a = elements[self.a].element;
	            var b = elements[self.b].element;
	
	            // Call the onDragStart callback.
	            if (!self.dragging) {
	                getOption(options, 'onDragStart', NOOP)(getSizes());
	            }
	
	            // Don't actually drag the element. We emulate that in the drag function.
	            e.preventDefault();
	
	            // Set the dragging property of the pair object.
	            self.dragging = true;
	
	            // Create two event listeners bound to the same pair object and store
	            // them in the pair object.
	            self.move = drag.bind(self);
	            self.stop = stopDragging.bind(self);
	
	            // All the binding. `window` gets the stop events in case we drag out of the elements.
	            global[addEventListener]('mouseup', self.stop);
	            global[addEventListener]('touchend', self.stop);
	            global[addEventListener]('touchcancel', self.stop);
	            global[addEventListener]('mousemove', self.move);
	            global[addEventListener]('touchmove', self.move);
	
	            // Disable selection. Disable!
	            a[addEventListener]('selectstart', NOOP);
	            a[addEventListener]('dragstart', NOOP);
	            b[addEventListener]('selectstart', NOOP);
	            b[addEventListener]('dragstart', NOOP);
	
	            a.style.userSelect = 'none';
	            a.style.webkitUserSelect = 'none';
	            a.style.MozUserSelect = 'none';
	            a.style.pointerEvents = 'none';
	
	            b.style.userSelect = 'none';
	            b.style.webkitUserSelect = 'none';
	            b.style.MozUserSelect = 'none';
	            b.style.pointerEvents = 'none';
	
	            // Set the cursor at multiple levels
	            self.gutter.style.cursor = cursor;
	            self.parent.style.cursor = cursor;
	            document.body.style.cursor = cursor;
	
	            // Cache the initial sizes of the pair.
	            calculateSizes.call(self);
	
	            // Determine the position of the mouse compared to the gutter
	            self.dragOffset = getMousePosition(e) - self.end;
	        }
	
	        // adjust sizes to ensure percentage is within min size and gutter.
	        sizes = trimToMin(sizes);
	
	        // 5. Create pair and element objects. Each pair has an index reference to
	        // elements `a` and `b` of the pair (first and second elements).
	        // Loop through the elements while pairing them off. Every pair gets a
	        // `pair` object and a gutter.
	        //
	        // Basic logic:
	        //
	        // - Starting with the second element `i > 0`, create `pair` objects with
	        //   `a = i - 1` and `b = i`
	        // - Set gutter sizes based on the _pair_ being first/last. The first and last
	        //   pair have gutterSize / 2, since they only have one half gutter, and not two.
	        // - Create gutter elements and add event listeners.
	        // - Set the size of the elements, minus the gutter sizes.
	        //
	        // -----------------------------------------------------------------------
	        // |     i=0     |         i=1         |        i=2       |      i=3     |
	        // |             |                     |                  |              |
	        // |           pair 0                pair 1             pair 2           |
	        // |             |                     |                  |              |
	        // -----------------------------------------------------------------------
	        var pairs = [];
	        elements = ids.map(function (id, i) {
	            // Create the element object.
	            var element = {
	                element: elementOrSelector(id),
	                size: sizes[i],
	                minSize: minSizes[i],
	                i: i,
	            };
	
	            var pair;
	
	            if (i > 0) {
	                // Create the pair object with its metadata.
	                pair = {
	                    a: i - 1,
	                    b: i,
	                    dragging: false,
	                    direction: direction,
	                    parent: parent,
	                };
	
	                pair[aGutterSize] = getGutterSize(gutterSize, i - 1 === 0, false, gutterAlign);
	                pair[bGutterSize] = getGutterSize(gutterSize, false, i === ids.length - 1, gutterAlign);
	
	                // if the parent has a reverse flex-direction, switch the pair elements.
	                if (parentFlexDirection === 'row-reverse' || parentFlexDirection === 'column-reverse') {
	                    var temp = pair.a;
	                    pair.a = pair.b;
	                    pair.b = temp;
	                }
	            }
	
	            // Determine the size of the current element. IE8 is supported by
	            // staticly assigning sizes without draggable gutters. Assigns a string
	            // to `size`.
	            //
	            // IE9 and above
	            if (!isIE8) {
	                // Create gutter elements for each pair.
	                if (i > 0) {
	                    var gutterElement = gutter(i, direction, element.element);
	                    setGutterSize(gutterElement, gutterSize, i);
	
	                    // Save bound event listener for removal later
	                    pair[gutterStartDragging] = startDragging.bind(pair);
	
	                    // Attach bound event listener
	                    gutterElement[addEventListener]('mousedown', pair[gutterStartDragging]);
	                    gutterElement[addEventListener]('touchstart', pair[gutterStartDragging]);
	
	                    parent.insertBefore(gutterElement, element.element);
	
	                    pair.gutter = gutterElement;
	                }
	            }
	
	            setElementSize(
	                element.element,
	                element.size,
	                getGutterSize(gutterSize, i === 0, i === ids.length - 1, gutterAlign)
	            );
	
	            // After the first iteration, and we have a pair object, append it to the
	            // list of pairs.
	            if (i > 0) {
	                pairs.push(pair);
	            }
	
	            return element
	        });
	
	        function adjustToMin (element) {
	            var isLast = (element.i === pairs.length);
	            var pair = isLast ? pairs[element.i - 1] : pairs[element.i];
	
	            calculateSizes.call(pair);
	
	            var size = isLast ? (pair.size - element.minSize - pair[bGutterSize]) : element.minSize + pair[aGutterSize];
	
	            adjust.call(pair, size);
	        }
	
	        elements.forEach(function (element) {
	            var computedSize = element.element[getBoundingClientRect]()[dimension];
	
	            if (computedSize < element.minSize) {
	                if (expandToMin) {
	                    adjustToMin(element);
	                } else {
	                    element.minSize = computedSize;
	                }
	            }
	        });
	
	        function setSizes (newSizes) {
	            var trimmed = trimToMin(newSizes);
	            trimmed.forEach(function (newSize, i) {
	                if (i > 0) {
	                    var pair = pairs[i - 1];
	
	                    var a = elements[pair.a];
	                    var b = elements[pair.b];
	
	                    a.size = trimmed[i - 1];
	                    b.size = newSize;
	
	                    setElementSize(a.element, a.size, pair[aGutterSize]);
	                    setElementSize(b.element, b.size, pair[bGutterSize]);
	                }
	            });
	        }
	
	        function destroy (preserveStyles, preserveGutter) {
	            pairs.forEach(function (pair) {
	                if (preserveGutter !== true) {
	                    pair.parent.removeChild(pair.gutter);
	                } else {
	                    pair.gutter[removeEventListener]('mousedown', pair[gutterStartDragging]);
	                    pair.gutter[removeEventListener]('touchstart', pair[gutterStartDragging]);
	                }
	
	                if (preserveStyles !== true) {
	                    var style = elementStyle(dimension, pair.a.size, pair[aGutterSize]);
	
	                    Object.keys(style).forEach(function (prop) {
	                        elements[pair.a].element.style[prop] = '';
	                        elements[pair.b].element.style[prop] = '';
	                    });
	                }
	            });
	        }
	
	        if (isIE8) {
	            return {
	                setSizes: setSizes,
	                destroy: destroy,
	            }
	        }
	
	        return {
	            setSizes: setSizes,
	            getSizes: getSizes,
	            collapse: function collapse (i) {
	                adjustToMin(elements[i]);
	            },
	            destroy: destroy,
	            parent: parent,
	            pairs: pairs,
	        }
	    };
	
	    return Split;
	
	})));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(70).EventEmitter;
	var inherits = __webpack_require__(30);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(120);
	Stream.Writable = __webpack_require__(1693);
	Stream.Duplex = __webpack_require__(1689);
	Stream.Transform = __webpack_require__(571);
	Stream.PassThrough = __webpack_require__(1692);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 576 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)
	
	exports.writableStream = isFunction(global.WritableStream)
	
	exports.abortController = isFunction(global.AbortController)
	
	exports.blobConstructor = false
	try {
		new Blob([new ArrayBuffer(1)])
		exports.blobConstructor = true
	} catch (e) {}
	
	// The xhr request to example.com may violate some restrictive CSP configurations,
	// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
	// and assume support for certain features below.
	var xhr
	function getXHR () {
		// Cache the xhr value
		if (xhr !== undefined) return xhr
	
		if (global.XMLHttpRequest) {
			xhr = new global.XMLHttpRequest()
			// If XDomainRequest is available (ie only, where xhr might not work
			// cross domain), use the page location. Otherwise use example.com
			// Note: this doesn't actually make an http request.
			try {
				xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
			} catch(e) {
				xhr = null
			}
		} else {
			// Service workers don't have XHR
			xhr = null
		}
		return xhr
	}
	
	function checkTypeSupport (type) {
		var xhr = getXHR()
		if (!xhr) return false
		try {
			xhr.responseType = type
			return xhr.responseType === type
		} catch (e) {}
		return false
	}
	
	// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
	// Safari 7.1 appears to have fixed this bug.
	var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined'
	var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice)
	
	// If fetch is supported, then arraybuffer will be supported too. Skip calling
	// checkTypeSupport(), since that calls getXHR().
	exports.arraybuffer = exports.fetch || (haveArrayBuffer && checkTypeSupport('arraybuffer'))
	
	// These next two tests unavoidably show warnings in Chrome. Since fetch will always
	// be used if it's available, just return false for these to avoid the warnings.
	exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream')
	exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer &&
		checkTypeSupport('moz-chunked-arraybuffer')
	
	// If fetch is supported, then overrideMimeType will be supported too. Skip calling
	// getXHR().
	exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)
	
	exports.vbArray = isFunction(global.VBArray)
	
	function isFunction (value) {
		return typeof value === 'function'
	}
	
	xhr = null // Help gc
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {var capability = __webpack_require__(576)
	var inherits = __webpack_require__(30)
	var stream = __webpack_require__(120)
	
	var rStates = exports.readyStates = {
		UNSENT: 0,
		OPENED: 1,
		HEADERS_RECEIVED: 2,
		LOADING: 3,
		DONE: 4
	}
	
	var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, fetchTimer) {
		var self = this
		stream.Readable.call(self)
	
		self._mode = mode
		self.headers = {}
		self.rawHeaders = []
		self.trailers = {}
		self.rawTrailers = []
	
		// Fake the 'close' event, but only once 'end' fires
		self.on('end', function () {
			// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
			process.nextTick(function () {
				self.emit('close')
			})
		})
	
		if (mode === 'fetch') {
			self._fetchResponse = response
	
			self.url = response.url
			self.statusCode = response.status
			self.statusMessage = response.statusText
			
			response.headers.forEach(function (header, key){
				self.headers[key.toLowerCase()] = header
				self.rawHeaders.push(key, header)
			})
	
			if (capability.writableStream) {
				var writable = new WritableStream({
					write: function (chunk) {
						return new Promise(function (resolve, reject) {
							if (self._destroyed) {
								reject()
							} else if(self.push(new Buffer(chunk))) {
								resolve()
							} else {
								self._resumeFetch = resolve
							}
						})
					},
					close: function () {
						global.clearTimeout(fetchTimer)
						if (!self._destroyed)
							self.push(null)
					},
					abort: function (err) {
						if (!self._destroyed)
							self.emit('error', err)
					}
				})
	
				try {
					response.body.pipeTo(writable).catch(function (err) {
						global.clearTimeout(fetchTimer)
						if (!self._destroyed)
							self.emit('error', err)
					})
					return
				} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
			}
			// fallback for when writableStream or pipeTo aren't available
			var reader = response.body.getReader()
			function read () {
				reader.read().then(function (result) {
					if (self._destroyed)
						return
					if (result.done) {
						global.clearTimeout(fetchTimer)
						self.push(null)
						return
					}
					self.push(new Buffer(result.value))
					read()
				}).catch(function (err) {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.emit('error', err)
				})
			}
			read()
		} else {
			self._xhr = xhr
			self._pos = 0
	
			self.url = xhr.responseURL
			self.statusCode = xhr.status
			self.statusMessage = xhr.statusText
			var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
			headers.forEach(function (header) {
				var matches = header.match(/^([^:]+):\s*(.*)/)
				if (matches) {
					var key = matches[1].toLowerCase()
					if (key === 'set-cookie') {
						if (self.headers[key] === undefined) {
							self.headers[key] = []
						}
						self.headers[key].push(matches[2])
					} else if (self.headers[key] !== undefined) {
						self.headers[key] += ', ' + matches[2]
					} else {
						self.headers[key] = matches[2]
					}
					self.rawHeaders.push(matches[1], matches[2])
				}
			})
	
			self._charset = 'x-user-defined'
			if (!capability.overrideMimeType) {
				var mimeType = self.rawHeaders['mime-type']
				if (mimeType) {
					var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
					if (charsetMatch) {
						self._charset = charsetMatch[1].toLowerCase()
					}
				}
				if (!self._charset)
					self._charset = 'utf-8' // best guess
			}
		}
	}
	
	inherits(IncomingMessage, stream.Readable)
	
	IncomingMessage.prototype._read = function () {
		var self = this
	
		var resolve = self._resumeFetch
		if (resolve) {
			self._resumeFetch = null
			resolve()
		}
	}
	
	IncomingMessage.prototype._onXHRProgress = function () {
		var self = this
	
		var xhr = self._xhr
	
		var response = null
		switch (self._mode) {
			case 'text:vbarray': // For IE9
				if (xhr.readyState !== rStates.DONE)
					break
				try {
					// This fails in IE8
					response = new global.VBArray(xhr.responseBody).toArray()
				} catch (e) {}
				if (response !== null) {
					self.push(new Buffer(response))
					break
				}
				// Falls through in IE8	
			case 'text':
				try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
					response = xhr.responseText
				} catch (e) {
					self._mode = 'text:vbarray'
					break
				}
				if (response.length > self._pos) {
					var newData = response.substr(self._pos)
					if (self._charset === 'x-user-defined') {
						var buffer = new Buffer(newData.length)
						for (var i = 0; i < newData.length; i++)
							buffer[i] = newData.charCodeAt(i) & 0xff
	
						self.push(buffer)
					} else {
						self.push(newData, self._charset)
					}
					self._pos = response.length
				}
				break
			case 'arraybuffer':
				if (xhr.readyState !== rStates.DONE || !xhr.response)
					break
				response = xhr.response
				self.push(new Buffer(new Uint8Array(response)))
				break
			case 'moz-chunked-arraybuffer': // take whole
				response = xhr.response
				if (xhr.readyState !== rStates.LOADING || !response)
					break
				self.push(new Buffer(new Uint8Array(response)))
				break
			case 'ms-stream':
				response = xhr.response
				if (xhr.readyState !== rStates.LOADING)
					break
				var reader = new global.MSStreamReader()
				reader.onprogress = function () {
					if (reader.result.byteLength > self._pos) {
						self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))))
						self._pos = reader.result.byteLength
					}
				}
				reader.onload = function () {
					self.push(null)
				}
				// reader.onerror = ??? // TODO: this
				reader.readAsArrayBuffer(response)
				break
		}
	
		// The ms-stream case handles end separately in reader.onload()
		if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
			self.push(null)
		}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(15).Buffer, (function() { return this; }())))

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(162).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fcf0bed18bb7094e2daa4e6df748beab.svg";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var bufferUtil;
	
	try {
	  bufferUtil = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"bufferutil\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	} catch (e) {
	  bufferUtil = __webpack_require__(1731);
	}
	
	module.exports = bufferUtil.BufferUtil || bufferUtil;


/***/ }),
/* 581 */
/***/ (function(module, exports) {

	/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	module.exports = {
	  isValidErrorCode: function(code) {
	    return (code >= 1000 && code <= 1011 && code != 1004 && code != 1005 && code != 1006) ||
	         (code >= 3000 && code <= 4999);
	  },
	  1000: 'normal',
	  1001: 'going away',
	  1002: 'protocol error',
	  1003: 'unsupported data',
	  1004: 'reserved',
	  1005: 'reserved for extensions',
	  1006: 'reserved for extensions',
	  1007: 'inconsistent or invalid data',
	  1008: 'policy violation',
	  1009: 'message too big',
	  1010: 'extension handshake missing',
	  1011: 'an unexpected condition prevented the request from being fulfilled',
	};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	
	var util = __webpack_require__(36);
	
	/**
	 * Module exports.
	 */
	
	exports.parse = parse;
	exports.format = format;
	
	/**
	 * Parse extensions header value
	 */
	
	function parse(value) {
	  value = value || '';
	
	  var extensions = {};
	
	  value.split(',').forEach(function(v) {
	    var params = v.split(';');
	    var token = params.shift().trim();
	
	    if (extensions[token] === undefined) {
	      extensions[token] = [];
	    } else if (!extensions.hasOwnProperty(token)) {
	      return;
	    }
	
	    var parsedParams = {};
	
	    params.forEach(function(param) {
	      var parts = param.trim().split('=');
	      var key = parts[0];
	      var value = parts[1];
	      if (typeof value === 'undefined') {
	        value = true;
	      } else {
	        // unquote value
	        if (value[0] === '"') {
	          value = value.slice(1);
	        }
	        if (value[value.length - 1] === '"') {
	          value = value.slice(0, value.length - 1);
	        }
	      }
	
	      if (parsedParams[key] === undefined) {
	        parsedParams[key] = [value];
	      } else if (parsedParams.hasOwnProperty(key)) {
	        parsedParams[key].push(value);
	      }
	    });
	
	    extensions[token].push(parsedParams);
	  });
	
	  return extensions;
	}
	
	/**
	 * Format extensions header value
	 */
	
	function format(value) {
	  return Object.keys(value).map(function(token) {
	    var paramsList = value[token];
	    if (!util.isArray(paramsList)) {
	      paramsList = [paramsList];
	    }
	    return paramsList.map(function(params) {
	      return [token].concat(Object.keys(params).map(function(k) {
	        var p = params[k];
	        if (!util.isArray(p)) p = [p];
	        return p.map(function(v) {
	          return v === true ? k : k + '=' + v;
	        }).join('; ');
	      })).join('; ');
	    }).join(', ');
	  }).join(', ');
	}


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var util = __webpack_require__(36)
	  , isValidUTF8 = __webpack_require__(1735)
	  , ErrorCodes = __webpack_require__(581)
	  , BufferPool = __webpack_require__(1730)
	  , bufferUtil = __webpack_require__(580)
	  , PerMessageDeflate = __webpack_require__(163);
	
	/**
	 * HyBi Receiver implementation
	 */
	
	function Receiver (extensions,maxPayload) {
	  if (this instanceof Receiver === false) {
	    throw new TypeError("Classes can't be function-called");
	  }
	  if(typeof extensions==='number'){
	    maxPayload=extensions;
	    extensions={};
	  }
	
	
	  // memory pool for fragmented messages
	  var fragmentedPoolPrevUsed = -1;
	  this.fragmentedBufferPool = new BufferPool(1024, function(db, length) {
	    return db.used + length;
	  }, function(db) {
	    return fragmentedPoolPrevUsed = fragmentedPoolPrevUsed >= 0 ?
	      Math.ceil((fragmentedPoolPrevUsed + db.used) / 2) :
	      db.used;
	  });
	
	  // memory pool for unfragmented messages
	  var unfragmentedPoolPrevUsed = -1;
	  this.unfragmentedBufferPool = new BufferPool(1024, function(db, length) {
	    return db.used + length;
	  }, function(db) {
	    return unfragmentedPoolPrevUsed = unfragmentedPoolPrevUsed >= 0 ?
	      Math.ceil((unfragmentedPoolPrevUsed + db.used) / 2) :
	      db.used;
	  });
	  this.extensions = extensions || {};
	  this.maxPayload = maxPayload || 0;
	  this.currentPayloadLength = 0;
	  this.state = {
	    activeFragmentedOperation: null,
	    lastFragment: false,
	    masked: false,
	    opcode: 0,
	    fragmentedOperation: false
	  };
	  this.overflow = [];
	  this.headerBuffer = new Buffer(10);
	  this.expectOffset = 0;
	  this.expectBuffer = null;
	  this.expectHandler = null;
	  this.currentMessage = [];
	  this.currentMessageLength = 0;
	  this.messageHandlers = [];
	  this.expectHeader(2, this.processPacket);
	  this.dead = false;
	  this.processing = false;
	
	  this.onerror = function() {};
	  this.ontext = function() {};
	  this.onbinary = function() {};
	  this.onclose = function() {};
	  this.onping = function() {};
	  this.onpong = function() {};
	}
	
	module.exports = Receiver;
	
	/**
	 * Add new data to the parser.
	 *
	 * @api public
	 */
	
	Receiver.prototype.add = function(data) {
	  if (this.dead) return;
	  var dataLength = data.length;
	  if (dataLength == 0) return;
	  if (this.expectBuffer == null) {
	    this.overflow.push(data);
	    return;
	  }
	  var toRead = Math.min(dataLength, this.expectBuffer.length - this.expectOffset);
	  fastCopy(toRead, data, this.expectBuffer, this.expectOffset);
	  this.expectOffset += toRead;
	  if (toRead < dataLength) {
	    this.overflow.push(data.slice(toRead));
	  }
	  while (this.expectBuffer && this.expectOffset == this.expectBuffer.length) {
	    var bufferForHandler = this.expectBuffer;
	    this.expectBuffer = null;
	    this.expectOffset = 0;
	    this.expectHandler.call(this, bufferForHandler);
	  }
	};
	
	/**
	 * Releases all resources used by the receiver.
	 *
	 * @api public
	 */
	
	Receiver.prototype.cleanup = function() {
	  this.dead = true;
	  this.overflow = null;
	  this.headerBuffer = null;
	  this.expectBuffer = null;
	  this.expectHandler = null;
	  this.unfragmentedBufferPool = null;
	  this.fragmentedBufferPool = null;
	  this.state = null;
	  this.currentMessage = null;
	  this.onerror = null;
	  this.ontext = null;
	  this.onbinary = null;
	  this.onclose = null;
	  this.onping = null;
	  this.onpong = null;
	};
	
	/**
	 * Waits for a certain amount of header bytes to be available, then fires a callback.
	 *
	 * @api private
	 */
	
	Receiver.prototype.expectHeader = function(length, handler) {
	  if (length == 0) {
	    handler(null);
	    return;
	  }
	  this.expectBuffer = this.headerBuffer.slice(this.expectOffset, this.expectOffset + length);
	  this.expectHandler = handler;
	  var toRead = length;
	  while (toRead > 0 && this.overflow.length > 0) {
	    var fromOverflow = this.overflow.pop();
	    if (toRead < fromOverflow.length) this.overflow.push(fromOverflow.slice(toRead));
	    var read = Math.min(fromOverflow.length, toRead);
	    fastCopy(read, fromOverflow, this.expectBuffer, this.expectOffset);
	    this.expectOffset += read;
	    toRead -= read;
	  }
	};
	
	/**
	 * Waits for a certain amount of data bytes to be available, then fires a callback.
	 *
	 * @api private
	 */
	
	Receiver.prototype.expectData = function(length, handler) {
	  if (length == 0) {
	    handler(null);
	    return;
	  }
	  this.expectBuffer = this.allocateFromPool(length, this.state.fragmentedOperation);
	  this.expectHandler = handler;
	  var toRead = length;
	  while (toRead > 0 && this.overflow.length > 0) {
	    var fromOverflow = this.overflow.pop();
	    if (toRead < fromOverflow.length) this.overflow.push(fromOverflow.slice(toRead));
	    var read = Math.min(fromOverflow.length, toRead);
	    fastCopy(read, fromOverflow, this.expectBuffer, this.expectOffset);
	    this.expectOffset += read;
	    toRead -= read;
	  }
	};
	
	/**
	 * Allocates memory from the buffer pool.
	 *
	 * @api private
	 */
	
	Receiver.prototype.allocateFromPool = function(length, isFragmented) {
	  return (isFragmented ? this.fragmentedBufferPool : this.unfragmentedBufferPool).get(length);
	};
	
	/**
	 * Start processing a new packet.
	 *
	 * @api private
	 */
	
	Receiver.prototype.processPacket = function (data) {
	  if (this.extensions[PerMessageDeflate.extensionName]) {
	    if ((data[0] & 0x30) != 0) {
	      this.error('reserved fields (2, 3) must be empty', 1002);
	      return;
	    }
	  } else {
	    if ((data[0] & 0x70) != 0) {
	      this.error('reserved fields must be empty', 1002);
	      return;
	    }
	  }
	  this.state.lastFragment = (data[0] & 0x80) == 0x80;
	  this.state.masked = (data[1] & 0x80) == 0x80;
	  var compressed = (data[0] & 0x40) == 0x40;
	  var opcode = data[0] & 0xf;
	  if (opcode === 0) {
	    if (compressed) {
	      this.error('continuation frame cannot have the Per-message Compressed bits', 1002);
	      return;
	    }
	    // continuation frame
	    this.state.fragmentedOperation = true;
	    this.state.opcode = this.state.activeFragmentedOperation;
	    if (!(this.state.opcode == 1 || this.state.opcode == 2)) {
	      this.error('continuation frame cannot follow current opcode', 1002);
	      return;
	    }
	  }
	  else {
	    if (opcode < 3 && this.state.activeFragmentedOperation != null) {
	      this.error('data frames after the initial data frame must have opcode 0', 1002);
	      return;
	    }
	    if (opcode >= 8 && compressed) {
	      this.error('control frames cannot have the Per-message Compressed bits', 1002);
	      return;
	    }
	    this.state.compressed = compressed;
	    this.state.opcode = opcode;
	    if (this.state.lastFragment === false) {
	      this.state.fragmentedOperation = true;
	      this.state.activeFragmentedOperation = opcode;
	    }
	    else this.state.fragmentedOperation = false;
	  }
	  var handler = opcodes[this.state.opcode];
	  if (typeof handler == 'undefined') this.error('no handler for opcode ' + this.state.opcode, 1002);
	  else {
	    handler.start.call(this, data);
	  }
	};
	
	/**
	 * Endprocessing a packet.
	 *
	 * @api private
	 */
	
	Receiver.prototype.endPacket = function() {
	  if (this.dead) return;
	  if (!this.state.fragmentedOperation) this.unfragmentedBufferPool.reset(true);
	  else if (this.state.lastFragment) this.fragmentedBufferPool.reset(true);
	  this.expectOffset = 0;
	  this.expectBuffer = null;
	  this.expectHandler = null;
	  if (this.state.lastFragment && this.state.opcode === this.state.activeFragmentedOperation) {
	    // end current fragmented operation
	    this.state.activeFragmentedOperation = null;
	  }
	  this.currentPayloadLength = 0;
	  this.state.lastFragment = false;
	  this.state.opcode = this.state.activeFragmentedOperation != null ? this.state.activeFragmentedOperation : 0;
	  this.state.masked = false;
	  this.expectHeader(2, this.processPacket);
	};
	
	/**
	 * Reset the parser state.
	 *
	 * @api private
	 */
	
	Receiver.prototype.reset = function() {
	  if (this.dead) return;
	  this.state = {
	    activeFragmentedOperation: null,
	    lastFragment: false,
	    masked: false,
	    opcode: 0,
	    fragmentedOperation: false
	  };
	  this.fragmentedBufferPool.reset(true);
	  this.unfragmentedBufferPool.reset(true);
	  this.expectOffset = 0;
	  this.expectBuffer = null;
	  this.expectHandler = null;
	  this.overflow = [];
	  this.currentMessage = [];
	  this.currentMessageLength = 0;
	  this.messageHandlers = [];
	  this.currentPayloadLength = 0;
	};
	
	/**
	 * Unmask received data.
	 *
	 * @api private
	 */
	
	Receiver.prototype.unmask = function (mask, buf, binary) {
	  if (mask != null && buf != null) bufferUtil.unmask(buf, mask);
	  if (binary) return buf;
	  return buf != null ? buf.toString('utf8') : '';
	};
	
	/**
	 * Handles an error
	 *
	 * @api private
	 */
	
	Receiver.prototype.error = function (reason, protocolErrorCode) {
	  if (this.dead) return;
	  this.reset();
	  if(typeof reason == 'string'){
	    this.onerror(new Error(reason), protocolErrorCode);
	  }
	  else if(reason.constructor == Error){
	    this.onerror(reason, protocolErrorCode);
	  }
	  else{
	    this.onerror(new Error("An error occured"),protocolErrorCode);
	  }
	  return this;
	};
	
	/**
	 * Execute message handler buffers
	 *
	 * @api private
	 */
	
	Receiver.prototype.flush = function() {
	  if (this.processing || this.dead) return;
	
	  var handler = this.messageHandlers.shift();
	  if (!handler) return;
	
	  this.processing = true;
	  var self = this;
	
	  handler(function() {
	    self.processing = false;
	    self.flush();
	  });
	};
	
	/**
	 * Apply extensions to message
	 *
	 * @api private
	 */
	
	Receiver.prototype.applyExtensions = function(messageBuffer, fin, compressed, callback) {
	  var self = this;
	  if (compressed) {
	    this.extensions[PerMessageDeflate.extensionName].decompress(messageBuffer, fin, function(err, buffer) {
	      if (self.dead) return;
	      if (err) {
	        callback(new Error('invalid compressed data'));
	        return;
	      }
	      callback(null, buffer);
	    });
	  } else {
	    callback(null, messageBuffer);
	  }
	};
	
	/**
	* Checks payload size, disconnects socket when it exceeds maxPayload
	*
	* @api private
	*/
	Receiver.prototype.maxPayloadExceeded = function(length) {
	  if (this.maxPayload=== undefined || this.maxPayload === null || this.maxPayload < 1) {
	    return false;
	  }
	  var fullLength = this.currentPayloadLength + length;
	  if (fullLength < this.maxPayload) {
	    this.currentPayloadLength = fullLength;
	    return false;
	  }
	  this.error('payload cannot exceed ' + this.maxPayload + ' bytes', 1009);
	  this.messageBuffer=[];
	  this.cleanup();
	
	  return true;
	};
	
	/**
	 * Buffer utilities
	 */
	
	function readUInt16BE(start) {
	  return (this[start]<<8) +
	         this[start+1];
	}
	
	function readUInt32BE(start) {
	  return (this[start]<<24) +
	         (this[start+1]<<16) +
	         (this[start+2]<<8) +
	         this[start+3];
	}
	
	function fastCopy(length, srcBuffer, dstBuffer, dstOffset) {
	  switch (length) {
	    default: srcBuffer.copy(dstBuffer, dstOffset, 0, length); break;
	    case 16: dstBuffer[dstOffset+15] = srcBuffer[15];
	    case 15: dstBuffer[dstOffset+14] = srcBuffer[14];
	    case 14: dstBuffer[dstOffset+13] = srcBuffer[13];
	    case 13: dstBuffer[dstOffset+12] = srcBuffer[12];
	    case 12: dstBuffer[dstOffset+11] = srcBuffer[11];
	    case 11: dstBuffer[dstOffset+10] = srcBuffer[10];
	    case 10: dstBuffer[dstOffset+9] = srcBuffer[9];
	    case 9: dstBuffer[dstOffset+8] = srcBuffer[8];
	    case 8: dstBuffer[dstOffset+7] = srcBuffer[7];
	    case 7: dstBuffer[dstOffset+6] = srcBuffer[6];
	    case 6: dstBuffer[dstOffset+5] = srcBuffer[5];
	    case 5: dstBuffer[dstOffset+4] = srcBuffer[4];
	    case 4: dstBuffer[dstOffset+3] = srcBuffer[3];
	    case 3: dstBuffer[dstOffset+2] = srcBuffer[2];
	    case 2: dstBuffer[dstOffset+1] = srcBuffer[1];
	    case 1: dstBuffer[dstOffset] = srcBuffer[0];
	  }
	}
	
	function clone(obj) {
	  var cloned = {};
	  for (var k in obj) {
	    if (obj.hasOwnProperty(k)) {
	      cloned[k] = obj[k];
	    }
	  }
	  return cloned;
	}
	
	/**
	 * Opcode handlers
	 */
	
	var opcodes = {
	  // text
	  '1': {
	    start: function(data) {
	      var self = this;
	      // decode length
	      var firstLength = data[1] & 0x7f;
	      if (firstLength < 126) {
	        if (self.maxPayloadExceeded(firstLength)){
	          self.error('Maximumpayload exceeded in compressed text message. Aborting...', 1009);
	          return;
	        }
	        opcodes['1'].getData.call(self, firstLength);
	      }
	      else if (firstLength == 126) {
	        self.expectHeader(2, function(data) {
	          var length = readUInt16BE.call(data, 0);
	          if (self.maxPayloadExceeded(length)){
	            self.error('Maximumpayload exceeded in compressed text message. Aborting...', 1009);
	            return;
	          }
	          opcodes['1'].getData.call(self, length);
	        });
	      }
	      else if (firstLength == 127) {
	        self.expectHeader(8, function(data) {
	          if (readUInt32BE.call(data, 0) != 0) {
	            self.error('packets with length spanning more than 32 bit is currently not supported', 1008);
	            return;
	          }
	          var length = readUInt32BE.call(data, 4);
	          if (self.maxPayloadExceeded(length)){
	            self.error('Maximumpayload exceeded in compressed text message. Aborting...', 1009);
	            return;
	          }
	          opcodes['1'].getData.call(self, readUInt32BE.call(data, 4));
	        });
	      }
	    },
	    getData: function(length) {
	      var self = this;
	      if (self.state.masked) {
	        self.expectHeader(4, function(data) {
	          var mask = data;
	          self.expectData(length, function(data) {
	            opcodes['1'].finish.call(self, mask, data);
	          });
	        });
	      }
	      else {
	        self.expectData(length, function(data) {
	          opcodes['1'].finish.call(self, null, data);
	        });
	      }
	    },
	    finish: function(mask, data) {
	      var self = this;
	      var packet = this.unmask(mask, data, true) || new Buffer(0);
	      var state = clone(this.state);
	      this.messageHandlers.push(function(callback) {
	        self.applyExtensions(packet, state.lastFragment, state.compressed, function(err, buffer) {
	          if (err) {
	            if(err.type===1009){
	                return self.error('Maximumpayload exceeded in compressed text message. Aborting...', 1009);
	            }
	            return self.error(err.message, 1007);
	          }
	          if (buffer != null) {
	            if( self.maxPayload==0 || (self.maxPayload > 0 && (self.currentMessageLength + buffer.length) < self.maxPayload) ){
	              self.currentMessage.push(buffer);
	            }
	            else{
	                self.currentMessage=null;
	                self.currentMessage = [];
	                self.currentMessageLength = 0;
	                self.error(new Error('Maximum payload exceeded. maxPayload: '+self.maxPayload), 1009);
	                return;
	            }
	            self.currentMessageLength += buffer.length;
	          }
	          if (state.lastFragment) {
	            var messageBuffer = Buffer.concat(self.currentMessage);
	            self.currentMessage = [];
	            self.currentMessageLength = 0;
	            if (!isValidUTF8(messageBuffer)) {
	              self.error('invalid utf8 sequence', 1007);
	              return;
	            }
	            self.ontext(messageBuffer.toString('utf8'), {masked: state.masked, buffer: messageBuffer});
	          }
	          callback();
	        });
	      });
	      this.flush();
	      this.endPacket();
	    }
	  },
	  // binary
	  '2': {
	    start: function(data) {
	      var self = this;
	      // decode length
	      var firstLength = data[1] & 0x7f;
	      if (firstLength < 126) {
	          if (self.maxPayloadExceeded(firstLength)){
	            self.error('Max payload exceeded in compressed text message. Aborting...', 1009);
	            return;
	          }
	        opcodes['2'].getData.call(self, firstLength);
	      }
	      else if (firstLength == 126) {
	        self.expectHeader(2, function(data) {
	          var length = readUInt16BE.call(data, 0);
	          if (self.maxPayloadExceeded(length)){
	            self.error('Max payload exceeded in compressed text message. Aborting...', 1009);
	            return;
	          }
	          opcodes['2'].getData.call(self, length);
	        });
	      }
	      else if (firstLength == 127) {
	        self.expectHeader(8, function(data) {
	          if (readUInt32BE.call(data, 0) != 0) {
	            self.error('packets with length spanning more than 32 bit is currently not supported', 1008);
	            return;
	          }
	          var length = readUInt32BE.call(data, 4, true);
	          if (self.maxPayloadExceeded(length)){
	            self.error('Max payload exceeded in compressed text message. Aborting...', 1009);
	            return;
	          }
	          opcodes['2'].getData.call(self, length);
	        });
	      }
	    },
	    getData: function(length) {
	      var self = this;
	      if (self.state.masked) {
	        self.expectHeader(4, function(data) {
	          var mask = data;
	          self.expectData(length, function(data) {
	            opcodes['2'].finish.call(self, mask, data);
	          });
	        });
	      }
	      else {
	        self.expectData(length, function(data) {
	          opcodes['2'].finish.call(self, null, data);
	        });
	      }
	    },
	    finish: function(mask, data) {
	      var self = this;
	      var packet = this.unmask(mask, data, true) || new Buffer(0);
	      var state = clone(this.state);
	      this.messageHandlers.push(function(callback) {
	        self.applyExtensions(packet, state.lastFragment, state.compressed, function(err, buffer) {
	          if (err) {
	            if(err.type===1009){
	                return self.error('Max payload exceeded in compressed binary message. Aborting...', 1009);
	            }
	            return self.error(err.message, 1007);
	          }
	          if (buffer != null) {
	            if( self.maxPayload==0 || (self.maxPayload > 0 && (self.currentMessageLength + buffer.length) < self.maxPayload) ){
	              self.currentMessage.push(buffer);
	            }
	            else{
	                self.currentMessage=null;
	                self.currentMessage = [];
	                self.currentMessageLength = 0;
	                self.error(new Error('Maximum payload exceeded'), 1009);
	                return;
	            }
	            self.currentMessageLength += buffer.length;
	          }
	          if (state.lastFragment) {
	            var messageBuffer = Buffer.concat(self.currentMessage);
	            self.currentMessage = [];
	            self.currentMessageLength = 0;
	            self.onbinary(messageBuffer, {masked: state.masked, buffer: messageBuffer});
	          }
	          callback();
	        });
	      });
	      this.flush();
	      this.endPacket();
	    }
	  },
	  // close
	  '8': {
	    start: function(data) {
	      var self = this;
	      if (self.state.lastFragment == false) {
	        self.error('fragmented close is not supported', 1002);
	        return;
	      }
	
	      // decode length
	      var firstLength = data[1] & 0x7f;
	      if (firstLength < 126) {
	        opcodes['8'].getData.call(self, firstLength);
	      }
	      else {
	        self.error('control frames cannot have more than 125 bytes of data', 1002);
	      }
	    },
	    getData: function(length) {
	      var self = this;
	      if (self.state.masked) {
	        self.expectHeader(4, function(data) {
	          var mask = data;
	          self.expectData(length, function(data) {
	            opcodes['8'].finish.call(self, mask, data);
	          });
	        });
	      }
	      else {
	        self.expectData(length, function(data) {
	          opcodes['8'].finish.call(self, null, data);
	        });
	      }
	    },
	    finish: function(mask, data) {
	      var self = this;
	      data = self.unmask(mask, data, true);
	
	      var state = clone(this.state);
	      this.messageHandlers.push(function() {
	        if (data && data.length == 1) {
	          self.error('close packets with data must be at least two bytes long', 1002);
	          return;
	        }
	        var code = data && data.length > 1 ? readUInt16BE.call(data, 0) : 1000;
	        if (!ErrorCodes.isValidErrorCode(code)) {
	          self.error('invalid error code', 1002);
	          return;
	        }
	        var message = '';
	        if (data && data.length > 2) {
	          var messageBuffer = data.slice(2);
	          if (!isValidUTF8(messageBuffer)) {
	            self.error('invalid utf8 sequence', 1007);
	            return;
	          }
	          message = messageBuffer.toString('utf8');
	        }
	        self.onclose(code, message, {masked: state.masked});
	        self.reset();
	      });
	      this.flush();
	    },
	  },
	  // ping
	  '9': {
	    start: function(data) {
	      var self = this;
	      if (self.state.lastFragment == false) {
	        self.error('fragmented ping is not supported', 1002);
	        return;
	      }
	
	      // decode length
	      var firstLength = data[1] & 0x7f;
	      if (firstLength < 126) {
	        opcodes['9'].getData.call(self, firstLength);
	      }
	      else {
	        self.error('control frames cannot have more than 125 bytes of data', 1002);
	      }
	    },
	    getData: function(length) {
	      var self = this;
	      if (self.state.masked) {
	        self.expectHeader(4, function(data) {
	          var mask = data;
	          self.expectData(length, function(data) {
	            opcodes['9'].finish.call(self, mask, data);
	          });
	        });
	      }
	      else {
	        self.expectData(length, function(data) {
	          opcodes['9'].finish.call(self, null, data);
	        });
	      }
	    },
	    finish: function(mask, data) {
	      var self = this;
	      data = this.unmask(mask, data, true);
	      var state = clone(this.state);
	      this.messageHandlers.push(function(callback) {
	        self.onping(data, {masked: state.masked, binary: true});
	        callback();
	      });
	      this.flush();
	      this.endPacket();
	    }
	  },
	  // pong
	  '10': {
	    start: function(data) {
	      var self = this;
	      if (self.state.lastFragment == false) {
	        self.error('fragmented pong is not supported', 1002);
	        return;
	      }
	
	      // decode length
	      var firstLength = data[1] & 0x7f;
	      if (firstLength < 126) {
	        opcodes['10'].getData.call(self, firstLength);
	      }
	      else {
	        self.error('control frames cannot have more than 125 bytes of data', 1002);
	      }
	    },
	    getData: function(length) {
	      var self = this;
	      if (this.state.masked) {
	        this.expectHeader(4, function(data) {
	          var mask = data;
	          self.expectData(length, function(data) {
	            opcodes['10'].finish.call(self, mask, data);
	          });
	        });
	      }
	      else {
	        this.expectData(length, function(data) {
	          opcodes['10'].finish.call(self, null, data);
	        });
	      }
	    },
	    finish: function(mask, data) {
	      var self = this;
	      data = self.unmask(mask, data, true);
	      var state = clone(this.state);
	      this.messageHandlers.push(function(callback) {
	        self.onpong(data, {masked: state.masked, binary: true});
	        callback();
	      });
	      this.flush();
	      this.endPacket();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var events = __webpack_require__(70)
	  , util = __webpack_require__(36)
	  , crypto = __webpack_require__(189)
	  , EventEmitter = events.EventEmitter
	  , ErrorCodes = __webpack_require__(581)
	  , bufferUtil = __webpack_require__(580)
	  , PerMessageDeflate = __webpack_require__(163);
	
	/**
	 * HyBi Sender implementation
	 */
	
	function Sender(socket, extensions) {
	  if (this instanceof Sender === false) {
	    throw new TypeError("Classes can't be function-called");
	  }
	
	  events.EventEmitter.call(this);
	
	  this._socket = socket;
	  this.extensions = extensions || {};
	  this.firstFragment = true;
	  this.compress = false;
	  this.messageHandlers = [];
	  this.processing = false;
	}
	
	/**
	 * Inherits from EventEmitter.
	 */
	
	util.inherits(Sender, events.EventEmitter);
	
	/**
	 * Sends a close instruction to the remote party.
	 *
	 * @api public
	 */
	
	Sender.prototype.close = function(code, data, mask, cb) {
	  if (typeof code !== 'undefined') {
	    if (typeof code !== 'number' ||
	      !ErrorCodes.isValidErrorCode(code)) throw new Error('first argument must be a valid error code number');
	  }
	  code = code || 1000;
	  var dataBuffer = new Buffer(2 + (data ? Buffer.byteLength(data) : 0));
	  writeUInt16BE.call(dataBuffer, code, 0);
	  if (dataBuffer.length > 2) dataBuffer.write(data, 2);
	
	  var self = this;
	  this.messageHandlers.push(function() {
	    self.frameAndSend(0x8, dataBuffer, true, mask);
	    if (typeof cb == 'function') cb();
	  });
	  this.flush();
	};
	
	/**
	 * Sends a ping message to the remote party.
	 *
	 * @api public
	 */
	
	Sender.prototype.ping = function(data, options) {
	  var mask = options && options.mask;
	  var self = this;
	  this.messageHandlers.push(function() {
	    self.frameAndSend(0x9, data || '', true, mask);
	  });
	  this.flush();
	};
	
	/**
	 * Sends a pong message to the remote party.
	 *
	 * @api public
	 */
	
	Sender.prototype.pong = function(data, options) {
	  var mask = options && options.mask;
	  var self = this;
	  this.messageHandlers.push(function() {
	    self.frameAndSend(0xa, data || '', true, mask);
	  });
	  this.flush();
	};
	
	/**
	 * Sends text or binary data to the remote party.
	 *
	 * @api public
	 */
	
	Sender.prototype.send = function(data, options, cb) {
	  var finalFragment = options && options.fin === false ? false : true;
	  var mask = options && options.mask;
	  var compress = options && options.compress;
	  var opcode = options && options.binary ? 2 : 1;
	  if (this.firstFragment === false) {
	    opcode = 0;
	    compress = false;
	  } else {
	    this.firstFragment = false;
	    this.compress = compress;
	  }
	  if (finalFragment) this.firstFragment = true
	
	  var compressFragment = this.compress;
	
	  var self = this;
	  this.messageHandlers.push(function() {
	    if (!data || !compressFragment) {
	      self.frameAndSend(opcode, data, finalFragment, mask, compress, cb);
	      return;
	    }
	
	    self.processing = true;
	    self.applyExtensions(data, finalFragment, compressFragment, function(err, data) {
	      if (err) {
	        if (typeof cb == 'function') cb(err);
	        else self.emit('error', err);
	        return;
	      }
	      self.frameAndSend(opcode, data, finalFragment, mask, compress, cb);
	      self.processing = false;
	      self.flush();
	    });
	  });
	  this.flush();
	};
	
	/**
	 * Frames and sends a piece of data according to the HyBi WebSocket protocol.
	 *
	 * @api private
	 */
	
	Sender.prototype.frameAndSend = function(opcode, data, finalFragment, maskData, compressed, cb) {
	  var canModifyData = false;
	
	  if (!data) {
	    try {
	      this._socket.write(new Buffer([opcode | (finalFragment ? 0x80 : 0), 0 | (maskData ? 0x80 : 0)].concat(maskData ? [0, 0, 0, 0] : [])), 'binary', cb);
	    }
	    catch (e) {
	      if (typeof cb == 'function') cb(e);
	      else this.emit('error', e);
	    }
	    return;
	  }
	
	  if (!Buffer.isBuffer(data)) {
	    canModifyData = true;
	    if (data && (typeof data.byteLength !== 'undefined' || typeof data.buffer !== 'undefined')) {
	      data = getArrayBuffer(data);
	    } else {
	      //
	      // If people want to send a number, this would allocate the number in
	      // bytes as memory size instead of storing the number as buffer value. So
	      // we need to transform it to string in order to prevent possible
	      // vulnerabilities / memory attacks.
	      //
	      if (typeof data === 'number') data = data.toString();
	
	      data = new Buffer(data);
	    }
	  }
	
	  var dataLength = data.length
	    , dataOffset = maskData ? 6 : 2
	    , secondByte = dataLength;
	
	  if (dataLength >= 65536) {
	    dataOffset += 8;
	    secondByte = 127;
	  }
	  else if (dataLength > 125) {
	    dataOffset += 2;
	    secondByte = 126;
	  }
	
	  var mergeBuffers = dataLength < 32768 || (maskData && !canModifyData);
	  var totalLength = mergeBuffers ? dataLength + dataOffset : dataOffset;
	  var outputBuffer = new Buffer(totalLength);
	  outputBuffer[0] = finalFragment ? opcode | 0x80 : opcode;
	  if (compressed) outputBuffer[0] |= 0x40;
	
	  switch (secondByte) {
	    case 126:
	      writeUInt16BE.call(outputBuffer, dataLength, 2);
	      break;
	    case 127:
	      writeUInt32BE.call(outputBuffer, 0, 2);
	      writeUInt32BE.call(outputBuffer, dataLength, 6);
	  }
	
	  if (maskData) {
	    outputBuffer[1] = secondByte | 0x80;
	    var mask = getRandomMask();
	    outputBuffer[dataOffset - 4] = mask[0];
	    outputBuffer[dataOffset - 3] = mask[1];
	    outputBuffer[dataOffset - 2] = mask[2];
	    outputBuffer[dataOffset - 1] = mask[3];
	    if (mergeBuffers) {
	      bufferUtil.mask(data, mask, outputBuffer, dataOffset, dataLength);
	      try {
	        this._socket.write(outputBuffer, 'binary', cb);
	      }
	      catch (e) {
	        if (typeof cb == 'function') cb(e);
	        else this.emit('error', e);
	      }
	    }
	    else {
	      bufferUtil.mask(data, mask, data, 0, dataLength);
	      try {
	        this._socket.write(outputBuffer, 'binary');
	        this._socket.write(data, 'binary', cb);
	      }
	      catch (e) {
	        if (typeof cb == 'function') cb(e);
	        else this.emit('error', e);
	      }
	    }
	  }
	  else {
	    outputBuffer[1] = secondByte;
	    if (mergeBuffers) {
	      data.copy(outputBuffer, dataOffset);
	      try {
	        this._socket.write(outputBuffer, 'binary', cb);
	      }
	      catch (e) {
	        if (typeof cb == 'function') cb(e);
	        else this.emit('error', e);
	      }
	    }
	    else {
	      try {
	        this._socket.write(outputBuffer, 'binary');
	        this._socket.write(data, 'binary', cb);
	      }
	      catch (e) {
	        if (typeof cb == 'function') cb(e);
	        else this.emit('error', e);
	      }
	    }
	  }
	};
	
	/**
	 * Execute message handler buffers
	 *
	 * @api private
	 */
	
	Sender.prototype.flush = function() {
	  while (!this.processing && this.messageHandlers.length) {
	    this.messageHandlers.shift()();
	  }
	};
	
	/**
	 * Apply extensions to message
	 *
	 * @api private
	 */
	
	Sender.prototype.applyExtensions = function(data, fin, compress, callback) {
	  if ((data.buffer || data) instanceof ArrayBuffer) {
	    data = getArrayBuffer(data);
	  }
	  this.extensions[PerMessageDeflate.extensionName].compress(data, fin, callback);
	};
	
	module.exports = Sender;
	
	function writeUInt16BE(value, offset) {
	  this[offset] = (value & 0xff00)>>8;
	  this[offset+1] = value & 0xff;
	}
	
	function writeUInt32BE(value, offset) {
	  this[offset] = (value & 0xff000000)>>24;
	  this[offset+1] = (value & 0xff0000)>>16;
	  this[offset+2] = (value & 0xff00)>>8;
	  this[offset+3] = value & 0xff;
	}
	
	function getArrayBuffer(data) {
	  // data is either an ArrayBuffer or ArrayBufferView.
	  var array = new Uint8Array(data.buffer || data)
	    , l = data.byteLength || data.length
	    , o = data.byteOffset || 0
	    , buffer = new Buffer(l);
	  for (var i = 0; i < l; ++i) {
	    buffer[i] = array[o+i];
	  }
	  return buffer;
	}
	
	function getRandomMask() {
	  return crypto.randomBytes(4);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {'use strict';
	
	/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var url = __webpack_require__(261)
	  , util = __webpack_require__(36)
	  , http = __webpack_require__(259)
	  , https = __webpack_require__(860)
	  , crypto = __webpack_require__(189)
	  , stream = __webpack_require__(575)
	  , Ultron = __webpack_require__(1716)
	  , Options = __webpack_require__(527)
	  , Sender = __webpack_require__(584)
	  , Receiver = __webpack_require__(583)
	  , SenderHixie = __webpack_require__(1733)
	  , ReceiverHixie = __webpack_require__(1732)
	  , Extensions = __webpack_require__(582)
	  , PerMessageDeflate = __webpack_require__(163)
	  , EventEmitter = __webpack_require__(70).EventEmitter;
	
	/**
	 * Constants
	 */
	
	// Default protocol version
	
	var protocolVersion = 13;
	
	// Close timeout
	
	var closeTimeout = 30 * 1000; // Allow 30 seconds to terminate the connection cleanly
	
	/**
	 * WebSocket implementation
	 *
	 * @constructor
	 * @param {String} address Connection address.
	 * @param {String|Array} protocols WebSocket protocols.
	 * @param {Object} options Additional connection options.
	 * @api public
	 */
	function WebSocket(address, protocols, options) {
	  if (this instanceof WebSocket === false) {
	    return new WebSocket(address, protocols, options);
	  }
	
	  EventEmitter.call(this);
	
	  if (protocols && !Array.isArray(protocols) && 'object' === typeof protocols) {
	    // accept the "options" Object as the 2nd argument
	    options = protocols;
	    protocols = null;
	  }
	
	  if ('string' === typeof protocols) {
	    protocols = [ protocols ];
	  }
	
	  if (!Array.isArray(protocols)) {
	    protocols = [];
	  }
	
	  this._socket = null;
	  this._ultron = null;
	  this._closeReceived = false;
	  this.bytesReceived = 0;
	  this.readyState = null;
	  this.supports = {};
	  this.extensions = {};
	  this._binaryType = 'nodebuffer';
	
	  if (Array.isArray(address)) {
	    initAsServerClient.apply(this, address.concat(options));
	  } else {
	    initAsClient.apply(this, [address, protocols, options]);
	  }
	}
	
	/**
	 * Inherits from EventEmitter.
	 */
	util.inherits(WebSocket, EventEmitter);
	
	/**
	 * Ready States
	 */
	["CONNECTING", "OPEN", "CLOSING", "CLOSED"].forEach(function each(state, index) {
	    WebSocket.prototype[state] = WebSocket[state] = index;
	});
	
	/**
	 * Gracefully closes the connection, after sending a description message to the server
	 *
	 * @param {Object} data to be sent to the server
	 * @api public
	 */
	WebSocket.prototype.close = function close(code, data) {
	  if (this.readyState === WebSocket.CLOSED) return;
	
	  if (this.readyState === WebSocket.CONNECTING) {
	    this.readyState = WebSocket.CLOSED;
	    return;
	  }
	
	  if (this.readyState === WebSocket.CLOSING) {
	    if (this._closeReceived && this._isServer) {
	      this.terminate();
	    }
	    return;
	  }
	
	  var self = this;
	  try {
	    this.readyState = WebSocket.CLOSING;
	    this._closeCode = code;
	    this._closeMessage = data;
	    var mask = !this._isServer;
	    this._sender.close(code, data, mask, function(err) {
	      if (err) self.emit('error', err);
	
	      if (self._closeReceived && self._isServer) {
	        self.terminate();
	      } else {
	        // ensure that the connection is cleaned up even when no response of closing handshake.
	        clearTimeout(self._closeTimer);
	        self._closeTimer = setTimeout(cleanupWebsocketResources.bind(self, true), closeTimeout);
	      }
	    });
	  } catch (e) {
	    this.emit('error', e);
	  }
	};
	
	/**
	 * Pause the client stream
	 *
	 * @api public
	 */
	WebSocket.prototype.pause = function pauser() {
	  if (this.readyState !== WebSocket.OPEN) throw new Error('not opened');
	
	  return this._socket.pause();
	};
	
	/**
	 * Sends a ping
	 *
	 * @param {Object} data to be sent to the server
	 * @param {Object} Members - mask: boolean, binary: boolean
	 * @param {boolean} dontFailWhenClosed indicates whether or not to throw if the connection isnt open
	 * @api public
	 */
	WebSocket.prototype.ping = function ping(data, options, dontFailWhenClosed) {
	  if (this.readyState !== WebSocket.OPEN) {
	    if (dontFailWhenClosed === true) return;
	    throw new Error('not opened');
	  }
	
	  options = options || {};
	
	  if (typeof options.mask === 'undefined') options.mask = !this._isServer;
	
	  this._sender.ping(data, options);
	};
	
	/**
	 * Sends a pong
	 *
	 * @param {Object} data to be sent to the server
	 * @param {Object} Members - mask: boolean, binary: boolean
	 * @param {boolean} dontFailWhenClosed indicates whether or not to throw if the connection isnt open
	 * @api public
	 */
	WebSocket.prototype.pong = function(data, options, dontFailWhenClosed) {
	  if (this.readyState !== WebSocket.OPEN) {
	    if (dontFailWhenClosed === true) return;
	    throw new Error('not opened');
	  }
	
	  options = options || {};
	
	  if (typeof options.mask === 'undefined') options.mask = !this._isServer;
	
	  this._sender.pong(data, options);
	};
	
	/**
	 * Resume the client stream
	 *
	 * @api public
	 */
	WebSocket.prototype.resume = function resume() {
	  if (this.readyState !== WebSocket.OPEN) throw new Error('not opened');
	
	  return this._socket.resume();
	};
	
	/**
	 * Sends a piece of data
	 *
	 * @param {Object} data to be sent to the server
	 * @param {Object} Members - mask: boolean, binary: boolean, compress: boolean
	 * @param {function} Optional callback which is executed after the send completes
	 * @api public
	 */
	
	WebSocket.prototype.send = function send(data, options, cb) {
	  if (typeof options === 'function') {
	    cb = options;
	    options = {};
	  }
	
	  if (this.readyState !== WebSocket.OPEN) {
	    if (typeof cb === 'function') cb(new Error('not opened'));
	    else throw new Error('not opened');
	    return;
	  }
	
	  if (!data) data = '';
	  if (this._queue) {
	    var self = this;
	    this._queue.push(function() { self.send(data, options, cb); });
	    return;
	  }
	
	  options = options || {};
	  options.fin = true;
	
	  if (typeof options.binary === 'undefined') {
	    options.binary = (data instanceof ArrayBuffer || data instanceof Buffer ||
	      data instanceof Uint8Array ||
	      data instanceof Uint16Array ||
	      data instanceof Uint32Array ||
	      data instanceof Int8Array ||
	      data instanceof Int16Array ||
	      data instanceof Int32Array ||
	      data instanceof Float32Array ||
	      data instanceof Float64Array);
	  }
	
	  if (typeof options.mask === 'undefined') options.mask = !this._isServer;
	  if (typeof options.compress === 'undefined') options.compress = true;
	  if (!this.extensions[PerMessageDeflate.extensionName]) {
	    options.compress = false;
	  }
	
	  var readable = typeof stream.Readable === 'function'
	    ? stream.Readable
	    : stream.Stream;
	
	  if (data instanceof readable) {
	    startQueue(this);
	    var self = this;
	
	    sendStream(this, data, options, function send(error) {
	      process.nextTick(function tock() {
	        executeQueueSends(self);
	      });
	
	      if (typeof cb === 'function') cb(error);
	    });
	  } else {
	    this._sender.send(data, options, cb);
	  }
	};
	
	/**
	 * Streams data through calls to a user supplied function
	 *
	 * @param {Object} Members - mask: boolean, binary: boolean, compress: boolean
	 * @param {function} 'function (error, send)' which is executed on successive ticks of which send is 'function (data, final)'.
	 * @api public
	 */
	WebSocket.prototype.stream = function stream(options, cb) {
	  if (typeof options === 'function') {
	    cb = options;
	    options = {};
	  }
	
	  var self = this;
	
	  if (typeof cb !== 'function') throw new Error('callback must be provided');
	
	  if (this.readyState !== WebSocket.OPEN) {
	    if (typeof cb === 'function') cb(new Error('not opened'));
	    else throw new Error('not opened');
	    return;
	  }
	
	  if (this._queue) {
	    this._queue.push(function () { self.stream(options, cb); });
	    return;
	  }
	
	  options = options || {};
	
	  if (typeof options.mask === 'undefined') options.mask = !this._isServer;
	  if (typeof options.compress === 'undefined') options.compress = true;
	  if (!this.extensions[PerMessageDeflate.extensionName]) {
	    options.compress = false;
	  }
	
	  startQueue(this);
	
	  function send(data, final) {
	    try {
	      if (self.readyState !== WebSocket.OPEN) throw new Error('not opened');
	      options.fin = final === true;
	      self._sender.send(data, options);
	      if (!final) process.nextTick(cb.bind(null, null, send));
	      else executeQueueSends(self);
	    } catch (e) {
	      if (typeof cb === 'function') cb(e);
	      else {
	        delete self._queue;
	        self.emit('error', e);
	      }
	    }
	  }
	
	  process.nextTick(cb.bind(null, null, send));
	};
	
	/**
	 * Immediately shuts down the connection
	 *
	 * @api public
	 */
	WebSocket.prototype.terminate = function terminate() {
	  if (this.readyState === WebSocket.CLOSED) return;
	
	  if (this._socket) {
	    this.readyState = WebSocket.CLOSING;
	
	    // End the connection
	    try { this._socket.end(); }
	    catch (e) {
	      // Socket error during end() call, so just destroy it right now
	      cleanupWebsocketResources.call(this, true);
	      return;
	    }
	
	    // Add a timeout to ensure that the connection is completely
	    // cleaned up within 30 seconds, even if the clean close procedure
	    // fails for whatever reason
	    // First cleanup any pre-existing timeout from an earlier "terminate" call,
	    // if one exists.  Otherwise terminate calls in quick succession will leak timeouts
	    // and hold the program open for `closeTimout` time.
	    if (this._closeTimer) { clearTimeout(this._closeTimer); }
	    this._closeTimer = setTimeout(cleanupWebsocketResources.bind(this, true), closeTimeout);
	  } else if (this.readyState === WebSocket.CONNECTING) {
	    cleanupWebsocketResources.call(this, true);
	  }
	};
	
	/**
	 * Expose bufferedAmount
	 *
	 * @api public
	 */
	Object.defineProperty(WebSocket.prototype, 'bufferedAmount', {
	  get: function get() {
	    var amount = 0;
	    if (this._socket) {
	      amount = this._socket.bufferSize || 0;
	    }
	    return amount;
	  }
	});
	
	/**
	 * Expose binaryType
	 *
	 * This deviates from the W3C interface since ws doesn't support the required
	 * default "blob" type (instead we define a custom "nodebuffer" type).
	 *
	 * @see http://dev.w3.org/html5/websockets/#the-websocket-interface
	 * @api public
	 */
	Object.defineProperty(WebSocket.prototype, 'binaryType', {
	  get: function get() {
	    return this._binaryType;
	  },
	  set: function set(type) {
	    if (type === 'arraybuffer' || type === 'nodebuffer')
	      this._binaryType = type;
	    else
	      throw new SyntaxError('unsupported binaryType: must be either "nodebuffer" or "arraybuffer"');
	  }
	});
	
	/**
	 * Emulates the W3C Browser based WebSocket interface using function members.
	 *
	 * @see http://dev.w3.org/html5/websockets/#the-websocket-interface
	 * @api public
	 */
	['open', 'error', 'close', 'message'].forEach(function(method) {
	  Object.defineProperty(WebSocket.prototype, 'on' + method, {
	    /**
	     * Returns the current listener
	     *
	     * @returns {Mixed} the set function or undefined
	     * @api public
	     */
	    get: function get() {
	      var listener = this.listeners(method)[0];
	      return listener ? (listener._listener ? listener._listener : listener) : undefined;
	    },
	
	    /**
	     * Start listening for events
	     *
	     * @param {Function} listener the listener
	     * @returns {Mixed} the set function or undefined
	     * @api public
	     */
	    set: function set(listener) {
	      this.removeAllListeners(method);
	      this.addEventListener(method, listener);
	    }
	  });
	});
	
	/**
	 * Emulates the W3C Browser based WebSocket interface using addEventListener.
	 *
	 * @see https://developer.mozilla.org/en/DOM/element.addEventListener
	 * @see http://dev.w3.org/html5/websockets/#the-websocket-interface
	 * @api public
	 */
	WebSocket.prototype.addEventListener = function(method, listener) {
	  var target = this;
	
	  function onMessage (data, flags) {
	    if (flags.binary && this.binaryType === 'arraybuffer')
	        data = new Uint8Array(data).buffer;
	    listener.call(target, new MessageEvent(data, !!flags.binary, target));
	  }
	
	  function onClose (code, message) {
	    listener.call(target, new CloseEvent(code, message, target));
	  }
	
	  function onError (event) {
	    event.type = 'error';
	    event.target = target;
	    listener.call(target, event);
	  }
	
	  function onOpen () {
	    listener.call(target, new OpenEvent(target));
	  }
	
	  if (typeof listener === 'function') {
	    if (method === 'message') {
	      // store a reference so we can return the original function from the
	      // addEventListener hook
	      onMessage._listener = listener;
	      this.on(method, onMessage);
	    } else if (method === 'close') {
	      // store a reference so we can return the original function from the
	      // addEventListener hook
	      onClose._listener = listener;
	      this.on(method, onClose);
	    } else if (method === 'error') {
	      // store a reference so we can return the original function from the
	      // addEventListener hook
	      onError._listener = listener;
	      this.on(method, onError);
	    } else if (method === 'open') {
	      // store a reference so we can return the original function from the
	      // addEventListener hook
	      onOpen._listener = listener;
	      this.on(method, onOpen);
	    } else {
	      this.on(method, listener);
	    }
	  }
	};
	
	module.exports = WebSocket;
	module.exports.buildHostHeader = buildHostHeader
	
	/**
	 * W3C MessageEvent
	 *
	 * @see http://www.w3.org/TR/html5/comms.html
	 * @constructor
	 * @api private
	 */
	function MessageEvent(dataArg, isBinary, target) {
	  this.type = 'message';
	  this.data = dataArg;
	  this.target = target;
	  this.binary = isBinary; // non-standard.
	}
	
	/**
	 * W3C CloseEvent
	 *
	 * @see http://www.w3.org/TR/html5/comms.html
	 * @constructor
	 * @api private
	 */
	function CloseEvent(code, reason, target) {
	  this.type = 'close';
	  this.wasClean = (typeof code === 'undefined' || code === 1000);
	  this.code = code;
	  this.reason = reason;
	  this.target = target;
	}
	
	/**
	 * W3C OpenEvent
	 *
	 * @see http://www.w3.org/TR/html5/comms.html
	 * @constructor
	 * @api private
	 */
	function OpenEvent(target) {
	  this.type = 'open';
	  this.target = target;
	}
	
	// Append port number to Host header, only if specified in the url
	// and non-default
	function buildHostHeader(isSecure, hostname, port) {
	  var headerHost = hostname;
	  if (hostname) {
	    if ((isSecure && (port != 443)) || (!isSecure && (port != 80))){
	      headerHost = headerHost + ':' + port;
	    }
	  }
	  return headerHost;
	}
	
	/**
	 * Entirely private apis,
	 * which may or may not be bound to a sepcific WebSocket instance.
	 */
	function initAsServerClient(req, socket, upgradeHead, options) {
	  options = new Options({
	    protocolVersion: protocolVersion,
	    protocol: null,
	    extensions: {},
	    maxPayload: 0
	  }).merge(options);
	
	  // expose state properties
	  this.protocol = options.value.protocol;
	  this.protocolVersion = options.value.protocolVersion;
	  this.extensions = options.value.extensions;
	  this.supports.binary = (this.protocolVersion !== 'hixie-76');
	  this.upgradeReq = req;
	  this.readyState = WebSocket.CONNECTING;
	  this._isServer = true;
	  this.maxPayload = options.value.maxPayload;
	  // establish connection
	  if (options.value.protocolVersion === 'hixie-76') {
	    establishConnection.call(this, ReceiverHixie, SenderHixie, socket, upgradeHead);
	  } else {
	    establishConnection.call(this, Receiver, Sender, socket, upgradeHead);
	  }
	}
	
	function initAsClient(address, protocols, options) {
	  options = new Options({
	    origin: null,
	    protocolVersion: protocolVersion,
	    host: null,
	    headers: null,
	    protocol: protocols.join(','),
	    agent: null,
	
	    // ssl-related options
	    pfx: null,
	    key: null,
	    passphrase: null,
	    cert: null,
	    ca: null,
	    ciphers: null,
	    rejectUnauthorized: null,
	    perMessageDeflate: true,
	    localAddress: null
	  }).merge(options);
	
	  if (options.value.protocolVersion !== 8 && options.value.protocolVersion !== 13) {
	    throw new Error('unsupported protocol version');
	  }
	
	  // verify URL and establish http class
	  var serverUrl = url.parse(address);
	  var isUnixSocket = serverUrl.protocol === 'ws+unix:';
	  if (!serverUrl.host && !isUnixSocket) throw new Error('invalid url');
	  var isSecure = serverUrl.protocol === 'wss:' || serverUrl.protocol === 'https:';
	  var httpObj = isSecure ? https : http;
	  var port = serverUrl.port || (isSecure ? 443 : 80);
	  var auth = serverUrl.auth;
	
	  // prepare extensions
	  var extensionsOffer = {};
	  var perMessageDeflate;
	  if (options.value.perMessageDeflate) {
	    perMessageDeflate = new PerMessageDeflate(typeof options.value.perMessageDeflate !== true ? options.value.perMessageDeflate : {}, false);
	    extensionsOffer[PerMessageDeflate.extensionName] = perMessageDeflate.offer();
	  }
	
	  // expose state properties
	  this._isServer = false;
	  this.url = address;
	  this.protocolVersion = options.value.protocolVersion;
	  this.supports.binary = (this.protocolVersion !== 'hixie-76');
	
	  // begin handshake
	  var key = new Buffer(options.value.protocolVersion + '-' + Date.now()).toString('base64');
	  var shasum = crypto.createHash('sha1');
	  shasum.update(key + '258EAFA5-E914-47DA-95CA-C5AB0DC85B11');
	  var expectedServerKey = shasum.digest('base64');
	
	  var agent = options.value.agent;
	
	  var headerHost = buildHostHeader(isSecure, serverUrl.hostname, port)
	
	  var requestOptions = {
	    port: port,
	    host: serverUrl.hostname,
	    headers: {
	      'Connection': 'Upgrade',
	      'Upgrade': 'websocket',
	      'Host': headerHost,
	      'Sec-WebSocket-Version': options.value.protocolVersion,
	      'Sec-WebSocket-Key': key
	    }
	  };
	
	  // If we have basic auth.
	  if (auth) {
	    requestOptions.headers.Authorization = 'Basic ' + new Buffer(auth).toString('base64');
	  }
	
	  if (options.value.protocol) {
	    requestOptions.headers['Sec-WebSocket-Protocol'] = options.value.protocol;
	  }
	
	  if (options.value.host) {
	    requestOptions.headers.Host = options.value.host;
	  }
	
	  if (options.value.headers) {
	    for (var header in options.value.headers) {
	       if (options.value.headers.hasOwnProperty(header)) {
	        requestOptions.headers[header] = options.value.headers[header];
	       }
	    }
	  }
	
	  if (Object.keys(extensionsOffer).length) {
	    requestOptions.headers['Sec-WebSocket-Extensions'] = Extensions.format(extensionsOffer);
	  }
	
	  if (options.isDefinedAndNonNull('pfx')
	   || options.isDefinedAndNonNull('key')
	   || options.isDefinedAndNonNull('passphrase')
	   || options.isDefinedAndNonNull('cert')
	   || options.isDefinedAndNonNull('ca')
	   || options.isDefinedAndNonNull('ciphers')
	   || options.isDefinedAndNonNull('rejectUnauthorized')) {
	
	    if (options.isDefinedAndNonNull('pfx')) requestOptions.pfx = options.value.pfx;
	    if (options.isDefinedAndNonNull('key')) requestOptions.key = options.value.key;
	    if (options.isDefinedAndNonNull('passphrase')) requestOptions.passphrase = options.value.passphrase;
	    if (options.isDefinedAndNonNull('cert')) requestOptions.cert = options.value.cert;
	    if (options.isDefinedAndNonNull('ca')) requestOptions.ca = options.value.ca;
	    if (options.isDefinedAndNonNull('ciphers')) requestOptions.ciphers = options.value.ciphers;
	    if (options.isDefinedAndNonNull('rejectUnauthorized')) requestOptions.rejectUnauthorized = options.value.rejectUnauthorized;
	
	    if (!agent) {
	        // global agent ignores client side certificates
	        agent = new httpObj.Agent(requestOptions);
	    }
	  }
	
	  requestOptions.path = serverUrl.path || '/';
	
	  if (agent) {
	    requestOptions.agent = agent;
	  }
	
	  if (isUnixSocket) {
	    requestOptions.socketPath = serverUrl.pathname;
	  }
	
	  if (options.value.localAddress) {
	    requestOptions.localAddress = options.value.localAddress;
	  }
	
	  if (options.value.origin) {
	    if (options.value.protocolVersion < 13) requestOptions.headers['Sec-WebSocket-Origin'] = options.value.origin;
	    else requestOptions.headers.Origin = options.value.origin;
	  }
	
	  var self = this;
	  var req = httpObj.request(requestOptions);
	
	  req.on('error', function onerror(error) {
	    self.emit('error', error);
	    cleanupWebsocketResources.call(self, error);
	  });
	
	  req.once('response', function response(res) {
	    var error;
	
	    if (!self.emit('unexpected-response', req, res)) {
	      error = new Error('unexpected server response (' + res.statusCode + ')');
	      req.abort();
	      self.emit('error', error);
	    }
	
	    cleanupWebsocketResources.call(self, error);
	  });
	
	  req.once('upgrade', function upgrade(res, socket, upgradeHead) {
	    if (self.readyState === WebSocket.CLOSED) {
	      // client closed before server accepted connection
	      self.emit('close');
	      self.removeAllListeners();
	      socket.end();
	      return;
	    }
	
	    var serverKey = res.headers['sec-websocket-accept'];
	    if (typeof serverKey === 'undefined' || serverKey !== expectedServerKey) {
	      self.emit('error', 'invalid server key');
	      self.removeAllListeners();
	      socket.end();
	      return;
	    }
	
	    var serverProt = res.headers['sec-websocket-protocol'];
	    var protList = (options.value.protocol || "").split(/, */);
	    var protError = null;
	
	    if (!options.value.protocol && serverProt) {
	      protError = 'server sent a subprotocol even though none requested';
	    } else if (options.value.protocol && !serverProt) {
	      protError = 'server sent no subprotocol even though requested';
	    } else if (serverProt && protList.indexOf(serverProt) === -1) {
	      protError = 'server responded with an invalid protocol';
	    }
	
	    if (protError) {
	      self.emit('error', protError);
	      self.removeAllListeners();
	      socket.end();
	      return;
	    } else if (serverProt) {
	      self.protocol = serverProt;
	    }
	
	    var serverExtensions = Extensions.parse(res.headers['sec-websocket-extensions']);
	    if (perMessageDeflate && serverExtensions[PerMessageDeflate.extensionName]) {
	      try {
	        perMessageDeflate.accept(serverExtensions[PerMessageDeflate.extensionName]);
	      } catch (err) {
	        self.emit('error', 'invalid extension parameter');
	        self.removeAllListeners();
	        socket.end();
	        return;
	      }
	      self.extensions[PerMessageDeflate.extensionName] = perMessageDeflate;
	    }
	
	    establishConnection.call(self, Receiver, Sender, socket, upgradeHead);
	
	    // perform cleanup on http resources
	    req.removeAllListeners();
	    req = null;
	    agent = null;
	  });
	
	  req.end();
	  this.readyState = WebSocket.CONNECTING;
	}
	
	function establishConnection(ReceiverClass, SenderClass, socket, upgradeHead) {
	  var ultron = this._ultron = new Ultron(socket)
	    , called = false
	    , self = this;
	
	  socket.setTimeout(0);
	  socket.setNoDelay(true);
	
	  this._receiver = new ReceiverClass(this.extensions,this.maxPayload);
	  this._socket = socket;
	
	  // socket cleanup handlers
	  ultron.on('end', cleanupWebsocketResources.bind(this));
	  ultron.on('close', cleanupWebsocketResources.bind(this));
	  ultron.on('error', cleanupWebsocketResources.bind(this));
	
	  // ensure that the upgradeHead is added to the receiver
	  function firstHandler(data) {
	    if (called || self.readyState === WebSocket.CLOSED) return;
	
	    called = true;
	    socket.removeListener('data', firstHandler);
	    ultron.on('data', realHandler);
	
	    if (upgradeHead && upgradeHead.length > 0) {
	      realHandler(upgradeHead);
	      upgradeHead = null;
	    }
	
	    if (data) realHandler(data);
	  }
	
	  // subsequent packets are pushed straight to the receiver
	  function realHandler(data) {
	    self.bytesReceived += data.length;
	    self._receiver.add(data);
	  }
	
	  ultron.on('data', firstHandler);
	
	  // if data was passed along with the http upgrade,
	  // this will schedule a push of that on to the receiver.
	  // this has to be done on next tick, since the caller
	  // hasn't had a chance to set event handlers on this client
	  // object yet.
	  process.nextTick(firstHandler);
	
	  // receiver event handlers
	  self._receiver.ontext = function ontext(data, flags) {
	    flags = flags || {};
	
	    self.emit('message', data, flags);
	  };
	
	  self._receiver.onbinary = function onbinary(data, flags) {
	    flags = flags || {};
	
	    flags.binary = true;
	    self.emit('message', data, flags);
	  };
	
	  self._receiver.onping = function onping(data, flags) {
	    flags = flags || {};
	
	    self.pong(data, {
	      mask: !self._isServer,
	      binary: flags.binary === true
	    }, true);
	
	    self.emit('ping', data, flags);
	  };
	
	  self._receiver.onpong = function onpong(data, flags) {
	    self.emit('pong', data, flags || {});
	  };
	
	  self._receiver.onclose = function onclose(code, data, flags) {
	    flags = flags || {};
	
	    self._closeReceived = true;
	    self.close(code, data);
	  };
	
	  self._receiver.onerror = function onerror(reason, errorCode) {
	    // close the connection when the receiver reports a HyBi error code
	    self.close(typeof errorCode !== 'undefined' ? errorCode : 1002, '');
	    self.emit('error', (reason instanceof Error) ? reason : (new Error(reason)));
	  };
	
	  // finalize the client
	  this._sender = new SenderClass(socket, this.extensions);
	  this._sender.on('error', function onerror(error) {
	    self.close(1002, '');
	    self.emit('error', error);
	  });
	
	  this.readyState = WebSocket.OPEN;
	  this.emit('open');
	}
	
	function startQueue(instance) {
	  instance._queue = instance._queue || [];
	}
	
	function executeQueueSends(instance) {
	  var queue = instance._queue;
	  if (typeof queue === 'undefined') return;
	
	  delete instance._queue;
	  for (var i = 0, l = queue.length; i < l; ++i) {
	    queue[i]();
	  }
	}
	
	function sendStream(instance, stream, options, cb) {
	  stream.on('data', function incoming(data) {
	    if (instance.readyState !== WebSocket.OPEN) {
	      if (typeof cb === 'function') cb(new Error('not opened'));
	      else {
	        delete instance._queue;
	        instance.emit('error', new Error('not opened'));
	      }
	      return;
	    }
	
	    options.fin = false;
	    instance._sender.send(data, options);
	  });
	
	  stream.on('end', function end() {
	    if (instance.readyState !== WebSocket.OPEN) {
	      if (typeof cb === 'function') cb(new Error('not opened'));
	      else {
	        delete instance._queue;
	        instance.emit('error', new Error('not opened'));
	      }
	      return;
	    }
	
	    options.fin = true;
	    instance._sender.send(null, options);
	
	    if (typeof cb === 'function') cb(null);
	  });
	}
	
	function cleanupWebsocketResources(error) {
	  if (this.readyState === WebSocket.CLOSED) return;
	
	  this.readyState = WebSocket.CLOSED;
	
	  clearTimeout(this._closeTimer);
	  this._closeTimer = null;
	
	  // If the connection was closed abnormally (with an error), or if
	  // the close control frame was not received then the close code
	  // must default to 1006.
	  if (error || !this._closeReceived) {
	    this._closeCode = 1006;
	  }
	  this.emit('close', this._closeCode || 1000, this._closeMessage || '');
	
	  if (this._socket) {
	    if (this._ultron) this._ultron.destroy();
	    this._socket.on('error', function onerror() {
	      try { this.destroy(); }
	      catch (e) {}
	    });
	
	    try {
	      if (!error) this._socket.end();
	      else this._socket.destroy();
	    } catch (e) { /* Ignore termination errors */ }
	
	    this._socket = null;
	    this._ultron = null;
	  }
	
	  if (this._sender) {
	    this._sender.removeAllListeners();
	    this._sender = null;
	  }
	
	  if (this._receiver) {
	    this._receiver.cleanup();
	    this._receiver = null;
	  }
	
	  if (this.extensions[PerMessageDeflate.extensionName]) {
	    this.extensions[PerMessageDeflate.extensionName].cleanup();
	  }
	
	  this.extensions = null;
	
	  this.removeAllListeners();
	  this.on('error', function onerror() {}); // catch all errors after this
	  delete this._queue;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer, __webpack_require__(28)))

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(586);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(18);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(587);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback, option) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    var _ret = (function () {
	      var useCapture = false;
	      if (typeof option === 'object') {
	        useCapture = option.capture || false;
	      } else if (typeof option === 'boolean') {
	        useCapture = option;
	      }
	
	      target.addEventListener(eventType, wrapCallback, option || false);
	
	      return {
	        v: {
	          remove: function remove() {
	            target.removeEventListener(eventType, wrapCallback, useCapture);
	          }
	        }
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var ELEMENT_NODE = 1;
	var COMMENT_NODE = 8;
	
	var ADD_CLASS_SUFFIX = '-add';
	var REMOVE_CLASS_SUFFIX = '-remove';
	var EVENT_CLASS_PREFIX = 'ng-';
	var ACTIVE_CLASS_SUFFIX = '-active';
	var PREPARE_CLASS_SUFFIX = '-prepare';
	
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	// Detect proper transitionend/animationend event names.
	var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	// If unprefixed events are not supported but webkit-prefixed are, use the latter.
	// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	// Register both events in case `window.onanimationend` is not supported because of that,
	// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	// therefore there is no reason to test anymore for other vendor prefixes:
	// http://caniuse.com/#search=transition
	if ((window.ontransitionend === void 0) && (window.onwebkittransitionend !== void 0)) {
	  CSS_PREFIX = '-webkit-';
	  TRANSITION_PROP = 'WebkitTransition';
	  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	} else {
	  TRANSITION_PROP = 'transition';
	  TRANSITIONEND_EVENT = 'transitionend';
	}
	
	if ((window.onanimationend === void 0) && (window.onwebkitanimationend !== void 0)) {
	  CSS_PREFIX = '-webkit-';
	  ANIMATION_PROP = 'WebkitAnimation';
	  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	} else {
	  ANIMATION_PROP = 'animation';
	  ANIMATIONEND_EVENT = 'animationend';
	}
	
	var DURATION_KEY = 'Duration';
	var PROPERTY_KEY = 'Property';
	var DELAY_KEY = 'Delay';
	var TIMING_KEY = 'TimingFunction';
	var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	var ngMinErr = angular.$$minErr('ng');
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	  }
	  return arg;
	}
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function packageStyles(options) {
	  var styles = {};
	  if (options && (options.to || options.from)) {
	    styles.to = options.to;
	    styles.from = options.from;
	  }
	  return styles;
	}
	
	function pendClasses(classes, fix, isPrefix) {
	  var className = '';
	  classes = isArray(classes)
	      ? classes
	      : classes && isString(classes) && classes.length
	          ? classes.split(/\s+/)
	          : [];
	  forEach(classes, function(klass, i) {
	    if (klass && klass.length > 0) {
	      className += (i > 0) ? ' ' : '';
	      className += isPrefix ? fix + klass
	                            : klass + fix;
	    }
	  });
	  return className;
	}
	
	function removeFromArray(arr, val) {
	  var index = arr.indexOf(val);
	  if (val >= 0) {
	    arr.splice(index, 1);
	  }
	}
	
	function stripCommentsFromElement(element) {
	  if (element instanceof jqLite) {
	    switch (element.length) {
	      case 0:
	        return element;
	
	      case 1:
	        // there is no point of stripping anything if the element
	        // is the only element within the jqLite wrapper.
	        // (it's important that we retain the element instance.)
	        if (element[0].nodeType === ELEMENT_NODE) {
	          return element;
	        }
	        break;
	
	      default:
	        return jqLite(extractElementNode(element));
	    }
	  }
	
	  if (element.nodeType === ELEMENT_NODE) {
	    return jqLite(element);
	  }
	}
	
	function extractElementNode(element) {
	  if (!element[0]) return element;
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType == ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function $$addClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.addClass(elm, className);
	  });
	}
	
	function $$removeClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.removeClass(elm, className);
	  });
	}
	
	function applyAnimationClassesFactory($$jqLite) {
	  return function(element, options) {
	    if (options.addClass) {
	      $$addClass($$jqLite, element, options.addClass);
	      options.addClass = null;
	    }
	    if (options.removeClass) {
	      $$removeClass($$jqLite, element, options.removeClass);
	      options.removeClass = null;
	    }
	  };
	}
	
	function prepareAnimationOptions(options) {
	  options = options || {};
	  if (!options.$$prepared) {
	    var domOperation = options.domOperation || noop;
	    options.domOperation = function() {
	      options.$$domOperationFired = true;
	      domOperation();
	      domOperation = noop;
	    };
	    options.$$prepared = true;
	  }
	  return options;
	}
	
	function applyAnimationStyles(element, options) {
	  applyAnimationFromStyles(element, options);
	  applyAnimationToStyles(element, options);
	}
	
	function applyAnimationFromStyles(element, options) {
	  if (options.from) {
	    element.css(options.from);
	    options.from = null;
	  }
	}
	
	function applyAnimationToStyles(element, options) {
	  if (options.to) {
	    element.css(options.to);
	    options.to = null;
	  }
	}
	
	function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	  var target = oldAnimation.options || {};
	  var newOptions = newAnimation.options || {};
	
	  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	  if (newOptions.preparationClasses) {
	    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	    delete newOptions.preparationClasses;
	  }
	
	  // noop is basically when there is no callback; otherwise something has been set
	  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	  extend(target, newOptions);
	
	  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	  if (realDomOperation) {
	    target.domOperation = realDomOperation;
	  }
	
	  if (classes.addClass) {
	    target.addClass = classes.addClass;
	  } else {
	    target.addClass = null;
	  }
	
	  if (classes.removeClass) {
	    target.removeClass = classes.removeClass;
	  } else {
	    target.removeClass = null;
	  }
	
	  oldAnimation.addClass = target.addClass;
	  oldAnimation.removeClass = target.removeClass;
	
	  return target;
	}
	
	function resolveElementClasses(existing, toAdd, toRemove) {
	  var ADD_CLASS = 1;
	  var REMOVE_CLASS = -1;
	
	  var flags = {};
	  existing = splitClassesToLookup(existing);
	
	  toAdd = splitClassesToLookup(toAdd);
	  forEach(toAdd, function(value, key) {
	    flags[key] = ADD_CLASS;
	  });
	
	  toRemove = splitClassesToLookup(toRemove);
	  forEach(toRemove, function(value, key) {
	    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	  });
	
	  var classes = {
	    addClass: '',
	    removeClass: ''
	  };
	
	  forEach(flags, function(val, klass) {
	    var prop, allow;
	    if (val === ADD_CLASS) {
	      prop = 'addClass';
	      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
	    } else if (val === REMOVE_CLASS) {
	      prop = 'removeClass';
	      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
	    }
	    if (allow) {
	      if (classes[prop].length) {
	        classes[prop] += ' ';
	      }
	      classes[prop] += klass;
	    }
	  });
	
	  function splitClassesToLookup(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    var obj = {};
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	  return classes;
	}
	
	function getDomNode(element) {
	  return (element instanceof jqLite) ? element[0] : element;
	}
	
	function applyGeneratedPreparationClasses(element, event, options) {
	  var classes = '';
	  if (event) {
	    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	  }
	  if (options.addClass) {
	    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	  }
	  if (options.removeClass) {
	    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	  }
	  if (classes.length) {
	    options.preparationClasses = classes;
	    element.addClass(classes);
	  }
	}
	
	function clearGeneratedClasses(element, options) {
	  if (options.preparationClasses) {
	    element.removeClass(options.preparationClasses);
	    options.preparationClasses = null;
	  }
	  if (options.activeClasses) {
	    element.removeClass(options.activeClasses);
	    options.activeClasses = null;
	  }
	}
	
	function blockTransitions(node, duration) {
	  // we use a negative delay value since it performs blocking
	  // yet it doesn't kill any existing transitions running on the
	  // same element which makes this safe for class-based animations
	  var value = duration ? '-' + duration + 's' : '';
	  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	  return [TRANSITION_DELAY_PROP, value];
	}
	
	function blockKeyframeAnimations(node, applyBlock) {
	  var value = applyBlock ? 'paused' : '';
	  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	  applyInlineStyle(node, [key, value]);
	  return [key, value];
	}
	
	function applyInlineStyle(node, styleTuple) {
	  var prop = styleTuple[0];
	  var value = styleTuple[1];
	  node.style[prop] = value;
	}
	
	function concatWithSpace(a,b) {
	  if (!a) return b;
	  if (!b) return a;
	  return a + ' ' + b;
	}
	
	var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
	  var queue, cancelFn;
	
	  function scheduler(tasks) {
	    // we make a copy since RAFScheduler mutates the state
	    // of the passed in array variable and this would be difficult
	    // to track down on the outside code
	    queue = queue.concat(tasks);
	    nextTick();
	  }
	
	  queue = scheduler.queue = [];
	
	  /* waitUntilQuiet does two things:
	   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	   *
	   * The motivation here is that animation code can request more time from the scheduler
	   * before the next wave runs. This allows for certain DOM properties such as classes to
	   * be resolved in time for the next animation to run.
	   */
	  scheduler.waitUntilQuiet = function(fn) {
	    if (cancelFn) cancelFn();
	
	    cancelFn = $$rAF(function() {
	      cancelFn = null;
	      fn();
	      nextTick();
	    });
	  };
	
	  return scheduler;
	
	  function nextTick() {
	    if (!queue.length) return;
	
	    var items = queue.shift();
	    for (var i = 0; i < items.length; i++) {
	      items[i]();
	    }
	
	    if (!cancelFn) {
	      $$rAF(function() {
	        if (!cancelFn) nextTick();
	      });
	    }
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateChildren
	 * @restrict AE
	 * @element ANY
	 *
	 * @description
	 *
	 * ngAnimateChildren allows you to specify that children of this element should animate even if any
	 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	 * (structural) animation, child elements that also have an active structural animation are not animated.
	 *
	 * Note that even if `ngAnimteChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	 *
	 *
	 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	 *
	 * @example
	 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	       <div ng-controller="mainController as main">
	         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	         <hr>
	         <div ng-animate-children="{{main.animateChildren}}">
	           <div ng-if="main.enterElement" class="container">
	             List of items:
	             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	           </div>
	         </div>
	       </div>
	     </file>
	     <file name="animations.css">
	
	      .container.ng-enter,
	      .container.ng-leave {
	        transition: all ease 1.5s;
	      }
	
	      .container.ng-enter,
	      .container.ng-leave-active {
	        opacity: 0;
	      }
	
	      .container.ng-leave,
	      .container.ng-enter-active {
	        opacity: 1;
	      }
	
	      .item {
	        background: firebrick;
	        color: #FFF;
	        margin-bottom: 10px;
	      }
	
	      .item.ng-enter,
	      .item.ng-leave {
	        transition: transform 1.5s ease;
	      }
	
	      .item.ng-enter {
	        transform: translateX(50px);
	      }
	
	      .item.ng-enter-active {
	        transform: translateX(0);
	      }
	    </file>
	    <file name="script.js">
	      angular.module('ngAnimateChildren', ['ngAnimate'])
	        .controller('mainController', function() {
	          this.animateChildren = false;
	          this.enterElement = false;
	        });
	    </file>
	  </example>
	 */
	var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
	  return {
	    link: function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN_DATA, true);
	      } else {
	        // Interpolate and set the value, so that it is available to
	        // animations that run right after compilation
	        setData($interpolate(val)(scope));
	        attrs.$observe('ngAnimateChildren', setData);
	      }
	
	      function setData(value) {
	        value = value === 'on' || value === 'true';
	        element.data(NG_ANIMATE_CHILDREN_DATA, value);
	      }
	    }
	  };
	}];
	
	var ANIMATE_TIMER_KEY = '$$animateCss';
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	 * directives to create more complex animations that can be purely driven using CSS code.
	 *
	 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	 *
	 * ## Usage
	 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	 * any automatic control over cancelling animations and/or preventing animations from being run on
	 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
	 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	 * the CSS animation.
	 *
	 * The example below shows how we can create a folding animation on an element using `ng-if`:
	 *
	 * ```html
	 * <!-- notice the `fold-animation` CSS class -->
	 * <div ng-if="onOff" class="fold-animation">
	 *   This element will go BOOM
	 * </div>
	 * <button ng-click="onOff=true">Fold In</button>
	 * ```
	 *
	 * Now we create the **JavaScript animation** that will trigger the CSS transition:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## More Advanced Uses
	 *
	 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	 *
	 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	 * to provide a working animation that will run in CSS.
	 *
	 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         addClass: 'red large-text pulse-twice',
	 *         easing: 'ease-out',
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	 *
	 * ```css
	 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	 * .red { background:red; }
	 * .large-text { font-size:20px; }
	 *
	 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	 * .pulse-twice {
	 *   animation: 0.5s pulse linear 2;
	 *   -webkit-animation: 0.5s pulse linear 2;
	 * }
	 *
	 * @keyframes pulse {
	 *   from { transform: scale(0.5); }
	 *   to { transform: scale(1.5); }
	 * }
	 *
	 * @-webkit-keyframes pulse {
	 *   from { -webkit-transform: scale(0.5); }
	 *   to { -webkit-transform: scale(1.5); }
	 * }
	 * ```
	 *
	 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	 *
	 * ## How the Options are handled
	 *
	 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	 * styles using the `from` and `to` properties.
	 *
	 * ```js
	 * var animator = $animateCss(element, {
	 *   from: { background:'red' },
	 *   to: { background:'blue' }
	 * });
	 * animator.start();
	 * ```
	 *
	 * ```css
	 * .rotating-animation {
	 *   animation:0.5s rotate linear;
	 *   -webkit-animation:0.5s rotate linear;
	 * }
	 *
	 * @keyframes rotate {
	 *   from { transform: rotate(0deg); }
	 *   to { transform: rotate(360deg); }
	 * }
	 *
	 * @-webkit-keyframes rotate {
	 *   from { -webkit-transform: rotate(0deg); }
	 *   to { -webkit-transform: rotate(360deg); }
	 * }
	 * ```
	 *
	 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	 * and spread across the transition and keyframe animation.
	 *
	 * ## What is returned
	 *
	 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	 *
	 * ```js
	 * var animator = $animateCss(element, { ... });
	 * ```
	 *
	 * Now what do the contents of our `animator` variable look like:
	 *
	 * ```js
	 * {
	 *   // starts the animation
	 *   start: Function,
	 *
	 *   // ends (aborts) the animation
	 *   end: Function
	 * }
	 * ```
	 *
	 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	 * and that changing them will not reconfigure the parameters of the animation.
	 *
	 * ### runner.done() vs runner.then()
	 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	 * unless you really need a digest to kick off afterwards.
	 *
	 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	 *
	 * @param {DOMElement} element the element that will be animated
	 * @param {object} options the animation-related options that will be applied during the animation
	 *
	 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	 * is provided then the animation will be skipped entirely.
	 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	 * CSS delay value.
	 * * `stagger` - A numeric time value representing the delay between successively animated elements
	 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	 *    the animation is closed. This is useful for when the styles are used purely for the sake of
	 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	 *    By default this value is set to `false`.
	 *
	 * @return {object} an object with start and end methods and details about the animation.
	 *
	 * * `start` - The method to start the animation. This will return a `Promise` when called.
	 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	 */
	var ONE_SECOND = 1000;
	var BASE_TEN = 10;
	
	var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	var CLOSING_TIME_BUFFER = 1.5;
	
	var DETECT_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP,
	  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	};
	
	var DETECT_STAGGER_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP
	};
	
	function getCssKeyframeDurationStyle(duration) {
	  return [ANIMATION_DURATION_PROP, duration + 's'];
	}
	
	function getCssDelayStyle(delay, isKeyframeAnimation) {
	  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	  return [prop, delay + 's'];
	}
	
	function computeCssStyles($window, element, properties) {
	  var styles = Object.create(null);
	  var detectedStyles = $window.getComputedStyle(element) || {};
	  forEach(properties, function(formalStyleName, actualStyleName) {
	    var val = detectedStyles[formalStyleName];
	    if (val) {
	      var c = val.charAt(0);
	
	      // only numerical-based values have a negative sign or digit as the first value
	      if (c === '-' || c === '+' || c >= 0) {
	        val = parseMaxTime(val);
	      }
	
	      // by setting this to null in the event that the delay is not set or is set directly as 0
	      // then we can still allow for negative values to be used later on and not mistake this
	      // value for being greater than any other negative value.
	      if (val === 0) {
	        val = null;
	      }
	      styles[actualStyleName] = val;
	    }
	  });
	
	  return styles;
	}
	
	function parseMaxTime(str) {
	  var maxValue = 0;
	  var values = str.split(/\s*,\s*/);
	  forEach(values, function(value) {
	    // it's always safe to consider only second values and omit `ms` values since
	    // getComputedStyle will always handle the conversion for us
	    if (value.charAt(value.length - 1) == 's') {
	      value = value.substring(0, value.length - 1);
	    }
	    value = parseFloat(value) || 0;
	    maxValue = maxValue ? Math.max(value, maxValue) : value;
	  });
	  return maxValue;
	}
	
	function truthyTimingValue(val) {
	  return val === 0 || val != null;
	}
	
	function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	  var style = TRANSITION_PROP;
	  var value = duration + 's';
	  if (applyOnlyDuration) {
	    style += DURATION_KEY;
	  } else {
	    value += ' linear all';
	  }
	  return [style, value];
	}
	
	function createLocalCacheLookup() {
	  var cache = Object.create(null);
	  return {
	    flush: function() {
	      cache = Object.create(null);
	    },
	
	    count: function(key) {
	      var entry = cache[key];
	      return entry ? entry.total : 0;
	    },
	
	    get: function(key) {
	      var entry = cache[key];
	      return entry && entry.value;
	    },
	
	    put: function(key, value) {
	      if (!cache[key]) {
	        cache[key] = { total: 1, value: value };
	      } else {
	        cache[key].total++;
	      }
	    }
	  };
	}
	
	// we do not reassign an already present style value since
	// if we detect the style property value again we may be
	// detecting styles that were added via the `from` styles.
	// We make use of `isDefined` here since an empty string
	// or null value (which is what getPropertyValue will return
	// for a non-existing style) will still be marked as a valid
	// value for the style (a falsy value implies that the style
	// is to be removed at the end of the animation). If we had a simple
	// "OR" statement then it would not be enough to catch that.
	function registerRestorableStyles(backup, node, properties) {
	  forEach(properties, function(prop) {
	    backup[prop] = isDefined(backup[prop])
	        ? backup[prop]
	        : node.style.getPropertyValue(prop);
	  });
	}
	
	var $AnimateCssProvider = ['$animateProvider', function($animateProvider) {
	  var gcsLookup = createLocalCacheLookup();
	  var gcsStaggerLookup = createLocalCacheLookup();
	
	  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
	               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
	       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
	                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    var parentCounter = 0;
	    function gcsHashFn(node, extraClasses) {
	      var KEY = "$$ngAnimateParentKey";
	      var parentNode = node.parentNode;
	      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
	    }
	
	    function computeCachedCssStyles(node, className, cacheKey, properties) {
	      var timings = gcsLookup.get(cacheKey);
	
	      if (!timings) {
	        timings = computeCssStyles($window, node, properties);
	        if (timings.animationIterationCount === 'infinite') {
	          timings.animationIterationCount = 1;
	        }
	      }
	
	      // we keep putting this in multiple times even though the value and the cacheKey are the same
	      // because we're keeping an internal tally of how many duplicate animations are detected.
	      gcsLookup.put(cacheKey, timings);
	      return timings;
	    }
	
	    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	      var stagger;
	
	      // if we have one or more existing matches of matching elements
	      // containing the same parent + CSS styles (which is how cacheKey works)
	      // then staggering is possible
	      if (gcsLookup.count(cacheKey) > 0) {
	        stagger = gcsStaggerLookup.get(cacheKey);
	
	        if (!stagger) {
	          var staggerClassName = pendClasses(className, '-stagger');
	
	          $$jqLite.addClass(node, staggerClassName);
	
	          stagger = computeCssStyles($window, node, properties);
	
	          // force the conversion of a null value to zero incase not set
	          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	          $$jqLite.removeClass(node, staggerClassName);
	
	          gcsStaggerLookup.put(cacheKey, stagger);
	        }
	      }
	
	      return stagger || {};
	    }
	
	    var cancelLastRAFRequest;
	    var rafWaitQueue = [];
	    function waitUntilQuiet(callback) {
	      rafWaitQueue.push(callback);
	      $$rAFScheduler.waitUntilQuiet(function() {
	        gcsLookup.flush();
	        gcsStaggerLookup.flush();
	
	        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	        var pageWidth = $$forceReflow();
	
	        // we use a for loop to ensure that if the queue is changed
	        // during this looping then it will consider new requests
	        for (var i = 0; i < rafWaitQueue.length; i++) {
	          rafWaitQueue[i](pageWidth);
	        }
	        rafWaitQueue.length = 0;
	      });
	    }
	
	    function computeTimings(node, className, cacheKey) {
	      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
	      var aD = timings.animationDelay;
	      var tD = timings.transitionDelay;
	      timings.maxDelay = aD && tD
	          ? Math.max(aD, tD)
	          : (aD || tD);
	      timings.maxDuration = Math.max(
	          timings.animationDuration * timings.animationIterationCount,
	          timings.transitionDuration);
	
	      return timings;
	    }
	
	    return function init(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = prepareAnimationOptions(copy(options));
	      }
	
	      var restoreStyles = {};
	      var node = getDomNode(element);
	      if (!node
	          || !node.parentNode
	          || !$$animateQueue.enabled()) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var temporaryStyles = [];
	      var classes = element.attr('class');
	      var styles = packageStyles(options);
	      var animationClosed;
	      var animationPaused;
	      var animationCompleted;
	      var runner;
	      var runnerHost;
	      var maxDelay;
	      var maxDelayTime;
	      var maxDuration;
	      var maxDurationTime;
	      var startTime;
	      var events = [];
	
	      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var method = options.event && isArray(options.event)
	            ? options.event.join(' ')
	            : options.event;
	
	      var isStructural = method && options.structural;
	      var structuralClassName = '';
	      var addRemoveClassName = '';
	
	      if (isStructural) {
	        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	      } else if (method) {
	        structuralClassName = method;
	      }
	
	      if (options.addClass) {
	        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	      }
	
	      if (options.removeClass) {
	        if (addRemoveClassName.length) {
	          addRemoveClassName += ' ';
	        }
	        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	      }
	
	      // there may be a situation where a structural animation is combined together
	      // with CSS classes that need to resolve before the animation is computed.
	      // However this means that there is no explicit CSS code to block the animation
	      // from happening (by setting 0s none in the class name). If this is the case
	      // we need to apply the classes before the first rAF so we know to continue if
	      // there actually is a detected transition or keyframe animation
	      if (options.applyClassesEarly && addRemoveClassName.length) {
	        applyAnimationClasses(element, options);
	      }
	
	      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	      var fullClassName = classes + ' ' + preparationClasses;
	      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	      // there is no way we can trigger an animation if no styles and
	      // no classes are being applied which would then trigger a transition,
	      // unless there a is raw keyframe value that is applied to the element.
	      if (!containsKeyframeAnimation
	           && !hasToStyles
	           && !preparationClasses) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var cacheKey, stagger;
	      if (options.stagger > 0) {
	        var staggerVal = parseFloat(options.stagger);
	        stagger = {
	          transitionDelay: staggerVal,
	          animationDelay: staggerVal,
	          transitionDuration: 0,
	          animationDuration: 0
	        };
	      } else {
	        cacheKey = gcsHashFn(node, fullClassName);
	        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	      }
	
	      if (!options.$$skipPreparationClasses) {
	        $$jqLite.addClass(element, preparationClasses);
	      }
	
	      var applyOnlyDuration;
	
	      if (options.transitionStyle) {
	        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	        applyInlineStyle(node, transitionStyle);
	        temporaryStyles.push(transitionStyle);
	      }
	
	      if (options.duration >= 0) {
	        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	        // we set the duration so that it will be picked up by getComputedStyle later
	        applyInlineStyle(node, durationStyle);
	        temporaryStyles.push(durationStyle);
	      }
	
	      if (options.keyframeStyle) {
	        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	        applyInlineStyle(node, keyframeStyle);
	        temporaryStyles.push(keyframeStyle);
	      }
	
	      var itemIndex = stagger
	          ? options.staggerIndex >= 0
	              ? options.staggerIndex
	              : gcsLookup.count(cacheKey)
	          : 0;
	
	      var isFirst = itemIndex === 0;
	
	      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	      // without causing any combination of transitions to kick in. By adding a negative delay value
	      // it forces the setup class' transition to end immediately. We later then remove the negative
	      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	      // that if there is no transition defined then nothing will happen and this will also allow
	      // other transitions to be stacked on top of each other without any chopping them out.
	      if (isFirst && !options.skipBlocking) {
	        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	      }
	
	      var timings = computeTimings(node, fullClassName, cacheKey);
	      var relativeDelay = timings.maxDelay;
	      maxDelay = Math.max(relativeDelay, 0);
	      maxDuration = timings.maxDuration;
	
	      var flags = {};
	      flags.hasTransitions          = timings.transitionDuration > 0;
	      flags.hasAnimations           = timings.animationDuration > 0;
	      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty == 'all';
	      flags.applyTransitionDuration = hasToStyles && (
	                                        (flags.hasTransitions && !flags.hasTransitionAll)
	                                         || (flags.hasAnimations && !flags.hasTransitions));
	      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
	      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
	      flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	        if (flags.applyTransitionDuration) {
	          flags.hasTransitions = true;
	          timings.transitionDuration = maxDuration;
	          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	        }
	
	        if (flags.applyAnimationDuration) {
	          flags.hasAnimations = true;
	          timings.animationDuration = maxDuration;
	          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	        }
	      }
	
	      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      if (options.delay != null) {
	        var delayStyle;
	        if (typeof options.delay !== "boolean") {
	          delayStyle = parseFloat(options.delay);
	          // number in options.delay means we have to recalculate the delay for the closing timeout
	          maxDelay = Math.max(delayStyle, 0);
	        }
	
	        if (flags.applyTransitionDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle));
	        }
	
	        if (flags.applyAnimationDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	        }
	      }
	
	      // we need to recalculate the delay value since we used a pre-emptive negative
	      // delay value and the delay value is required for the final event checking. This
	      // property will ensure that this will happen after the RAF phase has passed.
	      if (options.duration == null && timings.transitionDuration > 0) {
	        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	      }
	
	      maxDelayTime = maxDelay * ONE_SECOND;
	      maxDurationTime = maxDuration * ONE_SECOND;
	      if (!options.skipBlocking) {
	        flags.blockTransition = timings.transitionDuration > 0;
	        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
	                                       stagger.animationDelay > 0 &&
	                                       stagger.animationDuration === 0;
	      }
	
	      if (options.from) {
	        if (options.cleanupStyles) {
	          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	        }
	        applyAnimationFromStyles(element, options);
	      }
	
	      if (flags.blockTransition || flags.blockKeyframeAnimation) {
	        applyBlocking(maxDuration);
	      } else if (!options.skipBlocking) {
	        blockTransitions(node, false);
	      }
	
	      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	      return {
	        $$willAnimate: true,
	        end: endFn,
	        start: function() {
	          if (animationClosed) return;
	
	          runnerHost = {
	            end: endFn,
	            cancel: cancelFn,
	            resume: null, //this will be set during the start() phase
	            pause: null
	          };
	
	          runner = new $$AnimateRunner(runnerHost);
	
	          waitUntilQuiet(start);
	
	          // we don't have access to pause/resume the animation
	          // since it hasn't run yet. AnimateRunner will therefore
	          // set noop functions for resume and pause and they will
	          // later be overridden once the animation is triggered
	          return runner;
	        }
	      };
	
	      function endFn() {
	        close();
	      }
	
	      function cancelFn() {
	        close(true);
	      }
	
	      function close(rejected) { // jshint ignore:line
	        // if the promise has been called already then we shouldn't close
	        // the animation again
	        if (animationClosed || (animationCompleted && animationPaused)) return;
	        animationClosed = true;
	        animationPaused = false;
	
	        if (!options.$$skipPreparationClasses) {
	          $$jqLite.removeClass(element, preparationClasses);
	        }
	        $$jqLite.removeClass(element, activeClasses);
	
	        blockKeyframeAnimations(node, false);
	        blockTransitions(node, false);
	
	        forEach(temporaryStyles, function(entry) {
	          // There is only one way to remove inline style properties entirely from elements.
	          // By using `removeProperty` this works, but we need to convert camel-cased CSS
	          // styles down to hyphenated values.
	          node.style[entry[0]] = '';
	        });
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	
	        if (Object.keys(restoreStyles).length) {
	          forEach(restoreStyles, function(value, prop) {
	            value ? node.style.setProperty(prop, value)
	                  : node.style.removeProperty(prop);
	          });
	        }
	
	        // the reason why we have this option is to allow a synchronous closing callback
	        // that is fired as SOON as the animation ends (when the CSS is removed) or if
	        // the animation never takes off at all. A good example is a leave animation since
	        // the element must be removed just after the animation is over or else the element
	        // will appear on screen for one animation frame causing an overbearing flicker.
	        if (options.onDone) {
	          options.onDone();
	        }
	
	        if (events && events.length) {
	          // Remove the transitionend / animationend listener(s)
	          element.off(events.join(' '), onAnimationProgress);
	        }
	
	        //Cancel the fallback closing timeout and remove the timer data
	        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	        if (animationTimerData) {
	          $timeout.cancel(animationTimerData[0].timer);
	          element.removeData(ANIMATE_TIMER_KEY);
	        }
	
	        // if the preparation function fails then the promise is not setup
	        if (runner) {
	          runner.complete(!rejected);
	        }
	      }
	
	      function applyBlocking(duration) {
	        if (flags.blockTransition) {
	          blockTransitions(node, duration);
	        }
	
	        if (flags.blockKeyframeAnimation) {
	          blockKeyframeAnimations(node, !!duration);
	        }
	      }
	
	      function closeAndReturnNoopAnimator() {
	        runner = new $$AnimateRunner({
	          end: endFn,
	          cancel: cancelFn
	        });
	
	        // should flush the cache animation
	        waitUntilQuiet(noop);
	        close();
	
	        return {
	          $$willAnimate: false,
	          start: function() {
	            return runner;
	          },
	          end: endFn
	        };
	      }
	
	      function onAnimationProgress(event) {
	        event.stopPropagation();
	        var ev = event.originalEvent || event;
	
	        // we now always use `Date.now()` due to the recent changes with
	        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	        var timeStamp = ev.$manualTimeStamp || Date.now();
	
	        /* Firefox (or possibly just Gecko) likes to not round values up
	         * when a ms measurement is used for the animation */
	        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	        /* $manualTimeStamp is a mocked timeStamp value which is set
	         * within browserTrigger(). This is only here so that tests can
	         * mock animations properly. Real events fallback to event.timeStamp,
	         * or, if they don't, then a timeStamp is automatically created for them.
	         * We're checking to see if the timeStamp surpasses the expected delay,
	         * but we're using elapsedTime instead of the timeStamp on the 2nd
	         * pre-condition since animationPauseds sometimes close off early */
	        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	          // we set this flag to ensure that if the transition is paused then, when resumed,
	          // the animation will automatically close itself since transitions cannot be paused.
	          animationCompleted = true;
	          close();
	        }
	      }
	
	      function start() {
	        if (animationClosed) return;
	        if (!node.parentNode) {
	          close();
	          return;
	        }
	
	        // even though we only pause keyframe animations here the pause flag
	        // will still happen when transitions are used. Only the transition will
	        // not be paused since that is not possible. If the animation ends when
	        // paused then it will not complete until unpaused or cancelled.
	        var playPause = function(playAnimation) {
	          if (!animationCompleted) {
	            animationPaused = !playAnimation;
	            if (timings.animationDuration) {
	              var value = blockKeyframeAnimations(node, animationPaused);
	              animationPaused
	                  ? temporaryStyles.push(value)
	                  : removeFromArray(temporaryStyles, value);
	            }
	          } else if (animationPaused && playAnimation) {
	            animationPaused = false;
	            close();
	          }
	        };
	
	        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	        // being inherited from the parent. If the transition duration is zero then we can safely
	        // rely that the delay value is an intentional stagger delay style.
	        var maxStagger = itemIndex > 0
	                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
	                            (timings.animationDuration && stagger.animationDuration === 0))
	                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
	        if (maxStagger) {
	          $timeout(triggerAnimationStart,
	                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
	                   false);
	        } else {
	          triggerAnimationStart();
	        }
	
	        // this will decorate the existing promise runner with pause/resume methods
	        runnerHost.resume = function() {
	          playPause(true);
	        };
	
	        runnerHost.pause = function() {
	          playPause(false);
	        };
	
	        function triggerAnimationStart() {
	          // just incase a stagger animation kicks in when the animation
	          // itself was cancelled entirely
	          if (animationClosed) return;
	
	          applyBlocking(false);
	
	          forEach(temporaryStyles, function(entry) {
	            var key = entry[0];
	            var value = entry[1];
	            node.style[key] = value;
	          });
	
	          applyAnimationClasses(element, options);
	          $$jqLite.addClass(element, activeClasses);
	
	          if (flags.recalculateTimingStyles) {
	            fullClassName = node.className + ' ' + preparationClasses;
	            cacheKey = gcsHashFn(node, fullClassName);
	
	            timings = computeTimings(node, fullClassName, cacheKey);
	            relativeDelay = timings.maxDelay;
	            maxDelay = Math.max(relativeDelay, 0);
	            maxDuration = timings.maxDuration;
	
	            if (maxDuration === 0) {
	              close();
	              return;
	            }
	
	            flags.hasTransitions = timings.transitionDuration > 0;
	            flags.hasAnimations = timings.animationDuration > 0;
	          }
	
	          if (flags.applyAnimationDelay) {
	            relativeDelay = typeof options.delay !== "boolean" && truthyTimingValue(options.delay)
	                  ? parseFloat(options.delay)
	                  : relativeDelay;
	
	            maxDelay = Math.max(relativeDelay, 0);
	            timings.animationDelay = relativeDelay;
	            delayStyle = getCssDelayStyle(relativeDelay, true);
	            temporaryStyles.push(delayStyle);
	            node.style[delayStyle[0]] = delayStyle[1];
	          }
	
	          maxDelayTime = maxDelay * ONE_SECOND;
	          maxDurationTime = maxDuration * ONE_SECOND;
	
	          if (options.easing) {
	            var easeProp, easeVal = options.easing;
	            if (flags.hasTransitions) {
	              easeProp = TRANSITION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	            if (flags.hasAnimations) {
	              easeProp = ANIMATION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	          }
	
	          if (timings.transitionDuration) {
	            events.push(TRANSITIONEND_EVENT);
	          }
	
	          if (timings.animationDuration) {
	            events.push(ANIMATIONEND_EVENT);
	          }
	
	          startTime = Date.now();
	          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	          var endTime = startTime + timerTime;
	
	          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	          var setupFallbackTimer = true;
	          if (animationsData.length) {
	            var currentTimerData = animationsData[0];
	            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	            if (setupFallbackTimer) {
	              $timeout.cancel(currentTimerData.timer);
	            } else {
	              animationsData.push(close);
	            }
	          }
	
	          if (setupFallbackTimer) {
	            var timer = $timeout(onAnimationExpired, timerTime, false);
	            animationsData[0] = {
	              timer: timer,
	              expectedEndTime: endTime
	            };
	            animationsData.push(close);
	            element.data(ANIMATE_TIMER_KEY, animationsData);
	          }
	
	          if (events.length) {
	            element.on(events.join(' '), onAnimationProgress);
	          }
	
	          if (options.to) {
	            if (options.cleanupStyles) {
	              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	            }
	            applyAnimationToStyles(element, options);
	          }
	        }
	
	        function onAnimationExpired() {
	          var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	          // this will be false in the event that the element was
	          // removed from the DOM (via a leave animation or something
	          // similar)
	          if (animationsData) {
	            for (var i = 1; i < animationsData.length; i++) {
	              animationsData[i]();
	            }
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	        }
	      }
	    };
	  }];
	}];
	
	var $$AnimateCssDriverProvider = ['$$animationProvider', function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateCssDriver');
	
	  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	  function isDocumentFragment(node) {
	    return node.parentNode && node.parentNode.nodeType === 11;
	  }
	
	  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
	       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {
	
	    // only browsers that support these properties can render animations
	    if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	    var bodyNode = $document[0].body;
	    var rootNode = getDomNode($rootElement);
	
	    var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
	    );
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    return function initDriverFn(animationDetails) {
	      return animationDetails.from && animationDetails.to
	          ? prepareFromToAnchorAnimation(animationDetails.from,
	                                         animationDetails.to,
	                                         animationDetails.classes,
	                                         animationDetails.anchors)
	          : prepareRegularAnimation(animationDetails);
	    };
	
	    function filterCssClasses(classes) {
	      //remove all the `ng-` stuff
	      return classes.replace(/\bng-\S+\b/g, '');
	    }
	
	    function getUniqueValues(a, b) {
	      if (isString(a)) a = a.split(' ');
	      if (isString(b)) b = b.split(' ');
	      return a.filter(function(val) {
	        return b.indexOf(val) === -1;
	      }).join(' ');
	    }
	
	    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	      var startingClasses = filterCssClasses(getClassVal(clone));
	
	      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	      rootBodyElement.append(clone);
	
	      var animatorIn, animatorOut = prepareOutAnimation();
	
	      // the user may not end up using the `out` animation and
	      // only making use of the `in` animation or vice-versa.
	      // In either case we should allow this and not assume the
	      // animation is over unless both animations are not used.
	      if (!animatorOut) {
	        animatorIn = prepareInAnimation();
	        if (!animatorIn) {
	          return end();
	        }
	      }
	
	      var startingAnimator = animatorOut || animatorIn;
	
	      return {
	        start: function() {
	          var runner;
	
	          var currentAnimation = startingAnimator.start();
	          currentAnimation.done(function() {
	            currentAnimation = null;
	            if (!animatorIn) {
	              animatorIn = prepareInAnimation();
	              if (animatorIn) {
	                currentAnimation = animatorIn.start();
	                currentAnimation.done(function() {
	                  currentAnimation = null;
	                  end();
	                  runner.complete();
	                });
	                return currentAnimation;
	              }
	            }
	            // in the event that there is no `in` animation
	            end();
	            runner.complete();
	          });
	
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn
	          });
	
	          return runner;
	
	          function endFn() {
	            if (currentAnimation) {
	              currentAnimation.end();
	            }
	          }
	        }
	      };
	
	      function calculateAnchorStyles(anchor) {
	        var styles = {};
	
	        var coords = getDomNode(anchor).getBoundingClientRect();
	
	        // we iterate directly since safari messes up and doesn't return
	        // all the keys for the coords object when iterated
	        forEach(['width','height','top','left'], function(key) {
	          var value = coords[key];
	          switch (key) {
	            case 'top':
	              value += bodyNode.scrollTop;
	              break;
	            case 'left':
	              value += bodyNode.scrollLeft;
	              break;
	          }
	          styles[key] = Math.floor(value) + 'px';
	        });
	        return styles;
	      }
	
	      function prepareOutAnimation() {
	        var animator = $animateCss(clone, {
	          addClass: NG_OUT_ANCHOR_CLASS_NAME,
	          delay: true,
	          from: calculateAnchorStyles(outAnchor)
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function getClassVal(element) {
	        return element.attr('class') || '';
	      }
	
	      function prepareInAnimation() {
	        var endingClasses = filterCssClasses(getClassVal(inAnchor));
	        var toAdd = getUniqueValues(endingClasses, startingClasses);
	        var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	        var animator = $animateCss(clone, {
	          to: calculateAnchorStyles(inAnchor),
	          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	          delay: true
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function end() {
	        clone.remove();
	        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      }
	    }
	
	    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	      var fromAnimation = prepareRegularAnimation(from, noop);
	      var toAnimation = prepareRegularAnimation(to, noop);
	
	      var anchorAnimations = [];
	      forEach(anchors, function(anchor) {
	        var outElement = anchor['out'];
	        var inElement = anchor['in'];
	        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	        if (animator) {
	          anchorAnimations.push(animator);
	        }
	      });
	
	      // no point in doing anything when there are no elements to animate
	      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	      return {
	        start: function() {
	          var animationRunners = [];
	
	          if (fromAnimation) {
	            animationRunners.push(fromAnimation.start());
	          }
	
	          if (toAnimation) {
	            animationRunners.push(toAnimation.start());
	          }
	
	          forEach(anchorAnimations, function(animation) {
	            animationRunners.push(animation.start());
	          });
	
	          var runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	          });
	
	          $$AnimateRunner.all(animationRunners, function(status) {
	            runner.complete(status);
	          });
	
	          return runner;
	
	          function endFn() {
	            forEach(animationRunners, function(runner) {
	              runner.end();
	            });
	          }
	        }
	      };
	    }
	
	    function prepareRegularAnimation(animationDetails) {
	      var element = animationDetails.element;
	      var options = animationDetails.options || {};
	
	      if (animationDetails.structural) {
	        options.event = animationDetails.event;
	        options.structural = true;
	        options.applyClassesEarly = true;
	
	        // we special case the leave animation since we want to ensure that
	        // the element is removed as soon as the animation is over. Otherwise
	        // a flicker might appear or the element may not be removed at all
	        if (animationDetails.event === 'leave') {
	          options.onDone = options.domOperation;
	        }
	      }
	
	      // We assign the preparationClasses as the actual animation event since
	      // the internals of $animateCss will just suffix the event token values
	      // with `-active` to trigger the animation.
	      if (options.preparationClasses) {
	        options.event = concatWithSpace(options.event, options.preparationClasses);
	      }
	
	      var animator = $animateCss(element, options);
	
	      // the driver lookup code inside of $$animation attempts to spawn a
	      // driver one by one until a driver returns a.$$willAnimate animator object.
	      // $animateCss will always return an object, however, it will pass in
	      // a flag as a hint as to whether an animation was detected or not
	      return animator.$$willAnimate ? animator : null;
	    }
	  }];
	}];
	
	// TODO(matsko): use caching here to speed things up for detection
	// TODO(matsko): add documentation
	//  by the time...
	
	var $$AnimateJsProvider = ['$animateProvider', function($animateProvider) {
	  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
	       function($injector,   $$AnimateRunner,   $$jqLite) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	         // $animateJs(element, 'enter');
	    return function(element, event, classes, options) {
	      var animationClosed = false;
	
	      // the `classes` argument is optional and if it is not used
	      // then the classes will be resolved from the element's className
	      // property as well as options.addClass/options.removeClass.
	      if (arguments.length === 3 && isObject(classes)) {
	        options = classes;
	        classes = null;
	      }
	
	      options = prepareAnimationOptions(options);
	      if (!classes) {
	        classes = element.attr('class') || '';
	        if (options.addClass) {
	          classes += ' ' + options.addClass;
	        }
	        if (options.removeClass) {
	          classes += ' ' + options.removeClass;
	        }
	      }
	
	      var classesToAdd = options.addClass;
	      var classesToRemove = options.removeClass;
	
	      // the lookupAnimations function returns a series of animation objects that are
	      // matched up with one or more of the CSS classes. These animation objects are
	      // defined via the module.animation factory function. If nothing is detected then
	      // we don't return anything which then makes $animation query the next driver.
	      var animations = lookupAnimations(classes);
	      var before, after;
	      if (animations.length) {
	        var afterFn, beforeFn;
	        if (event == 'leave') {
	          beforeFn = 'leave';
	          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	        } else {
	          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	          afterFn = event;
	        }
	
	        if (event !== 'enter' && event !== 'move') {
	          before = packageAnimations(element, event, options, animations, beforeFn);
	        }
	        after  = packageAnimations(element, event, options, animations, afterFn);
	      }
	
	      // no matching animations
	      if (!before && !after) return;
	
	      function applyOptions() {
	        options.domOperation();
	        applyAnimationClasses(element, options);
	      }
	
	      function close() {
	        animationClosed = true;
	        applyOptions();
	        applyAnimationStyles(element, options);
	      }
	
	      var runner;
	
	      return {
	        $$willAnimate: true,
	        end: function() {
	          if (runner) {
	            runner.end();
	          } else {
	            close();
	            runner = new $$AnimateRunner();
	            runner.complete(true);
	          }
	          return runner;
	        },
	        start: function() {
	          if (runner) {
	            return runner;
	          }
	
	          runner = new $$AnimateRunner();
	          var closeActiveAnimations;
	          var chain = [];
	
	          if (before) {
	            chain.push(function(fn) {
	              closeActiveAnimations = before(fn);
	            });
	          }
	
	          if (chain.length) {
	            chain.push(function(fn) {
	              applyOptions();
	              fn(true);
	            });
	          } else {
	            applyOptions();
	          }
	
	          if (after) {
	            chain.push(function(fn) {
	              closeActiveAnimations = after(fn);
	            });
	          }
	
	          runner.setHost({
	            end: function() {
	              endAnimations();
	            },
	            cancel: function() {
	              endAnimations(true);
	            }
	          });
	
	          $$AnimateRunner.chain(chain, onComplete);
	          return runner;
	
	          function onComplete(success) {
	            close(success);
	            runner.complete(success);
	          }
	
	          function endAnimations(cancelled) {
	            if (!animationClosed) {
	              (closeActiveAnimations || noop)(cancelled);
	              onComplete(cancelled);
	            }
	          }
	        }
	      };
	
	      function executeAnimationFn(fn, element, event, options, onDone) {
	        var args;
	        switch (event) {
	          case 'animate':
	            args = [element, options.from, options.to, onDone];
	            break;
	
	          case 'setClass':
	            args = [element, classesToAdd, classesToRemove, onDone];
	            break;
	
	          case 'addClass':
	            args = [element, classesToAdd, onDone];
	            break;
	
	          case 'removeClass':
	            args = [element, classesToRemove, onDone];
	            break;
	
	          default:
	            args = [element, onDone];
	            break;
	        }
	
	        args.push(options);
	
	        var value = fn.apply(fn, args);
	        if (value) {
	          if (isFunction(value.start)) {
	            value = value.start();
	          }
	
	          if (value instanceof $$AnimateRunner) {
	            value.done(onDone);
	          } else if (isFunction(value)) {
	            // optional onEnd / onCancel callback
	            return value;
	          }
	        }
	
	        return noop;
	      }
	
	      function groupEventedAnimations(element, event, options, animations, fnName) {
	        var operations = [];
	        forEach(animations, function(ani) {
	          var animation = ani[fnName];
	          if (!animation) return;
	
	          // note that all of these animations will run in parallel
	          operations.push(function() {
	            var runner;
	            var endProgressCb;
	
	            var resolved = false;
	            var onAnimationComplete = function(rejected) {
	              if (!resolved) {
	                resolved = true;
	                (endProgressCb || noop)(rejected);
	                runner.complete(!rejected);
	              }
	            };
	
	            runner = new $$AnimateRunner({
	              end: function() {
	                onAnimationComplete();
	              },
	              cancel: function() {
	                onAnimationComplete(true);
	              }
	            });
	
	            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
	              var cancelled = result === false;
	              onAnimationComplete(cancelled);
	            });
	
	            return runner;
	          });
	        });
	
	        return operations;
	      }
	
	      function packageAnimations(element, event, options, animations, fnName) {
	        var operations = groupEventedAnimations(element, event, options, animations, fnName);
	        if (operations.length === 0) {
	          var a,b;
	          if (fnName === 'beforeSetClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	          } else if (fnName === 'setClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	          }
	
	          if (a) {
	            operations = operations.concat(a);
	          }
	          if (b) {
	            operations = operations.concat(b);
	          }
	        }
	
	        if (operations.length === 0) return;
	
	        // TODO(matsko): add documentation
	        return function startAnimation(callback) {
	          var runners = [];
	          if (operations.length) {
	            forEach(operations, function(animateFn) {
	              runners.push(animateFn());
	            });
	          }
	
	          runners.length ? $$AnimateRunner.all(runners, callback) : callback();
	
	          return function endFn(reject) {
	            forEach(runners, function(runner) {
	              reject ? runner.cancel() : runner.end();
	            });
	          };
	        };
	      }
	    };
	
	    function lookupAnimations(classes) {
	      classes = isArray(classes) ? classes : classes.split(' ');
	      var matches = [], flagMap = {};
	      for (var i=0; i < classes.length; i++) {
	        var klass = classes[i],
	            animationFactory = $animateProvider.$$registeredAnimations[klass];
	        if (animationFactory && !flagMap[klass]) {
	          matches.push($injector.get(animationFactory));
	          flagMap[klass] = true;
	        }
	      }
	      return matches;
	    }
	  }];
	}];
	
	var $$AnimateJsDriverProvider = ['$$animationProvider', function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateJsDriver');
	  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
	    return function initDriverFn(animationDetails) {
	      if (animationDetails.from && animationDetails.to) {
	        var fromAnimation = prepareAnimation(animationDetails.from);
	        var toAnimation = prepareAnimation(animationDetails.to);
	        if (!fromAnimation && !toAnimation) return;
	
	        return {
	          start: function() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            $$AnimateRunner.all(animationRunners, done);
	
	            var runner = new $$AnimateRunner({
	              end: endFnFactory(),
	              cancel: endFnFactory()
	            });
	
	            return runner;
	
	            function endFnFactory() {
	              return function() {
	                forEach(animationRunners, function(runner) {
	                  // at this point we cannot cancel animations for groups just yet. 1.5+
	                  runner.end();
	                });
	              };
	            }
	
	            function done(status) {
	              runner.complete(status);
	            }
	          }
	        };
	      } else {
	        return prepareAnimation(animationDetails);
	      }
	    };
	
	    function prepareAnimation(animationDetails) {
	      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	      var element = animationDetails.element;
	      var event = animationDetails.event;
	      var options = animationDetails.options;
	      var classes = animationDetails.classes;
	      return $$animateJs(element, event, classes, options);
	    }
	  }];
	}];
	
	var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	var $$AnimateQueueProvider = ['$animateProvider', function($animateProvider) {
	  var PRE_DIGEST_STATE = 1;
	  var RUNNING_STATE = 2;
	  var ONE_SPACE = ' ';
	
	  var rules = this.rules = {
	    skip: [],
	    cancel: [],
	    join: []
	  };
	
	  function makeTruthyCssClassMap(classString) {
	    if (!classString) {
	      return null;
	    }
	
	    var keys = classString.split(ONE_SPACE);
	    var map = Object.create(null);
	
	    forEach(keys, function(key) {
	      map[key] = true;
	    });
	    return map;
	  }
	
	  function hasMatchingClasses(newClassString, currentClassString) {
	    if (newClassString && currentClassString) {
	      var currentClassMap = makeTruthyCssClassMap(currentClassString);
	      return newClassString.split(ONE_SPACE).some(function(className) {
	        return currentClassMap[className];
	      });
	    }
	  }
	
	  function isAllowed(ruleType, element, currentAnimation, previousAnimation) {
	    return rules[ruleType].some(function(fn) {
	      return fn(element, currentAnimation, previousAnimation);
	    });
	  }
	
	  function hasAnimationClasses(animation, and) {
	    var a = (animation.addClass || '').length > 0;
	    var b = (animation.removeClass || '').length > 0;
	    return and ? a && b : a || b;
	  }
	
	  rules.join.push(function(element, newAnimation, currentAnimation) {
	    // if the new animation is class-based then we can just tack that on
	    return !newAnimation.structural && hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // there is no need to animate anything if no classes are being added and
	    // there is no structural animation that will be triggered
	    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // why should we trigger a new structural animation if the element will
	    // be removed from the DOM anyway?
	    return currentAnimation.event == 'leave' && newAnimation.structural;
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // if there is an ongoing current animation then don't even bother running the class-based animation
	    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // there can never be two structural animations running at the same time
	    return currentAnimation.structural && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // if the previous animation is already running, but the new animation will
	    // be triggered, but the new animation is structural
	    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // cancel the animation if classes added / removed in both animation cancel each other out,
	    // but only if the current animation isn't structural
	
	    if (currentAnimation.structural) return false;
	
	    var nA = newAnimation.addClass;
	    var nR = newAnimation.removeClass;
	    var cA = currentAnimation.addClass;
	    var cR = currentAnimation.removeClass;
	
	    // early detection to save the global CPU shortage :)
	    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
	      return false;
	    }
	
	    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	  });
	
	  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$HashMap',
	               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
	       function($$rAF,   $rootScope,   $rootElement,   $document,   $$HashMap,
	                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow) {
	
	    var activeAnimationsLookup = new $$HashMap();
	    var disabledElementsLookup = new $$HashMap();
	    var animationsEnabled = null;
	
	    function postDigestTaskFactory() {
	      var postDigestCalled = false;
	      return function(fn) {
	        // we only issue a call to postDigest before
	        // it has first passed. This prevents any callbacks
	        // from not firing once the animation has completed
	        // since it will be out of the digest cycle.
	        if (postDigestCalled) {
	          fn();
	        } else {
	          $rootScope.$$postDigest(function() {
	            postDigestCalled = true;
	            fn();
	          });
	        }
	      };
	    }
	
	    // Wait until all directive and route-related templates are downloaded and
	    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	    // all of the remote templates being currently downloaded. If there are no
	    // templates currently downloading then the watcher will still fire anyway.
	    var deregisterWatch = $rootScope.$watch(
	      function() { return $templateRequest.totalPendingRequests === 0; },
	      function(isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function() {
	          $rootScope.$$postDigest(function() {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      }
	    );
	
	    var callbackRegistry = Object.create(null);
	
	    // remember that the classNameFilter is set during the provider/config
	    // stage therefore we can optimize here and setup a helper function
	    var classNameFilter = $animateProvider.classNameFilter();
	    var isAnimatableClassName = !classNameFilter
	              ? function() { return true; }
	              : function(className) {
	                return classNameFilter.test(className);
	              };
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function normalizeAnimationDetails(element, animation) {
	      return mergeAnimationDetails(element, animation, {});
	    }
	
	    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	    var contains = window.Node.prototype.contains || function(arg) {
	      // jshint bitwise: false
	      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	      // jshint bitwise: true
	    };
	
	    function findCallbacks(parent, element, event) {
	      var targetNode = getDomNode(element);
	      var targetParentNode = getDomNode(parent);
	
	      var matches = [];
	      var entries = callbackRegistry[event];
	      if (entries) {
	        forEach(entries, function(entry) {
	          if (contains.call(entry.node, targetNode)) {
	            matches.push(entry.callback);
	          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	            matches.push(entry.callback);
	          }
	        });
	      }
	
	      return matches;
	    }
	
	    function filterFromRegistry(list, matchContainer, matchCallback) {
	      var containerNode = extractElementNode(matchContainer);
	      return list.filter(function(entry) {
	        var isMatch = entry.node === containerNode &&
	                        (!matchCallback || entry.callback === matchCallback);
	        return !isMatch;
	      });
	    }
	
	    function cleanupEventListeners(phase, element) {
	      if (phase === 'close' && !element[0].parentNode) {
	        // If the element is not attached to a parentNode, it has been removed by
	        // the domOperation, and we can safely remove the event callbacks
	        $animate.off(element);
	      }
	    }
	
	    var $animate = {
	      on: function(event, container, callback) {
	        var node = extractElementNode(container);
	        callbackRegistry[event] = callbackRegistry[event] || [];
	        callbackRegistry[event].push({
	          node: node,
	          callback: callback
	        });
	
	        // Remove the callback when the element is removed from the DOM
	        jqLite(container).on('$destroy', function() {
	          var animationDetails = activeAnimationsLookup.get(node);
	
	          if (!animationDetails) {
	            // If there's an animation ongoing, the callback calling code will remove
	            // the event listeners. If we'd remove here, the callbacks would be removed
	            // before the animation ends
	            $animate.off(event, container, callback);
	          }
	        });
	      },
	
	      off: function(event, container, callback) {
	        if (arguments.length === 1 && !isString(arguments[0])) {
	          container = arguments[0];
	          for (var eventType in callbackRegistry) {
	            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	          }
	
	          return;
	        }
	
	        var entries = callbackRegistry[event];
	        if (!entries) return;
	
	        callbackRegistry[event] = arguments.length === 1
	            ? null
	            : filterFromRegistry(entries, container, callback);
	      },
	
	      pin: function(element, parentElement) {
	        assertArg(isElement(element), 'element', 'not an element');
	        assertArg(isElement(parentElement), 'parentElement', 'not an element');
	        element.data(NG_ANIMATE_PIN_DATA, parentElement);
	      },
	
	      push: function(element, event, options, domOperation) {
	        options = options || {};
	        options.domOperation = domOperation;
	        return queueAnimation(element, event, options);
	      },
	
	      // this method has four signatures:
	      //  () - global getter
	      //  (bool) - global setter
	      //  (element) - element getter
	      //  (element, bool) - element setter<F37>
	      enabled: function(element, bool) {
	        var argCount = arguments.length;
	
	        if (argCount === 0) {
	          // () - Global getter
	          bool = !!animationsEnabled;
	        } else {
	          var hasElement = isElement(element);
	
	          if (!hasElement) {
	            // (bool) - Global setter
	            bool = animationsEnabled = !!element;
	          } else {
	            var node = getDomNode(element);
	
	            if (argCount === 1) {
	              // (element) - Element getter
	              bool = !disabledElementsLookup.get(node);
	            } else {
	              // (element, bool) - Element setter
	              disabledElementsLookup.put(node, !bool);
	            }
	          }
	        }
	
	        return bool;
	      }
	    };
	
	    return $animate;
	
	    function queueAnimation(element, event, initialOptions) {
	      // we always make a copy of the options since
	      // there should never be any side effects on
	      // the input data when running `$animateCss`.
	      var options = copy(initialOptions);
	
	      var node, parent;
	      element = stripCommentsFromElement(element);
	      if (element) {
	        node = getDomNode(element);
	        parent = element.parent();
	      }
	
	      options = prepareAnimationOptions(options);
	
	      // we create a fake runner with a working promise.
	      // These methods will become available after the digest has passed
	      var runner = new $$AnimateRunner();
	
	      // this is used to trigger callbacks in postDigest mode
	      var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	      if (isArray(options.addClass)) {
	        options.addClass = options.addClass.join(' ');
	      }
	
	      if (options.addClass && !isString(options.addClass)) {
	        options.addClass = null;
	      }
	
	      if (isArray(options.removeClass)) {
	        options.removeClass = options.removeClass.join(' ');
	      }
	
	      if (options.removeClass && !isString(options.removeClass)) {
	        options.removeClass = null;
	      }
	
	      if (options.from && !isObject(options.from)) {
	        options.from = null;
	      }
	
	      if (options.to && !isObject(options.to)) {
	        options.to = null;
	      }
	
	      // there are situations where a directive issues an animation for
	      // a jqLite wrapper that contains only comment nodes... If this
	      // happens then there is no way we can perform an animation
	      if (!node) {
	        close();
	        return runner;
	      }
	
	      var className = [node.className, options.addClass, options.removeClass].join(' ');
	      if (!isAnimatableClassName(className)) {
	        close();
	        return runner;
	      }
	
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      var documentHidden = $document[0].hidden;
	
	      // this is a hard disable of all animations for the application or on
	      // the element itself, therefore  there is no need to continue further
	      // past this point if not enabled
	      // Animations are also disabled if the document is currently hidden (page is not visible
	      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
	      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
	      var hasExistingAnimation = !!existingAnimation.state;
	
	      // there is no point in traversing the same collection of parent ancestors if a followup
	      // animation will be run on the same element that already did all that checking work
	      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state != PRE_DIGEST_STATE)) {
	        skipAnimations = !areAnimationsAllowed(element, parent, event);
	      }
	
	      if (skipAnimations) {
	        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	        if (documentHidden) notifyProgress(runner, event, 'start');
	        close();
	        if (documentHidden) notifyProgress(runner, event, 'close');
	        return runner;
	      }
	
	      if (isStructural) {
	        closeChildAnimations(element);
	      }
	
	      var newAnimation = {
	        structural: isStructural,
	        element: element,
	        event: event,
	        addClass: options.addClass,
	        removeClass: options.removeClass,
	        close: close,
	        options: options,
	        runner: runner
	      };
	
	      if (hasExistingAnimation) {
	        var skipAnimationFlag = isAllowed('skip', element, newAnimation, existingAnimation);
	        if (skipAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            close();
	            return runner;
	          } else {
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	            return existingAnimation.runner;
	          }
	        }
	        var cancelAnimationFlag = isAllowed('cancel', element, newAnimation, existingAnimation);
	        if (cancelAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            // this will end the animation right away and it is safe
	            // to do so since the animation is already running and the
	            // runner callback code will run in async
	            existingAnimation.runner.end();
	          } else if (existingAnimation.structural) {
	            // this means that the animation is queued into a digest, but
	            // hasn't started yet. Therefore it is safe to run the close
	            // method which will call the runner methods in async.
	            existingAnimation.close();
	          } else {
	            // this will merge the new animation options into existing animation options
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	            return existingAnimation.runner;
	          }
	        } else {
	          // a joined animation means that this animation will take over the existing one
	          // so an example would involve a leave animation taking over an enter. Then when
	          // the postDigest kicks in the enter will be ignored.
	          var joinAnimationFlag = isAllowed('join', element, newAnimation, existingAnimation);
	          if (joinAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              normalizeAnimationDetails(element, newAnimation);
	            } else {
	              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);
	
	              event = newAnimation.event = existingAnimation.event;
	              options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              //we return the same runner since only the option values of this animation will
	              //be fed into the `existingAnimation`.
	              return existingAnimation.runner;
	            }
	          }
	        }
	      } else {
	        // normalization in this case means that it removes redundant CSS classes that
	        // already exist (addClass) or do not exist (removeClass) on the element
	        normalizeAnimationDetails(element, newAnimation);
	      }
	
	      // when the options are merged and cleaned up we may end up not having to do
	      // an animation at all, therefore we should check this before issuing a post
	      // digest callback. Structural animations will always run no matter what.
	      var isValidAnimation = newAnimation.structural;
	      if (!isValidAnimation) {
	        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
	                            || hasAnimationClasses(newAnimation);
	      }
	
	      if (!isValidAnimation) {
	        close();
	        clearElementAnimationState(element);
	        return runner;
	      }
	
	      // the counter keeps track of cancelled animations
	      var counter = (existingAnimation.counter || 0) + 1;
	      newAnimation.counter = counter;
	
	      markElementAnimationState(element, PRE_DIGEST_STATE, newAnimation);
	
	      $rootScope.$$postDigest(function() {
	        var animationDetails = activeAnimationsLookup.get(node);
	        var animationCancelled = !animationDetails;
	        animationDetails = animationDetails || {};
	
	        // if addClass/removeClass is called before something like enter then the
	        // registered parent element may not be present. The code below will ensure
	        // that a final value for parent element is obtained
	        var parentElement = element.parent() || [];
	
	        // animate/structural/class-based animations all have requirements. Otherwise there
	        // is no point in performing an animation. The parent node must also be set.
	        var isValidAnimation = parentElement.length > 0
	                                && (animationDetails.event === 'animate'
	                                    || animationDetails.structural
	                                    || hasAnimationClasses(animationDetails));
	
	        // this means that the previous animation was cancelled
	        // even if the follow-up animation is the same event
	        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	          // if another animation did not take over then we need
	          // to make sure that the domOperation and options are
	          // handled accordingly
	          if (animationCancelled) {
	            applyAnimationClasses(element, options);
	            applyAnimationStyles(element, options);
	          }
	
	          // if the event changed from something like enter to leave then we do
	          // it, otherwise if it's the same then the end result will be the same too
	          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
	            options.domOperation();
	            runner.end();
	          }
	
	          // in the event that the element animation was not cancelled or a follow-up animation
	          // isn't allowed to animate from here then we need to clear the state of the element
	          // so that any future animations won't read the expired animation data.
	          if (!isValidAnimation) {
	            clearElementAnimationState(element);
	          }
	
	          return;
	        }
	
	        // this combined multiple class to addClass / removeClass into a setClass event
	        // so long as a structural event did not take over the animation
	        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
	            ? 'setClass'
	            : animationDetails.event;
	
	        markElementAnimationState(element, RUNNING_STATE);
	        var realRunner = $$animation(element, event, animationDetails.options);
	
	        // this will update the runner's flow-control events based on
	        // the `realRunner` object.
	        runner.setHost(realRunner);
	        notifyProgress(runner, event, 'start', {});
	
	        realRunner.done(function(status) {
	          close(!status);
	          var animationDetails = activeAnimationsLookup.get(node);
	          if (animationDetails && animationDetails.counter === counter) {
	            clearElementAnimationState(getDomNode(element));
	          }
	          notifyProgress(runner, event, 'close', {});
	        });
	      });
	
	      return runner;
	
	      function notifyProgress(runner, event, phase, data) {
	        runInNextPostDigestOrNow(function() {
	          var callbacks = findCallbacks(parent, element, event);
	          if (callbacks.length) {
	            // do not optimize this call here to RAF because
	            // we don't know how heavy the callback code here will
	            // be and if this code is buffered then this can
	            // lead to a performance regression.
	            $$rAF(function() {
	              forEach(callbacks, function(callback) {
	                callback(element, phase, data);
	              });
	              cleanupEventListeners(phase, element);
	            });
	          } else {
	            cleanupEventListeners(phase, element);
	          }
	        });
	        runner.progress(event, phase, data);
	      }
	
	      function close(reject) { // jshint ignore:line
	        clearGeneratedClasses(element, options);
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	        runner.complete(!reject);
	      }
	    }
	
	    function closeChildAnimations(element) {
	      var node = getDomNode(element);
	      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	      forEach(children, function(child) {
	        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME));
	        var animationDetails = activeAnimationsLookup.get(child);
	        if (animationDetails) {
	          switch (state) {
	            case RUNNING_STATE:
	              animationDetails.runner.end();
	              /* falls through */
	            case PRE_DIGEST_STATE:
	              activeAnimationsLookup.remove(child);
	              break;
	          }
	        }
	      });
	    }
	
	    function clearElementAnimationState(element) {
	      var node = getDomNode(element);
	      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	      activeAnimationsLookup.remove(node);
	    }
	
	    function isMatchingElement(nodeOrElmA, nodeOrElmB) {
	      return getDomNode(nodeOrElmA) === getDomNode(nodeOrElmB);
	    }
	
	    /**
	     * This fn returns false if any of the following is true:
	     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	     * b) a parent element has an ongoing structural animation, and animateChildren is false
	     * c) the element is not a child of the body
	     * d) the element is not a child of the $rootElement
	     */
	    function areAnimationsAllowed(element, parentElement, event) {
	      var bodyElement = jqLite($document[0].body);
	      var bodyElementDetected = isMatchingElement(element, bodyElement) || element[0].nodeName === 'HTML';
	      var rootElementDetected = isMatchingElement(element, $rootElement);
	      var parentAnimationDetected = false;
	      var animateChildren;
	      var elementDisabled = disabledElementsLookup.get(getDomNode(element));
	
	      var parentHost = jqLite.data(element[0], NG_ANIMATE_PIN_DATA);
	      if (parentHost) {
	        parentElement = parentHost;
	      }
	
	      parentElement = getDomNode(parentElement);
	
	      while (parentElement) {
	        if (!rootElementDetected) {
	          // angular doesn't want to attempt to animate elements outside of the application
	          // therefore we need to ensure that the rootElement is an ancestor of the current element
	          rootElementDetected = isMatchingElement(parentElement, $rootElement);
	        }
	
	        if (parentElement.nodeType !== ELEMENT_NODE) {
	          // no point in inspecting the #document element
	          break;
	        }
	
	        var details = activeAnimationsLookup.get(parentElement) || {};
	        // either an enter, leave or move animation will commence
	        // therefore we can't allow any animations to take place
	        // but if a parent animation is class-based then that's ok
	        if (!parentAnimationDetected) {
	          var parentElementDisabled = disabledElementsLookup.get(parentElement);
	
	          if (parentElementDisabled === true && elementDisabled !== false) {
	            // disable animations if the user hasn't explicitly enabled animations on the
	            // current element
	            elementDisabled = true;
	            // element is disabled via parent element, no need to check anything else
	            break;
	          } else if (parentElementDisabled === false) {
	            elementDisabled = false;
	          }
	          parentAnimationDetected = details.structural;
	        }
	
	        if (isUndefined(animateChildren) || animateChildren === true) {
	          var value = jqLite.data(parentElement, NG_ANIMATE_CHILDREN_DATA);
	          if (isDefined(value)) {
	            animateChildren = value;
	          }
	        }
	
	        // there is no need to continue traversing at this point
	        if (parentAnimationDetected && animateChildren === false) break;
	
	        if (!bodyElementDetected) {
	          // we also need to ensure that the element is or will be a part of the body element
	          // otherwise it is pointless to even issue an animation to be rendered
	          bodyElementDetected = isMatchingElement(parentElement, bodyElement);
	        }
	
	        if (bodyElementDetected && rootElementDetected) {
	          // If both body and root have been found, any other checks are pointless,
	          // as no animation data should live outside the application
	          break;
	        }
	
	        if (!rootElementDetected) {
	          // If no rootElement is detected, check if the parentElement is pinned to another element
	          parentHost = jqLite.data(parentElement, NG_ANIMATE_PIN_DATA);
	          if (parentHost) {
	            // The pin target element becomes the next parent element
	            parentElement = getDomNode(parentHost);
	            continue;
	          }
	        }
	
	        parentElement = parentElement.parentNode;
	      }
	
	      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	      return allowAnimation && rootElementDetected && bodyElementDetected;
	    }
	
	    function markElementAnimationState(element, state, details) {
	      details = details || {};
	      details.state = state;
	
	      var node = getDomNode(element);
	      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	      var oldValue = activeAnimationsLookup.get(node);
	      var newValue = oldValue
	          ? extend(oldValue, details)
	          : details;
	      activeAnimationsLookup.put(node, newValue);
	    }
	  }];
	}];
	
	var $$AnimationProvider = ['$animateProvider', function($animateProvider) {
	  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	  var drivers = this.drivers = [];
	
	  var RUNNER_STORAGE_KEY = '$$animationRunner';
	
	  function setRunner(element, runner) {
	    element.data(RUNNER_STORAGE_KEY, runner);
	  }
	
	  function removeRunner(element) {
	    element.removeData(RUNNER_STORAGE_KEY);
	  }
	
	  function getRunner(element) {
	    return element.data(RUNNER_STORAGE_KEY);
	  }
	
	  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$HashMap', '$$rAFScheduler',
	       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$HashMap,   $$rAFScheduler) {
	
	    var animationQueue = [];
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function sortAnimations(animations) {
	      var tree = { children: [] };
	      var i, lookup = new $$HashMap();
	
	      // this is done first beforehand so that the hashmap
	      // is filled with a list of the elements that will be animated
	      for (i = 0; i < animations.length; i++) {
	        var animation = animations[i];
	        lookup.put(animation.domNode, animations[i] = {
	          domNode: animation.domNode,
	          fn: animation.fn,
	          children: []
	        });
	      }
	
	      for (i = 0; i < animations.length; i++) {
	        processNode(animations[i]);
	      }
	
	      return flatten(tree);
	
	      function processNode(entry) {
	        if (entry.processed) return entry;
	        entry.processed = true;
	
	        var elementNode = entry.domNode;
	        var parentNode = elementNode.parentNode;
	        lookup.put(elementNode, entry);
	
	        var parentEntry;
	        while (parentNode) {
	          parentEntry = lookup.get(parentNode);
	          if (parentEntry) {
	            if (!parentEntry.processed) {
	              parentEntry = processNode(parentEntry);
	            }
	            break;
	          }
	          parentNode = parentNode.parentNode;
	        }
	
	        (parentEntry || tree).children.push(entry);
	        return entry;
	      }
	
	      function flatten(tree) {
	        var result = [];
	        var queue = [];
	        var i;
	
	        for (i = 0; i < tree.children.length; i++) {
	          queue.push(tree.children[i]);
	        }
	
	        var remainingLevelEntries = queue.length;
	        var nextLevelEntries = 0;
	        var row = [];
	
	        for (i = 0; i < queue.length; i++) {
	          var entry = queue[i];
	          if (remainingLevelEntries <= 0) {
	            remainingLevelEntries = nextLevelEntries;
	            nextLevelEntries = 0;
	            result.push(row);
	            row = [];
	          }
	          row.push(entry.fn);
	          entry.children.forEach(function(childEntry) {
	            nextLevelEntries++;
	            queue.push(childEntry);
	          });
	          remainingLevelEntries--;
	        }
	
	        if (row.length) {
	          result.push(row);
	        }
	
	        return result;
	      }
	    }
	
	    // TODO(matsko): document the signature in a better way
	    return function(element, event, options) {
	      options = prepareAnimationOptions(options);
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      // there is no animation at the current moment, however
	      // these runner methods will get later updated with the
	      // methods leading into the driver's end/cancel methods
	      // for now they just stop the animation from starting
	      var runner = new $$AnimateRunner({
	        end: function() { close(); },
	        cancel: function() { close(true); }
	      });
	
	      if (!drivers.length) {
	        close();
	        return runner;
	      }
	
	      setRunner(element, runner);
	
	      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	      var tempClasses = options.tempClasses;
	      if (tempClasses) {
	        classes += ' ' + tempClasses;
	        options.tempClasses = null;
	      }
	
	      var prepareClassName;
	      if (isStructural) {
	        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
	        $$jqLite.addClass(element, prepareClassName);
	      }
	
	      animationQueue.push({
	        // this data is used by the postDigest code and passed into
	        // the driver step function
	        element: element,
	        classes: classes,
	        event: event,
	        structural: isStructural,
	        options: options,
	        beforeStart: beforeStart,
	        close: close
	      });
	
	      element.on('$destroy', handleDestroyedElement);
	
	      // we only want there to be one function called within the post digest
	      // block. This way we can group animations for all the animations that
	      // were apart of the same postDigest flush call.
	      if (animationQueue.length > 1) return runner;
	
	      $rootScope.$$postDigest(function() {
	        var animations = [];
	        forEach(animationQueue, function(entry) {
	          // the element was destroyed early on which removed the runner
	          // form its storage. This means we can't animate this element
	          // at all and it already has been closed due to destruction.
	          if (getRunner(entry.element)) {
	            animations.push(entry);
	          } else {
	            entry.close();
	          }
	        });
	
	        // now any future animations will be in another postDigest
	        animationQueue.length = 0;
	
	        var groupedAnimations = groupAnimations(animations);
	        var toBeSortedAnimations = [];
	
	        forEach(groupedAnimations, function(animationEntry) {
	          toBeSortedAnimations.push({
	            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
	            fn: function triggerAnimationStart() {
	              // it's important that we apply the `ng-animate` CSS class and the
	              // temporary classes before we do any driver invoking since these
	              // CSS classes may be required for proper CSS detection.
	              animationEntry.beforeStart();
	
	              var startAnimationFn, closeFn = animationEntry.close;
	
	              // in the event that the element was removed before the digest runs or
	              // during the RAF sequencing then we should not trigger the animation.
	              var targetElement = animationEntry.anchors
	                  ? (animationEntry.from.element || animationEntry.to.element)
	                  : animationEntry.element;
	
	              if (getRunner(targetElement)) {
	                var operation = invokeFirstDriver(animationEntry);
	                if (operation) {
	                  startAnimationFn = operation.start;
	                }
	              }
	
	              if (!startAnimationFn) {
	                closeFn();
	              } else {
	                var animationRunner = startAnimationFn();
	                animationRunner.done(function(status) {
	                  closeFn(!status);
	                });
	                updateAnimationRunners(animationEntry, animationRunner);
	              }
	            }
	          });
	        });
	
	        // we need to sort each of the animations in order of parent to child
	        // relationships. This ensures that the child classes are applied at the
	        // right time.
	        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
	      });
	
	      return runner;
	
	      // TODO(matsko): change to reference nodes
	      function getAnchorNodes(node) {
	        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
	              ? [node]
	              : node.querySelectorAll(SELECTOR);
	        var anchors = [];
	        forEach(items, function(node) {
	          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	          if (attr && attr.length) {
	            anchors.push(node);
	          }
	        });
	        return anchors;
	      }
	
	      function groupAnimations(animations) {
	        var preparedAnimations = [];
	        var refLookup = {};
	        forEach(animations, function(animation, index) {
	          var element = animation.element;
	          var node = getDomNode(element);
	          var event = animation.event;
	          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	          if (anchorNodes.length) {
	            var direction = enterOrMove ? 'to' : 'from';
	
	            forEach(anchorNodes, function(anchor) {
	              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	              refLookup[key] = refLookup[key] || {};
	              refLookup[key][direction] = {
	                animationID: index,
	                element: jqLite(anchor)
	              };
	            });
	          } else {
	            preparedAnimations.push(animation);
	          }
	        });
	
	        var usedIndicesLookup = {};
	        var anchorGroups = {};
	        forEach(refLookup, function(operations, key) {
	          var from = operations.from;
	          var to = operations.to;
	
	          if (!from || !to) {
	            // only one of these is set therefore we can't have an
	            // anchor animation since all three pieces are required
	            var index = from ? from.animationID : to.animationID;
	            var indexKey = index.toString();
	            if (!usedIndicesLookup[indexKey]) {
	              usedIndicesLookup[indexKey] = true;
	              preparedAnimations.push(animations[index]);
	            }
	            return;
	          }
	
	          var fromAnimation = animations[from.animationID];
	          var toAnimation = animations[to.animationID];
	          var lookupKey = from.animationID.toString();
	          if (!anchorGroups[lookupKey]) {
	            var group = anchorGroups[lookupKey] = {
	              structural: true,
	              beforeStart: function() {
	                fromAnimation.beforeStart();
	                toAnimation.beforeStart();
	              },
	              close: function() {
	                fromAnimation.close();
	                toAnimation.close();
	              },
	              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	              from: fromAnimation,
	              to: toAnimation,
	              anchors: [] // TODO(matsko): change to reference nodes
	            };
	
	            // the anchor animations require that the from and to elements both have at least
	            // one shared CSS class which effectively marries the two elements together to use
	            // the same animation driver and to properly sequence the anchor animation.
	            if (group.classes.length) {
	              preparedAnimations.push(group);
	            } else {
	              preparedAnimations.push(fromAnimation);
	              preparedAnimations.push(toAnimation);
	            }
	          }
	
	          anchorGroups[lookupKey].anchors.push({
	            'out': from.element, 'in': to.element
	          });
	        });
	
	        return preparedAnimations;
	      }
	
	      function cssClassesIntersection(a,b) {
	        a = a.split(' ');
	        b = b.split(' ');
	        var matches = [];
	
	        for (var i = 0; i < a.length; i++) {
	          var aa = a[i];
	          if (aa.substring(0,3) === 'ng-') continue;
	
	          for (var j = 0; j < b.length; j++) {
	            if (aa === b[j]) {
	              matches.push(aa);
	              break;
	            }
	          }
	        }
	
	        return matches.join(' ');
	      }
	
	      function invokeFirstDriver(animationDetails) {
	        // we loop in reverse order since the more general drivers (like CSS and JS)
	        // may attempt more elements, but custom drivers are more particular
	        for (var i = drivers.length - 1; i >= 0; i--) {
	          var driverName = drivers[i];
	          var factory = $injector.get(driverName);
	          var driver = factory(animationDetails);
	          if (driver) {
	            return driver;
	          }
	        }
	      }
	
	      function beforeStart() {
	        element.addClass(NG_ANIMATE_CLASSNAME);
	        if (tempClasses) {
	          $$jqLite.addClass(element, tempClasses);
	        }
	        if (prepareClassName) {
	          $$jqLite.removeClass(element, prepareClassName);
	          prepareClassName = null;
	        }
	      }
	
	      function updateAnimationRunners(animation, newRunner) {
	        if (animation.from && animation.to) {
	          update(animation.from.element);
	          update(animation.to.element);
	        } else {
	          update(animation.element);
	        }
	
	        function update(element) {
	          var runner = getRunner(element);
	          if (runner) runner.setHost(newRunner);
	        }
	      }
	
	      function handleDestroyedElement() {
	        var runner = getRunner(element);
	        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	          runner.end();
	        }
	      }
	
	      function close(rejected) { // jshint ignore:line
	        element.off('$destroy', handleDestroyedElement);
	        removeRunner(element);
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	
	        if (tempClasses) {
	          $$jqLite.removeClass(element, tempClasses);
	        }
	
	        element.removeClass(NG_ANIMATE_CLASSNAME);
	        runner.complete(!rejected);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateSwap
	 * @restrict A
	 * @scope
	 *
	 * @description
	 *
	 * ngAnimateSwap is a animation-oriented directive that allows for the container to
	 * be removed and entered in whenever the associated expression changes. A
	 * common usecase for this directive is a rotating banner or slider component which
	 * contains one image being present at a time. When the active image changes
	 * then the old image will perform a `leave` animation and the new element
	 * will be inserted via an `enter` animation.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|--------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	 *
	 * @example
	 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	 *          deps="angular-animate.js"
	 *          animations="true" fixBase="true">
	 *   <file name="index.html">
	 *     <div class="container" ng-controller="AppCtrl">
	 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	 *         {{ number }}
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="script.js">
	 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	 *         $scope.number = 0;
	 *         $interval(function() {
	 *           $scope.number++;
	 *         }, 1000);
	 *
	 *         var colors = ['red','blue','green','yellow','orange'];
	 *         $scope.colorClass = function(number) {
	 *           return colors[number % colors.length];
	 *         };
	 *       }]);
	 *   </file>
	 *  <file name="animations.css">
	 *  .container {
	 *    height:250px;
	 *    width:250px;
	 *    position:relative;
	 *    overflow:hidden;
	 *    border:2px solid black;
	 *  }
	 *  .container .cell {
	 *    font-size:150px;
	 *    text-align:center;
	 *    line-height:250px;
	 *    position:absolute;
	 *    top:0;
	 *    left:0;
	 *    right:0;
	 *    border-bottom:2px solid black;
	 *  }
	 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	 *    transition:0.5s linear all;
	 *  }
	 *  .swap-animation.ng-enter {
	 *    top:-250px;
	 *  }
	 *  .swap-animation.ng-enter-active {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave-active {
	 *    top:250px;
	 *  }
	 *  .red { background:red; }
	 *  .green { background:green; }
	 *  .blue { background:blue; }
	 *  .yellow { background:yellow; }
	 *  .orange { background:orange; }
	 *  </file>
	 * </example>
	 */
	var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
	  return {
	    restrict: 'A',
	    transclude: 'element',
	    terminal: true,
	    priority: 600, // we use 600 here to ensure that the directive is caught before others
	    link: function(scope, $element, attrs, ctrl, $transclude) {
	      var previousElement, previousScope;
	      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
	        if (previousElement) {
	          $animate.leave(previousElement);
	        }
	        if (previousScope) {
	          previousScope.$destroy();
	          previousScope = null;
	        }
	        if (value || value === 0) {
	          previousScope = scope.$new();
	          $transclude(previousScope, function(element) {
	            previousElement = element;
	            $animate.enter(element, null, $element);
	          });
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
	 *
	 * <div doc-module-components="ngAnimate"></div>
	 *
	 * # Usage
	 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	 * the HTML element that the animation will be triggered on.
	 *
	 * ## Directive Support
	 * The following directives are "animation aware":
	 *
	 * | Directive                                                                                                | Supported Animations                                                     |
	 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
	 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
	 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
	 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
	 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
	 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
	 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
	 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
	 *
	 * (More information can be found by visiting each the documentation associated with each directive.)
	 *
	 * ## CSS-based Animations
	 *
	 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	 * and CSS code we can create an animation that will be picked up by Angular when an the underlying directive performs an operation.
	 *
	 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	 *
	 * ```html
	 * <div ng-if="bool" class="fade">
	 *    Fade me in out
	 * </div>
	 * <button ng-click="bool=true">Fade In!</button>
	 * <button ng-click="bool=false">Fade Out!</button>
	 * ```
	 *
	 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	 *
	 * ```css
	 * /&#42; The starting CSS styles for the enter animation &#42;/
	 * .fade.ng-enter {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 *
	 * /&#42; The finishing CSS styles for the enter animation &#42;/
	 * .fade.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	 *
	 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	 *
	 * ```css
	 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	 * .fade.ng-leave {
	 *   transition:0.5s linear all;
	 *   opacity:1;
	 * }
	 * .fade.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	 *
	 * ```css
	 * /&#42; there is no need to define anything inside of the destination
	 * CSS class since the keyframe will take charge of the animation &#42;/
	 * .fade.ng-leave {
	 *   animation: my_fade_animation 0.5s linear;
	 *   -webkit-animation: my_fade_animation 0.5s linear;
	 * }
	 *
	 * @keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 *
	 * @-webkit-keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 * ```
	 *
	 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	 *
	 * ### CSS Class-based Animations
	 *
	 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	 * and removed.
	 *
	 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	 *
	 * ```html
	 * <div ng-show="bool" class="fade">
	 *   Show and hide me
	 * </div>
	 * <button ng-click="bool=!bool">Toggle</button>
	 *
	 * <style>
	 * .fade.ng-hide {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 * </style>
	 * ```
	 *
	 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	 *
	 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	 * with CSS styles.
	 *
	 * ```html
	 * <div ng-class="{on:onOff}" class="highlight">
	 *   Highlight this box
	 * </div>
	 * <button ng-click="onOff=!onOff">Toggle</button>
	 *
	 * <style>
	 * .highlight {
	 *   transition:0.5s linear all;
	 * }
	 * .highlight.on-add {
	 *   background:white;
	 * }
	 * .highlight.on {
	 *   background:yellow;
	 * }
	 * .highlight.on-remove {
	 *   background:black;
	 * }
	 * </style>
	 * ```
	 *
	 * We can also make use of CSS keyframes by placing them within the CSS classes.
	 *
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	 *     to not accidentally inherit a delay property from another CSS class &#42;/
	 *   transition-duration: 0s;
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * window.requestAnimationFrame(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 *
	 *   $scope.$digest();
	 * });
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ### The `ng-animate` CSS class
	 *
	 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	 *
	 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	 *
	 * ```css
	 * .zipper.ng-animate {
	 *   transition:0.5s linear all;
	 * }
	 * .zipper.ng-enter {
	 *   opacity:0;
	 * }
	 * .zipper.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	 * the CSS class once an animation has completed.)
	 *
	 *
	 * ### The `ng-[event]-prepare` class
	 *
	 * This is a special class that can be used to prevent unwanted flickering / flash of content before
	 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	 * before the actual animation starts (after waiting for a $digest).
	 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	 *
	 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	 * into elements that have class-based animations such as `ngClass`.
	 *
	 * ```html
	 * <div ng-class="{red: myProp}">
	 *   <div ng-class="{blue: myProp}">
	 *     <div class="message" ng-if="myProp"></div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	 *
	 * ```css
	 * .message.ng-enter-prepare {
	 *   opacity: 0;
	 * }
	 *
	 * ```
	 *
	 * ## JavaScript-based Animations
	 *
	 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	 * `module.animation()` module function we can register the animation.
	 *
	 * Let's see an example of a enter/leave animation using `ngRepeat`:
	 *
	 * ```html
	 * <div ng-repeat="item in items" class="slide">
	 *   {{ item }}
	 * </div>
	 * ```
	 *
	 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     // make note that other events (like addClass/removeClass)
	 *     // have different function input parameters
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *
	 *       // remember to call doneFn so that angular
	 *       // knows that the animation has concluded
	 *     },
	 *
	 *     move: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *     },
	 *
	 *     leave: function(element, doneFn) {
	 *       jQuery(element).fadeOut(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	 * greensock.js and velocity.js.
	 *
	 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	 *
	 * ```html
	 * <div ng-class="color" class="colorful">
	 *   this box is moody
	 * </div>
	 * <button ng-click="color='red'">Change to red</button>
	 * <button ng-click="color='blue'">Change to blue</button>
	 * <button ng-click="color='green'">Change to green</button>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.colorful', [function() {
	 *   return {
	 *     addClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     removeClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     setClass: function(element, addedClass, removedClass, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## CSS + JS Animations Together
	 *
	 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
	 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	 * charge of the animation**:
	 *
	 * ```html
	 * <div ng-if="bool" class="slide">
	 *   Slide in and out
	 * </div>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).slideIn(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ```css
	 * .slide.ng-enter {
	 *   transition:0.5s linear all;
	 *   transform:translateY(-100px);
	 * }
	 * .slide.ng-enter.ng-enter-active {
	 *   transform:translateY(0);
	 * }
	 * ```
	 *
	 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	 * our own JS-based animation code:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	 *
	 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	 * data into `$animateCss` directly:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true,
	 *         addClass: 'maroon-setting',
	 *         from: { height:0 },
	 *         to: { height: 200 }
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Now we can fill in the rest via our transition CSS code:
	 *
	 * ```css
	 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	 * .slide.ng-enter { transition:0.5s linear all; }
	 *
	 * /&#42; this extra CSS class will be absorbed into the transition
	 * since the $animateCss code is adding the class &#42;/
	 * .maroon-setting { background:red; }
	 * ```
	 *
	 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	 *
	 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	 *
	 * ## Animation Anchoring (via `ng-animate-ref`)
	 *
	 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	 * structural areas of an application (like views) by pairing up elements using an attribute
	 * called `ng-animate-ref`.
	 *
	 * Let's say for example we have two views that are managed by `ng-view` and we want to show
	 * that there is a relationship between two components situated in within these views. By using the
	 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	 * can then attach an animation, which is triggered when the view changes.
	 *
	 * Say for example we have the following template code:
	 *
	 * ```html
	 * <!-- index.html -->
	 * <div ng-view class="view-animation">
	 * </div>
	 *
	 * <!-- home.html -->
	 * <a href="#/banner-page">
	 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * </a>
	 *
	 * <!-- banner-page.html -->
	 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * ```
	 *
	 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	 * HTML contents to see if there is a match reference between any components in the view
	 * that is leaving and the view that is entering. It will scan both the view which is being
	 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	 * contain a matching ref value.
	 *
	 * The two images match since they share the same ref value. ngAnimate will now create a
	 * transport element (which is a clone of the first image element) and it will then attempt
	 * to animate to the position of the second image element in the next view. For the animation to
	 * work a special CSS class called `ng-anchor` will be added to the transported element.
	 *
	 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	 * ngAnimate will handle the entire transition for us as well as the addition and removal of
	 * any changes of CSS classes between the elements:
	 *
	 * ```css
	 * .banner.ng-anchor {
	 *   /&#42; this animation will last for 1 second since there are
	 *          two phases to the animation (an `in` and an `out` phase) &#42;/
	 *   transition:0.5s linear all;
	 * }
	 * ```
	 *
	 * We also **must** include animations for the views that are being entered and removed
	 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	 *
	 * ```css
	 * .view-animation.ng-enter, .view-animation.ng-leave {
	 *   transition:0.5s linear all;
	 *   position:fixed;
	 *   left:0;
	 *   top:0;
	 *   width:100%;
	 * }
	 * .view-animation.ng-enter {
	 *   transform:translateX(100%);
	 * }
	 * .view-animation.ng-leave,
	 * .view-animation.ng-enter.ng-enter-active {
	 *   transform:translateX(0%);
	 * }
	 * .view-animation.ng-leave.ng-leave-active {
	 *   transform:translateX(-100%);
	 * }
	 * ```
	 *
	 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	 * from its origin. Once that animation is over then the `in` stage occurs which animates the
	 * element to its destination. The reason why there are two animations is to give enough time
	 * for the enter animation on the new element to be ready.
	 *
	 * The example above sets up a transition for both the in and out phases, but we can also target the out or
	 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	 *
	 * ```css
	 * .banner.ng-anchor-out {
	 *   transition: 0.5s linear all;
	 *
	 *   /&#42; the scale will be applied during the out animation,
	 *          but will be animated away when the in animation runs &#42;/
	 *   transform: scale(1.2);
	 * }
	 *
	 * .banner.ng-anchor-in {
	 *   transition: 1s linear all;
	 * }
	 * ```
	 *
	 *
	 *
	 *
	 * ### Anchoring Demo
	 *
	  <example module="anchoringExample"
	           name="anchoringExample"
	           id="anchoringExample"
	           deps="angular-animate.js;angular-route.js"
	           animations="true">
	    <file name="index.html">
	      <a href="#/">Home</a>
	      <hr />
	      <div class="view-container">
	        <div ng-view class="view"></div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	        .config(['$routeProvider', function($routeProvider) {
	          $routeProvider.when('/', {
	            templateUrl: 'home.html',
	            controller: 'HomeController as home'
	          });
	          $routeProvider.when('/profile/:id', {
	            templateUrl: 'profile.html',
	            controller: 'ProfileController as profile'
	          });
	        }])
	        .run(['$rootScope', function($rootScope) {
	          $rootScope.records = [
	            { id:1, title: "Miss Beulah Roob" },
	            { id:2, title: "Trent Morissette" },
	            { id:3, title: "Miss Ava Pouros" },
	            { id:4, title: "Rod Pouros" },
	            { id:5, title: "Abdul Rice" },
	            { id:6, title: "Laurie Rutherford Sr." },
	            { id:7, title: "Nakia McLaughlin" },
	            { id:8, title: "Jordon Blanda DVM" },
	            { id:9, title: "Rhoda Hand" },
	            { id:10, title: "Alexandrea Sauer" }
	          ];
	        }])
	        .controller('HomeController', [function() {
	          //empty
	        }])
	        .controller('ProfileController', ['$rootScope', '$routeParams', function($rootScope, $routeParams) {
	          var index = parseInt($routeParams.id, 10);
	          var record = $rootScope.records[index - 1];
	
	          this.title = record.title;
	          this.id = record.id;
	        }]);
	    </file>
	    <file name="home.html">
	      <h2>Welcome to the home page</h1>
	      <p>Please click on an element</p>
	      <a class="record"
	         ng-href="#/profile/{{ record.id }}"
	         ng-animate-ref="{{ record.id }}"
	         ng-repeat="record in records">
	        {{ record.title }}
	      </a>
	    </file>
	    <file name="profile.html">
	      <div class="profile record" ng-animate-ref="{{ profile.id }}">
	        {{ profile.title }}
	      </div>
	    </file>
	    <file name="animations.css">
	      .record {
	        display:block;
	        font-size:20px;
	      }
	      .profile {
	        background:black;
	        color:white;
	        font-size:100px;
	      }
	      .view-container {
	        position:relative;
	      }
	      .view-container > .view.ng-animate {
	        position:absolute;
	        top:0;
	        left:0;
	        width:100%;
	        min-height:500px;
	      }
	      .view.ng-enter, .view.ng-leave,
	      .record.ng-anchor {
	        transition:0.5s linear all;
	      }
	      .view.ng-enter {
	        transform:translateX(100%);
	      }
	      .view.ng-enter.ng-enter-active, .view.ng-leave {
	        transform:translateX(0%);
	      }
	      .view.ng-leave.ng-leave-active {
	        transform:translateX(-100%);
	      }
	      .record.ng-anchor-out {
	        background:red;
	      }
	    </file>
	  </example>
	 *
	 * ### How is the element transported?
	 *
	 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	 * will become visible since the shim class will be removed.
	 *
	 * ### How is the morphing handled?
	 *
	 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	 * what CSS classes differ between the starting element and the destination element. These different CSS classes
	 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	 * the cloned element is placed inside of root element which is likely close to the body element).
	 *
	 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	 *
	 *
	 * ## Using $animate in your directive code
	 *
	 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
	 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	 * imagine we have a greeting box that shows and hides itself when the data changes
	 *
	 * ```html
	 * <greeting-box active="onOrOff">Hi there</greeting-box>
	 * ```
	 *
	 * ```js
	 * ngModule.directive('greetingBox', ['$animate', function($animate) {
	 *   return function(scope, element, attrs) {
	 *     attrs.$observe('active', function(value) {
	 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	 *     });
	 *   });
	 * }]);
	 * ```
	 *
	 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	 * in our HTML code then we can trigger a CSS or JS animation to happen.
	 *
	 * ```css
	 * /&#42; normally we would create a CSS class to reference on the element &#42;/
	 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	 * ```
	 *
	 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	 * possible be sure to visit the {@link ng.$animate $animate service API page}.
	 *
	 *
	 * ## Callbacks and Promises
	 *
	 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	 * ended by chaining onto the returned promise that animation method returns.
	 *
	 * ```js
	 * // somewhere within the depths of the directive
	 * $animate.enter(element, parent).then(function() {
	 *   //the animation has completed
	 * });
	 * ```
	 *
	 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	 * anymore.)
	 *
	 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	 * routing controller to hook into that:
	 *
	 * ```js
	 * ngModule.controller('HomePageController', ['$animate', function($animate) {
	 *   $animate.on('enter', ngViewElement, function(element) {
	 *     // the animation for this route has completed
	 *   }]);
	 * }])
	 * ```
	 *
	 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
	 */
	
	var copy;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var isElement;
	var isFunction;
	var isObject;
	var isString;
	var isUndefined;
	var jqLite;
	var noop;
	
	/**
	 * @ngdoc service
	 * @name $animate
	 * @kind object
	 *
	 * @description
	 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	 *
	 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	 */
	angular.module('ngAnimate', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  noop        = angular.noop;
	  copy        = angular.copy;
	  extend      = angular.extend;
	  jqLite      = angular.element;
	  forEach     = angular.forEach;
	  isArray     = angular.isArray;
	  isString    = angular.isString;
	  isObject    = angular.isObject;
	  isUndefined = angular.isUndefined;
	  isDefined   = angular.isDefined;
	  isFunction  = angular.isFunction;
	  isElement   = angular.isElement;
	})
	  .directive('ngAnimateSwap', ngAnimateSwapDirective)
	
	  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
	  .factory('$$rAFScheduler', $$rAFSchedulerFactory)
	
	  .provider('$$animateQueue', $$AnimateQueueProvider)
	  .provider('$$animation', $$AnimationProvider)
	
	  .provider('$animateCss', $AnimateCssProvider)
	  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)
	
	  .provider('$$animateJs', $$AnimateJsProvider)
	  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	
	
	})(window, window.angular);


/***/ }),
/* 590 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngAria
	 * @description
	 *
	 * The `ngAria` module provides support for common
	 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
	 * attributes that convey state or semantic information about the application for users
	 * of assistive technologies, such as screen readers.
	 *
	 * <div doc-module-components="ngAria"></div>
	 *
	 * ## Usage
	 *
	 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
	 * directives are supported:
	 * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`,
	 * `ngDblClick`, and `ngMessages`.
	 *
	 * Below is a more detailed breakdown of the attributes handled by ngAria:
	 *
	 * | Directive                                   | Supported Attributes                                                                   |
	 * |---------------------------------------------|----------------------------------------------------------------------------------------|
	 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
	 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                          |
	 * | {@link ng.directive:ngRequired ngRequired}  | aria-required
	 * | {@link ng.directive:ngChecked ngChecked}    | aria-checked
	 * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                          |
	 * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                           |
	 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                            |
	 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                            |
	 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                               |
	 * | {@link module:ngMessages ngMessages}        | aria-live                                                                              |
	 * | {@link ng.directive:ngClick ngClick}        | tabindex, keypress event, button role                                                  |
	 *
	 * Find out more information about each directive by reading the
	 * {@link guide/accessibility ngAria Developer Guide}.
	 *
	 * ## Example
	 * Using ngDisabled with ngAria:
	 * ```html
	 * <md-checkbox ng-disabled="disabled">
	 * ```
	 * Becomes:
	 * ```html
	 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
	 * ```
	 *
	 * ## Disabling Attributes
	 * It's possible to disable individual attributes added by ngAria with the
	 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
	 * {@link guide/accessibility Developer Guide}.
	 */
	 /* global -ngAriaModule */
	var ngAriaModule = angular.module('ngAria', ['ng']).
	                        provider('$aria', $AriaProvider);
	
	/**
	* Internal Utilities
	*/
	var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];
	
	var isNodeOneOf = function(elem, nodeTypeArray) {
	  if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
	    return true;
	  }
	};
	/**
	 * @ngdoc provider
	 * @name $ariaProvider
	 *
	 * @description
	 *
	 * Used for configuring the ARIA attributes injected and managed by ngAria.
	 *
	 * ```js
	 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
	 *   $ariaProvider.config({
	 *     ariaValue: true,
	 *     tabindex: false
	 *   });
	 * });
	 *```
	 *
	 * ## Dependencies
	 * Requires the {@link ngAria} module to be installed.
	 *
	 */
	function $AriaProvider() {
	  var config = {
	    ariaHidden: true,
	    ariaChecked: true,
	    ariaReadonly: true,
	    ariaDisabled: true,
	    ariaRequired: true,
	    ariaInvalid: true,
	    ariaValue: true,
	    tabindex: true,
	    bindKeypress: true,
	    bindRoleForClick: true
	  };
	
	  /**
	   * @ngdoc method
	   * @name $ariaProvider#config
	   *
	   * @param {object} config object to enable/disable specific ARIA attributes
	   *
	   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
	   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
	   *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
	   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
	   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
	   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
	   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and aria-valuenow tags
	   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
	   *  - **bindKeypress** – `{boolean}` – Enables/disables keypress event binding on `div` and
	   *    `li` elements with ng-click
	   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements like `div`
	   *    using ng-click, making them more accessible to users of assistive technologies
	   *
	   * @description
	   * Enables/disables various ARIA attributes
	   */
	  this.config = function(newConfig) {
	    config = angular.extend(config, newConfig);
	  };
	
	  function watchExpr(attrName, ariaAttr, nodeBlackList, negate) {
	    return function(scope, elem, attr) {
	      var ariaCamelName = attr.$normalize(ariaAttr);
	      if (config[ariaCamelName] && !isNodeOneOf(elem, nodeBlackList) && !attr[ariaCamelName]) {
	        scope.$watch(attr[attrName], function(boolVal) {
	          // ensure boolean value
	          boolVal = negate ? !boolVal : !!boolVal;
	          elem.attr(ariaAttr, boolVal);
	        });
	      }
	    };
	  }
	  /**
	   * @ngdoc service
	   * @name $aria
	   *
	   * @description
	   * @priority 200
	   *
	   * The $aria service contains helper methods for applying common
	   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
	   *
	   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
	   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
	   * let's review a code snippet from ngAria itself:
	   *
	   *```js
	   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
	   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	   * }])
	   *```
	   * Shown above, the ngAria module creates a directive with the same signature as the
	   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
	   * solely managing accessibility attributes on custom elements. The internal `$aria` service is
	   * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
	   * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
	   * value in `ngDisabled`.
	   *
	   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
	   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
	   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
	   *
	   * The full list of directives that interface with ngAria:
	   * * **ngModel**
	   * * **ngChecked**
	   * * **ngReadonly**
	   * * **ngRequired**
	   * * **ngDisabled**
	   * * **ngValue**
	   * * **ngShow**
	   * * **ngHide**
	   * * **ngClick**
	   * * **ngDblclick**
	   * * **ngMessages**
	   *
	   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
	   * directive.
	   *
	   *
	   * ## Dependencies
	   * Requires the {@link ngAria} module to be installed.
	   */
	  this.$get = function() {
	    return {
	      config: function(key) {
	        return config[key];
	      },
	      $$watchExpr: watchExpr
	    };
	  };
	}
	
	
	ngAriaModule.directive('ngShow', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
	}])
	.directive('ngHide', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
	}])
	.directive('ngValue', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngValue', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngChecked', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngChecked', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngReadonly', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nodeBlackList, false);
	}])
	.directive('ngRequired', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngRequired', 'aria-required', nodeBlackList, false);
	}])
	.directive('ngModel', ['$aria', function($aria) {
	
	  function shouldAttachAttr(attr, normalizedAttr, elem, allowBlacklistEls) {
	    return $aria.config(normalizedAttr) && !elem.attr(attr) && (allowBlacklistEls || !isNodeOneOf(elem, nodeBlackList));
	  }
	
	  function shouldAttachRole(role, elem) {
	    // if element does not have role attribute
	    // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
	    // AND element is not INPUT
	    return !elem.attr('role') && (elem.attr('type') === role) && (elem[0].nodeName !== 'INPUT');
	  }
	
	  function getShape(attr, elem) {
	    var type = attr.type,
	        role = attr.role;
	
	    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
	           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
	           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' : '';
	  }
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
	    compile: function(elem, attr) {
	      var shape = getShape(attr, elem);
	
	      return {
	        pre: function(scope, elem, attr, ngModel) {
	          if (shape === 'checkbox') {
	            //Use the input[checkbox] $isEmpty implementation for elements with checkbox roles
	            ngModel.$isEmpty = function(value) {
	              return value === false;
	            };
	          }
	        },
	        post: function(scope, elem, attr, ngModel) {
	          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);
	
	          function ngAriaWatchModelValue() {
	            return ngModel.$modelValue;
	          }
	
	          function getRadioReaction(newVal) {
	            var boolVal = (attr.value == ngModel.$viewValue);
	            elem.attr('aria-checked', boolVal);
	          }
	
	          function getCheckboxReaction() {
	            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
	          }
	
	          switch (shape) {
	            case 'radio':
	            case 'checkbox':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', shape);
	              }
	              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
	                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
	                    getRadioReaction : getCheckboxReaction);
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	            case 'range':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', 'slider');
	              }
	              if ($aria.config('ariaValue')) {
	                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
	                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
	                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
	                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
	                var needsAriaValuenow = !elem.attr('aria-valuenow');
	
	                if (needsAriaValuemin) {
	                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemin', newVal);
	                  });
	                }
	                if (needsAriaValuemax) {
	                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemax', newVal);
	                  });
	                }
	                if (needsAriaValuenow) {
	                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
	                    elem.attr('aria-valuenow', newVal);
	                  });
	                }
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	          }
	
	          if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required
	            && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
	            // ngModel.$error.required is undefined on custom controls
	            attr.$observe('required', function() {
	              elem.attr('aria-required', !!attr['required']);
	            });
	          }
	
	          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
	            scope.$watch(function ngAriaInvalidWatch() {
	              return ngModel.$invalid;
	            }, function ngAriaInvalidReaction(newVal) {
	              elem.attr('aria-invalid', !!newVal);
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDisabled', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	}])
	.directive('ngMessages', function() {
	  return {
	    restrict: 'A',
	    require: '?ngMessages',
	    link: function(scope, elem, attr, ngMessages) {
	      if (!elem.attr('aria-live')) {
	        elem.attr('aria-live', 'assertive');
	      }
	    }
	  };
	})
	.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
	  return {
	    restrict: 'A',
	    compile: function(elem, attr) {
	      var fn = $parse(attr.ngClick, /* interceptorFn */ null, /* expensiveChecks */ true);
	      return function(scope, elem, attr) {
	
	        if (!isNodeOneOf(elem, nodeBlackList)) {
	
	          if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
	            elem.attr('role', 'button');
	          }
	
	          if ($aria.config('tabindex') && !elem.attr('tabindex')) {
	            elem.attr('tabindex', 0);
	          }
	
	          if ($aria.config('bindKeypress') && !attr.ngKeypress) {
	            elem.on('keypress', function(event) {
	              var keyCode = event.which || event.keyCode;
	              if (keyCode === 32 || keyCode === 13) {
	                scope.$apply(callback);
	              }
	
	              function callback() {
	                fn(scope, { $event: event });
	              }
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDblclick', ['$aria', function($aria) {
	  return function(scope, elem, attr) {
	    if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nodeBlackList)) {
	      elem.attr('tabindex', 0);
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 591 */
/***/ (function(module, exports) {

	/*! angular-breadcrumb - v0.4.1
	* http://ncuillery.github.io/angular-breadcrumb
	* Copyright (c) 2015 Nicolas Cuillery; Licensed MIT */
	
	(function (window, angular, undefined) {
	'use strict';
	
	function isAOlderThanB(scopeA, scopeB) {
	    if(angular.equals(scopeA.length, scopeB.length)) {
	        return scopeA > scopeB;
	    } else {
	        return scopeA.length > scopeB.length;
	    }
	}
	
	function parseStateRef(ref) {
	    var parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	    if (!parsed || parsed.length !== 4) { throw new Error("Invalid state ref '" + ref + "'"); }
	    return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function $Breadcrumb() {
	
	    var $$options = {
	        prefixStateName: null,
	        template: 'bootstrap3',
	        templateUrl: null,
	        includeAbstract : false
	    };
	
	    this.setOptions = function(options) {
	        angular.extend($$options, options);
	    };
	
	    this.$get = ['$state', '$stateParams', '$rootScope', function($state, $stateParams, $rootScope) {
	
	        var $lastViewScope = $rootScope;
	
	        // Early catch of $viewContentLoaded event
	        $rootScope.$on('$viewContentLoaded', function (event) {
	            // With nested views, the event occur several times, in "wrong" order
	            if(!event.targetScope.ncyBreadcrumbIgnore &&
	                isAOlderThanB(event.targetScope.$id, $lastViewScope.$id)) {
	                $lastViewScope = event.targetScope;
	            }
	        });
	
	        // Get the parent state
	        var $$parentState = function(state) {
	            // Check if state has explicit parent OR we try guess parent from its name
	            var parent = state.parent || (/^(.+)\.[^.]+$/.exec(state.name) || [])[1];
	            var isObjectParent = typeof parent === "object";
	            // if parent is a object reference, then extract the name
	            return isObjectParent ? parent.name : parent;
	        };
	
	        // Add the state in the chain if not already in and if not abstract
	        var $$addStateInChain = function(chain, stateRef) {
	            var conf,
	                parentParams,
	                ref = parseStateRef(stateRef),
	                force = false,
	                skip = false;
	
	            for(var i=0, l=chain.length; i<l; i+=1) {
	                if (chain[i].name === ref.state) {
	                    return;
	                }
	            }
	
	            conf = $state.get(ref.state);
	            // Get breadcrumb options
	            if(conf.ncyBreadcrumb) {
	                if(conf.ncyBreadcrumb.force){ force = true; }
	                if(conf.ncyBreadcrumb.skip){ skip = true; }
	            }
	            if((!conf.abstract || $$options.includeAbstract || force) && !skip) {
	                if(ref.paramExpr) {
	                    parentParams = $lastViewScope.$eval(ref.paramExpr);
	                }
	
	                conf.ncyBreadcrumbLink = $state.href(ref.state, parentParams || $stateParams || {});
	                chain.unshift(conf);
	            }
	        };
	
	        // Get the state for the parent step in the breadcrumb
	        var $$breadcrumbParentState = function(stateRef) {
	            var ref = parseStateRef(stateRef),
	                conf = $state.get(ref.state);
	
	            if(conf.ncyBreadcrumb && conf.ncyBreadcrumb.parent) {
	                // Handle the "parent" property of the breadcrumb, override the parent/child relation of the state
	                var isFunction = typeof conf.ncyBreadcrumb.parent === 'function';
	                var parentStateRef = isFunction ? conf.ncyBreadcrumb.parent($lastViewScope) : conf.ncyBreadcrumb.parent;
	                if(parentStateRef) {
	                    return parentStateRef;
	                }
	            }
	
	            return $$parentState(conf);
	        };
	
	        return {
	
	            getTemplate: function(templates) {
	                if($$options.templateUrl) {
	                    // templateUrl takes precedence over template
	                    return null;
	                } else if(templates[$$options.template]) {
	                    // Predefined templates (bootstrap, ...)
	                    return templates[$$options.template];
	                } else {
	                    return $$options.template;
	                }
	            },
	
	            getTemplateUrl: function() {
	                return $$options.templateUrl;
	            },
	
	            getStatesChain: function(exitOnFirst) { // Deliberately undocumented param, see getLastStep
	                var chain = [];
	
	                // From current state to the root
	                for(var stateRef = $state.$current.self.name; stateRef; stateRef=$$breadcrumbParentState(stateRef)) {
	                    $$addStateInChain(chain, stateRef);
	                    if(exitOnFirst && chain.length) {
	                        return chain;
	                    }
	                }
	
	                // Prefix state treatment
	                if($$options.prefixStateName) {
	                    $$addStateInChain(chain, $$options.prefixStateName);
	                }
	
	                return chain;
	            },
	
	            getLastStep: function() {
	                var chain = this.getStatesChain(true);
	                return chain.length ? chain[0] : undefined;
	            },
	
	            $getLastViewScope: function() {
	                return $lastViewScope;
	            }
	        };
	    }];
	}
	
	var getExpression = function(interpolationFunction) {
	    if(interpolationFunction.expressions) {
	        return interpolationFunction.expressions;
	    } else {
	        var expressions = [];
	        angular.forEach(interpolationFunction.parts, function(part) {
	            if(angular.isFunction(part)) {
	                expressions.push(part.exp);
	            }
	        });
	        return expressions;
	    }
	};
	
	var registerWatchers = function(labelWatcherArray, interpolationFunction, viewScope, step) {
	    angular.forEach(getExpression(interpolationFunction), function(expression) {
	        var watcher = viewScope.$watch(expression, function() {
	            step.ncyBreadcrumbLabel = interpolationFunction(viewScope);
	        });
	        labelWatcherArray.push(watcher);
	    });
	
	};
	
	var deregisterWatchers = function(labelWatcherArray) {
	    angular.forEach(labelWatcherArray, function(deregisterWatch) {
	        deregisterWatch();
	    });
	};
	
	function BreadcrumbDirective($interpolate, $breadcrumb, $rootScope) {
	    var $$templates = {
	        bootstrap2: '<ul class="breadcrumb">' +
	            '<li ng-repeat="step in steps" ng-switch="$last || !!step.abstract" ng-class="{active: $last}">' +
	            '<a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel}}</a>' +
	            '<span ng-switch-when="true">{{step.ncyBreadcrumbLabel}}</span>' +
	            '<span class="divider" ng-hide="$last">/</span>' +
	            '</li>' +
	            '</ul>',
	        bootstrap3: '<ol class="breadcrumb">' +
	            '<li ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract">' +
	            '<a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel}}</a>' +
	            '<span ng-switch-when="true">{{step.ncyBreadcrumbLabel}}</span>' +
	            '</li>' +
	            '</ol>'
	    };
	
	    return {
	        restrict: 'AE',
	        replace: true,
	        scope: {},
	        template: $breadcrumb.getTemplate($$templates),
	        templateUrl: $breadcrumb.getTemplateUrl(),
	        link: {
	            post: function postLink(scope) {
	                var labelWatchers = [];
	
	                var renderBreadcrumb = function() {
	                    deregisterWatchers(labelWatchers);
	                    labelWatchers = [];
	                    
	                    var viewScope = $breadcrumb.$getLastViewScope();
	                    scope.steps = $breadcrumb.getStatesChain();
	                    angular.forEach(scope.steps, function (step) {
	                        if (step.ncyBreadcrumb && step.ncyBreadcrumb.label) {
	                            var parseLabel = $interpolate(step.ncyBreadcrumb.label);
	                            step.ncyBreadcrumbLabel = parseLabel(viewScope);
	                            // Watcher for further viewScope updates
	                            registerWatchers(labelWatchers, parseLabel, viewScope, step);
	                        } else {
	                            step.ncyBreadcrumbLabel = step.name;
	                        }
	                    });
	                };
	
	                $rootScope.$on('$viewContentLoaded', function (event) {
	                    if(!event.targetScope.ncyBreadcrumbIgnore) {
	                        renderBreadcrumb();
	                    }
	                });
	
	                // View(s) may be already loaded while the directive's linking
	                renderBreadcrumb();
	            }
	        }
	    };
	}
	BreadcrumbDirective.$inject = ['$interpolate', '$breadcrumb', '$rootScope'];
	
	function BreadcrumbLastDirective($interpolate, $breadcrumb, $rootScope) {
	
	    return {
	        restrict: 'A',
	        scope: {},
	        template: '{{ncyBreadcrumbLabel}}',
	        compile: function(cElement, cAttrs) {
	
	            // Override the default template if ncyBreadcrumbLast has a value
	            var template = cElement.attr(cAttrs.$attr.ncyBreadcrumbLast);
	            if(template) {
	                cElement.html(template);
	            }
	
	            return {
	                post: function postLink(scope) {
	                    var labelWatchers = [];
	
	                    var renderLabel = function() {
	                        deregisterWatchers(labelWatchers);
	                        labelWatchers = [];
	                        
	                        var viewScope = $breadcrumb.$getLastViewScope();
	                        var lastStep = $breadcrumb.getLastStep();
	                        if(lastStep) {
	                            scope.ncyBreadcrumbLink = lastStep.ncyBreadcrumbLink;
	                            if (lastStep.ncyBreadcrumb && lastStep.ncyBreadcrumb.label) {
	                                var parseLabel = $interpolate(lastStep.ncyBreadcrumb.label);
	                                scope.ncyBreadcrumbLabel = parseLabel(viewScope);
	                                // Watcher for further viewScope updates
	                                // Tricky last arg: the last step is the entire scope of the directive !
	                                registerWatchers(labelWatchers, parseLabel, viewScope, scope);
	                            } else {
	                                scope.ncyBreadcrumbLabel = lastStep.name;
	                            }
	                        }
	                    };
	
	                    $rootScope.$on('$viewContentLoaded', function (event) {
	                        if(!event.targetScope.ncyBreadcrumbIgnore) {
	                            renderLabel();
	                        }
	                    });
	
	                    // View(s) may be already loaded while the directive's linking
	                    renderLabel();
	                }
	            };
	
	        }
	    };
	}
	BreadcrumbLastDirective.$inject = ['$interpolate', '$breadcrumb', '$rootScope'];
	
	function BreadcrumbTextDirective($interpolate, $breadcrumb, $rootScope) {
	
	    return {
	        restrict: 'A',
	        scope: {},
	        template: '{{ncyBreadcrumbChain}}',
	
	        compile: function(cElement, cAttrs) {
	            // Override the default template if ncyBreadcrumbText has a value
	            var template = cElement.attr(cAttrs.$attr.ncyBreadcrumbText);
	            if(template) {
	                cElement.html(template);
	            }
	            
	            var separator = cElement.attr(cAttrs.$attr.ncyBreadcrumbTextSeparator) || ' / ';
	
	            return {
	                post: function postLink(scope) {
	                    var labelWatchers = [];
	                    
	                    var registerWatchersText = function(labelWatcherArray, interpolationFunction, viewScope) {
	                        angular.forEach(getExpression(interpolationFunction), function(expression) {
	                            var watcher = viewScope.$watch(expression, function(newValue, oldValue) {
	                                if (newValue !== oldValue) {
	                                    renderLabel();
	                                }
	                            });
	                            labelWatcherArray.push(watcher);
	                        });
	                    };
	
	                    var renderLabel = function() {
	                        deregisterWatchers(labelWatchers);
	                        labelWatchers = [];
	                        
	                        var viewScope = $breadcrumb.$getLastViewScope();
	                        var steps = $breadcrumb.getStatesChain();
	                        var combinedLabels = [];
	                        angular.forEach(steps, function (step) {
	                            if (step.ncyBreadcrumb && step.ncyBreadcrumb.label) {
	                                var parseLabel = $interpolate(step.ncyBreadcrumb.label);
	                                combinedLabels.push(parseLabel(viewScope));
	                                // Watcher for further viewScope updates
	                                registerWatchersText(labelWatchers, parseLabel, viewScope);
	                            } else {
	                                combinedLabels.push(step.name);
	                            }
	                        });
	                        
	                        scope.ncyBreadcrumbChain = combinedLabels.join(separator);
	                    };
	
	                    $rootScope.$on('$viewContentLoaded', function (event) {
	                        if(!event.targetScope.ncyBreadcrumbIgnore) {
	                            renderLabel();
	                        }
	                    });
	
	                    // View(s) may be already loaded while the directive's linking
	                    renderLabel();
	                }
	            };
	
	        }
	    };
	}
	BreadcrumbTextDirective.$inject = ['$interpolate', '$breadcrumb', '$rootScope'];
	
	angular.module('ncy-angular-breadcrumb', ['ui.router.state'])
	    .provider('$breadcrumb', $Breadcrumb)
	    .directive('ncyBreadcrumb', BreadcrumbDirective)
	    .directive('ncyBreadcrumbLast', BreadcrumbLastDirective)
	    .directive('ncyBreadcrumbText', BreadcrumbTextDirective);
	})(window, window.angular);


/***/ }),
/* 592 */
/***/ (function(module, exports) {

	/**
	 * Angular Carousel - Mobile friendly touch carousel for AngularJS
	 * @version v1.0.2 - 2017-08-03
	 * @link http://revolunet.github.com/angular-carousel
	 * @author Julien Bouquillon <julien@revolunet.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	/*global angular */
	
	/*
	Angular touch carousel with CSS GPU accel and slide buffering
	http://github.com/revolunet/angular-carousel
	
	*/
	
	angular.module('angular-carousel', [
	    'ngTouch',
	    'angular-carousel.shifty'
	]);
	
	angular.module('angular-carousel')
	
	.directive('rnCarouselAutoSlide', ['$interval', function($interval) {
	  return {
	    restrict: 'A',
	    link: function (scope, element, attrs) {
	        var stopAutoPlay = function() {
	            if (scope.autoSlider) {
	                $interval.cancel(scope.autoSlider);
	                scope.autoSlider = null;
	            }
	        };
	        var restartTimer = function() {
	            scope.autoSlide();
	        };
	
	        scope.$watch('carouselIndex', restartTimer);
	
	        if (attrs.hasOwnProperty('rnCarouselPauseOnHover') && attrs.rnCarouselPauseOnHover !== 'false'){
	            element.on('mouseenter', stopAutoPlay);
	            element.on('mouseleave', restartTimer);
	        }
	
	        scope.$on('$destroy', function(){
	            stopAutoPlay();
	            element.off('mouseenter', stopAutoPlay);
	            element.off('mouseleave', restartTimer);
	        });
	    }
	  };
	}]);
	
	angular.module('angular-carousel')
	
	.directive('rnCarouselIndicators', ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    scope: {
	      slides: '=',
	      index: '=rnCarouselIndex'
	    },
	    templateUrl: 'carousel-indicators.html',
	    link: function(scope, iElement, iAttributes) {
	      var indexModel = $parse(iAttributes.rnCarouselIndex);
	      scope.goToSlide = function(index) {
	        indexModel.assign(scope.$parent.$parent, index);
	      };
	    }
	  };
	}]);
	
	angular.module('angular-carousel').run(['$templateCache', function($templateCache) {
	  $templateCache.put('carousel-indicators.html',
	      '<div class="rn-carousel-indicator">\n' +
	        '<span ng-repeat="slide in slides" ng-class="{active: $index==index}" ng-click="goToSlide($index)">●</span>' +
	      '</div>'
	  );
	}]);
	
	(function() {
	    "use strict";
	
	    angular.module('angular-carousel')
	
	    .service('DeviceCapabilities', function() {
	
	        // TODO: merge in a single function
	
	        // detect supported CSS property
	        function detectTransformProperty() {
	            var transformProperty = 'transform',
	                safariPropertyHack = 'webkitTransform';
	            if (typeof document.body.style[transformProperty] !== 'undefined') {
	
	                ['webkit', 'moz', 'o', 'ms'].every(function (prefix) {
	                    var e = '-' + prefix + '-transform';
	                    if (typeof document.body.style[e] !== 'undefined') {
	                        transformProperty = e;
	                        return false;
	                    }
	                    return true;
	                });
	            } else if (typeof document.body.style[safariPropertyHack] !== 'undefined') {
	                transformProperty = '-webkit-transform';
	            } else {
	                transformProperty = undefined;
	            }
	            return transformProperty;
	        }
	
	        //Detect support of translate3d
	        function detect3dSupport() {
	            var el = document.createElement('p'),
	                has3d,
	                transforms = {
	                    'webkitTransform': '-webkit-transform',
	                    'msTransform': '-ms-transform',
	                    'transform': 'transform'
	                };
	            // Add it to the body to get the computed style
	            document.body.insertBefore(el, null);
	            for (var t in transforms) {
	                if (el.style[t] !== undefined) {
	                    el.style[t] = 'translate3d(1px,1px,1px)';
	                    has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
	                }
	            }
	            document.body.removeChild(el);
	            return (has3d !== undefined && has3d.length > 0 && has3d !== "none");
	        }
	
	        return {
	            has3d: detect3dSupport(),
	            transformProperty: detectTransformProperty()
	        };
	
	    })
	
	    .service('computeCarouselSlideStyle', ["DeviceCapabilities", function(DeviceCapabilities) {
	        // compute transition transform properties for a given slide and global offset
	        return function(slideIndex, offset, transitionType) {
	            var style = {
	                    display: 'inline-block'
	                },
	                opacity,
	                absoluteLeft = (slideIndex * 100) + offset,
	                slideTransformValue = DeviceCapabilities.has3d ? 'translate3d(' + absoluteLeft + '%, 0, 0)' : 'translate3d(' + absoluteLeft + '%, 0)',
	                distance = ((100 - Math.abs(absoluteLeft)) / 100);
	
	            if (!DeviceCapabilities.transformProperty) {
	                // fallback to default slide if transformProperty is not available
	                style['margin-left'] = absoluteLeft + '%';
	            } else {
	                if (transitionType == 'fadeAndSlide') {
	                    style[DeviceCapabilities.transformProperty] = slideTransformValue;
	                    opacity = 0;
	                    if (Math.abs(absoluteLeft) < 100) {
	                        opacity = 0.3 + distance * 0.7;
	                    }
	                    style.opacity = opacity;
	                } else if (transitionType == 'hexagon') {
	                    var transformFrom = 100,
	                        degrees = 0,
	                        maxDegrees = 60 * (distance - 1);
	
	                    transformFrom = offset < (slideIndex * -100) ? 100 : 0;
	                    degrees = offset < (slideIndex * -100) ? maxDegrees : -maxDegrees;
	                    style[DeviceCapabilities.transformProperty] = slideTransformValue + ' ' + 'rotateY(' + degrees + 'deg)';
	                    style[DeviceCapabilities.transformProperty + '-origin'] = transformFrom + '% 50%';
	                } else if (transitionType == 'zoom') {
	                    style[DeviceCapabilities.transformProperty] = slideTransformValue;
	                    var scale = 1;
	                    if (Math.abs(absoluteLeft) < 100) {
	                        scale = 1 + ((1 - distance) * 2);
	                    }
	                    style[DeviceCapabilities.transformProperty] += ' scale(' + scale + ')';
	                    style[DeviceCapabilities.transformProperty + '-origin'] = '50% 50%';
	                    opacity = 0;
	                    if (Math.abs(absoluteLeft) < 100) {
	                        opacity = 0.3 + distance * 0.7;
	                    }
	                    style.opacity = opacity;
	                } else {
	                    style[DeviceCapabilities.transformProperty] = slideTransformValue;
	                }
	            }
	            return style;
	        };
	    }])
	
	    .service('createStyleString', function() {
	        return function(object) {
	            var styles = [];
	            angular.forEach(object, function(value, key) {
	                styles.push(key + ':' + value);
	            });
	            return styles.join(';');
	        };
	    })
	
	    .directive('rnCarousel', ['$swipe', '$window', '$document', '$parse', '$compile', '$timeout', '$interval', 'computeCarouselSlideStyle', 'createStyleString', 'Tweenable',
	        function($swipe, $window, $document, $parse, $compile, $timeout, $interval, computeCarouselSlideStyle, createStyleString, Tweenable) {
	            // internal ids to allow multiple instances
	            var carouselId = 0,
	                // in absolute pixels, at which distance the slide stick to the edge on release
	                rubberTreshold = 3;
	
	            var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame || $window.mozRequestAnimationFrame;
	
	            function getItemIndex(collection, target, defaultIndex) {
	                var result = defaultIndex;
	                collection.every(function(item, index) {
	                    if (angular.equals(item, target)) {
	                        result = index;
	                        return false;
	                    }
	                    return true;
	                });
	                return result;
	            }
	
	            return {
	                restrict: 'A',
	                scope: true,
	                compile: function(tElement, tAttributes) {
	                    // use the compile phase to customize the DOM
	                    var firstChild = tElement[0].querySelector('li'),
	                        firstChildAttributes = (firstChild) ? firstChild.attributes : [],
	                        isRepeatBased = false,
	                        isBuffered = false,
	                        repeatItem,
	                        repeatCollection;
	
	                    // try to find an ngRepeat expression
	                    // at this point, the attributes are not yet normalized so we need to try various syntax
	                    ['ng-repeat', 'data-ng-repeat', 'ng:repeat', 'x-ng-repeat'].every(function(attr) {
	                        var repeatAttribute = firstChildAttributes[attr];
	                        if (angular.isDefined(repeatAttribute)) {
	                            // ngRepeat regexp extracted from angular 1.2.7 src
	                            var exprMatch = repeatAttribute.value.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/),
	                                trackProperty = exprMatch[3];
	
	                            repeatItem = exprMatch[1];
	                            repeatCollection = exprMatch[2];
	
	                            if (repeatItem) {
	                                if (angular.isDefined(tAttributes['rnCarouselBuffered'])) {
	                                    // update the current ngRepeat expression and add a slice operator if buffered
	                                    isBuffered = true;
	                                    repeatAttribute.value = repeatItem + ' in ' + repeatCollection + '|carouselSlice:carouselBufferIndex:carouselBufferSize';
	                                    if (trackProperty) {
	                                        repeatAttribute.value += ' track by ' + trackProperty;
	                                    }
	                                }
	                                isRepeatBased = true;
	                                return false;
	                            }
	                        }
	                        return true;
	                    });
	
	                    return function(scope, iElement, iAttributes, containerCtrl) {
	
	                        carouselId++;
	
	                        var defaultOptions = {
	                            transitionType: iAttributes.rnCarouselTransition || 'slide',
	                            transitionEasing: iAttributes.rnCarouselEasing || 'easeTo',
	                            transitionDuration: parseInt(iAttributes.rnCarouselDuration, 10) || 300,
	                            isSequential: true,
	                            autoSlideDuration: 3,
	                            bufferSize: 5,
	                            /* in container % how much we need to drag to trigger the slide change */
	                            moveTreshold: 0.1,
	                            defaultIndex: 0
	                        };
	
	                        // TODO
	                        var options = angular.extend({}, defaultOptions);
	
	                        var pressed,
	                            startX,
	                            isIndexBound = false,
	                            offset = 0,
	                            destination,
	                            swipeMoved = false,
	                            //animOnIndexChange = true,
	                            currentSlides = [],
	                            elWidth = null,
	                            elX = null,
	                            animateTransitions = true,
	                            intialState = true,
	                            animating = false,
	                            mouseUpBound = false,
	                            locked = false;
	
	                        //rn-swipe-disabled =true will only disable swipe events
	                        if(iAttributes.rnSwipeDisabled !== "true") {
	                            $swipe.bind(iElement, {
	                                start: swipeStart,
	                                move: swipeMove,
	                                end: swipeEnd,
	                                cancel: function(event) {
	                                    swipeEnd({}, event);
	                                }
	                            });
	                        }
	
	                        function getSlidesDOM() {
	                            var nodes = iElement[0].childNodes;
	                            var slides = [];
	                            for(var i=0; i<nodes.length ;i++){
	                                if(nodes[i].tagName === "LI"){
	                                    slides.push(nodes[i]);
	                                }
	                            }
	                            return slides;
	                        }
	
	                        function documentMouseUpEvent(event) {
	                            // in case we click outside the carousel, trigger a fake swipeEnd
	                            swipeMoved = true;
	                            swipeEnd({
	                                x: event.clientX,
	                                y: event.clientY
	                            }, event);
	                        }
	
	                        function updateSlidesPosition(offset) {
	                            // manually apply transformation to carousel childrens
	                            // todo : optim : apply only to visible items
	                            var x = scope.carouselBufferIndex * 100 + offset;
	                            angular.forEach(getSlidesDOM(), function(child, index) {
	                                child.style.cssText = createStyleString(computeCarouselSlideStyle(index, x, options.transitionType));
	                            });
	                        }
	
	                        scope.nextSlide = function(slideOptions) {
	                            var index = scope.carouselIndex + 1;
	                            if (index > currentSlides.length - 1) {
	                                index = 0;
	                            }
	                            if (!locked) {
	                                goToSlide(index, slideOptions);
	                            }
	                        };
	
	                        scope.prevSlide = function(slideOptions) {
	                            var index = scope.carouselIndex - 1;
	                            if (index < 0) {
	                                index = currentSlides.length - 1;
	                            }
	                            goToSlide(index, slideOptions);
	                        };
	
	                        function goToSlide(index, slideOptions) {
	                            //console.log('goToSlide', arguments);
	                            // move a to the given slide index
	                            if (index === undefined) {
	                                index = scope.carouselIndex;
	                            }
	
	                            slideOptions = slideOptions || {};
	                            if (slideOptions.animate === false || options.transitionType === 'none') {
	                                locked = false;
	                                offset = index * -100;
	                                scope.carouselIndex = index;
	                                updateBufferIndex();
	                                return;
	                            }
	
	                            locked = true;
	                            var tweenable = new Tweenable();
	                            tweenable.tween({
	                                from: {
	                                    'x': offset
	                                },
	                                to: {
	                                    'x': index * -100
	                                },
	                                duration: options.transitionDuration,
	                                easing: options.transitionEasing,
	                                step: function(state) {
	                                    if (isFinite(state.x)) {
	                                      updateSlidesPosition(state.x);
	                                    }
	                                },
	                                finish: function() {
	                                    scope.$apply(function() {
	                                        scope.carouselIndex = index;
	                                        offset = index * -100;
	                                        updateBufferIndex();
	                                        $timeout(function () {
	                                          locked = false;
	                                        }, 0, false);
	                                    });
	                                }
	                            });
	                        }
	
	                        function getContainerWidth() {
	                            var rect = iElement[0].getBoundingClientRect();
	                            return rect.width ? rect.width : rect.right - rect.left;
	                        }
	
	                        function updateContainerWidth() {
	                            elWidth = getContainerWidth();
	                        }
	
	                        function bindMouseUpEvent() {
	                            if (!mouseUpBound) {
	                              mouseUpBound = true;
	                              $document.bind('mouseup', documentMouseUpEvent);
	                            }
	                        }
	
	                        function unbindMouseUpEvent() {
	                            if (mouseUpBound) {
	                              mouseUpBound = false;
	                              $document.unbind('mouseup', documentMouseUpEvent);
	                            }
	                        }
	
	                        function swipeStart(coords, event) {
	                            // console.log('swipeStart', coords, event);
	                            if (locked || currentSlides.length <= 1) {
	                                return;
	                            }
	                            updateContainerWidth();
	                            elX = iElement[0].querySelector('li').getBoundingClientRect().left;
	                            pressed = true;
	                            startX = coords.x;
	                            return false;
	                        }
	
	                        function swipeMove(coords, event) {
	                            //console.log('swipeMove', coords, event);
	                            var x, delta;
	                            bindMouseUpEvent();
	                            if (pressed) {
	                                x = coords.x;
	                                delta = startX - x;
	                                if (delta > 2 || delta < -2) {
	                                    swipeMoved = true;
	                                    var moveOffset = offset + (-delta * 100 / elWidth);
	                                    updateSlidesPosition(moveOffset);
	                                }
	                            }
	                            return false;
	                        }
	
	                        var init = true;
	                        scope.carouselIndex = 0;
	
	                        if (!isRepeatBased) {
	                            // fake array when no ng-repeat
	                            currentSlides = [];
	                            angular.forEach(getSlidesDOM(), function(node, index) {
	                                currentSlides.push({id: index});
	                            });
	                            if (iAttributes.rnCarouselHtmlSlides) {
	                                var updateParentSlides = function(value) {
	                                    slidesModel.assign(scope.$parent, value);
	                                };
	                                var slidesModel = $parse(iAttributes.rnCarouselHtmlSlides);
	                                if (angular.isFunction(slidesModel.assign)) {
	                                    /* check if this property is assignable then watch it */
	                                    scope.$watch('htmlSlides', function(newValue) {
	                                        updateParentSlides(newValue);
	                                    });
	                                    scope.$parent.$watch(slidesModel, function(newValue, oldValue) {
	                                        if (newValue !== undefined && newValue !== null) {
	                                            newValue = 0;
	                                            updateParentIndex(newValue);
	                                        }
	                                    });
	                                }
	                                scope.htmlSlides = currentSlides;
	                            }
	                        }
	
	                        if (iAttributes.rnCarouselControls!==undefined) {
	                            // dont use a directive for this
	                            var canloop = ((isRepeatBased ? scope.$eval(repeatCollection.replace('::', '')).length : currentSlides.length) > 1) ? angular.isDefined(tAttributes['rnCarouselControlsAllowLoop']) : false;
	                            var nextSlideIndexCompareValue = isRepeatBased ? '(' + repeatCollection.replace('::', '') + ').length - 1' : currentSlides.length - 1;
	                            var tpl = '<div class="rn-carousel-controls">\n' +
	                                '  <span class="rn-carousel-control rn-carousel-control-prev" ng-click="prevSlide()" ng-if="carouselIndex > 0 || ' + canloop + '"></span>\n' +
	                                '  <span class="rn-carousel-control rn-carousel-control-next" ng-click="nextSlide()" ng-if="carouselIndex < ' + nextSlideIndexCompareValue + ' || ' + canloop + '"></span>\n' +
	                                '</div>';
	                            iElement.parent().append($compile(angular.element(tpl))(scope));
	                        }
	
	                        if (iAttributes.rnCarouselAutoSlide!==undefined) {
	                            var duration = parseInt(iAttributes.rnCarouselAutoSlide, 10) || options.autoSlideDuration;
	                            scope.autoSlide = function() {
	                                if (scope.autoSlider) {
	                                    $interval.cancel(scope.autoSlider);
	                                    scope.autoSlider = null;
	                                }
	                                scope.autoSlider = $interval(function() {
	                                    if (!locked && !pressed) {
	                                        scope.nextSlide();
	                                    }
	                                }, duration * 1000);
	                            };
	                        }
	
	                        if (iAttributes.rnCarouselDefaultIndex) {
	                            var defaultIndexModel = $parse(iAttributes.rnCarouselDefaultIndex);
	                            options.defaultIndex = defaultIndexModel(scope.$parent) || 0;
	                        }
	
	                        if (iAttributes.rnCarouselIndex) {
	                            var updateParentIndex = function(value) {
	                                indexModel.assign(scope.$parent, value);
	                            };
	                            var indexModel = $parse(iAttributes.rnCarouselIndex);
	                            if (angular.isFunction(indexModel.assign)) {
	                                /* check if this property is assignable then watch it */
	                                scope.$watch('carouselIndex', function(newValue) {
	                                    updateParentIndex(newValue);
	                                });
	                                scope.$parent.$watch(indexModel, function(newValue, oldValue) {
	
	                                    if (newValue !== undefined && newValue !== null) {
	                                        if (currentSlides && currentSlides.length > 0 && newValue >= currentSlides.length) {
	                                            newValue = currentSlides.length - 1;
	                                            updateParentIndex(newValue);
	                                        } else if (currentSlides && newValue < 0) {
	                                            newValue = 0;
	                                            updateParentIndex(newValue);
	                                        }
	                                        if (!locked) {
	                                            goToSlide(newValue, {
	                                                animate: !init
	                                            });
	                                        }
	                                        init = false;
	                                    }
	                                });
	                                isIndexBound = true;
	
	                                if (options.defaultIndex) {
	                                    goToSlide(options.defaultIndex, {
	                                        animate: !init
	                                    });
	                                }
	                            } else if (!isNaN(iAttributes.rnCarouselIndex)) {
	                                /* if user just set an initial number, set it */
	                                goToSlide(parseInt(iAttributes.rnCarouselIndex, 10), {
	                                    animate: false
	                                });
	                            }
	                        } else {
	                            goToSlide(options.defaultIndex, {
	                                animate: !init
	                            });
	                            init = false;
	                        }
	
	                        if (iAttributes.rnCarouselLocked) {
	                            scope.$watch(iAttributes.rnCarouselLocked, function(newValue, oldValue) {
	                                // only bind swipe when it's not switched off
	                                if(newValue === true) {
	                                    locked = true;
	                                } else {
	                                    locked = false;
	                                }
	                            });
	                        }
	
	                        if (isRepeatBased) {
	                            // use rn-carousel-deep-watch to fight the Angular $watchCollection weakness : https://github.com/angular/angular.js/issues/2621
	                            // optional because it have some performance impacts (deep watch)
	                            var deepWatch = (iAttributes.rnCarouselDeepWatch!==undefined);
	
	                            scope[deepWatch?'$watch':'$watchCollection'](repeatCollection, function(newValue, oldValue) {
	                                //console.log('repeatCollection', currentSlides);
	                                currentSlides = newValue;
	                                // if deepWatch ON ,manually compare objects to guess the new position
	                                if (!angular.isArray(currentSlides)) {
	                                  throw Error('the slides collection must be an Array');
	                                }
	                                if (deepWatch && angular.isArray(newValue)) {
	                                    var activeElement = oldValue[scope.carouselIndex];
	                                    var newIndex = getItemIndex(newValue, activeElement, scope.carouselIndex);
	                                    goToSlide(newIndex, {animate: false});
	                                } else {
	                                    goToSlide(scope.carouselIndex, {animate: false});
	                                }
	                            }, true);
	                        }
	
	                        function swipeEnd(coords, event, forceAnimation) {
	                            //  console.log('swipeEnd', 'scope.carouselIndex', scope.carouselIndex);
	                            // Prevent clicks on buttons inside slider to trigger "swipeEnd" event on touchend/mouseup
	                            // console.log(iAttributes.rnCarouselOnInfiniteScroll);
	                            if (event && !swipeMoved) {
	                                return;
	                            }
	                            unbindMouseUpEvent();
	                            pressed = false;
	                            swipeMoved = false;
	                            destination = startX - coords.x;
	                            if (destination===0) {
	                                return;
	                            }
	                            if (locked) {
	                                return;
	                            }
	                            offset += (-destination * 100 / elWidth);
	                            if (options.isSequential) {
	                                var minMove = options.moveTreshold * elWidth,
	                                    absMove = -destination,
	                                    slidesMove = -Math[absMove >= 0 ? 'ceil' : 'floor'](absMove / elWidth),
	                                    shouldMove = Math.abs(absMove) > minMove;
	
	                                if (currentSlides && (slidesMove + scope.carouselIndex) >= currentSlides.length) {
	                                    slidesMove = currentSlides.length - 1 - scope.carouselIndex;
	                                }
	                                if ((slidesMove + scope.carouselIndex) < 0) {
	                                    slidesMove = -scope.carouselIndex;
	                                }
	                                var moveOffset = shouldMove ? slidesMove : 0;
	
	                                destination = (scope.carouselIndex + moveOffset);
	
	                                goToSlide(destination);
	                                if(iAttributes.rnCarouselOnInfiniteScrollRight!==undefined && slidesMove === 0 && scope.carouselIndex !== 0) {
	                                    $parse(iAttributes.rnCarouselOnInfiniteScrollRight)(scope)
	                                    goToSlide(0);
	                                }
	                                if(iAttributes.rnCarouselOnInfiniteScrollLeft!==undefined && slidesMove === 0 && scope.carouselIndex === 0 && moveOffset === 0) {
	                                    $parse(iAttributes.rnCarouselOnInfiniteScrollLeft)(scope)
	                                    goToSlide(currentSlides.length);
	                                }
	
	                            } else {
	                                scope.$apply(function() {
	                                    scope.carouselIndex = parseInt(-offset / 100, 10);
	                                    updateBufferIndex();
	                                });
	
	                            }
	
	                        }
	
	                        scope.$on('$destroy', function() {
	                            unbindMouseUpEvent();
	                        });
	
	                        scope.carouselBufferIndex = 0;
	                        scope.carouselBufferSize = options.bufferSize;
	
	                        function updateBufferIndex() {
	                            // update and cap te buffer index
	                            var bufferIndex = 0;
	                            var bufferEdgeSize = (scope.carouselBufferSize - 1) / 2;
	                            if (isBuffered) {
	                                if (scope.carouselIndex <= bufferEdgeSize) {
	                                    // first buffer part
	                                    bufferIndex = 0;
	                                } else if (currentSlides && currentSlides.length < scope.carouselBufferSize) {
	                                    // smaller than buffer
	                                    bufferIndex = 0;
	                                } else if (currentSlides && scope.carouselIndex > currentSlides.length - scope.carouselBufferSize) {
	                                    // last buffer part
	                                    bufferIndex = currentSlides.length - scope.carouselBufferSize;
	                                } else {
	                                    // compute buffer start
	                                    bufferIndex = scope.carouselIndex - bufferEdgeSize;
	                                }
	
	                                scope.carouselBufferIndex = bufferIndex;
	                                $timeout(function() {
	                                    updateSlidesPosition(offset);
	                                }, 0, false);
	                            } else {
	                                $timeout(function() {
	                                    updateSlidesPosition(offset);
	                                }, 0, false);
	                            }
	                        }
	
	                        function onOrientationChange() {
	                            updateContainerWidth();
	                            goToSlide();
	                        }
	
	                        // handle orientation change
	                        var winEl = angular.element($window);
	                        winEl.bind('orientationchange', onOrientationChange);
	                        winEl.bind('resize', onOrientationChange);
	
	                        scope.$on('$destroy', function() {
	                            unbindMouseUpEvent();
	                            winEl.unbind('orientationchange', onOrientationChange);
	                            winEl.unbind('resize', onOrientationChange);
	                        });
	                    };
	                }
	            };
	        }
	    ]);
	})();
	
	
	
	angular.module('angular-carousel.shifty', [])
	
	.factory('Tweenable', function() {
	
	    /*! shifty - v1.3.4 - 2014-10-29 - http://jeremyckahn.github.io/shifty */
	  ;(function (root) {
	
	  /*!
	   * Shifty Core
	   * By Jeremy Kahn - jeremyckahn@gmail.com
	   */
	
	  var Tweenable = (function () {
	
	    'use strict';
	
	    // Aliases that get defined later in this function
	    var formula;
	
	    // CONSTANTS
	    var DEFAULT_SCHEDULE_FUNCTION;
	    var DEFAULT_EASING = 'linear';
	    var DEFAULT_DURATION = 500;
	    var UPDATE_TIME = 1000 / 60;
	
	    var _now = Date.now
	         ? Date.now
	         : function () {return +new Date();};
	
	    var now = typeof SHIFTY_DEBUG_NOW !== 'undefined' ? SHIFTY_DEBUG_NOW : _now;
	
	    if (typeof window !== 'undefined') {
	      // requestAnimationFrame() shim by Paul Irish (modified for Shifty)
	      // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	      DEFAULT_SCHEDULE_FUNCTION = window.requestAnimationFrame
	         || window.webkitRequestAnimationFrame
	         || window.oRequestAnimationFrame
	         || window.msRequestAnimationFrame
	         || (window.mozCancelRequestAnimationFrame
	         && window.mozRequestAnimationFrame)
	         || setTimeout;
	    } else {
	      DEFAULT_SCHEDULE_FUNCTION = setTimeout;
	    }
	
	    function noop () {
	      // NOOP!
	    }
	
	    /*!
	     * Handy shortcut for doing a for-in loop. This is not a "normal" each
	     * function, it is optimized for Shifty.  The iterator function only receives
	     * the property name, not the value.
	     * @param {Object} obj
	     * @param {Function(string)} fn
	     */
	    function each (obj, fn) {
	      var key;
	      for (key in obj) {
	        if (Object.hasOwnProperty.call(obj, key)) {
	          fn(key);
	        }
	      }
	    }
	
	    /*!
	     * Perform a shallow copy of Object properties.
	     * @param {Object} targetObject The object to copy into
	     * @param {Object} srcObject The object to copy from
	     * @return {Object} A reference to the augmented `targetObj` Object
	     */
	    function shallowCopy (targetObj, srcObj) {
	      each(srcObj, function (prop) {
	        targetObj[prop] = srcObj[prop];
	      });
	
	      return targetObj;
	    }
	
	    /*!
	     * Copies each property from src onto target, but only if the property to
	     * copy to target is undefined.
	     * @param {Object} target Missing properties in this Object are filled in
	     * @param {Object} src
	     */
	    function defaults (target, src) {
	      each(src, function (prop) {
	        if (typeof target[prop] === 'undefined') {
	          target[prop] = src[prop];
	        }
	      });
	    }
	
	    /*!
	     * Calculates the interpolated tween values of an Object for a given
	     * timestamp.
	     * @param {Number} forPosition The position to compute the state for.
	     * @param {Object} currentState Current state properties.
	     * @param {Object} originalState: The original state properties the Object is
	     * tweening from.
	     * @param {Object} targetState: The destination state properties the Object
	     * is tweening to.
	     * @param {number} duration: The length of the tween in milliseconds.
	     * @param {number} timestamp: The UNIX epoch time at which the tween began.
	     * @param {Object} easing: This Object's keys must correspond to the keys in
	     * targetState.
	     */
	    function tweenProps (forPosition, currentState, originalState, targetState,
	      duration, timestamp, easing) {
	      var normalizedPosition = (forPosition - timestamp) / duration;
	
	      var prop;
	      for (prop in currentState) {
	        if (currentState.hasOwnProperty(prop)) {
	          currentState[prop] = tweenProp(originalState[prop],
	            targetState[prop], formula[easing[prop]], normalizedPosition);
	        }
	      }
	
	      return currentState;
	    }
	
	    /*!
	     * Tweens a single property.
	     * @param {number} start The value that the tween started from.
	     * @param {number} end The value that the tween should end at.
	     * @param {Function} easingFunc The easing curve to apply to the tween.
	     * @param {number} position The normalized position (between 0.0 and 1.0) to
	     * calculate the midpoint of 'start' and 'end' against.
	     * @return {number} The tweened value.
	     */
	    function tweenProp (start, end, easingFunc, position) {
	      return start + (end - start) * easingFunc(position);
	    }
	
	    /*!
	     * Applies a filter to Tweenable instance.
	     * @param {Tweenable} tweenable The `Tweenable` instance to call the filter
	     * upon.
	     * @param {String} filterName The name of the filter to apply.
	     */
	    function applyFilter (tweenable, filterName) {
	      var filters = Tweenable.prototype.filter;
	      var args = tweenable._filterArgs;
	
	      each(filters, function (name) {
	        if (typeof filters[name][filterName] !== 'undefined') {
	          filters[name][filterName].apply(tweenable, args);
	        }
	      });
	    }
	
	    var timeoutHandler_endTime;
	    var timeoutHandler_currentTime;
	    var timeoutHandler_isEnded;
	    var timeoutHandler_offset;
	    /*!
	     * Handles the update logic for one step of a tween.
	     * @param {Tweenable} tweenable
	     * @param {number} timestamp
	     * @param {number} duration
	     * @param {Object} currentState
	     * @param {Object} originalState
	     * @param {Object} targetState
	     * @param {Object} easing
	     * @param {Function(Object, *, number)} step
	     * @param {Function(Function,number)}} schedule
	     */
	    function timeoutHandler (tweenable, timestamp, duration, currentState,
	      originalState, targetState, easing, step, schedule) {
	      timeoutHandler_endTime = timestamp + duration;
	      timeoutHandler_currentTime = Math.min(now(), timeoutHandler_endTime);
	      timeoutHandler_isEnded =
	        timeoutHandler_currentTime >= timeoutHandler_endTime;
	
	      timeoutHandler_offset = duration - (
	          timeoutHandler_endTime - timeoutHandler_currentTime);
	
	      if (tweenable.isPlaying() && !timeoutHandler_isEnded) {
	        tweenable._scheduleId = schedule(tweenable._timeoutHandler, UPDATE_TIME);
	
	        applyFilter(tweenable, 'beforeTween');
	        tweenProps(timeoutHandler_currentTime, currentState, originalState,
	          targetState, duration, timestamp, easing);
	        applyFilter(tweenable, 'afterTween');
	
	        step(currentState, tweenable._attachment, timeoutHandler_offset);
	      } else if (timeoutHandler_isEnded) {
	        step(targetState, tweenable._attachment, timeoutHandler_offset);
	        tweenable.stop(true);
	      }
	    }
	
	
	    /*!
	     * Creates a usable easing Object from either a string or another easing
	     * Object.  If `easing` is an Object, then this function clones it and fills
	     * in the missing properties with "linear".
	     * @param {Object} fromTweenParams
	     * @param {Object|string} easing
	     */
	    function composeEasingObject (fromTweenParams, easing) {
	      var composedEasing = {};
	
	      if (typeof easing === 'string') {
	        each(fromTweenParams, function (prop) {
	          composedEasing[prop] = easing;
	        });
	      } else {
	        each(fromTweenParams, function (prop) {
	          if (!composedEasing[prop]) {
	            composedEasing[prop] = easing[prop] || DEFAULT_EASING;
	          }
	        });
	      }
	
	      return composedEasing;
	    }
	
	    /**
	     * Tweenable constructor.
	     * @param {Object=} opt_initialState The values that the initial tween should start at if a "from" object is not provided to Tweenable#tween.
	     * @param {Object=} opt_config See Tweenable.prototype.setConfig()
	     * @constructor
	     */
	    function Tweenable (opt_initialState, opt_config) {
	      this._currentState = opt_initialState || {};
	      this._configured = false;
	      this._scheduleFunction = DEFAULT_SCHEDULE_FUNCTION;
	
	      // To prevent unnecessary calls to setConfig do not set default configuration here.
	      // Only set default configuration immediately before tweening if none has been set.
	      if (typeof opt_config !== 'undefined') {
	        this.setConfig(opt_config);
	      }
	    }
	
	    /**
	     * Configure and start a tween.
	     * @param {Object=} opt_config See Tweenable.prototype.setConfig()
	     * @return {Tweenable}
	     */
	    Tweenable.prototype.tween = function (opt_config) {
	      if (this._isTweening) {
	        return this;
	      }
	
	      // Only set default config if no configuration has been set previously and none is provided now.
	      if (opt_config !== undefined || !this._configured) {
	        this.setConfig(opt_config);
	      }
	
	      this._timestamp = now();
	      this._start(this.get(), this._attachment);
	      return this.resume();
	    };
	
	    /**
	     * Sets the tween configuration. `config` may have the following options:
	     *
	     * - __from__ (_Object=_): Starting position.  If omitted, the current state is used.
	     * - __to__ (_Object=_): Ending position.
	     * - __duration__ (_number=_): How many milliseconds to animate for.
	     * - __start__ (_Function(Object)_): Function to execute when the tween begins.  Receives the state of the tween as the first parameter. Attachment is the second parameter.
	     * - __step__ (_Function(Object, *, number)_): Function to execute on every tick.  Receives the state of the tween as the first parameter. Attachment is the second parameter, and the time elapsed since the start of the tween is the third parameter. This function is not called on the final step of the animation, but `finish` is.
	     * - __finish__ (_Function(Object, *)_): Function to execute upon tween completion.  Receives the state of the tween as the first parameter. Attachment is the second parameter.
	     * - __easing__ (_Object|string=_): Easing curve name(s) to use for the tween.
	     * - __attachment__ (_Object|string|any=_): Value that is attached to this instance and passed on to the step/start/finish methods.
	     * @param {Object} config
	     * @return {Tweenable}
	     */
	    Tweenable.prototype.setConfig = function (config) {
	      config = config || {};
	      this._configured = true;
	
	      // Attach something to this Tweenable instance (e.g.: a DOM element, an object, a string, etc.);
	      this._attachment = config.attachment;
	
	      // Init the internal state
	      this._pausedAtTime = null;
	      this._scheduleId = null;
	      this._start = config.start || noop;
	      this._step = config.step || noop;
	      this._finish = config.finish || noop;
	      this._duration = config.duration || DEFAULT_DURATION;
	      this._currentState = config.from || this.get();
	      this._originalState = this.get();
	      this._targetState = config.to || this.get();
	
	      // Aliases used below
	      var currentState = this._currentState;
	      var targetState = this._targetState;
	
	      // Ensure that there is always something to tween to.
	      defaults(targetState, currentState);
	
	      this._easing = composeEasingObject(
	        currentState, config.easing || DEFAULT_EASING);
	
	      this._filterArgs =
	        [currentState, this._originalState, targetState, this._easing];
	
	      applyFilter(this, 'tweenCreated');
	      return this;
	    };
	
	    /**
	     * Gets the current state.
	     * @return {Object}
	     */
	    Tweenable.prototype.get = function () {
	      return shallowCopy({}, this._currentState);
	    };
	
	    /**
	     * Sets the current state.
	     * @param {Object} state
	     */
	    Tweenable.prototype.set = function (state) {
	      this._currentState = state;
	    };
	
	    /**
	     * Pauses a tween.  Paused tweens can be resumed from the point at which they were paused.  This is different than [`stop()`](#stop), as that method causes a tween to start over when it is resumed.
	     * @return {Tweenable}
	     */
	    Tweenable.prototype.pause = function () {
	      this._pausedAtTime = now();
	      this._isPaused = true;
	      return this;
	    };
	
	    /**
	     * Resumes a paused tween.
	     * @return {Tweenable}
	     */
	    Tweenable.prototype.resume = function () {
	      if (this._isPaused) {
	        this._timestamp += now() - this._pausedAtTime;
	      }
	
	      this._isPaused = false;
	      this._isTweening = true;
	
	      var self = this;
	      this._timeoutHandler = function () {
	        timeoutHandler(self, self._timestamp, self._duration, self._currentState,
	          self._originalState, self._targetState, self._easing, self._step,
	          self._scheduleFunction);
	      };
	
	      this._timeoutHandler();
	
	      return this;
	    };
	
	    /**
	     * Move the state of the animation to a specific point in the tween's timeline.
	     * If the animation is not running, this will cause the `step` handlers to be
	     * called.
	     * @param {millisecond} millisecond The millisecond of the animation to seek to.
	     * @return {Tweenable}
	     */
	    Tweenable.prototype.seek = function (millisecond) {
	      this._timestamp = now() - millisecond;
	
	      if (!this.isPlaying()) {
	        this._isTweening = true;
	        this._isPaused = false;
	
	        // If the animation is not running, call timeoutHandler to make sure that
	        // any step handlers are run.
	        timeoutHandler(this, this._timestamp, this._duration, this._currentState,
	          this._originalState, this._targetState, this._easing, this._step,
	          this._scheduleFunction);
	
	        this._timeoutHandler();
	        this.pause();
	      }
	
	      return this;
	    };
	
	    /**
	     * Stops and cancels a tween.
	     * @param {boolean=} gotoEnd If false or omitted, the tween just stops at its current state, and the "finish" handler is not invoked.  If true, the tweened object's values are instantly set to the target values, and "finish" is invoked.
	     * @return {Tweenable}
	     */
	    Tweenable.prototype.stop = function (gotoEnd) {
	      this._isTweening = false;
	      this._isPaused = false;
	      this._timeoutHandler = noop;
	
	      (root.cancelAnimationFrame            ||
	        root.webkitCancelAnimationFrame     ||
	        root.oCancelAnimationFrame          ||
	        root.msCancelAnimationFrame         ||
	        root.mozCancelRequestAnimationFrame ||
	        root.clearTimeout)(this._scheduleId);
	
	      if (gotoEnd) {
	        shallowCopy(this._currentState, this._targetState);
	        applyFilter(this, 'afterTweenEnd');
	        this._finish.call(this, this._currentState, this._attachment);
	      }
	
	      return this;
	    };
	
	    /**
	     * Returns whether or not a tween is running.
	     * @return {boolean}
	     */
	    Tweenable.prototype.isPlaying = function () {
	      return this._isTweening && !this._isPaused;
	    };
	
	    /**
	     * Sets a custom schedule function.
	     *
	     * If a custom function is not set the default one is used [`requestAnimationFrame`](https://developer.mozilla.org/en-US/docs/Web/API/window.requestAnimationFrame) if available, otherwise [`setTimeout`](https://developer.mozilla.org/en-US/docs/Web/API/Window.setTimeout)).
	     *
	     * @param {Function(Function,number)} scheduleFunction The function to be called to schedule the next frame to be rendered
	     */
	    Tweenable.prototype.setScheduleFunction = function (scheduleFunction) {
	      this._scheduleFunction = scheduleFunction;
	    };
	
	    /**
	     * `delete`s all "own" properties.  Call this when the `Tweenable` instance is no longer needed to free memory.
	     */
	    Tweenable.prototype.dispose = function () {
	      var prop;
	      for (prop in this) {
	        if (this.hasOwnProperty(prop)) {
	          delete this[prop];
	        }
	      }
	    };
	
	    /*!
	     * Filters are used for transforming the properties of a tween at various
	     * points in a Tweenable's life cycle.  See the README for more info on this.
	     */
	    Tweenable.prototype.filter = {};
	
	    /*!
	     * This object contains all of the tweens available to Shifty.  It is extendible - simply attach properties to the Tweenable.prototype.formula Object following the same format at linear.
	     *
	     * `pos` should be a normalized `number` (between 0 and 1).
	     */
	    Tweenable.prototype.formula = {
	      linear: function (pos) {
	        return pos;
	      }
	    };
	
	    formula = Tweenable.prototype.formula;
	
	    shallowCopy(Tweenable, {
	      'now': now
	      ,'each': each
	      ,'tweenProps': tweenProps
	      ,'tweenProp': tweenProp
	      ,'applyFilter': applyFilter
	      ,'shallowCopy': shallowCopy
	      ,'defaults': defaults
	      ,'composeEasingObject': composeEasingObject
	    });
	
	    root.Tweenable = Tweenable;
	    return Tweenable;
	
	  } ());
	
	  /*!
	   * All equations are adapted from Thomas Fuchs' [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/penner.js).
	   *
	   * Based on Easing Equations (c) 2003 [Robert Penner](http://www.robertpenner.com/), all rights reserved. This work is [subject to terms](http://www.robertpenner.com/easing_terms_of_use.html).
	   */
	
	  /*!
	   *  TERMS OF USE - EASING EQUATIONS
	   *  Open source under the BSD License.
	   *  Easing Equations (c) 2003 Robert Penner, all rights reserved.
	   */
	
	  ;(function () {
	
	    Tweenable.shallowCopy(Tweenable.prototype.formula, {
	      easeInQuad: function (pos) {
	        return Math.pow(pos, 2);
	      },
	
	      easeOutQuad: function (pos) {
	        return -(Math.pow((pos - 1), 2) - 1);
	      },
	
	      easeInOutQuad: function (pos) {
	        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,2);}
	        return -0.5 * ((pos -= 2) * pos - 2);
	      },
	
	      easeInCubic: function (pos) {
	        return Math.pow(pos, 3);
	      },
	
	      easeOutCubic: function (pos) {
	        return (Math.pow((pos - 1), 3) + 1);
	      },
	
	      easeInOutCubic: function (pos) {
	        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,3);}
	        return 0.5 * (Math.pow((pos - 2),3) + 2);
	      },
	
	      easeInQuart: function (pos) {
	        return Math.pow(pos, 4);
	      },
	
	      easeOutQuart: function (pos) {
	        return -(Math.pow((pos - 1), 4) - 1);
	      },
	
	      easeInOutQuart: function (pos) {
	        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,4);}
	        return -0.5 * ((pos -= 2) * Math.pow(pos,3) - 2);
	      },
	
	      easeInQuint: function (pos) {
	        return Math.pow(pos, 5);
	      },
	
	      easeOutQuint: function (pos) {
	        return (Math.pow((pos - 1), 5) + 1);
	      },
	
	      easeInOutQuint: function (pos) {
	        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,5);}
	        return 0.5 * (Math.pow((pos - 2),5) + 2);
	      },
	
	      easeInSine: function (pos) {
	        return -Math.cos(pos * (Math.PI / 2)) + 1;
	      },
	
	      easeOutSine: function (pos) {
	        return Math.sin(pos * (Math.PI / 2));
	      },
	
	      easeInOutSine: function (pos) {
	        return (-0.5 * (Math.cos(Math.PI * pos) - 1));
	      },
	
	      easeInExpo: function (pos) {
	        return (pos === 0) ? 0 : Math.pow(2, 10 * (pos - 1));
	      },
	
	      easeOutExpo: function (pos) {
	        return (pos === 1) ? 1 : -Math.pow(2, -10 * pos) + 1;
	      },
	
	      easeInOutExpo: function (pos) {
	        if (pos === 0) {return 0;}
	        if (pos === 1) {return 1;}
	        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(2,10 * (pos - 1));}
	        return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
	      },
	
	      easeInCirc: function (pos) {
	        return -(Math.sqrt(1 - (pos * pos)) - 1);
	      },
	
	      easeOutCirc: function (pos) {
	        return Math.sqrt(1 - Math.pow((pos - 1), 2));
	      },
	
	      easeInOutCirc: function (pos) {
	        if ((pos /= 0.5) < 1) {return -0.5 * (Math.sqrt(1 - pos * pos) - 1);}
	        return 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
	      },
	
	      easeOutBounce: function (pos) {
	        if ((pos) < (1 / 2.75)) {
	          return (7.5625 * pos * pos);
	        } else if (pos < (2 / 2.75)) {
	          return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
	        } else if (pos < (2.5 / 2.75)) {
	          return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
	        } else {
	          return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
	        }
	      },
	
	      easeInBack: function (pos) {
	        var s = 1.70158;
	        return (pos) * pos * ((s + 1) * pos - s);
	      },
	
	      easeOutBack: function (pos) {
	        var s = 1.70158;
	        return (pos = pos - 1) * pos * ((s + 1) * pos + s) + 1;
	      },
	
	      easeInOutBack: function (pos) {
	        var s = 1.70158;
	        if ((pos /= 0.5) < 1) {return 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s));}
	        return 0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
	      },
	
	      elastic: function (pos) {
	        return -1 * Math.pow(4,-8 * pos) * Math.sin((pos * 6 - 1) * (2 * Math.PI) / 2) + 1;
	      },
	
	      swingFromTo: function (pos) {
	        var s = 1.70158;
	        return ((pos /= 0.5) < 1) ? 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s)) :
	            0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
	      },
	
	      swingFrom: function (pos) {
	        var s = 1.70158;
	        return pos * pos * ((s + 1) * pos - s);
	      },
	
	      swingTo: function (pos) {
	        var s = 1.70158;
	        return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
	      },
	
	      bounce: function (pos) {
	        if (pos < (1 / 2.75)) {
	          return (7.5625 * pos * pos);
	        } else if (pos < (2 / 2.75)) {
	          return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
	        } else if (pos < (2.5 / 2.75)) {
	          return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
	        } else {
	          return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
	        }
	      },
	
	      bouncePast: function (pos) {
	        if (pos < (1 / 2.75)) {
	          return (7.5625 * pos * pos);
	        } else if (pos < (2 / 2.75)) {
	          return 2 - (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
	        } else if (pos < (2.5 / 2.75)) {
	          return 2 - (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
	        } else {
	          return 2 - (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
	        }
	      },
	
	      easeFromTo: function (pos) {
	        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,4);}
	        return -0.5 * ((pos -= 2) * Math.pow(pos,3) - 2);
	      },
	
	      easeFrom: function (pos) {
	        return Math.pow(pos,4);
	      },
	
	      easeTo: function (pos) {
	        return Math.pow(pos,0.25);
	      }
	    });
	
	  }());
	
	  /*!
	   * The Bezier magic in this file is adapted/copied almost wholesale from
	   * [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/cubic-bezier.js),
	   * which was adapted from Apple code (which probably came from
	   * [here](http://opensource.apple.com/source/WebCore/WebCore-955.66/platform/graphics/UnitBezier.h)).
	   * Special thanks to Apple and Thomas Fuchs for much of this code.
	   */
	
	  /*!
	   *  Copyright (c) 2006 Apple Computer, Inc. All rights reserved.
	   *
	   *  Redistribution and use in source and binary forms, with or without
	   *  modification, are permitted provided that the following conditions are met:
	   *
	   *  1. Redistributions of source code must retain the above copyright notice,
	   *  this list of conditions and the following disclaimer.
	   *
	   *  2. Redistributions in binary form must reproduce the above copyright notice,
	   *  this list of conditions and the following disclaimer in the documentation
	   *  and/or other materials provided with the distribution.
	   *
	   *  3. Neither the name of the copyright holder(s) nor the names of any
	   *  contributors may be used to endorse or promote products derived from
	   *  this software without specific prior written permission.
	   *
	   *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	   *  "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
	   *  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	   *  ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE
	   *  FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	   *  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	   *  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
	   *  ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	   *  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	   *  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	   */
	  ;(function () {
	    // port of webkit cubic bezier handling by http://www.netzgesta.de/dev/
	    function cubicBezierAtTime(t,p1x,p1y,p2x,p2y,duration) {
	      var ax = 0,bx = 0,cx = 0,ay = 0,by = 0,cy = 0;
	      function sampleCurveX(t) {return ((ax * t + bx) * t + cx) * t;}
	      function sampleCurveY(t) {return ((ay * t + by) * t + cy) * t;}
	      function sampleCurveDerivativeX(t) {return (3.0 * ax * t + 2.0 * bx) * t + cx;}
	      function solveEpsilon(duration) {return 1.0 / (200.0 * duration);}
	      function solve(x,epsilon) {return sampleCurveY(solveCurveX(x,epsilon));}
	      function fabs(n) {if (n >= 0) {return n;}else {return 0 - n;}}
	      function solveCurveX(x,epsilon) {
	        var t0,t1,t2,x2,d2,i;
	        for (t2 = x, i = 0; i < 8; i++) {x2 = sampleCurveX(t2) - x; if (fabs(x2) < epsilon) {return t2;} d2 = sampleCurveDerivativeX(t2); if (fabs(d2) < 1e-6) {break;} t2 = t2 - x2 / d2;}
	        t0 = 0.0; t1 = 1.0; t2 = x; if (t2 < t0) {return t0;} if (t2 > t1) {return t1;}
	        while (t0 < t1) {x2 = sampleCurveX(t2); if (fabs(x2 - x) < epsilon) {return t2;} if (x > x2) {t0 = t2;}else {t1 = t2;} t2 = (t1 - t0) * 0.5 + t0;}
	        return t2; // Failure.
	      }
	      cx = 3.0 * p1x; bx = 3.0 * (p2x - p1x) - cx; ax = 1.0 - cx - bx; cy = 3.0 * p1y; by = 3.0 * (p2y - p1y) - cy; ay = 1.0 - cy - by;
	      return solve(t, solveEpsilon(duration));
	    }
	    /*!
	     *  getCubicBezierTransition(x1, y1, x2, y2) -> Function
	     *
	     *  Generates a transition easing function that is compatible
	     *  with WebKit's CSS transitions `-webkit-transition-timing-function`
	     *  CSS property.
	     *
	     *  The W3C has more information about
	     *  <a href="http://www.w3.org/TR/css3-transitions/#transition-timing-function_tag">
	     *  CSS3 transition timing functions</a>.
	     *
	     *  @param {number} x1
	     *  @param {number} y1
	     *  @param {number} x2
	     *  @param {number} y2
	     *  @return {function}
	     */
	    function getCubicBezierTransition (x1, y1, x2, y2) {
	      return function (pos) {
	        return cubicBezierAtTime(pos,x1,y1,x2,y2,1);
	      };
	    }
	    // End ported code
	
	    /**
	     * Creates a Bezier easing function and attaches it to `Tweenable.prototype.formula`.  This function gives you total control over the easing curve.  Matthew Lein's [Ceaser](http://matthewlein.com/ceaser/) is a useful tool for visualizing the curves you can make with this function.
	     *
	     * @param {string} name The name of the easing curve.  Overwrites the old easing function on Tweenable.prototype.formula if it exists.
	     * @param {number} x1
	     * @param {number} y1
	     * @param {number} x2
	     * @param {number} y2
	     * @return {function} The easing function that was attached to Tweenable.prototype.formula.
	     */
	    Tweenable.setBezierFunction = function (name, x1, y1, x2, y2) {
	      var cubicBezierTransition = getCubicBezierTransition(x1, y1, x2, y2);
	      cubicBezierTransition.x1 = x1;
	      cubicBezierTransition.y1 = y1;
	      cubicBezierTransition.x2 = x2;
	      cubicBezierTransition.y2 = y2;
	
	      return Tweenable.prototype.formula[name] = cubicBezierTransition;
	    };
	
	
	    /**
	     * `delete`s an easing function from `Tweenable.prototype.formula`.  Be careful with this method, as it `delete`s whatever easing formula matches `name` (which means you can delete default Shifty easing functions).
	     *
	     * @param {string} name The name of the easing function to delete.
	     * @return {function}
	     */
	    Tweenable.unsetBezierFunction = function (name) {
	      delete Tweenable.prototype.formula[name];
	    };
	
	  })();
	
	  ;(function () {
	
	    function getInterpolatedValues (
	      from, current, targetState, position, easing) {
	      return Tweenable.tweenProps(
	        position, current, from, targetState, 1, 0, easing);
	    }
	
	    // Fake a Tweenable and patch some internals.  This approach allows us to
	    // skip uneccessary processing and object recreation, cutting down on garbage
	    // collection pauses.
	    var mockTweenable = new Tweenable();
	    mockTweenable._filterArgs = [];
	
	    /**
	     * Compute the midpoint of two Objects.  This method effectively calculates a specific frame of animation that [Tweenable#tween](shifty.core.js.html#tween) does many times over the course of a tween.
	     *
	     * Example:
	     *
	     *     var interpolatedValues = Tweenable.interpolate({
	     *       width: '100px',
	     *       opacity: 0,
	     *       color: '#fff'
	     *     }, {
	     *       width: '200px',
	     *       opacity: 1,
	     *       color: '#000'
	     *     }, 0.5);
	     *
	     *     console.log(interpolatedValues);
	     *     // {opacity: 0.5, width: "150px", color: "rgb(127,127,127)"}
	     *
	     * @param {Object} from The starting values to tween from.
	     * @param {Object} targetState The ending values to tween to.
	     * @param {number} position The normalized position value (between 0.0 and 1.0) to interpolate the values between `from` and `to` for.  `from` represents 0 and `to` represents `1`.
	     * @param {string|Object} easing The easing curve(s) to calculate the midpoint against.  You can reference any easing function attached to `Tweenable.prototype.formula`.  If omitted, this defaults to "linear".
	     * @return {Object}
	     */
	    Tweenable.interpolate = function (from, targetState, position, easing) {
	      var current = Tweenable.shallowCopy({}, from);
	      var easingObject = Tweenable.composeEasingObject(
	        from, easing || 'linear');
	
	      mockTweenable.set({});
	
	      // Alias and reuse the _filterArgs array instead of recreating it.
	      var filterArgs = mockTweenable._filterArgs;
	      filterArgs.length = 0;
	      filterArgs[0] = current;
	      filterArgs[1] = from;
	      filterArgs[2] = targetState;
	      filterArgs[3] = easingObject;
	
	      // Any defined value transformation must be applied
	      Tweenable.applyFilter(mockTweenable, 'tweenCreated');
	      Tweenable.applyFilter(mockTweenable, 'beforeTween');
	
	      var interpolatedValues = getInterpolatedValues(
	        from, current, targetState, position, easingObject);
	
	      // Transform values back into their original format
	      Tweenable.applyFilter(mockTweenable, 'afterTween');
	
	      return interpolatedValues;
	    };
	
	  }());
	
	  /**
	   * Adds string interpolation support to Shifty.
	   *
	   * The Token extension allows Shifty to tween numbers inside of strings.  Among
	   * other things, this allows you to animate CSS properties.  For example, you
	   * can do this:
	   *
	   *     var tweenable = new Tweenable();
	   *     tweenable.tween({
	   *       from: { transform: 'translateX(45px)'},
	   *       to: { transform: 'translateX(90xp)'}
	   *     });
	   *
	   * ` `
	   * `translateX(45)` will be tweened to `translateX(90)`.  To demonstrate:
	   *
	   *     var tweenable = new Tweenable();
	   *     tweenable.tween({
	   *       from: { transform: 'translateX(45px)'},
	   *       to: { transform: 'translateX(90px)'},
	   *       step: function (state) {
	   *         console.log(state.transform);
	   *       }
	   *     });
	   *
	   * ` `
	   * The above snippet will log something like this in the console:
	   *
	   *     translateX(60.3px)
	   *     ...
	   *     translateX(76.05px)
	   *     ...
	   *     translateX(90px)
	   *
	   * ` `
	   * Another use for this is animating colors:
	   *
	   *     var tweenable = new Tweenable();
	   *     tweenable.tween({
	   *       from: { color: 'rgb(0,255,0)'},
	   *       to: { color: 'rgb(255,0,255)'},
	   *       step: function (state) {
	   *         console.log(state.color);
	   *       }
	   *     });
	   *
	   * ` `
	   * The above snippet will log something like this:
	   *
	   *     rgb(84,170,84)
	   *     ...
	   *     rgb(170,84,170)
	   *     ...
	   *     rgb(255,0,255)
	   *
	   * ` `
	   * This extension also supports hexadecimal colors, in both long (`#ff00ff`)
	   * and short (`#f0f`) forms.  Be aware that hexadecimal input values will be
	   * converted into the equivalent RGB output values.  This is done to optimize
	   * for performance.
	   *
	   *     var tweenable = new Tweenable();
	   *     tweenable.tween({
	   *       from: { color: '#0f0'},
	   *       to: { color: '#f0f'},
	   *       step: function (state) {
	   *         console.log(state.color);
	   *       }
	   *     });
	   *
	   * ` `
	   * This snippet will generate the same output as the one before it because
	   * equivalent values were supplied (just in hexadecimal form rather than RGB):
	   *
	   *     rgb(84,170,84)
	   *     ...
	   *     rgb(170,84,170)
	   *     ...
	   *     rgb(255,0,255)
	   *
	   * ` `
	   * ` `
	   * ## Easing support
	   *
	   * Easing works somewhat differently in the Token extension.  This is because
	   * some CSS properties have multiple values in them, and you might need to
	   * tween each value along its own easing curve.  A basic example:
	   *
	   *     var tweenable = new Tweenable();
	   *     tweenable.tween({
	   *       from: { transform: 'translateX(0px) translateY(0px)'},
	   *       to: { transform:   'translateX(100px) translateY(100px)'},
	   *       easing: { transform: 'easeInQuad' },
	   *       step: function (state) {
	   *         console.log(state.transform);
	   *       }
	   *     });
	   *
	   * ` `
	   * The above snippet create values like this:
	   *
	   *     translateX(11.560000000000002px) translateY(11.560000000000002px)
	   *     ...
	   *     translateX(46.24000000000001px) translateY(46.24000000000001px)
	   *     ...
	   *     translateX(100px) translateY(100px)
	   *
	   * ` `
	   * In this case, the values for `translateX` and `translateY` are always the
	   * same for each step of the tween, because they have the same start and end
	   * points and both use the same easing curve.  We can also tween `translateX`
	   * and `translateY` along independent curves:
	   *
	   *     var tweenable = new Tweenable();
	   *     tweenable.tween({
	   *       from: { transform: 'translateX(0px) translateY(0px)'},
	   *       to: { transform:   'translateX(100px) translateY(100px)'},
	   *       easing: { transform: 'easeInQuad bounce' },
	   *       step: function (state) {
	   *         console.log(state.transform);
	   *       }
	   *     });
	   *
	   * ` `
	   * The above snippet create values like this:
	   *
	   *     translateX(10.89px) translateY(82.355625px)
	   *     ...
	   *     translateX(44.89000000000001px) translateY(86.73062500000002px)
	   *     ...
	   *     translateX(100px) translateY(100px)
	   *
	   * ` `
	   * `translateX` and `translateY` are not in sync anymore, because `easeInQuad`
	   * was specified for `translateX` and `bounce` for `translateY`.  Mixing and
	   * matching easing curves can make for some interesting motion in your
	   * animations.
	   *
	   * The order of the space-separated easing curves correspond the token values
	   * they apply to.  If there are more token values than easing curves listed,
	   * the last easing curve listed is used.
	   */
	  function token () {
	    // Functionality for this extension runs implicitly if it is loaded.
	  } /*!*/
	
	  // token function is defined above only so that dox-foundation sees it as
	  // documentation and renders it.  It is never used, and is optimized away at
	  // build time.
	
	  ;(function (Tweenable) {
	
	    /*!
	     * @typedef {{
	     *   formatString: string
	     *   chunkNames: Array.<string>
	     * }}
	     */
	    var formatManifest;
	
	    // CONSTANTS
	
	    var R_NUMBER_COMPONENT = /(\d|\-|\.)/;
	    var R_FORMAT_CHUNKS = /([^\-0-9\.]+)/g;
	    var R_UNFORMATTED_VALUES = /[0-9.\-]+/g;
	    var R_RGB = new RegExp(
	      'rgb\\(' + R_UNFORMATTED_VALUES.source +
	      (/,\s*/.source) + R_UNFORMATTED_VALUES.source +
	      (/,\s*/.source) + R_UNFORMATTED_VALUES.source + '\\)', 'g');
	    var R_RGB_PREFIX = /^.*\(/;
	    var R_HEX = /#([0-9]|[a-f]){3,6}/gi;
	    var VALUE_PLACEHOLDER = 'VAL';
	
	    // HELPERS
	
	    var getFormatChunksFrom_accumulator = [];
	    /*!
	     * @param {Array.number} rawValues
	     * @param {string} prefix
	     *
	     * @return {Array.<string>}
	     */
	    function getFormatChunksFrom (rawValues, prefix) {
	      getFormatChunksFrom_accumulator.length = 0;
	
	      var rawValuesLength = rawValues.length;
	      var i;
	
	      for (i = 0; i < rawValuesLength; i++) {
	        getFormatChunksFrom_accumulator.push('_' + prefix + '_' + i);
	      }
	
	      return getFormatChunksFrom_accumulator;
	    }
	
	    /*!
	     * @param {string} formattedString
	     *
	     * @return {string}
	     */
	    function getFormatStringFrom (formattedString) {
	      var chunks = formattedString.match(R_FORMAT_CHUNKS);
	
	      if (!chunks) {
	        // chunks will be null if there were no tokens to parse in
	        // formattedString (for example, if formattedString is '2').  Coerce
	        // chunks to be useful here.
	        chunks = ['', ''];
	
	        // If there is only one chunk, assume that the string is a number
	        // followed by a token...
	        // NOTE: This may be an unwise assumption.
	      } else if (chunks.length === 1 ||
	          // ...or if the string starts with a number component (".", "-", or a
	          // digit)...
	          formattedString[0].match(R_NUMBER_COMPONENT)) {
	        // ...prepend an empty string here to make sure that the formatted number
	        // is properly replaced by VALUE_PLACEHOLDER
	        chunks.unshift('');
	      }
	
	      return chunks.join(VALUE_PLACEHOLDER);
	    }
	
	    /*!
	     * Convert all hex color values within a string to an rgb string.
	     *
	     * @param {Object} stateObject
	     *
	     * @return {Object} The modified obj
	     */
	    function sanitizeObjectForHexProps (stateObject) {
	      Tweenable.each(stateObject, function (prop) {
	        var currentProp = stateObject[prop];
	
	        if (typeof currentProp === 'string' && currentProp.match(R_HEX)) {
	          stateObject[prop] = sanitizeHexChunksToRGB(currentProp);
	        }
	      });
	    }
	
	    /*!
	     * @param {string} str
	     *
	     * @return {string}
	     */
	    function  sanitizeHexChunksToRGB (str) {
	      return filterStringChunks(R_HEX, str, convertHexToRGB);
	    }
	
	    /*!
	     * @param {string} hexString
	     *
	     * @return {string}
	     */
	    function convertHexToRGB (hexString) {
	      var rgbArr = hexToRGBArray(hexString);
	      return 'rgb(' + rgbArr[0] + ',' + rgbArr[1] + ',' + rgbArr[2] + ')';
	    }
	
	    var hexToRGBArray_returnArray = [];
	    /*!
	     * Convert a hexadecimal string to an array with three items, one each for
	     * the red, blue, and green decimal values.
	     *
	     * @param {string} hex A hexadecimal string.
	     *
	     * @returns {Array.<number>} The converted Array of RGB values if `hex` is a
	     * valid string, or an Array of three 0's.
	     */
	    function hexToRGBArray (hex) {
	
	      hex = hex.replace(/#/, '');
	
	      // If the string is a shorthand three digit hex notation, normalize it to
	      // the standard six digit notation
	      if (hex.length === 3) {
	        hex = hex.split('');
	        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	      }
	
	      hexToRGBArray_returnArray[0] = hexToDec(hex.substr(0, 2));
	      hexToRGBArray_returnArray[1] = hexToDec(hex.substr(2, 2));
	      hexToRGBArray_returnArray[2] = hexToDec(hex.substr(4, 2));
	
	      return hexToRGBArray_returnArray;
	    }
	
	    /*!
	     * Convert a base-16 number to base-10.
	     *
	     * @param {Number|String} hex The value to convert
	     *
	     * @returns {Number} The base-10 equivalent of `hex`.
	     */
	    function hexToDec (hex) {
	      return parseInt(hex, 16);
	    }
	
	    /*!
	     * Runs a filter operation on all chunks of a string that match a RegExp
	     *
	     * @param {RegExp} pattern
	     * @param {string} unfilteredString
	     * @param {function(string)} filter
	     *
	     * @return {string}
	     */
	    function filterStringChunks (pattern, unfilteredString, filter) {
	      var pattenMatches = unfilteredString.match(pattern);
	      var filteredString = unfilteredString.replace(pattern, VALUE_PLACEHOLDER);
	
	      if (pattenMatches) {
	        var pattenMatchesLength = pattenMatches.length;
	        var currentChunk;
	
	        for (var i = 0; i < pattenMatchesLength; i++) {
	          currentChunk = pattenMatches.shift();
	          filteredString = filteredString.replace(
	            VALUE_PLACEHOLDER, filter(currentChunk));
	        }
	      }
	
	      return filteredString;
	    }
	
	    /*!
	     * Check for floating point values within rgb strings and rounds them.
	     *
	     * @param {string} formattedString
	     *
	     * @return {string}
	     */
	    function sanitizeRGBChunks (formattedString) {
	      return filterStringChunks(R_RGB, formattedString, sanitizeRGBChunk);
	    }
	
	    /*!
	     * @param {string} rgbChunk
	     *
	     * @return {string}
	     */
	    function sanitizeRGBChunk (rgbChunk) {
	      var numbers = rgbChunk.match(R_UNFORMATTED_VALUES);
	      var numbersLength = numbers.length;
	      var sanitizedString = rgbChunk.match(R_RGB_PREFIX)[0];
	
	      for (var i = 0; i < numbersLength; i++) {
	        sanitizedString += parseInt(numbers[i], 10) + ',';
	      }
	
	      sanitizedString = sanitizedString.slice(0, -1) + ')';
	
	      return sanitizedString;
	    }
	
	    /*!
	     * @param {Object} stateObject
	     *
	     * @return {Object} An Object of formatManifests that correspond to
	     * the string properties of stateObject
	     */
	    function getFormatManifests (stateObject) {
	      var manifestAccumulator = {};
	
	      Tweenable.each(stateObject, function (prop) {
	        var currentProp = stateObject[prop];
	
	        if (typeof currentProp === 'string') {
	          var rawValues = getValuesFrom(currentProp);
	
	          manifestAccumulator[prop] = {
	            'formatString': getFormatStringFrom(currentProp)
	            ,'chunkNames': getFormatChunksFrom(rawValues, prop)
	          };
	        }
	      });
	
	      return manifestAccumulator;
	    }
	
	    /*!
	     * @param {Object} stateObject
	     * @param {Object} formatManifests
	     */
	    function expandFormattedProperties (stateObject, formatManifests) {
	      Tweenable.each(formatManifests, function (prop) {
	        var currentProp = stateObject[prop];
	        var rawValues = getValuesFrom(currentProp);
	        var rawValuesLength = rawValues.length;
	
	        for (var i = 0; i < rawValuesLength; i++) {
	          stateObject[formatManifests[prop].chunkNames[i]] = +rawValues[i];
	        }
	
	        delete stateObject[prop];
	      });
	    }
	
	    /*!
	     * @param {Object} stateObject
	     * @param {Object} formatManifests
	     */
	    function collapseFormattedProperties (stateObject, formatManifests) {
	      Tweenable.each(formatManifests, function (prop) {
	        var currentProp = stateObject[prop];
	        var formatChunks = extractPropertyChunks(
	          stateObject, formatManifests[prop].chunkNames);
	        var valuesList = getValuesList(
	          formatChunks, formatManifests[prop].chunkNames);
	        currentProp = getFormattedValues(
	          formatManifests[prop].formatString, valuesList);
	        stateObject[prop] = sanitizeRGBChunks(currentProp);
	      });
	    }
	
	    /*!
	     * @param {Object} stateObject
	     * @param {Array.<string>} chunkNames
	     *
	     * @return {Object} The extracted value chunks.
	     */
	    function extractPropertyChunks (stateObject, chunkNames) {
	      var extractedValues = {};
	      var currentChunkName, chunkNamesLength = chunkNames.length;
	
	      for (var i = 0; i < chunkNamesLength; i++) {
	        currentChunkName = chunkNames[i];
	        extractedValues[currentChunkName] = stateObject[currentChunkName];
	        delete stateObject[currentChunkName];
	      }
	
	      return extractedValues;
	    }
	
	    var getValuesList_accumulator = [];
	    /*!
	     * @param {Object} stateObject
	     * @param {Array.<string>} chunkNames
	     *
	     * @return {Array.<number>}
	     */
	    function getValuesList (stateObject, chunkNames) {
	      getValuesList_accumulator.length = 0;
	      var chunkNamesLength = chunkNames.length;
	
	      for (var i = 0; i < chunkNamesLength; i++) {
	        getValuesList_accumulator.push(stateObject[chunkNames[i]]);
	      }
	
	      return getValuesList_accumulator;
	    }
	
	    /*!
	     * @param {string} formatString
	     * @param {Array.<number>} rawValues
	     *
	     * @return {string}
	     */
	    function getFormattedValues (formatString, rawValues) {
	      var formattedValueString = formatString;
	      var rawValuesLength = rawValues.length;
	
	      for (var i = 0; i < rawValuesLength; i++) {
	        formattedValueString = formattedValueString.replace(
	          VALUE_PLACEHOLDER, +rawValues[i].toFixed(4));
	      }
	
	      return formattedValueString;
	    }
	
	    /*!
	     * Note: It's the duty of the caller to convert the Array elements of the
	     * return value into numbers.  This is a performance optimization.
	     *
	     * @param {string} formattedString
	     *
	     * @return {Array.<string>|null}
	     */
	    function getValuesFrom (formattedString) {
	      return formattedString.match(R_UNFORMATTED_VALUES);
	    }
	
	    /*!
	     * @param {Object} easingObject
	     * @param {Object} tokenData
	     */
	    function expandEasingObject (easingObject, tokenData) {
	      Tweenable.each(tokenData, function (prop) {
	        var currentProp = tokenData[prop];
	        var chunkNames = currentProp.chunkNames;
	        var chunkLength = chunkNames.length;
	        var easingChunks = easingObject[prop].split(' ');
	        var lastEasingChunk = easingChunks[easingChunks.length - 1];
	
	        for (var i = 0; i < chunkLength; i++) {
	          easingObject[chunkNames[i]] = easingChunks[i] || lastEasingChunk;
	        }
	
	        delete easingObject[prop];
	      });
	    }
	
	    /*!
	     * @param {Object} easingObject
	     * @param {Object} tokenData
	     */
	    function collapseEasingObject (easingObject, tokenData) {
	      Tweenable.each(tokenData, function (prop) {
	        var currentProp = tokenData[prop];
	        var chunkNames = currentProp.chunkNames;
	        var chunkLength = chunkNames.length;
	        var composedEasingString = '';
	
	        for (var i = 0; i < chunkLength; i++) {
	          composedEasingString += ' ' + easingObject[chunkNames[i]];
	          delete easingObject[chunkNames[i]];
	        }
	
	        easingObject[prop] = composedEasingString.substr(1);
	      });
	    }
	
	    Tweenable.prototype.filter.token = {
	      'tweenCreated': function (currentState, fromState, toState, easingObject) {
	        sanitizeObjectForHexProps(currentState);
	        sanitizeObjectForHexProps(fromState);
	        sanitizeObjectForHexProps(toState);
	        this._tokenData = getFormatManifests(currentState);
	      },
	
	      'beforeTween': function (currentState, fromState, toState, easingObject) {
	        expandEasingObject(easingObject, this._tokenData);
	        expandFormattedProperties(currentState, this._tokenData);
	        expandFormattedProperties(fromState, this._tokenData);
	        expandFormattedProperties(toState, this._tokenData);
	      },
	
	      'afterTween': function (currentState, fromState, toState, easingObject) {
	        collapseFormattedProperties(currentState, this._tokenData);
	        collapseFormattedProperties(fromState, this._tokenData);
	        collapseFormattedProperties(toState, this._tokenData);
	        collapseEasingObject(easingObject, this._tokenData);
	      }
	    };
	
	  } (Tweenable));
	
	  }(window));
	
	  return window.Tweenable;
	});
	
	(function() {
	    "use strict";
	
	    angular.module('angular-carousel')
	
	    .filter('carouselSlice', function() {
	        return function(collection, start, size) {
	            if (angular.isArray(collection)) {
	                return collection.slice(start, start + size);
	            } else if (angular.isObject(collection)) {
	                // dont try to slice collections :)
	                return collection;
	            }
	        };
	    });
	
	})();


/***/ }),
/* 593 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * # ngCookies
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 *
	 * <div doc-module-components="ngCookies"></div>
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until Angular 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	angular.module('ngCookies').
	/**
	 * @ngdoc service
	 * @name $cookieStore
	 * @deprecated
	 * @requires $cookies
	 *
	 * @description
	 * Provides a key-value (string-object) storage, that is backed by session cookies.
	 * Objects put or retrieved from this storage are automatically serialized or
	 * deserialized by angular's toJson/fromJson.
	 *
	 * Requires the {@link ngCookies `ngCookies`} module to be installed.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The $cookieStore service is **deprecated**.
	 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	 * </div>
	 *
	 * @example
	 *
	 * ```js
	 * angular.module('cookieStoreExample', ['ngCookies'])
	 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	 *     // Put cookie
	 *     $cookieStore.put('myFavorite','oatmeal');
	 *     // Get cookie
	 *     var favoriteCookie = $cookieStore.get('myFavorite');
	 *     // Removing a cookie
	 *     $cookieStore.remove('myFavorite');
	 *   }]);
	 * ```
	 */
	 factory('$cookieStore', ['$cookies', function($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function(key) {
	        $cookies.remove(key);
	      }
	    };
	
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn("Cookie '" + name +
	        "' possibly not set or overflowed because it was too large (" +
	        cookieLength + " > 4096 bytes)!");
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(593);
	module.exports = 'ngCookies';


/***/ }),
/* 595 */
/***/ (function(module, exports) {

	/**
	 * angular-drag-and-drop-lists v1.4.0
	 *
	 * Copyright (c) 2014 Marcel Juenemann marcel@juenemann.cc
	 * Copyright (c) 2014-2016 Google Inc.
	 * https://github.com/marceljuenemann/angular-drag-and-drop-lists
	 *
	 * License: MIT
	 */
	angular.module('dndLists', [])
	
	  /**
	   * Use the dnd-draggable attribute to make your element draggable
	   *
	   * Attributes:
	   * - dnd-draggable      Required attribute. The value has to be an object that represents the data
	   *                      of the element. In case of a drag and drop operation the object will be
	   *                      serialized and unserialized on the receiving end.
	   * - dnd-selected       Callback that is invoked when the element was clicked but not dragged.
	   *                      The original click event will be provided in the local event variable.
	   * - dnd-effect-allowed Use this attribute to limit the operations that can be performed. Options:
	   *                      - "move": The drag operation will move the element. This is the default.
	   *                      - "copy": The drag operation will copy the element. Shows a copy cursor.
	   *                      - "copyMove": The user can choose between copy and move by pressing the
	   *                        ctrl or shift key. *Not supported in IE:* In Internet Explorer this
	   *                        option will be the same as "copy". *Not fully supported in Chrome on
	   *                        Windows:* In the Windows version of Chrome the cursor will always be the
	   *                        move cursor. However, when the user drops an element and has the ctrl
	   *                        key pressed, we will perform a copy anyways.
	   *                      - HTML5 also specifies the "link" option, but this library does not
	   *                        actively support it yet, so use it at your own risk.
	   * - dnd-moved          Callback that is invoked when the element was moved. Usually you will
	   *                      remove your element from the original list in this callback, since the
	   *                      directive is not doing that for you automatically. The original dragend
	   *                      event will be provided in the local event variable.
	   * - dnd-canceled       Callback that is invoked if the element was dragged, but the operation was
	   *                      canceled and the element was not dropped. The original dragend event will
	   *                      be provided in the local event variable.
	   * - dnd-copied         Same as dnd-moved, just that it is called when the element was copied
	   *                      instead of moved. The original dragend event will be provided in the local
	   *                      event variable.
	   * - dnd-dragstart      Callback that is invoked when the element was dragged. The original
	   *                      dragstart event will be provided in the local event variable.
	   * - dnd-dragend        Callback that is invoked when the drag operation ended. Available local
	   *                      variables are event and dropEffect.
	   * - dnd-type           Use this attribute if you have different kinds of items in your
	   *                      application and you want to limit which items can be dropped into which
	   *                      lists. Combine with dnd-allowed-types on the dnd-list(s). This attribute
	   *                      should evaluate to a string, although this restriction is not enforced.
	   * - dnd-disable-if     You can use this attribute to dynamically disable the draggability of the
	   *                      element. This is useful if you have certain list items that you don't want
	   *                      to be draggable, or if you want to disable drag & drop completely without
	   *                      having two different code branches (e.g. only allow for admins).
	   *                      **Note**: If your element is not draggable, the user is probably able to
	   *                      select text or images inside of it. Since a selection is always draggable,
	   *                      this breaks your UI. You most likely want to disable user selection via
	   *                      CSS (see user-select).
	   *
	   * CSS classes:
	   * - dndDragging        This class will be added to the element while the element is being
	   *                      dragged. It will affect both the element you see while dragging and the
	   *                      source element that stays at it's position. Do not try to hide the source
	   *                      element with this class, because that will abort the drag operation.
	   * - dndDraggingSource  This class will be added to the element after the drag operation was
	   *                      started, meaning it only affects the original element that is still at
	   *                      it's source position, and not the "element" that the user is dragging with
	   *                      his mouse pointer.
	   */
	  .directive('dndDraggable', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround',
	                      function($parse,   $timeout,   dndDropEffectWorkaround,   dndDragTypeWorkaround) {
	    return function(scope, element, attr) {
	      // Set the HTML5 draggable attribute on the element
	      element.attr("draggable", "true");
	
	      // If the dnd-disable-if attribute is set, we have to watch that
	      if (attr.dndDisableIf) {
	        scope.$watch(attr.dndDisableIf, function(disabled) {
	          element.attr("draggable", !disabled);
	        });
	      }
	
	      /**
	       * When the drag operation is started we have to prepare the dataTransfer object,
	       * which is the primary way we communicate with the target element
	       */
	      element.on('dragstart', function(event) {
	        event = event.originalEvent || event;
	
	        // Check whether the element is draggable, since dragstart might be triggered on a child.
	        if (element.attr('draggable') == 'false') return true;
	
	        // Serialize the data associated with this element. IE only supports the Text drag type
	        event.dataTransfer.setData("Text", angular.toJson(scope.$eval(attr.dndDraggable)));
	
	        // Only allow actions specified in dnd-effect-allowed attribute
	        event.dataTransfer.effectAllowed = attr.dndEffectAllowed || "move";
	
	        // Add CSS classes. See documentation above
	        element.addClass("dndDragging");
	        $timeout(function() { element.addClass("dndDraggingSource"); }, 0);
	
	        // Workarounds for stupid browsers, see description below
	        dndDropEffectWorkaround.dropEffect = "none";
	        dndDragTypeWorkaround.isDragging = true;
	
	        // Save type of item in global state. Usually, this would go into the dataTransfer
	        // typename, but we have to use "Text" there to support IE
	        dndDragTypeWorkaround.dragType = attr.dndType ? scope.$eval(attr.dndType) : undefined;
	
	        // Try setting a proper drag image if triggered on a dnd-handle (won't work in IE).
	        if (event._dndHandle && event.dataTransfer.setDragImage) {
	          event.dataTransfer.setDragImage(element[0], 0, 0);
	        }
	
	        // Invoke callback
	        $parse(attr.dndDragstart)(scope, {event: event});
	
	        event.stopPropagation();
	      });
	
	      /**
	       * The dragend event is triggered when the element was dropped or when the drag
	       * operation was aborted (e.g. hit escape button). Depending on the executed action
	       * we will invoke the callbacks specified with the dnd-moved or dnd-copied attribute.
	       */
	      element.on('dragend', function(event) {
	        event = event.originalEvent || event;
	
	        // Invoke callbacks. Usually we would use event.dataTransfer.dropEffect to determine
	        // the used effect, but Chrome has not implemented that field correctly. On Windows
	        // it always sets it to 'none', while Chrome on Linux sometimes sets it to something
	        // else when it's supposed to send 'none' (drag operation aborted).
	        var dropEffect = dndDropEffectWorkaround.dropEffect;
	        scope.$apply(function() {
	          switch (dropEffect) {
	            case "move":
	              $parse(attr.dndMoved)(scope, {event: event});
	              break;
	            case "copy":
	              $parse(attr.dndCopied)(scope, {event: event});
	              break;
	            case "none":
	              $parse(attr.dndCanceled)(scope, {event: event});
	              break;
	          }
	          $parse(attr.dndDragend)(scope, {event: event, dropEffect: dropEffect});
	        });
	
	        // Clean up
	        element.removeClass("dndDragging");
	        $timeout(function() { element.removeClass("dndDraggingSource"); }, 0);
	        dndDragTypeWorkaround.isDragging = false;
	        event.stopPropagation();
	      });
	
	      /**
	       * When the element is clicked we invoke the callback function
	       * specified with the dnd-selected attribute.
	       */
	      element.on('click', function(event) {
	        if (!attr.dndSelected) return;
	
	        event = event.originalEvent || event;
	        scope.$apply(function() {
	          $parse(attr.dndSelected)(scope, {event: event});
	        });
	
	        // Prevent triggering dndSelected in parent elements.
	        event.stopPropagation();
	      });
	
	      /**
	       * Workaround to make element draggable in IE9
	       */
	      element.on('selectstart', function() {
	        if (this.dragDrop) this.dragDrop();
	      });
	    };
	  }])
	
	  /**
	   * Use the dnd-list attribute to make your list element a dropzone. Usually you will add a single
	   * li element as child with the ng-repeat directive. If you don't do that, we will not be able to
	   * position the dropped element correctly. If you want your list to be sortable, also add the
	   * dnd-draggable directive to your li element(s). Both the dnd-list and it's direct children must
	   * have position: relative CSS style, otherwise the positioning algorithm will not be able to
	   * determine the correct placeholder position in all browsers.
	   *
	   * Attributes:
	   * - dnd-list             Required attribute. The value has to be the array in which the data of
	   *                        the dropped element should be inserted.
	   * - dnd-allowed-types    Optional array of allowed item types. When used, only items that had a
	   *                        matching dnd-type attribute will be dropable.
	   * - dnd-disable-if       Optional boolean expresssion. When it evaluates to true, no dropping
	   *                        into the list is possible. Note that this also disables rearranging
	   *                        items inside the list.
	   * - dnd-horizontal-list  Optional boolean expresssion. When it evaluates to true, the positioning
	   *                        algorithm will use the left and right halfs of the list items instead of
	   *                        the upper and lower halfs.
	   * - dnd-dragover         Optional expression that is invoked when an element is dragged over the
	   *                        list. If the expression is set, but does not return true, the element is
	   *                        not allowed to be dropped. The following variables will be available:
	   *                        - event: The original dragover event sent by the browser.
	   *                        - index: The position in the list at which the element would be dropped.
	   *                        - type: The dnd-type set on the dnd-draggable, or undefined if unset.
	   *                        - external: Whether the element was dragged from an external source.
	   * - dnd-drop             Optional expression that is invoked when an element is dropped on the
	   *                        list. The following variables will be available:
	   *                        - event: The original drop event sent by the browser.
	   *                        - index: The position in the list at which the element would be dropped.
	   *                        - item: The transferred object.
	   *                        - type: The dnd-type set on the dnd-draggable, or undefined if unset.
	   *                        - external: Whether the element was dragged from an external source.
	   *                        The return value determines the further handling of the drop:
	   *                        - false: The drop will be canceled and the element won't be inserted.
	   *                        - true: Signalises that the drop is allowed, but the dnd-drop
	   *                          callback already took care of inserting the element.
	   *                        - otherwise: All other return values will be treated as the object to
	   *                          insert into the array. In most cases you want to simply return the
	   *                          item parameter, but there are no restrictions on what you can return.
	   * - dnd-inserted         Optional expression that is invoked after a drop if the element was
	   *                        actually inserted into the list. The same local variables as for
	   *                        dnd-drop will be available. Note that for reorderings inside the same
	   *                        list the old element will still be in the list due to the fact that
	   *                        dnd-moved was not called yet.
	   * - dnd-external-sources Optional boolean expression. When it evaluates to true, the list accepts
	   *                        drops from sources outside of the current browser tab. This allows to
	   *                        drag and drop accross different browser tabs. Note that this will allow
	   *                        to drop arbitrary text into the list, thus it is highly recommended to
	   *                        implement the dnd-drop callback to check the incoming element for
	   *                        sanity. Furthermore, the dnd-type of external sources can not be
	   *                        determined, therefore do not rely on restrictions of dnd-allowed-type.
	   *
	   * CSS classes:
	   * - dndPlaceholder       When an element is dragged over the list, a new placeholder child
	   *                        element will be added. This element is of type li and has the class
	   *                        dndPlaceholder set. Alternatively, you can define your own placeholder
	   *                        by creating a child element with dndPlaceholder class.
	   * - dndDragover          Will be added to the list while an element is dragged over the list.
	   */
	  .directive('dndList', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround',
	                 function($parse,   $timeout,   dndDropEffectWorkaround,   dndDragTypeWorkaround) {
	    return function(scope, element, attr) {
	      // While an element is dragged over the list, this placeholder element is inserted
	      // at the location where the element would be inserted after dropping
	      var placeholder = getPlaceholderElement();
	      var placeholderNode = placeholder[0];
	      var listNode = element[0];
	      placeholder.remove();
	
	      var horizontal = attr.dndHorizontalList && scope.$eval(attr.dndHorizontalList);
	      var externalSources = attr.dndExternalSources && scope.$eval(attr.dndExternalSources);
	
	      /**
	       * The dragenter event is fired when a dragged element or text selection enters a valid drop
	       * target. According to the spec, we either need to have a dropzone attribute or listen on
	       * dragenter events and call preventDefault(). It should be noted though that no browser seems
	       * to enforce this behaviour.
	       */
	      element.on('dragenter', function (event) {
	        event = event.originalEvent || event;
	        if (!isDropAllowed(event)) return true;
	        event.preventDefault();
	      });
	
	      /**
	       * The dragover event is triggered "every few hundred milliseconds" while an element
	       * is being dragged over our list, or over an child element.
	       */
	      element.on('dragover', function(event) {
	        event = event.originalEvent || event;
	
	        if (!isDropAllowed(event)) return true;
	
	        // First of all, make sure that the placeholder is shown
	        // This is especially important if the list is empty
	        if (placeholderNode.parentNode != listNode) {
	          element.append(placeholder);
	        }
	
	        if (event.target !== listNode) {
	          // Try to find the node direct directly below the list node.
	          var listItemNode = event.target;
	          while (listItemNode.parentNode !== listNode && listItemNode.parentNode) {
	            listItemNode = listItemNode.parentNode;
	          }
	
	          if (listItemNode.parentNode === listNode && listItemNode !== placeholderNode) {
	            // If the mouse pointer is in the upper half of the child element,
	            // we place it before the child element, otherwise below it.
	            if (isMouseInFirstHalf(event, listItemNode)) {
	              listNode.insertBefore(placeholderNode, listItemNode);
	            } else {
	              listNode.insertBefore(placeholderNode, listItemNode.nextSibling);
	            }
	          }
	        } else {
	          // This branch is reached when we are dragging directly over the list element.
	          // Usually we wouldn't need to do anything here, but the IE does not fire it's
	          // events for the child element, only for the list directly. Therefore, we repeat
	          // the positioning algorithm for IE here.
	          if (isMouseInFirstHalf(event, placeholderNode, true)) {
	            // Check if we should move the placeholder element one spot towards the top.
	            // Note that display none elements will have offsetTop and offsetHeight set to
	            // zero, therefore we need a special check for them.
	            while (placeholderNode.previousElementSibling
	                 && (isMouseInFirstHalf(event, placeholderNode.previousElementSibling, true)
	                 || placeholderNode.previousElementSibling.offsetHeight === 0)) {
	              listNode.insertBefore(placeholderNode, placeholderNode.previousElementSibling);
	            }
	          } else {
	            // Check if we should move the placeholder element one spot towards the bottom
	            while (placeholderNode.nextElementSibling &&
	                 !isMouseInFirstHalf(event, placeholderNode.nextElementSibling, true)) {
	              listNode.insertBefore(placeholderNode,
	                  placeholderNode.nextElementSibling.nextElementSibling);
	            }
	          }
	        }
	
	        // At this point we invoke the callback, which still can disallow the drop.
	        // We can't do this earlier because we want to pass the index of the placeholder.
	        if (attr.dndDragover && !invokeCallback(attr.dndDragover, event, getPlaceholderIndex())) {
	          return stopDragover();
	        }
	
	        element.addClass("dndDragover");
	        event.preventDefault();
	        event.stopPropagation();
	        return false;
	      });
	
	      /**
	       * When the element is dropped, we use the position of the placeholder element as the
	       * position where we insert the transferred data. This assumes that the list has exactly
	       * one child element per array element.
	       */
	      element.on('drop', function(event) {
	        event = event.originalEvent || event;
	
	        if (!isDropAllowed(event)) return true;
	
	        // The default behavior in Firefox is to interpret the dropped element as URL and
	        // forward to it. We want to prevent that even if our drop is aborted.
	        event.preventDefault();
	
	        // Unserialize the data that was serialized in dragstart. According to the HTML5 specs,
	        // the "Text" drag type will be converted to text/plain, but IE does not do that.
	        var data = event.dataTransfer.getData("Text") || event.dataTransfer.getData("text/plain");
	        var transferredObject;
	        try {
	          transferredObject = JSON.parse(data);
	        } catch(e) {
	          return stopDragover();
	        }
	
	        // Invoke the callback, which can transform the transferredObject and even abort the drop.
	        var index = getPlaceholderIndex();
	        if (attr.dndDrop) {
	          transferredObject = invokeCallback(attr.dndDrop, event, index, transferredObject);
	          if (!transferredObject) {
	            return stopDragover();
	          }
	        }
	
	        // Insert the object into the array, unless dnd-drop took care of that (returned true).
	        if (transferredObject !== true) {
	          scope.$apply(function() {
	            scope.$eval(attr.dndList).splice(index, 0, transferredObject);
	          });
	        }
	        invokeCallback(attr.dndInserted, event, index, transferredObject);
	
	        // In Chrome on Windows the dropEffect will always be none...
	        // We have to determine the actual effect manually from the allowed effects
	        if (event.dataTransfer.dropEffect === "none") {
	          if (event.dataTransfer.effectAllowed === "copy" ||
	              event.dataTransfer.effectAllowed === "move") {
	            dndDropEffectWorkaround.dropEffect = event.dataTransfer.effectAllowed;
	          } else {
	            dndDropEffectWorkaround.dropEffect = event.ctrlKey ? "copy" : "move";
	          }
	        } else {
	          dndDropEffectWorkaround.dropEffect = event.dataTransfer.dropEffect;
	        }
	
	        // Clean up
	        stopDragover();
	        event.stopPropagation();
	        return false;
	      });
	
	      /**
	       * We have to remove the placeholder when the element is no longer dragged over our list. The
	       * problem is that the dragleave event is not only fired when the element leaves our list,
	       * but also when it leaves a child element -- so practically it's fired all the time. As a
	       * workaround we wait a few milliseconds and then check if the dndDragover class was added
	       * again. If it is there, dragover must have been called in the meantime, i.e. the element
	       * is still dragging over the list. If you know a better way of doing this, please tell me!
	       */
	      element.on('dragleave', function(event) {
	        event = event.originalEvent || event;
	
	        element.removeClass("dndDragover");
	        $timeout(function() {
	          if (!element.hasClass("dndDragover")) {
	            placeholder.remove();
	          }
	        }, 100);
	      });
	
	      /**
	       * Checks whether the mouse pointer is in the first half of the given target element.
	       *
	       * In Chrome we can just use offsetY, but in Firefox we have to use layerY, which only
	       * works if the child element has position relative. In IE the events are only triggered
	       * on the listNode instead of the listNodeItem, therefore the mouse positions are
	       * relative to the parent element of targetNode.
	       */
	      function isMouseInFirstHalf(event, targetNode, relativeToParent) {
	        var mousePointer = horizontal ? (event.offsetX || event.layerX)
	                                      : (event.offsetY || event.layerY);
	        var targetSize = horizontal ? targetNode.offsetWidth : targetNode.offsetHeight;
	        var targetPosition = horizontal ? targetNode.offsetLeft : targetNode.offsetTop;
	        targetPosition = relativeToParent ? targetPosition : 0;
	        return mousePointer < targetPosition + targetSize / 2;
	      }
	
	      /**
	       * Tries to find a child element that has the dndPlaceholder class set. If none was found, a
	       * new li element is created.
	       */
	      function getPlaceholderElement() {
	        var placeholder;
	        angular.forEach(element.children(), function(childNode) {
	          var child = angular.element(childNode);
	          if (child.hasClass('dndPlaceholder')) {
	            placeholder = child;
	          }
	        });
	        return placeholder || angular.element("<li class='dndPlaceholder'></li>");
	      }
	
	      /**
	       * We use the position of the placeholder node to determine at which position of the array the
	       * object needs to be inserted
	       */
	      function getPlaceholderIndex() {
	        return Array.prototype.indexOf.call(listNode.children, placeholderNode);
	      }
	
	      /**
	       * Checks various conditions that must be fulfilled for a drop to be allowed
	       */
	      function isDropAllowed(event) {
	        // Disallow drop from external source unless it's allowed explicitly.
	        if (!dndDragTypeWorkaround.isDragging && !externalSources) return false;
	
	        // Check mimetype. Usually we would use a custom drag type instead of Text, but IE doesn't
	        // support that.
	        if (!hasTextMimetype(event.dataTransfer.types)) return false;
	
	        // Now check the dnd-allowed-types against the type of the incoming element. For drops from
	        // external sources we don't know the type, so it will need to be checked via dnd-drop.
	        if (attr.dndAllowedTypes && dndDragTypeWorkaround.isDragging) {
	          var allowed = scope.$eval(attr.dndAllowedTypes);
	          if (angular.isArray(allowed) && allowed.indexOf(dndDragTypeWorkaround.dragType) === -1) {
	            return false;
	          }
	        }
	
	        // Check whether droping is disabled completely
	        if (attr.dndDisableIf && scope.$eval(attr.dndDisableIf)) return false;
	
	        return true;
	      }
	
	      /**
	       * Small helper function that cleans up if we aborted a drop.
	       */
	      function stopDragover() {
	        placeholder.remove();
	        element.removeClass("dndDragover");
	        return true;
	      }
	
	      /**
	       * Invokes a callback with some interesting parameters and returns the callbacks return value.
	       */
	      function invokeCallback(expression, event, index, item) {
	        return $parse(expression)(scope, {
	          event: event,
	          index: index,
	          item: item || undefined,
	          external: !dndDragTypeWorkaround.isDragging,
	          type: dndDragTypeWorkaround.isDragging ? dndDragTypeWorkaround.dragType : undefined
	        });
	      }
	
	      /**
	       * Check if the dataTransfer object contains a drag type that we can handle. In old versions
	       * of IE the types collection will not even be there, so we just assume a drop is possible.
	       */
	      function hasTextMimetype(types) {
	        if (!types) return true;
	        for (var i = 0; i < types.length; i++) {
	          if (types[i] === "Text" || types[i] === "text/plain") return true;
	        }
	
	        return false;
	      }
	    };
	  }])
	
	  /**
	   * Use the dnd-nodrag attribute inside of dnd-draggable elements to prevent them from starting
	   * drag operations. This is especially useful if you want to use input elements inside of
	   * dnd-draggable elements or create specific handle elements. Note: This directive does not work
	   * in Internet Explorer 9.
	   */
	  .directive('dndNodrag', function() {
	    return function(scope, element, attr) {
	      // Set as draggable so that we can cancel the events explicitly
	      element.attr("draggable", "true");
	
	      /**
	       * Since the element is draggable, the browser's default operation is to drag it on dragstart.
	       * We will prevent that and also stop the event from bubbling up.
	       */
	      element.on('dragstart', function(event) {
	        event = event.originalEvent || event;
	
	        if (!event._dndHandle) {
	          // If a child element already reacted to dragstart and set a dataTransfer object, we will
	          // allow that. For example, this is the case for user selections inside of input elements.
	          if (!(event.dataTransfer.types && event.dataTransfer.types.length)) {
	            event.preventDefault();
	          }
	          event.stopPropagation();
	        }
	      });
	
	      /**
	       * Stop propagation of dragend events, otherwise dnd-moved might be triggered and the element
	       * would be removed.
	       */
	      element.on('dragend', function(event) {
	        event = event.originalEvent || event;
	        if (!event._dndHandle) {
	          event.stopPropagation();
	        }
	      });
	    };
	  })
	
	  /**
	   * Use the dnd-handle directive within a dnd-nodrag element in order to allow dragging with that
	   * element after all. Therefore, by combining dnd-nodrag and dnd-handle you can allow
	   * dnd-draggable elements to only be dragged via specific "handle" elements. Note that Internet
	   * Explorer will show the handle element as drag image instead of the dnd-draggable element. You
	   * can work around this by styling the handle element differently when it is being dragged. Use
	   * the CSS selector .dndDragging:not(.dndDraggingSource) [dnd-handle] for that.
	   */
	  .directive('dndHandle', function() {
	    return function(scope, element, attr) {
	      element.attr("draggable", "true");
	
	      element.on('dragstart dragend', function(event) {
	        event = event.originalEvent || event;
	        event._dndHandle = true;
	      });
	    };
	  })
	
	  /**
	   * This workaround handles the fact that Internet Explorer does not support drag types other than
	   * "Text" and "URL". That means we can not know whether the data comes from one of our elements or
	   * is just some other data like a text selection. As a workaround we save the isDragging flag in
	   * here. When a dropover event occurs, we only allow the drop if we are already dragging, because
	   * that means the element is ours.
	   */
	  .factory('dndDragTypeWorkaround', function(){ return {} })
	
	  /**
	   * Chrome on Windows does not set the dropEffect field, which we need in dragend to determine
	   * whether a drag operation was successful. Therefore we have to maintain it in this global
	   * variable. The bug report for that has been open for years:
	   * https://code.google.com/p/chromium/issues/detail?id=39399
	   */
	  .factory('dndDropEffectWorkaround', function(){ return {} });


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(window) {
	   var createModule = function(angular) {
	      var module = angular.module('FBAngular', []);
	
	      module.factory('Fullscreen', ['$document', '$rootScope', function ($document,$rootScope) {
	         var document = $document[0];
	
	         // ensure ALLOW_KEYBOARD_INPUT is available and enabled
	         var isKeyboardAvailbleOnFullScreen = (typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element) && Element.ALLOW_KEYBOARD_INPUT;
	
	         var emitter = $rootScope.$new();
	
	         // listen event on document instead of element to avoid firefox limitation
	         // see https://developer.mozilla.org/en-US/docs/Web/Guide/API/DOM/Using_full_screen_mode
	         $document.on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', function(){
	            emitter.$emit('FBFullscreen.change', serviceInstance.isEnabled());
	         });
	
	         var serviceInstance = {
	            $on: angular.bind(emitter, emitter.$on),
	            all: function() {
	               serviceInstance.enable( document.documentElement );
	            },
	            enable: function(element) {
	               if(element.requestFullScreen) {
	                  element.requestFullScreen();
	               } else if(element.mozRequestFullScreen) {
	                  element.mozRequestFullScreen();
	               } else if(element.webkitRequestFullscreen) {
	                  // Safari temporary fix
	                  if (/Version\/[\d]{1,2}(\.[\d]{1,2}){1}(\.(\d){1,2}){0,1} Safari/.test(navigator.userAgent)) {
	                     element.webkitRequestFullscreen();
	                  } else {
	                     element.webkitRequestFullscreen(isKeyboardAvailbleOnFullScreen);
	                  }
	               } else if (element.msRequestFullscreen) {
	                  element.msRequestFullscreen();
	               }
	            },
	            cancel: function() {
	               if(document.cancelFullScreen) {
	                  document.cancelFullScreen();
	               } else if(document.mozCancelFullScreen) {
	                  document.mozCancelFullScreen();
	               } else if(document.webkitExitFullscreen) {
	                  document.webkitExitFullscreen();
	               } else if (document.msExitFullscreen) {
	                  document.msExitFullscreen();
	               }
	            },
	            isEnabled: function(){
	               var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
	               return fullscreenElement ? true : false;
	            },
	            toggleAll: function(){
	                serviceInstance.isEnabled() ? serviceInstance.cancel() : serviceInstance.all();
	            },
	            isSupported: function(){
	                var docElm = document.documentElement;
	                var requestFullscreen = docElm.requestFullScreen || docElm.mozRequestFullScreen || docElm.webkitRequestFullscreen || docElm.msRequestFullscreen;
	                return requestFullscreen ? true : false;
	            }
	         };
	
	         return serviceInstance;
	      }]);
	
	      module.directive('fullscreen', ['Fullscreen', function(Fullscreen) {
	         return {
	            link : function ($scope, $element, $attrs) {
	               // Watch for changes on scope if model is provided
	               if ($attrs.fullscreen) {
	                  $scope.$watch($attrs.fullscreen, function(value) {
	                     var isEnabled = Fullscreen.isEnabled();
	                     if (value && !isEnabled) {
	                        Fullscreen.enable($element[0]);
	                        $element.addClass('isInFullScreen');
	                     } else if (!value && isEnabled) {
	                        Fullscreen.cancel();
	                        $element.removeClass('isInFullScreen');
	                     }
	                  });
	
	                  // Listen on the `FBFullscreen.change`
	                  // the event will fire when anything changes the fullscreen mode
	                  var removeFullscreenHandler = Fullscreen.$on('FBFullscreen.change', function(evt, isFullscreenEnabled){
	                     if(!isFullscreenEnabled){
	                        $scope.$evalAsync(function(){
	                           $scope.$eval($attrs.fullscreen + '= false');
	                           $element.removeClass('isInFullScreen');
	                        });
	                     }
	                  });
	
	                  $scope.$on('$destroy', function() {
	                     removeFullscreenHandler();
	                  });
	
	               } else {
	                  if ($attrs.onlyWatchedProperty !== undefined) {
	                     return;
	                  }
	
	                  $element.on('click', function (ev) {
	                     Fullscreen.enable(  $element[0] );
	                  });
	               }
	            }
	         };
	      }]);
	      return module;
	   };
	
	   if (true) {
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) { return createModule(angular); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	   } else if (typeof module !== 'undefined' && module.exports) {
	      module.exports = createModule(window.angular).name;
	   } else {
	      createModule(window.angular);
	   }
	})(window);


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * angular-gridster
	 * http://manifestwebdesign.github.io/angular-gridster
	 *
	 * @version: 0.13.14
	 * @license: MIT
	 */
	!function(a,b){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=b(require("angular")):b(a.angular)}(this,function(a){"use strict";return a.module("gridster",[]).constant("gridsterConfig",{columns:6,pushing:!0,floating:!0,swapping:!1,width:"auto",colWidth:"auto",rowHeight:"match",margins:[10,10],outerMargin:!0,isMobile:!1,mobileBreakPoint:600,mobileModeEnabled:!0,minColumns:1,minRows:1,maxRows:100,defaultSizeX:2,defaultSizeY:1,minSizeX:1,maxSizeX:null,minSizeY:1,maxSizeY:null,saveGridItemCalculatedHeightInMobile:!1,resizable:{enabled:!0,handles:["s","e","n","w","se","ne","sw","nw"]},draggable:{enabled:!0,scrollSensitivity:20,scrollSpeed:15}}).controller("GridsterCtrl",["gridsterConfig","$timeout",function(b,c){var d=this;a.extend(this,b),this.resizable=a.extend({},b.resizable||{}),this.draggable=a.extend({},b.draggable||{});var e=!1;this.layoutChanged=function(){e||(e=!0,c(function(){e=!1,d.loaded&&d.floatItemsUp(),d.updateHeight(d.movingItem?d.movingItem.sizeY:0)},30))},this.grid=[],this.destroy=function(){this.grid&&(this.grid=[]),this.$element=null},this.setOptions=function(b){if(b)if(b=a.extend({},b),b.draggable&&(a.extend(this.draggable,b.draggable),delete b.draggable),b.resizable&&(a.extend(this.resizable,b.resizable),delete b.resizable),a.extend(this,b),this.margins&&2===this.margins.length)for(var c=0,d=this.margins.length;c<d;++c)this.margins[c]=parseInt(this.margins[c],10),isNaN(this.margins[c])&&(this.margins[c]=0);else this.margins=[0,0]},this.canItemOccupy=function(a,b,c){return b>-1&&c>-1&&a.sizeX+c<=this.columns&&a.sizeY+b<=this.maxRows},this.autoSetItemPosition=function(a){for(var b=0;b<this.maxRows;++b)for(var c=0;c<this.columns;++c){var d=this.getItems(b,c,a.sizeX,a.sizeY,a);if(0===d.length&&this.canItemOccupy(a,b,c))return void this.putItem(a,b,c)}throw new Error("Unable to place item!")},this.getItems=function(a,b,c,d,e){var f=[];c&&d||(c=d=1),!e||e instanceof Array||(e=[e]);for(var g=0;g<d;++g)for(var h=0;h<c;++h){var i=this.getItem(a+g,b+h,e);!i||e&&e.indexOf(i)!==-1||f.indexOf(i)!==-1||f.push(i)}return f},this.getBoundingBox=function(a){if(0===a.length)return null;if(1===a.length)return{row:a[0].row,col:a[0].col,sizeY:a[0].sizeY,sizeX:a[0].sizeX};for(var b=0,c=0,d=9999,e=9999,f=0,g=a.length;f<g;++f){var h=a[f];d=Math.min(h.row,d),e=Math.min(h.col,e),b=Math.max(h.row+h.sizeY,b),c=Math.max(h.col+h.sizeX,c)}return{row:d,col:e,sizeY:b-d,sizeX:c-e}},this.removeItem=function(a){for(var b=0,c=this.grid.length;b<c;++b){var d=this.grid[b];if(d){var e=d.indexOf(a);if(e!==-1){d[e]=null;break}}}this.layoutChanged()},this.getItem=function(a,b,c){!c||c instanceof Array||(c=[c]);for(var d=1;a>-1;){for(var e=1,f=b;f>-1;){var g=this.grid[a];if(g){var h=g[f];if(h&&(!c||c.indexOf(h)===-1)&&h.sizeX>=e&&h.sizeY>=d)return h}++e,--f}--a,++d}return null},this.putItems=function(a){for(var b=0,c=a.length;b<c;++b)this.putItem(a[b])},this.putItem=function(a,b,c,d){if(("undefined"==typeof b||null===b)&&(b=a.row,c=a.col,"undefined"==typeof b||null===b))return void this.autoSetItemPosition(a);if(this.canItemOccupy(a,b,c)||(c=Math.min(this.columns-a.sizeX,Math.max(0,c)),b=Math.min(this.maxRows-a.sizeY,Math.max(0,b))),null!==a.oldRow&&"undefined"!=typeof a.oldRow){var e=a.oldRow===b&&a.oldColumn===c,f=this.grid[b]&&this.grid[b][c]===a;if(e&&f)return a.row=b,void(a.col=c);var g=this.grid[a.oldRow];g&&g[a.oldColumn]===a&&delete g[a.oldColumn]}a.oldRow=a.row=b,a.oldColumn=a.col=c,this.moveOverlappingItems(a,d),this.grid[b]||(this.grid[b]=[]),this.grid[b][c]=a,this.movingItem===a&&this.floatItemUp(a),this.layoutChanged()},this.swapItems=function(a,b){this.grid[a.row][a.col]=b,this.grid[b.row][b.col]=a;var c=a.row,d=a.col;a.row=b.row,a.col=b.col,b.row=c,b.col=d},this.moveOverlappingItems=function(a,b){b?b.indexOf(a)===-1&&(b=b.slice(0),b.push(a)):b=[a];var c=this.getItems(a.row,a.col,a.sizeX,a.sizeY,b);this.moveItemsDown(c,a.row+a.sizeY,b)},this.moveItemsDown=function(a,b,c){if(a&&0!==a.length){a.sort(function(a,b){return a.row-b.row}),c=c?c.slice(0):[];var d,e,f,g={};for(e=0,f=a.length;e<f;++e){d=a[e];var h=g[d.col];("undefined"==typeof h||d.row<h)&&(g[d.col]=d.row)}for(e=0,f=a.length;e<f;++e){d=a[e];var i=b-g[d.col];this.moveItemDown(d,d.row+i,c),c.push(d)}}},this.moveItemDown=function(a,b,c){if(!(a.row>=b)){for(;a.row<b;)++a.row,this.moveOverlappingItems(a,c);this.putItem(a,a.row,a.col,c)}},this.floatItemsUp=function(){if(this.floating!==!1)for(var a=0,b=this.grid.length;a<b;++a){var c=this.grid[a];if(c)for(var d=0,e=c.length;d<e;++d){var f=c[d];f&&this.floatItemUp(f)}}},this.floatItemUp=function(a){if(this.floating!==!1){for(var b=a.col,c=a.sizeY,d=a.sizeX,e=null,f=null,g=a.row-1;g>-1;){var h=this.getItems(g,b,d,c,a);if(0!==h.length)break;e=g,f=b,--g}null!==e&&this.putItem(a,e,f)}},this.updateHeight=function(a){var b=this.minRows;a=a||0;for(var c=this.grid.length;c>=0;--c){var d=this.grid[c];if(d)for(var e=0,f=d.length;e<f;++e)d[e]&&(b=Math.max(b,c+a+d[e].sizeY))}this.gridHeight=this.maxRows-b>0?Math.min(this.maxRows,b):Math.max(this.maxRows,b)},this.pixelsToRows=function(a,b){return this.outerMargin||(a+=this.margins[0]/2),b===!0?Math.ceil(a/this.curRowHeight):b===!1?Math.floor(a/this.curRowHeight):Math.round(a/this.curRowHeight)},this.pixelsToColumns=function(a,b){return this.outerMargin||(a+=this.margins[1]/2),b===!0?Math.ceil(a/this.curColWidth):b===!1?Math.floor(a/this.curColWidth):Math.round(a/this.curColWidth)}}]).directive("gridsterPreview",function(){return{replace:!0,scope:!0,require:"^gridster",template:'<div ng-style="previewStyle()" class="gridster-item gridster-preview-holder"></div>',link:function(a,b,c,d){a.previewStyle=function(){return d.movingItem?{display:"block",height:d.movingItem.sizeY*d.curRowHeight-d.margins[0]+"px",width:d.movingItem.sizeX*d.curColWidth-d.margins[1]+"px",top:d.movingItem.row*d.curRowHeight+(d.outerMargin?d.margins[0]:0)+"px",left:d.movingItem.col*d.curColWidth+(d.outerMargin?d.margins[1]:0)+"px"}:{display:"none"}}}}}).directive("gridster",["$timeout","$window","$rootScope","gridsterDebounce",function(b,c,d,e){return{scope:!0,restrict:"EAC",controller:"GridsterCtrl",controllerAs:"gridster",compile:function(f){return f.prepend('<div ng-if="gridster.movingItem" gridster-preview></div>'),function(f,g,h,i){function j(){g.css("height",i.gridHeight*i.curRowHeight+(i.outerMargin?i.margins[0]:-i.margins[0])+"px")}function k(a){if(i.setOptions(a),l(g[0])){"auto"===i.width?i.curWidth=g[0].offsetWidth||parseInt(g.css("width"),10):i.curWidth=i.width,"auto"===i.colWidth?i.curColWidth=(i.curWidth+(i.outerMargin?-i.margins[1]:i.margins[1]))/i.columns:i.curColWidth=i.colWidth,i.curRowHeight=i.rowHeight,"string"==typeof i.rowHeight&&("match"===i.rowHeight?i.curRowHeight=Math.round(i.curColWidth):i.rowHeight.indexOf("*")!==-1?i.curRowHeight=Math.round(i.curColWidth*i.rowHeight.replace("*","").replace(" ","")):i.rowHeight.indexOf("/")!==-1&&(i.curRowHeight=Math.round(i.curColWidth/i.rowHeight.replace("/","").replace(" ","")))),i.isMobile=i.mobileModeEnabled&&i.curWidth<=i.mobileBreakPoint;for(var b=0,c=i.grid.length;b<c;++b){var d=i.grid[b];if(d)for(var e=0,f=d.length;e<f;++e)if(d[e]){var h=d[e];h.setElementPosition(),h.setElementSizeY(),h.setElementSizeX()}}j()}}i.loaded=!1,i.$element=g,f.gridster=i,g.addClass("gridster");var l=function(a){return"hidden"!==a.style.visibility&&"none"!==a.style.display};f.$watch(function(){return i.gridHeight},j),f.$watch(function(){return i.movingItem},function(){i.updateHeight(i.movingItem?i.movingItem.sizeY:0)});var m=h.gridster;m?f.$parent.$watch(m,function(a){k(a)},!0):k({}),f.$watch(function(){return i.loaded},function(){i.loaded?(g.addClass("gridster-loaded"),d.$broadcast("gridster-loaded",i)):g.removeClass("gridster-loaded")}),f.$watch(function(){return i.isMobile},function(){i.isMobile?g.addClass("gridster-mobile").removeClass("gridster-desktop"):g.removeClass("gridster-mobile").addClass("gridster-desktop"),d.$broadcast("gridster-mobile-changed",i)}),f.$watch(function(){return i.draggable},function(){d.$broadcast("gridster-draggable-changed",i)},!0),f.$watch(function(){return i.resizable},function(){d.$broadcast("gridster-resizable-changed",i)},!0);var n=g[0].offsetWidth||parseInt(g.css("width"),10),o=function(){var a=g[0].offsetWidth||parseInt(g.css("width"),10);a&&a!==n&&!i.movingItem&&(n=a,i.loaded&&g.removeClass("gridster-loaded"),k(),i.loaded&&g.addClass("gridster-loaded"),d.$broadcast("gridster-resized",[a,g[0].offsetHeight],i))},p=e(function(){o(),b(function(){f.$apply()})},100);f.$watch(function(){return l(g[0])},p),"function"==typeof window.addResizeListener?window.addResizeListener(g[0],p):f.$watch(function(){return g[0].offsetWidth||parseInt(g.css("width"),10)},o);var q=a.element(c);q.on("resize",p),f.$on("$destroy",function(){i.destroy(),q.off("resize",p),"function"==typeof window.removeResizeListener&&window.removeResizeListener(g[0],p)}),b(function(){f.$watch("gridster.floating",function(){i.floatItemsUp()}),i.loaded=!0},100)}}}}]).controller("GridsterItemCtrl",function(){this.$element=null,this.gridster=null,this.row=null,this.col=null,this.sizeX=null,this.sizeY=null,this.minSizeX=0,this.minSizeY=0,this.maxSizeX=null,this.maxSizeY=null,this.init=function(a,b){this.$element=a,this.gridster=b,this.sizeX=b.defaultSizeX,this.sizeY=b.defaultSizeY},this.destroy=function(){this.gridster=null,this.$element=null},this.toJSON=function(){return{row:this.row,col:this.col,sizeY:this.sizeY,sizeX:this.sizeX}},this.isMoving=function(){return this.gridster.movingItem===this},this.setPosition=function(a,b){this.gridster.putItem(this,a,b),this.isMoving()||this.setElementPosition()},this.setSize=function(a,b,c){a=a.toUpperCase();var d="size"+a,e="Size"+a;if(""!==b){b=parseInt(b,10),(isNaN(b)||0===b)&&(b=this.gridster["default"+e]);var f="X"===a?this.gridster.columns:this.gridster.maxRows;this["max"+e]&&(f=Math.min(this["max"+e],f)),this.gridster["max"+e]&&(f=Math.min(this.gridster["max"+e],f)),"X"===a&&this.cols?f-=this.cols:"Y"===a&&this.rows&&(f-=this.rows);var g=0;this["min"+e]&&(g=Math.max(this["min"+e],g)),this.gridster["min"+e]&&(g=Math.max(this.gridster["min"+e],g)),b=Math.max(Math.min(b,f),g);var h=this[d]!==b||this["old"+e]&&this["old"+e]!==b;return this["old"+e]=this[d]=b,this.isMoving()||this["setElement"+e](),!c&&h&&(this.gridster.moveOverlappingItems(this),this.gridster.layoutChanged()),h}},this.setSizeY=function(a,b){return this.setSize("Y",a,b)},this.setSizeX=function(a,b){return this.setSize("X",a,b)},this.setElementPosition=function(){this.gridster.isMobile?this.$element.css({marginLeft:this.gridster.margins[0]+"px",marginRight:this.gridster.margins[0]+"px",marginTop:this.gridster.margins[1]+"px",marginBottom:this.gridster.margins[1]+"px",top:"",left:""}):this.$element.css({margin:0,top:this.row*this.gridster.curRowHeight+(this.gridster.outerMargin?this.gridster.margins[0]:0)+"px",left:this.col*this.gridster.curColWidth+(this.gridster.outerMargin?this.gridster.margins[1]:0)+"px"})},this.setElementSizeY=function(){this.gridster.isMobile&&!this.gridster.saveGridItemCalculatedHeightInMobile?this.$element.css("height",""):this.$element.css("height",this.sizeY*this.gridster.curRowHeight-this.gridster.margins[0]+"px")},this.setElementSizeX=function(){this.gridster.isMobile?this.$element.css("width",""):this.$element.css("width",this.sizeX*this.gridster.curColWidth-this.gridster.margins[1]+"px")},this.getElementSizeX=function(){return this.sizeX*this.gridster.curColWidth-this.gridster.margins[1]},this.getElementSizeY=function(){return this.sizeY*this.gridster.curRowHeight-this.gridster.margins[0]}}).factory("GridsterTouch",[function(){return function(a,b,c,d){var e,f,g={},h=function(a){if(Object.keys)return Object.keys(a).length;var b,c=0;for(b in a)++c;return c},i=function(a){for(var b=0,c=0,d=navigator.userAgent.match(/\bMSIE\b/),e=a;null!=e;e=e.offsetParent)d&&(!document.documentMode||document.documentMode<8)&&"relative"===e.currentStyle.position&&e.offsetParent&&"relative"===e.offsetParent.currentStyle.position&&e.offsetLeft===e.offsetParent.offsetLeft?c+=e.offsetTop:(b+=e.offsetLeft,c+=e.offsetTop);return{x:b,y:c}},j=i(a),k=!1,l=function(e){if("mousemove"!==e.type||0!==h(g)){for(var f=!0,m=e.changedTouches?e.changedTouches:[e],n=0;n<m.length;++n){var o=m[n],p="undefined"!=typeof o.identifier?o.identifier:"undefined"!=typeof o.pointerId?o.pointerId:1;if("undefined"==typeof o.pageX)if(o.pageX=o.offsetX+j.x,o.pageY=o.offsetY+j.y,o.srcElement.offsetParent===a&&document.documentMode&&8===document.documentMode&&"mousedown"===o.type)o.pageX+=o.srcElement.offsetLeft,o.pageY+=o.srcElement.offsetTop;else if(o.srcElement!==a&&!document.documentMode||document.documentMode<8){for(var q=-2,r=-2,s=o.srcElement;null!==s;s=s.parentNode)q+=s.scrollLeft?s.scrollLeft:0,r+=s.scrollTop?s.scrollTop:0;o.pageX=o.clientX+q,o.pageY=o.clientY+r}var t=o.pageX,u=o.pageY;e.type.match(/(start|down)$/i)?(j=i(a),g[p]&&(d&&d({target:e.target,which:e.which,pointerId:p,pageX:t,pageY:u}),delete g[p]),b&&f&&(f=b({target:e.target,which:e.which,pointerId:p,pageX:t,pageY:u})),g[p]={x:t,y:u},a.msSetPointerCapture&&f?a.msSetPointerCapture(p):"mousedown"===e.type&&1===h(g)&&(k?a.setCapture(!0):(document.addEventListener("mousemove",l,!1),document.addEventListener("mouseup",l,!1)))):e.type.match(/move$/i)?!g[p]||g[p].x===t&&g[p].y===u||(c&&f&&(f=c({target:e.target,which:e.which,pointerId:p,pageX:t,pageY:u})),g[p].x=t,g[p].y=u):g[p]&&e.type.match(/(up|end|cancel)$/i)&&(d&&f&&(f=d({target:e.target,which:e.which,pointerId:p,pageX:t,pageY:u})),delete g[p],a.msReleasePointerCapture?a.msReleasePointerCapture(p):"mouseup"===e.type&&0===h(g)&&(k?a.releaseCapture():(document.removeEventListener("mousemove",l,!1),document.removeEventListener("mouseup",l,!1))))}f&&(e.preventDefault&&e.preventDefault(),e.preventManipulation&&e.preventManipulation(),e.preventMouseEvent&&e.preventMouseEvent())}};return this.enable=function(){window.navigator.msPointerEnabled?(a.addEventListener("MSPointerDown",l,!1),a.addEventListener("MSPointerMove",l,!1),a.addEventListener("MSPointerUp",l,!1),a.addEventListener("MSPointerCancel",l,!1),"undefined"!=typeof a.style.msContentZooming&&(e=a.style.msContentZooming,a.style.msContentZooming="none"),"undefined"!=typeof a.style.msTouchAction&&(f=a.style.msTouchAction,a.style.msTouchAction="none")):a.addEventListener?(a.addEventListener("touchstart",l,!1),a.addEventListener("touchmove",l,!1),a.addEventListener("touchend",l,!1),a.addEventListener("touchcancel",l,!1),a.addEventListener("mousedown",l,!1),a.setCapture&&!window.navigator.userAgent.match(/\bGecko\b/)&&(k=!0,a.addEventListener("mousemove",l,!1),a.addEventListener("mouseup",l,!1))):a.attachEvent&&a.setCapture&&(k=!0,a.attachEvent("onmousedown",function(){return l(window.event),window.event.returnValue=!1,!1}),a.attachEvent("onmousemove",function(){return l(window.event),window.event.returnValue=!1,!1}),a.attachEvent("onmouseup",function(){return l(window.event),window.event.returnValue=!1,!1}))},this.disable=function(){window.navigator.msPointerEnabled?(a.removeEventListener("MSPointerDown",l,!1),a.removeEventListener("MSPointerMove",l,!1),a.removeEventListener("MSPointerUp",l,!1),a.removeEventListener("MSPointerCancel",l,!1),e&&(a.style.msContentZooming=e),f&&(a.style.msTouchAction=f)):a.removeEventListener?(a.removeEventListener("touchstart",l,!1),a.removeEventListener("touchmove",l,!1),a.removeEventListener("touchend",l,!1),a.removeEventListener("touchcancel",l,!1),a.removeEventListener("mousedown",l,!1),a.setCapture&&!window.navigator.userAgent.match(/\bGecko\b/)&&(k=!0,a.removeEventListener("mousemove",l,!1),a.removeEventListener("mouseup",l,!1))):a.detachEvent&&a.setCapture&&(k=!0,a.detachEvent("onmousedown"),a.detachEvent("onmousemove"),a.detachEvent("onmouseup"))},this}}]).factory("GridsterDraggable",["$document","$window","GridsterTouch",function(b,c,d){function e(e,f,g,h,i){function j(a){e.addClass("gridster-item-moving"),g.movingItem=h,g.updateHeight(h.sizeY),f.$apply(function(){g.draggable&&g.draggable.start&&g.draggable.start(a,e,i)})}function k(a){var b=h.row,d=h.col,j=g.draggable&&g.draggable.drag,k=g.draggable.scrollSensitivity,l=g.draggable.scrollSpeed,m=Math.min(g.pixelsToRows(q),g.maxRows-1),n=Math.min(g.pixelsToColumns(p),g.columns-1),o=g.getItems(m,n,h.sizeX,h.sizeY,h),r=0!==o.length;if(g.swapping===!0&&r){var s=g.getBoundingBox(o),t=s.sizeX===h.sizeX&&s.sizeY===h.sizeY,u=s.row===b,v=s.col===d,w=s.row===m&&s.col===n,x=u||v;if(t&&1===o.length){if(w)g.swapItems(h,o[0]);else if(x)return}else if(s.sizeX<=h.sizeX&&s.sizeY<=h.sizeY&&x)for(var y=h.row<=m?h.row:m+h.sizeY,z=h.col<=n?h.col:n+h.sizeX,A=y-s.row,B=z-s.col,C=0,E=o.length;C<E;++C){var F=o[C],G=g.getItems(F.row+A,F.col+B,F.sizeX,F.sizeY,h);0===G.length&&g.putItem(F,F.row+A,F.col+B)}}g.pushing===!1&&r||(h.row=m,h.col=n),a.pageY-D.body.scrollTop<k?D.body.scrollTop=D.body.scrollTop-l:c.innerHeight-(a.pageY-D.body.scrollTop)<k&&(D.body.scrollTop=D.body.scrollTop+l),a.pageX-D.body.scrollLeft<k?D.body.scrollLeft=D.body.scrollLeft-l:c.innerWidth-(a.pageX-D.body.scrollLeft)<k&&(D.body.scrollLeft=D.body.scrollLeft+l),(j||b!==h.row||d!==h.col)&&f.$apply(function(){j&&g.draggable.drag(a,e,i)})}function l(a){e.removeClass("gridster-item-moving");var b=Math.min(g.pixelsToRows(q),g.maxRows-1),c=Math.min(g.pixelsToColumns(p),g.columns-1);g.pushing===!1&&0!==g.getItems(b,c,h.sizeX,h.sizeY,h).length||(h.row=b,h.col=c),g.movingItem=null,h.setPosition(h.row,h.col),f.$apply(function(){g.draggable&&g.draggable.stop&&g.draggable.stop(a,e,i)})}function m(b){if(E.indexOf(b.target.nodeName.toLowerCase())!==-1)return!1;var c=a.element(b.target);if(c.hasClass("gridster-item-resizable-handler"))return!1;if(c.attr("onclick")||c.attr("ng-click"))return!1;if(c.closest&&c.closest(".gridster-no-drag").length)return!1;if(g.draggable&&g.draggable.handle){var d=a.element(e[0].querySelectorAll(g.draggable.handle)),f=!1;a:for(var i=0,k=d.length;i<k;++i){var l=d[i];if(l===b.target){f=!0;break}for(var m=b.target,n=0;n<20;++n){var o=m.parentNode;if(o===e[0]||!o)break;if(o===l){f=!0;break a}m=o}}if(!f)return!1}switch(b.which){case 1:break;case 2:case 3:return}return x=b.pageX,y=b.pageY,p=parseInt(e.css("left"),10),q=parseInt(e.css("top"),10),r=e[0].offsetWidth,s=e[0].offsetHeight,t=h.col,u=h.row,j(b),!0}function n(a){if(!e.hasClass("gridster-item-moving")||e.hasClass("gridster-item-resizing"))return!1;var b=g.curWidth-1,c=g.curRowHeight*g.maxRows-1;v=a.pageX,w=a.pageY;var d=v-x+z,f=w-y+A;z=A=0,x=v,y=w;var h=d,i=f;return p+h<C?(d=C-p,z=h-d):p+r+h>b&&(d=b-p-r,z=h-d),q+i<B?(f=B-q,A=i-f):q+s+i>c&&(f=c-q-s,A=i-f),p+=d,q+=f,e.css({top:q+"px",left:p+"px"}),k(a),!0}function o(a){return!(!e.hasClass("gridster-item-moving")||e.hasClass("gridster-item-resizing"))&&(z=A=0,l(a),!0)}var p,q,r,s,t,u,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=b[0],E=["select","option","input","textarea","button"],F=null,G=null;this.enable=function(){if(F!==!0){if(F=!0,G)return void G.enable();G=new d(e[0],m,n,o),G.enable()}},this.disable=function(){F!==!1&&(F=!1,G&&G.disable())},this.toggle=function(a){a?this.enable():this.disable()},this.destroy=function(){this.disable()}}return e}]).factory("GridsterResizable",["GridsterTouch",function(b){function c(c,d,e,f,g){function h(h){function i(a){c.addClass("gridster-item-moving"),c.addClass("gridster-item-resizing"),e.movingItem=f,f.setElementSizeX(),f.setElementSizeY(),f.setElementPosition(),e.updateHeight(1),d.$apply(function(){e.resizable&&e.resizable.start&&e.resizable.start(a,c,g)})}function j(a){var b=f.row,i=f.col,j=f.sizeX,k=f.sizeY,l=e.resizable&&e.resizable.resize,m=f.col;["w","nw","sw"].indexOf(h)!==-1&&(m=e.pixelsToColumns(o,!1));var n=f.row;["n","ne","nw"].indexOf(h)!==-1&&(n=e.pixelsToRows(p,!1));var s=f.sizeX;["n","s"].indexOf(h)===-1&&(s=e.pixelsToColumns(q,!0));var t=f.sizeY;["e","w"].indexOf(h)===-1&&(t=e.pixelsToRows(r,!0));var u=n>-1&&m>-1&&s+m<=e.columns&&t+n<=e.maxRows;!u||e.pushing===!1&&0!==e.getItems(n,m,s,t,f).length||(f.row=n,f.col=m,f.sizeX=s,f.sizeY=t);var v=f.row!==b||f.col!==i||f.sizeX!==j||f.sizeY!==k;(l||v)&&d.$apply(function(){l&&e.resizable.resize(a,c,g)})}function k(a){c.removeClass("gridster-item-moving"),c.removeClass("gridster-item-resizing"),e.movingItem=null,f.setPosition(f.row,f.col),f.setSizeY(f.sizeY),f.setSizeX(f.sizeX),d.$apply(function(){e.resizable&&e.resizable.stop&&e.resizable.stop(a,c,g)})}function l(a){switch(a.which){case 1:break;case 2:case 3:return}return u=e.draggable.enabled,u&&(e.draggable.enabled=!1,d.$broadcast("gridster-draggable-changed",e)),z=a.pageX,A=a.pageY,o=parseInt(c.css("left"),10),p=parseInt(c.css("top"),10),q=c[0].offsetWidth,r=c[0].offsetHeight,s=f.sizeX,t=f.sizeY,i(a),!0}function m(a){var b=e.curWidth-1;x=a.pageX,y=a.pageY;var d=x-z+B,f=y-A+C;B=C=0,z=x,A=y;var g=f,h=d;return w.indexOf("n")>=0&&(r-g<G()?(f=r-G(),C=g-f):p+g<D&&(f=D-p,C=g-f),p+=f,r-=f),w.indexOf("s")>=0&&(r+g<G()?(f=G()-r,C=g-f):p+r+g>E&&(f=E-p-r,C=g-f),r+=f),w.indexOf("w")>=0&&(q-h<H()?(d=q-H(),B=h-d):o+h<F&&(d=F-o,B=h-d),o+=d,q-=d),w.indexOf("e")>=0&&(q+h<H()?(d=H()-q,B=h-d):o+q+h>b&&(d=b-o-q,B=h-d),q+=d),c.css({top:p+"px",left:o+"px",width:q+"px",height:r+"px"}),j(a),!0}function n(a){return e.draggable.enabled!==u&&(e.draggable.enabled=u,d.$broadcast("gridster-draggable-changed",e)),B=C=0,k(a),!0}var o,p,q,r,s,t,u,v,w=h,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=9999,F=0,G=function(){return(f.minSizeY?f.minSizeY:1)*e.curRowHeight-e.margins[0]},H=function(){return(f.minSizeX?f.minSizeX:1)*e.curColWidth-e.margins[1]},I=null;this.enable=function(){I||(I=a.element('<div class="gridster-item-resizable-handler handle-'+w+'"></div>'),c.append(I)),v=new b(I[0],l,m,n),v.enable()},this.disable=function(){I&&(I.remove(),I=null),v.disable(),v=void 0},this.destroy=function(){this.disable()}}var i=[],j=e.resizable.handles;"string"==typeof j&&(j=e.resizable.handles.split(","));for(var k=!1,l=0,m=j.length;l<m;l++)i.push(new h(j[l]));this.enable=function(){if(!k){for(var a=0,b=i.length;a<b;a++)i[a].enable();k=!0}},this.disable=function(){if(k){for(var a=0,b=i.length;a<b;a++)i[a].disable();k=!1}},this.toggle=function(a){a?this.enable():this.disable()},this.destroy=function(){for(var a=0,b=i.length;a<b;a++)i[a].destroy()}}return c}]).factory("gridsterDebounce",function(){return function(a,b,c){var d;return function(){var e=this,f=arguments,g=function(){d=null,c||a.apply(e,f)},h=c&&!d;clearTimeout(d),d=setTimeout(g,b),h&&a.apply(e,f)}}}).directive("gridsterItem",["$parse","GridsterDraggable","GridsterResizable","gridsterDebounce",function(a,b,c,d){return{scope:!0,restrict:"EA",controller:"GridsterItemCtrl",controllerAs:"gridsterItem",require:["^gridster","gridsterItem"],link:function(e,f,g,h){function i(){o.setPosition(o.row,o.col),r.row&&r.row.assign&&r.row.assign(e,o.row),r.col&&r.col.assign&&r.col.assign(e,o.col)}function j(){var a=o.setSizeX(o.sizeX,!0);a&&r.sizeX&&r.sizeX.assign&&r.sizeX.assign(e,o.sizeX);var b=o.setSizeY(o.sizeY,!0);b&&r.sizeY&&r.sizeY.assign&&r.sizeY.assign(e,o.sizeY),(a||b)&&(o.gridster.moveOverlappingItems(o),n.layoutChanged(),e.$broadcast("gridster-item-resized",o))}function k(){var a=document.createElement("div"),b={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(var c in b)if(void 0!==a.style[c])return b[c]}var l,m=g.gridsterItem,n=h[0],o=h[1];if(e.gridster=n,m){var p=a(m);l=p(e)||{},!l&&p.assign&&(l={row:o.row,col:o.col,sizeX:o.sizeX,sizeY:o.sizeY,minSizeX:0,minSizeY:0,maxSizeX:null,maxSizeY:null},p.assign(e,l))}else l=g;o.init(f,n),f.addClass("gridster-item");for(var q=["minSizeX","maxSizeX","minSizeY","maxSizeY","sizeX","sizeY","row","col"],r={},s=[],t=function(b){var c;if("string"==typeof l[b])c=l[b];else if("string"==typeof l[b.toLowerCase()])c=l[b.toLowerCase()];else{if(!m)return;c=m+"."+b}s.push('"'+b+'":'+c),r[b]=a(c);var d=r[b](e);"number"==typeof d&&(o[b]=d)},u=0,v=q.length;u<v;++u)t(q[u]);var w="{"+s.join(",")+"}";e.$watchCollection(w,function(a,b){for(var c in a){var d=a[c],e=b[c];e!==d&&(d=parseInt(d,10),isNaN(d)||(o[c]=d))}}),e.$watch(function(){return o.row+","+o.col},i),e.$watch(function(){return o.sizeY+","+o.sizeX+","+o.minSizeX+","+o.maxSizeX+","+o.minSizeY+","+o.maxSizeY},j);var x=new b(f,e,n,o,l),y=new c(f,e,n,o,l),z=function(){y.toggle(!n.isMobile&&n.resizable&&n.resizable.enabled)};z();var A=function(){x.toggle(!n.isMobile&&n.draggable&&n.draggable.enabled)};A(),e.$on("gridster-draggable-changed",A),e.$on("gridster-resizable-changed",z),e.$on("gridster-resized",z),e.$on("gridster-mobile-changed",function(){z(),A()});var B=d(function(){e.$apply(function(){e.$broadcast("gridster-item-transition-end",o)})},50);return f.on(k(),B),e.$broadcast("gridster-item-initialized",o),e.$on("$destroy",function(){try{y.destroy(),x.destroy()}catch(a){}try{n.removeItem(o)}catch(a){}try{o.destroy()}catch(a){}})}}}]).directive("gridsterNoDrag",function(){return{restrict:"A",link:function(a,b){b.addClass("gridster-no-drag")}}})});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! 
	 * angular-hotkeys v1.7.0
	 * https://chieffancypants.github.io/angular-hotkeys
	 * Copyright (c) 2016 Wes Cruver
	 * License: MIT
	 */
	/*
	 * angular-hotkeys
	 *
	 * Automatic keyboard shortcuts for your angular apps
	 *
	 * (c) 2016 Wes Cruver
	 * License: MIT
	 */
	
	(function() {
	
	  'use strict';
	
	  angular.module('cfp.hotkeys', []).provider('hotkeys', ['$injector', function($injector) {
	
	    /**
	     * Configurable setting to disable the cheatsheet entirely
	     * @type {Boolean}
	     */
	    this.includeCheatSheet = true;
	
	    /**
	     * Configurable setting to disable ngRoute hooks
	     * @type {Boolean}
	     */
	    this.useNgRoute = $injector.has('ngViewDirective');
	
	    /**
	     * Configurable setting for the cheat sheet title
	     * @type {String}
	     */
	
	    this.templateTitle = 'Keyboard Shortcuts:';
	
	    /**
	     * Configurable settings for the cheat sheet header and footer.  Both are HTML, and the header
	     * overrides the normal title if specified.
	     * @type {String}
	     */
	    this.templateHeader = null;
	    this.templateFooter = null;
	
	    /**
	     * Cheat sheet template in the event you want to totally customize it.
	     * @type {String}
	     */
	    this.template = '<div class="cfp-hotkeys-container fade" ng-class="{in: helpVisible}" style="display: none;"><div class="cfp-hotkeys">' +
	                      '<h4 class="cfp-hotkeys-title" ng-if="!header">{{ title }}</h4>' +
	                      '<div ng-bind-html="header" ng-if="header"></div>' +
	                      '<table><tbody>' +
	                        '<tr ng-repeat="hotkey in hotkeys | filter:{ description: \'!$$undefined$$\' }">' +
	                          '<td class="cfp-hotkeys-keys">' +
	                            '<span ng-repeat="key in hotkey.format() track by $index" class="cfp-hotkeys-key">{{ key }}</span>' +
	                          '</td>' +
	                          '<td class="cfp-hotkeys-text">{{ hotkey.description }}</td>' +
	                        '</tr>' +
	                      '</tbody></table>' +
	                      '<div ng-bind-html="footer" ng-if="footer"></div>' +
	                      '<div class="cfp-hotkeys-close" ng-click="toggleCheatSheet()">&#215;</div>' +
	                    '</div></div>';
	
	    /**
	     * Configurable setting for the cheat sheet hotkey
	     * @type {String}
	     */
	    this.cheatSheetHotkey = '?';
	
	    /**
	     * Configurable setting for the cheat sheet description
	     * @type {String}
	     */
	    this.cheatSheetDescription = 'Show / hide this help menu';
	
	    this.$get = ['$rootElement', '$rootScope', '$compile', '$window', '$document', function ($rootElement, $rootScope, $compile, $window, $document) {
	
	      var mouseTrapEnabled = true;
	
	      function pause() {
	        mouseTrapEnabled = false;
	      }
	
	      function unpause() {
	        mouseTrapEnabled = true;
	      }
	
	      // monkeypatch Mousetrap's stopCallback() function
	      // this version doesn't return true when the element is an INPUT, SELECT, or TEXTAREA
	      // (instead we will perform this check per-key in the _add() method)
	      Mousetrap.prototype.stopCallback = function(event, element) {
	        if (!mouseTrapEnabled) {
	          return true;
	        }
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	          return false;
	        }
	
	        return (element.contentEditable && element.contentEditable == 'true');
	      };
	
	      /**
	       * Convert strings like cmd into symbols like ⌘
	       * @param  {String} combo Key combination, e.g. 'mod+f'
	       * @return {String}       The key combination with symbols
	       */
	      function symbolize (combo) {
	        var map = {
	          command   : '\u2318',     // ⌘
	          shift     : '\u21E7',     // ⇧
	          left      : '\u2190',     // ←
	          right     : '\u2192',     // →
	          up        : '\u2191',     // ↑
	          down      : '\u2193',     // ↓
	          'return'  : '\u23CE',     // ⏎
	          backspace : '\u232B'      // ⌫
	        };
	        combo = combo.split('+');
	
	        for (var i = 0; i < combo.length; i++) {
	          // try to resolve command / ctrl based on OS:
	          if (combo[i] === 'mod') {
	            if ($window.navigator && $window.navigator.platform.indexOf('Mac') >=0 ) {
	              combo[i] = 'command';
	            } else {
	              combo[i] = 'ctrl';
	            }
	          }
	
	          combo[i] = map[combo[i]] || combo[i];
	        }
	
	        return combo.join(' + ');
	      }
	
	      /**
	       * Hotkey object used internally for consistency
	       *
	       * @param {array}    combo       The keycombo. it's an array to support multiple combos
	       * @param {String}   description Description for the keycombo
	       * @param {Function} callback    function to execute when keycombo pressed
	       * @param {string}   action      the type of event to listen for (for mousetrap)
	       * @param {array}    allowIn     an array of tag names to allow this combo in ('INPUT', 'SELECT', and/or 'TEXTAREA')
	       * @param {Boolean}  persistent  Whether the hotkey persists navigation events
	       */
	      function Hotkey (combo, description, callback, action, allowIn, persistent) {
	        // TODO: Check that the values are sane because we could
	        // be trying to instantiate a new Hotkey with outside dev's
	        // supplied values
	
	        this.combo = combo instanceof Array ? combo : [combo];
	        this.description = description;
	        this.callback = callback;
	        this.action = action;
	        this.allowIn = allowIn;
	        this.persistent = persistent;
	        this._formated = null;
	      }
	
	      /**
	       * Helper method to format (symbolize) the key combo for display
	       *
	       * @return {[Array]} An array of the key combination sequence
	       *   for example: "command+g c i" becomes ["⌘ + g", "c", "i"]
	       *
	       */
	      Hotkey.prototype.format = function() {
	        if (this._formated === null) {
	          // Don't show all the possible key combos, just the first one.  Not sure
	          // of usecase here, so open a ticket if my assumptions are wrong
	          var combo = this.combo[0];
	
	          var sequence = combo.split(/[\s]/);
	          for (var i = 0; i < sequence.length; i++) {
	            sequence[i] = symbolize(sequence[i]);
	          }
	          this._formated = sequence;
	        }
	
	        return this._formated;
	      };
	
	      /**
	       * A new scope used internally for the cheatsheet
	       * @type {$rootScope.Scope}
	       */
	      var scope = $rootScope.$new();
	
	      /**
	       * Holds an array of Hotkey objects currently bound
	       * @type {Array}
	       */
	      scope.hotkeys = [];
	
	      /**
	       * Contains the state of the help's visibility
	       * @type {Boolean}
	       */
	      scope.helpVisible = false;
	
	      /**
	       * Holds the title string for the help menu
	       * @type {String}
	       */
	      scope.title = this.templateTitle;
	
	      /**
	       * Holds the header HTML for the help menu
	       * @type {String}
	       */
	      scope.header = this.templateHeader;
	
	      /**
	       * Holds the footer HTML for the help menu
	       * @type {String}
	       */
	      scope.footer = this.templateFooter;
	
	      /**
	       * Expose toggleCheatSheet to hotkeys scope so we can call it using
	       * ng-click from the template
	       * @type {function}
	       */
	      scope.toggleCheatSheet = toggleCheatSheet;
	
	
	      /**
	       * Holds references to the different scopes that have bound hotkeys
	       * attached.  This is useful to catch when the scopes are `$destroy`d and
	       * then automatically unbind the hotkey.
	       *
	       * @type {Object}
	       */
	      var boundScopes = {};
	
	      if (this.useNgRoute) {
	        $rootScope.$on('$routeChangeSuccess', function (event, route) {
	          purgeHotkeys();
	
	          if (route && route.hotkeys) {
	            angular.forEach(route.hotkeys, function (hotkey) {
	              // a string was given, which implies this is a function that is to be
	              // $eval()'d within that controller's scope
	              // TODO: hotkey here is super confusing.  sometimes a function (that gets turned into an array), sometimes a string
	              var callback = hotkey[2];
	              if (typeof(callback) === 'string' || callback instanceof String) {
	                hotkey[2] = [callback, route];
	              }
	
	              // todo: perform check to make sure not already defined:
	              // this came from a route, so it's likely not meant to be persistent
	              hotkey[5] = false;
	              _add.apply(this, hotkey);
	            });
	          }
	        });
	      }
	
	
	
	      // Auto-create a help menu:
	      if (this.includeCheatSheet) {
	        var document = $document[0];
	        var element = $rootElement[0];
	        var helpMenu = angular.element(this.template);
	        _add(this.cheatSheetHotkey, this.cheatSheetDescription, toggleCheatSheet);
	
	        // If $rootElement is document or documentElement, then body must be used
	        if (element === document || element === document.documentElement) {
	          element = document.body;
	        }
	
	        angular.element(element).append($compile(helpMenu)(scope));
	      }
	
	
	      /**
	       * Purges all non-persistent hotkeys (such as those defined in routes)
	       *
	       * Without this, the same hotkey would get recreated everytime
	       * the route is accessed.
	       */
	      function purgeHotkeys() {
	        var i = scope.hotkeys.length;
	        while (i--) {
	          var hotkey = scope.hotkeys[i];
	          if (hotkey && !hotkey.persistent) {
	            _del(hotkey);
	          }
	        }
	      }
	
	      /**
	       * Toggles the help menu element's visiblity
	       */
	      var previousEsc = false;
	
	      function toggleCheatSheet() {
	        scope.helpVisible = !scope.helpVisible;
	
	        // Bind to esc to remove the cheat sheet.  Ideally, this would be done
	        // as a directive in the template, but that would create a nasty
	        // circular dependency issue that I don't feel like sorting out.
	        if (scope.helpVisible) {
	          previousEsc = _get('esc');
	          _del('esc');
	
	          // Here's an odd way to do this: we're going to use the original
	          // description of the hotkey on the cheat sheet so that it shows up.
	          // without it, no entry for esc will ever show up (#22)
	          _add('esc', previousEsc.description, toggleCheatSheet, null, ['INPUT', 'SELECT', 'TEXTAREA']);
	        } else {
	          _del('esc');
	
	          // restore the previously bound ESC key
	          if (previousEsc !== false) {
	            _add(previousEsc);
	          }
	        }
	      }
	
	      /**
	       * Creates a new Hotkey and creates the Mousetrap binding
	       *
	       * @param {string}   combo       mousetrap key binding
	       * @param {string}   description description for the help menu
	       * @param {Function} callback    method to call when key is pressed
	       * @param {string}   action      the type of event to listen for (for mousetrap)
	       * @param {array}    allowIn     an array of tag names to allow this combo in ('INPUT', 'SELECT', and/or 'TEXTAREA')
	       * @param {boolean}  persistent  if true, the binding is preserved upon route changes
	       */
	      function _add (combo, description, callback, action, allowIn, persistent) {
	
	        // used to save original callback for "allowIn" wrapping:
	        var _callback;
	
	        // these elements are prevented by the default Mousetrap.stopCallback():
	        var preventIn = ['INPUT', 'SELECT', 'TEXTAREA'];
	
	        // Determine if object format was given:
	        var objType = Object.prototype.toString.call(combo);
	
	        if (objType === '[object Object]') {
	          description = combo.description;
	          callback    = combo.callback;
	          action      = combo.action;
	          persistent  = combo.persistent;
	          allowIn     = combo.allowIn;
	          combo       = combo.combo;
	        }
	
	        // no duplicates please
	        _del(combo);
	
	        // description is optional:
	        if (description instanceof Function) {
	          action = callback;
	          callback = description;
	          description = '$$undefined$$';
	        } else if (angular.isUndefined(description)) {
	          description = '$$undefined$$';
	        }
	
	        // any items added through the public API are for controllers
	        // that persist through navigation, and thus undefined should mean
	        // true in this case.
	        if (persistent === undefined) {
	          persistent = true;
	        }
	        // if callback is defined, then wrap it in a function
	        // that checks if the event originated from a form element.
	        // the function blocks the callback from executing unless the element is specified
	        // in allowIn (emulates Mousetrap.stopCallback() on a per-key level)
	        if (typeof callback === 'function') {
	
	          // save the original callback
	          _callback = callback;
	
	          // make sure allowIn is an array
	          if (!(allowIn instanceof Array)) {
	            allowIn = [];
	          }
	
	          // remove anything from preventIn that's present in allowIn
	          var index;
	          for (var i=0; i < allowIn.length; i++) {
	            allowIn[i] = allowIn[i].toUpperCase();
	            index = preventIn.indexOf(allowIn[i]);
	            if (index !== -1) {
	              preventIn.splice(index, 1);
	            }
	          }
	
	          // create the new wrapper callback
	          callback = function(event) {
	            var shouldExecute = true;
	
	            // if the callback is executed directly `hotkey.get('w').callback()`
	            // there will be no event, so just execute the callback.
	            if (event) {
	              var target = event.target || event.srcElement; // srcElement is IE only
	              var nodeName = target.nodeName.toUpperCase();
	
	              // check if the input has a mousetrap class, and skip checking preventIn if so
	              if ((' ' + target.className + ' ').indexOf(' mousetrap ') > -1) {
	                shouldExecute = true;
	              } else {
	                // don't execute callback if the event was fired from inside an element listed in preventIn
	                for (var i=0; i<preventIn.length; i++) {
	                  if (preventIn[i] === nodeName) {
	                    shouldExecute = false;
	                    break;
	                  }
	                }
	              }
	            }
	
	            if (shouldExecute) {
	              wrapApply(_callback.apply(this, arguments));
	            }
	          };
	        }
	
	        if (typeof(action) === 'string') {
	          Mousetrap.bind(combo, wrapApply(callback), action);
	        } else {
	          Mousetrap.bind(combo, wrapApply(callback));
	        }
	
	        var hotkey = new Hotkey(combo, description, callback, action, allowIn, persistent);
	        scope.hotkeys.push(hotkey);
	        return hotkey;
	      }
	
	      /**
	       * delete and unbind a Hotkey
	       *
	       * @param  {mixed} hotkey   Either the bound key or an instance of Hotkey
	       * @return {boolean}        true if successful
	       */
	      function _del (hotkey) {
	        var combo = (hotkey instanceof Hotkey) ? hotkey.combo : hotkey;
	
	        Mousetrap.unbind(combo);
	
	        if (angular.isArray(combo)) {
	          var retStatus = true;
	          var i = combo.length;
	          while (i--) {
	            retStatus = _del(combo[i]) && retStatus;
	          }
	          return retStatus;
	        } else {
	          var index = scope.hotkeys.indexOf(_get(combo));
	
	          if (index > -1) {
	            // if the combo has other combos bound, don't unbind the whole thing, just the one combo:
	            if (scope.hotkeys[index].combo.length > 1) {
	              scope.hotkeys[index].combo.splice(scope.hotkeys[index].combo.indexOf(combo), 1);
	            } else {
	
	              // remove hotkey from bound scopes
	              angular.forEach(boundScopes, function (boundScope) {
	                var scopeIndex = boundScope.indexOf(scope.hotkeys[index]);
	                if (scopeIndex !== -1) {
	                    boundScope.splice(scopeIndex, 1);
	                }
	              });
	
	              scope.hotkeys.splice(index, 1);
	            }
	            return true;
	          }
	        }
	
	        return false;
	
	      }
	
	      /**
	       * Get a Hotkey object by key binding
	       *
	       * @param  {[string]} [combo]  the key the Hotkey is bound to. Returns all key bindings if no key is passed
	       * @return {Hotkey}          The Hotkey object
	       */
	      function _get (combo) {
	
	        if (!combo) {
	          return scope.hotkeys;
	        }
	
	        var hotkey;
	
	        for (var i = 0; i < scope.hotkeys.length; i++) {
	          hotkey = scope.hotkeys[i];
	
	          if (hotkey.combo.indexOf(combo) > -1) {
	            return hotkey;
	          }
	        }
	
	        return false;
	      }
	
	      /**
	       * Binds the hotkey to a particular scope.  Useful if the scope is
	       * destroyed, we can automatically destroy the hotkey binding.
	       *
	       * @param  {Object} scope The scope to bind to
	       */
	      function bindTo (scope) {
	        // Only initialize once to allow multiple calls for same scope.
	        if (!(scope.$id in boundScopes)) {
	
	          // Add the scope to the list of bound scopes
	          boundScopes[scope.$id] = [];
	
	          scope.$on('$destroy', function () {
	            var i = boundScopes[scope.$id].length;
	            while (i--) {
	              _del(boundScopes[scope.$id].pop());
	            }
	          });
	        }
	        // return an object with an add function so we can keep track of the
	        // hotkeys and their scope that we added via this chaining method
	        return {
	          add: function (args) {
	            var hotkey;
	
	            if (arguments.length > 1) {
	              hotkey = _add.apply(this, arguments);
	            } else {
	              hotkey = _add(args);
	            }
	
	            boundScopes[scope.$id].push(hotkey);
	            return this;
	          }
	        };
	      }
	
	      /**
	       * All callbacks sent to Mousetrap are wrapped using this function
	       * so that we can force a $scope.$apply()
	       *
	       * @param  {Function} callback [description]
	       * @return {[type]}            [description]
	       */
	      function wrapApply (callback) {
	        // return mousetrap a function to call
	        return function (event, combo) {
	
	          // if this is an array, it means we provided a route object
	          // because the scope wasn't available yet, so rewrap the callback
	          // now that the scope is available:
	          if (callback instanceof Array) {
	            var funcString = callback[0];
	            var route = callback[1];
	            callback = function (event) {
	              route.scope.$eval(funcString);
	            };
	          }
	
	          // this takes place outside angular, so we'll have to call
	          // $apply() to make sure angular's digest happens
	          $rootScope.$apply(function() {
	            // call the original hotkey callback with the keyboard event
	            callback(event, _get(combo));
	          });
	        };
	      }
	
	      var publicApi = {
	        add                   : _add,
	        del                   : _del,
	        get                   : _get,
	        bindTo                : bindTo,
	        template              : this.template,
	        toggleCheatSheet      : toggleCheatSheet,
	        includeCheatSheet     : this.includeCheatSheet,
	        cheatSheetHotkey      : this.cheatSheetHotkey,
	        cheatSheetDescription : this.cheatSheetDescription,
	        useNgRoute            : this.useNgRoute,
	        purgeHotkeys          : purgeHotkeys,
	        templateTitle         : this.templateTitle,
	        pause                 : pause,
	        unpause               : unpause
	      };
	
	      return publicApi;
	
	    }];
	
	
	  }])
	
	  .directive('hotkey', ['hotkeys', function (hotkeys) {
	    return {
	      restrict: 'A',
	      link: function (scope, el, attrs) {
	        var keys = [],
	            allowIn;
	
	        angular.forEach(scope.$eval(attrs.hotkey), function (func, hotkey) {
	          // split and trim the hotkeys string into array
	          allowIn = typeof attrs.hotkeyAllowIn === "string" ? attrs.hotkeyAllowIn.split(/[\s,]+/) : [];
	
	          keys.push(hotkey);
	
	          hotkeys.add({
	            combo: hotkey,
	            description: attrs.hotkeyDescription,
	            callback: func,
	            action: attrs.hotkeyAction,
	            allowIn: allowIn
	          });
	        });
	
	        // remove the hotkey if the directive is destroyed:
	        el.bind('$destroy', function() {
	          angular.forEach(keys, hotkeys.del);
	        });
	      }
	    };
	  }])
	
	  .run(['hotkeys', function(hotkeys) {
	    // force hotkeys to run by injecting it. Without this, hotkeys only runs
	    // when a controller or something else asks for it via DI.
	  }]);
	
	})();
	
	/*global define:false */
	/**
	 * Copyright 2015 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.5.2
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	        _MAP[i + 96] = i;
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (window, document);


/***/ }),
/* 599 */
/***/ (function(module, exports) {

	(function() {
	
	
	// Create all modules and define dependencies to make sure they exist
	// and are loaded in the correct order to satisfy dependency injection
	// before all nested files are concatenated by Grunt
	
	// Modules
	angular.module('angular-jwt',
	    [
	        'angular-jwt.options',
	        'angular-jwt.interceptor',
	        'angular-jwt.jwt',
	        'angular-jwt.authManager'
	    ]);
	
	angular.module('angular-jwt.authManager', [])
	  .provider('authManager', function () {
	
	    this.$get = ["$rootScope", "$injector", "$location", "jwtHelper", "jwtInterceptor", "jwtOptions", function ($rootScope, $injector, $location, jwtHelper, jwtInterceptor, jwtOptions) {
	
	      var config = jwtOptions.getConfig();
	
	      function invokeToken(tokenGetter) {
	        var token = null;
	        if (Array.isArray(tokenGetter)) {
	          token = $injector.invoke(tokenGetter, this, {options: null});
	        } else {
	          token = tokenGetter();
	        }
	        return token;
	      }
	
	      function invokeRedirector(redirector) {
	        if (Array.isArray(redirector) || angular.isFunction(redirector)) {
	          return $injector.invoke(redirector, config, {});
	        } else {
	          throw new Error('unauthenticatedRedirector must be a function');
	        }
	      }
	
	      function isAuthenticated() {
	        var token = invokeToken(config.tokenGetter);
	        if (token) {
	          return !jwtHelper.isTokenExpired(token);
	        }
	      }
	
	      $rootScope.isAuthenticated = false;
	
	      function authenticate() {
	        $rootScope.isAuthenticated = true;
	      }
	
	      function unauthenticate() {
	        $rootScope.isAuthenticated = false;
	      }
	
	      function validateToken() {
	        var token = invokeToken(config.tokenGetter);
	        if (token) {
	          if (!jwtHelper.isTokenExpired(token)) {
	            authenticate();
	          } else {
	            $rootScope.$broadcast('tokenHasExpired', token);
	          }
	        }
	      }
	
	      function checkAuthOnRefresh() {
	        if ($injector.has('$transitions')) {
	          var $transitions = $injector.get('$transitions');
	          $transitions.onStart({}, validateToken);
	        } else {
	          $rootScope.$on('$locationChangeStart', validateToken);
	        }
	      }
	
	      function redirectWhenUnauthenticated() {
	        $rootScope.$on('unauthenticated', function () {
	          invokeRedirector(config.unauthenticatedRedirector);
	          unauthenticate();
	        });
	      }
	
	      function verifyRoute(event, next) {
	        if (!next) {
	          return false;
	        }
	
	        var routeData = (next.$$route) ? next.$$route : next.data;
	
	        if (routeData && routeData.requiresLogin === true && !isAuthenticated()) {
	          event.preventDefault();
	          invokeRedirector(config.unauthenticatedRedirector);
	        }
	      }
	
	      function verifyState(transition) {
	        var route = transition.to();
	        var $state = transition.router.stateService;
	          if (route && route.data && route.data.requiresLogin === true && !isAuthenticated()) {
	            return $state.target(config.loginPath);
	          }
	      }
	
	      if ($injector.has('$transitions')) {
	        var $transitions = $injector.get('$transitions');
	        $transitions.onStart({}, verifyState);
	      } else {
	        var eventName = ($injector.has('$state')) ? '$stateChangeStart' : '$routeChangeStart';
	        $rootScope.$on(eventName, verifyRoute);
	      }
	
	
	
	      return {
	        authenticate: authenticate,
	        unauthenticate: unauthenticate,
	        getToken: function(){ return invokeToken(config.tokenGetter); },
	        redirect: function() { return invokeRedirector(config.unauthenticatedRedirector); },
	        checkAuthOnRefresh: checkAuthOnRefresh,
	        redirectWhenUnauthenticated: redirectWhenUnauthenticated,
	        isAuthenticated: isAuthenticated
	      }
	    }]
	  });
	
	angular.module('angular-jwt.interceptor', [])
	  .provider('jwtInterceptor', function() {
	
	    this.urlParam;
	    this.authHeader;
	    this.authPrefix;
	    this.whiteListedDomains;
	    this.tokenGetter;
	
	    var config = this;
	
	    this.$get = ["$q", "$injector", "$rootScope", "urlUtils", "jwtOptions", function($q, $injector, $rootScope, urlUtils, jwtOptions) {
	
	      var options = angular.extend({}, jwtOptions.getConfig(), config);
	
	      function isSafe (url) {
	        if (!urlUtils.isSameOrigin(url) && !options.whiteListedDomains.length) {
	          throw new Error('As of v0.1.0, requests to domains other than the application\'s origin must be white listed. Use jwtOptionsProvider.config({ whiteListedDomains: [<domain>] }); to whitelist.')
	        }
	        var hostname = urlUtils.urlResolve(url).hostname.toLowerCase();
	        for (var i = 0; i < options.whiteListedDomains.length; i++) {
	          var domain = options.whiteListedDomains[i];
	          if (domain instanceof RegExp) {
	            if (hostname.match(domain)) {
	              return true;
	            }
	          } else {
	            if (hostname === domain.toLowerCase()) {
	              return true;
	            }
	          }
	        }
	
	        if (urlUtils.isSameOrigin(url)) {
	          return true;
	        }
	
	        return false;
	      }
	
	      return {
	        request: function (request) {
	          if (request.skipAuthorization || !isSafe(request.url)) {
	            return request;
	          }
	
	          if (options.urlParam) {
	            request.params = request.params || {};
	            // Already has the token in the url itself
	            if (request.params[options.urlParam]) {
	              return request;
	            }
	          } else {
	            request.headers = request.headers || {};
	            // Already has an Authorization header
	            if (request.headers[options.authHeader]) {
	              return request;
	            }
	          }
	
	          var tokenPromise = $q.when($injector.invoke(options.tokenGetter, this, {
	            options: request
	          }));
	
	          return tokenPromise.then(function(token) {
	            if (token) {
	              if (options.urlParam) {
	                request.params[options.urlParam] = token;
	              } else {
	                request.headers[options.authHeader] = options.authPrefix + token;
	              }
	            }
	            return request;
	          });
	        },
	        responseError: function (response) {
	          // handle the case where the user is not authenticated
	          if (response.status === 401) {
	            $rootScope.$broadcast('unauthenticated', response);
	          }
	          return $q.reject(response);
	        }
	      };
	    }]
	  });
	
	 angular.module('angular-jwt.jwt', [])
	  .service('jwtHelper', ["$window", function($window) {
	
	    this.urlBase64Decode = function(str) {
	      var output = str.replace(/-/g, '+').replace(/_/g, '/');
	      switch (output.length % 4) {
	        case 0: { break; }
	        case 2: { output += '=='; break; }
	        case 3: { output += '='; break; }
	        default: {
	          throw 'Illegal base64url string!';
	        }
	      }
	      return $window.decodeURIComponent(escape($window.atob(output))); //polyfill https://github.com/davidchambers/Base64.js
	    };
	
	
	    this.decodeToken = function(token) {
	      var parts = token.split('.');
	
	      if (parts.length !== 3) {
	        throw new Error('JWT must have 3 parts');
	      }
	
	      var decoded = this.urlBase64Decode(parts[1]);
	      if (!decoded) {
	        throw new Error('Cannot decode the token');
	      }
	
	      return angular.fromJson(decoded);
	    };
	
	    this.getTokenExpirationDate = function(token) {
	      var decoded = this.decodeToken(token);
	
	      if(typeof decoded.exp === "undefined") {
	        return null;
	      }
	
	      var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
	      d.setUTCSeconds(decoded.exp);
	
	      return d;
	    };
	
	    this.isTokenExpired = function(token, offsetSeconds) {
	      var d = this.getTokenExpirationDate(token);
	      offsetSeconds = offsetSeconds || 0;
	      if (d === null) {
	        return false;
	      }
	
	      // Token expired?
	      return !(d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
	    };
	  }]);
	
	angular.module('angular-jwt.options', [])
	  .provider('jwtOptions', function() {
	    var globalConfig = {};
	    this.config = function(value) {
	      globalConfig = value;
	    };
	    this.$get = function() {
	
	      var options = {
	        urlParam: null,
	        authHeader: 'Authorization',
	        authPrefix: 'Bearer ',
	        whiteListedDomains: [],
	        tokenGetter: function() {
	          return null;
	        },
	        loginPath: '/',
	        unauthenticatedRedirectPath: '/',
	        unauthenticatedRedirector: ['$location', function($location) {
	          $location.path(this.unauthenticatedRedirectPath);
	        }]
	      };
	
	      function JwtOptions() {
	        var config = this.config = angular.extend({}, options, globalConfig);
	      }
	
	      JwtOptions.prototype.getConfig = function() {
	        return this.config;
	      };
	
	      return new JwtOptions();
	    }
	  });
	
	 /**
	  * The content from this file was directly lifted from Angular. It is
	  * unfortunately not a public API, so the best we can do is copy it.
	  *
	  * Angular References:
	  *   https://github.com/angular/angular.js/issues/3299
	  *   https://github.com/angular/angular.js/blob/d077966ff1ac18262f4615ff1a533db24d4432a7/src/ng/urlUtils.js
	  */
	
	 angular.module('angular-jwt.interceptor')
	  .service('urlUtils', function () {
	
	    // NOTE:  The usage of window and document instead of $window and $document here is
	    // deliberate.  This service depends on the specific behavior of anchor nodes created by the
	    // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	    // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	    // doesn't know about mocked locations and resolves URLs to the real document - which is
	    // exactly the behavior needed here.  There is little value is mocking these out for this
	    // service.
	    var urlParsingNode = document.createElement("a");
	    var originUrl = urlResolve(window.location.href);
	
	    /**
	     *
	     * Implementation Notes for non-IE browsers
	     * ----------------------------------------
	     * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	     * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	     * URL will be resolved into an absolute URL in the context of the application document.
	     * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	     * properties are all populated to reflect the normalized URL.  This approach has wide
	     * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	     * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	     *
	     * Implementation Notes for IE
	     * ---------------------------
	     * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	     * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	     * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	     * work around that by performing the parsing in a 2nd step by taking a previously normalized
	     * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	     * properties such as protocol, hostname, port, etc.
	     *
	     * References:
	     *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	     *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	     *   http://url.spec.whatwg.org/#urlutils
	     *   https://github.com/angular/angular.js/pull/2902
	     *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	     *
	     * @kind function
	     * @param {string} url The URL to be parsed.
	     * @description Normalizes and parses a URL.
	     * @returns {object} Returns the normalized URL as a dictionary.
	     *
	     *   | member name   | Description    |
	     *   |---------------|----------------|
	     *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	     *   | protocol      | The protocol including the trailing colon                              |
	     *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	     *   | search        | The search params, minus the question mark                             |
	     *   | hash          | The hash string, minus the hash symbol
	     *   | hostname      | The hostname
	     *   | port          | The port, without ":"
	     *   | pathname      | The pathname, beginning with "/"
	     *
	     */
	    function urlResolve(url) {
	      var href = url;
	
	      // Normalize before parse.  Refer Implementation Notes on why this is
	      // done in two steps on IE.
	      urlParsingNode.setAttribute("href", href);
	      href = urlParsingNode.href;
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/')
	          ? urlParsingNode.pathname
	          : '/' + urlParsingNode.pathname
	      };
	    }
	
	    /**
	     * Parse a request URL and determine whether this is a same-origin request as the application document.
	     *
	     * @param {string|object} requestUrl The url of the request as a string that will be resolved
	     * or a parsed URL object.
	     * @returns {boolean} Whether the request is for the same origin as the application document.
	     */
	    function urlIsSameOrigin(requestUrl) {
	      var parsed = (angular.isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	      return (parsed.protocol === originUrl.protocol &&
	              parsed.host === originUrl.host);
	    }
	
	    return {
	      urlResolve: urlResolve,
	      isSameOrigin: urlIsSameOrigin
	    };
	
	  });
	
	}());

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(599);
	module.exports = 'angular-jwt';
	


/***/ }),
/* 601 */
/***/ (function(module, exports) {

	/*
	 * Angular Material Data Table
	 * https://github.com/daniel-nagy/md-data-table
	 * @license MIT
	 * v0.10.9
	 */
	(function (window, angular, undefined) {
	'use strict';
	
	angular.module('md.table.templates', ['md-table-pagination.html', 'md-table-progress.html', 'arrow-up.svg', 'navigate-before.svg', 'navigate-first.svg', 'navigate-last.svg', 'navigate-next.svg']);
	
	angular.module('md-table-pagination.html', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('md-table-pagination.html',
	    '<div class="page-select" ng-if="$pagination.showPageSelect()">\n' +
	    '  <div class="label">{{$pagination.label.page}}</div>\n' +
	    '\n' +
	    '  <md-select virtual-page-select total="{{$pagination.pages()}}" class="md-table-select" ng-model="$pagination.page" md-container-class="md-pagination-select" ng-change="$pagination.onPaginationChange()" ng-disabled="$pagination.disabled" aria-label="Page">\n' +
	    '    <md-content>\n' +
	    '      <md-option ng-repeat="page in $pageSelect.pages" ng-value="page">{{page}}</md-option>\n' +
	    '    </md-content>\n' +
	    '  </md-select>\n' +
	    '</div>\n' +
	    '\n' +
	    '<div class="limit-select" ng-if="$pagination.limitOptions">\n' +
	    '  <div class="label">{{$pagination.label.rowsPerPage}}</div>\n' +
	    '\n' +
	    '  <md-select class="md-table-select" ng-model="$pagination.limit" md-container-class="md-pagination-select" ng-disabled="$pagination.disabled" aria-label="Linhas" placeholder="{{ $pagination.limitOptions[0] }}">\n' +
	    '    <md-option ng-repeat="option in $pagination.limitOptions" ng-value="option.value ? $pagination.eval(option.value) : option">{{::option.label ? option.label : option}}</md-option>\n' +
	    '  </md-select>\n' +
	    '</div>\n' +
	    '\n' +
	    '<div class="buttons">\n' +
	    '  <div class="label">{{$pagination.min()}} - {{$pagination.max()}} {{$pagination.label.of}} {{$pagination.total}}</div>\n' +
	    '\n' +
	    '  <md-button class="md-icon-button" type="button" ng-if="$pagination.showBoundaryLinks()" ng-click="$pagination.first()" ng-disabled="$pagination.disabled || !$pagination.hasPrevious()" aria-label="First">\n' +
	    '    <md-icon md-svg-icon="navigate-first.svg"></md-icon>\n' +
	    '  </md-button>\n' +
	    '\n' +
	    '  <md-button class="md-icon-button" type="button" ng-click="$pagination.previous()" ng-disabled="$pagination.disabled || !$pagination.hasPrevious()" aria-label="Previous">\n' +
	    '    <md-icon md-svg-icon="navigate-before.svg"></md-icon>\n' +
	    '  </md-button>\n' +
	    '\n' +
	    '  <md-button class="md-icon-button" type="button" ng-click="$pagination.next()" ng-disabled="$pagination.disabled || !$pagination.hasNext()" aria-label="Next">\n' +
	    '    <md-icon md-svg-icon="navigate-next.svg"></md-icon>\n' +
	    '  </md-button>\n' +
	    '\n' +
	    '  <md-button class="md-icon-button" type="button" ng-if="$pagination.showBoundaryLinks()" ng-click="$pagination.last()" ng-disabled="$pagination.disabled || !$pagination.hasNext()" aria-label="Last">\n' +
	    '    <md-icon md-svg-icon="navigate-last.svg"></md-icon>\n' +
	    '  </md-button>\n' +
	    '</div>');
	}]);
	
	angular.module('md-table-progress.html', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('md-table-progress.html',
	    '<tr>\n' +
	    '  <th colspan="{{columnCount()}}">\n' +
	    '    <md-progress-linear ng-show="deferred()" md-mode="indeterminate"></md-progress-linear>\n' +
	    '  </th>\n' +
	    '</tr>');
	}]);
	
	angular.module('arrow-up.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('arrow-up.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>');
	}]);
	
	angular.module('navigate-before.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('navigate-before.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>');
	}]);
	
	angular.module('navigate-first.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('navigate-first.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 6 v12 h2 v-12 h-2z M17.41 7.41L16 6l-6 6 6 6 1.41-1.41L12.83 12z"/></svg>');
	}]);
	
	angular.module('navigate-last.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('navigate-last.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 6 v12 h2 v-12 h-2z M8 6L6.59 7.41 11.17 12l-4.58 4.59L8 18l6-6z"/></svg>');
	}]);
	
	angular.module('navigate-next.svg', []).run(['$templateCache', function($templateCache) {
	  $templateCache.put('navigate-next.svg',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>');
	}]);
	
	
	angular.module('md.data.table', ['md.table.templates']);
	
	angular.module('md.data.table').directive('mdBody', mdBody);
	
	function mdBody() {
	
	  function compile(tElement) {
	    tElement.addClass('md-body');
	  }
	
	  return {
	    compile: compile,
	    restrict: 'A'
	  };
	}
	
	angular.module('md.data.table').directive('mdCell', mdCell);
	
	function mdCell() {
	  
	  function compile(tElement) {
	    var select = tElement.find('md-select');
	    
	    if(select.length) {
	      select.addClass('md-table-select').attr('md-container-class', 'md-table-select');
	    }
	    
	    tElement.addClass('md-cell');
	    
	    return postLink;
	  }
	  
	  // empty controller to be bind properties to in postLink function
	  function Controller() {
	    
	  }
	  
	  function postLink(scope, element, attrs, ctrls) {
	    var select = element.find('md-select');
	    var cellCtrl = ctrls.shift();
	    var tableCtrl = ctrls.shift();
	    
	    if(attrs.ngClick) {
	      element.addClass('md-clickable');
	    }
	    
	    if(select.length) {
	      select.on('click', function (event) {
	        event.stopPropagation();
	      });
	      
	      element.addClass('md-clickable').on('click', function (event) {
	        event.stopPropagation();
	        select[0].click();
	      });
	    }
	    
	    cellCtrl.getTable = tableCtrl.getElement;
	    
	    function getColumn() {
	      return tableCtrl.$$columns[getIndex()];
	    }
	    
	    function getIndex() {
	      return Array.prototype.indexOf.call(element.parent().children(), element[0]);
	    }
	    
	    scope.$watch(getColumn, function (column) {
	      if(!column) {
	        return;
	      }
	      
	      if(column.numeric) {
	        element.addClass('md-numeric');
	      } else {
	        element.removeClass('md-numeric');
	      }
	    });
	  }
	  
	  return {
	    controller: Controller,
	    compile: compile,
	    require: ['mdCell', '^^mdTable'],
	    restrict: 'A'
	  };
	}
	
	angular.module('md.data.table').directive('mdColumn', mdColumn);
	
	function mdColumn($compile, $mdUtil) {
	
	  function compile(tElement) {
	    tElement.addClass('md-column');
	    return postLink;
	  }
	
	  function postLink(scope, element, attrs, ctrls) {
	    var headCtrl = ctrls.shift();
	    var tableCtrl = ctrls.shift();
	
	    function attachSortIcon() {
	      var sortIcon = angular.element('<md-icon md-svg-icon="arrow-up.svg">');
	
	      $compile(sortIcon.addClass('md-sort-icon').attr('ng-class', 'getDirection()'))(scope);
	
	      if(element.hasClass('md-numeric')) {
	        element.prepend(sortIcon);
	      } else {
	        element.append(sortIcon);
	      }
	    }
	
	    function detachSortIcon() {
	      Array.prototype.some.call(element.find('md-icon'), function (icon) {
	        return icon.classList.contains('md-sort-icon') && element[0].removeChild(icon);
	      });
	    }
	
	    function disableSorting() {
	      detachSortIcon();
	      element.removeClass('md-sort').off('click', setOrder);
	    }
	
	    function enableSorting() {
	      attachSortIcon();
	      element.addClass('md-sort').on('click', setOrder);
	    }
	
	    function getIndex() {
	      return Array.prototype.indexOf.call(element.parent().children(), element[0]);
	    }
	
	    function isActive() {
	      return scope.orderBy && (headCtrl.order === scope.orderBy || headCtrl.order === '-' + scope.orderBy);
	    }
	
	    function isNumeric() {
	      return attrs.mdNumeric === '' || scope.numeric;
	    }
	
	    function setOrder() {
	      scope.$applyAsync(function () {
	        if(isActive()) {
	          headCtrl.order = scope.getDirection() === 'md-asc' ? '-' + scope.orderBy : scope.orderBy;
	        } else {
	          headCtrl.order = scope.getDirection() === 'md-asc' ? scope.orderBy : '-' + scope.orderBy;
	        }
	
	        if(angular.isFunction(headCtrl.onReorder)) {
	          $mdUtil.nextTick(function () {
	            headCtrl.onReorder(headCtrl.order);
	          });
	        }
	      });
	    }
	
	    function updateColumn(index, column) {
	      tableCtrl.$$columns[index] = column;
	
	      if(column.numeric) {
	        element.addClass('md-numeric');
	      } else {
	        element.removeClass('md-numeric');
	      }
	    }
	
	    scope.getDirection = function () {
	      if(isActive()) {
	        return headCtrl.order.charAt(0) === '-' ? 'md-desc' : 'md-asc';
	      }
	
	      return attrs.mdDesc === '' || scope.$eval(attrs.mdDesc) ? 'md-desc' : 'md-asc';
	    };
	
	    scope.$watch(isActive, function (active) {
	      if(active) {
	        element.addClass('md-active');
	      } else {
	        element.removeClass('md-active');
	      }
	    });
	
	    scope.$watch(getIndex, function (index) {
	      updateColumn(index, {'numeric': isNumeric()});
	    });
	
	    scope.$watch(isNumeric, function (numeric) {
	      updateColumn(getIndex(), {'numeric': numeric});
	    });
	
	    scope.$watch('orderBy', function (orderBy) {
	      if(orderBy) {
	        if(!element.hasClass('md-sort')) {
	          enableSorting();
	        }
	      } else if(element.hasClass('md-sort')) {
	        disableSorting();
	      }
	    });
	  }
	
	  return {
	    compile: compile,
	    require: ['^^mdHead', '^^mdTable'],
	    restrict: 'A',
	    scope: {
	      numeric: '=?mdNumeric',
	      orderBy: '@?mdOrderBy'
	    }
	  };
	}
	
	mdColumn.$inject = ['$compile', '$mdUtil'];
	
	angular.module('md.data.table')
	  .decorator('$controller', controllerDecorator)
	  .factory('$mdEditDialog', mdEditDialog);
	
	/*
	 * A decorator for ng.$controller to optionally bind properties to the
	 * controller before invoking the constructor. Stolen from the ngMock.
	 *
	 * https://docs.angularjs.org/api/ngMock/service/$controller
	 */
	function controllerDecorator($delegate) {
	  return function(expression, locals, later, ident) {
	    if(later && typeof later === 'object') {
	      var create = $delegate(expression, locals, true, ident);
	      angular.extend(create.instance, later);
	      return create();
	    }
	    return $delegate(expression, locals, later, ident);
	  };
	}
	
	controllerDecorator.$inject = ['$delegate'];
	  
	function mdEditDialog($compile, $controller, $document, $mdUtil, $q, $rootScope, $templateCache, $templateRequest, $window) {
	  /* jshint validthis: true */
	  
	  var ESCAPE = 27;
	  
	  var busy = false;
	  var body = angular.element($document.prop('body'));
	  
	  /*
	   * bindToController
	   * controller
	   * controllerAs
	   * locals
	   * resolve
	   * scope
	   * targetEvent
	   * template
	   * templateUrl
	   */
	  var defaultOptions = {
	    clickOutsideToClose: true,
	    disableScroll: true,
	    escToClose: true,
	    focusOnOpen: true
	  };
	  
	  function build(template, options) {
	    var scope = $rootScope.$new();
	    var element = $compile(template)(scope);
	    var backdrop = $mdUtil.createBackdrop(scope, 'md-edit-dialog-backdrop');
	    var controller;
	    
	    if(options.controller) {
	      controller = getController(options, scope, {$element: element, $scope: scope});
	    } else {
	      angular.extend(scope, options.scope);
	    }
	    
	    if(options.disableScroll) {
	      disableScroll(element);
	    }
	    
	    body.prepend(backdrop).append(element.addClass('md-whiteframe-1dp'));
	    
	    positionDialog(element, options.target);
	    
	    if(options.focusOnOpen) {
	      focusOnOpen(element);
	    }
	    
	    if(options.clickOutsideToClose) {
	      backdrop.on('click', function () {
	        element.remove();
	      });
	    }
	    
	    if(options.escToClose) {
	      escToClose(element);
	    }
	    
	    element.on('$destroy', function () {
	      busy = false;
	      backdrop.remove();
	    });
	    
	    return controller;
	  }
	  
	  function disableScroll(element) {
	    var restoreScroll = $mdUtil.disableScrollAround(element, body);
	    
	    element.on('$destroy', function () {
	      restoreScroll();
	    });
	  }
	  
	  function getController(options, scope, inject) {
	    if(!options.controller) {
	      return;
	    }
	    
	    if(options.resolve) {
	      angular.extend(inject, options.resolve);
	    }
	    
	    if(options.locals) {
	      angular.extend(inject, options.locals);
	    }
	    
	    if(options.controllerAs) {
	      scope[options.controllerAs] = {};
	      
	      if(options.bindToController) {
	        angular.extend(scope[options.controllerAs], options.scope);
	      } else {
	        angular.extend(scope, options.scope);
	      }
	    } else {
	      angular.extend(scope, options.scope);
	    }
	    
	    if(options.bindToController) {
	      return $controller(options.controller, inject, scope[options.controllerAs]);
	    } else {
	      return $controller(options.controller, inject);
	    }
	  }
	  
	  function getTemplate(options) {
	    return $q(function (resolve, reject) {
	      var template = options.template;
	      
	      function illegalType(type) {
	        reject('Unexpected template value. Expected a string; received a ' + type + '.');
	      }
	      
	      if(template) {
	        return angular.isString(template) ? resolve(template) : illegalType(typeof template);
	      }
	      
	      if(options.templateUrl) {
	        template = $templateCache.get(options.templateUrl);
	        
	        if(template) {
	          return resolve(template);
	        }
	        
	        var success = function (template) {
	          return resolve(template);
	        };
	        
	        var error = function () {
	          return reject('Error retrieving template from URL.');
	        };
	        
	        return $templateRequest(options.templateUrl).then(success, error);
	      }
	      
	      reject('Template not provided.');
	    });
	  }
	  
	  function logError(error) {
	    busy = false;
	    console.error(error);
	  }
	  
	  function escToClose(element) {
	    var keyup = function (event) {
	      if(event.keyCode === ESCAPE) {
	        element.remove();
	      }
	    };
	    
	    body.on('keyup', keyup);
	    
	    element.on('$destroy', function () {
	      body.off('keyup', keyup);
	    });
	  }
	
	  function focusOnOpen(element) {
	    $mdUtil.nextTick(function () {
	      var autofocus = $mdUtil.findFocusTarget(element);
	      
	      if(autofocus) {
	        autofocus.focus();
	      }
	    }, false);
	  }
	
	  function positionDialog(element, target) {
	    var table = angular.element(target).controller('mdCell').getTable();
	    
	    var getHeight = function () {
	      return element.prop('clientHeight');
	    };
	    
	    var getSize = function () {
	      return {
	        width: getWidth(),
	        height: getHeight()
	      };
	    };
	    
	    var getTableBounds = function () {
	      var parent = table.parent();
	      
	      if(parent.prop('tagName') === 'MD-TABLE-CONTAINER') {
	        return parent[0].getBoundingClientRect();
	      } else {
	        return table[0].getBoundingClientRect();
	      }
	    };
	    
	    var getWidth = function () {
	      return element.prop('clientWidth');
	    };
	    
	    var reposition = function () {
	      var size = getSize();
	      var cellBounds = target.getBoundingClientRect();
	      var tableBounds = getTableBounds();
	      
	      if(size.width > tableBounds.right - cellBounds.left) {
	        element.css('left', tableBounds.right - size.width + 'px');
	      } else {
	        element.css('left', cellBounds.left + 'px');
	      }
	      
	      if(size.height > tableBounds.bottom - cellBounds.top) {
	        element.css('top', tableBounds.bottom - size.height + 'px');
	      } else {
	        element.css('top', cellBounds.top + 1 + 'px');
	      }
	      
	      element.css('minWidth', cellBounds.width + 'px');
	    };
	    
	    var watchWidth = $rootScope.$watch(getWidth, reposition);
	    var watchHeight = $rootScope.$watch(getHeight, reposition);
	    
	    $window.addEventListener('resize', reposition);
	    
	    element.on('$destroy', function () {
	      watchWidth();
	      watchHeight();
	      
	      $window.removeEventListener('resize', reposition);
	    });
	  }
	  
	  function preset(size, options) {
	    
	    function getAttrs() {
	      var attrs = 'type="' + (options.type || 'text') + '"';
	      
	      for(var attr in options.validators) {
	        attrs += ' ' + attr + '="' + options.validators[attr] + '"';
	      }
	      
	      return attrs;
	    }
	    
	    return {
	      controller: ['$element', '$q', 'save', '$scope', function ($element, $q, save, $scope) {
	        function update() {
	          if($scope.editDialog.$invalid) {
	            return $q.reject();
	          }
	          
	          if(angular.isFunction(save)) {
	            return $q.when(save($scope.editDialog.input));
	          }
	          
	          return $q.resolve();
	        }
	        
	        this.dismiss = function () {
	          $element.remove();
	        };
	        
	        this.getInput = function () {
	          return $scope.editDialog.input;
	        };
	        
	        $scope.dismiss = this.dismiss;
	        
	        $scope.submit = function () {
	          update().then(function () {
	            $scope.dismiss();
	          });
	        };
	      }],
	      locals: {
	        save: options.save
	      },
	      scope: {
	        cancel: options.cancel || 'Cancel',
	        messages: options.messages,
	        model: options.modelValue,
	        ok: options.ok || 'Save',
	        placeholder: options.placeholder,
	        title: options.title,
	        size: size
	      },
	      template:
	        '<md-edit-dialog>' +
	          '<div layout="column" class="md-content">' +
	            '<div ng-if="size === \'large\'" class="md-title">{{title || \'Edit\'}}</div>' +
	            '<form name="editDialog" layout="column" ng-submit="submit(model)">' +
	              '<md-input-container md-no-float>' +
	                '<input name="input" ng-model="model" md-autofocus placeholder="{{placeholder}} "' + getAttrs() + '>' +
	                '<div ng-messages="editDialog.input.$error">' +
	                  '<div ng-repeat="(key, message) in messages" ng-message="{{key}}">{{message}}</div>' +
	                '</div>' +
	              '</md-input-container>' +
	            '</form>' +
	          '</div>' +
	          '<div ng-if="size === \'large\'" layout="row" layout-align="end" class="md-actions">' +
	            '<md-button class="md-primary" ng-click="dismiss()">{{cancel}}</md-button>' +
	            '<md-button class="md-primary" ng-click="submit()">{{ok}}</md-button>' +
	          '</div>' +
	        '</md-edit-dialog>'
	    };
	  }
	  
	  this.show = function (options) {
	    if(busy) {
	      return $q.reject();
	    }
	    
	    busy = true;
	    options = angular.extend({}, defaultOptions, options);
	    
	    if(!options.targetEvent) {
	      return logError('options.targetEvent is required to align the dialog with the table cell.');
	    }
	    
	    if(!options.targetEvent.currentTarget.classList.contains('md-cell')) {
	      return logError('The event target must be a table cell.');
	    }
	    
	    if(options.bindToController && !options.controllerAs) {
	      return logError('You must define options.controllerAs when options.bindToController is true.');
	    }
	    
	    options.target = options.targetEvent.currentTarget;
	    
	    var promise = getTemplate(options);
	    var promises = [promise];
	    
	    for(var prop in options.resolve) {
	      promise = options.resolve[prop];
	      promises.push($q.when(angular.isFunction(promise) ? promise() : promise));
	    }
	    
	    promise = $q.all(promises);
	    
	    promise['catch'](logError);
	    
	    return promise.then(function (results) {
	      var template = results.shift();
	      
	      for(var prop in options.resolve) {
	        options.resolve[prop] = results.shift();
	      }
	      
	      return build(template, options);
	    });
	  };
	  
	  this.small = function (options) {
	    return this.show(angular.extend({}, options, preset('small', options)));
	  }.bind(this);
	  
	  this.large = function (options) {
	    return this.show(angular.extend({}, options, preset('large', options)));
	  }.bind(this);
	  
	  return this;
	}
	
	mdEditDialog.$inject = ['$compile', '$controller', '$document', '$mdUtil', '$q', '$rootScope', '$templateCache', '$templateRequest', '$window'];
	
	
	angular.module('md.data.table').directive('mdFoot', mdFoot);
	
	function mdFoot() {
	
	  function compile(tElement) {
	    tElement.addClass('md-foot');
	  }
	
	  return {
	    compile: compile,
	    restrict: 'A'
	  };
	}
	
	angular.module('md.data.table').directive('mdHead', mdHead);
	
	function mdHead($compile) {
	
	  function compile(tElement) {
	    tElement.addClass('md-head');
	    return postLink;
	  }
	  
	  // empty controller to be bind scope properties to
	  function Controller() {
	    
	  }
	  
	  function postLink(scope, element, attrs, tableCtrl) {
	    // because scope.$watch is unpredictable
	    var oldValue = new Array(2);
	    
	    function addCheckboxColumn() {
	      element.children().prepend('<th class="md-column md-checkbox-column">');
	    }
	    
	    function attatchCheckbox() {
	      element.prop('lastElementChild').firstElementChild.appendChild($compile(createCheckBox())(scope)[0]);
	    }
	    
	    function createCheckBox() {
	      return angular.element('<md-checkbox>').attr({
	        'aria-label': 'Select All',
	        'ng-click': 'toggleAll()',
	        'ng-checked': 'allSelected()',
	        'ng-disabled': '!getSelectableRows().length'
	      });
	    }
	    
	    function detachCheckbox() {
	      var cell = element.prop('lastElementChild').firstElementChild;
	      
	      if(cell.classList.contains('md-checkbox-column')) {
	        angular.element(cell).empty();
	      }
	    }
	    
	    function enableRowSelection() {
	      return tableCtrl.$$rowSelect;
	    }
	    
	    function mdSelectCtrl(row) {
	      return angular.element(row).controller('mdSelect');
	    }
	    
	    function removeCheckboxColumn() {
	      Array.prototype.some.call(element.find('th'), function (cell) {
	        return cell.classList.contains('md-checkbox-column') && cell.remove();
	      });
	    }
	    
	    scope.allSelected = function () {
	      var rows = scope.getSelectableRows();
	      
	      return rows.length && rows.every(function (row) {
	        return row.isSelected();
	      });
	    };
	    
	    scope.getSelectableRows = function () {
	      return tableCtrl.getBodyRows().map(mdSelectCtrl).filter(function (ctrl) {
	        return ctrl && !ctrl.disabled;
	      });
	    };
	    
	    scope.selectAll = function () {
	      tableCtrl.getBodyRows().map(mdSelectCtrl).forEach(function (ctrl) {
	        if(ctrl && !ctrl.isSelected()) {
	          ctrl.select();
	        }
	      });
	    };
	    
	    scope.toggleAll = function () {
	      return scope.allSelected() ? scope.unSelectAll() : scope.selectAll();
	    };
	    
	    scope.unSelectAll = function () {
	      tableCtrl.getBodyRows().map(mdSelectCtrl).forEach(function (ctrl) {
	        if(ctrl && ctrl.isSelected()) {
	          ctrl.deselect();
	        }
	      });
	    };
	    
	    scope.$watchGroup([enableRowSelection, tableCtrl.enableMultiSelect], function (newValue) {
	      if(newValue[0] !== oldValue[0]) {
	        if(newValue[0]) {
	          addCheckboxColumn();
	          
	          if(newValue[1]) {
	            attatchCheckbox();
	          }
	        } else {
	          removeCheckboxColumn();
	        }
	      } else if(newValue[0] && newValue[1] !== oldValue[1]) {
	        if(newValue[1]) {
	          attatchCheckbox();
	        } else {
	          detachCheckbox();
	        }
	      }
	      
	      angular.copy(newValue, oldValue);
	    });
	  }
	  
	  return {
	    bindToController: true,
	    compile: compile,
	    controller: Controller,
	    controllerAs: '$mdHead',
	    require: '^^mdTable',
	    restrict: 'A',
	    scope: {
	      order: '=?mdOrder',
	      onReorder: '=?mdOnReorder'
	    }
	  };
	}
	
	mdHead.$inject = ['$compile'];
	
	angular.module('md.data.table').directive('mdRow', mdRow);
	
	function mdRow() {
	
	  function compile(tElement) {
	    tElement.addClass('md-row');
	    return postLink;
	  }
	  
	  function postLink(scope, element, attrs, tableCtrl) {
	    function enableRowSelection() {
	      return tableCtrl.$$rowSelect;
	    }
	    
	    function isBodyRow() {
	      return tableCtrl.getBodyRows().indexOf(element[0]) !== -1;
	    }
	    
	    function isChild(node) {
	      return element[0].contains(node[0]);
	    }
	    
	    if(isBodyRow()) {
	      var cell = angular.element('<td class="md-cell">');
	      
	      scope.$watch(enableRowSelection, function (enable) {
	        // if a row is not selectable, prepend an empty cell to it
	        if(enable && !attrs.mdSelect) {
	          if(!isChild(cell)) {
	            element.prepend(cell);
	          }
	          return;
	        }
	        
	        if(isChild(cell)) {
	          cell.remove();
	        }
	      });
	    }
	  }
	
	  return {
	    compile: compile,
	    require: '^^mdTable',
	    restrict: 'A'
	  };
	}
	
	angular.module('md.data.table').directive('mdSelect', mdSelect);
	
	function mdSelect($compile, $parse) {
	
	  // empty controller to bind scope properties to
	  function Controller() {
	
	  }
	
	  function postLink(scope, element, attrs, ctrls) {
	    var self = ctrls.shift();
	    var tableCtrl = ctrls.shift();
	    var getId = $parse(attrs.mdSelectId);
	
	    self.id = getId(self.model);
	
	    if(tableCtrl.$$rowSelect && self.id) {
	      if(tableCtrl.$$hash.has(self.id)) {
	        var index = tableCtrl.selected.indexOf(tableCtrl.$$hash.get(self.id));
	
	        // if the item is no longer selected remove it
	        if(index === -1) {
	          tableCtrl.$$hash.purge(self.id);
	        }
	
	        // if the item is not a reference to the current model update the reference
	        else if(!tableCtrl.$$hash.equals(self.id, self.model)) {
	          tableCtrl.$$hash.update(self.id, self.model);
	          tableCtrl.selected.splice(index, 1, self.model);
	        }
	
	      } else {
	
	        // check if the item has been selected
	        tableCtrl.selected.some(function (item, index) {
	          if(getId(item) === self.id) {
	            tableCtrl.$$hash.update(self.id, self.model);
	            tableCtrl.selected.splice(index, 1, self.model);
	
	            return true;
	          }
	        });
	      }
	    }
	
	    self.isSelected = function () {
	      if(!tableCtrl.$$rowSelect) {
	        return false;
	      }
	
	      if(self.id) {
	        return tableCtrl.$$hash.has(self.id);
	      }
	
	      return tableCtrl.selected.indexOf(self.model) !== -1;
	    };
	
	    self.select = function () {
	      if(self.disabled) {
	        return;
	      }
	
	      if(tableCtrl.enableMultiSelect()) {
	        tableCtrl.selected.push(self.model);
	      } else {
	        tableCtrl.selected.splice(0, tableCtrl.selected.length, self.model);
	      }
	
	      if(angular.isFunction(self.onSelect)) {
	        self.onSelect(self.model);
	      }
	    };
	
	    self.deselect = function () {
	      if(self.disabled) {
	        return;
	      }
	
	      tableCtrl.selected.splice(tableCtrl.selected.indexOf(self.model), 1);
	
	      if(angular.isFunction(self.onDeselect)) {
	        self.onDeselect(self.model);
	      }
	    };
	
	    self.toggle = function (event) {
	      if(event && event.stopPropagation) {
	        event.stopPropagation();
	      }
	
	      return self.isSelected() ? self.deselect() : self.select();
	    };
	
	    function autoSelect() {
	      return attrs.mdAutoSelect === '' || self.autoSelect;
	    }
	
	    function createCheckbox() {
	      var checkbox = angular.element('<md-checkbox>').attr({
	        'aria-label': 'Select Row',
	        'ng-click': '$mdSelect.toggle($event)',
	        'ng-checked': '$mdSelect.isSelected()',
	        'ng-disabled': '$mdSelect.disabled'
	      });
	
	      return angular.element('<td class="md-cell md-checkbox-cell">').append($compile(checkbox)(scope));
	    }
	
	    function disableSelection() {
	      Array.prototype.some.call(element.children(), function (child) {
	        return child.classList.contains('md-checkbox-cell') && element[0].removeChild(child);
	      });
	
	      if(autoSelect()) {
	        element.off('click', toggle);
	      }
	    }
	
	    function enableSelection() {
	      element.prepend(createCheckbox());
	
	      if(autoSelect()) {
	        element.on('click', toggle);
	      }
	    }
	
	    function enableRowSelection() {
	      return tableCtrl.$$rowSelect;
	    }
	
	    function onSelectChange(selected) {
	      if(!self.id) {
	        return;
	      }
	
	      if(tableCtrl.$$hash.has(self.id)) {
	        // check if the item has been deselected
	        if(selected.indexOf(tableCtrl.$$hash.get(self.id)) === -1) {
	          tableCtrl.$$hash.purge(self.id);
	        }
	
	        return;
	      }
	
	      // check if the item has been selected
	      if(selected.indexOf(self.model) !== -1) {
	        tableCtrl.$$hash.update(self.id, self.model);
	      }
	    }
	
	    function toggle(event) {
	      scope.$applyAsync(function () {
	        self.toggle(event);
	      });
	    }
	
	    scope.$watch(enableRowSelection, function (enable) {
	      if(enable) {
	        enableSelection();
	      } else {
	        disableSelection();
	      }
	    });
	
	    scope.$watch(autoSelect, function (newValue, oldValue) {
	      if(newValue === oldValue) {
	        return;
	      }
	
	      if(tableCtrl.$$rowSelect && newValue) {
	        element.on('click', toggle);
	      } else {
	        element.off('click', toggle);
	      }
	    });
	
	    scope.$watch(self.isSelected, function (isSelected) {
	      return isSelected ? element.addClass('md-selected') : element.removeClass('md-selected');
	    });
	
	    scope.$watch(tableCtrl.enableMultiSelect, function (multiple) {
	      if(tableCtrl.$$rowSelect && !multiple) {
	        // remove all but the first selected item
	        tableCtrl.selected.splice(1);
	      }
	    });
	
	    tableCtrl.registerModelChangeListener(onSelectChange);
	
	    element.on('$destroy', function () {
	      tableCtrl.removeModelChangeListener(onSelectChange);
	    });
	  }
	
	  return {
	    bindToController: true,
	    controller: Controller,
	    controllerAs: '$mdSelect',
	    link: postLink,
	    require: ['mdSelect', '^^mdTable'],
	    restrict: 'A',
	    scope: {
	      model: '=mdSelect',
	      disabled: '=ngDisabled',
	      onSelect: '=?mdOnSelect',
	      onDeselect: '=?mdOnDeselect',
	      autoSelect: '=mdAutoSelect'
	    }
	  };
	}
	
	mdSelect.$inject = ['$compile', '$parse'];
	
	angular.module('md.data.table').directive('mdTable', mdTable);
	
	function Hash() {
	  var keys = {};
	  
	  this.equals = function (key, item) {
	    return keys[key] === item;
	  };
	
	  this.get = function (key) {
	    return keys[key];
	  };
	  
	  this.has = function (key) {
	    return keys.hasOwnProperty(key);
	  };
	
	  this.purge = function (key) {
	    delete keys[key];
	  };
	  
	  this.update = function (key, item) {
	    keys[key] = item;
	  };
	}
	
	function mdTable() {
	  
	  function compile(tElement, tAttrs) {
	    tElement.addClass('md-table');
	    
	    if(tAttrs.hasOwnProperty('mdProgress')) {
	      var body = tElement.find('tbody')[0];
	      var progress = angular.element('<thead class="md-table-progress" md-table-progress>');
	      
	      if(body) {
	        tElement[0].insertBefore(progress[0], body);
	      }
	    }
	  }
	  
	  function Controller($attrs, $element, $q, $scope) {
	    var self = this;
	    var queue = [];
	    var watchListener;
	    var modelChangeListeners = [];
	    
	    self.$$hash = new Hash();
	    self.$$columns = {};
	    
	    function enableRowSelection() {
	      self.$$rowSelect = true;
	      
	      watchListener = $scope.$watchCollection('$mdTable.selected', function (selected) {
	        modelChangeListeners.forEach(function (listener) {
	          listener(selected);
	        });
	      });
	      
	      $element.addClass('md-row-select');
	    }
	    
	    function disableRowSelection() {
	      self.$$rowSelect = false;
	      
	      if(angular.isFunction(watchListener)) {
	        watchListener();
	      }
	      
	      $element.removeClass('md-row-select');
	    }
	    
	    function resolvePromises() {
	      if(!queue.length) {
	        return $scope.$applyAsync();
	      }
	      
	      queue[0]['finally'](function () {
	        queue.shift();
	        resolvePromises();
	      });
	    }
	    
	    function rowSelect() {
	      return $attrs.mdRowSelect === '' || self.rowSelect;
	    }
	    
	    function validateModel() {
	      if(!self.selected) {
	        return console.error('Row selection: ngModel is not defined.');
	      }
	      
	      if(!angular.isArray(self.selected)) {
	        return console.error('Row selection: Expected an array. Recived ' + typeof self.selected + '.');
	      }
	      
	      return true;
	    }
	    
	    self.columnCount = function () {
	      return self.getRows($element[0]).reduce(function (count, row) {
	        return row.cells.length > count ? row.cells.length : count;
	      }, 0);
	    };
	    
	    self.getRows = function (element) {
	      return Array.prototype.filter.call(element.rows, function (row) {
	        return !row.classList.contains('ng-leave');
	      });
	    };
	    
	    self.getBodyRows = function () {
	      return Array.prototype.reduce.call($element.prop('tBodies'), function (result, tbody) {
	        return result.concat(self.getRows(tbody));
	      }, []);
	    };
	    
	    self.getElement = function () {
	      return $element;
	    };
	    
	    self.getHeaderRows = function () {
	      return self.getRows($element.prop('tHead'));
	    };
	    
	    self.enableMultiSelect = function () {
	      return $attrs.multiple === '' || $scope.$eval($attrs.multiple);
	    };
	    
	    self.waitingOnPromise = function () {
	      return !!queue.length;
	    };
	    
	    self.queuePromise = function (promise) {
	      if(!promise) {
	        return;
	      }
	      
	      if(queue.push(angular.isArray(promise) ? $q.all(promise) : $q.when(promise)) === 1) {
	        resolvePromises();
	      }
	    };
	    
	    self.registerModelChangeListener = function (listener) {
	      modelChangeListeners.push(listener);
	    };
	    
	    self.removeModelChangeListener = function (listener) {
	      var index = modelChangeListeners.indexOf(listener);
	      
	      if(index !== -1) {
	        modelChangeListeners.splice(index, 1);
	      }
	    };
	    
	    if($attrs.hasOwnProperty('mdProgress')) {
	      $scope.$watch('$mdTable.progress', self.queuePromise);
	    }
	    
	    $scope.$watch(rowSelect, function (enable) {
	      if(enable && !!validateModel()) {
	        enableRowSelection();
	      } else {
	        disableRowSelection();
	      }
	    });
	  }
	  
	  Controller.$inject = ['$attrs', '$element', '$q', '$scope'];
	  
	  return {
	    bindToController: true,
	    compile: compile,
	    controller: Controller,
	    controllerAs: '$mdTable',
	    restrict: 'A',
	    scope: {
	      progress: '=?mdProgress',
	      selected: '=ngModel',
	      rowSelect: '=mdRowSelect'
	    }
	  };
	}
	
	angular.module('md.data.table').directive('mdTablePagination', mdTablePagination);
	
	function mdTablePagination() {
	
	  function compile(tElement) {
	    tElement.addClass('md-table-pagination');
	  }
	
	  function Controller($attrs, $mdUtil, $scope) {
	    var self = this;
	    var defaultLabel = {
	      page: 'Página:',
	      rowsPerPage: 'Linhas por página:',
	      of: 'de'
	    };
	
	    self.label = angular.copy(defaultLabel);
	
	    function isPositive(number) {
	      return parseInt(number, 10) > 0;
	    }
	
	    self.eval = function (expression) {
	      return $scope.$eval(expression);
	    };
	
	    self.first = function () {
	      self.page = 1;
	      self.onPaginationChange();
	    };
	
	    self.hasNext = function () {
	      return self.page * self.limit < self.total;
	    };
	
	    self.hasPrevious = function () {
	      return self.page > 1;
	    };
	
	    self.last = function () {
	      self.page = self.pages();
	      self.onPaginationChange();
	    };
	
	    self.max = function () {
	      return self.hasNext() ? self.page * self.limit : self.total;
	    };
	
	    self.min = function () {
	      return isPositive(self.total) ? self.page * self.limit - self.limit + 1 : 0;
	    };
	
	    self.next = function () {
	      self.page++;
	      self.onPaginationChange();
	    };
	
	    self.onPaginationChange = function () {
	      if(angular.isFunction(self.onPaginate)) {
	        $mdUtil.nextTick(function () {
	          self.onPaginate(self.page, self.limit);
	        });
	      }
	    };
	
	    self.pages = function () {
	      return isPositive(self.total) ? Math.ceil(self.total / (isPositive(self.limit) ? self.limit : 1)) : 1;
	    };
	
	    self.previous = function () {
	      self.page--;
	      self.onPaginationChange();
	    };
	
	    self.showBoundaryLinks = function () {
	      return $attrs.mdBoundaryLinks === '' || self.boundaryLinks;
	    };
	
	    self.showPageSelect = function () {
	      return $attrs.mdPageSelect === '' || self.pageSelect;
	    };
	
	    $scope.$watch('$pagination.limit', function (newValue, oldValue) {
	      if(isNaN(newValue) || isNaN(oldValue) || newValue === oldValue) {
	        return;
	      }
	
	      // find closest page from previous min
	      self.page = Math.floor(((self.page * oldValue - oldValue) + newValue) / (isPositive(newValue) ? newValue : 1));
	      self.onPaginationChange();
	    });
	
	    $attrs.$observe('mdLabel', function (label) {
	      angular.extend(self.label, defaultLabel, $scope.$eval(label));
	    });
	
	    $scope.$watch('$pagination.total', function (newValue, oldValue) {
	      if(isNaN(newValue) || newValue === oldValue) {
	        return;
	      }
	
	      if(self.page > self.pages()) {
	        self.last();
	      }
	    });
	  }
	
	  Controller.$inject = ['$attrs', '$mdUtil', '$scope'];
	
	  return {
	    bindToController: {
	      boundaryLinks: '=?mdBoundaryLinks',
	      disabled: '=ngDisabled',
	      limit: '=mdLimit',
	      page: '=mdPage',
	      pageSelect: '=?mdPageSelect',
	      onPaginate: '=?mdOnPaginate',
	      limitOptions: '=?mdLimitOptions',
	      total: '@mdTotal'
	    },
	    compile: compile,
	    controller: Controller,
	    controllerAs: '$pagination',
	    restrict: 'E',
	    scope: {},
	    templateUrl: 'md-table-pagination.html'
	  };
	}
	
	angular.module('md.data.table').directive('mdTableProgress', mdTableProgress);
	
	function mdTableProgress() {
	
	  function postLink(scope, element, attrs, tableCtrl) {
	    scope.columnCount = tableCtrl.columnCount;
	    scope.deferred = tableCtrl.waitingOnPromise;
	  }
	
	  return {
	    link: postLink,
	    require: '^^mdTable',
	    restrict: 'A',
	    scope: {},
	    templateUrl: 'md-table-progress.html'
	  };
	}
	
	angular.module('md.data.table').directive('virtualPageSelect', virtualPageSelect);
	
	function virtualPageSelect() {
	
	  function Controller($element, $scope) {
	    var self = this;
	    var content = $element.find('md-content');
	
	    self.pages = [];
	
	    function getMin(pages, total) {
	      return Math.min(pages, isFinite(total) && isPositive(total) ? total : 1);
	    }
	
	    function isPositive(number) {
	      return number > 0;
	    }
	
	    function setPages(max) {
	      if(self.pages.length > max) {
	        return self.pages.splice(max);
	      }
	
	      for(var i = self.pages.length; i < max; i++) {
	        self.pages.push(i + 1);
	      }
	    }
	
	    content.on('scroll', function () {
	      if((content.prop('clientHeight') + content.prop('scrollTop')) >= content.prop('scrollHeight')) {
	        $scope.$applyAsync(function () {
	          setPages(getMin(self.pages.length + 10, self.total));
	        });
	      }
	    });
	
	    $scope.$watch('$pageSelect.total', function (total) {
	      setPages(getMin(Math.max(self.pages.length, 10), total));
	    });
	
	    $scope.$watch('$pagination.page', function (page) {
	      for(var i = self.pages.length; i < page; i++) {
	        self.pages.push(i + 1);
	      }
	    });
	  }
	
	  Controller.$inject = ['$element', '$scope'];
	
	  return {
	    bindToController: {
	      total: '@'
	    },
	    controller: Controller,
	    controllerAs: '$pageSelect'
	  };
	}
	
	})(window, angular);

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	// support for Browserify
	
	__webpack_require__(80);
	__webpack_require__(601);
	
	module.exports = 'md.data.table';


/***/ }),
/* 603 */
/***/ (function(module, exports) {

	(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.expansionPanels
	 *
	 * @description
	 * Expansion panel component
	 */
	angular
	  .module('material.components.expansionPanels', [
	    'material.core'
	  ]);
	}());
	(function(){"use strict";angular.module("material.components.expansionPanels").run(["$templateCache", function($templateCache) {$templateCache.put("icons/ic_keyboard_arrow_right_black_24px.svg","<svg fill=\"#000000\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z\"/>\n    <path d=\"M0-.25h24v24H0z\" fill=\"none\"/>\n</svg>");}]);}());
	(function(){"use strict";angular
	  .module('material.components.expansionPanels')
	  .directive('mdExpansionPanel', expansionPanelDirective);
	
	
	var ANIMATION_TIME = 180; //ms
	
	
	/**
	 * @ngdoc directive
	 * @name mdExpansionPanel
	 * @module material.components.expansionPanels
	 *
	 * @restrict E
	 *
	 * @description
	 * `mdExpansionPanel` is the main container for panels
	 *
	 * @param {string=} md-component-id - add an id if you want to acces the panel via the `$mdExpansionPanel` service
	 **/
	function expansionPanelDirective() {
	  var directive = {
	    restrict: 'E',
	    require: ['mdExpansionPanel', '?^^mdExpansionPanelGroup'],
	    scope: true,
	    compile: compile,
	    controller: ['$scope', '$element', '$attrs', '$window', '$$rAF', '$mdConstant', '$mdUtil', '$mdComponentRegistry', '$timeout', '$q', '$animate', '$parse', controller]
	  };
	  return directive;
	
	
	
	
	  function compile(tElement, tAttrs) {
	    var INVALID_PREFIX = 'Invalid HTML for md-expansion-panel: ';
	
	    tElement.attr('tabindex', tAttrs.tabindex || '0');
	
	    if (tElement[0].querySelector('md-expansion-panel-collapsed') === null) {
	      throw Error(INVALID_PREFIX + 'Expected a child element of `md-epxansion-panel-collapsed`');
	    }
	    if (tElement[0].querySelector('md-expansion-panel-expanded') === null) {
	      throw Error(INVALID_PREFIX + 'Expected a child element of `md-epxansion-panel-expanded`');
	    }
	
	    return function postLink(scope, element, attrs, ctrls) {
	      var epxansionPanelCtrl = ctrls[0];
	      var epxansionPanelGroupCtrl = ctrls[1];
	
	      epxansionPanelCtrl.epxansionPanelGroupCtrl = epxansionPanelGroupCtrl || undefined;
	      epxansionPanelCtrl.init();
	    };
	  }
	
	
	
	
	  function controller($scope, $element, $attrs, $window, $$rAF, $mdConstant, $mdUtil, $mdComponentRegistry, $timeout, $q, $animate, $parse) {
	    /* jshint validthis: true */
	    var vm = this;
	
	    var collapsedCtrl;
	    var expandedCtrl;
	    var headerCtrl;
	    var footerCtrl;
	    var deregister;
	    var scrollContainer;
	    var stickyContainer;
	    var topKiller;
	    var resizeKiller;
	    var onRemoveCallback;
	    var transformParent;
	    var backdrop;
	    var inited = false;
	    var registerOnInit = false;
	    var _isOpen = false;
	    var isDisabled = false;
	    var debouncedUpdateScroll = $$rAF.throttle(updateScroll);
	    var debouncedUpdateResize = $$rAF.throttle(updateResize);
	
	    vm.registerCollapsed = function (ctrl) { collapsedCtrl = ctrl; };
	    vm.registerExpanded = function (ctrl) { expandedCtrl = ctrl; };
	    vm.registerHeader = function (ctrl) { headerCtrl = ctrl; };
	    vm.registerFooter = function (ctrl) { footerCtrl = ctrl; };
	
	
	
	    if ($attrs.mdComponentId === undefined) {
	      $attrs.$set('mdComponentId', '_expansion_panel_id_' + $mdUtil.nextUid());
	      registerPanel();
	    } else {
	      $attrs.$observe('mdComponentId', function() {
	        registerPanel();
	      });
	    }
	
	    vm.$element = $element;
	    vm.expand = expand;
	    vm.collapse = collapse;
	    vm.remove = remove;
	    vm.destroy = destroy;
	    vm.onRemove = onRemove;
	    vm.init = init;
	
	    if ($attrs.ngDisabled !== undefined) {
	      $scope.$watch($attrs.ngDisabled, function(value) {
	        isDisabled = value;
	        $element.attr('tabindex', isDisabled ? -1 : 0);
	      });
	    } else if ($attrs.disabled !== undefined) {
	      isDisabled = ($attrs.disabled !== undefined && $attrs.disabled !== 'false' && $attrs.disabled !== false);
	      $element.attr('tabindex', isDisabled ? -1 : 0);
	    }
	
	    $element
	      .on('focus', function (ev) {
	        $element.on('keydown', handleKeypress);
	      })
	      .on('blur', function (ev) {
	        $element.off('keydown', handleKeypress);
	      });
	
	    function handleKeypress(ev) {
	      var keyCodes = $mdConstant.KEY_CODE;
	      switch (ev.keyCode) {
	        case keyCodes.ENTER:
	          expand();
	          break;
	        case keyCodes.ESCAPE:
	          collapse();
	          break;
	      }
	    }
	
	
	    $scope.$panel = {
	      collapse: collapse,
	      expand: expand,
	      remove: remove,
	      isOpen: isOpen
	    };
	
	    $scope.$on('$destroy', function () {
	      removeClickCatcher();
	
	      // remove component from registry
	      if (typeof deregister === 'function') {
	        deregister();
	        deregister = undefined;
	      }
	      killEvents();
	    });
	
	
	
	
	
	    function init() {
	      inited = true;
	      if (registerOnInit === true) {
	        registerPanel();
	      }
	    }
	
	
	    function registerPanel() {
	      if (inited === false) {
	        registerOnInit = true;
	        return;
	      }
	
	      // deregister if component was already registered
	      if (typeof deregister === 'function') {
	        deregister();
	        deregister = undefined;
	      }
	      // remove component from group ctrl if component was already added
	      if (vm.componentId && vm.epxansionPanelGroupCtrl) {
	        vm.epxansionPanelGroupCtrl.removePanel(vm.componentId);
	      }
	
	      // if componentId was removed then set one
	      if ($attrs.mdComponentId === undefined) {
	        $attrs.$set('mdComponentId', '_expansion_panel_id_' + $mdUtil.nextUid());
	      }
	
	      vm.componentId = $attrs.mdComponentId;
	      deregister = $mdComponentRegistry.register({
	        expand: expand,
	        collapse: collapse,
	        remove: remove,
	        onRemove: onRemove,
	        isOpen: isOpen,
	        addClickCatcher: addClickCatcher,
	        removeClickCatcher: removeClickCatcher,
	        componentId: $attrs.mdComponentId
	      }, $attrs.mdComponentId);
	
	      if (vm.epxansionPanelGroupCtrl) {
	        vm.epxansionPanelGroupCtrl.addPanel(vm.componentId, {
	          expand: expand,
	          collapse: collapse,
	          remove: remove,
	          onRemove: onRemove,
	          destroy: destroy,
	          isOpen: isOpen
	        });
	      }
	    }
	
	
	    function isOpen() {
	      return _isOpen;
	    }
	
	    function expand(options) {
	      if (_isOpen === true || isDisabled === true) { return; }
	      _isOpen = true;
	      options = options || {};
	
	      var deferred = $q.defer();
	
	      if (vm.epxansionPanelGroupCtrl) {
	        vm.epxansionPanelGroupCtrl.expandPanel(vm.componentId);
	      }
	
	      $element.removeClass('md-close');
	      $element.addClass('md-open');
	      if (options.animation === false) {
	        $element.addClass('md-no-animation');
	      } else {
	        $element.removeClass('md-no-animation');
	      }
	
	      initEvents();
	      collapsedCtrl.hide(options);
	      expandedCtrl.show(options);
	
	      if (headerCtrl) { headerCtrl.show(options); }
	      if (footerCtrl) { footerCtrl.show(options); }
	
	      $timeout(function () {
	        deferred.resolve();
	      }, options.animation === false ? 0 : ANIMATION_TIME);
	      return deferred.promise;
	    }
	
	
	    function collapse(options) {
	      if (_isOpen === false) { return; }
	      _isOpen = false;
	      options = options || {};
	
	      var deferred = $q.defer();
	
	      $element.addClass('md-close');
	      $element.removeClass('md-open');
	      if (options.animation === false) {
	        $element.addClass('md-no-animation');
	      } else {
	        $element.removeClass('md-no-animation');
	      }
	
	      killEvents();
	      collapsedCtrl.show(options);
	      expandedCtrl.hide(options);
	
	      if (headerCtrl) { headerCtrl.hide(options); }
	      if (footerCtrl) { footerCtrl.hide(options); }
	
	      $timeout(function () {
	        deferred.resolve();
	      }, options.animation === false ? 0 : ANIMATION_TIME);
	      return deferred.promise;
	    }
	
	
	    function remove(options) {
	      options = options || {};
	      var deferred = $q.defer();
	
	      if (vm.epxansionPanelGroupCtrl) {
	        vm.epxansionPanelGroupCtrl.removePanel(vm.componentId);
	      }
	
	      if (typeof deregister === 'function') {
	        deregister();
	        deregister = undefined;
	      }
	
	      if (options.animation === false || _isOpen === false) {
	        $scope.$destroy();
	        $element.remove();
	        deferred.resolve();
	        callbackRemove();
	      } else {
	        collapse();
	        $timeout(function () {
	          $scope.$destroy();
	          $element.remove();
	          deferred.resolve();
	          callbackRemove();
	        }, ANIMATION_TIME);
	      }
	
	      return deferred.promise;
	    }
	
	    function onRemove(callback) {
	      onRemoveCallback = callback;
	    }
	
	    function callbackRemove() {
	      if (typeof onRemoveCallback === 'function') {
	        onRemoveCallback();
	        onRemoveCallback = undefined;
	      }
	    }
	
	    function destroy() {
	      $scope.$destroy();
	    }
	
	
	
	    function initEvents() {
	      if ((!footerCtrl || footerCtrl.noSticky === true) && (!headerCtrl || headerCtrl.noSticky === true)) {
	        return;
	      }
	
	      // watch for panel position changes
	      topKiller = $scope.$watch(function () { return $element[0].offsetTop; }, debouncedUpdateScroll, true);
	
	      // watch for panel position changes
	      resizeKiller = $scope.$watch(function () { return $element[0].offsetWidth; }, debouncedUpdateResize, true);
	
	      // listen to md-content scroll events id we are nested in one
	      scrollContainer = $mdUtil.getNearestContentElement($element);
	      if (scrollContainer.nodeName === 'MD-CONTENT') {
	        transformParent = getTransformParent(scrollContainer);
	        angular.element(scrollContainer).on('scroll', debouncedUpdateScroll);
	      } else {
	        transformParent = undefined;
	      }
	
	      // listen to expanded content scroll if height is set
	      if (expandedCtrl.setHeight === true) {
	        expandedCtrl.$element.on('scroll', debouncedUpdateScroll);
	      }
	
	      // listen to window scroll events
	      angular.element($window)
	        .on('scroll', debouncedUpdateScroll)
	        .on('resize', debouncedUpdateScroll)
	        .on('resize', debouncedUpdateResize);
	    }
	
	
	    function killEvents() {
	      if (typeof topKiller === 'function') {
	        topKiller();
	        topKiller = undefined;
	      }
	
	      if (typeof resizeKiller === 'function') {
	        resizeKiller();
	        resizeKiller = undefined;
	      }
	
	      if (scrollContainer && scrollContainer.nodeName === 'MD-CONTENT') {
	        angular.element(scrollContainer).off('scroll', debouncedUpdateScroll);
	      }
	
	      if (expandedCtrl.setHeight === true) {
	        expandedCtrl.$element.off('scroll', debouncedUpdateScroll);
	      }
	
	      angular.element($window)
	        .off('scroll', debouncedUpdateScroll)
	        .off('resize', debouncedUpdateScroll)
	        .off('resize', debouncedUpdateResize);
	    }
	
	
	
	    function getTransformParent(el) {
	      var parent = el.parentNode;
	
	      while (parent && parent !== document) {
	        if (hasComputedStyle(parent, 'transform')) {
	          return parent;
	        }
	        parent = parent.parentNode;
	      }
	
	      return undefined;
	    }
	
	    function hasComputedStyle(target, key) {
	      var hasValue = false;
	
	      if (target) {
	        var computedStyles = $window.getComputedStyle(target);
	        hasValue = computedStyles[key] !== undefined && computedStyles[key] !== 'none';
	      }
	
	      return hasValue;
	    }
	
	
	    function updateScroll(e) {
	      var top;
	      var bottom;
	      var bounds;
	      if (expandedCtrl.setHeight === true) {
	        bounds = expandedCtrl.$element[0].getBoundingClientRect();
	      } else {
	        bounds = scrollContainer.getBoundingClientRect();
	      }
	      var transformTop = transformParent ? transformParent.getBoundingClientRect().top : 0;
	
	      // we never want the header going post the top of the page. to prevent this don't allow top to go below 0
	      top = Math.max(bounds.top, 0);
	      bottom = top + bounds.height;
	
	      if (footerCtrl && footerCtrl.noSticky === false) { footerCtrl.onScroll(top, bottom, transformTop); }
	      if (headerCtrl && headerCtrl.noSticky === false) { headerCtrl.onScroll(top, bottom, transformTop); }
	    }
	
	
	    function updateResize() {
	      var value = $element[0].offsetWidth;
	      if (footerCtrl && footerCtrl.noSticky === false) { footerCtrl.onResize(value); }
	      if (headerCtrl && headerCtrl.noSticky === false) { headerCtrl.onResize(value); }
	    }
	
	
	
	
	    function addClickCatcher(clickCallback) {
	      backdrop = $mdUtil.createBackdrop($scope);
	      backdrop[0].tabIndex = -1;
	
	      if (typeof clickCallback === 'function') {
	        backdrop.on('click', clickCallback);
	      }
	
	      $animate.enter(backdrop, $element.parent(), null, {duration: 0});
	      $element.css('z-index', 60);
	    }
	
	    function removeClickCatcher() {
	      if (backdrop) {
	        backdrop.remove();
	        backdrop.off('click');
	        backdrop = undefined;
	        $element.css('z-index', '');
	      }
	    }
	  }
	}
	}());
	(function(){"use strict";angular
	  .module('material.components.expansionPanels')
	  .factory('$mdExpansionPanel', expansionPanelService);
	
	
	/**
	 * @ngdoc service
	 * @name $mdExpansionPanel
	 * @module material.components.expansionPanels
	 *
	 * @description
	 * Expand and collapse Expansion Panel using its `md-component-id`
	 *
	 * @example
	 * $mdExpansionPanel('comonentId').then(function (instance) {
	 *  instance.exapand();
	 *  instance.collapse({animation: false});
	 *  instance.remove({animation: false});
	 *  instance.onRemove(function () {});
	 * });
	 */
	expansionPanelService.$inject = ['$mdComponentRegistry', '$mdUtil', '$log'];
	function expansionPanelService($mdComponentRegistry, $mdUtil, $log) {
	  var errorMsg = "ExpansionPanel '{0}' is not available! Did you use md-component-id='{0}'?";
	  var service = {
	    find: findInstance,
	    waitFor: waitForInstance
	  };
	
	  return function (handle) {
	    if (handle === undefined) { return service; }
	    return findInstance(handle);
	  };
	
	
	
	  function findInstance(handle) {
	    var instance = $mdComponentRegistry.get(handle);
	
	    if (!instance) {
	      // Report missing instance
	      $log.error( $mdUtil.supplant(errorMsg, [handle || ""]) );
	      return undefined;
	    }
	
	    return instance;
	  }
	
	  function waitForInstance(handle) {
	    return $mdComponentRegistry.when(handle).catch($log.error);
	  }
	}
	}());
	(function(){"use strict";angular
	  .module('material.components.expansionPanels')
	  .directive('mdExpansionPanelCollapsed', expansionPanelCollapsedDirective);
	
	
	
	/**
	 * @ngdoc directive
	 * @name mdExpansionPanelCollapsed
	 * @module material.components.expansionPanels
	 *
	 * @restrict E
	 *
	 * @description
	 * `mdExpansionPanelCollapsed` is used to contain content when the panel is collapsed
	 **/
	expansionPanelCollapsedDirective.$inject = ['$animateCss', '$timeout'];
	function expansionPanelCollapsedDirective($animateCss, $timeout) {
	  var directive = {
	    restrict: 'E',
	    require: '^^mdExpansionPanel',
	    link: link
	  };
	  return directive;
	
	
	  function link(scope, element, attrs, expansionPanelCtrl) {
	    expansionPanelCtrl.registerCollapsed({
	      show: show,
	      hide: hide
	    });
	
	
	    element.on('click', function () {
	      expansionPanelCtrl.expand();
	    });
	
	
	    function hide(options) {
	      // set width to maintian demensions when element is set to postion: absolute
	      element.css('width', element[0].offsetWidth + 'px');
	      // set min height so the expansion panel does not shrink when collapsed element is set to position: absolute
	      expansionPanelCtrl.$element.css('min-height', element[0].offsetHeight + 'px');
	
	      var animationParams = {
	        addClass: 'md-absolute md-hide',
	        from: {opacity: 1},
	        to: {opacity: 0}
	      };
	      if (options.animation === false) { animationParams.duration = 0; }
	      $animateCss(element, animationParams)
	      .start()
	      .then(function () {
	        element.removeClass('md-hide');
	        element.css('display', 'none');
	      });
	    }
	
	
	    function show(options) {
	      element.css('display', '');
	      // set width to maintian demensions when element is set to postion: absolute
	      element.css('width', element[0].parentNode.offsetWidth + 'px');
	
	      var animationParams = {
	        addClass: 'md-show',
	        from: {opacity: 0},
	        to: {opacity: 1}
	      };
	      if (options.animation === false) { animationParams.duration = 0; }
	      $animateCss(element, animationParams)
	      .start()
	      .then(function () {
	        // safari will animate the min-height if transition is not set to 0
	        expansionPanelCtrl.$element.css('transition', 'none');
	        element.removeClass('md-absolute md-show');
	
	        // remove width when element is no longer position: absolute
	        element.css('width', '');
	
	
	        // remove min height when element is no longer position: absolute
	        expansionPanelCtrl.$element.css('min-height', '');
	        // remove transition block on next digest
	        $timeout(function () {
	          expansionPanelCtrl.$element.css('transition', '');
	        }, 0);
	      });
	    }
	  }
	}
	}());
	(function(){"use strict";angular
	  .module('material.components.expansionPanels')
	  .directive('mdExpansionPanelExpanded', expansionPanelExpandedDirective);
	
	
	
	/**
	 * @ngdoc directive
	 * @name mdExpansionPanelExpanded
	 * @module material.components.expansionPanels
	 *
	 * @restrict E
	 *
	 * @description
	 * `mdExpansionPanelExpanded` is used to contain content when the panel is expanded
	 *
	 * @param {number=} height - add this aatribute set the max height of the expanded content. The container will be set to scroll
	 **/
	expansionPanelExpandedDirective.$inject = ['$animateCss', '$timeout'];
	function expansionPanelExpandedDirective($animateCss, $timeout) {
	  var directive = {
	    restrict: 'E',
	    require: '^^mdExpansionPanel',
	    link: link
	  };
	  return directive;
	
	
	  function link(scope, element, attrs, expansionPanelCtrl) {
	    var setHeight = attrs.height || undefined;
	    if (setHeight !== undefined) { setHeight = setHeight.replace('px', '') + 'px'; }
	
	    expansionPanelCtrl.registerExpanded({
	      show: show,
	      hide: hide,
	      setHeight: setHeight !== undefined,
	      $element: element
	    });
	
	
	
	
	    function hide(options) {
	      var height = setHeight ? setHeight : element[0].scrollHeight + 'px';
	      element.addClass('md-hide md-overflow');
	      element.removeClass('md-show md-scroll-y');
	
	      var animationParams = {
	        from: {'max-height': height, opacity: 1},
	        to: {'max-height': '48px', opacity: 0}
	      };
	      if (options.animation === false) { animationParams.duration = 0; }
	      $animateCss(element, animationParams)
	      .start()
	      .then(function () {
	        element.css('display', 'none');
	        element.removeClass('md-hide');
	      });
	    }
	
	
	    function show(options) {
	      element.css('display', '');
	      element.addClass('md-show md-overflow');
	      // use passed in height or the contents height
	      var height = setHeight ? setHeight : element[0].scrollHeight + 'px';
	
	      var animationParams = {
	        from: {'max-height': '48px', opacity: 0},
	        to: {'max-height': height, opacity: 1}
	      };
	      if (options.animation === false) { animationParams.duration = 0; }
	      $animateCss(element, animationParams)
	      .start()
	      .then(function () {
	
	        // if height was passed in then set div to scroll
	        if (setHeight !== undefined) {
	          element.addClass('md-scroll-y');
	        } else {
	          // safari will animate the max-height if transition is not set to 0
	          element.css('transition', 'none');
	          element.css('max-height', 'none');
	          // remove transition block on next digest
	          $timeout(function () {
	            element.css('transition', '');
	          }, 0);
	        }
	
	        element.removeClass('md-overflow');
	      });
	    }
	  }
	}
	}());
	(function(){"use strict";angular
	  .module('material.components.expansionPanels')
	  .directive('mdExpansionPanelFooter', expansionPanelFooterDirective);
	
	
	
	
	/**
	 * @ngdoc directive
	 * @name mdExpansionPanelFooter
	 * @module material.components.expansionPanels
	 *
	 * @restrict E
	 *
	 * @description
	 * `mdExpansionPanelFooter` is nested inside of `mdExpansionPanelExpanded` and contains content you want at the bottom.
	 * By default the Footer will stick to the bottom of the page if the panel expands past
	 * this is optional
	 *
	 * @param {boolean=} md-no-sticky - add this aatribute to disable sticky
	 **/
	function expansionPanelFooterDirective() {
	  var directive = {
	    restrict: 'E',
	    transclude: true,
	    template: '<div class="md-expansion-panel-footer-container" ng-transclude></div>',
	    require: '^^mdExpansionPanel',
	    link: link
	  };
	  return directive;
	
	
	
	  function link(scope, element, attrs, expansionPanelCtrl) {
	    var isStuck = false;
	    var noSticky = attrs.mdNoSticky !== undefined;
	    var container = angular.element(element[0].querySelector('.md-expansion-panel-footer-container'));
	
	    expansionPanelCtrl.registerFooter({
	      show: show,
	      hide: hide,
	      onScroll: onScroll,
	      onResize: onResize,
	      noSticky: noSticky
	    });
	
	
	
	    function show() {
	
	    }
	    function hide() {
	      unstick();
	    }
	
	    function onScroll(top, bottom, transformTop) {
	      var height;
	      var footerBounds = element[0].getBoundingClientRect();
	      var offset;
	
	      if (footerBounds.bottom > bottom) {
	        height = container[0].offsetHeight;
	        offset = bottom - height - transformTop;
	        if (offset < element[0].parentNode.getBoundingClientRect().top) {
	          offset = element[0].parentNode.getBoundingClientRect().top;
	        }
	
	        // set container width because element becomes postion fixed
	        container.css('width', expansionPanelCtrl.$element[0].offsetWidth + 'px');
	
	        // set element height so it does not loose its height when container is position fixed
	        element.css('height', height + 'px');
	        container.css('top', offset + 'px');
	
	        element.addClass('md-stick');
	        isStuck = true;
	      } else if (isStuck === true) {
	        unstick();
	      }
	    }
	
	    function onResize(width) {
	      if (isStuck === false) { return; }
	      container.css('width', width + 'px');
	    }
	
	
	    function unstick() {
	      isStuck = false;
	      container.css('width', '');
	      container.css('top', '');
	      element.css('height', '');
	      element.removeClass('md-stick');
	    }
	  }
	}
	}());
	(function(){"use strict";angular
	  .module('material.components.expansionPanels')
	  .directive('mdExpansionPanelGroup', expansionPanelGroupDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdExpansionPanelGroup
	 * @module material.components.expansionPanels
	 *
	 * @restrict E
	 *
	 * @description
	 * `mdExpansionPanelGroup` is a container used to manage multiple expansion panels
	 *
	 * @param {string=} md-component-id - add an id if you want to acces the panel via the `$mdExpansionPanelGroup` service
	 * @param {string=} auto-expand - panels expand when added to `<md-expansion-panel-group>`
	 * @param {string=} multiple - allows for more than one panel to be expanded at a time
	 **/
	function expansionPanelGroupDirective() {
	  var directive = {
	    restrict: 'E',
	    controller: ['$scope', '$attrs', '$element', '$mdComponentRegistry', controller]
	  };
	  return directive;
	
	
	  function controller($scope, $attrs, $element, $mdComponentRegistry) {
	    /* jshint validthis: true */
	    var vm = this;
	
	    var deregister;
	    var registered = {};
	    var panels = {};
	    var onChangeFuncs = [];
	    var multipleExpand = $attrs.mdMultiple !== undefined || $attrs.multiple !== undefined;
	    var autoExpand = $attrs.mdAutoExpand !== undefined || $attrs.autoExpand !== undefined;
	
	
	    deregister = $mdComponentRegistry.register({
	      $element: $element,
	      register: register,
	      getRegistered: getRegistered,
	      getAll: getAll,
	      getOpen: getOpen,
	      remove: remove,
	      removeAll: removeAll,
	      collapseAll: collapseAll,
	      onChange: onChange,
	      count: panelCount
	    }, $attrs.mdComponentId);
	
	    vm.addPanel = addPanel;
	    vm.expandPanel = expandPanel;
	    vm.removePanel = removePanel;
	
	
	    $scope.$on('$destroy', function () {
	      if (typeof deregister === 'function') {
	        deregister();
	        deregister = undefined;
	      }
	
	      // destroy all panels
	      // for some reason the child panels scopes are not getting destroyed
	      Object.keys(panels).forEach(function (key) {
	        panels[key].destroy();
	      });
	    });
	
	
	
	    function onChange(callback) {
	      onChangeFuncs.push(callback);
	
	      return function () {
	        onChangeFuncs.splice(onChangeFuncs.indexOf(callback), 1);
	      };
	    }
	
	    function callOnChange() {
	      var count = panelCount();
	      onChangeFuncs.forEach(function (func) {
	        func(count);
	      });
	    }
	
	
	    function addPanel(componentId, panelCtrl) {
	      panels[componentId] = panelCtrl;
	      if (autoExpand === true) {
	        panelCtrl.expand();
	        closeOthers(componentId);
	      }
	      callOnChange();
	    }
	
	    function expandPanel(componentId) {
	      closeOthers(componentId);
	    }
	
	    function remove(componentId, options) {
	      return panels[componentId].remove(options);
	    }
	
	    function removeAll(options) {
	      Object.keys(panels).forEach(function (panelId) {
	        panels[panelId].remove(options);
	      });
	    }
	
	    function removePanel(componentId) {
	      delete panels[componentId];
	      callOnChange();
	    }
	
	    function panelCount() {
	      return Object.keys(panels).length;
	    }
	
	    function closeOthers(id) {
	      if (multipleExpand === false) {
	        Object.keys(panels).forEach(function (panelId) {
	          if (panelId !== id) { panels[panelId].collapse(); }
	        });
	      }
	    }
	
	
	    function register(name, options) {
	      if (registered[name] !== undefined) {
	        throw Error('$mdExpansionPanelGroup.register() The name "' + name + '" has already been registered');
	      }
	      registered[name] = options;
	    }
	
	
	    function getRegistered(name) {
	      if (registered[name] === undefined) {
	        throw Error('$mdExpansionPanelGroup.addPanel() Cannot find Panel with name of "' + name + '"');
	      }
	      return registered[name];
	    }
	
	
	    function getAll() {
	      return Object.keys(panels).map(function (panelId) {
	        return panels[panelId];
	      });
	    }
	
	    function getOpen() {
	      return Object.keys(panels).map(function (panelId) {
	        return panels[panelId];
	      }).filter(function (instance) {
	        return instance.isOpen();
	      });
	    }
	
	    function collapseAll(noAnimation) {
	      var animation = noAnimation === true ? false : true;
	      Object.keys(panels).forEach(function (panelId) {
	        panels[panelId].collapse({animation: animation});
	      });
	    }
	  }
	}
	}());
	(function(){"use strict";angular
	  .module('material.components.expansionPanels')
	  .factory('$mdExpansionPanelGroup', expansionPanelGroupService);
	
	
	/**
	 * @ngdoc service
	 * @name $mdExpansionPanelGroup
	 * @module material.components.expansionPanels
	 *
	 * @description
	 * Expand and collapse Expansion Panel using its `md-component-id`
	 *
	 * @example
	 * $mdExpansionPanelGroup('comonentId').then(function (instance) {
	 *  instance.register({
	 *    componentId: 'cardComponentId',
	 *    templateUrl: 'template.html',
	 *    controller: 'Controller'
	 *  });
	 *  instance.add('cardComponentId', {local: localData});
	 *  instance.remove('cardComponentId', {animation: false});
	 *  instance.removeAll({animation: false});
	 * });
	 */
	expansionPanelGroupService.$inject = ['$mdComponentRegistry', '$mdUtil', '$mdExpansionPanel', '$templateRequest', '$rootScope', '$compile', '$controller', '$q', '$log'];
	function expansionPanelGroupService($mdComponentRegistry, $mdUtil, $mdExpansionPanel, $templateRequest, $rootScope, $compile, $controller, $q, $log) {
	  var errorMsg = "ExpansionPanelGroup '{0}' is not available! Did you use md-component-id='{0}'?";
	  var service = {
	    find: findInstance,
	    waitFor: waitForInstance
	  };
	
	  return function (handle) {
	    if (handle === undefined) { return service; }
	    return findInstance(handle);
	  };
	
	
	
	  function findInstance(handle) {
	    var instance = $mdComponentRegistry.get(handle);
	
	    if (!instance) {
	      // Report missing instance
	      $log.error( $mdUtil.supplant(errorMsg, [handle || ""]) );
	      return undefined;
	    }
	
	    return createGroupInstance(instance);
	  }
	
	  function waitForInstance(handle) {
	    var deffered = $q.defer();
	
	    $mdComponentRegistry.when(handle).then(function (instance) {
	      deffered.resolve(createGroupInstance(instance));
	    }).catch(function (error) {
	      deffered.reject();
	      $log.error(error);
	    });
	
	    return deffered.promise;
	  }
	
	
	
	
	
	  // --- returned service for group instance ---
	
	  function createGroupInstance(instance) {
	    var service = {
	      add: add,
	      register: register,
	      getAll: getAll,
	      getOpen: getOpen,
	      remove: remove,
	      removeAll: removeAll,
	      collapseAll: collapseAll,
	      onChange: onChange,
	      count: count
	    };
	
	    return service;
	
	
	    function register(name, options) {
	      if (typeof name !== 'string') {
	        throw Error('$mdExpansionPanelGroup.register() Expects name to be a string');
	      }
	
	      validateOptions(options);
	      instance.register(name, options);
	    }
	
	    function remove(componentId, options) {
	      return instance.remove(componentId, options);
	    }
	
	    function removeAll(options) {
	      instance.removeAll(options);
	    }
	
	    function onChange(callback) {
	      return instance.onChange(callback);
	    }
	
	    function count() {
	      return instance.count();
	    }
	
	    function getAll() {
	      return instance.getAll();
	    }
	
	    function getOpen() {
	      return instance.getOpen();
	    }
	
	    function collapseAll(noAnimation) {
	      instance.collapseAll(noAnimation);
	    }
	
	
	    function add(options, locals) {
	      locals = locals || {};
	      // assume if options is a string then they are calling a registered card by its component id
	      if (typeof options === 'string') {
	        // call add panel with the stored options
	        return add(instance.getRegistered(options), locals);
	      }
	
	      validateOptions(options);
	      if (options.componentId && instance.isPanelActive(options.componentId)) {
	        return $q.reject('panel with componentId "' + options.componentId + '" is currently active');
	      }
	
	
	      var deffered = $q.defer();
	      var scope = $rootScope.$new();
	      angular.extend(scope, options.scope);
	
	      getTemplate(options, function (template) {
	        var element = angular.element(template);
	        var componentId = options.componentId || element.attr('md-component-id') || '_panelComponentId_' + $mdUtil.nextUid();
	        var panelPromise = $mdExpansionPanel().waitFor(componentId);
	        element.attr('md-component-id', componentId);
	
	        var linkFunc = $compile(element);
	        if (options.controller) {
	          angular.extend(locals, options.locals || {});
	          locals.$scope = scope;
	          locals.$panel = panelPromise;
	          var invokeCtrl = $controller(options.controller, locals, true);
	          var ctrl = invokeCtrl();
	          element.data('$ngControllerController', ctrl);
	          element.children().data('$ngControllerController', ctrl);
	          if (options.controllerAs) {
	            scope[options.controllerAs] = ctrl;
	          }
	        }
	
	        // link after the element is added so we can find card manager directive
	        instance.$element.append(element);
	        linkFunc(scope);
	
	        panelPromise.then(function (instance) {
	          deffered.resolve(instance);
	        });
	      });
	
	      return deffered.promise;
	    }
	
	
	    function validateOptions(options) {
	      if (typeof options !== 'object' || options === null) {
	        throw Error('$mdExapnsionPanelGroup.add()/.register() : Requires an options object to be passed in');
	      }
	
	      // if none of these exist then a dialog box cannot be created
	      if (!options.template && !options.templateUrl) {
	        throw Error('$mdExapnsionPanelGroup.add()/.register() : Is missing required paramters to create. Required One of the following: template, templateUrl');
	      }
	    }
	
	
	
	    function getTemplate(options, callback) {
	      var template;
	
	      if (options.templateUrl !== undefined) {
	        $templateRequest(options.templateUrl)
	          .then(function(response) {
	            callback(response);
	          });
	      } else {
	        callback(options.template);
	      }
	    }
	  }
	}
	}());
	(function(){"use strict";angular
	  .module('material.components.expansionPanels')
	  .directive('mdExpansionPanelHeader', expansionPanelHeaderDirective);
	
	
	
	/**
	 * @ngdoc directive
	 * @name mdExpansionPanelHeader
	 * @module material.components.expansionPanels
	 *
	 * @restrict E
	 *
	 * @description
	 * `mdExpansionPanelHeader` is nested inside of `mdExpansionPanelExpanded` and contains content you want in place of the collapsed content
	 * this is optional
	 *
	 * @param {boolean=} md-no-sticky - add this aatribute to disable sticky
	 **/
	expansionPanelHeaderDirective.$inject = [];
	function expansionPanelHeaderDirective() {
	  var directive = {
	    restrict: 'E',
	    transclude: true,
	    template: '<div class="md-expansion-panel-header-container" ng-transclude></div>',
	    require: '^^mdExpansionPanel',
	    link: link
	  };
	  return directive;
	
	
	
	  function link(scope, element, attrs, expansionPanelCtrl) {
	    var isStuck = false;
	    var noSticky = attrs.mdNoSticky !== undefined;
	    var container = angular.element(element[0].querySelector('.md-expansion-panel-header-container'));
	
	    expansionPanelCtrl.registerHeader({
	      show: show,
	      hide: hide,
	      noSticky: noSticky,
	      onScroll: onScroll,
	      onResize: onResize
	    });
	
	
	    function show() {
	
	    }
	    function hide() {
	      unstick();
	    }
	
	
	    function onScroll(top, bottom, transformTop) {
	      var offset;
	      var panelbottom;
	      var bounds = element[0].getBoundingClientRect();
	
	
	      if (bounds.top < top) {
	        offset = top - transformTop;
	        panelbottom = element[0].parentNode.getBoundingClientRect().bottom - top - bounds.height;
	        if (panelbottom < 0) {
	          offset += panelbottom;
	        }
	
	        // set container width because element becomes postion fixed
	        container.css('width', element[0].offsetWidth + 'px');
	        container.css('top', offset + 'px');
	
	        // set element height so it does not shink when container is position fixed
	        element.css('height', container[0].offsetHeight + 'px');
	
	        element.removeClass('md-no-stick');
	        element.addClass('md-stick');
	        isStuck = true;
	      } else if (isStuck === true) {
	        unstick();
	      }
	    }
	
	    function onResize(width) {
	      if (isStuck === false) { return; }
	      container.css('width', width + 'px');
	    }
	
	
	    function unstick() {
	      isStuck = false;
	      container.css('width', '');
	      element.css('height', '');
	      element.css('top', '');
	      element.removeClass('md-stick');
	      element.addClass('md-no-stick');
	    }
	  }
	}
	}());
	(function(){"use strict";angular
	  .module('material.components.expansionPanels')
	  .directive('mdExpansionPanelIcon', mdExpansionPanelIconDirective);
	
	
	
	/**
	 * @ngdoc directive
	 * @name mdExpansionPanelIcon
	 * @module material.components.expansionPanels
	 *
	 * @restrict E
	 *
	 * @description
	 * `mdExpansionPanelIcon` can be used in both `md-expansion-panel-collapsed` and `md-expansion-panel-header` as the first or last element.
	 * Adding this will provide a animated arrow for expanded and collapsed states
	 **/
	function mdExpansionPanelIconDirective() {
	  var directive = {
	    restrict: 'E',
	    template: '<md-icon class="md-expansion-panel-icon" md-svg-icon="icons/ic_keyboard_arrow_right_black_24px.svg"></md-icon>',
	    replace: true
	  };
	  return directive;
	}
	}());

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(603); 


/***/ }),
/* 605 */
/***/ (function(module, exports) {

	/*
	 * angular-material-icons v0.7.1
	 * (c) 2014 Klar Systems
	 * License: MIT
	 */
	
	/* jshint -W097, -W101 */
	'use strict';
	
	angular.module('ngMdIcons', [])
	    .directive('ngMdIcon', ['ngMdIconService', function (ngMdIconService) {
	        var shapes = ngMdIconService.getShapes();
	
	        return {
	            restrict: 'AE',
	            link: function(scope, element, attr) {
	
	                var icon, size, viewBox;
	
	                var render = function() {
	                    // icon
	                    if (attr.icon !== undefined) {
	                        icon = attr.icon;
	                        // Check for material-design-icons style name, and extract icon / size
	                        var ss = icon.match(/ic_(.*)_([0-9]+)px.svg/m);
	                        if (ss !== null) {
	                            icon = ss[1];
	                            size = ss[2];
	                        }
	                    } else {
	                        icon = 'help';
	                    }
	                    // validate
	                    if (shapes[icon] === undefined) {
	                        icon = 'help';
	                    }
	
	                    // size
	                    if (attr.size !== undefined) {
	                        size = attr.size;
	                    }
	                    else if (size !== null) {
	                        size = 24;
	                    }
	
	                    // viewBox
	                    if (attr.viewBox !== undefined) {
	                        viewBox = attr.viewBox;
	                    }
	                    else {
	                        viewBox = ngMdIconService.getViewBox(icon) ? ngMdIconService.getViewBox(icon) : '0 0 24 24';
	                    }
	
	                    // render
	                    element.html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + viewBox + '" width="' + size + '" height="' + size + '">' + shapes[icon] + '</svg>');
	                };
	
	                var replace = function(newicon) {
	                    // validate
	                    if (shapes[newicon] === undefined) {
	                        newicon = 'help';
	                    }
	                    if (newicon === icon) { return; }
	                    // render new and old icons (old icon will be shown by default)
	                    element.html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="' + size + '" height="' + size + '"><g id="' + newicon + '" style="display:none">' + shapes[newicon] + '</g><g id="' + icon + '" style="display:none">' + shapes[icon] + '</g></svg>');
	                    // morph
	                    var options = JSON.parse(attr.options || null);
	                    try {
	                        // this block will succeed if SVGMorpheus is available
	                        new SVGMorpheus(element.children()[0]).to(newicon, options);
	                    } catch (error) {
	                        // fallback
	                        element.html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="' + size + '" height="' + size + '">' + shapes[newicon] + '</svg>');
	                    }
	                    icon = newicon;
	                };
	
	                var resize = function(newsize) {
	                    if (newsize === size) { return; }
	                    element.children()[0].setAttribute('width', newsize);
	                    element.children()[0].setAttribute('height', newsize);
	                    size = newsize;
	                };
	
	                // render the first time
	                render();
	
	                // watch for any changes
	                if (attr.icon !== undefined) { attr.$observe('icon', replace); }
	                if (attr.size !== undefined) { attr.$observe('size', resize);  }
	            }
	        };
	    }])
	    .provider('ngMdIconService', function () {
	        var provider, service, shapes, viewBoxes;
	
	        shapes = includedShapes();
	        viewBoxes = {};
	
	        service = {
	            getShape : getShape,
	            getShapes: getShapes,
	            getViewBox : getViewBox,
	            getViewBoxes: getViewBoxes,
	            setShape : addShape,
	            setShapes: addShapes,
	            setViewBox : addViewBox,
	            setViewBoxes: addViewBoxes,
	            addShape : addShape,
	            addShapes: addShapes,
	            addViewBox : addViewBox,
	            addViewBoxes: addViewBoxes
	        };
	
	        provider = {
	            $get     : ngMdIconServiceFactory,
	            getShape : getShape,
	            getShapes: getShapes,
	            getViewBox : getViewBox,
	            getViewBoxes: getViewBoxes,
	            setShape : addShape,
	            setShapes: addShapes,
	            setViewBox : addViewBox,
	            setViewBoxes: addViewBoxes,
	            addShape : addShape,
	            addShapes: addShapes,
	            addViewBox : addViewBox,
	            addViewBoxes: addViewBoxes
	        };
	
	        return provider;
	
	        function addShape(name, shape) {
	            shapes[name] = shape;
	
	            return provider; // chainable function
	        }
	
	        function addShapes(newShapes) {
	            shapes = angular.extend(shapes, newShapes);
	
	            return provider; // chainable function
	        }
	
	        function addViewBox(name, viewBox) {
	            viewBoxes[name] = viewBox;
	
	            return provider; // chainable function
	        }
	
	        function addViewBoxes(newViewBoxes) {
	            viewBoxes = angular.extend(viewBoxes, newViewBoxes);
	
	            return provider; // chainable function
	        }
	
	        function getShape(name) {
	            return shapes[name];
	        }
	
	        function getShapes() {
	            return shapes;
	        }
	
	        function getViewBox(name) {
	            return viewBoxes[name];
	        }
	
	        function getViewBoxes() {
	            return viewBoxes;
	        }
	
	        function includedShapes() {
	            return {
	                /*
	                 * Material Design Icons
	                 * (http://materialdesignicons.com)
	                 */
	                'amazon': '<path d="M13.23 10.56V10c-1.94 0-3.99.39-3.99 2.67 0 1.16.61 1.95 1.63 1.95.76 0 1.43-.47 1.86-1.22.52-.93.5-1.8.5-2.84m2.7 6.53c-.18.16-.43.17-.63.06-.89-.74-1.05-1.08-1.54-1.79-1.47 1.5-2.51 1.95-4.42 1.95-2.25 0-4.01-1.39-4.01-4.17 0-2.18 1.17-3.64 2.86-4.38 1.46-.64 3.49-.76 5.04-.93V7.5c0-.66.05-1.41-.33-1.96-.32-.49-.95-.7-1.5-.7-1.02 0-1.93.53-2.15 1.61-.05.24-.25.48-.47.49l-2.6-.28c-.22-.05-.46-.22-.4-.56.6-3.15 3.45-4.1 6-4.1 1.3 0 3 .35 4.03 1.33C17.11 4.55 17 6.18 17 7.95v4.17c0 1.25.5 1.81 1 2.48.17.25.21.54 0 .71l-2.06 1.78h-.01"/><path d="M20.16 19.54C18 21.14 14.82 22 12.1 22c-3.81 0-7.25-1.41-9.85-3.76-.2-.18-.02-.43.25-.29 2.78 1.63 6.25 2.61 9.83 2.61 2.41 0 5.07-.5 7.51-1.53.37-.16.66.24.32.51"/><path d="M21.07 18.5c-.28-.36-1.85-.17-2.57-.08-.19.02-.22-.16-.03-.3 1.24-.88 3.29-.62 3.53-.33.24.3-.07 2.35-1.24 3.32-.18.16-.35.07-.26-.11.26-.67.85-2.14.57-2.5z"/>',
	                'apple': '<path d="M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83"/>',
	                'facebook-box': '<path d="M19 4v3h-2a1 1 0 0 0-1 1v2h3v3h-3v7h-3v-7h-2v-3h2V7.5C13 5.56 14.57 4 16.5 4M20 2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4c0-1.11-.9-2-2-2z"/>',
	                'facebook-messenger': '<path d="M12 2C6.5 2 2 6.14 2 11.25c0 2.88 1.42 5.45 3.65 7.15l.06 3.6 3.45-1.88-.03-.01c.91.25 1.87.39 2.87.39 5.5 0 10-4.14 10-9.25S17.5 2 12 2m1.03 12.41l-2.49-2.63-5.04 2.63 5.38-5.63 2.58 2.47 4.85-2.47-5.28 5.63z"/>',
	                'facebook': '<path d="M17 2v4h-2c-.69 0-1 .81-1 1.5V10h3v4h-3v8h-4v-8H7v-4h3V6a4 4 0 0 1 4-4h3z"/>',
	                'github-box': '<path d="M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-5.15c-.35-.08-.35-.76-.35-1v-2.74c0-.93-.33-1.54-.69-1.85 2.23-.25 4.57-1.09 4.57-4.91 0-1.11-.38-2-1.03-2.71.1-.25.45-1.29-.1-2.64 0 0-.84-.27-2.75 1.02-.79-.22-1.65-.33-2.5-.33-.85 0-1.71.11-2.5.33-1.91-1.29-2.75-1.02-2.75-1.02-.55 1.35-.2 2.39-.1 2.64-.65.71-1.03 1.6-1.03 2.71 0 3.81 2.33 4.67 4.55 4.92-.28.25-.54.69-.63 1.34-.57.24-2.04.69-2.91-.83 0 0-.53-.96-1.53-1.03 0 0-.98-.02-.1.6 0 0 .68.31 1.14 1.47 0 0 .59 1.94 3.36 1.34V21c0 .24 0 .92-.36 1H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"/>',
	                'github-circle': '<path d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2z"/>',
	                'google-plus-box': '<path d="M20 2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4c0-1.11-.9-2-2-2M9.07 19.2C6.27 19.2 5 17.64 5 16.18c0-.45.14-1.59 1.5-2.38.75-.47 1.83-.8 3.12-.91-.19-.25-.34-.55-.34-.99 0-.15.02-.31.06-.46h-.39C7 11.44 5.8 9.89 5.8 8.39c0-1.73 1.29-3.59 4.11-3.59h4.22l-.34.34-.71.71-.08.06h-.7c.41.42.9 1.09.9 2.16 0 1.4-.74 2.09-1.56 2.73-.14.12-.42.38-.42.7 0 .32.24.5.39.64.13.11.29.22.47.36.81.55 1.92 1.33 1.92 2.86 0 1.77-1.29 3.84-4.93 3.84M19 12h-2v2h-1v-2h-2v-1h2V9h1v2h2"/><path d="M10.57 13.81c-.11-.01-.19-.01-.32-.01h-.02c-.26 0-1.15.05-1.82.27-.64.24-1.41.72-1.41 1.7C7 16.85 8.04 18 9.96 18c1.54 0 2.44-1 2.44-2 0-.75-.46-1.21-1.83-2.19"/><path d="M11.2 8.87c0-1.02-.63-3.02-2.08-3.02-.62 0-1.32.44-1.32 1.65 0 1.2.62 2.95 1.97 2.95.06 0 1.43-.01 1.43-1.58z"/>',
	                'google-plus': '<path d="M13.3 13.45l-1.08-.85c-.36-.3-.82-.69-.82-1.42s.55-1.29.97-1.62c1.31-1.02 2.57-2.1 2.57-4.34 0-2.07-1.27-3.26-2.04-3.92h1.75L15.9.05H9.67c-4.36 0-6.6 2.71-6.6 5.72 0 2.33 1.79 4.83 4.98 4.83h.8c-.13.35-.35.84-.35 1.3 0 1.01.42 1.43.92 2-1.42.1-4.01.43-5.92 1.6-1.86 1.1-2.3 2.63-2.3 3.75 0 2.3 2.06 4.5 6.57 4.5 5.35 0 8.03-2.96 8.03-5.88 0-2.16-1.13-3.27-2.5-4.42M5.65 4.31c0-2.21 1.31-3.21 2.69-3.21 2.66 0 4.01 3.45 4.01 5.53 0 2.57-2.07 3.07-2.89 3.07C7 9.7 5.65 6.64 5.65 4.31M9.3 22.3c-3.33 0-5.45-1.49-5.45-3.7 0-2.2 1.96-2.91 2.65-3.16 1.3-.44 3-.49 3.27-.49.3 0 .46 0 .73.02 2.34 1.69 3.35 2.44 3.35 4.03 0 1.77-1.82 3.3-4.55 3.3"/><path d="M21 10V7h-2v3h-3v2h3v3h2v-3h3v-2h-3z"/>',
	                'hangouts': '<path d="M15 11l-1 2h-1.5l1-2H12V8h3m-4 3l-1 2H8.5l1-2H8V8h3m.5-6A8.5 8.5 0 0 0 3 10.5a8.5 8.5 0 0 0 8.5 8.5h.5v3.5c4.86-2.35 8-7.5 8-12C20 5.8 16.19 2 11.5 2z"/>',
	                'linkedin-box': '<path d="M19 19h-3v-5.3a1.5 1.5 0 0 0-1.5-1.5 1.5 1.5 0 0 0-1.5 1.5V19h-3v-9h3v1.2c.5-.84 1.59-1.4 2.5-1.4a3.5 3.5 0 0 1 3.5 3.5M6.5 8.31c-1 0-1.81-.81-1.81-1.81A1.81 1.81 0 0 1 6.5 4.69c1 0 1.81.81 1.81 1.81A1.81 1.81 0 0 1 6.5 8.31M8 19H5v-9h3m12-8H4c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4c0-1.11-.9-2-2-2z"/>',
	                'linkedin': '<path d="M21 21h-4v-6.75c0-1.06-1.19-1.94-2.25-1.94S13 13.19 13 14.25V21H9V9h4v2c.66-1.07 2.36-1.76 3.5-1.76 2.5 0 4.5 2.04 4.5 4.51V21"/><path d="M7 21H3V9h4v12"/><path d="M5 3a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z"/>',
	                'login': '<path d="M10 17.25V14H3v-4h7V6.75L15.25 12 10 17.25"/><path d="M8 2h9a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-4h2v4h9V4H8v4H6V4a2 2 0 0 1 2-2z"/>',
	                'logout': '<path d="M17 17.25V14h-7v-4h7V6.75L22.25 12 17 17.25"/><path d="M13 2a2 2 0 0 1 2 2v4h-2V4H4v16h9v-4h2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9z"/>',
	                'office': '<path d="M3 18l4-1.25V7l7-2v14.5L3.5 18.25 14 22l6-1.25V3.5L13.95 2 3 5.75V18z"/>',
	                'twitter': '<path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21-.36.1-.74.15-1.13.15-.27 0-.54-.03-.8-.08.54 1.69 2.11 2.95 4 2.98-1.46 1.16-3.31 1.84-5.33 1.84-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>',
	                'whatsapp': '<path d="M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88"/><path d="M12 4a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96C8.69 19.46 10.28 20 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8zm0-2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65C2.57 15.8 2 13.97 2 12A10 10 0 0 1 12 2"/>',
	                'windows': '<path d="M3 12V6.75l6-1.32v6.48L3 12"/><path d="M20 3v8.75l-10 .15V5.21L20 3"/><path d="M3 13l6 .09v6.81l-6-1.15V13"/><path d="M20 13.25V22l-10-1.91V13.1l10 .15z"/>',
	
	
	                /*
	                 * custom icons
	                 */
	                'signal_wifi_0_bar': '<path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"/>',
	                'signal_wifi_1_bar': '<path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"/><path d="M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"/>',
	                'signal_wifi_2_bar': '<path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"/><path d="M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"/>',
	                'signal_wifi_3_bar': '<path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"/><path d="M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"/>',
	                'signal_cellular_connected_no_internet_0_bar': '<path fill-opacity=".3" d="M22 8V2L2 22h16V8z"/><path d="M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z"/>',
	                'signal_cellular_connected_no_internet_1_bar': '<path fill-opacity=".3" d="M22 8V2L2 22h16V8z"/><path d="M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"/>',
	                'signal_cellular_connected_no_internet_2_bar': '<path fill-opacity=".3" d="M22 8V2L2 22h16V8z"/><path d="M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"/>',
	                'signal_cellular_connected_no_internet_3_bar': '<path fill-opacity=".3" d="M22 8V2L2 22h16V8z"/><path d="M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z"/>',
	                'signal_cellular_0_bar': '<path fill-opacity=".3" d="M2 22h20V2z"/>',
	                'signal_cellular_1_bar': '<path fill-opacity=".3" d="M2 22h20V2z"/><path d="M12 12L2 22h10z"/>',
	                'signal_cellular_2_bar': '<path fill-opacity=".3" d="M2 22h20V2z"/><path d="M14 10L2 22h12z"/>',
	                'signal_cellular_3_bar': '<path fill-opacity=".3" d="M2 22h20V2z"/><path d="M17 7L2 22h15z"/>',
	                'now_wallpaper': '<path d="M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4z"/><path d="M10 13l-4 5h12l-3-4-2.03 2.71L10 13z"/><path d="M17 8.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5z"/><path d="M20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2z"/><path d="M20 20h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7z"/><path d="M4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"/>',
	                'now_widgets': '<path d="M13 13v8h8v-8h-8z"/><path d="M3 21h8v-8H3v8z"/><path d="M3 3v8h8V3H3z"/><path d="M16.66 1.69L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"/>',
	                'battery_20': '<path d="M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"/><path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"/>',
	                'battery_30': '<path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"/><path d="M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"/>',
	                'battery_50': '<path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"/><path d="M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"/>',
	                'battery_60': '<path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"/><path d="M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"/>',
	                'battery_80': '<path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"/><path d="M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"/>',
	                'battery_90': '<path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"/><path d="M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"/>',
	                'battery_alert': '<path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"/>',
	                'battery_charging_20': '<path d="M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"/><path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"/>',
	                'battery_charging_30': '<path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"/><path d="M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"/>',
	                'battery_charging_50': '<path d="M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"/><path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"/>',
	                'battery_charging_60': '<path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"/><path d="M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"/>',
	                'battery_charging_80': '<path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"/><path d="M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"/>',
	                'battery_charging_90': '<path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"/><path d="M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"/>',
	                'account_child': '<circle cx="12" cy="13.49" r="1.5"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 2.5c1.24 0 2.25 1.01 2.25 2.25S13.24 9 12 9 9.75 7.99 9.75 6.75 10.76 4.5 12 4.5zm5 10.56v2.5c-.45.41-.96.77-1.5 1.05v-.68c0-.34-.17-.65-.46-.92-.65-.62-1.89-1.02-3.04-1.02-.96 0-1.96.28-2.65.73l-.17.12-.21.17c.78.47 1.63.72 2.54.82l1.33.15c.37.04.66.36.66.75 0 .29-.16.53-.4.66-.28.15-.64.09-.95.09-.35 0-.69-.01-1.03-.05-.5-.06-.99-.17-1.46-.33-.49-.16-.97-.38-1.42-.64-.22-.13-.44-.27-.65-.43l-.31-.24c-.04-.02-.28-.18-.28-.23v-4.28c0-1.58 2.63-2.78 5-2.78s5 1.2 5 2.78v1.78z"/>',
	
	
	                /*
	                 * Google Material Design Icons
	                 * (https://www.google.com/design/icons)
	                 */
	                //
	                // action
	                //
	                '3d_rotation': '<path d="M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"/><path d="M16.57 12.2c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zm.39-3.16c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-8.55 5.92c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44.23-.19.42-.43.55-.72.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33z"/><path d="M12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"/>',
	                'accessibility': '<path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"/><path d="M21 9h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"/>',
	                'accessible': '<circle cx="12" cy="4" r="2"/><path d="M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z"/>',
	                'account_balance': '<path d="M4 10v7h3v-7H4z"/><path d="M10 10v7h3v-7h-3z"/><path d="M2 22h19v-3H2v3z"/><path d="M16 10v7h3v-7h-3z"/><path d="M11.5 1L2 6v2h19V6l-9.5-5z"/>',
	                'account_balance_wallet': '<path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9z"/><path d="M16 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM12 16h10V8H12v8z"/>',
	                'account_box': '<path d="M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"/>',
	                'account_circle': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>',
	                'add_shopping_cart': '<path d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3z"/><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"/><path d="M17 18c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/><path d="M7.17 14.75l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"/>',
	                'alarm': '<path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72z"/><path d="M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85z"/><path d="M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8z"/><path d="M12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm0-16c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/>',
	                'alarm_add': '<path d="M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85z"/><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72z"/><path d="M12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm0-16c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"/>',
	                'alarm_off': '<path d="M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92a9 9 0 0 0-9-9c-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6z"/><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72z"/><path d="M16.47 18.39C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8A8.964 8.964 0 0 0 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98z"/><path d="M8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z"/>',
	                'alarm_on': '<path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72z"/><path d="M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85z"/><path d="M12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm0-16c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M10.54 14.53L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z"/>',
	                'all_out': '<path d="M16.21 4.16l4 4v-4z"/><path d="M20.21 16.16l-4 4h4z"/><path d="M8.21 20.16l-4-4v4z"/><path d="M4.21 8.16l4-4h-4z"/><path d="M16.06 16.01a5.438 5.438 0 0 1-7.7 0 5.438 5.438 0 0 1 0-7.7 5.438 5.438 0 0 1 7.7 0 5.438 5.438 0 0 1 0 7.7zm1.1-8.8a7.007 7.007 0 0 0-9.9 0 7.007 7.007 0 0 0 0 9.9 7.007 7.007 0 0 0 9.9 0c2.73-2.73 2.73-7.16 0-9.9z"/>',
	                'android': '<path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10z"/><path d="M3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8z"/><path d="M20.5 8c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5z"/><path d="M15 5h-1V4h1v1zm-5 0H9V4h1v1zm5.53-2.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84z"/>',
	                'announcement': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"/>',
	                'aspect_ratio': '<path d="M19 12h-2v3h-3v2h5v-5z"/><path d="M7 9h3V7H5v5h2V9z"/><path d="M21 19.01H3V4.99h18v14.02zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'assessment': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>',
	                'assignment': '<path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>',
	                'assignment_ind': '<path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/>',
	                'assignment_late': '<path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>',
	                'assignment_return': '<path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"/>',
	                'assignment_returned': '<path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"/>',
	                'assignment_turned_in': '<path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>',
	                'autorenew': '<path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6z"/><path d="M18.76 7.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/>',
	                'backup': '<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>',
	                'book': '<path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>',
	                'bookmark': '<path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"/>',
	                'bookmark_outline': '<path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"/>',
	                'bug_report': '<path d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"/>',
	                'build': '<path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>',
	                'cached': '<path d="M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4z"/><path d="M6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"/>',
	                'camera_enhanced': '<path d="M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/> <path d="M12 17l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z"/>',
	                'card_giftcard': '<path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"/>',
	                'card_membership': '<path d="M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"/>',
	                'card_travel': '<path d="M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"/>',
	                'change_history': '<path d="M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"/>',
	                'check_circle': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>',
	                'chrome_reader_mode': '<path d="M13 12h7v1.5h-7z"/><path d="M13 9.5h7V11h-7z"/><path d="M13 14.5h7V16h-7z"/><path d="M21 19h-9V6h9v13zm0-15H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"/>',
	                'class': '<path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>',
	                'code': '<path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z"/><path d="M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>',
	                'compare_arrows': '<path d="M9.01 14H2v2h7.01v3L13 15l-3.99-4v3z"/><path d="M14.99 13v-3H22V8h-7.01V5L11 9l3.99 4z"/>',
	                'copyright': '<path d="M10.08 10.86c.05-.33.16-.62.3-.87.14-.25.34-.46.59-.62.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53c.09.2.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29-.17-.39-.4-.73-.7-1.01-.3-.28-.66-.5-1.08-.66-.42-.16-.88-.23-1.39-.23-.65 0-1.22.11-1.7.34-.48.23-.88.53-1.2.92-.32.39-.56.84-.71 1.36-.15.52-.24 1.06-.24 1.64v.27c0 .58.08 1.12.23 1.64.15.52.39.97.71 1.35.32.38.72.69 1.2.91.48.22 1.05.34 1.7.34.47 0 .91-.08 1.32-.23.41-.15.77-.36 1.08-.63.31-.27.56-.58.74-.94.18-.36.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58-.09.18-.21.33-.36.46s-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23a1.75 1.75 0 0 1-.59-.62c-.14-.25-.25-.55-.3-.88a6.74 6.74 0 0 1-.08-1v-.27c0-.35.03-.68.08-1.01z"/><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>',
	                'credit_card': '<path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>',
	                'dashboard': '<path d="M3 13h8V3H3v10z"/><path d="M3 21h8v-6H3v6z"/><path d="M13 21h8V11h-8v10z"/><path d="M13 3v6h8V3h-8z"/>',
	                'date_range': '<path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/>',
	                'delete': '<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12z"/><path d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>',
	                'delete_forever': '<path d="M8.46 11.88l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12z"/><path d="M15.5 4l-1-1h-5l-1 1H5v2h14V4z"/>',
	                'description': '<path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>',
	                'dns': '<path d="M7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm13-6H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1z"/><path d="M7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm13-6H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"/>',
	                'done': '<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>',
	                'done_all': '<path d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7z"/><path d="M22.24 5.59L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41z"/><path d="M.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"/>',
	                'donut_large': '<path d="M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92z"/><path d="M18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11z"/><path d="M13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z"/>',
	                'donut_small': '<path d="M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84 0-1.32 1-2.43 2-2.84z"/><path d="M14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84z"/><path d="M13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z"/>',
	                'eject': '<path d="M5 17h14v2H5z"/><path d="M12 5L5.33 15h13.34z"/>',
	                'euro_symbol': '<path d="M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"/>',
	                'event': '<path d="M17 12h-5v5h5v-5z"/><path d="M19 19H5V8h14v11zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2z"/>',
	                'event_seat': '<path d="M4 18v3h3v-3h10v3h3v-6H4z"/><path d="M19 10h3v3h-3z"/><path d="M2 10h3v3H2z"/><path d="M17 13H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"/>',
	                'exit_to_app': '<path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59z"/><path d="M19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'explore': '<path d="M12 10.9c-.61 0-1.1.49-1.1 1.1 0 .61.49 1.1 1.1 1.1.61 0 1.1-.49 1.1-1.1 0-.61-.49-1.1-1.1-1.1z"/><path d="M14.19 14.19L6 18l3.81-8.19L18 6l-3.81 8.19zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>',
	                'extension': '<path d="M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"/>',
	                'face': '<path d="M14.69 17.1c-.74.58-1.7.9-2.69.9s-1.95-.32-2.69-.9c-.22-.17-.53-.13-.7.09-.17.22-.13.53.09.7.91.72 2.09 1.11 3.3 1.11s2.39-.39 3.31-1.1c.22-.17.26-.48.09-.7-.17-.23-.49-.26-.71-.1z"/><path d="M19.96 14.82c-1.09 3.74-4.27 6.46-8.04 6.46-3.78 0-6.96-2.72-8.04-6.47-1.19-.11-2.13-1.18-2.13-2.52 0-1.27.85-2.31 1.97-2.5 2.09-1.46 3.8-3.49 4.09-5.05v-.01c1.35 2.63 6.3 5.19 11.83 5.06l.3-.03c1.28 0 2.31 1.14 2.31 2.54 0 1.38-1.02 2.51-2.29 2.52zM12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0z"/><path d="M16.5 12.5c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1zm-7 0c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1z"/>',
	                'favorite': '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>',
	                'favorite_border': '<path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/>',
	                'feedback': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"/>',
	                'find_in_page': '<path d="M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59z"/><path d="M9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"/>',
	                'find_replace': '<path d="M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4z"/><path d="M16.64 15.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"/>',
	                'fingerprint': '<path d="M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 0 1 .2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 0 1-.44.28z"/><path d="M3.5 9.72a.499.499 0 0 1-.41-.79c.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25a.5.5 0 0 1-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 0 0-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21z"/><path d="M9.75 21.79a.47.47 0 0 1-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15z"/><path d="M16.92 19.94c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12z"/><path d="M14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 0 1-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 0 1-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94-1.7 0-3.08-1.32-3.08-2.94 0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"/>',
	                'flight_land': '<path d="M2.5 19h19v2h-19z"/><path d="M9.68 13.27l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z"/>',
	                'flight_takeoff': '<path d="M2.5 19h19v2h-19z"/><path d="M22.07 9.64c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"/>',
	                'flip_to_back': '<path d="M9 7H7v2h2V7z"/><path d="M9 11H7v2h2v-2z"/><path d="M9 3a2 2 0 0 0-2 2h2V3z"/><path d="M13 15h-2v2h2v-2z"/><path d="M19 3v2h2c0-1.1-.9-2-2-2z"/><path d="M13 3h-2v2h2V3z"/><path d="M9 17v-2H7a2 2 0 0 0 2 2z"/><path d="M19 13h2v-2h-2v2z"/><path d="M19 9h2V7h-2v2z"/><path d="M19 17c1.1 0 2-.9 2-2h-2v2z"/><path d="M5 7H3v12a2 2 0 0 0 2 2h12v-2H5V7z"/><path d="M15 5h2V3h-2v2z"/><path d="M15 17h2v-2h-2v2z"/>',
	                'flip_to_front': '<path d="M3 13h2v-2H3v2z"/><path d="M3 17h2v-2H3v2z"/><path d="M5 21v-2H3a2 2 0 0 0 2 2z"/><path d="M3 9h2V7H3v2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M19 15H9V5h10v10zm0-12H9a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M11 21h2v-2h-2v2z"/><path d="M7 21h2v-2H7v2z"/>',
	                'g_translate': '<path d="M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"/>',
	                'gavel': '<path d="M1 21h12v2H1z"/><path d="M5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828z"/><path d="M12.317 1l5.657 5.656-2.83 2.83-5.654-5.66z"/><path d="M3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z"/>',
	                'get_app': '<path d="M19 9h-4V3H9v6H5l7 7 7-7z"/><path d="M5 18v2h14v-2H5z"/>',
	                'gif': '<path d="M11.5 9H13v6h-1.5z"/><path d="M9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1z"/><path d="M19 10.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"/>',
	                'grade': '<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>',
	                'group_work': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>',
	                'help': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>',
	                'help_outline': '<path d="M11 18h2v-2h-2v2z"/><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/><path d="M12 6c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"/>',
	                'highlight_off': '<path d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8z"/><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z"/>',
	                'history': '<path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M12 8v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>',
	                'home': '<path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>',
	                'hourglass_empty': '<path d="M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"/>',
	                'hourglass_full': '<path d="M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"/>',
	                'http': '<path d="M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2z"/><path d="M7 10.5h1.5V15H10v-4.5h1.5V9H7v1.5z"/><path d="M12.5 10.5H14V15h1.5v-4.5H17V9h-4.5v1.5z"/><path d="M21.5 11.5h-2v-1h2v1zm0-2.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5z"/>',
	                'https': '<path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>',
	                'important_devices': '<path d="M23 20h-5v-7h5v7zm0-8.99L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99z"/><path d="M20 2H2C.89 2 0 2.89 0 4v12a2 2 0 0 0 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4a2 2 0 0 0-2-2z"/><path d="M11.97 9L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"/>',
	                'info': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>',
	                'info_outline': '<path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/><path d="M11 9h2V7h-2v2zm0 8h2v-6h-2v6z"/>',
	                'input': '<path d="M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2z"/><path d="M11 16l4-4-4-4v3H1v2h10v3z"/>',
	                'invert_colors': '<path d="M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"/>',
	                'label': '<path d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"/>',
	                'label_outline': '<path d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"/>',
	                'language': '<path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/>',
	                'launch': '<path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7z"/><path d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>',
	                'lightbulb_outline': '<path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1z"/><path d="M14.85 13.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 0 1 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1zM12 2C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z"/>',
	                'line_style': '<path d="M3 16h5v-2H3v2z"/><path d="M9.5 16h5v-2h-5v2z"/><path d="M16 16h5v-2h-5v2z"/><path d="M3 20h2v-2H3v2z"/><path d="M7 20h2v-2H7v2z"/><path d="M11 20h2v-2h-2v2z"/><path d="M15 20h2v-2h-2v2z"/><path d="M19 20h2v-2h-2v2z"/><path d="M3 12h8v-2H3v2z"/><path d="M13 12h8v-2h-8v2z"/><path d="M3 4v4h18V4H3z"/>',
	                'line_weight': '<path d="M3 17h18v-2H3v2z"/><path d="M3 20h18v-1H3v1z"/><path d="M3 13h18v-3H3v3z"/><path d="M3 4v4h18V4H3z"/>',
	                'list': '<path d="M3 9h2V7H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2z"/><path d="M7 13h14v-2H7v2z"/><path d="M7 17h14v-2H7v2z"/><path d="M7 7v2h14V7H7z"/>',
	                'lock': '<path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>',
	                'lock_open': '<path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/><path d="M18 20H6V10h12v10zm0-12h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2z"/>',
	                'lock_outline': '<path d="M18 20H6V10h12zM12 2.9c1.71 0 3.1 1.39 3.1 3.1v2H9V6l-.002-.008C8.998 4.282 10.29 2.9 12 2.9zM18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2z"/><path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>',
	                'loyalty': '<path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"/>',
	                'markunread_mailbox': '<path d="M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"/>',
	                'motorcycle': '<path d="M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/>',
	                'note_add': '<path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"/>',
	                'offline_pin': '<path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z"/>',
	                'opacity': '<path d="M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"/>',
	                'open_in_browser': '<path d="M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2z"/><path d="M12 10l-4 4h3v6h2v-6h3l-4-4z"/>',
	                'open_in_new': '<path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7z"/><path d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>',
	                'open_with': '<path d="M10 9h4V6h3l-5-5-5 5h3v3z"/><path d="M9 10H6V7l-5 5 5 5v-3h3v-4z"/><path d="M23 12l-5-5v3h-3v4h3v3l5-5z"/><path d="M14 15h-4v3H7l5 5 5-5h-3v-3z"/>',
	                'pageview': '<path d="M11 8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/><path d="M17.59 19l-3.83-3.83c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L19 17.59 17.59 19zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'pan_tool': '<path d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>',
	                'payment': '<path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>',
	                'perm_camera_mic': '<path d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"/>',
	                'perm_contact_calendar': '<path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"/>',
	                'perm_data_setting': '<path d="M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5z"/><path d="M18.99 20.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm3.71-1.01c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83z"/>',
	                'perm_device_information': '<path d="M13 11h-2v6h2v-6zm0-4h-2v2h2V7z"/><path d="M17 19H7V5h10v14zm0-17.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"/>',
	                'perm_identity': '<path d="M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1.9c1.16 0 2.1.94 2.1 2.1 0 1.16-.94 2.1-2.1 2.1-1.16 0-2.1-.94-2.1-2.1 0-1.16.94-2.1 2.1-2.1"/><path d="M12 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm0 1.9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1"/>',
	                'perm_media': '<path d="M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6z"/><path d="M7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7zM22 4h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"/>',
	                'perm_phone_msg': '<path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/><path d="M12 3v10l3-3h6V3h-9z"/>',
	                'perm_scan_wifi': '<path d="M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z"/>',
	                'pets': '<circle cx="4.5" cy="9.5" r="2.5"/> <circle cx="9" cy="5.5" r="2.5"/> <circle cx="15" cy="5.5" r="2.5"/> <circle cx="19.5" cy="9.5" r="2.5"/> <path d="M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"/>',
	                'picture_in_picture': '<path d="M19 7h-8v6h8V7z"/><path d="M21 19.01H3V4.98h18v14.03zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2z"/>',
	                'picture_in_picture_alt': '<path d="M19 11h-8v6h8v-6z"/><path d="M21 19.02H3V4.97h18v14.05zm2-.02V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2z"/>',
	                'play_for_work': '<path d="M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2z"/><path d="M6 14c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"/>',
	                'polymer': '<path d="M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z"/>',
	                'power_settings_new': '<path d="M13 3h-2v10h2V3z"/><path d="M17.83 5.17l-1.42 1.42A6.92 6.92 0 0 1 19 12c0 3.87-3.13 7-7 7A6.995 6.995 0 0 1 7.58 6.58L6.17 5.17A8.932 8.932 0 0 0 3 12a9 9 0 0 0 18 0c0-2.74-1.23-5.18-3.17-6.83z"/>',
	                'pregnant_woman': '<path d="M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"/>',
	                'print': '<path d="M19 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-3 7H8v-5h8v5zm3-11H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3z"/><path d="M18 3H6v4h12V3z"/>',
	                'query_builder': '<path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.01-18C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z"/><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>',
	                'question_answer': '<path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"/><path d="M17 12V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>',
	                'receipt': '<path d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"/>',
	                'record_voice_over': '<circle cx="9" cy="9" r="4"/><path d="M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"/>',
	                'redeem': '<path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"/>',
	                'remove_shopping_cart': '<path d="M7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm15.31 7.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38A1.997 1.997 0 0 0 17 22c.67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27z"/><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H6.54l9.01 9z"/><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"/>',
	                'reorder': '<path d="M3 15h18v-2H3v2z"/><path d="M3 19h18v-2H3v2z"/><path d="M3 11h18V9H3v2z"/><path d="M3 5v2h18V5H3z"/>',
	                'report_problem': '<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>',
	                'restore': '<path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M12 8v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>',
	                'restore_page': '<path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"/>',
	                'room': '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>',
	                'rounded_corner': '<path d="M19 19h2v2h-2v-2z"/><path d="M19 17h2v-2h-2v2z"/><path d="M3 13h2v-2H3v2z"/><path d="M3 17h2v-2H3v2z"/><path d="M3 9h2V7H3v2z"/><path d="M3 5h2V3H3v2z"/><path d="M7 5h2V3H7v2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M11 21h2v-2h-2v2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M7 21h2v-2H7v2z"/><path d="M3 21h2v-2H3v2z"/><path d="M21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"/>',
	                'rowing': '<path d="M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5z"/><path d="M15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M21 21.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"/>',
	                'schedule': '<path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.01-18C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z"/><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>',
	                'search': '<path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>',
	                'settings': '<path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/>',
	                'settings_applications': '<path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M17.25 12c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69zM19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2z"/>',
	                'settings_backup_restore': '<path d="M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"/><path d="M12 3c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/>',
	                'settings_bluetooth': '<path d="M15 24h2v-2h-2v2zm-8 0h2v-2H7v2zm4 0h2v-2h-2v2z"/><path d="M14.88 14.29L13 16.17v-3.76l1.88 1.88zM13 3.83l1.88 1.88L13 7.59V3.83zm4.71 1.88L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29z"/>',
	                'settings_brightness': '<path d="M21 19.01H3V4.99h18v14.02zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M12 9c1.66 0 3 1.34 3 3s-1.34 3-3 3V9zm-4 7h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16z"/>',
	                'settings_cell': '<path d="M15 24h2v-2h-2v2zm-4 0h2v-2h-2v2zm-4 0h2v-2H7v2z"/><path d="M16 16H8V4h8v12zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99z"/>',
	                'settings_ethernet': '<path d="M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24z"/><path d="M11 13h2v-2h-2v2zm6-2h-2v2h2v-2zM7 13h2v-2H7v2z"/><path d="M17.77 5.48l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"/>',
	                'settings_input_antenna': '<path d="M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7z"/><path d="M13 14.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3z"/><path d="M12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z"/>',
	                'settings_input_component': '<path d="M1 16c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2z"/><path d="M13 2c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zM9 16c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2z"/><path d="M17 16c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2zm4-10V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2z"/>',
	                'settings_input_composite': '<path d="M1 16c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2z"/><path d="M13 2c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zM9 16c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2z"/><path d="M17 16c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2zm4-10V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2z"/>',
	                'settings_input_hdmi': '<path d="M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"/>',
	                'settings_input_svideo': '<path d="M15 6.5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5z"/><path d="M8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5z"/><path d="M12 21c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm0-20C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1z"/><path d="M15.5 15c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm2-5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"/>',
	                'settings_overscan': '<path d="M14 16h-4l2.01 2.5L14 16zm-8-6l-2.5 2.01L6 14v-4zm12 0v4l2.5-1.99L18 10zm-5.99-4.5L10 8h4l-1.99-2.5z"/><path d="M21 19.01H3V4.99h18v14.02zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'settings_phone': '<path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/><path d="M19 9v2h2V9h-2zm-2 0h-2v2h2V9zm-4 0h-2v2h2V9z"/>',
	                'settings_power': '<path d="M13 2h-2v10h2V2z"/><path d="M16.56 4.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56z"/><path d="M15 24h2v-2h-2v2zm-4 0h2v-2h-2v2zm-4 0h2v-2H7v2z"/>',
	                'settings_remote': '<path d="M12 15c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3-6H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1z"/><path d="M7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4c-1.93 0-3.68.78-4.95 2.05z"/><path d="M12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"/>',
	                'settings_voice': '<path d="M12 13c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3z"/><path d="M15 24h2v-2h-2v2zm-4 0h2v-2h-2v2zm-4 0h2v-2H7v2z"/><path d="M19 10h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"/>',
	                'shop': '<path d="M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z"/>',
	                'shop_two': '<path d="M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9z"/><path d="M12 15V8l5.5 3-5.5 4zm0-12h4v2h-4V3zm6 2V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5z"/>',
	                'shopping_basket': '<path d="M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>',
	                'shopping_cart': '<path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"/><path d="M1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1z"/><path d="M17 18c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>',
	                'speaker_notes': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"/>',
	                'speaker_notes_off': '<path d="M6 11V9l2 2H6zm2 3H6v-2h2v2zm2.54-3l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7z"/><path d="M20 2H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z"/>',
	                'spellcheck': '<path d="M6.43 11L8.5 5.48 10.57 11H6.43zm6.02 5h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3z"/><path d="M21.59 11.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"/>',
	                'star_rate': '<path d="M12 14.3l3.71 2.7-1.42-4.36L18 10h-4.55L12 5.5 10.55 10H6l3.71 2.64L8.29 17z"/>',
	                'stars': '<path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/>',
	                'store': '<path d="M20 4H4v2h16V4z"/><path d="M12 18H6v-4h6v4zm9-4v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1z"/>',
	                'subject': '<path d="M14 17H4v2h10v-2z"/><path d="M20 9H4v2h16V9z"/><path d="M4 15h16v-2H4v2z"/><path d="M4 5v2h16V5H4z"/>',
	                'supervisor_account': '<path d="M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5z"/><path d="M9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3z"/><path d="M16.5 14c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75z"/><path d="M9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"/>',
	                'swap_horiz': '<path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3z"/><path d="M21 9l-3.99-4v3H10v2h7.01v3L21 9z"/>',
	                'swap_vert': '<path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3z"/><path d="M9 3L5 6.99h3V14h2V6.99h3L9 3z"/>',
	                'swap_vertial_circle': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z"/>',
	                'system_update_alt': '<path d="M12 16.5l4-4h-3v-9h-2v9H8l4 4z"/><path d="M21 3.5h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"/>',
	                'tab': '<path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"/>',
	                'tab_unselected': '<path d="M1 9h2V7H1v2z"/><path d="M1 13h2v-2H1v2z"/><path d="M1 5h2V3c-1.1 0-2 .9-2 2z"/><path d="M9 21h2v-2H9v2z"/><path d="M1 17h2v-2H1v2z"/><path d="M3 21v-2H1c0 1.1.9 2 2 2z"/><path d="M21 3h-8v6h10V5c0-1.1-.9-2-2-2z"/><path d="M21 17h2v-2h-2v2z"/><path d="M9 5h2V3H9v2z"/><path d="M5 21h2v-2H5v2z"/><path d="M5 5h2V3H5v2z"/><path d="M21 21c1.1 0 2-.9 2-2h-2v2z"/><path d="M21 13h2v-2h-2v2z"/><path d="M13 21h2v-2h-2v2z"/><path d="M17 21h2v-2h-2v2z"/>',
	                'theaters': '<path d="M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"/>',
	                'thumb_down': '<path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2z"/><path d="M19 3v12h4V3h-4z"/>',
	                'thumb_up': '<path d="M1 21h4V9H1v12z"/><path d="M23 10c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"/>',
	                'thumbs_up_down': '<path d="M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6z"/><path d="M22.5 10h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"/>',
	                'timeline': '<path d="M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"/>',
	                'toc': '<path d="M3 9h14V7H3v2z"/><path d="M3 13h14v-2H3v2z"/><path d="M3 17h14v-2H3v2z"/><path d="M19 13h2v-2h-2v2zm0-6v2h2V7h-2zm0 10h2v-2h-2v2z"/>',
	                'today': '<path d="M19 19H5V8h14v11zm0-16h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M7 10h5v5H7z"/>',
	                'toll': '<path d="M3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z"/>',
	                'touch_app': '<path d="M9 11.24V7.5a2.5 2.5 0 0 1 5 0v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74z"/><path d="M18.84 15.87l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"/>',
	                'track_changes': '<path d="M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"/>',
	                'translate': '<path d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04z"/><path d="M15.88 17l1.62-4.33L19.12 17h-3.24zm2.62-7h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12z"/>',
	                'trending_down': '<path d="M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"/>',
	                'trending_flat': '<path d="M22 12l-4-4v3H3v2h15v3z"/>',
	                'trending_up': '<path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>',
	                'turned_in': '<path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"/>',
	                'turned_in_not': '<path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"/>',
	                'update': '<path d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1a6.875 6.875 0 0 0 0 9.79 7.02 7.02 0 0 0 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58a8.987 8.987 0 0 1 12.65 0L21 3v7.12z"/><path d="M12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"/>',
	                'verified_user': '<path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>',
	                'view_agenda': '<path d="M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1z"/><path d="M20 3H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"/>',
	                'view_array': '<path d="M4 18h3V5H4v13z"/><path d="M18 5v13h3V5h-3z"/><path d="M8 18h9V5H8v13z"/>',
	                'view_carousel': '<path d="M7 19h10V4H7v15z"/><path d="M2 17h4V6H2v11z"/><path d="M18 6v11h4V6h-4z"/>',
	                'view_column': '<path d="M10 18h5V5h-5v13z"/><path d="M4 18h5V5H4v13z"/><path d="M16 5v13h5V5h-5z"/>',
	                'view_day': '<path d="M2 21h19v-3H2v3z"/><path d="M20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"/><path d="M2 3v3h19V3H2z"/>',
	                'view_headline': '<path d="M4 15h17v-2H4v2z"/><path d="M4 19h17v-2H4v2z"/><path d="M4 11h17V9H4v2z"/><path d="M4 5v2h17V5H4z"/>',
	                'view_list': '<path d="M4 14h4v-4H4v4z"/><path d="M4 19h4v-4H4v4z"/><path d="M4 9h4V5H4v4z"/><path d="M9 14h12v-4H9v4z"/><path d="M9 19h12v-4H9v4z"/><path d="M9 5v4h12V5H9z"/>',
	                'view_module': '<path d="M4 11h5V5H4v6z"/><path d="M4 18h5v-6H4v6z"/><path d="M10 18h5v-6h-5v6z"/><path d="M16 18h5v-6h-5v6z"/><path d="M10 11h5V5h-5v6z"/><path d="M16 5v6h5V5h-5z"/>',
	                'view_quilt': '<path d="M10 18h5v-6h-5v6z"/><path d="M4 18h5V5H4v13z"/><path d="M16 18h5v-6h-5v6z"/><path d="M10 5v6h11V5H10z"/>',
	                'view_stream': '<path d="M4 18h17v-6H4v6z"/><path d="M4 5v6h17V5H4z"/>',
	                'view_week': '<path d="M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"/><path d="M20 5h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"/><path d="M13 5h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"/>',
	                'visibility': '<path d="M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"/><path d="M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>',
	                'visibility_off': '<path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7z"/><path d="M7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27z"/><path d="M11.84 9.02l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>',
	                'watch_later': '<path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"/>',
	                'work': '<path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/>',
	                'youtube_searched_for': '<path d="M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z"/>',
	                'zoom_in': '<path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/><path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>',
	                'zoom_out': '<path d="M9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm6 0h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/><path d="M7 9h5v1H7z"/>',
	                //
	                // alert
	                //
	                'add_alert':'<path d="M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"/>',
	                'error': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>',
	                'error_outline':'<path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>',
	                'warning': '<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>',
	                //
	                // av
	                //
	                'add_to_queue': '<path d="M21 17H3V5h18v12zm0-14H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2z"/><path d="M16 10v2h-3v3h-2v-3H8v-2h3V7h2v3h3z"/>',
	                'airplay': '<path d="M6 22h12l-6-6z"/><path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'album': '<path d="M12 16.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/><path d="M12 11c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/>',
	                'art_track': '<path d="M22 13h-8v-2h8v2z"/><path d="M22 7h-8v2h8V7z"/><path d="M14 17h8v-2h-8v2z"/><path d="M10.5 15l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7zM12 9v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2z"/>',
	                'av_timer': '<path d="M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"/><path d="M11 3v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1z"/><path d="M18 12c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1z"/><path d="M6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"/>',
	                'branding_watermark': '<path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z"/>',
	                'call_to_action': '<path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z"/>',
	                'closed_caption': '<path d="M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"/>',
	                'equalizer': '<path d="M10 20h4V4h-4v16z"/><path d="M4 20h4v-8H4v8z"/><path d="M16 9v11h4V9h-4z"/>',
	                'explicit': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z"/>',
	                'fast_forward': '<path d="M4 18l8.5-6L4 6v12z"/><path d="M13 6v12l8.5-6L13 6z"/>',
	                'fast_rewind': '<path d="M11 18V6l-8.5 6 8.5 6z"/><path d="M11.5 12l8.5 6V6l-8.5 6z"/>',
	                'featured_play_list': '<path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z"/>',
	                'featured_video': '<path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z"/>',
	                'fibre_dvr': '<path d="M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z"/>',
	                'fiber_manual_record': '<circle cx="12" cy="12" r="8"/>',
	                'fibre_new': '<path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z"/>',
	                'fibre_pin': '<path d="M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z"/>',
	                'fibre_smart_record': '<path d="M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z"/>',
	                'forward_10': '<path d="M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"/><path d="M10.8 16H10v-3.3L9 13v-.7l1.8-.6h.1V16z"/><path d="M14.3 13.4v-.5s-.1-.2-.1-.3c0-.1-.1-.1-.2-.2s-.2-.1-.3-.1c-.1 0-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3c0 .1.1.1.2.2s.2.1.3.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zm.8.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1c-.2 0-.4 0-.6-.1-.2-.1-.3-.2-.5-.3-.2-.1-.2-.3-.3-.6-.1-.3-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.3.2.5.3.2.1.2.3.3.6.1.3.1.5.1.8v.7z"/>',
	                'forward_30': '<path d="M9.6 13.5h.4c.2 0 .4-.1.5-.2.1-.1.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4c.1-.1.3-.2.4-.2.1 0 .4-.1.5-.1.2 0 .4 0 .6.1.2.1.3.1.5.2s.2.2.3.4c.1.2.1.3.1.5v.3s-.1.2-.1.3c0 .1-.1.2-.2.2s-.2.1-.3.2c.2.1.4.2.5.4.1.2.2.4.2.6 0 .2 0 .4-.1.5-.1.1-.2.3-.3.4-.1.1-.3.2-.5.2s-.4.1-.6.1c-.2 0-.4 0-.5-.1-.1-.1-.3-.1-.5-.2s-.2-.2-.3-.4c-.1-.2-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7z"/><path d="M14.4 13.4v-.5s-.1-.2-.1-.3c0-.1-.1-.1-.2-.2s-.2-.1-.3-.1c-.1 0-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3c0 .1.1.1.2.2s.2.1.3.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zm.9.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1c-.2 0-.4 0-.6-.1-.2-.1-.3-.2-.5-.3-.2-.1-.2-.3-.3-.6-.1-.3-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.3.2.5.3.2.1.2.3.3.6.1.3.1.5.1.8v.7z"/><path d="M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"/>',
	                'forward_5': '<path d="M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"/><path d="M10.7 13.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1.1.1.3.2.4.3.1.1.2.3.3.5.1.2.1.4.1.6 0 .2 0 .4-.1.5-.1.1-.1.3-.3.5-.2.2-.3.2-.5.3-.2.1-.4.1-.6.1-.2 0-.4 0-.5-.1-.1-.1-.3-.1-.5-.2s-.2-.2-.3-.4c-.1-.2-.1-.3-.1-.5h.8c0 .2.1.3.2.4.1.1.2.1.4.1.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z"/>',
	                'games': '<path d="M15 7.5V2H9v5.5l3 3 3-3z"/><path d="M7.5 9H2v6h5.5l3-3-3-3z"/><path d="M9 16.5V22h6v-5.5l-3-3-3 3z"/><path d="M16.5 9l-3 3 3 3H22V9h-5.5z"/>',
	                'hd': '<path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"/>',
	                'hearing': '<path d="M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2z"/><path d="M7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36z"/><path d="M11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z"/>',
	                'high_quality': '<path d="M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z"/>',
	                'my_library_add': '<path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/><path d="M19 11h-4v4h-2v-4H9V9h4V5h2v4h4v2zm1-9H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>',
	                'my_library_books': '<path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/><path d="M19 7H9V5h10v2zm-4 8H9v-2h6v2zm4-4H9V9h10v2zm1-9H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>',
	                'my_library_music': '<path d="M18 7h-3v5.5a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zm2-5H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/>',
	                'loop': '<path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8z"/><path d="M12 18c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/>',
	                'mic': '<path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/><path d="M17.3 11c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>',
	                'mic_none': '<path d="M10.8 4.9c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zM12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/><path d="M17.3 11c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>',
	                'mic_off': '<path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28z"/><path d="M14.98 11.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99z"/><path d="M4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"/>',
	                'movie': '<path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"/>',
	                'music_video': '<path d="M21 19H3V5h18v14zm0-16H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03A3.003 3.003 0 0 1 11 18c-1.66 0-3-1.34-3-3z"/>',
	                'new_releases': '<path d="M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"/>',
	                'not_interested': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"/>',
	                'note': '<path d="M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z"/>',
	                'pause': '<path d="M6 19h4V5H6v14z"/><path d="M14 5v14h4V5h-4z"/>',
	                'pause_circle_filled': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>',
	                'pause_circle_outline': '<path d="M9 16h2V8H9v8z"/><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/><path d="M13 16h2V8h-2v8z"/>',
	                'play_arrow': '<path d="M8 5v14l11-7z"/>',
	                'play_circle_fill': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>',
	                'play_circle_outline': '<path d="M10 16.5l6-4.5-6-4.5v9z"/><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>',
	                'playlist_add': '<path d="M14 10H2v2h12v-2z"/><path d="M14 6H2v2h12V6z"/><path d="M18 14v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z"/><path d="M2 16h8v-2H2v2z"/>',
	                'playlist_add_check': '<path d="M14 10H2v2h12v-2z"/><path d="M14 6H2v2h12V6z"/><path d="M2 16h8v-2H2v2z"/><path d="M21.5 11.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"/>',
	                'playlist_play': '<path d="M19 9H2v2h17V9z"/><path d="M19 5H2v2h17V5z"/><path d="M2 15h13v-2H2v2z"/><path d="M17 13v6l5-3-5-3z"/>',
	                'queue': '<path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/><path d="M19 11h-4v4h-2v-4H9V9h4V5h2v4h4v2zm1-9H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>',
	                'queue_music': '<path d="M15 6H3v2h12V6z"/><path d="M15 10H3v2h12v-2z"/><path d="M3 16h8v-2H3v2z"/><path d="M17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z"/>',
	                'queue_play_next': '<path d="M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5a2 2 0 0 0-2-2z"/><path d="M13 10V7h-2v3H8v2h3v3h2v-3h3v-2h-3z"/><path d="M24 18l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"/>',
	                'radio': '<path d="M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"/>',
	                'recent_actors': '<path d="M17 19h2V5h-2v14zm4-14v14h2V5h-2z"/><path d="M12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"/>',
	                'remove_from_queue': '<path d="M21 17H3V5h18v12zm0-14H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2z"/><path d="M16 10v2H8v-2h8z"/>',
	                'repeat': '<path d="M7 7h10v3l4-4-4-4v3H5v6h2V7z"/><path d="M17 17H7v-3l-4 4 4 4v-3h12v-6h-2v4z"/>',
	                'repeat_one': '<path d="M7 7h10v3l4-4-4-4v3H5v6h2V7z"/><path d="M17 17H7v-3l-4 4 4 4v-3h12v-6h-2v4z"/><path d="M13 15V9h-1l-2 1v1h1.5v4H13z"/>',
	                'replay': '<path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>',
	                'replay_10': '<path d="M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8z"/><path d="M10.9 16H10v-3.3L9 13v-.7l1.8-.6h.1V16z"/><path d="M14.3 13.4v-.5s-.1-.2-.1-.3c0-.1-.1-.1-.2-.2s-.2-.1-.3-.1c-.1 0-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3c0 .1.1.1.2.2s.2.1.3.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zm.9.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1c-.2 0-.4 0-.6-.1-.2-.1-.3-.2-.5-.3-.2-.1-.2-.3-.3-.6-.1-.3-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.3.2.5.3.2.1.2.3.3.6.1.3.1.5.1.8v.7z"/>',
	                'replay_30': '<path d="M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8z"/><path d="M9.6 13.5h.4c.2 0 .4-.1.5-.2.1-.1.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4c.1-.1.3-.2.4-.2.1 0 .4-.1.5-.1.2 0 .4 0 .6.1.2.1.3.1.5.2s.2.2.3.4c.1.2.1.3.1.5v.3s-.1.2-.1.3c0 .1-.1.2-.2.2s-.2.1-.3.2c.2.1.4.2.5.4.1.2.2.4.2.6 0 .2 0 .4-.1.5-.1.1-.2.3-.3.4-.1.1-.3.2-.5.2s-.4.1-.6.1c-.2 0-.4 0-.5-.1-.1-.1-.3-.1-.5-.2s-.2-.2-.3-.4c-.1-.2-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7z"/><path d="M14.5 13.4v-.5c0-.1-.1-.2-.1-.3 0-.1-.1-.1-.2-.2s-.2-.1-.3-.1c-.1 0-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3c0 .1.1.1.2.2s.2.1.3.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zm.8.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1c-.2 0-.4 0-.6-.1-.2-.1-.3-.2-.5-.3-.2-.1-.2-.3-.3-.6-.1-.3-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.3.2.5.3.2.1.2.3.3.6.1.3.1.5.1.8v.7z"/>',
	                'replay_5': '<path d="M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8z"/><path d="M10.7 13.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1.1.1.3.2.4.3.1.1.2.3.3.5.1.2.1.4.1.6 0 .2 0 .4-.1.5-.1.1-.1.3-.3.5-.2.2-.3.2-.4.3-.1.1-.4.1-.6.1-.2 0-.4 0-.5-.1-.1-.1-.3-.1-.5-.2s-.2-.2-.3-.4c-.1-.2-.1-.3-.1-.5h.8c0 .2.1.3.2.4.1.1.2.1.4.1.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z"/>',
	                'shuffle': '<path d="M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41z"/><path d="M14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5z"/><path d="M14.83 13.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"/>',
	                'skip_next': '<path d="M6 18l8.5-6L6 6v12z"/><path d="M16 6v12h2V6h-2z"/>',
	                'skip_previous': '<path d="M6 6h2v12H6z"/><path d="M9.5 12l8.5 6V6z"/>',
	                'slow_motion_video': '<path d="M13.05 9.79L10 7.5v9l3.05-2.29L16 12z"/><path d="M13.05 9.79L10 7.5v9l3.05-2.29L16 12z"/><path d="M13.05 9.79L10 7.5v9l3.05-2.29L16 12z"/><path d="M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0 1 11 4.07z"/><path d="M5.69 7.1L4.26 5.68A9.949 9.949 0 0 0 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9z"/><path d="M4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 0 1 4.07 13z"/><path d="M5.68 19.74A9.981 9.981 0 0 0 11 21.95v-2.02a7.941 7.941 0 0 1-3.9-1.62l-1.42 1.43z"/><path d="M22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"/>',
	                'snooze': '<path d="M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85z"/><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72z"/><path d="M12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm0-16c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M9 11h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z"/>',
	                'sort_by_alpha': '<path d="M14.94 4.66h-4.72l2.36-2.36z"/><path d="M10.25 19.37h4.66l-2.33 2.33z"/><path d="M4.97 13.64l1.94-5.18 1.94 5.18H4.97zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1z"/><path d="M15.73 16.14h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"/>',
	                'stop': '<path d="M6 6h12v12H6z"/>',
	                'subscriptions': '<path d="M20 8H4V6h16v2z"/><path d="M18 2H6v2h12V2z"/><path d="M16 16l-6-3.27v6.53L16 16zm6-4v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2z"/>',
	                'subtitles': '<path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"/>',
	                'surround_sound': '<path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>',
	                'video_call': ' <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"/>',
	                'video_label': '<path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"/>',
	                'video_library': '<path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/><path d="M12 14.5v-9l6 4.5-6 4.5zM20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>',
	                'videocam': '<path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>',
	                'videocam_off': '<path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5z"/><path d="M3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"/>',
	                'volume_down': '<path d="M18.5 12A4.5 4.5 0 0 0 16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/><path d="M5 9v6h4l5 5V4L9 9H5z"/>',
	                'volume_mute': '<path d="M7 9v6h4l5 5V4l-5 5H7z"/>',
	                'volume_off': '<path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63z"/><path d="M19 12c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71z"/><path d="M4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3z"/><path d="M12 4L9.91 6.09 12 8.18V4z"/>',
	                'volume_up': '<path d="M3 9v6h4l5 5V4L7 9H3z"/><path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/><path d="M14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z"/>',
	                'web': '<path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"/>',
	                'web_asset': '<path d="M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z" />',
	                //
	                // communication
	                //
	                'business': '<path d="M20 19h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zM10 7H8V5h2v2zm0 4H8V9h2v2zm0 4H8v-2h2v2zm0 4H8v-2h2v2zM6 7H4V5h2v2zm0 4H4V9h2v2zm0 4H4v-2h2v2zm0 4H4v-2h2v2zm6-12V3H2v18h20V7H12z"/><path d="M18 11h-2v2h2v-2z"/><path d="M18 15h-2v2h2v-2z"/>',
	                'call': '<path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>',
	                'call_end': '<path d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"/>',
	                'call_made': '<path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"/>',
	                'call_merge': '<path d="M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41z"/><path d="M7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"/>',
	                'call_missed': '<path d="M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z"/>',
	                'call_missed_outgoing':'<path d="M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"/>',
	                'call_received': '<path d="M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z"/>',
	                'call_split': '<path d="M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4z"/><path d="M10 4H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"/>',
	                'chat': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/>',
	                'chat_bubble': '<path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>',
	                'chat_bubble_outline': '<path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>',
	                'clear_all': '<path d="M5 13h14v-2H5v2z"/><path d="M3 17h14v-2H3v2z"/><path d="M7 7v2h14V7H7z"/>',
	                'comment': '<path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>',
	                'contact_mail':'<path d="M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"/>',
	                'contact_phone':'<path d="M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"/>',
	                'contacts': '<path d="M20 0H4v2h16V0z"/><path d="M4 24h16v-2H4v2z"/><path d="M17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17zM12 6.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"/>',
	                'dialer_sip': '<path d="M20 5h-1V4h1v1zm-2-2v5h1V6h2V3h-3zm-3 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm2-2h-1v5h1V3z"/><path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/>',
	                'dialpad': '<path d="M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M6 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M18 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/><path d="M12 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>',
	                'email': '<path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>',
	                'forum': '<path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"/><path d="M17 12V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>',
	                'import_contacts': '<path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>',
	                'import_export': '<path d="M9 3L5 6.99h3V14h2V6.99h3L9 3z"/><path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3z"/>',
	                'invert_colors_off': '<path d="M12 19.59c-1.6 0-3.11-.62-4.24-1.76A5.945 5.945 0 0 1 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zm8.65 1.28l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78a8.005 8.005 0 0 0 .56 10.69A7.98 7.98 0 0 0 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36z"/><path d="M12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z"/>',
	                'live_help': '<path d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>',
	                'location_off': '<path d="M12 6.5A2.5 2.5 0 0 1 14.5 9c0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7a7 7 0 0 0-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84z"/><path d="M16.37 16.1l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z"/>',
	                'location_on': '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>',
	                'mail_outline': '<path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>',
	                'message': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>',
	                'no_sim': '<path d="M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5z"/><path d="M3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"/>',
	                'phone': '<path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>',
	                'phonelink_erase':'<path d="M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/>',
	                'phonelink_lock':'<path d="M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"/>',
	                'phonelink_ring':'<path d="M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"/>',
	                'phonelink_setup':'<path d="M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/>',
	                'portable_wifi_off': '<path d="M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06a3.999 3.999 0 0 1 3.95 4.63l1.61 1.61z"/><path d="M12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47A9.86 9.86 0 0 0 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4z"/><path d="M3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z"/>',
	                'present_to_all': '<path d="M21 19.02H3V4.98h18v14.04zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2z"/><path d="M10 12H8l4-4 4 4h-2v4h-4v-4z"/>',
	                'ring_volume': '<path d="M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7z"/><path d="M21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55z"/><path d="M13 2h-2v5h2V2z"/><path d="M6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"/>',
	                'rss_feed': '<path d="M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56z"/><path d="M4 10.1v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"/>',
	                'screen_share': '<path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"/>',
	                'stay_current_landscape': '<path d="M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"/>',
	                'stay_current_portrait': '<path d="M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>',
	                'stay_primary_landscape': '<path d="M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"/>',
	                'stay_primary_portrait': '<path d="M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>',
	                'stop_screen_share': '<path d="M21.22 18.02l2 2H24v-2h-2.78z"/><path d="M21.99 16.02l.01-10a2 2 0 0 0-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74z"/><path d="M7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10a2 2 0 0 0 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73z"/>',
	                'swap_calls': '<path d="M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"/>',
	                'textsms': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"/>',
	                'voicemail': '<path d="M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"/>',
	                'vpn_key': '<path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>',
	                //
	                // content
	                //
	                'add': '<path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>',
	                'add_box': '<path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>',
	                'add_circle': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>',
	                'add_circle_outline': '<path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7z"/><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>',
	                'archive': '<path d="M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"/>',
	                'backspace': '<path d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"/>',
	                'block': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"/>',
	                'clear': '<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>',
	                'content_copy': '<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1z"/><path d="M19 21H8V7h11v14zm0-16H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"/>',
	                'content_cut': '<path d="M12 12.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM6 20a2 2 0 1 1-.001-3.999A2 2 0 0 1 6 20zM6 8a2 2 0 1 1-.001-3.999A2 2 0 0 1 6 8zm3.64-.36c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64z"/><path d="M19 3l-6 6 2 2 7-7V3z"/>',
	                'content_paste': '<path d="M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"/>',
	                'create': '<path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z"/><path d="M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>',
	                'delete_sweep': '<path d="M15 16h4v2h-4z"/><path d="M15 8h7v2h-7z"/><path d="M15 12h6v2h-6z"/><path d="M3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10z"/><path d="M14 5h-3l-1-1H6L5 5H2v2h12z"/>',
	                'drafts': '<path d="M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"/>',
	                'filter_list': '<path d="M10 18h4v-2h-4v2z"/><path d="M3 6v2h18V6H3z"/><path d="M6 13h12v-2H6v2z"/>',
	                'flag': '<path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"/>',
	                'font_download': '<path d="M9.93 13.5h4.14L12 7.98z"/><path d="M15.95 18.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>',
	                'forward': '<path d="M12 8V4l8 8-8 8v-4H4V8z"/>',
	                'gesture': '<path d="M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"/>',
	                'inbox': '<path d="M19 15h-4c0 1.66-1.34 3-3 3s-3-1.34-3-3H4.99V5H19v10zm0-12H4.99c-1.1 0-1.98.9-1.98 2L3 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M16 10h-2V7h-4v3H8l4 4 4-4z"/>',
	                'link': '<path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1z"/><path d="M8 13h8v-2H8v2z"/><path d="M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/>',
	                'low_priority': '<path d="M14 5h8v2h-8z"/><path d="M14 10.5h8v2h-8z"/><path d="M14 16h8v2h-8z"/><path d="M2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"/>',
	                'mail': '<path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>',
	                'markunread': '<path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>',
	                'move_to_inbox': '<path d="M19 15h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm0-12H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M16 10h-2V7h-4v3H8l4 4 4-4z"/>',
	                'next_week': '<path d="M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"/>',
	                'redo': '<path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"/>',
	                'remove': '<path d="M19 13H5v-2h14v2z"/>',
	                'remove_circle': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/>',
	                'remove_circle_outline': '<path d="M7 11v2h10v-2H7z"/><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>',
	                'reply': '<path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/>',
	                'reply_all': '<path d="M7 8V5l-7 7 7 7v-3l-4-4 4-4z"/><path d="M13 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/>',
	                'report': '<path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"/>',
	                'save': '<path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/>',
	                'select_all': '<path d="M3 5h2V3c-1.1 0-2 .9-2 2z"/><path d="M3 13h2v-2H3v2z"/><path d="M7 21h2v-2H7v2z"/><path d="M3 9h2V7H3v2z"/><path d="M13 3h-2v2h2V3z"/><path d="M19 3v2h2c0-1.1-.9-2-2-2z"/><path d="M5 21v-2H3c0 1.1.9 2 2 2z"/><path d="M3 17h2v-2H3v2z"/><path d="M9 3H7v2h2V3z"/><path d="M11 21h2v-2h-2v2z"/><path d="M19 13h2v-2h-2v2z"/><path d="M19 21c1.1 0 2-.9 2-2h-2v2z"/><path d="M19 9h2V7h-2v2z"/><path d="M19 17h2v-2h-2v2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M15 5h2V3h-2v2z"/><path d="M9 9h6v6H9V9zm-2 8h10V7H7v10z"/>',
	                'send': '<path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>',
	                'sort': '<path d="M3 18h6v-2H3v2z"/><path d="M3 6v2h18V6H3z"/><path d="M3 13h12v-2H3v2z"/>',
	                'text_format': '<path d="M5 17v2h14v-2H5z"/><path d="M12 5.98L13.87 11h-3.74L12 5.98zM9.5 12.8h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2z"/>',
	                'unarchive': '<path d="M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z"/>',
	                'undo': '<path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"/>',
	                'weekend': '<path d="M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2z"/><path d="M18 5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z"/>',
	                //
	                // device
	                //
	                'access_alarms': '<path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72z"/><path d="M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85z"/><path d="M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8z"/><path d="M12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm0-16c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/>',
	                'access_alarm': '<path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72z"/><path d="M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85z"/><path d="M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8z"/><path d="M12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm0-16c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/>',
	                'access_time': '<path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.01-18C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z"/><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>',
	                'add_alarm': '<path d="M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85z"/><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72z"/><path d="M12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm0-16c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"/>',
	                'airplanemode_on': '<path d="M10.18 9"/><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>',
	                'airplanemode_inactive': '<path d="M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5z"/><path d="M3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z"/>',
	                'battery_charging_full': '<path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"/>',
	                'battery_full': '<path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"/>',
	                'battery_std': '<path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"/>',
	                'battery_unknown': '<path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"/>',
	                'bluetooth': '<path d="M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"/>',
	                'bluetooth_connected': '<path d="M14.88 16.29L13 18.17v-3.76l1.88 1.88zM13 5.83l1.88 1.88L13 9.59V5.83zm4.71 1.88L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29z"/><path d="M19 10l-2 2 2 2 2-2-2-2z"/><path d="M7 12l-2-2-2 2 2 2 2-2z"/>',
	                'bluetooth_disabled': '<path d="M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2z"/><path d="M13 18.17v-3.76l1.88 1.88L13 18.17zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4z"/>',
	                'bluetooth_searching': '<path d="M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32z"/><path d="M19.53 6.71l-1.26 1.26c.63 1.21.98 2.57.98 4.02 0 1.45-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19z"/><path d="M12.88 16.29L11 18.17v-3.76l1.88 1.88zM11 5.83l1.88 1.88L11 9.59V5.83zm4.71 1.88L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29z"/>',
	                'brightness_auto': '<path d="M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z"/>',
	                'brightness_high': '<path d="M12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm8-9.31V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69z"/><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/>',
	                'brightness_low': '<path d="M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"/>',
	                'brightness_medium': '<path d="M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"/>',
	                'data_usage': '<path d="M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95z"/><path d="M12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"/>',
	                'developer_mode': '<path d="M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5z"/><path d="M15.41 16.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42z"/><path d="M10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17z"/><path d="M17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"/>',
	                'devices': '<path d="M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6z"/><path d="M22 17h-4v-7h4v7zm1-9h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"/>',
	                'dvr': '<path d="M21 17H3V5h18v12zm0-14H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2z"/><path d="M7 8H5v2h2V8zm12 0H8v2h11V8z"/><path d="M7 12H5v2h2v-2zm12 0H8v2h11v-2z"/>',
	                'gps_fixed': '<path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/><path d="M12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm8.94-8c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06z"/>',
	                'gps_not_fixed': '<path d="M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>',
	                'gps_off': '<path d="M20.94 11A8.994 8.994 0 0 0 13 3.06V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5A6.995 6.995 0 0 1 19 12c0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06z"/><path d="M16.27 17.54a6.995 6.995 0 0 1-9.81-9.81l9.81 9.81zM3 4.27l2.04 2.04A8.914 8.914 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27z"/>',
	                'graphic_eq': '<path d="M7 18h2V6H7v12z"/><path d="M11 22h2V2h-2v20z"/><path d="M3 14h2v-4H3v4z"/><path d="M15 18h2V6h-2v12z"/><path d="M19 10v4h2v-4h-2z"/>',
	                'location_disabled': '<path d="M20.94 11A8.994 8.994 0 0 0 13 3.06V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5A6.995 6.995 0 0 1 19 12c0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06z"/><path d="M16.27 17.54a6.995 6.995 0 0 1-9.81-9.81l9.81 9.81zM3 4.27l2.04 2.04A8.914 8.914 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27z"/>',
	                'location_searching': '<path d="M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>',
	                'network_cell': '<path fill-opacity=".3" d="M2 22h20V2z"/><path d="M17 7L2 22h15z"/>',
	                'network_wifi': '<path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"/><path d="M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"/>',
	                'nfc': '<path d="M20 20H4V4h16v16zm0-18H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/><path d="M18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"/>',
	                'screen_lock_landscape': '<path d="M19 17H5V7h14v10zm2-12H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"/><path d="M10.8 10c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zm-.8 6h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1z"/>',
	                'screen_lock_portrait': '<path d="M10.8 10c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zm-.8 6h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1z"/><path d="M17 19H7V5h10v14zm0-18H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/>',
	                'screen_lock_rotation': '<path d="M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12z"/><path d="M8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33z"/><path d="M16.8 2.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"/>',
	                'screen_rotation': '<path d="M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32z"/><path d="M14.83 21.19L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-4.6-19.44c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75z"/><path d="M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"/>',
	                'sd_storage': '<path d="M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"/>',
	                'settings_system_daydream': '<path d="M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3z"/><path d="M21 19.01H3V4.99h18v14.02zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'signal_cellular_4_bar': '<path d="M2 22h20V2z"/>',
	                'signal_cellular_connected_no_internet_4_bar': '<path d="M20 18h2v-8h-2v8z"/><path d="M20 22h2v-2h-2v2z"/><path d="M2 22h16V8h4V2L2 22z"/>',
	                'signal_cellular_no_sim': '<path d="M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5z"/><path d="M3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"/>',
	                'signal_cellular_null': '<path d="M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"/>',
	                'signal_cellular_off': '<path d="M21 1l-8.59 8.59L21 18.18V1z"/><path d="M4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z"/>',
	                'signal_wifi_4_bar': '<path d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"/>',
	                'signal_wifi_4_bar_lock': '<path d="M22 16h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm1 0v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1z"/><path d="M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z"/>',
	                'signal_wifi_off': '<path d="M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7z"/><path d="M17.04 15.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z"/>',
	                'storage': '<path d="M4 17h2v2H4v-2zm-2 3h20v-4H2v4z"/><path d="M6 7H4V5h2v2zM2 4v4h20V4H2z"/><path d="M4 11h2v2H4v-2zm-2 3h20v-4H2v4z"/>',
	                'usb': '<path d="M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"/>',
	                'wallpaper': '<path d="M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4z"/><path d="M10 13l-4 5h12l-3-4-2.03 2.71L10 13z"/><path d="M17 8.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5z"/><path d="M20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2z"/><path d="M20 20h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7z"/><path d="M4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"/>',
	                'wifi_lock': '<path d="M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5z"/><path d="M22 16h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16zm1 0v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z"/>',
	                'wifi_tethering': '<path d="M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M18 13c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19z"/><path d="M12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"/>',
	                //
	                // editor
	                //
	                'attach_file': '<path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/>',
	                'attach_money': '<path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>',
	                'border_all': '<path d="M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"/>',
	                'border_bottom': '<path d="M9 11H7v2h2v-2z"/><path d="M13 15h-2v2h2v-2z"/><path d="M9 3H7v2h2V3z"/><path d="M13 11h-2v2h2v-2z"/><path d="M5 3H3v2h2V3z"/><path d="M13 7h-2v2h2V7z"/><path d="M17 11h-2v2h2v-2z"/><path d="M13 3h-2v2h2V3z"/><path d="M17 3h-2v2h2V3z"/><path d="M19 13h2v-2h-2v2z"/><path d="M19 17h2v-2h-2v2z"/><path d="M5 7H3v2h2V7z"/><path d="M19 3v2h2V3h-2z"/><path d="M19 9h2V7h-2v2z"/><path d="M5 11H3v2h2v-2z"/><path d="M3 21h18v-2H3v2z"/><path d="M5 15H3v2h2v-2z"/>',
	                'border_clear': '<path d="M7 5h2V3H7v2z"/><path d="M7 13h2v-2H7v2z"/><path d="M7 21h2v-2H7v2z"/><path d="M11 17h2v-2h-2v2z"/><path d="M11 21h2v-2h-2v2z"/><path d="M3 21h2v-2H3v2z"/><path d="M3 17h2v-2H3v2z"/><path d="M3 13h2v-2H3v2z"/><path d="M3 9h2V7H3v2z"/><path d="M3 5h2V3H3v2z"/><path d="M11 13h2v-2h-2v2z"/><path d="M19 17h2v-2h-2v2z"/><path d="M19 13h2v-2h-2v2z"/><path d="M19 21h2v-2h-2v2z"/><path d="M19 9h2V7h-2v2z"/><path d="M11 9h2V7h-2v2z"/><path d="M19 3v2h2V3h-2z"/><path d="M11 5h2V3h-2v2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M15 13h2v-2h-2v2z"/><path d="M15 5h2V3h-2v2z"/>',
	                'border_color': '<path d="M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z"/><path fill-opacity=".36" d="M0 20h24v4H0z"/>',
	                'border_horizontal': '<path d="M3 21h2v-2H3v2z"/><path d="M5 7H3v2h2V7z"/><path d="M3 17h2v-2H3v2z"/><path d="M7 21h2v-2H7v2z"/><path d="M5 3H3v2h2V3z"/><path d="M9 3H7v2h2V3z"/><path d="M17 3h-2v2h2V3z"/><path d="M13 7h-2v2h2V7z"/><path d="M13 3h-2v2h2V3z"/><path d="M19 17h2v-2h-2v2z"/><path d="M11 21h2v-2h-2v2z"/><path d="M3 13h18v-2H3v2z"/><path d="M19 3v2h2V3h-2z"/><path d="M19 9h2V7h-2v2z"/><path d="M11 17h2v-2h-2v2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M19 21h2v-2h-2v2z"/>',
	                'border_inner': '<path d="M3 21h2v-2H3v2z"/><path d="M7 21h2v-2H7v2z"/><path d="M5 7H3v2h2V7z"/><path d="M3 17h2v-2H3v2z"/><path d="M9 3H7v2h2V3z"/><path d="M5 3H3v2h2V3z"/><path d="M17 3h-2v2h2V3z"/><path d="M19 9h2V7h-2v2z"/><path d="M19 3v2h2V3h-2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3z"/><path d="M19 21h2v-2h-2v2z"/><path d="M19 17h2v-2h-2v2z"/>',
	                'border_left': '<path d="M11 21h2v-2h-2v2z"/><path d="M11 17h2v-2h-2v2z"/><path d="M11 5h2V3h-2v2z"/><path d="M11 9h2V7h-2v2z"/><path d="M11 13h2v-2h-2v2z"/><path d="M7 21h2v-2H7v2z"/><path d="M7 5h2V3H7v2z"/><path d="M7 13h2v-2H7v2z"/><path d="M3 21h2V3H3v18z"/><path d="M19 9h2V7h-2v2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M19 17h2v-2h-2v2z"/><path d="M19 3v2h2V3h-2z"/><path d="M19 13h2v-2h-2v2z"/><path d="M19 21h2v-2h-2v2z"/><path d="M15 13h2v-2h-2v2z"/><path d="M15 5h2V3h-2v2z"/>',
	                'border_outer': '<path d="M13 7h-2v2h2V7z"/><path d="M13 11h-2v2h2v-2z"/><path d="M17 11h-2v2h2v-2z"/><path d="M19 19H5V5h14v14zM3 3v18h18V3H3z"/><path d="M13 15h-2v2h2v-2z"/><path d="M9 11H7v2h2v-2z"/>',
	                'border_right': '<path d="M7 21h2v-2H7v2z"/><path d="M3 5h2V3H3v2z"/><path d="M7 5h2V3H7v2z"/><path d="M7 13h2v-2H7v2z"/><path d="M3 21h2v-2H3v2z"/><path d="M11 21h2v-2h-2v2z"/><path d="M3 13h2v-2H3v2z"/><path d="M3 17h2v-2H3v2z"/><path d="M3 9h2V7H3v2z"/><path d="M11 17h2v-2h-2v2z"/><path d="M15 13h2v-2h-2v2z"/><path d="M19 3v18h2V3h-2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M15 5h2V3h-2v2z"/><path d="M11 13h2v-2h-2v2z"/><path d="M11 5h2V3h-2v2z"/><path d="M11 9h2V7h-2v2z"/>',
	                'border_style': '<path d="M15 21h2v-2h-2v2z"/><path d="M19 21h2v-2h-2v2z"/><path d="M7 21h2v-2H7v2z"/><path d="M11 21h2v-2h-2v2z"/><path d="M19 17h2v-2h-2v2z"/><path d="M19 13h2v-2h-2v2z"/><path d="M3 3v18h2V5h16V3H3z"/><path d="M19 9h2V7h-2v2z"/>',
	                'border_top': '<path d="M7 21h2v-2H7v2z"/><path d="M7 13h2v-2H7v2z"/><path d="M11 13h2v-2h-2v2z"/><path d="M11 21h2v-2h-2v2z"/><path d="M3 17h2v-2H3v2z"/><path d="M3 21h2v-2H3v2z"/><path d="M3 13h2v-2H3v2z"/><path d="M3 9h2V7H3v2z"/><path d="M11 17h2v-2h-2v2z"/><path d="M19 9h2V7h-2v2z"/><path d="M19 13h2v-2h-2v2z"/><path d="M3 3v2h18V3H3z"/><path d="M19 17h2v-2h-2v2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M11 9h2V7h-2v2z"/><path d="M19 21h2v-2h-2v2z"/><path d="M15 13h2v-2h-2v2z"/>',
	                'border_vertical': '<path d="M3 9h2V7H3v2z"/><path d="M3 5h2V3H3v2z"/><path d="M7 21h2v-2H7v2z"/><path d="M7 13h2v-2H7v2z"/><path d="M3 13h2v-2H3v2z"/><path d="M3 21h2v-2H3v2z"/><path d="M3 17h2v-2H3v2z"/><path d="M7 5h2V3H7v2z"/><path d="M19 17h2v-2h-2v2z"/><path d="M11 21h2V3h-2v18z"/><path d="M19 21h2v-2h-2v2z"/><path d="M19 13h2v-2h-2v2z"/><path d="M19 3v2h2V3h-2z"/><path d="M19 9h2V7h-2v2z"/><path d="M15 5h2V3h-2v2z"/><path d="M15 21h2v-2h-2v2z"/><path d="M15 13h2v-2h-2v2z"/>',
	                'bubble_chart': '<circle cx="7.2" cy="14.4" r="3.2"/><circle cx="14.8" cy="18" r="2"/><circle cx="15.2" cy="8.8" r="4.8"/>',
	                'drag_handle': '<path d="M20 9H4v2h16V9z"/><path d="M4 15h16v-2H4v2z"/>',
	                'format_align_center': '<path d="M7 15v2h10v-2H7z"/><path d="M3 21h18v-2H3v2z"/><path d="M3 13h18v-2H3v2z"/><path d="M7 7v2h10V7H7z"/><path d="M3 3v2h18V3H3z"/>',
	                'format_align_justify': '<path d="M3 21h18v-2H3v2z"/><path d="M3 17h18v-2H3v2z"/><path d="M3 13h18v-2H3v2z"/><path d="M3 9h18V7H3v2z"/><path d="M3 3v2h18V3H3z"/>',
	                'format_align_left': '<path d="M15 15H3v2h12v-2z"/><path d="M15 7H3v2h12V7z"/><path d="M3 13h18v-2H3v2z"/><path d="M3 21h18v-2H3v2z"/><path d="M3 3v2h18V3H3z"/>',
	                'format_align_right': '<path d="M3 21h18v-2H3v2z"/><path d="M9 17h12v-2H9v2z"/><path d="M3 13h18v-2H3v2z"/><path d="M9 9h12V7H9v2z"/><path d="M3 3v2h18V3H3z"/>',
	                'format_bold': '<path d="M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"/>',
	                'format_clear': '<path d="M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5z"/><path d="M6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"/>',
	                'format_color_fill': '<path d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"/><path fill-opacity=".36" d="M0 20h24v4H0z"/>',
	                'format_color_reset': '<path d="M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31z"/><path d="M17.12 17.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z"/>',
	                'format_color_text': '<path fill-opacity=".36" d="M0 20h24v4H0z"/><path d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"/>',
	                'format_indent_decrease': '<path d="M11 17h10v-2H11v2z"/><path d="M3 12l4 4V8l-4 4z"/><path d="M3 21h18v-2H3v2z"/><path d="M3 3v2h18V3H3z"/><path d="M11 9h10V7H11v2z"/><path d="M11 13h10v-2H11v2z"/>',
	                'format_indent_increase': '<path d="M3 21h18v-2H3v2z"/><path d="M3 8v8l4-4-4-4z"/><path d="M11 17h10v-2H11v2z"/><path d="M3 3v2h18V3H3z"/><path d="M11 9h10V7H11v2z"/><path d="M11 13h10v-2H11v2z"/>',
	                'format_italic': '<path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"/>',
	                'format_line_spacing': '<path d="M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7z"/><path d="M10 5v2h12V5H10z"/><path d="M10 19h12v-2H10v2z"/><path d="M10 13h12v-2H10v2z"/>',
	                'format_list_bulleted': '<path d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"/><path d="M4 4.5c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5z"/><path d="M4 16.67c-.74 0-1.33.6-1.33 1.33 0 .73.6 1.33 1.33 1.33.73 0 1.33-.6 1.33-1.33 0-.73-.59-1.33-1.33-1.33z"/><path d="M7 19h14v-2H7v2z"/><path d="M7 13h14v-2H7v2z"/><path d="M7 5v2h14V5H7z"/>',
	                'format_list_numbered': '<path d="M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1z"/><path d="M3 8h1V4H2v1h1v3z"/><path d="M2 11h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1z"/><path d="M7 5v2h14V5H7z"/><path d="M7 19h14v-2H7v2z"/><path d="M7 13h14v-2H7v2z"/>',
	                'format_paint': '<path d="M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z"/>',
	                'format_quote': '<path d="M6 17h3l2-4V7H5v6h3z"/><path d="M14 17h3l2-4V7h-6v6h3z"/>',
	                'format_shapes': '<path d="M19 5V3h2v2h-2zm2 16h-2v-2h2v2zm-4-2H7v-2H5V7h2V5h10v2h2v10h-2v2zM5 21H3v-2h2v2zM3 3h2v2H3V3zm20 4V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2z"/><path d="M10.69 12.74h2.61L12 8.91l-1.31 3.83zM13.73 14h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2z"/>',
	                'format_size': '<path d="M9 4v3h5v12h3V7h5V4H9z"/><path d="M3 12h3v7h3v-7h3V9H3v3z"/>',
	                'format_strikethrough': '<path d="M10 19h4v-3h-4v3z"/><path d="M5 4v3h5v3h4V7h5V4H5z"/><path d="M3 14h18v-2H3v2z"/>',
	                'format_textdirection_l_to_r': '<path d="M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4z"/><path d="M21 18l-4-4v3H5v2h12v3l4-4z"/>',
	                'format_textdirection_r_to_l': '<path d="M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4z"/><path d="M8 17v-3l-4 4 4 4v-3h12v-2H8z"/>',
	                'format_underline': '<path d="M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6z"/><path d="M5 19v2h14v-2H5z"/>',
	                'functions': '<path d="M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z"/>',
	                'highlight': '<path d="M6 14l3 3v5h6v-5l3-3V9H6z"/><path d="M11 2h2v3h-2z"/><path d="M3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997z"/><path d="M16.96 6.585l2.123-2.12 1.414 1.414L18.375 8z"/>',
	                'insert_chart': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>',
	                'insert_comment': '<path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>',
	                'insert_drive_file': '<path d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"/>',
	                'insert_emoticon': '<path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.01-18C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z"/><path d="M15.5 11c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5z"/><path d="M8.5 11c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11z"/><path d="M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>',
	                'insert_invitation': '<path d="M17 12h-5v5h5v-5z"/><path d="M19 19H5V8h14v11zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2z"/>',
	                'insert_link': '<path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1z"/><path d="M8 13h8v-2H8v2z"/><path d="M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/>',
	                'insert_photo': '<path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>',
	                'linear_scale': '<path d="M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"/>',
	                'merge_type': '<path d="M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41z"/><path d="M7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"/>',
	                'mode_comment': '<path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"/>',
	                'mode_edit': '<path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z"/><path d="M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>',
	                'monetization_on': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>',
	                'money_off': '<path d="M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27z"/><path d="M5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z"/>',
	                'multiline_chart': '<path d="M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"/>',
	                'pie_chart': '<path d="M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10z"/><path d="M13.03 2v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99z"/><path d="M13.03 13.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"/>',
	                'pie_chart_outline': '<path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z"/>',
	                'publish': '<path d="M5 4v2h14V4H5z"/><path d="M5 14h4v6h6v-6h4l-7-7-7 7z"/>',
	                'short_text': '<path d="M4 9h16v2H4z"/><path d="M4 13h10v2H4z"/>',
	                'show_chart': '<path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"/>',
	                'space_bar': '<path d="M18 9v4H6V9H4v6h16V9z"/>',
	                'strikethrough_s': '<path d="M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29a5.73 5.73 0 0 1 1.7-.83c.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25z"/><path d="M21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28.65-.19 1.21-.45 1.67-.79.46-.34.82-.77 1.07-1.27.25-.5.38-1.07.38-1.71 0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z"/>',
	                'text_fields': '<path d="M2.5 4v3h5v12h3V7h5V4h-13z"/><path d="M21.5 9h-9v3h3v7h3v-7h3V9z"/>',
	                'title': '<path d="M5 4v3h5.5v12h3V7H19V4z"/>',
	                'vertical_align_bottom': '<path d="M16 13h-3V3h-2v10H8l4 4 4-4z"/><path d="M4 19v2h16v-2H4z"/>',
	                'vertical_align_center': '<path d="M8 19h3v4h2v-4h3l-4-4-4 4z"/><path d="M16 5h-3V1h-2v4H8l4 4 4-4z"/><path d="M4 11v2h16v-2H4z"/>',
	                'vertical_align_top': '<path d="M8 11h3v10h2V11h3l-4-4-4 4z"/><path d="M4 3v2h16V3H4z"/>',
	                'wrap_text': '<path d="M4 19h6v-2H4v2z"/><path d="M20 5H4v2h16V5z"/><path d="M17 11H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"/>',
	                //
	                // file
	                //
	                'attachment': '<path d="M7.5 18C4.46 18 2 15.54 2 12.5S4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v1.5H9.5c-.55 0-1 .45-1 1s.45 1 1 1H18c1.38 0 2.5-1.12 2.5-2.5S19.38 8.5 18 8.5H7.5c-2.21 0-4 1.79-4 4s1.79 4 4 4H17V18H7.5z"/>',
	                'cloud': '<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"/>',
	                'cloud_circle': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z"/>',
	                'cloud_done': '<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"/>',
	                'cloud_download': '<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"/>',
	                'cloud_off': '<path d="M19.35 10.04A7.49 7.49 0 0 0 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46a5.497 5.497 0 0 1 8.05 4.87v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96z"/><path d="M7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27z"/>',
	                'cloud_queue': '<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"/>',
	                'cloud_upload': '<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>',
	                'create_new_folder': '<path d="M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"/>',
	                'file_download': '<path d="M19 9h-4V3H9v6H5l7 7 7-7z"/><path d="M5 18v2h14v-2H5z"/>',
	                'file_upload': '<path d="M9 16h6v-6h4l-7-7-7 7h4z"/><path d="M5 18h14v2H5z"/>',
	                'folder': '<path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/>',
	                'folder_open': '<path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"/>',
	                'folder_shared': '<path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"/>',
	                //
	                // hardware
	                //
	                'cast': '<path d="M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M1 18v3h3c0-1.66-1.34-3-3-3z"/><path d="M1 14v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7z"/><path d="M1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"/>',
	                'cast_connected': '<path d="M1 18v3h3c0-1.66-1.34-3-3-3z"/><path d="M1 14v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7z"/><path d="M19 7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7z"/><path d="M1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"/><path d="M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'computer': '<path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/>',
	                'desktop_mac': '<path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"/>',
	                'desktop_windows': '<path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"/>',
	                'developer_dashboard': '<path d="M18 19H4V5h14v14zm4-10V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2z"/><path d="M6 13h5v4H6z"/><path d="M12 7h4v3h-4z"/><path d="M6 7h5v5H6z"/><path d="M12 11h4v6h-4z"/>',
	                'device_hub': '<path d="M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"/>',
	                'devices_other': '<path d="M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6z"/><path d="M11 17.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2-5.5H9v1.78c-.61.55-1 1.33-1 2.22 0 .89.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22 0-.88-.39-1.67-1-2.22V12z"/><path d="M21 18h-4v-8h4v8zm1-10h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1z"/>',
	                'dock': '<path d="M8 23h8v-2H8v2z"/><path d="M16 15H8V5h8v10zm0-13.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"/>',
	                'gamepad': '<path d="M15 7.5V2H9v5.5l3 3 3-3z"/><path d="M7.5 9H2v6h5.5l3-3-3-3z"/><path d="M9 16.5V22h6v-5.5l-3-3-3 3z"/><path d="M16.5 9l-3 3 3 3H22V9h-5.5z"/>',
	                'headset': '<path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"/>',
	                'headset_mic': '<path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z"/>',
	                'keyboard': '<path d="M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"/>',
	                'keyboard_arrow_down': '<path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/>',
	                'keyboard_arrow_left': '<path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/>',
	                'keyboard_arrow_right': '<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>',
	                'keyboard_arrow_up': '<path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>',
	                'keyboard_backspace': '<path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"/>',
	                'keyboard_capslock': '<path d="M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41z"/><path d="M6 18h12v-2H6v2z"/>',
	                'keyboard_hide': '<path d="M19 8h-2V6h2v2zm0 3h-2V9h2v2zm-3-3h-2V6h2v2zm0 3h-2V9h2v2zm0 4H8v-2h8v2zM7 8H5V6h2v2zm0 3H5V9h2v2zm1-2h2v2H8V9zm0-3h2v2H8V6zm3 3h2v2h-2V9zm0-3h2v2h-2V6zm9-3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M12 23l4-4H8l4 4z"/>',
	                'keyboard_return': '<path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"/>',
	                'keyboard_tab': '<path d="M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41z"/><path d="M20 6v12h2V6h-2z"/>',
	                'keyboard_voice': '<path d="M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3z"/><path d="M17.3 12c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>',
	                'laptop': '<path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/>',
	                'laptop_chromebook': '<path d="M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"/>',
	                'laptop_mac': '<path d="M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>',
	                'laptop_windows': '<path d="M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"/>',
	                'memory': '<path d="M13 13h-2v-2h2v2zm2-4H9v6h6V9z"/><path d="M17 17H7V7h10v10zm4-6V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2z"/>',
	                'mouse': '<path d="M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93z"/><path d="M4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4z"/><path d="M11 1.07C7.05 1.56 4 4.92 4 9h7V1.07z"/>',
	                'phone_android': '<path d="M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"/>',
	                'phone_iphone': '<path d="M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"/>',
	                'phonelink': '<path d="M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6z"/><path d="M22 17h-4v-7h4v7zm1-9h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"/>',
	                'phonelink_off': '<path d="M22 6V4H6.82l2 2H22z"/><path d="M4 6.27L14.73 17H4V6.27zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65z"/><path d="M23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"/>',
	                'power_input': '<path d="M2 9v2h19V9H2z"/><path d="M2 15h5v-2H2v2z"/><path d="M9 15h5v-2H9v2z"/><path d="M16 15h5v-2h-5v2z"/>',
	                'router': '<path d="M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3c-1.8 0-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7z"/><path d="M19.3 6.7c-.9-.9-2.1-1.4-3.3-1.4-1.2 0-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8z"/><path d="M15 18h-2v-2h2v2zm-3.5 0h-2v-2h2v2zM8 18H6v-2h2v2zm11-5h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2z"/>',
	                'scanner': '<path d="M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"/>',
	                'security': '<path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>',
	                'sim_card': '<path d="M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z"/>',
	                'smartphone': '<path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>',
	                'speaker': '<path d="M12 20c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-16c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm5-2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/><path d="M12 12c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>',
	                'speaker_group': '<path d="M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/> <circle cx="14" cy="12.5" r="2.5"/> <path d="M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z"/>',
	                'tablet': '<path d="M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"/>',
	                'tablet_android': '<path d="M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"/>',
	                'tablet_mac': '<path d="M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"/>',
	                'toys': '<path d="M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12z"/><path d="M12 12c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11z"/><path d="M12 12c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11z"/><path d="M12 12c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z"/>',
	                'tv': '<path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"/>',
	                'vidiogame_asset': '<path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>',
	                'watch': '<path d="M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"/>',
	                //
	                // image
	                //
	                'add_a_photo': '<path d="M3 4V1h2v3h3v2H5v3H3V6H0V4h3z"/><path d="M13 19c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-7-9V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3z"/><path d="M9.8 14c0 1.77 1.43 3.2 3.2 3.2 1.77 0 3.2-1.43 3.2-3.2 0-1.77-1.43-3.2-3.2-3.2-1.77 0-3.2 1.43-3.2 3.2z"/>',
	                'add_to_photos': '<path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/><path d="M19 11h-4v4h-2v-4H9V9h4V5h2v4h4v2zm1-9H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>',
	                'adjust': '<path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2z"/><path d="M15 12c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"/>',
	                'assistant_photo': '<path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"/>',
	                'audiotrack': '<path d="M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"/>',
	                'blur_circular': '<path d="M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M10 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M10 16.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M7 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M10 7.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M14 7.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M17 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M17 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/><path d="M14 16.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M14 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/>',
	                'blur_linear': '<path d="M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5z"/><path d="M9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M9 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M3 21h18v-2H3v2z"/><path d="M5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5z"/><path d="M5 13.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5z"/><path d="M9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M17 16.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M3 3v2h18V3H3z"/><path d="M17 8.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M17 12.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M13 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M13 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/>',
	                'blur_off': '<path d="M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M13.8 11.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28z"/><path d="M14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M10 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M18 15c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M18 11c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M18 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M14 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27z"/><path d="M10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M21 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M10 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M3 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/>',
	                'blur_on': '<path d="M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M3 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M10 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M10 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"/><path d="M10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/><path d="M10 12.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"/><path d="M18 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M18 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M18 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M18 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M21 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M14 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"/><path d="M10 8.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"/><path d="M10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/><path d="M14 12.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"/><path d="M14 8.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"/>',
	                'brightness_1': '<circle cx="12" cy="12" r="10"/>',
	                'brightness_2': '<path d="M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"/>',
	                'brightness_3': '<path d="M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"/>',
	                'brightness_4': '<path d="M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"/>',
	                'brightness_5': '<path d="M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"/>',
	                'brightness_6': '<path d="M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"/>',
	                'brightness_7': '<path d="M12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm8-9.31V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69z"/><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/>',
	                'broken_image': '<path d="M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2z"/><path d="M18 11.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"/>',
	                'brush': '<path d="M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"/><path d="M20.71 4.63l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"/>',
	                'burst_mode': '<path d="M1 5h2v14H1z"/><path d="M5 5h2v14H5z"/><path d="M11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11zM22 5H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"/>',
	                'camera': '<path d="M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1z"/><path d="M21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66z"/><path d="M21.8 10h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2z"/><path d="M8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2z"/><path d="M2.46 15c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46z"/><path d="M13.73 15l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z"/>',
	                'camera_alt': '<circle cx="12" cy="12" r="3.2"/><path d="M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zM9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9z"/>',
	                'camera_front': '<path d="M10 20H5v2h5v2l3-3-3-3v2z"/><path d="M14 20v2h5v-2h-5z"/><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8z"/><path d="M7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2zm10-2H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z"/>',
	                'camera_rear': '<path d="M10 20H5v2h5v2l3-3-3-3v2z"/><path d="M14 20v2h5v-2h-5z"/><path d="M12 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6zm5-6H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z"/>',
	                'camera_roll': '<path d="M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"/>',
	                'center_focus_strong': '<path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/><path d="M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4z"/><path d="M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5z"/><path d="M19 3h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"/><path d="M19 19h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"/>',
	                'center_focus_weak': '<path d="M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4z"/><path d="M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5z"/><path d="M19 3h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"/><path d="M19 19h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"/><path d="M12 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/>',
	                'collections': '<path d="M11 12l2.03 2.71L16 11l4 5H8l3-4zm11 4V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2z"/><path d="M2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"/>',
	                'collections_bookmark': '<path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"/>',
	                'color_lens': '<path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>',
	                'colorize': '<path d="M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"/>',
	                'compare': '<path d="M10 18H5l5-6v6zm0-15H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2z"/><path d="M19 3h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'control_point': '<path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7z"/><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2z"/>',
	                'control_point_duplicate': '<path d="M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3z"/><path d="M2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12z"/><path d="M15 19c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm0-16c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9z"/>',
	                'crop': '<path d="M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8z"/><path d="M7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"/>',
	                'crop_16_9': '<path d="M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"/>',
	                'crop_3_2': '<path d="M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"/>',
	                'crop_5_4': '<path d="M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"/>',
	                'crop_7_5': '<path d="M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"/>',
	                'crop_din': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/>',
	                'crop_free': '<path d="M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2z"/><path d="M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4z"/><path d="M19 19h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"/><path d="M19 3h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"/>',
	                'crop_landscape': '<path d="M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"/>',
	                'crop_original': '<path d="M19 19H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M13.96 12.29l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"/>',
	                'crop_portrait': '<path d="M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"/>',
	                'crop_rotate': '<path d="M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34z"/><path d="M12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11z"/><path d="M16 14h2V8a2 2 0 0 0-2-2h-6v2h6v6z"/><path d="M8 16V4H6v2H4v2h2v8a2 2 0 0 0 2 2h8v2h2v-2h2v-2H8z"/>',
	                'crop_square': '<path d="M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"/>',
	                'dehaze': '<path d="M2 15.5v2h20v-2H2z"/><path d="M2 10.5v2h20v-2H2z"/><path d="M2 5.5v2h20v-2H2z"/>',
	                'details': '<path d="M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"/>',
	                'edit': '<path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z"/><path d="M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>',
	                'exposure': '<path d="M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2z"/><path d="M20 20H4L20 4v16zM5 5h6v2H5V5zm15-3H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>',
	                'exposure_neg_1': '<path d="M4 11v2h8v-2H4z"/><path d="M19 18h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"/>',
	                'exposure_neg_2': '<path d="M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0 0 16.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95z"/><path d="M2 11v2h8v-2H2z"/>',
	                'exposure_plus_1': '<path d="M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7z"/><path d="M20 18h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"/>',
	                'exposure_plus_2': '<path d="M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0 0 17.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95z"/><path d="M8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"/>',
	                'exposure_zero': '<path d="M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z"/>',
	                'filter': '<path d="M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71z"/><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/>',
	                'filter_1': '<path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M14 15h2V5h-4v2h2v8z"/><path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/>',
	                'filter_2': '<path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/><path d="M17 13h-4v-2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4v2h4v2h-2a2 2 0 0 0-2 2v4h6v-2z"/>',
	                'filter_3': '<path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M17 13v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 0 0-2-2h-4v2h4v2h-2v2h2v2h-4v2h4a2 2 0 0 0 2-2z"/>',
	                'filter_4': '<path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M15 15h2V5h-2v4h-2V5h-2v6h4v4z"/><path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/>',
	                'filter_5': '<path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M17 13v-2a2 2 0 0 0-2-2h-2V7h4V5h-6v6h4v2h-4v2h4a2 2 0 0 0 2-2z"/>',
	                'filter_6': '<path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/><path d="M13 11h2v2h-2v-2zm0 4h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V7h4V5h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2z"/>',
	                'filter_7': '<path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/><path d="M13 15l4-8V5h-6v2h4l-4 8h2z"/>',
	                'filter_8': '<path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/><path d="M13 11h2v2h-2v-2zm0-4h2v2h-2V7zm0 8h2a2 2 0 0 0 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13a2 2 0 0 0 2 2z"/>',
	                'filter_9': '<path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/><path d="M15 9h-2V7h2v2zm0-4h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2h-4v2h4a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z"/>',
	                'filter_9_plus': '<path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M11 9V8h1v1h-1zm3 3V8a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v1H9v2h3a2 2 0 0 0 2-2z"/><path d="M21 9h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6zm0-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/>',
	                'filter_b_and_w': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"/>',
	                'filter_center_focus': '<path d="M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4z"/><path d="M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5z"/><path d="M19 3h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"/><path d="M19 19h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"/><path d="M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>',
	                'filter_drama': '<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"/>',
	                'filter_frames': '<path d="M20 20H4V6h4.52l3.52-3.5L15.52 6H20v14zm0-16h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"/><path d="M18 8H6v10h12"/>',
	                'filter_hdr': '<path d="M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"/>',
	                'filter_none': '<path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5z"/><path d="M21 17H7V3h14v14zm0-16H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/>',
	                'filter_tilt_shift': '<path d="M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0 1 11 4.07z"/><path d="M18.32 4.26A9.949 9.949 0 0 0 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43z"/><path d="M19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 0 1 1.62 3.9z"/><path d="M5.69 7.1L4.26 5.68A9.949 9.949 0 0 0 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9z"/><path d="M4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 0 1 4.07 13z"/><path d="M15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3z"/><path d="M18.31 16.9l1.43 1.43a9.981 9.981 0 0 0 2.21-5.32h-2.02a7.945 7.945 0 0 1-1.62 3.89z"/><path d="M13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62z"/><path d="M5.68 19.74A9.981 9.981 0 0 0 11 21.95v-2.02a7.941 7.941 0 0 1-3.9-1.62l-1.42 1.43z"/>',
	                'filter_vintage': '<path d="M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>',
	                'flare': '<path d="M7 11H1v2h6v-2z"/><path d="M9.17 7.76L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41z"/><path d="M13 1h-2v6h2V1z"/><path d="M18.36 7.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12z"/><path d="M17 11v2h6v-2h-6z"/><path d="M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/><path d="M14.83 16.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41z"/><path d="M5.64 16.95l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12z"/><path d="M11 23h2v-6h-2v6z"/>',
	                'flash_auto': '<path d="M3 2v12h3v9l7-12H9l4-9H3z"/><path d="M16.85 7.65L18 4l1.15 3.65h-2.3zM19 2h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2z"/>',
	                'flash_off': '<path d="M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3z"/><path d="M17 10h-4l4-8H7v2.18l8.46 8.46L17 10z"/>',
	                'flash_on': '<path d="M7 2v11h3v9l7-12h-4l4-8z"/>',
	                'flip': '<path d="M15 21h2v-2h-2v2z"/><path d="M19 9h2V7h-2v2z"/><path d="M3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2z"/><path d="M19 3v2h2c0-1.1-.9-2-2-2z"/><path d="M11 23h2V1h-2v22z"/><path d="M19 17h2v-2h-2v2z"/><path d="M15 5h2V3h-2v2z"/><path d="M19 13h2v-2h-2v2z"/><path d="M19 21c1.1 0 2-.9 2-2h-2v2z"/>',
	                'gradient': '<path d="M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"/>',
	                'grain': '<path d="M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M6 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M18 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/><path d="M14 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M18 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M14 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M10 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>',
	                'grid_off': '<path d="M16 4h4v4h-4V4zM8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8z"/><path d="M16 20v-1.46L17.46 20H16zm-2 0h-4v-4h3.45l.55.54V20zm-6-6H4v-4h3.45l.55.55V14zm0 6H4v-4h4v4zM4 6.55L5.45 8H4V6.55zm6 6L11.45 14H10v-1.45zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27z"/>',
	                'grid_on': '<path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"/>',
	                'hdr_off': '<path d="M13 15h-2v-2.45l2 2V15zm5 2L3.27 2.27 2 3.55l4 4V11H4V7H2v10h2v-4h2v4h2V9.55l1 1V17h4c.67 0 1.26-.33 1.62-.84l6.34 6.34 1.27-1.27L18 17z"/><path d="M18 9h2v2h-2V9zm0 4h1l.82 3.27.73.73H22l-1.19-4.17c.7-.31 1.19-1.01 1.19-1.83V9c0-1.1-.9-2-2-2h-4v5.45l2 2V13z"/><path d="M15 11.45V9c0-1.1-.9-2-2-2h-2.45L15 11.45z"/>',
	                'hdr_on': '<path d="M6 11H4V7H2v10h2v-4h2v4h2V7H6v4z"/><path d="M13 15h-2V9h2v6zm0-8H9v10h4c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2z"/><path d="M20 11h-2V9h2v2zm2 0V9c0-1.1-.9-2-2-2h-4v10h2v-4h1l1 4h2l-1.19-4.17c.7-.31 1.19-1.01 1.19-1.83z"/>',
	                'hdr_strong': '<path d="M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"/><path d="M5 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/>',
	                'hdr_weak': '<path d="M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/><path d="M17 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-10c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"/>',
	                'healing': '<path d="M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"/>',
	                'image': '<path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>',
	                'image_aspect_ratio': '<path d="M16 10h-2v2h2v-2z"/><path d="M16 14h-2v2h2v-2z"/><path d="M8 10H6v2h2v-2z"/><path d="M12 10h-2v2h2v-2z"/><path d="M20 18H4V6h16v12zm0-14H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"/>',
	                'iso': '<path d="M19 19H5L19 5v14zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M17 17v-1.5h-5V17h5z"/>',
	                'landscape': '<path d="M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"/>',
	                'leak_add': '<path d="M6 3H3v3c1.66 0 3-1.34 3-3z"/><path d="M14 3h-2a9 9 0 0 1-9 9v2c6.08 0 11-4.93 11-11z"/><path d="M10 3H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7z"/><path d="M10 21h2a9 9 0 0 1 9-9v-2c-6.07 0-11 4.93-11 11z"/><path d="M18 21h3v-3c-1.66 0-3 1.34-3 3z"/><path d="M14 21h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"/>',
	                'leak_remove': '<path d="M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3z"/><path d="M3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97A8.99 8.99 0 0 1 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5A11.044 11.044 0 0 0 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43A6.922 6.922 0 0 0 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27z"/><path d="M14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3z"/><path d="M19.94 16.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6z"/><path d="M15.38 11.56l1.46 1.46A8.98 8.98 0 0 1 21 12v-2c-2.06 0-3.98.58-5.62 1.56z"/>',
	                'lens': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>',
	                'linked_camera': '<circle cx="12" cy="14" r="3.2"/><path d="M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6"/><path d="M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>',
	                'looks': '<path d="M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7z"/><path d="M12 6C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"/>',
	                'looks_3': '<path d="M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z"/>',
	                'looks_4': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z"/>',
	                'looks_5': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z"/>',
	                'looks_6': '<path d="M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z"/>',
	                'looks_one': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"/>',
	                'looks_two': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z"/>',
	                'loupe': '<path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7z"/><path d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10z"/>',
	                'monochrome_photos': '<path d="M20 19h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm0-14h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"/><path d="M17 13c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5z"/><path d="M8.8 13c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"/>',
	                'movie_creation': '<path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"/>',
	                'movie_filter': '<path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.58 11.68L10.37 18l-1.05-2.32L7 14.63l2.32-1.05 1.05-2.32 1.05 2.32 2.32 1.05-2.32 1.05zm3.69-3.47l-.53 1.16-.53-1.16-1.16-.53 1.16-.53.53-1.15.53 1.16 1.16.53-1.16.52z"/>',
	                'music_note': '<path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>',
	                'nature': '<path d="M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z"/>',
	                'nature_people': '<path d="M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"/>',
	                'navigate_before': '<path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>',
	                'navigate_next': '<path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>',
	                'palette': '<path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>',
	                'panorama': '<path d="M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"/>',
	                'panorama_fisheye': '<path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>',
	                'panorama_horizontal': '<path d="M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"/>',
	                'panorama_vertical': '<path d="M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z"/>',
	                'panorama_wide_angle': '<path d="M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"/>',
	                'photo': '<path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>',
	                'photo_album': '<path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z"/>',
	                'photo_camera': '<circle cx="12" cy="12" r="3.2"/><path d="M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zM9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9z"/>',
	                'photo_filter': '<path d="M17.13 8.9l.59-1.3 1.3-.6-1.3-.59-.59-1.3-.59 1.3-1.31.59 1.31.6z"/><path d="M12.39 6.53l-1.18 2.61-2.61 1.18 2.61 1.18 1.18 2.61 1.19-2.61 2.6-1.18-2.6-1.18z"/><path d="M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2z"/>',
	                'photo_library': '<path d="M11 12l2.03 2.71L16 11l4 5H8l3-4zm11 4V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2z"/><path d="M2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"/>',
	                'photo_size_select_actual': '<path d="M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"/>',
	                'photo_size_select_large': '<path d="M21 15h2v2h-2v-2z"/><path d="M21 11h2v2h-2v-2z"/><path d="M23 19h-2v2c1 0 2-1 2-2z"/><path d="M13 3h2v2h-2V3z"/><path d="M21 7h2v2h-2V7z"/><path d="M21 3v2h2c0-1-1-2-2-2z"/><path d="M1 7h2v2H1V7z"/><path d="M17 3h2v2h-2V3z"/><path d="M17 19h2v2h-2v-2z"/><path d="M3 3C2 3 1 4 1 5h2V3z"/><path d="M9 3h2v2H9V3z"/><path d="M5 3h2v2H5V3z"/><path d="M3 19l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3zm-2-8v8c0 1.1.9 2 2 2h12V11H1z"/>',
	                'photo_size_select_small': '<path d="M23 15h-2v2h2v-2z"/><path d="M23 11h-2v2h2v-2z"/><path d="M23 19h-2v2c1 0 2-1 2-2z"/><path d="M15 3h-2v2h2V3z"/><path d="M23 7h-2v2h2V7z"/><path d="M21 3v2h2c0-1-1-2-2-2z"/><path d="M3 21h8v-6H1v4c0 1.1.9 2 2 2z"/><path d="M3 7H1v2h2V7z"/><path d="M15 19h-2v2h2v-2z"/><path d="M19 3h-2v2h2V3z"/><path d="M19 19h-2v2h2v-2z"/><path d="M3 3C2 3 1 4 1 5h2V3z"/><path d="M3 11H1v2h2v-2z"/><path d="M11 3H9v2h2V3z"/><path d="M7 3H5v2h2V3z"/>',
	                'picture_as_pdf': '<path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/><path d="M14 11.5h1v-3h-1v3zm-5-2h1v-1H9v1zm11.5-1H19v1h1.5V11H19v2h-1.5V7h3v1.5zm-4 3c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm-5-2c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zM20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>',
	                'portrait': '<path d="M16.5 16.25c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zm-4.5-4c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25z"/><path d="M19 19H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'remove_red_eye': '<path d="M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"/><path d="M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>',
	                'rotate_90_degrees_ccw': '<path d="M3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm3.65-6.49L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49z"/><path d="M19.36 6.64A8.95 8.95 0 0 0 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 0 1 0 9.9 6.973 6.973 0 0 1-7.79 1.44l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 0 0 0-12.72z"/>',
	                'rotate_left': '<path d="M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47z"/><path d="M6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47z"/><path d="M7.1 18.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32z"/><path d="M13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"/>',
	                'rotate_right': '<path d="M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45z"/><path d="M19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02z"/><path d="M13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03z"/><path d="M16.89 15.48l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"/>',
	                'slideshow': '<path d="M10 8v8l5-4-5-4z"/><path d="M19 19H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'straighten': '<path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"/>',
	                'style': '<path d="M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61z"/><path d="M7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm14.15 7.2L17.07 3.98a2.013 2.013 0 0 0-1.81-1.23c-.26 0-.53.04-.79.15L7.1 5.95a1.999 1.999 0 0 0-1.08 2.6l4.96 11.97a1.998 1.998 0 0 0 2.6 1.08l7.36-3.05a1.994 1.994 0 0 0 1.09-2.6z"/><path d="M5.88 19.75c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"/>',
	                'switch_camera': '<path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"/>',
	                'switch_video': '<path d="M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"/>',
	                'tag_faces': '<path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.01-18C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z"/><path d="M15.5 11c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5z"/><path d="M8.5 11c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11z"/><path d="M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>',
	                'texture': '<path d="M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41z"/><path d="M11.88 3L3 11.88v2.83L14.71 3h-2.83z"/><path d="M5 3c-1.1 0-2 .9-2 2v2l4-4H5z"/><path d="M19 21c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2z"/><path d="M9.29 21h2.83L21 12.12V9.29L9.29 21z"/>',
	                'timelapse': '<path d="M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48z"/><path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>',
	                'timer': '<path d="M15 1H9v2h6V1z"/><path d="M11 14h2V8h-2v6z"/><path d="M12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm7.03-12.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61z"/>',
	                'timer_10': '<path d="M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72z"/><path d="M23.78 14.37c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 0 1-.87-.23 2.61 2.61 0 0 1-.55-.25.717.717 0 0 1-.28-.3.978.978 0 0 1 .01-.8c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95a2.517 2.517 0 0 0-.93-1.97c-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84a2.2 2.2 0 0 0-.23 1.01c0 .36.08.69.23.96.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 0 1-.59-1.11h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"/><path d="M12.9 13.22c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51zm.92-6.17c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59z"/>',
	                'timer_3': '<path d="M11.61 12.97c-.16-.24-.36-.46-.62-.65a3.38 3.38 0 0 0-.93-.48c.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76z"/><path d="M20.87 14.37c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 0 1-.87-.23 2.61 2.61 0 0 1-.55-.25.717.717 0 0 1-.28-.3.935.935 0 0 1-.08-.39.946.946 0 0 1 .36-.75c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95a2.517 2.517 0 0 0-.93-1.97c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84a2.2 2.2 0 0 0-.23 1.01c0 .36.08.68.23.96.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 0 1-.59-1.11h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"/>',
	                'timer_off': '<path d="M19.04 4.55l-1.42 1.42a9.012 9.012 0 0 0-10.57-.49l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45A8.878 8.878 0 0 0 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42z"/><path d="M15 1H9v2h6V1z"/><path d="M11 9.44l2 2V8h-2v1.44z"/><path d="M12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96zM3.02 4L1.75 5.27 4.5 8.03A8.905 8.905 0 0 0 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4z"/>',
	                'tonality': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"/>',
	                'transform': '<path d="M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4z"/><path d="M10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"/>',
	                'tune': '<path d="M13 21v-2h8v-2h-8v-2h-2v6h2zM3 17v2h6v-2H3z"/><path d="M21 13v-2H11v2h10zM7 9v2H3v2h4v2h2V9H7z"/><path d="M15 9h2V7h4V5h-4V3h-2v6zM3 5v2h10V5H3z"/>',
	                'view_comfy': '<path d="M3 9h4V5H3v4z"/><path d="M3 14h4v-4H3v4z"/><path d="M8 14h4v-4H8v4z"/><path d="M13 14h4v-4h-4v4z"/><path d="M8 9h4V5H8v4z"/><path d="M13 5v4h4V5h-4z"/><path d="M18 14h4v-4h-4v4z"/><path d="M3 19h4v-4H3v4z"/><path d="M8 19h4v-4H8v4z"/><path d="M13 19h4v-4h-4v4z"/><path d="M18 19h4v-4h-4v4z"/><path d="M18 5v4h4V5h-4z"/>',
	                'view_compact': '<path d="M3 19h6v-7H3v7z"/><path d="M10 19h12v-7H10v7z"/><path d="M3 5v6h19V5H3z"/>',
	                'vignette': '<path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"/>',
	                'wb_auto': '<path d="M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z"/>',
	                'wb_cloudy': '<path d="M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"/>',
	                'wb_incandescent': '<path d="M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"/><path d="M11 22.45h2V19.5h-2v2.95z"/><path d="M4 10.5H1v2h3v-2z"/><path d="M15 6.31V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19z"/><path d="M20 10.5v2h3v-2h-3z"/><path d="M17.24 18.16l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"/>',
	                'wb_irradescent': '<path d="M5 14.5h14v-6H5v6z"/><path d="M11 .55V3.5h2V.55h-2z"/><path d="M19.04 3.05l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41z"/><path d="M13 22.45V19.5h-2v2.95h2z"/><path d="M20.45 18.54l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42z"/><path d="M3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41z"/><path d="M4.96 19.95l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z"/>',
	                'wb_sunny': '<path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41z"/><path d="M4 10.5H1v2h3v-2z"/><path d="M13 .55h-2V3.5h2V.55z"/><path d="M20.45 4.46l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79z"/><path d="M17.24 18.16l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"/><path d="M20 10.5v2h3v-2h-3z"/><path d="M12 5.5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"/><path d="M11 22.45h2V19.5h-2v2.95z"/><path d="M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"/>',
	                //
	                // maps
	                //
	                'add_location': '<path d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z"/>',
	                'beenhere': '<path d="M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z"/>',
	                'directions': '<path d="M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z"/>',
	                'directions_bike': '<path d="M16 4.8c.99 0 1.8-.81 1.8-1.8s-.81-1.8-1.8-1.8c-1 0-1.8.81-1.8 1.8S15 4.8 16 4.8z"/><path d="M19 20.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm0-8.5c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"/><path d="M14.8 10H19V8.2h-3.2l-1.93-3.27c-.3-.5-.84-.83-1.46-.83-.47 0-.89.19-1.2.5l-3.7 3.7c-.32.3-.51.73-.51 1.2 0 .63.33 1.16.85 1.47L11.2 13v5H13v-6.48l-2.25-1.67 2.32-2.33L14.8 10z"/><path d="M5 20.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zM5 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"/>',
	                'directions_bus': '<path d="M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"/>',
	                'directions_car': '<path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>',
	                'directions_ferry': '<path d="M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2z"/><path d="M6 6h12v3.97L12 8 6 9.97V6zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19z"/>',
	                'directions_subway': '<path d="M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"/>',
	                'directions_train': '<path d="M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z"/>',
	                'directions_transit': '<path d="M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"/>',
	                'directions_walk': '<path d="M14 3.8c.99 0 1.8-.81 1.8-1.8 0-1-.81-1.8-1.8-1.8-1 0-1.8.81-1.8 1.8S13 3.8 14 3.8z"/><path d="M14.12 10H19V8.2h-3.62l-2-3.33c-.3-.5-.84-.83-1.46-.83-.17 0-.34.03-.49.07L6 5.8V11h1.8V7.33l2.11-.66L6 22h1.8l2.87-8.11L13 17v5h1.8v-6.41l-2.49-4.54.73-2.87L14.12 10z"/>',
	                'edit_location': '<path d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z"/>',
	                'ev_station': '<path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z"/>',
	                'flight': '<path d="M10.18 9"/><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>',
	                'hotel': '<path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3z"/><path d="M19 7h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"/>',
	                'layers': '<path d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74z"/><path d="M12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"/>',
	                'layers_clear': '<path d="M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43z"/><path d="M19.36 10.27L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88z"/><path d="M3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z"/>',
	                'local_activity': '<path d="M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"/>',
	                'local_airport': '<path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>',
	                'local_atm': '<path d="M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1z"/><path d="M20 18H4V6h16v12zm0-14H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2z"/>',
	                'local_bar': '<path d="M11 13v6H6v2h12v-2h-5v-6l8-8V3H3v2l8 8zM7.5 7l-2-2h13l-2 2h-9z"/>',
	                'local_cafe': '<path d="M20 8h-2V5h2v3zm0-5H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2z"/><path d="M2 21h18v-2H2v2z"/>',
	                'local_car_wash': '<path d="M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5z"/><path d="M12 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5z"/><path d="M7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5z"/><path d="M5 13l1.5-4.5h11L19 13H5zm12.5 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm-11 0c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm12.42-9.99C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99z"/>',
	                'local_convenience_store': '<path d="M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z"/>',
	                'local_dining': '<path d="M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 0 0 0 5.66l4.19 4.18z"/><path d="M14.88 11.53c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/>',
	                'local_drink': '<path d="M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z"/>',
	                'local_florist': '<path d="M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9z"/><path d="M12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zm-6.4 4.75c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25z"/><path d="M3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z"/>',
	                'local_gas_station': '<path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>',
	                'local_grocery_store': '<path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"/><path d="M1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1z"/><path d="M17 18c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>',
	                'local_hospital': '<path d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"/>',
	                'local_hotel': '<path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3z"/><path d="M19 7h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"/>',
	                'local_laundry_service': '<path d="M9.17 16.83a4.008 4.008 0 0 0 5.66 0 4.008 4.008 0 0 0 0-5.66l-5.66 5.66z"/><path d="M12 20c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm3 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm8-1.99L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99z"/>',
	                'local_library': '<path d="M12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"/><path d="M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55z"/>',
	                'local_mall': '<path d="M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"/>',
	                'local_movies': '<path d="M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"/>',
	                'local_offer': '<path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/>',
	                'local_parking': '<path d="M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"/>',
	                'local_pharmacy': '<path d="M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"/>',
	                'local_phone': '<path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>',
	                'local_pizza': '<path d="M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>',
	                'local_play': '<path d="M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"/>',
	                'local_post_office': '<path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>',
	                'local_print_shop': '<path d="M19 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-3 7H8v-5h8v5zm3-11H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3z"/><path d="M18 3H6v4h12V3z"/>',
	                'local_restaurant': '<path d="M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 0 0 0 5.66l4.19 4.18z"/><path d="M14.88 11.53c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/>',
	                'local_see': '<circle cx="12" cy="12" r="3.2"/><path d="M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zM9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9z"/>',
	                'local_shipping': '<path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>',
	                'local_taxi': '<path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>',
	                'map': '<path d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"/>',
	                'my_location': '<path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/><path d="M12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm8.94-8c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06z"/>',
	                'navigation': '<path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"/>',
	                'near_me': '<path d="M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"/>',
	                'person_pin_circle': '<path d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z"/>',
	                'person_pin': '<path d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z"/>',
	                'pin_drop': '<path d="M10 8c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zm8 0c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11z"/><path d="M5 20v2h14v-2H5z"/>',
	                'place': '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>',
	                'rate_review': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"/>',
	                'restaurant': '<path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7z"/><path d="M16 6v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/>',
	                'restaurant_menu': '<path d="M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 0 0 0 5.66l4.19 4.18z"/><path d="M14.88 11.53c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/>',
	                'satellite': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z"/>',
	                'store_mall_directory': '<path d="M20 4H4v2h16V4z"/><path d="M12 18H6v-4h6v4zm9-4v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1z"/>',
	                'streetview': '<path d="M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"/><circle cx="18" cy="6" r="5"/><path d="M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"/>',
	                'subway': '<circle cx="15.5" cy="16" r="1"/><circle cx="8.5" cy="16" r="1"/><path d="M7.01 9h10v5h-10z"/><path d="M17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z"/>',
	                'terrain': '<path d="M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"/>',
	                'traffic': '<path d="M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z"/>',
	                'train': '<path d="M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>',
	                'tram': '<path d="M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z"/>',
	                'transfer_within_a_station': '<path d="M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5z"/><path d="M19.51 19.75H14v1.5h5.51V23L22 20.5 19.51 18z"/><path d="M9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"/>',
	                'zoom_out_map': '<path d="M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3z"/><path d="M3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3z"/><path d="M9 21l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6z"/><path d="M21 15l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z"/>',
	                //
	                // navigation
	                //
	                'apps': '<path d="M4 8h4V4H4v4z"/><path d="M10 20h4v-4h-4v4z"/><path d="M4 20h4v-4H4v4z"/><path d="M4 14h4v-4H4v4z"/><path d="M10 14h4v-4h-4v4z"/><path d="M16 4v4h4V4h-4z"/><path d="M10 8h4V4h-4v4z"/><path d="M16 14h4v-4h-4v4z"/><path d="M16 20h4v-4h-4v4z"/>',
	                'arrow_back': '<path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>',
	                'arrow_downward': '<path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/>',
	                'arrow_drop_down': '<path d="M7 10l5 5 5-5z"/>',
	                'arrow_drop_down_circle': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z"/>',
	                'arrow_drop_up': '<path d="M7 14l5-5 5 5z"/>',
	                'arrow_forward': '<path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>',
	                'arrow_upwards': '<path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/>',
	                'cancel': '<path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>',
	                'check': '<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>',
	                'chevron_left': '<path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>',
	                'chevron_right': '<path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>',
	                'close': '<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>',
	                'expand_less': '<path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"/>',
	                'expand_more': '<path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>',
	                'first_page': '<path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6z"/><path d="M6 6h2v12H6z"/>',
	                'fullscreen': '<path d="M7 14H5v5h5v-2H7v-3z"/><path d="M5 10h2V7h3V5H5v5z"/><path d="M17 17h-3v2h5v-5h-2v3z"/><path d="M14 5v2h3v3h2V5h-5z"/>',
	                'fullscreen_exit': '<path d="M5 16h3v3h2v-5H5v2z"/><path d="M8 8H5v2h5V5H8v3z"/><path d="M14 19h2v-3h3v-2h-5v5z"/><path d="M16 8V5h-2v5h5V8h-3z"/>',
	                'last_page': '<path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6z"/><path d="M16 6h2v12h-2z"/>',
	                'menu': '<path d="M3 18h18v-2H3v2z"/><path d="M3 13h18v-2H3v2z"/><path d="M3 6v2h18V6H3z"/>',
	                'more_horiz': '<path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M18 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>',
	                'more_vert': '<path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/><path d="M12 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>',
	                'refresh': '<path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>',
	                'subdirectory_arrow_left': ' <path d="M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"/>',
	                'subdirectory_arrow_right': '<path d="M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"/>',
	                //
	                // notification
	                //
	                'adb': '<path d="M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4z"/><path d="M15 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7.12-4.63l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63z"/>',
	                'airline_seat_flat': '<path d="M22 11v2H9V7h9c2.21 0 4 1.79 4 4z"/><path d="M2 14v2h6v2h8v-2h6v-2H2z"/><path d="M7.14 12.1a3 3 0 0 0-.04-4.24 3 3 0 0 0-4.24.04 3 3 0 0 0 .04 4.24 3 3 0 0 0 4.24-.04z"/>',
	                'airline_seat_angled': '<path d="M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09a4 4 0 0 1 2.41 5.15z"/><path d="M1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89z"/><path d="M7.3 10.2a3.01 3.01 0 0 0 1.41-4A3.005 3.005 0 0 0 4.7 4.8a2.99 2.99 0 0 0-1.4 4 2.99 2.99 0 0 0 4 1.4z"/>',
	                'airline_seat_individual_suite': '<path d="M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3z"/><path d="M19 7h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z"/>',
	                'airline_seat_legroom_extra': '<path d="M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3z"/><path d="M22.83 17.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98a2.01 2.01 0 0 0-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"/>',
	                'airline_seat_legroom_normal': '<path d="M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3z"/><path d="M20.5 18H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"/>',
	                'airline_seat_legroom_reduced': '<path d="M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2z"/><path d="M5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"/>',
	                'airline_seat_recline_extra': '<path d="M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49z"/><path d="M16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76A5.01 5.01 0 0 0 8.94 21H16v-2z"/><path d="M16.23 15h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38a2.21 2.21 0 0 0-.99-.06h-.02a2.268 2.268 0 0 0-1.84 2.61l1.35 5.92A3.008 3.008 0 0 0 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"/>',
	                'airline_seat_recline_normal': '<path d="M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0z"/><path d="M6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3z"/><path d="M20 20.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"/>',
	                'bluetooth_audio': '<path d="M19.53 6.71l-1.26 1.26c.63 1.21.98 2.57.98 4.02 0 1.45-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-5.29 5.3l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32z"/><path d="M12.88 16.29L11 18.17v-3.76l1.88 1.88zM11 5.83l1.88 1.88L11 9.59V5.83zm4.71 1.88L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29z"/>',
	                'confirmation_number': '<path d="M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"/>',
	                'disc_full': '<path d="M20 7v5h2V7h-2zm0 9h2v-2h-2v2z"/><path d="M10 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-10c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z"/>',
	                'do_not_disturb': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"/>',
	                'do_not_disturb_alt': '<path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"/>',
	                'do_not_disturb_off': '<path d="M17 11v2h-1.46l4.68 4.68A9.92 9.92 0 0 0 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17z"/><path d="M7 13v-2h1.46l2 2H7zM2.27 2.27L1 3.54l2.78 2.78A9.92 9.92 0 0 0 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27z"/>',
	                'do_not_disturb_on': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/>',
	                'drive_eta': '<path d="M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"/>',
	                'enhanced_encryption': '<path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"/>',
	                'event_available': '<path d="M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94z"/><path d="M19 19H5V8h14v11zm0-16h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'event_busy': '<path d="M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17z"/><path d="M19 19H5V8h14v11zm0-16h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'event_note': '<path d="M19 19H5V8h14v11zm0-16h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M14 14H7v2h7v-2zm3-4H7v2h10v-2z"/>',
	                'folder_special': '<path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6.42 12L10 15.9 6.42 18l.95-4.07-3.16-2.74 4.16-.36L10 7l1.63 3.84 4.16.36-3.16 2.74.95 4.06z"/>',
	                'live_tv': '<path d="M21 20H3V8h18v12zm0-14h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8a2 2 0 0 0-2-2z"/><path d="M9 10v8l7-4z"/>',
	                'mms': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z"/>',
	                'more': '<path d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>',
	                'network_check': '<path d="M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5z"/><path d="M21 11l2-2a15.367 15.367 0 0 0-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9z"/><path d="M5 13l2 2a7.1 7.1 0 0 1 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88zm12 2l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97z"/>',
	                'network_locked': '<path d="M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5z"/><path d="M21 16h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16zm1 0v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z"/>',
	                'no_encryption': '<path d="M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78z"/><path d="M8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z"/>',
	                'ondemand_video': '<path d="M21 17H3V5h18v12zm0-14H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2z"/><path d="M16 11l-7 4V7z"/>',
	                'personal_video': '<path d="M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"/>',
	                'phone_bluetooth_speaker': '<path d="M18 7.21l.94.94-.94.94V7.21zm0-4.3l.94.94-.94.94V2.91zM14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71z"/><path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/>',
	                'phone_forwarded': '<path d="M18 11l5-5-5-5v3h-4v4h4v3z"/><path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/>',
	                'phone_in_talk': '<path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/><path d="M19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7z"/><path d="M15 12h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z"/>',
	                'phone_locked': '<path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/><path d="M19.2 4h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm.8 0v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"/>',
	                'phone_missed': '<path d="M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5z"/><path d="M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.28-.12-.52-.3-.7z"/>',
	                'phone_paused': '<path d="M17 3h-2v7h2V3z"/><path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/><path d="M19 3v7h2V3h-2z"/>',
	                'power': '<path d="M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z"/>',
	                'priority_high': '<circle cx="12" cy="19" r="2"/><path d="M10 3h4v12h-4z"/>',
	                'sd_card': '<path d="M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"/>',
	                'sim_card_alert': '<path d="M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z"/>',
	                'sms': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"/>',
	                'sms_failed': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"/>',
	                'sync': '<path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8z"/><path d="M12 18c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/>',
	                'sync_disabled': '<path d="M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33z"/><path d="M2.86 5.41l2.36 2.36a7.925 7.925 0 0 0 1.14 9.87L4 20h6v-6l-2.24 2.24A6.003 6.003 0 0 1 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41z"/><path d="M20 4h-6v6l2.24-2.24A6.003 6.003 0 0 1 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46a7.925 7.925 0 0 0-1.14-9.87L20 4z"/>',
	                'sync_problem': '<path d="M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12z"/><path d="M21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4z"/><path d="M11 13h2V7h-2v6zm0 4h2v-2h-2v2z"/>',
	                'system_update': '<path d="M17 19H7V5h10v14zm0-17.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"/><path d="M16 13h-3V8h-2v5H8l4 4 4-4z"/>',
	                'tap_and_play': '<path d="M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7z"/><path d="M2 20v3h3c0-1.66-1.34-3-3-3z"/><path d="M2 12v2a9 9 0 0 1 9 9h2c0-6.08-4.92-11-11-11z"/><path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"/>',
	                'time_to_leave': '<path d="M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"/>',
	                'vibration': '<path d="M0 15h2V9H0v6z"/><path d="M3 17h2V7H3v10z"/><path d="M22 9v6h2V9h-2z"/><path d="M19 17h2V7h-2v10z"/><path d="M16 19H8V5h8v14zm.5-16h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5z"/>',
	                'voice_chat': '<path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z"/>',
	                'vpn_lock': '<path d="M21.2 4h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm.8 0v-.5a2.5 2.5 0 0 0-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"/><path d="M10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93zM18.92 12c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03z"/>',
	                'wc': '<path d="M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4z"/><path d="M18 22v-6h3l-2.54-7.63A2.01 2.01 0 0 0 16.56 7h-.12a2 2 0 0 0-1.9 1.37L12 16h3v6h3z"/><path d="M7.5 6c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2 .89-2 2 0 1.11.89 2 2 2z"/><path d="M16.5 6c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2 .89-2 2 0 1.11.89 2 2 2z"/>',
	                'wifi': '<path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9z"/><path d="M9 17l3 3 3-3a4.237 4.237 0 0 0-6 0z"/><path d="M5 13l2 2a7.074 7.074 0 0 1 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"/>',
	                //
	                // places
	                //
	                'ac_unit': '<path d="M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"/>',
	                'airport_shuttle': '<path d="M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z"/>',
	                'all_inclusive': '<path d="M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"/>',
	                'beach_access': '<path d="M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21z"/><path d="M17.42 8.83l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88z"/><path d="M5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98z"/><path d="M5.97 5.96l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z"/>',
	                'business_center': '<path d="M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4z"/><path d="M14 7h-4V5h4v2zm6 0h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2z"/>',
	                'casino': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"/>',
	                'child_care': '<circle cx="14.5" cy="10.5" r="1.25"/> <circle cx="9.5" cy="10.5" r="1.25"/> <path d="M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z"/>',
	                'child_friedly': '<path d="M13 2v8h8c0-4.42-3.58-8-8-8z"/><path d="M17 20c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20zm-9 0c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm11.32-4.11A7.948 7.948 0 0 0 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61z"/>',
	                'fitness_center': '<path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"/>',
	                'free_breakfast': '<path d="M20 8h-2V5h2v3zm0-5H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 0 0 2-2V5c0-1.11-.89-2-2-2z"/><path d="M4 19h16v2H4z"/>',
	                'golf_course': '<circle cx="19.5" cy="19.5" r="1.5"/><path d="M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"/>',
	                'hot_tub': '<circle cx="7" cy="6" r="2"/><path d="M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"/>',
	                'kitchen': '<path d="M18 9H6V4h12v5zm0 11H6v-9.02h12V20zm0-17.99L6 2a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99z"/><path d="M8 5h2v3H8z"/><path d="M8 12h2v5H8z"/>',
	                'pool': '<path d="M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z"/> <circle cx="16.5" cy="5.5" r="2.5"/>',
	                'room_service': '<path d="M2 17h20v2H2z"/><path d="M13.84 7.79A2.006 2.006 0 0 0 12 5a2.006 2.006 0 0 0-1.84 2.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z"/>',
	                'rv_hookup': '<path d="M18 14h-4v-3h4v3zm-7 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm9-3v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2z"/><path d="M17 2v2H9v2h8v2l3-3z"/>',
	                'smoke_free': '<path d="M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17z"/><path d="M20.5 13H22v3h-1.5z"/><path d="M18 13h1.5v3H18z"/><path d="M18.85 4.88c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04z"/><path d="M14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2a3.35 3.35 0 0 0 0 6.7z"/><path d="M17 15.93V13h-2.93z"/>',
	                'smoke_rooms': '<path d="M2 16h15v3H2z"/><path d="M20.5 16H22v3h-1.5z"/><path d="M18 16h1.5v3H18z"/><path d="M18.85 7.73c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03z"/><path d="M16.03 10.2H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5a3.35 3.35 0 0 0 0 6.7h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"/>',
	                'spa': '<path d="M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z"/> <path d="M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"/>',
	                //
	                // social
	                //
	                'cake': '<path d="M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2z"/><path d="M16.6 15.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01z"/><path d="M18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"/>',
	                'domain': '<path d="M20 19h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zM10 7H8V5h2v2zm0 4H8V9h2v2zm0 4H8v-2h2v2zm0 4H8v-2h2v2zM6 7H4V5h2v2zm0 4H4V9h2v2zm0 4H4v-2h2v2zm0 4H4v-2h2v2zm6-12V3H2v18h20V7H12z"/><path d="M18 11h-2v2h2v-2z"/><path d="M18 15h-2v2h2v-2z"/>',
	                'group': '<path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3z"/><path d="M8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3z"/><path d="M8 13c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/><path d="M16 13c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>',
	                'group_add': '<path d="M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2z"/><path d="M18 11c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86 0 1.07-.34 2.04-.9 2.86.28.09.59.14.91.14z"/><path d="M13 11c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3z"/><path d="M19.62 13.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84z"/><path d="M13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"/>',
	                'location_city': '<path d="M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"/>',
	                'mood': '<path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.01-18C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z"/><path d="M15.5 11c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5z"/><path d="M8.5 11c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11z"/><path d="M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>',
	                'mood_bad': '<path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.01-18C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z"/><path d="M15.5 11c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5z"/><path d="M8.5 11c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11z"/><path d="M12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"/>',
	                'notifications': '<path d="M11.5 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"/><path d="M18 16v-5.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-2.87.68-5 3.25-5 6.32V16l-2 2v1h17v-1l-2-2z"/>',
	                'notifications_none': '<path d="M11.5 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"/><path d="M16 17H7v-6.5C7 8.01 9.01 6 11.5 6S16 8.01 16 10.5V17zm2-1v-5.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-2.87.68-5 3.25-5 6.32V16l-2 2v1h17v-1l-2-2z"/>',
	                'notifications_off': '<path d="M11.5 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"/><path d="M18 10.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-.51.12-.99.32-1.45.56L18 14.18V10.5z"/><path d="M17.73 19l2 2L21 19.73 4.27 3 3 4.27l2.92 2.92C5.34 8.16 5 9.29 5 10.5V16l-2 2v1h14.73z"/>',
	                'notifications_active': '<path d="M6.58 3.58L5.15 2.15C2.76 3.97 1.18 6.8 1.03 10h2c.15-2.65 1.51-4.97 3.55-6.42z"/><path d="M19.97 10h2c-.15-3.2-1.73-6.03-4.13-7.85l-1.43 1.43c2.05 1.45 3.41 3.77 3.56 6.42z"/><path d="M18 10.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-2.87.68-5 3.25-5 6.32V16l-2 2v1h17v-1l-2-2v-5.5z"/><path d="M11.5 22c.14 0 .27-.01.4-.04.65-.13 1.19-.58 1.44-1.18.1-.24.16-.5.16-.78h-4c0 1.1.9 2 2 2z"/>',
	                'notifications_paused': '<path d="M11.5 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"/><path d="M14 9.8l-2.8 3.4H14V15H9v-1.8l2.8-3.4H9V8h5v1.8zm4 6.2v-5.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-2.87.68-5 3.25-5 6.32V16l-2 2v1h17v-1l-2-2z"/>',
	                'pages': '<path d="M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2z"/><path d="M8 13H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4z"/><path d="M17 17l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4z"/><path d="M19 3h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z"/>',
	                'party_mode': '<path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z"/>',
	                'people': '<path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3z"/><path d="M8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3z"/><path d="M8 13c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/><path d="M16 13c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>',
	                'people_outline': '<path d="M21.5 17.5H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zm-9 0h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm4-4.5c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25z"/><path d="M7.5 6.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 5.5c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12z"/><path d="M16.5 6.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5z"/>',
	                'person': '<path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"/><path d="M12 14c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>',
	                'person_add': '<path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"/><path d="M6 10V7H4v3H1v2h3v3h2v-3h3v-2H6z"/><path d="M15 14c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>',
	                'person_outline': '<path d="M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1.9c1.16 0 2.1.94 2.1 2.1 0 1.16-.94 2.1-2.1 2.1-1.16 0-2.1-.94-2.1-2.1 0-1.16.94-2.1 2.1-2.1"/><path d="M12 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm0 1.9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1"/>',
	                'plus_one': '<path d="M10 8H8v4H4v2h4v4h2v-4h4v-2h-4z"/><path d="M14.5 6.08V7.9l2.5-.5V18h2V5z"/>',
	                'poll': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>',
	                'public': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>',
	                'school': '<path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>',
	                'sentiment_dissatisfied': '<circle cx="15.5" cy="9.5" r="1.5"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"/>',
	                'sentiment_neutral': '<path d="M9 14h6v1.5H9z"/><circle cx="15.5" cy="9.5" r="1.5"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>',
	                'sentiment_satisfied': '<circle cx="15.5" cy="9.5" r="1.5"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z"/>',
	                'sentiment_very_dissatisfied': '<path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.01-18C6.47 2 2 6.47 2 12s4.47 10 9.99 10C17.51 22 22 17.53 22 12S17.52 2 11.99 2z"/><path d="M16.18 7.76l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06z"/><path d="M7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06z"/><path d="M12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"/>',
	                'sentiment_very_satisfied': '<path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.01-18C6.47 2 2 6.47 2 12s4.47 10 9.99 10C17.51 22 22 17.53 22 12S17.52 2 11.99 2z"/><path d="M13 9.94L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12z"/><path d="M8.88 9.94L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11z"/><path d="M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>',
	                'share': '<path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>',
	                'whatshot': '<path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"/>',
	                //
	                // toggle
	                //
	                'check_box': '<path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>',
	                'check_box_outline_blank': '<path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>',
	                'indeterminate_check_box': '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"/>',
	                'radio_button_unchecked': '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>',
	                'radio_button_checked': '<path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"/><path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>',
	                'star': '<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>',
	                'star_half': '<path d="M22 9.74l-7.19-.62L12 2.5 9.19 9.13 2 9.74l5.46 4.73-1.64 7.03L12 17.77l6.18 3.73-1.63-7.03L22 9.74zM12 15.9V6.6l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.9z"/>',
	                'star_border': '<path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/>'
	            };
	        }
	
	        function ngMdIconServiceFactory() {
	            return service;
	        }
	    })
	;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(605);
	module.exports = 'ngMdIcons';


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*!
	 * Angular Material Design
	 * https://github.com/angular/material
	 * @license MIT
	 * v1.1.1
	 */
	(function( window, angular, undefined ){
	"use strict";
	
	(function(){
	"use strict";
	
	angular.module('ngMaterial', ["ng","ngAnimate","ngAria","material.core","material.core.gestures","material.core.layout","material.core.meta","material.core.theming.palette","material.core.theming","material.core.animate","material.components.autocomplete","material.components.backdrop","material.components.bottomSheet","material.components.button","material.components.card","material.components.chips","material.components.checkbox","material.components.colors","material.components.content","material.components.datepicker","material.components.dialog","material.components.divider","material.components.fabActions","material.components.fabShared","material.components.fabSpeedDial","material.components.fabToolbar","material.components.gridList","material.components.icon","material.components.input","material.components.list","material.components.menu","material.components.menuBar","material.components.navBar","material.components.panel","material.components.progressCircular","material.components.progressLinear","material.components.radioButton","material.components.select","material.components.showHide","material.components.sidenav","material.components.slider","material.components.sticky","material.components.subheader","material.components.swipe","material.components.switch","material.components.tabs","material.components.toast","material.components.toolbar","material.components.tooltip","material.components.virtualRepeat","material.components.whiteframe"]);
	})();
	(function(){
	"use strict";
	
	/**
	 * Initialization function that validates environment
	 * requirements.
	 */
	DetectNgTouch.$inject = ["$log", "$injector"];
	MdCoreConfigure.$inject = ["$provide", "$mdThemingProvider"];
	rAFDecorator.$inject = ["$delegate"];
	angular
	  .module('material.core', [
	    'ngAnimate',
	    'material.core.animate',
	    'material.core.layout',
	    'material.core.gestures',
	    'material.core.theming'
	  ])
	  .config(MdCoreConfigure)
	  .run(DetectNgTouch);
	
	
	/**
	 * Detect if the ng-Touch module is also being used.
	 * Warn if detected.
	 * @ngInject
	 */
	function DetectNgTouch($log, $injector) {
	  if ( $injector.has('$swipe') ) {
	    var msg = "" +
	      "You are using the ngTouch module. \n" +
	      "Angular Material already has mobile click, tap, and swipe support... \n" +
	      "ngTouch is not supported with Angular Material!";
	    $log.warn(msg);
	  }
	}
	
	/**
	 * @ngInject
	 */
	function MdCoreConfigure($provide, $mdThemingProvider) {
	
	  $provide.decorator('$$rAF', ["$delegate", rAFDecorator]);
	
	  $mdThemingProvider.theme('default')
	    .primaryPalette('indigo')
	    .accentPalette('pink')
	    .warnPalette('deep-orange')
	    .backgroundPalette('grey');
	}
	
	/**
	 * @ngInject
	 */
	function rAFDecorator($delegate) {
	  /**
	   * Use this to throttle events that come in often.
	   * The throttled function will always use the *last* invocation before the
	   * coming frame.
	   *
	   * For example, window resize events that fire many times a second:
	   * If we set to use an raf-throttled callback on window resize, then
	   * our callback will only be fired once per frame, with the last resize
	   * event that happened before that frame.
	   *
	   * @param {function} callback function to debounce
	   */
	  $delegate.throttle = function(cb) {
	    var queuedArgs, alreadyQueued, queueCb, context;
	    return function debounced() {
	      queuedArgs = arguments;
	      context = this;
	      queueCb = cb;
	      if (!alreadyQueued) {
	        alreadyQueued = true;
	        $delegate(function() {
	          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
	          alreadyQueued = false;
	        });
	      }
	    };
	  };
	  return $delegate;
	}
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	  .directive('mdAutofocus', MdAutofocusDirective)
	
	  // Support the deprecated md-auto-focus and md-sidenav-focus as well
	  .directive('mdAutoFocus', MdAutofocusDirective)
	  .directive('mdSidenavFocus', MdAutofocusDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdAutofocus
	 * @module material.core.util
	 *
	 * @description
	 *
	 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
	 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
	 *
	 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
	 * attribute directive and optional expression. An expression may be specified as the directive
	 * value to enable conditional activation of the autofocus.
	 *
	 * @usage
	 *
	 * ### Dialog
	 * <hljs lang="html">
	 * <md-dialog>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-autofocus>
	 *     </md-input-container>
	 *   </form>
	 * </md-dialog>
	 * </hljs>
	 *
	 * ### Bottomsheet
	 * <hljs lang="html">
	 * <md-bottom-sheet class="md-list md-has-header">
	 *  <md-subheader>Comment Actions</md-subheader>
	 *  <md-list>
	 *    <md-list-item ng-repeat="item in items">
	 *
	 *      <md-button md-autofocus="$index == 2">
	 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
	 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
	 *      </md-button>
	 *
	 *    </md-list-item>
	 *  </md-list>
	 * </md-bottom-sheet>
	 * </hljs>
	 *
	 * ### Autocomplete
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-autofocus
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Sidenav
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 **/
	function MdAutofocusDirective() {
	  return {
	    restrict: 'A',
	
	    link: postLink
	  }
	}
	
	function postLink(scope, element, attrs) {
	  var attr = attrs.mdAutoFocus || attrs.mdAutofocus || attrs.mdSidenavFocus;
	
	  // Setup a watcher on the proper attribute to update a class we can check for in $mdUtil
	  scope.$watch(attr, function(canAutofocus) {
	    element.toggleClass('md-autofocus', canAutofocus);
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.colorUtil
	 * @description
	 * Color Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdColorUtil', ColorUtilFactory);
	
	function ColorUtilFactory() {
	  /**
	   * Converts hex value to RGBA string
	   * @param color {string}
	   * @returns {string}
	   */
	  function hexToRgba (color) {
	    var hex   = color[ 0 ] === '#' ? color.substr(1) : color,
	      dig   = hex.length / 3,
	      red   = hex.substr(0, dig),
	      green = hex.substr(dig, dig),
	      blue  = hex.substr(dig * 2);
	    if (dig === 1) {
	      red += red;
	      green += green;
	      blue += blue;
	    }
	    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
	  }
	
	  /**
	   * Converts rgba value to hex string
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbaToHex(color) {
	    color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	
	    var hex = (color && color.length === 4) ? "#" +
	    ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[3],10).toString(16)).slice(-2) : '';
	
	    return hex.toUpperCase();
	  }
	
	  /**
	   * Converts an RGB color to RGBA
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbToRgba (color) {
	    return color.replace(')', ', 0.1)').replace('(', 'a(');
	  }
	
	  /**
	   * Converts an RGBA color to RGB
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbaToRgb (color) {
	    return color
	      ? color.replace('rgba', 'rgb').replace(/,[^\),]+\)/, ')')
	      : 'rgb(0,0,0)';
	  }
	
	  return {
	    rgbaToHex: rgbaToHex,
	    hexToRgba: hexToRgba,
	    rgbToRgba: rgbToRgba,
	    rgbaToRgb: rgbaToRgb
	  }
	}
	})();
	(function(){
	"use strict";
	
	
	MdConstantFactory.$inject = ["$sniffer", "$window", "$document"];angular.module('material.core')
	.factory('$mdConstant', MdConstantFactory);
	
	/**
	 * Factory function that creates the grab-bag $mdConstant service.
	 * @ngInject
	 */
	function MdConstantFactory($sniffer, $window, $document) {
	
	  var vendorPrefix = $sniffer.vendorPrefix;
	  var isWebkit = /webkit/i.test(vendorPrefix);
	  var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	  var prefixTestEl = document.createElement('div');
	
	  function vendorProperty(name) {
	    // Add a dash between the prefix and name, to be able to transform the string into camelcase.
	    var prefixedName = vendorPrefix + '-' + name;
	    var ucPrefix = camelCase(prefixedName);
	    var lcPrefix = ucPrefix.charAt(0).toLowerCase() + ucPrefix.substring(1);
	
	    return hasStyleProperty(name)     ? name     :       // The current browser supports the un-prefixed property
	           hasStyleProperty(ucPrefix) ? ucPrefix :       // The current browser only supports the prefixed property.
	           hasStyleProperty(lcPrefix) ? lcPrefix : name; // Some browsers are only supporting the prefix in lowercase.
	  }
	
	  function hasStyleProperty(property) {
	    return angular.isDefined(prefixTestEl.style[property]);
	  }
	
	  function camelCase(input) {
	    return input.replace(SPECIAL_CHARS_REGEXP, function(matches, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	  }
	
	  var self = {
	    isInputKey : function(e) { return (e.keyCode >= 31 && e.keyCode <= 90); },
	    isNumPadKey : function (e){ return (3 === e.location && e.keyCode >= 97 && e.keyCode <= 105); },
	    isNavigationKey : function(e) {
	      var kc = self.KEY_CODE, NAVIGATION_KEYS =  [kc.SPACE, kc.ENTER, kc.UP_ARROW, kc.DOWN_ARROW];
	      return (NAVIGATION_KEYS.indexOf(e.keyCode) != -1);    
	    },
	
	    KEY_CODE: {
	      COMMA: 188,
	      SEMICOLON : 186,
	      ENTER: 13,
	      ESCAPE: 27,
	      SPACE: 32,
	      PAGE_UP: 33,
	      PAGE_DOWN: 34,
	      END: 35,
	      HOME: 36,
	      LEFT_ARROW : 37,
	      UP_ARROW : 38,
	      RIGHT_ARROW : 39,
	      DOWN_ARROW : 40,
	      TAB : 9,
	      BACKSPACE: 8,
	      DELETE: 46
	    },
	    CSS: {
	      /* Constants */
	      TRANSITIONEND: 'transitionend' + (isWebkit ? ' webkitTransitionEnd' : ''),
	      ANIMATIONEND: 'animationend' + (isWebkit ? ' webkitAnimationEnd' : ''),
	
	      TRANSFORM: vendorProperty('transform'),
	      TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
	      TRANSITION: vendorProperty('transition'),
	      TRANSITION_DURATION: vendorProperty('transitionDuration'),
	      ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
	      ANIMATION_DURATION: vendorProperty('animationDuration'),
	      ANIMATION_NAME: vendorProperty('animationName'),
	      ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
	      ANIMATION_DIRECTION: vendorProperty('animationDirection')
	    },
	    /**
	     * As defined in core/style/variables.scss
	     *
	     * $layout-breakpoint-xs:     600px !default;
	     * $layout-breakpoint-sm:     960px !default;
	     * $layout-breakpoint-md:     1280px !default;
	     * $layout-breakpoint-lg:     1920px !default;
	     *
	     */
	    MEDIA: {
	      'xs'        : '(max-width: 599px)'                         ,
	      'gt-xs'     : '(min-width: 600px)'                         ,
	      'sm'        : '(min-width: 600px) and (max-width: 959px)'  ,
	      'gt-sm'     : '(min-width: 960px)'                         ,
	      'md'        : '(min-width: 960px) and (max-width: 1279px)' ,
	      'gt-md'     : '(min-width: 1280px)'                        ,
	      'lg'        : '(min-width: 1280px) and (max-width: 1919px)',
	      'gt-lg'     : '(min-width: 1920px)'                        ,
	      'xl'        : '(min-width: 1920px)'                        ,
	      'landscape' : '(orientation: landscape)'                   ,
	      'portrait'  : '(orientation: portrait)'                    ,
	      'print' : 'print'
	    },
	    MEDIA_PRIORITY: [
	      'xl',
	      'gt-lg',
	      'lg',
	      'gt-md',
	      'md',
	      'gt-sm',
	      'sm',
	      'gt-xs',
	      'xs',
	      'landscape',
	      'portrait',
	      'print'
	    ]
	  };
	
	  return self;
	}
	
	})();
	(function(){
	"use strict";
	
	  angular
	    .module('material.core')
	    .config( ["$provide", function($provide){
	       $provide.decorator('$mdUtil', ['$delegate', function ($delegate){
	           /**
	            * Inject the iterator facade to easily support iteration and accessors
	            * @see iterator below
	            */
	           $delegate.iterator = MdIterator;
	
	           return $delegate;
	         }
	       ]);
	     }]);
	
	  /**
	   * iterator is a list facade to easily support iteration and accessors
	   *
	   * @param items Array list which this iterator will enumerate
	   * @param reloop Boolean enables iterator to consider the list as an endless reloop
	   */
	  function MdIterator(items, reloop) {
	    var trueFn = function() { return true; };
	
	    if (items && !angular.isArray(items)) {
	      items = Array.prototype.slice.call(items);
	    }
	
	    reloop = !!reloop;
	    var _items = items || [ ];
	
	    // Published API
	    return {
	      items: getItems,
	      count: count,
	
	      inRange: inRange,
	      contains: contains,
	      indexOf: indexOf,
	      itemAt: itemAt,
	
	      findBy: findBy,
	
	      add: add,
	      remove: remove,
	
	      first: first,
	      last: last,
	      next: angular.bind(null, findSubsequentItem, false),
	      previous: angular.bind(null, findSubsequentItem, true),
	
	      hasPrevious: hasPrevious,
	      hasNext: hasNext
	
	    };
	
	    /**
	     * Publish copy of the enumerable set
	     * @returns {Array|*}
	     */
	    function getItems() {
	      return [].concat(_items);
	    }
	
	    /**
	     * Determine length of the list
	     * @returns {Array.length|*|number}
	     */
	    function count() {
	      return _items.length;
	    }
	
	    /**
	     * Is the index specified valid
	     * @param index
	     * @returns {Array.length|*|number|boolean}
	     */
	    function inRange(index) {
	      return _items.length && ( index > -1 ) && (index < _items.length );
	    }
	
	    /**
	     * Can the iterator proceed to the next item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasNext(item) {
	      return item ? inRange(indexOf(item) + 1) : false;
	    }
	
	    /**
	     * Can the iterator proceed to the previous item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasPrevious(item) {
	      return item ? inRange(indexOf(item) - 1) : false;
	    }
	
	    /**
	     * Get item at specified index/position
	     * @param index
	     * @returns {*}
	     */
	    function itemAt(index) {
	      return inRange(index) ? _items[index] : null;
	    }
	
	    /**
	     * Find all elements matching the key/value pair
	     * otherwise return null
	     *
	     * @param val
	     * @param key
	     *
	     * @return array
	     */
	    function findBy(key, val) {
	      return _items.filter(function(item) {
	        return item[key] === val;
	      });
	    }
	
	    /**
	     * Add item to list
	     * @param item
	     * @param index
	     * @returns {*}
	     */
	    function add(item, index) {
	      if ( !item ) return -1;
	
	      if (!angular.isNumber(index)) {
	        index = _items.length;
	      }
	
	      _items.splice(index, 0, item);
	
	      return indexOf(item);
	    }
	
	    /**
	     * Remove item from list...
	     * @param item
	     */
	    function remove(item) {
	      if ( contains(item) ){
	        _items.splice(indexOf(item), 1);
	      }
	    }
	
	    /**
	     * Get the zero-based index of the target item
	     * @param item
	     * @returns {*}
	     */
	    function indexOf(item) {
	      return _items.indexOf(item);
	    }
	
	    /**
	     * Boolean existence check
	     * @param item
	     * @returns {boolean}
	     */
	    function contains(item) {
	      return item && (indexOf(item) > -1);
	    }
	
	    /**
	     * Return first item in the list
	     * @returns {*}
	     */
	    function first() {
	      return _items.length ? _items[0] : null;
	    }
	
	    /**
	     * Return last item in the list...
	     * @returns {*}
	     */
	    function last() {
	      return _items.length ? _items[_items.length - 1] : null;
	    }
	
	    /**
	     * Find the next item. If reloop is true and at the end of the list, it will go back to the
	     * first item. If given, the `validate` callback will be used to determine whether the next item
	     * is valid. If not valid, it will try to find the next item again.
	     *
	     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
	     * @param {*} item The item whose subsequent item we are looking for
	     * @param {Function=} validate The `validate` function
	     * @param {integer=} limit The recursion limit
	     *
	     * @returns {*} The subsequent item or null
	     */
	    function findSubsequentItem(backwards, item, validate, limit) {
	      validate = validate || trueFn;
	
	      var curIndex = indexOf(item);
	      while (true) {
	        if (!inRange(curIndex)) return null;
	
	        var nextIndex = curIndex + (backwards ? -1 : 1);
	        var foundItem = null;
	        if (inRange(nextIndex)) {
	          foundItem = _items[nextIndex];
	        } else if (reloop) {
	          foundItem = backwards ? last() : first();
	          nextIndex = indexOf(foundItem);
	        }
	
	        if ((foundItem === null) || (nextIndex === limit)) return null;
	        if (validate(foundItem)) return foundItem;
	
	        if (angular.isUndefined(limit)) limit = nextIndex;
	
	        curIndex = nextIndex;
	      }
	    }
	  }
	
	
	})();
	(function(){
	"use strict";
	
	
	mdMediaFactory.$inject = ["$mdConstant", "$rootScope", "$window"];angular.module('material.core')
	.factory('$mdMedia', mdMediaFactory);
	
	/**
	 * @ngdoc service
	 * @name $mdMedia
	 * @module material.core
	 *
	 * @description
	 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
	 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
	 * you to register a watch.
	 *
	 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
	 *
	 *  <table class="md-api-table">
	 *    <thead>
	 *    <tr>
	 *      <th>Breakpoint</th>
	 *      <th>mediaQuery</th>
	 *    </tr>
	 *    </thead>
	 *    <tbody>
	 *    <tr>
	 *      <td>xs</td>
	 *      <td>(max-width: 599px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-xs</td>
	 *      <td>(min-width: 600px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>sm</td>
	 *      <td>(min-width: 600px) and (max-width: 959px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-sm</td>
	 *      <td>(min-width: 960px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>md</td>
	 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-md</td>
	 *      <td>(min-width: 1280px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>lg</td>
	 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-lg</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>xl</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>landscape</td>
	 *      <td>landscape</td>
	 *    </tr>
	 *    <tr>
	 *      <td>portrait</td>
	 *      <td>portrait</td>
	 *    </tr>
	 *    <tr>
	 *      <td>print</td>
	 *      <td>print</td>
	 *    </tr>
	 *    </tbody>
	 *  </table>
	 *
	 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
	 *
	 *  <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">
	 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
	 *  </a>
	 *
	 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.controller('MyController', function($mdMedia, $scope) {
	 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
	 *     $scope.bigScreen = big;
	 *   });
	 *
	 *   $scope.screenIsSmall = $mdMedia('sm');
	 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
	 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
	 * });
	 * </hljs>
	 */
	
	/* @ngInject */
	function mdMediaFactory($mdConstant, $rootScope, $window) {
	  var queries = {};
	  var mqls = {};
	  var results = {};
	  var normalizeCache = {};
	
	  $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
	  $mdMedia.getQuery = getQuery;
	  $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;
	
	  return $mdMedia;
	
	  function $mdMedia(query) {
	    var validated = queries[query];
	    if (angular.isUndefined(validated)) {
	      validated = queries[query] = validate(query);
	    }
	
	    var result = results[validated];
	    if (angular.isUndefined(result)) {
	      result = add(validated);
	    }
	
	    return result;
	  }
	
	  function validate(query) {
	    return $mdConstant.MEDIA[query] ||
	           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
	  }
	
	  function add(query) {
	    var result = mqls[query];
	    if ( !result ) {
	      result = mqls[query] = $window.matchMedia(query);
	    }
	
	    result.addListener(onQueryChange);
	    return (results[result.media] = !!result.matches);
	  }
	
	  function onQueryChange(query) {
	    $rootScope.$evalAsync(function() {
	      results[query.media] = !!query.matches;
	    });
	  }
	
	  function getQuery(name) {
	    return mqls[name];
	  }
	
	  function getResponsiveAttribute(attrs, attrName) {
	    for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
	      var mediaName = $mdConstant.MEDIA_PRIORITY[i];
	      if (!mqls[queries[mediaName]].matches) {
	        continue;
	      }
	
	      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	      if (attrs[normalizedName]) {
	        return attrs[normalizedName];
	      }
	    }
	
	    // fallback on unprefixed
	    return attrs[getNormalizedName(attrs, attrName)];
	  }
	
	  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
	    var unwatchFns = [];
	    attrNames.forEach(function(attrName) {
	      var normalizedName = getNormalizedName(attrs, attrName);
	      if (angular.isDefined(attrs[normalizedName])) {
	        unwatchFns.push(
	            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
	      }
	
	      for (var mediaName in $mdConstant.MEDIA) {
	        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	        if (angular.isDefined(attrs[normalizedName])) {
	          unwatchFns.push(
	              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
	        }
	      }
	    });
	
	    return function unwatch() {
	      unwatchFns.forEach(function(fn) { fn(); })
	    };
	  }
	
	  // Improves performance dramatically
	  function getNormalizedName(attrs, attrName) {
	    return normalizeCache[attrName] ||
	        (normalizeCache[attrName] = attrs.$normalize(attrName));
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.core')
	  .config( ["$provide", function($provide) {
	    $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {
	
	      // Inject the prefixer into our original $mdUtil service.
	      $delegate.prefixer = MdPrefixer;
	
	      return $delegate;
	    }]);
	  }]);
	
	function MdPrefixer(initialAttributes, buildSelector) {
	  var PREFIXES = ['data', 'x'];
	
	  if (initialAttributes) {
	    // The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
	    // the specified attributes.
	    return buildSelector ? _buildSelector(initialAttributes) : _buildList(initialAttributes);
	  }
	
	  return {
	    buildList: _buildList,
	    buildSelector: _buildSelector,
	    hasAttribute: _hasAttribute,
	    removeAttribute: _removeAttribute
	  };
	
	  function _buildList(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    attributes.forEach(function(item) {
	      PREFIXES.forEach(function(prefix) {
	        attributes.push(prefix + '-' + item);
	      });
	    });
	
	    return attributes;
	  }
	
	  function _buildSelector(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    return _buildList(attributes)
	      .map(function(item) {
	        return '[' + item + ']'
	      })
	      .join(',');
	  }
	
	  function _hasAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return false;
	    }
	
	    var prefixedAttrs = _buildList(attribute);
	
	    for (var i = 0; i < prefixedAttrs.length; i++) {
	      if (element.hasAttribute(prefixedAttrs[i])) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function _removeAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return;
	    }
	
	    _buildList(attribute).forEach(function(prefixedAttribute) {
	      element.removeAttribute(prefixedAttribute);
	    });
	  }
	
	  /**
	   * Transforms a jqLite or DOM element into a HTML element.
	   * This is useful when supporting jqLite elements and DOM elements at
	   * same time.
	   * @param element {JQLite|Element} Element to be parsed
	   * @returns {HTMLElement} Parsed HTMLElement
	   */
	  function _getNativeElement(element) {
	    element =  element[0] || element;
	
	    if (element.nodeType) {
	      return element;
	    }
	  }
	
	}
	})();
	(function(){
	"use strict";
	
	/*
	 * This var has to be outside the angular factory, otherwise when
	 * there are multiple material apps on the same page, each app
	 * will create its own instance of this array and the app's IDs
	 * will not be unique.
	 */
	UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window", "$$rAF"];
	var nextUniqueId = 0;
	
	/**
	 * @ngdoc module
	 * @name material.core.util
	 * @description
	 * Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdUtil', UtilFactory);
	
	/**
	 * @ngInject
	 */
	function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log, $rootElement, $window, $$rAF) {
	  // Setup some core variables for the processTemplate method
	  var startSymbol = $interpolate.startSymbol(),
	    endSymbol = $interpolate.endSymbol(),
	    usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));
	
	  /**
	   * Checks if the target element has the requested style by key
	   * @param {DOMElement|JQLite} target Target element
	   * @param {string} key Style key
	   * @param {string=} expectedVal Optional expected value
	   * @returns {boolean} Whether the target element has the style or not
	   */
	  var hasComputedStyle = function (target, key, expectedVal) {
	    var hasValue = false;
	
	    if ( target && target.length  ) {
	      var computedStyles = $window.getComputedStyle(target[0]);
	      hasValue = angular.isDefined(computedStyles[key]) && (expectedVal ? computedStyles[key] == expectedVal : true);
	    }
	
	    return hasValue;
	  };
	
	  function validateCssValue(value) {
	    return !value       ? '0'   :
	      hasPx(value) || hasPercent(value) ? value : value + 'px';
	  }
	
	  function hasPx(value) {
	    return String(value).indexOf('px') > -1;
	  }
	
	  function hasPercent(value) {
	    return String(value).indexOf('%') > -1;
	
	  }
	
	  var $mdUtil = {
	    dom: {},
	    now: window.performance ?
	      angular.bind(window.performance, window.performance.now) : Date.now || function() {
	      return new Date().getTime();
	    },
	
	    /**
	     * Bi-directional accessor/mutator used to easily update an element's
	     * property based on the current 'dir'ectional value.
	     */
	    bidi : function(element, property, lValue, rValue) {
	      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');
	
	      // If accessor
	      if ( arguments.length == 0 ) return ltr ? 'ltr' : 'rtl';
	
	      // If mutator
	      var elem = angular.element(element);
	
	      if ( ltr && angular.isDefined(lValue)) {
	        elem.css(property, validateCssValue(lValue));
	      }
	      else if ( !ltr && angular.isDefined(rValue)) {
	        elem.css(property, validateCssValue(rValue) );
	      }
	    },
	
	    bidiProperty: function (element, lProperty, rProperty, value) {
	      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');
	
	      var elem = angular.element(element);
	
	      if ( ltr && angular.isDefined(lProperty)) {
	        elem.css(lProperty, validateCssValue(value));
	        elem.css(rProperty, '');
	      }
	      else if ( !ltr && angular.isDefined(rProperty)) {
	        elem.css(rProperty, validateCssValue(value) );
	        elem.css(lProperty, '');
	      }
	    },
	
	    clientRect: function(element, offsetParent, isOffsetRect) {
	      var node = getNode(element);
	      offsetParent = getNode(offsetParent || node.offsetParent || document.body);
	      var nodeRect = node.getBoundingClientRect();
	
	      // The user can ask for an offsetRect: a rect relative to the offsetParent,
	      // or a clientRect: a rect relative to the page
	      var offsetRect = isOffsetRect ?
	        offsetParent.getBoundingClientRect() :
	      {left: 0, top: 0, width: 0, height: 0};
	      return {
	        left: nodeRect.left - offsetRect.left,
	        top: nodeRect.top - offsetRect.top,
	        width: nodeRect.width,
	        height: nodeRect.height
	      };
	    },
	    offsetRect: function(element, offsetParent) {
	      return $mdUtil.clientRect(element, offsetParent, true);
	    },
	
	    // Annoying method to copy nodes to an array, thanks to IE
	    nodesToArray: function(nodes) {
	      nodes = nodes || [];
	
	      var results = [];
	      for (var i = 0; i < nodes.length; ++i) {
	        results.push(nodes.item(i));
	      }
	      return results;
	    },
	
	    /**
	     * Calculate the positive scroll offset
	     * TODO: Check with pinch-zoom in IE/Chrome;
	     *       https://code.google.com/p/chromium/issues/detail?id=496285
	     */
	    scrollTop: function(element) {
	      element = angular.element(element || $document[0].body);
	
	      var body = (element[0] == $document[0].body) ? $document[0].body : undefined;
	      var scrollTop = body ? body.scrollTop + body.parentElement.scrollTop : 0;
	
	      // Calculate the positive scroll offset
	      return scrollTop || Math.abs(element[0].getBoundingClientRect().top);
	    },
	
	    /**
	     * Finds the proper focus target by searching the DOM.
	     *
	     * @param containerEl
	     * @param attributeVal
	     * @returns {*}
	     */
	    findFocusTarget: function(containerEl, attributeVal) {
	      var AUTO_FOCUS = this.prefixer('md-autofocus', true);
	      var elToFocus;
	
	      elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);
	
	      if ( !elToFocus && attributeVal != AUTO_FOCUS) {
	        // Scan for deprecated attribute
	        elToFocus = scanForFocusable(containerEl, this.prefixer('md-auto-focus', true));
	
	        if ( !elToFocus ) {
	          // Scan for fallback to 'universal' API
	          elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
	        }
	      }
	
	      return elToFocus;
	
	      /**
	       * Can target and nested children for specified Selector (attribute)
	       * whose value may be an expression that evaluates to True/False.
	       */
	      function scanForFocusable(target, selector) {
	        var elFound, items = target[0].querySelectorAll(selector);
	
	        // Find the last child element with the focus attribute
	        if ( items && items.length ){
	          items.length && angular.forEach(items, function(it) {
	            it = angular.element(it);
	
	            // Check the element for the md-autofocus class to ensure any associated expression
	            // evaluated to true.
	            var isFocusable = it.hasClass('md-autofocus');
	            if (isFocusable) elFound = it;
	          });
	        }
	        return elFound;
	      }
	    },
	
	    /**
	     * Disables scroll around the passed parent element.
	     * @param element Unused
	     * @param {!Element|!angular.JQLite} parent Element to disable scrolling within.
	     *   Defaults to body if none supplied.
	     * @param options Object of options to modify functionality
	     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
	     *     use the passed parent element.
	     */
	    disableScrollAround: function(element, parent, options) {
	      $mdUtil.disableScrollAround._count = $mdUtil.disableScrollAround._count || 0;
	      ++$mdUtil.disableScrollAround._count;
	      if ($mdUtil.disableScrollAround._enableScrolling) return $mdUtil.disableScrollAround._enableScrolling;
	      var body = $document[0].body,
	        restoreBody = disableBodyScroll(),
	        restoreElement = disableElementScroll(parent);
	
	      return $mdUtil.disableScrollAround._enableScrolling = function() {
	        if (!--$mdUtil.disableScrollAround._count) {
	          restoreBody();
	          restoreElement();
	          delete $mdUtil.disableScrollAround._enableScrolling;
	        }
	      };
	
	      // Creates a virtual scrolling mask to absorb touchmove, keyboard, scrollbar clicking, and wheel events
	      function disableElementScroll(element) {
	        element = angular.element(element || body);
	        var scrollMask;
	        if (options && options.disableScrollMask) {
	          scrollMask = element;
	        } else {
	          element = element[0];
	          scrollMask = angular.element(
	            '<div class="md-scroll-mask">' +
	            '  <div class="md-scroll-mask-bar"></div>' +
	            '</div>');
	          element.appendChild(scrollMask[0]);
	        }
	
	        scrollMask.on('wheel', preventDefault);
	        scrollMask.on('touchmove', preventDefault);
	
	        return function restoreScroll() {
	          scrollMask.off('wheel');
	          scrollMask.off('touchmove');
	          scrollMask[0].parentNode.removeChild(scrollMask[0]);
	          delete $mdUtil.disableScrollAround._enableScrolling;
	        };
	
	        function preventDefault(e) {
	          e.preventDefault();
	        }
	      }
	
	      // Converts the body to a position fixed block and translate it to the proper scroll position
	      function disableBodyScroll() {
	        var htmlNode = body.parentNode;
	        var restoreHtmlStyle = htmlNode.style.cssText || '';
	        var restoreBodyStyle = body.style.cssText || '';
	        var scrollOffset = $mdUtil.scrollTop(body);
	        var clientWidth = body.clientWidth;
	
	        if (body.scrollHeight > body.clientHeight + 1) {
	          applyStyles(body, {
	            position: 'fixed',
	            width: '100%',
	            top: -scrollOffset + 'px'
	          });
	
	          htmlNode.style.overflowY = 'scroll';
	        }
	
	        if (body.clientWidth < clientWidth) applyStyles(body, {overflow: 'hidden'});
	
	        return function restoreScroll() {
	          body.style.cssText = restoreBodyStyle;
	          htmlNode.style.cssText = restoreHtmlStyle;
	          body.scrollTop = scrollOffset;
	          htmlNode.scrollTop = scrollOffset;
	        };
	      }
	
	      function applyStyles(el, styles) {
	        for (var key in styles) {
	          el.style[key] = styles[key];
	        }
	      }
	    },
	    enableScrolling: function() {
	      var method = this.disableScrollAround._enableScrolling;
	      method && method();
	    },
	    floatingScrollbars: function() {
	      if (this.floatingScrollbars.cached === undefined) {
	        var tempNode = angular.element('<div><div></div></div>').css({
	          width: '100%',
	          'z-index': -1,
	          position: 'absolute',
	          height: '35px',
	          'overflow-y': 'scroll'
	        });
	        tempNode.children().css('height', '60px');
	
	        $document[0].body.appendChild(tempNode[0]);
	        this.floatingScrollbars.cached = (tempNode[0].offsetWidth == tempNode[0].childNodes[0].offsetWidth);
	        tempNode.remove();
	      }
	      return this.floatingScrollbars.cached;
	    },
	
	    // Mobile safari only allows you to set focus in click event listeners...
	    forceFocus: function(element) {
	      var node = element[0] || element;
	
	      document.addEventListener('click', function focusOnClick(ev) {
	        if (ev.target === node && ev.$focus) {
	          node.focus();
	          ev.stopImmediatePropagation();
	          ev.preventDefault();
	          node.removeEventListener('click', focusOnClick);
	        }
	      }, true);
	
	      var newEvent = document.createEvent('MouseEvents');
	      newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
	        false, false, false, false, 0, null);
	      newEvent.$material = true;
	      newEvent.$focus = true;
	      node.dispatchEvent(newEvent);
	    },
	
	    /**
	     * facade to build md-backdrop element with desired styles
	     * NOTE: Use $compile to trigger backdrop postLink function
	     */
	    createBackdrop: function(scope, addClass) {
	      return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
	    },
	
	    /**
	     * supplant() method from Crockford's `Remedial Javascript`
	     * Equivalent to use of $interpolate; without dependency on
	     * interpolation symbols and scope. Note: the '{<token>}' can
	     * be property names, property chains, or array indices.
	     */
	    supplant: function(template, values, pattern) {
	      pattern = pattern || /\{([^\{\}]*)\}/g;
	      return template.replace(pattern, function(a, b) {
	        var p = b.split('.'),
	          r = values;
	        try {
	          for (var s in p) {
	            if (p.hasOwnProperty(s) ) {
	              r = r[p[s]];
	            }
	          }
	        } catch (e) {
	          r = a;
	        }
	        return (typeof r === 'string' || typeof r === 'number') ? r : a;
	      });
	    },
	
	    fakeNgModel: function() {
	      return {
	        $fake: true,
	        $setTouched: angular.noop,
	        $setViewValue: function(value) {
	          this.$viewValue = value;
	          this.$render(value);
	          this.$viewChangeListeners.forEach(function(cb) {
	            cb();
	          });
	        },
	        $isEmpty: function(value) {
	          return ('' + value).length === 0;
	        },
	        $parsers: [],
	        $formatters: [],
	        $viewChangeListeners: [],
	        $render: angular.noop
	      };
	    },
	
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds.
	    // @param wait Integer value of msecs to delay (since last debounce reset); default value 10 msecs
	    // @param invokeApply should the $timeout trigger $digest() dirty checking
	    debounce: function(func, wait, scope, invokeApply) {
	      var timer;
	
	      return function debounced() {
	        var context = scope,
	          args = Array.prototype.slice.call(arguments);
	
	        $timeout.cancel(timer);
	        timer = $timeout(function() {
	
	          timer = undefined;
	          func.apply(context, args);
	
	        }, wait || 10, invokeApply);
	      };
	    },
	
	    // Returns a function that can only be triggered every `delay` milliseconds.
	    // In other words, the function will not be called unless it has been more
	    // than `delay` milliseconds since the last call.
	    throttle: function throttle(func, delay) {
	      var recent;
	      return function throttled() {
	        var context = this;
	        var args = arguments;
	        var now = $mdUtil.now();
	
	        if (!recent || (now - recent > delay)) {
	          func.apply(context, args);
	          recent = now;
	        }
	      };
	    },
	
	    /**
	     * Measures the number of milliseconds taken to run the provided callback
	     * function. Uses a high-precision timer if available.
	     */
	    time: function time(cb) {
	      var start = $mdUtil.now();
	      cb();
	      return $mdUtil.now() - start;
	    },
	
	    /**
	     * Create an implicit getter that caches its `getter()`
	     * lookup value
	     */
	    valueOnUse : function (scope, key, getter) {
	      var value = null, args = Array.prototype.slice.call(arguments);
	      var params = (args.length > 3) ? args.slice(3) : [ ];
	
	      Object.defineProperty(scope, key, {
	        get: function () {
	          if (value === null) value = getter.apply(scope, params);
	          return value;
	        }
	      });
	    },
	
	    /**
	     * Get a unique ID.
	     *
	     * @returns {string} an unique numeric string
	     */
	    nextUid: function() {
	      return '' + nextUniqueId++;
	    },
	
	    // Stop watchers and events from firing on a scope without destroying it,
	    // by disconnecting it from its parent and its siblings' linked lists.
	    disconnectScope: function disconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't destroy the root scope or a scope that has been already destroyed
	      if (scope.$root === scope) return;
	      if (scope.$$destroyed) return;
	
	      var parent = scope.$parent;
	      scope.$$disconnected = true;
	
	      // See Scope.$destroy
	      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
	      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
	      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
	      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;
	
	      scope.$$nextSibling = scope.$$prevSibling = null;
	
	    },
	
	    // Undo the effects of disconnectScope above.
	    reconnectScope: function reconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't disconnect the root node or scope already disconnected
	      if (scope.$root === scope) return;
	      if (!scope.$$disconnected) return;
	
	      var child = scope;
	
	      var parent = child.$parent;
	      child.$$disconnected = false;
	      // See Scope.$new for this logic...
	      child.$$prevSibling = parent.$$childTail;
	      if (parent.$$childHead) {
	        parent.$$childTail.$$nextSibling = child;
	        parent.$$childTail = child;
	      } else {
	        parent.$$childHead = parent.$$childTail = child;
	      }
	    },
	
	    /*
	     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
	     *
	     * @param el Element to start walking the DOM from
	     * @param check Either a string or a function. If a string is passed, it will be evaluated against
	     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each of
	     * the parents and will use the return value to determine whether the node is a match.
	     * @param onlyParent Only start checking from the parent element, not `el`.
	     */
	    getClosest: function getClosest(el, validateWith, onlyParent) {
	      if ( angular.isString(validateWith) ) {
	        var tagName = validateWith.toUpperCase();
	        validateWith = function(el) {
	          return el.nodeName === tagName;
	        };
	      }
	
	      if (el instanceof angular.element) el = el[0];
	      if (onlyParent) el = el.parentNode;
	      if (!el) return null;
	
	      do {
	        if (validateWith(el)) {
	          return el;
	        }
	      } while (el = el.parentNode);
	
	      return null;
	    },
	
	    /**
	     * Build polyfill for the Node.contains feature (if needed)
	     */
	    elementContains: function(node, child) {
	      var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
	      var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function(arg) {
	        // compares the positions of two nodes and returns a bitmask
	        return (node === child) || !!(this.compareDocumentPosition(arg) & 16)
	      });
	
	      return findFn(child);
	    },
	
	    /**
	     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
	     * useful with interimElements where the element and its container are important...
	     *
	     * @param {[]} elements to scan
	     * @param {string} name of node to find (e.g. 'md-dialog')
	     * @param {boolean=} optional flag to allow deep scans; defaults to 'false'.
	     * @param {boolean=} optional flag to enable log warnings; defaults to false
	     */
	    extractElementByName: function(element, nodeName, scanDeep, warnNotFound) {
	      var found = scanTree(element);
	      if (!found && !!warnNotFound) {
	        $log.warn( $mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName, element[0].outerHTML]) );
	      }
	
	      return angular.element(found || element);
	
	      /**
	       * Breadth-First tree scan for element with matching `nodeName`
	       */
	      function scanTree(element) {
	        return scanLevel(element) || (!!scanDeep ? scanChildren(element) : null);
	      }
	
	      /**
	       * Case-insensitive scan of current elements only (do not descend).
	       */
	      function scanLevel(element) {
	        if ( element ) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            if (element[i].nodeName.toLowerCase() === nodeName) {
	              return element[i];
	            }
	          }
	        }
	        return null;
	      }
	
	      /**
	       * Scan children of specified node
	       */
	      function scanChildren(element) {
	        var found;
	        if ( element ) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            var target = element[i];
	            if ( !found ) {
	              for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
	                found = found || scanTree([target.childNodes[j]]);
	              }
	            }
	          }
	        }
	        return found;
	      }
	
	    },
	
	    /**
	     * Give optional properties with no value a boolean true if attr provided or false otherwise
	     */
	    initOptionalProperties: function(scope, attr, defaults) {
	      defaults = defaults || {};
	      angular.forEach(scope.$$isolateBindings, function(binding, key) {
	        if (binding.optional && angular.isUndefined(scope[key])) {
	          var attrIsDefined = angular.isDefined(attr[binding.attrName]);
	          scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
	        }
	      });
	    },
	
	    /**
	     * Alternative to $timeout calls with 0 delay.
	     * nextTick() coalesces all calls within a single frame
	     * to minimize $digest thrashing
	     *
	     * @param callback
	     * @param digest
	     * @returns {*}
	     */
	    nextTick: function(callback, digest, scope) {
	      //-- grab function reference for storing state details
	      var nextTick = $mdUtil.nextTick;
	      var timeout = nextTick.timeout;
	      var queue = nextTick.queue || [];
	
	      //-- add callback to the queue
	      queue.push({scope: scope, callback: callback});
	
	      //-- set default value for digest
	      if (digest == null) digest = true;
	
	      //-- store updated digest/queue values
	      nextTick.digest = nextTick.digest || digest;
	      nextTick.queue = queue;
	
	      //-- either return existing timeout or create a new one
	      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));
	
	      /**
	       * Grab a copy of the current queue
	       * Clear the queue for future use
	       * Process the existing queue
	       * Trigger digest if necessary
	       */
	      function processQueue() {
	        var queue = nextTick.queue;
	        var digest = nextTick.digest;
	
	        nextTick.queue = [];
	        nextTick.timeout = null;
	        nextTick.digest = false;
	
	        queue.forEach(function(queueItem) {
	          var skip = queueItem.scope && queueItem.scope.$$destroyed;
	          if (!skip) {
	            queueItem.callback();
	          }
	        });
	
	        if (digest) $rootScope.$digest();
	      }
	    },
	
	    /**
	     * Processes a template and replaces the start/end symbols if the application has
	     * overriden them.
	     *
	     * @param template The template to process whose start/end tags may be replaced.
	     * @returns {*}
	     */
	    processTemplate: function(template) {
	      if (usesStandardSymbols) {
	        return template;
	      } else {
	        if (!template || !angular.isString(template)) return template;
	        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	      }
	    },
	
	    /**
	     * Scan up dom hierarchy for enabled parent;
	     */
	    getParentWithPointerEvents: function (element) {
	      var parent = element.parent();
	
	      // jqLite might return a non-null, but still empty, parent; so check for parent and length
	      while (hasComputedStyle(parent, 'pointer-events', 'none')) {
	        parent = parent.parent();
	      }
	
	      return parent;
	    },
	
	    getNearestContentElement: function (element) {
	      var current = element.parent()[0];
	      // Look for the nearest parent md-content, stopping at the rootElement.
	      while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
	        current = current.parentNode;
	      }
	      return current;
	    },
	
	    /**
	     * Checks if the current browser is natively supporting the `sticky` position.
	     * @returns {string} supported sticky property name
	     */
	    checkStickySupport: function() {
	      var stickyProp;
	      var testEl = angular.element('<div>');
	      $document[0].body.appendChild(testEl[0]);
	
	      var stickyProps = ['sticky', '-webkit-sticky'];
	      for (var i = 0; i < stickyProps.length; ++i) {
	        testEl.css({
	          position: stickyProps[i],
	          top: 0,
	          'z-index': 2
	        });
	
	        if (testEl.css('position') == stickyProps[i]) {
	          stickyProp = stickyProps[i];
	          break;
	        }
	      }
	
	      testEl.remove();
	
	      return stickyProp;
	    },
	
	    /**
	     * Parses an attribute value, mostly a string.
	     * By default checks for negated values and returns `false´ if present.
	     * Negated values are: (native falsy) and negative strings like:
	     * `false` or `0`.
	     * @param value Attribute value which should be parsed.
	     * @param negatedCheck When set to false, won't check for negated values.
	     * @returns {boolean}
	     */
	    parseAttributeBoolean: function(value, negatedCheck) {
	      return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
	    },
	
	    hasComputedStyle: hasComputedStyle,
	
	    /**
	     * Returns true if the parent form of the element has been submitted.
	     *
	     * @param element An Angular or HTML5 element.
	     *
	     * @returns {boolean}
	     */
	    isParentFormSubmitted: function(element) {
	      var parent = $mdUtil.getClosest(element, 'form');
	      var form = parent ? angular.element(parent).controller('form') : null;
	
	      return form ? form.$submitted : false;
	    },
	
	    /**
	     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
	     *
	     * @param element The element to scroll.
	     * @param scrollEnd The new/final scroll position.
	     */
	    animateScrollTo: function(element, scrollEnd) {
	      var scrollStart = element.scrollTop;
	      var scrollChange = scrollEnd - scrollStart;
	      var scrollingDown = scrollStart < scrollEnd;
	      var startTime = $mdUtil.now();
	
	      $$rAF(scrollChunk);
	
	      function scrollChunk() {
	        var newPosition = calculateNewPosition();
	        
	        element.scrollTop = newPosition;
	        
	        if (scrollingDown ? newPosition < scrollEnd : newPosition > scrollEnd) {
	          $$rAF(scrollChunk);
	        }
	      }
	      
	      function calculateNewPosition() {
	        var duration = 1000;
	        var currentTime = $mdUtil.now() - startTime;
	        
	        return ease(currentTime, scrollStart, scrollChange, duration);
	      }
	
	      function ease(currentTime, start, change, duration) {
	        // If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
	        // straight to the proper position
	        if (currentTime > duration) {
	          return start + change;
	        }
	        
	        var ts = (currentTime /= duration) * currentTime;
	        var tc = ts * currentTime;
	
	        return start + change * (-2 * tc + 3 * ts);
	      }
	    }
	  };
	
	
	// Instantiate other namespace utility methods
	
	  $mdUtil.dom.animator = $$mdAnimate($mdUtil);
	
	  return $mdUtil;
	
	  function getNode(el) {
	    return el[0] || el;
	  }
	
	}
	
	/*
	 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
	 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
	 */
	
	angular.element.prototype.focus = angular.element.prototype.focus || function() {
	    if (this.length) {
	      this[0].focus();
	    }
	    return this;
	  };
	angular.element.prototype.blur = angular.element.prototype.blur || function() {
	    if (this.length) {
	      this[0].blur();
	    }
	    return this;
	  };
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.aria
	 * @description
	 * Aria Expectations for ngMaterial components.
	 */
	MdAriaService.$inject = ["$$rAF", "$log", "$window", "$interpolate"];
	angular
	  .module('material.core')
	  .provider('$mdAria', MdAriaProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdAriaProvider
	 * @module material.core.aria
	 *
	 * @description
	 *
	 * Modify options of the `$mdAria` service, which will be used by most of the Angular Material
	 * components.
	 *
	 * You are able to disable `$mdAria` warnings, by using the following markup.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdAriaProvider) {
	 *     // Globally disables all ARIA warnings.
	 *     $mdAriaProvider.disableWarnings();
	 *   });
	 * </hljs>
	 *
	 */
	function MdAriaProvider() {
	
	  var self = this;
	
	  /**
	   * Whether we should show ARIA warnings in the console, if labels are missing on the element
	   * By default the warnings are enabled
	   */
	  self.showWarnings = true;
	
	  return {
	    disableWarnings: disableWarnings,
	    $get: ["$$rAF", "$log", "$window", "$interpolate", function($$rAF, $log, $window, $interpolate) {
	      return MdAriaService.apply(self, arguments);
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdAriaProvider#disableWarnings
	   * @description Disables all ARIA warnings generated by Angular Material.
	   */
	  function disableWarnings() {
	    self.showWarnings = false;
	  }
	}
	
	/*
	 * @ngInject
	 */
	function MdAriaService($$rAF, $log, $window, $interpolate) {
	
	  // Load the showWarnings option from the current context and store it inside of a scope variable,
	  // because the context will be probably lost in some function calls.
	  var showWarnings = this.showWarnings;
	
	  return {
	    expect: expect,
	    expectAsync: expectAsync,
	    expectWithText: expectWithText,
	    expectWithoutText: expectWithoutText
	  };
	
	  /**
	   * Check if expected attribute has been specified on the target element or child
	   * @param element
	   * @param attrName
	   * @param {optional} defaultValue What to set the attr to if no value is found
	   */
	  function expect(element, attrName, defaultValue) {
	
	    var node = angular.element(element)[0] || element;
	
	    // if node exists and neither it nor its children have the attribute
	    if (node &&
	       ((!node.hasAttribute(attrName) ||
	        node.getAttribute(attrName).length === 0) &&
	        !childHasAttribute(node, attrName))) {
	
	      defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
	      if (defaultValue.length) {
	        element.attr(attrName, defaultValue);
	      } else if (showWarnings) {
	        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
	      }
	
	    }
	  }
	
	  function expectAsync(element, attrName, defaultValueGetter) {
	    // Problem: when retrieving the element's contents synchronously to find the label,
	    // the text may not be defined yet in the case of a binding.
	    // There is a higher chance that a binding will be defined if we wait one frame.
	    $$rAF(function() {
	        expect(element, attrName, defaultValueGetter());
	    });
	  }
	
	  function expectWithText(element, attrName) {
	    var content = getText(element) || "";
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if ( hasBinding ) {
	      expectAsync(element, attrName, function() {
	        return getText(element);
	      });
	    } else {
	      expect(element, attrName, content);
	    }
	  }
	
	  function expectWithoutText(element, attrName) {
	    var content = getText(element);
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if ( !hasBinding && !content) {
	      expect(element, attrName, content);
	    }
	  }
	
	  function getText(element) {
	    element = element[0] || element;
	    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
	    var text = '';
	
	    var node;
	    while (node = walker.nextNode()) {
	      if (!isAriaHiddenNode(node)) {
	        text += node.textContent;
	      }
	    }
	
	    return text.trim() || '';
	
	    function isAriaHiddenNode(node) {
	      while (node.parentNode && (node = node.parentNode) !== element) {
	        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	          return true;
	        }
	      }
	    }
	  }
	
	  function childHasAttribute(node, attrName) {
	    var hasChildren = node.hasChildNodes(),
	        hasAttr = false;
	
	    function isHidden(el) {
	      var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
	      return (style.display === 'none');
	    }
	
	    if (hasChildren) {
	      var children = node.childNodes;
	      for (var i=0; i < children.length; i++) {
	        var child = children[i];
	        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
	          if (!isHidden(child)) {
	            hasAttr = true;
	          }
	        }
	      }
	    }
	
	    return hasAttr;
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	mdCompilerService.$inject = ["$q", "$templateRequest", "$injector", "$compile", "$controller"];angular
	  .module('material.core')
	  .service('$mdCompiler', mdCompilerService);
	
	function mdCompilerService($q, $templateRequest, $injector, $compile, $controller) {
	  /* jshint validthis: true */
	
	  /*
	   * @ngdoc service
	   * @name $mdCompiler
	   * @module material.core
	   * @description
	   * The $mdCompiler service is an abstraction of angular's compiler, that allows the developer
	   * to easily compile an element with a templateUrl, controller, and locals.
	   *
	   * @usage
	   * <hljs lang="js">
	   * $mdCompiler.compile({
	   *   templateUrl: 'modal.html',
	   *   controller: 'ModalCtrl',
	   *   locals: {
	   *     modal: myModalInstance;
	   *   }
	   * }).then(function(compileData) {
	   *   compileData.element; // modal.html's template in an element
	   *   compileData.link(myScope); //attach controller & scope to element
	   * });
	   * </hljs>
	   */
	
	   /*
	    * @ngdoc method
	    * @name $mdCompiler#compile
	    * @description A helper to compile an HTML template/templateUrl with a given controller,
	    * locals, and scope.
	    * @param {object} options An options object, with the following properties:
	    *
	    *    - `controller` - `{(string=|function()=}` Controller fn that should be associated with
	    *      newly created scope or the name of a registered controller if passed as a string.
	    *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
	    *      published to scope under the `controllerAs` name.
	    *    - `template` - `{string=}` An html template as a string.
	    *    - `templateUrl` - `{string=}` A path to an html template.
	    *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
	    *      it is loaded. It will be given the template string as a parameter, and should
	    *      return a a new string representing the transformed template.
	    *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
	    *      be injected into the controller. If any of these dependencies are promises, the compiler
	    *      will wait for them all to be resolved, or if one is rejected before the controller is
	    *      instantiated `compile()` will fail..
	    *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
	    *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
	    *        Otherwise if function, then it is injected and the return value is treated as the
	    *        dependency. If the result is a promise, it is resolved before its value is
	    *        injected into the controller.
	    *
	    * @returns {object=} promise A promise, which will be resolved with a `compileData` object.
	    * `compileData` has the following properties:
	    *
	    *   - `element` - `{element}`: an uncompiled element matching the provided template.
	    *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
	    *     the element and instantiate the provided controller (if given).
	    *   - `locals` - `{object}`: The locals which will be passed into the controller once `link` is
	    *     called. If `bindToController` is true, they will be coppied to the ctrl instead
	    *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	    */
	  this.compile = function(options) {
	    var templateUrl = options.templateUrl;
	    var template = options.template || '';
	    var controller = options.controller;
	    var controllerAs = options.controllerAs;
	    var resolve = angular.extend({}, options.resolve || {});
	    var locals = angular.extend({}, options.locals || {});
	    var transformTemplate = options.transformTemplate || angular.identity;
	    var bindToController = options.bindToController;
	
	    // Take resolve values and invoke them.
	    // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
	    // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
	    angular.forEach(resolve, function(value, key) {
	      if (angular.isString(value)) {
	        resolve[key] = $injector.get(value);
	      } else {
	        resolve[key] = $injector.invoke(value);
	      }
	    });
	    //Add the locals, which are just straight values to inject
	    //eg locals: { three: 3 }, will inject three into the controller
	    angular.extend(resolve, locals);
	
	    if (templateUrl) {
	      resolve.$template = $templateRequest(templateUrl)
	        .then(function(response) {
	          return response;
	        });
	    } else {
	      resolve.$template = $q.when(template);
	    }
	
	    // Wait for all the resolves to finish if they are promises
	    return $q.all(resolve).then(function(locals) {
	
	      var compiledData;
	      var template = transformTemplate(locals.$template, options);
	      var element = options.element || angular.element('<div>').html(template.trim()).contents();
	      var linkFn = $compile(element);
	
	      // Return a linking function that can be used later when the element is ready
	      return compiledData = {
	        locals: locals,
	        element: element,
	        link: function link(scope) {
	          locals.$scope = scope;
	
	          //Instantiate controller if it exists, because we have scope
	          if (controller) {
	            var invokeCtrl = $controller(controller, locals, true, controllerAs);
	            if (bindToController) {
	              angular.extend(invokeCtrl.instance, locals);
	            }
	            var ctrl = invokeCtrl();
	            //See angular-route source for this logic
	            element.data('$ngControllerController', ctrl);
	            element.children().data('$ngControllerController', ctrl);
	
	            // Publish reference to this controller
	            compiledData.controller = ctrl;
	          }
	          return linkFn(scope);
	        }
	      };
	    });
	
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdGesture.$inject = ["$$MdGestureHandler", "$$rAF", "$timeout"];
	attachToDocument.$inject = ["$mdGesture", "$$MdGestureHandler"];var HANDLERS = {};
	
	/* The state of the current 'pointer'
	 * The pointer represents the state of the current touch.
	 * It contains normalized x and y coordinates from DOM events,
	 * as well as other information abstracted from the DOM.
	 */
	
	var pointer, lastPointer, forceSkipClickHijack = false;
	
	/**
	 * The position of the most recent click if that click was on a label element.
	 * @type {{x: number, y: number}?}
	 */
	var lastLabelClickPos = null;
	
	// Used to attach event listeners once when multiple ng-apps are running.
	var isInitialized = false;
	
	angular
	  .module('material.core.gestures', [ ])
	  .provider('$mdGesture', MdGestureProvider)
	  .factory('$$MdGestureHandler', MdGestureHandler)
	  .run( attachToDocument );
	
	/**
	   * @ngdoc service
	   * @name $mdGestureProvider
	   * @module material.core.gestures
	   *
	   * @description
	   * In some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked.
	   * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking on mobile
	   * devices.
	   *
	   * <hljs lang="js">
	   *   app.config(function($mdGestureProvider) {
	   *
	   *     // For mobile devices without jQuery loaded, do not
	   *     // intercept click events during the capture phase.
	   *     $mdGestureProvider.skipClickHijack();
	   *
	   *   });
	   * </hljs>
	   *
	   */
	function MdGestureProvider() { }
	
	MdGestureProvider.prototype = {
	
	  // Publish access to setter to configure a variable  BEFORE the
	  // $mdGesture service is instantiated...
	  skipClickHijack: function() {
	    return forceSkipClickHijack = true;
	  },
	
	  /**
	   * $get is used to build an instance of $mdGesture
	   * @ngInject
	   */
	  $get : ["$$MdGestureHandler", "$$rAF", "$timeout", function($$MdGestureHandler, $$rAF, $timeout) {
	       return new MdGesture($$MdGestureHandler, $$rAF, $timeout);
	  }]
	};
	
	
	
	/**
	 * MdGesture factory construction function
	 * @ngInject
	 */
	function MdGesture($$MdGestureHandler, $$rAF, $timeout) {
	  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	  var isIos = userAgent.match(/ipad|iphone|ipod/i);
	  var isAndroid = userAgent.match(/android/i);
	  var touchActionProperty = getTouchAction();
	  var hasJQuery =  (typeof __webpack_provided_window_dot_jQuery !== 'undefined') && (angular.element === __webpack_provided_window_dot_jQuery);
	
	  var self = {
	    handler: addHandler,
	    register: register,
	    isIos: isIos,
	    isAndroid: isAndroid,
	    // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
	    isHijackingClicks: (isIos || isAndroid) && !hasJQuery && !forceSkipClickHijack
	  };
	
	  if (self.isHijackingClicks) {
	    var maxClickDistance = 6;
	    self.handler('click', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('click')
	    });
	
	    self.handler('focus', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: function(ev, pointer) {
	        if (pointer.distance < this.state.options.maxDistance) {
	          if (canFocus(ev.target)) {
	            this.dispatchEvent(ev, 'focus', pointer);
	            ev.target.focus();
	          }
	        }
	
	        function canFocus(element) {
	          var focusableElements = ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'];
	
	          return (element.getAttribute('tabindex') != '-1') &&
	              !element.hasAttribute('DISABLED') &&
	              (element.hasAttribute('tabindex') || element.hasAttribute('href') || element.isContentEditable ||
	              (focusableElements.indexOf(element.nodeName) != -1));
	        }
	      }
	    });
	
	    self.handler('mouseup', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('mouseup')
	    });
	
	    self.handler('mousedown', {
	      onStart: function(ev) {
	        this.dispatchEvent(ev, 'mousedown');
	      }
	    });
	  }
	
	  function checkDistanceAndEmit(eventName) {
	    return function(ev, pointer) {
	      if (pointer.distance < this.state.options.maxDistance) {
	        this.dispatchEvent(ev, eventName, pointer);
	      }
	    };
	  }
	
	  /*
	   * Register an element to listen for a handler.
	   * This allows an element to override the default options for a handler.
	   * Additionally, some handlers like drag and hold only dispatch events if
	   * the domEvent happens inside an element that's registered to listen for these events.
	   *
	   * @see GestureHandler for how overriding of default options works.
	   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horziontal: false })
	   */
	  function register(element, handlerName, options) {
	    var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
	    if (!handler) {
	      throw new Error('Failed to register element with handler ' + handlerName + '. ' +
	      'Available handlers: ' + Object.keys(HANDLERS).join(', '));
	    }
	    return handler.registerElement(element, options);
	  }
	
	  /*
	   * add a handler to $mdGesture. see below.
	   */
	  function addHandler(name, definition) {
	    var handler = new $$MdGestureHandler(name);
	    angular.extend(handler, definition);
	    HANDLERS[name] = handler;
	
	    return self;
	  }
	
	  /*
	   * Register handlers. These listen to touch/start/move events, interpret them,
	   * and dispatch gesture events depending on options & conditions. These are all
	   * instances of GestureHandler.
	   * @see GestureHandler
	   */
	  return self
	    /*
	     * The press handler dispatches an event on touchdown/touchend.
	     * It's a simple abstraction of touch/mouse/pointer start and end.
	     */
	    .handler('press', {
	      onStart: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressdown');
	      },
	      onEnd: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressup');
	      }
	    })
	
	    /*
	     * The hold handler dispatches an event if the user keeps their finger within
	     * the same <maxDistance> area for <delay> ms.
	     * The hold handler will only run if a parent of the touch target is registered
	     * to listen for hold events through $mdGesture.register()
	     */
	    .handler('hold', {
	      options: {
	        maxDistance: 6,
	        delay: 500
	      },
	      onCancel: function () {
	        $timeout.cancel(this.state.timeout);
	      },
	      onStart: function (ev, pointer) {
	        // For hold, require a parent to be registered with $mdGesture.register()
	        // Because we prevent scroll events, this is necessary.
	        if (!this.state.registeredParent) return this.cancel();
	
	        this.state.pos = {x: pointer.x, y: pointer.y};
	        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
	          this.dispatchEvent(ev, '$md.hold');
	          this.cancel(); //we're done!
	        }), this.state.options.delay, false);
	      },
	      onMove: function (ev, pointer) {
	        // Don't scroll while waiting for hold.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        // If the user moves greater than <maxDistance> pixels, stop the hold timer
	        // set in onStart
	        var dx = this.state.pos.x - pointer.x;
	        var dy = this.state.pos.y - pointer.y;
	        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
	          this.cancel();
	        }
	      },
	      onEnd: function () {
	        this.onCancel();
	      }
	    })
	
	    /*
	     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
	     * <minDistance> px in the x or y direction, depending on options.horizontal.
	     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
	     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
	     * pixels vertically, this handler won't consider the move part of a drag.
	     */
	    .handler('drag', {
	      options: {
	        minDistance: 6,
	        horizontal: true,
	        cancelMultiplier: 1.5
	      },
	      onSetup: function(element, options) {
	        if (touchActionProperty) {
	          // We check for horizontal to be false, because otherwise we would overwrite the default opts.
	          this.oldTouchAction = element[0].style[touchActionProperty];
	          element[0].style[touchActionProperty] = options.horizontal === false ? 'pan-y' : 'pan-x';
	        }
	      },
	      onCleanup: function(element) {
	        if (this.oldTouchAction) {
	          element[0].style[touchActionProperty] = this.oldTouchAction;
	        }
	      },
	      onStart: function (ev) {
	        // For drag, require a parent to be registered with $mdGesture.register()
	        if (!this.state.registeredParent) this.cancel();
	      },
	      onMove: function (ev, pointer) {
	        var shouldStartDrag, shouldCancel;
	        // Don't scroll while deciding if this touchmove qualifies as a drag event.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        if (!this.state.dragPointer) {
	          if (this.state.options.horizontal) {
	            shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          } else {
	            shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          }
	
	          if (shouldStartDrag) {
	            // Create a new pointer representing this drag, starting at this point where the drag started.
	            this.state.dragPointer = makeStartPointer(ev);
	            updatePointerState(ev, this.state.dragPointer);
	            this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);
	
	          } else if (shouldCancel) {
	            this.cancel();
	          }
	        } else {
	          this.dispatchDragMove(ev);
	        }
	      },
	      // Only dispatch dragmove events every frame; any more is unnecessary
	      dispatchDragMove: $$rAF.throttle(function (ev) {
	        // Make sure the drag didn't stop while waiting for the next frame
	        if (this.state.isRunning) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
	        }
	      }),
	      onEnd: function (ev, pointer) {
	        if (this.state.dragPointer) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
	        }
	      }
	    })
	
	    /*
	     * The swipe handler will dispatch a swipe event if, on the end of a touch,
	     * the velocity and distance were high enough.
	     */
	    .handler('swipe', {
	      options: {
	        minVelocity: 0.65,
	        minDistance: 10
	      },
	      onEnd: function (ev, pointer) {
	        var eventType;
	
	        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceX) > this.state.options.minDistance) {
	          eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
	          this.dispatchEvent(ev, eventType);
	        }
	        else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceY) > this.state.options.minDistance) {
	          eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
	          this.dispatchEvent(ev, eventType);
	        }
	      }
	    });
	
	  function getTouchAction() {
	    var testEl = document.createElement('div');
	    var vendorPrefixes = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	
	    for (var i = 0; i < vendorPrefixes.length; i++) {
	      var prefix = vendorPrefixes[i];
	      var property = prefix ? prefix + 'TouchAction' : 'touchAction';
	      if (angular.isDefined(testEl.style[property])) {
	        return property;
	      }
	    }
	  }
	
	}
	
	/**
	 * MdGestureHandler
	 * A GestureHandler is an object which is able to dispatch custom dom events
	 * based on native dom {touch,pointer,mouse}{start,move,end} events.
	 *
	 * A gesture will manage its lifecycle through the start,move,end, and cancel
	 * functions, which are called by native dom events.
	 *
	 * A gesture has the concept of 'options' (eg a swipe's required velocity), which can be
	 * overridden by elements registering through $mdGesture.register()
	 */
	function GestureHandler (name) {
	  this.name = name;
	  this.state = {};
	}
	
	function MdGestureHandler() {
	  var hasJQuery =  (typeof __webpack_provided_window_dot_jQuery !== 'undefined') && (angular.element === __webpack_provided_window_dot_jQuery);
	
	  GestureHandler.prototype = {
	    options: {},
	    // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
	    // differently when jQuery is loaded
	    dispatchEvent: hasJQuery ?  jQueryDispatchEvent : nativeDispatchEvent,
	
	    // These are overridden by the registered handler
	    onSetup: angular.noop,
	    onCleanup: angular.noop,
	    onStart: angular.noop,
	    onMove: angular.noop,
	    onEnd: angular.noop,
	    onCancel: angular.noop,
	
	    // onStart sets up a new state for the handler, which includes options from the
	    // nearest registered parent element of ev.target.
	    start: function (ev, pointer) {
	      if (this.state.isRunning) return;
	      var parentTarget = this.getNearestParent(ev.target);
	      // Get the options from the nearest registered parent
	      var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};
	
	      this.state = {
	        isRunning: true,
	        // Override the default options with the nearest registered parent's options
	        options: angular.extend({}, this.options, parentTargetOptions),
	        // Pass in the registered parent node to the state so the onStart listener can use
	        registeredParent: parentTarget
	      };
	      this.onStart(ev, pointer);
	    },
	    move: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onMove(ev, pointer);
	    },
	    end: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onEnd(ev, pointer);
	      this.state.isRunning = false;
	    },
	    cancel: function (ev, pointer) {
	      this.onCancel(ev, pointer);
	      this.state = {};
	    },
	
	    // Find and return the nearest parent element that has been registered to
	    // listen for this handler via $mdGesture.register(element, 'handlerName').
	    getNearestParent: function (node) {
	      var current = node;
	      while (current) {
	        if ((current.$mdGesture || {})[this.name]) {
	          return current;
	        }
	        current = current.parentNode;
	      }
	      return null;
	    },
	
	    // Called from $mdGesture.register when an element registers itself with a handler.
	    // Store the options the user gave on the DOMElement itself. These options will
	    // be retrieved with getNearestParent when the handler starts.
	    registerElement: function (element, options) {
	      var self = this;
	      element[0].$mdGesture = element[0].$mdGesture || {};
	      element[0].$mdGesture[this.name] = options || {};
	      element.on('$destroy', onDestroy);
	
	      self.onSetup(element, options || {});
	
	      return onDestroy;
	
	      function onDestroy() {
	        delete element[0].$mdGesture[self.name];
	        element.off('$destroy', onDestroy);
	
	        self.onCleanup(element, options || {});
	      }
	    }
	  };
	
	  return GestureHandler;
	
	  /*
	   * Dispatch an event with jQuery
	   * TODO: Make sure this sends bubbling events
	   *
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj = new angular.element.Event(eventType);
	
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	
	    angular.extend(eventObj, {
	      clientX: eventPointer.x,
	      clientY: eventPointer.y,
	      screenX: eventPointer.x,
	      screenY: eventPointer.y,
	      pageX: eventPointer.x,
	      pageY: eventPointer.y,
	      ctrlKey: srcEvent.ctrlKey,
	      altKey: srcEvent.altKey,
	      shiftKey: srcEvent.shiftKey,
	      metaKey: srcEvent.metaKey
	    });
	    angular.element(eventPointer.target).trigger(eventObj);
	  }
	
	  /*
	   * NOTE: nativeDispatchEvent is very performance sensitive.
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj;
	
	    if (eventType === 'click' || eventType == 'mouseup' || eventType == 'mousedown' ) {
	      eventObj = document.createEvent('MouseEvents');
	      eventObj.initMouseEvent(
	        eventType, true, true, window, srcEvent.detail,
	        eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
	        srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
	        srcEvent.button, srcEvent.relatedTarget || null
	      );
	
	    } else {
	      eventObj = document.createEvent('CustomEvent');
	      eventObj.initCustomEvent(eventType, true, true, {});
	    }
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	    eventPointer.target.dispatchEvent(eventObj);
	  }
	
	}
	
	/**
	 * Attach Gestures: hook document and check shouldHijack clicks
	 * @ngInject
	 */
	function attachToDocument( $mdGesture, $$MdGestureHandler ) {
	
	  // Polyfill document.contains for IE11.
	  // TODO: move to util
	  document.contains || (document.contains = function (node) {
	    return document.body.contains(node);
	  });
	
	  if (!isInitialized && $mdGesture.isHijackingClicks ) {
	    /*
	     * If hijack clicks is true, we preventDefault any click that wasn't
	     * sent by ngMaterial. This is because on older Android & iOS, a false, or 'ghost',
	     * click event will be sent ~400ms after a touchend event happens.
	     * The only way to know if this click is real is to prevent any normal
	     * click events, and add a flag to events sent by material so we know not to prevent those.
	     *
	     * Two exceptions to click events that should be prevented are:
	     *  - click events sent by the keyboard (eg form submit)
	     *  - events that originate from an Ionic app
	     */
	    document.addEventListener('click'    , clickHijacker     , true);
	    document.addEventListener('mouseup'  , mouseInputHijacker, true);
	    document.addEventListener('mousedown', mouseInputHijacker, true);
	    document.addEventListener('focus'    , mouseInputHijacker, true);
	
	    isInitialized = true;
	  }
	
	  function mouseInputHijacker(ev) {
	    var isKeyClick = !ev.clientX && !ev.clientY;
	    if (!isKeyClick && !ev.$material && !ev.isIonicTap
	      && !isInputEventFromLabelClick(ev)) {
	      ev.preventDefault();
	      ev.stopPropagation();
	    }
	  }
	
	  function clickHijacker(ev) {
	    var isKeyClick = ev.clientX === 0 && ev.clientY === 0;
	    if (!isKeyClick && !ev.$material && !ev.isIonicTap
	      && !isInputEventFromLabelClick(ev)) {
	      ev.preventDefault();
	      ev.stopPropagation();
	      lastLabelClickPos = null;
	    } else {
	      lastLabelClickPos = null;
	      if (ev.target.tagName.toLowerCase() == 'label') {
	        lastLabelClickPos = {x: ev.x, y: ev.y};
	      }
	    }
	  }
	
	
	  // Listen to all events to cover all platforms.
	  var START_EVENTS = 'mousedown touchstart pointerdown';
	  var MOVE_EVENTS = 'mousemove touchmove pointermove';
	  var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';
	
	  angular.element(document)
	    .on(START_EVENTS, gestureStart)
	    .on(MOVE_EVENTS, gestureMove)
	    .on(END_EVENTS, gestureEnd)
	    // For testing
	    .on('$$mdGestureReset', function gestureClearCache () {
	      lastPointer = pointer = null;
	    });
	
	  /*
	   * When a DOM event happens, run all registered gesture handlers' lifecycle
	   * methods which match the DOM event.
	   * Eg when a 'touchstart' event happens, runHandlers('start') will call and
	   * run `handler.cancel()` and `handler.start()` on all registered handlers.
	   */
	  function runHandlers(handlerEvent, event) {
	    var handler;
	    for (var name in HANDLERS) {
	      handler = HANDLERS[name];
	      if( handler instanceof $$MdGestureHandler ) {
	
	        if (handlerEvent === 'start') {
	          // Run cancel to reset any handlers' state
	          handler.cancel();
	        }
	        handler[handlerEvent](event, pointer);
	
	      }
	    }
	  }
	
	  /*
	   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
	   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
	   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
	   * won't effect it.
	   */
	  function gestureStart(ev) {
	    // If we're already touched down, abort
	    if (pointer) return;
	
	    var now = +Date.now();
	
	    // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
	    // If <400ms have passed, don't allow an event of a different type than the previous event
	    if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
	      return;
	    }
	
	    pointer = makeStartPointer(ev);
	
	    runHandlers('start', ev);
	  }
	  /*
	   * If a move event happens of the right type, update the pointer and run all the move handlers.
	   * "of the right type": if a mousemove happens but our pointer started with a touch event, do nothing.
	   */
	  function gestureMove(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    runHandlers('move', ev);
	  }
	  /*
	   * If an end event happens of the right type, update the pointer, run endHandlers, and save the pointer as 'lastPointer'
	   */
	  function gestureEnd(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    pointer.endTime = +Date.now();
	
	    runHandlers('end', ev);
	
	    lastPointer = pointer;
	    pointer = null;
	  }
	
	}
	
	// ********************
	// Module Functions
	// ********************
	
	/*
	 * Initiate the pointer. x, y, and the pointer's type.
	 */
	function makeStartPointer(ev) {
	  var point = getEventPoint(ev);
	  var startPointer = {
	    startTime: +Date.now(),
	    target: ev.target,
	    // 'p' for pointer events, 'm' for mouse, 't' for touch
	    type: ev.type.charAt(0)
	  };
	  startPointer.startX = startPointer.x = point.pageX;
	  startPointer.startY = startPointer.y = point.pageY;
	  return startPointer;
	}
	
	/*
	 * return whether the pointer's type matches the event's type.
	 * Eg if a touch event happens but the pointer has a mouse type, return false.
	 */
	function typesMatch(ev, pointer) {
	  return ev && pointer && ev.type.charAt(0) === pointer.type;
	}
	
	/**
	 * Gets whether the given event is an input event that was caused by clicking on an
	 * associated label element.
	 *
	 * This is necessary because the browser will, upon clicking on a label element, fire an
	 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
	 * click as with `$material` correctly, but not the second input click.
	 *
	 * In order to determine whether an input event is from a label click, we compare the (x, y) for
	 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
	 * click occurs). Unfortunately, there are no event properties that tie the input and the label
	 * together (such as relatedTarget).
	 *
	 * @param {MouseEvent} event
	 * @returns {boolean}
	 */
	function isInputEventFromLabelClick(event) {
	  return lastLabelClickPos
	      && lastLabelClickPos.x == event.x
	      && lastLabelClickPos.y == event.y;
	}
	
	/*
	 * Update the given pointer based upon the given DOMEvent.
	 * Distance, velocity, direction, duration, etc
	 */
	function updatePointerState(ev, pointer) {
	  var point = getEventPoint(ev);
	  var x = pointer.x = point.pageX;
	  var y = pointer.y = point.pageY;
	
	  pointer.distanceX = x - pointer.startX;
	  pointer.distanceY = y - pointer.startY;
	  pointer.distance = Math.sqrt(
	    pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
	  );
	
	  pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
	  pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';
	
	  pointer.duration = +Date.now() - pointer.startTime;
	  pointer.velocityX = pointer.distanceX / pointer.duration;
	  pointer.velocityY = pointer.distanceY / pointer.duration;
	}
	
	/*
	 * Normalize the point where the DOM event happened whether it's touch or mouse.
	 * @returns point event obj with pageX and pageY on it.
	 */
	function getEventPoint(ev) {
	  ev = ev.originalEvent || ev; // support jQuery events
	  return (ev.touches && ev.touches[0]) ||
	    (ev.changedTouches && ev.changedTouches[0]) ||
	    ev;
	}
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	  .provider('$$interimElement', InterimElementProvider);
	
	/*
	 * @ngdoc service
	 * @name $$interimElement
	 * @module material.core
	 *
	 * @description
	 *
	 * Factory that contructs `$$interimElement.$service` services.
	 * Used internally in material design for elements that appear on screen temporarily.
	 * The service provides a promise-like API for interacting with the temporary
	 * elements.
	 *
	 * ```js
	 * app.service('$mdToast', function($$interimElement) {
	 *   var $mdToast = $$interimElement(toastDefaultOptions);
	 *   return $mdToast;
	 * });
	 * ```
	 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
	 *
	 * @returns {$$interimElement.$service}
	 *
	 */
	
	function InterimElementProvider() {
	  InterimElementFactory.$inject = ["$document", "$q", "$$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector"];
	  createInterimElementProvider.$get = InterimElementFactory;
	  return createInterimElementProvider;
	
	  /**
	   * Returns a new provider which allows configuration of a new interimElement
	   * service. Allows configuration of default options & methods for options,
	   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
	   */
	  function createInterimElementProvider(interimFactoryName) {
	    factory.$inject = ["$$interimElement", "$injector"];
	    var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];
	
	    var customMethods = {};
	    var providerConfig = {
	      presets: {}
	    };
	
	    var provider = {
	      setDefaults: setDefaults,
	      addPreset: addPreset,
	      addMethod: addMethod,
	      $get: factory
	    };
	
	    /**
	     * all interim elements will come with the 'build' preset
	     */
	    provider.addPreset('build', {
	      methods: ['controller', 'controllerAs', 'resolve',
	        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent']
	    });
	
	    return provider;
	
	    /**
	     * Save the configured defaults to be used when the factory is instantiated
	     */
	    function setDefaults(definition) {
	      providerConfig.optionsFactory = definition.options;
	      providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
	      return provider;
	    }
	
	    /**
	     * Add a method to the factory that isn't specific to any interim element operations
	     */
	
	    function addMethod(name, fn) {
	      customMethods[name] = fn;
	      return provider;
	    }
	
	    /**
	     * Save the configured preset to be used when the factory is instantiated
	     */
	    function addPreset(name, definition) {
	      definition = definition || {};
	      definition.methods = definition.methods || [];
	      definition.options = definition.options || function() { return {}; };
	
	      if (/^cancel|hide|show$/.test(name)) {
	        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
	      }
	      if (definition.methods.indexOf('_options') > -1) {
	        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
	      }
	      providerConfig.presets[name] = {
	        methods: definition.methods.concat(EXPOSED_METHODS),
	        optionsFactory: definition.options,
	        argOption: definition.argOption
	      };
	      return provider;
	    }
	
	    function addPresetMethod(presetName, methodName, method) {
	      providerConfig.presets[presetName][methodName] = method;
	    }
	
	    /**
	     * Create a factory that has the given methods & defaults implementing interimElement
	     */
	    /* @ngInject */
	    function factory($$interimElement, $injector) {
	      var defaultMethods;
	      var defaultOptions;
	      var interimElementService = $$interimElement();
	
	      /*
	       * publicService is what the developer will be using.
	       * It has methods hide(), cancel(), show(), build(), and any other
	       * presets which were set during the config phase.
	       */
	      var publicService = {
	        hide: interimElementService.hide,
	        cancel: interimElementService.cancel,
	        show: showInterimElement,
	
	        // Special internal method to destroy an interim element without animations
	        // used when navigation changes causes a $scope.$destroy() action
	        destroy : destroyInterimElement
	      };
	
	
	      defaultMethods = providerConfig.methods || [];
	      // This must be invoked after the publicService is initialized
	      defaultOptions = invokeFactory(providerConfig.optionsFactory, {});
	
	      // Copy over the simple custom methods
	      angular.forEach(customMethods, function(fn, name) {
	        publicService[name] = fn;
	      });
	
	      angular.forEach(providerConfig.presets, function(definition, name) {
	        var presetDefaults = invokeFactory(definition.optionsFactory, {});
	        var presetMethods = (definition.methods || []).concat(defaultMethods);
	
	        // Every interimElement built with a preset has a field called `$type`,
	        // which matches the name of the preset.
	        // Eg in preset 'confirm', options.$type === 'confirm'
	        angular.extend(presetDefaults, { $type: name });
	
	        // This creates a preset class which has setter methods for every
	        // method given in the `.addPreset()` function, as well as every
	        // method given in the `.setDefaults()` function.
	        //
	        // @example
	        // .setDefaults({
	        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
	        //   options: dialogDefaultOptions
	        // })
	        // .addPreset('alert', {
	        //   methods: ['title', 'ok'],
	        //   options: alertDialogOptions
	        // })
	        //
	        // Set values will be passed to the options when interimElement.show() is called.
	        function Preset(opts) {
	          this._options = angular.extend({}, presetDefaults, opts);
	        }
	        angular.forEach(presetMethods, function(name) {
	          Preset.prototype[name] = function(value) {
	            this._options[name] = value;
	            return this;
	          };
	        });
	
	        // Create shortcut method for one-linear methods
	        if (definition.argOption) {
	          var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
	          publicService[methodName] = function(arg) {
	            var config = publicService[name](arg);
	            return publicService.show(config);
	          };
	        }
	
	        // eg $mdDialog.alert() will return a new alert preset
	        publicService[name] = function(arg) {
	          // If argOption is supplied, eg `argOption: 'content'`, then we assume
	          // if the argument is not an options object then it is the `argOption` option.
	          //
	          // @example `$mdToast.simple('hello')` // sets options.content to hello
	          //                                     // because argOption === 'content'
	          if (arguments.length && definition.argOption &&
	              !angular.isObject(arg) && !angular.isArray(arg))  {
	
	            return (new Preset())[definition.argOption](arg);
	
	          } else {
	            return new Preset(arg);
	          }
	
	        };
	      });
	
	      return publicService;
	
	      /**
	       *
	       */
	      function showInterimElement(opts) {
	        // opts is either a preset which stores its options on an _options field,
	        // or just an object made up of options
	        opts = opts || { };
	        if (opts._options) opts = opts._options;
	
	        return interimElementService.show(
	          angular.extend({}, defaultOptions, opts)
	        );
	      }
	
	      /**
	       *  Special method to hide and destroy an interimElement WITHOUT
	       *  any 'leave` or hide animations ( an immediate force hide/remove )
	       *
	       *  NOTE: This calls the onRemove() subclass method for each component...
	       *  which must have code to respond to `options.$destroy == true`
	       */
	      function destroyInterimElement(opts) {
	          return interimElementService.destroy(opts);
	      }
	
	      /**
	       * Helper to call $injector.invoke with a local of the factory name for
	       * this provider.
	       * If an $mdDialog is providing options for a dialog and tries to inject
	       * $mdDialog, a circular dependency error will happen.
	       * We get around that by manually injecting $mdDialog as a local.
	       */
	      function invokeFactory(factory, defaultVal) {
	        var locals = {};
	        locals[interimFactoryName] = publicService;
	        return $injector.invoke(factory || function() { return defaultVal; }, {}, locals);
	      }
	
	    }
	
	  }
	
	  /* @ngInject */
	  function InterimElementFactory($document, $q, $$q, $rootScope, $timeout, $rootElement, $animate,
	                                 $mdUtil, $mdCompiler, $mdTheming, $injector ) {
	    return function createInterimElementService() {
	      var SHOW_CANCELLED = false;
	
	      /*
	       * @ngdoc service
	       * @name $$interimElement.$service
	       *
	       * @description
	       * A service used to control inserting and removing an element into the DOM.
	       *
	       */
	      var service, stack = [];
	
	      // Publish instance $$interimElement service;
	      // ... used as $mdDialog, $mdToast, $mdMenu, and $mdSelect
	
	      return service = {
	        show: show,
	        hide: hide,
	        cancel: cancel,
	        destroy : destroy,
	        $injector_: $injector
	      };
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#show
	       * @kind function
	       *
	       * @description
	       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved or rejected
	       * with hide or cancel, respectively. To external cancel/hide, developers should use the
	       *
	       * @param {*} options is hashMap of settings
	       * @returns a Promise
	       *
	       */
	      function show(options) {
	        options = options || {};
	        var interimElement = new InterimElement(options || {});
	        // When an interim element is currently showing, we have to cancel it.
	        // Just hiding it, will resolve the InterimElement's promise, the promise should be
	        // rejected instead.
	        var hideExisting = !options.skipHide && stack.length ? service.cancel() : $q.when(true);
	
	        // This hide()s only the current interim element before showing the next, new one
	        // NOTE: this is not reversible (e.g. interim elements are not stackable)
	
	        hideExisting.finally(function() {
	
	          stack.push(interimElement);
	          interimElement
	            .show()
	            .catch(function( reason ) {
	              //$log.error("InterimElement.show() error: " + reason );
	              return reason;
	            });
	
	        });
	
	        // Return a promise that will be resolved when the interim
	        // element is hidden or cancelled...
	
	        return interimElement.deferred.promise;
	      }
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#hide
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and resolves the promise returned from `show`
	       *
	       * @param {*} resolveParam Data to resolve the promise with
	       * @returns a Promise that will be resolved after the element has been removed.
	       *
	       */
	      function hide(reason, options) {
	        if ( !stack.length ) return $q.when(reason);
	        options = options || {};
	
	        if (options.closeAll) {
	          var promise = $q.all(stack.reverse().map(closeElement));
	          stack = [];
	          return promise;
	        } else if (options.closeTo !== undefined) {
	          return $q.all(stack.splice(options.closeTo).map(closeElement));
	        } else {
	          var interim = stack.pop();
	          return closeElement(interim);
	        }
	
	        function closeElement(interim) {
	          interim
	            .remove(reason, false, options || { })
	            .catch(function( reason ) {
	              //$log.error("InterimElement.hide() error: " + reason );
	              return reason;
	            });
	          return interim.deferred.promise;
	        }
	      }
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#cancel
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and rejects the promise returned from `show`
	       *
	       * @param {*} reason Data to reject the promise with
	       * @returns Promise that will be resolved after the element has been removed.
	       *
	       */
	      function cancel(reason, options) {
	        var interim = stack.pop();
	        if ( !interim ) return $q.when(reason);
	
	        interim
	          .remove(reason, true, options || { })
	          .catch(function( reason ) {
	            //$log.error("InterimElement.cancel() error: " + reason );
	            return reason;
	          });
	
	        // Since Angular 1.6.7, promises will be logged to $exceptionHandler when the promise
	        // is not handling the rejection. We create a pseudo catch handler, which will prevent the
	        // promise from being logged to the $exceptionHandler.
	        return interim.deferred.promise.catch(angular.noop);
	      }
	
	      /*
	       * Special method to quick-remove the interim element without animations
	       * Note: interim elements are in "interim containers"
	       */
	      function destroy(target) {
	        var interim = !target ? stack.shift() : null;
	        var cntr = angular.element(target).length ? angular.element(target)[0].parentNode : null;
	
	        if (cntr) {
	            // Try to find the interim element in the stack which corresponds to the supplied DOM element.
	            var filtered = stack.filter(function(entry) {
	                  var currNode = entry.options.element[0];
	                  return  (currNode === cntr);
	                });
	
	            // Note: this function might be called when the element already has been removed, in which
	            //       case we won't find any matches. That's ok.
	            if (filtered.length > 0) {
	              interim = filtered[0];
	              stack.splice(stack.indexOf(interim), 1);
	            }
	        }
	
	        return interim ? interim.remove(SHOW_CANCELLED, false, {'$destroy':true}) : $q.when(SHOW_CANCELLED);
	      }
	
	      /*
	       * Internal Interim Element Object
	       * Used internally to manage the DOM element and related data
	       */
	      function InterimElement(options) {
	        var self, element, showAction = $q.when(true);
	
	        options = configureScopeAndTransitions(options);
	
	        return self = {
	          options : options,
	          deferred: $q.defer(),
	          show    : createAndTransitionIn,
	          remove  : transitionOutAndRemove
	        };
	
	        /**
	         * Compile, link, and show this interim element
	         * Use optional autoHided and transition-in effects
	         */
	        function createAndTransitionIn() {
	          return $q(function(resolve, reject) {
	
	            // Trigger onCompiling callback before the compilation starts.
	            // This is useful, when modifying options, which can be influenced by developers.
	            options.onCompiling && options.onCompiling(options);
	
	            compileElement(options)
	              .then(function( compiledData ) {
	                element = linkElement( compiledData, options );
	
	                showAction = showElement(element, options, compiledData.controller)
	                  .then(resolve, rejectAll);
	
	              }, rejectAll);
	
	            function rejectAll(fault) {
	              // Force the '$md<xxx>.show()' promise to reject
	              self.deferred.reject(fault);
	
	              // Continue rejection propagation
	              reject(fault);
	            }
	          });
	        }
	
	        /**
	         * After the show process has finished/rejected:
	         * - announce 'removing',
	         * - perform the transition-out, and
	         * - perform optional clean up scope.
	         */
	        function transitionOutAndRemove(response, isCancelled, opts) {
	
	          // abort if the show() and compile failed
	          if ( !element ) return $q.when(false);
	
	          options = angular.extend(options || {}, opts || {});
	          options.cancelAutoHide && options.cancelAutoHide();
	          options.element.triggerHandler('$mdInterimElementRemove');
	
	          if ( options.$destroy === true ) {
	
	            return hideElement(options.element, options).then(function(){
	              (isCancelled && rejectAll(response)) || resolveAll(response);
	            });
	
	          } else {
	
	            $q.when(showAction)
	                .finally(function() {
	                  hideElement(options.element, options).then(function() {
	
	                    (isCancelled && rejectAll(response)) || resolveAll(response);
	
	                  }, rejectAll);
	                });
	
	            return self.deferred.promise;
	          }
	
	
	          /**
	           * The `show()` returns a promise that will be resolved when the interim
	           * element is hidden or cancelled...
	           */
	          function resolveAll(response) {
	            self.deferred.resolve(response);
	          }
	
	          /**
	           * Force the '$md<xxx>.show()' promise to reject
	           */
	          function rejectAll(fault) {
	            self.deferred.reject(fault);
	          }
	        }
	
	        /**
	         * Prepare optional isolated scope and prepare $animate with default enter and leave
	         * transitions for the new element instance.
	         */
	        function configureScopeAndTransitions(options) {
	          options = options || { };
	          if ( options.template ) {
	            options.template = $mdUtil.processTemplate(options.template);
	          }
	
	          return angular.extend({
	            preserveScope: false,
	            cancelAutoHide : angular.noop,
	            scope: options.scope || $rootScope.$new(options.isolateScope),
	
	            /**
	             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
	             */
	            onShow: function transitionIn(scope, element, options) {
	              return $animate.enter(element, options.parent);
	            },
	
	            /**
	             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
	             */
	            onRemove: function transitionOut(scope, element) {
	              // Element could be undefined if a new element is shown before
	              // the old one finishes compiling.
	              return element && $animate.leave(element) || $q.when();
	            }
	          }, options );
	
	        }
	
	        /**
	         * Compile an element with a templateUrl, controller, and locals
	         */
	        function compileElement(options) {
	
	          var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;
	
	          return compiled || $q(function (resolve) {
	              resolve({
	                locals: {},
	                link: function () {
	                  return options.element;
	                }
	              });
	            });
	        }
	
	        /**
	         *  Link an element with compiled configuration
	         */
	        function linkElement(compileData, options){
	          angular.extend(compileData.locals, options);
	
	          var element = compileData.link(options.scope);
	
	          // Search for parent at insertion time, if not specified
	          options.element = element;
	          options.parent = findParent(element, options);
	          if (options.themable) $mdTheming(element);
	
	          return element;
	        }
	
	        /**
	         * Search for parent at insertion time, if not specified
	         */
	        function findParent(element, options) {
	          var parent = options.parent;
	
	          // Search for parent at insertion time, if not specified
	          if (angular.isFunction(parent)) {
	            parent = parent(options.scope, element, options);
	          } else if (angular.isString(parent)) {
	            parent = angular.element($document[0].querySelector(parent));
	          } else {
	            parent = angular.element(parent);
	          }
	
	          // If parent querySelector/getter function fails, or it's just null,
	          // find a default.
	          if (!(parent || {}).length) {
	            var el;
	            if ($rootElement[0] && $rootElement[0].querySelector) {
	              el = $rootElement[0].querySelector(':not(svg) > body');
	            }
	            if (!el) el = $rootElement[0];
	            if (el.nodeName == '#comment') {
	              el = $document[0].body;
	            }
	            return angular.element(el);
	          }
	
	          return parent;
	        }
	
	        /**
	         * If auto-hide is enabled, start timer and prepare cancel function
	         */
	        function startAutoHide() {
	          var autoHideTimer, cancelAutoHide = angular.noop;
	
	          if (options.hideDelay) {
	            autoHideTimer = $timeout(service.hide, options.hideDelay) ;
	            cancelAutoHide = function() {
	              $timeout.cancel(autoHideTimer);
	            }
	          }
	
	          // Cache for subsequent use
	          options.cancelAutoHide = function() {
	            cancelAutoHide();
	            options.cancelAutoHide = undefined;
	          }
	        }
	
	        /**
	         * Show the element ( with transitions), notify complete and start
	         * optional auto-Hide
	         */
	        function showElement(element, options, controller) {
	          // Trigger onShowing callback before the `show()` starts
	          var notifyShowing = options.onShowing || angular.noop;
	          // Trigger onComplete callback when the `show()` finishes
	          var notifyComplete = options.onComplete || angular.noop;
	
	          notifyShowing(options.scope, element, options, controller);
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              $q.when(options.onShow(options.scope, element, options, controller))
	                .then(function () {
	                  notifyComplete(options.scope, element, options);
	                  startAutoHide();
	
	                  resolve(element);
	
	                }, reject );
	
	            } catch(e) {
	              reject(e.message);
	            }
	          });
	        }
	
	        function hideElement(element, options) {
	          var announceRemoving = options.onRemoving || angular.noop;
	
	          return $$q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              var action = $$q.when( options.onRemove(options.scope, element, options) || true );
	
	              // Trigger callback *before* the remove operation starts
	              announceRemoving(element, action);
	
	              if ( options.$destroy == true ) {
	
	                // For $destroy, onRemove should be synchronous
	                resolve(element);
	
	              } else {
	
	                // Wait until transition-out is done
	                action.then(function () {
	
	                  if (!options.preserveScope && options.scope ) {
	                    options.scope.$destroy();
	                  }
	
	                  resolve(element);
	
	                }, reject );
	              }
	
	            } catch(e) {
	              reject(e);
	            }
	          });
	        }
	
	      }
	    };
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  var $mdUtil, $interpolate, $log;
	
	  var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
	  var WHITESPACE = /\s+/g;
	
	  var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow' ];
	  var LAYOUT_OPTIONS = ['row', 'column'];
	  var ALIGNMENT_MAIN_AXIS= [ "", "start", "center", "end", "stretch", "space-around", "space-between" ];
	  var ALIGNMENT_CROSS_AXIS= [ "", "start", "center", "end", "stretch" ];
	
	  var config = {
	    /**
	     * Enable directive attribute-to-class conversions
	     * Developers can use `<body md-layout-css />` to quickly
	     * disable the Layout directives and prohibit the injection of Layout classNames
	     */
	    enabled: true,
	
	    /**
	     * List of mediaQuery breakpoints and associated suffixes
	     *
	     *   [
	     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
	     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
	     *   ]
	     */
	    breakpoints: []
	  };
	
	  registerLayoutAPI( angular.module('material.core.layout', ['ng']) );
	
	  /**
	   *   registerLayoutAPI()
	   *
	   *   The original ngMaterial Layout solution used attribute selectors and CSS.
	   *
	   *  ```html
	   *  <div layout="column"> My Content </div>
	   *  ```
	   *
	   *  ```css
	   *  [layout] {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  [layout=column] {
	   *    flex-direction : column
	   *  }
	   *  ```
	   *
	   *  Use of attribute selectors creates significant performance impacts in some
	   *  browsers... mainly IE.
	   *
	   *  This module registers directives that allow the same layout attributes to be
	   *  interpreted and converted to class selectors. The directive will add equivalent classes to each element that
	   *  contains a Layout directive.
	   *
	   * ```html
	   *   <div layout="column" class="layout layout-column"> My Content </div>
	   *```
	   *
	   *  ```css
	   *  .layout {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  .layout-column {
	   *    flex-direction : column
	   *  }
	   *  ```
	   */
	  function registerLayoutAPI(module){
	    var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	    var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	
	    // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
	    var BREAKPOINTS     = [ "", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print" ];
	    var API_WITH_VALUES = [ "layout", "flex", "flex-order", "flex-offset", "layout-align" ];
	    var API_NO_VALUES   = [ "show", "hide", "layout-padding", "layout-margin" ];
	
	
	    // Build directive registration functions for the standard Layout API... for all breakpoints.
	    angular.forEach(BREAKPOINTS, function(mqb) {
	
	      // Attribute directives with expected, observable value(s)
	      angular.forEach( API_WITH_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive( directiveNormalize(fullName), attributeWithObserve(fullName));
	      });
	
	      // Attribute directives with no expected value(s)
	      angular.forEach( API_NO_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive( directiveNormalize(fullName), attributeWithoutValue(fullName));
	      });
	
	    });
	
	    // Register other, special directive functions for the Layout features:
	    module
	
	      .provider('$$mdLayout'     , function() {
	        // Publish internal service for Layouts
	        return {
	          $get : angular.noop,
	          validateAttributeValue : validateAttributeValue,
	          validateAttributeUsage : validateAttributeUsage,
	          /**
	           * Easy way to disable/enable the Layout API.
	           * When disabled, this stops all attribute-to-classname generations
	           */
	          disableLayouts  : function(isDisabled) {
	            config.enabled =  (isDisabled !== true);
	          }
	        };
	      })
	
	      .directive('mdLayoutCss'        , disableLayoutDirective )
	      .directive('ngCloak'            , buildCloakInterceptor('ng-cloak'))
	
	      .directive('layoutWrap'   , attributeWithoutValue('layout-wrap'))
	      .directive('layoutNowrap' , attributeWithoutValue('layout-nowrap'))
	      .directive('layoutNoWrap' , attributeWithoutValue('layout-no-wrap'))
	      .directive('layoutFill'   , attributeWithoutValue('layout-fill'))
	
	      // !! Deprecated attributes: use the `-lt` (aka less-than) notations
	
	      .directive('layoutLtMd'     , warnAttrNotSupported('layout-lt-md', true))
	      .directive('layoutLtLg'     , warnAttrNotSupported('layout-lt-lg', true))
	      .directive('flexLtMd'       , warnAttrNotSupported('flex-lt-md', true))
	      .directive('flexLtLg'       , warnAttrNotSupported('flex-lt-lg', true))
	
	      .directive('layoutAlignLtMd', warnAttrNotSupported('layout-align-lt-md'))
	      .directive('layoutAlignLtLg', warnAttrNotSupported('layout-align-lt-lg'))
	      .directive('flexOrderLtMd'  , warnAttrNotSupported('flex-order-lt-md'))
	      .directive('flexOrderLtLg'  , warnAttrNotSupported('flex-order-lt-lg'))
	      .directive('offsetLtMd'     , warnAttrNotSupported('flex-offset-lt-md'))
	      .directive('offsetLtLg'     , warnAttrNotSupported('flex-offset-lt-lg'))
	
	      .directive('hideLtMd'       , warnAttrNotSupported('hide-lt-md'))
	      .directive('hideLtLg'       , warnAttrNotSupported('hide-lt-lg'))
	      .directive('showLtMd'       , warnAttrNotSupported('show-lt-md'))
	      .directive('showLtLg'       , warnAttrNotSupported('show-lt-lg'))
	
	      // Determine if
	      .config( detectDisabledLayouts );
	
	    /**
	     * Converts snake_case to camelCase.
	     * Also there is special case for Moz prefix starting with upper case letter.
	     * @param name Name to normalize
	     */
	    function directiveNormalize(name) {
	      return name
	        .replace(PREFIX_REGEXP, '')
	        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	          return offset ? letter.toUpperCase() : letter;
	        });
	    }
	
	  }
	
	
	  /**
	    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
	    * If yes, then immediately disable all layout API features
	    *
	    * Note: this attribute should be specified on either the HTML or BODY tags
	    */
	   /**
	    * @ngInject
	    */
	   function detectDisabledLayouts() {
	     var isDisabled = !!document.querySelector('[md-layouts-disabled]');
	     config.enabled = !isDisabled;
	   }
	
	  /**
	   * Special directive that will disable ALL Layout conversions of layout
	   * attribute(s) to classname(s).
	   *
	   * <link rel="stylesheet" href="angular-material.min.css">
	   * <link rel="stylesheet" href="angular-material.layout.css">
	   *
	   * <body md-layout-css>
	   *  ...
	   * </body>
	   *
	   * Note: Using md-layout-css directive requires the developer to load the Material
	   * Layout Attribute stylesheet (which only uses attribute selectors):
	   *
	   *       `angular-material.layout.css`
	   *
	   * Another option is to use the LayoutProvider to configure and disable the attribute
	   * conversions; this would obviate the use of the `md-layout-css` directive
	   *
	   */
	  function disableLayoutDirective() {
	    // Return a 1x-only, first-match attribute directive
	    config.enabled = false;
	
	    return {
	      restrict : 'A',
	      priority : '900'
	    };
	  }
	
	  /**
	   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
	   * finish processing. Eliminates flicker with Material.Layouts
	   */
	  function buildCloakInterceptor(className) {
	    return [ '$timeout', function($timeout){
	      return {
	        restrict : 'A',
	        priority : -10,   // run after normal ng-cloak
	        compile  : function( element ) {
	          if (!config.enabled) return angular.noop;
	
	          // Re-add the cloak
	          element.addClass(className);
	
	          return function( scope, element ) {
	            // Wait while layout injectors configure, then uncloak
	            // NOTE: $rAF does not delay enough... and this is a 1x-only event,
	            //       $timeout is acceptable.
	            $timeout( function(){
	              element.removeClass(className);
	            }, 10, false);
	          };
	        }
	      };
	    }];
	  }
	
	
	  // *********************************************************************************
	  //
	  // These functions create registration functions for ngMaterial Layout attribute directives
	  // This provides easy translation to switch ngMaterial attribute selectors to
	  // CLASS selectors and directives; which has huge performance implications
	  // for IE Browsers
	  //
	  // *********************************************************************************
	
	  /**
	   * Creates a directive registration function where a possible dynamic attribute
	   * value will be observed/watched.
	   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
	   */
	  function attributeWithObserve(className) {
	
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeUsage(className, attr, element, $log);
	
	            validateAttributeValue( className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            linkFn = translateWithValueToCssClass;
	          }
	
	          // Use for postLink to account for transforms after ng-transclude.
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector(s), then
	     * remove the deprecated attribute selector
	     */
	    function translateWithValueToCssClass(scope, element, attrs) {
	      var updateFn = updateClassWithValue(element, className, attrs);
	      var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);
	
	      updateFn(getNormalizedAttrValue(className, attrs, ""));
	      scope.$on("$destroy", function() { unwatch(); });
	    }
	  }
	
	  /**
	   * Creates a registration function for ngMaterial Layout attribute directive.
	   * This is a `simple` transpose of attribute usage to class usage; where we ignore
	   * any attribute value
	   */
	  function attributeWithoutValue(className) {
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeValue( className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            translateToCssClass(null, element);
	
	            // Use for postLink to account for transforms after ng-transclude.
	            linkFn = translateToCssClass;
	          }
	
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector, then
	     * remove the deprecated attribute selector
	     */
	    function translateToCssClass(scope, element) {
	      element.addClass(className);
	    }
	  }
	
	
	
	  /**
	   * After link-phase, do NOT remove deprecated layout attribute selector.
	   * Instead watch the attribute so interpolated data-bindings to layout
	   * selectors will continue to be supported.
	   *
	   * $observe() the className and update with new class (after removing the last one)
	   *
	   * e.g. `layout="{{layoutDemo.direction}}"` will update...
	   *
	   * NOTE: The value must match one of the specified styles in the CSS.
	   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
	   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
	   *
	   */
	  function updateClassWithValue(element, className) {
	    var lastClass;
	
	    return function updateClassFn(newValue) {
	      var value = validateAttributeValue(className, newValue || "");
	      if ( angular.isDefined(value) ) {
	        if (lastClass) element.removeClass(lastClass);
	        lastClass = !value ? className : className + "-" + value.replace(WHITESPACE, "-");
	        element.addClass(lastClass);
	      }
	    };
	  }
	
	  /**
	   * Provide console warning that this layout attribute has been deprecated
	   *
	   */
	  function warnAttrNotSupported(className) {
	    var parts = className.split("-");
	    return ["$log", function($log) {
	      $log.warn(className + "has been deprecated. Please use a `" + parts[0] + "-gt-<xxx>` variant.");
	      return angular.noop;
	    }];
	  }
	
	  /**
	   * Centralize warnings for known flexbox issues (especially IE-related issues)
	   */
	  function validateAttributeUsage(className, attr, element, $log){
	    var message, usage, url;
	    var nodeName = element[0].nodeName.toLowerCase();
	
	    switch(className.replace(SUFFIXES,"")) {
	      case "flex":
	        if ((nodeName == "md-button") || (nodeName == "fieldset")){
	          // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
	          // Use <div flex> wrapper inside (preferred) or outside
	
	          usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
	          url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
	          message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";
	
	          $log.warn( $mdUtil.supplant(message, [usage, url]) );
	        }
	    }
	
	  }
	
	
	  /**
	   * For the Layout attribute value, validate or replace with default
	   * fallback value
	   */
	  function validateAttributeValue(className, value, updateFn) {
	    var origValue = value;
	
	    if (!needsInterpolation(value)) {
	      switch (className.replace(SUFFIXES,"")) {
	        case 'layout'        :
	          if ( !findIn(value, LAYOUT_OPTIONS) ) {
	            value = LAYOUT_OPTIONS[0];    // 'row';
	          }
	          break;
	
	        case 'flex'          :
	          if (!findIn(value, FLEX_OPTIONS)) {
	            if (isNaN(value)) {
	              value = '';
	            }
	          }
	          break;
	
	        case 'flex-offset' :
	        case 'flex-order'    :
	          if (!value || isNaN(+value)) {
	            value = '0';
	          }
	          break;
	
	        case 'layout-align'  :
	          var axis = extractAlignAxis(value);
	          value = $mdUtil.supplant("{main}-{cross}",axis);
	          break;
	
	        case 'layout-padding' :
	        case 'layout-margin'  :
	        case 'layout-fill'    :
	        case 'layout-wrap'    :
	        case 'layout-nowrap'  :
	        case 'layout-nowrap' :
	          value = '';
	          break;
	      }
	
	      if (value != origValue) {
	        (updateFn || angular.noop)(value);
	      }
	    }
	
	    return value;
	  }
	
	  /**
	   * Replace current attribute value with fallback value
	   */
	  function buildUpdateFn(element, className, attrs) {
	    return function updateAttrValue(fallback) {
	      if (!needsInterpolation(fallback)) {
	        // Do not modify the element's attribute value; so
	        // uses '<ui-layout layout="/api/sidebar.html" />' will not
	        // be affected. Just update the attrs value.
	        attrs[attrs.$normalize(className)] = fallback;
	      }
	    };
	  }
	
	  /**
	   * See if the original value has interpolation symbols:
	   * e.g.  flex-gt-md="{{triggerPoint}}"
	   */
	  function needsInterpolation(value) {
	    return (value || "").indexOf($interpolate.startSymbol()) > -1;
	  }
	
	  function getNormalizedAttrValue(className, attrs, defaultVal) {
	    var normalizedAttr = attrs.$normalize(className);
	    return attrs[normalizedAttr] ? attrs[normalizedAttr].replace(WHITESPACE, "-") : defaultVal || null;
	  }
	
	  function findIn(item, list, replaceWith) {
	    item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;
	
	    var found = false;
	    if (item) {
	      list.forEach(function(it) {
	        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
	        found = found || (it === item);
	      });
	    }
	    return found;
	  }
	
	  function extractAlignAxis(attrValue) {
	    var axis = {
	      main : "start",
	      cross: "stretch"
	    }, values;
	
	    attrValue = (attrValue || "");
	
	    if ( attrValue.indexOf("-") === 0 || attrValue.indexOf(" ") === 0) {
	      // For missing main-axis values
	      attrValue = "none" + attrValue;
	    }
	
	    values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
	    if ( values.length && (values[0] === "space") ) {
	      // for main-axis values of "space-around" or "space-between"
	      values = [ values[0]+"-"+values[1],values[2] ];
	    }
	
	    if ( values.length > 0 ) axis.main  = values[0] || axis.main;
	    if ( values.length > 1 ) axis.cross = values[1] || axis.cross;
	
	    if ( ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0 )   axis.main = "start";
	    if ( ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0 ) axis.cross = "stretch";
	
	    return axis;
	  }
	
	
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $$mdMeta
	 * @module material.core.meta
	 *
	 * @description
	 *
	 * A provider and a service that simplifies meta tags access
	 *
	 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
	 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
	 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
	 *
	 * ```js
	 * app.config(function($$mdMetaProvider) {
	 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 *
	 * app.controller('myController', function($$mdMeta) {
	 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 * ```
	 *
	 * @returns {$$mdMeta.$service}
	 *
	 */
	angular.module('material.core.meta', [])
	  .provider('$$mdMeta', function () {
	    var head = angular.element(document.head);
	    var metaElements = {};
	
	    /**
	     * Checks if the requested element was written manually and maps it
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {boolean} returns true if there is an element with the requested name
	     */
	    function mapExistingElement(name) {
	      if (metaElements[name]) {
	        return true;
	      }
	
	      var element = document.getElementsByName(name)[0];
	
	      if (!element) {
	        return false;
	      }
	
	      metaElements[name] = angular.element(element);
	
	      return true;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#setMeta
	     *
	     * @description
	     * Creates meta element with the 'name' and 'content' attributes,
	     * if the meta tag is already created than we replace the 'content' value
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @param {string} content meta tag 'content' attribute value
	     * @returns {function} remove function
	     *
	     */
	    function setMeta(name, content) {
	      mapExistingElement(name);
	
	      if (!metaElements[name]) {
	        var newMeta = angular.element('<meta name="' + name + '" content="' + content + '"/>');
	        head.append(newMeta);
	        metaElements[name] = newMeta;
	      }
	      else {
	        metaElements[name].attr('content', content);
	      }
	
	      return function () {
	        metaElements[name].attr('content', '');
	        metaElements[name].remove();
	        delete metaElements[name];
	      };
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#getMeta
	     *
	     * @description
	     * Gets the 'content' attribute value of the wanted meta element
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {string} content attribute value
	     */
	    function getMeta(name) {
	      if (!mapExistingElement(name)) {
	        throw Error('$$mdMeta: could not find a meta tag with the name \'' + name + '\'');
	      }
	
	      return metaElements[name].attr('content');
	    }
	
	    var module = {
	      setMeta: setMeta,
	      getMeta: getMeta
	    };
	
	    return angular.extend({}, module, {
	      $get: function () {
	        return module;
	      }
	    });
	  });
	})();
	(function(){
	"use strict";
	
	  /**
	   * @ngdoc module
	   * @name material.core.componentRegistry
	   *
	   * @description
	   * A component instance registration service.
	   * Note: currently this as a private service in the SideNav component.
	   */
	  ComponentRegistry.$inject = ["$log", "$q"];
	  angular.module('material.core')
	    .factory('$mdComponentRegistry', ComponentRegistry);
	
	  /*
	   * @private
	   * @ngdoc factory
	   * @name ComponentRegistry
	   * @module material.core.componentRegistry
	   *
	   */
	  function ComponentRegistry($log, $q) {
	
	    var self;
	    var instances = [ ];
	    var pendings = { };
	
	    return self = {
	      /**
	       * Used to print an error when an instance for a handle isn't found.
	       */
	      notFoundError: function(handle, msgContext) {
	        $log.error( (msgContext || "") + 'No instance found for handle', handle);
	      },
	      /**
	       * Return all registered instances as an array.
	       */
	      getInstances: function() {
	        return instances;
	      },
	
	      /**
	       * Get a registered instance.
	       * @param handle the String handle to look up for a registered instance.
	       */
	      get: function(handle) {
	        if ( !isValidID(handle) ) return null;
	
	        var i, j, instance;
	        for(i = 0, j = instances.length; i < j; i++) {
	          instance = instances[i];
	          if(instance.$$mdHandle === handle) {
	            return instance;
	          }
	        }
	        return null;
	      },
	
	      /**
	       * Register an instance.
	       * @param instance the instance to register
	       * @param handle the handle to identify the instance under.
	       */
	      register: function(instance, handle) {
	        if ( !handle ) return angular.noop;
	
	        instance.$$mdHandle = handle;
	        instances.push(instance);
	        resolveWhen();
	
	        return deregister;
	
	        /**
	         * Remove registration for an instance
	         */
	        function deregister() {
	          var index = instances.indexOf(instance);
	          if (index !== -1) {
	            instances.splice(index, 1);
	          }
	        }
	
	        /**
	         * Resolve any pending promises for this instance
	         */
	        function resolveWhen() {
	          var dfd = pendings[handle];
	          if ( dfd ) {
	            dfd.forEach(function (promise) {
	              promise.resolve(instance);
	            });
	            delete pendings[handle];
	          }
	        }
	      },
	
	      /**
	       * Async accessor to registered component instance
	       * If not available then a promise is created to notify
	       * all listeners when the instance is registered.
	       */
	      when : function(handle) {
	        if ( isValidID(handle) ) {
	          var deferred = $q.defer();
	          var instance = self.get(handle);
	
	          if ( instance )  {
	            deferred.resolve( instance );
	          } else {
	            if (pendings[handle] === undefined) {
	              pendings[handle] = [];
	            }
	            pendings[handle].push(deferred);
	          }
	
	          return deferred.promise;
	        }
	        return $q.reject("Invalid `md-component-id` value.");
	      }
	
	    };
	
	    function isValidID(handle){
	      return handle && (handle !== "");
	    }
	
	  }
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdButtonInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
	   */
	
	  MdButtonInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdButtonInkRipple', MdButtonInkRipple);
	
	  function MdButtonInkRipple($mdInkRipple) {
	    return {
	      attach: function attachRipple(scope, element, options) {
	        options = angular.extend(optionsForElement(element), options);
	
	        return $mdInkRipple.attach(scope, element, options);
	      }
	    };
	
	    function optionsForElement(element) {
	      if (element.hasClass('md-icon-button')) {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          fitRipple: true,
	          center: true
	        };
	      } else {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          dimBackground: true
	        }
	      }
	    };
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdCheckboxInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdCheckboxInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);
	
	  function MdCheckboxInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: true,
	        dimBackground: false,
	        fitRipple: true
	      }, options));
	    };
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdListInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdListInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdListInkRipple', MdListInkRipple);
	
	  function MdListInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    };
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.ripple
	 * @description
	 * Ripple
	 */
	InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
	InkRippleDirective.$inject = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];
	angular.module('material.core')
	    .provider('$mdInkRipple', InkRippleProvider)
	    .directive('mdInkRipple', InkRippleDirective)
	    .directive('mdNoInk', attrNoDirective)
	    .directive('mdNoBar', attrNoDirective)
	    .directive('mdNoStretch', attrNoDirective);
	
	var DURATION = 450;
	
	/**
	 * @ngdoc directive
	 * @name mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * The `md-ink-ripple` directive allows you to specify the ripple color or id a ripple is allowed.
	 *
	 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for preventing ripple
	 *
	 * @usage
	 * ### String values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="#FF0000">
	 *     Ripples in red
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="false">
	 *     Not rippling
	 *   </ANY>
	 * </hljs>
	 *
	 * ### Interpolated values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="{{ randomColor() }}">
	 *     Ripples with the return value of 'randomColor' function
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="{{ canRipple() }}">
	 *     Ripples if 'canRipple' function return value is not 'false' or '0'
	 *   </ANY>
	 * </hljs>
	 */
	function InkRippleDirective ($mdButtonInkRipple, $mdCheckboxInkRipple) {
	  return {
	    controller: angular.noop,
	    link:       function (scope, element, attr) {
	      attr.hasOwnProperty('mdInkRippleCheckbox')
	          ? $mdCheckboxInkRipple.attach(scope, element)
	          : $mdButtonInkRipple.attach(scope, element);
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * `$mdInkRipple` is a service for adding ripples to any element
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.factory('$myElementInkRipple', function($mdInkRipple) {
	 *   return {
	 *     attach: function (scope, element, options) {
	 *       return $mdInkRipple.attach(scope, element, angular.extend({
	 *         center: false,
	 *         dimBackground: true
	 *       }, options));
	 *     }
	 *   };
	 * });
	 *
	 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
	 *   $scope.onClick = function (ev) {
	 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
	 *   }
	 * });
	 * </hljs>
	 *
	 * ### Disabling ripples globally
	 * If you want to disable ink ripples globally, for all components, you can call the
	 * `disableInkRipple` method in your app's config.
	 *
	 * <hljs lang="js">
	 * app.config(function ($mdInkRippleProvider) {
	 *   $mdInkRippleProvider.disableInkRipple();
	 * });
	 */
	
	function InkRippleProvider () {
	  var isDisabledGlobally = false;
	
	  return {
	    disableInkRipple: disableInkRipple,
	    $get: ["$injector", function($injector) {
	      return { attach: attach };
	
	      /**
	       * @ngdoc method
	       * @name $mdInkRipple#attach
	       *
	       * @description
	       * Attaching given scope, element and options to inkRipple controller
	       *
	       * @param {object=} scope Scope within the current context
	       * @param {object=} element The element the ripple effect should be applied to
	       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
	       * * `center` -  Whether the ripple should start from the center of the container element
	       * * `dimBackground` - Whether the background should be dimmed with the ripple color
	       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
	       * * `fitRipple` - Whether the ripple should fill the element
	       */
	      function attach (scope, element, options) {
	        if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
	        return $injector.instantiate(InkRippleCtrl, {
	          $scope:        scope,
	          $element:      element,
	          rippleOptions: options
	        });
	      }
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdInkRipple#disableInkRipple
	   *
	   * @description
	   * A config-time method that, when called, disables ripples globally.
	   */
	  function disableInkRipple () {
	    isDisabledGlobally = true;
	  }
	}
	
	/**
	 * Controller used by the ripple service in order to apply ripples
	 * @ngInject
	 */
	function InkRippleCtrl ($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
	  this.$window    = $window;
	  this.$timeout   = $timeout;
	  this.$mdUtil    = $mdUtil;
	  this.$mdColorUtil    = $mdColorUtil;
	  this.$scope     = $scope;
	  this.$element   = $element;
	  this.options    = rippleOptions;
	  this.mousedown  = false;
	  this.ripples    = [];
	  this.timeout    = null; // Stores a reference to the most-recent ripple timeout
	  this.lastRipple = null;
	
	  $mdUtil.valueOnUse(this, 'container', this.createContainer);
	
	  this.$element.addClass('md-ink-ripple');
	
	  // attach method for unit tests
	  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
	  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);
	
	  this.bindEvents();
	}
	
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup or mouseleave event)
	 */
	function autoCleanup (self, cleanupFn) {
	
	  if ( self.mousedown || self.lastRipple ) {
	    self.mousedown = false;
	    self.$mdUtil.nextTick( angular.bind(self, cleanupFn), false);
	  }
	
	}
	
	
	/**
	 * Returns the color that the ripple should be (either based on CSS or hard-coded)
	 * @returns {string}
	 */
	InkRippleCtrl.prototype.color = function (value) {
	  var self = this;
	
	  // If assigning a color value, apply it to background and the ripple color
	  if (angular.isDefined(value)) {
	    self._color = self._parseColor(value);
	  }
	
	  // If color lookup, use assigned, defined, or inherited
	  return self._color || self._parseColor( self.inkRipple() ) || self._parseColor( getElementColor() );
	
	  /**
	   * Finds the color element and returns its text color for use as default ripple color
	   * @returns {string}
	   */
	  function getElementColor () {
	    var items = self.options && self.options.colorElement ? self.options.colorElement : [];
	    var elem =  items.length ? items[ 0 ] : self.$element[ 0 ];
	
	    return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
	  }
	};
	
	/**
	 * Updating the ripple colors based on the current inkRipple value
	 * or the element's computed style color
	 */
	InkRippleCtrl.prototype.calculateColor = function () {
	  return this.color();
	};
	
	
	/**
	 * Takes a string color and converts it to RGBA format
	 * @param color {string}
	 * @param [multiplier] {int}
	 * @returns {string}
	 */
	
	InkRippleCtrl.prototype._parseColor = function parseColor (color, multiplier) {
	  multiplier = multiplier || 1;
	  var colorUtil = this.$mdColorUtil;
	
	  if (!color) return;
	  if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
	  if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
	  if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);
	
	};
	
	/**
	 * Binds events to the root element for
	 */
	InkRippleCtrl.prototype.bindEvents = function () {
	  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
	  this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
	  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
	  this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
	};
	
	/**
	 * Create a new ripple on every mousedown event from the root element
	 * @param event {MouseEvent}
	 */
	InkRippleCtrl.prototype.handleMousedown = function (event) {
	  if ( this.mousedown ) return;
	
	  // When jQuery is loaded, we have to get the original event
	  if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
	  this.mousedown = true;
	  if (this.options.center) {
	    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
	  } else {
	
	    // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
	    if (event.srcElement !== this.$element[0]) {
	      var layerRect = this.$element[0].getBoundingClientRect();
	      var layerX = event.clientX - layerRect.left;
	      var layerY = event.clientY - layerRect.top;
	
	      this.createRipple(layerX, layerY);
	    } else {
	      this.createRipple(event.offsetX, event.offsetY);
	    }
	  }
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup, touchend or mouseleave event)
	 */
	InkRippleCtrl.prototype.handleMouseup = function () {
	  autoCleanup(this, this.clearRipples);
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
	 * touchmove)
	 */
	InkRippleCtrl.prototype.handleTouchmove = function () {
	  autoCleanup(this, this.deleteRipples);
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them.
	 */
	InkRippleCtrl.prototype.deleteRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.ripples[ i ].remove();
	  }
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them with fade.
	 * Depending on logic within `fadeInComplete`, some removals will be postponed.
	 */
	InkRippleCtrl.prototype.clearRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.fadeInComplete(this.ripples[ i ]);
	  }
	};
	
	/**
	 * Creates the ripple container element
	 * @returns {*}
	 */
	InkRippleCtrl.prototype.createContainer = function () {
	  var container = angular.element('<div class="md-ripple-container"></div>');
	  this.$element.append(container);
	  return container;
	};
	
	InkRippleCtrl.prototype.clearTimeout = function () {
	  if (this.timeout) {
	    this.$timeout.cancel(this.timeout);
	    this.timeout = null;
	  }
	};
	
	InkRippleCtrl.prototype.isRippleAllowed = function () {
	  var element = this.$element[0];
	  do {
	    if (!element.tagName || element.tagName === 'BODY') break;
	
	    if (element && angular.isFunction(element.hasAttribute)) {
	      if (element.hasAttribute('disabled')) return false;
	      if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
	    }
	
	  } while (element = element.parentNode);
	  return true;
	};
	
	/**
	 * The attribute `md-ink-ripple` may be a static or interpolated
	 * color value OR a boolean indicator (used to disable ripples)
	 */
	InkRippleCtrl.prototype.inkRipple = function () {
	  return this.$element.attr('md-ink-ripple');
	};
	
	/**
	 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
	 * @param left
	 * @param top
	 */
	InkRippleCtrl.prototype.createRipple = function (left, top) {
	  if (!this.isRippleAllowed()) return;
	
	  var ctrl        = this;
	  var colorUtil   = ctrl.$mdColorUtil;
	  var ripple      = angular.element('<div class="md-ripple"></div>');
	  var width       = this.$element.prop('clientWidth');
	  var height      = this.$element.prop('clientHeight');
	  var x           = Math.max(Math.abs(width - left), left) * 2;
	  var y           = Math.max(Math.abs(height - top), top) * 2;
	  var size        = getSize(this.options.fitRipple, x, y);
	  var color       = this.calculateColor();
	
	  ripple.css({
	    left:            left + 'px',
	    top:             top + 'px',
	    background:      'black',
	    width:           size + 'px',
	    height:          size + 'px',
	    backgroundColor: colorUtil.rgbaToRgb(color),
	    borderColor:     colorUtil.rgbaToRgb(color)
	  });
	  this.lastRipple = ripple;
	
	  // we only want one timeout to be running at a time
	  this.clearTimeout();
	  this.timeout    = this.$timeout(function () {
	    ctrl.clearTimeout();
	    if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
	  }, DURATION * 0.35, false);
	
	  if (this.options.dimBackground) this.container.css({ backgroundColor: color });
	  this.container.append(ripple);
	  this.ripples.push(ripple);
	  ripple.addClass('md-ripple-placed');
	
	  this.$mdUtil.nextTick(function () {
	
	    ripple.addClass('md-ripple-scaled md-ripple-active');
	    ctrl.$timeout(function () {
	      ctrl.clearRipples();
	    }, DURATION, false);
	
	  }, false);
	
	  function getSize (fit, x, y) {
	    return fit
	        ? Math.max(x, y)
	        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
	  }
	};
	
	
	
	/**
	 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
	  if (this.lastRipple === ripple) {
	    if (!this.timeout && !this.mousedown) {
	      this.removeRipple(ripple);
	    }
	  } else {
	    this.removeRipple(ripple);
	  }
	};
	
	/**
	 * Kicks off the animation for removing a ripple
	 * @param ripple {Element}
	 */
	InkRippleCtrl.prototype.removeRipple = function (ripple) {
	  var ctrl  = this;
	  var index = this.ripples.indexOf(ripple);
	  if (index < 0) return;
	  this.ripples.splice(this.ripples.indexOf(ripple), 1);
	  ripple.removeClass('md-ripple-active');
	  ripple.addClass('md-ripple-remove');
	  if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
	  // use a 2-second timeout in order to allow for the animation to finish
	  // we don't actually care how long the animation takes
	  this.$timeout(function () {
	    ctrl.fadeOutComplete(ripple);
	  }, DURATION, false);
	};
	
	/**
	 * Removes the provided ripple from the DOM
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
	  ripple.remove();
	  this.lastRipple = null;
	};
	
	/**
	 * Used to create an empty directive.  This is used to track flag-directives whose children may have
	 * functionality based on them.
	 *
	 * Example: `md-no-ink` will potentially be used by all child directives.
	 */
	function attrNoDirective () {
	  return { controller: angular.noop };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdTabInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdTabInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdTabInkRipple', MdTabInkRipple);
	
	  function MdTabInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    };
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core.theming.palette', [])
	.constant('$mdColorPalette', {
	  'red': {
	    '50': '#ffebee',
	    '100': '#ffcdd2',
	    '200': '#ef9a9a',
	    '300': '#e57373',
	    '400': '#ef5350',
	    '500': '#f44336',
	    '600': '#e53935',
	    '700': '#d32f2f',
	    '800': '#c62828',
	    '900': '#b71c1c',
	    'A100': '#ff8a80',
	    'A200': '#ff5252',
	    'A400': '#ff1744',
	    'A700': '#d50000',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100',
	    'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
	  },
	  'pink': {
	    '50': '#fce4ec',
	    '100': '#f8bbd0',
	    '200': '#f48fb1',
	    '300': '#f06292',
	    '400': '#ec407a',
	    '500': '#e91e63',
	    '600': '#d81b60',
	    '700': '#c2185b',
	    '800': '#ad1457',
	    '900': '#880e4f',
	    'A100': '#ff80ab',
	    'A200': '#ff4081',
	    'A400': '#f50057',
	    'A700': '#c51162',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '500 600 A200 A400 A700'
	  },
	  'purple': {
	    '50': '#f3e5f5',
	    '100': '#e1bee7',
	    '200': '#ce93d8',
	    '300': '#ba68c8',
	    '400': '#ab47bc',
	    '500': '#9c27b0',
	    '600': '#8e24aa',
	    '700': '#7b1fa2',
	    '800': '#6a1b9a',
	    '900': '#4a148c',
	    'A100': '#ea80fc',
	    'A200': '#e040fb',
	    'A400': '#d500f9',
	    'A700': '#aa00ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400 A700'
	  },
	  'deep-purple': {
	    '50': '#ede7f6',
	    '100': '#d1c4e9',
	    '200': '#b39ddb',
	    '300': '#9575cd',
	    '400': '#7e57c2',
	    '500': '#673ab7',
	    '600': '#5e35b1',
	    '700': '#512da8',
	    '800': '#4527a0',
	    '900': '#311b92',
	    'A100': '#b388ff',
	    'A200': '#7c4dff',
	    'A400': '#651fff',
	    'A700': '#6200ea',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200'
	  },
	  'indigo': {
	    '50': '#e8eaf6',
	    '100': '#c5cae9',
	    '200': '#9fa8da',
	    '300': '#7986cb',
	    '400': '#5c6bc0',
	    '500': '#3f51b5',
	    '600': '#3949ab',
	    '700': '#303f9f',
	    '800': '#283593',
	    '900': '#1a237e',
	    'A100': '#8c9eff',
	    'A200': '#536dfe',
	    'A400': '#3d5afe',
	    'A700': '#304ffe',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400'
	  },
	  'blue': {
	    '50': '#e3f2fd',
	    '100': '#bbdefb',
	    '200': '#90caf9',
	    '300': '#64b5f6',
	    '400': '#42a5f5',
	    '500': '#2196f3',
	    '600': '#1e88e5',
	    '700': '#1976d2',
	    '800': '#1565c0',
	    '900': '#0d47a1',
	    'A100': '#82b1ff',
	    'A200': '#448aff',
	    'A400': '#2979ff',
	    'A700': '#2962ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100',
	    'contrastStrongLightColors': '500 600 700 A200 A400 A700'
	  },
	  'light-blue': {
	    '50': '#e1f5fe',
	    '100': '#b3e5fc',
	    '200': '#81d4fa',
	    '300': '#4fc3f7',
	    '400': '#29b6f6',
	    '500': '#03a9f4',
	    '600': '#039be5',
	    '700': '#0288d1',
	    '800': '#0277bd',
	    '900': '#01579b',
	    'A100': '#80d8ff',
	    'A200': '#40c4ff',
	    'A400': '#00b0ff',
	    'A700': '#0091ea',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A700',
	    'contrastStrongLightColors': '600 700 800 A700'
	  },
	  'cyan': {
	    '50': '#e0f7fa',
	    '100': '#b2ebf2',
	    '200': '#80deea',
	    '300': '#4dd0e1',
	    '400': '#26c6da',
	    '500': '#00bcd4',
	    '600': '#00acc1',
	    '700': '#0097a7',
	    '800': '#00838f',
	    '900': '#006064',
	    'A100': '#84ffff',
	    'A200': '#18ffff',
	    'A400': '#00e5ff',
	    'A700': '#00b8d4',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'teal': {
	    '50': '#e0f2f1',
	    '100': '#b2dfdb',
	    '200': '#80cbc4',
	    '300': '#4db6ac',
	    '400': '#26a69a',
	    '500': '#009688',
	    '600': '#00897b',
	    '700': '#00796b',
	    '800': '#00695c',
	    '900': '#004d40',
	    'A100': '#a7ffeb',
	    'A200': '#64ffda',
	    'A400': '#1de9b6',
	    'A700': '#00bfa5',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'green': {
	    '50': '#e8f5e9',
	    '100': '#c8e6c9',
	    '200': '#a5d6a7',
	    '300': '#81c784',
	    '400': '#66bb6a',
	    '500': '#4caf50',
	    '600': '#43a047',
	    '700': '#388e3c',
	    '800': '#2e7d32',
	    '900': '#1b5e20',
	    'A100': '#b9f6ca',
	    'A200': '#69f0ae',
	    'A400': '#00e676',
	    'A700': '#00c853',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'light-green': {
	    '50': '#f1f8e9',
	    '100': '#dcedc8',
	    '200': '#c5e1a5',
	    '300': '#aed581',
	    '400': '#9ccc65',
	    '500': '#8bc34a',
	    '600': '#7cb342',
	    '700': '#689f38',
	    '800': '#558b2f',
	    '900': '#33691e',
	    'A100': '#ccff90',
	    'A200': '#b2ff59',
	    'A400': '#76ff03',
	    'A700': '#64dd17',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'lime': {
	    '50': '#f9fbe7',
	    '100': '#f0f4c3',
	    '200': '#e6ee9c',
	    '300': '#dce775',
	    '400': '#d4e157',
	    '500': '#cddc39',
	    '600': '#c0ca33',
	    '700': '#afb42b',
	    '800': '#9e9d24',
	    '900': '#827717',
	    'A100': '#f4ff81',
	    'A200': '#eeff41',
	    'A400': '#c6ff00',
	    'A700': '#aeea00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '900',
	    'contrastStrongLightColors': '900'
	  },
	  'yellow': {
	    '50': '#fffde7',
	    '100': '#fff9c4',
	    '200': '#fff59d',
	    '300': '#fff176',
	    '400': '#ffee58',
	    '500': '#ffeb3b',
	    '600': '#fdd835',
	    '700': '#fbc02d',
	    '800': '#f9a825',
	    '900': '#f57f17',
	    'A100': '#ffff8d',
	    'A200': '#ffff00',
	    'A400': '#ffea00',
	    'A700': '#ffd600',
	    'contrastDefaultColor': 'dark'
	  },
	  'amber': {
	    '50': '#fff8e1',
	    '100': '#ffecb3',
	    '200': '#ffe082',
	    '300': '#ffd54f',
	    '400': '#ffca28',
	    '500': '#ffc107',
	    '600': '#ffb300',
	    '700': '#ffa000',
	    '800': '#ff8f00',
	    '900': '#ff6f00',
	    'A100': '#ffe57f',
	    'A200': '#ffd740',
	    'A400': '#ffc400',
	    'A700': '#ffab00',
	    'contrastDefaultColor': 'dark'
	  },
	  'orange': {
	    '50': '#fff3e0',
	    '100': '#ffe0b2',
	    '200': '#ffcc80',
	    '300': '#ffb74d',
	    '400': '#ffa726',
	    '500': '#ff9800',
	    '600': '#fb8c00',
	    '700': '#f57c00',
	    '800': '#ef6c00',
	    '900': '#e65100',
	    'A100': '#ffd180',
	    'A200': '#ffab40',
	    'A400': '#ff9100',
	    'A700': '#ff6d00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '800 900',
	    'contrastStrongLightColors': '800 900'
	  },
	  'deep-orange': {
	    '50': '#fbe9e7',
	    '100': '#ffccbc',
	    '200': '#ffab91',
	    '300': '#ff8a65',
	    '400': '#ff7043',
	    '500': '#ff5722',
	    '600': '#f4511e',
	    '700': '#e64a19',
	    '800': '#d84315',
	    '900': '#bf360c',
	    'A100': '#ff9e80',
	    'A200': '#ff6e40',
	    'A400': '#ff3d00',
	    'A700': '#dd2c00',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100 A200',
	    'contrastStrongLightColors': '500 600 700 800 900 A400 A700'
	  },
	  'brown': {
	    '50': '#efebe9',
	    '100': '#d7ccc8',
	    '200': '#bcaaa4',
	    '300': '#a1887f',
	    '400': '#8d6e63',
	    '500': '#795548',
	    '600': '#6d4c41',
	    '700': '#5d4037',
	    '800': '#4e342e',
	    '900': '#3e2723',
	    'A100': '#d7ccc8',
	    'A200': '#bcaaa4',
	    'A400': '#8d6e63',
	    'A700': '#5d4037',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100 A200',
	    'contrastStrongLightColors': '300 400'
	  },
	  'grey': {
	    '50': '#fafafa',
	    '100': '#f5f5f5',
	    '200': '#eeeeee',
	    '300': '#e0e0e0',
	    '400': '#bdbdbd',
	    '500': '#9e9e9e',
	    '600': '#757575',
	    '700': '#616161',
	    '800': '#424242',
	    '900': '#212121',
	    'A100': '#ffffff',
	    'A200': '#000000',
	    'A400': '#303030',
	    'A700': '#616161',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A200 A400 A700'
	  },
	  'blue-grey': {
	    '50': '#eceff1',
	    '100': '#cfd8dc',
	    '200': '#b0bec5',
	    '300': '#90a4ae',
	    '400': '#78909c',
	    '500': '#607d8b',
	    '600': '#546e7a',
	    '700': '#455a64',
	    '800': '#37474f',
	    '900': '#263238',
	    'A100': '#cfd8dc',
	    'A200': '#b0bec5',
	    'A400': '#78909c',
	    'A700': '#455a64',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100 A200',
	    'contrastStrongLightColors': '400 500 700'
	  }
	});
	
	})();
	(function(){
	"use strict";
	
	(function(angular) {
	  'use strict';
	/**
	 * @ngdoc module
	 * @name material.core.theming
	 * @description
	 * Theming
	 */
	detectDisabledThemes.$inject = ["$mdThemingProvider"];
	ThemingDirective.$inject = ["$mdTheming", "$interpolate", "$log"];
	ThemableDirective.$inject = ["$mdTheming"];
	ThemingProvider.$inject = ["$mdColorPalette", "$$mdMetaProvider"];
	generateAllThemes.$inject = ["$injector", "$mdTheming"];
	angular.module('material.core.theming', ['material.core.theming.palette', 'material.core.meta'])
	  .directive('mdTheme', ThemingDirective)
	  .directive('mdThemable', ThemableDirective)
	  .directive('mdThemesDisabled', disableThemesDirective )
	  .provider('$mdTheming', ThemingProvider)
	  .config( detectDisabledThemes )
	  .run(generateAllThemes);
	
	/**
	 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
	 * If yes, then immediately disable all theme stylesheet generation and DOM injection
	 */
	/**
	 * @ngInject
	 */
	function detectDisabledThemes($mdThemingProvider) {
	  var isDisabled = !!document.querySelector('[md-themes-disabled]');
	  $mdThemingProvider.disableTheming(isDisabled);
	}
	
	/**
	 * @ngdoc service
	 * @name $mdThemingProvider
	 * @module material.core.theming
	 *
	 * @description Provider to configure the `$mdTheming` service.
	 *
	 * ### Default Theme
	 * The `$mdThemingProvider` uses by default the following theme configuration:
	 *
	 * - Primary Palette: `Primary`
	 * - Accent Palette: `Pink`
	 * - Warn Palette: `Deep-Orange`
	 * - Background Palette: `Grey`
	 *
	 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
	 * the default theme.<br/>
	 * This can be done by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     $mdThemingProvider
	 *       .theme('default')
	 *       .primaryPalette('blue')
	 *       .accentPalette('teal')
	 *       .warnPalette('red')
	 *       .backgroundPalette('grey');
	 *   });
	 * </hljs>
	 *
	
	 * ### Dynamic Themes
	 *
	 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
	 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable theme watching.
	 *     $mdThemingProvider.alwaysWatchTheme(true);
	 *   });
	 * </hljs>
	 *
	 * ### Custom Theme Styles
	 *
	 * Sometimes you may want to use your own theme styles for some custom components.<br/>
	 * You are able to register your own styles by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register our custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(STYLESHEET);
	 *   });
	 * </hljs>
	 *
	 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
	 * stylesheet file into the `$mdThemingProvider`.
	 *
	 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
	 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register your custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
	 *   });
	 * </hljs>
	 *
	 * ### Browser color
	 *
	 * Enables browser header coloring
	 * for more info please visit:
	 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	 *
	 * Options parameter: <br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable browser color
	 *     $mdThemingProvider.enableBrowserColor({
	 *       theme: 'myTheme', // Default is 'default'
	 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
	 *       hue: '200' // Default is '800'
	 *     });
	 *   });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#registerStyles
	 * @param {string} styles The styles to be appended to Angular Material's built in theme css.
	 */
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#setNonce
	 * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
	 * Setting a value allows the use of CSP policy without using the unsafe-inline directive.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#setDefaultTheme
	 * @param {string} themeName Default theme name to be applied to elements. Default value is `default`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#alwaysWatchTheme
	 * @param {boolean} watch Whether or not to always watch themes for changes and re-apply
	 * classes when they change. Default is `false`. Enabling can reduce performance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#enableBrowserColor
	 * @param {Object=} options Options object for the browser color<br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 * @returns {Function} remove function of the browser color
	 */
	
	/* Some Example Valid Theming Expressions
	 * =======================================
	 *
	 * Intention group expansion: (valid for primary, accent, warn, background)
	 *
	 * {{primary-100}} - grab shade 100 from the primary palette
	 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
	 * {{primary-100-contrast}} - grab shade 100's contrast color
	 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
	 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
	 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
	 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
	 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
	 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
	 *
	 * Foreground expansion: Applies rgba to black/white foreground text
	 *
	 * {{foreground-1}} - used for primary text
	 * {{foreground-2}} - used for secondary text/divider
	 * {{foreground-3}} - used for disabled text
	 * {{foreground-4}} - used for dividers
	 *
	 */
	
	// In memory generated CSS rules; registered by theme.name
	var GENERATED = { };
	
	// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
	var PALETTES;
	
	// Text Colors on light and dark backgrounds
	// @see https://www.google.com/design/spec/style/color.html#color-text-background-colors
	var DARK_FOREGROUND = {
	  name: 'dark',
	  '1': 'rgba(0,0,0,0.87)',
	  '2': 'rgba(0,0,0,0.54)',
	  '3': 'rgba(0,0,0,0.38)',
	  '4': 'rgba(0,0,0,0.12)'
	};
	var LIGHT_FOREGROUND = {
	  name: 'light',
	  '1': 'rgba(255,255,255,1.0)',
	  '2': 'rgba(255,255,255,0.7)',
	  '3': 'rgba(255,255,255,0.5)',
	  '4': 'rgba(255,255,255,0.12)'
	};
	
	var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
	var LIGHT_SHADOW = '';
	
	var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
	var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
	var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');
	
	var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
	var DEFAULT_COLOR_TYPE = 'primary';
	
	// A color in a theme will use these hues by default, if not specified by user.
	var LIGHT_DEFAULT_HUES = {
	  'accent': {
	    'default': 'A200',
	    'hue-1': 'A100',
	    'hue-2': 'A400',
	    'hue-3': 'A700'
	  },
	  'background': {
	    'default': '50',
	    'hue-1': 'A100',
	    'hue-2': '100',
	    'hue-3': '300'
	  }
	};
	
	var DARK_DEFAULT_HUES = {
	  'background': {
	    'default': 'A400',
	    'hue-1': '800',
	    'hue-2': '900',
	    'hue-3': 'A200'
	  }
	};
	THEME_COLOR_TYPES.forEach(function(colorType) {
	  // Color types with unspecified default hues will use these default hue values
	  var defaultDefaultHues = {
	    'default': '500',
	    'hue-1': '300',
	    'hue-2': '800',
	    'hue-3': 'A100'
	  };
	  if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
	  if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
	});
	
	var VALID_HUE_VALUES = [
	  '50', '100', '200', '300', '400', '500', '600',
	  '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
	];
	
	var themeConfig = {
	  disableTheming : false,   // Generate our themes at run time; also disable stylesheet DOM injection
	  generateOnDemand : false, // Whether or not themes are to be generated on-demand (vs. eagerly).
	  registeredStyles : [],    // Custom styles registered to be used in the theming of custom components.
	  nonce : null              // Nonce to be added as an attribute to the generated themes style tags.
	};
	
	/**
	 *
	 */
	function ThemingProvider($mdColorPalette, $$mdMetaProvider) {
	  ThemingService.$inject = ["$rootScope", "$log"];
	  PALETTES = { };
	  var THEMES = { };
	
	  var themingProvider;
	
	  var alwaysWatchTheme = false;
	  var defaultTheme = 'default';
	
	  // Load JS Defined Palettes
	  angular.extend(PALETTES, $mdColorPalette);
	
	  // Default theme defined in core.js
	
	  /**
	   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
	   * @param {string} color Hex value of the wanted browser color
	   * @returns {Function} Remove function of the meta tags
	   */
	  var setBrowserColor = function (color) {
	    // Chrome, Firefox OS and Opera
	    var removeChrome = $$mdMetaProvider.setMeta('theme-color', color);
	    // Windows Phone
	    var removeWindows = $$mdMetaProvider.setMeta('msapplication-navbutton-color', color);
	
	    return function () {
	      removeChrome();
	      removeWindows();
	    }
	  };
	
	  /**
	   * Enables browser header coloring
	   * for more info please visit:
	   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	   *
	   * The default color is `800` from `primary` palette of the `default` theme
	   *
	   * options are:
	   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme
	   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	   *             'accent', 'background' and 'warn'. Default is `primary`
	   * `hue`     - The hue from the selected palette. Default is `800`
	   *
	   * @param {Object=} options Options object for the browser color
	   * @returns {Function} remove function of the browser color
	   */
	  var enableBrowserColor = function (options) {
	    options = angular.isObject(options) ? options : {};
	
	    var theme = options.theme || 'default';
	    var hue = options.hue || '800';
	
	    var palette = PALETTES[options.palette] ||
	      PALETTES[THEMES[theme].colors[options.palette || 'primary'].name];
	
	    var color = angular.isObject(palette[hue]) ? palette[hue].hex : palette[hue];
	
	    return setBrowserColor(color);
	  };
	
	  return themingProvider = {
	    definePalette: definePalette,
	    extendPalette: extendPalette,
	    theme: registerTheme,
	
	    /**
	     * return a read-only clone of the current theme configuration
	     */
	    configuration : function() {
	      return angular.extend( { }, themeConfig, {
	        defaultTheme : defaultTheme,
	        alwaysWatchTheme : alwaysWatchTheme,
	        registeredStyles : [].concat(themeConfig.registeredStyles)
	      });
	    },
	
	    /**
	     * Easy way to disable theming without having to use
	     * `.constant("$MD_THEME_CSS","");` This disables
	     * all dynamic theme style sheet generations and injections...
	     */
	    disableTheming: function(isDisabled) {
	      themeConfig.disableTheming = angular.isUndefined(isDisabled) || !!isDisabled;
	    },
	
	    registerStyles: function(styles) {
	      themeConfig.registeredStyles.push(styles);
	    },
	
	    setNonce: function(nonceValue) {
	      themeConfig.nonce = nonceValue;
	    },
	
	    generateThemesOnDemand: function(onDemand) {
	      themeConfig.generateOnDemand = onDemand;
	    },
	
	    setDefaultTheme: function(theme) {
	      defaultTheme = theme;
	    },
	
	    alwaysWatchTheme: function(alwaysWatch) {
	      alwaysWatchTheme = alwaysWatch;
	    },
	
	    enableBrowserColor: enableBrowserColor,
	
	    $get: ThemingService,
	    _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
	    _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
	    _PALETTES: PALETTES,
	    _THEMES: THEMES,
	    _parseRules: parseRules,
	    _rgba: rgba
	  };
	
	  // Example: $mdThemingProvider.definePalette('neonRed', { 50: '#f5fafa', ... });
	  function definePalette(name, map) {
	    map = map || {};
	    PALETTES[name] = checkPaletteValid(name, map);
	    return themingProvider;
	  }
	
	  // Returns an new object which is a copy of a given palette `name` with variables from
	  // `map` overwritten
	  // Example: var neonRedMap = $mdThemingProvider.extendPalette('red', { 50: '#f5fafafa' });
	  function extendPalette(name, map) {
	    return checkPaletteValid(name,  angular.extend({}, PALETTES[name] || {}, map) );
	  }
	
	  // Make sure that palette has all required hues
	  function checkPaletteValid(name, map) {
	    var missingColors = VALID_HUE_VALUES.filter(function(field) {
	      return !map[field];
	    });
	    if (missingColors.length) {
	      throw new Error("Missing colors %1 in palette %2!"
	                      .replace('%1', missingColors.join(', '))
	                      .replace('%2', name));
	    }
	
	    return map;
	  }
	
	  // Register a theme (which is a collection of color palettes to use with various states
	  // ie. warn, accent, primary )
	  // Optionally inherit from an existing theme
	  // $mdThemingProvider.theme('custom-theme').primaryPalette('red');
	  function registerTheme(name, inheritFrom) {
	    if (THEMES[name]) return THEMES[name];
	
	    inheritFrom = inheritFrom || 'default';
	
	    var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
	    var theme = new Theme(name);
	
	    if (parentTheme) {
	      angular.forEach(parentTheme.colors, function(color, colorType) {
	        theme.colors[colorType] = {
	          name: color.name,
	          // Make sure a COPY of the hues is given to the child color,
	          // not the same reference.
	          hues: angular.extend({}, color.hues)
	        };
	      });
	    }
	    THEMES[name] = theme;
	
	    return theme;
	  }
	
	  function Theme(name) {
	    var self = this;
	    self.name = name;
	    self.colors = {};
	
	    self.dark = setDark;
	    setDark(false);
	
	    function setDark(isDark) {
	      isDark = arguments.length === 0 ? true : !!isDark;
	
	      // If no change, abort
	      if (isDark === self.isDark) return;
	
	      self.isDark = isDark;
	
	      self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
	      self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;
	
	      // Light and dark themes have different default hues.
	      // Go through each existing color type for this theme, and for every
	      // hue value that is still the default hue value from the previous light/dark setting,
	      // set it to the default hue value from the new light/dark setting.
	      var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
	      var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
	      angular.forEach(newDefaultHues, function(newDefaults, colorType) {
	        var color = self.colors[colorType];
	        var oldDefaults = oldDefaultHues[colorType];
	        if (color) {
	          for (var hueName in color.hues) {
	            if (color.hues[hueName] === oldDefaults[hueName]) {
	              color.hues[hueName] = newDefaults[hueName];
	            }
	          }
	        }
	      });
	
	      return self;
	    }
	
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
	      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
	        var color = self.colors[colorType] = {
	          name: paletteName,
	          hues: angular.extend({}, defaultHues, hues)
	        };
	
	        Object.keys(color.hues).forEach(function(name) {
	          if (!defaultHues[name]) {
	            throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
	              .replace('%1', name)
	              .replace('%2', self.name)
	              .replace('%3', paletteName)
	              .replace('%4', Object.keys(defaultHues).join(', '))
	            );
	          }
	        });
	        Object.keys(color.hues).map(function(key) {
	          return color.hues[key];
	        }).forEach(function(hueValue) {
	          if (VALID_HUE_VALUES.indexOf(hueValue) == -1) {
	            throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
	              .replace('%1', hueValue)
	              .replace('%2', self.name)
	              .replace('%3', colorType)
	              .replace('%4', paletteName)
	              .replace('%5', VALID_HUE_VALUES.join(', '))
	            );
	          }
	        });
	        return self;
	      };
	
	      self[colorType + 'Color'] = function() {
	        var args = Array.prototype.slice.call(arguments);
	        console.warn('$mdThemingProviderTheme.' + colorType + 'Color() has been deprecated. ' +
	                     'Use $mdThemingProviderTheme.' + colorType + 'Palette() instead.');
	        return self[colorType + 'Palette'].apply(self, args);
	      };
	    });
	  }
	
	  /**
	   * @ngdoc service
	   * @name $mdTheming
	   *
	   * @description
	   *
	   * Service that makes an element apply theming related classes to itself.
	   *
	   * ```js
	   * app.directive('myFancyDirective', function($mdTheming) {
	   *   return {
	   *     restrict: 'e',
	   *     link: function(scope, el, attrs) {
	   *       $mdTheming(el);
	   *     }
	   *   };
	   * });
	   * ```
	   * @param {el=} element to apply theming to
	   */
	  /* @ngInject */
	  function ThemingService($rootScope, $log) {
	        // Allow us to be invoked via a linking function signature.
	    var applyTheme = function (scope, el) {
	          if (el === undefined) { el = scope; scope = undefined; }
	          if (scope === undefined) { scope = $rootScope; }
	          applyTheme.inherit(el, el);
	        };
	
	    applyTheme.THEMES = angular.extend({}, THEMES);
	    applyTheme.PALETTES = angular.extend({}, PALETTES);
	    applyTheme.inherit = inheritTheme;
	    applyTheme.registered = registered;
	    applyTheme.defaultTheme = function() { return defaultTheme; };
	    applyTheme.generateTheme = function(name) { generateTheme(THEMES[name], name, themeConfig.nonce); };
	    applyTheme.setBrowserColor = enableBrowserColor;
	
	    return applyTheme;
	
	    /**
	     * Determine is specified theme name is a valid, registered theme
	     */
	    function registered(themeName) {
	      if (themeName === undefined || themeName === '') return true;
	      return applyTheme.THEMES[themeName] !== undefined;
	    }
	
	    /**
	     * Get theme name for the element, then update with Theme CSS class
	     */
	    function inheritTheme (el, parent) {
	      var ctrl = parent.controller('mdTheme');
	      var attrThemeValue = el.attr('md-theme-watch');
	      var watchTheme = (alwaysWatchTheme || angular.isDefined(attrThemeValue)) && attrThemeValue != 'false';
	
	      updateThemeClass(lookupThemeName());
	
	      if ((alwaysWatchTheme && !registerChangeCallback()) || (!alwaysWatchTheme && watchTheme)) {
	        el.on('$destroy', $rootScope.$watch(lookupThemeName, updateThemeClass) );
	      }
	
	      /**
	       * Find the theme name from the parent controller or element data
	       */
	      function lookupThemeName() {
	        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
	        ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');
	        return ctrl && ctrl.$mdTheme || (defaultTheme == 'default' ? '' : defaultTheme);
	      }
	
	      /**
	       * Remove old theme class and apply a new one
	       * NOTE: if not a valid theme name, then the current name is not changed
	       */
	      function updateThemeClass(theme) {
	        if (!theme) return;
	        if (!registered(theme)) {
	          $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
	                    'Register it with $mdThemingProvider.theme().');
	        }
	
	        var oldTheme = el.data('$mdThemeName');
	        if (oldTheme) el.removeClass('md-' + oldTheme +'-theme');
	        el.addClass('md-' + theme + '-theme');
	        el.data('$mdThemeName', theme);
	        if (ctrl) {
	          el.data('$mdThemeController', ctrl);
	        }
	      }
	
	      /**
	       * Register change callback with parent mdTheme controller
	       */
	      function registerChangeCallback() {
	        var parentController = parent.controller('mdTheme');
	        if (!parentController) return false;
	        el.on('$destroy', parentController.registerChanges( function() {
	          updateThemeClass(lookupThemeName());
	        }));
	        return true;
	      }
	    }
	
	  }
	}
	
	function ThemingDirective($mdTheming, $interpolate, $log) {
	  return {
	    priority: 100,
	    link: {
	      pre: function(scope, el, attrs) {
	        var registeredCallbacks = [];
	        var ctrl = {
	          registerChanges: function (cb, context) {
	            if (context) {
	              cb = angular.bind(context, cb);
	            }
	
	            registeredCallbacks.push(cb);
	
	            return function () {
	              var index = registeredCallbacks.indexOf(cb);
	
	              if (index > -1) {
	                registeredCallbacks.splice(index, 1);
	              }
	            };
	          },
	          $setTheme: function (theme) {
	            if (!$mdTheming.registered(theme)) {
	              $log.warn('attempted to use unregistered theme \'' + theme + '\'');
	            }
	            ctrl.$mdTheme = theme;
	
	            registeredCallbacks.forEach(function (cb) {
	              cb();
	            });
	          }
	        };
	        el.data('$mdThemeController', ctrl);
	        ctrl.$setTheme($interpolate(attrs.mdTheme)(scope));
	        attrs.$observe('mdTheme', ctrl.$setTheme);
	      }
	    }
	  };
	}
	
	/**
	 * Special directive that will disable ALL runtime Theme style generation and DOM injection
	 *
	 * <link rel="stylesheet" href="angular-material.min.css">
	 * <link rel="stylesheet" href="angular-material.themes.css">
	 *
	 * <body md-themes-disabled>
	 *  ...
	 * </body>
	 *
	 * Note: Using md-themes-css directive requires the developer to load external
	 * theme stylesheets; e.g. custom themes from Material-Tools:
	 *
	 *       `angular-material.themes.css`
	 *
	 * Another option is to use the ThemingProvider to configure and disable the attribute
	 * conversions; this would obviate the use of the `md-themes-css` directive
	 *
	 */
	function disableThemesDirective() {
	  themeConfig.disableTheming = true;
	
	  // Return a 1x-only, first-match attribute directive
	  return {
	    restrict : 'A',
	    priority : '900'
	  };
	}
	
	function ThemableDirective($mdTheming) {
	  return $mdTheming;
	}
	
	function parseRules(theme, colorType, rules) {
	  checkValidPalette(theme, colorType);
	
	  rules = rules.replace(/THEME_NAME/g, theme.name);
	  var generatedRules = [];
	  var color = theme.colors[colorType];
	
	  var themeNameRegex = new RegExp('\\.md-' + theme.name + '-theme', 'g');
	  // Matches '{{ primary-color }}', etc
	  var hueRegex = new RegExp('(\'|")?{{\\s*(' + colorType + ')-(color|contrast)-?(\\d\\.?\\d*)?\\s*}}(\"|\')?','g');
	  var simpleVariableRegex = /'?"?\{\{\s*([a-zA-Z]+)-(A?\d+|hue\-[0-3]|shadow|default)-?(\d\.?\d*)?(contrast)?\s*\}\}'?"?/g;
	  var palette = PALETTES[color.name];
	
	  // find and replace simple variables where we use a specific hue, not an entire palette
	  // eg. "{{primary-100}}"
	  //\(' + THEME_COLOR_TYPES.join('\|') + '\)'
	  rules = rules.replace(simpleVariableRegex, function(match, colorType, hue, opacity, contrast) {
	    if (colorType === 'foreground') {
	      if (hue == 'shadow') {
	        return theme.foregroundShadow;
	      } else {
	        return theme.foregroundPalette[hue] || theme.foregroundPalette['1'];
	      }
	    }
	
	    // `default` is also accepted as a hue-value, because the background palettes are
	    // using it as a name for the default hue.
	    if (hue.indexOf('hue') === 0 || hue === 'default') {
	      hue = theme.colors[colorType].hues[hue];
	    }
	
	    return rgba( (PALETTES[ theme.colors[colorType].name ][hue] || '')[contrast ? 'contrast' : 'value'], opacity );
	  });
	
	  // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
	  angular.forEach(color.hues, function(hueValue, hueName) {
	    var newRule = rules
	      .replace(hueRegex, function(match, _, colorType, hueType, opacity) {
	        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
	      });
	    if (hueName !== 'default') {
	      newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
	    }
	
	    // Don't apply a selector rule to the default theme, making it easier to override
	    // styles of the base-component
	    if (theme.name == 'default') {
	      var themeRuleRegex = /((?:(?:(?: |>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)+) )?)((?:(?:\w|\.|-)+)?)\.md-default-theme((?: |>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)/g;
	      newRule = newRule.replace(themeRuleRegex, function(match, prefix, target, suffix) {
	        return match + ', ' + prefix + target + suffix;
	      });
	    }
	    generatedRules.push(newRule);
	  });
	
	  return generatedRules;
	}
	
	var rulesByType = {};
	
	// Generate our themes at run time given the state of THEMES and PALETTES
	function generateAllThemes($injector, $mdTheming) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	  var themeCss = !themeConfig.disableTheming && $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';
	
	  // Append our custom registered styles to the theme stylesheet.
	  themeCss += themeConfig.registeredStyles.join('');
	
	  if ( !firstChild ) return;
	  if (themeCss.length === 0) return; // no rules, so no point in running this expensive task
	
	  // Expose contrast colors for palettes to ensure that text is always readable
	  angular.forEach(PALETTES, sanitizePalette);
	
	  // MD_THEME_CSS is a string generated by the build process that includes all the themable
	  // components as templates
	
	  // Break the CSS into individual rules
	  var rules = themeCss
	                  .split(/\}(?!(\}|'|"|;))/)
	                  .filter(function(rule) { return rule && rule.trim().length; })
	                  .map(function(rule) { return rule.trim() + '}'; });
	
	
	  var ruleMatchRegex = new RegExp('md-(' + THEME_COLOR_TYPES.join('|') + ')', 'g');
	
	  THEME_COLOR_TYPES.forEach(function(type) {
	    rulesByType[type] = '';
	  });
	
	
	  // Sort the rules based on type, allowing us to do color substitution on a per-type basis
	  rules.forEach(function(rule) {
	    var match = rule.match(ruleMatchRegex);
	    // First: test that if the rule has '.md-accent', it goes into the accent set of rules
	    for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf('.md-' + type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
	    // there
	    for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf(type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // Default to the primary array
	    return rulesByType[DEFAULT_COLOR_TYPE] += rule;
	  });
	
	  // If themes are being generated on-demand, quit here. The user will later manually
	  // call generateTheme to do this on a theme-by-theme basis.
	  if (themeConfig.generateOnDemand) return;
	
	  angular.forEach($mdTheming.THEMES, function(theme) {
	    if (!GENERATED[theme.name] && !($mdTheming.defaultTheme() !== 'default' && theme.name === 'default')) {
	      generateTheme(theme, theme.name, themeConfig.nonce);
	    }
	  });
	
	
	  // *************************
	  // Internal functions
	  // *************************
	
	  // The user specifies a 'default' contrast color as either light or dark,
	  // then explicitly lists which hues are the opposite contrast (eg. A100 has dark, A200 has light)
	  function sanitizePalette(palette, name) {
	    var defaultContrast = palette.contrastDefaultColor;
	    var lightColors = palette.contrastLightColors || [];
	    var strongLightColors = palette.contrastStrongLightColors || [];
	    var darkColors = palette.contrastDarkColors || [];
	
	    // These colors are provided as space-separated lists
	    if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
	    if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
	    if (typeof darkColors === 'string') darkColors = darkColors.split(' ');
	
	    // Cleanup after ourselves
	    delete palette.contrastDefaultColor;
	    delete palette.contrastLightColors;
	    delete palette.contrastStrongLightColors;
	    delete palette.contrastDarkColors;
	
	    // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
	    angular.forEach(palette, function(hueValue, hueName) {
	      if (angular.isObject(hueValue)) return; // Already converted
	      // Map everything to rgb colors
	      var rgbValue = colorToRgbaArray(hueValue);
	      if (!rgbValue) {
	        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
	                        .replace('%1', hueValue)
	                        .replace('%2', palette.name)
	                        .replace('%3', hueName));
	      }
	
	      palette[hueName] = {
	        hex: palette[hueName],
	        value: rgbValue,
	        contrast: getContrastColor()
	      };
	      function getContrastColor() {
	        if (defaultContrast === 'light') {
	          if (darkColors.indexOf(hueName) > -1) {
	            return DARK_CONTRAST_COLOR;
	          } else {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          }
	        } else {
	          if (lightColors.indexOf(hueName) > -1) {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          } else {
	            return DARK_CONTRAST_COLOR;
	          }
	        }
	      }
	    });
	  }
	}
	
	function generateTheme(theme, name, nonce) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	
	  if (!GENERATED[name]) {
	    // For each theme, use the color palettes specified for
	    // `primary`, `warn` and `accent` to generate CSS rules.
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
	      while (styleStrings.length) {
	        var styleContent = styleStrings.shift();
	        if (styleContent) {
	          var style = document.createElement('style');
	          style.setAttribute('md-theme-style', '');
	          if (nonce) {
	            style.setAttribute('nonce', nonce);
	          }
	          style.appendChild(document.createTextNode(styleContent));
	          head.insertBefore(style, firstChild);
	        }
	      }
	    });
	
	    GENERATED[theme.name] = true;
	  }
	
	}
	
	
	function checkValidPalette(theme, colorType) {
	  // If theme attempts to use a palette that doesnt exist, throw error
	  if (!PALETTES[ (theme.colors[colorType] || {}).name ]) {
	    throw new Error(
	      "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
	                    .replace('%1', theme.name)
	                    .replace('%2', colorType)
	                    .replace('%3', Object.keys(PALETTES).join(', '))
	    );
	  }
	}
	
	function colorToRgbaArray(clr) {
	  if (angular.isArray(clr) && clr.length == 3) return clr;
	  if (/^rgb/.test(clr)) {
	    return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
	      return i == 3 ? parseFloat(value, 10) : parseInt(value, 10);
	    });
	  }
	  if (clr.charAt(0) == '#') clr = clr.substring(1);
	  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;
	
	  var dig = clr.length / 3;
	  var red = clr.substr(0, dig);
	  var grn = clr.substr(dig, dig);
	  var blu = clr.substr(dig * 2);
	  if (dig === 1) {
	    red += red;
	    grn += grn;
	    blu += blu;
	  }
	  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
	}
	
	function rgba(rgbArray, opacity) {
	  if ( !rgbArray ) return "rgb('0,0,0')";
	
	  if (rgbArray.length == 4) {
	    rgbArray = angular.copy(rgbArray);
	    opacity ? rgbArray.pop() : opacity = rgbArray.pop();
	  }
	  return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
	    'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
	    'rgb(' + rgbArray.join(',') + ')';
	}
	
	
	})(window.angular);
	
	})();
	(function(){
	"use strict";
	
	// Polyfill angular < 1.4 (provide $animateCss)
	angular
	  .module('material.core')
	  .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function($q, $timeout, $mdConstant, $animateCss){
	
	     // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
	     // to subsequently inject $mdUtil as an argument to the AnimateDomUtils
	
	     return function($mdUtil) {
	       return AnimateDomUtils( $mdUtil, $q, $timeout, $mdConstant, $animateCss);
	     };
	   }]);
	
	/**
	 * Factory function that requires special injections
	 */
	function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
	  var self;
	  return self = {
	    /**
	     *
	     */
	    translate3d : function( target, from, to, options ) {
	      return $animateCss(target,{
	        from:from,
	        to:to,
	        addClass:options.transitionInClass,
	        removeClass:options.transitionOutClass
	      })
	      .start()
	      .then(function(){
	          // Resolve with reverser function...
	          return reverseTranslate;
	      });
	
	      /**
	       * Specific reversal of the request translate animation above...
	       */
	      function reverseTranslate (newFrom) {
	        return $animateCss(target, {
	           to: newFrom || from,
	           addClass: options.transitionOutClass,
	           removeClass: options.transitionInClass
	        }).start();
	
	      }
	    },
	
	    /**
	     * Listen for transitionEnd event (with optional timeout)
	     * Announce completion or failure via promise handlers
	     */
	    waitTransitionEnd: function (element, opts) {
	      var TIMEOUT = 3000; // fallback is 3 secs
	
	      return $q(function(resolve, reject){
	        opts = opts || { };
	
	        // If there is no transition is found, resolve immediately
	        //
	        // NOTE: using $mdUtil.nextTick() causes delays/issues
	        if (noTransitionFound(opts.cachedTransitionStyles)) {
	          TIMEOUT = 0;
	        }
	
	        var timer = $timeout(finished, opts.timeout || TIMEOUT);
	        element.on($mdConstant.CSS.TRANSITIONEND, finished);
	
	        /**
	         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
	         * NOTE: Make sure this transitionEnd didn't bubble up from a child
	         */
	        function finished(ev) {
	          if ( ev && ev.target !== element[0]) return;
	
	          if ( ev  ) $timeout.cancel(timer);
	          element.off($mdConstant.CSS.TRANSITIONEND, finished);
	
	          // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
	          resolve();
	
	        }
	
	        /**
	         * Checks whether or not there is a transition.
	         *
	         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
	         * will be used.
	         *
	         * @returns {boolean} True if there is no transition/duration; false otherwise.
	         */
	        function noTransitionFound(styles) {
	          styles = styles || window.getComputedStyle(element[0]);
	
	          return styles.transitionDuration == '0s' || (!styles.transition && !styles.transitionProperty);
	        }
	
	      });
	    },
	
	    calculateTransformValues: function (element, originator) {
	      var origin = originator.element;
	      var bounds = originator.bounds;
	
	      if (origin || bounds) {
	        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
	        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
	        var dialogCenterPt = self.centerPointFor(dialogRect);
	        var originCenterPt = self.centerPointFor(originBnds);
	
	        return {
	          centerX: originCenterPt.x - dialogCenterPt.x,
	          centerY: originCenterPt.y - dialogCenterPt.y,
	          scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
	          scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
	        };
	      }
	      return {centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5};
	
	      /**
	       * This is a fallback if the origin information is no longer valid, then the
	       * origin bounds simply becomes the current bounds for the dialogContainer's parent
	       */
	      function currentBounds() {
	        var cntr = element ? element.parent() : null;
	        var parent = cntr ? cntr.parent() : null;
	
	        return parent ? self.clientRect(parent) : null;
	      }
	    },
	
	    /**
	     * Calculate the zoom transform from dialog to origin.
	     *
	     * We use this to set the dialog position immediately;
	     * then the md-transition-in actually translates back to
	     * `translate3d(0,0,0) scale(1.0)`...
	     *
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateZoomToOrigin: function (element, originator) {
	      var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
	      var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);
	
	      return buildZoom(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Calculate the slide transform from panel to origin.
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateSlideToOrigin: function (element, originator) {
	      var slideTemplate = "translate3d( {centerX}px, {centerY}px, 0 )";
	      var buildSlide = angular.bind(null, $mdUtil.supplant, slideTemplate);
	
	      return buildSlide(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Enhance raw values to represent valid css stylings...
	     */
	    toCss : function( raw ) {
	      var css = { };
	      var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';
	
	      angular.forEach(raw, function(value,key) {
	        if ( angular.isUndefined(value) ) return;
	
	        if ( lookups.indexOf(key) >= 0 ) {
	          css[key] = value + 'px';
	        } else {
	          switch (key) {
	            case 'transition':
	              convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
	              break;
	            case 'transform':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
	              break;
	            case 'transformOrigin':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
	              break;
	            case 'font-size':
	              css['font-size'] = value; // font sizes aren't always in px
	              break;
	          }
	        }
	      });
	
	      return css;
	
	      function convertToVendor(key, vendor, value) {
	        angular.forEach(vendor.split(' '), function (key) {
	          css[key] = value;
	        });
	      }
	    },
	
	    /**
	     * Convert the translate CSS value to key/value pair(s).
	     */
	    toTransformCss: function (transform, addTransition, transition) {
	      var css = {};
	      angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
	        css[key] = transform;
	      });
	
	      if (addTransition) {
	        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
	        css.transition = transition;
	      }
	
	      return css;
	    },
	
	    /**
	     *  Clone the Rect and calculate the height/width if needed
	     */
	    copyRect: function (source, destination) {
	      if (!source) return null;
	
	      destination = destination || {};
	
	      angular.forEach('left top right bottom width height'.split(' '), function (key) {
	        destination[key] = Math.round(source[key]);
	      });
	
	      destination.width = destination.width || (destination.right - destination.left);
	      destination.height = destination.height || (destination.bottom - destination.top);
	
	      return destination;
	    },
	
	    /**
	     * Calculate ClientRect of element; return null if hidden or zero size
	     */
	    clientRect: function (element) {
	      var bounds = angular.element(element)[0].getBoundingClientRect();
	      var isPositiveSizeClientRect = function (rect) {
	        return rect && (rect.width > 0) && (rect.height > 0);
	      };
	
	      // If the event origin element has zero size, it has probably been hidden.
	      return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
	    },
	
	    /**
	     *  Calculate 'rounded' center point of Rect
	     */
	    centerPointFor: function (targetRect) {
	      return targetRect ? {
	        x: Math.round(targetRect.left + (targetRect.width / 2)),
	        y: Math.round(targetRect.top + (targetRect.height / 2))
	      } : { x : 0, y : 0 };
	    }
	
	  };
	}
	
	
	})();
	(function(){
	"use strict";
	
	"use strict";
	
	if (angular.version.minor >= 4) {
	  angular.module('material.core.animate', []);
	} else {
	(function() {
	
	  var forEach = angular.forEach;
	
	  var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
	  var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
	  var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
	  var PREFIX = WEBKIT ? '-webkit-' : '';
	
	  var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
	  var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';
	
	  var $$ForceReflowFactory = ['$document', function($document) {
	    return function() {
	      return $document[0].body.clientWidth + 1;
	    }
	  }];
	
	  var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
	    return function() {
	      var passed = false;
	      $$rAF(function() {
	        passed = true;
	      });
	      return function(fn) {
	        passed ? fn() : $$rAF(fn);
	      };
	    };
	  }];
	
	  var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      this._doneCallbacks = [];
	      this._runInAnimationFrame = $$rAFMutex();
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: angular.noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._runInAnimationFrame(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    // Polyfill AnimateRunner.all which is used by input animations
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	
	  angular
	    .module('material.core.animate', [])
	    .factory('$$forceReflow', $$ForceReflowFactory)
	    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
	    .factory('$$rAFMutex', $$rAFMutexFactory)
	    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout', '$animate',
	                     function($window,   $$rAF,   $$AnimateRunner,   $$forceReflow,   $$jqLite,   $timeout, $animate) {
	
	      function init(element, options) {
	
	        var temporaryStyles = [];
	        var node = getDomNode(element);
	        var areAnimationsAllowed = node && $animate.enabled();
	
	        var hasCompleteStyles = false;
	        var hasCompleteClasses = false;
	
	        if (areAnimationsAllowed) {
	          if (options.transitionStyle) {
	            temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
	          }
	
	          if (options.keyframeStyle) {
	            temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
	          }
	
	          if (options.delay) {
	            temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
	          }
	
	          if (options.duration) {
	            temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
	          }
	
	          hasCompleteStyles = options.keyframeStyle ||
	              (options.to && (options.duration > 0 || options.transitionStyle));
	          hasCompleteClasses = !!options.addClass || !!options.removeClass;
	
	          blockTransition(element, true);
	        }
	
	        var hasCompleteAnimation = areAnimationsAllowed && (hasCompleteStyles || hasCompleteClasses);
	
	        applyAnimationFromStyles(element, options);
	
	        var animationClosed = false;
	        var events, eventFn;
	
	        return {
	          close: $window.close,
	          start: function() {
	            var runner = new $$AnimateRunner();
	            waitUntilQuiet(function() {
	              blockTransition(element, false);
	              if (!hasCompleteAnimation) {
	                return close();
	              }
	
	              forEach(temporaryStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	              });
	
	              applyClasses(element, options);
	
	              var timings = computeTimings(element);
	              if (timings.duration === 0) {
	                return close();
	              }
	
	              var moreStyles = [];
	
	              if (options.easing) {
	                if (timings.transitionDuration) {
	                  moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
	                }
	                if (timings.animationDuration) {
	                  moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
	                }
	              }
	
	              if (options.delay && timings.animationDelay) {
	                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
	              }
	
	              if (options.duration && timings.animationDuration) {
	                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
	              }
	
	              forEach(moreStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	                temporaryStyles.push(entry);
	              });
	
	              var maxDelay = timings.delay;
	              var maxDelayTime = maxDelay * 1000;
	              var maxDuration = timings.duration;
	              var maxDurationTime = maxDuration * 1000;
	              var startTime = Date.now();
	
	              events = [];
	              if (timings.transitionDuration) {
	                events.push(TRANSITION_EVENTS);
	              }
	              if (timings.animationDuration) {
	                events.push(ANIMATION_EVENTS);
	              }
	              events = events.join(' ');
	              eventFn = function(event) {
	                event.stopPropagation();
	                var ev = event.originalEvent || event;
	                var timeStamp = ev.timeStamp || Date.now();
	                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
	                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	                  close();
	                }
	              };
	              element.on(events, eventFn);
	
	              applyAnimationToStyles(element, options);
	
	              $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
	            });
	
	            return runner;
	
	            function close() {
	              if (animationClosed) return;
	              animationClosed = true;
	
	              if (events && eventFn) {
	                element.off(events, eventFn);
	              }
	              applyClasses(element, options);
	              applyAnimationStyles(element, options);
	              forEach(temporaryStyles, function(entry) {
	                node.style[camelCase(entry[0])] = '';
	              });
	              runner.complete(true);
	              return runner;
	            }
	          }
	        }
	      }
	
	      function applyClasses(element, options) {
	        if (options.addClass) {
	          $$jqLite.addClass(element, options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          $$jqLite.removeClass(element, options.removeClass);
	          options.removeClass = null;
	        }
	      }
	
	      function computeTimings(element) {
	        var node = getDomNode(element);
	        var cs = $window.getComputedStyle(node)
	        var tdr = parseMaxTime(cs[prop('transitionDuration')]);
	        var adr = parseMaxTime(cs[prop('animationDuration')]);
	        var tdy = parseMaxTime(cs[prop('transitionDelay')]);
	        var ady = parseMaxTime(cs[prop('animationDelay')]);
	
	        adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
	        var duration = Math.max(adr, tdr);
	        var delay = Math.max(ady, tdy);
	
	        return {
	          duration: duration,
	          delay: delay,
	          animationDuration: adr,
	          transitionDuration: tdr,
	          animationDelay: ady,
	          transitionDelay: tdy
	        };
	
	        function prop(key) {
	          return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1)
	                        : key;
	        }
	      }
	
	      function parseMaxTime(str) {
	        var maxValue = 0;
	        var values = (str || "").split(/\s*,\s*/);
	        forEach(values, function(value) {
	          // it's always safe to consider only second values and omit `ms` values since
	          // getComputedStyle will always handle the conversion for us
	          if (value.charAt(value.length - 1) == 's') {
	            value = value.substring(0, value.length - 1);
	          }
	          value = parseFloat(value) || 0;
	          maxValue = maxValue ? Math.max(value, maxValue) : value;
	        });
	        return maxValue;
	      }
	
	      var cancelLastRAFRequest;
	      var rafWaitQueue = [];
	      function waitUntilQuiet(callback) {
	        if (cancelLastRAFRequest) {
	          cancelLastRAFRequest(); //cancels the request
	        }
	        rafWaitQueue.push(callback);
	        cancelLastRAFRequest = $$rAF(function() {
	          cancelLastRAFRequest = null;
	
	          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	          var pageWidth = $$forceReflow();
	
	          // we use a for loop to ensure that if the queue is changed
	          // during this looping then it will consider new requests
	          for (var i = 0; i < rafWaitQueue.length; i++) {
	            rafWaitQueue[i](pageWidth);
	          }
	          rafWaitQueue.length = 0;
	        });
	      }
	
	      function applyAnimationStyles(element, options) {
	        applyAnimationFromStyles(element, options);
	        applyAnimationToStyles(element, options);
	      }
	
	      function applyAnimationFromStyles(element, options) {
	        if (options.from) {
	          element.css(options.from);
	          options.from = null;
	        }
	      }
	
	      function applyAnimationToStyles(element, options) {
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	
	      function getDomNode(element) {
	        for (var i = 0; i < element.length; i++) {
	          if (element[i].nodeType === 1) return element[i];
	        }
	      }
	
	      function blockTransition(element, bool) {
	        var node = getDomNode(element);
	        var key = camelCase(PREFIX + 'transition-delay');
	        node.style[key] = bool ? '-9999s' : '';
	      }
	
	      return init;
	    }]);
	
	  /**
	   * Older browsers [FF31] expect camelCase
	   * property keys.
	   * e.g.
	   *  animation-duration --> animationDuration
	   */
	  function camelCase(str) {
	    return str.replace(/-[a-z]/g, function(str) {
	      return str.charAt(1).toUpperCase();
	    });
	  }
	
	})();
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.autocomplete
	 */
	/*
	 * @see js folder for autocomplete implementation
	 */
	angular.module('material.components.autocomplete', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	/*
	 * @ngdoc module
	 * @name material.components.backdrop
	 * @description Backdrop
	 */
	
	/**
	 * @ngdoc directive
	 * @name mdBackdrop
	 * @module material.components.backdrop
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
	 * Apply class `opaque` to make the backdrop use the theme backdrop color.
	 *
	 */
	
	angular
	  .module('material.components.backdrop', ['material.core'])
	  .directive('mdBackdrop', ["$mdTheming", "$mdUtil", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $mdUtil, $animate, $rootElement, $window, $log, $$rAF, $document) {
	    var ERROR_CSS_POSITION = '<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';
	
	    return {
	      restrict: 'E',
	      link: postLink
	    };
	
	    function postLink(scope, element, attrs) {
	      // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
	      if ($animate.pin) $animate.pin(element, $rootElement);
	
	      var bodyStyles;
	
	      $$rAF(function() {
	        // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
	        // adjust the 'backdrop' height to account for the fixed 'body' top offset.
	        // Note that this can be pretty expensive and is better done inside the $$rAF.
	        bodyStyles = $window.getComputedStyle($document[0].body);
	
	        if (bodyStyles.position === 'fixed') {
	          var resizeHandler = $mdUtil.debounce(function(){
	            bodyStyles = $window.getComputedStyle($document[0].body);
	            resize();
	          }, 60, null, false);
	
	          resize();
	          angular.element($window).on('resize', resizeHandler);
	
	          scope.$on('$destroy', function() {
	            angular.element($window).off('resize', resizeHandler);
	          });
	        }
	
	        // Often $animate.enter() is used to append the backDrop element
	        // so let's wait until $animate is done...
	        var parent = element.parent();
	
	        if (parent.length) {
	          if (parent[0].nodeName === 'BODY') {
	            element.css('position', 'fixed');
	          }
	
	          var styles = $window.getComputedStyle(parent[0]);
	
	          if (styles.position === 'static') {
	            // backdrop uses position:absolute and will not work properly with parent position:static (default)
	            $log.warn(ERROR_CSS_POSITION);
	          }
	
	          // Only inherit the parent if the backdrop has a parent.
	          $mdTheming.inherit(element, parent);
	        }
	      });
	
	      function resize() {
	        var viewportHeight = parseInt(bodyStyles.height, 10) + Math.abs(parseInt(bodyStyles.top, 10));
	        element.css('height', viewportHeight + 'px');
	      }
	    }
	
	  }]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.bottomSheet
	 * @description
	 * BottomSheet
	 */
	MdBottomSheetDirective.$inject = ["$mdBottomSheet"];
	MdBottomSheetProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.bottomSheet', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdBottomSheet', MdBottomSheetDirective)
	  .provider('$mdBottomSheet', MdBottomSheetProvider);
	
	/* @ngInject */
	function MdBottomSheetDirective($mdBottomSheet) {
	  return {
	    restrict: 'E',
	    link : function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdBottomSheet.destroy();
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $mdBottomSheet
	 * @module material.components.bottomSheet
	 *
	 * @description
	 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
	 *
	 * ## Restrictions
	 *
	 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
	 * - Add the `md-grid` class to the bottom sheet for a grid layout.
	 * - Add the `md-list` class to the bottom sheet for a list layout.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-controller="MyController">
	 *   <md-button ng-click="openBottomSheet()">
	 *     Open a Bottom Sheet!
	 *   </md-button>
	 * </div>
	 * </hljs>
	 * <hljs lang="js">
	 * var app = angular.module('app', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdBottomSheet) {
	 *   $scope.openBottomSheet = function() {
	 *     $mdBottomSheet.show({
	 *       template: '<md-bottom-sheet>Hello!</md-bottom-sheet>'
	 *     });
	 *   };
	 * });
	 * </hljs>
	 */
	
	 /**
	 * @ngdoc method
	 * @name $mdBottomSheet#show
	 *
	 * @description
	 * Show a bottom sheet with the specified options.
	 *
	 * @param {object} options An options object, with the following properties:
	 *
	 *   - `templateUrl` - `{string=}`: The url of an html template file that will
	 *   be used as the content of the bottom sheet. Restrictions: the template must
	 *   have an outer `md-bottom-sheet` element.
	 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	 *   template string.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	 *     This scope will be destroyed when the bottom sheet is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
	 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	 *   be used as names of values to inject into the controller. For example,
	 *   `locals: {three: 3}` would inject `three` into the controller with the value
	 *   of 3.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
	 *     close it. Default true.
	 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
	 *     Default true.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	 *   and the bottom sheet will not open until the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a `function`, `string`,
	 *   `object`, or null. Defaults to appending to the body of the root element (or the root element) of the application.
	 *   e.g. angular.element(document.getElementById('content')) or "#content"
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is open.
	 *     Default true.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
	 * rejected with `$mdBottomSheet.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#hide
	 *
	 * @description
	 * Hide the existing bottom sheet and resolve the promise returned from
	 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottomsheet (if any).
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#cancel
	 *
	 * @description
	 * Hide the existing bottom sheet and reject the promise returned from
	 * `$mdBottomSheet.show()`.
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 */
	
	function MdBottomSheetProvider($$interimElementProvider) {
	  // how fast we need to flick down to close the sheet, pixels/ms
	  bottomSheetDefaults.$inject = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture", "$log"];
	  var CLOSING_VELOCITY = 0.5;
	  var PADDING = 80; // same as css
	
	  return $$interimElementProvider('$mdBottomSheet')
	    .setDefaults({
	      methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
	      options: bottomSheetDefaults
	    });
	
	  /* @ngInject */
	  function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement,
	                               $mdGesture, $log) {
	    var backdrop;
	
	    return {
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      disableBackdrop: false,
	      escapeToClose: true,
	      clickOutsideToClose: true,
	      disableParentScroll: true
	    };
	
	
	    function onShow(scope, element, options, controller) {
	
	      element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');
	
	      // prevent tab focus or click focus on the bottom-sheet container
	      element.attr('tabindex',"-1");
	
	      // Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (element.hasClass('ng-cloak')) {
	        var message = '$mdBottomSheet: using `<md-bottom-sheet ng-cloak >` will affect the bottom-sheet opening animations.';
	        $log.warn( message, element[0] );
	      }
	
	      if (!options.disableBackdrop) {
	        // Add a backdrop that will close on click
	        backdrop = $mdUtil.createBackdrop(scope, "md-bottom-sheet-backdrop md-opaque");
	
	        // Prevent mouse focus on backdrop; ONLY programatic focus allowed.
	        // This allows clicks on backdrop to propogate to the $rootElement and
	        // ESC key events to be detected properly.
	        
	        backdrop[0].tabIndex = -1;
	
	        if (options.clickOutsideToClose) {
	          backdrop.on('click', function() {
	            $mdUtil.nextTick($mdBottomSheet.cancel,true);
	          });
	        }
	
	        $mdTheming.inherit(backdrop, options.parent);
	
	        $animate.enter(backdrop, options.parent, null);
	      }
	
	      var bottomSheet = new BottomSheet(element, options.parent);
	      options.bottomSheet = bottomSheet;
	
	      $mdTheming.inherit(bottomSheet.element, options.parent);
	
	      if (options.disableParentScroll) {
	        options.restoreScroll = $mdUtil.disableScrollAround(bottomSheet.element, options.parent);
	      }
	
	      return $animate.enter(bottomSheet.element, options.parent, backdrop)
	        .then(function() {
	          var focusable = $mdUtil.findFocusTarget(element) || angular.element(
	            element[0].querySelector('button') ||
	            element[0].querySelector('a') ||
	            element[0].querySelector($mdUtil.prefixer('ng-click', true))
	          ) || backdrop;
	
	          if (options.escapeToClose) {
	            options.rootElementKeyupCallback = function(e) {
	              if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	                $mdUtil.nextTick($mdBottomSheet.cancel,true);
	              }
	            };
	
	            $rootElement.on('keyup', options.rootElementKeyupCallback);
	            focusable && focusable.focus();
	          }
	        });
	
	    }
	
	    function onRemove(scope, element, options) {
	
	      var bottomSheet = options.bottomSheet;
	
	      if (!options.disableBackdrop) $animate.leave(backdrop);
	      return $animate.leave(bottomSheet.element).then(function() {
	        if (options.disableParentScroll) {
	          options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        bottomSheet.cleanup();
	      });
	    }
	
	    /**
	     * BottomSheet class to apply bottom-sheet behavior to an element
	     */
	    function BottomSheet(element, parent) {
	      var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
	      parent.on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      return {
	        element: element,
	        cleanup: function cleanup() {
	          deregister();
	          parent.off('$md.dragstart', onDragStart);
	          parent.off('$md.drag', onDrag);
	          parent.off('$md.dragend', onDragEnd);
	        }
	      };
	
	      function onDragStart(ev) {
	        // Disable transitions on transform so that it feels fast
	        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
	      }
	
	      function onDrag(ev) {
	        var transform = ev.pointer.distanceY;
	        if (transform < 5) {
	          // Slow down drag when trying to drag up, and stop after PADDING
	          transform = Math.max(-PADDING, transform / 2);
	        }
	        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
	      }
	
	      function onDragEnd(ev) {
	        if (ev.pointer.distanceY > 0 &&
	            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
	          var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
	          var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
	          element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
	          $mdUtil.nextTick($mdBottomSheet.cancel,true);
	        } else {
	          element.css($mdConstant.CSS.TRANSITION_DURATION, '');
	          element.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      }
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.button
	 * @description
	 *
	 * Button
	 */
	MdButtonDirective.$inject = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$timeout"];
	MdAnchorDirective.$inject = ["$mdTheming"];
	angular
	    .module('material.components.button', [ 'material.core' ])
	    .directive('mdButton', MdButtonDirective)
	    .directive('a', MdAnchorDirective);
	
	
	/**
	 * @private
	 * @restrict E
	 *
	 * @description
	 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 *  <md-content md-theme="myTheme">
	 *    <a href="#chapter1" class="md-accent"></a>
	 *  </md-content>
	 * </hljs>
	 */
	function MdAnchorDirective($mdTheming) {
	  return {
	    restrict : 'E',
	    link : function postLink(scope, element) {
	      // Make sure to inherit theme so stand-alone anchors
	      // support theme colors for md-primary, md-accent, etc.
	      $mdTheming(element);
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name mdButton
	 * @module material.components.button
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-button>` is a button directive with optional ink ripples (default enabled).
	 *
	 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
	 * will become a `<button>` element. As per the
	 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
	 * the FAB button background is filled with the accent color [by default]. The primary color palette
	 * may be used with the `md-primary` class.
	 *
	 * Developers can also change the color palette of the button, by using the following classes
	 * - `md-primary`
	 * - `md-accent`
	 * - `md-warn`
	 *
	 * See for example
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-primary">Primary Button</md-button>
	 * </hljs>
	 *
	 * Button can be also raised, which means that they will use the current color palette to fill the button.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
	 * </hljs>
	 *
	 * It is also possible to disable the focus effect on the button, by using the following markup.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-no-focus">No Focus Style</md-button>
	 * </hljs>
	 *
	 * @param {boolean=} md-no-ink If present, disable ripple ink effects.
	 * @param {expression=} ng-disabled En/Disable based on the expression
	 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`
	 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
	 * If no default text is found, a warning will be logged.
	 *
	 * @usage
	 *
	 * Regular buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button> Flat Button </md-button>
	 *  <md-button href="http://google.com"> Flat link </md-button>
	 *  <md-button class="md-raised"> Raised Button </md-button>
	 *  <md-button ng-disabled="true"> Disabled Button </md-button>
	 *  <md-button>
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *    Register Now
	 *  </md-button>
	 * </hljs>
	 *
	 * FAB buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button class="md-fab" aria-label="FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- mini-FAB -->
	 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- Button with SVG Icon -->
	 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
	 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
	 *  </md-button>
	 * </hljs>
	 */
	function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $timeout) {
	
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    template: getTemplate,
	    link: postLink
	  };
	
	  function isAnchor(attr) {
	    return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
	  }
	
	  function getTemplate(element, attr) {
	    if (isAnchor(attr)) {
	      return '<a class="md-button" ng-transclude></a>';
	    } else {
	      //If buttons don't have type="button", they will submit forms automatically.
	      var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
	      return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
	    }
	  }
	
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    $mdButtonInkRipple.attach(scope, element);
	
	    // Use async expect to support possible bindings in the button label
	    $mdAria.expectWithoutText(element, 'aria-label');
	
	    // For anchor elements, we have to set tabindex manually when the
	    // element is disabled
	    if (isAnchor(attr) && angular.isDefined(attr.ngDisabled) ) {
	      scope.$watch(attr.ngDisabled, function(isDisabled) {
	        element.attr('tabindex', isDisabled ? -1 : 0);
	      });
	    }
	
	    // disabling click event when disabled is true
	    element.on('click', function(e){
	      if (attr.disabled === true) {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    });
	
	    if (!element.hasClass('md-no-focus')) {
	      // restrict focus styles to the keyboard
	      scope.mouseActive = false;
	      element.on('mousedown', function() {
	        scope.mouseActive = true;
	        $timeout(function(){
	          scope.mouseActive = false;
	        }, 100);
	      })
	      .on('focus', function() {
	        if (scope.mouseActive === false) {
	          element.addClass('md-focused');
	        }
	      })
	      .on('blur', function(ev) {
	        element.removeClass('md-focused');
	      });
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.card
	 *
	 * @description
	 * Card components.
	 */
	mdCardDirective.$inject = ["$mdTheming"];
	angular.module('material.components.card', [
	    'material.core'
	  ])
	  .directive('mdCard', mdCardDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdCard
	 * @module material.components.card
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-card>` directive is a container element used within `<md-content>` containers.
	 *
	 * An image included as a direct descendant will fill the card's width. If you want to avoid this,
	 * you can add the `md-image-no-fill` class to the parent element. The `<md-card-content>`
	 * container will wrap text content and provide padding. An `<md-card-footer>` element can be
	 * optionally included to put content flush against the bottom edge of the card.
	 *
	 * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
	 * You can then position buttons using layout attributes.
	 *
	 * Card is built with:
	 * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
	 *  - `<md-card-avatar>` - Card avatar
	 *    - `md-user-avatar` - Class for user image
	 *    - `<md-icon>`
	 *  - `<md-card-header-text>` - Contains elements for the card description
	 *    - `md-title` - Class for the card title
	 *    - `md-subhead` - Class for the card sub header
	 * * `<img>` - Image for the card
	 * * `<md-card-title>` - Card content title
	 *  - `<md-card-title-text>`
	 *    - `md-headline` - Class for the card content title
	 *    - `md-subhead` - Class for the card content sub header
	 *  - `<md-card-title-media>` - Squared image within the title
	 *    - `md-media-sm` - Class for small image
	 *    - `md-media-md` - Class for medium image
	 *    - `md-media-lg` - Class for large image
	 * * `<md-card-content>` - Card content
	 *  - `md-media-xl` - Class for extra large image
	 * * `<md-card-actions>` - Card actions
	 *  - `<md-card-icon-actions>` - Icon actions
	 *
	 * Cards have constant width and variable heights; where the maximum height is limited to what can
	 * fit within a single view on a platform, but it can temporarily expand as needed.
	 *
	 * @usage
	 * ### Card with optional footer
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-footer>
	 *    Card footer
	 *  </md-card-footer>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with actions
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-actions layout="row" layout-align="end center">
	 *    <md-button>Action 1</md-button>
	 *    <md-button>Action 2</md-button>
	 *  </md-card-actions>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with header, image, title actions and content
	 * <hljs lang="html">
	 * <md-card>
	 *   <md-card-header>
	 *     <md-card-avatar>
	 *       <img class="md-user-avatar" src="avatar.png"/>
	 *     </md-card-avatar>
	 *     <md-card-header-text>
	 *       <span class="md-title">Title</span>
	 *       <span class="md-subhead">Sub header</span>
	 *     </md-card-header-text>
	 *   </md-card-header>
	 *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
	 *   <md-card-title>
	 *     <md-card-title-text>
	 *       <span class="md-headline">Card headline</span>
	 *       <span class="md-subhead">Card subheader</span>
	 *     </md-card-title-text>
	 *   </md-card-title>
	 *   <md-card-actions layout="row" layout-align="start center">
	 *     <md-button>Action 1</md-button>
	 *     <md-button>Action 2</md-button>
	 *     <md-card-icon-actions>
	 *       <md-button class="md-icon-button" aria-label="icon">
	 *         <md-icon md-svg-icon="icon"></md-icon>
	 *       </md-button>
	 *     </md-card-icon-actions>
	 *   </md-card-actions>
	 *   <md-card-content>
	 *     <p>
	 *      Card content
	 *     </p>
	 *   </md-card-content>
	 * </md-card>
	 * </hljs>
	 */
	function mdCardDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: function ($scope, $element, attr) {
	      $element.addClass('_md');     // private md component indicator for styling
	      $mdTheming($element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.chips
	 */
	/*
	 * @see js folder for chips implementation
	 */
	angular.module('material.components.chips', [
	  'material.core',
	  'material.components.autocomplete'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.checkbox
	 * @description Checkbox module!
	 */
	MdCheckboxDirective.$inject = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$timeout"];
	angular
	  .module('material.components.checkbox', ['material.core'])
	  .directive('mdCheckbox', MdCheckboxDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdCheckbox
	 * @module material.components.checkbox
	 * @restrict E
	 *
	 * @description
	 * The checkbox directive is used like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-color-schemes)
	 * the checkbox is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {string=} ng-change Angular expression to be executed when input changes due to user interaction with the input element.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects
	 * @param {string=} aria-label Adds label to checkbox for accessibility.
	 *     Defaults to checkbox's text. If no default text is found, a warning will be logged.
	 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as 'indeterminate'.
	 *     If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state.
	 *     If falsy expression is passed in it just looks like a normal unchecked checkbox.
	 *     The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time.
	 *     Adding the 'md-indeterminate' attribute overrides any checked/unchecked rendering logic.
	 *     When using the 'md-indeterminate' attribute use 'ng-checked' to define rendering logic instead of using 'ng-model'.
	 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css class is added to the checkbox and it
	 *     will appear checked.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
	 *   Finished ?
	 * </md-checkbox>
	 *
	 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-checkbox>
	 *
	 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-checkbox>
	 *
	 * </hljs>
	 *
	 */
	function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $timeout) {
	  inputDirective = inputDirective[0];
	
	  return {
	    restrict: 'E',
	    transclude: true,
	    require: '?ngModel',
	    priority: 210, // Run before ngAria
	    template:
	      '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	        '<div class="md-icon"></div>' +
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    tAttrs.$set('tabindex', tAttrs.tabindex || '0');
	    tAttrs.$set('type', 'checkbox');
	    tAttrs.$set('role', tAttrs.type);
	
	    return  {
	      pre: function(scope, element) {
	        // Attach a click handler during preLink, in order to immediately stop propagation
	        // (especially for ng-click) when the checkbox is disabled.
	        element.on('click', function(e) {
	          if (this.hasAttribute('disabled')) {
	            e.stopImmediatePropagation();
	          }
	        });
	      },
	      post: postLink
	    };
	
	    function postLink(scope, element, attr, ngModelCtrl) {
	      var isIndeterminate;
	      ngModelCtrl = ngModelCtrl || $mdUtil.fakeNgModel();
	      $mdTheming(element);
	
	      // Redirect focus events to the root element, because IE11 is always focusing the container element instead
	      // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
	      element.children().on('focus', function() {
	        element.focus();
	      });
	
	      if ($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)) {
	        setIndeterminateState();
	        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
	      }
	
	      if (attr.ngChecked) {
	        scope.$watch(scope.$eval.bind(scope, attr.ngChecked), function(value) {
	          ngModelCtrl.$setViewValue(value);
	          ngModelCtrl.$render();
	        });
	      }
	
	      $$watchExpr('ngDisabled', 'tabindex', {
	        true: '-1',
	        false: attr.tabindex
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	
	      // Reuse the original input[type=checkbox] directive from Angular core.
	      // This is a bit hacky as we need our own event listener and own render
	      // function.
	      inputDirective.link.pre(scope, {
	        on: angular.noop,
	        0: {}
	      }, attr, [ngModelCtrl]);
	
	      scope.mouseActive = false;
	      element.on('click', listener)
	        .on('keypress', keypressHandler)
	        .on('mousedown', function() {
	          scope.mouseActive = true;
	          $timeout(function() {
	            scope.mouseActive = false;
	          }, 100);
	        })
	        .on('focus', function() {
	          if (scope.mouseActive === false) {
	            element.addClass('md-focused');
	          }
	        })
	        .on('blur', function() {
	          element.removeClass('md-focused');
	        });
	
	      ngModelCtrl.$render = render;
	
	      function $$watchExpr(expr, htmlAttr, valueOpts) {
	        if (attr[expr]) {
	          scope.$watch(attr[expr], function(val) {
	            if (valueOpts[val]) {
	              element.attr(htmlAttr, valueOpts[val]);
	            }
	          });
	        }
	      }
	
	      function keypressHandler(ev) {
	        var keyCode = ev.which || ev.keyCode;
	        if (keyCode === $mdConstant.KEY_CODE.SPACE || keyCode === $mdConstant.KEY_CODE.ENTER) {
	          ev.preventDefault();
	          element.addClass('md-focused');
	          listener(ev);
	        }
	      }
	
	      function listener(ev) {
	        // skipToggle boolean is used by the switch directive to prevent the click event
	        // when releasing the drag. There will be always a click if releasing the drag over the checkbox
	        if (element[0].hasAttribute('disabled') || scope.skipToggle) {
	          return;
	        }
	
	        scope.$apply(function() {
	          // Toggle the checkbox value...
	          var viewValue = attr.ngChecked ? attr.checked : !ngModelCtrl.$viewValue;
	
	          ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
	          ngModelCtrl.$render();
	        });
	      }
	
	      function render() {
	        // Cast the $viewValue to a boolean since it could be undefined
	        element.toggleClass('md-checked', !!ngModelCtrl.$viewValue && !isIndeterminate);
	      }
	
	      function setIndeterminateState(newValue) {
	        isIndeterminate = newValue !== false;
	        if (isIndeterminate) {
	          element.attr('aria-checked', 'mixed');
	        }
	        element.toggleClass('md-indeterminate', isIndeterminate);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	(function () {
	  "use strict";
	
	  /**
	   *  Use a RegExp to check if the `md-colors="<expression>"` is static string
	   *  or one that should be observed and dynamically interpolated.
	   */
	  MdColorsDirective.$inject = ["$mdColors", "$mdUtil", "$log", "$parse"];
	  MdColorsService.$inject = ["$mdTheming", "$mdUtil", "$log"];
	  var STATIC_COLOR_EXPRESSION = /^{((\s|,)*?["'a-zA-Z-]+?\s*?:\s*?('|")[a-zA-Z0-9-.]*('|"))+\s*}$/;
	  var colorPalettes = null;
	
	  /**
	   * @ngdoc module
	   * @name material.components.colors
	   *
	   * @description
	   * Define $mdColors service and a `md-colors=""` attribute directive
	   */
	  angular
	    .module('material.components.colors', ['material.core'])
	    .directive('mdColors', MdColorsDirective)
	    .service('$mdColors', MdColorsService);
	
	  /**
	   * @ngdoc service
	   * @name $mdColors
	   * @module material.components.colors
	   *
	   * @description
	   * With only defining themes, one couldn't get non ngMaterial elements colored with Material colors,
	   * `$mdColors` service is used by the md-color directive to convert the 1..n color expressions to RGBA values and will apply
	   * those values to element as CSS property values.
	   *
	   *  @usage
	   *  <hljs lang="js">
	   *    angular.controller('myCtrl', function ($mdColors) {
	   *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	   *      ...
	   *    });
	   *  </hljs>
	   *
	   */
	  function MdColorsService($mdTheming, $mdUtil, $log) {
	    colorPalettes = colorPalettes || Object.keys($mdTheming.PALETTES);
	
	    // Publish service instance
	    return {
	      applyThemeColors: applyThemeColors,
	      getThemeColor: getThemeColor,
	      hasTheme: hasTheme
	    };
	
	    // ********************************************
	    // Internal Methods
	    // ********************************************
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#applyThemeColors
	     *
	     * @description
	     * Gets a color json object, keys are css properties and values are string of the wanted color
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @param {DOMElement} element the element to apply the styles on.
	     * @param {object} colorExpression json object, keys are css properties and values are string of the wanted color,
	     * for example: `{color: 'red-A200-0.3'}`.
	     *
	     * @usage
	     * <hljs lang="js">
	     *   app.directive('myDirective', function($mdColors) {
	     *     return {
	     *       ...
	     *       link: function (scope, elem) {
	     *         $mdColors.applyThemeColors(elem, {color: 'red'});
	     *       }
	     *    }
	     *   });
	     * </hljs>
	     */
	    function applyThemeColors(element, colorExpression) {
	      try {
	        if (colorExpression) {
	          // Assign the calculate RGBA color values directly as inline CSS
	          element.css(interpolateColors(colorExpression));
	        }
	      } catch (e) {
	        $log.error(e.message);
	      }
	
	    }
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#getThemeColor
	     *
	     * @description
	     * Get parsed color from expression
	     *
	     * @param {string} expression string of a color expression (for instance `'red-700-0.8'`)
	     *
	     * @returns {string} a css color expression (for instance `rgba(211, 47, 47, 0.8)`)
	     *
	     * @usage
	     *  <hljs lang="js">
	     *    angular.controller('myCtrl', function ($mdColors) {
	     *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	     *      ...
	     *    });
	     *  </hljs>
	     */
	    function getThemeColor(expression) {
	      var color = extractColorOptions(expression);
	
	      return parseColor(color);
	    }
	
	    /**
	     * Return the parsed color
	     * @param color hashmap of color definitions
	     * @param contrast whether use contrast color for foreground
	     * @returns rgba color string
	     */
	    function parseColor(color, contrast) {
	      contrast = contrast || false;
	      var rgbValues = $mdTheming.PALETTES[color.palette][color.hue];
	
	      rgbValues = contrast ? rgbValues.contrast : rgbValues.value;
	
	      return $mdUtil.supplant('rgba({0}, {1}, {2}, {3})',
	        [rgbValues[0], rgbValues[1], rgbValues[2], rgbValues[3] || color.opacity]
	      );
	    }
	
	    /**
	     * Convert the color expression into an object with scope-interpolated values
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @results Hashmap of CSS properties with associated `rgba( )` string vales
	     *
	     *
	     */
	    function interpolateColors(themeColors) {
	      var rgbColors = {};
	
	      var hasColorProperty = themeColors.hasOwnProperty('color');
	
	      angular.forEach(themeColors, function (value, key) {
	        var color = extractColorOptions(value);
	        var hasBackground = key.indexOf('background') > -1;
	
	        rgbColors[key] = parseColor(color);
	        if (hasBackground && !hasColorProperty) {
	          rgbColors.color = parseColor(color, true);
	        }
	      });
	
	      return rgbColors;
	    }
	
	    /**
	     * Check if expression has defined theme
	     * e.g.
	     * 'myTheme-primary' => true
	     * 'red-800' => false
	     */
	    function hasTheme(expression) {
	      return angular.isDefined($mdTheming.THEMES[expression.split('-')[0]]);
	    }
	
	    /**
	     * For the evaluated expression, extract the color parts into a hash map
	     */
	    function extractColorOptions(expression) {
	      var parts = expression.split('-');
	      var hasTheme = angular.isDefined($mdTheming.THEMES[parts[0]]);
	      var theme = hasTheme ? parts.splice(0, 1)[0] : $mdTheming.defaultTheme();
	
	      return {
	        theme: theme,
	        palette: extractPalette(parts, theme),
	        hue: extractHue(parts, theme),
	        opacity: parts[2] || 1
	      };
	    }
	
	    /**
	     * Calculate the theme palette name
	     */
	    function extractPalette(parts, theme) {
	      // If the next section is one of the palettes we assume it's a two word palette
	      // Two word palette can be also written in camelCase, forming camelCase to dash-case
	
	      var isTwoWord = parts.length > 1 && colorPalettes.indexOf(parts[1]) !== -1;
	      var palette = parts[0].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	
	      if (isTwoWord)  palette = parts[0] + '-' + parts.splice(1, 1);
	
	      if (colorPalettes.indexOf(palette) === -1) {
	        // If the palette is not in the palette list it's one of primary/accent/warn/background
	        var scheme = $mdTheming.THEMES[theme].colors[palette];
	        if (!scheme) {
	          throw new Error($mdUtil.supplant('mdColors: couldn\'t find \'{palette}\' in the palettes.', {palette: palette}));
	        }
	        palette = scheme.name;
	      }
	
	      return palette;
	    }
	
	    function extractHue(parts, theme) {
	      var themeColors = $mdTheming.THEMES[theme].colors;
	
	      if (parts[1] === 'hue') {
	        var hueNumber = parseInt(parts.splice(2, 1)[0], 10);
	
	        if (hueNumber < 1 || hueNumber > 3) {
	          throw new Error($mdUtil.supplant('mdColors: \'hue-{hueNumber}\' is not a valid hue, can be only \'hue-1\', \'hue-2\' and \'hue-3\'', {hueNumber: hueNumber}));
	        }
	        parts[1] = 'hue-' + hueNumber;
	
	        if (!(parts[0] in themeColors)) {
	          throw new Error($mdUtil.supplant('mdColors: \'hue-x\' can only be used with [{availableThemes}], but was used with \'{usedTheme}\'', {
	            availableThemes: Object.keys(themeColors).join(', '),
	            usedTheme: parts[0]
	          }));
	        }
	
	        return themeColors[parts[0]].hues[parts[1]];
	      }
	
	      return parts[1] || themeColors[parts[0] in themeColors ? parts[0] : 'primary'].hues['default'];
	    }
	  }
	
	  /**
	   * @ngdoc directive
	   * @name mdColors
	   * @module material.components.colors
	   *
	   * @restrict A
	   *
	   * @description
	   * `mdColors` directive will apply the theme-based color expression as RGBA CSS style values.
	   *
	   *   The format will be similar to our color defining in the scss files:
	   *
	   *   ## `[?theme]-[palette]-[?hue]-[?opacity]`
	   *   - [theme]    - default value is the default theme
	   *   - [palette]  - can be either palette name or primary/accent/warn/background
	   *   - [hue]      - default is 500 (hue-x can be used with primary/accent/warn/background)
	   *   - [opacity]  - default is 1
	   *
	   *   > `?` indicates optional parameter
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <div md-colors="{background: 'myTheme-accent-900-0.43'}">
	   *     <div md-colors="{color: 'red-A100', 'border-color': 'primary-600'}">
	   *       <span>Color demo</span>
	   *     </div>
	   *   </div>
	   * </hljs>
	   *
	   * `mdColors` directive will automatically watch for changes in the expression if it recognizes an interpolation
	   * expression or a function. For performance options, you can use `::` prefix to the `md-colors` expression
	   * to indicate a one-time data binding.
	   * <hljs lang="html">
	   *   <md-card md-colors="::{background: '{{theme}}-primary-700'}">
	   *   </md-card>
	   * </hljs>
	   *
	   */
	  function MdColorsDirective($mdColors, $mdUtil, $log, $parse) {
	    return {
	      restrict: 'A',
	      require: ['^?mdTheme'],
	      compile: function (tElem, tAttrs) {
	        var shouldWatch = shouldColorsWatch();
	
	        return function (scope, element, attrs, ctrl) {
	          var mdThemeController = ctrl[0];
	
	          var lastColors = {};
	
	          var parseColors = function (theme) {
	            if (typeof theme !== 'string') {
	              theme = '';
	            }
	
	            if (!attrs.mdColors) {
	              attrs.mdColors = '{}';
	            }
	
	            /**
	             * Json.parse() does not work because the keys are not quoted;
	             * use $parse to convert to a hash map
	             */
	            var colors = $parse(attrs.mdColors)(scope);
	
	            /**
	             * If mdTheme is defined up the DOM tree
	             * we add mdTheme theme to colors who doesn't specified a theme
	             *
	             * # example
	             * <hljs lang="html">
	             *   <div md-theme="myTheme">
	             *     <div md-colors="{background: 'primary-600'}">
	             *       <span md-colors="{background: 'mySecondTheme-accent-200'}">Color demo</span>
	             *     </div>
	             *   </div>
	             * </hljs>
	             *
	             * 'primary-600' will be 'myTheme-primary-600',
	             * but 'mySecondTheme-accent-200' will stay the same cause it has a theme prefix
	             */
	            if (mdThemeController) {
	              Object.keys(colors).forEach(function (prop) {
	                var color = colors[prop];
	                if (!$mdColors.hasTheme(color)) {
	                  colors[prop] = (theme || mdThemeController.$mdTheme) + '-' + color;
	                }
	              });
	            }
	
	            cleanElement(colors);
	
	            return colors;
	          };
	
	          var cleanElement = function (colors) {
	            if (!angular.equals(colors, lastColors)) {
	              var keys = Object.keys(lastColors);
	
	              if (lastColors.background && !keys.color) {
	                keys.push('color');
	              }
	
	              keys.forEach(function (key) {
	                element.css(key, '');
	              });
	            }
	
	            lastColors = colors;
	          };
	
	          /**
	           * Registering for mgTheme changes and asking mdTheme controller run our callback whenever a theme changes
	           */
	          var unregisterChanges = angular.noop;
	
	          if (mdThemeController) {
	            unregisterChanges = mdThemeController.registerChanges(function (theme) {
	              $mdColors.applyThemeColors(element, parseColors(theme));
	            });
	          }
	
	          scope.$on('$destroy', function () {
	            unregisterChanges();
	          });
	
	          try {
	            if (shouldWatch) {
	              scope.$watch(parseColors, angular.bind(this,
	                $mdColors.applyThemeColors, element
	              ), true);
	            }
	            else {
	              $mdColors.applyThemeColors(element, parseColors());
	            }
	
	          }
	          catch (e) {
	            $log.error(e.message);
	          }
	
	        };
	
	        function shouldColorsWatch() {
	          // Simulate 1x binding and mark mdColorsWatch == false
	          var rawColorExpression = tAttrs.mdColors;
	          var bindOnce = rawColorExpression.indexOf('::') > -1;
	          var isStatic = bindOnce ? true : STATIC_COLOR_EXPRESSION.test(tAttrs.mdColors);
	
	          // Remove it for the postLink...
	          tAttrs.mdColors = rawColorExpression.replace('::', '');
	
	          var hasWatchAttr = angular.isDefined(tAttrs.mdColorsWatch);
	
	          return (bindOnce || isStatic) ? false :
	            hasWatchAttr ? $mdUtil.parseAttributeBoolean(tAttrs.mdColorsWatch) : true;
	        }
	      }
	    };
	
	  }
	
	
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.content
	 *
	 * @description
	 * Scrollable content
	 */
	mdContentDirective.$inject = ["$mdTheming"];
	angular.module('material.components.content', [
	  'material.core'
	])
	  .directive('mdContent', mdContentDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdContent
	 * @module material.components.content
	 *
	 * @restrict E
	 *
	 * @description
	 *
	 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
	 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
	 *
	 * In general, `<md-content>` components are not designed to be nested inside one another. If
	 * possible, it is better to make them siblings. This often results in a better user experience as
	 * having nested scrollbars may confuse the user.
	 *
	 * ## Troubleshooting
	 *
	 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
	 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
	 * SVG icons and some other components.
	 *
	 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
	 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
	 * inside (which eliminates the flicker on iOS devices).
	 *
	 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
	 * related to the z-index of elements. Please use with caution and only on the elements needed._
	 *
	 * @usage
	 *
	 * Add the `[layout-padding]` attribute to make the content padded.
	 *
	 * <hljs lang="html">
	 *  <md-content layout-padding>
	 *      Lorem ipsum dolor sit amet, ne quod novum mei.
	 *  </md-content>
	 * </hljs>
	 */
	
	function mdContentDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    controller: ['$scope', '$element', ContentController],
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      scope.$broadcast('$mdContentLoaded', element);
	
	      iosScrollFix(element[0]);
	    }
	  };
	
	  function ContentController($scope, $element) {
	    this.$scope = $scope;
	    this.$element = $element;
	  }
	}
	
	function iosScrollFix(node) {
	  // IOS FIX:
	  // If we scroll where there is no more room for the webview to scroll,
	  // by default the webview itself will scroll up and down, this looks really
	  // bad.  So if we are scrolling to the very top or bottom, add/subtract one
	  angular.element(node).on('$md.pressdown', function(ev) {
	    // Only touch events
	    if (ev.pointer.type !== 't') return;
	    // Don't let a child content's touchstart ruin it for us.
	    if (ev.$materialScrollFixed) return;
	    ev.$materialScrollFixed = true;
	
	    if (node.scrollTop === 0) {
	      node.scrollTop = 1;
	    } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
	      node.scrollTop -= 1;
	    }
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.datepicker
	 * @description Module for the datepicker component.
	 */
	
	angular.module('material.components.datepicker', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.dialog
	 */
	MdDialogDirective.$inject = ["$$rAF", "$mdTheming", "$mdDialog"];
	MdDialogProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.dialog', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdDialog', MdDialogDirective)
	  .provider('$mdDialog', MdDialogProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdDialog
	 * @module material.components.dialog
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-dialog>` - The dialog's template must be inside this element.
	 *
	 * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 * an `<md-dialog-actions>` element for the dialog's actions.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * ## Notes
	 * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
	 * prefixed with `dialogContent_`.
	 *
	 * @usage
	 * ### Dialog template
	 * <hljs lang="html">
	 * <md-dialog aria-label="List dialog">
	 *   <md-dialog-content>
	 *     <md-list>
	 *       <md-list-item ng-repeat="item in items">
	 *         <p>Number {{item}}</p>
	 *       </md-list-item>
	 *     </md-list>
	 *   </md-dialog-content>
	 *   <md-dialog-actions>
	 *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
	 *   </md-dialog-actions>
	 * </md-dialog>
	 * </hljs>
	 */
	function MdDialogDirective($$rAF, $mdTheming, $mdDialog) {
	  return {
	    restrict: 'E',
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      $$rAF(function() {
	        var images;
	        var content = element[0].querySelector('md-dialog-content');
	
	        if (content) {
	          images = content.getElementsByTagName('img');
	          addOverflowClass();
	          //-- delayed image loading may impact scroll height, check after images are loaded
	          angular.element(images).on('load', addOverflowClass);
	        }
	
	        scope.$on('$destroy', function() {
	          $mdDialog.destroy(element);
	        });
	
	        /**
	         *
	         */
	        function addOverflowClass() {
	          element.toggleClass('md-content-overflow', content.scrollHeight > content.clientHeight);
	        }
	
	
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdDialog
	 * @module material.components.dialog
	 *
	 * @description
	 * `$mdDialog` opens a dialog over the app to inform users about critical information or require
	 *  them to make decisions. There are two approaches for setup: a simple promise API
	 *  and regular object syntax.
	 *
	 * ## Restrictions
	 *
	 * - The dialog is always given an isolate scope.
	 * - The dialog's template must have an outer `<md-dialog>` element.
	 *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 *   an `<md-dialog-actions>` element for the dialog's actions.
	 * - Dialogs must cover the entire application to keep interactions inside of them.
	 * Use the `parent` option to change where dialogs are appended.
	 *
	 * ## Sizing
	 * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
	 * - Default max-width is 80% of the `rootElement` or `parent`.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div  ng-app="demoApp" ng-controller="EmployeeController">
	 *   <div>
	 *     <md-button ng-click="showAlert()" class="md-raised md-warn">
	 *       Employee Alert!
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showDialog($event)" class="md-raised">
	 *       Custom Dialog
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="closeAlert()" ng-disabled="!hasAlert()" class="md-raised">
	 *       Close Alert
	 *     </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showGreeting($event)" class="md-raised md-primary" >
	 *       Greet Employee
	 *       </md-button>
	 *   </div>
	 * </div>
	 * </hljs>
	 *
	 * ### JavaScript: object syntax
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *    .module('demoApp', ['ngMaterial'])
	 *    .controller('AppCtrl', AppController);
	 *
	 *   function AppController($scope, $mdDialog) {
	 *     var alert;
	 *     $scope.showAlert = showAlert;
	 *     $scope.showDialog = showDialog;
	 *     $scope.items = [1, 2, 3];
	 *
	 *     // Internal method
	 *     function showAlert() {
	 *       alert = $mdDialog.alert({
	 *         title: 'Attention',
	 *         textContent: 'This is an example of how easy dialogs can be!',
	 *         ok: 'Close'
	 *       });
	 *
	 *       $mdDialog
	 *         .show( alert )
	 *         .finally(function() {
	 *           alert = undefined;
	 *         });
	 *     }
	 *
	 *     function showDialog($event) {
	 *        var parentEl = angular.element(document.body);
	 *        $mdDialog.show({
	 *          parent: parentEl,
	 *          targetEvent: $event,
	 *          template:
	 *            '<md-dialog aria-label="List dialog">' +
	 *            '  <md-dialog-content>'+
	 *            '    <md-list>'+
	 *            '      <md-list-item ng-repeat="item in items">'+
	 *            '       <p>Number {{item}}</p>' +
	 *            '      </md-item>'+
	 *            '    </md-list>'+
	 *            '  </md-dialog-content>' +
	 *            '  <md-dialog-actions>' +
	 *            '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *            '      Close Dialog' +
	 *            '    </md-button>' +
	 *            '  </md-dialog-actions>' +
	 *            '</md-dialog>',
	 *          locals: {
	 *            items: $scope.items
	 *          },
	 *          controller: DialogController
	 *       });
	 *       function DialogController($scope, $mdDialog, items) {
	 *         $scope.items = items;
	 *         $scope.closeDialog = function() {
	 *           $mdDialog.hide();
	 *         }
	 *       }
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 *
	 * ### Pre-Rendered Dialogs
	 * By using the `contentElement` option, it is possible to use an already existing element in the DOM.
	 *
	 * <hljs lang="js">
	 *   $scope.showPrerenderedDialog = function() {
	 *     $mdDialog.show({
	 *       contentElement: '#myStaticDialog',
	 *       parent: angular.element(document.body)
	 *     });
	 *   };
	 * </hljs>
	 *
	 * When using a string as value, `$mdDialog` will automatically query the DOM for the specified CSS selector.
	 *
	 * <hljs lang="html">
	 *   <div style="visibility: hidden">
	 *     <div class="md-dialog-container" id="myStaticDialog">
	 *       <md-dialog>
	 *         This is a pre-rendered dialog.
	 *       </md-dialog>
	 *     </div>
	 *   </div>
	 * </hljs>
	 *
	 * **Notice**: It is important, to use the `.md-dialog-container` as the content element, otherwise the dialog
	 * will not show up.
	 *
	 * It also possible to use a DOM element for the `contentElement` option.
	 * - `contentElement: document.querySelector('#myStaticDialog')`
	 * - `contentElement: angular.element(TEMPLATE)`
	 *
	 * When using a `template` as content element, it will be not compiled upon open.
	 * This allows you to compile the element yourself and use it each time the dialog opens.
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdDialogProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-dialog>' +
	 *             'This is a custom preset' +
	 *           '</md-dialog>',
	 *         controllerAs: 'dialog',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you created your preset at config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdDialog.show(
	 *     $mdDialog.testPreset()
	 *   );
	 * </hljs>
	 *
	 * ### JavaScript: promise API syntax, custom dialog template
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *     .module('demoApp', ['ngMaterial'])
	 *     .controller('EmployeeController', EmployeeEditor)
	 *     .controller('GreetingController', GreetingController);
	 *
	 *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
	 *
	 *   function EmployeeEditor($scope, $mdDialog) {
	 *     var alert;
	 *
	 *     $scope.showAlert = showAlert;
	 *     $scope.closeAlert = closeAlert;
	 *     $scope.showGreeting = showCustomGreeting;
	 *
	 *     $scope.hasAlert = function() { return !!alert };
	 *     $scope.userName = $scope.userName || 'Bobby';
	 *
	 *     // Dialog #1 - Show simple alert dialog and cache
	 *     // reference to dialog instance
	 *
	 *     function showAlert() {
	 *       alert = $mdDialog.alert()
	 *         .title('Attention, ' + $scope.userName)
	 *         .textContent('This is an example of how easy dialogs can be!')
	 *         .ok('Close');
	 *
	 *       $mdDialog
	 *           .show( alert )
	 *           .finally(function() {
	 *             alert = undefined;
	 *           });
	 *     }
	 *
	 *     // Close the specified dialog instance and resolve with 'finished' flag
	 *     // Normally this is not needed, just use '$mdDialog.hide()' to close
	 *     // the most recent dialog popup.
	 *
	 *     function closeAlert() {
	 *       $mdDialog.hide( alert, "finished" );
	 *       alert = undefined;
	 *     }
	 *
	 *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
	 *
	 *     function showCustomGreeting($event) {
	 *         $mdDialog.show({
	 *           targetEvent: $event,
	 *           template:
	 *             '<md-dialog>' +
	 *
	 *             '  <md-dialog-content>Hello {{ employee }}!</md-dialog-content>' +
	 *
	 *             '  <md-dialog-actions>' +
	 *             '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *             '      Close Greeting' +
	 *             '    </md-button>' +
	 *             '  </md-dialog-actions>' +
	 *             '</md-dialog>',
	 *           controller: 'GreetingController',
	 *           onComplete: afterShowAnimation,
	 *           locals: { employee: $scope.userName }
	 *         });
	 *
	 *         // When the 'enter' animation finishes...
	 *
	 *         function afterShowAnimation(scope, element, options) {
	 *            // post-show code here: DOM element focus, etc.
	 *         }
	 *     }
	 *
	 *     // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog
	 *     //             Here we used ng-controller="GreetingController as vm" and
	 *     //             $scope.vm === <controller instance>
	 *
	 *     function showCustomGreeting() {
	 *
	 *        $mdDialog.show({
	 *           clickOutsideToClose: true,
	 *
	 *           scope: $scope,        // use parent scope in template
	 *           preserveScope: true,  // do not forget this if use parent scope
	
	 *           // Since GreetingController is instantiated with ControllerAs syntax
	 *           // AND we are passing the parent '$scope' to the dialog, we MUST
	 *           // use 'vm.<xxx>' in the template markup
	 *
	 *           template: '<md-dialog>' +
	 *                     '  <md-dialog-content>' +
	 *                     '     Hi There {{vm.employee}}' +
	 *                     '  </md-dialog-content>' +
	 *                     '</md-dialog>',
	 *
	 *           controller: function DialogController($scope, $mdDialog) {
	 *             $scope.closeDialog = function() {
	 *               $mdDialog.hide();
	 *             }
	 *           }
	 *        });
	 *     }
	 *
	 *   }
	 *
	 *   // Greeting controller used with the more complex 'showCustomGreeting()' custom dialog
	 *
	 *   function GreetingController($scope, $mdDialog, employee) {
	 *     // Assigned from construction <code>locals</code> options...
	 *     $scope.employee = employee;
	 *
	 *     $scope.closeDialog = function() {
	 *       // Easily hides most recent dialog shown...
	 *       // no specific instance reference is needed.
	 *       $mdDialog.hide();
	 *     };
	 *   }
	 *
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#alert
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the alert title.
	 * - $mdDialogPreset#textContent(string) - Sets the alert message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the alert "Okay" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the alert dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#confirm
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message. You can call show and the promise returned
	 * will be resolved only if the user clicks the confirm action on the dialog.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the confirm title.
	 * - $mdDialogPreset#textContent(string) - Sets the confirm message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the confirm "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the confirm "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#prompt
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message and input box. You can call show and the promise returned
	 * will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the prompt title.
	 * - $mdDialogPreset#textContent(string) - Sets the prompt message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.
	 * - $mdDialogPreset#initialValue(string) - Sets the initial value for the prompt input.
	 * - $mdDialogPreset#ok(string) - Sets the prompt "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the prompt "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#show
	 *
	 * @description
	 * Show a dialog with the specified options.
	 *
	 * @param {object} optionsOrPreset Either provide an `$mdDialogPreset` returned from `alert()`, and
	 * `confirm()`, or an options object with the following properties:
	 *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
	 *   of the dialog.
	 *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
	 *      with respect to Angular's [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *      This template should **never** be constructed with any kind of user input or user data.
	 *   - `contentElement` - `{string|Element}`: Instead of using a template, which will be compiled each time a
	 *     dialog opens, you can also use a DOM element.<br/>
	 *     * When specifying an element, which is present on the DOM, `$mdDialog` will temporary fetch the element into
	 *       the dialog and restores it at the old DOM position upon close.
	 *     * When specifying a string, the string be used as a CSS selector, to lookup for the element in the DOM.
	 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
	 *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
	 *     custom dialog directive.
	 *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *   - `openFrom` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
	 *     originate.
	 *   - `closeTo` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
	 *     target.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified,
	 *     it will create a new isolate scope.
	 *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
	 *     Default true.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
	 *     Default true.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
	 *     close it. Default false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
	 *     Default true.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
	 *     focusing some other way, as focus management is required for dialogs to be accessible.
	 *     Defaults to true.
	 *   - `controller` - `{function|string=}`: The controller to associate with the dialog. The controller
	 *     will be injected with the local `$mdDialog`, which passes along a scope for the dialog.
	 *   - `locals` - `{object=}`: An object containing key/value pairs. The keys will be used as names
	 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
	 *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
	 *     copied to the controller instead.
	 *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values, and the
	 *     dialog will not open until all of the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
	 *     to the root element of the application.
	 *   - `onShowing` - `function(scope, element)`: Callback function used to announce the show() action is
	 *     starting.
	 *   - `onComplete` - `function(scope, element)`: Callback function used to announce when the show() action is
	 *     finished.
	 *   - `onRemoving` - `function(element, removePromise)`: Callback function used to announce the
	 *      close/hide() action is starting. This allows developers to run custom animations
	 *      in parallel the close animations.
	 *   - `fullscreen` `{boolean=}`: An option to toggle whether the dialog should show in fullscreen
	 *      or not. Defaults to `false`.
	 * @returns {promise} A promise that can be resolved with `$mdDialog.hide()` or
	 * rejected with `$mdDialog.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#hide
	 *
	 * @description
	 * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#cancel
	 *
	 * @description
	 * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	function MdDialogProvider($$interimElementProvider) {
	  // Elements to capture and redirect focus when the user presses tab at the dialog boundary.
	  advancedDialogOptions.$inject = ["$mdDialog", "$mdConstant"];
	  dialogDefaultOptions.$inject = ["$mdDialog", "$mdAria", "$mdUtil", "$mdConstant", "$animate", "$document", "$window", "$rootElement", "$log", "$injector", "$mdTheming"];
	  var topFocusTrap, bottomFocusTrap;
	
	  return $$interimElementProvider('$mdDialog')
	    .setDefaults({
	      methods: ['disableParentScroll', 'hasBackdrop', 'clickOutsideToClose', 'escapeToClose',
	          'targetEvent', 'closeTo', 'openFrom', 'parent', 'fullscreen', 'contentElement'],
	      options: dialogDefaultOptions
	    })
	    .addPreset('alert', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'theme',
	          'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('confirm', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'cancel',
	          'theme', 'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('prompt', {
	      methods: ['title', 'htmlContent', 'textContent', 'initialValue', 'content', 'placeholder', 'ariaLabel',
	          'ok', 'cancel', 'theme', 'css'],
	      options: advancedDialogOptions
	    });
	
	  /* @ngInject */
	  function advancedDialogOptions($mdDialog, $mdConstant) {
	    return {
	      template: [
	        '<md-dialog md-theme="{{ dialog.theme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
	        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
	        '    <h2 class="md-title">{{ dialog.title }}</h2>',
	        '    <div ng-if="::dialog.mdHtmlContent" class="md-dialog-content-body" ',
	        '        ng-bind-html="::dialog.mdHtmlContent"></div>',
	        '    <div ng-if="::!dialog.mdHtmlContent" class="md-dialog-content-body">',
	        '      <p>{{::dialog.mdTextContent}}</p>',
	        '    </div>',
	        '    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">',
	        '      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
	        '             placeholder="{{::dialog.placeholder}}">',
	        '    </md-input-container>',
	        '  </md-dialog-content>',
	        '  <md-dialog-actions>',
	        '    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"' +
	        '               ng-click="dialog.abort()" class="md-primary md-cancel-button">',
	        '      {{ dialog.cancel }}',
	        '    </md-button>',
	        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" md-autofocus="dialog.$type===\'alert\'">',
	        '      {{ dialog.ok }}',
	        '    </md-button>',
	        '  </md-dialog-actions>',
	        '</md-dialog>'
	      ].join('').replace(/\s\s+/g, ''),
	      controller: function mdDialogCtrl() {
	        var isPrompt = this.$type == 'prompt';
	
	        if (isPrompt && this.initialValue) {
	          this.result = this.initialValue;
	        }
	
	        this.hide = function() {
	          $mdDialog.hide(isPrompt ? this.result : true);
	        };
	        this.abort = function() {
	          $mdDialog.cancel();
	        };
	        this.keypress = function($event) {
	          if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
	            $mdDialog.hide(this.result);
	          }
	        };
	      },
	      controllerAs: 'dialog',
	      bindToController: true,
	    };
	  }
	
	  /* @ngInject */
	  function dialogDefaultOptions($mdDialog, $mdAria, $mdUtil, $mdConstant, $animate, $document, $window, $rootElement,
	                                $log, $injector, $mdTheming) {
	
	    return {
	      hasBackdrop: true,
	      isolateScope: true,
	      onCompiling: beforeCompile,
	      onShow: onShow,
	      onShowing: beforeShow,
	      onRemove: onRemove,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      targetEvent: null,
	      contentElement: null,
	      closeTo: null,
	      openFrom: null,
	      focusOnOpen: true,
	      disableParentScroll: true,
	      autoWrap: true,
	      fullscreen: false,
	      transformTemplate: function(template, options) {
	        // Make the dialog container focusable, because otherwise the focus will be always redirected to
	        // an element outside of the container, and the focus trap won't work probably..
	        // Also the tabindex is needed for the `escapeToClose` functionality, because
	        // the keyDown event can't be triggered when the focus is outside of the container.
	        return '<div class="md-dialog-container" tabindex="-1">' + validatedTemplate(template) + '</div>';
	
	        /**
	         * The specified template should contain a <md-dialog> wrapper element....
	         */
	        function validatedTemplate(template) {
	          if (options.autoWrap && !/<\/md-dialog>/g.test(template)) {
	            return '<md-dialog>' + (template || '') + '</md-dialog>';
	          } else {
	            return template || '';
	          }
	        }
	      }
	    };
	
	    function beforeCompile(options) {
	      // Automatically apply the theme, if the user didn't specify a theme explicitly.
	      // Those option changes need to be done, before the compilation has started, because otherwise
	      // the option changes will be not available in the $mdCompilers locales.
	      detectTheming(options);
	
	      if (options.contentElement) {
	        options.restoreContentElement = installContentElement(options);
	      }
	    }
	
	    function beforeShow(scope, element, options, controller) {
	
	      if (controller) {
	        controller.mdHtmlContent = controller.htmlContent || options.htmlContent || '';
	        controller.mdTextContent = controller.textContent || options.textContent ||
	            controller.content || options.content || '';
	
	        if (controller.mdHtmlContent && !$injector.has('$sanitize')) {
	          throw Error('The ngSanitize module must be loaded in order to use htmlContent.');
	        }
	
	        if (controller.mdHtmlContent && controller.mdTextContent) {
	          throw Error('md-dialog cannot have both `htmlContent` and `textContent`');
	        }
	      }
	    }
	
	    /** Show method for dialogs */
	    function onShow(scope, element, options, controller) {
	      angular.element($document[0].body).addClass('md-dialog-is-showing');
	
	      var dialogElement = element.find('md-dialog');
	
	      // Once a dialog has `ng-cloak` applied on his template the dialog animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (dialogElement.hasClass('ng-cloak')) {
	        var message = '$mdDialog: using `<md-dialog ng-cloak >` will affect the dialog opening animations.';
	        $log.warn( message, element[0] );
	      }
	
	      captureParentAndFromToElements(options);
	      configureAria(dialogElement, options);
	      showBackdrop(scope, element, options);
	      activateListeners(element, options);
	
	      return dialogPopIn(element, options)
	        .then(function() {
	          lockScreenReader(element, options);
	          warnDeprecatedActions();
	          focusOnOpen();
	        });
	
	      /**
	       * Check to see if they used the deprecated .md-actions class and log a warning
	       */
	      function warnDeprecatedActions() {
	        if (element[0].querySelector('.md-actions')) {
	          $log.warn('Using a class of md-actions is deprecated, please use <md-dialog-actions>.');
	        }
	      }
	
	      /**
	       * For alerts, focus on content... otherwise focus on
	       * the close button (or equivalent)
	       */
	      function focusOnOpen() {
	        if (options.focusOnOpen) {
	          var target = $mdUtil.findFocusTarget(element) || findCloseButton() || dialogElement;
	          target.focus();
	        }
	
	        /**
	         * If no element with class dialog-close, try to find the last
	         * button child in md-actions and assume it is a close button.
	         *
	         * If we find no actions at all, log a warning to the console.
	         */
	        function findCloseButton() {
	          var closeButton = element[0].querySelector('.dialog-close');
	
	          if (!closeButton) {
	            var actionButtons = element[0].querySelectorAll('.md-actions button, md-dialog-actions button');
	            closeButton = actionButtons[actionButtons.length - 1];
	          }
	
	          return closeButton;
	        }
	      }
	    }
	
	    /**
	     * Remove function for all dialogs
	     */
	    function onRemove(scope, element, options) {
	      options.deactivateListeners();
	      options.unlockScreenReader();
	      options.hideBackdrop(options.$destroy);
	
	      // Remove the focus traps that we added earlier for keeping focus within the dialog.
	      if (topFocusTrap && topFocusTrap.parentNode) {
	        topFocusTrap.parentNode.removeChild(topFocusTrap);
	      }
	
	      if (bottomFocusTrap && bottomFocusTrap.parentNode) {
	        bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);
	      }
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	      return !!options.$destroy ? detachAndClean() : animateRemoval().then( detachAndClean );
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return dialogPopOut(element, options);
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        angular.element($document[0].body).removeClass('md-dialog-is-showing');
	        // Only remove the element, if it's not provided through the contentElement option.
	        if (!options.contentElement) {
	          element.remove();
	        } else {
	          options.reverseContainerStretch();
	          options.restoreContentElement();
	        }
	
	        if (!options.$destroy) options.origin.focus();
	      }
	    }
	
	    function detectTheming(options) {
	      // Only detect the theming, if the developer didn't specify the theme specifically.
	      if (options.theme) return;
	
	      options.theme = $mdTheming.defaultTheme();
	
	      if (options.targetEvent && options.targetEvent.target) {
	        var targetEl = angular.element(options.targetEvent.target);
	
	        // Once the user specifies a targetEvent, we will automatically try to find the correct
	        // nested theme.
	        options.theme = (targetEl.controller('mdTheme') || {}).$mdTheme || options.theme;
	      }
	
	    }
	
	    /**
	     * Installs a content element to the current $$interimElement provider options.
	     * @returns {Function} Function to restore the content element at its old DOM location.
	     */
	    function installContentElement(options) {
	      var contentEl = options.contentElement;
	      var restoreFn = null;
	
	      if (angular.isString(contentEl)) {
	        contentEl = document.querySelector(contentEl);
	        restoreFn = createRestoreFn(contentEl);
	      } else {
	        contentEl = contentEl[0] || contentEl;
	
	        // When the element is visible in the DOM, then we restore it at close of the dialog.
	        // Otherwise it will be removed from the DOM after close.
	        if (document.contains(contentEl)) {
	          restoreFn = createRestoreFn(contentEl);
	        } else {
	          restoreFn = function() {
	            contentEl.parentNode.removeChild(contentEl);
	          }
	        }
	      }
	
	      // Overwrite the options to use the content element.
	      options.element = angular.element(contentEl);
	      options.skipCompile = true;
	
	      return restoreFn;
	
	      function createRestoreFn(element) {
	        var parent = element.parentNode;
	        var nextSibling = element.nextElementSibling;
	
	        return function() {
	          if (!nextSibling) {
	            // When the element didn't had any sibling, then it can be simply appended to the
	            // parent, because it plays no role, which index it had before.
	            parent.appendChild(element);
	          } else {
	            // When the element had a sibling, which marks the previous position of the element
	            // in the DOM, we insert it correctly before the sibling, to have the same index as
	            // before.
	            parent.insertBefore(element, nextSibling);
	          }
	        }
	      }
	    }
	
	    /**
	     * Capture originator/trigger/from/to element information (if available)
	     * and the parent container for the dialog; defaults to the $rootElement
	     * unless overridden in the options.parent
	     */
	    function captureParentAndFromToElements(options) {
	          options.origin = angular.extend({
	            element: null,
	            bounds: null,
	            focus: angular.noop
	          }, options.origin || {});
	
	          options.parent   = getDomElement(options.parent, $rootElement);
	          options.closeTo  = getBoundingClientRect(getDomElement(options.closeTo));
	          options.openFrom = getBoundingClientRect(getDomElement(options.openFrom));
	
	          if ( options.targetEvent ) {
	            options.origin   = getBoundingClientRect(options.targetEvent.target, options.origin);
	          }
	
	
	          /**
	           * Identify the bounding RECT for the target element
	           *
	           */
	          function getBoundingClientRect (element, orig) {
	            var source = angular.element((element || {}));
	            if (source && source.length) {
	              // Compute and save the target element's bounding rect, so that if the
	              // element is hidden when the dialog closes, we can shrink the dialog
	              // back to the same position it expanded from.
	              //
	              // Checking if the source is a rect object or a DOM element
	              var bounds = {top:0,left:0,height:0,width:0};
	              var hasFn = angular.isFunction(source[0].getBoundingClientRect);
	
	              return angular.extend(orig || {}, {
	                  element : hasFn ? source : undefined,
	                  bounds  : hasFn ? source[0].getBoundingClientRect() : angular.extend({}, bounds, source[0]),
	                  focus   : angular.bind(source, source.focus),
	              });
	            }
	          }
	
	          /**
	           * If the specifier is a simple string selector, then query for
	           * the DOM element.
	           */
	          function getDomElement(element, defaultElement) {
	            if (angular.isString(element)) {
	              element = $document[0].querySelector(element);
	            }
	
	            // If we have a reference to a raw dom element, always wrap it in jqLite
	            return angular.element(element || defaultElement);
	          }
	
	        }
	
	    /**
	     * Listen for escape keys and outside clicks to auto close
	     */
	    function activateListeners(element, options) {
	      var window = angular.element($window);
	      var onWindowResize = $mdUtil.debounce(function() {
	        stretchDialogContainerToViewport(element, options);
	      }, 60);
	
	      var removeListeners = [];
	      var smartClose = function() {
	        // Only 'confirm' dialogs have a cancel button... escape/clickOutside will
	        // cancel or fallback to hide.
	        var closeFn = ( options.$type == 'alert' ) ? $mdDialog.hide : $mdDialog.cancel;
	        $mdUtil.nextTick(closeFn, true);
	      };
	
	      if (options.escapeToClose) {
	        var parentTarget = options.parent;
	        var keyHandlerFn = function(ev) {
	          if (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add keydown listeners
	        element.on('keydown', keyHandlerFn);
	        parentTarget.on('keydown', keyHandlerFn);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	
	          element.off('keydown', keyHandlerFn);
	          parentTarget.off('keydown', keyHandlerFn);
	
	        });
	      }
	
	      // Register listener to update dialog on window resize
	      window.on('resize', onWindowResize);
	
	      removeListeners.push(function() {
	        window.off('resize', onWindowResize);
	      });
	
	      if (options.clickOutsideToClose) {
	        var target = element;
	        var sourceElem;
	
	        // Keep track of the element on which the mouse originally went down
	        // so that we can only close the backdrop when the 'click' started on it.
	        // A simple 'click' handler does not work,
	        // it sets the target object as the element the mouse went down on.
	        var mousedownHandler = function(ev) {
	          sourceElem = ev.target;
	        };
	
	        // We check if our original element and the target is the backdrop
	        // because if the original was the backdrop and the target was inside the dialog
	        // we don't want to dialog to close.
	        var mouseupHandler = function(ev) {
	          if (sourceElem === target[0] && ev.target === target[0]) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add listeners
	        target.on('mousedown', mousedownHandler);
	        target.on('mouseup', mouseupHandler);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	          target.off('mousedown', mousedownHandler);
	          target.off('mouseup', mouseupHandler);
	        });
	      }
	
	      // Attach specific `remove` listener handler
	      options.deactivateListeners = function() {
	        removeListeners.forEach(function(removeFn) {
	          removeFn();
	        });
	        options.deactivateListeners = null;
	      };
	    }
	
	    /**
	     * Show modal backdrop element...
	     */
	    function showBackdrop(scope, element, options) {
	
	      if (options.disableParentScroll) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-dialog-backdrop md-opaque");
	        $animate.enter(options.backdrop, options.parent);
	      }
	
	      /**
	       * Hide modal backdrop element...
	       */
	      options.hideBackdrop = function hideBackdrop($destroy) {
	        if (options.backdrop) {
	          if ( !!$destroy ) options.backdrop.remove();
	          else              $animate.leave(options.backdrop);
	        }
	
	
	        if (options.disableParentScroll) {
	          options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        options.hideBackdrop = null;
	      };
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for Dialogs
	     */
	    function configureAria(element, options) {
	
	      var role = (options.$type === 'alert') ? 'alertdialog' : 'dialog';
	      var dialogContent = element.find('md-dialog-content');
	      var existingDialogId = element.attr('id');
	      var dialogContentId = 'dialogContent_' + (existingDialogId || $mdUtil.nextUid());
	
	      element.attr({
	        'role': role,
	        'tabIndex': '-1'
	      });
	
	      if (dialogContent.length === 0) {
	        dialogContent = element;
	        // If the dialog element already had an ID, don't clobber it.
	        if (existingDialogId) {
	          dialogContentId = existingDialogId;
	        }
	      }
	
	      dialogContent.attr('id', dialogContentId);
	      element.attr('aria-describedby', dialogContentId);
	
	      if (options.ariaLabel) {
	        $mdAria.expect(element, 'aria-label', options.ariaLabel);
	      }
	      else {
	        $mdAria.expectAsync(element, 'aria-label', function() {
	          var words = dialogContent.text().split(/\s+/);
	          if (words.length > 3) words = words.slice(0, 3).concat('...');
	          return words.join(' ');
	        });
	      }
	
	      // Set up elements before and after the dialog content to capture focus and
	      // redirect back into the dialog.
	      topFocusTrap = document.createElement('div');
	      topFocusTrap.classList.add('md-dialog-focus-trap');
	      topFocusTrap.tabIndex = 0;
	
	      bottomFocusTrap = topFocusTrap.cloneNode(false);
	
	      // When focus is about to move out of the dialog, we want to intercept it and redirect it
	      // back to the dialog element.
	      var focusHandler = function() {
	        element.focus();
	      };
	      topFocusTrap.addEventListener('focus', focusHandler);
	      bottomFocusTrap.addEventListener('focus', focusHandler);
	
	      // The top focus trap inserted immeidately before the md-dialog element (as a sibling).
	      // The bottom focus trap is inserted at the very end of the md-dialog element (as a child).
	      element[0].parentNode.insertBefore(topFocusTrap, element[0]);
	      element.after(bottomFocusTrap);
	    }
	
	    /**
	     * Prevents screen reader interaction behind modal window
	     * on swipe interfaces
	     */
	    function lockScreenReader(element, options) {
	      var isHidden = true;
	
	      // get raw DOM node
	      walkDOM(element[0]);
	
	      options.unlockScreenReader = function() {
	        isHidden = false;
	        walkDOM(element[0]);
	
	        options.unlockScreenReader = null;
	      };
	
	      /**
	       * Walk DOM to apply or remove aria-hidden on sibling nodes
	       * and parent sibling nodes
	       *
	       */
	      function walkDOM(element) {
	        while (element.parentNode) {
	          if (element === document.body) {
	            return;
	          }
	          var children = element.parentNode.children;
	          for (var i = 0; i < children.length; i++) {
	            // skip over child if it is an ascendant of the dialog
	            // or a script or style tag
	            if (element !== children[i] && !isNodeOneOf(children[i], ['SCRIPT', 'STYLE'])) {
	              children[i].setAttribute('aria-hidden', isHidden);
	            }
	          }
	
	          walkDOM(element = element.parentNode);
	        }
	      }
	    }
	
	    /**
	     * Ensure the dialog container fill-stretches to the viewport
	     */
	    function stretchDialogContainerToViewport(container, options) {
	      var isFixed = $window.getComputedStyle($document[0].body).position == 'fixed';
	      var backdrop = options.backdrop ? $window.getComputedStyle(options.backdrop[0]) : null;
	      var height = backdrop ? Math.min($document[0].body.clientHeight, Math.ceil(Math.abs(parseInt(backdrop.height, 10)))) : 0;
	
	      var previousStyles = {
	        top: container.css('top'),
	        height: container.css('height')
	      };
	
	      container.css({
	        top: (isFixed ? $mdUtil.scrollTop(options.parent) : 0) + 'px',
	        height: height ? height + 'px' : '100%'
	      });
	
	      return function() {
	        // Reverts the modified styles back to the previous values.
	        // This is needed for contentElements, which should have the same styles after close
	        // as before.
	        container.css(previousStyles);
	      };
	    }
	
	    /**
	     *  Dialog open and pop-in animation
	     */
	    function dialogPopIn(container, options) {
	      // Add the `md-dialog-container` to the DOM
	      options.parent.append(container);
	      options.reverseContainerStretch = stretchDialogContainerToViewport(container, options);
	
	      var dialogEl = container.find('md-dialog');
	      var animator = $mdUtil.dom.animator;
	      var buildTranslateToOrigin = animator.calculateZoomToOrigin;
	      var translateOptions = {transitionInClass: 'md-transition-in', transitionOutClass: 'md-transition-out'};
	      var from = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.openFrom || options.origin));
	      var to = animator.toTransformCss("");  // defaults to center display (or parent or $rootElement)
	
	      dialogEl.toggleClass('md-dialog-fullscreen', !!options.fullscreen);
	
	      return animator
	        .translate3d(dialogEl, from, to, translateOptions)
	        .then(function(animateReversal) {
	
	          // Build a reversal translate function synced to this translation...
	          options.reverseAnimate = function() {
	            delete options.reverseAnimate;
	
	            if (options.closeTo) {
	              // Using the opposite classes to create a close animation to the closeTo element
	              translateOptions = {transitionInClass: 'md-transition-out', transitionOutClass: 'md-transition-in'};
	              from = to;
	              to = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.closeTo));
	
	              return animator
	                .translate3d(dialogEl, from, to,translateOptions);
	            }
	
	            return animateReversal(
	              to = animator.toTransformCss(
	                // in case the origin element has moved or is hidden,
	                // let's recalculate the translateCSS
	                buildTranslateToOrigin(dialogEl, options.origin)
	              )
	            );
	
	          };
	
	          // Function to revert the generated animation styles on the dialog element.
	          // Useful when using a contentElement instead of a template.
	          options.clearAnimate = function() {
	            delete options.clearAnimate;
	
	            // Remove the transition classes, added from $animateCSS, since those can't be removed
	            // by reversely running the animator.
	            dialogEl.removeClass([
	              translateOptions.transitionOutClass,
	              translateOptions.transitionInClass
	            ].join(' '));
	
	            // Run the animation reversely to remove the previous added animation styles.
	            return animator.translate3d(dialogEl, to, animator.toTransformCss(''), {});
	          };
	
	          return true;
	        });
	    }
	
	    /**
	     * Dialog close and pop-out animation
	     */
	    function dialogPopOut(container, options) {
	      return options.reverseAnimate().then(function() {
	        if (options.contentElement) {
	          // When we use a contentElement, we want the element to be the same as before.
	          // That means, that we have to clear all the animation properties, like transform.
	          options.clearAnimate();
	        }
	      });
	    }
	
	    /**
	     * Utility function to filter out raw DOM nodes
	     */
	    function isNodeOneOf(elem, nodeTypeArray) {
	      if (nodeTypeArray.indexOf(elem.nodeName) !== -1) {
	        return true;
	      }
	    }
	
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.divider
	 * @description Divider module!
	 */
	MdDividerDirective.$inject = ["$mdTheming"];
	angular.module('material.components.divider', [
	  'material.core'
	])
	  .directive('mdDivider', MdDividerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdDivider
	 * @module material.components.divider
	 * @restrict E
	 *
	 * @description
	 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
	 *
	 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
	 * @usage
	 * <hljs lang="html">
	 * <md-divider></md-divider>
	 *
	 * <md-divider md-inset></md-divider>
	 * </hljs>
	 *
	 */
	function MdDividerDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: $mdTheming
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabActions
	   */
	  MdFabActionsDirective.$inject = ["$mdUtil"];
	  angular
	    .module('material.components.fabActions', ['material.core'])
	    .directive('mdFabActions', MdFabActionsDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabActions
	   * @module material.components.fabActions
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
	   * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
	   * proper event listeners.
	   *
	   * @usage
	   * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
	   */
	  function MdFabActionsDirective($mdUtil) {
	    return {
	      restrict: 'E',
	
	      require: ['^?mdFabSpeedDial', '^?mdFabToolbar'],
	
	      compile: function(element, attributes) {
	        var children = element.children();
	
	        var hasNgRepeat = $mdUtil.prefixer().hasAttribute(children, 'ng-repeat');
	
	        // Support both ng-repeat and static content
	        if (hasNgRepeat) {
	          children.addClass('md-fab-action-item');
	        } else {
	          // Wrap every child in a new div and add a class that we can scale/fling independently
	          children.wrap('<div class="md-fab-action-item">');
	        }
	      }
	    }
	  }
	
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  MdFabController.$inject = ["$scope", "$element", "$animate", "$mdUtil", "$mdConstant", "$timeout"];
	  angular.module('material.components.fabShared', ['material.core'])
	    .controller('MdFabController', MdFabController);
	
	  function MdFabController($scope, $element, $animate, $mdUtil, $mdConstant, $timeout) {
	    var vm = this;
	
	    // NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops
	
	    vm.open = function() {
	      $scope.$evalAsync("vm.isOpen = true");
	    };
	
	    vm.close = function() {
	      // Async eval to avoid conflicts with existing digest loops
	      $scope.$evalAsync("vm.isOpen = false");
	
	      // Focus the trigger when the element closes so users can still tab to the next item
	      $element.find('md-fab-trigger')[0].focus();
	    };
	
	    // Toggle the open/close state when the trigger is clicked
	    vm.toggle = function() {
	      $scope.$evalAsync("vm.isOpen = !vm.isOpen");
	    };
	
	    setupDefaults();
	    setupListeners();
	    setupWatchers();
	
	    var initialAnimationAttempts = 0;
	    fireInitialAnimations();
	
	    function setupDefaults() {
	      // Set the default direction to 'down' if none is specified
	      vm.direction = vm.direction || 'down';
	
	      // Set the default to be closed
	      vm.isOpen = vm.isOpen || false;
	
	      // Start the keyboard interaction at the first action
	      resetActionIndex();
	
	      // Add an animations waiting class so we know not to run
	      $element.addClass('md-animations-waiting');
	    }
	
	    function setupListeners() {
	      var eventTypes = [
	        'click', 'focusin', 'focusout'
	      ];
	
	      // Add our listeners
	      angular.forEach(eventTypes, function(eventType) {
	        $element.on(eventType, parseEvents);
	      });
	
	      // Remove our listeners when destroyed
	      $scope.$on('$destroy', function() {
	        angular.forEach(eventTypes, function(eventType) {
	          $element.off(eventType, parseEvents);
	        });
	
	        // remove any attached keyboard handlers in case element is removed while
	        // speed dial is open
	        disableKeyboard();
	      });
	    }
	
	    var closeTimeout;
	    function parseEvents(event) {
	      // If the event is a click, just handle it
	      if (event.type == 'click') {
	        handleItemClick(event);
	      }
	
	      // If we focusout, set a timeout to close the element
	      if (event.type == 'focusout' && !closeTimeout) {
	        closeTimeout = $timeout(function() {
	          vm.close();
	        }, 100, false);
	      }
	
	      // If we see a focusin and there is a timeout about to run, cancel it so we stay open
	      if (event.type == 'focusin' && closeTimeout) {
	        $timeout.cancel(closeTimeout);
	        closeTimeout = null;
	      }
	    }
	
	    function resetActionIndex() {
	      vm.currentActionIndex = -1;
	    }
	
	    function setupWatchers() {
	      // Watch for changes to the direction and update classes/attributes
	      $scope.$watch('vm.direction', function(newDir, oldDir) {
	        // Add the appropriate classes so we can target the direction in the CSS
	        $animate.removeClass($element, 'md-' + oldDir);
	        $animate.addClass($element, 'md-' + newDir);
	
	        // Reset the action index since it may have changed
	        resetActionIndex();
	      });
	
	      var trigger, actions;
	
	      // Watch for changes to md-open
	      $scope.$watch('vm.isOpen', function(isOpen) {
	        // Reset the action index since it may have changed
	        resetActionIndex();
	
	        // We can't get the trigger/actions outside of the watch because the component hasn't been
	        // linked yet, so we wait until the first watch fires to cache them.
	        if (!trigger || !actions) {
	          trigger = getTriggerElement();
	          actions = getActionsElement();
	        }
	
	        if (isOpen) {
	          enableKeyboard();
	        } else {
	          disableKeyboard();
	        }
	
	        var toAdd = isOpen ? 'md-is-open' : '';
	        var toRemove = isOpen ? '' : 'md-is-open';
	
	        // Set the proper ARIA attributes
	        trigger.attr('aria-haspopup', true);
	        trigger.attr('aria-expanded', isOpen);
	        actions.attr('aria-hidden', !isOpen);
	
	        // Animate the CSS classes
	        $animate.setClass($element, toAdd, toRemove);
	      });
	    }
	
	    function fireInitialAnimations() {
	      // If the element is actually visible on the screen
	      if ($element[0].scrollHeight > 0) {
	        // Fire our animation
	        $animate.addClass($element, '_md-animations-ready').then(function() {
	          // Remove the waiting class
	          $element.removeClass('md-animations-waiting');
	        });
	      }
	
	      // Otherwise, try for up to 1 second before giving up
	      else if (initialAnimationAttempts < 10) {
	        $timeout(fireInitialAnimations, 100);
	
	        // Increment our counter
	        initialAnimationAttempts = initialAnimationAttempts + 1;
	      }
	    }
	
	    function enableKeyboard() {
	      $element.on('keydown', keyPressed);
	
	      // On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
	      // clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
	      $mdUtil.nextTick(function() {
	        angular.element(document).on('click touchend', checkForOutsideClick);
	      });
	
	      // TODO: On desktop, we should be able to reset the indexes so you cannot tab through, but
	      // this breaks accessibility, especially on mobile, since you have no arrow keys to press
	      //resetActionTabIndexes();
	    }
	
	    function disableKeyboard() {
	      $element.off('keydown', keyPressed);
	      angular.element(document).off('click touchend', checkForOutsideClick);
	    }
	
	    function checkForOutsideClick(event) {
	      if (event.target) {
	        var closestTrigger = $mdUtil.getClosest(event.target, 'md-fab-trigger');
	        var closestActions = $mdUtil.getClosest(event.target, 'md-fab-actions');
	
	        if (!closestTrigger && !closestActions) {
	          vm.close();
	        }
	      }
	    }
	
	    function keyPressed(event) {
	      switch (event.which) {
	        case $mdConstant.KEY_CODE.ESCAPE: vm.close(); event.preventDefault(); return false;
	        case $mdConstant.KEY_CODE.LEFT_ARROW: doKeyLeft(event); return false;
	        case $mdConstant.KEY_CODE.UP_ARROW: doKeyUp(event); return false;
	        case $mdConstant.KEY_CODE.RIGHT_ARROW: doKeyRight(event); return false;
	        case $mdConstant.KEY_CODE.DOWN_ARROW: doKeyDown(event); return false;
	      }
	    }
	
	    function doActionPrev(event) {
	      focusAction(event, -1);
	    }
	
	    function doActionNext(event) {
	      focusAction(event, 1);
	    }
	
	    function focusAction(event, direction) {
	      var actions = resetActionTabIndexes();
	
	      // Increment/decrement the counter with restrictions
	      vm.currentActionIndex = vm.currentActionIndex + direction;
	      vm.currentActionIndex = Math.min(actions.length - 1, vm.currentActionIndex);
	      vm.currentActionIndex = Math.max(0, vm.currentActionIndex);
	
	      // Focus the element
	      var focusElement =  angular.element(actions[vm.currentActionIndex]).children()[0];
	      angular.element(focusElement).attr('tabindex', 0);
	      focusElement.focus();
	
	      // Make sure the event doesn't bubble and cause something else
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    }
	
	    function resetActionTabIndexes() {
	      // Grab all of the actions
	      var actions = getActionsElement()[0].querySelectorAll('.md-fab-action-item');
	
	      // Disable all other actions for tabbing
	      angular.forEach(actions, function(action) {
	        angular.element(angular.element(action).children()[0]).attr('tabindex', -1);
	      });
	
	      return actions;
	    }
	
	    function doKeyLeft(event) {
	      if (vm.direction === 'left') {
	        doActionNext(event);
	      } else {
	        doActionPrev(event);
	      }
	    }
	
	    function doKeyUp(event) {
	      if (vm.direction === 'down') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyRight(event) {
	      if (vm.direction === 'left') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyDown(event) {
	      if (vm.direction === 'up') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function isTrigger(element) {
	      return $mdUtil.getClosest(element, 'md-fab-trigger');
	    }
	
	    function isAction(element) {
	      return $mdUtil.getClosest(element, 'md-fab-actions');
	    }
	
	    function handleItemClick(event) {
	      if (isTrigger(event.target)) {
	        vm.toggle();
	      }
	
	      if (isAction(event.target)) {
	        vm.close();
	      }
	    }
	
	    function getTriggerElement() {
	      return $element.find('md-fab-trigger');
	    }
	
	    function getActionsElement() {
	      return $element.find('md-fab-actions');
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * The duration of the CSS animation in milliseconds.
	   *
	   * @type {number}
	   */
	  MdFabSpeedDialFlingAnimation.$inject = ["$timeout"];
	  MdFabSpeedDialScaleAnimation.$inject = ["$timeout"];
	  var cssAnimationDuration = 300;
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabSpeedDial
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabSpeedDial', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabSpeedDial', MdFabSpeedDialDirective)
	
	    // Register our custom animations
	    .animation('.md-fling', MdFabSpeedDialFlingAnimation)
	    .animation('.md-scale', MdFabSpeedDialScaleAnimation)
	
	    // Register a service for each animation so that we can easily inject them into unit tests
	    .service('mdFabSpeedDialFlingAnimation', MdFabSpeedDialFlingAnimation)
	    .service('mdFabSpeedDialScaleAnimation', MdFabSpeedDialScaleAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabSpeedDial
	   * @module material.components.fabSpeedDial
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
	   * `<md-button>`s) for quick access to common actions.
	   *
	   * There are currently two animations available by applying one of the following classes to
	   * the component:
	   *
	   *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
	   *    appropriate positions.
	   *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-speed-dial>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
	   * open or close the speed dial. However, if you wish to allow users to hover over the empty
	   * space where the actions will appear, you must also add the `md-hover-full` class to the speed
	   * dial element. Without this, the hover effect will only occur on top of the trigger.
	   *
	   * See the demos for more information.
	   *
	   * ## Troubleshooting
	   *
	   * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
	   * the parent container to ensure that it is only visible once ready. We have plans to remove this
	   * necessity in the future.
	   *
	   * @usage
	   * <hljs lang="html">
	   * <md-fab-speed-dial md-direction="up" class="md-fling">
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon icon="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-fab-actions>
	   *     <md-button aria-label="Add User">
	   *       <md-icon icon="/img/icons/user.svg"></md-icon>
	   *     </md-button>
	   *
	   *     <md-button aria-label="Add Group">
	   *       <md-icon icon="/img/icons/group.svg"></md-icon>
	   *     </md-button>
	   *   </md-fab-actions>
	   * </md-fab-speed-dial>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the speed dial to appear
	   * relative to the trigger element.
	   * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
	   */
	  function MdFabSpeedDialDirective() {
	    return {
	      restrict: 'E',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: FabSpeedDialLink
	    };
	
	    function FabSpeedDialLink(scope, element) {
	      // Prepend an element to hold our CSS variables so we can use them in the animations below
	      element.prepend('<div class="_md-css-variables"></div>');
	    }
	  }
	
	  function MdFabSpeedDialFlingAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    function runAnimation(element) {
	      // Don't run if we are still waiting and we are not ready
	      if (element.hasClass('md-animations-waiting') && !element.hasClass('_md-animations-ready')) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our trigger element
	      var triggerElement = el.querySelector('md-fab-trigger');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style;
	
	        styles.transform = styles.webkitTransform = '';
	        styles.transitionDelay = '';
	        styles.opacity = 1;
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	
	      // Set the trigger to be above all of the actions so they disappear behind it.
	      triggerElement.style.zIndex = startZIndex + items.length + 1;
	
	      // If the control is closed, hide the items behind the trigger
	      if (!ctrl.isOpen) {
	        angular.forEach(items, function(item, index) {
	          var newPosition, axis;
	          var styles = item.style;
	
	          // Make sure to account for differences in the dimensions of the trigger verses the items
	          // so that we can properly center everything; this helps hide the item's shadows behind
	          // the trigger.
	          var triggerItemHeightOffset = (triggerElement.clientHeight - item.clientHeight) / 2;
	          var triggerItemWidthOffset = (triggerElement.clientWidth - item.clientWidth) / 2;
	
	          switch (ctrl.direction) {
	            case 'up':
	              newPosition = (item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'down':
	              newPosition = -(item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'left':
	              newPosition = (item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	            case 'right':
	              newPosition = -(item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	          }
	
	          var newTranslate = 'translate' + axis + '(' + newPosition + 'px)';
	
	          styles.transform = styles.webkitTransform = newTranslate;
	        });
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        if (element.hasClass('md-fling')) {
	          runAnimation(element);
	          delayDone(done);
	        } else {
	          done();
	        }
	      },
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    }
	  }
	
	  function MdFabSpeedDialScaleAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    var delay = 65;
	
	    function runAnimation(element) {
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style,
	          offsetDelay = index * delay;
	
	        styles.opacity = ctrl.isOpen ? 1 : 0;
	        styles.transform = styles.webkitTransform = ctrl.isOpen ? 'scale(1)' : 'scale(0)';
	        styles.transitionDelay = (ctrl.isOpen ? offsetDelay : (items.length - offsetDelay)) + 'ms';
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabToolbar
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabToolbar', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabToolbar', MdFabToolbarDirective)
	
	    // Register our custom animations
	    .animation('.md-fab-toolbar', MdFabToolbarAnimation)
	
	    // Register a service for the animation so that we can easily inject it into unit tests
	    .service('mdFabToolbarAnimation', MdFabToolbarAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabToolbar
	   * @module material.components.fabToolbar
	   *
	   * @restrict E
	   *
	   * @description
	   *
	   * The `<md-fab-toolbar>` directive is used present a toolbar of elements (usually `<md-button>`s)
	   * for quick access to common actions when a floating action button is activated (via click or
	   * keyboard navigation).
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-toolbar>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   * <md-fab-toolbar md-direction='left'>
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon icon="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-toolbar>
	   *    <md-fab-actions>
	   *      <md-button aria-label="Add User">
	   *        <md-icon icon="/img/icons/user.svg"></md-icon>
	   *      </md-button>
	   *
	   *      <md-button aria-label="Add Group">
	   *        <md-icon icon="/img/icons/group.svg"></md-icon>
	   *      </md-button>
	   *    </md-fab-actions>
	   *   </md-toolbar>
	   * </md-fab-toolbar>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the toolbar items to appear
	   * relative to the trigger element. Supports `left` and `right` directions.
	   * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
	   */
	  function MdFabToolbarDirective() {
	    return {
	      restrict: 'E',
	      transclude: true,
	      template: '<div class="md-fab-toolbar-wrapper">' +
	      '  <div class="md-fab-toolbar-content" ng-transclude></div>' +
	      '</div>',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: link
	    };
	
	    function link(scope, element, attributes) {
	      // Add the base class for animations
	      element.addClass('md-fab-toolbar');
	
	      // Prepend the background element to the trigger's button
	      element.find('md-fab-trigger').find('button')
	        .prepend('<div class="md-fab-toolbar-background"></div>');
	    }
	  }
	
	  function MdFabToolbarAnimation() {
	
	    function runAnimation(element, className, done) {
	      // If no className was specified, don't do anything
	      if (!className) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabToolbar');
	
	      // Grab the relevant child elements
	      var backgroundElement = el.querySelector('.md-fab-toolbar-background');
	      var triggerElement = el.querySelector('md-fab-trigger button');
	      var toolbarElement = el.querySelector('md-toolbar');
	      var iconElement = el.querySelector('md-fab-trigger button md-icon');
	      var actions = element.find('md-fab-actions').children();
	
	      // If we have both elements, use them to position the new background
	      if (triggerElement && backgroundElement) {
	        // Get our variables
	        var color = window.getComputedStyle(triggerElement).getPropertyValue('background-color');
	        var width = el.offsetWidth;
	        var height = el.offsetHeight;
	
	        // Make it twice as big as it should be since we scale from the center
	        var scale = 2 * (width / triggerElement.offsetWidth);
	
	        // Set some basic styles no matter what animation we're doing
	        backgroundElement.style.backgroundColor = color;
	        backgroundElement.style.borderRadius = width + 'px';
	
	        // If we're open
	        if (ctrl.isOpen) {
	          // Turn on toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'inherit';
	
	          backgroundElement.style.width = triggerElement.offsetWidth + 'px';
	          backgroundElement.style.height = triggerElement.offsetHeight + 'px';
	          backgroundElement.style.transform = 'scale(' + scale + ')';
	
	          // Set the next close animation to have the proper delays
	          backgroundElement.style.transitionDelay = '0ms';
	          iconElement && (iconElement.style.transitionDelay = '.3s');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = (actions.length - index) * 25 + 'ms';
	          });
	        } else {
	          // Turn off toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'none';
	
	          // Scale it back down to the trigger's size
	          backgroundElement.style.transform = 'scale(1)';
	
	          // Reset the position
	          backgroundElement.style.top = '0';
	
	          if (element.hasClass('md-right')) {
	            backgroundElement.style.left = '0';
	            backgroundElement.style.right = null;
	          }
	
	          if (element.hasClass('md-left')) {
	            backgroundElement.style.right = '0';
	            backgroundElement.style.left = null;
	          }
	
	          // Set the next open animation to have the proper delays
	          backgroundElement.style.transitionDelay = '200ms';
	          iconElement && (iconElement.style.transitionDelay = '0ms');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = 200 + (index * 25) + 'ms';
	          });
	        }
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      }
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.gridList
	 */
	GridListController.$inject = ["$mdUtil"];
	GridLayoutFactory.$inject = ["$mdUtil"];
	GridListDirective.$inject = ["$interpolate", "$mdConstant", "$mdGridLayout", "$mdMedia"];
	GridTileDirective.$inject = ["$mdMedia"];
	angular.module('material.components.gridList', ['material.core'])
	       .directive('mdGridList', GridListDirective)
	       .directive('mdGridTile', GridTileDirective)
	       .directive('mdGridTileFooter', GridTileCaptionDirective)
	       .directive('mdGridTileHeader', GridTileCaptionDirective)
	       .factory('$mdGridLayout', GridLayoutFactory);
	
	/**
	 * @ngdoc directive
	 * @name mdGridList
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Grid lists are an alternative to standard list views. Grid lists are distinct
	 * from grids used for layouts and other visual presentations.
	 *
	 * A grid list is best suited to presenting a homogenous data type, typically
	 * images, and is optimized for visual comprehension and differentiating between
	 * like data types.
	 *
	 * A grid list is a continuous element consisting of tessellated, regular
	 * subdivisions called cells that contain tiles (`md-grid-tile`).
	 *
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
	 *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
	 *    style="width: 300px; height: auto;" alt="Grid concepts legend">
	 *
	 * Cells are arrayed vertically and horizontally within the grid.
	 *
	 * Tiles hold content and can span one or more cells vertically or horizontally.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-list` directive supports "responsive" attributes, which allow
	 * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
	 * currently matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-cols-lg="8"`)
	 *
	 * @param {number} md-cols Number of columns in the grid.
	 * @param {string} md-row-height One of
	 * <ul>
	 *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
	 *   <li>`{width}:{height}` - Ratio of width to height (eg.
	 *   `md-row-height="16:9"`)</li>
	 *   <li>`"fit"` - Height will be determined by subdividing the available
	 *   height by the number of rows</li>
	 * </ul>
	 * @param {string=} md-gutter The amount of space between tiles in CSS units
	 *     (default 1px)
	 * @param {expression=} md-on-layout Expression to evaluate after layout. Event
	 *     object is available as `$event`, and contains performance information.
	 *
	 * @usage
	 * Basic:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fixed-height rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="200px" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fit rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Using responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-list
	 *     md-cols-sm="2"
	 *     md-cols-md="4"
	 *     md-cols-lg="8"
	 *     md-cols-gt-lg="12"
	 *     ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 */
	function GridListDirective($interpolate, $mdConstant, $mdGridLayout, $mdMedia) {
	  return {
	    restrict: 'E',
	    controller: GridListController,
	    scope: {
	      mdOnLayout: '&'
	    },
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, ctrl) {
	    element.addClass('_md');     // private md component indicator for styling
	    
	    // Apply semantics
	    element.attr('role', 'list');
	
	    // Provide the controller with a way to trigger layouts.
	    ctrl.layoutDelegate = layoutDelegate;
	
	    var invalidateLayout = angular.bind(ctrl, ctrl.invalidateLayout),
	        unwatchAttrs = watchMedia();
	      scope.$on('$destroy', unwatchMedia);
	
	    /**
	     * Watches for changes in media, invalidating layout as necessary.
	     */
	    function watchMedia() {
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia(mediaName); // initialize
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .addListener(invalidateLayout);
	      }
	      return $mdMedia.watchResponsiveAttributes(
	          ['md-cols', 'md-row-height', 'md-gutter'], attrs, layoutIfMediaMatch);
	    }
	
	    function unwatchMedia() {
	      ctrl.layoutDelegate = angular.noop;
	
	      unwatchAttrs();
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .removeListener(invalidateLayout);
	      }
	    }
	
	    /**
	     * Performs grid layout if the provided mediaName matches the currently
	     * active media type.
	     */
	    function layoutIfMediaMatch(mediaName) {
	      if (mediaName == null) {
	        // TODO(shyndman): It would be nice to only layout if we have
	        // instances of attributes using this media type
	        ctrl.invalidateLayout();
	      } else if ($mdMedia(mediaName)) {
	        ctrl.invalidateLayout();
	      }
	    }
	
	    var lastLayoutProps;
	
	    /**
	     * Invokes the layout engine, and uses its results to lay out our
	     * tile elements.
	     *
	     * @param {boolean} tilesInvalidated Whether tiles have been
	     *    added/removed/moved since the last layout. This is to avoid situations
	     *    where tiles are replaced with properties identical to their removed
	     *    counterparts.
	     */
	    function layoutDelegate(tilesInvalidated) {
	      var tiles = getTileElements();
	      var props = {
	        tileSpans: getTileSpans(tiles),
	        colCount: getColumnCount(),
	        rowMode: getRowMode(),
	        rowHeight: getRowHeight(),
	        gutter: getGutter()
	      };
	
	      if (!tilesInvalidated && angular.equals(props, lastLayoutProps)) {
	        return;
	      }
	
	      var performance =
	        $mdGridLayout(props.colCount, props.tileSpans, tiles)
	          .map(function(tilePositions, rowCount) {
	            return {
	              grid: {
	                element: element,
	                style: getGridStyle(props.colCount, rowCount,
	                    props.gutter, props.rowMode, props.rowHeight)
	              },
	              tiles: tilePositions.map(function(ps, i) {
	                return {
	                  element: angular.element(tiles[i]),
	                  style: getTileStyle(ps.position, ps.spans,
	                      props.colCount, rowCount,
	                      props.gutter, props.rowMode, props.rowHeight)
	                }
	              })
	            }
	          })
	          .reflow()
	          .performance();
	
	      // Report layout
	      scope.mdOnLayout({
	        $event: {
	          performance: performance
	        }
	      });
	
	      lastLayoutProps = props;
	    }
	
	    // Use $interpolate to do some simple string interpolation as a convenience.
	
	    var startSymbol = $interpolate.startSymbol();
	    var endSymbol = $interpolate.endSymbol();
	
	    // Returns an expression wrapped in the interpolator's start and end symbols.
	    function expr(exprStr) {
	      return startSymbol + exprStr + endSymbol;
	    }
	
	    // The amount of space a single 1x1 tile would take up (either width or height), used as
	    // a basis for other calculations. This consists of taking the base size percent (as would be
	    // if evenly dividing the size between cells), and then subtracting the size of one gutter.
	    // However, since there are no gutters on the edges, each tile only uses a fration
	    // (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
	    // tile, and then breaking up the extra gutter on the edge evenly among the cells).
	    var UNIT = $interpolate(expr('share') + '% - (' + expr('gutter') + ' * ' + expr('gutterShare') + ')');
	
	    // The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	    // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
	    // row/column (offset).
	    var POSITION  = $interpolate('calc((' + expr('unit') + ' + ' + expr('gutter') + ') * ' + expr('offset') + ')');
	
	    // The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
	    // This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
	    // in the space that the gutter would normally have used (which was already accounted for in
	    // the base unit calculation).
	    var DIMENSION = $interpolate('calc((' + expr('unit') + ') * ' + expr('span') + ' + (' + expr('span') + ' - 1) * ' + expr('gutter') + ')');
	
	    /**
	     * Gets the styles applied to a tile element described by the given parameters.
	     * @param {{row: number, col: number}} position The row and column indices of the tile.
	     * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
	     * @param {number} colCount The number of columns.
	     * @param {number} rowCount The number of rows.
	     * @param {string} gutter The amount of space between tiles. This will be something like
	     *     '5px' or '2em'.
	     * @param {string} rowMode The row height mode. Can be one of:
	     *     'fixed': all rows have a fixed size, given by rowHeight,
	     *     'ratio': row height defined as a ratio to width, or
	     *     'fit': fit to the grid-list element height, divinding evenly among rows.
	     * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
	     *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
	     * @returns {Object} Map of CSS properties to be applied to the style element. Will define
	     *     values for top, left, width, height, marginTop, and paddingTop.
	     */
	    function getTileStyle(position, spans, colCount, rowCount, gutter, rowMode, rowHeight) {
	      // TODO(shyndman): There are style caching opportunities here.
	
	      // Percent of the available horizontal space that one column takes up.
	      var hShare = (1 / colCount) * 100;
	
	      // Fraction of the gutter size that each column takes up.
	      var hGutterShare = (colCount - 1) / colCount;
	
	      // Base horizontal size of a column.
	      var hUnit = UNIT({share: hShare, gutterShare: hGutterShare, gutter: gutter});
	
	      // The width and horizontal position of each tile is always calculated the same way, but the
	      // height and vertical position depends on the rowMode.
	      var style = {
	        left: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	        width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	        // resets
	        paddingTop: '',
	        marginTop: '',
	        top: '',
	        height: ''
	      };
	
	      switch (rowMode) {
	        case 'fixed':
	          // In fixed mode, simply use the given rowHeight.
	          style.top = POSITION({ unit: rowHeight, offset: position.row, gutter: gutter });
	          style.height = DIMENSION({ unit: rowHeight, span: spans.row, gutter: gutter });
	          break;
	
	        case 'ratio':
	          // Percent of the available vertical space that one row takes up. Here, rowHeight holds
	          // the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
	          var vShare = hShare / rowHeight;
	
	          // Base veritcal size of a row.
	          var vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          // padidngTop and marginTop are used to maintain the given aspect ratio, as
	          // a percentage-based value for these properties is applied to the *width* of the
	          // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
	          style.paddingTop = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter});
	          style.marginTop = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
	          break;
	
	        case 'fit':
	          // Fraction of the gutter size that each column takes up.
	          var vGutterShare = (rowCount - 1) / rowCount;
	
	          // Percent of the available vertical space that one row takes up.
	          var vShare = (1 / rowCount) * 100;
	
	          // Base vertical size of a row.
	          var vUnit = UNIT({share: vShare, gutterShare: vGutterShare, gutter: gutter});
	
	          style.top = POSITION({unit: vUnit, offset: position.row, gutter: gutter});
	          style.height = DIMENSION({unit: vUnit, span: spans.row, gutter: gutter});
	          break;
	      }
	
	      return style;
	    }
	
	    function getGridStyle(colCount, rowCount, gutter, rowMode, rowHeight) {
	      var style = {};
	
	      switch(rowMode) {
	        case 'fixed':
	          style.height = DIMENSION({ unit: rowHeight, span: rowCount, gutter: gutter });
	          style.paddingBottom = '';
	          break;
	
	        case 'ratio':
	          // rowHeight is width / height
	          var hGutterShare = colCount === 1 ? 0 : (colCount - 1) / colCount,
	              hShare = (1 / colCount) * 100,
	              vShare = hShare * (1 / rowHeight),
	              vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          style.height = '';
	          style.paddingBottom = DIMENSION({ unit: vUnit, span: rowCount, gutter: gutter});
	          break;
	
	        case 'fit':
	          // noop, as the height is user set
	          break;
	      }
	
	      return style;
	    }
	
	    function getTileElements() {
	      return [].filter.call(element.children(), function(ele) {
	        return ele.tagName == 'MD-GRID-TILE' && !ele.$$mdDestroyed;
	      });
	    }
	
	    /**
	     * Gets an array of objects containing the rowspan and colspan for each tile.
	     * @returns {Array<{row: number, col: number}>}
	     */
	    function getTileSpans(tileElements) {
	      return [].map.call(tileElements, function(ele) {
	        var ctrl = angular.element(ele).controller('mdGridTile');
	        return {
	          row: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-rowspan'), 10) || 1,
	          col: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-colspan'), 10) || 1
	        };
	      });
	    }
	
	    function getColumnCount() {
	      var colCount = parseInt($mdMedia.getResponsiveAttribute(attrs, 'md-cols'), 10);
	      if (isNaN(colCount)) {
	        throw 'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';
	      }
	      return colCount;
	    }
	
	    function getGutter() {
	      return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs, 'md-gutter') || 1);
	    }
	
	    function getRowHeight() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      switch (getRowMode()) {
	        case 'fixed':
	          return applyDefaultUnit(rowHeight);
	        case 'ratio':
	          var whRatio = rowHeight.split(':');
	          return parseFloat(whRatio[0]) / parseFloat(whRatio[1]);
	        case 'fit':
	          return 0; // N/A
	      }
	    }
	
	    function getRowMode() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      if (rowHeight == 'fit') {
	        return 'fit';
	      } else if (rowHeight.indexOf(':') !== -1) {
	        return 'ratio';
	      } else {
	        return 'fixed';
	      }
	    }
	
	    function applyDefaultUnit(val) {
	      return /\D$/.test(val) ? val : val + 'px';
	    }
	  }
	}
	
	/* @ngInject */
	function GridListController($mdUtil) {
	  this.layoutInvalidated = false;
	  this.tilesInvalidated = false;
	  this.$timeout_ = $mdUtil.nextTick;
	  this.layoutDelegate = angular.noop;
	}
	
	GridListController.prototype = {
	  invalidateTiles: function() {
	    this.tilesInvalidated = true;
	    this.invalidateLayout();
	  },
	
	  invalidateLayout: function() {
	    if (this.layoutInvalidated) {
	      return;
	    }
	    this.layoutInvalidated = true;
	    this.$timeout_(angular.bind(this, this.layout));
	  },
	
	  layout: function() {
	    try {
	      this.layoutDelegate(this.tilesInvalidated);
	    } finally {
	      this.layoutInvalidated = false;
	      this.tilesInvalidated = false;
	    }
	  }
	};
	
	
	/* @ngInject */
	function GridLayoutFactory($mdUtil) {
	  var defaultAnimator = GridTileAnimator;
	
	  /**
	   * Set the reflow animator callback
	   */
	  GridLayout.animateWith = function(customAnimator) {
	    defaultAnimator = !angular.isFunction(customAnimator) ? GridTileAnimator : customAnimator;
	  };
	
	  return GridLayout;
	
	  /**
	   * Publish layout function
	   */
	  function GridLayout(colCount, tileSpans) {
	      var self, layoutInfo, gridStyles, layoutTime, mapTime, reflowTime;
	
	      layoutTime = $mdUtil.time(function() {
	        layoutInfo = calculateGridFor(colCount, tileSpans);
	      });
	
	      return self = {
	
	        /**
	         * An array of objects describing each tile's position in the grid.
	         */
	        layoutInfo: function() {
	          return layoutInfo;
	        },
	
	        /**
	         * Maps grid positioning to an element and a set of styles using the
	         * provided updateFn.
	         */
	        map: function(updateFn) {
	          mapTime = $mdUtil.time(function() {
	            var info = self.layoutInfo();
	            gridStyles = updateFn(info.positioning, info.rowCount);
	          });
	          return self;
	        },
	
	        /**
	         * Default animator simply sets the element.css( <styles> ). An alternate
	         * animator can be provided as an argument. The function has the following
	         * signature:
	         *
	         *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
	         */
	        reflow: function(animatorFn) {
	          reflowTime = $mdUtil.time(function() {
	            var animator = animatorFn || defaultAnimator;
	            animator(gridStyles.grid, gridStyles.tiles);
	          });
	          return self;
	        },
	
	        /**
	         * Timing for the most recent layout run.
	         */
	        performance: function() {
	          return {
	            tileCount: tileSpans.length,
	            layoutTime: layoutTime,
	            mapTime: mapTime,
	            reflowTime: reflowTime,
	            totalTime: layoutTime + mapTime + reflowTime
	          };
	        }
	      };
	    }
	
	  /**
	   * Default Gridlist animator simple sets the css for each element;
	   * NOTE: any transitions effects must be manually set in the CSS.
	   * e.g.
	   *
	   *  md-grid-tile {
	   *    transition: all 700ms ease-out 50ms;
	   *  }
	   *
	   */
	  function GridTileAnimator(grid, tiles) {
	    grid.element.css(grid.style);
	    tiles.forEach(function(t) {
	      t.element.css(t.style);
	    })
	  }
	
	  /**
	   * Calculates the positions of tiles.
	   *
	   * The algorithm works as follows:
	   *    An Array<Number> with length colCount (spaceTracker) keeps track of
	   *    available tiling positions, where elements of value 0 represents an
	   *    empty position. Space for a tile is reserved by finding a sequence of
	   *    0s with length <= than the tile's colspan. When such a space has been
	   *    found, the occupied tile positions are incremented by the tile's
	   *    rowspan value, as these positions have become unavailable for that
	   *    many rows.
	   *
	   *    If the end of a row has been reached without finding space for the
	   *    tile, spaceTracker's elements are each decremented by 1 to a minimum
	   *    of 0. Rows are searched in this fashion until space is found.
	   */
	  function calculateGridFor(colCount, tileSpans) {
	    var curCol = 0,
	        curRow = 0,
	        spaceTracker = newSpaceTracker();
	
	    return {
	      positioning: tileSpans.map(function(spans, i) {
	        return {
	          spans: spans,
	          position: reserveSpace(spans, i)
	        };
	      }),
	      rowCount: curRow + Math.max.apply(Math, spaceTracker)
	    };
	
	    function reserveSpace(spans, i) {
	      if (spans.col > colCount) {
	        throw 'md-grid-list: Tile at position ' + i + ' has a colspan ' +
	            '(' + spans.col + ') that exceeds the column count ' +
	            '(' + colCount + ')';
	      }
	
	      var start = 0,
	          end = 0;
	
	      // TODO(shyndman): This loop isn't strictly necessary if you can
	      // determine the minimum number of rows before a space opens up. To do
	      // this, recognize that you've iterated across an entire row looking for
	      // space, and if so fast-forward by the minimum rowSpan count. Repeat
	      // until the required space opens up.
	      while (end - start < spans.col) {
	        if (curCol >= colCount) {
	          nextRow();
	          continue;
	        }
	
	        start = spaceTracker.indexOf(0, curCol);
	        if (start === -1 || (end = findEnd(start + 1)) === -1) {
	          start = end = 0;
	          nextRow();
	          continue;
	        }
	
	        curCol = end + 1;
	      }
	
	      adjustRow(start, spans.col, spans.row);
	      curCol = start + spans.col;
	
	      return {
	        col: start,
	        row: curRow
	      };
	    }
	
	    function nextRow() {
	      curCol = 0;
	      curRow++;
	      adjustRow(0, colCount, -1); // Decrement row spans by one
	    }
	
	    function adjustRow(from, cols, by) {
	      for (var i = from; i < from + cols; i++) {
	        spaceTracker[i] = Math.max(spaceTracker[i] + by, 0);
	      }
	    }
	
	    function findEnd(start) {
	      var i;
	      for (i = start; i < spaceTracker.length; i++) {
	        if (spaceTracker[i] !== 0) {
	          return i;
	        }
	      }
	
	      if (i === spaceTracker.length) {
	        return i;
	      }
	    }
	
	    function newSpaceTracker() {
	      var tracker = [];
	      for (var i = 0; i < colCount; i++) {
	        tracker.push(0);
	      }
	      return tracker;
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdGridTile
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Tiles contain the content of an `md-grid-list`. They span one or more grid
	 * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
	 * display secondary content.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-tile` directive supports "responsive" attributes, which allow
	 * different `md-rowspan` and `md-colspan` values depending on the currently
	 * matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-colspan-sm="4"`)
	 *
	 * @param {number=} md-colspan The number of columns to span (default 1). Cannot
	 *    exceed the number of columns in the grid. Supports interpolation.
	 * @param {number=} md-rowspan The number of rows to span (default 1). Supports
	 *     interpolation.
	 *
	 * @usage
	 * With header:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-header>
	 *     <h3>This is a header</h3>
	 *   </md-grid-tile-header>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * With footer:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-footer>
	 *     <h3>This is a footer</h3>
	 *   </md-grid-tile-footer>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Spanning multiple rows/columns:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="2" md-rowspan="3">
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
	 * </md-grid-tile>
	 * </hljs>
	 */
	function GridTileDirective($mdMedia) {
	  return {
	    restrict: 'E',
	    require: '^mdGridList',
	    template: '<figure ng-transclude></figure>',
	    transclude: true,
	    scope: {},
	    // Simple controller that exposes attributes to the grid directive
	    controller: ["$attrs", function($attrs) {
	      this.$attrs = $attrs;
	    }],
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, gridCtrl) {
	    // Apply semantics
	    element.attr('role', 'listitem');
	
	    // If our colspan or rowspan changes, trigger a layout
	    var unwatchAttrs = $mdMedia.watchResponsiveAttributes(['md-colspan', 'md-rowspan'],
	        attrs, angular.bind(gridCtrl, gridCtrl.invalidateLayout));
	
	    // Tile registration/deregistration
	    gridCtrl.invalidateTiles();
	    scope.$on('$destroy', function() {
	      // Mark the tile as destroyed so it is no longer considered in layout,
	      // even if the DOM element sticks around (like during a leave animation)
	      element[0].$$mdDestroyed = true;
	      unwatchAttrs();
	      gridCtrl.invalidateLayout();
	    });
	
	    if (angular.isDefined(scope.$parent.$index)) {
	      scope.$watch(function() { return scope.$parent.$index; },
	        function indexChanged(newIdx, oldIdx) {
	          if (newIdx === oldIdx) {
	            return;
	          }
	          gridCtrl.invalidateTiles();
	        });
	    }
	  }
	}
	
	
	function GridTileCaptionDirective() {
	  return {
	    template: '<figcaption ng-transclude></figcaption>',
	    transclude: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.icon
	 * @description
	 * Icon
	 */
	angular.module('material.components.icon', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.input
	 */
	mdInputContainerDirective.$inject = ["$mdTheming", "$parse"];
	inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout", "$mdGesture"];
	mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];
	placeholderDirective.$inject = ["$compile"];
	ngMessageDirective.$inject = ["$mdUtil"];
	mdSelectOnFocusDirective.$inject = ["$timeout"];
	mdInputInvalidMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil"];
	ngMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil"];
	ngMessageAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil"];
	angular.module('material.components.input', [
	    'material.core'
	  ])
	  .directive('mdInputContainer', mdInputContainerDirective)
	  .directive('label', labelDirective)
	  .directive('input', inputTextareaDirective)
	  .directive('textarea', inputTextareaDirective)
	  .directive('mdMaxlength', mdMaxlengthDirective)
	  .directive('placeholder', placeholderDirective)
	  .directive('ngMessages', ngMessagesDirective)
	  .directive('ngMessage', ngMessageDirective)
	  .directive('ngMessageExp', ngMessageDirective)
	  .directive('mdSelectOnFocus', mdSelectOnFocusDirective)
	
	  .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
	  .animation('.md-input-messages-animation', ngMessagesAnimation)
	  .animation('.md-input-message-animation', ngMessageAnimation)
	
	  // Register a service for each animation so that we can easily inject them into unit tests
	  .service('mdInputInvalidAnimation', mdInputInvalidMessagesAnimation)
	  .service('mdInputMessagesAnimation', ngMessagesAnimation)
	  .service('mdInputMessageAnimation', ngMessageAnimation);
	
	/**
	 * @ngdoc directive
	 * @name mdInputContainer
	 * @module material.components.input
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-input-container>` is the parent of any input or textarea element.
	 *
	 * Input and textarea elements will not behave properly unless the md-input-container
	 * parent is provided.
	 *
	 * A single `<md-input-container>` should contain only one `<input>` element, otherwise it will throw an error.
	 *
	 * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an error, so
	 * you may combine these with other inputs.
	 *
	 * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container elements
	 * are *block* elements, otherwise animations applied to the messages will not look as intended. Either use a `div` and
	 * apply the `ng-message` and `ng-messages` classes respectively, or use the `md-block` class on your element.
	 *
	 * @param md-is-error {expression=} When the given expression evaluates to true, the input container
	 *   will go into error state. Defaults to erroring if the input has been touched and is invalid.
	 * @param md-no-float {boolean=} When present, `placeholder` attributes on the input will not be converted to floating
	 *   labels.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Username</label>
	 *   <input type="text" ng-model="user.name">
	 * </md-input-container>
	 *
	 * <md-input-container>
	 *   <label>Description</label>
	 *   <textarea ng-model="user.description"></textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 *
	 * <h3>When disabling floating labels</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container md-no-float>
	 *   <input type="text" placeholder="Non-Floating Label">
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdInputContainerDirective($mdTheming, $parse) {
	
	  ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
	  var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];
	
	  var LEFT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
	  }, []).join(",");
	
	  var RIGHT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
	  }, []).join(",");
	
	  return {
	    restrict: 'E',
	    compile: compile,
	    controller: ContainerCtrl
	  };
	
	  function compile(tElement) {
	    // Check for both a left & right icon
	    var leftIcon = tElement[0].querySelector(LEFT_SELECTORS);
	    var rightIcon = tElement[0].querySelector(RIGHT_SELECTORS);
	
	    if (leftIcon) { tElement.addClass('md-icon-left'); }
	    if (rightIcon) { tElement.addClass('md-icon-right'); }
	
	    return function postLink(scope, element) {
	      $mdTheming(element);
	    };
	  }
	
	  function ContainerCtrl($scope, $element, $attrs, $animate) {
	    var self = this;
	
	    self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);
	
	    self.delegateClick = function() {
	      self.input.focus();
	    };
	    self.element = $element;
	    self.setFocused = function(isFocused) {
	      $element.toggleClass('md-input-focused', !!isFocused);
	    };
	    self.setHasValue = function(hasValue) {
	      $element.toggleClass('md-input-has-value', !!hasValue);
	    };
	    self.setHasPlaceholder = function(hasPlaceholder) {
	      $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
	    };
	    self.setInvalid = function(isInvalid) {
	      if (isInvalid) {
	        $animate.addClass($element, 'md-input-invalid');
	      } else {
	        $animate.removeClass($element, 'md-input-invalid');
	      }
	    };
	    $scope.$watch(function() {
	      return self.label && self.input;
	    }, function(hasLabelAndInput) {
	      if (hasLabelAndInput && !self.label.attr('for')) {
	        self.label.attr('for', self.input.attr('id'));
	      }
	    });
	  }
	}
	
	function labelDirective() {
	  return {
	    restrict: 'E',
	    require: '^?mdInputContainer',
	    link: function(scope, element, attr, containerCtrl) {
	      if (!containerCtrl || attr.mdNoFloat || element.hasClass('md-container-ignore')) return;
	
	      containerCtrl.label = element;
	      scope.$on('$destroy', function() {
	        containerCtrl.label = null;
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInput
	 * @restrict E
	 * @module material.components.input
	 *
	 * @description
	 * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
	 * allows you to build complex forms for data entry.
	 *
	 * When the input is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`).<br/>
	 * This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
	 *   specified, a character counter will be shown underneath the input.<br/><br/>
	 *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
	 *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
	 *   or maxlength attributes.<br/><br/>
	 *   **Note:** Only valid for text/string inputs (not numeric).
	 *
	 * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
	 *   will be logged in the console if not present.
	 * @param {string=} placeholder An alternative approach to using aria-label when the label is not
	 *   PRESENT. The placeholder text is copied to the aria-label attribute.
	 * @param md-no-autogrow {boolean=} When present, textareas will not grow automatically.
	 * @param md-no-asterisk {boolean=} When present, an asterisk will not be appended to the inputs floating label
	 * @param md-no-resize {boolean=} Disables the textarea resize handle.
	 * @param {number=} max-rows The maximum amount of rows for a textarea.
	 * @param md-detect-hidden {boolean=} When present, textareas will be sized properly when they are
	 *   revealed after being hidden. This is off by default for performance reasons because it
	 *   guarantees a reflow every digest cycle.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-input-container>
	 *   <label>Color</label>
	 *   <input type="text" ng-model="color" required md-maxlength="10">
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>With Errors</h3>
	 *
	 * `md-input-container` also supports errors using the standard `ng-messages` directives and
	 * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
	 * the `ngShow`/`ngHide` events.
	 *
	 * By default, the messages will be hidden until the input is in an error state. This is based off
	 * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
	 * fill out the form before the errors become visible.
	 *
	 * <hljs lang="html">
	 * <form name="colorForm">
	 *   <md-input-container>
	 *     <label>Favorite Color</label>
	 *     <input name="favoriteColor" ng-model="favoriteColor" required>
	 *     <div ng-messages="colorForm.favoriteColor.$error">
	 *       <div ng-message="required">This is required!</div>
	 *     </div>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * We automatically disable this auto-hiding functionality if you provide any of the following
	 * visibility directives on the `ng-messages` container:
	 *
	 *  - `ng-if`
	 *  - `ng-show`/`ng-hide`
	 *  - `ng-switch-when`/`ng-switch-default`
	 *
	 * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
	 * to the `ng-messages` container. This may be helpful if you always want to see the error messages
	 * or if you are building your own visibilty directive.
	 *
	 * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
	 * initialization of the `ng-messages` directive to see if it equals the string `false`._
	 *
	 * <hljs lang="html">
	 * <form name="userForm">
	 *   <md-input-container>
	 *     <label>Last Name</label>
	 *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
	 *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *       <div ng-message="minlength">That's too short!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <label>Biography</label>
	 *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
	 *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input aria-label='title' ng-model='title'>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input placeholder='title' ng-model='title'>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * <h3>Notes</h3>
	 *
	 * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
	 * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
	 *
	 * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
	 * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
	 * `<md-input-container>` tags. Instead, use relative or absolute positioning.
	 *
	 *
	 * <h3>Textarea directive</h3>
	 * The `textarea` element within a `md-input-container` has the following specific behavior:
	 * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
	 * attribute.
	 * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
	 * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
	 * high initially. If no rows are specified, the directive defaults to 1.
	 * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
	 * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
	 * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
	 * - If you wan't a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
	 * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
	 * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
	 * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
	 */
	
	function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout, $mdGesture) {
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	
	    var containerCtrl = ctrls[0];
	    var hasNgModel = !!ctrls[1];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	    var parentForm = ctrls[2];
	    var isReadonly = angular.isDefined(attr.readonly);
	    var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	    var tagName = element[0].tagName.toLowerCase();
	
	
	    if (!containerCtrl) return;
	    if (attr.type === 'hidden') {
	      element.attr('aria-hidden', 'true');
	      return;
	    } else if (containerCtrl.input) {
	      if (containerCtrl.input[0].contains(element[0])) {
	        return;
	      } else {
	        throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
	      }
	    }
	    containerCtrl.input = element;
	
	    setupAttributeWatchers();
	
	    // Add an error spacer div after our input to provide space for the char counter and any ng-messages
	    var errorsSpacer = angular.element('<div class="md-errors-spacer">');
	    element.after(errorsSpacer);
	
	    if (!containerCtrl.label) {
	      $mdAria.expect(element, 'aria-label', attr.placeholder);
	    }
	
	    element.addClass('md-input');
	    if (!element.attr('id')) {
	      element.attr('id', 'input_' + $mdUtil.nextUid());
	    }
	
	    // This works around a Webkit issue where number inputs, placed in a flexbox, that have
	    // a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
	    // for more info. Also note that we don't override the `step` if the user has specified it,
	    // in order to prevent some unexpected behaviour.
	    if (tagName === 'input' && attr.type === 'number' && attr.min && attr.max && !attr.step) {
	      element.attr('step', 'any');
	    } else if (tagName === 'textarea') {
	      setupTextarea();
	    }
	
	    // If the input doesn't have an ngModel, it may have a static value. For that case,
	    // we have to do one initial check to determine if the container should be in the
	    // "has a value" state.
	    if (!hasNgModel) {
	      inputCheckValue();
	    }
	
	    var isErrorGetter = containerCtrl.isErrorGetter || function() {
	      return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	    };
	
	    scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	
	    // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
	    // Angular's ngValue directive is just setting the `value` attribute.
	    if (attr.ngValue) {
	      attr.$observe('value', inputCheckValue);
	    }
	
	    ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
	    ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
	
	    element.on('input', inputCheckValue);
	
	    if (!isReadonly) {
	      element
	        .on('focus', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(true);
	          });
	        })
	        .on('blur', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(false);
	            inputCheckValue();
	          });
	        });
	    }
	
	    scope.$on('$destroy', function() {
	      containerCtrl.setFocused(false);
	      containerCtrl.setHasValue(false);
	      containerCtrl.input = null;
	    });
	
	    /** Gets run through ngModel's pipeline and set the `has-value` class on the container. */
	    function ngModelPipelineCheckValue(arg) {
	      containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
	      return arg;
	    }
	
	    function setupAttributeWatchers() {
	      if (containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // We don't need to parse the required value, it's always a boolean because of angular's
	          // required directive.
	          containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
	        });
	      }
	    }
	
	    function inputCheckValue() {
	      // An input's value counts if its length > 0,
	      // or if the input's validity state says it has bad input (eg string in a number input)
	      containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
	    }
	
	    function setupTextarea() {
	      var isAutogrowing = !attr.hasOwnProperty('mdNoAutogrow');
	
	      attachResizeHandle();
	
	      if (!isAutogrowing) return;
	
	      // Can't check if height was or not explicity set,
	      // so rows attribute will take precedence if present
	      var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
	      var maxRows = attr.hasOwnProperty('maxRows') ? parseInt(attr.maxRows) : NaN;
	      var scopeResizeListener = scope.$on('md-resize-textarea', growTextarea);
	      var lineHeight = null;
	      var node = element[0];
	
	      // This timeout is necessary, because the browser needs a little bit
	      // of time to calculate the `clientHeight` and `scrollHeight`.
	      $timeout(function() {
	        $mdUtil.nextTick(growTextarea);
	      }, 10, false);
	
	      // We could leverage ngModel's $parsers here, however it
	      // isn't reliable, because Angular trims the input by default,
	      // which means that growTextarea won't fire when newlines and
	      // spaces are added.
	      element.on('input', growTextarea);
	
	      // We should still use the $formatters, because they fire when
	      // the value was changed from outside the textarea.
	      if (hasNgModel) {
	        ngModelCtrl.$formatters.push(formattersListener);
	      }
	
	      if (!minRows) {
	        element.attr('rows', 1);
	      }
	
	      angular.element($window).on('resize', growTextarea);
	      scope.$on('$destroy', disableAutogrow);
	
	      function growTextarea() {
	        // temporarily disables element's flex so its height 'runs free'
	        element
	          .attr('rows', 1)
	          .css('height', 'auto')
	          .addClass('md-no-flex');
	
	        var height = getHeight();
	
	        if (!lineHeight) {
	          // offsetHeight includes padding which can throw off our value
	          var originalPadding = element[0].style.padding || '';
	          lineHeight = element.css('padding', 0).prop('offsetHeight');
	          element[0].style.padding = originalPadding;
	        }
	
	        if (minRows && lineHeight) {
	          height = Math.max(height, lineHeight * minRows);
	        }
	
	        if (maxRows && lineHeight) {
	          var maxHeight = lineHeight * maxRows;
	
	          if (maxHeight < height) {
	            element.attr('md-no-autogrow', '');
	            height = maxHeight;
	          } else {
	            element.removeAttr('md-no-autogrow');
	          }
	        }
	
	        if (lineHeight) {
	          element.attr('rows', Math.round(height / lineHeight));
	        }
	
	        element
	          .css('height', height + 'px')
	          .removeClass('md-no-flex');
	      }
	
	      function getHeight() {
	        var offsetHeight = node.offsetHeight;
	        var line = node.scrollHeight - offsetHeight;
	        return offsetHeight + Math.max(line, 0);
	      }
	
	      function formattersListener(value) {
	        $mdUtil.nextTick(growTextarea);
	        return value;
	      }
	
	      function disableAutogrow() {
	        if (!isAutogrowing) return;
	
	        isAutogrowing = false;
	        angular.element($window).off('resize', growTextarea);
	        scopeResizeListener && scopeResizeListener();
	        element
	          .attr('md-no-autogrow', '')
	          .off('input', growTextarea);
	
	        if (hasNgModel) {
	          var listenerIndex = ngModelCtrl.$formatters.indexOf(formattersListener);
	
	          if (listenerIndex > -1) {
	            ngModelCtrl.$formatters.splice(listenerIndex, 1);
	          }
	        }
	      }
	
	      function attachResizeHandle() {
	        if (attr.hasOwnProperty('mdNoResize')) return;
	
	        var handle = angular.element('<div class="md-resize-handle"></div>');
	        var isDragging = false;
	        var dragStart = null;
	        var startHeight = 0;
	        var container = containerCtrl.element;
	        var dragGestureHandler = $mdGesture.register(handle, 'drag', { horizontal: false });
	
	
	        element.wrap('<div class="md-resize-wrapper">').after(handle);
	        handle.on('mousedown', onMouseDown);
	
	        container
	          .on('$md.dragstart', onDragStart)
	          .on('$md.drag', onDrag)
	          .on('$md.dragend', onDragEnd);
	
	        scope.$on('$destroy', function() {
	          handle
	            .off('mousedown', onMouseDown)
	            .remove();
	
	          container
	            .off('$md.dragstart', onDragStart)
	            .off('$md.drag', onDrag)
	            .off('$md.dragend', onDragEnd);
	
	          dragGestureHandler();
	          handle = null;
	          container = null;
	          dragGestureHandler = null;
	        });
	
	        function onMouseDown(ev) {
	          ev.preventDefault();
	          isDragging = true;
	          dragStart = ev.clientY;
	          startHeight = parseFloat(element.css('height')) || element.prop('offsetHeight');
	        }
	
	        function onDragStart(ev) {
	          if (!isDragging) return;
	          ev.preventDefault();
	          disableAutogrow();
	          container.addClass('md-input-resized');
	        }
	
	        function onDrag(ev) {
	          if (!isDragging) return;
	          element.css('height', startHeight + (ev.pointer.y - dragStart) - $mdUtil.scrollTop() + 'px');
	        }
	
	        function onDragEnd(ev) {
	          if (!isDragging) return;
	          isDragging = false;
	          container.removeClass('md-input-resized');
	        }
	      }
	
	      // Attach a watcher to detect when the textarea gets shown.
	      if (attr.hasOwnProperty('mdDetectHidden')) {
	
	        var handleHiddenChange = function() {
	          var wasHidden = false;
	
	          return function() {
	            var isHidden = node.offsetHeight === 0;
	
	            if (isHidden === false && wasHidden === true) {
	              growTextarea();
	            }
	
	            wasHidden = isHidden;
	          };
	        }();
	
	        // Check every digest cycle whether the visibility of the textarea has changed.
	        // Queue up to run after the digest cycle is complete.
	        scope.$watch(function() {
	          $mdUtil.nextTick(handleHiddenChange, false);
	          return true;
	        });
	      }
	    }
	  }
	}
	
	function mdMaxlengthDirective($animate, $mdUtil) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^mdInputContainer'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var maxlength;
	    var ngModelCtrl = ctrls[0];
	    var containerCtrl = ctrls[1];
	    var charCountEl, errorsSpacer;
	
	    // Wait until the next tick to ensure that the input has setup the errors spacer where we will
	    // append our counter
	    $mdUtil.nextTick(function() {
	      errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
	      charCountEl = angular.element('<div class="md-char-counter">');
	
	      // Append our character counter inside the errors spacer
	      errorsSpacer.append(charCountEl);
	
	      // Stop model from trimming. This makes it so whitespace
	      // over the maxlength still counts as invalid.
	      attr.$set('ngTrim', 'false');
	
	      ngModelCtrl.$formatters.push(renderCharCount);
	      ngModelCtrl.$viewChangeListeners.push(renderCharCount);
	      element.on('input keydown keyup', function() {
	        renderCharCount(); //make sure it's called with no args
	      });
	
	      scope.$watch(attr.mdMaxlength, function(value) {
	        maxlength = value;
	        if (angular.isNumber(value) && value > 0) {
	          if (!charCountEl.parent().length) {
	            $animate.enter(charCountEl, errorsSpacer);
	          }
	          renderCharCount();
	        } else {
	          $animate.leave(charCountEl);
	        }
	      });
	
	      ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
	        if (!angular.isNumber(maxlength) || maxlength < 0) {
	          return true;
	        }
	        return ( modelValue || element.val() || viewValue || '' ).length <= maxlength;
	      };
	    });
	
	    function renderCharCount(value) {
	      // If we have not been appended to the body yet; do not render
	      if (!charCountEl.parent) {
	        return value;
	      }
	
	      // Force the value into a string since it may be a number,
	      // which does not have a length property.
	      charCountEl.text(String(element.val() || value || '').length + ' / ' + maxlength);
	      return value;
	    }
	  }
	}
	
	function placeholderDirective($compile) {
	  return {
	    restrict: 'A',
	    require: '^^?mdInputContainer',
	    priority: 200,
	    link: {
	      // Note that we need to do this in the pre-link, as opposed to the post link, if we want to
	      // support data bindings in the placeholder. This is necessary, because we have a case where
	      // we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
	      // If we did this in the post-link, Angular would have set up the observers already and would be
	      // re-adding the attribute, even though we removed it from the element.
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr, inputContainer) {
	    // If there is no input container, just return
	    if (!inputContainer) return;
	
	    var label = inputContainer.element.find('label');
	    var noFloat = inputContainer.element.attr('md-no-float');
	
	    // If we have a label, or they specify the md-no-float attribute, just return
	    if ((label && label.length) || noFloat === '' || scope.$eval(noFloat)) {
	      // Add a placeholder class so we can target it in the CSS
	      inputContainer.setHasPlaceholder(true);
	      return;
	    }
	
	    // md-select handles placeholders on it's own
	    if (element[0].nodeName != 'MD-SELECT') {
	      // Move the placeholder expression to the label
	      var newLabel = angular.element('<label ng-click="delegateClick()" tabindex="-1">' + attr.placeholder + '</label>');
	
	      // Note that we unset it via `attr`, in order to get Angular
	      // to remove any observers that it might have set up. Otherwise
	      // the attribute will be added on the next digest.
	      attr.$set('placeholder', null);
	
	      // We need to compile the label manually in case it has any bindings.
	      // A gotcha here is that we first add the element to the DOM and we compile
	      // it later. This is necessary, because if we compile the element beforehand,
	      // it won't be able to find the `mdInputContainer` controller.
	      inputContainer.element
	        .addClass('md-icon-float')
	        .prepend(newLabel);
	
	      $compile(newLabel)(scope);
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSelectOnFocus
	 * @module material.components.input
	 *
	 * @restrict A
	 *
	 * @description
	 * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
	 *
	 * <h3>Notes</h3>
	 * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
	 *
	 * @usage
	 * <h3>Using with an Input</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <input type="text" md-select-on-focus>
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>Using with a Textarea</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdSelectOnFocusDirective($timeout) {
	
	  return {
	    restrict: 'A',
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;
	
	    var preventMouseUp = false;
	
	    element
	      .on('focus', onFocus)
	      .on('mouseup', onMouseUp);
	
	    scope.$on('$destroy', function() {
	      element
	        .off('focus', onFocus)
	        .off('mouseup', onMouseUp);
	    });
	
	    function onFocus() {
	      preventMouseUp = true;
	
	      $timeout(function() {
	        // Use HTMLInputElement#select to fix firefox select issues.
	        // The debounce is here for Edge's sake, otherwise the selection doesn't work.
	        element[0].select();
	
	        // This should be reset from inside the `focus`, because the event might
	        // have originated from something different than a click, e.g. a keyboard event.
	        preventMouseUp = false;
	      }, 1, false);
	    }
	
	    // Prevents the default action of the first `mouseup` after a focus.
	    // This is necessary, because browsers fire a `mouseup` right after the element
	    // has been focused. In some browsers (Firefox in particular) this can clear the
	    // selection. There are examples of the problem in issue #7487.
	    function onMouseUp(event) {
	      if (preventMouseUp) {
	        event.preventDefault();
	      }
	    }
	  }
	}
	
	var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];
	function ngMessagesDirective() {
	  return {
	    restrict: 'EA',
	    link: postLink,
	
	    // This is optional because we don't want target *all* ngMessage instances, just those inside of
	    // mdInputContainer.
	    require: '^^?mdInputContainer'
	  };
	
	  function postLink(scope, element, attrs, inputContainer) {
	    // If we are not a child of an input container, don't do anything
	    if (!inputContainer) return;
	
	    // Add our animation class
	    element.toggleClass('md-input-messages-animation', true);
	
	    // Add our md-auto-hide class to automatically hide/show messages when container is invalid
	    element.toggleClass('md-auto-hide', true);
	
	    // If we see some known visibility directives, remove the md-auto-hide class
	    if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
	      element.toggleClass('md-auto-hide', false);
	    }
	  }
	
	  function hasVisibiltyDirective(attrs) {
	    return visibilityDirectives.some(function(attr) {
	      return attrs[attr];
	    });
	  }
	}
	
	function ngMessageDirective($mdUtil) {
	  return {
	    restrict: 'EA',
	    compile: compile,
	    priority: 100
	  };
	
	  function compile(tElement) {
	    if (!isInsideInputContainer(tElement)) {
	
	      // When the current element is inside of a document fragment, then we need to check for an input-container
	      // in the postLink, because the element will be later added to the DOM and is currently just in a temporary
	      // fragment, which causes the input-container check to fail.
	      if (isInsideFragment()) {
	        return function (scope, element) {
	          if (isInsideInputContainer(element)) {
	            // Inside of the postLink function, a ngMessage directive will be a comment element, because it's
	            // currently hidden. To access the shown element, we need to use the element from the compile function.
	            initMessageElement(tElement);
	          }
	        };
	      }
	    } else {
	      initMessageElement(tElement);
	    }
	
	    function isInsideFragment() {
	      var nextNode = tElement[0];
	      while (nextNode = nextNode.parentNode) {
	        if (nextNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function isInsideInputContainer(element) {
	      return !!$mdUtil.getClosest(element, "md-input-container");
	    }
	
	    function initMessageElement(element) {
	      // Add our animation class
	      element.toggleClass('md-input-message-animation', true);
	    }
	  }
	}
	
	var $$AnimateRunner, $animateCss, $mdUtil;
	
	function mdInputInvalidMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil);
	
	  return {
	    addClass: function(element, className, done) {
	      showInputMessages(element, done);
	    }
	
	    // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
	  };
	}
	
	function ngMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil);
	
	  return {
	    enter: function(element, done) {
	      showInputMessages(element, done);
	    },
	
	    leave: function(element, done) {
	      hideInputMessages(element, done);
	    },
	
	    addClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        hideInputMessages(element, done);
	      } else {
	        done();
	      }
	    },
	
	    removeClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        showInputMessages(element, done);
	      } else {
	        done();
	      }
	    }
	  }
	}
	
	function ngMessageAnimation($$AnimateRunner, $animateCss, $mdUtil) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil);
	
	  return {
	    enter: function(element, done) {
	      var animator = showMessage(element);
	
	      animator.start().done(done);
	    },
	
	    leave: function(element, done) {
	      var animator = hideMessage(element);
	
	      animator.start().done(done);
	    }
	  }
	}
	
	function showInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	
	  angular.forEach(messages.children(), function(child) {
	    animator = showMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function hideInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	
	  angular.forEach(messages.children(), function(child) {
	    animator = hideMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function showMessage(element) {
	  var height = parseInt(window.getComputedStyle(element[0]).height);
	  var topMargin = parseInt(window.getComputedStyle(element[0]).marginTop);
	
	  var messages = getMessagesElement(element);
	  var container = getInputElement(element);
	
	  // Check to see if the message is already visible so we can skip
	  var alreadyVisible = (topMargin > -height);
	
	  // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
	  if (alreadyVisible || (messages.hasClass('md-auto-hide') && !container.hasClass('md-input-invalid'))) {
	    return $animateCss(element, {});
	  }
	
	  return $animateCss(element, {
	    event: 'enter',
	    structural: true,
	    from: {"opacity": 0, "margin-top": -height + "px"},
	    to: {"opacity": 1, "margin-top": "0"},
	    duration: 0.3
	  });
	}
	
	function hideMessage(element) {
	  var height = element[0].offsetHeight;
	  var styles = window.getComputedStyle(element[0]);
	
	  // If we are already hidden, just return an empty animation
	  if (styles.opacity == 0) {
	    return $animateCss(element, {});
	  }
	
	  // Otherwise, animate
	  return $animateCss(element, {
	    event: 'leave',
	    structural: true,
	    from: {"opacity": 1, "margin-top": 0},
	    to: {"opacity": 0, "margin-top": -height + "px"},
	    duration: 0.3
	  });
	}
	
	function getInputElement(element) {
	  var inputContainer = element.controller('mdInputContainer');
	
	  return inputContainer.element;
	}
	
	function getMessagesElement(element) {
	  // If we are a ng-message element, we need to traverse up the DOM tree
	  if (element.hasClass('md-input-message-animation')) {
	    return angular.element($mdUtil.getClosest(element, function(node) {
	      return node.classList.contains('md-input-messages-animation');
	    }));
	  }
	
	  // Otherwise, we can traverse down
	  return angular.element(element[0].querySelector('.md-input-messages-animation'));
	}
	
	function saveSharedServices(_$$AnimateRunner_, _$animateCss_, _$mdUtil_) {
	  $$AnimateRunner = _$$AnimateRunner_;
	  $animateCss = _$animateCss_;
	  $mdUtil = _$mdUtil_;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.list
	 * @description
	 * List module
	 */
	MdListController.$inject = ["$scope", "$element", "$mdListInkRipple"];
	mdListDirective.$inject = ["$mdTheming"];
	mdListItemDirective.$inject = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];
	angular.module('material.components.list', [
	  'material.core'
	])
	  .controller('MdListController', MdListController)
	  .directive('mdList', mdListDirective)
	  .directive('mdListItem', mdListItemDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdList
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-list>
	 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
	 *     <md-checkbox ng-model="item.done"></md-checkbox>
	 *     <div class="md-list-item-text">
	 *       <h3>{{item.title}}</h3>
	 *       <p>{{item.description}}</p>
	 *     </div>
	 *   </md-list-item>
	 * </md-list>
	 * </hljs>
	 */
	
	function mdListDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    compile: function(tEl) {
	      tEl[0].setAttribute('role', 'list');
	      return $mdTheming;
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdListItem
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * A `md-list-item` element can be used to represent some information in a row.<br/>
	 *
	 * @usage
	 * ### Single Row Item
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Multiple Lines
	 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-2-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It is also possible to have three lines inside of one list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-3-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *       <p>Third Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Secondary Items
	 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">
	 *       Secondary Button
	 *     </md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It also possible to have multiple secondary items inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">First Button</md-button>
	 *     <md-button class="md-secondary">Second Button</md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Proxy Item
	 * Proxies are elements, which will execute their specific action on click<br/>
	 * Currently supported proxy items are
	 * - `md-checkbox` (Toggle)
	 * - `md-switch` (Toggle)
	 * - `md-menu` (Open)
	 *
	 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
	 * become clickable and executes the associated action of the proxy element on click.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on click.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-switch class="md-secondary"></md-switch>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
	 *
	 * It is also possible to have a `md-menu` inside of a `md-list-item`.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <p>Click anywhere to fire the secondary action</p>
	 *     <md-menu class="md-secondary">
	 *       <md-button class="md-icon-button">
	 *         <md-icon md-svg-icon="communication:message"></md-icon>
	 *       </md-button>
	 *       <md-menu-content width="4">
	 *         <md-menu-item>
	 *           <md-button>
	 *             Redial
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Check voicemail
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-divider></md-menu-divider>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Notifications
	 *           </md-button>
	 *         </md-menu-item>
	 *       </md-menu-content>
	 *     </md-menu>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
	 *
	 * If the developer didn't specify any position mode on the menu, the `md-list-item` will automatically detect the
	 * position mode and applies it to the `md-menu`.
	 *
	 * ### Avatars
	 * Sometimes you may want to have some avatars inside of the `md-list-item `.<br/>
	 * You are able to create a optimized icon for the list item, by applying the `.md-avatar` class on the `<img>` element.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <img src="my-avatar.png" class="md-avatar">
	 *     <span>Alan Turing</span>
	 * </hljs>
	 *
	 * When using `<md-icon>` for an avater, you have to use the `.md-avatar-icon` class.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <md-icon class="md-avatar-icon" md-svg-icon="avatars:timothy"></md-icon>
	 *     <span>Timothy Kopra</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * In cases, you have a `md-list-item`, which doesn't have any avatar,
	 * but you want to align it with the other avatar items, you have to use the `.md-offset` class.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-offset">
	 *     <span>Jon Doe</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### DOM modification
	 * The `md-list-item` component automatically detects if the list item should be clickable.
	 *
	 * ---
	 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
	 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`)
	 *
	 * We create an overlaying button, instead of wrapping all content inside of the button,
	 * because otherwise some elements may not be clickable inside of the button.
	 *
	 * ---
	 * When using a secondary item inside of your list item, the `md-list-item` component will automatically create
	 * a secondary container at the end of the `md-list-item`, which contains all secondary items.
	 *
	 * The secondary item container is not static, because otherwise the overflow will not work properly on the
	 * list item.
	 *
	 */
	function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
	  var proxiedTypes = ['md-checkbox', 'md-switch', 'md-menu'];
	  return {
	    restrict: 'E',
	    controller: 'MdListController',
	    compile: function(tEl, tAttrs) {
	
	      // Check for proxy controls (no ng-click on parent, and a control inside)
	      var secondaryItems = tEl[0].querySelectorAll('.md-secondary');
	      var hasProxiedElement;
	      var proxyElement;
	      var itemContainer = tEl;
	
	      tEl[0].setAttribute('role', 'listitem');
	
	      if (tAttrs.ngClick || tAttrs.ngDblclick ||  tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
	        wrapIn('button');
	      } else {
	        for (var i = 0, type; type = proxiedTypes[i]; ++i) {
	          if (proxyElement = tEl[0].querySelector(type)) {
	            hasProxiedElement = true;
	            break;
	          }
	        }
	        if (hasProxiedElement) {
	          wrapIn('div');
	        } else if (!tEl[0].querySelector('md-button:not(.md-secondary):not(.md-exclude)')) {
	          tEl.addClass('md-no-proxy');
	        }
	      }
	
	      wrapSecondaryItems();
	      setupToggleAria();
	
	      if (hasProxiedElement && proxyElement.nodeName === "MD-MENU") {
	        setupProxiedMenu();
	      }
	
	      function setupToggleAria() {
	        var toggleTypes = ['md-switch', 'md-checkbox'];
	        var toggle;
	
	        for (var i = 0, toggleType; toggleType = toggleTypes[i]; ++i) {
	          if (toggle = tEl.find(toggleType)[0]) {
	            if (!toggle.hasAttribute('aria-label')) {
	              var p = tEl.find('p')[0];
	              if (!p) return;
	              toggle.setAttribute('aria-label', 'Toggle ' + p.textContent);
	            }
	          }
	        }
	      }
	
	      function setupProxiedMenu() {
	        var menuEl = angular.element(proxyElement);
	
	        var isEndAligned = menuEl.parent().hasClass('md-secondary-container') ||
	                           proxyElement.parentNode.firstElementChild !== proxyElement;
	
	        var xAxisPosition = 'left';
	
	        if (isEndAligned) {
	          // When the proxy item is aligned at the end of the list, we have to set the origin to the end.
	          xAxisPosition = 'right';
	        }
	        
	        // Set the position mode / origin of the proxied menu.
	        if (!menuEl.attr('md-position-mode')) {
	          menuEl.attr('md-position-mode', xAxisPosition + ' target');
	        }
	
	        // Apply menu open binding to menu button
	        var menuOpenButton = menuEl.children().eq(0);
	        if (!hasClickEvent(menuOpenButton[0])) {
	          menuOpenButton.attr('ng-click', '$mdOpenMenu($event)');
	        }
	
	        if (!menuOpenButton.attr('aria-label')) {
	          menuOpenButton.attr('aria-label', 'Open List Menu');
	        }
	      }
	
	      function wrapIn(type) {
	        if (type == 'div') {
	          itemContainer = angular.element('<div class="md-no-style md-list-item-inner">');
	          itemContainer.append(tEl.contents());
	          tEl.addClass('md-proxy-focus');
	        } else {
	          // Element which holds the default list-item content.
	          itemContainer = angular.element(
	            '<div class="md-button md-no-style">'+
	            '   <div class="md-list-item-inner"></div>'+
	            '</div>'
	          );
	
	          // Button which shows ripple and executes primary action.
	          var buttonWrap = angular.element(
	            '<md-button class="md-no-style"></md-button>'
	          );
	
	          buttonWrap[0].setAttribute('aria-label', tEl[0].textContent);
	
	          copyAttributes(tEl[0], buttonWrap[0]);
	
	          // We allow developers to specify the `md-no-focus` class, to disable the focus style
	          // on the button executor. Once more classes should be forwarded, we should probably make the
	          // class forward more generic.
	          if (tEl.hasClass('md-no-focus')) {
	            buttonWrap.addClass('md-no-focus');
	          }
	
	          // Append the button wrap before our list-item content, because it will overlay in relative.
	          itemContainer.prepend(buttonWrap);
	          itemContainer.children().eq(1).append(tEl.contents());
	
	          tEl.addClass('_md-button-wrap');
	        }
	
	        tEl[0].setAttribute('tabindex', '-1');
	        tEl.append(itemContainer);
	      }
	
	      function wrapSecondaryItems() {
	        var secondaryItemsWrapper = angular.element('<div class="md-secondary-container">');
	
	        angular.forEach(secondaryItems, function(secondaryItem) {
	          wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
	        });
	
	        itemContainer.append(secondaryItemsWrapper);
	      }
	
	      function wrapSecondaryItem(secondaryItem, container) {
	        // If the current secondary item is not a button, but contains a ng-click attribute,
	        // the secondary item will be automatically wrapped inside of a button.
	        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {
	
	          $mdAria.expect(secondaryItem, 'aria-label');
	          var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');
	
	          // Copy the attributes from the secondary item to the generated button.
	          // We also support some additional attributes from the secondary item,
	          // because some developers may use a ngIf, ngHide, ngShow on their item.
	          copyAttributes(secondaryItem, buttonWrapper[0], ['ng-if', 'ng-hide', 'ng-show']);
	
	          secondaryItem.setAttribute('tabindex', '-1');
	          buttonWrapper.append(secondaryItem);
	
	          secondaryItem = buttonWrapper[0];
	        }
	
	        if (secondaryItem && (!hasClickEvent(secondaryItem) || (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
	          // In this case we remove the secondary class, so we can identify it later, when we searching for the
	          // proxy items.
	          angular.element(secondaryItem).removeClass('md-secondary');
	        }
	
	        tEl.addClass('md-with-secondary');
	        container.append(secondaryItem);
	      }
	
	      /**
	       * Copies attributes from a source element to the destination element
	       * By default the function will copy the most necessary attributes, supported
	       * by the button executor for clickable list items.
	       * @param source Element with the specified attributes
	       * @param destination Element which will retrieve the attributes
	       * @param extraAttrs Additional attributes, which will be copied over.
	       */
	      function copyAttributes(source, destination, extraAttrs) {
	        var copiedAttrs = $mdUtil.prefixer([
	          'ng-if', 'ng-click', 'ng-dblclick', 'aria-label', 'ng-disabled', 'ui-sref',
	          'href', 'ng-href', 'target', 'ng-attr-ui-sref', 'ui-sref-opts'
	        ]);
	
	        if (extraAttrs) {
	          copiedAttrs = copiedAttrs.concat($mdUtil.prefixer(extraAttrs));
	        }
	
	        angular.forEach(copiedAttrs, function(attr) {
	          if (source.hasAttribute(attr)) {
	            destination.setAttribute(attr, source.getAttribute(attr));
	            source.removeAttribute(attr);
	          }
	        });
	      }
	
	      function isProxiedElement(el) {
	        return proxiedTypes.indexOf(el.nodeName.toLowerCase()) != -1;
	      }
	
	      function isButton(el) {
	        var nodeName = el.nodeName.toUpperCase();
	
	        return nodeName == "MD-BUTTON" || nodeName == "BUTTON";
	      }
	
	      function hasClickEvent (element) {
	        var attr = element.attributes;
	        for (var i = 0; i < attr.length; i++) {
	          if (tAttrs.$normalize(attr[i].name) === 'ngClick') return true;
	        }
	        return false;
	      }
	
	      return postLink;
	
	      function postLink($scope, $element, $attr, ctrl) {
	        $element.addClass('_md');     // private md component indicator for styling
	
	        var proxies       = [],
	            firstElement  = $element[0].firstElementChild,
	            isButtonWrap  = $element.hasClass('_md-button-wrap'),
	            clickChild    = isButtonWrap ? firstElement.firstElementChild : firstElement,
	            hasClick      = clickChild && hasClickEvent(clickChild);
	
	        computeProxies();
	        computeClickable();
	
	        if ($element.hasClass('md-proxy-focus') && proxies.length) {
	          angular.forEach(proxies, function(proxy) {
	            proxy = angular.element(proxy);
	
	            $scope.mouseActive = false;
	            proxy.on('mousedown', function() {
	              $scope.mouseActive = true;
	              $timeout(function(){
	                $scope.mouseActive = false;
	              }, 100);
	            })
	            .on('focus', function() {
	              if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
	              proxy.on('blur', function proxyOnBlur() {
	                $element.removeClass('md-focused');
	                proxy.off('blur', proxyOnBlur);
	              });
	            });
	          });
	        }
	
	
	        function computeProxies() {
	          if (firstElement && firstElement.children && !hasClick) {
	
	            angular.forEach(proxiedTypes, function(type) {
	
	              // All elements which are not capable for being used a proxy have the .md-secondary class
	              // applied. These items had been sorted out in the secondary wrap function.
	              angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function(child) {
	                proxies.push(child);
	              });
	            });
	
	          }
	        }
	
	        function computeClickable() {
	          if (proxies.length == 1 || hasClick) {
	            $element.addClass('md-clickable');
	
	            if (!hasClick) {
	              ctrl.attachRipple($scope, angular.element($element[0].querySelector('.md-no-style')));
	            }
	          }
	        }
	
	        function isEventFromControl(event) {
	          var forbiddenControls = ['md-slider'];
	
	          // If there is no path property in the event, then we can assume that the event was not bubbled.
	          if (!event.path) {
	            return forbiddenControls.indexOf(event.target.tagName.toLowerCase()) !== -1;
	          }
	
	          // We iterate the event path up and check for a possible component.
	          // Our maximum index to search, is the list item root.
	          var maxPath = event.path.indexOf($element.children()[0]);
	
	          for (var i = 0; i < maxPath; i++) {
	            if (forbiddenControls.indexOf(event.path[i].tagName.toLowerCase()) !== -1) {
	              return true;
	            }
	          }
	        }
	
	        var clickChildKeypressListener = function(e) {
	          if (e.target.nodeName != 'INPUT' && e.target.nodeName != 'TEXTAREA' && !e.target.isContentEditable) {
	            var keyCode = e.which || e.keyCode;
	            if (keyCode == $mdConstant.KEY_CODE.SPACE) {
	              if (clickChild) {
	                clickChild.click();
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            }
	          }
	        };
	
	        if (!hasClick && !proxies.length) {
	          clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
	        }
	
	        $element.off('click');
	        $element.off('keypress');
	
	        if (proxies.length == 1 && clickChild) {
	          $element.children().eq(0).on('click', function(e) {
	            // When the event is coming from an control and it should not trigger the proxied element
	            // then we are skipping.
	            if (isEventFromControl(e)) return;
	
	            var parentButton = $mdUtil.getClosest(e.target, 'BUTTON');
	            if (!parentButton && clickChild.contains(e.target)) {
	              angular.forEach(proxies, function(proxy) {
	                if (e.target !== proxy && !proxy.contains(e.target)) {
	                  if (proxy.nodeName === 'MD-MENU') {
	                    proxy = proxy.children[0];
	                  }
	                  angular.element(proxy).triggerHandler('click');
	                }
	              });
	            }
	          });
	        }
	
	        $scope.$on('$destroy', function () {
	          clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
	        });
	      }
	    }
	  };
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name MdListController
	 * @module material.components.list
	 *
	 */
	function MdListController($scope, $element, $mdListInkRipple) {
	  var ctrl = this;
	  ctrl.attachRipple = attachRipple;
	
	  function attachRipple (scope, element) {
	    var options = {};
	    $mdListInkRipple.attach(scope, element, options);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menu
	 */
	
	angular.module('material.components.menu', [
	  'material.core',
	  'material.components.backdrop'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menu-bar
	 */
	
	angular.module('material.components.menuBar', [
	  'material.core',
	  'material.components.icon',
	  'material.components.menu'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.navBar
	 */
	
	
	MdNavBarController.$inject = ["$element", "$scope", "$timeout", "$mdConstant"];
	MdNavItem.$inject = ["$$rAF"];
	MdNavItemController.$inject = ["$element"];
	MdNavBar.$inject = ["$mdAria", "$mdTheming"];
	angular.module('material.components.navBar', ['material.core'])
	    .controller('MdNavBarController', MdNavBarController)
	    .directive('mdNavBar', MdNavBar)
	    .controller('MdNavItemController', MdNavItemController)
	    .directive('mdNavItem', MdNavItem);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	/**
	 * @ngdoc directive
	 * @name mdNavBar
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-nav-bar>` directive renders a list of material tabs that can be used
	 * for top-level page navigation. Unlike `<md-tabs>`, it has no concept of a tab
	 * body and no bar pagination.
	 *
	 * Because it deals with page navigation, certain routing concepts are built-in.
	 * Route changes via via ng-href, ui-sref, or ng-click events are supported.
	 * Alternatively, the user could simply watch currentNavItem for changes.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to
	 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
	 *
	 * @param {string=} mdSelectedNavItem The name of the current tab; this must
	 * match the name attribute of `<md-nav-item>`
	 * @param {string=} navBarAriaLabel An aria-label for the nav-bar
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-nav-bar md-selected-nav-item="currentNavItem">
	 *    <md-nav-item md-nav-click="goto('page1')" name="page1">Page One</md-nav-item>
	 *    <md-nav-item md-nav-sref="app.page2" name="page2">Page Two</md-nav-item>
	 *    <md-nav-item md-nav-href="#page3" name="page3">Page Three</md-nav-item>
	 *  </md-nav-bar>
	 *</hljs>
	 * <hljs lang="js">
	 * (function() {
	 *   ‘use strict’;
	 *
	 *    $rootScope.$on('$routeChangeSuccess', function(event, current) {
	 *      $scope.currentLink = getCurrentLinkFromRoute(current);
	 *    });
	 * });
	 * </hljs>
	 */
	
	/*****************************************************************************
	 *                            mdNavItem
	 *****************************************************************************/
	/**
	 * @ngdoc directive
	 * @name mdNavItem
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-nav-item>` describes a page navigation link within the `<md-nav-bar>`
	 * component. It renders an md-button as the actual link.
	 *
	 * Exactly one of the mdNavClick, mdNavHref, mdNavSref attributes are required to be
	 * specified.
	 *
	 * @param {Function=} mdNavClick Function which will be called when the
	 * link is clicked to change the page. Renders as an `ng-click`.
	 * @param {string=} mdNavHref url to transition to when this link is clicked.
	 * Renders as an `ng-href`.
	 * @param {string=} mdNavSref Ui-router state to transition to when this link is
	 * clicked. Renders as a `ui-sref`.
	 * @param {string=} name The name of this link. Used by the nav bar to know
	 * which link is currently selected.
	 *
	 * @usage
	 * See `<md-nav-bar>` for usage.
	 */
	
	
	/*****************************************************************************
	 *                                IMPLEMENTATION                             *
	 *****************************************************************************/
	
	function MdNavBar($mdAria, $mdTheming) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    controller: MdNavBarController,
	    controllerAs: 'ctrl',
	    bindToController: true,
	    scope: {
	      'mdSelectedNavItem': '=?',
	      'navBarAriaLabel': '@?',
	    },
	    template:
	      '<div class="md-nav-bar">' +
	        '<nav role="navigation">' +
	          '<ul class="_md-nav-bar-list" ng-transclude role="listbox"' +
	            'tabindex="0"' +
	            'ng-focus="ctrl.onFocus()"' +
	            'ng-blur="ctrl.onBlur()"' +
	            'ng-keydown="ctrl.onKeydown($event)"' +
	            'aria-label="{{ctrl.navBarAriaLabel}}">' +
	          '</ul>' +
	        '</nav>' +
	        '<md-nav-ink-bar></md-nav-ink-bar>' +
	      '</div>',
	    link: function(scope, element, attrs, ctrl) {
	      $mdTheming(element);
	      if (!ctrl.navBarAriaLabel) {
	        $mdAria.expectAsync(element, 'aria-label', angular.noop);
	      }
	    },
	  };
	}
	
	/**
	 * Controller for the nav-bar component.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to
	 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
	 * @param {!angular.JQLite} $element
	 * @param {!angular.Scope} $scope
	 * @param {!angular.Timeout} $timeout
	 * @param {!Object} $mdConstant
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavBarController($element, $scope, $timeout, $mdConstant) {
	  // Injected variables
	  /** @private @const {!angular.Timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const {!angular.Scope} */
	  this._$scope = $scope;
	
	  /** @private @const {!Object} */
	  this._$mdConstant = $mdConstant;
	
	  // Data-bound variables.
	  /** @type {string} */
	  this.mdSelectedNavItem;
	
	  /** @type {string} */
	  this.navBarAriaLabel;
	
	  // State variables.
	
	  /** @type {?angular.JQLite} */
	  this._navBarEl = $element[0];
	
	  /** @type {?angular.JQLite} */
	  this._inkbar;
	
	  var self = this;
	  // need to wait for transcluded content to be available
	  var deregisterTabWatch = this._$scope.$watch(function() {
	    return self._navBarEl.querySelectorAll('._md-nav-button').length;
	  },
	  function(newLength) {
	    if (newLength > 0) {
	      self._initTabs();
	      deregisterTabWatch();
	    }
	  });
	}
	
	
	
	/**
	 * Initializes the tab components once they exist.
	 * @private
	 */
	MdNavBarController.prototype._initTabs = function() {
	  this._inkbar = angular.element(this._navBarEl.getElementsByTagName('md-nav-ink-bar')[0]);
	
	  var self = this;
	  this._$timeout(function() {
	    self._updateTabs(self.mdSelectedNavItem, undefined);
	  });
	
	  this._$scope.$watch('ctrl.mdSelectedNavItem', function(newValue, oldValue) {
	    // Wait a digest before update tabs for products doing
	    // anything dynamic in the template.
	    self._$timeout(function() {
	      self._updateTabs(newValue, oldValue);
	    });
	  });
	};
	
	/**
	 * Set the current tab to be selected.
	 * @param {string|undefined} newValue New current tab name.
	 * @param {string|undefined} oldValue Previous tab name.
	 * @private
	 */
	MdNavBarController.prototype._updateTabs = function(newValue, oldValue) {
	  var self = this;
	  var tabs = this._getTabs();
	  var oldIndex = -1;
	  var newIndex = -1;
	  var newTab = this._getTabByName(newValue);
	  var oldTab = this._getTabByName(oldValue);
	
	  if (oldTab) {
	    oldTab.setSelected(false);
	    oldIndex = tabs.indexOf(oldTab);
	  }
	
	  if (newTab) {
	    newTab.setSelected(true);
	    newIndex = tabs.indexOf(newTab);
	  }
	
	  this._$timeout(function() {
	    self._updateInkBarStyles(newTab, newIndex, oldIndex);
	  });
	};
	
	/**
	 * Repositions the ink bar to the selected tab.
	 * @private
	 */
	MdNavBarController.prototype._updateInkBarStyles = function(tab, newIndex, oldIndex) {
	  this._inkbar.toggleClass('_md-left', newIndex < oldIndex)
	      .toggleClass('_md-right', newIndex > oldIndex);
	
	  this._inkbar.css({display: newIndex < 0 ? 'none' : ''});
	
	  if(tab){
	    var tabEl = tab.getButtonEl();
	    var left = tabEl.offsetLeft;
	
	    this._inkbar.css({left: left + 'px', width: tabEl.offsetWidth + 'px'});
	  }
	};
	
	/**
	 * Returns an array of the current tabs.
	 * @return {!Array<!NavItemController>}
	 * @private
	 */
	MdNavBarController.prototype._getTabs = function() {
	  var linkArray = Array.prototype.slice.call(
	      this._navBarEl.querySelectorAll('.md-nav-item'));
	  return linkArray.map(function(el) {
	    return angular.element(el).controller('mdNavItem')
	  });
	};
	
	/**
	 * Returns the tab with the specified name.
	 * @param {string} name The name of the tab, found in its name attribute.
	 * @return {!NavItemController|undefined}
	 * @private
	 */
	MdNavBarController.prototype._getTabByName = function(name) {
	  return this._findTab(function(tab) {
	    return tab.getName() == name;
	  });
	};
	
	/**
	 * Returns the selected tab.
	 * @return {!NavItemController|undefined}
	 * @private
	 */
	MdNavBarController.prototype._getSelectedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.isSelected()
	  });
	};
	
	/**
	 * Returns the focused tab.
	 * @return {!NavItemController|undefined}
	 */
	MdNavBarController.prototype.getFocusedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.hasFocus()
	  });
	};
	
	/**
	 * Find a tab that matches the specified function.
	 * @private
	 */
	MdNavBarController.prototype._findTab = function(fn) {
	  var tabs = this._getTabs();
	  for (var i = 0; i < tabs.length; i++) {
	    if (fn(tabs[i])) {
	      return tabs[i];
	    }
	  }
	
	  return null;
	};
	
	/**
	 * Direct focus to the selected tab when focus enters the nav bar.
	 */
	MdNavBarController.prototype.onFocus = function() {
	  var tab = this._getSelectedTab();
	  if (tab) {
	    tab.setFocused(true);
	  }
	};
	
	/**
	 * Clear tab focus when focus leaves the nav bar.
	 */
	MdNavBarController.prototype.onBlur = function() {
	  var tab = this.getFocusedTab();
	  if (tab) {
	    tab.setFocused(false);
	  }
	};
	
	/**
	 * Move focus from oldTab to newTab.
	 * @param {!NavItemController} oldTab
	 * @param {!NavItemController} newTab
	 * @private
	 */
	MdNavBarController.prototype._moveFocus = function(oldTab, newTab) {
	  oldTab.setFocused(false);
	  newTab.setFocused(true);
	};
	
	/**
	 * Responds to keypress events.
	 * @param {!Event} e
	 */
	MdNavBarController.prototype.onKeydown = function(e) {
	  var keyCodes = this._$mdConstant.KEY_CODE;
	  var tabs = this._getTabs();
	  var focusedTab = this.getFocusedTab();
	  if (!focusedTab) return;
	
	  var focusedTabIndex = tabs.indexOf(focusedTab);
	
	  // use arrow keys to navigate between tabs
	  switch (e.keyCode) {
	    case keyCodes.UP_ARROW:
	    case keyCodes.LEFT_ARROW:
	      if (focusedTabIndex > 0) {
	        this._moveFocus(focusedTab, tabs[focusedTabIndex - 1]);
	      }
	      break;
	    case keyCodes.DOWN_ARROW:
	    case keyCodes.RIGHT_ARROW:
	      if (focusedTabIndex < tabs.length - 1) {
	        this._moveFocus(focusedTab, tabs[focusedTabIndex + 1]);
	      }
	      break;
	    case keyCodes.SPACE:
	    case keyCodes.ENTER:
	      // timeout to avoid a "digest already in progress" console error
	      this._$timeout(function() {
	        focusedTab.getButtonEl().click();
	      });
	      break;
	  }
	};
	
	/**
	 * @ngInject
	 */
	function MdNavItem($$rAF) {
	  return {
	    restrict: 'E',
	    require: ['mdNavItem', '^mdNavBar'],
	    controller: MdNavItemController,
	    bindToController: true,
	    controllerAs: 'ctrl',
	    replace: true,
	    transclude: true,
	    template:
	      '<li class="md-nav-item" role="option" aria-selected="{{ctrl.isSelected()}}">' +
	        '<md-button ng-if="ctrl.mdNavSref" class="_md-nav-button md-accent"' +
	          'ng-class="ctrl.getNgClassMap()"' +
	          'tabindex="-1"' +
	          'ui-sref="{{ctrl.mdNavSref}}">' +
	          '<span ng-transclude class="_md-nav-button-text"></span>' +
	        '</md-button>' +
	        '<md-button ng-if="ctrl.mdNavHref" class="_md-nav-button md-accent"' +
	          'ng-class="ctrl.getNgClassMap()"' +
	          'tabindex="-1"' +
	          'ng-href="{{ctrl.mdNavHref}}">' +
	          '<span ng-transclude class="_md-nav-button-text"></span>' +
	        '</md-button>' +
	        '<md-button ng-if="ctrl.mdNavClick" class="_md-nav-button md-accent"' +
	          'ng-class="ctrl.getNgClassMap()"' +
	          'tabindex="-1"' +
	          'ng-click="ctrl.mdNavClick()">' +
	          '<span ng-transclude class="_md-nav-button-text"></span>' +
	        '</md-button>' +
	      '</li>',
	    scope: {
	      'mdNavClick': '&?',
	      'mdNavHref': '@?',
	      'mdNavSref': '@?',
	      'name': '@',
	    },
	    link: function(scope, element, attrs, controllers) {
	      var mdNavItem = controllers[0];
	      var mdNavBar = controllers[1];
	
	      // When accessing the element's contents synchronously, they
	      // may not be defined yet because of transclusion. There is a higher chance
	      // that it will be accessible if we wait one frame.
	      $$rAF(function() {
	        if (!mdNavItem.name) {
	          mdNavItem.name = angular.element(element[0].querySelector('._md-nav-button-text'))
	            .text().trim();
	        }
	
	        var navButton = angular.element(element[0].querySelector('._md-nav-button'));
	        navButton.on('click', function() {
	          mdNavBar.mdSelectedNavItem = mdNavItem.name;
	          scope.$apply();
	        });
	      });
	    }
	  };
	}
	
	/**
	 * Controller for the nav-item component.
	 * @param {!angular.JQLite} $element
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavItemController($element) {
	
	  /** @private @const {!angular.JQLite} */
	  this._$element = $element;
	
	  // Data-bound variables
	  /** @const {?Function} */
	  this.mdNavClick;
	  /** @const {?string} */
	  this.mdNavHref;
	  /** @const {?string} */
	  this.name;
	
	  // State variables
	  /** @private {boolean} */
	  this._selected = false;
	
	  /** @private {boolean} */
	  this._focused = false;
	
	  var hasNavClick = !!($element.attr('md-nav-click'));
	  var hasNavHref = !!($element.attr('md-nav-href'));
	  var hasNavSref = !!($element.attr('md-nav-sref'));
	
	  // Cannot specify more than one nav attribute
	  if ((hasNavClick ? 1:0) + (hasNavHref ? 1:0) + (hasNavSref ? 1:0) > 1) {
	    throw Error(
	        'Must specify exactly one of md-nav-click, md-nav-href, ' +
	        'md-nav-sref for nav-item directive');
	  }
	}
	
	/**
	 * Returns a map of class names and values for use by ng-class.
	 * @return {!Object<string,boolean>}
	 */
	MdNavItemController.prototype.getNgClassMap = function() {
	  return {
	    'md-active': this._selected,
	    'md-primary': this._selected,
	    'md-unselected': !this._selected,
	    'md-focused': this._focused,
	  };
	};
	
	/**
	 * Get the name attribute of the tab.
	 * @return {string}
	 */
	MdNavItemController.prototype.getName = function() {
	  return this.name;
	};
	
	/**
	 * Get the button element associated with the tab.
	 * @return {!Element}
	 */
	MdNavItemController.prototype.getButtonEl = function() {
	  return this._$element[0].querySelector('._md-nav-button');
	};
	
	/**
	 * Set the selected state of the tab.
	 * @param {boolean} isSelected
	 */
	MdNavItemController.prototype.setSelected = function(isSelected) {
	  this._selected = isSelected;
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.isSelected = function() {
	  return this._selected;
	};
	
	/**
	 * Set the focused state of the tab.
	 * @param {boolean} isFocused
	 */
	MdNavItemController.prototype.setFocused = function(isFocused) {
	  this._focused = isFocused;
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.hasFocus = function() {
	  return this._focused;
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.panel
	 */
	MdPanelService.$inject = ["$rootElement", "$rootScope", "$injector", "$window"];
	angular
	    .module('material.components.panel', [
	      'material.core',
	      'material.components.backdrop'
	    ])
	    .service('$mdPanel', MdPanelService);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	/**
	 * @ngdoc service
	 * @name $mdPanel
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanel` is a robust, low-level service for creating floating panels on
	 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   ‘use strict’;
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .controller('DemoDialogController', DialogController);
	 *
	 *   var panelRef;
	 *
	 *   function showPanel($event) {
	 *     var panelPosition = $mdPanel.newPanelPosition()
	 *         .absolute()
	 *         .top('50%')
	 *         .left('50%');
	 *
	 *     var panelAnimation = $mdPanel.newPanelAnimation()
	 *         .targetEvent($event)
	 *         .defaultAnimation('md-panel-animate-fly')
	 *         .closeTo('.show-button');
	 *
	 *     var config = {
	 *       attachTo: angular.element(document.body),
	 *       controller: DialogController,
	 *       controllerAs: 'ctrl',
	 *       position: panelPosition,
	 *       animation: panelAnimation,
	 *       targetEvent: $event,
	 *       templateUrl: 'dialog-template.html',
	 *       clickOutsideToClose: true,
	 *       escapeToClose: true,
	 *       focusOnOpen: true
	 *     }
	 *
	 *     $mdPanel.open(config)
	 *         .then(function(result) {
	 *           panelRef = result;
	 *         });
	 *   }
	 *
	 *   function DialogController(MdPanelRef, toppings) {
	 *     var toppings;
	 *
	 *     function closeDialog() {
	 *       MdPanelRef && MdPanelRef.close();
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#create
	 * @description
	 * Creates a panel with the specified options.
	 *
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
	 *     the created panel is added to a tracked panels object. Any subsequent
	 *     requests made to create a panel with that ID are ignored. This is useful
	 *     in having the panel service not open multiple panels from the same user
	 *     interaction when there is no backdrop and events are propagated. Defaults
	 *     to an arbitrary string that is not tracked.
	 *   - `template` - `{string=}`: HTML template to show in the panel. This
	 *     **must** be trusted HTML with respect to Angular’s
	 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
	 *     the panel.
	 *   - `controller` - `{(function|string)=}`: The controller to associate with
	 *     the panel. The controller can inject a reference to the returned
	 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
	 *     fields passed in through locals or resolve will be bound to the
	 *     controller.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
	 *     the scope.
	 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
	 *     instead of passing them in. Defaults to true, as this is a best
	 *     practice.
	 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
	 *     will be used as names of values to inject into the controller. For
	 *     example, `locals: {three: 3}` would inject `three` into the controller,
	 *     with the value 3.
	 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
	 *     values. The panel will not open until all of the promises resolve.
	 *   - `attachTo` - `{(string|!angular.JQLite|!Element)=}`: The element to
	 *     attach the panel to. Defaults to appending to the root element of the
	 *     application.
	 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
	 *     events should be allowed to propagate 'go through' the container, aka the
	 *     wrapper, of the panel. Defaults to false.
	 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
	 *     This class should define any borders, box-shadow, etc. for the panel.
	 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
	 *     Defaults to 80.
	 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
	 *     specifies the alignment of the panel. For more information, see
	 *     `MdPanelPosition`.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
	 *     outside the panel to close it. Defaults to false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
	 *     close the panel. Defaults to false.
	 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
	 *     panel. If `trapFocus` is true, the user will not be able to interact
	 *     with the rest of the page until the panel is dismissed. Defaults to
	 *     false.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
	 *     open. Only disable if focusing some other way, as focus management is
	 *     required for panels to be accessible. Defaults to true.
	 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
	 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
	 *     to false.
	 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
	 *     specifies the animation of the panel. For more information, see
	 *     `MdPanelAnimation`.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
	 *     behind the panel. Defaults to false.
	 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
	 *     page behind the panel. Defaults to false.
	 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
	 *     the panel is added to the DOM.
	 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
	 *     when the open() action is finished.
	 *   - `onRemoving` - `{function=}`: Callback function used to announce the
	 *     close/hide() action is starting.
	 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
	 *     the panel is removed from the DOM.
	 *   - `origin` - `{(string|!angular.JQLite|!Element)=}`: The element to focus
	 *     on when the panel closes. This is commonly the element which triggered
	 *     the opening of the panel. If you do not use `origin`, you need to control
	 *     the focus manually.
	 *
	 * @returns {!MdPanelRef} panelRef
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#open
	 * @description
	 * Calls the create method above, then opens the panel. This is a shortcut for
	 * creating and then calling open manually. If custom methods need to be
	 * called when the panel is added to the DOM or opened, do not use this method.
	 * Instead create the panel, chain promises on the domAdded and openComplete
	 * methods, and call open from the returned panelRef.
	 *
	 * @param {!Object=} config Specific configuration object that may contain
	 *     the properties defined in `$mdPanel.create`.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} panelRef A promise that resolves
	 *     to an instance of the panel.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelPosition
	 * @description
	 * Returns a new instance of the MdPanelPosition object. Use this to create
	 * the position config object.
	 *
	 * @returns {!MdPanelPosition} panelPosition
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelAnimation
	 * @description
	 * Returns a new instance of the MdPanelAnimation object. Use this to create
	 * the animation config object.
	 *
	 * @returns {!MdPanelAnimation} panelAnimation
	 */
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelRef
	 * @module material.components.panel
	 * @description
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with the following properties:
	 *
	 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
	 *     when a panel was interacted with.
	 *   - `config` - `{!Object=}`: The entire config object that was used in
	 *     create.
	 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
	 *     Visibility to the user does not factor into isAttached.
	 *   - `panelContainer` - `{angular.JQLite}`: The wrapper element containing the
	 *     panel. This property is added in order to have access to the `addClass`,
	 *     `removeClass`, `toggleClass`, etc methods.
	 *   - `panelEl` - `{angular.JQLite}`: The panel element. This property is added
	 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
	 *     etc methods.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#open
	 * @description
	 * Attaches and shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     opened.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#close
	 * @description
	 * Hides and detaches the panel. Note that this will **not** destroy the panel.
	 * If you don't intend on using the panel again, call the {@link #destroy
	 * destroy} method afterwards.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#attach
	 * @description
	 * Create the panel elements and attach them to the DOM. The panel will be
	 * hidden by default.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     attached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#detach
	 * @description
	 * Removes the panel from the DOM. This will NOT hide the panel before removing
	 * it.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     detached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#show
	 * @description
	 * Shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     shown and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#hide
	 * @description
	 * Hides the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     hidden and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#destroy
	 * @description
	 * Destroys the panel. The panel cannot be opened again after this is called.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Adds a class to the panel. DO NOT use this hide/show the panel.
	 *
	 * @param {string} newClass class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Removes a class from the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#toggleClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Toggles a class on the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} toggleClass Class to be toggled.
	 * @param {boolean} onElement Whether or not to remove the class from the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updatePosition
	 * @description
	 * Updates the position configuration of a panel. Use this to update the
	 * position of a panel that is open, without having to close and re-open the
	 * panel.
	 *
	 * @param {!MdPanelPosition} position
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelPosition
	 * @module material.components.panel
	 * @description
	 *
	 * Object for configuring the position of the panel.
	 *
	 * @usage
	 *
	 * #### Centering the panel
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition().absolute().center();
	 * </hljs>
	 *
	 * #### Overlapping the panel with an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.ALIGN_START,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 * </hljs>
	 *
	 * #### Aligning the panel with the bottom of an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#absolute
	 * @description
	 * Positions the panel absolutely relative to the parent element. If the parent
	 * is document.body, this is equivalent to positioning the panel absolutely
	 * within the viewport.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#relativeTo
	 * @description
	 * Positions the panel relative to a specific element.
	 *
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to position the panel with respect to.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#top
	 * @description
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#bottom
	 * @description
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#start
	 * @description
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 *
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#end
	 * @description
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 *
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#left
	 * @description
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#right
	 * @description
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerHorizontally
	 * @description
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerVertically
	 * @description
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#center
	 * @description
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#addPanelPosition
	 * @description
	 * Sets the x and y position for the panel relative to another element. Can be
	 * called multiple times to specify an ordered list of panel positions. The
	 * first position which allows the panel to be completely on-screen will be
	 * chosen; the last position will be chose whether it is on-screen or not.
	 *
	 * xPosition must be one of the following values available on
	 * $mdPanel.xPosition:
	 *
	 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
	 *
	 *    *************
	 *    *           *
	 *    *   PANEL   *
	 *    *           *
	 *    *************
	 *   A B    C    D E
	 *
	 * A: OFFSET_START (for LTR displays)
	 * B: ALIGN_START (for LTR displays)
	 * C: CENTER
	 * D: ALIGN_END (for LTR displays)
	 * E: OFFSET_END (for LTR displays)
	 *
	 * yPosition must be one of the following values available on
	 * $mdPanel.yPosition:
	 *
	 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
	 *
	 *   F
	 *   G *************
	 *     *           *
	 *   H *   PANEL   *
	 *     *           *
	 *   I *************
	 *   J
	 *
	 * F: BELOW
	 * G: ALIGN_TOPS
	 * H: CENTER
	 * I: ALIGN_BOTTOMS
	 * J: ABOVE
	 *
	 * @param {string} xPosition
	 * @param {string} yPosition
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetX
	 * @description
	 * Sets the value of the offset in the x-direction.
	 *
	 * @param {string} offsetX
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetY
	 * @description
	 * Sets the value of the offset in the y-direction.
	 *
	 * @param {string} offsetY
	 * @returns {!MdPanelPosition}
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc object
	 * @name MdPanelAnimation
	 * @description
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#openFrom
	 * @description
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 *
	 * @param {string|!Element|!Event|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#closeTo
	 * @description
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 *
	 * @param {string|!Element|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#withAnimation
	 * @description
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * ($mdPanel.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *       elements. It will not fade in or out.
	 *   SCALE: The panel scales in and out. Slide and fade are
	 *       included in this animation.
	 *   FADE: The panel fades in and out.
	 *
	 * Custom classes will by default fade in and out unless
	 * "transition: opacity 1ms" is added to the to custom class.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	
	
	/*****************************************************************************
	 *                                IMPLEMENTATION                             *
	 *****************************************************************************/
	
	
	// Default z-index for the panel.
	var defaultZIndex = 80;
	var MD_PANEL_HIDDEN = '_md-panel-hidden';
	
	var FOCUS_TRAP_TEMPLATE = angular.element(
	    '<div class="_md-panel-focus-trap" tabindex="0"></div>');
	
	
	/**
	 * A service that is used for controlling/displaying panels on the screen.
	 * @param {!angular.JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!angular.$injector} $injector
	 * @param {!angular.$window} $window
	 * @final @constructor @ngInject
	 */
	function MdPanelService($rootElement, $rootScope, $injector, $window) {
	  /**
	   * Default config options for the panel.
	   * Anything angular related needs to be done later. Therefore
	   *     scope: $rootScope.$new(true),
	   *     attachTo: $rootElement,
	   * are added later.
	   * @private {!Object}
	   */
	  this._defaultConfigOptions = {
	    bindToController: true,
	    clickOutsideToClose: false,
	    disableParentScroll: false,
	    escapeToClose: false,
	    focusOnOpen: true,
	    fullscreen: false,
	    hasBackdrop: false,
	    propagateContainerEvents: false,
	    transformTemplate: angular.bind(this, this._wrapTemplate),
	    trapFocus: false,
	    zIndex: defaultZIndex
	  };
	
	  /** @private {!Object} */
	  this._config = {};
	
	  /** @private @const */
	  this._$rootElement = $rootElement;
	
	  /** @private @const */
	  this._$rootScope = $rootScope;
	
	  /** @private @const */
	  this._$injector = $injector;
	
	  /** @private @const */
	  this._$window = $window;
	
	  /** @private {!Object<string, !MdPanelRef>} */
	  this._trackedPanels = {};
	
	  /**
	   * Default animations that can be used within the panel.
	   * @type {enum}
	   */
	  this.animation = MdPanelAnimation.animation;
	
	  /**
	   * Possible values of xPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.xPosition = MdPanelPosition.xPosition;
	
	  /**
	   * Possible values of yPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.yPosition = MdPanelPosition.yPosition;
	}
	
	
	/**
	 * Creates a panel with the specified options.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!MdPanelRef}
	 */
	MdPanelService.prototype.create = function(config) {
	  config = config || {};
	
	  // If the passed-in config contains an ID and the ID is within _trackedPanels,
	  // return the tracked panel.
	  if (angular.isDefined(config.id) && this._trackedPanels[config.id]) {
	    return this._trackedPanels[config.id];
	  }
	
	  // If no ID is set within the passed-in config, then create an arbitrary ID.
	  this._config = {
	    id: config.id || 'panel_' + this._$injector.get('$mdUtil').nextUid(),
	    scope: this._$rootScope.$new(true),
	    attachTo: this._$rootElement
	  };
	  angular.extend(this._config, this._defaultConfigOptions, config);
	
	  var panelRef = new MdPanelRef(this._config, this._$injector);
	  this._trackedPanels[config.id] = panelRef;
	
	  return panelRef;
	};
	
	
	/**
	 * Creates and opens a panel with the specified options.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} The panel created from create.
	 */
	MdPanelService.prototype.open = function(config) {
	  var panelRef = this.create(config);
	  return panelRef.open().then(function() {
	    return panelRef;
	  });
	};
	
	
	/**
	 * Returns a new instance of the MdPanelPosition. Use this to create the
	 * positioning object.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelService.prototype.newPanelPosition = function() {
	  return new MdPanelPosition(this._$injector);
	};
	
	
	/**
	 * Returns a new instance of the MdPanelAnimation. Use this to create the
	 * animation object.
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelService.prototype.newPanelAnimation = function() {
	  return new MdPanelAnimation(this._$injector);
	};
	
	
	/**
	 * Wraps the users template in two elements, md-panel-outer-wrapper, which
	 * covers the entire attachTo element, and md-panel, which contains only the
	 * template. This allows the panel control over positioning, animations,
	 * and similar properties.
	 * @param {string} origTemplate The original template.
	 * @returns {string} The wrapped template.
	 * @private
	 */
	MdPanelService.prototype._wrapTemplate = function(origTemplate) {
	  var template = origTemplate || '';
	
	  // The panel should be initially rendered offscreen so we can calculate
	  // height and width for positioning.
	  return '' +
	      '<div class="md-panel-outer-wrapper">' +
	      '  <div class="md-panel" style="left: -9999px;">' + template + '</div>' +
	      '</div>';
	};
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with properties/functions used to control the panel.
	 * @param {!Object} config
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelRef(config, $injector) {
	  // Injected variables.
	  /** @private @const {!angular.$q} */
	  this._$q = $injector.get('$q');
	
	  /** @private @const {!angular.$mdCompiler} */
	  this._$mdCompiler = $injector.get('$mdCompiler');
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /** @private @const {!angular.Scope} */
	  this._$rootScope = $injector.get('$rootScope');
	
	  /** @private @const {!angular.$animate} */
	  this._$animate = $injector.get('$animate');
	
	  /** @private @const {!MdPanelRef} */
	  this._$mdPanel = $injector.get('$mdPanel');
	
	  /** @private @const {!angular.$log} */
	  this._$log = $injector.get('$log');
	
	  /** @private @const {!angular.$window} */
	  this._$window = $injector.get('$window');
	
	  /** @private @const {!Function} */
	  this._$$rAF = $injector.get('$$rAF');
	
	  // Public variables.
	  /**
	   * Unique id for the panelRef.
	   * @type {string}
	   */
	  this.id = config.id;
	
	  /** @type {!Object} */
	  this.config = config;
	
	  /** @type {!angular.JQLite|undefined} */
	  this.panelContainer;
	
	  /** @type {!angular.JQLite|undefined} */
	  this.panelEl;
	
	  /**
	   * Whether the panel is attached. This is synchronous. When attach is called,
	   * isAttached is set to true. When detach is called, isAttached is set to
	   * false.
	   * @type {boolean}
	   */
	  this.isAttached = false;
	
	  // Private variables.
	  /** @private {Array<function()>} */
	  this._removeListeners = [];
	
	  /** @private {!angular.JQLite|undefined} */
	  this._topFocusTrap;
	
	  /** @private {!angular.JQLite|undefined} */
	  this._bottomFocusTrap;
	
	  /** @private {!$mdPanel|undefined} */
	  this._backdropRef;
	
	  /** @private {Function?} */
	  this._restoreScroll = null;
	}
	
	
	/**
	 * Opens an already created and configured panel. If the panel is already
	 * visible, does nothing.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is opened and animations finish.
	 */
	MdPanelRef.prototype.open = function() {
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var show = self._simpleBind(self.show, self);
	
	    self.attach()
	        .then(show)
	        .then(done)
	        .catch(reject);
	  });
	};
	
	
	/**
	 * Closes the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is closed and animations finish.
	 */
	MdPanelRef.prototype.close = function() {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var detach = self._simpleBind(self.detach, self);
	
	    self.hide()
	        .then(detach)
	        .then(done)
	        .catch(reject);
	  });
	};
	
	
	/**
	 * Attaches the panel. The panel will be hidden afterwards.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is attached.
	 */
	MdPanelRef.prototype.attach = function() {
	  if (this.isAttached && this.panelEl) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onDomAdded = self.config['onDomAdded'] || angular.noop;
	    var addListeners = function(response) {
	        self.isAttached = true;
	        self._addEventListeners();
	        return response;
	    };
	
	    self._$q.all([
	        self._createBackdrop(),
	        self._createPanel()
	            .then(addListeners)
	            .catch(reject)
	    ]).then(onDomAdded)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Only detaches the panel. Will NOT hide the panel first.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is detached.
	 */
	MdPanelRef.prototype.detach = function() {
	  if (!this.isAttached) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var onDomRemoved = self.config['onDomRemoved'] || angular.noop;
	
	  var detachFn = function() {
	    self._removeEventListeners();
	
	    // Remove the focus traps that we added earlier for keeping focus within
	    // the panel.
	    if (self._topFocusTrap && self._topFocusTrap.parentNode) {
	      self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);
	    }
	
	    if (self._bottomFocusTrap && self._bottomFocusTrap.parentNode) {
	      self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);
	    }
	
	    self.panelContainer.remove();
	    self.isAttached = false;
	    return self._$q.when(self);
	  };
	
	  if (this._restoreScroll) {
	    this._restoreScroll();
	    this._restoreScroll = null;
	  }
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	
	    self._$q.all([
	      detachFn(),
	      self._backdropRef ? self._backdropRef.detach() : true
	    ]).then(onDomRemoved)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Destroys the panel. The Panel cannot be opened again after this.
	 */
	MdPanelRef.prototype.destroy = function() {
	  this.config.scope.$destroy();
	  this.config.locals = null;
	};
	
	
	/**
	 * Shows the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has shown and animations finish.
	 */
	MdPanelRef.prototype.show = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (!this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var animatePromise = function() {
	    self.panelContainer.removeClass(MD_PANEL_HIDDEN);
	    return self._animateOpen();
	  };
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onOpenComplete = self.config['onOpenComplete'] || angular.noop;
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.show() : self,
	      animatePromise().then(function() { self._focusOnOpen(); }, reject)
	    ]).then(onOpenComplete)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Hides the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has hidden and animations finish.
	 */
	MdPanelRef.prototype.hide = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onRemoving = self.config['onRemoving'] || angular.noop;
	
	    var focusOnOrigin = function() {
	      var origin = self.config['origin'];
	      if (origin) {
	        getElement(origin).focus();
	      }
	    };
	
	    var hidePanel = function() {
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.hide() : self,
	      self._animateClose()
	          .then(onRemoving)
	          .then(hidePanel)
	          .then(focusOnOrigin)
	          .catch(reject)
	    ]).then(done, reject);
	  });
	};
	
	
	/**
	 * Add a class to the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} newClass Class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.addClass = function(newClass, toElement) {
	  this._$log.warn(
	      'The addClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the Angular Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error('Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!toElement && !this.panelContainer.hasClass(newClass)) {
	    this.panelContainer.addClass(newClass);
	  } else if (toElement && !this.panelEl.hasClass(newClass)) {
	    this.panelEl.addClass(newClass);
	  }
	};
	
	
	/**
	 * Remove a class from the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	MdPanelRef.prototype.removeClass = function(oldClass, fromElement) {
	  this._$log.warn(
	      'The removeClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the Angular Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error('Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!fromElement && this.panelContainer.hasClass(oldClass)) {
	    this.panelContainer.removeClass(oldClass);
	  } else if (fromElement && this.panelEl.hasClass(oldClass)) {
	    this.panelEl.removeClass(oldClass);
	  }
	};
	
	
	/**
	 * Toggle a class on the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} toggleClass The class to toggle.
	 * @param {boolean} onElement Whether or not to toggle the class on the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.toggleClass = function(toggleClass, onElement) {
	  this._$log.warn(
	      'The toggleClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the Angular Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error('Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!onElement) {
	    this.panelContainer.toggleClass(toggleClass);
	  } else {
	    this.panelEl.toggleClass(toggleClass);
	  }
	};
	
	
	/**
	 * Creates a panel and adds it to the dom.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     created.
	 * @private
	 */
	MdPanelRef.prototype._createPanel = function() {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    if (!self.config.locals) {
	      self.config.locals = {};
	    }
	
	    self.config.locals.mdPanelRef = self;
	    self._$mdCompiler.compile(self.config)
	        .then(function(compileData) {
	          self.panelContainer = compileData.link(self.config['scope']);
	          getElement(self.config['attachTo']).append(self.panelContainer);
	
	          if (self.config['disableParentScroll']) {
	            self._restoreScroll = self._$mdUtil.disableScrollAround(
	              null,
	              self.panelContainer,
	              { disableScrollMask: true }
	            );
	          }
	
	          self.panelEl = angular.element(
	              self.panelContainer[0].querySelector('.md-panel'));
	
	          // Add a custom CSS class to the panel element.
	          if (self.config['panelClass']) {
	            self.panelEl.addClass(self.config['panelClass']);
	          }
	
	          // Handle click and touch events for the panel container.
	          if (self.config['propagateContainerEvents']) {
	            self.panelContainer.css('pointer-events', 'none');
	          }
	
	          // Panel may be outside the $rootElement, tell ngAnimate to animate
	          // regardless.
	          if (self._$animate.pin) {
	            self._$animate.pin(self.panelContainer,
	                getElement(self.config['attachTo']));
	          }
	
	          self._configureTrapFocus();
	          self._addStyles().then(function() {
	            resolve(self);
	          }, reject);
	        }, reject);
	  });
	};
	
	
	/**
	 * Adds the styles for the panel, such as positioning and z-index.
	 * @returns {!angular.$q.Promise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._addStyles = function() {
	  var self = this;
	  return this._$q(function(resolve) {
	    self.panelContainer.css('z-index', self.config['zIndex']);
	    self.panelEl.css('z-index', self.config['zIndex'] + 1);
	
	    var hideAndResolve = function() {
	      // Remove left: -9999px and add hidden class.
	      self.panelEl.css('left', '');
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	      resolve(self);
	    };
	
	    if (self.config['fullscreen']) {
	      self.panelEl.addClass('_md-panel-fullscreen');
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    var positionConfig = self.config['position'];
	    if (!positionConfig) {
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    // Wait for angular to finish processing the template, then position it
	    // correctly. This is necessary so that the panel will have a defined height
	    // and width.
	    self._$rootScope['$$postDigest'](function() {
	      self._updatePosition(true);
	      resolve(self);
	    });
	  });
	};
	
	
	/**
	 * Updates the position configuration of a panel
	 * @param {!MdPanelPosition} position
	 */
	MdPanelRef.prototype.updatePosition = function(position) {
	  if (!this.panelContainer) {
	    throw new Error('Panel does not exist yet. Call open() or attach().');
	  }
	
	  this.config['position'] = position;
	  this._updatePosition();
	};
	
	
	/**
	 * Calculates and updates the position of the panel.
	 * @param {boolean=} init
	 * @private
	 */
	MdPanelRef.prototype._updatePosition = function(init) {
	  var positionConfig = this.config['position'];
	
	  if (positionConfig) {
	    positionConfig._setPanelPosition(this.panelEl);
	
	    // Hide the panel now that position is known.
	    if (init) {
	      this.panelContainer.addClass(MD_PANEL_HIDDEN);
	    }
	
	    this.panelEl.css(
	      MdPanelPosition.absPosition.TOP,
	      positionConfig.getTop()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.BOTTOM,
	      positionConfig.getBottom()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.LEFT,
	      positionConfig.getLeft()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.RIGHT,
	      positionConfig.getRight()
	    );
	
	    // Use the vendor prefixed version of transform.
	    var prefixedTransform = this._$mdConstant.CSS.TRANSFORM;
	    this.panelEl.css(prefixedTransform, positionConfig.getTransform());
	  }
	};
	
	
	/**
	 * Focuses on the panel or the first focus target.
	 * @private
	 */
	MdPanelRef.prototype._focusOnOpen = function() {
	  if (this.config['focusOnOpen']) {
	    // Wait for the template to finish rendering to guarantee md-autofocus has
	    // finished adding the class md-autofocus, otherwise the focusable element
	    // isn't available to focus.
	    var self = this;
	    this._$rootScope['$$postDigest'](function() {
	      var target = self._$mdUtil.findFocusTarget(self.panelEl) ||
	          self.panelEl;
	      target.focus();
	    });
	  }
	};
	
	
	/**
	 * Shows the backdrop.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the backdrop
	 *     is created and attached.
	 * @private
	 */
	MdPanelRef.prototype._createBackdrop = function() {
	  if (this.config.hasBackdrop) {
	    if (!this._backdropRef) {
	      var backdropAnimation = this._$mdPanel.newPanelAnimation()
	          .openFrom(this.config.attachTo)
	          .withAnimation({
	            open: '_md-opaque-enter',
	            close: '_md-opaque-leave'
	          });
	      var backdropConfig = {
	        animation: backdropAnimation,
	        attachTo: this.config.attachTo,
	        focusOnOpen: false,
	        panelClass: '_md-panel-backdrop',
	        zIndex: this.config.zIndex - 1
	      };
	      this._backdropRef = this._$mdPanel.create(backdropConfig);
	    }
	    if (!this._backdropRef.isAttached) {
	      return this._backdropRef.attach();
	    }
	  }
	};
	
	
	/**
	 * Listen for escape keys and outside clicks to auto close.
	 * @private
	 */
	MdPanelRef.prototype._addEventListeners = function() {
	  this._configureEscapeToClose();
	  this._configureClickOutsideToClose();
	  this._configureScrollListener();
	};
	
	
	/**
	 * Remove event listeners added in _addEventListeners.
	 * @private
	 */
	MdPanelRef.prototype._removeEventListeners = function() {
	  this._removeListeners && this._removeListeners.forEach(function(removeFn) {
	    removeFn();
	  });
	  this._removeListeners = [];
	};
	
	
	/**
	 * Setup the escapeToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureEscapeToClose = function() {
	  if (this.config['escapeToClose']) {
	    var parentTarget = getElement(this.config['attachTo']);
	    var self = this;
	
	    var keyHandlerFn = function(ev) {
	      if (ev.keyCode === self._$mdConstant.KEY_CODE.ESCAPE) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close();
	      }
	    };
	
	    // Add keydown listeners
	    this.panelContainer.on('keydown', keyHandlerFn);
	    parentTarget.on('keydown', keyHandlerFn);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      self.panelContainer.off('keydown', keyHandlerFn);
	      parentTarget.off('keydown', keyHandlerFn);
	    });
	  }
	};
	
	
	/**
	 * Setup the clickOutsideToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureClickOutsideToClose = function() {
	  if (this.config['clickOutsideToClose']) {
	    var target = this.panelContainer;
	    var sourceElem;
	
	    // Keep track of the element on which the mouse originally went down
	    // so that we can only close the backdrop when the 'click' started on it.
	    // A simple 'click' handler does not work,
	    // it sets the target object as the element the mouse went down on.
	    var mousedownHandler = function(ev) {
	      sourceElem = ev.target;
	    };
	
	    // We check if our original element and the target is the backdrop
	    // because if the original was the backdrop and the target was inside the
	    // panel we don't want to panel to close.
	    var self = this;
	    var mouseupHandler = function(ev) {
	      if (sourceElem === target[0] && ev.target === target[0]) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close();
	      }
	    };
	
	    // Add listeners
	    target.on('mousedown', mousedownHandler);
	    target.on('mouseup', mouseupHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      target.off('mousedown', mousedownHandler);
	      target.off('mouseup', mouseupHandler);
	    });
	  }
	};
	
	
	/**
	 * Configures the listeners for updating the panel position on scroll.
	 * @private
	*/
	MdPanelRef.prototype._configureScrollListener = function() {
	  var updatePosition = angular.bind(this, this._updatePosition);
	  var debouncedUpdatePosition = this._$$rAF.throttle(updatePosition);
	  var self = this;
	
	  var onScroll = function() {
	    if (!self.config['disableParentScroll']) {
	      debouncedUpdatePosition();
	    }
	  };
	
	  // Add listeners.
	  this._$window.addEventListener('scroll', onScroll, true);
	
	  // Queue remove listeners function.
	  this._removeListeners.push(function() {
	    self._$window.removeEventListener('scroll', onScroll, true);
	  });
	};
	
	
	/**
	 * Setup the focus traps. These traps will wrap focus when tabbing past the
	 * panel. When shift-tabbing, the focus will stick in place.
	 * @private
	 */
	MdPanelRef.prototype._configureTrapFocus = function() {
	  // Focus doesn't remain instead of the panel without this.
	  this.panelEl.attr('tabIndex', '-1');
	  if (this.config['trapFocus']) {
	    var element = this.panelEl;
	    // Set up elements before and after the panel to capture focus and
	    // redirect back into the panel.
	    this._topFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	    this._bottomFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	
	    // When focus is about to move out of the panel, we want to intercept it
	    // and redirect it back to the panel element.
	    var focusHandler = function() {
	      element.focus();
	    };
	    this._topFocusTrap.addEventListener('focus', focusHandler);
	    this._bottomFocusTrap.addEventListener('focus', focusHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(this._simpleBind(function() {
	      this._topFocusTrap.removeEventListener('focus', focusHandler);
	      this._bottomFocusTrap.removeEventListener('focus', focusHandler);
	    }, this));
	
	    // The top focus trap inserted immediately before the md-panel element (as
	    // a sibling). The bottom focus trap inserted immediately after the
	    // md-panel element (as a sibling).
	    element[0].parentNode.insertBefore(this._topFocusTrap, element[0]);
	    element.after(this._bottomFocusTrap);
	  }
	};
	
	
	/**
	 * Animate the panel opening.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated open.
	 * @private
	 */
	MdPanelRef.prototype._animateOpen = function() {
	  this.panelContainer.addClass('md-panel-is-showing');
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    // Promise is in progress, return it.
	    this.panelContainer.addClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = self._done(resolve, self);
	    var warnAndOpen = function() {
	      self._$log.warn(
	          'MdPanel Animations failed. Showing panel without animating.');
	      done();
	    };
	
	    animationConfig.animateOpen(self.panelEl)
	        .then(done, warnAndOpen);
	  });
	};
	
	
	/**
	 * Animate the panel closing.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated closed.
	 * @private
	 */
	MdPanelRef.prototype._animateClose = function() {
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    this.panelContainer.removeClass('md-panel-is-showing');
	    this.panelContainer.removeClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = function() {
	      self.panelContainer.removeClass('md-panel-is-showing');
	      resolve(self);
	    };
	    var warnAndClose = function() {
	      self._$log.warn(
	          'MdPanel Animations failed. Hiding panel without animating.');
	      done();
	    };
	
	    animationConfig.animateClose(self.panelEl)
	        .then(done, warnAndClose);
	  });
	};
	
	
	/**
	 * Faster, more basic than angular.bind
	 * http://jsperf.com/angular-bind-vs-custom-vs-native
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a bound self.
	 */
	MdPanelRef.prototype._simpleBind = function(callback, self) {
	  return function(value) {
	    return callback.apply(self, value);
	  };
	};
	
	
	/**
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a self param.
	 */
	MdPanelRef.prototype._done = function(callback, self) {
	  return function() {
	    callback(self);
	  };
	};
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                             *
	 *****************************************************************************/
	
	
	/**
	 * Position configuration object. To use, create an MdPanelPosition with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelPosition = new MdPanelPosition()
	 *     .relativeTo(myButtonEl)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.CENTER,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 *
	 * $mdPanel.create({
	 *   position: panelPosition
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelPosition($injector) {
	  /** @private @const {!angular.$window} */
	  this._$window = $injector.get('$window');
	
	  /** @private {boolean} */
	  this._isRTL = $injector.get('$mdUtil').bidi() === 'rtl';
	
	  /** @private {boolean} */
	  this._absolute = false;
	
	  /** @private {!angular.JQLite} */
	  this._relativeToEl;
	
	  /** @private {string} */
	  this._top = '';
	
	  /** @private {string} */
	  this._bottom = '';
	
	  /** @private {string} */
	  this._left = '';
	
	  /** @private {string} */
	  this._right = '';
	
	  /** @private {!Array<string>} */
	  this._translateX = [];
	
	  /** @private {!Array<string>} */
	  this._translateY = [];
	
	  /** @private {!Array<{x:string, y:string}>} */
	  this._positions = [];
	
	  /** @private {?{x:string, y:string}} */
	  this._actualPosition;
	}
	
	
	/**
	 * Possible values of xPosition.
	 * @enum {string}
	 */
	MdPanelPosition.xPosition = {
	  CENTER: 'center',
	  ALIGN_START: 'align-start',
	  ALIGN_END: 'align-end',
	  OFFSET_START: 'offset-start',
	  OFFSET_END: 'offset-end'
	};
	
	
	/**
	 * Possible values of yPosition.
	 * @enum {string}
	 */
	MdPanelPosition.yPosition = {
	  CENTER: 'center',
	  ALIGN_TOPS: 'align-tops',
	  ALIGN_BOTTOMS: 'align-bottoms',
	  ABOVE: 'above',
	  BELOW: 'below'
	};
	
	
	/**
	 * Possible values of absolute position.
	 * @enum {string}
	 */
	MdPanelPosition.absPosition = {
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	
	
	/**
	 * Sets absolute positioning for the panel.
	 * @return {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.absolute = function() {
	  this._absolute = true;
	  return this;
	};
	
	/**
	 * Sets the value of a position for the panel. Clears any previously set
	 * position.
	 * @param {string} position Position to set
	 * @param {string=} value Value of the position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 * @private
	 */
	MdPanelPosition.prototype._setPosition = function(position, value) {
	  if (position === MdPanelPosition.absPosition.RIGHT ||
	      position === MdPanelPosition.absPosition.LEFT) {
	    this._left = this._right = '';
	  } else if (
	      position === MdPanelPosition.absPosition.BOTTOM ||
	      position === MdPanelPosition.absPosition.TOP) {
	    this._top = this._bottom = '';
	  } else {
	    var positions = Object.keys(MdPanelPosition.absPosition).join()
	        .toLowerCase();
	
	    throw new Error('Position must be one of ' + positions + '.');
	  }
	
	  this['_' +  position] = angular.isString(value) ? value : '0';
	
	  return this;
	};
	
	
	/**
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.top = function(top) {
	  return this._setPosition(MdPanelPosition.absPosition.TOP, top);
	};
	
	
	/**
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.bottom = function(bottom) {
	  return this._setPosition(MdPanelPosition.absPosition.BOTTOM, bottom);
	};
	
	
	/**
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.start = function(start) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.RIGHT : MdPanelPosition.absPosition.LEFT;
	  return this._setPosition(position, start);
	};
	
	
	/**
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.end = function(end) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.LEFT : MdPanelPosition.absPosition.RIGHT;
	  return this._setPosition(position, end);
	};
	
	
	/**
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.left = function(left) {
	  return this._setPosition(MdPanelPosition.absPosition.LEFT, left);
	};
	
	
	/**
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	*/
	MdPanelPosition.prototype.right = function(right) {
	  return this._setPosition(MdPanelPosition.absPosition.RIGHT, right);
	};
	
	
	/**
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerHorizontally = function() {
	  this._left = '50%';
	  this._right = '';
	  this._translateX = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerVertically = function() {
	  this._top = '50%';
	  this._bottom = '';
	  this._translateY = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.center = function() {
	  return this.centerHorizontally().centerVertically();
	};
	
	
	/**
	 * Sets element for relative positioning.
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to set the panel relative to.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.relativeTo = function(element) {
	  this._absolute = false;
	  this._relativeToEl = getElement(element);
	  return this;
	};
	
	
	/**
	 * Sets the x and y positions for the panel relative to another element.
	 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
	 *     values.
	 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
	 *     values.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.addPanelPosition = function(xPosition, yPosition) {
	  if (!this._relativeToEl) {
	    throw new Error('addPanelPosition can only be used with relative ' +
	        'positioning. Set relativeTo first.');
	  }
	
	  this._validateXPosition(xPosition);
	  this._validateYPosition(yPosition);
	
	  this._positions.push({
	      x: xPosition,
	      y: yPosition,
	  });
	  return this;
	};
	
	
	/**
	 * Ensures that yPosition is a valid position name. Throw an exception if not.
	 * @param {string} yPosition
	 */
	MdPanelPosition.prototype._validateYPosition = function(yPosition) {
	  // empty is ok
	  if (yPosition == null) {
	      return;
	  }
	
	  var positionKeys = Object.keys(MdPanelPosition.yPosition);
	  var positionValues = [];
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = MdPanelPosition.yPosition[key];
	    positionValues.push(position);
	
	    if (position === yPosition) {
	      return;
	    }
	  }
	
	  throw new Error('Panel y position only accepts the following values:\n' +
	    positionValues.join(' | '));
	};
	
	
	/**
	 * Ensures that xPosition is a valid position name. Throw an exception if not.
	 * @param {string} xPosition
	 */
	MdPanelPosition.prototype._validateXPosition = function(xPosition) {
	  // empty is ok
	  if (xPosition == null) {
	      return;
	  }
	
	  var positionKeys = Object.keys(MdPanelPosition.xPosition);
	  var positionValues = [];
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = MdPanelPosition.xPosition[key];
	    positionValues.push(position);
	    if (position === xPosition) {
	      return;
	    }
	  }
	
	  throw new Error('Panel x Position only accepts the following values:\n' +
	      positionValues.join(' | '));
	};
	
	
	/**
	 * Sets the value of the offset in the x-direction. This will add to any
	 * previously set offsets.
	 * @param {string} offsetX
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetX = function(offsetX) {
	  this._translateX.push(offsetX);
	  return this;
	};
	
	
	/**
	 * Sets the value of the offset in the y-direction. This will add to any
	 * previously set offsets.
	 * @param {string} offsetY
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetY = function(offsetY) {
	  this._translateY.push(offsetY);
	  return this;
	};
	
	
	/**
	 * Gets the value of `top` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTop = function() {
	  return this._top;
	};
	
	
	/**
	 * Gets the value of `bottom` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getBottom = function() {
	  return this._bottom;
	};
	
	
	/**
	 * Gets the value of `left` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getLeft = function() {
	  return this._left;
	};
	
	
	/**
	 * Gets the value of `right` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getRight = function() {
	  return this._right;
	};
	
	
	/**
	 * Gets the value of `transform` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTransform = function() {
	  var translateX = this._reduceTranslateValues('translateX', this._translateX);
	  var translateY = this._reduceTranslateValues('translateY', this._translateY);
	
	  // It's important to trim the result, because the browser will ignore the set
	  // operation if the string contains only whitespace.
	  return (translateX + ' ' + translateY).trim();
	};
	
	/**
	 * True if the panel is completely on-screen with this positioning; false
	 * otherwise.
	 * @param {!angular.JQLite} panelEl
	 * @return {boolean}
	 */
	MdPanelPosition.prototype._isOnscreen = function(panelEl) {
	  // this works because we always use fixed positioning for the panel,
	  // which is relative to the viewport.
	  // TODO(gmoothart): take into account _translateX and _translateY to the
	  // extent feasible.
	
	  var left = parseInt(this.getLeft());
	  var top = parseInt(this.getTop());
	  var right = left + panelEl[0].offsetWidth;
	  var bottom = top + panelEl[0].offsetHeight;
	
	  return (left >= 0) &&
	    (top >= 0) &&
	    (bottom <= this._$window.innerHeight) &&
	    (right <= this._$window.innerWidth);
	};
	
	
	/**
	 * Gets the first x/y position that can fit on-screen.
	 * @returns {{x: string, y: string}}
	 */
	MdPanelPosition.prototype.getActualPosition = function() {
	  return this._actualPosition;
	};
	
	
	/**
	 * Reduces a list of translate values to a string that can be used within
	 * transform.
	 * @param {string} translateFn
	 * @param {!Array<string>} values
	 * @returns {string}
	 * @private
	 */
	MdPanelPosition.prototype._reduceTranslateValues =
	    function(translateFn, values) {
	      return values.map(function(translation) {
	        return translateFn + '(' + translation + ')';
	      }).join(' ');
	    };
	
	
	/**
	 * Sets the panel position based on the created panel element and best x/y
	 * positioning.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelPosition.prototype._setPanelPosition = function(panelEl) {
	  // Only calculate the position if necessary.
	  if (this._absolute) {
	    return;
	  }
	
	  if (this._actualPosition) {
	    this._calculatePanelPosition(panelEl, this._actualPosition);
	    return;
	  }
	
	  for (var i = 0; i < this._positions.length; i++) {
	    this._actualPosition = this._positions[i];
	    this._calculatePanelPosition(panelEl, this._actualPosition);
	    if (this._isOnscreen(panelEl)) {
	      break;
	    }
	  }
	};
	
	
	/**
	 * Switches between 'start' and 'end'.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} Reversed position
	 * @private
	 */
	MdPanelPosition.prototype._reverseXPosition = function(position) {
	  if (position === MdPanelPosition.xPosition.CENTER) {
	    return;
	  }
	
	  var start = 'start';
	  var end = 'end';
	
	  return position.indexOf(start) > -1 ? position.replace(start, end) : position.replace(end, start);
	};
	
	
	/**
	 * Handles horizontal positioning in rtl or ltr environments.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} The correct position according the page direction
	 * @private
	 */
	MdPanelPosition.prototype._bidi = function(position) {
	  return this._isRTL ? this._reverseXPosition(position) : position;
	};
	
	
	/**
	 * Calculates the panel position based on the created panel element and the
	 * provided positioning.
	 * @param {!angular.JQLite} panelEl
	 * @param {!{x:string, y:string}} position
	 * @private
	 */
	MdPanelPosition.prototype._calculatePanelPosition = function(panelEl, position) {
	
	  var panelBounds = panelEl[0].getBoundingClientRect();
	  var panelWidth = panelBounds.width;
	  var panelHeight = panelBounds.height;
	
	  var targetBounds = this._relativeToEl[0].getBoundingClientRect();
	
	  var targetLeft = targetBounds.left;
	  var targetRight = targetBounds.right;
	  var targetWidth = targetBounds.width;
	
	  switch (this._bidi(position.x)) {
	    case MdPanelPosition.xPosition.OFFSET_START:
	      this._left = targetLeft - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_END:
	      this._left = targetRight - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.CENTER:
	      var left = targetLeft + (0.5 * targetWidth) - (0.5 * panelWidth);
	      this._left = left + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_START:
	      this._left = targetLeft + 'px';
	      break;
	    case MdPanelPosition.xPosition.OFFSET_END:
	      this._left = targetRight + 'px';
	      break;
	  }
	
	  var targetTop = targetBounds.top;
	  var targetBottom = targetBounds.bottom;
	  var targetHeight = targetBounds.height;
	
	  switch (position.y) {
	    case MdPanelPosition.yPosition.ABOVE:
	      this._top = targetTop - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_BOTTOMS:
	      this._top = targetBottom - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.CENTER:
	      var top = targetTop + (0.5 * targetHeight) - (0.5 * panelHeight);
	      this._top = top + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_TOPS:
	      this._top = targetTop + 'px';
	      break;
	    case MdPanelPosition.yPosition.BELOW:
	      this._top = targetBottom + 'px';
	      break;
	  }
	};
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelAnimation($injector) {
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._openFrom;
	
	  /**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._closeTo;
	
	  /** @private {string|{open: string, close: string}} */
	  this._animationClass = '';
	}
	
	
	/**
	 * Possible default animations.
	 * @enum {string}
	 */
	MdPanelAnimation.animation = {
	  SLIDE: 'md-panel-animate-slide',
	  SCALE: 'md-panel-animate-scale',
	  FADE: 'md-panel-animate-fade'
	};
	
	
	/**
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.openFrom = function(openFrom) {
	  // Check if 'openFrom' is an Event.
	  openFrom = openFrom.target ? openFrom.target : openFrom;
	
	  this._openFrom = this._getPanelAnimationTarget(openFrom);
	
	  if (!this._closeTo) {
	    this._closeTo = this._openFrom;
	  }
	  return this;
	};
	
	
	/**
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 * @param {string|!Element|{top: number, left: number}} closeTo
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.closeTo = function(closeTo) {
	  this._closeTo = this._getPanelAnimationTarget(closeTo);
	  return this;
	};
	
	
	/**
	 * Returns the element and bounds for the animation target.
	 * @param {string|!Element|{top: number, left: number}} location
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getPanelAnimationTarget = function(location) {
	  if (angular.isDefined(location.top) || angular.isDefined(location.left)) {
	    return {
	      element: undefined,
	      bounds: {
	        top: location.top || 0,
	        left: location.left || 0
	      }
	    };
	  } else {
	    return this._getBoundingClientRect(getElement(location));
	  }
	};
	
	
	/**
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * (MdPanelAnimation.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *        elements.
	 *   SCALE: The panel scales in and out.
	 *   FADE: The panel fades in and out.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.withAnimation = function(cssClass) {
	  this._animationClass = cssClass;
	  return this;
	};
	
	
	/**
	 * Animate the panel open.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that is resolved when the open
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateOpen = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	
	  this._fixBounds(panelEl);
	  var animationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var openFrom = animator.toTransformCss(panelTransform);
	  var openTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openSlide = animator.calculateSlideToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openScale = animator.calculateZoomToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openScale + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        animationOptions = {
	          transitionInClass: this._animationClass
	        };
	      } else {
	        animationOptions = {
	          transitionInClass: this._animationClass['open'],
	          transitionOutClass: this._animationClass['close'],
	        };
	      }
	  }
	
	  return animator
	      .translate3d(panelEl, openFrom, openTo, animationOptions);
	};
	
	
	/**
	 * Animate the panel close.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that resolves when the close
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateClose = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	  var reverseAnimationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var closeFrom = animator.toTransformCss(panelTransform);
	  var closeTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-leave'
	      };
	
	      var closeSlide = animator.calculateSlideToOrigin(
	              panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-scale-out _md-panel-animate-leave'
	      };
	
	      var closeScale = animator.calculateZoomToOrigin(
	              panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeScale + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-fade-out _md-panel-animate-leave'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        reverseAnimationOptions = {
	          transitionOutClass: this._animationClass
	        };
	      } else {
	        reverseAnimationOptions = {
	          transitionInClass: this._animationClass['close'],
	          transitionOutClass: this._animationClass['open']
	        };
	      }
	  }
	
	  return animator
	      .translate3d(panelEl, closeFrom, closeTo, reverseAnimationOptions);
	};
	
	
	/**
	 * Set the height and width to match the panel if not provided.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelAnimation.prototype._fixBounds = function(panelEl) {
	  var panelWidth = panelEl[0].offsetWidth;
	  var panelHeight = panelEl[0].offsetHeight;
	
	  if (this._openFrom && this._openFrom.bounds.height == null) {
	    this._openFrom.bounds.height = panelHeight;
	  }
	  if (this._openFrom && this._openFrom.bounds.width == null) {
	    this._openFrom.bounds.width = panelWidth;
	  }
	  if (this._closeTo && this._closeTo.bounds.height == null) {
	    this._closeTo.bounds.height = panelHeight;
	  }
	  if (this._closeTo && this._closeTo.bounds.width == null) {
	    this._closeTo.bounds.width = panelWidth;
	  }
	};
	
	
	/**
	 * Identify the bounding RECT for the target element.
	 * @param {!angular.JQLite} element
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getBoundingClientRect = function(element) {
	  if (element instanceof angular.element) {
	    return {
	      element: element,
	      bounds: element[0].getBoundingClientRect()
	    };
	  }
	};
	
	
	/*****************************************************************************
	 *                                Util Methods                               *
	 *****************************************************************************/
	
	/**
	 * Returns the angular element associated with a css selector or element.
	 * @param el {string|!angular.JQLite|!Element}
	 * @returns {!angular.JQLite}
	 */
	function getElement(el) {
	  var queryResult = angular.isString(el) ?
	      document.querySelector(el) : el;
	  return angular.element(queryResult);
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressCircular
	 * @description Module for a circular progressbar
	 */
	
	angular.module('material.components.progressCircular', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressLinear
	 * @description Linear Progress module!
	 */
	MdProgressLinearDirective.$inject = ["$mdTheming", "$mdUtil", "$log"];
	angular.module('material.components.progressLinear', [
	  'material.core'
	])
	  .directive('mdProgressLinear', MdProgressLinearDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdProgressLinear
	 * @module material.components.progressLinear
	 * @restrict E
	 *
	 * @description
	 * The linear progress directive is used to make loading content
	 * in your app as delightful and painless as possible by minimizing
	 * the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * Each operation should only be represented by one activity indicator
	 * For example: one refresh operation should not display both a
	 * refresh bar and an activity circle.
	 *
	 * For operations where the percentage of the operation completed
	 * can be determined, use a determinate indicator. They give users
	 * a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while
	 * something finishes up, and it’s not necessary to expose what's
	 * happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
	 * then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
	 * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="query"></md-progress-linear>
	 * </hljs>
	 */
	function MdProgressLinearDirective($mdTheming, $mdUtil, $log) {
	  var MODE_DETERMINATE = "determinate";
	  var MODE_INDETERMINATE = "indeterminate";
	  var MODE_BUFFER = "buffer";
	  var MODE_QUERY = "query";
	  var DISABLED_CLASS = "_md-progress-linear-disabled";
	
	  return {
	    restrict: 'E',
	    template: '<div class="md-container">' +
	      '<div class="md-dashed"></div>' +
	      '<div class="md-bar md-bar1"></div>' +
	      '<div class="md-bar md-bar2"></div>' +
	      '</div>',
	    compile: compile
	  };
	
	  function compile(tElement, tAttrs, transclude) {
	    tElement.attr('aria-valuemin', 0);
	    tElement.attr('aria-valuemax', 100);
	    tElement.attr('role', 'progressbar');
	
	    return postLink;
	  }
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	
	    var lastMode;
	    var isDisabled = attr.hasOwnProperty('disabled');
	    var toVendorCSS = $mdUtil.dom.animator.toCss;
	    var bar1 = angular.element(element[0].querySelector('.md-bar1'));
	    var bar2 = angular.element(element[0].querySelector('.md-bar2'));
	    var container = angular.element(element[0].querySelector('.md-container'));
	
	    element
	      .attr('md-mode', mode())
	      .toggleClass(DISABLED_CLASS, isDisabled);
	
	    validateMode();
	    watchAttributes();
	
	    /**
	     * Watch the value, md-buffer-value, and md-mode attributes
	     */
	    function watchAttributes() {
	      attr.$observe('value', function(value) {
	        var percentValue = clamp(value);
	        element.attr('aria-valuenow', percentValue);
	
	        if (mode() != MODE_QUERY) animateIndicator(bar2, percentValue);
	      });
	
	      attr.$observe('mdBufferValue', function(value) {
	        animateIndicator(bar1, clamp(value));
	      });
	
	      attr.$observe('disabled', function(value) {
	        if (value === true || value === false) {
	          isDisabled = !!value;
	        } else {
	          isDisabled = angular.isDefined(value);
	        }
	
	        element.toggleClass(DISABLED_CLASS, isDisabled);
	        container.toggleClass(lastMode, !isDisabled);
	      });
	
	      attr.$observe('mdMode', function(mode) {
	        if (lastMode) container.removeClass( lastMode );
	
	        switch( mode ) {
	          case MODE_QUERY:
	          case MODE_BUFFER:
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	            container.addClass( lastMode = "md-mode-" + mode );
	            break;
	          default:
	            container.addClass( lastMode = "md-mode-" + MODE_INDETERMINATE );
	            break;
	        }
	      });
	    }
	
	    /**
	     * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
	     */
	    function validateMode() {
	      if ( angular.isUndefined(attr.mdMode) ) {
	        var hasValue = angular.isDefined(attr.value);
	        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        var info = "Auto-adding the missing md-mode='{0}' to the ProgressLinear element";
	
	        //$log.debug( $mdUtil.supplant(info, [mode]) );
	
	        element.attr("md-mode", mode);
	        attr.mdMode = mode;
	      }
	    }
	
	    /**
	     * Is the md-mode a valid option?
	     */
	    function mode() {
	      var value = (attr.mdMode || "").trim();
	      if ( value ) {
	        switch(value) {
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	          case MODE_BUFFER:
	          case MODE_QUERY:
	            break;
	          default:
	            value = MODE_INDETERMINATE;
	            break;
	        }
	      }
	      return value;
	    }
	
	    /**
	     * Manually set CSS to animate the Determinate indicator based on the specified
	     * percentage value (0-100).
	     */
	    function animateIndicator(target, value) {
	      if ( isDisabled || !mode() ) return;
	
	      var to = $mdUtil.supplant("translateX({0}%) scale({1},1)", [ (value-100)/2, value/100 ]);
	      var styles = toVendorCSS({ transform : to });
	      angular.element(target).css( styles );
	    }
	  }
	
	  /**
	   * Clamps the value to be between 0 and 100.
	   * @param {number} value The value to clamp.
	   * @returns {number}
	   */
	  function clamp(value) {
	    return Math.max(0, Math.min(value || 0, 100));
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.radioButton
	 * @description radioButton module!
	 */
	mdRadioGroupDirective.$inject = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];
	mdRadioButtonDirective.$inject = ["$mdAria", "$mdUtil", "$mdTheming"];
	angular.module('material.components.radioButton', [
	  'material.core'
	])
	  .directive('mdRadioGroup', mdRadioGroupDirective)
	  .directive('mdRadioButton', mdRadioButtonDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioGroup
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-group>` directive identifies a grouping
	 * container for the 1..n grouped radio buttons; specified using nested
	 * `<md-radio-button>` tags.
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the radio button is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * Note: `<md-radio-group>` and `<md-radio-button>` handle tabindex differently
	 * than the native `<input type='radio'>` controls. Whereas the native controls
	 * force the user to tab through all the radio buttons, `<md-radio-group>`
	 * is focusable, and by default the `<md-radio-button>`s are not.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {boolean=} md-no-ink Use of attribute indicates flag to disable ink ripple effects.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-radio-group ng-model="selected">
	 *
	 *   <md-radio-button
	 *        ng-repeat="d in colorOptions"
	 *        ng-value="d.value" aria-label="{{ d.label }}">
	 *
	 *          {{ d.label }}
	 *
	 *   </md-radio-button>
	 *
	 * </md-radio-group>
	 * </hljs>
	 *
	 */
	function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
	  RadioGroupController.prototype = createRadioGroupControllerProto();
	
	  return {
	    restrict: 'E',
	    controller: ['$element', RadioGroupController],
	    require: ['mdRadioGroup', '?ngModel'],
	    link: { pre: linkRadioGroup }
	  };
	
	  function linkRadioGroup(scope, element, attr, ctrls) {
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	    
	    var rgCtrl = ctrls[0];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	
	    rgCtrl.init(ngModelCtrl);
	
	    scope.mouseActive = false;
	
	    element
	      .attr({
	        'role': 'radiogroup',
	        'tabIndex': element.attr('tabindex') || '0'
	      })
	      .on('keydown', keydownListener)
	      .on('mousedown', function(event) {
	        scope.mouseActive = true;
	        $timeout(function() {
	          scope.mouseActive = false;
	        }, 100);
	      })
	      .on('focus', function() {
	        if(scope.mouseActive === false) {
	          rgCtrl.$element.addClass('md-focused');
	        }
	      })
	      .on('blur', function() {
	        rgCtrl.$element.removeClass('md-focused');
	      });
	
	    /**
	     *
	     */
	    function setFocus() {
	      if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
	    }
	
	    /**
	     *
	     */
	    function keydownListener(ev) {
	      var keyCode = ev.which || ev.keyCode;
	
	      // Only listen to events that we originated ourselves
	      // so that we don't trigger on things like arrow keys in
	      // inputs.
	
	      if (keyCode != $mdConstant.KEY_CODE.ENTER &&
	          ev.currentTarget != ev.target) {
	        return;
	      }
	
	      switch (keyCode) {
	        case $mdConstant.KEY_CODE.LEFT_ARROW:
	        case $mdConstant.KEY_CODE.UP_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectPrevious();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        case $mdConstant.KEY_CODE.DOWN_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectNext();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.ENTER:
	          var form = angular.element($mdUtil.getClosest(element[0], 'form'));
	          if (form.length > 0) {
	            form.triggerHandler('submit');
	          }
	          break;
	      }
	
	    }
	  }
	
	  function RadioGroupController($element) {
	    this._radioButtonRenderFns = [];
	    this.$element = $element;
	  }
	
	  function createRadioGroupControllerProto() {
	    return {
	      init: function(ngModelCtrl) {
	        this._ngModelCtrl = ngModelCtrl;
	        this._ngModelCtrl.$render = angular.bind(this, this.render);
	      },
	      add: function(rbRender) {
	        this._radioButtonRenderFns.push(rbRender);
	      },
	      remove: function(rbRender) {
	        var index = this._radioButtonRenderFns.indexOf(rbRender);
	        if (index !== -1) {
	          this._radioButtonRenderFns.splice(index, 1);
	        }
	      },
	      render: function() {
	        this._radioButtonRenderFns.forEach(function(rbRender) {
	          rbRender();
	        });
	      },
	      setViewValue: function(value, eventType) {
	        this._ngModelCtrl.$setViewValue(value, eventType);
	        // update the other radio buttons as well
	        this.render();
	      },
	      getViewValue: function() {
	        return this._ngModelCtrl.$viewValue;
	      },
	      selectNext: function() {
	        return changeSelectedButton(this.$element, 1);
	      },
	      selectPrevious: function() {
	        return changeSelectedButton(this.$element, -1);
	      },
	      setActiveDescendant: function (radioId) {
	        this.$element.attr('aria-activedescendant', radioId);
	      },
	      isDisabled: function() {
	        return this.$element[0].hasAttribute('disabled');
	      }
	    };
	  }
	  /**
	   * Change the radio group's selected button by a given increment.
	   * If no button is selected, select the first button.
	   */
	  function changeSelectedButton(parent, increment) {
	    // Coerce all child radio buttons into an array, then wrap then in an iterator
	    var buttons = $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);
	
	    if (buttons.count()) {
	      var validate = function (button) {
	        // If disabled, then NOT valid
	        return !angular.element(button).attr("disabled");
	      };
	
	      var selected = parent[0].querySelector('md-radio-button.md-checked');
	      var target = buttons[increment < 0 ? 'previous' : 'next'](selected, validate) || buttons.first();
	
	      // Activate radioButton's click listener (triggerHandler won't create a real click event)
	      angular.element(target).triggerHandler('click');
	
	
	    }
	  }
	
	}
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioButton
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
	 *
	 * While similar to the `<input type="radio" ng-model="" value="">` directive,
	 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
	 * supports use within named radio groups.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {string} ngValue Angular expression which sets the value to which the expression should
	 *    be set when selected.
	 * @param {string} value The value to which the expression should be set when selected.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} aria-label Adds label to radio button for accessibility.
	 * Defaults to radio button's text. If no text content is available, a warning will be logged.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-radio-button value="1" aria-label="Label 1">
	 *   Label 1
	 * </md-radio-button>
	 *
	 * <md-radio-button ng-model="color" ng-value="specialValue" aria-label="Green">
	 *   Green
	 * </md-radio-button>
	 *
	 * </hljs>
	 *
	 */
	function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {
	
	  var CHECKED_CSS = 'md-checked';
	
	  return {
	    restrict: 'E',
	    require: '^mdRadioGroup',
	    transclude: true,
	    template: '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	                '<div class="md-off"></div>' +
	                '<div class="md-on"></div>' +
	              '</div>' +
	              '<div ng-transclude class="md-label"></div>',
	    link: link
	  };
	
	  function link(scope, element, attr, rgCtrl) {
	    var lastChecked;
	
	    $mdTheming(element);
	    configureAria(element, scope);
	
	    initialize();
	
	    /**
	     *
	     */
	    function initialize() {
	      if (!rgCtrl) {
	        throw 'RadioButton: No RadioGroupController could be found.';
	      }
	
	      rgCtrl.add(render);
	      attr.$observe('value', render);
	
	      element
	        .on('click', listener)
	        .on('$destroy', function() {
	          rgCtrl.remove(render);
	        });
	    }
	
	    /**
	     *
	     */
	    function listener(ev) {
	      if (element[0].hasAttribute('disabled') || rgCtrl.isDisabled()) return;
	
	      scope.$apply(function() {
	        rgCtrl.setViewValue(attr.value, ev && ev.type);
	      });
	    }
	
	    /**
	     *  Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
	     *  Update the `aria-activedescendant` attribute.
	     */
	    function render() {
	      var checked = (rgCtrl.getViewValue() == attr.value);
	      if (checked === lastChecked) {
	        return;
	      }
	
	      lastChecked = checked;
	      element.attr('aria-checked', checked);
	
	      if (checked) {
	        markParentAsChecked(true);
	        element.addClass(CHECKED_CSS);
	
	        rgCtrl.setActiveDescendant(element.attr('id'));
	
	      } else {
	        markParentAsChecked(false);
	        element.removeClass(CHECKED_CSS);
	      }
	
	      /**
	       * If the radioButton is inside a div, then add class so highlighting will work...
	       */
	      function markParentAsChecked(addClass ) {
	        if ( element.parent()[0].nodeName != "MD-RADIO-GROUP") {
	          element.parent()[ !!addClass ? 'addClass' : 'removeClass'](CHECKED_CSS);
	        }
	
	      }
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for each radio button
	     */
	    function configureAria( element, scope ){
	      scope.ariaId = buildAriaID();
	
	      element.attr({
	        'id' :  scope.ariaId,
	        'role' : 'radio',
	        'aria-checked' : 'false'
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	
	      /**
	       * Build a unique ID for each radio button that will be used with aria-activedescendant.
	       * Preserve existing ID if already specified.
	       * @returns {*|string}
	       */
	      function buildAriaID() {
	        return attr.id || ( 'radio' + "_" + $mdUtil.nextUid() );
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.select
	 */
	
	/***************************************************
	
	 ### TODO - POST RC1 ###
	 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service
	
	 ***************************************************/
	
	SelectDirective.$inject = ["$mdSelect", "$mdUtil", "$mdConstant", "$mdTheming", "$mdAria", "$compile", "$parse"];
	SelectMenuDirective.$inject = ["$parse", "$mdUtil", "$mdConstant", "$mdTheming"];
	OptionDirective.$inject = ["$mdButtonInkRipple", "$mdUtil"];
	SelectProvider.$inject = ["$$interimElementProvider"];
	var SELECT_EDGE_MARGIN = 8;
	var selectNextId = 0;
	var CHECKBOX_SELECTION_INDICATOR =
	  angular.element('<div class="md-container"><div class="md-icon"></div></div>');
	
	angular.module('material.components.select', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdSelect', SelectDirective)
	  .directive('mdSelectMenu', SelectMenuDirective)
	  .directive('mdOption', OptionDirective)
	  .directive('mdOptgroup', OptgroupDirective)
	  .directive('mdSelectHeader', SelectHeaderDirective)
	  .provider('$mdSelect', SelectProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdSelect
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays a select box, bound to an ng-model.
	 *
	 * When the select is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * By default, the select will display with an underline to match other form elements. This can be
	 * disabled by applying the `md-no-underline` CSS class.
	 *
	 * ### Option Params
	 *
	 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to  clear the
	 * select and put it back in it's default state. You may supply this attribute on any option you
	 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
	 * defined.
	 *
	 * **Automatically Applied**
	 *
	 *  - `<md-option>`
	 *  - `<md-option value>`
	 *  - `<md-option value="">`
	 *  - `<md-option ng-value>`
	 *  - `<md-option ng-value="">`
	 *
	 * **NOT Automatically Applied**
	 *
	 *  - `<md-option ng-value="1">`
	 *  - `<md-option ng-value="''">`
	 *  - `<md-option ng-value="undefined">`
	 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
	 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
	 *
	 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
	 * attribute) since you may wish this to be your "Not Available" or "None" option.
	 *
	 * **Note:** Using the `value` attribute (as opposed to `ng-value`) always evaluates to a string, so
	 * `value="null"` will require the test `ng-if="myValue != 'null'"` rather than `ng-if="!myValue"`.
	 *
	 * @param {expression} ng-model The model!
	 * @param {boolean=} multiple Whether it's multiple.
	 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
	 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
	 * Will hide the select options and show a spinner until the evaluated promise resolves.
	 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
	 * to be displayed as a placeholder in the select input box when it is closed.
	 * @param {string=} placeholder Placeholder hint text.
	 * @param md-no-asterisk {boolean=} When set to true, an asterisk will not be appended to the
	 * floating label. **Note:** This attribute is only evaluated once; it is not watched.
	 * @param {string=} aria-label Optional label for accessibility. Only necessary if no placeholder or
	 * explicit label is present.
	 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
	 * element (for custom styling).
	 *
	 * @usage
	 * With a placeholder (label and aria-label are added dynamically)
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select
	 *       ng-model="someModel"
	 *       placeholder="Select a state">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With an explicit label
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <label>State</label>
	 *     <md-select
	 *       ng-model="someModel">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With a select-header
	 *
	 * When a developer needs to put more than just a text label in the
	 * md-select-menu, they should use the md-select-header.
	 * The user can put custom HTML inside of the header and style it to their liking.
	 * One common use case of this would be a sticky search bar.
	 *
	 * When using the md-select-header the labels that would previously be added to the
	 * OptGroupDirective are ignored.
	 *
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select ng-model="someModel">
	 *       <md-select-header>
	 *         <span> Neighborhoods - </span>
	 *       </md-select-header>
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * ## Selects and object equality
	 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
	 * equality. Consider the following example:
	 * <hljs lang="js">
	 * angular.controller('MyCtrl', function($scope) {
	 *   $scope.users = [
	 *     { id: 1, name: 'Bob' },
	 *     { id: 2, name: 'Alice' },
	 *     { id: 3, name: 'Steve' }
	 *   ];
	 *   $scope.selectedUser = { id: 1, name: 'Bob' };
	 * });
	 * </hljs>
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 *
	 * At first one might expect that the select should be populated with "Bob" as the selected user. However,
	 * this is not true. To determine whether something is selected,
	 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
	 *
	 * Javascript's `==` operator does not check for deep equality (ie. that all properties
	 * on the object are the same), but instead whether the objects are *the same object in memory*.
	 * In this case, we have two instances of identical objects, but they exist in memory as unique
	 * entities. Because of this, the select will have no value populated for a selected user.
	 *
	 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a different
	 * expression which will be used for the equality operator. As such, we can update our `html` to
	 * make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the `md-select`
	 * element. This converts our equality expression to be
	 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
	 * which results in Bob being selected as desired.
	 *
	 * Working HTML:
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 */
	function SelectDirective($mdSelect, $mdUtil, $mdConstant, $mdTheming, $mdAria, $compile, $parse) {
	  var keyCodes = $mdConstant.KEY_CODE;
	  var NAVIGATION_KEYS = [keyCodes.SPACE, keyCodes.ENTER, keyCodes.UP_ARROW, keyCodes.DOWN_ARROW];
	
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
	    compile: compile,
	    controller: function() {
	    } // empty placeholder controller to be initialized in link
	  };
	
	  function compile(element, attr) {
	    // add the select value that will hold our placeholder or selected option value
	    var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
	    valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');
	    valueEl.addClass('md-select-value');
	    if (!valueEl[0].hasAttribute('id')) {
	      valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
	    }
	
	    // There's got to be an md-content inside. If there's not one, let's add it.
	    if (!element.find('md-content').length) {
	      element.append(angular.element('<md-content>').append(element.contents()));
	    }
	
	
	    // Add progress spinner for md-options-loading
	    if (attr.mdOnOpen) {
	
	      // Show progress indicator while loading async
	      // Use ng-hide for `display:none` so the indicator does not interfere with the options list
	      element
	        .find('md-content')
	        .prepend(angular.element(
	          '<div>' +
	          ' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false" md-diameter="25px"></md-progress-circular>' +
	          '</div>'
	        ));
	
	      // Hide list [of item options] while loading async
	      element
	        .find('md-option')
	        .attr('ng-show', '$$loadingAsyncDone');
	    }
	
	    if (attr.name) {
	      var autofillClone = angular.element('<select class="md-visually-hidden">');
	      autofillClone.attr({
	        'name': attr.name,
	        'aria-hidden': 'true',
	        'tabindex': '-1'
	      });
	      var opts = element.find('md-option');
	      angular.forEach(opts, function(el) {
	        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
	        if (el.hasAttribute('ng-value')) newEl.attr('ng-value', el.getAttribute('ng-value'));
	        else if (el.hasAttribute('value')) newEl.attr('value', el.getAttribute('value'));
	        autofillClone.append(newEl);
	      });
	
	      // Adds an extra option that will hold the selected value for the
	      // cases where the select is a part of a non-angular form. This can be done with a ng-model,
	      // however if the `md-option` is being `ng-repeat`-ed, Angular seems to insert a similar
	      // `option` node, but with a value of `? string: <value> ?` which would then get submitted.
	      // This also goes around having to prepend a dot to the name attribute.
	      autofillClone.append(
	        '<option ng-value="' + attr.ngModel + '" selected></option>'
	      );
	
	      element.parent().append(autofillClone);
	    }
	
	    var isMultiple = $mdUtil.parseAttributeBoolean(attr.multiple);
	
	    // Use everything that's left inside element.contents() as the contents of the menu
	    var multipleContent = isMultiple ? 'multiple' : '';
	    var selectTemplate = '' +
	      '<div class="md-select-menu-container" aria-hidden="true">' +
	      '<md-select-menu {0}>{1}</md-select-menu>' +
	      '</div>';
	
	    selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, element.html()]);
	    element.empty().append(valueEl);
	    element.append(selectTemplate);
	
	    if(!attr.tabindex){
	      attr.$set('tabindex', 0);
	    }
	
	    return function postLink(scope, element, attr, ctrls) {
	      var untouched = true;
	      var isDisabled, ariaLabelBase;
	
	      var containerCtrl = ctrls[0];
	      var mdSelectCtrl = ctrls[1];
	      var ngModelCtrl = ctrls[2];
	      var formCtrl = ctrls[3];
	      // grab a reference to the select menu value label
	      var valueEl = element.find('md-select-value');
	      var isReadonly = angular.isDefined(attr.readonly);
	      var disableAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	      if (disableAsterisk) {
	        element.addClass('md-no-asterisk');
	      }
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        if (containerCtrl.input) {
	          // We ignore inputs that are in the md-select-header (one
	          // case where this might be useful would be adding as searchbox)
	          if (element.find('md-select-header').find('input')[0] !== containerCtrl.input[0]) {
	            throw new Error("<md-input-container> can only have *one* child <input>, <textarea> or <select> element!");
	          }
	        }
	
	        containerCtrl.input = element;
	        if (!containerCtrl.label) {
	          $mdAria.expect(element, 'aria-label', element.attr('placeholder'));
	        }
	
	        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      var selectContainer, selectScope, selectMenuCtrl;
	
	      findSelectContainer();
	      $mdTheming(element);
	
	      if (formCtrl && angular.isDefined(attr.multiple)) {
	        $mdUtil.nextTick(function() {
	          var hasModelValue = ngModelCtrl.$modelValue || ngModelCtrl.$viewValue;
	          if (hasModelValue) {
	            formCtrl.$setPristine();
	          }
	        });
	      }
	
	      var originalRender = ngModelCtrl.$render;
	      ngModelCtrl.$render = function() {
	        originalRender();
	        syncLabelText();
	        syncAriaLabel();
	        inputCheckValue();
	      };
	
	      attr.$observe('placeholder', ngModelCtrl.$render);
	
	      if (containerCtrl && containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // Toggle the md-required class on the input containers label, because the input container is automatically
	          // applying the asterisk indicator on the label.
	          containerCtrl.label.toggleClass('md-required', value && !disableAsterisk);
	        });
	      }
	
	      mdSelectCtrl.setLabelText = function(text) {
	        mdSelectCtrl.setIsPlaceholder(!text);
	
	        if (attr.mdSelectedText) {
	          text = $parse(attr.mdSelectedText)(scope);
	        } else {
	          // Use placeholder attribute, otherwise fallback to the md-input-container label
	          var tmpPlaceholder = attr.placeholder ||
	              (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');
	          text = text || tmpPlaceholder || '';
	        }
	
	        var target = valueEl.children().eq(0);
	        target.html(text);
	      };
	
	      mdSelectCtrl.setIsPlaceholder = function(isPlaceholder) {
	        if (isPlaceholder) {
	          valueEl.addClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.addClass('md-placeholder');
	          }
	        } else {
	          valueEl.removeClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.removeClass('md-placeholder');
	          }
	        }
	      };
	
	      if (!isReadonly) {
	        element
	          .on('focus', function(ev) {
	            // Always focus the container (if we have one) so floating labels and other styles are
	            // applied properly
	            containerCtrl && containerCtrl.setFocused(true);
	          });
	
	        // Attach before ngModel's blur listener to stop propagation of blur event
	        // to prevent from setting $touched.
	        element.on('blur', function(event) {
	          if (untouched) {
	            untouched = false;
	            if (selectScope._mdSelectIsOpen) {
	              event.stopImmediatePropagation();
	            }
	          }
	
	          if (selectScope._mdSelectIsOpen) return;
	          containerCtrl && containerCtrl.setFocused(false);
	          inputCheckValue();
	        });
	      }
	
	      mdSelectCtrl.triggerClose = function() {
	        $parse(attr.mdOnClose)(scope);
	      };
	
	      scope.$$postDigest(function() {
	        initAriaLabel();
	        syncLabelText();
	        syncAriaLabel();
	      });
	
	      function initAriaLabel() {
	        var labelText = element.attr('aria-label') || element.attr('placeholder');
	        if (!labelText && containerCtrl && containerCtrl.label) {
	          labelText = containerCtrl.label.text();
	        }
	        ariaLabelBase = labelText;
	        $mdAria.expect(element, 'aria-label', labelText);
	      }
	
	      scope.$watch(function() {
	          return selectMenuCtrl.selectedLabels();
	      }, syncLabelText);
	
	      function syncLabelText() {
	        if (selectContainer) {
	          selectMenuCtrl = selectMenuCtrl || selectContainer.find('md-select-menu').controller('mdSelectMenu');
	          mdSelectCtrl.setLabelText(selectMenuCtrl.selectedLabels());
	        }
	      }
	
	      function syncAriaLabel() {
	        if (!ariaLabelBase) return;
	        var ariaLabels = selectMenuCtrl.selectedLabels({mode: 'aria'});
	        element.attr('aria-label', ariaLabels.length ? ariaLabelBase + ': ' + ariaLabels : ariaLabelBase);
	      }
	
	      var deregisterWatcher;
	      attr.$observe('ngMultiple', function(val) {
	        if (deregisterWatcher) deregisterWatcher();
	        var parser = $parse(val);
	        deregisterWatcher = scope.$watch(function() {
	          return parser(scope);
	        }, function(multiple, prevVal) {
	          if (multiple === undefined && prevVal === undefined) return; // assume compiler did a good job
	          if (multiple) {
	            element.attr('multiple', 'multiple');
	          } else {
	            element.removeAttr('multiple');
	          }
	          element.attr('aria-multiselectable', multiple ? 'true' : 'false');
	          if (selectContainer) {
	            selectMenuCtrl.setMultiple(multiple);
	            originalRender = ngModelCtrl.$render;
	            ngModelCtrl.$render = function() {
	              originalRender();
	              syncLabelText();
	              syncAriaLabel();
	              inputCheckValue();
	            };
	            ngModelCtrl.$render();
	          }
	        });
	      });
	
	      attr.$observe('disabled', function(disabled) {
	        if (angular.isString(disabled)) {
	          disabled = true;
	        }
	        // Prevent click event being registered twice
	        if (isDisabled !== undefined && isDisabled === disabled) {
	          return;
	        }
	        isDisabled = disabled;
	        if (disabled) {
	          element
	            .attr({'aria-disabled': 'true'})
	            .removeAttr('tabindex')
	            .off('click', openSelect)
	            .off('keydown', handleKeypress);
	        } else {
	          element
	            .attr({'tabindex': attr.tabindex, 'aria-disabled': 'false'})
	            .on('click', openSelect)
	            .on('keydown', handleKeypress);
	        }
	      });
	
	      if (!attr.hasOwnProperty('disabled') && !attr.hasOwnProperty('ngDisabled')) {
	        element.attr({'aria-disabled': 'false'});
	        element.on('click', openSelect);
	        element.on('keydown', handleKeypress);
	      }
	
	      var ariaAttrs = {
	        role: 'listbox',
	        'aria-expanded': 'false',
	        'aria-multiselectable': isMultiple && !attr.ngMultiple ? 'true' : 'false'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
	      }
	
	      var containerId = 'select_container_' + $mdUtil.nextUid();
	      selectContainer.attr('id', containerId);
	      ariaAttrs['aria-owns'] = containerId;
	      element.attr(ariaAttrs);
	
	      scope.$on('$destroy', function() {
	        $mdSelect
	          .destroy()
	          .finally(function() {
	            if (containerCtrl) {
	              containerCtrl.setFocused(false);
	              containerCtrl.setHasValue(false);
	              containerCtrl.input = null;
	            }
	            ngModelCtrl.$setTouched();
	          });
	      });
	
	
	
	      function inputCheckValue() {
	        // The select counts as having a value if one or more options are selected,
	        // or if the input's validity state says it has bad input (eg string in a number input)
	        containerCtrl && containerCtrl.setHasValue(selectMenuCtrl.selectedLabels().length > 0 || (element[0].validity || {}).badInput);
	      }
	
	      function findSelectContainer() {
	        selectContainer = angular.element(
	          element[0].querySelector('.md-select-menu-container')
	        );
	        selectScope = scope;
	        if (attr.mdContainerClass) {
	          var value = selectContainer[0].getAttribute('class') + ' ' + attr.mdContainerClass;
	          selectContainer[0].setAttribute('class', value);
	        }
	        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
	        selectMenuCtrl.init(ngModelCtrl, attr.ngModel);
	        element.on('$destroy', function() {
	          selectContainer.remove();
	        });
	      }
	
	      function handleKeypress(e) {
	        if ($mdConstant.isNavigationKey(e)) {
	          // prevent page scrolling on interaction
	          e.preventDefault();
	          openSelect(e);
	        } else {
	          if ($mdConstant.isInputKey(e) || $mdConstant.isNumPadKey(e)) {
	            e.preventDefault();
	
	            var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
	            if (!node || node.hasAttribute('disabled')) return;
	            var optionCtrl = angular.element(node).controller('mdOption');
	            if (!selectMenuCtrl.isMultiple) {
	              selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
	            }
	            selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	            selectMenuCtrl.refreshViewValue();
	          }
	        }
	      }
	
	      function openSelect() {
	        selectScope._mdSelectIsOpen = true;
	        element.attr('aria-expanded', 'true');
	
	        $mdSelect.show({
	          scope: selectScope,
	          preserveScope: true,
	          skipCompile: true,
	          element: selectContainer,
	          target: element[0],
	          selectCtrl: mdSelectCtrl,
	          preserveElement: true,
	          hasBackdrop: true,
	          loadingAsync: attr.mdOnOpen ? scope.$eval(attr.mdOnOpen) || true : false
	        }).finally(function() {
	          selectScope._mdSelectIsOpen = false;
	          element.focus();
	          element.attr('aria-expanded', 'false');
	          ngModelCtrl.$setTouched();
	        });
	      }
	
	    };
	  }
	}
	
	function SelectMenuDirective($parse, $mdUtil, $mdConstant, $mdTheming) {
	  // We want the scope to be set to 'false' so an isolated scope is not created
	  // which would interfere with the md-select-header's access to the
	  // parent scope.
	  SelectMenuController.$inject = ["$scope", "$attrs", "$element"];
	  return {
	    restrict: 'E',
	    require: ['mdSelectMenu'],
	    scope: false,
	    controller: SelectMenuController,
	    link: {pre: preLink}
	  };
	
	  // We use preLink instead of postLink to ensure that the select is initialized before
	  // its child options run postLink.
	  function preLink(scope, element, attr, ctrls) {
	    var selectCtrl = ctrls[0];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    $mdTheming(element);
	    element.on('click', clickListener);
	    element.on('keypress', keyListener);
	
	    function keyListener(e) {
	      if (e.keyCode == 13 || e.keyCode == 32) {
	        clickListener(e);
	      }
	    }
	
	    function clickListener(ev) {
	      var option = $mdUtil.getClosest(ev.target, 'md-option');
	      var optionCtrl = option && angular.element(option).data('$mdOptionController');
	      if (!option || !optionCtrl) return;
	      if (option.hasAttribute('disabled')) {
	        ev.stopImmediatePropagation();
	        return false;
	      }
	
	      var optionHashKey = selectCtrl.hashGetter(optionCtrl.value);
	      var isSelected = angular.isDefined(selectCtrl.selected[optionHashKey]);
	
	      scope.$apply(function() {
	        if (selectCtrl.isMultiple) {
	          if (isSelected) {
	            selectCtrl.deselect(optionHashKey);
	          } else {
	            selectCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        } else {
	          if (!isSelected) {
	            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
	            selectCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        }
	        selectCtrl.refreshViewValue();
	      });
	    }
	  }
	
	  function SelectMenuController($scope, $attrs, $element) {
	    var self = this;
	    self.isMultiple = angular.isDefined($attrs.multiple);
	    // selected is an object with keys matching all of the selected options' hashed values
	    self.selected = {};
	    // options is an object with keys matching every option's hash value,
	    // and values matching every option's controller.
	    self.options = {};
	
	    $scope.$watchCollection(function() {
	      return self.options;
	    }, function() {
	      self.ngModel.$render();
	    });
	
	    var deregisterCollectionWatch;
	    var defaultIsEmpty;
	    self.setMultiple = function(isMultiple) {
	      var ngModel = self.ngModel;
	      defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;
	
	      self.isMultiple = isMultiple;
	      if (deregisterCollectionWatch) deregisterCollectionWatch();
	
	      if (self.isMultiple) {
	        ngModel.$validators['md-multiple'] = validateArray;
	        ngModel.$render = renderMultiple;
	
	        // watchCollection on the model because by default ngModel only watches the model's
	        // reference. This allowed the developer to also push and pop from their array.
	        $scope.$watchCollection(self.modelBinding, function(value) {
	          if (validateArray(value)) renderMultiple(value);
	          self.ngModel.$setPristine();
	        });
	
	        ngModel.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	      } else {
	        delete ngModel.$validators['md-multiple'];
	        ngModel.$render = renderSingular;
	      }
	
	      function validateArray(modelValue, viewValue) {
	        // If a value is truthy but not an array, reject it.
	        // If value is undefined/falsy, accept that it's an empty array.
	        return angular.isArray(modelValue || viewValue || []);
	      }
	    };
	
	    var searchStr = '';
	    var clearSearchTimeout, optNodes, optText;
	    var CLEAR_SEARCH_AFTER = 300;
	
	    self.optNodeForKeyboardSearch = function(e) {
	      clearSearchTimeout && clearTimeout(clearSearchTimeout);
	      clearSearchTimeout = setTimeout(function() {
	        clearSearchTimeout = undefined;
	        searchStr = '';
	        optText = undefined;
	        optNodes = undefined;
	      }, CLEAR_SEARCH_AFTER);
	
	      // Support 1-9 on numpad
	      var keyCode = e.keyCode - ($mdConstant.isNumPadKey(e) ? 48 : 0);
	
	      searchStr += String.fromCharCode(keyCode);
	      var search = new RegExp('^' + searchStr, 'i');
	      if (!optNodes) {
	        optNodes = $element.find('md-option');
	        optText = new Array(optNodes.length);
	        angular.forEach(optNodes, function(el, i) {
	          optText[i] = el.textContent.trim();
	        });
	      }
	      for (var i = 0; i < optText.length; ++i) {
	        if (search.test(optText[i])) {
	          return optNodes[i];
	        }
	      }
	    };
	
	    self.init = function(ngModel, binding) {
	      self.ngModel = ngModel;
	      self.modelBinding = binding;
	
	      // Setup a more robust version of isEmpty to ensure value is a valid option
	      self.ngModel.$isEmpty = function($viewValue) {
	        // We have to transform the viewValue into the hashKey, because otherwise the
	        // OptionCtrl may not exist. Developers may have specified a trackBy function.
	        return !self.options[self.hashGetter($viewValue)];
	      };
	
	      // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: 'foo.id'}"` so
	      // that we can properly compare objects set on the model to the available options
	      if (ngModel.$options && ngModel.$options.trackBy) {
	        var trackByLocals = {};
	        var trackByParsed = $parse(ngModel.$options.trackBy);
	        self.hashGetter = function(value, valueScope) {
	          trackByLocals.$value = value;
	          return trackByParsed(valueScope || $scope, trackByLocals);
	        };
	        // If the user doesn't provide a trackBy, we automatically generate an id for every
	        // value passed in
	      } else {
	        self.hashGetter = function getHashValue(value) {
	          if (angular.isObject(value)) {
	            return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
	          }
	          return value;
	        };
	      }
	      self.setMultiple(self.isMultiple);
	    };
	
	    self.selectedLabels = function(opts) {
	      opts = opts || {};
	      var mode = opts.mode || 'html';
	      var selectedOptionEls = $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));
	      if (selectedOptionEls.length) {
	        var mapFn;
	
	        if (mode == 'html') {
	          // Map the given element to its innerHTML string. If the element has a child ripple
	          // container remove it from the HTML string, before returning the string.
	          mapFn = function(el) {
	            // If we do not have a `value` or `ng-value`, assume it is an empty option which clears the select
	            if (el.hasAttribute('md-option-empty')) {
	              return '';
	            }
	
	            var html = el.innerHTML;
	
	            // Remove the ripple container from the selected option, copying it would cause a CSP violation.
	            var rippleContainer = el.querySelector('.md-ripple-container');
	            if (rippleContainer) {
	              html = html.replace(rippleContainer.outerHTML, '');
	            }
	
	            // Remove the checkbox container, because it will cause the label to wrap inside of the placeholder.
	            // It should be not displayed inside of the label element.
	            var checkboxContainer = el.querySelector('.md-container');
	            if (checkboxContainer) {
	              html = html.replace(checkboxContainer.outerHTML, '');
	            }
	
	            return html;
	          };
	        } else if (mode == 'aria') {
	          mapFn = function(el) { return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent; };
	        }
	        return selectedOptionEls.map(mapFn).join(', ');
	      } else {
	        return '';
	      }
	    };
	
	    self.select = function(hashKey, hashedValue) {
	      var option = self.options[hashKey];
	      option && option.setSelected(true);
	      self.selected[hashKey] = hashedValue;
	    };
	    self.deselect = function(hashKey) {
	      var option = self.options[hashKey];
	      option && option.setSelected(false);
	      delete self.selected[hashKey];
	    };
	
	    self.addOption = function(hashKey, optionCtrl) {
	      if (angular.isDefined(self.options[hashKey])) {
	        throw new Error('Duplicate md-option values are not allowed in a select. ' +
	          'Duplicate value "' + optionCtrl.value + '" found.');
	      }
	
	      self.options[hashKey] = optionCtrl;
	
	      // If this option's value was already in our ngModel, go ahead and select it.
	      if (angular.isDefined(self.selected[hashKey])) {
	        self.select(hashKey, optionCtrl.value);
	
	        // When the current $modelValue of the ngModel Controller is using the same hash as
	        // the current option, which will be added, then we can be sure, that the validation
	        // of the option has occurred before the option was added properly.
	        // This means, that we have to manually trigger a new validation of the current option.
	        if (angular.isDefined(self.ngModel.$modelValue) && self.hashGetter(self.ngModel.$modelValue) === hashKey) {
	          self.ngModel.$validate();
	        }
	
	        self.refreshViewValue();
	      }
	    };
	    self.removeOption = function(hashKey) {
	      delete self.options[hashKey];
	      // Don't deselect an option when it's removed - the user's ngModel should be allowed
	      // to have values that do not match a currently available option.
	    };
	
	    self.refreshViewValue = function() {
	      var values = [];
	      var option;
	      for (var hashKey in self.selected) {
	        // If this hashKey has an associated option, push that option's value to the model.
	        if ((option = self.options[hashKey])) {
	          values.push(option.value);
	        } else {
	          // Otherwise, the given hashKey has no associated option, and we got it
	          // from an ngModel value at an earlier time. Push the unhashed value of
	          // this hashKey to the model.
	          // This allows the developer to put a value in the model that doesn't yet have
	          // an associated option.
	          values.push(self.selected[hashKey]);
	        }
	      }
	      var usingTrackBy = self.ngModel.$options && self.ngModel.$options.trackBy;
	
	      var newVal = self.isMultiple ? values : values[0];
	      var prevVal = self.ngModel.$modelValue;
	
	      if (usingTrackBy ? !angular.equals(prevVal, newVal) : prevVal != newVal) {
	        self.ngModel.$setViewValue(newVal);
	        self.ngModel.$render();
	      }
	    };
	
	    function renderMultiple() {
	      var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
	      if (!angular.isArray(newSelectedValues)) return;
	
	      var oldSelected = Object.keys(self.selected);
	
	      var newSelectedHashes = newSelectedValues.map(self.hashGetter);
	      var deselected = oldSelected.filter(function(hash) {
	        return newSelectedHashes.indexOf(hash) === -1;
	      });
	
	      deselected.forEach(self.deselect);
	      newSelectedHashes.forEach(function(hashKey, i) {
	        self.select(hashKey, newSelectedValues[i]);
	      });
	    }
	
	    function renderSingular() {
	      var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
	      Object.keys(self.selected).forEach(self.deselect);
	      self.select(self.hashGetter(value), value);
	    }
	  }
	
	}
	
	function OptionDirective($mdButtonInkRipple, $mdUtil) {
	
	  OptionController.$inject = ["$element"];
	  return {
	    restrict: 'E',
	    require: ['mdOption', '^^mdSelectMenu'],
	    controller: OptionController,
	    compile: compile
	  };
	
	  function compile(element, attr) {
	    // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
	    element.append(angular.element('<div class="md-text">').append(element.contents()));
	
	    element.attr('tabindex', attr.tabindex || '0');
	
	    if (!hasDefinedValue(attr)) {
	      element.attr('md-option-empty', '');
	    }
	
	    return postLink;
	  }
	
	  function hasDefinedValue(attr) {
	    var value = attr.value;
	    var ngValue = attr.ngValue;
	
	    return value || ngValue;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    var optionCtrl = ctrls[0];
	    var selectCtrl = ctrls[1];
	
	    if (selectCtrl.isMultiple) {
	      element.addClass('md-checkbox-enabled');
	      element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
	    }
	
	    if (angular.isDefined(attr.ngValue)) {
	      scope.$watch(attr.ngValue, setOptionValue);
	    } else if (angular.isDefined(attr.value)) {
	      setOptionValue(attr.value);
	    } else {
	      scope.$watch(function() {
	        return element.text().trim();
	      }, setOptionValue);
	    }
	
	    attr.$observe('disabled', function(disabled) {
	      if (disabled) {
	        element.attr('tabindex', '-1');
	      } else {
	        element.attr('tabindex', '0');
	      }
	    });
	
	    scope.$$postDigest(function() {
	      attr.$observe('selected', function(selected) {
	        if (!angular.isDefined(selected)) return;
	        if (typeof selected == 'string') selected = true;
	        if (selected) {
	          if (!selectCtrl.isMultiple) {
	            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
	          }
	          selectCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	        } else {
	          selectCtrl.deselect(optionCtrl.hashKey);
	        }
	        selectCtrl.refreshViewValue();
	      });
	    });
	
	    $mdButtonInkRipple.attach(scope, element);
	    configureAria();
	
	    function setOptionValue(newValue, oldValue, prevAttempt) {
	      if (!selectCtrl.hashGetter) {
	        if (!prevAttempt) {
	          scope.$$postDigest(function() {
	            setOptionValue(newValue, oldValue, true);
	          });
	        }
	        return;
	      }
	      var oldHashKey = selectCtrl.hashGetter(oldValue, scope);
	      var newHashKey = selectCtrl.hashGetter(newValue, scope);
	
	      optionCtrl.hashKey = newHashKey;
	      optionCtrl.value = newValue;
	
	      selectCtrl.removeOption(oldHashKey, optionCtrl);
	      selectCtrl.addOption(newHashKey, optionCtrl);
	    }
	
	    scope.$on('$destroy', function() {
	      selectCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
	    });
	
	    function configureAria() {
	      var ariaAttrs = {
	        'role': 'option',
	        'aria-selected': 'false'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
	      }
	      element.attr(ariaAttrs);
	    }
	  }
	
	  function OptionController($element) {
	    this.selected = false;
	    this.setSelected = function(isSelected) {
	      if (isSelected && !this.selected) {
	        $element.attr({
	          'selected': 'selected',
	          'aria-selected': 'true'
	        });
	      } else if (!isSelected && this.selected) {
	        $element.removeAttr('selected');
	        $element.attr('aria-selected', 'false');
	      }
	      this.selected = isSelected;
	    };
	  }
	
	}
	
	function OptgroupDirective() {
	  return {
	    restrict: 'E',
	    compile: compile
	  };
	  function compile(el, attrs) {
	    // If we have a select header element, we don't want to add the normal label
	    // header.
	    if (!hasSelectHeader()) {
	      setupLabelElement();
	    }
	
	    function hasSelectHeader() {
	      return el.parent().find('md-select-header').length;
	    }
	
	    function setupLabelElement() {
	      var labelElement = el.find('label');
	      if (!labelElement.length) {
	        labelElement = angular.element('<label>');
	        el.prepend(labelElement);
	      }
	      labelElement.addClass('md-container-ignore');
	      if (attrs.label) labelElement.text(attrs.label);
	    }
	  }
	}
	
	function SelectHeaderDirective() {
	  return {
	    restrict: 'E',
	  };
	}
	
	function SelectProvider($$interimElementProvider) {
	  selectDefaultOptions.$inject = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
	  return $$interimElementProvider('$mdSelect')
	    .setDefaults({
	      methods: ['target'],
	      options: selectDefaultOptions
	    });
	
	  /* @ngInject */
	  function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
	    var ERROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
	    var animator = $mdUtil.dom.animator;
	    var keyCodes = $mdConstant.KEY_CODE;
	
	    return {
	      parent: 'body',
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true
	    };
	
	    /**
	     * Interim-element onRemove logic....
	     */
	    function onRemove(scope, element, opts) {
	      opts = opts || { };
	      opts.cleanupInteraction();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	
	      return  (opts.$destroy === true) ? cleanElement() : animateRemoval().then( cleanElement );
	
	      /**
	       * For normal closes (eg clicks), animate the removal.
	       * For forced closes (like $destroy events from navigation),
	       * skip the animations
	       */
	      function animateRemoval() {
	        return $animateCss(element, {addClass: 'md-leave'}).start();
	      }
	
	      /**
	       * Restore the element to a closed state
	       */
	      function cleanElement() {
	
	        element.removeClass('md-active');
	        element.attr('aria-hidden', 'true');
	        element[0].style.display = 'none';
	
	        announceClosed(opts);
	
	        if (!opts.$destroy && opts.restoreFocus) {
	          opts.target.focus();
	        }
	      }
	
	    }
	
	    /**
	     * Interim-element onShow logic....
	     */
	    function onShow(scope, element, opts) {
	
	      watchAsyncLoad();
	      sanitizeAndConfigure(scope, opts);
	
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      return showDropDown(scope, element, opts)
	        .then(function(response) {
	          element.attr('aria-hidden', 'false');
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupResizing = activateResizing();
	
	          return response;
	        }, opts.hideBackdrop);
	
	      // ************************************
	      // Closure Functions
	      // ************************************
	
	      /**
	       *  Attach the select DOM element(s) and animate to the correct positions
	       *  and scalings...
	       */
	      function showDropDown(scope, element, opts) {
	        opts.parent.append(element);
	
	        return $q(function(resolve, reject) {
	
	          try {
	
	            $animateCss(element, {removeClass: 'md-leave', duration: 0})
	              .start()
	              .then(positionAndFocusMenu)
	              .then(resolve);
	
	          } catch (e) {
	            reject(e);
	          }
	
	        });
	      }
	
	      /**
	       * Initialize container and dropDown menu positions/scale, then animate
	       * to show... and autoFocus.
	       */
	      function positionAndFocusMenu() {
	        return $q(function(resolve) {
	          if (opts.isRemoved) return $q.reject(false);
	
	          var info = calculateMenuPositions(scope, element, opts);
	
	          info.container.element.css(animator.toCss(info.container.styles));
	          info.dropDown.element.css(animator.toCss(info.dropDown.styles));
	
	          $$rAF(function() {
	            element.addClass('md-active');
	            info.dropDown.element.css(animator.toCss({transform: ''}));
	
	            autoFocus(opts.focusedNode);
	            resolve();
	          });
	
	        });
	      }
	
	      /**
	       * Show modal backdrop element...
	       */
	      function showBackdrop(scope, element, options) {
	
	        // If we are not within a dialog...
	        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	          // !! DO this before creating the backdrop; since disableScrollAround()
	          //    configures the scroll offset; which is used by mdBackDrop postLink()
	          options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	        } else {
	          options.disableParentScroll = false;
	        }
	
	        if (options.hasBackdrop) {
	          // Override duration to immediately show invisible backdrop
	          options.backdrop = $mdUtil.createBackdrop(scope, "md-select-backdrop md-click-catcher");
	          $animate.enter(options.backdrop, $document[0].body, null, {duration: 0});
	        }
	
	        /**
	         * Hide modal backdrop element...
	         */
	        return function hideBackdrop() {
	          if (options.backdrop) options.backdrop.remove();
	          if (options.disableParentScroll) options.restoreScroll();
	
	          delete options.restoreScroll;
	        };
	      }
	
	      /**
	       *
	       */
	      function autoFocus(focusedNode) {
	        if (focusedNode && !focusedNode.hasAttribute('disabled')) {
	          focusedNode.focus();
	        }
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure(scope, options) {
	        var selectEl = element.find('md-select-menu');
	
	        if (!options.target) {
	          throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED, [options.target]));
	        }
	
	        angular.extend(options, {
	          isRemoved: false,
	          target: angular.element(options.target), //make sure it's not a naked dom node
	          parent: angular.element(options.parent),
	          selectEl: selectEl,
	          contentEl: element.find('md-content'),
	          optionNodes: selectEl[0].getElementsByTagName('md-option')
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function activateResizing() {
	        var debouncedOnResize = (function(scope, target, options) {
	
	          return function() {
	            if (options.isRemoved) return;
	
	            var updates = calculateMenuPositions(scope, target, options);
	            var container = updates.container;
	            var dropDown = updates.dropDown;
	
	            container.element.css(animator.toCss(container.styles));
	            dropDown.element.css(animator.toCss(dropDown.styles));
	          };
	
	        })(scope, element, opts);
	
	        var window = angular.element($window);
	        window.on('resize', debouncedOnResize);
	        window.on('orientationchange', debouncedOnResize);
	
	        // Publish deactivation closure...
	        return function deactivateResizing() {
	
	          // Disable resizing handlers
	          window.off('resize', debouncedOnResize);
	          window.off('orientationchange', debouncedOnResize);
	        };
	      }
	
	      /**
	       *  If asynchronously loading, watch and update internal
	       *  '$$loadingAsyncDone' flag
	       */
	      function watchAsyncLoad() {
	        if (opts.loadingAsync && !opts.isRemoved) {
	          scope.$$loadingAsyncDone = false;
	
	          $q.when(opts.loadingAsync)
	            .then(function() {
	              scope.$$loadingAsyncDone = true;
	              delete opts.loadingAsync;
	            }).then(function() {
	              $$rAF(positionAndFocusMenu);
	            });
	        }
	      }
	
	      /**
	       *
	       */
	      function activateInteraction() {
	        if (opts.isRemoved) return;
	
	        var dropDown = opts.selectEl;
	        var selectCtrl = dropDown.controller('mdSelectMenu') || {};
	
	        element.addClass('md-clickable');
	
	        // Close on backdrop click
	        opts.backdrop && opts.backdrop.on('click', onBackdropClick);
	
	        // Escape to close
	        // Cycling of options, and closing on enter
	        dropDown.on('keydown', onMenuKeyDown);
	        dropDown.on('click', checkCloseMenu);
	
	        return function cleanupInteraction() {
	          opts.backdrop && opts.backdrop.off('click', onBackdropClick);
	          dropDown.off('keydown', onMenuKeyDown);
	          dropDown.off('click', checkCloseMenu);
	
	          element.removeClass('md-clickable');
	          opts.isRemoved = true;
	        };
	
	        // ************************************
	        // Closure Functions
	        // ************************************
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          opts.restoreFocus = false;
	          $mdUtil.nextTick($mdSelect.hide, true);
	        }
	
	        function onMenuKeyDown(ev) {
	          ev.preventDefault();
	          ev.stopPropagation();
	
	          switch (ev.keyCode) {
	            case keyCodes.UP_ARROW:
	              return focusPrevOption();
	            case keyCodes.DOWN_ARROW:
	              return focusNextOption();
	            case keyCodes.SPACE:
	            case keyCodes.ENTER:
	              var option = $mdUtil.getClosest(ev.target, 'md-option');
	              if (option) {
	                dropDown.triggerHandler({
	                  type: 'click',
	                  target: option
	                });
	                ev.preventDefault();
	              }
	              checkCloseMenu(ev);
	              break;
	            case keyCodes.TAB:
	            case keyCodes.ESCAPE:
	              ev.stopPropagation();
	              ev.preventDefault();
	              opts.restoreFocus = true;
	              $mdUtil.nextTick($mdSelect.hide, true);
	              break;
	            default:
	              if ($mdConstant.isInputKey(ev) || $mdConstant.isNumPadKey(ev)) {
	                var optNode = dropDown.controller('mdSelectMenu').optNodeForKeyboardSearch(ev);
	                opts.focusedNode = optNode || opts.focusedNode;
	                optNode && optNode.focus();
	              }
	          }
	        }
	
	        function focusOption(direction) {
	          var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
	          var index = optionsArray.indexOf(opts.focusedNode);
	
	          var newOption;
	
	          do {
	            if (index === -1) {
	              // We lost the previously focused element, reset to first option
	              index = 0;
	            } else if (direction === 'next' && index < optionsArray.length - 1) {
	              index++;
	            } else if (direction === 'prev' && index > 0) {
	              index--;
	            }
	            newOption = optionsArray[index];
	            if (newOption.hasAttribute('disabled')) newOption = undefined;
	          } while (!newOption && index < optionsArray.length - 1 && index > 0);
	
	          newOption && newOption.focus();
	          opts.focusedNode = newOption;
	        }
	
	        function focusNextOption() {
	          focusOption('next');
	        }
	
	        function focusPrevOption() {
	          focusOption('prev');
	        }
	
	        function checkCloseMenu(ev) {
	          if (ev && ( ev.type == 'click') && (ev.currentTarget != dropDown[0])) return;
	          if ( mouseOnScrollbar() ) return;
	
	          var option = $mdUtil.getClosest(ev.target, 'md-option');
	          if (option && option.hasAttribute && !option.hasAttribute('disabled')) {
	            ev.preventDefault();
	            ev.stopPropagation();
	            if (!selectCtrl.isMultiple) {
	              opts.restoreFocus = true;
	
	              $mdUtil.nextTick(function () {
	                $mdSelect.hide(selectCtrl.ngModel.$viewValue);
	              }, true);
	            }
	          }
	          /**
	           * check if the mouseup event was on a scrollbar
	           */
	          function mouseOnScrollbar() {
	            var clickOnScrollbar = false;
	            if (ev && (ev.currentTarget.children.length > 0)) {
	              var child = ev.currentTarget.children[0];
	              var hasScrollbar = child.scrollHeight > child.clientHeight;
	              if (hasScrollbar && child.children.length > 0) {
	                var relPosX = ev.pageX - ev.currentTarget.getBoundingClientRect().left;
	                if (relPosX > child.querySelector('md-option').offsetWidth)
	                  clickOnScrollbar = true;
	              }
	            }
	            return clickOnScrollbar;
	          }
	        }
	      }
	
	    }
	
	    /**
	     * To notify listeners that the Select menu has closed,
	     * trigger the [optional] user-defined expression
	     */
	    function announceClosed(opts) {
	      var mdSelect = opts.selectCtrl;
	      if (mdSelect) {
	        var menuController = opts.selectEl.controller('mdSelectMenu');
	        mdSelect.setLabelText(menuController ? menuController.selectedLabels() : '');
	        mdSelect.triggerClose();
	      }
	    }
	
	
	    /**
	     * Calculate the
	     */
	    function calculateMenuPositions(scope, element, opts) {
	      var
	        containerNode = element[0],
	        targetNode = opts.target[0].children[0], // target the label
	        parentNode = $document[0].body,
	        selectNode = opts.selectEl[0],
	        contentNode = opts.contentEl[0],
	        parentRect = parentNode.getBoundingClientRect(),
	        targetRect = targetNode.getBoundingClientRect(),
	        shouldOpenAroundTarget = false,
	        bounds = {
	          left: parentRect.left + SELECT_EDGE_MARGIN,
	          top: SELECT_EDGE_MARGIN,
	          bottom: parentRect.height - SELECT_EDGE_MARGIN,
	          right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
	        },
	        spaceAvailable = {
	          top: targetRect.top - bounds.top,
	          left: targetRect.left - bounds.left,
	          right: bounds.right - (targetRect.left + targetRect.width),
	          bottom: bounds.bottom - (targetRect.top + targetRect.height)
	        },
	        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
	        selectedNode = selectNode.querySelector('md-option[selected]'),
	        optionNodes = selectNode.getElementsByTagName('md-option'),
	        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
	        isScrollable = calculateScrollable(element, contentNode),
	        centeredNode;
	
	      var loading = isPromiseLike(opts.loadingAsync);
	      if (!loading) {
	        // If a selected node, center around that
	        if (selectedNode) {
	          centeredNode = selectedNode;
	          // If there are option groups, center around the first option group
	        } else if (optgroupNodes.length) {
	          centeredNode = optgroupNodes[0];
	          // Otherwise - if we are not loading async - center around the first optionNode
	        } else if (optionNodes.length) {
	          centeredNode = optionNodes[0];
	          // In case there are no options, center on whatever's in there... (eg progress indicator)
	        } else {
	          centeredNode = contentNode.firstElementChild || contentNode;
	        }
	      } else {
	        // If loading, center on progress indicator
	        centeredNode = contentNode.firstElementChild || contentNode;
	      }
	
	      if (contentNode.offsetWidth > maxWidth) {
	        contentNode.style['max-width'] = maxWidth + 'px';
	      } else {
	        contentNode.style.maxWidth = null;
	      }
	      if (shouldOpenAroundTarget) {
	        contentNode.style['min-width'] = targetRect.width + 'px';
	      }
	
	      // Remove padding before we compute the position of the menu
	      if (isScrollable) {
	        selectNode.classList.add('md-overflow');
	      }
	
	      var focusedNode = centeredNode;
	      if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
	        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
	        centeredNode = focusedNode;
	      }
	      // Cache for autoFocus()
	      opts.focusedNode = focusedNode;
	
	      // Get the selectMenuRect *after* max-width is possibly set above
	      containerNode.style.display = 'block';
	      var selectMenuRect = selectNode.getBoundingClientRect();
	      var centeredRect = getOffsetRect(centeredNode);
	
	      if (centeredNode) {
	        var centeredStyle = $window.getComputedStyle(centeredNode);
	        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
	        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
	      }
	
	      if (isScrollable) {
	        var scrollBuffer = contentNode.offsetHeight / 2;
	        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;
	
	        if (spaceAvailable.top < scrollBuffer) {
	          contentNode.scrollTop = Math.min(
	            centeredRect.top,
	            contentNode.scrollTop + scrollBuffer - spaceAvailable.top
	          );
	        } else if (spaceAvailable.bottom < scrollBuffer) {
	          contentNode.scrollTop = Math.max(
	            centeredRect.top + centeredRect.height - selectMenuRect.height,
	            contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
	          );
	        }
	      }
	
	      var left, top, transformOrigin, minWidth, fontSize;
	      if (shouldOpenAroundTarget) {
	        left = targetRect.left;
	        top = targetRect.top + targetRect.height;
	        transformOrigin = '50% 0';
	        if (top + selectMenuRect.height > bounds.bottom) {
	          top = targetRect.top - selectMenuRect.height;
	          transformOrigin = '50% 100%';
	        }
	      } else {
	        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft) + 2;
	        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
	            centeredRect.top + contentNode.scrollTop) + 2;
	
	        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
	          (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';
	
	        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);
	
	        fontSize = window.getComputedStyle(targetNode)['font-size'];
	      }
	
	      // Keep left and top within the window
	      var containerRect = containerNode.getBoundingClientRect();
	      var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;
	
	      return {
	        container: {
	          element: angular.element(containerNode),
	          styles: {
	            left: Math.floor(clamp(bounds.left, left, bounds.right - containerRect.width)),
	            top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
	            'min-width': minWidth,
	            'font-size': fontSize
	          }
	        },
	        dropDown: {
	          element: angular.element(selectNode),
	          styles: {
	            transformOrigin: transformOrigin,
	            transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
	          }
	        }
	      };
	
	    }
	
	  }
	
	  function isPromiseLike(obj) {
	    return obj && angular.isFunction(obj.then);
	  }
	
	  function clamp(min, n, max) {
	    return Math.max(min, Math.min(n, max));
	  }
	
	  function getOffsetRect(node) {
	    return node ? {
	      left: node.offsetLeft,
	      top: node.offsetTop,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    } : {left: 0, top: 0, width: 0, height: 0};
	  }
	
	  function calculateScrollable(element, contentNode) {
	    var isScrollable = false;
	
	    try {
	      var oldDisplay = element[0].style.display;
	
	      // Set the element's display to block so that this calculation is correct
	      element[0].style.display = 'block';
	
	      isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;
	
	      // Reset it back afterwards
	      element[0].style.display = oldDisplay;
	    } finally {
	      // Nothing to do
	    }
	    return isScrollable;
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.showHide
	 */
	
	// Add additional handlers to ng-show and ng-hide that notify directives
	// contained within that they should recompute their size.
	// These run in addition to Angular's built-in ng-hide and ng-show directives.
	angular.module('material.components.showHide', [
	  'material.core'
	])
	  .directive('ngShow', createDirective('ngShow', true))
	  .directive('ngHide', createDirective('ngHide', false));
	
	
	function createDirective(name, targetValue) {
	  return ['$mdUtil', '$window', function($mdUtil, $window) {
	    return {
	      restrict: 'A',
	      multiElement: true,
	      link: function($scope, $element, $attr) {
	        var unregister = $scope.$on('$md-resize-enable', function() {
	          unregister();
	
	          var node = $element[0];
	          var cachedTransitionStyles = node.nodeType === $window.Node.ELEMENT_NODE ?
	            $window.getComputedStyle(node) : {};
	
	          $scope.$watch($attr[name], function(value) {
	            if (!!value === targetValue) {
	              $mdUtil.nextTick(function() {
	                $scope.$broadcast('$md-resize');
	              });
	
	              var opts = {
	                cachedTransitionStyles: cachedTransitionStyles
	              };
	
	              $mdUtil.dom.animator.waitTransitionEnd($element, opts).then(function() {
	                $scope.$broadcast('$md-resize');
	              });
	            }
	          });
	        });
	      }
	    };
	  }];
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sidenav
	 *
	 * @description
	 * A Sidenav QP component.
	 */
	SidenavService.$inject = ["$mdComponentRegistry", "$mdUtil", "$q", "$log"];
	SidenavDirective.$inject = ["$mdMedia", "$mdUtil", "$mdConstant", "$mdTheming", "$animate", "$compile", "$parse", "$log", "$q", "$document"];
	SidenavController.$inject = ["$scope", "$element", "$attrs", "$mdComponentRegistry", "$q"];
	angular
	  .module('material.components.sidenav', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .factory('$mdSidenav', SidenavService )
	  .directive('mdSidenav', SidenavDirective)
	  .directive('mdSidenavFocus', SidenavFocusDirective)
	  .controller('$mdSidenavController', SidenavController);
	
	
	/**
	 * @ngdoc service
	 * @name $mdSidenav
	 * @module material.components.sidenav
	 *
	 * @description
	 * `$mdSidenav` makes it easy to interact with multiple sidenavs
	 * in an app. When looking up a sidenav instance, you can either look
	 * it up synchronously or wait for it to be initializied asynchronously.
	 * This is done by passing the second argument to `$mdSidenav`.
	 *
	 * @usage
	 * <hljs lang="js">
	 * // Async lookup for sidenav instance; will resolve when the instance is available
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Sync lookup for sidenav instance; this will resolve immediately.
	 * $mdSidenav(componentId).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Async toggle the given sidenav;
	 * // when instance is known ready and lazy lookup is not needed.
	 * $mdSidenav(componentId)
	 *    .toggle()
	 *    .then(function(){
	 *      $log.debug('toggled');
	 *    });
	 * // Async open the given sidenav
	 * $mdSidenav(componentId)
	 *    .open()
	 *    .then(function(){
	 *      $log.debug('opened');
	 *    });
	 * // Async close the given sidenav
	 * $mdSidenav(componentId)
	 *    .close()
	 *    .then(function(){
	 *      $log.debug('closed');
	 *    });
	 * // Sync check to see if the specified sidenav is set to be open
	 * $mdSidenav(componentId).isOpen();
	 * // Sync check to whether given sidenav is locked open
	 * // If this is true, the sidenav will be open regardless of close()
	 * $mdSidenav(componentId).isLockedOpen();
	 * // On close callback to handle close, backdrop click or escape key pressed
	 * // Callback happens BEFORE the close action occurs.
	 * $mdSidenav(componentId).onClose(function () {
	 *   $log.debug('closing');
	 * });
	 * </hljs>
	 */
	function SidenavService($mdComponentRegistry, $mdUtil, $q, $log) {
	  var errorMsg = "SideNav '{0}' is not available! Did you use md-component-id='{0}'?";
	  var service = {
	        find    : findInstance,     //  sync  - returns proxy API
	        waitFor : waitForInstance   //  async - returns promise
	      };
	
	  /**
	   * Service API that supports three (3) usages:
	   *   $mdSidenav().find("left")                       // sync (must already exist) or returns undefined
	   *   $mdSidenav("left").toggle();                    // sync (must already exist) or returns reject promise;
	   *   $mdSidenav("left",true).then( function(left){   // async returns instance when available
	   *    left.toggle();
	   *   });
	   */
	  return function(handle, enableWait) {
	    if ( angular.isUndefined(handle) ) return service;
	
	    var shouldWait = enableWait === true;
	    var instance = service.find(handle, shouldWait);
	    return  !instance && shouldWait ? service.waitFor(handle) :
	            !instance && angular.isUndefined(enableWait) ? addLegacyAPI(service, handle) : instance;
	  };
	
	  /**
	   * For failed instance/handle lookups, older-clients expect an response object with noops
	   * that include `rejected promise APIs`
	   */
	  function addLegacyAPI(service, handle) {
	      var falseFn  = function() { return false; };
	      var rejectFn = function() {
	            return $q.when($mdUtil.supplant(errorMsg, [handle || ""]));
	          };
	
	      return angular.extend({
	        isLockedOpen : falseFn,
	        isOpen       : falseFn,
	        toggle       : rejectFn,
	        open         : rejectFn,
	        close        : rejectFn,
	        onClose      : angular.noop,
	        then : function(callback) {
	          return waitForInstance(handle)
	            .then(callback || angular.noop);
	        }
	       }, service);
	    }
	    /**
	     * Synchronously lookup the controller instance for the specified sidNav instance which has been
	     * registered with the markup `md-component-id`
	     */
	    function findInstance(handle, shouldWait) {
	      var instance = $mdComponentRegistry.get(handle);
	
	      if (!instance && !shouldWait) {
	
	        // Report missing instance
	        $log.error( $mdUtil.supplant(errorMsg, [handle || ""]) );
	
	        // The component has not registered itself... most like NOT yet created
	        // return null to indicate that the Sidenav is not in the DOM
	        return undefined;
	      }
	      return instance;
	    }
	
	    /**
	     * Asynchronously wait for the component instantiation,
	     * Deferred lookup of component instance using $component registry
	     */
	    function waitForInstance(handle) {
	      return $mdComponentRegistry.when(handle).catch($log.error);
	    }
	}
	/**
	 * @ngdoc directive
	 * @name mdSidenavFocus
	 * @module material.components.sidenav
	 *
	 * @restrict A
	 *
	 * @description
	 * `mdSidenavFocus` provides a way to specify the focused element when a sidenav opens.
	 * This is completely optional, as the sidenav itself is focused by default.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-sidenav>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-sidenav-focus>
	 *     </md-input-container>
	 *   </form>
	 * </md-sidenav>
	 * </hljs>
	 **/
	function SidenavFocusDirective() {
	  return {
	    restrict: 'A',
	    require: '^mdSidenav',
	    link: function(scope, element, attr, sidenavCtrl) {
	      // @see $mdUtil.findFocusTarget(...)
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdSidenav
	 * @module material.components.sidenav
	 * @restrict E
	 *
	 * @description
	 *
	 * A Sidenav component that can be opened and closed programatically.
	 *
	 * By default, upon opening it will slide out on top of the main content area.
	 *
	 * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
	 * It can be overridden with the `md-autofocus` directive on the child element you want focused.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="js">
	 * var app = angular.module('myApp', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdSidenav) {
	 *   $scope.openLeftMenu = function() {
	 *     $mdSidenav('left').toggle();
	 *   };
	 * });
	 * </hljs>
	 *
	 * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
	 * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a backdrop.
	 * @param {string=} md-component-id componentId to use with $mdSidenav service.
	 * @param {expression=} md-is-locked-open When this expression evaluates to true,
	 * the sidenav 'locks open': it falls into the content's flow instead
	 * of appearing over it. This overrides the `md-is-open` attribute.
	 * @param {string=} md-disable-scroll-target Selector, pointing to an element, whose scrolling will
	 * be disabled when the sidenav is opened. By default this is the sidenav's direct parent.
	 *
	* The $mdMedia() service is exposed to the is-locked-open attribute, which
	 * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
	 * Examples:
	 *
	 *   - `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>` (locks open on small screens)
	 */
	function SidenavDirective($mdMedia, $mdUtil, $mdConstant, $mdTheming, $animate, $compile, $parse, $log, $q, $document) {
	  return {
	    restrict: 'E',
	    scope: {
	      isOpen: '=?mdIsOpen'
	    },
	    controller: '$mdSidenavController',
	    compile: function(element) {
	      element.addClass('md-closed');
	      element.attr('tabIndex', '-1');
	      return postLink;
	    }
	  };
	
	  /**
	   * Directive Post Link function...
	   */
	  function postLink(scope, element, attr, sidenavCtrl) {
	    var lastParentOverFlow;
	    var backdrop;
	    var disableScrollTarget = null;
	    var triggeringElement = null;
	    var previousContainerStyles;
	    var promise = $q.when(true);
	    var isLockedOpenParsed = $parse(attr.mdIsLockedOpen);
	    var isLocked = function() {
	      return isLockedOpenParsed(scope.$parent, {
	        $media: function(arg) {
	          $log.warn("$media is deprecated for is-locked-open. Use $mdMedia instead.");
	          return $mdMedia(arg);
	        },
	        $mdMedia: $mdMedia
	      });
	    };
	
	    if (attr.mdDisableScrollTarget) {
	      disableScrollTarget = $document[0].querySelector(attr.mdDisableScrollTarget);
	
	      if (disableScrollTarget) {
	        disableScrollTarget = angular.element(disableScrollTarget);
	      } else {
	        $log.warn($mdUtil.supplant('mdSidenav: couldn\'t find element matching ' +
	          'selector "{selector}". Falling back to parent.', { selector: attr.mdDisableScrollTarget }));
	      }
	    }
	
	    if (!disableScrollTarget) {
	      disableScrollTarget = element.parent();
	    }
	
	    // Only create the backdrop if the backdrop isn't disabled.
	    if (!attr.hasOwnProperty('mdDisableBackdrop')) {
	      backdrop = $mdUtil.createBackdrop(scope, "md-sidenav-backdrop md-opaque ng-enter");
	    }
	
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	
	    // The backdrop should inherit the sidenavs theme,
	    // because the backdrop will take its parent theme by default.
	    if ( backdrop ) $mdTheming.inherit(backdrop, element);
	
	    element.on('$destroy', function() {
	      backdrop && backdrop.remove();
	      sidenavCtrl.destroy();
	    });
	
	    scope.$on('$destroy', function(){
	      backdrop && backdrop.remove();
	    });
	
	    scope.$watch(isLocked, updateIsLocked);
	    scope.$watch('isOpen', updateIsOpen);
	
	
	    // Publish special accessor for the Controller instance
	    sidenavCtrl.$toggleOpen = toggleOpen;
	
	    /**
	     * Toggle the DOM classes to indicate `locked`
	     * @param isLocked
	     */
	    function updateIsLocked(isLocked, oldValue) {
	      scope.isLockedOpen = isLocked;
	      if (isLocked === oldValue) {
	        element.toggleClass('md-locked-open', !!isLocked);
	      } else {
	        $animate[isLocked ? 'addClass' : 'removeClass'](element, 'md-locked-open');
	      }
	      if (backdrop) {
	        backdrop.toggleClass('md-locked-open', !!isLocked);
	      }
	    }
	
	    /**
	     * Toggle the SideNav view and attach/detach listeners
	     * @param isOpen
	     */
	    function updateIsOpen(isOpen) {
	      // Support deprecated md-sidenav-focus attribute as fallback
	      var focusEl = $mdUtil.findFocusTarget(element) || $mdUtil.findFocusTarget(element,'[md-sidenav-focus]') || element;
	      var parent = element.parent();
	
	      parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
	      if (backdrop) backdrop[isOpen ? 'on' : 'off']('click', close);
	
	      var restorePositioning = updateContainerPositions(parent, isOpen);
	
	      if ( isOpen ) {
	        // Capture upon opening..
	        triggeringElement = $document[0].activeElement;
	      }
	
	      disableParentScroll(isOpen);
	
	      return promise = $q.all([
	        isOpen && backdrop ? $animate.enter(backdrop, parent) : backdrop ?
	                             $animate.leave(backdrop) : $q.when(true),
	        $animate[isOpen ? 'removeClass' : 'addClass'](element, 'md-closed')
	      ]).then(function() {
	        // Perform focus when animations are ALL done...
	        if (scope.isOpen) {
	          focusEl && focusEl.focus();
	        }
	
	        // Restores the positioning on the sidenav and backdrop.
	        restorePositioning && restorePositioning();
	      });
	    }
	
	    function updateContainerPositions(parent, willOpen) {
	      var drawerEl = element[0];
	      var scrollTop = parent[0].scrollTop;
	
	      if (willOpen && scrollTop) {
	        previousContainerStyles = {
	          top: drawerEl.style.top,
	          bottom: drawerEl.style.bottom,
	          height: drawerEl.style.height
	        };
	
	        // When the parent is scrolled down, then we want to be able to show the sidenav at the current scroll
	        // position. We're moving the sidenav down to the correct scroll position and apply the height of the
	        // parent, to increase the performance. Using 100% as height, will impact the performance heavily.
	        var positionStyle = {
	          top: scrollTop + 'px',
	          bottom: 'auto',
	          height: parent[0].clientHeight + 'px'
	        };
	
	        // Apply the new position styles to the sidenav and backdrop.
	        element.css(positionStyle);
	        backdrop.css(positionStyle);
	      }
	
	      // When the sidenav is closing and we have previous defined container styles,
	      // then we return a restore function, which resets the sidenav and backdrop.
	      if (!willOpen && previousContainerStyles) {
	        return function() {
	          drawerEl.style.top = previousContainerStyles.top;
	          drawerEl.style.bottom = previousContainerStyles.bottom;
	          drawerEl.style.height = previousContainerStyles.height;
	
	          backdrop[0].style.top = null;
	          backdrop[0].style.bottom = null;
	          backdrop[0].style.height = null;
	
	          previousContainerStyles = null;
	        };
	      }
	    }
	
	    /**
	     * Prevent parent scrolling (when the SideNav is open)
	     */
	    function disableParentScroll(disabled) {
	      if ( disabled && !lastParentOverFlow ) {
	        lastParentOverFlow = disableScrollTarget.css('overflow');
	        disableScrollTarget.css('overflow', 'hidden');
	      } else if (angular.isDefined(lastParentOverFlow)) {
	        disableScrollTarget.css('overflow', lastParentOverFlow);
	        lastParentOverFlow = undefined;
	      }
	    }
	
	    /**
	     * Toggle the sideNav view and publish a promise to be resolved when
	     * the view animation finishes.
	     *
	     * @param isOpen
	     * @returns {*}
	     */
	    function toggleOpen( isOpen ) {
	      if (scope.isOpen == isOpen ) {
	
	        return $q.when(true);
	
	      } else {
	        if (scope.isOpen && sidenavCtrl.onCloseCb) sidenavCtrl.onCloseCb();
	
	        return $q(function(resolve){
	          // Toggle value to force an async `updateIsOpen()` to run
	          scope.isOpen = isOpen;
	
	          $mdUtil.nextTick(function() {
	            // When the current `updateIsOpen()` animation finishes
	            promise.then(function(result) {
	
	              if ( !scope.isOpen ) {
	                // reset focus to originating element (if available) upon close
	                triggeringElement && triggeringElement.focus();
	                triggeringElement = null;
	              }
	
	              resolve(result);
	            });
	          });
	
	        });
	
	      }
	    }
	
	    /**
	     * Auto-close sideNav when the `escape` key is pressed.
	     * @param evt
	     */
	    function onKeyDown(ev) {
	      var isEscape = (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE);
	      return isEscape ? close(ev) : $q.when(true);
	    }
	
	    /**
	     * With backdrop `clicks` or `escape` key-press, immediately
	     * apply the CSS close transition... Then notify the controller
	     * to close() and perform its own actions.
	     */
	    function close(ev) {
	      ev.preventDefault();
	
	      return sidenavCtrl.close();
	    }
	
	  }
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name SidenavController
	 * @module material.components.sidenav
	 *
	 */
	function SidenavController($scope, $element, $attrs, $mdComponentRegistry, $q) {
	
	  var self = this;
	
	  // Use Default internal method until overridden by directive postLink
	
	  // Synchronous getters
	  self.isOpen = function() { return !!$scope.isOpen; };
	  self.isLockedOpen = function() { return !!$scope.isLockedOpen; };
	
	  // Synchronous setters
	  self.onClose = function (callback) {
	    self.onCloseCb = callback;
	    return self;
	  };
	
	  // Async actions
	  self.open   = function() { return self.$toggleOpen( true );  };
	  self.close  = function() { return self.$toggleOpen( false ); };
	  self.toggle = function() { return self.$toggleOpen( !$scope.isOpen );  };
	  self.$toggleOpen = function(value) { return $q.when($scope.isOpen = value); };
	
	  self.destroy = $mdComponentRegistry.register(self, $attrs.mdComponentId);
	}
	
	})();
	(function(){
	"use strict";
	
	  /**
	   * @ngdoc module
	   * @name material.components.slider
	   */
	SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
	  angular.module('material.components.slider', [
	    'material.core'
	  ])
	  .directive('mdSlider', SliderDirective)
	  .directive('mdSliderContainer', SliderContainerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSliderContainer
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider-container>` contains slider with two other elements.
	 *
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * </hljs>
	 */
	function SliderContainerDirective() {
	  return {
	    controller: function () {},
	    compile: function (elem) {
	      var slider = elem.find('md-slider');
	
	      if (!slider) {
	        return;
	      }
	
	      var vertical = slider.attr('md-vertical');
	
	      if (vertical !== undefined) {
	        elem.attr('md-vertical', '');
	      }
	
	      if(!slider.attr('flex')) {
	        slider.attr('flex', '');
	      }
	
	      return function postLink(scope, element, attr, ctrl) {
	        element.addClass('_md');     // private md component indicator for styling
	
	        // We have to manually stop the $watch on ngDisabled because it exists
	        // on the parent scope, and won't be automatically destroyed when
	        // the component is destroyed.
	        function setDisable(value) {
	          element.children().attr('disabled', value);
	          element.find('input').attr('disabled', value);
	        }
	
	        var stopDisabledWatch = angular.noop;
	
	        if (attr.disabled) {
	          setDisable(true);
	        }
	        else if (attr.ngDisabled) {
	          stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
	            setDisable(value);
	          });
	        }
	
	        scope.$on('$destroy', function () {
	          stopDisabledWatch();
	        });
	
	        var initialMaxWidth;
	
	        ctrl.fitInputWidthToTextLength = function (length) {
	          var input = element[0].querySelector('md-input-container');
	
	          if (input) {
	            var computedStyle = getComputedStyle(input);
	            var minWidth = parseInt(computedStyle.minWidth);
	            var padding = parseInt(computedStyle.padding) * 2;
	
	            initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
	            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));
	
	            input.style.maxWidth = newMaxWidth + 'px';
	          }
	        };
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSlider
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider>` component allows the user to choose from a range of
	 * values.
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the slider is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * It has two modes: 'normal' mode, where the user slides between a wide range
	 * of values, and 'discrete' mode, where the user slides between only a few
	 * select values.
	 *
	 * To enable discrete mode, add the `md-discrete` attribute to a slider,
	 * and use the `step` attribute to change the distance between
	 * values the user is allowed to pick.
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * <md-slider ng-model="myValue" min="5" max="500">
	 * </md-slider>
	 * </hljs>
	 * <h4>Discrete Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 * <h4>Invert Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 *
	 * @param {boolean=} md-discrete Whether to enable discrete mode.
	 * @param {boolean=} md-invert Whether to enable invert mode.
	 * @param {number=} step The distance between values the user is allowed to pick. Default 1.
	 * @param {number=} min The minimum value the user is allowed to pick. Default 0.
	 * @param {number=} max The maximum value the user is allowed to pick. Default 100.
	 * @param {number=} round The amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.
	 */
	function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture, $parse, $log, $timeout) {
	  return {
	    scope: {},
	    require: ['?ngModel', '?^mdSliderContainer'],
	    template:
	      '<div class="md-slider-wrapper">' +
	        '<div class="md-slider-content">' +
	          '<div class="md-track-container">' +
	            '<div class="md-track"></div>' +
	            '<div class="md-track md-track-fill"></div>' +
	            '<div class="md-track-ticks"></div>' +
	          '</div>' +
	          '<div class="md-thumb-container">' +
	            '<div class="md-thumb"></div>' +
	            '<div class="md-focus-thumb"></div>' +
	            '<div class="md-focus-ring"></div>' +
	            '<div class="md-sign">' +
	              '<span class="md-thumb-text"></span>' +
	            '</div>' +
	            '<div class="md-disabled-thumb"></div>' +
	          '</div>' +
	        '</div>' +
	      '</div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    var wrapper = angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));
	
	    var tabIndex = tAttrs.tabindex || 0;
	    wrapper.attr('tabindex', tabIndex);
	
	    if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);
	
	    wrapper.attr('role', 'slider');
	
	    $mdAria.expect(tElement, 'aria-label');
	
	    return postLink;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    $mdTheming(element);
	    var ngModelCtrl = ctrls[0] || {
	      // Mock ngModelController if it doesn't exist to give us
	      // the minimum functionality needed
	      $setViewValue: function(val) {
	        this.$viewValue = val;
	        this.$viewChangeListeners.forEach(function(cb) { cb(); });
	      },
	      $parsers: [],
	      $formatters: [],
	      $viewChangeListeners: []
	    };
	
	    var containerCtrl = ctrls[1];
	    var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
	    var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
	          return element[0].hasAttribute('disabled');
	        };
	
	    var thumb = angular.element(element[0].querySelector('.md-thumb'));
	    var thumbText = angular.element(element[0].querySelector('.md-thumb-text'));
	    var thumbContainer = thumb.parent();
	    var trackContainer = angular.element(element[0].querySelector('.md-track-container'));
	    var activeTrack = angular.element(element[0].querySelector('.md-track-fill'));
	    var tickContainer = angular.element(element[0].querySelector('.md-track-ticks'));
	    var wrapper = angular.element(element[0].getElementsByClassName('md-slider-wrapper'));
	    var content = angular.element(element[0].getElementsByClassName('md-slider-content'));
	    var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);
	
	    // Default values, overridable by attrs
	    var DEFAULT_ROUND = 3;
	    var vertical = angular.isDefined(attr.mdVertical);
	    var discrete = angular.isDefined(attr.mdDiscrete);
	    var invert = angular.isDefined(attr.mdInvert);
	    angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
	    angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
	    angular.isDefined(attr.step)? attr.$observe('step', updateStep) : updateStep(1);
	    angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);
	
	    // We have to manually stop the $watch on ngDisabled because it exists
	    // on the parent scope, and won't be automatically destroyed when
	    // the component is destroyed.
	    var stopDisabledWatch = angular.noop;
	    if (attr.ngDisabled) {
	      stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
	    }
	
	    $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });
	
	    scope.mouseActive = false;
	
	    wrapper
	      .on('keydown', keydownListener)
	      .on('mousedown', mouseDownListener)
	      .on('focus', focusListener)
	      .on('blur', blurListener)
	      .on('$md.pressdown', onPressDown)
	      .on('$md.pressup', onPressUp)
	      .on('$md.dragstart', onDragStart)
	      .on('$md.drag', onDrag)
	      .on('$md.dragend', onDragEnd);
	
	    // On resize, recalculate the slider's dimensions and re-render
	    function updateAll() {
	      refreshSliderDimensions();
	      ngModelRender();
	    }
	    setTimeout(updateAll, 0);
	
	    var debouncedUpdateAll = $$rAF.throttle(updateAll);
	    angular.element($window).on('resize', debouncedUpdateAll);
	
	    scope.$on('$destroy', function() {
	      angular.element($window).off('resize', debouncedUpdateAll);
	    });
	
	    ngModelCtrl.$render = ngModelRender;
	    ngModelCtrl.$viewChangeListeners.push(ngModelRender);
	    ngModelCtrl.$formatters.push(minMaxValidator);
	    ngModelCtrl.$formatters.push(stepValidator);
	
	    /**
	     * Attributes
	     */
	    var min;
	    var max;
	    var step;
	    var round;
	    function updateMin(value) {
	      min = parseFloat(value);
	      element.attr('aria-valuemin', value);
	      updateAll();
	    }
	    function updateMax(value) {
	      max = parseFloat(value);
	      element.attr('aria-valuemax', value);
	      updateAll();
	    }
	    function updateStep(value) {
	      step = parseFloat(value);
	    }
	    function updateRound(value) {
	      // Set max round digits to 6, after 6 the input uses scientific notation
	      round = minMaxValidator(parseInt(value), 0, 6);
	    }
	    function updateAriaDisabled() {
	      element.attr('aria-disabled', !!isDisabled());
	    }
	
	    // Draw the ticks with canvas.
	    // The alternative to drawing ticks with canvas is to draw one element for each tick,
	    // which could quickly become a performance bottleneck.
	    var tickCanvas, tickCtx;
	    function redrawTicks() {
	      if (!discrete || isDisabled()) return;
	      if ( angular.isUndefined(step) )         return;
	
	      if ( step <= 0 ) {
	        var msg = 'Slider step value must be greater than zero when in discrete mode';
	        $log.error(msg);
	        throw new Error(msg);
	      }
	
	      var numSteps = Math.floor( (max - min) / step );
	      if (!tickCanvas) {
	        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
	        tickContainer.append(tickCanvas);
	
	        tickCtx = tickCanvas[0].getContext('2d');
	      }
	
	      var dimensions = getSliderDimensions();
	
	      // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
	      if (dimensions && !dimensions.height && !dimensions.width) {
	        refreshSliderDimensions();
	        dimensions = sliderDimensions;
	      }
	
	      tickCanvas[0].width = dimensions.width;
	      tickCanvas[0].height = dimensions.height;
	
	      var distance;
	      for (var i = 0; i <= numSteps; i++) {
	        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
	        tickCtx.fillStyle = trackTicksStyle.color || 'black';
	
	        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));
	
	        tickCtx.fillRect(vertical ? 0 : distance - 1,
	          vertical ? distance - 1 : 0,
	          vertical ? dimensions.width : 2,
	          vertical ? 2 : dimensions.height);
	      }
	    }
	
	    function clearTicks() {
	      if(tickCanvas && tickCtx) {
	        var dimensions = getSliderDimensions();
	        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
	      }
	    }
	
	    /**
	     * Refreshing Dimensions
	     */
	    var sliderDimensions = {};
	    refreshSliderDimensions();
	    function refreshSliderDimensions() {
	      sliderDimensions = trackContainer[0].getBoundingClientRect();
	    }
	    function getSliderDimensions() {
	      throttledRefreshDimensions();
	      return sliderDimensions;
	    }
	
	    /**
	     * left/right/up/down arrow listener
	     */
	    function keydownListener(ev) {
	      if (isDisabled()) return;
	
	      var changeAmount;
	      if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW : ev.keyCode === $mdConstant.KEY_CODE.LEFT_ARROW) {
	        changeAmount = -step;
	      } else if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.UP_ARROW : ev.keyCode === $mdConstant.KEY_CODE.RIGHT_ARROW) {
	        changeAmount = step;
	      }
	      changeAmount = invert ? -changeAmount : changeAmount;
	      if (changeAmount) {
	        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
	          changeAmount *= 4;
	        }
	        ev.preventDefault();
	        ev.stopPropagation();
	        scope.$evalAsync(function() {
	          setModelValue(ngModelCtrl.$viewValue + changeAmount);
	        });
	      }
	    }
	
	    function mouseDownListener() {
	      redrawTicks();
	
	      scope.mouseActive = true;
	      wrapper.removeClass('md-focused');
	
	      $timeout(function() {
	        scope.mouseActive = false;
	      }, 100);
	    }
	
	    function focusListener() {
	      if (scope.mouseActive === false) {
	        wrapper.addClass('md-focused');
	      }
	    }
	
	    function blurListener() {
	      wrapper.removeClass('md-focused');
	      element.removeClass('md-active');
	      clearTicks();
	    }
	
	    /**
	     * ngModel setters and validators
	     */
	    function setModelValue(value) {
	      ngModelCtrl.$setViewValue( minMaxValidator(stepValidator(value)) );
	    }
	    function ngModelRender() {
	      if (isNaN(ngModelCtrl.$viewValue)) {
	        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
	      }
	
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);
	
	      var percent = valueToPercent(ngModelCtrl.$viewValue);
	      scope.modelValue = ngModelCtrl.$viewValue;
	      element.attr('aria-valuenow', ngModelCtrl.$viewValue);
	      setSliderPercent(percent);
	      thumbText.text( ngModelCtrl.$viewValue );
	    }
	
	    function minMaxValidator(value, minValue, maxValue) {
	      if (angular.isNumber(value)) {
	        minValue = angular.isNumber(minValue) ? minValue : min;
	        maxValue = angular.isNumber(maxValue) ? maxValue : max;
	
	        return Math.max(minValue, Math.min(maxValue, value));
	      }
	    }
	
	    function stepValidator(value) {
	      if (angular.isNumber(value)) {
	        var formattedValue = (Math.round((value - min) / step) * step + min);
	        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));
	
	        if (containerCtrl && containerCtrl.fitInputWidthToTextLength){
	          $mdUtil.debounce(function () {
	            containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
	          }, 100)();
	        }
	
	        return formattedValue;
	      }
	    }
	
	    /**
	     * @param percent 0-1
	     */
	    function setSliderPercent(percent) {
	
	      percent = clamp(percent);
	
	      var thumbPosition = (percent * 100) + '%';
	      var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;
	
	      if (vertical) {
	        thumbContainer.css('bottom', thumbPosition);
	      }
	      else {
	        $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
	      }
	
	      
	      activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);
	
	      element.toggleClass((invert ? 'md-max' : 'md-min'), percent === 0);
	      element.toggleClass((invert ? 'md-min' : 'md-max'), percent === 1);
	    }
	
	    /**
	     * Slide listeners
	     */
	    var isDragging = false;
	
	    function onPressDown(ev) {
	      if (isDisabled()) return;
	
	      element.addClass('md-active');
	      element[0].focus();
	      refreshSliderDimensions();
	
	      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      scope.$apply(function() {
	        setModelValue( closestVal );
	        setSliderPercent( valueToPercent(closestVal));
	      });
	    }
	    function onPressUp(ev) {
	      if (isDisabled()) return;
	
	      element.removeClass('md-dragging');
	
	      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      scope.$apply(function() {
	        setModelValue(closestVal);
	        ngModelRender();
	      });
	    }
	    function onDragStart(ev) {
	      if (isDisabled()) return;
	      isDragging = true;
	
	      ev.stopPropagation();
	
	      element.addClass('md-dragging');
	      setSliderFromEvent(ev);
	    }
	    function onDrag(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      setSliderFromEvent(ev);
	    }
	    function onDragEnd(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      isDragging = false;
	    }
	
	    function setSliderFromEvent(ev) {
	      // While panning discrete, update only the
	      // visual positioning but not the model value.
	      if ( discrete ) adjustThumbPosition( vertical ? ev.pointer.y : ev.pointer.x );
	      else            doSlide( vertical ? ev.pointer.y : ev.pointer.x );
	    }
	
	    /**
	     * Slide the UI by changing the model value
	     * @param x
	     */
	    function doSlide( x ) {
	      scope.$evalAsync( function() {
	        setModelValue( percentToValue( positionToPercent(x) ));
	      });
	    }
	
	    /**
	     * Slide the UI without changing the model (while dragging/panning)
	     * @param x
	     */
	    function adjustThumbPosition( x ) {
	      var exactVal = percentToValue( positionToPercent( x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      setSliderPercent( positionToPercent(x) );
	      thumbText.text( closestVal );
	    }
	
	    /**
	    * Clamps the value to be between 0 and 1.
	    * @param {number} value The value to clamp.
	    * @returns {number}
	    */
	    function clamp(value) {
	      return Math.max(0, Math.min(value || 0, 1));
	    }
	
	    /**
	     * Convert position on slider to percentage value of offset from beginning...
	     * @param position
	     * @returns {number}
	     */
	    function positionToPercent( position ) {
	      var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
	      var size = vertical ? sliderDimensions.height : sliderDimensions.width;
	      var calc = (position - offset) / size;
	
	      if (!vertical && $mdUtil.bidi() === 'rtl') {
	        calc = 1 - calc;
	      }
	
	      return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
	    }
	
	    /**
	     * Convert percentage offset on slide to equivalent model value
	     * @param percent
	     * @returns {*}
	     */
	    function percentToValue( percent ) {
	      var adjustedPercent = invert ? (1 - percent) : percent;
	      return (min + adjustedPercent * (max - min));
	    }
	
	    function valueToPercent( val ) {
	      var percent = (val - min) / (max - min);
	      return invert ? (1 - percent) : percent;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sticky
	 * @description
	 * Sticky effects for md
	 *
	 */
	MdSticky.$inject = ["$mdConstant", "$$rAF", "$mdUtil", "$compile"];
	angular
	  .module('material.components.sticky', [
	    'material.core',
	    'material.components.content'
	  ])
	  .factory('$mdSticky', MdSticky);
	
	/**
	 * @ngdoc service
	 * @name $mdSticky
	 * @module material.components.sticky
	 *
	 * @description
	 * The `$mdSticky`service provides a mixin to make elements sticky.
	 *
	 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will just
	 * use the native browser stickiness.
	 *
	 * By default the `$mdSticky` service compiles the cloned element, when not specified through the `elementClone`
	 * parameter, in the same scope as the actual element lives.
	 *
	 *
	 * <h3>Notes</h3>
	 * When using an element which is containing a compiled directive, which changed its DOM structure during compilation,
	 * you should compile the clone yourself using the plain template.<br/><br/>
	 * See the right usage below:
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickySelect', function($mdSticky, $compile) {
	 *       var SELECT_TEMPLATE =
	 *         '<md-select ng-model="selected">' +
	 *           '<md-option>Option 1</md-option>' +
	 *         '</md-select>';
	 *
	 *       return {
	 *         restrict: 'E',
	 *         replace: true,
	 *         template: SELECT_TEMPLATE,
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickyText', function($mdSticky, $compile) {
	 *       return {
	 *         restrict: 'E',
	 *         template: '<span>Sticky Text</span>',
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element);
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @returns A `$mdSticky` function that takes three arguments:
	 *   - `scope`
	 *   - `element`: The element that will be 'sticky'
	 *   - `elementClone`: A clone of the element, that will be shown
	 *     when the user starts scrolling past the original element.
	 *     If not provided, it will use the result of `element.clone()` and compiles it in the given scope.
	 */
	function MdSticky($mdConstant, $$rAF, $mdUtil, $compile) {
	
	  var browserStickySupport = $mdUtil.checkStickySupport();
	
	  /**
	   * Registers an element as sticky, used internally by directives to register themselves
	   */
	  return function registerStickyElement(scope, element, stickyClone) {
	    var contentCtrl = element.controller('mdContent');
	    if (!contentCtrl) return;
	
	    if (browserStickySupport) {
	      element.css({
	        position: browserStickySupport,
	        top: 0,
	        'z-index': 2
	      });
	    } else {
	      var $$sticky = contentCtrl.$element.data('$$sticky');
	      if (!$$sticky) {
	        $$sticky = setupSticky(contentCtrl);
	        contentCtrl.$element.data('$$sticky', $$sticky);
	      }
	
	      // Compile our cloned element, when cloned in this service, into the given scope.
	      var cloneElement = stickyClone || $compile(element.clone())(scope);
	
	      var deregister = $$sticky.add(element, cloneElement);
	      scope.$on('$destroy', deregister);
	    }
	  };
	
	  function setupSticky(contentCtrl) {
	    var contentEl = contentCtrl.$element;
	
	    // Refresh elements is very expensive, so we use the debounced
	    // version when possible.
	    var debouncedRefreshElements = $$rAF.throttle(refreshElements);
	
	    // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
	    // more reliable than `scroll` on android.
	    setupAugmentedScrollEvents(contentEl);
	    contentEl.on('$scrollstart', debouncedRefreshElements);
	    contentEl.on('$scroll', onScroll);
	
	    var self;
	    return self = {
	      prev: null,
	      current: null, //the currently stickied item
	      next: null,
	      items: [],
	      add: add,
	      refreshElements: refreshElements
	    };
	
	    /***************
	     * Public
	     ***************/
	    // Add an element and its sticky clone to this content's sticky collection
	    function add(element, stickyClone) {
	      stickyClone.addClass('md-sticky-clone');
	
	      var item = {
	        element: element,
	        clone: stickyClone
	      };
	      self.items.push(item);
	
	      $mdUtil.nextTick(function() {
	        contentEl.prepend(item.clone);
	      });
	
	      debouncedRefreshElements();
	
	      return function remove() {
	        self.items.forEach(function(item, index) {
	          if (item.element[0] === element[0]) {
	            self.items.splice(index, 1);
	            item.clone.remove();
	          }
	        });
	        debouncedRefreshElements();
	      };
	    }
	
	    function refreshElements() {
	      // Sort our collection of elements by their current position in the DOM.
	      // We need to do this because our elements' order of being added may not
	      // be the same as their order of display.
	      self.items.forEach(refreshPosition);
	      self.items = self.items.sort(function(a, b) {
	        return a.top < b.top ? -1 : 1;
	      });
	
	      // Find which item in the list should be active, 
	      // based upon the content's current scroll position
	      var item;
	      var currentScrollTop = contentEl.prop('scrollTop');
	      for (var i = self.items.length - 1; i >= 0; i--) {
	        if (currentScrollTop > self.items[i].top) {
	          item = self.items[i];
	          break;
	        }
	      }
	      setCurrentItem(item);
	    }
	
	    /***************
	     * Private
	     ***************/
	
	    // Find the `top` of an item relative to the content element,
	    // and also the height.
	    function refreshPosition(item) {
	      // Find the top of an item by adding to the offsetHeight until we reach the 
	      // content element.
	      var current = item.element[0];
	      item.top = 0;
	      item.left = 0;
	      item.right = 0;
	      while (current && current !== contentEl[0]) {
	        item.top += current.offsetTop;
	        item.left += current.offsetLeft;
	        if ( current.offsetParent ){
	          item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft; //Compute offsetRight
	        }
	        current = current.offsetParent;
	      }
	      item.height = item.element.prop('offsetHeight');
	
	      var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
	      $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
	      $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
	    }
	
	    // As we scroll, push in and select the correct sticky element.
	    function onScroll() {
	      var scrollTop = contentEl.prop('scrollTop');
	      var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);
	
	      // Store the previous scroll so we know which direction we are scrolling
	      onScroll.prevScrollTop = scrollTop;
	
	      //
	      // AT TOP (not scrolling)
	      //
	      if (scrollTop === 0) {
	        // If we're at the top, just clear the current item and return
	        setCurrentItem(null);
	        return;
	      }
	
	      //
	      // SCROLLING DOWN (going towards the next item)
	      //
	      if (isScrollingDown) {
	
	        // If we've scrolled down past the next item's position, sticky it and return
	        if (self.next && self.next.top <= scrollTop) {
	          setCurrentItem(self.next);
	          return;
	        }
	
	        // If the next item is close to the current one, push the current one up out of the way
	        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
	          translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
	          return;
	        }
	      }
	
	      //
	      // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
	      //
	      if (!isScrollingDown) {
	
	        // If we've scrolled up past the previous item's position, sticky it and return
	        if (self.current && self.prev && scrollTop < self.current.top) {
	          setCurrentItem(self.prev);
	          return;
	        }
	
	        // If the next item is close to the current one, pull the current one down into view
	        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
	          translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
	          return;
	        }
	      }
	
	      //
	      // Otherwise, just move the current item to the proper place (scrolling up or down)
	      //
	      if (self.current) {
	        translate(self.current, scrollTop);
	      }
	    }
	
	    function setCurrentItem(item) {
	      if (self.current === item) return;
	      // Deactivate currently active item
	      if (self.current) {
	        translate(self.current, null);
	        setStickyState(self.current, null);
	      }
	
	      // Activate new item if given
	      if (item) {
	        setStickyState(item, 'active');
	      }
	
	      self.current = item;
	      var index = self.items.indexOf(item);
	      // If index === -1, index + 1 = 0. It works out.
	      self.next = self.items[index + 1];
	      self.prev = self.items[index - 1];
	      setStickyState(self.next, 'next');
	      setStickyState(self.prev, 'prev');
	    }
	
	    function setStickyState(item, state) {
	      if (!item || item.state === state) return;
	      if (item.state) {
	        item.clone.attr('sticky-prev-state', item.state);
	        item.element.attr('sticky-prev-state', item.state);
	      }
	      item.clone.attr('sticky-state', state);
	      item.element.attr('sticky-state', state);
	      item.state = state;
	    }
	
	    function translate(item, amount) {
	      if (!item) return;
	      if (amount === null || amount === undefined) {
	        if (item.translateY) {
	          item.translateY = null;
	          item.clone.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      } else {
	        item.translateY = amount;
	
	        $mdUtil.bidi( item.clone, $mdConstant.CSS.TRANSFORM,
	          'translate3d(' + item.left + 'px,' + amount + 'px,0)',
	          'translateY(' + amount + 'px)'
	        );
	      }
	    }
	  }
	
	
	  // Android 4.4 don't accurately give scroll events.
	  // To fix this problem, we setup a fake scroll event. We say:
	  // > If a scroll or touchmove event has happened in the last DELAY milliseconds, 
	  //   then send a `$scroll` event every animationFrame.
	  // Additionally, we add $scrollstart and $scrollend events.
	  function setupAugmentedScrollEvents(element) {
	    var SCROLL_END_DELAY = 200;
	    var isScrolling;
	    var lastScrollTime;
	    element.on('scroll touchmove', function() {
	      if (!isScrolling) {
	        isScrolling = true;
	        $$rAF.throttle(loopScrollEvent);
	        element.triggerHandler('$scrollstart');
	      }
	      element.triggerHandler('$scroll');
	      lastScrollTime = +$mdUtil.now();
	    });
	
	    function loopScrollEvent() {
	      if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
	        isScrolling = false;
	        element.triggerHandler('$scrollend');
	      } else {
	        element.triggerHandler('$scroll');
	        $$rAF.throttle(loopScrollEvent);
	      }
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.subheader
	 * @description
	 * SubHeader module
	 *
	 *  Subheaders are special list tiles that delineate distinct sections of a
	 *  list or grid list and are typically related to the current filtering or
	 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
	 *  can be associated with content, for example, in an adjacent column.
	 *
	 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
	 *  pinned until pushed on or off screen by the next subheader. @see [Material
	 *  Design Specifications](https://www.google.com/design/spec/components/subheaders.html)
	 *
	 *  > To improve the visual grouping of content, use the system color for your subheaders.
	 *
	 */
	MdSubheaderDirective.$inject = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil"];
	angular
	  .module('material.components.subheader', [
	    'material.core',
	    'material.components.sticky'
	  ])
	  .directive('mdSubheader', MdSubheaderDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSubheader
	 * @module material.components.subheader
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-subheader` directive creates a sticky subheader for a section.
	 *
	 * Developers are able to disable the stickiness of the subheader by using the following markup
	 *
	 * <hljs lang="html">
	 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
	 * </hljs>
	 *
	 * ### Notes
	 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
	 * to make the subheader sticky.
	 *
	 * > Whenever the current browser doesn't support stickiness natively, the subheader
	 * will be compiled twice to create a sticky clone of the subheader.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-subheader>Online Friends</md-subheader>
	 * </hljs>
	 */
	
	function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    template: (
	    '<div class="md-subheader _md">' +
	    '  <div class="md-subheader-inner">' +
	    '    <div class="md-subheader-content"></div>' +
	    '  </div>' +
	    '</div>'
	    ),
	    link: function postLink(scope, element, attr, controllers, transclude) {
	      $mdTheming(element);
	      element.addClass('_md');
	
	      // Remove the ngRepeat attribute from the root element, because we don't want to compile
	      // the ngRepeat for the sticky clone again.
	      $mdUtil.prefixer().removeAttribute(element, 'ng-repeat');
	
	      var outerHTML = element[0].outerHTML;
	
	      function getContent(el) {
	        return angular.element(el[0].querySelector('.md-subheader-content'));
	      }
	
	      // Transclude the user-given contents of the subheader
	      // the conventional way.
	      transclude(scope, function(clone) {
	        getContent(element).append(clone);
	      });
	
	      // Create another clone, that uses the outer and inner contents
	      // of the element, that will be 'stickied' as the user scrolls.
	      if (!element.hasClass('md-no-sticky')) {
	        transclude(scope, function(clone) {
	          // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
	          // compiled clone below will only be a comment tag (since they replace their elements with
	          // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
	          // DIV to ensure we have something $mdSticky can use
	          var wrapper = $compile('<div class="md-subheader-wrapper">' + outerHTML + '</div>')(scope);
	
	          // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
	          // attempting to create the clone
	          $mdUtil.nextTick(function() {
	            // Append our transcluded clone into the wrapper.
	            // We don't have to recompile the element again, because the clone is already
	            // compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
	            // our ngIf's and other previous registered bindings / properties.
	            getContent(wrapper).append(clone);
	          });
	
	          // Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
	          // element.
	          $mdSticky(scope, element, wrapper);
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.swipe
	 * @description Swipe module!
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeLeft
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
	 * left.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-left="onSwipeLeft()">Swipe me left!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeRight
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
	 * right.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-right="onSwipeRight()">Swipe me right!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeUp
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
	 * up.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-up="onSwipeUp()">Swipe me up!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeDown
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
	 * down.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-down="onSwipDown()">Swipe me down!</div>
	 * </hljs>
	 */
	
	angular.module('material.components.swipe', ['material.core'])
	    .directive('mdSwipeLeft', getDirective('SwipeLeft'))
	    .directive('mdSwipeRight', getDirective('SwipeRight'))
	    .directive('mdSwipeUp', getDirective('SwipeUp'))
	    .directive('mdSwipeDown', getDirective('SwipeDown'));
	
	function getDirective(name) {
	    DirectiveFactory.$inject = ["$parse"];
	  var directiveName = 'md' + name;
	  var eventName = '$md.' + name.toLowerCase();
	
	  return DirectiveFactory;
	
	  /* @ngInject */
	  function DirectiveFactory($parse) {
	      return { restrict: 'A', link: postLink };
	      function postLink(scope, element, attr) {
	        var fn = $parse(attr[directiveName]);
	        element.on(eventName, function(ev) {
	          scope.$applyAsync(function() { fn(scope, { $event: ev }); });
	        });
	      }
	    }
	}
	
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.switch
	 */
	
	MdSwitch.$inject = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture", "$timeout"];
	angular.module('material.components.switch', [
	  'material.core',
	  'material.components.checkbox'
	])
	  .directive('mdSwitch', MdSwitch);
	
	/**
	 * @ngdoc directive
	 * @module material.components.switch
	 * @name mdSwitch
	 * @restrict E
	 *
	 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the switch is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {string=} ng-change Angular expression to be executed when input changes due to user interaction with the input element.
	 * @param {expression=} ng-disabled En/Disable based on the expression.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
	 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-switch ng-model="isActive" aria-label="Finished?">
	 *   Finished ?
	 * </md-switch>
	 *
	 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-switch>
	 *
	 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-switch>
	 *
	 * </hljs>
	 */
	function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture, $timeout) {
	  var checkboxDirective = mdCheckboxDirective[0];
	
	  return {
	    restrict: 'E',
	    priority: 210, // Run before ngAria
	    transclude: true,
	    template:
	      '<div class="md-container">' +
	        '<div class="md-bar"></div>' +
	        '<div class="md-thumb-container">' +
	          '<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
	        '</div>'+
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    require: '?ngModel',
	    compile: mdSwitchCompile
	  };
	
	  function mdSwitchCompile(element, attr) {
	    var checkboxLink = checkboxDirective.compile(element, attr).post;
	    // No transition on initial load.
	    element.addClass('md-dragging');
	
	    return function (scope, element, attr, ngModel) {
	      ngModel = ngModel || $mdUtil.fakeNgModel();
	
	      var disabledGetter = null;
	      if (attr.disabled != null) {
	        disabledGetter = function() { return true; };
	      } else if (attr.ngDisabled) {
	        disabledGetter = $parse(attr.ngDisabled);
	      }
	
	      var thumbContainer = angular.element(element[0].querySelector('.md-thumb-container'));
	      var switchContainer = angular.element(element[0].querySelector('.md-container'));
	
	      // no transition on initial load
	      $$rAF(function() {
	        element.removeClass('md-dragging');
	      });
	
	      checkboxLink(scope, element, attr, ngModel);
	
	      if (disabledGetter) {
	        scope.$watch(disabledGetter, function(isDisabled) {
	          element.attr('tabindex', isDisabled ? -1 : 0);
	        });
	      }
	
	      // These events are triggered by setup drag
	      $mdGesture.register(switchContainer, 'drag');
	      switchContainer
	        .on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      var drag;
	      function onDragStart(ev) {
	        // Don't go if the switch is disabled.
	        if (disabledGetter && disabledGetter(scope)) return;
	        ev.stopPropagation();
	
	        element.addClass('md-dragging');
	        drag = {width: thumbContainer.prop('offsetWidth')};
	      }
	
	      function onDrag(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	        ev.srcEvent && ev.srcEvent.preventDefault();
	
	        var percent = ev.pointer.distanceX / drag.width;
	
	        //if checked, start from right. else, start from left
	        var translate = ngModel.$viewValue ?  1 + percent : percent;
	        // Make sure the switch stays inside its bounds, 0-1%
	        translate = Math.max(0, Math.min(1, translate));
	
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100*translate) + '%,0,0)');
	        drag.translate = translate;
	      }
	
	      function onDragEnd(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	
	        element.removeClass('md-dragging');
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');
	
	        // We changed if there is no distance (this is a click a click),
	        // or if the drag distance is >50% of the total.
	        var isChanged = ngModel.$viewValue ? drag.translate < 0.5 : drag.translate > 0.5;
	        if (isChanged) {
	          applyModelValue(!ngModel.$viewValue);
	        }
	        drag = null;
	
	        // Wait for incoming mouse click
	        scope.skipToggle = true;
	        $timeout(function() {
	          scope.skipToggle = false;
	        }, 1);
	      }
	
	      function applyModelValue(newValue) {
	        scope.$apply(function() {
	          ngModel.$setViewValue(newValue);
	          ngModel.$render();
	        });
	      }
	
	    };
	  }
	
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tabs
	 * @description
	 *
	 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
	 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
	 *
	 *  Features include support for:
	 *
	 *  - static or dynamic tabs,
	 *  - responsive designs,
	 *  - accessibility support (ARIA),
	 *  - tab pagination,
	 *  - external or internal tab content,
	 *  - focus indicators and arrow-key navigations,
	 *  - programmatic lookup and access to tab controllers, and
	 *  - dynamic transitions through different tab contents.
	 *
	 */
	/*
	 * @see js folder for tabs implementation
	 */
	angular.module('material.components.tabs', [
	  'material.core',
	  'material.components.icon'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	  * @ngdoc module
	  * @name material.components.toast
	  * @description
	  * Toast
	  */
	MdToastDirective.$inject = ["$mdToast"];
	MdToastProvider.$inject = ["$$interimElementProvider"];
	angular.module('material.components.toast', [
	  'material.core',
	  'material.components.button'
	])
	  .directive('mdToast', MdToastDirective)
	  .provider('$mdToast', MdToastProvider);
	
	/* @ngInject */
	function MdToastDirective($mdToast) {
	  return {
	    restrict: 'E',
	    link: function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	      
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdToast.destroy();
	      });
	    }
	  };
	}
	
	/**
	  * @ngdoc service
	  * @name $mdToast
	  * @module material.components.toast
	  *
	  * @description
	  * `$mdToast` is a service to build a toast notification on any position
	  * on the screen with an optional duration, and provides a simple promise API.
	  *
	  * The toast will be always positioned at the `bottom`, when the screen size is
	  * between `600px` and `959px` (`sm` breakpoint)
	  *
	  * ## Restrictions on custom toasts
	  * - The toast's template must have an outer `<md-toast>` element.
	  * - For a toast action, use element with class `md-action`.
	  * - Add the class `md-capsule` for curved corners.
	  *
	  * ### Custom Presets
	  * Developers are also able to create their own preset, which can be easily used without repeating
	  * their options each time.
	  *
	  * <hljs lang="js">
	  *   $mdToastProvider.addPreset('testPreset', {
	  *     options: function() {
	  *       return {
	  *         template:
	  *           '<md-toast>' +
	  *             '<div class="md-toast-content">' +
	  *               'This is a custom preset' +
	  *             '</div>' +
	  *           '</md-toast>',
	  *         controllerAs: 'toast',
	  *         bindToController: true
	  *       };
	  *     }
	  *   });
	  * </hljs>
	  *
	  * After you created your preset at config phase, you can easily access it.
	  *
	  * <hljs lang="js">
	  *   $mdToast.show(
	  *     $mdToast.testPreset()
	  *   );
	  * </hljs>
	  *
	  * ## Parent container notes
	  *
	  * The toast is positioned using absolute positioning relative to its first non-static parent
	  * container. Thus, if the requested parent container uses static positioning, we will temporarily
	  * set its positioning to `relative` while the toast is visible and reset it when the toast is
	  * hidden.
	  *
	  * Because of this, it is usually best to ensure that the parent container has a fixed height and
	  * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
	  * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
	  *
	  * You can, however, have a scrollable element inside of the container; just make sure the
	  * container itself does not scroll.
	  *
	  * <hljs lang="html">
	  * <div layout-fill id="toast-container">
	  *   <md-content>
	  *     I can have lots of content and scroll!
	  *   </md-content>
	  * </div>
	  * </hljs>
	  *
	  * @usage
	  * <hljs lang="html">
	  * <div ng-controller="MyController">
	  *   <md-button ng-click="openToast()">
	  *     Open a Toast!
	  *   </md-button>
	  * </div>
	  * </hljs>
	  *
	  * <hljs lang="js">
	  * var app = angular.module('app', ['ngMaterial']);
	  * app.controller('MyController', function($scope, $mdToast) {
	  *   $scope.openToast = function($event) {
	  *     $mdToast.show($mdToast.simple().textContent('Hello!'));
	  *     // Could also do $mdToast.showSimple('Hello');
	  *   };
	  * });
	  * </hljs>
	  */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#showSimple
	 * 
	 * @param {string} message The message to display inside the toast
	 * @description
	 * Convenience method which builds and shows a simple toast.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	 * rejected with `$mdToast.cancel()`.
	 *
	 */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#simple
	  *
	  * @description
	  * Builds a preconfigured toast.
	  *
	  * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
	  *
	  * _**Note:** These configuration methods are provided in addition to the methods provided by
	  * the `build()` and `show()` methods below._
	  *
	  * <table class="md-api-table methods">
	  *    <thead>
	  *      <tr>
	  *        <th>Method</th>
	  *        <th>Description</th>
	  *      </tr>
	  *    </thead>
	  *    <tbody>
	  *      <tr>
	  *        <td>`.textContent(string)`</td>
	  *        <td>Sets the toast content to the specified string</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.action(string)`</td>
	  *        <td>
	  *          Adds an action button. <br/>
	  *          If clicked, the promise (returned from `show()`)
	  *          will resolve with the value `'ok'`; otherwise, it is resolved with `true` after a `hideDelay`
	  *          timeout
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightAction(boolean)`</td>
	  *        <td>
	  *          Whether or not the action button will have an additional highlight class.<br/>
	  *          By default the `accent` color will be applied to the action button.
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightClass(string)`</td>
	  *        <td>
	  *          If set, the given class will be applied to the highlighted action button.<br/>
	  *          This allows you to specify the highlight color easily. Highlight classes are `md-primary`, `md-warn`
	  *          and `md-accent`
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.capsule(boolean)`</td>
	  *        <td>Whether or not to add the `md-capsule` class to the toast to provide rounded corners</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.theme(string)`</td>
	  *        <td>Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s default.</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.toastClass(string)`</td>
	  *        <td>Sets a class on the toast element</td>
	  *      </tr>
	  *    </tbody>
	  * </table>
	  *
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#updateTextContent
	  *
	  * @description
	  * Updates the content of an existing toast. Useful for updating things like counts, etc.
	  *
	  */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#build
	  *
	  * @description
	  * Creates a custom `$mdToastPreset` that you can configure.
	  *
	  * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options (see below).
	  */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#show
	  *
	  * @description Shows the toast.
	  *
	  * @param {object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
	  * and `build()`, or an options object with the following properties:
	  *
	  *   - `templateUrl` - `{string=}`: The url of an html template file that will
	  *     be used as the content of the toast. Restrictions: the template must
	  *     have an outer `md-toast` element.
	  *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	  *     template string.
	  *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
	  *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled if you provide a
	  *     custom toast directive.
	  *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	  *     This scope will be destroyed when the toast is removed unless `preserveScope` is set to true.
	  *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	  *   - `hideDelay` - `{number=}`: How many milliseconds the toast should stay
	  *     active before automatically closing.  Set to 0 or false to have the toast stay open until
	  *     closed manually. Default: 3000.
	  *   - `position` - `{string=}`: Sets the position of the toast. <br/>
	  *     Available: any combination of `'bottom'`, `'left'`, `'top'`, `'right'`, `'end'` and `'start'`.
	  *     The properties `'end'` and `'start'` are dynamic and can be used for RTL support.<br/>
	  *     Default combination: `'bottom left'`.
	  *   - `toastClass` - `{string=}`: A class to set on the toast element.
	  *   - `controller` - `{string=}`: The controller to associate with this toast.
	  *     The controller will be injected the local `$mdToast.hide( )`, which is a function
	  *     used to hide the toast.
	  *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	  *     be used as names of values to inject into the controller. For example,
	  *     `locals: {three: 3}` would inject `three` into the controller with the value
	  *     of 3.
	  *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	  *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	  *     and the toast will not open until the promises resolve.
	  *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	  *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
	  *     to the root element of the application.
	  *
	  * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	  * rejected with `$mdToast.cancel()`. `$mdToast.hide()` will resolve either with a Boolean
	  * value == 'true' or the value passed as an argument to `$mdToast.hide()`.
	  * And `$mdToast.cancel()` will resolve the promise with a Boolean value == 'false'
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#hide
	  *
	  * @description
	  * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the resolved promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM.
	  * The promise is resolved with either a Boolean value == 'true' or the value passed as the
	  * argument to `.hide()`.
	  *
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#cancel
	  *
	  * @description
	  * `DEPRECATED` - The promise returned from opening a toast is used only to notify about the closing of the toast.
	  * As such, there isn't any reason to also allow that promise to be rejected,
	  * since it's not clear what the difference between resolve and reject would be.
	  *
	  * Hide the existing toast and reject the promise returned from
	  * `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the rejected promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM
	  * The promise is resolved with a Boolean value == 'false'.
	  *
	  */
	
	function MdToastProvider($$interimElementProvider) {
	  // Differentiate promise resolves: hide timeout (value == true) and hide action clicks (value == ok).
	  toastDefaultOptions.$inject = ["$animate", "$mdToast", "$mdUtil", "$mdMedia"];
	  var ACTION_RESOLVE = 'ok';
	
	  var activeToastContent;
	  var $mdToast = $$interimElementProvider('$mdToast')
	    .setDefaults({
	      methods: ['position', 'hideDelay', 'capsule', 'parent', 'position', 'toastClass'],
	      options: toastDefaultOptions
	    })
	    .addPreset('simple', {
	      argOption: 'textContent',
	      methods: ['textContent', 'content', 'action', 'highlightAction', 'highlightClass', 'theme', 'parent' ],
	      options: /* @ngInject */ ["$mdToast", "$mdTheming", function($mdToast, $mdTheming) {
	        return {
	          template:
	            '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">' +
	            '  <div class="md-toast-content">' +
	            '    <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">' +
	            '      {{ toast.content }}' +
	            '    </span>' +
	            '    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ' +
	            '        ng-class="highlightClasses">' +
	            '      {{ toast.action }}' +
	            '    </md-button>' +
	            '  </div>' +
	            '</md-toast>',
	          controller: /* @ngInject */ ["$scope", function mdToastCtrl($scope) {
	            var self = this;
	
	            if (self.highlightAction) {
	              $scope.highlightClasses = [
	                'md-highlight',
	                self.highlightClass
	              ]
	            }
	
	            $scope.$watch(function() { return activeToastContent; }, function() {
	              self.content = activeToastContent;
	            });
	
	            this.resolve = function() {
	              $mdToast.hide( ACTION_RESOLVE );
	            };
	          }],
	          theme: $mdTheming.defaultTheme(),
	          controllerAs: 'toast',
	          bindToController: true
	        };
	      }]
	    })
	    .addMethod('updateTextContent', updateTextContent)
	    .addMethod('updateContent', updateTextContent);
	
	    function updateTextContent(newContent) {
	      activeToastContent = newContent;
	    }
	
	    return $mdToast;
	
	  /* @ngInject */
	  function toastDefaultOptions($animate, $mdToast, $mdUtil, $mdMedia) {
	    var SWIPE_EVENTS = '$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';
	    return {
	      onShow: onShow,
	      onRemove: onRemove,
	      toastClass: '',
	      position: 'bottom left',
	      themable: true,
	      hideDelay: 3000,
	      autoWrap: true,
	      transformTemplate: function(template, options) {
	        var shouldAddWrapper = options.autoWrap && template && !/md-toast-content/g.test(template);
	
	        if (shouldAddWrapper) {
	          // Root element of template will be <md-toast>. We need to wrap all of its content inside of
	          // of <div class="md-toast-content">. All templates provided here should be static, developer-controlled
	          // content (meaning we're not attempting to guard against XSS).
	          var templateRoot = document.createElement('md-template');
	          templateRoot.innerHTML = template;
	
	          // Iterate through all root children, to detect possible md-toast directives.
	          for (var i = 0; i < templateRoot.children.length; i++) {
	            if (templateRoot.children[i].nodeName === 'MD-TOAST') {
	              var wrapper = angular.element('<div class="md-toast-content">');
	
	              // Wrap the children of the `md-toast` directive in jqLite, to be able to append multiple
	              // nodes with the same execution.
	              wrapper.append(angular.element(templateRoot.children[i].childNodes));
	
	              // Append the new wrapped element to the `md-toast` directive.
	              templateRoot.children[i].appendChild(wrapper[0]);
	            }
	          }
	
	          // We have to return the innerHTMl, because we do not want to have the `md-template` element to be
	          // the root element of our interimElement.
	          return templateRoot.innerHTML;
	        }
	
	        return template || '';
	      }
	    };
	
	    function onShow(scope, element, options) {
	      activeToastContent = options.textContent || options.content; // support deprecated #content method
	
	      var isSmScreen = !$mdMedia('gt-sm');
	
	      element = $mdUtil.extractElementByName(element, 'md-toast', true);
	      options.element = element;
	
	      options.onSwipe = function(ev, gesture) {
	        //Add the relevant swipe class to the element so it can animate correctly
	        var swipe = ev.type.replace('$md.','');
	        var direction = swipe.replace('swipe', '');
	
	        // If the swipe direction is down/up but the toast came from top/bottom don't fade away
	        // Unless the screen is small, then the toast always on bottom
	        if ((direction === 'down' && options.position.indexOf('top') != -1 && !isSmScreen) ||
	            (direction === 'up' && (options.position.indexOf('bottom') != -1 || isSmScreen))) {
	          return;
	        }
	
	        if ((direction === 'left' || direction === 'right') && isSmScreen) {
	          return;
	        }
	
	        element.addClass('md-' + swipe);
	        $mdUtil.nextTick($mdToast.cancel);
	      };
	      options.openClass = toastOpenClass(options.position);
	
	      element.addClass(options.toastClass);
	
	      // 'top left' -> 'md-top md-left'
	      options.parent.addClass(options.openClass);
	
	      // static is the default position
	      if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	        options.parent.css('position', 'relative');
	      }
	
	      element.on(SWIPE_EVENTS, options.onSwipe);
	      element.addClass(isSmScreen ? 'md-bottom' : options.position.split(' ').map(function(pos) {
	        return 'md-' + pos;
	      }).join(' '));
	
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      return $animate.enter(element, options.parent).then(function() {
	        if (options.parent) options.parent.removeClass('md-toast-animating');
	      });
	    }
	
	    function onRemove(scope, element, options) {
	      element.off(SWIPE_EVENTS, options.onSwipe);
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      if (options.openClass) options.parent.removeClass(options.openClass);
	
	      return ((options.$destroy == true) ? element.remove() : $animate.leave(element))
	        .then(function () {
	          if (options.parent) options.parent.removeClass('md-toast-animating');
	          if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	            options.parent.css('position', '');
	          }
	        });
	    }
	
	    function toastOpenClass(position) {
	      // For mobile, always open full-width on bottom
	      if (!$mdMedia('gt-xs')) {
	        return 'md-toast-open-bottom';
	      }
	
	      return 'md-toast-open-' +
	        (position.indexOf('top') > -1 ? 'top' : 'bottom');
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.toolbar
	 */
	mdToolbarDirective.$inject = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate"];
	angular.module('material.components.toolbar', [
	  'material.core',
	  'material.components.content'
	])
	  .directive('mdToolbar', mdToolbarDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdToolbar
	 * @module material.components.toolbar
	 * @restrict E
	 * @description
	 * `md-toolbar` is used to place a toolbar in your app.
	 *
	 * Toolbars are usually used above a content area to display the title of the
	 * current page, and show relevant action buttons for that page.
	 *
	 * You can change the height of the toolbar by adding either the
	 * `md-medium-tall` or `md-tall` class to the toolbar.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="column" layout-fill>
	 *   <md-toolbar>
	 *
	 *     <div class="md-toolbar-tools">
	 *       <span>My App's Title</span>
	 *
	 *       <!-- fill up the space between left and right area -->
	 *       <span flex></span>
	 *
	 *       <md-button>
	 *         Right Bar Button
	 *       </md-button>
	 *     </div>
	 *
	 *   </md-toolbar>
	 *   <md-content>
	 *     Hello!
	 *   </md-content>
	 * </div>
	 * </hljs>
	 *
	 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
	 * the user scrolls down, and reveal itself as the user scrolls up.
	 *
	 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
	 * `md-content` element, placed before it. See the scroll shrink demo._
	 *
	 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
	 * initialization, it does not watch for scope changes._
	 *
	 *
	 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
	 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
	 * at one fourth the rate at which the user scrolls down. Default 0.5.
	 */
	
	function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate) {
	  var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');
	
	  return {
	    template: '',
	    restrict: 'E',
	
	    link: function(scope, element, attr) {
	
	      element.addClass('_md');     // private md component indicator for styling
	      $mdTheming(element);
	
	      $mdUtil.nextTick(function () {
	        element.addClass('_md-toolbar-transitions');     // adding toolbar transitions after digest
	      }, false);
	
	      if (angular.isDefined(attr.mdScrollShrink)) {
	        setupScrollShrink();
	      }
	
	      function setupScrollShrink() {
	
	        var toolbarHeight;
	        var contentElement;
	        var disableScrollShrink = angular.noop;
	
	        // Current "y" position of scroll
	        // Store the last scroll top position
	        var y = 0;
	        var prevScrollTop = 0;
	        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;
	
	        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
	        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);
	
	        // Wait for $mdContentLoaded event from mdContent directive.
	        // If the mdContent element is a sibling of our toolbar, hook it up
	        // to scroll events.
	
	        scope.$on('$mdContentLoaded', onMdContentLoad);
	
	        // If the toolbar is used inside an ng-if statement, we may miss the
	        // $mdContentLoaded event, so we attempt to fake it if we have a
	        // md-content close enough.
	
	        attr.$observe('mdScrollShrink', onChangeScrollShrink);
	
	        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
	        // and not wait for $mdUtil.debounce to happen
	
	        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
	        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }
	
	        // If the scope is destroyed (which could happen with ng-if), make sure
	        // to disable scroll shrinking again
	
	        scope.$on('$destroy', disableScrollShrink);
	
	        /**
	         *
	         */
	        function onChangeScrollShrink(shrinkWithScroll) {
	          var closestContent = element.parent().find('md-content');
	
	          // If we have a content element, fake the call; this might still fail
	          // if the content element isn't a sibling of the toolbar
	
	          if (!contentElement && closestContent.length) {
	            onMdContentLoad(null, closestContent);
	          }
	
	          // Evaluate the expression
	          shrinkWithScroll = scope.$eval(shrinkWithScroll);
	
	          // Disable only if the attribute's expression evaluates to false
	          if (shrinkWithScroll === false) {
	            disableScrollShrink();
	          } else {
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onMdContentLoad($event, newContentEl) {
	          // Toolbar and content must be siblings
	          if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
	            // unhook old content event listener if exists
	            if (contentElement) {
	              contentElement.off('scroll', debouncedContentScroll);
	            }
	
	            contentElement = newContentEl;
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onContentScroll(e) {
	          var scrollTop = e ? e.target.scrollTop : prevScrollTop;
	
	          debouncedUpdateHeight();
	
	          y = Math.min(
	            toolbarHeight / shrinkSpeedFactor,
	            Math.max(0, y + scrollTop - prevScrollTop)
	          );
	
	          element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
	          contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));
	
	          prevScrollTop = scrollTop;
	
	          $mdUtil.nextTick(function() {
	            var hasWhiteFrame = element.hasClass('md-whiteframe-z1');
	
	            if (hasWhiteFrame && !y) {
	              $animate.removeClass(element, 'md-whiteframe-z1');
	            } else if (!hasWhiteFrame && y) {
	              $animate.addClass(element, 'md-whiteframe-z1');
	            }
	          });
	
	        }
	
	        /**
	         *
	         */
	        function enableScrollShrink() {
	          if (!contentElement)     return angular.noop;           // no md-content
	
	          contentElement.on('scroll', debouncedContentScroll);
	          contentElement.attr('scroll-shrink', 'true');
	
	          $mdUtil.nextTick(updateToolbarHeight, false);
	
	          return function disableScrollShrink() {
	            contentElement.off('scroll', debouncedContentScroll);
	            contentElement.attr('scroll-shrink', 'false');
	
	            updateToolbarHeight();
	          };
	        }
	
	        /**
	         *
	         */
	        function updateToolbarHeight() {
	          toolbarHeight = element.prop('offsetHeight');
	          // Add a negative margin-top the size of the toolbar to the content el.
	          // The content will start transformed down the toolbarHeight amount,
	          // so everything looks normal.
	          //
	          // As the user scrolls down, the content will be transformed up slowly
	          // to put the content underneath where the toolbar was.
	          var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';
	
	          contentElement.css({
	            "margin-top": margin,
	            "margin-bottom": margin
	          });
	
	          onContentScroll();
	        }
	
	      }
	
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tooltip
	 */
	MdTooltipDirective.$inject = ["$timeout", "$window", "$$rAF", "$document", "$mdUtil", "$mdTheming", "$rootElement", "$animate", "$q", "$interpolate"];
	angular
	    .module('material.components.tooltip', [ 'material.core' ])
	    .directive('mdTooltip', MdTooltipDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdTooltip
	 * @module material.components.tooltip
	 * @description
	 * Tooltips are used to describe elements that are interactive and primarily graphical (not textual).
	 *
	 * Place a `<md-tooltip>` as a child of the element it describes.
	 *
	 * A tooltip will activate when the user focuses, hovers over, or touches the parent.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-button class="md-fab md-accent" aria-label="Play">
	 *   <md-tooltip>
	 *     Play Music
	 *   </md-tooltip>
	 *   <md-icon icon="img/icons/ic_play_arrow_24px.svg"></md-icon>
	 * </md-button>
	 * </hljs>
	 *
	 * @param {expression=} md-visible Boolean bound to whether the tooltip is currently visible.
	 * @param {number=} md-delay How many milliseconds to wait to show the tooltip after the user focuses, hovers, or touches the
	 * parent. Defaults to 0ms on non-touch devices and 75ms on touch.
	 * @param {boolean=} md-autohide If present or provided with a boolean value, the tooltip will hide on mouse leave, regardless of focus
	 * @param {string=} md-direction Which direction would you like the tooltip to go?  Supports left, right, top, and bottom.  Defaults to bottom.
	 */
	function MdTooltipDirective($timeout, $window, $$rAF, $document, $mdUtil, $mdTheming, $rootElement,
	                            $animate, $q, $interpolate) {
	
	  var ENTER_EVENTS = 'focus touchstart mouseenter';
	  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
	  var SHOW_CLASS = 'md-show';
	  var TOOLTIP_SHOW_DELAY = 0;
	  var TOOLTIP_WINDOW_EDGE_SPACE = 8;
	
	  return {
	    restrict: 'E',
	    transclude: true,
	    priority: 210, // Before ngAria
	    template: '<div class="md-content _md" ng-transclude></div>',
	    scope: {
	      delay: '=?mdDelay',
	      visible: '=?mdVisible',
	      autohide: '=?mdAutohide',
	      direction: '@?mdDirection'    // only expect raw or interpolated string value; not expression
	    },
	    compile: function(tElement, tAttr) {
	      if (!tAttr.mdDirection) {
	        tAttr.$set('mdDirection', 'bottom');
	      }
	
	      return postLink;
	    }
	  };
	
	  function postLink(scope, element, attr) {
	
	    $mdTheming(element);
	
	    var parent        = $mdUtil.getParentWithPointerEvents(element),
	        content       = angular.element(element[0].getElementsByClassName('md-content')[0]),
	        tooltipParent = angular.element(document.body),
	        showTimeout   = null,
	        debouncedOnResize = $$rAF.throttle(function () { updatePosition(); });
	
	    if ($animate.pin) $animate.pin(element, parent);
	
	    // Initialize element
	
	    setDefaults();
	    manipulateElement();
	    bindEvents();
	
	    // Default origin transform point is 'center top'
	    // positionTooltip() is always relative to center top
	    updateContentOrigin();
	
	    configureWatchers();
	    addAriaLabel();
	
	
	    function setDefaults () {
	      scope.delay = scope.delay || TOOLTIP_SHOW_DELAY;
	    }
	
	    function updateContentOrigin() {
	      var origin = 'center top';
	      switch (scope.direction) {
	        case 'left'  : origin =  'right center';  break;
	        case 'right' : origin =  'left center';   break;
	        case 'top'   : origin =  'center bottom'; break;
	        case 'bottom': origin =  'center top';    break;
	      }
	      content.css('transform-origin', origin);
	    }
	
	    function onVisibleChanged (isVisible) {
	      if (isVisible) showTooltip();
	      else hideTooltip();
	    }
	
	    function configureWatchers () {
	      if (element[0] && 'MutationObserver' in $window) {
	        var attributeObserver = new MutationObserver(function(mutations) {
	          mutations
	            .forEach(function (mutation) {
	              if (mutation.attributeName === 'md-visible') {
	                if (!scope.visibleWatcher)
	                  scope.visibleWatcher = scope.$watch('visible', onVisibleChanged );
	              }
	              if (mutation.attributeName === 'md-direction') {
	                updatePosition(scope.direction);
	              }
	            });
	        });
	
	        attributeObserver.observe(element[0], { attributes: true });
	
	        // build watcher only if mdVisible is being used
	        if (attr.hasOwnProperty('mdVisible')) {
	          scope.visibleWatcher = scope.$watch('visible', onVisibleChanged );
	        }
	      } else { // MutationObserver not supported
	        scope.visibleWatcher = scope.$watch('visible', onVisibleChanged );
	        scope.$watch('direction', updatePosition );
	      }
	
	      var onElementDestroy = function() {
	        scope.$destroy();
	      };
	
	      // Clean up if the element or parent was removed via jqLite's .remove.
	      // A couple of notes:
	      // - In these cases the scope might not have been destroyed, which is why we
	      // destroy it manually. An example of this can be having `md-visible="false"` and
	      // adding tooltips while they're invisible. If `md-visible` becomes true, at some
	      // point, you'd usually get a lot of inputs.
	      // - We use `.one`, not `.on`, because this only needs to fire once. If we were
	      // using `.on`, it would get thrown into an infinite loop.
	      // - This kicks off the scope's `$destroy` event which finishes the cleanup.
	      element.one('$destroy', onElementDestroy);
	      parent.one('$destroy', onElementDestroy);
	      scope.$on('$destroy', function() {
	        setVisible(false);
	        element.remove();
	        attributeObserver && attributeObserver.disconnect();
	      });
	
	      // Updates the aria-label when the element text changes. This watch
	      // doesn't need to be set up if the element doesn't have any data
	      // bindings.
	      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
	        scope.$watch(function() {
	          return element.text().trim();
	        }, addAriaLabel);
	      }
	    }
	
	    function addAriaLabel (override) {
	      if ((override || !parent.attr('aria-label')) && !parent.text().trim()) {
	        var rawText = override || element.text().trim();
	        var interpolatedText = $interpolate(rawText)(parent.scope());
	        parent.attr('aria-label', interpolatedText);
	      }
	    }
	
	    function manipulateElement () {
	      element.detach();
	      element.attr('role', 'tooltip');
	    }
	
	    function bindEvents () {
	      var mouseActive = false;
	
	      // add an mutationObserver when there is support for it
	      // and the need for it in the form of viable host(parent[0])
	      if (parent[0] && 'MutationObserver' in $window) {
	        // use an mutationObserver to tackle #2602
	        var attributeObserver = new MutationObserver(function(mutations) {
	          if (mutations.some(function (mutation) {
	              return (mutation.attributeName === 'disabled' && parent[0].disabled);
	            })) {
	              $mdUtil.nextTick(function() {
	                setVisible(false);
	              });
	          }
	        });
	
	        attributeObserver.observe(parent[0], { attributes: true});
	      }
	
	      // Store whether the element was focused when the window loses focus.
	      var windowBlurHandler = function() {
	        elementFocusedOnWindowBlur = document.activeElement === parent[0];
	      };
	      var elementFocusedOnWindowBlur = false;
	
	      function windowScrollHandler() {
	        setVisible(false);
	      }
	
	      angular.element($window)
	        .on('blur', windowBlurHandler)
	        .on('resize', debouncedOnResize);
	
	      document.addEventListener('scroll', windowScrollHandler, true);
	      scope.$on('$destroy', function() {
	        angular.element($window)
	          .off('blur', windowBlurHandler)
	          .off('resize', debouncedOnResize);
	
	        parent
	          .off(ENTER_EVENTS, enterHandler)
	          .off(LEAVE_EVENTS, leaveHandler)
	          .off('mousedown', mousedownHandler);
	
	        // Trigger the handler in case any the tooltip was still visible.
	        leaveHandler();
	        document.removeEventListener('scroll', windowScrollHandler, true);
	        attributeObserver && attributeObserver.disconnect();
	      });
	
	      var enterHandler = function(e) {
	        // Prevent the tooltip from showing when the window is receiving focus.
	        if (e.type === 'focus' && elementFocusedOnWindowBlur) {
	          elementFocusedOnWindowBlur = false;
	        } else if (!scope.visible) {
	          parent.on(LEAVE_EVENTS, leaveHandler);
	          setVisible(true);
	
	          // If the user is on a touch device, we should bind the tap away after
	          // the `touched` in order to prevent the tooltip being removed immediately.
	          if (e.type === 'touchstart') {
	            parent.one('touchend', function() {
	              $mdUtil.nextTick(function() {
	                $document.one('touchend', leaveHandler);
	              }, false);
	            });
	          }
	        }
	      };
	      var leaveHandler = function () {
	        var autohide = scope.hasOwnProperty('autohide') ? scope.autohide : attr.hasOwnProperty('mdAutohide');
	
	        if (autohide || mouseActive || $document[0].activeElement !== parent[0]) {
	          // When a show timeout is currently in progress, then we have to cancel it.
	          // Otherwise the tooltip will remain showing without focus or hover.
	          if (showTimeout) {
	            $timeout.cancel(showTimeout);
	            setVisible.queued = false;
	            showTimeout = null;
	          }
	
	          parent.off(LEAVE_EVENTS, leaveHandler);
	          parent.triggerHandler('blur');
	          setVisible(false);
	        }
	        mouseActive = false;
	      };
	      var mousedownHandler = function() {
	        mouseActive = true;
	      };
	
	      // to avoid `synthetic clicks` we listen to mousedown instead of `click`
	      parent.on('mousedown', mousedownHandler);
	      parent.on(ENTER_EVENTS, enterHandler);
	    }
	
	    function setVisible (value) {
	      // break if passed value is already in queue or there is no queue and passed value is current in the scope
	      if (setVisible.queued && setVisible.value === !!value || !setVisible.queued && scope.visible === !!value) return;
	      setVisible.value = !!value;
	
	      if (!setVisible.queued) {
	        if (value) {
	          setVisible.queued = true;
	          showTimeout = $timeout(function() {
	            scope.visible = setVisible.value;
	            setVisible.queued = false;
	            showTimeout = null;
	
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(scope.visible);
	            }
	          }, scope.delay);
	        } else {
	          $mdUtil.nextTick(function() {
	            scope.visible = false;
	            if (!scope.visibleWatcher)
	              onVisibleChanged(false);
	          });
	        }
	      }
	    }
	
	    function showTooltip() {
	      //  Do not show the tooltip if the text is empty.
	      if (!element[0].textContent.trim()) return;
	
	      // Insert the element and position at top left, so we can get the position
	      // and check if we should display it
	      element.css({top: 0, left: 0});
	      tooltipParent.append(element);
	
	      // Check if we should display it or not.
	      // This handles hide-* and show-* along with any user defined css
	      if ( $mdUtil.hasComputedStyle(element, 'display', 'none')) {
	        scope.visible = false;
	        element.detach();
	        return;
	      }
	
	      updatePosition();
	
	      $animate.addClass(content, SHOW_CLASS).then(function() {
	        element.addClass(SHOW_CLASS);
	      });
	    }
	
	    function hideTooltip() {
	      $animate.removeClass(content, SHOW_CLASS).then(function(){
	        element.removeClass(SHOW_CLASS);
	        if (!scope.visible) element.detach();
	      });
	    }
	
	    function updatePosition() {
	      if ( !scope.visible ) return;
	
	      updateContentOrigin();
	      positionTooltip();
	    }
	
	    function positionTooltip() {
	      var tipRect = $mdUtil.offsetRect(element, tooltipParent);
	      var parentRect = $mdUtil.offsetRect(parent, tooltipParent);
	      var newPosition = getPosition(scope.direction);
	      var offsetParent = element.prop('offsetParent');
	
	      // If the user provided a direction, just nudge the tooltip onto the screen
	      // Otherwise, recalculate based on 'top' since default is 'bottom'
	      if (scope.direction) {
	        newPosition = fitInParent(newPosition);
	      } else if (offsetParent && newPosition.top > offsetParent.scrollHeight - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE) {
	        newPosition = fitInParent(getPosition('top'));
	      }
	
	      element.css({
	        left: newPosition.left + 'px',
	        top: newPosition.top + 'px'
	      });
	
	      function fitInParent (pos) {
	        var newPosition = { left: pos.left, top: pos.top };
	        newPosition.left = Math.min( newPosition.left, tooltipParent.prop('scrollWidth') - tipRect.width - TOOLTIP_WINDOW_EDGE_SPACE );
	        newPosition.left = Math.max( newPosition.left, TOOLTIP_WINDOW_EDGE_SPACE );
	        newPosition.top  = Math.min( newPosition.top,  tooltipParent.prop('scrollHeight') - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE );
	        newPosition.top  = Math.max( newPosition.top,  TOOLTIP_WINDOW_EDGE_SPACE );
	        return newPosition;
	      }
	
	      function getPosition (dir) {
	        return dir === 'left'
	          ? { left: parentRect.left - tipRect.width - TOOLTIP_WINDOW_EDGE_SPACE,
	              top: parentRect.top + parentRect.height / 2 - tipRect.height / 2 }
	          : dir === 'right'
	          ? { left: parentRect.left + parentRect.width + TOOLTIP_WINDOW_EDGE_SPACE,
	              top: parentRect.top + parentRect.height / 2 - tipRect.height / 2 }
	          : dir === 'top'
	          ? { left: parentRect.left + parentRect.width / 2 - tipRect.width / 2,
	              top: parentRect.top - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE }
	          : { left: parentRect.left + parentRect.width / 2 - tipRect.width / 2,
	              top: parentRect.top + parentRect.height + TOOLTIP_WINDOW_EDGE_SPACE };
	      }
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.virtualRepeat
	 */
	VirtualRepeatContainerController.$inject = ["$$rAF", "$mdUtil", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs"];
	VirtualRepeatController.$inject = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];
	VirtualRepeatDirective.$inject = ["$parse"];
	angular.module('material.components.virtualRepeat', [
	  'material.core',
	  'material.components.showHide'
	])
	.directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
	.directive('mdVirtualRepeat', VirtualRepeatDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeatContainer
	 * @module material.components.virtualRepeat
	 * @restrict E
	 * @description
	 * `md-virtual-repeat-container` provides the scroll container for md-virtual-repeat.
	 *
	 * VirtualRepeat is a limited substitute for ng-repeat that renders only
	 * enough DOM nodes to fill the container and recycling them as the user scrolls.
	 *
	 * Once an element is not visible anymore, the VirtualRepeat recycles it and will reuse it for
	 * another visible item by replacing the previous dataset with the new one.
	 *
	 * ### Common Issues
	 *
	 * > When having one-time bindings inside of the view template, the VirtualRepeat will not properly
	 * > update the bindings for new items, since the view will be recycled.
	 *
	 * ### Notes
	 *
	 * > The VirtualRepeat is a similar implementation to the Android
	 * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html)
	 *
	 * <!-- This comment forces a break between blockquotes //-->
	 *
	 * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">VirtualRepeat</a>
	 * documentation for more information.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-virtual-repeat-container md-top-index="topIndex">
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
	 *     container to $scope. It can both read and set the scroll position.
	 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally
	 *     (defaults to orientation and scrolling vertically).
	 * @param {boolean=} md-auto-shrink When present, the container will shrink to fit
	 *     the number of items when that number is less than its original size.
	 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
	 *     will shrink to (default: 0).
	 */
	function VirtualRepeatContainerDirective() {
	  return {
	    controller: VirtualRepeatContainerController,
	    template: virtualRepeatContainerTemplate,
	    compile: function virtualRepeatContainerCompile($element, $attrs) {
	      $element
	          .addClass('md-virtual-repeat-container')
	          .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
	              ? 'md-orient-horizontal'
	              : 'md-orient-vertical');
	    }
	  };
	}
	
	
	function virtualRepeatContainerTemplate($element) {
	  return '<div class="md-virtual-repeat-scroller">' +
	    '<div class="md-virtual-repeat-sizer"></div>' +
	    '<div class="md-virtual-repeat-offsetter">' +
	      $element[0].innerHTML +
	    '</div></div>';
	}
	
	/**
	 * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
	 * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
	 * *compute* this value, but Firefox always reports an element to have a size of zero if it
	 * goes over the max, meaning that we'd have to binary search for the value.
	 * @const {number}
	 */
	var MAX_ELEMENT_SIZE = 1533917;
	
	/**
	 * Number of additional elements to render above and below the visible area inside
	 * of the virtual repeat container. A higher number results in less flicker when scrolling
	 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
	 * @const {number}
	 */
	var NUM_EXTRA = 3;
	
	/** @ngInject */
	function VirtualRepeatContainerController(
	    $$rAF, $mdUtil, $parse, $rootScope, $window, $scope, $element, $attrs) {
	  this.$rootScope = $rootScope;
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  /** @type {number} The width or height of the container */
	  this.size = 0;
	  /** @type {number} The scroll width or height of the scroller */
	  this.scrollSize = 0;
	  /** @type {number} The scrollLeft or scrollTop of the scroller */
	  this.scrollOffset = 0;
	  /** @type {boolean} Whether the scroller is oriented horizontally */
	  this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
	  /** @type {!VirtualRepeatController} The repeater inside of this container */
	  this.repeater = null;
	  /** @type {boolean} Whether auto-shrink is enabled */
	  this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
	  /** @type {number} Minimum number of items to auto-shrink to */
	  this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
	  /** @type {?number} Original container size when shrank */
	  this.originalSize = null;
	  /** @type {number} Amount to offset the total scroll size by. */
	  this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
	  /** @type {?string} height or width element style on the container prior to auto-shrinking. */
	  this.oldElementSize = null;
	
	  if (this.$attrs.mdTopIndex) {
	    /** @type {function(angular.Scope): number} Binds to topIndex on Angular scope */
	    this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
	    /** @type {number} The index of the item that is at the top of the scroll container */
	    this.topIndex = this.bindTopIndex(this.$scope);
	
	    if (!angular.isDefined(this.topIndex)) {
	      this.topIndex = 0;
	      this.bindTopIndex.assign(this.$scope, 0);
	    }
	
	    this.$scope.$watch(this.bindTopIndex, angular.bind(this, function(newIndex) {
	      if (newIndex !== this.topIndex) {
	        this.scrollToIndex(newIndex);
	      }
	    }));
	  } else {
	    this.topIndex = 0;
	  }
	
	  this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	  this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
	  this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');
	
	  // After the dom stablizes, measure the initial size of the container and
	  // make a best effort at re-measuring as it changes.
	  var boundUpdateSize = angular.bind(this, this.updateSize);
	
	  $$rAF(angular.bind(this, function() {
	    boundUpdateSize();
	
	    var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
	    var jWindow = angular.element($window);
	
	    // Make one more attempt to get the size if it is 0.
	    // This is not by any means a perfect approach, but there's really no
	    // silver bullet here.
	    if (!this.size) {
	      debouncedUpdateSize();
	    }
	
	    jWindow.on('resize', debouncedUpdateSize);
	    $scope.$on('$destroy', function() {
	      jWindow.off('resize', debouncedUpdateSize);
	    });
	
	    $scope.$emit('$md-resize-enable');
	    $scope.$on('$md-resize', boundUpdateSize);
	  }));
	}
	
	
	/** Called by the md-virtual-repeat inside of the container at startup. */
	VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
	  this.repeater = repeaterCtrl;
	
	  angular.element(this.scroller)
	      .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
	};
	
	
	/** @return {boolean} Whether the container is configured for horizontal scrolling. */
	VirtualRepeatContainerController.prototype.isHorizontal = function() {
	  return this.horizontal;
	};
	
	
	/** @return {number} The size (width or height) of the container. */
	VirtualRepeatContainerController.prototype.getSize = function() {
	  return this.size;
	};
	
	
	/**
	 * Resizes the container.
	 * @private
	 * @param {number} size The new size to set.
	 */
	VirtualRepeatContainerController.prototype.setSize_ = function(size) {
	  var dimension = this.getDimensionName_();
	
	  this.size = size;
	  this.$element[0].style[dimension] = size + 'px';
	};
	
	
	VirtualRepeatContainerController.prototype.unsetSize_ = function() {
	  this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
	  this.oldElementSize = null;
	};
	
	
	/** Instructs the container to re-measure its size. */
	VirtualRepeatContainerController.prototype.updateSize = function() {
	  // If the original size is already determined, we can skip the update.
	  if (this.originalSize) return;
	
	  this.size = this.isHorizontal()
	      ? this.$element[0].clientWidth
	      : this.$element[0].clientHeight;
	
	  // Recheck the scroll position after updating the size. This resolves
	  // problems that can result if the scroll position was measured while the
	  // element was display: none or detached from the document.
	  this.handleScroll_();
	
	  this.repeater && this.repeater.containerUpdated();
	};
	
	
	/** @return {number} The container's scrollHeight or scrollWidth. */
	VirtualRepeatContainerController.prototype.getScrollSize = function() {
	  return this.scrollSize;
	};
	
	
	VirtualRepeatContainerController.prototype.getDimensionName_ = function() {
	  return this.isHorizontal() ? 'width' : 'height';
	};
	
	
	/**
	 * Sets the scroller element to the specified size.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
	  var dimension =  this.getDimensionName_();
	  var crossDimension = this.isHorizontal() ? 'height' : 'width';
	
	  // Clear any existing dimensions.
	  this.sizer.innerHTML = '';
	
	  // If the size falls within the browser's maximum explicit size for a single element, we can
	  // set the size and be done. Otherwise, we have to create children that add up the the desired
	  // size.
	  if (size < MAX_ELEMENT_SIZE) {
	    this.sizer.style[dimension] = size + 'px';
	  } else {
	    this.sizer.style[dimension] = 'auto';
	    this.sizer.style[crossDimension] = 'auto';
	
	    // Divide the total size we have to render into N max-size pieces.
	    var numChildren = Math.floor(size / MAX_ELEMENT_SIZE);
	
	    // Element template to clone for each max-size piece.
	    var sizerChild = document.createElement('div');
	    sizerChild.style[dimension] = MAX_ELEMENT_SIZE + 'px';
	    sizerChild.style[crossDimension] = '1px';
	
	    for (var i = 0; i < numChildren; i++) {
	      this.sizer.appendChild(sizerChild.cloneNode(false));
	    }
	
	    // Re-use the element template for the remainder.
	    sizerChild.style[dimension] = (size - (numChildren * MAX_ELEMENT_SIZE)) + 'px';
	    this.sizer.appendChild(sizerChild);
	  }
	};
	
	
	/**
	 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
	  var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());
	
	  if (this.autoShrink && shrinkSize !== this.size) {
	    if (this.oldElementSize === null) {
	      this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
	    }
	
	    var currentSize = this.originalSize || this.size;
	
	    if (!currentSize || shrinkSize < currentSize) {
	      if (!this.originalSize) {
	        this.originalSize = this.size;
	      }
	
	      // Now we update the containers size, because shrinking is enabled.
	      this.setSize_(shrinkSize);
	    } else if (this.originalSize !== null) {
	      // Set the size back to our initial size.
	      this.unsetSize_();
	
	      var _originalSize = this.originalSize;
	      this.originalSize = null;
	
	      // We determine the repeaters size again, if the original size was zero.
	      // The originalSize needs to be null, to be able to determine the size.
	      if (!_originalSize) this.updateSize();
	
	      // Apply the original size or the determined size back to the container, because
	      // it has been overwritten before, in the shrink block.
	      this.setSize_(_originalSize || this.size);
	    }
	
	    this.repeater.containerUpdated();
	  }
	};
	
	
	/**
	 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
	 * its item count and item size.
	 * @param {number} itemsSize The total size of the items.
	 */
	VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
	  var size = itemsSize + this.offsetSize;
	  if (this.scrollSize === size) return;
	
	  this.sizeScroller_(size);
	  this.autoShrink_(size);
	  this.scrollSize = size;
	};
	
	
	/** @return {number} The container's current scroll offset. */
	VirtualRepeatContainerController.prototype.getScrollOffset = function() {
	  return this.scrollOffset;
	};
	
	/**
	 * Scrolls to a given scrollTop position.
	 * @param {number} position
	 */
	VirtualRepeatContainerController.prototype.scrollTo = function(position) {
	  this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
	  this.handleScroll_();
	};
	
	/**
	 * Scrolls the item with the given index to the top of the scroll container.
	 * @param {number} index
	 */
	VirtualRepeatContainerController.prototype.scrollToIndex = function(index) {
	  var itemSize = this.repeater.getItemSize();
	  var itemsLength = this.repeater.itemsLength;
	  if(index > itemsLength) {
	    index = itemsLength - 1;
	  }
	  this.scrollTo(itemSize * index);
	};
	
	VirtualRepeatContainerController.prototype.resetScroll = function() {
	  this.scrollTo(0);
	};
	
	
	VirtualRepeatContainerController.prototype.handleScroll_ = function() {
	  var doc = angular.element(document)[0];
	  var ltr = doc.dir != 'rtl' && doc.body.dir != 'rtl';
	  if(!ltr && !this.maxSize) {
	    this.scroller.scrollLeft = this.scrollSize;
	    this.maxSize = this.scroller.scrollLeft;
	  }
	  var offset = this.isHorizontal() ?
	      (ltr?this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
	      : this.scroller.scrollTop;
	  if (offset === this.scrollOffset || offset > this.scrollSize - this.size) return;
	
	  var itemSize = this.repeater.getItemSize();
	  if (!itemSize) return;
	
	  var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);
	
	  var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
	      (!this.isHorizontal() || ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';
	
	  this.scrollOffset = offset;
	  this.offsetter.style.webkitTransform = transform;
	  this.offsetter.style.transform = transform;
	
	  if (this.bindTopIndex) {
	    var topIndex = Math.floor(offset / itemSize);
	    if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
	      this.topIndex = topIndex;
	      this.bindTopIndex.assign(this.$scope, topIndex);
	      if (!this.$rootScope.$$phase) this.$scope.$digest();
	    }
	  }
	
	  this.repeater.containerUpdated();
	};
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeat
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @priority 1000
	 * @description
	 * `md-virtual-repeat` specifies an element to repeat using virtual scrolling.
	 *
	 * Virtual repeat is a limited substitute for ng-repeat that renders only
	 * enough dom nodes to fill the container and recycling them as the user scrolls.
	 * Arrays, but not objects are supported for iteration.
	 * Track by, as alias, and (key, value) syntax are not supported.
	 *
	 * > <b>Note:</b> Please also review the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
	 *   for more information.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-virtual-repeat-container>
	 *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 *
	 * <md-virtual-repeat-container md-orient-horizontal>
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {number=} md-item-size The height or width of the repeated elements (which must be
	 *   identical for each element). Optional. Will attempt to read the size from the dom if missing,
	 *   but still assumes that all repeated nodes have same height or width.
	 * @param {string=} md-extra-name Evaluates to an additional name to which the current iterated item
	 *   can be assigned on the repeated scope (needed for use in `md-autocomplete`).
	 * @param {boolean=} md-on-demand When present, treats the md-virtual-repeat argument as an object
	 *   that can fetch rows rather than an array.
	 *
	 *   **NOTE:** This object must implement the following interface with two (2) methods:
	 *
	 *   - `getItemAtIndex: function(index) [object]` The item at that index or null if it is not yet
	 *     loaded (it should start downloading the item in that case).
	 *   - `getLength: function() [number]` The data length to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 */
	function VirtualRepeatDirective($parse) {
	  return {
	    controller: VirtualRepeatController,
	    priority: 1000,
	    require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
	    restrict: 'A',
	    terminal: true,
	    transclude: 'element',
	    compile: function VirtualRepeatCompile($element, $attrs) {
	      var expression = $attrs.mdVirtualRepeat;
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
	      var repeatName = match[1];
	      var repeatListExpression = $parse(match[2]);
	      var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);
	
	      return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
	        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
	      };
	    }
	  };
	}
	
	
	/** @ngInject */
	function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
	    $$rAF, $mdUtil) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$browser = $browser;
	  this.$document = $document;
	  this.$rootScope = $rootScope;
	  this.$$rAF = $$rAF;
	
	  /** @type {boolean} Whether we are in on-demand mode. */
	  this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
	  /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
	  this.browserCheckUrlChange = $browser.$$checkUrlChange;
	  /** @type {number} Most recent starting repeat index (based on scroll offset) */
	  this.newStartIndex = 0;
	  /** @type {number} Most recent ending repeat index (based on scroll offset) */
	  this.newEndIndex = 0;
	  /** @type {number} Most recent end visible index (based on scroll offset) */
	  this.newVisibleEnd = 0;
	  /** @type {number} Previous starting repeat index (based on scroll offset) */
	  this.startIndex = 0;
	  /** @type {number} Previous ending repeat index (based on scroll offset) */
	  this.endIndex = 0;
	  // TODO: measure width/height of first element from dom if not provided.
	  // getComputedStyle?
	  /** @type {?number} Height/width of repeated elements. */
	  this.itemSize = $scope.$eval($attrs.mdItemSize) || null;
	
	  /** @type {boolean} Whether this is the first time that items are rendered. */
	  this.isFirstRender = true;
	
	  /**
	   * @private {boolean} Whether the items in the list are already being updated. Used to prevent
	   *     nested calls to virtualRepeatUpdate_.
	   */
	  this.isVirtualRepeatUpdating_ = false;
	
	  /** @type {number} Most recently seen length of items. */
	  this.itemsLength = 0;
	
	  /**
	   * @type {!Function} Unwatch callback for item size (when md-items-size is
	   *     not specified), or angular.noop otherwise.
	   */
	  this.unwatchItemSize_ = angular.noop;
	
	  /**
	   * Presently rendered blocks by repeat index.
	   * @type {Object<number, !VirtualRepeatController.Block}
	   */
	  this.blocks = {};
	  /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
	  this.pooledBlocks = [];
	
	  $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
	}
	
	
	/**
	 * An object representing a repeated item.
	 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
	 */
	VirtualRepeatController.Block;
	
	
	/**
	 * Called at startup by the md-virtual-repeat postLink function.
	 * @param {!VirtualRepeatContainerController} container The container's controller.
	 * @param {!Function} transclude The repeated element's bound transclude function.
	 * @param {string} repeatName The left hand side of the repeat expression, indicating
	 *     the name for each item in the array.
	 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
	 *     of the repeat expression. Points to the array to repeat over.
	 * @param {string|undefined} extraName The optional extra repeatName.
	 */
	VirtualRepeatController.prototype.link_ =
	    function(container, transclude, repeatName, repeatListExpression, extraName) {
	  this.container = container;
	  this.transclude = transclude;
	  this.repeatName = repeatName;
	  this.rawRepeatListExpression = repeatListExpression;
	  this.extraName = extraName;
	  this.sized = false;
	
	  this.repeatListExpression = angular.bind(this, this.repeatListExpression_);
	
	  this.container.register(this);
	};
	
	
	/** @private Cleans up unused blocks. */
	VirtualRepeatController.prototype.cleanupBlocks_ = function() {
	  angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
	    block.element.remove();
	  });
	};
	
	
	/** @private Attempts to set itemSize by measuring a repeated element in the dom */
	VirtualRepeatController.prototype.readItemSize_ = function() {
	  if (this.itemSize) {
	    // itemSize was successfully read in a different asynchronous call.
	    return;
	  }
	
	  this.items = this.repeatListExpression(this.$scope);
	  this.parentNode = this.$element[0].parentNode;
	  var block = this.getBlock_(0);
	  if (!block.element[0].parentNode) {
	    this.parentNode.appendChild(block.element[0]);
	  }
	
	  this.itemSize = block.element[0][
	      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;
	
	  this.blocks[0] = block;
	  this.poolBlock_(0);
	
	  if (this.itemSize) {
	    this.containerUpdated();
	  }
	};
	
	
	/**
	 * Returns the user-specified repeat list, transforming it into an array-like
	 * object in the case of infinite scroll/dynamic load mode.
	 * @param {!angular.Scope} The scope.
	 * @return {!Array|!Object} An array or array-like object for iteration.
	 */
	VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
	  var repeatList = this.rawRepeatListExpression(scope);
	
	  if (this.onDemand && repeatList) {
	    var virtualList = new VirtualRepeatModelArrayLike(repeatList);
	    virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
	    return virtualList;
	  } else {
	    return repeatList;
	  }
	};
	
	
	/**
	 * Called by the container. Informs us that the containers scroll or size has
	 * changed.
	 */
	VirtualRepeatController.prototype.containerUpdated = function() {
	  // If itemSize is unknown, attempt to measure it.
	  if (!this.itemSize) {
	    // Make sure to clean up watchers if we can (see #8178)
	    if(this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop){
	      this.unwatchItemSize_();
	    }
	    this.unwatchItemSize_ = this.$scope.$watchCollection(
	        this.repeatListExpression,
	        angular.bind(this, function(items) {
	          if (items && items.length) {
	            this.readItemSize_();
	          }
	        }));
	    if (!this.$rootScope.$$phase) this.$scope.$digest();
	
	    return;
	  } else if (!this.sized) {
	    this.items = this.repeatListExpression(this.$scope);
	  }
	
	  if (!this.sized) {
	    this.unwatchItemSize_();
	    this.sized = true;
	    this.$scope.$watchCollection(this.repeatListExpression,
	        angular.bind(this, function(items, oldItems) {
	          if (!this.isVirtualRepeatUpdating_) {
	            this.virtualRepeatUpdate_(items, oldItems);
	          }
	        }));
	  }
	
	  this.updateIndexes_();
	
	  if (this.newStartIndex !== this.startIndex ||
	      this.newEndIndex !== this.endIndex ||
	      this.container.getScrollOffset() > this.container.getScrollSize()) {
	    if (this.items instanceof VirtualRepeatModelArrayLike) {
	      this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
	    }
	    this.virtualRepeatUpdate_(this.items, this.items);
	  }
	};
	
	
	/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} Size of a repeated item.
	 */
	VirtualRepeatController.prototype.getItemSize = function() {
	  return this.itemSize;
	};
	
	
	/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} Size of a repeated item.
	 */
	VirtualRepeatController.prototype.getItemCount = function() {
	  return this.itemsLength;
	};
	
	
	/**
	 * Updates the order and visible offset of repeated blocks in response to scrolling
	 * or items updates.
	 * @private
	 */
	VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
	  this.isVirtualRepeatUpdating_ = true;
	
	  var itemsLength = items && items.length || 0;
	  var lengthChanged = false;
	
	  // If the number of items shrank, keep the scroll position.
	  if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
	    this.items = items;
	    var previousScrollOffset = this.container.getScrollOffset();
	    this.container.resetScroll();
	    this.container.scrollTo(previousScrollOffset);
	  }
	
	  if (itemsLength !== this.itemsLength) {
	    lengthChanged = true;
	    this.itemsLength = itemsLength;
	  }
	
	  this.items = items;
	  if (items !== oldItems || lengthChanged) {
	    this.updateIndexes_();
	  }
	
	  this.parentNode = this.$element[0].parentNode;
	
	  if (lengthChanged) {
	    this.container.setScrollSize(itemsLength * this.itemSize);
	  }
	
	  if (this.isFirstRender) {
	    this.isFirstRender = false;
	    var startIndex = this.$attrs.mdStartIndex ?
	      this.$scope.$eval(this.$attrs.mdStartIndex) :
	      this.container.topIndex;
	    this.container.scrollToIndex(startIndex);
	  }
	
	  // Detach and pool any blocks that are no longer in the viewport.
	  Object.keys(this.blocks).forEach(function(blockIndex) {
	    var index = parseInt(blockIndex, 10);
	    if (index < this.newStartIndex || index >= this.newEndIndex) {
	      this.poolBlock_(index);
	    }
	  }, this);
	
	  // Add needed blocks.
	  // For performance reasons, temporarily block browser url checks as we digest
	  // the restored block scopes ($$checkUrlChange reads window.location to
	  // check for changes and trigger route change, etc, which we don't need when
	  // trying to scroll at 60fps).
	  this.$browser.$$checkUrlChange = angular.noop;
	
	  var i, block,
	      newStartBlocks = [],
	      newEndBlocks = [];
	
	  // Collect blocks at the top.
	  for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newStartBlocks.push(block);
	  }
	
	  // Update blocks that are already rendered.
	  for (; this.blocks[i] != null; i++) {
	    this.updateBlock_(this.blocks[i], i);
	  }
	  var maxIndex = i - 1;
	
	  // Collect blocks at the end.
	  for (; i < this.newEndIndex; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newEndBlocks.push(block);
	  }
	
	  // Attach collected blocks to the document.
	  if (newStartBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newStartBlocks),
	        this.$element[0].nextSibling);
	  }
	  if (newEndBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newEndBlocks),
	        this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
	  }
	
	  // Restore $$checkUrlChange.
	  this.$browser.$$checkUrlChange = this.browserCheckUrlChange;
	
	  this.startIndex = this.newStartIndex;
	  this.endIndex = this.newEndIndex;
	
	  this.isVirtualRepeatUpdating_ = false;
	};
	
	
	/**
	 * @param {number} index Where the block is to be in the repeated list.
	 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
	 * @private
	 */
	VirtualRepeatController.prototype.getBlock_ = function(index) {
	  if (this.pooledBlocks.length) {
	    return this.pooledBlocks.pop();
	  }
	
	  var block;
	  this.transclude(angular.bind(this, function(clone, scope) {
	    block = {
	      element: clone,
	      new: true,
	      scope: scope
	    };
	
	    this.updateScope_(scope, index);
	    this.parentNode.appendChild(clone[0]);
	  }));
	
	  return block;
	};
	
	
	/**
	 * Updates and if not in a digest cycle, digests the specified block's scope to the data
	 * at the specified index.
	 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
	  this.blocks[index] = block;
	
	  if (!block.new &&
	      (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
	    return;
	  }
	  block.new = false;
	
	  // Update and digest the block's scope.
	  this.updateScope_(block.scope, index);
	
	  // Perform digest before reattaching the block.
	  // Any resulting synchronous dom mutations should be much faster as a result.
	  // This might break some directives, but I'm going to try it for now.
	  if (!this.$rootScope.$$phase) {
	    block.scope.$digest();
	  }
	};
	
	
	/**
	 * Updates scope to the data at the specified index.
	 * @param {!angular.Scope} scope The scope which should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
	  scope.$index = index;
	  scope[this.repeatName] = this.items && this.items[index];
	  if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
	};
	
	
	/**
	 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
	 * @param {number} index The index at which the block to pool is stored.
	 * @private
	 */
	VirtualRepeatController.prototype.poolBlock_ = function(index) {
	  this.pooledBlocks.push(this.blocks[index]);
	  this.parentNode.removeChild(this.blocks[index].element[0]);
	  delete this.blocks[index];
	};
	
	
	/**
	 * Produces a dom fragment containing the elements from the list of blocks.
	 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
	 *     should be added to the document fragment.
	 * @return {DocumentFragment}
	 * @private
	 */
	VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
	  var fragment = this.$document[0].createDocumentFragment();
	  blocks.forEach(function(block) {
	    fragment.appendChild(block.element[0]);
	  });
	  return fragment;
	};
	
	
	/**
	 * Updates start and end indexes based on length of repeated items and container size.
	 * @private
	 */
	VirtualRepeatController.prototype.updateIndexes_ = function() {
	  var itemsLength = this.items ? this.items.length : 0;
	  var containerLength = Math.ceil(this.container.getSize() / this.itemSize);
	
	  this.newStartIndex = Math.max(0, Math.min(
	      itemsLength - containerLength,
	      Math.floor(this.container.getScrollOffset() / this.itemSize)));
	  this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
	  this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
	  this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
	};
	
	/**
	 * This VirtualRepeatModelArrayLike class enforces the interface requirements
	 * for infinite scrolling within a mdVirtualRepeatContainer. An object with this
	 * interface must implement the following interface with two (2) methods:
	 *
	 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
	 *     loaded (It should start downloading the item in that case).
	 *
	 * getLength: function() -> number The data legnth to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-virtual-repeat-container md-orient-horizontal>
	 *    <div md-virtual-repeat="i in items" md-on-demand>
	 *      Hello {{i}}!
	 *    </div>
	 *  </md-virtual-repeat-container>
	 * </hljs>
	 *
	 */
	function VirtualRepeatModelArrayLike(model) {
	  if (!angular.isFunction(model.getItemAtIndex) ||
	      !angular.isFunction(model.getLength)) {
	    throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement ' +
	        'functions getItemAtIndex() and getLength() ');
	  }
	
	  this.model = model;
	}
	
	
	VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
	  for (var i = start; i < end; i++) {
	    if (!this.hasOwnProperty(i)) {
	      this[i] = this.model.getItemAtIndex(i);
	    }
	  }
	  this.length = this.model.getLength();
	};
	
	
	function abstractMethod() {
	  throw Error('Non-overridden abstract method called.');
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.whiteframe
	 */
	MdWhiteframeDirective.$inject = ["$log"];
	angular
	  .module('material.components.whiteframe', ['material.core'])
	  .directive('mdWhiteframe', MdWhiteframeDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.whiteframe
	 * @name mdWhiteframe
	 *
	 * @description
	 * The md-whiteframe directive allows you to apply an elevation shadow to an element.
	 *
	 * The attribute values needs to be a number between 1 and 24 or -1.
	 * When set to -1 no style is applied.
	 *
	 * ### Notes
	 * - If there is no value specified it defaults to 4dp.
	 * - If the value is not valid it defaults to 4dp.
	
	 * @usage
	 * <hljs lang="html">
	 * <div md-whiteframe="3">
	 *   <span>Elevation of 3dp</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div md-whiteframe="-1">
	 *   <span>No elevation shadow applied</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div ng-init="elevation = 5" md-whiteframe="{{elevation}}">
	 *   <span>Elevation of 5dp with an interpolated value</span>
	 * </div>
	 * </hljs>
	 */
	function MdWhiteframeDirective($log) {
	  var DISABLE_DP = -1;
	  var MIN_DP = 1;
	  var MAX_DP = 24;
	  var DEFAULT_DP = 4;
	
	  return {
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    var oldClass = '';
	
	    attr.$observe('mdWhiteframe', function(elevation) {
	      elevation = parseInt(elevation, 10) || DEFAULT_DP;
	
	      if (elevation != DISABLE_DP && (elevation > MAX_DP || elevation < MIN_DP)) {
	        $log.warn('md-whiteframe attribute value is invalid. It should be a number between ' + MIN_DP + ' and ' + MAX_DP, element[0]);
	        elevation = DEFAULT_DP;
	      }
	
	      var newClass = elevation == DISABLE_DP ? '' : 'md-whiteframe-' + elevation + 'dp';
	      attr.$updateClass(newClass, oldClass);
	      oldClass = newClass;
	    });
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteCtrl.$inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$log"];angular
	    .module('material.components.autocomplete')
	    .controller('MdAutocompleteCtrl', MdAutocompleteCtrl);
	
	var ITEM_HEIGHT   = 41,
	    MAX_HEIGHT    = 5.5 * ITEM_HEIGHT,
	    MENU_PADDING  = 8,
	    INPUT_PADDING = 2; // Padding provided by `md-input-container`
	
	function MdAutocompleteCtrl ($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
	                             $animate, $rootElement, $attrs, $q, $log) {
	
	  // Internal Variables.
	  var ctrl                 = this,
	      itemParts            = $scope.itemsExpr.split(/ in /i),
	      itemExpr             = itemParts[ 1 ],
	      elements             = null,
	      cache                = {},
	      noBlur               = false,
	      selectedItemWatchers = [],
	      hasFocus             = false,
	      lastCount            = 0,
	      fetchesInProgress    = 0,
	      enableWrapScroll     = null,
	      inputModelCtrl       = null;
	
	  // Public Exported Variables with handlers
	  defineProperty('hidden', handleHiddenChange, true);
	
	  // Public Exported Variables
	  ctrl.scope      = $scope;
	  ctrl.parent     = $scope.$parent;
	  ctrl.itemName   = itemParts[ 0 ];
	  ctrl.matches    = [];
	  ctrl.loading    = false;
	  ctrl.hidden     = true;
	  ctrl.index      = null;
	  ctrl.messages   = [];
	  ctrl.id         = $mdUtil.nextUid();
	  ctrl.isDisabled = null;
	  ctrl.isRequired = null;
	  ctrl.isReadonly = null;
	  ctrl.hasNotFound = false;
	
	  // Public Exported Methods
	  ctrl.keydown                       = keydown;
	  ctrl.blur                          = blur;
	  ctrl.focus                         = focus;
	  ctrl.clear                         = clearValue;
	  ctrl.select                        = select;
	  ctrl.listEnter                     = onListEnter;
	  ctrl.listLeave                     = onListLeave;
	  ctrl.mouseUp                       = onMouseup;
	  ctrl.getCurrentDisplayValue        = getCurrentDisplayValue;
	  ctrl.registerSelectedItemWatcher   = registerSelectedItemWatcher;
	  ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
	  ctrl.notFoundVisible               = notFoundVisible;
	  ctrl.loadingIsVisible              = loadingIsVisible;
	  ctrl.positionDropdown              = positionDropdown;
	
	  return init();
	
	  //-- initialization methods
	
	  /**
	   * Initialize the controller, setup watchers, gather elements
	   */
	  function init () {
	    $mdUtil.initOptionalProperties($scope, $attrs, { searchText: '', selectedItem: null });
	    $mdTheming($element);
	    configureWatchers();
	    $mdUtil.nextTick(function () {
	
	      gatherElements();
	      moveDropdown();
	
	      // Forward all focus events to the input element when autofocus is enabled
	      if ($scope.autofocus) {
	        $element.on('focus', focusInputElement);
	      }
	    });
	  }
	
	  function updateModelValidators() {
	    if (!$scope.requireMatch || !inputModelCtrl) return;
	
	    inputModelCtrl.$setValidity('md-require-match', !!$scope.selectedItem);
	  }
	
	  /**
	   * Calculates the dropdown's position and applies the new styles to the menu element
	   * @returns {*}
	   */
	  function positionDropdown () {
	    if (!elements) return $mdUtil.nextTick(positionDropdown, false, $scope);
	    var hrect  = elements.wrap.getBoundingClientRect(),
	        vrect  = elements.snap.getBoundingClientRect(),
	        root   = elements.root.getBoundingClientRect(),
	        top    = vrect.bottom - root.top,
	        bot    = root.bottom - vrect.top,
	        left   = hrect.left - root.left,
	        width  = hrect.width,
	        offset = getVerticalOffset(),
	        styles;
	    // Adjust the width to account for the padding provided by `md-input-container`
	    if ($attrs.mdFloatingLabel) {
	      left += INPUT_PADDING;
	      width -= INPUT_PADDING * 2;
	    }
	    styles = {
	      left:     left + 'px',
	      minWidth: width + 'px',
	      maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
	    };
	    if (top > bot && root.height - hrect.bottom - MENU_PADDING < MAX_HEIGHT) {
	      styles.top       = 'auto';
	      styles.bottom    = bot + 'px';
	      styles.maxHeight = Math.min(MAX_HEIGHT, hrect.top - root.top - MENU_PADDING) + 'px';
	    } else {
	      styles.top       = (top - offset) + 'px';
	      styles.bottom    = 'auto';
	      styles.maxHeight = Math.min(MAX_HEIGHT, root.bottom + $mdUtil.scrollTop() - hrect.bottom - MENU_PADDING) + 'px';
	    }
	
	    elements.$.scrollContainer.css(styles);
	    $mdUtil.nextTick(correctHorizontalAlignment, false);
	
	    /**
	     * Calculates the vertical offset for floating label examples to account for ngMessages
	     * @returns {number}
	     */
	    function getVerticalOffset () {
	      var offset = 0;
	      var inputContainer = $element.find('md-input-container');
	      if (inputContainer.length) {
	        var input = inputContainer.find('input');
	        offset = inputContainer.prop('offsetHeight');
	        offset -= input.prop('offsetTop');
	        offset -= input.prop('offsetHeight');
	        // add in the height left up top for the floating label text
	        offset += inputContainer.prop('offsetTop');
	      }
	      return offset;
	    }
	
	    /**
	     * Makes sure that the menu doesn't go off of the screen on either side.
	     */
	    function correctHorizontalAlignment () {
	      var dropdown = elements.scrollContainer.getBoundingClientRect(),
	          styles   = {};
	      if (dropdown.right > root.right - MENU_PADDING) {
	        styles.left = (hrect.right - dropdown.width) + 'px';
	      }
	      elements.$.scrollContainer.css(styles);
	    }
	  }
	
	  /**
	   * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
	   */
	  function moveDropdown () {
	    if (!elements.$.root.length) return;
	    $mdTheming(elements.$.scrollContainer);
	    elements.$.scrollContainer.detach();
	    elements.$.root.append(elements.$.scrollContainer);
	    if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
	  }
	
	  /**
	   * Sends focus to the input element.
	   */
	  function focusInputElement () {
	    elements.input.focus();
	  }
	
	  /**
	   * Sets up any watchers used by autocomplete
	   */
	  function configureWatchers () {
	    var wait = parseInt($scope.delay, 10) || 0;
	    $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });
	    $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
	    $scope.$watch('selectedItem', selectedItemChange);
	    angular.element($window).on('resize', positionDropdown);
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Removes any events or leftover elements created by this controller
	   */
	  function cleanup () {
	    if (!ctrl.hidden) {
	      $mdUtil.enableScrolling();
	    }
	
	    angular.element($window).off('resize', positionDropdown);
	    if ( elements ){
	      var items = ['ul', 'scroller', 'scrollContainer', 'input'];
	      angular.forEach(items, function(key){
	        elements.$[key].remove();
	      });
	    }
	  }
	
	  /**
	   * Gathers all of the elements needed for this controller
	   */
	  function gatherElements () {
	    elements = {
	      main:  $element[0],
	      scrollContainer: $element[0].querySelector('.md-virtual-repeat-container'),
	      scroller: $element[0].querySelector('.md-virtual-repeat-scroller'),
	      ul:    $element.find('ul')[0],
	      input: $element.find('input')[0],
	      wrap:  $element.find('md-autocomplete-wrap')[0],
	      root:  document.body
	    };
	
	    elements.li   = elements.ul.getElementsByTagName('li');
	    elements.snap = getSnapTarget();
	    elements.$    = getAngularElements(elements);
	
	    inputModelCtrl = elements.$.input.controller('ngModel');
	  }
	
	  /**
	   * Finds the element that the menu will base its position on
	   * @returns {*}
	   */
	  function getSnapTarget () {
	    for (var element = $element; element.length; element = element.parent()) {
	      if (angular.isDefined(element.attr('md-autocomplete-snap'))) return element[ 0 ];
	    }
	    return elements.wrap;
	  }
	
	  /**
	   * Gathers angular-wrapped versions of each element
	   * @param elements
	   * @returns {{}}
	   */
	  function getAngularElements (elements) {
	    var obj = {};
	    for (var key in elements) {
	      if (elements.hasOwnProperty(key)) obj[ key ] = angular.element(elements[ key ]);
	    }
	    return obj;
	  }
	
	  //-- event/change handlers
	
	  /**
	   * Handles changes to the `hidden` property.
	   * @param hidden
	   * @param oldHidden
	   */
	  function handleHiddenChange (hidden, oldHidden) {
	    if (!hidden && oldHidden) {
	      positionDropdown();
	
	      if (elements) {
	        $mdUtil.disableScrollAround(elements.ul);
	        enableWrapScroll = disableElementScrollEvents(angular.element(elements.wrap));
	      }
	    } else if (hidden && !oldHidden) {
	      $mdUtil.enableScrolling();
	
	      if (enableWrapScroll) {
	        enableWrapScroll();
	        enableWrapScroll = null;
	      }
	    }
	  }
	
	  /**
	   * Disables scrolling for a specific element
	   */
	  function disableElementScrollEvents(element) {
	
	    function preventDefault(e) {
	      e.preventDefault();
	    }
	
	    element.on('wheel', preventDefault);
	    element.on('touchmove', preventDefault);
	
	    return function() {
	      element.off('wheel', preventDefault);
	      element.off('touchmove', preventDefault);
	    };
	  }
	
	  /**
	   * When the user mouses over the dropdown menu, ignore blur events.
	   */
	  function onListEnter () {
	    noBlur = true;
	  }
	
	  /**
	   * When the user's mouse leaves the menu, blur events may hide the menu again.
	   */
	  function onListLeave () {
	    if (!hasFocus && !ctrl.hidden) elements.input.focus();
	    noBlur = false;
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * When the mouse button is released, send focus back to the input field.
	   */
	  function onMouseup () {
	    elements.input.focus();
	  }
	
	  /**
	   * Handles changes to the selected item.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function selectedItemChange (selectedItem, previousSelectedItem) {
	
	    updateModelValidators();
	
	    if (selectedItem) {
	      getDisplayValue(selectedItem).then(function (val) {
	        $scope.searchText = val;
	        handleSelectedItemChange(selectedItem, previousSelectedItem);
	      });
	    } else if (previousSelectedItem && $scope.searchText) {
	      getDisplayValue(previousSelectedItem).then(function(displayValue) {
	        // Clear the searchText, when the selectedItem is set to null.
	        // Do not clear the searchText, when the searchText isn't matching with the previous
	        // selected item.
	        if (displayValue.toString().toLowerCase() === $scope.searchText.toLowerCase()) {
	          $scope.searchText = '';
	        }
	      });
	    }
	
	    if (selectedItem !== previousSelectedItem) announceItemChange();
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time a new item is selected
	   */
	  function announceItemChange () {
	    angular.isFunction($scope.itemChange) && $scope.itemChange(getItemAsNameVal($scope.selectedItem));
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time the search text is changed
	   */
	  function announceTextChange () {
	    angular.isFunction($scope.textChange) && $scope.textChange();
	  }
	
	  /**
	   * Calls any external watchers listening for the selected item.  Used in conjunction with
	   * `registerSelectedItemWatcher`.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function handleSelectedItemChange (selectedItem, previousSelectedItem) {
	    selectedItemWatchers.forEach(function (watcher) { watcher(selectedItem, previousSelectedItem); });
	  }
	
	  /**
	   * Register a function to be called when the selected item changes.
	   * @param cb
	   */
	  function registerSelectedItemWatcher (cb) {
	    if (selectedItemWatchers.indexOf(cb) == -1) {
	      selectedItemWatchers.push(cb);
	    }
	  }
	
	  /**
	   * Unregister a function previously registered for selected item changes.
	   * @param cb
	   */
	  function unregisterSelectedItemWatcher (cb) {
	    var i = selectedItemWatchers.indexOf(cb);
	    if (i != -1) {
	      selectedItemWatchers.splice(i, 1);
	    }
	  }
	
	  /**
	   * Handles changes to the searchText property.
	   * @param searchText
	   * @param previousSearchText
	   */
	  function handleSearchText (searchText, previousSearchText) {
	    ctrl.index = getDefaultIndex();
	
	    // do nothing on init
	    if (searchText === previousSearchText) return;
	
	    updateModelValidators();
	
	    getDisplayValue($scope.selectedItem).then(function (val) {
	      // clear selected item if search text no longer matches it
	      if (searchText !== val) {
	        $scope.selectedItem = null;
	
	        // trigger change event if available
	        if (searchText !== previousSearchText) announceTextChange();
	
	        // cancel results if search text is not long enough
	        if (!isMinLengthMet()) {
	          ctrl.matches = [];
	          setLoading(false);
	          updateMessages();
	        } else {
	          handleQuery();
	        }
	      }
	    });
	
	  }
	
	  /**
	   * Handles input blur event, determines if the dropdown should hide.
	   */
	  function blur($event) {
	    hasFocus = false;
	
	    if (!noBlur) {
	      ctrl.hidden = shouldHide();
	      evalAttr('ngBlur', { $event: $event });
	    }
	  }
	
	  /**
	   * Force blur on input element
	   * @param forceBlur
	   */
	  function doBlur(forceBlur) {
	    if (forceBlur) {
	      noBlur = false;
	      hasFocus = false;
	    }
	    elements.input.blur();
	  }
	
	  /**
	   * Handles input focus event, determines if the dropdown should show.
	   */
	  function focus($event) {
	    hasFocus = true;
	
	    if (isSearchable() && isMinLengthMet()) {
	      handleQuery();
	    }
	
	    ctrl.hidden = shouldHide();
	
	    evalAttr('ngFocus', { $event: $event });
	  }
	
	  /**
	   * Handles keyboard input.
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.DOWN_ARROW:
	        if (ctrl.loading) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index   = Math.min(ctrl.index + 1, ctrl.matches.length - 1);
	        updateScroll();
	        updateMessages();
	        break;
	      case $mdConstant.KEY_CODE.UP_ARROW:
	        if (ctrl.loading) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index   = ctrl.index < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
	        updateScroll();
	        updateMessages();
	        break;
	      case $mdConstant.KEY_CODE.TAB:
	        // If we hit tab, assume that we've left the list so it will close
	        onListLeave();
	
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ENTER:
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        if (hasSelection()) return;
	        event.stopPropagation();
	        event.preventDefault();
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ESCAPE:
	        event.preventDefault(); // Prevent browser from always clearing input
	        if (!shouldProcessEscape()) return;
	        event.stopPropagation();
	
	        clearSelectedItem();
	        if ($scope.searchText && hasEscapeOption('clear')) {
	          clearSearchText();
	        }
	
	        // Manually hide (needed for mdNotFound support)
	        ctrl.hidden = true;
	
	        if (hasEscapeOption('blur')) {
	          // Force the component to blur if they hit escape
	          doBlur(true);
	        }
	
	        break;
	      default:
	    }
	  }
	
	  //-- getters
	
	  /**
	   * Returns the minimum length needed to display the dropdown.
	   * @returns {*}
	   */
	  function getMinLength () {
	    return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
	  }
	
	  /**
	   * Returns the display value for an item.
	   * @param item
	   * @returns {*}
	   */
	  function getDisplayValue (item) {
	    return $q.when(getItemText(item) || item).then(function(itemText) {
	      if (itemText && !angular.isString(itemText)) {
	        $log.warn('md-autocomplete: Could not resolve display value to a string. ' +
	          'Please check the `md-item-text` attribute.');
	      }
	
	      return itemText;
	    });
	
	    /**
	     * Getter function to invoke user-defined expression (in the directive)
	     * to convert your object to a single string.
	     */
	    function getItemText (item) {
	      return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
	    }
	  }
	
	  /**
	   * Returns the locals object for compiling item templates.
	   * @param item
	   * @returns {{}}
	   */
	  function getItemAsNameVal (item) {
	    if (!item) return undefined;
	
	    var locals = {};
	    if (ctrl.itemName) locals[ ctrl.itemName ] = item;
	
	    return locals;
	  }
	
	  /**
	   * Returns the default index based on whether or not autoselect is enabled.
	   * @returns {number}
	   */
	  function getDefaultIndex () {
	    return $scope.autoselect ? 0 : -1;
	  }
	
	  /**
	   * Sets the loading parameter and updates the hidden state.
	   * @param value {boolean} Whether or not the component is currently loading.
	   */
	  function setLoading(value) {
	    if (ctrl.loading != value) {
	      ctrl.loading = value;
	    }
	
	    // Always refresh the hidden variable as something else might have changed
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Determines if the menu should be hidden.
	   * @returns {boolean}
	   */
	  function shouldHide () {
	    if (!isSearchable()) return true;    // Hide when not able to query
	    else return !shouldShow();            // Hide when the dropdown is not able to show.
	  }
	
	  /**
	   * Determines whether the autocomplete is able to query within the current state.
	   * @returns {boolean}
	   */
	  function isSearchable() {
	    if (ctrl.loading && !hasMatches()) return false; // No query when query is in progress.
	    else if (hasSelection()) return false;           // No query if there is already a selection
	    else if (!hasFocus) return false;                // No query if the input does not have focus
	    return true;
	  }
	
	  /**
	   * Determines if the escape keydown should be processed
	   * @returns {boolean}
	   */
	  function shouldProcessEscape() {
	    return hasEscapeOption('blur') || !ctrl.hidden || ctrl.loading || hasEscapeOption('clear') && $scope.searchText;
	  }
	
	  /**
	   * Determines if an escape option is set
	   * @returns {boolean}
	   */
	  function hasEscapeOption(option) {
	    return !$scope.escapeOptions || $scope.escapeOptions.toLowerCase().indexOf(option) !== -1;
	  }
	
	  /**
	   * Determines if the menu should be shown.
	   * @returns {boolean}
	   */
	  function shouldShow() {
	    return (isMinLengthMet() && hasMatches()) || notFoundVisible();
	  }
	
	  /**
	   * Returns true if the search text has matches.
	   * @returns {boolean}
	   */
	  function hasMatches() {
	    return ctrl.matches.length ? true : false;
	  }
	
	  /**
	   * Returns true if the autocomplete has a valid selection.
	   * @returns {boolean}
	   */
	  function hasSelection() {
	    return ctrl.scope.selectedItem ? true : false;
	  }
	
	  /**
	   * Returns true if the loading indicator is, or should be, visible.
	   * @returns {boolean}
	   */
	  function loadingIsVisible() {
	    return ctrl.loading && !hasSelection();
	  }
	
	  /**
	   * Returns the display value of the current item.
	   * @returns {*}
	   */
	  function getCurrentDisplayValue () {
	    return getDisplayValue(ctrl.matches[ ctrl.index ]);
	  }
	
	  /**
	   * Determines if the minimum length is met by the search text.
	   * @returns {*}
	   */
	  function isMinLengthMet () {
	    return ($scope.searchText || '').length >= getMinLength();
	  }
	
	  //-- actions
	
	  /**
	   * Defines a public property with a handler and a default value.
	   * @param key
	   * @param handler
	   * @param value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Selects the item at the given index.
	   * @param index
	   */
	  function select (index) {
	    //-- force form to update state for validation
	    $mdUtil.nextTick(function () {
	      getDisplayValue(ctrl.matches[ index ]).then(function (val) {
	        var ngModel = elements.$.input.controller('ngModel');
	        ngModel.$setViewValue(val);
	        ngModel.$render();
	      }).finally(function () {
	        $scope.selectedItem = ctrl.matches[ index ];
	        setLoading(false);
	      });
	    }, false);
	  }
	
	  /**
	   * Clears the searchText value and selected item.
	   */
	  function clearValue () {
	    clearSelectedItem();
	    clearSearchText();
	  }
	
	  /**
	   * Clears the selected item
	   */
	  function clearSelectedItem () {
	    // Reset our variables
	    ctrl.index = 0;
	    ctrl.matches = [];
	  }
	
	  /**
	   * Clears the searchText value
	   */
	  function clearSearchText () {
	    // Set the loading to true so we don't see flashes of content.
	    // The flashing will only occur when an async request is running.
	    // So the loading process will stop when the results had been retrieved.
	    setLoading(true);
	
	    $scope.searchText = '';
	
	    // Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
	    // But some browsers are not detecting it properly, which means that we have to trigger the event.
	    // Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
	    // The `change` event is a good alternative and is supported by all supported browsers.
	    var eventObj = document.createEvent('CustomEvent');
	    eventObj.initCustomEvent('change', true, true, { value: '' });
	    elements.input.dispatchEvent(eventObj);
	
	    // For some reason, firing the above event resets the value of $scope.searchText if
	    // $scope.searchText has a space character at the end, so we blank it one more time and then
	    // focus.
	    elements.input.blur();
	    $scope.searchText = '';
	    elements.input.focus();
	  }
	
	  /**
	   * Fetches the results for the provided search text.
	   * @param searchText
	   */
	  function fetchResults (searchText) {
	    var items = $scope.$parent.$eval(itemExpr),
	        term  = searchText.toLowerCase(),
	        isList = angular.isArray(items),
	        isPromise = !!items.then; // Every promise should contain a `then` property
	
	    if (isList) onResultsRetrieved(items);
	    else if (isPromise) handleAsyncResults(items);
	
	    function handleAsyncResults(items) {
	      if ( !items ) return;
	
	      items = $q.when(items);
	      fetchesInProgress++;
	      setLoading(true);
	
	      $mdUtil.nextTick(function () {
	          items
	            .then(onResultsRetrieved)
	            .finally(function(){
	              if (--fetchesInProgress === 0) {
	                setLoading(false);
	              }
	            });
	      },true, $scope);
	    }
	
	    function onResultsRetrieved(matches) {
	      cache[term] = matches;
	
	      // Just cache the results if the request is now outdated.
	      // The request becomes outdated, when the new searchText has changed during the result fetching.
	      if ((searchText || '') !== ($scope.searchText || '')) {
	        return;
	      }
	
	      handleResults(matches);
	    }
	  }
	
	  /**
	   * Updates the ARIA messages
	   */
	  function updateMessages () {
	    getCurrentDisplayValue().then(function (msg) {
	      ctrl.messages = [ getCountMessage(), msg ];
	    });
	  }
	
	  /**
	   * Returns the ARIA message for how many results match the current query.
	   * @returns {*}
	   */
	  function getCountMessage () {
	    if (lastCount === ctrl.matches.length) return '';
	    lastCount = ctrl.matches.length;
	    switch (ctrl.matches.length) {
	      case 0:
	        return 'There are no matches available.';
	      case 1:
	        return 'There is 1 match available.';
	      default:
	        return 'There are ' + ctrl.matches.length + ' matches available.';
	    }
	  }
	
	  /**
	   * Makes sure that the focused element is within view.
	   */
	  function updateScroll () {
	    if (!elements.li[0]) return;
	    var height = elements.li[0].offsetHeight,
	        top = height * ctrl.index,
	        bot = top + height,
	        hgt = elements.scroller.clientHeight,
	        scrollTop = elements.scroller.scrollTop;
	    if (top < scrollTop) {
	      scrollTo(top);
	    } else if (bot > scrollTop + hgt) {
	      scrollTo(bot - hgt);
	    }
	  }
	
	  function isPromiseFetching() {
	    return fetchesInProgress !== 0;
	  }
	
	  function scrollTo (offset) {
	    elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
	  }
	
	  function notFoundVisible () {
	    var textLength = (ctrl.scope.searchText || '').length;
	
	    return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
	  }
	
	  /**
	   * Starts the query to gather the results for the current searchText.  Attempts to return cached
	   * results first, then forwards the process to `fetchResults` if necessary.
	   */
	  function handleQuery () {
	    var searchText = $scope.searchText || '';
	    var term = searchText.toLowerCase();
	
	    // If caching is enabled and the current searchText is stored in the cache
	    if (!$scope.noCache && cache[term]) {
	      // The results should be handled as same as a normal un-cached request does.
	      handleResults(cache[term]);
	    } else {
	      fetchResults(searchText);
	    }
	
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Handles the retrieved results by showing them in the autocompletes dropdown.
	   * @param results Retrieved results
	   */
	  function handleResults(results) {
	    ctrl.matches = results;
	    ctrl.hidden  = shouldHide();
	
	    // If loading is in progress, then we'll end the progress. This is needed for example,
	    // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
	    if (ctrl.loading) setLoading(false);
	
	    if ($scope.selectOnMatch) selectItemOnMatch();
	
	    updateMessages();
	    positionDropdown();
	  }
	
	  /**
	   * If there is only one matching item and the search text matches its display value exactly,
	   * automatically select that item.  Note: This function is only called if the user uses the
	   * `md-select-on-match` flag.
	   */
	  function selectItemOnMatch () {
	    var searchText = $scope.searchText,
	        matches    = ctrl.matches,
	        item       = matches[ 0 ];
	    if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
	      var isMatching = searchText == displayValue;
	      if ($scope.matchInsensitive && !isMatching) {
	        isMatching = searchText.toLowerCase() == displayValue.toLowerCase();
	      }
	
	      if (isMatching) select(0);
	    });
	  }
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   * @param {Object?} locals Properties to be injected into the evaluation context.
	   */
	 function evalAttr(attr, locals) {
	    if ($attrs[attr]) {
	      $scope.$parent.$eval($attrs[attr], locals || {});
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocomplete.$inject = ["$$mdSvgRegistry"];angular
	    .module('material.components.autocomplete')
	    .directive('mdAutocomplete', MdAutocomplete);
	
	/**
	 * @ngdoc directive
	 * @name mdAutocomplete
	 * @module material.components.autocomplete
	 *
	 * @description
	 * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
	 *     custom query. This component allows you to provide real-time suggestions as the user types
	 *     in the input area.
	 *
	 * To start, you will need to specify the required parameters and provide a template for your
	 *     results. The content inside `md-autocomplete` will be treated as a template.
	 *
	 * In more complex cases, you may want to include other content such as a message to display when
	 *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
	 *     adding a tag for `md-not-found`.  An example of this is shown below.
	 *
	 * To reset the displayed value you must clear both values for `md-search-text` and `md-selected-item`.
	 *
	 * ### Validation
	 *
	 * You can use `ng-messages` to include validation the same way that you would normally validate;
	 *     however, if you want to replicate a standard input with a floating label, you will have to
	 *     do the following:
	 *
	 * - Make sure that your template is wrapped in `md-item-template`
	 * - Add your `ng-messages` code inside of `md-autocomplete`
	 * - Add your validation properties to `md-autocomplete` (ie. `required`)
	 * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
	 *
	 * There is an example below of how this should look.
	 *
	 * ### Notes
	 * The `md-autocomplete` uses the the <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeat</a>
	 * directive for displaying the results inside of the dropdown.<br/>
	 * > When encountering issues regarding the item template please take a look at the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation.
	 *
	 *
	 * @param {expression} md-items An expression in the format of `item in items` to iterate over
	 *     matches for your search.
	 * @param {expression=} md-selected-item-change An expression to be run each time a new item is
	 *     selected
	 * @param {expression=} md-search-text-change An expression to be run each time the search text
	 *     updates
	 * @param {expression=} md-search-text A model to bind the search query text to
	 * @param {object=} md-selected-item A model to bind the selected item to
	 * @param {expression=} md-item-text An expression that will convert your object to a single string.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete
	 * @param {boolean=} ng-disabled Determines whether or not to disable the input field
	 * @param {boolean=} md-require-match When set to true, the autocomplete will add a validator,
	 *     which will evaluate to false, when no item is currently selected.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *     make suggestions
	 * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
	 *     for results
	 * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a `$mdDialog`,
	 *     `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening. <br/><br/>
	 *     Also the autocomplete will immediately focus the input element.
	 * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating label
	 * @param {boolean=} md-autoselect If set to true, the first item will be automatically selected
	 *     in the dropdown upon open.
	 * @param {string=} md-menu-class This will be applied to the dropdown menu for styling
	 * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
	 *     `md-input-container`
	 * @param {string=} md-input-name The name attribute given to the input element to be used with
	 *     FormController
	 * @param {string=} md-select-on-focus When present the inputs text will be automatically selected
	 *     on focus.
	 * @param {string=} md-input-id An ID to be added to the input element
	 * @param {number=} md-input-minlength The minimum length for the input's value for validation
	 * @param {number=} md-input-maxlength The maximum length for the input's value for validation
	 * @param {boolean=} md-select-on-match When set, autocomplete will automatically select exact
	 *     the item if the search text is an exact match. <br/><br/>
	 *     Exact match means that there is only one match showing up.
	 * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
	 *     will select on case-insensitive match
	 * @param {string=} md-escape-options Override escape key logic. Default is `blur clear`.<br/>
	 *     Options: `blur | clear`, `none`
	 *
	 * @usage
	 * ### Basic Example
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with "not found" message
	 * <hljs lang="html">
	 * <md-autocomplete
	 *     md-selected-item="selectedItem"
	 *     md-search-text="searchText"
	 *     md-items="item in getMatches(searchText)"
	 *     md-item-text="item.display">
	 *   <md-item-template>
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-item-template>
	 *   <md-not-found>
	 *     No matches found.
	 *   </md-not-found>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
	 *     different parts that make up our component.
	 *
	 * ### Example with validation
	 * <hljs lang="html">
	 * <form name="autocompleteForm">
	 *   <md-autocomplete
	 *       required
	 *       md-input-name="autocomplete"
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item.display}}</span>
	 *     </md-item-template>
	 *     <div ng-messages="autocompleteForm.autocomplete.$error">
	 *       <div ng-message="required">This field is required</div>
	 *     </div>
	 *   </md-autocomplete>
	 * </form>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `ng-messages` to specify
	 *     input validation for the field.
	 */
	
	function MdAutocomplete ($$mdSvgRegistry) {
	
	  return {
	    controller:   'MdAutocompleteCtrl',
	    controllerAs: '$mdAutocompleteCtrl',
	    scope:        {
	      inputName:        '@mdInputName',
	      inputMinlength:   '@mdInputMinlength',
	      inputMaxlength:   '@mdInputMaxlength',
	      searchText:       '=?mdSearchText',
	      selectedItem:     '=?mdSelectedItem',
	      itemsExpr:        '@mdItems',
	      itemText:         '&mdItemText',
	      placeholder:      '@placeholder',
	      noCache:          '=?mdNoCache',
	      requireMatch:     '=?mdRequireMatch',
	      selectOnMatch:    '=?mdSelectOnMatch',
	      matchInsensitive: '=?mdMatchCaseInsensitive',
	      itemChange:       '&?mdSelectedItemChange',
	      textChange:       '&?mdSearchTextChange',
	      minLength:        '=?mdMinLength',
	      delay:            '=?mdDelay',
	      autofocus:        '=?mdAutofocus',
	      floatingLabel:    '@?mdFloatingLabel',
	      autoselect:       '=?mdAutoselect',
	      menuClass:        '@?mdMenuClass',
	      inputId:          '@?mdInputId',
	      escapeOptions:    '@?mdEscapeOptions'
	    },
	    link: function(scope, element, attrs, controller) {
	      // Retrieve the state of using a md-not-found template by using our attribute, which will
	      // be added to the element in the template function.
	      controller.hasNotFound = !!element.attr('md-has-not-found');
	    },
	    template:     function (element, attr) {
	      var noItemsTemplate = getNoItemsTemplate(),
	          itemTemplate    = getItemTemplate(),
	          leftover        = element.html(),
	          tabindex        = attr.tabindex;
	
	      // Set our attribute for the link function above which runs later.
	      // We will set an attribute, because otherwise the stored variables will be trashed when
	      // removing the element is hidden while retrieving the template. For example when using ngIf.
	      if (noItemsTemplate) element.attr('md-has-not-found', true);
	
	      // Always set our tabindex of the autocomplete directive to -1, because our input
	      // will hold the actual tabindex.
	      element.attr('tabindex', '-1');
	
	      return '\
	        <md-autocomplete-wrap\
	            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \'md-menu-showing\': !$mdAutocompleteCtrl.hidden }">\
	          ' + getInputElement() + '\
	          <md-progress-linear\
	              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
	              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
	              md-mode="indeterminate"></md-progress-linear>\
	          <md-virtual-repeat-container\
	              md-auto-shrink\
	              md-auto-shrink-min="1"\
	              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
	              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
	              ng-mouseup="$mdAutocompleteCtrl.mouseUp()"\
	              ng-hide="$mdAutocompleteCtrl.hidden"\
	              class="md-autocomplete-suggestions-container md-whiteframe-z1"\
	              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
	              role="presentation">\
	            <ul class="md-autocomplete-suggestions"\
	                ng-class="::menuClass"\
	                id="ul-{{$mdAutocompleteCtrl.id}}">\
	              <li md-virtual-repeat="item in $mdAutocompleteCtrl.matches"\
	                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
	                  ng-click="$mdAutocompleteCtrl.select($index)"\
	                  md-extra-name="$mdAutocompleteCtrl.itemName">\
	                  ' + itemTemplate + '\
	                  </li>' + noItemsTemplate + '\
	            </ul>\
	          </md-virtual-repeat-container>\
	        </md-autocomplete-wrap>\
	        <aria-status\
	            class="md-visually-hidden"\
	            role="status"\
	            aria-live="assertive">\
	          <p ng-repeat="message in $mdAutocompleteCtrl.messages track by $index" ng-if="message">{{message}}</p>\
	        </aria-status>';
	
	      function getItemTemplate() {
	        var templateTag = element.find('md-item-template').detach(),
	            html = templateTag.length ? templateTag.html() : element.html();
	        if (!templateTag.length) element.empty();
	        return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html + '</md-autocomplete-parent-scope>';
	      }
	
	      function getNoItemsTemplate() {
	        var templateTag = element.find('md-not-found').detach(),
	            template = templateTag.length ? templateTag.html() : '';
	        return template
	            ? '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()"\
	                         md-autocomplete-parent-scope>' + template + '</li>'
	            : '';
	
	      }
	
	      function getInputElement () {
	        if (attr.mdFloatingLabel) {
	          return '\
	            <md-input-container ng-if="floatingLabel">\
	              <label>{{floatingLabel}}</label>\
	              <input type="search"\
	                  ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                  id="{{ inputId || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
	                  name="{{inputName}}"\
	                  autocomplete="off"\
	                  ng-required="$mdAutocompleteCtrl.isRequired"\
	                  ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                  ng-minlength="inputMinlength"\
	                  ng-maxlength="inputMaxlength"\
	                  ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                  ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                  ng-model-options="{ allowInvalid: true }"\
	                  ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                  ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                  ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                  aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                  ' + (attr.mdNoAsterisk != null ? 'md-no-asterisk="' + attr.mdNoAsterisk + '"' : '') + '\
	                  ' + (attr.mdSelectOnFocus != null ? 'md-select-on-focus=""' : '') + '\
	                  aria-label="{{floatingLabel}}"\
	                  aria-autocomplete="list"\
	                  role="combobox"\
	                  aria-haspopup="true"\
	                  aria-activedescendant=""\
	                  aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
	              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
	            </md-input-container>';
	        } else {
	          return '\
	            <input type="search"\
	                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                id="{{ inputId || \'input-\' + $mdAutocompleteCtrl.id }}"\
	                name="{{inputName}}"\
	                ng-if="!floatingLabel"\
	                autocomplete="off"\
	                ng-required="$mdAutocompleteCtrl.isRequired"\
	                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                placeholder="{{placeholder}}"\
	                aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                ' + (attr.mdSelectOnFocus != null ? 'md-select-on-focus=""' : '') + '\
	                aria-label="{{placeholder}}"\
	                aria-autocomplete="list"\
	                role="combobox"\
	                aria-haspopup="true"\
	                aria-activedescendant=""\
	                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
	            <button\
	                type="button"\
	                tabindex="-1"\
	                ng-if="$mdAutocompleteCtrl.scope.searchText && !$mdAutocompleteCtrl.isDisabled"\
	                ng-click="$mdAutocompleteCtrl.clear($event)">\
	              <md-icon md-svg-src="' + $$mdSvgRegistry.mdClose + '"></md-icon>\
	              <span class="md-visually-hidden">Clear</span>\
	            </button>\
	                ';
	        }
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteItemScopeDirective.$inject = ["$compile", "$mdUtil"];angular
	  .module('material.components.autocomplete')
	  .directive('mdAutocompleteParentScope', MdAutocompleteItemScopeDirective);
	
	function MdAutocompleteItemScopeDirective($compile, $mdUtil) {
	  return {
	    restrict: 'AE',
	    compile: compile,
	    terminal: true,
	    transclude: 'element'
	  };
	
	  function compile(tElement, tAttr, transclude) {
	    return function postLink(scope, element, attr) {
	      var ctrl = scope.$mdAutocompleteCtrl;
	      var newScope = ctrl.parent.$new();
	      var itemName = ctrl.itemName;
	
	      // Watch for changes to our scope's variables and copy them to the new scope
	      watchVariable('$index', '$index');
	      watchVariable('item', itemName);
	
	      // Ensure that $digest calls on our scope trigger $digest on newScope.
	      connectScopes();
	
	      // Link the element against newScope.
	      transclude(newScope, function(clone) {
	        element.after(clone);
	      });
	
	      /**
	       * Creates a watcher for variables that are copied from the parent scope
	       * @param variable
	       * @param alias
	       */
	      function watchVariable(variable, alias) {
	        newScope[alias] = scope[variable];
	
	        scope.$watch(variable, function(value) {
	          $mdUtil.nextTick(function() {
	            newScope[alias] = value;
	          });
	        });
	      }
	
	      /**
	       * Creates watchers on scope and newScope that ensure that for any
	       * $digest of scope, newScope is also $digested.
	       */
	      function connectScopes() {
	        var scopeDigesting = false;
	        var newScopeDigesting = false;
	
	        scope.$watch(function() {
	          if (newScopeDigesting || scopeDigesting) {
	            return;
	          }
	
	          scopeDigesting = true;
	          scope.$$postDigest(function() {
	            if (!newScopeDigesting) {
	              newScope.$digest();
	            }
	
	            scopeDigesting = newScopeDigesting = false;
	          });
	        });
	
	        newScope.$watch(function() {
	          newScopeDigesting = true;
	        });
	      }
	    };
	  }
	}
	})();
	(function(){
	"use strict";
	
	
	MdHighlightCtrl.$inject = ["$scope", "$element", "$attrs"];angular
	    .module('material.components.autocomplete')
	    .controller('MdHighlightCtrl', MdHighlightCtrl);
	
	function MdHighlightCtrl ($scope, $element, $attrs) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  // Cache the Regex to avoid rebuilding each time.
	  this.regex = null;
	}
	
	MdHighlightCtrl.prototype.init = function(unsafeTermFn, unsafeContentFn) {
	
	  this.flags = this.$attrs.mdHighlightFlags || '';
	
	  this.unregisterFn = this.$scope.$watch(function($scope) {
	    return {
	      term: unsafeTermFn($scope),
	      contentText: unsafeContentFn($scope)
	    };
	  }.bind(this), this.onRender.bind(this), true);
	
	  this.$element.on('$destroy', this.unregisterFn);
	};
	
	/**
	 * Triggered once a new change has been recognized and the highlighted
	 * text needs to be updated.
	 */
	MdHighlightCtrl.prototype.onRender = function(state, prevState) {
	
	  var contentText = state.contentText;
	
	  /* Update the regex if it's outdated, because we don't want to rebuilt it constantly. */
	  if (this.regex === null || state.term !== prevState.term) {
	    this.regex = this.createRegex(state.term, this.flags);
	  }
	
	  /* If a term is available apply the regex to the content */
	  if (state.term) {
	    this.applyRegex(contentText);
	  } else {
	    this.$element.text(contentText);
	  }
	
	};
	
	/**
	 * Decomposes the specified text into different tokens (whether match or not).
	 * Breaking down the string guarantees proper XSS protection due to the native browser
	 * escaping of unsafe text.
	 */
	MdHighlightCtrl.prototype.applyRegex = function(text) {
	  var tokens = this.resolveTokens(text);
	
	  this.$element.empty();
	
	  tokens.forEach(function (token) {
	
	    if (token.isMatch) {
	      var tokenEl = angular.element('<span class="highlight">').text(token.text);
	
	      this.$element.append(tokenEl);
	    } else {
	      this.$element.append(document.createTextNode(token));
	    }
	
	  }.bind(this));
	
	};
	
	  /**
	 * Decomposes the specified text into different tokens by running the regex against the text.
	 */
	MdHighlightCtrl.prototype.resolveTokens = function(string) {
	  var tokens = [];
	  var lastIndex = 0;
	
	  // Use replace here, because it supports global and single regular expressions at same time.
	  string.replace(this.regex, function(match, index) {
	    appendToken(lastIndex, index);
	
	    tokens.push({
	      text: match,
	      isMatch: true
	    });
	
	    lastIndex = index + match.length;
	  });
	
	  // Append the missing text as a token.
	  appendToken(lastIndex);
	
	  return tokens;
	
	  function appendToken(from, to) {
	    var targetText = string.slice(from, to);
	    targetText && tokens.push(targetText);
	  }
	};
	
	/** Creates a regex for the specified text with the given flags. */
	MdHighlightCtrl.prototype.createRegex = function(term, flags) {
	  var startFlag = '', endFlag = '';
	  var regexTerm = this.sanitizeRegex(term);
	
	  if (flags.indexOf('^') >= 0) startFlag = '^';
	  if (flags.indexOf('$') >= 0) endFlag = '$';
	
	  return new RegExp(startFlag + regexTerm + endFlag, flags.replace(/[$\^]/g, ''));
	};
	
	/** Sanitizes a regex by removing all common RegExp identifiers */
	MdHighlightCtrl.prototype.sanitizeRegex = function(term) {
	  return term && term.toString().replace(/[\\\^\$\*\+\?\.\(\)\|\{}\[\]]/g, '\\$&');
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdHighlight.$inject = ["$interpolate", "$parse"];angular
	    .module('material.components.autocomplete')
	    .directive('mdHighlightText', MdHighlight);
	
	/**
	 * @ngdoc directive
	 * @name mdHighlightText
	 * @module material.components.autocomplete
	 *
	 * @description
	 * The `md-highlight-text` directive allows you to specify text that should be highlighted within
	 *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
	 *     be styled through CSS.  Please note that child elements may not be used with this directive.
	 *
	 * @param {string} md-highlight-text A model to be searched for
	 * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
	 * #### **Supported flags**:
	 * - `g`: Find all matches within the provided text
	 * - `i`: Ignore case when searching for matches
	 * - `$`: Only match if the text ends with the search term
	 * - `^`: Only match if the text begins with the search term
	 *
	 * @usage
	 * <hljs lang="html">
	 * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
	 * <ul>
	 *   <li ng-repeat="result in results" md-highlight-text="searchTerm">
	 *     {{result.text}}
	 *   </li>
	 * </ul>
	 * </hljs>
	 */
	
	function MdHighlight ($interpolate, $parse) {
	  return {
	    terminal: true,
	    controller: 'MdHighlightCtrl',
	    compile: function mdHighlightCompile(tElement, tAttr) {
	      var termExpr = $parse(tAttr.mdHighlightText);
	      var unsafeContentExpr = $interpolate(tElement.html());
	
	      return function mdHighlightLink(scope, element, attr, ctrl) {
	        ctrl.init(termExpr, unsafeContentExpr);
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];angular
	  .module('material.components.chips')
	  .controller('MdChipCtrl', MdChipCtrl);
	
	/**
	 * Controller for the MdChip component. Responsible for handling keyboard
	 * events and editting the chip if needed.
	 *
	 * @param $scope
	 * @param $element
	 * @param $mdConstant
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */
	function MdChipCtrl ($scope, $element, $mdConstant, $timeout, $mdUtil) {
	  /**
	   * @type {$scope}
	   */
	  this.$scope = $scope;
	
	  /**
	   * @type {$element}
	   */
	  this.$element = $element;
	
	  /**
	   * @type {$mdConstant}
	   */
	  this.$mdConstant = $mdConstant;
	
	  /**
	   * @type {$timeout}
	   */
	  this.$timeout = $timeout;
	
	  /**
	   * @type {$mdUtil}
	   */
	  this.$mdUtil = $mdUtil;
	
	  /**
	   * @type {boolean}
	   */
	  this.isEditting = false;
	
	  /**
	   * @type {MdChipsCtrl}
	   */
	  this.parentController = undefined;
	
	  /**
	   * @type {boolean}
	   */
	  this.enableChipEdit = false;
	}
	
	
	/**
	 * @param {MdChipsCtrl} controller
	 */
	MdChipCtrl.prototype.init = function(controller) {
	  this.parentController = controller;
	  this.enableChipEdit = this.parentController.enableChipEdit;
	
	  if (this.enableChipEdit) {
	    this.$element.on('keydown', this.chipKeyDown.bind(this));
	    this.$element.on('mousedown', this.chipMouseDown.bind(this));
	    this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
	  }
	};
	
	
	/**
	 * @return {Object}
	 */
	MdChipCtrl.prototype.getChipContent = function() {
	  var chipContents = this.$element[0].getElementsByClassName('md-chip-content');
	  return angular.element(chipContents[0]);
	};
	
	
	/**
	 * @return {Object}
	 */
	MdChipCtrl.prototype.getContentElement = function() {
	  return angular.element(this.getChipContent().children()[0]);
	};
	
	
	/**
	 * @return {number}
	 */
	MdChipCtrl.prototype.getChipIndex = function() {
	  return parseInt(this.$element.attr('index'));
	};
	
	
	/**
	 * Presents an input element to edit the contents of the chip.
	 */
	MdChipCtrl.prototype.goOutOfEditMode = function() {
	  if (!this.isEditting) return;
	
	  this.isEditting = false;
	  this.$element.removeClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'false';
	  var chipIndex = this.getChipIndex();
	
	  var content = this.getContentElement().text();
	  if (content) {
	    this.parentController.updateChipContents(
	        chipIndex,
	        this.getContentElement().text()
	    );
	
	    this.$mdUtil.nextTick(function() {
	      if (this.parentController.selectedChip === chipIndex) {
	        this.parentController.focusChip(chipIndex);
	      }
	    }.bind(this));
	  } else {
	    this.parentController.removeChipAndFocusInput(chipIndex);
	  }
	};
	
	
	/**
	 * Given an HTML element. Selects contents of it.
	 * @param node
	 */
	MdChipCtrl.prototype.selectNodeContents = function(node) {
	  var range, selection;
	  if (document.body.createTextRange) {
	    range = document.body.createTextRange();
	    range.moveToElementText(node);
	    range.select();
	  } else if (window.getSelection) {
	    selection = window.getSelection();
	    range = document.createRange();
	    range.selectNodeContents(node);
	    selection.removeAllRanges();
	    selection.addRange(range);
	  }
	};
	
	
	/**
	 * Presents an input element to edit the contents of the chip.
	 */
	MdChipCtrl.prototype.goInEditMode = function() {
	  this.isEditting = true;
	  this.$element.addClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'true';
	  this.getChipContent().on('blur', function() {
	    this.goOutOfEditMode();
	  }.bind(this));
	
	  this.selectNodeContents(this.getChipContent()[0]);
	};
	
	
	/**
	 * Handles the keydown event on the chip element. If enable-chip-edit attribute is
	 * set to true, space or enter keys can trigger going into edit mode. Enter can also
	 * trigger submitting if the chip is already being edited.
	 * @param event
	 */
	MdChipCtrl.prototype.chipKeyDown = function(event) {
	  if (!this.isEditting &&
	    (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
	    event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
	    event.preventDefault();
	    this.goInEditMode();
	  } else if (this.isEditting &&
	    event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
	    event.preventDefault();
	    this.goOutOfEditMode();
	  }
	};
	
	
	/**
	 * Handles the double click event
	 */
	MdChipCtrl.prototype.chipMouseDown = function() {
	  if(this.getChipIndex() == this.parentController.selectedChip &&
	    this.enableChipEdit &&
	    !this.isEditting) {
	    this.goInEditMode();
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdChip.$inject = ["$mdTheming", "$mdUtil"];angular
	    .module('material.components.chips')
	    .directive('mdChip', MdChip);
	
	/**
	 * @ngdoc directive
	 * @name mdChip
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-chip>` is a component used within `<md-chips>` and is responsible for rendering individual
	 * chips.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chip>{{$chip}}</md-chip>
	 * </hljs>
	 *
	 */
	
	// This hint text is hidden within a chip but used by screen readers to
	// inform the user how they can interact with a chip.
	var DELETE_HINT_TEMPLATE = '\
	    <span ng-if="!$mdChipsCtrl.readonly" class="md-visually-hidden">\
	      {{$mdChipsCtrl.deleteHint}}\
	    </span>';
	
	/**
	 * MDChip Directive Definition
	 *
	 * @param $mdTheming
	 * @param $mdUtil
	 * @ngInject
	 */
	function MdChip($mdTheming, $mdUtil) {
	  var hintTemplate = $mdUtil.processTemplate(DELETE_HINT_TEMPLATE);
	
	  return {
	    restrict: 'E',
	    require: ['^?mdChips', 'mdChip'],
	    compile:  compile,
	    controller: 'MdChipCtrl'
	  };
	
	  function compile(element, attr) {
	    // Append the delete template
	    element.append($mdUtil.processTemplate(hintTemplate));
	
	    return function postLink(scope, element, attr, ctrls) {
	      var chipsController = ctrls.shift();
	      var chipController  = ctrls.shift();
	      $mdTheming(element);
	
	      if (chipsController) {
	        chipController.init(chipsController);
	
	        angular
	          .element(element[0]
	          .querySelector('.md-chip-content'))
	          .on('blur', function () {
	            chipsController.resetSelectedChip();
	            chipsController.$scope.$applyAsync();
	          });
	      }
	    };
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipRemove.$inject = ["$timeout"];angular
	    .module('material.components.chips')
	    .directive('mdChipRemove', MdChipRemove);
	
	/**
	 * @ngdoc directive
	 * @name mdChipRemove
	 * @restrict A
	 * @module material.components.chips
	 *
	 * @description
	 * Designates an element to be used as the delete button for a chip. <br/>
	 * This element is passed as a child of the `md-chips` element.
	 *
	 * The designated button will be just appended to the chip and removes the given chip on click.<br/>
	 * By default the button is not being styled by the `md-chips` component.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chips>
	 *     <button md-chip-remove="">
	 *       <md-icon md-svg-icon="md-close"></md-icon>
	 *     </button>
	 *   </md-chips>
	 * </hljs>
	 */
	
	
	/**
	 * MdChipRemove Directive Definition.
	 * 
	 * @param $timeout
	 * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
	 * @constructor
	 */
	function MdChipRemove ($timeout) {
	  return {
	    restrict: 'A',
	    require: '^mdChips',
	    scope: false,
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrl) {
	    element.on('click', function(event) {
	      scope.$apply(function() {
	        ctrl.removeChip(scope.$$replacedScope.$index);
	      });
	    });
	
	    // Child elements aren't available until after a $timeout tick as they are hidden by an
	    // `ng-if`. see http://goo.gl/zIWfuw
	    $timeout(function() {
	      element.attr({ tabindex: -1, 'aria-hidden': true });
	      element.find('button').attr('tabindex', '-1');
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipTransclude.$inject = ["$compile"];angular
	    .module('material.components.chips')
	    .directive('mdChipTransclude', MdChipTransclude);
	
	function MdChipTransclude ($compile) {
	  return {
	    restrict: 'EA',
	    terminal: true,
	    link: link,
	    scope: false
	  };
	  function link (scope, element, attr) {
	    var ctrl = scope.$parent.$mdChipsCtrl,
	        newScope = ctrl.parent.$new(false, ctrl.parent);
	    newScope.$$replacedScope = scope;
	    newScope.$chip = scope.$chip;
	    newScope.$index = scope.$index;
	    newScope.$mdChipsCtrl = ctrl;
	
	    var newHtml = ctrl.$scope.$eval(attr.mdChipTransclude);
	
	    element.html(newHtml);
	    $compile(element.contents())(newScope);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipsCtrl.$inject = ["$scope", "$attrs", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil"];angular
	    .module('material.components.chips')
	    .controller('MdChipsCtrl', MdChipsCtrl);
	
	/**
	 * Controller for the MdChips component. Responsible for adding to and
	 * removing from the list of chips, marking chips as selected, and binding to
	 * the models of various input components.
	 *
	 * @param $scope
	 * @param $attrs
	 * @param $mdConstant
	 * @param $log
	 * @param $element
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */
	function MdChipsCtrl ($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil) {
	  /** @type {$timeout} **/
	  this.$timeout = $timeout;
	
	  /** @type {Object} */
	  this.$mdConstant = $mdConstant;
	
	  /** @type {angular.$scope} */
	  this.$scope = $scope;
	
	  /** @type {angular.$scope} */
	  this.parent = $scope.$parent;
	
	  /** @type {$log} */
	  this.$log = $log;
	
	  /** @type {$element} */
	  this.$element = $element;
	
	  /** @type {angular.NgModelController} */
	  this.ngModelCtrl = null;
	
	  /** @type {angular.NgModelController} */
	  this.userInputNgModelCtrl = null;
	
	  /** @type {MdAutocompleteCtrl} */
	  this.autocompleteCtrl = null;
	
	  /** @type {Element} */
	  this.userInputElement = null;
	
	  /** @type {Array.<Object>} */
	  this.items = [];
	
	  /** @type {number} */
	  this.selectedChip = -1;
	
	  /** @type {string} */
	  this.enableChipEdit = $mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);
	
	  /** @type {string} */
	  this.addOnBlur = $mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);
	
	  /**
	   * Hidden hint text for how to delete a chip. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteHint = 'Press delete to remove this chip.';
	
	  /**
	   * Hidden label for the delete button. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteButtonLabel = 'Remove';
	
	  /**
	   * Model used by the input element.
	   * @type {string}
	   */
	  this.chipBuffer = '';
	
	  /**
	   * Whether to use the transformChip expression to transform the chip buffer
	   * before appending it to the list.
	   * @type {boolean}
	   */
	  this.useTransformChip = false;
	
	  /**
	   * Whether to use the onAdd expression to notify of chip additions.
	   * @type {boolean}
	   */
	  this.useOnAdd = false;
	
	  /**
	   * Whether to use the onRemove expression to notify of chip removals.
	   * @type {boolean}
	   */
	  this.useOnRemove = false;
	
	  /**
	   * Whether to use the onSelect expression to notify the component's user
	   * after selecting a chip from the list.
	   * @type {boolean}
	   */
	}
	
	/**
	 * Handles the keydown event on the input element: by default <enter> appends
	 * the buffer to the chip list, while backspace removes the last chip in the
	 * list if the current buffer is empty.
	 * @param event
	 */
	MdChipsCtrl.prototype.inputKeydown = function(event) {
	  var chipBuffer = this.getChipBuffer();
	
	  // If we have an autocomplete, and it handled the event, we have nothing to do
	  if (this.autocompleteCtrl && event.isDefaultPrevented && event.isDefaultPrevented()) {
	    return;
	  }
	
	  if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
	    // Only select and focus the previous chip, if the current caret position of the
	    // input element is at the beginning.
	    if (this.getCursorPosition(event.target) !== 0) {
	      return;
	    }
	
	    event.preventDefault();
	    event.stopPropagation();
	
	    if (this.items.length) {
	      this.selectAndFocusChipSafe(this.items.length - 1);
	    }
	
	    return;
	  }
	
	  // By default <enter> appends the buffer to the chip list.
	  if (!this.separatorKeys || this.separatorKeys.length < 1) {
	    this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
	  }
	
	  // Support additional separator key codes in an array of `md-separator-keys`.
	  if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
	    if ((this.autocompleteCtrl && this.requireMatch) || !chipBuffer) return;
	    event.preventDefault();
	
	    // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	    if (this.hasMaxChipsReached()) return;
	
	    this.appendChip(chipBuffer.trim());
	    this.resetChipBuffer();
	  }
	};
	
	/**
	 * Returns the cursor position of the specified input element.
	 * @param element HTMLInputElement
	 * @returns {Number} Cursor Position of the input.
	 */
	MdChipsCtrl.prototype.getCursorPosition = function(element) {
	  /*
	   * Figure out whether the current input for the chips buffer is valid for using
	   * the selectionStart / end property to retrieve the cursor position.
	   * Some browsers do not allow the use of those attributes, on different input types.
	   */
	  try {
	    if (element.selectionStart === element.selectionEnd) {
	      return element.selectionStart;
	    }
	  } catch (e) {
	    if (!element.value) {
	      return 0;
	    }
	  }
	};
	
	
	/**
	 * Updates the content of the chip at given index
	 * @param chipIndex
	 * @param chipContents
	 */
	MdChipsCtrl.prototype.updateChipContents = function(chipIndex, chipContents){
	  if(chipIndex >= 0 && chipIndex < this.items.length) {
	    this.items[chipIndex] = chipContents;
	    this.ngModelCtrl.$setDirty();
	  }
	};
	
	
	/**
	 * Returns true if a chip is currently being edited. False otherwise.
	 * @return {boolean}
	 */
	MdChipsCtrl.prototype.isEditingChip = function() {
	  return !!this.$element[0].getElementsByClassName('_md-chip-editing').length;
	};
	
	
	MdChipsCtrl.prototype.isRemovable = function() {
	  // Return false if we have static chips
	  if (!this.ngModelCtrl) {
	    return false;
	  }
	
	  return this.readonly ? this.removable :
	         angular.isDefined(this.removable) ? this.removable : true;
	};
	
	/**
	 * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
	 * keys switch which chips is active
	 * @param event
	 */
	MdChipsCtrl.prototype.chipKeydown = function (event) {
	  if (this.getChipBuffer()) return;
	  if (this.isEditingChip()) return;
	  
	  switch (event.keyCode) {
	    case this.$mdConstant.KEY_CODE.BACKSPACE:
	    case this.$mdConstant.KEY_CODE.DELETE:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      // Cancel the delete action only after the event cancel. Otherwise the page will go back.
	      if (!this.isRemovable()) return;
	      this.removeAndSelectAdjacentChip(this.selectedChip);
	      break;
	    case this.$mdConstant.KEY_CODE.LEFT_ARROW:
	      event.preventDefault();
	      if (this.selectedChip < 0) this.selectedChip = this.items.length;
	      if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
	      break;
	    case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
	      event.preventDefault();
	      this.selectAndFocusChipSafe(this.selectedChip + 1);
	      break;
	    case this.$mdConstant.KEY_CODE.ESCAPE:
	    case this.$mdConstant.KEY_CODE.TAB:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      this.onFocus();
	      break;
	  }
	};
	
	/**
	 * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
	 * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
	 * always.
	 */
	MdChipsCtrl.prototype.getPlaceholder = function() {
	  // Allow `secondary-placeholder` to be blank.
	  var useSecondary = (this.items && this.items.length &&
	      (this.secondaryPlaceholder == '' || this.secondaryPlaceholder));
	  return useSecondary ? this.secondaryPlaceholder : this.placeholder;
	};
	
	/**
	 * Removes chip at {@code index} and selects the adjacent chip.
	 * @param index
	 */
	MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function(index) {
	  var selIndex = this.getAdjacentChipIndex(index);
	  this.removeChip(index);
	  this.$timeout(angular.bind(this, function () {
	      this.selectAndFocusChipSafe(selIndex);
	  }));
	};
	
	/**
	 * Sets the selected chip index to -1.
	 */
	MdChipsCtrl.prototype.resetSelectedChip = function() {
	  this.selectedChip = -1;
	};
	
	/**
	 * Gets the index of an adjacent chip to select after deletion. Adjacency is
	 * determined as the next chip in the list, unless the target chip is the
	 * last in the list, then it is the chip immediately preceding the target. If
	 * there is only one item in the list, -1 is returned (select none).
	 * The number returned is the index to select AFTER the target has been
	 * removed.
	 * If the current chip is not selected, then -1 is returned to select none.
	 */
	MdChipsCtrl.prototype.getAdjacentChipIndex = function(index) {
	  var len = this.items.length - 1;
	  return (len == 0) ? -1 :
	      (index == len) ? index -1 : index;
	};
	
	/**
	 * Append the contents of the buffer to the chip list. This method will first
	 * call out to the md-transform-chip method, if provided.
	 *
	 * @param newChip
	 */
	MdChipsCtrl.prototype.appendChip = function(newChip) {
	  if (this.useTransformChip && this.transformChip) {
	    var transformedChip = this.transformChip({'$chip': newChip});
	
	    // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
	    // they want the string version.
	    if (angular.isDefined(transformedChip)) {
	      newChip = transformedChip;
	    }
	  }
	
	  // If items contains an identical object to newChip, do not append
	  if (angular.isObject(newChip)){
	    var identical = this.items.some(function(item){
	      return angular.equals(newChip, item);
	    });
	    if (identical) return;
	  }
	
	  // Check for a null (but not undefined), or existing chip and cancel appending
	  if (newChip == null || this.items.indexOf(newChip) + 1) return;
	
	  // Append the new chip onto our list
	  var index = this.items.push(newChip);
	
	  // Update model validation
	  this.ngModelCtrl.$setDirty();
	  this.validateModel();
	
	  // If they provide the md-on-add attribute, notify them of the chip addition
	  if (this.useOnAdd && this.onAdd) {
	    this.onAdd({ '$chip': newChip, '$index': index });
	  }
	};
	
	/**
	 * Sets whether to use the md-transform-chip expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code transformChip}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useTransformChipExpression = function() {
	  this.useTransformChip = true;
	};
	
	/**
	 * Sets whether to use the md-on-add expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onAdd}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnAddExpression = function() {
	  this.useOnAdd = true;
	};
	
	/**
	 * Sets whether to use the md-on-remove expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onRemove}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnRemoveExpression = function() {
	  this.useOnRemove = true;
	};
	
	/*
	 * Sets whether to use the md-on-select expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onSelect}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnSelectExpression = function() {
	  this.useOnSelect = true;
	};
	
	/**
	 * Gets the input buffer. The input buffer can be the model bound to the
	 * default input item {@code this.chipBuffer}, the {@code selectedItem}
	 * model of an {@code md-autocomplete}, or, through some magic, the model
	 * bound to any inpput or text area element found within a
	 * {@code md-input-container} element.
	 * @return {Object|string}
	 */
	MdChipsCtrl.prototype.getChipBuffer = function() {
	  return !this.userInputElement ? this.chipBuffer :
	      this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
	          this.userInputElement[0].value;
	};
	
	/**
	 * Resets the input buffer for either the internal input or user provided input element.
	 */
	MdChipsCtrl.prototype.resetChipBuffer = function() {
	  if (this.userInputElement) {
	    if (this.userInputNgModelCtrl) {
	      this.userInputNgModelCtrl.$setViewValue('');
	      this.userInputNgModelCtrl.$render();
	    } else {
	      this.userInputElement[0].value = '';
	    }
	  } else {
	    this.chipBuffer = '';
	  }
	};
	
	MdChipsCtrl.prototype.hasMaxChipsReached = function() {
	  if (angular.isString(this.maxChips)) this.maxChips = parseInt(this.maxChips, 10) || 0;
	
	  return this.maxChips > 0 && this.items.length >= this.maxChips;
	};
	
	/**
	 * Updates the validity properties for the ngModel.
	 */
	MdChipsCtrl.prototype.validateModel = function() {
	  this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
	};
	
	/**
	 * Removes the chip at the given index.
	 * @param index
	 */
	MdChipsCtrl.prototype.removeChip = function(index) {
	  var removed = this.items.splice(index, 1);
	
	  // Update model validation
	  this.ngModelCtrl.$setDirty();
	  this.validateModel();
	
	  if (removed && removed.length && this.useOnRemove && this.onRemove) {
	    this.onRemove({ '$chip': removed[0], '$index': index });
	  }
	};
	
	MdChipsCtrl.prototype.removeChipAndFocusInput = function (index) {
	  this.removeChip(index);
	
	  if (this.autocompleteCtrl) {
	    // Always hide the autocomplete dropdown before focusing the autocomplete input.
	    // Wait for the input to move horizontally, because the chip was removed.
	    // This can lead to an incorrect dropdown position.
	    this.autocompleteCtrl.hidden = true;
	    this.$mdUtil.nextTick(this.onFocus.bind(this));
	  } else {
	    this.onFocus();
	  }
	
	};
	/**
	 * Selects the chip at `index`,
	 * @param index
	 */
	MdChipsCtrl.prototype.selectAndFocusChipSafe = function(index) {
	  if (!this.items.length) {
	    this.selectChip(-1);
	    this.onFocus();
	    return;
	  }
	  if (index === this.items.length) return this.onFocus();
	  index = Math.max(index, 0);
	  index = Math.min(index, this.items.length - 1);
	  this.selectChip(index);
	  this.focusChip(index);
	};
	
	/**
	 * Marks the chip at the given index as selected.
	 * @param index
	 */
	MdChipsCtrl.prototype.selectChip = function(index) {
	  if (index >= -1 && index <= this.items.length) {
	    this.selectedChip = index;
	
	    // Fire the onSelect if provided
	    if (this.useOnSelect && this.onSelect) {
	      this.onSelect({'$chip': this.items[this.selectedChip] });
	    }
	  } else {
	    this.$log.warn('Selected Chip index out of bounds; ignoring.');
	  }
	};
	
	/**
	 * Selects the chip at `index` and gives it focus.
	 * @param index
	 */
	MdChipsCtrl.prototype.selectAndFocusChip = function(index) {
	  this.selectChip(index);
	  if (index != -1) {
	    this.focusChip(index);
	  }
	};
	
	/**
	 * Call `focus()` on the chip at `index`
	 */
	MdChipsCtrl.prototype.focusChip = function(index) {
	  this.$element[0].querySelector('md-chip[index="' + index + '"] .md-chip-content').focus();
	};
	
	/**
	 * Configures the required interactions with the ngModel Controller.
	 * Specifically, set {@code this.items} to the {@code NgModelCtrl#$viewVale}.
	 * @param ngModelCtrl
	 */
	MdChipsCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	  this.ngModelCtrl = ngModelCtrl;
	
	  var self = this;
	  ngModelCtrl.$render = function() {
	    // model is updated. do something.
	    self.items = self.ngModelCtrl.$viewValue;
	  };
	};
	
	MdChipsCtrl.prototype.onFocus = function () {
	  var input = this.$element[0].querySelector('input');
	  input && input.focus();
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputFocus = function () {
	  this.inputHasFocus = true;
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputBlur = function () {
	  this.inputHasFocus = false;
	
	  var chipBuffer = this.getChipBuffer().trim();
	
	  // Update the custom chip validators.
	  this.validateModel();
	
	  var isModelValid = this.ngModelCtrl.$valid;
	
	  if (this.userInputNgModelCtrl) {
	    isModelValid &= this.userInputNgModelCtrl.$valid;
	  }
	
	  // Only append the chip and reset the chip buffer if the chips and input ngModel is valid.
	  if (this.addOnBlur && chipBuffer && isModelValid) {
	    this.appendChip(chipBuffer);
	    this.resetChipBuffer();
	  }
	};
	
	/**
	 * Configure event bindings on a user-provided input element.
	 * @param inputElement
	 */
	MdChipsCtrl.prototype.configureUserInput = function(inputElement) {
	  this.userInputElement = inputElement;
	
	  // Find the NgModelCtrl for the input element
	  var ngModelCtrl = inputElement.controller('ngModel');
	  // `.controller` will look in the parent as well.
	  if (ngModelCtrl != this.ngModelCtrl) {
	    this.userInputNgModelCtrl = ngModelCtrl;
	  }
	
	  var scope = this.$scope;
	  var ctrl = this;
	
	  // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
	  var scopeApplyFn = function(event, fn) {
	    scope.$evalAsync(angular.bind(ctrl, fn, event));
	  };
	
	  // Bind to keydown and focus events of input
	  inputElement
	      .attr({ tabindex: 0 })
	      .on('keydown', function(event) { scopeApplyFn(event, ctrl.inputKeydown) })
	      .on('focus', function(event) { scopeApplyFn(event, ctrl.onInputFocus) })
	      .on('blur', function(event) { scopeApplyFn(event, ctrl.onInputBlur) })
	};
	
	MdChipsCtrl.prototype.configureAutocomplete = function(ctrl) {
	  if (ctrl) {
	    this.autocompleteCtrl = ctrl;
	
	    ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
	      if (item) {
	        // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	        if (this.hasMaxChipsReached()) return;
	
	        this.appendChip(item);
	        this.resetChipBuffer();
	      }
	    }));
	
	    this.$element.find('input')
	        .on('focus',angular.bind(this, this.onInputFocus) )
	        .on('blur', angular.bind(this, this.onInputBlur) );
	  }
	};
	
	MdChipsCtrl.prototype.hasFocus = function () {
	  return this.inputHasFocus || this.selectedChip >= 0;
	};
	
	})();
	(function(){
	"use strict";
	
	  
	  MdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout", "$$mdSvgRegistry"];angular
	      .module('material.components.chips')
	      .directive('mdChips', MdChips);
	
	  /**
	   * @ngdoc directive
	   * @name mdChips
	   * @module material.components.chips
	   *
	   * @description
	   * `<md-chips>` is an input component for building lists of strings or objects. The list items are
	   * displayed as 'chips'. This component can make use of an `<input>` element or an 
	   * `<md-autocomplete>` element.
	   *
	   * ### Custom templates
	   * A custom template may be provided to render the content of each chip. This is achieved by
	   * specifying an `<md-chip-template>` element containing the custom content as a child of
	   * `<md-chips>`.
	   *
	   * Note: Any attributes on
	   * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
	   * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
	   * the chip object and its index in the list of chips, respectively.
	   * To override the chip delete control, include an element (ideally a button) with the attribute
	   * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
	   * is also placed as a sibling to the chip content (on which there are also click listeners) to
	   * avoid a nested ng-click situation.
	   *
	   * <h3> Pending Features </h3>
	   * <ul style="padding-left:20px;">
	   *
	   *   <ul>Style
	   *     <li>Colours for hover, press states (ripple?).</li>
	   *   </ul>
	   *
	   *   <ul>Validation
	   *     <li>allow a validation callback</li>
	   *     <li>hilighting style for invalid chips</li>
	   *   </ul>
	   *
	   *   <ul>Item mutation
	   *     <li>Support `
	   *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
	   *       click?
	   *     </li>
	   *   </ul>
	   *
	   *   <ul>Truncation and Disambiguation (?)
	   *     <li>Truncate chip text where possible, but do not truncate entries such that two are
	   *     indistinguishable.</li>
	   *   </ul>
	   *
	   *   <ul>Drag and Drop
	   *     <li>Drag and drop chips between related `<md-chips>` elements.
	   *     </li>
	   *   </ul>
	   * </ul>
	   *
	   * <span style="font-size:.8em;text-align:center">
	   *   Warning: This component is a WORK IN PROGRESS. If you use it now,
	   *   it will probably break on you in the future.
	   * </span>
	   *
	   * Sometimes developers want to limit the amount of possible chips.<br/>
	   * You can specify the maximum amount of chips by using the following markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *   </md-chips>
	   * </hljs>
	   *
	   * In some cases, you have an autocomplete inside of the `md-chips`.<br/>
	   * When the maximum amount of chips has been reached, you can also disable the autocomplete selection.<br/>
	   * Here is an example markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips ng-model="myItems" md-max-chips="5">
	   *     <md-autocomplete ng-hide="myItems.length > 5" ...></md-autocomplete>
	   *   </md-chips>
	   * </hljs>
	   *
	   * @param {string=|object=} ng-model A model to bind the list of items to
	   * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	   * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	   *    displayed when there is at least one item in the list
	   * @param {boolean=} md-removable Enables or disables the deletion of chips through the
	   *    removal icon or the Delete/Backspace key. Defaults to true.
	   * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
	   *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
	   *    marked as readonly.<br/><br/>
	   *    When `md-removable` is not defined, the `md-remove` behavior will be overwritten and disabled.
	   * @param {string=} md-enable-chip-edit Set this to "true" to enable editing of chip contents. The user can 
	   *    go into edit mode with pressing "space", "enter", or double clicking on the chip. Chip edit is only
	   *    supported for chips with basic template.
	   * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
	   *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
	   *    amount is reached.
	   * @param {boolean=} md-add-on-blur When set to true, remaining text inside of the input will
	   *    be converted into a new chip on blur.
	   * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when called
	   *    expects one of the following return values:
	   *    - an object representing the `$chip` input string
	   *    - `undefined` to simply add the `$chip` input string, or
	   *    - `null` to prevent the chip from being appended
	   * @param {expression=} md-on-add An expression which will be called when a chip has been
	   *    added.
	   * @param {expression=} md-on-remove An expression which will be called when a chip has been
	   *    removed.
	   * @param {expression=} md-on-select An expression which will be called when a chip is selected.
	   * @param {boolean} md-require-match If true, and the chips template contains an autocomplete,
	   *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
	   * @param {string=} delete-hint A string read by screen readers instructing users that pressing
	   *    the delete key will remove the chip.
	   * @param {string=} delete-button-label A label for the delete button. Also hidden and read by
	   *    screen readers.
	   * @param {expression=} md-separator-keys An array of key codes used to separate chips.
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       readonly="isReadOnly">
	   *   </md-chips>
	   * </hljs>
	   *
	   * <h3>Validation</h3>
	   * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
	   * on our custom validators.
	   * <hljs lang="html">
	   *   <form name="userForm">
	   *     <md-chips
	   *       name="fruits"
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *     </md-chips>
	   *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
	   *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
	   *    </div>
	   *   </form>
	   * </hljs>
	   *
	   */
	
	
	  var MD_CHIPS_TEMPLATE = '\
	      <md-chips-wrap\
	          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
	          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
	                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
	                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
	          class="md-chips">\
	        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
	            index="{{$index}}"\
	            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
	          <div class="md-chip-content"\
	              tabindex="-1"\
	              aria-hidden="true"\
	              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
	              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
	              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
	          <div ng-if="$mdChipsCtrl.isRemovable()"\
	               class="md-chip-remove-container"\
	               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
	        </md-chip>\
	        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
	          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
	        </div>\
	      </md-chips-wrap>';
	
	  var CHIP_INPUT_TEMPLATE = '\
	        <input\
	            class="md-input"\
	            tabindex="0"\
	            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
	            aria-label="{{$mdChipsCtrl.getPlaceholder()}}"\
	            ng-model="$mdChipsCtrl.chipBuffer"\
	            ng-focus="$mdChipsCtrl.onInputFocus()"\
	            ng-blur="$mdChipsCtrl.onInputBlur()"\
	            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';
	
	  var CHIP_DEFAULT_TEMPLATE = '\
	      <span>{{$chip}}</span>';
	
	  var CHIP_REMOVE_TEMPLATE = '\
	      <button\
	          class="md-chip-remove"\
	          ng-if="$mdChipsCtrl.isRemovable()"\
	          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)"\
	          type="button"\
	          aria-hidden="true"\
	          tabindex="-1">\
	        <md-icon md-svg-src="{{ $mdChipsCtrl.mdCloseIcon }}"></md-icon>\
	        <span class="md-visually-hidden">\
	          {{$mdChipsCtrl.deleteButtonLabel}}\
	        </span>\
	      </button>';
	
	  /**
	   * MDChips Directive Definition
	   */
	  function MdChips ($mdTheming, $mdUtil, $compile, $log, $timeout, $$mdSvgRegistry) {
	    // Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
	    var templates = getTemplates();
	
	    return {
	      template: function(element, attrs) {
	        // Clone the element into an attribute. By prepending the attribute
	        // name with '$', Angular won't write it into the DOM. The cloned
	        // element propagates to the link function via the attrs argument,
	        // where various contained-elements can be consumed.
	        attrs['$mdUserTemplate'] = element.clone();
	        return templates.chips;
	      },
	      require: ['mdChips'],
	      restrict: 'E',
	      controller: 'MdChipsCtrl',
	      controllerAs: '$mdChipsCtrl',
	      bindToController: true,
	      compile: compile,
	      scope: {
	        readonly: '=readonly',
	        removable: '=mdRemovable',
	        placeholder: '@',
	        secondaryPlaceholder: '@',
	        maxChips: '@mdMaxChips',
	        transformChip: '&mdTransformChip',
	        onAppend: '&mdOnAppend',
	        onAdd: '&mdOnAdd',
	        onRemove: '&mdOnRemove',
	        onSelect: '&mdOnSelect',
	        deleteHint: '@',
	        deleteButtonLabel: '@',
	        separatorKeys: '=?mdSeparatorKeys',
	        requireMatch: '=?mdRequireMatch'
	      }
	    };
	
	    /**
	     * Builds the final template for `md-chips` and returns the postLink function.
	     *
	     * Building the template involves 3 key components:
	     * static chips
	     * chip template
	     * input control
	     *
	     * If no `ng-model` is provided, only the static chip work needs to be done.
	     *
	     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
	     * template is appended to the chip content element.
	     *
	     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
	     *
	     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
	     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
	     * If no user input is provided, a default one is appended to the input container node in the
	     * template.
	     *
	     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
	     * transclusion in the `postLink` function.
	     *
	     *
	     * @param element
	     * @param attr
	     * @returns {Function}
	     */
	    function compile(element, attr) {
	      // Grab the user template from attr and reset the attribute to null.
	      var userTemplate = attr['$mdUserTemplate'];
	      attr['$mdUserTemplate'] = null;
	
	      var chipTemplate = getTemplateByQuery('md-chips>md-chip-template');
	
	      var chipRemoveSelector = $mdUtil
	        .prefixer()
	        .buildList('md-chip-remove')
	        .map(function(attr) {
	          return 'md-chips>*[' + attr + ']';
	        })
	        .join(',');
	
	      // Set the chip remove, chip contents and chip input templates. The link function will put
	      // them on the scope for transclusion later.
	      var chipRemoveTemplate   = getTemplateByQuery(chipRemoveSelector) || templates.remove,
	          chipContentsTemplate = chipTemplate || templates.default,
	          chipInputTemplate    = getTemplateByQuery('md-chips>md-autocomplete')
	              || getTemplateByQuery('md-chips>input')
	              || templates.input,
	          staticChips = userTemplate.find('md-chip');
	
	      // Warn of malformed template. See #2545
	      if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
	        $log.warn('invalid placement of md-chip-remove within md-chip-template.');
	      }
	
	      function getTemplateByQuery (query) {
	        if (!attr.ngModel) return;
	        var element = userTemplate[0].querySelector(query);
	        return element && element.outerHTML;
	      }
	
	      /**
	       * Configures controller and transcludes.
	       */
	      return function postLink(scope, element, attrs, controllers) {
	        $mdUtil.initOptionalProperties(scope, attr);
	
	        $mdTheming(element);
	        var mdChipsCtrl = controllers[0];
	        if(chipTemplate) {
	          // Chip editing functionality assumes we are using the default chip template.
	          mdChipsCtrl.enableChipEdit = false;
	        }
	
	        mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
	        mdChipsCtrl.chipRemoveTemplate   = chipRemoveTemplate;
	        mdChipsCtrl.chipInputTemplate    = chipInputTemplate;
	
	        mdChipsCtrl.mdCloseIcon = $$mdSvgRegistry.mdClose;
	
	        element
	            .attr({ 'aria-hidden': true, tabindex: -1 })
	            .on('focus', function () { mdChipsCtrl.onFocus(); });
	
	        if (attr.ngModel) {
	          mdChipsCtrl.configureNgModel(element.controller('ngModel'));
	
	          // If an `md-transform-chip` attribute was set, tell the controller to use the expression
	          // before appending chips.
	          if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();
	
	          // If an `md-on-append` attribute was set, tell the controller to use the expression
	          // when appending chips.
	          //
	          // DEPRECATED: Will remove in official 1.0 release
	          if (attrs.mdOnAppend) mdChipsCtrl.useOnAppendExpression();
	
	          // If an `md-on-add` attribute was set, tell the controller to use the expression
	          // when adding chips.
	          if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();
	
	          // If an `md-on-remove` attribute was set, tell the controller to use the expression
	          // when removing chips.
	          if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();
	
	          // If an `md-on-select` attribute was set, tell the controller to use the expression
	          // when selecting chips.
	          if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();
	
	          // The md-autocomplete and input elements won't be compiled until after this directive
	          // is complete (due to their nested nature). Wait a tick before looking for them to
	          // configure the controller.
	          if (chipInputTemplate != templates.input) {
	            // The autocomplete will not appear until the readonly attribute is not true (i.e.
	            // false or undefined), so we have to watch the readonly and then on the next tick
	            // after the chip transclusion has run, we can configure the autocomplete and user
	            // input.
	            scope.$watch('$mdChipsCtrl.readonly', function(readonly) {
	              if (!readonly) {
	
	                $mdUtil.nextTick(function(){
	
	                  if (chipInputTemplate.indexOf('<md-autocomplete') === 0) {
	                    var autocompleteEl = element.find('md-autocomplete');
	                    mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('mdAutocomplete'));
	                  }
	
	                  mdChipsCtrl.configureUserInput(element.find('input'));
	                });
	              }
	            });
	          }
	
	          // At the next tick, if we find an input, make sure it has the md-input class
	          $mdUtil.nextTick(function() {
	            var input = element.find('input');
	
	            input && input.toggleClass('md-input', true);
	          });
	        }
	
	        // Compile with the parent's scope and prepend any static chips to the wrapper.
	        if (staticChips.length > 0) {
	          var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
	          $timeout(function() { element.find('md-chips-wrap').prepend(compiledStaticChips); });
	        }
	      };
	    }
	
	    function getTemplates() {
	      return {
	        chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
	        input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
	        default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
	        remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
	      };
	    }
	  }
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.chips')
	    .controller('MdContactChipsCtrl', MdContactChipsCtrl);
	
	
	
	/**
	 * Controller for the MdContactChips component
	 * @constructor
	 */
	function MdContactChipsCtrl () {
	  /** @type {Object} */
	  this.selectedItem = null;
	
	  /** @type {string} */
	  this.searchText = '';
	}
	
	
	MdContactChipsCtrl.prototype.queryContact = function(searchText) {
	  var results = this.contactQuery({'$query': searchText});
	  return this.filterSelected ?
	      results.filter(angular.bind(this, this.filterSelectedContacts)) : results;
	};
	
	
	MdContactChipsCtrl.prototype.itemName = function(item) {
	  return item[this.contactName];
	};
	
	
	MdContactChipsCtrl.prototype.filterSelectedContacts = function(contact) {
	  return this.contacts.indexOf(contact) == -1;
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdContactChips.$inject = ["$mdTheming", "$mdUtil"];angular
	  .module('material.components.chips')
	  .directive('mdContactChips', MdContactChips);
	
	/**
	 * @ngdoc directive
	 * @name mdContactChips
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
	 * `md-autocomplete` element. The component allows the caller to supply a query expression which
	 * returns  a list of possible contacts. The user can select one of these and add it to the list of
	 * chips.
	 *
	 * You may also use the `md-highlight-text` directive along with its parameters to control the
	 * appearance of the matched text inside of the contacts' autocomplete popup.
	 *
	 * @param {string=|object=} ng-model A model to bind the list of items to
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	 *    displayed when there is at least on item in the list
	 * @param {expression} md-contacts An expression expected to return contacts matching the search
	 *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
	 *    waiting for it to resolve.
	 * @param {string} md-contact-name The field name of the contact object representing the
	 *    contact's name.
	 * @param {string} md-contact-email The field name of the contact object representing the
	 *    contact's email address.
	 * @param {string} md-contact-image The field name of the contact object representing the
	 *    contact's image.
	 *
	 *
	 * @param {expression=} filter-selected Whether to filter selected contacts from the list of
	 *    suggestions shown in the autocomplete. This attribute has been removed but may come back.
	 *
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-contact-chips
	 *       ng-model="ctrl.contacts"
	 *       md-contacts="ctrl.querySearch($query)"
	 *       md-contact-name="name"
	 *       md-contact-image="image"
	 *       md-contact-email="email"
	 *       placeholder="To">
	 *   </md-contact-chips>
	 * </hljs>
	 *
	 */
	
	
	var MD_CONTACT_CHIPS_TEMPLATE = '\
	      <md-chips class="md-contact-chips"\
	          ng-model="$mdContactChipsCtrl.contacts"\
	          md-require-match="$mdContactChipsCtrl.requireMatch"\
	          md-autocomplete-snap>\
	          <md-autocomplete\
	              md-menu-class="md-contact-chips-suggestions"\
	              md-selected-item="$mdContactChipsCtrl.selectedItem"\
	              md-search-text="$mdContactChipsCtrl.searchText"\
	              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
	              md-item-text="$mdContactChipsCtrl.itemName(item)"\
	              md-no-cache="true"\
	              md-autoselect\
	              placeholder="{{$mdContactChipsCtrl.contacts.length == 0 ?\
	                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
	            <div class="md-contact-suggestion">\
	              <img \
	                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
	              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
	                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
	                {{item[$mdContactChipsCtrl.contactName]}}\
	              </span>\
	              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
	            </div>\
	          </md-autocomplete>\
	          <md-chip-template>\
	            <div class="md-contact-avatar">\
	              <img \
	                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
	            </div>\
	            <div class="md-contact-name">\
	              {{$chip[$mdContactChipsCtrl.contactName]}}\
	            </div>\
	          </md-chip-template>\
	      </md-chips>';
	
	
	/**
	 * MDContactChips Directive Definition
	 *
	 * @param $mdTheming
	 * @returns {*}
	 * @ngInject
	 */
	function MdContactChips($mdTheming, $mdUtil) {
	  return {
	    template: function(element, attrs) {
	      return MD_CONTACT_CHIPS_TEMPLATE;
	    },
	    restrict: 'E',
	    controller: 'MdContactChipsCtrl',
	    controllerAs: '$mdContactChipsCtrl',
	    bindToController: true,
	    compile: compile,
	    scope: {
	      contactQuery: '&mdContacts',
	      placeholder: '@',
	      secondaryPlaceholder: '@',
	      contactName: '@mdContactName',
	      contactImage: '@mdContactImage',
	      contactEmail: '@mdContactEmail',
	      contacts: '=ngModel',
	      requireMatch: '=?mdRequireMatch',
	      highlightFlags: '@?mdHighlightFlags'
	    }
	  };
	
	  function compile(element, attr) {
	    return function postLink(scope, element, attrs, controllers) {
	
	      $mdUtil.initOptionalProperties(scope, attr);
	      $mdTheming(element);
	
	      element.attr('tabindex', '-1');
	    };
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name mdCalendar
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Should be a Date object.
	   * @param {Date=} md-min-date Expression representing the minimum date.
	   * @param {Date=} md-max-date Expression representing the maximum date.
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
	   *
	   * @description
	   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
	   * It is a part of the `<md-datepicker` pane, however it can also be used on it's own.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   *   <md-calendar ng-model="birthday"></md-calendar>
	   * </hljs>
	   */
	  CalendarCtrl.$inject = ["$element", "$scope", "$$mdDateUtil", "$mdUtil", "$mdConstant", "$mdTheming", "$$rAF", "$attrs", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendar', calendarDirective);
	
	  // POST RELEASE
	  // TODO(jelbourn): Mac Cmd + left / right == Home / End
	  // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
	  // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
	  // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
	  // TODO(jelbourn): Scroll snapping (virtual repeat)
	  // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
	  // TODO(jelbourn): Month headers stick to top when scrolling.
	  // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
	  // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
	  //     announcement and key handling).
	  // Read-only calendar (not just date-picker).
	
	  function calendarDirective() {
	    return {
	      template: function(tElement, tAttr) {
	        // TODO(crisbeto): This is a workaround that allows the calendar to work, without
	        // a datepicker, until issue #8585 gets resolved. It can safely be removed
	        // afterwards. This ensures that the virtual repeater scrolls to the proper place on load by
	        // deferring the execution until the next digest. It's necessary only if the calendar is used
	        // without a datepicker, otherwise it's already wrapped in an ngIf.
	        var extraAttrs = tAttr.hasOwnProperty('ngIf') ? '' : 'ng-if="calendarCtrl.isInitialized"';
	        var template = '' +
	          '<div ng-switch="calendarCtrl.currentView" ' + extraAttrs + '>' +
	            '<md-calendar-year ng-switch-when="year"></md-calendar-year>' +
	            '<md-calendar-month ng-switch-default></md-calendar-month>' +
	          '</div>';
	
	        return template;
	      },
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        dateFilter: '=mdDateFilter',
	        _currentView: '@mdCurrentView'
	      },
	      require: ['ngModel', 'mdCalendar'],
	      controller: CalendarCtrl,
	      controllerAs: 'calendarCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdCalendarCtrl = controllers[1];
	        mdCalendarCtrl.configureNgModel(ngModelCtrl);
	      }
	    };
	  }
	
	  /**
	   * Occasionally the hideVerticalScrollbar method might read an element's
	   * width as 0, because it hasn't been laid out yet. This value will be used
	   * as a fallback, in order to prevent scenarios where the element's width
	   * would otherwise have been set to 0. This value is the "usual" width of a
	   * calendar within a floating calendar pane.
	   */
	  var FALLBACK_WIDTH = 340;
	
	  /** Next identifier for calendar instance. */
	  var nextUniqueId = 0;
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarCtrl($element, $scope, $$mdDateUtil, $mdUtil,
	    $mdConstant, $mdTheming, $$rAF, $attrs, $mdDateLocale) {
	
	    $mdTheming($element);
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.keyCode = $mdConstant.KEY_CODE;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final {Date} */
	    this.today = this.dateUtil.createDateAtMidnight();
	
	    /** @type {!angular.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /**
	     * The currently visible calendar view. Note the prefix on the scope value,
	     * which is necessary, because the datepicker seems to reset the real one value if the
	     * calendar is open, but the value on the datepicker's scope is empty.
	     * @type {String}
	     */
	    this.currentView = this._currentView || 'month';
	
	    /** @type {String} Class applied to the selected date cell. */
	    this.SELECTED_DATE_CLASS = 'md-calendar-selected-date';
	
	    /** @type {String} Class applied to the cell for today. */
	    this.TODAY_CLASS = 'md-calendar-date-today';
	
	    /** @type {String} Class applied to the focused cell. */
	    this.FOCUSED_DATE_CLASS = 'md-focus';
	
	    /** @final {number} Unique ID for this calendar instance. */
	    this.id = nextUniqueId++;
	
	    /**
	     * The date that is currently focused or showing in the calendar. This will initially be set
	     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
	     * to other months. The cell corresponding to the displayDate does not necesarily always have
	     * focus in the document (such as for cases when the user is scrolling the calendar).
	     * @type {Date}
	     */
	    this.displayDate = null;
	
	    /**
	     * The selected date. Keep track of this separately from the ng-model value so that we
	     * can know, when the ng-model value changes, what the previous value was before it's updated
	     * in the component's UI.
	     *
	     * @type {Date}
	     */
	    this.selectedDate = null;
	
	    /**
	     * The first date that can be rendered by the calendar. The default is taken
	     * from the mdDateLocale provider and is limited by the mdMinDate.
	     * @type {Date}
	     */
	    this.firstRenderableDate = null;
	
	    /**
	     * The last date that can be rendered by the calendar. The default comes
	     * from the mdDateLocale provider and is limited by the maxDate.
	     * @type {Date}
	     */
	    this.lastRenderableDate = null;
	
	    /**
	     * Used to toggle initialize the root element in the next digest.
	     * @type {Boolean}
	     */
	    this.isInitialized = false;
	
	    /**
	     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
	     * and to avoid extra reflows when switching between views.
	     * @type {Number}
	     */
	    this.width = 0;
	
	    /**
	     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
	     * @type {Number}
	     */
	    this.scrollbarWidth = 0;
	
	    // Unless the user specifies so, the calendar should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if (!$attrs.tabindex) {
	      $element.attr('tabindex', '-1');
	    }
	
	    var boundKeyHandler = angular.bind(this, this.handleKeyEvent);
	
	    // Bind the keydown handler to the body, in order to handle cases where the focused
	    // element gets removed from the DOM and stops propagating click events.
	    angular.element(document.body).on('keydown', boundKeyHandler);
	
	    $scope.$on('$destroy', function() {
	      angular.element(document.body).off('keydown', boundKeyHandler);
	    });
	
	    if (this.minDate && this.minDate > $mdDateLocale.firstRenderableDate) {
	      this.firstRenderableDate = this.minDate;
	    } else {
	      this.firstRenderableDate = $mdDateLocale.firstRenderableDate;
	    }
	
	    if (this.maxDate && this.maxDate < $mdDateLocale.lastRenderableDate) {
	      this.lastRenderableDate = this.maxDate;
	    } else {
	      this.lastRenderableDate = $mdDateLocale.lastRenderableDate;
	    }
	  }
	
	  /**
	   * Sets up the controller's reference to ngModelController.
	   * @param {!angular.NgModelController} ngModelCtrl
	   */
	  CalendarCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	    var self = this;
	
	    self.ngModelCtrl = ngModelCtrl;
	
	    self.$mdUtil.nextTick(function() {
	      self.isInitialized = true;
	    });
	
	    ngModelCtrl.$render = function() {
	      var value = this.$viewValue;
	
	      // Notify the child scopes of any changes.
	      self.$scope.$broadcast('md-calendar-parent-changed', value);
	
	      // Set up the selectedDate if it hasn't been already.
	      if (!self.selectedDate) {
	        self.selectedDate = value;
	      }
	
	      // Also set up the displayDate.
	      if (!self.displayDate) {
	        self.displayDate = self.selectedDate || self.today;
	      }
	    };
	  };
	
	  /**
	   * Sets the ng-model value for the calendar and emits a change event.
	   * @param {Date} date
	   */
	  CalendarCtrl.prototype.setNgModelValue = function(date) {
	    var value = this.dateUtil.createDateAtMidnight(date);
	    this.focus(value);
	    this.$scope.$emit('md-calendar-change', value);
	    this.ngModelCtrl.$setViewValue(value);
	    this.ngModelCtrl.$render();
	    return value;
	  };
	
	  /**
	   * Sets the current view that should be visible in the calendar
	   * @param {string} newView View name to be set.
	   * @param {number|Date} time Date object or a timestamp for the new display date.
	   */
	  CalendarCtrl.prototype.setCurrentView = function(newView, time) {
	    var self = this;
	
	    self.$mdUtil.nextTick(function() {
	      self.currentView = newView;
	
	      if (time) {
	        self.displayDate = angular.isDate(time) ? time : new Date(time);
	      }
	    });
	  };
	
	  /**
	   * Focus the cell corresponding to the given date.
	   * @param {Date} date The date to be focused.
	   */
	  CalendarCtrl.prototype.focus = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var previousFocus = this.$element[0].querySelector('.md-focus');
	      if (previousFocus) {
	        previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);
	      }
	
	      var cellId = this.getDateId(date, this.currentView);
	      var cell = document.getElementById(cellId);
	      if (cell) {
	        cell.classList.add(this.FOCUSED_DATE_CLASS);
	        cell.focus();
	        this.displayDate = date;
	      }
	    } else {
	      var rootElement = this.$element[0].querySelector('[ng-switch]');
	
	      if (rootElement) {
	        rootElement.focus();
	      }
	    }
	  };
	
	  /**
	   * Normalizes the key event into an action name. The action will be broadcast
	   * to the child controllers.
	   * @param {KeyboardEvent} event
	   * @returns {String} The action that should be taken, or null if the key
	   * does not match a calendar shortcut.
	   */
	  CalendarCtrl.prototype.getActionFromKeyEvent = function(event) {
	    var keyCode = this.keyCode;
	
	    switch (event.which) {
	      case keyCode.ENTER: return 'select';
	
	      case keyCode.RIGHT_ARROW: return 'move-right';
	      case keyCode.LEFT_ARROW: return 'move-left';
	
	      // TODO(crisbeto): Might want to reconsider using metaKey, because it maps
	      // to the "Windows" key on PC, which opens the start menu or resizes the browser.
	      case keyCode.DOWN_ARROW: return event.metaKey ? 'move-page-down' : 'move-row-down';
	      case keyCode.UP_ARROW: return event.metaKey ? 'move-page-up' : 'move-row-up';
	
	      case keyCode.PAGE_DOWN: return 'move-page-down';
	      case keyCode.PAGE_UP: return 'move-page-up';
	
	      case keyCode.HOME: return 'start';
	      case keyCode.END: return 'end';
	
	      default: return null;
	    }
	  };
	
	  /**
	   * Handles a key event in the calendar with the appropriate action. The action will either
	   * be to select the focused date or to navigate to focus a new date.
	   * @param {KeyboardEvent} event
	   */
	  CalendarCtrl.prototype.handleKeyEvent = function(event) {
	    var self = this;
	
	    this.$scope.$apply(function() {
	      // Capture escape and emit back up so that a wrapping component
	      // (such as a date-picker) can decide to close.
	      if (event.which == self.keyCode.ESCAPE || event.which == self.keyCode.TAB) {
	        self.$scope.$emit('md-calendar-close');
	
	        if (event.which == self.keyCode.TAB) {
	          event.preventDefault();
	        }
	
	        return;
	      }
	
	      // Broadcast the action that any child controllers should take.
	      var action = self.getActionFromKeyEvent(event);
	      if (action) {
	        event.preventDefault();
	        event.stopPropagation();
	        self.$scope.$broadcast('md-calendar-parent-action', action);
	      }
	    });
	  };
	
	  /**
	   * Hides the vertical scrollbar on the calendar scroller of a child controller by
	   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
	   * around the scroller, and then setting a padding-right on the scroller equal
	   * to the width of the browser's scrollbar.
	   *
	   * This will cause a reflow.
	   *
	   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
	   */
	  CalendarCtrl.prototype.hideVerticalScrollbar = function(childCtrl) {
	    var self = this;
	    var element = childCtrl.$element[0];
	    var scrollMask = element.querySelector('.md-calendar-scroll-mask');
	
	    if (self.width > 0) {
	      setWidth();
	    } else {
	      self.$$rAF(function() {
	        var scroller = childCtrl.calendarScroller;
	
	        self.scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;
	        self.width = element.querySelector('table').offsetWidth;
	        setWidth();
	      });
	    }
	
	    function setWidth() {
	      var width = self.width || FALLBACK_WIDTH;
	      var scrollbarWidth = self.scrollbarWidth;
	      var scroller = childCtrl.calendarScroller;
	
	      scrollMask.style.width = width + 'px';
	      scroller.style.width = (width + scrollbarWidth) + 'px';
	      scroller.style.paddingRight = scrollbarWidth + 'px';
	    }
	  };
	
	  /**
	   * Gets an identifier for a date unique to the calendar instance for internal
	   * purposes. Not to be displayed.
	   * @param {Date} date The date for which the id is being generated
	   * @param {string} namespace Namespace for the id. (month, year etc.)
	   * @returns {string}
	   */
	  CalendarCtrl.prototype.getDateId = function(date, namespace) {
	    if (!namespace) {
	      throw new Error('A namespace for the date id has to be specified.');
	    }
	
	    return [
	      'md',
	      this.id,
	      namespace,
	      date.getFullYear(),
	      date.getMonth(),
	      date.getDate()
	    ].join('-');
	  };
	
	  /**
	   * Util to trigger an extra digest on a parent scope, in order to to ensure that
	   * any child virtual repeaters have updated. This is necessary, because the virtual
	   * repeater doesn't update the $index the first time around since the content isn't
	   * in place yet. The case, in which this is an issue, is when the repeater has less
	   * than a page of content (e.g. a month or year view has a min or max date).
	   */
	  CalendarCtrl.prototype.updateVirtualRepeat = function() {
	    var scope = this.$scope;
	    var virtualRepeatResizeListener = scope.$on('$md-resize-enable', function() {
	      if (!scope.$$phase) {
	        scope.$apply();
	      }
	
	      virtualRepeatResizeListener();
	    });
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarMonthCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarMonth', calendarDirective);
	
	  /**
	   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific months.
	   */
	  var TBODY_HEIGHT = 265;
	
	  /**
	   * Height of a calendar month with a single row. This is needed to calculate the offset for
	   * rendering an extra month in virtual-repeat that only contains one row.
	   */
	  var TBODY_SINGLE_ROW_HEIGHT = 45;
	
	  /** Private directive that represents a list of months inside the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
	        '<div class="md-calendar-scroll-mask">' +
	        '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
	              'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-month-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in monthCtrl.items" ' +
	                  'md-month-offset="$index" ' +
	                  'class="md-calendar-month" ' +
	                  'md-start-index="monthCtrl.getSelectedMonthIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '"></tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarMonth'],
	      controller: CalendarMonthCtrl,
	      controllerAs: 'monthCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        monthCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the calendar month component.
	   * @ngInject @constructor
	   */
	  function CalendarMonthCtrl($element, $scope, $animate, $q,
	    $$mdDateUtil, $mdDateLocale) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      var timestamp = $$mdDateUtil.getTimestampFromNode(this);
	      self.$scope.$apply(function() {
	        self.calendarCtrl.setNgModelValue(timestamp);
	      });
	    };
	
	    /**
	     * Handles click events on the month headers. Switches
	     * the calendar to the year view.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.headerClickHandler = function() {
	      self.calendarCtrl.setCurrentView('year', $$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /*** Initialization ***/
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarMonthCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of months that can be viewed. We add 2 months: one to include the current month
	     * and one for the last dummy month.
	     *
	     * This is shorter than ideal because of a (potential) Firefox bug
	     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
	     */
	
	    this.items = {
	      length: this.dateUtil.getMonthDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 2
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarMonthCtrl.prototype.getSelectedMonthIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getMonthDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the selected date in the calendar (ngModel value has already been changed).
	   * @param {Date} date
	   */
	  CalendarMonthCtrl.prototype.changeSelectedDate = function(date) {
	    var self = this;
	    var calendarCtrl = self.calendarCtrl;
	    var previousSelectedDate = calendarCtrl.selectedDate;
	    calendarCtrl.selectedDate = date;
	
	    this.changeDisplayDate(date).then(function() {
	      var selectedDateClass = calendarCtrl.SELECTED_DATE_CLASS;
	      var namespace = 'month';
	
	      // Remove the selected class from the previously selected date, if any.
	      if (previousSelectedDate) {
	        var prevDateCell = document.getElementById(calendarCtrl.getDateId(previousSelectedDate, namespace));
	        if (prevDateCell) {
	          prevDateCell.classList.remove(selectedDateClass);
	          prevDateCell.setAttribute('aria-selected', 'false');
	        }
	      }
	
	      // Apply the select class to the new selected date if it is set.
	      if (date) {
	        var dateCell = document.getElementById(calendarCtrl.getDateId(date, namespace));
	        if (dateCell) {
	          dateCell.classList.add(selectedDateClass);
	          dateCell.setAttribute('aria-selected', 'true');
	        }
	      }
	    });
	  };
	
	  /**
	   * Change the date that is being shown in the calendar. If the given date is in a different
	   * month, the displayed month will be transitioned.
	   * @param {Date} date
	   */
	  CalendarMonthCtrl.prototype.changeDisplayDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.buildWeekHeader();
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    }
	
	    // If trying to show an invalid date or a transition is in progress, do nothing.
	    if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
	      return this.$q.when();
	    }
	
	    this.isMonthTransitionInProgress = true;
	    var animationPromise = this.animateDateChange(date);
	
	    this.calendarCtrl.displayDate = date;
	
	    var self = this;
	    animationPromise.then(function() {
	      self.isMonthTransitionInProgress = false;
	    });
	
	    return animationPromise;
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarMonthCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Builds and appends a day-of-the-week header to the calendar.
	   * This should only need to be called once during initialization.
	   */
	  CalendarMonthCtrl.prototype.buildWeekHeader = function() {
	    var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
	    var shortDays = this.dateLocale.shortDays;
	
	    var row = document.createElement('tr');
	    for (var i = 0; i < 7; i++) {
	      var th = document.createElement('th');
	      th.textContent = shortDays[(i + firstDayOfWeek) % 7];
	      row.appendChild(th);
	    }
	
	    this.$element.find('thead').append(row);
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarMonthCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.changeSelectedDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(this, this.handleKeyEvent));
	  };
	
	  /**
	   * Handles the month-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarMonthCtrl.prototype.handleKeyEvent = function(event, action) {
	    var calendarCtrl = this.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      calendarCtrl.setNgModelValue(displayDate);
	    } else {
	      var date = null;
	      var dateUtil = this.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementDays(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementDays(displayDate, -1); break;
	
	        case 'move-page-down': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-page-up': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementDays(displayDate, 7); break;
	        case 'move-row-up': date = dateUtil.incrementDays(displayDate, -7); break;
	
	        case 'start': date = dateUtil.getFirstDateOfMonth(displayDate); break;
	        case 'end': date = dateUtil.getLastDateOfMonth(displayDate); break;
	      }
	
	      if (date) {
	        date = this.dateUtil.clampDate(date, calendarCtrl.minDate, calendarCtrl.maxDate);
	
	        this.changeDisplayDate(date).then(function() {
	          calendarCtrl.focus(date);
	        });
	      }
	    }
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  mdCalendarMonthBodyDirective.$inject = ["$compile", "$$mdSvgRegistry"];
	  CalendarMonthBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarMonthBody', mdCalendarMonthBodyDirective);
	
	  /**
	   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
	   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
	   * the rest of the calendar controller logic.
	   * @ngInject
	   */
	  function mdCalendarMonthBodyDirective($compile, $$mdSvgRegistry) {
	    var ARROW_ICON = $compile('<md-icon md-svg-src="' +
	      $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];
	
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarMonth', 'mdCalendarMonthBody'],
	      scope: { offset: '=mdMonthOffset' },
	      controller: CalendarMonthBodyCtrl,
	      controllerAs: 'mdMonthBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        var monthBodyCtrl = controllers[2];
	
	        monthBodyCtrl.calendarCtrl = calendarCtrl;
	        monthBodyCtrl.monthCtrl = monthCtrl;
	        monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);
	
	        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
	        // of repeated items that are linked, and then those elements have their bindings updated.
	        // Since the months are not generated by bindings, we simply regenerate the entire thing
	        // when the binding (offset) changes.
	        scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset, oldOffset) {
	          if (offset !== oldOffset) {
	            monthBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single calendar month.
	   * @ngInject @constructor
	   */
	  function CalendarMonthBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the month view. */
	    this.monthCtrl = null;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this month to the directive element. */
	  CalendarMonthBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForMonth(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend.focus();
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a date in the calendar with all appropriate
	   * attributes and classes added. If a date is given, the cell content will be set
	   * based on the date.
	   * @param {Date=} opt_date
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateCell = function(opt_date) {
	    var monthCtrl = this.monthCtrl;
	    var calendarCtrl = this.calendarCtrl;
	
	    // TODO(jelbourn): cloneNode is likely a faster way of doing this.
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    if (opt_date) {
	      cell.setAttribute('tabindex', '-1');
	      cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
	      cell.id = calendarCtrl.getDateId(opt_date, 'month');
	
	      // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	      cell.setAttribute('data-timestamp', opt_date.getTime());
	
	      // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
	      // It may be better to finish the construction and then query the node and add the class.
	      if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
	        cell.classList.add(calendarCtrl.TODAY_CLASS);
	      }
	
	      if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	          this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
	        cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	        cell.setAttribute('aria-selected', 'true');
	      }
	
	      var cellText = this.dateLocale.dates[opt_date.getDate()];
	
	      if (this.isDateEnabled(opt_date)) {
	        // Add a indicator for select, hover, and focus states.
	        var selectionIndicator = document.createElement('span');
	        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	        selectionIndicator.textContent = cellText;
	        cell.appendChild(selectionIndicator);
	        cell.addEventListener('click', monthCtrl.cellClickHandler);
	
	        if (calendarCtrl.displayDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.displayDate)) {
	          this.focusAfterAppend = cell;
	        }
	      } else {
	        cell.classList.add('md-calendar-date-disabled');
	        cell.textContent = cellText;
	      }
	    }
	
	    return cell;
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  CalendarMonthBodyCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date,
	          this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
	          (!angular.isFunction(this.calendarCtrl.dateFilter)
	           || this.calendarCtrl.dateFilter(opt_date));
	  };
	
	  /**
	   * Builds a `tr` element for the calendar grid.
	   * @param rowNumber The week number within the month.
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateRow = function(rowNumber) {
	    var row = document.createElement('tr');
	    row.setAttribute('role', 'row');
	
	    // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
	    // to prevent the entire row being read aloud when the user moves between rows.
	    // See http://community.nvda-project.org/ticket/4643.
	    row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));
	
	    return row;
	  };
	
	  /**
	   * Builds the <tbody> content for the given date's month.
	   * @param {Date=} opt_dateInMonth
	   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
	   */
	  CalendarMonthBodyCtrl.prototype.buildCalendarForMonth = function(opt_dateInMonth) {
	    var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();
	
	    var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
	    var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
	    var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);
	
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var monthBody = document.createDocumentFragment();
	
	    var rowNumber = 1;
	    var row = this.buildDateRow(rowNumber);
	    monthBody.appendChild(row);
	
	    // If this is the final month in the list of items, only the first week should render,
	    // so we should return immediately after the first row is complete and has been
	    // attached to the body.
	    var isFinalMonth = this.offset === this.monthCtrl.items.length - 1;
	
	    // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
	    // goes on a row above the first of the month. Otherwise, the month label takes up the first
	    // two cells of the first row.
	    var blankCellOffset = 0;
	    var monthLabelCell = document.createElement('td');
	    var monthLabelCellContent = document.createElement('span');
	
	    monthLabelCellContent.textContent = this.dateLocale.monthHeaderFormatter(date);
	    monthLabelCell.appendChild(monthLabelCellContent);
	    monthLabelCell.classList.add('md-calendar-month-label');
	    // If the entire month is after the max date, render the label as a disabled state.
	    if (this.calendarCtrl.maxDate && firstDayOfMonth > this.calendarCtrl.maxDate) {
	      monthLabelCell.classList.add('md-calendar-month-label-disabled');
	    } else {
	      monthLabelCell.addEventListener('click', this.monthCtrl.headerClickHandler);
	      monthLabelCell.setAttribute('data-timestamp', firstDayOfMonth.getTime());
	      monthLabelCell.setAttribute('aria-label', this.dateLocale.monthFormatter(date));
	      monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));
	    }
	
	    if (firstDayOfTheWeek <= 2) {
	      monthLabelCell.setAttribute('colspan', '7');
	
	      var monthLabelRow = this.buildDateRow();
	      monthLabelRow.appendChild(monthLabelCell);
	      monthBody.insertBefore(monthLabelRow, row);
	
	      if (isFinalMonth) {
	        return monthBody;
	      }
	    } else {
	      blankCellOffset = 3;
	      monthLabelCell.setAttribute('colspan', '3');
	      row.appendChild(monthLabelCell);
	    }
	
	    // Add a blank cell for each day of the week that occurs before the first of the month.
	    // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
	    // The blankCellOffset is needed in cases where the first N cells are used by the month label.
	    for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Add a cell for each day of the month, keeping track of the day of the week so that
	    // we know when to start a new row.
	    var dayOfWeek = firstDayOfTheWeek;
	    var iterationDate = firstDayOfMonth;
	    for (var d = 1; d <= numberOfDaysInMonth; d++) {
	      // If we've reached the end of the week, start a new row.
	      if (dayOfWeek === 7) {
	        // We've finished the first row, so we're done if this is the final month.
	        if (isFinalMonth) {
	          return monthBody;
	        }
	        dayOfWeek = 0;
	        rowNumber++;
	        row = this.buildDateRow(rowNumber);
	        monthBody.appendChild(row);
	      }
	
	      iterationDate.setDate(d);
	      var cell = this.buildDateCell(iterationDate);
	      row.appendChild(cell);
	
	      dayOfWeek++;
	    }
	
	    // Ensure that the last row of the month has 7 cells.
	    while (row.childNodes.length < 7) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
	    // requires that all items have exactly the same height.
	    while (monthBody.childNodes.length < 6) {
	      var whitespaceRow = this.buildDateRow();
	      for (var j = 0; j < 7; j++) {
	        whitespaceRow.appendChild(this.buildDateCell());
	      }
	      monthBody.appendChild(whitespaceRow);
	    }
	
	    return monthBody;
	  };
	
	  /**
	   * Gets the day-of-the-week index for a date for the current locale.
	   * @private
	   * @param {Date} date
	   * @returns {number} The column index of the date in the calendar.
	   */
	  CalendarMonthBodyCtrl.prototype.getLocaleDay_ = function(date) {
	    return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarYear', calendarDirective);
	
	  /**
	   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific years.
	   */
	  var TBODY_HEIGHT = 88;
	
	  /** Private component, representing a list of years in the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<div class="md-calendar-scroll-mask">' +
	          '<md-virtual-repeat-container class="md-calendar-scroll-container">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-year-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in yearCtrl.items" ' +
	                  'md-year-offset="$index" class="md-calendar-year" ' +
	                  'md-start-index="yearCtrl.getFocusedYearIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '"></tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarYear'],
	      controller: CalendarYearCtrl,
	      controllerAs: 'yearCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        yearCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarYearCtrl($element, $scope, $animate, $q, $$mdDateUtil) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      self.calendarCtrl.setCurrentView('month', $$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarYearCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of years that can be viewed. We add 1 extra in order to include the current year.
	     */
	    this.items = {
	      length: this.dateUtil.getYearDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 1
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarYearCtrl.prototype.getFocusedYearIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getYearDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the date that is highlighted in the calendar.
	   * @param {Date} date
	   */
	  CalendarYearCtrl.prototype.changeDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    } else if (this.dateUtil.isValidDate(date) && !this.isMonthTransitionInProgress) {
	      var self = this;
	      var animationPromise = this.animateDateChange(date);
	
	      self.isMonthTransitionInProgress = true;
	      self.calendarCtrl.displayDate = date;
	
	      return animationPromise.then(function() {
	        self.isMonthTransitionInProgress = false;
	      });
	    }
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarYearCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Handles the year-view-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarYearCtrl.prototype.handleKeyEvent = function(event, action) {
	    var calendarCtrl = this.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      this.changeDate(displayDate).then(function() {
	        calendarCtrl.setCurrentView('month', displayDate);
	        calendarCtrl.focus(displayDate);
	      });
	    } else {
	      var date = null;
	      var dateUtil = this.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementMonths(displayDate, 6); break;
	        case 'move-row-up': date = dateUtil.incrementMonths(displayDate, -6); break;
	      }
	
	      if (date) {
	        var min = calendarCtrl.minDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.minDate) : null;
	        var max = calendarCtrl.maxDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate) : null;
	        date = dateUtil.getFirstDateOfMonth(this.dateUtil.clampDate(date, min, max));
	
	        this.changeDate(date).then(function() {
	          calendarCtrl.focus(date);
	        });
	      }
	    }
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarYearCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.changeDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(self, self.handleKeyEvent));
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarYearBody', mdCalendarYearDirective);
	
	  /**
	   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
	   * and allows for the year view to use md-virtual-repeat.
	   */
	  function mdCalendarYearDirective() {
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarYear', 'mdCalendarYearBody'],
	      scope: { offset: '=mdYearOffset' },
	      controller: CalendarYearBodyCtrl,
	      controllerAs: 'mdYearBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        var yearBodyCtrl = controllers[2];
	
	        yearBodyCtrl.calendarCtrl = calendarCtrl;
	        yearBodyCtrl.yearCtrl = yearCtrl;
	
	        scope.$watch(function() { return yearBodyCtrl.offset; }, function(offset, oldOffset) {
	          if (offset !== oldOffset) {
	            yearBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single year.
	   * @ngInject @constructor
	   */
	  function CalendarYearBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /** @type {Object} Reference to the year view. */
	    this.yearCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this year to the directive element. */
	  CalendarYearBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForYear(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend.focus();
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a year in the calendar.
	   * @param {number} opt_year Four-digit year.
	   * @param {number} opt_month Zero-indexed month.
	   * @returns {HTMLElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildMonthCell = function(year, month) {
	    var calendarCtrl = this.calendarCtrl;
	    var yearCtrl = this.yearCtrl;
	    var cell = this.buildBlankCell();
	
	    // Represent this month/year as a date.
	    var firstOfMonth = new Date(year, month, 1);
	    cell.setAttribute('aria-label', this.dateLocale.monthFormatter(firstOfMonth));
	    cell.id = calendarCtrl.getDateId(firstOfMonth, 'year');
	
	    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	    cell.setAttribute('data-timestamp', firstOfMonth.getTime());
	
	    if (this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.today)) {
	      cell.classList.add(calendarCtrl.TODAY_CLASS);
	    }
	
	    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	        this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.selectedDate)) {
	      cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	      cell.setAttribute('aria-selected', 'true');
	    }
	
	    var cellText = this.dateLocale.shortMonths[month];
	
	    if (this.dateUtil.isMonthWithinRange(firstOfMonth,
	        calendarCtrl.minDate, calendarCtrl.maxDate)) {
	      var selectionIndicator = document.createElement('span');
	      selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	      selectionIndicator.textContent = cellText;
	      cell.appendChild(selectionIndicator);
	      cell.addEventListener('click', yearCtrl.cellClickHandler);
	
	      if (calendarCtrl.displayDate && this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.displayDate)) {
	        this.focusAfterAppend = cell;
	      }
	    } else {
	      cell.classList.add('md-calendar-date-disabled');
	      cell.textContent = cellText;
	    }
	
	    return cell;
	  };
	
	  /**
	   * Builds a blank cell.
	   * @return {HTMLTableCellElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildBlankCell = function() {
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    cell.setAttribute('tabindex', '-1');
	    return cell;
	  };
	
	  /**
	   * Builds the <tbody> content for the given year.
	   * @param {Date} date Date for which the content should be built.
	   * @returns {DocumentFragment} A document fragment containing the months within the year.
	   */
	  CalendarYearBodyCtrl.prototype.buildCalendarForYear = function(date) {
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var year = date.getFullYear();
	    var yearBody = document.createDocumentFragment();
	
	    var monthCell, i;
	    // First row contains label and Jan-Jun.
	    var firstRow = document.createElement('tr');
	    var labelCell = document.createElement('td');
	    labelCell.className = 'md-calendar-month-label';
	    labelCell.textContent = year;
	    firstRow.appendChild(labelCell);
	
	    for (i = 0; i < 6; i++) {
	      firstRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(firstRow);
	
	    // Second row contains a blank cell and Jul-Dec.
	    var secondRow = document.createElement('tr');
	    secondRow.appendChild(this.buildBlankCell());
	    for (i = 6; i < 12; i++) {
	      secondRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(secondRow);
	
	    return yearBody;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdDateLocaleProvider
	   * @module material.components.datepicker
	   *
	   * @description
	   * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
	   * This provider that allows the user to specify messages, formatters, and parsers for date
	   * internationalization. The `$mdDateLocale` service itself is consumed by Angular Material
	   * components that deal with dates.
	   *
	   * @property {(Array<string>)=} months Array of month names (in order).
	   * @property {(Array<string>)=} shortMonths Array of abbreviated month names.
	   * @property {(Array<string>)=} days Array of the days of the week (in order).
	   * @property {(Array<string>)=} shortDays Array of abbreviated dayes of the week.
	   * @property {(Array<string>)=} dates Array of dates of the month. Only necessary for locales
	   *     using a numeral system other than [1, 2, 3...].
	   * @property {(Array<string>)=} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
	   *    etc.
	   * @property {(function(string): Date)=} parseDate Function to parse a date object from a string.
	   * @property {(function(Date): string)=} formatDate Function to format a date object to a string.
	   * @property {(function(Date): string)=} monthHeaderFormatter Function that returns the label for
	   *     a month given a date.
	   * @property {(function(Date): string)=} monthFormatter Function that returns the full name of a month
	   *     for a giben date.
	   * @property {(function(number): string)=} weekNumberFormatter Function that returns a label for
	   *     a week given the week number.
	   * @property {(string)=} msgCalendar Translation of the label "Calendar" for the current locale.
	   * @property {(string)=} msgOpenCalendar Translation of the button label "Open calendar" for the
	   *     current locale.
	   * @property {Date=} firstRenderableDate The date from which the datepicker calendar will begin
	   * rendering. Note that this will be ignored if a minimum date is set. Defaults to January 1st 1880.
	   * @property {Date=} lastRenderableDate The last date that will be rendered by the datepicker
	   * calendar. Note that this will be ignored if a maximum date is set. Defaults to January 1st 2130.
	   *
	   * @usage
	   * <hljs lang="js">
	   * myAppModule.config(function($mdDateLocaleProvider) {
	   *
	   *     // Example of a French localization.
	   *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
	   *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
	   *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
	   *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
	   *
	   *     // Can change week display to start on Monday.
	   *     $mdDateLocaleProvider.firstDayOfWeek = 1;
	   *
	   *     // Optional.
	   *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
	   *
	   *     // Example uses moment.js to parse and format dates.
	   *     $mdDateLocaleProvider.parseDate = function(dateString) {
	   *       var m = moment(dateString, 'L', true);
	   *       return m.isValid() ? m.toDate() : new Date(NaN);
	   *     };
	   *
	   *     $mdDateLocaleProvider.formatDate = function(date) {
	   *       var m = moment(date);
	   *       return m.isValid() ? m.format('L') : '';
	   *     };
	   *
	   *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
	   *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
	   *     };
	   *
	   *     // In addition to date display, date components also need localized messages
	   *     // for aria-labels for screen-reader users.
	   *
	   *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
	   *       return 'Semaine ' + weekNumber;
	   *     };
	   *
	   *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
	   *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
	   *
	   *     // You can also set when your calendar begins and ends.
	   *     $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
	   *     $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
	   * });
	   * </hljs>
	   *
	   */
	  angular.module('material.components.datepicker').config(["$provide", function($provide) {
	    // TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.
	
	    /** @constructor */
	    function DateLocaleProvider() {
	      /** Array of full month names. E.g., ['January', 'Febuary', ...] */
	      this.months = null;
	
	      /** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */
	      this.shortMonths = null;
	
	      /** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */
	      this.days = null;
	
	      /** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */
	      this.shortDays = null;
	
	      /** Array of dates of a month (1 - 31). Characters might be different in some locales. */
	      this.dates = null;
	
	      /** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */
	      this.firstDayOfWeek = 0;
	
	      /**
	       * Function that converts the date portion of a Date to a string.
	       * @type {(function(Date): string)}
	       */
	      this.formatDate = null;
	
	      /**
	       * Function that converts a date string to a Date object (the date portion)
	       * @type {function(string): Date}
	       */
	      this.parseDate = null;
	
	      /**
	       * Function that formats a Date into a month header string.
	       * @type {function(Date): string}
	       */
	      this.monthHeaderFormatter = null;
	
	      /**
	       * Function that formats a week number into a label for the week.
	       * @type {function(number): string}
	       */
	      this.weekNumberFormatter = null;
	
	      /**
	       * Function that formats a date into a long aria-label that is read
	       * when the focused date changes.
	       * @type {function(Date): string}
	       */
	      this.longDateFormatter = null;
	
	      /**
	       * ARIA label for the calendar "dialog" used in the datepicker.
	       * @type {string}
	       */
	      this.msgCalendar = '';
	
	      /**
	       * ARIA label for the datepicker's "Open calendar" buttons.
	       * @type {string}
	       */
	      this.msgOpenCalendar = '';
	    }
	
	    /**
	     * Factory function that returns an instance of the dateLocale service.
	     * @ngInject
	     * @param $locale
	     * @returns {DateLocale}
	     */
	    DateLocaleProvider.prototype.$get = function($locale, $filter) {
	      /**
	       * Default date-to-string formatting function.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultFormatDate(date) {
	        if (!date) {
	          return '';
	        }
	
	        // All of the dates created through ng-material *should* be set to midnight.
	        // If we encounter a date where the localeTime shows at 11pm instead of midnight,
	        // we have run into an issue with DST where we need to increment the hour by one:
	        // var d = new Date(1992, 9, 8, 0, 0, 0);
	        // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
	        var localeTime = date.toLocaleTimeString();
	        var formatDate = date;
	        if (date.getHours() == 0 &&
	            (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)) {
	          formatDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, 0, 0);
	        }
	
	        return $filter('date')(formatDate, 'M/d/yyyy');
	      }
	
	      /**
	       * Default string-to-date parsing function.
	       * @param {string} dateString
	       * @returns {!Date}
	       */
	      function defaultParseDate(dateString) {
	        return new Date(dateString);
	      }
	
	      /**
	       * Default function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       *
	       * This is very permissive and is just a basic sanity check to ensure that
	       * things like single integers aren't able to be parsed into dates.
	       * @param {string} dateString
	       * @returns {boolean}
	       */
	      function defaultIsDateComplete(dateString) {
	        dateString = dateString.trim();
	
	        // Looks for three chunks of content (either numbers or text) separated
	        // by delimiters.
	        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ \.,]+|[\/\-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;
	        return re.test(dateString);
	      }
	
	      /**
	       * Default date-to-string formatter to get a month header.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthHeaderFormatter(date) {
	        return service.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default formatter for a month.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthFormatter(date) {
	        return service.months[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default week number formatter.
	       * @param number
	       * @returns {string}
	       */
	      function defaultWeekNumberFormatter(number) {
	        return 'Week ' + number;
	      }
	
	      /**
	       * Default formatter for date cell aria-labels.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultLongDateFormatter(date) {
	        // Example: 'Thursday June 18 2015'
	        return [
	          service.days[date.getDay()],
	          service.months[date.getMonth()],
	          service.dates[date.getDate()],
	          date.getFullYear()
	        ].join(' ');
	      }
	
	      // The default "short" day strings are the first character of each day,
	      // e.g., "Monday" => "M".
	      var defaultShortDays = $locale.DATETIME_FORMATS.SHORTDAY.map(function(day) {
	        return day.substring(0, 1);
	      });
	
	      // The default dates are simply the numbers 1 through 31.
	      var defaultDates = Array(32);
	      for (var i = 1; i <= 31; i++) {
	        defaultDates[i] = i;
	      }
	
	      // Default ARIA messages are in English (US).
	      var defaultMsgCalendar = 'Calendar';
	      var defaultMsgOpenCalendar = 'Open calendar';
	
	      // Default start/end dates that are rendered in the calendar.
	      var defaultFirstRenderableDate = new Date(1880, 0, 1);
	      var defaultLastRendereableDate = new Date(defaultFirstRenderableDate.getFullYear() + 250, 0, 1);
	
	      var service = {
	        months: this.months || $locale.DATETIME_FORMATS.MONTH,
	        shortMonths: this.shortMonths || $locale.DATETIME_FORMATS.SHORTMONTH,
	        days: this.days || $locale.DATETIME_FORMATS.DAY,
	        shortDays: this.shortDays || defaultShortDays,
	        dates: this.dates || defaultDates,
	        firstDayOfWeek: this.firstDayOfWeek || 0,
	        formatDate: this.formatDate || defaultFormatDate,
	        parseDate: this.parseDate || defaultParseDate,
	        isDateComplete: this.isDateComplete || defaultIsDateComplete,
	        monthHeaderFormatter: this.monthHeaderFormatter || defaultMonthHeaderFormatter,
	        monthFormatter: this.monthFormatter || defaultMonthFormatter,
	        weekNumberFormatter: this.weekNumberFormatter || defaultWeekNumberFormatter,
	        longDateFormatter: this.longDateFormatter || defaultLongDateFormatter,
	        msgCalendar: this.msgCalendar || defaultMsgCalendar,
	        msgOpenCalendar: this.msgOpenCalendar || defaultMsgOpenCalendar,
	        firstRenderableDate: this.firstRenderableDate || defaultFirstRenderableDate,
	        lastRenderableDate: this.lastRenderableDate || defaultLastRendereableDate
	      };
	
	      return service;
	    };
	    DateLocaleProvider.prototype.$get.$inject = ["$locale", "$filter"];
	
	    $provide.provider('$mdDateLocale', new DateLocaleProvider());
	  }]);
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * Utility for performing date calculations to facilitate operation of the calendar and
	   * datepicker.
	   */
	  angular.module('material.components.datepicker').factory('$$mdDateUtil', function() {
	    return {
	      getFirstDateOfMonth: getFirstDateOfMonth,
	      getNumberOfDaysInMonth: getNumberOfDaysInMonth,
	      getDateInNextMonth: getDateInNextMonth,
	      getDateInPreviousMonth: getDateInPreviousMonth,
	      isInNextMonth: isInNextMonth,
	      isInPreviousMonth: isInPreviousMonth,
	      getDateMidpoint: getDateMidpoint,
	      isSameMonthAndYear: isSameMonthAndYear,
	      getWeekOfMonth: getWeekOfMonth,
	      incrementDays: incrementDays,
	      incrementMonths: incrementMonths,
	      getLastDateOfMonth: getLastDateOfMonth,
	      isSameDay: isSameDay,
	      getMonthDistance: getMonthDistance,
	      isValidDate: isValidDate,
	      setDateTimeToMidnight: setDateTimeToMidnight,
	      createDateAtMidnight: createDateAtMidnight,
	      isDateWithinRange: isDateWithinRange,
	      incrementYears: incrementYears,
	      getYearDistance: getYearDistance,
	      clampDate: clampDate,
	      getTimestampFromNode: getTimestampFromNode,
	      isMonthWithinRange: isMonthWithinRange
	    };
	
	    /**
	     * Gets the first day of the month for the given date's month.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getFirstDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), 1);
	    }
	
	    /**
	     * Gets the number of days in the month for the given date's month.
	     * @param date
	     * @returns {number}
	     */
	    function getNumberOfDaysInMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
	    }
	
	    /**
	     * Get an arbitrary date in the month after the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInNextMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
	    }
	
	    /**
	     * Get an arbitrary date in the month before the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInPreviousMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
	    }
	
	    /**
	     * Gets whether two dates have the same month and year.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameMonthAndYear(d1, d2) {
	      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
	    }
	
	    /**
	     * Gets whether two dates are the same day (not not necesarily the same time).
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameDay(d1, d2) {
	      return d1.getDate() == d2.getDate() && isSameMonthAndYear(d1, d2);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately after some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInNextMonth(startDate, endDate) {
	      var nextMonth = getDateInNextMonth(startDate);
	      return isSameMonthAndYear(nextMonth, endDate);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately before some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInPreviousMonth(startDate, endDate) {
	      var previousMonth = getDateInPreviousMonth(startDate);
	      return isSameMonthAndYear(endDate, previousMonth);
	    }
	
	    /**
	     * Gets the midpoint between two dates.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {Date}
	     */
	    function getDateMidpoint(d1, d2) {
	      return createDateAtMidnight((d1.getTime() + d2.getTime()) / 2);
	    }
	
	    /**
	     * Gets the week of the month that a given date occurs in.
	     * @param {Date} date
	     * @returns {number} Index of the week of the month (zero-based).
	     */
	    function getWeekOfMonth(date) {
	      var firstDayOfMonth = getFirstDateOfMonth(date);
	      return Math.floor((firstDayOfMonth.getDay() + date.getDate() - 1) / 7);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of days. Number of days can be negative.
	     * @param {Date} date
	     * @param {number} numberOfDays
	     * @returns {Date}
	     */
	    function incrementDays(date, numberOfDays) {
	      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of months. Number of months can be negative.
	     * If the date of the given month does not match the target month, the date will be set to the
	     * last day of the month.
	     * @param {Date} date
	     * @param {number} numberOfMonths
	     * @returns {Date}
	     */
	    function incrementMonths(date, numberOfMonths) {
	      // If the same date in the target month does not actually exist, the Date object will
	      // automatically advance *another* month by the number of missing days.
	      // For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
	      // So, we check if the month overflowed and go to the last day of the target month instead.
	      var dateInTargetMonth = new Date(date.getFullYear(), date.getMonth() + numberOfMonths, 1);
	      var numberOfDaysInMonth = getNumberOfDaysInMonth(dateInTargetMonth);
	      if (numberOfDaysInMonth < date.getDate()) {
	        dateInTargetMonth.setDate(numberOfDaysInMonth);
	      } else {
	        dateInTargetMonth.setDate(date.getDate());
	      }
	
	      return dateInTargetMonth;
	    }
	
	    /**
	     * Get the integer distance between two months. This *only* considers the month and year
	     * portion of the Date instances.
	     *
	     * @param {Date} start
	     * @param {Date} end
	     * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	     *     chronologically, this number will be negative.
	     */
	    function getMonthDistance(start, end) {
	      return (12 * (end.getFullYear() - start.getFullYear())) + (end.getMonth() - start.getMonth());
	    }
	
	    /**
	     * Gets the last day of the month for the given date.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getLastDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), getNumberOfDaysInMonth(date));
	    }
	
	    /**
	     * Checks whether a date is valid.
	     * @param {Date} date
	     * @return {boolean} Whether the date is a valid Date.
	     */
	    function isValidDate(date) {
	      return date != null && date.getTime && !isNaN(date.getTime());
	    }
	
	    /**
	     * Sets a date's time to midnight.
	     * @param {Date} date
	     */
	    function setDateTimeToMidnight(date) {
	      if (isValidDate(date)) {
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	
	    /**
	     * Creates a date with the time set to midnight.
	     * Drop-in replacement for two forms of the Date constructor:
	     * 1. No argument for Date representing now.
	     * 2. Single-argument value representing number of seconds since Unix Epoch
	     * or a Date object.
	     * @param {number|Date=} opt_value
	     * @return {Date} New date with time set to midnight.
	     */
	    function createDateAtMidnight(opt_value) {
	      var date;
	      if (angular.isUndefined(opt_value)) {
	        date = new Date();
	      } else {
	        date = new Date(opt_value);
	      }
	      setDateTimeToMidnight(date);
	      return date;
	    }
	
	     /**
	      * Checks if a date is within a min and max range, ignoring the time component.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isDateWithinRange(date, minDate, maxDate) {
	       var dateAtMidnight = createDateAtMidnight(date);
	       var minDateAtMidnight = isValidDate(minDate) ? createDateAtMidnight(minDate) : null;
	       var maxDateAtMidnight = isValidDate(maxDate) ? createDateAtMidnight(maxDate) : null;
	       return (!minDateAtMidnight || minDateAtMidnight <= dateAtMidnight) &&
	           (!maxDateAtMidnight || maxDateAtMidnight >= dateAtMidnight);
	     }
	
	    /**
	     * Gets a new date incremented by the given number of years. Number of years can be negative.
	     * See `incrementMonths` for notes on overflow for specific dates.
	     * @param {Date} date
	     * @param {number} numberOfYears
	     * @returns {Date}
	     */
	     function incrementYears(date, numberOfYears) {
	       return incrementMonths(date, numberOfYears * 12);
	     }
	
	     /**
	      * Get the integer distance between two years. This *only* considers the year portion of the
	      * Date instances.
	      *
	      * @param {Date} start
	      * @param {Date} end
	      * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	      *     chronologically, this number will be negative.
	      */
	     function getYearDistance(start, end) {
	       return end.getFullYear() - start.getFullYear();
	     }
	
	     /**
	      * Clamps a date between a minimum and a maximum date.
	      * @param {Date} date Date to be clamped
	      * @param {Date=} minDate Minimum date
	      * @param {Date=} maxDate Maximum date
	      * @return {Date}
	      */
	     function clampDate(date, minDate, maxDate) {
	       var boundDate = date;
	       if (minDate && date < minDate) {
	         boundDate = new Date(minDate.getTime());
	       }
	       if (maxDate && date > maxDate) {
	         boundDate = new Date(maxDate.getTime());
	       }
	       return boundDate;
	     }
	
	     /**
	      * Extracts and parses the timestamp from a DOM node.
	      * @param  {HTMLElement} node Node from which the timestamp will be extracted.
	      * @return {number} Time since epoch.
	      */
	     function getTimestampFromNode(node) {
	       if (node && node.hasAttribute('data-timestamp')) {
	         return Number(node.getAttribute('data-timestamp'));
	       }
	     }
	
	     /**
	      * Checks if a month is within a min and max range, ignoring the date and time components.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isMonthWithinRange(date, minDate, maxDate) {
	       var month = date.getMonth();
	       var year = date.getFullYear();
	
	       return (!minDate || minDate.getFullYear() < year || minDate.getMonth() <= month) &&
	        (!maxDate || maxDate.getFullYear() > year || maxDate.getMonth() >= month);
	     }
	  });
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  // POST RELEASE
	  // TODO(jelbourn): Demo that uses moment.js
	  // TODO(jelbourn): make sure this plays well with validation and ngMessages.
	  // TODO(jelbourn): calendar pane doesn't open up outside of visible viewport.
	  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
	  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
	  // TODO(jelbourn): input behavior (masking? auto-complete?)
	
	
	  DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF", "$mdGesture", "$filter"];
	  datePickerDirective.$inject = ["$$mdSvgRegistry", "$mdUtil", "$mdAria", "inputDirective"];
	  angular.module('material.components.datepicker')
	      .directive('mdDatepicker', datePickerDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdDatepicker
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Expects a JavaScript Date object.
	   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being updated. Also allows
	   * for a timezone to be specified. <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">Read more at the ngModelOptions docs.</a>
	   * @param {expression=} ng-change Expression evaluated when the model value changes.
	   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar is opened.
	   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the calendar is closed.
	   * @param {Date=} md-min-date Expression representing a min date (inclusive).
	   * @param {Date=} md-max-date Expression representing a max date (inclusive).
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
	   * @param {String=} md-placeholder The date input placeholder value.
	   * @param {String=} md-open-on-focus When present, the calendar will be opened when the input is focused.
	   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar on-demand.
	   * @param {String=} md-current-view Default open view of the calendar pane. Can be either "month" or "year".
	   * @param {String=} md-hide-icons Determines which datepicker icons should be hidden. Note that this may cause the
	   * datepicker to not align properly with other components. **Use at your own risk.** Possible values are:
	   * * `"all"` - Hides all icons.
	   * * `"calendar"` - Only hides the calendar icon.
	   * * `"triangle"` - Only hides the triangle icon.
	   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
	   * @param {boolean=} ng-required Whether a value is required for the datepicker.
	   *
	   * @description
	   * `<md-datepicker>` is a component used to select a single date.
	   * For information on how to configure internationalization for the date picker,
	   * see `$mdDateLocaleProvider`.
	   *
	   * This component supports [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
	   * Supported attributes are:
	   * * `required`: whether a required date is not set.
	   * * `mindate`: whether the selected date is before the minimum allowed date.
	   * * `maxdate`: whether the selected date is after the maximum allowed date.
	   * * `debounceInterval`: ms to delay input processing (since last debounce reset); default value 500ms
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-datepicker ng-model="birthday"></md-datepicker>
	   * </hljs>
	   *
	   */
	
	  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
	    return {
	      template: function(tElement, tAttrs) {
	        // Buttons are not in the tab order because users can open the calendar via keyboard
	        // interaction on the text input, and multiple tab stops for one component (picker)
	        // may be confusing.
	        var hiddenIcons = tAttrs.mdHideIcons;
	        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;
	
	        var calendarButton = (hiddenIcons === 'all' || hiddenIcons === 'calendar') ? '' :
	          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
	              'tabindex="-1" aria-hidden="true" ' +
	              'ng-click="ctrl.openCalendarPane($event)">' +
	            '<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" ' +
	                     'md-svg-src="' + $$mdSvgRegistry.mdCalendar + '"></md-icon>' +
	          '</md-button>';
	
	        var triangleButton = (hiddenIcons === 'all' || hiddenIcons === 'triangle') ? '' :
	          '<md-button type="button" md-no-ink ' +
	              'class="md-datepicker-triangle-button md-icon-button" ' +
	              'ng-click="ctrl.openCalendarPane($event)" ' +
	              'aria-label="{{::ctrl.dateLocale.msgOpenCalendar}}">' +
	            '<div class="md-datepicker-expand-triangle"></div>' +
	          '</md-button>';
	
	        return calendarButton +
	        '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
	          '<input ' +
	            (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : '') +
	            'class="md-datepicker-input" ' +
	            'aria-haspopup="true" ' +
	            'ng-focus="ctrl.setFocused(true)" ' +
	            'ng-blur="ctrl.setFocused(false)"> ' +
	            triangleButton +
	        '</div>' +
	
	        // This pane will be detached from here and re-attached to the document body.
	        '<div class="md-datepicker-calendar-pane md-whiteframe-z1">' +
	          '<div class="md-datepicker-input-mask">' +
	            '<div class="md-datepicker-input-mask-opaque"></div>' +
	          '</div>' +
	          '<div class="md-datepicker-calendar">' +
	            '<md-calendar role="dialog" aria-label="{{::ctrl.dateLocale.msgCalendar}}" ' +
	                'md-current-view="{{::ctrl.currentView}}"' +
	                'md-min-date="ctrl.minDate"' +
	                'md-max-date="ctrl.maxDate"' +
	                'md-date-filter="ctrl.dateFilter"' +
	                'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
	            '</md-calendar>' +
	          '</div>' +
	        '</div>';
	      },
	      require: ['ngModel', 'mdDatepicker', '?^mdInputContainer', '?^form'],
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        placeholder: '@mdPlaceholder',
	        currentView: '@mdCurrentView',
	        dateFilter: '=mdDateFilter',
	        isOpen: '=?mdIsOpen',
	        debounceInterval: '=mdDebounceInterval'
	      },
	      controller: DatePickerCtrl,
	      controllerAs: 'ctrl',
	      bindToController: true,
	      link: function(scope, element, attr, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdDatePickerCtrl = controllers[1];
	        var mdInputContainer = controllers[2];
	        var parentForm = controllers[3];
	        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);
	
	        if (mdInputContainer) {
	          // We need to move the spacer after the datepicker itself,
	          // because md-input-container adds it after the
	          // md-datepicker-input by default. The spacer gets wrapped in a
	          // div, because it floats and gets aligned next to the datepicker.
	          // There are easier ways of working around this with CSS (making the
	          // datepicker 100% wide, change the `display` etc.), however they
	          // break the alignment with any other form controls.
	          var spacer = element[0].querySelector('.md-errors-spacer');
	
	          if (spacer) {
	            element.after(angular.element('<div>').append(spacer));
	          }
	
	          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
	          mdInputContainer.input = element;
	          mdInputContainer.element
	            .addClass(INPUT_CONTAINER_CLASS)
	            .toggleClass(HAS_ICON_CLASS, attr.mdHideIcons !== 'calendar' && attr.mdHideIcons !== 'all');
	
	          if (!mdInputContainer.label) {
	            $mdAria.expect(element, 'aria-label', attr.mdPlaceholder);
	          } else if(!mdNoAsterisk) {
	            attr.$observe('required', function(value) {
	              mdInputContainer.label.toggleClass('md-required', !!value);
	            });
	          }
	
	          scope.$watch(mdInputContainer.isErrorGetter || function() {
	            return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	          }, mdInputContainer.setInvalid);
	        } else if (parentForm) {
	          // If invalid, highlights the input when the parent form is submitted.
	          var parentSubmittedWatcher = scope.$watch(function() {
	            return parentForm.$submitted;
	          }, function(isSubmitted) {
	            if (isSubmitted) {
	              mdDatePickerCtrl.updateErrorState();
	              parentSubmittedWatcher();
	            }
	          });
	        }
	      }
	    };
	  }
	
	  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
	  var EXTRA_INPUT_SIZE = 3;
	
	  /** Class applied to the container if the date is invalid. */
	  var INVALID_CLASS = 'md-datepicker-invalid';
	
	  /** Class applied to the datepicker when it's open. */
	  var OPEN_CLASS = 'md-datepicker-open';
	
	  /** Class applied to the md-input-container, if a datepicker is placed inside it */
	  var INPUT_CONTAINER_CLASS = '_md-datepicker-floating-label';
	
	  /** Class to be applied when the calendar icon is enabled. */
	  var HAS_ICON_CLASS = '_md-datepicker-has-calendar-icon';
	
	  /** Default time in ms to debounce input event by. */
	  var DEFAULT_DEBOUNCE_INTERVAL = 500;
	
	  /**
	   * Height of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_HEIGHT = 368;
	
	  /**
	   * Width of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_WIDTH = 360;
	
	  /**
	   * Controller for md-datepicker.
	   *
	   * @ngInject @constructor
	   */
	  function DatePickerCtrl($scope, $element, $attrs, $window, $mdConstant,
	    $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF, $mdGesture, $filter) {
	
	    /** @final */
	    this.$window = $window;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdConstant = $mdConstant;
	
	    /* @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /**
	     * The root document element. This is used for attaching a top-level click handler to
	     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
	     * instead of body because, when scrolling is disabled, some browsers consider the body element
	     * to be completely off the screen and propagate events directly to the html element.
	     * @type {!angular.JQLite}
	     */
	    this.documentElement = angular.element(document.documentElement);
	
	    /** @type {!angular.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /** @type {HTMLInputElement} */
	    this.inputElement = $element[0].querySelector('input');
	
	    /** @final {!angular.JQLite} */
	    this.ngInputElement = angular.element(this.inputElement);
	
	    /** @type {HTMLElement} */
	    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');
	
	    /** @type {HTMLElement} Floating calendar pane. */
	    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');
	
	    /** @type {HTMLElement} Calendar icon button. */
	    this.calendarButton = $element[0].querySelector('.md-datepicker-button');
	
	    /**
	     * Element covering everything but the input in the top of the floating calendar pane.
	     * @type {!angular.JQLite}
	     */
	    this.inputMask = angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Attributes} */
	    this.$attrs = $attrs;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @type {Date} */
	    this.date = null;
	
	    /** @type {boolean} */
	    this.isFocused = false;
	
	    /** @type {boolean} */
	    this.isDisabled;
	    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));
	
	    /** @type {boolean} Whether the date-picker's calendar pane is open. */
	    this.isCalendarOpen = false;
	
	    /** @type {boolean} Whether the calendar should open when the input is focused. */
	    this.openOnFocus = $attrs.hasOwnProperty('mdOpenOnFocus');
	
	    /** @final */
	    this.mdInputContainer = null;
	
	    /**
	     * Element from which the calendar pane was opened. Keep track of this so that we can return
	     * focus to it when the pane is closed.
	     * @type {HTMLElement}
	     */
	    this.calendarPaneOpenedFrom = null;
	
	    /** @type {String} Unique id for the calendar pane. */
	    this.calendarPane.id = 'md-date-pane' + $mdUtil.nextUid();
	
	    /** Pre-bound click handler is saved so that the event listener can be removed. */
	    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);
	
	    /**
	     * Name of the event that will trigger a close. Necessary to sniff the browser, because
	     * the resize event doesn't make sense on mobile and can have a negative impact since it
	     * triggers whenever the browser zooms in on a focused input.
	     */
	    this.windowEventName = ($mdGesture.isIos || $mdGesture.isAndroid) ? 'orientationchange' : 'resize';
	
	    /** Pre-bound close handler so that the event listener can be removed. */
	    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);
	
	    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
	    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);
	
	    /** The built-in Angular date filter. */
	    this.ngDateFilter = $filter('date');
	
	    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
	    this.leftMargin = 20;
	
	    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
	    this.topMargin = null;
	
	    // Unless the user specifies so, the datepicker should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if ($attrs.tabindex) {
	      this.ngInputElement.attr('tabindex', $attrs.tabindex);
	      $attrs.$set('tabindex', null);
	    } else {
	      $attrs.$set('tabindex', '-1');
	    }
	
	    $mdTheming($element);
	    $mdTheming(angular.element(this.calendarPane));
	
	    this.installPropertyInterceptors();
	    this.attachChangeListeners();
	    this.attachInteractionListeners();
	
	    var self = this;
	
	    $scope.$on('$destroy', function() {
	      self.detachCalendarPane();
	    });
	
	    if ($attrs.mdIsOpen) {
	      $scope.$watch('ctrl.isOpen', function(shouldBeOpen) {
	        if (shouldBeOpen) {
	          self.openCalendarPane({
	            target: self.inputElement
	          });
	        } else {
	          self.closeCalendarPane();
	        }
	      });
	    }
	  }
	
	  /**
	   * Sets up the controller's reference to ngModelController and
	   * applies Angular's `input[type="date"]` directive.
	   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
	   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
	   * @param {Object} inputDirective Config for Angular's `input` directive.
	   */
	  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
	    this.ngModelCtrl = ngModelCtrl;
	    this.mdInputContainer = mdInputContainer;
	
	    // The input needs to be [type="date"] in order to be picked up by Angular.
	    this.$attrs.$set('type', 'date');
	
	    // Invoke the `input` directive link function, adding a stub for the element.
	    // This allows us to re-use Angular's logic for setting the timezone via ng-model-options.
	    // It works by calling the link function directly which then adds the proper `$parsers` and
	    // `$formatters` to the ngModel controller.
	    inputDirective[0].link.pre(this.$scope, {
	      on: angular.noop,
	      val: angular.noop,
	      0: {}
	    }, this.$attrs, [ngModelCtrl]);
	
	    var self = this;
	
	    // Responds to external changes to the model value.
	    self.ngModelCtrl.$formatters.push(function(value) {
	      if (value && !(value instanceof Date)) {
	        throw Error('The ng-model for md-datepicker must be a Date instance. ' +
	            'Currently the model is a: ' + (typeof value));
	      }
	
	      self.date = value;
	      self.inputElement.value = self.dateLocale.formatDate(value);
	      self.mdInputContainer && self.mdInputContainer.setHasValue(!!value);
	      self.resizeInputElement();
	      self.updateErrorState();
	
	      return value;
	    });
	
	    // Responds to external error state changes (e.g. ng-required based on another input).
	    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));
	  };
	
	  /**
	   * Attach event listeners for both the text input and the md-calendar.
	   * Events are used instead of ng-model so that updates don't infinitely update the other
	   * on a change. This should also be more performant than using a $watch.
	   */
	  DatePickerCtrl.prototype.attachChangeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-change', function(event, date) {
	      self.setModelValue(date);
	      self.date = date;
	      self.inputElement.value = self.dateLocale.formatDate(date);
	      self.mdInputContainer && self.mdInputContainer.setHasValue(!!date);
	      self.closeCalendarPane();
	      self.resizeInputElement();
	      self.updateErrorState();
	    });
	
	    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
	
	    var debounceInterval = angular.isDefined(this.debounceInterval) ?
	        this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
	    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
	        debounceInterval, self));
	  };
	
	  /** Attach event listeners for user interaction. */
	  DatePickerCtrl.prototype.attachInteractionListeners = function() {
	    var self = this;
	    var $scope = this.$scope;
	    var keyCodes = this.$mdConstant.KEY_CODE;
	
	    // Add event listener through angular so that we can triggerHandler in unit tests.
	    self.ngInputElement.on('keydown', function(event) {
	      if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
	        self.openCalendarPane(event);
	        $scope.$digest();
	      }
	    });
	
	    if (self.openOnFocus) {
	      self.ngInputElement.on('focus', angular.bind(self, self.openCalendarPane));
	      angular.element(self.$window).on('blur', self.windowBlurHandler);
	
	      $scope.$on('$destroy', function() {
	        angular.element(self.$window).off('blur', self.windowBlurHandler);
	      });
	    }
	
	    $scope.$on('md-calendar-close', function() {
	      self.closeCalendarPane();
	    });
	  };
	
	  /**
	   * Capture properties set to the date-picker and imperitively handle internal changes.
	   * This is done to avoid setting up additional $watches.
	   */
	  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
	    var self = this;
	
	    if (this.$attrs.ngDisabled) {
	      // The expression is to be evaluated against the directive element's scope and not
	      // the directive's isolate scope.
	      var scope = this.$scope.$parent;
	
	      if (scope) {
	        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
	          self.setDisabled(isDisabled);
	        });
	      }
	    }
	
	    Object.defineProperty(this, 'placeholder', {
	      get: function() { return self.inputElement.placeholder; },
	      set: function(value) { self.inputElement.placeholder = value || ''; }
	    });
	  };
	
	  /**
	   * Sets whether the date-picker is disabled.
	   * @param {boolean} isDisabled
	   */
	  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
	    this.isDisabled = isDisabled;
	    this.inputElement.disabled = isDisabled;
	
	    if (this.calendarButton) {
	      this.calendarButton.disabled = isDisabled;
	    }
	  };
	
	  /**
	   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
	   *   - mindate: whether the selected date is before the minimum date.
	   *   - maxdate: whether the selected flag is after the maximum date.
	   *   - filtered: whether the selected date is allowed by the custom filtering function.
	   *   - valid: whether the entered text input is a valid date
	   *
	   * The 'required' flag is handled automatically by ngModel.
	   *
	   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
	   */
	  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
	    var date = opt_date || this.date;
	
	    // Clear any existing errors to get rid of anything that's no longer relevant.
	    this.clearErrorState();
	
	    if (this.dateUtil.isValidDate(date)) {
	      // Force all dates to midnight in order to ignore the time portion.
	      date = this.dateUtil.createDateAtMidnight(date);
	
	      if (this.dateUtil.isValidDate(this.minDate)) {
	        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
	        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
	      }
	
	      if (this.dateUtil.isValidDate(this.maxDate)) {
	        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
	        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
	      }
	
	      if (angular.isFunction(this.dateFilter)) {
	        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
	      }
	    } else {
	      // The date is seen as "not a valid date" if there is *something* set
	      // (i.e.., not null or undefined), but that something isn't a valid date.
	      this.ngModelCtrl.$setValidity('valid', date == null);
	    }
	
	    // TODO(jelbourn): Change this to classList.toggle when we stop using PhantomJS in unit tests
	    // because it doesn't conform to the DOMTokenList spec.
	    // See https://github.com/ariya/phantomjs/issues/12782.
	    if (!this.ngModelCtrl.$valid) {
	      this.inputContainer.classList.add(INVALID_CLASS);
	    }
	  };
	
	  /** Clears any error flags set by `updateErrorState`. */
	  DatePickerCtrl.prototype.clearErrorState = function() {
	    this.inputContainer.classList.remove(INVALID_CLASS);
	    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
	      this.ngModelCtrl.$setValidity(field, true);
	    }, this);
	  };
	
	  /** Resizes the input element based on the size of its content. */
	  DatePickerCtrl.prototype.resizeInputElement = function() {
	    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
	  };
	
	  /**
	   * Sets the model value if the user input is a valid date.
	   * Adds an invalid class to the input element if not.
	   */
	  DatePickerCtrl.prototype.handleInputEvent = function() {
	    var inputString = this.inputElement.value;
	    var parsedDate = inputString ? this.dateLocale.parseDate(inputString) : null;
	    this.dateUtil.setDateTimeToMidnight(parsedDate);
	
	    // An input string is valid if it is either empty (representing no date)
	    // or if it parses to a valid date that the user is allowed to select.
	    var isValidInput = inputString == '' || (
	      this.dateUtil.isValidDate(parsedDate) &&
	      this.dateLocale.isDateComplete(inputString) &&
	      this.isDateEnabled(parsedDate)
	    );
	
	    // The datepicker's model is only updated when there is a valid input.
	    if (isValidInput) {
	      this.setModelValue(parsedDate);
	      this.date = parsedDate;
	    }
	
	    this.updateErrorState(parsedDate);
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
	          (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
	  };
	
	  /** Position and attach the floating calendar to the document. */
	  DatePickerCtrl.prototype.attachCalendarPane = function() {
	    var calendarPane = this.calendarPane;
	    var body = document.body;
	
	    calendarPane.style.transform = '';
	    this.$element.addClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
	    angular.element(body).addClass('md-datepicker-is-showing');
	
	    var elementRect = this.inputContainer.getBoundingClientRect();
	    var bodyRect = body.getBoundingClientRect();
	
	    if (!this.topMargin || this.topMargin < 0) {
	      this.topMargin = (this.inputMask.parent().prop('clientHeight') - this.ngInputElement.prop('clientHeight')) / 2;
	    }
	
	    // Check to see if the calendar pane would go off the screen. If so, adjust position
	    // accordingly to keep it within the viewport.
	    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
	    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;
	
	    // If ng-material has disabled body scrolling (for example, if a dialog is open),
	    // then it's possible that the already-scrolled body has a negative top/left. In this case,
	    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
	    // though, the top of the viewport should just be the body's scroll position.
	    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ?
	        -bodyRect.top :
	        document.body.scrollTop;
	
	    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ?
	        -bodyRect.left :
	        document.body.scrollLeft;
	
	    var viewportBottom = viewportTop + this.$window.innerHeight;
	    var viewportRight = viewportLeft + this.$window.innerWidth;
	
	    // Creates an overlay with a hole the same size as element. We remove a pixel or two
	    // on each end to make it overlap slightly. The overlay's background is added in
	    // the theme in the form of a box-shadow with a huge spread.
	    this.inputMask.css({
	      position: 'absolute',
	      left: this.leftMargin + 'px',
	      top: this.topMargin + 'px',
	      width: (elementRect.width - 1) + 'px',
	      height: (elementRect.height - 2) + 'px'
	    });
	
	    // If the right edge of the pane would be off the screen and shifting it left by the
	    // difference would not go past the left edge of the screen. If the calendar pane is too
	    // big to fit on the screen at all, move it to the left of the screen and scale the entire
	    // element down to fit.
	    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
	      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
	        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
	      } else {
	        paneLeft = viewportLeft;
	        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
	        calendarPane.style.transform = 'scale(' + scale + ')';
	      }
	
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    // If the bottom edge of the pane would be off the screen and shifting it up by the
	    // difference would not go past the top edge of the screen.
	    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
	        viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
	      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    calendarPane.style.left = paneLeft + 'px';
	    calendarPane.style.top = paneTop + 'px';
	    document.body.appendChild(calendarPane);
	
	    // Add CSS class after one frame to trigger open animation.
	    this.$$rAF(function() {
	      calendarPane.classList.add('md-pane-open');
	    });
	  };
	
	  /** Detach the floating calendar pane from the document. */
	  DatePickerCtrl.prototype.detachCalendarPane = function() {
	    this.$element.removeClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
	    angular.element(document.body).removeClass('md-datepicker-is-showing');
	    this.calendarPane.classList.remove('md-pane-open');
	    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');
	
	    if (this.isCalendarOpen) {
	      this.$mdUtil.enableScrolling();
	    }
	
	    if (this.calendarPane.parentNode) {
	      // Use native DOM removal because we do not want any of the
	      // angular state of this element to be disposed.
	      this.calendarPane.parentNode.removeChild(this.calendarPane);
	    }
	  };
	
	  /**
	   * Open the floating calendar pane.
	   * @param {Event} event
	   */
	  DatePickerCtrl.prototype.openCalendarPane = function(event) {
	    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
	      this.isCalendarOpen = this.isOpen = true;
	      this.calendarPaneOpenedFrom = event.target;
	
	      // Because the calendar pane is attached directly to the body, it is possible that the
	      // rest of the component (input, etc) is in a different scrolling container, such as
	      // an md-content. This means that, if the container is scrolled, the pane would remain
	      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
	      // also matches the native behavior for things like `<select>` on Mac and Windows.
	      this.$mdUtil.disableScrollAround(this.calendarPane);
	
	      this.attachCalendarPane();
	      this.focusCalendar();
	      this.evalAttr('ngFocus');
	
	      // Attach click listener inside of a timeout because, if this open call was triggered by a
	      // click, we don't want it to be immediately propogated up to the body and handled.
	      var self = this;
	      this.$mdUtil.nextTick(function() {
	        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
	        // events aren't propogated under most circumstances.
	        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	        self.documentElement.on('click touchstart', self.bodyClickHandler);
	      }, false);
	
	      window.addEventListener(this.windowEventName, this.windowEventHandler);
	    }
	  };
	
	  /** Close the floating calendar pane. */
	  DatePickerCtrl.prototype.closeCalendarPane = function() {
	    if (this.isCalendarOpen) {
	      var self = this;
	
	      self.detachCalendarPane();
	      self.ngModelCtrl.$setTouched();
	      self.evalAttr('ngBlur');
	
	      self.documentElement.off('click touchstart', self.bodyClickHandler);
	      window.removeEventListener(self.windowEventName, self.windowEventHandler);
	
	      self.calendarPaneOpenedFrom.focus();
	      self.calendarPaneOpenedFrom = null;
	
	      if (self.openOnFocus) {
	        // Ensures that all focus events have fired before resetting
	        // the calendar. Prevents the calendar from reopening immediately
	        // in IE when md-open-on-focus is set. Also it needs to trigger
	        // a digest, in order to prevent issues where the calendar wasn't
	        // showing up on the next open.
	        self.$mdUtil.nextTick(reset);
	      } else {
	        reset();
	      }
	    }
	
	    function reset(){
	      self.isCalendarOpen = self.isOpen = false;
	    }
	  };
	
	  /** Gets the controller instance for the calendar in the floating pane. */
	  DatePickerCtrl.prototype.getCalendarCtrl = function() {
	    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
	  };
	
	  /** Focus the calendar in the floating pane. */
	  DatePickerCtrl.prototype.focusCalendar = function() {
	    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
	    var self = this;
	    this.$mdUtil.nextTick(function() {
	      self.getCalendarCtrl().focus();
	    }, false);
	  };
	
	  /**
	   * Sets whether the input is currently focused.
	   * @param {boolean} isFocused
	   */
	  DatePickerCtrl.prototype.setFocused = function(isFocused) {
	    if (!isFocused) {
	      this.ngModelCtrl.$setTouched();
	    }
	
	    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
	    // because they also get called when the calendar is opened/closed.
	    if (!this.openOnFocus) {
	      this.evalAttr(isFocused ? 'ngFocus' : 'ngBlur');
	    }
	
	    this.isFocused = isFocused;
	  };
	
	  /**
	   * Handles a click on the document body when the floating calendar pane is open.
	   * Closes the floating calendar pane if the click is not inside of it.
	   * @param {MouseEvent} event
	   */
	  DatePickerCtrl.prototype.handleBodyClick = function(event) {
	    if (this.isCalendarOpen) {
	      var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
	
	      if (!isInCalendar) {
	        this.closeCalendarPane();
	      }
	
	      this.$scope.$digest();
	    }
	  };
	
	  /**
	   * Handles the event when the user navigates away from the current tab. Keeps track of
	   * whether the input was focused when the event happened, in order to prevent the calendar
	   * from re-opening.
	   */
	  DatePickerCtrl.prototype.handleWindowBlur = function() {
	    this.inputFocusedOnWindowBlur = document.activeElement === this.inputElement;
	  };
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   */
	  DatePickerCtrl.prototype.evalAttr = function(attr) {
	    if (this.$attrs[attr]) {
	      this.$scope.$parent.$eval(this.$attrs[attr]);
	    }
	  };
	
	  /**
	   * Sets the ng-model value by first converting the date object into a strng. Converting it
	   * is necessary, in order to pass Angular's `input[type="date"]` validations. Angular turns
	   * the value into a Date object afterwards, before setting it on the model.
	   * @param {Date=} value Date to be set as the model value.
	   */
	  DatePickerCtrl.prototype.setModelValue = function(value) {
	    this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd'));
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.components.icon')
	  .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', '$sce', mdIconDirective]);
	
	/**
	 * @ngdoc directive
	 * @name mdIcon
	 * @module material.components.icon
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
	 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
	 *
	 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
	 * inside a `md-button` to add hover and click features.
	 *
	 * ### Icon fonts
	 * Icon fonts are a technique in which you use a font where the glyphs in the font are
	 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
	 * single HTTP request, simple scaling, easy color changing, and more.
	 *
	 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
	 * by name rather than character code.
	 *
	 * ### SVG
	 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
	 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
	 * animation.
	 *
	 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
	 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
	 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
	 * reference it by name instead of URL throughout your templates.
	 *
	 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
	 * your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can
	 * also be given a name, which acts as a namespace for individual icons, so you can reference them
	 * like `"social:cake"`.
	 *
	 * When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be
	 * easily loaded and used.When use font-icons, developers must following three (3) simple steps:
	 *
	 * <ol>
	 * <li>Load the font library. e.g.<br/>
	 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
	 *    rel="stylesheet">`
	 * </li>
	 * <li>
	 *   Use either (a) font-icon class names or (b) font ligatures to render the font glyph by using
	 *   its textual name
	 * </li>
	 * <li>
	 *   Use `<md-icon md-font-icon="classname" />` or <br/>
	 *   use `<md-icon md-font-set="font library classname or alias"> textual_name </md-icon>` or <br/>
	 *   use `<md-icon md-font-set="font library classname or alias"> numerical_character_reference </md-icon>`
	 * </li>
	 * </ol>
	 *
	 * Full details for these steps can be found:
	 *
	 * <ul>
	 * <li>http://google.github.io/material-design-icons/</li>
	 * <li>http://google.github.io/material-design-icons/#icon-font-for-the-web</li>
	 * </ul>
	 *
	 * The Material Design icon style <code>.material-icons</code> and the icon font references are published in
	 * Material Design Icons:
	 *
	 * <ul>
	 * <li>https://design.google.com/icons/</li>
	 * <li>https://design.google.com/icons/#ic_accessibility</li>
	 * </ul>
	 *
	 * <h2 id="material_design_icons">Material Design Icons</h2>
	 * Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and
	 * determine its textual name and character reference code. Click on any icon to see the slide-up information
	 * panel with details regarding a SVG download or information on the font-icon usage.
	 *
	 * <a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank" style="border-bottom:none;">
	 * <img src="https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png"
	 *      aria-label="Material Design Icon-Selector" style="max-width:75%;padding-left:10%">
	 * </a>
	 *
	 * <span class="image_caption">
	 *  Click on the image above to link to the
	 *  <a href="https://design.google.com/icons/#ic_accessibility" target="_blank">Material Design Icon-Selector</a>.
	 * </span>
	 *
	 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
	 * to render the icon. Requires the fonts and the named CSS styles to be preloaded.
	 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
	 * the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
	 * internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
	 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
	 *     external SVG.
	 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
	 *     interpolated strings or expressions may also be used. Specific set names can be used with
	 *     the syntax `<set name>:<icon name>`.<br/><br/>
	 * To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
	 * @param {string=} aria-label Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no aria-label on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 * @param {string=} alt Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no alt on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 *
	 * @usage
	 * When using SVGs:
	 * <hljs lang="html">
	 *
	 *  <!-- Icon ID; may contain optional icon set prefix; icons must registered using $mdIconProvider -->
	 *  <md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
	 *
	 *  <!-- Icon urls; may be preloaded in templateCache -->
	 *  <md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
	 *  <md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
	 *
	 * </hljs>
	 *
	 * Use the <code>$mdIconProvider</code> to configure your application with
	 * svg iconsets.
	 *
	 * <hljs lang="js">
	 *  angular.module('appSvgIconSets', ['ngMaterial'])
	 *    .controller('DemoCtrl', function($scope) {})
	 *    .config(function($mdIconProvider) {
	 *      $mdIconProvider
	 *         .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
	 *         .defaultIconSet('img/icons/sets/core-icons.svg', 24);
	 *     });
	 * </hljs>
	 *
	 *
	 * When using Font Icons with classnames:
	 * <hljs lang="html">
	 *
	 *  <md-icon md-font-icon="android" aria-label="android" ></md-icon>
	 *  <md-icon class="icon_home"      aria-label="Home"    ></md-icon>
	 *
	 * </hljs>
	 *
	 * When using Material Font Icons with ligatures:
	 * <hljs lang="html">
	 *  <!--
	 *  For Material Design Icons
	 *  The class '.material-icons' is auto-added if a style has NOT been specified
	 *  since `material-icons` is the default fontset. So your markup:
	 *  -->
	 *  <md-icon> face </md-icon>
	 *  <!-- becomes this at runtime: -->
	 *  <md-icon md-font-set="material-icons"> face </md-icon>
	 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
	 *  <md-icon> &#xE87C; </md-icon>
	 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
	 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
	 * </hljs>
	 *
	 * When using other Font-Icon libraries:
	 *
	 * <hljs lang="js">
	 *  // Specify a font-icon style alias
	 *  angular.config(function($mdIconProvider) {
	 *    $mdIconProvider.fontSet('md', 'material-icons');
	 *  });
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *  <md-icon md-font-set="md">favorite</md-icon>
	 * </hljs>
	 *
	 */
	function mdIconDirective($mdIcon, $mdTheming, $mdAria, $sce) {
	
	  return {
	    restrict: 'E',
	    link : postLink
	  };
	
	
	  /**
	   * Directive postLink
	   * Supports embedded SVGs, font-icons, & external SVGs
	   */
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    var lastFontIcon = attr.mdFontIcon;
	    var lastFontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	    prepareForFontIcon();
	
	    attr.$observe('mdFontIcon', fontIconChanged);
	    attr.$observe('mdFontSet', fontIconChanged);
	
	    // Keep track of the content of the svg src so we can compare against it later to see if the
	    // attribute is static (and thus safe).
	    var originalSvgSrc = element[0].getAttribute(attr.$attr.mdSvgSrc);
	
	    // If using a font-icon, then the textual name of the icon itself
	    // provides the aria-label.
	
	    var label = attr.alt || attr.mdFontIcon || attr.mdSvgIcon || element.text();
	    var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');
	
	    if ( !attr['aria-label'] ) {
	
	      if (label !== '' && !parentsHaveText() ) {
	
	        $mdAria.expect(element, 'aria-label', label);
	        $mdAria.expect(element, 'role', 'img');
	
	      } else if ( !element.text() ) {
	        // If not a font-icon with ligature, then
	        // hide from the accessibility layer.
	
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      }
	    }
	
	    if (attrName) {
	      // Use either pre-configured SVG or URL source, respectively.
	      attr.$observe(attrName, function(attrVal) {
	        element.empty();
	        if (attrVal) {
	          $mdIcon(attrVal)
	            .then(function(svg) {
	            element.empty();
	            element.append(svg);
	          });
	        }
	
	      });
	    }
	
	    function parentsHaveText() {
	      var parent = element.parent();
	      if (parent.attr('aria-label') || parent.text()) {
	        return true;
	      }
	      else if(parent.parent().attr('aria-label') || parent.parent().text()) {
	        return true;
	      }
	      return false;
	    }
	
	    function prepareForFontIcon() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.addClass('md-font ' + attr.mdFontIcon);
	        }
	
	        element.addClass(lastFontSet);
	      }
	    }
	
	    function fontIconChanged() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.removeClass(lastFontIcon);
	          element.addClass(attr.mdFontIcon);
	
	          lastFontIcon = attr.mdFontIcon;
	        }
	
	        var fontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	        if (lastFontSet !== fontSet) {
	          element.removeClass(lastFontSet);
	          element.addClass(fontSet);
	
	          lastFontSet = fontSet;
	        }
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	  
	MdIconService.$inject = ["config", "$templateRequest", "$q", "$log", "$mdUtil", "$sce"];angular
	    .module('material.components.icon')
	    .constant('$$mdSvgRegistry', {
	        'mdTabsArrow':   'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=',
	        'mdClose':       'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=',
	        'mdCancel':      'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==',
	        'mdMenu':        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+',
	        'mdToggleArrow': 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==',
	        'mdCalendar':    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==',
	        'mdChecked':     'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'
	    })
	    .provider('$mdIcon', MdIconProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdIconProvider
	 * @module material.components.icon
	 *
	 * @description
	 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
	 * icons and icon sets to be pre-registered and associated with source URLs **before** the `<md-icon />`
	 * directives are compiled.
	 *
	 * If using font-icons, the developer is responsible for loading the fonts.
	 *
	 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
	 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
	 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
	 * that URL is used to on-demand load and parse the SVG dynamically.
	 *
	 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
	 * This means, when loading icons from an external URL, you have to trust the URL in the `$sceDelegateProvider`.
	 *
	 * <hljs lang="js">
	 *   app.config(function($sceDelegateProvider) {
	 *     $sceDelegateProvider.resourceUrlWhitelist([
	 *       // Adding 'self' to the whitelist, will allow requests from the current origin.
	 *       'self',
	 *       // Using double asterisks here, will allow all URLs to load.
	 *       // We recommend to only specify the given domain you want to allow.
	 *       '**'
	 *     ]);
	 *   });
	 * </hljs>
	 *
	 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
	 *
	 * **Notice:** Most font-icons libraries do not support ligatures (for example `fontawesome`).<br/>
	 *  In such cases you are not able to use the icon's ligature name - Like so:
	 *
	 *  <hljs lang="html">
	 *    <md-icon md-font-set="fa">fa-bell</md-icon>
	 *  </hljs>
	 *
	 * You should instead use the given unicode, instead of the ligature name.
	 *
	 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
	 *  ```html
	 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
	 *  ```
	 *
	 * All unicode ligatures are prefixed with the `&#x` string.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultFontSet( 'fa' )                   // This sets our default fontset className.
	    *          .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime
	 * **startup** process (shown below):
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Register a default set of SVG icon definitions
	    *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
	    *
	    *   })
	 *   .run(function($templateRequest){
	    *
	    *     // Pre-fetch icons sources by URL and cache in the $templateCache...
	    *     // subsequent $templateRequest calls will look there first.
	    *
	    *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
	    *
	    *     angular.forEach(urls, function(url) {
	    *       $templateRequest(url);
	    *     });
	    *
	    *   });
	 *
	 * </hljs>
	 *
	 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#icon
	 *
	 * @description
	 * Register a source URL for a specific icon name; the name may include optional 'icon set' name prefix.
	 * These icons  will later be retrieved from the cache using `$mdIcon( <icon name> )`
	 *
	 * @param {string} id Icon name/id used to register the icon
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
	 * It is ignored for icons with an existing viewBox. Default size is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#iconSet
	 *
	 * @description
	 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
	 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
	 * `$mdIcon(<icon set name>:<icon name>)`
	 *
	 * @param {string} id Icon name/id used to register the iconset
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultIconSet
	 *
	 * @description
	 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
	 * subsequent lookups of icons will failover to search this 'default' icon set.
	 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
	 *
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultIconSet( 'my/app/social.svg' )   // Register a default icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultFontSet
	 *
	 * @description
	 * When using Font-Icons, Angular Material assumes the the Material Design icons will be used and automatically
	 * configures the default font-set == 'material-icons'. Note that the font-set references the font-icon library
	 * class style that should be applied to the `<md-icon>`.
	 *
	 * Configuring the default means that the attributes
	 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared on the
	 * `<md-icon>` markup. For example:
	 *
	 *  `<md-icon> face </md-icon>`
	 *  will render as
	 *  `<span class="material-icons"> face </span>`, and
	 *
	 *  `<md-icon md-font-set="fa"> face </md-icon>`
	 *  will render as
	 *  `<span class="fa"> face </span>`
	 *
	 * @param {string} name of the font-library style that should be applied to the md-icon DOM element
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     $mdIconProvider.defaultFontSet( 'fa' );
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#fontSet
	 *
	 * @description
	 * When using a font set for `<md-icon>` you must specify the correct font classname in the `md-font-set`
	 * attribute. If the fonset className is really long, your markup may become cluttered... an easy
	 * solution is to define an `alias` for your fontset:
	 *
	 * @param {string} alias of the specified fontset.
	 * @param {string} className of the fontset.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     // In this case, we set an alias for the `material-icons` fontset.
	   *     $mdIconProvider.fontSet('md', 'material-icons');
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultViewBoxSize
	 *
	 * @description
	 * While `<md-icon />` markup can also be style with sizing CSS, this method configures
	 * the default width **and** height used for all icons; unless overridden by specific CSS.
	 * The default sizing is (24px, 24px).
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
	 * All icons in a set should be the same size. The default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultViewBoxSize(36)   // Register a default icon size (width == height)
	    *   });
	 * </hljs>
	 *
	 */
	
	var config = {
	  defaultViewBoxSize: 24,
	  defaultFontSet: 'material-icons',
	  fontSets: []
	};
	
	function MdIconProvider() {
	}
	
	MdIconProvider.prototype = {
	  icon: function(id, url, viewBoxSize) {
	    if (id.indexOf(':') == -1) id = '$default:' + id;
	
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  iconSet: function(id, url, viewBoxSize) {
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  defaultIconSet: function(url, viewBoxSize) {
	    var setName = '$default';
	
	    if (!config[setName]) {
	      config[setName] = new ConfigurationItem(url, viewBoxSize);
	    }
	
	    config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	
	    return this;
	  },
	
	  defaultViewBoxSize: function(viewBoxSize) {
	    config.defaultViewBoxSize = viewBoxSize;
	    return this;
	  },
	
	  /**
	   * Register an alias name associated with a font-icon library style ;
	   */
	  fontSet: function fontSet(alias, className) {
	    config.fontSets.push({
	      alias: alias,
	      fontSet: className || alias
	    });
	    return this;
	  },
	
	  /**
	   * Specify a default style name associated with a font-icon library
	   * fallback to Material Icons.
	   *
	   */
	  defaultFontSet: function defaultFontSet(className) {
	    config.defaultFontSet = !className ? '' : className;
	    return this;
	  },
	
	  defaultIconSize: function defaultIconSize(iconSize) {
	    config.defaultIconSize = iconSize;
	    return this;
	  },
	
	  $get: ['$templateRequest', '$q', '$log', '$mdUtil', '$sce', function($templateRequest, $q, $log, $mdUtil, $sce) {
	    return MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce);
	  }]
	};
	
	/**
	 *  Configuration item stored in the Icon registry; used for lookups
	 *  to load if not already cached in the `loaded` cache
	 */
	function ConfigurationItem(url, viewBoxSize) {
	  this.url = url;
	  this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	}
	
	/**
	 * @ngdoc service
	 * @name $mdIcon
	 * @module material.components.icon
	 *
	 * @description
	 * The `$mdIcon` service is a function used to lookup SVG icons.
	 *
	 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
	 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
	 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
	 *
	 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
	 * using the `$mdIconProvider`.
	 *
	 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
	 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
	 * will get rejected.
	 *
	 * @usage
	 * <hljs lang="js">
	 * function SomeDirective($mdIcon) {
	  *
	  *   // See if the icon has already been loaded, if not
	  *   // then lookup the icon from the registry cache, load and cache
	  *   // it for future requests.
	  *   // NOTE: ID queries require configuration with $mdIconProvider
	  *
	  *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
	  *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
	  *
	  *   // Load and cache the external SVG using a URL
	  *
	  *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
	  *     element.append(iconEl);
	  *   });
	  * };
	 * </hljs>
	 *
	 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, loaded,
	 *   and instantiate SVG DOM elements.
	 */
	
	/* @ngInject */
	function MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce) {
	  var iconCache = {};
	  var svgCache = {};
	  var urlRegex = /[-\w@:%\+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%\+.~#?&//=]*)?/i;
	  var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-\=]*?(base64)?,(.*)$/i;
	
	  Icon.prototype = {clone: cloneSVG, prepare: prepareAndStyle};
	  getIcon.fontSet = findRegisteredFontSet;
	
	  // Publish service...
	  return getIcon;
	
	  /**
	   * Actual $mdIcon service is essentially a lookup function
	   */
	  function getIcon(id) {
	    id = id || '';
	
	    // If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
	    // over a URL string. If the value is not trusted, this will intentionally throw an error
	    // because the user is attempted to use an unsafe URL, potentially opening themselves up
	    // to an XSS attack.
	    if (!angular.isString(id)) {
	      id = $sce.getTrustedUrl(id);
	    }
	
	    // If already loaded and cached, use a clone of the cached icon.
	    // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.
	
	    if (iconCache[id]) {
	      return $q.when(transformClone(iconCache[id]));
	    }
	
	    if (urlRegex.test(id) || dataUrlRegex.test(id)) {
	      return loadByURL(id).then(cacheIcon(id));
	    }
	
	    if (id.indexOf(':') == -1) {
	      id = '$default:' + id;
	    }
	
	    var load = config[id] ? loadByID : loadFromIconSet;
	    return load(id)
	      .then(cacheIcon(id));
	  }
	
	  /**
	   * Lookup registered fontSet style using its alias...
	   * If not found,
	   */
	  function findRegisteredFontSet(alias) {
	    var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
	    if (useDefault) return config.defaultFontSet;
	
	    var result = alias;
	    angular.forEach(config.fontSets, function(it) {
	      if (it.alias == alias) result = it.fontSet || result;
	    });
	
	    return result;
	  }
	
	  function transformClone(cacheElement) {
	    var clone = cacheElement.clone();
	    var cacheSuffix = '_cache' + $mdUtil.nextUid();
	
	    // We need to modify for each cached icon the id attributes.
	    // This is needed because SVG id's are treated as normal DOM ids
	    // and should not have a duplicated id.
	    if (clone.id) clone.id += cacheSuffix;
	    angular.forEach(clone.querySelectorAll('[id]'), function(item) {
	      item.id += cacheSuffix;
	    });
	
	    return clone;
	  }
	
	  /**
	   * Prepare and cache the loaded icon for the specified `id`
	   */
	  function cacheIcon(id) {
	
	    return function updateCache(icon) {
	      iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);
	
	      return iconCache[id].clone();
	    };
	  }
	
	  /**
	   * Lookup the configuration in the registry, if !registered throw an error
	   * otherwise load the icon [on-demand] using the registered URL.
	   *
	   */
	  function loadByID(id) {
	    var iconConfig = config[id];
	    return loadByURL(iconConfig.url).then(function(icon) {
	      return new Icon(icon, iconConfig);
	    });
	  }
	
	  /**
	   *    Loads the file as XML and uses querySelector( <id> ) to find
	   *    the desired node...
	   */
	  function loadFromIconSet(id) {
	    var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
	    var iconSetConfig = config[setName];
	
	    return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);
	
	    function extractFromSet(set) {
	      var iconName = id.slice(id.lastIndexOf(':') + 1);
	      var icon = set.querySelector('#' + iconName);
	      return icon ? new Icon(icon, iconSetConfig) : announceIdNotFound(id);
	    }
	
	    function announceIdNotFound(id) {
	      var msg = 'icon ' + id + ' not found';
	      $log.warn(msg);
	
	      return $q.reject(msg || id);
	    }
	  }
	
	  /**
	   * Load the icon by URL (may use the $templateCache).
	   * Extract the data for later conversion to Icon
	   */
	  function loadByURL(url) {
	    /* Load the icon from embedded data URL. */
	    function loadByDataUrl(url) {
	      var results = dataUrlRegex.exec(url);
	      var isBase64 = /base64/i.test(url);
	      var data = isBase64 ? window.atob(results[2]) : results[2];
	
	      return $q.when(angular.element(data)[0]);
	    }
	
	    /* Load the icon by URL using HTTP. */
	    function loadByHttpUrl(url) {
	      return $q(function(resolve, reject) {
	        // Catch HTTP or generic errors not related to incorrect icon IDs.
	        var announceAndReject = function(err) {
	            var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
	            $log.warn(msg);
	            reject(err);
	          },
	          extractSvg = function(response) {
	            if (!svgCache[url]) {
	              svgCache[url] = angular.element('<div>').append(response)[0].querySelector('svg');
	            }
	            resolve(svgCache[url]);
	          };
	
	        $templateRequest(url, true).then(extractSvg, announceAndReject);
	      });
	    }
	
	    return dataUrlRegex.test(url)
	      ? loadByDataUrl(url)
	      : loadByHttpUrl(url);
	  }
	
	  /**
	   * Check target signature to see if it is an Icon instance.
	   */
	  function isIcon(target) {
	    return angular.isDefined(target.element) && angular.isDefined(target.config);
	  }
	
	  /**
	   *  Define the Icon class
	   */
	  function Icon(el, config) {
	    if (el && el.tagName != 'svg') {
	      el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];
	    }
	
	    // Inject the namespace if not available...
	    if (!el.getAttribute('xmlns')) {
	      el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	    }
	
	    this.element = el;
	    this.config = config;
	    this.prepare();
	  }
	
	  /**
	   *  Prepare the DOM element that will be cached in the
	   *  loaded iconCache store.
	   */
	  function prepareAndStyle() {
	    var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
	    angular.forEach({
	      'fit': '',
	      'height': '100%',
	      'width': '100%',
	      'preserveAspectRatio': 'xMidYMid meet',
	      'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
	      'focusable': false // Disable IE11s default behavior to make SVGs focusable
	    }, function(val, attr) {
	      this.element.setAttribute(attr, val);
	    }, this);
	  }
	
	  /**
	   * Clone the Icon DOM element.
	   */
	  function cloneSVG() {
	    // If the element or any of its children have a style attribute, then a CSP policy without
	    // 'unsafe-inline' in the style-src directive, will result in a violation.
	    return this.element.cloneNode(true);
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	
	MenuController.$inject = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q"];
	angular
	    .module('material.components.menu')
	    .controller('mdMenuCtrl', MenuController);
	
	/**
	 * @ngInject
	 */
	function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q) {
	
	  var prefixer = $mdUtil.prefixer();
	  var menuContainer;
	  var self = this;
	  var triggerElement;
	
	  this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;
	
	  /**
	   * Called by our linking fn to provide access to the menu-content
	   * element removed during link
	   */
	  this.init = function init(setMenuContainer, opts) {
	    opts = opts || {};
	    menuContainer = setMenuContainer;
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerElement = $element[0].querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter']));
	    triggerElement.setAttribute('aria-expanded', 'false');
	
	    this.isInMenuBar = opts.isInMenuBar;
	    this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));
	
	    menuContainer.on('$mdInterimElementRemove', function() {
	      self.isOpen = false;
	      $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    });
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
	    menuContainer.attr('id', menuContainerId);
	    angular.element(triggerElement).attr({
	      'aria-owns': menuContainerId,
	      'aria-haspopup': 'true'
	    });
	
	    $scope.$on('$destroy', angular.bind(this, function() {
	      this.disableHoverListener();
	      $mdMenu.destroy();
	    }));
	
	    menuContainer.on('$destroy', function() {
	      $mdMenu.destroy();
	    });
	  };
	
	  var openMenuTimeout, menuItems, deregisterScopeListeners = [];
	  this.enableHoverListener = function() {
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = el.controller('mdMenu');
	        self.isAlreadyOpening = false;
	        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
	      }
	    }));
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = undefined;
	      }
	    }));
	    menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
	    menuItems.on('mouseenter', self.handleMenuItemHover);
	    menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.disableHoverListener = function() {
	    while (deregisterScopeListeners.length) {
	      deregisterScopeListeners.shift()();
	    }
	    menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
	    menuItems && menuItems.off('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.handleMenuItemHover = function(event) {
	    if (self.isAlreadyOpening) return;
	    var nestedMenu = (
	      event.target.querySelector('md-menu')
	        || $mdUtil.getClosest(event.target, 'MD-MENU')
	    );
	    openMenuTimeout = $timeout(function() {
	      if (nestedMenu) {
	        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
	      }
	
	      if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
	        var closeTo = self.nestLevel + 1;
	        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      }
	    }, nestedMenu ? 100 : 250);
	    var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
	    focusableTarget && focusableTarget.focus();
	  };
	
	  this.handleMenuItemMouseLeave = function() {
	    if (openMenuTimeout) {
	      $timeout.cancel(openMenuTimeout);
	      openMenuTimeout = undefined;
	    }
	  };
	
	
	  /**
	   * Uses the $mdMenu interim element service to open the menu contents
	   */
	  this.open = function openMenu(ev) {
	    ev && ev.stopPropagation();
	    ev && ev.preventDefault();
	    if (self.isOpen) return;
	    self.enableHoverListener();
	    self.isOpen = true;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    triggerElement = triggerElement || (ev ? ev.target : $element[0]);
	    triggerElement.setAttribute('aria-expanded', 'true');
	    $scope.$emit('$mdMenuOpen', $element);
	    $mdMenu.show({
	      scope: $scope,
	      mdMenuCtrl: self,
	      nestLevel: self.nestLevel,
	      element: menuContainer,
	      target: triggerElement,
	      preserveElement: true,
	      parent: 'body'
	    }).finally(function() {
	      triggerElement.setAttribute('aria-expanded', 'false');
	      self.disableHoverListener();
	    });
	  };
	
	  // Expose a open function to the child scope for html to use
	  $scope.$mdOpenMenu = this.open;
	
	  this.onIsOpenChanged = function(isOpen) {
	    if (isOpen) {
	      menuContainer.attr('aria-hidden', 'false');
	      $element[0].classList.add('md-open');
	      angular.forEach(self.nestedMenus, function(el) {
	        el.classList.remove('md-open');
	      });
	    } else {
	      menuContainer.attr('aria-hidden', 'true');
	      $element[0].classList.remove('md-open');
	    }
	    $scope.$mdMenuIsOpen = self.isOpen;
	  };
	
	  this.focusMenuContainer = function focusMenuContainer() {
	    var focusTarget = menuContainer[0]
	      .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	    if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button');
	    focusTarget.focus();
	  };
	
	  this.registerContainerProxy = function registerContainerProxy(handler) {
	    this.containerProxy = handler;
	  };
	
	  this.triggerContainerProxy = function triggerContainerProxy(ev) {
	    this.containerProxy && this.containerProxy(ev);
	  };
	
	  this.destroy = function() {
	    return self.isOpen ? $mdMenu.destroy() : $q.when(false);
	  };
	
	  // Use the $mdMenu interim element service to close the menu contents
	  this.close = function closeMenu(skipFocus, closeOpts) {
	    if ( !self.isOpen ) return;
	    self.isOpen = false;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
	    $scope.$emit('$mdMenuClose', $element, eventDetails);
	    $mdMenu.hide(null, closeOpts);
	
	    if (!skipFocus) {
	      var el = self.restoreFocusTo || $element.find('button')[0];
	      if (el instanceof angular.element) el = el[0];
	      if (el) el.focus();
	    }
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies the
	   * target mode for left and top positioning
	   */
	  this.positionMode = function positionMode() {
	    var attachment = ($attrs.mdPositionMode || 'target').split(' ');
	
	    // If attachment is a single item, duplicate it for our second value.
	    // ie. 'target' -> 'target target'
	    if (attachment.length == 1) {
	      attachment.push(attachment[0]);
	    }
	
	    return {
	      left: attachment[0],
	      top: attachment[1]
	    };
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies
	   * the offset of top and left in pixels.
	   */
	  this.offsets = function offsets() {
	    var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
	    if (position.length == 2) {
	      return {
	        left: position[0],
	        top: position[1]
	      };
	    } else if (position.length == 1) {
	      return {
	        top: position[0],
	        left: position[0]
	      };
	    } else {
	      throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenu
	 * @module material.components.menu
	 * @restrict E
	 * @description
	 *
	 * Menus are elements that open when clicked. They are useful for displaying
	 * additional options within the context of an action.
	 *
	 * Every `md-menu` must specify exactly two child elements. The first element is what is
	 * left in the DOM and is used to open the menu. This element is called the trigger element.
	 * The trigger element's scope has access to `$mdOpenMenu($event)`
	 * which it may call to open the menu. By passing $event as argument, the
	 * corresponding event is stopped from propagating up the DOM-tree.
	 *
	 * The second element is the `md-menu-content` element which represents the
	 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
	 * but you can do custom content as well.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <!-- Trigger element is a md-button with an icon -->
	 *  <md-button ng-click="$mdOpenMenu($event)" class="md-icon-button" aria-label="Open sample menu">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	
	 * ## Sizing Menus
	 *
	 * The width of the menu when it is open may be specified by specifying a `width`
	 * attribute on the `md-menu-content` element.
	 * See the [Material Design Spec](https://material.google.com/components/menus.html#menus-simple-menus)
	 * for more information.
	 *
	 *
	 * ## Aligning Menus
	 *
	 * When a menu opens, it is important that the content aligns with the trigger element.
	 * Failure to align menus can result in jarring experiences for users as content
	 * suddenly shifts. To help with this, `md-menu` provides serveral APIs to help
	 * with alignment.
	 *
	 * ### Target Mode
	 *
	 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
	 * designated child elements in both the trigger and the menu content.
	 *
	 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
	 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
	 * will be used as the origin element.
	 *
	 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
	 * `md-menu-item` to specify the node that it should try and align with.
	 *
	 * In this example code, we specify an icon to be our origin element, and an
	 * icon in our menu content to be our alignment target. This ensures that both
	 * icons are aligned when the menu opens.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdOpenMenu($event)" class="md-icon-button" aria-label="Open some menu">
	 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item>
	 *      <md-button ng-click="doSomething()" aria-label="Do something">
	 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *        Do Something
	 *      </md-button>
	 *    </md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * Sometimes we want to specify alignment on the right side of an element, for example
	 * if we have a menu on the right side a toolbar, we want to right align our menu content.
	 *
	 * We can specify the origin by using the `md-position-mode` attribute on both
	 * the `x` and `y` axis. Right now only the `x-axis` has more than one option.
	 * You may specify the default mode of `target target` or
	 * `target-right target` to specify a right-oriented alignment target. See the
	 * position section of the demos for more examples.
	 *
	 * ### Menu Offsets
	 *
	 * It is sometimes unavoidable to need to have a deeper level of control for
	 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
	 * the `md-offset` attribute to allow pixel level specificty of adjusting the
	 * exact positioning.
	 *
	 * This offset is provided in the format of `x y` or `n` where `n` will be used
	 * in both the `x` and `y` axis.
	 *
	 * For example, to move a menu by `2px` from the top, we can use:
	 * <hljs lang="html">
	 * <md-menu md-offset="2 0">
	 *   <!-- menu-content -->
	 * </md-menu>
	 * </hljs>
	 *
	 * ### Auto Focus
	 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
	 * 
	 * But sometimes you would like to focus another specific menu item instead of the first.<br/>
	 * This can be done by applying the `md-autofocus` directive on the given element.
	 *
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-button md-autofocus ng-click="doSomething()">
	 *     Auto Focus
	 *   </md-button>
	 * </md-menu-item>
	 * </hljs>
	 *
	 *
	 * ### Preventing close
	 *
	 * Sometimes you would like to be able to click on a menu item without having the menu
	 * close. To do this, ngMaterial exposes the `md-prevent-menu-close` attribute which
	 * can be added to a button inside a menu to stop the menu from automatically closing.
	 * You can then close the menu programatically by injecting `$mdMenu` and calling 
	 * `$mdMenu.hide()`.
	 *
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
	 *     <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *     Do Something
	 *   </md-button>
	 * </md-menu-item>
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdOpenMenu($event)" class="md-icon-button">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * @param {string} md-position-mode The position mode in the form of
	 *           `x`, `y`. Default value is `target`,`target`. Right now the `x` axis
	 *           also suppports `target-right`.
	 * @param {string} md-offset An offset to apply to the dropdown after positioning
	 *           `x`, `y`. Default value is `0`,`0`.
	 *
	 */
	
	MenuDirective.$inject = ["$mdUtil"];
	angular
	    .module('material.components.menu')
	    .directive('mdMenu', MenuDirective);
	
	/**
	 * @ngInject
	 */
	function MenuDirective($mdUtil) {
	  var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
	  return {
	    restrict: 'E',
	    require: ['mdMenu', '?^mdMenuBar'],
	    controller: 'mdMenuCtrl', // empty function to be built by link
	    scope: true,
	    compile: compile
	  };
	
	  function compile(templateElement) {
	    templateElement.addClass('md-menu');
	    var triggerElement = templateElement.children()[0];
	    var prefixer = $mdUtil.prefixer();
	
	    if (!prefixer.hasAttribute(triggerElement, 'ng-click')) {
	      triggerElement = triggerElement
	          .querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter'])) || triggerElement;
	    }
	    if (triggerElement && (
	      triggerElement.nodeName == 'MD-BUTTON' ||
	      triggerElement.nodeName == 'BUTTON'
	    ) && !triggerElement.hasAttribute('type')) {
	      triggerElement.setAttribute('type', 'button');
	    }
	
	    if (templateElement.children().length != 2) {
	      throw Error(INVALID_PREFIX + 'Expected two children elements.');
	    }
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerElement && triggerElement.setAttribute('aria-haspopup', 'true');
	
	    var nestedMenus = templateElement[0].querySelectorAll('md-menu');
	    var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
	    if (nestedMenus) {
	      angular.forEach($mdUtil.nodesToArray(nestedMenus), function(menuEl) {
	        if (!menuEl.hasAttribute('md-position-mode')) {
	          menuEl.setAttribute('md-position-mode', 'cascade');
	        }
	        menuEl.classList.add('_md-nested-menu');
	        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
	      });
	    }
	    return link;
	  }
	
	  function link(scope, element, attr, ctrls) {
	    var mdMenuCtrl = ctrls[0];
	    var isInMenuBar = ctrls[1] != undefined;
	    // Move everything into a md-menu-container and pass it to the controller
	    var menuContainer = angular.element( '<div class="_md md-open-menu-container md-whiteframe-z2"></div>');
	    var menuContents = element.children()[1];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    if (!menuContents.hasAttribute('role')) {
	      menuContents.setAttribute('role', 'menu');
	    }
	    menuContainer.append(menuContents);
	
	    element.on('$destroy', function() {
	      menuContainer.remove();
	    });
	
	    element.append(menuContainer);
	    menuContainer[0].style.display = 'none';
	    mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar });
	
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuProvider.$inject = ["$$interimElementProvider"];angular
	  .module('material.components.menu')
	  .provider('$mdMenu', MenuProvider);
	
	/*
	 * Interim element provider for the menu.
	 * Handles behavior for a menu while it is open, including:
	 *    - handling animating the menu opening/closing
	 *    - handling key/mouse events on the menu element
	 *    - handling enabling/disabling scroll while the menu is open
	 *    - handling redrawing during resizes and orientation changes
	 *
	 */
	
	function MenuProvider($$interimElementProvider) {
	  menuDefaultOptions.$inject = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate"];
	  var MENU_EDGE_MARGIN = 8;
	
	  return $$interimElementProvider('$mdMenu')
	    .setDefaults({
	      methods: ['target'],
	      options: menuDefaultOptions
	    });
	
	  /* @ngInject */
	  function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF, $animateCss, $animate) {
	    var prefixer = $mdUtil.prefixer();
	    var animator = $mdUtil.dom.animator;
	
	    return {
	      parent: 'body',
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true,
	      skipCompile: true,
	      preserveScope: true,
	      skipHide: true,
	      themable: true
	    };
	
	    /**
	     * Show modal backdrop element...
	     * @returns {function(): void} A function that removes this backdrop
	     */
	    function showBackdrop(scope, element, options) {
	      if (options.nestLevel) return angular.noop;
	
	      // If we are not within a dialog...
	      if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	      } else {
	        options.disableParentScroll = false;
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-menu-backdrop md-click-catcher");
	
	        $animate.enter(options.backdrop, $document[0].body);
	      }
	
	      /**
	       * Hide and destroys the backdrop created by showBackdrop()
	       */
	      return function hideBackdrop() {
	        if (options.backdrop) options.backdrop.remove();
	        if (options.disableParentScroll) options.restoreScroll();
	      };
	    }
	
	    /**
	     * Removing the menu element from the DOM and remove all associated event listeners
	     * and backdrop
	     */
	    function onRemove(scope, element, opts) {
	      opts.cleanupInteraction && opts.cleanupInteraction();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	
	      return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then( detachAndClean );
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return $animateCss(element, {addClass: 'md-leave'}).start();
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        element.removeClass('md-active');
	        detachElement(element, opts);
	        opts.alreadyOpen = false;
	      }
	
	    }
	
	    /**
	     * Inserts and configures the staged Menu element into the DOM, positioning it,
	     * and wiring up various interaction events
	     */
	    function onShow(scope, element, opts) {
	      sanitizeAndConfigure(opts);
	
	      // Wire up theming on our menu element
	      $mdTheming.inherit(opts.menuContentEl, opts.target);
	
	      // Register various listeners to move menu on resize/orientation change
	      opts.cleanupResizing = startRepositioningOnResize();
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      // Return the promise for when our menu is done animating in
	      return showMenu()
	        .then(function(response) {
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          return response;
	        });
	
	      /**
	       * Place the menu into the DOM and call positioning related functions
	       */
	      function showMenu() {
	        opts.parent.append(element);
	        element[0].style.display = '';
	
	        return $q(function(resolve) {
	          var position = calculateMenuPosition(element, opts);
	
	          element.removeClass('md-leave');
	
	          // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
	          // to normal scale.
	          $animateCss(element, {
	            addClass: 'md-active',
	            from: animator.toCss(position),
	            to: animator.toCss({transform: ''})
	          })
	          .start()
	          .then(resolve);
	
	        });
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure() {
	        if (!opts.target) {
	          throw Error(
	            '$mdMenu.show() expected a target to animate from in options.target'
	          );
	        }
	        angular.extend(opts, {
	          alreadyOpen: false,
	          isRemoved: false,
	          target: angular.element(opts.target), //make sure it's not a naked dom node
	          parent: angular.element(opts.parent),
	          menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function startRepositioningOnResize() {
	
	        var repositionMenu = (function(target, options) {
	          return $$rAF.throttle(function() {
	            if (opts.isRemoved) return;
	            var position = calculateMenuPosition(target, options);
	
	            target.css(animator.toCss(position));
	          });
	        })(element, opts);
	
	        $window.addEventListener('resize', repositionMenu);
	        $window.addEventListener('orientationchange', repositionMenu);
	
	        return function stopRepositioningOnResize() {
	
	          // Disable resizing handlers
	          $window.removeEventListener('resize', repositionMenu);
	          $window.removeEventListener('orientationchange', repositionMenu);
	
	        }
	      }
	
	      /**
	       * Activate interaction on the menu. Wire up keyboard listerns for
	       * clicks, keypresses, backdrop closing, etc.
	       */
	      function activateInteraction() {
	        element.addClass('md-clickable');
	
	        // close on backdrop click
	        if (opts.backdrop) opts.backdrop.on('click', onBackdropClick);
	
	        // Wire up keyboard listeners.
	        // - Close on escape,
	        // - focus next item on down arrow,
	        // - focus prev item on up
	        opts.menuContentEl.on('keydown', onMenuKeyDown);
	        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);
	
	        // kick off initial focus in the menu on the first element
	        var focusTarget = opts.menuContentEl[0]
	          .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	        if ( !focusTarget ) {
	          var firstChild = opts.menuContentEl[0].firstElementChild;
	
	          focusTarget = firstChild && (firstChild.querySelector('.md-button:not([disabled])') || firstChild.firstElementChild);
	        }
	
	        focusTarget && focusTarget.focus();
	
	        return function cleanupInteraction() {
	          element.removeClass('md-clickable');
	          if (opts.backdrop) opts.backdrop.off('click', onBackdropClick);
	          opts.menuContentEl.off('keydown', onMenuKeyDown);
	          opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
	        };
	
	        // ************************************
	        // internal functions
	        // ************************************
	
	        function onMenuKeyDown(ev) {
	          var handled;
	          switch (ev.keyCode) {
	            case $mdConstant.KEY_CODE.ESCAPE:
	              opts.mdMenuCtrl.close(false, { closeAll: true });
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.UP_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.DOWN_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.LEFT_ARROW:
	              if (opts.nestLevel) {
	                opts.mdMenuCtrl.close();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.RIGHT_ARROW:
	              var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
	              if (parentMenu && parentMenu != opts.parent[0]) {
	                ev.target.click();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	          }
	          if (handled) {
	            ev.preventDefault();
	            ev.stopImmediatePropagation();
	          }
	        }
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          scope.$apply(function() {
	            opts.mdMenuCtrl.close(true, { closeAll: true });
	          });
	        }
	
	        // Close menu on menu item click, if said menu-item is not disabled
	        function captureClickListener(e) {
	          var target = e.target;
	          // Traverse up the event until we get to the menuContentEl to see if
	          // there is an ng-click and that the ng-click is not disabled
	          do {
	            if (target == opts.menuContentEl[0]) return;
	            if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
	                target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
	              var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
	              if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
	                close();
	              }
	              break;
	            }
	          } while (target = target.parentNode)
	
	          function close() {
	            scope.$apply(function() {
	              opts.mdMenuCtrl.close(true, { closeAll: true });
	            });
	          }
	
	          function hasAnyAttribute(target, attrs) {
	            if (!target) return false;
	
	            for (var i = 0, attr; attr = attrs[i]; ++i) {
	              if (prefixer.hasAttribute(target, attr)) {
	                return true;
	              }
	            }
	
	            return false;
	          }
	        }
	
	      }
	    }
	
	    /**
	     * Takes a keypress event and focuses the next/previous menu
	     * item from the emitting element
	     * @param {event} e - The origin keypress event
	     * @param {angular.element} menuEl - The menu element
	     * @param {object} opts - The interim element options for the mdMenu
	     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
	     */
	    function focusMenuItem(e, menuEl, opts, direction) {
	      var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');
	
	      var items = $mdUtil.nodesToArray(menuEl[0].children);
	      var currentIndex = items.indexOf(currentItem);
	
	      // Traverse through our elements in the specified direction (+/-1) and try to
	      // focus them until we find one that accepts focus
	      var didFocus;
	      for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
	        var focusTarget = items[i].querySelector('.md-button');
	        didFocus = attemptFocus(focusTarget);
	        if (didFocus) {
	          break;
	        }
	      }
	      return didFocus;
	    }
	
	    /**
	     * Attempts to focus an element. Checks whether that element is the currently
	     * focused element after attempting.
	     * @param {HTMLElement} el - the element to attempt focus on
	     * @returns {bool} - whether the element was successfully focused
	     */
	    function attemptFocus(el) {
	      if (el && el.getAttribute('tabindex') != -1) {
	        el.focus();
	        return ($document[0].activeElement == el);
	      }
	    }
	
	    /**
	     * Use browser to remove this element without triggering a $destroy event
	     */
	    function detachElement(element, opts) {
	      if (!opts.preserveElement) {
	        if (toNode(element).parentNode === toNode(opts.parent)) {
	          toNode(opts.parent).removeChild(toNode(element));
	        }
	      } else {
	        toNode(element).style.display = 'none';
	      }
	    }
	
	    /**
	     * Computes menu position and sets the style on the menu container
	     * @param {HTMLElement} el - the menu container element
	     * @param {object} opts - the interim element options object
	     */
	    function calculateMenuPosition(el, opts) {
	
	      var containerNode = el[0],
	        openMenuNode = el[0].firstElementChild,
	        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
	        boundryNode = $document[0].body,
	        boundryNodeRect = boundryNode.getBoundingClientRect();
	
	      var menuStyle = $window.getComputedStyle(openMenuNode);
	
	      var originNode = opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin')) || opts.target[0],
	        originNodeRect = originNode.getBoundingClientRect();
	
	      var bounds = {
	        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
	        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
	        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
	        right: boundryNodeRect.right - MENU_EDGE_MARGIN
	      };
	
	      var alignTarget, alignTargetRect = { top:0, left : 0, right:0, bottom:0 }, existingOffsets  = { top:0, left : 0, right:0, bottom:0  };
	      var positionMode = opts.mdMenuCtrl.positionMode();
	
	      if (positionMode.top == 'target' || positionMode.left == 'target' || positionMode.left == 'target-right') {
	        alignTarget = firstVisibleChild();
	        if ( alignTarget ) {
	          // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
	          alignTarget = alignTarget.firstElementChild || alignTarget;
	          alignTarget = alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target')) || alignTarget;
	          alignTargetRect = alignTarget.getBoundingClientRect();
	
	          existingOffsets = {
	            top: parseFloat(containerNode.style.top || 0),
	            left: parseFloat(containerNode.style.left || 0)
	          };
	        }
	      }
	
	      var position = {};
	      var transformOrigin = 'top ';
	
	      switch (positionMode.top) {
	        case 'target':
	          position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
	          break;
	        case 'cascade':
	          position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
	          break;
	        case 'bottom':
	          position.top = originNodeRect.top + originNodeRect.height;
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
	      }
	
	      var rtl = ($mdUtil.bidi() == 'rtl');
	
	      switch (positionMode.left) {
	        case 'target':
	          position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
	          transformOrigin += rtl ? 'right'  : 'left';
	          break;
	        case 'target-left':
	          position.left = originNodeRect.left;
	          transformOrigin += 'left';
	          break;
	        case 'target-right':
	          position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
	          transformOrigin += 'right';
	          break;
	        case 'cascade':
	          var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
	          position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
	          transformOrigin += willFitRight ? 'left' : 'right';
	          break;
	        case 'right':
	          if (rtl) {
	            position.left = originNodeRect.right - originNodeRect.width;
	            transformOrigin += 'left';
	          } else {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          }
	          break;
	        case 'left':
	          if (rtl) {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          } else {
	            position.left = originNodeRect.left;
	            transformOrigin += 'left';
	          }
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
	      }
	
	      var offsets = opts.mdMenuCtrl.offsets();
	      position.top += offsets.top;
	      position.left += offsets.left;
	
	      clamp(position);
	
	      var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;
	
	      return {
	        top: Math.round(position.top),
	        left: Math.round(position.left),
	        // Animate a scale out if we aren't just repositioning
	        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
	        transformOrigin: transformOrigin
	      };
	
	      /**
	       * Clamps the repositioning of the menu within the confines of
	       * bounding element (often the screen/body)
	       */
	      function clamp(pos) {
	        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
	        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
	      }
	
	      /**
	       * Gets the first visible child in the openMenuNode
	       * Necessary incase menu nodes are being dynamically hidden
	       */
	      function firstVisibleChild() {
	        for (var i = 0; i < openMenuNode.children.length; ++i) {
	          if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
	            return openMenuNode.children[i];
	          }
	        }
	      }
	    }
	  }
	  function toNode(el) {
	    if (el instanceof angular.element) {
	      el = el[0];
	    }
	    return el;
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuBarController.$inject = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuBarController', MenuBarController);
	
	var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];
	
	/**
	 * @ngInject
	 */
	function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$mdConstant = $mdConstant;
	  this.$mdUtil = $mdUtil;
	  this.$document = $document;
	  this.$scope = $scope;
	  this.$rootScope = $rootScope;
	  this.$timeout = $timeout;
	
	  var self = this;
	  angular.forEach(BOUND_MENU_METHODS, function(methodName) {
	    self[methodName] = angular.bind(self, self[methodName]);
	  });
	}
	
	MenuBarController.prototype.init = function() {
	  var $element = this.$element;
	  var $mdUtil = this.$mdUtil;
	  var $scope = this.$scope;
	
	  var self = this;
	  var deregisterFns = [];
	  $element.on('keydown', this.handleKeyDown);
	  this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function(event, el) {
	    if (self.getMenus().indexOf(el[0]) != -1) {
	      $element[0].classList.add('md-open');
	      el[0].classList.add('md-open');
	      self.currentlyOpenMenu = el.controller('mdMenu');
	      self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
	      self.enableOpenOnHover();
	    }
	  }));
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function(event, el, opts) {
	    var rootMenus = self.getMenus();
	    if (rootMenus.indexOf(el[0]) != -1) {
	      $element[0].classList.remove('md-open');
	      el[0].classList.remove('md-open');
	    }
	
	    if ($element[0].contains(el[0])) {
	      var parentMenu = el[0];
	      while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
	        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
	      }
	      if (parentMenu) {
	        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
	        self.currentlyOpenMenu = undefined;
	        self.disableOpenOnHover();
	        self.setKeyboardMode(true);
	      }
	    }
	  }));
	
	  $scope.$on('$destroy', function() {
	    self.disableOpenOnHover();
	    while (deregisterFns.length) {
	      deregisterFns.shift()();
	    }
	  });
	
	
	  this.setKeyboardMode(true);
	};
	
	MenuBarController.prototype.setKeyboardMode = function(enabled) {
	  if (enabled) this.$element[0].classList.add('md-keyboard-mode');
	  else this.$element[0].classList.remove('md-keyboard-mode');
	};
	
	MenuBarController.prototype.enableOpenOnHover = function() {
	  if (this.openOnHoverEnabled) return;
	
	  var self = this;
	
	  self.openOnHoverEnabled = true;
	
	  if (self.parentToolbar) {
	    self.parentToolbar.classList.add('md-has-open-menu');
	
	    // Needs to be on the next tick so it doesn't close immediately.
	    self.$mdUtil.nextTick(function() {
	      angular.element(self.parentToolbar).on('click', self.handleParentClick);
	    }, false);
	  }
	
	  angular
	    .element(self.getMenus())
	    .on('mouseenter', self.handleMenuHover);
	};
	
	MenuBarController.prototype.handleMenuHover = function(e) {
	  this.setKeyboardMode(false);
	  if (this.openOnHoverEnabled) {
	    this.scheduleOpenHoveredMenu(e);
	  }
	};
	
	MenuBarController.prototype.disableOpenOnHover = function() {
	  if (!this.openOnHoverEnabled) return;
	
	  this.openOnHoverEnabled = false;
	
	  if (this.parentToolbar) {
	    this.parentToolbar.classList.remove('md-has-open-menu');
	    angular.element(this.parentToolbar).off('click', this.handleParentClick);
	  }
	
	  angular
	    .element(this.getMenus())
	    .off('mouseenter', this.handleMenuHover);
	};
	
	MenuBarController.prototype.scheduleOpenHoveredMenu = function(e) {
	  var menuEl = angular.element(e.currentTarget);
	  var menuCtrl = menuEl.controller('mdMenu');
	  this.setKeyboardMode(false);
	  this.scheduleOpenMenu(menuCtrl);
	};
	
	MenuBarController.prototype.scheduleOpenMenu = function(menuCtrl) {
	  var self = this;
	  var $timeout = this.$timeout;
	  if (menuCtrl != self.currentlyOpenMenu) {
	    $timeout.cancel(self.pendingMenuOpen);
	    self.pendingMenuOpen = $timeout(function() {
	      self.pendingMenuOpen = undefined;
	      if (self.currentlyOpenMenu) {
	        self.currentlyOpenMenu.close(true, { closeAll: true });
	      }
	      menuCtrl.open();
	    }, 200, false);
	  }
	};
	
	MenuBarController.prototype.handleKeyDown = function(e) {
	  var keyCodes = this.$mdConstant.KEY_CODE;
	  var currentMenu = this.currentlyOpenMenu;
	  var wasOpen = currentMenu && currentMenu.isOpen;
	  this.setKeyboardMode(true);
	  var handled, newMenu, newMenuCtrl;
	  switch (e.keyCode) {
	    case keyCodes.DOWN_ARROW:
	      if (currentMenu) {
	        currentMenu.focusMenuContainer();
	      } else {
	        this.openFocusedMenu();
	      }
	      handled = true;
	      break;
	    case keyCodes.UP_ARROW:
	      currentMenu && currentMenu.close();
	      handled = true;
	      break;
	    case keyCodes.LEFT_ARROW:
	      newMenu = this.focusMenu(-1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	    case keyCodes.RIGHT_ARROW:
	      newMenu = this.focusMenu(+1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	  }
	  if (handled) {
	    e && e.preventDefault && e.preventDefault();
	    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
	  }
	};
	
	MenuBarController.prototype.focusMenu = function(direction) {
	  var menus = this.getMenus();
	  var focusedIndex = this.getFocusedMenuIndex();
	
	  if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }
	
	  var changed = false;
	
	  if (focusedIndex == -1) { focusedIndex = 0; changed = true; }
	  else if (
	    direction < 0 && focusedIndex > 0 ||
	    direction > 0 && focusedIndex < menus.length - direction
	  ) {
	    focusedIndex += direction;
	    changed = true;
	  }
	  if (changed) {
	    menus[focusedIndex].querySelector('button').focus();
	    return menus[focusedIndex];
	  }
	};
	
	MenuBarController.prototype.openFocusedMenu = function() {
	  var menu = this.getFocusedMenu();
	  menu && angular.element(menu).controller('mdMenu').open();
	};
	
	MenuBarController.prototype.getMenus = function() {
	  var $element = this.$element;
	  return this.$mdUtil.nodesToArray($element[0].children)
	    .filter(function(el) { return el.nodeName == 'MD-MENU'; });
	};
	
	MenuBarController.prototype.getFocusedMenu = function() {
	  return this.getMenus()[this.getFocusedMenuIndex()];
	};
	
	MenuBarController.prototype.getFocusedMenuIndex = function() {
	  var $mdUtil = this.$mdUtil;
	  var focusedEl = $mdUtil.getClosest(
	    this.$document[0].activeElement,
	    'MD-MENU'
	  );
	  if (!focusedEl) return -1;
	
	  var focusedIndex = this.getMenus().indexOf(focusedEl);
	  return focusedIndex;
	};
	
	MenuBarController.prototype.getOpenMenuIndex = function() {
	  var menus = this.getMenus();
	  for (var i = 0; i < menus.length; ++i) {
	    if (menus[i].classList.contains('md-open')) return i;
	  }
	  return -1;
	};
	
	MenuBarController.prototype.handleParentClick = function(event) {
	  var openMenu = this.querySelector('md-menu.md-open');
	
	  if (openMenu && !openMenu.contains(event.target)) {
	    angular.element(openMenu).controller('mdMenu').close();
	  }
	};
	
	
	
	
	
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenuBar
	 * @module material.components.menu-bar
	 * @restrict E
	 * @description
	 *
	 * Menu bars are containers that hold multiple menus. They change the behavior and appearence
	 * of the `md-menu` directive to behave similar to an operating system provided menu.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *   <md-menu>
	 *     <button ng-click="$mdOpenMenu()">
	 *       File
	 *     </button>
	 *     <md-menu-content>
	 *       <md-menu-item>
	 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
	 *           Share...
	 *         </md-button>
	 *       </md-menu-item>
	 *       <md-menu-divider></md-menu-divider>
	 *       <md-menu-item>
	 *       <md-menu-item>
	 *         <md-menu>
	 *           <md-button ng-click="$mdOpenMenu()">New</md-button>
	 *           <md-menu-content>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *           </md-menu-content>
	 *         </md-menu>
	 *       </md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 * ## Menu Bar Controls
	 *
	 * You may place `md-menu-items` that function as controls within menu bars.
	 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
	 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
	 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
	 * to the `string` value of the `value` attribute. If you need non-string values, you can use
	 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]` works.
	 *
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *  <md-menu>
	 *    <button ng-click="$mdOpenMenu()">
	 *      Sample Menu
	 *    </button>
	 *    <md-menu-content>
	 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges">Allow changes</md-menu-item>
	 *      <md-menu-divider></md-menu-divider>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 2</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 3</md-menu-item>
	 *    </md-menu-content>
	 *  </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 *
	 * ### Nesting Menus
	 *
	 * Menus may be nested within menu bars. This is commonly called cascading menus.
	 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-menu>
	 *     <button ng-click="$mdOpenMenu()">New</md-button>
	 *     <md-menu-content>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-item>
	 * </hljs>
	 *
	 */
	
	MenuBarDirective.$inject = ["$mdUtil", "$mdTheming"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuBar', MenuBarDirective);
	
	/* @ngInject */
	function MenuBarDirective($mdUtil, $mdTheming) {
	  return {
	    restrict: 'E',
	    require: 'mdMenuBar',
	    controller: 'MenuBarController',
	
	    compile: function compile(templateEl, templateAttrs) {
	      if (!templateAttrs.ariaRole) {
	        templateEl[0].setAttribute('role', 'menubar');
	      }
	      angular.forEach(templateEl[0].children, function(menuEl) {
	        if (menuEl.nodeName == 'MD-MENU') {
	          if (!menuEl.hasAttribute('md-position-mode')) {
	            menuEl.setAttribute('md-position-mode', 'left bottom');
	
	            // Since we're in the compile function and actual `md-buttons` are not compiled yet,
	            // we need to query for possible `md-buttons` as well.
	            menuEl.querySelector('button, a, md-button').setAttribute('role', 'menuitem');
	          }
	          var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
	          angular.forEach(contentEls, function(contentEl) {
	            contentEl.classList.add('md-menu-bar-menu');
	            contentEl.classList.add('md-dense');
	            if (!contentEl.hasAttribute('width')) {
	              contentEl.setAttribute('width', 5);
	            }
	          });
	        }
	      });
	
	      // Mark the child menu items that they're inside a menu bar. This is necessary,
	      // because mnMenuItem has special behaviour during compilation, depending on
	      // whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
	      // however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
	      // the element won't have a parent and won't compile properly.
	      templateEl.find('md-menu-item').addClass('md-in-menu-bar');
	
	      return function postLink(scope, el, attr, ctrl) {
	        el.addClass('_md');     // private md component indicator for styling
	        $mdTheming(scope, el);
	        ctrl.init();
	      };
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuDivider', MenuDividerDirective);
	
	
	function MenuDividerDirective() {
	  return {
	    restrict: 'E',
	    compile: function(templateEl, templateAttrs) {
	      if (!templateAttrs.role) {
	        templateEl[0].setAttribute('role', 'separator');
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemController.$inject = ["$scope", "$element", "$attrs"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuItemController', MenuItemController);
	
	
	/**
	 * @ngInject
	 */
	function MenuItemController($scope, $element, $attrs) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$scope = $scope;
	}
	
	MenuItemController.prototype.init = function(ngModel) {
	  var $element = this.$element;
	  var $attrs = this.$attrs;
	
	  this.ngModel = ngModel;
	  if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
	    this.mode  = $attrs.type;
	    this.iconEl = $element[0].children[0];
	    this.buttonEl = $element[0].children[1];
	    if (ngModel) {
	      // Clear ngAria set attributes
	      this.initClickListeners();
	    }
	  }
	};
	
	// ngAria auto sets attributes on a menu-item with a ngModel.
	// We don't want this because our content (buttons) get the focus
	// and set their own aria attributes appropritately. Having both
	// breaks NVDA / JAWS. This undeoes ngAria's attrs.
	MenuItemController.prototype.clearNgAria = function() {
	  var el = this.$element[0];
	  var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
	  angular.forEach(clearAttrs, function(attr) {
	    el.removeAttribute(attr);
	  });
	};
	
	MenuItemController.prototype.initClickListeners = function() {
	  var self = this;
	  var ngModel = this.ngModel;
	  var $scope = this.$scope;
	  var $attrs = this.$attrs;
	  var $element = this.$element;
	  var mode = this.mode;
	
	  this.handleClick = angular.bind(this, this.handleClick);
	
	  var icon = this.iconEl;
	  var button = angular.element(this.buttonEl);
	  var handleClick = this.handleClick;
	
	  $attrs.$observe('disabled', setDisabled);
	  setDisabled($attrs.disabled);
	
	  ngModel.$render = function render() {
	    self.clearNgAria();
	    if (isSelected()) {
	      icon.style.display = '';
	      button.attr('aria-checked', 'true');
	    } else {
	      icon.style.display = 'none';
	      button.attr('aria-checked', 'false');
	    }
	  };
	
	  $scope.$$postDigest(ngModel.$render);
	
	  function isSelected() {
	    if (mode == 'radio') {
	      var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
	      return ngModel.$modelValue == val;
	    } else {
	      return ngModel.$modelValue;
	    }
	  }
	
	  function setDisabled(disabled) {
	    if (disabled) {
	      button.off('click', handleClick);
	    } else {
	      button.on('click', handleClick);
	    }
	  }
	};
	
	MenuItemController.prototype.handleClick = function(e) {
	  var mode = this.mode;
	  var ngModel = this.ngModel;
	  var $attrs = this.$attrs;
	  var newVal;
	  if (mode == 'checkbox') {
	    newVal = !ngModel.$modelValue;
	  } else if (mode == 'radio') {
	    newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
	  }
	  ngModel.$setViewValue(newVal);
	  ngModel.$render();
	};
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemDirective.$inject = ["$mdUtil", "$$mdSvgRegistry"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuItem', MenuItemDirective);
	
	 /* @ngInject */
	function MenuItemDirective($mdUtil, $$mdSvgRegistry) {
	  return {
	    controller: 'MenuItemController',
	    require: ['mdMenuItem', '?ngModel'],
	    priority: 210, // ensure that our post link runs after ngAria
	    compile: function(templateEl, templateAttrs) {
	      var type = templateAttrs.type;
	      var inMenuBarClass = 'md-in-menu-bar';
	
	      // Note: This allows us to show the `check` icon for the md-menu-bar items.
	      // The `md-in-menu-bar` class is set by the mdMenuBar directive.
	      if ((type == 'checkbox' || type == 'radio') && templateEl.hasClass(inMenuBarClass)) {
	        var text = templateEl[0].textContent;
	        var buttonEl = angular.element('<md-button type="button"></md-button>');
	        var iconTemplate = '<md-icon md-svg-src="' + $$mdSvgRegistry.mdChecked + '"></md-icon>';
	
	        buttonEl.html(text);
	        buttonEl.attr('tabindex', '0');
	
	        templateEl.html('');
	        templateEl.append(angular.element(iconTemplate));
	        templateEl.append(buttonEl);
	        templateEl.addClass('md-indent').removeClass(inMenuBarClass);
	
	        setDefault('role', type == 'checkbox' ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
	        moveAttrToButton('ng-disabled');
	
	      } else {
	        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button, button, a'));
	      }
	
	
	      return function(scope, el, attrs, ctrls) {
	        var ctrl = ctrls[0];
	        var ngModel = ctrls[1];
	        ctrl.init(ngModel);
	      };
	
	      function setDefault(attr, val, el) {
	        el = el || templateEl;
	        if (el instanceof angular.element) {
	          el = el[0];
	        }
	        if (!el.hasAttribute(attr)) {
	          el.setAttribute(attr, val);
	        }
	      }
	
	      function moveAttrToButton(attribute) {
	        var attributes = $mdUtil.prefixer(attribute);
	
	        angular.forEach(attributes, function(attr) {
	          if (templateEl[0].hasAttribute(attr)) {
	            var val = templateEl[0].getAttribute(attr);
	            buttonEl[0].setAttribute(attr, val);
	            templateEl[0].removeAttribute(attr);
	          }
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdProgressCircular
	 * @module material.components.progressCircular
	 * @restrict E
	 *
	 * @description
	 * The circular progress directive is used to make loading content in your app as delightful and
	 * painless as possible by minimizing the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * For operations where the percentage of the operation completed can be determined, use a
	 * determinate indicator. They give users a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while something finishes up, and it’s
	 * not necessary to expose what's happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
	 * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate mode, this number represents the percentage of the
	 *     circular progress. Default: 0
	 * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
	 * should be a pixel-size value (eg '100'). If this attribute is
	 * not present then a default value of '50px' is assumed.
	 *
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
	 * </hljs>
	 */
	
	MdProgressCircularDirective.$inject = ["$window", "$mdProgressCircular", "$mdTheming", "$mdUtil", "$interval", "$log"];
	angular
	  .module('material.components.progressCircular')
	  .directive('mdProgressCircular', MdProgressCircularDirective);
	
	/* @ngInject */
	function MdProgressCircularDirective($window, $mdProgressCircular, $mdTheming,
	                                     $mdUtil, $interval, $log) {
	
	  // Note that this shouldn't use use $$rAF, because it can cause an infinite loop
	  // in any tests that call $animate.flush.
	  var rAF = $window.requestAnimationFrame ||
	            $window.webkitRequestAnimationFrame ||
	            angular.noop;
	
	  var cAF = $window.cancelAnimationFrame ||
	            $window.webkitCancelAnimationFrame ||
	            $window.webkitCancelRequestAnimationFrame ||
	            angular.noop;
	
	  var DEGREE_IN_RADIANS = $window.Math.PI / 180;
	  var MODE_DETERMINATE = 'determinate';
	  var MODE_INDETERMINATE = 'indeterminate';
	  var DISABLED_CLASS = '_md-progress-circular-disabled';
	  var INDETERMINATE_CLASS = 'md-mode-indeterminate';
	
	  return {
	    restrict: 'E',
	    scope: {
	      value: '@',
	      mdDiameter: '@',
	      mdMode: '@'
	    },
	    template:
	      '<svg xmlns="http://www.w3.org/2000/svg">' +
	        '<path fill="none"/>' +
	      '</svg>',
	    compile: function(element, attrs) {
	      element.attr({
	        'aria-valuemin': 0,
	        'aria-valuemax': 100,
	        'role': 'progressbar'
	      });
	
	      if (angular.isUndefined(attrs.mdMode)) {
	        var hasValue = angular.isDefined(attrs.value);
	        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        var info = "Auto-adding the missing md-mode='{0}' to the ProgressCircular element";
	
	          // $log.debug( $mdUtil.supplant(info, [mode]) );
	        attrs.$set('mdMode', mode);
	      } else {
	        attrs.$set('mdMode', attrs.mdMode.trim());
	      }
	
	      return MdProgressCircularLink;
	    }
	  };
	
	  function MdProgressCircularLink(scope, element, attrs) {
	    var node = element[0];
	    var svg = angular.element(node.querySelector('svg'));
	    var path = angular.element(node.querySelector('path'));
	    var startIndeterminate = $mdProgressCircular.startIndeterminate;
	    var endIndeterminate = $mdProgressCircular.endIndeterminate;
	    var rotationIndeterminate = 0;
	    var lastAnimationId = 0;
	    var lastDrawFrame;
	    var interval;
	
	    $mdTheming(element);
	    element.toggleClass(DISABLED_CLASS, attrs.hasOwnProperty('disabled'));
	
	    // If the mode is indeterminate, it doesn't need to
	    // wait for the next digest. It can start right away.
	    if(scope.mdMode === MODE_INDETERMINATE){
	      startIndeterminateAnimation();
	    }
	
	    scope.$on('$destroy', function(){
	      cleanupIndeterminateAnimation();
	
	      if (lastDrawFrame) {
	        cAF(lastDrawFrame);
	      }
	    });
	
	    scope.$watchGroup(['value', 'mdMode', function() {
	      var isDisabled = node.disabled;
	
	      // Sometimes the browser doesn't return a boolean, in
	      // which case we should check whether the attribute is
	      // present.
	      if (isDisabled === true || isDisabled === false){
	        return isDisabled;
	      }
	      return angular.isDefined(element.attr('disabled'));
	
	    }], function(newValues, oldValues) {
	      var mode = newValues[1];
	      var isDisabled = newValues[2];
	      var wasDisabled = oldValues[2];
	
	      if (isDisabled !== wasDisabled) {
	        element.toggleClass(DISABLED_CLASS, !!isDisabled);
	      }
	
	      if (isDisabled) {
	        cleanupIndeterminateAnimation();
	      } else {
	        if (mode !== MODE_DETERMINATE && mode !== MODE_INDETERMINATE) {
	          mode = MODE_INDETERMINATE;
	          attrs.$set('mdMode', mode);
	        }
	
	        if (mode === MODE_INDETERMINATE) {
	          startIndeterminateAnimation();
	        } else {
	          var newValue = clamp(newValues[0]);
	
	          cleanupIndeterminateAnimation();
	
	          element.attr('aria-valuenow', newValue);
	          renderCircle(clamp(oldValues[0]), newValue);
	        }
	      }
	
	    });
	
	    // This is in a separate watch in order to avoid layout, unless
	    // the value has actually changed.
	    scope.$watch('mdDiameter', function(newValue) {
	      var diameter = getSize(newValue);
	      var strokeWidth = getStroke(diameter);
	      var transformOrigin = (diameter / 2) + 'px';
	      var dimensions = {
	        width: diameter + 'px',
	        height: diameter + 'px'
	      };
	
	      // The viewBox has to be applied via setAttribute, because it is
	      // case-sensitive. If jQuery is included in the page, `.attr` lowercases
	      // all attribute names.
	      svg[0].setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);
	
	      // Usually viewBox sets the dimensions for the SVG, however that doesn't
	      // seem to be the case on IE10.
	      // Important! The transform origin has to be set from here and it has to
	      // be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
	      // IE and Edge, because they don't account for the stroke width when
	      // rotating. Also "center" doesn't help in this case, it has to be a
	      // precise value.
	      svg
	        .css(dimensions)
	        .css('transform-origin', transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin);
	
	      element.css(dimensions);
	      path.css('stroke-width',  strokeWidth + 'px');
	    });
	
	    function renderCircle(animateFrom, animateTo, easing, duration, rotation) {
	      var id = ++lastAnimationId;
	      var startTime = $mdUtil.now();
	      var changeInValue = animateTo - animateFrom;
	      var diameter = getSize(scope.mdDiameter);
	      var pathDiameter = diameter - getStroke(diameter);
	      var ease = easing || $mdProgressCircular.easeFn;
	      var animationDuration = duration || $mdProgressCircular.duration;
	
	      // No need to animate it if the values are the same
	      if (animateTo === animateFrom) {
	        path.attr('d', getSvgArc(animateTo, diameter, pathDiameter, rotation));
	      } else {
	        lastDrawFrame = rAF(function animation() {
	          var currentTime = $window.Math.max(0, $window.Math.min($mdUtil.now() - startTime, animationDuration));
	
	          path.attr('d', getSvgArc(
	            ease(currentTime, animateFrom, changeInValue, animationDuration),
	            diameter,
	            pathDiameter,
	            rotation
	          ));
	
	          // Do not allow overlapping animations
	          if (id === lastAnimationId && currentTime < animationDuration) {
	            lastDrawFrame = rAF(animation);
	          }
	        });
	      }
	    }
	
	    function animateIndeterminate() {
	      renderCircle(
	        startIndeterminate,
	        endIndeterminate,
	        $mdProgressCircular.easeFnIndeterminate,
	        $mdProgressCircular.durationIndeterminate,
	        rotationIndeterminate
	      );
	
	      // The % 100 technically isn't necessary, but it keeps the rotation
	      // under 100, instead of becoming a crazy large number.
	      rotationIndeterminate = (rotationIndeterminate + endIndeterminate) % 100;
	
	      var temp = startIndeterminate;
	      startIndeterminate = -endIndeterminate;
	      endIndeterminate = -temp;
	    }
	
	    function startIndeterminateAnimation() {
	      if (!interval) {
	        // Note that this interval isn't supposed to trigger a digest.
	        interval = $interval(
	          animateIndeterminate,
	          $mdProgressCircular.durationIndeterminate + 50,
	          0,
	          false
	        );
	
	        animateIndeterminate();
	
	        element
	          .addClass(INDETERMINATE_CLASS)
	          .removeAttr('aria-valuenow');
	      }
	    }
	
	    function cleanupIndeterminateAnimation() {
	      if (interval) {
	        $interval.cancel(interval);
	        interval = null;
	        element.removeClass(INDETERMINATE_CLASS);
	      }
	    }
	  }
	
	  /**
	   * Generates an arc following the SVG arc syntax.
	   * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
	   *
	   * @param {number} current Current value between 0 and 100.
	   * @param {number} diameter Diameter of the container.
	   * @param {number} pathDiameter Diameter of the path element.
	   * @param {number=0} rotation The point at which the semicircle should start rendering.
	   * Used for doing the indeterminate animation.
	   *
	   * @returns {string} String representation of an SVG arc.
	   */
	  function getSvgArc(current, diameter, pathDiameter, rotation) {
	    // The angle can't be exactly 360, because the arc becomes hidden.
	    var maximumAngle = 359.99 / 100;
	    var startPoint = rotation || 0;
	    var radius = diameter / 2;
	    var pathRadius = pathDiameter / 2;
	
	    var startAngle = startPoint * maximumAngle;
	    var endAngle = current * maximumAngle;
	    var start = polarToCartesian(radius, pathRadius, startAngle);
	    var end = polarToCartesian(radius, pathRadius, endAngle + startAngle);
	    var arcSweep = endAngle < 0 ? 0 : 1;
	    var largeArcFlag;
	
	    if (endAngle < 0) {
	      largeArcFlag = endAngle >= -180 ? 0 : 1;
	    } else {
	      largeArcFlag = endAngle <= 180 ? 0 : 1;
	    }
	
	    return 'M' + start + 'A' + pathRadius + ',' + pathRadius +
	      ' 0 ' + largeArcFlag + ',' + arcSweep + ' ' + end;
	  }
	
	  /**
	   * Converts Polar coordinates to Cartesian.
	   *
	   * @param {number} radius Radius of the container.
	   * @param {number} pathRadius Radius of the path element
	   * @param {number} angleInDegress Angle at which to place the point.
	   *
	   * @returns {string} Cartesian coordinates in the format of `x,y`.
	   */
	  function polarToCartesian(radius, pathRadius, angleInDegrees) {
	    var angleInRadians = (angleInDegrees - 90) * DEGREE_IN_RADIANS;
	
	    return (radius + (pathRadius * $window.Math.cos(angleInRadians))) +
	      ',' + (radius + (pathRadius * $window.Math.sin(angleInRadians)));
	  }
	
	  /**
	   * Limits a value between 0 and 100.
	   */
	  function clamp(value) {
	    return $window.Math.max(0, $window.Math.min(value || 0, 100));
	  }
	
	  /**
	   * Determines the size of a progress circle, based on the provided
	   * value in the following formats: `X`, `Ypx`, `Z%`.
	   */
	  function getSize(value) {
	    var defaultValue = $mdProgressCircular.progressSize;
	
	    if (value) {
	      var parsed = parseFloat(value);
	
	      if (value.lastIndexOf('%') === value.length - 1) {
	        parsed = (parsed / 100) * defaultValue;
	      }
	
	      return parsed;
	    }
	
	    return defaultValue;
	  }
	
	  /**
	   * Determines the circle's stroke width, based on
	   * the provided diameter.
	   */
	  function getStroke(diameter) {
	    return $mdProgressCircular.strokeWidth / 100 * diameter;
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $mdProgressCircular
	 * @module material.components.progressCircular
	 *
	 * @description
	 * Allows the user to specify the default options for the `progressCircular` directive.
	 *
	 * @property {number} progressSize Diameter of the progress circle in pixels.
	 * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
	 * @property {number} duration Length of the circle animation in milliseconds.
	 * @property {function} easeFn Default easing animation function.
	 * @property {object} easingPresets Collection of pre-defined easing functions.
	 *
	 * @property {number} durationIndeterminate Duration of the indeterminate animation.
	 * @property {number} startIndeterminate Indeterminate animation start point.
	 * @property {number} endIndeterminate Indeterminate animation end point.
	 * @property {function} easeFnIndeterminate Easing function to be used when animating
	 * between the indeterminate values.
	 *
	 * @property {(function(object): object)} configure Used to modify the default options.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdProgressCircularProvider) {
	 *
	 *     // Example of changing the default progress options.
	 *     $mdProgressCircularProvider.configure({
	 *       progressSize: 100,
	 *       strokeWidth: 20,
	 *       duration: 800
	 *     });
	 * });
	 * </hljs>
	 *
	 */
	
	angular
	  .module('material.components.progressCircular')
	  .provider("$mdProgressCircular", MdProgressCircularProvider);
	
	function MdProgressCircularProvider() {
	  var progressConfig = {
	    progressSize: 50,
	    strokeWidth: 10,
	    duration: 100,
	    easeFn: linearEase,
	
	    durationIndeterminate: 500,
	    startIndeterminate: 3,
	    endIndeterminate: 80,
	    easeFnIndeterminate: materialEase,
	
	    easingPresets: {
	      linearEase: linearEase,
	      materialEase: materialEase
	    }
	  };
	
	  return {
	    configure: function(options) {
	      progressConfig = angular.extend(progressConfig, options || {});
	      return progressConfig;
	    },
	    $get: function() { return progressConfig; }
	  };
	
	  function linearEase(t, b, c, d) {
	    return c * t / d + b;
	  }
	
	  function materialEase(t, b, c, d) {
	    // via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
	    // with settings of [0, 0, 1, 1]
	    var ts = (t /= d) * t;
	    var tc = ts * t;
	    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTab
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * Use the `<md-tab>` a nested directive used within `<md-tabs>` to specify a tab with a **label** and optional *view content*.
	 *
	 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to specify more
	 * complex tab header markup. If neither the **label** nor the **md-tab-label** are specified, then the nested
	 * markup of the `<md-tab>` is used as the tab header markup.
	 *
	 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the `<md-tab-body>` tag.  This
	 * is to define a clear separation between the tab content and the tab label.
	 *
	 * This container is used by the TabsController to show/hide the active tab's content view. This synchronization is
	 * automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can
	 * be initiated via data binding changes, programmatic invocation, or user gestures.
	 *
	 * @param {string=} label Optional attribute to specify a simple string as the tab label
	 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab selection.
	 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been de-selected.
	 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
	 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active tab at a time.
	 *
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 * <md-tab label="" ng-disabled md-on-select="" md-on-deselect="" >
	 *   <h3>My Tab content</h3>
	 * </md-tab>
	 *
	 * <md-tab >
	 *   <md-tab-label>
	 *     <h3>My Tab content</h3>
	 *   </md-tab-label>
	 *   <md-tab-body>
	 *     <p>
	 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
	 *       totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
	 *       dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
	 *       sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
	 *     </p>
	 *   </md-tab-body>
	 * </md-tab>
	 * </hljs>
	 *
	 */
	angular
	    .module('material.components.tabs')
	    .directive('mdTab', MdTab);
	
	function MdTab () {
	  return {
	    require:  '^?mdTabs',
	    terminal: true,
	    compile:  function (element, attr) {
	      var label = firstChild(element, 'md-tab-label'),
	          body  = firstChild(element, 'md-tab-body');
	
	      if (label.length == 0) {
	        label = angular.element('<md-tab-label></md-tab-label>');
	        if (attr.label) label.text(attr.label);
	        else label.append(element.contents());
	
	        if (body.length == 0) {
	          var contents = element.contents().detach();
	          body         = angular.element('<md-tab-body></md-tab-body>');
	          body.append(contents);
	        }
	      }
	
	      element.append(label);
	      if (body.html()) element.append(body);
	
	      return postLink;
	    },
	    scope:    {
	      active:   '=?mdActive',
	      disabled: '=?ngDisabled',
	      select:   '&?mdOnSelect',
	      deselect: '&?mdOnDeselect'
	    }
	  };
	
	  function postLink (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	    var index = ctrl.getTabElementIndex(element),
	        body  = firstChild(element, 'md-tab-body').remove(),
	        label = firstChild(element, 'md-tab-label').remove(),
	        data  = ctrl.insertTab({
	          scope:    scope,
	          parent:   scope.$parent,
	          index:    index,
	          element:  element,
	          template: body.html(),
	          label:    label.html()
	        }, index);
	
	    scope.select   = scope.select || angular.noop;
	    scope.deselect = scope.deselect || angular.noop;
	
	    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
	    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
	    scope.$watch(
	        function () {
	          return ctrl.getTabElementIndex(element);
	        },
	        function (newIndex) {
	          data.index = newIndex;
	          ctrl.updateTabOrder();
	        }
	    );
	    scope.$on('$destroy', function () { ctrl.removeTab(data); });
	  }
	
	  function firstChild (element, tagName) {
	    var children = element[0].children;
	    for (var i = 0, len = children.length; i < len; i++) {
	      var child = children[i];
	      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
	    }
	    return angular.element();
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabItem', MdTabItem);
	
	function MdTabItem () {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	      ctrl.attachRipple(scope, element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabLabel', MdTabLabel);
	
	function MdTabLabel () {
	  return { terminal: true };
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdTabScroll.$inject = ["$parse"];angular.module('material.components.tabs')
	    .directive('mdTabScroll', MdTabScroll);
	
	function MdTabScroll ($parse) {
	  return {
	    restrict: 'A',
	    compile: function ($element, attr) {
	      var fn = $parse(attr.mdTabScroll, null, true);
	      return function ngEventHandler (scope, element) {
	        element.on('mousewheel', function (event) {
	          scope.$apply(function () { fn(scope, { $event: event }); });
	        });
	      };
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsController.$inject = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming"];angular
	    .module('material.components.tabs')
	    .controller('MdTabsController', MdTabsController);
	
	/**
	 * @ngInject
	 */
	function MdTabsController ($scope, $element, $window, $mdConstant, $mdTabInkRipple,
	                           $mdUtil, $animateCss, $attrs, $compile, $mdTheming) {
	  // define private properties
	  var ctrl      = this,
	      locked    = false,
	      elements  = getElements(),
	      queue     = [],
	      destroyed = false,
	      loaded    = false;
	
	  // define one-way bindings
	  defineOneWayBinding('stretchTabs', handleStretchTabs);
	
	  // define public properties with change handlers
	  defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
	  defineProperty('offsetLeft', handleOffsetChange, 0);
	  defineProperty('hasContent', handleHasContent, false);
	  defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
	  defineProperty('shouldPaginate', handleShouldPaginate, false);
	
	  // define boolean attributes
	  defineBooleanAttribute('noInkBar', handleInkBar);
	  defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
	  defineBooleanAttribute('noPagination');
	  defineBooleanAttribute('swipeContent');
	  defineBooleanAttribute('noDisconnect');
	  defineBooleanAttribute('autoselect');
	  defineBooleanAttribute('noSelectClick');
	  defineBooleanAttribute('centerTabs', handleCenterTabs, false);
	  defineBooleanAttribute('enableDisconnect');
	
	  // define public properties
	  ctrl.scope             = $scope;
	  ctrl.parent            = $scope.$parent;
	  ctrl.tabs              = [];
	  ctrl.lastSelectedIndex = null;
	  ctrl.hasFocus          = false;
	  ctrl.lastClick         = true;
	  ctrl.shouldCenterTabs  = shouldCenterTabs();
	
	  // define public methods
	  ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
	  ctrl.redirectFocus      = redirectFocus;
	  ctrl.attachRipple       = attachRipple;
	  ctrl.insertTab          = insertTab;
	  ctrl.removeTab          = removeTab;
	  ctrl.select             = select;
	  ctrl.scroll             = scroll;
	  ctrl.nextPage           = nextPage;
	  ctrl.previousPage       = previousPage;
	  ctrl.keydown            = keydown;
	  ctrl.canPageForward     = canPageForward;
	  ctrl.canPageBack        = canPageBack;
	  ctrl.refreshIndex       = refreshIndex;
	  ctrl.incrementIndex     = incrementIndex;
	  ctrl.getTabElementIndex = getTabElementIndex;
	  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
	  ctrl.updateTabOrder     = $mdUtil.debounce(updateTabOrder, 100);
	
	  init();
	
	  /**
	   * Perform initialization for the controller, setup events and watcher(s)
	   */
	  function init () {
	    ctrl.selectedIndex = ctrl.selectedIndex || 0;
	    compileTemplate();
	    configureWatchers();
	    bindEvents();
	    $mdTheming($element);
	    $mdUtil.nextTick(function () {
	      // Note that the element references need to be updated, because certain "browsers"
	      // (IE/Edge) lose them and start throwing "Invalid calling object" errors, when we
	      // compile the element contents down in `compileElement`.
	      elements = getElements();
	      updateHeightFromContent();
	      adjustOffset();
	      updateInkBarStyles();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	      loaded = true;
	      updatePagination();
	    });
	  }
	
	  /**
	   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
	   * directive's template function.
	   */
	  function compileTemplate () {
	    var template = $attrs.$mdTabsTemplate,
	        element  = angular.element($element[0].querySelector('md-tab-data'));
	
	    element.html(template);
	    $compile(element.contents())(ctrl.parent);
	    delete $attrs.$mdTabsTemplate;
	  }
	
	  /**
	   * Binds events used by the tabs component.
	   */
	  function bindEvents () {
	    angular.element($window).on('resize', handleWindowResize);
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Configure watcher(s) used by Tabs
	   */
	  function configureWatchers () {
	    $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
	  }
	
	  /**
	   * Creates a one-way binding manually rather than relying on Angular's isolated scope
	   * @param key
	   * @param handler
	   */
	  function defineOneWayBinding (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    $attrs.$observe(attr, function (newValue) { ctrl[ key ] = newValue; });
	  }
	
	  /**
	   * Defines boolean attributes with default value set to true.  (ie. md-stretch-tabs with no value
	   * will be treated as being truthy)
	   * @param key
	   * @param handler
	   */
	  function defineBooleanAttribute (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
	    $attrs.$observe(attr, updateValue);
	    function updateValue (newValue) {
	      ctrl[ key ] = newValue !== 'false';
	    }
	  }
	
	  /**
	   * Remove any events defined by this controller
	   */
	  function cleanup () {
	    destroyed = true;
	    angular.element($window).off('resize', handleWindowResize);
	  }
	
	  // Change handlers
	
	  /**
	   * Toggles stretch tabs class and updates inkbar when tab stretching changes
	   * @param stretchTabs
	   */
	  function handleStretchTabs (stretchTabs) {
	    var elements = getElements();
	    angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
	    updateInkBarStyles();
	  }
	
	  function handleCenterTabs (newValue) {
	    ctrl.shouldCenterTabs = shouldCenterTabs();
	  }
	
	  function handleMaxTabWidth (newWidth, oldWidth) {
	    if (newWidth !== oldWidth) {
	      var elements = getElements();
	
	      angular.forEach(elements.tabs, function(tab) {
	        tab.style.maxWidth = newWidth + 'px';
	      });
	      $mdUtil.nextTick(ctrl.updateInkBarStyles);
	    }
	  }
	
	  function handleShouldPaginate (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      ctrl.maxTabWidth      = getMaxTabWidth();
	      ctrl.shouldCenterTabs = shouldCenterTabs();
	      $mdUtil.nextTick(function () {
	        ctrl.maxTabWidth = getMaxTabWidth();
	        adjustOffset(ctrl.selectedIndex);
	      });
	    }
	  }
	
	  /**
	   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
	   * @param hasContent
	   */
	  function handleHasContent (hasContent) {
	    $element[ hasContent ? 'removeClass' : 'addClass' ]('md-no-tab-content');
	  }
	
	  /**
	   * Apply ctrl.offsetLeft to the paging element when it changes
	   * @param left
	   */
	  function handleOffsetChange (left) {
	    var elements = getElements();
	    var newValue = ctrl.shouldCenterTabs ? '' : '-' + left + 'px';
	
	    angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM, 'translate3d(' + newValue + ', 0, 0)');
	    $scope.$broadcast('$mdTabsPaginationChanged');
	  }
	
	  /**
	   * Update the UI whenever `ctrl.focusIndex` is updated
	   * @param newIndex
	   * @param oldIndex
	   */
	  function handleFocusIndexChange (newIndex, oldIndex) {
	    if (newIndex === oldIndex) return;
	    if (!getElements().tabs[ newIndex ]) return;
	    adjustOffset();
	    redirectFocus();
	  }
	
	  /**
	   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
	   * @param newValue
	   * @param oldValue
	   */
	  function handleSelectedIndexChange (newValue, oldValue) {
	    if (newValue === oldValue) return;
	
	    ctrl.selectedIndex     = getNearestSafeIndex(newValue);
	    ctrl.lastSelectedIndex = oldValue;
	    ctrl.updateInkBarStyles();
	    updateHeightFromContent();
	    adjustOffset(newValue);
	    $scope.$broadcast('$mdTabsChanged');
	    ctrl.tabs[ oldValue ] && ctrl.tabs[ oldValue ].scope.deselect();
	    ctrl.tabs[ newValue ] && ctrl.tabs[ newValue ].scope.select();
	  }
	
	  function getTabElementIndex(tabEl){
	    var tabs = $element[0].getElementsByTagName('md-tab');
	    return Array.prototype.indexOf.call(tabs, tabEl[0]);
	  }
	
	  /**
	   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
	   * hidden.
	   */
	  function handleResizeWhenVisible () {
	    // if there is already a watcher waiting for resize, do nothing
	    if (handleResizeWhenVisible.watcher) return;
	    // otherwise, we will abuse the $watch function to check for visible
	    handleResizeWhenVisible.watcher = $scope.$watch(function () {
	      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
	      $mdUtil.nextTick(function () {
	        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
	        if (!handleResizeWhenVisible.watcher) return;
	
	        if ($element.prop('offsetParent')) {
	          handleResizeWhenVisible.watcher();
	          handleResizeWhenVisible.watcher = null;
	
	          handleWindowResize();
	        }
	      }, false);
	    });
	  }
	
	  // Event handlers / actions
	
	  /**
	   * Handle user keyboard interactions
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.LEFT_ARROW:
	        event.preventDefault();
	        incrementIndex(-1, true);
	        break;
	      case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        event.preventDefault();
	        incrementIndex(1, true);
	        break;
	      case $mdConstant.KEY_CODE.SPACE:
	      case $mdConstant.KEY_CODE.ENTER:
	        event.preventDefault();
	        if (!locked) select(ctrl.focusIndex);
	        break;
	    }
	    ctrl.lastClick = false;
	  }
	
	  /**
	   * Update the selected index. Triggers a click event on the original `md-tab` element in order
	   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
	   * @param index
	   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
	   */
	  function select (index, canSkipClick) {
	    if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
	    ctrl.lastClick = true;
	    // skip the click event if noSelectClick is enabled
	    if (canSkipClick && ctrl.noSelectClick) return;
	    // nextTick is required to prevent errors in user-defined click events
	    $mdUtil.nextTick(function () {
	      ctrl.tabs[ index ].element.triggerHandler('click');
	    }, false);
	  }
	
	  /**
	   * When pagination is on, this makes sure the selected index is in view.
	   * @param event
	   */
	  function scroll (event) {
	    if (!ctrl.shouldPaginate) return;
	    event.preventDefault();
	    ctrl.offsetLeft = fixOffset(ctrl.offsetLeft - event.wheelDelta);
	  }
	
	  /**
	   * Slides the tabs over approximately one page forward.
	   */
	  function nextPage () {
	    var elements = getElements();
	    var viewportWidth = elements.canvas.clientWidth,
	        totalWidth    = viewportWidth + ctrl.offsetLeft,
	        i, tab;
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[ i ];
	      if (tab.offsetLeft + tab.offsetWidth > totalWidth) break;
	    }
	    
	    if (viewportWidth > tab.offsetWidth) {
	      //Canvas width *greater* than tab width: usual positioning
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft);
	    } else {
	      /**
	       * Canvas width *smaller* than tab width: positioning at the *end* of current tab to let 
	       * pagination "for loop" to proceed correctly on next tab when nextPage() is called again
	       */
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft + (tab.offsetWidth - viewportWidth + 1));
	    }
	  }
	
	  /**
	   * Slides the tabs over approximately one page backward.
	   */
	  function previousPage () {
	    var i, tab, elements = getElements();
	
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[ i ];
	      if (tab.offsetLeft + tab.offsetWidth >= ctrl.offsetLeft) break;
	    }
	    
	    if (elements.canvas.clientWidth > tab.offsetWidth) {
	      //Canvas width *greater* than tab width: usual positioning
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft + tab.offsetWidth - elements.canvas.clientWidth);
	    } else {
	      /**
	       * Canvas width *smaller* than tab width: positioning at the *beginning* of current tab to let 
	       * pagination "for loop" to break correctly on previous tab when previousPage() is called again
	       */
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft);  
	    }
	  }
	
	  /**
	   * Update size calculations when the window is resized.
	   */
	  function handleWindowResize () {
	    ctrl.lastSelectedIndex = ctrl.selectedIndex;
	    ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);
	    $mdUtil.nextTick(function () {
	      ctrl.updateInkBarStyles();
	      updatePagination();
	    });
	  }
	
	  function handleInkBar (hide) {
	    angular.element(getElements().inkBar).toggleClass('ng-hide', hide);
	  }
	
	  /**
	   * Toggle dynamic height class when value changes
	   * @param value
	   */
	  function handleDynamicHeight (value) {
	    $element.toggleClass('md-dynamic-height', value);
	  }
	
	  /**
	   * Remove a tab from the data and select the nearest valid tab.
	   * @param tabData
	   */
	  function removeTab (tabData) {
	    if (destroyed) return;
	    var selectedIndex = ctrl.selectedIndex,
	        tab           = ctrl.tabs.splice(tabData.getIndex(), 1)[ 0 ];
	    refreshIndex();
	    // when removing a tab, if the selected index did not change, we have to manually trigger the
	    //   tab select/deselect events
	    if (ctrl.selectedIndex === selectedIndex) {
	      tab.scope.deselect();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	    }
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
	    });
	  }
	
	  /**
	   * Create an entry in the tabs array for a new tab at the specified index.
	   * @param tabData
	   * @param index
	   * @returns {*}
	   */
	  function insertTab (tabData, index) {
	    var hasLoaded = loaded;
	    var proto     = {
	          getIndex:     function () { return ctrl.tabs.indexOf(tab); },
	          isActive:     function () { return this.getIndex() === ctrl.selectedIndex; },
	          isLeft:       function () { return this.getIndex() < ctrl.selectedIndex; },
	          isRight:      function () { return this.getIndex() > ctrl.selectedIndex; },
	          shouldRender: function () { return !ctrl.noDisconnect || this.isActive(); },
	          hasFocus:     function () {
	            return !ctrl.lastClick
	                && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
	          },
	          id:           $mdUtil.nextUid()
	        },
	        tab       = angular.extend(proto, tabData);
	    if (angular.isDefined(index)) {
	      ctrl.tabs.splice(index, 0, tab);
	    } else {
	      ctrl.tabs.push(tab);
	    }
	    processQueue();
	    updateHasContent();
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      // if autoselect is enabled, select the newly added tab
	      if (hasLoaded && ctrl.autoselect) $mdUtil.nextTick(function () {
	        $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
	      });
	    });
	    return tab;
	  }
	
	  // Getter methods
	
	  /**
	   * Gathers references to all of the DOM elements used by this controller.
	   * @returns {{}}
	   */
	  function getElements () {
	    var elements = {};
	    var node = $element[0];
	
	    // gather tab bar elements
	    elements.wrapper = node.querySelector('md-tabs-wrapper');
	    elements.canvas  = elements.wrapper.querySelector('md-tabs-canvas');
	    elements.paging  = elements.canvas.querySelector('md-pagination-wrapper');
	    elements.inkBar  = elements.paging.querySelector('md-ink-bar');
	
	    elements.contents = node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');
	    elements.tabs    = elements.paging.querySelectorAll('md-tab-item');
	    elements.dummies = elements.canvas.querySelectorAll('md-dummy-tab');
	
	    return elements;
	  }
	
	  /**
	   * Determines whether or not the left pagination arrow should be enabled.
	   * @returns {boolean}
	   */
	  function canPageBack () {
	    return ctrl.offsetLeft > 0;
	  }
	
	  /**
	   * Determines whether or not the right pagination arrow should be enabled.
	   * @returns {*|boolean}
	   */
	  function canPageForward () {
	    var elements = getElements();
	    var lastTab = elements.tabs[ elements.tabs.length - 1 ];
	    return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
	        ctrl.offsetLeft;
	  }
	
	  /**
	   * Determines if the UI should stretch the tabs to fill the available space.
	   * @returns {*}
	   */
	  function shouldStretchTabs () {
	    switch (ctrl.stretchTabs) {
	      case 'always':
	        return true;
	      case 'never':
	        return false;
	      default:
	        return !ctrl.shouldPaginate
	            && $window.matchMedia('(max-width: 600px)').matches;
	    }
	  }
	
	  /**
	   * Determines if the tabs should appear centered.
	   * @returns {string|boolean}
	   */
	  function shouldCenterTabs () {
	    return ctrl.centerTabs && !ctrl.shouldPaginate;
	  }
	
	  /**
	   * Determines if pagination is necessary to display the tabs within the available space.
	   * @returns {boolean}
	   */
	  function shouldPaginate () {
	    if (ctrl.noPagination || !loaded) return false;
	    var canvasWidth = $element.prop('clientWidth');
	
	    angular.forEach(getElements().dummies, function (tab) {
	      canvasWidth -= tab.offsetWidth;
	    });
	
	    return canvasWidth < 0;
	  }
	
	  /**
	   * Finds the nearest tab index that is available.  This is primarily used for when the active
	   * tab is removed.
	   * @param newIndex
	   * @returns {*}
	   */
	  function getNearestSafeIndex (newIndex) {
	    if (newIndex === -1) return -1;
	    var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
	        i, tab;
	    for (i = 0; i <= maxOffset; i++) {
	      tab = ctrl.tabs[ newIndex + i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	      tab = ctrl.tabs[ newIndex - i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	    }
	    return newIndex;
	  }
	
	  // Utility methods
	
	  /**
	   * Defines a property using a getter and setter in order to trigger a change handler without
	   * using `$watch` to observe changes.
	   * @param key
	   * @param handler
	   * @param value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler && handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Updates whether or not pagination should be displayed.
	   */
	  function updatePagination () {
	    updatePagingWidth();
	    ctrl.maxTabWidth = getMaxTabWidth();
	    ctrl.shouldPaginate = shouldPaginate();
	  }
	
	  /**
	   * Sets or clears fixed width for md-pagination-wrapper depending on if tabs should stretch.
	   */
	  function updatePagingWidth() {
	    var elements = getElements();
	    if (shouldStretchTabs()) {
	      angular.element(elements.paging).css('width', '');
	    } else {
	      angular.element(elements.paging).css('width', calcPagingWidth() + 'px');
	    }
	  }
	
	  /**
	   * Calculates the width of the pagination wrapper by summing the widths of the dummy tabs.
	   * @returns {number}
	   */
	  function calcPagingWidth () {
	    return calcTabsWidth(getElements().dummies);
	  }
	
	  function calcTabsWidth(tabs) {
	    var width = 0;
	
	    angular.forEach(tabs, function (tab) {
	      //-- Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
	      //   prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
	      //   also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
	      //   of a dialog)
	      width += Math.max(tab.offsetWidth, tab.getBoundingClientRect().width);
	    });
	
	    return Math.ceil(width);
	  }
	
	  function getMaxTabWidth () {
	    return $element.prop('clientWidth');
	  }
	
	  /**
	   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
	   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
	   */
	  function updateTabOrder () {
	    var selectedItem   = ctrl.tabs[ ctrl.selectedIndex ],
	        focusItem      = ctrl.tabs[ ctrl.focusIndex ];
	    ctrl.tabs          = ctrl.tabs.sort(function (a, b) {
	      return a.index - b.index;
	    });
	    ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
	    ctrl.focusIndex    = ctrl.tabs.indexOf(focusItem);
	  }
	
	  /**
	   * This moves the selected or focus index left or right.  This is used by the keydown handler.
	   * @param inc
	   */
	  function incrementIndex (inc, focus) {
	    var newIndex,
	        key   = focus ? 'focusIndex' : 'selectedIndex',
	        index = ctrl[ key ];
	    for (newIndex = index + inc;
	         ctrl.tabs[ newIndex ] && ctrl.tabs[ newIndex ].scope.disabled;
	         newIndex += inc) {}
	    if (ctrl.tabs[ newIndex ]) {
	      ctrl[ key ] = newIndex;
	    }
	  }
	
	  /**
	   * This is used to forward focus to dummy elements.  This method is necessary to avoid animation
	   * issues when attempting to focus an item that is out of view.
	   */
	  function redirectFocus () {
	    getElements().dummies[ ctrl.focusIndex ].focus();
	  }
	
	  /**
	   * Forces the pagination to move the focused tab into view.
	   */
	  function adjustOffset (index) {
	    var elements = getElements();
	
	    if (index == null) index = ctrl.focusIndex;
	    if (!elements.tabs[ index ]) return;
	    if (ctrl.shouldCenterTabs) return;
	    var tab         = elements.tabs[ index ],
	        left        = tab.offsetLeft,
	        right       = tab.offsetWidth + left;
	    ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + 32 * 2));
	    ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
	  }
	
	  /**
	   * Iterates through all queued functions and clears the queue.  This is used for functions that
	   * are called before the UI is ready, such as size calculations.
	   */
	  function processQueue () {
	    queue.forEach(function (func) { $mdUtil.nextTick(func); });
	    queue = [];
	  }
	
	  /**
	   * Determines if the tab content area is needed.
	   */
	  function updateHasContent () {
	    var hasContent  = false;
	    angular.forEach(ctrl.tabs, function (tab) {
	      if (tab.template) hasContent = true;
	    });
	    ctrl.hasContent = hasContent;
	  }
	
	  /**
	   * Moves the indexes to their nearest valid values.
	   */
	  function refreshIndex () {
	    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
	    ctrl.focusIndex    = getNearestSafeIndex(ctrl.focusIndex);
	  }
	
	  /**
	   * Calculates the content height of the current tab.
	   * @returns {*}
	   */
	  function updateHeightFromContent () {
	    if (!ctrl.dynamicHeight) return $element.css('height', '');
	    if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);
	
	    var elements = getElements();
	
	    var tabContent    = elements.contents[ ctrl.selectedIndex ],
	        contentHeight = tabContent ? tabContent.offsetHeight : 0,
	        tabsHeight    = elements.wrapper.offsetHeight,
	        newHeight     = contentHeight + tabsHeight,
	        currentHeight = $element.prop('clientHeight');
	
	    if (currentHeight === newHeight) return;
	
	    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
	    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
	    if ($element.attr('md-align-tabs') === 'bottom') {
	      currentHeight -= tabsHeight;
	      newHeight -= tabsHeight;
	      // Need to include bottom border in these calculations
	      if ($element.attr('md-border-bottom') !== undefined) ++currentHeight;
	    }
	
	    // Lock during animation so the user can't change tabs
	    locked = true;
	
	    var fromHeight = { height: currentHeight + 'px' },
	        toHeight = { height: newHeight + 'px' };
	
	    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
	    // first animates to 0, then back to the proper height causing a visual glitch
	    $element.css(fromHeight);
	
	    // Animate the height from the old to the new
	    $animateCss($element, {
	      from: fromHeight,
	      to: toHeight,
	      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
	      duration: 0.5
	    }).start().done(function () {
	      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
	      // pixel height so the height can size with browser width/content changes, etc.
	      $element.css({
	        transition: 'none',
	        height: ''
	      });
	
	      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
	      // enough to batch it for us instead of doing it immediately, which undoes the original
	      // transition: none)
	      $mdUtil.nextTick(function() {
	        $element.css('transition', '');
	      });
	
	      // And unlock so tab changes can occur
	      locked = false;
	    });
	  }
	
	  /**
	   * Repositions the ink bar to the selected tab.
	   * @returns {*}
	   */
	  function updateInkBarStyles () {
	    var elements = getElements();
	
	    if (!elements.tabs[ ctrl.selectedIndex ]) {
	      angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
	      return;
	    }
	
	    if (!ctrl.tabs.length) return queue.push(ctrl.updateInkBarStyles);
	    // if the element is not visible, we will not be able to calculate sizes until it is
	    // we should treat that as a resize event rather than just updating the ink bar
	    if (!$element.prop('offsetParent')) return handleResizeWhenVisible();
	
	    var index      = ctrl.selectedIndex,
	        totalWidth = elements.paging.offsetWidth,
	        tab        = elements.tabs[ index ],
	        left       = tab.offsetLeft,
	        right      = totalWidth - left - tab.offsetWidth;
	
	    if (ctrl.shouldCenterTabs) {
	      // We need to use the same calculate process as in the pagination wrapper, to avoid rounding deviations.
	      var tabWidth = calcTabsWidth(elements.tabs);
	
	      if (totalWidth > tabWidth) {
	        $mdUtil.nextTick(updateInkBarStyles, false);
	      }
	    }
	    updateInkBarClassName();
	    angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
	  }
	
	  /**
	   * Adds left/right classes so that the ink bar will animate properly.
	   */
	  function updateInkBarClassName () {
	    var elements = getElements();
	    var newIndex = ctrl.selectedIndex,
	        oldIndex = ctrl.lastSelectedIndex,
	        ink      = angular.element(elements.inkBar);
	    if (!angular.isNumber(oldIndex)) return;
	    ink
	        .toggleClass('md-left', newIndex < oldIndex)
	        .toggleClass('md-right', newIndex > oldIndex);
	  }
	
	  /**
	   * Takes an offset value and makes sure that it is within the min/max allowed values.
	   * @param value
	   * @returns {*}
	   */
	  function fixOffset (value) {
	    var elements = getElements();
	
	    if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;
	    var lastTab    = elements.tabs[ elements.tabs.length - 1 ],
	        totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;
	    value          = Math.max(0, value);
	    value          = Math.min(totalWidth - elements.canvas.clientWidth, value);
	    return value;
	  }
	
	  /**
	   * Attaches a ripple to the tab item element.
	   * @param scope
	   * @param element
	   */
	  function attachRipple (scope, element) {
	    var elements = getElements();
	    var options = { colorElement: angular.element(elements.inkBar) };
	    $mdTabInkRipple.attach(scope, element, options);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTabs
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tabs>` directive serves as the container for 1..n `<md-tab>` child directives to
	 * produces a Tabs components. In turn, the nested `<md-tab>` directive is used to specify a tab
	 * label for the **header button** and a [optional] tab view content that will be associated with
	 * each tab button.
	 *
	 * Below is the markup for its simplest usage:
	 *
	 *  <hljs lang="html">
	 *  <md-tabs>
	 *    <md-tab label="Tab #1"></md-tab>
	 *    <md-tab label="Tab #2"></md-tab>
	 *    <md-tab label="Tab #3"></md-tab>
	 *  </md-tabs>
	 *  </hljs>
	 *
	 * Tabs supports three (3) usage scenarios:
	 *
	 *  1. Tabs (buttons only)
	 *  2. Tabs with internal view content
	 *  3. Tabs with external view content
	 *
	 * **Tab-only** support is useful when tab buttons are used for custom navigation regardless of any
	 * other components, content, or views.
	 *
	 * <i><b>Note:</b> If you are using the Tabs component for page-level navigation, please take a look
	 * at the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead as it can handle this
	 * case a bit more natively.</i>
	 *
	 * **Tabs with internal views** are the traditional usages where each tab has associated view
	 * content and the view switching is managed internally by the Tabs component.
	 *
	 * **Tabs with external view content** is often useful when content associated with each tab is
	 * independently managed and data-binding notifications announce tab selection changes.
	 *
	 * Additional features also include:
	 *
	 * *  Content can include any markup.
	 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
	 *
	 * ### Explanation of tab stretching
	 *
	 * Initially, tabs will have an inherent size.  This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS.  Calculations will be based on this size.
	 *
	 * On mobile devices, tabs will be expanded to fill the available horizontal space.  When this happens, all tabs will become the same size.
	 *
	 * On desktops, by default, stretching will never occur.
	 *
	 * This default behavior can be overridden through the `md-stretch-tabs` attribute.  Here is a table showing when stretching will occur:
	 *
	 * `md-stretch-tabs` | mobile    | desktop
	 * ------------------|-----------|--------
	 * `auto`            | stretched | ---
	 * `always`          | stretched | stretched
	 * `never`           | ---       | ---
	 *
	 * @param {integer=} md-selected Index of the active/selected tab
	 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
	 * @param {boolean=} md-no-ink-bar If present, disables the selection ink bar.
	 * @param {string=}  md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`; default is `top`
	 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`, `always`, or `never`; default is `auto`
	 * @param {boolean=} md-dynamic-height When enabled, the tab wrapper will resize based on the contents of the selected tab
	 * @param {boolean=} md-border-bottom If present, shows a solid `1px` border between the tabs and their content
	 * @param {boolean=} md-center-tabs When enabled, tabs will be centered provided there is no need for pagination
	 * @param {boolean=} md-no-pagination When enabled, pagination will remain off
	 * @param {boolean=} md-swipe-content When enabled, swipe gestures will be enabled for the content area to jump between tabs
	 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that are not being displayed.  This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.
	 * @param {boolean=} md-autoselect When present, any tabs added after the initial load will be automatically selected
	 * @param {boolean=} md-no-select-click When enabled, click events will not be fired when selecting tabs
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-tabs md-selected="selectedIndex" >
	 *   <img ng-src="img/angular.png" class="centered">
	 *   <md-tab
	 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
	 *       md-on-select="onTabSelected(tab)"
	 *       md-on-deselect="announceDeselected(tab)"
	 *       ng-disabled="tab.disabled">
	 *     <md-tab-label>
	 *       {{tab.title}}
	 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete">
	 *     </md-tab-label>
	 *     <md-tab-body>
	 *       {{tab.content}}
	 *     </md-tab-body>
	 *   </md-tab>
	 * </md-tabs>
	 * </hljs>
	 *
	 */
	MdTabs.$inject = ["$$mdSvgRegistry"];
	angular
	    .module('material.components.tabs')
	    .directive('mdTabs', MdTabs);
	
	function MdTabs ($$mdSvgRegistry) {
	  return {
	    scope:            {
	      selectedIndex: '=?mdSelected'
	    },
	    template:         function (element, attr) {
	      attr[ "$mdTabsTemplate" ] = element.html();
	      return '' +
	        '<md-tabs-wrapper> ' +
	          '<md-tab-data></md-tab-data> ' +
	          '<md-prev-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Previous Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.previousPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-prev-button> ' +
	          '<md-next-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Next Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.nextPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-next-button> ' +
	          '<md-tabs-canvas ' +
	              'tabindex="{{ $mdTabsCtrl.hasFocus ? -1 : 0 }}" ' +
	              'aria-activedescendant="tab-item-{{$mdTabsCtrl.tabs[$mdTabsCtrl.focusIndex].id}}" ' +
	              'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
	              'ng-class="{ ' +
	                  '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
	                  '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
	              '}" ' +
	              'ng-keydown="$mdTabsCtrl.keydown($event)" ' +
	              'role="tablist"> ' +
	            '<md-pagination-wrapper ' +
	                'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
	                'md-tab-scroll="$mdTabsCtrl.scroll($event)"> ' +
	              '<md-tab-item ' +
	                  'tabindex="-1" ' +
	                  'class="md-tab" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'role="tab" ' +
	                  'aria-controls="tab-content-{{::tab.id}}" ' +
	                  'aria-selected="{{tab.isActive()}}" ' +
	                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
	                  'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
	                  'ng-class="{ ' +
	                      '\'md-active\':    tab.isActive(), ' +
	                      '\'md-focused\':   tab.hasFocus(), ' +
	                      '\'md-disabled\':  tab.scope.disabled ' +
	                  '}" ' +
	                  'ng-disabled="tab.scope.disabled" ' +
	                  'md-swipe-left="$mdTabsCtrl.nextPage()" ' +
	                  'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-tab-item> ' +
	              '<md-ink-bar></md-ink-bar> ' +
	            '</md-pagination-wrapper> ' +
	            '<md-tabs-dummy-wrapper class="md-visually-hidden md-dummy-wrapper"> ' +
	              '<md-dummy-tab ' +
	                  'class="md-tab" ' +
	                  'tabindex="-1" ' +
	                  'id="tab-item-{{::tab.id}}" ' +
	                  'role="tab" ' +
	                  'aria-controls="tab-content-{{::tab.id}}" ' +
	                  'aria-selected="{{tab.isActive()}}" ' +
	                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
	                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
	                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-dummy-tab> ' +
	            '</md-tabs-dummy-wrapper> ' +
	          '</md-tabs-canvas> ' +
	        '</md-tabs-wrapper> ' +
	        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> ' +
	          '<md-tab-content ' +
	              'id="tab-content-{{::tab.id}}" ' +
	              'class="_md" ' +
	              'role="tabpanel" ' +
	              'aria-labelledby="tab-item-{{::tab.id}}" ' +
	              'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
	              'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
	              'ng-if="$mdTabsCtrl.hasContent" ' +
	              'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
	              'ng-class="{ ' +
	                '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
	                '\'md-active\':        tab.isActive(), ' +
	                '\'md-left\':          tab.isLeft(), ' +
	                '\'md-right\':         tab.isRight(), ' +
	                '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
	              '}"> ' +
	            '<div ' +
	                'md-tabs-template="::tab.template" ' +
	                'md-connected-if="tab.isActive()" ' +
	                'md-scope="::tab.parent" ' +
	                'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
	          '</md-tab-content> ' +
	        '</md-tabs-content-wrapper>';
	    },
	    controller:       'MdTabsController',
	    controllerAs:     '$mdTabsCtrl',
	    bindToController: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsDummyWrapper.$inject = ["$mdUtil", "$window"];angular
	  .module('material.components.tabs')
	  .directive('mdTabsDummyWrapper', MdTabsDummyWrapper);
	
	/**
	 * @private
	 *
	 * @param $mdUtil
	 * @param $window
	 * @returns {{require: string, link: link}}
	 * @constructor
	 *
	 * @ngInject
	 */
	function MdTabsDummyWrapper ($mdUtil, $window) {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	
	      var observer;
	      var disconnect;
	
	      var mutationCallback = function() {
	        ctrl.updatePagination();
	        ctrl.updateInkBarStyles();
	      };
	
	      if('MutationObserver' in $window) {
	        var config = {
	          childList: true,
	          subtree: true,
	          // Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
	          // the childList mutation, once a <span> element's innerText changes.
	          // The characterData of the <span> element will change.
	          characterData: true
	        };
	
	        observer = new MutationObserver(mutationCallback);
	        observer.observe(element[0], config);
	        disconnect = observer.disconnect.bind(observer);
	      } else {
	        var debounced = $mdUtil.debounce(mutationCallback, 15, null, false);
	        
	        element.on('DOMSubtreeModified', debounced);
	        disconnect = element.off.bind(element, 'DOMSubtreeModified', debounced);
	      }
	
	      // Disconnect the observer
	      scope.$on('$destroy', function() {
	        disconnect();
	      });
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsTemplate.$inject = ["$compile", "$mdUtil"];angular
	    .module('material.components.tabs')
	    .directive('mdTabsTemplate', MdTabsTemplate);
	
	function MdTabsTemplate ($compile, $mdUtil) {
	  return {
	    restrict: 'A',
	    link:     link,
	    scope:    {
	      template:     '=mdTabsTemplate',
	      connected:    '=?mdConnectedIf',
	      compileScope: '=mdScope'
	    },
	    require:  '^?mdTabs'
	  };
	  function link (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	
	    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;
	
	    element.html(scope.template);
	    $compile(element.contents())(compileScope);
	
	    return $mdUtil.nextTick(handleScope);
	
	    function handleScope () {
	      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
	      scope.$on('$destroy', reconnect);
	    }
	
	    function disconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
	    }
	
	    function reconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
	    }
	  }
	}
	
	})();
	(function(){ 
	angular.module("material.core").constant("$MD_THEME_CSS", "md-autocomplete.md-THEME_NAME-theme {  background: '{{background-A100}}'; }  md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]) {    background: '{{background-100}}'; }  md-autocomplete.md-THEME_NAME-theme button md-icon path {    fill: '{{background-600}}'; }  md-autocomplete.md-THEME_NAME-theme button:after {    background: '{{background-600-0.3}}'; }.md-autocomplete-suggestions-container.md-THEME_NAME-theme {  background: '{{background-A100}}'; }  .md-autocomplete-suggestions-container.md-THEME_NAME-theme li {    color: '{{background-900}}'; }    .md-autocomplete-suggestions-container.md-THEME_NAME-theme li .highlight {      color: '{{background-600}}'; }    .md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover, .md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected {      background: '{{background-200}}'; }md-backdrop {  background-color: '{{background-900-0.0}}'; }  md-backdrop.md-opaque.md-THEME_NAME-theme {    background-color: '{{background-900-1.0}}'; }md-bottom-sheet.md-THEME_NAME-theme {  background-color: '{{background-50}}';  border-top-color: '{{background-300}}'; }  md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item {    color: '{{foreground-1}}'; }  md-bottom-sheet.md-THEME_NAME-theme .md-subheader {    background-color: '{{background-50}}'; }  md-bottom-sheet.md-THEME_NAME-theme .md-subheader {    color: '{{foreground-1}}'; }.md-button.md-THEME_NAME-theme:not([disabled]):hover {  background-color: '{{background-500-0.2}}'; }.md-button.md-THEME_NAME-theme:not([disabled]).md-focused {  background-color: '{{background-500-0.2}}'; }.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover {  background-color: transparent; }.md-button.md-THEME_NAME-theme.md-fab {  background-color: '{{accent-color}}';  color: '{{accent-contrast}}'; }  .md-button.md-THEME_NAME-theme.md-fab md-icon {    color: '{{accent-contrast}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover {    background-color: '{{accent-A700}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused {    background-color: '{{accent-A700}}'; }.md-button.md-THEME_NAME-theme.md-primary {  color: '{{primary-color}}'; }  .md-button.md-THEME_NAME-theme.md-primary.md-raised, .md-button.md-THEME_NAME-theme.md-primary.md-fab {    color: '{{primary-contrast}}';    background-color: '{{primary-color}}'; }    .md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon, .md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon {      color: '{{primary-contrast}}'; }    .md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover, .md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover {      background-color: '{{primary-600}}'; }    .md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused, .md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused {      background-color: '{{primary-600}}'; }  .md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon {    color: '{{primary-color}}'; }.md-button.md-THEME_NAME-theme.md-fab {  background-color: '{{accent-color}}';  color: '{{accent-contrast}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon {    color: '{{accent-contrast}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover {    background-color: '{{accent-A700}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused {    background-color: '{{accent-A700}}'; }.md-button.md-THEME_NAME-theme.md-raised {  color: '{{background-900}}';  background-color: '{{background-50}}'; }  .md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon {    color: '{{background-900}}'; }  .md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover {    background-color: '{{background-50}}'; }  .md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused {    background-color: '{{background-200}}'; }.md-button.md-THEME_NAME-theme.md-warn {  color: '{{warn-color}}'; }  .md-button.md-THEME_NAME-theme.md-warn.md-raised, .md-button.md-THEME_NAME-theme.md-warn.md-fab {    color: '{{warn-contrast}}';    background-color: '{{warn-color}}'; }    .md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon, .md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon {      color: '{{warn-contrast}}'; }    .md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover, .md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover {      background-color: '{{warn-600}}'; }    .md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused, .md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused {      background-color: '{{warn-600}}'; }  .md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon {    color: '{{warn-color}}'; }.md-button.md-THEME_NAME-theme.md-accent {  color: '{{accent-color}}'; }  .md-button.md-THEME_NAME-theme.md-accent.md-raised, .md-button.md-THEME_NAME-theme.md-accent.md-fab {    color: '{{accent-contrast}}';    background-color: '{{accent-color}}'; }    .md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon, .md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon {      color: '{{accent-contrast}}'; }    .md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover, .md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover {      background-color: '{{accent-A700}}'; }    .md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused, .md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused {      background-color: '{{accent-A700}}'; }  .md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon {    color: '{{accent-color}}'; }.md-button.md-THEME_NAME-theme[disabled], .md-button.md-THEME_NAME-theme.md-raised[disabled], .md-button.md-THEME_NAME-theme.md-fab[disabled], .md-button.md-THEME_NAME-theme.md-accent[disabled], .md-button.md-THEME_NAME-theme.md-warn[disabled] {  color: '{{foreground-3}}';  cursor: default; }  .md-button.md-THEME_NAME-theme[disabled] md-icon, .md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon, .md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon, .md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon, .md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon {    color: '{{foreground-3}}'; }.md-button.md-THEME_NAME-theme.md-raised[disabled], .md-button.md-THEME_NAME-theme.md-fab[disabled] {  background-color: '{{foreground-4}}'; }.md-button.md-THEME_NAME-theme[disabled] {  background-color: transparent; }._md a.md-THEME_NAME-theme:not(.md-button).md-primary {  color: '{{primary-color}}'; }  ._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover {    color: '{{primary-700}}'; }._md a.md-THEME_NAME-theme:not(.md-button).md-accent {  color: '{{accent-color}}'; }  ._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover {    color: '{{accent-700}}'; }._md a.md-THEME_NAME-theme:not(.md-button).md-accent {  color: '{{accent-color}}'; }  ._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover {    color: '{{accent-A700}}'; }._md a.md-THEME_NAME-theme:not(.md-button).md-warn {  color: '{{warn-color}}'; }  ._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover {    color: '{{warn-700}}'; }md-card.md-THEME_NAME-theme {  color: '{{foreground-1}}';  background-color: '{{background-hue-1}}';  border-radius: 2px; }  md-card.md-THEME_NAME-theme .md-card-image {    border-radius: 2px 2px 0 0; }  md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon {    color: '{{background-color}}';    background-color: '{{foreground-3}}'; }  md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead {    color: '{{foreground-2}}'; }  md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead {    color: '{{foreground-2}}'; }md-chips.md-THEME_NAME-theme .md-chips {  box-shadow: 0 1px '{{foreground-4}}'; }  md-chips.md-THEME_NAME-theme .md-chips.md-focused {    box-shadow: 0 2px '{{primary-color}}'; }  md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input {    color: '{{foreground-1}}'; }    md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder {      color: '{{foreground-3}}'; }    md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder {      color: '{{foreground-3}}'; }    md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder {      color: '{{foreground-3}}'; }    md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder {      color: '{{foreground-3}}'; }    md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder {      color: '{{foreground-3}}'; }md-chips.md-THEME_NAME-theme md-chip {  background: '{{background-300}}';  color: '{{background-800}}'; }  md-chips.md-THEME_NAME-theme md-chip md-icon {    color: '{{background-700}}'; }  md-chips.md-THEME_NAME-theme md-chip.md-focused {    background: '{{primary-color}}';    color: '{{primary-contrast}}'; }    md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon {      color: '{{primary-contrast}}'; }  md-chips.md-THEME_NAME-theme md-chip._md-chip-editing {    background: transparent;    color: '{{background-800}}'; }md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path {  fill: '{{background-500}}'; }.md-contact-suggestion span.md-contact-email {  color: '{{background-400}}'; }md-checkbox.md-THEME_NAME-theme .md-ripple {  color: '{{accent-A700}}'; }md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple {  color: '{{background-600}}'; }md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before {  background-color: '{{accent-color-0.26}}'; }md-checkbox.md-THEME_NAME-theme .md-ink-ripple {  color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple {  color: '{{accent-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon {  border-color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme.md-checked .md-icon {  background-color: '{{accent-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after {  border-color: '{{accent-contrast-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple {  color: '{{primary-600}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple {  color: '{{background-600}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple {  color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple {  color: '{{primary-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon {  border-color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon {  background-color: '{{primary-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before {  background-color: '{{primary-color-0.26}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after {  border-color: '{{primary-contrast-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container {  color: '{{foreground-3}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple {  color: '{{warn-600}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple {  color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple {  color: '{{warn-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon {  border-color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon {  background-color: '{{warn-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before {  background-color: '{{warn-color-0.26}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon:after {  border-color: '{{background-200}}'; }md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon {  border-color: '{{foreground-3}}'; }md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon {  background-color: '{{foreground-3}}'; }md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon:after {  border-color: '{{background-200}}'; }md-checkbox.md-THEME_NAME-theme[disabled] .md-icon:after {  border-color: '{{foreground-3}}'; }md-checkbox.md-THEME_NAME-theme[disabled] .md-label {  color: '{{foreground-3}}'; }md-content.md-THEME_NAME-theme {  color: '{{foreground-1}}';  background-color: '{{background-default}}'; }/** Theme styles for mdCalendar. */.md-calendar.md-THEME_NAME-theme {  background: '{{background-A100}}';  color: '{{background-A200-0.87}}'; }  .md-calendar.md-THEME_NAME-theme tr:last-child td {    border-bottom-color: '{{background-200}}'; }.md-THEME_NAME-theme .md-calendar-day-header {  background: '{{background-300}}';  color: '{{background-A200-0.87}}'; }.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator {  border: 1px solid '{{primary-500}}'; }.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled {  color: '{{primary-500-0.6}}'; }.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator, .md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover {  background: '{{background-300}}'; }.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator {  background: '{{primary-500}}';  color: '{{primary-500-contrast}}';  border-color: transparent; }.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled {  color: '{{background-A200-0.435}}'; }/** Theme styles for mdDatepicker. */.md-THEME_NAME-theme .md-datepicker-input {  color: '{{foreground-1}}'; }  .md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder {    color: '{{foreground-3}}'; }  .md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder {    color: '{{foreground-3}}'; }  .md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder {    color: '{{foreground-3}}'; }  .md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder {    color: '{{foreground-3}}'; }  .md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder {    color: '{{foreground-3}}'; }.md-THEME_NAME-theme .md-datepicker-input-container {  border-bottom-color: '{{foreground-4}}'; }  .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused {    border-bottom-color: '{{primary-color}}'; }    .md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused {      border-bottom-color: '{{accent-color}}'; }    .md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused {      border-bottom-color: '{{warn-A700}}'; }  .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid {    border-bottom-color: '{{warn-A700}}'; }.md-THEME_NAME-theme .md-datepicker-calendar-pane {  border-color: '{{background-hue-1}}'; }.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle {  border-top-color: '{{foreground-3}}'; }.md-THEME_NAME-theme .md-datepicker-triangle-button:hover .md-datepicker-expand-triangle {  border-top-color: '{{foreground-2}}'; }.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon {  color: '{{primary-color}}'; }.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon, .md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon {  color: '{{accent-color}}'; }.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon, .md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon {  color: '{{warn-A700}}'; }.md-THEME_NAME-theme .md-datepicker-calendar {  background: '{{background-A100}}'; }.md-THEME_NAME-theme .md-datepicker-input-mask-opaque {  box-shadow: 0 0 0 9999px \"{{background-hue-1}}\"; }.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container {  background: \"{{background-hue-1}}\"; }md-dialog.md-THEME_NAME-theme {  border-radius: 4px;  background-color: '{{background-hue-1}}';  color: '{{foreground-1}}'; }  md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions, md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions {    border-top-color: '{{foreground-4}}'; }md-divider.md-THEME_NAME-theme {  border-top-color: '{{foreground-4}}'; }.layout-row > md-divider.md-THEME_NAME-theme,.layout-xs-row > md-divider.md-THEME_NAME-theme, .layout-gt-xs-row > md-divider.md-THEME_NAME-theme,.layout-sm-row > md-divider.md-THEME_NAME-theme, .layout-gt-sm-row > md-divider.md-THEME_NAME-theme,.layout-md-row > md-divider.md-THEME_NAME-theme, .layout-gt-md-row > md-divider.md-THEME_NAME-theme,.layout-lg-row > md-divider.md-THEME_NAME-theme, .layout-gt-lg-row > md-divider.md-THEME_NAME-theme,.layout-xl-row > md-divider.md-THEME_NAME-theme {  border-right-color: '{{foreground-4}}'; }md-icon.md-THEME_NAME-theme {  color: '{{foreground-2}}'; }  md-icon.md-THEME_NAME-theme.md-primary {    color: '{{primary-color}}'; }  md-icon.md-THEME_NAME-theme.md-accent {    color: '{{accent-color}}'; }  md-icon.md-THEME_NAME-theme.md-warn {    color: '{{warn-color}}'; }md-input-container.md-THEME_NAME-theme .md-input {  color: '{{foreground-1}}';  border-color: '{{foreground-4}}'; }  md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder {    color: '{{foreground-3}}'; }  md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder {    color: '{{foreground-3}}'; }  md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder {    color: '{{foreground-3}}'; }  md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder {    color: '{{foreground-3}}'; }  md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder {    color: '{{foreground-3}}'; }md-input-container.md-THEME_NAME-theme > md-icon {  color: '{{foreground-1}}'; }md-input-container.md-THEME_NAME-theme label,md-input-container.md-THEME_NAME-theme .md-placeholder {  color: '{{foreground-3}}'; }md-input-container.md-THEME_NAME-theme label.md-required:after {  color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after {  color: '{{foreground-2}}'; }md-input-container.md-THEME_NAME-theme .md-input-messages-animation, md-input-container.md-THEME_NAME-theme .md-input-message-animation {  color: '{{warn-A700}}'; }  md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter, md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter {    color: '{{foreground-1}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label {  color: '{{foreground-2}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input, md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input {  border-color: '{{primary-color}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon {  color: '{{primary-color}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input {  border-color: '{{accent-color}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon {  color: '{{accent-color}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input {  border-color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon {  color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input {  border-color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme.md-input-invalid label,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter {  color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme .md-input[disabled],[disabled] md-input-container.md-THEME_NAME-theme .md-input {  border-bottom-color: transparent;  color: '{{foreground-3}}';  background-image: linear-gradient(to right, \"{{foreground-3}}\" 0%, \"{{foreground-3}}\" 33%, transparent 0%);  background-image: -ms-linear-gradient(left, transparent 0%, \"{{foreground-3}}\" 100%); }md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3, md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4 {  color: '{{foreground-1}}'; }md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p {  color: '{{foreground-2}}'; }md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style {  background-color: '{{background-100}}'; }md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon {  background-color: '{{foreground-3}}';  color: '{{background-color}}'; }md-list.md-THEME_NAME-theme md-list-item > md-icon {  color: '{{foreground-2}}'; }  md-list.md-THEME_NAME-theme md-list-item > md-icon.md-highlight {    color: '{{primary-color}}'; }    md-list.md-THEME_NAME-theme md-list-item > md-icon.md-highlight.md-accent {      color: '{{accent-color}}'; }md-menu-content.md-THEME_NAME-theme {  background-color: '{{background-A100}}'; }  md-menu-content.md-THEME_NAME-theme md-menu-item {    color: '{{background-A200-0.87}}'; }    md-menu-content.md-THEME_NAME-theme md-menu-item md-icon {      color: '{{background-A200-0.54}}'; }    md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] {      color: '{{background-A200-0.25}}'; }      md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon {        color: '{{background-A200-0.25}}'; }  md-menu-content.md-THEME_NAME-theme md-menu-divider {    background-color: '{{background-A200-0.11}}'; }md-menu-bar.md-THEME_NAME-theme > button.md-button {  color: '{{foreground-2}}';  border-radius: 2px; }md-menu-bar.md-THEME_NAME-theme md-menu.md-open > button, md-menu-bar.md-THEME_NAME-theme md-menu > button:focus {  outline: none;  background: '{{background-200}}'; }md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover > button {  background-color: '{{ background-500-0.2}}'; }md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus {  background: transparent; }md-menu-content.md-THEME_NAME-theme .md-menu > .md-button:after {  color: '{{background-A200-0.54}}'; }md-menu-content.md-THEME_NAME-theme .md-menu.md-open > .md-button {  background-color: '{{ background-500-0.2}}'; }md-toolbar.md-THEME_NAME-theme.md-menu-toolbar {  background-color: '{{background-A100}}';  color: '{{background-A200}}'; }  md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler {    background-color: '{{primary-color}}';    color: '{{background-A100-0.87}}'; }    md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon {      color: '{{background-A100-0.87}}'; }md-nav-bar.md-THEME_NAME-theme .md-nav-bar {  background-color: transparent;  border-color: '{{foreground-4}}'; }md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected {  color: '{{foreground-2}}'; }md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar {  color: '{{accent-color}}';  background: '{{accent-color}}'; }.md-panel {  background-color: '{{background-900-0.0}}'; }  .md-panel._md-panel-backdrop.md-THEME_NAME-theme {    background-color: '{{background-900-1.0}}'; }md-progress-circular.md-THEME_NAME-theme path {  stroke: '{{primary-color}}'; }md-progress-circular.md-THEME_NAME-theme.md-warn path {  stroke: '{{warn-color}}'; }md-progress-circular.md-THEME_NAME-theme.md-accent path {  stroke: '{{accent-color}}'; }md-progress-linear.md-THEME_NAME-theme .md-container {  background-color: '{{primary-100}}'; }md-progress-linear.md-THEME_NAME-theme .md-bar {  background-color: '{{primary-color}}'; }md-progress-linear.md-THEME_NAME-theme.md-warn .md-container {  background-color: '{{warn-100}}'; }md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar {  background-color: '{{warn-color}}'; }md-progress-linear.md-THEME_NAME-theme.md-accent .md-container {  background-color: '{{accent-100}}'; }md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar {  background-color: '{{accent-color}}'; }md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1 {  background-color: '{{warn-100}}'; }md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before {  background: radial-gradient(\"{{warn-100}}\" 0%, \"{{warn-100}}\" 16%, transparent 42%); }md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1 {  background-color: '{{accent-100}}'; }md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before {  background: radial-gradient(\"{{accent-100}}\" 0%, \"{{accent-100}}\" 16%, transparent 42%); }md-radio-button.md-THEME_NAME-theme .md-off {  border-color: '{{foreground-2}}'; }md-radio-button.md-THEME_NAME-theme .md-on {  background-color: '{{accent-color-0.87}}'; }md-radio-button.md-THEME_NAME-theme.md-checked .md-off {  border-color: '{{accent-color-0.87}}'; }md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple {  color: '{{accent-color-0.87}}'; }md-radio-button.md-THEME_NAME-theme .md-container .md-ripple {  color: '{{accent-A700}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on {  background-color: '{{primary-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off {  border-color: '{{primary-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple {  color: '{{primary-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple {  color: '{{primary-600}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on {  background-color: '{{warn-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off {  border-color: '{{warn-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple {  color: '{{warn-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple {  color: '{{warn-600}}'; }md-radio-group.md-THEME_NAME-theme[disabled],md-radio-button.md-THEME_NAME-theme[disabled] {  color: '{{foreground-3}}'; }  md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,  md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off {    border-color: '{{foreground-3}}'; }  md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on,  md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on {    border-color: '{{foreground-3}}'; }md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple {  color: '{{accent-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple, md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple {  color: '{{primary-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme .md-checked.md-primary .md-ink-ripple {  color: '{{warn-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before {  background-color: '{{accent-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before {  background-color: '{{primary-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before {  background-color: '{{warn-color-0.26}}'; }md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after {  color: '{{warn-A700}}'; }md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after {  color: '{{foreground-3}}'; }md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value {  color: '{{primary-color}}'; }  md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder {    color: '{{primary-color}}'; }md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value {  color: '{{warn-A700}}' !important;  border-bottom-color: '{{warn-A700}}' !important; }md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value {  border-bottom-color: transparent !important; }md-select.md-THEME_NAME-theme[disabled] .md-select-value {  border-bottom-color: transparent;  background-image: linear-gradient(to right, \"{{foreground-3}}\" 0%, \"{{foreground-3}}\" 33%, transparent 0%);  background-image: -ms-linear-gradient(left, transparent 0%, \"{{foreground-3}}\" 100%); }md-select.md-THEME_NAME-theme .md-select-value {  border-bottom-color: '{{foreground-4}}'; }  md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder {    color: '{{foreground-3}}'; }  md-select.md-THEME_NAME-theme .md-select-value span:first-child:after {    color: '{{warn-A700}}'; }md-select.md-THEME_NAME-theme.md-no-underline .md-select-value {  border-bottom-color: transparent !important; }md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value {  color: '{{warn-A700}}' !important;  border-bottom-color: '{{warn-A700}}' !important; }md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value {  border-bottom-color: transparent !important; }md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value {  border-bottom-color: '{{primary-color}}';  color: '{{ foreground-1 }}'; }  md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder {    color: '{{ foreground-1 }}'; }md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value {  border-bottom-color: transparent !important; }md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value {  border-bottom-color: '{{accent-color}}'; }md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value {  border-bottom-color: '{{warn-color}}'; }md-select.md-THEME_NAME-theme[disabled] .md-select-value {  color: '{{foreground-3}}'; }  md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder {    color: '{{foreground-3}}'; }md-select-menu.md-THEME_NAME-theme md-content {  background: '{{background-A100}}'; }  md-select-menu.md-THEME_NAME-theme md-content md-optgroup {    color: '{{background-600-0.87}}'; }  md-select-menu.md-THEME_NAME-theme md-content md-option {    color: '{{background-900-0.87}}'; }    md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text {      color: '{{background-400-0.87}}'; }    md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus, md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover {      background: '{{background-200}}'; }    md-select-menu.md-THEME_NAME-theme md-content md-option[selected] {      color: '{{primary-500}}'; }      md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus {        color: '{{primary-600}}'; }      md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent {        color: '{{accent-color}}'; }        md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus {          color: '{{accent-A700}}'; }.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple {  color: '{{primary-600}}'; }.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple {  color: '{{background-600}}'; }.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple {  color: '{{foreground-2}}'; }.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple {  color: '{{primary-color-0.87}}'; }.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon {  border-color: '{{foreground-2}}'; }.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon {  background-color: '{{primary-color-0.87}}'; }.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before {  background-color: '{{primary-color-0.26}}'; }.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after {  border-color: '{{primary-contrast-0.87}}'; }.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container {  color: '{{foreground-3}}'; }.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text {  color: '{{background-900-0.87}}'; }md-sidenav.md-THEME_NAME-theme, md-sidenav.md-THEME_NAME-theme md-content {  background-color: '{{background-hue-1}}'; }md-slider.md-THEME_NAME-theme .md-track {  background-color: '{{foreground-3}}'; }md-slider.md-THEME_NAME-theme .md-track-ticks {  color: '{{background-contrast}}'; }md-slider.md-THEME_NAME-theme .md-focus-ring {  background-color: '{{accent-A200-0.2}}'; }md-slider.md-THEME_NAME-theme .md-disabled-thumb {  border-color: '{{background-color}}';  background-color: '{{background-color}}'; }md-slider.md-THEME_NAME-theme.md-min .md-thumb:after {  background-color: '{{background-color}}';  border-color: '{{foreground-3}}'; }md-slider.md-THEME_NAME-theme.md-min .md-focus-ring {  background-color: '{{foreground-3-0.38}}'; }md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after {  background-color: '{{background-contrast}}';  border-color: transparent; }md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign {  background-color: '{{background-400}}'; }  md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after {    border-top-color: '{{background-400}}'; }md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after {  border-top-color: transparent;  border-left-color: '{{background-400}}'; }md-slider.md-THEME_NAME-theme .md-track.md-track-fill {  background-color: '{{accent-color}}'; }md-slider.md-THEME_NAME-theme .md-thumb:after {  border-color: '{{accent-color}}';  background-color: '{{accent-color}}'; }md-slider.md-THEME_NAME-theme .md-sign {  background-color: '{{accent-color}}'; }  md-slider.md-THEME_NAME-theme .md-sign:after {    border-top-color: '{{accent-color}}'; }md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after {  border-top-color: transparent;  border-left-color: '{{accent-color}}'; }md-slider.md-THEME_NAME-theme .md-thumb-text {  color: '{{accent-contrast}}'; }md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring {  background-color: '{{warn-200-0.38}}'; }md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill {  background-color: '{{warn-color}}'; }md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after {  border-color: '{{warn-color}}';  background-color: '{{warn-color}}'; }md-slider.md-THEME_NAME-theme.md-warn .md-sign {  background-color: '{{warn-color}}'; }  md-slider.md-THEME_NAME-theme.md-warn .md-sign:after {    border-top-color: '{{warn-color}}'; }md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after {  border-top-color: transparent;  border-left-color: '{{warn-color}}'; }md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text {  color: '{{warn-contrast}}'; }md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring {  background-color: '{{primary-200-0.38}}'; }md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill {  background-color: '{{primary-color}}'; }md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after {  border-color: '{{primary-color}}';  background-color: '{{primary-color}}'; }md-slider.md-THEME_NAME-theme.md-primary .md-sign {  background-color: '{{primary-color}}'; }  md-slider.md-THEME_NAME-theme.md-primary .md-sign:after {    border-top-color: '{{primary-color}}'; }md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after {  border-top-color: transparent;  border-left-color: '{{primary-color}}'; }md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text {  color: '{{primary-contrast}}'; }md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after {  border-color: transparent; }md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after, md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after {  background-color: '{{foreground-3}}';  border-color: transparent; }md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign {  background-color: '{{background-400}}'; }  md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after {    border-top-color: '{{background-400}}'; }md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after {  border-top-color: transparent;  border-left-color: '{{background-400}}'; }md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb {  border-color: transparent;  background-color: transparent; }md-slider-container[disabled] > *:first-child:not(md-slider),md-slider-container[disabled] > *:last-child:not(md-slider) {  color: '{{foreground-3}}'; }.md-subheader.md-THEME_NAME-theme {  color: '{{ foreground-2-0.23 }}';  background-color: '{{background-default}}'; }  .md-subheader.md-THEME_NAME-theme.md-primary {    color: '{{primary-color}}'; }  .md-subheader.md-THEME_NAME-theme.md-accent {    color: '{{accent-color}}'; }  .md-subheader.md-THEME_NAME-theme.md-warn {    color: '{{warn-color}}'; }md-switch.md-THEME_NAME-theme .md-ink-ripple {  color: '{{background-500}}'; }md-switch.md-THEME_NAME-theme .md-thumb {  background-color: '{{background-50}}'; }md-switch.md-THEME_NAME-theme .md-bar {  background-color: '{{background-500}}'; }md-switch.md-THEME_NAME-theme.md-checked .md-ink-ripple {  color: '{{accent-color}}'; }md-switch.md-THEME_NAME-theme.md-checked .md-thumb {  background-color: '{{accent-color}}'; }md-switch.md-THEME_NAME-theme.md-checked .md-bar {  background-color: '{{accent-color-0.5}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-focused .md-thumb:before {  background-color: '{{accent-color-0.26}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-ink-ripple {  color: '{{primary-color}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-thumb {  background-color: '{{primary-color}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-bar {  background-color: '{{primary-color-0.5}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-primary.md-focused .md-thumb:before {  background-color: '{{primary-color-0.26}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-ink-ripple {  color: '{{warn-color}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-thumb {  background-color: '{{warn-color}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-bar {  background-color: '{{warn-color-0.5}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-warn.md-focused .md-thumb:before {  background-color: '{{warn-color-0.26}}'; }md-switch.md-THEME_NAME-theme[disabled] .md-thumb {  background-color: '{{background-400}}'; }md-switch.md-THEME_NAME-theme[disabled] .md-bar {  background-color: '{{foreground-4}}'; }md-tabs.md-THEME_NAME-theme md-tabs-wrapper {  background-color: transparent;  border-color: '{{foreground-4}}'; }md-tabs.md-THEME_NAME-theme .md-paginator md-icon {  color: '{{primary-color}}'; }md-tabs.md-THEME_NAME-theme md-ink-bar {  color: '{{accent-color}}';  background: '{{accent-color}}'; }md-tabs.md-THEME_NAME-theme .md-tab {  color: '{{foreground-2}}'; }  md-tabs.md-THEME_NAME-theme .md-tab[disabled], md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon {    color: '{{foreground-3}}'; }  md-tabs.md-THEME_NAME-theme .md-tab.md-active, md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon, md-tabs.md-THEME_NAME-theme .md-tab.md-focused, md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon {    color: '{{primary-color}}'; }  md-tabs.md-THEME_NAME-theme .md-tab.md-focused {    background: '{{primary-color-0.1}}'; }  md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container {    color: '{{accent-A100}}'; }md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper {  background-color: '{{accent-color}}'; }  md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{accent-A100}}'; }    md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{accent-contrast}}'; }    md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{accent-contrast-0.1}}'; }  md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-ink-bar {    color: '{{primary-600-1}}';    background: '{{primary-600-1}}'; }md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper {  background-color: '{{primary-color}}'; }  md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{primary-100}}'; }    md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{primary-contrast}}'; }    md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{primary-contrast-0.1}}'; }md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper {  background-color: '{{warn-color}}'; }  md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{warn-100}}'; }    md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{warn-contrast}}'; }    md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{warn-contrast-0.1}}'; }md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper {  background-color: '{{primary-color}}'; }  md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{primary-100}}'; }    md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{primary-contrast}}'; }    md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{primary-contrast-0.1}}'; }md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper {  background-color: '{{accent-color}}'; }  md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{accent-A100}}'; }    md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{accent-contrast}}'; }    md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{accent-contrast-0.1}}'; }  md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-ink-bar {    color: '{{primary-600-1}}';    background: '{{primary-600-1}}'; }md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper {  background-color: '{{warn-color}}'; }  md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{warn-100}}'; }    md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{warn-contrast}}'; }    md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{warn-contrast-0.1}}'; }md-toast.md-THEME_NAME-theme .md-toast-content {  background-color: #323232;  color: '{{background-50}}'; }  md-toast.md-THEME_NAME-theme .md-toast-content .md-button {    color: '{{background-50}}'; }    md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight {      color: '{{accent-color}}'; }      md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary {        color: '{{primary-color}}'; }      md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn {        color: '{{warn-color}}'; }md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) {  background-color: '{{primary-color}}';  color: '{{primary-contrast}}'; }  md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon {    color: '{{primary-contrast}}';    fill: '{{primary-contrast}}'; }  md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon {    color: '{{primary-contrast-0.26}}';    fill: '{{primary-contrast-0.26}}'; }  md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent {    background-color: '{{accent-color}}';    color: '{{accent-contrast}}'; }    md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple {      color: '{{accent-contrast}}'; }    md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon {      color: '{{accent-contrast}}';      fill: '{{accent-contrast}}'; }    md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon {      color: '{{accent-contrast-0.26}}';      fill: '{{accent-contrast-0.26}}'; }  md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn {    background-color: '{{warn-color}}';    color: '{{warn-contrast}}'; }md-tooltip.md-THEME_NAME-theme {  color: '{{background-700-contrast}}'; }  md-tooltip.md-THEME_NAME-theme .md-content {    background-color: '{{background-700}}'; }/*  Only used with Theme processes */html.md-THEME_NAME-theme, body.md-THEME_NAME-theme {  color: '{{foreground-1}}';  background-color: '{{background-color}}'; }"); 
	})();
	
	
	})(window, window.angular);;window.ngMaterial={version:{full: "1.1.1"}};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var forEach;
	var isArray;
	var isString;
	var jqLite;
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage` and `ngMessageExp` directives.
	 *
	 * # Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritise messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, Angular may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
	 */
	angular.module('ngMessages', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isString = angular.isString;
	  jqLite = angular.element;
	})
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used to promote message reusability and messages can also be
	   * overridden.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an angular expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
	                  // this is to prevent the same error name from showing up twice
	                  if (matchedKeys[key]) return;
	                  matchedKeys[key] = true;
	
	                  messageUsed = true;
	                  messageCtrl.attach();
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          unmatchedMessages.length !== totalMessages
	              ? $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS)
	              : $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        // If the element is destroyed, proactively destroy all the currently visible messages
	        $element.on('$destroy', function() {
	          forEach(messages, function(item) {
	            item.message.detach();
	          });
	        });
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater) {
	                cachedCollection && ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl) {
	          var nextKey = latestKey.toString();
	          messages[nextKey] = {
	            message: messageCtrl
	          };
	          insertMessageNode($element[0], comment, nextKey);
	          comment.$$ngMessageNode = nextKey;
	          latestKey++;
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment) {
	          var key = comment.$$ngMessageNode;
	          delete comment.$$ngMessageNode;
	          removeMessageNode($element[0], comment, key);
	          delete messages[key];
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessageExp` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory());
	
	function ngMessageDirectiveFactory() {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode = element[0];
	
	        var records;
	        var staticExp = attrs.ngMessage || attrs.when;
	        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	        var assignRecords = function(items) {
	          records = items
	              ? (isArray(items)
	                  ? items
	                  : items.split(/[\s,]+/))
	              : null;
	          ngMessagesCtrl.reRender();
	        };
	
	        if (dynamicExp) {
	          assignRecords(scope.$eval(dynamicExp));
	          scope.$watchCollection(dynamicExp, assignRecords);
	        } else {
	          assignRecords(staticExp);
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ }),
/* 609 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isDefined;
	var lowercase;
	var noop;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isDefined = angular.isDefined;
	  lowercase = angular.lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = toMap("area,br,col,hr,img,wbr");
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = toMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	      optionalEndTagInlineElements = toMap("rp,rt"),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, toMap("address,article," +
	          "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	          "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, toMap("a,abbr,acronym,b," +
	          "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	          "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = toMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
	          "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
	          "radialGradient,rect,stop,svg,switch,text,title,tspan");
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = toMap("script,style");
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = toMap("background,cite,href,longdesc,src,xlink:href");
	
	  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function toMap(str, lowercaseKeys) {
	    var obj = {}, items = str.split(','), i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  var inertBodyElement;
	  (function(window) {
	    var doc;
	    if (window.document && window.document.implementation) {
	      doc = window.document.implementation.createHTMLDocument("inert");
	    } else {
	      throw $sanitizeMinErr('noinert', "Can't create an inert html document");
	    }
	    var docElement = doc.documentElement || doc.getDocumentElement();
	    var bodyElements = docElement.getElementsByTagName('body');
	
	    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	    if (bodyElements.length === 1) {
	      inertBodyElement = bodyElements[0];
	    } else {
	      var html = doc.createElement('html');
	      inertBodyElement = doc.createElement('body');
	      html.appendChild(inertBodyElement);
	      doc.appendChild(html);
	    }
	  })(window);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	    inertBodyElement.innerHTML = html;
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', "Failed to sanitize html because the input is unstable");
	      }
	      mXSSAttempts--;
	
	      // strip custom-namespaced attributes on IE<=11
	      if (window.document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	      html = inertBodyElement.innerHTML; //trigger mXSS
	      inertBodyElement.innerHTML = html;
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	      if (node.nodeType == 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = node.nextSibling;
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = node.parentNode;
	            if (node === inertBodyElement) break;
	            nextNode = node.nextSibling;
	          if (node.nodeType == 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while (node = inertBodyElement.firstChild) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    if (node.nodeType === window.Node.ELEMENT_NODE) {
	      var attrs = node.attributes;
	      for (var i = 0, l = attrs.length; i < l; i++) {
	        var attrNode = attrs[i];
	        var attrName = attrNode.name.toLowerCase();
	        if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	          node.removeAttributeNode(attrNode);
	          i--;
	          l--;
	        }
	      }
	    }
	
	    var nextNode = node.firstChild;
	    if (nextNode) {
	      stripCustomNsAttrs(nextNode);
	    }
	
	    nextNode = node.nextSibling;
	    if (nextNode) {
	      stripCustomNsAttrs(nextNode);
	    }
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n'+
	             'http://angularjs.org/,\n'+
	             'mailto:us@somewhere.org,\n'+
	             'another@somewhere.org,\n'+
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 610 */
/***/ (function(module, exports) {

	/*
	 * angular-socialshare
	 * 2.3.11
	 * 
	 * A social media url and content share module for angularjs.
	 * http://720kb.github.io/angular-socialshare
	 * 
	 * MIT license
	 * Fri Jun 23 2017
	 */
	/*global angular*/
	/*eslint no-loop-func:0, func-names:0*/
	
	(function withAngular(angular) {
	  'use strict';
	
	  var directiveName = 'socialshare'
	    , serviceName = 'Socialshare'
	    , socialshareProviderNames = ['facebook', 'facebook-messenger','sms', 'twitter', 'linkedin', 'google', 'pinterest', 'tumblr', 'reddit', 'stumbleupon', 'buffer', 'digg', 'delicious', 'vk', 'pocket', 'wordpress', 'flipboard', 'xing', 'hackernews', 'evernote', 'whatsapp', 'telegram', 'viber', 'skype', 'email', 'ok', 'weibo']
	    , socialshareConfigurationProvider = /*@ngInject*/ function socialshareConfigurationProvider() {
	
	      var socialshareConfigurationDefault = [{
	        'provider': 'email',
	        'conf': {
	          'subject': '',
	          'body': '',
	          'to': '',
	          'cc': '',
	          'bcc': '',
	          'trigger': 'click'
	        }
	      },
	      {
	        'provider': 'facebook',
	        'conf': {
	          'url':'',
	          'title':'',
	          'href':'',
	          'quote':'',
	          'hashtags':'',
	          'text': '',
	          'media': '',
	          'mobile_iframe': '',
	          'type': '',
	          'via': '',
	          'to': '',
	          'from': '',
	          'ref': '',
	          'display': '',
	          'source': '',
	          'caption': '',
	          'redirectUri': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'facebook-messenger',
	        'conf': {
	          'url': ''
	        }
	      },
	      {
	        'provider': 'twitter',
	        'conf': {
	          'url': '',
	          'text': '',
	          'via': '',
	          'hashtags': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'linkedin',
	        'conf': {
	          'url': '',
	          'text': '',
	          'description': '',
	          'source': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'reddit',
	        'conf': {
	          'url': '',
	          'text': '',
	          'subreddit': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'vk',
	        'conf': {
	          'url': '',
	          'text': '',
	          'media': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'ok',
	        'conf': {
	          'url': '',
	          'text': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'digg',
	        'conf': {
	          'url': '',
	          'text': '',
	          'media': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'delicious',
	        'conf': {
	          'url': '',
	          'text': '',
	          'media': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'stumbleupon',
	        'conf': {
	          'url': '',
	          'text': '',
	          'media': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'pinterest',
	        'conf': {
	          'url': '',
	          'text': '',
	          'media': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'google',
	        'conf': {
	          'url': '',
	          'text': '',
	          'media': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'tumblr',
	        'conf': {
	          'url': '',
	          'text': '',
	          'media': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'buffer',
	        'conf': {
	          'url': '',
	          'text': '',
	          'via': '',
	          'media': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'pocket',
	        'conf': {
	          'url': '',
	          'text': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'flipboard',
	        'conf': {
	          'url': '',
	          'text': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'hackernews',
	        'conf': {
	          'url': '',
	          'text': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'wordpress',
	        'conf': {
	          'url': '',
	          'text': '',
	          'media': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'xing',
	        'conf': {
	          'url': '',
	          'text': '',
	          'media': '',
	          'follow' : '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'evernote',
	        'conf': {
	          'url': '',
	          'text': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'whatsapp',
	        'conf': {
	          'url': '',
	          'text': ''
	        }
	      },
	      {
	        'provider': 'sms',
	        'conf': {
	          'url': '',
	          'text': '',
	          'to': '',
	          'trigger': 'click'
	        }
	      },
	      {
	        'provider': 'telegram',
	        'conf': {
	          'url': '',
	          'text': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'viber',
	        'conf': {
	          'url': '',
	          'text': ''
	        }
	      },
	      {
	        'provider': 'skype',
	        'conf': {
	          'url': '',
	          'text': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      },
	      {
	        'provider': 'weibo',
	        'conf': {
	          'url': '',
	          'text': '',
	          'trigger': 'click',
	          'popupHeight': 600,
	          'popupWidth': 500
	        }
	      }];
	
	      return {
	        'configure': function configure(configuration) {
	
	          var configIndex = 0
	            , configurationKeys
	            , configurationIndex
	            , aConfigurationKey
	            , configElement
	            , internIndex = 0
	          //this is necessary becuase provider run before any service
	          //so i have to take the log from another injector
	          , $log = angular.injector(['ng']).get('$log');
	
	          if (configuration && configuration.length > 0) {
	            for (; configIndex < configuration.length; configIndex += 1) {
	              if (configuration[configIndex].provider && socialshareProviderNames.indexOf(configuration[configIndex].provider) > -1) {
	
	                for (; internIndex < socialshareConfigurationDefault.length; internIndex += 1) {
	                  configElement = socialshareConfigurationDefault[internIndex];
	
	                  if (configElement &&
	                    configElement.provider &&
	                    configuration[configIndex].provider === configElement.provider) {
	
	                      configurationKeys = Object.keys(configElement.conf);
	                      configurationIndex = 0;
	
	                      for (; configurationIndex < configurationKeys.length; configurationIndex += 1) {
	
	                        aConfigurationKey = configurationKeys[configurationIndex];
	                        if (aConfigurationKey && configuration[configIndex].conf[aConfigurationKey]) {
	
	                          configElement.conf[aConfigurationKey] = configuration[configIndex].conf[aConfigurationKey];
	                        }
	                      }
	
	                      // once the provider has been found and configuration applied
	                      // we should reset the internIndex for the next provider match to work correctly
	                      // and break, to skip loops on unwanted next providers
	                      internIndex = 0;
	                      break;
	                    }
	                  }
	                } else {
	                  $log.warn('Invalid provider at element ' + configIndex + ' with name:' + configuration[configIndex].provider);
	                }
	              }
	            }
	        }
	        , '$get': /*@ngInject*/ function instantiateProvider() {
	
	            return socialshareConfigurationDefault;
	        }
	      };
	    }
	    , manageFacebookShare = function manageFacebookShare($window, attrs) {
	
	      var urlString;
	
	      if (attrs.socialshareType && attrs.socialshareType === 'feed') {
	        // if user specifies that they want to use the Facebook feed dialog
	        //(https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4)
	        urlString = 'https://www.facebook.com/dialog/feed?';
	
	        if (attrs.socialshareVia) {
	          urlString += '&app_id=' + encodeURIComponent(attrs.socialshareVia);
	        }
	
	        if (attrs.socialshareRedirectUri) {
	          urlString += '&redirect_uri=' + encodeURIComponent(attrs.socialshareRedirectUri);
	        }
	        if (attrs.socialshareUrl) {
	          urlString += '&link=' + encodeURIComponent(attrs.socialshareUrl);
	        }
	
	        if (attrs.socialshareTo) {
	          urlString += '&to=' + encodeURIComponent(attrs.socialshareTo);
	        }
	
	        if (attrs.socialshareDisplay) {
	          urlString += '&display=' + encodeURIComponent(attrs.socialshareDisplay);
	        }
	
	        if (attrs.socialshareRef) {
	          urlString += '&ref=' + encodeURIComponent(attrs.socialshareRef);
	        }
	
	        if (attrs.socialshareFrom) {
	          urlString += '&from=' + encodeURIComponent(attrs.socialshareFrom);
	        }
	
	        if (attrs.socialshareSource) {
	          urlString += '&source=' + encodeURIComponent(attrs.socialshareSource);
	        }
	
	        $window.open(
	          urlString,
	          'Facebook', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	          + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	
	      } else if (attrs.socialshareType && attrs.socialshareType === 'share') {
	       // if user specifies that they want to use the Facebook share dialog
	       //(https://developers.facebook.com/docs/sharing/reference/share-dialog)
	       urlString = 'https://www.facebook.com/dialog/share?';
	
	       if (attrs.socialshareVia) {
	         urlString += '&app_id=' + encodeURIComponent(attrs.socialshareVia);
	       }
	
	       if (attrs.socialshareRedirectUri) {
	         urlString += '&redirect_uri=' + encodeURIComponent(attrs.socialshareRedirectUri);
	       }
	
	       if (attrs.socialshareUrl) {
	         urlString += '&href=' + encodeURIComponent(attrs.socialshareUrl);
	       }
	
	       if (attrs.socialshareQuote) {
	         urlString += '&quote=' + encodeURIComponent(attrs.socialshareQuote);
	       }
	
	       if (attrs.socialshareDisplay) {
	         urlString += '&display=' + encodeURIComponent(attrs.socialshareDisplay);
	       }
	
	       if (attrs.socialshareMobileiframe) {
	       urlString += '&mobile_iframe=' + encodeURIComponent(attrs.socialshareMobileiframe);
	       }
	
	       if (attrs.socialshareHashtags) {
	         urlString += '&hashtag=' + encodeURIComponent(attrs.socialshareHashtags);
	       }
	
	
	       $window.open(
	         urlString,
	         'Facebook', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	         + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	
	      } else if (attrs.socialshareType && attrs.socialshareType === 'send') {
	        // if user specifies that they want to use the Facebook send dialog
	        //(https://developers.facebook.com/docs/sharing/reference/send-dialog)
	        urlString = 'https://www.facebook.com/dialog/send?';
	
	        if (attrs.socialshareVia) {
	          urlString += '&app_id=' + encodeURIComponent(attrs.socialshareVia);
	        }
	
	        if (attrs.socialshareRedirectUri) {
	          urlString += '&redirect_uri=' + encodeURIComponent(attrs.socialshareRedirectUri);
	        }
	
	        if (attrs.socialshareUrl) {
	          urlString += '&link=' + encodeURIComponent(attrs.socialshareUrl);
	        }
	
	        if (attrs.socialshareTo) {
	          urlString += '&to=' + encodeURIComponent(attrs.socialshareTo);
	        }
	
	        if (attrs.socialshareDisplay) {
	          urlString += '&display=' + encodeURIComponent(attrs.socialshareDisplay);
	        }
	
	        $window.open(
	          urlString,
	          'Facebook', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	          + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	
	      } else {
	        //otherwise default to using sharer.php
	        $window.open(
	          'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href)
	          , 'Facebook', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	          + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      }
	    }
	    , manageEmailShare = function manageEmailShare($window, attrs) {
	      var urlString = 'mailto:';
	
	      if (attrs.socialshareTo) {
	
	        urlString += encodeURIComponent(attrs.socialshareTo);
	      }
	
	      urlString += '?';
	
	      if (attrs.socialshareBody) {
	
	        urlString += 'body=' + encodeURIComponent(attrs.socialshareBody);
	      }
	
	      if (attrs.socialshareSubject) {
	
	        urlString += '&subject=' + encodeURIComponent(attrs.socialshareSubject);
	      }
	      if (attrs.socialshareCc) {
	
	        urlString += '&cc=' + encodeURIComponent(attrs.socialshareCc);
	      }
	      if (attrs.socialshareBcc) {
	
	        urlString += '&bcc=' + encodeURIComponent(attrs.socialshareBcc);
	      }
	      if ($window.self !== $window.top) {
	        $window.open(urlString, '_blank');
	      } else {
	        $window.open(urlString, '_self');
	      }
	
	    }
	    , facebookMessengerShare = function facebookMessengerShare($window, attrs, element) {
	
	      var href = 'fb-messenger://share?link=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      element.attr('href', href);
	      element.attr('target', '_top');
	  }
	    , manageTwitterShare = function manageTwitterShare($window, attrs) {
	      var urlString = 'https://www.twitter.com/intent/tweet?';
	
	      if (attrs.socialshareText) {
	        urlString += 'text=' + encodeURIComponent(attrs.socialshareText);
	      }
	
	      if (attrs.socialshareVia) {
	        urlString += '&via=' + encodeURIComponent(attrs.socialshareVia);
	      }
	
	      if (attrs.socialshareHashtags) {
	        urlString += '&hashtags=' + encodeURIComponent(attrs.socialshareHashtags);
	      }
	
	      //default to the current page if a URL isn't specified
	      urlString += '&url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      $window.open(
	        urlString,
	        'Twitter', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageGooglePlusShare = function manageGooglePlusShare($window, attrs) {
	
	      $window.open(
	        'https://plus.google.com/share?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href)
	        , 'Google+', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      }
	    , manageRedditShare = function manageRedditShare($window, attrs) {
	      var urlString = 'https://www.reddit.com/';
	
	      if (attrs.socialshareSubreddit) {
	        urlString += 'r/' + attrs.socialshareSubreddit + '/submit?url=';
	      } else {
	        urlString += 'submit?url=';
	      }
	      /*-
	      * Reddit isn't responsive and at default width for our popups (500 x 500), everything is messed up.
	      * So, overriding the width if it is less than 900 (played around to settle on this) and height if
	      * it is less than 650px.
	      */
	      if (attrs.socialsharePopupWidth < 900) {
	        attrs.socialsharePopupWidth = 900;
	      }
	
	      if (attrs.socialsharePopupHeight < 650) {
	        attrs.socialsharePopupHeight = 650;
	      }
	
	      $window.open(
	        urlString + encodeURIComponent(attrs.socialshareUrl || $window.location.href) + '&title=' + encodeURIComponent(attrs.socialshareText)
	        , 'Reddit', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      }
	    , manageStumbleuponShare = function manageStumbleuponShare($window, attrs) {
	
	      $window.open(
	        'https://www.stumbleupon.com/submit?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href) + '&title=' + encodeURIComponent(attrs.socialshareText)
	        , 'StumbleUpon', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageLinkedinShare = function manageLinkedinShare($window, attrs) {
	      /*
	      * Refer: https://developer.linkedin.com/docs/share-on-linkedin
	      * Tab: Customized URL
	      */
	      var urlString = 'https://www.linkedin.com/shareArticle?mini=true';
	
	      urlString += '&url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      if (attrs.socialshareText) {
	        urlString += '&title=' + encodeURIComponent(attrs.socialshareText);
	      }
	
	      if (attrs.socialshareDescription) {
	        urlString += '&summary=' + encodeURIComponent(attrs.socialshareDescription);
	      }
	
	      if (attrs.socialshareSource) {
	        urlString += '&source=' + encodeURIComponent(attrs.socialshareSource);
	      }
	
	      $window.open(
	        urlString,
	        'Linkedin', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , managePinterestShare = function managePinterestShare($window, attrs) {
	
	      $window.open(
	        'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href) + '&media=' + encodeURIComponent(attrs.socialshareMedia) + '&description=' + encodeURIComponent(attrs.socialshareText)
	        , 'Pinterest', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageDiggShare = function manageDiggShare($window, attrs) {
	
	      $window.open(
	        'https://www.digg.com/submit?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href) + '&title=' + encodeURIComponent(attrs.socialshareText)
	        , 'Digg', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageTumblrShare = function manageTumblrShare($window, attrs) {
	
	      if (attrs.socialshareMedia) {
	        var urlString = 'https://www.tumblr.com/share/photo?source=' + encodeURIComponent(attrs.socialshareMedia);
	
	        if (attrs.socialshareText) {
	          urlString += '&caption=' + encodeURIComponent(attrs.socialshareText);
	        }
	
	        $window.open(
	          urlString,
	          'Tumblr', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	          + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      } else {
	
	        $window.open(
	          'https://www.tumblr.com/share/link?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href) + '&description=' + encodeURIComponent(attrs.socialshareText)
	          , 'Tumblr', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	          + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      }
	    }
	    , manageVkShare = function manageVkShare($window, attrs) {
	      var urlString = 'https://www.vk.com/share.php?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      if (attrs.socialshareText) {
	        urlString += '&title=' + encodeURIComponent(attrs.socialshareText);
	      }
	
	      if (attrs.socialshareMedia) {
	        urlString += '&image=' + encodeURIComponent(attrs.socialshareMedia);
	      }
	
	      if (attrs.socialshareDescription) {
	        urlString += '&description=' + encodeURIComponent(attrs.socialshareDescription);
	      }
	
	      $window.open(
	       urlString
	       , 'Vk', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	       + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageOkShare = function manageOkShare($window, attrs) {
	      $window.open(
	        'http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st._surl=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href) + '&st.comments=' + encodeURIComponent(attrs.socialshareText)
	        , 'Ok', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageDeliciousShare = function manageDeliciousShare($window, attrs) {
	
	     $window.open(
	       'https://www.delicious.com/save?v=5&noui&jump=close&url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href) + '&title=' + encodeURIComponent(attrs.socialshareText)
	       , 'Delicious', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	       + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageBufferShare = function manageBufferShare($window, attrs) {
	      var urlString = 'https://bufferapp.com/add?';
	
	      if (attrs.socialshareText) {
	        urlString += 'text=' + encodeURIComponent(attrs.socialshareText);
	      }
	
	      if (attrs.socialshareVia) {
	        urlString += '&via=' + encodeURIComponent(attrs.socialshareVia);
	      }
	
	      if (attrs.socialshareMedia) {
	        urlString += '&picture=' + encodeURIComponent(attrs.socialshareMedia);
	      }
	
	      //default to the current page if a URL isn't specified
	      urlString += '&url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      $window.open(
	        urlString,
	        'Buffer', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageHackernewsShare = function manageHackernewsShare($window, attrs) {
	      var urlString = 'https://news.ycombinator.com/submitlink?';
	
	      if (attrs.socialshareText) {
	        urlString += 't=' + encodeURIComponent(attrs.socialshareText) + '&';
	      }
	      //default to the current page if a URL isn't specified
	      urlString += 'u=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      $window.open(
	       urlString,
	       'Hackernews', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	      + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageFlipboardShare = function manageFlipboardShare($window, attrs) {
	      var urlString = 'https://share.flipboard.com/bookmarklet/popout?v=2&';
	
	      if (attrs.socialshareText) {
	        urlString += 'title=' + encodeURIComponent(attrs.socialshareText) + '&';
	      }
	
	      //default to the current page if a URL isn't specified
	      urlString += 'url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      $window.open(
	        urlString,
	        'Flipboard', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , managePocketShare = function managePocketShare($window, attrs) {
	      var urlString = 'https://getpocket.com/save?';
	
	      if (attrs.socialshareText) {
	        urlString += 'text=' + encodeURIComponent(attrs.socialshareText) + '&';
	      }
	
	      //default to the current page if a URL isn't specified
	      urlString += 'url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      $window.open(
	        urlString,
	        'Pocket', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageWordpressShare = function manageWordpressShare($window, attrs) {
	      var urlString = 'http://wordpress.com/press-this.php?';
	
	      if (attrs.socialshareText) {
	        urlString += 't=' + encodeURIComponent(attrs.socialshareText) + '&';
	      }
	      if (attrs.socialshareMedia) {
	        urlString += 'i=' + encodeURIComponent(attrs.socialshareMedia) + '&';
	      }
	
	      //default to the current page if a URL isn't specified
	      urlString += 'u=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      $window.open(
	        urlString,
	        'Wordpress', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageXingShare = function manageXingShare($window, attrs) {
	      var followUrl = '';
	
	      if (attrs.socialshareFollow) {
	        followUrl = '&follow_url=' + encodeURIComponent(attrs.socialshareFollow);
	      }
	      $window.open(
	        'https://www.xing.com/spi/shares/new?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href) + followUrl
	        , 'Xing', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageEvernoteShare = function manageEvernoteShare($window, attrs) {
	
	      var urlString = 'http://www.evernote.com/clip.action?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      if (attrs.socialshareText) {
	        urlString += '&title=' + encodeURIComponent(attrs.socialshareText);
	      }
	
	      $window.open(
	        urlString
	        , 'Evernote', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageWhatsappShare = function manageWhatsappShare($window, attrs, element) {
	
	      var href = 'whatsapp://send?text=' + encodeURIComponent(attrs.socialshareText) + '%0A' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      element.attr('href', href);
	      element.attr('target', '_top');
	
	    }
	    , manageSmsShare = function smsShare($window, attrs, element) {
	
	      if (attrs.socialshareText.indexOf('%') >= 0) {
	        $log.warn('sending sms text with "%" sign is not supported');
	      }
	
	      var body = encodeURIComponent(attrs.socialshareText.replace('%',''))
	        , toPhoneNumber = attrs.socialshareTo || ''
	        , urlString;
	
	      if (attrs.socialshareUrl) {
	        body += encodeURIComponent(attrs.socialshareUrl);
	      }
	
	      urlString = 'sms:' + toPhoneNumber + '?&body=' + body;
	
	      element.attr('href', urlString);
	      element.attr('target', '_blank');
	    }
	    , manageViberShare = function manageViberShare($window, attrs, element) {
	
	      var href = 'viber://forward?text=' + encodeURIComponent(attrs.socialshareText) + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      element.attr('href', href);
	      element.attr('target', '_top');
	    }
	    , manageTelegramShare = function manageTelegramShare($window, attrs) {
	
	      var urlString = 'https://telegram.me/share/url?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      if (attrs.socialshareText) {
	        urlString += '&text=' + encodeURIComponent(attrs.socialshareText);
	      }
	
	      $window.open(
	        urlString
	        , 'Telegram', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , skypeShare = function skypeShare($window, attrs) {
	      var urlString = 'https://web.skype.com/share?source=button&url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      if (attrs.socialshareText) {
	        urlString += '&text=' + encodeURIComponent(attrs.socialshareText);
	      }
	
	      $window.open(
	        urlString
	        , 'Skype', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , weiboShare = function weiboShare($window, attrs) {
	      var urlString = 'http://service.weibo.com/share/share.php?url=' + encodeURIComponent(attrs.socialshareUrl || $window.location.href);
	
	      if (attrs.socialshareText) {
	        urlString += '&title=' + encodeURIComponent(attrs.socialshareText);
	      }
	
	      $window.open(
	        urlString
	        , 'Weibo', 'toolbar=0,status=0,resizable=yes,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , socialshareService = /*@ngInject*/  ['$window', '$log', function socialshareService($window, $log) {
	
	      this.emailShare = manageEmailShare;
	      this.facebookShare = manageFacebookShare;
	      this.twitterShare = manageTwitterShare;
	      //**** Fb Messenger can't open without an element clicked (href)
	      //this.facebookMessengerShare = facebookMessengerShare;
	      this.stumbleuponShare = manageStumbleuponShare;
	      this.pinterestShare = managePinterestShare;
	      this.googleShare = manageGooglePlusShare;
	      this.bufferShare = manageBufferShare;
	      this.hackernewsShare = manageHackernewsShare;
	      this.okShare = manageOkShare;
	      this.deliciousShare = manageDeliciousShare;
	      this.pocketShare = managePocketShare;
	      this.vkShare = manageVkShare;
	      this.flipboardShare = manageFlipboardShare;
	      this.xingShare = manageXingShare;
	      this.diggShare = manageDiggShare;
	      this.linkedinShare = manageLinkedinShare;
	      this.wordpressShare = manageWordpressShare;
	      this.telegramShare = manageTelegramShare;
	      this.redditShare = manageRedditShare;
	      this.evernoteShare = manageEvernoteShare;
	      this.tumblrShare = manageTumblrShare;
	      //**** viber can't share without an element clicked (href)
	      //this.viberShare = manageViberShare;
	      //**** whatsapp can't share without an element clicked (href)
	      //this.whatsappShare = manageWhatsappShare;
	      this.skypeShare = skypeShare;
	      this.smsShare = manageSmsShare;
	      this.weiboShare = weiboShare;
	
	      this.share = function shareTrigger(serviceShareConf) {
	
	        switch (serviceShareConf.provider) {
	          case 'email': {
	            this.emailShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'sms': {
	            this.smsShare($window, $log, serviceShareConf.attrs);
	            break;
	          }
	          case 'facebook': {
	            this.facebookShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'twitter': {
	            this.twitterShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'pinterest': {
	            this.pinterestShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'ok': {
	            this.okShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'vk': {
	            this.vkShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'delicious': {
	            this.deliciousShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'digg': {
	            this.diggShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'google': {
	            this.googleShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'reddit': {
	            this.redditShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'hackernews': {
	            this.hackernewsShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'skype': {
	            this.skypeShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'evernote': {
	            this.evernoteShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'pocket': {
	            this.pocketShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'tumblr': {
	            this.tumblrShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'telegram': {
	            this.telegramShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'xing': {
	            this.xingShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'buffer': {
	            this.bufferShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'stumbleupon': {
	            this.stumbleuponShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'linkedin': {
	            this.linkedinShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'wordpress': {
	            this.wordpressShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'flipboard': {
	            this.flipboardShare($window, serviceShareConf.attrs);
	            break;
	          }
	          case 'weibo': {
	            this.weiboShare($window, serviceShareConf.attrs);
	            break;
	          }
	          default: {
	            return;
	          }
	        }
	      };
	    }]
	    , socialshareDirective = /*@ngInject*/ ['$window', 'socialshareConf', 'Socialshare', '$log', function socialshareDirective($window, socialshareConf, $log) {
	
	      var linkingFunction = function linkingFunction($scope, element, attrs) {
	
	        // observe the values in each of the properties so that if they're updated elsewhere,
	        // they are updated in this directive.
	        var configurationElement
	        , index = 0
	        , onEventTriggered = function onEventTriggered() {
	          /*eslint-disable no-use-before-define*/
	          if (attrs.socialshareProvider in sharingFunctions) {
	            sharingFunctions[attrs.socialshareProvider]($window, attrs, element);
	          } else {
	            return true;
	          }
	        };
	        /*eslint-enable no-use-before-define*/
	        //looking into configuration if there is a config for the current provider
	        for (; index < socialshareConf.length; index += 1) {
	          if (socialshareConf[index].provider === attrs.socialshareProvider) {
	            configurationElement = socialshareConf[index];
	            break;
	          }
	        }
	
	        if (socialshareProviderNames.indexOf(configurationElement.provider) === -1) {
	          $log.warn('Invalid Provider Name : ' + attrs.socialshareProvider);
	        }
	
	        //if some attribute is not define provide a default one
	        attrs.socialshareMobileiframe = attrs.socialshareMobileiframe || configurationElement.conf.mobile_iframe;
	        attrs.socialshareQuote = attrs.socialshareQuote || configurationElement.conf.quote;
	        attrs.socialshareTitle = attrs.socialshareTitle || configurationElement.conf.title;
	        attrs.socialshareUrl = attrs.socialshareUrl || configurationElement.conf.url || configurationElement.conf.href;
	        attrs.socialshareText = attrs.socialshareText || configurationElement.conf.text;
	        attrs.socialshareMedia = attrs.socialshareMedia || configurationElement.conf.media;
	        attrs.socialshareType =  attrs.socialshareType || configurationElement.conf.type;
	        attrs.socialshareVia = attrs.socialshareVia || configurationElement.conf.via;
	        attrs.socialshareTo =  attrs.socialshareTo || configurationElement.conf.to;
	        attrs.socialshareFrom =  attrs.socialshareFrom || configurationElement.conf.from;
	        attrs.socialshareRef = attrs.socialshareRef || configurationElement.conf.ref;
	        attrs.socialshareDislay = attrs.socialshareDislay || configurationElement.conf.display;
	        attrs.socialshareSource = attrs.socialshareSource || configurationElement.conf.source;
	        attrs.socialshareCaption = attrs.socialshareCaption || configurationElement.conf.caption;
	        attrs.socialshareRedirectUri = attrs.socialshareRedirectUri || configurationElement.conf.redirectUri;
	        attrs.socialshareTrigger =  attrs.socialshareTrigger || configurationElement.conf.trigger;
	        attrs.socialsharePopupHeight = attrs.socialsharePopupHeight || configurationElement.conf.popupHeight;
	        attrs.socialsharePopupWidth = attrs.socialsharePopupWidth || configurationElement.conf.popupWidth;
	        attrs.socialshareSubreddit = attrs.socialshareSubreddit || configurationElement.conf.subreddit;
	        attrs.socialshareDescription = attrs.socialshareDescription || configurationElement.conf.description;
	        attrs.socialshareFollow = attrs.socialshareFollow || configurationElement.conf.follow;
	        attrs.socialshareHashtags = attrs.socialshareHashtags || configurationElement.conf.hashtags;
	        attrs.socialshareBody = attrs.socialshareBody || configurationElement.conf.body;
	        attrs.socialshareSubject = attrs.socialshareSubject || configurationElement.conf.subject;
	        attrs.socialshareCc = attrs.socialshareCc || configurationElement.conf.cc;
	        attrs.socialshareBcc = attrs.socialshareBcc || configurationElement.conf.bcc;
	
	        if (attrs.socialshareTrigger) {
	
	          element.bind(attrs.socialshareTrigger, onEventTriggered);
	        } else {
	
	          onEventTriggered();
	        }
	      };
	
	      return {
	        'restrict': 'A',
	        'link': linkingFunction
	      };
	    }]
	    , sharingFunctions = {
	        'email': manageEmailShare
	      , 'facebook': manageFacebookShare
	      , 'facebook-messenger': facebookMessengerShare
	      , 'twitter': manageTwitterShare
	      , 'google': manageGooglePlusShare
	      , 'reddit': manageRedditShare
	      , 'stumbleupon': manageStumbleuponShare
	      , 'linkedin': manageLinkedinShare
	      , 'pinterest': managePinterestShare
	      , 'digg': manageDiggShare
	      , 'tumblr': manageTumblrShare
	      , 'vk': manageVkShare
	      , 'ok': manageOkShare
	      , 'delicious': manageDeliciousShare
	      , 'buffer': manageBufferShare
	      , 'hackernews': manageHackernewsShare
	      , 'flipboard': manageFlipboardShare
	      , 'pocket': managePocketShare
	      , 'wordpress': manageWordpressShare
	      , 'xing': manageXingShare
	      , 'evernote': manageEvernoteShare
	      , 'whatsapp': manageWhatsappShare
	      , 'sms': manageSmsShare
	      , 'telegram': manageTelegramShare
	      , 'viber': manageViberShare
	      , 'skype': skypeShare
	      , 'weibo': weiboShare
	    };
	
	
	  angular.module('720kb.socialshare', [])
	  .provider(directiveName + 'Conf', socialshareConfigurationProvider)
	  .service(serviceName, socialshareService)
	  .directive(directiveName, socialshareDirective);
	}(angular));


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {(function commonJS(require, module) {
	    'use strict';
	
	    __webpack_require__(610);
	
	    module.exports = '720kb.socialshare';
	}(require, module));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module)))

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	(function() {
	
	
	// Create all modules and define dependencies to make sure they exist
	// and are loaded in the correct order to satisfy dependency injection
	// before all nested files are concatenated by Grunt
	
	angular.module('angular-storage',
	    [
	      'angular-storage.store'
	    ]);
	
	angular.module('angular-storage.cookieStorage', [])
	  .service('cookieStorage', ["$cookies", function ($cookies) {
	
	    this.set = function (what, value) {
	      return $cookies.put(what, value);
	    };
	
	    this.get = function (what) {
	      return $cookies.get(what);
	    };
	
	    this.remove = function (what) {
	      return $cookies.remove(what);
	    };
	  }]);
	
	angular.module('angular-storage.internalStore', ['angular-storage.localStorage', 'angular-storage.sessionStorage'])
	  .factory('InternalStore', ["$log", "$injector", function($log, $injector) {
	
	    function InternalStore(namespace, storage, delimiter, useCache) {
	      this.namespace = namespace || null;
	      if (angular.isUndefined(useCache) || useCache == null) {
	        useCache = true;
	      }
	      this.useCache = useCache;
	      this.delimiter = delimiter || '.';
	      this.inMemoryCache = {};
	      this.storage = $injector.get(storage || 'localStorage');
	    }
	
	    InternalStore.prototype.getNamespacedKey = function(key) {
	      if (!this.namespace) {
	        return key;
	      } else {
	        return [this.namespace, key].join(this.delimiter);
	      }
	    };
	
	    InternalStore.prototype.set = function(name, elem) {
	      if (this.useCache) {
	        this.inMemoryCache[name] = elem;
	      }
	      this.storage.set(this.getNamespacedKey(name), JSON.stringify(elem));
	    };
	
	    InternalStore.prototype.get = function(name) {
	      var obj = null;
	      if (this.useCache && name in this.inMemoryCache) {
	        return this.inMemoryCache[name];
	      }
	      var saved = this.storage.get(this.getNamespacedKey(name));
	      try {
	
	        if (typeof saved === 'undefined' || saved === 'undefined') {
	          obj = undefined;
	        } else {
	          obj = JSON.parse(saved);
	        }
	
	        if (this.useCache) {
	          this.inMemoryCache[name] = obj;
	        }
	      } catch(e) {
	        $log.error('Error parsing saved value', e);
	        this.remove(name);
	      }
	      return obj;
	    };
	
	    InternalStore.prototype.remove = function(name) {
	      if (this.useCache) {
	        this.inMemoryCache[name] = null;
	      }
	      this.storage.remove(this.getNamespacedKey(name));
	    };
	
	    return InternalStore;
	  }]);
	
	
	angular.module('angular-storage.localStorage', ['angular-storage.cookieStorage'])
	  .service('localStorage', ["$window", "$injector", function ($window, $injector) {
	    var localStorageAvailable;
	
	    try {
	      $window.localStorage.setItem('testKey', 'test');
	      $window.localStorage.removeItem('testKey');
	      localStorageAvailable = true;
	    } catch(e) {
	      localStorageAvailable = false;
	    }
	
	    if (localStorageAvailable) {
	      this.set = function (what, value) {
	        return $window.localStorage.setItem(what, value);
	      };
	
	      this.get = function (what) {
	        return $window.localStorage.getItem(what);
	      };
	
	      this.remove = function (what) {
	        return $window.localStorage.removeItem(what);
	      };
	      
	      this.clear = function () {
	        $window.localStorage.clear();
	      };
	    } else {
	      var cookieStorage = $injector.get('cookieStorage');
	
	      this.set = cookieStorage.set;
	      this.get = cookieStorage.get;
	      this.remove = cookieStorage.remove;
	    }
	  }]);
	
	angular.module('angular-storage.sessionStorage', ['angular-storage.cookieStorage'])
	  .service('sessionStorage', ["$window", "$injector", function ($window, $injector) {
	    var sessionStorageAvailable;
	
	    try {
	      $window.sessionStorage.setItem('testKey', 'test');
	      $window.sessionStorage.removeItem('testKey');
	      sessionStorageAvailable = true;
	    } catch(e) {
	      sessionStorageAvailable = false;
	    }
	
	    if (sessionStorageAvailable) {
	      this.set = function (what, value) {
	        return $window.sessionStorage.setItem(what, value);
	      };
	
	      this.get = function (what) {
	        return $window.sessionStorage.getItem(what);
	      };
	
	      this.remove = function (what) {
	        return $window.sessionStorage.removeItem(what);
	      };
	    } else {
	      var cookieStorage = $injector.get('cookieStorage');
	
	      this.set = cookieStorage.set;
	      this.get = cookieStorage.get;
	      this.remove = cookieStorage.remove;
	    }
	  }]);
	
	angular.module('angular-storage.store', ['angular-storage.internalStore'])
	  .provider('store', function() {
	
	    // the default storage
	    var _storage = 'localStorage';
	
	    //caching is on by default
	    var _caching = true;
	
	    /**
	     * Sets the storage.
	     *
	     * @param {String} storage The storage name
	     */
	    this.setStore = function(storage) {
	      if (storage && angular.isString(storage)) {
	        _storage = storage;
	      }
	    };
	
	    /**
	     * Sets the internal cache usage
	     *
	     * @param {boolean} useCache Whether to use internal cache
	     */
	    this.setCaching = function(useCache) {
	      _caching = !!useCache;
	    };
	
	    this.$get = ["InternalStore", function(InternalStore) {
	      var store = new InternalStore(null, _storage, null, _caching);
	
	      /**
	       * Returns a namespaced store
	       *
	       * @param {String} namespace The namespace
	       * @param {String} storage The name of the storage service
	       * @param {String} delimiter The key delimiter
	       * @param {boolean} useCache whether to use the internal caching
	       * @returns {InternalStore}
	       */
	      store.getNamespacedStore = function(namespace, storage, delimiter, useCache) {
	        return new InternalStore(namespace, storage, delimiter, useCache);
	      };
	
	      return store;
	    }];
	  });
	
	
	}());

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* global ngTouchClickDirectiveFactory: false,
	 */
	
	/**
	 * @ngdoc module
	 * @name ngTouch
	 * @description
	 *
	 * # ngTouch
	 *
	 * The `ngTouch` module provides touch events and other helpers for touch-enabled devices.
	 * The implementation is based on jQuery Mobile touch event handling
	 * ([jquerymobile.com](http://jquerymobile.com/)).
	 *
	 *
	 * See {@link ngTouch.$swipe `$swipe`} for usage.
	 *
	 * <div doc-module-components="ngTouch"></div>
	 *
	 */
	
	// define ngTouch module
	/* global -ngTouch */
	var ngTouch = angular.module('ngTouch', []);
	
	ngTouch.provider('$touch', $TouchProvider);
	
	function nodeName_(element) {
	  return angular.lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	/**
	 * @ngdoc provider
	 * @name $touchProvider
	 *
	 * @description
	 * The `$touchProvider` allows enabling / disabling {@link ngTouch.ngClick ngTouch's ngClick directive}.
	 */
	$TouchProvider.$inject = ['$provide', '$compileProvider'];
	function $TouchProvider($provide, $compileProvider) {
	
	  /**
	   * @ngdoc method
	   * @name  $touchProvider#ngClickOverrideEnabled
	   *
	   * @param {boolean=} enabled update the ngClickOverrideEnabled state if provided, otherwise just return the
	   * current ngClickOverrideEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable {@link ngTouch.ngClick ngTouch's ngClick directive}. If enabled,
	   * the default ngClick directive will be replaced by a version that eliminates the 300ms delay for
	   * click events on browser for touch-devices.
	   *
	   * The default is `false`.
	   *
	   */
	  var ngClickOverrideEnabled = false;
	  var ngClickDirectiveAdded = false;
	  this.ngClickOverrideEnabled = function(enabled) {
	    if (angular.isDefined(enabled)) {
	
	      if (enabled && !ngClickDirectiveAdded) {
	        ngClickDirectiveAdded = true;
	
	        // Use this to identify the correct directive in the delegate
	        ngTouchClickDirectiveFactory.$$moduleName = 'ngTouch';
	        $compileProvider.directive('ngClick', ngTouchClickDirectiveFactory);
	
	        $provide.decorator('ngClickDirective', ['$delegate', function($delegate) {
	          if (ngClickOverrideEnabled) {
	            // drop the default ngClick directive
	            $delegate.shift();
	          } else {
	            // drop the ngTouch ngClick directive if the override has been re-disabled (because
	            // we cannot de-register added directives)
	            var i = $delegate.length - 1;
	            while (i >= 0) {
	              if ($delegate[i].$$moduleName === 'ngTouch') {
	                $delegate.splice(i, 1);
	                break;
	              }
	              i--;
	            }
	          }
	
	          return $delegate;
	        }]);
	      }
	
	      ngClickOverrideEnabled = enabled;
	      return this;
	    }
	
	    return ngClickOverrideEnabled;
	  };
	
	  /**
	  * @ngdoc service
	  * @name $touch
	  * @kind object
	  *
	  * @description
	  * Provides the {@link ngTouch.$touch#ngClickOverrideEnabled `ngClickOverrideEnabled`} method.
	  *
	  */
	  this.$get = function() {
	    return {
	      /**
	       * @ngdoc method
	       * @name  $touch#ngClickOverrideEnabled
	       *
	       * @returns {*} current value of `ngClickOverrideEnabled` set in the {@link ngTouch.$touchProvider $touchProvider},
	       * i.e. if {@link ngTouch.ngClick ngTouch's ngClick} directive is enabled.
	       *
	       * @kind function
	       */
	      ngClickOverrideEnabled: function() {
	        return ngClickOverrideEnabled;
	      }
	    };
	  };
	
	}
	
	/* global ngTouch: false */
	
	    /**
	     * @ngdoc service
	     * @name $swipe
	     *
	     * @description
	     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
	     * behavior, to make implementing swipe-related directives more convenient.
	     *
	     * Requires the {@link ngTouch `ngTouch`} module to be installed.
	     *
	     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
	     *
	     * # Usage
	     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
	     * which is to be watched for swipes, and an object with four handler functions. See the
	     * documentation for `bind` below.
	     */
	
	ngTouch.factory('$swipe', [function() {
	  // The total distance in any direction before we make the call on swipe vs. scroll.
	  var MOVE_BUFFER_RADIUS = 10;
	
	  var POINTER_EVENTS = {
	    'mouse': {
	      start: 'mousedown',
	      move: 'mousemove',
	      end: 'mouseup'
	    },
	    'touch': {
	      start: 'touchstart',
	      move: 'touchmove',
	      end: 'touchend',
	      cancel: 'touchcancel'
	    },
	    'pointer': {
	      start: 'pointerdown',
	      move: 'pointermove',
	      end: 'pointerup',
	      cancel: 'pointercancel'
	    }
	  };
	
	  function getCoordinates(event) {
	    var originalEvent = event.originalEvent || event;
	    var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
	    var e = (originalEvent.changedTouches && originalEvent.changedTouches[0]) || touches[0];
	
	    return {
	      x: e.clientX,
	      y: e.clientY
	    };
	  }
	
	  function getEvents(pointerTypes, eventType) {
	    var res = [];
	    angular.forEach(pointerTypes, function(pointerType) {
	      var eventName = POINTER_EVENTS[pointerType][eventType];
	      if (eventName) {
	        res.push(eventName);
	      }
	    });
	    return res.join(' ');
	  }
	
	  return {
	    /**
	     * @ngdoc method
	     * @name $swipe#bind
	     *
	     * @description
	     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
	     * object containing event handlers.
	     * The pointer types that should be used can be specified via the optional
	     * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
	     * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
	     *
	     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
	     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
	     * `event`. `cancel` receives the raw `event` as its single parameter.
	     *
	     * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
	     * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
	     * distance moved in either dimension exceeds a small threshold.
	     *
	     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
	     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
	     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
	     *   A `cancel` event is sent.
	     *
	     * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
	     * a swipe is in progress.
	     *
	     * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
	     *
	     * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
	     * as described above.
	     *
	     */
	    bind: function(element, eventHandlers, pointerTypes) {
	      // Absolute total movement, used to control swipe vs. scroll.
	      var totalX, totalY;
	      // Coordinates of the start position.
	      var startCoords;
	      // Last event's position.
	      var lastPos;
	      // Whether a swipe is active.
	      var active = false;
	
	      pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
	      element.on(getEvents(pointerTypes, 'start'), function(event) {
	        startCoords = getCoordinates(event);
	        active = true;
	        totalX = 0;
	        totalY = 0;
	        lastPos = startCoords;
	        eventHandlers['start'] && eventHandlers['start'](startCoords, event);
	      });
	      var events = getEvents(pointerTypes, 'cancel');
	      if (events) {
	        element.on(events, function(event) {
	          active = false;
	          eventHandlers['cancel'] && eventHandlers['cancel'](event);
	        });
	      }
	
	      element.on(getEvents(pointerTypes, 'move'), function(event) {
	        if (!active) return;
	
	        // Android will send a touchcancel if it thinks we're starting to scroll.
	        // So when the total distance (+ or - or both) exceeds 10px in either direction,
	        // we either:
	        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
	        // - On totalY > totalX, we let the browser handle it as a scroll.
	
	        if (!startCoords) return;
	        var coords = getCoordinates(event);
	
	        totalX += Math.abs(coords.x - lastPos.x);
	        totalY += Math.abs(coords.y - lastPos.y);
	
	        lastPos = coords;
	
	        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
	          return;
	        }
	
	        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
	        if (totalY > totalX) {
	          // Allow native scrolling to take over.
	          active = false;
	          eventHandlers['cancel'] && eventHandlers['cancel'](event);
	          return;
	        } else {
	          // Prevent the browser from scrolling.
	          event.preventDefault();
	          eventHandlers['move'] && eventHandlers['move'](coords, event);
	        }
	      });
	
	      element.on(getEvents(pointerTypes, 'end'), function(event) {
	        if (!active) return;
	        active = false;
	        eventHandlers['end'] && eventHandlers['end'](getCoordinates(event), event);
	      });
	    }
	  };
	}]);
	
	/* global ngTouch: false,
	  nodeName_: false
	*/
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @deprecated
	 *
	 * @description
	 * <div class="alert alert-danger">
	 * **DEPRECATION NOTICE**: Beginning with Angular 1.5, this directive is deprecated and by default **disabled**.
	 * The directive will receive no further support and might be removed from future releases.
	 * If you need the directive, you can enable it with the {@link ngTouch.$touchProvider $touchProvider#ngClickOverrideEnabled}
	 * function. We also recommend that you migrate to [FastClick](https://github.com/ftlabs/fastclick).
	 * To learn more about the 300ms delay, this [Telerik article](http://developer.telerik.com/featured/300-ms-click-delay-ios-8/)
	 * gives a good overview.
	 * </div>
	 * A more powerful replacement for the default ngClick designed to be used on touchscreen
	 * devices. Most mobile browsers wait about 300ms after a tap-and-release before sending
	 * the click event. This version handles them immediately, and then prevents the
	 * following click event from propagating.
	 *
	 * Requires the {@link ngTouch `ngTouch`} module to be installed.
	 *
	 * This directive can fall back to using an ordinary click event, and so works on desktop
	 * browsers as well as mobile.
	 *
	 * This directive also sets the CSS class `ng-click-active` while the element is being held
	 * down (by a mouse click or touch) so you can restyle the depressed element if you wish.
	 *
	 * @element ANY
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate
	 * upon tap. (Event object is available as `$event`)
	 *
	 * @example
	    <example module="ngClickExample" deps="angular-touch.js">
	      <file name="index.html">
	        <button ng-click="count = count + 1" ng-init="count=0">
	          Increment
	        </button>
	        count: {{ count }}
	      </file>
	      <file name="script.js">
	        angular.module('ngClickExample', ['ngTouch']);
	      </file>
	    </example>
	 */
	
	var ngTouchClickDirectiveFactory = ['$parse', '$timeout', '$rootElement',
	    function($parse, $timeout, $rootElement) {
	  var TAP_DURATION = 750; // Shorter than 750ms is a tap, longer is a taphold or drag.
	  var MOVE_TOLERANCE = 12; // 12px seems to work in most mobile browsers.
	  var PREVENT_DURATION = 2500; // 2.5 seconds maximum from preventGhostClick call to click
	  var CLICKBUSTER_THRESHOLD = 25; // 25 pixels in any dimension is the limit for busting clicks.
	
	  var ACTIVE_CLASS_NAME = 'ng-click-active';
	  var lastPreventedTime;
	  var touchCoordinates;
	  var lastLabelClickCoordinates;
	
	
	  // TAP EVENTS AND GHOST CLICKS
	  //
	  // Why tap events?
	  // Mobile browsers detect a tap, then wait a moment (usually ~300ms) to see if you're
	  // double-tapping, and then fire a click event.
	  //
	  // This delay sucks and makes mobile apps feel unresponsive.
	  // So we detect touchstart, touchcancel and touchend ourselves and determine when
	  // the user has tapped on something.
	  //
	  // What happens when the browser then generates a click event?
	  // The browser, of course, also detects the tap and fires a click after a delay. This results in
	  // tapping/clicking twice. We do "clickbusting" to prevent it.
	  //
	  // How does it work?
	  // We attach global touchstart and click handlers, that run during the capture (early) phase.
	  // So the sequence for a tap is:
	  // - global touchstart: Sets an "allowable region" at the point touched.
	  // - element's touchstart: Starts a touch
	  // (- touchcancel ends the touch, no click follows)
	  // - element's touchend: Determines if the tap is valid (didn't move too far away, didn't hold
	  //   too long) and fires the user's tap handler. The touchend also calls preventGhostClick().
	  // - preventGhostClick() removes the allowable region the global touchstart created.
	  // - The browser generates a click event.
	  // - The global click handler catches the click, and checks whether it was in an allowable region.
	  //     - If preventGhostClick was called, the region will have been removed, the click is busted.
	  //     - If the region is still there, the click proceeds normally. Therefore clicks on links and
	  //       other elements without ngTap on them work normally.
	  //
	  // This is an ugly, terrible hack!
	  // Yeah, tell me about it. The alternatives are using the slow click events, or making our users
	  // deal with the ghost clicks, so I consider this the least of evils. Fortunately Angular
	  // encapsulates this ugly logic away from the user.
	  //
	  // Why not just put click handlers on the element?
	  // We do that too, just to be sure. If the tap event caused the DOM to change,
	  // it is possible another element is now in that position. To take account for these possibly
	  // distinct elements, the handlers are global and care only about coordinates.
	
	  // Checks if the coordinates are close enough to be within the region.
	  function hit(x1, y1, x2, y2) {
	    return Math.abs(x1 - x2) < CLICKBUSTER_THRESHOLD && Math.abs(y1 - y2) < CLICKBUSTER_THRESHOLD;
	  }
	
	  // Checks a list of allowable regions against a click location.
	  // Returns true if the click should be allowed.
	  // Splices out the allowable region from the list after it has been used.
	  function checkAllowableRegions(touchCoordinates, x, y) {
	    for (var i = 0; i < touchCoordinates.length; i += 2) {
	      if (hit(touchCoordinates[i], touchCoordinates[i + 1], x, y)) {
	        touchCoordinates.splice(i, i + 2);
	        return true; // allowable region
	      }
	    }
	    return false; // No allowable region; bust it.
	  }
	
	  // Global click handler that prevents the click if it's in a bustable zone and preventGhostClick
	  // was called recently.
	  function onClick(event) {
	    if (Date.now() - lastPreventedTime > PREVENT_DURATION) {
	      return; // Too old.
	    }
	
	    var touches = event.touches && event.touches.length ? event.touches : [event];
	    var x = touches[0].clientX;
	    var y = touches[0].clientY;
	    // Work around desktop Webkit quirk where clicking a label will fire two clicks (on the label
	    // and on the input element). Depending on the exact browser, this second click we don't want
	    // to bust has either (0,0), negative coordinates, or coordinates equal to triggering label
	    // click event
	    if (x < 1 && y < 1) {
	      return; // offscreen
	    }
	    if (lastLabelClickCoordinates &&
	        lastLabelClickCoordinates[0] === x && lastLabelClickCoordinates[1] === y) {
	      return; // input click triggered by label click
	    }
	    // reset label click coordinates on first subsequent click
	    if (lastLabelClickCoordinates) {
	      lastLabelClickCoordinates = null;
	    }
	    // remember label click coordinates to prevent click busting of trigger click event on input
	    if (nodeName_(event.target) === 'label') {
	      lastLabelClickCoordinates = [x, y];
	    }
	
	    // Look for an allowable region containing this click.
	    // If we find one, that means it was created by touchstart and not removed by
	    // preventGhostClick, so we don't bust it.
	    if (checkAllowableRegions(touchCoordinates, x, y)) {
	      return;
	    }
	
	    // If we didn't find an allowable region, bust the click.
	    event.stopPropagation();
	    event.preventDefault();
	
	    // Blur focused form elements
	    event.target && event.target.blur && event.target.blur();
	  }
	
	
	  // Global touchstart handler that creates an allowable region for a click event.
	  // This allowable region can be removed by preventGhostClick if we want to bust it.
	  function onTouchStart(event) {
	    var touches = event.touches && event.touches.length ? event.touches : [event];
	    var x = touches[0].clientX;
	    var y = touches[0].clientY;
	    touchCoordinates.push(x, y);
	
	    $timeout(function() {
	      // Remove the allowable region.
	      for (var i = 0; i < touchCoordinates.length; i += 2) {
	        if (touchCoordinates[i] == x && touchCoordinates[i + 1] == y) {
	          touchCoordinates.splice(i, i + 2);
	          return;
	        }
	      }
	    }, PREVENT_DURATION, false);
	  }
	
	  // On the first call, attaches some event handlers. Then whenever it gets called, it creates a
	  // zone around the touchstart where clicks will get busted.
	  function preventGhostClick(x, y) {
	    if (!touchCoordinates) {
	      $rootElement[0].addEventListener('click', onClick, true);
	      $rootElement[0].addEventListener('touchstart', onTouchStart, true);
	      touchCoordinates = [];
	    }
	
	    lastPreventedTime = Date.now();
	
	    checkAllowableRegions(touchCoordinates, x, y);
	  }
	
	  // Actual linking function.
	  return function(scope, element, attr) {
	    var clickHandler = $parse(attr.ngClick),
	        tapping = false,
	        tapElement,  // Used to blur the element after a tap.
	        startTime,   // Used to check if the tap was held too long.
	        touchStartX,
	        touchStartY;
	
	    function resetState() {
	      tapping = false;
	      element.removeClass(ACTIVE_CLASS_NAME);
	    }
	
	    element.on('touchstart', function(event) {
	      tapping = true;
	      tapElement = event.target ? event.target : event.srcElement; // IE uses srcElement.
	      // Hack for Safari, which can target text nodes instead of containers.
	      if (tapElement.nodeType == 3) {
	        tapElement = tapElement.parentNode;
	      }
	
	      element.addClass(ACTIVE_CLASS_NAME);
	
	      startTime = Date.now();
	
	      // Use jQuery originalEvent
	      var originalEvent = event.originalEvent || event;
	      var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
	      var e = touches[0];
	      touchStartX = e.clientX;
	      touchStartY = e.clientY;
	    });
	
	    element.on('touchcancel', function(event) {
	      resetState();
	    });
	
	    element.on('touchend', function(event) {
	      var diff = Date.now() - startTime;
	
	      // Use jQuery originalEvent
	      var originalEvent = event.originalEvent || event;
	      var touches = (originalEvent.changedTouches && originalEvent.changedTouches.length) ?
	          originalEvent.changedTouches :
	          ((originalEvent.touches && originalEvent.touches.length) ? originalEvent.touches : [originalEvent]);
	      var e = touches[0];
	      var x = e.clientX;
	      var y = e.clientY;
	      var dist = Math.sqrt(Math.pow(x - touchStartX, 2) + Math.pow(y - touchStartY, 2));
	
	      if (tapping && diff < TAP_DURATION && dist < MOVE_TOLERANCE) {
	        // Call preventGhostClick so the clickbuster will catch the corresponding click.
	        preventGhostClick(x, y);
	
	        // Blur the focused element (the button, probably) before firing the callback.
	        // This doesn't work perfectly on Android Chrome, but seems to work elsewhere.
	        // I couldn't get anything to work reliably on Android Chrome.
	        if (tapElement) {
	          tapElement.blur();
	        }
	
	        if (!angular.isDefined(attr.disabled) || attr.disabled === false) {
	          element.triggerHandler('click', [event]);
	        }
	      }
	
	      resetState();
	    });
	
	    // Hack for iOS Safari's benefit. It goes searching for onclick handlers and is liable to click
	    // something else nearby.
	    element.onclick = function(event) { };
	
	    // Actual click handler.
	    // There are three different kinds of clicks, only two of which reach this point.
	    // - On desktop browsers without touch events, their clicks will always come here.
	    // - On mobile browsers, the simulated "fast" click will call this.
	    // - But the browser's follow-up slow click will be "busted" before it reaches this handler.
	    // Therefore it's safe to use this directive on both mobile and desktop.
	    element.on('click', function(event, touchend) {
	      scope.$apply(function() {
	        clickHandler(scope, {$event: (touchend || event)});
	      });
	    });
	
	    element.on('mousedown', function(event) {
	      element.addClass(ACTIVE_CLASS_NAME);
	    });
	
	    element.on('mousemove mouseup', function(event) {
	      element.removeClass(ACTIVE_CLASS_NAME);
	    });
	
	  };
	}];
	
	/* global ngTouch: false */
	
	/**
	 * @ngdoc directive
	 * @name ngSwipeLeft
	 *
	 * @description
	 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
	 * A leftward swipe is a quick, right-to-left slide of the finger.
	 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
	 * too.
	 *
	 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
	 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
	 *
	 * Requires the {@link ngTouch `ngTouch`} module to be installed.
	 *
	 * @element ANY
	 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
	 * upon left swipe. (Event object is available as `$event`)
	 *
	 * @example
	    <example module="ngSwipeLeftExample" deps="angular-touch.js">
	      <file name="index.html">
	        <div ng-show="!showActions" ng-swipe-left="showActions = true">
	          Some list content, like an email in the inbox
	        </div>
	        <div ng-show="showActions" ng-swipe-right="showActions = false">
	          <button ng-click="reply()">Reply</button>
	          <button ng-click="delete()">Delete</button>
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngSwipeLeftExample', ['ngTouch']);
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSwipeRight
	 *
	 * @description
	 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
	 * A rightward swipe is a quick, left-to-right slide of the finger.
	 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
	 * too.
	 *
	 * Requires the {@link ngTouch `ngTouch`} module to be installed.
	 *
	 * @element ANY
	 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
	 * upon right swipe. (Event object is available as `$event`)
	 *
	 * @example
	    <example module="ngSwipeRightExample" deps="angular-touch.js">
	      <file name="index.html">
	        <div ng-show="!showActions" ng-swipe-left="showActions = true">
	          Some list content, like an email in the inbox
	        </div>
	        <div ng-show="showActions" ng-swipe-right="showActions = false">
	          <button ng-click="reply()">Reply</button>
	          <button ng-click="delete()">Delete</button>
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngSwipeRightExample', ['ngTouch']);
	      </file>
	    </example>
	 */
	
	function makeSwipeDirective(directiveName, direction, eventName) {
	  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
	    // The maximum vertical delta for a swipe should be less than 75px.
	    var MAX_VERTICAL_DISTANCE = 75;
	    // Vertical distance should not be more than a fraction of the horizontal distance.
	    var MAX_VERTICAL_RATIO = 0.3;
	    // At least a 30px lateral motion is necessary for a swipe.
	    var MIN_HORIZONTAL_DISTANCE = 30;
	
	    return function(scope, element, attr) {
	      var swipeHandler = $parse(attr[directiveName]);
	
	      var startCoords, valid;
	
	      function validSwipe(coords) {
	        // Check that it's within the coordinates.
	        // Absolute vertical distance must be within tolerances.
	        // Horizontal distance, we take the current X - the starting X.
	        // This is negative for leftward swipes and positive for rightward swipes.
	        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
	        // (ie. same direction as the directive wants) will have a positive delta and
	        // illegal ones a negative delta.
	        // Therefore this delta must be positive, and larger than the minimum.
	        if (!startCoords) return false;
	        var deltaY = Math.abs(coords.y - startCoords.y);
	        var deltaX = (coords.x - startCoords.x) * direction;
	        return valid && // Short circuit for already-invalidated swipes.
	            deltaY < MAX_VERTICAL_DISTANCE &&
	            deltaX > 0 &&
	            deltaX > MIN_HORIZONTAL_DISTANCE &&
	            deltaY / deltaX < MAX_VERTICAL_RATIO;
	      }
	
	      var pointerTypes = ['touch'];
	      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
	        pointerTypes.push('mouse');
	      }
	      $swipe.bind(element, {
	        'start': function(coords, event) {
	          startCoords = coords;
	          valid = true;
	        },
	        'cancel': function(event) {
	          valid = false;
	        },
	        'end': function(coords, event) {
	          if (validSwipe(coords)) {
	            scope.$apply(function() {
	              element.triggerHandler(eventName);
	              swipeHandler(scope, {$event: event});
	            });
	          }
	        }
	      }, pointerTypes);
	    };
	  }]);
	}
	
	// Left is negative X-coordinate, right is positive.
	makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
	makeSwipeDirective('ngSwipeRight', 1, 'swiperight');
	
	
	
	})(window, window.angular);


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(613);
	module.exports = 'ngTouch';


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	$translateMissingTranslationHandlerLog.$inject = ['$log'];
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateMissingTranslationHandlerLog
	 * @requires $log
	 *
	 * @description
	 * Uses angular's `$log` service to give a warning when trying to translate a
	 * translation id which doesn't exist.
	 *
	 * @returns {function} Handler function
	 */
	.factory('$translateMissingTranslationHandlerLog', $translateMissingTranslationHandlerLog);
	
	function $translateMissingTranslationHandlerLog ($log) {
	
	  'use strict';
	
	  return function (translationId) {
	    $log.warn('Translation for ' + translationId + ' doesn\'t exist');
	  };
	}
	
	$translateMissingTranslationHandlerLog.displayName = '$translateMissingTranslationHandlerLog';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1124)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
	      return (factory(a0));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("messageformat"));
	  } else {
	    factory(root["MessageFormat"]);
	  }
	}(this, function (MessageFormat) {
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc property
	 * @name pascalprecht.translate.TRANSLATE_MF_INTERPOLATION_CACHE
	 * @requires TRANSLATE_MF_INTERPOLATION_CACHE
	 *
	 * @description
	 * Uses MessageFormat.js to interpolate strings against some values.
	 */
	.constant('TRANSLATE_MF_INTERPOLATION_CACHE', '$translateMessageFormatInterpolation')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateMessageFormatInterpolationProvider
	 *
	 * @description
	 * Configurations for $translateMessageFormatInterpolation
	 */
	.provider('$translateMessageFormatInterpolation', $translateMessageFormatInterpolationProvider);
	
	function $translateMessageFormatInterpolationProvider() {
	
	  'use strict';
	
	  var configurer;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateMessageFormatInterpolationProvider#messageFormatConfigurer
	   * @methodOf pascalprecht.translate.$translateMessageFormatInterpolationProvider
	   *
	   * @description
	   * Defines an optional configurer for the MessageFormat instance.
	   *
	   * Note: This hook will be called whenever a new instance of MessageFormat will be created.
	   *
	   * @param {function} fn callback with the instance as argument
	   */
	  this.messageFormatConfigurer = function (fn) {
	    configurer = fn;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateMessageFormatInterpolation
	   * @requires pascalprecht.translate.TRANSLATE_MF_INTERPOLATION_CACHE
	   *
	   * @description
	   * Uses MessageFormat.js to interpolate strings against some values.
	   *
	   * Be aware to configure a proper sanitization strategy.
	   *
	   * See also:
	   * * {@link pascalprecht.translate.$translateSanitization}
	   * * {@link https://github.com/SlexAxton/messageformat.js}
	   *
	   * @return {object} $translateMessageFormatInterpolation Interpolator service
	   */
	  this.$get = ['$translateSanitization', '$cacheFactory', 'TRANSLATE_MF_INTERPOLATION_CACHE', function ($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE) {
	    return $translateMessageFormatInterpolation($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE, configurer);
	  }];
	
	}
	
	function $translateMessageFormatInterpolation($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE, messageFormatConfigurer) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $cache = $cacheFactory.get(TRANSLATE_MF_INTERPOLATION_CACHE),
	      // instantiate with default locale (which is 'en')
	      $mf = new MessageFormat('en'),
	      $identifier = 'messageformat';
	
	  if (angular.isFunction(messageFormatConfigurer)) {
	    messageFormatConfigurer($mf);
	  }
	
	  if (!$cache) {
	    // create cache if it doesn't exist already
	    $cache = $cacheFactory(TRANSLATE_MF_INTERPOLATION_CACHE);
	  }
	
	  $cache.put('en', $mf);
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateMessageFormatInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateMessageFormatInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $mf = $cache.get(locale);
	    if (!$mf) {
	      $mf = new MessageFormat(locale);
	      if (angular.isFunction(messageFormatConfigurer)) {
	        messageFormatConfigurer($mf);
	      }
	      $cache.put(locale, $mf);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateMessageFormatInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateMessageFormatInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateMessageFormatInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateMessageFormatInterpolation
	   *
	   * @description
	   * Interpolates given string against given interpolate params using MessageFormat.js.
	   *
	   * @returns {string} interpolated string.
	   */
	  $translateInterpolator.interpolate = function (string, interpolationParams, context, sanitizeStrategy) {
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy);
	
	    var compiledFunction = $cache.get('mf:' + string);
	
	    // if given string wasn't compiled yet, we do so now and never have to do it again
	    if (!compiledFunction) {
	
	      // Ensure explicit type if possible
	      // MessageFormat checks the actual type (i.e. for amount based conditions)
	      for (var key in interpolationParams) {
	        if (interpolationParams.hasOwnProperty(key)) {
	          // ensure number
	          var number = parseInt(interpolationParams[key], 10);
	          if (angular.isNumber(number) && ('' + number) === interpolationParams[key]) {
	            interpolationParams[key] = number;
	          }
	        }
	      }
	
	      compiledFunction = $mf.compile(string);
	      $cache.put('mf:' + string, compiledFunction);
	    }
	
	    var interpolatedText = compiledFunction(interpolationParams);
	    return $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy);
	  };
	
	  return $translateInterpolator;
	}
	
	$translateMessageFormatInterpolation.displayName = '$translateMessageFormatInterpolation';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	$translateStaticFilesLoader.$inject = ['$q', '$http'];
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateStaticFilesLoader
	 * @requires $q
	 * @requires $http
	 *
	 * @description
	 * Creates a loading function for a typical static file url pattern:
	 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
	 * the response of these urls must be an object of key-value pairs.
	 *
	 * @param {object} options Options object, which gets prefix, suffix, key, and fileMap
	 */
	.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);
	
	function $translateStaticFilesLoader($q, $http) {
	
	  'use strict';
	
	  return function (options) {
	
	    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
	      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
	    }
	
	    if (!options.files) {
	      options.files = [{
	        prefix: options.prefix,
	        suffix: options.suffix
	      }];
	    }
	
	    var load = function (file) {
	      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
	        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
	      }
	
	      var fileUrl = [
	        file.prefix,
	        options.key,
	        file.suffix
	      ].join('');
	
	      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
	        fileUrl = options.fileMap[fileUrl];
	      }
	
	      return $http(angular.extend({
	        url: fileUrl,
	        method: 'GET'
	      }, options.$http))
	        .then(function(result) {
	          return result.data;
	        }, function () {
	          return $q.reject(options.key);
	        });
	    };
	
	    var promises = [],
	        length = options.files.length;
	
	    for (var i = 0; i < length; i++) {
	      promises.push(load({
	        prefix: options.files[i].prefix,
	        key: options.key,
	        suffix: options.files[i].suffix
	      }));
	    }
	
	    return $q.all(promises)
	      .then(function (data) {
	        var length = data.length,
	            mergedData = {};
	
	        for (var i = 0; i < length; i++) {
	          for (var key in data[i]) {
	            mergedData[key] = data[i][key];
	          }
	        }
	
	        return mergedData;
	      });
	  };
	}
	
	$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	$translateCookieStorageFactory.$inject = ['$injector'];
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateCookieStorage
	 * @requires $cookieStore
	 *
	 * @description
	 * Abstraction layer for cookieStore. This service is used when telling angular-translate
	 * to use cookieStore as storage.
	 *
	 */
	  .factory('$translateCookieStorage', $translateCookieStorageFactory);
	
	function $translateCookieStorageFactory($injector) {
	
	  'use strict';
	
	  // Since AngularJS 1.4, $cookieStore is deprecated
	  var delegate;
	  if (angular.version.major === 1 && angular.version.minor >= 4) {
	    var $cookies = $injector.get('$cookies');
	    delegate = {
	      get : function (key) {
	        return $cookies.get(key);
	      },
	      put : function (key, value) {
	        $cookies.put(key, value);
	      }
	    };
	  } else {
	    var $cookieStore = $injector.get('$cookieStore');
	    delegate = {
	      get : function (key) {
	        return $cookieStore.get(key);
	      },
	      put : function (key, value) {
	        $cookieStore.put(key, value);
	      }
	    };
	  }
	
	  var $translateCookieStorage = {
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateCookieStorage#get
	     * @methodOf pascalprecht.translate.$translateCookieStorage
	     *
	     * @description
	     * Returns an item from cookieStorage by given name.
	     *
	     * @param {string} name Item name
	     * @return {string} Value of item name
	     */
	    get : function (name) {
	      return delegate.get(name);
	    },
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateCookieStorage#set
	     * @methodOf pascalprecht.translate.$translateCookieStorage
	     *
	     * @description
	     * Sets an item in cookieStorage by given name.
	     *
	     * @deprecated use #put
	     *
	     * @param {string} name Item name
	     * @param {string} value Item value
	     */
	    set : function (name, value) {
	      delegate.put(name, value);
	    },
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateCookieStorage#put
	     * @methodOf pascalprecht.translate.$translateCookieStorage
	     *
	     * @description
	     * Sets an item in cookieStorage by given name.
	     *
	     * @param {string} name Item name
	     * @param {string} value Item value
	     */
	    put : function (name, value) {
	      delegate.put(name, value);
	    }
	  };
	
	  return $translateCookieStorage;
	}
	
	$translateCookieStorageFactory.displayName = '$translateCookieStorage';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	$translateLocalStorageFactory.$inject = ['$window', '$translateCookieStorage'];
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateLocalStorage
	 * @requires $window
	 * @requires $translateCookieStorage
	 *
	 * @description
	 * Abstraction layer for localStorage. This service is used when telling angular-translate
	 * to use localStorage as storage.
	 *
	 */
	.factory('$translateLocalStorage', $translateLocalStorageFactory);
	
	function $translateLocalStorageFactory($window, $translateCookieStorage) {
	
	  'use strict';
	
	  // Setup adapter
	  var localStorageAdapter = (function(){
	    var langKey;
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateLocalStorage#get
	       * @methodOf pascalprecht.translate.$translateLocalStorage
	       *
	       * @description
	       * Returns an item from localStorage by given name.
	       *
	       * @param {string} name Item name
	       * @return {string} Value of item name
	       */
	      get: function (name) {
	        if(!langKey) {
	          langKey = $window.localStorage.getItem(name);
	        }
	
	        return langKey;
	      },
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateLocalStorage#set
	       * @methodOf pascalprecht.translate.$translateLocalStorage
	       *
	       * @description
	       * Sets an item in localStorage by given name.
	       *
	       * @deprecated use #put
	       *
	       * @param {string} name Item name
	       * @param {string} value Item value
	       */
	      set: function (name, value) {
	        langKey=value;
	        $window.localStorage.setItem(name, value);
	      },
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateLocalStorage#put
	       * @methodOf pascalprecht.translate.$translateLocalStorage
	       *
	       * @description
	       * Sets an item in localStorage by given name.
	       *
	       * @param {string} name Item name
	       * @param {string} value Item value
	       */
	      put: function (name, value) {
	        langKey=value;
	        $window.localStorage.setItem(name, value);
	      }
	    };
	  }());
	
	  var hasLocalStorageSupport = 'localStorage' in $window;
	  if (hasLocalStorageSupport) {
	    var testKey = 'pascalprecht.translate.storageTest';
	    try {
	      // this check have to be wrapped within a try/catch because on
	      // a SecurityError: Dom Exception 18 on iOS
	      if ($window.localStorage !== null) {
	        $window.localStorage.setItem(testKey, 'foo');
	        $window.localStorage.removeItem(testKey);
	        hasLocalStorageSupport = true;
	      } else {
	        hasLocalStorageSupport = false;
	      }
	    } catch (e){
	      hasLocalStorageSupport = false;
	    }
	  }
	  var $translateLocalStorage = hasLocalStorageSupport ? localStorageAdapter : $translateCookieStorage;
	  return $translateLocalStorage;
	}
	
	$translateLocalStorageFactory.displayName = '$translateLocalStorageFactory';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	runTranslate.$inject = ['$translate'];
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	translateAttrDirective.$inject = ['$translate', '$rootScope'];
	translateCloakDirective.$inject = ['$translate', '$rootScope'];
	translateFilterFactory.$inject = ['$parse', '$translate'];
	$translationCache.$inject = ['$cacheFactory'];
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      $sce,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    },
	    sce: function (value, mode, context) {
	      if (mode === 'text') {
	        value = htmlTrustValue(value);
	      } else if (mode === 'params') {
	        if (context !== 'filter') {
	          // do html escape in filter context #1101
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	      }
	      return value;
	    },
	    sceParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlTrustValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, context, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode, context);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode, context);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	    if ($injector.has('$sce')) {
	      $sce = $injector.get('$sce');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy, context) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (!strategy && strategy !== null) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        if (!context) {
	          context = 'service';
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, context, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var htmlTrustValue = function (value) {
	    if (!$sce) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	    }
	    return $sce.trustAsHtml(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee, stack) {
	    if (angular.isDate(value)) {
	      return value;
	    } else if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      if (!stack) {
	        stack = [];
	      } else {
	        if (stack.indexOf(value) > -1) {
	          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	        }
	      }
	
	      stack.push(value);
	      angular.forEach(value, function (propertyValue, propertyKey) {
	
	        /* Skipping function properties. */
	        if (angular.isFunction(propertyValue)) {
	          return;
	        }
	
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	      });
	      stack.splice(-1, 1); // remove last
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else if (value === true || value === false) {
	      return value;
	    } else if (!angular.isUndefined(value) && value !== null) {
	      return iteratee(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	  .constant('pascalprechtTranslateOverrider', {})
	  .provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	    $preferredLanguage,
	    $availableLanguageKeys = [],
	    $languageKeyAliases,
	    $fallbackLanguage,
	    $fallbackWasString,
	    $uses,
	    $nextLang,
	    $storageFactory,
	    $storageKey = $STORAGE_KEY,
	    $storagePrefix,
	    $missingTranslationHandlerFactory,
	    $interpolationFactory,
	    $interpolatorFactories = [],
	    $loaderFactory,
	    $cloakClassName = 'translate-cloak',
	    $loaderOptions,
	    $notFoundIndicatorLeft,
	    $notFoundIndicatorRight,
	    $postCompilingEnabled = false,
	    $forceAsyncReloadEnabled = false,
	    $nestedObjectDelimeter = '.',
	    $isReady = false,
	    $keepContent = false,
	    loaderCache,
	    directivePriority = 0,
	    statefulFilter = true,
	    postProcessFn,
	    uniformLanguageTagResolver = 'default',
	    languageTagResolver = {
	      'default' : function (tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java : function (tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	      },
	      bcp47 : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1: // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2: // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) { // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else { // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3: // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1' : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	  var version = '2.18.1';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	      i,
	      language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function (array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function () {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  var negotiateLocale = function (preferred) {
	    if (!preferred) {
	      return;
	    }
	
	    var avail = [],
	      locale = lowercase(preferred),
	      i = 0,
	      n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(lowercase($availableLanguageKeys[i]));
	    }
	
	    // Check for an exact match in our list of available keys
	    i = indexOf(avail, locale);
	    if (i > -1) {
	      return $availableLanguageKeys[i];
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	          var hasWildcardKey = false;
	          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	            lowercase(langKeyAlias) === lowercase(preferred);
	
	          if (langKeyAlias.slice(-1) === '*') {
	            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	          }
	          if (hasExactKey || hasWildcardKey) {
	            alias = $languageKeyAliases[langKeyAlias];
	            if (indexOf(avail, lowercase(alias)) > -1) {
	              return alias;
	            }
	          }
	        }
	      }
	    }
	
	    // Check for a language code without region
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, return undefined.
	    return;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if (path.length && key === prevKey) {
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function (langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [langKey];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */
	  this.resolveClientLocale = function () {
	    return getLocale();
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function (key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     EN => en
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *     sr-latn => sr-Latn
	   *     sr-latn-rs => sr-Latn-RS
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard : options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale) || locale;
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */
	  this.postProcess = function (fn) {
	    if (fn) {
	      postProcessFn = fn;
	    } else {
	      postProcessFn = undefined;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.keepContent = function (value) {
	    $keepContent = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} [interpolateParams={}] An object hash for dynamic values
	   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	   * @returns {object} promise
	   */
	  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	    var Storage,
	      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	      pendingLoader = false,
	      interpolatorHashMap = {},
	      langPromises = {},
	      fallbackIndex,
	      startFallbackIteration;
	
	    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	      if (!$uses && $preferredLanguage) {
	        $uses = $preferredLanguage;
	      }
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        // Inspired by Q.allSettled by Kris Kowal
	        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	        // This transforms all promises regardless resolved or rejected
	        var translateAll = function (translationIds) {
	          var results = {}; // storing the actual results
	          var promises = []; // promises to wait for
	          // Wraps the promise a) being always resolved and b) storing the link id->value
	          var translate = function (translationId) {
	            var deferred = $q.defer();
	            var regardless = function (value) {
	              results[translationId] = value;
	              deferred.resolve([translationId, value]);
	            };
	            // we don't care whether the promise was resolved or rejected; just store the values
	            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	            return deferred.promise;
	          };
	          for (var i = 0, c = translationIds.length; i < c; i++) {
	            promises.push(translate(translationIds[i]));
	          }
	          // wait for all (including storing to results)
	          return $q.all(promises).then(function () {
	            // return the results
	            return results;
	          });
	        };
	        return translateAll(translationId);
	      }
	
	      var deferred = $q.defer();
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var promiseToWaitFor = (function () {
	        var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	        fallbackIndex = 0;
	
	        if ($storageFactory && !promise) {
	          // looks like there's no pending promise for $preferredLanguage or
	          // $uses. Maybe there's one pending for a language that comes from
	          // storage.
	          var langKey = Storage.get($storageKey);
	          promise = langPromises[langKey];
	
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            var index = indexOf($fallbackLanguage, langKey);
	            // maybe the language from storage is also defined as fallback language
	            // we increase the fallback language index to not search in that language
	            // as fallback, since it's probably the first used language
	            // in that case the index starts after the first element
	            fallbackIndex = (index === 0) ? 1 : 0;
	
	            // but we can make sure to ALWAYS fallback to preferred language at least
	            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	              $fallbackLanguage.push($preferredLanguage);
	            }
	          }
	        }
	        return promise;
	      }());
	
	      if (!promiseToWaitFor) {
	        // no promise to wait for? okay. Then there's no loader registered
	        // nor is a one pending for language that comes from storage.
	        // We can just translate.
	        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	      } else {
	        var promiseResolved = function () {
	          // $uses may have changed while waiting
	          if (!forceLanguage) {
	            uses = $uses;
	          }
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        };
	        promiseResolved.displayName = 'promiseResolved';
	
	        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */
	    var applyNotFoundIndicators = function (translationId) {
	      // applying notFoundIndicators
	      if ($notFoundIndicatorLeft) {
	        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	      }
	      if ($notFoundIndicatorRight) {
	        translationId = [translationId, $notFoundIndicatorRight].join(' ');
	      }
	      return translationId;
	    };
	
	    /**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */
	    var useLanguage = function (key) {
	      $uses = key;
	
	      // make sure to store new language key before triggering success event
	      if ($storageFactory) {
	        Storage.put($translate.storageKey(), $uses);
	      }
	
	      $rootScope.$emit('$translateChangeSuccess', {language : key});
	
	      // inform default interpolator
	      defaultInterpolator.setLocale($uses);
	
	      var eachInterpolator = function (interpolator, id) {
	        interpolatorHashMap[id].setLocale($uses);
	      };
	      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	      // inform all others too!
	      angular.forEach(interpolatorHashMap, eachInterpolator);
	      $rootScope.$emit('$translateChangeEnd', {language : key});
	    };
	
	    /**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks off registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */
	    var loadAsync = function (key) {
	      if (!key) {
	        throw 'No language key specified for loading.';
	      }
	
	      var deferred = $q.defer();
	
	      $rootScope.$emit('$translateLoadingStart', {language : key});
	      pendingLoader = true;
	
	      var cache = loaderCache;
	      if (typeof(cache) === 'string') {
	        // getting on-demand instance of loader
	        cache = $injector.get(cache);
	      }
	
	      var loaderOptions = angular.extend({}, $loaderOptions, {
	        key : key,
	        $http : angular.extend({}, {
	          cache : cache
	        }, $loaderOptions.$http)
	      });
	
	      var onLoaderSuccess = function (data) {
	        var translationTable = {};
	        $rootScope.$emit('$translateLoadingSuccess', {language : key});
	
	        if (angular.isArray(data)) {
	          angular.forEach(data, function (table) {
	            angular.extend(translationTable, flatObject(table));
	          });
	        } else {
	          angular.extend(translationTable, flatObject(data));
	        }
	        pendingLoader = false;
	        deferred.resolve({
	          key : key,
	          table : translationTable
	        });
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	      var onLoaderError = function (key) {
	        $rootScope.$emit('$translateLoadingError', {language : key});
	        deferred.reject(key);
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderError.displayName = 'onLoaderError';
	
	      $injector.get($loaderFactory)(loaderOptions)
	        .then(onLoaderSuccess, onLoaderError);
	
	      return deferred.promise;
	    };
	
	    if ($storageFactory) {
	      Storage = $injector.get($storageFactory);
	
	      if (!Storage.get || !Storage.put) {
	        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	      }
	    }
	
	    // if we have additional interpolations that were added via
	    // $translateProvider.addInterpolation(), we have to map'em
	    if ($interpolatorFactories.length) {
	      var eachInterpolationFactory = function (interpolatorFactory) {
	        var interpolator = $injector.get(interpolatorFactory);
	        // setting initial locale for each interpolation service
	        interpolator.setLocale($preferredLanguage || $uses);
	        // make'em recognizable through id
	        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	      };
	      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	      angular.forEach($interpolatorFactories, eachInterpolationFactory);
	    }
	
	    /**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */
	    var getTranslationTable = function (langKey) {
	      var deferred = $q.defer();
	      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	        deferred.resolve($translationTable[langKey]);
	      } else if (langPromises[langKey]) {
	        var onResolve = function (data) {
	          translations(data.key, data.table);
	          deferred.resolve(data.table);
	        };
	        onResolve.displayName = 'translationTableResolver';
	        langPromises[langKey].then(onResolve, deferred.reject);
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {Q.promise}
	     */
	    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      var onResolve = function (translationTable) {
	        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          var translation = translationTable[translationId];
	          if (translation.substr(0, 2) === '@:') {
	            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	            deferred.resolve(interpolatedValue);
	
	          }
	          Interpolator.setLocale($uses);
	        } else {
	          deferred.reject();
	        }
	      };
	      onResolve.displayName = 'fallbackTranslationResolver';
	
	      getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */
	    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result, translationTable = $translationTable[langKey];
	
	      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	        Interpolator.setLocale(langKey);
	        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	        // workaround for TrustedValueHolderType
	        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	          var result2 = result.$$unwrapTrustedValue();
	          if (result2.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	        } else if (result.substr(0, 2) === '@:') {
	          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	        }
	        Interpolator.setLocale($uses);
	      }
	
	      return result;
	    };
	
	
	    /**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */
	    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	      // If we have a handler factory - we might also call it here to determine if it provides
	      // a default text for a translationid that can't be found anywhere in our tables
	      if ($missingTranslationHandlerFactory) {
	        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	      } else {
	        return translationId;
	      }
	    };
	
	    /**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */
	    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
	          function (data) {
	            deferred.resolve(data);
	          },
	          function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          }
	        );
	      } else {
	        // No translation found in any fallback language
	        // if a default translation text is set in the directive, then return this as a result
	        if (defaultTranslationText) {
	          deferred.resolve(defaultTranslationText);
	        } else {
	          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	          // if no default translation is set and an error handler is defined, send it to the handler
	          // and then return the result if it isn't undefined
	          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */
	    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result;
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        if (!result && result !== '') {
	          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	        }
	      }
	      return result;
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */
	    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {String} translation
	     */
	    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
	    };
	
	    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	      var deferred = $q.defer();
	
	      var table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	
	          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
	            .then(deferred.resolve, deferred.reject);
	        } else {
	          //
	          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	          deferred.resolve(resolvedTranslation);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
	            .then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          }
	        } else {
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	      var result, table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = defaultInterpolator;
	
	      // if the interpolation id exists use custom interpolator
	      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	        Interpolator = interpolatorHashMap[interpolationId];
	      }
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	        } else {
	          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackIndex = 0;
	          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          result = missingTranslationHandlerTranslation;
	        } else {
	          result = applyNotFoundIndicators(translationId);
	        }
	      }
	
	      return result;
	    };
	
	    var clearNextLangAndPromise = function (key) {
	      if ($nextLang === key) {
	        $nextLang = undefined;
	      }
	      langPromises[key] = undefined;
	    };
	
	    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	      var fn = postProcessFn;
	
	      if (fn) {
	
	        if (typeof(fn) === 'string') {
	          // getting on-demand instance
	          fn = $injector.get(fn);
	        }
	        if (fn) {
	          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	        }
	      }
	
	      return resolvedTranslation;
	    };
	
	    var loadTranslationsIfMissing = function (key) {
	      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          return translation;
	        });
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */
	    $translate.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	      }
	      return $preferredLanguage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */
	    $translate.cloakClassName = function () {
	      return $cloakClassName;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */
	    $translate.nestedObjectDelimeter = function () {
	      return $nestedObjectDelimeter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */
	    $translate.fallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        fallbackStack(langKey);
	
	        // as we might have an async loader initiated and a new translation language might have been defined
	        // we need to add the promise to the stack also. So - iterate.
	        if ($loaderFactory) {
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              if (!langPromises[$fallbackLanguage[i]]) {
	                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	              }
	            }
	          }
	        }
	        $translate.use($translate.use());
	      }
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */
	    $translate.useFallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        if (!langKey) {
	          startFallbackIteration = 0;
	        } else {
	          var langKeyPosition = indexOf($fallbackLanguage, langKey);
	          if (langKeyPosition > -1) {
	            startFallbackIteration = langKeyPosition;
	          }
	        }
	
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */
	    $translate.proposedLanguage = function () {
	      return $nextLang;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */
	    $translate.storage = function () {
	      return Storage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */
	    $translate.negotiateLocale = negotiateLocale;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string=} key Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */
	    $translate.use = function (key) {
	      if (!key) {
	        return $uses;
	      }
	
	      var deferred = $q.defer();
	      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	      $rootScope.$emit('$translateChangeStart', {language : key});
	
	      // Try to get the aliased language key
	      var aliasedKey = negotiateLocale(key);
	      // Ensure only registered language keys will be loaded
	      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	        return $q.reject(key);
	      }
	
	      if (aliasedKey) {
	        key = aliasedKey;
	      }
	
	      // if there isn't a translation table for the language we've requested,
	      // we load it asynchronously
	      $nextLang = key;
	      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          deferred.resolve(translation.key);
	          if ($nextLang === key) {
	            useLanguage(translation.key);
	          }
	          return translation;
	        }, function (key) {
	          $rootScope.$emit('$translateChangeError', {language : key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateChangeEnd', {language : key});
	          return $q.reject(key);
	        });
	        langPromises[key]['finally'](function () {
	          clearNextLangAndPromise(key);
	        })['catch'](angular.noop); // we don't care about errors (clearing)
	      } else if (langPromises[key]) {
	        // we are already loading this asynchronously
	        // resolve our new deferred when the old langPromise is resolved
	        langPromises[key].then(function (translation) {
	          if ($nextLang === translation.key) {
	            useLanguage(translation.key);
	          }
	          deferred.resolve(translation.key);
	          return translation;
	        }, function (key) {
	          // find first available fallback language if that request has failed
	          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	          } else {
	            return deferred.reject(key);
	          }
	        });
	      } else {
	        deferred.resolve(key);
	        useLanguage(key);
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    $translate.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */
	    $translate.storageKey = function () {
	      return storageKey();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */
	    $translate.isPostCompilingEnabled = function () {
	      return $postCompilingEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */
	    $translate.isForceAsyncReloadEnabled = function () {
	      return $forceAsyncReloadEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */
	    $translate.isKeepContent = function () {
	      return $keepContent;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */
	    $translate.refresh = function (langKey) {
	      if (!$loaderFactory) {
	        throw new Error('Couldn\'t refresh translation table, no loader registered!');
	      }
	
	      $rootScope.$emit('$translateRefreshStart', {language : langKey});
	
	      var deferred = $q.defer(), updatedLanguages = {};
	
	      //private helper
	      function loadNewData(languageKey) {
	        var promise = loadAsync(languageKey);
	        //update the load promise cache for this language
	        langPromises[languageKey] = promise;
	        //register a data handler for the promise
	        promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	        return promise;
	      }
	
	      //set up post-processing
	      deferred.promise.then(
	        function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop
	      )['finally'](
	        function () {
	          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
	        }
	      );
	
	      if (!langKey) {
	        // if there's no language key specified we refresh ALL THE THINGS!
	        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	        if ($uses && languagesToReload.indexOf($uses) === -1) {
	          languagesToReload.push($uses);
	        }
	        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	
	      } else if ($translationTable[langKey]) {
	        //just refresh the specified language cache
	        loadNewData(langKey).then(deferred.resolve, deferred.reject);
	
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] Params
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     *
	     * @return {string|object} translation
	     */
	    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	      // we don't want to re-negotiate $uses
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Detect undefined and null values to shorten the execution and prevent exceptions
	      if (translationId === null || angular.isUndefined(translationId)) {
	        return translationId;
	      }
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        var results = {};
	        for (var i = 0, c = translationId.length; i < c; i++) {
	          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	        }
	        return results;
	      }
	
	      // We discarded unacceptable values. So we just need to verify if translationId is empty String
	      if (angular.isString(translationId) && translationId.length < 1) {
	        return translationId;
	      }
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var result, possibleLangKeys = [];
	      if ($preferredLanguage) {
	        possibleLangKeys.push($preferredLanguage);
	      }
	      if (uses) {
	        possibleLangKeys.push(uses);
	      }
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	      }
	      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	        var possibleLangKey = possibleLangKeys[j];
	        if ($translationTable[possibleLangKey]) {
	          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	          }
	        }
	        if (typeof result !== 'undefined') {
	          break;
	        }
	      }
	
	      if (!result && result !== '') {
	        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	          result = applyNotFoundIndicators(translationId);
	        } else {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          var missingTranslationHandlerTranslation;
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            result = missingTranslationHandlerTranslation;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */
	    $translate.versionInfo = function () {
	      return version;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */
	    $translate.loaderCache = function () {
	      return loaderCache;
	    };
	
	    // internal purpose only
	    $translate.directivePriority = function () {
	      return directivePriority;
	    };
	
	    // internal purpose only
	    $translate.statefulFilter = function () {
	      return statefulFilter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */
	    $translate.isReady = function () {
	      return $isReady;
	    };
	
	    var $onReadyDeferred = $q.defer();
	    $onReadyDeferred.promise.then(function () {
	      $isReady = true;
	    });
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */
	    $translate.onReady = function (fn) {
	      var deferred = $q.defer();
	      if (angular.isFunction(fn)) {
	        deferred.promise.then(fn);
	      }
	      if ($isReady) {
	        deferred.resolve();
	      } else {
	        $onReadyDeferred.promise.then(deferred.resolve);
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */
	    $translate.getAvailableLanguageKeys = function () {
	      if ($availableLanguageKeys.length > 0) {
	        return $availableLanguageKeys;
	      }
	      return null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */
	    $translate.getTranslationTable = function (langKey) {
	      langKey = langKey || $translate.use();
	      if (langKey && $translationTable[langKey]) {
	        return angular.copy($translationTable[langKey]);
	      }
	      return null;
	    };
	
	    // Whenever $translateReady is being fired, this will ensure the state of $isReady
	    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	      $onReadyDeferred.resolve();
	      globalOnReadyListener(); // one time only
	      globalOnReadyListener = null;
	    });
	    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	      $onReadyDeferred.resolve();
	      globalOnChangeListener(); // one time only
	      globalOnChangeListener = null;
	    });
	
	    if ($loaderFactory) {
	
	      // If at least one async loader is defined and there are no
	      // (default) translations available we should try to load them.
	      if (angular.equals($translationTable, {})) {
	        if ($translate.use()) {
	          $translate.use($translate.use());
	        }
	      }
	
	      // Also, if there are any fallback language registered, we start
	      // loading them asynchronously as soon as we can.
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        var processAsyncResult = function (translation) {
	          translations(translation.key, translation.table);
	          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
	          return translation;
	        };
	        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	          var fallbackLanguageId = $fallbackLanguage[i];
	          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	          }
	        }
	      }
	    } else {
	      $rootScope.$emit('$translateReady', {language : $translate.use()});
	    }
	
	    return $translate;
	  }];
	}
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @param {string} value translation
	   * @param {object} [interpolationParams={}] interpolation params
	   * @param {string} [context=undefined] current context (filter, directive, service)
	   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	   * @param {string} translationId current translationId
	   *
	   * @returns {string} interpolated string
	   */
	  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	    var interpolatedText;
	    if (angular.isNumber(value)) {
	      // numbers are safe
	      interpolatedText = '' + value;
	    } else if (angular.isString(value)) {
	      // strings must be interpolated (that's the job here)
	      interpolatedText = $interpolate(value)(interpolationParams);
	      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	    } else {
	      // neither a number or a string, cant interpolate => empty string
	      interpolatedText = '';
	    }
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate,
	 * @requires $compile,
	 * @requires $parse,
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
	        tAttr.translateSanitizeStrategy : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text());
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              // do not assigne the translation id if it is empty.
	              translationIds.translate = !iElementText ? undefined : iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	          updateTranslations();
	        });
	
	        if (translateSanitizeStrategyExist) {
	          iAttr.$observe('translateSanitizeStrategy', function (value) {
	            scope.sanitizeStrategy = $parse(value)(scope.$parent);
	            updateTranslations();
	          });
	        }
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (!successful) {
	            if (typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	          }
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
	              iElement.empty().append(scope.preText + value + scope.postText);
	            }
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translateAttr', translateAttrDirective);
	function translateAttrDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    priority: $translate.directivePriority(),
	    link: function linkFn(scope, element, attr) {
	
	      var translateAttr,
	          translateValues,
	          translateSanitizeStrategy,
	          previousAttributes = {};
	
	      // Main update translations function
	      var updateTranslations = function () {
	        angular.forEach(translateAttr, function (translationId, attributeName) {
	          if (!translationId) {
	            return;
	          }
	          previousAttributes[attributeName] = true;
	
	          // if translation id starts with '.' and translateNamespace given, prepend namespace
	          if (scope.translateNamespace && translationId.charAt(0) === '.') {
	            translationId = scope.translateNamespace + translationId;
	          }
	          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
	            .then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	        });
	
	        // Removing unused attributes that were previously used
	        angular.forEach(previousAttributes, function (flag, attributeName) {
	          if (!translateAttr[attributeName]) {
	            element.removeAttr(attributeName);
	            delete previousAttributes[attributeName];
	          }
	        });
	      };
	
	      // Watch for attribute changes
	      watchAttribute(
	        scope,
	        attr.translateAttr,
	        function (newValue) { translateAttr = newValue; },
	        updateTranslations
	      );
	      // Watch for value changes
	      watchAttribute(
	        scope,
	        attr.translateValues,
	        function (newValue) { translateValues = newValue; },
	        updateTranslations
	      );
	      // Watch for sanitize strategy changes
	      watchAttribute(
	        scope,
	        attr.translateSanitizeStrategy,
	        function (newValue) { translateSanitizeStrategy = newValue; },
	        updateTranslations
	      );
	
	      if (attr.translateValues) {
	        scope.$watch(attr.translateValues, updateTranslations, true);
	      }
	
	      // Replaced watcher on translateLanguage with event listener
	      scope.$on('translateLanguageChanged', updateTranslations);
	
	      // Ensures the text will be refreshed after the current language was changed
	      // w/ $translate.use(...)
	      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	      updateTranslations();
	      scope.$on('$destroy', unbind);
	    }
	  };
	}
	
	function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	  'use strict';
	  if (!attribute) {
	    return;
	  }
	  if (attribute.substr(0, 2) === '::') {
	    attribute = attribute.substr(2);
	  } else {
	    scope.$watch(attribute, function(newValue) {
	      valueCallback(newValue);
	      changeCallback();
	    }, true);
	  }
	  valueCallback(scope.$eval(attribute));
	}
	
	translateAttrDirective.displayName = 'translateAttrDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    compile : function (tElement) {
	      var applyCloak = function (element) {
	          element.addClass($translate.cloakClassName());
	        },
	        removeCloak = function (element) {
	          element.removeClass($translate.cloakClassName());
	        };
	      applyCloak(tElement);
	
	      return function linkFn(scope, iElement, iAttr) {
	        //Create bound functions that incorporate the active DOM element.
	        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          // Register a watcher for the defined translation allowing a fine tuned cloak
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(iRemoveCloak, iApplyCloak);
	          });
	          $rootScope.$on('$translateChangeSuccess', function () {
	            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	          });
	        } else {
	          $translate.onReady(iRemoveCloak);
	        }
	      };
	    }
	  };
	}
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It is possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = _getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function _getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return _getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateLanguage', translateLanguageDirective);
	
	function translateLanguageDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return function linkFn(scope, iElement, iAttrs) {
	
	        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	          scope.translateLanguage = newTranslateLanguage;
	        });
	
	        scope.$watch('translateLanguage', function(){
	          scope.$broadcast('translateLanguageChanged');
	        });
	      };
	    }
	  };
	}
	
	translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
	    if (!angular.isObject(interpolateParams)) {
	      var ctx = this || {
	        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	      interpolateParams = $parse(interpolateParams)(ctx);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var SKIP_INDEXES = 2;
	
	    var templateArgs = arguments,
	      code = templateArgs[0],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      template = templateArgs[1],
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1),
	        shiftedIndex = index + SKIP_INDEXES;
	
	      if (shiftedIndex < templateArgs.length) {
	        return toDebugString(templateArgs[shiftedIndex]);
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.5.8/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
	        encodeURIComponent(toDebugString(templateArgs[i]));
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell jshint what variables are being exported */
	/* global angular: true,
	  msie: true,
	  jqLite: true,
	  jQuery: true,
	  slice: true,
	  splice: true,
	  push: true,
	  toString: true,
	  ngMinErr: true,
	  angularModule: true,
	  uid: true,
	  REGEX_STRING_REGEXP: true,
	  VALIDITY_STATE_PROPERTY: true,
	
	  lowercase: true,
	  uppercase: true,
	  manualLowercase: true,
	  manualUppercase: true,
	  nodeName_: true,
	  isArrayLike: true,
	  forEach: true,
	  forEachSorted: true,
	  reverseParams: true,
	  nextUid: true,
	  setHashKey: true,
	  extend: true,
	  toInt: true,
	  inherit: true,
	  merge: true,
	  noop: true,
	  identity: true,
	  valueFn: true,
	  isUndefined: true,
	  isDefined: true,
	  isObject: true,
	  isBlankObject: true,
	  isString: true,
	  isNumber: true,
	  isDate: true,
	  isArray: true,
	  isFunction: true,
	  isRegExp: true,
	  isWindow: true,
	  isScope: true,
	  isFile: true,
	  isFormData: true,
	  isBlob: true,
	  isBoolean: true,
	  isPromiseLike: true,
	  trim: true,
	  escapeForRegexp: true,
	  isElement: true,
	  makeMap: true,
	  includes: true,
	  arrayRemove: true,
	  copy: true,
	  equals: true,
	  csp: true,
	  jq: true,
	  concat: true,
	  sliceArgs: true,
	  bind: true,
	  toJsonReplacer: true,
	  toJson: true,
	  fromJson: true,
	  convertTimezoneToLocal: true,
	  timezoneToOffset: true,
	  startingTag: true,
	  tryDecodeURIComponent: true,
	  parseKeyValue: true,
	  toKeyValue: true,
	  encodeUriSegment: true,
	  encodeUriQuery: true,
	  angularInit: true,
	  bootstrap: true,
	  getTestability: true,
	  snake_case: true,
	  bindJQuery: true,
	  assertArg: true,
	  assertArgFn: true,
	  assertNotHasOwnProperty: true,
	  getter: true,
	  getBlockNodes: true,
	  hasOwnProperty: true,
	  createMap: true,
	
	  NODE_TYPE_ELEMENT: true,
	  NODE_TYPE_ATTRIBUTE: true,
	  NODE_TYPE_TEXT: true,
	  NODE_TYPE_COMMENT: true,
	  NODE_TYPE_DOCUMENT: true,
	  NODE_TYPE_DOCUMENT_FRAGMENT: true,
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	};
	var manualUppercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = "length" in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item == 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        // Need to check if hasOwnProperty exists,
	        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
	           replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) != -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination) {
	  var stackSource = [];
	  var stackDest = [];
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', "Can't copy! TypedArray destination cannot be mutated.");
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', "Can't copy! Source and destination are identical.");
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination);
	  }
	
	  return copyElement(source);
	
	  function copyRecurse(source, destination) {
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i]));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key]);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        "Can't copy! Making copies of Window or Scope instances is not supported.");
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        //Support: IE10
	        if (!source.slice) {
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.result;
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 == t2 && t1 == 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) == o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return equals(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() == o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      /* jshint -W031, -W054 */
	      new Function('');
	      /* jshint +W031, +W054 */
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    if (el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/* jshint -W101 */
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	/* jshint +W101 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) {}
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w\-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || "").split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query       = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = "World";
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          "App already bootstrapped with this element '{0}'",
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? __webpack_provided_window_dot_jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: JQLitePrototype.controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, "events");
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
	             "the module name or forgot to load it. If registering a module ensure that you " +
	             "specify the dependencies as the second argument.", name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method) {
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            invokeQueue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global toDebugString: true */
	
	function serializeObject(obj) {
	  var seen = [];
	
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  styleDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $$HashMapProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  full: '1.5.8',    // all of these placeholder strings will be replaced by grunt's
	  major: 1,    // package task
	  minor: 5,
	  dot: 8,
	  codeName: 'arbitrary-fallbacks'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    'reloadWithDebugInfo': reloadWithDebugInfo
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            style: styleDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$HashMap: $$HashMapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ]);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global JQLitePrototype: true,
	  addEventListenerFn: true,
	  removeEventListenerFn: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true,
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1,
	    addEventListenerFn = function(element, type, fn) {
	      element.addEventListener(type, fn, false);
	    },
	    removeEventListenerFn = function(element, type, fn) {
	      element.removeEventListener(type, fn, false);
	    };
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts snake_case to camelCase.
	 * Also there is special case for Moz prefix starting with upper case letter.
	 * @param name Name to normalize
	 */
	function camelCase(name) {
	  return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, "", ""]
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteCleanData(nodes) {
	  for (var i = 0, ii = nodes.length; i < ii; i++) {
	    jqLiteRemoveData(nodes[i]);
	  }
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement("div"));
	    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = "";
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = "";
	  fragment.innerHTML = ""; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || function(arg) {
	  // jshint bitwise: false
	  return !!(this.compareDocumentPosition(arg) & 16);
	  // jshint bitwise: true
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) != '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants) jqLiteRemoveData(element);
	
	  if (element.querySelectorAll) {
	    var descendants = element.querySelectorAll('*');
	    for (var i = 0, l = descendants.length; i < l; i++) {
	      jqLiteRemoveData(descendants[i]);
	    }
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        removeEventListenerFn(element, type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        removeEventListenerFn(element, type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[key] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[key];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          extend(data, key);
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
	      indexOf(" " + selector + " ") > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (" " + (element.getAttribute('class') || '') + " ")
	          .replace(/[\n\t]/g, " ")
	          .replace(" " + trim(cssClass) + " ", " "))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, " ");
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType == NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: function(fn) {
	    var fired = false;
	
	    function trigger() {
	      if (fired) return;
	      fired = true;
	      fn();
	    }
	
	    // check if document is already loaded
	    if (window.document.readyState === 'complete') {
	      window.setTimeout(trigger);
	    } else {
	      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
	      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
	      // jshint -W064
	      JQLite(window).on('load', trigger); // fallback to window.onload for others
	      // jshint +W064
	    }
	  },
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: jqLiteCleanData
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = camelCase(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
	      return;
	    }
	    var lowercasedName = lowercase(name);
	    if (BOOLEAN_ATTR[lowercasedName]) {
	      if (isDefined(value)) {
	        if (!!value) {
	          element[name] = true;
	          element.setAttribute(name, lowercasedName);
	        } else {
	          element[name] = false;
	          element.removeAttribute(lowercasedName);
	        }
	      } else {
	        return (element[name] ||
	                 (element.attributes.getNamedItem(name) || noop).specified)
	               ? lowercasedName
	               : undefined;
	      }
	    } else if (isDefined(value)) {
	      element.setAttribute(name, value);
	    } else if (element.getAttribute) {
	      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	      // some elements (e.g. Document) don't have get attribute, so return undefined
	      var ret = element.getAttribute(name, 2);
	      // normalize non-existing attributes to undefined (as jQuery)
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result.length === 0 ? null : result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          addEventListenerFn(element, type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	    newElement = new JQLite(newElement);
	
	    for (var i = 0, ii = newElement.length; i < ii; i++) {
	      var node = newElement[i];
	      parent.insertBefore(node, index.nextSibling);
	      index = node;
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	
	  // bind legacy bind/unbind to on/off
	  JQLite.prototype.bind = JQLite.prototype.on;
	  JQLite.prototype.unbind = JQLite.prototype.off;
	});
	
	
	// Provider for private $$jqLite service
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType == 'function' || (objType == 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	/**
	 * HashMap which can use objects as keys
	 */
	function HashMap(array, isolatedUid) {
	  if (isolatedUid) {
	    var uid = 0;
	    this.nextUid = function() {
	      return ++uid;
	    };
	  }
	  forEach(array, this.put, this);
	}
	HashMap.prototype = {
	  /**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */
	  put: function(key, value) {
	    this[hashKey(key, this.nextUid)] = value;
	  },
	
	  /**
	   * @param key
	   * @returns {Object} the value for the key
	   */
	  get: function(key) {
	    return this[hashKey(key, this.nextUid)];
	  },
	
	  /**
	   * Remove the key/value pair
	   * @param key
	   */
	  remove: function(key) {
	    var value = this[key = hashKey(key, this.nextUid)];
	    delete this[key];
	    return value;
	  }
	};
	
	var $$HashMapProvider = [function() {
	  this.$get = [function() {
	    return HashMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^\(]+?)=>/;
	var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  // Support: Chrome 50-51 only
	  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
	  // (See https://github.com/angular/angular.js/issues/14487.)
	  // TODO (gkalpak): Remove workaround when Chrome v52 is released
	  return Function.prototype.toString.call(fn) + ' ';
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
	    }
	    return providerCache[name + providerSuffix] = provider_;
	  }
	
	  function enforceReturnValue(name, factory) {
	    return function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.put(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          /* jshint -W022 */
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          return cache[serviceName] = factory(serviceName, caller);
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie <= 11) {
	        return false;
	      }
	      // Support: Edge 12-13 only
	      // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	      return typeof func === 'function'
	        && /^(?:class\b|constructor\()/.test(stringifyFn(func));
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function ($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function ($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      hash = isString(hash) ? hash : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash == 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = function() {
	  var postDigestQueue = new HashMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        domOperation        && domOperation();
	
	        options = options || {};
	        options.from        && element.css(options.from);
	        options.to          && element.css(options.to);
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner(); // jshint ignore:line
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            toAdd    && jqLiteAddClass(elm, toAdd);
	            toRemove && jqLiteRemoveClass(elm, toRemove);
	          });
	          postDigestQueue.remove(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.put(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', function($provide) {
	  var provider = this;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (this.$$classNameFilter) {
	        var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
	        if (reservedRegex.test(this.$$classNameFilter.toString())) {
	          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	
	        }
	      }
	    }
	    return this.$$classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      afterElement ? afterElement.after(element) : parentElement.prepend(element);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        runner.end && runner.end();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given classNamem, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        passed ? callback() : waitForTick(callback);
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $document,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        var doc = $document[0];
	
	        // the document may not be ready or attached
	        // to the module for some internal tests
	        if (doc && doc.hidden) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      /* jshint newcap: false */
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	  lastHistoryState = cachedState;
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	        // Do the assignment again so that those two variables are referentially identical.
	        lastHistoryState = cachedState;
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,"'");
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    cacheState();
	    fireUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	    lastCachedState = cachedState;
	  }
	
	  function fireUrlChange() {
	    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	      // don't fire popstate when user change the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      };
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry != freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd == entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry != prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your HTML:
	 * ```html
	 * <div ng-include=" 'templateId.html' "></div>
	 * ```
	 *
	 * or get it via Javascript:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       priority: 0,
	 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       transclude: false,
	 *       restrict: 'A',
	 *       templateNamespace: 'html',
	 *       scope: false,
	 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       controllerAs: 'stringIdentifier',
	 *       bindToController: false,
	 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       compile: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // link: {
	 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // link: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true, the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `true`, an object or a falsy value:
	 *
	 * * **falsy:** No scope will be created for the directive. The directive will use its parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created. The new scope rule does not apply for the root of the template
	 * since the root of the template always gets a new scope.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
	 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
	 * scope. This is useful when creating reusable components, which should not accidentally read or modify
	 * data in the parent scope.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property. Additionally, a controller
	 * alias must be set, either by using `controllerAs: 'myAlias'` or by specifying the alias in the controller
	 * definition: `controller: 'myCtrl as myAlias'`.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
	 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
	 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkinFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default translusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            "Invalid {3} for directive '{0}'." +
	            " Definition: {... {1}: '{2}' ...}",
	            directiveName, scopeName, definition,
	            (isController ? "controller bindings definition" :
	            "isolate scope definition"));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (isObject(bindings.bindToController)) {
	      var controller = directive.controller;
	      var controllerAs = directive.controllerAs;
	      if (!controller) {
	        // There is no controller, there may or may not be a controllerAs property
	        throw $compileMinErr('noctrl',
	              "Cannot bind to controller without directive '{0}'s controller.",
	              directiveName);
	      } else if (!identifierForController(controller, controllerAs)) {
	        // There is a controller, but no identifier or controllerAs property
	        throw $compileMinErr('noident',
	              "Cannot bind to controller without identifier for directive '{0}'.",
	              directiveName);
	      }
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = directive.restrict || 'EA';
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = "";
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (" " + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (" " + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        $$observers && forEach($$observers[observer], function(fn) {
	          try {
	            fn(value);
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        });
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = "<span " + attrName + ">";
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol == '{{' && endSymbol  == '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	
	      var NOT_EMPTY = /\S+/;
	
	      // We can not compile top level text elements since text nodes can be merged and we will
	      // not be able to attach scope data to them, so we will wrap them in <span>
	      for (var i = 0, len = $compileNodes.length; i < len; i++) {
	        var domNode = $compileNodes[i];
	
	        if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
	          jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
	        }
	      }
	
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i+=3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = trim(attr.value);
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          // use class as directive
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          if (msie === 11) {
	            // Workaround for #11781
	            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
	              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
	              node.parentNode.removeChild(node.nextSibling);
	            }
	          }
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with an directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType == NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        if (directiveValue = directive.scope) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          directiveValue = directive.controller;
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate("'" + directiveName + "' controller",
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        if (directiveValue = directive.transclude) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue == 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            $template = jqLite(jqLiteClone(compileNode)).contents();
	
	            if (isObject(directiveValue)) {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          /* jshint -W021 */
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	          /* jshint +W021 */
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (controller.identifier && bindings) {
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          } else {
	            controller.bindingInfo = {};
	          }
	
	          var controllerResult = controller();
	          if (controllerResult !== controller.instance) {
	            // If the controller constructor has a return value, overwrite the instance
	            // from setupControllers
	            controller.instance = controllerResult;
	            $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	            controller.bindingInfo.removeWatches && controller.bindingInfo.removeWatches();
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              "Controller '{0}', required by directive '{1}', can't be found!",
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller == '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          try {
	            directive = directives[i];
	            if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	                 directive.restrict.indexOf(location) != -1) {
	              if (startAttrName) {
	                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	              }
	              if (!directive.$$bindings) {
	                var bindings = directive.$$bindings =
	                    parseDirectiveBindings(directive, directive.name);
	                if (isObject(bindings.isolateScope)) {
	                  directive.$$isolateBindings = bindings.isolateScope;
	                }
	              }
	              tDirectives.push(directive);
	              match = directive;
	            }
	          } catch (e) { $exceptionHandler(e); }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr,
	          $element = dst.$$element;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) != '$') {
	          if (src[key] && src[key] !== value) {
	            value += (key === 'style' ? ';' : ' ') + src[key];
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node == compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName == "srcdoc") {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      if (attrNormalizedName == "xlinkHref" ||
	          (tag == "form" && attrNormalizedName == "action") ||
	          (tag != "img" && (attrNormalizedName == "src" ||
	                            attrNormalizedName == "ngSrc"))) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
	      var trustedContext = getTrustedContext(node, name);
	      allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;
	
	      var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	
	      if (name === "multiple" && nodeName_(node) === "select") {
	        throw $compileMinErr("selmulti",
	            "Binding to the 'multiple' attribute is not supported. Element: {0}",
	            startingTag(node));
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	                  throw $compileMinErr('nodomevents',
	                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
	                          "ng- versions (such as ng-click instead of onclick) instead.");
	                }
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue != oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] == firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings. This process
	    // only occurs for isolate scopes and new scopes with controllerAs.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = void 0;
	            }
	            attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              return lastValue = parentValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue) return;
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, parentGet.literal);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && currentValue !== previousValue) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return camelCase(name.replace(PREFIX_REGEXP, ''));
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token == tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT) {
	      splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            "Badly formed controller string '{0}'. " +
	            "Must match `__name__ as __id__` or `__name__`.", expression);
	        }
	        constructor = match[1],
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        var instantiate;
	        return instantiate = extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var $httpMinErr = minErr('$http');
	var $httpMinErrLegacyFn = function(method) {
	  return function() {
	    throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
	  };
	};
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        data = fromJson(tempData);
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with single an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === void 0) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  var useLegacyPromise = true;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useLegacyPromiseExtensions
	   * @description
	   *
	   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
	   * This should be used to make sure that applications work without these methods.
	   *
	   * Defaults to true. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useLegacyPromiseExtensions = function(value) {
	    if (isDefined(value)) {
	      useLegacyPromise = !!value;
	      return this;
	    }
	    return useLegacyPromise;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
	      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Deprecation Notice
	     * <div class="alert alert-danger">
	     *   The `$http` legacy promise methods `success` and `error` have been deprecated.
	     *   Use the standard `then` method instead.
	     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
	     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
	     * </div>
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - `Accept: application/json, text/plain, * / *`
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || "Request failed";
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString(requestConfig.url)) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.when(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	
	      if (useLegacyPromise) {
	        promise.success = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	
	        promise.error = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(null, function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	      } else {
	        promise.success = $httpMinErrLegacyFn('success');
	        promise.error = $httpMinErrLegacyFn('error');
	      }
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request.
	     *                     The name of the callback should be the string `JSON_CALLBACK`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          url = buildUrl(config.url, config.paramSerializer(config.params));
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') == -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    $browser.$$incOutstandingRequestCount();
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, "", text);
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      jsonpDone && jsonpDone();
	      xhr && xhr.abort();
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	      $browser.$$completeOutstandingRequest(noop);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = "text/javascript";
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      removeEventListenerFn(script, "load", callback);
	      removeEventListenerFn(script, "error", callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = "unknown";
	
	      if (event) {
	        if (event.type === "load" && !callbacks.wasCalled(callbackPath)) {
	          event = { type: "error" };
	        }
	        text = event.type;
	        status = event.type === "error" ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    addEventListenerFn(script, "load", callback);
	    addEventListenerFn(script, "error", callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
	      "interpolations that concatenate multiple expressions when a trusted value is " +
	      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    function stringify(value) {
	      if (value == null) { // null || undefined
	        return '';
	      }
	      switch (typeof value) {
	        case 'string':
	          break;
	        case 'number':
	          value = '' + value;
	          break;
	        default:
	          value = toJson(value);
	      }
	
	      return value;
	    }
	
	    //TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example>
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = function() {
	  this.$get = ['$window', function($window) {
	    var callbacks = $window.angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	
	function parseAppUrl(relativeUrl, locationObj) {
	  var prefixed = (relativeUrl.charAt(0) !== '/');
	  if (prefixed) {
	    relativeUrl = '/' + relativeUrl;
	  }
	  var match = urlResolve(relativeUrl);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(haystack, needle) {
	  return haystack.lastIndexOf(needle, 0) === 0;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index == -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents an url
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix url path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given html5 (regular) url string into properties
	   * @param {string} url HTML5 url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile == url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang url into properties
	   * @param {string} url Hashbang url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the url starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          this.replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) == stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase == stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute url is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full url representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full url
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current url
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current url.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current url.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current url when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) == '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current url when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the url.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables url rewriting for relative links.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          "$location in HTML5 mode requires a <base> tag to be present!");
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() != $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      var oldUrl = trimEmptyHash($browser.url());
	      var newUrl = trimEmptyHash($location.absUrl());
	      var oldState = $browser.state();
	      var currentReplace = $location.$$replace;
	      var urlOrStateChanged = oldUrl !== newUrl ||
	        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	      if (initializing || urlOrStateChanged) {
	        initializing = false;
	
	        $rootScope.$evalAsync(function() {
	          var newUrl = $location.absUrl();
	          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              $location.$$state, oldState).defaultPrevented;
	
	          // if the location was changed by a `$locationChangeStart` handler then stop
	          // processing this location change
	          if ($location.absUrl() !== newUrl) return;
	
	          if (defaultPrevented) {
	            $location.$$parse(oldUrl);
	            $location.$$state = oldState;
	          } else {
	            if (urlOrStateChanged) {
	              setBrowserUrlWithFallback(newUrl, currentReplace,
	                                        oldState === $location.$$state ? null : $location.$$state);
	            }
	            afterLocationChange(oldUrl, oldState);
	          }
	        });
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	    return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      }())
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) {}
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function ensureSafeMemberName(name, fullExpression) {
	  if (name === "__defineGetter__" || name === "__defineSetter__"
	      || name === "__lookupGetter__" || name === "__lookupSetter__"
	      || name === "__proto__") {
	    throw $parseMinErr('isecfld',
	        'Attempting to access a disallowed field in Angular expressions! '
	        + 'Expression: {0}', fullExpression);
	  }
	  return name;
	}
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	function ensureSafeObject(obj, fullExpression) {
	  // nifty check if obj is Function that is fast and works across iframes and other contexts
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isWindow(obj)
	        obj.window === obj) {
	      throw $parseMinErr('isecwindow',
	          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isElement(obj)
	        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
	      throw $parseMinErr('isecdom',
	          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// block Object so that we can't get hold of dangerous Object.* methods
	        obj === Object) {
	      throw $parseMinErr('isecobj',
	          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    }
	  }
	  return obj;
	}
	
	var CALL = Function.prototype.call;
	var APPLY = Function.prototype.apply;
	var BIND = Function.prototype.bind;
	
	function ensureSafeFunction(obj, fullExpression) {
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    } else if (obj === CALL || obj === APPLY || obj === BIND) {
	      throw $parseMinErr('isecff',
	        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    }
	  }
	}
	
	function ensureSafeAssignContext(obj, fullExpression) {
	  if (obj) {
	    if (obj === (0).constructor || obj === (false).constructor || obj === ''.constructor ||
	        obj === {}.constructor || obj === [].constructor || obj === Function.constructor) {
	      throw $parseMinErr('isecaf',
	        'Assigning to a constructor is disallowed! Expression: {0}', fullExpression);
	    }
	  }
	}
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === "'") {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === "string";
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    /*jshint bitwise: false*/
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	    /*jshint bitwise: true*/
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch == '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch == 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) == 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) == 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    var token;
	    while ((token = this.expect('|'))) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError("invalid key", this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length != 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.state = {
	      nextId: 0,
	      filters: {},
	      expensiveChecks: expensiveChecks,
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    /* jshint -W054 */
	    var fn = (new Function('$filter',
	        'ensureSafeMemberName',
	        'ensureSafeObject',
	        'ensureSafeFunction',
	        'getStringValue',
	        'ensureSafeAssignContext',
	        'ifDefined',
	        'plus',
	        'text',
	        fnString))(
	          this.$filter,
	          ensureSafeMemberName,
	          ensureSafeObject,
	          ensureSafeFunction,
	          getStringValue,
	          ensureSafeAssignContext,
	          ifDefined,
	          plusFn,
	          expression);
	    /* jshint +W054 */
	    this.state = this.stage = undefined;
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      ensureSafeMemberName(ast.name);
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.not(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
	        self.addEnsureSafeObject(intoId);
	      }
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (create && create !== 1) {
	            self.addEnsureSafeAssignContext(left);
	          }
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            self.addEnsureSafeMemberName(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.ensureSafeObject(self.computedMember(left, right));
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            ensureSafeMemberName(ast.property.name);
	            if (create && create !== 1) {
	              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
	              expression = self.ensureSafeObject(expression);
	            }
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            self.addEnsureSafeFunction(right);
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, self.nextId(), undefined, function(argument) {
	                args.push(self.ensureSafeObject(argument));
	              });
	            });
	            if (left.name) {
	              if (!self.state.expensiveChecks) {
	                self.addEnsureSafeObject(left.context);
	              }
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            expression = self.ensureSafeObject(expression);
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      if (!isAssignable(ast.left)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
	          self.addEnsureSafeAssignContext(left.context);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn('s');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn('l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn('v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /[$_a-zA-Z][$_a-zA-Z0-9]*/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  addEnsureSafeObject: function(item) {
	    this.current().body.push(this.ensureSafeObject(item), ';');
	  },
	
	  addEnsureSafeMemberName: function(item) {
	    this.current().body.push(this.ensureSafeMemberName(item), ';');
	  },
	
	  addEnsureSafeFunction: function(item) {
	    this.current().body.push(this.ensureSafeFunction(item), ';');
	  },
	
	  addEnsureSafeAssignContext: function(item) {
	    this.current().body.push(this.ensureSafeAssignContext(item), ';');
	  },
	
	  ensureSafeObject: function(item) {
	    return 'ensureSafeObject(' + item + ',text)';
	  },
	
	  ensureSafeMemberName: function(item) {
	    return 'ensureSafeMemberName(' + item + ',text)';
	  },
	
	  ensureSafeFunction: function(item) {
	    return 'ensureSafeFunction(' + item + ',text)';
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  ensureSafeAssignContext: function(item) {
	    return 'ensureSafeAssignContext(' + item + ',text)';
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.expression = expression;
	    this.expensiveChecks = expensiveChecks;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args, expression;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      ensureSafeMemberName(ast.name, self.expression);
	      return self.identifier(ast.name,
	                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
	                             context, create, self.expression);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        ensureSafeMemberName(ast.property.name, self.expression);
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create, self.expression) :
	        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            ensureSafeObject(rhs.context, self.expression);
	            ensureSafeFunction(rhs.value, self.expression);
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
	            }
	            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        ensureSafeObject(lhs.value, self.expression);
	        ensureSafeAssignContext(lhs.context);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && !(base[name])) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (expensiveChecks) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        ensureSafeMemberName(rhs, expression);
	        if (create && create !== 1) {
	          ensureSafeAssignContext(lhs);
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        ensureSafeAssignContext(lhs);
	        if (lhs && !(lhs[right])) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	var Parser = function(lexer, $filter, options) {
	  this.lexer = lexer;
	  this.$filter = $filter;
	  this.options = options;
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
	                                   new ASTCompiler(this.ast, $filter);
	};
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    return this.astCompiler.compile(text, this.options.expensiveChecks);
	  }
	};
	
	function isPossiblyDangerousMemberName(name) {
	  return name == 'constructor';
	}
	
	var objectValueOf = Object.prototype.valueOf;
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cacheDefault = createMap();
	  var cacheExpensive = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensivelly, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          expensiveChecks: false,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        },
	        $parseOptionsExpensive = {
	          csp: noUnsafeEval,
	          expensiveChecks: true,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    var runningChecksEnabled = false;
	
	    $parse.$$runningExpensiveChecks = function() {
	      return runningChecksEnabled;
	    };
	
	    return $parse;
	
	    function $parse(exp, interceptorFn, expensiveChecks) {
	      var parsedExpression, oneTime, cacheKey;
	
	      expensiveChecks = expensiveChecks || runningChecksEnabled;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
	            var lexer = new Lexer(parseOptions);
	            var parser = new Parser(lexer, $filter, parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            if (expensiveChecks) {
	              parsedExpression = expensiveChecksInterceptor(parsedExpression);
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expensiveChecksInterceptor(fn) {
	      if (!fn) return fn;
	      expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
	      expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
	      expensiveCheckFn.constant = fn.constant;
	      expensiveCheckFn.literal = fn.literal;
	      for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
	        fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
	      }
	      expensiveCheckFn.inputs = fn.inputs;
	
	      return expensiveCheckFn;
	
	      function expensiveCheckFn(scope, locals, assign, inputs) {
	        var expensiveCheckOldValue = runningChecksEnabled;
	        runningChecksEnabled = true;
	        try {
	          return fn(scope, locals, assign, inputs);
	        } finally {
	          runningChecksEnabled = expensiveCheckOldValue;
	        }
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object') {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }, objectEquality);
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.call(this, value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is an implementation of promises/deferred objects inspired by
	 * [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	function $QProvider() {
	
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	function $$QProvider() {
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler) {
	  var $qMinErr = minErr('$q', TypeError);
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  var defer = function() {
	    var d = new Deferred();
	    //Necessary to support unbound execution :/
	    d.resolve = simpleBind(d, d.resolve);
	    d.reject = simpleBind(d, d.reject);
	    d.notify = simpleBind(d, d.notify);
	    return d;
	  };
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Deferred();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result.promise;
	    },
	
	    "catch": function(callback) {
	      return this.then(null, callback);
	    },
	
	    "finally": function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, true, callback);
	      }, function(error) {
	        return handleCallback(error, false, callback);
	      }, progressBack);
	    }
	  });
	
	  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	  function simpleBind(context, fn) {
	    return function(value) {
	      fn.call(context, value);
	    };
	  }
	
	  function processQueue(state) {
	    var fn, deferred, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    for (var i = 0, ii = pending.length; i < ii; ++i) {
	      deferred = pending[i][0];
	      fn = pending[i][state.status];
	      try {
	        if (isFunction(fn)) {
	          deferred.resolve(fn(state.value));
	        } else if (state.status === 1) {
	          deferred.resolve(state.value);
	        } else {
	          deferred.reject(state.value);
	        }
	      } catch (e) {
	        deferred.reject(e);
	        exceptionHandler(e);
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function Deferred() {
	    this.promise = new Promise();
	  }
	
	  extend(Deferred.prototype, {
	    resolve: function(val) {
	      if (this.promise.$$state.status) return;
	      if (val === this.promise) {
	        this.$$reject($qMinErr(
	          'qcycle',
	          "Expected promise to be resolved with value other than itself '{0}'",
	          val));
	      } else {
	        this.$$resolve(val);
	      }
	
	    },
	
	    $$resolve: function(val) {
	      var then;
	      var that = this;
	      var done = false;
	      try {
	        if ((isObject(val) || isFunction(val))) then = val && val.then;
	        if (isFunction(then)) {
	          this.promise.$$state.status = -1;
	          then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
	        } else {
	          this.promise.$$state.value = val;
	          this.promise.$$state.status = 1;
	          scheduleProcessQueue(this.promise.$$state);
	        }
	      } catch (e) {
	        rejectPromise(e);
	        exceptionHandler(e);
	      }
	
	      function resolvePromise(val) {
	        if (done) return;
	        done = true;
	        that.$$resolve(val);
	      }
	      function rejectPromise(val) {
	        if (done) return;
	        done = true;
	        that.$$reject(val);
	      }
	    },
	
	    reject: function(reason) {
	      if (this.promise.$$state.status) return;
	      this.$$reject(reason);
	    },
	
	    $$reject: function(reason) {
	      this.promise.$$state.value = reason;
	      this.promise.$$state.status = 2;
	      scheduleProcessQueue(this.promise.$$state);
	    },
	
	    notify: function(progress) {
	      var callbacks = this.promise.$$state.pending;
	
	      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
	        nextTick(function() {
	          var callback, result;
	          for (var i = 0, ii = callbacks.length; i < ii; i++) {
	            result = callbacks[i][0];
	            callback = callbacks[i][3];
	            try {
	              result.notify(isFunction(callback) ? callback(progress) : progress);
	            } catch (e) {
	              exceptionHandler(e);
	            }
	          }
	        });
	      }
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  var reject = function(reason) {
	    var result = new Deferred();
	    result.reject(reason);
	    return result.promise;
	  };
	
	  var makePromise = function makePromise(value, resolved) {
	    var result = new Deferred();
	    if (resolved) {
	      result.resolve(value);
	    } else {
	      result.reject(value);
	    }
	    return result.promise;
	  };
	
	  var handleCallback = function handleCallback(value, isResolved, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return makePromise(e, false);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return makePromise(value, isResolved);
	      }, function(error) {
	        return makePromise(error, false);
	      });
	    } else {
	      return makePromise(value, isResolved);
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  var when = function(value, callback, errback, progressBack) {
	    var result = new Deferred();
	    result.resolve(value);
	    return result.promise.then(callback, errback, progressBack);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var deferred = new Deferred(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        if (results.hasOwnProperty(key)) return;
	        results[key] = value;
	        if (!(--counter)) deferred.resolve(results);
	      }, function(reason) {
	        if (results.hasOwnProperty(key)) return;
	        deferred.reject(reason);
	      });
	    });
	
	    if (counter === 0) {
	      deferred.resolve(results);
	    }
	
	    return deferred.promise;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  var $Q = function Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
	    }
	
	    var deferred = new Deferred();
	
	    function resolveFn(value) {
	      deferred.resolve(value);
	    }
	
	    function rejectFn(reason) {
	      deferred.reject(reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return deferred.promise;
	  };
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        $scope.$$childHead && cleanUpScope($scope.$$childHead);
	        $scope.$$nextSibling && cleanUpScope($scope.$$nextSibling);
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent != this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          if (arrayRemove(array, watcher) >= 0) {
	            incrementWatchersCount(scope, -1);
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
	       *   call to $digest() to see if any items changes.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            length,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              length = watchers.length;
	              while (length--) {
	                try {
	                  watch = watchers[length];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (typeof value === 'number' && typeof last === 'number'
	                               && isNaN(value) && isNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        expr && applyAsyncQueue.push($applyAsyncExpression);
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  HTML: 'html',
	  CSS: 'css',
	  URL: 'url',
	  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	  // url.  (e.g. ng-include, script src, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace('\\*\\*', '.*').
	                  replace('\\*', '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** an empty whitelist array will block all URLs!
	   *    </div>
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    The typical usage for the blacklist is to **block
	   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *    these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *    Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // If we get here, then we may only take one of two actions.
	      // 1. sanitize the value for the requested type, or
	      // 2. throw an exception.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        return htmlSanitizer(maybeTrusted);
	      }
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/* jshint maxlen: false*/
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	/* jshint maxlen: 100 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[camelCase("parse_as_" + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[camelCase("get_trusted_" + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[camelCase("trust_as_" + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`. They can be detected by
	        // the presence of `chrome.app.runtime` (see https://developer.chrome.com/apps/api_index)
	        isChromePackagedApp = $window.chrome && $window.chrome.app && $window.chrome.app.runtime,
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        vendorPrefix,
	        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false,
	        match;
	
	    if (bodyStyle) {
	      for (var prop in bodyStyle) {
	        if (match = vendorRegex.exec(prop)) {
	          vendorPrefix = match[0];
	          vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
	          break;
	        }
	      }
	
	      if (!vendorPrefix) {
	        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
	      }
	
	      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
	      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));
	
	      if (android && (!transitions ||  !animations)) {
	        transitions = isString(bodyStyle.webkitTransition);
	        animations = isString(bodyStyle.webkitAnimation);
	      }
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      // jshint -W018
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      // jshint +W018
	      hasEvent: function(event) {
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie <= 11) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      vendorPrefix: vendorPrefix,
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {
	
	    function handleRequestFn(tpl, ignoreRequestError) {
	      handleRequestFn.totalPendingRequests++;
	
	      // We consider the template cache holds only trusted templates, so
	      // there's no need to go through whitelisting again for keys that already
	      // are included in there. This also makes Angular accept any script
	      // directive, no matter its name. However, we still need to unwrap trusted
	      // types.
	      if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	        tpl = $sce.getTrustedResourceUrl(tpl);
	      }
	
	      var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	      if (isArray(transformResponse)) {
	        transformResponse = transformResponse.filter(function(transformer) {
	          return transformer !== defaultHttpResponseTransform;
	        });
	      } else if (transformResponse === defaultHttpResponseTransform) {
	        transformResponse = null;
	      }
	
	      return $http.get(tpl, extend({
	          cache: $templateCache,
	          transformResponse: transformResponse
	        }, httpOptions))
	        ['finally'](function() {
	          handleRequestFn.totalPendingRequests--;
	        })
	        .then(function(response) {
	          $templateCache.put(tpl, response.data);
	          return response.data;
	        }, handleError);
	
	      function handleError(resp) {
	        if (!ignoreRequestError) {
	          throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
	            tpl, resp.status, resp.statusText);
	        }
	        return $q.reject(resp);
	      }
	    }
	
	    handleRequestFn.totalPendingRequests = 0;
	
	    return handleRequestFn;
	  }];
	}
	
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) != -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        }
	        finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement("a");
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute("href", href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = rawDocument.cookie || '';
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * The general syntax in templates is as follows:
	 *
	 *         {{ expression [| filter_name[:parameter_value] ... ] }}
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false,
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
	 *     insensitive way.
	 *
	 *     Primitive values are converted to strings. Objects are not compared against primitives,
	 *     unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 * @param {string=} anyPropertyKey The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        //jshint -W086
	      case 'object':
	        //jshint +W086
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	      break;
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser == 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++) {/* jshint noempty: false */}
	
	  if (i == (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset == -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? "+" : "";
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^\-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if (match = string.match(R_ISO8601_STR)) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === "''" ? "'" : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceeding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
	          descending = predicate.charAt(0) == '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html A tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * This change permits the easy creation of action links with the `ngClick` directive
	 * without changing the location or causing page reloads, e.g.:
	 * `<a href="" ng-click="list.addItem()">Add Item</a>`
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example>
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example>
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName == "multiple") return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set("ngPattern", new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // we use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController(element, attrs, $scope, $animate, $interpolate) {
	  var form = this,
	      controls = [];
	
	  // init state
	  form.$error = {};
	  form.$$success = {};
	  form.$pending = undefined;
	  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
	  form.$dirty = false;
	  form.$pristine = true;
	  form.$valid = true;
	  form.$invalid = false;
	  form.$submitted = false;
	  form.$$parentForm = nullFormCtrl;
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  form.$rollbackViewValue = function() {
	    forEach(controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  form.$commitViewValue = function() {
	    forEach(controls, function(control) {
	      control.$commitViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  form.$addControl = function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    controls.push(control);
	
	    if (control.$name) {
	      form[control.$name] = control;
	    }
	
	    control.$$parentForm = form;
	  };
	
	  // Private API: rename a form control
	  form.$$renameControl = function(control, newName) {
	    var oldName = control.$name;
	
	    if (form[oldName] === control) {
	      delete form[oldName];
	    }
	    form[newName] = control;
	    control.$name = newName;
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  form.$removeControl = function(control) {
	    if (control.$name && form[control.$name] === control) {
	      delete form[control.$name];
	    }
	    forEach(form.$pending, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$error, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$$success, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	
	    arrayRemove(controls, control);
	    control.$$parentForm = nullFormCtrl;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setValidity
	   *
	   * @description
	   * Sets the validity of a form control.
	   *
	   * This method will also propagate to parent forms.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: element,
	    set: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        object[property] = [controller];
	      } else {
	        var index = list.indexOf(controller);
	        if (index === -1) {
	          list.push(controller);
	        }
	      }
	    },
	    unset: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        return;
	      }
	      arrayRemove(list, controller);
	      if (list.length === 0) {
	        delete object[property];
	      }
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  form.$setDirty = function() {
	    $animate.removeClass(element, PRISTINE_CLASS);
	    $animate.addClass(element, DIRTY_CLASS);
	    form.$dirty = true;
	    form.$pristine = false;
	    form.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
	   * state (ng-pristine class). This method will also propagate to all the controls contained
	   * in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  form.$setPristine = function() {
	    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    form.$dirty = false;
	    form.$pristine = true;
	    form.$submitted = false;
	    forEach(controls, function(control) {
	      control.$setPristine();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  form.$setUntouched = function() {
	    forEach(controls, function(control) {
	      control.$setUntouched();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  form.$setSubmitted = function() {
	    $animate.addClass(element, SUBMITTED_CLASS);
	    form.$submitted = true;
	    form.$$parentForm.$setSubmitted();
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	/* global VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  UNTOUCHED_CLASS: false,
	  TOUCHED_CLASS: false,
	  ngModelMinErr: false,
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        555555555555555555555555    666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	/* jshint maxlen:220 */
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	/* jshint maxlen:200 */
	var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	        var input = element(by.model('example.value'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            element.all(by.model('color.name')).get(0).click();
	
	            expect(color.getText()).toContain('red');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputing intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal;
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val);
	      }
	      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal;
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val);
	      }
	      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    if (element[0].checked) {
	      ctrl.$setViewValue(attr.value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    element[0].checked = (value == ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	 * the bound value.
	 *
	 * `ngValue` is useful when dynamically generating lists of radio buttons using
	 * {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * Likewise, `ngValue` can be used to generate `<option>` elements for
	 * the {@link select `select`} element. In that case however, only strings are supported
	 * for the `value `attribute, so the resulting `ngModel` will always be a string.
	 * Support for `select` models with non-string values is available via `ngOptions`.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 *   of the `input` element
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          attr.$set('value', scope.$eval(attr.ngValue));
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            attr.$set('value', value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var oldVal;
	
	        scope.$watch(attr[name], ngClassWatchAction, true);
	
	        attr.$observe('class', function(value) {
	          ngClassWatchAction(scope.$eval(attr[name]));
	        });
	
	
	        if (name !== 'ngClass') {
	          scope.$watch('$index', function($index, old$index) {
	            // jshint bitwise: false
	            var mod = $index & 1;
	            if (mod !== (old$index & 1)) {
	              var classes = arrayClasses(scope.$eval(attr[name]));
	              mod === selector ?
	                addClasses(classes) :
	                removeClasses(classes);
	            }
	          });
	        }
	
	        function addClasses(classes) {
	          var newClasses = digestClassCounts(classes, 1);
	          attr.$addClass(newClasses);
	        }
	
	        function removeClasses(classes) {
	          var newClasses = digestClassCounts(classes, -1);
	          attr.$removeClass(newClasses);
	        }
	
	        function digestClassCounts(classes, count) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          var classCounts = element.data('$classCounts') || createMap();
	          var classesToUpdate = [];
	          forEach(classes, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	          element.data('$classCounts', classCounts);
	          return classesToUpdate.join(' ');
	        }
	
	        function updateClasses(oldClasses, newClasses) {
	          var toAdd = arrayDifference(newClasses, oldClasses);
	          var toRemove = arrayDifference(oldClasses, newClasses);
	          toAdd = digestClassCounts(toAdd, 1);
	          toRemove = digestClassCounts(toRemove, -1);
	          if (toAdd && toAdd.length) {
	            $animate.addClass(element, toAdd);
	          }
	          if (toRemove && toRemove.length) {
	            $animate.removeClass(element, toRemove);
	          }
	        }
	
	        function ngClassWatchAction(newVal) {
	          // jshint bitwise: false
	          if (selector === true || (scope.$index & 1) === selector) {
	          // jshint bitwise: true
	            var newClasses = arrayClasses(newVal || []);
	            if (!oldVal) {
	              addClasses(newClasses);
	            } else if (!equals(newVal,oldVal)) {
	              var oldClasses = arrayClasses(oldVal);
	              updateClasses(oldClasses, newClasses);
	            }
	          }
	          if (isArray(newVal)) {
	            oldVal = newVal.map(function(v) { return shallowCopy(v); });
	          } else {
	            oldVal = shallowCopy(newVal);
	          }
	        }
	      }
	    };
	
	    function arrayDifference(tokens1, tokens2) {
	      var values = [];
	
	      outer:
	      for (var i = 0; i < tokens1.length; i++) {
	        var token = tokens1[i];
	        for (var j = 0; j < tokens2.length; j++) {
	          if (token == tokens2[j]) continue outer;
	        }
	        values.push(token);
	      }
	      return values;
	    }
	
	    function arrayClasses(classVal) {
	      var classes = [];
	      if (isArray(classVal)) {
	        forEach(classVal, function(v) {
	          classes = classes.concat(arrayClasses(v));
	        });
	        return classes;
	      } else if (isString(classVal)) {
	        return classVal.split(' ');
	      } else if (isObject(classVal)) {
	        forEach(classVal, function(v, k) {
	          if (v) {
	            classes = classes.concat(k.split(' '));
	          }
	        });
	        return classes;
	      }
	      return classVal;
	    }
	  }];
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example>
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = "John Smith";
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'} ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = "John Smith";
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'} ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @element html
	 * @description
	 *
	 * Angular has some features that can break certain
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement these rules then you must tell Angular not to use these features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following rules affect Angular:
	 *
	 * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
	 * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
	 * increase in the speed of evaluating Angular expressions.
	 *
	 * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
	 * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
	 * To make these directives work when a CSP rule is blocking inline styles, you must link to the
	 * `angular-csp.css` in your HTML manually.
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
	 * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
	 * however, triggers a CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
	 * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      // Note: the suffix `.csp` in the example name triggers
	      // csp mode in our http server!
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  // jshint evil:true
	                  try {
	                    eval('1+2');
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('protractor/node_modules/selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
	// bootstrap the system (before $parse is instantiated), for this reason we just have
	// the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // We expose the powerful $event object on the scope that provides access to the Window,
	          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	          // checks at the cost of speed since event handler expressions are not executed as
	          // frequently as regular change detection.
	          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event:event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).then(function() {
	                previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [ { name: 'template1.html', url: 'template1.html'},
	              { name: 'template2.html', url: 'template2.html'} ];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).then(function() {
	              previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function() {
	            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	              $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).then(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      // We want to control whitespace trimming so we use this convoluted approach
	      // to access the ngList attribute, which doesn't pre-trim the attribute
	      var ngList = element.attr(attr.$attr.ngList) || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	*/
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    PENDING_CLASS = 'ng-pending',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if ( attrs.stripBr && html == '<br>' ) {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
	    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	
	  var parsedNgModel = $parse($attr.ngModel),
	      parsedNgModelAssign = parsedNgModel.assign,
	      ngModelGet = parsedNgModel,
	      ngModelSet = parsedNgModelAssign,
	      pendingDebounce = null,
	      parserValid,
	      ctrl = this;
	
	  this.$$setOptions = function(options) {
	    ctrl.$options = options;
	    if (options && options.getterSetter) {
	      var invokeModelGetter = $parse($attr.ngModel + '()'),
	          invokeModelSetter = $parse($attr.ngModel + '($$$p)');
	
	      ngModelGet = function($scope) {
	        var modelValue = parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      ngModelSet = function($scope, newValue) {
	        if (isFunction(parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
	          $attr.ngModel, startingTag($element));
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  this.$render = noop;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  this.$isEmpty = function(value) {
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  };
	
	  this.$$updateEmptyClasses = function(value) {
	    if (ctrl.$isEmpty(value)) {
	      $animate.removeClass($element, NOT_EMPTY_CLASS);
	      $animate.addClass($element, EMPTY_CLASS);
	    } else {
	      $animate.removeClass($element, EMPTY_CLASS);
	      $animate.addClass($element, NOT_EMPTY_CLASS);
	    }
	  };
	
	
	  var currentValidationRunId = 0;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setValidity
	   *
	   * @description
	   * Change the validity state, and notify the form.
	   *
	   * This method can be called within $parsers/$formatters or a custom validation implementation.
	   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	   *
	   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	   *                          Skipped is used by Angular when validators do not run because of parse errors and
	   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: $element,
	    set: function(object, property) {
	      object[property] = true;
	    },
	    unset: function(object, property) {
	      delete object[property];
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  this.$setPristine = function() {
	    ctrl.$dirty = false;
	    ctrl.$pristine = true;
	    $animate.removeClass($element, DIRTY_CLASS);
	    $animate.addClass($element, PRISTINE_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  this.$setDirty = function() {
	    ctrl.$dirty = true;
	    ctrl.$pristine = false;
	    $animate.removeClass($element, PRISTINE_CLASS);
	    $animate.addClass($element, DIRTY_CLASS);
	    ctrl.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  this.$setUntouched = function() {
	    ctrl.$touched = false;
	    ctrl.$untouched = true;
	    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  this.$setTouched = function() {
	    ctrl.$touched = true;
	    ctrl.$untouched = false;
	    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for a some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as blur, you can have a situation where there is a period when
	   * the `$viewValue` is out of sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode == 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *        <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *        empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *        <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *         <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                ng-keydown="setEmpty($event, 'value1')">
	   *         value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *        <p id="inputDescription2">With $rollbackViewValue():</p>
	   *         <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                ng-keydown="setEmpty($event, 'value2', true)">
	   *         value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  this.$rollbackViewValue = function() {
	    $timeout.cancel(pendingDebounce);
	    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
	    ctrl.$render();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  this.$validate = function() {
	    // ignore $validate before model is initialized
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = ctrl.$$rawModelValue;
	
	    var prevValid = ctrl.$valid;
	    var prevModelValue = ctrl.$modelValue;
	
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	
	    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	
	        if (ctrl.$modelValue !== prevModelValue) {
	          ctrl.$$writeModelToScope();
	        }
	      }
	    });
	
	  };
	
	  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
	    currentValidationRunId++;
	    var localValidationRunId = currentValidationRunId;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = ctrl.$$parserName || 'parse';
	      if (isUndefined(parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!parserValid) {
	          forEach(ctrl.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(ctrl.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, parserValid);
	        return parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(ctrl.$validators, function(validator, name) {
	        var result = validator(modelValue, viewValue);
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(ctrl.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(ctrl.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        $q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === currentValidationRunId) {
	        ctrl.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  this.$commitViewValue = function() {
	    var viewValue = ctrl.$viewValue;
	
	    $timeout.cancel(pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
	      return;
	    }
	    ctrl.$$updateEmptyClasses(viewValue);
	    ctrl.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (ctrl.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  };
	
	  this.$$parseAndValidate = function() {
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (parserValid) {
	      for (var i = 0; i < ctrl.$parsers.length; i++) {
	        modelValue = ctrl.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      // ctrl.$modelValue has not been touched yet...
	      ctrl.$modelValue = ngModelGet($scope);
	    }
	    var prevModelValue = ctrl.$modelValue;
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	    ctrl.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      ctrl.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (ctrl.$modelValue !== prevModelValue) {
	        ctrl.$$writeModelToScope();
	      }
	    }
	  };
	
	  this.$$writeModelToScope = function() {
	    ngModelSet($scope, ctrl.$modelValue);
	    forEach(ctrl.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        $exceptionHandler(e);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
	   * in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  this.$setViewValue = function(value, trigger) {
	    ctrl.$viewValue = value;
	    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
	      ctrl.$$debounceViewValueCommit(trigger);
	    }
	  };
	
	  this.$$debounceViewValueCommit = function(trigger) {
	    var debounceDelay = 0,
	        options = ctrl.$options,
	        debounce;
	
	    if (options && isDefined(options.debounce)) {
	      debounce = options.debounce;
	      if (isNumber(debounce)) {
	        debounceDelay = debounce;
	      } else if (isNumber(debounce[trigger])) {
	        debounceDelay = debounce[trigger];
	      } else if (isNumber(debounce['default'])) {
	        debounceDelay = debounce['default'];
	      }
	    }
	
	    $timeout.cancel(pendingDebounce);
	    if (debounceDelay) {
	      pendingDebounce = $timeout(function() {
	        ctrl.$commitViewValue();
	      }, debounceDelay);
	    } else if ($rootScope.$$phase) {
	      ctrl.$commitViewValue();
	    } else {
	      $scope.$apply(function() {
	        ctrl.$commitViewValue();
	      });
	    }
	  };
	
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  $scope.$watch(function ngModelWatch() {
	    var modelValue = ngModelGet($scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        ctrl.$$runValidators(modelValue, viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm;
	
	          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
	            element.on(modelCtrl.$options.updateOn, function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(modelCtrl.$setTouched);
	            } else {
	              scope.$apply(modelCtrl.$setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	 * events that will trigger a model update and/or a debouncing delay so that the actual update only
	 * takes place when a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	 *
	 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging of the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	       `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 * @example
	
	  The following example shows how to override immediate updates. Changes on the inputs within the
	  form will update the model only when the control loses focus (blur event). If `escape` key is
	  pressed while the input field is focused, the value is reset to the value in the current model.
	
	  <example name="ngModelOptions-directive-blur" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ updateOn: 'blur' }"
	                   ng-keyup="cancel($event)" />
	          </label><br />
	          <label>Other data:
	            <input type="text" ng-model="user.data" />
	          </label><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	        <pre>user.data = <span ng-bind="user.data"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'John', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode == 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	    </file>
	    <file name="protractor.js" type="protractor">
	      var model = element(by.binding('user.name'));
	      var input = element(by.model('user.name'));
	      var other = element(by.model('user.data'));
	
	      it('should allow custom events', function() {
	        input.sendKeys(' Doe');
	        input.click();
	        expect(model.getText()).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John Doe');
	      });
	
	      it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' Doe');
	        expect(input.getAttribute('value')).toEqual('John Doe');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John');
	      });
	    </file>
	  </example>
	
	  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	  <example name="ngModelOptions-directive-debounce" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ debounce: 1000 }" />
	          </label>
	          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
	          <br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'Igor' };
	        }]);
	    </file>
	  </example>
	
	  This one shows how to bind to getter/setters:
	
	  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ getterSetter: true }" />
	          </label>
	        </form>
	        <pre>user.name = <span ng-bind="user.name()"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('getterSetterExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	    </file>
	  </example>
	 */
	var ngModelOptionsDirective = function() {
	  return {
	    restrict: 'A',
	    controller: ['$scope', '$attrs', function($scope, $attrs) {
	      var that = this;
	      this.$options = copy($scope.$eval($attrs.ngModelOptions));
	      // Allow adding/overriding bound events
	      if (isDefined(this.$options.updateOn)) {
	        this.$options.updateOnDefault = false;
	        // extract "default" pseudo-event from list of events that can trigger a model update
	        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
	          that.$options.updateOnDefault = true;
	          return ' ';
	        }));
	      } else {
	        this.$options.updateOnDefault = true;
	      }
	    }]
	  };
	};
	
	
	
	// helper methods
	function addSetValidityMethod(context) {
	  var ctrl = context.ctrl,
	      $element = context.$element,
	      classCache = {},
	      set = context.set,
	      unset = context.unset,
	      $animate = context.$animate;
	
	  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));
	
	  ctrl.$setValidity = setValidity;
	
	  function setValidity(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet('$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup('$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(ctrl.$error, validationErrorKey, controller);
	      unset(ctrl.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(ctrl.$error, validationErrorKey, controller);
	        set(ctrl.$$success, validationErrorKey, controller);
	      } else {
	        set(ctrl.$error, validationErrorKey, controller);
	        unset(ctrl.$$success, validationErrorKey, controller);
	      }
	    }
	    if (ctrl.$pending) {
	      cachedToggleClass(PENDING_CLASS, true);
	      ctrl.$valid = ctrl.$invalid = undefined;
	      toggleValidationCss('', null);
	    } else {
	      cachedToggleClass(PENDING_CLASS, false);
	      ctrl.$valid = isObjectEmpty(ctrl.$error);
	      ctrl.$invalid = !ctrl.$valid;
	      toggleValidationCss('', ctrl.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in ctrl.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (ctrl.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (ctrl.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(validationErrorKey, combinedState);
	    ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
	  }
	
	  function createAndSet(name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(className, switchValue) {
	    if (switchValue && !classCache[className]) {
	      $animate.addClass($element, className);
	      classCache[className] = true;
	    } else if (!switchValue && classCache[className]) {
	      $animate.removeClass($element, className);
	      classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
	 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
	 * increasing speed by not creating a new scope for each repeated instance, as well as providing
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	 *  to a non-string value. This is because an option element can only be bound to string values at
	 * present.
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	// jshint maxlen: false
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	// jshint maxlen: 100
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        "Expected expression in form of " +
	        "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
	        " but got '{0}'. Element: {1}",
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? angular.copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      var emptyOption;
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      var renderEmptyOption = function() {
	        if (!providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	        selectElement.val('');
	        emptyOption.prop('selected', true); // needed for IE
	        emptyOption.attr('selected', true);
	      };
	
	      var removeEmptyOption = function() {
	        if (!providedEmptyOption) {
	          emptyOption.remove();
	        }
	      };
	
	
	      var renderUnknownOption = function() {
	        selectElement.prepend(unknownOption);
	        selectElement.val('?');
	        unknownOption.prop('selected', true); // needed for IE
	        unknownOption.attr('selected', true);
	      };
	
	      var removeUnknownOption = function() {
	        unknownOption.remove();
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var option = options.getOptionFromViewValue(value);
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              removeUnknownOption();
	              removeEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            if (value === null || providedEmptyOption) {
	              removeUnknownOption();
	              renderEmptyOption();
	            } else {
	              removeEmptyOption();
	              renderUnknownOption();
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            removeEmptyOption();
	            removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
	          options.items.forEach(function(option) {
	            option.element.selected = false;
	          });
	
	          if (value) {
	            value.forEach(function(item) {
	              var option = options.getOptionFromViewValue(item);
	              if (option) option.element.selected = true;
	            });
	          }
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(emptyOption)(scope);
	
	        // remove the class, which is added automatically because we recompile the element and it
	        // becomes the compilation root
	        emptyOption.removeClass('ng-scope');
	      } else {
	        emptyOption = jqLite(optionTemplate.cloneNode(false));
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        if (option.value !== element.value) element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, ngRepeat then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, ngRepeat will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have an identifier property, you should track
	 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *     {{model.name}}
	 * </div>
	 * ```
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length == 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // jshint bitwise: false
	    scope.$odd = !(scope.$even = (index&1) === 0);
	    // jshint bitwise: true
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) != nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	 * with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass except that
	 * you must also include the !important flag to override the display property
	 * so that you can perform an animation when the element is hidden during the time of the animation.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add-active,
	 * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	 *     then the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-show" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-show" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class in CSS:
	 *
	 * ```css
	 * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	 * CSS class is added and removed for you instead of your own CSS class.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	 *     the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-hide" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-hide" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-hide {
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function ngSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function() { array.splice(index, 1); };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
	          $animate.cancel(previousLeaveAnimations[i]);
	        }
	        previousLeaveAnimations.length = 0;
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
	          promise.then(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
	    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
	 * that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}">{{text}}</pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function(){
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = "https://google.com";
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example>
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type == 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function chromeHack(optionElement) {
	  // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	  // Adding an <option selected="selected"> element to a <select required="required"> should
	  // automatically select the new element
	  if (optionElement[0].hasAttribute('selected')) {
	    optionElement[0].selected = true;
	  }
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', function($element, $scope) {
	
	  var self = this,
	      optionsMap = new HashMap();
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	  self.renderUnknownOption = function(val) {
	    var unknownVal = '? ' + hashKey(val) + ' ?';
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    $element.val(unknownVal);
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    self.removeUnknownOption();
	    return $element.val();
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	      $element.val(value);
	      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        $element.val('');
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.put(value, count + 1);
	    self.ngModelCtrl.$render();
	    chromeHack(element);
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.remove(value);
	        if (value === '') {
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.put(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (interpolateValueFn) {
	      // The value attribute is interpolated
	      var oldVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	    optionElement.on('$destroy', function() {
	      self.removeOption(optionAttrs.value);
	      self.ngModelCtrl.$render();
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `SELECT` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * If you want dynamic value attributes, you can use interpolation inside the value attribute.
	 *
	 * <div class="alert alert-warning">
	 * Note that the value of a `select` directive used without `ngOptions` is always a string.
	 * When the model needs to be bound to a non-string value, you must either explicitly convert it
	 * using a directive (see example below) or use `ngOptions` to specify the set of options.
	 * This is because an option element can only be bound to string values at present.
	 * </div>
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * <div class="alert alert-info">
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
	 * a new scope for each repeated instance.
	 * </div>
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1',
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="ngrepeat-select" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       repeatSelect: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       var select = element(by.css('select'));
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected) {
	              array.push(option.value);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          var items = new HashMap(value);
	          forEach(element.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        var interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        var interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	var styleDirective = valueFn({
	  restrict: 'E',
	  terminal: false
	});
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  //AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	//try to bind to jquery now so that one can write jqLite(document).ready()
	//but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(window.document).ready(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 622 */
30,
/* 623 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 624 */
[1741, 623, 622],
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, setImmediate, process) {/*!
	 * async
	 * https://github.com/caolan/async
	 *
	 * Copyright 2010-2014 Caolan McMahon
	 * Released under the MIT license
	 */
	(function () {
	
	    var async = {};
	    function noop() {}
	    function identity(v) {
	        return v;
	    }
	    function toBool(v) {
	        return !!v;
	    }
	    function notId(v) {
	        return !v;
	    }
	
	    // global on the server, window in the browser
	    var previous_async;
	
	    // Establish the root object, `window` (`self`) in the browser, `global`
	    // on the server, or `this` in some virtual machines. We use `self`
	    // instead of `window` for `WebWorker` support.
	    var root = typeof self === 'object' && self.self === self && self ||
	            typeof global === 'object' && global.global === global && global ||
	            this;
	
	    if (root != null) {
	        previous_async = root.async;
	    }
	
	    async.noConflict = function () {
	        root.async = previous_async;
	        return async;
	    };
	
	    function only_once(fn) {
	        return function() {
	            if (fn === null) throw new Error("Callback was already called.");
	            fn.apply(this, arguments);
	            fn = null;
	        };
	    }
	
	    function _once(fn) {
	        return function() {
	            if (fn === null) return;
	            fn.apply(this, arguments);
	            fn = null;
	        };
	    }
	
	    //// cross-browser compatiblity functions ////
	
	    var _toString = Object.prototype.toString;
	
	    var _isArray = Array.isArray || function (obj) {
	        return _toString.call(obj) === '[object Array]';
	    };
	
	    // Ported from underscore.js isObject
	    var _isObject = function(obj) {
	        var type = typeof obj;
	        return type === 'function' || type === 'object' && !!obj;
	    };
	
	    function _isArrayLike(arr) {
	        return _isArray(arr) || (
	            // has a positive integer length property
	            typeof arr.length === "number" &&
	            arr.length >= 0 &&
	            arr.length % 1 === 0
	        );
	    }
	
	    function _arrayEach(arr, iterator) {
	        var index = -1,
	            length = arr.length;
	
	        while (++index < length) {
	            iterator(arr[index], index, arr);
	        }
	    }
	
	    function _map(arr, iterator) {
	        var index = -1,
	            length = arr.length,
	            result = Array(length);
	
	        while (++index < length) {
	            result[index] = iterator(arr[index], index, arr);
	        }
	        return result;
	    }
	
	    function _range(count) {
	        return _map(Array(count), function (v, i) { return i; });
	    }
	
	    function _reduce(arr, iterator, memo) {
	        _arrayEach(arr, function (x, i, a) {
	            memo = iterator(memo, x, i, a);
	        });
	        return memo;
	    }
	
	    function _forEachOf(object, iterator) {
	        _arrayEach(_keys(object), function (key) {
	            iterator(object[key], key);
	        });
	    }
	
	    function _indexOf(arr, item) {
	        for (var i = 0; i < arr.length; i++) {
	            if (arr[i] === item) return i;
	        }
	        return -1;
	    }
	
	    var _keys = Object.keys || function (obj) {
	        var keys = [];
	        for (var k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                keys.push(k);
	            }
	        }
	        return keys;
	    };
	
	    function _keyIterator(coll) {
	        var i = -1;
	        var len;
	        var keys;
	        if (_isArrayLike(coll)) {
	            len = coll.length;
	            return function next() {
	                i++;
	                return i < len ? i : null;
	            };
	        } else {
	            keys = _keys(coll);
	            len = keys.length;
	            return function next() {
	                i++;
	                return i < len ? keys[i] : null;
	            };
	        }
	    }
	
	    // Similar to ES6's rest param (http://ariya.ofilabs.com/2013/03/es6-and-rest-parameter.html)
	    // This accumulates the arguments passed into an array, after a given index.
	    // From underscore.js (https://github.com/jashkenas/underscore/pull/2140).
	    function _restParam(func, startIndex) {
	        startIndex = startIndex == null ? func.length - 1 : +startIndex;
	        return function() {
	            var length = Math.max(arguments.length - startIndex, 0);
	            var rest = Array(length);
	            for (var index = 0; index < length; index++) {
	                rest[index] = arguments[index + startIndex];
	            }
	            switch (startIndex) {
	                case 0: return func.call(this, rest);
	                case 1: return func.call(this, arguments[0], rest);
	            }
	            // Currently unused but handle cases outside of the switch statement:
	            // var args = Array(startIndex + 1);
	            // for (index = 0; index < startIndex; index++) {
	            //     args[index] = arguments[index];
	            // }
	            // args[startIndex] = rest;
	            // return func.apply(this, args);
	        };
	    }
	
	    function _withoutIndex(iterator) {
	        return function (value, index, callback) {
	            return iterator(value, callback);
	        };
	    }
	
	    //// exported async module functions ////
	
	    //// nextTick implementation with browser-compatible fallback ////
	
	    // capture the global reference to guard against fakeTimer mocks
	    var _setImmediate = typeof setImmediate === 'function' && setImmediate;
	
	    var _delay = _setImmediate ? function(fn) {
	        // not a direct alias for IE10 compatibility
	        _setImmediate(fn);
	    } : function(fn) {
	        setTimeout(fn, 0);
	    };
	
	    if (typeof process === 'object' && typeof process.nextTick === 'function') {
	        async.nextTick = process.nextTick;
	    } else {
	        async.nextTick = _delay;
	    }
	    async.setImmediate = _setImmediate ? _delay : async.nextTick;
	
	
	    async.forEach =
	    async.each = function (arr, iterator, callback) {
	        return async.eachOf(arr, _withoutIndex(iterator), callback);
	    };
	
	    async.forEachSeries =
	    async.eachSeries = function (arr, iterator, callback) {
	        return async.eachOfSeries(arr, _withoutIndex(iterator), callback);
	    };
	
	
	    async.forEachLimit =
	    async.eachLimit = function (arr, limit, iterator, callback) {
	        return _eachOfLimit(limit)(arr, _withoutIndex(iterator), callback);
	    };
	
	    async.forEachOf =
	    async.eachOf = function (object, iterator, callback) {
	        callback = _once(callback || noop);
	        object = object || [];
	
	        var iter = _keyIterator(object);
	        var key, completed = 0;
	
	        while ((key = iter()) != null) {
	            completed += 1;
	            iterator(object[key], key, only_once(done));
	        }
	
	        if (completed === 0) callback(null);
	
	        function done(err) {
	            completed--;
	            if (err) {
	                callback(err);
	            }
	            // Check key is null in case iterator isn't exhausted
	            // and done resolved synchronously.
	            else if (key === null && completed <= 0) {
	                callback(null);
	            }
	        }
	    };
	
	    async.forEachOfSeries =
	    async.eachOfSeries = function (obj, iterator, callback) {
	        callback = _once(callback || noop);
	        obj = obj || [];
	        var nextKey = _keyIterator(obj);
	        var key = nextKey();
	        function iterate() {
	            var sync = true;
	            if (key === null) {
	                return callback(null);
	            }
	            iterator(obj[key], key, only_once(function (err) {
	                if (err) {
	                    callback(err);
	                }
	                else {
	                    key = nextKey();
	                    if (key === null) {
	                        return callback(null);
	                    } else {
	                        if (sync) {
	                            async.setImmediate(iterate);
	                        } else {
	                            iterate();
	                        }
	                    }
	                }
	            }));
	            sync = false;
	        }
	        iterate();
	    };
	
	
	
	    async.forEachOfLimit =
	    async.eachOfLimit = function (obj, limit, iterator, callback) {
	        _eachOfLimit(limit)(obj, iterator, callback);
	    };
	
	    function _eachOfLimit(limit) {
	
	        return function (obj, iterator, callback) {
	            callback = _once(callback || noop);
	            obj = obj || [];
	            var nextKey = _keyIterator(obj);
	            if (limit <= 0) {
	                return callback(null);
	            }
	            var done = false;
	            var running = 0;
	            var errored = false;
	
	            (function replenish () {
	                if (done && running <= 0) {
	                    return callback(null);
	                }
	
	                while (running < limit && !errored) {
	                    var key = nextKey();
	                    if (key === null) {
	                        done = true;
	                        if (running <= 0) {
	                            callback(null);
	                        }
	                        return;
	                    }
	                    running += 1;
	                    iterator(obj[key], key, only_once(function (err) {
	                        running -= 1;
	                        if (err) {
	                            callback(err);
	                            errored = true;
	                        }
	                        else {
	                            replenish();
	                        }
	                    }));
	                }
	            })();
	        };
	    }
	
	
	    function doParallel(fn) {
	        return function (obj, iterator, callback) {
	            return fn(async.eachOf, obj, iterator, callback);
	        };
	    }
	    function doParallelLimit(fn) {
	        return function (obj, limit, iterator, callback) {
	            return fn(_eachOfLimit(limit), obj, iterator, callback);
	        };
	    }
	    function doSeries(fn) {
	        return function (obj, iterator, callback) {
	            return fn(async.eachOfSeries, obj, iterator, callback);
	        };
	    }
	
	    function _asyncMap(eachfn, arr, iterator, callback) {
	        callback = _once(callback || noop);
	        arr = arr || [];
	        var results = _isArrayLike(arr) ? [] : {};
	        eachfn(arr, function (value, index, callback) {
	            iterator(value, function (err, v) {
	                results[index] = v;
	                callback(err);
	            });
	        }, function (err) {
	            callback(err, results);
	        });
	    }
	
	    async.map = doParallel(_asyncMap);
	    async.mapSeries = doSeries(_asyncMap);
	    async.mapLimit = doParallelLimit(_asyncMap);
	
	    // reduce only has a series version, as doing reduce in parallel won't
	    // work in many situations.
	    async.inject =
	    async.foldl =
	    async.reduce = function (arr, memo, iterator, callback) {
	        async.eachOfSeries(arr, function (x, i, callback) {
	            iterator(memo, x, function (err, v) {
	                memo = v;
	                callback(err);
	            });
	        }, function (err) {
	            callback(err, memo);
	        });
	    };
	
	    async.foldr =
	    async.reduceRight = function (arr, memo, iterator, callback) {
	        var reversed = _map(arr, identity).reverse();
	        async.reduce(reversed, memo, iterator, callback);
	    };
	
	    async.transform = function (arr, memo, iterator, callback) {
	        if (arguments.length === 3) {
	            callback = iterator;
	            iterator = memo;
	            memo = _isArray(arr) ? [] : {};
	        }
	
	        async.eachOf(arr, function(v, k, cb) {
	            iterator(memo, v, k, cb);
	        }, function(err) {
	            callback(err, memo);
	        });
	    };
	
	    function _filter(eachfn, arr, iterator, callback) {
	        var results = [];
	        eachfn(arr, function (x, index, callback) {
	            iterator(x, function (v) {
	                if (v) {
	                    results.push({index: index, value: x});
	                }
	                callback();
	            });
	        }, function () {
	            callback(_map(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), function (x) {
	                return x.value;
	            }));
	        });
	    }
	
	    async.select =
	    async.filter = doParallel(_filter);
	
	    async.selectLimit =
	    async.filterLimit = doParallelLimit(_filter);
	
	    async.selectSeries =
	    async.filterSeries = doSeries(_filter);
	
	    function _reject(eachfn, arr, iterator, callback) {
	        _filter(eachfn, arr, function(value, cb) {
	            iterator(value, function(v) {
	                cb(!v);
	            });
	        }, callback);
	    }
	    async.reject = doParallel(_reject);
	    async.rejectLimit = doParallelLimit(_reject);
	    async.rejectSeries = doSeries(_reject);
	
	    function _createTester(eachfn, check, getResult) {
	        return function(arr, limit, iterator, cb) {
	            function done() {
	                if (cb) cb(getResult(false, void 0));
	            }
	            function iteratee(x, _, callback) {
	                if (!cb) return callback();
	                iterator(x, function (v) {
	                    if (cb && check(v)) {
	                        cb(getResult(true, x));
	                        cb = iterator = false;
	                    }
	                    callback();
	                });
	            }
	            if (arguments.length > 3) {
	                eachfn(arr, limit, iteratee, done);
	            } else {
	                cb = iterator;
	                iterator = limit;
	                eachfn(arr, iteratee, done);
	            }
	        };
	    }
	
	    async.any =
	    async.some = _createTester(async.eachOf, toBool, identity);
	
	    async.someLimit = _createTester(async.eachOfLimit, toBool, identity);
	
	    async.all =
	    async.every = _createTester(async.eachOf, notId, notId);
	
	    async.everyLimit = _createTester(async.eachOfLimit, notId, notId);
	
	    function _findGetResult(v, x) {
	        return x;
	    }
	    async.detect = _createTester(async.eachOf, identity, _findGetResult);
	    async.detectSeries = _createTester(async.eachOfSeries, identity, _findGetResult);
	    async.detectLimit = _createTester(async.eachOfLimit, identity, _findGetResult);
	
	    async.sortBy = function (arr, iterator, callback) {
	        async.map(arr, function (x, callback) {
	            iterator(x, function (err, criteria) {
	                if (err) {
	                    callback(err);
	                }
	                else {
	                    callback(null, {value: x, criteria: criteria});
	                }
	            });
	        }, function (err, results) {
	            if (err) {
	                return callback(err);
	            }
	            else {
	                callback(null, _map(results.sort(comparator), function (x) {
	                    return x.value;
	                }));
	            }
	
	        });
	
	        function comparator(left, right) {
	            var a = left.criteria, b = right.criteria;
	            return a < b ? -1 : a > b ? 1 : 0;
	        }
	    };
	
	    async.auto = function (tasks, concurrency, callback) {
	        if (typeof arguments[1] === 'function') {
	            // concurrency is optional, shift the args.
	            callback = concurrency;
	            concurrency = null;
	        }
	        callback = _once(callback || noop);
	        var keys = _keys(tasks);
	        var remainingTasks = keys.length;
	        if (!remainingTasks) {
	            return callback(null);
	        }
	        if (!concurrency) {
	            concurrency = remainingTasks;
	        }
	
	        var results = {};
	        var runningTasks = 0;
	
	        var hasError = false;
	
	        var listeners = [];
	        function addListener(fn) {
	            listeners.unshift(fn);
	        }
	        function removeListener(fn) {
	            var idx = _indexOf(listeners, fn);
	            if (idx >= 0) listeners.splice(idx, 1);
	        }
	        function taskComplete() {
	            remainingTasks--;
	            _arrayEach(listeners.slice(0), function (fn) {
	                fn();
	            });
	        }
	
	        addListener(function () {
	            if (!remainingTasks) {
	                callback(null, results);
	            }
	        });
	
	        _arrayEach(keys, function (k) {
	            if (hasError) return;
	            var task = _isArray(tasks[k]) ? tasks[k]: [tasks[k]];
	            var taskCallback = _restParam(function(err, args) {
	                runningTasks--;
	                if (args.length <= 1) {
	                    args = args[0];
	                }
	                if (err) {
	                    var safeResults = {};
	                    _forEachOf(results, function(val, rkey) {
	                        safeResults[rkey] = val;
	                    });
	                    safeResults[k] = args;
	                    hasError = true;
	
	                    callback(err, safeResults);
	                }
	                else {
	                    results[k] = args;
	                    async.setImmediate(taskComplete);
	                }
	            });
	            var requires = task.slice(0, task.length - 1);
	            // prevent dead-locks
	            var len = requires.length;
	            var dep;
	            while (len--) {
	                if (!(dep = tasks[requires[len]])) {
	                    throw new Error('Has nonexistent dependency in ' + requires.join(', '));
	                }
	                if (_isArray(dep) && _indexOf(dep, k) >= 0) {
	                    throw new Error('Has cyclic dependencies');
	                }
	            }
	            function ready() {
	                return runningTasks < concurrency && _reduce(requires, function (a, x) {
	                    return (a && results.hasOwnProperty(x));
	                }, true) && !results.hasOwnProperty(k);
	            }
	            if (ready()) {
	                runningTasks++;
	                task[task.length - 1](taskCallback, results);
	            }
	            else {
	                addListener(listener);
	            }
	            function listener() {
	                if (ready()) {
	                    runningTasks++;
	                    removeListener(listener);
	                    task[task.length - 1](taskCallback, results);
	                }
	            }
	        });
	    };
	
	
	
	    async.retry = function(times, task, callback) {
	        var DEFAULT_TIMES = 5;
	        var DEFAULT_INTERVAL = 0;
	
	        var attempts = [];
	
	        var opts = {
	            times: DEFAULT_TIMES,
	            interval: DEFAULT_INTERVAL
	        };
	
	        function parseTimes(acc, t){
	            if(typeof t === 'number'){
	                acc.times = parseInt(t, 10) || DEFAULT_TIMES;
	            } else if(typeof t === 'object'){
	                acc.times = parseInt(t.times, 10) || DEFAULT_TIMES;
	                acc.interval = parseInt(t.interval, 10) || DEFAULT_INTERVAL;
	            } else {
	                throw new Error('Unsupported argument type for \'times\': ' + typeof t);
	            }
	        }
	
	        var length = arguments.length;
	        if (length < 1 || length > 3) {
	            throw new Error('Invalid arguments - must be either (task), (task, callback), (times, task) or (times, task, callback)');
	        } else if (length <= 2 && typeof times === 'function') {
	            callback = task;
	            task = times;
	        }
	        if (typeof times !== 'function') {
	            parseTimes(opts, times);
	        }
	        opts.callback = callback;
	        opts.task = task;
	
	        function wrappedTask(wrappedCallback, wrappedResults) {
	            function retryAttempt(task, finalAttempt) {
	                return function(seriesCallback) {
	                    task(function(err, result){
	                        seriesCallback(!err || finalAttempt, {err: err, result: result});
	                    }, wrappedResults);
	                };
	            }
	
	            function retryInterval(interval){
	                return function(seriesCallback){
	                    setTimeout(function(){
	                        seriesCallback(null);
	                    }, interval);
	                };
	            }
	
	            while (opts.times) {
	
	                var finalAttempt = !(opts.times-=1);
	                attempts.push(retryAttempt(opts.task, finalAttempt));
	                if(!finalAttempt && opts.interval > 0){
	                    attempts.push(retryInterval(opts.interval));
	                }
	            }
	
	            async.series(attempts, function(done, data){
	                data = data[data.length - 1];
	                (wrappedCallback || opts.callback)(data.err, data.result);
	            });
	        }
	
	        // If a callback is passed, run this as a controll flow
	        return opts.callback ? wrappedTask() : wrappedTask;
	    };
	
	    async.waterfall = function (tasks, callback) {
	        callback = _once(callback || noop);
	        if (!_isArray(tasks)) {
	            var err = new Error('First argument to waterfall must be an array of functions');
	            return callback(err);
	        }
	        if (!tasks.length) {
	            return callback();
	        }
	        function wrapIterator(iterator) {
	            return _restParam(function (err, args) {
	                if (err) {
	                    callback.apply(null, [err].concat(args));
	                }
	                else {
	                    var next = iterator.next();
	                    if (next) {
	                        args.push(wrapIterator(next));
	                    }
	                    else {
	                        args.push(callback);
	                    }
	                    ensureAsync(iterator).apply(null, args);
	                }
	            });
	        }
	        wrapIterator(async.iterator(tasks))();
	    };
	
	    function _parallel(eachfn, tasks, callback) {
	        callback = callback || noop;
	        var results = _isArrayLike(tasks) ? [] : {};
	
	        eachfn(tasks, function (task, key, callback) {
	            task(_restParam(function (err, args) {
	                if (args.length <= 1) {
	                    args = args[0];
	                }
	                results[key] = args;
	                callback(err);
	            }));
	        }, function (err) {
	            callback(err, results);
	        });
	    }
	
	    async.parallel = function (tasks, callback) {
	        _parallel(async.eachOf, tasks, callback);
	    };
	
	    async.parallelLimit = function(tasks, limit, callback) {
	        _parallel(_eachOfLimit(limit), tasks, callback);
	    };
	
	    async.series = function(tasks, callback) {
	        _parallel(async.eachOfSeries, tasks, callback);
	    };
	
	    async.iterator = function (tasks) {
	        function makeCallback(index) {
	            function fn() {
	                if (tasks.length) {
	                    tasks[index].apply(null, arguments);
	                }
	                return fn.next();
	            }
	            fn.next = function () {
	                return (index < tasks.length - 1) ? makeCallback(index + 1): null;
	            };
	            return fn;
	        }
	        return makeCallback(0);
	    };
	
	    async.apply = _restParam(function (fn, args) {
	        return _restParam(function (callArgs) {
	            return fn.apply(
	                null, args.concat(callArgs)
	            );
	        });
	    });
	
	    function _concat(eachfn, arr, fn, callback) {
	        var result = [];
	        eachfn(arr, function (x, index, cb) {
	            fn(x, function (err, y) {
	                result = result.concat(y || []);
	                cb(err);
	            });
	        }, function (err) {
	            callback(err, result);
	        });
	    }
	    async.concat = doParallel(_concat);
	    async.concatSeries = doSeries(_concat);
	
	    async.whilst = function (test, iterator, callback) {
	        callback = callback || noop;
	        if (test()) {
	            var next = _restParam(function(err, args) {
	                if (err) {
	                    callback(err);
	                } else if (test.apply(this, args)) {
	                    iterator(next);
	                } else {
	                    callback.apply(null, [null].concat(args));
	                }
	            });
	            iterator(next);
	        } else {
	            callback(null);
	        }
	    };
	
	    async.doWhilst = function (iterator, test, callback) {
	        var calls = 0;
	        return async.whilst(function() {
	            return ++calls <= 1 || test.apply(this, arguments);
	        }, iterator, callback);
	    };
	
	    async.until = function (test, iterator, callback) {
	        return async.whilst(function() {
	            return !test.apply(this, arguments);
	        }, iterator, callback);
	    };
	
	    async.doUntil = function (iterator, test, callback) {
	        return async.doWhilst(iterator, function() {
	            return !test.apply(this, arguments);
	        }, callback);
	    };
	
	    async.during = function (test, iterator, callback) {
	        callback = callback || noop;
	
	        var next = _restParam(function(err, args) {
	            if (err) {
	                callback(err);
	            } else {
	                args.push(check);
	                test.apply(this, args);
	            }
	        });
	
	        var check = function(err, truth) {
	            if (err) {
	                callback(err);
	            } else if (truth) {
	                iterator(next);
	            } else {
	                callback(null);
	            }
	        };
	
	        test(check);
	    };
	
	    async.doDuring = function (iterator, test, callback) {
	        var calls = 0;
	        async.during(function(next) {
	            if (calls++ < 1) {
	                next(null, true);
	            } else {
	                test.apply(this, arguments);
	            }
	        }, iterator, callback);
	    };
	
	    function _queue(worker, concurrency, payload) {
	        if (concurrency == null) {
	            concurrency = 1;
	        }
	        else if(concurrency === 0) {
	            throw new Error('Concurrency must not be zero');
	        }
	        function _insert(q, data, pos, callback) {
	            if (callback != null && typeof callback !== "function") {
	                throw new Error("task callback must be a function");
	            }
	            q.started = true;
	            if (!_isArray(data)) {
	                data = [data];
	            }
	            if(data.length === 0 && q.idle()) {
	                // call drain immediately if there are no tasks
	                return async.setImmediate(function() {
	                    q.drain();
	                });
	            }
	            _arrayEach(data, function(task) {
	                var item = {
	                    data: task,
	                    callback: callback || noop
	                };
	
	                if (pos) {
	                    q.tasks.unshift(item);
	                } else {
	                    q.tasks.push(item);
	                }
	
	                if (q.tasks.length === q.concurrency) {
	                    q.saturated();
	                }
	            });
	            async.setImmediate(q.process);
	        }
	        function _next(q, tasks) {
	            return function(){
	                workers -= 1;
	
	                var removed = false;
	                var args = arguments;
	                _arrayEach(tasks, function (task) {
	                    _arrayEach(workersList, function (worker, index) {
	                        if (worker === task && !removed) {
	                            workersList.splice(index, 1);
	                            removed = true;
	                        }
	                    });
	
	                    task.callback.apply(task, args);
	                });
	                if (q.tasks.length + workers === 0) {
	                    q.drain();
	                }
	                q.process();
	            };
	        }
	
	        var workers = 0;
	        var workersList = [];
	        var q = {
	            tasks: [],
	            concurrency: concurrency,
	            payload: payload,
	            saturated: noop,
	            empty: noop,
	            drain: noop,
	            started: false,
	            paused: false,
	            push: function (data, callback) {
	                _insert(q, data, false, callback);
	            },
	            kill: function () {
	                q.drain = noop;
	                q.tasks = [];
	            },
	            unshift: function (data, callback) {
	                _insert(q, data, true, callback);
	            },
	            process: function () {
	                while(!q.paused && workers < q.concurrency && q.tasks.length){
	
	                    var tasks = q.payload ?
	                        q.tasks.splice(0, q.payload) :
	                        q.tasks.splice(0, q.tasks.length);
	
	                    var data = _map(tasks, function (task) {
	                        return task.data;
	                    });
	
	                    if (q.tasks.length === 0) {
	                        q.empty();
	                    }
	                    workers += 1;
	                    workersList.push(tasks[0]);
	                    var cb = only_once(_next(q, tasks));
	                    worker(data, cb);
	                }
	            },
	            length: function () {
	                return q.tasks.length;
	            },
	            running: function () {
	                return workers;
	            },
	            workersList: function () {
	                return workersList;
	            },
	            idle: function() {
	                return q.tasks.length + workers === 0;
	            },
	            pause: function () {
	                q.paused = true;
	            },
	            resume: function () {
	                if (q.paused === false) { return; }
	                q.paused = false;
	                var resumeCount = Math.min(q.concurrency, q.tasks.length);
	                // Need to call q.process once per concurrent
	                // worker to preserve full concurrency after pause
	                for (var w = 1; w <= resumeCount; w++) {
	                    async.setImmediate(q.process);
	                }
	            }
	        };
	        return q;
	    }
	
	    async.queue = function (worker, concurrency) {
	        var q = _queue(function (items, cb) {
	            worker(items[0], cb);
	        }, concurrency, 1);
	
	        return q;
	    };
	
	    async.priorityQueue = function (worker, concurrency) {
	
	        function _compareTasks(a, b){
	            return a.priority - b.priority;
	        }
	
	        function _binarySearch(sequence, item, compare) {
	            var beg = -1,
	                end = sequence.length - 1;
	            while (beg < end) {
	                var mid = beg + ((end - beg + 1) >>> 1);
	                if (compare(item, sequence[mid]) >= 0) {
	                    beg = mid;
	                } else {
	                    end = mid - 1;
	                }
	            }
	            return beg;
	        }
	
	        function _insert(q, data, priority, callback) {
	            if (callback != null && typeof callback !== "function") {
	                throw new Error("task callback must be a function");
	            }
	            q.started = true;
	            if (!_isArray(data)) {
	                data = [data];
	            }
	            if(data.length === 0) {
	                // call drain immediately if there are no tasks
	                return async.setImmediate(function() {
	                    q.drain();
	                });
	            }
	            _arrayEach(data, function(task) {
	                var item = {
	                    data: task,
	                    priority: priority,
	                    callback: typeof callback === 'function' ? callback : noop
	                };
	
	                q.tasks.splice(_binarySearch(q.tasks, item, _compareTasks) + 1, 0, item);
	
	                if (q.tasks.length === q.concurrency) {
	                    q.saturated();
	                }
	                async.setImmediate(q.process);
	            });
	        }
	
	        // Start with a normal queue
	        var q = async.queue(worker, concurrency);
	
	        // Override push to accept second parameter representing priority
	        q.push = function (data, priority, callback) {
	            _insert(q, data, priority, callback);
	        };
	
	        // Remove unshift function
	        delete q.unshift;
	
	        return q;
	    };
	
	    async.cargo = function (worker, payload) {
	        return _queue(worker, 1, payload);
	    };
	
	    function _console_fn(name) {
	        return _restParam(function (fn, args) {
	            fn.apply(null, args.concat([_restParam(function (err, args) {
	                if (typeof console === 'object') {
	                    if (err) {
	                        if (console.error) {
	                            console.error(err);
	                        }
	                    }
	                    else if (console[name]) {
	                        _arrayEach(args, function (x) {
	                            console[name](x);
	                        });
	                    }
	                }
	            })]));
	        });
	    }
	    async.log = _console_fn('log');
	    async.dir = _console_fn('dir');
	    /*async.info = _console_fn('info');
	    async.warn = _console_fn('warn');
	    async.error = _console_fn('error');*/
	
	    async.memoize = function (fn, hasher) {
	        var memo = {};
	        var queues = {};
	        var has = Object.prototype.hasOwnProperty;
	        hasher = hasher || identity;
	        var memoized = _restParam(function memoized(args) {
	            var callback = args.pop();
	            var key = hasher.apply(null, args);
	            if (has.call(memo, key)) {   
	                async.setImmediate(function () {
	                    callback.apply(null, memo[key]);
	                });
	            }
	            else if (has.call(queues, key)) {
	                queues[key].push(callback);
	            }
	            else {
	                queues[key] = [callback];
	                fn.apply(null, args.concat([_restParam(function (args) {
	                    memo[key] = args;
	                    var q = queues[key];
	                    delete queues[key];
	                    for (var i = 0, l = q.length; i < l; i++) {
	                        q[i].apply(null, args);
	                    }
	                })]));
	            }
	        });
	        memoized.memo = memo;
	        memoized.unmemoized = fn;
	        return memoized;
	    };
	
	    async.unmemoize = function (fn) {
	        return function () {
	            return (fn.unmemoized || fn).apply(null, arguments);
	        };
	    };
	
	    function _times(mapper) {
	        return function (count, iterator, callback) {
	            mapper(_range(count), iterator, callback);
	        };
	    }
	
	    async.times = _times(async.map);
	    async.timesSeries = _times(async.mapSeries);
	    async.timesLimit = function (count, limit, iterator, callback) {
	        return async.mapLimit(_range(count), limit, iterator, callback);
	    };
	
	    async.seq = function (/* functions... */) {
	        var fns = arguments;
	        return _restParam(function (args) {
	            var that = this;
	
	            var callback = args[args.length - 1];
	            if (typeof callback == 'function') {
	                args.pop();
	            } else {
	                callback = noop;
	            }
	
	            async.reduce(fns, args, function (newargs, fn, cb) {
	                fn.apply(that, newargs.concat([_restParam(function (err, nextargs) {
	                    cb(err, nextargs);
	                })]));
	            },
	            function (err, results) {
	                callback.apply(that, [err].concat(results));
	            });
	        });
	    };
	
	    async.compose = function (/* functions... */) {
	        return async.seq.apply(null, Array.prototype.reverse.call(arguments));
	    };
	
	
	    function _applyEach(eachfn) {
	        return _restParam(function(fns, args) {
	            var go = _restParam(function(args) {
	                var that = this;
	                var callback = args.pop();
	                return eachfn(fns, function (fn, _, cb) {
	                    fn.apply(that, args.concat([cb]));
	                },
	                callback);
	            });
	            if (args.length) {
	                return go.apply(this, args);
	            }
	            else {
	                return go;
	            }
	        });
	    }
	
	    async.applyEach = _applyEach(async.eachOf);
	    async.applyEachSeries = _applyEach(async.eachOfSeries);
	
	
	    async.forever = function (fn, callback) {
	        var done = only_once(callback || noop);
	        var task = ensureAsync(fn);
	        function next(err) {
	            if (err) {
	                return done(err);
	            }
	            task(next);
	        }
	        next();
	    };
	
	    function ensureAsync(fn) {
	        return _restParam(function (args) {
	            var callback = args.pop();
	            args.push(function () {
	                var innerArgs = arguments;
	                if (sync) {
	                    async.setImmediate(function () {
	                        callback.apply(null, innerArgs);
	                    });
	                } else {
	                    callback.apply(null, innerArgs);
	                }
	            });
	            var sync = true;
	            fn.apply(this, args);
	            sync = false;
	        });
	    }
	
	    async.ensureAsync = ensureAsync;
	
	    async.constant = _restParam(function(values) {
	        var args = [null].concat(values);
	        return function (callback) {
	            return callback.apply(this, args);
	        };
	    });
	
	    async.wrapSync =
	    async.asyncify = function asyncify(func) {
	        return _restParam(function (args) {
	            var callback = args.pop();
	            var result;
	            try {
	                result = func.apply(this, args);
	            } catch (e) {
	                return callback(e);
	            }
	            // if result is Promise object
	            if (_isObject(result) && typeof result.then === "function") {
	                result.then(function(value) {
	                    callback(null, value);
	                })["catch"](function(err) {
	                    callback(err.message ? err : new Error(err));
	                });
	            } else {
	                callback(null, result);
	            }
	        });
	    };
	
	    // Node.js
	    if (typeof module === 'object' && module.exports) {
	        module.exports = async;
	    }
	    // AMD / RequireJS
	    else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return async;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    // included directly via <script> tag
	    else {
	        root.async = async;
	    }
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(260).setImmediate, __webpack_require__(28)))

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSchemaForm = __webpack_require__(118);
	
	var _jsonFormBaseComponent = __webpack_require__(49);
	
	var _jsonFormBaseComponent2 = _interopRequireDefault(_jsonFormBaseComponent);
	
	var _RaisedButton = __webpack_require__(142);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _FontIcon = __webpack_require__(139);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _lodash = __webpack_require__(87);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IconButton = __webpack_require__(45);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardArray = function (_React$Component) {
	    _inherits(ThingsboardArray, _React$Component);
	
	    function ThingsboardArray(props) {
	        _classCallCheck(this, ThingsboardArray);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardArray.__proto__ || Object.getPrototypeOf(ThingsboardArray)).call(this, props));
	
	        _this.onAppend = _this.onAppend.bind(_this);
	        _this.onDelete = _this.onDelete.bind(_this);
	        var model = _reactSchemaForm.utils.selectOrSet(_this.props.form.key, _this.props.model) || [];
	        var keys = [];
	        for (var i = 0; i < model.length; i++) {
	            keys.push(i);
	        }
	        _this.state = {
	            model: model,
	            keys: keys
	        };
	        return _this;
	    }
	
	    _createClass(ThingsboardArray, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.form.startEmpty !== true && this.state.model.length === 0) {
	                this.onAppend();
	            }
	        }
	    }, {
	        key: 'onAppend',
	        value: function onAppend() {
	            var empty;
	            if (this.props.form && this.props.form.schema && this.props.form.schema.items) {
	                var items = this.props.form.schema.items;
	                if (items.type && items.type.indexOf('object') !== -1) {
	                    empty = {};
	                    if (!this.props.options || this.props.options.setSchemaDefaults !== false) {
	                        empty = typeof items['default'] !== 'undefined' ? items['default'] : empty;
	                        if (empty) {
	                            _reactSchemaForm.utils.traverseSchema(items, function (prop, path) {
	                                if (typeof prop['default'] !== 'undefined') {
	                                    _reactSchemaForm.utils.selectOrSet(path, empty, prop['default']);
	                                }
	                            });
	                        }
	                    }
	                } else if (items.type && items.type.indexOf('array') !== -1) {
	                    empty = [];
	                    if (!this.props.options || this.props.options.setSchemaDefaults !== false) {
	                        empty = items['default'] || empty;
	                    }
	                } else {
	                    if (!this.props.options || this.props.options.setSchemaDefaults !== false) {
	                        empty = items['default'] || empty;
	                    }
	                }
	            }
	            var newModel = this.state.model;
	            newModel.push(empty);
	            var newKeys = this.state.keys;
	            var key = 0;
	            if (newKeys.length > 0) {
	                key = newKeys[newKeys.length - 1] + 1;
	            }
	            newKeys.push(key);
	            this.setState({
	                model: newModel,
	                keys: newKeys
	            });
	            this.props.onChangeValidate(this.state.model);
	        }
	    }, {
	        key: 'onDelete',
	        value: function onDelete(index) {
	            var newModel = this.state.model;
	            newModel.splice(index, 1);
	            var newKeys = this.state.keys;
	            newKeys.splice(index, 1);
	            this.setState({
	                model: newModel,
	                keys: newKeys
	            });
	            this.props.onChangeValidate(this.state.model);
	        }
	    }, {
	        key: 'setIndex',
	        value: function setIndex(index) {
	            return function (form) {
	                if (form.key) {
	                    form.key[form.key.indexOf('')] = index;
	                }
	            };
	        }
	    }, {
	        key: 'copyWithIndex',
	        value: function copyWithIndex(form, index) {
	            var copy = _lodash2.default.cloneDeep(form);
	            copy.arrayIndex = index;
	            _reactSchemaForm.utils.traverseForm(copy, this.setIndex(index));
	            return copy;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var arrays = [];
	            var fields = [];
	            var model = this.state.model;
	            var keys = this.state.keys;
	            var items = this.props.form.items;
	            for (var i = 0; i < model.length; i++) {
	                var removeButton = '';
	                if (!this.props.form.readonly) {
	                    var boundOnDelete = this.onDelete.bind(this, i);
	                    removeButton = _react2.default.createElement(
	                        _IconButton2.default,
	                        { iconClassName: 'material-icons', tooltip: 'Remove', onTouchTap: boundOnDelete },
	                        'clear'
	                    );
	                }
	                var forms = this.props.form.items.map(function (form, index) {
	                    var copy = this.copyWithIndex(form, i);
	                    return this.props.builder(copy, this.props.model, index, this.props.onChange, this.props.onColorClick, this.props.mapper, this.props.builder);
	                }.bind(this));
	                arrays.push(_react2.default.createElement(
	                    'li',
	                    { key: keys[i], className: 'list-group-item' },
	                    removeButton,
	                    forms
	                ));
	            }
	            var addButton = '';
	            if (!this.props.form.readonly) {
	                addButton = _react2.default.createElement(_RaisedButton2.default, { label: this.props.form.add || 'New',
	                    primary: true,
	                    icon: _react2.default.createElement(
	                        _FontIcon2.default,
	                        { className: 'material-icons' },
	                        'add'
	                    ),
	                    onTouchTap: this.onAppend });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tb-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tb-head-label' },
	                        this.props.form.title
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        { className: 'list-group' },
	                        arrays
	                    )
	                ),
	                addButton
	            );
	        }
	    }]);
	
	    return ThingsboardArray;
	}(_react2.default.Component);
	
	exports.default = (0, _jsonFormBaseComponent2.default)(ThingsboardArray);

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormBaseComponent = __webpack_require__(49);
	
	var _jsonFormBaseComponent2 = _interopRequireDefault(_jsonFormBaseComponent);
	
	var _Checkbox = __webpack_require__(108);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardCheckbox = function (_React$Component) {
	    _inherits(ThingsboardCheckbox, _React$Component);
	
	    function ThingsboardCheckbox() {
	        _classCallCheck(this, ThingsboardCheckbox);
	
	        return _possibleConstructorReturn(this, (ThingsboardCheckbox.__proto__ || Object.getPrototypeOf(ThingsboardCheckbox)).apply(this, arguments));
	    }
	
	    _createClass(ThingsboardCheckbox, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(_Checkbox2.default, {
	                name: this.props.form.key.slice(-1)[0],
	                value: this.props.form.key.slice(-1)[0],
	                defaultChecked: this.props.value || false,
	                label: this.props.form.title,
	                disabled: this.props.form.readonly,
	                onCheck: function onCheck(e, checked) {
	                    _this2.props.onChangeValidate(e);
	                },
	                style: { paddingTop: '14px' }
	            });
	        }
	    }]);
	
	    return ThingsboardCheckbox;
	}(_react2.default.Component);
	
	exports.default = (0, _jsonFormBaseComponent2.default)(ThingsboardCheckbox);

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(768);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _jsonFormBaseComponent = __webpack_require__(49);
	
	var _jsonFormBaseComponent2 = _interopRequireDefault(_jsonFormBaseComponent);
	
	var _reactcss = __webpack_require__(566);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _TextField = __webpack_require__(40);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _IconButton = __webpack_require__(45);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardColor = function (_React$Component) {
	    _inherits(ThingsboardColor, _React$Component);
	
	    function ThingsboardColor(props) {
	        _classCallCheck(this, ThingsboardColor);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardColor.__proto__ || Object.getPrototypeOf(ThingsboardColor)).call(this, props));
	
	        _this.onValueChanged = _this.onValueChanged.bind(_this);
	        _this.onSwatchClick = _this.onSwatchClick.bind(_this);
	        _this.onClear = _this.onClear.bind(_this);
	        var value = props.value ? props.value + '' : null;
	        var color = value != null ? (0, _tinycolor2.default)(value).toRgb() : null;
	        _this.state = {
	            color: color
	        };
	        return _this;
	    }
	
	    _createClass(ThingsboardColor, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var node = _reactDom2.default.findDOMNode(this);
	            var colContainer = (0, _jquery2.default)(node).children('#color-container');
	            colContainer.click(this, function (event) {
	                if (!event.data.props.form.readonly) {
	                    event.data.onSwatchClick(event);
	                }
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var node = _reactDom2.default.findDOMNode(this);
	            var colContainer = (0, _jquery2.default)(node).children('#color-container');
	            colContainer.off("click");
	        }
	    }, {
	        key: 'onValueChanged',
	        value: function onValueChanged(value) {
	            var color = null;
	            if (value != null) {
	                color = (0, _tinycolor2.default)(value);
	            }
	            this.setState({
	                color: value
	            });
	            var colorValue = '';
	            if (color != null && color.getAlpha() != 1) {
	                colorValue = color.toRgbString();
	            } else if (color != null) {
	                colorValue = color.toHexString();
	            }
	            this.props.onChangeValidate({
	                target: {
	                    value: colorValue
	                }
	            });
	        }
	    }, {
	        key: 'onSwatchClick',
	        value: function onSwatchClick(event) {
	            this.props.onColorClick(event, this.props.form.key, this.state.color);
	        }
	    }, {
	        key: 'onClear',
	        value: function onClear(event) {
	            if (event) {
	                event.stopPropagation();
	            }
	            this.onValueChanged(null);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var background = 'rgba(0,0,0,0)';
	            if (this.state.color != null) {
	                background = 'rgba(' + this.state.color.r + ', ' + this.state.color.g + ', ' + this.state.color.b + ', ' + this.state.color.a + ')';
	            }
	
	            var styles = (0, _reactcss2.default)({
	                'default': {
	                    color: {
	                        background: '' + background
	                    },
	                    swatch: {
	                        display: 'inline-block',
	                        marginRight: '10px',
	                        marginTop: 'auto',
	                        marginBottom: 'auto',
	                        cursor: 'pointer',
	                        opacity: '' + (this.props.form.readonly ? '0.6' : '1')
	                    },
	                    swatchText: {
	                        display: 'inline-block',
	                        width: '100%'
	                    },
	                    container: {
	                        display: 'flex'
	                    },
	                    colorContainer: {
	                        display: 'flex',
	                        width: '100%'
	                    }
	                }
	            });
	
	            var fieldClass = "tb-field";
	            if (this.props.form.required) {
	                fieldClass += " tb-required";
	            }
	            if (this.props.form.readonly) {
	                fieldClass += " tb-readonly";
	            }
	            if (this.state.focused) {
	                fieldClass += " tb-focused";
	            }
	
	            var stringColor = '';
	            if (this.state.color != null) {
	                var color = (0, _tinycolor2.default)(this.state.color);
	                stringColor = color.toRgbString();
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { style: styles.container },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'color-container', style: styles.colorContainer },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tb-color-preview', style: styles.swatch },
	                        _react2.default.createElement('div', { className: 'tb-color-result', style: styles.color })
	                    ),
	                    _react2.default.createElement(_TextField2.default, {
	                        className: fieldClass,
	                        floatingLabelText: this.props.form.title,
	                        hintText: this.props.form.placeholder,
	                        errorText: this.props.error,
	                        value: stringColor,
	                        disabled: this.props.form.readonly,
	                        style: styles.swatchText })
	                ),
	                _react2.default.createElement(
	                    _IconButton2.default,
	                    { iconClassName: 'material-icons', tooltip: 'Clear', onTouchTap: this.onClear },
	                    'clear'
	                )
	            );
	        }
	    }]);
	
	    return ThingsboardColor;
	}(_react2.default.Component);
	
	exports.default = (0, _jsonFormBaseComponent2.default)(ThingsboardColor);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormAceEditor = __webpack_require__(122);
	
	var _jsonFormAceEditor2 = _interopRequireDefault(_jsonFormAceEditor);
	
	__webpack_require__(275);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var css_beautify = _jsBeautify2.default.css;
	
	var ThingsboardCss = function (_React$Component) {
	    _inherits(ThingsboardCss, _React$Component);
	
	    function ThingsboardCss(props) {
	        _classCallCheck(this, ThingsboardCss);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardCss.__proto__ || Object.getPrototypeOf(ThingsboardCss)).call(this, props));
	
	        _this.onTidyCss = _this.onTidyCss.bind(_this);
	        return _this;
	    }
	
	    _createClass(ThingsboardCss, [{
	        key: 'onTidyCss',
	        value: function onTidyCss(css) {
	            return css_beautify(css, { indent_size: 4 });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_jsonFormAceEditor2.default, _extends({}, this.props, { mode: 'css', onTidy: this.onTidyCss }, this.state));
	        }
	    }]);
	
	    return ThingsboardCss;
	}(_react2.default.Component);
	
	exports.default = ThingsboardCss;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormBaseComponent = __webpack_require__(49);
	
	var _jsonFormBaseComponent2 = _interopRequireDefault(_jsonFormBaseComponent);
	
	var _DatePicker = __webpack_require__(213);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardDate = function (_React$Component) {
	    _inherits(ThingsboardDate, _React$Component);
	
	    function ThingsboardDate(props) {
	        _classCallCheck(this, ThingsboardDate);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardDate.__proto__ || Object.getPrototypeOf(ThingsboardDate)).call(this, props));
	
	        _this.onDatePicked = _this.onDatePicked.bind(_this);
	        return _this;
	    }
	
	    _createClass(ThingsboardDate, [{
	        key: 'onDatePicked',
	        value: function onDatePicked(empty, date) {
	            this.props.onChangeValidate(date);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var fieldClass = "tb-date-field";
	            if (this.props.form.required) {
	                fieldClass += " tb-required";
	            }
	            if (this.props.form.readonly) {
	                fieldClass += " tb-readonly";
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { style: { width: '100%', display: 'block' } },
	                _react2.default.createElement(_DatePicker2.default, {
	                    className: fieldClass,
	                    mode: 'landscape',
	                    autoOk: true,
	                    hintText: this.props.form.title,
	                    onChange: this.onDatePicked,
	                    onShow: null,
	                    onDismiss: null,
	                    disabled: this.props.form.readonly,
	                    style: this.props.form.style || { width: '100%' } })
	            );
	        }
	    }]);
	
	    return ThingsboardDate;
	}(_react2.default.Component);
	
	exports.default = (0, _jsonFormBaseComponent2.default)(ThingsboardDate);

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardFieldSet = function (_React$Component) {
	    _inherits(ThingsboardFieldSet, _React$Component);
	
	    function ThingsboardFieldSet() {
	        _classCallCheck(this, ThingsboardFieldSet);
	
	        return _possibleConstructorReturn(this, (ThingsboardFieldSet.__proto__ || Object.getPrototypeOf(ThingsboardFieldSet)).apply(this, arguments));
	    }
	
	    _createClass(ThingsboardFieldSet, [{
	        key: 'render',
	        value: function render() {
	            var forms = this.props.form.items.map(function (form, index) {
	                return this.props.builder(form, this.props.model, index, this.props.onChange, this.props.onColorClick, this.props.mapper, this.props.builder);
	            }.bind(this));
	
	            return _react2.default.createElement(
	                'div',
	                { style: { paddingTop: '20px' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tb-head-label' },
	                    this.props.form.title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    forms
	                )
	            );
	        }
	    }]);
	
	    return ThingsboardFieldSet;
	}(_react2.default.Component);
	
	exports.default = ThingsboardFieldSet;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormAceEditor = __webpack_require__(122);
	
	var _jsonFormAceEditor2 = _interopRequireDefault(_jsonFormAceEditor);
	
	__webpack_require__(276);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var html_beautify = _jsBeautify2.default.html;
	
	var ThingsboardHtml = function (_React$Component) {
	    _inherits(ThingsboardHtml, _React$Component);
	
	    function ThingsboardHtml(props) {
	        _classCallCheck(this, ThingsboardHtml);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardHtml.__proto__ || Object.getPrototypeOf(ThingsboardHtml)).call(this, props));
	
	        _this.onTidyHtml = _this.onTidyHtml.bind(_this);
	        return _this;
	    }
	
	    _createClass(ThingsboardHtml, [{
	        key: 'onTidyHtml',
	        value: function onTidyHtml(html) {
	            return html_beautify(html, { indent_size: 4 });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_jsonFormAceEditor2.default, _extends({}, this.props, { mode: 'html', onTidy: this.onTidyHtml }, this.state));
	        }
	    }]);
	
	    return ThingsboardHtml;
	}(_react2.default.Component);
	
	exports.default = ThingsboardHtml;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(769);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormBaseComponent = __webpack_require__(49);
	
	var _jsonFormBaseComponent2 = _interopRequireDefault(_jsonFormBaseComponent);
	
	var _reactDropzone = __webpack_require__(1659);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _IconButton = __webpack_require__(45);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardImage = function (_React$Component) {
	    _inherits(ThingsboardImage, _React$Component);
	
	    function ThingsboardImage(props) {
	        _classCallCheck(this, ThingsboardImage);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardImage.__proto__ || Object.getPrototypeOf(ThingsboardImage)).call(this, props));
	
	        _this.onValueChanged = _this.onValueChanged.bind(_this);
	        _this.onDrop = _this.onDrop.bind(_this);
	        _this.onClear = _this.onClear.bind(_this);
	        var value = props.value ? props.value + '' : null;
	        _this.state = {
	            imageUrl: value
	        };
	        return _this;
	    }
	
	    _createClass(ThingsboardImage, [{
	        key: 'onValueChanged',
	        value: function onValueChanged(value) {
	            this.setState({
	                imageUrl: value
	            });
	            this.props.onChangeValidate({
	                target: {
	                    value: value
	                }
	            });
	        }
	    }, {
	        key: 'onDrop',
	        value: function onDrop(files) {
	            var reader = new FileReader();
	            reader.onload = function (tImg) {
	                return function (event) {
	                    tImg.onValueChanged(event.target.result);
	                };
	            }(this);
	            reader.readAsDataURL(files[0]);
	        }
	    }, {
	        key: 'onClear',
	        value: function onClear(event) {
	            if (event) {
	                event.stopPropagation();
	            }
	            this.onValueChanged("");
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var labelClass = "tb-label";
	            if (this.props.form.required) {
	                labelClass += " tb-required";
	            }
	            if (this.props.form.readonly) {
	                labelClass += " tb-readonly";
	            }
	            if (this.state.focused) {
	                labelClass += " tb-focused";
	            }
	
	            var previewComponent;
	            if (this.state.imageUrl) {
	                previewComponent = _react2.default.createElement('img', { className: 'tb-image-preview', src: this.state.imageUrl });
	            } else {
	                previewComponent = _react2.default.createElement(
	                    'div',
	                    null,
	                    'No image selected'
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'tb-container' },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    this.props.form.title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tb-image-select-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tb-image-preview-container' },
	                        previewComponent
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tb-image-clear-container' },
	                        _react2.default.createElement(
	                            _IconButton2.default,
	                            { className: 'tb-image-clear-btn', iconClassName: 'material-icons', tooltip: 'Clear', onTouchTap: this.onClear },
	                            'clear'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactDropzone2.default,
	                        { className: 'tb-dropzone',
	                            onDrop: this.onDrop,
	                            multiple: false,
	                            accept: 'image/*' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Drop an image or click to select a file to upload.'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ThingsboardImage;
	}(_react2.default.Component);
	
	exports.default = (0, _jsonFormBaseComponent2.default)(ThingsboardImage);

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormAceEditor = __webpack_require__(122);
	
	var _jsonFormAceEditor2 = _interopRequireDefault(_jsonFormAceEditor);
	
	__webpack_require__(278);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var js_beautify = _jsBeautify2.default.js;
	
	var ThingsboardJavaScript = function (_React$Component) {
	    _inherits(ThingsboardJavaScript, _React$Component);
	
	    function ThingsboardJavaScript(props) {
	        _classCallCheck(this, ThingsboardJavaScript);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardJavaScript.__proto__ || Object.getPrototypeOf(ThingsboardJavaScript)).call(this, props));
	
	        _this.onTidyJavascript = _this.onTidyJavascript.bind(_this);
	        return _this;
	    }
	
	    _createClass(ThingsboardJavaScript, [{
	        key: 'onTidyJavascript',
	        value: function onTidyJavascript(javascript) {
	            return js_beautify(javascript, { indent_size: 4, wrap_line_length: 60 });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_jsonFormAceEditor2.default, _extends({}, this.props, { mode: 'javascript', onTidy: this.onTidyJavascript }, this.state));
	        }
	    }]);
	
	    return ThingsboardJavaScript;
	}(_react2.default.Component);
	
	exports.default = ThingsboardJavaScript;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormAceEditor = __webpack_require__(122);
	
	var _jsonFormAceEditor2 = _interopRequireDefault(_jsonFormAceEditor);
	
	__webpack_require__(51);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var js_beautify = _jsBeautify2.default.js;
	
	var ThingsboardJson = function (_React$Component) {
	    _inherits(ThingsboardJson, _React$Component);
	
	    function ThingsboardJson(props) {
	        _classCallCheck(this, ThingsboardJson);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardJson.__proto__ || Object.getPrototypeOf(ThingsboardJson)).call(this, props));
	
	        _this.onTidyJson = _this.onTidyJson.bind(_this);
	        return _this;
	    }
	
	    _createClass(ThingsboardJson, [{
	        key: 'onTidyJson',
	        value: function onTidyJson(json) {
	            return js_beautify(json, { indent_size: 4 });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_jsonFormAceEditor2.default, _extends({}, this.props, { mode: 'json', onTidy: this.onTidyJson }, this.state));
	        }
	    }]);
	
	    return ThingsboardJson;
	}(_react2.default.Component);
	
	exports.default = ThingsboardJson;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormBaseComponent = __webpack_require__(49);
	
	var _jsonFormBaseComponent2 = _interopRequireDefault(_jsonFormBaseComponent);
	
	var _materialUiNumberInput = __webpack_require__(997);
	
	var _materialUiNumberInput2 = _interopRequireDefault(_materialUiNumberInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardNumber = function (_React$Component) {
	    _inherits(ThingsboardNumber, _React$Component);
	
	    function ThingsboardNumber(props) {
	        _classCallCheck(this, ThingsboardNumber);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardNumber.__proto__ || Object.getPrototypeOf(ThingsboardNumber)).call(this, props));
	
	        _this.preValidationCheck = _this.preValidationCheck.bind(_this);
	        _this.onBlur = _this.onBlur.bind(_this);
	        _this.onFocus = _this.onFocus.bind(_this);
	        _this.state = {
	            lastSuccessfulValue: _this.props.value,
	            focused: false
	        };
	        return _this;
	    }
	
	    _createClass(ThingsboardNumber, [{
	        key: 'isNumeric',
	        value: function isNumeric(n) {
	            return n === null || n === '' || !isNaN(n) && isFinite(n);
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur() {
	            this.setState({ focused: false });
	        }
	    }, {
	        key: 'onFocus',
	        value: function onFocus() {
	            this.setState({ focused: true });
	        }
	    }, {
	        key: 'preValidationCheck',
	        value: function preValidationCheck(e) {
	            if (this.isNumeric(e.target.value)) {
	                this.setState({
	                    lastSuccessfulValue: e.target.value
	                });
	                this.props.onChangeValidate(e);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var fieldClass = "tb-field";
	            if (this.props.form.required) {
	                fieldClass += " tb-required";
	            }
	            if (this.props.form.readonly) {
	                fieldClass += " tb-readonly";
	            }
	            if (this.state.focused) {
	                fieldClass += " tb-focused";
	            }
	            var value = this.state.lastSuccessfulValue;
	            if (typeof value !== 'undefined') {
	                value = Number(value);
	            } else {
	                value = null;
	            }
	            return _react2.default.createElement(_materialUiNumberInput2.default, {
	                className: fieldClass,
	                strategy: 'allow',
	                floatingLabelText: this.props.form.title,
	                hintText: this.props.form.placeholder,
	                errorText: this.props.error,
	                onChange: this.preValidationCheck,
	                defaultValue: value,
	                ref: 'numberField',
	                disabled: this.props.form.readonly,
	                onFocus: this.onFocus,
	                onBlur: this.onBlur,
	                style: this.props.form.style || { width: '100%' } });
	        }
	    }]);
	
	    return ThingsboardNumber;
	}(_react2.default.Component);
	
	exports.default = (0, _jsonFormBaseComponent2.default)(ThingsboardNumber);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(832);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormBaseComponent = __webpack_require__(49);
	
	var _jsonFormBaseComponent2 = _interopRequireDefault(_jsonFormBaseComponent);
	
	var _rcSelect = __webpack_require__(1586);
	
	var _rcSelect2 = _interopRequireDefault(_rcSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardRcSelect = function (_React$Component) {
	    _inherits(ThingsboardRcSelect, _React$Component);
	
	    function ThingsboardRcSelect(props) {
	        _classCallCheck(this, ThingsboardRcSelect);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardRcSelect.__proto__ || Object.getPrototypeOf(ThingsboardRcSelect)).call(this, props));
	
	        _this.onSelect = _this.onSelect.bind(_this);
	        _this.onDeselect = _this.onDeselect.bind(_this);
	        _this.onBlur = _this.onBlur.bind(_this);
	        _this.onFocus = _this.onFocus.bind(_this);
	        _this.state = {
	            currentValue: _this.keyToCurrentValue(_this.props.value, _this.props.form.schema.type === 'array'),
	            items: _this.props.form.items,
	            focused: false
	        };
	        return _this;
	    }
	
	    _createClass(ThingsboardRcSelect, [{
	        key: 'keyToCurrentValue',
	        value: function keyToCurrentValue(key, isArray) {
	            var currentValue = isArray ? [] : null;
	            if (isArray) {
	                var keys = key;
	                if (keys) {
	                    for (var i = 0; i < keys.length; i++) {
	                        currentValue.push({ key: keys[i], label: this.labelFromKey(keys[i]) });
	                    }
	                }
	            } else {
	                currentValue = { key: key, label: this.labelFromKey(key) };
	            }
	            return currentValue;
	        }
	    }, {
	        key: 'labelFromKey',
	        value: function labelFromKey(key) {
	            var label = key || '';
	            if (key) {
	                for (var i = 0; i < this.props.form.items.length; i++) {
	                    var item = this.props.form.items[i];
	                    if (item.value === key) {
	                        label = item.label;
	                        break;
	                    }
	                }
	            }
	            return label;
	        }
	    }, {
	        key: 'arrayValues',
	        value: function arrayValues(items) {
	            var v = [];
	            if (items) {
	                for (var i = 0; i < items.length; i++) {
	                    v.push(items[i].key);
	                }
	            }
	            return v;
	        }
	    }, {
	        key: 'keyIndex',
	        value: function keyIndex(values, key) {
	            var index = -1;
	            if (values) {
	                for (var i = 0; i < values.length; i++) {
	                    if (values[i].key === key) {
	                        index = i;
	                        break;
	                    }
	                }
	            }
	            return index;
	        }
	    }, {
	        key: 'onSelect',
	        value: function onSelect(value, option) {
	            if (this.props.form.schema.type === 'array') {
	                var v = this.state.currentValue;
	                v.push(this.keyToCurrentValue(value.key, false));
	                this.setState({
	                    currentValue: v
	                });
	                this.props.onChangeValidate(this.arrayValues(v));
	            } else {
	                this.setState({ currentValue: this.keyToCurrentValue(value.key, false) });
	                this.props.onChangeValidate({ target: { value: value.key } });
	            }
	        }
	    }, {
	        key: 'onDeselect',
	        value: function onDeselect(value, option) {
	            if (this.props.form.schema.type === 'array') {
	                var v = this.state.currentValue;
	                var index = this.keyIndex(v, value.key);
	                if (index > -1) {
	                    v.splice(index, 1);
	                }
	                this.setState({
	                    currentValue: v
	                });
	                this.props.onChangeValidate(this.arrayValues(v));
	            }
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur() {
	            this.setState({ focused: false });
	        }
	    }, {
	        key: 'onFocus',
	        value: function onFocus() {
	            this.setState({ focused: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var options = [];
	            if (this.state.items && this.state.items.length > 0) {
	                options = this.state.items.map(function (item, idx) {
	                    return _react2.default.createElement(
	                        _rcSelect.Option,
	                        { key: idx, value: item.value },
	                        item.label
	                    );
	                });
	            }
	
	            var labelClass = "tb-label";
	            if (this.props.form.required) {
	                labelClass += " tb-required";
	            }
	            if (this.props.form.readonly) {
	                labelClass += " tb-readonly";
	            }
	            if (this.state.focused) {
	                labelClass += " tb-focused";
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'tb-container' },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    this.props.form.title
	                ),
	                _react2.default.createElement(
	                    _rcSelect2.default,
	                    {
	                        className: this.props.form.className,
	                        dropdownClassName: this.props.form.dropdownClassName,
	                        dropdownStyle: this.props.form.dropdownStyle,
	                        dropdownMenuStyle: this.props.form.dropdownMenuStyle,
	                        allowClear: this.props.form.allowClear,
	                        tags: this.props.form.tags,
	                        maxTagTextLength: this.props.form.maxTagTextLength,
	                        multiple: this.props.form.multiple,
	                        combobox: this.props.form.combobox,
	                        disabled: this.props.form.readonly,
	                        value: this.state.currentValue,
	                        labelInValue: true,
	                        onSelect: this.onSelect,
	                        onDeselect: this.onDeselect,
	                        onFocus: this.onFocus,
	                        onBlur: this.onBlur,
	                        style: this.props.form.style || { width: "100%" } },
	                    options
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'json-form-error',
	                        style: { opacity: this.props.valid ? '0' : '1',
	                            bottom: '-5px' } },
	                    this.props.error
	                )
	            );
	        }
	    }]);
	
	    return ThingsboardRcSelect;
	}(_react2.default.Component);
	
	exports.default = (0, _jsonFormBaseComponent2.default)(ThingsboardRcSelect);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(770);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getMuiTheme = __webpack_require__(377);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _thingsboardTheme = __webpack_require__(1194);
	
	var _thingsboardTheme2 = _interopRequireDefault(_thingsboardTheme);
	
	var _jsonFormSchemaForm = __webpack_require__(639);
	
	var _jsonFormSchemaForm2 = _interopRequireDefault(_jsonFormSchemaForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ReactSchemaForm = function (_React$Component) {
	    _inherits(ReactSchemaForm, _React$Component);
	
	    _createClass(ReactSchemaForm, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                muiTheme: this.state.muiTheme
	            };
	        }
	    }]);
	
	    function ReactSchemaForm(props) {
	        _classCallCheck(this, ReactSchemaForm);
	
	        var _this = _possibleConstructorReturn(this, (ReactSchemaForm.__proto__ || Object.getPrototypeOf(ReactSchemaForm)).call(this, props));
	
	        _this.state = {
	            muiTheme: (0, _getMuiTheme2.default)(_thingsboardTheme2.default)
	        };
	        return _this;
	    }
	
	    _createClass(ReactSchemaForm, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.form.length > 0) {
	                return _react2.default.createElement(_jsonFormSchemaForm2.default, this.props);
	            } else {
	                return _react2.default.createElement('div', null);
	            }
	        }
	    }]);
	
	    return ReactSchemaForm;
	}(_react2.default.Component);
	
	ReactSchemaForm.propTypes = {
	    schema: _react2.default.PropTypes.object,
	    form: _react2.default.PropTypes.array,
	    model: _react2.default.PropTypes.object,
	    option: _react2.default.PropTypes.object,
	    onModelChange: _react2.default.PropTypes.func,
	    onColorClick: _react2.default.PropTypes.func
	};
	
	ReactSchemaForm.defaultProps = {
	    schema: {},
	    form: ["*"]
	};
	
	ReactSchemaForm.childContextTypes = {
	    muiTheme: _react2.default.PropTypes.object
	};
	
	exports.default = ReactSchemaForm;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSchemaForm = __webpack_require__(118);
	
	var _jsonFormArray = __webpack_require__(626);
	
	var _jsonFormArray2 = _interopRequireDefault(_jsonFormArray);
	
	var _jsonFormJavascript = __webpack_require__(634);
	
	var _jsonFormJavascript2 = _interopRequireDefault(_jsonFormJavascript);
	
	var _jsonFormJson = __webpack_require__(635);
	
	var _jsonFormJson2 = _interopRequireDefault(_jsonFormJson);
	
	var _jsonFormHtml = __webpack_require__(632);
	
	var _jsonFormHtml2 = _interopRequireDefault(_jsonFormHtml);
	
	var _jsonFormCss = __webpack_require__(629);
	
	var _jsonFormCss2 = _interopRequireDefault(_jsonFormCss);
	
	var _jsonFormColor = __webpack_require__(628);
	
	var _jsonFormColor2 = _interopRequireDefault(_jsonFormColor);
	
	var _jsonFormRcSelect = __webpack_require__(637);
	
	var _jsonFormRcSelect2 = _interopRequireDefault(_jsonFormRcSelect);
	
	var _jsonFormNumber = __webpack_require__(636);
	
	var _jsonFormNumber2 = _interopRequireDefault(_jsonFormNumber);
	
	var _jsonFormText = __webpack_require__(640);
	
	var _jsonFormText2 = _interopRequireDefault(_jsonFormText);
	
	var _Select = __webpack_require__(161);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Radios = __webpack_require__(160);
	
	var _Radios2 = _interopRequireDefault(_Radios);
	
	var _jsonFormDate = __webpack_require__(630);
	
	var _jsonFormDate2 = _interopRequireDefault(_jsonFormDate);
	
	var _jsonFormImage = __webpack_require__(633);
	
	var _jsonFormImage2 = _interopRequireDefault(_jsonFormImage);
	
	var _jsonFormCheckbox = __webpack_require__(627);
	
	var _jsonFormCheckbox2 = _interopRequireDefault(_jsonFormCheckbox);
	
	var _Help = __webpack_require__(159);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _jsonFormFieldset = __webpack_require__(631);
	
	var _jsonFormFieldset2 = _interopRequireDefault(_jsonFormFieldset);
	
	var _lodash = __webpack_require__(87);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardSchemaForm = function (_React$Component) {
	    _inherits(ThingsboardSchemaForm, _React$Component);
	
	    function ThingsboardSchemaForm(props) {
	        _classCallCheck(this, ThingsboardSchemaForm);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardSchemaForm.__proto__ || Object.getPrototypeOf(ThingsboardSchemaForm)).call(this, props));
	
	        _this.mapper = {
	            'number': _jsonFormNumber2.default,
	            'text': _jsonFormText2.default,
	            'password': _jsonFormText2.default,
	            'textarea': _jsonFormText2.default,
	            'select': _Select2.default,
	            'radios': _Radios2.default,
	            'date': _jsonFormDate2.default,
	            'image': _jsonFormImage2.default,
	            'checkbox': _jsonFormCheckbox2.default,
	            'help': _Help2.default,
	            'array': _jsonFormArray2.default,
	            'javascript': _jsonFormJavascript2.default,
	            'json': _jsonFormJson2.default,
	            'html': _jsonFormHtml2.default,
	            'css': _jsonFormCss2.default,
	            'color': _jsonFormColor2.default,
	            'rc-select': _jsonFormRcSelect2.default,
	            'fieldset': _jsonFormFieldset2.default
	        };
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.onColorClick = _this.onColorClick.bind(_this);
	        _this.hasConditions = false;
	        return _this;
	    }
	
	    _createClass(ThingsboardSchemaForm, [{
	        key: 'onChange',
	        value: function onChange(key, val) {
	            //console.log('SchemaForm.onChange', key, val);
	            this.props.onModelChange(key, val);
	            if (this.hasConditions) {
	                this.forceUpdate();
	            }
	        }
	    }, {
	        key: 'onColorClick',
	        value: function onColorClick(event, key, val) {
	            this.props.onColorClick(event, key, val);
	        }
	    }, {
	        key: 'builder',
	        value: function builder(form, model, index, onChange, onColorClick, mapper) {
	            var type = form.type;
	            var Field = this.mapper[type];
	            if (!Field) {
	                console.log('Invalid field: \"' + form.key[0] + '\"!');
	                return null;
	            }
	            if (form.condition) {
	                this.hasConditions = true;
	                if (eval(form.condition) === false) {
	                    return null;
	                }
	            }
	            return _react2.default.createElement(Field, { model: model, form: form, key: index, onChange: onChange, onColorClick: onColorClick, mapper: mapper, builder: this.builder });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var merged = _reactSchemaForm.utils.merge(this.props.schema, this.props.form, this.props.ignore, this.props.option);
	            var mapper = this.mapper;
	            if (this.props.mapper) {
	                mapper = _lodash2.default.merge(this.mapper, this.props.mapper);
	            }
	            var forms = merged.map(function (form, index) {
	                return this.builder(form, this.props.model, index, this.onChange, this.onColorClick, mapper);
	            }.bind(this));
	
	            return _react2.default.createElement(
	                'div',
	                { style: { width: '100%' }, className: 'SchemaForm' },
	                forms
	            );
	        }
	    }]);
	
	    return ThingsboardSchemaForm;
	}(_react2.default.Component);
	
	exports.default = ThingsboardSchemaForm;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonFormBaseComponent = __webpack_require__(49);
	
	var _jsonFormBaseComponent2 = _interopRequireDefault(_jsonFormBaseComponent);
	
	var _TextField = __webpack_require__(40);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ThingsboardText = function (_React$Component) {
	    _inherits(ThingsboardText, _React$Component);
	
	    function ThingsboardText(props) {
	        _classCallCheck(this, ThingsboardText);
	
	        var _this = _possibleConstructorReturn(this, (ThingsboardText.__proto__ || Object.getPrototypeOf(ThingsboardText)).call(this, props));
	
	        _this.onBlur = _this.onBlur.bind(_this);
	        _this.onFocus = _this.onFocus.bind(_this);
	        _this.state = {
	            focused: false
	        };
	        return _this;
	    }
	
	    _createClass(ThingsboardText, [{
	        key: 'onBlur',
	        value: function onBlur() {
	            this.setState({ focused: false });
	        }
	    }, {
	        key: 'onFocus',
	        value: function onFocus() {
	            this.setState({ focused: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var fieldClass = "tb-field";
	            if (this.props.form.required) {
	                fieldClass += " tb-required";
	            }
	            if (this.props.form.readonly) {
	                fieldClass += " tb-readonly";
	            }
	            if (this.state.focused) {
	                fieldClass += " tb-focused";
	            }
	
	            var multiline = this.props.form.type === 'textarea';
	            var rows = multiline ? this.props.form.rows : 1;
	            var rowsMax = multiline ? this.props.form.rowsMax : 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_TextField2.default, {
	                    className: fieldClass,
	                    type: this.props.form.type,
	                    floatingLabelText: this.props.form.title,
	                    hintText: this.props.form.placeholder,
	                    errorText: this.props.error,
	                    onChange: this.props.onChangeValidate,
	                    defaultValue: this.props.value,
	                    disabled: this.props.form.readonly,
	                    multiLine: multiline,
	                    rows: rows,
	                    rowsMax: rowsMax,
	                    onFocus: this.onFocus,
	                    onBlur: this.onBlur,
	                    style: this.props.form.style || { width: '100%' } })
	            );
	        }
	    }]);
	
	    return ThingsboardText;
	}(_react2.default.Component);
	
	exports.default = (0, _jsonFormBaseComponent2.default)(ThingsboardText);

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(667), __esModule: true };

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(669), __esModule: true };

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(673), __esModule: true };

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(674), __esModule: true };

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(675), __esModule: true };

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants;
	(function (constants) {
	    constants.typeOfFunction = 'function';
	    constants.boolTrue = true;
	})(constants || (constants = {}));
	function bind(target, propertyKey, descriptor) {
	    if (!descriptor || (typeof descriptor.value !== constants.typeOfFunction)) {
	        throw new TypeError("Only methods can be decorated with @bind. <" + propertyKey + "> is not a method!");
	    }
	    return {
	        configurable: constants.boolTrue,
	        get: function () {
	            var bound = descriptor.value.bind(this);
	            // Credits to https://github.com/andreypopp/autobind-decorator for memoizing the result of bind against a symbol on the instance.
	            Object.defineProperty(this, propertyKey, {
	                value: bound,
	                configurable: constants.boolTrue,
	                writable: constants.boolTrue
	            });
	            return bound;
	        }
	    };
	}
	exports.bind = bind;
	exports.default = bind;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(262)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)(o|0)s/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/Whale/i.test(ua)) {
	      result = {
	        name: 'NAVER Whale browser'
	        , whale: t
	        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/MZBrowser/i.test(ua)) {
	      result = {
	        name: 'MZ Browser'
	        , mzbrowser: t
	        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/focus/i.test(ua)) {
	      result = {
	        name: 'Focus'
	        , focus: t
	        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
	        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
	        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ }),
/* 648 */
/***/ (function(module, exports) {

	


/***/ }),
/* 649 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/css",["require","exports","module"],function(e,t,n){"use strict";t.snippetText="snippet .\n	${1} {\n		${2}\n	}\nsnippet !\n	 !important\nsnippet bdi:m+\n	-moz-border-image: url(${1}) ${2:0} ${3:0} ${4:0} ${5:0} ${6:stretch} ${7:stretch};\nsnippet bdi:m\n	-moz-border-image: ${1};\nsnippet bdrz:m\n	-moz-border-radius: ${1};\nsnippet bxsh:m+\n	-moz-box-shadow: ${1:0} ${2:0} ${3:0} #${4:000};\nsnippet bxsh:m\n	-moz-box-shadow: ${1};\nsnippet bdi:w+\n	-webkit-border-image: url(${1}) ${2:0} ${3:0} ${4:0} ${5:0} ${6:stretch} ${7:stretch};\nsnippet bdi:w\n	-webkit-border-image: ${1};\nsnippet bdrz:w\n	-webkit-border-radius: ${1};\nsnippet bxsh:w+\n	-webkit-box-shadow: ${1:0} ${2:0} ${3:0} #${4:000};\nsnippet bxsh:w\n	-webkit-box-shadow: ${1};\nsnippet @f\n	@font-face {\n		font-family: ${1};\n		src: url(${2});\n	}\nsnippet @i\n	@import url(${1});\nsnippet @m\n	@media ${1:print} {\n		${2}\n	}\nsnippet bg+\n	background: #${1:FFF} url(${2}) ${3:0} ${4:0} ${5:no-repeat};\nsnippet bga\n	background-attachment: ${1};\nsnippet bga:f\n	background-attachment: fixed;\nsnippet bga:s\n	background-attachment: scroll;\nsnippet bgbk\n	background-break: ${1};\nsnippet bgbk:bb\n	background-break: bounding-box;\nsnippet bgbk:c\n	background-break: continuous;\nsnippet bgbk:eb\n	background-break: each-box;\nsnippet bgcp\n	background-clip: ${1};\nsnippet bgcp:bb\n	background-clip: border-box;\nsnippet bgcp:cb\n	background-clip: content-box;\nsnippet bgcp:nc\n	background-clip: no-clip;\nsnippet bgcp:pb\n	background-clip: padding-box;\nsnippet bgc\n	background-color: #${1:FFF};\nsnippet bgc:t\n	background-color: transparent;\nsnippet bgi\n	background-image: url(${1});\nsnippet bgi:n\n	background-image: none;\nsnippet bgo\n	background-origin: ${1};\nsnippet bgo:bb\n	background-origin: border-box;\nsnippet bgo:cb\n	background-origin: content-box;\nsnippet bgo:pb\n	background-origin: padding-box;\nsnippet bgpx\n	background-position-x: ${1};\nsnippet bgpy\n	background-position-y: ${1};\nsnippet bgp\n	background-position: ${1:0} ${2:0};\nsnippet bgr\n	background-repeat: ${1};\nsnippet bgr:n\n	background-repeat: no-repeat;\nsnippet bgr:x\n	background-repeat: repeat-x;\nsnippet bgr:y\n	background-repeat: repeat-y;\nsnippet bgr:r\n	background-repeat: repeat;\nsnippet bgz\n	background-size: ${1};\nsnippet bgz:a\n	background-size: auto;\nsnippet bgz:ct\n	background-size: contain;\nsnippet bgz:cv\n	background-size: cover;\nsnippet bg\n	background: ${1};\nsnippet bg:ie\n	filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='${1}',sizingMethod='${2:crop}');\nsnippet bg:n\n	background: none;\nsnippet bd+\n	border: ${1:1px} ${2:solid} #${3:000};\nsnippet bdb+\n	border-bottom: ${1:1px} ${2:solid} #${3:000};\nsnippet bdbc\n	border-bottom-color: #${1:000};\nsnippet bdbi\n	border-bottom-image: url(${1});\nsnippet bdbi:n\n	border-bottom-image: none;\nsnippet bdbli\n	border-bottom-left-image: url(${1});\nsnippet bdbli:c\n	border-bottom-left-image: continue;\nsnippet bdbli:n\n	border-bottom-left-image: none;\nsnippet bdblrz\n	border-bottom-left-radius: ${1};\nsnippet bdbri\n	border-bottom-right-image: url(${1});\nsnippet bdbri:c\n	border-bottom-right-image: continue;\nsnippet bdbri:n\n	border-bottom-right-image: none;\nsnippet bdbrrz\n	border-bottom-right-radius: ${1};\nsnippet bdbs\n	border-bottom-style: ${1};\nsnippet bdbs:n\n	border-bottom-style: none;\nsnippet bdbw\n	border-bottom-width: ${1};\nsnippet bdb\n	border-bottom: ${1};\nsnippet bdb:n\n	border-bottom: none;\nsnippet bdbk\n	border-break: ${1};\nsnippet bdbk:c\n	border-break: close;\nsnippet bdcl\n	border-collapse: ${1};\nsnippet bdcl:c\n	border-collapse: collapse;\nsnippet bdcl:s\n	border-collapse: separate;\nsnippet bdc\n	border-color: #${1:000};\nsnippet bdci\n	border-corner-image: url(${1});\nsnippet bdci:c\n	border-corner-image: continue;\nsnippet bdci:n\n	border-corner-image: none;\nsnippet bdf\n	border-fit: ${1};\nsnippet bdf:c\n	border-fit: clip;\nsnippet bdf:of\n	border-fit: overwrite;\nsnippet bdf:ow\n	border-fit: overwrite;\nsnippet bdf:r\n	border-fit: repeat;\nsnippet bdf:sc\n	border-fit: scale;\nsnippet bdf:sp\n	border-fit: space;\nsnippet bdf:st\n	border-fit: stretch;\nsnippet bdi\n	border-image: url(${1}) ${2:0} ${3:0} ${4:0} ${5:0} ${6:stretch} ${7:stretch};\nsnippet bdi:n\n	border-image: none;\nsnippet bdl+\n	border-left: ${1:1px} ${2:solid} #${3:000};\nsnippet bdlc\n	border-left-color: #${1:000};\nsnippet bdli\n	border-left-image: url(${1});\nsnippet bdli:n\n	border-left-image: none;\nsnippet bdls\n	border-left-style: ${1};\nsnippet bdls:n\n	border-left-style: none;\nsnippet bdlw\n	border-left-width: ${1};\nsnippet bdl\n	border-left: ${1};\nsnippet bdl:n\n	border-left: none;\nsnippet bdlt\n	border-length: ${1};\nsnippet bdlt:a\n	border-length: auto;\nsnippet bdrz\n	border-radius: ${1};\nsnippet bdr+\n	border-right: ${1:1px} ${2:solid} #${3:000};\nsnippet bdrc\n	border-right-color: #${1:000};\nsnippet bdri\n	border-right-image: url(${1});\nsnippet bdri:n\n	border-right-image: none;\nsnippet bdrs\n	border-right-style: ${1};\nsnippet bdrs:n\n	border-right-style: none;\nsnippet bdrw\n	border-right-width: ${1};\nsnippet bdr\n	border-right: ${1};\nsnippet bdr:n\n	border-right: none;\nsnippet bdsp\n	border-spacing: ${1};\nsnippet bds\n	border-style: ${1};\nsnippet bds:ds\n	border-style: dashed;\nsnippet bds:dtds\n	border-style: dot-dash;\nsnippet bds:dtdtds\n	border-style: dot-dot-dash;\nsnippet bds:dt\n	border-style: dotted;\nsnippet bds:db\n	border-style: double;\nsnippet bds:g\n	border-style: groove;\nsnippet bds:h\n	border-style: hidden;\nsnippet bds:i\n	border-style: inset;\nsnippet bds:n\n	border-style: none;\nsnippet bds:o\n	border-style: outset;\nsnippet bds:r\n	border-style: ridge;\nsnippet bds:s\n	border-style: solid;\nsnippet bds:w\n	border-style: wave;\nsnippet bdt+\n	border-top: ${1:1px} ${2:solid} #${3:000};\nsnippet bdtc\n	border-top-color: #${1:000};\nsnippet bdti\n	border-top-image: url(${1});\nsnippet bdti:n\n	border-top-image: none;\nsnippet bdtli\n	border-top-left-image: url(${1});\nsnippet bdtli:c\n	border-corner-image: continue;\nsnippet bdtli:n\n	border-corner-image: none;\nsnippet bdtlrz\n	border-top-left-radius: ${1};\nsnippet bdtri\n	border-top-right-image: url(${1});\nsnippet bdtri:c\n	border-top-right-image: continue;\nsnippet bdtri:n\n	border-top-right-image: none;\nsnippet bdtrrz\n	border-top-right-radius: ${1};\nsnippet bdts\n	border-top-style: ${1};\nsnippet bdts:n\n	border-top-style: none;\nsnippet bdtw\n	border-top-width: ${1};\nsnippet bdt\n	border-top: ${1};\nsnippet bdt:n\n	border-top: none;\nsnippet bdw\n	border-width: ${1};\nsnippet bd\n	border: ${1};\nsnippet bd:n\n	border: none;\nsnippet b\n	bottom: ${1};\nsnippet b:a\n	bottom: auto;\nsnippet bxsh+\n	box-shadow: ${1:0} ${2:0} ${3:0} #${4:000};\nsnippet bxsh\n	box-shadow: ${1};\nsnippet bxsh:n\n	box-shadow: none;\nsnippet bxz\n	box-sizing: ${1};\nsnippet bxz:bb\n	box-sizing: border-box;\nsnippet bxz:cb\n	box-sizing: content-box;\nsnippet cps\n	caption-side: ${1};\nsnippet cps:b\n	caption-side: bottom;\nsnippet cps:t\n	caption-side: top;\nsnippet cl\n	clear: ${1};\nsnippet cl:b\n	clear: both;\nsnippet cl:l\n	clear: left;\nsnippet cl:n\n	clear: none;\nsnippet cl:r\n	clear: right;\nsnippet cp\n	clip: ${1};\nsnippet cp:a\n	clip: auto;\nsnippet cp:r\n	clip: rect(${1:0} ${2:0} ${3:0} ${4:0});\nsnippet c\n	color: #${1:000};\nsnippet ct\n	content: ${1};\nsnippet ct:a\n	content: attr(${1});\nsnippet ct:cq\n	content: close-quote;\nsnippet ct:c\n	content: counter(${1});\nsnippet ct:cs\n	content: counters(${1});\nsnippet ct:ncq\n	content: no-close-quote;\nsnippet ct:noq\n	content: no-open-quote;\nsnippet ct:n\n	content: normal;\nsnippet ct:oq\n	content: open-quote;\nsnippet coi\n	counter-increment: ${1};\nsnippet cor\n	counter-reset: ${1};\nsnippet cur\n	cursor: ${1};\nsnippet cur:a\n	cursor: auto;\nsnippet cur:c\n	cursor: crosshair;\nsnippet cur:d\n	cursor: default;\nsnippet cur:ha\n	cursor: hand;\nsnippet cur:he\n	cursor: help;\nsnippet cur:m\n	cursor: move;\nsnippet cur:p\n	cursor: pointer;\nsnippet cur:t\n	cursor: text;\nsnippet d\n	display: ${1};\nsnippet d:mib\n	display: -moz-inline-box;\nsnippet d:mis\n	display: -moz-inline-stack;\nsnippet d:b\n	display: block;\nsnippet d:cp\n	display: compact;\nsnippet d:ib\n	display: inline-block;\nsnippet d:itb\n	display: inline-table;\nsnippet d:i\n	display: inline;\nsnippet d:li\n	display: list-item;\nsnippet d:n\n	display: none;\nsnippet d:ri\n	display: run-in;\nsnippet d:tbcp\n	display: table-caption;\nsnippet d:tbc\n	display: table-cell;\nsnippet d:tbclg\n	display: table-column-group;\nsnippet d:tbcl\n	display: table-column;\nsnippet d:tbfg\n	display: table-footer-group;\nsnippet d:tbhg\n	display: table-header-group;\nsnippet d:tbrg\n	display: table-row-group;\nsnippet d:tbr\n	display: table-row;\nsnippet d:tb\n	display: table;\nsnippet ec\n	empty-cells: ${1};\nsnippet ec:h\n	empty-cells: hide;\nsnippet ec:s\n	empty-cells: show;\nsnippet exp\n	expression()\nsnippet fl\n	float: ${1};\nsnippet fl:l\n	float: left;\nsnippet fl:n\n	float: none;\nsnippet fl:r\n	float: right;\nsnippet f+\n	font: ${1:1em} ${2:Arial},${3:sans-serif};\nsnippet fef\n	font-effect: ${1};\nsnippet fef:eb\n	font-effect: emboss;\nsnippet fef:eg\n	font-effect: engrave;\nsnippet fef:n\n	font-effect: none;\nsnippet fef:o\n	font-effect: outline;\nsnippet femp\n	font-emphasize-position: ${1};\nsnippet femp:a\n	font-emphasize-position: after;\nsnippet femp:b\n	font-emphasize-position: before;\nsnippet fems\n	font-emphasize-style: ${1};\nsnippet fems:ac\n	font-emphasize-style: accent;\nsnippet fems:c\n	font-emphasize-style: circle;\nsnippet fems:ds\n	font-emphasize-style: disc;\nsnippet fems:dt\n	font-emphasize-style: dot;\nsnippet fems:n\n	font-emphasize-style: none;\nsnippet fem\n	font-emphasize: ${1};\nsnippet ff\n	font-family: ${1};\nsnippet ff:c\n	font-family: ${1:'Monotype Corsiva','Comic Sans MS'},cursive;\nsnippet ff:f\n	font-family: ${1:Capitals,Impact},fantasy;\nsnippet ff:m\n	font-family: ${1:Monaco,'Courier New'},monospace;\nsnippet ff:ss\n	font-family: ${1:Helvetica,Arial},sans-serif;\nsnippet ff:s\n	font-family: ${1:Georgia,'Times New Roman'},serif;\nsnippet fza\n	font-size-adjust: ${1};\nsnippet fza:n\n	font-size-adjust: none;\nsnippet fz\n	font-size: ${1};\nsnippet fsm\n	font-smooth: ${1};\nsnippet fsm:aw\n	font-smooth: always;\nsnippet fsm:a\n	font-smooth: auto;\nsnippet fsm:n\n	font-smooth: never;\nsnippet fst\n	font-stretch: ${1};\nsnippet fst:c\n	font-stretch: condensed;\nsnippet fst:e\n	font-stretch: expanded;\nsnippet fst:ec\n	font-stretch: extra-condensed;\nsnippet fst:ee\n	font-stretch: extra-expanded;\nsnippet fst:n\n	font-stretch: normal;\nsnippet fst:sc\n	font-stretch: semi-condensed;\nsnippet fst:se\n	font-stretch: semi-expanded;\nsnippet fst:uc\n	font-stretch: ultra-condensed;\nsnippet fst:ue\n	font-stretch: ultra-expanded;\nsnippet fs\n	font-style: ${1};\nsnippet fs:i\n	font-style: italic;\nsnippet fs:n\n	font-style: normal;\nsnippet fs:o\n	font-style: oblique;\nsnippet fv\n	font-variant: ${1};\nsnippet fv:n\n	font-variant: normal;\nsnippet fv:sc\n	font-variant: small-caps;\nsnippet fw\n	font-weight: ${1};\nsnippet fw:b\n	font-weight: bold;\nsnippet fw:br\n	font-weight: bolder;\nsnippet fw:lr\n	font-weight: lighter;\nsnippet fw:n\n	font-weight: normal;\nsnippet f\n	font: ${1};\nsnippet h\n	height: ${1};\nsnippet h:a\n	height: auto;\nsnippet l\n	left: ${1};\nsnippet l:a\n	left: auto;\nsnippet lts\n	letter-spacing: ${1};\nsnippet lh\n	line-height: ${1};\nsnippet lisi\n	list-style-image: url(${1});\nsnippet lisi:n\n	list-style-image: none;\nsnippet lisp\n	list-style-position: ${1};\nsnippet lisp:i\n	list-style-position: inside;\nsnippet lisp:o\n	list-style-position: outside;\nsnippet list\n	list-style-type: ${1};\nsnippet list:c\n	list-style-type: circle;\nsnippet list:dclz\n	list-style-type: decimal-leading-zero;\nsnippet list:dc\n	list-style-type: decimal;\nsnippet list:d\n	list-style-type: disc;\nsnippet list:lr\n	list-style-type: lower-roman;\nsnippet list:n\n	list-style-type: none;\nsnippet list:s\n	list-style-type: square;\nsnippet list:ur\n	list-style-type: upper-roman;\nsnippet lis\n	list-style: ${1};\nsnippet lis:n\n	list-style: none;\nsnippet mb\n	margin-bottom: ${1};\nsnippet mb:a\n	margin-bottom: auto;\nsnippet ml\n	margin-left: ${1};\nsnippet ml:a\n	margin-left: auto;\nsnippet mr\n	margin-right: ${1};\nsnippet mr:a\n	margin-right: auto;\nsnippet mt\n	margin-top: ${1};\nsnippet mt:a\n	margin-top: auto;\nsnippet m\n	margin: ${1};\nsnippet m:4\n	margin: ${1:0} ${2:0} ${3:0} ${4:0};\nsnippet m:3\n	margin: ${1:0} ${2:0} ${3:0};\nsnippet m:2\n	margin: ${1:0} ${2:0};\nsnippet m:0\n	margin: 0;\nsnippet m:a\n	margin: auto;\nsnippet mah\n	max-height: ${1};\nsnippet mah:n\n	max-height: none;\nsnippet maw\n	max-width: ${1};\nsnippet maw:n\n	max-width: none;\nsnippet mih\n	min-height: ${1};\nsnippet miw\n	min-width: ${1};\nsnippet op\n	opacity: ${1};\nsnippet op:ie\n	filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=${1:100});\nsnippet op:ms\n	-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=${1:100})';\nsnippet orp\n	orphans: ${1};\nsnippet o+\n	outline: ${1:1px} ${2:solid} #${3:000};\nsnippet oc\n	outline-color: ${1:#000};\nsnippet oc:i\n	outline-color: invert;\nsnippet oo\n	outline-offset: ${1};\nsnippet os\n	outline-style: ${1};\nsnippet ow\n	outline-width: ${1};\nsnippet o\n	outline: ${1};\nsnippet o:n\n	outline: none;\nsnippet ovs\n	overflow-style: ${1};\nsnippet ovs:a\n	overflow-style: auto;\nsnippet ovs:mq\n	overflow-style: marquee;\nsnippet ovs:mv\n	overflow-style: move;\nsnippet ovs:p\n	overflow-style: panner;\nsnippet ovs:s\n	overflow-style: scrollbar;\nsnippet ovx\n	overflow-x: ${1};\nsnippet ovx:a\n	overflow-x: auto;\nsnippet ovx:h\n	overflow-x: hidden;\nsnippet ovx:s\n	overflow-x: scroll;\nsnippet ovx:v\n	overflow-x: visible;\nsnippet ovy\n	overflow-y: ${1};\nsnippet ovy:a\n	overflow-y: auto;\nsnippet ovy:h\n	overflow-y: hidden;\nsnippet ovy:s\n	overflow-y: scroll;\nsnippet ovy:v\n	overflow-y: visible;\nsnippet ov\n	overflow: ${1};\nsnippet ov:a\n	overflow: auto;\nsnippet ov:h\n	overflow: hidden;\nsnippet ov:s\n	overflow: scroll;\nsnippet ov:v\n	overflow: visible;\nsnippet pb\n	padding-bottom: ${1};\nsnippet pl\n	padding-left: ${1};\nsnippet pr\n	padding-right: ${1};\nsnippet pt\n	padding-top: ${1};\nsnippet p\n	padding: ${1};\nsnippet p:4\n	padding: ${1:0} ${2:0} ${3:0} ${4:0};\nsnippet p:3\n	padding: ${1:0} ${2:0} ${3:0};\nsnippet p:2\n	padding: ${1:0} ${2:0};\nsnippet p:0\n	padding: 0;\nsnippet pgba\n	page-break-after: ${1};\nsnippet pgba:aw\n	page-break-after: always;\nsnippet pgba:a\n	page-break-after: auto;\nsnippet pgba:l\n	page-break-after: left;\nsnippet pgba:r\n	page-break-after: right;\nsnippet pgbb\n	page-break-before: ${1};\nsnippet pgbb:aw\n	page-break-before: always;\nsnippet pgbb:a\n	page-break-before: auto;\nsnippet pgbb:l\n	page-break-before: left;\nsnippet pgbb:r\n	page-break-before: right;\nsnippet pgbi\n	page-break-inside: ${1};\nsnippet pgbi:a\n	page-break-inside: auto;\nsnippet pgbi:av\n	page-break-inside: avoid;\nsnippet pos\n	position: ${1};\nsnippet pos:a\n	position: absolute;\nsnippet pos:f\n	position: fixed;\nsnippet pos:r\n	position: relative;\nsnippet pos:s\n	position: static;\nsnippet q\n	quotes: ${1};\nsnippet q:en\n	quotes: '\\201C' '\\201D' '\\2018' '\\2019';\nsnippet q:n\n	quotes: none;\nsnippet q:ru\n	quotes: '\\00AB' '\\00BB' '\\201E' '\\201C';\nsnippet rz\n	resize: ${1};\nsnippet rz:b\n	resize: both;\nsnippet rz:h\n	resize: horizontal;\nsnippet rz:n\n	resize: none;\nsnippet rz:v\n	resize: vertical;\nsnippet r\n	right: ${1};\nsnippet r:a\n	right: auto;\nsnippet tbl\n	table-layout: ${1};\nsnippet tbl:a\n	table-layout: auto;\nsnippet tbl:f\n	table-layout: fixed;\nsnippet tal\n	text-align-last: ${1};\nsnippet tal:a\n	text-align-last: auto;\nsnippet tal:c\n	text-align-last: center;\nsnippet tal:l\n	text-align-last: left;\nsnippet tal:r\n	text-align-last: right;\nsnippet ta\n	text-align: ${1};\nsnippet ta:c\n	text-align: center;\nsnippet ta:l\n	text-align: left;\nsnippet ta:r\n	text-align: right;\nsnippet td\n	text-decoration: ${1};\nsnippet td:l\n	text-decoration: line-through;\nsnippet td:n\n	text-decoration: none;\nsnippet td:o\n	text-decoration: overline;\nsnippet td:u\n	text-decoration: underline;\nsnippet te\n	text-emphasis: ${1};\nsnippet te:ac\n	text-emphasis: accent;\nsnippet te:a\n	text-emphasis: after;\nsnippet te:b\n	text-emphasis: before;\nsnippet te:c\n	text-emphasis: circle;\nsnippet te:ds\n	text-emphasis: disc;\nsnippet te:dt\n	text-emphasis: dot;\nsnippet te:n\n	text-emphasis: none;\nsnippet th\n	text-height: ${1};\nsnippet th:a\n	text-height: auto;\nsnippet th:f\n	text-height: font-size;\nsnippet th:m\n	text-height: max-size;\nsnippet th:t\n	text-height: text-size;\nsnippet ti\n	text-indent: ${1};\nsnippet ti:-\n	text-indent: -9999px;\nsnippet tj\n	text-justify: ${1};\nsnippet tj:a\n	text-justify: auto;\nsnippet tj:d\n	text-justify: distribute;\nsnippet tj:ic\n	text-justify: inter-cluster;\nsnippet tj:ii\n	text-justify: inter-ideograph;\nsnippet tj:iw\n	text-justify: inter-word;\nsnippet tj:k\n	text-justify: kashida;\nsnippet tj:t\n	text-justify: tibetan;\nsnippet to+\n	text-outline: ${1:0} ${2:0} #${3:000};\nsnippet to\n	text-outline: ${1};\nsnippet to:n\n	text-outline: none;\nsnippet tr\n	text-replace: ${1};\nsnippet tr:n\n	text-replace: none;\nsnippet tsh+\n	text-shadow: ${1:0} ${2:0} ${3:0} #${4:000};\nsnippet tsh\n	text-shadow: ${1};\nsnippet tsh:n\n	text-shadow: none;\nsnippet tt\n	text-transform: ${1};\nsnippet tt:c\n	text-transform: capitalize;\nsnippet tt:l\n	text-transform: lowercase;\nsnippet tt:n\n	text-transform: none;\nsnippet tt:u\n	text-transform: uppercase;\nsnippet tw\n	text-wrap: ${1};\nsnippet tw:no\n	text-wrap: none;\nsnippet tw:n\n	text-wrap: normal;\nsnippet tw:s\n	text-wrap: suppress;\nsnippet tw:u\n	text-wrap: unrestricted;\nsnippet t\n	top: ${1};\nsnippet t:a\n	top: auto;\nsnippet va\n	vertical-align: ${1};\nsnippet va:bl\n	vertical-align: baseline;\nsnippet va:b\n	vertical-align: bottom;\nsnippet va:m\n	vertical-align: middle;\nsnippet va:sub\n	vertical-align: sub;\nsnippet va:sup\n	vertical-align: super;\nsnippet va:tb\n	vertical-align: text-bottom;\nsnippet va:tt\n	vertical-align: text-top;\nsnippet va:t\n	vertical-align: top;\nsnippet v\n	visibility: ${1};\nsnippet v:c\n	visibility: collapse;\nsnippet v:h\n	visibility: hidden;\nsnippet v:v\n	visibility: visible;\nsnippet whsc\n	white-space-collapse: ${1};\nsnippet whsc:ba\n	white-space-collapse: break-all;\nsnippet whsc:bs\n	white-space-collapse: break-strict;\nsnippet whsc:k\n	white-space-collapse: keep-all;\nsnippet whsc:l\n	white-space-collapse: loose;\nsnippet whsc:n\n	white-space-collapse: normal;\nsnippet whs\n	white-space: ${1};\nsnippet whs:n\n	white-space: normal;\nsnippet whs:nw\n	white-space: nowrap;\nsnippet whs:pl\n	white-space: pre-line;\nsnippet whs:pw\n	white-space: pre-wrap;\nsnippet whs:p\n	white-space: pre;\nsnippet wid\n	widows: ${1};\nsnippet w\n	width: ${1};\nsnippet w:a\n	width: auto;\nsnippet wob\n	word-break: ${1};\nsnippet wob:ba\n	word-break: break-all;\nsnippet wob:bs\n	word-break: break-strict;\nsnippet wob:k\n	word-break: keep-all;\nsnippet wob:l\n	word-break: loose;\nsnippet wob:n\n	word-break: normal;\nsnippet wos\n	word-spacing: ${1};\nsnippet wow\n	word-wrap: ${1};\nsnippet wow:no\n	word-wrap: none;\nsnippet wow:n\n	word-wrap: normal;\nsnippet wow:s\n	word-wrap: suppress;\nsnippet wow:u\n	word-wrap: unrestricted;\nsnippet z\n	z-index: ${1};\nsnippet z:a\n	z-index: auto;\nsnippet zoo\n	zoom: 1;\n",t.scope="css"})

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/html",["require","exports","module"],function(e,t,n){"use strict";t.snippetText='# Some useful Unicode entities\n# Non-Breaking Space\nsnippet nbs\n	&nbsp;\n# \u2190\nsnippet left\n	&#x2190;\n# \u2192\nsnippet right\n	&#x2192;\n# \u2191\nsnippet up\n	&#x2191;\n# \u2193\nsnippet down\n	&#x2193;\n# \u21a9\nsnippet return\n	&#x21A9;\n# \u21e4\nsnippet backtab\n	&#x21E4;\n# \u21e5\nsnippet tab\n	&#x21E5;\n# \u21e7\nsnippet shift\n	&#x21E7;\n# \u2303\nsnippet ctrl\n	&#x2303;\n# \u2305\nsnippet enter\n	&#x2305;\n# \u2318\nsnippet cmd\n	&#x2318;\n# \u2325\nsnippet option\n	&#x2325;\n# \u2326\nsnippet delete\n	&#x2326;\n# \u232b\nsnippet backspace\n	&#x232B;\n# \u238b\nsnippet esc\n	&#x238B;\n# Generic Doctype\nsnippet doctype HTML 4.01 Strict\n	<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01//EN"\n	"http://www.w3.org/TR/html4/strict.dtd">\nsnippet doctype HTML 4.01 Transitional\n	<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"\n	"http://www.w3.org/TR/html4/loose.dtd">\nsnippet doctype HTML 5\n	<!DOCTYPE HTML>\nsnippet doctype XHTML 1.0 Frameset\n	<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"\n	"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">\nsnippet doctype XHTML 1.0 Strict\n	<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"\n	"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">\nsnippet doctype XHTML 1.0 Transitional\n	<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN"\n	"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\nsnippet doctype XHTML 1.1\n	<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN"\n	"http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">\n# HTML Doctype 4.01 Strict\nsnippet docts\n	<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01//EN"\n	"http://www.w3.org/TR/html4/strict.dtd">\n# HTML Doctype 4.01 Transitional\nsnippet doct\n	<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"\n	"http://www.w3.org/TR/html4/loose.dtd">\n# HTML Doctype 5\nsnippet doct5\n	<!DOCTYPE HTML>\n# XHTML Doctype 1.0 Frameset\nsnippet docxf\n	<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Frameset//EN"\n	"http://www.w3.org/TR/xhtml1/DTD/xhtml1-frameset.dtd">\n# XHTML Doctype 1.0 Strict\nsnippet docxs\n	<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"\n	"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">\n# XHTML Doctype 1.0 Transitional\nsnippet docxt\n	<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN"\n	"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n# XHTML Doctype 1.1\nsnippet docx\n	<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN"\n	"http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">\n# Attributes\nsnippet attr\n	${1:attribute}="${2:property}"\nsnippet attr+\n	${1:attribute}="${2:property}" attr+${3}\nsnippet .\n	class="${1}"${2}\nsnippet #\n	id="${1}"${2}\nsnippet alt\n	alt="${1}"${2}\nsnippet charset\n	charset="${1:utf-8}"${2}\nsnippet data\n	data-${1}="${2:$1}"${3}\nsnippet for\n	for="${1}"${2}\nsnippet height\n	height="${1}"${2}\nsnippet href\n	href="${1:#}"${2}\nsnippet lang\n	lang="${1:en}"${2}\nsnippet media\n	media="${1}"${2}\nsnippet name\n	name="${1}"${2}\nsnippet rel\n	rel="${1}"${2}\nsnippet scope\n	scope="${1:row}"${2}\nsnippet src\n	src="${1}"${2}\nsnippet title=\n	title="${1}"${2}\nsnippet type\n	type="${1}"${2}\nsnippet value\n	value="${1}"${2}\nsnippet width\n	width="${1}"${2}\n# Elements\nsnippet a\n	<a href="${1:#}">${2:$1}</a>\nsnippet a.\n	<a class="${1}" href="${2:#}">${3:$1}</a>\nsnippet a#\n	<a id="${1}" href="${2:#}">${3:$1}</a>\nsnippet a:ext\n	<a href="http://${1:example.com}">${2:$1}</a>\nsnippet a:mail\n	<a href="mailto:${1:joe@example.com}?subject=${2:feedback}">${3:email me}</a>\nsnippet abbr\n	<abbr title="${1}">${2}</abbr>\nsnippet address\n	<address>\n		${1}\n	</address>\nsnippet area\n	<area shape="${1:rect}" coords="${2}" href="${3}" alt="${4}" />\nsnippet area+\n	<area shape="${1:rect}" coords="${2}" href="${3}" alt="${4}" />\n	area+${5}\nsnippet area:c\n	<area shape="circle" coords="${1}" href="${2}" alt="${3}" />\nsnippet area:d\n	<area shape="default" coords="${1}" href="${2}" alt="${3}" />\nsnippet area:p\n	<area shape="poly" coords="${1}" href="${2}" alt="${3}" />\nsnippet area:r\n	<area shape="rect" coords="${1}" href="${2}" alt="${3}" />\nsnippet article\n	<article>\n		${1}\n	</article>\nsnippet article.\n	<article class="${1}">\n		${2}\n	</article>\nsnippet article#\n	<article id="${1}">\n		${2}\n	</article>\nsnippet aside\n	<aside>\n		${1}\n	</aside>\nsnippet aside.\n	<aside class="${1}">\n		${2}\n	</aside>\nsnippet aside#\n	<aside id="${1}">\n		${2}\n	</aside>\nsnippet audio\n	<audio src="${1}>${2}</audio>\nsnippet b\n	<b>${1}</b>\nsnippet base\n	<base href="${1}" target="${2}" />\nsnippet bdi\n	<bdi>${1}</bdo>\nsnippet bdo\n	<bdo dir="${1}">${2}</bdo>\nsnippet bdo:l\n	<bdo dir="ltr">${1}</bdo>\nsnippet bdo:r\n	<bdo dir="rtl">${1}</bdo>\nsnippet blockquote\n	<blockquote>\n		${1}\n	</blockquote>\nsnippet body\n	<body>\n		${1}\n	</body>\nsnippet br\n	<br />${1}\nsnippet button\n	<button type="${1:submit}">${2}</button>\nsnippet button.\n	<button class="${1:button}" type="${2:submit}">${3}</button>\nsnippet button#\n	<button id="${1}" type="${2:submit}">${3}</button>\nsnippet button:s\n	<button type="submit">${1}</button>\nsnippet button:r\n	<button type="reset">${1}</button>\nsnippet canvas\n	<canvas>\n		${1}\n	</canvas>\nsnippet caption\n	<caption>${1}</caption>\nsnippet cite\n	<cite>${1}</cite>\nsnippet code\n	<code>${1}</code>\nsnippet col\n	<col />${1}\nsnippet col+\n	<col />\n	col+${1}\nsnippet colgroup\n	<colgroup>\n		${1}\n	</colgroup>\nsnippet colgroup+\n	<colgroup>\n		<col />\n		col+${1}\n	</colgroup>\nsnippet command\n	<command type="command" label="${1}" icon="${2}" />\nsnippet command:c\n	<command type="checkbox" label="${1}" icon="${2}" />\nsnippet command:r\n	<command type="radio" radiogroup="${1}" label="${2}" icon="${3}" />\nsnippet datagrid\n	<datagrid>\n		${1}\n	</datagrid>\nsnippet datalist\n	<datalist>\n		${1}\n	</datalist>\nsnippet datatemplate\n	<datatemplate>\n		${1}\n	</datatemplate>\nsnippet dd\n	<dd>${1}</dd>\nsnippet dd.\n	<dd class="${1}">${2}</dd>\nsnippet dd#\n	<dd id="${1}">${2}</dd>\nsnippet del\n	<del>${1}</del>\nsnippet details\n	<details>${1}</details>\nsnippet dfn\n	<dfn>${1}</dfn>\nsnippet dialog\n	<dialog>\n		${1}\n	</dialog>\nsnippet div\n	<div>\n		${1}\n	</div>\nsnippet div.\n	<div class="${1}">\n		${2}\n	</div>\nsnippet div#\n	<div id="${1}">\n		${2}\n	</div>\nsnippet dl\n	<dl>\n		${1}\n	</dl>\nsnippet dl.\n	<dl class="${1}">\n		${2}\n	</dl>\nsnippet dl#\n	<dl id="${1}">\n		${2}\n	</dl>\nsnippet dl+\n	<dl>\n		<dt>${1}</dt>\n		<dd>${2}</dd>\n		dt+${3}\n	</dl>\nsnippet dt\n	<dt>${1}</dt>\nsnippet dt.\n	<dt class="${1}">${2}</dt>\nsnippet dt#\n	<dt id="${1}">${2}</dt>\nsnippet dt+\n	<dt>${1}</dt>\n	<dd>${2}</dd>\n	dt+${3}\nsnippet em\n	<em>${1}</em>\nsnippet embed\n	<embed src=${1} type="${2} />\nsnippet fieldset\n	<fieldset>\n		${1}\n	</fieldset>\nsnippet fieldset.\n	<fieldset class="${1}">\n		${2}\n	</fieldset>\nsnippet fieldset#\n	<fieldset id="${1}">\n		${2}\n	</fieldset>\nsnippet fieldset+\n	<fieldset>\n		<legend><span>${1}</span></legend>\n		${2}\n	</fieldset>\n	fieldset+${3}\nsnippet figcaption\n	<figcaption>${1}</figcaption>\nsnippet figure\n	<figure>${1}</figure>\nsnippet footer\n	<footer>\n		${1}\n	</footer>\nsnippet footer.\n	<footer class="${1}">\n		${2}\n	</footer>\nsnippet footer#\n	<footer id="${1}">\n		${2}\n	</footer>\nsnippet form\n	<form action="${1}" method="${2:get}" accept-charset="utf-8">\n		${3}\n	</form>\nsnippet form.\n	<form class="${1}" action="${2}" method="${3:get}" accept-charset="utf-8">\n		${4}\n	</form>\nsnippet form#\n	<form id="${1}" action="${2}" method="${3:get}" accept-charset="utf-8">\n		${4}\n	</form>\nsnippet h1\n	<h1>${1}</h1>\nsnippet h1.\n	<h1 class="${1}">${2}</h1>\nsnippet h1#\n	<h1 id="${1}">${2}</h1>\nsnippet h2\n	<h2>${1}</h2>\nsnippet h2.\n	<h2 class="${1}">${2}</h2>\nsnippet h2#\n	<h2 id="${1}">${2}</h2>\nsnippet h3\n	<h3>${1}</h3>\nsnippet h3.\n	<h3 class="${1}">${2}</h3>\nsnippet h3#\n	<h3 id="${1}">${2}</h3>\nsnippet h4\n	<h4>${1}</h4>\nsnippet h4.\n	<h4 class="${1}">${2}</h4>\nsnippet h4#\n	<h4 id="${1}">${2}</h4>\nsnippet h5\n	<h5>${1}</h5>\nsnippet h5.\n	<h5 class="${1}">${2}</h5>\nsnippet h5#\n	<h5 id="${1}">${2}</h5>\nsnippet h6\n	<h6>${1}</h6>\nsnippet h6.\n	<h6 class="${1}">${2}</h6>\nsnippet h6#\n	<h6 id="${1}">${2}</h6>\nsnippet head\n	<head>\n		<meta http-equiv="content-type" content="text/html; charset=utf-8" />\n\n		<title>${1:`substitute(Filename(\'\', \'Page Title\'), \'^.\', \'\\u&\', \'\')`}</title>\n		${2}\n	</head>\nsnippet header\n	<header>\n		${1}\n	</header>\nsnippet header.\n	<header class="${1}">\n		${2}\n	</header>\nsnippet header#\n	<header id="${1}">\n		${2}\n	</header>\nsnippet hgroup\n	<hgroup>\n		${1}\n	</hgroup>\nsnippet hgroup.\n	<hgroup class="${1}>\n		${2}\n	</hgroup>\nsnippet hr\n	<hr />${1}\nsnippet html\n	<html>\n	${1}\n	</html>\nsnippet xhtml\n	<html xmlns="http://www.w3.org/1999/xhtml">\n	${1}\n	</html>\nsnippet html5\n	<!DOCTYPE html>\n	<html>\n		<head>\n			<meta http-equiv="content-type" content="text/html; charset=utf-8" />\n			<title>${1:`substitute(Filename(\'\', \'Page Title\'), \'^.\', \'\\u&\', \'\')`}</title>\n			${2:meta}\n		</head>\n		<body>\n			${3:body}\n		</body>\n	</html>\nsnippet i\n	<i>${1}</i>\nsnippet iframe\n	<iframe src="${1}" frameborder="0"></iframe>${2}\nsnippet iframe.\n	<iframe class="${1}" src="${2}" frameborder="0"></iframe>${3}\nsnippet iframe#\n	<iframe id="${1}" src="${2}" frameborder="0"></iframe>${3}\nsnippet img\n	<img src="${1}" alt="${2}" />${3}\nsnippet img.\n	<img class="${1}" src="${2}" alt="${3}" />${4}\nsnippet img#\n	<img id="${1}" src="${2}" alt="${3}" />${4}\nsnippet input\n	<input type="${1:text/submit/hidden/button/image}" name="${2}" id="${3:$2}" value="${4}" />${5}\nsnippet input.\n	<input class="${1}" type="${2:text/submit/hidden/button/image}" name="${3}" id="${4:$3}" value="${5}" />${6}\nsnippet input:text\n	<input type="text" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:submit\n	<input type="submit" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:hidden\n	<input type="hidden" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:button\n	<input type="button" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:image\n	<input type="image" name="${1}" id="${2:$1}" src="${3}" alt="${4}" />${5}\nsnippet input:checkbox\n	<input type="checkbox" name="${1}" id="${2:$1}" />${3}\nsnippet input:radio\n	<input type="radio" name="${1}" id="${2:$1}" />${3}\nsnippet input:color\n	<input type="color" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:date\n	<input type="date" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:datetime\n	<input type="datetime" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:datetime-local\n	<input type="datetime-local" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:email\n	<input type="email" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:file\n	<input type="file" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:month\n	<input type="month" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:number\n	<input type="number" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:password\n	<input type="password" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:range\n	<input type="range" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:reset\n	<input type="reset" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:search\n	<input type="search" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:time\n	<input type="time" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:url\n	<input type="url" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet input:week\n	<input type="week" name="${1}" id="${2:$1}" value="${3}" />${4}\nsnippet ins\n	<ins>${1}</ins>\nsnippet kbd\n	<kbd>${1}</kbd>\nsnippet keygen\n	<keygen>${1}</keygen>\nsnippet label\n	<label for="${2:$1}">${1}</label>\nsnippet label:i\n	<label for="${2:$1}">${1}</label>\n	<input type="${3:text/submit/hidden/button}" name="${4:$2}" id="${5:$2}" value="${6}" />${7}\nsnippet label:s\n	<label for="${2:$1}">${1}</label>\n	<select name="${3:$2}" id="${4:$2}">\n		<option value="${5}">${6:$5}</option>\n	</select>\nsnippet legend\n	<legend>${1}</legend>\nsnippet legend+\n	<legend><span>${1}</span></legend>\nsnippet li\n	<li>${1}</li>\nsnippet li.\n	<li class="${1}">${2}</li>\nsnippet li+\n	<li>${1}</li>\n	li+${2}\nsnippet lia\n	<li><a href="${2:#}">${1}</a></li>\nsnippet lia+\n	<li><a href="${2:#}">${1}</a></li>\n	lia+${3}\nsnippet link\n	<link rel="${1}" href="${2}" title="${3}" type="${4}" />${5}\nsnippet link:atom\n	<link rel="alternate" href="${1:atom.xml}" title="Atom" type="application/atom+xml" />${2}\nsnippet link:css\n	<link rel="stylesheet" href="${2:style.css}" type="text/css" media="${3:all}" />${4}\nsnippet link:favicon\n	<link rel="shortcut icon" href="${1:favicon.ico}" type="image/x-icon" />${2}\nsnippet link:rss\n	<link rel="alternate" href="${1:rss.xml}" title="RSS" type="application/atom+xml" />${2}\nsnippet link:touch\n	<link rel="apple-touch-icon" href="${1:favicon.png}" />${2}\nsnippet map\n	<map name="${1}">\n		${2}\n	</map>\nsnippet map.\n	<map class="${1}" name="${2}">\n		${3}\n	</map>\nsnippet map#\n	<map name="${1}" id="${2:$1}>\n		${3}\n	</map>\nsnippet map+\n	<map name="${1}">\n		<area shape="${2}" coords="${3}" href="${4}" alt="${5}" />${6}\n	</map>${7}\nsnippet mark\n	<mark>${1}</mark>\nsnippet menu\n	<menu>\n		${1}\n	</menu>\nsnippet menu:c\n	<menu type="context">\n		${1}\n	</menu>\nsnippet menu:t\n	<menu type="toolbar">\n		${1}\n	</menu>\nsnippet meta\n	<meta http-equiv="${1}" content="${2}" />${3}\nsnippet meta:compat\n	<meta http-equiv="X-UA-Compatible" content="IE=${1:7,8,edge}" />${3}\nsnippet meta:refresh\n	<meta http-equiv="refresh" content="text/html;charset=UTF-8" />${3}\nsnippet meta:utf\n	<meta http-equiv="content-type" content="text/html;charset=UTF-8" />${3}\nsnippet meter\n	<meter>${1}</meter>\nsnippet nav\n	<nav>\n		${1}\n	</nav>\nsnippet nav.\n	<nav class="${1}">\n		${2}\n	</nav>\nsnippet nav#\n	<nav id="${1}">\n		${2}\n	</nav>\nsnippet noscript\n	<noscript>\n		${1}\n	</noscript>\nsnippet object\n	<object data="${1}" type="${2}">\n		${3}\n	</object>${4}\n# Embed QT Movie\nsnippet movie\n	<object width="$2" height="$3" classid="clsid:02BF25D5-8C17-4B23-BC80-D3488ABDDC6B"\n	 codebase="http://www.apple.com/qtactivex/qtplugin.cab">\n		<param name="src" value="$1" />\n		<param name="controller" value="$4" />\n		<param name="autoplay" value="$5" />\n		<embed src="${1:movie.mov}"\n			width="${2:320}" height="${3:240}"\n			controller="${4:true}" autoplay="${5:true}"\n			scale="tofit" cache="true"\n			pluginspage="http://www.apple.com/quicktime/download/" />\n	</object>${6}\nsnippet ol\n	<ol>\n		${1}\n	</ol>\nsnippet ol.\n	<ol class="${1}>\n		${2}\n	</ol>\nsnippet ol#\n	<ol id="${1}>\n		${2}\n	</ol>\nsnippet ol+\n	<ol>\n		<li>${1}</li>\n		li+${2}\n	</ol>\nsnippet opt\n	<option value="${1}">${2:$1}</option>\nsnippet opt+\n	<option value="${1}">${2:$1}</option>\n	opt+${3}\nsnippet optt\n	<option>${1}</option>\nsnippet optgroup\n	<optgroup>\n		<option value="${1}">${2:$1}</option>\n		opt+${3}\n	</optgroup>\nsnippet output\n	<output>${1}</output>\nsnippet p\n	<p>${1}</p>\nsnippet param\n	<param name="${1}" value="${2}" />${3}\nsnippet pre\n	<pre>\n		${1}\n	</pre>\nsnippet progress\n	<progress>${1}</progress>\nsnippet q\n	<q>${1}</q>\nsnippet rp\n	<rp>${1}</rp>\nsnippet rt\n	<rt>${1}</rt>\nsnippet ruby\n	<ruby>\n		<rp><rt>${1}</rt></rp>\n	</ruby>\nsnippet s\n	<s>${1}</s>\nsnippet samp\n	<samp>\n		${1}\n	</samp>\nsnippet script\n	<script type="text/javascript" charset="utf-8">\n		${1}\n	<\/script>\nsnippet scriptsrc\n	<script src="${1}.js" type="text/javascript" charset="utf-8"><\/script>\nsnippet section\n	<section>\n		${1}\n	</section>\nsnippet section.\n	<section class="${1}">\n		${2}\n	</section>\nsnippet section#\n	<section id="${1}">\n		${2}\n	</section>\nsnippet select\n	<select name="${1}" id="${2:$1}">\n		${3}\n	</select>\nsnippet select.\n	<select name="${1}" id="${2:$1}" class="${3}>\n		${4}\n	</select>\nsnippet select+\n	<select name="${1}" id="${2:$1}">\n		<option value="${3}">${4:$3}</option>\n		opt+${5}\n	</select>\nsnippet small\n	<small>${1}</small>\nsnippet source\n	<source src="${1}" type="${2}" media="${3}" />\nsnippet span\n	<span>${1}</span>\nsnippet strong\n	<strong>${1}</strong>\nsnippet style\n	<style type="text/css" media="${1:all}">\n		${2}\n	</style>\nsnippet sub\n	<sub>${1}</sub>\nsnippet summary\n	<summary>\n		${1}\n	</summary>\nsnippet sup\n	<sup>${1}</sup>\nsnippet table\n	<table border="${1:0}">\n		${2}\n	</table>\nsnippet table.\n	<table class="${1}" border="${2:0}">\n		${3}\n	</table>\nsnippet table#\n	<table id="${1}" border="${2:0}">\n		${3}\n	</table>\nsnippet tbody\n	<tbody>\n		${1}\n	</tbody>\nsnippet td\n	<td>${1}</td>\nsnippet td.\n	<td class="${1}">${2}</td>\nsnippet td#\n	<td id="${1}">${2}</td>\nsnippet td+\n	<td>${1}</td>\n	td+${2}\nsnippet textarea\n	<textarea name="${1}" id=${2:$1} rows="${3:8}" cols="${4:40}">${5}</textarea>${6}\nsnippet tfoot\n	<tfoot>\n		${1}\n	</tfoot>\nsnippet th\n	<th>${1}</th>\nsnippet th.\n	<th class="${1}">${2}</th>\nsnippet th#\n	<th id="${1}">${2}</th>\nsnippet th+\n	<th>${1}</th>\n	th+${2}\nsnippet thead\n	<thead>\n		${1}\n	</thead>\nsnippet time\n	<time datetime="${1}" pubdate="${2:$1}>${3:$1}</time>\nsnippet title\n	<title>${1:`substitute(Filename(\'\', \'Page Title\'), \'^.\', \'\\u&\', \'\')`}</title>\nsnippet tr\n	<tr>\n		${1}\n	</tr>\nsnippet tr+\n	<tr>\n		<td>${1}</td>\n		td+${2}\n	</tr>\nsnippet track\n	<track src="${1}" srclang="${2}" label="${3}" default="${4:default}>${5}</track>${6}\nsnippet ul\n	<ul>\n		${1}\n	</ul>\nsnippet ul.\n	<ul class="${1}">\n		${2}\n	</ul>\nsnippet ul#\n	<ul id="${1}">\n		${2}\n	</ul>\nsnippet ul+\n	<ul>\n		<li>${1}</li>\n		li+${2}\n	</ul>\nsnippet var\n	<var>${1}</var>\nsnippet video\n	<video src="${1} height="${2}" width="${3}" preload="${5:none}" autoplay="${6:autoplay}>${7}</video>${8}\nsnippet wbr\n	<wbr />${1}\n',t.scope="html"})

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/javascript",["require","exports","module"],function(e,t,n){"use strict";t.snippetText='# Prototype\nsnippet proto\n	${1:class_name}.prototype.${2:method_name} = function(${3:first_argument}) {\n		${4:// body...}\n	};\n# Function\nsnippet fun\n	function ${1?:function_name}(${2:argument}) {\n		${3:// body...}\n	}\n# Anonymous Function\nregex /((=)\\s*|(:)\\s*|(\\()|\\b)/f/(\\))?/\nsnippet f\n	function${M1?: ${1:functionName}}($2) {\n		${0:$TM_SELECTED_TEXT}\n	}${M2?;}${M3?,}${M4?)}\n# Immediate function\ntrigger \\(?f\\(\nendTrigger \\)?\nsnippet f(\n	(function(${1}) {\n		${0:${TM_SELECTED_TEXT:/* code */}}\n	}(${1}));\n# if\nsnippet if\n	if (${1:true}) {\n		${0}\n	}\n# if ... else\nsnippet ife\n	if (${1:true}) {\n		${2}\n	} else {\n		${0}\n	}\n# tertiary conditional\nsnippet ter\n	${1:/* condition */} ? ${2:a} : ${3:b}\n# switch\nsnippet switch\n	switch (${1:expression}) {\n		case \'${3:case}\':\n			${4:// code}\n			break;\n		${5}\n		default:\n			${2:// code}\n	}\n# case\nsnippet case\n	case \'${1:case}\':\n		${2:// code}\n		break;\n	${3}\n\n# while (...) {...}\nsnippet wh\n	while (${1:/* condition */}) {\n		${0:/* code */}\n	}\n# try\nsnippet try\n	try {\n		${0:/* code */}\n	} catch (e) {}\n# do...while\nsnippet do\n	do {\n		${2:/* code */}\n	} while (${1:/* condition */});\n# Object Method\nsnippet :f\nregex /([,{[])|^\\s*/:f/\n	${1:method_name}: function(${2:attribute}) {\n		${0}\n	}${3:,}\n# setTimeout function\nsnippet setTimeout\nregex /\\b/st|timeout|setTimeo?u?t?/\n	setTimeout(function() {${3:$TM_SELECTED_TEXT}}, ${1:10});\n# Get Elements\nsnippet gett\n	getElementsBy${1:TagName}(\'${2}\')${3}\n# Get Element\nsnippet get\n	getElementBy${1:Id}(\'${2}\')${3}\n# console.log (Firebug)\nsnippet cl\n	console.log(${1});\n# return\nsnippet ret\n	return ${1:result}\n# for (property in object ) { ... }\nsnippet fori\n	for (var ${1:prop} in ${2:Things}) {\n		${0:$2[$1]}\n	}\n# hasOwnProperty\nsnippet has\n	hasOwnProperty(${1})\n# docstring\nsnippet /**\n	/**\n	 * ${1:description}\n	 *\n	 */\nsnippet @par\nregex /^\\s*\\*\\s*/@(para?m?)?/\n	@param {${1:type}} ${2:name} ${3:description}\nsnippet @ret\n	@return {${1:type}} ${2:description}\n# JSON.parse\nsnippet jsonp\n	JSON.parse(${1:jstr});\n# JSON.stringify\nsnippet jsons\n	JSON.stringify(${1:object});\n# self-defining function\nsnippet sdf\n	var ${1:function_name} = function(${2:argument}) {\n		${3:// initial code ...}\n\n		$1 = function($2) {\n			${4:// main code}\n		};\n	}\n# singleton\nsnippet sing\n	function ${1:Singleton} (${2:argument}) {\n		// the cached instance\n		var instance;\n\n		// rewrite the constructor\n		$1 = function $1($2) {\n			return instance;\n		};\n		\n		// carry over the prototype properties\n		$1.prototype = this;\n\n		// the instance\n		instance = new $1();\n\n		// reset the constructor pointer\n		instance.constructor = $1;\n\n		${3:// code ...}\n\n		return instance;\n	}\n# class\nsnippet class\nregex /^\\s*/clas{0,2}/\n	var ${1:class} = function(${20}) {\n		$40$0\n	};\n	\n	(function() {\n		${60:this.prop = ""}\n	}).call(${1:class}.prototype);\n	\n	exports.${1:class} = ${1:class};\n# \nsnippet for-\n	for (var ${1:i} = ${2:Things}.length; ${1:i}--; ) {\n		${0:${2:Things}[${1:i}];}\n	}\n# for (...) {...}\nsnippet for\n	for (var ${1:i} = 0; $1 < ${2:Things}.length; $1++) {\n		${3:$2[$1]}$0\n	}\n# for (...) {...} (Improved Native For-Loop)\nsnippet forr\n	for (var ${1:i} = ${2:Things}.length - 1; $1 >= 0; $1--) {\n		${3:$2[$1]}$0\n	}\n\n\n#modules\nsnippet def\n	define(function(require, exports, module) {\n	"use strict";\n	var ${1/.*\\///} = require("${1}");\n	\n	$TM_SELECTED_TEXT\n	});\nsnippet req\nguard ^\\s*\n	var ${1/.*\\///} = require("${1}");\n	$0\nsnippet requ\nguard ^\\s*\n	var ${1/.*\\/(.)/\\u$1/} = require("${1}").${1/.*\\/(.)/\\u$1/};\n	$0\n',t.scope="javascript"})

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports.id = 'ace/mode/html_worker';
	module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/html/saxparser\",[\"require\",\"exports\",\"module\"],function(acequire,exports,module){module.exports=function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=\"function\"==typeof acequire&&acequire;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw Error(\"Cannot find module '\"+o+\"'\")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}for(var i=\"function\"==typeof acequire&&acequire,o=0;r.length>o;o++)s(r[o]);return s}({1:[function(_dereq_,module,exports){function isScopeMarker(node){return\"http://www.w3.org/1999/xhtml\"===node.namespaceURI?\"applet\"===node.localName||\"caption\"===node.localName||\"marquee\"===node.localName||\"object\"===node.localName||\"table\"===node.localName||\"td\"===node.localName||\"th\"===node.localName:\"http://www.w3.org/1998/Math/MathML\"===node.namespaceURI?\"mi\"===node.localName||\"mo\"===node.localName||\"mn\"===node.localName||\"ms\"===node.localName||\"mtext\"===node.localName||\"annotation-xml\"===node.localName:\"http://www.w3.org/2000/svg\"===node.namespaceURI?\"foreignObject\"===node.localName||\"desc\"===node.localName||\"title\"===node.localName:void 0}function isListItemScopeMarker(node){return isScopeMarker(node)||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"ol\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"ul\"===node.localName}function isTableScopeMarker(node){return\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"table\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"html\"===node.localName}function isTableBodyScopeMarker(node){return\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"tbody\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"tfoot\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"thead\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"html\"===node.localName}function isTableRowScopeMarker(node){return\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"tr\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"html\"===node.localName}function isButtonScopeMarker(node){return isScopeMarker(node)||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"button\"===node.localName}function isSelectScopeMarker(node){return!(\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"optgroup\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"option\"===node.localName)}function ElementStack(){this.elements=[],this.rootNode=null,this.headElement=null,this.bodyElement=null}ElementStack.prototype._inScope=function(localName,isMarker){for(var i=this.elements.length-1;i>=0;i--){var node=this.elements[i];if(node.localName===localName)return!0;if(isMarker(node))return!1}},ElementStack.prototype.push=function(item){this.elements.push(item)},ElementStack.prototype.pushHtmlElement=function(item){this.rootNode=item.node,this.push(item)},ElementStack.prototype.pushHeadElement=function(item){this.headElement=item.node,this.push(item)},ElementStack.prototype.pushBodyElement=function(item){this.bodyElement=item.node,this.push(item)},ElementStack.prototype.pop=function(){return this.elements.pop()},ElementStack.prototype.remove=function(item){this.elements.splice(this.elements.indexOf(item),1)},ElementStack.prototype.popUntilPopped=function(localName){var element;do element=this.pop();while(element.localName!=localName)},ElementStack.prototype.popUntilTableScopeMarker=function(){for(;!isTableScopeMarker(this.top);)this.pop()},ElementStack.prototype.popUntilTableBodyScopeMarker=function(){for(;!isTableBodyScopeMarker(this.top);)this.pop()},ElementStack.prototype.popUntilTableRowScopeMarker=function(){for(;!isTableRowScopeMarker(this.top);)this.pop()},ElementStack.prototype.item=function(index){return this.elements[index]},ElementStack.prototype.contains=function(element){return-1!==this.elements.indexOf(element)},ElementStack.prototype.inScope=function(localName){return this._inScope(localName,isScopeMarker)},ElementStack.prototype.inListItemScope=function(localName){return this._inScope(localName,isListItemScopeMarker)},ElementStack.prototype.inTableScope=function(localName){return this._inScope(localName,isTableScopeMarker)},ElementStack.prototype.inButtonScope=function(localName){return this._inScope(localName,isButtonScopeMarker)},ElementStack.prototype.inSelectScope=function(localName){return this._inScope(localName,isSelectScopeMarker)},ElementStack.prototype.hasNumberedHeaderElementInScope=function(){for(var i=this.elements.length-1;i>=0;i--){var node=this.elements[i];if(node.isNumberedHeader())return!0;if(isScopeMarker(node))return!1}},ElementStack.prototype.furthestBlockForFormattingElement=function(element){for(var furthestBlock=null,i=this.elements.length-1;i>=0;i--){var node=this.elements[i];\nif(node.node===element)break;node.isSpecial()&&(furthestBlock=node)}return furthestBlock},ElementStack.prototype.findIndex=function(localName){for(var i=this.elements.length-1;i>=0;i--)if(this.elements[i].localName==localName)return i;return-1},ElementStack.prototype.remove_openElements_until=function(callback){for(var element,finished=!1;!finished;)element=this.elements.pop(),finished=callback(element);return element},Object.defineProperty(ElementStack.prototype,\"top\",{get:function(){return this.elements[this.elements.length-1]}}),Object.defineProperty(ElementStack.prototype,\"length\",{get:function(){return this.elements.length}}),exports.ElementStack=ElementStack},{}],2:[function(_dereq_,module,exports){function isAlphaNumeric(c){return c>=\"0\"&&\"9\">=c||c>=\"a\"&&\"z\">=c||c>=\"A\"&&\"Z\">=c}function isHexDigit(c){return c>=\"0\"&&\"9\">=c||c>=\"a\"&&\"f\">=c||c>=\"A\"&&\"F\">=c}function isDecimalDigit(c){return c>=\"0\"&&\"9\">=c}var entities=_dereq_(\"html5-entities\"),InputStream=_dereq_(\"./InputStream\").InputStream,namedEntityPrefixes={};Object.keys(entities).forEach(function(entityKey){for(var i=0;entityKey.length>i;i++)namedEntityPrefixes[entityKey.substring(0,i+1)]=!0});var EntityParser={};EntityParser.consumeEntity=function(buffer,tokenizer,additionalAllowedCharacter){var decodedCharacter=\"\",consumedCharacters=\"\",ch=buffer.char();if(ch===InputStream.EOF)return!1;if(consumedCharacters+=ch,\"\t\"==ch||\"\\n\"==ch||\"\u000b\"==ch||\" \"==ch||\"<\"==ch||\"&\"==ch)return buffer.unget(consumedCharacters),!1;if(additionalAllowedCharacter===ch)return buffer.unget(consumedCharacters),!1;if(\"#\"==ch){if(ch=buffer.shift(1),ch===InputStream.EOF)return tokenizer._parseError(\"expected-numeric-entity-but-got-eof\"),buffer.unget(consumedCharacters),!1;consumedCharacters+=ch;var radix=10,isDigit=isDecimalDigit;if(\"x\"==ch||\"X\"==ch){if(radix=16,isDigit=isHexDigit,ch=buffer.shift(1),ch===InputStream.EOF)return tokenizer._parseError(\"expected-numeric-entity-but-got-eof\"),buffer.unget(consumedCharacters),!1;consumedCharacters+=ch}if(isDigit(ch)){for(var code=\"\";ch!==InputStream.EOF&&isDigit(ch);)code+=ch,ch=buffer.char();code=parseInt(code,radix);var replacement=this.replaceEntityNumbers(code);if(replacement&&(tokenizer._parseError(\"invalid-numeric-entity-replaced\"),code=replacement),code>65535&&1114111>=code){code-=65536;var first=((1047552&code)>>10)+55296,second=(1023&code)+56320;decodedCharacter=String.fromCharCode(first,second)}else decodedCharacter=String.fromCharCode(code);return\";\"!==ch&&(tokenizer._parseError(\"numeric-entity-without-semicolon\"),buffer.unget(ch)),decodedCharacter}return buffer.unget(consumedCharacters),tokenizer._parseError(\"expected-numeric-entity\"),!1}if(ch>=\"a\"&&\"z\">=ch||ch>=\"A\"&&\"Z\">=ch){for(var mostRecentMatch=\"\";namedEntityPrefixes[consumedCharacters]&&(entities[consumedCharacters]&&(mostRecentMatch=consumedCharacters),\";\"!=ch)&&(ch=buffer.char(),ch!==InputStream.EOF);)consumedCharacters+=ch;return mostRecentMatch?(decodedCharacter=entities[mostRecentMatch],\";\"===ch||!additionalAllowedCharacter||!isAlphaNumeric(ch)&&\"=\"!==ch?(consumedCharacters.length>mostRecentMatch.length&&buffer.unget(consumedCharacters.substring(mostRecentMatch.length)),\";\"!==ch&&tokenizer._parseError(\"named-entity-without-semicolon\"),decodedCharacter):(buffer.unget(consumedCharacters),!1)):(tokenizer._parseError(\"expected-named-entity\"),buffer.unget(consumedCharacters),!1)}},EntityParser.replaceEntityNumbers=function(c){switch(c){case 0:return 65533;case 19:return 16;case 128:return 8364;case 129:return 129;case 130:return 8218;case 131:return 402;case 132:return 8222;case 133:return 8230;case 134:return 8224;case 135:return 8225;case 136:return 710;case 137:return 8240;case 138:return 352;case 139:return 8249;case 140:return 338;case 141:return 141;case 142:return 381;case 143:return 143;case 144:return 144;case 145:return 8216;case 146:return 8217;case 147:return 8220;case 148:return 8221;case 149:return 8226;case 150:return 8211;case 151:return 8212;case 152:return 732;case 153:return 8482;case 154:return 353;case 155:return 8250;case 156:return 339;case 157:return 157;case 158:return 382;case 159:return 376;default:if(c>=55296&&57343>=c||c>1114111)return 65533;if(c>=1&&8>=c||c>=14&&31>=c||c>=127&&159>=c||c>=64976&&65007>=c||11==c||65534==c||131070==c||3145726==c||196607==c||262142==c||262143==c||327678==c||327679==c||393214==c||393215==c||458750==c||458751==c||524286==c||524287==c||589822==c||589823==c||655358==c||655359==c||720894==c||720895==c||786430==c||786431==c||851966==c||851967==c||917502==c||917503==c||983038==c||983039==c||1048574==c||1048575==c||1114110==c||1114111==c)return c}},exports.EntityParser=EntityParser},{\"./InputStream\":3,\"html5-entities\":12}],3:[function(_dereq_,module,exports){function InputStream(){this.data=\"\",this.start=0,this.committed=0,this.eof=!1,this.lastLocation={line:0,column:0}}InputStream.EOF=-1,InputStream.DRAIN=-2,InputStream.prototype={slice:function(){if(this.start>=this.data.length){if(!this.eof)throw InputStream.DRAIN;return InputStream.EOF}return this.data.slice(this.start,this.data.length)},\"char\":function(){if(!this.eof&&this.start>=this.data.length-1)throw InputStream.DRAIN;if(this.start>=this.data.length)return InputStream.EOF;var ch=this.data[this.start++];return\"\\r\"===ch&&(ch=\"\\n\"),ch},advance:function(amount){if(this.start+=amount,this.start>=this.data.length){if(!this.eof)throw InputStream.DRAIN;return InputStream.EOF}this.committed>this.data.length/2&&(this.lastLocation=this.location(),this.data=this.data.slice(this.committed),this.start=this.start-this.committed,this.committed=0)},matchWhile:function(re){if(this.eof&&this.start>=this.data.length)return\"\";var r=RegExp(\"^\"+re+\"+\"),m=r.exec(this.slice());if(m){if(!this.eof&&m[0].length==this.data.length-this.start)throw InputStream.DRAIN;return this.advance(m[0].length),m[0]}return\"\"},matchUntil:function(re){var m,s;if(s=this.slice(),s===InputStream.EOF)return\"\";if(m=RegExp(re+(this.eof?\"|$\":\"\")).exec(s)){var t=this.data.slice(this.start,this.start+m.index);return this.advance(m.index),t.replace(/\\r/g,\"\\n\").replace(/\\n{2,}/g,\"\\n\")}throw InputStream.DRAIN},append:function(data){this.data+=data},shift:function(n){if(!this.eof&&this.start+n>=this.data.length)throw InputStream.DRAIN;if(this.eof&&this.start>=this.data.length)return InputStream.EOF;var d=\"\"+this.data.slice(this.start,this.start+n);return this.advance(Math.min(n,this.data.length-this.start)),d},peek:function(n){if(!this.eof&&this.start+n>=this.data.length)throw InputStream.DRAIN;return this.eof&&this.start>=this.data.length?InputStream.EOF:\"\"+this.data.slice(this.start,Math.min(this.start+n,this.data.length))},length:function(){return this.data.length-this.start-1},unget:function(d){d!==InputStream.EOF&&(this.start-=d.length)},undo:function(){this.start=this.committed},commit:function(){this.committed=this.start},location:function(){var lastLine=this.lastLocation.line,lastColumn=this.lastLocation.column,read=this.data.slice(0,this.committed),newlines=read.match(/\\n/g),line=newlines?lastLine+newlines.length:lastLine,column=newlines?read.length-read.lastIndexOf(\"\\n\")-1:lastColumn+read.length;return{line:line,column:column}}},exports.InputStream=InputStream},{}],4:[function(_dereq_,module,exports){function StackItem(namespaceURI,localName,attributes,node){this.localName=localName,this.namespaceURI=namespaceURI,this.attributes=attributes,this.node=node}function getAttribute(item,name){for(var i=0;item.attributes.length>i;i++)if(item.attributes[i].nodeName==name)return item.attributes[i].nodeValue;return null}var SpecialElements={\"http://www.w3.org/1999/xhtml\":[\"address\",\"applet\",\"area\",\"article\",\"aside\",\"base\",\"basefont\",\"bgsound\",\"blockquote\",\"body\",\"br\",\"button\",\"caption\",\"center\",\"col\",\"colgroup\",\"dd\",\"details\",\"dir\",\"div\",\"dl\",\"dt\",\"embed\",\"fieldset\",\"figcaption\",\"figure\",\"footer\",\"form\",\"frame\",\"frameset\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"head\",\"header\",\"hgroup\",\"hr\",\"html\",\"iframe\",\"img\",\"input\",\"isindex\",\"li\",\"link\",\"listing\",\"main\",\"marquee\",\"menu\",\"menuitem\",\"meta\",\"nav\",\"noembed\",\"noframes\",\"noscript\",\"object\",\"ol\",\"p\",\"param\",\"plaintext\",\"pre\",\"script\",\"section\",\"select\",\"source\",\"style\",\"summary\",\"table\",\"tbody\",\"td\",\"textarea\",\"tfoot\",\"th\",\"thead\",\"title\",\"tr\",\"track\",\"ul\",\"wbr\",\"xmp\"],\"http://www.w3.org/1998/Math/MathML\":[\"mi\",\"mo\",\"mn\",\"ms\",\"mtext\",\"annotation-xml\"],\"http://www.w3.org/2000/svg\":[\"foreignObject\",\"desc\",\"title\"]};StackItem.prototype.isSpecial=function(){return this.namespaceURI in SpecialElements&&SpecialElements[this.namespaceURI].indexOf(this.localName)>-1},StackItem.prototype.isFosterParenting=function(){return\"http://www.w3.org/1999/xhtml\"===this.namespaceURI?\"table\"===this.localName||\"tbody\"===this.localName||\"tfoot\"===this.localName||\"thead\"===this.localName||\"tr\"===this.localName:!1},StackItem.prototype.isNumberedHeader=function(){return\"http://www.w3.org/1999/xhtml\"===this.namespaceURI?\"h1\"===this.localName||\"h2\"===this.localName||\"h3\"===this.localName||\"h4\"===this.localName||\"h5\"===this.localName||\"h6\"===this.localName:!1},StackItem.prototype.isForeign=function(){return\"http://www.w3.org/1999/xhtml\"!=this.namespaceURI},StackItem.prototype.isHtmlIntegrationPoint=function(){if(\"http://www.w3.org/1998/Math/MathML\"===this.namespaceURI){if(\"annotation-xml\"!==this.localName)return!1;var encoding=getAttribute(this,\"encoding\");return encoding?(encoding=encoding.toLowerCase(),\"text/html\"===encoding||\"application/xhtml+xml\"===encoding):!1}return\"http://www.w3.org/2000/svg\"===this.namespaceURI?\"foreignObject\"===this.localName||\"desc\"===this.localName||\"title\"===this.localName:!1},StackItem.prototype.isMathMLTextIntegrationPoint=function(){return\"http://www.w3.org/1998/Math/MathML\"===this.namespaceURI?\"mi\"===this.localName||\"mo\"===this.localName||\"mn\"===this.localName||\"ms\"===this.localName||\"mtext\"===this.localName:!1},exports.StackItem=StackItem},{}],5:[function(_dereq_,module,exports){function isWhitespace(c){return\" \"===c||\"\\n\"===c||\"\t\"===c||\"\\r\"===c||\"\\f\"===c}function isAlpha(c){return c>=\"A\"&&\"Z\">=c||c>=\"a\"&&\"z\">=c}function Tokenizer(tokenHandler){this._tokenHandler=tokenHandler,this._state=Tokenizer.DATA,this._inputStream=new InputStream,this._currentToken=null,this._temporaryBuffer=\"\",this._additionalAllowedCharacter=\"\"}var InputStream=_dereq_(\"./InputStream\").InputStream,EntityParser=_dereq_(\"./EntityParser\").EntityParser;Tokenizer.prototype._parseError=function(code,args){this._tokenHandler.parseError(code,args)},Tokenizer.prototype._emitToken=function(token){if(\"StartTag\"===token.type)for(var i=1;token.data.length>i;i++)token.data[i].nodeName||token.data.splice(i--,1);else\"EndTag\"===token.type&&(token.selfClosing&&this._parseError(\"self-closing-flag-on-end-tag\"),0!==token.data.length&&this._parseError(\"attributes-in-end-tag\"));this._tokenHandler.processToken(token),\"StartTag\"===token.type&&token.selfClosing&&!this._tokenHandler.isSelfClosingFlagAcknowledged()&&this._parseError(\"non-void-element-with-trailing-solidus\",{name:token.name})},Tokenizer.prototype._emitCurrentToken=function(){this._state=Tokenizer.DATA,this._emitToken(this._currentToken)},Tokenizer.prototype._currentAttribute=function(){return this._currentToken.data[this._currentToken.data.length-1]},Tokenizer.prototype.setState=function(state){this._state=state},Tokenizer.prototype.tokenize=function(source){function data_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"&\"===data)tokenizer.setState(character_reference_in_data_state);else if(\"<\"===data)tokenizer.setState(tag_open_state);else if(\"\\0\"===data)tokenizer._emitToken({type:\"Characters\",data:data}),buffer.commit();else{var chars=buffer.matchUntil(\"&|<|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars}),buffer.commit()}return!0}function character_reference_in_data_state(buffer){var character=EntityParser.consumeEntity(buffer,tokenizer);return tokenizer.setState(data_state),tokenizer._emitToken({type:\"Characters\",data:character||\"&\"}),!0}function rcdata_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"&\"===data)tokenizer.setState(character_reference_in_rcdata_state);else if(\"<\"===data)tokenizer.setState(rcdata_less_than_sign_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"&|<|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars}),buffer.commit()}return!0}function character_reference_in_rcdata_state(buffer){var character=EntityParser.consumeEntity(buffer,tokenizer);return tokenizer.setState(rcdata_state),tokenizer._emitToken({type:\"Characters\",data:character||\"&\"}),!0}function rawtext_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"<\"===data)tokenizer.setState(rawtext_less_than_sign_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"<|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars})}return!0}function plaintext_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars})}return!0}function script_data_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"<\"===data)tokenizer.setState(script_data_less_than_sign_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"<|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars})}return!0}function rcdata_less_than_sign_state(buffer){var data=buffer.char();return\"/\"===data?(this._temporaryBuffer=\"\",tokenizer.setState(rcdata_end_tag_open_state)):(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(rcdata_state)),!0}function rcdata_end_tag_open_state(buffer){var data=buffer.char();return isAlpha(data)?(this._temporaryBuffer+=data,tokenizer.setState(rcdata_end_tag_name_state)):(tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(rcdata_state)),!0}function rcdata_end_tag_name_state(buffer){var appropriate=tokenizer._currentToken&&tokenizer._currentToken.name===this._temporaryBuffer.toLowerCase(),data=buffer.char();return isWhitespace(data)&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer.setState(before_attribute_name_state)):\"/\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer.setState(self_closing_tag_state)):\">\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):isAlpha(data)?(this._temporaryBuffer+=data,buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:\"</\"+this._temporaryBuffer}),buffer.unget(data),tokenizer.setState(rcdata_state)),!0}function rawtext_less_than_sign_state(buffer){var data=buffer.char();return\"/\"===data?(this._temporaryBuffer=\"\",tokenizer.setState(rawtext_end_tag_open_state)):(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(rawtext_state)),!0}function rawtext_end_tag_open_state(buffer){var data=buffer.char();return isAlpha(data)?(this._temporaryBuffer+=data,tokenizer.setState(rawtext_end_tag_name_state)):(tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(rawtext_state)),!0}function rawtext_end_tag_name_state(buffer){var appropriate=tokenizer._currentToken&&tokenizer._currentToken.name===this._temporaryBuffer.toLowerCase(),data=buffer.char();return isWhitespace(data)&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer.setState(before_attribute_name_state)):\"/\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer.setState(self_closing_tag_state)):\">\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):isAlpha(data)?(this._temporaryBuffer+=data,buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:\"</\"+this._temporaryBuffer}),buffer.unget(data),tokenizer.setState(rawtext_state)),!0}function script_data_less_than_sign_state(buffer){var data=buffer.char();return\"/\"===data?(this._temporaryBuffer=\"\",tokenizer.setState(script_data_end_tag_open_state)):\"!\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"<!\"}),tokenizer.setState(script_data_escape_start_state)):(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_end_tag_open_state(buffer){var data=buffer.char();return isAlpha(data)?(this._temporaryBuffer+=data,tokenizer.setState(script_data_end_tag_name_state)):(tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_end_tag_name_state(buffer){var appropriate=tokenizer._currentToken&&tokenizer._currentToken.name===this._temporaryBuffer.toLowerCase(),data=buffer.char();return isWhitespace(data)&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(before_attribute_name_state)):\"/\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(self_closing_tag_state)):\">\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer._emitCurrentToken()):isAlpha(data)?(this._temporaryBuffer+=data,buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:\"</\"+this._temporaryBuffer}),buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_escape_start_state(buffer){var data=buffer.char();return\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_escape_start_dash_state)):(buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_escape_start_dash_state(buffer){var data=buffer.char();return\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_escaped_dash_dash_state)):(buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_escaped_state(buffer){var data=buffer.char();if(data===InputStream.EOF)buffer.unget(data),tokenizer.setState(data_state);else if(\"-\"===data)tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_escaped_dash_state);else if(\"<\"===data)tokenizer.setState(script_data_escaped_less_then_sign_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"<|-|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars})}return!0}function script_data_escaped_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_escaped_dash_dash_state)):\"<\"===data?tokenizer.setState(script_data_escaped_less_then_sign_state):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),tokenizer.setState(script_data_escaped_state)):(tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(script_data_escaped_state)),!0}function script_data_escaped_dash_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-script\"),buffer.unget(data),tokenizer.setState(data_state)):\"<\"===data?tokenizer.setState(script_data_escaped_less_then_sign_state):\">\"===data?(tokenizer._emitToken({type:\"Characters\",data:\">\"}),tokenizer.setState(script_data_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),tokenizer.setState(script_data_escaped_state)):(tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(script_data_escaped_state)),!0}function script_data_escaped_less_then_sign_state(buffer){var data=buffer.char();return\"/\"===data?(this._temporaryBuffer=\"\",tokenizer.setState(script_data_escaped_end_tag_open_state)):isAlpha(data)?(tokenizer._emitToken({type:\"Characters\",data:\"<\"+data}),this._temporaryBuffer=data,tokenizer.setState(script_data_double_escape_start_state)):(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(script_data_escaped_state)),!0}function script_data_escaped_end_tag_open_state(buffer){var data=buffer.char();return isAlpha(data)?(this._temporaryBuffer=data,tokenizer.setState(script_data_escaped_end_tag_name_state)):(tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(script_data_escaped_state)),!0}function script_data_escaped_end_tag_name_state(buffer){var appropriate=tokenizer._currentToken&&tokenizer._currentToken.name===this._temporaryBuffer.toLowerCase(),data=buffer.char();return isWhitespace(data)&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(before_attribute_name_state)):\"/\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(self_closing_tag_state)):\">\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isAlpha(data)?(this._temporaryBuffer+=data,buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:\"</\"+this._temporaryBuffer}),buffer.unget(data),tokenizer.setState(script_data_escaped_state)),!0}function script_data_double_escape_start_state(buffer){var data=buffer.char();return isWhitespace(data)||\"/\"===data||\">\"===data?(tokenizer._emitToken({type:\"Characters\",data:data}),\"script\"===this._temporaryBuffer.toLowerCase()?tokenizer.setState(script_data_double_escaped_state):tokenizer.setState(script_data_escaped_state)):isAlpha(data)?(tokenizer._emitToken({type:\"Characters\",data:data}),this._temporaryBuffer+=data,buffer.commit()):(buffer.unget(data),tokenizer.setState(script_data_escaped_state)),!0}function script_data_double_escaped_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-script\"),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_double_escaped_dash_state)):\"<\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),tokenizer.setState(script_data_double_escaped_less_than_sign_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:data}),buffer.commit()),!0}function script_data_double_escaped_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-script\"),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_double_escaped_dash_dash_state)):\"<\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),tokenizer.setState(script_data_double_escaped_less_than_sign_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),tokenizer.setState(script_data_double_escaped_state)):(tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(script_data_double_escaped_state)),!0}function script_data_double_escaped_dash_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-script\"),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),buffer.commit()):\"<\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),tokenizer.setState(script_data_double_escaped_less_than_sign_state)):\">\"===data?(tokenizer._emitToken({type:\"Characters\",data:\">\"}),tokenizer.setState(script_data_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),tokenizer.setState(script_data_double_escaped_state)):(tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(script_data_double_escaped_state)),!0}function script_data_double_escaped_less_than_sign_state(buffer){var data=buffer.char();return\"/\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"/\"}),this._temporaryBuffer=\"\",tokenizer.setState(script_data_double_escape_end_state)):(buffer.unget(data),tokenizer.setState(script_data_double_escaped_state)),!0}function script_data_double_escape_end_state(buffer){var data=buffer.char();return isWhitespace(data)||\"/\"===data||\">\"===data?(tokenizer._emitToken({type:\"Characters\",data:data}),\"script\"===this._temporaryBuffer.toLowerCase()?tokenizer.setState(script_data_escaped_state):tokenizer.setState(script_data_double_escaped_state)):isAlpha(data)?(tokenizer._emitToken({type:\"Characters\",data:data}),this._temporaryBuffer+=data,buffer.commit()):(buffer.unget(data),tokenizer.setState(script_data_double_escaped_state)),!0}function tag_open_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"bare-less-than-sign-at-eof\"),tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(data_state)):isAlpha(data)?(tokenizer._currentToken={type:\"StartTag\",name:data.toLowerCase(),data:[]},tokenizer.setState(tag_name_state)):\"!\"===data?tokenizer.setState(markup_declaration_open_state):\"/\"===data?tokenizer.setState(close_tag_open_state):\">\"===data?(tokenizer._parseError(\"expected-tag-name-but-got-right-bracket\"),tokenizer._emitToken({type:\"Characters\",data:\"<>\"}),tokenizer.setState(data_state)):\"?\"===data?(tokenizer._parseError(\"expected-tag-name-but-got-question-mark\"),buffer.unget(data),tokenizer.setState(bogus_comment_state)):(tokenizer._parseError(\"expected-tag-name\"),tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(data_state)),!0}function close_tag_open_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"expected-closing-tag-but-got-eof\"),tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(data_state)):isAlpha(data)?(tokenizer._currentToken={type:\"EndTag\",name:data.toLowerCase(),data:[]},tokenizer.setState(tag_name_state)):\">\"===data?(tokenizer._parseError(\"expected-closing-tag-but-got-right-bracket\"),tokenizer.setState(data_state)):(tokenizer._parseError(\"expected-closing-tag-but-got-char\",{data:data}),buffer.unget(data),tokenizer.setState(bogus_comment_state)),!0}function tag_name_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-tag-name\"),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)?tokenizer.setState(before_attribute_name_state):isAlpha(data)?tokenizer._currentToken.name+=data.toLowerCase():\">\"===data?tokenizer._emitCurrentToken():\"/\"===data?tokenizer.setState(self_closing_tag_state):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.name+=\"�\"):tokenizer._currentToken.name+=data,buffer.commit(),!0}function before_attribute_name_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"expected-attribute-name-but-got-eof\"),buffer.unget(data),tokenizer.setState(data_state);else{if(isWhitespace(data))return!0;isAlpha(data)?(tokenizer._currentToken.data.push({nodeName:data.toLowerCase(),nodeValue:\"\"}),tokenizer.setState(attribute_name_state)):\">\"===data?tokenizer._emitCurrentToken():\"/\"===data?tokenizer.setState(self_closing_tag_state):\"'\"===data||'\"'===data||\"=\"===data||\"<\"===data?(tokenizer._parseError(\"invalid-character-in-attribute-name\"),tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data.push({nodeName:\"�\",nodeValue:\"\"})):(tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state))}return!0}function attribute_name_state(buffer){var data=buffer.char(),leavingThisState=!0,shouldEmit=!1;if(data===InputStream.EOF?(tokenizer._parseError(\"eof-in-attribute-name\"),buffer.unget(data),tokenizer.setState(data_state),shouldEmit=!0):\"=\"===data?tokenizer.setState(before_attribute_value_state):isAlpha(data)?(tokenizer._currentAttribute().nodeName+=data.toLowerCase(),leavingThisState=!1):\">\"===data?shouldEmit=!0:isWhitespace(data)?tokenizer.setState(after_attribute_name_state):\"/\"===data?tokenizer.setState(self_closing_tag_state):\"'\"===data||'\"'===data?(tokenizer._parseError(\"invalid-character-in-attribute-name\"),tokenizer._currentAttribute().nodeName+=data,leavingThisState=!1):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeName+=\"�\"):(tokenizer._currentAttribute().nodeName+=data,leavingThisState=!1),leavingThisState){for(var attributes=tokenizer._currentToken.data,currentAttribute=attributes[attributes.length-1],i=attributes.length-2;i>=0;i--)if(currentAttribute.nodeName===attributes[i].nodeName){tokenizer._parseError(\"duplicate-attribute\",{name:currentAttribute.nodeName}),currentAttribute.nodeName=null;break}shouldEmit&&tokenizer._emitCurrentToken()}else buffer.commit();return!0}function after_attribute_name_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"expected-end-of-tag-but-got-eof\"),buffer.unget(data),tokenizer.setState(data_state);else{if(isWhitespace(data))return!0;\"=\"===data?tokenizer.setState(before_attribute_value_state):\">\"===data?tokenizer._emitCurrentToken():isAlpha(data)?(tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state)):\"/\"===data?tokenizer.setState(self_closing_tag_state):\"'\"===data||'\"'===data||\"<\"===data?(tokenizer._parseError(\"invalid-character-after-attribute-name\"),tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data.push({nodeName:\"�\",nodeValue:\"\"})):(tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state))}return!0}function before_attribute_value_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"expected-attribute-value-but-got-eof\"),buffer.unget(data),tokenizer.setState(data_state);else{if(isWhitespace(data))return!0;'\"'===data?tokenizer.setState(attribute_value_double_quoted_state):\"&\"===data?(tokenizer.setState(attribute_value_unquoted_state),buffer.unget(data)):\"'\"===data?tokenizer.setState(attribute_value_single_quoted_state):\">\"===data?(tokenizer._parseError(\"expected-attribute-value-but-got-right-bracket\"),tokenizer._emitCurrentToken()):\"=\"===data||\"<\"===data||\"`\"===data?(tokenizer._parseError(\"unexpected-character-in-unquoted-attribute-value\"),tokenizer._currentAttribute().nodeValue+=data,tokenizer.setState(attribute_value_unquoted_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeValue+=\"�\"):(tokenizer._currentAttribute().nodeValue+=data,tokenizer.setState(attribute_value_unquoted_state))}return!0\n}function attribute_value_double_quoted_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"eof-in-attribute-value-double-quote\"),buffer.unget(data),tokenizer.setState(data_state);else if('\"'===data)tokenizer.setState(after_attribute_value_state);else if(\"&\"===data)this._additionalAllowedCharacter='\"',tokenizer.setState(character_reference_in_attribute_value_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeValue+=\"�\";else{var s=buffer.matchUntil('[\\0\"&]');data+=s,tokenizer._currentAttribute().nodeValue+=data}return!0}function attribute_value_single_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-attribute-value-single-quote\"),buffer.unget(data),tokenizer.setState(data_state)):\"'\"===data?tokenizer.setState(after_attribute_value_state):\"&\"===data?(this._additionalAllowedCharacter=\"'\",tokenizer.setState(character_reference_in_attribute_value_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeValue+=\"�\"):tokenizer._currentAttribute().nodeValue+=data+buffer.matchUntil(\"\\0|['&]\"),!0}function attribute_value_unquoted_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"eof-after-attribute-value\"),buffer.unget(data),tokenizer.setState(data_state);else if(isWhitespace(data))tokenizer.setState(before_attribute_name_state);else if(\"&\"===data)this._additionalAllowedCharacter=\">\",tokenizer.setState(character_reference_in_attribute_value_state);else if(\">\"===data)tokenizer._emitCurrentToken();else if('\"'===data||\"'\"===data||\"=\"===data||\"`\"===data||\"<\"===data)tokenizer._parseError(\"unexpected-character-in-unquoted-attribute-value\"),tokenizer._currentAttribute().nodeValue+=data,buffer.commit();else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeValue+=\"�\";else{var o=buffer.matchUntil(\"\\0|[\t\\n\u000b\\f \\r&<>\\\"'=`]\");o===InputStream.EOF&&(tokenizer._parseError(\"eof-in-attribute-value-no-quotes\"),tokenizer._emitCurrentToken()),buffer.commit(),tokenizer._currentAttribute().nodeValue+=data+o}return!0}function character_reference_in_attribute_value_state(buffer){var character=EntityParser.consumeEntity(buffer,tokenizer,this._additionalAllowedCharacter);return this._currentAttribute().nodeValue+=character||\"&\",'\"'===this._additionalAllowedCharacter?tokenizer.setState(attribute_value_double_quoted_state):\"'\"===this._additionalAllowedCharacter?tokenizer.setState(attribute_value_single_quoted_state):\">\"===this._additionalAllowedCharacter&&tokenizer.setState(attribute_value_unquoted_state),!0}function after_attribute_value_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-after-attribute-value\"),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)?tokenizer.setState(before_attribute_name_state):\">\"===data?(tokenizer.setState(data_state),tokenizer._emitCurrentToken()):\"/\"===data?tokenizer.setState(self_closing_tag_state):(tokenizer._parseError(\"unexpected-character-after-attribute-value\"),buffer.unget(data),tokenizer.setState(before_attribute_name_state)),!0}function self_closing_tag_state(buffer){var c=buffer.char();return c===InputStream.EOF?(tokenizer._parseError(\"unexpected-eof-after-solidus-in-tag\"),buffer.unget(c),tokenizer.setState(data_state)):\">\"===c?(tokenizer._currentToken.selfClosing=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(tokenizer._parseError(\"unexpected-character-after-solidus-in-tag\"),buffer.unget(c),tokenizer.setState(before_attribute_name_state)),!0}function bogus_comment_state(buffer){var data=buffer.matchUntil(\">\");return data=data.replace(/\\u0000/g,\"�\"),buffer.char(),tokenizer._emitToken({type:\"Comment\",data:data}),tokenizer.setState(data_state),!0}function markup_declaration_open_state(buffer){var chars=buffer.shift(2);if(\"--\"===chars)tokenizer._currentToken={type:\"Comment\",data:\"\"},tokenizer.setState(comment_start_state);else{var newchars=buffer.shift(5);if(newchars===InputStream.EOF||chars===InputStream.EOF)return tokenizer._parseError(\"expected-dashes-or-doctype\"),tokenizer.setState(bogus_comment_state),buffer.unget(chars),!0;chars+=newchars,\"DOCTYPE\"===chars.toUpperCase()?(tokenizer._currentToken={type:\"Doctype\",name:\"\",publicId:null,systemId:null,forceQuirks:!1},tokenizer.setState(doctype_state)):tokenizer._tokenHandler.isCdataSectionAllowed()&&\"[CDATA[\"===chars?tokenizer.setState(cdata_section_state):(tokenizer._parseError(\"expected-dashes-or-doctype\"),buffer.unget(chars),tokenizer.setState(bogus_comment_state))}return!0}function cdata_section_state(buffer){var data=buffer.matchUntil(\"]]>\");return buffer.shift(3),data&&tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(data_state),!0}function comment_start_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?tokenizer.setState(comment_start_dash_state):\">\"===data?(tokenizer._parseError(\"incorrect-comment\"),tokenizer._emitToken(tokenizer._currentToken),tokenizer.setState(data_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"�\"):(tokenizer._currentToken.data+=data,tokenizer.setState(comment_state)),!0}function comment_start_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?tokenizer.setState(comment_end_state):\">\"===data?(tokenizer._parseError(\"incorrect-comment\"),tokenizer._emitToken(tokenizer._currentToken),tokenizer.setState(data_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"�\"):(tokenizer._currentToken.data+=\"-\"+data,tokenizer.setState(comment_state)),!0}function comment_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?tokenizer.setState(comment_end_dash_state):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"�\"):(tokenizer._currentToken.data+=data,buffer.commit()),!0}function comment_end_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment-end-dash\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?tokenizer.setState(comment_end_state):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"-�\",tokenizer.setState(comment_state)):(tokenizer._currentToken.data+=\"-\"+data+buffer.matchUntil(\"\\0|-\"),buffer.char()),!0}function comment_end_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment-double-dash\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\">\"===data?(tokenizer._emitToken(tokenizer._currentToken),tokenizer.setState(data_state)):\"!\"===data?(tokenizer._parseError(\"unexpected-bang-after-double-dash-in-comment\"),tokenizer.setState(comment_end_bang_state)):\"-\"===data?(tokenizer._parseError(\"unexpected-dash-after-double-dash-in-comment\"),tokenizer._currentToken.data+=data):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"--�\",tokenizer.setState(comment_state)):(tokenizer._parseError(\"unexpected-char-in-comment\"),tokenizer._currentToken.data+=\"--\"+data,tokenizer.setState(comment_state)),!0}function comment_end_bang_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment-end-bang-state\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\">\"===data?(tokenizer._emitToken(tokenizer._currentToken),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._currentToken.data+=\"--!\",tokenizer.setState(comment_end_dash_state)):(tokenizer._currentToken.data+=\"--!\"+data,tokenizer.setState(comment_state)),!0}function doctype_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"expected-doctype-name-but-got-eof\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)?tokenizer.setState(before_doctype_name_state):(tokenizer._parseError(\"need-space-after-doctype\"),buffer.unget(data),tokenizer.setState(before_doctype_name_state)),!0}function before_doctype_name_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"expected-doctype-name-but-got-eof\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)||(\">\"===data?(tokenizer._parseError(\"expected-doctype-name-but-got-right-bracket\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(isAlpha(data)&&(data=data.toLowerCase()),tokenizer._currentToken.name=data,tokenizer.setState(doctype_name_state))),!0}function doctype_name_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer._parseError(\"eof-in-doctype-name\"),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)?tokenizer.setState(after_doctype_name_state):\">\"===data?(tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(isAlpha(data)&&(data=data.toLowerCase()),tokenizer._currentToken.name+=data,buffer.commit()),!0}function after_doctype_name_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer._parseError(\"eof-in-doctype\"),tokenizer.setState(data_state),tokenizer._emitCurrentToken();else if(isWhitespace(data));else if(\">\"===data)tokenizer.setState(data_state),tokenizer._emitCurrentToken();else{if([\"p\",\"P\"].indexOf(data)>-1){var expected=[[\"u\",\"U\"],[\"b\",\"B\"],[\"l\",\"L\"],[\"i\",\"I\"],[\"c\",\"C\"]],matched=expected.every(function(expected){return data=buffer.char(),expected.indexOf(data)>-1});if(matched)return tokenizer.setState(after_doctype_public_keyword_state),!0}else if([\"s\",\"S\"].indexOf(data)>-1){var expected=[[\"y\",\"Y\"],[\"s\",\"S\"],[\"t\",\"T\"],[\"e\",\"E\"],[\"m\",\"M\"]],matched=expected.every(function(expected){return data=buffer.char(),expected.indexOf(data)>-1});if(matched)return tokenizer.setState(after_doctype_system_keyword_state),!0}buffer.unget(data),tokenizer._currentToken.forceQuirks=!0,data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(tokenizer._parseError(\"expected-space-or-right-bracket-in-doctype\",{data:data}),tokenizer.setState(bogus_doctype_state))}return!0}function after_doctype_public_keyword_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)?tokenizer.setState(before_doctype_public_identifier_state):\"'\"===data||'\"'===data?(tokenizer._parseError(\"unexpected-char-in-doctype\"),buffer.unget(data),tokenizer.setState(before_doctype_public_identifier_state)):(buffer.unget(data),tokenizer.setState(before_doctype_public_identifier_state)),!0}function before_doctype_public_identifier_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)||('\"'===data?(tokenizer._currentToken.publicId=\"\",tokenizer.setState(doctype_public_identifier_double_quoted_state)):\"'\"===data?(tokenizer._currentToken.publicId=\"\",tokenizer.setState(doctype_public_identifier_single_quoted_state)):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(bogus_doctype_state))),!0}function doctype_public_identifier_double_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):'\"'===data?tokenizer.setState(after_doctype_public_identifier_state):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):tokenizer._currentToken.publicId+=data,!0}function doctype_public_identifier_single_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):\"'\"===data?tokenizer.setState(after_doctype_public_identifier_state):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):tokenizer._currentToken.publicId+=data,!0}function after_doctype_public_identifier_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)?tokenizer.setState(between_doctype_public_and_system_identifiers_state):\">\"===data?(tokenizer.setState(data_state),tokenizer._emitCurrentToken()):'\"'===data?(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_double_quoted_state)):\"'\"===data?(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_single_quoted_state)):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(bogus_doctype_state)),!0}function between_doctype_public_and_system_identifiers_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)||(\">\"===data?(tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):'\"'===data?(tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_double_quoted_state)):\"'\"===data?(tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_single_quoted_state)):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(bogus_doctype_state))),!0}function after_doctype_system_keyword_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)?tokenizer.setState(before_doctype_system_identifier_state):\"'\"===data||'\"'===data?(tokenizer._parseError(\"unexpected-char-in-doctype\"),buffer.unget(data),tokenizer.setState(before_doctype_system_identifier_state)):(buffer.unget(data),tokenizer.setState(before_doctype_system_identifier_state)),!0}function before_doctype_system_identifier_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)||('\"'===data?(tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_double_quoted_state)):\"'\"===data?(tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_single_quoted_state)):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(bogus_doctype_state))),!0}function doctype_system_identifier_double_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):'\"'===data?tokenizer.setState(after_doctype_system_identifier_state):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):tokenizer._currentToken.systemId+=data,!0}function doctype_system_identifier_single_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):\"'\"===data?tokenizer.setState(after_doctype_system_identifier_state):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):tokenizer._currentToken.systemId+=data,!0}function after_doctype_system_identifier_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)||(\">\"===data?(tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer.setState(bogus_doctype_state))),!0}function bogus_doctype_state(buffer){var data=buffer.char();return data===InputStream.EOF?(buffer.unget(data),tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):\">\"===data&&(tokenizer._emitCurrentToken(),tokenizer.setState(data_state)),!0}Tokenizer.DATA=data_state,Tokenizer.RCDATA=rcdata_state,Tokenizer.RAWTEXT=rawtext_state,Tokenizer.SCRIPT_DATA=script_data_state,Tokenizer.PLAINTEXT=plaintext_state,this._state=Tokenizer.DATA,this._inputStream.append(source),this._tokenHandler.startTokenization(this),this._inputStream.eof=!0;for(var tokenizer=this;this._state.call(this,this._inputStream););},Object.defineProperty(Tokenizer.prototype,\"lineNumber\",{get:function(){return this._inputStream.location().line}}),Object.defineProperty(Tokenizer.prototype,\"columnNumber\",{get:function(){return this._inputStream.location().column}}),exports.Tokenizer=Tokenizer},{\"./EntityParser\":2,\"./InputStream\":3}],6:[function(_dereq_,module,exports){function isWhitespace(ch){return\" \"===ch||\"\\n\"===ch||\"\t\"===ch||\"\\r\"===ch||\"\\f\"===ch}function isWhitespaceOrReplacementCharacter(ch){return isWhitespace(ch)||\"�\"===ch}function isAllWhitespace(characters){for(var i=0;characters.length>i;i++){var ch=characters[i];if(!isWhitespace(ch))return!1}return!0}function isAllWhitespaceOrReplacementCharacters(characters){for(var i=0;characters.length>i;i++){var ch=characters[i];if(!isWhitespaceOrReplacementCharacter(ch))return!1}return!0}function getAttribute(node,name){for(var i=0;node.attributes.length>i;i++){var attribute=node.attributes[i];if(attribute.nodeName===name)return attribute}return null}function CharacterBuffer(characters){this.characters=characters,this.current=0,this.end=this.characters.length}function TreeBuilder(){this.tokenizer=null,this.errorHandler=null,this.scriptingEnabled=!1,this.document=null,this.head=null,this.form=null,this.openElements=new ElementStack,this.activeFormattingElements=[],this.insertionMode=null,this.insertionModeName=\"\",this.originalInsertionMode=\"\",this.inQuirksMode=!1,this.compatMode=\"no quirks\",this.framesetOk=!0,this.redirectAttachToFosterParent=!1,this.selfClosingFlagAcknowledged=!1,this.context=\"\",this.pendingTableCharacters=[],this.shouldSkipLeadingNewline=!1;var tree=this,modes=this.insertionModes={};modes.base={end_tag_handlers:{\"-default\":\"endTagOther\"},start_tag_handlers:{\"-default\":\"startTagOther\"},processEOF:function(){tree.generateImpliedEndTags(),tree.openElements.length>2?tree.parseError(\"expected-closing-tag-but-got-eof\"):2==tree.openElements.length&&\"body\"!=tree.openElements.item(1).localName?tree.parseError(\"expected-closing-tag-but-got-eof\"):tree.context&&tree.openElements.length>1},processComment:function(data){tree.insertComment(data,tree.currentStackItem().node)},processDoctype:function(){tree.parseError(\"unexpected-doctype\")},processStartTag:function(name,attributes,selfClosing){if(this[this.start_tag_handlers[name]])this[this.start_tag_handlers[name]](name,attributes,selfClosing);else{if(!this[this.start_tag_handlers[\"-default\"]])throw Error(\"No handler found for \"+name);this[this.start_tag_handlers[\"-default\"]](name,attributes,selfClosing)}},processEndTag:function(name){if(this[this.end_tag_handlers[name]])this[this.end_tag_handlers[name]](name);else{if(!this[this.end_tag_handlers[\"-default\"]])throw Error(\"No handler found for \"+name);this[this.end_tag_handlers[\"-default\"]](name)}},startTagHtml:function(name,attributes){modes.inBody.startTagHtml(name,attributes)}},modes.initial=Object.create(modes.base),modes.initial.processEOF=function(){tree.parseError(\"expected-doctype-but-got-eof\"),this.anythingElse(),tree.insertionMode.processEOF()},modes.initial.processComment=function(data){tree.insertComment(data,tree.document)},modes.initial.processDoctype=function(name,publicId,systemId,forceQuirks){function publicIdStartsWith(string){return 0===publicId.toLowerCase().indexOf(string)}tree.insertDoctype(name||\"\",publicId||\"\",systemId||\"\"),forceQuirks||\"html\"!=name||null!=publicId&&([\"+//silmaril//dtd html pro v0r11 19970101//\",\"-//advasoft ltd//dtd html 3.0 aswedit + extensions//\",\"-//as//dtd html 3.0 aswedit + extensions//\",\"-//ietf//dtd html 2.0 level 1//\",\"-//ietf//dtd html 2.0 level 2//\",\"-//ietf//dtd html 2.0 strict level 1//\",\"-//ietf//dtd html 2.0 strict level 2//\",\"-//ietf//dtd html 2.0 strict//\",\"-//ietf//dtd html 2.0//\",\"-//ietf//dtd html 2.1e//\",\"-//ietf//dtd html 3.0//\",\"-//ietf//dtd html 3.0//\",\"-//ietf//dtd html 3.2 final//\",\"-//ietf//dtd html 3.2//\",\"-//ietf//dtd html 3//\",\"-//ietf//dtd html level 0//\",\"-//ietf//dtd html level 0//\",\"-//ietf//dtd html level 1//\",\"-//ietf//dtd html level 1//\",\"-//ietf//dtd html level 2//\",\"-//ietf//dtd html level 2//\",\"-//ietf//dtd html level 3//\",\"-//ietf//dtd html level 3//\",\"-//ietf//dtd html strict level 0//\",\"-//ietf//dtd html strict level 0//\",\"-//ietf//dtd html strict level 1//\",\"-//ietf//dtd html strict level 1//\",\"-//ietf//dtd html strict level 2//\",\"-//ietf//dtd html strict level 2//\",\"-//ietf//dtd html strict level 3//\",\"-//ietf//dtd html strict level 3//\",\"-//ietf//dtd html strict//\",\"-//ietf//dtd html strict//\",\"-//ietf//dtd html strict//\",\"-//ietf//dtd html//\",\"-//ietf//dtd html//\",\"-//ietf//dtd html//\",\"-//metrius//dtd metrius presentational//\",\"-//microsoft//dtd internet explorer 2.0 html strict//\",\"-//microsoft//dtd internet explorer 2.0 html//\",\"-//microsoft//dtd internet explorer 2.0 tables//\",\"-//microsoft//dtd internet explorer 3.0 html strict//\",\"-//microsoft//dtd internet explorer 3.0 html//\",\"-//microsoft//dtd internet explorer 3.0 tables//\",\"-//netscape comm. corp.//dtd html//\",\"-//netscape comm. corp.//dtd strict html//\",\"-//o'reilly and associates//dtd html 2.0//\",\"-//o'reilly and associates//dtd html extended 1.0//\",\"-//spyglass//dtd html 2.0 extended//\",\"-//sq//dtd html 2.0 hotmetal + extensions//\",\"-//sun microsystems corp.//dtd hotjava html//\",\"-//sun microsystems corp.//dtd hotjava strict html//\",\"-//w3c//dtd html 3 1995-03-24//\",\"-//w3c//dtd html 3.2 draft//\",\"-//w3c//dtd html 3.2 final//\",\"-//w3c//dtd html 3.2//\",\"-//w3c//dtd html 3.2s draft//\",\"-//w3c//dtd html 4.0 frameset//\",\"-//w3c//dtd html 4.0 transitional//\",\"-//w3c//dtd html experimental 19960712//\",\"-//w3c//dtd html experimental 970421//\",\"-//w3c//dtd w3 html//\",\"-//w3o//dtd w3 html 3.0//\",\"-//webtechs//dtd mozilla html 2.0//\",\"-//webtechs//dtd mozilla html//\",\"html\"].some(publicIdStartsWith)||[\"-//w3o//dtd w3 html strict 3.0//en//\",\"-/w3c/dtd html 4.0 transitional/en\",\"html\"].indexOf(publicId.toLowerCase())>-1||null==systemId&&[\"-//w3c//dtd html 4.01 transitional//\",\"-//w3c//dtd html 4.01 frameset//\"].some(publicIdStartsWith))||null!=systemId&&\"http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd\"==systemId.toLowerCase()?(tree.compatMode=\"quirks\",tree.parseError(\"quirky-doctype\")):null!=publicId&&([\"-//w3c//dtd xhtml 1.0 transitional//\",\"-//w3c//dtd xhtml 1.0 frameset//\"].some(publicIdStartsWith)||null!=systemId&&[\"-//w3c//dtd html 4.01 transitional//\",\"-//w3c//dtd html 4.01 frameset//\"].indexOf(publicId.toLowerCase())>-1)?(tree.compatMode=\"limited quirks\",tree.parseError(\"almost-standards-doctype\")):\"-//W3C//DTD HTML 4.0//EN\"==publicId&&(null==systemId||\"http://www.w3.org/TR/REC-html40/strict.dtd\"==systemId)||\"-//W3C//DTD HTML 4.01//EN\"==publicId&&(null==systemId||\"http://www.w3.org/TR/html4/strict.dtd\"==systemId)||\"-//W3C//DTD XHTML 1.0 Strict//EN\"==publicId&&\"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd\"==systemId||\"-//W3C//DTD XHTML 1.1//EN\"==publicId&&\"http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd\"==systemId||(null!=systemId&&\"about:legacy-compat\"!=systemId||null!=publicId)&&tree.parseError(\"unknown-doctype\"),tree.setInsertionMode(\"beforeHTML\")},modes.initial.processCharacters=function(buffer){buffer.skipLeadingWhitespace(),buffer.length&&(tree.parseError(\"expected-doctype-but-got-chars\"),this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.initial.processStartTag=function(name,attributes,selfClosing){tree.parseError(\"expected-doctype-but-got-start-tag\",{name:name}),this.anythingElse(),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.initial.processEndTag=function(name){tree.parseError(\"expected-doctype-but-got-end-tag\",{name:name}),this.anythingElse(),tree.insertionMode.processEndTag(name)},modes.initial.anythingElse=function(){tree.compatMode=\"quirks\",tree.setInsertionMode(\"beforeHTML\")},modes.beforeHTML=Object.create(modes.base),modes.beforeHTML.start_tag_handlers={html:\"startTagHtml\",\"-default\":\"startTagOther\"},modes.beforeHTML.processEOF=function(){this.anythingElse(),tree.insertionMode.processEOF()},modes.beforeHTML.processComment=function(data){tree.insertComment(data,tree.document)},modes.beforeHTML.processCharacters=function(buffer){buffer.skipLeadingWhitespace(),buffer.length&&(this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.beforeHTML.startTagHtml=function(name,attributes){tree.insertHtmlElement(attributes),tree.setInsertionMode(\"beforeHead\")},modes.beforeHTML.startTagOther=function(name,attributes,selfClosing){this.anythingElse(),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.beforeHTML.processEndTag=function(name){this.anythingElse(),tree.insertionMode.processEndTag(name)},modes.beforeHTML.anythingElse=function(){tree.insertHtmlElement(),tree.setInsertionMode(\"beforeHead\")},modes.afterAfterBody=Object.create(modes.base),modes.afterAfterBody.start_tag_handlers={html:\"startTagHtml\",\"-default\":\"startTagOther\"},modes.afterAfterBody.processComment=function(data){tree.insertComment(data,tree.document)},modes.afterAfterBody.processDoctype=function(data){modes.inBody.processDoctype(data)},modes.afterAfterBody.startTagHtml=function(data,attributes){modes.inBody.startTagHtml(data,attributes)},modes.afterAfterBody.startTagOther=function(name,attributes,selfClosing){tree.parseError(\"unexpected-start-tag\",{name:name}),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.afterAfterBody.endTagOther=function(name){tree.parseError(\"unexpected-end-tag\",{name:name}),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processEndTag(name)},modes.afterAfterBody.processCharacters=function(data){return isAllWhitespace(data.characters)?(modes.inBody.processCharacters(data),void 0):(tree.parseError(\"unexpected-char-after-body\"),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processCharacters(data))},modes.afterBody=Object.create(modes.base),modes.afterBody.end_tag_handlers={html:\"endTagHtml\",\"-default\":\"endTagOther\"},modes.afterBody.processComment=function(data){tree.insertComment(data,tree.openElements.rootNode)},modes.afterBody.processCharacters=function(data){return isAllWhitespace(data.characters)?(modes.inBody.processCharacters(data),void 0):(tree.parseError(\"unexpected-char-after-body\"),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processCharacters(data))},modes.afterBody.processStartTag=function(name,attributes,selfClosing){tree.parseError(\"unexpected-start-tag-after-body\",{name:name}),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.afterBody.endTagHtml=function(){tree.context?tree.parseError(\"end-html-in-innerhtml\"):tree.setInsertionMode(\"afterAfterBody\")},modes.afterBody.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-after-body\",{name:name}),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processEndTag(name)},modes.afterFrameset=Object.create(modes.base),modes.afterFrameset.start_tag_handlers={html:\"startTagHtml\",noframes:\"startTagNoframes\",\"-default\":\"startTagOther\"},modes.afterFrameset.end_tag_handlers={html:\"endTagHtml\",\"-default\":\"endTagOther\"},modes.afterFrameset.processCharacters=function(buffer){for(var characters=buffer.takeRemaining(),whitespace=\"\",i=0;characters.length>i;i++){var ch=characters[i];isWhitespace(ch)&&(whitespace+=ch)}whitespace&&tree.insertText(whitespace),whitespace.length<characters.length&&tree.parseError(\"expected-eof-but-got-char\")},modes.afterFrameset.startTagNoframes=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.afterFrameset.startTagOther=function(name){tree.parseError(\"unexpected-start-tag-after-frameset\",{name:name})},modes.afterFrameset.endTagHtml=function(){tree.setInsertionMode(\"afterAfterFrameset\")},modes.afterFrameset.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-after-frameset\",{name:name})},modes.beforeHead=Object.create(modes.base),modes.beforeHead.start_tag_handlers={html:\"startTagHtml\",head:\"startTagHead\",\"-default\":\"startTagOther\"},modes.beforeHead.end_tag_handlers={html:\"endTagImplyHead\",head:\"endTagImplyHead\",body:\"endTagImplyHead\",br:\"endTagImplyHead\",\"-default\":\"endTagOther\"},modes.beforeHead.processEOF=function(){this.startTagHead(\"head\",[]),tree.insertionMode.processEOF()},modes.beforeHead.processCharacters=function(buffer){buffer.skipLeadingWhitespace(),buffer.length&&(this.startTagHead(\"head\",[]),tree.insertionMode.processCharacters(buffer))},modes.beforeHead.startTagHead=function(name,attributes){tree.insertHeadElement(attributes),tree.setInsertionMode(\"inHead\")},modes.beforeHead.startTagOther=function(name,attributes,selfClosing){this.startTagHead(\"head\",[]),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.beforeHead.endTagImplyHead=function(name){this.startTagHead(\"head\",[]),tree.insertionMode.processEndTag(name)},modes.beforeHead.endTagOther=function(name){tree.parseError(\"end-tag-after-implied-root\",{name:name})},modes.inHead=Object.create(modes.base),modes.inHead.start_tag_handlers={html:\"startTagHtml\",head:\"startTagHead\",title:\"startTagTitle\",script:\"startTagScript\",style:\"startTagNoFramesStyle\",noscript:\"startTagNoScript\",noframes:\"startTagNoFramesStyle\",base:\"startTagBaseBasefontBgsoundLink\",basefont:\"startTagBaseBasefontBgsoundLink\",bgsound:\"startTagBaseBasefontBgsoundLink\",link:\"startTagBaseBasefontBgsoundLink\",meta:\"startTagMeta\",\"-default\":\"startTagOther\"},modes.inHead.end_tag_handlers={head:\"endTagHead\",html:\"endTagHtmlBodyBr\",body:\"endTagHtmlBodyBr\",br:\"endTagHtmlBodyBr\",\"-default\":\"endTagOther\"},modes.inHead.processEOF=function(){var name=tree.currentStackItem().localName;\n-1!=[\"title\",\"style\",\"script\"].indexOf(name)&&(tree.parseError(\"expected-named-closing-tag-but-got-eof\",{name:name}),tree.popElement()),this.anythingElse(),tree.insertionMode.processEOF()},modes.inHead.processCharacters=function(buffer){var leadingWhitespace=buffer.takeLeadingWhitespace();leadingWhitespace&&tree.insertText(leadingWhitespace),buffer.length&&(this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.inHead.startTagHtml=function(name,attributes){modes.inBody.processStartTag(name,attributes)},modes.inHead.startTagHead=function(){tree.parseError(\"two-heads-are-not-better-than-one\")},modes.inHead.startTagTitle=function(name,attributes){tree.processGenericRCDATAStartTag(name,attributes)},modes.inHead.startTagNoScript=function(name,attributes){return tree.scriptingEnabled?tree.processGenericRawTextStartTag(name,attributes):(tree.insertElement(name,attributes),tree.setInsertionMode(\"inHeadNoscript\"),void 0)},modes.inHead.startTagNoFramesStyle=function(name,attributes){tree.processGenericRawTextStartTag(name,attributes)},modes.inHead.startTagScript=function(name,attributes){tree.insertElement(name,attributes),tree.tokenizer.setState(Tokenizer.SCRIPT_DATA),tree.originalInsertionMode=tree.insertionModeName,tree.setInsertionMode(\"text\")},modes.inHead.startTagBaseBasefontBgsoundLink=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inHead.startTagMeta=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inHead.startTagOther=function(name,attributes,selfClosing){this.anythingElse(),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.inHead.endTagHead=function(){\"head\"==tree.openElements.item(tree.openElements.length-1).localName?tree.openElements.pop():tree.parseError(\"unexpected-end-tag\",{name:\"head\"}),tree.setInsertionMode(\"afterHead\")},modes.inHead.endTagHtmlBodyBr=function(name){this.anythingElse(),tree.insertionMode.processEndTag(name)},modes.inHead.endTagOther=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inHead.anythingElse=function(){this.endTagHead(\"head\")},modes.afterHead=Object.create(modes.base),modes.afterHead.start_tag_handlers={html:\"startTagHtml\",head:\"startTagHead\",body:\"startTagBody\",frameset:\"startTagFrameset\",base:\"startTagFromHead\",link:\"startTagFromHead\",meta:\"startTagFromHead\",script:\"startTagFromHead\",style:\"startTagFromHead\",title:\"startTagFromHead\",\"-default\":\"startTagOther\"},modes.afterHead.end_tag_handlers={body:\"endTagBodyHtmlBr\",html:\"endTagBodyHtmlBr\",br:\"endTagBodyHtmlBr\",\"-default\":\"endTagOther\"},modes.afterHead.processEOF=function(){this.anythingElse(),tree.insertionMode.processEOF()},modes.afterHead.processCharacters=function(buffer){var leadingWhitespace=buffer.takeLeadingWhitespace();leadingWhitespace&&tree.insertText(leadingWhitespace),buffer.length&&(this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.afterHead.startTagHtml=function(name,attributes){modes.inBody.processStartTag(name,attributes)},modes.afterHead.startTagBody=function(name,attributes){tree.framesetOk=!1,tree.insertBodyElement(attributes),tree.setInsertionMode(\"inBody\")},modes.afterHead.startTagFrameset=function(name,attributes){tree.insertElement(name,attributes),tree.setInsertionMode(\"inFrameset\")},modes.afterHead.startTagFromHead=function(name,attributes,selfClosing){tree.parseError(\"unexpected-start-tag-out-of-my-head\",{name:name}),tree.openElements.push(tree.head),modes.inHead.processStartTag(name,attributes,selfClosing),tree.openElements.remove(tree.head)},modes.afterHead.startTagHead=function(name){tree.parseError(\"unexpected-start-tag\",{name:name})},modes.afterHead.startTagOther=function(name,attributes,selfClosing){this.anythingElse(),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.afterHead.endTagBodyHtmlBr=function(name){this.anythingElse(),tree.insertionMode.processEndTag(name)},modes.afterHead.endTagOther=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.afterHead.anythingElse=function(){tree.insertBodyElement([]),tree.setInsertionMode(\"inBody\"),tree.framesetOk=!0},modes.inBody=Object.create(modes.base),modes.inBody.start_tag_handlers={html:\"startTagHtml\",head:\"startTagMisplaced\",base:\"startTagProcessInHead\",basefont:\"startTagProcessInHead\",bgsound:\"startTagProcessInHead\",link:\"startTagProcessInHead\",meta:\"startTagProcessInHead\",noframes:\"startTagProcessInHead\",script:\"startTagProcessInHead\",style:\"startTagProcessInHead\",title:\"startTagProcessInHead\",body:\"startTagBody\",form:\"startTagForm\",plaintext:\"startTagPlaintext\",a:\"startTagA\",button:\"startTagButton\",xmp:\"startTagXmp\",table:\"startTagTable\",hr:\"startTagHr\",image:\"startTagImage\",input:\"startTagInput\",textarea:\"startTagTextarea\",select:\"startTagSelect\",isindex:\"startTagIsindex\",applet:\"startTagAppletMarqueeObject\",marquee:\"startTagAppletMarqueeObject\",object:\"startTagAppletMarqueeObject\",li:\"startTagListItem\",dd:\"startTagListItem\",dt:\"startTagListItem\",address:\"startTagCloseP\",article:\"startTagCloseP\",aside:\"startTagCloseP\",blockquote:\"startTagCloseP\",center:\"startTagCloseP\",details:\"startTagCloseP\",dir:\"startTagCloseP\",div:\"startTagCloseP\",dl:\"startTagCloseP\",fieldset:\"startTagCloseP\",figcaption:\"startTagCloseP\",figure:\"startTagCloseP\",footer:\"startTagCloseP\",header:\"startTagCloseP\",hgroup:\"startTagCloseP\",main:\"startTagCloseP\",menu:\"startTagCloseP\",nav:\"startTagCloseP\",ol:\"startTagCloseP\",p:\"startTagCloseP\",section:\"startTagCloseP\",summary:\"startTagCloseP\",ul:\"startTagCloseP\",listing:\"startTagPreListing\",pre:\"startTagPreListing\",b:\"startTagFormatting\",big:\"startTagFormatting\",code:\"startTagFormatting\",em:\"startTagFormatting\",font:\"startTagFormatting\",i:\"startTagFormatting\",s:\"startTagFormatting\",small:\"startTagFormatting\",strike:\"startTagFormatting\",strong:\"startTagFormatting\",tt:\"startTagFormatting\",u:\"startTagFormatting\",nobr:\"startTagNobr\",area:\"startTagVoidFormatting\",br:\"startTagVoidFormatting\",embed:\"startTagVoidFormatting\",img:\"startTagVoidFormatting\",keygen:\"startTagVoidFormatting\",wbr:\"startTagVoidFormatting\",param:\"startTagParamSourceTrack\",source:\"startTagParamSourceTrack\",track:\"startTagParamSourceTrack\",iframe:\"startTagIFrame\",noembed:\"startTagRawText\",noscript:\"startTagRawText\",h1:\"startTagHeading\",h2:\"startTagHeading\",h3:\"startTagHeading\",h4:\"startTagHeading\",h5:\"startTagHeading\",h6:\"startTagHeading\",caption:\"startTagMisplaced\",col:\"startTagMisplaced\",colgroup:\"startTagMisplaced\",frame:\"startTagMisplaced\",frameset:\"startTagFrameset\",tbody:\"startTagMisplaced\",td:\"startTagMisplaced\",tfoot:\"startTagMisplaced\",th:\"startTagMisplaced\",thead:\"startTagMisplaced\",tr:\"startTagMisplaced\",option:\"startTagOptionOptgroup\",optgroup:\"startTagOptionOptgroup\",math:\"startTagMath\",svg:\"startTagSVG\",rt:\"startTagRpRt\",rp:\"startTagRpRt\",\"-default\":\"startTagOther\"},modes.inBody.end_tag_handlers={p:\"endTagP\",body:\"endTagBody\",html:\"endTagHtml\",address:\"endTagBlock\",article:\"endTagBlock\",aside:\"endTagBlock\",blockquote:\"endTagBlock\",button:\"endTagBlock\",center:\"endTagBlock\",details:\"endTagBlock\",dir:\"endTagBlock\",div:\"endTagBlock\",dl:\"endTagBlock\",fieldset:\"endTagBlock\",figcaption:\"endTagBlock\",figure:\"endTagBlock\",footer:\"endTagBlock\",header:\"endTagBlock\",hgroup:\"endTagBlock\",listing:\"endTagBlock\",main:\"endTagBlock\",menu:\"endTagBlock\",nav:\"endTagBlock\",ol:\"endTagBlock\",pre:\"endTagBlock\",section:\"endTagBlock\",summary:\"endTagBlock\",ul:\"endTagBlock\",form:\"endTagForm\",applet:\"endTagAppletMarqueeObject\",marquee:\"endTagAppletMarqueeObject\",object:\"endTagAppletMarqueeObject\",dd:\"endTagListItem\",dt:\"endTagListItem\",li:\"endTagListItem\",h1:\"endTagHeading\",h2:\"endTagHeading\",h3:\"endTagHeading\",h4:\"endTagHeading\",h5:\"endTagHeading\",h6:\"endTagHeading\",a:\"endTagFormatting\",b:\"endTagFormatting\",big:\"endTagFormatting\",code:\"endTagFormatting\",em:\"endTagFormatting\",font:\"endTagFormatting\",i:\"endTagFormatting\",nobr:\"endTagFormatting\",s:\"endTagFormatting\",small:\"endTagFormatting\",strike:\"endTagFormatting\",strong:\"endTagFormatting\",tt:\"endTagFormatting\",u:\"endTagFormatting\",br:\"endTagBr\",\"-default\":\"endTagOther\"},modes.inBody.processCharacters=function(buffer){tree.shouldSkipLeadingNewline&&(tree.shouldSkipLeadingNewline=!1,buffer.skipAtMostOneLeadingNewline()),tree.reconstructActiveFormattingElements();var characters=buffer.takeRemaining();characters=characters.replace(/\\u0000/g,function(){return tree.parseError(\"invalid-codepoint\"),\"\"}),characters&&(tree.insertText(characters),tree.framesetOk&&!isAllWhitespaceOrReplacementCharacters(characters)&&(tree.framesetOk=!1))},modes.inBody.startTagHtml=function(name,attributes){tree.parseError(\"non-html-root\"),tree.addAttributesToElement(tree.openElements.rootNode,attributes)},modes.inBody.startTagProcessInHead=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.inBody.startTagBody=function(name,attributes){tree.parseError(\"unexpected-start-tag\",{name:\"body\"}),1==tree.openElements.length||\"body\"!=tree.openElements.item(1).localName?assert.ok(tree.context):(tree.framesetOk=!1,tree.addAttributesToElement(tree.openElements.bodyElement,attributes))},modes.inBody.startTagFrameset=function(name,attributes){if(tree.parseError(\"unexpected-start-tag\",{name:\"frameset\"}),1==tree.openElements.length||\"body\"!=tree.openElements.item(1).localName)assert.ok(tree.context);else if(tree.framesetOk){for(tree.detachFromParent(tree.openElements.bodyElement);tree.openElements.length>1;)tree.openElements.pop();tree.insertElement(name,attributes),tree.setInsertionMode(\"inFrameset\")}},modes.inBody.startTagCloseP=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes)},modes.inBody.startTagPreListing=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes),tree.framesetOk=!1,tree.shouldSkipLeadingNewline=!0},modes.inBody.startTagForm=function(name,attributes){tree.form?tree.parseError(\"unexpected-start-tag\",{name:name}):(tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes),tree.form=tree.currentStackItem())},modes.inBody.startTagRpRt=function(name,attributes){tree.openElements.inScope(\"ruby\")&&(tree.generateImpliedEndTags(),\"ruby\"!=tree.currentStackItem().localName&&tree.parseError(\"unexpected-start-tag\",{name:name})),tree.insertElement(name,attributes)},modes.inBody.startTagListItem=function(name,attributes){for(var stopNames={li:[\"li\"],dd:[\"dd\",\"dt\"],dt:[\"dd\",\"dt\"]},stopName=stopNames[name],els=tree.openElements,i=els.length-1;i>=0;i--){var node=els.item(i);if(-1!=stopName.indexOf(node.localName)){tree.insertionMode.processEndTag(node.localName);break}if(node.isSpecial()&&\"p\"!==node.localName&&\"address\"!==node.localName&&\"div\"!==node.localName)break}tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes),tree.framesetOk=!1},modes.inBody.startTagPlaintext=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes),tree.tokenizer.setState(Tokenizer.PLAINTEXT)},modes.inBody.startTagHeading=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.currentStackItem().isNumberedHeader()&&(tree.parseError(\"unexpected-start-tag\",{name:name}),tree.popElement()),tree.insertElement(name,attributes)},modes.inBody.startTagA=function(name,attributes){var activeA=tree.elementInActiveFormattingElements(\"a\");activeA&&(tree.parseError(\"unexpected-start-tag-implies-end-tag\",{startName:\"a\",endName:\"a\"}),tree.adoptionAgencyEndTag(\"a\"),tree.openElements.contains(activeA)&&tree.openElements.remove(activeA),tree.removeElementFromActiveFormattingElements(activeA)),tree.reconstructActiveFormattingElements(),tree.insertFormattingElement(name,attributes)},modes.inBody.startTagFormatting=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertFormattingElement(name,attributes)},modes.inBody.startTagNobr=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.openElements.inScope(\"nobr\")&&(tree.parseError(\"unexpected-start-tag-implies-end-tag\",{startName:\"nobr\",endName:\"nobr\"}),this.processEndTag(\"nobr\"),tree.reconstructActiveFormattingElements()),tree.insertFormattingElement(name,attributes)},modes.inBody.startTagButton=function(name,attributes){tree.openElements.inScope(\"button\")?(tree.parseError(\"unexpected-start-tag-implies-end-tag\",{startName:\"button\",endName:\"button\"}),this.processEndTag(\"button\"),tree.insertionMode.processStartTag(name,attributes)):(tree.framesetOk=!1,tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes))},modes.inBody.startTagAppletMarqueeObject=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes),tree.activeFormattingElements.push(Marker),tree.framesetOk=!1},modes.inBody.endTagAppletMarqueeObject=function(name){tree.openElements.inScope(name)?(tree.generateImpliedEndTags(),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early\",{name:name}),tree.openElements.popUntilPopped(name),tree.clearActiveFormattingElements()):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.startTagXmp=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.processEndTag(\"p\"),tree.reconstructActiveFormattingElements(),tree.processGenericRawTextStartTag(name,attributes),tree.framesetOk=!1},modes.inBody.startTagTable=function(name,attributes){\"quirks\"!==tree.compatMode&&tree.openElements.inButtonScope(\"p\")&&this.processEndTag(\"p\"),tree.insertElement(name,attributes),tree.setInsertionMode(\"inTable\"),tree.framesetOk=!1},modes.inBody.startTagVoidFormatting=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertSelfClosingElement(name,attributes),tree.framesetOk=!1},modes.inBody.startTagParamSourceTrack=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inBody.startTagHr=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertSelfClosingElement(name,attributes),tree.framesetOk=!1},modes.inBody.startTagImage=function(name,attributes){tree.parseError(\"unexpected-start-tag-treated-as\",{originalName:\"image\",newName:\"img\"}),this.processStartTag(\"img\",attributes)},modes.inBody.startTagInput=function(name,attributes){var currentFramesetOk=tree.framesetOk;this.startTagVoidFormatting(name,attributes);for(var key in attributes)if(\"type\"==attributes[key].nodeName){\"hidden\"==attributes[key].nodeValue.toLowerCase()&&(tree.framesetOk=currentFramesetOk);break}},modes.inBody.startTagIsindex=function(name,attributes){if(tree.parseError(\"deprecated-tag\",{name:\"isindex\"}),tree.selfClosingFlagAcknowledged=!0,!tree.form){var formAttributes=[],inputAttributes=[],prompt=\"This is a searchable index. Enter search keywords: \";for(var key in attributes)switch(attributes[key].nodeName){case\"action\":formAttributes.push({nodeName:\"action\",nodeValue:attributes[key].nodeValue});break;case\"prompt\":prompt=attributes[key].nodeValue;break;case\"name\":break;default:inputAttributes.push({nodeName:attributes[key].nodeName,nodeValue:attributes[key].nodeValue})}inputAttributes.push({nodeName:\"name\",nodeValue:\"isindex\"}),this.processStartTag(\"form\",formAttributes),this.processStartTag(\"hr\"),this.processStartTag(\"label\"),this.processCharacters(new CharacterBuffer(prompt)),this.processStartTag(\"input\",inputAttributes),this.processEndTag(\"label\"),this.processStartTag(\"hr\"),this.processEndTag(\"form\")}},modes.inBody.startTagTextarea=function(name,attributes){tree.insertElement(name,attributes),tree.tokenizer.setState(Tokenizer.RCDATA),tree.originalInsertionMode=tree.insertionModeName,tree.shouldSkipLeadingNewline=!0,tree.framesetOk=!1,tree.setInsertionMode(\"text\")},modes.inBody.startTagIFrame=function(name,attributes){tree.framesetOk=!1,this.startTagRawText(name,attributes)},modes.inBody.startTagRawText=function(name,attributes){tree.processGenericRawTextStartTag(name,attributes)},modes.inBody.startTagSelect=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes),tree.framesetOk=!1;var insertionModeName=tree.insertionModeName;\"inTable\"==insertionModeName||\"inCaption\"==insertionModeName||\"inColumnGroup\"==insertionModeName||\"inTableBody\"==insertionModeName||\"inRow\"==insertionModeName||\"inCell\"==insertionModeName?tree.setInsertionMode(\"inSelectInTable\"):tree.setInsertionMode(\"inSelect\")},modes.inBody.startTagMisplaced=function(name){tree.parseError(\"unexpected-start-tag-ignored\",{name:name})},modes.inBody.endTagMisplaced=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.endTagBr=function(name){tree.parseError(\"unexpected-end-tag-treated-as\",{originalName:\"br\",newName:\"br element\"}),tree.reconstructActiveFormattingElements(),tree.insertElement(name,[]),tree.popElement()},modes.inBody.startTagOptionOptgroup=function(name,attributes){\"option\"==tree.currentStackItem().localName&&tree.popElement(),tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes)},modes.inBody.startTagOther=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes)},modes.inBody.endTagOther=function(name){for(var node,i=tree.openElements.length-1;i>0;i--){if(node=tree.openElements.item(i),node.localName==name){tree.generateImpliedEndTags(name),tree.currentStackItem().localName!=name&&tree.parseError(\"unexpected-end-tag\",{name:name}),tree.openElements.remove_openElements_until(function(x){return x===node});break}if(node.isSpecial()){tree.parseError(\"unexpected-end-tag\",{name:name});break}}},modes.inBody.startTagMath=function(name,attributes,selfClosing){tree.reconstructActiveFormattingElements(),attributes=tree.adjustMathMLAttributes(attributes),attributes=tree.adjustForeignAttributes(attributes),tree.insertForeignElement(name,attributes,\"http://www.w3.org/1998/Math/MathML\",selfClosing)},modes.inBody.startTagSVG=function(name,attributes,selfClosing){tree.reconstructActiveFormattingElements(),attributes=tree.adjustSVGAttributes(attributes),attributes=tree.adjustForeignAttributes(attributes),tree.insertForeignElement(name,attributes,\"http://www.w3.org/2000/svg\",selfClosing)},modes.inBody.endTagP=function(name){tree.openElements.inButtonScope(\"p\")?(tree.generateImpliedEndTags(\"p\"),\"p\"!=tree.currentStackItem().localName&&tree.parseError(\"unexpected-implied-end-tag\",{name:\"p\"}),tree.openElements.popUntilPopped(name)):(tree.parseError(\"unexpected-end-tag\",{name:\"p\"}),this.startTagCloseP(\"p\",[]),this.endTagP(\"p\"))},modes.inBody.endTagBody=function(name){return tree.openElements.inScope(\"body\")?(\"body\"!=tree.currentStackItem().localName&&tree.parseError(\"expected-one-end-tag-but-got-another\",{expectedName:tree.currentStackItem().localName,gotName:name}),tree.setInsertionMode(\"afterBody\"),void 0):(tree.parseError(\"unexpected-end-tag\",{name:name}),void 0)},modes.inBody.endTagHtml=function(name){return tree.openElements.inScope(\"body\")?(\"body\"!=tree.currentStackItem().localName&&tree.parseError(\"expected-one-end-tag-but-got-another\",{expectedName:tree.currentStackItem().localName,gotName:name}),tree.setInsertionMode(\"afterBody\"),tree.insertionMode.processEndTag(name),void 0):(tree.parseError(\"unexpected-end-tag\",{name:name}),void 0)},modes.inBody.endTagBlock=function(name){tree.openElements.inScope(name)?(tree.generateImpliedEndTags(),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early\",{name:name}),tree.openElements.popUntilPopped(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.endTagForm=function(name){var node=tree.form;tree.form=null,node&&tree.openElements.inScope(name)?(tree.generateImpliedEndTags(),tree.currentStackItem()!=node&&tree.parseError(\"end-tag-too-early-ignored\",{name:\"form\"}),tree.openElements.remove(node)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.endTagListItem=function(name){tree.openElements.inListItemScope(name)?(tree.generateImpliedEndTags(name),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early\",{name:name}),tree.openElements.popUntilPopped(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.endTagHeading=function(name){return tree.openElements.hasNumberedHeaderElementInScope()?(tree.generateImpliedEndTags(),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early\",{name:name}),tree.openElements.remove_openElements_until(function(e){return e.isNumberedHeader()}),void 0):(tree.parseError(\"unexpected-end-tag\",{name:name}),void 0)},modes.inBody.endTagFormatting=function(name,attributes){tree.adoptionAgencyEndTag(name)||this.endTagOther(name,attributes)},modes.inCaption=Object.create(modes.base),modes.inCaption.start_tag_handlers={html:\"startTagHtml\",caption:\"startTagTableElement\",col:\"startTagTableElement\",colgroup:\"startTagTableElement\",tbody:\"startTagTableElement\",td:\"startTagTableElement\",tfoot:\"startTagTableElement\",thead:\"startTagTableElement\",tr:\"startTagTableElement\",\"-default\":\"startTagOther\"},modes.inCaption.end_tag_handlers={caption:\"endTagCaption\",table:\"endTagTable\",body:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",tbody:\"endTagIgnore\",td:\"endTagIgnore\",tfood:\"endTagIgnore\",thead:\"endTagIgnore\",tr:\"endTagIgnore\",\"-default\":\"endTagOther\"},modes.inCaption.processCharacters=function(data){modes.inBody.processCharacters(data)},modes.inCaption.startTagTableElement=function(name,attributes){tree.parseError(\"unexpected-end-tag\",{name:name});var ignoreEndTag=!tree.openElements.inTableScope(\"caption\");tree.insertionMode.processEndTag(\"caption\"),ignoreEndTag||tree.insertionMode.processStartTag(name,attributes)},modes.inCaption.startTagOther=function(name,attributes,selfClosing){modes.inBody.processStartTag(name,attributes,selfClosing)},modes.inCaption.endTagCaption=function(name){tree.openElements.inTableScope(\"caption\")?(tree.generateImpliedEndTags(),\"caption\"!=tree.currentStackItem().localName&&tree.parseError(\"expected-one-end-tag-but-got-another\",{gotName:\"caption\",expectedName:tree.currentStackItem().localName}),tree.openElements.popUntilPopped(\"caption\"),tree.clearActiveFormattingElements(),tree.setInsertionMode(\"inTable\")):(assert.ok(tree.context),tree.parseError(\"unexpected-end-tag\",{name:name}))},modes.inCaption.endTagTable=function(name){tree.parseError(\"unexpected-end-table-in-caption\");var ignoreEndTag=!tree.openElements.inTableScope(\"caption\");tree.insertionMode.processEndTag(\"caption\"),ignoreEndTag||tree.insertionMode.processEndTag(name)},modes.inCaption.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inCaption.endTagOther=function(name){modes.inBody.processEndTag(name)},modes.inCell=Object.create(modes.base),modes.inCell.start_tag_handlers={html:\"startTagHtml\",caption:\"startTagTableOther\",col:\"startTagTableOther\",colgroup:\"startTagTableOther\",tbody:\"startTagTableOther\",td:\"startTagTableOther\",tfoot:\"startTagTableOther\",th:\"startTagTableOther\",thead:\"startTagTableOther\",tr:\"startTagTableOther\",\"-default\":\"startTagOther\"},modes.inCell.end_tag_handlers={td:\"endTagTableCell\",th:\"endTagTableCell\",body:\"endTagIgnore\",caption:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",table:\"endTagImply\",tbody:\"endTagImply\",tfoot:\"endTagImply\",thead:\"endTagImply\",tr:\"endTagImply\",\"-default\":\"endTagOther\"},modes.inCell.processCharacters=function(data){modes.inBody.processCharacters(data)},modes.inCell.startTagTableOther=function(name,attributes,selfClosing){tree.openElements.inTableScope(\"td\")||tree.openElements.inTableScope(\"th\")?(this.closeCell(),tree.insertionMode.processStartTag(name,attributes,selfClosing)):tree.parseError(\"unexpected-start-tag\",{name:name})},modes.inCell.startTagOther=function(name,attributes,selfClosing){modes.inBody.processStartTag(name,attributes,selfClosing)},modes.inCell.endTagTableCell=function(name){tree.openElements.inTableScope(name)?(tree.generateImpliedEndTags(name),tree.currentStackItem().localName!=name.toLowerCase()?(tree.parseError(\"unexpected-cell-end-tag\",{name:name}),tree.openElements.popUntilPopped(name)):tree.popElement(),tree.clearActiveFormattingElements(),tree.setInsertionMode(\"inRow\")):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inCell.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inCell.endTagImply=function(name){tree.openElements.inTableScope(name)?(this.closeCell(),tree.insertionMode.processEndTag(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inCell.endTagOther=function(name){modes.inBody.processEndTag(name)},modes.inCell.closeCell=function(){tree.openElements.inTableScope(\"td\")?this.endTagTableCell(\"td\"):tree.openElements.inTableScope(\"th\")&&this.endTagTableCell(\"th\")},modes.inColumnGroup=Object.create(modes.base),modes.inColumnGroup.start_tag_handlers={html:\"startTagHtml\",col:\"startTagCol\",\"-default\":\"startTagOther\"},modes.inColumnGroup.end_tag_handlers={colgroup:\"endTagColgroup\",col:\"endTagCol\",\"-default\":\"endTagOther\"},modes.inColumnGroup.ignoreEndTagColgroup=function(){return\"html\"==tree.currentStackItem().localName},modes.inColumnGroup.processCharacters=function(buffer){var leadingWhitespace=buffer.takeLeadingWhitespace();if(leadingWhitespace&&tree.insertText(leadingWhitespace),buffer.length){var ignoreEndTag=this.ignoreEndTagColgroup();this.endTagColgroup(\"colgroup\"),ignoreEndTag||tree.insertionMode.processCharacters(buffer)}},modes.inColumnGroup.startTagCol=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inColumnGroup.startTagOther=function(name,attributes,selfClosing){var ignoreEndTag=this.ignoreEndTagColgroup();this.endTagColgroup(\"colgroup\"),ignoreEndTag||tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.inColumnGroup.endTagColgroup=function(name){this.ignoreEndTagColgroup()?(assert.ok(tree.context),tree.parseError(\"unexpected-end-tag\",{name:name})):(tree.popElement(),tree.setInsertionMode(\"inTable\"))},modes.inColumnGroup.endTagCol=function(){tree.parseError(\"no-end-tag\",{name:\"col\"})},modes.inColumnGroup.endTagOther=function(name){var ignoreEndTag=this.ignoreEndTagColgroup();this.endTagColgroup(\"colgroup\"),ignoreEndTag||tree.insertionMode.processEndTag(name)},modes.inForeignContent=Object.create(modes.base),modes.inForeignContent.processStartTag=function(name,attributes,selfClosing){if(-1!=[\"b\",\"big\",\"blockquote\",\"body\",\"br\",\"center\",\"code\",\"dd\",\"div\",\"dl\",\"dt\",\"em\",\"embed\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"head\",\"hr\",\"i\",\"img\",\"li\",\"listing\",\"menu\",\"meta\",\"nobr\",\"ol\",\"p\",\"pre\",\"ruby\",\"s\",\"small\",\"span\",\"strong\",\"strike\",\"sub\",\"sup\",\"table\",\"tt\",\"u\",\"ul\",\"var\"].indexOf(name)||\"font\"==name&&attributes.some(function(attr){return[\"color\",\"face\",\"size\"].indexOf(attr.nodeName)>=0})){for(tree.parseError(\"unexpected-html-element-in-foreign-content\",{name:name});tree.currentStackItem().isForeign()&&!tree.currentStackItem().isHtmlIntegrationPoint()&&!tree.currentStackItem().isMathMLTextIntegrationPoint();)tree.openElements.pop();return tree.insertionMode.processStartTag(name,attributes,selfClosing),void 0}\"http://www.w3.org/1998/Math/MathML\"==tree.currentStackItem().namespaceURI&&(attributes=tree.adjustMathMLAttributes(attributes)),\"http://www.w3.org/2000/svg\"==tree.currentStackItem().namespaceURI&&(name=tree.adjustSVGTagNameCase(name),attributes=tree.adjustSVGAttributes(attributes)),attributes=tree.adjustForeignAttributes(attributes),tree.insertForeignElement(name,attributes,tree.currentStackItem().namespaceURI,selfClosing)},modes.inForeignContent.processEndTag=function(name){var node=tree.currentStackItem(),index=tree.openElements.length-1;for(node.localName.toLowerCase()!=name&&tree.parseError(\"unexpected-end-tag\",{name:name});;){if(0===index)break;if(node.localName.toLowerCase()==name){for(;tree.openElements.pop()!=node;);break}if(index-=1,node=tree.openElements.item(index),!node.isForeign()){tree.insertionMode.processEndTag(name);break}}},modes.inForeignContent.processCharacters=function(buffer){var characters=buffer.takeRemaining();characters=characters.replace(/\\u0000/g,function(){return tree.parseError(\"invalid-codepoint\"),\"�\"}),tree.framesetOk&&!isAllWhitespaceOrReplacementCharacters(characters)&&(tree.framesetOk=!1),tree.insertText(characters)},modes.inHeadNoscript=Object.create(modes.base),modes.inHeadNoscript.start_tag_handlers={html:\"startTagHtml\",basefont:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",bgsound:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",link:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",meta:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",noframes:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",style:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",head:\"startTagHeadNoscript\",noscript:\"startTagHeadNoscript\",\"-default\":\"startTagOther\"},modes.inHeadNoscript.end_tag_handlers={noscript:\"endTagNoscript\",br:\"endTagBr\",\"-default\":\"endTagOther\"},modes.inHeadNoscript.processCharacters=function(buffer){var leadingWhitespace=buffer.takeLeadingWhitespace();leadingWhitespace&&tree.insertText(leadingWhitespace),buffer.length&&(tree.parseError(\"unexpected-char-in-frameset\"),this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.inHeadNoscript.processComment=function(data){modes.inHead.processComment(data)},modes.inHeadNoscript.startTagBasefontBgsoundLinkMetaNoframesStyle=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.inHeadNoscript.startTagHeadNoscript=function(name){tree.parseError(\"unexpected-start-tag-in-frameset\",{name:name})},modes.inHeadNoscript.startTagOther=function(name,attributes){tree.parseError(\"unexpected-start-tag-in-frameset\",{name:name}),this.anythingElse(),tree.insertionMode.processStartTag(name,attributes)},modes.inHeadNoscript.endTagBr=function(name,attributes){tree.parseError(\"unexpected-end-tag-in-frameset\",{name:name}),this.anythingElse(),tree.insertionMode.processEndTag(name,attributes)},modes.inHeadNoscript.endTagNoscript=function(){tree.popElement(),tree.setInsertionMode(\"inHead\")},modes.inHeadNoscript.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-in-frameset\",{name:name})},modes.inHeadNoscript.anythingElse=function(){tree.popElement(),tree.setInsertionMode(\"inHead\")},modes.inFrameset=Object.create(modes.base),modes.inFrameset.start_tag_handlers={html:\"startTagHtml\",frameset:\"startTagFrameset\",frame:\"startTagFrame\",noframes:\"startTagNoframes\",\"-default\":\"startTagOther\"},modes.inFrameset.end_tag_handlers={frameset:\"endTagFrameset\",noframes:\"endTagNoframes\",\"-default\":\"endTagOther\"},modes.inFrameset.processCharacters=function(){tree.parseError(\"unexpected-char-in-frameset\")},modes.inFrameset.startTagFrameset=function(name,attributes){tree.insertElement(name,attributes)},modes.inFrameset.startTagFrame=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inFrameset.startTagNoframes=function(name,attributes){modes.inBody.processStartTag(name,attributes)},modes.inFrameset.startTagOther=function(name){tree.parseError(\"unexpected-start-tag-in-frameset\",{name:name})},modes.inFrameset.endTagFrameset=function(){\"html\"==tree.currentStackItem().localName?tree.parseError(\"unexpected-frameset-in-frameset-innerhtml\"):tree.popElement(),tree.context||\"frameset\"==tree.currentStackItem().localName||tree.setInsertionMode(\"afterFrameset\")},modes.inFrameset.endTagNoframes=function(name){modes.inBody.processEndTag(name)},modes.inFrameset.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-in-frameset\",{name:name})},modes.inTable=Object.create(modes.base),modes.inTable.start_tag_handlers={html:\"startTagHtml\",caption:\"startTagCaption\",colgroup:\"startTagColgroup\",col:\"startTagCol\",table:\"startTagTable\",tbody:\"startTagRowGroup\",tfoot:\"startTagRowGroup\",thead:\"startTagRowGroup\",td:\"startTagImplyTbody\",th:\"startTagImplyTbody\",tr:\"startTagImplyTbody\",style:\"startTagStyleScript\",script:\"startTagStyleScript\",input:\"startTagInput\",form:\"startTagForm\",\"-default\":\"startTagOther\"},modes.inTable.end_tag_handlers={table:\"endTagTable\",body:\"endTagIgnore\",caption:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",tbody:\"endTagIgnore\",td:\"endTagIgnore\",tfoot:\"endTagIgnore\",th:\"endTagIgnore\",thead:\"endTagIgnore\",tr:\"endTagIgnore\",\"-default\":\"endTagOther\"},modes.inTable.processCharacters=function(data){if(tree.currentStackItem().isFosterParenting()){var originalInsertionMode=tree.insertionModeName;\ntree.setInsertionMode(\"inTableText\"),tree.originalInsertionMode=originalInsertionMode,tree.insertionMode.processCharacters(data)}else tree.redirectAttachToFosterParent=!0,modes.inBody.processCharacters(data),tree.redirectAttachToFosterParent=!1},modes.inTable.startTagCaption=function(name,attributes){tree.openElements.popUntilTableScopeMarker(),tree.activeFormattingElements.push(Marker),tree.insertElement(name,attributes),tree.setInsertionMode(\"inCaption\")},modes.inTable.startTagColgroup=function(name,attributes){tree.openElements.popUntilTableScopeMarker(),tree.insertElement(name,attributes),tree.setInsertionMode(\"inColumnGroup\")},modes.inTable.startTagCol=function(name,attributes){this.startTagColgroup(\"colgroup\",[]),tree.insertionMode.processStartTag(name,attributes)},modes.inTable.startTagRowGroup=function(name,attributes){tree.openElements.popUntilTableScopeMarker(),tree.insertElement(name,attributes),tree.setInsertionMode(\"inTableBody\")},modes.inTable.startTagImplyTbody=function(name,attributes){this.startTagRowGroup(\"tbody\",[]),tree.insertionMode.processStartTag(name,attributes)},modes.inTable.startTagTable=function(name,attributes){tree.parseError(\"unexpected-start-tag-implies-end-tag\",{startName:\"table\",endName:\"table\"}),tree.insertionMode.processEndTag(\"table\"),tree.context||tree.insertionMode.processStartTag(name,attributes)},modes.inTable.startTagStyleScript=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.inTable.startTagInput=function(name,attributes){for(var key in attributes)if(\"type\"==attributes[key].nodeName.toLowerCase()){if(\"hidden\"==attributes[key].nodeValue.toLowerCase())return tree.parseError(\"unexpected-hidden-input-in-table\"),tree.insertElement(name,attributes),tree.openElements.pop(),void 0;break}this.startTagOther(name,attributes)},modes.inTable.startTagForm=function(name,attributes){tree.parseError(\"unexpected-form-in-table\"),tree.form||(tree.insertElement(name,attributes),tree.form=tree.currentStackItem(),tree.openElements.pop())},modes.inTable.startTagOther=function(name,attributes,selfClosing){tree.parseError(\"unexpected-start-tag-implies-table-voodoo\",{name:name}),tree.redirectAttachToFosterParent=!0,modes.inBody.processStartTag(name,attributes,selfClosing),tree.redirectAttachToFosterParent=!1},modes.inTable.endTagTable=function(name){tree.openElements.inTableScope(name)?(tree.generateImpliedEndTags(),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early-named\",{gotName:\"table\",expectedName:tree.currentStackItem().localName}),tree.openElements.popUntilPopped(\"table\"),tree.resetInsertionMode()):(assert.ok(tree.context),tree.parseError(\"unexpected-end-tag\",{name:name}))},modes.inTable.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inTable.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-implies-table-voodoo\",{name:name}),tree.redirectAttachToFosterParent=!0,modes.inBody.processEndTag(name),tree.redirectAttachToFosterParent=!1},modes.inTableText=Object.create(modes.base),modes.inTableText.flushCharacters=function(){var characters=tree.pendingTableCharacters.join(\"\");isAllWhitespace(characters)?tree.insertText(characters):(tree.redirectAttachToFosterParent=!0,tree.reconstructActiveFormattingElements(),tree.insertText(characters),tree.framesetOk=!1,tree.redirectAttachToFosterParent=!1),tree.pendingTableCharacters=[]},modes.inTableText.processComment=function(data){this.flushCharacters(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processComment(data)},modes.inTableText.processEOF=function(){this.flushCharacters(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processEOF()},modes.inTableText.processCharacters=function(buffer){var characters=buffer.takeRemaining();characters=characters.replace(/\\u0000/g,function(){return tree.parseError(\"invalid-codepoint\"),\"\"}),characters&&tree.pendingTableCharacters.push(characters)},modes.inTableText.processStartTag=function(name,attributes,selfClosing){this.flushCharacters(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.inTableText.processEndTag=function(name,attributes){this.flushCharacters(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processEndTag(name,attributes)},modes.inTableBody=Object.create(modes.base),modes.inTableBody.start_tag_handlers={html:\"startTagHtml\",tr:\"startTagTr\",td:\"startTagTableCell\",th:\"startTagTableCell\",caption:\"startTagTableOther\",col:\"startTagTableOther\",colgroup:\"startTagTableOther\",tbody:\"startTagTableOther\",tfoot:\"startTagTableOther\",thead:\"startTagTableOther\",\"-default\":\"startTagOther\"},modes.inTableBody.end_tag_handlers={table:\"endTagTable\",tbody:\"endTagTableRowGroup\",tfoot:\"endTagTableRowGroup\",thead:\"endTagTableRowGroup\",body:\"endTagIgnore\",caption:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",td:\"endTagIgnore\",th:\"endTagIgnore\",tr:\"endTagIgnore\",\"-default\":\"endTagOther\"},modes.inTableBody.processCharacters=function(data){modes.inTable.processCharacters(data)},modes.inTableBody.startTagTr=function(name,attributes){tree.openElements.popUntilTableBodyScopeMarker(),tree.insertElement(name,attributes),tree.setInsertionMode(\"inRow\")},modes.inTableBody.startTagTableCell=function(name,attributes){tree.parseError(\"unexpected-cell-in-table-body\",{name:name}),this.startTagTr(\"tr\",[]),tree.insertionMode.processStartTag(name,attributes)},modes.inTableBody.startTagTableOther=function(name,attributes){tree.openElements.inTableScope(\"tbody\")||tree.openElements.inTableScope(\"thead\")||tree.openElements.inTableScope(\"tfoot\")?(tree.openElements.popUntilTableBodyScopeMarker(),this.endTagTableRowGroup(tree.currentStackItem().localName),tree.insertionMode.processStartTag(name,attributes)):tree.parseError(\"unexpected-start-tag\",{name:name})},modes.inTableBody.startTagOther=function(name,attributes){modes.inTable.processStartTag(name,attributes)},modes.inTableBody.endTagTableRowGroup=function(name){tree.openElements.inTableScope(name)?(tree.openElements.popUntilTableBodyScopeMarker(),tree.popElement(),tree.setInsertionMode(\"inTable\")):tree.parseError(\"unexpected-end-tag-in-table-body\",{name:name})},modes.inTableBody.endTagTable=function(name){tree.openElements.inTableScope(\"tbody\")||tree.openElements.inTableScope(\"thead\")||tree.openElements.inTableScope(\"tfoot\")?(tree.openElements.popUntilTableBodyScopeMarker(),this.endTagTableRowGroup(tree.currentStackItem().localName),tree.insertionMode.processEndTag(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inTableBody.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag-in-table-body\",{name:name})},modes.inTableBody.endTagOther=function(name){modes.inTable.processEndTag(name)},modes.inSelect=Object.create(modes.base),modes.inSelect.start_tag_handlers={html:\"startTagHtml\",option:\"startTagOption\",optgroup:\"startTagOptgroup\",select:\"startTagSelect\",input:\"startTagInput\",keygen:\"startTagInput\",textarea:\"startTagInput\",script:\"startTagScript\",\"-default\":\"startTagOther\"},modes.inSelect.end_tag_handlers={option:\"endTagOption\",optgroup:\"endTagOptgroup\",select:\"endTagSelect\",caption:\"endTagTableElements\",table:\"endTagTableElements\",tbody:\"endTagTableElements\",tfoot:\"endTagTableElements\",thead:\"endTagTableElements\",tr:\"endTagTableElements\",td:\"endTagTableElements\",th:\"endTagTableElements\",\"-default\":\"endTagOther\"},modes.inSelect.processCharacters=function(buffer){var data=buffer.takeRemaining();data=data.replace(/\\u0000/g,function(){return tree.parseError(\"invalid-codepoint\"),\"\"}),data&&tree.insertText(data)},modes.inSelect.startTagOption=function(name,attributes){\"option\"==tree.currentStackItem().localName&&tree.popElement(),tree.insertElement(name,attributes)},modes.inSelect.startTagOptgroup=function(name,attributes){\"option\"==tree.currentStackItem().localName&&tree.popElement(),\"optgroup\"==tree.currentStackItem().localName&&tree.popElement(),tree.insertElement(name,attributes)},modes.inSelect.endTagOption=function(name){return\"option\"!==tree.currentStackItem().localName?(tree.parseError(\"unexpected-end-tag-in-select\",{name:name}),void 0):(tree.popElement(),void 0)},modes.inSelect.endTagOptgroup=function(){\"option\"==tree.currentStackItem().localName&&\"optgroup\"==tree.openElements.item(tree.openElements.length-2).localName&&tree.popElement(),\"optgroup\"==tree.currentStackItem().localName?tree.popElement():tree.parseError(\"unexpected-end-tag-in-select\",{name:\"optgroup\"})},modes.inSelect.startTagSelect=function(){tree.parseError(\"unexpected-select-in-select\"),this.endTagSelect(\"select\")},modes.inSelect.endTagSelect=function(name){tree.openElements.inTableScope(\"select\")?(tree.openElements.popUntilPopped(\"select\"),tree.resetInsertionMode()):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inSelect.startTagInput=function(name,attributes){tree.parseError(\"unexpected-input-in-select\"),tree.openElements.inSelectScope(\"select\")&&(this.endTagSelect(\"select\"),tree.insertionMode.processStartTag(name,attributes))},modes.inSelect.startTagScript=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.inSelect.endTagTableElements=function(name){tree.parseError(\"unexpected-end-tag-in-select\",{name:name}),tree.openElements.inTableScope(name)&&(this.endTagSelect(\"select\"),tree.insertionMode.processEndTag(name))},modes.inSelect.startTagOther=function(name){tree.parseError(\"unexpected-start-tag-in-select\",{name:name})},modes.inSelect.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-in-select\",{name:name})},modes.inSelectInTable=Object.create(modes.base),modes.inSelectInTable.start_tag_handlers={caption:\"startTagTable\",table:\"startTagTable\",tbody:\"startTagTable\",tfoot:\"startTagTable\",thead:\"startTagTable\",tr:\"startTagTable\",td:\"startTagTable\",th:\"startTagTable\",\"-default\":\"startTagOther\"},modes.inSelectInTable.end_tag_handlers={caption:\"endTagTable\",table:\"endTagTable\",tbody:\"endTagTable\",tfoot:\"endTagTable\",thead:\"endTagTable\",tr:\"endTagTable\",td:\"endTagTable\",th:\"endTagTable\",\"-default\":\"endTagOther\"},modes.inSelectInTable.processCharacters=function(data){modes.inSelect.processCharacters(data)},modes.inSelectInTable.startTagTable=function(name,attributes){tree.parseError(\"unexpected-table-element-start-tag-in-select-in-table\",{name:name}),this.endTagOther(\"select\"),tree.insertionMode.processStartTag(name,attributes)},modes.inSelectInTable.startTagOther=function(name,attributes,selfClosing){modes.inSelect.processStartTag(name,attributes,selfClosing)},modes.inSelectInTable.endTagTable=function(name){tree.parseError(\"unexpected-table-element-end-tag-in-select-in-table\",{name:name}),tree.openElements.inTableScope(name)&&(this.endTagOther(\"select\"),tree.insertionMode.processEndTag(name))},modes.inSelectInTable.endTagOther=function(name){modes.inSelect.processEndTag(name)},modes.inRow=Object.create(modes.base),modes.inRow.start_tag_handlers={html:\"startTagHtml\",td:\"startTagTableCell\",th:\"startTagTableCell\",caption:\"startTagTableOther\",col:\"startTagTableOther\",colgroup:\"startTagTableOther\",tbody:\"startTagTableOther\",tfoot:\"startTagTableOther\",thead:\"startTagTableOther\",tr:\"startTagTableOther\",\"-default\":\"startTagOther\"},modes.inRow.end_tag_handlers={tr:\"endTagTr\",table:\"endTagTable\",tbody:\"endTagTableRowGroup\",tfoot:\"endTagTableRowGroup\",thead:\"endTagTableRowGroup\",body:\"endTagIgnore\",caption:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",td:\"endTagIgnore\",th:\"endTagIgnore\",\"-default\":\"endTagOther\"},modes.inRow.processCharacters=function(data){modes.inTable.processCharacters(data)},modes.inRow.startTagTableCell=function(name,attributes){tree.openElements.popUntilTableRowScopeMarker(),tree.insertElement(name,attributes),tree.setInsertionMode(\"inCell\"),tree.activeFormattingElements.push(Marker)},modes.inRow.startTagTableOther=function(name,attributes){var ignoreEndTag=this.ignoreEndTagTr();this.endTagTr(\"tr\"),ignoreEndTag||tree.insertionMode.processStartTag(name,attributes)},modes.inRow.startTagOther=function(name,attributes,selfClosing){modes.inTable.processStartTag(name,attributes,selfClosing)},modes.inRow.endTagTr=function(name){this.ignoreEndTagTr()?(assert.ok(tree.context),tree.parseError(\"unexpected-end-tag\",{name:name})):(tree.openElements.popUntilTableRowScopeMarker(),tree.popElement(),tree.setInsertionMode(\"inTableBody\"))},modes.inRow.endTagTable=function(name){var ignoreEndTag=this.ignoreEndTagTr();this.endTagTr(\"tr\"),ignoreEndTag||tree.insertionMode.processEndTag(name)},modes.inRow.endTagTableRowGroup=function(name){tree.openElements.inTableScope(name)?(this.endTagTr(\"tr\"),tree.insertionMode.processEndTag(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inRow.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag-in-table-row\",{name:name})},modes.inRow.endTagOther=function(name){modes.inTable.processEndTag(name)},modes.inRow.ignoreEndTagTr=function(){return!tree.openElements.inTableScope(\"tr\")},modes.afterAfterFrameset=Object.create(modes.base),modes.afterAfterFrameset.start_tag_handlers={html:\"startTagHtml\",noframes:\"startTagNoFrames\",\"-default\":\"startTagOther\"},modes.afterAfterFrameset.processEOF=function(){},modes.afterAfterFrameset.processComment=function(data){tree.insertComment(data,tree.document)},modes.afterAfterFrameset.processCharacters=function(buffer){for(var characters=buffer.takeRemaining(),whitespace=\"\",i=0;characters.length>i;i++){var ch=characters[i];isWhitespace(ch)&&(whitespace+=ch)}whitespace&&(tree.reconstructActiveFormattingElements(),tree.insertText(whitespace)),whitespace.length<characters.length&&tree.parseError(\"expected-eof-but-got-char\")},modes.afterAfterFrameset.startTagNoFrames=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.afterAfterFrameset.startTagOther=function(name){tree.parseError(\"expected-eof-but-got-start-tag\",{name:name})},modes.afterAfterFrameset.processEndTag=function(name){tree.parseError(\"expected-eof-but-got-end-tag\",{name:name})},modes.text=Object.create(modes.base),modes.text.start_tag_handlers={\"-default\":\"startTagOther\"},modes.text.end_tag_handlers={script:\"endTagScript\",\"-default\":\"endTagOther\"},modes.text.processCharacters=function(buffer){tree.shouldSkipLeadingNewline&&(tree.shouldSkipLeadingNewline=!1,buffer.skipAtMostOneLeadingNewline());var data=buffer.takeRemaining();data&&tree.insertText(data)},modes.text.processEOF=function(){tree.parseError(\"expected-named-closing-tag-but-got-eof\",{name:tree.currentStackItem().localName}),tree.openElements.pop(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processEOF()},modes.text.startTagOther=function(name){throw\"Tried to process start tag \"+name+\" in RCDATA/RAWTEXT mode\"},modes.text.endTagScript=function(){var node=tree.openElements.pop();assert.ok(\"script\"==node.localName),tree.setInsertionMode(tree.originalInsertionMode)},modes.text.endTagOther=function(){tree.openElements.pop(),tree.setInsertionMode(tree.originalInsertionMode)}}function formatMessage(format,args){return format.replace(RegExp(\"{[0-9a-z-]+}\",\"gi\"),function(match){return args[match.slice(1,-1)]||match})}var assert=_dereq_(\"assert\"),messages=_dereq_(\"./messages.json\"),constants=_dereq_(\"./constants\");_dereq_(\"events\").EventEmitter;var Tokenizer=_dereq_(\"./Tokenizer\").Tokenizer,ElementStack=_dereq_(\"./ElementStack\").ElementStack,StackItem=_dereq_(\"./StackItem\").StackItem,Marker={};CharacterBuffer.prototype.skipAtMostOneLeadingNewline=function(){\"\\n\"===this.characters[this.current]&&this.current++},CharacterBuffer.prototype.skipLeadingWhitespace=function(){for(;isWhitespace(this.characters[this.current]);)if(++this.current==this.end)return},CharacterBuffer.prototype.skipLeadingNonWhitespace=function(){for(;!isWhitespace(this.characters[this.current]);)if(++this.current==this.end)return},CharacterBuffer.prototype.takeRemaining=function(){return this.characters.substring(this.current)},CharacterBuffer.prototype.takeLeadingWhitespace=function(){var start=this.current;return this.skipLeadingWhitespace(),start===this.current?\"\":this.characters.substring(start,this.current-start)},Object.defineProperty(CharacterBuffer.prototype,\"length\",{get:function(){return this.end-this.current}}),TreeBuilder.prototype.setInsertionMode=function(name){this.insertionMode=this.insertionModes[name],this.insertionModeName=name},TreeBuilder.prototype.adoptionAgencyEndTag=function(name){function isActiveFormattingElement(el){return el===formattingElement}for(var formattingElement,outerIterationLimit=8,innerIterationLimit=3,outerLoopCounter=0;outerIterationLimit>outerLoopCounter++;){if(formattingElement=this.elementInActiveFormattingElements(name),!formattingElement||this.openElements.contains(formattingElement)&&!this.openElements.inScope(formattingElement.localName))return this.parseError(\"adoption-agency-1.1\",{name:name}),!1;if(!this.openElements.contains(formattingElement))return this.parseError(\"adoption-agency-1.2\",{name:name}),this.removeElementFromActiveFormattingElements(formattingElement),!0;this.openElements.inScope(formattingElement.localName)||this.parseError(\"adoption-agency-4.4\",{name:name}),formattingElement!=this.currentStackItem()&&this.parseError(\"adoption-agency-1.3\",{name:name});var furthestBlock=this.openElements.furthestBlockForFormattingElement(formattingElement.node);if(!furthestBlock)return this.openElements.remove_openElements_until(isActiveFormattingElement),this.removeElementFromActiveFormattingElements(formattingElement),!0;for(var afeIndex=this.openElements.elements.indexOf(formattingElement),commonAncestor=this.openElements.item(afeIndex-1),bookmark=this.activeFormattingElements.indexOf(formattingElement),node=furthestBlock,lastNode=furthestBlock,index=this.openElements.elements.indexOf(node),innerLoopCounter=0;innerIterationLimit>innerLoopCounter++;)if(index-=1,node=this.openElements.item(index),0>this.activeFormattingElements.indexOf(node))this.openElements.elements.splice(index,1);else{if(node==formattingElement)break;lastNode==furthestBlock&&(bookmark=this.activeFormattingElements.indexOf(node)+1);var clone=this.createElement(node.namespaceURI,node.localName,node.attributes),newNode=new StackItem(node.namespaceURI,node.localName,node.attributes,clone);this.activeFormattingElements[this.activeFormattingElements.indexOf(node)]=newNode,this.openElements.elements[this.openElements.elements.indexOf(node)]=newNode,node=newNode,this.detachFromParent(lastNode.node),this.attachNode(lastNode.node,node.node),lastNode=node}this.detachFromParent(lastNode.node),commonAncestor.isFosterParenting()?this.insertIntoFosterParent(lastNode.node):this.attachNode(lastNode.node,commonAncestor.node);var clone=this.createElement(\"http://www.w3.org/1999/xhtml\",formattingElement.localName,formattingElement.attributes),formattingClone=new StackItem(formattingElement.namespaceURI,formattingElement.localName,formattingElement.attributes,clone);this.reparentChildren(furthestBlock.node,clone),this.attachNode(clone,furthestBlock.node),this.removeElementFromActiveFormattingElements(formattingElement),this.activeFormattingElements.splice(Math.min(bookmark,this.activeFormattingElements.length),0,formattingClone),this.openElements.remove(formattingElement),this.openElements.elements.splice(this.openElements.elements.indexOf(furthestBlock)+1,0,formattingClone)}return!0},TreeBuilder.prototype.start=function(){throw\"Not mplemented\"},TreeBuilder.prototype.startTokenization=function(tokenizer){if(this.tokenizer=tokenizer,this.compatMode=\"no quirks\",this.originalInsertionMode=\"initial\",this.framesetOk=!0,this.openElements=new ElementStack,this.activeFormattingElements=[],this.start(),this.context){switch(this.context){case\"title\":case\"textarea\":this.tokenizer.setState(Tokenizer.RCDATA);break;case\"style\":case\"xmp\":case\"iframe\":case\"noembed\":case\"noframes\":this.tokenizer.setState(Tokenizer.RAWTEXT);break;case\"script\":this.tokenizer.setState(Tokenizer.SCRIPT_DATA);break;case\"noscript\":this.scriptingEnabled&&this.tokenizer.setState(Tokenizer.RAWTEXT);break;case\"plaintext\":this.tokenizer.setState(Tokenizer.PLAINTEXT)}this.insertHtmlElement(),this.resetInsertionMode()}else this.setInsertionMode(\"initial\")},TreeBuilder.prototype.processToken=function(token){this.selfClosingFlagAcknowledged=!1;var insertionMode,currentNode=this.openElements.top||null;switch(insertionMode=!currentNode||!currentNode.isForeign()||currentNode.isMathMLTextIntegrationPoint()&&(\"StartTag\"==token.type&&!(token.name in{mglyph:0,malignmark:0})||\"Characters\"===token.type)||\"http://www.w3.org/1998/Math/MathML\"==currentNode.namespaceURI&&\"annotation-xml\"==currentNode.localName&&\"StartTag\"==token.type&&\"svg\"==token.name||currentNode.isHtmlIntegrationPoint()&&token.type in{StartTag:0,Characters:0}||\"EOF\"==token.type?this.insertionMode:this.insertionModes.inForeignContent,token.type){case\"Characters\":var buffer=new CharacterBuffer(token.data);insertionMode.processCharacters(buffer);break;case\"Comment\":insertionMode.processComment(token.data);break;case\"StartTag\":insertionMode.processStartTag(token.name,token.data,token.selfClosing);break;case\"EndTag\":insertionMode.processEndTag(token.name);break;case\"Doctype\":insertionMode.processDoctype(token.name,token.publicId,token.systemId,token.forceQuirks);break;case\"EOF\":insertionMode.processEOF()}},TreeBuilder.prototype.isCdataSectionAllowed=function(){return this.openElements.length>0&&this.currentStackItem().isForeign()},TreeBuilder.prototype.isSelfClosingFlagAcknowledged=function(){return this.selfClosingFlagAcknowledged},TreeBuilder.prototype.createElement=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.attachNode=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.attachNodeToFosterParent=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.detachFromParent=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.addAttributesToElement=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.insertHtmlElement=function(attributes){var root=this.createElement(\"http://www.w3.org/1999/xhtml\",\"html\",attributes);return this.attachNode(root,this.document),this.openElements.pushHtmlElement(new StackItem(\"http://www.w3.org/1999/xhtml\",\"html\",attributes,root)),root},TreeBuilder.prototype.insertHeadElement=function(attributes){var element=this.createElement(\"http://www.w3.org/1999/xhtml\",\"head\",attributes);return this.head=new StackItem(\"http://www.w3.org/1999/xhtml\",\"head\",attributes,element),this.attachNode(element,this.openElements.top.node),this.openElements.pushHeadElement(this.head),element},TreeBuilder.prototype.insertBodyElement=function(attributes){var element=this.createElement(\"http://www.w3.org/1999/xhtml\",\"body\",attributes);return this.attachNode(element,this.openElements.top.node),this.openElements.pushBodyElement(new StackItem(\"http://www.w3.org/1999/xhtml\",\"body\",attributes,element)),element},TreeBuilder.prototype.insertIntoFosterParent=function(node){var tableIndex=this.openElements.findIndex(\"table\"),tableElement=this.openElements.item(tableIndex).node;return 0===tableIndex?this.attachNode(node,tableElement):(this.attachNodeToFosterParent(node,tableElement,this.openElements.item(tableIndex-1).node),void 0)},TreeBuilder.prototype.insertElement=function(name,attributes,namespaceURI,selfClosing){namespaceURI||(namespaceURI=\"http://www.w3.org/1999/xhtml\");var element=this.createElement(namespaceURI,name,attributes);this.shouldFosterParent()?this.insertIntoFosterParent(element):this.attachNode(element,this.openElements.top.node),selfClosing||this.openElements.push(new StackItem(namespaceURI,name,attributes,element))},TreeBuilder.prototype.insertFormattingElement=function(name,attributes){this.insertElement(name,attributes,\"http://www.w3.org/1999/xhtml\"),this.appendElementToActiveFormattingElements(this.currentStackItem())},TreeBuilder.prototype.insertSelfClosingElement=function(name,attributes){this.selfClosingFlagAcknowledged=!0,this.insertElement(name,attributes,\"http://www.w3.org/1999/xhtml\",!0)},TreeBuilder.prototype.insertForeignElement=function(name,attributes,namespaceURI,selfClosing){selfClosing&&(this.selfClosingFlagAcknowledged=!0),this.insertElement(name,attributes,namespaceURI,selfClosing)},TreeBuilder.prototype.insertComment=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.insertDoctype=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.insertText=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.currentStackItem=function(){return this.openElements.top},TreeBuilder.prototype.popElement=function(){return this.openElements.pop()},TreeBuilder.prototype.shouldFosterParent=function(){return this.redirectAttachToFosterParent&&this.currentStackItem().isFosterParenting()},TreeBuilder.prototype.generateImpliedEndTags=function(exclude){var name=this.openElements.top.localName;-1!=[\"dd\",\"dt\",\"li\",\"option\",\"optgroup\",\"p\",\"rp\",\"rt\"].indexOf(name)&&name!=exclude&&(this.popElement(),this.generateImpliedEndTags(exclude))},TreeBuilder.prototype.reconstructActiveFormattingElements=function(){if(0!==this.activeFormattingElements.length){var i=this.activeFormattingElements.length-1,entry=this.activeFormattingElements[i];if(entry!=Marker&&!this.openElements.contains(entry)){for(;entry!=Marker&&!this.openElements.contains(entry)&&(i-=1,entry=this.activeFormattingElements[i]););for(;;){i+=1,entry=this.activeFormattingElements[i],this.insertElement(entry.localName,entry.attributes);var element=this.currentStackItem();if(this.activeFormattingElements[i]=element,element==this.activeFormattingElements[this.activeFormattingElements.length-1])break}}}},TreeBuilder.prototype.ensureNoahsArkCondition=function(item){var kNoahsArkCapacity=3;if(!(kNoahsArkCapacity>this.activeFormattingElements.length)){for(var candidates=[],newItemAttributeCount=item.attributes.length,i=this.activeFormattingElements.length-1;i>=0;i--){var candidate=this.activeFormattingElements[i];if(candidate===Marker)break;item.localName===candidate.localName&&item.namespaceURI===candidate.namespaceURI&&candidate.attributes.length==newItemAttributeCount&&candidates.push(candidate)}if(!(kNoahsArkCapacity>candidates.length)){for(var remainingCandidates=[],attributes=item.attributes,i=0;attributes.length>i;i++){for(var attribute=attributes[i],j=0;candidates.length>j;j++){var candidate=candidates[j],candidateAttribute=getAttribute(candidate,attribute.nodeName);candidateAttribute&&candidateAttribute.nodeValue===attribute.nodeValue&&remainingCandidates.push(candidate)}if(kNoahsArkCapacity>remainingCandidates.length)return;candidates=remainingCandidates,remainingCandidates=[]}for(var i=kNoahsArkCapacity-1;candidates.length>i;i++)this.removeElementFromActiveFormattingElements(candidates[i])}}},TreeBuilder.prototype.appendElementToActiveFormattingElements=function(item){this.ensureNoahsArkCondition(item),this.activeFormattingElements.push(item)},TreeBuilder.prototype.removeElementFromActiveFormattingElements=function(item){var index=this.activeFormattingElements.indexOf(item);index>=0&&this.activeFormattingElements.splice(index,1)},TreeBuilder.prototype.elementInActiveFormattingElements=function(name){for(var els=this.activeFormattingElements,i=els.length-1;i>=0&&els[i]!=Marker;i--)if(els[i].localName==name)return els[i];return!1},TreeBuilder.prototype.clearActiveFormattingElements=function(){for(;0!==this.activeFormattingElements.length&&this.activeFormattingElements.pop()!=Marker;);},TreeBuilder.prototype.reparentChildren=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.setFragmentContext=function(context){this.context=context},TreeBuilder.prototype.parseError=function(code,args){if(this.errorHandler){var message=formatMessage(messages[code],args);this.errorHandler.error(message,this.tokenizer._inputStream.location(),code)}},TreeBuilder.prototype.resetInsertionMode=function(){for(var last=!1,node=null,i=this.openElements.length-1;i>=0;i--){if(node=this.openElements.item(i),0===i&&(assert.ok(this.context),last=!0,node=new StackItem(\"http://www.w3.org/1999/xhtml\",this.context,[],null)),\"http://www.w3.org/1999/xhtml\"===node.namespaceURI){if(\"select\"===node.localName)return this.setInsertionMode(\"inSelect\");if(\"td\"===node.localName||\"th\"===node.localName)return this.setInsertionMode(\"inCell\");if(\"tr\"===node.localName)return this.setInsertionMode(\"inRow\");if(\"tbody\"===node.localName||\"thead\"===node.localName||\"tfoot\"===node.localName)return this.setInsertionMode(\"inTableBody\");if(\"caption\"===node.localName)return this.setInsertionMode(\"inCaption\");if(\"colgroup\"===node.localName)return this.setInsertionMode(\"inColumnGroup\");if(\"table\"===node.localName)return this.setInsertionMode(\"inTable\");if(\"head\"===node.localName&&!last)return this.setInsertionMode(\"inHead\");if(\"body\"===node.localName)return this.setInsertionMode(\"inBody\");if(\"frameset\"===node.localName)return this.setInsertionMode(\"inFrameset\");if(\"html\"===node.localName)return this.openElements.headElement?this.setInsertionMode(\"afterHead\"):this.setInsertionMode(\"beforeHead\")}if(last)return this.setInsertionMode(\"inBody\")}},TreeBuilder.prototype.processGenericRCDATAStartTag=function(name,attributes){this.insertElement(name,attributes),this.tokenizer.setState(Tokenizer.RCDATA),this.originalInsertionMode=this.insertionModeName,this.setInsertionMode(\"text\")},TreeBuilder.prototype.processGenericRawTextStartTag=function(name,attributes){this.insertElement(name,attributes),this.tokenizer.setState(Tokenizer.RAWTEXT),this.originalInsertionMode=this.insertionModeName,this.setInsertionMode(\"text\")},TreeBuilder.prototype.adjustMathMLAttributes=function(attributes){return attributes.forEach(function(a){a.namespaceURI=\"http://www.w3.org/1998/Math/MathML\",constants.MATHMLAttributeMap[a.nodeName]&&(a.nodeName=constants.MATHMLAttributeMap[a.nodeName])}),attributes},TreeBuilder.prototype.adjustSVGTagNameCase=function(name){return constants.SVGTagMap[name]||name},TreeBuilder.prototype.adjustSVGAttributes=function(attributes){return attributes.forEach(function(a){a.namespaceURI=\"http://www.w3.org/2000/svg\",constants.SVGAttributeMap[a.nodeName]&&(a.nodeName=constants.SVGAttributeMap[a.nodeName])}),attributes},TreeBuilder.prototype.adjustForeignAttributes=function(attributes){for(var i=0;attributes.length>i;i++){var attribute=attributes[i],adjusted=constants.ForeignAttributeMap[attribute.nodeName];adjusted&&(attribute.nodeName=adjusted.localName,attribute.prefix=adjusted.prefix,attribute.namespaceURI=adjusted.namespaceURI)}return attributes},exports.TreeBuilder=TreeBuilder},{\"./ElementStack\":1,\"./StackItem\":4,\"./Tokenizer\":5,\"./constants\":7,\"./messages.json\":8,assert:13,events:16}],7:[function(_dereq_,module,exports){exports.SVGTagMap={altglyph:\"altGlyph\",altglyphdef:\"altGlyphDef\",altglyphitem:\"altGlyphItem\",animatecolor:\"animateColor\",animatemotion:\"animateMotion\",animatetransform:\"animateTransform\",clippath:\"clipPath\",feblend:\"feBlend\",fecolormatrix:\"feColorMatrix\",fecomponenttransfer:\"feComponentTransfer\",fecomposite:\"feComposite\",feconvolvematrix:\"feConvolveMatrix\",fediffuselighting:\"feDiffuseLighting\",fedisplacementmap:\"feDisplacementMap\",fedistantlight:\"feDistantLight\",feflood:\"feFlood\",fefunca:\"feFuncA\",fefuncb:\"feFuncB\",fefuncg:\"feFuncG\",fefuncr:\"feFuncR\",fegaussianblur:\"feGaussianBlur\",feimage:\"feImage\",femerge:\"feMerge\",femergenode:\"feMergeNode\",femorphology:\"feMorphology\",feoffset:\"feOffset\",fepointlight:\"fePointLight\",fespecularlighting:\"feSpecularLighting\",fespotlight:\"feSpotLight\",fetile:\"feTile\",feturbulence:\"feTurbulence\",foreignobject:\"foreignObject\",glyphref:\"glyphRef\",lineargradient:\"linearGradient\",radialgradient:\"radialGradient\",textpath:\"textPath\"},exports.MATHMLAttributeMap={definitionurl:\"definitionURL\"},exports.SVGAttributeMap={attributename:\"attributeName\",attributetype:\"attributeType\",basefrequency:\"baseFrequency\",baseprofile:\"baseProfile\",calcmode:\"calcMode\",clippathunits:\"clipPathUnits\",contentscripttype:\"contentScriptType\",contentstyletype:\"contentStyleType\",diffuseconstant:\"diffuseConstant\",edgemode:\"edgeMode\",externalresourcesacequired:\"externalResourcesRequired\",filterres:\"filterRes\",filterunits:\"filterUnits\",glyphref:\"glyphRef\",gradienttransform:\"gradientTransform\",gradientunits:\"gradientUnits\",kernelmatrix:\"kernelMatrix\",kernelunitlength:\"kernelUnitLength\",keypoints:\"keyPoints\",keysplines:\"keySplines\",keytimes:\"keyTimes\",lengthadjust:\"lengthAdjust\",limitingconeangle:\"limitingConeAngle\",markerheight:\"markerHeight\",markerunits:\"markerUnits\",markerwidth:\"markerWidth\",maskcontentunits:\"maskContentUnits\",maskunits:\"maskUnits\",numoctaves:\"numOctaves\",pathlength:\"pathLength\",patterncontentunits:\"patternContentUnits\",patterntransform:\"patternTransform\",patternunits:\"patternUnits\",pointsatx:\"pointsAtX\",pointsaty:\"pointsAtY\",pointsatz:\"pointsAtZ\",preservealpha:\"preserveAlpha\",preserveaspectratio:\"preserveAspectRatio\",primitiveunits:\"primitiveUnits\",refx:\"refX\",refy:\"refY\",repeatcount:\"repeatCount\",repeatdur:\"repeatDur\",acequiredextensions:\"acequiredExtensions\",acequiredfeatures:\"acequiredFeatures\",specularconstant:\"specularConstant\",specularexponent:\"specularExponent\",spreadmethod:\"spreadMethod\",startoffset:\"startOffset\",stddeviation:\"stdDeviation\",stitchtiles:\"stitchTiles\",surfacescale:\"surfaceScale\",systemlanguage:\"systemLanguage\",tablevalues:\"tableValues\",targetx:\"targetX\",targety:\"targetY\",textlength:\"textLength\",viewbox:\"viewBox\",viewtarget:\"viewTarget\",xchannelselector:\"xChannelSelector\",ychannelselector:\"yChannelSelector\",zoomandpan:\"zoomAndPan\"},exports.ForeignAttributeMap={\"xlink:actuate\":{prefix:\"xlink\",localName:\"actuate\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:arcrole\":{prefix:\"xlink\",localName:\"arcrole\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:href\":{prefix:\"xlink\",localName:\"href\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:role\":{prefix:\"xlink\",localName:\"role\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:show\":{prefix:\"xlink\",localName:\"show\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:title\":{prefix:\"xlink\",localName:\"title\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:type\":{prefix:\"xlink\",localName:\"title\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xml:base\":{prefix:\"xml\",localName:\"base\",namespaceURI:\"http://www.w3.org/XML/1998/namespace\"},\"xml:lang\":{prefix:\"xml\",localName:\"lang\",namespaceURI:\"http://www.w3.org/XML/1998/namespace\"},\"xml:space\":{prefix:\"xml\",localName:\"space\",namespaceURI:\"http://www.w3.org/XML/1998/namespace\"},xmlns:{prefix:null,localName:\"xmlns\",namespaceURI:\"http://www.w3.org/2000/xmlns/\"},\"xmlns:xlink\":{prefix:\"xmlns\",localName:\"xlink\",namespaceURI:\"http://www.w3.org/2000/xmlns/\"}}\n},{}],8:[function(_dereq_,module){module.exports={\"null-character\":\"Null character in input stream, replaced with U+FFFD.\",\"invalid-codepoint\":\"Invalid codepoint in stream\",\"incorrectly-placed-solidus\":\"Solidus (/) incorrectly placed in tag.\",\"incorrect-cr-newline-entity\":\"Incorrect CR newline entity, replaced with LF.\",\"illegal-windows-1252-entity\":\"Entity used with illegal number (windows-1252 reference).\",\"cant-convert-numeric-entity\":\"Numeric entity couldn't be converted to character (codepoint U+{charAsInt}).\",\"invalid-numeric-entity-replaced\":\"Numeric entity represents an illegal codepoint. Expanded to the C1 controls range.\",\"numeric-entity-without-semicolon\":\"Numeric entity didn't end with ';'.\",\"expected-numeric-entity-but-got-eof\":\"Numeric entity expected. Got end of file instead.\",\"expected-numeric-entity\":\"Numeric entity expected but none found.\",\"named-entity-without-semicolon\":\"Named entity didn't end with ';'.\",\"expected-named-entity\":\"Named entity expected. Got none.\",\"attributes-in-end-tag\":\"End tag contains unexpected attributes.\",\"self-closing-flag-on-end-tag\":\"End tag contains unexpected self-closing flag.\",\"bare-less-than-sign-at-eof\":\"End of file after <.\",\"expected-tag-name-but-got-right-bracket\":\"Expected tag name. Got '>' instead.\",\"expected-tag-name-but-got-question-mark\":\"Expected tag name. Got '?' instead. (HTML doesn't support processing instructions.)\",\"expected-tag-name\":\"Expected tag name. Got something else instead.\",\"expected-closing-tag-but-got-right-bracket\":\"Expected closing tag. Got '>' instead. Ignoring '</>'.\",\"expected-closing-tag-but-got-eof\":\"Expected closing tag. Unexpected end of file.\",\"expected-closing-tag-but-got-char\":\"Expected closing tag. Unexpected character '{data}' found.\",\"eof-in-tag-name\":\"Unexpected end of file in the tag name.\",\"expected-attribute-name-but-got-eof\":\"Unexpected end of file. Expected attribute name instead.\",\"eof-in-attribute-name\":\"Unexpected end of file in attribute name.\",\"invalid-character-in-attribute-name\":\"Invalid character in attribute name.\",\"duplicate-attribute\":\"Dropped duplicate attribute '{name}' on tag.\",\"expected-end-of-tag-but-got-eof\":\"Unexpected end of file. Expected = or end of tag.\",\"expected-attribute-value-but-got-eof\":\"Unexpected end of file. Expected attribute value.\",\"expected-attribute-value-but-got-right-bracket\":\"Expected attribute value. Got '>' instead.\",\"unexpected-character-in-unquoted-attribute-value\":\"Unexpected character in unquoted attribute\",\"invalid-character-after-attribute-name\":\"Unexpected character after attribute name.\",\"unexpected-character-after-attribute-value\":\"Unexpected character after attribute value.\",\"eof-in-attribute-value-double-quote\":'Unexpected end of file in attribute value (\").',\"eof-in-attribute-value-single-quote\":\"Unexpected end of file in attribute value (').\",\"eof-in-attribute-value-no-quotes\":\"Unexpected end of file in attribute value.\",\"eof-after-attribute-value\":\"Unexpected end of file after attribute value.\",\"unexpected-eof-after-solidus-in-tag\":\"Unexpected end of file in tag. Expected >.\",\"unexpected-character-after-solidus-in-tag\":\"Unexpected character after / in tag. Expected >.\",\"expected-dashes-or-doctype\":\"Expected '--' or 'DOCTYPE'. Not found.\",\"unexpected-bang-after-double-dash-in-comment\":\"Unexpected ! after -- in comment.\",\"incorrect-comment\":\"Incorrect comment.\",\"eof-in-comment\":\"Unexpected end of file in comment.\",\"eof-in-comment-end-dash\":\"Unexpected end of file in comment (-).\",\"unexpected-dash-after-double-dash-in-comment\":\"Unexpected '-' after '--' found in comment.\",\"eof-in-comment-double-dash\":\"Unexpected end of file in comment (--).\",\"eof-in-comment-end-bang-state\":\"Unexpected end of file in comment.\",\"unexpected-char-in-comment\":\"Unexpected character in comment found.\",\"need-space-after-doctype\":\"No space after literal string 'DOCTYPE'.\",\"expected-doctype-name-but-got-right-bracket\":\"Unexpected > character. Expected DOCTYPE name.\",\"expected-doctype-name-but-got-eof\":\"Unexpected end of file. Expected DOCTYPE name.\",\"eof-in-doctype-name\":\"Unexpected end of file in DOCTYPE name.\",\"eof-in-doctype\":\"Unexpected end of file in DOCTYPE.\",\"expected-space-or-right-bracket-in-doctype\":\"Expected space or '>'. Got '{data}'.\",\"unexpected-end-of-doctype\":\"Unexpected end of DOCTYPE.\",\"unexpected-char-in-doctype\":\"Unexpected character in DOCTYPE.\",\"eof-in-bogus-doctype\":\"Unexpected end of file in bogus doctype.\",\"eof-in-innerhtml\":\"Unexpected EOF in inner html mode.\",\"unexpected-doctype\":\"Unexpected DOCTYPE. Ignored.\",\"non-html-root\":\"html needs to be the first start tag.\",\"expected-doctype-but-got-eof\":\"Unexpected End of file. Expected DOCTYPE.\",\"unknown-doctype\":\"Erroneous DOCTYPE. Expected <!DOCTYPE html>.\",\"quirky-doctype\":\"Quirky doctype. Expected <!DOCTYPE html>.\",\"almost-standards-doctype\":\"Almost standards mode doctype. Expected <!DOCTYPE html>.\",\"obsolete-doctype\":\"Obsolete doctype. Expected <!DOCTYPE html>.\",\"expected-doctype-but-got-chars\":\"Non-space characters found without seeing a doctype first. Expected e.g. <!DOCTYPE html>.\",\"expected-doctype-but-got-start-tag\":\"Start tag seen without seeing a doctype first. Expected e.g. <!DOCTYPE html>.\",\"expected-doctype-but-got-end-tag\":\"End tag seen without seeing a doctype first. Expected e.g. <!DOCTYPE html>.\",\"end-tag-after-implied-root\":\"Unexpected end tag ({name}) after the (implied) root element.\",\"expected-named-closing-tag-but-got-eof\":\"Unexpected end of file. Expected end tag ({name}).\",\"two-heads-are-not-better-than-one\":\"Unexpected start tag head in existing head. Ignored.\",\"unexpected-end-tag\":\"Unexpected end tag ({name}). Ignored.\",\"unexpected-implied-end-tag\":\"End tag {name} implied, but there were open elements.\",\"unexpected-start-tag-out-of-my-head\":\"Unexpected start tag ({name}) that can be in head. Moved.\",\"unexpected-start-tag\":\"Unexpected start tag ({name}).\",\"missing-end-tag\":\"Missing end tag ({name}).\",\"missing-end-tags\":\"Missing end tags ({name}).\",\"unexpected-start-tag-implies-end-tag\":\"Unexpected start tag ({startName}) implies end tag ({endName}).\",\"unexpected-start-tag-treated-as\":\"Unexpected start tag ({originalName}). Treated as {newName}.\",\"deprecated-tag\":\"Unexpected start tag {name}. Don't use it!\",\"unexpected-start-tag-ignored\":\"Unexpected start tag {name}. Ignored.\",\"expected-one-end-tag-but-got-another\":\"Unexpected end tag ({gotName}). Missing end tag ({expectedName}).\",\"end-tag-too-early\":\"End tag ({name}) seen too early. Expected other end tag.\",\"end-tag-too-early-named\":\"Unexpected end tag ({gotName}). Expected end tag ({expectedName}.\",\"end-tag-too-early-ignored\":\"End tag ({name}) seen too early. Ignored.\",\"adoption-agency-1.1\":\"End tag ({name}) violates step 1, paragraph 1 of the adoption agency algorithm.\",\"adoption-agency-1.2\":\"End tag ({name}) violates step 1, paragraph 2 of the adoption agency algorithm.\",\"adoption-agency-1.3\":\"End tag ({name}) violates step 1, paragraph 3 of the adoption agency algorithm.\",\"adoption-agency-4.4\":\"End tag ({name}) violates step 4, paragraph 4 of the adoption agency algorithm.\",\"unexpected-end-tag-treated-as\":\"Unexpected end tag ({originalName}). Treated as {newName}.\",\"no-end-tag\":\"This element ({name}) has no end tag.\",\"unexpected-implied-end-tag-in-table\":\"Unexpected implied end tag ({name}) in the table phase.\",\"unexpected-implied-end-tag-in-table-body\":\"Unexpected implied end tag ({name}) in the table body phase.\",\"unexpected-char-implies-table-voodoo\":\"Unexpected non-space characters in table context caused voodoo mode.\",\"unexpected-hidden-input-in-table\":\"Unexpected input with type hidden in table context.\",\"unexpected-form-in-table\":\"Unexpected form in table context.\",\"unexpected-start-tag-implies-table-voodoo\":\"Unexpected start tag ({name}) in table context caused voodoo mode.\",\"unexpected-end-tag-implies-table-voodoo\":\"Unexpected end tag ({name}) in table context caused voodoo mode.\",\"unexpected-cell-in-table-body\":\"Unexpected table cell start tag ({name}) in the table body phase.\",\"unexpected-cell-end-tag\":\"Got table cell end tag ({name}) while acequired end tags are missing.\",\"unexpected-end-tag-in-table-body\":\"Unexpected end tag ({name}) in the table body phase. Ignored.\",\"unexpected-implied-end-tag-in-table-row\":\"Unexpected implied end tag ({name}) in the table row phase.\",\"unexpected-end-tag-in-table-row\":\"Unexpected end tag ({name}) in the table row phase. Ignored.\",\"unexpected-select-in-select\":\"Unexpected select start tag in the select phase treated as select end tag.\",\"unexpected-input-in-select\":\"Unexpected input start tag in the select phase.\",\"unexpected-start-tag-in-select\":\"Unexpected start tag token ({name}) in the select phase. Ignored.\",\"unexpected-end-tag-in-select\":\"Unexpected end tag ({name}) in the select phase. Ignored.\",\"unexpected-table-element-start-tag-in-select-in-table\":\"Unexpected table element start tag ({name}) in the select in table phase.\",\"unexpected-table-element-end-tag-in-select-in-table\":\"Unexpected table element end tag ({name}) in the select in table phase.\",\"unexpected-char-after-body\":\"Unexpected non-space characters in the after body phase.\",\"unexpected-start-tag-after-body\":\"Unexpected start tag token ({name}) in the after body phase.\",\"unexpected-end-tag-after-body\":\"Unexpected end tag token ({name}) in the after body phase.\",\"unexpected-char-in-frameset\":\"Unepxected characters in the frameset phase. Characters ignored.\",\"unexpected-start-tag-in-frameset\":\"Unexpected start tag token ({name}) in the frameset phase. Ignored.\",\"unexpected-frameset-in-frameset-innerhtml\":\"Unexpected end tag token (frameset in the frameset phase (innerHTML).\",\"unexpected-end-tag-in-frameset\":\"Unexpected end tag token ({name}) in the frameset phase. Ignored.\",\"unexpected-char-after-frameset\":\"Unexpected non-space characters in the after frameset phase. Ignored.\",\"unexpected-start-tag-after-frameset\":\"Unexpected start tag ({name}) in the after frameset phase. Ignored.\",\"unexpected-end-tag-after-frameset\":\"Unexpected end tag ({name}) in the after frameset phase. Ignored.\",\"expected-eof-but-got-char\":\"Unexpected non-space characters. Expected end of file.\",\"expected-eof-but-got-start-tag\":\"Unexpected start tag ({name}). Expected end of file.\",\"expected-eof-but-got-end-tag\":\"Unexpected end tag ({name}). Expected end of file.\",\"unexpected-end-table-in-caption\":\"Unexpected end table tag in caption. Generates implied end caption.\",\"end-html-in-innerhtml\":\"Unexpected html end tag in inner html mode.\",\"eof-in-table\":\"Unexpected end of file. Expected table content.\",\"eof-in-script\":\"Unexpected end of file. Expected script content.\",\"non-void-element-with-trailing-solidus\":\"Trailing solidus not allowed on element {name}.\",\"unexpected-html-element-in-foreign-content\":'HTML start tag \"{name}\" in a foreign namespace context.',\"unexpected-start-tag-in-table\":\"Unexpected {name}. Expected table content.\"}},{}],9:[function(_dereq_,module,exports){function SAXParser(){this.contentHandler=null,this._errorHandler=null,this._treeBuilder=new SAXTreeBuilder,this._tokenizer=new Tokenizer(this._treeBuilder),this._scriptingEnabled=!1}var SAXTreeBuilder=_dereq_(\"./SAXTreeBuilder\").SAXTreeBuilder,Tokenizer=_dereq_(\"../Tokenizer\").Tokenizer,TreeParser=_dereq_(\"./TreeParser\").TreeParser;SAXParser.prototype.parse=function(source){this._tokenizer.tokenize(source);var document=this._treeBuilder.document;document&&new TreeParser(this.contentHandler).parse(document)},SAXParser.prototype.parseFragment=function(source,context){this._treeBuilder.setFragmentContext(context),this._tokenizer.tokenize(source);var fragment=this._treeBuilder.getFragment();fragment&&new TreeParser(this.contentHandler).parse(fragment)},Object.defineProperty(SAXParser.prototype,\"scriptingEnabled\",{get:function(){return this._scriptingEnabled},set:function(value){this._scriptingEnabled=value,this._treeBuilder.scriptingEnabled=value}}),Object.defineProperty(SAXParser.prototype,\"errorHandler\",{get:function(){return this._errorHandler},set:function(value){this._errorHandler=value,this._treeBuilder.errorHandler=value}}),exports.SAXParser=SAXParser},{\"../Tokenizer\":5,\"./SAXTreeBuilder\":10,\"./TreeParser\":11}],10:[function(_dereq_,module,exports){function SAXTreeBuilder(){TreeBuilder.call(this)}function getAttribute(node,name){for(var i=0;node.attributes.length>i;i++){var attribute=node.attributes[i];if(attribute.nodeName===name)return attribute.nodeValue}}function Node(locator){locator?(this.columnNumber=locator.columnNumber,this.lineNumber=locator.lineNumber):(this.columnNumber=-1,this.lineNumber=-1),this.parentNode=null,this.nextSibling=null,this.firstChild=null}function ParentNode(locator){Node.call(this,locator),this.lastChild=null,this._endLocator=null}function Document(locator){ParentNode.call(this,locator),this.nodeType=NodeType.DOCUMENT}function DocumentFragment(){ParentNode.call(this,new Locator),this.nodeType=NodeType.DOCUMENT_FRAGMENT}function Element(locator,uri,localName,qName,atts,prefixMappings){ParentNode.call(this,locator),this.uri=uri,this.localName=localName,this.qName=qName,this.attributes=atts,this.prefixMappings=prefixMappings,this.nodeType=NodeType.ELEMENT}function Characters(locator,data){Node.call(this,locator),this.data=data,this.nodeType=NodeType.CHARACTERS}function IgnorableWhitespace(locator,data){Node.call(this,locator),this.data=data,this.nodeType=NodeType.IGNORABLE_WHITESPACE}function Comment(locator,data){Node.call(this,locator),this.data=data,this.nodeType=NodeType.COMMENT}function CDATA(locator){ParentNode.call(this,locator),this.nodeType=NodeType.CDATA}function Entity(name){ParentNode.call(this),this.name=name,this.nodeType=NodeType.ENTITY}function SkippedEntity(name){Node.call(this),this.name=name,this.nodeType=NodeType.SKIPPED_ENTITY}function ProcessingInstruction(target,data){Node.call(this),this.target=target,this.data=data}function DTD(name,publicIdentifier,systemIdentifier){ParentNode.call(this),this.name=name,this.publicIdentifier=publicIdentifier,this.systemIdentifier=systemIdentifier,this.nodeType=NodeType.DTD}var util=_dereq_(\"util\"),TreeBuilder=_dereq_(\"../TreeBuilder\").TreeBuilder;util.inherits(SAXTreeBuilder,TreeBuilder),SAXTreeBuilder.prototype.start=function(){this.document=new Document(this.tokenizer)},SAXTreeBuilder.prototype.end=function(){this.document.endLocator=this.tokenizer},SAXTreeBuilder.prototype.insertDoctype=function(name,publicId,systemId){var doctype=new DTD(this.tokenizer,name,publicId,systemId);doctype.endLocator=this.tokenizer,this.document.appendChild(doctype)},SAXTreeBuilder.prototype.createElement=function(namespaceURI,localName,attributes){var element=new Element(this.tokenizer,namespaceURI,localName,localName,attributes||[]);return element},SAXTreeBuilder.prototype.insertComment=function(data,parent){parent||(parent=this.currentStackItem());var comment=new Comment(this.tokenizer,data);parent.appendChild(comment)},SAXTreeBuilder.prototype.appendCharacters=function(parent,data){var text=new Characters(this.tokenizer,data);parent.appendChild(text)},SAXTreeBuilder.prototype.insertText=function(data){if(this.redirectAttachToFosterParent&&this.openElements.top.isFosterParenting()){var tableIndex=this.openElements.findIndex(\"table\"),tableItem=this.openElements.item(tableIndex),table=tableItem.node;if(0===tableIndex)return this.appendCharacters(table,data);var text=new Characters(this.tokenizer,data),parent=table.parentNode;if(parent)return parent.insertBetween(text,table.previousSibling,table),void 0;var stackParent=this.openElements.item(tableIndex-1).node;return stackParent.appendChild(text),void 0}this.appendCharacters(this.currentStackItem().node,data)},SAXTreeBuilder.prototype.attachNode=function(node,parent){parent.appendChild(node)},SAXTreeBuilder.prototype.attachNodeToFosterParent=function(child,table,stackParent){var parent=table.parentNode;parent?parent.insertBetween(child,table.previousSibling,table):stackParent.appendChild(child)},SAXTreeBuilder.prototype.detachFromParent=function(element){element.detach()},SAXTreeBuilder.prototype.reparentChildren=function(oldParent,newParent){newParent.appendChildren(oldParent.firstChild)},SAXTreeBuilder.prototype.getFragment=function(){var fragment=new DocumentFragment;return this.reparentChildren(this.openElements.rootNode,fragment),fragment},SAXTreeBuilder.prototype.addAttributesToElement=function(element,attributes){for(var i=0;attributes.length>i;i++){var attribute=attributes[i];getAttribute(element,attribute.nodeName)||element.attributes.push(attribute)}};var NodeType={CDATA:1,CHARACTERS:2,COMMENT:3,DOCUMENT:4,DOCUMENT_FRAGMENT:5,DTD:6,ELEMENT:7,ENTITY:8,IGNORABLE_WHITESPACE:9,PROCESSING_INSTRUCTION:10,SKIPPED_ENTITY:11};Node.prototype.visit=function(){throw Error(\"Not Implemented\")},Node.prototype.revisit=function(){},Node.prototype.detach=function(){null!==this.parentNode&&(this.parentNode.removeChild(this),this.parentNode=null)},Object.defineProperty(Node.prototype,\"previousSibling\",{get:function(){for(var prev=null,next=this.parentNode.firstChild;;){if(this==next)return prev;prev=next,next=next.nextSibling}}}),ParentNode.prototype=Object.create(Node.prototype),ParentNode.prototype.insertBefore=function(child,sibling){if(!sibling)return this.appendChild(child);if(child.detach(),child.parentNode=this,this.firstChild==sibling)child.nextSibling=sibling,this.firstChild=child;else{for(var prev=this.firstChild,next=this.firstChild.nextSibling;next!=sibling;)prev=next,next=next.nextSibling;prev.nextSibling=child,child.nextSibling=next}return child},ParentNode.prototype.insertBetween=function(child,prev,next){return next?(child.detach(),child.parentNode=this,child.nextSibling=next,prev?prev.nextSibling=child:firstChild=child,child):this.appendChild(child)},ParentNode.prototype.appendChild=function(child){return child.detach(),child.parentNode=this,this.firstChild?this.lastChild.nextSibling=child:this.firstChild=child,this.lastChild=child,child},ParentNode.prototype.appendChildren=function(parent){var child=parent.firstChild;if(child){var another=parent;this.firstChild?this.lastChild.nextSibling=child:this.firstChild=child,this.lastChild=another.lastChild;do child.parentNode=this;while(child=child.nextSibling);another.firstChild=null,another.lastChild=null}},ParentNode.prototype.removeChild=function(node){if(this.firstChild==node)this.firstChild=node.nextSibling,this.lastChild==node&&(this.lastChild=null);else{for(var prev=this.firstChild,next=this.firstChild.nextSibling;next!=node;)prev=next,next=next.nextSibling;prev.nextSibling=node.nextSibling,this.lastChild==node&&(this.lastChild=prev)}return node.parentNode=null,node},Object.defineProperty(ParentNode.prototype,\"endLocator\",{get:function(){return this._endLocator},set:function(endLocator){this._endLocator={lineNumber:endLocator.lineNumber,columnNumber:endLocator.columnNumber}}}),Document.prototype=Object.create(ParentNode.prototype),Document.prototype.visit=function(treeParser){treeParser.startDocument(this)},Document.prototype.revisit=function(treeParser){treeParser.endDocument(this.endLocator)},DocumentFragment.prototype=Object.create(ParentNode.prototype),DocumentFragment.prototype.visit=function(){},Element.prototype=Object.create(ParentNode.prototype),Element.prototype.visit=function(treeParser){if(this.prefixMappings)for(var key in prefixMappings){var mapping=prefixMappings[key];treeParser.startPrefixMapping(mapping.getPrefix(),mapping.getUri(),this)}treeParser.startElement(this.uri,this.localName,this.qName,this.attributes,this)},Element.prototype.revisit=function(treeParser){if(treeParser.endElement(this.uri,this.localName,this.qName,this.endLocator),this.prefixMappings)for(var key in prefixMappings){var mapping=prefixMappings[key];treeParser.endPrefixMapping(mapping.getPrefix(),this.endLocator)}},Characters.prototype=Object.create(Node.prototype),Characters.prototype.visit=function(treeParser){treeParser.characters(this.data,0,this.data.length,this)},IgnorableWhitespace.prototype=Object.create(Node.prototype),IgnorableWhitespace.prototype.visit=function(treeParser){treeParser.ignorableWhitespace(this.data,0,this.data.length,this)},Comment.prototype=Object.create(Node.prototype),Comment.prototype.visit=function(treeParser){treeParser.comment(this.data,0,this.data.length,this)},CDATA.prototype=Object.create(ParentNode.prototype),CDATA.prototype.visit=function(treeParser){treeParser.startCDATA(this)},CDATA.prototype.revisit=function(treeParser){treeParser.endCDATA(this.endLocator)},Entity.prototype=Object.create(ParentNode.prototype),Entity.prototype.visit=function(treeParser){treeParser.startEntity(this.name,this)},Entity.prototype.revisit=function(treeParser){treeParser.endEntity(this.name)},SkippedEntity.prototype=Object.create(Node.prototype),SkippedEntity.prototype.visit=function(treeParser){treeParser.skippedEntity(this.name,this)},ProcessingInstruction.prototype=Object.create(Node.prototype),ProcessingInstruction.prototype.visit=function(treeParser){treeParser.processingInstruction(this.target,this.data,this)},ProcessingInstruction.prototype.getNodeType=function(){return NodeType.PROCESSING_INSTRUCTION},DTD.prototype=Object.create(ParentNode.prototype),DTD.prototype.visit=function(treeParser){treeParser.startDTD(this.name,this.publicIdentifier,this.systemIdentifier,this)},DTD.prototype.revisit=function(treeParser){treeParser.endDTD()},exports.SAXTreeBuilder=SAXTreeBuilder},{\"../TreeBuilder\":6,util:20}],11:[function(_dereq_,module,exports){function TreeParser(contentHandler,lexicalHandler){if(this.contentHandler,this.lexicalHandler,this.locatorDelegate,!contentHandler)throw new IllegalArgumentException(\"contentHandler was null.\");this.contentHandler=contentHandler,this.lexicalHandler=lexicalHandler?lexicalHandler:new NullLexicalHandler}function NullLexicalHandler(){}TreeParser.prototype.parse=function(node){this.contentHandler.documentLocator=this;for(var next,current=node;;)if(current.visit(this),next=current.firstChild)current=next;else for(;;){if(current.revisit(this),current==node)return;if(next=current.nextSibling){current=next;break}current=current.parentNode}},TreeParser.prototype.characters=function(ch,start,length,locator){this.locatorDelegate=locator,this.contentHandler.characters(ch,start,length)},TreeParser.prototype.endDocument=function(locator){this.locatorDelegate=locator,this.contentHandler.endDocument()},TreeParser.prototype.endElement=function(uri,localName,qName,locator){this.locatorDelegate=locator,this.contentHandler.endElement(uri,localName,qName)},TreeParser.prototype.endPrefixMapping=function(prefix,locator){this.locatorDelegate=locator,this.contentHandler.endPrefixMapping(prefix)},TreeParser.prototype.ignorableWhitespace=function(ch,start,length,locator){this.locatorDelegate=locator,this.contentHandler.ignorableWhitespace(ch,start,length)},TreeParser.prototype.processingInstruction=function(target,data,locator){this.locatorDelegate=locator,this.contentHandler.processingInstruction(target,data)},TreeParser.prototype.skippedEntity=function(name,locator){this.locatorDelegate=locator,this.contentHandler.skippedEntity(name)},TreeParser.prototype.startDocument=function(locator){this.locatorDelegate=locator,this.contentHandler.startDocument()},TreeParser.prototype.startElement=function(uri,localName,qName,atts,locator){this.locatorDelegate=locator,this.contentHandler.startElement(uri,localName,qName,atts)},TreeParser.prototype.startPrefixMapping=function(prefix,uri,locator){this.locatorDelegate=locator,this.contentHandler.startPrefixMapping(prefix,uri)},TreeParser.prototype.comment=function(ch,start,length,locator){this.locatorDelegate=locator,this.lexicalHandler.comment(ch,start,length)},TreeParser.prototype.endCDATA=function(locator){this.locatorDelegate=locator,this.lexicalHandler.endCDATA()},TreeParser.prototype.endDTD=function(locator){this.locatorDelegate=locator,this.lexicalHandler.endDTD()},TreeParser.prototype.endEntity=function(name,locator){this.locatorDelegate=locator,this.lexicalHandler.endEntity(name)},TreeParser.prototype.startCDATA=function(locator){this.locatorDelegate=locator,this.lexicalHandler.startCDATA()},TreeParser.prototype.startDTD=function(name,publicId,systemId,locator){this.locatorDelegate=locator,this.lexicalHandler.startDTD(name,publicId,systemId)},TreeParser.prototype.startEntity=function(name,locator){this.locatorDelegate=locator,this.lexicalHandler.startEntity(name)},Object.defineProperty(TreeParser.prototype,\"columnNumber\",{get:function(){return this.locatorDelegate?this.locatorDelegate.columnNumber:-1}}),Object.defineProperty(TreeParser.prototype,\"lineNumber\",{get:function(){return this.locatorDelegate?this.locatorDelegate.lineNumber:-1}}),NullLexicalHandler.prototype.comment=function(){},NullLexicalHandler.prototype.endCDATA=function(){},NullLexicalHandler.prototype.endDTD=function(){},NullLexicalHandler.prototype.endEntity=function(){},NullLexicalHandler.prototype.startCDATA=function(){},NullLexicalHandler.prototype.startDTD=function(){},NullLexicalHandler.prototype.startEntity=function(){},exports.TreeParser=TreeParser},{}],12:[function(_dereq_,module){module.exports={\"Aacute;\":\"Á\",Aacute:\"Á\",\"aacute;\":\"á\",aacute:\"á\",\"Abreve;\":\"Ă\",\"abreve;\":\"ă\",\"ac;\":\"∾\",\"acd;\":\"∿\",\"acE;\":\"∾̳\",\"Acirc;\":\"Â\",Acirc:\"Â\",\"acirc;\":\"â\",acirc:\"â\",\"acute;\":\"´\",acute:\"´\",\"Acy;\":\"А\",\"acy;\":\"а\",\"AElig;\":\"Æ\",AElig:\"Æ\",\"aelig;\":\"æ\",aelig:\"æ\",\"af;\":\"⁡\",\"Afr;\":\"𝔄\",\"afr;\":\"𝔞\",\"Agrave;\":\"À\",Agrave:\"À\",\"agrave;\":\"à\",agrave:\"à\",\"alefsym;\":\"ℵ\",\"aleph;\":\"ℵ\",\"Alpha;\":\"Α\",\"alpha;\":\"α\",\"Amacr;\":\"Ā\",\"amacr;\":\"ā\",\"amalg;\":\"⨿\",\"amp;\":\"&\",amp:\"&\",\"AMP;\":\"&\",AMP:\"&\",\"andand;\":\"⩕\",\"And;\":\"⩓\",\"and;\":\"∧\",\"andd;\":\"⩜\",\"andslope;\":\"⩘\",\"andv;\":\"⩚\",\"ang;\":\"∠\",\"ange;\":\"⦤\",\"angle;\":\"∠\",\"angmsdaa;\":\"⦨\",\"angmsdab;\":\"⦩\",\"angmsdac;\":\"⦪\",\"angmsdad;\":\"⦫\",\"angmsdae;\":\"⦬\",\"angmsdaf;\":\"⦭\",\"angmsdag;\":\"⦮\",\"angmsdah;\":\"⦯\",\"angmsd;\":\"∡\",\"angrt;\":\"∟\",\"angrtvb;\":\"⊾\",\"angrtvbd;\":\"⦝\",\"angsph;\":\"∢\",\"angst;\":\"Å\",\"angzarr;\":\"⍼\",\"Aogon;\":\"Ą\",\"aogon;\":\"ą\",\"Aopf;\":\"𝔸\",\"aopf;\":\"𝕒\",\"apacir;\":\"⩯\",\"ap;\":\"≈\",\"apE;\":\"⩰\",\"ape;\":\"≊\",\"apid;\":\"≋\",\"apos;\":\"'\",\"ApplyFunction;\":\"⁡\",\"approx;\":\"≈\",\"approxeq;\":\"≊\",\"Aring;\":\"Å\",Aring:\"Å\",\"aring;\":\"å\",aring:\"å\",\"Ascr;\":\"𝒜\",\"ascr;\":\"𝒶\",\"Assign;\":\"≔\",\"ast;\":\"*\",\"asymp;\":\"≈\",\"asympeq;\":\"≍\",\"Atilde;\":\"Ã\",Atilde:\"Ã\",\"atilde;\":\"ã\",atilde:\"ã\",\"Auml;\":\"Ä\",Auml:\"Ä\",\"auml;\":\"ä\",auml:\"ä\",\"awconint;\":\"∳\",\"awint;\":\"⨑\",\"backcong;\":\"≌\",\"backepsilon;\":\"϶\",\"backprime;\":\"‵\",\"backsim;\":\"∽\",\"backsimeq;\":\"⋍\",\"Backslash;\":\"∖\",\"Barv;\":\"⫧\",\"barvee;\":\"⊽\",\"barwed;\":\"⌅\",\"Barwed;\":\"⌆\",\"barwedge;\":\"⌅\",\"bbrk;\":\"⎵\",\"bbrktbrk;\":\"⎶\",\"bcong;\":\"≌\",\"Bcy;\":\"Б\",\"bcy;\":\"б\",\"bdquo;\":\"„\",\"becaus;\":\"∵\",\"because;\":\"∵\",\"Because;\":\"∵\",\"bemptyv;\":\"⦰\",\"bepsi;\":\"϶\",\"bernou;\":\"ℬ\",\"Bernoullis;\":\"ℬ\",\"Beta;\":\"Β\",\"beta;\":\"β\",\"beth;\":\"ℶ\",\"between;\":\"≬\",\"Bfr;\":\"𝔅\",\"bfr;\":\"𝔟\",\"bigcap;\":\"⋂\",\"bigcirc;\":\"◯\",\"bigcup;\":\"⋃\",\"bigodot;\":\"⨀\",\"bigoplus;\":\"⨁\",\"bigotimes;\":\"⨂\",\"bigsqcup;\":\"⨆\",\"bigstar;\":\"★\",\"bigtriangledown;\":\"▽\",\"bigtriangleup;\":\"△\",\"biguplus;\":\"⨄\",\"bigvee;\":\"⋁\",\"bigwedge;\":\"⋀\",\"bkarow;\":\"⤍\",\"blacklozenge;\":\"⧫\",\"blacksquare;\":\"▪\",\"blacktriangle;\":\"▴\",\"blacktriangledown;\":\"▾\",\"blacktriangleleft;\":\"◂\",\"blacktriangleright;\":\"▸\",\"blank;\":\"␣\",\"blk12;\":\"▒\",\"blk14;\":\"░\",\"blk34;\":\"▓\",\"block;\":\"█\",\"bne;\":\"=⃥\",\"bnequiv;\":\"≡⃥\",\"bNot;\":\"⫭\",\"bnot;\":\"⌐\",\"Bopf;\":\"𝔹\",\"bopf;\":\"𝕓\",\"bot;\":\"⊥\",\"bottom;\":\"⊥\",\"bowtie;\":\"⋈\",\"boxbox;\":\"⧉\",\"boxdl;\":\"┐\",\"boxdL;\":\"╕\",\"boxDl;\":\"╖\",\"boxDL;\":\"╗\",\"boxdr;\":\"┌\",\"boxdR;\":\"╒\",\"boxDr;\":\"╓\",\"boxDR;\":\"╔\",\"boxh;\":\"─\",\"boxH;\":\"═\",\"boxhd;\":\"┬\",\"boxHd;\":\"╤\",\"boxhD;\":\"╥\",\"boxHD;\":\"╦\",\"boxhu;\":\"┴\",\"boxHu;\":\"╧\",\"boxhU;\":\"╨\",\"boxHU;\":\"╩\",\"boxminus;\":\"⊟\",\"boxplus;\":\"⊞\",\"boxtimes;\":\"⊠\",\"boxul;\":\"┘\",\"boxuL;\":\"╛\",\"boxUl;\":\"╜\",\"boxUL;\":\"╝\",\"boxur;\":\"└\",\"boxuR;\":\"╘\",\"boxUr;\":\"╙\",\"boxUR;\":\"╚\",\"boxv;\":\"│\",\"boxV;\":\"║\",\"boxvh;\":\"┼\",\"boxvH;\":\"╪\",\"boxVh;\":\"╫\",\"boxVH;\":\"╬\",\"boxvl;\":\"┤\",\"boxvL;\":\"╡\",\"boxVl;\":\"╢\",\"boxVL;\":\"╣\",\"boxvr;\":\"├\",\"boxvR;\":\"╞\",\"boxVr;\":\"╟\",\"boxVR;\":\"╠\",\"bprime;\":\"‵\",\"breve;\":\"˘\",\"Breve;\":\"˘\",\"brvbar;\":\"¦\",brvbar:\"¦\",\"bscr;\":\"𝒷\",\"Bscr;\":\"ℬ\",\"bsemi;\":\"⁏\",\"bsim;\":\"∽\",\"bsime;\":\"⋍\",\"bsolb;\":\"⧅\",\"bsol;\":\"\\\\\",\"bsolhsub;\":\"⟈\",\"bull;\":\"•\",\"bullet;\":\"•\",\"bump;\":\"≎\",\"bumpE;\":\"⪮\",\"bumpe;\":\"≏\",\"Bumpeq;\":\"≎\",\"bumpeq;\":\"≏\",\"Cacute;\":\"Ć\",\"cacute;\":\"ć\",\"capand;\":\"⩄\",\"capbrcup;\":\"⩉\",\"capcap;\":\"⩋\",\"cap;\":\"∩\",\"Cap;\":\"⋒\",\"capcup;\":\"⩇\",\"capdot;\":\"⩀\",\"CapitalDifferentialD;\":\"ⅅ\",\"caps;\":\"∩︀\",\"caret;\":\"⁁\",\"caron;\":\"ˇ\",\"Cayleys;\":\"ℭ\",\"ccaps;\":\"⩍\",\"Ccaron;\":\"Č\",\"ccaron;\":\"č\",\"Ccedil;\":\"Ç\",Ccedil:\"Ç\",\"ccedil;\":\"ç\",ccedil:\"ç\",\"Ccirc;\":\"Ĉ\",\"ccirc;\":\"ĉ\",\"Cconint;\":\"∰\",\"ccups;\":\"⩌\",\"ccupssm;\":\"⩐\",\"Cdot;\":\"Ċ\",\"cdot;\":\"ċ\",\"cedil;\":\"¸\",cedil:\"¸\",\"Cedilla;\":\"¸\",\"cemptyv;\":\"⦲\",\"cent;\":\"¢\",cent:\"¢\",\"centerdot;\":\"·\",\"CenterDot;\":\"·\",\"cfr;\":\"𝔠\",\"Cfr;\":\"ℭ\",\"CHcy;\":\"Ч\",\"chcy;\":\"ч\",\"check;\":\"✓\",\"checkmark;\":\"✓\",\"Chi;\":\"Χ\",\"chi;\":\"χ\",\"circ;\":\"ˆ\",\"circeq;\":\"≗\",\"circlearrowleft;\":\"↺\",\"circlearrowright;\":\"↻\",\"circledast;\":\"⊛\",\"circledcirc;\":\"⊚\",\"circleddash;\":\"⊝\",\"CircleDot;\":\"⊙\",\"circledR;\":\"®\",\"circledS;\":\"Ⓢ\",\"CircleMinus;\":\"⊖\",\"CirclePlus;\":\"⊕\",\"CircleTimes;\":\"⊗\",\"cir;\":\"○\",\"cirE;\":\"⧃\",\"cire;\":\"≗\",\"cirfnint;\":\"⨐\",\"cirmid;\":\"⫯\",\"cirscir;\":\"⧂\",\"ClockwiseContourIntegral;\":\"∲\",\"CloseCurlyDoubleQuote;\":\"”\",\"CloseCurlyQuote;\":\"’\",\"clubs;\":\"♣\",\"clubsuit;\":\"♣\",\"colon;\":\":\",\"Colon;\":\"∷\",\"Colone;\":\"⩴\",\"colone;\":\"≔\",\"coloneq;\":\"≔\",\"comma;\":\",\",\"commat;\":\"@\",\"comp;\":\"∁\",\"compfn;\":\"∘\",\"complement;\":\"∁\",\"complexes;\":\"ℂ\",\"cong;\":\"≅\",\"congdot;\":\"⩭\",\"Congruent;\":\"≡\",\"conint;\":\"∮\",\"Conint;\":\"∯\",\"ContourIntegral;\":\"∮\",\"copf;\":\"𝕔\",\"Copf;\":\"ℂ\",\"coprod;\":\"∐\",\"Coproduct;\":\"∐\",\"copy;\":\"©\",copy:\"©\",\"COPY;\":\"©\",COPY:\"©\",\"copysr;\":\"℗\",\"CounterClockwiseContourIntegral;\":\"∳\",\"crarr;\":\"↵\",\"cross;\":\"✗\",\"Cross;\":\"⨯\",\"Cscr;\":\"𝒞\",\"cscr;\":\"𝒸\",\"csub;\":\"⫏\",\"csube;\":\"⫑\",\"csup;\":\"⫐\",\"csupe;\":\"⫒\",\"ctdot;\":\"⋯\",\"cudarrl;\":\"⤸\",\"cudarrr;\":\"⤵\",\"cuepr;\":\"⋞\",\"cuesc;\":\"⋟\",\"cularr;\":\"↶\",\"cularrp;\":\"⤽\",\"cupbrcap;\":\"⩈\",\"cupcap;\":\"⩆\",\"CupCap;\":\"≍\",\"cup;\":\"∪\",\"Cup;\":\"⋓\",\"cupcup;\":\"⩊\",\"cupdot;\":\"⊍\",\"cupor;\":\"⩅\",\"cups;\":\"∪︀\",\"curarr;\":\"↷\",\"curarrm;\":\"⤼\",\"curlyeqprec;\":\"⋞\",\"curlyeqsucc;\":\"⋟\",\"curlyvee;\":\"⋎\",\"curlywedge;\":\"⋏\",\"curren;\":\"¤\",curren:\"¤\",\"curvearrowleft;\":\"↶\",\"curvearrowright;\":\"↷\",\"cuvee;\":\"⋎\",\"cuwed;\":\"⋏\",\"cwconint;\":\"∲\",\"cwint;\":\"∱\",\"cylcty;\":\"⌭\",\"dagger;\":\"†\",\"Dagger;\":\"‡\",\"daleth;\":\"ℸ\",\"darr;\":\"↓\",\"Darr;\":\"↡\",\"dArr;\":\"⇓\",\"dash;\":\"‐\",\"Dashv;\":\"⫤\",\"dashv;\":\"⊣\",\"dbkarow;\":\"⤏\",\"dblac;\":\"˝\",\"Dcaron;\":\"Ď\",\"dcaron;\":\"ď\",\"Dcy;\":\"Д\",\"dcy;\":\"д\",\"ddagger;\":\"‡\",\"ddarr;\":\"⇊\",\"DD;\":\"ⅅ\",\"dd;\":\"ⅆ\",\"DDotrahd;\":\"⤑\",\"ddotseq;\":\"⩷\",\"deg;\":\"°\",deg:\"°\",\"Del;\":\"∇\",\"Delta;\":\"Δ\",\"delta;\":\"δ\",\"demptyv;\":\"⦱\",\"dfisht;\":\"⥿\",\"Dfr;\":\"𝔇\",\"dfr;\":\"𝔡\",\"dHar;\":\"⥥\",\"dharl;\":\"⇃\",\"dharr;\":\"⇂\",\"DiacriticalAcute;\":\"´\",\"DiacriticalDot;\":\"˙\",\"DiacriticalDoubleAcute;\":\"˝\",\"DiacriticalGrave;\":\"`\",\"DiacriticalTilde;\":\"˜\",\"diam;\":\"⋄\",\"diamond;\":\"⋄\",\"Diamond;\":\"⋄\",\"diamondsuit;\":\"♦\",\"diams;\":\"♦\",\"die;\":\"¨\",\"DifferentialD;\":\"ⅆ\",\"digamma;\":\"ϝ\",\"disin;\":\"⋲\",\"div;\":\"÷\",\"divide;\":\"÷\",divide:\"÷\",\"divideontimes;\":\"⋇\",\"divonx;\":\"⋇\",\"DJcy;\":\"Ђ\",\"djcy;\":\"ђ\",\"dlcorn;\":\"⌞\",\"dlcrop;\":\"⌍\",\"dollar;\":\"$\",\"Dopf;\":\"𝔻\",\"dopf;\":\"𝕕\",\"Dot;\":\"¨\",\"dot;\":\"˙\",\"DotDot;\":\"⃜\",\"doteq;\":\"≐\",\"doteqdot;\":\"≑\",\"DotEqual;\":\"≐\",\"dotminus;\":\"∸\",\"dotplus;\":\"∔\",\"dotsquare;\":\"⊡\",\"doublebarwedge;\":\"⌆\",\"DoubleContourIntegral;\":\"∯\",\"DoubleDot;\":\"¨\",\"DoubleDownArrow;\":\"⇓\",\"DoubleLeftArrow;\":\"⇐\",\"DoubleLeftRightArrow;\":\"⇔\",\"DoubleLeftTee;\":\"⫤\",\"DoubleLongLeftArrow;\":\"⟸\",\"DoubleLongLeftRightArrow;\":\"⟺\",\"DoubleLongRightArrow;\":\"⟹\",\"DoubleRightArrow;\":\"⇒\",\"DoubleRightTee;\":\"⊨\",\"DoubleUpArrow;\":\"⇑\",\"DoubleUpDownArrow;\":\"⇕\",\"DoubleVerticalBar;\":\"∥\",\"DownArrowBar;\":\"⤓\",\"downarrow;\":\"↓\",\"DownArrow;\":\"↓\",\"Downarrow;\":\"⇓\",\"DownArrowUpArrow;\":\"⇵\",\"DownBreve;\":\"̑\",\"downdownarrows;\":\"⇊\",\"downharpoonleft;\":\"⇃\",\"downharpoonright;\":\"⇂\",\"DownLeftRightVector;\":\"⥐\",\"DownLeftTeeVector;\":\"⥞\",\"DownLeftVectorBar;\":\"⥖\",\"DownLeftVector;\":\"↽\",\"DownRightTeeVector;\":\"⥟\",\"DownRightVectorBar;\":\"⥗\",\"DownRightVector;\":\"⇁\",\"DownTeeArrow;\":\"↧\",\"DownTee;\":\"⊤\",\"drbkarow;\":\"⤐\",\"drcorn;\":\"⌟\",\"drcrop;\":\"⌌\",\"Dscr;\":\"𝒟\",\"dscr;\":\"𝒹\",\"DScy;\":\"Ѕ\",\"dscy;\":\"ѕ\",\"dsol;\":\"⧶\",\"Dstrok;\":\"Đ\",\"dstrok;\":\"đ\",\"dtdot;\":\"⋱\",\"dtri;\":\"▿\",\"dtrif;\":\"▾\",\"duarr;\":\"⇵\",\"duhar;\":\"⥯\",\"dwangle;\":\"⦦\",\"DZcy;\":\"Џ\",\"dzcy;\":\"џ\",\"dzigrarr;\":\"⟿\",\"Eacute;\":\"É\",Eacute:\"É\",\"eacute;\":\"é\",eacute:\"é\",\"easter;\":\"⩮\",\"Ecaron;\":\"Ě\",\"ecaron;\":\"ě\",\"Ecirc;\":\"Ê\",Ecirc:\"Ê\",\"ecirc;\":\"ê\",ecirc:\"ê\",\"ecir;\":\"≖\",\"ecolon;\":\"≕\",\"Ecy;\":\"Э\",\"ecy;\":\"э\",\"eDDot;\":\"⩷\",\"Edot;\":\"Ė\",\"edot;\":\"ė\",\"eDot;\":\"≑\",\"ee;\":\"ⅇ\",\"efDot;\":\"≒\",\"Efr;\":\"𝔈\",\"efr;\":\"𝔢\",\"eg;\":\"⪚\",\"Egrave;\":\"È\",Egrave:\"È\",\"egrave;\":\"è\",egrave:\"è\",\"egs;\":\"⪖\",\"egsdot;\":\"⪘\",\"el;\":\"⪙\",\"Element;\":\"∈\",\"elinters;\":\"⏧\",\"ell;\":\"ℓ\",\"els;\":\"⪕\",\"elsdot;\":\"⪗\",\"Emacr;\":\"Ē\",\"emacr;\":\"ē\",\"empty;\":\"∅\",\"emptyset;\":\"∅\",\"EmptySmallSquare;\":\"◻\",\"emptyv;\":\"∅\",\"EmptyVerySmallSquare;\":\"▫\",\"emsp13;\":\" \",\"emsp14;\":\" \",\"emsp;\":\" \",\"ENG;\":\"Ŋ\",\"eng;\":\"ŋ\",\"ensp;\":\" \",\"Eogon;\":\"Ę\",\"eogon;\":\"ę\",\"Eopf;\":\"𝔼\",\"eopf;\":\"𝕖\",\"epar;\":\"⋕\",\"eparsl;\":\"⧣\",\"eplus;\":\"⩱\",\"epsi;\":\"ε\",\"Epsilon;\":\"Ε\",\"epsilon;\":\"ε\",\"epsiv;\":\"ϵ\",\"eqcirc;\":\"≖\",\"eqcolon;\":\"≕\",\"eqsim;\":\"≂\",\"eqslantgtr;\":\"⪖\",\"eqslantless;\":\"⪕\",\"Equal;\":\"⩵\",\"equals;\":\"=\",\"EqualTilde;\":\"≂\",\"equest;\":\"≟\",\"Equilibrium;\":\"⇌\",\"equiv;\":\"≡\",\"equivDD;\":\"⩸\",\"eqvparsl;\":\"⧥\",\"erarr;\":\"⥱\",\"erDot;\":\"≓\",\"escr;\":\"ℯ\",\"Escr;\":\"ℰ\",\"esdot;\":\"≐\",\"Esim;\":\"⩳\",\"esim;\":\"≂\",\"Eta;\":\"Η\",\"eta;\":\"η\",\"ETH;\":\"Ð\",ETH:\"Ð\",\"eth;\":\"ð\",eth:\"ð\",\"Euml;\":\"Ë\",Euml:\"Ë\",\"euml;\":\"ë\",euml:\"ë\",\"euro;\":\"€\",\"excl;\":\"!\",\"exist;\":\"∃\",\"Exists;\":\"∃\",\"expectation;\":\"ℰ\",\"exponentiale;\":\"ⅇ\",\"ExponentialE;\":\"ⅇ\",\"fallingdotseq;\":\"≒\",\"Fcy;\":\"Ф\",\"fcy;\":\"ф\",\"female;\":\"♀\",\"ffilig;\":\"ﬃ\",\"fflig;\":\"ﬀ\",\"ffllig;\":\"ﬄ\",\"Ffr;\":\"𝔉\",\"ffr;\":\"𝔣\",\"filig;\":\"ﬁ\",\"FilledSmallSquare;\":\"◼\",\"FilledVerySmallSquare;\":\"▪\",\"fjlig;\":\"fj\",\"flat;\":\"♭\",\"fllig;\":\"ﬂ\",\"fltns;\":\"▱\",\"fnof;\":\"ƒ\",\"Fopf;\":\"𝔽\",\"fopf;\":\"𝕗\",\"forall;\":\"∀\",\"ForAll;\":\"∀\",\"fork;\":\"⋔\",\"forkv;\":\"⫙\",\"Fouriertrf;\":\"ℱ\",\"fpartint;\":\"⨍\",\"frac12;\":\"½\",frac12:\"½\",\"frac13;\":\"⅓\",\"frac14;\":\"¼\",frac14:\"¼\",\"frac15;\":\"⅕\",\"frac16;\":\"⅙\",\"frac18;\":\"⅛\",\"frac23;\":\"⅔\",\"frac25;\":\"⅖\",\"frac34;\":\"¾\",frac34:\"¾\",\"frac35;\":\"⅗\",\"frac38;\":\"⅜\",\"frac45;\":\"⅘\",\"frac56;\":\"⅚\",\"frac58;\":\"⅝\",\"frac78;\":\"⅞\",\"frasl;\":\"⁄\",\"frown;\":\"⌢\",\"fscr;\":\"𝒻\",\"Fscr;\":\"ℱ\",\"gacute;\":\"ǵ\",\"Gamma;\":\"Γ\",\"gamma;\":\"γ\",\"Gammad;\":\"Ϝ\",\"gammad;\":\"ϝ\",\"gap;\":\"⪆\",\"Gbreve;\":\"Ğ\",\"gbreve;\":\"ğ\",\"Gcedil;\":\"Ģ\",\"Gcirc;\":\"Ĝ\",\"gcirc;\":\"ĝ\",\"Gcy;\":\"Г\",\"gcy;\":\"г\",\"Gdot;\":\"Ġ\",\"gdot;\":\"ġ\",\"ge;\":\"≥\",\"gE;\":\"≧\",\"gEl;\":\"⪌\",\"gel;\":\"⋛\",\"geq;\":\"≥\",\"geqq;\":\"≧\",\"geqslant;\":\"⩾\",\"gescc;\":\"⪩\",\"ges;\":\"⩾\",\"gesdot;\":\"⪀\",\"gesdoto;\":\"⪂\",\"gesdotol;\":\"⪄\",\"gesl;\":\"⋛︀\",\"gesles;\":\"⪔\",\"Gfr;\":\"𝔊\",\"gfr;\":\"𝔤\",\"gg;\":\"≫\",\"Gg;\":\"⋙\",\"ggg;\":\"⋙\",\"gimel;\":\"ℷ\",\"GJcy;\":\"Ѓ\",\"gjcy;\":\"ѓ\",\"gla;\":\"⪥\",\"gl;\":\"≷\",\"glE;\":\"⪒\",\"glj;\":\"⪤\",\"gnap;\":\"⪊\",\"gnapprox;\":\"⪊\",\"gne;\":\"⪈\",\"gnE;\":\"≩\",\"gneq;\":\"⪈\",\"gneqq;\":\"≩\",\"gnsim;\":\"⋧\",\"Gopf;\":\"𝔾\",\"gopf;\":\"𝕘\",\"grave;\":\"`\",\"GreaterEqual;\":\"≥\",\"GreaterEqualLess;\":\"⋛\",\"GreaterFullEqual;\":\"≧\",\"GreaterGreater;\":\"⪢\",\"GreaterLess;\":\"≷\",\"GreaterSlantEqual;\":\"⩾\",\"GreaterTilde;\":\"≳\",\"Gscr;\":\"𝒢\",\"gscr;\":\"ℊ\",\"gsim;\":\"≳\",\"gsime;\":\"⪎\",\"gsiml;\":\"⪐\",\"gtcc;\":\"⪧\",\"gtcir;\":\"⩺\",\"gt;\":\">\",gt:\">\",\"GT;\":\">\",GT:\">\",\"Gt;\":\"≫\",\"gtdot;\":\"⋗\",\"gtlPar;\":\"⦕\",\"gtquest;\":\"⩼\",\"gtrapprox;\":\"⪆\",\"gtrarr;\":\"⥸\",\"gtrdot;\":\"⋗\",\"gtreqless;\":\"⋛\",\"gtreqqless;\":\"⪌\",\"gtrless;\":\"≷\",\"gtrsim;\":\"≳\",\"gvertneqq;\":\"≩︀\",\"gvnE;\":\"≩︀\",\"Hacek;\":\"ˇ\",\"hairsp;\":\" \",\"half;\":\"½\",\"hamilt;\":\"ℋ\",\"HARDcy;\":\"Ъ\",\"hardcy;\":\"ъ\",\"harrcir;\":\"⥈\",\"harr;\":\"↔\",\"hArr;\":\"⇔\",\"harrw;\":\"↭\",\"Hat;\":\"^\",\"hbar;\":\"ℏ\",\"Hcirc;\":\"Ĥ\",\"hcirc;\":\"ĥ\",\"hearts;\":\"♥\",\"heartsuit;\":\"♥\",\"hellip;\":\"…\",\"hercon;\":\"⊹\",\"hfr;\":\"𝔥\",\"Hfr;\":\"ℌ\",\"HilbertSpace;\":\"ℋ\",\"hksearow;\":\"⤥\",\"hkswarow;\":\"⤦\",\"hoarr;\":\"⇿\",\"homtht;\":\"∻\",\"hookleftarrow;\":\"↩\",\"hookrightarrow;\":\"↪\",\"hopf;\":\"𝕙\",\"Hopf;\":\"ℍ\",\"horbar;\":\"―\",\"HorizontalLine;\":\"─\",\"hscr;\":\"𝒽\",\"Hscr;\":\"ℋ\",\"hslash;\":\"ℏ\",\"Hstrok;\":\"Ħ\",\"hstrok;\":\"ħ\",\"HumpDownHump;\":\"≎\",\"HumpEqual;\":\"≏\",\"hybull;\":\"⁃\",\"hyphen;\":\"‐\",\"Iacute;\":\"Í\",Iacute:\"Í\",\"iacute;\":\"í\",iacute:\"í\",\"ic;\":\"⁣\",\"Icirc;\":\"Î\",Icirc:\"Î\",\"icirc;\":\"î\",icirc:\"î\",\"Icy;\":\"И\",\"icy;\":\"и\",\"Idot;\":\"İ\",\"IEcy;\":\"Е\",\"iecy;\":\"е\",\"iexcl;\":\"¡\",iexcl:\"¡\",\"iff;\":\"⇔\",\"ifr;\":\"𝔦\",\"Ifr;\":\"ℑ\",\"Igrave;\":\"Ì\",Igrave:\"Ì\",\"igrave;\":\"ì\",igrave:\"ì\",\"ii;\":\"ⅈ\",\"iiiint;\":\"⨌\",\"iiint;\":\"∭\",\"iinfin;\":\"⧜\",\"iiota;\":\"℩\",\"IJlig;\":\"Ĳ\",\"ijlig;\":\"ĳ\",\"Imacr;\":\"Ī\",\"imacr;\":\"ī\",\"image;\":\"ℑ\",\"ImaginaryI;\":\"ⅈ\",\"imagline;\":\"ℐ\",\"imagpart;\":\"ℑ\",\"imath;\":\"ı\",\"Im;\":\"ℑ\",\"imof;\":\"⊷\",\"imped;\":\"Ƶ\",\"Implies;\":\"⇒\",\"incare;\":\"℅\",\"in;\":\"∈\",\"infin;\":\"∞\",\"infintie;\":\"⧝\",\"inodot;\":\"ı\",\"intcal;\":\"⊺\",\"int;\":\"∫\",\"Int;\":\"∬\",\"integers;\":\"ℤ\",\"Integral;\":\"∫\",\"intercal;\":\"⊺\",\"Intersection;\":\"⋂\",\"intlarhk;\":\"⨗\",\"intprod;\":\"⨼\",\"InvisibleComma;\":\"⁣\",\"InvisibleTimes;\":\"⁢\",\"IOcy;\":\"Ё\",\"iocy;\":\"ё\",\"Iogon;\":\"Į\",\"iogon;\":\"į\",\"Iopf;\":\"𝕀\",\"iopf;\":\"𝕚\",\"Iota;\":\"Ι\",\"iota;\":\"ι\",\"iprod;\":\"⨼\",\"iquest;\":\"¿\",iquest:\"¿\",\"iscr;\":\"𝒾\",\"Iscr;\":\"ℐ\",\"isin;\":\"∈\",\"isindot;\":\"⋵\",\"isinE;\":\"⋹\",\"isins;\":\"⋴\",\"isinsv;\":\"⋳\",\"isinv;\":\"∈\",\"it;\":\"⁢\",\"Itilde;\":\"Ĩ\",\"itilde;\":\"ĩ\",\"Iukcy;\":\"І\",\"iukcy;\":\"і\",\"Iuml;\":\"Ï\",Iuml:\"Ï\",\"iuml;\":\"ï\",iuml:\"ï\",\"Jcirc;\":\"Ĵ\",\"jcirc;\":\"ĵ\",\"Jcy;\":\"Й\",\"jcy;\":\"й\",\"Jfr;\":\"𝔍\",\"jfr;\":\"𝔧\",\"jmath;\":\"ȷ\",\"Jopf;\":\"𝕁\",\"jopf;\":\"𝕛\",\"Jscr;\":\"𝒥\",\"jscr;\":\"𝒿\",\"Jsercy;\":\"Ј\",\"jsercy;\":\"ј\",\"Jukcy;\":\"Є\",\"jukcy;\":\"є\",\"Kappa;\":\"Κ\",\"kappa;\":\"κ\",\"kappav;\":\"ϰ\",\"Kcedil;\":\"Ķ\",\"kcedil;\":\"ķ\",\"Kcy;\":\"К\",\"kcy;\":\"к\",\"Kfr;\":\"𝔎\",\"kfr;\":\"𝔨\",\"kgreen;\":\"ĸ\",\"KHcy;\":\"Х\",\"khcy;\":\"х\",\"KJcy;\":\"Ќ\",\"kjcy;\":\"ќ\",\"Kopf;\":\"𝕂\",\"kopf;\":\"𝕜\",\"Kscr;\":\"𝒦\",\"kscr;\":\"𝓀\",\"lAarr;\":\"⇚\",\"Lacute;\":\"Ĺ\",\"lacute;\":\"ĺ\",\"laemptyv;\":\"⦴\",\"lagran;\":\"ℒ\",\"Lambda;\":\"Λ\",\"lambda;\":\"λ\",\"lang;\":\"⟨\",\"Lang;\":\"⟪\",\"langd;\":\"⦑\",\"langle;\":\"⟨\",\"lap;\":\"⪅\",\"Laplacetrf;\":\"ℒ\",\"laquo;\":\"«\",laquo:\"«\",\"larrb;\":\"⇤\",\"larrbfs;\":\"⤟\",\"larr;\":\"←\",\"Larr;\":\"↞\",\"lArr;\":\"⇐\",\"larrfs;\":\"⤝\",\"larrhk;\":\"↩\",\"larrlp;\":\"↫\",\"larrpl;\":\"⤹\",\"larrsim;\":\"⥳\",\"larrtl;\":\"↢\",\"latail;\":\"⤙\",\"lAtail;\":\"⤛\",\"lat;\":\"⪫\",\"late;\":\"⪭\",\"lates;\":\"⪭︀\",\"lbarr;\":\"⤌\",\"lBarr;\":\"⤎\",\"lbbrk;\":\"❲\",\"lbrace;\":\"{\",\"lbrack;\":\"[\",\"lbrke;\":\"⦋\",\"lbrksld;\":\"⦏\",\"lbrkslu;\":\"⦍\",\"Lcaron;\":\"Ľ\",\"lcaron;\":\"ľ\",\"Lcedil;\":\"Ļ\",\"lcedil;\":\"ļ\",\"lceil;\":\"⌈\",\"lcub;\":\"{\",\"Lcy;\":\"Л\",\"lcy;\":\"л\",\"ldca;\":\"⤶\",\"ldquo;\":\"“\",\"ldquor;\":\"„\",\"ldrdhar;\":\"⥧\",\"ldrushar;\":\"⥋\",\"ldsh;\":\"↲\",\"le;\":\"≤\",\"lE;\":\"≦\",\"LeftAngleBracket;\":\"⟨\",\"LeftArrowBar;\":\"⇤\",\"leftarrow;\":\"←\",\"LeftArrow;\":\"←\",\"Leftarrow;\":\"⇐\",\"LeftArrowRightArrow;\":\"⇆\",\"leftarrowtail;\":\"↢\",\"LeftCeiling;\":\"⌈\",\"LeftDoubleBracket;\":\"⟦\",\"LeftDownTeeVector;\":\"⥡\",\"LeftDownVectorBar;\":\"⥙\",\"LeftDownVector;\":\"⇃\",\"LeftFloor;\":\"⌊\",\"leftharpoondown;\":\"↽\",\"leftharpoonup;\":\"↼\",\"leftleftarrows;\":\"⇇\",\"leftrightarrow;\":\"↔\",\"LeftRightArrow;\":\"↔\",\"Leftrightarrow;\":\"⇔\",\"leftrightarrows;\":\"⇆\",\"leftrightharpoons;\":\"⇋\",\"leftrightsquigarrow;\":\"↭\",\"LeftRightVector;\":\"⥎\",\"LeftTeeArrow;\":\"↤\",\"LeftTee;\":\"⊣\",\"LeftTeeVector;\":\"⥚\",\"leftthreetimes;\":\"⋋\",\"LeftTriangleBar;\":\"⧏\",\"LeftTriangle;\":\"⊲\",\"LeftTriangleEqual;\":\"⊴\",\"LeftUpDownVector;\":\"⥑\",\"LeftUpTeeVector;\":\"⥠\",\"LeftUpVectorBar;\":\"⥘\",\"LeftUpVector;\":\"↿\",\"LeftVectorBar;\":\"⥒\",\"LeftVector;\":\"↼\",\"lEg;\":\"⪋\",\"leg;\":\"⋚\",\"leq;\":\"≤\",\"leqq;\":\"≦\",\"leqslant;\":\"⩽\",\"lescc;\":\"⪨\",\"les;\":\"⩽\",\"lesdot;\":\"⩿\",\"lesdoto;\":\"⪁\",\"lesdotor;\":\"⪃\",\"lesg;\":\"⋚︀\",\"lesges;\":\"⪓\",\"lessapprox;\":\"⪅\",\"lessdot;\":\"⋖\",\"lesseqgtr;\":\"⋚\",\"lesseqqgtr;\":\"⪋\",\"LessEqualGreater;\":\"⋚\",\"LessFullEqual;\":\"≦\",\"LessGreater;\":\"≶\",\"lessgtr;\":\"≶\",\"LessLess;\":\"⪡\",\"lesssim;\":\"≲\",\"LessSlantEqual;\":\"⩽\",\"LessTilde;\":\"≲\",\"lfisht;\":\"⥼\",\"lfloor;\":\"⌊\",\"Lfr;\":\"𝔏\",\"lfr;\":\"𝔩\",\"lg;\":\"≶\",\"lgE;\":\"⪑\",\"lHar;\":\"⥢\",\"lhard;\":\"↽\",\"lharu;\":\"↼\",\"lharul;\":\"⥪\",\"lhblk;\":\"▄\",\"LJcy;\":\"Љ\",\"ljcy;\":\"љ\",\"llarr;\":\"⇇\",\"ll;\":\"≪\",\"Ll;\":\"⋘\",\"llcorner;\":\"⌞\",\"Lleftarrow;\":\"⇚\",\"llhard;\":\"⥫\",\"lltri;\":\"◺\",\"Lmidot;\":\"Ŀ\",\"lmidot;\":\"ŀ\",\"lmoustache;\":\"⎰\",\"lmoust;\":\"⎰\",\"lnap;\":\"⪉\",\"lnapprox;\":\"⪉\",\"lne;\":\"⪇\",\"lnE;\":\"≨\",\"lneq;\":\"⪇\",\"lneqq;\":\"≨\",\"lnsim;\":\"⋦\",\"loang;\":\"⟬\",\"loarr;\":\"⇽\",\"lobrk;\":\"⟦\",\"longleftarrow;\":\"⟵\",\"LongLeftArrow;\":\"⟵\",\"Longleftarrow;\":\"⟸\",\"longleftrightarrow;\":\"⟷\",\"LongLeftRightArrow;\":\"⟷\",\"Longleftrightarrow;\":\"⟺\",\"longmapsto;\":\"⟼\",\"longrightarrow;\":\"⟶\",\"LongRightArrow;\":\"⟶\",\"Longrightarrow;\":\"⟹\",\"looparrowleft;\":\"↫\",\"looparrowright;\":\"↬\",\"lopar;\":\"⦅\",\"Lopf;\":\"𝕃\",\"lopf;\":\"𝕝\",\"loplus;\":\"⨭\",\"lotimes;\":\"⨴\",\"lowast;\":\"∗\",\"lowbar;\":\"_\",\"LowerLeftArrow;\":\"↙\",\"LowerRightArrow;\":\"↘\",\"loz;\":\"◊\",\"lozenge;\":\"◊\",\"lozf;\":\"⧫\",\"lpar;\":\"(\",\"lparlt;\":\"⦓\",\"lrarr;\":\"⇆\",\"lrcorner;\":\"⌟\",\"lrhar;\":\"⇋\",\"lrhard;\":\"⥭\",\"lrm;\":\"‎\",\"lrtri;\":\"⊿\",\"lsaquo;\":\"‹\",\"lscr;\":\"𝓁\",\"Lscr;\":\"ℒ\",\"lsh;\":\"↰\",\"Lsh;\":\"↰\",\"lsim;\":\"≲\",\"lsime;\":\"⪍\",\"lsimg;\":\"⪏\",\"lsqb;\":\"[\",\"lsquo;\":\"‘\",\"lsquor;\":\"‚\",\"Lstrok;\":\"Ł\",\"lstrok;\":\"ł\",\"ltcc;\":\"⪦\",\"ltcir;\":\"⩹\",\"lt;\":\"<\",lt:\"<\",\"LT;\":\"<\",LT:\"<\",\"Lt;\":\"≪\",\"ltdot;\":\"⋖\",\"lthree;\":\"⋋\",\"ltimes;\":\"⋉\",\"ltlarr;\":\"⥶\",\"ltquest;\":\"⩻\",\"ltri;\":\"◃\",\"ltrie;\":\"⊴\",\"ltrif;\":\"◂\",\"ltrPar;\":\"⦖\",\"lurdshar;\":\"⥊\",\"luruhar;\":\"⥦\",\"lvertneqq;\":\"≨︀\",\"lvnE;\":\"≨︀\",\"macr;\":\"¯\",macr:\"¯\",\"male;\":\"♂\",\"malt;\":\"✠\",\"maltese;\":\"✠\",\"Map;\":\"⤅\",\"map;\":\"↦\",\"mapsto;\":\"↦\",\"mapstodown;\":\"↧\",\"mapstoleft;\":\"↤\",\"mapstoup;\":\"↥\",\"marker;\":\"▮\",\"mcomma;\":\"⨩\",\"Mcy;\":\"М\",\"mcy;\":\"м\",\"mdash;\":\"—\",\"mDDot;\":\"∺\",\"measuredangle;\":\"∡\",\"MediumSpace;\":\" \",\"Mellintrf;\":\"ℳ\",\"Mfr;\":\"𝔐\",\"mfr;\":\"𝔪\",\"mho;\":\"℧\",\"micro;\":\"µ\",micro:\"µ\",\"midast;\":\"*\",\"midcir;\":\"⫰\",\"mid;\":\"∣\",\"middot;\":\"·\",middot:\"·\",\"minusb;\":\"⊟\",\"minus;\":\"−\",\"minusd;\":\"∸\",\"minusdu;\":\"⨪\",\"MinusPlus;\":\"∓\",\"mlcp;\":\"⫛\",\"mldr;\":\"…\",\"mnplus;\":\"∓\",\"models;\":\"⊧\",\"Mopf;\":\"𝕄\",\"mopf;\":\"𝕞\",\"mp;\":\"∓\",\"mscr;\":\"𝓂\",\"Mscr;\":\"ℳ\",\"mstpos;\":\"∾\",\"Mu;\":\"Μ\",\"mu;\":\"μ\",\"multimap;\":\"⊸\",\"mumap;\":\"⊸\",\"nabla;\":\"∇\",\"Nacute;\":\"Ń\",\"nacute;\":\"ń\",\"nang;\":\"∠⃒\",\"nap;\":\"≉\",\"napE;\":\"⩰̸\",\"napid;\":\"≋̸\",\"napos;\":\"ŉ\",\"napprox;\":\"≉\",\"natural;\":\"♮\",\"naturals;\":\"ℕ\",\"natur;\":\"♮\",\"nbsp;\":\" \",nbsp:\" \",\"nbump;\":\"≎̸\",\"nbumpe;\":\"≏̸\",\"ncap;\":\"⩃\",\"Ncaron;\":\"Ň\",\"ncaron;\":\"ň\",\"Ncedil;\":\"Ņ\",\"ncedil;\":\"ņ\",\"ncong;\":\"≇\",\"ncongdot;\":\"⩭̸\",\"ncup;\":\"⩂\",\"Ncy;\":\"Н\",\"ncy;\":\"н\",\"ndash;\":\"–\",\"nearhk;\":\"⤤\",\"nearr;\":\"↗\",\"neArr;\":\"⇗\",\"nearrow;\":\"↗\",\"ne;\":\"≠\",\"nedot;\":\"≐̸\",\"NegativeMediumSpace;\":\"​\",\"NegativeThickSpace;\":\"​\",\"NegativeThinSpace;\":\"​\",\"NegativeVeryThinSpace;\":\"​\",\"nequiv;\":\"≢\",\"nesear;\":\"⤨\",\"nesim;\":\"≂̸\",\"NestedGreaterGreater;\":\"≫\",\"NestedLessLess;\":\"≪\",\"NewLine;\":\"\\n\",\"nexist;\":\"∄\",\"nexists;\":\"∄\",\"Nfr;\":\"𝔑\",\"nfr;\":\"𝔫\",\"ngE;\":\"≧̸\",\"nge;\":\"≱\",\"ngeq;\":\"≱\",\"ngeqq;\":\"≧̸\",\"ngeqslant;\":\"⩾̸\",\"nges;\":\"⩾̸\",\"nGg;\":\"⋙̸\",\"ngsim;\":\"≵\",\"nGt;\":\"≫⃒\",\"ngt;\":\"≯\",\"ngtr;\":\"≯\",\"nGtv;\":\"≫̸\",\"nharr;\":\"↮\",\"nhArr;\":\"⇎\",\"nhpar;\":\"⫲\",\"ni;\":\"∋\",\"nis;\":\"⋼\",\"nisd;\":\"⋺\",\"niv;\":\"∋\",\"NJcy;\":\"Њ\",\"njcy;\":\"њ\",\"nlarr;\":\"↚\",\"nlArr;\":\"⇍\",\"nldr;\":\"‥\",\"nlE;\":\"≦̸\",\"nle;\":\"≰\",\"nleftarrow;\":\"↚\",\"nLeftarrow;\":\"⇍\",\"nleftrightarrow;\":\"↮\",\"nLeftrightarrow;\":\"⇎\",\"nleq;\":\"≰\",\"nleqq;\":\"≦̸\",\"nleqslant;\":\"⩽̸\",\"nles;\":\"⩽̸\",\"nless;\":\"≮\",\"nLl;\":\"⋘̸\",\"nlsim;\":\"≴\",\"nLt;\":\"≪⃒\",\"nlt;\":\"≮\",\"nltri;\":\"⋪\",\"nltrie;\":\"⋬\",\"nLtv;\":\"≪̸\",\"nmid;\":\"∤\",\"NoBreak;\":\"⁠\",\"NonBreakingSpace;\":\" \",\"nopf;\":\"𝕟\",\"Nopf;\":\"ℕ\",\"Not;\":\"⫬\",\"not;\":\"¬\",not:\"¬\",\"NotCongruent;\":\"≢\",\"NotCupCap;\":\"≭\",\"NotDoubleVerticalBar;\":\"∦\",\"NotElement;\":\"∉\",\"NotEqual;\":\"≠\",\"NotEqualTilde;\":\"≂̸\",\"NotExists;\":\"∄\",\"NotGreater;\":\"≯\",\"NotGreaterEqual;\":\"≱\",\"NotGreaterFullEqual;\":\"≧̸\",\"NotGreaterGreater;\":\"≫̸\",\"NotGreaterLess;\":\"≹\",\"NotGreaterSlantEqual;\":\"⩾̸\",\"NotGreaterTilde;\":\"≵\",\"NotHumpDownHump;\":\"≎̸\",\"NotHumpEqual;\":\"≏̸\",\"notin;\":\"∉\",\"notindot;\":\"⋵̸\",\"notinE;\":\"⋹̸\",\"notinva;\":\"∉\",\"notinvb;\":\"⋷\",\"notinvc;\":\"⋶\",\"NotLeftTriangleBar;\":\"⧏̸\",\"NotLeftTriangle;\":\"⋪\",\"NotLeftTriangleEqual;\":\"⋬\",\"NotLess;\":\"≮\",\"NotLessEqual;\":\"≰\",\"NotLessGreater;\":\"≸\",\"NotLessLess;\":\"≪̸\",\"NotLessSlantEqual;\":\"⩽̸\",\"NotLessTilde;\":\"≴\",\"NotNestedGreaterGreater;\":\"⪢̸\",\"NotNestedLessLess;\":\"⪡̸\",\"notni;\":\"∌\",\"notniva;\":\"∌\",\"notnivb;\":\"⋾\",\"notnivc;\":\"⋽\",\"NotPrecedes;\":\"⊀\",\"NotPrecedesEqual;\":\"⪯̸\",\"NotPrecedesSlantEqual;\":\"⋠\",\"NotReverseElement;\":\"∌\",\"NotRightTriangleBar;\":\"⧐̸\",\"NotRightTriangle;\":\"⋫\",\"NotRightTriangleEqual;\":\"⋭\",\"NotSquareSubset;\":\"⊏̸\",\"NotSquareSubsetEqual;\":\"⋢\",\"NotSquareSuperset;\":\"⊐̸\",\"NotSquareSupersetEqual;\":\"⋣\",\"NotSubset;\":\"⊂⃒\",\"NotSubsetEqual;\":\"⊈\",\"NotSucceeds;\":\"⊁\",\"NotSucceedsEqual;\":\"⪰̸\",\"NotSucceedsSlantEqual;\":\"⋡\",\"NotSucceedsTilde;\":\"≿̸\",\"NotSuperset;\":\"⊃⃒\",\"NotSupersetEqual;\":\"⊉\",\"NotTilde;\":\"≁\",\"NotTildeEqual;\":\"≄\",\"NotTildeFullEqual;\":\"≇\",\"NotTildeTilde;\":\"≉\",\"NotVerticalBar;\":\"∤\",\"nparallel;\":\"∦\",\"npar;\":\"∦\",\"nparsl;\":\"⫽⃥\",\"npart;\":\"∂̸\",\"npolint;\":\"⨔\",\"npr;\":\"⊀\",\"nprcue;\":\"⋠\",\"nprec;\":\"⊀\",\"npreceq;\":\"⪯̸\",\"npre;\":\"⪯̸\",\"nrarrc;\":\"⤳̸\",\"nrarr;\":\"↛\",\"nrArr;\":\"⇏\",\"nrarrw;\":\"↝̸\",\"nrightarrow;\":\"↛\",\"nRightarrow;\":\"⇏\",\"nrtri;\":\"⋫\",\"nrtrie;\":\"⋭\",\"nsc;\":\"⊁\",\"nsccue;\":\"⋡\",\"nsce;\":\"⪰̸\",\"Nscr;\":\"𝒩\",\"nscr;\":\"𝓃\",\"nshortmid;\":\"∤\",\"nshortparallel;\":\"∦\",\"nsim;\":\"≁\",\"nsime;\":\"≄\",\"nsimeq;\":\"≄\",\"nsmid;\":\"∤\",\"nspar;\":\"∦\",\"nsqsube;\":\"⋢\",\"nsqsupe;\":\"⋣\",\"nsub;\":\"⊄\",\"nsubE;\":\"⫅̸\",\"nsube;\":\"⊈\",\"nsubset;\":\"⊂⃒\",\"nsubseteq;\":\"⊈\",\"nsubseteqq;\":\"⫅̸\",\"nsucc;\":\"⊁\",\"nsucceq;\":\"⪰̸\",\"nsup;\":\"⊅\",\"nsupE;\":\"⫆̸\",\"nsupe;\":\"⊉\",\"nsupset;\":\"⊃⃒\",\"nsupseteq;\":\"⊉\",\"nsupseteqq;\":\"⫆̸\",\"ntgl;\":\"≹\",\"Ntilde;\":\"Ñ\",Ntilde:\"Ñ\",\"ntilde;\":\"ñ\",ntilde:\"ñ\",\"ntlg;\":\"≸\",\"ntriangleleft;\":\"⋪\",\"ntrianglelefteq;\":\"⋬\",\"ntriangleright;\":\"⋫\",\"ntrianglerighteq;\":\"⋭\",\"Nu;\":\"Ν\",\"nu;\":\"ν\",\"num;\":\"#\",\"numero;\":\"№\",\"numsp;\":\" \",\"nvap;\":\"≍⃒\",\"nvdash;\":\"⊬\",\"nvDash;\":\"⊭\",\"nVdash;\":\"⊮\",\"nVDash;\":\"⊯\",\"nvge;\":\"≥⃒\",\"nvgt;\":\">⃒\",\"nvHarr;\":\"⤄\",\"nvinfin;\":\"⧞\",\"nvlArr;\":\"⤂\",\"nvle;\":\"≤⃒\",\"nvlt;\":\"<⃒\",\"nvltrie;\":\"⊴⃒\",\"nvrArr;\":\"⤃\",\"nvrtrie;\":\"⊵⃒\",\"nvsim;\":\"∼⃒\",\"nwarhk;\":\"⤣\",\"nwarr;\":\"↖\",\"nwArr;\":\"⇖\",\"nwarrow;\":\"↖\",\"nwnear;\":\"⤧\",\"Oacute;\":\"Ó\",Oacute:\"Ó\",\"oacute;\":\"ó\",oacute:\"ó\",\"oast;\":\"⊛\",\"Ocirc;\":\"Ô\",Ocirc:\"Ô\",\"ocirc;\":\"ô\",ocirc:\"ô\",\"ocir;\":\"⊚\",\"Ocy;\":\"О\",\"ocy;\":\"о\",\"odash;\":\"⊝\",\"Odblac;\":\"Ő\",\"odblac;\":\"ő\",\"odiv;\":\"⨸\",\"odot;\":\"⊙\",\"odsold;\":\"⦼\",\"OElig;\":\"Œ\",\"oelig;\":\"œ\",\"ofcir;\":\"⦿\",\"Ofr;\":\"𝔒\",\"ofr;\":\"𝔬\",\"ogon;\":\"˛\",\"Ograve;\":\"Ò\",Ograve:\"Ò\",\"ograve;\":\"ò\",ograve:\"ò\",\"ogt;\":\"⧁\",\"ohbar;\":\"⦵\",\"ohm;\":\"Ω\",\"oint;\":\"∮\",\"olarr;\":\"↺\",\"olcir;\":\"⦾\",\"olcross;\":\"⦻\",\"oline;\":\"‾\",\"olt;\":\"⧀\",\"Omacr;\":\"Ō\",\"omacr;\":\"ō\",\"Omega;\":\"Ω\",\"omega;\":\"ω\",\"Omicron;\":\"Ο\",\"omicron;\":\"ο\",\"omid;\":\"⦶\",\"ominus;\":\"⊖\",\"Oopf;\":\"𝕆\",\"oopf;\":\"𝕠\",\"opar;\":\"⦷\",\"OpenCurlyDoubleQuote;\":\"“\",\"OpenCurlyQuote;\":\"‘\",\"operp;\":\"⦹\",\"oplus;\":\"⊕\",\"orarr;\":\"↻\",\"Or;\":\"⩔\",\"or;\":\"∨\",\"ord;\":\"⩝\",\"order;\":\"ℴ\",\"orderof;\":\"ℴ\",\"ordf;\":\"ª\",ordf:\"ª\",\"ordm;\":\"º\",ordm:\"º\",\"origof;\":\"⊶\",\"oror;\":\"⩖\",\"orslope;\":\"⩗\",\"orv;\":\"⩛\",\"oS;\":\"Ⓢ\",\"Oscr;\":\"𝒪\",\"oscr;\":\"ℴ\",\"Oslash;\":\"Ø\",Oslash:\"Ø\",\"oslash;\":\"ø\",oslash:\"ø\",\"osol;\":\"⊘\",\"Otilde;\":\"Õ\",Otilde:\"Õ\",\"otilde;\":\"õ\",otilde:\"õ\",\"otimesas;\":\"⨶\",\"Otimes;\":\"⨷\",\"otimes;\":\"⊗\",\"Ouml;\":\"Ö\",Ouml:\"Ö\",\"ouml;\":\"ö\",ouml:\"ö\",\"ovbar;\":\"⌽\",\"OverBar;\":\"‾\",\"OverBrace;\":\"⏞\",\"OverBracket;\":\"⎴\",\"OverParenthesis;\":\"⏜\",\"para;\":\"¶\",para:\"¶\",\"parallel;\":\"∥\",\"par;\":\"∥\",\"parsim;\":\"⫳\",\"parsl;\":\"⫽\",\"part;\":\"∂\",\"PartialD;\":\"∂\",\"Pcy;\":\"П\",\"pcy;\":\"п\",\"percnt;\":\"%\",\"period;\":\".\",\"permil;\":\"‰\",\"perp;\":\"⊥\",\"pertenk;\":\"‱\",\"Pfr;\":\"𝔓\",\"pfr;\":\"𝔭\",\"Phi;\":\"Φ\",\"phi;\":\"φ\",\"phiv;\":\"ϕ\",\"phmmat;\":\"ℳ\",\"phone;\":\"☎\",\"Pi;\":\"Π\",\"pi;\":\"π\",\"pitchfork;\":\"⋔\",\"piv;\":\"ϖ\",\"planck;\":\"ℏ\",\"planckh;\":\"ℎ\",\"plankv;\":\"ℏ\",\"plusacir;\":\"⨣\",\"plusb;\":\"⊞\",\"pluscir;\":\"⨢\",\"plus;\":\"+\",\"plusdo;\":\"∔\",\"plusdu;\":\"⨥\",\"pluse;\":\"⩲\",\"PlusMinus;\":\"±\",\"plusmn;\":\"±\",plusmn:\"±\",\"plussim;\":\"⨦\",\"plustwo;\":\"⨧\",\"pm;\":\"±\",\"Poincareplane;\":\"ℌ\",\"pointint;\":\"⨕\",\"popf;\":\"𝕡\",\"Popf;\":\"ℙ\",\"pound;\":\"£\",pound:\"£\",\"prap;\":\"⪷\",\"Pr;\":\"⪻\",\"pr;\":\"≺\",\"prcue;\":\"≼\",\"precapprox;\":\"⪷\",\"prec;\":\"≺\",\"preccurlyeq;\":\"≼\",\"Precedes;\":\"≺\",\"PrecedesEqual;\":\"⪯\",\"PrecedesSlantEqual;\":\"≼\",\"PrecedesTilde;\":\"≾\",\"preceq;\":\"⪯\",\"precnapprox;\":\"⪹\",\"precneqq;\":\"⪵\",\"precnsim;\":\"⋨\",\"pre;\":\"⪯\",\"prE;\":\"⪳\",\"precsim;\":\"≾\",\"prime;\":\"′\",\"Prime;\":\"″\",\"primes;\":\"ℙ\",\"prnap;\":\"⪹\",\"prnE;\":\"⪵\",\"prnsim;\":\"⋨\",\"prod;\":\"∏\",\"Product;\":\"∏\",\"profalar;\":\"⌮\",\"profline;\":\"⌒\",\"profsurf;\":\"⌓\",\"prop;\":\"∝\",\"Proportional;\":\"∝\",\"Proportion;\":\"∷\",\"propto;\":\"∝\",\"prsim;\":\"≾\",\"prurel;\":\"⊰\",\"Pscr;\":\"𝒫\",\"pscr;\":\"𝓅\",\"Psi;\":\"Ψ\",\"psi;\":\"ψ\",\"puncsp;\":\" \",\"Qfr;\":\"𝔔\",\"qfr;\":\"𝔮\",\"qint;\":\"⨌\",\"qopf;\":\"𝕢\",\"Qopf;\":\"ℚ\",\"qprime;\":\"⁗\",\"Qscr;\":\"𝒬\",\"qscr;\":\"𝓆\",\"quaternions;\":\"ℍ\",\"quatint;\":\"⨖\",\"quest;\":\"?\",\"questeq;\":\"≟\",\"quot;\":'\"',quot:'\"',\"QUOT;\":'\"',QUOT:'\"',\"rAarr;\":\"⇛\",\"race;\":\"∽̱\",\"Racute;\":\"Ŕ\",\"racute;\":\"ŕ\",\"radic;\":\"√\",\"raemptyv;\":\"⦳\",\"rang;\":\"⟩\",\"Rang;\":\"⟫\",\"rangd;\":\"⦒\",\"range;\":\"⦥\",\"rangle;\":\"⟩\",\"raquo;\":\"»\",raquo:\"»\",\"rarrap;\":\"⥵\",\"rarrb;\":\"⇥\",\"rarrbfs;\":\"⤠\",\"rarrc;\":\"⤳\",\"rarr;\":\"→\",\"Rarr;\":\"↠\",\"rArr;\":\"⇒\",\"rarrfs;\":\"⤞\",\"rarrhk;\":\"↪\",\"rarrlp;\":\"↬\",\"rarrpl;\":\"⥅\",\"rarrsim;\":\"⥴\",\"Rarrtl;\":\"⤖\",\"rarrtl;\":\"↣\",\"rarrw;\":\"↝\",\"ratail;\":\"⤚\",\"rAtail;\":\"⤜\",\"ratio;\":\"∶\",\"rationals;\":\"ℚ\",\"rbarr;\":\"⤍\",\"rBarr;\":\"⤏\",\"RBarr;\":\"⤐\",\"rbbrk;\":\"❳\",\"rbrace;\":\"}\",\"rbrack;\":\"]\",\"rbrke;\":\"⦌\",\"rbrksld;\":\"⦎\",\"rbrkslu;\":\"⦐\",\"Rcaron;\":\"Ř\",\"rcaron;\":\"ř\",\"Rcedil;\":\"Ŗ\",\"rcedil;\":\"ŗ\",\"rceil;\":\"⌉\",\"rcub;\":\"}\",\"Rcy;\":\"Р\",\"rcy;\":\"р\",\"rdca;\":\"⤷\",\"rdldhar;\":\"⥩\",\"rdquo;\":\"”\",\"rdquor;\":\"”\",\"rdsh;\":\"↳\",\"real;\":\"ℜ\",\"realine;\":\"ℛ\",\"realpart;\":\"ℜ\",\"reals;\":\"ℝ\",\"Re;\":\"ℜ\",\"rect;\":\"▭\",\"reg;\":\"®\",reg:\"®\",\"REG;\":\"®\",REG:\"®\",\"ReverseElement;\":\"∋\",\"ReverseEquilibrium;\":\"⇋\",\"ReverseUpEquilibrium;\":\"⥯\",\"rfisht;\":\"⥽\",\"rfloor;\":\"⌋\",\"rfr;\":\"𝔯\",\"Rfr;\":\"ℜ\",\"rHar;\":\"⥤\",\"rhard;\":\"⇁\",\"rharu;\":\"⇀\",\"rharul;\":\"⥬\",\"Rho;\":\"Ρ\",\"rho;\":\"ρ\",\"rhov;\":\"ϱ\",\"RightAngleBracket;\":\"⟩\",\"RightArrowBar;\":\"⇥\",\"rightarrow;\":\"→\",\"RightArrow;\":\"→\",\"Rightarrow;\":\"⇒\",\"RightArrowLeftArrow;\":\"⇄\",\"rightarrowtail;\":\"↣\",\"RightCeiling;\":\"⌉\",\"RightDoubleBracket;\":\"⟧\",\"RightDownTeeVector;\":\"⥝\",\"RightDownVectorBar;\":\"⥕\",\"RightDownVector;\":\"⇂\",\"RightFloor;\":\"⌋\",\"rightharpoondown;\":\"⇁\",\"rightharpoonup;\":\"⇀\",\"rightleftarrows;\":\"⇄\",\"rightleftharpoons;\":\"⇌\",\"rightrightarrows;\":\"⇉\",\"rightsquigarrow;\":\"↝\",\"RightTeeArrow;\":\"↦\",\"RightTee;\":\"⊢\",\"RightTeeVector;\":\"⥛\",\"rightthreetimes;\":\"⋌\",\"RightTriangleBar;\":\"⧐\",\"RightTriangle;\":\"⊳\",\"RightTriangleEqual;\":\"⊵\",\"RightUpDownVector;\":\"⥏\",\"RightUpTeeVector;\":\"⥜\",\"RightUpVectorBar;\":\"⥔\",\"RightUpVector;\":\"↾\",\"RightVectorBar;\":\"⥓\",\"RightVector;\":\"⇀\",\"ring;\":\"˚\",\"risingdotseq;\":\"≓\",\"rlarr;\":\"⇄\",\"rlhar;\":\"⇌\",\"rlm;\":\"‏\",\"rmoustache;\":\"⎱\",\"rmoust;\":\"⎱\",\"rnmid;\":\"⫮\",\"roang;\":\"⟭\",\"roarr;\":\"⇾\",\"robrk;\":\"⟧\",\"ropar;\":\"⦆\",\"ropf;\":\"𝕣\",\"Ropf;\":\"ℝ\",\"roplus;\":\"⨮\",\"rotimes;\":\"⨵\",\"RoundImplies;\":\"⥰\",\"rpar;\":\")\",\"rpargt;\":\"⦔\",\"rppolint;\":\"⨒\",\"rrarr;\":\"⇉\",\"Rrightarrow;\":\"⇛\",\"rsaquo;\":\"›\",\"rscr;\":\"𝓇\",\"Rscr;\":\"ℛ\",\"rsh;\":\"↱\",\"Rsh;\":\"↱\",\"rsqb;\":\"]\",\"rsquo;\":\"’\",\"rsquor;\":\"’\",\"rthree;\":\"⋌\",\"rtimes;\":\"⋊\",\"rtri;\":\"▹\",\"rtrie;\":\"⊵\",\"rtrif;\":\"▸\",\"rtriltri;\":\"⧎\",\"RuleDelayed;\":\"⧴\",\"ruluhar;\":\"⥨\",\"rx;\":\"℞\",\"Sacute;\":\"Ś\",\"sacute;\":\"ś\",\"sbquo;\":\"‚\",\"scap;\":\"⪸\",\"Scaron;\":\"Š\",\"scaron;\":\"š\",\"Sc;\":\"⪼\",\"sc;\":\"≻\",\"sccue;\":\"≽\",\"sce;\":\"⪰\",\"scE;\":\"⪴\",\"Scedil;\":\"Ş\",\"scedil;\":\"ş\",\"Scirc;\":\"Ŝ\",\"scirc;\":\"ŝ\",\"scnap;\":\"⪺\",\"scnE;\":\"⪶\",\"scnsim;\":\"⋩\",\"scpolint;\":\"⨓\",\"scsim;\":\"≿\",\"Scy;\":\"С\",\"scy;\":\"с\",\"sdotb;\":\"⊡\",\"sdot;\":\"⋅\",\"sdote;\":\"⩦\",\"searhk;\":\"⤥\",\"searr;\":\"↘\",\"seArr;\":\"⇘\",\"searrow;\":\"↘\",\"sect;\":\"§\",sect:\"§\",\"semi;\":\";\",\"seswar;\":\"⤩\",\"setminus;\":\"∖\",\"setmn;\":\"∖\",\"sext;\":\"✶\",\"Sfr;\":\"𝔖\",\"sfr;\":\"𝔰\",\"sfrown;\":\"⌢\",\"sharp;\":\"♯\",\"SHCHcy;\":\"Щ\",\"shchcy;\":\"щ\",\"SHcy;\":\"Ш\",\"shcy;\":\"ш\",\"ShortDownArrow;\":\"↓\",\"ShortLeftArrow;\":\"←\",\"shortmid;\":\"∣\",\"shortparallel;\":\"∥\",\"ShortRightArrow;\":\"→\",\"ShortUpArrow;\":\"↑\",\"shy;\":\"­\",shy:\"­\",\"Sigma;\":\"Σ\",\"sigma;\":\"σ\",\"sigmaf;\":\"ς\",\"sigmav;\":\"ς\",\"sim;\":\"∼\",\"simdot;\":\"⩪\",\"sime;\":\"≃\",\"simeq;\":\"≃\",\"simg;\":\"⪞\",\"simgE;\":\"⪠\",\"siml;\":\"⪝\",\"simlE;\":\"⪟\",\"simne;\":\"≆\",\"simplus;\":\"⨤\",\"simrarr;\":\"⥲\",\"slarr;\":\"←\",\"SmallCircle;\":\"∘\",\"smallsetminus;\":\"∖\",\"smashp;\":\"⨳\",\"smeparsl;\":\"⧤\",\"smid;\":\"∣\",\"smile;\":\"⌣\",\"smt;\":\"⪪\",\"smte;\":\"⪬\",\"smtes;\":\"⪬︀\",\"SOFTcy;\":\"Ь\",\"softcy;\":\"ь\",\"solbar;\":\"⌿\",\"solb;\":\"⧄\",\"sol;\":\"/\",\"Sopf;\":\"𝕊\",\"sopf;\":\"𝕤\",\"spades;\":\"♠\",\"spadesuit;\":\"♠\",\"spar;\":\"∥\",\"sqcap;\":\"⊓\",\"sqcaps;\":\"⊓︀\",\"sqcup;\":\"⊔\",\"sqcups;\":\"⊔︀\",\"Sqrt;\":\"√\",\"sqsub;\":\"⊏\",\"sqsube;\":\"⊑\",\"sqsubset;\":\"⊏\",\"sqsubseteq;\":\"⊑\",\"sqsup;\":\"⊐\",\"sqsupe;\":\"⊒\",\"sqsupset;\":\"⊐\",\"sqsupseteq;\":\"⊒\",\"square;\":\"□\",\"Square;\":\"□\",\"SquareIntersection;\":\"⊓\",\"SquareSubset;\":\"⊏\",\"SquareSubsetEqual;\":\"⊑\",\"SquareSuperset;\":\"⊐\",\"SquareSupersetEqual;\":\"⊒\",\"SquareUnion;\":\"⊔\",\"squarf;\":\"▪\",\"squ;\":\"□\",\"squf;\":\"▪\",\"srarr;\":\"→\",\"Sscr;\":\"𝒮\",\"sscr;\":\"𝓈\",\"ssetmn;\":\"∖\",\"ssmile;\":\"⌣\",\"sstarf;\":\"⋆\",\"Star;\":\"⋆\",\"star;\":\"☆\",\"starf;\":\"★\",\"straightepsilon;\":\"ϵ\",\"straightphi;\":\"ϕ\",\"strns;\":\"¯\",\"sub;\":\"⊂\",\"Sub;\":\"⋐\",\"subdot;\":\"⪽\",\"subE;\":\"⫅\",\"sube;\":\"⊆\",\"subedot;\":\"⫃\",\"submult;\":\"⫁\",\"subnE;\":\"⫋\",\"subne;\":\"⊊\",\"subplus;\":\"⪿\",\"subrarr;\":\"⥹\",\"subset;\":\"⊂\",\"Subset;\":\"⋐\",\"subseteq;\":\"⊆\",\"subseteqq;\":\"⫅\",\"SubsetEqual;\":\"⊆\",\"subsetneq;\":\"⊊\",\"subsetneqq;\":\"⫋\",\"subsim;\":\"⫇\",\"subsub;\":\"⫕\",\"subsup;\":\"⫓\",\"succapprox;\":\"⪸\",\"succ;\":\"≻\",\"succcurlyeq;\":\"≽\",\"Succeeds;\":\"≻\",\"SucceedsEqual;\":\"⪰\",\"SucceedsSlantEqual;\":\"≽\",\"SucceedsTilde;\":\"≿\",\"succeq;\":\"⪰\",\"succnapprox;\":\"⪺\",\"succneqq;\":\"⪶\",\"succnsim;\":\"⋩\",\"succsim;\":\"≿\",\"SuchThat;\":\"∋\",\"sum;\":\"∑\",\"Sum;\":\"∑\",\"sung;\":\"♪\",\"sup1;\":\"¹\",sup1:\"¹\",\"sup2;\":\"²\",sup2:\"²\",\"sup3;\":\"³\",sup3:\"³\",\"sup;\":\"⊃\",\"Sup;\":\"⋑\",\"supdot;\":\"⪾\",\"supdsub;\":\"⫘\",\"supE;\":\"⫆\",\"supe;\":\"⊇\",\"supedot;\":\"⫄\",\"Superset;\":\"⊃\",\"SupersetEqual;\":\"⊇\",\"suphsol;\":\"⟉\",\"suphsub;\":\"⫗\",\"suplarr;\":\"⥻\",\"supmult;\":\"⫂\",\"supnE;\":\"⫌\",\"supne;\":\"⊋\",\"supplus;\":\"⫀\",\"supset;\":\"⊃\",\"Supset;\":\"⋑\",\"supseteq;\":\"⊇\",\"supseteqq;\":\"⫆\",\"supsetneq;\":\"⊋\",\"supsetneqq;\":\"⫌\",\"supsim;\":\"⫈\",\"supsub;\":\"⫔\",\"supsup;\":\"⫖\",\"swarhk;\":\"⤦\",\"swarr;\":\"↙\",\"swArr;\":\"⇙\",\"swarrow;\":\"↙\",\"swnwar;\":\"⤪\",\"szlig;\":\"ß\",szlig:\"ß\",\"Tab;\":\"\t\",\"target;\":\"⌖\",\"Tau;\":\"Τ\",\"tau;\":\"τ\",\"tbrk;\":\"⎴\",\"Tcaron;\":\"Ť\",\"tcaron;\":\"ť\",\"Tcedil;\":\"Ţ\",\"tcedil;\":\"ţ\",\"Tcy;\":\"Т\",\"tcy;\":\"т\",\"tdot;\":\"⃛\",\"telrec;\":\"⌕\",\"Tfr;\":\"𝔗\",\"tfr;\":\"𝔱\",\"there4;\":\"∴\",\"therefore;\":\"∴\",\"Therefore;\":\"∴\",\"Theta;\":\"Θ\",\"theta;\":\"θ\",\"thetasym;\":\"ϑ\",\"thetav;\":\"ϑ\",\"thickapprox;\":\"≈\",\"thicksim;\":\"∼\",\"ThickSpace;\":\"  \",\"ThinSpace;\":\" \",\"thinsp;\":\" \",\"thkap;\":\"≈\",\"thksim;\":\"∼\",\"THORN;\":\"Þ\",THORN:\"Þ\",\"thorn;\":\"þ\",thorn:\"þ\",\"tilde;\":\"˜\",\"Tilde;\":\"∼\",\"TildeEqual;\":\"≃\",\"TildeFullEqual;\":\"≅\",\"TildeTilde;\":\"≈\",\"timesbar;\":\"⨱\",\"timesb;\":\"⊠\",\"times;\":\"×\",times:\"×\",\"timesd;\":\"⨰\",\"tint;\":\"∭\",\"toea;\":\"⤨\",\"topbot;\":\"⌶\",\"topcir;\":\"⫱\",\"top;\":\"⊤\",\"Topf;\":\"𝕋\",\"topf;\":\"𝕥\",\"topfork;\":\"⫚\",\"tosa;\":\"⤩\",\"tprime;\":\"‴\",\"trade;\":\"™\",\"TRADE;\":\"™\",\"triangle;\":\"▵\",\"triangledown;\":\"▿\",\"triangleleft;\":\"◃\",\"trianglelefteq;\":\"⊴\",\"triangleq;\":\"≜\",\"triangleright;\":\"▹\",\"trianglerighteq;\":\"⊵\",\"tridot;\":\"◬\",\"trie;\":\"≜\",\"triminus;\":\"⨺\",\"TripleDot;\":\"⃛\",\"triplus;\":\"⨹\",\"trisb;\":\"⧍\",\"tritime;\":\"⨻\",\"trpezium;\":\"⏢\",\"Tscr;\":\"𝒯\",\"tscr;\":\"𝓉\",\"TScy;\":\"Ц\",\"tscy;\":\"ц\",\"TSHcy;\":\"Ћ\",\"tshcy;\":\"ћ\",\"Tstrok;\":\"Ŧ\",\"tstrok;\":\"ŧ\",\"twixt;\":\"≬\",\"twoheadleftarrow;\":\"↞\",\"twoheadrightarrow;\":\"↠\",\"Uacute;\":\"Ú\",Uacute:\"Ú\",\"uacute;\":\"ú\",uacute:\"ú\",\"uarr;\":\"↑\",\"Uarr;\":\"↟\",\"uArr;\":\"⇑\",\"Uarrocir;\":\"⥉\",\"Ubrcy;\":\"Ў\",\"ubrcy;\":\"ў\",\"Ubreve;\":\"Ŭ\",\"ubreve;\":\"ŭ\",\"Ucirc;\":\"Û\",Ucirc:\"Û\",\"ucirc;\":\"û\",ucirc:\"û\",\"Ucy;\":\"У\",\"ucy;\":\"у\",\"udarr;\":\"⇅\",\"Udblac;\":\"Ű\",\"udblac;\":\"ű\",\"udhar;\":\"⥮\",\"ufisht;\":\"⥾\",\"Ufr;\":\"𝔘\",\"ufr;\":\"𝔲\",\"Ugrave;\":\"Ù\",Ugrave:\"Ù\",\"ugrave;\":\"ù\",ugrave:\"ù\",\"uHar;\":\"⥣\",\"uharl;\":\"↿\",\"uharr;\":\"↾\",\"uhblk;\":\"▀\",\"ulcorn;\":\"⌜\",\"ulcorner;\":\"⌜\",\"ulcrop;\":\"⌏\",\"ultri;\":\"◸\",\"Umacr;\":\"Ū\",\"umacr;\":\"ū\",\"uml;\":\"¨\",uml:\"¨\",\"UnderBar;\":\"_\",\"UnderBrace;\":\"⏟\",\"UnderBracket;\":\"⎵\",\"UnderParenthesis;\":\"⏝\",\"Union;\":\"⋃\",\"UnionPlus;\":\"⊎\",\"Uogon;\":\"Ų\",\"uogon;\":\"ų\",\"Uopf;\":\"𝕌\",\"uopf;\":\"𝕦\",\"UpArrowBar;\":\"⤒\",\"uparrow;\":\"↑\",\"UpArrow;\":\"↑\",\"Uparrow;\":\"⇑\",\"UpArrowDownArrow;\":\"⇅\",\"updownarrow;\":\"↕\",\"UpDownArrow;\":\"↕\",\"Updownarrow;\":\"⇕\",\"UpEquilibrium;\":\"⥮\",\"upharpoonleft;\":\"↿\",\"upharpoonright;\":\"↾\",\"uplus;\":\"⊎\",\"UpperLeftArrow;\":\"↖\",\"UpperRightArrow;\":\"↗\",\"upsi;\":\"υ\",\"Upsi;\":\"ϒ\",\"upsih;\":\"ϒ\",\"Upsilon;\":\"Υ\",\"upsilon;\":\"υ\",\"UpTeeArrow;\":\"↥\",\"UpTee;\":\"⊥\",\"upuparrows;\":\"⇈\",\"urcorn;\":\"⌝\",\"urcorner;\":\"⌝\",\"urcrop;\":\"⌎\",\"Uring;\":\"Ů\",\"uring;\":\"ů\",\"urtri;\":\"◹\",\"Uscr;\":\"𝒰\",\"uscr;\":\"𝓊\",\"utdot;\":\"⋰\",\"Utilde;\":\"Ũ\",\"utilde;\":\"ũ\",\"utri;\":\"▵\",\"utrif;\":\"▴\",\"uuarr;\":\"⇈\",\"Uuml;\":\"Ü\",Uuml:\"Ü\",\"uuml;\":\"ü\",uuml:\"ü\",\"uwangle;\":\"⦧\",\"vangrt;\":\"⦜\",\"varepsilon;\":\"ϵ\",\"varkappa;\":\"ϰ\",\"varnothing;\":\"∅\",\"varphi;\":\"ϕ\",\"varpi;\":\"ϖ\",\"varpropto;\":\"∝\",\"varr;\":\"↕\",\"vArr;\":\"⇕\",\"varrho;\":\"ϱ\",\"varsigma;\":\"ς\",\"varsubsetneq;\":\"⊊︀\",\"varsubsetneqq;\":\"⫋︀\",\"varsupsetneq;\":\"⊋︀\",\"varsupsetneqq;\":\"⫌︀\",\"vartheta;\":\"ϑ\",\"vartriangleleft;\":\"⊲\",\"vartriangleright;\":\"⊳\",\"vBar;\":\"⫨\",\"Vbar;\":\"⫫\",\"vBarv;\":\"⫩\",\"Vcy;\":\"В\",\"vcy;\":\"в\",\"vdash;\":\"⊢\",\"vDash;\":\"⊨\",\"Vdash;\":\"⊩\",\"VDash;\":\"⊫\",\"Vdashl;\":\"⫦\",\"veebar;\":\"⊻\",\"vee;\":\"∨\",\"Vee;\":\"⋁\",\"veeeq;\":\"≚\",\"vellip;\":\"⋮\",\"verbar;\":\"|\",\"Verbar;\":\"‖\",\"vert;\":\"|\",\"Vert;\":\"‖\",\"VerticalBar;\":\"∣\",\"VerticalLine;\":\"|\",\"VerticalSeparator;\":\"❘\",\"VerticalTilde;\":\"≀\",\"VeryThinSpace;\":\" \",\"Vfr;\":\"𝔙\",\"vfr;\":\"𝔳\",\"vltri;\":\"⊲\",\"vnsub;\":\"⊂⃒\",\"vnsup;\":\"⊃⃒\",\"Vopf;\":\"𝕍\",\"vopf;\":\"𝕧\",\"vprop;\":\"∝\",\"vrtri;\":\"⊳\",\"Vscr;\":\"𝒱\",\"vscr;\":\"𝓋\",\"vsubnE;\":\"⫋︀\",\"vsubne;\":\"⊊︀\",\"vsupnE;\":\"⫌︀\",\"vsupne;\":\"⊋︀\",\"Vvdash;\":\"⊪\",\"vzigzag;\":\"⦚\",\"Wcirc;\":\"Ŵ\",\"wcirc;\":\"ŵ\",\"wedbar;\":\"⩟\",\"wedge;\":\"∧\",\"Wedge;\":\"⋀\",\"wedgeq;\":\"≙\",\"weierp;\":\"℘\",\"Wfr;\":\"𝔚\",\"wfr;\":\"𝔴\",\"Wopf;\":\"𝕎\",\"wopf;\":\"𝕨\",\"wp;\":\"℘\",\"wr;\":\"≀\",\"wreath;\":\"≀\",\"Wscr;\":\"𝒲\",\"wscr;\":\"𝓌\",\"xcap;\":\"⋂\",\"xcirc;\":\"◯\",\"xcup;\":\"⋃\",\"xdtri;\":\"▽\",\"Xfr;\":\"𝔛\",\"xfr;\":\"𝔵\",\"xharr;\":\"⟷\",\"xhArr;\":\"⟺\",\"Xi;\":\"Ξ\",\"xi;\":\"ξ\",\"xlarr;\":\"⟵\",\"xlArr;\":\"⟸\",\"xmap;\":\"⟼\",\"xnis;\":\"⋻\",\"xodot;\":\"⨀\",\"Xopf;\":\"𝕏\",\"xopf;\":\"𝕩\",\"xoplus;\":\"⨁\",\"xotime;\":\"⨂\",\"xrarr;\":\"⟶\",\"xrArr;\":\"⟹\",\"Xscr;\":\"𝒳\",\"xscr;\":\"𝓍\",\"xsqcup;\":\"⨆\",\"xuplus;\":\"⨄\",\"xutri;\":\"△\",\"xvee;\":\"⋁\",\"xwedge;\":\"⋀\",\"Yacute;\":\"Ý\",Yacute:\"Ý\",\"yacute;\":\"ý\",yacute:\"ý\",\"YAcy;\":\"Я\",\"yacy;\":\"я\",\"Ycirc;\":\"Ŷ\",\"ycirc;\":\"ŷ\",\"Ycy;\":\"Ы\",\"ycy;\":\"ы\",\"yen;\":\"¥\",yen:\"¥\",\"Yfr;\":\"𝔜\",\"yfr;\":\"𝔶\",\"YIcy;\":\"Ї\",\"yicy;\":\"ї\",\"Yopf;\":\"𝕐\",\"yopf;\":\"𝕪\",\"Yscr;\":\"𝒴\",\"yscr;\":\"𝓎\",\"YUcy;\":\"Ю\",\"yucy;\":\"ю\",\"yuml;\":\"ÿ\",yuml:\"ÿ\",\"Yuml;\":\"Ÿ\",\"Zacute;\":\"Ź\",\"zacute;\":\"ź\",\"Zcaron;\":\"Ž\",\"zcaron;\":\"ž\",\"Zcy;\":\"З\",\"zcy;\":\"з\",\"Zdot;\":\"Ż\",\"zdot;\":\"ż\",\"zeetrf;\":\"ℨ\",\"ZeroWidthSpace;\":\"​\",\"Zeta;\":\"Ζ\",\"zeta;\":\"ζ\",\"zfr;\":\"𝔷\",\"Zfr;\":\"ℨ\",\"ZHcy;\":\"Ж\",\"zhcy;\":\"ж\",\"zigrarr;\":\"⇝\",\"zopf;\":\"𝕫\",\"Zopf;\":\"ℤ\",\"Zscr;\":\"𝒵\",\"zscr;\":\"𝓏\",\"zwj;\":\"‍\",\"zwnj;\":\"‌\"}\n},{}],13:[function(_dereq_,module){function replacer(key,value){return util.isUndefined(value)?\"\"+value:!util.isNumber(value)||!isNaN(value)&&isFinite(value)?util.isFunction(value)||util.isRegExp(value)?\"\"+value:value:\"\"+value}function truncate(s,n){return util.isString(s)?n>s.length?s:s.slice(0,n):s}function getMessage(self){return truncate(JSON.stringify(self.actual,replacer),128)+\" \"+self.operator+\" \"+truncate(JSON.stringify(self.expected,replacer),128)}function fail(actual,expected,message,operator,stackStartFunction){throw new assert.AssertionError({message:message,actual:actual,expected:expected,operator:operator,stackStartFunction:stackStartFunction})}function ok(value,message){value||fail(value,!0,message,\"==\",assert.ok)}function _deepEqual(actual,expected){if(actual===expected)return!0;if(util.isBuffer(actual)&&util.isBuffer(expected)){if(actual.length!=expected.length)return!1;for(var i=0;actual.length>i;i++)if(actual[i]!==expected[i])return!1;return!0}return util.isDate(actual)&&util.isDate(expected)?actual.getTime()===expected.getTime():util.isRegExp(actual)&&util.isRegExp(expected)?actual.source===expected.source&&actual.global===expected.global&&actual.multiline===expected.multiline&&actual.lastIndex===expected.lastIndex&&actual.ignoreCase===expected.ignoreCase:util.isObject(actual)||util.isObject(expected)?objEquiv(actual,expected):actual==expected}function isArguments(object){return\"[object Arguments]\"==Object.prototype.toString.call(object)}function objEquiv(a,b){if(util.isNullOrUndefined(a)||util.isNullOrUndefined(b))return!1;if(a.prototype!==b.prototype)return!1;if(isArguments(a))return isArguments(b)?(a=pSlice.call(a),b=pSlice.call(b),_deepEqual(a,b)):!1;try{var key,i,ka=objectKeys(a),kb=objectKeys(b)}catch(e){return!1}if(ka.length!=kb.length)return!1;for(ka.sort(),kb.sort(),i=ka.length-1;i>=0;i--)if(ka[i]!=kb[i])return!1;for(i=ka.length-1;i>=0;i--)if(key=ka[i],!_deepEqual(a[key],b[key]))return!1;return!0}function expectedException(actual,expected){return actual&&expected?\"[object RegExp]\"==Object.prototype.toString.call(expected)?expected.test(actual):actual instanceof expected?!0:expected.call({},actual)===!0?!0:!1:!1}function _throws(shouldThrow,block,expected,message){var actual;util.isString(expected)&&(message=expected,expected=null);try{block()}catch(e){actual=e}if(message=(expected&&expected.name?\" (\"+expected.name+\").\":\".\")+(message?\" \"+message:\".\"),shouldThrow&&!actual&&fail(actual,expected,\"Missing expected exception\"+message),!shouldThrow&&expectedException(actual,expected)&&fail(actual,expected,\"Got unwanted exception\"+message),shouldThrow&&actual&&expected&&!expectedException(actual,expected)||!shouldThrow&&actual)throw actual}var util=_dereq_(\"util/\"),pSlice=Array.prototype.slice,hasOwn=Object.prototype.hasOwnProperty,assert=module.exports=ok;assert.AssertionError=function(options){this.name=\"AssertionError\",this.actual=options.actual,this.expected=options.expected,this.operator=options.operator,options.message?(this.message=options.message,this.generatedMessage=!1):(this.message=getMessage(this),this.generatedMessage=!0);var stackStartFunction=options.stackStartFunction||fail;if(Error.captureStackTrace)Error.captureStackTrace(this,stackStartFunction);else{var err=Error();if(err.stack){var out=err.stack,fn_name=stackStartFunction.name,idx=out.indexOf(\"\\n\"+fn_name);if(idx>=0){var next_line=out.indexOf(\"\\n\",idx+1);out=out.substring(next_line+1)}this.stack=out}}},util.inherits(assert.AssertionError,Error),assert.fail=fail,assert.ok=ok,assert.equal=function(actual,expected,message){actual!=expected&&fail(actual,expected,message,\"==\",assert.equal)},assert.notEqual=function(actual,expected,message){actual==expected&&fail(actual,expected,message,\"!=\",assert.notEqual)},assert.deepEqual=function(actual,expected,message){_deepEqual(actual,expected)||fail(actual,expected,message,\"deepEqual\",assert.deepEqual)},assert.notDeepEqual=function(actual,expected,message){_deepEqual(actual,expected)&&fail(actual,expected,message,\"notDeepEqual\",assert.notDeepEqual)},assert.strictEqual=function(actual,expected,message){actual!==expected&&fail(actual,expected,message,\"===\",assert.strictEqual)},assert.notStrictEqual=function(actual,expected,message){actual===expected&&fail(actual,expected,message,\"!==\",assert.notStrictEqual)},assert.throws=function(){_throws.apply(this,[!0].concat(pSlice.call(arguments)))},assert.doesNotThrow=function(){_throws.apply(this,[!1].concat(pSlice.call(arguments)))},assert.ifError=function(err){if(err)throw err};var objectKeys=Object.keys||function(obj){var keys=[];for(var key in obj)hasOwn.call(obj,key)&&keys.push(key);return keys}},{\"util/\":15}],14:[function(_dereq_,module){module.exports=function(arg){return arg&&\"object\"==typeof arg&&\"function\"==typeof arg.copy&&\"function\"==typeof arg.fill&&\"function\"==typeof arg.readUInt8}},{}],15:[function(_dereq_,module,exports){(function(process,global){function inspect(obj,opts){var ctx={seen:[],stylize:stylizeNoColor};return arguments.length>=3&&(ctx.depth=arguments[2]),arguments.length>=4&&(ctx.colors=arguments[3]),isBoolean(opts)?ctx.showHidden=opts:opts&&exports._extend(ctx,opts),isUndefined(ctx.showHidden)&&(ctx.showHidden=!1),isUndefined(ctx.depth)&&(ctx.depth=2),isUndefined(ctx.colors)&&(ctx.colors=!1),isUndefined(ctx.customInspect)&&(ctx.customInspect=!0),ctx.colors&&(ctx.stylize=stylizeWithColor),formatValue(ctx,obj,ctx.depth)}function stylizeWithColor(str,styleType){var style=inspect.styles[styleType];return style?\"\u001b[\"+inspect.colors[style][0]+\"m\"+str+\"\u001b[\"+inspect.colors[style][1]+\"m\":str}function stylizeNoColor(str){return str}function arrayToHash(array){var hash={};return array.forEach(function(val){hash[val]=!0}),hash}function formatValue(ctx,value,recurseTimes){if(ctx.customInspect&&value&&isFunction(value.inspect)&&value.inspect!==exports.inspect&&(!value.constructor||value.constructor.prototype!==value)){var ret=value.inspect(recurseTimes,ctx);return isString(ret)||(ret=formatValue(ctx,ret,recurseTimes)),ret}var primitive=formatPrimitive(ctx,value);if(primitive)return primitive;var keys=Object.keys(value),visibleKeys=arrayToHash(keys);if(ctx.showHidden&&(keys=Object.getOwnPropertyNames(value)),isError(value)&&(keys.indexOf(\"message\")>=0||keys.indexOf(\"description\")>=0))return formatError(value);if(0===keys.length){if(isFunction(value)){var name=value.name?\": \"+value.name:\"\";return ctx.stylize(\"[Function\"+name+\"]\",\"special\")}if(isRegExp(value))return ctx.stylize(RegExp.prototype.toString.call(value),\"regexp\");if(isDate(value))return ctx.stylize(Date.prototype.toString.call(value),\"date\");if(isError(value))return formatError(value)}var base=\"\",array=!1,braces=[\"{\",\"}\"];if(isArray(value)&&(array=!0,braces=[\"[\",\"]\"]),isFunction(value)){var n=value.name?\": \"+value.name:\"\";base=\" [Function\"+n+\"]\"}if(isRegExp(value)&&(base=\" \"+RegExp.prototype.toString.call(value)),isDate(value)&&(base=\" \"+Date.prototype.toUTCString.call(value)),isError(value)&&(base=\" \"+formatError(value)),0===keys.length&&(!array||0==value.length))return braces[0]+base+braces[1];if(0>recurseTimes)return isRegExp(value)?ctx.stylize(RegExp.prototype.toString.call(value),\"regexp\"):ctx.stylize(\"[Object]\",\"special\");ctx.seen.push(value);var output;return output=array?formatArray(ctx,value,recurseTimes,visibleKeys,keys):keys.map(function(key){return formatProperty(ctx,value,recurseTimes,visibleKeys,key,array)}),ctx.seen.pop(),reduceToSingleString(output,base,braces)}function formatPrimitive(ctx,value){if(isUndefined(value))return ctx.stylize(\"undefined\",\"undefined\");if(isString(value)){var simple=\"'\"+JSON.stringify(value).replace(/^\"|\"$/g,\"\").replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"')+\"'\";return ctx.stylize(simple,\"string\")}return isNumber(value)?ctx.stylize(\"\"+value,\"number\"):isBoolean(value)?ctx.stylize(\"\"+value,\"boolean\"):isNull(value)?ctx.stylize(\"null\",\"null\"):void 0}function formatError(value){return\"[\"+Error.prototype.toString.call(value)+\"]\"}function formatArray(ctx,value,recurseTimes,visibleKeys,keys){for(var output=[],i=0,l=value.length;l>i;++i)hasOwnProperty(value,i+\"\")?output.push(formatProperty(ctx,value,recurseTimes,visibleKeys,i+\"\",!0)):output.push(\"\");return keys.forEach(function(key){key.match(/^\\d+$/)||output.push(formatProperty(ctx,value,recurseTimes,visibleKeys,key,!0))}),output}function formatProperty(ctx,value,recurseTimes,visibleKeys,key,array){var name,str,desc;if(desc=Object.getOwnPropertyDescriptor(value,key)||{value:value[key]},desc.get?str=desc.set?ctx.stylize(\"[Getter/Setter]\",\"special\"):ctx.stylize(\"[Getter]\",\"special\"):desc.set&&(str=ctx.stylize(\"[Setter]\",\"special\")),hasOwnProperty(visibleKeys,key)||(name=\"[\"+key+\"]\"),str||(0>ctx.seen.indexOf(desc.value)?(str=isNull(recurseTimes)?formatValue(ctx,desc.value,null):formatValue(ctx,desc.value,recurseTimes-1),str.indexOf(\"\\n\")>-1&&(str=array?str.split(\"\\n\").map(function(line){return\"  \"+line}).join(\"\\n\").substr(2):\"\\n\"+str.split(\"\\n\").map(function(line){return\"   \"+line}).join(\"\\n\"))):str=ctx.stylize(\"[Circular]\",\"special\")),isUndefined(name)){if(array&&key.match(/^\\d+$/))return str;name=JSON.stringify(\"\"+key),name.match(/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?(name=name.substr(1,name.length-2),name=ctx.stylize(name,\"name\")):(name=name.replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"').replace(/(^\"|\"$)/g,\"'\"),name=ctx.stylize(name,\"string\"))}return name+\": \"+str}function reduceToSingleString(output,base,braces){var numLinesEst=0,length=output.reduce(function(prev,cur){return numLinesEst++,cur.indexOf(\"\\n\")>=0&&numLinesEst++,prev+cur.replace(/\\u001b\\[\\d\\d?m/g,\"\").length+1},0);return length>60?braces[0]+(\"\"===base?\"\":base+\"\\n \")+\" \"+output.join(\",\\n  \")+\" \"+braces[1]:braces[0]+base+\" \"+output.join(\", \")+\" \"+braces[1]}function isArray(ar){return Array.isArray(ar)}function isBoolean(arg){return\"boolean\"==typeof arg}function isNull(arg){return null===arg}function isNullOrUndefined(arg){return null==arg}function isNumber(arg){return\"number\"==typeof arg}function isString(arg){return\"string\"==typeof arg}function isSymbol(arg){return\"symbol\"==typeof arg}function isUndefined(arg){return void 0===arg}function isRegExp(re){return isObject(re)&&\"[object RegExp]\"===objectToString(re)}function isObject(arg){return\"object\"==typeof arg&&null!==arg}function isDate(d){return isObject(d)&&\"[object Date]\"===objectToString(d)}function isError(e){return isObject(e)&&(\"[object Error]\"===objectToString(e)||e instanceof Error)}function isFunction(arg){return\"function\"==typeof arg}function isPrimitive(arg){return null===arg||\"boolean\"==typeof arg||\"number\"==typeof arg||\"string\"==typeof arg||\"symbol\"==typeof arg||arg===void 0}function objectToString(o){return Object.prototype.toString.call(o)}function pad(n){return 10>n?\"0\"+n.toString(10):n.toString(10)}function timestamp(){var d=new Date,time=[pad(d.getHours()),pad(d.getMinutes()),pad(d.getSeconds())].join(\":\");return[d.getDate(),months[d.getMonth()],time].join(\" \")}function hasOwnProperty(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop)}var formatRegExp=/%[sdj%]/g;exports.format=function(f){if(!isString(f)){for(var objects=[],i=0;arguments.length>i;i++)objects.push(inspect(arguments[i]));return objects.join(\" \")}for(var i=1,args=arguments,len=args.length,str=(f+\"\").replace(formatRegExp,function(x){if(\"%%\"===x)return\"%\";if(i>=len)return x;switch(x){case\"%s\":return args[i++]+\"\";case\"%d\":return Number(args[i++]);case\"%j\":try{return JSON.stringify(args[i++])}catch(_){return\"[Circular]\"}default:return x}}),x=args[i];len>i;x=args[++i])str+=isNull(x)||!isObject(x)?\" \"+x:\" \"+inspect(x);return str},exports.deprecate=function(fn,msg){function deprecated(){if(!warned){if(process.throwDeprecation)throw Error(msg);process.traceDeprecation?console.trace(msg):console.error(msg),warned=!0}return fn.apply(this,arguments)}if(isUndefined(global.process))return function(){return exports.deprecate(fn,msg).apply(this,arguments)};if(process.noDeprecation===!0)return fn;var warned=!1;return deprecated};var debugEnviron,debugs={};exports.debuglog=function(set){if(isUndefined(debugEnviron)&&(debugEnviron=process.env.NODE_DEBUG||\"\"),set=set.toUpperCase(),!debugs[set])if(RegExp(\"\\\\b\"+set+\"\\\\b\",\"i\").test(debugEnviron)){var pid=process.pid;debugs[set]=function(){var msg=exports.format.apply(exports,arguments);console.error(\"%s %d: %s\",set,pid,msg)}}else debugs[set]=function(){};return debugs[set]},exports.inspect=inspect,inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},inspect.styles={special:\"cyan\",number:\"yellow\",\"boolean\":\"yellow\",undefined:\"grey\",\"null\":\"bold\",string:\"green\",date:\"magenta\",regexp:\"red\"},exports.isArray=isArray,exports.isBoolean=isBoolean,exports.isNull=isNull,exports.isNullOrUndefined=isNullOrUndefined,exports.isNumber=isNumber,exports.isString=isString,exports.isSymbol=isSymbol,exports.isUndefined=isUndefined,exports.isRegExp=isRegExp,exports.isObject=isObject,exports.isDate=isDate,exports.isError=isError,exports.isFunction=isFunction,exports.isPrimitive=isPrimitive,exports.isBuffer=_dereq_(\"./support/isBuffer\");var months=[\"Jan\",\"Feb\",\"Mar\",\"Apr\",\"May\",\"Jun\",\"Jul\",\"Aug\",\"Sep\",\"Oct\",\"Nov\",\"Dec\"];exports.log=function(){console.log(\"%s - %s\",timestamp(),exports.format.apply(exports,arguments))},exports.inherits=_dereq_(\"inherits\"),exports._extend=function(origin,add){if(!add||!isObject(add))return origin;for(var keys=Object.keys(add),i=keys.length;i--;)origin[keys[i]]=add[keys[i]];return origin}}).call(this,_dereq_(\"/usr/local/lib/node_modules/browserify/node_modules/insert-module-globals/node_modules/process/browser.js\"),\"undefined\"!=typeof self?self:\"undefined\"!=typeof window?window:{})},{\"./support/isBuffer\":14,\"/usr/local/lib/node_modules/browserify/node_modules/insert-module-globals/node_modules/process/browser.js\":18,inherits:17}],16:[function(_dereq_,module){function EventEmitter(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function isFunction(arg){return\"function\"==typeof arg}function isNumber(arg){return\"number\"==typeof arg}function isObject(arg){return\"object\"==typeof arg&&null!==arg}function isUndefined(arg){return void 0===arg}module.exports=EventEmitter,EventEmitter.EventEmitter=EventEmitter,EventEmitter.prototype._events=void 0,EventEmitter.prototype._maxListeners=void 0,EventEmitter.defaultMaxListeners=10,EventEmitter.prototype.setMaxListeners=function(n){if(!isNumber(n)||0>n||isNaN(n))throw TypeError(\"n must be a positive number\");return this._maxListeners=n,this},EventEmitter.prototype.emit=function(type){var er,handler,len,args,i,listeners;if(this._events||(this._events={}),\"error\"===type&&(!this._events.error||isObject(this._events.error)&&!this._events.error.length))throw er=arguments[1],er instanceof Error?er:TypeError('Uncaught, unspecified \"error\" event.');if(handler=this._events[type],isUndefined(handler))return!1;if(isFunction(handler))switch(arguments.length){case 1:handler.call(this);break;case 2:handler.call(this,arguments[1]);break;case 3:handler.call(this,arguments[1],arguments[2]);break;default:for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];handler.apply(this,args)}else if(isObject(handler)){for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];for(listeners=handler.slice(),len=listeners.length,i=0;len>i;i++)listeners[i].apply(this,args)}return!0},EventEmitter.prototype.addListener=function(type,listener){var m;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(this._events||(this._events={}),this._events.newListener&&this.emit(\"newListener\",type,isFunction(listener.listener)?listener.listener:listener),this._events[type]?isObject(this._events[type])?this._events[type].push(listener):this._events[type]=[this._events[type],listener]:this._events[type]=listener,isObject(this._events[type])&&!this._events[type].warned){var m;m=isUndefined(this._maxListeners)?EventEmitter.defaultMaxListeners:this._maxListeners,m&&m>0&&this._events[type].length>m&&(this._events[type].warned=!0,console.error(\"(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.\",this._events[type].length),console.trace())}return this},EventEmitter.prototype.on=EventEmitter.prototype.addListener,EventEmitter.prototype.once=function(type,listener){function g(){this.removeListener(type,g),fired||(fired=!0,listener.apply(this,arguments))}if(!isFunction(listener))throw TypeError(\"listener must be a function\");var fired=!1;return g.listener=listener,this.on(type,g),this},EventEmitter.prototype.removeListener=function(type,listener){var list,position,length,i;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(!this._events||!this._events[type])return this;if(list=this._events[type],length=list.length,position=-1,list===listener||isFunction(list.listener)&&list.listener===listener)delete this._events[type],this._events.removeListener&&this.emit(\"removeListener\",type,listener);else if(isObject(list)){for(i=length;i-->0;)if(list[i]===listener||list[i].listener&&list[i].listener===listener){position=i;break}if(0>position)return this;1===list.length?(list.length=0,delete this._events[type]):list.splice(position,1),this._events.removeListener&&this.emit(\"removeListener\",type,listener)}return this},EventEmitter.prototype.removeAllListeners=function(type){var key,listeners;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[type]&&delete this._events[type],this;if(0===arguments.length){for(key in this._events)\"removeListener\"!==key&&this.removeAllListeners(key);return this.removeAllListeners(\"removeListener\"),this._events={},this}if(listeners=this._events[type],isFunction(listeners))this.removeListener(type,listeners);else for(;listeners.length;)this.removeListener(type,listeners[listeners.length-1]);return delete this._events[type],this},EventEmitter.prototype.listeners=function(type){var ret;return ret=this._events&&this._events[type]?isFunction(this._events[type])?[this._events[type]]:this._events[type].slice():[]},EventEmitter.listenerCount=function(emitter,type){var ret;return ret=emitter._events&&emitter._events[type]?isFunction(emitter._events[type])?1:emitter._events[type].length:0}},{}],17:[function(_dereq_,module){module.exports=\"function\"==typeof Object.create?function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})}:function(ctor,superCtor){ctor.super_=superCtor;var TempCtor=function(){};TempCtor.prototype=superCtor.prototype,ctor.prototype=new TempCtor,ctor.prototype.constructor=ctor}},{}],18:[function(_dereq_,module){function noop(){}var process=module.exports={};process.nextTick=function(){var canSetImmediate=\"undefined\"!=typeof window&&window.setImmediate,canPost=\"undefined\"!=typeof window&&window.postMessage&&window.addEventListener;if(canSetImmediate)return function(f){return window.setImmediate(f)};if(canPost){var queue=[];return window.addEventListener(\"message\",function(ev){var source=ev.source;if((source===window||null===source)&&\"process-tick\"===ev.data&&(ev.stopPropagation(),queue.length>0)){var fn=queue.shift();fn()}},!0),function(fn){queue.push(fn),window.postMessage(\"process-tick\",\"*\")}}return function(fn){setTimeout(fn,0)}}(),process.title=\"browser\",process.browser=!0,process.env={},process.argv=[],process.on=noop,process.once=noop,process.off=noop,process.emit=noop,process.binding=function(){throw Error(\"process.binding is not supported\")},process.cwd=function(){return\"/\"},process.chdir=function(){throw Error(\"process.chdir is not supported\")}},{}],19:[function(_dereq_,module){module.exports=_dereq_(14)},{}],20:[function(_dereq_,module){module.exports=_dereq_(15)},{\"./support/isBuffer\":19,\"/usr/local/lib/node_modules/browserify/node_modules/insert-module-globals/node_modules/process/browser.js\":18,inherits:17}]},{},[9])(9)}),ace.define(\"ace/mode/html_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/lang\",\"ace/worker/mirror\",\"ace/mode/html/saxparser\"],function(acequire,exports){\"use strict\";var oop=acequire(\"../lib/oop\");acequire(\"../lib/lang\");var Mirror=acequire(\"../worker/mirror\").Mirror,SAXParser=acequire(\"./html/saxparser\").SAXParser,errorTypes={\"expected-doctype-but-got-start-tag\":\"info\",\"expected-doctype-but-got-chars\":\"info\",\"non-html-root\":\"info\"},Worker=exports.Worker=function(sender){Mirror.call(this,sender),this.setTimeout(400),this.context=null};oop.inherits(Worker,Mirror),function(){this.setOptions=function(options){this.context=options.context},this.onUpdate=function(){var value=this.doc.getValue();if(value){var parser=new SAXParser,errors=[],noop=function(){};parser.contentHandler={startDocument:noop,endDocument:noop,startElement:noop,endElement:noop,characters:noop},parser.errorHandler={error:function(message,location,code){errors.push({row:location.line,column:location.column,text:message,type:errorTypes[code]||\"error\"})}},this.context?parser.parseFragment(value,this.context):parser.parse(value),this.sender.emit(\"error\",errors)}}}.call(Worker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object\n});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports.id = 'ace/mode/json_worker';
	module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/json/json_parse\",[\"require\",\"exports\",\"module\"],function(){\"use strict\";var at,ch,text,value,escapee={'\"':'\"',\"\\\\\":\"\\\\\",\"/\":\"/\",b:\"\\b\",f:\"\\f\",n:\"\\n\",r:\"\\r\",t:\"\t\"},error=function(m){throw{name:\"SyntaxError\",message:m,at:at,text:text}},next=function(c){return c&&c!==ch&&error(\"Expected '\"+c+\"' instead of '\"+ch+\"'\"),ch=text.charAt(at),at+=1,ch},number=function(){var number,string=\"\";for(\"-\"===ch&&(string=\"-\",next(\"-\"));ch>=\"0\"&&\"9\">=ch;)string+=ch,next();if(\".\"===ch)for(string+=\".\";next()&&ch>=\"0\"&&\"9\">=ch;)string+=ch;if(\"e\"===ch||\"E\"===ch)for(string+=ch,next(),(\"-\"===ch||\"+\"===ch)&&(string+=ch,next());ch>=\"0\"&&\"9\">=ch;)string+=ch,next();return number=+string,isNaN(number)?(error(\"Bad number\"),void 0):number},string=function(){var hex,i,uffff,string=\"\";if('\"'===ch)for(;next();){if('\"'===ch)return next(),string;if(\"\\\\\"===ch)if(next(),\"u\"===ch){for(uffff=0,i=0;4>i&&(hex=parseInt(next(),16),isFinite(hex));i+=1)uffff=16*uffff+hex;string+=String.fromCharCode(uffff)}else{if(\"string\"!=typeof escapee[ch])break;string+=escapee[ch]}else string+=ch}error(\"Bad string\")},white=function(){for(;ch&&\" \">=ch;)next()},word=function(){switch(ch){case\"t\":return next(\"t\"),next(\"r\"),next(\"u\"),next(\"e\"),!0;case\"f\":return next(\"f\"),next(\"a\"),next(\"l\"),next(\"s\"),next(\"e\"),!1;case\"n\":return next(\"n\"),next(\"u\"),next(\"l\"),next(\"l\"),null}error(\"Unexpected '\"+ch+\"'\")},array=function(){var array=[];if(\"[\"===ch){if(next(\"[\"),white(),\"]\"===ch)return next(\"]\"),array;for(;ch;){if(array.push(value()),white(),\"]\"===ch)return next(\"]\"),array;next(\",\"),white()}}error(\"Bad array\")},object=function(){var key,object={};if(\"{\"===ch){if(next(\"{\"),white(),\"}\"===ch)return next(\"}\"),object;for(;ch;){if(key=string(),white(),next(\":\"),Object.hasOwnProperty.call(object,key)&&error('Duplicate key \"'+key+'\"'),object[key]=value(),white(),\"}\"===ch)return next(\"}\"),object;next(\",\"),white()}}error(\"Bad object\")};return value=function(){switch(white(),ch){case\"{\":return object();case\"[\":return array();case'\"':return string();case\"-\":return number();default:return ch>=\"0\"&&\"9\">=ch?number():word()}},function(source,reviver){var result;return text=source,at=0,ch=\" \",result=value(),white(),ch&&error(\"Syntax error\"),\"function\"==typeof reviver?function walk(holder,key){var k,v,value=holder[key];if(value&&\"object\"==typeof value)for(k in value)Object.hasOwnProperty.call(value,k)&&(v=walk(value,k),void 0!==v?value[k]=v:delete value[k]);return reviver.call(holder,key,value)}({\"\":result},\"\"):result}}),ace.define(\"ace/mode/json_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/worker/mirror\",\"ace/mode/json/json_parse\"],function(acequire,exports){\"use strict\";var oop=acequire(\"../lib/oop\"),Mirror=acequire(\"../worker/mirror\").Mirror,parse=acequire(\"./json/json_parse\"),JsonWorker=exports.JsonWorker=function(sender){Mirror.call(this,sender),this.setTimeout(200)};oop.inherits(JsonWorker,Mirror),function(){this.onUpdate=function(){var value=this.doc.getValue(),errors=[];try{value&&parse(value)}catch(e){var pos=this.doc.indexToPosition(e.at-1);errors.push({row:pos.row,column:pos.column,text:e.message,type:\"error\"})}this.sender.emit(\"annotate\",errors)}}.call(JsonWorker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0\n}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(171);
	var Transform = __webpack_require__(172);
	var inherits = __webpack_require__(30);
	var modes = __webpack_require__(173);
	var StreamCipher = __webpack_require__(287);
	var ebtk = __webpack_require__(281);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(285),
	  CBC: __webpack_require__(282),
	  CFB: __webpack_require__(283),
	  OFB: __webpack_require__(286),
	  CTR: __webpack_require__(284)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(171);
	var Transform = __webpack_require__(172);
	var inherits = __webpack_require__(30);
	var modes = __webpack_require__(173);
	var ebtk = __webpack_require__(281);
	var StreamCipher = __webpack_require__(287);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(285),
	  CBC: __webpack_require__(282),
	  CFB: __webpack_require__(283),
	  OFB: __webpack_require__(286),
	  CTR: __webpack_require__(284)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(655)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(654)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(173);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {var msg = __webpack_require__(530);
	var zstream = __webpack_require__(1554);
	var zlib_deflate = __webpack_require__(1549);
	var zlib_inflate = __webpack_require__(1551);
	var constants = __webpack_require__(1548);
	
	for (var key in constants) {
	  exports[key] = constants[key];
	}
	
	// zlib modes
	exports.NONE = 0;
	exports.DEFLATE = 1;
	exports.INFLATE = 2;
	exports.GZIP = 3;
	exports.GUNZIP = 4;
	exports.DEFLATERAW = 5;
	exports.INFLATERAW = 6;
	exports.UNZIP = 7;
	
	/**
	 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
	 */
	function Zlib(mode) {
	  if (mode < exports.DEFLATE || mode > exports.UNZIP)
	    throw new TypeError("Bad argument");
	    
	  this.mode = mode;
	  this.init_done = false;
	  this.write_in_progress = false;
	  this.pending_close = false;
	  this.windowBits = 0;
	  this.level = 0;
	  this.memLevel = 0;
	  this.strategy = 0;
	  this.dictionary = null;
	}
	
	Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
	  this.windowBits = windowBits;
	  this.level = level;
	  this.memLevel = memLevel;
	  this.strategy = strategy;
	  // dictionary not supported.
	  
	  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP)
	    this.windowBits += 16;
	    
	  if (this.mode === exports.UNZIP)
	    this.windowBits += 32;
	    
	  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW)
	    this.windowBits = -this.windowBits;
	    
	  this.strm = new zstream();
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateInit2(
	        this.strm,
	        this.level,
	        exports.Z_DEFLATED,
	        this.windowBits,
	        this.memLevel,
	        this.strategy
	      );
	      break;
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	    case exports.UNZIP:
	      var status  = zlib_inflate.inflateInit2(
	        this.strm,
	        this.windowBits
	      );
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	    return;
	  }
	  
	  this.write_in_progress = false;
	  this.init_done = true;
	};
	
	Zlib.prototype.params = function() {
	  throw new Error("deflateParams Not supported");
	};
	
	Zlib.prototype._writeCheck = function() {
	  if (!this.init_done)
	    throw new Error("write before init");
	    
	  if (this.mode === exports.NONE)
	    throw new Error("already finalized");
	    
	  if (this.write_in_progress)
	    throw new Error("write already in progress");
	    
	  if (this.pending_close)
	    throw new Error("close is pending");
	};
	
	Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {    
	  this._writeCheck();
	  this.write_in_progress = true;
	  
	  var self = this;
	  process.nextTick(function() {
	    self.write_in_progress = false;
	    var res = self._write(flush, input, in_off, in_len, out, out_off, out_len);
	    self.callback(res[0], res[1]);
	    
	    if (self.pending_close)
	      self.close();
	  });
	  
	  return this;
	};
	
	// set method for Node buffers, used by pako
	function bufferSet(data, offset) {
	  for (var i = 0; i < data.length; i++) {
	    this[offset + i] = data[i];
	  }
	}
	
	Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this._writeCheck();
	  return this._write(flush, input, in_off, in_len, out, out_off, out_len);
	};
	
	Zlib.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this.write_in_progress = true;
	  
	  if (flush !== exports.Z_NO_FLUSH &&
	      flush !== exports.Z_PARTIAL_FLUSH &&
	      flush !== exports.Z_SYNC_FLUSH &&
	      flush !== exports.Z_FULL_FLUSH &&
	      flush !== exports.Z_FINISH &&
	      flush !== exports.Z_BLOCK) {
	    throw new Error("Invalid flush value");
	  }
	  
	  if (input == null) {
	    input = new Buffer(0);
	    in_len = 0;
	    in_off = 0;
	  }
	  
	  if (out._set)
	    out.set = out._set;
	  else
	    out.set = bufferSet;
	  
	  var strm = this.strm;
	  strm.avail_in = in_len;
	  strm.input = input;
	  strm.next_in = in_off;
	  strm.avail_out = out_len;
	  strm.output = out;
	  strm.next_out = out_off;
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflate(strm, flush);
	      break;
	    case exports.UNZIP:
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflate(strm, flush);
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_STREAM_END && status !== exports.Z_OK) {
	    this._error(status);
	  }
	  
	  this.write_in_progress = false;
	  return [strm.avail_in, strm.avail_out];
	};
	
	Zlib.prototype.close = function() {
	  if (this.write_in_progress) {
	    this.pending_close = true;
	    return;
	  }
	  
	  this.pending_close = false;
	  
	  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
	    zlib_deflate.deflateEnd(this.strm);
	  } else {
	    zlib_inflate.inflateEnd(this.strm);
	  }
	  
	  this.mode = exports.NONE;
	};
	
	Zlib.prototype.reset = function() {
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateReset(this.strm);
	      break;
	    case exports.INFLATE:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflateReset(this.strm);
	      break;
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	  }
	};
	
	Zlib.prototype._error = function(status) {
	  this.onerror(msg[status] + ': ' + this.strm.msg, status);
	  
	  this.write_in_progress = false;
	  if (this.pending_close)
	    this.close();
	};
	
	exports.Zlib = Zlib;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(15).Buffer))

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Transform = __webpack_require__(571);
	
	var binding = __webpack_require__(657);
	var util = __webpack_require__(36);
	var assert = __webpack_require__(269).ok;
	
	// zlib doesn't provide these, so kludge them in following the same
	// const naming scheme zlib uses.
	binding.Z_MIN_WINDOWBITS = 8;
	binding.Z_MAX_WINDOWBITS = 15;
	binding.Z_DEFAULT_WINDOWBITS = 15;
	
	// fewer than 64 bytes per chunk is stupid.
	// technically it could work with as few as 8, but even 64 bytes
	// is absurdly low.  Usually a MB or more is best.
	binding.Z_MIN_CHUNK = 64;
	binding.Z_MAX_CHUNK = Infinity;
	binding.Z_DEFAULT_CHUNK = (16 * 1024);
	
	binding.Z_MIN_MEMLEVEL = 1;
	binding.Z_MAX_MEMLEVEL = 9;
	binding.Z_DEFAULT_MEMLEVEL = 8;
	
	binding.Z_MIN_LEVEL = -1;
	binding.Z_MAX_LEVEL = 9;
	binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
	
	// expose all the zlib constants
	Object.keys(binding).forEach(function(k) {
	  if (k.match(/^Z/)) exports[k] = binding[k];
	});
	
	// translation table for return codes.
	exports.codes = {
	  Z_OK: binding.Z_OK,
	  Z_STREAM_END: binding.Z_STREAM_END,
	  Z_NEED_DICT: binding.Z_NEED_DICT,
	  Z_ERRNO: binding.Z_ERRNO,
	  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
	  Z_DATA_ERROR: binding.Z_DATA_ERROR,
	  Z_MEM_ERROR: binding.Z_MEM_ERROR,
	  Z_BUF_ERROR: binding.Z_BUF_ERROR,
	  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
	};
	
	Object.keys(exports.codes).forEach(function(k) {
	  exports.codes[exports.codes[k]] = k;
	});
	
	exports.Deflate = Deflate;
	exports.Inflate = Inflate;
	exports.Gzip = Gzip;
	exports.Gunzip = Gunzip;
	exports.DeflateRaw = DeflateRaw;
	exports.InflateRaw = InflateRaw;
	exports.Unzip = Unzip;
	
	exports.createDeflate = function(o) {
	  return new Deflate(o);
	};
	
	exports.createInflate = function(o) {
	  return new Inflate(o);
	};
	
	exports.createDeflateRaw = function(o) {
	  return new DeflateRaw(o);
	};
	
	exports.createInflateRaw = function(o) {
	  return new InflateRaw(o);
	};
	
	exports.createGzip = function(o) {
	  return new Gzip(o);
	};
	
	exports.createGunzip = function(o) {
	  return new Gunzip(o);
	};
	
	exports.createUnzip = function(o) {
	  return new Unzip(o);
	};
	
	
	// Convenience methods.
	// compress/decompress a string or buffer in one step.
	exports.deflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Deflate(opts), buffer, callback);
	};
	
	exports.deflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Deflate(opts), buffer);
	};
	
	exports.gzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gzip(opts), buffer, callback);
	};
	
	exports.gzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gzip(opts), buffer);
	};
	
	exports.deflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
	};
	
	exports.deflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new DeflateRaw(opts), buffer);
	};
	
	exports.unzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Unzip(opts), buffer, callback);
	};
	
	exports.unzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Unzip(opts), buffer);
	};
	
	exports.inflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Inflate(opts), buffer, callback);
	};
	
	exports.inflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Inflate(opts), buffer);
	};
	
	exports.gunzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gunzip(opts), buffer, callback);
	};
	
	exports.gunzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gunzip(opts), buffer);
	};
	
	exports.inflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new InflateRaw(opts), buffer, callback);
	};
	
	exports.inflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new InflateRaw(opts), buffer);
	};
	
	function zlibBuffer(engine, buffer, callback) {
	  var buffers = [];
	  var nread = 0;
	
	  engine.on('error', onError);
	  engine.on('end', onEnd);
	
	  engine.end(buffer);
	  flow();
	
	  function flow() {
	    var chunk;
	    while (null !== (chunk = engine.read())) {
	      buffers.push(chunk);
	      nread += chunk.length;
	    }
	    engine.once('readable', flow);
	  }
	
	  function onError(err) {
	    engine.removeListener('end', onEnd);
	    engine.removeListener('readable', flow);
	    callback(err);
	  }
	
	  function onEnd() {
	    var buf = Buffer.concat(buffers, nread);
	    buffers = [];
	    callback(null, buf);
	    engine.close();
	  }
	}
	
	function zlibBufferSync(engine, buffer) {
	  if (typeof buffer === 'string')
	    buffer = new Buffer(buffer);
	  if (!Buffer.isBuffer(buffer))
	    throw new TypeError('Not a string or buffer');
	
	  var flushFlag = binding.Z_FINISH;
	
	  return engine._processChunk(buffer, flushFlag);
	}
	
	// generic zlib
	// minimal 2-byte header
	function Deflate(opts) {
	  if (!(this instanceof Deflate)) return new Deflate(opts);
	  Zlib.call(this, opts, binding.DEFLATE);
	}
	
	function Inflate(opts) {
	  if (!(this instanceof Inflate)) return new Inflate(opts);
	  Zlib.call(this, opts, binding.INFLATE);
	}
	
	
	
	// gzip - bigger header, same deflate compression
	function Gzip(opts) {
	  if (!(this instanceof Gzip)) return new Gzip(opts);
	  Zlib.call(this, opts, binding.GZIP);
	}
	
	function Gunzip(opts) {
	  if (!(this instanceof Gunzip)) return new Gunzip(opts);
	  Zlib.call(this, opts, binding.GUNZIP);
	}
	
	
	
	// raw - no header
	function DeflateRaw(opts) {
	  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
	  Zlib.call(this, opts, binding.DEFLATERAW);
	}
	
	function InflateRaw(opts) {
	  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
	  Zlib.call(this, opts, binding.INFLATERAW);
	}
	
	
	// auto-detect header.
	function Unzip(opts) {
	  if (!(this instanceof Unzip)) return new Unzip(opts);
	  Zlib.call(this, opts, binding.UNZIP);
	}
	
	
	// the Zlib class they all inherit from
	// This thing manages the queue of requests, and returns
	// true or false if there is anything in the queue when
	// you call the .write() method.
	
	function Zlib(opts, mode) {
	  this._opts = opts = opts || {};
	  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
	
	  Transform.call(this, opts);
	
	  if (opts.flush) {
	    if (opts.flush !== binding.Z_NO_FLUSH &&
	        opts.flush !== binding.Z_PARTIAL_FLUSH &&
	        opts.flush !== binding.Z_SYNC_FLUSH &&
	        opts.flush !== binding.Z_FULL_FLUSH &&
	        opts.flush !== binding.Z_FINISH &&
	        opts.flush !== binding.Z_BLOCK) {
	      throw new Error('Invalid flush flag: ' + opts.flush);
	    }
	  }
	  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
	
	  if (opts.chunkSize) {
	    if (opts.chunkSize < exports.Z_MIN_CHUNK ||
	        opts.chunkSize > exports.Z_MAX_CHUNK) {
	      throw new Error('Invalid chunk size: ' + opts.chunkSize);
	    }
	  }
	
	  if (opts.windowBits) {
	    if (opts.windowBits < exports.Z_MIN_WINDOWBITS ||
	        opts.windowBits > exports.Z_MAX_WINDOWBITS) {
	      throw new Error('Invalid windowBits: ' + opts.windowBits);
	    }
	  }
	
	  if (opts.level) {
	    if (opts.level < exports.Z_MIN_LEVEL ||
	        opts.level > exports.Z_MAX_LEVEL) {
	      throw new Error('Invalid compression level: ' + opts.level);
	    }
	  }
	
	  if (opts.memLevel) {
	    if (opts.memLevel < exports.Z_MIN_MEMLEVEL ||
	        opts.memLevel > exports.Z_MAX_MEMLEVEL) {
	      throw new Error('Invalid memLevel: ' + opts.memLevel);
	    }
	  }
	
	  if (opts.strategy) {
	    if (opts.strategy != exports.Z_FILTERED &&
	        opts.strategy != exports.Z_HUFFMAN_ONLY &&
	        opts.strategy != exports.Z_RLE &&
	        opts.strategy != exports.Z_FIXED &&
	        opts.strategy != exports.Z_DEFAULT_STRATEGY) {
	      throw new Error('Invalid strategy: ' + opts.strategy);
	    }
	  }
	
	  if (opts.dictionary) {
	    if (!Buffer.isBuffer(opts.dictionary)) {
	      throw new Error('Invalid dictionary: it should be a Buffer instance');
	    }
	  }
	
	  this._binding = new binding.Zlib(mode);
	
	  var self = this;
	  this._hadError = false;
	  this._binding.onerror = function(message, errno) {
	    // there is no way to cleanly recover.
	    // continuing only obscures problems.
	    self._binding = null;
	    self._hadError = true;
	
	    var error = new Error(message);
	    error.errno = errno;
	    error.code = exports.codes[errno];
	    self.emit('error', error);
	  };
	
	  var level = exports.Z_DEFAULT_COMPRESSION;
	  if (typeof opts.level === 'number') level = opts.level;
	
	  var strategy = exports.Z_DEFAULT_STRATEGY;
	  if (typeof opts.strategy === 'number') strategy = opts.strategy;
	
	  this._binding.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
	                     level,
	                     opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
	                     strategy,
	                     opts.dictionary);
	
	  this._buffer = new Buffer(this._chunkSize);
	  this._offset = 0;
	  this._closed = false;
	  this._level = level;
	  this._strategy = strategy;
	
	  this.once('end', this.close);
	}
	
	util.inherits(Zlib, Transform);
	
	Zlib.prototype.params = function(level, strategy, callback) {
	  if (level < exports.Z_MIN_LEVEL ||
	      level > exports.Z_MAX_LEVEL) {
	    throw new RangeError('Invalid compression level: ' + level);
	  }
	  if (strategy != exports.Z_FILTERED &&
	      strategy != exports.Z_HUFFMAN_ONLY &&
	      strategy != exports.Z_RLE &&
	      strategy != exports.Z_FIXED &&
	      strategy != exports.Z_DEFAULT_STRATEGY) {
	    throw new TypeError('Invalid strategy: ' + strategy);
	  }
	
	  if (this._level !== level || this._strategy !== strategy) {
	    var self = this;
	    this.flush(binding.Z_SYNC_FLUSH, function() {
	      self._binding.params(level, strategy);
	      if (!self._hadError) {
	        self._level = level;
	        self._strategy = strategy;
	        if (callback) callback();
	      }
	    });
	  } else {
	    process.nextTick(callback);
	  }
	};
	
	Zlib.prototype.reset = function() {
	  return this._binding.reset();
	};
	
	// This is the _flush function called by the transform class,
	// internally, when the last chunk has been written.
	Zlib.prototype._flush = function(callback) {
	  this._transform(new Buffer(0), '', callback);
	};
	
	Zlib.prototype.flush = function(kind, callback) {
	  var ws = this._writableState;
	
	  if (typeof kind === 'function' || (kind === void 0 && !callback)) {
	    callback = kind;
	    kind = binding.Z_FULL_FLUSH;
	  }
	
	  if (ws.ended) {
	    if (callback)
	      process.nextTick(callback);
	  } else if (ws.ending) {
	    if (callback)
	      this.once('end', callback);
	  } else if (ws.needDrain) {
	    var self = this;
	    this.once('drain', function() {
	      self.flush(callback);
	    });
	  } else {
	    this._flushFlag = kind;
	    this.write(new Buffer(0), '', callback);
	  }
	};
	
	Zlib.prototype.close = function(callback) {
	  if (callback)
	    process.nextTick(callback);
	
	  if (this._closed)
	    return;
	
	  this._closed = true;
	
	  this._binding.close();
	
	  var self = this;
	  process.nextTick(function() {
	    self.emit('close');
	  });
	};
	
	Zlib.prototype._transform = function(chunk, encoding, cb) {
	  var flushFlag;
	  var ws = this._writableState;
	  var ending = ws.ending || ws.ended;
	  var last = ending && (!chunk || ws.length === chunk.length);
	
	  if (!chunk === null && !Buffer.isBuffer(chunk))
	    return cb(new Error('invalid input'));
	
	  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
	  // If it's explicitly flushing at some other time, then we use
	  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
	  // goodness.
	  if (last)
	    flushFlag = binding.Z_FINISH;
	  else {
	    flushFlag = this._flushFlag;
	    // once we've flushed the last of the queue, stop flushing and
	    // go back to the normal behavior.
	    if (chunk.length >= ws.length) {
	      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
	    }
	  }
	
	  var self = this;
	  this._processChunk(chunk, flushFlag, cb);
	};
	
	Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
	  var availInBefore = chunk && chunk.length;
	  var availOutBefore = this._chunkSize - this._offset;
	  var inOff = 0;
	
	  var self = this;
	
	  var async = typeof cb === 'function';
	
	  if (!async) {
	    var buffers = [];
	    var nread = 0;
	
	    var error;
	    this.on('error', function(er) {
	      error = er;
	    });
	
	    do {
	      var res = this._binding.writeSync(flushFlag,
	                                        chunk, // in
	                                        inOff, // in_off
	                                        availInBefore, // in_len
	                                        this._buffer, // out
	                                        this._offset, //out_off
	                                        availOutBefore); // out_len
	    } while (!this._hadError && callback(res[0], res[1]));
	
	    if (this._hadError) {
	      throw error;
	    }
	
	    var buf = Buffer.concat(buffers, nread);
	    this.close();
	
	    return buf;
	  }
	
	  var req = this._binding.write(flushFlag,
	                                chunk, // in
	                                inOff, // in_off
	                                availInBefore, // in_len
	                                this._buffer, // out
	                                this._offset, //out_off
	                                availOutBefore); // out_len
	
	  req.buffer = chunk;
	  req.callback = callback;
	
	  function callback(availInAfter, availOutAfter) {
	    if (self._hadError)
	      return;
	
	    var have = availOutBefore - availOutAfter;
	    assert(have >= 0, 'have should not go down');
	
	    if (have > 0) {
	      var out = self._buffer.slice(self._offset, self._offset + have);
	      self._offset += have;
	      // serve some output to the consumer.
	      if (async) {
	        self.push(out);
	      } else {
	        buffers.push(out);
	        nread += out.length;
	      }
	    }
	
	    // exhausted the output buffer, or used all the input create a new one.
	    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
	      availOutBefore = self._chunkSize;
	      self._offset = 0;
	      self._buffer = new Buffer(self._chunkSize);
	    }
	
	    if (availOutAfter === 0) {
	      // Not actually done.  Need to reprocess.
	      // Also, update the availInBefore to the availInAfter value,
	      // so that if we have to hit it a third (fourth, etc.) time,
	      // it'll have the correct byte counts.
	      inOff += (availInBefore - availInAfter);
	      availInBefore = availInAfter;
	
	      if (!async)
	        return true;
	
	      var newReq = self._binding.write(flushFlag,
	                                       chunk,
	                                       inOff,
	                                       availInBefore,
	                                       self._buffer,
	                                       self._offset,
	                                       self._chunkSize);
	      newReq.callback = callback; // this same function
	      newReq.buffer = chunk;
	      return;
	    }
	
	    if (!async)
	      return false;
	
	    // finished with the chunk.
	    cb();
	  }
	};
	
	util.inherits(Deflate, Zlib);
	util.inherits(Inflate, Zlib);
	util.inherits(Gzip, Zlib);
	util.inherits(Gunzip, Zlib);
	util.inherits(DeflateRaw, Zlib);
	util.inherits(InflateRaw, Zlib);
	util.inherits(Unzip, Zlib);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer, __webpack_require__(28)))

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	;(function (exports) {
		'use strict';
	
	  var Arr = (typeof Uint8Array !== 'undefined')
	    ? Uint8Array
	    : Array
	
		var PLUS   = '+'.charCodeAt(0)
		var SLASH  = '/'.charCodeAt(0)
		var NUMBER = '0'.charCodeAt(0)
		var LOWER  = 'a'.charCodeAt(0)
		var UPPER  = 'A'.charCodeAt(0)
		var PLUS_URL_SAFE = '-'.charCodeAt(0)
		var SLASH_URL_SAFE = '_'.charCodeAt(0)
	
		function decode (elt) {
			var code = elt.charCodeAt(0)
			if (code === PLUS ||
			    code === PLUS_URL_SAFE)
				return 62 // '+'
			if (code === SLASH ||
			    code === SLASH_URL_SAFE)
				return 63 // '/'
			if (code < NUMBER)
				return -1 //no match
			if (code < NUMBER + 10)
				return code - NUMBER + 26 + 26
			if (code < UPPER + 26)
				return code - UPPER
			if (code < LOWER + 26)
				return code - LOWER + 26
		}
	
		function b64ToByteArray (b64) {
			var i, j, l, tmp, placeHolders, arr
	
			if (b64.length % 4 > 0) {
				throw new Error('Invalid string. Length must be a multiple of 4')
			}
	
			// the number of equal signs (place holders)
			// if there are two placeholders, than the two characters before it
			// represent one byte
			// if there is only one, then the three characters before it represent 2 bytes
			// this is just a cheap hack to not do indexOf twice
			var len = b64.length
			placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0
	
			// base64 is 4/3 + up to two characters of the original data
			arr = new Arr(b64.length * 3 / 4 - placeHolders)
	
			// if there are placeholders, only get up to the last complete 4 chars
			l = placeHolders > 0 ? b64.length - 4 : b64.length
	
			var L = 0
	
			function push (v) {
				arr[L++] = v
			}
	
			for (i = 0, j = 0; i < l; i += 4, j += 3) {
				tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
				push((tmp & 0xFF0000) >> 16)
				push((tmp & 0xFF00) >> 8)
				push(tmp & 0xFF)
			}
	
			if (placeHolders === 2) {
				tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
				push(tmp & 0xFF)
			} else if (placeHolders === 1) {
				tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
				push((tmp >> 8) & 0xFF)
				push(tmp & 0xFF)
			}
	
			return arr
		}
	
		function uint8ToBase64 (uint8) {
			var i,
				extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
				output = "",
				temp, length
	
			function encode (num) {
				return lookup.charAt(num)
			}
	
			function tripletToBase64 (num) {
				return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
			}
	
			// go through the array every three bytes, we'll deal with trailing stuff later
			for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
				temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
				output += tripletToBase64(temp)
			}
	
			// pad the end with zeros, but make sure to not forget the extra bytes
			switch (extraBytes) {
				case 1:
					temp = uint8[uint8.length - 1]
					output += encode(temp >> 2)
					output += encode((temp << 4) & 0x3F)
					output += '=='
					break
				case 2:
					temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
					output += encode(temp >> 10)
					output += encode((temp >> 4) & 0x3F)
					output += encode((temp << 2) & 0x3F)
					output += '='
					break
			}
	
			return output
		}
	
		exports.toByteArray = b64ToByteArray
		exports.fromByteArray = uint8ToBase64
	}( false ? (this.base64js = {}) : exports))


/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports = {
	  "100": "Continue",
	  "101": "Switching Protocols",
	  "102": "Processing",
	  "200": "OK",
	  "201": "Created",
	  "202": "Accepted",
	  "203": "Non-Authoritative Information",
	  "204": "No Content",
	  "205": "Reset Content",
	  "206": "Partial Content",
	  "207": "Multi-Status",
	  "208": "Already Reported",
	  "226": "IM Used",
	  "300": "Multiple Choices",
	  "301": "Moved Permanently",
	  "302": "Found",
	  "303": "See Other",
	  "304": "Not Modified",
	  "305": "Use Proxy",
	  "307": "Temporary Redirect",
	  "308": "Permanent Redirect",
	  "400": "Bad Request",
	  "401": "Unauthorized",
	  "402": "Payment Required",
	  "403": "Forbidden",
	  "404": "Not Found",
	  "405": "Method Not Allowed",
	  "406": "Not Acceptable",
	  "407": "Proxy Authentication Required",
	  "408": "Request Timeout",
	  "409": "Conflict",
	  "410": "Gone",
	  "411": "Length Required",
	  "412": "Precondition Failed",
	  "413": "Payload Too Large",
	  "414": "URI Too Long",
	  "415": "Unsupported Media Type",
	  "416": "Range Not Satisfiable",
	  "417": "Expectation Failed",
	  "418": "I'm a teapot",
	  "421": "Misdirected Request",
	  "422": "Unprocessable Entity",
	  "423": "Locked",
	  "424": "Failed Dependency",
	  "425": "Unordered Collection",
	  "426": "Upgrade Required",
	  "428": "Precondition Required",
	  "429": "Too Many Requests",
	  "431": "Request Header Fields Too Large",
	  "451": "Unavailable For Legal Reasons",
	  "500": "Internal Server Error",
	  "501": "Not Implemented",
	  "502": "Bad Gateway",
	  "503": "Service Unavailable",
	  "504": "Gateway Timeout",
	  "505": "HTTP Version Not Supported",
	  "506": "Variant Also Negotiates",
	  "507": "Insufficient Storage",
	  "508": "Loop Detected",
	  "509": "Bandwidth Limit Exceeded",
	  "510": "Not Extended",
	  "511": "Network Authentication Required"
	}


/***/ }),
/* 661 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(573)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('select'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.select);
	        global.clipboardAction = mod.exports;
	    }
	})(this, function (module, _select) {
	    'use strict';
	
	    var _select2 = _interopRequireDefault(_select);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    var ClipboardAction = function () {
	        /**
	         * @param {Object} options
	         */
	        function ClipboardAction(options) {
	            _classCallCheck(this, ClipboardAction);
	
	            this.resolveOptions(options);
	            this.initSelection();
	        }
	
	        /**
	         * Defines base properties passed from constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(ClipboardAction, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = options.action;
	                this.container = options.container;
	                this.emitter = options.emitter;
	                this.target = options.target;
	                this.text = options.text;
	                this.trigger = options.trigger;
	
	                this.selectedText = '';
	            }
	        }, {
	            key: 'initSelection',
	            value: function initSelection() {
	                if (this.text) {
	                    this.selectFake();
	                } else if (this.target) {
	                    this.selectTarget();
	                }
	            }
	        }, {
	            key: 'selectFake',
	            value: function selectFake() {
	                var _this = this;
	
	                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
	
	                this.removeFake();
	
	                this.fakeHandlerCallback = function () {
	                    return _this.removeFake();
	                };
	                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
	
	                this.fakeElem = document.createElement('textarea');
	                // Prevent zooming on iOS
	                this.fakeElem.style.fontSize = '12pt';
	                // Reset box model
	                this.fakeElem.style.border = '0';
	                this.fakeElem.style.padding = '0';
	                this.fakeElem.style.margin = '0';
	                // Move element out of screen horizontally
	                this.fakeElem.style.position = 'absolute';
	                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	                // Move element to the same position vertically
	                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	                this.fakeElem.style.top = yPosition + 'px';
	
	                this.fakeElem.setAttribute('readonly', '');
	                this.fakeElem.value = this.text;
	
	                this.container.appendChild(this.fakeElem);
	
	                this.selectedText = (0, _select2.default)(this.fakeElem);
	                this.copyText();
	            }
	        }, {
	            key: 'removeFake',
	            value: function removeFake() {
	                if (this.fakeHandler) {
	                    this.container.removeEventListener('click', this.fakeHandlerCallback);
	                    this.fakeHandler = null;
	                    this.fakeHandlerCallback = null;
	                }
	
	                if (this.fakeElem) {
	                    this.container.removeChild(this.fakeElem);
	                    this.fakeElem = null;
	                }
	            }
	        }, {
	            key: 'selectTarget',
	            value: function selectTarget() {
	                this.selectedText = (0, _select2.default)(this.target);
	                this.copyText();
	            }
	        }, {
	            key: 'copyText',
	            value: function copyText() {
	                var succeeded = void 0;
	
	                try {
	                    succeeded = document.execCommand(this.action);
	                } catch (err) {
	                    succeeded = false;
	                }
	
	                this.handleResult(succeeded);
	            }
	        }, {
	            key: 'handleResult',
	            value: function handleResult(succeeded) {
	                this.emitter.emit(succeeded ? 'success' : 'error', {
	                    action: this.action,
	                    text: this.selectedText,
	                    trigger: this.trigger,
	                    clearSelection: this.clearSelection.bind(this)
	                });
	            }
	        }, {
	            key: 'clearSelection',
	            value: function clearSelection() {
	                if (this.trigger) {
	                    this.trigger.focus();
	                }
	
	                window.getSelection().removeAllRanges();
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.removeFake();
	            }
	        }, {
	            key: 'action',
	            set: function set() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
	
	                this._action = action;
	
	                if (this._action !== 'copy' && this._action !== 'cut') {
	                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
	                }
	            },
	            get: function get() {
	                return this._action;
	            }
	        }, {
	            key: 'target',
	            set: function set(target) {
	                if (target !== undefined) {
	                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
	                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
	                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	                        }
	
	                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	                        }
	
	                        this._target = target;
	                    } else {
	                        throw new Error('Invalid "target" value, use a valid Element');
	                    }
	                }
	            },
	            get: function get() {
	                return this._target;
	            }
	        }]);
	
	        return ClipboardAction;
	    }();
	
	    module.exports = ClipboardAction;
	});

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(662), __webpack_require__(1712), __webpack_require__(315)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
	        global.clipboard = mod.exports;
	    }
	})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
	    'use strict';
	
	    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);
	
	    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);
	
	    var _goodListener2 = _interopRequireDefault(_goodListener);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var Clipboard = function (_Emitter) {
	        _inherits(Clipboard, _Emitter);
	
	        /**
	         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	         * @param {Object} options
	         */
	        function Clipboard(trigger, options) {
	            _classCallCheck(this, Clipboard);
	
	            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
	
	            _this.resolveOptions(options);
	            _this.listenClick(trigger);
	            return _this;
	        }
	
	        /**
	         * Defines if attributes would be resolved using internal setter functions
	         * or custom functions that were passed in the constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(Clipboard, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
	            }
	        }, {
	            key: 'listenClick',
	            value: function listenClick(trigger) {
	                var _this2 = this;
	
	                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
	                    return _this2.onClick(e);
	                });
	            }
	        }, {
	            key: 'onClick',
	            value: function onClick(e) {
	                var trigger = e.delegateTarget || e.currentTarget;
	
	                if (this.clipboardAction) {
	                    this.clipboardAction = null;
	                }
	
	                this.clipboardAction = new _clipboardAction2.default({
	                    action: this.action(trigger),
	                    target: this.target(trigger),
	                    text: this.text(trigger),
	                    container: this.container,
	                    trigger: trigger,
	                    emitter: this
	                });
	            }
	        }, {
	            key: 'defaultAction',
	            value: function defaultAction(trigger) {
	                return getAttributeValue('action', trigger);
	            }
	        }, {
	            key: 'defaultTarget',
	            value: function defaultTarget(trigger) {
	                var selector = getAttributeValue('target', trigger);
	
	                if (selector) {
	                    return document.querySelector(selector);
	                }
	            }
	        }, {
	            key: 'defaultText',
	            value: function defaultText(trigger) {
	                return getAttributeValue('text', trigger);
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.listener.destroy();
	
	                if (this.clipboardAction) {
	                    this.clipboardAction.destroy();
	                    this.clipboardAction = null;
	                }
	            }
	        }], [{
	            key: 'isSupported',
	            value: function isSupported() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
	
	                var actions = typeof action === 'string' ? [action] : action;
	                var support = !!document.queryCommandSupported;
	
	                actions.forEach(function (action) {
	                    support = support && !!document.queryCommandSupported(action);
	                });
	
	                return support;
	            }
	        }]);
	
	        return Clipboard;
	    }(_tinyEmitter2.default);
	
	    /**
	     * Helper function to retrieve attribute value.
	     * @param {String} suffix
	     * @param {Element} element
	     */
	    function getAttributeValue(suffix, element) {
	        var attribute = 'data-clipboard-' + suffix;
	
	        if (!element.hasAttribute(attribute)) {
	            return;
	        }
	
	        return element.getAttribute(attribute);
	    }
	
	    module.exports = Clipboard;
	});

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth == 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(127);
	__webpack_require__(697);
	module.exports = __webpack_require__(27).Array.from;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(188);
	__webpack_require__(127);
	module.exports = __webpack_require__(695);


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(188);
	__webpack_require__(127);
	module.exports = __webpack_require__(696);


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(699);
	module.exports = __webpack_require__(27).Object.assign;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(700);
	var $Object = __webpack_require__(27).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(701);
	var $Object = __webpack_require__(27).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(702);
	module.exports = __webpack_require__(27).Object.getPrototypeOf;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(703);
	module.exports = __webpack_require__(27).Object.keys;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(704);
	module.exports = __webpack_require__(27).Object.setPrototypeOf;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(706);
	__webpack_require__(705);
	__webpack_require__(707);
	__webpack_require__(708);
	module.exports = __webpack_require__(27).Symbol;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(127);
	__webpack_require__(188);
	module.exports = __webpack_require__(187).f('iterator');


/***/ }),
/* 676 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 677 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(85);
	var toLength = __webpack_require__(301);
	var toAbsoluteIndex = __webpack_require__(694);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(64);
	var createDesc = __webpack_require__(102);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(101);
	var gOPS = __webpack_require__(180);
	var pIE = __webpack_require__(125);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(63).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(84);
	var ITERATOR = __webpack_require__(37)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(175);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(66);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(179);
	var descriptor = __webpack_require__(102);
	var setToStringTag = __webpack_require__(181);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(82)(IteratorPrototype, __webpack_require__(37)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(37)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 687 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(126)('meta');
	var isObject = __webpack_require__(83);
	var has = __webpack_require__(68);
	var setDesc = __webpack_require__(64).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(81)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(101);
	var gOPS = __webpack_require__(180);
	var pIE = __webpack_require__(125);
	var toObject = __webpack_require__(103);
	var IObject = __webpack_require__(293);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(81)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(64);
	var anObject = __webpack_require__(66);
	var getKeys = __webpack_require__(101);
	
	module.exports = __webpack_require__(67) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(85);
	var gOPN = __webpack_require__(296).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(83);
	var anObject = __webpack_require__(66);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(176)(Function.call, __webpack_require__(295).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(184);
	var defined = __webpack_require__(177);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(184);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var get = __webpack_require__(302);
	module.exports = __webpack_require__(27).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(290);
	var ITERATOR = __webpack_require__(37)('iterator');
	var Iterators = __webpack_require__(84);
	module.exports = __webpack_require__(27).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(176);
	var $export = __webpack_require__(62);
	var toObject = __webpack_require__(103);
	var call = __webpack_require__(684);
	var isArrayIter = __webpack_require__(682);
	var toLength = __webpack_require__(301);
	var createProperty = __webpack_require__(679);
	var getIterFn = __webpack_require__(302);
	
	$export($export.S + $export.F * !__webpack_require__(686)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(677);
	var step = __webpack_require__(687);
	var Iterators = __webpack_require__(84);
	var toIObject = __webpack_require__(85);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(294)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(62);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(689) });


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(62);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(179) });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(62);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(67), 'Object', { defineProperty: __webpack_require__(64).f });


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(103);
	var $getPrototypeOf = __webpack_require__(297);
	
	__webpack_require__(299)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(103);
	var $keys = __webpack_require__(101);
	
	__webpack_require__(299)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(62);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(692).set });


/***/ }),
/* 705 */
525,
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(63);
	var has = __webpack_require__(68);
	var DESCRIPTORS = __webpack_require__(67);
	var $export = __webpack_require__(62);
	var redefine = __webpack_require__(300);
	var META = __webpack_require__(688).KEY;
	var $fails = __webpack_require__(81);
	var shared = __webpack_require__(183);
	var setToStringTag = __webpack_require__(181);
	var uid = __webpack_require__(126);
	var wks = __webpack_require__(37);
	var wksExt = __webpack_require__(187);
	var wksDefine = __webpack_require__(186);
	var enumKeys = __webpack_require__(680);
	var isArray = __webpack_require__(683);
	var anObject = __webpack_require__(66);
	var isObject = __webpack_require__(83);
	var toIObject = __webpack_require__(85);
	var toPrimitive = __webpack_require__(185);
	var createDesc = __webpack_require__(102);
	var _create = __webpack_require__(179);
	var gOPNExt = __webpack_require__(691);
	var $GOPD = __webpack_require__(295);
	var $DP = __webpack_require__(64);
	var $keys = __webpack_require__(101);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(296).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(125).f = $propertyIsEnumerable;
	  __webpack_require__(180).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(124)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(82)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(186)('asyncIterator');


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(186)('observable');


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(304)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(710);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(1555)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(1738)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(15).Buffer))

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	      var baseEvents = EVENT_NAME_MAP[baseEventName];
	      for (var styleName in baseEvents) {
	        if (styleName in style) {
	          endEvents.push(baseEvents[styleName]);
	          break;
	        }
	      }
	    }
	  }
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	
	  endEvents: endEvents,
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(50);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(714);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(288);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	var clone = __webpack_require__(664);
	
	module.exports = function(options, defaults) {
	  options = options || {};
	
	  Object.keys(defaults).forEach(function(key) {
	    if (typeof options[key] === 'undefined') {
	      options[key] = clone(defaults[key]);
	    }
	  });
	
	  return options;
	};

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	var DOCUMENT_NODE_TYPE = 9;
	
	/**
	 * A polyfill for Element.matches()
	 */
	if (typeof Element !== 'undefined' && !Element.prototype.matches) {
	    var proto = Element.prototype;
	
	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}
	
	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (typeof element.matches === 'function' &&
	            element.matches(selector)) {
	          return element;
	        }
	        element = element.parentNode;
	    }
	}
	
	module.exports = closest;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(717);
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function _delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);
	
	    element.addEventListener(type, listenerFn, useCapture);
	
	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element|String|Array} [elements]
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(elements, selector, type, callback, useCapture) {
	    // Handle the regular Element usage
	    if (typeof elements.addEventListener === 'function') {
	        return _delegate.apply(null, arguments);
	    }
	
	    // Handle Element-less usage, it defaults to global delegation
	    if (typeof type === 'function') {
	        // Use `document` as the first parameter, then apply arguments
	        // This is a short way to .unshift `arguments` without running into deoptimizations
	        return _delegate.bind(null, document).apply(null, arguments);
	    }
	
	    // Handle Selector-based usage
	    if (typeof elements === 'string') {
	        elements = document.querySelectorAll(elements);
	    }
	
	    // Handle Array-like based usage
	    return Array.prototype.map.call(elements, function (element) {
	        return _delegate(element, selector, type, callback, useCapture);
	    });
	}
	
	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);
	
	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}
	
	module.exports = delegate;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(69);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = _utils2['default'].clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return _utils2['default'].mix(pos, size);
	}
	
	exports['default'] = adjustForViewport;
	module.exports = exports['default'];

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _align = __webpack_require__(305);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _getOffsetParent = __webpack_require__(306);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _getVisibleRectForElement = __webpack_require__(308);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _getRegion = __webpack_require__(307);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isOutOfVisibleRect(target) {
	  var visibleRect = (0, _getVisibleRectForElement2['default'])(target);
	  var targetRegion = (0, _getRegion2['default'])(target);
	
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	
	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = (0, _getRegion2['default'])(target);
	
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);
	
	  return (0, _align2['default'])(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}
	
	alignElement.__getOffsetParent = _getOffsetParent2['default'];
	
	alignElement.__getVisibleRectForElement = _getVisibleRectForElement2['default'];
	
	exports['default'] = alignElement;
	module.exports = exports['default'];

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(69);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _align = __webpack_require__(305);
	
	var _align2 = _interopRequireDefault(_align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */
	
	function alignPoint(el, tgtPoint, align) {
	  var pageX = void 0;
	  var pageY = void 0;
	
	  var doc = _utils2['default'].getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	
	  var scrollX = _utils2['default'].getWindowScrollLeft(win);
	  var scrollY = _utils2['default'].getWindowScrollTop(win);
	  var viewportWidth = _utils2['default'].viewportWidth(win);
	  var viewportHeight = _utils2['default'].viewportHeight(win);
	
	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }
	
	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }
	
	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
	
	  // Provide default target point
	  var points = [align.points[0], 'cc'];
	
	  return (0, _align2['default'])(el, tgtRegion, _extends({}, align, { points: points }), pointInView);
	}
	
	exports['default'] = alignPoint;
	module.exports = exports['default'];

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	
	  var x = region.left;
	  var y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	exports['default'] = getAlignOffset;
	module.exports = exports['default'];

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAlignOffset = __webpack_require__(722);
	
	var _getAlignOffset2 = _interopRequireDefault(_getAlignOffset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = (0, _getAlignOffset2['default'])(refNodeRegion, points[1]);
	  var p2 = (0, _getAlignOffset2['default'])(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	
	  return {
	    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
	    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
	  };
	}
	
	exports['default'] = getElFuturePos;
	module.exports = exports['default'];

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.alignPoint = exports.alignElement = undefined;
	
	var _alignElement = __webpack_require__(720);
	
	var _alignElement2 = _interopRequireDefault(_alignElement);
	
	var _alignPoint = __webpack_require__(721);
	
	var _alignPoint2 = _interopRequireDefault(_alignPoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.alignElement = _alignElement2['default'];
	exports.alignPoint = _alignPoint2['default'];
	exports['default'] = _alignElement2['default'];

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isAncestorFixed;
	
	var _utils = __webpack_require__(69);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isAncestorFixed(element) {
	  if (_utils2['default'].isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	
	  var doc = _utils2['default'].getDocument(element);
	  var body = doc.body;
	  var parent = null;
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    var positionStyle = _utils2['default'].css(parent, 'position');
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransformName = getTransformName;
	exports.setTransitionProperty = setTransitionProperty;
	exports.getTransitionProperty = getTransitionProperty;
	exports.getTransformXY = getTransformXY;
	exports.setTransformXY = setTransformXY;
	var vendorPrefix = void 0;
	
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
	}
	
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr = void 0;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, 'matrix(' + arr.join(',') + ')');
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
	    }
	  } else {
	    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
	  }
	}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(728);
	
	function scrollIntoView(elem, container, config) {
	  config = config || {};
	  // document 归一化到 window
	  if (container.nodeType === 9) {
	    container = util.getWindow(container);
	  }
	
	  var allowHorizontalScroll = config.allowHorizontalScroll;
	  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
	  var alignWithTop = config.alignWithTop;
	  var alignWithLeft = config.alignWithLeft;
	  var offsetTop = config.offsetTop || 0;
	  var offsetLeft = config.offsetLeft || 0;
	  var offsetBottom = config.offsetBottom || 0;
	  var offsetRight = config.offsetRight || 0;
	
	  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;
	
	  var isWin = util.isWindow(container);
	  var elemOffset = util.offset(elem);
	  var eh = util.outerHeight(elem);
	  var ew = util.outerWidth(elem);
	  var containerOffset = undefined;
	  var ch = undefined;
	  var cw = undefined;
	  var containerScroll = undefined;
	  var diffTop = undefined;
	  var diffBottom = undefined;
	  var win = undefined;
	  var winScroll = undefined;
	  var ww = undefined;
	  var wh = undefined;
	
	  if (isWin) {
	    win = container;
	    wh = util.height(win);
	    ww = util.width(win);
	    winScroll = {
	      left: util.scrollLeft(win),
	      top: util.scrollTop(win)
	    };
	    // elem 相对 container 可视视窗的距离
	    diffTop = {
	      left: elemOffset.left - winScroll.left - offsetLeft,
	      top: elemOffset.top - winScroll.top - offsetTop
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
	      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
	    };
	    containerScroll = winScroll;
	  } else {
	    containerOffset = util.offset(container);
	    ch = container.clientHeight;
	    cw = container.clientWidth;
	    containerScroll = {
	      left: container.scrollLeft,
	      top: container.scrollTop
	    };
	    // elem 相对 container 可视视窗的距离
	    // 注意边框, offset 是边框到根节点
	    diffTop = {
	      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
	      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
	      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
	    };
	  }
	
	  if (diffTop.top < 0 || diffBottom.top > 0) {
	    // 强制向上
	    if (alignWithTop === true) {
	      util.scrollTop(container, containerScroll.top + diffTop.top);
	    } else if (alignWithTop === false) {
	      util.scrollTop(container, containerScroll.top + diffBottom.top);
	    } else {
	      // 自动调整
	      if (diffTop.top < 0) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  } else {
	    if (!onlyScrollIfNeeded) {
	      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
	      if (alignWithTop) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  }
	
	  if (allowHorizontalScroll) {
	    if (diffTop.left < 0 || diffBottom.left > 0) {
	      // 强制向上
	      if (alignWithLeft === true) {
	        util.scrollLeft(container, containerScroll.left + diffTop.left);
	      } else if (alignWithLeft === false) {
	        util.scrollLeft(container, containerScroll.left + diffBottom.left);
	      } else {
	        // 自动调整
	        if (diffTop.left < 0) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    } else {
	      if (!onlyScrollIfNeeded) {
	        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
	        if (alignWithLeft) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    }
	  }
	}
	
	module.exports = scrollIntoView;

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	function getClientPosition(elem) {
	  var box = undefined;
	  var x = undefined;
	  var y = undefined;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, computedStyle_) {
	  var val = '';
	  var d = elem.ownerDocument;
	  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	var getComputedStyleX = undefined;
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = undefined;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = undefined;
	  var j = undefined;
	  var i = undefined;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = undefined;
	        if (prop === 'border') {
	          cssProp = prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj != null && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, extra) {
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue == null || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  }
	  if (borderBoxValueOrIsBorderBox) {
	    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
	    return val + (extra === BORDER_INDEX ? 0 : padding);
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay(elem) {
	  var val = undefined;
	  var args = arguments;
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value += 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, val) {
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setOffset(elem, offset) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	
	  var old = getOffset(elem);
	  var ret = {};
	  var current = undefined;
	  var key = undefined;
	
	  for (key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      current = parseFloat(css(elem, key)) || 0;
	      ret[key] = current + offset[key] - old[key];
	    }
	  }
	  css(elem, ret);
	}
	
	module.exports = _extends({
	  getWindow: function getWindow(node) {
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function offset(el, value) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value);
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var ret = {};
	    for (var i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (var i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	  scrollLeft: function scrollLeft(w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollLeft(w);
	      }
	      window.scrollTo(v, getScrollTop(w));
	    } else {
	      if (v === undefined) {
	        return w.scrollLeft;
	      }
	      w.scrollLeft = v;
	    }
	  },
	  scrollTop: function scrollTop(w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollTop(w);
	      }
	      window.scrollTo(getScrollLeft(w), v);
	    } else {
	      if (v === undefined) {
	        return w.scrollTop;
	      }
	      w.scrollTop = v;
	    }
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	}, domUtils);

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	/** @license
	 * eventsource.js
	 * Available under MIT License (MIT)
	 * https://github.com/Yaffle/EventSource/
	 */
	
	/*jslint indent: 2, vars: true, plusplus: true */
	/*global setTimeout, clearTimeout */
	
	(function (global) {
	  "use strict";
	
	  var setTimeout = global.setTimeout;
	  var clearTimeout = global.clearTimeout;
	
	  var k = function () {
	  };
	
	  function XHRTransport(xhr, onStartCallback, onProgressCallback, onFinishCallback, thisArg) {
	    this._internal = new XHRTransportInternal(xhr, onStartCallback, onProgressCallback, onFinishCallback, thisArg);
	  }
	
	  XHRTransport.prototype.open = function (url, withCredentials) {
	    this._internal.open(url, withCredentials);
	  };
	
	  XHRTransport.prototype.cancel = function () {
	    this._internal.cancel();
	  };
	
	  function XHRTransportInternal(xhr, onStartCallback, onProgressCallback, onFinishCallback, thisArg) {
	    this.onStartCallback = onStartCallback;
	    this.onProgressCallback = onProgressCallback;
	    this.onFinishCallback = onFinishCallback;
	    this.thisArg = thisArg;
	    this.xhr = xhr;
	    this.state = 0;
	    this.charOffset = 0;
	    this.offset = 0;
	    this.url = "";
	    this.withCredentials = false;
	    this.timeout = 0;
	  }
	
	  XHRTransportInternal.prototype.onStart = function () {
	    if (this.state === 1) {
	      this.state = 2;
	      var status = 0;
	      var statusText = "";
	      var contentType = undefined;
	      if (!("contentType" in this.xhr)) {
	        try {
	          status = this.xhr.status;
	          statusText = this.xhr.statusText;
	          contentType = this.xhr.getResponseHeader("Content-Type");
	        } catch (error) {
	          // https://bugs.webkit.org/show_bug.cgi?id=29121
	          status = 0;
	          statusText = "";
	          contentType = undefined;
	          // FF < 14, WebKit
	          // https://bugs.webkit.org/show_bug.cgi?id=29658
	          // https://bugs.webkit.org/show_bug.cgi?id=77854
	        }
	      } else {
	        status = 200;
	        statusText = "OK";
	        contentType = this.xhr.contentType;
	      }
	      if (contentType == undefined) {
	        contentType = "";
	      }
	      this.onStartCallback.call(this.thisArg, status, statusText, contentType);
	    }
	  };
	  XHRTransportInternal.prototype.onProgress = function () {
	    this.onStart();
	    if (this.state === 2 || this.state === 3) {
	      this.state = 3;
	      var responseText = "";
	      try {
	        responseText = this.xhr.responseText;
	      } catch (error) {
	        // IE 8 - 9 with XMLHttpRequest
	      }
	      var chunkStart = this.charOffset;
	      var length = responseText.length;
	      for (var i = this.offset; i < length; i += 1) {
	        var c = responseText.charCodeAt(i);
	        if (c === "\n".charCodeAt(0) || c === "\r".charCodeAt(0)) {
	          this.charOffset = i + 1;
	        }
	      }
	      this.offset = length;
	      var chunk = responseText.slice(chunkStart, this.charOffset);
	      this.onProgressCallback.call(this.thisArg, chunk);
	    }
	  };
	  XHRTransportInternal.prototype.onFinish = function () {
	    // IE 8 fires "onload" without "onprogress
	    this.onProgress();
	    if (this.state === 3) {
	      this.state = 4;
	      if (this.timeout !== 0) {
	        clearTimeout(this.timeout);
	        this.timeout = 0;
	      }
	      this.onFinishCallback.call(this.thisArg);
	    }
	  };
	  XHRTransportInternal.prototype.onReadyStateChange = function () {
	    if (this.xhr != undefined) { // Opera 12
	      if (this.xhr.readyState === 4) {
	        if (this.xhr.status === 0) {
	          this.onFinish();
	        } else {
	          this.onFinish();
	        }
	      } else if (this.xhr.readyState === 3) {
	        this.onProgress();
	      } else if (this.xhr.readyState === 2) {
	        // Opera 10.63 throws exception for `this.xhr.status`
	        // this.onStart();
	      }
	    }
	  };
	  XHRTransportInternal.prototype.onTimeout2 = function () {
	    this.timeout = 0;
	    var tmp = (/^data\:([^,]*?)(base64)?,([\S]*)$/).exec(this.url);
	    var contentType = tmp[1];
	    var data = tmp[2] === "base64" ? global.atob(tmp[3]) : decodeURIComponent(tmp[3]);
	    if (this.state === 1) {
	      this.state = 2;
	      this.onStartCallback.call(this.thisArg, 200, "OK", contentType);
	    }
	    if (this.state === 2 || this.state === 3) {
	      this.state = 3;
	      this.onProgressCallback.call(this.thisArg, data);
	    }
	    if (this.state === 3) {
	      this.state = 4;
	      this.onFinishCallback.call(this.thisArg);
	    }
	  };
	  XHRTransportInternal.prototype.onTimeout1 = function () {
	    this.timeout = 0;
	    this.open(this.url, this.withCredentials);
	  };
	  XHRTransportInternal.prototype.onTimeout0 = function () {
	    var that = this;
	    this.timeout = setTimeout(function () {
	      that.onTimeout0();
	    }, 500);
	    if (this.xhr.readyState === 3) {
	      this.onProgress();
	    }
	  };
	  XHRTransportInternal.prototype.handleEvent = function (event) {
	    if (event.type === "load") {
	      this.onFinish();
	    } else if (event.type === "error") {
	      this.onFinish();
	    } else if (event.type === "abort") {
	      // improper fix to match Firefox behaviour, but it is better than just ignore abort
	      // see https://bugzilla.mozilla.org/show_bug.cgi?id=768596
	      // https://bugzilla.mozilla.org/show_bug.cgi?id=880200
	      // https://code.google.com/p/chromium/issues/detail?id=153570
	      // IE 8 fires "onload" without "onprogress
	      this.onFinish();
	    } else if (event.type === "progress") {
	      this.onProgress();
	    } else if (event.type === "readystatechange") {
	      this.onReadyStateChange();
	    }
	  };
	  XHRTransportInternal.prototype.open = function (url, withCredentials) {
	    this.cancel();
	
	    this.url = url;
	    this.withCredentials = withCredentials;
	
	    this.state = 1;
	    this.charOffset = 0;
	    this.offset = 0;
	
	    var that = this;
	
	    var tmp = (/^data\:([^,]*?)(?:;base64)?,[\S]*$/).exec(url);
	    if (tmp != undefined) {
	      this.timeout = setTimeout(function () {
	        that.onTimeout2();
	      }, 0);
	      return;
	    }
	
	    // loading indicator in Safari, Chrome < 14
	    // loading indicator in Firefox
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=736723
	    if ((!("ontimeout" in this.xhr) || ("sendAsBinary" in this.xhr) || ("mozAnon" in this.xhr)) && global.document != undefined && global.document.readyState != undefined && global.document.readyState !== "complete") {
	      this.timeout = setTimeout(function () {
	        that.onTimeout1();
	      }, 4);
	      return;
	    }
	
	    // XDomainRequest#abort removes onprogress, onerror, onload
	    this.xhr.onload = function (event) {
	      that.handleEvent({type: "load"});
	    };
	    this.xhr.onerror = function () {
	      that.handleEvent({type: "error"});
	    };
	    this.xhr.onabort = function () {
	      that.handleEvent({type: "abort"});
	    };
	    this.xhr.onprogress = function () {
	      that.handleEvent({type: "progress"});
	    };
	    // IE 8-9 (XMLHTTPRequest)
	    // Firefox 3.5 - 3.6 - ? < 9.0
	    // onprogress is not fired sometimes or delayed
	    // see also #64
	    this.xhr.onreadystatechange = function () {
	      that.handleEvent({type: "readystatechange"});
	    };
	
	    this.xhr.open("GET", url, true);
	
	    // withCredentials should be set after "open" for Safari and Chrome (< 19 ?)
	    this.xhr.withCredentials = withCredentials;
	
	    this.xhr.responseType = "text";
	
	    if ("setRequestHeader" in this.xhr) {
	      // Request header field Cache-Control is not allowed by Access-Control-Allow-Headers.
	      // "Cache-control: no-cache" are not honored in Chrome and Firefox
	      // https://bugzilla.mozilla.org/show_bug.cgi?id=428916
	      //this.xhr.setRequestHeader("Cache-Control", "no-cache");
	      this.xhr.setRequestHeader("Accept", "text/event-stream");
	      // Request header field Last-Event-ID is not allowed by Access-Control-Allow-Headers.
	      //this.xhr.setRequestHeader("Last-Event-ID", this.lastEventId);
	    }
	
	    try {
	      this.xhr.send(undefined);
	    } catch (error1) {
	      // Safari 5.1.7, Opera 12
	      throw error1;
	    }
	
	    if (("readyState" in this.xhr) && global.opera != undefined) {
	      // workaround for Opera issue with "progress" events
	      this.timeout = setTimeout(function () {
	        that.onTimeout0();
	      }, 0);
	    }
	  };
	  XHRTransportInternal.prototype.cancel = function () {
	    if (this.state !== 0 && this.state !== 4) {
	      this.state = 4;
	      this.xhr.onload = k;
	      this.xhr.onerror = k;
	      this.xhr.onabort = k;
	      this.xhr.onprogress = k;
	      this.xhr.onreadystatechange = k;
	      this.xhr.abort();
	      if (this.timeout !== 0) {
	        clearTimeout(this.timeout);
	        this.timeout = 0;
	      }
	      this.onFinishCallback.call(this.thisArg);
	    }
	    this.state = 0;
	  };
	
	  function Map() {
	    this._data = {};
	  }
	
	  Map.prototype.get = function (key) {
	    return this._data[key + "~"];
	  };
	  Map.prototype.set = function (key, value) {
	    this._data[key + "~"] = value;
	  };
	  Map.prototype["delete"] = function (key) {
	    delete this._data[key + "~"];
	  };
	
	  function EventTarget() {
	    this._listeners = new Map();
	  }
	
	  function throwError(e) {
	    setTimeout(function () {
	      throw e;
	    }, 0);
	  }
	
	  EventTarget.prototype.dispatchEvent = function (event) {
	    event.target = this;
	    var type = event.type.toString();
	    var listeners = this._listeners;
	    var typeListeners = listeners.get(type);
	    if (typeListeners == undefined) {
	      return;
	    }
	    var length = typeListeners.length;
	    var listener = undefined;
	    for (var i = 0; i < length; i += 1) {
	      listener = typeListeners[i];
	      try {
	        if (typeof listener.handleEvent === "function") {
	          listener.handleEvent(event);
	        } else {
	          listener.call(this, event);
	        }
	      } catch (e) {
	        throwError(e);
	      }
	    }
	  };
	  EventTarget.prototype.addEventListener = function (type, callback) {
	    type = type.toString();
	    var listeners = this._listeners;
	    var typeListeners = listeners.get(type);
	    if (typeListeners == undefined) {
	      typeListeners = [];
	      listeners.set(type, typeListeners);
	    }
	    for (var i = typeListeners.length; i >= 0; i -= 1) {
	      if (typeListeners[i] === callback) {
	        return;
	      }
	    }
	    typeListeners.push(callback);
	  };
	  EventTarget.prototype.removeEventListener = function (type, callback) {
	    type = type.toString();
	    var listeners = this._listeners;
	    var typeListeners = listeners.get(type);
	    if (typeListeners == undefined) {
	      return;
	    }
	    var length = typeListeners.length;
	    var filtered = [];
	    for (var i = 0; i < length; i += 1) {
	      if (typeListeners[i] !== callback) {
	        filtered.push(typeListeners[i]);
	      }
	    }
	    if (filtered.length === 0) {
	      listeners["delete"](type);
	    } else {
	      listeners.set(type, filtered);
	    }
	  };
	
	  function Event(type) {
	    this.type = type;
	    this.target = undefined;
	  }
	
	  function MessageEvent(type, options) {
	    Event.call(this, type);
	    this.data = options.data;
	    this.lastEventId = options.lastEventId;
	  }
	
	  MessageEvent.prototype = Event.prototype;
	
	  var XHR = global.XMLHttpRequest;
	  var XDR = global.XDomainRequest;
	  var isCORSSupported = XHR != undefined && (new XHR()).withCredentials != undefined;
	  var Transport = isCORSSupported || (XHR != undefined && XDR == undefined) ? XHR : XDR;
	
	  var WAITING = -1;
	  var CONNECTING = 0;
	  var OPEN = 1;
	  var CLOSED = 2;
	  var AFTER_CR = 3;
	  var FIELD_START = 4;
	  var FIELD = 5;
	  var VALUE_START = 6;
	  var VALUE = 7;
	  var contentTypeRegExp = /^text\/event\-stream;?(\s*charset\=utf\-8)?$/i;
	
	  var MINIMUM_DURATION = 1000;
	  var MAXIMUM_DURATION = 18000000;
	
	  var getDuration = function (value, def) {
	    var n = value;
	    if (n !== n) {
	      n = def;
	    }
	    return (n < MINIMUM_DURATION ? MINIMUM_DURATION : (n > MAXIMUM_DURATION ? MAXIMUM_DURATION : n));
	  };
	
	  var fire = function (that, f, event) {
	    try {
	      if (typeof f === "function") {
	        f.call(that, event);
	      }
	    } catch (e) {
	      throwError(e);
	    }
	  };
	
	  function EventSource(url, options) {
	    EventTarget.call(this);
	
	    this.onopen = undefined;
	    this.onmessage = undefined;
	    this.onerror = undefined;
	
	    this.url = "";
	    this.readyState = CONNECTING;
	    this.withCredentials = false;
	
	    this._internal = new EventSourceInternal(this, url, options);
	  }
	
	  function EventSourceInternal(es, url, options) {
	    this.url = url.toString();
	    this.readyState = CONNECTING;
	    this.withCredentials = isCORSSupported && options != undefined && Boolean(options.withCredentials);
	
	    this.es = es;
	    this.initialRetry = getDuration(1000, 0);
	    this.heartbeatTimeout = getDuration(45000, 0);
	
	    this.lastEventId = "";
	    this.retry = this.initialRetry;
	    this.wasActivity = false;
	    var CurrentTransport = options != undefined && options.Transport != undefined ? options.Transport : Transport;
	    var xhr = new CurrentTransport();
	    this.transport = new XHRTransport(xhr, this.onStart, this.onProgress, this.onFinish, this);
	    this.timeout = 0;
	    this.currentState = WAITING;
	    this.dataBuffer = [];
	    this.lastEventIdBuffer = "";
	    this.eventTypeBuffer = "";
	
	    this.state = FIELD_START;
	    this.fieldStart = 0;
	    this.valueStart = 0;
	
	    this.es.url = this.url;
	    this.es.readyState = this.readyState;
	    this.es.withCredentials = this.withCredentials;
	
	    this.onTimeout();
	  }
	
	  EventSourceInternal.prototype.onStart = function (status, statusText, contentType) {
	    if (this.currentState === CONNECTING) {
	      if (contentType == undefined) {
	        contentType = "";
	      }
	      if (status === 200 && contentTypeRegExp.test(contentType)) {
	        this.currentState = OPEN;
	        this.wasActivity = true;
	        this.retry = this.initialRetry;
	        this.readyState = OPEN;
	        this.es.readyState = OPEN;
	        var event = new Event("open");
	        this.es.dispatchEvent(event);
	        fire(this.es, this.es.onopen, event);
	      } else if (status !== 0) {
	        var message = "";
	        if (status !== 200) {
	          message = "EventSource's response has a status " + status + " " + statusText.replace(/\s+/g, " ") + " that is not 200. Aborting the connection.";
	        } else {
	          message = "EventSource's response has a Content-Type specifying an unsupported type: " + contentType.replace(/\s+/g, " ") + ". Aborting the connection.";
	        }
	        throwError(new Error(message));
	        this.close();
	        var event = new Event("error");
	        this.es.dispatchEvent(event);
	        fire(this.es, this.es.onerror, event);
	      }
	    }
	  };
	
	  EventSourceInternal.prototype.onProgress = function (chunk) {
	    if (this.currentState === OPEN) {
	      var length = chunk.length;
	      if (length !== 0) {
	        this.wasActivity = true;
	      }
	      for (var position = 0; position < length; position += 1) {
	        var c = chunk.charCodeAt(position);
	        if (this.state === AFTER_CR && c === "\n".charCodeAt(0)) {
	          this.state = FIELD_START;
	        } else {
	          if (this.state === AFTER_CR) {
	            this.state = FIELD_START;
	          }
	          if (c === "\r".charCodeAt(0) || c === "\n".charCodeAt(0)) {
	            if (this.state !== FIELD_START) {
	              if (this.state === FIELD) {
	                this.valueStart = position + 1;
	              }
	              var field = chunk.slice(this.fieldStart, this.valueStart - 1);
	              var value = chunk.slice(this.valueStart + (this.valueStart < position && chunk.charCodeAt(this.valueStart) === " ".charCodeAt(0) ? 1 : 0), position);
	              if (field === "data") {
	                this.dataBuffer.push(value);
	              } else if (field === "id") {
	                this.lastEventIdBuffer = value;
	              } else if (field === "event") {
	                this.eventTypeBuffer = value;
	              } else if (field === "retry") {
	                this.initialRetry = getDuration(Number(value), this.initialRetry);
	                this.retry = this.initialRetry;
	              } else if (field === "heartbeatTimeout") {
	                this.heartbeatTimeout = getDuration(Number(value), this.heartbeatTimeout);
	                if (this.timeout !== 0) {
	                  clearTimeout(this.timeout);
	                  var that = this;
	                  this.timeout = setTimeout(function () {
	                    that.onTimeout();
	                  }, this.heartbeatTimeout);
	                }
	              }
	            }
	            if (this.state === FIELD_START) {
	              if (this.dataBuffer.length !== 0) {
	                this.lastEventId = this.lastEventIdBuffer;
	                if (this.eventTypeBuffer === "") {
	                  this.eventTypeBuffer = "message";
	                }
	                var event = new MessageEvent(this.eventTypeBuffer, {
	                  data: this.dataBuffer.join("\n"),
	                  lastEventId: this.lastEventIdBuffer
	                });
	                this.es.dispatchEvent(event);
	                if (this.eventTypeBuffer === "message") {
	                  fire(this.es, this.es.onmessage, event);
	                }
	                if (this.currentState === CLOSED) {
	                  return;
	                }
	              }
	              this.dataBuffer.length = 0;
	              this.eventTypeBuffer = "";
	            }
	            this.state = c === "\r".charCodeAt(0) ? AFTER_CR : FIELD_START;
	          } else {
	            if (this.state === FIELD_START) {
	              this.fieldStart = position;
	              this.state = FIELD;
	            }
	            if (this.state === FIELD) {
	              if (c === ":".charCodeAt(0)) {
	                this.valueStart = position + 1;
	                this.state = VALUE_START;
	              }
	            } else if (this.state === VALUE_START) {
	              this.state = VALUE;
	            }
	          }
	        }
	      }
	    }
	  };
	
	  EventSourceInternal.prototype.onFinish = function () {
	    if (this.currentState === OPEN || this.currentState === CONNECTING) {
	      this.currentState = WAITING;
	      if (this.timeout !== 0) {
	        clearTimeout(this.timeout);
	        this.timeout = 0;
	      }
	      if (this.retry > this.initialRetry * 16) {
	        this.retry = this.initialRetry * 16;
	      }
	      if (this.retry > MAXIMUM_DURATION) {
	        this.retry = MAXIMUM_DURATION;
	      }
	      var that = this;
	      this.timeout = setTimeout(function () {
	        that.onTimeout();
	      }, this.retry);
	      this.retry = this.retry * 2 + 1;
	
	      this.readyState = CONNECTING;
	      this.es.readyState = CONNECTING;
	      var event = new Event("error");
	      this.es.dispatchEvent(event);
	      fire(this.es, this.es.onerror, event);
	    }
	  };
	
	  EventSourceInternal.prototype.onTimeout = function () {
	    this.timeout = 0;
	    if (this.currentState !== WAITING) {
	      if (!this.wasActivity) {
	        throwError(new Error("No activity within " + this.heartbeatTimeout + " milliseconds. Reconnecting."));
	        this.transport.cancel();
	      } else {
	        this.wasActivity = false;
	        var that = this;
	        this.timeout = setTimeout(function () {
	          that.onTimeout();
	        }, this.heartbeatTimeout);
	      }
	      return;
	    }
	
	    this.wasActivity = false;
	    var that = this;
	    this.timeout = setTimeout(function () {
	      that.onTimeout();
	    }, this.heartbeatTimeout);
	
	    this.currentState = CONNECTING;
	    this.dataBuffer.length = 0;
	    this.eventTypeBuffer = "";
	    this.lastEventIdBuffer = this.lastEventId;
	    this.fieldStart = 0;
	    this.valueStart = 0;
	    this.state = FIELD_START;
	
	    var s = this.url.slice(0, 5);
	    if (s !== "data:" && s !== "blob:") {
	      s = this.url + ((this.url.indexOf("?", 0) === -1 ? "?" : "&") + "lastEventId=" + encodeURIComponent(this.lastEventId) + "&r=" + (Math.random() + 1).toString().slice(2));
	    } else {
	      s = this.url;
	    }
	    try {
	      this.transport.open(s, this.withCredentials);
	    } catch (error) {
	      this.close();
	      throw error;
	    }
	  };
	
	  EventSourceInternal.prototype.close = function () {
	    this.currentState = CLOSED;
	    this.transport.cancel();
	    if (this.timeout !== 0) {
	      clearTimeout(this.timeout);
	      this.timeout = 0;
	    }
	    this.readyState = CLOSED;
	    this.es.readyState = CLOSED;
	  };
	
	  function F() {
	    this.CONNECTING = CONNECTING;
	    this.OPEN = OPEN;
	    this.CLOSED = CLOSED;
	  }
	  F.prototype = EventTarget.prototype;
	
	  EventSource.prototype = new F();
	
	  EventSource.prototype.close = function () {
	    this._internal.close();
	  };
	
	  F.call(EventSource);
	  if (isCORSSupported) {
	    EventSource.prototype.withCredentials = undefined;
	  }
	
	  var isEventSourceSupported = function () {
	    // Opera 12 fails this test, but this is fine.
	    return global.EventSource != undefined && ("withCredentials" in global.EventSource.prototype);
	  };
	
	  if (Transport != undefined && (global.EventSource == undefined || (isCORSSupported && !isEventSourceSupported()))) {
	    // Why replace a native EventSource ?
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=444328
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=831392
	    // https://code.google.com/p/chromium/issues/detail?id=260144
	    // https://code.google.com/p/chromium/issues/detail?id=225654
	    // ...
	    global.NativeEventSource = global.EventSource;
	    global.EventSource = EventSource;
	  }
	
	}(typeof window !== 'undefined' ? window : this));


/***/ }),
/* 730 */
128,
/* 731 */
128,
/* 732 */
128,
/* 733 */
128,
/* 734 */
128,
/* 735 */
128,
/* 736 */
128,
/* 737 */
128,
/* 738 */
128,
/* 739 */
128,
/* 740 */
128,
/* 741 */
128,
/* 742 */
128,
/* 743 */
128,
/* 744 */
128,
/* 745 */
128,
/* 746 */
128,
/* 747 */
128,
/* 748 */
128,
/* 749 */
128,
/* 750 */
128,
/* 751 */
128,
/* 752 */
128,
/* 753 */
128,
/* 754 */
128,
/* 755 */
128,
/* 756 */
128,
/* 757 */
128,
/* 758 */
128,
/* 759 */
128,
/* 760 */
128,
/* 761 */
128,
/* 762 */
128,
/* 763 */
128,
/* 764 */
128,
/* 765 */
128,
/* 766 */
128,
/* 767 */
128,
/* 768 */
128,
/* 769 */
128,
/* 770 */
128,
/* 771 */
128,
/* 772 */
128,
/* 773 */
128,
/* 774 */
128,
/* 775 */
128,
/* 776 */
128,
/* 777 */
128,
/* 778 */
128,
/* 779 */
128,
/* 780 */
128,
/* 781 */
128,
/* 782 */
128,
/* 783 */
128,
/* 784 */
128,
/* 785 */
128,
/* 786 */
128,
/* 787 */
128,
/* 788 */
128,
/* 789 */
128,
/* 790 */
128,
/* 791 */
128,
/* 792 */
128,
/* 793 */
128,
/* 794 */
128,
/* 795 */
128,
/* 796 */
128,
/* 797 */
128,
/* 798 */
128,
/* 799 */
128,
/* 800 */
128,
/* 801 */
128,
/* 802 */
128,
/* 803 */
128,
/* 804 */
128,
/* 805 */
128,
/* 806 */
128,
/* 807 */
128,
/* 808 */
128,
/* 809 */
128,
/* 810 */
128,
/* 811 */
128,
/* 812 */
128,
/* 813 */
128,
/* 814 */
128,
/* 815 */
128,
/* 816 */
128,
/* 817 */
128,
/* 818 */
128,
/* 819 */
128,
/* 820 */
128,
/* 821 */
128,
/* 822 */
128,
/* 823 */
128,
/* 824 */
128,
/* 825 */
128,
/* 826 */
128,
/* 827 */
128,
/* 828 */
128,
/* 829 */
128,
/* 830 */
128,
/* 831 */
128,
/* 832 */
128,
/* 833 */
128,
/* 834 */
128,
/* 835 */
128,
/* 836 */
128,
/* 837 */
128,
/* 838 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(838);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(848);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var createArrayFromMixed = __webpack_require__(841);
	var getMarkupWrap = __webpack_require__(843);
	var invariant = __webpack_require__(11);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(845);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(847);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* The MIT License
	
	 Copyright (c) 2011 by Michael Zinsmaier and nergal.dev
	 Copyright (c) 2012 by Thomas Ritou
	
	 Permission is hereby granted, free of charge, to any person obtaining a copy
	 of this software and associated documentation files (the "Software"), to deal
	 in the Software without restriction, including without limitation the rights
	 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 copies of the Software, and to permit persons to whom the Software is
	 furnished to do so, subject to the following conditions:
	
	 The above copyright notice and this permission notice shall be included in
	 all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 THE SOFTWARE.
	*/
	
	/*
	____________________________________________________
	
	 what it is:
	 ____________________________________________________
	
	 curvedLines is a plugin for flot, that tries to display lines in a smoother way.
	 This is achieved through adding of more data points. The plugin is a data processor and can thus be used
	 in combination with standard line / point rendering options.
	
	 => 1) with large data sets you may get trouble
	 => 2) if you want to display the points too, you have to plot them as 2nd data series over the lines
	 => 3) consecutive x data points are not allowed to have the same value
	
	 Feel free to further improve the code
	
	 ____________________________________________________
	
	 how to use it:
	 ____________________________________________________
	
	 var d1 = [[5,5],[7,3],[9,12]];
	
	 var options = { series: { curvedLines: {  active: true }}};
	
	 $.plot($("#placeholder"), [{data: d1, lines: { show: true}, curvedLines: {apply: true}}], options);
	
	 _____________________________________________________
	
	 options:
	 _____________________________________________________
	
	 active:           bool true => plugin can be used
	 apply:            bool true => series will be drawn as curved line
	 monotonicFit:	   bool true => uses monotone cubic interpolation (preserve monotonicity)
	 tension:          int          defines the tension parameter of the hermite spline interpolation (no effect if monotonicFit is set)
	 nrSplinePoints:   int 			defines the number of sample points (of the spline) in between two consecutive points
	
	 deprecated options from flot prior to 1.0.0:
	 ------------------------------------------------
	 legacyOverride	   bool true => use old default
	    OR
	 legacyOverride    optionArray
	 {
	 	fit: 	             bool true => forces the max,mins of the curve to be on the datapoints
	 	curvePointFactor	 int  		  defines how many "virtual" points are used per "real" data point to
	 									  emulate the curvedLines (points total = real points * curvePointFactor)
	 	fitPointDist: 	     int  		  defines the x axis distance of the additional two points that are used
	 }						   		   	  to enforce the min max condition.
	 */
	
	/*
	 *  v0.1   initial commit
	 *  v0.15  negative values should work now (outcommented a negative -> 0 hook hope it does no harm)
	 *  v0.2   added fill option (thanks to monemihir) and multi axis support (thanks to soewono effendi)
	 *  v0.3   improved saddle handling and added basic handling of Dates
	 *  v0.4   rewritten fill option (thomas ritou) mostly from original flot code (now fill between points rather than to graph bottom), corrected fill Opacity bug
	 *  v0.5   rewritten instead of implementing a own draw function CurvedLines is now based on the processDatapoints flot hook (credits go to thomas ritou).
	 * 		   This change breakes existing code however CurvedLines are now just many tiny straight lines to flot and therefore all flot lines options (like gradient fill,
	 * 	       shadow) are now supported out of the box
	 *  v0.6   flot 0.8 compatibility and some bug fixes
	 *  v0.6.x changed versioning schema
	 *
	 *  v1.0.0 API Break marked existing implementation/options as deprecated
	 *  v1.1.0 added the new curved line calculations based on hermite splines
	 *  v1.1.1 added a rough parameter check to make sure the new options are used
	 */
	
	(function($) {
	
		var options = {
			series : {
				curvedLines : {
					active : false,
					apply : false,
					monotonicFit : false,
					tension : 0.5,
					nrSplinePoints : 20,
					legacyOverride : undefined
				}
			}
		};
	
		function init(plot) {
	
			plot.hooks.processOptions.push(processOptions);
	
			//if the plugin is active register processDatapoints method
			function processOptions(plot, options) {
				if (options.series.curvedLines.active) {
					plot.hooks.processDatapoints.unshift(processDatapoints);
				}
			}
	
			//only if the plugin is active
			function processDatapoints(plot, series, datapoints) {
				var nrPoints = datapoints.points.length / datapoints.pointsize;
				var EPSILON = 0.005;
	
				//detects missplaced legacy parameters (prior v1.x.x) in the options object
				//this can happen if somebody upgrades to v1.x.x without adjusting the parameters or uses old examples
	            var invalidLegacyOptions = hasInvalidParameters(series.curvedLines);
	
				if (!invalidLegacyOptions && series.curvedLines.apply == true && series.originSeries === undefined && nrPoints > (1 + EPSILON)) {
					if (series.lines.fill) {
	
						var pointsTop = calculateCurvePoints(datapoints, series.curvedLines, 1);
						var pointsBottom = calculateCurvePoints(datapoints, series.curvedLines, 2);
						//flot makes sure for us that we've got a second y point if fill is true !
	
						//Merge top and bottom curve
						datapoints.pointsize = 3;
						datapoints.points = [];
						var j = 0;
						var k = 0;
						var i = 0;
						var ps = 2;
						while (i < pointsTop.length || j < pointsBottom.length) {
							if (pointsTop[i] == pointsBottom[j]) {
								datapoints.points[k] = pointsTop[i];
								datapoints.points[k + 1] = pointsTop[i + 1];
								datapoints.points[k + 2] = pointsBottom[j + 1];
								j += ps;
								i += ps;
	
							} else if (pointsTop[i] < pointsBottom[j]) {
								datapoints.points[k] = pointsTop[i];
								datapoints.points[k + 1] = pointsTop[i + 1];
								datapoints.points[k + 2] = k > 0 ? datapoints.points[k - 1] : null;
								i += ps;
							} else {
								datapoints.points[k] = pointsBottom[j];
								datapoints.points[k + 1] = k > 1 ? datapoints.points[k - 2] : null;
								datapoints.points[k + 2] = pointsBottom[j + 1];
								j += ps;
							}
							k += 3;
						}
					} else if (series.lines.lineWidth > 0) {
						datapoints.points = calculateCurvePoints(datapoints, series.curvedLines, 1);
						datapoints.pointsize = 2;
					}
				}
			}
	
			function calculateCurvePoints(datapoints, curvedLinesOptions, yPos) {
				if ( typeof curvedLinesOptions.legacyOverride != 'undefined' && curvedLinesOptions.legacyOverride != false) {
					var defaultOptions = {
						fit : false,
						curvePointFactor : 20,
						fitPointDist : undefined
					};
					var legacyOptions = jQuery.extend(defaultOptions, curvedLinesOptions.legacyOverride);
					return calculateLegacyCurvePoints(datapoints, legacyOptions, yPos);
				}
	
				return calculateSplineCurvePoints(datapoints, curvedLinesOptions, yPos);
			}
	
			function calculateSplineCurvePoints(datapoints, curvedLinesOptions, yPos) {
				var points = datapoints.points;
				var ps = datapoints.pointsize;
				
				//create interpolant fuction
				var splines = createHermiteSplines(datapoints, curvedLinesOptions, yPos);
				var result = [];
	
				//sample the function
				// (the result is intependent from the input data =>
				//	it is ok to alter the input after this method)
				var j = 0;
				for (var i = 0; i < points.length - ps; i += ps) {
					var curX = i;
					var curY = i + yPos;	
					
					var xStart = points[curX];
					var xEnd = points[curX + ps];
					var xStep = (xEnd - xStart) / Number(curvedLinesOptions.nrSplinePoints);
	
					//add point
					result.push(points[curX]);
					result.push(points[curY]);
	
					//add curve point
					for (var x = (xStart += xStep); x < xEnd; x += xStep) {
						result.push(x);
						result.push(splines[j](x));
					}
					
					j++;
				}
	
				//add last point
				result.push(points[points.length - ps]);
				result.push(points[points.length - ps + yPos]);
	
				return result;
			}
	
	
	
			// Creates an array of splines, one for each segment of the original curve. Algorithm based on the wikipedia articles: 
			//
			// http://de.wikipedia.org/w/index.php?title=Kubisch_Hermitescher_Spline&oldid=130168003 and 
			// http://en.wikipedia.org/w/index.php?title=Monotone_cubic_interpolation&oldid=622341725 and the description of Fritsch-Carlson from
			// http://math.stackexchange.com/questions/45218/implementation-of-monotone-cubic-interpolation
			// for a detailed description see https://github.com/MichaelZinsmaier/CurvedLines/docu
			function createHermiteSplines(datapoints, curvedLinesOptions, yPos) {
				var points = datapoints.points;
				var ps = datapoints.pointsize;
				
				// preparation get length (x_{k+1} - x_k) and slope s=(p_{k+1} - p_k) / (x_{k+1} - x_k) of the segments
				var segmentLengths = [];
				var segmentSlopes = [];
	
				for (var i = 0; i < points.length - ps; i += ps) {
					var curX = i;
					var curY = i + yPos;			
					var dx = points[curX + ps] - points[curX];
					var dy = points[curY + ps] - points[curY];
								
					segmentLengths.push(dx);
					segmentSlopes.push(dy / dx);
				}
	
				//get the values for the desired gradients  m_k for all points k
				//depending on the used method the formula is different
				var gradients = [segmentSlopes[0]];	
				if (curvedLinesOptions.monotonicFit) {
					// Fritsch Carlson
					for (var i = 1; i < segmentLengths.length; i++) {
						var slope = segmentSlopes[i];
						var prev_slope = segmentSlopes[i - 1];
						if (slope * prev_slope <= 0) { // sign(prev_slope) != sign(slpe)
							gradients.push(0);
						} else {
							var length = segmentLengths[i];
							var prev_length = segmentLengths[i - 1];
							var common = length + prev_length;
							//m = 3 (prev_length + length) / ((2 length + prev_length) / prev_slope + (length + 2 prev_length) / slope)
							gradients.push(3 * common / ((common + length) / prev_slope + (common + prev_length) / slope));
						}
					}
				} else {
					// Cardinal spline with t € [0,1]
					// Catmull-Rom for t = 0
					for (var i = ps; i < points.length - ps; i += ps) {
						var curX = i;
						var curY = i + yPos;	
						gradients.push(Number(curvedLinesOptions.tension) * (points[curY + ps] - points[curY - ps]) / (points[curX + ps] - points[curX - ps]));
					}
				}
				gradients.push(segmentSlopes[segmentSlopes.length - 1]);
	
				//get the two major coefficients (c'_{oef1} and c'_{oef2}) for each segment spline
				var coefs1 = [];
				var coefs2 = [];
				for (i = 0; i < segmentLengths.length; i++) {
					var m_k = gradients[i];
					var m_k_plus = gradients[i + 1];
					var slope = segmentSlopes[i];
					var invLength = 1 / segmentLengths[i];
					var common = m_k + m_k_plus - slope - slope;
					
					coefs1.push(common * invLength * invLength);
					coefs2.push((slope - common - m_k) * invLength);
				}
	
				//create functions with from the coefficients and capture the parameters
				var ret = [];
				for (var i = 0; i < segmentLengths.length; i ++) {
					var spline = function (x_k, coef1, coef2, coef3, coef4) {
						// spline for a segment
						return function (x) {									
							var diff = x - x_k;
							var diffSq = diff * diff;
							return coef1 * diff * diffSq + coef2 * diffSq + coef3 * diff + coef4;
						};
					};			
			
					ret.push(spline(points[i * ps], coefs1[i], coefs2[i], gradients[i], points[i * ps + yPos]));
				}
				
				return ret;
			};
	
			//no real idea whats going on here code mainly from https://code.google.com/p/flot/issues/detail?id=226
			//if fit option is selected additional datapoints get inserted before the curve calculations in nergal.dev s code.
			function calculateLegacyCurvePoints(datapoints, curvedLinesOptions, yPos) {
	
				var points = datapoints.points;
				var ps = datapoints.pointsize;
				var num = Number(curvedLinesOptions.curvePointFactor) * (points.length / ps);
	
				var xdata = new Array;
				var ydata = new Array;
	
				var curX = -1;
				var curY = -1;
				var j = 0;
	
				if (curvedLinesOptions.fit) {
					//insert a point before and after the "real" data point to force the line
					//to have a max,min at the data point.
	
					var fpDist;
					if ( typeof curvedLinesOptions.fitPointDist == 'undefined') {
						//estimate it
						var minX = points[0];
						var maxX = points[points.length - ps];
						fpDist = (maxX - minX) / (500 * 100);
						//x range / (estimated pixel length of placeholder * factor)
					} else {
						//use user defined value
						fpDist = Number(curvedLinesOptions.fitPointDist);
					}
	
					for (var i = 0; i < points.length; i += ps) {
	
						var frontX;
						var backX;
						curX = i;
						curY = i + yPos;
	
						//add point X s
						frontX = points[curX] - fpDist;
						backX = points[curX] + fpDist;
	
						var factor = 2;
						while (frontX == points[curX] || backX == points[curX]) {
							//inside the ulp
							frontX = points[curX] - (fpDist * factor);
							backX = points[curX] + (fpDist * factor);
							factor++;
						}
	
						//add curve points
						xdata[j] = frontX;
						ydata[j] = points[curY];
						j++;
	
						xdata[j] = points[curX];
						ydata[j] = points[curY];
						j++;
	
						xdata[j] = backX;
						ydata[j] = points[curY];
						j++;
					}
				} else {
					//just use the datapoints
					for (var i = 0; i < points.length; i += ps) {
						curX = i;
						curY = i + yPos;
	
						xdata[j] = points[curX];
						ydata[j] = points[curY];
						j++;
					}
				}
	
				var n = xdata.length;
	
				var y2 = new Array();
				var delta = new Array();
				y2[0] = 0;
				y2[n - 1] = 0;
				delta[0] = 0;
	
				for (var i = 1; i < n - 1; ++i) {
					var d = (xdata[i + 1] - xdata[i - 1]);
					if (d == 0) {
						//point before current point and after current point need some space in between
						return [];
					}
	
					var s = (xdata[i] - xdata[i - 1]) / d;
					var p = s * y2[i - 1] + 2;
					y2[i] = (s - 1) / p;
					delta[i] = (ydata[i + 1] - ydata[i]) / (xdata[i + 1] - xdata[i]) - (ydata[i] - ydata[i - 1]) / (xdata[i] - xdata[i - 1]);
					delta[i] = (6 * delta[i] / (xdata[i + 1] - xdata[i - 1]) - s * delta[i - 1]) / p;
				}
	
				for (var j = n - 2; j >= 0; --j) {
					y2[j] = y2[j] * y2[j + 1] + delta[j];
				}
	
				//   xmax  - xmin  / #points
				var step = (xdata[n - 1] - xdata[0]) / (num - 1);
	
				var xnew = new Array;
				var ynew = new Array;
				var result = new Array;
	
				xnew[0] = xdata[0];
				ynew[0] = ydata[0];
	
				result.push(xnew[0]);
				result.push(ynew[0]);
	
				for ( j = 1; j < num; ++j) {
					//new x point (sampling point for the created curve)
					xnew[j] = xnew[0] + j * step;
	
					var max = n - 1;
					var min = 0;
	
					while (max - min > 1) {
						var k = Math.round((max + min) / 2);
						if (xdata[k] > xnew[j]) {
							max = k;
						} else {
							min = k;
						}
					}
	
					//found point one to the left and one to the right of generated new point
					var h = (xdata[max] - xdata[min]);
	
					if (h == 0) {
						//similar to above two points from original x data need some space between them
						return [];
					}
	
					var a = (xdata[max] - xnew[j]) / h;
					var b = (xnew[j] - xdata[min]) / h;
	
					ynew[j] = a * ydata[min] + b * ydata[max] + ((a * a * a - a) * y2[min] + (b * b * b - b) * y2[max]) * (h * h) / 6;
	
					result.push(xnew[j]);
					result.push(ynew[j]);
				}
	
				return result;
			}
			
			function hasInvalidParameters(curvedLinesOptions) {
				if (typeof curvedLinesOptions.fit != 'undefined' ||
				    typeof curvedLinesOptions.curvePointFactor != 'undefined' ||
				    typeof curvedLinesOptions.fitPointDist != 'undefined') {
				    	throw new Error("CurvedLines detected illegal parameters. The CurvedLines API changed with version 1.0.0 please check the options object.");
				    	return true;
				    }
				return false;
			}
			
	
		}//end init
	
	
		$.plot.plugins.push({
			init : init,
			options : options,
			name : 'curvedLines',
			version : '1.1.1'
		});
	
	})(jQuery);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* Plugin for jQuery for working with colors.
	 *
	 * Version 1.1.
	 *
	 * Inspiration from jQuery color animation plugin by John Resig.
	 *
	 * Released under the MIT license by Ole Laursen, October 2009.
	 *
	 * Examples:
	 *
	 *   $.color.parse("#fff").scale('rgb', 0.25).add('a', -0.5).toString()
	 *   var c = $.color.extract($("#mydiv"), 'background-color');
	 *   console.log(c.r, c.g, c.b, c.a);
	 *   $.color.make(100, 50, 25, 0.4).toString() // returns "rgba(100,50,25,0.4)"
	 *
	 * Note that .scale() and .add() return the same modified object
	 * instead of making a new one.
	 *
	 * V. 1.1: Fix error handling so e.g. parsing an empty string does
	 * produce a color rather than just crashing.
	 */
	
	(function($) {
	    $.color = {};
	
	    // construct color object with some convenient chainable helpers
	    $.color.make = function (r, g, b, a) {
	        var o = {};
	        o.r = r || 0;
	        o.g = g || 0;
	        o.b = b || 0;
	        o.a = a != null ? a : 1;
	
	        o.add = function (c, d) {
	            for (var i = 0; i < c.length; ++i) {
	                o[c.charAt(i)] += d;
	            }
	            return o.normalize();
	        };
	
	        o.scale = function (c, f) {
	            for (var i = 0; i < c.length; ++i) {
	                o[c.charAt(i)] *= f;
	            }
	            return o.normalize();
	        };
	
	        o.toString = function () {
	            if (o.a >= 1.0) {
	                return "rgb("+[o.r, o.g, o.b].join(",")+")";
	            } else {
	                return "rgba("+[o.r, o.g, o.b, o.a].join(",")+")";
	            }
	        };
	
	        o.normalize = function () {
	            function clamp(min, value, max) {
	                return value < min ? min: (value > max ? max: value);
	            }
	
	            o.r = clamp(0, parseInt(o.r, 10), 255);
	            o.g = clamp(0, parseInt(o.g, 10), 255);
	            o.b = clamp(0, parseInt(o.b, 10), 255);
	            o.a = clamp(0, o.a, 1);
	            return o;
	        };
	
	        o.clone = function () {
	            return $.color.make(o.r, o.b, o.g, o.a);
	        };
	
	        return o.normalize();
	    };
	
	    // extract CSS color property from element, going up in the DOM
	    // if it's "transparent"
	    $.color.extract = function (elem, css) {
	        var c;
	
	        do {
	            c = elem.css(css).toLowerCase();
	            // keep going until we find an element that has color, or
	            // we hit the body or root (have no parent)
	            if (c !== "" && c !== "transparent") {
	                break;
	            }
	            elem = elem.parent();
	        } while (elem.length && !$.nodeName(elem.get(0), "body"));
	
	        // catch Safari's way of signalling transparent
	        if (c === "rgba(0, 0, 0, 0)") {
	            c = "transparent";
	        }
	
	        return $.color.parse(c);
	    };
	
	    // parse CSS color string (like "rgb(10, 32, 43)" or "#fff"),
	    // returns color object, if parsing failed, you get black (0, 0,
	    // 0) out
	    $.color.parse = function (str) {
	        var res, m = $.color.make;
	
	        // Look for rgb(num,num,num)
		res = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(str);
	        if (res) {
	            return m(parseInt(res[1], 10), parseInt(res[2], 10), parseInt(res[3], 10));
	        }
	
	        // Look for rgba(num,num,num,num)
	        res = /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str);
	        if (res) {
	            return m(parseInt(res[1], 10), parseInt(res[2], 10), parseInt(res[3], 10), parseFloat(res[4]));
	        }
	
	        // Look for rgb(num%,num%,num%)
	        res = /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(str);
	        if (res) {
	            return m(parseFloat(res[1])*2.55, parseFloat(res[2])*2.55, parseFloat(res[3])*2.55);
	        }
	
	        // Look for rgba(num%,num%,num%,num)
	        res = /rgba\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str);
	        if (res) {
	            return m(parseFloat(res[1])*2.55, parseFloat(res[2])*2.55, parseFloat(res[3])*2.55, parseFloat(res[4]));
	        }
	
	        // Look for #a0b1c2
	        res = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(str);
	        if (res) {
	            return m(parseInt(res[1], 16), parseInt(res[2], 16), parseInt(res[3], 16));
	        }
	
	        // Look for #fff
	        res = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(str);
	        if (res) {
	            return m(parseInt(res[1]+res[1], 16), parseInt(res[2]+res[2], 16), parseInt(res[3]+res[3], 16));
	        }
	
	        // Otherwise, we're most likely dealing with a named color
	        var name = $.trim(str).toLowerCase();
	        if (name === "transparent") {
	            return m(255, 255, 255, 0);
	        } else {
	            // default to black
	            res = lookupColors[name] || [0, 0, 0];
	            return m(res[0], res[1], res[2]);
	        }
	    };
	
	    var lookupColors = {
	        aqua:[0,255,255],
	        azure:[240,255,255],
	        beige:[245,245,220],
	        black:[0,0,0],
	        blue:[0,0,255],
	        brown:[165,42,42],
	        cyan:[0,255,255],
	        darkblue:[0,0,139],
	        darkcyan:[0,139,139],
	        darkgrey:[169,169,169],
	        darkgreen:[0,100,0],
	        darkkhaki:[189,183,107],
	        darkmagenta:[139,0,139],
	        darkolivegreen:[85,107,47],
	        darkorange:[255,140,0],
	        darkorchid:[153,50,204],
	        darkred:[139,0,0],
	        darksalmon:[233,150,122],
	        darkviolet:[148,0,211],
	        fuchsia:[255,0,255],
	        gold:[255,215,0],
	        green:[0,128,0],
	        indigo:[75,0,130],
	        khaki:[240,230,140],
	        lightblue:[173,216,230],
	        lightcyan:[224,255,255],
	        lightgreen:[144,238,144],
	        lightgrey:[211,211,211],
	        lightpink:[255,182,193],
	        lightyellow:[255,255,224],
	        lime:[0,255,0],
	        magenta:[255,0,255],
	        maroon:[128,0,0],
	        navy:[0,0,128],
	        olive:[128,128,0],
	        orange:[255,165,0],
	        pink:[255,192,203],
	        purple:[128,0,128],
	        violet:[128,0,128],
	        red:[255,0,0],
	        silver:[192,192,192],
	        white:[255,255,255],
	        yellow:[255,255,0]
	    };
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* Javascript plotting library for jQuery, version 0.9.0-alpha.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	*/
	
	(function($) {
	
	    // A jquery-esque isNumeric method since we currently support 1.4.4
	    // and $.isNumeric was introduced on in 1.7
	    var isNumeric = $.isNumeric || function(obj) {
	        return obj - parseFloat( obj ) >= 0;
	    };
	
	    /**
	     * The Canvas object is a wrapper around an HTML5 <canvas> tag.
	     *
	     * @constructor
	     * @param {string} cls List of classes to apply to the canvas.
	     * @param {element} container Element onto which to append the canvas.
	     *
	     * Requiring a container is a little iffy, but unfortunately canvas
	     * operations don't work unless the canvas is attached to the DOM.
	     */
	    function Canvas(cls, container) {
	
	        var element = container.children("." + cls)[0];
	
	        if (element == null) {
	
	            element = document.createElement("canvas");
	            element.className = cls;
	
	            $(element).css({ direction: "ltr", position: "absolute", left: 0, top: 0 })
	                .appendTo(container);
	
	            // If HTML5 Canvas isn't available, fall back to [Ex|Flash]canvas
	            if (!element.getContext) {
	                if (window.G_vmlCanvasManager) {
	                    element = window.G_vmlCanvasManager.initElement(element);
	                } else {
	                    throw new Error("Canvas is not available. If you're using IE with a fall-back such as Excanvas, then there's either a mistake in your conditional include, or the page has no DOCTYPE and is rendering in Quirks Mode.");
	                }
	            }
	        }
	
	        this.element = element;
	
	        var context = this.context = element.getContext("2d"),
	
	            // Determine the screen's ratio of physical to device-independent
	            // pixels.  This is the ratio between the canvas width that the browser
	            // advertises and the number of pixels actually present in that space.
	
	            // The iPhone 4, for example, has a device-independent width of 320px,
	            // but its screen is actually 640px wide.  It therefore has a pixel
	            // ratio of 2, while most normal devices have a ratio of 1.
	            devicePixelRatio = window.devicePixelRatio || 1,
	            backingStoreRatio =
	                context.webkitBackingStorePixelRatio ||
	                context.mozBackingStorePixelRatio ||
	                context.msBackingStorePixelRatio ||
	                context.oBackingStorePixelRatio ||
	                context.backingStorePixelRatio || 1;
	
	        this.pixelRatio = devicePixelRatio / backingStoreRatio;
	
	        // Size the canvas to match the internal dimensions of its container
	        this.resize(container.width(), container.height());
	
	        // Collection of HTML div layers for text overlaid onto the canvas
	        this.textContainer = null;
	        this.text = {};
	
	        // Cache of text fragments and metrics, so we can avoid expensively
	        // re-calculating them when the plot is re-rendered in a loop.
	        this._textCache = {};
	    }
	
	    /**
	     * Resizes the canvas to the given dimensions.
	     *
	     * @param {number} width New width of the canvas, in pixels.
	     * @param {number} height New height of the canvas, in pixels.
	     */
	    Canvas.prototype.resize = function(width, height) {
	
	        if (width <= 0 || height <= 0) {
	            throw new Error("Invalid dimensions for plot, width = " + width + ", height = " + height);
	        }
	
	        var element = this.element,
	            context = this.context,
	            pixelRatio = this.pixelRatio;
	
	        // Resize the canvas, increasing its density based on the display's
	        // pixel ratio; basically giving it more pixels without increasing the
	        // size of its element, to take advantage of the fact that retina
	        // displays have that many more pixels in the same advertised space.
	
	        // Resizing should reset the state (excanvas seems to be buggy though)
	        if (this.width !== width) {
	            element.width = width * pixelRatio;
	            element.style.width = width + "px";
	            this.width = width;
	        }
	
	        if (this.height !== height) {
	            element.height = height * pixelRatio;
	            element.style.height = height + "px";
	            this.height = height;
	        }
	
	        // Save the context, so we can reset in case we get replotted.  The
	        // restore ensure that we're really back at the initial state, and
	        // should be safe even if we haven't saved the initial state yet.
	        context.restore();
	        context.save();
	
	        // Scale the coordinate space to match the display density; so even though we
	        // may have twice as many pixels, we still want lines and other drawing to
	        // appear at the same size; the extra pixels will just make them crisper.
	
	        context.scale(pixelRatio, pixelRatio);
	    };
	
	    /**
	     * Clears the entire canvas area, not including any overlaid HTML text
	     */
	    Canvas.prototype.clear = function() {
	        this.context.clearRect(0, 0, this.width, this.height);
	    };
	
	    /**
	     * Finishes rendering the canvas, including managing the text overlay.
	     */
	    Canvas.prototype.render = function() {
	
	        var cache = this._textCache;
	
	        // For each text layer, add elements marked as active that haven't
	        // already been rendered, and remove those that are no longer active.
	        for (var layerKey in cache) {
	            if (Object.prototype.hasOwnProperty.call(cache, layerKey)) {
	
	                var layer = this.getTextLayer(layerKey),
	                    layerCache = cache[layerKey];
	
	                layer.hide();
	
	                for (var styleKey in layerCache) {
	                    if (Object.prototype.hasOwnProperty.call(layerCache, styleKey)) {
	                        var styleCache = layerCache[styleKey];
	                        for (var angleKey in styleCache) {
	                            if (Object.prototype.hasOwnProperty.call(styleCache, angleKey)) {
	                                var angleCache = styleCache[angleKey];
	                                for (var key in angleCache) {
	                                    if (Object.prototype.hasOwnProperty.call(angleCache, key)) {
	
	                                        var positions = angleCache[key].positions;
	
	                                        for (var i = 0, position; position = positions[i]; i++) {
	                                            if (position.active) {
	                                                if (!position.rendered) {
	                                                    layer.append(position.element);
	                                                    position.rendered = true;
	                                                }
	                                            } else {
	                                                positions.splice(i--, 1);
	                                                if (position.rendered) {
	                                                    position.element.detach();
	                                                }
	                                            }
	                                        }
	
	                                        if (positions.length === 0) {
	                                            delete angleCache[key];
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	
	                layer.show();
	            }
	        }
	    };
	
	    /**
	     * Creates (if necessary) and returns the text overlay container.
	     *
	     * @param {string} classes String of space-separated CSS classes used to
	     *     uniquely identify the text layer.
	     * @return {object} The jQuery-wrapped text-layer div.
	     */
	    Canvas.prototype.getTextLayer = function(classes) {
	
	        var layer = this.text[classes];
	
	        // Create the text layer if it doesn't exist
	        if (layer == null) {
	
	            // Create the text layer container, if it doesn't exist
	            if (this.textContainer == null) {
	                this.textContainer = $("<div class='flot-text'></div>")
	                    .css({
	                        position: "absolute",
	                        top: 0,
	                        left: 0,
	                        bottom: 0,
	                        right: 0,
	                        "font-size": "smaller",
	                        color: "#545454"
	                    })
	                    .insertAfter(this.element);
	            }
	
	            layer = this.text[classes] = $("<div></div>")
	                .addClass(classes)
	                .css({
	                    position: "absolute",
	                    top: 0,
	                    left: 0,
	                    bottom: 0,
	                    right: 0
	                })
	                .appendTo(this.textContainer);
	        }
	
	        return layer;
	    };
	
	    /**
	     * Creates (if necessary) and returns a text info object.
	     *
	     * The object looks like this:
	     *
	     * {
	     *     width: Width of the text's wrapper div.
	     *     height: Height of the text's wrapper div.
	     *     element: The jQuery-wrapped HTML div containing the text.
	     *     positions: Array of positions at which this text is drawn.
	     * }
	     *
	     * The positions array contains objects that look like this:
	     *
	     * {
	     *     active: Flag indicating whether the text should be visible.
	     *     rendered: Flag indicating whether the text is currently visible.
	     *     element: The jQuery-wrapped HTML div containing the text.
	     *     x: X coordinate at which to draw the text.
	     *     y: Y coordinate at which to draw the text.
	     * }
	     *
	     * Each position after the first receives a clone of the original element.
	     *
	     * The idea is that that the width, height, and general 'identity' of the
	     * text is constant no matter where it is placed; the placements are a
	     * secondary property.
	     *
	     * Canvas maintains a cache of recently-used text info objects; getTextInfo
	     * either returns the cached element or creates a new entry.
	     *
	     * @param {string} layer A string of space-separated CSS classes uniquely
	     *     identifying the layer containing this text.
	     * @param {string} text Text string to retrieve info for.
	     * @param {(string|object)=} font Either a string of space-separated CSS
	     *     classes or a font-spec object, defining the text's font and style.
	     * @param {number=} angle Angle at which to rotate the text, in degrees.
	     * @param {number=} width Maximum width of the text before it wraps.
	     * @return {object} a text info object.
	     */
	    Canvas.prototype.getTextInfo = function(layer, text, font, angle, width) {
	
	        var textStyle, layerCache, styleCache, angleCache, info;
	
	        // Cast to string in case we have a number or such
	        text = "" + text;
	
	        // Normalize the angle to 0...359
	        angle = (360 + (angle || 0)) % 360;
	
	        // If the font is a font-spec object, generate a CSS font definition
	        if (typeof font === "object") {
	            textStyle = font.style + " " + font.variant + " " + font.weight + " " + font.size + "px/" + font.lineHeight + "px " + font.family;
	        } else {
	            textStyle = font;
	        }
	
	        // Retrieve or create the caches for the text's layer, style, and angle
	        layerCache = this._textCache[layer];
	        if (layerCache == null) {
	            layerCache = this._textCache[layer] = {};
	        }
	
	        styleCache = layerCache[textStyle];
	        if (styleCache == null) {
	            styleCache = layerCache[textStyle] = {};
	        }
	
	        angleCache = styleCache[angle];
	        if (angleCache == null) {
	            angleCache = styleCache[angle] = {};
	        }
	
	        info = angleCache[text];
	
	        // If we can't find a matching element in our cache, create a new one
	        if (info == null) {
	
	            var element = $("<div></div>").html(text)
	                .css({
	                    position: "absolute",
	                    "max-width": width,
	                    top: -9999
	                })
	                .appendTo(this.getTextLayer(layer));
	
	            if (typeof font === "object") {
	                element.css({
	                    font: textStyle,
	                    color: font.color
	                });
	            } else if (typeof font === "string") {
	                element.addClass(font);
	            }
	
	            // Save the original dimensions of the text; we'll modify these
	            // later to take into account rotation, if there is any.
	            var textWidth = element.outerWidth(true),
	                textHeight = element.outerHeight(true);
	
	            // Apply rotation to the text using CSS3/IE matrix transforms
	
	            // Note how we also set the element's width, as a work-around for
	            // the way most browsers resize the div on rotate, which may cause
	            // the contents to wrap differently. The extra +1 is because IE
	            // rounds the width differently and needs a little extra help.
	            if (angle) {
	
	                var radians = angle * Math.PI / 180,
	                    sin = Math.sin(radians),
	                    cos = Math.cos(radians),
	
	                    // Use fixed-point so these don't show up in scientific
	                    // notation when we add them to the string
	                    a = cos.toFixed(6),
	                    b = (-sin).toFixed(6),
	                    c = sin.toFixed(6),
	
	                    transformRule;
	
	                // Detect IE7/8 to use microsofts proprietary matrix filter
	                // $.support.leadingWhitespace is false on IE7/8, true on other browsers and
	                // undefined with jQuery greater 2.0, which dropped support for IE7/8.
	                if ($.support.leadingWhitespace !== false) {
	
	                    // The transform origin defaults to '50% 50%', producing
	                    // blurry text on some browsers (Chrome) when the width or
	                    // height happens to be odd, making 50% fractional. Avoid
	                    // this by setting the origin to rounded values.
	                    var cx = textWidth / 2,
	                        cy = textHeight / 2,
	                        transformOrigin = Math.floor(cx) + "px " + Math.floor(cy) + "px",
	
	                        // Transforms alter the div's appearance without changing
	                        // its origin. This will make it difficult to position it
	                        // later, since we'll be positioning the new bounding box
	                        // with respect to the old origin. We can work around this
	                        // by adding a translation to align the new bounding box's
	                        // top-left corner with the origin, using the same matrix.
	
	                        // Rather than examining all four points, we can use the
	                        // angle to figure out in advance which two points are in
	                        // the top-left quadrant; we can then use the x-coordinate
	                        // of the first (left-most) point and the y-coordinate of
	                        // the second (top-most) point as the bounding box corner.
	                        x, y;
	
	                    if (angle < 90) {
	                        x = Math.floor(cx * cos + cy * sin - cx);
	                        y = Math.floor(cx * sin + cy * cos - cy);
	                    } else if (angle < 180) {
	                        x = Math.floor(cy * sin - cx * cos - cx);
	                        y = Math.floor(cx * sin - cy * cos - cy);
	                    } else if (angle < 270) {
	                        x = Math.floor(-cx * cos - cy * sin - cx);
	                        y = Math.floor(-cx * sin - cy * cos - cy);
	                    } else {
	                        x = Math.floor(cx * cos - cy * sin - cx);
	                        y = Math.floor(cy * cos - cx * sin - cy);
	                    }
	
	                    transformRule = "matrix(" + a + "," + c + "," + b + "," + a + "," + x + "," + y + ")";
	
	                    element.css({
	                        width: textWidth + 1,
	                        transform: transformRule,
	                        "-o-transform": transformRule,
	                        "-ms-transform": transformRule,
	                        "-moz-transform": transformRule,
	                        "-webkit-transform": transformRule,
	                        "transform-origin": transformOrigin,
	                        "-o-transform-origin": transformOrigin,
	                        "-ms-transform-origin": transformOrigin,
	                        "-moz-transform-origin": transformOrigin,
	                        "-webkit-transform-origin": transformOrigin
	                    });
	
	                } else {
	
	                    // The IE7/8 matrix filter produces very ugly aliasing for
	                    // text with a transparent background. Using a solid color
	                    // greatly improves text clarity, although it does result
	                    // in ugly boxes for plots using a non-white background.
	
	                    // TODO: Instead of white use the actual background color?
	                    // This still wouldn't solve the problem when the plot has
	                    // a gradient background, but it would at least help.
	                    transformRule = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + a + ",sizingMethod='auto expand')";
	
	                    element.css({
	                        width: textWidth + 1,
	                        filter: transformRule,
	                        "-ms-filter": transformRule,
	                        "background-color": "#fff"
	                    });
	                }
	
	                // Compute the final dimensions of the text's bounding box
	                var ac = Math.abs(cos),
	                    as = Math.abs(sin),
	                    originalWidth = textWidth;
	                textWidth = Math.round(ac * textWidth + as * textHeight);
	                textHeight = Math.round(as * originalWidth + ac * textHeight);
	            }
	
	            info = angleCache[text] = {
	                width: textWidth,
	                height: textHeight,
	                element: element,
	                positions: []
	            };
	
	            element.detach();
	        }
	
	        return info;
	    };
	
	    /**
	     * Adds a text string to the canvas text overlay.
	     *
	     * The text isn't drawn immediately; it is marked as rendering, which will
	     * result in its addition to the canvas on the next render pass.
	     *
	     * @param {string} layer A string of space-separated CSS classes uniquely
	     *     identifying the layer containing this text.
	     * @param {number} x X coordinate at which to draw the text.
	     * @param {number} y Y coordinate at which to draw the text.
	     * @param {string} text Text string to draw.
	     * @param {(string|object)=} font Either a string of space-separated CSS
	     *     classes or a font-spec object, defining the text's font and style.
	     * @param {number=} angle Angle at which to rotate the text, in degrees.
	     * @param {number=} width Maximum width of the text before it wraps.
	     * @param {string=} halign Horizontal alignment of the text; either "left",
	     *     "center" or "right".
	     * @param {string=} valign Vertical alignment of the text; either "top",
	     *     "middle" or "bottom".
	     */
	    Canvas.prototype.addText = function(layer, x, y, text, font, angle, width, halign, valign) {
	
	        var info = this.getTextInfo(layer, text, font, angle, width),
	            positions = info.positions;
	
	        // Tweak the div's position to match the text's alignment
	        if (halign === "center") {
	            x -= info.width / 2;
	        } else if (halign === "right") {
	            x -= info.width;
	        }
	
	        if (valign === "middle") {
	            y -= info.height / 2;
	        } else if (valign === "bottom") {
	            y -= info.height;
	        }
	
	        // Determine whether this text already exists at this position.
	        // If so, mark it for inclusion in the next render pass.
	        for (var i = 0, position; position = positions[i]; i++) {
	            if (position.x === x && position.y === y) {
	                position.active = true;
	                return;
	            }
	        }
	
	        // If the text doesn't exist at this position, create a new entry
	
	        // For the very first position we'll re-use the original element,
	        // while for subsequent ones we'll clone it.
	        position = {
	            active: true,
	            rendered: false,
	            element: positions.length ? info.element.clone() : info.element,
	            x: x,
	            y: y
	        };
	
	        positions.push(position);
	
	        // Move the element to its final position within the container
	        position.element.css({
	            top: Math.round(y),
	            left: Math.round(x),
	
	            // In case the text wraps
	
	            "text-align": halign
	        });
	    };
	
	    /**
	     * Removes one or more text strings from the canvas text overlay.
	     *
	     * If no parameters are given, all text within the layer is removed.
	     *
	     * Note that the text is not immediately removed; it is simply marked as
	     * inactive, which will result in its removal on the next render pass.
	     * This avoids the performance penalty for 'clear and redraw' behavior,
	     * where we potentially get rid of all text on a layer, but will likely
	     * add back most or all of it later, as when redrawing axes, for example.
	     *
	     * @param {string} layer A string of space-separated CSS classes uniquely
	     *     identifying the layer containing this text.
	     * @param {number=} x X coordinate of the text.
	     * @param {number=} y Y coordinate of the text.
	     * @param {string=} text Text string to remove.
	     * @param {(string|object)=} font Either a string of space-separated CSS
	     *     classes or a font-spec object, defining the text's font and style.
	     * @param {number=} angle Angle at which the text is rotated, in degrees.
	     *     Angle is currently unused, it will be implemented in the future.
	     */
	    Canvas.prototype.removeText = function(layer, x, y, text, font, angle) {
	        var i, positions, position;
	        if (text == null) {
	            var layerCache = this._textCache[layer];
	            if (layerCache != null) {
	                for (var styleKey in layerCache) {
	                    if (Object.prototype.hasOwnProperty.call(layerCache, styleKey)) {
	                        var styleCache = layerCache[styleKey];
	                        for (var angleKey in styleCache) {
	                            if (Object.prototype.hasOwnProperty.call(styleCache, angleKey)) {
	                                var angleCache = styleCache[angleKey];
	                                for (var key in angleCache) {
	                                    if (Object.prototype.hasOwnProperty.call(angleCache, key)) {
	                                        positions = angleCache[key].positions;
	                                        for (i = 0; position = positions[i]; i++) {
	                                            position.active = false;
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        } else {
	            positions = this.getTextInfo(layer, text, font, angle).positions;
	            for (i = 0; position = positions[i]; i++) {
	                if (position.x === x && position.y === y) {
	                    position.active = false;
	                }
	            }
	        }
	    };
	
	    /**
	     * The top-level container for the entire plot.
	     */
	    function Plot(placeholder, data_, options_, plugins) {
	
	        // data is on the form:
	        //   [ series1, series2 ... ]
	        // where series is either just the data as [ [x1, y1], [x2, y2], ... ]
	        // or { data: [ [x1, y1], [x2, y2], ... ], label: "some label", ... }
	        var series = [],
	            options = {
	
	                // the color theme used for graphs
	                colors: ["#edc240", "#afd8f8", "#cb4b4b", "#4da74d", "#9440ed"],
	                legend: {
	                    show: true,
	
	                    // number of colums in legend table
	                    noColumns: 1,
	
	                    // fn: string -> string
	                    labelFormatter: null,
	
	                    // border color for the little label boxes
	                    labelBoxBorderColor: "#ccc",
	
	                    // container (as jQuery object) to put legend in, null means default on top of graph
	                    container: null,
	
	                    // position of default legend container within plot
	                    position: "ne",
	
	                    // distance from grid edge to default legend container within plot
	                    margin: 5,
	
	                    // null means auto-detect
	                    backgroundColor: null,
	
	                    // set to 0 to avoid background
	                    backgroundOpacity: 0.85,
	
	                    // default to no legend sorting
	                    sorted: null
	                },
	                xaxis: {
	
	                    // null = auto-detect, true = always, false = never
	
	                    show: null,
	
	                    // or "top"
	                    position: "bottom",
	
	                    // null or "time"
	                    mode: null,
	
	                    // base color, labels, ticks
	                    color: null,
	
	                    // null (derived from CSS in placeholder) or
	                    // object like { size: 11, lineHeight: 13, style: "italic", weight: "bold", family: "sans-serif", variant: "small-caps" }
	                    font: null,
	
	                    // min. value to show, null means set automatically
	                    min: null,
	
	                    // max. value to show, null means set automatically
	                    max: null,
	
	                    // margin in % to add if auto-setting min/max
	                    autoscaleMargin: null,
	
	                    // null or f: number -> number to transform axis
	                    transform: null,
	
	                    // if transform is set, this should be the inverse function
	                    inverseTransform: null,
	
	                    // either [1, 3] or [[1, "a"], 3] or (fn: axis info -> ticks) or app. number of ticks for auto-ticks
	                    ticks: null,
	
	                    // number or [number, "unit"]
	                    tickSize: null,
	
	                    // number or [number, "unit"]
	                    minTickSize: null,
	
	                    // fn: number -> string
	                    tickFormatter: null,
	
	                    // no. of decimals, null means auto
	                    tickDecimals: null,
	
	                    // possibly different color of ticks, e.g. "rgba(0,0,0,0.15)"
	                    tickColor: null,
	
	                    // size in pixels of ticks, or "full" for whole line
	                    tickLength: null,
	
	                    // width of tick labels in pixels
	                    tickWidth: null,
	
	                    // height of tick labels in pixels
	                    tickHeight: null,
	
	                    // null or font-spec object (see font, above)
	                    tickFont: null,
	
	                    // null or an axis label string
	                    label: null,
	
	                    // null or font-spec object (see font, above)
	                    labelFont: null,
	
	                    // spacing between the axis and its label
	                    labelPadding: 2,
	
	                    // whether to reserve space even if axis isn't shown
	                    reserveSpace: null,
	
	                    // axis number or null for no sync
	                    alignTicksWithAxis: null
	                },
	                yaxis: {
	
	                    // also accepts "right"
	                    position: "left",
	                    autoscaleMargin: 0.02,
	                    labelPadding: 2
	                },
	                xaxes: [],
	                yaxes: [],
	                series: {
	                    points: {
	                        show: false,
	                        radius: 3,
	
	                        // value in pixels
	                        lineWidth: 2,
	                        fill: true,
	                        fillColor: "#ffffff",
	                        strokeColor: null,
	
	                        // type or callback
	                        symbol: "circle"
	                    },
	
	
	                    lines: {
	
	                        // we don't put in show: false so we can see
	                        // whether lines were actively disabled
	
	                        // value in pixels
	                        lineWidth: 2,
	                        fill: false,
	                        fillColor: null,
	                        steps: false
	
	                        // Omit 'zero', so we can later default its value to
	                        // match that of the 'fill' option.
	                    },
	                    bars: {
	                        show: false,
	
	                        // in pixels
	                        lineWidth: 2,
	
	                        // in units of the x axis
	                        barWidth: 1,
	
	                        fill: true,
	                        fillColor: null,
	
	                        // "left", "right", or "center"
	                        align: "left",
	                        horizontal: false,
	                        zero: true
	                    },
	                    shadowSize: 3,
	                    highlightColor: null
	                },
	                grid: {
	                    show: true,
	                    aboveData: false,
	
	                    // primary color used for outline and labels
	                    color: "#545454",
	
	                    // null for transparent, else color
	                    backgroundColor: null,
	
	                    // set if different from the grid color
	                    borderColor: null,
	
	                    // color for the ticks, e.g. "rgba(0,0,0,0.15)"
	                    tickColor: null,
	
	                    // distance from the canvas edge to the grid
	                    margin: 0,
	
	                    // value in pixels
	                    labelMargin: 5,
	
	                    // value in pixels
	                    axisMargin: 8,
	
	                    // value in pixels
	                    borderWidth: 2,
	
	                    // value in pixels, null means taken from points radius
	                    minBorderMargin: null,
	
	                    // array of ranges or fn: axes -> array of ranges
	                    markings: null,
	                    markingsColor: "#f4f4f4",
	                    markingsLineWidth: 2,
	
	                    // interactive stuff
	                    clickable: false,
	                    hoverable: false,
	
	                    // highlight in case mouse is near
	                    autoHighlight: true,
	
	                    // how far the mouse can be away to activate an item
	                    mouseActiveRadius: 10
	                },
	                interaction: {
	
	                    // time between updates, -1 means in same flow
	                    redrawOverlayInterval: 1000 / 60
	                },
	                hooks: {}
	            },
	
	            // interactive features
	            highlights = [],
	            redrawTimeout = null,
	
	            // the canvas for the plot itself
	            surface = null,
	
	            // canvas for interactive stuff on top of plot
	            overlay = null,
	
	            // jQuery object that events should be bound to
	            eventHolder = null,
	            ctx = null,
	            octx = null,
	            xaxes = [],
	            yaxes = [],
	            plotOffset = {
	                left: 0,
	                right: 0,
	                top: 0,
	                bottom: 0
	            },
	            plotWidth = 0,
	            plotHeight = 0,
	            hooks = {
	                processOptions: [],
	                processRawData: [],
	                processDatapoints: [],
	                processOffset: [],
	                drawBackground: [],
	                drawSeries: [],
	                draw: [],
	                bindEvents: [],
	                drawOverlay: [],
	                shutdown: []
	            },
	            plot = this;
	
	        // public functions
	        plot.setData = setData;
	        plot.setupGrid = setupGrid;
	        plot.draw = draw;
	        plot.getPlaceholder = function() { return placeholder; };
	        plot.getCanvas = function() { return surface.element; };
	        plot.getPlotOffset = function() { return plotOffset; };
	        plot.width = function() { return plotWidth; };
	        plot.height = function() { return plotHeight; };
	        plot.offset = function() {
	            var o = eventHolder.offset();
	            o.left += plotOffset.left;
	            o.top += plotOffset.top;
	            return o;
	        };
	        plot.getData = function() { return series; };
	        plot.getAxes = function() {
	            var res = {};
	            $.each(xaxes.concat(yaxes), function(_, axis) {
	                if (axis) {
	                    res[axis.direction + (axis.n !== 1 ? axis.n : "") + "axis"] = axis;
	                }
	            });
	            return res;
	        };
	        plot.getXAxes = function() { return xaxes; };
	        plot.getYAxes = function() { return yaxes; };
	        plot.c2p = canvasToAxisCoords;
	        plot.p2c = axisToCanvasCoords;
	        plot.getOptions = function() { return options; };
	        plot.highlight = highlight;
	        plot.unhighlight = unhighlight;
	        plot.triggerRedrawOverlay = triggerRedrawOverlay;
	        plot.pointOffset = function(point) {
	            return {
	                left: parseInt(xaxes[axisNumber(point, "x") - 1].p2c(+point.x) + plotOffset.left, 10),
	                top: parseInt(yaxes[axisNumber(point, "y") - 1].p2c(+point.y) + plotOffset.top, 10)
	            };
	        };
	        plot.shutdown = shutdown;
	        plot.destroy = function() {
	            shutdown();
	            placeholder.removeData("plot").empty();
	
	            series = [];
	            options = null;
	            surface = null;
	            overlay = null;
	            eventHolder = null;
	            ctx = null;
	            octx = null;
	            xaxes = [];
	            yaxes = [];
	            hooks = null;
	            highlights = [];
	            plot = null;
	        };
	        plot.resize = function(width, height) {
	            width = width || placeholder.width();
	            height = height || placeholder.height();
	            surface.resize(width, height);
	            overlay.resize(width, height);
	        };
	
	        // public attributes
	        plot.hooks = hooks;
	
	        // initialize
	        initPlugins(plot);
	        parseOptions(options_);
	        setupCanvases();
	        setData(data_);
	        setupGrid();
	        draw();
	        bindEvents();
	
	        function executeHooks(hook, args) {
	            args = [plot].concat(args);
	            for (var i = 0; i < hook.length; ++i) {
	                hook[i].apply(this, args);
	            }
	        }
	
	        function initPlugins() {
	
	            // References to key classes, allowing plugins to modify them
	            var classes = {
	                Canvas: Canvas
	            };
	
	            for (var i = 0; i < plugins.length; ++i) {
	                var p = plugins[i];
	                p.init(plot, classes);
	                if (p.options) {
	                    $.extend(true, options, p.options);
	                }
	            }
	        }
	
	        function parseOptions(opts) {
	
	            $.extend(true, options, opts);
	
	            // $.extend merges arrays, rather than replacing them.  When less
	            // colors are provided than the size of the default palette, we
	            // end up with those colors plus the remaining defaults, which is
	            // not expected behavior; avoid it by replacing them here.
	            if (opts && opts.colors) {
	                options.colors = opts.colors;
	            }
	
	            if (options.xaxis.color == null) {
	                options.xaxis.color = $.color.parse(options.grid.color).scale("a", 0.22).toString();
	            }
	            if (options.yaxis.color == null) {
	                options.yaxis.color = $.color.parse(options.grid.color).scale("a", 0.22).toString();
	            }
	
	            if (options.xaxis.tickColor == null) {
	
	                // grid.tickColor for back-compatibility
	                options.xaxis.tickColor = options.grid.tickColor || options.xaxis.color;
	            }
	            if (options.yaxis.tickColor == null) {
	
	                // grid.tickColor for back-compatibility
	                options.yaxis.tickColor = options.grid.tickColor || options.yaxis.color;
	            }
	
	            if (options.grid.borderColor == null) {
	                options.grid.borderColor = options.grid.color;
	            }
	            if (options.grid.tickColor == null) {
	                options.grid.tickColor = $.color.parse(options.grid.color).scale("a", 0.22).toString();
	            }
	
	            // Fill in defaults for axis options, including any unspecified
	            // font-spec fields, if a font-spec was provided.
	
	            // If no x/y axis options were provided, create one of each anyway,
	            // since the rest of the code assumes that they exist.
	            var i, axisOptions, axisCount,
	                fontSize = placeholder.css("font-size"),
	                fontSizeDefault = fontSize ? +fontSize.replace("px", "") : 13,
	                fontDefaults = {
	                    style: placeholder.css("font-style"),
	                    size: Math.round(0.8 * fontSizeDefault),
	                    variant: placeholder.css("font-variant"),
	                    weight: placeholder.css("font-weight"),
	                    family: placeholder.css("font-family")
	                },
	                markings;
	
	            axisCount = options.xaxes.length || 1;
	            for (i = 0; i < axisCount; ++i) {
	
	                axisOptions = options.xaxes[i];
	                if (axisOptions && !axisOptions.tickColor) {
	                    axisOptions.tickColor = axisOptions.color;
	                }
	
	                // Compatibility with markrcote/flot-axislabels
	                if (axisOptions) {
	                    if (!axisOptions.label && axisOptions.axisLabel) {
	                        axisOptions.label = axisOptions.axisLabel;
	                    }
	                    if (!axisOptions.labelPadding && axisOptions.axisLabelPadding) {
	                        axisOptions.labelPadding = axisOptions.axisLabelPadding;
	                    }
	                }
	
	                axisOptions = $.extend(true, {}, options.xaxis, axisOptions);
	                options.xaxes[i] = axisOptions;
	
	                if (axisOptions.font) {
	                    axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
	                }
	                if (axisOptions.tickFont || axisOptions.font) {
	                    axisOptions.tickFont = $.extend({}, axisOptions.font || fontDefaults, axisOptions.tickFont);
	                    if (!axisOptions.tickFont.color) {
	                        axisOptions.tickFont.color = axisOptions.color;
	                    }
	                    if (!axisOptions.tickFont.lineHeight) {
	                        axisOptions.tickFont.lineHeight = Math.round(axisOptions.tickFont.size * 1.15);
	                    }
	                }
	                if (axisOptions.label && (axisOptions.labelFont || axisOptions.font)) {
	                    axisOptions.labelFont = $.extend({}, axisOptions.font || fontDefaults, axisOptions.labelFont);
	                    if (!axisOptions.labelFont.color) {
	                        axisOptions.labelFont.color = axisOptions.color;
	                    }
	                    if (!axisOptions.labelFont.lineHeight) {
	                        axisOptions.labelFont.lineHeight = Math.round(axisOptions.labelFont.size * 1.15);
	                    }
	                }
	                if (axisOptions.font) {
	                    if (!axisOptions.font.color) {
	                        axisOptions.font.color = axisOptions.color;
	                    }
	                    if (!axisOptions.font.lineHeight) {
	                        axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
	                    }
	                }
	            }
	
	            axisCount = options.yaxes.length || 1;
	            for (i = 0; i < axisCount; ++i) {
	
	                axisOptions = options.yaxes[i];
	                if (axisOptions && !axisOptions.tickColor) {
	                    axisOptions.tickColor = axisOptions.color;
	                }
	
	                // Compatibility with markrcote/flot-axislabels
	                if (axisOptions) {
	                    if (!axisOptions.label && axisOptions.axisLabel) {
	                        axisOptions.label = axisOptions.axisLabel;
	                    }
	                    if (!axisOptions.labelPadding && axisOptions.axisLabelPadding) {
	                        axisOptions.labelPadding = axisOptions.axisLabelPadding;
	                    }
	                }
	
	                axisOptions = $.extend(true, {}, options.yaxis, axisOptions);
	                options.yaxes[i] = axisOptions;
	
	                if (axisOptions.font) {
	                    axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
	                }
	                if (axisOptions.tickFont || axisOptions.font) {
	                    axisOptions.tickFont = $.extend({}, axisOptions.font || fontDefaults, axisOptions.tickFont);
	                    if (!axisOptions.tickFont.color) {
	                        axisOptions.tickFont.color = axisOptions.color;
	                    }
	                    if (!axisOptions.tickFont.lineHeight) {
	                        axisOptions.tickFont.lineHeight = Math.round(axisOptions.tickFont.size * 1.15);
	                    }
	                }
	                if (axisOptions.label && (axisOptions.labelFont || axisOptions.font)) {
	                    axisOptions.labelFont = $.extend({}, axisOptions.font || fontDefaults, axisOptions.labelFont);
	                    if (!axisOptions.labelFont.color) {
	                        axisOptions.labelFont.color = axisOptions.color;
	                    }
	                    if (!axisOptions.labelFont.lineHeight) {
	                        axisOptions.labelFont.lineHeight = Math.round(axisOptions.labelFont.size * 1.15);
	                    }
	                }
	                if (axisOptions.font) {
	                    if (!axisOptions.font.color) {
	                        axisOptions.font.color = axisOptions.color;
	                    }
	                    if (!axisOptions.font.lineHeight) {
	                        axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
	                    }
	                }
	            }
	
	            markings = options.grid.markings;
	            if ($.isArray(markings)) {
	                for (i = 0; i < markings.length; ++i) {
	
	                    if (markings[i].font) {
	                        markings[i].font = $.extend({}, fontDefaults, markings[i].font);
	                    }
	                }
	            }
	
	            // backwards compatibility, to be removed in future
	            if (options.xaxis.noTicks && options.xaxis.ticks == null) {
	                options.xaxis.ticks = options.xaxis.noTicks;
	            }
	            if (options.yaxis.noTicks && options.yaxis.ticks == null) {
	                options.yaxis.ticks = options.yaxis.noTicks;
	            }
	            if (options.x2axis) {
	                options.xaxes[1] = $.extend(true, {}, options.xaxis, options.x2axis);
	                options.xaxes[1].position = "top";
	                // Override the inherit to allow the axis to auto-scale
	                if (options.x2axis.min == null) {
	                    options.xaxes[1].min = null;
	                }
	                if (options.x2axis.max == null) {
	                    options.xaxes[1].max = null;
	                }
	            }
	            if (options.y2axis) {
	                options.yaxes[1] = $.extend(true, {}, options.yaxis, options.y2axis);
	                options.yaxes[1].position = "right";
	                // Override the inherit to allow the axis to auto-scale
	                if (options.y2axis.min == null) {
	                    options.yaxes[1].min = null;
	                }
	                if (options.y2axis.max == null) {
	                    options.yaxes[1].max = null;
	                }
	            }
	            if (options.grid.coloredAreas) {
	                options.grid.markings = options.grid.coloredAreas;
	            }
	            if (options.grid.coloredAreasColor) {
	                options.grid.markingsColor = options.grid.coloredAreasColor;
	            }
	            if (options.lines) {
	                $.extend(true, options.series.lines, options.lines);
	            }
	            if (options.points) {
	                $.extend(true, options.series.points, options.points);
	            }
	            if (options.bars) {
	                $.extend(true, options.series.bars, options.bars);
	            }
	            if (options.shadowSize != null) {
	                options.series.shadowSize = options.shadowSize;
	            }
	            if (options.highlightColor != null) {
	                options.series.highlightColor = options.highlightColor;
	            }
	
	            // save options on axes for future reference
	            for (i = 0; i < options.xaxes.length; ++i) {
	                getOrCreateAxis(xaxes, i + 1).options = options.xaxes[i];
	            }
	            for (i = 0; i < options.yaxes.length; ++i) {
	                getOrCreateAxis(yaxes, i + 1).options = options.yaxes[i];
	            }
	
	            // add hooks from options
	            for (var n in hooks) {
	                if (options.hooks[n] && options.hooks[n].length) {
	                    hooks[n] = hooks[n].concat(options.hooks[n]);
	                }
	            }
	
	            executeHooks(hooks.processOptions, [options]);
	        }
	
	        function setData(d) {
	            series = parseData(d);
	            fillInSeriesOptions();
	            processData();
	        }
	
	        function parseData(d) {
	            var res = [];
	            for (var i = 0; i < d.length; ++i) {
	                var s = $.extend(true, {}, options.series);
	
	                if (d[i].data != null) {
	
	                    // move the data instead of deep-copy
	                    s.data = d[i].data;
	                    delete d[i].data;
	
	                    $.extend(true, s, d[i]);
	
	                    d[i].data = s.data;
	                } else {
	                    s.data = d[i];
	                }
	                res.push(s);
	            }
	
	            return res;
	        }
	
	        function axisNumber(obj, coord) {
	            var a = obj[coord + "axis"];
	
	            if (typeof a === "object") {
	
	                // if we got a real axis, extract number
	                a = a.n;
	            }
	            if (!isNumeric(a)) {
	
	                // default to first axis
	                a = 1;
	            }
	            return a;
	        }
	
	        function allAxes() {
	
	            // return flat array without annoying null entries
	            return $.grep(xaxes.concat(yaxes), function(a) { return a; });
	        }
	
	        function canvasToAxisCoords(pos) {
	
	            // return an object with x/y corresponding to all used axes
	            var res = {}, i, axis;
	            for (i = 0; i < xaxes.length; ++i) {
	                axis = xaxes[i];
	                if (axis && axis.used) {
	                    res["x" + axis.n] = axis.c2p(pos.left);
	                }
	            }
	
	            for (i = 0; i < yaxes.length; ++i) {
	                axis = yaxes[i];
	                if (axis && axis.used) {
	                    res["y" + axis.n] = axis.c2p(pos.top);
	                }
	            }
	
	            if (res.x1 !== undefined) {
	                res.x = res.x1;
	            }
	            if (res.y1 !== undefined) {
	                res.y = res.y1;
	            }
	
	            return res;
	        }
	
	        function axisToCanvasCoords(pos) {
	
	            // get canvas coords from the first pair of x/y found in pos
	            var res = {}, i, axis, key;
	
	            for (i = 0; i < xaxes.length; ++i) {
	                axis = xaxes[i];
	                if (axis && axis.used) {
	                    key = "x" + axis.n;
	                    if (pos[key] == null && axis.n === 1) {
	                        key = "x";
	                    }
	
	                    if (pos[key] != null) {
	                        res.left = axis.p2c(pos[key]);
	                        break;
	                    }
	                }
	            }
	
	            for (i = 0; i < yaxes.length; ++i) {
	                axis = yaxes[i];
	                if (axis && axis.used) {
	                    key = "y" + axis.n;
	                    if (pos[key] == null && axis.n === 1) {
	                        key = "y";
	                    }
	
	                    if (pos[key] != null) {
	                        res.top = axis.p2c(pos[key]);
	                        break;
	                    }
	                }
	            }
	
	            return res;
	        }
	
	        function getOrCreateAxis(axes, number) {
	            if (!axes[number - 1]) {
	                axes[number - 1] = {
	
	                    // save the number for future reference
	                    n: number,
	                    direction: axes === xaxes ? "x" : "y",
	                    options: $.extend(true, {}, axes === xaxes ? options.xaxis : options.yaxis)
	                };
	            }
	
	            return axes[number - 1];
	        }
	
	        function fillInSeriesOptions() {
	
	            var neededColors = series.length, maxIndex = -1, i;
	
	            // Subtract the number of series that already have fixed colors or
	            // color indexes from the number that we still need to generate.
	            for (i = 0; i < series.length; ++i) {
	                var sc = series[i].color;
	                if (sc != null) {
	                    neededColors--;
	                    if (isNumeric(sc) && sc > maxIndex) {
	                        maxIndex = sc;
	                    }
	                }
	            }
	
	            // If any of the series have fixed color indexes, then we need to
	            // generate at least as many colors as the highest index.
	            if (neededColors <= maxIndex) {
	                neededColors = maxIndex + 1;
	            }
	
	            // Generate all the colors, using first the option colors and then
	            // variations on those colors once they're exhausted.
	            var c, colors = [], colorPool = options.colors,
	                colorPoolSize = colorPool.length, variation = 0;
	
	            for (i = 0; i < neededColors; i++) {
	
	                c = $.color.parse(colorPool[i % colorPoolSize] || "#666");
	
	                // Each time we exhaust the colors in the pool we adjust
	                // a scaling factor used to produce more variations on
	                // those colors. The factor alternates negative/positive
	                // to produce lighter/darker colors.
	
	                // Reset the variation after every few cycles, or else
	                // it will end up producing only white or black colors.
	                if (i % colorPoolSize === 0 && i) {
	                    if (variation >= 0) {
	                        if (variation < 0.5) {
	                            variation = -variation - 0.2;
	                        } else {
	                            variation = 0;
	                        }
	                    } else {
	                        variation = -variation;
	                    }
	                }
	
	                colors[i] = c.scale("rgb", 1 + variation);
	            }
	
	            // Finalize the series options, filling in their colors
	            var colori = 0, s;
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	
	                // assign colors
	                if (s.color == null) {
	                    s.color = colors[colori].toString();
	                    ++colori;
	                } else if (isNumeric(s.color)) {
	                    s.color = colors[s.color].toString();
	                }
	
	                // turn on lines automatically in case nothing is set
	                if (s.lines.show == null) {
	                    var v, show = true;
	                    for (v in s) {
	                        if (s[v] && s[v].show) {
	                            show = false;
	                            break;
	                        }
	                    }
	                    if (show) {
	                        s.lines.show = true;
	                    }
	                }
	
	                // If nothing was provided for lines.zero, default it to match
	                // lines.fill, since areas by default should extend to zero.
	                if (s.lines.zero == null) {
	                    s.lines.zero = !!s.lines.fill;
	                }
	
	                // setup axes
	                s.xaxis = getOrCreateAxis(xaxes, axisNumber(s, "x"));
	                s.yaxis = getOrCreateAxis(yaxes, axisNumber(s, "y"));
	            }
	        }
	
	        function processData() {
	            var topSentry = Number.POSITIVE_INFINITY,
	                bottomSentry = Number.NEGATIVE_INFINITY,
	                fakeInfinity = Number.MAX_VALUE,
	                i, j, k, m, s, points, ps, val, f, p, data, format;
	
	            function updateAxis(axis, min, max) {
	                if (min < axis.datamin && min !== -fakeInfinity) {
	                    axis.datamin = min;
	                }
	                if (max > axis.datamax && max !== fakeInfinity) {
	                    axis.datamax = max;
	                }
	            }
	
	            $.each(allAxes(), function(_, axis) {
	
	                // init axis
	                axis.datamin = topSentry;
	                axis.datamax = bottomSentry;
	                axis.used = false;
	            });
	
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	                s.datapoints = { points: [] };
	                executeHooks(hooks.processRawData, [s, s.data, s.datapoints]);
	            }
	
	            // first pass: clean and copy data
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	
	                data = s.data;
	                format = s.datapoints.format;
	
	                if (!format) {
	                    format = [];
	
	                    // find out how to copy
	                    format.push({ x: true, number: true, required: true });
	                    format.push({ y: true, number: true, required: true });
	
	                    if (s.bars.show || (s.lines.show && s.lines.fill)) {
	                        var autoscale = !!((s.bars.show && s.bars.zero) || (s.lines.show && s.lines.zero));
	                        format.push({ y: true, number: true, required: false, defaultValue: 0, autoscale: autoscale });
	                        if (s.bars.horizontal) {
	                            delete format[format.length - 1].y;
	                            format[format.length - 1].x = true;
	                        }
	                    }
	
	                    s.datapoints.format = format;
	                }
	
	                if (s.datapoints.pointsize != null) {
	
	                    // already filled in
	                    continue;
	                }
	
	                s.datapoints.pointsize = format.length;
	
	                ps = s.datapoints.pointsize;
	                points = s.datapoints.points;
	
	                s.xaxis.used = s.yaxis.used = true;
	
	                for (j = k = 0; j < data.length; ++j, k += ps) {
	                    p = data[j];
	
	                    var nullify = p == null;
	                    if (!nullify) {
	                        for (m = 0; m < ps; ++m) {
	                            val = p[m];
	                            f = format[m];
	
	                            if (f) {
	                                if (f.number && val != null) {
	
	                                    // convert to number
	                                    val = +val;
	                                    if (isNaN(val)) {
	                                        val = null;
	                                    } else if (val === Infinity) {
	                                        val = fakeInfinity;
	                                    } else if (val === -Infinity) {
	                                        val = -fakeInfinity;
	                                    }
	                                }
	
	                                if (val == null) {
	                                    if (f.required) {
	                                        nullify = true;
	                                    }
	
	                                    if (f.defaultValue != null) {
	                                        val = f.defaultValue;
	                                    }
	                                }
	                            }
	
	                            points[k + m] = val;
	                        }
	                    }
	
	                    if (nullify) {
	                        for (m = 0; m < ps; ++m) {
	                            val = points[k + m];
	                            if (val != null) {
	                                f = format[m];
	
	                                // extract min/max info
	                                if (f.autoscale !== false) {
	                                    if (f.x) {
	                                        updateAxis(s.xaxis, val, val);
	                                    }
	                                    if (f.y) {
	                                        updateAxis(s.yaxis, val, val);
	                                    }
	                                }
	                            }
	                            points[k + m] = null;
	                        }
	                    }
	                }
	            }
	
	            // give the hooks a chance to run
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	
	                executeHooks(hooks.processDatapoints, [s, s.datapoints]);
	            }
	
	            // second pass: find datamax/datamin for auto-scaling
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	                points = s.datapoints.points;
	                ps = s.datapoints.pointsize;
	                format = s.datapoints.format;
	
	                var xmin = topSentry, ymin = topSentry,
	                    xmax = bottomSentry, ymax = bottomSentry;
	
	                for (j = 0; j < points.length; j += ps) {
	                    if (points[j] == null) {
	                        continue;
	                    }
	
	                    for (m = 0; m < ps; ++m) {
	                        val = points[j + m];
	                        f = format[m];
	                        if (!f || f.autoscale === false || val === fakeInfinity || val === -fakeInfinity) {
	                            continue;
	                        }
	
	                        if (f.x) {
	                            if (val < xmin) {
	                                xmin = val;
	                            }
	                            if (val > xmax) {
	                                xmax = val;
	                            }
	                        }
	                        if (f.y) {
	                            if (val < ymin) {
	                                ymin = val;
	                            }
	                            if (val > ymax) {
	                                ymax = val;
	                            }
	                        }
	                    }
	                }
	
	                if (s.bars.show) {
	
	                    // make sure we got room for the bar on the dancing floor
	                    var delta;
	
	                    switch (s.bars.align) {
	                    case "left":
	                        delta = 0;
	                        break;
	                    case "right":
	                        delta = -s.bars.barWidth;
	                        break;
	                    default:
	                        delta = -s.bars.barWidth / 2;
	                    }
	
	                    if (s.bars.horizontal) {
	                        ymin += delta;
	                        ymax += delta + s.bars.barWidth;
	                    } else {
	                        xmin += delta;
	                        xmax += delta + s.bars.barWidth;
	                    }
	                }
	
	                updateAxis(s.xaxis, xmin, xmax);
	                updateAxis(s.yaxis, ymin, ymax);
	            }
	
	            $.each(allAxes(), function(_, axis) {
	                if (axis.datamin === topSentry) {
	                    axis.datamin = null;
	                }
	                if (axis.datamax === bottomSentry) {
	                    axis.datamax = null;
	                }
	            });
	        }
	
	        function setupCanvases() {
	
	            // Make sure the placeholder is clear of everything except canvases
	            // from a previous plot in this container that we'll try to re-use.
	
	            // padding messes up the positioning
	            placeholder.css("padding", 0)
	                .children().filter(function() {
	                    return !$(this).hasClass("flot-overlay") && !$(this).hasClass("flot-base");
	                }).remove();
	
	            if (placeholder.css("position") === "static") {
	
	                // for positioning labels and overlay
	                placeholder.css("position", "relative");
	            }
	
	            surface = new Canvas("flot-base", placeholder);
	
	            // overlay canvas for interactive features
	            overlay = new Canvas("flot-overlay", placeholder);
	
	            ctx = surface.context;
	            octx = overlay.context;
	
	            // define which element we're listening for events on
	            eventHolder = $(overlay.element).unbind();
	
	            // If we're re-using a plot object, shut down the old one
	            var existing = placeholder.data("plot");
	
	            if (existing) {
	                existing.shutdown();
	                overlay.clear();
	            }
	
	            // save in case we get replotted
	            placeholder.data("plot", plot);
	        }
	
	        function bindEvents() {
	
	            // bind events
	            if (options.grid.hoverable) {
	                eventHolder.mousemove(onMouseMove);
	
	                // Use bind, rather than .mouseleave, because we officially
	                // still support jQuery 1.2.6, which doesn't define a shortcut
	                // for mouseenter or mouseleave.  This was a bug/oversight that
	                // was fixed somewhere around 1.3.x.  We can return to using
	                // .mouseleave when we drop support for 1.2.6.
	                eventHolder.bind("mouseleave", onMouseLeave);
	            }
	
	            if (options.grid.clickable) {
	                eventHolder.click(onClick);
	            }
	
	            executeHooks(hooks.bindEvents, [eventHolder]);
	        }
	
	        function shutdown() {
	            if (redrawTimeout) {
	                clearTimeout(redrawTimeout);
	            }
	
	            eventHolder.unbind("mousemove", onMouseMove);
	            eventHolder.unbind("mouseleave", onMouseLeave);
	            eventHolder.unbind("click", onClick);
	
	            executeHooks(hooks.shutdown, [eventHolder]);
	        }
	
	        function setTransformationHelpers(axis) {
	
	            // set helper functions on the axis, assumes plot area
	            // has been computed already
	            function identity(x) { return x; }
	
	            var s, m, t = axis.options.transform || identity,
	                it = axis.options.inverseTransform;
	
	            // precompute how much the axis is scaling a point
	            // in canvas space
	            if (axis.direction === "x") {
	                s = axis.scale = plotWidth / Math.abs(t(axis.max) - t(axis.min));
	                m = Math.min(t(axis.max), t(axis.min));
	            } else {
	                s = axis.scale = plotHeight / Math.abs(t(axis.max) - t(axis.min));
	                s = -s;
	                m = Math.max(t(axis.max), t(axis.min));
	            }
	
	            // data point to canvas coordinate
	            if (t === identity) {
	
	                // slight optimization
	                axis.p2c = function(p) { return (p - m) * s; };
	            } else {
	                axis.p2c = function(p) { return (t(p) - m) * s; };
	            }
	
	            // canvas coordinate to data point
	            if (!it) {
	                axis.c2p = function(c) { return m + c / s; };
	            } else {
	                axis.c2p = function(c) { return it(m + c / s); };
	            }
	        }
	
	        function measureTickLabels(axis) {
	
	            var opts = axis.options,
	                ticks = axis.ticks || [],
	
	                // Label width & height are deprecated; remove in 1.0!
	                tickWidth = opts.tickWidth || opts.labelWidth || 0,
	                tickHeight = opts.tickHeight || opts.labelHeight || 0,
	                maxWidth = tickWidth || axis.direction === "x" ? Math.floor(surface.width / (ticks.length || 1)) : null,
	                legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
	                layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
	                font = opts.tickFont || "flot-tick-label tickLabel";
	
	            for (var i = 0; i < ticks.length; ++i) {
	
	                var t = ticks[i];
	
	                if (!t.label) {
	                    continue;
	                }
	
	                var info = surface.getTextInfo(layer, t.label, font, null, maxWidth);
	
	                tickWidth = Math.max(tickWidth, info.width);
	                tickHeight = Math.max(tickHeight, info.height);
	            }
	
	            axis.tickWidth = opts.tickWidth || opts.labelWidth || tickWidth;
	            axis.tickHeight = opts.tickHeight || opts.labelHeight || tickHeight;
	
	            // Label width/height properties are deprecated; remove in 1.0!
	            axis.labelWidth = axis.tickWidth;
	            axis.labelHeight = axis.tickHeight;
	        }
	
	        /**
	         * Compute the axis bounding box based on the dimensions of its label
	         * and tick labels, then adjust the plotOffset to make room for it.
	         *
	         * This first phase only considers one dimension per axis; the other
	         * dimension depends on the other axes, and will be calculated later.
	         */
	        function allocateAxisBoxFirstPhase(axis) {
	
	            var contentWidth = axis.tickWidth,
	                contentHeight = axis.tickHeight,
	                axisOptions = axis.options,
	                tickLength = axisOptions.tickLength,
	                axisPosition = axisOptions.position,
	                axisMargin = options.grid.axisMargin,
	                padding = options.grid.labelMargin,
	                isXAxis = axis.direction === "x",
	                innermost = true,
	                outermost = true,
	                first = true,
	                found = false;
	
	            // Determine the axis's position in its direction and on its side
	            $.each(isXAxis ? xaxes : yaxes, function(i, a) {
	                if (a && (a.show || a.reserveSpace)) {
	                    if (a === axis) {
	                        found = true;
	                    } else if (a.options.position === axisPosition) {
	                        if (found) {
	                            outermost = false;
	                        } else {
	                            innermost = false;
	                        }
	                    }
	                    if (!found) {
	                        first = false;
	                    }
	                }
	            });
	
	            // The outermost axis on each side has no margin
	            if (outermost) {
	                axisMargin = 0;
	            }
	
	            // The ticks for the first axis in each direction stretch across
	            if (tickLength == null) {
	                tickLength = first ? "full" : 5;
	            }
	
	            if (!isNaN(+tickLength)) {
	                padding += +tickLength;
	            }
	
	            // Measure the dimensions of the axis label, if it has one
	            if (axisOptions.label) {
	                var legacyStyles = "Axis " + axis.direction + axis.n + "Axis",
	                    layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + axis.direction + legacyStyles,
	                    font = axisOptions.labelFont || "flot-axis-label axisLabels " + axis.direction + axis.n + "axisLabel",
	                    angle = isXAxis ? 0 : axisOptions.position === "right" ? 90 : -90,
	                    labelInfo = surface.getTextInfo(layer, axisOptions.label, font, angle);
	                contentWidth += labelInfo.width + axisOptions.labelPadding;
	                contentHeight += labelInfo.height + axisOptions.labelPadding;
	            }
	
	            // Compute the axis bounding box and update the plot bounds
	            if (isXAxis) {
	                contentHeight += padding;
	                if (axisPosition === "top") {
	                    axis.box = { top: plotOffset.top + axisMargin, height: contentHeight };
	                    plotOffset.top += contentHeight + axisMargin;
	                } else {
	                    plotOffset.bottom += contentHeight + axisMargin;
	                    axis.box = { top: surface.height - plotOffset.bottom, height: contentHeight };
	                }
	            } else {
	                contentWidth += padding;
	                if (axisPosition === "right") {
	                    plotOffset.right += contentWidth + axisMargin;
	                    axis.box = { left: surface.width - plotOffset.right, width: contentWidth };
	                } else {
	                    axis.box = { left: plotOffset.left + axisMargin, width: contentWidth };
	                    plotOffset.left += contentWidth + axisMargin;
	                }
	            }
	
	            axis.position = axisPosition;
	            axis.tickLength = tickLength;
	            axis.box.padding = padding;
	            axis.innermost = innermost;
	        }
	
	        function allocateAxisBoxSecondPhase(axis) {
	
	            // now that all axis boxes have been placed in one
	            // dimension, we can set the remaining dimension coordinates
	            if (axis.direction === "x") {
	                axis.box.left = plotOffset.left - axis.tickWidth / 2;
	                axis.box.width = surface.width - plotOffset.left - plotOffset.right + axis.tickWidth;
	            } else {
	                axis.box.top = plotOffset.top - axis.tickHeight / 2;
	                axis.box.height = surface.height - plotOffset.bottom - plotOffset.top + axis.tickHeight;
	            }
	        }
	
	        function adjustLayoutForThingsStickingOut() {
	
	            // possibly adjust plot offset to ensure everything stays
	            // inside the canvas and isn't clipped off
	            var minMargin = options.grid.minBorderMargin;
	
	            // check stuff from the plot (FIXME: this should just read
	            // a value from the series, otherwise it's impossible to
	            // customize)
	            if (minMargin == null) {
	                minMargin = 0;
	                for (var i = 0; i < series.length; ++i) {
	                    minMargin = Math.max(minMargin, 2 * (series[i].points.radius + series[i].points.lineWidth / 2));
	                }
	            }
	
	            var margins = {
	                left: minMargin,
	                right: minMargin,
	                top: minMargin,
	                bottom: minMargin
	            };
	
	            // check axis labels, note we don't check the actual
	            // labels but instead use the overall width/height to not
	            // jump as much around with replots
	            $.each(allAxes(), function(_, axis) {
	                if (axis.reserveSpace && axis.ticks && axis.ticks.length) {
	                    if (axis.direction === "x") {
	                        margins.left = Math.max(margins.left, axis.tickWidth / 2);
	                        margins.right = Math.max(margins.right, axis.tickWidth / 2);
	                    } else {
	                        margins.bottom = Math.max(margins.bottom, axis.tickHeight / 2);
	                        margins.top = Math.max(margins.top, axis.tickHeight / 2);
	                    }
	                }
	            });
	
	            plotOffset.left = Math.ceil(Math.max(margins.left, plotOffset.left));
	            plotOffset.right = Math.ceil(Math.max(margins.right, plotOffset.right));
	            plotOffset.top = Math.ceil(Math.max(margins.top, plotOffset.top));
	            plotOffset.bottom = Math.ceil(Math.max(margins.bottom, plotOffset.bottom));
	        }
	
	        function setupGrid() {
	            var axes = allAxes(),
	                showGrid = options.grid.show,
	                margin = options.grid.margin || 0,
	                i, a;
	
	            // Initialize the plot's offset from the edge of the canvas
	            for (a in plotOffset) {
	                if (Object.prototype.hasOwnProperty.call(plotOffset, a)) {
	                    plotOffset[a] = isNumeric(margin) ? margin : margin[a] || 0;
	                }
	            }
	
	            executeHooks(hooks.processOffset, [plotOffset]);
	
	            // If the grid is visible, add its border width to the offset
	            for (a in plotOffset) {
	                if (typeof(options.grid.borderWidth) === "object") {
	                    plotOffset[a] += showGrid ? options.grid.borderWidth[a] : 0;
	                } else {
	                    plotOffset[a] += showGrid ? options.grid.borderWidth : 0;
	                }
	            }
	
	            $.each(axes, function(_, axis) {
	                var axisOpts = axis.options;
	                axis.show = axisOpts.show == null ? axis.used : axisOpts.show;
	                axis.reserveSpace = axisOpts.reserveSpace == null ? axis.show : axisOpts.reserveSpace;
	                setRange(axis);
	            });
	
	            if (showGrid) {
	
	                var allocatedAxes = $.grep(axes, function(axis) {
	                    return axis.show || axis.reserveSpace;
	                });
	
	                $.each(allocatedAxes, function(_, axis) {
	                    // make the ticks
	                    setupTickGeneration(axis);
	                    setTicks(axis);
	                    snapRangeToTicks(axis, axis.ticks);
	                    measureTickLabels(axis);
	                });
	
	                // with all dimensions calculated, we can compute the
	                // axis bounding boxes, start from the outside
	                // (reverse order)
	                for (i = allocatedAxes.length - 1; i >= 0; --i) {
	                    allocateAxisBoxFirstPhase(allocatedAxes[i]);
	                }
	
	                // make sure we've got enough space for things that
	                // might stick out
	                adjustLayoutForThingsStickingOut();
	
	                $.each(allocatedAxes, function(_, axis) {
	                    allocateAxisBoxSecondPhase(axis);
	                });
	            }
	
	            plotWidth = surface.width - plotOffset.left - plotOffset.right;
	            plotHeight = surface.height - plotOffset.bottom - plotOffset.top;
	
	            // now we got the proper plot dimensions, we can compute the scaling
	            $.each(axes, function(_, axis) {
	                setTransformationHelpers(axis);
	            });
	
	            if (showGrid) {
	                drawAxisLabels();
	            }
	
	            insertLegend();
	        }
	
	        function setRange(axis) {
	            var opts = axis.options,
	                min = +(opts.min != null ? opts.min : axis.datamin),
	                max = +(opts.max != null ? opts.max : axis.datamax),
	                delta = max - min;
	
	            if (delta === 0.0) {
	
	                // degenerate case
	                var widen = max === 0 ? 1 : 0.01;
	
	                if (opts.min == null) {
	                    min -= widen;
	                }
	
	                // always widen max if we couldn't widen min to ensure we
	                // don't fall into min == max which doesn't work
	
	                if (opts.max == null || opts.min != null) {
	                    max += widen;
	                }
	            } else {
	
	                // consider autoscaling
	                var margin = opts.autoscaleMargin;
	                if (margin != null) {
	                    if (opts.min == null) {
	                        min -= delta * margin;
	
	                        // make sure we don't go below zero if all values
	                        // are positive
	                        if (min < 0 && axis.datamin != null && axis.datamin >= 0) {
	                            min = 0;
	                        }
	                    }
	                    if (opts.max == null) {
	                        max += delta * margin;
	                        if (max > 0 && axis.datamax != null && axis.datamax <= 0) {
	                            max = 0;
	                        }
	                    }
	                }
	            }
	            axis.min = min;
	            axis.max = max;
	        }
	
	        function setupTickGeneration(axis) {
	            var opts = axis.options,
	
	                // estimate number of ticks
	                noTicks;
	
	            if (isNumeric(opts.ticks) && opts.ticks > 0) {
	                noTicks = opts.ticks;
	            } else {
	
	                // heuristic based on the model a*sqrt(x) fitted to
	                // some data points that seemed reasonable
	                noTicks = 0.3 * Math.sqrt(axis.direction === "x" ? surface.width : surface.height);
	            }
	
	            var delta = (axis.max - axis.min) / noTicks,
	                dec = -Math.floor(Math.log(delta) / Math.LN10),
	                maxDec = opts.tickDecimals;
	
	            if (maxDec != null && dec > maxDec) {
	                dec = maxDec;
	            }
	
	            var magn = Math.pow(10, -dec),
	
	                // norm is between 1.0 and 10.0
	                norm = delta / magn,
	                size;
	
	            if (norm < 1.5) {
	                size = 1;
	            } else if (norm < 3) {
	                size = 2;
	
	                // special case for 2.5, requires an extra decimal
	                if (norm > 2.25 && (maxDec == null || dec + 1 <= maxDec)) {
	                    size = 2.5;
	                    ++dec;
	                }
	            } else if (norm < 7.5) {
	                size = 5;
	            } else {
	                size = 10;
	            }
	
	            size *= magn;
	
	            if (opts.minTickSize != null && size < opts.minTickSize) {
	                size = opts.minTickSize;
	            }
	
	            axis.delta = delta;
	            axis.tickDecimals = Math.max(0, maxDec != null ? maxDec : dec);
	            axis.tickSize = opts.tickSize || size;
	
	            // Time mode was moved to a plug-in in 0.8, but since so many people use this
	            // we'll add an especially friendly make sure they remembered to include it.
	            if (opts.mode === "time" && !axis.tickGenerator) {
	                throw new Error("Time mode requires the flot.time plugin.");
	            }
	
	            // Flot supports base-10 axes; any other mode else is handled by a plug-in,
	            // like flot.time.js.
	            if (!axis.tickGenerator) {
	
	                axis.tickGenerator = function(axis) {
	
	                    var ticks = [],
	                        start = floorInBase(axis.min, axis.tickSize),
	                        i = 0,
	                        v = Number.NaN,
	                        prev;
	
	                    do {
	                        prev = v;
	                        v = start + i * axis.tickSize;
	                        ticks.push(v);
	                        ++i;
	                    } while (v < axis.max && v !== prev);
	                    return ticks;
	                };
	
	                axis.tickFormatter = function(value, axis) {
	
	                    var factor = axis.tickDecimals ? Math.pow(10, axis.tickDecimals) : 1,
	                        formatted = "" + Math.round(value * factor) / factor;
	
	                    // If tickDecimals was specified, ensure that we have exactly that
	                    // much precision; otherwise default to the value's own precision.
	                    if (axis.tickDecimals != null) {
	                        var decimal = formatted.indexOf("."),
	                            precision = decimal === -1 ? 0 : formatted.length - decimal - 1;
	
	                        if (precision < axis.tickDecimals) {
	                            return (precision ? formatted : formatted + ".") + ("" + factor).substr(1, axis.tickDecimals - precision);
	                        }
	                    }
	
	                    return formatted;
	                };
	            }
	
	            if ($.isFunction(opts.tickFormatter)) {
	                axis.tickFormatter = function(v, axis) { return "" + opts.tickFormatter(v, axis); };
	            }
	
	            if (opts.alignTicksWithAxis != null) {
	                var otherAxis = (axis.direction === "x" ? xaxes : yaxes)[opts.alignTicksWithAxis - 1];
	                if (otherAxis && otherAxis.used && otherAxis !== axis) {
	
	                    // consider snapping min/max to outermost nice ticks
	                    var niceTicks = axis.tickGenerator(axis);
	                    if (niceTicks.length > 0) {
	                        if (opts.min == null) {
	                            axis.min = Math.min(axis.min, niceTicks[0]);
	                        }
	                        if (opts.max == null && niceTicks.length > 1) {
	                            axis.max = Math.max(axis.max, niceTicks[niceTicks.length - 1]);
	                        }
	                    }
	
	                    axis.tickGenerator = function(axis) {
	
	                        // copy ticks, scaled to this axis
	                        var ticks = [], v, i;
	                        for (i = 0; i < otherAxis.ticks.length; ++i) {
	                            v = (otherAxis.ticks[i].v - otherAxis.min) / (otherAxis.max - otherAxis.min);
	                            v = axis.min + v * (axis.max - axis.min);
	                            ticks.push(v);
	                        }
	                        return ticks;
	                    };
	
	                    // we might need an extra decimal since forced
	                    // ticks don't necessarily fit naturally
	                    if (!axis.mode && opts.tickDecimals == null) {
	                        var extraDec = Math.max(0, -Math.floor(Math.log(axis.delta) / Math.LN10) + 1),
	                            ts = axis.tickGenerator(axis);
	
	                        // only proceed if the tick interval rounded
	                        // with an extra decimal doesn't give us a
	                        // zero at end
	                        if (!(ts.length > 1 && /\..*0$/.test((ts[1] - ts[0]).toFixed(extraDec)))) {
	                            axis.tickDecimals = extraDec;
	                        }
	                    }
	                }
	            }
	        }
	
	        function setTicks(axis) {
	            var oticks = axis.options.ticks, ticks = [];
	            if (oticks == null || (isNumeric(oticks) && oticks > 0)) {
	                ticks = axis.tickGenerator(axis);
	            } else if (oticks) {
	                if ($.isFunction(oticks)) {
	
	                    // generate the ticks
	                    ticks = oticks(axis);
	                } else {
	                    ticks = oticks;
	                }
	            }
	
	            // clean up/labelify the supplied ticks, copy them over
	            var i, v;
	            axis.ticks = [];
	            for (i = 0; i < ticks.length; ++i) {
	                var label = null,
	                    t = ticks[i];
	
	                if (typeof t === "object") {
	                    v = +t[0];
	                    if (t.length > 1) {
	                        label = t[1];
	                    }
	                } else {
	                    v = +t;
	                }
	                if (label == null) {
	                    label = axis.tickFormatter(v, axis);
	                }
	                if (!isNaN(v)) {
	                    axis.ticks.push({ v: v, label: label });
	                }
	            }
	        }
	
	        function snapRangeToTicks(axis, ticks) {
	            if (axis.options.autoscaleMargin && ticks.length > 0) {
	
	                // snap to ticks
	                if (axis.options.min == null) {
	                    axis.min = Math.min(axis.min, ticks[0].v);
	                }
	                if (axis.options.max == null && ticks.length > 1) {
	                    axis.max = Math.max(axis.max, ticks[ticks.length - 1].v);
	                }
	            }
	        }
	
	        function draw() {
	
	            surface.clear();
	
	            executeHooks(hooks.drawBackground, [ctx]);
	
	            var grid = options.grid;
	
	            // draw background, if any
	            if (grid.show && grid.backgroundColor) {
	                drawBackground();
	            }
	
	            if (grid.show && !grid.aboveData) {
	                drawGrid();
	            }
	
	            for (var i = 0; i < series.length; ++i) {
	                executeHooks(hooks.drawSeries, [ctx, series[i]]);
	                drawSeries(series[i]);
	            }
	
	            executeHooks(hooks.draw, [ctx]);
	
	            if (grid.show && grid.aboveData) {
	                drawGrid();
	            }
	
	            surface.render();
	
	            // A draw implies that either the axes or data have changed, so we
	            // should probably update the overlay highlights as well.
	
	            triggerRedrawOverlay();
	        }
	
	        function extractRange(ranges, coord) {
	            var axis, from, to, key, axes = allAxes();
	
	            for (var i = 0; i < axes.length; ++i) {
	                axis = axes[i];
	                if (axis.direction === coord) {
	                    key = coord + axis.n + "axis";
	                    if (!ranges[key] && axis.n === 1) {
	
	                        // support x1axis as xaxis
	                        key = coord + "axis";
	                    }
	                    if (ranges[key]) {
	                        from = ranges[key].from;
	                        to = ranges[key].to;
	                        break;
	                    }
	                }
	            }
	
	            // backwards-compat stuff - to be removed in future
	            if (!ranges[key]) {
	                axis = coord === "x" ? xaxes[0] : yaxes[0];
	                from = ranges[coord + "1"];
	                to = ranges[coord + "2"];
	            }
	
	            // auto-reverse as an added bonus
	            if (from != null && to != null && from > to) {
	                var tmp = from;
	                from = to;
	                to = tmp;
	            }
	
	            return { from: from, to: to, axis: axis };
	        }
	
	        function drawBackground() {
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            ctx.fillStyle = getColorOrGradient(options.grid.backgroundColor, plotHeight, 0, "rgba(255, 255, 255, 0)");
	            ctx.fillRect(0, 0, plotWidth, plotHeight);
	            ctx.restore();
	        }
	
	        function drawGrid() {
	            var i, axes, bw, bc;
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            var markingLayer = "flot-markings";
	            surface.removeText(markingLayer);
	
	            // process markings
	            var markingsUnderGrid = [],
	                markingsAboveGrid = [],
	                markings = options.grid.markings;
	
	            if (markings) {
	                if ($.isFunction(markings)) {
	                    axes = plot.getAxes();
	
	                    // xmin etc. is backwards compatibility, to be
	                    // removed in the future
	                    axes.xmin = axes.xaxis.min;
	                    axes.xmax = axes.xaxis.max;
	                    axes.ymin = axes.yaxis.min;
	                    axes.ymax = axes.yaxis.max;
	
	                    markings = markings(axes);
	                }
	
	                for (i = 0; i < markings.length; ++i) {
	                    var m = markings[i];
	
	                    if (m.aboveGrid) {
	                        markingsAboveGrid.push(m);
	                    } else {
	                        markingsUnderGrid.push(m);
	                    }
	                }
	            }
	
	            drawMarkings(markingsUnderGrid, markingLayer);
	
	            // draw the ticks
	            axes = allAxes();
	            bw = options.grid.borderWidth;
	
	            for (var j = 0; j < axes.length; ++j) {
	                var axis = axes[j], box = axis.box,
	                    t = axis.tickLength, x, y, xoff, yoff;
	                if (!axis.show || axis.ticks.length === 0) {
	                    continue;
	                }
	
	                ctx.lineWidth = 1;
	
	                // find the edges
	                if (axis.direction === "x") {
	                    x = 0;
	                    if (t === "full") {
	                        y = (axis.position === "top" ? 0 : plotHeight);
	                    } else {
	                        y = box.top - plotOffset.top + (axis.position === "top" ? box.height : 0);
	                    }
	                } else {
	                    y = 0;
	                    if (t === "full") {
	                        x = (axis.position === "left" ? 0 : plotWidth);
	                    } else {
	                        x = box.left - plotOffset.left + (axis.position === "left" ? box.width : 0);
	                    }
	                }
	
	                // draw tick bar
	                if (!axis.innermost) {
	                    ctx.strokeStyle = axis.options.color;
	                    ctx.beginPath();
	                    xoff = yoff = 0;
	                    if (axis.direction === "x") {
	                        xoff = plotWidth + 1;
	                    } else {
	                        yoff = plotHeight + 1;
	                    }
	
	                    if (ctx.lineWidth === 1) {
	                        if (axis.direction === "x") {
	                            y = Math.floor(y) + 0.5;
	                        } else {
	                            x = Math.floor(x) + 0.5;
	                        }
	                    }
	
	                    ctx.moveTo(x, y);
	                    ctx.lineTo(x + xoff, y + yoff);
	                    ctx.stroke();
	                }
	
	                // draw ticks
	                ctx.strokeStyle = axis.options.tickColor;
	
	                ctx.beginPath();
	                for (i = 0; i < axis.ticks.length; ++i) {
	                    var v = axis.ticks[i].v;
	
	                    xoff = yoff = 0;
	
	                    if (isNaN(v) || v < axis.min || v > axis.max || (
	
	                        // skip those lying on the axes if we got a border
	                        t === "full" && ((typeof bw === "object" && bw[axis.position] > 0) || bw > 0) &&
	                        (v === axis.min || v === axis.max)
	                    )) {
	                        continue;
	                    }
	
	                    if (axis.direction === "x") {
	                        x = axis.p2c(v);
	                        yoff = t === "full" ? -plotHeight : t;
	
	                        if (axis.position === "top") {
	                            yoff = -yoff;
	                        }
	                    } else {
	                        y = axis.p2c(v);
	                        xoff = t === "full" ? -plotWidth : t;
	
	                        if (axis.position === "left") {
	                            xoff = -xoff;
	                        }
	                    }
	
	                    if (ctx.lineWidth === 1) {
	                        if (axis.direction === "x") {
	                            x = Math.floor(x) + 0.5;
	                        } else {
	                            y = Math.floor(y) + 0.5;
	                        }
	                    }
	
	                    ctx.moveTo(x, y);
	                    ctx.lineTo(x + xoff, y + yoff);
	                }
	
	                ctx.stroke();
	            }
	
	            drawMarkings(markingsAboveGrid, markingLayer);
	
	            // draw border
	            if (bw) {
	
	                // If either borderWidth or borderColor is an object, then draw the border
	                // line by line instead of as one rectangle
	                bc = options.grid.borderColor;
	                if (typeof bw === "object" || typeof bc === "object") {
	                    if (typeof bw !== "object") {
	                        bw = { top: bw, right: bw, bottom: bw, left: bw };
	                    }
	                    if (typeof bc !== "object") {
	                        bc = { top: bc, right: bc, bottom: bc, left: bc };
	                    }
	
	                    if (bw.top > 0) {
	                        ctx.strokeStyle = bc.top;
	                        ctx.lineWidth = bw.top;
	                        ctx.beginPath();
	                        ctx.moveTo(0 - bw.left, 0 - bw.top / 2);
	                        ctx.lineTo(plotWidth, 0 - bw.top / 2);
	                        ctx.stroke();
	                    }
	
	                    if (bw.right > 0) {
	                        ctx.strokeStyle = bc.right;
	                        ctx.lineWidth = bw.right;
	                        ctx.beginPath();
	                        ctx.moveTo(plotWidth + bw.right / 2, 0 - bw.top);
	                        ctx.lineTo(plotWidth + bw.right / 2, plotHeight);
	                        ctx.stroke();
	                    }
	
	                    if (bw.bottom > 0) {
	                        ctx.strokeStyle = bc.bottom;
	                        ctx.lineWidth = bw.bottom;
	                        ctx.beginPath();
	                        ctx.moveTo(plotWidth + bw.right, plotHeight + bw.bottom / 2);
	                        ctx.lineTo(0, plotHeight + bw.bottom / 2);
	                        ctx.stroke();
	                    }
	
	                    if (bw.left > 0) {
	                        ctx.strokeStyle = bc.left;
	                        ctx.lineWidth = bw.left;
	                        ctx.beginPath();
	                        ctx.moveTo(0 - bw.left / 2, plotHeight + bw.bottom);
	                        ctx.lineTo(0 - bw.left / 2, 0);
	                        ctx.stroke();
	                    }
	                } else {
	                    ctx.lineWidth = bw;
	                    ctx.strokeStyle = options.grid.borderColor;
	                    ctx.strokeRect(-bw / 2, -bw / 2, plotWidth + bw, plotHeight + bw);
	                }
	            }
	
	            ctx.restore();
	        }
	
	        function drawMarkings(markings, markingLayer) {
	            if (!markings) {
	                return;
	            }
	
	            for (var i = 0; i < markings.length; i++) {
	                drawMarking(markings[i], markingLayer);
	            }
	        }
	
	        function drawMarking(m, markingLayer) {
	            var xrange = extractRange(m, "x"),
	                yrange = extractRange(m, "y");
	
	            // fill in missing
	            if (xrange.from == null) {
	                xrange.from = xrange.axis.min;
	            }
	            if (xrange.to == null) {
	                xrange.to = xrange.axis.max;
	            }
	            if (yrange.from == null) {
	                yrange.from = yrange.axis.min;
	            }
	            if (yrange.to == null) {
	                yrange.to = yrange.axis.max;
	            }
	
	            // clip
	            if (xrange.to < xrange.axis.min || xrange.from > xrange.axis.max ||
	                yrange.to < yrange.axis.min || yrange.from > yrange.axis.max) {
	                return;
	            }
	
	            xrange.from = Math.max(xrange.from, xrange.axis.min);
	            xrange.to = Math.min(xrange.to, xrange.axis.max);
	            yrange.from = Math.max(yrange.from, yrange.axis.min);
	            yrange.to = Math.min(yrange.to, yrange.axis.max);
	
	            var xequal = xrange.from === xrange.to,
	                yequal = yrange.from === yrange.to;
	
	            if (xequal && yequal) {
	                return;
	            }
	
	            // then draw
	            xrange.from = Math.floor(xrange.axis.p2c(xrange.from));
	            xrange.to = Math.floor(xrange.axis.p2c(xrange.to));
	            yrange.from = Math.floor(yrange.axis.p2c(yrange.from));
	            yrange.to = Math.floor(yrange.axis.p2c(yrange.to));
	
	            if (xequal || yequal) {
	                var lineWidth = m.lineWidth || options.grid.markingsLineWidth,
	                    subPixel = lineWidth % 2 ? 0.5 : 0;
	                ctx.beginPath();
	                ctx.strokeStyle = m.color || options.grid.markingsColor;
	                ctx.lineWidth = lineWidth;
	                if (xequal) {
	                    ctx.moveTo(xrange.to + subPixel, yrange.from);
	                    ctx.lineTo(xrange.to + subPixel, yrange.to);
	                } else {
	                    ctx.moveTo(xrange.from, yrange.to + subPixel);
	                    ctx.lineTo(xrange.to, yrange.to + subPixel);
	                }
	                ctx.stroke();
	            } else {
	                ctx.fillStyle = m.color || options.grid.markingsColor;
	                if (m.rounded) {
	                    roundRect(
	                        ctx, xrange.from, yrange.to, xrange.to - xrange.from,
	                        yrange.from - yrange.to, m.rounded);
	                    ctx.fill();
	                } else {
	                    ctx.fillRect(
	                        xrange.from, yrange.to, xrange.to - xrange.from,
	                        yrange.from - yrange.to);
	                }
	            }
	
	            if (m.text) {
	
	                // left aligned horizontal position:
	                var xPos = xrange.from + plotOffset.left,
	
	                    // top baselined vertical position:
	                    yPos = (yrange.to + plotOffset.top);
	
	                if (!!m.textAlign) {
	                    switch (m.textAlign.toLowerCase()) {
	                    case "right":
	                        xPos = xrange.to + plotOffset.left;
	                        break;
	                    case "center":
	                        xPos = (xrange.from + plotOffset.left + xrange.to + plotOffset.left) / 2;
	                        break;
	                    }
	                }
	
	                if (!!m.textBaseline) {
	                    switch (m.textBaseline.toLowerCase()) {
	                    case "bottom":
	                        yPos = (yrange.from + plotOffset.top);
	                        break;
	                    case "middle":
	                        yPos = (yrange.from + plotOffset.top + yrange.to + plotOffset.top) / 2;
	                        break;
	                    }
	                }
	
	                surface.addText(markingLayer, xPos, yPos, m.text, m.font || "flot-marking", 0, null, m.textAlign, m.textBaseline);
	            }
	        }
	
	        function drawAxisLabels() {
	
	            $.each(allAxes(), function(_, axis) {
	
	                var box = axis.box,
	                    axisOptions = axis.options,
	                    legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
	                    layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
	                    labelFont = axisOptions.labelFont || "flot-axis-label axisLabels " + axis.direction + axis.n + "axisLabel",
	                    tickFont = axisOptions.tickFont || "flot-tick-label tickLabel",
	                    tick, x, y, halign, valign;
	
	                // Remove text before checking for axis.show and ticks.length;
	                // otherwise plugins, like flot-tickrotor, that draw their own
	                // tick labels will end up with both theirs and the defaults.
	                surface.removeText(layer);
	
	                if (!axis.show || axis.ticks.length === 0) {
	                    return;
	                }
	
	                if (axisOptions.label) {
	                    if (axis.direction === "x") {
	                        if (axisOptions.position === "top") {
	                            surface.addText(layer, box.left + box.width / 2, box.top, axisOptions.label, labelFont, 0, null, "center", "top");
	                        } else {
	                            surface.addText(layer, box.left + box.width / 2, box.top + box.height, axisOptions.label, labelFont, 0, null, "center", "bottom");
	                        }
	                    } else {
	                        if (axisOptions.position === "right") {
	                            surface.addText(layer, box.left + box.width, box.top + box.height / 2, axisOptions.label, labelFont, 90, null, "right", "middle");
	                        } else {
	                            surface.addText(layer, box.left, box.top + box.height / 2, axisOptions.label, labelFont, -90, null, "left", "middle");
	                        }
	                    }
	                }
	
	                // Add labels for the ticks on this axis
	                for (var i = 0; i < axis.ticks.length; ++i) {
	
	                    tick = axis.ticks[i];
	                    if (!tick.label || tick.v < axis.min || tick.v > axis.max) {
	                        continue;
	                    }
	
	                    if (axis.direction === "x") {
	                        halign = "center";
	                        x = plotOffset.left + axis.p2c(tick.v);
	                        if (axis.position === "bottom") {
	                            y = box.top + box.padding;
	                        } else {
	                            y = box.top + box.height - box.padding;
	                            valign = "bottom";
	                        }
	                    } else {
	                        valign = "middle";
	                        y = plotOffset.top + axis.p2c(tick.v);
	                        if (axis.position === "left") {
	                            x = box.left + box.width - box.padding;
	                            halign = "right";
	                        } else {
	                            x = box.left + box.padding;
	                        }
	                    }
	
	                    surface.addText(layer, x, y, tick.label, tickFont, null, null, halign, valign);
	                }
	            });
	        }
	
	        function drawSeries(series) {
	            if (series.lines.show) {
	                drawSeriesLines(series);
	            }
	            if (series.bars.show) {
	                drawSeriesBars(series);
	            }
	            if (series.points.show) {
	                drawSeriesPoints(series);
	            }
	        }
	
	        function drawSeriesLines(series) {
	            function plotLine(datapoints, xoffset, yoffset, axisx, axisy) {
	                var points = datapoints.points,
	                    ps = datapoints.pointsize,
	                    showSteps = series.lines.steps,
	                    prevx = null, prevy = null;
	
	                ctx.beginPath();
	                for (var i = ps; i < points.length; i += ps) {
	                    var x1 = points[i - ps], y1 = points[i - ps + 1],
	                        x2 = points[i], y2 = points[i + 1];
	
	                    if (x1 == null || x2 == null) {
	                        continue;
	                    }
	
	                    // clip with ymin
	                    if (y1 <= y2 && y1 < axisy.min) {
	                        if (y2 < axisy.min) {
	
	                            // line segment is outside
	                            continue;
	                        }
	
	                        // compute new intersection point
	                        x1 = showSteps ? x2 : (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.min;
	                    } else if (y2 <= y1 && y2 < axisy.min) {
	                        if (y1 < axisy.min) {
	                            continue;
	                        }
	                        x2 = showSteps ? x2 : (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.min;
	                    }
	
	                    // clip with ymax
	                    if (y1 >= y2 && y1 > axisy.max) {
	                        if (y2 > axisy.max) {
	                            continue;
	                        }
	                        x1 = showSteps ? x2 : (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.max;
	                    } else if (y2 >= y1 && y2 > axisy.max) {
	                        if (y1 > axisy.max) {
	                            continue;
	                        }
	                        x2 = showSteps ? x2 : (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.max;
	                    }
	
	                    // clip with xmin
	                    if (x1 <= x2 && x1 < axisx.min) {
	                        if (x2 < axisx.min) {
	                            continue;
	                        }
	                        y1 = showSteps ? y1 : (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.min;
	                    } else if (x2 <= x1 && x2 < axisx.min) {
	                        if (x1 < axisx.min) {
	                            continue;
	                        }
	                        y2 = showSteps ? y1 : (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.min;
	                    }
	
	                    // clip with xmax
	                    if (x1 >= x2 && x1 > axisx.max) {
	                        if (x2 > axisx.max) {
	                            continue;
	                        }
	                        y1 = showSteps ? y1 : (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.max;
	                    } else if (x2 >= x1 && x2 > axisx.max) {
	                        if (x1 > axisx.max) {
	                            continue;
	                        }
	                        y2 = showSteps ? y1 : (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.max;
	                    }
	
	                    if (x1 !== prevx || y1 !== prevy) {
	                        ctx.moveTo(axisx.p2c(x1) + xoffset, axisy.p2c(y1) + yoffset);
	                    }
	
	                    prevx = x2;
	                    prevy = y2;
	
	                    // Draw a step
	                    if (showSteps) {
	                        if (x1 < x2) {
	                            ctx.lineTo(axisx.p2c(x2) + xoffset, axisy.p2c(y1) + yoffset);
	                        } else {
	                            ctx.lineTo(axisx.p2c(x1) + xoffset, axisy.p2c(y2) + yoffset);
	                        }
	                    }
	                    ctx.lineTo(axisx.p2c(x2) + xoffset, axisy.p2c(y2) + yoffset);
	                }
	                ctx.stroke();
	            }
	
	            function plotLineArea(datapoints, axisx, axisy) {
	                var points = datapoints.points,
	                    ps = datapoints.pointsize,
	                    showSteps = series.lines.steps,
	                    bottom = Math.min(Math.max(0, axisy.min), axisy.max),
	                    i = 0, areaOpen = false,
	                    ypos = 1, segmentStart = 0, segmentEnd = 0;
	
	                // we process each segment in two turns, first forward
	                // direction to sketch out top, then once we hit the
	                // end we go backwards to sketch the bottom
	                while (true) {
	                    if (ps > 0 && i > points.length + ps) {
	                        break;
	                    }
	
	                    // ps is negative if going backwards
	                    i += ps;
	
	                    var x1 = points[i - ps],
	                        y1 = points[i - ps + ypos],
	                        x2 = points[i], y2 = points[i + ypos];
	
	                    if (areaOpen) {
	                        if (ps > 0 && x1 != null && x2 == null) {
	
	                            // at turning point
	                            segmentEnd = i;
	                            ps = -ps;
	                            ypos = 2;
	                            continue;
	                        }
	
	                        if (ps < 0 && i === segmentStart + ps) {
	
	                            // done with the reverse sweep
	                            ctx.fill();
	                            areaOpen = false;
	                            ps = -ps;
	                            ypos = 1;
	                            i = segmentStart = segmentEnd + ps;
	                            continue;
	                        }
	                    }
	
	                    if (x1 == null || x2 == null) {
	                        continue;
	                    }
	
	                    // clip x values
	
	                    // clip with xmin
	                    if (x1 <= x2 && x1 < axisx.min) {
	                        if (x2 < axisx.min) {
	                            continue;
	                        }
	                        y1 = showSteps ? y1 : (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.min;
	                    } else if (x2 <= x1 && x2 < axisx.min) {
	                        if (x1 < axisx.min) {
	                            continue;
	                        }
	                        y2 = showSteps ? y1 : (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.min;
	                    }
	
	                    // clip with xmax
	                    if (x1 >= x2 && x1 > axisx.max) {
	                        if (x2 > axisx.max) {
	                            continue;
	                        }
	                        y1 = showSteps ? y1 : (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.max;
	                    } else if (x2 >= x1 && x2 > axisx.max) {
	                        if (x1 > axisx.max) {
	                            continue;
	                        }
	                        y2 = showSteps ? y1 : (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.max;
	                    }
	
	                    if (!areaOpen) {
	
	                        // open area
	                        ctx.beginPath();
	                        ctx.moveTo(axisx.p2c(x1), axisy.p2c(bottom));
	                        areaOpen = true;
	                    }
	
	                    // now first check the case where both is outside
	                    if (y1 >= axisy.max && y2 >= axisy.max) {
	                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.max));
	                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.max));
	                        continue;
	                    } else if (y1 <= axisy.min && y2 <= axisy.min) {
	                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.min));
	                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.min));
	                        continue;
	                    }
	
	                    // else it's a bit more complicated, there might
	                    // be a flat maxed out rectangle first, then a
	                    // triangular cutout or reverse; to find these
	                    // keep track of the current x values
	                    var x1old = x1, x2old = x2;
	
	                    // clip the y values, without shortcutting, we
	                    // go through all cases in turn
	
	                    // clip with ymin
	                    if (y1 <= y2 && y1 < axisy.min && y2 >= axisy.min) {
	                        x1 = showSteps ? x2 : (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.min;
	                    } else if (y2 <= y1 && y2 < axisy.min && y1 >= axisy.min) {
	                        x2 = showSteps ? x2 : (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.min;
	                    }
	
	                    // clip with ymax
	                    if (y1 >= y2 && y1 > axisy.max && y2 <= axisy.max) {
	                        x1 = showSteps ? x2 : (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.max;
	                    } else if (y2 >= y1 && y2 > axisy.max && y1 <= axisy.max) {
	                        x2 = showSteps ? x2 : (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.max;
	                    }
	
	                    // if the x value was changed we got a rectangle to fill
	                    if (x1 !== x1old) {
	
	                        // it goes to (x1, y1), but we fill that below
	                        ctx.lineTo(axisx.p2c(x1old), axisy.p2c(y1));
	                    }
	
	                    // fill triangular section, this sometimes result
	                    // in redundant points if (x1, y1) hasn't changed
	                    // from previous line to, but we just ignore that
	                    ctx.lineTo(axisx.p2c(x1), axisy.p2c(y1));
	
	                    // Draw a step
	                    if (showSteps) {
	                        if (x1 < x2) {
	                            ctx.lineTo(axisx.p2c(x2), axisy.p2c(y1));
	                        } else {
	                            ctx.lineTo(axisx.p2c(x1), axisy.p2c(y2));
	                        }
	                    }
	                    ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));
	
	                    // fill the other rectangle if it's there
	                    if (x2 !== x2old) {
	                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));
	                        ctx.lineTo(axisx.p2c(x2old), axisy.p2c(y2));
	                    }
	                }
	            }
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	            ctx.lineJoin = "round";
	
	            var lw = series.lines.lineWidth,
	                sw = series.shadowSize;
	
	            // FIXME: consider another form of shadow when filling is turned on
	            if (lw > 0 && sw > 0) {
	
	                // draw shadow as a thick and thin line with transparency
	                ctx.lineWidth = sw;
	                ctx.strokeStyle = "rgba(0,0,0,0.1)";
	
	                // position shadow at angle from the mid of line
	                var angle = Math.PI / 18;
	                plotLine(series.datapoints, Math.sin(angle) * (lw / 2 + sw / 2), Math.cos(angle) * (lw / 2 + sw / 2), series.xaxis, series.yaxis);
	                ctx.lineWidth = sw / 2;
	                plotLine(series.datapoints, Math.sin(angle) * (lw / 2 + sw / 4), Math.cos(angle) * (lw / 2 + sw / 4), series.xaxis, series.yaxis);
	            }
	
	            ctx.lineWidth = lw;
	            ctx.strokeStyle = series.color;
	            var fillStyle = getFillStyle(series.lines, series.color, 0, plotHeight);
	            if (fillStyle) {
	                ctx.fillStyle = fillStyle;
	                plotLineArea(series.datapoints, series.xaxis, series.yaxis);
	            }
	
	            if (lw > 0) {
	                plotLine(series.datapoints, 0, 0, series.xaxis, series.yaxis);
	            }
	            ctx.restore();
	        }
	
	        function drawSeriesPoints(series) {
	            function plotPoints(datapoints, radius, fillStyle, offset, shadow, axisx, axisy, symbol) {
	                var points = datapoints.points, ps = datapoints.pointsize;
	
	                for (var i = 0; i < points.length; i += ps) {
	                    var x = points[i], y = points[i + 1];
	                    if (x == null || x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max) {
	                        continue;
	                    }
	
	                    ctx.beginPath();
	                    x = axisx.p2c(x);
	                    y = axisy.p2c(y) + offset;
	                    if (symbol === "circle") {
	                        ctx.arc(x, y, radius, 0, shadow ? Math.PI : Math.PI * 2, false);
	                    } else {
	                        symbol(ctx, x, y, radius, shadow);
	                    }
	                    ctx.closePath();
	
	                    if (fillStyle) {
	                        ctx.fillStyle = fillStyle;
	                        ctx.fill();
	                    }
	                    ctx.stroke();
	                }
	            }
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            var lw = series.points.lineWidth,
	                sw = series.shadowSize,
	                radius = series.points.radius,
	                symbol = series.points.symbol;
	
	            // If the user sets the line width to 0, we change it to a very
	            // small value. A line width of 0 seems to force the default of 1.
	            // Doing the conditional here allows the shadow setting to still be
	            // optional even with a lineWidth of 0.
	            if (lw === 0) {
	                lw = 0.0001;
	            }
	
	            if (lw > 0 && sw > 0) {
	
	                // draw shadow in two steps
	                var w = sw / 2;
	                ctx.lineWidth = w;
	                ctx.strokeStyle = "rgba(0,0,0,0.1)";
	                plotPoints(series.datapoints, radius, null, w + w / 2, true,
	                           series.xaxis, series.yaxis, symbol);
	
	                ctx.strokeStyle = "rgba(0,0,0,0.2)";
	                plotPoints(series.datapoints, radius, null, w / 2, true,
	                           series.xaxis, series.yaxis, symbol);
	            }
	
	            ctx.lineWidth = lw;
	            ctx.strokeStyle = series.points.strokeColor || series.color;
	            plotPoints(series.datapoints, radius,
	                       getFillStyle(series.points, series.color), 0, false,
	                       series.xaxis, series.yaxis, symbol);
	            ctx.restore();
	        }
	
	        function drawBar(x, y, b, barLeft, barRight, fillStyleCallback, axisx, axisy, c, horizontal, lineWidth) {
	            var left, right, bottom, top,
	                drawLeft, drawRight, drawTop, drawBottom,
	                tmp;
	
	            // in horizontal mode, we start the bar from the left
	            // instead of from the bottom so it appears to be
	            // horizontal rather than vertical
	            if (horizontal) {
	                drawBottom = drawRight = drawTop = true;
	                drawLeft = false;
	                left = b;
	                right = x;
	                top = y + barLeft;
	                bottom = y + barRight;
	
	                // account for negative bars
	                if (right < left) {
	                    tmp = right;
	                    right = left;
	                    left = tmp;
	                    drawLeft = true;
	                    drawRight = false;
	                }
	            } else {
	                drawLeft = drawRight = drawTop = true;
	                drawBottom = false;
	                left = x + barLeft;
	                right = x + barRight;
	                bottom = b;
	                top = y;
	
	                // account for negative bars
	                if (top < bottom) {
	                    tmp = top;
	                    top = bottom;
	                    bottom = tmp;
	                    drawBottom = true;
	                    drawTop = false;
	                }
	            }
	
	            // clip
	            if (right < axisx.min || left > axisx.max ||
	                top < axisy.min || bottom > axisy.max) {
	                return;
	            }
	
	            if (left < axisx.min) {
	                left = axisx.min;
	                drawLeft = false;
	            }
	
	            if (right > axisx.max) {
	                right = axisx.max;
	                drawRight = false;
	            }
	
	            if (bottom < axisy.min) {
	                bottom = axisy.min;
	                drawBottom = false;
	            }
	
	            if (top > axisy.max) {
	                top = axisy.max;
	                drawTop = false;
	            }
	
	            left = axisx.p2c(left);
	            bottom = axisy.p2c(bottom);
	            right = axisx.p2c(right);
	            top = axisy.p2c(top);
	
	            // fill the bar
	            if (fillStyleCallback) {
	                c.fillStyle = fillStyleCallback(bottom, top);
	                c.fillRect(left, top, right - left, bottom - top);
	            }
	
	            // draw outline
	            if (lineWidth > 0 && (drawLeft || drawRight || drawTop || drawBottom)) {
	                c.beginPath();
	
	                // FIXME: inline moveTo is buggy with excanvas
	                c.moveTo(left, bottom);
	                if (drawLeft) {
	                    c.lineTo(left, top);
	                } else {
	                    c.moveTo(left, top);
	                }
	                if (drawTop) {
	                    c.lineTo(right, top);
	                } else {
	                    c.moveTo(right, top);
	                }
	                if (drawRight) {
	                    c.lineTo(right, bottom);
	                } else {
	                    c.moveTo(right, bottom);
	                }
	                if (drawBottom) {
	                    c.lineTo(left, bottom);
	                } else {
	                    c.moveTo(left, bottom);
	                }
	                c.stroke();
	            }
	        }
	
	        function drawSeriesBars(series) {
	            function plotBars(datapoints, barLeft, barRight, fillStyleCallback, axisx, axisy) {
	                var points = datapoints.points, ps = datapoints.pointsize;
	
	                for (var i = 0; i < points.length; i += ps) {
	                    if (points[i] == null) {
	                        continue;
	                    }
	                    drawBar(points[i], points[i + 1], points[i + 2], barLeft, barRight, fillStyleCallback, axisx, axisy, ctx, series.bars.horizontal, series.bars.lineWidth);
	                }
	            }
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            // FIXME: figure out a way to add shadows (for instance along the right edge)
	            ctx.lineWidth = series.bars.lineWidth;
	            ctx.strokeStyle = series.color;
	
	            var barLeft;
	
	            switch (series.bars.align) {
	            case "left":
	                barLeft = 0;
	                break;
	            case "right":
	                barLeft = -series.bars.barWidth;
	                break;
	            default:
	                barLeft = -series.bars.barWidth / 2;
	            }
	
	            var fillStyleCallback = series.bars.fill ? function(bottom, top) { return getFillStyle(series.bars, series.color, bottom, top); } : null;
	            plotBars(series.datapoints, barLeft, barLeft + series.bars.barWidth, fillStyleCallback, series.xaxis, series.yaxis);
	            ctx.restore();
	        }
	
	        function getFillStyle(filloptions, seriesColor, bottom, top) {
	            var fill = filloptions.fill;
	            if (!fill) {
	                return null;
	            }
	
	            if (filloptions.fillColor) {
	                return getColorOrGradient(filloptions.fillColor, bottom, top, seriesColor);
	            }
	
	            var c = $.color.parse(seriesColor);
	            c.a = isNumeric(fill) ? fill : 0.4;
	            c.normalize();
	            return c.toString();
	        }
	
	        function insertLegend() {
	
	            if (options.legend.container != null) {
	                $(options.legend.container).html("");
	            } else {
	                placeholder.find(".legend").remove();
	            }
	
	            if (!options.legend.show) {
	                return;
	            }
	
	            var entries = [], lf = options.legend.labelFormatter, s, label, i;
	
	            // Build a list of legend entries, with each having a label and a color
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	                if (s.label) {
	                    label = lf ? lf(s.label, s) : s.label;
	                    if (label) {
	                        entries.push({
	                            label: label,
	                            color: s.color
	                        });
	                    }
	                }
	            }
	
	            // No entries implies no legend
	            if (entries.length === 0) {
	                return;
	            }
	
	            // Sort the legend using either the default or a custom comparator
	            if (options.legend.sorted) {
	                if ($.isFunction(options.legend.sorted)) {
	                    entries.sort(options.legend.sorted);
	                } else if (options.legend.sorted === "reverse") {
	                    entries.reverse();
	                } else {
	                    var ascending = options.legend.sorted !== "descending";
	                    entries.sort(function(a, b) {
	                        return a.label === b.label ? 0 : (
	                            (a.label < b.label) !== ascending ? 1 : -1   // Logical XOR
	                        );
	                    });
	                }
	            }
	
	            // Generate markup for the list of entries, in their final order
	            var table = $("<table></table>").css({
	                "font-size": "smaller",
	                "color": options.grid.color
	            }), rowBuffer = null;
	
	            for (i = 0; i < entries.length; ++i) {
	
	                var entry = entries[i];
	
	                if (i % options.legend.noColumns === 0) {
	                    if (rowBuffer !== null) {
	                        table.append(rowBuffer);
	                    }
	                    rowBuffer = $("<tr></tr>");
	                }
	
	                var colorbox = $("<div></div>").css({
	                    "width": "4px",
	                    "height": 0,
	                    "border": "5px solid " + entry.color,
	                    "overflow": "hidden"
	                }),
	
	                borderbox = $("<div></div>").css({
	                    "border": "1px solid " + options.legend.labelBoxBorderColor,
	                    "padding": "1px"
	                });
	
	                rowBuffer.append(
	                    $("<td></td>").addClass("legendColorBox").append(borderbox.append(colorbox)),
	                    $("<td></td>").addClass("legendLabel").html(entry.label)
	                );
	            }
	
	            table.append(rowBuffer);
	
	            if (options.legend.container != null) {
	                $(options.legend.container).html(table);
	            } else {
	                var pos = { "position": "absolute" },
	                    p = options.legend.position,
	                    m = options.legend.margin;
	                if (m[0] == null) {
	                    m = [m, m];
	                }
	                if (p.charAt(0) === "n") {
	                    pos.top = (m[1] + plotOffset.top) + "px";
	                } else if (p.charAt(0) === "s") {
	                    pos.bottom = (m[1] + plotOffset.bottom) + "px";
	                }
	                if (p.charAt(1) === "e") {
	                    pos.right = (m[0] + plotOffset.right) + "px";
	                } else if (p.charAt(1) === "w") {
	                    pos.left = (m[0] + plotOffset.left) + "px";
	                }
	                var legend = $("<div></div>").addClass("legend").append(table.css(pos)).appendTo(placeholder);
	                if (options.legend.backgroundOpacity !== 0.0) {
	
	                    // put in the transparent background
	                    // separately to avoid blended labels and
	                    // label boxes
	                    var c = options.legend.backgroundColor;
	                    if (c == null) {
	                        c = options.grid.backgroundColor;
	                        if (c && typeof c === "string") {
	                            c = $.color.parse(c);
	                        } else {
	                            c = $.color.extract(legend, "background-color");
	                        }
	                        c.a = 1;
	                        c = c.toString();
	                    }
	                    var div = legend.children();
	
	                    // Position also applies to this
	                    $("<div></div>").css(pos).css({
	                        "width": div.width() + "px",
	                        "height": div.height() + "px",
	                        "background-color": c,
	                        "opacity": options.legend.backgroundOpacity
	                    }).prependTo(legend);
	                }
	            }
	        }
	
	        /**
	         * returns the data item the mouse is over, or null if none is found
	         */
	        function findNearbyItem(mouseX, mouseY, seriesFilter) {
	            var maxDistance = options.grid.mouseActiveRadius,
	                smallestDistance = maxDistance * maxDistance + 1,
	                item = null, i, j, ps;
	
	            for (i = series.length - 1; i >= 0; --i) {
	                if (!seriesFilter(series[i])) {
	                    continue;
	                }
	
	                var s = series[i],
	                    axisx = s.xaxis,
	                    axisy = s.yaxis,
	                    points = s.datapoints.points,
	
	                    // precompute some stuff to make the loop faster
	                    mx = axisx.c2p(mouseX),
	                    my = axisy.c2p(mouseY),
	                    maxx = maxDistance / axisx.scale,
	                    maxy = maxDistance / axisy.scale,
	                    x, y;
	
	                ps = s.datapoints.pointsize;
	
	                // with inverse transforms, we can't use the maxx/maxy
	                // optimization, sadly
	                if (axisx.options.inverseTransform) {
	                    maxx = Number.MAX_VALUE;
	                }
	                if (axisy.options.inverseTransform) {
	                    maxy = Number.MAX_VALUE;
	                }
	
	                if (s.lines.show || s.points.show) {
	                    for (j = 0; j < points.length; j += ps) {
	
	                        x = points[j];
	                        y = points[j + 1];
	
	                        if (x == null) {
	                            continue;
	                        }
	
	                        // For points and lines, the cursor must be within a
	                        // certain distance to the data point
	                        if (x - mx > maxx || x - mx < -maxx ||
	                            y - my > maxy || y - my < -maxy) {
	                            continue;
	                        }
	
	                        // We have to calculate distances in pixels, not in
	                        // data units, because the scales of the axes may be different
	                        var dx = Math.abs(axisx.p2c(x) - mouseX),
	                            dy = Math.abs(axisy.p2c(y) - mouseY),
	                            dist = dx * dx + dy * dy; // we save the sqrt
	
	                        // use <= to ensure last point takes precedence
	                        // (last generally means on top of)
	                        if (dist < smallestDistance) {
	                            smallestDistance = dist;
	                            item = [i, j / ps];
	                        }
	                    }
	                }
	
	                if (s.bars.show && !item) {
	
	                    // no other point can be nearby
	                    var barLeft, barRight;
	
	                    switch (s.bars.align) {
	                    case "left":
	                        barLeft = 0;
	                        break;
	                    case "right":
	                        barLeft = -s.bars.barWidth;
	                        break;
	                    default:
	                        barLeft = -s.bars.barWidth / 2;
	                    }
	
	                    barRight = barLeft + s.bars.barWidth;
	
	                    for (j = 0; j < points.length; j += ps) {
	                        x = points[j];
	                        y = points[j + 1];
	                        var b = points[j + 2];
	                        if (x == null) {
	                            continue;
	                        }
	
	                        // for a bar graph, the cursor must be inside the bar
	                        if (series[i].bars.horizontal ?
	                            (mx <= Math.max(b, x) && mx >= Math.min(b, x) &&
	                             my >= y + barLeft && my <= y + barRight) :
	                            (mx >= x + barLeft && mx <= x + barRight &&
	                             my >= Math.min(b, y) && my <= Math.max(b, y))) {
	                            item = [i, j / ps];
	                        }
	                    }
	                }
	            }
	
	            if (item) {
	                i = item[0];
	                j = item[1];
	                ps = series[i].datapoints.pointsize;
	
	                return { datapoint: series[i].datapoints.points.slice(j * ps, (j + 1) * ps),
	                         dataIndex: j,
	                         series: series[i],
	                         seriesIndex: i };
	            }
	
	            return null;
	        }
	
	        function onMouseMove(e) {
	            if (options.grid.hoverable) {
	                triggerClickHoverEvent("plothover", e,
	                                       function(s) { return s.hoverable !== false; });
	            }
	        }
	
	        function onMouseLeave(e) {
	            if (options.grid.hoverable) {
	                triggerClickHoverEvent("plothover", e,
	                                       function() { return false; });
	            }
	        }
	
	        function onClick(e) {
	            triggerClickHoverEvent("plotclick", e,
	                                   function(s) { return s.clickable !== false; });
	        }
	
	        /**
	         * trigger click or hover event (they send the same parameters
	         * so we share their code)
	         */
	        function triggerClickHoverEvent(eventname, event, seriesFilter) {
	            var offset = eventHolder.offset(),
	                canvasX = event.pageX - offset.left - plotOffset.left,
	                canvasY = event.pageY - offset.top - plotOffset.top,
	            pos = canvasToAxisCoords({ left: canvasX, top: canvasY });
	
	            pos.pageX = event.pageX;
	            pos.pageY = event.pageY;
	
	            var item = findNearbyItem(canvasX, canvasY, seriesFilter);
	
	            if (item) {
	
	                // fill in mouse pos for any listeners out there
	                item.pageX = parseInt(item.series.xaxis.p2c(item.datapoint[0]) + offset.left + plotOffset.left, 10);
	                item.pageY = parseInt(item.series.yaxis.p2c(item.datapoint[1]) + offset.top + plotOffset.top, 10);
	            }
	
	            if (options.grid.autoHighlight) {
	
	                // clear auto-highlights
	                for (var i = 0; i < highlights.length; ++i) {
	                    var h = highlights[i];
	                    if (h.auto === eventname && !(
	                        item && h.series === item.series &&
	                        h.point[0] === item.datapoint[0] &&
	                        h.point[1] === item.datapoint[1]
	                    )) {
	                        unhighlight(h.series, h.point);
	                    }
	                }
	
	                if (item) {
	                    highlight(item.series, item.datapoint, eventname);
	                }
	            }
	
	            placeholder.trigger(eventname, [pos, item]);
	        }
	
	        function triggerRedrawOverlay() {
	            var t = options.interaction.redrawOverlayInterval;
	
	            if (t === -1) {
	
	                // skip event queue
	                drawOverlay();
	                return;
	            }
	
	            if (!redrawTimeout) {
	                redrawTimeout = setTimeout(drawOverlay, t);
	            }
	        }
	
	        function drawOverlay() {
	            redrawTimeout = null;
	
	            // draw highlights
	            octx.save();
	            overlay.clear();
	            octx.translate(plotOffset.left, plotOffset.top);
	
	            var i, hi;
	            for (i = 0; i < highlights.length; ++i) {
	                hi = highlights[i];
	
	                if (hi.series.bars.show) {
	                    drawBarHighlight(hi.series, hi.point);
	                } else {
	                    drawPointHighlight(hi.series, hi.point);
	                }
	            }
	            octx.restore();
	
	            executeHooks(hooks.drawOverlay, [octx]);
	        }
	
	        function highlight(s, point, auto) {
	            if (isNumeric(s)) {
	                s = series[s];
	            }
	
	            if (isNumeric(point)) {
	                var ps = s.datapoints.pointsize;
	                point = s.datapoints.points.slice(ps * point, ps * (point + 1));
	            }
	
	            var i = indexOfHighlight(s, point);
	            if (i === -1) {
	                highlights.push({ series: s, point: point, auto: auto });
	                triggerRedrawOverlay();
	            } else if (!auto) {
	                highlights[i].auto = false;
	            }
	        }
	
	        function unhighlight(s, point) {
	            if (s == null && point == null) {
	                highlights = [];
	                triggerRedrawOverlay();
	                return;
	            }
	
	            if (isNumeric(s)) {
	                s = series[s];
	            }
	
	            if (isNumeric(point)) {
	                var ps = s.datapoints.pointsize;
	                point = s.datapoints.points.slice(ps * point, ps * (point + 1));
	            }
	
	            var i = indexOfHighlight(s, point);
	            if (i !== -1) {
	                highlights.splice(i, 1);
	                triggerRedrawOverlay();
	            }
	        }
	
	        function indexOfHighlight(s, p) {
	            for (var i = 0; i < highlights.length; ++i) {
	                var h = highlights[i];
	                if (h.series === s && h.point[0] === p[0] && h.point[1] === p[1]) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	
	        function drawPointHighlight(series, point) {
	            var x = point[0], y = point[1],
	                axisx = series.xaxis, axisy = series.yaxis,
	                highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale("a", 0.5).toString();
	
	            if (x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max) {
	                return;
	            }
	
	            var pointRadius, radius;
	
	            if (series.points.show) {
	                pointRadius = series.points.radius + series.points.lineWidth / 2;
	                radius = 1.5 * pointRadius;
	            } else {
	                pointRadius = series.points.radius;
	                radius = 0.5 * pointRadius;
	            }
	            octx.lineWidth = pointRadius;
	            octx.strokeStyle = highlightColor;
	            x = axisx.p2c(x);
	            y = axisy.p2c(y);
	
	            octx.beginPath();
	            if (series.points.symbol === "circle") {
	                octx.arc(x, y, radius, 0, 2 * Math.PI, false);
	            } else {
	                series.points.symbol(octx, x, y, radius, false);
	            }
	            octx.closePath();
	            octx.stroke();
	        }
	
	        function drawBarHighlight(series, point) {
	            var highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale("a", 0.5).toString(),
	                fillStyle = highlightColor,
	                barLeft;
	
	            switch (series.bars.align) {
	            case "left":
	                barLeft = 0;
	                break;
	            case "right":
	                barLeft = -series.bars.barWidth;
	                break;
	            default:
	                barLeft = -series.bars.barWidth / 2;
	            }
	
	            octx.lineWidth = series.bars.lineWidth;
	            octx.strokeStyle = highlightColor;
	
	            drawBar(point[0], point[1], point[2] || 0, barLeft, barLeft + series.bars.barWidth,
	                    function() { return fillStyle; }, series.xaxis, series.yaxis, octx, series.bars.horizontal, series.bars.lineWidth);
	        }
	
	        function getColorOrGradient(spec, bottom, top, defaultColor) {
	            if (typeof spec === "string") {
	                return spec;
	            } else {
	
	                // assume this is a gradient spec; IE currently only
	                // supports a simple vertical gradient properly, so that's
	                // what we support too
	                var gradient = ctx.createLinearGradient(0, top, 0, bottom);
	
	                for (var i = 0, l = spec.colors.length; i < l; ++i) {
	                    var c = spec.colors[i];
	                    if (typeof c !== "string") {
	                        var co = $.color.parse(defaultColor);
	                        if (c.brightness != null) {
	                            co = co.scale("rgb", c.brightness);
	                        }
	                        if (c.opacity != null) {
	                            co.a *= c.opacity;
	                        }
	                        c = co.toString();
	                    }
	                    gradient.addColorStop(i / (l - 1), c);
	                }
	
	                return gradient;
	            }
	        }
	    }
	
	    /**
	     * Add the plot function to the top level of the jQuery object
	     */
	    $.plot = function(placeholder, data, options) {
	        var plot = new Plot($(placeholder), data, options, $.plot.plugins);
	        return plot;
	    };
	
	    $.plot.version = "0.9.0-alpha";
	
	    $.plot.plugins = [];
	
	    /**
	     * Also add the plot function as a chainable property
	     */
	    $.fn.plot = function(data, options) {
	        return this.each(function() {
	            $.plot(this, data, options);
	        });
	    };
	
	    /**
	     * round to nearby lower multiple of base
	     */
	    function floorInBase(n, base) {
	        return base * Math.floor(n / base);
	    }
	
	    /**
	     * Draw a rectangle with rounded corner on the canvas.
	     *
	     * @param {CanvasRenderingContext2D} ctx The canvas 2D context.
	     * @param {number} x The x-axis coordinate of the upper left corner of
	     *      the rectangle to be drawn.
	     * @param {number} y The y-axis coordinate of the upper left corner of
	     *      the rectangle to be drawn.
	     * @param {number} width The width of the rectangle to be drawn.
	     * @param {number} height The height of the rectangle to be drawn.
	     * @param {number} radius The radius of the corner of the rectangle
	     *      to be drawn.
	     */
	    function roundRect(ctx, x, y, width, height, radius) {
	        var r = x + width,
	            b = y + height;
	
	        ctx.beginPath();
	        ctx.moveTo(x + radius, y);
	        ctx.lineTo(r - radius, y);
	        ctx.quadraticCurveTo(r, y, r, y + radius);
	        ctx.lineTo(r, y + height - radius);
	        ctx.quadraticCurveTo(r, b, r - radius, b);
	        ctx.lineTo(x + radius, b);
	        ctx.quadraticCurveTo(x, b, x, b - radius);
	        ctx.lineTo(x, y + radius);
	        ctx.quadraticCurveTo(x, y, x + radius, y);
	        ctx.closePath();
	        return ctx;
	    }
	
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* Flot plugin for showing crosshairs when the mouse hovers over the plot.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	The plugin supports these options:
	
	    crosshair: {
	        mode: null or "x" or "y" or "xy"
	        color: color
	        lineWidth: number
	    }
	
	Set the mode to one of "x", "y" or "xy". The "x" mode enables a vertical
	crosshair that lets you trace the values on the x axis, "y" enables a
	horizontal crosshair and "xy" enables them both. "color" is the color of the
	crosshair (default is "rgba(170, 0, 0, 0.80)"), "lineWidth" is the width of
	the drawn lines (default is 1).
	
	The plugin also adds four public methods:
	
	  - setCrosshair( pos )
	
	    Set the position of the crosshair. Note that this is cleared if the user
	    moves the mouse. "pos" is in coordinates of the plot and should be on the
	    form { x: xpos, y: ypos } (you can use x2/x3/... if you're using multiple
	    axes), which is coincidentally the same format as what you get from a
	    "plothover" event. If "pos" is null, the crosshair is cleared.
	
	  - clearCrosshair()
	
	    Clear the crosshair.
	
	  - lockCrosshair(pos)
	
	    Cause the crosshair to lock to the current location, no longer updating if
	    the user moves the mouse. Optionally supply a position (passed on to
	    setCrosshair()) to move it to.
	
	    Example usage:
	
	    var myFlot = $.plot( $("#graph"), ..., { crosshair: { mode: "x" } } };
	    $("#graph").bind( "plothover", function( evt, position, item ) {
	        if ( item ) {
	            // Lock the crosshair to the data point being hovered
	            myFlot.lockCrosshair({
	                x: item.datapoint[ 0 ],
	                y: item.datapoint[ 1 ]
	            });
	        } else {
	            // Return normal crosshair operation
	            myFlot.unlockCrosshair();
	        }
	    });
	
	  - unlockCrosshair()
	
	    Free the crosshair to move again after locking it.
	*/
	
	(function($) {
	
	    var options = {
	        crosshair: {
	            mode: null, // one of null, "x", "y" or "xy",
	            color: "rgba(170, 0, 0, 0.80)",
	            lineWidth: 1
	        }
	    };
	
	    function init(plot) {
	        // position of crosshair in pixels
	        var crosshair = { x: -1, y: -1, locked: false };
	
	        plot.setCrosshair = function setCrosshair(pos) {
	            if (!pos) {
	                crosshair.x = -1;
	            } else {
	                var o = plot.p2c(pos);
	                crosshair.x = Math.max(0, Math.min(o.left, plot.width()));
	                crosshair.y = Math.max(0, Math.min(o.top, plot.height()));
	            }
	
	            plot.triggerRedrawOverlay();
	        };
	
	        plot.clearCrosshair = plot.setCrosshair; // passes null for pos
	
	        plot.lockCrosshair = function lockCrosshair(pos) {
	            if (pos) {
	                plot.setCrosshair(pos);
	            }
	            crosshair.locked = true;
	        };
	
	        plot.unlockCrosshair = function unlockCrosshair() {
	            crosshair.locked = false;
	        };
	
	        function onMouseOut() {
	            if (crosshair.locked) {
	                return;
	            }
	
	            if (crosshair.x !== -1) {
	                crosshair.x = -1;
	                plot.triggerRedrawOverlay();
	            }
	        }
	
	        function onMouseMove(e) {
	            if (crosshair.locked) {
	                return;
	            }
	
	            if (plot.getSelection && plot.getSelection()) {
	                crosshair.x = -1; // hide the crosshair while selecting
	                return;
	            }
	
	            var offset = plot.offset();
	            crosshair.x = Math.max(0, Math.min(e.pageX - offset.left, plot.width()));
	            crosshair.y = Math.max(0, Math.min(e.pageY - offset.top, plot.height()));
	            plot.triggerRedrawOverlay();
	        }
	
	        plot.hooks.bindEvents.push(function(plot, eventHolder) {
	            if (!plot.getOptions().crosshair.mode) {
	                return;
	            }
	
	            eventHolder.mouseout(onMouseOut);
	            eventHolder.mousemove(onMouseMove);
	        });
	
	        plot.hooks.drawOverlay.push(function(plot, ctx) {
	            var c = plot.getOptions().crosshair;
	            if (!c.mode) {
	                return;
	            }
	
	            var plotOffset = plot.getPlotOffset();
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            if (crosshair.x !== -1) {
	                var adj = plot.getOptions().crosshair.lineWidth % 2 ? 0.5 : 0;
	
	                ctx.strokeStyle = c.color;
	                ctx.lineWidth = c.lineWidth;
	                ctx.lineJoin = "round";
	
	                ctx.beginPath();
	                if (c.mode.indexOf("x") !== -1) {
	                    var drawX = Math.floor(crosshair.x) + adj;
	                    ctx.moveTo(drawX, 0);
	                    ctx.lineTo(drawX, plot.height());
	                }
	                if (c.mode.indexOf("y") !== -1) {
	                    var drawY = Math.floor(crosshair.y) + adj;
	                    ctx.moveTo(0, drawY);
	                    ctx.lineTo(plot.width(), drawY);
	                }
	                ctx.stroke();
	            }
	            ctx.restore();
	        });
	
	        plot.hooks.shutdown.push(function(plot, eventHolder) {
	            eventHolder.unbind("mouseout", onMouseOut);
	            eventHolder.unbind("mousemove", onMouseMove);
	        });
	    }
	
	    $.plot.plugins.push({
	        init: init,
	        options: options,
	        name: "crosshair",
	        version: "1.0"
	    });
	
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* Flot plugin for rendering pie charts.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	The plugin assumes that each series has a single data value, and that each
	value is a positive integer or zero.  Negative numbers don't make sense for a
	pie chart, and have unpredictable results.  The values do NOT need to be
	passed in as percentages; the plugin will calculate the total and per-slice
	percentages internally.
	
	* Created by Brian Medendorp
	
	* Updated with contributions from btburnett3, Anthony Aragues and Xavi Ivars
	
	The plugin supports these options:
	
	    series: {
	        pie: {
	            show: true/false
	            radius: 0-1 for percentage of fullsize, or a specified pixel length, or 'auto'
	            innerRadius: 0-1 for percentage of fullsize or a specified pixel length, for creating a donut effect
	            startAngle: 0-2 factor of PI used for starting angle (in radians) i.e 3/2 starts at the top, 0 and 2 have the same result
	            tilt: 0-1 for percentage to tilt the pie, where 1 is no tilt, and 0 is completely flat (nothing will show)
	            offset: {
	                top: integer value to move the pie up or down
	                left: integer value to move the pie left or right, or 'auto'
	            },
	            stroke: {
	                color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#FFF')
	                width: integer pixel width of the stroke
	            },
	            label: {
	                show: true/false, or 'auto'
	                formatter:  a user-defined function that modifies the text/style of the label text
	                radius: 0-1 for percentage of fullsize, or a specified pixel length
	                background: {
	                    color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#000')
	                    opacity: 0-1
	                },
	                threshold: 0-1 for the percentage value at which to hide labels (if they're too small)
	            },
	            combine: {
	                threshold: 0-1 for the percentage value at which to combine slices (if they're too small)
	                color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#CCC'), if null, the plugin will automatically use the color of the first slice to be combined
	                label: any text value of what the combined slice should be labeled
	            }
	            highlight: {
	                opacity: 0-1
	            }
	        }
	    }
	
	More detail and specific examples can be found in the included HTML file.
	
	*/
	
	(function($) {
	
	    // Maximum redraw attempts when fitting labels within the plot
	
	    var REDRAW_ATTEMPTS = 10,
	
	        // Factor by which to shrink the pie when fitting labels within the plot
	
	        REDRAW_SHRINK = 0.95;
	
	    function init(plot) {
	
	        var canvas = null,
	            target = null,
	            options = null,
	            maxRadius = null,
	            centerLeft = null,
	            centerTop = null,
	            processed = false,
	            ctx = null,
	
	            // interactive variables
	
	            highlights = [];
	
	        // add hook to determine if pie plugin in enabled, and then perform necessary operations
	
	        plot.hooks.processOptions.push(function(plot, options) {
	            if (options.series.pie.show) {
	
	                options.grid.show = false;
	
	                // set labels.show
	
	                if (options.series.pie.label.show === "auto") {
	                    if (options.legend.show) {
	                        options.series.pie.label.show = false;
	                    } else {
	                        options.series.pie.label.show = true;
	                    }
	                }
	
	                // set radius
	
	                if (options.series.pie.radius === "auto") {
	                    if (options.series.pie.label.show) {
	                        options.series.pie.radius = 3 / 4;
	                    } else {
	                        options.series.pie.radius = 1;
	                    }
	                }
	
	                // ensure sane tilt
	
	                if (options.series.pie.tilt > 1) {
	                    options.series.pie.tilt = 1;
	                } else if (options.series.pie.tilt < 0) {
	                    options.series.pie.tilt = 0;
	                }
	            }
	        });
	
	        plot.hooks.bindEvents.push(function(plot, eventHolder) {
	            var options = plot.getOptions();
	            if (options.series.pie.show) {
	                if (options.grid.hoverable) {
	                    eventHolder.unbind("mousemove").mousemove(onMouseMove);
	                }
	                if (options.grid.clickable) {
	                    eventHolder.unbind("click").click(onClick);
	                }
	            }
	        });
	
	        plot.hooks.processDatapoints.push(function(plot, series, data, datapoints) {
	            var options = plot.getOptions();
	            if (options.series.pie.show) {
	                processDatapoints(plot, series, data, datapoints);
	            }
	        });
	
	        plot.hooks.drawOverlay.push(function(plot, octx) {
	            var options = plot.getOptions();
	            if (options.series.pie.show) {
	                drawOverlay(plot, octx);
	            }
	        });
	
	        plot.hooks.draw.push(function(plot, newCtx) {
	            var options = plot.getOptions();
	            if (options.series.pie.show) {
	                draw(plot, newCtx);
	            }
	        });
	
	        function processDatapoints(plot) {
	            if (!processed)    {
	                processed = true;
	                canvas = plot.getCanvas();
	                target = $(canvas).parent();
	                options = plot.getOptions();
	                plot.setData(combine(plot.getData()));
	            }
	        }
	
	        function combine(data) {
	
	            var total = 0,
	                combined = 0,
	                numCombined = 0,
	                color = options.series.pie.combine.color,
	                newdata = [],
	                i, value;
	
	            // Fix up the raw data from Flot, ensuring the data is numeric
	
	            for (i = 0; i < data.length; ++i) {
	
	                value = data[i].data;
	
	                // If the data is an array, we'll assume that it's a standard
	                // Flot x-y pair, and are concerned only with the second value.
	
	                // Note how we use the original array, rather than creating a
	                // new one; this is more efficient and preserves any extra data
	                // that the user may have stored in higher indexes.
	
	                if ($.isArray(value) && value.length === 1) {
	                    value = value[0];
	                }
	
	                if ($.isArray(value)) {
	                    // Equivalent to $.isNumeric() but compatible with jQuery < 1.7
	                    if (!isNaN(parseFloat(value[1])) && isFinite(value[1])) {
	                        value[1] = +value[1];
	                    } else {
	                        value[1] = 0;
	                    }
	                } else if (!isNaN(parseFloat(value)) && isFinite(value)) {
	                    value = [1, +value];
	                } else {
	                    value = [1, 0];
	                }
	
	                data[i].data = [value];
	            }
	
	            // Sum up all the slices, so we can calculate percentages for each
	
	            for (i = 0; i < data.length; ++i) {
	                total += data[i].data[0][1];
	            }
	
	            // Count the number of slices with percentages below the combine
	            // threshold; if it turns out to be just one, we won't combine.
	
	            for (i = 0; i < data.length; ++i) {
	                value = data[i].data[0][1];
	                if (value / total <= options.series.pie.combine.threshold) {
	                    combined += value;
	                    numCombined++;
	                    if (!color) {
	                        color = data[i].color;
	                    }
	                }
	            }
	
	            for (i = 0; i < data.length; ++i) {
	                value = data[i].data[0][1];
	                if (numCombined < 2 || value / total > options.series.pie.combine.threshold) {
	                    newdata.push(
	                        // Use extend rather than replacing, so other original
	                        // data values can be used, e.g. in labelFormatter.
	                        $.extend(data[i], {
	                            data: [[1, value]],
	                            color: data[i].color,
	                            label: data[i].label,
	                            angle: value * Math.PI * 2 / total,
	                            percent: value / (total / 100)
	                        })
	                    );
	                }
	            }
	
	            if (numCombined > 1) {
	                newdata.push({
	                    data: [[1, combined]],
	                    color: color,
	                    label: options.series.pie.combine.label,
	                    angle: combined * Math.PI * 2 / total,
	                    percent: combined / (total / 100)
	                });
	            }
	
	            return newdata;
	        }
	
	        function draw(plot, newCtx) {
	
	            /* global console */
	
	            if (!target) {
	                return; // if no series were passed
	            }
	
	            var canvasWidth = plot.getPlaceholder().width(),
	                canvasHeight = plot.getPlaceholder().height(),
	                legendWidth = target.children().filter(".legend").children().width() || 0;
	
	            ctx = newCtx;
	
	            // WARNING: HACK! REWRITE THIS CODE AS SOON AS POSSIBLE!
	
	            // When combining smaller slices into an 'other' slice, we need to
	            // add a new series.  Since Flot gives plugins no way to modify the
	            // list of series, the pie plugin uses a hack where the first call
	            // to processDatapoints results in a call to setData with the new
	            // list of series, then subsequent processDatapoints do nothing.
	
	            // The plugin-global 'processed' flag is used to control this hack;
	            // it starts out false, and is set to true after the first call to
	            // processDatapoints.
	
	            // Unfortunately this turns future setData calls into no-ops; they
	            // call processDatapoints, the flag is true, and nothing happens.
	
	            // To fix this we'll set the flag back to false here in draw, when
	            // all series have been processed, so the next sequence of calls to
	            // processDatapoints once again starts out with a slice-combine.
	            // This is really a hack; in 0.9 we need to give plugins a proper
	            // way to modify series before any processing begins.
	
	            processed = false;
	
	            // calculate maximum radius and center point
	
	            maxRadius =  Math.min(canvasWidth, canvasHeight / options.series.pie.tilt) / 2;
	            centerTop = canvasHeight / 2 + options.series.pie.offset.top;
	            centerLeft = canvasWidth / 2;
	
	            if (options.series.pie.offset.left === "auto") {
	                if (options.legend.position.match("w")) {
	                    centerLeft += legendWidth / 2;
	                } else {
	                    centerLeft -= legendWidth / 2;
	                }
	                if (centerLeft < maxRadius) {
	                    centerLeft = maxRadius;
	                } else if (centerLeft > canvasWidth - maxRadius) {
	                    centerLeft = canvasWidth - maxRadius;
	                }
	            } else {
	                centerLeft += options.series.pie.offset.left;
	            }
	
	            var slices = plot.getData(),
	                attempts = 0;
	
	            // Keep shrinking the pie's radius until drawPie returns true,
	            // indicating that all the labels fit, or we try too many times.
	
	            do {
	                if (attempts > 0) {
	                    maxRadius *= REDRAW_SHRINK;
	                }
	                attempts += 1;
	                clear();
	                if (options.series.pie.tilt <= 0.8) {
	                    drawShadow();
	                }
	            } while (!drawPie() && attempts < REDRAW_ATTEMPTS);
	
	            if (attempts >= REDRAW_ATTEMPTS) {
	                clear();
	                if ( typeof console === "object" && typeof console.warn === "function" ) {
	                    console.warn("Could not draw pie with labels contained inside canvas");
	                }
	            }
	
	            if (plot.setSeries && plot.insertLegend) {
	                plot.setSeries(slices);
	                plot.insertLegend();
	            }
	
	            // we're actually done at this point, just defining internal functions at this point
	
	            function clear() {
	                ctx.clearRect(0, 0, canvasWidth, canvasHeight);
	                target.children().filter(".pieLabel, .pieLabelBackground").remove();
	            }
	
	            function drawShadow() {
	
	                var shadowLeft = options.series.pie.shadow.left,
	                    shadowTop = options.series.pie.shadow.top,
	                    edge = 10,
	                    alpha = options.series.pie.shadow.alpha,
	                    radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
	
	                if (radius >= canvasWidth / 2 - shadowLeft || radius * options.series.pie.tilt >= canvasHeight / 2 - shadowTop || radius <= edge) {
	                    return;    // shadow would be outside canvas, so don't draw it
	                }
	
	                ctx.save();
	                ctx.translate(shadowLeft,shadowTop);
	                ctx.globalAlpha = alpha;
	                ctx.fillStyle = "#000";
	
	                // center and rotate to starting position
	
	                ctx.translate(centerLeft,centerTop);
	                ctx.scale(1, options.series.pie.tilt);
	
	                //radius -= edge;
	
	                for (var i = 1; i <= edge; i++) {
	                    ctx.beginPath();
	                    ctx.arc(0, 0, radius, 0, Math.PI * 2, false);
	                    ctx.fill();
	                    radius -= i;
	                }
	
	                ctx.restore();
	            }
	
	            function drawPie() {
	
	                var startAngle = Math.PI * options.series.pie.startAngle,
	                    radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius,
	                    i;
	
	                // center and rotate to starting position
	
	                ctx.save();
	                ctx.translate(centerLeft,centerTop);
	                ctx.scale(1, options.series.pie.tilt);
	                //ctx.rotate(startAngle); // start at top; -- This doesn't work properly in Opera
	
	                // draw slices
	
	                ctx.save();
	                var currentAngle = startAngle;
	                for (i = 0; i < slices.length; ++i) {
	                    slices[i].startAngle = currentAngle;
	                    drawSlice(slices[i].angle, slices[i].color, true);
	                }
	                ctx.restore();
	
	                // draw slice outlines
	
	                if (options.series.pie.stroke.width > 0) {
	                    ctx.save();
	                    ctx.lineWidth = options.series.pie.stroke.width;
	                    currentAngle = startAngle;
	                    for (i = 0; i < slices.length; ++i) {
	                        drawSlice(slices[i].angle, options.series.pie.stroke.color, false);
	                    }
	                    ctx.restore();
	                }
	
	                // draw donut hole
	
	                drawDonutHole(ctx);
	
	                ctx.restore();
	
	                // Draw the labels, returning true if they fit within the plot
	
	                if (options.series.pie.label.show) {
	                    return drawLabels();
	                } else {
	                    return true;
	                }
	
	                function drawSlice(angle, color, fill) {
	
	                    if (angle <= 0 || isNaN(angle)) {
	                        return;
	                    }
	
	                    if (fill) {
	                        ctx.fillStyle = color;
	                    } else {
	                        ctx.strokeStyle = color;
	                        ctx.lineJoin = "round";
	                    }
	
	                    ctx.beginPath();
	                    if (Math.abs(angle - Math.PI * 2) > 0.000000001) {
	                        ctx.moveTo(0, 0); // Center of the pie
	                    }
	
	                    //ctx.arc(0, 0, radius, 0, angle, false); // This doesn't work properly in Opera
	                    ctx.arc(0, 0, radius,currentAngle, currentAngle + angle / 2, false);
	                    ctx.arc(0, 0, radius,currentAngle + angle / 2, currentAngle + angle, false);
	                    ctx.closePath();
	                    //ctx.rotate(angle); // This doesn't work properly in Opera
	                    currentAngle += angle;
	
	                    if (fill) {
	                        ctx.fill();
	                    } else {
	                        ctx.stroke();
	                    }
	                }
	
	                function drawLabels() {
	
	                    var currentAngle = startAngle,
	                        radius = options.series.pie.label.radius > 1 ? options.series.pie.label.radius : maxRadius * options.series.pie.label.radius;
	
	                    for (var i = 0; i < slices.length; ++i) {
	                        if (slices[i].percent >= options.series.pie.label.threshold * 100) {
	                            if (!drawLabel(slices[i], currentAngle, i)) {
	                                return false;
	                            }
	                        }
	                        currentAngle += slices[i].angle;
	                    }
	
	                    return true;
	
	                    function drawLabel(slice, startAngle, index) {
	
	                        if (slice.data[0][1] === 0) {
	                            return true;
	                        }
	
	                        // format label text
	
	                        var lf = options.legend.labelFormatter, text, plf = options.series.pie.label.formatter;
	
	                        if (lf) {
	                            text = lf(slice.label, slice);
	                        } else {
	                            text = slice.label;
	                        }
	
	                        if (plf) {
	                            text = plf(text, slice);
	                        }
	
	                        var halfAngle = ((startAngle + slice.angle) + startAngle) / 2,
	                            x = centerLeft + Math.round(Math.cos(halfAngle) * radius),
	                            y = centerTop + Math.round(Math.sin(halfAngle) * radius) * options.series.pie.tilt,
	                            html = "<span class='pieLabel' id='pieLabel" + index + "' style='position:absolute;top:" + y + "px;left:" + x + "px;'>" + text + "</span>";
	
	                        target.append(html);
	
	                        var label = target.children("#pieLabel" + index),
	                            labelTop = (y - label.height() / 2),
	                            labelLeft = (x - label.width() / 2);
	
	                        label.css("top", labelTop);
	                        label.css("left", labelLeft);
	
	                        // check to make sure that the label is not outside the canvas
	
	                        if (0 - labelTop > 0 || 0 - labelLeft > 0 || canvasHeight - (labelTop + label.height()) < 0 || canvasWidth - (labelLeft + label.width()) < 0) {
	                            return false;
	                        }
	
	                        if (options.series.pie.label.background.opacity !== 0) {
	
	                            // put in the transparent background separately to avoid blended labels and label boxes
	
	                            var c = options.series.pie.label.background.color;
	
	                            if (c == null) {
	                                c = slice.color;
	                            }
	
	                            var pos = "top:" + labelTop + "px;left:" + labelLeft + "px;";
	                            $("<div class='pieLabelBackground' style='position:absolute;width:" + label.width() + "px;height:" + label.height() + "px;" + pos + "background-color:" + c + ";'></div>")
	                                .css("opacity", options.series.pie.label.background.opacity)
	                                .insertBefore(label);
	                        }
	
	                        return true;
	                    } // end individual label function
	                } // end drawLabels function
	            } // end drawPie function
	        } // end draw function
	
	        // Placed here because it needs to be accessed from multiple locations
	
	        function drawDonutHole(layer) {
	            if (options.series.pie.innerRadius > 0) {
	
	                // subtract the center
	
	                layer.save();
	                var innerRadius = options.series.pie.innerRadius > 1 ? options.series.pie.innerRadius : maxRadius * options.series.pie.innerRadius;
	                layer.globalCompositeOperation = "destination-out"; // this does not work with excanvas, but it will fall back to using the stroke color
	                layer.beginPath();
	                layer.fillStyle = options.series.pie.stroke.color;
	                layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
	                layer.fill();
	                layer.closePath();
	                layer.restore();
	
	                // add inner stroke
	
	                layer.save();
	                layer.beginPath();
	                layer.strokeStyle = options.series.pie.stroke.color;
	                layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
	                layer.stroke();
	                layer.closePath();
	                layer.restore();
	
	                // TODO: add extra shadow inside hole (with a mask) if the pie is tilted.
	            }
	        }
	
	        //-- Additional Interactive related functions --
	
	        function isPointInPoly(poly, pt) {
	            for (var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i) {
	                ((poly[i][1] <= pt[1] && pt[1] < poly[j][1]) ||
	                 (poly[j][1] <= pt[1] && pt[1] < poly[i][1])) &&
	                (pt[0] < (poly[j][0] - poly[i][0]) * (pt[1] - poly[i][1]) / (poly[j][1] - poly[i][1]) + poly[i][0]) &&
	                (c = !c);
	            }
	            return c;
	        }
	
	        function findNearbySlice(mouseX, mouseY) {
	
	            var slices = plot.getData(),
	                options = plot.getOptions(),
	                radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius,
	                x, y;
	
	            for (var i = 0; i < slices.length; ++i) {
	
	                var s = slices[i];
	
	                if (s.pie.show) {
	
	                    ctx.save();
	                    ctx.beginPath();
	                    ctx.moveTo(0, 0); // Center of the pie
	                    //ctx.scale(1, options.series.pie.tilt);    // this actually seems to break everything when here.
	                    ctx.arc(0, 0, radius, s.startAngle, s.startAngle + s.angle / 2, false);
	                    ctx.arc(0, 0, radius, s.startAngle + s.angle / 2, s.startAngle + s.angle, false);
	                    ctx.closePath();
	                    x = mouseX - centerLeft;
	                    y = mouseY - centerTop;
	
	                    if (ctx.isPointInPath) {
	                        if (ctx.isPointInPath(mouseX - centerLeft, mouseY - centerTop)) {
	                            ctx.restore();
	                            return {
	                                datapoint: [s.percent, s.data],
	                                dataIndex: 0,
	                                series: s,
	                                seriesIndex: i
	                            };
	                        }
	                    } else {
	
	                        // excanvas for IE doesn;t support isPointInPath, this is a workaround.
	
	                        var p1X = radius * Math.cos(s.startAngle),
	                            p1Y = radius * Math.sin(s.startAngle),
	                            p2X = radius * Math.cos(s.startAngle + s.angle / 4),
	                            p2Y = radius * Math.sin(s.startAngle + s.angle / 4),
	                            p3X = radius * Math.cos(s.startAngle + s.angle / 2),
	                            p3Y = radius * Math.sin(s.startAngle + s.angle / 2),
	                            p4X = radius * Math.cos(s.startAngle + s.angle / 1.5),
	                            p4Y = radius * Math.sin(s.startAngle + s.angle / 1.5),
	                            p5X = radius * Math.cos(s.startAngle + s.angle),
	                            p5Y = radius * Math.sin(s.startAngle + s.angle),
	                            arrPoly = [[0, 0], [p1X, p1Y], [p2X, p2Y], [p3X, p3Y], [p4X, p4Y], [p5X, p5Y]],
	                            arrPoint = [x, y];
	
	                        // TODO: perhaps do some mathmatical trickery here with the Y-coordinate to compensate for pie tilt?
	
	                        if (isPointInPoly(arrPoly, arrPoint)) {
	                            ctx.restore();
	                            return {
	                                datapoint: [s.percent, s.data],
	                                dataIndex: 0,
	                                series: s,
	                                seriesIndex: i
	                            };
	                        }
	                    }
	
	                    ctx.restore();
	                }
	            }
	
	            return null;
	        }
	
	        function onMouseMove(e) {
	            triggerClickHoverEvent("plothover", e);
	        }
	
	        function onClick(e) {
	            triggerClickHoverEvent("plotclick", e);
	        }
	
	        // trigger click or hover event (they send the same parameters so we share their code)
	
	        function triggerClickHoverEvent(eventname, e) {
	
	            var offset = plot.offset(),
	                canvasX = parseInt(e.pageX - offset.left, 10),
	                canvasY = parseInt(e.pageY - offset.top, 10),
	                item = findNearbySlice(canvasX, canvasY);
	
	            if (options.grid.autoHighlight) {
	
	                // clear auto-highlights
	
	                for (var i = 0; i < highlights.length; ++i) {
	                    var h = highlights[i];
	                    if (h.auto === eventname && !(item && h.series === item.series)) {
	                        unhighlight(h.series);
	                    }
	                }
	            }
	
	            // highlight the slice
	
	            if (item) {
	                highlight(item.series, eventname);
	            }
	
	            // trigger any hover bind events
	
	            var pos = { pageX: e.pageX, pageY: e.pageY };
	            target.trigger(eventname, [pos, item]);
	        }
	
	        function highlight(s, auto) {
	            //if (typeof s == "number") {
	            //    s = series[s];
	            //}
	
	            var i = indexOfHighlight(s);
	
	            if (i === -1) {
	                highlights.push({ series: s, auto: auto });
	                plot.triggerRedrawOverlay();
	            } else if (!auto) {
	                highlights[i].auto = false;
	            }
	        }
	
	        function unhighlight(s) {
	            if (s == null) {
	                highlights = [];
	                plot.triggerRedrawOverlay();
	            }
	
	            //if (typeof s == "number") {
	            //    s = series[s];
	            //}
	
	            var i = indexOfHighlight(s);
	
	            if (i !== -1) {
	                highlights.splice(i, 1);
	                plot.triggerRedrawOverlay();
	            }
	        }
	
	        function indexOfHighlight(s) {
	            for (var i = 0; i < highlights.length; ++i) {
	                var h = highlights[i];
	                if (h.series === s) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	
	        function drawOverlay(plot, octx) {
	
	            var options = plot.getOptions(),
	                radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
	
	            octx.save();
	            octx.translate(centerLeft, centerTop);
	            octx.scale(1, options.series.pie.tilt);
	
	            for (var i = 0; i < highlights.length; ++i) {
	                drawHighlight(highlights[i].series);
	            }
	
	            drawDonutHole(octx);
	
	            octx.restore();
	
	            function drawHighlight(series) {
	
	                if (series.angle <= 0 || isNaN(series.angle)) {
	                    return;
	                }
	
	                //octx.fillStyle = parseColor(options.series.pie.highlight.color).scale(null, null, null, options.series.pie.highlight.opacity).toString();
	                octx.fillStyle = "rgba(255, 255, 255, " + options.series.pie.highlight.opacity + ")"; // this is temporary until we have access to parseColor
	                octx.beginPath();
	                if (Math.abs(series.angle - Math.PI * 2) > 0.000000001) {
	                    octx.moveTo(0, 0); // Center of the pie
	                }
	                octx.arc(0, 0, radius, series.startAngle, series.startAngle + series.angle / 2, false);
	                octx.arc(0, 0, radius, series.startAngle + series.angle / 2, series.startAngle + series.angle, false);
	                octx.closePath();
	                octx.fill();
	            }
	        }
	    } // end init (plugin body)
	
	    // define pie specific options and their default values
	
	    var options = {
	        series: {
	            pie: {
	                show: false,
	                radius: "auto",    // actual radius of the visible pie (based on full calculated radius if <=1, or hard pixel value)
	                innerRadius: 0, /* for donut */
	                startAngle: 3 / 2,
	                tilt: 1,
	                shadow: {
	                    left: 5,    // shadow left offset
	                    top: 15,    // shadow top offset
	                    alpha: 0.02    // shadow alpha
	                },
	                offset: {
	                    top: 0,
	                    left: "auto"
	                },
	                stroke: {
	                    color: "#fff",
	                    width: 1
	                },
	                label: {
	                    show: "auto",
	                    formatter: function(label, slice) {
	                        return "<div style='font-size:x-small;text-align:center;padding:2px;color:" + slice.color + ";'>" + label + "<br/>" + Math.round(slice.percent) + "%</div>";
	                    },    // formatter function
	                    radius: 1,    // radius at which to place the labels (based on full calculated radius if <=1, or hard pixel value)
	                    background: {
	                        color: null,
	                        opacity: 0
	                    },
	                    threshold: 0    // percentage at which to hide the label (i.e. the slice is too narrow)
	                },
	                combine: {
	                    threshold: -1,    // percentage at which to combine little slices into one larger slice
	                    color: null,    // color to give the new slice (auto-generated if null)
	                    label: "Other"    // label to give the new slice
	                },
	                highlight: {
	                    //color: "#fff",        // will add this functionality once parseColor is available
	                    opacity: 0.5
	                }
	            }
	        }
	    };
	
	    $.plot.plugins.push({
	        init: init,
	        options: options,
	        name: "pie",
	        version: "1.1"
	    });
	
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* Flot plugin for selecting regions of a plot.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	The plugin supports these options:
	
	selection: {
	    mode: null or "x" or "y" or "xy",
	    color: color,
	    shape: "round" or "miter" or "bevel",
	    minSize: number of pixels
	}
	
	Selection support is enabled by setting the mode to one of "x", "y" or "xy".
	In "x" mode, the user will only be able to specify the x range, similarly for
	"y" mode. For "xy", the selection becomes a rectangle where both ranges can be
	specified. "color" is color of the selection (if you need to change the color
	later on, you can get to it with plot.getOptions().selection.color). "shape"
	is the shape of the corners of the selection.
	
	"minSize" is the minimum size a selection can be in pixels. This value can
	be customized to determine the smallest size a selection can be and still
	have the selection rectangle be displayed. When customizing this value, the
	fact that it refers to pixels, not axis units must be taken into account.
	Thus, for example, if there is a bar graph in time mode with BarWidth set to 1
	minute, setting "minSize" to 1 will not make the minimum selection size 1
	minute, but rather 1 pixel. Note also that setting "minSize" to 0 will prevent
	"plotunselected" events from being fired when the user clicks the mouse without
	dragging.
	
	When selection support is enabled, a "plotselected" event will be emitted on
	the DOM element you passed into the plot function. The event handler gets a
	parameter with the ranges selected on the axes, like this:
	
	    placeholder.bind( "plotselected", function( event, ranges ) {
	        alert("You selected " + ranges.xaxis.from + " to " + ranges.xaxis.to)
	        // similar for yaxis - with multiple axes, the extra ones are in
	        // x2axis, x3axis, ...
	    });
	
	The "plotselected" event is only fired when the user has finished making the
	selection. A "plotselecting" event is fired during the process with the same
	parameters as the "plotselected" event, in case you want to know what's
	happening while it's happening,
	
	A "plotunselected" event with no arguments is emitted when the user clicks the
	mouse to remove the selection. As stated above, setting "minSize" to 0 will
	destroy this behavior.
	
	The plugin allso adds the following methods to the plot object:
	
	- setSelection( ranges, preventEvent )
	
	  Set the selection rectangle. The passed in ranges is on the same form as
	  returned in the "plotselected" event. If the selection mode is "x", you
	  should put in either an xaxis range, if the mode is "y" you need to put in
	  an yaxis range and both xaxis and yaxis if the selection mode is "xy", like
	  this:
	
	    setSelection({ xaxis: { from: 0, to: 10 }, yaxis: { from: 40, to: 60 } });
	
	  setSelection will trigger the "plotselected" event when called. If you don't
	  want that to happen, e.g. if you're inside a "plotselected" handler, pass
	  true as the second parameter. If you are using multiple axes, you can
	  specify the ranges on any of those, e.g. as x2axis/x3axis/... instead of
	  xaxis, the plugin picks the first one it sees.
	
	- clearSelection( preventEvent )
	
	  Clear the selection rectangle. Pass in true to avoid getting a
	  "plotunselected" event.
	
	- getSelection()
	
	  Returns the current selection in the same format as the "plotselected"
	  event. If there's currently no selection, the function returns null.
	
	*/
	
	(function($) {
	    function init(plot) {
	
	        var selection = {
	                first: { x: -1, y: -1 },
	                second: { x: -1, y: -1 },
	                show: false,
	                active: false,
	                touch: false
	            },
	
	            // FIXME: The drag handling implemented here should be
	            // abstracted out, there's some similar code from a library in
	            // the navigation plugin, this should be massaged a bit to fit
	            // the Flot cases here better and reused. Doing this would
	            // make this plugin much slimmer.
	
	            savedhandlers = {},
	            mouseUpHandler = null;
	
	        function onMouseMove(e) {
	            if (selection.active) {
	                updateSelection(e);
	                plot.getPlaceholder().trigger("plotselecting", [getSelection()]);
	
	                // prevent the default action if it is a 'touch' action
	                if (selection.touch === true) {
	                    e.preventDefault();
	                }
	            }
	        }
	
	        function onMouseDown(e) {
	            if (e.type === "touchstart" && e.originalEvent.touches.length === 1) { // only accept single touch
	                selection.touch = true;
	            } else if (e.which !== 1 || e.originalEvent.touches && e.originalEvent.touches.length > 1) { // only accept left-click
	                return;
	            }
	
	            // cancel out any text selections
	            document.body.focus();
	
	            // prevent text selection and drag in old-school browsers
	            if (document.onselectstart !== undefined && savedhandlers.onselectstart === null) {
	                savedhandlers.onselectstart = document.onselectstart;
	                document.onselectstart = function() { return false; };
	            }
	            if (document.ondrag !== undefined && savedhandlers.ondrag === null) {
	                savedhandlers.ondrag = document.ondrag;
	                document.ondrag = function() { return false; };
	            }
	
	            setSelectionPos(selection.first, e);
	
	            selection.active = true;
	
	            // this is a bit silly, but we have to use a closure to be
	            // able to whack the same handler again
	            mouseUpHandler = function(e) { onMouseUp(e); };
	
	            $(document).one(selection.touch ? "touchend" : "mouseup", mouseUpHandler);
	        }
	
	        function onMouseUp(e) {
	            mouseUpHandler = null;
	
	            // revert drag stuff for old-school browsers
	            if (document.onselectstart !== undefined) {
	                document.onselectstart = savedhandlers.onselectstart;
	            }
	            if (document.ondrag !== undefined) {
	                document.ondrag = savedhandlers.ondrag;
	            }
	
	            // no more dragging
	            selection.active = false;
	            updateSelection(e);
	
	            if (selectionIsSane()) {
	                triggerSelectedEvent();
	            } else {
	                // this counts as a clear
	                plot.getPlaceholder().trigger("plotunselected", []);
	                plot.getPlaceholder().trigger("plotselecting", [null]);
	            }
	
	            selection.touch = false;
	            return false;
	        }
	
	        function getSelection() {
	
	            if (!selectionIsSane() || !selection.show) {
	                return null;
	            }
	
	            var r = {},
	                c1 = selection.first,
	                c2 = selection.second;
	
	            $.each(plot.getAxes(), function(name, axis) {
	                if (axis.used) {
	                    var p1 = axis.c2p(c1[axis.direction]),
	                        p2 = axis.c2p(c2[axis.direction]);
	                    r[name] = { from: Math.min(p1, p2), to: Math.max(p1, p2) };
	                }
	            });
	            return r;
	        }
	
	        function triggerSelectedEvent() {
	            var r = getSelection();
	
	            plot.getPlaceholder().trigger("plotselected", [r]);
	
	            // backwards-compat stuff, to be removed in future
	            if (r.xaxis && r.yaxis) {
	                plot.getPlaceholder().trigger("selected", [{ x1: r.xaxis.from, y1: r.yaxis.from, x2: r.xaxis.to, y2: r.yaxis.to }]);
	            }
	        }
	
	        function clamp(min, value, max) {
	            return value < min ? min: (value > max ? max: value);
	        }
	
	        function setSelectionPos(pos, e) {
	            var o = plot.getOptions(),
	                offset = plot.getPlaceholder().offset(),
	                plotOffset = plot.getPlotOffset(),
	                coordHolder = selection.touch ? e.originalEvent.changedTouches[0] : e;
	
	            pos.x = clamp(0, coordHolder.pageX - offset.left - plotOffset.left, plot.width());
	            pos.y = clamp(0, coordHolder.pageY - offset.top - plotOffset.top, plot.height());
	
	            if (o.selection.mode === "y") {
	                pos.x = pos === selection.first ? 0 : plot.width();
	            }
	
	            if (o.selection.mode === "x") {
	                pos.y = pos === selection.first ? 0 : plot.height();
	            }
	        }
	
	        function updateSelection(pos) {
	            var coordHolder = selection.touch ? pos.originalEvent.changedTouches[0] : pos;
	            if (coordHolder.pageX === null) {
	                return;
	            }
	
	            setSelectionPos(selection.second, pos);
	            if (selectionIsSane()) {
	                selection.show = true;
	                plot.triggerRedrawOverlay();
	            } else {
	                clearSelection(true);
	            }
	        }
	
	        function clearSelection(preventEvent) {
	            if (selection.show) {
	                selection.show = false;
	                plot.triggerRedrawOverlay();
	                if (!preventEvent) {
	                    plot.getPlaceholder().trigger("plotunselected", []);
	                }
	            }
	        }
	
	        // function taken from markings support in Flot
	        function extractRange(ranges, coord) {
	            var axis, from, to, key, axes = plot.getAxes();
	
	            for (var k in axes) {
	                if (Object.prototype.hasOwnProperty.call(axes, k)) {
	                    axis = axes[k];
	                    if (axis.direction === coord) {
	                        key = coord + axis.n + "axis";
	                        if (!ranges[key] && axis.n === 1) {
	                            key = coord + "axis"; // support x1axis as xaxis
	                        }
	                        if (ranges[key]) {
	                            from = ranges[key].from;
	                            to = ranges[key].to;
	                            break;
	                        }
	                    }
	                }
	            }
	
	            // backwards-compat stuff - to be removed in future
	            if (!ranges[key]) {
	                axis = coord === "x" ? plot.getXAxes()[0] : plot.getYAxes()[0];
	                from = ranges[coord + "1"];
	                to = ranges[coord + "2"];
	            }
	
	            // auto-reverse as an added bonus
	            if (from != null && to != null && from > to) {
	                var tmp = from;
	                from = to;
	                to = tmp;
	            }
	
	            return { from: from, to: to, axis: axis };
	        }
	
	        function setSelection(ranges, preventEvent) {
	            var range, o = plot.getOptions();
	
	            if (o.selection.mode === "y") {
	                selection.first.x = 0;
	                selection.second.x = plot.width();
	            } else {
	                range = extractRange(ranges, "x");
	                selection.first.x = range.axis.p2c(range.from);
	                selection.second.x = range.axis.p2c(range.to);
	            }
	
	            if (o.selection.mode === "x") {
	                selection.first.y = 0;
	                selection.second.y = plot.height();
	            } else {
	                range = extractRange(ranges, "y");
	                selection.first.y = range.axis.p2c(range.from);
	                selection.second.y = range.axis.p2c(range.to);
	            }
	
	            selection.show = true;
	            plot.triggerRedrawOverlay();
	            if (!preventEvent && selectionIsSane()) {
	                triggerSelectedEvent();
	            }
	        }
	
	        function selectionIsSane() {
	            var minSize = plot.getOptions().selection.minSize;
	            return Math.abs(selection.second.x - selection.first.x) >= minSize &&
	                Math.abs(selection.second.y - selection.first.y) >= minSize;
	        }
	
	        plot.clearSelection = clearSelection;
	        plot.setSelection = setSelection;
	        plot.getSelection = getSelection;
	
	        plot.hooks.bindEvents.push(function(plot, eventHolder) {
	            var o = plot.getOptions();
	            if (o.selection.mode != null) {
	                eventHolder.mousemove(onMouseMove);
	                eventHolder.mousedown(onMouseDown);
	                eventHolder.bind("touchstart", function(e) {
	                    // Using a touch device, disable mouse events to prevent
	                    // event handlers being called twice
	                    eventHolder.unbind("mousedown", onMouseDown);
	                    onMouseDown(e);
	                });
	                eventHolder.bind("touchmove", onMouseMove);
	            }
	        });
	
	        plot.hooks.drawOverlay.push(function(plot, ctx) {
	            // draw selection
	            if (selection.show && selectionIsSane()) {
	                var plotOffset = plot.getPlotOffset(),
	                    o = plot.getOptions(),
	                    c, x, y, w, h;
	
	                ctx.save();
	                ctx.translate(plotOffset.left, plotOffset.top);
	
	                c = $.color.parse(o.selection.color);
	
	                ctx.strokeStyle = c.scale("a", 0.8).toString();
	                ctx.lineWidth = 1;
	                ctx.lineJoin = o.selection.shape;
	                ctx.fillStyle = c.scale("a", 0.4).toString();
	
	                x = Math.min(selection.first.x, selection.second.x) + 0.5;
	                y = Math.min(selection.first.y, selection.second.y) + 0.5;
	                w = Math.abs(selection.second.x - selection.first.x) - 1;
	                h = Math.abs(selection.second.y - selection.first.y) - 1;
	
	                ctx.fillRect(x, y, w, h);
	                ctx.strokeRect(x, y, w, h);
	
	                ctx.restore();
	            }
	        });
	
	        plot.hooks.shutdown.push(function(plot, eventHolder) {
	            eventHolder.unbind("mousemove", onMouseMove);
	            eventHolder.unbind("mousedown", onMouseDown);
	            if (mouseUpHandler) {
	                $(document).unbind("mouseup", mouseUpHandler);
	            }
	        });
	
	    }
	
	    $.plot.plugins.push({
	        init: init,
	        options: {
	            selection: {
	                mode: null, // one of null, "x", "y" or "xy"
	                color: "#e8cfac",
	                shape: "round", // one of "round", "miter", or "bevel"
	                minSize: 5 // minimum number of pixels
	            }
	        },
	        name: "selection",
	        version: "1.1"
	    });
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* Flot plugin for stacking data sets rather than overlyaing them.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	The plugin assumes the data is sorted on x (or y if stacking horizontally).
	For line charts, it is assumed that if a line has an undefined gap (from a
	null point), then the line above it should have the same gap - insert zeros
	instead of "null" if you want another behaviour. This also holds for the start
	and end of the chart. Note that stacking a mix of positive and negative values
	in most instances doesn't make sense (so it looks weird).
	
	Two or more series are stacked when their "stack" attribute is set to the same
	key (which can be any number or string or just "true"). To specify the default
	stack, you can set the stack option like this:
	
	    series: {
	        stack: null/false, true, or a key (number/string)
	    }
	
	You can also specify it for a single series, like this:
	
	    $.plot( $("#placeholder"), [{
	        data: [ ... ],
	        stack: true
	    }])
	
	The stacking order is determined by the order of the data series in the array
	(later series end up on top of the previous).
	
	Internally, the plugin modifies the datapoints in each series, adding an
	offset to the y value. For line series, extra data points are inserted through
	interpolation. If there's a second y value, it's also adjusted (e.g for bar
	charts or filled areas).
	
	*/
	
	(function($) {
	    var options = {
	        series: { stack: null } // or number/string
	    };
	
	    function init(plot) {
	        function findMatchingSeries(s, allseries) {
	            var res = null;
	            for (var i = 0; i < allseries.length; ++i) {
	                if (s === allseries[i]) {
	                    break;
	                }
	
	                if (allseries[i].stack === s.stack) {
	                    res = allseries[i];
	                }
	            }
	
	            return res;
	        }
	
	        function stackData(plot, s, datapoints) {
	            if (s.stack == null || s.stack === false) {
	                return;
	            }
	
	            var other = findMatchingSeries(s, plot.getData());
	            if (!other) {
	                return;
	            }
	
	            var ps = datapoints.pointsize,
	                points = datapoints.points,
	                otherps = other.datapoints.pointsize,
	                otherpoints = other.datapoints.points,
	                newpoints = [],
	                px, py, intery, qx, qy, bottom,
	                withlines = s.lines.show,
	                horizontal = s.bars.horizontal,
	                withbottom = ps > 2 && (horizontal ? datapoints.format[2].x : datapoints.format[2].y),
	                fromgap = true,
	                keyOffset = horizontal ? 1 : 0,
	                accumulateOffset = horizontal ? 0 : 1,
	                i = 0, j = 0, l, m;
	
	            while (true) {
	                if (i >= points.length) {
	                    break;
	                }
	
	                l = newpoints.length;
	
	                if (points[i] == null) {
	                    // copy gaps
	                    for (m = 0; m < ps; ++m) {
	                        newpoints.push(points[i + m]);
	                    }
	                    i += ps;
	                } else if (j >= otherpoints.length) {
	                    // for lines, we can't use the rest of the points
	                    if (!withlines) {
	                        for (m = 0; m < ps; ++m) {
	                            newpoints.push(points[i + m]);
	                        }
	                    }
	                    i += ps;
	                } else if (otherpoints[j] == null) {
	                    // oops, got a gap
	                    for (m = 0; m < ps; ++m) {
	                        newpoints.push(null);
	                    }
	                    fromgap = true;
	                    j += otherps;
	                } else {
	                    // cases where we actually got two points
	                    px = points[i + keyOffset];
	                    py = points[i + accumulateOffset];
	                    qx = otherpoints[j + keyOffset];
	                    qy = otherpoints[j + accumulateOffset];
	                    bottom = 0;
	
	                    if (px === qx) {
	                        for (m = 0; m < ps; ++m) {
	                            newpoints.push(points[i + m]);
	                        }
	
	                        newpoints[l + accumulateOffset] += qy;
	                        bottom = qy;
	
	                        i += ps;
	                        j += otherps;
	                    } else if (px > qx) {
	                        // we got past point below, might need to
	                        // insert interpolated extra point
	                        if (withlines && i > 0 && points[i - ps] != null) {
	                            intery = py + (points[i - ps + accumulateOffset] - py) * (qx - px) / (points[i - ps + keyOffset] - px);
	                            newpoints.push(qx);
	                            newpoints.push(intery + qy);
	                            for (m = 2; m < ps; ++m) {
	                                newpoints.push(points[i + m]);
	                            }
	                            bottom = qy;
	                        }
	
	                        j += otherps;
	                    } else { // px < qx
	                        if (fromgap && withlines) {
	                            // if we come from a gap, we just skip this point
	                            i += ps;
	                            continue;
	                        }
	
	                        for (m = 0; m < ps; ++m) {
	                            newpoints.push(points[i + m]);
	                        }
	
	                        // we might be able to interpolate a point below,
	                        // this can give us a better y
	                        if (withlines && j > 0 && otherpoints[j - otherps] != null) {
	                            bottom = qy + (otherpoints[j - otherps + accumulateOffset] - qy) * (px - qx) / (otherpoints[j - otherps + keyOffset] - qx);
	                        }
	
	                        newpoints[l + accumulateOffset] += bottom;
	
	                        i += ps;
	                    }
	
	                    fromgap = false;
	
	                    if (l !== newpoints.length && withbottom) {
	                        newpoints[l + 2] += bottom;
	                    }
	                }
	            }
	
	            datapoints.points = newpoints;
	        }
	
	        plot.hooks.processDatapoints.push(stackData);
	    }
	
	    $.plot.plugins.push({
	        init: init,
	        options: options,
	        name: "stack",
	        version: "1.2"
	    });
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* Pretty handling of time axes.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	Set axis.mode to "time" to enable. See the section "Time series data" in
	API.txt for details.
	
	*/
	
	(function($) {
	
	    var options = {
	        xaxis: {
	            timezone: null,        // "browser" for local to the client or timezone for timezone-js
	            timeformat: null,    // format string to use
	            twelveHourClock: false,    // 12 or 24 time in time mode
	            monthNames: null    // list of names of months
	        }
	    };
	
	    // round to nearby lower multiple of base
	
	    function floorInBase(n, base) {
	        return base * Math.floor(n / base);
	    }
	
	    // Returns a string with the date d formatted according to fmt.
	    // A subset of the Open Group's strftime format is supported.
	
	    function formatDate(d, fmt, monthNames, dayNames) {
	
	        if ($.isFunction(d.strftime)) {
	            return d.strftime(fmt);
	        }
	
	        var leftPad = function(n, pad) {
	                n = "" + n;
	                pad = "" + (pad == null ? "0" : pad);
	                return n.length === 1 ? pad + n : n;
	            },
	            r = [],
	            escape = false,
	            hours = d.getHours(),
	            isAM = hours < 12,
	            c, hours12;
	
	        if (monthNames == null) {
	            monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	        }
	
	        if (dayNames == null) {
	            dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	        }
	
	        if (hours > 12) {
	            hours12 = hours - 12;
	        } else if (hours === 0) {
	            hours12 = 12;
	        } else {
	            hours12 = hours;
	        }
	
	        for (var i = 0; i < fmt.length; ++i) {
	
	            c = fmt.charAt(i);
	
	            if (escape) {
	                switch (c) {
	                case "a":
	                    c = "" + dayNames[d.getDay()];
	                    break;
	                case "b":
	                    c = "" + monthNames[d.getMonth()];
	                    break;
	                case "d":
	                    c = leftPad(d.getDate());
	                    break;
	                case "e":
	                    c = leftPad(d.getDate(), " ");
	                    break;
	                case "h": // For back-compat with 0.7; remove in 1.0
	                case "H":
	                    c = leftPad(hours);
	                    break;
	                case "I":
	                    c = leftPad(hours12);
	                    break;
	                case "l":
	                    c = leftPad(hours12, " ");
	                    break;
	                case "m":
	                    c = leftPad(d.getMonth() + 1);
	                    break;
	                case "M":
	                    c = leftPad(d.getMinutes());
	                    break;
	                // quarters not in Open Group's strftime specification
	                case "q":
	                    c = "" + (Math.floor(d.getMonth() / 3) + 1);
	                    break;
	                case "S":
	                    c = leftPad(d.getSeconds());
	                    break;
	                case "y":
	                    c = leftPad(d.getFullYear() % 100);
	                    break;
	                case "Y":
	                    c = "" + d.getFullYear();
	                    break;
	                case "p":
	                    c = (isAM) ? ("" + "am") : ("" + "pm");
	                    break;
	                case "P":
	                    c = (isAM) ? ("" + "AM") : ("" + "PM");
	                    break;
	                case "w":
	                    c = "" + d.getDay();
	                    break;
	                }
	                r.push(c);
	                escape = false;
	            } else {
	                if (c === "%") {
	                    escape = true;
	                } else {
	                    r.push(c);
	                }
	            }
	        }
	
	        return r.join("");
	    }
	
	    // To have a consistent view of time-based data independent of which time
	    // zone the client happens to be in we need a date-like object independent
	    // of time zones.  This is done through a wrapper that only calls the UTC
	    // versions of the accessor methods.
	
	    function makeUtcWrapper(d) {
	
	        function addProxyMethod(sourceObj, sourceMethod, targetObj, targetMethod) {
	            sourceObj[sourceMethod] = function() {
	                return targetObj[targetMethod].apply(targetObj, arguments);
	            };
	        }
	
	        var utc = {
	            date: d
	        };
	
	        // support strftime, if found
	
	        if (d.strftime !== undefined) {
	            addProxyMethod(utc, "strftime", d, "strftime");
	        }
	
	        addProxyMethod(utc, "getTime", d, "getTime");
	        addProxyMethod(utc, "setTime", d, "setTime");
	
	        var props = ["Date", "Day", "FullYear", "Hours", "Milliseconds", "Minutes", "Month", "Seconds"];
	
	        for (var p = 0; p < props.length; p++) {
	            addProxyMethod(utc, "get" + props[p], d, "getUTC" + props[p]);
	            addProxyMethod(utc, "set" + props[p], d, "setUTC" + props[p]);
	        }
	
	        return utc;
	    }
	
	    // select time zone strategy.  This returns a date-like object tied to the
	    // desired timezone
	
	    function dateGenerator(ts, opts) {
	        if (opts.timezone === "browser") {
	            return new Date(ts);
	        } else if (!opts.timezone || opts.timezone === "utc") {
	            return makeUtcWrapper(new Date(ts));
	        } else if (typeof timezoneJS !== "undefined" && typeof timezoneJS.Date !== "undefined") {
	            var d = new timezoneJS.Date();
	            // timezone-js is fickle, so be sure to set the time zone before
	            // setting the time.
	            d.setTimezone(opts.timezone);
	            d.setTime(ts);
	            return d;
	        } else {
	            return makeUtcWrapper(new Date(ts));
	        }
	    }
	
	    // map of app. size of time units in milliseconds
	
	    var timeUnitSize = {
	            "second": 1000,
	            "minute": 60 * 1000,
	            "hour": 60 * 60 * 1000,
	            "day": 24 * 60 * 60 * 1000,
	            "month": 30 * 24 * 60 * 60 * 1000,
	            "quarter": 3 * 30 * 24 * 60 * 60 * 1000,
	            "year": 365.2425 * 24 * 60 * 60 * 1000
	        },
	
	        // the allowed tick sizes, after 1 year we use
	        // an integer algorithm
	
	        baseSpec = [
	            [1, "second"], [2, "second"], [5, "second"], [10, "second"],
	            [30, "second"],
	            [1, "minute"], [2, "minute"], [5, "minute"], [10, "minute"],
	            [30, "minute"],
	            [1, "hour"], [2, "hour"], [4, "hour"],
	            [8, "hour"], [12, "hour"],
	            [1, "day"], [2, "day"], [3, "day"],
	            [0.25, "month"], [0.5, "month"], [1, "month"],
	            [2, "month"]
	        ],
	
	        // we don't know which variant(s) we'll need yet, but generating both is
	        // cheap
	
	        specMonths = baseSpec.concat([
	            [3, "month"],
	            [6, "month"],
	            [1, "year"]
	        ]),
	        specQuarters = baseSpec.concat([
	            [1, "quarter"],
	            [2, "quarter"],
	            [1, "year"]
	        ]);
	
	    function init(plot) {
	        plot.hooks.processOptions.push(function(plot) {
	            $.each(plot.getAxes(), function(axisName, axis) {
	
	                var opts = axis.options;
	
	                if (opts.mode === "time") {
	                    axis.tickGenerator = function(axis) {
	
	                        var ticks = [],
	                            d = dateGenerator(axis.min, opts),
	                            minSize = 0,
	
	                            // make quarter use a possibility if quarters are
	                            // mentioned in either of these options
	
	                            spec = (opts.tickSize && opts.tickSize[1] ===
	                            "quarter") ||
	                            (opts.minTickSize && opts.minTickSize[1] ===
	                            "quarter") ? specQuarters : specMonths;
	
	                        if (opts.minTickSize != null) {
	                            if (typeof opts.tickSize === "number") {
	                                minSize = opts.tickSize;
	                            } else {
	                                minSize = opts.minTickSize[0] * timeUnitSize[opts.minTickSize[1]];
	                            }
	                        }
	
	                        for (var i = 0; i < spec.length - 1; ++i) {
	                            if (axis.delta < (spec[i][0] * timeUnitSize[spec[i][1]] +
	                                spec[i + 1][0] * timeUnitSize[spec[i + 1][1]]) / 2 &&
	                                spec[i][0] * timeUnitSize[spec[i][1]] >= minSize) {
	                                break;
	                            }
	                        }
	
	                        var size = spec[i][0],
	                            unit = spec[i][1];
	
	                        // special-case the possibility of several years
	
	                        if (unit === "year") {
	
	                            // if given a minTickSize in years, just use it,
	                            // ensuring that it's an integer
	
	                            if (opts.minTickSize != null && opts.minTickSize[1] === "year") {
	                                size = Math.floor(opts.minTickSize[0]);
	                            } else {
	
	                                var magn = Math.pow(10, Math.floor(Math.log(axis.delta / timeUnitSize.year) / Math.LN10)),
	                                    norm = (axis.delta / timeUnitSize.year) / magn;
	
	                                if (norm < 1.5) {
	                                    size = 1;
	                                } else if (norm < 3) {
	                                    size = 2;
	                                } else if (norm < 7.5) {
	                                    size = 5;
	                                } else {
	                                    size = 10;
	                                }
	
	                                size *= magn;
	                            }
	
	                            // minimum size for years is 1
	
	                            if (size < 1) {
	                                size = 1;
	                            }
	                        }
	
	                        axis.tickSize = opts.tickSize || [size, unit];
	                        var tickSize = axis.tickSize[0];
	                        unit = axis.tickSize[1];
	
	                        var step = tickSize * timeUnitSize[unit];
	
	                        if (unit === "second") {
	                            d.setSeconds(floorInBase(d.getSeconds(), tickSize));
	                        } else if (unit === "minute") {
	                            d.setMinutes(floorInBase(d.getMinutes(), tickSize));
	                        } else if (unit === "hour") {
	                            d.setHours(floorInBase(d.getHours(), tickSize));
	                        } else if (unit === "month") {
	                            d.setMonth(floorInBase(d.getMonth(), tickSize));
	                        } else if (unit === "quarter") {
	                            d.setMonth(3 * floorInBase(d.getMonth() / 3,
	                                tickSize));
	                        } else if (unit === "year") {
	                            d.setFullYear(floorInBase(d.getFullYear(), tickSize));
	                        }
	
	                        // reset smaller components
	
	                        d.setMilliseconds(0);
	
	                        if (step >= timeUnitSize.minute) {
	                            d.setSeconds(0);
	                        }
	                        if (step >= timeUnitSize.hour) {
	                            d.setMinutes(0);
	                        }
	                        if (step >= timeUnitSize.day) {
	                            d.setHours(0);
	                        }
	                        if (step >= timeUnitSize.day * 4) {
	                            d.setDate(1);
	                        }
	                        if (step >= timeUnitSize.month * 2) {
	                            d.setMonth(floorInBase(d.getMonth(), 3));
	                        }
	                        if (step >= timeUnitSize.quarter * 2) {
	                            d.setMonth(floorInBase(d.getMonth(), 6));
	                        }
	                        if (step >= timeUnitSize.year) {
	                            d.setMonth(0);
	                        }
	
	                        var carry = 0,
	                            v = Number.NaN,
	                            prev;
	
	                        do {
	
	                            prev = v;
	                            v = d.getTime();
	                            ticks.push(v);
	
	                            if (unit === "month" || unit === "quarter") {
	                                if (tickSize < 1) {
	
	                                    // a bit complicated - we'll divide the
	                                    // month/quarter up but we need to take
	                                    // care of fractions so we don't end up in
	                                    // the middle of a day
	
	                                    d.setDate(1);
	                                    var start = d.getTime();
	                                    d.setMonth(d.getMonth() + (unit === "quarter" ? 3 : 1));
	                                    var end = d.getTime();
	                                    d.setTime(v + carry * timeUnitSize.hour + (end - start) * tickSize);
	                                    carry = d.getHours();
	                                    d.setHours(0);
	                                } else {
	                                    d.setMonth(d.getMonth() +
	                                        tickSize * (unit === "quarter" ? 3 : 1));
	                                }
	                            } else if (unit === "year") {
	                                d.setFullYear(d.getFullYear() + tickSize);
	                            } else {
	                                d.setTime(v + step);
	                            }
	                        } while (v < axis.max && v !== prev);
	
	                        return ticks;
	                    };
	
	                    axis.tickFormatter = function(v, axis) {
	
	                        var d = dateGenerator(v, axis.options);
	
	                        // first check global format
	
	                        if (opts.timeformat != null) {
	                            return formatDate(d, opts.timeformat, opts.monthNames, opts.dayNames);
	                        }
	
	                        // possibly use quarters if quarters are mentioned in
	                        // any of these places
	
	                        var useQuarters = (axis.options.tickSize &&
	                                axis.options.tickSize[1] === "quarter") ||
	                                (axis.options.minTickSize &&
	                                axis.options.minTickSize[1] === "quarter"),
	                            t = axis.tickSize[0] * timeUnitSize[axis.tickSize[1]],
	                            span = axis.max - axis.min,
	                            suffix = (opts.twelveHourClock) ? " %p" : "",
	                            hourCode = (opts.twelveHourClock) ? "%I" : "%H",
	                            fmt;
	
	                        if (t < timeUnitSize.minute) {
	                            fmt = hourCode + ":%M:%S" + suffix;
	                        } else if (t < timeUnitSize.day) {
	                            if (span < 2 * timeUnitSize.day) {
	                                fmt = hourCode + ":%M" + suffix;
	                            } else {
	                                fmt = "%b %d " + hourCode + ":%M" + suffix;
	                            }
	                        } else if (t < timeUnitSize.month) {
	                            fmt = "%b %d";
	                        } else if ((useQuarters && t < timeUnitSize.quarter) ||
	                            (!useQuarters && t < timeUnitSize.year)) {
	                            if (span < timeUnitSize.year) {
	                                fmt = "%b";
	                            } else {
	                                fmt = "%b %Y";
	                            }
	                        } else if (useQuarters && t < timeUnitSize.year) {
	                            if (span < timeUnitSize.year) {
	                                fmt = "Q%q";
	                            } else {
	                                fmt = "Q%q %Y";
	                            }
	                        } else {
	                            fmt = "%Y";
	                        }
	
	                        var rt = formatDate(d, fmt, opts.monthNames, opts.dayNames);
	
	                        return rt;
	                    };
	                }
	            });
	        });
	    }
	
	    $.plot.plugins.push({
	        init: init,
	        options: options,
	        name: "time",
	        version: "1.0"
	    });
	
	    // Time-axis support used to be in Flot core, which exposed the
	    // formatDate function on the plot object.  Various plugins depend
	    // on the function, so we need to re-expose it here.
	
	    $.plot.formatDate = formatDate;
	
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	/**
	 * Check if argument is a HTML element.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.node = function(value) {
	    return value !== undefined
	        && value instanceof HTMLElement
	        && value.nodeType === 1;
	};
	
	/**
	 * Check if argument is a list of HTML elements.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.nodeList = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return value !== undefined
	        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
	        && ('length' in value)
	        && (value.length === 0 || exports.node(value[0]));
	};
	
	/**
	 * Check if argument is a string.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.string = function(value) {
	    return typeof value === 'string'
	        || value instanceof String;
	};
	
	/**
	 * Check if argument is a function.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.fn = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return type === '[object Function]';
	};


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	var http = __webpack_require__(259);
	
	var https = module.exports;
	
	for (var key in http) {
	    if (http.hasOwnProperty(key)) https[key] = http[key];
	};
	
	https.request = function (params, cb) {
	    if (!params) params = {};
	    params.scheme = 'https';
	    params.protocol = 'https:';
	    return http.request.call(this, params, cb);
	}


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = __webpack_require__(882);
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = __webpack_require__(883);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(884);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(191);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(319);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _prefixProps = __webpack_require__(872);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _position = __webpack_require__(868);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(862);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = __webpack_require__(871);
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = __webpack_require__(866);
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = __webpack_require__(863);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(869);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(867);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(870);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(864);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(865);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return (0, _sortPrefixedStyle2.default)(styles);
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(53);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(53);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(53);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(53);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = __webpack_require__(53);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(53);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = __webpack_require__(53);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function position(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(53);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(316);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _unprefixProperty = __webpack_require__(886);
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = __webpack_require__(53);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
	module.exports = exports["default"];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(130);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(192);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(130);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 875 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(130);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(192);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(130);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(316);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(191);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(192);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(318);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(318);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(191);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(319);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = __webpack_require__(879);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(873);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(874);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(875);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(880);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(878);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(881);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(876);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(877);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = __webpack_require__(647);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie: [['msie']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	var browserByInfo = function browserByInfo(info) {
	  if (info.firefox) {
	    return 'firefox';
	  }
	  var name = '';
	
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  return name;
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  info.browser = browserByInfo(info);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	  info.osversion = parseFloat(info.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (info.browser === 'ios_saf' && info.version > info.osversion) {
	    info.version = info.osversion;
	    info.safari = true;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/**@license
	 *       __ _____                     ________                              __
	 *      / // _  /__ __ _____ ___ __ _/__  ___/__ ___ ______ __ __  __ ___  / /
	 *  __ / // // // // // _  // _// // / / // _  // _//     // //  \/ // _ \/ /
	 * /  / // // // // // ___// / / // / / // ___// / / / / // // /\  // // / /__
	 * \___//____ \\___//____//_/ _\_  / /_//____//_/ /_/ /_//_//_/ /_/ \__\_\___/
	 *           \/              /____/                              version 1.23.2
	 *
	 * This file is part of jQuery Terminal. http://terminal.jcubic.pl
	 *
	 * Copyright (c) 2010-2018 Jakub Jankiewicz <http://jcubic.pl/me>
	 * Released under the MIT license
	 *
	 * Contains:
	 *
	 * Storage plugin Distributed under the MIT License
	 * modified to work from Data URIs that block storage and cookies in Chrome
	 * Copyright (c) 2010 Dave Schindler
	 *
	 * jQuery Timers licenced with the WTFPL
	 * <http://jquery.offput.ca/timers/>
	 *
	 * Cross-Browser Split 1.1.1
	 * Copyright 2007-2012 Steven Levithan <stevenlevithan.com>
	 * Available under the MIT License
	 *
	 * jQuery Caret
	 * Copyright (c) 2009, Gideon Sireling
	 * 3 clause BSD License
	 *
	 * sprintf.js
	 * Copyright (c) 2007-2013 Alexandru Marasteanu <hello at alexei dot ro>
	 * licensed under 3 clause BSD license
	 *
	 * emoji regex v7.0.1 by Mathias Bynens
	 * MIT license
	 *
	 * Date: Tue, 18 Sep 2018 14:16:35 +0000
	 */
	(function(e){var m=function(){if(!m.cache.hasOwnProperty(arguments[0])){m.cache[arguments[0]]=m.parse(arguments[0])}return m.format.call(null,m.cache[arguments[0]],arguments)};m.format=function(e,t){var n=1,r=e.length,i="",o,a=[],u,s,l,f,c,p;for(u=0;u<r;u++){i=D(e[u]);if(i==="string"){a.push(e[u])}else if(i==="array"){l=e[u];if(l[2]){o=t[n];for(s=0;s<l[2].length;s++){if(!o.hasOwnProperty(l[2][s])){throw m('[sprintf] property "%s" does not exist',l[2][s])}o=o[l[2][s]]}}else if(l[1]){o=t[l[1]]}else{o=t[n++]}if(/[^s]/.test(l[8])&&D(o)!=="number"){throw m("[sprintf] expecting number but found %s",D(o))}switch(l[8]){case"b":o=o.toString(2);break;case"c":o=String.fromCharCode(o);break;case"d":o=parseInt(o,10);break;case"e":o=l[7]?o.toExponential(l[7]):o.toExponential();break;case"f":o=l[7]?parseFloat(o).toFixed(l[7]):parseFloat(o);break;case"o":o=o.toString(8);break;case"s":o=(o=String(o))&&l[7]?o.substring(0,l[7]):o;break;case"u":o=o>>>0;break;case"x":o=o.toString(16);break;case"X":o=o.toString(16).toUpperCase();break}o=/[def]/.test(l[8])&&l[3]&&o>=0?" +"+o:o;c=l[4]?l[4]==="0"?"0":l[4].charAt(1):" ";p=l[6]-String(o).length;f=l[6]?d(c,p):"";a.push(l[5]?o+f:f+o)}}return a.join("")};m.cache={};m.parse=function(e){var t=e,n=[],r=[],i=0;while(t){if((n=/^[^\x25]+/.exec(t))!==null){r.push(n[0])}else if((n=/^\x25{2}/.exec(t))!==null){r.push("%")}else if((n=/^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(t))!==null){if(n[2]){i|=1;var o=[],a=n[2],u=[];if((u=/^([a-z_][a-z_\d]*)/i.exec(a))!==null){o.push(u[1]);while((a=a.substring(u[0].length))!==""){if((u=/^\.([a-z_][a-z_\d]*)/i.exec(a))!==null){o.push(u[1])}else if((u=/^\[(\d+)\]/.exec(a))!==null){o.push(u[1])}else{throw"[sprintf] huh?"}}}else{throw"[sprintf] huh?"}n[2]=o}else{i|=2}if(i===3){throw"[sprintf] mixing positional and named placeholders is not (yet) supported"}r.push(n)}else{throw"[sprintf] huh?"}t=t.substring(n[0].length)}return r};var t=function(e,t,n){n=t.slice(0);n.splice(0,0,e);return m.apply(null,n)};function D(e){return Object.prototype.toString.call(e).slice(8,-1).toLowerCase()}function d(e,t){for(var n=[];t>0;n[--t]=e){}return n.join("")}e.sprintf=m;e.vsprintf=t})(typeof global!=="undefined"?global:window);(function(r,i){var e=typeof window!=="undefined"?window:global;if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12),__webpack_require__(1726)], __WEBPACK_AMD_DEFINE_FACTORY__ = (r), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof module==="object"&&module.exports){module.exports=function(e,t,n){if(t===i){if(window!==i){t=require("jquery")}else{t=require("jquery")(e)}}if(n===i){n=require("wcwidth")}r(t,n);return t}}else{r(e.jQuery,e.wcwidth)}})(function($,wcwidth,undefined){"use strict";function debug(e){if(false){console.log(e)}}function DelayQueue(){var t=$.Callbacks();var n=false;this.resolve=function(){t.fire();n=true};this.add=function(e){if(n){e()}else{t.add(e)}}}$.omap=function(n,r){var i={};$.each(n,function(e,t){i[e]=r.call(n,e,t)});return i};$.fn.text_length=function(){return this.map(function(){return $(this).text().length}).get().reduce(function(e,t){return e+t},0)};var Clone={clone_object:function(e){var t={};if(typeof e==="object"){if($.isArray(e)){return this.clone_array(e)}else if(e===null){return e}else{for(var n in e){if($.isArray(e[n])){t[n]=this.clone_array(e[n])}else if(typeof e[n]==="object"){t[n]=this.clone_object(e[n])}else{t[n]=e[n]}}}}return t},clone_array:function(e){if(!is_function(Array.prototype.map)){throw new Error("Your browser don't support ES5 array map "+"use es5-shim")}return e.slice(0).map(function(e){if(typeof e==="object"){return this.clone_object(e)}else{return e}}.bind(this))}};var clone=function(e){return Clone.clone_object(e)};var localStorage;(function(){var e=function(){try{var e="test",t=window.localStorage;t.setItem(e,"1");t.removeItem(e);return true}catch(e){return false}};var t=function(){try{document.cookie.split(";");return true}catch(e){return false}};var n=e();function r(e,t){var n;if(typeof e==="string"&&typeof t==="string"){localStorage[e]=t;return true}else if(typeof e==="object"&&typeof t==="undefined"){for(n in e){if(e.hasOwnProperty(n)){localStorage[n]=e[n]}}return true}return false}function i(e,t){var n,r,i;n=new Date;n.setTime(n.getTime()+31536e6);r="; expires="+n.toGMTString();if(typeof e==="string"&&typeof t==="string"){document.cookie=e+"="+t+r+"; path=/";return true}else if(typeof e==="object"&&typeof t==="undefined"){for(i in e){if(e.hasOwnProperty(i)){document.cookie=i+"="+e[i]+r+"; path=/"}}return true}return false}function o(e){return localStorage[e]}function a(e){var t,n,r,i;t=e+"=";n=document.cookie.split(";");for(r=0;r<n.length;r++){i=n[r];while(i.charAt(0)===" "){i=i.substring(1,i.length)}if(i.indexOf(t)===0){return i.substring(t.length,i.length)}}return null}function u(e){return delete localStorage[e]}function s(e){return i(e,"",-1)}if(!t()&&!n){localStorage={};$.extend({Storage:{set:r,get:o,remove:u}})}else{if(n){localStorage=window.localStorage}$.extend({Storage:{set:n?r:i,get:n?o:a,remove:n?u:s}})}})();var jQuery=$;(function(e){jQuery.fn.extend({everyTime:function(e,t,n,r,i){return this.each(function(){jQuery.timer.add(this,e,t,n,r,i)})},oneTime:function(e,t,n){return this.each(function(){jQuery.timer.add(this,e,t,n,1)})},stopTime:function(e,t){return this.each(function(){jQuery.timer.remove(this,e,t)})}});jQuery.extend({timer:{guid:1,global:{},regex:/^([0-9]+)\s*(.*s)?$/,powers:{ms:1,cs:10,ds:100,s:1e3,das:1e4,hs:1e5,ks:1e6},timeParse:function(e){if(e===undefined||e===null){return null}var t=this.regex.exec(jQuery.trim(e.toString()));if(t[2]){var n=parseInt(t[1],10);var r=this.powers[t[2]]||1;return n*r}else{return e}},add:function(e,t,n,r,i,o){var a=0;if(jQuery.isFunction(n)){if(!i){i=r}r=n;n=t}t=jQuery.timer.timeParse(t);if(typeof t!=="number"||isNaN(t)||t<=0){return}if(i&&i.constructor!==Number){o=!!i;i=0}i=i||0;o=o||false;if(!e.$timers){e.$timers={}}if(!e.$timers[n]){e.$timers[n]={}}r.$timerID=r.$timerID||this.guid++;var u=function(){if(o&&u.inProgress){return}u.inProgress=true;if(++a>i&&i!==0||r.call(e,a)===false){jQuery.timer.remove(e,n,r)}u.inProgress=false};u.$timerID=r.$timerID;if(!e.$timers[n][r.$timerID]){e.$timers[n][r.$timerID]=window.setInterval(u,t)}if(!this.global[n]){this.global[n]=[]}this.global[n].push(e)},remove:function(e,t,n){var r=e.$timers,i;if(r){if(!t){for(var o in r){if(r.hasOwnProperty(o)){this.remove(e,o,n)}}}else if(r[t]){if(n){if(n.$timerID){window.clearInterval(r[t][n.$timerID]);delete r[t][n.$timerID]}}else{for(var a in r[t]){if(r[t].hasOwnProperty(a)){window.clearInterval(r[t][a]);delete r[t][a]}}}for(i in r[t]){if(r[t].hasOwnProperty(i)){break}}if(!i){i=null;delete r[t]}}for(i in r){if(r.hasOwnProperty(i)){break}}if(!i){e.$timers=null}}}}});if(/(msie) ([\w.]+)/.exec(navigator.userAgent.toLowerCase())){e(window).one("unload",function(){var e=jQuery.timer.global;for(var t in e){if(e.hasOwnProperty(t)){var n=e[t],r=n.length;while(--r){jQuery.timer.remove(n[r],t)}}}})}})(jQuery);(function(f){if(!String.prototype.split.toString().match(/\[native/)){return}var c=String.prototype.split,p=/()??/.exec("")[1]===f,n;n=function(e,t,n){if(Object.prototype.toString.call(t)!=="[object RegExp]"){return c.call(e,t,n)}var r=[],i=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.extended?"x":"")+(t.sticky?"y":""),o=0,a,u,s,l;t=new RegExp(t.source,i+"g");e+="";if(!p){a=new RegExp("^"+t.source+"$(?!\\s)",i)}n=n===f?-1>>>0:n>>>0;while(u=t.exec(e)){s=u.index+u[0].length;if(s>o){r.push(e.slice(o,u.index));if(!p&&u.length>1){u[0].replace(a,function(){for(var e=1;e<arguments.length-2;e++){if(arguments[e]===f){u[e]=f}}})}if(u.length>1&&u.index<e.length){Array.prototype.push.apply(r,u.slice(1))}l=u[0].length;o=s;if(r.length>=n){break}}if(t.lastIndex===u.index){t.lastIndex++}}if(o===e.length){if(l||!t.test("")){r.push("")}}else{r.push(e.slice(o))}return r.length>n?r.slice(0,n):r};String.prototype.split=function(e,t){return n(this,e,t)};return n})();$.fn.caret=function(e){var t=this[0];var n=t.contentEditable==="true";if(arguments.length===0){if(window.getSelection){if(n){t.focus();var r=window.getSelection().getRangeAt(0),i=r.cloneRange();i.selectNodeContents(t);i.setEnd(r.endContainer,r.endOffset);return i.toString().length}return t.selectionStart}if(document.selection){t.focus();if(n){var r=document.selection.createRange(),i=document.body.createTextRange();i.moveToElementText(t);i.setEndPoint("EndToEnd",r);return i.text.length}var e=0,o=t.createTextRange(),i=document.selection.createRange().duplicate(),a=i.getBookmark();o.moveToBookmark(a);while(o.moveStart("character",-1)!==0)e++;return e}return 0}if(e===-1)e=this[n?"text":"val"]().length;if(window.getSelection){if(n){t.focus();window.getSelection().collapse(t.firstChild,e)}else t.setSelectionRange(e,e)}else if(document.body.createTextRange){var o=document.body.createTextRange();o.moveToElementText(t);o.moveStart("character",e);o.collapse(true);o.select()}if(!n&&!this.is(":focus")){t.focus()}return e};$.fn.resizer=function(u){var s=arguments[0]==="unbind";if(!s&&!is_function(u)){throw new Error('Invalid argument, it need to a function or string "unbind".')}if(s){u=is_function(arguments[1])?arguments[1]:null}return this.each(function(){var e=$(this);var t;var n;function r(){n.fire()}if(s){n=e.data("callbacks");if(u&&n){n.remove(u);if(!n.has()){n=null}}else{n=null}if(!n){e.removeData("callbacks");if(window.ResizeObserver){var i=e.data("observer");if(i){i.unobserve(this);e.removeData("observer")}}else{t=e.find("> iframe");if(t.length){$(t[0].contentWindow).off("resize").remove();t.remove()}else if(e.is("body")){$(window).off("resize.resizer")}}}}else if(e.data("callbacks")){$(this).data("callbacks").add(u)}else{n=$.Callbacks();n.add(u);e.data("callbacks",n);var o;var a=true;if(window.ResizeObserver){o=new ResizeObserver(function(){if(!a){r()}a=false});o.observe(this);e.data("observer",o)}else if(e.is("body")){$(window).on("resize.resizer",r)}else{t=$("<iframe/>").addClass("resizer").appendTo(this)[0];$(t.contentWindow).on("resize",r)}}})};function a11y_hide(e){e.attr({role:"presentation","aria-hidden":"true"})}var excepctions=[];function alert_exception(e,t){var n=(e?e+": ":"")+exception_message(t);if(excepctions.indexOf(n)===-1){excepctions.push(n);alert(n+(t.stack?"\n"+t.stack:""))}}function scrollbar_event(e,t){var n=t.offset().left;return t.outerWidth()<=e.clientX-n}function exception_message(e){if(typeof e==="string"){return e}else if(typeof e.fileName==="string"){return e.fileName+": "+e.message}else{return e.message}}function Cycle(){var r=[].slice.call(arguments);var n=0;$.extend(this,{get:function(){return r},index:function(){return n},rotate:function(e){if(!e){var t=r.filter(function(e){return typeof e!=="undefined"});if(!t.length){return}}if(!r.length){return}if(r.length===1){return r[0]}else{if(n===r.length-1){n=0}else{++n}if(typeof r[n]!=="undefined"){return r[n]}else{return this.rotate(true)}}},length:function(){return r.length},remove:function(e){delete r[e]},set:function(e){for(var t=r.length;t--;){if(r[t]===e){n=t;return}}this.append(e);n=r.length-1},front:function(){if(r.length){var e=n;var t=false;while(!r[e]){e++;if(e>r.length){if(t){break}e=0;t=true}}return r[e]}},map:function(n){return r.map(function(e,t){if(typeof e!=="undefined"){return n(e,t)}return null}).filter(Boolean)},forEach:function(n){return r.forEach(function(e,t){if(typeof e!=="undefined"){n(e,t)}})},append:function(e){r.push(e)}})}function Stack(e){var t=e instanceof Array?e:e?[e]:[];$.extend(this,{data:function(){return t},map:function(e){return $.map(t,e)},size:function(){return t.length},pop:function(){if(t.length===0){return null}else{var e=t[t.length-1];t=t.slice(0,t.length-1);return e}},push:function(e){t=t.concat([e]);return e},top:function(){return t.length>0?t[t.length-1]:null},clone:function(){return new Stack(t.slice(0))}})}function History(e,t,n){var r=true;var i="";if(typeof e==="string"&&e!==""){i=e+"_"}i+="commands";var o;if(n){o=[]}else{o=$.Storage.get(i);o=o?JSON.parse(o):[]}var a=o.length-1;$.extend(this,{append:function(e){if(r){if(o[o.length-1]!==e){o.push(e);if(t&&o.length>t){o=o.slice(-t)}a=o.length-1;if(!n){$.Storage.set(i,JSON.stringify(o))}}}},set:function(e){if(e instanceof Array){o=e;if(!n){$.Storage.set(i,JSON.stringify(o))}}},data:function(){return o},reset:function(){a=o.length-1},last:function(){return o[o.length-1]},end:function(){return a===o.length-1},position:function(){return a},current:function(){return o[a]},next:function(){var e=a;if(a<o.length-1){++a}if(e!==a){return o[a]}},previous:function(){var e=a;if(a>0){--a}if(e!==a){return o[a]}},clear:function(){o=[];this.purge()},enabled:function(){return r},enable:function(){r=true},purge:function(){if(!n){$.Storage.remove(i)}},disable:function(){r=false},toggle:function(e){if(typeof e==="undefined"){r=!r}else{r=e}}})}var cmd_index=0;$.cmd={defaults:{mask:false,caseSensitiveSearch:true,historySize:60,prompt:"> ",enabled:true,history:true,onPositionChange:$.noop,onCommandChange:$.noop,clickTimeout:200,holdTimeout:400,holdRepeatTimeout:200,tabs:4}};$.fn.cmd=function(e){var C=$.extend({},$.cmd.defaults,e);var E=this;var t=E.data("cmd");if(t){return t}var u=cmd_index++;E.addClass("cmd");E.append('<span class="prompt"></span>');E.append('<div class="cursor-line">'+"<span></span>"+'<span class="cursor">&nbsp;</span>'+"<span></span>"+"</div>");a11y_hide(E.find(".cursor-line"));var o=$("<textarea>").attr({autocapitalize:"off",spellcheck:"false",tabindex:1}).addClass("clipboard").appendTo(E).val(" ");if(C.width){E.width(C.width)}var F;var a;var x;var k;var c=E.find(".prompt");var s=false;var l="";var f=null;var n;var A="";var r;var p="";var m=0;var i;var D;var T=0;var d,h;var S=E.find(".cursor");var g;var R;var v=0;function _(e){var t=$(e.target);if(t.is("span")){t=t.closest("[data-text]");return t.index()+t.parent("span").prevAll().find("[data-text]").length+t.closest('[role="presentation"]').prevUntil(".prompt").find("[data-text]").length}else if(t.is('div[role="presentation"]')){var n=!t.nextUntil("textarea").length;return t.find("span[data-text]").length+t.prevUntil(".prompt").find("span[data-text]").length-(n?0:1)}}var y={SPACEBAR:" ",UP:"ARROWUP",DOWN:"ARROWDOWN",LEFT:"ARROWLEFT",RIGHT:"ARROWRIGHT",DEL:"DELETE",MULTIPLY:"*",DIVIDE:"/",SUBTRACT:"-",ADD:"+"};function b(e){if(e.key){var t=e.key.toUpperCase();if(y[t]){t=y[t]}if(t==="CONTROL"){return"CTRL"}else{var n=[];if(e.ctrlKey){n.push("CTRL")}if(e.metaKey&&t!=="META"){n.push("META")}if(e.shiftKey&&t!=="SHIFT"){n.push("SHIFT")}if(e.altKey&&t!=="ALT"){n.push("ALT")}if(n.length&&t===" "){t="SPACEBAR"}if(e.key){n.push(t)}return n.join("+")}}}var w;var B={"ALT+D":j(true),"HOLD+DELETE":j(false),"HOLD+SHIFT+DELETE":j(false),ENTER:function(){if(h&&A&&!C.mask&&(is_function(C.historyFilter)&&C.historyFilter(A))||C.historyFilter instanceof RegExp&&A.match(C.historyFilter)||!C.historyFilter){h.append(A)}var e=A;h.reset();Ce="";ge=true;E.set("");if(C.commands){C.commands.call(E,e)}if(is_function(i)){se()}o.val("");return false},"SHIFT+ENTER":function(){E.insert("\n");return true},BACKSPACE:N,"SHIFT+BACKSPACE":N,TAB:function(){E.insert("\t")},"CTRL+D":function(){E["delete"](1);return false},DELETE:function(){E["delete"](1);return true},ARROWUP:I,"CTRL+P":I,ARROWDOWN:P,"CTRL+N":P,ARROWLEFT:H,"HOLD+ARROWLEFT":H,"CTRL+B":H,"CTRL+ARROWLEFT":function(){var e=m-1;var t=0;if(A[e]===" "){--e}for(var n=e;n>0;--n){if(A[n]===" "&&A[n+1]!==" "){t=n+1;break}else if(A[n]==="\n"&&A[n+1]!=="\n"){t=n;break}}E.position(t)},"CTRL+R":function(){if(s){X(true)}else{n=i;G();r=A;E.set("");ae();s=true}return false},"CTRL+G":function(){if(s){i=n;se();E.set(r);ae();s=false;l="";return false}},ARROWRIGHT:M,"HOLD+ARROWRIGHT":M,"CTRL+F":M,"CTRL+ARROWRIGHT":function(){if(A[m]===" "){++m}var e=/\S[\n\s]{2,}|[\n\s]+\S?/;var t=A.slice(m).match(e);if(!t||t[0].match(/^\s+$/)){E.position(A.length)}else if(t[0][0]!==" "){m+=t.index+1}else{m+=t.index+t[0].length-1;if(t[0][t[0].length-1]!==" "){--m}}ae()},F12:O,END:q,"CTRL+E":q,HOME:U,"CTRL+A":U,"SHIFT+INSERT":z,"CTRL+SHIFT+T":O,"CTRL+W":L(true),"HOLD+BACKSPACE":L(false),"HOLD+SHIFT+BACKSPACE":L(false),"CTRL+H":function(){if(A!==""&&m>0){E["delete"](-1)}return false},"CTRL+X":O,"CTRL+C":O,"CTRL+T":O,"CTRL+Y":function(){if(p!==""){E.insert(p)}},"CTRL+V":z,"META+V":z,"CTRL+K":function(){if(A.length-m){p=E["delete"](A.length-m);text_to_clipboard(E,p)}return false},"CTRL+U":function(){if(A!==""&&m!==0){p=E["delete"](-m);text_to_clipboard(E,p)}return false},"CTRL+TAB":function(){return false},"META+`":O,"META+R":O,"META+L":O};function j(i){return function e(){var t=/ *[^ ]+ *(?= )|[^ ]+$/;var n=A.slice(m);var r=n.match(t);if(r){p=r[0];if(i){text_to_clipboard(E,p)}}E.set(A.slice(0,m)+A.slice(m).replace(t,""),true);return false}}function L(n){return function e(){if(A!==""&&m!==0){var t=A.slice(0,m).match(/([^ ]+ *$)/);if(t[0].length){p=E["delete"](-t[0].length);if(n){text_to_clipboard(E,p)}}}return false}}function O(){return true}function z(){o.val("");v=0;if(E.isenabled()&&!o.is(":focus")){o.trigger("focus",[true])}o.one("input",le);return true}function I(){if(ce){r=A;E.set(h.current())}else{E.set(h.previous())}ce=false;return false}function P(){E.set(h.end()?r:h.next());return false}function N(){if(s){l=l.slice(0,-1);G()}else if(A!==""&&m>0){E["delete"](-1)}E.oneTime(1,function(){ge=true})}function H(){if(m>0){E.position(-1,true);ae()}}function M(){if(m<A.length){E.position(1,true)}return false}function U(){E.position(0)}function q(){E.position(A.length)}function W(){var e=o.is(":focus");if(D){if(!e){}E.oneTime(10,function(){if(!o.is(":focus")&&D){o.trigger("focus",[true])}})}else if(e&&(is_mobile||!D)){o.trigger("blur",[true])}}function K(){if(animation_supported){var e=window.getComputedStyle(S[0]);var t=e.getPropertyValue("--animation");t=t.replace(/^\s*|\s*$/g,"");var n=E.attr("class");if(n.match(/-animation/)){n=n.replace(/[a-z]+-animation/g,"")}if(t&&!t.match(/blink/)){var r=t.replace(/terminal-/,"")+"-animation";if(!n.match(r)){n+=" "+r}}if(n!==E.attr("class")){E.attr("class",n)}}}function J(e){if(!E.isenabled()){return}E.oneTime(10,function(){if(o.val()!==A&&!e){o.val(" "+A)}if(D){E.oneTime(10,function(){try{if(o.caret()!==m+1){o.caret(m+1)}}catch(e){}})}})}if(animation_supported&&!is_android){g=function(e){if(e){S.addClass("blink")}else{S.removeClass("blink")}};R=function(){var e=S.clone();e.insertBefore(S);S.remove();S=e}}else{var Q=false;g=function(e){if(e&&!Q){Q=true;S.addClass("inverted blink");E.everyTime(500,"blink",Y)}else if(Q&&!e){Q=false;E.stopTime("blink",Y);S.removeClass("inverted blink")}};R=function(){g(false);g(true)}}function Y(){S.toggleClass("inverted")}function G(){i="(reverse-i-search)`"+l+"': ";se()}function V(){i=n;s=false;f=null;l=""}function X(e){var t=h.data();var n,r;var i=t.length;if(e&&f>0){i-=f}if(l.length>0){for(var o=l.length;o>0;o--){r=$.terminal.escape_regex(l.substring(0,o));if(C.caseSensitiveSearch){n=new RegExp(r)}else{n=new RegExp(r,"i")}for(var a=i;a--;){if(n.test(t[a])){f=t.length-a;E.position(t[a].indexOf(r));E.set(t[a],true);ae();if(l.length!==o){l=l.substring(0,o);G()}return}}}}l=""}function Z(){var e=E.find(".prompt").html("<span>&nbsp;</span>");var t=E.width();var n=e.find("span")[0].getBoundingClientRect().width;F=Math.floor(t/n)}function ee(e){function t(e){return $.terminal.split_equal(e,F)}function n(e){return e.filter(function(e){return!$.terminal.strip(e).match(/^ $/)})}var r=c.find(".line");var i;if(r.length){i=r.nextUntil(".line").text()}else{i=c.text()}i=$.terminal.escape_brackets(i);var o=new RegExp("^"+$.terminal.escape_regex(i));var a;if(e.match(/\n/)){var u=e.split("\n");var s=F-k-1;for(var l=0;l<u.length-1;++l){u[l]+=" "}if(strlen(u[0])>s){a=t(i+u[0]);a[0]=a[0].replace(o,"");a=n(a)}else{a=[u[0]]}for(l=1;l<u.length;++l){if(strlen(u[l])>F){var f=t(u[l]);if(l<u.length-1){f=n(f)}a=a.concat(f)}else{a.push(u[l])}}}else{a=t(i+e,F);a[0]=a[0].replace(o,"")}if(a.length>1&&a[a.length-1].length===F){a.push("")}return a}function te(t,e){try{t=$.terminal.escape_formatting(t);var n=$.extend({},C,{unixFormattingEscapeBrackets:true,position:m});var r=$.terminal.apply_formatters(t,n);t=r[0];if(!e){T=r[1]}t=$.terminal.normalize(t);var i=$.terminal.length(t);if(T>i){T=i}return t}catch(e){alert_exception("[Formatting]",e.stack);return t}}function ne(e,t){var n=$.terminal.encode(re(e),{tabs:C.tabs,before:t});e=$.terminal.format(n,{char_width:C.char_width});var r=/(<span[^>]+data-text[^>]+>)(.*?)(<\/span>)/g;return e.replace(r,"$1<span>$2</span>$3")}function re(e){function t(e){if($.terminal.is_formatting(e)){if(e.match(/\]\\\]/)){e=e.replace(/\]\\\]/g,"]\\\\]")}}else{if(e.match(/\\$/)){e+="\\"}e="[[;;]"+e+"]"}return e}var n=ie(e);if(n===1){return t(e)}var r=[];for(var i=0;i<n;++i){var o=$.terminal.substring(e,i,i+1);r.push(t(o))}return r.join("")}function ie(e){return $.terminal.length(e)}function oe(e,t,n){return $.terminal.substring(e,t,n)}var ae=function(){var h=S.prev();var g=S.next();var v=S.parent();function _(e,t){var n=$.extend({prompt:"",last:false},t);var r=n.position;var i=ie(e);var o=n.prompt;var a;if(r===i){h.html(ne(e));S.html("<span><span>&nbsp;</span></span>");g.html("")}else if(r===0){h.html("");a=oe(e,0,1);S.html(ne(a));g.html(ne(oe(e,1),o+a))}else{var u=$.terminal.substring(e,0,r);h.html(ne(u,o));a=oe(e,r,r+1);var s=(o+u).replace(/^.*\t/,"");S.html(ne(a,s));if(r===i-1){g.html("")}else{if(a.match(/\t/)){s=""}else{s+=a}g.html(ne(oe(e,r+1),s))}}var l=n.position===(n.last?i:i-1);S.toggleClass("noselect",l);K();R()}function y(e,t){return'<div role="presentation" aria-hidden="true">'+ne(e,t||"")+"</div>"}function b(e){var n=v;$.each(e,function(e,t){n=$(y(t)).insertAfter(n)})}function w(e){$.each(e,function(e,t){v.before(y(t,e===0?x:""))})}return function(){var e;switch(typeof C.mask){case"boolean":e=C.mask?A.replace(/./g,"*"):A;break;case"string":e=A.replace(/./g,C.mask);break}e=te(e);var t=T;var n;E.find("div:not(.cursor-line,.clipboard-wrapper)").remove();h.html("");if(strlen(text(e))>F-k-1||e.match(/\n/)){var r=e.match(/\t/g);var i=e;if(r){e=e.replace(/\t/g,"\0\0\0\0")}var o=ee(e);if(r){o=$.map(o,function(e){return e.replace(/\x00\x00\x00\x00/g,"\t")})}var a=ie(o[0]);if(a===0&&o.length===1){}else if(t<a){_(o[0],{position:t,prompt:x});b(o.slice(1))}else if(t===a){v.before(y(o[0],x));_(o[1]||"",{position:0});if(o.length>1){b(o.slice(2))}}else{var u=o.slice(-1)[0];var s=ie(i);var l=s-t;var f=ie(u);var c=0;if(l===-1){l=0}if(l<=f){w(o.slice(0,-1));if(f===l){c=0}else{c=f-l}_(u,{position:c,last:true})}else{var p;var m;c=t;for(n=0;n<o.length;++n){var D=$.terminal.length(o[n]);if(c>D){c-=D}else{break}}m=o[n];p=n;if(c===ie(m)){c=0;m=o[++p];if(m===undefined){var d=$.terminal.defaults.strings.redrawError;throw new Error(d)}}_(m,{position:c});w(o.slice(0,p));b(o.slice(p+1))}}E.find(".cursor-line ~ div:last-of-type").append("<span></span>")}else if(e===""){h.html("");S.html("<span><span>&nbsp;</span></span>");g.html("")}else{_(e,{position:t})}}}();var ue=function(){function u(e,t){var n=$.extend({},C,{position:t});var r=$.terminal.apply_formatters(A,n)[1];if(r===e){return 0}else if(r<e){return 1}else{return-1}}return function(e,t){if(t===0){return 0}e=text(e);var n=e.length;var r=binary_search(0,n,t,u);var i=$.terminal.split_characters(e);if(n>i.length){var o=0;for(var a=0;a<i.length;++a){o+=i[a].length;if(o>=r){return o}}}return r}}();var se=function(){function e(e){e=$.terminal.apply_formatters(e,{});e=$.terminal.normalize(e);e=crlf(e);a=e;var t=$.terminal.split_equal(e,F);var n={char_width:C.char_width};x=t[t.length-1];var r=$.terminal.encode(t[t.length-1],{tabs:C.tabs});var i=$.terminal.format(r,n);var o=t.slice(0,-1).map(function(e){e=$.terminal.encode(e,{tabs:C.tabs});return'<span class="line">'+$.terminal.format(e,n)+"</span>"}).concat([i]).join("\n");if(c.html()!==o){c.html(o);k=strlen(text(r))}}return function(){switch(typeof i){case"string":e(i);break;case"function":i.call(E,e);break}}}();function le(){if(v++>0){return}if(E.isenabled()){E.oneTime(100,function(){E.insert(o.val());o.val(A);J()})}}function fe(){if(is_function(C.onCommandChange)){C.onCommandChange.call(E,A)}}$.extend(E,{option:function(e,t){if(typeof t==="undefined"){return C[e]}else{C[e]=t}return E},name:function(e){if(e!==undefined){d=e;var t=h&&h.enabled()||!h;h=new History(d,C.historySize,C.history==="memory");if(!t){h.disable()}return E}else{return d}},purge:function(){h.clear();return E},history:function(){return h},delete:function(e,t){var n;if(e===0){return""}else if(e<0){if(m>0){n=A.slice(0,m).slice(e);A=A.slice(0,m+e)+A.slice(m,A.length);if(!t){E.position(m+e)}fe()}}else if(A!==""&&m<A.length){n=A.slice(m).slice(0,e);A=A.slice(0,m)+A.slice(m+e,A.length);fe()}ae();J();return n},set:function(e,t,n){if(e!==undefined){A=e;if(!t){E.position(A.length)}ae();J();if(!n){fe()}}return E},keymap:function(e,t){function n(e,t){var n=B[e];if(is_function(n)){n=n.bind(E)}return function(e){return t.call(E,e,n)}}if(typeof e==="undefined"){return w}else if(typeof e==="string"){if(typeof t==="undefined"){if(w[e]){return w[e]}else if(B[e]){return B[e]}}else{w[e]=n(e,t)}}else{w=$.extend({},w?w:B,$.omap(e||{},n));return E}},insert:function(e,t){if(m===A.length){A+=e}else if(m===0){A=e+A}else{A=A.slice(0,m)+e+A.slice(m)}if(!t){E.position(e.length,true,true)}else{J()}ae();fe();J();return E},get:function(){return A},commands:function(e){if(e){C.commands=e;return E}else{return e}},destroy:function(){Ae.unbind("keypress.cmd",Te);Ae.unbind("keydown.cmd",$e);Ae.unbind("input.cmd",Re);E.stopTime("blink",Y);E.find(".cursor").next().remove().end().prev().remove().end().remove();E.find(".prompt, .clipboard").remove();E.removeClass("cmd").removeData("cmd").off(".cmd");return E},prompt:function(e){if(e===true){return a}else if(e===undefined){return i}else{if(typeof e==="string"||typeof e==="function"){i=e}else{throw new Error("prompt must be a function or string")}se();ae();return E}},kill_text:function(){return p},position:function(e,t,n){if(typeof e==="number"){var r=m;if(t){m+=e}else if(e<0){m=0}else if(e>A.length){m=A.length}else{m=e}if(r!==m&&!n){ae();if(is_function(C.onPositionChange)){C.onPositionChange(m,T)}J(true)}return E}else{return m}},refresh:function(){se();ae();return E},display_position:function(e,t){if(e===undefined){return T}else{var n=te(A,true);var r=$.terminal.length(n);var i=text(A).length;var o;if(t){o=T+e}else if(e>r){o=r}else{o=e}if(r===o){T=o;return E.position(i)}var a=ue(A,o);if(a!==-1){T=o;E.position(a)}return E}},visible:function(){var e=E.visible;return function(){e.apply(E,[]);ae();se();return E}}(),show:function(){var e=E.show;return function(){e.apply(E,[]);ae();se();return E}}(),resize:function(e){if(e){F=e}else{Z()}ae();se();return E},enable:function(e){if(!D){D=true;E.addClass("enabled");try{o.caret(m)}catch(e){}g(true);if(!e){se()}K();J()}W();return E},isenabled:function(){return D},disable:function(e){D=false;E.removeClass("enabled");g(false);if(!e){W()}return E},mask:function(e){if(typeof e==="undefined"){return C.mask}else{C.mask=e;ae();return E}}});E.name(C.name||C.prompt||"");if(typeof C.prompt==="string"){i=C.prompt}else{i="> "}se();if(C.enabled===true){E.enable()}if(!C.history){h.disable()}var ce=true;var pe=false;var me=false;var De=false;var de=false;var he=false;var ge=true;var ve=false;var _e=false;var ye=false;var be=false;var we;var Ce="";function Ee(e){return e.key.toUpperCase()==="BACKSPACE"||e.which===8}function Fe(e){return e.key&&e.key.length===1&&!e.ctrlKey}function xe(e){return e.which===35||e.which===36||e.which===37||e.which===38||e.which===39||e.which===40||e.which===13||e.which===27}function $e(e){debug('keydown "'+e.key+'" '+e.fake+" "+e.which);_e=(e.key||"").toLowerCase()==="process"||e.which===0;var t;me=de&&De&&!Ee(e);try{if(!e.fake){De=Fe(e);he=String(e.key).toLowerCase()==="unidentified";ve=Ee(e)}}catch(e){}if(e.key==="Unidentified"){ge=true;return}if(!e.fake){de=true;ge=false}o.off("input",le);var n=b(e);if(is_function(C.keydown)){t=C.keydown.call(E,e);if(t!==undefined){if(!t){we=true}return t}}if(D){E.oneTime(C.holdTimeout,"hold",function(){ye=true});if(ye){n="HOLD+"+n;if(be){return}if(C.holdRepeatTimeout>0){be=true;E.oneTime(C.holdRepeatTimeout,"delay",function(){be=false})}}R();we=["CTRL+V","META+V"].indexOf(n)!==-1;if(e.which!==38&&!(e.which===80&&e.ctrlKey)){ce=true}if(s&&xe(e)){V();se();if(e.which===27){E.set("")}ae();if(e.which===13){$e.call(this,e)}}else if(is_function(w[n])){t=w[n](e);if(t===true){return}if(t!==undefined){return t}}else if(e.altKey){return}else{pe=false;return}}}function ke(){E.stopTime("hold");be=ye=false}var Ae=$(document.documentElement||window);E.keymap(C.keymap||{});function Te(e){debug('keypress "'+e.key+'" '+e.fake);ke();var t;if(!e.fake){de=false}if((e.ctrlKey||e.metaKey)&&!e.altKey){return}if(pe){return}if(is_function(C.keypress)){t=C.keypress.call(E,e);if(t!==undefined){if(!t){we=true}return t}}if(D){if(e.fake){return}var n;if(is_key_native||e.fake){n=e.key;var r=n.toUpperCase();if(y[r]){n=y[r]}}if(!n||he){n=String.fromCharCode(e.which)}if($.inArray(e.which,[13,0,8])>-1){if(e.keyCode===123){return}return false}else if(n&&(!e.ctrlKey||e.ctrlKey&&e.ctrlKey)&&(!(e.altKey&&e.which===100)||e.altKey)&&!me){if(s){l+=n;X();G()}else if(n.length===1){E.insert(n)}}}}function Se(e,t,n){var r=$.Event(e);r.which=n;r.key=t;r.fake=true;Ae.trigger(r)}function Re(){debug("input "+ge+" || "+_e+" (("+de+" || "+me+") && !"+we+" && ("+De+" || "+he+") && !"+ve+")");var e=o.val().replace(/^ /,"");if((ge||_e||(de||me)&&!we&&(De||he)&&!ve)&&e!==A){var t=m;if(ge){var n=Ce;ve=n.substring(0,n.length-1).length===e.length}if(s){l=e;X();G()}else{var r=e.substring(m);if(r.length===1||ve){if(ge){var i;if(ve){i=8}else{i=r.toUpperCase().charCodeAt(0)}Se("keydown",ve?"Backspace":r,i)}if(de&&!ve){Se("keypress",r,r.charCodeAt(0))}}if(ve){Ce=A;return}if(we){we=false;return}E.set(e)}if(ve){E.position(t-1)}else{E.position(t+Math.abs(e.length-Ce.length))}}Ce=A;we=false;ge=true}Ae.bind("keypress.cmd",Te).bind("keydown.cmd",$e).bind("keyup.cmd",ke).bind("input.cmd",Re);(function(){var o=false;var a=0;E.on("mousedown.cmd",function(){o=true}).on("mouseup.cmd",function(t){function e(){var e=$(t.target);if(!e.is(".prompt")&&i){if(D){if(e.is(".cmd")){E.position(A.length)}else{E.display_position(_(t))}}}a=0}var n;if(t.originalEvent===undefined){n=t.button}else{n=t.originalEvent.button}if(n===0&&get_selected_text()===""){var r="click_"+u;if(++a===1){var i=o;if(D){if(C.clickTimeout===0){e()}else{E.oneTime(C.clickTimeout,r,e)}}else{a=0}}else{E.stopTime(r);a=0}}o=false})})();E.data("cmd",E);if(!("KeyboardEvent"in window&&"key"in window.KeyboardEvent.prototype)){setTimeout(function(){throw new Error("key event property not supported try https://github."+"com/inexorabletash/polyfill/blob/master/keyboard.js")},0)}return E};var combine_chr_re=/^(.(?:[\u0300-\u036F]|[\u1AB0-\u1abE]|[\u1DC0-\u1DF9]|[\u1DFB-\u1DFF]|[\u20D0-\u20F0]|[\uFE20-\uFE2F])+)/;var astral_symbols_re=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g;var emoji_re=/^(\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD]))/;var mobile_re=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i;var tablet_re=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;var format_split_re=/(\[\[[!gbiuso]*;[^;]*;[^\]]*\](?:[^\]]*[^\\](\\\\)*\\\][^\]]*|[^\]]*|[^[]*\[[^\]]*)\]?)/i;var format_parts_re=/\[\[([!gbiuso]*);([^;]*);([^;\]]*);?([^;\]]*);?([^\]]*)\]([^\]]*\\\][^\]]*|[^\]]*|[^[]*\[[^\]]*)\]?/gi;var format_re=/\[\[([!gbiuso]*;[^;\]]*;[^;\]]*(?:;|[^\]()]*);?[^\]]*)\]([^\]]*\\\][^\]]*|[^\]]*|[^[]*\[[^\]]*)\]?/gi;var format_exist_re=/\[\[([!gbiuso]*;[^;\]]*;[^;\]]*(?:;|[^\]()]*);?[^\]]*)\]([^\]]*\\\][^\]]*|[^\]]*|[^[]*\[[^\]]*)\]/gi;var format_full_re=/^\[\[([!gbiuso]*;[^;\]]*;[^;\]]*(?:;|[^\]()]*);?[^\]]*)\]([^\]]*\\\][^\]]*|[^\]]*|[^[]*\[[^\]]*)\]$/gi;var color_hex_re=/^#([0-9a-f]{3}|[0-9a-f]{6})$/i;var url_re=/(\bhttps?:\/\/(?:(?:(?!&[^;]+;)|(?=&amp;))[^\s"'<>\][)])+)/gi;var url_nf_re=/\b(?![^\s[\]]*])(https?:\/\/(?:(?:(?!&[^;]+;)|(?=&amp;))[^\s"'<>\][)])+)/gi;var email_re=/((([^<>('")[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))/g;var command_re=/((?:"[^"\\]*(?:\\[\S\s][^"\\]*)*"|'[^'\\]*(?:\\[\S\s][^'\\]*)*'|\/[^\/\\]*(?:\\[\S\s][^\/\\]*)*\/[gimsuy]*(?=\s|$)|(?:\\\s|\S))+)(?=\s|$)/gi;var extended_command_re=/^\s*((terminal|cmd)::([a-z_]+)\(([\s\S]*)\))\s*$/;var format_begin_re=/(\[\[[!gbiuso]*;[^;]*;[^\]]*\])/i;var format_start_re=/^(\[\[[!gbiuso]*;[^;]*;[^\]]*\])/i;var format_end_re=/\[\[[!gbiuso]*;[^;]*;[^\]]*\]?$/i;var format_exec_re=/(\[\[(?:[^\][]|\\\])+\]\])/;var float_re=/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/;var re_re=/^\/((?:\\\/|[^/]|\[[^\]]*\/[^\]]*\])+)\/([gimsuy]*)$/;var string_re=/("(?:[^"\\]|\\(?:\\\\)*"|\\\\)*"|'(?:[^'\\]|\\(?:\\\\)*'|\\\\)*')/;var unclosed_strings_re=/^(?=((?:[^"']+|"[^"\\]*(?:\\[^][^"\\]*)*"|'[^'\\]*(?:\\[^][^'\\]*)*')*))\1./;var animation_supported=function(){var e=false,t="Webkit Moz O ms Khtml".split(" "),n=document.createElement("div");if(n.style.animationName){e=true}if(e===false){for(var r=0;r<t.length;r++){var i=t[r]+"AnimationName";if(n.style[i]!==undefined){e=true;break}}}n=null;return e}();var is_ch_unit_supported=function(){var e=window.navigator.userAgent;if(e.match(/MSIE|Trident/)&&!e.match(/IEMobile/)){return false}var t=document.createElement("div");t.style.width="1ch";return t.style.width==="1ch"}();var is_css_variables_supported=window.CSS&&window.CSS.supports&&window.CSS.supports("--fake-var",0);var is_android=navigator.userAgent.toLowerCase().indexOf("android")!==-1;var is_safari=/^((?!chrome|android).)*safari/i.test(navigator.userAgent);var is_key_native=function e(){if(!("KeyboardEvent"in window&&"key"in window.KeyboardEvent.prototype)){return false}var t=window.KeyboardEvent.prototype;var n=Object.getOwnPropertyDescriptor(t,"key").get;return n.toString().match(/\[native code\]/)}();var is_mobile=function(e){var t=false;if(mobile_re.test(e)||tablet_re.test(e.substr(0,4))){t=true}return t}(navigator.userAgent||navigator.vendor||window.opera);var strlen=function(){if(typeof wcwidth==="undefined"){return function(e){return $.terminal.length(e)}}else{return wcwidth}}();function bare_text(e){if(!e.match(/&/)){return e}return $("<span>"+safe(e)+"</span>").text()}function text(e){return bare_text($.terminal.strip(e))}function safe(e){if(!e.match(/[<>&]/)){return e}return e.replace(/&(?![^;]+;)/g,"&amp;").replace(/>/g,"&gt;").replace(/</g,"&lt;")}function crlf(e){return e.replace(/\r/g,"")}function get_next_character(e){var t=e.match(emoji_re);if(t){return t[1]}else if(e.substring(0,2).replace(astral_symbols_re,"_")===1){if(e.substring(1).match(combine_chr_re)){return e.substring(0,3)}return e.substring(0,2)}else{var n=e.match(combine_chr_re);if(n){return n[1]}return e[0]}}function normalize_position(e,r){if(r===0){return r}e=$.terminal.strip(e);var t=$.terminal.split_characters(e).reduce(function(e,t){if(typeof e==="number"){return e}var n=e.length+t.length;if(n>=r){return e.position+1}return{position:e.position+1,length:n}},{position:0,length:0});if(typeof t==="number"){return t}else{return t.position}}function char_width_prop(e,t){if(is_ch_unit_supported){return"width: "+e+"ch"}else if(!is_css_variables_supported){if(t.char_width){return"width: "+t.char_width*e+"px"}}else{return"--length: "+e}return""}function extra_css(e,t){if(typeof wcwidth!=="undefined"){var n=bare_text(e);var r=strlen(n);if(r!==$.terminal.length(n)){return char_width_prop(r,t)}}return""}function wide_characters(e,n){if(typeof wcwidth!=="undefined"){var t=bare_text(e);var r=$.terminal.split_characters(t);if(r.length===1){return e}var i=r.map(function(e){return{len:strlen(e),chr:e}}).reduce(function(e,t){var n=e[e.length-1];if(n){if(n.len!==t.len){return e.concat([{sum:t.len,len:t.len,str:t.chr}])}else{e.pop();return e.concat([{sum:n.sum+t.len,len:n.len,str:n.str+t.chr}])}}return[{sum:t.len,str:t.chr,len:t.len}]},[]);return i.map(function(e){if(e.len===1){return e.str}var t=char_width_prop(e.sum,n);if(e.sum===r.length||!t.length){return"<span>"+e.str+"</span>"}else{return'<span style="'+t+'">'+e.str+"</span>"}}).join("")}return e}function binary_search(e,t,n,r){var i=t-e;var o=e+Math.floor(i/2);var a=r(n,o);if(a===0){return o}else if(a>0&&i>1){return binary_search(o,t,n,r)}else if(a<0&&i>1){return binary_search(e,o,n,r)}else{return-1}}var get_selected_text=function(){if(window.getSelection||document.getSelection){return function(){var e=(window.getSelection||document.getSelection)();if(e.text){return e.text}else{return e.toString()}}}else if(document.selection&&document.selection.type!=="Control"){return function(){return document.selection.createRange().text}}return function(){return""}}();function text_to_clipboard(e,t){var n=$("<div>"+t.replace(/\n/,"<br/>")+"<div>");n.appendTo("body");select_all(n[0]);try{document.execCommand("copy")}catch(e){}n.remove()}var get_textarea_selection=function(){var e=document.createElement("textarea");var t="selectionStart"in e;e=null;if(t){return function(e){var t=e.selectionEnd-e.selectionStart;return e.value.substr(e.selectionStart,t)}}else if(document.selection){return function(){var e=document.selection.createRange();return e.text()}}else{return function(){return""}}}();function clear_textarea_selection(e){e.selectionStart=e.selectionEnd=0}function common_string(e,t,n){if(!t.length){return""}var r=string_case(e);var i=[];for(var o=e.length;o<t[0].length;++o){var a=false;var u=t[0].charAt(o),s=u.toLowerCase();for(var l=1;l<t.length;++l){a=true;var f=t[l].charAt(o),c=f.toLowerCase();if(u!==f){if(n||r==="mixed"){a=false;break}else if(s===c){if(r==="lower"){u=u.toLowerCase()}else if(r==="upper"){u=u.toUpperCase()}else{a=false;break}}else{a=false;break}}}if(a){i.push(u)}else{break}}return e+i.join("")}function trigger_terminal_change(t){terminals.forEach(function(e){e.settings().onTerminalChange.call(e,t)})}var select=function(){if(window.getSelection){var e=window.getSelection();if(e.setBaseAndExtent){return function(e,t){var n=window.getSelection();n.setBaseAndExtent(e,0,t,1)}}else{return function(e,t){var n=window.getSelection();var r=document.createRange();r.setStart(e,0);r.setEnd(t,t.childNodes.length);n.removeAllRanges();n.addRange(r)}}}else{return $.noop}}();function select_all(e){if(window.getSelection){var t=window.getSelection();if(t.setBaseAndExtent){t.setBaseAndExtent(e,0,e,1)}else if(document.createRange){var n=document.createRange();n.selectNodeContents(e);t.removeAllRanges();t.addRange(n)}}}function process_command(e,t){var n=e.match(command_re)||[];if(n.length){var r=n.shift();var i=$.map(n,function(e){if(e.match(/^["']/)){e=e.replace(/\n/g,"\\u0000\\u0000\\u0000\\u0000");e=t(e);return e.replace(/\x00\x00\x00\x00/g,"\n")}return t(e)});var o=$.map(n,function(e){var t=e.match(/^(['"]).*\1$/);return t&&t[1]||""});var a=e.substring(r.length).trim();return{command:e,name:r,args:i,args_quotes:o,rest:a}}else{return{command:e,name:"",args:[],args_quotes:o,rest:""}}}$.terminal={version:"1.23.2",date:"Tue, 18 Sep 2018 14:16:35 +0000",color_names:["transparent","currentcolor","black","silver","gray","white","maroon","red","purple","fuchsia","green","lime","olive","yellow","navy","blue","teal","aqua","aliceblue","antiquewhite","aqua","aquamarine","azure","beige","bisque","black","blanchedalmond","blue","blueviolet","brown","burlywood","cadetblue","chartreuse","chocolate","coral","cornflowerblue","cornsilk","crimson","cyan","darkblue","darkcyan","darkgoldenrod","darkgray","darkgreen","darkgrey","darkkhaki","darkmagenta","darkolivegreen","darkorange","darkorchid","darkred","darksalmon","darkseagreen","darkslateblue","darkslategray","darkslategrey","darkturquoise","darkviolet","deeppink","deepskyblue","dimgray","dimgrey","dodgerblue","firebrick","floralwhite","forestgreen","fuchsia","gainsboro","ghostwhite","gold","goldenrod","gray","green","greenyellow","grey","honeydew","hotpink","indianred","indigo","ivory","khaki","lavender","lavenderblush","lawngreen","lemonchiffon","lightblue","lightcoral","lightcyan","lightgoldenrodyellow","lightgray","lightgreen","lightgrey","lightpink","lightsalmon","lightseagreen","lightskyblue","lightslategray","lightslategrey","lightsteelblue","lightyellow","lime","limegreen","linen","magenta","maroon","mediumaquamarine","mediumblue","mediumorchid","mediumpurple","mediumseagreen","mediumslateblue","mediumspringgreen","mediumturquoise","mediumvioletred","midnightblue","mintcream","mistyrose","moccasin","navajowhite","navy","oldlace","olive","olivedrab","orange","orangered","orchid","palegoldenrod","palegreen","paleturquoise","palevioletred","papayawhip","peachpuff","peru","pink","plum","powderblue","purple","red","rosybrown","royalblue","saddlebrown","salmon","sandybrown","seagreen","seashell","sienna","silver","skyblue","slateblue","slategray","slategrey","snow","springgreen","steelblue","tan","teal","thistle","tomato","turquoise","violet","wheat","white","whitesmoke","yellow","yellowgreen"],Cycle:Cycle,History:History,Stack:Stack,valid_color:function e(t){if(t.match(color_hex_re)){return true}else{return $.inArray(t.toLowerCase(),$.terminal.color_names)!==-1}},unclosed_strings:function e(t){return!!t.match(unclosed_strings_re)},escape_regex:function e(t){if(typeof t==="string"){var n=/([-\\^$[\]()+{}?*.|])/g;return t.replace(n,"\\$1")}},have_formatting:function e(t){return typeof t==="string"&&!!t.match(format_exist_re)},is_formatting:function e(t){return typeof t==="string"&&!!t.match(format_full_re)},format_split:function e(t){return t.split(format_split_re).filter(Boolean)},tracking_replace:function e(i,t,n,r){function o(e,t,n){return e.substring(t,n)}function a(e){return $.terminal.strip(e).length}function u(e){var t=a(i.substring(0,e));for(var n=e;n<i.length;++n){var r=a(i.substring(0,n));if(r===t+1){return t}t=r}return t}var s="";var l;var f=0;var c;var p=u(r);var m;t.lastIndex=0;while(l=t.exec(i)){if(t.global){var D=u(t.lastIndex);var d=a(o(i,0,D));m=d-a(l[0])}else{m=u(l.index);d=m+a(l[0])}if(f<m){s+=o(i,f,m)}f=d;if(typeof n==="function"){c=n.apply(null,l)}else{c=n.replace(/\$(\$|\d)/g,function(e,t){if(t==="$"){return"$"}return l[t]})}s+=c;if(m<r){if(d<r){p=Math.max(0,p+a(c)-a(l[0]))}else{p+=a(c)-(r-m)}}if(!t.global){break}}if(f<a(i)){s+=o(i,f)}if(i===s){return[i,r]}return[s,p]},iterate_formatting:function e(t,n){function r(e){return t.substring(e-6,e)==="&nbsp;"||t.substring(e-1,e).match(/\s/)}var i=/^(&(?:[a-z\d]+|#\d+|#x[a-f\d]+);)/i;function o(e){return t.substring(e).match(i)}function a(e){return t[e]==="["&&t[e+1]==="["}function u(e){return t[e]==="]"&&t[e-1]==="\\"}function s(e){return _&&(t[e]!=="]"||!l)&&!y}var l=$.terminal.have_formatting(t);var f="";var c=false;var p=0;var m;var D=-1;var d;var h=0;for(var g=0;g<t.length;g++){var v=t.substring(g);m=v.match(format_start_re);if(m){f=m[1];c=false}else if(f){if(t[g]==="]"){if(c){f="";c=false}else{c=true}}}else{c=true}var _=f&&c||!f;var y=a(g);if(r(g)&&(_||y)){if(D===-1&&d!==g||D!==-1){D=g}}var b=t[g].match(/[[\]]/);if(_){if(t[g]==="&"){m=o(g);if(m){g+=m[1].length-2;continue}++p;++h}else if(u(g)){--p;--h}else if(!b||!l){++p;++h}}if(s(g)){if(strlen(t[g])===2){h++}var w={count:p,index:g,formatting:f,length:h,text:c,space:D};var C=n(w);if(C===false){break}else if(C){if(C.count!==undefined){p=C.count}if(C.length!==undefined){h=C.length}if(C.space!==undefined){d=D;D=C.space}if(C.index!==undefined){g=C.index;continue}}}else if(g===t.length-1){n({count:p+1,index:g,formatting:f,length:0,text:c,space:D})}var E=get_next_character(v);if(E.length>1){g+=E.length-1}}},substring:function e(n,r,i){var t=$.terminal.split_characters(text(n));if(!t.slice(r,i).length){return""}var o=0;var a;var u="";var s="";var l;var f=/(&[^;]+);$/;$.terminal.iterate_formatting(n,function(e){var t;if(r&&e.count===r+1){o=e.index;t=n.substring(0,o+1).match(f);if(t){o-=t[1].length}if(e.formatting){u=e.formatting}}if(i&&e.count===i){s=e.formatting;l=e.index}if(e.count===i+1){a=e.index;t=n.substring(0,a+1).match(f);if(t){a-=t[1].length}if(e.formatting){a=l+1}}});if(r&&!o){return""}if(a===undefined){a=n.length}n=u+n.substring(o,a);if(s){n=n.replace(/(\[\[^\]]+)?\]$/,"");n+="]"}return n},normalize:function e(t){return t.replace(format_re,function(e,t,n){if(n===""){return""}function r(e){return e.replace(/\\\]/g,"&#93;").replace(/\n/g,"\\n").replace(/&nbsp;/g," ")}t=r(t);var i=t.match(/;/g).length;if(i>=4){var o=t.split(/;/);var a=o.slice(0,4).join(";");var u=o.slice(4).join(";");return"[["+a+";"+(u||n)+"]"+n+"]"}else if(i===2){i=";;"}else if(i===3){i=";"}else{i=""}return"[["+t+i+r(n)+"]"+n+"]"})},split_equal:function e(t,p,m){var D="";var d=[];var n=$.terminal.normalize(t).split(/\n/g);for(var r=0,i=n.length;r<i;++r){if(n[r]===""){d.push("");continue}var h=n[r];var g=0;var v;var _=h.length;var o=$.terminal.split_characters(text(h));var y=o[o.length-1];$.terminal.iterate_formatting(h,function(e){var t=e.index===_-y.length;var n,r;if(e.length>=p||t||e.length===p-1&&strlen(h[e.index+1])===2){var i=false;if(m&&e.space!==-1){var o=text(h.substring(e.space));var a=o.length;var u=e.index+p+1;o=o.substring(0,u);if(o.match(/\s|&nbsp;/)||u>a){i=true}}var s;if(m&&e.space!==-1&&e.index!==_-1&&i){v=h.substring(g,e.space);s=e.space-1}else{r=h.substring(e.index);n=get_next_character(r);v=h.substring(g,e.index)+n;s=e.index+n.length-1}if(m){v=v.replace(/^(&nbsp;|\s)+|(&nbsp;|\s)+$/g,"")}g=(s||e.index)+1;if(D){var l=v.match(/^[^\]]*\]/);v=D+v;if(l){D=""}}var f=v.match(format_re);if(f){var c=f[f.length-1];if(c[c.length-1]!=="]"){D=c.match(format_begin_re)[1];v+="]"}else if(v.match(format_end_re)){v=v.replace(format_end_re,"");D=c.match(format_begin_re)[1]}}d.push(v);return{index:s,length:0,space:-1}}})}return d},amp:function e(t){return t.replace(/&(?!#[0-9]+;|[a-zA-Z]+;)/g,"&amp;")},encode:function e(t,n){var s=$.extend({tabs:4,before:""},n);return $.terminal.amp(t).replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/ /g,"&nbsp;").split("\n").map(function(e){var u=e.split(/((?:\[\[[^\]]+\])?\t(?:\])?)/);u=u.filter(Boolean);return u.map(function(e,a){if(e.match(/\t/)){return e.replace(/\t([^\t]*)$/,function(e,t){if(a!==0&&u[a-1].match(/\t\]?$/)){var n=new Array(s.tabs+1).join("&nbsp;");return n+t}else{var r=u.slice(a-1,a).join("");if(s.before&&a<=1){r=s.before+r}var i=$.terminal.length(r);var o=s.tabs-i%s.tabs;if(o===0){o=4}return new Array(o+1).join("&nbsp;")+t}})}return e}).join("")}).join("\n")},nested_formatting:function e(t){if(!$.terminal.have_formatting(t)){return t}var n=[];var r=/((?:\[\[(?:[^\][]|\\\])+\])?(?:[^\][]|\\\])*\]?)/;var i=/(\[\[(?:[^\][]|\\\])+\])[\s\S]*/;return t.split(r).filter(Boolean).map(function(e){if(e.match(/^\[\[/)){if(!$.terminal.is_formatting(e)){e+="]";n.push(e.replace(i,"$1"))}}else{var t=false;if(e.match(/\]/)){t=true}if(n.length){e=n[n.length-1]+e}if(t){n.pop()}else if(n.length){e+="]"}}return e}).join("")},escape_formatting:function e(t){return $.terminal.escape_brackets(t)},apply_formatters:function e(t,i){if(t===""){if(typeof i.position==="number"){return["",i.position]}else{return""}}function o(e,t,n,r){if(!e.__no_warn__&&$.terminal.length(n)!==$.terminal.length(r)){warn("Your formatter["+t+"] change length of the string, "+"you should use [regex, replacement] formatter or function "+" that return [replacement, position] instead")}}var n=$.terminal.defaults.formatters;i=i||{};var f=0;function c(e,t){var n=$.extend({},i,{position:t[1]});var r=e(t[0],n);if(typeof r==="string"){o(e,f-1,r,t[0]);if(typeof r==="string"){return[r,n.position]}return t}else if(r instanceof Array&&r.length===2){return r}else{return t}}var r;if(typeof i.position==="number"){r=[t,i.position]}else{r=[t,0]}try{var a=n.reduce(function(a,u){f++;if(typeof u==="function"&&u.__meta__){return c(u,a)}else{var s=0;var l=false;var e=$.terminal.format_split(a[0]);var t=e.map(function(e){var t;var n=text(e).length;if(a[1]<=s+n&&!l){t=a[1]-s;l=true}else{t=-1}var r=s;var i;s+=n;if($.terminal.is_formatting(e)){return[e,-1]}else{if(u instanceof Array){var o=u[2]||{};i=[e,t<0?0:t];if(i[0].match(u[0])){if(o.loop){while(i[0].match(u[0])){i=$.terminal.tracking_replace(i[0],u[0],u[1],i[1])}}else{i=$.terminal.tracking_replace(i[0],u[0],u[1],i[1])}}if(t<0){return[i[0],-1]}}else if(typeof u==="function"){i=c(u,[e,t])}if(typeof i!=="undefined"){if(i[1]!==-1){i[1]+=r}return i}return[e,-1]}});var n=t.filter(function(e){return e[1]!==-1})[0];var r=t.map(function(e){return e[0]}).join("");var i;if(typeof n==="undefined"){i=a[1]}else{i=n[1]}var o=text(r).length;if(i>o){i=o}if(r===a[0]){return a}return[r,i]}},r);if(typeof i.position==="number"){var u=$.terminal.strip(a[0]).length;if($.terminal.length(a[0])<u){var s=a[1];s=normalize_position(a[0],s);var l=$.terminal.length(a[0]);if(s>l){s=l}a[1]=s}return a}else{return a[0]}}catch(e){var p="Error in formatter ["+(f-1)+"]";n.splice(f-1);throw new $.terminal.Exception("formatting",p,e.stack)}},format:function e(t,m){function D(e){if(e.match(/\\]/)){e=e.replace(/(\\+)]/g,function(e,t){if(t.length%2===1){return"]"}else{return t.replace(/../,"\\")}})}return safe(e)}var d=$.extend({},{linksNoReferrer:false,linksNoFollow:false,anyLinks:false},m||{});if(typeof t==="string"){var n=$.terminal.format_split(t);t=$.map(n,function(e){if(e===""){return e}else if($.terminal.is_formatting(e)){e=e.replace(/\[\[[^\]]+\]/,function(e){return e.replace(/&nbsp;/g," ")});return e.replace(format_parts_re,function(e,t,n,r,i,o,a){if(a===""){return""}a=D(a);var u="";if(t.indexOf("b")!==-1){u+="font-weight:bold;"}var s=[];if(t.indexOf("u")!==-1){s.push("underline")}if(t.indexOf("s")!==-1){s.push("line-through")}if(t.indexOf("o")!==-1){s.push("overline")}if(s.length){u+="text-decoration:"+s.join(" ")+";"}if(t.indexOf("i")!==-1){u+="font-style:italic;"}if($.terminal.valid_color(n)){u+="color:"+n+";"+"--color:"+n+";";if(t.indexOf("g")!==-1){u+="text-shadow:0 0 5px "+n+";"}}if($.terminal.valid_color(r)){u+="background-color:"+r}var l;if(o===""){l=a}else{l=o.replace(/&#93;/g,"]").replace(/>/g,"&gt;").replace(/</g,"&lt;")}var f=extra_css(a,m);if(f){a=wide_characters(a,m);u+=f}var c;if(t.indexOf("!")!==-1){if(l.match(email_re)){c='<a href="mailto:'+l+'"'}else{if(!d.anyLinks&&!l.match(/^(https?|ftp):\/\//)){l=""}c='<a target="_blank" href="'+l+'"';var p=["noopener"];if(d.linksNoReferrer){p.unshift("noreferrer")}if(d.linksNoFollow){p.unshift("nofollow")}c+=' rel="'+p.join(" ")+'"'}c+=' tabindex="1000"'}else{c="<span"}if(u!==""){c+=' style="'+u+'"'}if(i!==""){c+=' class="'+i+'"'}if(t.indexOf("!")!==-1){c+=">"+a+"</a>"}else{c+=' data-text="'+l.replace(/"/g,"&quote;")+'">'+a+"</span>"}return c})}else{e=D(e);var t=extra_css(e,m);if(t.length){e=wide_characters(e,m);return'<span style="'+t+'">'+e+"</span>"}else{return"<span>"+e+"</span>"}}}).join("");return t.replace(/<span><br\s*\/?><\/span>/gi,"<br/>")}else{return""}},escape_brackets:function e(t){return t.replace(/\[/g,"&#91;").replace(/\]/g,"&#93;")},unescape_brackets:function e(t){return t.replace(/&#91;/g,"[").replace(/&#93;/g,"]")},length:function(e){return $.terminal.split_characters(text(e)).length},split_characters:function e(t){var n=[];while(t.length){var r=get_next_character(t);t=t.substring(r.length);n.push(r)}return n},columns:function(e,t,n){var r=e.map(function(e){return $.terminal.strip(e)});var i=r.map(function(e){return strlen(e)});if(typeof n==="undefined"){n=4}var o=Math.max.apply(null,i)+n;var a=Math.floor(t/o)-1;if(a<1){return e.join("\n")}var u=[];for(var s=0,l=e.length;s<l;s+=a){var f=e.slice(s,s+a);var c=f.pop();u.push(f.reduce(function(e,t){var n=$.terminal.strip(t);var r=new Array(o-n.length+1).join(" ");e.push(t+r);return e},[]).join("")+c)}return u.join("\n")},strip:function e(t){t=t.replace(format_parts_re,"$6");return t.replace(/\\([[\]])/g,function(e,t){return t})},active:function e(){return terminals.front()},last_id:function e(){var t=terminals.length();return t-1},parse_argument:function e(t,n){function r(e){return e.split(string_re).map(function(e){if(e.match(/^['"]/)){if(e==='""'||e==="''"){return""}var t=e[0];var n=new RegExp("(^|(?:\\\\(?:\\\\)*)?)"+t,"g");e=e.replace(n,"$1")}e='"'+e+'"';return JSON.parse(e)}).join("")}if(n===false){if(t[0]==="'"&&t[t.length-1]==="'"){return t.replace(/^'|'$/g,"")}else if(t[0]==='"'&&t[t.length-1]==='"'){return t.replace(/^"|"$/g,"").replace(/\\([" ])/g,"$1")}else if(t.match(/\/.*\/[gimy]*$/)){return t}else if(t.match(/['"]]/)){return r(t)}else{return t.replace(/\\ /g," ")}}var i=t.match(re_re);if(i){return new RegExp(i[1],i[2])}else if(t.match(/['"]/)){return r(t)}else if(t.match(/^-?[0-9]+$/)){return parseInt(t,10)}else if(t.match(float_re)){return parseFloat(t)}else{return t.replace(/\\(['"() ])/g,"$1")}},parse_arguments:function e(t){return $.map(t.match(command_re)||[],$.terminal.parse_argument)},split_arguments:function e(t){return $.map(t.match(command_re)||[],function(e){return $.terminal.parse_argument(e,false)})},parse_command:function e(t){return process_command(t,$.terminal.parse_argument)},split_command:function e(t){return process_command(t,function(e){return $.terminal.parse_argument(e,false)})},parse_options:function e(t,n){var o=$.extend({},{boolean:[]},n);if(typeof t==="string"){return e($.terminal.split_arguments(t),n)}var a={_:[]};function u(e){this.value=e}var r=t.reduce(function(e,t){if(typeof t!=="string"){t=String(t)}if(t.match(/^-/)&&e instanceof u){a[e.value]=true}if(t.match(/^--/)){var n=t.replace(/^--/,"");if(o.boolean.indexOf(n)===-1){return new u(n)}else{a[n]=true}}else if(t.match(/^-/)){var r=t.replace(/^-/,"").split("");if(o.boolean.indexOf(r.slice(-1)[0])===-1){var i=r.pop()}r.forEach(function(e){a[e]=true});if(i){return new u(i)}}else if(e instanceof u){a[e.value]=t}else if(t){a._.push(t)}return null},null);if(r instanceof u){a[r.value]=true}return a},extended_command:function extended_command(term,string,options){var settings=$.extend({invokeMethods:false},options);try{change_hash=false;var m=string.match(extended_command_re);if(m){if(!settings.invokeMethods){warn("To invoke terminal or cmd methods you need to enable "+"invokeMethods option");return}string=m[1];var obj=m[2]==="terminal"?term:term.cmd();var fn=m[3];try{var args=eval("["+m[4]+"]");if(!obj[fn]){term.error("Unknow function "+fn)}else{obj[fn].apply(term,args)}}catch(e){term.error("Invalid invocation in "+$.terminal.escape_brackets(string))}}else{term.exec(string,true).done(function(){change_hash=true})}}catch(e){}},iterator:function(t){function n(e){if($.terminal.is_formatting(e)){if(e.match(/\]\\\]/)){e=e.replace(/\]\\\]/g,"]\\\\]")}}return e}if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){var r=$.terminal.length(t);var i=0;var e={};e[Symbol.iterator]=function(){return{next:function(){if(i<r){var e=$.terminal.substring(t,i,i+1);i++;return{value:n(e)}}else{return{done:true}}}}};return e}},formatter:new function(){try{this[Symbol.split]=function(e){return $.terminal.format_split(e)};this[Symbol.match]=function(e){return e.match(format_re)};this[Symbol.replace]=function(e,t){return e.replace(format_parts_re,t)};this[Symbol.search]=function(e){return e.search(format_re)}}catch(e){}},new_formatter:function(e){var t=$.terminal.defaults.formatters;for(var n=0;n<t.length;++n){if(t[n]===$.terminal.nested_formatting){t.splice(n,0,e);return}}t.push(e)}};$.terminal.Exception=function e(t,n,r){if(arguments.length===1){this.message=arguments[0];this.type="TERMINAL"}else{this.type=t;this.message=n;if(r){this.stack=r}}};$.terminal.Exception.prototype=new Error;$.terminal.Exception.prototype.toString=function(){return this.message+"\n"+this.stack};$.fn.visible=function(){return this.css("visibility","visible")};$.fn.hidden=function(){return this.css("visibility","hidden")};var warnings=[];function warn(e){e="[jQuery Terminal] "+e;if(warnings.indexOf(e)===-1){warnings.push(e);if(console){if(console.warn){console.warn(e)}else if(console.log){console.log(e)}}else{setTimeout(function(){throw new Error("WARN: "+e)},0)}}}var ids={};$.jrpc=function(e,t,n,r,i){var a=new $.Deferred;var u;if($.isPlainObject(e)){u=e}else{u={url:e,method:t,params:n,success:r,error:i}}function s(e){return $.isNumeric(e.id)&&(typeof e.result!=="undefined"||typeof e.error!=="undefined")}ids[u.url]=ids[u.url]||0;var o={jsonrpc:"2.0",method:u.method,params:u.params,id:++ids[u.url]};$.ajax({url:u.url,beforeSend:function e(t,n){if(is_function(u.request)){u.request(t,o)}n.data=JSON.stringify(o)},success:function e(t,n,r){var i=r.getResponseHeader("Content-Type");if(!i.match(/(application|text)\/json/)){warn("Response Content-Type is neither application/json"+" nor text/json")}var o;try{o=JSON.parse(t)}catch(e){if(u.error){u.error(r,"Invalid JSON",e)}else{throw new $.terminal.Exception("JSON","Invalid JSON",e.stack)}a.reject({message:"Invalid JSON",response:t});return}if(is_function(u.response)){u.response(r,o)}if(s(o)||u.method==="system.describe"){if(u.success){u.success(o,n,r)}a.resolve(o)}else{if(u.error){u.error(r,"Invalid JSON-RPC")}a.reject({message:"Invalid JSON-RPC",response:t})}},error:u.error,contentType:"application/json",dataType:"text",async:true,cache:false,type:"POST"});return a.promise()};function get_char_size(e){var t=$('<div class="terminal temp"><div class="terminal-output">'+'<div><div class="line" style="float: left"><span>&nbsp;</span>'+"</div></div></div></div>").appendTo("body");t.addClass(e.attr("class"));if(e){var n=e.attr("style");if(n){n=n.split(/\s*;\s*/).filter(function(e){return!e.match(/display\s*:\s*none/i)}).join(";");t.attr("style",n)}}var r=t.find(".line")[0].getBoundingClientRect();var i={width:r.width,height:r.height};t.remove();return i}function get_num_chars(e,t){var n=e.find(".terminal-fill").width();var r=Math.floor(n/t.width);return r||1e3}function get_num_rows(e,t){return Math.floor(e.find(".terminal-fill").height()/t.height)}function all(e,t){var n=e.filter(function(e){return e[t]()===e});return n.length===e.length}function string_case(e){var t=e.split("");if(all(t,"toLowerCase")){return"lower"}else if(all(t,"toUpperCase")){return"upper"}else{return"mixed"}}function same_case(e){return string_case(e)!=="mixed"}function is_function(e){return get_type(e)==="function"}function get_type(e){return typeof e==="function"?"function":$.type(e)}var version_set=!$.terminal.version.match(/^\{\{/);var copyright="Copyright (c) 2011-2018 Jakub Jankiewicz <http://jcubic"+".pl/me>";var version_string=version_set?" v. "+$.terminal.version:" ";var reg=new RegExp(" {"+version_string.length+"}$");var name_ver="jQuery Terminal Emulator"+(version_set?version_string:"");var signatures=[["jQuery Terminal","(c) 2011-2018 jcubic"],[name_ver,copyright.replace(/^Copyright | *<.*>/g,"")],[name_ver,copyright.replace(/^Copyright /,"")],["      _______                 ________                        __","     / / _  /_ ____________ _/__  ___/______________  _____  / /"," __ / / // / // / _  / _/ // / / / _  / _/     / /  \\/ / _ \\/ /","/  / / // / // / ___/ // // / / / ___/ // / / / / /\\  / // / /__","\\___/____ \\\\__/____/_/ \\__ / /_/____/_//_/_/_/_/_/  \\/\\__\\_\\___/","         \\/          /____/                                   ".replace(reg," ")+version_string,copyright],["      __ _____                     ________                            "+"  __","     / // _  /__ __ _____ ___ __ _/__  ___/__ ___ ______ __ __  __ ___ "+" / /"," __ / // // // // // _  // _// // / / // _  // _//     // //  \\/ // _ "+"\\/ /","/  / // // // // // ___// / / // / / // ___// / / / / // // /\\  // // "+"/ /__","\\___//____ \\\\___//____//_/ _\\_  / /_//____//_/ /_/ /_//_//_/ /_/ \\"+"__\\_\\___/",("          \\/              /____/                                     "+"     ").replace(reg,"")+version_string,copyright]];$.terminal.nested_formatting.__meta__=true;$.terminal.nested_formatting.__no_warn__=true;$.terminal.defaults={prompt:"> ",history:true,exit:true,clear:true,enabled:true,maskChar:"*",wrap:true,checkArity:true,raw:false,invokeMethods:false,exceptionHandler:null,pauseEvents:true,softPause:false,memory:false,cancelableAjax:true,processArguments:true,linksNoReferrer:false,anyLinks:false,linksNoFollow:false,processRPCResponse:null,completionEscape:true,onCommandChange:null,convertLinks:true,extra:{},tabs:4,historySize:60,scrollObject:null,historyState:false,importHistory:false,historyFilter:null,echoCommand:true,scrollOnEcho:true,login:null,outputLimit:-1,formatters:[$.terminal.nested_formatting],onAjaxError:null,pasteImage:true,scrollBottomOffset:20,wordAutocomplete:true,caseSensitiveAutocomplete:true,caseSensitiveSearch:true,clickTimeout:200,holdTimeout:400,holdRepeatTimeout:200,request:$.noop,response:$.noop,describe:"procs",onRPCError:null,doubleTab:null,completion:false,onInit:$.noop,onClear:$.noop,onBlur:$.noop,onFocus:$.noop,onTerminalChange:$.noop,onExit:$.noop,onPush:$.noop,onPop:$.noop,keypress:$.noop,keydown:$.noop,onAfterRedraw:$.noop,onEchoCommand:$.noop,onFlush:$.noop,strings:{comletionParameters:"From version 1.0.0 completion function need to"+" have two arguments",wrongPasswordTryAgain:"Wrong password try again!",wrongPassword:"Wrong password!",ajaxAbortError:"Error while aborting ajax call!",wrongArity:"Wrong number of arguments. Function '%s' expects %s got"+" %s!",commandNotFound:"Command '%s' Not Found!",oneRPCWithIgnore:"You can use only one rpc with describe == false "+"or rpc without system.describe",oneInterpreterFunction:"You can't use more than one function (rpc "+"without system.describe or with option describe == false count"+"s as one)",loginFunctionMissing:"You didn't specify a login function",noTokenError:"Access denied (no token)",serverResponse:"Server responded",wrongGreetings:"Wrong value of greetings parameter",notWhileLogin:"You can't call `%s' function while in login",loginIsNotAFunction:"Authenticate must be a function",canExitError:"You can't exit from main interpreter",invalidCompletion:"Invalid completion",invalidSelector:"Sorry, but terminal said that you use invalid "+"selector!",invalidTerminalId:"Invalid Terminal ID",login:"login",password:"password",recursiveCall:"Recursive call detected, skip",notAString:"%s function: argument is not a string",redrawError:"Internal error, wrong position in cmd redraw",invalidStrings:"Command %s have unclosed strings",defunctTerminal:"You can't call method on terminal that was destroyed"}};var requests=[];var terminals=new Cycle;var save_state=[];var hash_commands;var change_hash=false;var fire_hash_change=true;var first_instance=true;$.fn.terminal=function(e,t){function n(n){if(n){this.storage={}}this.set=function(e,t){if(n){this.storage[e]=t}else{$.Storage.set(e,t)}};this.get=function(e){if(n){return this.storage[e]}else{return $.Storage.get(e)}};this.remove=function(e){if(n){delete this.storage[e]}else{$.Storage.remove(e)}}}function f(e){if($.terminal.unclosed_strings(e)){var t=$.terminal.escape_brackets(e);var n=sprintf(H().invalidStrings,"`"+t+"`");throw new $.terminal.Exception(n)}else if(is_function(le.processArguments)){return process_command(e,le.processArguments)}else if(le.processArguments){return $.terminal.parse_command(e)}else{return $.terminal.split_command(e)}}function p(e){if(typeof e==="string"){M.echo(e)}else if(e instanceof Array){M.echo($.map(e,function(e){return JSON.stringify(e)}).join(" "))}else if(typeof e==="object"){M.echo(JSON.stringify(e))}else{M.echo(e)}}function c(e){var t=/(.*):([0-9]+):([0-9]+)$/;var i=e.match(t);if(i){M.pause(le.softPause);$.get(i[1],function(e){var t=i[1];M.echo("[[b;white;]"+t+"]");var n=e.split("\n");var r=+i[2]-1;M.echo(n.slice(r-2,r+3).map(function(e,t){if(t===2){e="[[;#f00;]"+$.terminal.escape_brackets(e)+"]"}return"["+(r+t-1)+"]: "+e}).join("\n")).resume()},"text")}}function a(e){if(is_function(le.onRPCError)){le.onRPCError.call(M,e)}else{M.error("&#91;RPC&#93; "+e.message);if(e.error&&e.error.message){e=e.error;var t="\t"+e.message;if(e.file){t+=' in file "'+e.file.replace(/.*\//,"")+'"'}if(e.at){t+=" at line "+e.at}M.error(t)}}}function m(n,r){var i=function(e,t){M.pause(le.softPause);$.jrpc({url:n,method:e,params:t,request:function(e,t){try{le.request.call(M,e,t,M)}catch(e){g(e,"USER")}},response:function(e,t){try{le.response.call(M,e,t,M)}catch(e){g(e,"USER")}},success:function e(t){if(t.error){a(t.error)}else if(is_function(le.processRPCResponse)){le.processRPCResponse.call(M,t.result,M)}else{p(t.result)}M.resume()},error:d})};return function(e,t){if(e===""){return}try{e=f(e)}catch(e){g(e,"TERMINAL (get_processed_command)");return}if(!r||e.name==="help"){i(e.name,e.args)}else{var n=t.token();if(n){i(e.name,[n].concat(e.args))}else{t.error("&#91;AUTH&#93; "+H().noTokenError)}}}}function D(a,u,s,l){return function(e,t){if(e===""){return}var n;try{n=f(e)}catch(e){if(is_function(le.exception)){le.exception(e,M)}else{M.error("Error: "+(e.message||e))}return}var r=a[n.name];var i=get_type(r);if(i==="function"){if(u&&r.length!==n.args.length){M.error("&#91;Arity&#93; "+sprintf(H().wrongArity,n.name,r.length,n.args.length))}else{return r.apply(M,n.args)}}else if(i==="object"||i==="string"){var o=[];if(i==="object"){o=Object.keys(r);r=D(r,u,s)}t.push(r,{prompt:n.name+"> ",name:n.name,completion:i==="object"?o:undefined})}else if(is_function(l)){l(e,M)}else if(is_function(le.onCommandNotFound)){le.onCommandNotFound.call(M,e,M)}else{t.error(sprintf(H().commandNotFound,n.name))}}}function d(e,t,n){M.resume();if(is_function(le.onAjaxError)){le.onAjaxError.call(M,e,t,n)}else if(t!=="abort"){M.error("&#91;AJAX&#93; "+t+" - "+H().serverResponse+":\n"+$.terminal.escape_brackets(e.responseText))}}function h(o,u,i){function s(e){if(e.error){a(e.error)}else if(is_function(le.processRPCResponse)){le.processRPCResponse.call(M,e.result,M)}else{p(e.result)}M.resume()}function l(e,t){try{le.request.call(M,e,t,M)}catch(e){g(e,"USER")}}function f(e,t){try{le.response.call(M,e,t,M)}catch(e){g(e,"USER")}}function e(n){var r=n;if(le.describe!==""){le.describe.split(".").forEach(function(e){r=r[e]})}if(r&&r.length){var t={};$.each(r,function(e,i){if($.isPlainObject(i)&&typeof i.name==="string"){t[i.name]=function(){var e=u&&i.name!=="help";var t=Array.prototype.slice.call(arguments);var n=t.length+(e?1:0);if(le.checkArity&&i.params&&i.params.length!==n){M.error("&#91;Arity&#93; "+sprintf(H().wrongArity,i.name,i.params.length,n))}else{M.pause(le.softPause);if(e){var r=M.token(true);if(r){t=[r].concat(t)}else{M.error("&#91;AUTH&#93; "+H().noTokenError)}}$.jrpc({url:o,method:i.name,params:t,request:l,response:f,success:s,error:d})}}}});var a=typeof u==="string"?u:"login";t.help=t.help||function(i){if(typeof i==="undefined"){var e=n.procs.map(function(e){return e.name}).join(", ")+", help";M.echo("Available commands: "+e)}else{var o=false;$.each(r,function(e,t){if(t.name===i){o=true;var n="";n+="[[bu;;]"+t.name+"]";if(t.params){var r=t.params;if(u&&t.name!==a){r=r.slice(1)}n+=" "+r.join(" ")}if(t.help){n+="\n"+t.help}M.echo(n);return false}});if(!o){if(i==="help"){M.echo("[[bu;;]help] [method]\ndisplay help "+"for the method or list of methods if not"+" specified")}else{var t="Method `"+i+"' not found ";M.error(t)}}}};i(t)}else{i(null)}}return $.jrpc({url:o,method:"system.describe",params:[],success:e,request:l,response:f,error:function e(){i(null)}})}function s(t,a,n){n=n||$.noop;var e=get_type(t);var u;var r={};var s=0;var l;if(e==="array"){u={};(function t(e,n){if(e.length){var r=e[0];var i=e.slice(1);var o=get_type(r);if(o==="string"){M.pause(le.softPause);if(le.describe===false){if(++s===1){l=m(r,a)}else{M.error(H().oneRPCWithIgnore)}t(i,n)}else{h(r,a,function(e){if(e){$.extend(u,e)}else if(++s===1){l=m(r,a)}else{M.error(H().oneRPCWithIgnore)}M.resume();t(i,n)})}}else if(o==="function"){if(l){M.error(H().oneInterpreterFunction)}else{l=r}t(i,n)}else if(o==="object"){$.extend(u,r);t(i,n)}}else{n()}})(t,function(){n({interpreter:D(u,false,a,l.bind(M)),completion:Object.keys(u)})})}else if(e==="string"){if(le.ignoreSystemDescribe){u={interpreter:m(t,a)};if($.isArray(le.completion)){u.completion=le.completion}n(u)}else{M.pause(le.softPause);h(t,a,function(e){if(e){r.interpreter=D(e,false,a);r.completion=Object.keys(e)}else{r.interpreter=m(t,a)}n(r);M.resume()})}}else if(e==="object"){n({interpreter:D(t,le.checkArity,a),completion:Object.keys(t)})}else{if(e==="undefined"){t=$.noop}else if(e!=="function"){var i=e+" is invalid interpreter value";throw new $.terminal.Exception(i)}n({interpreter:t,completion:le.completion})}}function l(r,e){var i=get_type(e)==="boolean"?"login":e;return function(e,t,n){M.pause(le.softPause);$.jrpc({url:r,method:i,params:[e,t],request:function(e,t){try{le.request.call(M,e,t,M)}catch(e){g(e,"USER")}},response:function(e,t){try{le.response.call(M,e,t,M)}catch(e){g(e,"USER")}},success:function e(t){if(!t.error&&t.result){n(t.result)}else{n(null)}M.resume()},error:d})}}function g(e,t,n){if(is_function(le.exceptionHandler)){le.exceptionHandler.call(M,e,t)}else{M.exception(e,t);if(!n){setTimeout(function(){throw e},0)}}}var v=[];var _=1;function u(e,t,n){var r,i;v.push(_);if(e===""){}else if(!n.raw){var o={linksNoReferrer:le.linksNoReferrer,linksNoFollow:le.linksNoFollow,anyLinks:le.anyLinks,char_width:ne.width};var a=M.cols();if((strlen(e)>a||e.match(/\n/))&&(le.wrap===true&&n.wrap===undefined||le.wrap===false&&n.wrap===true)){var u=n.keepWords;var s=$.terminal.split_equal(e,a,u);for(r=0,i=s.length;r<i;++r){if(s[r]===""||s[r]==="\r"){v.push("<span></span>")}else{v.push($.terminal.format(s[r],o))}}}else{e=$.terminal.normalize(e);e=$.terminal.format(e,o);e.split(/\n/).forEach(function(e){v.push(e)})}}else{v.push(e)}v.push({finalize:n.finalize,index:t})}function o(e){try{var n=$.extend({exec:true,raw:false,finalize:$.noop},e.options||{});var t;var r=e.string;var i=is_function(r);if(i){r=r()}if(get_type(r)!=="string"){if(is_function(le.parseObject)){var o=le.parseObject(r);if(get_type(o)==="string"){t=o}}else if(r instanceof Array){t=$.terminal.columns(r,M.cols(),le.tabs)}else{t=String(r)}}else{t=r}if(t!==""){if(t!==""){if(!n.raw){if(le.convertLinks){t=t.replace(email_re,"[[!;;]$1]").replace(url_nf_re,"[[!;;]$1]")}if(n.formatters){try{t=$.terminal.apply_formatters(t,le)}catch(e){g(e,"FORMATTING")}}var a=t.split(format_exec_re);t=$.map(a,function(e){if(e&&e.match(format_exec_re)&&!$.terminal.is_formatting(e)){e=e.replace(/^\[\[|\]\]$/g,"");if(n.exec){var t;if(W){W=W.command.trim()}if(t===e.trim()){M.error(H().recursiveCall)}else{$.terminal.extended_command(M,e,{invokeMethods:le.invokeMethods})}}return""}else{return e}}).join("");if(t!==""){t=crlf($.terminal.normalize(t));t=$.terminal.encode(t,{tabs:le.tabs})}}if(t!==""){u(t,e.index,n)}}}if(t===""&&i){u(t,e.index,n)}}catch(e){v=[];if(is_function(le.exceptionHandler)){le.exceptionHandler.call(M,e,"TERMINAL")}else{alert_exception("[Internal Exception(process_line)]",e)}}}function r(e){e=$.extend({},{update:false,scroll:true},e||{});if(!e.update){ve.resize(Y);var t=J.empty().detach()}var i=[];if(le.outputLimit>=0){var n;if(le.outputLimit===0){n=M.rows()}else{n=le.outputLimit}ce.forEach(function(e,t){var n=e[0];var r=e[1];if(get_type(n)==="function"){n=n()}if(get_type(n)!=="string"){n=String(n)}i.push({string:n,index:t,options:r})});i=i.slice(i.length-n-1)}else{i=ce.map(function(e,t){return{string:e[0],index:t,options:e[1]}})}try{v=[];$.each(i,function(e,t){o(t)});if(!e.update){ve.before(t)}M.flush(e);try{le.onAfterRedraw.call(M,M)}catch(e){le.onAfterRedraw=$.noop;g(e,"onAfterRedraw")}}catch(e){if(is_function(le.exceptionHandler)){le.exceptionHandler.call(M,e,"TERMINAL (redraw)")}else{alert_exception("[redraw]",e)}}}function y(){if(le.outputLimit>=0){var e;if(le.outputLimit===0){e=M.rows()}else{e=le.outputLimit}var t=J.find("> div > div");if(t.length+1>e){var n=t.length-e+1;var r=t.slice(0,n);var i=r.parent();r.remove();i.each(function(){var e=$(this);if(e.is(":empty")){e.remove()}})}}}function i(){if(le.greetings===undefined){M.echo(M.signature,{finalize:a11y_hide,formatters:false})}else if(le.greetings){var e=typeof le.greetings;if(e==="string"){M.echo(le.greetings)}else if(e==="function"){try{le.greetings.call(M,M.echo)}catch(e){le.greetings=null;g(e,"greetings")}}else{M.error(H().wrongGreetings)}}}function b(n){if(typeof n==="undefined"){n=M.get_command()}var e=ve.prompt(true);var t=ve.mask();switch(typeof t){case"string":n=n.replace(/./g,t);break;case"boolean":if(t){n=n.replace(/./g,le.maskChar)}else{n=$.terminal.escape_formatting(n)}break}var r={finalize:function e(t){a11y_hide(t.addClass("command"));try{le.onEchoCommand.call(M,t,n)}catch(e){le.onEchoCommand=$.noop;M.exception(e)}}};if(is_function(e)){var i=e(function(e){M.echo(e+n,r)});if(i&&is_function(i.then)){i.then(function(e){if(typeof e==="string"){M.echo(e+n,r)}})}}else{M.echo(e+n,r)}}function w(){if(M.is("body")){return window.innerWidth-document.documentElement.clientWidth>0}return $e.outerWidth()!==M.outerWidth()}function C(e){var t=terminals.get()[e[0]];if(!t){throw new $.terminal.Exception(H().invalidTerminalId)}var n=e[1];if(save_state[n]){t.import_view(save_state[n])}else{change_hash=false;var r=e[2];if(r){t.exec(r).done(function(){change_hash=true;save_state[n]=t.export_view()})}}}function E(){if(change_hash){fire_hash_change=false;location.hash="#"+JSON.stringify(hash_commands);setTimeout(function(){fire_hash_change=true},100)}}var F=true;var x=[];function k(t,e,n){function r(){if(le.historyState||le.execHash&&n){if(!save_state.length){M.save_state()}else{M.save_state(null)}}}function i(){if(!n){change_hash=true;if(le.historyState){M.save_state(t,false)}change_hash=l}s.resolve();if(is_function(le.onAfterCommand)){le.onAfterCommand.call(M,M,t)}}function o(e){if(typeof e!=="undefined"){p(e)}i();M.resume()}function a(){var e=u.interpreter.call(M,t,M);if(e){M.pause(le.softPause);if(is_function(e.done||e.then)){(e.done||e.then).call(e,o)}else{return $.when(e).done(o)}}else if(de){x.push(function(){i()})}else{i()}}if(F){F=false;r()}try{if(is_function(le.onBeforeCommand)){if(le.onBeforeCommand.call(M,M,t)===false){return}}if(!n){W=$.terminal.split_command(t)}if(!L()){if(n&&(is_function(le.historyFilter)&&le.historyFilter(t)||t.match(le.historyFilter))){ve.history().append(t)}}var u=ge.top();if(!e&&le.echoCommand){b(t)}var s=new $.Deferred;var l=change_hash;if(t.match(/^\s*login\s*$/)&&M.token(true)){if(M.level()>1){M.logout(true)}else{M.logout()}i()}else if(le.exit&&t.match(/^\s*exit\s*$/)&&!ie){var f=M.level();if(f===1&&M.get_token()||f>1){if(M.get_token(true)){M.set_token(undefined,true)}M.pop()}i()}else if(le.clear&&t.match(/^\s*clear\s*$/)&&!ie){M.clear();i()}else{var c=a();if(c){return c}}return s.promise()}catch(e){g(e,"USER",n);M.resume();if(n){throw e}}}function A(){if(is_function(le.onBeforeLogout)){try{if(le.onBeforeLogout.call(M,M)===false){return}}catch(e){le.onBeforeLogout=$.noop;g(e,"onBeforeLogout")}}T();if(is_function(le.onAfterLogout)){try{le.onAfterLogout.call(M,M)}catch(e){le.onAfterLogout=$.noop;g(e,"onAfterlogout")}}M.login(Se,true,j)}function T(){var e=M.prefix_name(true)+"_";pe.remove(e+"token");pe.remove(e+"login")}function S(e){var t=M.prefix_name()+"_interpreters";var n=pe.get(t);if(n){n=JSON.parse(n)}else{n=[]}if($.inArray(e,n)===-1){n.push(e);pe.set(t,JSON.stringify(n))}}function R(e){var n=ge.top();var t=M.prefix_name(true);if(!L()){S(t)}var r=M.login_name(true);ve.name(t+(r?"_"+r:""));if(n.prompt!==ve.prompt()){if(is_function(n.prompt)){ve.prompt(function(t){var e=n.prompt.call(M,t,M);if(e&&is_function(e.then)){e.then(function(e){if(typeof e==="string"){t(e)}})}})}else{ve.prompt(n.prompt)}}if(typeof n.history!=="undefined"){M.history().toggle(n.history)}if($.isPlainObject(n.keymap)){ve.keymap($.omap(n.keymap,function(e,t){return function(){var e=[].slice.call(arguments);try{return t.apply(M,e)}catch(e){g(e,"USER KEYMAP")}}}))}ve.set("");ee.resolve();if(!e&&is_function(n.onStart)){n.onStart.call(M,M)}}function B(){if(fire_hash_change&&le.execHash){try{if(location.hash){var e=location.hash.replace(/^#/,"");hash_commands=JSON.parse(decodeURIComponent(e))}else{hash_commands=[]}if(hash_commands.length){C(hash_commands[hash_commands.length-1])}else if(save_state[0]){M.import_view(save_state[0])}}catch(e){g(e,"TERMINAL")}}}function j(){R();i();if(ce.length){M.refresh()}var e=false;if(is_function(le.onInit)){oe=function(){e=true};try{le.onInit.call(M,M)}catch(e){g(e,"OnInit")}finally{oe=$.noop;if(!e&&M.enabled()){M.resume()}}}if(first_instance){first_instance=false;$(window).on("hashchange",B)}}function L(){return ie||ve.mask()!==false}function O(e){var t,n=ge.top();if(is_function(n.keydown)){t=n.keydown.call(M,e,M);if(t!==undefined){return t}}else if(is_function(le.keydown)){t=le.keydown.call(M,e,M);if(t!==undefined){return t}}}var z={"CTRL+D":function(e,t){if(!ie){if(ve.get()===""){if(ge.size()>1||is_function(Se)){M.pop("")}else{M.resume();M.echo("")}}else{t()}}return false},"CTRL+C":function(){if(get_selected_text()===""){var e=M.get_command();var t=M.get_position();e=e.substring(0,t)+"^C"+e.substring(t+2);b(e);M.set_command("")}},"CTRL+L":function(){M.clear()},TAB:function(e,t){var n=ge.top(),r,i;if(typeof n.caseSensitiveAutocomplete!=="undefined"){i=n.caseSensitiveAutocomplete}else{i=le.caseSensitiveAutocomplete}if(le.completion&&get_type(le.completion)!=="boolean"&&n.completion===undefined){r=le.completion}else{r=n.completion}if(r==="settings"){r=le.completion}function o(e){M.complete(e,{echo:true,word:le.wordAutocomplete,escape:le.completionEscape,caseSensitive:i,doubleTab:le.doubleTab})}if(r){switch(get_type(r)){case"function":var a=M.before_cursor(le.wordAutocomplete);if(r.length===3){var u=new Error(H().comletionParameters);g(u,"USER");return false}var s=r.call(M,a,o);if(s&&is_function(s.then)){s.then(o)}break;case"array":o(r);break;default:throw new $.terminal.Exception(H().invalidCompletion)}}else{t()}return false},"CTRL+V":function(e,t){t(e);M.oneTime(200,function(){M.scroll_to_bottom()});return true},"CTRL+TAB":function(){if(terminals.length()>1){M.focus(false);return false}},PAGEDOWN:function(){M.scroll(M.height())},PAGEUP:function(){M.scroll(-M.height())}};function I(t){var e,n;if(M.enabled()){if(!M.paused()){e=O(t);if(e!==undefined){return e}if(t.which!==9){K=0}}else{if(!le.pauseEvents){e=O(t);if(e!==undefined){return e}}if(t.which===68&&t.ctrlKey){if(le.pauseEvents){e=O(t);if(e!==undefined){return e}}if(requests.length){for(n=requests.length;n--;){var r=requests[n];if(r.readyState!==4){try{r.abort()}catch(e){if(is_function(le.exceptionHandler)){le.exceptionHandler.call(M,t,"AJAX ABORT")}else{M.error(H().ajaxAbortError)}}}}requests=[]}M.resume()}return false}}}function P(e){var t=ge.top();if(me&&(!de||!le.pauseEvents)){if(is_function(t.keypress)){return t.keypress.call(M,e,M)}else if(is_function(le.keypress)){return le.keypress.call(M,e,M)}}}function N(t){return function(e){t.add(e)}}function H(){return $.extend({},$.terminal.defaults.strings,le&&le.strings||{})}var M=this;if(this.length>1){return this.each(function(){$.fn.terminal.call($(this),e,$.extend({name:M.selector},t))})}if(M.data("terminal")){return M.data("terminal")}if(M.length===0){var U=sprintf(H().invalidSelector);throw new $.terminal.Exception(U)}var q;var W;var K=0;var J;var Q=terminals.length();var Y;var G;var V;var X=new Stack;var Z=new DelayQueue;var ee=new DelayQueue;var te=N(ee);var ne=get_char_size(M);var re=N(Z);var ie=false;var oe=$.noop;var ae,ue;var se=[];var le=$.extend({},$.terminal.defaults,{name:M.selector,exit:!!(t&&t.login||!t)},t||{});delete le.formatters;var fe=false;var ce=[];var pe=new n(le.memory);var me=le.enabled;var De=false;var de=false;var he=true;var ge;var ve;var _e;var ye;var be;$.extend(M,$.omap({id:function(){return Q},clear:function(){J.html("");ce=[];try{le.onClear.call(M,M)}catch(e){g(e,"onClear")}M.attr({scrollTop:0});return M},export_view:function(){var e={};if(is_function(le.onExport)){try{e=le.onExport.call(M)}catch(e){g(e,"onExport")}}return $.extend({},{focus:me,mask:ve.mask(),prompt:M.get_prompt(),command:M.get_command(),position:ve.position(),lines:clone(ce),interpreters:ge.clone(),history:ve.history().data},e)},import_view:function(t){if(ie){throw new Error(sprintf(H().notWhileLogin,"import_view"))}if(is_function(le.onImport)){try{le.onImport.call(M,t)}catch(e){le.onImport=$.noop;g(e,"onImport")}}te(function e(){M.set_prompt(t.prompt);M.set_command(t.command);ve.position(t.position);ve.mask(t.mask);if(t.focus){M.focus()}ce=clone(t.lines).filter(function(e){return e[0]});if(t.interpreters instanceof Stack){ge=t.interpreters}if(le.importHistory){ve.history().set(t.history)}r()});return M},save_state:function(e,t,n){if(typeof n!=="undefined"){save_state[n]=M.export_view()}else{save_state.push(M.export_view())}if(!$.isArray(hash_commands)){hash_commands=[]}if(e!==undefined&&!t){var r=[Q,save_state.length-1,e];hash_commands.push(r);E()}return M},exec:function(n,r,e){var i=e||new $.Deferred;re(function e(){if($.isArray(n)){(function e(){var t=n.shift();if(t){M.exec(t,r).done(e)}else{i.resolve()}})()}else if(de){se.push([n,r,i])}else{var t=k(n,r,true);if(t&&(t.done||t.then)){(t.done||t.then).call(t,function(){i.resolve(M)})}}});return i.promise()},autologin:function(e,t,n){M.trigger("terminal.autologin",[e,t,n]);return M},login:function(r,i,o,a){X.push([].slice.call(arguments));if(ie){throw new Error(sprintf(H().notWhileLogin,"login"))}if(!is_function(r)){throw new Error(H().loginIsNotAFunction)}ie=true;if(M.token()&&M.level()===1&&!he){ie=false;M.logout(true)}else if(M.token(true)&&M.login_name(true)){ie=false;if(is_function(o)){o()}return M}if(le.history){ve.history().disable()}var u=M.level();function s(e,t,n){if(t){while(M.level()>u){M.pop(undefined,true)}if(le.history){ve.history().enable()}var r=M.prefix_name(true)+"_";pe.set(r+"token",t);pe.set(r+"login",e);ie=false;if(is_function(o)){o()}}else{if(i){if(!n){M.error(H().wrongPasswordTryAgain)}M.pop(undefined,true).set_mask(false)}else{ie=false;if(!n){M.error(H().wrongPassword)}M.pop(undefined,true).pop(undefined,true)}if(is_function(a)){a()}}M.off("terminal.autologin")}M.on("terminal.autologin",function(e,t,n,r){s(t,n,r)});M.push(function(n){M.set_mask(le.maskChar).push(function(e){try{var t=r.call(M,n,e,function(e,t){s(n,e,t)});if(t&&is_function(t.then)){M.pause();t.then(function(e){s(n,e);M.resume()})}}catch(e){g(e,"AUTH")}},{prompt:H().password+": ",name:"password"})},{prompt:H().login+": ",name:"login"});return M},settings:function(){return le},before_cursor:function(e){var t=ve.position();var n=ve.get().substring(0,t);var r=n.split(" ");var i;if(e){if(r.length===1){i=r[0]}else{var o=n.match(/(\\?")/g);var a=o?o.filter(function(e){return!e.match(/^\\/)}).length:0;o=n.match(/'/g);var u=o?o.length:0;if(u%2===1){i=n.match(/('[^']*)$/)[0]}else if(a%2===1){i=n.match(/("(?:[^"]|\\")*)$/)[0]}else{i=r[r.length-1];for(Ae=r.length-1;Ae>0;Ae--){var s=r[Ae-1];if(s[s.length-1]==="\\"){i=r[Ae-1]+" "+i}else{break}}}}}else{i=n}return i},complete:function(r,i){i=$.extend({word:true,echo:false,escape:true,caseSensitive:true,doubleTab:null},i||{});var o=i.caseSensitive;var a=M.before_cursor(i.word).replace(/\\"/g,'"');var s=false;if(i.word){if(a.match(/^"/)){s='"'}else if(a.match(/^'/)){s="'"}if(s){a=a.replace(/^["']/,"")}}r=r.slice();if(le.clear&&$.inArray("clear",r)===-1){r.push("clear")}if(le.exit&&$.inArray("exit",r)===-1){r.push("exit")}if(K%2===0){V=M.before_cursor(i.word)}else{var e=M.before_cursor(i.word);if(e!==V){return}}var t=$.terminal.escape_regex(a);if(i.escape){t=t.replace(/(\\+)(["'() ])/g,function(e,t,n){if(n.match(/[()]/)){return t+"\\?\\"+n}else{return t+"?"+n}})}function n(){var e=[];for(var t=r.length;t--;){if(l.test(r[t])){var n=r[t];if(s==='"'){n=n.replace(/"/g,'\\"')}if(!s&&i.escape){n=n.replace(/(["'() ])/g,"\\$1")}if(!o&&same_case(n)){if(a.toLowerCase()===a){n=n.toLowerCase()}else if(a.toUpperCase()===a){n=n.toUpperCase()}}e.push(n)}}return e}var u=o?"":"i";var l=new RegExp("^"+t,u);var f=n();function c(e,t){var n=M.get_command();var r=M.get_position();var i=new RegExp("^"+e,"i");var o=n.substring(0,r);var a=n.substring(r);var u=t.replace(i,"")+(s||"");M.set_command(o+u+a);M.set_position((o+u).length)}if(f.length===1){if(i.escape){c(t,f[0])}else{M.insert(f[0].replace(l,"")+(s||""))}V=M.before_cursor(i.word);return true}else if(f.length>1){if(++K>=2){K=0;if(i.echo){if(is_function(i.doubleTab)){var p=i.doubleTab.call(M,a,f,b);if(typeof p==="undefined"){return true}else{return p}}else if(i.doubleTab!==false){b();var m=f.reverse().join("\t");M.echo($.terminal.escape_brackets(m),{keepWords:true,formatters:false})}return true}}else{var D=common_string(a,f,o);if(D){c(a,D);V=M.before_cursor(i.word);return true}}}},commands:function(){return ge.top().interpreter},set_interpreter:function(e,t){function n(){M.pause(le.softPause);s(e,t,function(e){M.resume();var t=ge.top();$.extend(t,e);R(true)})}if(is_function(t)){M.login(t,true,n)}else if(get_type(e)==="string"&&t){M.login(l(e,t),true,n)}else{n()}return M},greetings:function(){i();return M},paused:function(){return de},pause:function(t){re(function e(){oe();de=true;ve.disable(t||is_android);if(!t){ve.find(".prompt").hidden()}if(is_function(le.onPause)){le.onPause.call(M)}});return M},resume:function(){re(function e(){de=false;if(me&&terminals.front()===M){ve.enable(true)}ve.find(".prompt").visible();var t=se;se=[];for(var n=0;n<t.length;++n){M.exec.apply(M,t[n])}M.trigger("resume");var r=x.shift();if(r){r()}M.scroll_to_bottom();if(is_function(le.onResume)){le.onResume.call(M)}});return M},cols:function(){if(le.numChars){return le.numChars}if(typeof Y==="undefined"||Y===1e3){Y=get_num_chars(M,ne)}return Y},rows:function(){if(le.numRows){return le.numRows}if(typeof G==="undefined"){G=get_num_rows(M,ne)}return G},history:function(){return ve.history()},history_state:function(e){function t(){le.historyState=true;if(!save_state.length){M.save_state()}else if(terminals.length()>1){M.save_state(null)}}if(e){if(typeof window.setImmediate==="undefined"){setTimeout(t,0)}else{setImmediate(t)}}else{le.historyState=false}return M},clear_history_state:function(){hash_commands=[];save_state=[];return M},next:function(){if(terminals.length()===1){return M}else{terminals.front().disable();var e=terminals.rotate().enable();var t=e.offset().top-50;$("html,body").animate({scrollTop:t},500);try{trigger_terminal_change(e)}catch(e){g(e,"onTerminalChange")}return e}},focus:function(n,r){re(function e(){if(terminals.length()===1){if(n===false){M.disable(r)}else{M.enable(r)}}else if(n===false){M.next()}else{var t=terminals.front();if(t!==M){terminals.forEach(function(e){if(e!==M&&e.enabled()){e.disable(r)}});if(!r){try{trigger_terminal_change(M)}catch(e){g(e,"onTerminalChange")}}}terminals.set(M);M.enable(r)}});return M},freeze:function(t){te(function e(){if(t){M.disable();De=true}else{De=false;M.enable()}});return M},frozen:function(){return De},enable:function(n){if(!me&&!De){if(Y===undefined){M.resize()}re(function e(){var t;if(!n&&!me){try{t=le.onFocus.call(M,M)}catch(e){le.onFocus=$.noop;g(e,"onFocus")}}if(!n&&t===undefined||n){me=true;if(!M.paused()){ve.enable(true)}}})}return M},disable:function(n){re(function e(){var t;if(!n&&me){try{t=le.onBlur.call(M,M)}catch(e){le.onBlur=$.noop;g(e,"onBlur")}}if(!n&&t===undefined||n){me=false;ve.disable()}});return M},enabled:function(){return me},signature:function(){var e=M.cols();for(var t=signatures.length;t--;){var n=signatures[t].map(function(e){return e.length});if(Math.max.apply(null,n)<=e){return signatures[t].join("\n")+"\n"}}return""},version:function(){return $.terminal.version},cmd:function(){return ve},get_command:function(){return ve.get()},set_command:function(t,n){te(function e(){if(typeof t!=="string"){t=JSON.stringify(t)}ve.set(t,undefined,n)});return M},set_position:function(t,n){te(function e(){ve.position(t,n)});return M},get_position:function(){return ve.position()},insert:function(n,r){if(typeof n==="string"){te(function e(){var t=M.is_bottom();ve.insert(n,r);if(le.scrollOnEcho||t){M.scroll_to_bottom()}});return M}else{throw new Error(sprintf(H().notAString,"insert"))}},set_prompt:function(t){te(function e(){if(is_function(t)){ve.prompt(function(e){t.call(M,e,M)})}else{ve.prompt(t)}ge.top().prompt=t});return M},get_prompt:function(){return ge.top().prompt},set_mask:function(t){te(function e(){ve.mask(t===true?le.maskChar:t)});return M},get_output:function(e){if(e){return ce}else{return $.map(ce,function(e){return is_function(e[0])?e[0]():e[0]}).join("\n")}},resize:function(e,t){if(!M.is(":visible")){M.stopTime("resize");M.oneTime(500,"resize",function(){M.resize(e,t)})}else{if(e&&t){M.width(e);M.height(t)}e=M.width();t=M.height();if(typeof le.numChars!=="undefined"||typeof le.numRows!=="undefined"){ve.resize(le.numChars);M.refresh();return}var n=get_num_chars(M,ne);var r=get_num_rows(M,ne);if(n!==Y||r!==G){Y=n;G=r;ve.resize(Y);M.refresh();var i=ge.top();if(is_function(i.resize)){i.resize.call(M,M)}else if(is_function(le.onResize)){le.onResize.call(M,M)}}}return M},refresh:function(){if(ne.width!==0){M[0].style.setProperty("--char-width",ne.width)}r({scroll:false,update:true});return M},flush:function(i){i=$.extend({},{update:false,scroll:true},i||{});try{var e=M.is_bottom();var o;$.each(v,function(e,t){if(t===_){o=$("<div></div>")}else if($.isPlainObject(t)&&is_function(t.finalize)){if(i.update){var n="> div[data-index="+t.index+"]";var r=J.find(n);if(r.html()!==o.html()){r.replaceWith(o)}}else{o.appendTo(J)}t.finalize(o.attr("data-index",t.index))}else{$("<div/>").html(t).appendTo(o).width("100%")}});y();try{le.onFlush.call(M,M)}catch(e){le.onFlush=$.noop;g(e,"onFlush")}if(le.scrollOnEcho&&i.scroll||e){M.scroll_to_bottom()}v=[]}catch(e){if(is_function(le.exceptionHandler)){le.exceptionHandler.call(M,e,"TERMINAL (Flush)")}else{alert_exception("[Flush]",e)}}return M},update:function(t,n,r){te(function e(){if(t<0){t=ce.length+t}if(!ce[t]){M.error("Invalid line number "+t)}else if(n===null){ce.splice(t,1);J.find("[data-index="+t+"]").remove()}else{ce[t][0]=n;if(r){ce[t][1]=r}o({string:n,index:t,options:r});M.flush({scroll:false,update:true})}});return M},remove_line:function(e){return M.update(e,null)},last_index:function(){return ce.length-1},echo:function(e,t){function n(e){try{var n=$.extend({flush:true,raw:le.raw,finalize:$.noop,keepWords:false,formatters:true},t||{});(function(t){n.finalize=function(e){if(n.raw){e.addClass("raw")}try{if(is_function(t)){t(e)}}catch(e){g(e,"USER:echo(finalize)");t=null}}})(n.finalize);if(n.flush){if(v.length){M.flush()}v=[]}if(typeof e==="function"){e=e.bind(M)}o({string:e,options:n,index:ce.length});ce.push([e,$.extend(n,{exec:false})]);if(n.flush){M.flush()}}catch(e){if(is_function(le.exceptionHandler)){le.exceptionHandler.call(M,e,"TERMINAL (echo)")}else{alert_exception("[Terminal.echo]",e)}}}if(e!==undefined&&is_function(e.then)){$.when(e).done(n)}else{n(e)}return M},error:function(e,t){t=$.extend({},t,{raw:false,formatters:false});function n(e){if(typeof e!=="string"){e=String(e)}var t=$.terminal.escape_brackets(e).replace(/\\$/,"&#92;").replace(url_re,"]$1[[;;;error]");return"[[;;;error]"+t+"]"}if(typeof e==="function"){return M.echo(function(){return n(e.call(M))},t)}if(e&&e.then){e.then(function(e){M.echo(n(e))});return M}return M.echo(n(e),t)},exception:function(r,e){var t=exception_message(r);if(e){t="&#91;"+e+"&#93;: "+t}if(t){M.error(t,{finalize:function(e){e.addClass("exception message")},keepWords:true})}if(typeof r.fileName==="string"){M.pause(le.softPause);$.get(r.fileName,function(e){var t=r.lineNumber-1;var n=e.split("\n")[t];if(n){M.error("["+r.lineNumber+"]: "+n)}M.resume()},"text")}if(r.stack){var n=$.terminal.escape_brackets(r.stack);M.echo(n.split(/\n/g).map(function(e){return"[[;;;error]"+e.replace(url_re,function(e){return"]"+e+"[[;;;error]"})+"]"}).join("\n"),{finalize:function(e){e.addClass("exception stack-trace")},formatters:false})}return M},scroll:function(e){var t;e=Math.round(e);if(q.prop){if(e>q.prop("scrollTop")&&e>0){q.prop("scrollTop",0)}t=q.prop("scrollTop");q.scrollTop(t+e)}else{if(e>q.attr("scrollTop")&&e>0){q.attr("scrollTop",0)}t=q.attr("scrollTop");q.scrollTop(t+e)}return M},logout:function(n){if(ie){throw new Error(sprintf(H().notWhileLogin,"logout"))}te(function e(){if(n){var t=X.pop();M.set_token(undefined,true);M.login.apply(M,t)}else if(ge.size()===1&&M.token()){M.logout(true)}else{while(ge.size()>1){if(M.token()){M.logout(true).pop().pop()}else{M.pop()}}}});return M},token:function(e){return pe.get(M.prefix_name(e)+"_token")},set_token:function(e,t){var n=M.prefix_name(t)+"_token";if(typeof e==="undefined"){pe.remove(n)}else{pe.set(n,e)}return M},get_token:function(e){return M.token(e)},login_name:function(e){return pe.get(M.prefix_name(e)+"_login")},name:function(){return ge.top().name},prefix_name:function(e){var t=(le.name?le.name+"_":"")+Q;if(e&&ge.size()>1){var n=ge.map(function(e){return e.name||""}).slice(1).join("_");if(n){t+="_"+n}}return t},read:function(e,t,n){var r=jQuery.Deferred();var i=false;M.push(function(e){i=true;r.resolve(e);if(is_function(t)){t(e)}M.pop();if(le.history){ve.history().enable()}},{name:"read",history:false,prompt:e||"",onExit:function(){if(!i){r.reject();if(is_function(n)){n()}}}});if(le.history){ve.history().disable()}return r.promise()},push:function(a,u){re(function e(){u=u||{};var t={infiniteLogin:false};var r=$.extend({},t,u);if(!r.name&&W){r.name=W.name}if(r.prompt===undefined){r.prompt=(r.name||">")+" "}var n=ge.top();if(n){n.mask=ve.mask()}var i=de;function o(){le.onPush.call(M,n,ge.top(),M);R()}s(a,u.login,function(e){ge.push($.extend({},e,r));if(r.completion===true){if($.isArray(e.completion)){ge.top().completion=e.completion}else if(!e.completion){ge.top().completion=false}}if(r.login){var t;var n=get_type(r.login);if(n==="function"){t=r.infiniteLogin?$.noop:M.pop;M.login(r.login,r.infiniteLogin,o,t)}else if(get_type(a)==="string"&&n==="string"||n==="boolean"){t=r.infiniteLogin?$.noop:M.pop;M.login(l(a,r.login),r.infiniteLogin,o,t)}}else{o()}if(!i&&M.enabled()){M.resume()}})});return M},pop:function(e,t){if(e!==undefined){b(e)}var n=M.token(true);var r;if(ge.size()===1){r=ge.top();if(le.login){if(!t){le.onPop.call(M,r,null,M)}A();if(is_function(le.onExit)){try{le.onExit.call(M,M)}catch(e){le.onExit=$.noop;g(e,"onExit")}}}else{M.error(H().canExitError)}}else{if(n){T()}var i=ge.pop();r=ge.top();R();if(!t){le.onPop.call(M,i,r)}if(ie&&M.get_prompt()!==H().login+": "){ie=false}if(is_function(i.onExit)){try{i.onExit.call(M,M)}catch(e){i.onExit=$.noop;g(e,"onExit")}}M.set_mask(r.mask)}return M},option:function(e,t){if(typeof t==="undefined"){if(typeof e==="string"){return le[e]}else if(typeof e==="object"){$.each(e,function(e,t){le[e]=t})}}else{le[e]=t;if(e.match(/^num(Chars|Rows)$/)){r()}}return M},invoke_key:function(e){var t=e.toUpperCase().split("+");var n=t.pop();var r=t.indexOf("CTRL")!==-1;var i=t.indexOf("SHIFT")!==-1;var o=t.indexOf("ALT")!==-1;var a=t.indexOf("META")!==-1;var u=$.Event("keydown",{ctrlKey:r,shiftKey:i,altKey:o,metaKey:a,which:Ee[n],key:n});var s=$(document.documentElement||window);s.trigger(u);u=$.Event("keypress");u.key=n;u.which=u.keyCode=0;s.trigger(u);return M},keymap:function(e,n){if(arguments.length===0){return ve.keymap()}if(typeof n==="undefined"){if(typeof e==="string"){return ve.keymap(e)}else if($.isPlainObject(e)){e=$.omap(e||{},function(n,r){if(!Le[n]){return r.bind(M)}return function(e,t){return r.call(M,e,function(){return Le[n](e,t)})}});ve.keymap(e)}}else if(typeof n==="function"){var r=e;if(!Le[r]){ve.keymap(r,n.bind(M))}else{ve.keymap(r,function(e,t){return n.call(M,e,function(){return Le[r](e,t)})})}}},level:function(){return ge.size()},reset:function(){te(function e(){M.clear();while(ge.size()>1){ge.pop()}j()});return M},purge:function(){te(function e(){var t=M.prefix_name()+"_";var n=pe.get(t+"interpreters");if(n){$.each(JSON.parse(n),function(e,t){pe.remove(t+"_commands");pe.remove(t+"_token");pe.remove(t+"_login")})}ve.purge();pe.remove(t+"interpreters")});return M},destroy:function(){te(function e(){ve.destroy().remove();J.remove();Fe.remove();$(document).unbind(".terminal_"+M.id());$(window).unbind(".terminal_"+M.id());M.unbind("click wheel mousewheel mousedown mouseup");M.removeData("terminal").removeClass("terminal").unbind(".terminal");if(le.width){M.css("width","")}if(le.height){M.css("height","")}$(window).off("blur",Be).off("focus",Re);M.find(".terminal-fill").remove();M.stopTime();terminals.remove(Q);if(ye){if(ye.unobserve){ye.unobserve(M[0])}else{clearInterval(ye)}}if(be){be.disconnect()}M.resizer("unbind");xe.resizer("unbind").remove();if(!terminals.length()){$(window).off("hashchange")}fe=true});return M},scroll_to_bottom:function(){var e;if(q.prop){e=q.prop("scrollHeight")}else{e=q.attr("scrollHeight")}q.scrollTop(e);return M},is_bottom:function(){if(le.scrollBottomOffset===-1){return false}else{var e,t,n;if(M.is("body")){e=$(document).height();t=$(window).scrollTop();n=window.innerHeight}else{e=q[0].scrollHeight;t=q.scrollTop();n=q.outerHeight()}var r=e-le.scrollBottomOffset;return t+n>r}}},function(t,e){return function(){if(fe){if(!le.exceptionHandler){throw new $.terminal.Exception(H().defunctTerminal)}}try{return e.apply(M,[].slice.apply(arguments))}catch(e){if(t!=="exec"&&t!=="resume"){g(e,e.type||"TERMINAL",true)}if(!le.exceptionHandler){throw e}}}}));var we={3:"Cancel",6:"Help",8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",28:"Convert",29:"NonConvert",30:"Accept",31:"ModeChange",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",41:"Select",42:"Print",43:"Execute",44:"PrintScreen",45:"Insert",46:"Delete",48:["0",")"],49:["1","!"],50:["2","@"],51:["3","#"],52:["4","$"],53:["5","%"],54:["6","^"],55:["7","&"],56:["8","*"],57:["9","("],91:"OS",93:"ContextMenu",144:"NumLock",145:"ScrollLock",181:"VolumeMute",182:"VolumeDown",183:"VolumeUp",186:[";",":"],187:["=","+"],188:[",","<"],189:["-","_"],190:[".",">"],191:["/","?"],192:["`","~"],219:["[","{"],220:["\\","|"],221:["]","}"],222:["'",'"'],224:"Meta",225:"AltGraph",246:"Attn",247:"CrSel",248:"ExSel",249:"EraseEof",250:"Play",251:"ZoomOut"};for(Ae=1;Ae<25;Ae++){we[111+Ae]="F"+Ae}var Ce="";for(Ae=65;Ae<91;Ae++){Ce=String.fromCharCode(Ae);we[Ae]=[Ce.toLowerCase(),Ce.toUpperCase()]}var Ee={};Object.keys(we).forEach(function(t){if(we[t]instanceof Array){we[t].forEach(function(e){Ee[e.toUpperCase()]=t})}else{Ee[we[t].toUpperCase()]=t}});if(le.ignoreSystemDescribe===true){le.describe=false}if(le.width){M.width(le.width)}if(le.height){M.height(le.height)}if(le.scrollObject!==null){q=$(le.scrollObject)}else{q=M}if(q.is("body")&&!is_safari){q=$("html,body")}$(document).bind("ajaxSend.terminal_"+M.id(),function(e,t){requests.push(t)});var Fe=$('<div class="terminal-wrapper"/>').appendTo(M);var xe=$('<div class="font">&nbsp;</div>').appendTo(M);var $e=$('<div class="terminal-fill"/>').appendTo(M);J=$("<div>").addClass("terminal-output").attr("role","log").appendTo(Fe);M.addClass("terminal");if(le.login&&is_function(le.onBeforeLogin)){try{if(le.onBeforeLogin.call(M,M)===false){he=false}}catch(e){le.onBeforeLogin=$.noop;g(e,"onBeforeLogin")}}var ke;if(typeof e==="string"){ke=e}else if(e instanceof Array){for(var Ae=0,Te=e.length;Ae<Te;++Ae){if(typeof e[Ae]==="string"){ke=e[Ae];break}}}var Se;if(is_function(le.login)){Se=le.login}else if(ke&&(typeof le.login==="string"||le.login===true)){Se=l(ke,le.login)}terminals.append(M);function Re(){if(_e){M.focus()}}function Be(){_e=me;M.disable().find(".cmd textarea").trigger("blur",[true])}function je(e){e=e.originalEvent;function t(e,t){return e.type.indexOf(t)!==-1}if(e.clipboardData){if(M.enabled()){var n=e.clipboardData.items;if(n){for(var r=0;r<n.length;r++){if(t(n[r],"image")&&le.pasteImage){var i=n[r].getAsFile();var o=window.URL||window.webkitURL;var a=o.createObjectURL(i);M.echo('<img src="'+a+'"/>',{raw:true})}else if(t(n[r],"text/plain")){n[r].getAsString(M.insert)}}}else if(e.clipboardData.getData){var u=e.clipboardData.getData("text/plain");M.insert(u)}return false}}}$(document).on("paste.terminal_"+M.id(),je);var Le=$.extend({},z,$.omap(le.keymap||{},function(n,r){if(!z[n]){return r.bind(M)}return function(e,t){return r.call(M,e,function(){return z[n](e,t)})}}));s(e,le.login,function(e){if(le.completion&&typeof le.completion!=="boolean"||!le.completion){e.completion="settings"}ge=new Stack($.extend({},le.extra,{name:le.name,prompt:le.prompt,keypress:le.keypress,keydown:le.keydown,resize:le.onResize,greetings:le.greetings,mousewheel:le.mousewheel,history:le.history,keymap:Le},e));ve=$("<div/>").appendTo(Fe).cmd({prompt:le.prompt,history:le.memory?"memory":le.history,historyFilter:le.historyFilter,historySize:le.historySize,caseSensitiveSearch:le.caseSensitiveSearch,width:"100%",enabled:false,char_width:ne.width,keydown:I,keymap:Le,clickTimeout:le.clickTimeout,holdTimeout:le.holdTimeout,holdRepeatTimeout:le.holdRepeatTimeout,keypress:P,tabs:le.tabs,onCommandChange:function(e){if(is_function(le.onCommandChange)){try{le.onCommandChange.call(M,e,M)}catch(e){le.onCommandChange=$.noop;g(e,"onCommandChange")}}M.scroll_to_bottom()},commands:k});function t(e){e=e.originalEvent;if(e){var t=document.elementFromPoint(e.clientX,e.clientY);if(!$(t).closest(".terminal").length&&M.enabled()){M.disable()}}}M.oneTime(100,function(){$(document).bind("click.terminal_"+M.id(),t).bind("contextmenu.terminal_"+M.id(),t)});var n=$(window);document.addEventListener("resume",function(){M.disable()});if(is_mobile){M.click(function(){if(!De){if(!M.enabled()){M.focus();ve.enable()}else{M.disable()}}})}else{n.on("focus.terminal_"+M.id(),Re).on("blur.terminal_"+M.id(),Be);(function(){var t=0;var n;var r="click_"+M.id();var i=M.find(".cmd textarea");function o(){if(n.is(".terminal")||n.is(".terminal-wrapper")){var e=M.get_command().length;M.set_position(e)}else if(n.closest(".prompt").length){M.set_position(0)}if(!i.is(":focus")){i.focus()}a()}function a(){t=0;n=null}var e;M.find(".cmd textarea").on("focus",function(){if(typeof e!=="undefined"){q.scrollTop(e)}}).on("blur",function(){e=q.scrollTop()});M.mousedown(function(e){if(!scrollbar_event(e,$e)){n=$(e.target)}}).mouseup(function(){if(get_selected_text()===""&&n){if(++t===1){if(!De){if(!me){M.focus()}else{var e=le.clickTimeout;M.oneTime(e,r,o);return}}}else{M.stopTime(r)}}a()}).dblclick(function(){a();M.stopTime(r)})})();(function(){var n=M.find(".cmd textarea");M.on("contextmenu.terminal",function(e){if(get_selected_text()===""){if(!$(e.target).is("img,value,audio,object,canvas,a")){if(!M.enabled()){M.enable()}var t=ve.offset();n.css({left:e.pageX-t.left-20,top:e.pageY-t.top-20,width:"5em",height:"4em"});if(!n.is(":focus")){n.focus()}M.stopTime("textarea");M.oneTime(100,"textarea",function(){n.css({left:"",top:"",width:"",height:""})});M.stopTime("selection");M.everyTime(20,"selection",function(){if(n[0].selection!==n[0].value){if(get_textarea_selection(n[0])){clear_textarea_selection(n[0]);select(M.find(".terminal-output")[0],M.find(".cmd div:last-of-type")[0]);M.stopTime("selection")}}})}}})})()}M.on("click","a",function(e){var t=$(this);if(t.closest(".exception").length){var n=t.attr("href");if(n.match(/:[0-9]+$/)){e.preventDefault();c(n)}}if(me){M.find(".cmd textarea").focus()}});function r(){var e=ne.width;ne=get_char_size(M);if(e!==ne.width){ve.option("char_width",ne.width).refresh()}}i();function i(){if(M.is(":visible")){var e=$e.width();var t=$e.height();if(ue!==t||ae!==e){M.resize()}ue=t;ae=e}}function o(){M.resizer("unbind").resizer(i);xe.resizer("unbind").resizer(function(){r();M.resize()})}if(M.is(":visible")){o()}function a(){if(ye){if(ye.unobserve){ye.unobserve(M[0])}else{clearInterval(ye)}}var e=M.enabled();var t=M.is(":visible");if(t){o()}function n(){if(M.is(":visible")&&!t){t=true;o();r();i();if(e){M.enable()}}else if(t&&!M.is(":visible")){t=false;e=$.terminal.active()===M&&M.enabled();M.disable()}}if(window.IntersectionObserver){ye=new IntersectionObserver(n,{root:document.body});ye.observe(M[0])}else{ye=setInterval(n,400)}}var u=!!M.closest("body").length;var s=window.MutationObserver||window.WebKitMutationObserver;if(s){be=new s(function(){if(M.closest("body").length){if(!u){M.scroll_to_bottom();if(window.IntersectionObserver){a()}i()}u=true}else if(u){u=false}});be.observe(document.body,{childList:true})}if(u){a()}Z.resolve();if(me&&M.is(":visible")&&!is_mobile){M.focus(undefined,true)}else{M.disable()}if(is_function(Se)){M.login(Se,true,j)}else{j()}function l(e){var t=terminals.get()[e[0]];if(t&&Q===t.id()){if(!e[2]){n.resolve();return n.promise()}else if(de){var n=$.Deferred();x.push(function(){return t.exec(e[2]).done(function(){t.save_state(e[2],true,e[1]);n.resolve()})});return n.promise()}else{return t.exec(e[2]).done(function(){t.save_state(e[2],true,e[1])})}}}if(le.execHash){if(location.hash){setTimeout(function(){try{var e=location.hash.replace(/^#/,"");hash_commands=JSON.parse(decodeURIComponent(e));var n=0;(function e(){var t=hash_commands[n++];if(t){l(t).done(e)}else{change_hash=true}})()}catch(e){}})}else{change_hash=true}}else{change_hash=true}(function(){var i=false;$(document).bind("keydown.terminal_"+M.id(),function(e){if(e.shiftKey){i=true}}).bind("keyup.terminal_"+M.id(),function(e){if(e.shiftKey||e.which===16){i=false}});function n(e,t){if(!i){var n=ge.top();var r;if(is_function(n.mousewheel)){r=n.mousewheel(e,t,M)}else if(is_function(le.mousewheel)){r=le.mousewheel(e,t,M)}if(w()||r===false){e.stopPropagation();e.preventDefault()}if(r===false){return false}else if(r===true){return}if(t>0){M.scroll(-40)}else{M.scroll(40)}}}if($.event.special.mousewheel){M.on("mousewheel",n)}else{var r;var e=document.createElement("div");if("onwheel"in e){r="wheel"}else if(document.onmousewheel!==undefined){r="mousewheel"}else{r="DOMMouseScroll"}e=null;M.on(r,function(e){var t;if(r==="mousewheel"){t=-1/40*e.originalEvent.wheelDelta}else{t=e.originalEvent.deltaY||e.originalEvent.detail}n(e,-t)})}})()});M.data("terminal",M);return M}});
	//# sourceMappingURL=jquery.terminal.min.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(260).setImmediate))

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* AUTO-GENERATED. DO NOT MODIFY. */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	
	
	 Style HTML
	---------------
	
	  Written by Nochum Sossonko, (nsossonko@hotmail.com)
	
	  Based on code initially developed by: Einar Lielmanis, <einar@beautifier.io>
	    https://beautifier.io/
	
	  Usage:
	    style_html(html_source);
	
	    style_html(html_source, options);
	
	  The options are:
	    indent_inner_html (default false)  — indent <head> and <body> sections,
	    indent_size (default 4)          — indentation size,
	    indent_char (default space)      — character to indent with,
	    wrap_line_length (default 250)            -  maximum amount of characters per line (0 = disable)
	    brace_style (default "collapse") - "collapse" | "expand" | "end-expand" | "none"
	            put braces on the same line as control statements (default), or put braces on own line (Allman / ANSI style), or just put end braces on own line, or attempt to keep them where they are.
	    inline (defaults to inline tags) - list of tags to be considered inline tags
	    unformatted (defaults to inline tags) - list of tags, that shouldn't be reformatted
	    content_unformatted (defaults to ["pre", "textarea"] tags) - list of tags, whose content shouldn't be reformatted
	    indent_scripts (default normal)  - "keep"|"separate"|"normal"
	    preserve_newlines (default true) - whether existing line breaks before elements should be preserved
	                                        Only works before elements, not inside tags or for text.
	    max_preserve_newlines (default unlimited) - maximum number of line breaks to be preserved in one chunk
	    indent_handlebars (default false) - format and indent {{#foo}} and {{/foo}}
	    end_with_newline (false)          - end with a newline
	    extra_liners (default [head,body,/html]) -List of tags that should have an extra newline before them.
	
	    e.g.
	
	    style_html(html_source, {
	      'indent_inner_html': false,
	      'indent_size': 2,
	      'indent_char': ' ',
	      'wrap_line_length': 78,
	      'brace_style': 'expand',
	      'preserve_newlines': true,
	      'max_preserve_newlines': 5,
	      'indent_handlebars': false,
	      'extra_liners': ['/html']
	    });
	*/
	
	(function() {
	
	/* GENERATED_BUILD_OUTPUT */
	var legacy_beautify_html =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 15);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */,
	/* 1 */,
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function OutputLine(parent) {
	  this.__parent = parent;
	  this.__character_count = 0;
	  // use indent_count as a marker for this.__lines that have preserved indentation
	  this.__indent_count = -1;
	  this.__alignment_count = 0;
	
	  this.__items = [];
	}
	
	OutputLine.prototype.item = function(index) {
	  if (index < 0) {
	    return this.__items[this.__items.length + index];
	  } else {
	    return this.__items[index];
	  }
	};
	
	OutputLine.prototype.has_match = function(pattern) {
	  for (var lastCheckedOutput = this.__items.length - 1; lastCheckedOutput >= 0; lastCheckedOutput--) {
	    if (this.__items[lastCheckedOutput].match(pattern)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	OutputLine.prototype.set_indent = function(indent, alignment) {
	  this.__indent_count = indent || 0;
	  this.__alignment_count = alignment || 0;
	  this.__character_count = this.__parent.baseIndentLength + this.__alignment_count + this.__indent_count * this.__parent.indent_length;
	};
	
	OutputLine.prototype.get_character_count = function() {
	  return this.__character_count;
	};
	
	OutputLine.prototype.is_empty = function() {
	  return this.__items.length === 0;
	};
	
	OutputLine.prototype.last = function() {
	  if (!this.is_empty()) {
	    return this.__items[this.__items.length - 1];
	  } else {
	    return null;
	  }
	};
	
	OutputLine.prototype.push = function(item) {
	  this.__items.push(item);
	  this.__character_count += item.length;
	};
	
	OutputLine.prototype.push_raw = function(item) {
	  this.push(item);
	  var last_newline_index = item.lastIndexOf('\n');
	  if (last_newline_index !== -1) {
	    this.__character_count = item.length - last_newline_index;
	  }
	};
	
	OutputLine.prototype.pop = function() {
	  var item = null;
	  if (!this.is_empty()) {
	    item = this.__items.pop();
	    this.__character_count -= item.length;
	  }
	  return item;
	};
	
	OutputLine.prototype.remove_indent = function() {
	  if (this.__indent_count > 0) {
	    this.__indent_count -= 1;
	    this.__character_count -= this.__parent.indent_length;
	  }
	};
	
	OutputLine.prototype.trim = function() {
	  while (this.last() === ' ') {
	    this.__items.pop();
	    this.__character_count -= 1;
	  }
	};
	
	OutputLine.prototype.toString = function() {
	  var result = '';
	  if (!this.is_empty()) {
	    if (this.__indent_count >= 0) {
	      result = this.__parent.get_indent_string(this.__indent_count);
	    }
	    if (this.__alignment_count >= 0) {
	      result += this.__parent.get_alignment_string(this.__alignment_count);
	    }
	    result += this.__items.join('');
	  }
	  return result;
	};
	
	function IndentCache(base_string, level_string) {
	  this.__cache = [base_string];
	  this.__level_string = level_string;
	}
	
	IndentCache.prototype.__ensure_cache = function(level) {
	  while (level >= this.__cache.length) {
	    this.__cache.push(this.__cache[this.__cache.length - 1] + this.__level_string);
	  }
	};
	
	IndentCache.prototype.get_level_string = function(level) {
	  this.__ensure_cache(level);
	  return this.__cache[level];
	};
	
	
	function Output(options, baseIndentString) {
	  var indent_string = options.indent_char;
	  if (options.indent_size > 1) {
	    indent_string = new Array(options.indent_size + 1).join(options.indent_char);
	  }
	
	  // Set to null to continue support for auto detection of base indent level.
	  baseIndentString = baseIndentString || '';
	  if (options.indent_level > 0) {
	    baseIndentString = new Array(options.indent_level + 1).join(indent_string);
	  }
	
	  this.__indent_cache = new IndentCache(baseIndentString, indent_string);
	  this.__alignment_cache = new IndentCache('', ' ');
	  this.baseIndentLength = baseIndentString.length;
	  this.indent_length = indent_string.length;
	  this.raw = false;
	  this._end_with_newline = options.end_with_newline;
	
	  this.__lines = [];
	  this.previous_line = null;
	  this.current_line = null;
	  this.space_before_token = false;
	  // initialize
	  this.__add_outputline();
	}
	
	Output.prototype.__add_outputline = function() {
	  this.previous_line = this.current_line;
	  this.current_line = new OutputLine(this);
	  this.__lines.push(this.current_line);
	};
	
	Output.prototype.get_line_number = function() {
	  return this.__lines.length;
	};
	
	Output.prototype.get_indent_string = function(level) {
	  return this.__indent_cache.get_level_string(level);
	};
	
	Output.prototype.get_alignment_string = function(level) {
	  return this.__alignment_cache.get_level_string(level);
	};
	
	Output.prototype.is_empty = function() {
	  return !this.previous_line && this.current_line.is_empty();
	};
	
	Output.prototype.add_new_line = function(force_newline) {
	  // never newline at the start of file
	  // otherwise, newline only if we didn't just add one or we're forced
	  if (this.is_empty() ||
	    (!force_newline && this.just_added_newline())) {
	    return false;
	  }
	
	  // if raw output is enabled, don't print additional newlines,
	  // but still return True as though you had
	  if (!this.raw) {
	    this.__add_outputline();
	  }
	  return true;
	};
	
	Output.prototype.get_code = function(eol) {
	  var sweet_code = this.__lines.join('\n').replace(/[\r\n\t ]+$/, '');
	
	  if (this._end_with_newline) {
	    sweet_code += '\n';
	  }
	
	  if (eol !== '\n') {
	    sweet_code = sweet_code.replace(/[\n]/g, eol);
	  }
	
	  return sweet_code;
	};
	
	Output.prototype.set_indent = function(indent, alignment) {
	  indent = indent || 0;
	  alignment = alignment || 0;
	
	  // Never indent your first output indent at the start of the file
	  if (this.__lines.length > 1) {
	    this.current_line.set_indent(indent, alignment);
	    return true;
	  }
	  this.current_line.set_indent();
	  return false;
	};
	
	Output.prototype.add_raw_token = function(token) {
	  for (var x = 0; x < token.newlines; x++) {
	    this.__add_outputline();
	  }
	  this.current_line.push(token.whitespace_before);
	  this.current_line.push_raw(token.text);
	  this.space_before_token = false;
	};
	
	Output.prototype.add_token = function(printable_token) {
	  this.add_space_before_token();
	  this.current_line.push(printable_token);
	};
	
	Output.prototype.add_space_before_token = function() {
	  if (this.space_before_token && !this.just_added_newline()) {
	    this.current_line.push(' ');
	  }
	  this.space_before_token = false;
	};
	
	Output.prototype.remove_indent = function(index) {
	  var output_length = this.__lines.length;
	  while (index < output_length) {
	    this.__lines[index].remove_indent();
	    index++;
	  }
	};
	
	Output.prototype.trim = function(eat_newlines) {
	  eat_newlines = (eat_newlines === undefined) ? false : eat_newlines;
	
	  this.current_line.trim(this.indent_string, this.baseIndentString);
	
	  while (eat_newlines && this.__lines.length > 1 &&
	    this.current_line.is_empty()) {
	    this.__lines.pop();
	    this.current_line = this.__lines[this.__lines.length - 1];
	    this.current_line.trim();
	  }
	
	  this.previous_line = this.__lines.length > 1 ?
	    this.__lines[this.__lines.length - 2] : null;
	};
	
	Output.prototype.just_added_newline = function() {
	  return this.current_line.is_empty();
	};
	
	Output.prototype.just_added_blankline = function() {
	  return this.is_empty() ||
	    (this.current_line.is_empty() && this.previous_line.is_empty());
	};
	
	Output.prototype.ensure_empty_line_above = function(starts_with, ends_with) {
	  var index = this.__lines.length - 2;
	  while (index >= 0) {
	    var potentialEmptyLine = this.__lines[index];
	    if (potentialEmptyLine.is_empty()) {
	      break;
	    } else if (potentialEmptyLine.item(0).indexOf(starts_with) !== 0 &&
	      potentialEmptyLine.item(-1) !== ends_with) {
	      this.__lines.splice(index + 1, 0, new OutputLine(this));
	      this.previous_line = this.__lines[this.__lines.length - 2];
	      break;
	    }
	    index--;
	  }
	};
	
	module.exports.Output = Output;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function Token(type, text, newlines, whitespace_before) {
	  this.type = type;
	  this.text = text;
	
	  // comments_before are
	  // comments that have a new line before them
	  // and may or may not have a newline after
	  // this is a set of comments before
	  this.comments_before = null; /* inline comment*/
	
	
	  // this.comments_after =  new TokenStream(); // no new line before and newline after
	  this.newlines = newlines || 0;
	  this.whitespace_before = whitespace_before || '';
	  this.parent = null;
	  this.next = null;
	  this.previous = null;
	  this.opened = null;
	  this.closed = null;
	  this.directives = null;
	}
	
	
	module.exports.Token = Token;
	
	
	/***/ }),
	/* 4 */,
	/* 5 */,
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function Options(options, merge_child_field) {
	  this.raw_options = _mergeOpts(options, merge_child_field);
	
	  // Support passing the source text back with no change
	  this.disabled = this._get_boolean('disabled');
	
	  this.eol = this._get_characters('eol', 'auto');
	  this.end_with_newline = this._get_boolean('end_with_newline');
	  this.indent_size = this._get_number('indent_size', 4);
	  this.indent_char = this._get_characters('indent_char', ' ');
	  this.indent_level = this._get_number('indent_level');
	
	  this.preserve_newlines = this._get_boolean('preserve_newlines', true);
	  this.max_preserve_newlines = this._get_number('max_preserve_newlines', 32786);
	  if (!this.preserve_newlines) {
	    this.max_preserve_newlines = 0;
	  }
	
	  this.indent_with_tabs = this._get_boolean('indent_with_tabs');
	  if (this.indent_with_tabs) {
	    this.indent_char = '\t';
	    this.indent_size = 1;
	  }
	
	  // Backwards compat with 1.3.x
	  this.wrap_line_length = this._get_number('wrap_line_length', this._get_number('max_char'));
	
	}
	
	Options.prototype._get_array = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  var result = default_value || [];
	  if (typeof option_value === 'object') {
	    if (option_value !== null && typeof option_value.concat === 'function') {
	      result = option_value.concat();
	    }
	  } else if (typeof option_value === 'string') {
	    result = option_value.split(/[^a-zA-Z0-9_\/\-]+/);
	  }
	  return result;
	};
	
	Options.prototype._get_boolean = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  var result = option_value === undefined ? !!default_value : !!option_value;
	  return result;
	};
	
	Options.prototype._get_characters = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  var result = default_value || '';
	  if (typeof option_value === 'string') {
	    result = option_value.replace(/\\r/, '\r').replace(/\\n/, '\n').replace(/\\t/, '\t');
	  }
	  return result;
	};
	
	Options.prototype._get_number = function(name, default_value) {
	  var option_value = this.raw_options[name];
	  default_value = parseInt(default_value, 10);
	  if (isNaN(default_value)) {
	    default_value = 0;
	  }
	  var result = parseInt(option_value, 10);
	  if (isNaN(result)) {
	    result = default_value;
	  }
	  return result;
	};
	
	Options.prototype._get_selection = function(name, selection_list, default_value) {
	  var result = this._get_selection_list(name, selection_list, default_value);
	  if (result.length !== 1) {
	    throw new Error(
	      "Invalid Option Value: The option '" + name + "' can only be one of the following values:\n" +
	      selection_list + "\nYou passed in: '" + this.raw_options[name] + "'");
	  }
	
	  return result[0];
	};
	
	
	Options.prototype._get_selection_list = function(name, selection_list, default_value) {
	  if (!selection_list || selection_list.length === 0) {
	    throw new Error("Selection list cannot be empty.");
	  }
	
	  default_value = default_value || [selection_list[0]];
	  if (!this._is_valid_selection(default_value, selection_list)) {
	    throw new Error("Invalid Default Value!");
	  }
	
	  var result = this._get_array(name, default_value);
	  if (!this._is_valid_selection(result, selection_list)) {
	    throw new Error(
	      "Invalid Option Value: The option '" + name + "' can contain only the following values:\n" +
	      selection_list + "\nYou passed in: '" + this.raw_options[name] + "'");
	  }
	
	  return result;
	};
	
	Options.prototype._is_valid_selection = function(result, selection_list) {
	  return result.length && selection_list.length &&
	    !result.some(function(item) { return selection_list.indexOf(item) === -1; });
	};
	
	
	// merges child options up with the parent options object
	// Example: obj = {a: 1, b: {a: 2}}
	//          mergeOpts(obj, 'b')
	//
	//          Returns: {a: 2}
	function _mergeOpts(allOptions, childFieldName) {
	  var finalOpts = {};
	  allOptions = _normalizeOpts(allOptions);
	  var name;
	
	  for (name in allOptions) {
	    if (name !== childFieldName) {
	      finalOpts[name] = allOptions[name];
	    }
	  }
	
	  //merge in the per type settings for the childFieldName
	  if (childFieldName && allOptions[childFieldName]) {
	    for (name in allOptions[childFieldName]) {
	      finalOpts[name] = allOptions[childFieldName][name];
	    }
	  }
	  return finalOpts;
	}
	
	function _normalizeOpts(options) {
	  var convertedOpts = {};
	  var key;
	
	  for (key in options) {
	    var newKey = key.replace(/-/g, "_");
	    convertedOpts[newKey] = options[key];
	  }
	  return convertedOpts;
	}
	
	module.exports.Options = Options;
	module.exports.normalizeOpts = _normalizeOpts;
	module.exports.mergeOpts = _mergeOpts;
	
	
	/***/ }),
	/* 7 */,
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function InputScanner(input_string) {
	  this.__input = input_string || '';
	  this.__input_length = this.__input.length;
	  this.__position = 0;
	}
	
	InputScanner.prototype.restart = function() {
	  this.__position = 0;
	};
	
	InputScanner.prototype.back = function() {
	  if (this.__position > 0) {
	    this.__position -= 1;
	  }
	};
	
	InputScanner.prototype.hasNext = function() {
	  return this.__position < this.__input_length;
	};
	
	InputScanner.prototype.next = function() {
	  var val = null;
	  if (this.hasNext()) {
	    val = this.__input.charAt(this.__position);
	    this.__position += 1;
	  }
	  return val;
	};
	
	InputScanner.prototype.peek = function(index) {
	  var val = null;
	  index = index || 0;
	  index += this.__position;
	  if (index >= 0 && index < this.__input_length) {
	    val = this.__input.charAt(index);
	  }
	  return val;
	};
	
	InputScanner.prototype.test = function(pattern, index) {
	  index = index || 0;
	  index += this.__position;
	  pattern.lastIndex = index;
	
	  if (index >= 0 && index < this.__input_length) {
	    var pattern_match = pattern.exec(this.__input);
	    return pattern_match && pattern_match.index === index;
	  } else {
	    return false;
	  }
	};
	
	InputScanner.prototype.testChar = function(pattern, index) {
	  // test one character regex match
	  var val = this.peek(index);
	  return val !== null && pattern.test(val);
	};
	
	InputScanner.prototype.match = function(pattern) {
	  pattern.lastIndex = this.__position;
	  var pattern_match = pattern.exec(this.__input);
	  if (pattern_match && pattern_match.index === this.__position) {
	    this.__position += pattern_match[0].length;
	  } else {
	    pattern_match = null;
	  }
	  return pattern_match;
	};
	
	InputScanner.prototype.read = function(pattern) {
	  var val = '';
	  var match = this.match(pattern);
	  if (match) {
	    val = match[0];
	  }
	  return val;
	};
	
	InputScanner.prototype.readUntil = function(pattern, include_match) {
	  var val = '';
	  var match_index = this.__position;
	  pattern.lastIndex = this.__position;
	  var pattern_match = pattern.exec(this.__input);
	  if (pattern_match) {
	    if (include_match) {
	      match_index = pattern_match.index + pattern_match[0].length;
	    } else {
	      match_index = pattern_match.index;
	    }
	  } else {
	    match_index = this.__input_length;
	  }
	
	  val = this.__input.substring(this.__position, match_index);
	  this.__position = match_index;
	  return val;
	};
	
	InputScanner.prototype.readUntilAfter = function(pattern) {
	  return this.readUntil(pattern, true);
	};
	
	/* css beautifier legacy helpers */
	InputScanner.prototype.peekUntilAfter = function(pattern) {
	  var start = this.__position;
	  var val = this.readUntilAfter(pattern);
	  this.__position = start;
	  return val;
	};
	
	InputScanner.prototype.lookBack = function(testVal) {
	  var start = this.__position - 1;
	  return start >= testVal.length && this.__input.substring(start - testVal.length, start)
	    .toLowerCase() === testVal;
	};
	
	
	module.exports.InputScanner = InputScanner;
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var InputScanner = __webpack_require__(8).InputScanner;
	var Token = __webpack_require__(3).Token;
	var TokenStream = __webpack_require__(10).TokenStream;
	
	var TOKEN = {
	  START: 'TK_START',
	  RAW: 'TK_RAW',
	  EOF: 'TK_EOF'
	};
	
	var Tokenizer = function(input_string, options) {
	  this._input = new InputScanner(input_string);
	  this._options = options || {};
	  this.__tokens = null;
	  this.__newline_count = 0;
	  this.__whitespace_before_token = '';
	
	  this._whitespace_pattern = /[\n\r\t ]+/g;
	  this._newline_pattern = /([^\n\r]*)(\r\n|[\n\r])?/g;
	};
	
	Tokenizer.prototype.tokenize = function() {
	  this._input.restart();
	  this.__tokens = new TokenStream();
	
	  this._reset();
	
	  var current;
	  var previous = new Token(TOKEN.START, '');
	  var open_token = null;
	  var open_stack = [];
	  var comments = new TokenStream();
	
	  while (previous.type !== TOKEN.EOF) {
	    current = this._get_next_token(previous, open_token);
	    while (this._is_comment(current)) {
	      comments.add(current);
	      current = this._get_next_token(previous, open_token);
	    }
	
	    if (!comments.isEmpty()) {
	      current.comments_before = comments;
	      comments = new TokenStream();
	    }
	
	    current.parent = open_token;
	
	    if (this._is_opening(current)) {
	      open_stack.push(open_token);
	      open_token = current;
	    } else if (open_token && this._is_closing(current, open_token)) {
	      current.opened = open_token;
	      open_token.closed = current;
	      open_token = open_stack.pop();
	      current.parent = open_token;
	    }
	
	    current.previous = previous;
	    previous.next = current;
	
	    this.__tokens.add(current);
	    previous = current;
	  }
	
	  return this.__tokens;
	};
	
	
	Tokenizer.prototype._is_first_token = function() {
	  return this.__tokens.isEmpty();
	};
	
	Tokenizer.prototype._reset = function() {};
	
	Tokenizer.prototype._get_next_token = function(previous_token, open_token) { // jshint unused:false
	  this._readWhitespace();
	  var resulting_string = this._input.read(/.+/g);
	  if (resulting_string) {
	    return this._create_token(TOKEN.RAW, resulting_string);
	  } else {
	    return this._create_token(TOKEN.EOF, '');
	  }
	};
	
	Tokenizer.prototype._is_comment = function(current_token) { // jshint unused:false
	  return false;
	};
	
	Tokenizer.prototype._is_opening = function(current_token) { // jshint unused:false
	  return false;
	};
	
	Tokenizer.prototype._is_closing = function(current_token, open_token) { // jshint unused:false
	  return false;
	};
	
	Tokenizer.prototype._create_token = function(type, text) {
	  var token = new Token(type, text, this.__newline_count, this.__whitespace_before_token);
	  this.__newline_count = 0;
	  this.__whitespace_before_token = '';
	  return token;
	};
	
	Tokenizer.prototype._readWhitespace = function() {
	  var resulting_string = this._input.read(this._whitespace_pattern);
	  if (resulting_string === ' ') {
	    this.__whitespace_before_token = resulting_string;
	  } else if (resulting_string !== '') {
	    this._newline_pattern.lastIndex = 0;
	    var nextMatch = this._newline_pattern.exec(resulting_string);
	    while (nextMatch[2]) {
	      this.__newline_count += 1;
	      nextMatch = this._newline_pattern.exec(resulting_string);
	    }
	    this.__whitespace_before_token = nextMatch[1];
	  }
	};
	
	
	
	module.exports.Tokenizer = Tokenizer;
	module.exports.TOKEN = TOKEN;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function TokenStream(parent_token) {
	  // private
	  this.__tokens = [];
	  this.__tokens_length = this.__tokens.length;
	  this.__position = 0;
	  this.__parent_token = parent_token;
	}
	
	TokenStream.prototype.restart = function() {
	  this.__position = 0;
	};
	
	TokenStream.prototype.isEmpty = function() {
	  return this.__tokens_length === 0;
	};
	
	TokenStream.prototype.hasNext = function() {
	  return this.__position < this.__tokens_length;
	};
	
	TokenStream.prototype.next = function() {
	  var val = null;
	  if (this.hasNext()) {
	    val = this.__tokens[this.__position];
	    this.__position += 1;
	  }
	  return val;
	};
	
	TokenStream.prototype.peek = function(index) {
	  var val = null;
	  index = index || 0;
	  index += this.__position;
	  if (index >= 0 && index < this.__tokens_length) {
	    val = this.__tokens[index];
	  }
	  return val;
	};
	
	TokenStream.prototype.add = function(token) {
	  if (this.__parent_token) {
	    token.parent = this.__parent_token;
	  }
	  this.__tokens.push(token);
	  this.__tokens_length += 1;
	};
	
	module.exports.TokenStream = TokenStream;
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	function Directives(start_block_pattern, end_block_pattern) {
	  start_block_pattern = typeof start_block_pattern === 'string' ? start_block_pattern : start_block_pattern.source;
	  end_block_pattern = typeof end_block_pattern === 'string' ? end_block_pattern : end_block_pattern.source;
	  this.__directives_block_pattern = new RegExp(start_block_pattern + / beautify( \w+[:]\w+)+ /.source + end_block_pattern, 'g');
	  this.__directive_pattern = / (\w+)[:](\w+)/g;
	
	  this.__directives_end_ignore_pattern = new RegExp('(?:[\\s\\S]*?)((?:' + start_block_pattern + /\sbeautify\signore:end\s/.source + end_block_pattern + ')|$)', 'g');
	}
	
	Directives.prototype.get_directives = function(text) {
	  if (!text.match(this.__directives_block_pattern)) {
	    return null;
	  }
	
	  var directives = {};
	  this.__directive_pattern.lastIndex = 0;
	  var directive_match = this.__directive_pattern.exec(text);
	
	  while (directive_match) {
	    directives[directive_match[1]] = directive_match[2];
	    directive_match = this.__directive_pattern.exec(text);
	  }
	
	  return directives;
	};
	
	Directives.prototype.readIgnored = function(input) {
	  return input.read(this.__directives_end_ignore_pattern);
	};
	
	
	module.exports.Directives = Directives;
	
	
	/***/ }),
	/* 12 */,
	/* 13 */,
	/* 14 */,
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var Beautifier = __webpack_require__(16).Beautifier;
	
	function style_html(html_source, options, js_beautify, css_beautify) {
	  var beautifier = new Beautifier(html_source, options, js_beautify, css_beautify);
	  return beautifier.beautify();
	}
	
	module.exports = style_html;
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var Options = __webpack_require__(17).Options;
	var Output = __webpack_require__(2).Output;
	var Tokenizer = __webpack_require__(18).Tokenizer;
	var TOKEN = __webpack_require__(18).TOKEN;
	
	var lineBreak = /\r\n|[\r\n]/;
	var allLineBreaks = /\r\n|[\r\n]/g;
	
	var Printer = function(options, base_indent_string) { //handles input/output and some other printing functions
	
	  this.indent_level = 0;
	  this.alignment_size = 0;
	  this.wrap_line_length = options.wrap_line_length;
	  this.max_preserve_newlines = options.max_preserve_newlines;
	  this.preserve_newlines = options.preserve_newlines;
	
	  this._output = new Output(options, base_indent_string);
	
	};
	
	Printer.prototype.current_line_has_match = function(pattern) {
	  return this._output.current_line.has_match(pattern);
	};
	
	Printer.prototype.set_space_before_token = function(value) {
	  this._output.space_before_token = value;
	};
	
	Printer.prototype.add_raw_token = function(token) {
	  this._output.add_raw_token(token);
	};
	
	Printer.prototype.print_preserved_newlines = function(raw_token) {
	  var newlines = 0;
	  if (raw_token.type !== TOKEN.TEXT && raw_token.previous.type !== TOKEN.TEXT) {
	    newlines = raw_token.newlines ? 1 : 0;
	  }
	
	  if (this.preserve_newlines) {
	    newlines = raw_token.newlines < this.max_preserve_newlines + 1 ? raw_token.newlines : this.max_preserve_newlines + 1;
	  }
	  for (var n = 0; n < newlines; n++) {
	    this.print_newline(n > 0);
	  }
	
	  return newlines !== 0;
	};
	
	Printer.prototype.traverse_whitespace = function(raw_token) {
	  if (raw_token.whitespace_before || raw_token.newlines) {
	    if (!this.print_preserved_newlines(raw_token)) {
	      this._output.space_before_token = true;
	      this.print_space_or_wrap(raw_token.text);
	    }
	    return true;
	  }
	  return false;
	};
	
	// Append a space to the given content (string array) or, if we are
	// at the wrap_line_length, append a newline/indentation.
	// return true if a newline was added, false if a space was added
	Printer.prototype.print_space_or_wrap = function(text) {
	  if (this.wrap_line_length) {
	    if (this._output.current_line.get_character_count() + text.length + 1 >= this.wrap_line_length) { //insert a line when the wrap_line_length is reached
	      return this._output.add_new_line();
	    }
	  }
	  return false;
	};
	
	Printer.prototype.print_newline = function(force) {
	  this._output.add_new_line(force);
	};
	
	Printer.prototype.print_token = function(text) {
	  if (text) {
	    if (this._output.current_line.is_empty()) {
	      this._output.set_indent(this.indent_level, this.alignment_size);
	    }
	
	    this._output.add_token(text);
	  }
	};
	
	Printer.prototype.print_raw_text = function(text) {
	  this._output.current_line.push_raw(text);
	};
	
	Printer.prototype.indent = function() {
	  this.indent_level++;
	};
	
	Printer.prototype.unindent = function() {
	  if (this.indent_level > 0) {
	    this.indent_level--;
	  }
	};
	
	Printer.prototype.get_full_indent = function(level) {
	  level = this.indent_level + (level || 0);
	  if (level < 1) {
	    return '';
	  }
	
	  return this._output.get_indent_string(level);
	};
	
	
	var uses_beautifier = function(tag_check, start_token) {
	  var raw_token = start_token.next;
	  if (!start_token.closed) {
	    return false;
	  }
	
	  while (raw_token.type !== TOKEN.EOF && raw_token.closed !== start_token) {
	    if (raw_token.type === TOKEN.ATTRIBUTE && raw_token.text === 'type') {
	      // For script and style tags that have a type attribute, only enable custom beautifiers for matching values
	      var peekEquals = raw_token.next ? raw_token.next : raw_token;
	      var peekValue = peekEquals.next ? peekEquals.next : peekEquals;
	      if (peekEquals.type === TOKEN.EQUALS && peekValue.type === TOKEN.VALUE) {
	        return (tag_check === 'style' && peekValue.text.search('text/css') > -1) ||
	          (tag_check === 'script' && peekValue.text.search(/(text|application|dojo)\/(x-)?(javascript|ecmascript|jscript|livescript|(ld\+)?json|method|aspect)/) > -1);
	      }
	      return false;
	    }
	    raw_token = raw_token.next;
	  }
	
	  return true;
	};
	
	function in_array(what, arr) {
	  return arr.indexOf(what) !== -1;
	}
	
	function TagFrame(parent, parser_token, indent_level) {
	  this.parent = parent || null;
	  this.tag = parser_token ? parser_token.tag_name : '';
	  this.indent_level = indent_level || 0;
	  this.parser_token = parser_token || null;
	}
	
	function TagStack(printer) {
	  this._printer = printer;
	  this._current_frame = null;
	}
	
	TagStack.prototype.get_parser_token = function() {
	  return this._current_frame ? this._current_frame.parser_token : null;
	};
	
	TagStack.prototype.record_tag = function(parser_token) { //function to record a tag and its parent in this.tags Object
	  var new_frame = new TagFrame(this._current_frame, parser_token, this._printer.indent_level);
	  this._current_frame = new_frame;
	};
	
	TagStack.prototype._try_pop_frame = function(frame) { //function to retrieve the opening tag to the corresponding closer
	  var parser_token = null;
	
	  if (frame) {
	    parser_token = frame.parser_token;
	    this._printer.indent_level = frame.indent_level;
	    this._current_frame = frame.parent;
	  }
	
	  return parser_token;
	};
	
	TagStack.prototype._get_frame = function(tag_list, stop_list) { //function to retrieve the opening tag to the corresponding closer
	  var frame = this._current_frame;
	
	  while (frame) { //till we reach '' (the initial value);
	    if (tag_list.indexOf(frame.tag) !== -1) { //if this is it use it
	      break;
	    } else if (stop_list && stop_list.indexOf(frame.tag) !== -1) {
	      frame = null;
	      break;
	    }
	    frame = frame.parent;
	  }
	
	  return frame;
	};
	
	TagStack.prototype.try_pop = function(tag, stop_list) { //function to retrieve the opening tag to the corresponding closer
	  var frame = this._get_frame([tag], stop_list);
	  return this._try_pop_frame(frame);
	};
	
	TagStack.prototype.indent_to_tag = function(tag_list) {
	  var frame = this._get_frame(tag_list);
	  if (frame) {
	    this._printer.indent_level = frame.indent_level;
	  }
	};
	
	function Beautifier(source_text, options, js_beautify, css_beautify) {
	  //Wrapper function to invoke all the necessary constructors and deal with the output.
	  this._source_text = source_text || '';
	  options = options || {};
	  this._js_beautify = js_beautify;
	  this._css_beautify = css_beautify;
	  this._tag_stack = null;
	
	  // Allow the setting of language/file-type specific options
	  // with inheritance of overall settings
	  var optionHtml = new Options(options, 'html');
	
	  this._options = optionHtml;
	
	  this._is_wrap_attributes_force = this._options.wrap_attributes.substr(0, 'force'.length) === 'force';
	  this._is_wrap_attributes_force_expand_multiline = (this._options.wrap_attributes === 'force-expand-multiline');
	  this._is_wrap_attributes_force_aligned = (this._options.wrap_attributes === 'force-aligned');
	  this._is_wrap_attributes_aligned_multiple = (this._options.wrap_attributes === 'aligned-multiple');
	  this._is_wrap_attributes_preserve = this._options.wrap_attributes.substr(0, 'preserve'.length) === 'preserve';
	  this._is_wrap_attributes_preserve_aligned = (this._options.wrap_attributes === 'preserve-aligned');
	}
	
	Beautifier.prototype.beautify = function() {
	
	  // if disabled, return the input unchanged.
	  if (this._options.disabled) {
	    return this._source_text;
	  }
	
	  var source_text = this._source_text;
	  var eol = this._options.eol;
	  if (this._options.eol === 'auto') {
	    eol = '\n';
	    if (source_text && lineBreak.test(source_text)) {
	      eol = source_text.match(lineBreak)[0];
	    }
	  }
	
	  // HACK: newline parsing inconsistent. This brute force normalizes the input.
	  source_text = source_text.replace(allLineBreaks, '\n');
	  var baseIndentString = '';
	
	  // Including commented out text would change existing html beautifier behavior to autodetect base indent.
	  // baseIndentString = source_text.match(/^[\t ]*/)[0];
	
	  var last_token = {
	    text: '',
	    type: ''
	  };
	
	  var last_tag_token = new TagOpenParserToken();
	
	  var printer = new Printer(this._options, baseIndentString);
	  var tokens = new Tokenizer(source_text, this._options).tokenize();
	
	  this._tag_stack = new TagStack(printer);
	
	  var parser_token = null;
	  var raw_token = tokens.next();
	  while (raw_token.type !== TOKEN.EOF) {
	
	    if (raw_token.type === TOKEN.TAG_OPEN || raw_token.type === TOKEN.COMMENT) {
	      parser_token = this._handle_tag_open(printer, raw_token, last_tag_token, last_token);
	      last_tag_token = parser_token;
	    } else if ((raw_token.type === TOKEN.ATTRIBUTE || raw_token.type === TOKEN.EQUALS || raw_token.type === TOKEN.VALUE) ||
	      (raw_token.type === TOKEN.TEXT && !last_tag_token.tag_complete)) {
	      parser_token = this._handle_inside_tag(printer, raw_token, last_tag_token, tokens);
	    } else if (raw_token.type === TOKEN.TAG_CLOSE) {
	      parser_token = this._handle_tag_close(printer, raw_token, last_tag_token);
	    } else if (raw_token.type === TOKEN.TEXT) {
	      parser_token = this._handle_text(printer, raw_token, last_tag_token);
	    } else {
	      // This should never happen, but if it does. Print the raw token
	      printer.add_raw_token(raw_token);
	    }
	
	    last_token = parser_token;
	
	    raw_token = tokens.next();
	  }
	  var sweet_code = printer._output.get_code(eol);
	
	  return sweet_code;
	};
	
	Beautifier.prototype._handle_tag_close = function(printer, raw_token, last_tag_token) {
	  var parser_token = { text: raw_token.text, type: raw_token.type };
	  printer.alignment_size = 0;
	  last_tag_token.tag_complete = true;
	
	  printer.set_space_before_token(raw_token.newlines || raw_token.whitespace_before !== '');
	  if (last_tag_token.is_unformatted) {
	    printer.add_raw_token(raw_token);
	  } else {
	    if (last_tag_token.tag_start_char === '<') {
	      printer.set_space_before_token(raw_token.text[0] === '/'); // space before />, no space before >
	      if (this._is_wrap_attributes_force_expand_multiline && last_tag_token.has_wrapped_attrs) {
	        printer.print_newline(false);
	      }
	    }
	    printer.print_token(raw_token.text);
	  }
	
	  if (last_tag_token.indent_content &&
	    !(last_tag_token.is_unformatted || last_tag_token.is_content_unformatted)) {
	    printer.indent();
	
	    // only indent once per opened tag
	    last_tag_token.indent_content = false;
	  }
	  return parser_token;
	};
	
	Beautifier.prototype._handle_inside_tag = function(printer, raw_token, last_tag_token, tokens) {
	  var parser_token = { text: raw_token.text, type: raw_token.type };
	  printer.set_space_before_token(raw_token.newlines || raw_token.whitespace_before !== '');
	  if (last_tag_token.is_unformatted) {
	    printer.add_raw_token(raw_token);
	  } else if (last_tag_token.tag_start_char === '{' && raw_token.type === TOKEN.TEXT) {
	    // For the insides of handlebars allow newlines or a single space between open and contents
	    if (printer.print_preserved_newlines(raw_token)) {
	      printer.print_raw_text(raw_token.whitespace_before + raw_token.text);
	    } else {
	      printer.print_token(raw_token.text);
	    }
	  } else {
	    if (raw_token.type === TOKEN.ATTRIBUTE) {
	      printer.set_space_before_token(true);
	      last_tag_token.attr_count += 1;
	    } else if (raw_token.type === TOKEN.EQUALS) { //no space before =
	      printer.set_space_before_token(false);
	    } else if (raw_token.type === TOKEN.VALUE && raw_token.previous.type === TOKEN.EQUALS) { //no space before value
	      printer.set_space_before_token(false);
	    }
	
	    if (printer._output.space_before_token && last_tag_token.tag_start_char === '<') {
	      // Allow the current attribute to wrap
	      // Set wrapped to true if the line is wrapped
	      var wrapped = printer.print_space_or_wrap(raw_token.text);
	      if (raw_token.type === TOKEN.ATTRIBUTE) {
	        if (this._is_wrap_attributes_preserve || this._is_wrap_attributes_preserve_aligned) {
	          printer.traverse_whitespace(raw_token);
	          wrapped = wrapped || raw_token.newlines !== 0;
	        }
	        // Save whether we have wrapped any attributes
	        last_tag_token.has_wrapped_attrs = last_tag_token.has_wrapped_attrs || wrapped;
	
	        if (this._is_wrap_attributes_force) {
	          var force_attr_wrap = last_tag_token.attr_count > 1;
	          if (this._is_wrap_attributes_force_expand_multiline && last_tag_token.attr_count === 1) {
	            var is_only_attribute = true;
	            var peek_index = 0;
	            var peek_token;
	            do {
	              peek_token = tokens.peek(peek_index);
	              if (peek_token.type === TOKEN.ATTRIBUTE) {
	                is_only_attribute = false;
	                break;
	              }
	              peek_index += 1;
	            } while (peek_index < 4 && peek_token.type !== TOKEN.EOF && peek_token.type !== TOKEN.TAG_CLOSE);
	
	            force_attr_wrap = !is_only_attribute;
	          }
	
	          if (force_attr_wrap) {
	            printer.print_newline(false);
	            last_tag_token.has_wrapped_attrs = true;
	          }
	        }
	      }
	    }
	    printer.print_token(raw_token.text);
	  }
	  return parser_token;
	};
	
	Beautifier.prototype._handle_text = function(printer, raw_token, last_tag_token) {
	  var parser_token = { text: raw_token.text, type: 'TK_CONTENT' };
	  if (last_tag_token.custom_beautifier) { //check if we need to format javascript
	    this._print_custom_beatifier_text(printer, raw_token, last_tag_token);
	  } else if (last_tag_token.is_unformatted || last_tag_token.is_content_unformatted) {
	    printer.add_raw_token(raw_token);
	  } else {
	    printer.traverse_whitespace(raw_token);
	    printer.print_token(raw_token.text);
	  }
	  return parser_token;
	};
	
	Beautifier.prototype._print_custom_beatifier_text = function(printer, raw_token, last_tag_token) {
	  if (raw_token.text !== '') {
	    printer.print_newline(false);
	    var text = raw_token.text,
	      _beautifier,
	      script_indent_level = 1;
	    if (last_tag_token.tag_name === 'script') {
	      _beautifier = typeof this._js_beautify === 'function' && this._js_beautify;
	    } else if (last_tag_token.tag_name === 'style') {
	      _beautifier = typeof this._css_beautify === 'function' && this._css_beautify;
	    }
	
	    if (this._options.indent_scripts === "keep") {
	      script_indent_level = 0;
	    } else if (this._options.indent_scripts === "separate") {
	      script_indent_level = -printer.indent_level;
	    }
	
	    var indentation = printer.get_full_indent(script_indent_level);
	
	    // if there is at least one empty line at the end of this text, strip it
	    // we'll be adding one back after the text but before the containing tag.
	    text = text.replace(/\n[ \t]*$/, '');
	
	    if (_beautifier) {
	
	      // call the Beautifier if avaliable
	      var Child_options = function() {
	        this.eol = '\n';
	      };
	      Child_options.prototype = this._options.raw_options;
	      var child_options = new Child_options();
	      text = _beautifier(indentation + text, child_options);
	    } else {
	      // simply indent the string otherwise
	      var white = text.match(/^\s*/)[0];
	      var _level = white.match(/[^\n\r]*$/)[0].split(this._options.indent_string).length - 1;
	      var reindent = this._get_full_indent(script_indent_level - _level);
	      text = (indentation + text.trim())
	        .replace(/\r\n|\r|\n/g, '\n' + reindent);
	    }
	    if (text) {
	      printer.print_raw_text(text);
	      printer.print_newline(true);
	    }
	  }
	};
	
	Beautifier.prototype._handle_tag_open = function(printer, raw_token, last_tag_token, last_token) {
	  var parser_token = this._get_tag_open_token(raw_token);
	
	  if ((last_tag_token.is_unformatted || last_tag_token.is_content_unformatted) &&
	    raw_token.type === TOKEN.TAG_OPEN && raw_token.text.indexOf('</') === 0) {
	    // End element tags for unformatted or content_unformatted elements
	    // are printed raw to keep any newlines inside them exactly the same.
	    printer.add_raw_token(raw_token);
	  } else {
	    printer.traverse_whitespace(raw_token);
	    this._set_tag_position(printer, raw_token, parser_token, last_tag_token, last_token);
	    printer.print_token(raw_token.text);
	  }
	
	  //indent attributes an auto, forced, aligned or forced-align line-wrap
	  if (this._is_wrap_attributes_force_aligned || this._is_wrap_attributes_aligned_multiple || this._is_wrap_attributes_preserve_aligned) {
	    parser_token.alignment_size = raw_token.text.length + 1;
	  }
	
	
	  if (!parser_token.tag_complete && !parser_token.is_unformatted) {
	    printer.alignment_size = parser_token.alignment_size;
	  }
	
	  return parser_token;
	};
	
	var TagOpenParserToken = function(parent, raw_token) {
	  this.parent = parent || null;
	  this.text = '';
	  this.type = 'TK_TAG_OPEN';
	  this.tag_name = '';
	  this.is_inline_element = false;
	  this.is_unformatted = false;
	  this.is_content_unformatted = false;
	  this.is_empty_element = false;
	  this.is_start_tag = false;
	  this.is_end_tag = false;
	  this.indent_content = false;
	  this.multiline_content = false;
	  this.custom_beautifier = false;
	  this.start_tag_token = null;
	  this.attr_count = 0;
	  this.has_wrapped_attrs = false;
	  this.alignment_size = 0;
	  this.tag_complete = false;
	  this.tag_start_char = '';
	  this.tag_check = '';
	
	  if (!raw_token) {
	    this.tag_complete = true;
	  } else {
	    var tag_check_match;
	
	    this.tag_start_char = raw_token.text[0];
	    this.text = raw_token.text;
	
	    if (this.tag_start_char === '<') {
	      tag_check_match = raw_token.text.match(/^<([^\s>]*)/);
	      this.tag_check = tag_check_match ? tag_check_match[1] : '';
	    } else {
	      tag_check_match = raw_token.text.match(/^{{\#?([^\s}]+)/);
	      this.tag_check = tag_check_match ? tag_check_match[1] : '';
	    }
	    this.tag_check = this.tag_check.toLowerCase();
	
	    if (raw_token.type === TOKEN.COMMENT) {
	      this.tag_complete = true;
	    }
	
	    this.is_start_tag = this.tag_check.charAt(0) !== '/';
	    this.tag_name = !this.is_start_tag ? this.tag_check.substr(1) : this.tag_check;
	    this.is_end_tag = !this.is_start_tag ||
	      (raw_token.closed && raw_token.closed.text === '/>');
	
	    // handlebars tags that don't start with # or ^ are single_tags, and so also start and end.
	    this.is_end_tag = this.is_end_tag ||
	      (this.tag_start_char === '{' && (this.text.length < 3 || (/[^#\^]/.test(this.text.charAt(2)))));
	  }
	};
	
	Beautifier.prototype._get_tag_open_token = function(raw_token) { //function to get a full tag and parse its type
	  var parser_token = new TagOpenParserToken(this._tag_stack.get_parser_token(), raw_token);
	
	  parser_token.alignment_size = this._options.wrap_attributes_indent_size;
	
	  parser_token.is_end_tag = parser_token.is_end_tag ||
	    in_array(parser_token.tag_check, this._options.void_elements);
	
	  parser_token.is_empty_element = parser_token.tag_complete ||
	    (parser_token.is_start_tag && parser_token.is_end_tag);
	
	  parser_token.is_unformatted = !parser_token.tag_complete && in_array(parser_token.tag_check, this._options.unformatted);
	  parser_token.is_content_unformatted = !parser_token.is_empty_element && in_array(parser_token.tag_check, this._options.content_unformatted);
	  parser_token.is_inline_element = in_array(parser_token.tag_name, this._options.inline) || parser_token.tag_start_char === '{';
	
	  return parser_token;
	};
	
	Beautifier.prototype._set_tag_position = function(printer, raw_token, parser_token, last_tag_token, last_token) {
	
	  if (!parser_token.is_empty_element) {
	    if (parser_token.is_end_tag) { //this tag is a double tag so check for tag-ending
	      parser_token.start_tag_token = this._tag_stack.try_pop(parser_token.tag_name); //remove it and all ancestors
	    } else { // it's a start-tag
	      // check if this tag is starting an element that has optional end element
	      // and do an ending needed
	      this._do_optional_end_element(parser_token);
	
	      this._tag_stack.record_tag(parser_token); //push it on the tag stack
	
	      if ((parser_token.tag_name === 'script' || parser_token.tag_name === 'style') &&
	        !(parser_token.is_unformatted || parser_token.is_content_unformatted)) {
	        parser_token.custom_beautifier = uses_beautifier(parser_token.tag_check, raw_token);
	      }
	    }
	  }
	
	  if (in_array(parser_token.tag_check, this._options.extra_liners)) { //check if this double needs an extra line
	    printer.print_newline(false);
	    if (!printer._output.just_added_blankline()) {
	      printer.print_newline(true);
	    }
	  }
	
	  if (parser_token.is_empty_element) { //if this tag name is a single tag type (either in the list or has a closing /)
	
	    // if you hit an else case, reset the indent level if you are inside an:
	    // 'if', 'unless', or 'each' block.
	    if (parser_token.tag_start_char === '{' && parser_token.tag_check === 'else') {
	      this._tag_stack.indent_to_tag(['if', 'unless', 'each']);
	      parser_token.indent_content = true;
	      // Don't add a newline if opening {{#if}} tag is on the current line
	      var foundIfOnCurrentLine = printer.current_line_has_match(/{{#if/);
	      if (!foundIfOnCurrentLine) {
	        printer.print_newline(false);
	      }
	    }
	
	    // Don't add a newline before elements that should remain where they are.
	    if (parser_token.tag_name === '!--' && last_token.type === TOKEN.TAG_CLOSE &&
	      last_tag_token.is_end_tag && parser_token.text.indexOf('\n') === -1) {
	      //Do nothing. Leave comments on same line.
	    } else if (!parser_token.is_inline_element && !parser_token.is_unformatted) {
	      printer.print_newline(false);
	    }
	  } else if (parser_token.is_unformatted || parser_token.is_content_unformatted) {
	    if (!parser_token.is_inline_element && !parser_token.is_unformatted) {
	      printer.print_newline(false);
	    }
	  } else if (parser_token.is_end_tag) { //this tag is a double tag so check for tag-ending
	    if ((parser_token.start_tag_token && parser_token.start_tag_token.multiline_content) ||
	      !(parser_token.is_inline_element ||
	        (last_tag_token.is_inline_element) ||
	        (last_token.type === TOKEN.TAG_CLOSE &&
	          parser_token.start_tag_token === last_tag_token) ||
	        (last_token.type === 'TK_CONTENT')
	      )) {
	      printer.print_newline(false);
	    }
	  } else { // it's a start-tag
	    parser_token.indent_content = !parser_token.custom_beautifier;
	
	    if (parser_token.tag_start_char === '<') {
	      if (parser_token.tag_name === 'html') {
	        parser_token.indent_content = this._options.indent_inner_html;
	      } else if (parser_token.tag_name === 'head') {
	        parser_token.indent_content = this._options.indent_head_inner_html;
	      } else if (parser_token.tag_name === 'body') {
	        parser_token.indent_content = this._options.indent_body_inner_html;
	      }
	    }
	
	    if (!parser_token.is_inline_element && last_token.type !== 'TK_CONTENT') {
	      if (parser_token.parent) {
	        parser_token.parent.multiline_content = true;
	      }
	      printer.print_newline(false);
	    }
	  }
	};
	
	//To be used for <p> tag special case:
	//var p_closers = ['address', 'article', 'aside', 'blockquote', 'details', 'div', 'dl', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hr', 'main', 'nav', 'ol', 'p', 'pre', 'section', 'table', 'ul'];
	
	Beautifier.prototype._do_optional_end_element = function(parser_token) {
	  // NOTE: cases of "if there is no more content in the parent element"
	  // are handled automatically by the beautifier.
	  // It assumes parent or ancestor close tag closes all children.
	  // https://www.w3.org/TR/html5/syntax.html#optional-tags
	  if (parser_token.is_empty_element || !parser_token.is_start_tag || !parser_token.parent) {
	    return;
	
	  } else if (parser_token.tag_name === 'body') {
	    // A head element’s end tag may be omitted if the head element is not immediately followed by a space character or a comment.
	    this._tag_stack.try_pop('head');
	
	    //} else if (parser_token.tag_name === 'body') {
	    // DONE: A body element’s end tag may be omitted if the body element is not immediately followed by a comment.
	
	  } else if (parser_token.tag_name === 'li') {
	    // An li element’s end tag may be omitted if the li element is immediately followed by another li element or if there is no more content in the parent element.
	    this._tag_stack.try_pop('li', ['ol', 'ul']);
	
	  } else if (parser_token.tag_name === 'dd' || parser_token.tag_name === 'dt') {
	    // A dd element’s end tag may be omitted if the dd element is immediately followed by another dd element or a dt element, or if there is no more content in the parent element.
	    // A dt element’s end tag may be omitted if the dt element is immediately followed by another dt element or a dd element.
	    this._tag_stack.try_pop('dt', ['dl']);
	    this._tag_stack.try_pop('dd', ['dl']);
	
	    //} else if (p_closers.indexOf(parser_token.tag_name) !== -1) {
	    //TODO: THIS IS A BUG FARM. We are not putting this into 1.8.0 as it is likely to blow up.
	    //A p element’s end tag may be omitted if the p element is immediately followed by an address, article, aside, blockquote, details, div, dl, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hr, main, nav, ol, p, pre, section, table, or ul element, or if there is no more content in the parent element and the parent element is an HTML element that is not an a, audio, del, ins, map, noscript, or video element, or an autonomous custom element.
	    //this._tag_stack.try_pop('p', ['body']);
	
	  } else if (parser_token.tag_name === 'rp' || parser_token.tag_name === 'rt') {
	    // An rt element’s end tag may be omitted if the rt element is immediately followed by an rt or rp element, or if there is no more content in the parent element.
	    // An rp element’s end tag may be omitted if the rp element is immediately followed by an rt or rp element, or if there is no more content in the parent element.
	    this._tag_stack.try_pop('rt', ['ruby', 'rtc']);
	    this._tag_stack.try_pop('rp', ['ruby', 'rtc']);
	
	  } else if (parser_token.tag_name === 'optgroup') {
	    // An optgroup element’s end tag may be omitted if the optgroup element is immediately followed by another optgroup element, or if there is no more content in the parent element.
	    // An option element’s end tag may be omitted if the option element is immediately followed by another option element, or if it is immediately followed by an optgroup element, or if there is no more content in the parent element.
	    this._tag_stack.try_pop('optgroup', ['select']);
	    //this._tag_stack.try_pop('option', ['select']);
	
	  } else if (parser_token.tag_name === 'option') {
	    // An option element’s end tag may be omitted if the option element is immediately followed by another option element, or if it is immediately followed by an optgroup element, or if there is no more content in the parent element.
	    this._tag_stack.try_pop('option', ['select', 'datalist', 'optgroup']);
	
	  } else if (parser_token.tag_name === 'colgroup') {
	    // DONE: A colgroup element’s end tag may be omitted if the colgroup element is not immediately followed by a space character or a comment.
	    // A caption element's end tag may be ommitted if a colgroup, thead, tfoot, tbody, or tr element is started.
	    this._tag_stack.try_pop('caption', ['table']);
	
	  } else if (parser_token.tag_name === 'thead') {
	    // A colgroup element's end tag may be ommitted if a thead, tfoot, tbody, or tr element is started.
	    // A caption element's end tag may be ommitted if a colgroup, thead, tfoot, tbody, or tr element is started.
	    this._tag_stack.try_pop('caption', ['table']);
	    this._tag_stack.try_pop('colgroup', ['table']);
	
	    //} else if (parser_token.tag_name === 'caption') {
	    // DONE: A caption element’s end tag may be omitted if the caption element is not immediately followed by a space character or a comment.
	
	  } else if (parser_token.tag_name === 'tbody' || parser_token.tag_name === 'tfoot') {
	    // A thead element’s end tag may be omitted if the thead element is immediately followed by a tbody or tfoot element.
	    // A tbody element’s end tag may be omitted if the tbody element is immediately followed by a tbody or tfoot element, or if there is no more content in the parent element.
	    // A colgroup element's end tag may be ommitted if a thead, tfoot, tbody, or tr element is started.
	    // A caption element's end tag may be ommitted if a colgroup, thead, tfoot, tbody, or tr element is started.
	    this._tag_stack.try_pop('caption', ['table']);
	    this._tag_stack.try_pop('colgroup', ['table']);
	    this._tag_stack.try_pop('thead', ['table']);
	    this._tag_stack.try_pop('tbody', ['table']);
	
	    //} else if (parser_token.tag_name === 'tfoot') {
	    // DONE: A tfoot element’s end tag may be omitted if there is no more content in the parent element.
	
	  } else if (parser_token.tag_name === 'tr') {
	    // A tr element’s end tag may be omitted if the tr element is immediately followed by another tr element, or if there is no more content in the parent element.
	    // A colgroup element's end tag may be ommitted if a thead, tfoot, tbody, or tr element is started.
	    // A caption element's end tag may be ommitted if a colgroup, thead, tfoot, tbody, or tr element is started.
	    this._tag_stack.try_pop('caption', ['table']);
	    this._tag_stack.try_pop('colgroup', ['table']);
	    this._tag_stack.try_pop('tr', ['table', 'thead', 'tbody', 'tfoot']);
	
	  } else if (parser_token.tag_name === 'th' || parser_token.tag_name === 'td') {
	    // A td element’s end tag may be omitted if the td element is immediately followed by a td or th element, or if there is no more content in the parent element.
	    // A th element’s end tag may be omitted if the th element is immediately followed by a td or th element, or if there is no more content in the parent element.
	    this._tag_stack.try_pop('td', ['tr']);
	    this._tag_stack.try_pop('th', ['tr']);
	  }
	
	  // Start element omission not handled currently
	  // A head element’s start tag may be omitted if the element is empty, or if the first thing inside the head element is an element.
	  // A tbody element’s start tag may be omitted if the first thing inside the tbody element is a tr element, and if the element is not immediately preceded by a tbody, thead, or tfoot element whose end tag has been omitted. (It can’t be omitted if the element is empty.)
	  // A colgroup element’s start tag may be omitted if the first thing inside the colgroup element is a col element, and if the element is not immediately preceded by another colgroup element whose end tag has been omitted. (It can’t be omitted if the element is empty.)
	
	  // Fix up the parent of the parser token
	  parser_token.parent = this._tag_stack.get_parser_token();
	
	};
	
	module.exports.Beautifier = Beautifier;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var BaseOptions = __webpack_require__(6).Options;
	
	function Options(options) {
	  BaseOptions.call(this, options, 'html');
	
	  this.indent_inner_html = this._get_boolean('indent_inner_html');
	  this.indent_body_inner_html = this._get_boolean('indent_body_inner_html', true);
	  this.indent_head_inner_html = this._get_boolean('indent_head_inner_html', true);
	
	  this.indent_handlebars = this._get_boolean('indent_handlebars', true);
	  this.wrap_attributes = this._get_selection('wrap_attributes',
	    ['auto', 'force', 'force-aligned', 'force-expand-multiline', 'aligned-multiple', 'preserve', 'preserve-aligned']);
	  this.wrap_attributes_indent_size = this._get_number('wrap_attributes_indent_size', this.indent_size);
	  this.extra_liners = this._get_array('extra_liners', ['head', 'body', '/html']);
	
	  this.inline = this._get_array('inline', [
	    // https://www.w3.org/TR/html5/dom.html#phrasing-content
	    'a', 'abbr', 'area', 'audio', 'b', 'bdi', 'bdo', 'br', 'button', 'canvas', 'cite',
	    'code', 'data', 'datalist', 'del', 'dfn', 'em', 'embed', 'i', 'iframe', 'img',
	    'input', 'ins', 'kbd', 'keygen', 'label', 'map', 'mark', 'math', 'meter', 'noscript',
	    'object', 'output', 'progress', 'q', 'ruby', 's', 'samp', /* 'script', */ 'select', 'small',
	    'span', 'strong', 'sub', 'sup', 'svg', 'template', 'textarea', 'time', 'u', 'var',
	    'video', 'wbr', 'text',
	    // prexisting - not sure of full effect of removing, leaving in
	    'acronym', 'address', 'big', 'dt', 'ins', 'strike', 'tt'
	  ]);
	  this.void_elements = this._get_array('void_elements', [
	    // HTLM void elements - aka self-closing tags - aka singletons
	    // https://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
	    'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen',
	    'link', 'menuitem', 'meta', 'param', 'source', 'track', 'wbr',
	    // NOTE: Optional tags are too complex for a simple list
	    // they are hard coded in _do_optional_end_element
	
	    // Doctype and xml elements
	    '!doctype', '?xml',
	    // ?php and ?= tags
	    '?php', '?=',
	    // other tags that were in this list, keeping just in case
	    'basefont', 'isindex'
	  ]);
	  this.unformatted = this._get_array('unformatted', []);
	  this.content_unformatted = this._get_array('content_unformatted', [
	    'pre', 'textarea'
	  ]);
	  this.indent_scripts = this._get_selection('indent_scripts', ['normal', 'keep', 'separate']);
	}
	Options.prototype = new BaseOptions();
	
	
	
	module.exports.Options = Options;
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*jshint node:true */
	/*
	
	  The MIT License (MIT)
	
	  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.
	
	  Permission is hereby granted, free of charge, to any person
	  obtaining a copy of this software and associated documentation files
	  (the "Software"), to deal in the Software without restriction,
	  including without limitation the rights to use, copy, modify, merge,
	  publish, distribute, sublicense, and/or sell copies of the Software,
	  and to permit persons to whom the Software is furnished to do so,
	  subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be
	  included in all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
	  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	*/
	
	
	
	var BaseTokenizer = __webpack_require__(9).Tokenizer;
	var BASETOKEN = __webpack_require__(9).TOKEN;
	var Directives = __webpack_require__(11).Directives;
	
	var TOKEN = {
	  TAG_OPEN: 'TK_TAG_OPEN',
	  TAG_CLOSE: 'TK_TAG_CLOSE',
	  ATTRIBUTE: 'TK_ATTRIBUTE',
	  EQUALS: 'TK_EQUALS',
	  VALUE: 'TK_VALUE',
	  COMMENT: 'TK_COMMENT',
	  TEXT: 'TK_TEXT',
	  UNKNOWN: 'TK_UNKNOWN',
	  START: BASETOKEN.START,
	  RAW: BASETOKEN.RAW,
	  EOF: BASETOKEN.EOF
	};
	
	var directives_core = new Directives(/<\!--/, /-->/);
	
	var Tokenizer = function(input_string, options) {
	  BaseTokenizer.call(this, input_string, options);
	  this._current_tag_name = '';
	
	  // Words end at whitespace or when a tag starts
	  // if we are indenting handlebars, they are considered tags
	  this._word_pattern = this._options.indent_handlebars ? /[\n\r\t <]|{{/g : /[\n\r\t <]/g;
	};
	Tokenizer.prototype = new BaseTokenizer();
	
	Tokenizer.prototype._is_comment = function(current_token) { // jshint unused:false
	  return false; //current_token.type === TOKEN.COMMENT || current_token.type === TOKEN.UNKNOWN;
	};
	
	Tokenizer.prototype._is_opening = function(current_token) {
	  return current_token.type === TOKEN.TAG_OPEN;
	};
	
	Tokenizer.prototype._is_closing = function(current_token, open_token) {
	  return current_token.type === TOKEN.TAG_CLOSE &&
	    (open_token && (
	      ((current_token.text === '>' || current_token.text === '/>') && open_token.text[0] === '<') ||
	      (current_token.text === '}}' && open_token.text[0] === '{' && open_token.text[1] === '{')));
	};
	
	Tokenizer.prototype._reset = function() {
	  this._current_tag_name = '';
	};
	
	Tokenizer.prototype._get_next_token = function(previous_token, open_token) { // jshint unused:false
	  this._readWhitespace();
	  var token = null;
	  var c = this._input.peek();
	
	  if (c === null) {
	    return this._create_token(TOKEN.EOF, '');
	  }
	
	  token = token || this._read_attribute(c, previous_token, open_token);
	  token = token || this._read_raw_content(previous_token, open_token);
	  token = token || this._read_comment(c);
	  token = token || this._read_open(c, open_token);
	  token = token || this._read_close(c, open_token);
	  token = token || this._read_content_word();
	  token = token || this._create_token(TOKEN.UNKNOWN, this._input.next());
	
	  return token;
	};
	
	Tokenizer.prototype._read_comment = function(c) { // jshint unused:false
	  var token = null;
	  if (c === '<' || c === '{') {
	    var peek1 = this._input.peek(1);
	    var peek2 = this._input.peek(2);
	    if ((c === '<' && (peek1 === '!' || peek1 === '?' || peek1 === '%')) ||
	      this._options.indent_handlebars && c === '{' && peek1 === '{' && peek2 === '!') {
	      //if we're in a comment, do something special
	      // We treat all comments as literals, even more than preformatted tags
	      // we just look for the appropriate close tag
	
	      // this is will have very poor perf, but will work for now.
	      var comment = '',
	        delimiter = '>',
	        matched = false;
	
	      var input_char = this._input.next();
	
	      while (input_char) {
	        comment += input_char;
	
	        // only need to check for the delimiter if the last chars match
	        if (comment.charAt(comment.length - 1) === delimiter.charAt(delimiter.length - 1) &&
	          comment.indexOf(delimiter) !== -1) {
	          break;
	        }
	
	        // only need to search for custom delimiter for the first few characters
	        if (!matched) {
	          matched = comment.length > 10;
	          if (comment.indexOf('<![if') === 0) { //peek for <![if conditional comment
	            delimiter = '<![endif]>';
	            matched = true;
	          } else if (comment.indexOf('<![cdata[') === 0) { //if it's a <[cdata[ comment...
	            delimiter = ']]>';
	            matched = true;
	          } else if (comment.indexOf('<![') === 0) { // some other ![ comment? ...
	            delimiter = ']>';
	            matched = true;
	          } else if (comment.indexOf('<!--') === 0) { // <!-- comment ...
	            delimiter = '-->';
	            matched = true;
	          } else if (comment.indexOf('{{!--') === 0) { // {{!-- handlebars comment
	            delimiter = '--}}';
	            matched = true;
	          } else if (comment.indexOf('{{!') === 0) { // {{! handlebars comment
	            if (comment.length === 5 && comment.indexOf('{{!--') === -1) {
	              delimiter = '}}';
	              matched = true;
	            }
	          } else if (comment.indexOf('<?') === 0) { // {{! handlebars comment
	            delimiter = '?>';
	            matched = true;
	          } else if (comment.indexOf('<%') === 0) { // {{! handlebars comment
	            delimiter = '%>';
	            matched = true;
	          }
	        }
	
	        input_char = this._input.next();
	      }
	
	      var directives = directives_core.get_directives(comment);
	      if (directives && directives.ignore === 'start') {
	        comment += directives_core.readIgnored(this._input);
	      }
	      token = this._create_token(TOKEN.COMMENT, comment);
	      token.directives = directives;
	    }
	  }
	
	  return token;
	};
	
	Tokenizer.prototype._read_open = function(c, open_token) {
	  var resulting_string = null;
	  var token = null;
	  if (!open_token) {
	    if (c === '<') {
	      resulting_string = this._input.read(/<(?:[^\n\r\t >{][^\n\r\t >{/]*)?/g);
	      token = this._create_token(TOKEN.TAG_OPEN, resulting_string);
	    } else if (this._options.indent_handlebars && c === '{' && this._input.peek(1) === '{') {
	      resulting_string = this._input.readUntil(/[\n\r\t }]/g);
	      token = this._create_token(TOKEN.TAG_OPEN, resulting_string);
	    }
	  }
	  return token;
	};
	
	Tokenizer.prototype._read_close = function(c, open_token) {
	  var resulting_string = null;
	  var token = null;
	  if (open_token) {
	    if (open_token.text[0] === '<' && (c === '>' || (c === '/' && this._input.peek(1) === '>'))) {
	      resulting_string = this._input.next();
	      if (c === '/') { //  for close tag "/>"
	        resulting_string += this._input.next();
	      }
	      token = this._create_token(TOKEN.TAG_CLOSE, resulting_string);
	    } else if (open_token.text[0] === '{' && c === '}' && this._input.peek(1) === '}') {
	      this._input.next();
	      this._input.next();
	      token = this._create_token(TOKEN.TAG_CLOSE, '}}');
	    }
	  }
	
	  return token;
	};
	
	Tokenizer.prototype._read_attribute = function(c, previous_token, open_token) {
	  var token = null;
	  var resulting_string = '';
	  if (open_token && open_token.text[0] === '<') {
	
	    if (c === '=') {
	      token = this._create_token(TOKEN.EQUALS, this._input.next());
	    } else if (c === '"' || c === "'") {
	      var content = this._input.next();
	      var input_string = '';
	      var string_pattern = new RegExp(c + '|{{', 'g');
	      while (this._input.hasNext()) {
	        input_string = this._input.readUntilAfter(string_pattern);
	        content += input_string;
	        if (input_string[input_string.length - 1] === '"' || input_string[input_string.length - 1] === "'") {
	          break;
	        } else if (this._input.hasNext()) {
	          content += this._input.readUntilAfter(/}}/g);
	        }
	      }
	
	      token = this._create_token(TOKEN.VALUE, content);
	    } else {
	      if (c === '{' && this._input.peek(1) === '{') {
	        resulting_string = this._input.readUntilAfter(/}}/g);
	      } else {
	        resulting_string = this._input.readUntil(/[\n\r\t =\/>]/g);
	      }
	
	      if (resulting_string) {
	        if (previous_token.type === TOKEN.EQUALS) {
	          token = this._create_token(TOKEN.VALUE, resulting_string);
	        } else {
	          token = this._create_token(TOKEN.ATTRIBUTE, resulting_string);
	        }
	      }
	    }
	  }
	  return token;
	};
	
	Tokenizer.prototype._is_content_unformatted = function(tag_name) {
	  // void_elements have no content and so cannot have unformatted content
	  // script and style tags should always be read as unformatted content
	  // finally content_unformatted and unformatted element contents are unformatted
	  return this._options.void_elements.indexOf(tag_name) === -1 &&
	    (tag_name === 'script' || tag_name === 'style' ||
	      this._options.content_unformatted.indexOf(tag_name) !== -1 ||
	      this._options.unformatted.indexOf(tag_name) !== -1);
	};
	
	
	Tokenizer.prototype._read_raw_content = function(previous_token, open_token) { // jshint unused:false
	  var resulting_string = '';
	  if (open_token && open_token.text[0] === '{') {
	    resulting_string = this._input.readUntil(/}}/g);
	  } else if (previous_token.type === TOKEN.TAG_CLOSE && (previous_token.opened.text[0] === '<')) {
	    var tag_name = previous_token.opened.text.substr(1).toLowerCase();
	    if (this._is_content_unformatted(tag_name)) {
	      resulting_string = this._input.readUntil(new RegExp('</' + tag_name + '[\\n\\r\\t ]*?>', 'ig'));
	    }
	  }
	
	  if (resulting_string) {
	    return this._create_token(TOKEN.TEXT, resulting_string);
	  }
	
	  return null;
	};
	
	Tokenizer.prototype._read_content_word = function() {
	  // if we get here and we see handlebars treat them as plain text
	  var resulting_string = this._input.readUntil(this._word_pattern);
	  if (resulting_string) {
	    return this._create_token(TOKEN.TEXT, resulting_string);
	  }
	};
	
	module.exports.Tokenizer = Tokenizer;
	module.exports.TOKEN = TOKEN;
	
	
	/***/ })
	/******/ ]);
	var style_html = legacy_beautify_html;
	/* Footer */
	if (true) {
	    // Add support for AMD ( https://github.com/amdjs/amdjs-api/wiki/AMD#defineamd-property- )
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, __webpack_require__(196), __webpack_require__(195)], __WEBPACK_AMD_DEFINE_RESULT__ = function(requireamd) {
	        var js_beautify = __webpack_require__(196);
	        var css_beautify = __webpack_require__(195);
	
	        return {
	            html_beautify: function(html_source, options) {
	                return style_html(html_source, options, js_beautify.js_beautify, css_beautify.css_beautify);
	            }
	        };
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== "undefined") {
	    // Add support for CommonJS. Just put this file somewhere on your require.paths
	    // and you will be able to `var html_beautify = require("beautify").html_beautify`.
	    var js_beautify = require('./beautify.js');
	    var css_beautify = require('./beautify-css.js');
	
	    exports.html_beautify = function(html_source, options) {
	        return style_html(html_source, options, js_beautify.js_beautify, css_beautify.css_beautify);
	    };
	} else if (typeof window !== "undefined") {
	    // If we're running a web page and don't have either of the above, add our one global
	    window.html_beautify = function(html_source, options) {
	        return style_html(html_source, options, window.js_beautify, window.css_beautify);
	    };
	} else if (typeof global !== "undefined") {
	    // If we don't even have window, try global.
	    global.html_beautify = function(html_source, options) {
	        return style_html(html_source, options, global.js_beautify, global.css_beautify);
	    };
	}
	
	}());


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(890);


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	(function(root, factory) {
	
	 'use strict';
	
	  if (true) {
	    // CommonJS
	    module.exports = factory();
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD
	    define('json-schema-defaults', [], function() {
	      return factory();
	    });
	  } else {
	    // global with noConflict
	    var jsonSchemaDefaults = root.jsonSchemaDefaults;
	    root.jsonSchemaDefaults = factory();
	    root.jsonSchemaDefaults.noConflict = function() {
	      var defaults = root.jsonSchemaDefaults;
	      root.jsonSchemaDefaults = jsonSchemaDefaults;
	      return defaults;
	    };
	  }
	
	}(this, function() {
	
	  'use strict';
	
	  /**
	   * check whether item is plain object
	   * @param {*} item
	   * @return {Boolean}
	   */
	  var isObject = function(item) {
	    return typeof item === 'object' && item !== null && item.toString() === {}.toString();
	  };
	
	  /**
	   * deep JSON object clone
	   *
	   * @param {Object} source
	   * @return {Object}
	   */
	  var cloneJSON = function(source) {
	    return JSON.parse(JSON.stringify(source));
	  };
	
	  /**
	   * returns a result of deep merge of two objects
	   *
	   * @param {Object} target
	   * @param {Object} source
	   * @return {Object}
	   */
	  var merge = function(target, source) {
	    target = cloneJSON(target);
	
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        if (isObject(target[key]) && isObject(source[key])) {
	          target[key] = merge(target[key], source[key]);
	        } else {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  };
	
	
	  /**
	   * get object by reference. works only with local references that points on
	   * definitions object
	   *
	   * @param {String} path
	   * @param {Object} definitions
	   * @return {Object}
	   */
	  var getLocalRef = function(path, definitions) {
	    path = path.replace(/^#\/definitions\//, '').split('/');
	
	    var find = function(path, root) {
	      var key = path.shift();
	      if (!root[key]) {
	        return {};
	      } else if (!path.length) {
	        return root[key];
	      } else {
	        return find(path, root[key]);
	      }
	    };
	
	    var result = find(path, definitions);
	
	    if (!isObject(result)) {
	      return result;
	    }
	    return cloneJSON(result);
	  };
	
	
	  /**
	   * merge list of objects from allOf properties
	   * if some of objects contains $ref field extracts this reference and merge it
	   *
	   * @param {Array} allOfList
	   * @param {Object} definitions
	   * @return {Object}
	   */
	  var mergeAllOf = function(allOfList, definitions) {
	    var length = allOfList.length,
	        index = -1,
	        result = {};
	
	    while (++index < length) {
	      var item = allOfList[index];
	
	      item = (typeof item.$ref !== 'undefined') ? getLocalRef(item.$ref, definitions) : item;
	
	      result = merge(result, item);
	    }
	
	    return result;
	  };
	
	
	  /**
	   * returns a object that built with default values from json schema
	   *
	   * @param {Object} schema
	   * @param {Object} definitions
	   * @return {Object}
	   */
	  var defaults = function(schema, definitions) {
	
	    if (typeof schema['default'] !== 'undefined') {
	
	      return schema['default'];
	
	    } else if (typeof schema.allOf !== 'undefined') {
	
	      var mergedItem = mergeAllOf(schema.allOf, definitions);
	      return defaults(mergedItem, definitions);
	
	    } else if (typeof schema.$ref !== 'undefined') {
	
	      var reference = getLocalRef(schema.$ref, definitions);
	      return defaults(reference, definitions);
	
	    } else if (schema.type === 'object') {
	
	      if (!schema.properties) { return {}; }
	
	      for (var key in schema.properties) {
	        if (schema.properties.hasOwnProperty(key)) {
	          schema.properties[key] = defaults(schema.properties[key], definitions);
	
	          if (typeof schema.properties[key] === 'undefined') {
	            delete schema.properties[key];
	          }
	        }
	      }
	
	      return schema.properties;
	
	    } else if (schema.type === 'array') {
	
	      if (!schema.items) { return []; }
	
	      // minimum item count
	      var ct = schema.minItems || 0;
	      // tuple-typed arrays
	      if (schema.items.constructor === Array) {
	        var values = schema.items.map(function (item) {
	          return defaults(item, definitions);
	        });
	        // remove undefined items at the end (unless required by minItems)
	        for (var i = values.length - 1; i >= 0; i--) {
	          if (typeof values[i] !== 'undefined') {
	            break;
	          }
	          if (i + 1 > ct) {
	            values.pop();
	          }
	        }
	        return values;
	      }
	      // object-typed arrays
	      var value = defaults(schema.items, definitions);
	      if (typeof value === 'undefined') {
	        return [];
	      } else {
	        var values = [];
	        for (var i = 0; i < Math.max(1, ct); i++) {
	          values.push(value);
	        }
	        return values;
	      }
	
	    }
	
	  };
	
	  /**
	   * main function
	   *
	   * @param {Object} schema
	   * @param {Object|undefined} definitions
	   * @return {Object}
	   */
	  return function (schema, definitions) {
	
	    if (typeof definitions === 'undefined') {
	      definitions = schema.definitions || {};
	    } else if (isObject(schema.definitions)) {
	      definitions = merge(definitions, schema.definitions);
	    }
	
	    return defaults(cloneJSON(schema), definitions);
	  };
	
	}));


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(197)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof modules === 'object' && module.exports) {
			// define a Common JS module that relies on 'leaflet'
			module.exports = factory(require('leaflet'));
		} else {
			// Assume Leaflet is loaded into global object L already
			factory(L);
		}
	}(this, function (L) {
		'use strict';
	
		L.TileLayer.Provider = L.TileLayer.extend({
			initialize: function (arg, options) {
				var providers = L.TileLayer.Provider.providers;
	
				var parts = arg.split('.');
	
				var providerName = parts[0];
				var variantName = parts[1];
	
				if (!providers[providerName]) {
					throw 'No such provider (' + providerName + ')';
				}
	
				var provider = {
					url: providers[providerName].url,
					options: providers[providerName].options
				};
	
				// overwrite values in provider from variant.
				if (variantName && 'variants' in providers[providerName]) {
					if (!(variantName in providers[providerName].variants)) {
						throw 'No such variant of ' + providerName + ' (' + variantName + ')';
					}
					var variant = providers[providerName].variants[variantName];
					var variantOptions;
					if (typeof variant === 'string') {
						variantOptions = {
							variant: variant
						};
					} else {
						variantOptions = variant.options;
					}
					provider = {
						url: variant.url || provider.url,
						options: L.Util.extend({}, provider.options, variantOptions)
					};
				}
	
				// replace attribution placeholders with their values from toplevel provider attribution,
				// recursively
				var attributionReplacer = function (attr) {
					if (attr.indexOf('{attribution.') === -1) {
						return attr;
					}
					return attr.replace(/\{attribution.(\w*)\}/,
						function (match, attributionName) {
							return attributionReplacer(providers[attributionName].options.attribution);
						}
					);
				};
				provider.options.attribution = attributionReplacer(provider.options.attribution);
	
				// Compute final options combining provider options with any user overrides
				var layerOpts = L.Util.extend({}, provider.options, options);
				L.TileLayer.prototype.initialize.call(this, provider.url, layerOpts);
			}
		});
	
		/**
		 * Definition of providers.
		 * see http://leafletjs.com/reference.html#tilelayer for options in the options map.
		 */
	
		L.TileLayer.Provider.providers = {
			OpenStreetMap: {
				url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
				options: {
					maxZoom: 19,
					attribution:
						'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
				},
				variants: {
					Mapnik: {},
					BlackAndWhite: {
						url: 'http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
						options: {
							maxZoom: 18
						}
					},
					DE: {
						url: 'https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png',
						options: {
							maxZoom: 18
						}
					},
					CH: {
						url: 'https://tile.osm.ch/switzerland/{z}/{x}/{y}.png',
						options: {
							maxZoom: 18,
							bounds: [[45, 5], [48, 11]]
						}
					},
					France: {
						url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
						options: {
							maxZoom: 20,
							attribution: '&copy; Openstreetmap France | {attribution.OpenStreetMap}'
						}
					},
					HOT: {
						url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
						options: {
							attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
						}
					},
					BZH: {
						url: 'https://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png',
						options: {
							attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://www.openstreetmap.bzh/" target="_blank">Breton OpenStreetMap Team</a>',
							bounds: [[46.2, -5.5], [50, 0.7]]
						}
					}
				}
			},
			OpenInfraMap: {
				url: 'https://tiles-{s}.openinframap.org/{variant}/{z}/{x}/{y}.png',
				options: {
					maxZoom: 18,
					attribution:
						'{attribution.OpenStreetMap}, <a href="http://www.openinframap.org/about.html">About OpenInfraMap</a>'
				},
				variants: {
					Power: 'power',
					Telecom: 'telecoms',
					Petroleum: 'petroleum',
					Water: 'water'
				}
			},
			OpenSeaMap: {
				url: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
				options: {
					attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
				}
			},
			OpenPtMap: {
				url: 'http://openptmap.org/tiles/{z}/{x}/{y}.png',
				options: {
					maxZoom: 17,
					attribution: 'Map data: &copy; <a href="http://www.openptmap.org">OpenPtMap</a> contributors'
				}
			},
			OpenTopoMap: {
				url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
				options: {
					maxZoom: 17,
					attribution: 'Map data: {attribution.OpenStreetMap}, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
				}
			},
			OpenRailwayMap: {
				url: 'https://{s}.tiles.openrailwaymap.org/standard/{z}/{x}/{y}.png',
				options: {
					maxZoom: 19,
					attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://www.OpenRailwayMap.org">OpenRailwayMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
				}
			},
			OpenFireMap: {
				url: 'http://openfiremap.org/hytiles/{z}/{x}/{y}.png',
				options: {
					maxZoom: 19,
					attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="http://www.openfiremap.org">OpenFireMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
				}
			},
			SafeCast: {
				url: 'https://s3.amazonaws.com/te512.safecast.org/{z}/{x}/{y}.png',
				options: {
					maxZoom: 16,
					attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://blog.safecast.org/about/">SafeCast</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
				}
			},
			Thunderforest: {
				url: 'https://{s}.tile.thunderforest.com/{variant}/{z}/{x}/{y}.png?apikey={apikey}',
				options: {
					attribution:
						'&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, {attribution.OpenStreetMap}',
					variant: 'cycle',
					apikey: '<insert your api key here>',
					maxZoom: 22
				},
				variants: {
					OpenCycleMap: 'cycle',
					Transport: {
						options: {
							variant: 'transport'
						}
					},
					TransportDark: {
						options: {
							variant: 'transport-dark'
						}
					},
					SpinalMap: {
						options: {
							variant: 'spinal-map'
						}
					},
					Landscape: 'landscape',
					Outdoors: 'outdoors',
					Pioneer: 'pioneer'
				}
			},
			OpenMapSurfer: {
				url: 'https://korona.geog.uni-heidelberg.de/tiles/{variant}/x={x}&y={y}&z={z}',
				options: {
					maxZoom: 20,
					variant: 'roads',
					attribution: 'Imagery from <a href="http://giscience.uni-hd.de/">GIScience Research Group @ University of Heidelberg</a> &mdash; Map data {attribution.OpenStreetMap}'
				},
				variants: {
					Roads: 'roads',
					AdminBounds: {
						options: {
							variant: 'adminb',
							maxZoom: 19
						}
					},
					Grayscale: {
						options: {
							variant: 'roadsg',
							maxZoom: 19
						}
					}
				}
			},
			Hydda: {
				url: 'https://{s}.tile.openstreetmap.se/hydda/{variant}/{z}/{x}/{y}.png',
				options: {
					maxZoom: 18,
					variant: 'full',
					attribution: 'Tiles courtesy of <a href="http://openstreetmap.se/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data {attribution.OpenStreetMap}'
				},
				variants: {
					Full: 'full',
					Base: 'base',
					RoadsAndLabels: 'roads_and_labels'
				}
			},
			MapBox: {
				url: 'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}{r}.png?access_token={accessToken}',
				options: {
					attribution:
						'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' +
						'Map data {attribution.OpenStreetMap}',
					subdomains: 'abcd',
					id: 'streets',
					accessToken: '<insert your access token here>',
				}
			},
			Stamen: {
				url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}{r}.{ext}',
				options: {
					attribution:
						'Map tiles by <a href="http://stamen.com">Stamen Design</a>, ' +
						'<a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; ' +
						'Map data {attribution.OpenStreetMap}',
					subdomains: 'abcd',
					minZoom: 0,
					maxZoom: 20,
					variant: 'toner',
					ext: 'png'
				},
				variants: {
					Toner: 'toner',
					TonerBackground: 'toner-background',
					TonerHybrid: 'toner-hybrid',
					TonerLines: 'toner-lines',
					TonerLabels: 'toner-labels',
					TonerLite: 'toner-lite',
					Watercolor: {
						url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}.{ext}',
						options: {
							variant: 'watercolor',
							minZoom: 1,
							maxZoom: 16
						}
					},
					Terrain: {
						options: {
							variant: 'terrain',
							minZoom: 0,
							maxZoom: 18
						}
					},
					TerrainBackground: {
						options: {
							variant: 'terrain-background',
							minZoom: 0,
							maxZoom: 18
						}
					},
					TopOSMRelief: {
						url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}.{ext}',
						options: {
							variant: 'toposm-color-relief',
							ext: 'jpg',
							bounds: [[22, -132], [51, -56]]
						}
					},
					TopOSMFeatures: {
						options: {
							variant: 'toposm-features',
							bounds: [[22, -132], [51, -56]],
							opacity: 0.9
						}
					}
				}
			},
			Esri: {
				url: 'https://server.arcgisonline.com/ArcGIS/rest/services/{variant}/MapServer/tile/{z}/{y}/{x}',
				options: {
					variant: 'World_Street_Map',
					attribution: 'Tiles &copy; Esri'
				},
				variants: {
					WorldStreetMap: {
						options: {
							attribution:
								'{attribution.Esri} &mdash; ' +
								'Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
						}
					},
					DeLorme: {
						options: {
							variant: 'Specialty/DeLorme_World_Base_Map',
							minZoom: 1,
							maxZoom: 11,
							attribution: '{attribution.Esri} &mdash; Copyright: &copy;2012 DeLorme'
						}
					},
					WorldTopoMap: {
						options: {
							variant: 'World_Topo_Map',
							attribution:
								'{attribution.Esri} &mdash; ' +
								'Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
						}
					},
					WorldImagery: {
						options: {
							variant: 'World_Imagery',
							attribution:
								'{attribution.Esri} &mdash; ' +
								'Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
						}
					},
					WorldTerrain: {
						options: {
							variant: 'World_Terrain_Base',
							maxZoom: 13,
							attribution:
								'{attribution.Esri} &mdash; ' +
								'Source: USGS, Esri, TANA, DeLorme, and NPS'
						}
					},
					WorldShadedRelief: {
						options: {
							variant: 'World_Shaded_Relief',
							maxZoom: 13,
							attribution: '{attribution.Esri} &mdash; Source: Esri'
						}
					},
					WorldPhysical: {
						options: {
							variant: 'World_Physical_Map',
							maxZoom: 8,
							attribution: '{attribution.Esri} &mdash; Source: US National Park Service'
						}
					},
					OceanBasemap: {
						options: {
							variant: 'Ocean_Basemap',
							maxZoom: 13,
							attribution: '{attribution.Esri} &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri'
						}
					},
					NatGeoWorldMap: {
						options: {
							variant: 'NatGeo_World_Map',
							maxZoom: 16,
							attribution: '{attribution.Esri} &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC'
						}
					},
					WorldGrayCanvas: {
						options: {
							variant: 'Canvas/World_Light_Gray_Base',
							maxZoom: 16,
							attribution: '{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ'
						}
					}
				}
			},
			OpenWeatherMap: {
				url: 'http://{s}.tile.openweathermap.org/map/{variant}/{z}/{x}/{y}.png?appid={apiKey}',
				options: {
					maxZoom: 19,
					attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
					apiKey:'<insert your api key here>',
					opacity: 0.5
				},
				variants: {
					Clouds: 'clouds',
					CloudsClassic: 'clouds_cls',
					Precipitation: 'precipitation',
					PrecipitationClassic: 'precipitation_cls',
					Rain: 'rain',
					RainClassic: 'rain_cls',
					Pressure: 'pressure',
					PressureContour: 'pressure_cntr',
					Wind: 'wind',
					Temperature: 'temp',
					Snow: 'snow'
				}
			},
			HERE: {
				/*
				 * HERE maps, formerly Nokia maps.
				 * These basemaps are free, but you need an API key. Please sign up at
				 * http://developer.here.com/getting-started
				 *
				 * Note that the base urls contain '.cit' whichs is HERE's
				 * 'Customer Integration Testing' environment. Please remove for production
				 * envirionments.
				 */
				url:
					'https://{s}.{base}.maps.cit.api.here.com/maptile/2.1/' +
					'{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?' +
					'app_id={app_id}&app_code={app_code}&lg={language}',
				options: {
					attribution:
						'Map &copy; 1987-2014 <a href="http://developer.here.com">HERE</a>',
					subdomains: '1234',
					mapID: 'newest',
					'app_id': '<insert your app_id here>',
					'app_code': '<insert your app_code here>',
					base: 'base',
					variant: 'normal.day',
					maxZoom: 20,
					type: 'maptile',
					language: 'eng',
					format: 'png8',
					size: '256'
				},
				variants: {
					normalDay: 'normal.day',
					normalDayCustom: 'normal.day.custom',
					normalDayGrey: 'normal.day.grey',
					normalDayMobile: 'normal.day.mobile',
					normalDayGreyMobile: 'normal.day.grey.mobile',
					normalDayTransit: 'normal.day.transit',
					normalDayTransitMobile: 'normal.day.transit.mobile',
					normalNight: 'normal.night',
					normalNightMobile: 'normal.night.mobile',
					normalNightGrey: 'normal.night.grey',
					normalNightGreyMobile: 'normal.night.grey.mobile',
					normalNightTransit: 'normal.night.transit',
					normalNightTransitMobile: 'normal.night.transit.mobile',
					redcuedDay: 'reduced.day',
					redcuedNight: 'reduced.night',
					basicMap: {
						options: {
							type: 'basetile'
						}
					},
					mapLabels: {
						options: {
							type: 'labeltile',
							format: 'png'
						}
					},
					trafficFlow: {
						options: {
							base: 'traffic',
							type: 'flowtile'
						}
					},
					carnavDayGrey: 'carnav.day.grey',
					hybridDay: {
						options: {
							base: 'aerial',
							variant: 'hybrid.day'
						}
					},
					hybridDayMobile: {
						options: {
							base: 'aerial',
							variant: 'hybrid.day.mobile'
						}
					},
					hybridDayTransit: {
						options: {
							base: 'aerial',
							variant: 'hybrid.day.transit'
						}
					},
					hybridDayGrey: {
						options: {
							base: 'aerial',
							variant: 'hybrid.grey.day'
						}
					},
					pedestrianDay: 'pedestrian.day',
					pedestrianNight: 'pedestrian.night',
					satelliteDay: {
						options: {
							base: 'aerial',
							variant: 'satellite.day'
						}
					},
					terrainDay: {
						options: {
							base: 'aerial',
							variant: 'terrain.day'
						}
					},
					terrainDayMobile: {
						options: {
							base: 'aerial',
							variant: 'terrain.day.mobile'
						}
					}
				}
			},
			FreeMapSK: {
				url: 'http://t{s}.freemap.sk/T/{z}/{x}/{y}.jpeg',
				options: {
					minZoom: 8,
					maxZoom: 16,
					subdomains: '1234',
					bounds: [[47.204642, 15.996093], [49.830896, 22.576904]],
					attribution:
						'{attribution.OpenStreetMap}, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>'
				}
			},
			MtbMap: {
				url: 'http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png',
				options: {
					attribution:
						'{attribution.OpenStreetMap} &amp; USGS'
				}
			},
			CartoDB: {
				url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/{variant}/{z}/{x}/{y}{r}.png',
				options: {
					attribution: '{attribution.OpenStreetMap} &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
					subdomains: 'abcd',
					maxZoom: 19,
					variant: 'light_all'
				},
				variants: {
					Positron: 'light_all',
					PositronNoLabels: 'light_nolabels',
					PositronOnlyLabels: 'light_only_labels',
					DarkMatter: 'dark_all',
					DarkMatterNoLabels: 'dark_nolabels',
					DarkMatterOnlyLabels: 'dark_only_labels',
					Voyager: 'rastertiles/voyager',
					VoyagerNoLabels: 'rastertiles/voyager_nolabels',
					VoyagerOnlyLabels: 'rastertiles/voyager_only_labels',
					VoyagerLabelsUnder: 'rastertiles/voyager_labels_under'
				}
			},
			HikeBike: {
				url: 'http://{s}.tiles.wmflabs.org/{variant}/{z}/{x}/{y}.png',
				options: {
					maxZoom: 19,
					attribution: '{attribution.OpenStreetMap}',
					variant: 'hikebike'
				},
				variants: {
					HikeBike: {},
					HillShading: {
						options: {
							maxZoom: 15,
							variant: 'hillshading'
						}
					}
				}
			},
			BasemapAT: {
				url: 'https://maps{s}.wien.gv.at/basemap/{variant}/normal/google3857/{z}/{y}/{x}.{format}',
				options: {
					maxZoom: 19,
					attribution: 'Datenquelle: <a href="https://www.basemap.at">basemap.at</a>',
					subdomains: ['', '1', '2', '3', '4'],
					format: 'png',
					bounds: [[46.358770, 8.782379], [49.037872, 17.189532]],
					variant: 'geolandbasemap'
				},
				variants: {
					basemap: {
						options: {
							maxZoom: 20, // currently only in Vienna
							variant: 'geolandbasemap'
						}
					},
					grau: 'bmapgrau',
					overlay: 'bmapoverlay',
					highdpi: {
						options: {
							variant: 'bmaphidpi',
							format: 'jpeg'
						}
					},
					orthofoto: {
						options: {
							maxZoom: 20, // currently only in Vienna
							variant: 'bmaporthofoto30cm',
							format: 'jpeg'
						}
					}
				}
			},
			nlmaps: {
				url: 'https://geodata.nationaalgeoregister.nl/tiles/service/wmts/{variant}/EPSG:3857/{z}/{x}/{y}.png',
				options: {
					minZoom: 6,
					maxZoom: 19,
					bounds: [[50.5, 3.25], [54, 7.6]],
					attribution: 'Kaartgegevens &copy; <a href="kadaster.nl">Kadaster</a>'
				},
				variants: {
					'standaard': 'brtachtergrondkaart',
					'pastel': 'brtachtergrondkaartpastel',
					'grijs': 'brtachtergrondkaartgrijs',
					'luchtfoto': {
						'url': 'https://geodata.nationaalgeoregister.nl/luchtfoto/rgb/wmts/1.0.0/2016_ortho25/EPSG:3857/{z}/{x}/{y}.png',
					}
				}
			},
			NASAGIBS: {
				url: 'https://map1.vis.earthdata.nasa.gov/wmts-webmerc/{variant}/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}',
				options: {
					attribution:
						'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System ' +
						'(<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
					bounds: [[-85.0511287776, -179.999999975], [85.0511287776, 179.999999975]],
					minZoom: 1,
					maxZoom: 9,
					format: 'jpg',
					time: '',
					tilematrixset: 'GoogleMapsCompatible_Level'
				},
				variants: {
					ModisTerraTrueColorCR: 'MODIS_Terra_CorrectedReflectance_TrueColor',
					ModisTerraBands367CR: 'MODIS_Terra_CorrectedReflectance_Bands367',
					ViirsEarthAtNight2012: {
						options: {
							variant: 'VIIRS_CityLights_2012',
							maxZoom: 8
						}
					},
					ModisTerraLSTDay: {
						options: {
							variant: 'MODIS_Terra_Land_Surface_Temp_Day',
							format: 'png',
							maxZoom: 7,
							opacity: 0.75
						}
					},
					ModisTerraSnowCover: {
						options: {
							variant: 'MODIS_Terra_Snow_Cover',
							format: 'png',
							maxZoom: 8,
							opacity: 0.75
						}
					},
					ModisTerraAOD: {
						options: {
							variant: 'MODIS_Terra_Aerosol',
							format: 'png',
							maxZoom: 6,
							opacity: 0.75
						}
					},
					ModisTerraChlorophyll: {
						options: {
							variant: 'MODIS_Terra_Chlorophyll_A',
							format: 'png',
							maxZoom: 7,
							opacity: 0.75
						}
					}
				}
			},
			NLS: {
				// NLS maps are copyright National library of Scotland.
				// http://maps.nls.uk/projects/api/index.html
				// Please contact NLS for anything other than non-commercial low volume usage
				//
				// Map sources: Ordnance Survey 1:1m to 1:63K, 1920s-1940s
				//   z0-9  - 1:1m
				//  z10-11 - quarter inch (1:253440)
				//  z12-18 - one inch (1:63360)
				url: 'https://nls-{s}.tileserver.com/nls/{z}/{x}/{y}.jpg',
				options: {
					attribution: '<a href="http://geo.nls.uk/maps/">National Library of Scotland Historic Maps</a>',
					bounds: [[49.6, -12], [61.7, 3]],
					minZoom: 1,
					maxZoom: 18,
					subdomains: '0123',
				}
			},
			JusticeMap: {
				// Justice Map (http://www.justicemap.org/)
				// Visualize race and income data for your community, county and country.
				// Includes tools for data journalists, bloggers and community activists.
				url: 'http://www.justicemap.org/tile/{size}/{variant}/{z}/{x}/{y}.png',
				options: {
					attribution: '<a href="http://www.justicemap.org/terms.php">Justice Map</a>',
					// one of 'county', 'tract', 'block'
					size: 'county',
					// Bounds for USA, including Alaska and Hawaii
					bounds: [[14, -180], [72, -56]]
				},
				variants: {
					income: 'income',
					americanIndian: 'indian',
					asian: 'asian',
					black: 'black',
					hispanic: 'hispanic',
					multi: 'multi',
					nonWhite: 'nonwhite',
					white: 'white',
					plurality: 'plural'
				}
			},
			Wikimedia: {
				url: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png',
				options: {
					attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
					minZoom: 1,
					maxZoom: 19
				}
			},
			GeoportailFrance: {
				url: 'https://wxs.ign.fr/{apikey}/geoportail/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE={style}&TILEMATRIXSET=PM&FORMAT={format}&LAYER={variant}&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}',
				options: {
					attribution: '<a target="_blank" href="https://www.geoportail.gouv.fr/">Geoportail France</a>',
					bounds: [[-75, -180], [81, 180]],
					minZoom: 2,
					maxZoom: 18,
					// Get your own geoportail apikey here : http://professionnels.ign.fr/ign/contrats/
					// NB : 'choisirgeoportail' is a demonstration key that comes with no guarantee
					apikey: 'choisirgeoportail',
					format: 'image/jpeg',
					style : 'normal',
					variant: 'GEOGRAPHICALGRIDSYSTEMS.MAPS.SCAN-EXPRESS.STANDARD'
				},
				variants: {
					parcels: {
						options : {
							variant: 'CADASTRALPARCELS.PARCELS',
							maxZoom: 20,
							style : 'bdparcellaire',
							format: 'image/png'
						}
					},
					ignMaps: 'GEOGRAPHICALGRIDSYSTEMS.MAPS',
					maps: 'GEOGRAPHICALGRIDSYSTEMS.MAPS.SCAN-EXPRESS.STANDARD',
					orthos: {
						options: {
							maxZoom: 19,
							variant: 'ORTHOIMAGERY.ORTHOPHOTOS'
						}
					}
				}
			},
			OneMapSG: {
				url: 'https://maps-{s}.onemap.sg/v3/{variant}/{z}/{x}/{y}.png',
				options: {
					variant: 'Default',
					minZoom: 11,
					maxZoom: 18,
					bounds: [[1.56073, 104.11475], [1.16, 103.502]],
					attribution: 'New OneMap | Map data &copy; contributors, <a href="http://SLA.gov.sg">Singapore Land Authority</a>'
				},
				variants: {
					Default: 'Default',
					Night: 'Night',
					Original: 'Original',
					Grey: 'Grey',
					LandLot: 'LandLot'
				}
			}
		};
	
		L.tileLayer.provider = function (provider, options) {
			return new L.TileLayer.Provider(provider, options);
		};
	
		return L;
	}));


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(47)(module)))

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(47)(module)))

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(72),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(949),
	    hashDelete = __webpack_require__(950),
	    hashGet = __webpack_require__(951),
	    hashHas = __webpack_require__(952),
	    hashSet = __webpack_require__(953);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(72),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(72),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(199),
	    setCacheAdd = __webpack_require__(974),
	    setCacheHas = __webpack_require__(975);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(72),
	    root = __webpack_require__(44);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 901 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 902 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 903 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(133),
	    keys = __webpack_require__(107);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(133),
	    keysIn = __webpack_require__(344);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(200),
	    arrayEach = __webpack_require__(901),
	    assignValue = __webpack_require__(324),
	    baseAssign = __webpack_require__(904),
	    baseAssignIn = __webpack_require__(905),
	    cloneBuffer = __webpack_require__(930),
	    copyArray = __webpack_require__(935),
	    copySymbols = __webpack_require__(936),
	    copySymbolsIn = __webpack_require__(937),
	    getAllKeys = __webpack_require__(333),
	    getAllKeysIn = __webpack_require__(944),
	    getTag = __webpack_require__(135),
	    initCloneArray = __webpack_require__(954),
	    initCloneByTag = __webpack_require__(955),
	    initCloneObject = __webpack_require__(956),
	    isArray = __webpack_require__(39),
	    isBuffer = __webpack_require__(210),
	    isMap = __webpack_require__(986),
	    isObject = __webpack_require__(86),
	    isSet = __webpack_require__(988),
	    keys = __webpack_require__(107);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(86);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(326),
	    createBaseEach = __webpack_require__(939);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(940);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(200),
	    equalArrays = __webpack_require__(331),
	    equalByTag = __webpack_require__(942),
	    equalObjects = __webpack_require__(943),
	    getTag = __webpack_require__(135),
	    isArray = __webpack_require__(39),
	    isBuffer = __webpack_require__(210),
	    isTypedArray = __webpack_require__(343);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(135),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(200),
	    baseIsEqual = __webpack_require__(329);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(342),
	    isMasked = __webpack_require__(958),
	    isObject = __webpack_require__(86),
	    toSource = __webpack_require__(339);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(135),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    isLength = __webpack_require__(211),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(922),
	    baseMatchesProperty = __webpack_require__(923),
	    identity = __webpack_require__(340),
	    isArray = __webpack_require__(39),
	    property = __webpack_require__(992);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(206),
	    nativeKeys = __webpack_require__(971);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(86),
	    isPrototype = __webpack_require__(206),
	    nativeKeysIn = __webpack_require__(972);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(908),
	    isArrayLike = __webpack_require__(138);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(914),
	    getMatchData = __webpack_require__(945),
	    matchesStrictComparable = __webpack_require__(337);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(329),
	    get = __webpack_require__(984),
	    hasIn = __webpack_require__(985),
	    isKey = __webpack_require__(205),
	    isStrictComparable = __webpack_require__(336),
	    matchesStrictComparable = __webpack_require__(337),
	    toKey = __webpack_require__(137);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 924 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(327);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 926 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(106),
	    arrayMap = __webpack_require__(322),
	    isArray = __webpack_require__(39),
	    isSymbol = __webpack_require__(212);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(340);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(44);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module)))

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(202);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 932 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(106);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(202);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 935 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(133),
	    getSymbols = __webpack_require__(204);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(133),
	    getSymbolsIn = __webpack_require__(334);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(44);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(138);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 940 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(72);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(106),
	    Uint8Array = __webpack_require__(320),
	    eq = __webpack_require__(208),
	    equalArrays = __webpack_require__(331),
	    mapToArray = __webpack_require__(969),
	    setToArray = __webpack_require__(976);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(333);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(328),
	    getSymbolsIn = __webpack_require__(334),
	    keysIn = __webpack_require__(344);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(336),
	    keys = __webpack_require__(107);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(106);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 947 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(330),
	    isArguments = __webpack_require__(341),
	    isArray = __webpack_require__(39),
	    isIndex = __webpack_require__(335),
	    isLength = __webpack_require__(211),
	    toKey = __webpack_require__(137);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(136);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(136);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(136);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(136);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 954 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(202),
	    cloneDataView = __webpack_require__(931),
	    cloneRegExp = __webpack_require__(932),
	    cloneSymbol = __webpack_require__(933),
	    cloneTypedArray = __webpack_require__(934);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(907),
	    getPrototype = __webpack_require__(203),
	    isPrototype = __webpack_require__(206);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 957 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(938);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 959 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(132);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(132);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(132);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(132);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(896),
	    ListCache = __webpack_require__(131),
	    Map = __webpack_require__(198);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(134);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(134);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(134);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(134);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 969 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(991);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(338);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 972 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 973 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 974 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 975 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 976 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(131);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 978 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 979 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 980 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(131),
	    Map = __webpack_require__(198),
	    MapCache = __webpack_require__(199);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(970);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(906);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(327);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(910),
	    hasPath = __webpack_require__(948);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(913),
	    baseUnary = __webpack_require__(201),
	    nodeUtil = __webpack_require__(207);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    getPrototype = __webpack_require__(203),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(916),
	    baseUnary = __webpack_require__(201),
	    nodeUtil = __webpack_require__(207);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    isArray = __webpack_require__(39),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(322),
	    baseIteratee = __webpack_require__(918),
	    baseMap = __webpack_require__(921),
	    isArray = __webpack_require__(39);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(199);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(924),
	    basePropertyDeep = __webpack_require__(925),
	    isKey = __webpack_require__(205),
	    toKey = __webpack_require__(137);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 993 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(927);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _cc = [
	  {cardinal:["other"],ordinal:["other"]},
	  {cardinal:["one","other"],ordinal:["other"]},
	  {cardinal:["one","other"],ordinal:["one","other"]},
	  {cardinal:["one","two","other"],ordinal:["other"]}
	];
	
	(function (root, pluralCategories) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (pluralCategories), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = pluralCategories;
	  } else {
	    root.pluralCategories = pluralCategories;
	  }
	}(this, {
	af: _cc[1],
	ak: _cc[1],
	am: _cc[1],
	ar: {cardinal:["zero","one","two","few","many","other"],ordinal:["other"]},
	as: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
	asa: _cc[1],
	ast: _cc[1],
	az: {cardinal:["one","other"],ordinal:["one","few","many","other"]},
	be: {cardinal:["one","few","many","other"],ordinal:["few","other"]},
	bem: _cc[1],
	bez: _cc[1],
	bg: _cc[1],
	bh: _cc[1],
	bm: _cc[0],
	bn: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
	bo: _cc[0],
	br: {cardinal:["one","two","few","many","other"],ordinal:["other"]},
	brx: _cc[1],
	bs: {cardinal:["one","few","other"],ordinal:["other"]},
	ca: {cardinal:["one","other"],ordinal:["one","two","few","other"]},
	ce: _cc[1],
	cgg: _cc[1],
	chr: _cc[1],
	ckb: _cc[1],
	cs: {cardinal:["one","few","many","other"],ordinal:["other"]},
	cy: {cardinal:["zero","one","two","few","many","other"],ordinal:["zero","one","two","few","many","other"]},
	da: _cc[1],
	de: _cc[1],
	dsb: {cardinal:["one","two","few","other"],ordinal:["other"]},
	dv: _cc[1],
	dz: _cc[0],
	ee: _cc[1],
	el: _cc[1],
	en: {cardinal:["one","other"],ordinal:["one","two","few","other"]},
	eo: _cc[1],
	es: _cc[1],
	et: _cc[1],
	eu: _cc[1],
	fa: _cc[1],
	ff: _cc[1],
	fi: _cc[1],
	fil: _cc[2],
	fo: _cc[1],
	fr: _cc[2],
	fur: _cc[1],
	fy: _cc[1],
	ga: {cardinal:["one","two","few","many","other"],ordinal:["one","other"]},
	gd: {cardinal:["one","two","few","other"],ordinal:["other"]},
	gl: _cc[1],
	gsw: _cc[1],
	gu: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
	guw: _cc[1],
	gv: {cardinal:["one","two","few","many","other"],ordinal:["other"]},
	ha: _cc[1],
	haw: _cc[1],
	he: {cardinal:["one","two","many","other"],ordinal:["other"]},
	hi: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
	hr: {cardinal:["one","few","other"],ordinal:["other"]},
	hsb: {cardinal:["one","two","few","other"],ordinal:["other"]},
	hu: _cc[2],
	hy: _cc[2],
	id: _cc[0],
	ig: _cc[0],
	ii: _cc[0],
	"in": _cc[0],
	is: _cc[1],
	it: {cardinal:["one","other"],ordinal:["many","other"]},
	iu: _cc[3],
	iw: {cardinal:["one","two","many","other"],ordinal:["other"]},
	ja: _cc[0],
	jbo: _cc[0],
	jgo: _cc[1],
	ji: _cc[1],
	jmc: _cc[1],
	jv: _cc[0],
	jw: _cc[0],
	ka: {cardinal:["one","other"],ordinal:["one","many","other"]},
	kab: _cc[1],
	kaj: _cc[1],
	kcg: _cc[1],
	kde: _cc[0],
	kea: _cc[0],
	kk: {cardinal:["one","other"],ordinal:["many","other"]},
	kkj: _cc[1],
	kl: _cc[1],
	km: _cc[0],
	kn: _cc[1],
	ko: _cc[0],
	ks: _cc[1],
	ksb: _cc[1],
	ksh: {cardinal:["zero","one","other"],ordinal:["other"]},
	ku: _cc[1],
	kw: _cc[3],
	ky: _cc[1],
	lag: {cardinal:["zero","one","other"],ordinal:["other"]},
	lb: _cc[1],
	lg: _cc[1],
	lkt: _cc[0],
	ln: _cc[1],
	lo: {cardinal:["other"],ordinal:["one","other"]},
	lt: {cardinal:["one","few","many","other"],ordinal:["other"]},
	lv: {cardinal:["zero","one","other"],ordinal:["other"]},
	mas: _cc[1],
	mg: _cc[1],
	mgo: _cc[1],
	mk: {cardinal:["one","other"],ordinal:["one","two","many","other"]},
	ml: _cc[1],
	mn: _cc[1],
	mo: {cardinal:["one","few","other"],ordinal:["one","other"]},
	mr: {cardinal:["one","other"],ordinal:["one","two","few","other"]},
	ms: {cardinal:["other"],ordinal:["one","other"]},
	mt: {cardinal:["one","few","many","other"],ordinal:["other"]},
	my: _cc[0],
	nah: _cc[1],
	naq: _cc[3],
	nb: _cc[1],
	nd: _cc[1],
	ne: _cc[2],
	nl: _cc[1],
	nn: _cc[1],
	nnh: _cc[1],
	no: _cc[1],
	nqo: _cc[0],
	nr: _cc[1],
	nso: _cc[1],
	ny: _cc[1],
	nyn: _cc[1],
	om: _cc[1],
	or: _cc[1],
	os: _cc[1],
	pa: _cc[1],
	pap: _cc[1],
	pl: {cardinal:["one","few","many","other"],ordinal:["other"]},
	prg: {cardinal:["zero","one","other"],ordinal:["other"]},
	ps: _cc[1],
	pt: _cc[1],
	"pt-PT": _cc[1],
	rm: _cc[1],
	ro: {cardinal:["one","few","other"],ordinal:["one","other"]},
	rof: _cc[1],
	root: _cc[0],
	ru: {cardinal:["one","few","many","other"],ordinal:["other"]},
	rwk: _cc[1],
	sah: _cc[0],
	saq: _cc[1],
	sdh: _cc[1],
	se: _cc[3],
	seh: _cc[1],
	ses: _cc[0],
	sg: _cc[0],
	sh: {cardinal:["one","few","other"],ordinal:["other"]},
	shi: {cardinal:["one","few","other"],ordinal:["other"]},
	si: _cc[1],
	sk: {cardinal:["one","few","many","other"],ordinal:["other"]},
	sl: {cardinal:["one","two","few","other"],ordinal:["other"]},
	sma: _cc[3],
	smi: _cc[3],
	smj: _cc[3],
	smn: _cc[3],
	sms: _cc[3],
	sn: _cc[1],
	so: _cc[1],
	sq: {cardinal:["one","other"],ordinal:["one","many","other"]},
	sr: {cardinal:["one","few","other"],ordinal:["other"]},
	ss: _cc[1],
	ssy: _cc[1],
	st: _cc[1],
	sv: _cc[2],
	sw: _cc[1],
	syr: _cc[1],
	ta: _cc[1],
	te: _cc[1],
	teo: _cc[1],
	th: _cc[0],
	ti: _cc[1],
	tig: _cc[1],
	tk: _cc[1],
	tl: _cc[2],
	tn: _cc[1],
	to: _cc[0],
	tr: _cc[1],
	ts: _cc[1],
	tzm: _cc[1],
	ug: _cc[1],
	uk: {cardinal:["one","few","many","other"],ordinal:["few","other"]},
	ur: _cc[1],
	uz: _cc[1],
	ve: _cc[1],
	vi: {cardinal:["other"],ordinal:["one","other"]},
	vo: _cc[1],
	vun: _cc[1],
	wa: _cc[1],
	wae: _cc[1],
	wo: _cc[0],
	xh: _cc[1],
	xog: _cc[1],
	yi: _cc[1],
	yo: _cc[0],
	zh: _cc[0],
	zu: _cc[1]
	}));


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _cp = [
	function(n, ord) {
	  if (ord) return 'other';
	  return 'other';
	},
	function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one' : 'other';
	},
	function(n, ord) {
	  if (ord) return 'other';
	  return ((n == 0
	          || n == 1)) ? 'one' : 'other';
	},
	function(n, ord) {
	  var s = String(n).split('.'), v0 = !s[1];
	  if (ord) return 'other';
	  return (n == 1 && v0) ? 'one' : 'other';
	}
	];
	
	(function (root, plurals) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (plurals), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = plurals;
	  } else {
	    root.plurals = plurals;
	  }
	}(this, {
	af: _cp[1],
	
	ak: _cp[2],
	
	am: function(n, ord) {
	  if (ord) return 'other';
	  return (n >= 0 && n <= 1) ? 'one' : 'other';
	},
	
	ar: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n,
	      n100 = t0 && s[0].slice(-2);
	  if (ord) return 'other';
	  return (n == 0) ? 'zero'
	      : (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : ((n100 >= 3 && n100 <= 10)) ? 'few'
	      : ((n100 >= 11 && n100 <= 99)) ? 'many'
	      : 'other';
	},
	
	as: function(n, ord) {
	  if (ord) return ((n == 1 || n == 5 || n == 7 || n == 8 || n == 9
	          || n == 10)) ? 'one'
	      : ((n == 2
	          || n == 3)) ? 'two'
	      : (n == 4) ? 'few'
	      : (n == 6) ? 'many'
	      : 'other';
	  return (n >= 0 && n <= 1) ? 'one' : 'other';
	},
	
	asa: _cp[1],
	
	ast: _cp[3],
	
	az: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], i10 = i.slice(-1),
	      i100 = i.slice(-2), i1000 = i.slice(-3);
	  if (ord) return ((i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8)
	          || (i100 == 20 || i100 == 50 || i100 == 70
	          || i100 == 80)) ? 'one'
	      : ((i10 == 3 || i10 == 4) || (i1000 == 100 || i1000 == 200
	          || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700
	          || i1000 == 800
	          || i1000 == 900)) ? 'few'
	      : (i == 0 || i10 == 6 || (i100 == 40 || i100 == 60
	          || i100 == 90)) ? 'many'
	      : 'other';
	  return (n == 1) ? 'one' : 'other';
	},
	
	be: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
	  if (ord) return ((n10 == 2
	          || n10 == 3) && n100 != 12 && n100 != 13) ? 'few' : 'other';
	  return (n10 == 1 && n100 != 11) ? 'one'
	      : ((n10 >= 2 && n10 <= 4) && (n100 < 12
	          || n100 > 14)) ? 'few'
	      : (t0 && n10 == 0 || (n10 >= 5 && n10 <= 9)
	          || (n100 >= 11 && n100 <= 14)) ? 'many'
	      : 'other';
	},
	
	bem: _cp[1],
	
	bez: _cp[1],
	
	bg: _cp[1],
	
	bh: _cp[2],
	
	bm: _cp[0],
	
	bn: function(n, ord) {
	  if (ord) return ((n == 1 || n == 5 || n == 7 || n == 8 || n == 9
	          || n == 10)) ? 'one'
	      : ((n == 2
	          || n == 3)) ? 'two'
	      : (n == 4) ? 'few'
	      : (n == 6) ? 'many'
	      : 'other';
	  return (n >= 0 && n <= 1) ? 'one' : 'other';
	},
	
	bo: _cp[0],
	
	br: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2),
	      n1000000 = t0 && s[0].slice(-6);
	  if (ord) return 'other';
	  return (n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91) ? 'one'
	      : (n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92) ? 'two'
	      : (((n10 == 3 || n10 == 4) || n10 == 9) && (n100 < 10
	          || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90
	          || n100 > 99)) ? 'few'
	      : (n != 0 && t0 && n1000000 == 0) ? 'many'
	      : 'other';
	},
	
	brx: _cp[1],
	
	bs: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
	      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
	  if (ord) return 'other';
	  return (v0 && i10 == 1 && i100 != 11
	          || f10 == 1 && f100 != 11) ? 'one'
	      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
	          || (f10 >= 2 && f10 <= 4) && (f100 < 12
	          || f100 > 14)) ? 'few'
	      : 'other';
	},
	
	ca: function(n, ord) {
	  var s = String(n).split('.'), v0 = !s[1];
	  if (ord) return ((n == 1
	          || n == 3)) ? 'one'
	      : (n == 2) ? 'two'
	      : (n == 4) ? 'few'
	      : 'other';
	  return (n == 1 && v0) ? 'one' : 'other';
	},
	
	ce: _cp[1],
	
	cgg: _cp[1],
	
	chr: _cp[1],
	
	ckb: _cp[1],
	
	cs: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], v0 = !s[1];
	  if (ord) return 'other';
	  return (n == 1 && v0) ? 'one'
	      : ((i >= 2 && i <= 4) && v0) ? 'few'
	      : (!v0) ? 'many'
	      : 'other';
	},
	
	cy: function(n, ord) {
	  if (ord) return ((n == 0 || n == 7 || n == 8
	          || n == 9)) ? 'zero'
	      : (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : ((n == 3
	          || n == 4)) ? 'few'
	      : ((n == 5
	          || n == 6)) ? 'many'
	      : 'other';
	  return (n == 0) ? 'zero'
	      : (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : (n == 3) ? 'few'
	      : (n == 6) ? 'many'
	      : 'other';
	},
	
	da: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
	  if (ord) return 'other';
	  return (n == 1 || !t0 && (i == 0
	          || i == 1)) ? 'one' : 'other';
	},
	
	de: _cp[3],
	
	dsb: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
	      i100 = i.slice(-2), f100 = f.slice(-2);
	  if (ord) return 'other';
	  return (v0 && i100 == 1
	          || f100 == 1) ? 'one'
	      : (v0 && i100 == 2
	          || f100 == 2) ? 'two'
	      : (v0 && (i100 == 3 || i100 == 4) || (f100 == 3
	          || f100 == 4)) ? 'few'
	      : 'other';
	},
	
	dv: _cp[1],
	
	dz: _cp[0],
	
	ee: _cp[1],
	
	el: _cp[1],
	
	en: function(n, ord) {
	  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
	  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
	      : (n10 == 2 && n100 != 12) ? 'two'
	      : (n10 == 3 && n100 != 13) ? 'few'
	      : 'other';
	  return (n == 1 && v0) ? 'one' : 'other';
	},
	
	eo: _cp[1],
	
	es: _cp[1],
	
	et: _cp[3],
	
	eu: _cp[1],
	
	fa: function(n, ord) {
	  if (ord) return 'other';
	  return (n >= 0 && n <= 1) ? 'one' : 'other';
	},
	
	ff: function(n, ord) {
	  if (ord) return 'other';
	  return (n >= 0 && n < 2) ? 'one' : 'other';
	},
	
	fi: _cp[3],
	
	fil: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
	      i10 = i.slice(-1), f10 = f.slice(-1);
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return (v0 && (i == 1 || i == 2 || i == 3)
	          || v0 && i10 != 4 && i10 != 6 && i10 != 9
	          || !v0 && f10 != 4 && f10 != 6 && f10 != 9) ? 'one' : 'other';
	},
	
	fo: _cp[1],
	
	fr: function(n, ord) {
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return (n >= 0 && n < 2) ? 'one' : 'other';
	},
	
	fur: _cp[1],
	
	fy: _cp[3],
	
	ga: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n;
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : ((t0 && n >= 3 && n <= 6)) ? 'few'
	      : ((t0 && n >= 7 && n <= 10)) ? 'many'
	      : 'other';
	},
	
	gd: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n;
	  if (ord) return 'other';
	  return ((n == 1
	          || n == 11)) ? 'one'
	      : ((n == 2
	          || n == 12)) ? 'two'
	      : (((t0 && n >= 3 && n <= 10)
	          || (t0 && n >= 13 && n <= 19))) ? 'few'
	      : 'other';
	},
	
	gl: _cp[3],
	
	gsw: _cp[1],
	
	gu: function(n, ord) {
	  if (ord) return (n == 1) ? 'one'
	      : ((n == 2
	          || n == 3)) ? 'two'
	      : (n == 4) ? 'few'
	      : (n == 6) ? 'many'
	      : 'other';
	  return (n >= 0 && n <= 1) ? 'one' : 'other';
	},
	
	guw: _cp[2],
	
	gv: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
	      i100 = i.slice(-2);
	  if (ord) return 'other';
	  return (v0 && i10 == 1) ? 'one'
	      : (v0 && i10 == 2) ? 'two'
	      : (v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60
	          || i100 == 80)) ? 'few'
	      : (!v0) ? 'many'
	      : 'other';
	},
	
	ha: _cp[1],
	
	haw: _cp[1],
	
	he: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1);
	  if (ord) return 'other';
	  return (n == 1 && v0) ? 'one'
	      : (i == 2 && v0) ? 'two'
	      : (v0 && (n < 0
	          || n > 10) && t0 && n10 == 0) ? 'many'
	      : 'other';
	},
	
	hi: function(n, ord) {
	  if (ord) return (n == 1) ? 'one'
	      : ((n == 2
	          || n == 3)) ? 'two'
	      : (n == 4) ? 'few'
	      : (n == 6) ? 'many'
	      : 'other';
	  return (n >= 0 && n <= 1) ? 'one' : 'other';
	},
	
	hr: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
	      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
	  if (ord) return 'other';
	  return (v0 && i10 == 1 && i100 != 11
	          || f10 == 1 && f100 != 11) ? 'one'
	      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
	          || (f10 >= 2 && f10 <= 4) && (f100 < 12
	          || f100 > 14)) ? 'few'
	      : 'other';
	},
	
	hsb: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
	      i100 = i.slice(-2), f100 = f.slice(-2);
	  if (ord) return 'other';
	  return (v0 && i100 == 1
	          || f100 == 1) ? 'one'
	      : (v0 && i100 == 2
	          || f100 == 2) ? 'two'
	      : (v0 && (i100 == 3 || i100 == 4) || (f100 == 3
	          || f100 == 4)) ? 'few'
	      : 'other';
	},
	
	hu: function(n, ord) {
	  if (ord) return ((n == 1
	          || n == 5)) ? 'one' : 'other';
	  return (n == 1) ? 'one' : 'other';
	},
	
	hy: function(n, ord) {
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return (n >= 0 && n < 2) ? 'one' : 'other';
	},
	
	id: _cp[0],
	
	ig: _cp[0],
	
	ii: _cp[0],
	
	"in": _cp[0],
	
	is: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n,
	      i10 = i.slice(-1), i100 = i.slice(-2);
	  if (ord) return 'other';
	  return (t0 && i10 == 1 && i100 != 11
	          || !t0) ? 'one' : 'other';
	},
	
	it: function(n, ord) {
	  var s = String(n).split('.'), v0 = !s[1];
	  if (ord) return ((n == 11 || n == 8 || n == 80
	          || n == 800)) ? 'many' : 'other';
	  return (n == 1 && v0) ? 'one' : 'other';
	},
	
	iu: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : 'other';
	},
	
	iw: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1);
	  if (ord) return 'other';
	  return (n == 1 && v0) ? 'one'
	      : (i == 2 && v0) ? 'two'
	      : (v0 && (n < 0
	          || n > 10) && t0 && n10 == 0) ? 'many'
	      : 'other';
	},
	
	ja: _cp[0],
	
	jbo: _cp[0],
	
	jgo: _cp[1],
	
	ji: _cp[3],
	
	jmc: _cp[1],
	
	jv: _cp[0],
	
	jw: _cp[0],
	
	ka: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], i100 = i.slice(-2);
	  if (ord) return (i == 1) ? 'one'
	      : (i == 0 || ((i100 >= 2 && i100 <= 20) || i100 == 40 || i100 == 60
	          || i100 == 80)) ? 'many'
	      : 'other';
	  return (n == 1) ? 'one' : 'other';
	},
	
	kab: function(n, ord) {
	  if (ord) return 'other';
	  return (n >= 0 && n < 2) ? 'one' : 'other';
	},
	
	kaj: _cp[1],
	
	kcg: _cp[1],
	
	kde: _cp[0],
	
	kea: _cp[0],
	
	kk: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1);
	  if (ord) return (n10 == 6 || n10 == 9
	          || t0 && n10 == 0 && n != 0) ? 'many' : 'other';
	  return (n == 1) ? 'one' : 'other';
	},
	
	kkj: _cp[1],
	
	kl: _cp[1],
	
	km: _cp[0],
	
	kn: function(n, ord) {
	  if (ord) return 'other';
	  return (n >= 0 && n <= 1) ? 'one' : 'other';
	},
	
	ko: _cp[0],
	
	ks: _cp[1],
	
	ksb: _cp[1],
	
	ksh: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 0) ? 'zero'
	      : (n == 1) ? 'one'
	      : 'other';
	},
	
	ku: _cp[1],
	
	kw: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : 'other';
	},
	
	ky: _cp[1],
	
	lag: function(n, ord) {
	  var s = String(n).split('.'), i = s[0];
	  if (ord) return 'other';
	  return (n == 0) ? 'zero'
	      : ((i == 0
	          || i == 1) && n != 0) ? 'one'
	      : 'other';
	},
	
	lb: _cp[1],
	
	lg: _cp[1],
	
	lkt: _cp[0],
	
	ln: _cp[2],
	
	lo: function(n, ord) {
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return 'other';
	},
	
	lt: function(n, ord) {
	  var s = String(n).split('.'), f = s[1] || '', t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
	  if (ord) return 'other';
	  return (n10 == 1 && (n100 < 11
	          || n100 > 19)) ? 'one'
	      : ((n10 >= 2 && n10 <= 9) && (n100 < 11
	          || n100 > 19)) ? 'few'
	      : (f != 0) ? 'many'
	      : 'other';
	},
	
	lv: function(n, ord) {
	  var s = String(n).split('.'), f = s[1] || '', v = f.length,
	      t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1),
	      n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
	  if (ord) return 'other';
	  return (t0 && n10 == 0 || (n100 >= 11 && n100 <= 19)
	          || v == 2 && (f100 >= 11 && f100 <= 19)) ? 'zero'
	      : (n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11
	          || v != 2 && f10 == 1) ? 'one'
	      : 'other';
	},
	
	mas: _cp[1],
	
	mg: _cp[2],
	
	mgo: _cp[1],
	
	mk: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
	      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1);
	  if (ord) return (i10 == 1 && i100 != 11) ? 'one'
	      : (i10 == 2 && i100 != 12) ? 'two'
	      : ((i10 == 7
	          || i10 == 8) && i100 != 17 && i100 != 18) ? 'many'
	      : 'other';
	  return (v0 && i10 == 1
	          || f10 == 1) ? 'one' : 'other';
	},
	
	ml: _cp[1],
	
	mn: _cp[1],
	
	mo: function(n, ord) {
	  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
	      n100 = t0 && s[0].slice(-2);
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return (n == 1 && v0) ? 'one'
	      : (!v0 || n == 0
	          || n != 1 && (n100 >= 1 && n100 <= 19)) ? 'few'
	      : 'other';
	},
	
	mr: function(n, ord) {
	  if (ord) return (n == 1) ? 'one'
	      : ((n == 2
	          || n == 3)) ? 'two'
	      : (n == 4) ? 'few'
	      : 'other';
	  return (n >= 0 && n <= 1) ? 'one' : 'other';
	},
	
	ms: function(n, ord) {
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return 'other';
	},
	
	mt: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n,
	      n100 = t0 && s[0].slice(-2);
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 0
	          || (n100 >= 2 && n100 <= 10)) ? 'few'
	      : ((n100 >= 11 && n100 <= 19)) ? 'many'
	      : 'other';
	},
	
	my: _cp[0],
	
	nah: _cp[1],
	
	naq: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : 'other';
	},
	
	nb: _cp[1],
	
	nd: _cp[1],
	
	ne: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n;
	  if (ord) return ((t0 && n >= 1 && n <= 4)) ? 'one' : 'other';
	  return (n == 1) ? 'one' : 'other';
	},
	
	nl: _cp[3],
	
	nn: _cp[1],
	
	nnh: _cp[1],
	
	no: _cp[1],
	
	nqo: _cp[0],
	
	nr: _cp[1],
	
	nso: _cp[2],
	
	ny: _cp[1],
	
	nyn: _cp[1],
	
	om: _cp[1],
	
	or: _cp[1],
	
	os: _cp[1],
	
	pa: _cp[2],
	
	pap: _cp[1],
	
	pl: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
	      i100 = i.slice(-2);
	  if (ord) return 'other';
	  return (n == 1 && v0) ? 'one'
	      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
	          || i100 > 14)) ? 'few'
	      : (v0 && i != 1 && (i10 == 0 || i10 == 1)
	          || v0 && (i10 >= 5 && i10 <= 9)
	          || v0 && (i100 >= 12 && i100 <= 14)) ? 'many'
	      : 'other';
	},
	
	prg: function(n, ord) {
	  var s = String(n).split('.'), f = s[1] || '', v = f.length,
	      t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1),
	      n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
	  if (ord) return 'other';
	  return (t0 && n10 == 0 || (n100 >= 11 && n100 <= 19)
	          || v == 2 && (f100 >= 11 && f100 <= 19)) ? 'zero'
	      : (n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11
	          || v != 2 && f10 == 1) ? 'one'
	      : 'other';
	},
	
	ps: _cp[1],
	
	pt: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n;
	  if (ord) return 'other';
	  return ((t0 && n >= 0 && n <= 2) && n != 2) ? 'one' : 'other';
	},
	
	"pt-PT": _cp[3],
	
	rm: _cp[1],
	
	ro: function(n, ord) {
	  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
	      n100 = t0 && s[0].slice(-2);
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return (n == 1 && v0) ? 'one'
	      : (!v0 || n == 0
	          || n != 1 && (n100 >= 1 && n100 <= 19)) ? 'few'
	      : 'other';
	},
	
	rof: _cp[1],
	
	root: _cp[0],
	
	ru: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
	      i100 = i.slice(-2);
	  if (ord) return 'other';
	  return (v0 && i10 == 1 && i100 != 11) ? 'one'
	      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
	          || i100 > 14)) ? 'few'
	      : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
	          || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
	      : 'other';
	},
	
	rwk: _cp[1],
	
	sah: _cp[0],
	
	saq: _cp[1],
	
	sdh: _cp[1],
	
	se: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : 'other';
	},
	
	seh: _cp[1],
	
	ses: _cp[0],
	
	sg: _cp[0],
	
	sh: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
	      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
	  if (ord) return 'other';
	  return (v0 && i10 == 1 && i100 != 11
	          || f10 == 1 && f100 != 11) ? 'one'
	      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
	          || (f10 >= 2 && f10 <= 4) && (f100 < 12
	          || f100 > 14)) ? 'few'
	      : 'other';
	},
	
	shi: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n;
	  if (ord) return 'other';
	  return (n >= 0 && n <= 1) ? 'one'
	      : ((t0 && n >= 2 && n <= 10)) ? 'few'
	      : 'other';
	},
	
	si: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '';
	  if (ord) return 'other';
	  return ((n == 0 || n == 1)
	          || i == 0 && f == 1) ? 'one' : 'other';
	},
	
	sk: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], v0 = !s[1];
	  if (ord) return 'other';
	  return (n == 1 && v0) ? 'one'
	      : ((i >= 2 && i <= 4) && v0) ? 'few'
	      : (!v0) ? 'many'
	      : 'other';
	},
	
	sl: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], v0 = !s[1], i100 = i.slice(-2);
	  if (ord) return 'other';
	  return (v0 && i100 == 1) ? 'one'
	      : (v0 && i100 == 2) ? 'two'
	      : (v0 && (i100 == 3 || i100 == 4)
	          || !v0) ? 'few'
	      : 'other';
	},
	
	sma: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : 'other';
	},
	
	smi: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : 'other';
	},
	
	smj: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : 'other';
	},
	
	smn: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : 'other';
	},
	
	sms: function(n, ord) {
	  if (ord) return 'other';
	  return (n == 1) ? 'one'
	      : (n == 2) ? 'two'
	      : 'other';
	},
	
	sn: _cp[1],
	
	so: _cp[1],
	
	sq: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
	  if (ord) return (n == 1) ? 'one'
	      : (n10 == 4 && n100 != 14) ? 'many'
	      : 'other';
	  return (n == 1) ? 'one' : 'other';
	},
	
	sr: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
	      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
	  if (ord) return 'other';
	  return (v0 && i10 == 1 && i100 != 11
	          || f10 == 1 && f100 != 11) ? 'one'
	      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
	          || (f10 >= 2 && f10 <= 4) && (f100 < 12
	          || f100 > 14)) ? 'few'
	      : 'other';
	},
	
	ss: _cp[1],
	
	ssy: _cp[1],
	
	st: _cp[1],
	
	sv: function(n, ord) {
	  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
	  if (ord) return ((n10 == 1
	          || n10 == 2) && n100 != 11 && n100 != 12) ? 'one' : 'other';
	  return (n == 1 && v0) ? 'one' : 'other';
	},
	
	sw: _cp[3],
	
	syr: _cp[1],
	
	ta: _cp[1],
	
	te: _cp[1],
	
	teo: _cp[1],
	
	th: _cp[0],
	
	ti: _cp[2],
	
	tig: _cp[1],
	
	tk: _cp[1],
	
	tl: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
	      i10 = i.slice(-1), f10 = f.slice(-1);
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return (v0 && (i == 1 || i == 2 || i == 3)
	          || v0 && i10 != 4 && i10 != 6 && i10 != 9
	          || !v0 && f10 != 4 && f10 != 6 && f10 != 9) ? 'one' : 'other';
	},
	
	tn: _cp[1],
	
	to: _cp[0],
	
	tr: _cp[1],
	
	ts: _cp[1],
	
	tzm: function(n, ord) {
	  var s = String(n).split('.'), t0 = Number(s[0]) == n;
	  if (ord) return 'other';
	  return ((n == 0 || n == 1)
	          || (t0 && n >= 11 && n <= 99)) ? 'one' : 'other';
	},
	
	ug: _cp[1],
	
	uk: function(n, ord) {
	  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
	      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), i10 = i.slice(-1),
	      i100 = i.slice(-2);
	  if (ord) return (n10 == 3 && n100 != 13) ? 'few' : 'other';
	  return (v0 && i10 == 1 && i100 != 11) ? 'one'
	      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
	          || i100 > 14)) ? 'few'
	      : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
	          || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
	      : 'other';
	},
	
	ur: _cp[3],
	
	uz: _cp[1],
	
	ve: _cp[1],
	
	vi: function(n, ord) {
	  if (ord) return (n == 1) ? 'one' : 'other';
	  return 'other';
	},
	
	vo: _cp[1],
	
	vun: _cp[1],
	
	wa: _cp[2],
	
	wae: _cp[1],
	
	wo: _cp[0],
	
	xh: _cp[1],
	
	xog: _cp[1],
	
	yi: _cp[3],
	
	yo: _cp[0],
	
	zh: _cp[0],
	
	zu: function(n, ord) {
	  if (ord) return 'other';
	  return (n >= 0 && n <= 1) ? 'one' : 'other';
	}
	}));


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var NumberInput_1 = __webpack_require__(346);
	__export(__webpack_require__(346));
	exports.default = NumberInput_1.default;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(166);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getStyles = getStyles;
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(45);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _menu = __webpack_require__(1110);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      appBar = _context$muiTheme.appBar,
	      iconButtonSize = _context$muiTheme.button.iconButtonSize,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var flatButtonSize = 36;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      zIndex: zIndex.appBar,
	      width: '100%',
	      display: 'flex',
	      backgroundColor: appBar.color,
	      paddingLeft: appBar.padding,
	      paddingRight: appBar.padding
	    },
	    title: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      margin: 0,
	      paddingTop: 0,
	      letterSpacing: 0,
	      fontSize: 24,
	      fontWeight: appBar.titleFontWeight,
	      color: appBar.textColor,
	      height: appBar.height,
	      lineHeight: appBar.height + 'px'
	    },
	    mainElement: {
	      boxFlex: 1,
	      flex: '1'
	    },
	    iconButtonStyle: {
	      marginTop: (appBar.height - iconButtonSize) / 2,
	      marginRight: 8,
	      marginLeft: -16
	    },
	    iconButtonIconStyle: {
	      fill: appBar.textColor,
	      color: appBar.textColor
	    },
	    flatButton: {
	      color: appBar.textColor,
	      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
	    }
	  };
	
	  return styles;
	}
	
	var AppBar = function (_Component) {
	  (0, _inherits3.default)(AppBar, _Component);
	
	  function AppBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppBar.__proto__ || (0, _getPrototypeOf2.default)(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapLeftIconButton = function (event) {
	      if (_this.props.onLeftIconButtonTouchTap) {
	        _this.props.onLeftIconButtonTouchTap(event);
	      }
	    }, _this.handleTouchTapRightIconButton = function (event) {
	      if (_this.props.onRightIconButtonTouchTap) {
	        _this.props.onRightIconButtonTouchTap(event);
	      }
	    }, _this.handleTitleTouchTap = function (event) {
	      if (_this.props.onTitleTouchTap) {
	        _this.props.onTitleTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AppBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Material-UI: Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;
	
	       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Material-UI: Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          titleStyle = _props.titleStyle,
	          iconStyleLeft = _props.iconStyleLeft,
	          iconStyleRight = _props.iconStyleRight,
	          onTitleTouchTap = _props.onTitleTouchTap,
	          showMenuIconButton = _props.showMenuIconButton,
	          iconElementLeft = _props.iconElementLeft,
	          iconElementRight = _props.iconElementRight,
	          iconClassNameLeft = _props.iconClassNameLeft,
	          iconClassNameRight = _props.iconClassNameRight,
	          onLeftIconButtonTouchTap = _props.onLeftIconButtonTouchTap,
	          onRightIconButtonTouchTap = _props.onRightIconButtonTouchTap,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleTouchTap', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonTouchTap', 'onRightIconButtonTouchTap', 'className', 'style', 'zDepth', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var menuElementLeft = void 0;
	      var menuElementRight = void 0;
	
	      // If the title is a string, wrap in an h1 tag.
	      // If not, wrap in a div tag.
	      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';
	
	      var titleElement = _react2.default.createElement(titleComponent, {
	        onTouchTap: this.handleTitleTouchTap,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
	      }, title);
	
	      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);
	
	      if (showMenuIconButton) {
	        if (iconElementLeft) {
	          var iconElementLeftProps = {};
	
	          if (iconElementLeft.type.muiName === 'IconButton') {
	            var iconElemLeftChildren = iconElementLeft.props.children;
	            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementLeftProps.iconStyle = (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle);
	          }
	
	          if (!iconElementLeft.props.onTouchTap && this.props.onLeftIconButtonTouchTap) {
	            iconElementLeftProps.onTouchTap = this.handleTouchTapLeftIconButton;
	          }
	
	          menuElementLeft = _react2.default.createElement(
	            'div',
	            { style: prepareStyles(iconLeftStyle) },
	            (0, _keys2.default)(iconElementLeftProps).length > 0 ? (0, _react.cloneElement)(iconElementLeft, iconElementLeftProps) : iconElementLeft
	          );
	        } else {
	          menuElementLeft = _react2.default.createElement(
	            _IconButton2.default,
	            {
	              style: iconLeftStyle,
	              iconStyle: styles.iconButtonIconStyle,
	              iconClassName: iconClassNameLeft,
	              onTouchTap: this.handleTouchTapLeftIconButton
	            },
	            iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) })
	          );
	        }
	      }
	
	      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
	        marginRight: -16,
	        marginLeft: 'auto'
	      }, iconStyleRight);
	
	      if (iconElementRight) {
	        var iconElementRightProps = {};
	
	        switch (iconElementRight.type.muiName) {
	          case 'IconMenu':
	          case 'IconButton':
	            var iconElemRightChildren = iconElementRight.props.children;
	            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementRightProps.iconStyle = (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle);
	            break;
	
	          case 'FlatButton':
	            iconElementRightProps.style = (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style);
	            break;
	
	          default:
	        }
	
	        if (!iconElementRight.props.onTouchTap && this.props.onRightIconButtonTouchTap) {
	          iconElementRightProps.onTouchTap = this.handleTouchTapRightIconButton;
	        }
	
	        menuElementRight = _react2.default.createElement(
	          'div',
	          { style: prepareStyles(iconRightStyle) },
	          (0, _keys2.default)(iconElementRightProps).length > 0 ? (0, _react.cloneElement)(iconElementRight, iconElementRightProps) : iconElementRight
	        );
	      } else if (iconClassNameRight) {
	        menuElementRight = _react2.default.createElement(_IconButton2.default, {
	          style: iconRightStyle,
	          iconStyle: styles.iconButtonIconStyle,
	          iconClassName: iconClassNameRight,
	          onTouchTap: this.handleTouchTapRightIconButton
	        });
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, {
	          rounded: false,
	          className: className,
	          style: (0, _simpleAssign2.default)({}, styles.root, style),
	          zDepth: zDepth
	        }),
	        menuElementLeft,
	        titleElement,
	        menuElementRight,
	        children
	      );
	    }
	  }]);
	  return AppBar;
	}(_react.Component);
	
	AppBar.muiName = 'AppBar';
	AppBar.defaultProps = {
	  showMenuIconButton: true,
	  title: '',
	  zDepth: 1
	};
	AppBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? AppBar.propTypes = {
	  /**
	   * Can be used to render a tab inside an app bar for instance.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Applied to the app bar's root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The classname of the icon on the left of the app bar.
	   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	   */
	  iconClassNameLeft: _react.PropTypes.string,
	  /**
	   * Similiar to the iconClassNameLeft prop except that
	   * it applies to the icon displayed on the right of the app bar.
	   */
	  iconClassNameRight: _react.PropTypes.string,
	  /**
	   * The custom element to be displayed on the left side of the
	   * app bar such as an SvgIcon.
	   */
	  iconElementLeft: _react.PropTypes.element,
	  /**
	   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	   */
	  iconElementRight: _react.PropTypes.element,
	  /**
	   * Override the inline-styles of the element displayed on the left side of the app bar.
	   */
	  iconStyleLeft: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the element displayed on the right side of the app bar.
	   */
	  iconStyleRight: _react.PropTypes.object,
	  /**
	   * Callback function for when the left icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the left `IconButton`.
	   */
	  onLeftIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the right icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the right `IconButton`.
	   */
	  onRightIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the title text is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the `title` node.
	   */
	  onTitleTouchTap: _react.PropTypes.func,
	  /**
	   * Determines whether or not to display the Menu icon next to the title.
	   * Setting this prop to false will hide the icon.
	   */
	  showMenuIconButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the app bar.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the app bar's title element.
	   */
	  titleStyle: _react.PropTypes.object,
	  /**
	   * The zDepth of the component.
	   * The shadow of the app bar is also dependent on this property.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = AppBar;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AppBar = __webpack_require__(998);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppBar2.default;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(50);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _TextField = __webpack_require__(40);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Menu = __webpack_require__(359);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(140);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(355);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Popover = __webpack_require__(89);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var anchorEl = state.anchorEl;
	  var fullWidth = props.fullWidth;
	
	
	  var styles = {
	    root: {
	      display: 'inline-block',
	      position: 'relative',
	      width: fullWidth ? '100%' : 256
	    },
	    menu: {
	      width: '100%'
	    },
	    list: {
	      display: 'block',
	      width: fullWidth ? '100%' : 256
	    },
	    innerDiv: {
	      overflow: 'hidden'
	    }
	  };
	
	  if (anchorEl && fullWidth) {
	    styles.popover = {
	      width: anchorEl.clientWidth
	    };
	  }
	
	  return styles;
	}
	
	var AutoComplete = function (_Component) {
	  (0, _inherits3.default)(AutoComplete, _Component);
	
	  function AutoComplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoComplete.__proto__ || (0, _getPrototypeOf2.default)(AutoComplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      focusTextField: true,
	      open: false,
	      searchText: undefined
	    }, _this.handleRequestClose = function () {
	      // Only take into account the Popover clickAway when we are
	      // not focusing the TextField.
	      if (!_this.state.focusTextField) {
	        _this.close();
	      }
	    }, _this.handleMouseDown = function (event) {
	      // Keep the TextField focused
	      event.preventDefault();
	    }, _this.handleItemTouchTap = function (event, child) {
	      var dataSource = _this.props.dataSource;
	
	      var index = parseInt(child.key, 10);
	      var chosenRequest = dataSource[index];
	      var searchText = _this.chosenRequestText(chosenRequest);
	
	      _this.setState({
	        searchText: searchText
	      }, function () {
	        _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'touchTap'
	        });
	
	        _this.timerTouchTapCloseId = setTimeout(function () {
	          _this.timerTouchTapCloseId = null;
	          _this.close();
	          _this.props.onNewRequest(chosenRequest, index);
	        }, _this.props.menuCloseDelay);
	      });
	    }, _this.chosenRequestText = function (chosenRequest) {
	      if (typeof chosenRequest === 'string') {
	        return chosenRequest;
	      } else {
	        return chosenRequest[_this.props.dataSourceConfig.text];
	      }
	    }, _this.handleEscKeyDown = function () {
	      _this.close();
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.close();
	          var searchText = _this.state.searchText;
	          if (searchText !== '') {
	            _this.props.onNewRequest(searchText, -1);
	          }
	          break;
	
	        case 'esc':
	          _this.close();
	          break;
	
	        case 'down':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            focusTextField: false,
	            anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	          });
	          break;
	
	        default:
	          break;
	      }
	    }, _this.handleChange = function (event) {
	      var searchText = event.target.value;
	
	      // Make sure that we have a new searchText.
	      // Fix an issue with a Cordova Webview
	      if (searchText === _this.state.searchText) {
	        return;
	      }
	
	      _this.setState({
	        searchText: searchText,
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	      }, function () {
	        _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'change'
	        });
	      });
	    }, _this.handleBlur = function (event) {
	      if (_this.state.focusTextField && _this.timerTouchTapCloseId === null) {
	        _this.timerBlurClose = setTimeout(function () {
	          _this.close();
	        }, 0);
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      if (!_this.state.open && _this.props.openOnFocus) {
	        _this.setState({
	          open: true,
	          anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	        });
	      }
	
	      _this.setState({
	        focusTextField: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoComplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.requestsList = [];
	      this.setState({
	        open: this.props.open,
	        searchText: this.props.searchText
	      });
	      this.timerTouchTapCloseId = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.searchText !== nextProps.searchText) {
	        this.setState({
	          searchText: nextProps.searchText
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerTouchTapCloseId);
	      clearTimeout(this.timerBlurClose);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        open: false,
	        anchorEl: null
	      });
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.refs.searchTextField.blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.searchTextField.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          animated = _props.animated,
	          animation = _props.animation,
	          dataSource = _props.dataSource,
	          dataSourceConfig = _props.dataSourceConfig,
	          disableFocusRipple = _props.disableFocusRipple,
	          errorStyle = _props.errorStyle,
	          floatingLabelText = _props.floatingLabelText,
	          filter = _props.filter,
	          fullWidth = _props.fullWidth,
	          style = _props.style,
	          hintText = _props.hintText,
	          maxSearchResults = _props.maxSearchResults,
	          menuCloseDelay = _props.menuCloseDelay,
	          textFieldStyle = _props.textFieldStyle,
	          menuStyle = _props.menuStyle,
	          menuProps = _props.menuProps,
	          listStyle = _props.listStyle,
	          targetOrigin = _props.targetOrigin,
	          onClose = _props.onClose,
	          onNewRequest = _props.onNewRequest,
	          onUpdateInput = _props.onUpdateInput,
	          openOnFocus = _props.openOnFocus,
	          popoverProps = _props.popoverProps,
	          searchTextProp = _props.searchText,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'animated', 'animation', 'dataSource', 'dataSourceConfig', 'disableFocusRipple', 'errorStyle', 'floatingLabelText', 'filter', 'fullWidth', 'style', 'hintText', 'maxSearchResults', 'menuCloseDelay', 'textFieldStyle', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin', 'onClose', 'onNewRequest', 'onUpdateInput', 'openOnFocus', 'popoverProps', 'searchText']);
	
	      var _ref2 = popoverProps || {},
	          popoverStyle = _ref2.style,
	          popoverOther = (0, _objectWithoutProperties3.default)(_ref2, ['style']);
	
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl,
	          searchText = _state.searchText,
	          focusTextField = _state.focusTextField;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var requestsList = [];
	
	      dataSource.every(function (item, index) {
	        switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) {
	          case 'string':
	            if (filter(searchText, item, item)) {
	              requestsList.push({
	                text: item,
	                value: _react2.default.createElement(_MenuItem2.default, {
	                  innerDivStyle: styles.innerDiv,
	                  value: item,
	                  primaryText: item,
	                  disableFocusRipple: disableFocusRipple,
	                  key: index
	                })
	              });
	            }
	            break;
	
	          case 'object':
	            if (item && typeof item[_this2.props.dataSourceConfig.text] === 'string') {
	              var itemText = item[_this2.props.dataSourceConfig.text];
	              if (!_this2.props.filter(searchText, itemText, item)) break;
	
	              var itemValue = item[_this2.props.dataSourceConfig.value];
	              if (itemValue.type && (itemValue.type.muiName === _MenuItem2.default.muiName || itemValue.type.muiName === _Divider2.default.muiName)) {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.cloneElement(itemValue, {
	                    key: index,
	                    disableFocusRipple: disableFocusRipple
	                  })
	                });
	              } else {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.createElement(_MenuItem2.default, {
	                    innerDivStyle: styles.innerDiv,
	                    primaryText: itemText,
	                    disableFocusRipple: disableFocusRipple,
	                    key: index
	                  })
	                });
	              }
	            }
	            break;
	
	          default:
	          // Do nothing
	        }
	
	        return !(maxSearchResults && maxSearchResults > 0 && requestsList.length === maxSearchResults);
	      });
	
	      this.requestsList = requestsList;
	
	      var menu = open && requestsList.length > 0 && _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, menuProps, {
	          ref: 'menu',
	          autoWidth: false,
	          disableAutoFocus: focusTextField,
	          onEscKeyDown: this.handleEscKeyDown,
	          initiallyKeyboardFocused: true,
	          onItemTouchTap: this.handleItemTouchTap,
	          onMouseDown: this.handleMouseDown,
	          style: (0, _simpleAssign2.default)(styles.menu, menuStyle),
	          listStyle: (0, _simpleAssign2.default)(styles.list, listStyle)
	        }),
	        requestsList.map(function (i) {
	          return i.value;
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          ref: 'searchTextField',
	          autoComplete: 'off',
	          value: searchText,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          floatingLabelText: floatingLabelText,
	          hintText: hintText,
	          fullWidth: fullWidth,
	          multiLine: false,
	          errorStyle: errorStyle,
	          style: textFieldStyle
	        })),
	        _react2.default.createElement(
	          _Popover2.default,
	          (0, _extends3.default)({
	            style: (0, _simpleAssign2.default)({}, styles.popover, popoverStyle),
	            canAutoPosition: false,
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation
	          }, popoverOther),
	          menu
	        )
	      );
	    }
	  }]);
	  return AutoComplete;
	}(_react.Component);
	
	AutoComplete.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  dataSourceConfig: {
	    text: 'text',
	    value: 'value'
	  },
	  disableFocusRipple: true,
	  filter: function filter(searchText, key) {
	    return searchText !== '' && key.indexOf(searchText) !== -1;
	  },
	  fullWidth: false,
	  open: false,
	  openOnFocus: false,
	  onUpdateInput: function onUpdateInput() {},
	  onNewRequest: function onNewRequest() {},
	  searchText: '',
	  menuCloseDelay: 300,
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	AutoComplete.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? AutoComplete.propTypes = {
	  /**
	   * Location of the anchor for the auto complete.
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the auto complete is animated as it is toggled.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * Array of strings or nodes used to populate the list.
	   */
	  dataSource: _react.PropTypes.array.isRequired,
	  /**
	   * Config for objects list dataSource.
	   *
	   * @typedef {Object} dataSourceConfig
	   *
	   * @property {string} text `dataSource` element key used to find a string to be matched for search
	   * and shown as a `TextField` input value after choosing the result.
	   * @property {string} value `dataSource` element key used to find a string to be shown in search results.
	   */
	  dataSourceConfig: _react.PropTypes.object,
	  /**
	   * Disables focus ripple when true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * Override style prop for error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * Callback function used to filter the auto complete.
	   *
	   * @param {string} searchText The text to search for within `dataSource`.
	   * @param {string} key `dataSource` element, or `text` property on that element if it's not a string.
	   * @returns {boolean} `true` indicates the auto complete list will include `key` when the input is `searchText`.
	   */
	  filter: _react.PropTypes.func,
	  /**
	   * The content to use for adding floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property `width: 100%`.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * Override style for list.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The max number of search results to be shown.
	   * By default it shows all the items which matches filter.
	   */
	  maxSearchResults: _react.PropTypes.number,
	  /**
	   * Delay for closing time of the menu.
	   */
	  menuCloseDelay: _react.PropTypes.number,
	  /**
	   * Props to be passed to menu.
	   */
	  menuProps: _react.PropTypes.object,
	  /**
	   * Override style for menu.
	   */
	  menuStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when a list item is selected, or enter is pressed in the `TextField`.
	   *
	   * @param {string} chosenRequest Either the `TextField` input value, if enter is pressed in the `TextField`,
	   * or the text value of the corresponding list item that was selected.
	   * @param {number} index The index in `dataSource` of the list item selected, or `-1` if enter is pressed in the
	   * `TextField`.
	   */
	  onNewRequest: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the user updates the `TextField`.
	   *
	   * @param {string} searchText The auto-complete's `searchText` value.
	   * @param {array} dataSource The auto-complete's `dataSource` array.
	   * @param {object} params Additional information linked the update.
	   */
	  onUpdateInput: _react.PropTypes.func,
	  /**
	   * Auto complete menu is open if true.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * If true, the list item is showed when a focus event triggers.
	   */
	  openOnFocus: _react.PropTypes.bool,
	  /**
	   * Props to be passed to popover.
	   */
	  popoverProps: _react.PropTypes.object,
	  /**
	   * Text being input to auto complete.
	   */
	  searchText: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Origin for location of target.
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * Override the inline-styles of AutoComplete's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object
	} : void 0;
	
	
	AutoComplete.levenshteinDistance = function (searchText, key) {
	  var current = [];
	  var prev = void 0;
	  var value = void 0;
	
	  for (var i = 0; i <= key.length; i++) {
	    for (var j = 0; j <= searchText.length; j++) {
	      if (i && j) {
	        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
	      } else {
	        value = i + j;
	      }
	      prev = current[j];
	      current[j] = value;
	    }
	  }
	  return current.pop();
	};
	
	AutoComplete.noFilter = function () {
	  return true;
	};
	
	AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
	  return searchText !== '' && key.indexOf(searchText) !== -1;
	};
	
	AutoComplete.caseInsensitiveFilter = function (searchText, key) {
	  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	};
	
	AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
	  if (distanceLessThan === undefined) {
	    return AutoComplete.levenshteinDistance;
	  } else if (typeof distanceLessThan !== 'number') {
	    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
	  }
	
	  return function (s, k) {
	    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
	  };
	};
	
	AutoComplete.fuzzyFilter = function (searchText, key) {
	  var compareString = key.toLowerCase();
	  searchText = searchText.toLowerCase();
	
	  var searchTextIndex = 0;
	  for (var index = 0; index < key.length; index++) {
	    if (compareString[index] === searchText[searchTextIndex]) {
	      searchTextIndex += 1;
	    }
	  }
	
	  return searchTextIndex === searchText.length;
	};
	
	AutoComplete.Item = _MenuItem2.default;
	AutoComplete.Divider = _Divider2.default;
	
	exports.default = AutoComplete;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AutoComplete = __webpack_require__(1000);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoComplete2.default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var backgroundColor = props.backgroundColor,
	      color = props.color,
	      size = props.size;
	  var avatar = context.muiTheme.avatar;
	
	
	  var styles = {
	    root: {
	      color: color || avatar.color,
	      backgroundColor: backgroundColor || avatar.backgroundColor,
	      userSelect: 'none',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      fontSize: size / 2,
	      borderRadius: '50%',
	      height: size,
	      width: size
	    },
	    icon: {
	      color: color || avatar.color,
	      width: size * 0.6,
	      height: size * 0.6,
	      fontSize: size * 0.6,
	      margin: size * 0.2
	    }
	  };
	
	  return styles;
	}
	
	var Avatar = function (_Component) {
	  (0, _inherits3.default)(Avatar, _Component);
	
	  function Avatar() {
	    (0, _classCallCheck3.default)(this, Avatar);
	    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          src = _props.src,
	          style = _props.style,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      if (src) {
	        return _react2.default.createElement('img', (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other, {
	          src: src,
	          className: className
	        }));
	      } else {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
	            className: className
	          }),
	          icon && _react2.default.cloneElement(icon, {
	            color: styles.icon.color,
	            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	          }),
	          this.props.children
	        );
	      }
	    }
	  }]);
	  return Avatar;
	}(_react.Component);
	
	Avatar.muiName = 'Avatar';
	Avatar.defaultProps = {
	  size: 40
	};
	Avatar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Avatar.propTypes = {
	  /**
	   * The backgroundColor of the avatar. Does not apply to image avatars.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Can be used, for instance, to render a letter inside the avatar.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root `div` or `img` element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The icon or letter's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the SvgIcon or FontIcon to be used inside the avatar.
	   */
	  icon: _react.PropTypes.element,
	  /**
	   * This is the size of the avatar in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	   */
	  src: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Avatar;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var primary = props.primary,
	      secondary = props.secondary;
	  var badge = context.muiTheme.badge;
	
	
	  var badgeBackgroundColor = void 0;
	  var badgeTextColor = void 0;
	
	  if (primary) {
	    badgeBackgroundColor = badge.primaryColor;
	    badgeTextColor = badge.primaryTextColor;
	  } else if (secondary) {
	    badgeBackgroundColor = badge.secondaryColor;
	    badgeTextColor = badge.secondaryTextColor;
	  } else {
	    badgeBackgroundColor = badge.color;
	    badgeTextColor = badge.textColor;
	  }
	
	  var radius = 12;
	  var radius2x = Math.floor(2 * radius);
	
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      fontWeight: badge.fontWeight,
	      fontSize: radius,
	      width: radius2x,
	      height: radius2x,
	      borderRadius: '50%',
	      backgroundColor: badgeBackgroundColor,
	      color: badgeTextColor
	    }
	  };
	}
	
	var Badge = function (_Component) {
	  (0, _inherits3.default)(Badge, _Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, (Badge.__proto__ || (0, _getPrototypeOf2.default)(Badge)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          badgeContent = _props.badgeContent,
	          badgeStyle = _props.badgeStyle,
	          children = _props.children,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
	          badgeContent
	        )
	      );
	    }
	  }]);
	  return Badge;
	}(_react.Component);
	
	Badge.defaultProps = {
	  primary: false,
	  secondary: false
	};
	Badge.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Badge.propTypes = {
	  /**
	   * This is the content rendered within the badge.
	   */
	  badgeContent: _react.PropTypes.node.isRequired,
	  /**
	   * Override the inline-styles of the badge element.
	   */
	  badgeStyle: _react.PropTypes.object,
	  /**
	   * The badge will be added relativelty to this node.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the badge will use the primary badge colors.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * If true, the badge will use the secondary badge colors.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Badge;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Badge = __webpack_require__(1003);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge2.default;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      width: '100%',
	      display: 'flex',
	      justifyContent: 'center',
	      backgroundColor: bottomNavigation.backgroundColor,
	      height: bottomNavigation.height
	    },
	    item: {
	      flex: '1'
	    }
	  };
	
	  return styles;
	}
	
	var BottomNavigation = function BottomNavigation(props, context) {
	  var children = props.children,
	      style = props.style,
	      selectedIndex = props.selectedIndex,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'style', 'selectedIndex']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var preparedChildren = _react.Children.map(children, function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      style: (0, _simpleAssign2.default)({}, styles.item, child.props.style),
	      selected: index === selectedIndex
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	    preparedChildren
	  );
	};
	
	 false ? BottomNavigation.propTypes = {
	  /**
	   * The `BottomNavigationItem`s to populate the element with.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The index of the currently selected navigation item.
	   */
	  selectedIndex: _react.PropTypes.number,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	BottomNavigation.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = BottomNavigation;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BottomNavigationItem = exports.BottomNavigation = undefined;
	
	var _BottomNavigation2 = __webpack_require__(1005);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(348);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.default = _BottomNavigation3.default;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CardExpandable = __webpack_require__(350);
	
	var _CardExpandable2 = _interopRequireDefault(_CardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _this.handleExpanding = function (event) {
	      event.preventDefault();
	      var newExpandedState = !_this.state.expanded;
	      // no automatic state update when the component is controlled
	      if (_this.props.expanded === null) {
	        _this.setState({ expanded: newExpandedState });
	      }
	      if (_this.props.onExpandChange) {
	        _this.props.onExpandChange(newExpandedState);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          containerStyle = _props.containerStyle,
	          children = _props.children,
	          expandable = _props.expandable,
	          expandedProp = _props.expanded,
	          initiallyExpanded = _props.initiallyExpanded,
	          onExpandChange = _props.onExpandChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);
	
	
	      var lastElement = void 0;
	      var expanded = this.state.expanded;
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        var doClone = false;
	        var newChild = undefined;
	        var newProps = {};
	        var element = currentChild;
	        if (!currentChild || !currentChild.props) {
	          return null;
	        }
	        if (expanded === false && currentChild.props.expandable === true) return;
	        if (currentChild.props.actAsExpander === true) {
	          doClone = true;
	          newProps.onTouchTap = _this2.handleExpanding;
	          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
	        }
	        if (currentChild.props.showExpandableButton === true) {
	          doClone = true;
	          newChild = _react2.default.createElement(_CardExpandable2.default, {
	            closeIcon: currentChild.props.closeIcon,
	            expanded: expanded,
	            onExpanding: _this2.handleExpanding,
	            openIcon: currentChild.props.openIcon
	          });
	        }
	        if (doClone) {
	          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	        }
	        lastElement = element;
	        return element;
	      }, this);
	
	      // If the last element is text or a title we should add
	      // 8px padding to the bottom of the card
	      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        zIndex: 1
	      }, style);
	      var containerMergedStyles = (0, _simpleAssign2.default)({
	        paddingBottom: addBottomPadding ? 8 : 0
	      }, containerStyle);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, { style: mergedStyles }),
	        _react2.default.createElement(
	          'div',
	          { style: containerMergedStyles },
	          newChildren
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card.defaultProps = {
	  expandable: false,
	  expanded: null,
	  initiallyExpanded: false
	};
	 false ? Card.propTypes = {
	  /**
	   * Can be used to render elements inside the Card.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If true, this card component is expandable. Can be set on any child of the `Card` component.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Whether this card is expanded.
	   * If `true` or `false` the component is controlled.
	   * if `null` the component is uncontrolled.
	   */
	  expanded: _react.PropTypes.bool,
	  /**
	   * Whether this card is initially expanded.
	   */
	  initiallyExpanded: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the `expandable` state of the card has changed.
	   *
	   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
	   */
	  onExpandChange: _react.PropTypes.func,
	  /**
	   * If true, this card component will include a button to expand the card. `CardTitle`,
	   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
	   * of `Card` can implements `showExpandableButton` or forwards the property to a child
	   * component supporting it.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Card;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(1007);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardHeader2 = __webpack_require__(351);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardTitle2 = __webpack_require__(354);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(352);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardText2 = __webpack_require__(353);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActions2 = __webpack_require__(349);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardExpandable2 = __webpack_require__(350);
	
	var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardText = _CardText3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardExpandable = _CardExpandable3.default;
	exports.default = _Card3.default;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedSwitch = __webpack_require__(223);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(1111);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(1112);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
	    },
	    boxWhenSwitched: {
	      opacity: 0,
	      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
	      fill: checkbox.checkedColor
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          checked = _props.checked,
	          defaultChecked = _props.defaultChecked,
	          valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          iconStyle = _props2.iconStyle,
	          onCheck = _props2.onCheck,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Checkbox.propTypes = {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _react.PropTypes.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _react.PropTypes.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _react.PropTypes.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = Checkbox;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _colorManipulator = __webpack_require__(55);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _cancel = __webpack_require__(1104);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var chip = context.muiTheme.chip;
	
	
	  var backgroundColor = props.backgroundColor || chip.backgroundColor;
	  var focusColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.08);
	  var pressedColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.12);
	
	  return {
	    avatar: {
	      marginRight: -4
	    },
	    deleteIcon: {
	      color: state.deleteHovered ? (0, _colorManipulator.fade)(chip.deleteIconColor, 0.4) : chip.deleteIconColor,
	      cursor: 'pointer',
	      margin: '4px 4px 0px -8px'
	    },
	    label: {
	      color: props.labelColor || chip.textColor,
	      fontSize: chip.fontSize,
	      fontWeight: chip.fontWeight,
	      lineHeight: '32px',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap'
	    },
	    root: {
	      backgroundColor: state.clicked ? pressedColor : state.focused || state.hovered ? focusColor : backgroundColor,
	      borderRadius: 16,
	      boxShadow: state.clicked ? chip.shadow : null,
	      cursor: props.onTouchTap ? 'pointer' : 'default',
	      display: 'flex',
	      whiteSpace: 'nowrap',
	      width: 'fit-content'
	    }
	  };
	}
	
	var Chip = function (_Component) {
	  (0, _inherits3.default)(Chip, _Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clicked: false,
	      deleteHovered: false,
	      focused: false,
	      hovered: false
	    }, _this.handleBlur = function (event) {
	      _this.setState({ clicked: false, focused: false });
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (_this.props.onTouchTap || _this.props.onRequestDelete) {
	        _this.setState({ focused: true });
	      }
	      _this.props.onFocus(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused) {
	        _this.handleFocus();
	        _this.props.onFocus(event);
	      } else {
	        _this.handleBlur();
	      }
	
	      _this.props.onKeyboardFocus(event, keyboardFocused);
	    }, _this.handleKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'backspace') {
	        event.preventDefault();
	        if (_this.props.onRequestDelete) {
	          _this.props.onRequestDelete(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleMouseDown = function (event) {
	      // Only listen to left clicks
	      if (event.button === 0) {
	        event.stopPropagation();
	        if (_this.props.onTouchTap) {
	          _this.setState({ clicked: true });
	        }
	      }
	      _this.props.onMouseDown(event);
	    }, _this.handleMouseEnter = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.setState({ hovered: true });
	      }
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseEnterDeleteIcon = function () {
	      _this.setState({ deleteHovered: true });
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({
	        clicked: false,
	        hovered: false
	      });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseLeaveDeleteIcon = function () {
	      _this.setState({ deleteHovered: false });
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onMouseUp(event);
	    }, _this.handleTouchTapDeleteIcon = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      _this.props.onRequestDelete(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onTouchEnd(event);
	    }, _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      if (_this.props.onTouchTap) {
	        _this.setState({ clicked: true });
	      }
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Chip, [{
	    key: 'render',
	    value: function render() {
	      var buttonEventHandlers = {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchStart: this.handleTouchStart,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          style = _props.style,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelColor = _props.labelColor,
	          backgroundColor = _props.backgroundColor,
	          onRequestDelete = _props.onRequestDelete,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style', 'className', 'labelStyle', 'labelColor', 'backgroundColor', 'onRequestDelete']);
	
	
	      var deletable = this.props.onRequestDelete;
	      var avatar = null;
	
	      var deleteIcon = deletable ? _react2.default.createElement(_cancel2.default, {
	        color: styles.deleteIcon.color,
	        style: styles.deleteIcon,
	        onTouchTap: this.handleTouchTapDeleteIcon,
	        onMouseEnter: this.handleMouseEnterDeleteIcon,
	        onMouseLeave: this.handleMouseLeaveDeleteIcon
	      }) : null;
	
	      var children = childrenProp;
	      var childCount = _react2.default.Children.count(children);
	
	      // If the first child is an avatar, extract it and style it
	      if (childCount > 1) {
	        children = _react2.default.Children.toArray(children);
	
	        if (_react2.default.isValidElement(children[0]) && children[0].type.muiName === 'Avatar') {
	          avatar = children.shift();
	
	          avatar = _react2.default.cloneElement(avatar, {
	            style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style),
	            size: 32
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, buttonEventHandlers, {
	          className: className,
	          containerElement: 'div' // Firefox doesn't support nested buttons
	          , disableTouchRipple: true,
	          disableFocusRipple: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	          children
	        ),
	        deleteIcon
	      );
	    }
	  }]);
	  return Chip;
	}(_react.Component);
	
	Chip.defaultProps = {
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {}
	};
	Chip.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	 false ? Chip.propTypes = {
	  /**
	   * Override the background color of the chip.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Used to render elements inside the Chip.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * CSS `className` of the root element.
	   */
	  className: _react.PropTypes.node,
	  /**
	   * Override the label color.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /** @ignore */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /**
	   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
	   * @param {object} event `touchTap` event targeting the element.
	   */
	  onRequestDelete: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `Chip` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the element.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Chip;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Chip = __webpack_require__(1010);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip2.default;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(73);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return clampedValue / (max - min);
	}
	
	function getArcLength(fraction, props) {
	  return fraction * Math.PI * (props.size - props.thickness);
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      size = props.size,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      width: size,
	      height: size
	    },
	    wrapper: {
	      width: size,
	      height: size,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      width: size,
	      height: size,
	      position: 'relative'
	    },
	    path: {
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  (0, _inherits3.default)(CircularProgress, _Component);
	
	  function CircularProgress() {
	    (0, _classCallCheck3.default)(this, CircularProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path) {
	      var _this2 = this;
	
	      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-1, this.props);
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          innerStyle = _props.innerStyle,
	          size = _props.size,
	          thickness = _props.thickness,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            {
	              viewBox: '0 0 ' + size + ' ' + size,
	              style: prepareStyles(styles.svg)
	            },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: size / 2,
	              cy: size / 2,
	              r: (size - thickness) / 2,
	              fill: 'none',
	              strokeWidth: thickness,
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 40,
	  thickness: 3.5
	};
	CircularProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CircularProgress.propTypes = {
	  /**
	   * Override the progress's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _react.PropTypes.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The diameter of the progress in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Stroke width in pixels.
	   */
	  thickness: _react.PropTypes.number,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = CircularProgress;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(1012);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(57);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _CalendarActionButtons = __webpack_require__(1015);
	
	var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);
	
	var _CalendarMonth = __webpack_require__(1016);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarYear = __webpack_require__(1018);
	
	var _CalendarYear2 = _interopRequireDefault(_CalendarYear);
	
	var _CalendarToolbar = __webpack_require__(1017);
	
	var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);
	
	var _DateDisplay = __webpack_require__(1019);
	
	var _DateDisplay2 = _interopRequireDefault(_DateDisplay);
	
	var _SlideIn = __webpack_require__(225);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	var _dateUtils = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var daysArray = [].concat((0, _toConsumableArray3.default)(Array(7)));
	
	var Calendar = function (_Component) {
	  (0, _inherits3.default)(Calendar, _Component);
	
	  function Calendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      displayDate: undefined,
	      displayMonthDay: true,
	      selectedDate: undefined,
	      transitionDirection: 'left',
	      transitionEnter: true
	    }, _this.handleTouchTapDay = function (event, date) {
	      _this.setSelectedDate(date);
	      if (_this.props.onTouchTapDay) _this.props.onTouchTapDay(event, date);
	    }, _this.handleMonthChange = function (months) {
	      _this.setState({
	        transitionDirection: months >= 0 ? 'left' : 'right',
	        displayDate: (0, _dateUtils.addMonths)(_this.state.displayDate, months)
	      });
	    }, _this.handleTouchTapYear = function (event, year) {
	      var date = (0, _dateUtils.cloneDate)(_this.state.selectedDate);
	      date.setFullYear(year);
	      _this.setSelectedDate(date, event);
	      _this.handleTouchTapDateDisplayMonthDay();
	    }, _this.handleTouchTapDateDisplayMonthDay = function () {
	      _this.setState({
	        displayMonthDay: true
	      });
	    }, _this.handleTouchTapDateDisplayYear = function () {
	      _this.setState({
	        displayMonthDay: false
	      });
	    }, _this.handleWindowKeyDown = function (event) {
	      if (_this.props.open) {
	        switch ((0, _keycode2.default)(event)) {
	          case 'up':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-7);
	            }
	            break;
	
	          case 'down':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(7);
	            }
	            break;
	
	          case 'right':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(1);
	            }
	            break;
	
	          case 'left':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-1);
	            }
	            break;
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Calendar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        displayDate: (0, _dateUtils.getFirstDayOfMonth)(this.props.initialDate),
	        selectedDate: this.props.initialDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.initialDate !== this.props.initialDate) {
	        var date = nextProps.initialDate || new Date();
	        this.setState({
	          displayDate: (0, _dateUtils.getFirstDayOfMonth)(date),
	          selectedDate: date
	        });
	      }
	    }
	  }, {
	    key: 'getSelectedDate',
	    value: function getSelectedDate() {
	      return this.state.selectedDate;
	    }
	  }, {
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      if (!this.state.displayMonthDay) {
	        return false;
	      }
	
	      return this.refs.calendar.isSelectedDateDisabled();
	    }
	  }, {
	    key: 'addSelectedDays',
	    value: function addSelectedDays(days) {
	      this.setSelectedDate((0, _dateUtils.addDays)(this.state.selectedDate, days));
	    }
	  }, {
	    key: 'addSelectedMonths',
	    value: function addSelectedMonths(months) {
	      this.setSelectedDate((0, _dateUtils.addMonths)(this.state.selectedDate, months));
	    }
	  }, {
	    key: 'addSelectedYears',
	    value: function addSelectedYears(years) {
	      this.setSelectedDate((0, _dateUtils.addYears)(this.state.selectedDate, years));
	    }
	  }, {
	    key: 'setDisplayDate',
	    value: function setDisplayDate(date, newSelectedDate) {
	      var newDisplayDate = (0, _dateUtils.getFirstDayOfMonth)(date);
	      var direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';
	
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setState({
	          displayDate: newDisplayDate,
	          transitionDirection: direction,
	          selectedDate: newSelectedDate || this.state.selectedDate
	        });
	      }
	    }
	  }, {
	    key: 'setSelectedDate',
	    value: function setSelectedDate(date) {
	      var adjustedDate = date;
	      if ((0, _dateUtils.isBeforeDate)(date, this.props.minDate)) {
	        adjustedDate = this.props.minDate;
	      } else if ((0, _dateUtils.isAfterDate)(date, this.props.maxDate)) {
	        adjustedDate = this.props.maxDate;
	      }
	
	      var newDisplayDate = (0, _dateUtils.getFirstDayOfMonth)(adjustedDate);
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setDisplayDate(newDisplayDate, adjustedDate);
	      } else {
	        this.setState({
	          selectedDate: adjustedDate
	        });
	      }
	    }
	  }, {
	    key: 'getToolbarInteractions',
	    value: function getToolbarInteractions() {
	      return {
	        prevMonth: (0, _dateUtils.monthDiff)(this.state.displayDate, this.props.minDate) > 0,
	        nextMonth: (0, _dateUtils.monthDiff)(this.state.displayDate, this.props.maxDate) < 0
	      };
	    }
	  }, {
	    key: 'yearSelector',
	    value: function yearSelector() {
	      if (!this.props.disableYearSelection) {
	        return _react2.default.createElement(_CalendarYear2.default, {
	          key: 'years',
	          DateTimeFormat: this.props.DateTimeFormat,
	          locale: this.props.locale,
	          onTouchTapYear: this.handleTouchTapYear,
	          selectedDate: this.state.selectedDate,
	          minDate: this.props.minDate,
	          maxDate: this.props.maxDate
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var toolbarInteractions = this.getToolbarInteractions();
	      var isLandscape = this.props.mode === 'landscape';
	      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;
	
	
	      var styles = {
	        root: {
	          color: calendarTextColor,
	          userSelect: 'none',
	          width: isLandscape ? 479 : 310
	        },
	        calendar: {
	          display: 'flex',
	          flexDirection: 'column'
	        },
	        calendarContainer: {
	          display: 'flex',
	          alignContent: 'space-between',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          fontSize: 12,
	          fontWeight: 400,
	          padding: '0px 8px',
	          transition: _transitions2.default.easeOut()
	        },
	        yearContainer: {
	          display: 'flex',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          height: 272,
	          marginTop: 10,
	          overflow: 'hidden',
	          width: 310
	        },
	        weekTitle: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'space-between',
	          fontWeight: '500',
	          height: 20,
	          lineHeight: '15px',
	          opacity: '0.5',
	          textAlign: 'center'
	        },
	        weekTitleDay: {
	          width: 42
	        },
	        transitionSlide: {
	          height: 214
	        }
	      };
	
	      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);
	
	      var _props = this.props,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          cancelLabel = _props.cancelLabel,
	          DateTimeFormat = _props.DateTimeFormat,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          okLabel = _props.okLabel,
	          onTouchTapCancel = _props.onTouchTapCancel,
	          onTouchTapOk = _props.onTouchTapOk;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleWindowKeyDown
	        }),
	        _react2.default.createElement(_DateDisplay2.default, {
	          DateTimeFormat: DateTimeFormat,
	          disableYearSelection: this.props.disableYearSelection,
	          onTouchTapMonthDay: this.handleTouchTapDateDisplayMonthDay,
	          onTouchTapYear: this.handleTouchTapDateDisplayYear,
	          locale: locale,
	          monthDaySelected: this.state.displayMonthDay,
	          mode: this.props.mode,
	          selectedDate: this.state.selectedDate
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.calendar) },
	          this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.calendarContainer) },
	            _react2.default.createElement(_CalendarToolbar2.default, {
	              DateTimeFormat: DateTimeFormat,
	              locale: locale,
	              displayDate: this.state.displayDate,
	              onMonthChange: this.handleMonthChange,
	              prevMonth: toolbarInteractions.prevMonth,
	              nextMonth: toolbarInteractions.nextMonth
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.weekTitle) },
	              daysArray.map(function (event, i) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: i, style: weekTitleDayStyle },
	                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _SlideIn2.default,
	              { direction: this.state.transitionDirection, style: styles.transitionSlide },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                DateTimeFormat: DateTimeFormat,
	                locale: locale,
	                displayDate: this.state.displayDate,
	                firstDayOfWeek: this.props.firstDayOfWeek,
	                key: this.state.displayDate.toDateString(),
	                minDate: minDate,
	                maxDate: maxDate,
	                onTouchTapDay: this.handleTouchTapDay,
	                ref: 'calendar',
	                selectedDate: this.state.selectedDate,
	                shouldDisableDate: this.props.shouldDisableDate
	              })
	            )
	          ),
	          !this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.yearContainer) },
	            this.yearSelector()
	          ),
	          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
	            autoOk: this.props.autoOk,
	            cancelLabel: cancelLabel,
	            okLabel: okLabel,
	            onTouchTapCancel: onTouchTapCancel,
	            onTouchTapOk: onTouchTapOk
	          })
	        )
	      );
	    }
	  }]);
	  return Calendar;
	}(_react.Component);
	
	Calendar.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  disableYearSelection: false,
	  initialDate: new Date(),
	  locale: 'en-US',
	  minDate: (0, _dateUtils.addYears)(new Date(), -100),
	  maxDate: (0, _dateUtils.addYears)(new Date(), 100)
	};
	Calendar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Calendar.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  disableYearSelection: _react.PropTypes.bool,
	  firstDayOfWeek: _react.PropTypes.number,
	  initialDate: _react.PropTypes.object,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  okLabel: _react.PropTypes.node,
	  onTouchTapCancel: _react.PropTypes.func,
	  onTouchTapDay: _react.PropTypes.func,
	  onTouchTapOk: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  shouldDisableDate: _react.PropTypes.func
	} : void 0;
	exports.default = Calendar;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FlatButton = __webpack_require__(109);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarActionButton = function (_Component) {
	  (0, _inherits3.default)(CalendarActionButton, _Component);
	
	  function CalendarActionButton() {
	    (0, _classCallCheck3.default)(this, CalendarActionButton);
	    return (0, _possibleConstructorReturn3.default)(this, (CalendarActionButton.__proto__ || (0, _getPrototypeOf2.default)(CalendarActionButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CalendarActionButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          okLabel = _props.okLabel;
	
	
	      var styles = {
	        root: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'flex-end',
	          margin: 0,
	          maxHeight: 48,
	          padding: 0
	        },
	        flatButtons: {
	          fontsize: 14,
	          margin: '4px 8px 8px 0px',
	          maxHeight: 36,
	          minWidth: 64,
	          padding: 0
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_FlatButton2.default, {
	          label: cancelLabel,
	          onTouchTap: this.props.onTouchTapCancel,
	          primary: true,
	          style: styles.flatButtons
	        }),
	        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
	          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	          label: okLabel,
	          onTouchTap: this.props.onTouchTapOk,
	          primary: true,
	          style: styles.flatButtons
	        })
	      );
	    }
	  }]);
	  return CalendarActionButton;
	}(_react.Component);
	
	 false ? CalendarActionButton.propTypes = {
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  okLabel: _react.PropTypes.node,
	  onTouchTapCancel: _react.PropTypes.func,
	  onTouchTapOk: _react.PropTypes.func
	} : void 0;
	exports.default = CalendarActionButton;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateUtils = __webpack_require__(88);
	
	var _DayButton = __webpack_require__(1021);
	
	var _DayButton2 = _interopRequireDefault(_DayButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'flex-start',
	    fontWeight: 400,
	    height: 228,
	    lineHeight: 2,
	    position: 'relative',
	    textAlign: 'center',
	    MozPaddingStart: 0
	  },
	  week: {
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-around',
	    height: 34,
	    marginBottom: 2
	  }
	};
	
	var CalendarMonth = function (_Component) {
	  (0, _inherits3.default)(CalendarMonth, _Component);
	
	  function CalendarMonth() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarMonth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonth.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonth)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapDay = function (event, date) {
	      if (_this.props.onTouchTapDay) {
	        _this.props.onTouchTapDay(event, date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarMonth, [{
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      return this.selectedDateDisabled;
	    }
	  }, {
	    key: 'shouldDisableDate',
	    value: function shouldDisableDate(day) {
	      if (day === null) return false;
	      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
	      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	      return disabled;
	    }
	  }, {
	    key: 'getWeekElements',
	    value: function getWeekElements() {
	      var _this2 = this;
	
	      var weekArray = (0, _dateUtils.getWeekArray)(this.props.displayDate, this.props.firstDayOfWeek);
	
	      return weekArray.map(function (week, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: styles.week },
	          _this2.getDayElements(week, i)
	        );
	      }, this);
	    }
	  }, {
	    key: 'getDayElements',
	    value: function getDayElements(week, i) {
	      var _this3 = this;
	
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          selectedDate = _props.selectedDate;
	
	
	      return week.map(function (day, j) {
	        var isSameDate = (0, _dateUtils.isEqualDate)(selectedDate, day);
	        var disabled = _this3.shouldDisableDate(day);
	        var selected = !disabled && isSameDate;
	
	        if (isSameDate) {
	          _this3.selectedDateDisabled = disabled;
	        }
	
	        return _react2.default.createElement(_DayButton2.default, {
	          DateTimeFormat: DateTimeFormat,
	          locale: locale,
	          date: day,
	          disabled: disabled,
	          key: 'db' + (i + j),
	          onTouchTap: _this3.handleTouchTapDay,
	          selected: selected
	        });
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        this.getWeekElements()
	      );
	    }
	  }]);
	  return CalendarMonth;
	}(_react.Component);
	
	 false ? CalendarMonth.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  autoOk: _react.PropTypes.bool,
	  displayDate: _react.PropTypes.object.isRequired,
	  firstDayOfWeek: _react.PropTypes.number,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  onTouchTapDay: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  shouldDisableDate: _react.PropTypes.func
	} : void 0;
	exports.default = CalendarMonth;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(45);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _chevronLeft = __webpack_require__(1106);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(1107);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _SlideIn = __webpack_require__(225);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    backgroundColor: 'inherit',
	    height: 48
	  },
	  titleDiv: {
	    fontSize: 14,
	    fontWeight: '500',
	    textAlign: 'center',
	    width: '100%'
	  },
	  titleText: {
	    height: 'inherit',
	    paddingTop: 12
	  }
	};
	
	var CalendarToolbar = function (_Component) {
	  (0, _inherits3.default)(CalendarToolbar, _Component);
	
	  function CalendarToolbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarToolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarToolbar.__proto__ || (0, _getPrototypeOf2.default)(CalendarToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _this.handleTouchTapPrevMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(-1);
	      }
	    }, _this.handleTouchTapNextMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(1);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarToolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.displayDate !== this.props.displayDate) {
	        var direction = nextProps.displayDate > this.props.displayDate ? 'left' : 'right';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          displayDate = _props.displayDate;
	
	
	      var dateTimeFormatted = new DateTimeFormat(locale, {
	        month: 'long',
	        year: 'numeric'
	      }).format(displayDate);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.prevMonth,
	            onTouchTap: this.handleTouchTapPrevMonth
	          },
	          _react2.default.createElement(_chevronLeft2.default, null)
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            direction: this.state.transitionDirection,
	            style: styles.titleDiv
	          },
	          _react2.default.createElement(
	            'div',
	            { key: dateTimeFormatted, style: styles.titleText },
	            dateTimeFormatted
	          )
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.nextMonth,
	            onTouchTap: this.handleTouchTapNextMonth
	          },
	          _react2.default.createElement(_chevronRight2.default, null)
	        )
	      );
	    }
	  }]);
	  return CalendarToolbar;
	}(_react.Component);
	
	CalendarToolbar.defaultProps = {
	  nextMonth: true,
	  prevMonth: true
	};
	 false ? CalendarToolbar.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  displayDate: _react.PropTypes.object.isRequired,
	  locale: _react.PropTypes.string.isRequired,
	  nextMonth: _react.PropTypes.bool,
	  onMonthChange: _react.PropTypes.func,
	  prevMonth: _react.PropTypes.bool
	} : void 0;
	exports.default = CalendarToolbar;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _YearButton = __webpack_require__(1022);
	
	var _YearButton2 = _interopRequireDefault(_YearButton);
	
	var _dateUtils = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarYear = function (_Component) {
	  (0, _inherits3.default)(CalendarYear, _Component);
	
	  function CalendarYear() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarYear);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarYear.__proto__ || (0, _getPrototypeOf2.default)(CalendarYear)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapYear = function (event, year) {
	      if (_this.props.onTouchTapYear) {
	        _this.props.onTouchTapYear(event, year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarYear, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'getYears',
	    value: function getYears() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          selectedDate = _props.selectedDate;
	
	
	      var minYear = minDate.getFullYear();
	      var maxYear = maxDate.getFullYear();
	      var years = [];
	      var dateCheck = (0, _dateUtils.cloneDate)(selectedDate);
	
	      for (var year = minYear; year <= maxYear; year++) {
	        dateCheck.setFullYear(year);
	        var selected = selectedDate.getFullYear() === year;
	        var selectedProps = {};
	        if (selected) {
	          selectedProps.ref = 'selectedYearButton';
	        }
	
	        var yearFormated = new DateTimeFormat(locale, {
	          year: 'numeric'
	        }).format(dateCheck);
	
	        var yearButton = _react2.default.createElement(
	          _YearButton2.default,
	          (0, _extends3.default)({
	            key: 'yb' + year,
	            onTouchTap: this.handleTouchTapYear,
	            selected: selected,
	            year: year
	          }, selectedProps),
	          yearFormated
	        );
	
	        years.push(yearButton);
	      }
	
	      return years;
	    }
	  }, {
	    key: 'scrollToSelectedYear',
	    value: function scrollToSelectedYear() {
	      if (this.refs.selectedYearButton === undefined) {
	        return;
	      }
	
	      var container = _reactDom2.default.findDOMNode(this);
	      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);
	
	      var containerHeight = container.clientHeight;
	      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	      container.scrollTop = scrollYOffset;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          calendarYearBackgroundColor = _context$muiTheme.datePicker.calendarYearBackgroundColor;
	
	
	      var styles = {
	        root: {
	          backgroundColor: calendarYearBackgroundColor,
	          height: 'inherit',
	          lineHeight: '35px',
	          overflowX: 'hidden',
	          overflowY: 'scroll',
	          position: 'relative'
	        },
	        child: {
	          display: 'flex',
	          flexDirection: 'column',
	          justifyContent: 'center',
	          minHeight: '100%'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.child) },
	          this.getYears()
	        )
	      );
	    }
	  }]);
	  return CalendarYear;
	}(_react.Component);
	
	CalendarYear.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CalendarYear.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object.isRequired,
	  minDate: _react.PropTypes.object.isRequired,
	  onTouchTapYear: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  wordings: _react.PropTypes.object
	} : void 0;
	exports.default = CalendarYear;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _SlideIn = __webpack_require__(225);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var datePicker = context.muiTheme.datePicker;
	  var selectedYear = state.selectedYear;
	
	  var isLandscape = props.mode === 'landscape';
	
	  var styles = {
	    root: {
	      width: isLandscape ? 165 : '100%',
	      height: isLandscape ? 330 : 'auto',
	      float: isLandscape ? 'left' : 'none',
	      fontWeight: 700,
	      display: 'inline-block',
	      backgroundColor: datePicker.selectColor,
	      borderTopLeftRadius: 2,
	      borderTopRightRadius: isLandscape ? 0 : 2,
	      borderBottomLeftRadius: isLandscape ? 2 : 0,
	      color: datePicker.textColor,
	      padding: 20,
	      boxSizing: 'border-box'
	    },
	    monthDay: {
	      display: 'block',
	      fontSize: 36,
	      lineHeight: '36px',
	      height: props.mode === 'landscape' ? '100%' : 38,
	      opacity: selectedYear ? 0.7 : 1,
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      fontWeight: '500'
	    },
	    monthDayTitle: {
	      cursor: !selectedYear ? 'default' : 'pointer',
	      width: '100%',
	      display: 'block'
	    },
	    year: {
	      margin: 0,
	      fontSize: 16,
	      fontWeight: '500',
	      lineHeight: '16px',
	      height: 16,
	      opacity: selectedYear ? 1 : 0.7,
	      transition: _transitions2.default.easeOut(),
	      marginBottom: 10
	    },
	    yearTitle: {
	      cursor: props.disableYearSelection ? 'not-allowed' : !selectedYear ? 'pointer' : 'default'
	    }
	  };
	
	  return styles;
	}
	
	var DateDisplay = function (_Component) {
	  (0, _inherits3.default)(DateDisplay, _Component);
	
	  function DateDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DateDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDisplay.__proto__ || (0, _getPrototypeOf2.default)(DateDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedYear: false,
	      transitionDirection: 'up'
	    }, _this.handleTouchTapMonthDay = function () {
	      if (_this.props.onTouchTapMonthDay && _this.state.selectedYear) {
	        _this.props.onTouchTapMonthDay();
	      }
	
	      _this.setState({ selectedYear: false });
	    }, _this.handleTouchTapYear = function () {
	      if (_this.props.onTouchTapYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
	        _this.props.onTouchTapYear();
	      }
	
	      if (!_this.props.disableYearSelection) {
	        _this.setState({ selectedYear: true });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DateDisplay, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.monthDaySelected) {
	        this.setState({ selectedYear: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedDate !== this.props.selectedDate) {
	        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	
	      if (nextProps.monthDaySelected !== undefined) {
	        this.setState({
	          selectedYear: !nextProps.monthDaySelected
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          disableYearSelection = _props.disableYearSelection,
	          locale = _props.locale,
	          mode = _props.mode,
	          monthDaySelected = _props.monthDaySelected,
	          onTouchTapMonthDay = _props.onTouchTapMonthDay,
	          onTouchTapYear = _props.onTouchTapYear,
	          selectedDate = _props.selectedDate,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onTouchTapMonthDay', 'onTouchTapYear', 'selectedDate', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var year = new DateTimeFormat(locale, {
	        year: 'numeric'
	      }).format(selectedDate);
	
	      var dateTime = new DateTimeFormat(locale, {
	        month: 'short',
	        weekday: 'short',
	        day: '2-digit'
	      }).format(selectedDate);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root, style) }),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.year, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            { key: year, style: styles.yearTitle, onTouchTap: this.handleTouchTapYear },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.monthDay, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            {
	              key: dateTime,
	              onTouchTap: this.handleTouchTapMonthDay,
	              style: styles.monthDayTitle
	            },
	            dateTime
	          )
	        )
	      );
	    }
	  }]);
	  return DateDisplay;
	}(_react.Component);
	
	DateDisplay.defaultProps = {
	  disableYearSelection: false,
	  monthDaySelected: true
	};
	DateDisplay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DateDisplay.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  disableYearSelection: _react.PropTypes.bool,
	  locale: _react.PropTypes.string.isRequired,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  monthDaySelected: _react.PropTypes.bool,
	  onTouchTapMonthDay: _react.PropTypes.func,
	  onTouchTapYear: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = DateDisplay;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(57);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Calendar = __webpack_require__(1014);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Dialog = __webpack_require__(214);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Popover = __webpack_require__(89);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(218);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _dateUtils = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerDialog = function (_Component) {
	  (0, _inherits3.default)(DatePickerDialog, _Component);
	
	  function DatePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(DatePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.show = function () {
	      if (_this.props.onShow && !_this.state.open) {
	        _this.props.onShow();
	      }
	
	      _this.setState({
	        open: true
	      });
	    }, _this.dismiss = function () {
	      if (_this.props.onDismiss && _this.state.open) {
	        _this.props.onDismiss();
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleTouchTapDay = function () {
	      if (_this.props.autoOk) {
	        setTimeout(_this.handleTouchTapOk, 300);
	      }
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOk = function () {
	      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
	        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleWindowKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOk();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePickerDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          container = _props.container,
	          containerStyle = _props.containerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          initialDate = _props.initialDate,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onAccept = _props.onAccept,
	          onDismiss = _props.onDismiss,
	          onShow = _props.onShow,
	          shouldDisableDate = _props.shouldDisableDate,
	          style = _props.style,
	          animation = _props.animation,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'shouldDisableDate', 'style', 'animation']);
	      var open = this.state.open;
	
	
	      var styles = {
	        dialogContent: {
	          width: mode === 'landscape' ? 479 : 310
	        },
	        dialogBodyContent: {
	          padding: 0,
	          minHeight: mode === 'landscape' ? 330 : 434,
	          minWidth: mode === 'landscape' ? 479 : 310
	        }
	      };
	
	      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'root' }),
	        _react2.default.createElement(
	          Container,
	          {
	            anchorEl: this.refs.root // For Popover
	            , animation: animation || _PopoverAnimationVertical2.default // For Popover
	            , bodyStyle: styles.dialogBodyContent,
	            contentStyle: styles.dialogContent,
	            ref: 'dialog',
	            repositionOnUpdate: true,
	            open: open,
	            onRequestClose: this.handleRequestClose,
	            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
	          },
	          _react2.default.createElement(_reactEventListener2.default, {
	            target: 'window',
	            onKeyUp: this.handleWindowKeyUp
	          }),
	          _react2.default.createElement(_Calendar2.default, {
	            autoOk: autoOk,
	            DateTimeFormat: DateTimeFormat,
	            cancelLabel: cancelLabel,
	            disableYearSelection: disableYearSelection,
	            firstDayOfWeek: firstDayOfWeek,
	            initialDate: initialDate,
	            locale: locale,
	            onTouchTapDay: this.handleTouchTapDay,
	            maxDate: maxDate,
	            minDate: minDate,
	            mode: mode,
	            open: open,
	            ref: 'calendar',
	            onTouchTapCancel: this.handleTouchTapCancel,
	            onTouchTapOk: this.handleTouchTapOk,
	            okLabel: okLabel,
	            shouldDisableDate: shouldDisableDate
	          })
	        )
	      );
	    }
	  }]);
	  return DatePickerDialog;
	}(_react.Component);
	
	DatePickerDialog.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  cancelLabel: 'Cancel',
	  container: 'dialog',
	  locale: 'en-US',
	  okLabel: 'OK'
	};
	DatePickerDialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DatePickerDialog.propTypes = {
	  DateTimeFormat: _react.PropTypes.func,
	  animation: _react.PropTypes.func,
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  container: _react.PropTypes.oneOf(['dialog', 'inline']),
	  containerStyle: _react.PropTypes.object,
	  disableYearSelection: _react.PropTypes.bool,
	  firstDayOfWeek: _react.PropTypes.number,
	  initialDate: _react.PropTypes.object,
	  locale: _react.PropTypes.string,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  okLabel: _react.PropTypes.node,
	  onAccept: _react.PropTypes.func,
	  onDismiss: _react.PropTypes.func,
	  onShow: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  shouldDisableDate: _react.PropTypes.func,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = DatePickerDialog;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _dateUtils = __webpack_require__(88);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var date = props.date,
	      disabled = props.disabled,
	      selected = props.selected;
	  var hover = state.hover;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	
	
	  var labelColor = baseTheme.palette.textColor;
	  var buttonStateOpacity = 0;
	  var buttonStateTransform = 'scale(0)';
	
	  if (hover || selected) {
	    labelColor = datePicker.selectTextColor;
	    buttonStateOpacity = selected ? 1 : 0.6;
	    buttonStateTransform = 'scale(1)';
	  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
	    labelColor = datePicker.color;
	  }
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      fontWeight: '400',
	      opacity: disabled && '0.4',
	      padding: '4px 0px',
	      position: 'relative',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      width: 42
	    },
	    label: {
	      color: labelColor,
	      fontWeight: '400',
	      position: 'relative'
	    },
	    buttonState: {
	      backgroundColor: datePicker.selectColor,
	      borderRadius: '50%',
	      height: 34,
	      left: 4,
	      opacity: buttonStateOpacity,
	      position: 'absolute',
	      top: 0,
	      transform: buttonStateTransform,
	      transition: _transitions2.default.easeOut(),
	      width: 34
	    }
	  };
	}
	
	var DayButton = function (_Component) {
	  (0, _inherits3.default)(DayButton, _Component);
	
	  function DayButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DayButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DayButton.__proto__ || (0, _getPrototypeOf2.default)(DayButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this.handleMouseLeave = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (!_this.props.disabled && _this.props.onTouchTap) {
	        _this.props.onTouchTap(event, _this.props.date);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          date = _props.date,
	          disabled = _props.disabled,
	          locale = _props.locale,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'date', 'disabled', 'locale', 'onTouchTap', 'selected']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return date ? _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          new DateTimeFormat(locale, {
	            day: 'numeric'
	          }).format(date)
	        )
	      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
	    }
	  }]);
	  return DayButton;
	}(_react.Component);
	
	DayButton.defaultProps = {
	  selected: false,
	  disabled: false
	};
	DayButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DayButton.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  date: _react.PropTypes.object,
	  disabled: _react.PropTypes.bool,
	  locale: _react.PropTypes.string.isRequired,
	  onKeyboardFocus: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  selected: _react.PropTypes.bool
	} : void 0;
	exports.default = DayButton;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var selected = props.selected,
	      year = props.year;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	  var hover = state.hover;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      color: year === new Date().getFullYear() && datePicker.color,
	      display: 'block',
	      fontSize: 14,
	      margin: '0 auto',
	      position: 'relative',
	      textAlign: 'center',
	      lineHeight: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    label: {
	      alignSelf: 'center',
	      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
	      fontSize: selected ? 26 : 17,
	      fontWeight: hover ? 450 : selected ? 500 : 400,
	      position: 'relative',
	      top: -1
	    }
	  };
	}
	
	var YearButton = function (_Component) {
	  (0, _inherits3.default)(YearButton, _Component);
	
	  function YearButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, YearButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = YearButton.__proto__ || (0, _getPrototypeOf2.default)(YearButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hover: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hover: false });
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event, _this.props.year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(YearButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          year = _props.year,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onTouchTap', 'selected', 'year']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          children
	        )
	      );
	    }
	  }]);
	  return YearButton;
	}(_react.Component);
	
	YearButton.defaultProps = {
	  selected: false
	};
	YearButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? YearButton.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  onTouchTap: _react.PropTypes.func,
	  selected: _react.PropTypes.bool,
	  year: _react.PropTypes.number.isRequired
	} : void 0;
	exports.default = YearButton;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DatePicker = __webpack_require__(213);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DatePicker2.default;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(57);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(373);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(374);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactAddonsTransitionGroup = __webpack_require__(116);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransitionItem = function (_Component) {
	  (0, _inherits3.default)(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate(0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TransitionItem.propTypes = {
	  children: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent,
	      open = props.open;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      spacing = _context$muiTheme$bas.spacing,
	      palette = _context$muiTheme$bas.palette,
	      dialog = _context$muiTheme.dialog,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0,
	      borderTop: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0,
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  (0, _inherits3.default)(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    (0, _classCallCheck3.default)(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
	  }
	
	  (0, _createClass3.default)(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
	          autoScrollBodyContent = _props2.autoScrollBodyContent,
	          bodyStyle = _props2.bodyStyle,
	          open = _props2.open,
	          repositionOnUpdate = _props2.repositionOnUpdate,
	          title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          actionsContainerClassName = _props3.actionsContainerClassName,
	          actionsContainerStyle = _props3.actionsContainerStyle,
	          bodyClassName = _props3.bodyClassName,
	          bodyStyle = _props3.bodyStyle,
	          children = _props3.children,
	          className = _props3.className,
	          contentClassName = _props3.contentClassName,
	          contentStyle = _props3.contentStyle,
	          overlayClassName = _props3.overlayClassName,
	          overlayStyle = _props3.overlayStyle,
	          open = _props3.open,
	          titleClassName = _props3.titleClassName,
	          titleStyle = _props3.titleStyle,
	          title = _props3.title,
	          style = _props3.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { zDepth: 4 },
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onTouchTap: this.handleTouchTapOverlay
	        })
	      );
	    }
	  }]);
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DialogInline.propTypes = {
	  actions: _react.PropTypes.node,
	  actionsContainerClassName: _react.PropTypes.string,
	  actionsContainerStyle: _react.PropTypes.object,
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  autoScrollBodyContent: _react.PropTypes.bool,
	  bodyClassName: _react.PropTypes.string,
	  bodyStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  contentClassName: _react.PropTypes.string,
	  contentStyle: _react.PropTypes.object,
	  modal: _react.PropTypes.bool,
	  onRequestClose: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  overlayClassName: _react.PropTypes.string,
	  overlayStyle: _react.PropTypes.object,
	  repositionOnUpdate: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  title: _react.PropTypes.node,
	  titleClassName: _react.PropTypes.string,
	  titleStyle: _react.PropTypes.object
	} : void 0;
	
	var Dialog = function (_Component3) {
	  (0, _inherits3.default)(Dialog, _Component3);
	
	  function Dialog() {
	    var _ref3;
	
	    var _temp3, _this3, _ret3;
	
	    (0, _classCallCheck3.default)(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
	  }
	
	  (0, _createClass3.default)(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	  return Dialog;
	}(_react.Component);
	
	Dialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	 false ? Dialog.propTypes = {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _react.PropTypes.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _react.PropTypes.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _react.PropTypes.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _react.PropTypes.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = Dialog;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      prepareStyles = _context$muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	
	 false ? Divider.propTypes = {
	  /**
	   * If true, the `Divider` will be indented.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	Divider.defaultProps = {
	  inset: false
	};
	
	Divider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = Divider;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(57);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _autoPrefix = __webpack_require__(73);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(373);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openNavEventHandler = null;
	
	var Drawer = function (_Component) {
	  (0, _inherits3.default)(Drawer, _Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapOverlay = function (event) {
	      event.preventDefault();
	      _this.close('clickaway');
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
	        _this.close('escape');
	      }
	    }, _this.onBodyTouchStart = function (event) {
	      var swipeAreaWidth = _this.props.swipeAreaWidth;
	
	      var touchStartX = event.touches[0].pageX;
	      var touchStartY = event.touches[0].pageY;
	
	      // Open only if swiping from far left (or right) while closed
	      if (swipeAreaWidth !== null && !_this.state.open) {
	        if (_this.props.openSecondary) {
	          // If openSecondary is true calculate from the far right
	          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
	        } else {
	          // If openSecondary is false calculate from the far left
	          if (touchStartX > swipeAreaWidth) return;
	        }
	      }
	
	      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
	        return;
	      }
	
	      _this.maybeSwiping = true;
	      _this.touchStartX = touchStartX;
	      _this.touchStartY = touchStartY;
	
	      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _this.onBodyTouchMove = function (event) {
	      var currentX = event.touches[0].pageX;
	      var currentY = event.touches[0].pageY;
	
	      if (_this.state.swiping) {
	        event.preventDefault();
	        _this.setPosition(_this.getTranslateX(currentX));
	      } else if (_this.maybeSwiping) {
	        var dXAbs = Math.abs(currentX - _this.touchStartX);
	        var dYAbs = Math.abs(currentY - _this.touchStartY);
	        // If the user has moved his thumb ten pixels in either direction,
	        // we can safely make an assumption about whether he was intending
	        // to swipe or scroll.
	        var threshold = 10;
	
	        if (dXAbs > threshold && dYAbs <= threshold) {
	          _this.swipeStartX = currentX;
	          _this.setState({
	            swiping: _this.state.open ? 'closing' : 'opening'
	          });
	          _this.setPosition(_this.getTranslateX(currentX));
	        } else if (dXAbs <= threshold && dYAbs > threshold) {
	          _this.onBodyTouchEnd();
	        }
	      }
	    }, _this.onBodyTouchEnd = function (event) {
	      if (_this.state.swiping) {
	        var currentX = event.changedTouches[0].pageX;
	        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();
	
	        _this.maybeSwiping = false;
	        var swiping = _this.state.swiping;
	        _this.setState({
	          swiping: null
	        });
	
	        // We have to open or close after setting swiping to null,
	        // because only then CSS transition is enabled.
	        if (translateRatio > 0.5) {
	          if (swiping === 'opening') {
	            _this.setPosition(_this.getMaxTranslateX());
	          } else {
	            _this.close('swipe');
	          }
	        } else {
	          if (swiping === 'opening') {
	            _this.open('swipe');
	          } else {
	            _this.setPosition(0);
	          }
	        }
	      } else {
	        _this.maybeSwiping = false;
	      }
	
	      document.body.removeEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.removeEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.removeEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.maybeSwiping = false;
	      this.touchStartX = null;
	      this.touchStartY = null;
	      this.swipeStartX = null;
	
	      this.setState({
	        open: this.props.open !== null ? this.props.open : this.props.docked,
	        swiping: null
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If controlled then the open prop takes precedence.
	      if (nextProps.open !== null) {
	        this.setState({
	          open: nextProps.open
	        });
	        // Otherwise, if docked is changed, change the open state for when uncontrolled.
	      } else if (this.props.docked !== nextProps.docked) {
	        this.setState({
	          open: nextProps.docked
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disableSwipeHandling();
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var muiTheme = this.context.muiTheme;
	      var theme = muiTheme.drawer;
	
	      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());
	
	      var styles = {
	        root: {
	          height: '100%',
	          width: this.props.width || theme.width,
	          position: 'fixed',
	          zIndex: muiTheme.zIndex.drawer,
	          left: 0,
	          top: 0,
	          transform: 'translate(' + x + 'px, 0)',
	          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
	          backgroundColor: theme.color,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch' },
	        overlay: {
	          zIndex: muiTheme.zIndex.drawerOverlay,
	          pointerEvents: this.state.open ? 'auto' : 'none' },
	        rootWhenOpenRight: {
	          left: 'auto',
	          right: 0
	        }
	      };
	
	      return styles;
	    }
	  }, {
	    key: 'shouldShow',
	    value: function shouldShow() {
	      return this.state.open || !!this.state.swiping; // component is swiping
	    }
	  }, {
	    key: 'close',
	    value: function close(reason) {
	      if (this.props.open === null) this.setState({ open: false });
	      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
	      return this;
	    }
	  }, {
	    key: 'open',
	    value: function open(reason) {
	      if (this.props.open === null) this.setState({ open: true });
	      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
	      return this;
	    }
	  }, {
	    key: 'getMaxTranslateX',
	    value: function getMaxTranslateX() {
	      var width = this.props.width || this.context.muiTheme.drawer.width;
	      return width + 10;
	    }
	  }, {
	    key: 'getTranslateMultiplier',
	    value: function getTranslateMultiplier() {
	      return this.props.openSecondary ? 1 : -1;
	    }
	  }, {
	    key: 'enableSwipeHandling',
	    value: function enableSwipeHandling() {
	      if (!this.props.docked) {
	        document.body.addEventListener('touchstart', this.onBodyTouchStart);
	        if (!openNavEventHandler) {
	          openNavEventHandler = this.onBodyTouchStart;
	        }
	      } else {
	        this.disableSwipeHandling();
	      }
	    }
	  }, {
	    key: 'disableSwipeHandling',
	    value: function disableSwipeHandling() {
	      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
	      if (openNavEventHandler === this.onBodyTouchStart) {
	        openNavEventHandler = null;
	      }
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(translateX) {
	      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	      var transformCSS = 'translate(' + this.getTranslateMultiplier() * translateX + 'px, 0)';
	      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
	      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
	    }
	  }, {
	    key: 'getTranslateX',
	    value: function getTranslateX(currentX) {
	      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          containerClassName = _props.containerClassName,
	          containerStyle = _props.containerStyle,
	          docked = _props.docked,
	          openSecondary = _props.openSecondary,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = this.getStyles();
	
	      var overlay = void 0;
	      if (!docked) {
	        overlay = _react2.default.createElement(_Overlay2.default, {
	          ref: 'overlay',
	          show: this.shouldShow(),
	          className: overlayClassName,
	          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
	          transitionEnabled: !this.state.swiping,
	          onTouchTap: this.handleTouchTapOverlay
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: style
	        },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        overlay,
	        _react2.default.createElement(
	          _Paper2.default,
	          {
	            ref: 'clickAwayableElement',
	            zDepth: zDepth,
	            rounded: false,
	            transitionEnabled: !this.state.swiping,
	            className: containerClassName,
	            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return Drawer;
	}(_react.Component);
	
	Drawer.defaultProps = {
	  disableSwipeToOpen: false,
	  docked: true,
	  open: null,
	  openSecondary: false,
	  swipeAreaWidth: 30,
	  width: null,
	  zDepth: 2
	};
	Drawer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Drawer.propTypes = {
	  /**
	   * The contents of the `Drawer`
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The CSS class name of the container element.
	   */
	  containerClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If true, swiping sideways when the `Drawer` is closed will not open it.
	   */
	  disableSwipeToOpen: _react.PropTypes.bool,
	  /**
	   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
	   * clicking on a menu item will not close the `Drawer`.
	   */
	  docked: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
	   *
	   * @param {boolean} open If true, the `Drawer` was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
	   * 'escape' (on escape key press), and 'swipe' for close requests.
	   */
	  onRequestChange: _react.PropTypes.func,
	  /**
	   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
	   * into a controlled component.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * If true, the `Drawer` is positioned to open from the opposite side.
	   */
	  openSecondary: _react.PropTypes.bool,
	  /**
	   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The width of the left most (or right most) area in pixels where the `Drawer` can be
	   * swiped open from. Setting this to `null` spans that area to the entire page
	   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
	   * swipeable `Tabs`: use at your own risk).
	   */
	  swipeAreaWidth: _react.PropTypes.number,
	  /**
	   * The width of the `Drawer` in pixels. Defaults to using the values from theme.
	   */
	  width: _react.PropTypes.number,
	  /**
	   * The zDepth of the `Drawer`.
	   */
	  zDepth: _propTypes2.default.zDepth
	
	} : void 0;
	exports.default = Drawer;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Drawer = __webpack_require__(1026);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer2.default;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(1103);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(141);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(1090);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(89);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(218);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _events = __webpack_require__(145);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _IconButton = __webpack_require__(45);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var anchorOrigin = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
	    },
	    iconChildren: {
	      fill: 'inherit'
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      overflow: 'hidden',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
	      textOverflow: 'ellipsis',
	      top: 0,
	      whiteSpace: 'nowrap'
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  (0, _inherits3.default)(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.rootNode
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.close(false);
	    }, _this.handleEscKeyDownMenu = function () {
	      _this.close(true);
	    }, _this.handleKeyDown = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'up':
	        case 'down':
	        case 'space':
	        case 'enter':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            anchorEl: _this.rootNode
	          });
	          break;
	      }
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      event.persist();
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onChange) {
	          _this.props.onChange(event, index, child.props.value);
	        }
	
	        _this.close(_events2.default.isKeyboard(event));
	      });
	    }, _this.close = function (isKeyboard) {
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	
	        if (isKeyboard) {
	          var dropArrow = _this.arrowNode;
	          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
	          dropNode.focus();
	          dropArrow.setKeyboardFocus(true);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  (0, _createClass3.default)(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.rootNode
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'getInputNode',
	
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var rootNode = this.rootNode;
	
	      rootNode.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.rootNode
	          });
	        }
	      };
	
	      return rootNode;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.rootNode;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          animation = _props.animation,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          className = _props.className,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProp = _props.menuStyle,
	          onClose = _props.onClose,
	          openImmediately = _props.openImmediately,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'children', 'className', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value']);
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      _react2.default.Children.forEach(children, function (child) {
	        if (child && value === child.props.value) {
	          // This will need to be improved (in case primaryText is a node)
	          displayValue = child.props.label || child.props.primaryText;
	        }
	      });
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onTouchTap: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
	            displayValue
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              tabIndex: this.props.disabled ? -1 : undefined,
	              onKeyDown: this.handleKeyDown,
	              ref: function ref(node) {
	                _this4.arrowNode = node;
	              },
	              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
	              iconStyle: styles.iconChildren
	            },
	            _react2.default.createElement(_arrowDropDown2.default, null)
	          ),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              onEscKeyDown: this.handleEscKeyDownMenu,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap,
	              menuItemStyle: menuItemStyle,
	              selectedMenuItemStyle: selectedMenuItemStyle
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  openImmediately: false,
	  maxHeight: 500
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DropDownMenu.propTypes = {
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} payload The `value` prop of the clicked menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _react.PropTypes.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value that is currently selected.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = DropDownMenu;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _childUtils = __webpack_require__(111);
	
	var _colorManipulator = __webpack_require__(55);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(1030);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  (0, _inherits3.default)(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          disabled = _props.disabled,
	          hoverColor = _props.hoverColor,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'disabled', 'hoverColor', 'backgroundColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	      var _context$muiTheme = this.context.muiTheme,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: 2,
	        userSelect: 'none',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.defaultProps = {
	  disabled: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FlatButton.propTypes = {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _react.PropTypes.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FlatButton;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  (0, _inherits3.default)(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    (0, _classCallCheck3.default)(this, FlatButtonLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FlatButtonLabel.propTypes = {
	  label: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FlatButtonLabel;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(55);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(139);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _childUtils = __webpack_require__(111);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var floatingActionButton = context.muiTheme.floatingActionButton;
	
	
	  var backgroundColor = props.backgroundColor || floatingActionButton.color;
	  var iconColor = floatingActionButton.iconColor;
	
	  if (props.disabled) {
	    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
	    iconColor = floatingActionButton.disabledTextColor;
	  } else if (props.secondary) {
	    backgroundColor = floatingActionButton.secondaryColor;
	    iconColor = floatingActionButton.secondaryIconColor;
	  }
	
	  return {
	    root: {
	      transition: _transitions2.default.easeOut(),
	      display: 'inline-block',
	      backgroundColor: 'transparent'
	    },
	    container: {
	      backgroundColor: backgroundColor,
	      transition: _transitions2.default.easeOut(),
	      height: floatingActionButton.buttonSize,
	      width: floatingActionButton.buttonSize,
	      padding: 0,
	      overflow: 'hidden',
	      borderRadius: '50%',
	      textAlign: 'center',
	      verticalAlign: 'bottom'
	    },
	    containerWhenMini: {
	      height: floatingActionButton.miniSize,
	      width: floatingActionButton.miniSize
	    },
	    overlay: {
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    overlayWhenHovered: {
	      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
	    },
	    icon: {
	      height: floatingActionButton.buttonSize,
	      lineHeight: floatingActionButton.buttonSize + 'px',
	      fill: iconColor,
	      color: iconColor
	    },
	    iconWhenMini: {
	      height: floatingActionButton.miniSize,
	      lineHeight: floatingActionButton.miniSize + 'px'
	    }
	  };
	}
	
	var FloatingActionButton = function (_Component) {
	  (0, _inherits3.default)(FloatingActionButton, _Component);
	
	  function FloatingActionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FloatingActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touch: false,
	      zDepth: undefined
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	      }
	      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.container.isKeyboardFocused()) {
	        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth + 1
	      });
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth
	      });
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
	      } else if (!_this.state.hovered) {
	        _this.setState({ zDepth: _this.props.zDepth });
	        _this.refs.overlay.style.backgroundColor = 'transparent';
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FloatingActionButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        zDepth: this.props.disabled ? 0 : this.props.zDepth
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextState = {};
	
	      if (nextProps.disabled !== this.props.disabled) {
	        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
	      }
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          className = _props.className,
	          childrenProp = _props.children,
	          disabled = _props.disabled,
	          mini = _props.mini,
	          secondary = _props.secondary,
	          iconStyle = _props.iconStyle,
	          iconClassName = _props.iconClassName,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (iconClassName) {
	        iconElement = _react2.default.createElement(_FontIcon2.default, {
	          className: iconClassName,
	          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	        });
	      }
	
	      var children = void 0;
	
	      if (childrenProp) {
	        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
	          return {
	            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
	          };
	        });
	      }
	
	      var buttonEventHandlers = disabled ? null : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth,
	          circle: true
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	            focusRippleColor: styles.icon.color,
	            touchRippleColor: styles.icon.color
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
	            },
	            iconElement,
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return FloatingActionButton;
	}(_react.Component);
	
	FloatingActionButton.defaultProps = {
	  disabled: false,
	  mini: false,
	  secondary: false,
	  zDepth: 2
	};
	FloatingActionButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FloatingActionButton.propTypes = {
	  /**
	   * This value will override the default background color for the button.
	   * However it will not override the default disabled background color.
	   * This has to be set separately using the disabledColor attribute.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what displayed inside the floating action button; for example, a SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * This value will override the default background color for the button when it is disabled.
	   */
	  disabledColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The icon within the FloatingActionButton is a FontIcon component.
	   * This property is the classname of the icon to be displayed inside the button.
	   * An alternative to adding an iconClassName would be to manually insert a
	   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * This is the equivalent to iconClassName except that it is used for
	   * overriding the inline-styles of the FontIcon component.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will be a small floating action button.
	   */
	  mini: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, the button will use the secondary button colors.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The zDepth of the underlying `Paper` component.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = FloatingActionButton;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FloatingActionButton = __webpack_require__(1031);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FloatingActionButton2.default;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var color = props.color,
	      hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  (0, _inherits3.default)(FontIcon, _Component);
	
	  function FontIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hoverColor = _props.hoverColor,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FontIcon.propTypes = {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FontIcon;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    root: {
	      display: 'flex',
	      flexWrap: 'wrap',
	      margin: -props.padding / 2
	    },
	    item: {
	      boxSizing: 'border-box',
	      padding: props.padding / 2
	    }
	  };
	}
	
	var GridList = function (_Component) {
	  (0, _inherits3.default)(GridList, _Component);
	
	  function GridList() {
	    (0, _classCallCheck3.default)(this, GridList);
	    return (0, _possibleConstructorReturn3.default)(this, (GridList.__proto__ || (0, _getPrototypeOf2.default)(GridList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cols = _props.cols,
	          padding = _props.padding,
	          cellHeight = _props.cellHeight,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (_react2.default.isValidElement(currentChild) && currentChild.type.muiName === 'Subheader') {
	          return currentChild;
	        }
	        var childCols = currentChild.props.cols || 1;
	        var childRows = currentChild.props.rows || 1;
	        var itemStyle = (0, _simpleAssign2.default)({}, styles.item, {
	          width: 100 / cols * childCols + '%',
	          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + padding
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { style: prepareStyles(itemStyle) },
	          currentChild
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles(mergedRootStyles) }, other),
	        wrappedChildren
	      );
	    }
	  }]);
	  return GridList;
	}(_react.Component);
	
	GridList.defaultProps = {
	  cols: 2,
	  padding: 4,
	  cellHeight: 180
	};
	GridList.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Number of columns.
	   */
	  cols: _react.PropTypes.number,
	  /**
	   * Number of px for the padding/spacing between items.
	   */
	  padding: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = GridList;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GridTile = exports.GridList = undefined;
	
	var _GridList2 = __webpack_require__(1034);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(357);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.default = _GridList3.default;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(139);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(375);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'not-allowed'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  (0, _inherits3.default)(IconButton, _Component);
	
	  function IconButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      // Not to be confonded with the touch property.
	      // This state is to determined if it's a mobile device.
	      touch: false,
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.button.isKeyboardFocused()) {
	        _this.hideTooltip();
	      }
	      _this.setState({ hovered: false });
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus,
	          onBlur = _this$props.onBlur,
	          onKeyboardFocus = _this$props.onKeyboardFocus;
	
	      if (isKeyboardFocused && !disabled) {
	        _this.showTooltip();
	        if (onFocus) {
	          onFocus(event);
	        }
	      } else {
	        _this.hideTooltip();
	        if (onBlur) {
	          onBlur(event);
	        }
	      }
	
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      if (onKeyboardFocus) {
	        onKeyboardFocus(event, isKeyboardFocused);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({ hovered: false });
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          hoveredStyle = _props.hoveredStyle,
	          disableTouchRipple = _props.disableTouchRipple,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipPositionProp = _props.tooltipPosition,
	          tooltipStyles = _props.tooltipStyles,
	          touch = _props.touch,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor,
	            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);
	
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          ref: function ref(_ref2) {
	            return _this2.button = _ref2;
	          }
	        }, other, {
	          centerRipple: true,
	          disabled: disabled,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? IconButton.propTypes = {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _react.PropTypes.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when the component is hovered.
	   */
	  hoveredStyle: _react.PropTypes.object,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the icon element.
	   * Note: you can specify iconHoverColor as a String inside this object.
	   */
	  iconStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseOut: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _react.PropTypes.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes2.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _react.PropTypes.object,
	  /**
	   * If true, increase the tooltip element's size. Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _react.PropTypes.bool
	} : void 0;
	exports.default = IconButton;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(145);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Menu = __webpack_require__(141);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Popover = __webpack_require__(89);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function (_Component) {
	  (0, _inherits3.default)(IconMenu, _Component);
	
	  function IconMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    }, _this.handleItemTouchTap = function (event, child) {
	      if (_this.props.touchTapCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
	        (function () {
	          var isKeyboard = _events2.default.isKeyboard(event);
	          _this.timerCloseId = setTimeout(function () {
	            _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	          }, _this.props.touchTapCloseDelay);
	        })();
	      }
	
	      _this.props.onItemTouchTap(event, child);
	    }, _this.handleRequestClose = function (reason) {
	      _this.close(reason);
	    }, _this.handleEscKeyDownMenu = function (event) {
	      _this.close('escape', event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open != null) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: this.refs.iconMenuContainer
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerCloseId);
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.state.open;
	    }
	  }, {
	    key: 'close',
	    value: function close(reason, isKeyboard) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        return;
	      }
	
	      if (this.props.open !== null) {
	        this.props.onRequestChange(false, reason);
	      } else {
	        this.setState({ open: false }, function () {
	          // Set focus on the icon button when the menu close
	          if (isKeyboard) {
	            var iconButton = _this2.refs.iconButton;
	            _reactDom2.default.findDOMNode(iconButton).focus();
	            iconButton.setKeyboardFocus();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(reason, event) {
	      if (this.props.open !== null) {
	        this.props.onRequestChange(true, reason);
	
	        return this.setState({
	          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	          anchorEl: event.currentTarget
	        });
	      }
	
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	
	      event.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          className = _props.className,
	          animated = _props.animated,
	          animation = _props.animation,
	          iconButtonElement = _props.iconButtonElement,
	          iconStyle = _props.iconStyle,
	          onItemTouchTap = _props.onItemTouchTap,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseUp = _props.onMouseUp,
	          onRequestChange = _props.onRequestChange,
	          onTouchTap = _props.onTouchTap,
	          listStyle = _props.listStyle,
	          menuStyle = _props.menuStyle,
	          style = _props.style,
	          targetOrigin = _props.targetOrigin,
	          touchTapCloseDelay = _props.touchTapCloseDelay,
	          useLayerForClickAway = _props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onTouchTap', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'touchTapCloseDelay', 'useLayerForClickAway']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl;
	
	
	      var styles = {
	        root: {
	          display: 'inline-block',
	          position: 'relative'
	        },
	        menu: {
	          position: 'relative'
	        }
	      };
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);
	
	       false ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;
	
	      var iconButtonProps = {
	        onKeyboardFocus: onKeyboardFocus,
	        onTouchTap: function onTouchTap(event) {
	          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
	          if (iconButtonElement.props.onTouchTap) {
	            iconButtonElement.props.onTouchTap(event);
	          }
	        },
	        ref: 'iconButton'
	      };
	      if (iconStyle || iconButtonElement.props.iconStyle) {
	        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
	      }
	      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, other, {
	          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	          onEscKeyDown: this.handleEscKeyDownMenu,
	          onItemTouchTap: this.handleItemTouchTap,
	          style: mergedMenuStyles,
	          listStyle: listStyle
	        }),
	        this.props.children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'iconMenuContainer',
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          onMouseUp: onMouseUp,
	          onTouchTap: onTouchTap,
	          style: prepareStyles(mergedRootStyles)
	        },
	        iconButton,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            childContextTypes: this.constructor.childContextTypes,
	            useLayerForClickAway: useLayerForClickAway,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation,
	            context: this.context
	          },
	          menu
	        )
	      );
	    }
	  }]);
	  return IconMenu;
	}(_react.Component);
	
	IconMenu.muiName = 'IconMenu';
	IconMenu.defaultProps = {
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  animated: true,
	  multiple: false,
	  open: null,
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseUp: function onMouseUp() {},
	  onRequestChange: function onRequestChange() {},
	  onTouchTap: function onTouchTap() {},
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  touchTapCloseDelay: 200,
	  useLayerForClickAway: false
	};
	IconMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? IconMenu.propTypes = {
	  /**
	   * This is the point on the icon where the menu
	   * `targetOrigin` will attach.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * Should be used to pass `MenuItem` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * This is the `IconButton` to render. This button will open the menu.
	   */
	  iconButtonElement: _react.PropTypes.element.isRequired,
	  /**
	   * Override the inline-styles of the underlying icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the menu element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * If true, the value can an be array and allow the menu to be a multi-select.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item is selected with a touch-tap.
	   *
	   * @param {object} event TouchTap event targeting the selected menu item element.
	   * @param {object} child The selected element.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
	   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `open` state of the menu is requested to be changed.
	   *
	   * @param {boolean} open If true, the menu was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
	   * for close requests.
	   */
	  onRequestChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the `IconButton` element.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, the `IconMenu` is opened.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the menu which will stick to the menu
	   * origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * Sets the delay in milliseconds before closing the
	   * menu when an item is clicked.
	   * If set to 0 then the auto close functionality
	   * will be disabled.
	   */
	  touchTapCloseDelay: _react.PropTypes.number,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying elements.
	   */
	  useLayerForClickAway: _react.PropTypes.bool
	} : void 0;
	exports.default = IconMenu;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.IconMenu = undefined;
	
	var _IconMenu2 = __webpack_require__(1037);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _MenuItem2 = __webpack_require__(217);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconMenu = _IconMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _IconMenu3.default;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      height: 4,
	      display: 'block',
	      width: '100%',
	      backgroundColor: palette.primary3Color,
	      borderRadius: 2,
	      margin: 0,
	      overflow: 'hidden'
	    },
	    bar: {
	      height: '100%'
	    },
	    barFragment1: {},
	    barFragment2: {}
	  };
	
	  if (props.mode === 'indeterminate') {
	    styles.barFragment1 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
	    };
	
	    styles.barFragment2 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
	    };
	  } else {
	    styles.bar.backgroundColor = props.color || palette.primary1Color;
	    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
	    styles.bar.width = getRelativeValue(value, min, max) + '%';
	  }
	
	  return styles;
	}
	
	var LinearProgress = function (_Component) {
	  (0, _inherits3.default)(LinearProgress, _Component);
	
	  function LinearProgress() {
	    (0, _classCallCheck3.default)(this, LinearProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LinearProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timers = {};
	
	      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]]);
	
	      this.timers.bar2 = setTimeout(function () {
	        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]]);
	      }, 850);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timers.bar1);
	      clearTimeout(this.timers.bar2);
	    }
	  }, {
	    key: 'barUpdate',
	    value: function barUpdate(id, step, barElement, stepValues) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step = step || 0;
	      step %= 4;
	
	      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
	      var left = this.context.muiTheme.isRtl ? 'right' : 'left';
	
	      if (step === 0) {
	        barElement.style[left] = stepValues[0][0] + '%';
	        barElement.style[right] = stepValues[0][1] + '%';
	      } else if (step === 1) {
	        barElement.style.transitionDuration = '840ms';
	      } else if (step === 2) {
	        barElement.style[left] = stepValues[1][0] + '%';
	        barElement.style[right] = stepValues[1][1] + '%';
	      } else if (step === 3) {
	        barElement.style.transitionDuration = '0ms';
	      }
	      this.timers[id] = setTimeout(function () {
	        return _this3.barUpdate(id, step + 1, barElement, stepValues);
	      }, 420);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.bar) },
	          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
	          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
	        )
	      );
	    }
	  }]);
	  return LinearProgress;
	}(_react.Component);
	
	LinearProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100
	};
	LinearProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? LinearProgress.propTypes = {
	  /**
	   * The color of the progress bar, defaults to
	   * primary color of theme.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate for when
	   * there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = LinearProgress;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinearProgress = __webpack_require__(1039);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinearProgress2.default;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(215);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedList = function NestedList(props) {
	  var children = props.children,
	      open = props.open,
	      nestedLevel = props.nestedLevel,
	      style = props.style;
	
	
	  if (!open) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _List2.default,
	    { style: style },
	    _react.Children.map(children, function (child) {
	      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
	        nestedLevel: nestedLevel + 1
	      }) : child;
	    })
	  );
	};
	
	 false ? NestedList.propTypes = {
	  children: _react.PropTypes.node,
	  nestedLevel: _react.PropTypes.number.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = NestedList;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeSelectable = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(215);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(216);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(358);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.default = _List3.default;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HotKeyHolder = undefined;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  (0, _createClass3.default)(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	  return HotKeyHolder;
	}();

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? '2px' : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Paper.propTypes = {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Set to true to generate a circlular paper container.
	   */
	  circle: _react.PropTypes.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _react.PropTypes.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = Paper;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverAnimationDefault = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationDefault, _Component);
	
	  function PopoverAnimationDefault() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationDefault, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return PopoverAnimationDefault;
	}(_react.Component);
	
	PopoverAnimationDefault.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationDefault.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? PopoverAnimationDefault.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin.isRequired,
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationDefault;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;
	
	var _Popover2 = __webpack_require__(89);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _PopoverAnimationVertical2 = __webpack_require__(218);
	
	var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Popover = _Popover3.default;
	exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
	exports.default = _Popover3.default;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedSwitch = __webpack_require__(223);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _radioButtonUnchecked = __webpack_require__(1114);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _radioButtonChecked = __webpack_require__(1113);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var radioButton = context.muiTheme.radioButton;
	
	
	  return {
	    icon: {
	      height: radioButton.size,
	      width: radioButton.size
	    },
	    target: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(1)',
	      fill: radioButton.borderColor
	    },
	    fill: {
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(0)',
	      transformOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut(),
	      fill: radioButton.checkedColor
	    },
	    targetWhenChecked: {
	      opacity: 0,
	      transform: 'scale(0)'
	    },
	    fillWhenChecked: {
	      opacity: 1,
	      transform: 'scale(1)'
	    },
	    targetWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    fillWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    label: {
	      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
	    },
	    ripple: {
	      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
	    }
	  };
	}
	
	var RadioButton = function (_Component) {
	  (0, _inherits3.default)(RadioButton, _Component);
	
	  function RadioButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitch = function (event) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, _this.props.value);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // Only called when selected, not when unselected.
	
	
	  (0, _createClass3.default)(RadioButton, [{
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	
	    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	    // RadioButton's checked value.
	
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.enhancedSwitch.getValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onCheck = _props.onCheck,
	          uncheckedIcon = _props.uncheckedIcon,
	          disabled = _props.disabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);
	
	      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);
	
	      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });
	
	      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });
	
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, {
	        ref: 'enhancedSwitch',
	        inputType: 'radio',
	        checked: checked,
	        switched: checked,
	        disabled: disabled,
	        rippleColor: styles.ripple.color,
	        iconStyle: mergedIconStyle,
	        labelStyle: mergedLabelStyle,
	        labelPosition: labelPosition,
	        onSwitch: this.handleSwitch,
	        switchElement: _react2.default.createElement(
	          'div',
	          null,
	          uncheckedElement,
	          checkedElement
	        )
	      }));
	    }
	  }]);
	  return RadioButton;
	}(_react.Component);
	
	RadioButton.defaultProps = {
	  checked: false,
	  disabled: false,
	  labelPosition: 'right'
	};
	RadioButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RadioButton.propTypes = {
	  /**
	   * @ignore
	   * checked if true
	   * Used internally by `RadioButtonGroup`.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * The icon element to show when the radio button is checked.
	   */
	  checkedIcon: _react.PropTypes.element,
	  /**
	   * If true, the radio button is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
	   * Where the label will be placed next to the radio button.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Override the inline-styles of the label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Callback function fired when the radio button is checked. Note that this
	   * function will not be called if the radio button is part of a
	   * radio button group: in this case, use the `onChange` property of
	   * `RadioButtonGroup`.
	   *
	   * @param {object} event `change` event targeting the element.
	   * @param {string} value The element's `value`.
	   */
	  onCheck: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The icon element to show when the radio button is unchecked.
	   */
	  uncheckedIcon: _react.PropTypes.element,
	  /**
	   * The value of the radio button.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = RadioButton;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(55);
	
	var _childUtils = __webpack_require__(111);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      raisedButton = _context$muiTheme.raisedButton;
	  var disabled = props.disabled,
	      disabledBackgroundColor = props.disabledBackgroundColor,
	      disabledLabelColor = props.disabledLabelColor,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      label = props.label,
	      labelPosition = props.labelPosition,
	      primary = props.primary,
	      secondary = props.secondary,
	      style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	  var borderRadius = 2;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  (0, _inherits3.default)(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          buttonStyle = _props.buttonStyle,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          disabledBackgroundColor = _props.disabledBackgroundColor,
	          disabledLabelColor = _props.disabledLabelColor,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          label = _props.label,
	          labelColor = _props.labelColor,
	          labelPosition = _props.labelPosition,
	          labelStyle = _props.labelStyle,
	          overlayStyle = _props.overlayStyle,
	          primary = _props.primary,
	          rippleStyle = _props.rippleStyle,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	      });
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RaisedButton.propTypes = {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _react.PropTypes.object,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _react.PropTypes.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _react.PropTypes.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline style of the button overlay.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = RaisedButton;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _slicedToArray2 = __webpack_require__(167);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(73);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEWBOX_SIZE = 32;
	
	function getStyles(props) {
	  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
	  return {
	    root: {
	      position: 'absolute',
	      zIndex: 2,
	      width: props.size,
	      height: props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
	      opacity: props.status === 'hide' ? 0 : 1,
	      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
	    }
	  };
	}
	
	var RefreshIndicator = function (_Component) {
	  (0, _inherits3.default)(RefreshIndicator, _Component);
	
	  function RefreshIndicator() {
	    (0, _classCallCheck3.default)(this, RefreshIndicator);
	    return (0, _possibleConstructorReturn3.default)(this, (RefreshIndicator.__proto__ || (0, _getPrototypeOf2.default)(RefreshIndicator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RefreshIndicator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var paperSize = this.getPaperSize();
	
	      var childrenCmp = null;
	      if (this.props.status !== 'ready') {
	        var circleStyle = this.getCircleStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'div',
	          {
	            ref: 'wrapper',
	            style: prepareStyles({
	              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	              width: '100%',
	              height: '100%'
	            })
	          },
	          _react2.default.createElement(
	            'svg',
	            {
	              style: {
	                width: paperSize,
	                height: paperSize
	              },
	              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	            },
	            _react2.default.createElement('circle', (0, _extends3.default)({
	              ref: 'path',
	              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
	                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	              }))
	            }, circleStyle.attr))
	          )
	        );
	      } else {
	        var _circleStyle = this.getCircleStyle(paperSize);
	        var polygonStyle = this.getPolygonStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'svg',
	          {
	            style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2.default.createElement('circle', (0, _extends3.default)({
	            style: prepareStyles(_circleStyle.style)
	          }, _circleStyle.attr)),
	          _react2.default.createElement('polygon', (0, _extends3.default)({
	            style: prepareStyles(polygonStyle.style)
	          }, polygonStyle.attr))
	        );
	      }
	
	      return childrenCmp;
	    }
	  }, {
	    key: 'getTheme',
	    value: function getTheme() {
	      return this.context.muiTheme.refreshIndicator;
	    }
	  }, {
	    key: 'getPaddingSize',
	    value: function getPaddingSize() {
	      var padding = this.props.size * 0.1;
	      return padding;
	    }
	  }, {
	    key: 'getPaperSize',
	    value: function getPaperSize() {
	      return this.props.size - this.getPaddingSize() * 2;
	    }
	  }, {
	    key: 'getCircleAttr',
	    value: function getCircleAttr() {
	      return {
	        radiu: VIEWBOX_SIZE / 2 - 5,
	        originX: VIEWBOX_SIZE / 2,
	        originY: VIEWBOX_SIZE / 2,
	        strokeWidth: 3
	      };
	    }
	  }, {
	    key: 'getArcDeg',
	    value: function getArcDeg() {
	      var p = this.props.percentage / 100;
	
	      var beginDeg = p * 120;
	      var endDeg = p * 410;
	      return [beginDeg, endDeg];
	    }
	  }, {
	    key: 'getFactor',
	    value: function getFactor() {
	      var p = this.props.percentage / 100;
	      var p1 = Math.min(1, p / 0.4);
	
	      return p1;
	    }
	  }, {
	    key: 'getCircleStyle',
	    value: function getCircleStyle() {
	      var isLoading = this.props.status === 'loading';
	      var p1 = isLoading ? 1 : this.getFactor();
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	
	      var _getArcDeg = this.getArcDeg(),
	          _getArcDeg2 = (0, _slicedToArray3.default)(_getArcDeg, 2),
	          beginDeg = _getArcDeg2[0],
	          endDeg = _getArcDeg2[1];
	
	      var arcLen = (endDeg - beginDeg) * perimeter / 360;
	      var dashOffset = -beginDeg * perimeter / 360;
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	          strokeDashoffset: dashOffset,
	          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          strokeLinecap: 'round',
	          opacity: p1,
	          strokeWidth: circle.strokeWidth * p1,
	          fill: 'none'
	        },
	        attr: {
	          cx: circle.originX,
	          cy: circle.originY,
	          r: circle.radiu
	        }
	      };
	    }
	  }, {
	    key: 'getPolygonStyle',
	    value: function getPolygonStyle() {
	      var p1 = this.getFactor();
	      var circle = this.getCircleAttr();
	
	      var triangleCx = circle.originX + circle.radiu;
	      var triangleCy = circle.originY;
	      var dx = circle.strokeWidth * 7 / 4 * p1;
	      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	      var _getArcDeg3 = this.getArcDeg(),
	          _getArcDeg4 = (0, _slicedToArray3.default)(_getArcDeg3, 2),
	          endDeg = _getArcDeg4[1];
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          transform: 'rotate(' + endDeg + 'deg)',
	          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	          opacity: p1
	        },
	        attr: {
	          points: trianglePath
	        }
	      };
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      var currStep = (step || 0) % 3;
	
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	      var arcLen = perimeter * 0.64;
	
	      var strokeDasharray = void 0;
	      var strokeDashoffset = void 0;
	      var transitionDuration = void 0;
	
	      if (currStep === 0) {
	        strokeDasharray = '1, 200';
	        strokeDashoffset = 0;
	        transitionDuration = '0ms';
	      } else if (currStep === 1) {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -15;
	        transitionDuration = '750ms';
	      } else {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -(perimeter - 1);
	        transitionDuration = '850ms';
	      }
	
	      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
	      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
	      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, currStep + 1);
	      }, currStep ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', null);
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      this.rotateWrapperSecondTimer = setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          top = _props.top,
	          left = _props.left,
	          percentage = _props.percentage,
	          status = _props.status,
	          loadingColor = _props.loadingColor,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'top', 'left', 'percentage', 'status', 'loadingColor']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({
	          circle: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }, other),
	        this.renderChildren()
	      );
	    }
	  }]);
	  return RefreshIndicator;
	}(_react.Component);
	
	RefreshIndicator.defaultProps = {
	  percentage: 0,
	  size: 40,
	  status: 'hide'
	};
	RefreshIndicator.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RefreshIndicator.propTypes = {
	  /**
	   * Override the theme's color of the indicator while it's status is
	   * "ready" and it's percentage is less than 100.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * The absolute left position of the indicator in pixels.
	   */
	  left: _react.PropTypes.number.isRequired,
	  /**
	   * Override the theme's color of the indicator while
	   * it's status is "loading" or when it's percentage is 100.
	   */
	  loadingColor: _react.PropTypes.string,
	  /**
	   * The confirmation progress to fetch data. Max value is 100.
	   */
	  percentage: _react.PropTypes.number,
	  /**
	   * Size in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * The display status of the indicator. If the status is
	   * "ready", the indicator will display the ready state
	   * arrow. If the status is "loading", it will display
	   * the loading progress indicator. If the status is "hide",
	   * the indicator will be hidden.
	   */
	  status: _react.PropTypes.oneOf(['ready', 'loading', 'hide']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The absolute top position of the indicator in pixels.
	   */
	  top: _react.PropTypes.number.isRequired
	} : void 0;
	exports.default = RefreshIndicator;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RefreshIndicator = __webpack_require__(1049);
	
	var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RefreshIndicator2.default;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(40);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(356);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 8 : 0
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  (0, _inherits3.default)(SelectField, _Component);
	
	  function SelectField() {
	    (0, _classCallCheck3.default)(this, SelectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          iconStyle = _props.iconStyle,
	          id = _props.id,
	          underlineDisabledStyle = _props.underlineDisabledStyle,
	          underlineFocusStyle = _props.underlineFocusStyle,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          underlineStyle = _props.underlineStyle,
	          errorStyle = _props.errorStyle,
	          disabled = _props.disabled,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          hintStyle = _props.hintStyle,
	          hintText = _props.hintText,
	          fullWidth = _props.fullWidth,
	          errorText = _props.errorText,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyle = _props.menuStyle,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'value']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        (0, _extends3.default)({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          {
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            menuItemStyle: menuItemStyle,
	            selectedMenuItemStyle: selectedMenuItemStyle,
	            underlineStyle: styles.hideDropDownUnderline,
	            listStyle: listStyle,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return SelectField;
	}(_react.Component);
	
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false
	};
	SelectField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SelectField.propTypes = {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item.
	   * @param {any} payload The `value` prop of the selected menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value that is currently selected.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = SelectField;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(224);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _deprecatedPropType = __webpack_require__(1117);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    rest[_key2 - 3] = arguments[_key2];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	function getPercent(value, min, max) {
	  var percent = (value - min) / (max - min);
	  if (isNaN(percent)) {
	    percent = 0;
	  }
	
	  return percent;
	}
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var axis = props.axis,
	      disabled = props.disabled,
	      max = props.max,
	      min = props.min;
	  var _context$muiTheme$sli = context.muiTheme.slider,
	      handleColorZero = _context$muiTheme$sli.handleColorZero,
	      handleFillColor = _context$muiTheme$sli.handleFillColor,
	      handleSize = _context$muiTheme$sli.handleSize,
	      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
	      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
	      trackSize = _context$muiTheme$sli.trackSize,
	      trackColor = _context$muiTheme$sli.trackColor,
	      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
	      rippleColor = _context$muiTheme$sli.rippleColor,
	      selectionColor = _context$muiTheme$sli.selectionColor;
	
	
	  var fillGutter = handleSize / 2;
	  var disabledGutter = trackSize + handleSizeDisabled / 2;
	  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
	  var percent = getPercent(state.value, min, max);
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[axis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[axis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[axis], trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[axis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
	      x: trackSize / 2 + 'px 0 0 0',
	      'x-reverse': trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: trackColor,
	      width: handleSizeDisabled,
	      height: handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: trackSize + 'px solid ' + handleColorZero,
	      backgroundColor: handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: handleSizeDisabled,
	      height: handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: trackSize + 'px solid ' + trackColorSelected
	    },
	    handleWhenActive: {
	      width: handleSizeActive,
	      height: handleSizeActive
	    },
	    ripple: {
	      height: handleSize,
	      width: handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -trackSize,
	      left: -trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -handleSize,
	      left: -handleSize
	    },
	    rippleColor: {
	      fill: percent === 0 ? handleColorZero : rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[axis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[axis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  (0, _inherits3.default)(Slider, _Component);
	
	  function Slider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slider);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      value: 0
	    }, _this.track = null, _this.handle = null, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          min = _this$props.min,
	          max = _this$props.max,
	          step = _this$props.step;
	
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (axis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (axis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (axis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (axis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'min';
	          break;
	        case 'end':
	          action = 'max';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        switch (action) {
	          case 'decrease':
	            newValue = _this.state.value - step;
	            break;
	          case 'increase':
	            newValue = _this.state.value + step;
	            break;
	          case 'min':
	            newValue = min;
	            break;
	          case 'max':
	            newValue = max;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        newValue = parseFloat(newValue.toFixed(5));
	
	        if (newValue > max) {
	          newValue = max;
	        } else if (newValue < min) {
	          newValue = min;
	        }
	
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            value: newValue
	          });
	
	          if (_this.props.onChange) {
	            _this.props.onChange(event, newValue);
	          }
	        }
	      }
	    }, _this.handleDragMouseMove = function (event) {
	      _this.onDragUpdate(event, 'mouse');
	    }, _this.handleTouchMove = function (event) {
	      _this.onDragUpdate(event, 'touch');
	    }, _this.handleMouseEnd = function (event) {
	      document.removeEventListener('mousemove', _this.handleDragMouseMove);
	      document.removeEventListener('mouseup', _this.handleMouseEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchEnd = function (event) {
	      document.removeEventListener('touchmove', _this.handleTouchMove);
	      document.removeEventListener('touchup', _this.handleTouchEnd);
	      document.removeEventListener('touchend', _this.handleTouchEnd);
	      document.removeEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('touchmove', _this.handleTouchMove);
	      document.addEventListener('touchup', _this.handleTouchEnd);
	      document.addEventListener('touchend', _this.handleTouchEnd);
	      document.addEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.handleFocus = function (event) {
	      _this.setState({
	        focused: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('mousemove', _this.handleDragMouseMove);
	      document.addEventListener('mouseup', _this.handleMouseEnd);
	
	      // Cancel text selection
	      event.preventDefault();
	
	      // Set focus manually since we called preventDefault()
	      _this.handle.focus();
	
	      _this.onDragStart(event);
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({
	          active: false
	        });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({
	        hovered: true
	      });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({
	        hovered: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          valueProp = _props.value,
	          defaultValue = _props.defaultValue,
	          min = _props.min,
	          max = _props.max;
	
	
	      var value = valueProp;
	      if (value === undefined) {
	        value = defaultValue !== undefined ? defaultValue : min;
	      }
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      this.setState({
	        value: value
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        this.setState({
	          value: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      return this.state.value;
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      this.setState({
	        value: this.props.min
	      });
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[this.props.axis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, type) {
	      var _this2 = this;
	
	      if (this.dragRunning) {
	        return;
	      }
	      this.dragRunning = true;
	
	      requestAnimationFrame(function () {
	        _this2.dragRunning = false;
	
	        var source = type === 'touch' ? event.touches[0] : event;
	
	        var position = void 0;
	        if (isMouseControlInverted(_this2.props.axis)) {
	          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[_this2.props.axis]];
	        } else {
	          position = source[mainAxisClientOffsetProperty[_this2.props.axis]] - _this2.getTrackOffset();
	        }
	
	        if (!_this2.props.disabled) {
	          _this2.setValueFromPosition(event, position);
	        }
	      });
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'setValueFromPosition',
	    value: function setValueFromPosition(event, position) {
	      var positionMax = this.track[mainAxisClientProperty[this.props.axis]];
	      if (position < 0) {
	        position = 0;
	      } else if (position > positionMax) {
	        position = positionMax;
	      }
	
	      var _props2 = this.props,
	          step = _props2.step,
	          min = _props2.min,
	          max = _props2.max;
	
	
	      var value = void 0;
	      value = position / positionMax * (max - min);
	      value = Math.round(value / step) * step + min;
	      value = parseFloat(value.toFixed(5));
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      if (this.state.value !== value) {
	        this.setState({
	          value: value
	        });
	
	        if (this.props.onChange) {
	          this.props.onChange(event, value);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          axis = _props3.axis,
	          description = _props3.description,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          error = _props3.error,
	          max = _props3.max,
	          min = _props3.min,
	          name = _props3.name,
	          onBlur = _props3.onBlur,
	          onChange = _props3.onChange,
	          onDragStart = _props3.onDragStart,
	          onDragStop = _props3.onDragStop,
	          onFocus = _props3.onFocus,
	          required = _props3.required,
	          sliderStyle = _props3.sliderStyle,
	          step = _props3.step,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['axis', 'description', 'disabled', 'disableFocusRipple', 'error', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style']);
	      var _state = this.state,
	          active = _state.active,
	          focused = _state.focused,
	          hovered = _state.hovered,
	          value = _state.value;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var percent = getPercent(value, min, max);
	
	      var handleStyles = {};
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'span',
	          null,
	          description
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart,
	            onKeyDown: !disabled && this.handleKeyDown
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(node) {
	                return _this3.track = node;
	              }, style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(node) {
	                  return _this3.handle = node;
	                },
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              },
	              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
	                style: rippleStyle,
	                innerStyle: styles.rippleInner,
	                show: (hovered || focused) && !active,
	                color: styles.rippleColor.fill
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          type: 'hidden',
	          name: name,
	          value: value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Slider.propTypes = {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _react.PropTypes.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Describe the slider.
	   */
	  description: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * An error message for the slider.
	   */
	  error: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event KeyDown event targeting the slider.
	   * @param {number} newValue The new value of the slider.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   *
	   * @param {object} event MouseDown or TouchStart event targeting the slider.
	   */
	  onDragStart: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slide has stopped moving.
	   *
	   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
	   */
	  onDragStop: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _react.PropTypes.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	} : void 0;
	exports.default = Slider;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(1052);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ClickAwayListener = __webpack_require__(222);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _SnackbarBody = __webpack_require__(1055);
	
	var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
	      zIndex = _context$muiTheme.zIndex;
	  var open = state.open;
	
	
	  var styles = {
	    root: {
	      position: 'fixed',
	      left: '50%',
	      display: 'flex',
	      bottom: 0,
	      zIndex: zIndex.snackbar,
	      visibility: open ? 'visible' : 'hidden',
	      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
	      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
	    }
	  };
	
	  return styles;
	}
	
	var Snackbar = function (_Component) {
	  (0, _inherits3.default)(Snackbar, _Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
	      if (_this.timerTransitionId) {
	        // If transitioning, don't close the snackbar.
	        return;
	      }
	
	      if (_this.props.open !== null && _this.props.onRequestClose) {
	        _this.props.onRequestClose('clickaway');
	      } else {
	        _this.setState({ open: false });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open,
	        message: this.props.message,
	        action: this.props.action
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.open) {
	        this.setAutoHideTimer();
	        this.setTransitionTimer();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
	        this.setState({
	          open: false
	        });
	
	        clearTimeout(this.timerOneAtTheTimeId);
	        this.timerOneAtTheTimeId = setTimeout(function () {
	          _this2.setState({
	            message: nextProps.message,
	            action: nextProps.action,
	            open: true
	          });
	        }, 400);
	      } else {
	        var open = nextProps.open;
	
	        this.setState({
	          open: open !== null ? open : this.state.open,
	          message: nextProps.message,
	          action: nextProps.action
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.open !== this.state.open) {
	        if (this.state.open) {
	          this.setAutoHideTimer();
	          this.setTransitionTimer();
	        } else {
	          clearTimeout(this.timerAutoHideId);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHideId);
	      clearTimeout(this.timerTransitionId);
	      clearTimeout(this.timerOneAtTheTimeId);
	    }
	  }, {
	    key: 'setAutoHideTimer',
	
	
	    // Timer that controls delay before snackbar auto hides
	    value: function setAutoHideTimer() {
	      var _this3 = this;
	
	      var autoHideDuration = this.props.autoHideDuration;
	
	      if (autoHideDuration > 0) {
	        clearTimeout(this.timerAutoHideId);
	        this.timerAutoHideId = setTimeout(function () {
	          if (_this3.props.open !== null && _this3.props.onRequestClose) {
	            _this3.props.onRequestClose('timeout');
	          } else {
	            _this3.setState({ open: false });
	          }
	        }, autoHideDuration);
	      }
	    }
	
	    // Timer that controls delay before click-away events are captured (based on when animation completes)
	
	  }, {
	    key: 'setTransitionTimer',
	    value: function setTransitionTimer() {
	      var _this4 = this;
	
	      this.timerTransitionId = setTimeout(function () {
	        _this4.timerTransitionId = undefined;
	      }, 400);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHideDuration = _props.autoHideDuration,
	          contentStyle = _props.contentStyle,
	          bodyStyle = _props.bodyStyle,
	          messageProp = _props.message,
	          onRequestClose = _props.onRequestClose,
	          onActionTouchTap = _props.onActionTouchTap,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionTouchTap', 'style']);
	      var _state = this.state,
	          action = _state.action,
	          message = _state.message,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: open ? this.componentClickAway : null },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	          _react2.default.createElement(_SnackbarBody2.default, {
	            action: action,
	            contentStyle: contentStyle,
	            message: message,
	            open: open,
	            onActionTouchTap: onActionTouchTap,
	            style: bodyStyle
	          })
	        )
	      );
	    }
	  }]);
	  return Snackbar;
	}(_react.Component);
	
	Snackbar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Snackbar.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _react.PropTypes.node,
	  /**
	   * The number of milliseconds to wait before automatically dismissing.
	   * If no value is specified the snackbar will dismiss normally.
	   * If a value is provided the snackbar can still be dismissed normally.
	   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
	   */
	  autoHideDuration: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the body element.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _react.PropTypes.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _react.PropTypes.func,
	  /**
	   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
	   * `autoHideDuration` timer expires.
	   *
	   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
	   * `open` prop.
	   *
	   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Snackbar;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SnackbarBody = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _withWidth = __webpack_require__(1120);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _FlatButton = __webpack_require__(109);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var open = props.open,
	      width = props.width;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
	      desktopGutter = _context$muiTheme$bas2.desktopGutter,
	      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
	      fontFamily = _context$muiTheme$bas.fontFamily,
	      _context$muiTheme$sna = _context$muiTheme.snackbar,
	      backgroundColor = _context$muiTheme$sna.backgroundColor,
	      textColor = _context$muiTheme$sna.textColor,
	      actionColor = _context$muiTheme$sna.actionColor;
	
	
	  var isSmall = width === _withWidth.SMALL;
	
	  var styles = {
	    root: {
	      fontFamily: fontFamily,
	      backgroundColor: backgroundColor,
	      padding: '0 ' + desktopGutter + 'px',
	      height: desktopSubheaderHeight,
	      lineHeight: desktopSubheaderHeight + 'px',
	      borderRadius: isSmall ? 0 : 2,
	      maxWidth: isSmall ? 'inherit' : 568,
	      minWidth: isSmall ? 'inherit' : 288,
	      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
	      flexGrow: isSmall ? 1 : 0
	    },
	    content: {
	      fontSize: 14,
	      color: textColor,
	      opacity: open ? 1 : 0,
	      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
	    },
	    action: {
	      color: actionColor,
	      float: 'right',
	      marginTop: 6,
	      marginRight: -16,
	      marginLeft: desktopGutter,
	      backgroundColor: 'transparent'
	    }
	  };
	
	  return styles;
	}
	
	var SnackbarBody = exports.SnackbarBody = function SnackbarBody(props, context) {
	  var action = props.action,
	      contentStyle = props.contentStyle,
	      message = props.message,
	      open = props.open,
	      onActionTouchTap = props.onActionTouchTap,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionTouchTap', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
	    style: styles.action,
	    label: action,
	    onTouchTap: onActionTouchTap
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
	      _react2.default.createElement(
	        'span',
	        null,
	        message
	      ),
	      actionButton
	    )
	  );
	};
	
	 false ? SnackbarBody.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _react.PropTypes.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Width of the screen.
	   */
	  width: _react.PropTypes.number.isRequired
	} : void 0;
	
	SnackbarBody.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Snackbar = __webpack_require__(1054);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Snackbar2.default;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          completed = _this$props.completed,
	          disabled = _this$props.disabled,
	          index = _this$props.index,
	          last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          index = _props.index,
	          last = _props.last,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	 false ? Step.propTypes = {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _react.PropTypes.number,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Step;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(41);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(361);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper,
	      backgroundColor = _context$muiTheme$ste.backgroundColor,
	      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  (0, _inherits3.default)(StepButton, _Component);
	
	  function StepButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          iconContainerStyle = _props.iconContainerStyle,
	          last = _props.last,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
	      );
	    }
	  }]);
	  return StepButton;
	}(_react.Component);
	
	StepButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	 false ? StepButton.propTypes = {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _react.PropTypes.object,
	  /** @ignore */
	  last: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = StepButton;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme,
	      stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	 false ? StepConnector.propTypes = propTypes : void 0;
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExpandTransition = __webpack_require__(1091);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  (0, _inherits3.default)(StepContent, _Component);
	
	  function StepContent() {
	    (0, _classCallCheck3.default)(this, StepContent);
	    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          last = _props.last,
	          style = _props.style,
	          transition = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	      var _context = this.context,
	          stepper = _context.stepper,
	          prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	  return StepContent;
	}(_react.Component);
	
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	 false ? StepContent.propTypes = {
	  /**
	   * Expands the content
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Step content
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _react.PropTypes.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = StepContent;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StepConnector = __webpack_require__(1059);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  (0, _inherits3.default)(Stepper, _Component);
	
	  function Stepper() {
	    (0, _classCallCheck3.default)(this, Stepper);
	    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStep = _props.activeStep,
	          children = _props.children,
	          connector = _props.connector,
	          linear = _props.linear,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var numChildren = _react.Children.count(children);
	      var steps = _react.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === numChildren) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	  return Stepper;
	}(_react.Component);
	
	Stepper.defaultProps = {
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	Stepper.childContextTypes = { stepper: _react.PropTypes.object };
	 false ? Stepper.propTypes = {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _react.PropTypes.number,
	  /**
	   * Should be two or more `<Step />` components
	   */
	  children: _react.PropTypes.arrayOf(_react.PropTypes.node),
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _react.PropTypes.node,
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _react.PropTypes.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Stepper;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children,
	      inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      prepareStyles = _context$muiTheme.prepareStyles,
	      subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	
	 false ? Subheader.propTypes = {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the `Subheader` will be indented.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	Subheader.defaultProps = {
	  inset: false
	};
	
	Subheader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = Subheader;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SvgIcon.propTypes = {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _react.PropTypes.string
	} : void 0;
	exports.default = SvgIcon;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      table = _context$muiTheme.table;
	
	
	  return {
	    root: {
	      backgroundColor: table.backgroundColor,
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      tableLayout: 'fixed',
	      fontFamily: baseTheme.fontFamily
	    },
	    bodyTable: {
	      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
	      overflowX: 'hidden',
	      overflowY: 'auto'
	    },
	    tableWrapper: {
	      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
	      overflow: 'auto'
	    }
	  };
	}
	
	var Table = function (_Component) {
	  (0, _inherits3.default)(Table, _Component);
	
	  function Table() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      allRowsSelected: false
	    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
	    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
	    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
	    }, _this.onRowHover = function (rowNumber) {
	      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
	    }, _this.onRowHoverExit = function (rowNumber) {
	      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
	    }, _this.onRowSelection = function (selectedRows) {
	      if (_this.state.allRowsSelected) _this.setState({ allRowsSelected: false });
	      if (_this.props.onRowSelection) _this.props.onRowSelection(selectedRows);
	    }, _this.onSelectAll = function () {
	      if (_this.props.onRowSelection) {
	        if (!_this.state.allRowsSelected) {
	          _this.props.onRowSelection('all');
	        } else {
	          _this.props.onRowSelection('none');
	        }
	      }
	
	      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.allRowsSelected) {
	        this.setState({ allRowsSelected: true });
	      }
	    }
	  }, {
	    key: 'isScrollbarVisible',
	    value: function isScrollbarVisible() {
	      var tableDivHeight = this.refs.tableDiv.clientHeight;
	      var tableBodyHeight = this.refs.tableBody.clientHeight;
	
	      return tableBodyHeight > tableDivHeight;
	    }
	  }, {
	    key: 'createTableHeader',
	    value: function createTableHeader(base) {
	      return _react2.default.cloneElement(base, {
	        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	        onSelectAll: this.onSelectAll,
	        selectAllSelected: this.state.allRowsSelected
	      });
	    }
	  }, {
	    key: 'createTableBody',
	    value: function createTableBody(base) {
	      return _react2.default.cloneElement(base, {
	        allRowsSelected: this.state.allRowsSelected,
	        multiSelectable: this.props.multiSelectable,
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowSelection: this.onRowSelection,
	        selectable: this.props.selectable,
	        style: (0, _simpleAssign2.default)({ height: this.props.height }, base.props.style)
	      });
	    }
	  }, {
	    key: 'createTableFooter',
	    value: function createTableFooter(base) {
	      return base;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          fixedFooter = _props.fixedFooter,
	          fixedHeader = _props.fixedHeader,
	          style = _props.style,
	          wrapperStyle = _props.wrapperStyle,
	          headerStyle = _props.headerStyle,
	          bodyStyle = _props.bodyStyle,
	          footerStyle = _props.footerStyle;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var tHead = void 0;
	      var tFoot = void 0;
	      var tBody = void 0;
	
	      _react2.default.Children.forEach(children, function (child) {
	        if (!_react2.default.isValidElement(child)) return;
	
	        var muiName = child.type.muiName;
	
	        if (muiName === 'TableBody') {
	          tBody = _this2.createTableBody(child);
	        } else if (muiName === 'TableHeader') {
	          tHead = _this2.createTableHeader(child);
	        } else if (muiName === 'TableFooter') {
	          tFoot = _this2.createTableFooter(child);
	        } else {
	           false ? (0, _warning2.default)(false, 'Material-UI: Children of the Table component must be TableBody or TableHeader or TableFooter.\n           Nothing is rendered.') : void 0;
	        }
	      });
	
	      // If we could not find a table-header and a table-body, do not attempt to display anything.
	      if (!tBody && !tHead) return null;
	
	      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var headerTable = void 0;
	      var footerTable = void 0;
	      var inlineHeader = void 0;
	      var inlineFooter = void 0;
	
	      if (fixedHeader) {
	        headerTable = _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle },
	            tHead
	          )
	        );
	      } else {
	        inlineHeader = tHead;
	      }
	
	      if (tFoot !== undefined) {
	        if (fixedFooter) {
	          footerTable = _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
	            _react2.default.createElement(
	              'table',
	              { className: className, style: prepareStyles(mergedTableStyle) },
	              tFoot
	            )
	          );
	        } else {
	          inlineFooter = tFoot;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
	        headerTable,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle, ref: 'tableBody' },
	            inlineHeader,
	            inlineFooter,
	            tBody
	          )
	        ),
	        footerTable
	      );
	    }
	  }]);
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  allRowsSelected: false,
	  fixedFooter: true,
	  fixedHeader: true,
	  height: 'inherit',
	  multiSelectable: false,
	  selectable: true
	};
	Table.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Table.propTypes = {
	  /**
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the body's table element.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * Children passed to table.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the footer will appear fixed below the table.
	   * The default value is true.
	   */
	  fixedFooter: _react.PropTypes.bool,
	  /**
	   * If true, the header will appear fixed above the table.
	   * The default value is true.
	   */
	  fixedHeader: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the footer's table element.
	   */
	  footerStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the header's table element.
	   */
	  headerStyle: _react.PropTypes.object,
	  /**
	   * The height of the table.
	   */
	  height: _react.PropTypes.string,
	  /**
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _react.PropTypes.bool,
	  /**
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * Called when a row is selected.
	   * selectedRows is an array of all row selections.
	   * IF all rows have been selected, the string "all"
	   * will be returned instead to indicate that all rows have been selected.
	   */
	  onRowSelection: _react.PropTypes.func,
	  /**
	   * If true, table rows can be selected.
	   * If multiple row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the table's wrapper element.
	   */
	  wrapperStyle: _react.PropTypes.object
	} : void 0;
	exports.default = Table;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;
	
	var _Table2 = __webpack_require__(1064);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(363);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(364);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(365);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(221);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(366);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(143);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.default = _Table3.default;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var inkBar = context.muiTheme.inkBar;
	
	
	  return {
	    root: {
	      left: props.left,
	      width: props.width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: props.color || inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', 'left')
	    }
	  };
	}
	
	var InkBar = function (_Component) {
	  (0, _inherits3.default)(InkBar, _Component);
	
	  function InkBar() {
	    (0, _classCallCheck3.default)(this, InkBar);
	    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InkBar, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
	    }
	  }]);
	  return InkBar;
	}(_react.Component);
	
	InkBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? InkBar.propTypes = {
	  color: _react.PropTypes.string,
	  left: _react.PropTypes.string.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  width: _react.PropTypes.string.isRequired
	} : void 0;
	exports.default = InkBar;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  width: '100%',
	  position: 'relative',
	  textAlign: 'initial'
	};
	
	var TabTemplate = function TabTemplate(_ref) {
	  var children = _ref.children,
	      selected = _ref.selected,
	      style = _ref.style;
	
	  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
	  if (!selected) {
	    templateStyle.height = 0;
	    templateStyle.overflow = 'hidden';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: templateStyle },
	    children
	  );
	};
	
	 false ? TabTemplate.propTypes = {
	  children: _react.PropTypes.node,
	  selected: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = TabTemplate;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TabTemplate = __webpack_require__(1067);
	
	var _TabTemplate2 = _interopRequireDefault(_TabTemplate);
	
	var _InkBar = __webpack_require__(1066);
	
	var _InkBar2 = _interopRequireDefault(_InkBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    tabItemContainer: {
	      width: '100%',
	      backgroundColor: tabs.backgroundColor,
	      whiteSpace: 'nowrap',
	      display: 'flex'
	    }
	  };
	}
	
	var Tabs = function (_Component) {
	  (0, _inherits3.default)(Tabs, _Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
	      var valueLink = _this.getValueLink(_this.props);
	      var index = tab.props.index;
	
	      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
	        valueLink.requestChange(value, event, tab);
	      }
	
	      _this.setState({ selectedIndex: index });
	
	      if (tab.props.onActive) {
	        tab.props.onActive(tab);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueLink = this.getValueLink(this.props);
	      var initialIndex = this.props.initialSelectedIndex;
	
	      this.setState({
	        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps, nextContext) {
	      var valueLink = this.getValueLink(newProps);
	      var newState = {
	        muiTheme: nextContext.muiTheme || this.context.muiTheme
	      };
	
	      if (valueLink.value !== undefined) {
	        newState.selectedIndex = this.getSelectedIndex(newProps);
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var tabs = [];
	
	      _react.Children.forEach(props.children, function (tab) {
	        if ((0, _react.isValidElement)(tab)) {
	          tabs.push(tab);
	        }
	      });
	
	      return tabs;
	    }
	  }, {
	    key: 'getTabCount',
	    value: function getTabCount() {
	      return this.getTabs().length;
	    }
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	
	  }, {
	    key: 'getValueLink',
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props) {
	      var valueLink = this.getValueLink(props);
	      var selectedIndex = -1;
	
	      this.getTabs(props).forEach(function (tab, index) {
	        if (valueLink.value === tab.props.value) {
	          selectedIndex = index;
	        }
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected(tab, index) {
	      var valueLink = this.getValueLink(this.props);
	      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          contentContainerClassName = _props.contentContainerClassName,
	          contentContainerStyle = _props.contentContainerStyle,
	          initialSelectedIndex = _props.initialSelectedIndex,
	          inkBarStyle = _props.inkBarStyle,
	          onChange = _props.onChange,
	          style = _props.style,
	          tabItemContainerStyle = _props.tabItemContainerStyle,
	          tabTemplate = _props.tabTemplate,
	          tabTemplateStyle = _props.tabTemplateStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var valueLink = this.getValueLink(this.props);
	      var tabValue = valueLink.value;
	      var tabContent = [];
	      var width = 100 / this.getTabCount();
	
	      var tabs = this.getTabs().map(function (tab, index) {
	         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;
	
	         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;
	
	        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
	          key: index,
	          selected: _this2.getSelected(tab, index),
	          style: tabTemplateStyle
	        }, tab.props.children) : undefined);
	
	        return (0, _react.cloneElement)(tab, {
	          key: index,
	          index: index,
	          selected: _this2.getSelected(tab, index),
	          width: width + '%',
	          onTouchTap: _this2.handleTabTouchTap
	        });
	      });
	
	      var inkBar = this.state.selectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
	        left: width * this.state.selectedIndex + '%',
	        width: width + '%',
	        style: inkBarStyle
	      }) : null;
	
	      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
	          tabs
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: inkBarContainerWidth } },
	          inkBar
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
	            className: contentContainerClassName
	          },
	          tabContent
	        )
	      );
	    }
	  }]);
	  return Tabs;
	}(_react.Component);
	
	Tabs.defaultProps = {
	  initialSelectedIndex: 0,
	  onChange: function onChange() {}
	};
	Tabs.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Tabs.propTypes = {
	  /**
	   * Should be used to pass `Tab` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The css class name of the content's container.
	   */
	  contentContainerClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the content's container.
	   */
	  contentContainerStyle: _react.PropTypes.object,
	  /**
	   * Specify initial visible tab index.
	   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
	   * `initialSelectedIndex` will revert back to default.
	   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
	   */
	  initialSelectedIndex: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the InkBar.
	   */
	  inkBarStyle: _react.PropTypes.object,
	  /**
	   * Called when the selected value change.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the tab-labels container.
	   */
	  tabItemContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the default tab template used to wrap the content of each tab element.
	   */
	  tabTemplate: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the tab template.
	   */
	  tabTemplateStyle: _react.PropTypes.object,
	  /**
	   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = Tabs;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _Tab2 = __webpack_require__(367);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Tabs2 = __webpack_require__(1068);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab3.default;
	exports.Tabs = _Tabs3.default;
	exports.default = _Tabs3.default;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(57);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'initial'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(undefined, event);
	    }, _this.handleChange = function (event) {
	      _this.syncHeightWithShadow(event.target.value);
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.syncHeightWithShadow(nextProps.value);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event) {
	      var shadow = this.refs.shadow;
	
	      if (newValue !== undefined) {
	        shadow.value = newValue;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      if (this.props.rowsMax >= this.props.rows) {
	        newHeight = Math.min(this.props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	
	        if (this.props.onHeightChange) {
	          this.props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = this.props.valueLink.value;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value,
	          valueLink: this.props.valueLink
	        }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? EnhancedTextarea.propTypes = {
	  defaultValue: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onHeightChange: _react.PropTypes.func,
	  rows: _react.PropTypes.number,
	  rowsMax: _react.PropTypes.number,
	  shadowStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  textareaStyle: _react.PropTypes.object,
	  value: _react.PropTypes.string,
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = EnhancedTextarea;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(79);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(1070);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(1072);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(1073);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(1074);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    inputNative: {
	      appearance: 'textfield' }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null;
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      _this.setState({ hasValue: isValid(event.target.value) });
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TextField.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _react.PropTypes.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _react.PropTypes.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _react.PropTypes.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value of the text field.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = TextField;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	 false ? TextFieldHint.propTypes = {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _react.PropTypes.node
	} : void 0;
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onTouchTap = props.onTouchTap;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onTouchTap: onTouchTap
	    },
	    children
	  );
	};
	
	 false ? TextFieldLabel.propTypes = {
	  /**
	   * The label contents.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _react.PropTypes.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the text field label.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottom: 'solid 1px',
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottom: 'dotted 2px',
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottom: 'solid 2px',
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { style: prepareStyles(focusedUnderline) })
	  );
	};
	
	 false ? TextFieldUnderline.propTypes = propTypes : void 0;
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimeDisplay = __webpack_require__(1078);
	
	var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);
	
	var _ClockHours = __webpack_require__(1076);
	
	var _ClockHours2 = _interopRequireDefault(_ClockHours);
	
	var _ClockMinutes = __webpack_require__(1077);
	
	var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clock = function (_Component) {
	  (0, _inherits3.default)(Clock, _Component);
	
	  function Clock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Clock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Clock.__proto__ || (0, _getPrototypeOf2.default)(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedTime: null,
	      mode: 'hour'
	    }, _this.setMode = function (mode) {
	      setTimeout(function () {
	        _this.setState({
	          mode: mode
	        });
	      }, 100);
	    }, _this.handleSelectAffix = function (affix) {
	      if (affix === _this.getAffix()) return;
	
	      var hours = _this.state.selectedTime.getHours();
	
	      if (affix === 'am') {
	        _this.handleChangeHours(hours - 12, affix);
	        return;
	      }
	
	      _this.handleChangeHours(hours + 12, affix);
	    }, _this.handleChangeHours = function (hours, finished) {
	      var time = new Date(_this.state.selectedTime);
	      var affix = void 0;
	
	      if (typeof finished === 'string') {
	        affix = finished;
	        finished = undefined;
	      }
	      if (!affix) {
	        affix = _this.getAffix();
	      }
	      if (affix === 'pm' && hours < 12) {
	        hours += 12;
	      }
	
	      time.setHours(hours);
	      _this.setState({
	        selectedTime: time
	      });
	
	      if (finished) {
	        setTimeout(function () {
	          _this.setState({
	            mode: 'minute'
	          });
	
	          var onChangeHours = _this.props.onChangeHours;
	
	          if (onChangeHours) {
	            onChangeHours(time);
	          }
	        }, 100);
	      }
	    }, _this.handleChangeMinutes = function (minutes, finished) {
	      var time = new Date(_this.state.selectedTime);
	      time.setMinutes(minutes);
	      _this.setState({
	        selectedTime: time
	      });
	
	      var onChangeMinutes = _this.props.onChangeMinutes;
	
	      if (onChangeMinutes && finished) {
	        setTimeout(function () {
	          onChangeMinutes(time);
	        }, 0);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Clock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        selectedTime: this.props.initialTime || new Date()
	      });
	    }
	  }, {
	    key: 'getAffix',
	    value: function getAffix() {
	      if (this.props.format !== 'ampm') return '';
	
	      var hours = this.state.selectedTime.getHours();
	      if (hours < 12) {
	        return 'am';
	      }
	
	      return 'pm';
	    }
	  }, {
	    key: 'getSelectedTime',
	    value: function getSelectedTime() {
	      return this.state.selectedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clock = null;
	
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          userSelect: 'none'
	        },
	        container: {
	          height: 280,
	          padding: 10,
	          position: 'relative',
	          boxSizing: 'content-box'
	        },
	        circle: {
	          position: 'absolute',
	          top: 20,
	          width: 260,
	          height: 260,
	          borderRadius: '100%',
	          backgroundColor: timePicker.clockCircleColor
	        }
	      };
	
	      if (this.state.mode === 'hour') {
	        clock = _react2.default.createElement(_ClockHours2.default, {
	          key: 'hours',
	          format: this.props.format,
	          onChange: this.handleChangeHours,
	          initialHours: this.state.selectedTime.getHours()
	        });
	      } else {
	        clock = _react2.default.createElement(_ClockMinutes2.default, {
	          key: 'minutes',
	          onChange: this.handleChangeMinutes,
	          initialMinutes: this.state.selectedTime.getMinutes()
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_TimeDisplay2.default, {
	          selectedTime: this.state.selectedTime,
	          mode: this.state.mode,
	          format: this.props.format,
	          affix: this.getAffix(),
	          onSelectAffix: this.handleSelectAffix,
	          onSelectHour: this.setMode.bind(this, 'hour'),
	          onSelectMin: this.setMode.bind(this, 'minute')
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.container) },
	          _react2.default.createElement('div', { style: prepareStyles(styles.circle) }),
	          clock
	        )
	      );
	    }
	  }]);
	  return Clock;
	}(_react.Component);
	
	Clock.defaultProps = {
	  initialTime: new Date()
	};
	Clock.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Clock.propTypes = {
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialTime: _react.PropTypes.object,
	  onChangeHours: _react.PropTypes.func,
	  onChangeMinutes: _react.PropTypes.func
	} : void 0;
	exports.default = Clock;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ClockNumber = __webpack_require__(368);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(369);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockHours = function (_Component) {
	  (0, _inherits3.default)(ClockHours, _Component);
	
	  function ClockHours() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockHours);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockHours.__proto__ || (0, _getPrototypeOf2.default)(ClockHours)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) return;
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouchMove = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], false);
	    }, _this.handleTouchEnd = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], true);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockHours, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var hours = this.getHours(event.offsetX, event.offsetY);
	
	      this.props.onChange(hours, finish);
	    }
	  }, {
	    key: 'getHours',
	    value: function getHours(offsetX, offsetY) {
	      var step = 30;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      var delta = Math.pow(x, 2) + Math.pow(y, 2);
	      var distance = Math.sqrt(delta);
	
	      value = value || 12;
	      if (this.props.format === '24hr') {
	        if (distance < 90) {
	          value += 12;
	          value %= 24;
	        }
	      } else {
	        value %= 12;
	      }
	
	      return value;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      var hour = this.props.initialHours;
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      return hour;
	    }
	  }, {
	    key: 'getHourNumbers',
	    value: function getHourNumbers() {
	      var _this2 = this;
	
	      var style = {
	        pointerEvents: 'none'
	      };
	      var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	      var hours = [];
	      for (var i = 1; i <= hourSize; i++) {
	        hours.push(i % 24);
	      }
	
	      return hours.map(function (hour) {
	        var isSelected = _this2.getSelected() === hour;
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: hour,
	          style: style,
	          isSelected: isSelected,
	          type: 'hour',
	          value: hour
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var hours = this.getSelected();
	      var numbers = this.getHourNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
	        numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask', style: prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockHours;
	}(_react.Component);
	
	ClockHours.defaultProps = {
	  initialHours: new Date().getHours(),
	  onChange: function onChange() {},
	  format: 'ampm'
	};
	ClockHours.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ClockHours.propTypes = {
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialHours: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	} : void 0;
	exports.default = ClockHours;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClockNumber = __webpack_require__(368);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(369);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockMinutes = function (_Component) {
	  (0, _inherits3.default)(ClockMinutes, _Component);
	
	  function ClockMinutes() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockMinutes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockMinutes.__proto__ || (0, _getPrototypeOf2.default)(ClockMinutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) {
	        return;
	      }
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouch = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], event.type === 'touchend');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockMinutes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = this.refs.mask;
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var minutes = this.getMinutes(event.offsetX, event.offsetY);
	
	      this.props.onChange(minutes, finish);
	    }
	  }, {
	    key: 'getMinutes',
	    value: function getMinutes(offsetX, offsetY) {
	      var step = 6;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      return value;
	    }
	  }, {
	    key: 'getMinuteNumbers',
	    value: function getMinuteNumbers() {
	      var minutes = [];
	      for (var i = 0; i < 12; i++) {
	        minutes.push(i * 5);
	      }
	      var selectedMinutes = this.props.initialMinutes;
	      var hasSelected = false;
	
	      var numbers = minutes.map(function (minute) {
	        var isSelected = selectedMinutes === minute;
	        if (isSelected) {
	          hasSelected = true;
	        }
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: minute,
	          isSelected: isSelected,
	          type: 'minute',
	          value: minute
	        });
	      });
	
	      return {
	        numbers: numbers,
	        hasSelected: hasSelected,
	        selected: selectedMinutes
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var minutes = this.getMinuteNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { value: minutes.selected, type: 'minute', hasSelected: minutes.hasSelected }),
	        minutes.numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask',
	          style: prepareStyles(styles.hitMask),
	          onTouchMove: this.handleTouch,
	          onTouchEnd: this.handleTouch,
	          onMouseUp: this.handleUp,
	          onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockMinutes;
	}(_react.Component);
	
	ClockMinutes.defaultProps = {
	  initialMinutes: new Date().getMinutes(),
	  onChange: function onChange() {}
	};
	ClockMinutes.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ClockMinutes.propTypes = {
	  initialMinutes: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	} : void 0;
	exports.default = ClockMinutes;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(167);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeDisplay = function (_Component) {
	  (0, _inherits3.default)(TimeDisplay, _Component);
	
	  function TimeDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimeDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimeDisplay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTime !== this.props.selectedTime) {
	        var direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'sanitizeTime',
	    value: function sanitizeTime() {
	      var hour = this.props.selectedTime.getHours();
	      var min = this.props.selectedTime.getMinutes().toString();
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      hour = hour.toString();
	      if (hour.length < 2) hour = '0' + hour;
	      if (min.length < 2) min = '0' + min;
	
	      return [hour, min];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          affix = _props.affix,
	          format = _props.format,
	          mode = _props.mode,
	          onSelectAffix = _props.onSelectAffix,
	          onSelectHour = _props.onSelectHour,
	          onSelectMin = _props.onSelectMin,
	          selectedTime = _props.selectedTime,
	          other = (0, _objectWithoutProperties3.default)(_props, ['affix', 'format', 'mode', 'onSelectAffix', 'onSelectHour', 'onSelectMin', 'selectedTime']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          padding: '14px 0',
	          borderTopLeftRadius: 2,
	          borderTopRightRadius: 2,
	          backgroundColor: timePicker.headerColor,
	          color: timePicker.textColor
	        },
	        text: {
	          margin: '6px 0',
	          lineHeight: '58px',
	          height: 58,
	          fontSize: 58,
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'baseline'
	        },
	        time: {
	          margin: '0 10px'
	        },
	        affix: {
	          flex: 1,
	          position: 'relative',
	          lineHeight: '17px',
	          height: 17,
	          fontSize: 17
	        },
	        affixTop: {
	          position: 'absolute',
	          top: -20,
	          left: 0
	        },
	        clickable: {
	          cursor: 'pointer'
	        },
	        inactive: {
	          opacity: 0.7
	        }
	      };
	
	      var _sanitizeTime = this.sanitizeTime(),
	          _sanitizeTime2 = (0, _slicedToArray3.default)(_sanitizeTime, 2),
	          hour = _sanitizeTime2[0],
	          min = _sanitizeTime2[1];
	
	      var buttons = [];
	      if (format === 'ampm') {
	        buttons = [_react2.default.createElement(
	          'div',
	          {
	            key: 'pm',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, affix === 'pm' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('pm');
	            }
	          },
	          'PM'
	        ), _react2.default.createElement(
	          'div',
	          {
	            key: 'am',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('am');
	            }
	          },
	          'AM'
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.text) },
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.time) },
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'hour' ? {} : styles.inactive)),
	                onTouchTap: onSelectHour
	              },
	              hour
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'minute' ? {} : styles.inactive)),
	                onTouchTap: onSelectMin
	              },
	              min
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) },
	            buttons
	          )
	        )
	      );
	    }
	  }]);
	  return TimeDisplay;
	}(_react.Component);
	
	TimeDisplay.defaultProps = {
	  affix: '',
	  mode: 'hour'
	};
	TimeDisplay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TimeDisplay.propTypes = {
	  affix: _react.PropTypes.oneOf(['', 'pm', 'am']),
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  mode: _react.PropTypes.oneOf(['hour', 'minute']),
	  onSelectAffix: _react.PropTypes.func,
	  onSelectHour: _react.PropTypes.func,
	  onSelectMin: _react.PropTypes.func,
	  selectedTime: _react.PropTypes.object.isRequired
	} : void 0;
	exports.default = TimeDisplay;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimePickerDialog = __webpack_require__(1080);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	var _TextField = __webpack_require__(40);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _timeUtils = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	emptyTime.setSeconds(0);
	emptyTime.setMilliseconds(0);
	
	var TimePicker = function (_Component) {
	  (0, _inherits3.default)(TimePicker, _Component);
	
	  function TimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePicker.__proto__ || (0, _getPrototypeOf2.default)(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      time: null,
	      dialogTime: new Date()
	    }, _this.handleAcceptDialog = function (time) {
	      _this.setState({
	        time: time
	      });
	      if (_this.props.onChange) _this.props.onChange(null, time);
	    }, _this.handleFocusInput = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTapInput = function (event) {
	      event.preventDefault();
	
	      if (!_this.props.disabled) {
	        _this.openDialog();
	      }
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        time: this.isControlled() ? this.getControlledTime() : this.props.defaultTime
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          time: this.getControlledTime(nextProps)
	        });
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      this.setState({
	        dialogTime: this.state.time
	      });
	      this.refs.dialogWindow.show();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.value !== null;
	    }
	  }, {
	    key: 'getControlledTime',
	    value: function getControlledTime() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var result = null;
	      if (props.value instanceof Date) {
	        result = props.value;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          defaultTime = _props.defaultTime,
	          dialogBodyStyle = _props.dialogBodyStyle,
	          dialogStyle = _props.dialogStyle,
	          format = _props.format,
	          okLabel = _props.okLabel,
	          onFocus = _props.onFocus,
	          onTouchTap = _props.onTouchTap,
	          onShow = _props.onShow,
	          onDismiss = _props.onDismiss,
	          pedantic = _props.pedantic,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoOk', 'cancelLabel', 'defaultTime', 'dialogBodyStyle', 'dialogStyle', 'format', 'okLabel', 'onFocus', 'onTouchTap', 'onShow', 'onDismiss', 'pedantic', 'style', 'textFieldStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var time = this.state.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          style: textFieldStyle,
	          ref: 'input',
	          value: time === emptyTime ? null : (0, _timeUtils.formatTime)(time, format, pedantic),
	          onFocus: this.handleFocusInput,
	          onTouchTap: this.handleTouchTapInput
	        })),
	        _react2.default.createElement(_TimePickerDialog2.default, {
	          ref: 'dialogWindow',
	          bodyStyle: dialogBodyStyle,
	          initialTime: this.state.dialogTime,
	          onAccept: this.handleAcceptDialog,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          format: format,
	          okLabel: okLabel,
	          cancelLabel: cancelLabel,
	          autoOk: autoOk,
	          style: dialogStyle
	        })
	      );
	    }
	  }]);
	  return TimePicker;
	}(_react.Component);
	
	TimePicker.defaultProps = {
	  autoOk: false,
	  cancelLabel: 'Cancel',
	  defaultTime: null,
	  disabled: false,
	  format: 'ampm',
	  okLabel: 'OK',
	  pedantic: false,
	  style: {},
	  value: null
	};
	TimePicker.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TimePicker.propTypes = {
	  /**
	   * If true, automatically accept and close the picker on set minutes.
	   */
	  autoOk: _react.PropTypes.bool,
	  /**
	   * Override the label of the 'Cancel' button.
	   */
	  cancelLabel: _react.PropTypes.node,
	  /**
	   * The initial time value of the TimePicker.
	   */
	  defaultTime: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's body element.
	   */
	  dialogBodyStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's root element.
	   */
	  dialogStyle: _react.PropTypes.object,
	  /**
	   * If true, the TimePicker is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Tells the component to display the picker in `ampm` (12hr) format or `24hr` format.
	   */
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  /**
	   * Override the label of the 'OK' button.
	   */
	  okLabel: _react.PropTypes.node,
	  /**
	   * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
	   * Since there is no particular event associated with the change the first argument will always be null
	   * and the second argument will be the new Date instance.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker dialog is dismissed.
	   */
	  onDismiss: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker `TextField` gains focus.
	   */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker dialog is shown.
	   */
	  onShow: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker is tapped or clicked.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, uses ("noon" / "midnight") instead of ("12 a.m." / "12 p.m.").
	   *
	   * It's technically more correct to refer to "12 noon" and "12 midnight" rather than "12 a.m." and "12 p.m."
	   * and it avoids confusion between different locales. By default (for compatibility reasons) TimePicker uses
	   * ("12 a.m." / "12 p.m.").
	   */
	  pedantic: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePicker's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object,
	  /**
	   * Sets the time for the Time Picker programmatically.
	   */
	  value: _react.PropTypes.object
	} : void 0;
	exports.default = TimePicker;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(57);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(35);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Clock = __webpack_require__(1075);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _Dialog = __webpack_require__(214);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(109);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePickerDialog = function (_Component) {
	  (0, _inherits3.default)(TimePickerDialog, _Component);
	
	  function TimePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOK = function () {
	      if (_this.props.onAccept) {
	        _this.props.onAccept(_this.refs.clock.getSelectedTime());
	      }
	      _this.setState({
	        open: false
	      });
	    }, _this.handleKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOK();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePickerDialog, [{
	    key: 'show',
	    value: function show() {
	      if (this.props.onShow && !this.state.open) this.props.onShow();
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bodyStyle = _props.bodyStyle,
	          initialTime = _props.initialTime,
	          onAccept = _props.onAccept,
	          format = _props.format,
	          autoOk = _props.autoOk,
	          okLabel = _props.okLabel,
	          cancelLabel = _props.cancelLabel,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['bodyStyle', 'initialTime', 'onAccept', 'format', 'autoOk', 'okLabel', 'cancelLabel', 'style']);
	
	
	      var styles = {
	        root: {
	          fontSize: 14,
	          color: this.context.muiTheme.timePicker.clockColor
	        },
	        dialogContent: {
	          width: 280
	        },
	        body: {
	          padding: 0
	        }
	      };
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        key: 0,
	        label: cancelLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapCancel
	      }), _react2.default.createElement(_FlatButton2.default, {
	        key: 1,
	        label: okLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapOK
	      })];
	
	      var onClockChangeMinutes = autoOk === true ? this.handleTouchTapOK : undefined;
	      var open = this.state.open;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          bodyStyle: (0, _simpleAssign2.default)(styles.body, bodyStyle),
	          actions: actions,
	          contentStyle: styles.dialogContent,
	          repositionOnUpdate: false,
	          open: open,
	          onRequestClose: this.handleRequestClose
	        }),
	        open && _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        open && _react2.default.createElement(_Clock2.default, {
	          ref: 'clock',
	          format: format,
	          initialTime: initialTime,
	          onChangeMinutes: onClockChangeMinutes
	        })
	      );
	    }
	  }]);
	  return TimePickerDialog;
	}(_react.Component);
	
	TimePickerDialog.defaultProps = {
	  okLabel: 'OK',
	  cancelLabel: 'Cancel'
	};
	TimePickerDialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TimePickerDialog.propTypes = {
	  autoOk: _react.PropTypes.bool,
	  bodyStyle: _react.PropTypes.object,
	  cancelLabel: _react.PropTypes.node,
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialTime: _react.PropTypes.object,
	  okLabel: _react.PropTypes.node,
	  onAccept: _react.PropTypes.func,
	  onDismiss: _react.PropTypes.func,
	  onShow: _react.PropTypes.func,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TimePickerDialog;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TimePicker = __webpack_require__(1079);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TimePicker2.default;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(31);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _EnhancedSwitch = __webpack_require__(223);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var disabled = props.disabled,
	      elementStyle = props.elementStyle,
	      trackSwitchedStyle = props.trackSwitchedStyle,
	      thumbSwitchedStyle = props.thumbSwitchedStyle,
	      trackStyle = props.trackStyle,
	      thumbStyle = props.thumbStyle,
	      iconStyle = props.iconStyle,
	      rippleStyle = props.rippleStyle,
	      labelStyle = props.labelStyle;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toggle = _context$muiTheme.toggle;
	
	
	  var toggleSize = 20;
	  var toggleTrackWidth = 36;
	  var styles = {
	    icon: {
	      width: 36,
	      padding: '4px 0px 6px 2px'
	    },
	    ripple: {
	      top: -10,
	      left: -10,
	      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
	    },
	    toggleElement: {
	      width: toggleTrackWidth
	    },
	    track: {
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      height: 14,
	      borderRadius: 30,
	      backgroundColor: toggle.trackOffColor
	    },
	    thumb: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      top: 1,
	      left: 0,
	      width: toggleSize,
	      height: toggleSize,
	      lineHeight: '24px',
	      borderRadius: '50%',
	      backgroundColor: toggle.thumbOffColor
	    },
	    trackWhenSwitched: {
	      backgroundColor: toggle.trackOnColor
	    },
	    thumbWhenSwitched: {
	      backgroundColor: toggle.thumbOnColor,
	      left: '100%'
	    },
	    trackWhenDisabled: {
	      backgroundColor: toggle.trackDisabledColor
	    },
	    thumbWhenDisabled: {
	      backgroundColor: toggle.thumbDisabledColor
	    },
	    label: {
	      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
	      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
	    }
	  };
	
	  (0, _simpleAssign2.default)(styles.track, trackStyle, state.switched && styles.trackWhenSwitched, state.switched && trackSwitchedStyle, disabled && styles.trackWhenDisabled);
	
	  (0, _simpleAssign2.default)(styles.thumb, thumbStyle, state.switched && styles.thumbWhenSwitched, state.switched && thumbSwitchedStyle, disabled && styles.thumbWhenDisabled);
	
	  if (state.switched) {
	    styles.thumb.marginLeft = 0 - styles.thumb.width;
	  }
	
	  (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	  (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	  (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	  (0, _simpleAssign2.default)(styles.toggleElement, elementStyle);
	
	  return styles;
	}
	
	var Toggle = function (_Component) {
	  (0, _inherits3.default)(Toggle, _Component);
	
	  function Toggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Toggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleToggle = function (event, isInputChecked) {
	      if (_this.props.onToggle) {
	        _this.props.onToggle(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Toggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          toggled = _props.toggled,
	          defaultToggled = _props.defaultToggled,
	          valueLink = _props.valueLink;
	
	
	      if (toggled || defaultToggled || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'isToggled',
	    value: function isToggled() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setToggled',
	    value: function setToggled(newToggledValue) {
	      this.refs.enhancedSwitch.setSwitched(newToggledValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          defaultToggled = _props2.defaultToggled,
	          elementStyle = _props2.elementStyle,
	          onToggle = _props2.onToggle,
	          trackSwitchedStyle = _props2.trackSwitchedStyle,
	          thumbSwitchedStyle = _props2.thumbSwitchedStyle,
	          toggled = _props2.toggled,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'trackSwitchedStyle', 'thumbSwitchedStyle', 'toggled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var toggleElement = _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, styles.toggleElement)) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.track)) }),
	        _react2.default.createElement(_Paper2.default, { style: styles.thumb, circle: true, zDepth: 1 })
	      );
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switchElement: toggleElement,
	        rippleStyle: styles.ripple,
	        rippleColor: styles.ripple.color,
	        iconStyle: styles.icon,
	        trackStyle: styles.track,
	        thumbStyle: styles.thumb,
	        labelStyle: styles.label,
	        switched: this.state.switched,
	        onSwitch: this.handleToggle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      if (this.props.hasOwnProperty('toggled')) {
	        enhancedSwitchProps.checked = toggled;
	      } else if (this.props.hasOwnProperty('defaultToggled')) {
	        enhancedSwitchProps.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Toggle;
	}(_react.Component);
	
	Toggle.defaultProps = {
	  defaultToggled: false,
	  disabled: false,
	  labelPosition: 'left'
	};
	Toggle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Toggle.propTypes = {
	  /**
	   * Determines whether the Toggle is initially turned on.
	   * **Warning:** This cannot be used in conjunction with `toggled`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultToggled: _react.PropTypes.bool,
	  /**
	   * Will disable the toggle if true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the inline-styles of the Toggle element.
	   */
	  elementStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the Icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * Label for toggle.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * Where the label will be placed next to the toggle.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Toggle element label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function that is fired when the toggle switch is toggled.
	   */
	  onToggle: _react.PropTypes.func,
	  /**
	   * Override style of ripple.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override style for thumb.
	   */
	  thumbStyle: _react.PropTypes.object,
	  /**
	  * Override the inline styles for thumb when the toggle switch is toggled on.
	  */
	  thumbSwitchedStyle: _react.PropTypes.object,
	  /**
	   * Toggled if set to true.
	   */
	  toggled: _react.PropTypes.bool,
	  /**
	   * Override style for track.
	   */
	  trackStyle: _react.PropTypes.object,
	  /**
	  * Override the inline styles for track when the toggle switch is toggled on.
	  */
	  trackSwitchedStyle: _react.PropTypes.object,
	  /**
	   * ValueLink prop for when using controlled toggle.
	   */
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = Toggle;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Toggle = __webpack_require__(1082);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toggle2.default;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var noGutter = props.noGutter;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      backgroundColor: toolbar.backgroundColor,
	      height: toolbar.height,
	      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
	      display: 'flex',
	      justifyContent: 'space-between'
	    }
	  };
	}
	
	var Toolbar = function (_Component) {
	  (0, _inherits3.default)(Toolbar, _Component);
	
	  function Toolbar() {
	    (0, _classCallCheck3.default)(this, Toolbar);
	    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          noGutter = _props.noGutter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Toolbar;
	}(_react.Component);
	
	Toolbar.defaultProps = {
	  noGutter: false
	};
	Toolbar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Toolbar.propTypes = {
	  /**
	   * Can be a `ToolbarGroup` to render a group of related items.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Do not apply `desktopGutter` to the `Toolbar`.
	   */
	  noGutter: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Toolbar;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(1084);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(370);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(371);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(372);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;
	exports.default = _Toolbar3.default;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = exports.Toggle = exports.TimePicker = exports.TextField = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = exports.Tab = exports.Tabs = exports.Snackbar = exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = exports.SvgIcon = exports.Subheader = exports.Slider = exports.SelectField = exports.RefreshIndicator = exports.RaisedButton = exports.RadioButtonGroup = exports.RadioButton = exports.Popover = exports.Paper = exports.MuiThemeProvider = exports.MenuItem = exports.Menu = exports.makeSelectable = exports.ListItem = exports.List = exports.LinearProgress = exports.IconMenu = exports.IconButton = exports.GridTile = exports.GridList = exports.FontIcon = exports.FloatingActionButton = exports.FlatButton = exports.DropDownMenu = exports.Drawer = exports.Divider = exports.Dialog = exports.DatePicker = exports.CircularProgress = exports.Chip = exports.Checkbox = exports.CardText = exports.CardTitle = exports.CardMedia = exports.CardHeader = exports.CardActions = exports.Card = exports.BottomNavigationItem = exports.BottomNavigation = exports.Badge = exports.Avatar = exports.AutoComplete = exports.AppBar = undefined;
	
	var _AppBar2 = __webpack_require__(999);
	
	var _AppBar3 = _interopRequireDefault(_AppBar2);
	
	var _AutoComplete2 = __webpack_require__(1001);
	
	var _AutoComplete3 = _interopRequireDefault(_AutoComplete2);
	
	var _Avatar2 = __webpack_require__(347);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	var _Badge2 = __webpack_require__(1004);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _BottomNavigation2 = __webpack_require__(1006);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(348);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	var _Card2 = __webpack_require__(1008);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardActions2 = __webpack_require__(349);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardHeader2 = __webpack_require__(351);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardMedia2 = __webpack_require__(352);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardTitle2 = __webpack_require__(354);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardText2 = __webpack_require__(353);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _Checkbox2 = __webpack_require__(108);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Chip2 = __webpack_require__(1011);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	var _CircularProgress2 = __webpack_require__(1013);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	var _DatePicker2 = __webpack_require__(1023);
	
	var _DatePicker3 = _interopRequireDefault(_DatePicker2);
	
	var _Dialog2 = __webpack_require__(214);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	var _Divider2 = __webpack_require__(355);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	var _Drawer2 = __webpack_require__(1027);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	var _DropDownMenu2 = __webpack_require__(356);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _FlatButton2 = __webpack_require__(109);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _FloatingActionButton2 = __webpack_require__(1032);
	
	var _FloatingActionButton3 = _interopRequireDefault(_FloatingActionButton2);
	
	var _FontIcon2 = __webpack_require__(139);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	var _GridList2 = __webpack_require__(1035);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(357);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	var _IconButton2 = __webpack_require__(45);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	var _IconMenu2 = __webpack_require__(1038);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _LinearProgress2 = __webpack_require__(1040);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _List2 = __webpack_require__(1042);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(216);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(358);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	var _Menu2 = __webpack_require__(359);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(140);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _MuiThemeProvider2 = __webpack_require__(1096);
	
	var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);
	
	var _Paper2 = __webpack_require__(31);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	var _Popover2 = __webpack_require__(1046);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _RadioButton2 = __webpack_require__(220);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(219);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	var _RaisedButton2 = __webpack_require__(142);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _RefreshIndicator2 = __webpack_require__(1050);
	
	var _RefreshIndicator3 = _interopRequireDefault(_RefreshIndicator2);
	
	var _SelectField2 = __webpack_require__(360);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	var _Slider2 = __webpack_require__(1053);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	var _Subheader2 = __webpack_require__(362);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	var _SvgIcon2 = __webpack_require__(22);
	
	var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);
	
	var _Step2 = __webpack_require__(1057);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(1058);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(1060);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(361);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(1061);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	var _Snackbar2 = __webpack_require__(1056);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	var _Tabs2 = __webpack_require__(1069);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(367);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Table2 = __webpack_require__(1065);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(363);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(364);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(365);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(221);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(366);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(143);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	var _TextField2 = __webpack_require__(40);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	var _TimePicker2 = __webpack_require__(1081);
	
	var _TimePicker3 = _interopRequireDefault(_TimePicker2);
	
	var _Toggle2 = __webpack_require__(1083);
	
	var _Toggle3 = _interopRequireDefault(_Toggle2);
	
	var _Toolbar2 = __webpack_require__(1085);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(370);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(371);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(372);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppBar = _AppBar3.default;
	exports.AutoComplete = _AutoComplete3.default;
	exports.Avatar = _Avatar3.default;
	exports.Badge = _Badge3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.Card = _Card3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardText = _CardText3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Chip = _Chip3.default;
	exports.CircularProgress = _CircularProgress3.default;
	exports.DatePicker = _DatePicker3.default;
	exports.Dialog = _Dialog3.default;
	exports.Divider = _Divider3.default;
	exports.Drawer = _Drawer3.default;
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.FloatingActionButton = _FloatingActionButton3.default;
	exports.FontIcon = _FontIcon3.default;
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.IconButton = _IconButton3.default;
	exports.IconMenu = _IconMenu3.default;
	exports.LinearProgress = _LinearProgress3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.MuiThemeProvider = _MuiThemeProvider3.default;
	exports.Paper = _Paper3.default;
	exports.Popover = _Popover3.default;
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.RefreshIndicator = _RefreshIndicator3.default;
	exports.SelectField = _SelectField3.default;
	exports.Slider = _Slider3.default;
	exports.Subheader = _Subheader3.default;
	exports.SvgIcon = _SvgIcon3.default;
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;
	exports.Snackbar = _Snackbar3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.TextField = _TextField3.default;
	exports.TimePicker = _TimePicker3.default;
	exports.Toggle = _Toggle3.default;
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  (0, _inherits3.default)(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) {
	        this.preventScrolling();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) {
	        return;
	      }
	
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return AutoLockScrolling;
	}(_react.Component);
	
	 false ? AutoLockScrolling.propTypes = {
	  lock: _react.PropTypes.bool.isRequired
	} : void 0;
	exports.default = AutoLockScrolling;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  (0, _inherits3.default)(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          beforeStyle = _props.beforeStyle,
	          afterStyle = _props.afterStyle,
	          beforeElementType = _props.beforeElementType,
	          afterElementType = _props.afterElementType,
	          elementType = _props.elementType,
	          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? BeforeAfterWrapper.propTypes = {
	  afterElementType: _react.PropTypes.string,
	  afterStyle: _react.PropTypes.object,
	  beforeElementType: _react.PropTypes.string,
	  beforeStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  elementType: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = BeforeAfterWrapper;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(79);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(73);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CircleRipple.propTypes = {
	  aborted: _react.PropTypes.bool,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  touchGenerated: _react.PropTypes.bool
	} : void 0;
	exports.default = CircleRipple;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BeforeAfterWrapper = __webpack_require__(1088);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    (0, _extends3.default)({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	 false ? ClearFix.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = ClearFix;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(116);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(1092);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandTransition = function (_Component) {
	  (0, _inherits3.default)(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    (0, _classCallCheck3.default)(this, ExpandTransition);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          enterDelay = _props2.enterDelay,
	          loading = _props2.loading,
	          open = _props2.open,
	          style = _props2.style,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: 'auto'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ExpandTransition.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  loading: _react.PropTypes.bool,
	  open: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = ExpandTransition;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  (0, _inherits3.default)(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
	          style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          enterDelay = _props3.enterDelay,
	          style = _props3.style,
	          transitionDelay = _props3.transitionDelay,
	          transitionDuration = _props3.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ExpandTransitionChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = ExpandTransitionChild;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(116);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ScaleInChild = __webpack_require__(1094);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ScaleIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ScaleIn;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(73);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ScaleInChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ScaleInChild;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(9);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(73);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideInChild = function (_Component) {
	  (0, _inherits3.default)(SlideInChild, _Component);
	
	  function SlideInChild() {
	    (0, _classCallCheck3.default)(this, SlideInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (SlideInChild.__proto__ || (0, _getPrototypeOf2.default)(SlideInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SlideInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var direction = this.props.getLeaveDirection();
	      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          getLeaveDirection = _props.getLeaveDirection,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return SlideInChild;
	}(_react.Component);
	
	SlideInChild.defaultProps = {
	  enterDelay: 0
	};
	SlideInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SlideInChild.propTypes = {
	  children: _react.PropTypes.node,
	  direction: _react.PropTypes.string,
	  enterDelay: _react.PropTypes.number,
	  // This callback is needed bacause the direction could change when leaving the DOM
	  getLeaveDirection: _react.PropTypes.func.isRequired,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = SlideInChild;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _getMuiTheme = __webpack_require__(377);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? MuiThemeProvider.propTypes = {
	  children: _react.PropTypes.element,
	  muiTheme: _react.PropTypes.object
	} : void 0;
	exports.default = MuiThemeProvider;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(144);
	
	var _colorManipulator = __webpack_require__(55);
	
	var _spacing = __webpack_require__(378);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	  );
	};
	HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
	HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
	HardwareKeyboardArrowDown.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	  );
	};
	HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
	HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
	HardwareKeyboardArrowUp.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCancel = function NavigationCancel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
	  );
	};
	NavigationCancel = (0, _pure2.default)(NavigationCancel);
	NavigationCancel.displayName = 'NavigationCancel';
	NavigationCancel.muiName = 'SvgIcon';
	
	exports.default = NavigationCancel;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = function NavigationChevronLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
	NavigationChevronLeft.displayName = 'NavigationChevronLeft';
	NavigationChevronLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronLeft;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = function NavigationChevronRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
	NavigationChevronRight.displayName = 'NavigationChevronRight';
	NavigationChevronRight.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronRight;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = function NavigationMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	  );
	};
	NavigationMenu = (0, _pure2.default)(NavigationMenu);
	NavigationMenu.displayName = 'NavigationMenu';
	NavigationMenu.muiName = 'SvgIcon';
	
	exports.default = NavigationMenu;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
	ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
	ToggleRadioButtonChecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonChecked;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(25);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(22);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
	ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
	ToggleRadioButtonUnchecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonUnchecked;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(50);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = _inlineStylePrefixer2.default.prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var _ret = function () {
	      var prefixer = new _inlineStylePrefixer2.default({
	        userAgent: userAgent
	      });
	
	      return {
	        v: function v(style) {
	          return prefixer.prefix(style);
	        }
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	  }
	};
	
	var _inlineStylePrefixer = __webpack_require__(861);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {}; /**
	                  * This module is taken from https://github.com/react-bootstrap/react-prop-types.
	                  * It's not a dependency to reduce build size / install time.
	                  * It should be pretty stable.
	                  */
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	       false ? (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason)) : void 0;
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	* Returns a number of pixels from the top of the screen for given dom element.
	*
	* @param {object} dom element
	* @returns {number} A position from the top of the screen in pixels
	*/
	var getOffsetTop = exports.getOffsetTop = function getOffsetTop(elem) {
	  var yPos = elem.offsetTop;
	  var tempEl = elem.offsetParent;
	
	  while (tempEl != null) {
	    yPos += tempEl.offsetTop;
	    tempEl = tempEl.offsetParent;
	  }
	
	  return yPos;
	};
	
	var isIOS = exports.isIOS = function isIOS() {
	  return (/iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream
	  );
	};

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(166);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withWidth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(57);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SMALL = exports.SMALL = 1;
	var MEDIUM = exports.MEDIUM = 2;
	var LARGE = exports.LARGE = 3;
	
	function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$largeWidth = options.largeWidth,
	      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
	      _options$mediumWidth = options.mediumWidth,
	      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
	      _options$resizeInterv = options.resizeInterval,
	      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  return function (MyComponent) {
	    return function (_Component) {
	      (0, _inherits3.default)(WithWidth, _Component);
	
	      function WithWidth() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, WithWidth);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: null
	        }, _this.handleResize = function () {
	          clearTimeout(_this.deferTimer);
	          _this.deferTimer = setTimeout(function () {
	            _this.updateWidth();
	          }, resizeInterval);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(WithWidth, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.deferTimer);
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth() {
	          var innerWidth = window.innerWidth;
	          var width = void 0;
	
	          if (innerWidth >= largeWidth) {
	            width = LARGE;
	          } else if (innerWidth >= mediumWidth) {
	            width = MEDIUM;
	          } else {
	            // innerWidth < 768
	            width = SMALL;
	          }
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var width = this.state.width;
	
	          /**
	           * When rendering the component on the server,
	           * we have no idea about the screen width.
	           * In order to prevent blinks and help the reconciliation
	           * we are not rendering the component.
	           *
	           * A better alternative would be to send client hints.
	           * But the browser support of this API is low:
	           * http://caniuse.com/#search=client%20hint
	           */
	          if (width === null) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            _react2.default.createElement(MyComponent, (0, _extends3.default)({
	              width: width
	            }, this.props))
	          );
	        }
	      }]);
	      return WithWidth;
	    }(_react.Component);
	  };
	}

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {(function() {
	"use strict";
	/* global moment, angular */
	
	var module = angular.module("mdPickers", [
		"ngMaterial",
		"ngAnimate",
		"ngAria"
	]);
	
	module.config(["$mdIconProvider", "mdpIconsRegistry", function($mdIconProvider, mdpIconsRegistry) {
		angular.forEach(mdpIconsRegistry, function(icon, index) {
			$mdIconProvider.icon(icon.id, icon.url);
		});
	}]);
	
	module.run(["$templateCache", "mdpIconsRegistry", function($templateCache, mdpIconsRegistry) {
		angular.forEach(mdpIconsRegistry, function(icon, index) {
			$templateCache.put(icon.url, icon.svg);
		});
	}]);
	module.constant("mdpIconsRegistry", [
	    {
	        id: 'mdp-chevron-left',
	        url: 'mdp-chevron-left.svg',
	        svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
	    },
	    {
	        id: 'mdp-chevron-right',
	        url: 'mdp-chevron-right.svg',
	        svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
	    },
	    {
	        id: 'mdp-access-time',
	        url: 'mdp-access-time.svg',
	        svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/><path d="M0 0h24v24H0z" fill="none"/><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>'
	    },
	    {
	        id: 'mdp-event',
	        url: 'mdp-event.svg',
	        svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
	    }
	]);
	module.directive("ngMessage", ["$mdUtil", function($mdUtil) {
	   return {
	        restrict: "EA",
	        priority: 101,
	        compile: function(element) {
	            var inputContainer = $mdUtil.getClosest(element, "mdp-time-picker", true) ||
	                                 $mdUtil.getClosest(element, "mdp-date-picker", true);
	            
	            // If we are not a child of an input container, don't do anything
	            if (!inputContainer) return;
	            
	            // Add our animation class
	            element.toggleClass('md-input-message-animation', true);
	            
	            return {};
	        }
	    } 
	}]);
	/* global moment, angular */
	
	function DatePickerCtrl($scope, $mdDialog, $mdMedia, $timeout, currentDate, options) {
	    var self = this;
	
	    this.date = moment(currentDate);
	    this.minDate = options.minDate && moment(options.minDate).isValid() ? moment(options.minDate) : null;
	    this.maxDate = options.maxDate && moment(options.maxDate).isValid() ? moment(options.maxDate) : null;
	    this.displayFormat = options.displayFormat || "ddd, MMM DD";
	    this.dateFilter = angular.isFunction(options.dateFilter) ? options.dateFilter : null;
	    this.selectingYear = false;
	    
	    // validate min and max date
		if (this.minDate && this.maxDate) {
			if (this.maxDate.isBefore(this.minDate)) {
				this.maxDate = moment(this.minDate).add(1, 'days');
			}
		}
		
		if (this.date) {
			// check min date
	    	if (this.minDate && this.date.isBefore(this.minDate)) {
				this.date = moment(this.minDate);
	    	}
	    	
	    	// check max date
	    	if (this.maxDate && this.date.isAfter(this.maxDate)) {
				this.date = moment(this.maxDate);
	    	}
		}
		
		this.yearItems = {
	        currentIndex_: 0,
	        PAGE_SIZE: 5,
	        START: (self.minDate ? self.minDate.year() : 1900),
	        END: (self.maxDate ? self.maxDate.year() : 0),
	        getItemAtIndex: function(index) {
	        	if(this.currentIndex_ < index)
	                this.currentIndex_ = index;
	        	
	        	return this.START + index;
	        },
	        getLength: function() {
	            return Math.min(
	                this.currentIndex_ + Math.floor(this.PAGE_SIZE / 2),
	                Math.abs(this.START - this.END) + 1
	            );
	        }
	    };
	
	    $scope.$mdMedia = $mdMedia;
	    $scope.year = this.date.year();
	
		this.selectYear = function(year) {
	        self.date.year(year);
	        $scope.year = year;
	        self.selectingYear = false;
	        self.animate();
	    };
	    
	    this.showYear = function() { 
	        self.yearTopIndex = (self.date.year() - self.yearItems.START) + Math.floor(self.yearItems.PAGE_SIZE / 2);
	        self.yearItems.currentIndex_ = (self.date.year() - self.yearItems.START) + 1;
	        self.selectingYear = true;
	    };
	    
	    this.showCalendar = function() {
	        self.selectingYear = false;
	    };
	
	    this.cancel = function() {
	        $mdDialog.cancel();
	    };
	
	    this.confirm = function() {
	    	var date = this.date;
	    	
	    	if (this.minDate && this.date.isBefore(this.minDate)) {
	    		date = moment(this.minDate);
	    	}
	    	
	    	if (this.maxDate && this.date.isAfter(this.maxDate)) {
	    		date = moment(this.maxDate);
	    	}  	
	    	
	        $mdDialog.hide(date.toDate());
	    };
	    
	    this.animate = function() {
	        self.animating = true;
	        $timeout(angular.noop).then(function() {
	            self.animating = false;
	        })  
	    };
	}
	
	module.provider("$mdpDatePicker", function() {
	    var LABEL_OK = "OK",
	        LABEL_CANCEL = "Cancel",
	        DISPLAY_FORMAT = "ddd, MMM DD";
	        
	    this.setDisplayFormat = function(format) {
	        DISPLAY_FORMAT = format;    
	    };
	        
	    this.setOKButtonLabel = function(label) {
	        LABEL_OK = label;
	    };
	    
	    this.setCancelButtonLabel = function(label) {
	        LABEL_CANCEL = label;
	    };
	    
	    this.$get = ["$mdDialog", function($mdDialog) {
	        var datePicker = function(currentDate, options) {
	            if (!angular.isDate(currentDate)) currentDate = Date.now();
	            if (!angular.isObject(options)) options = {};
	            
	            options.displayFormat = DISPLAY_FORMAT;
	    
	            return $mdDialog.show({
	                controller:  ['$scope', '$mdDialog', '$mdMedia', '$timeout', 'currentDate', 'options', DatePickerCtrl],
	                controllerAs: 'datepicker',
	                clickOutsideToClose: true,
	                template: '<md-dialog aria-label="" class="mdp-datepicker" ng-class="{ \'portrait\': !$mdMedia(\'gt-xs\') }">' +
	                            '<md-dialog-content layout="row" layout-wrap>' +
	                                '<div layout="column" layout-align="start center">' +
	                                    '<md-toolbar layout-align="start start" flex class="mdp-datepicker-date-wrapper md-hue-1 md-primary" layout="column">' +
	                                        '<span class="mdp-datepicker-year" ng-click="datepicker.showYear()" ng-class="{ \'active\': datepicker.selectingYear }">{{ datepicker.date.format(\'YYYY\') }}</span>' +
	                                        '<span class="mdp-datepicker-date" ng-click="datepicker.showCalendar()" ng-class="{ \'active\': !datepicker.selectingYear }">{{ datepicker.date.format(datepicker.displayFormat) }}</span> ' +
	                                    '</md-toolbar>' + 
	                                '</div>' +  
	                                '<div>' + 
	                                    '<div class="mdp-datepicker-select-year mdp-animation-zoom" layout="column" layout-align="center start" ng-if="datepicker.selectingYear">' +
	                                        '<md-virtual-repeat-container md-auto-shrink md-top-index="datepicker.yearTopIndex">' +
	                                            '<div flex md-virtual-repeat="item in datepicker.yearItems" md-on-demand class="repeated-year">' +
	                                                '<span class="md-button" ng-click="datepicker.selectYear(item)" md-ink-ripple ng-class="{ \'md-primary current\': item == year }">{{ item }}</span>' +
	                                            '</div>' +
	                                        '</md-virtual-repeat-container>' +
	                                    '</div>' +
	                                    '<mdp-calendar ng-if="!datepicker.selectingYear" class="mdp-animation-zoom" date="datepicker.date" min-date="datepicker.minDate" date-filter="datepicker.dateFilter" max-date="datepicker.maxDate"></mdp-calendar>' +
	                                    '<md-dialog-actions layout="row">' +
	                                    	'<span flex></span>' +
	                                        '<md-button ng-click="datepicker.cancel()" aria-label="' + LABEL_CANCEL + '">' + LABEL_CANCEL + '</md-button>' +
	                                        '<md-button ng-click="datepicker.confirm()" class="md-primary" aria-label="' + LABEL_OK + '">' + LABEL_OK + '</md-button>' +
	                                    '</md-dialog-actions>' +
	                                '</div>' +
	                            '</md-dialog-content>' +
	                        '</md-dialog>',
	                targetEvent: options.targetEvent,
	                locals: {
	                    currentDate: currentDate,
	                    options: options
	                },
	                skipHide: true
	            });
	        };
	    
	        return datePicker;
	    }];
	});
	
	function CalendarCtrl($scope) {
		var self = this;
		this.dow = moment.localeData().firstDayOfWeek();
		
	    this.weekDays = [].concat(
	        moment.weekdaysMin().slice(
	            this.dow
	        ),
	        moment.weekdaysMin().slice(
	            0, 
	            this.dow
	        )
	    );
	    
	    this.daysInMonth = [];
	    
	    this.getDaysInMonth = function() {
	        var days = self.date.daysInMonth(),
	            firstDay = moment(self.date).date(1).day() - this.dow;
	            
	        if(firstDay < 0) firstDay = this.weekDays.length - 1;
	            
	
	        var arr = [];
	        for(var i = 1; i <= (firstDay + days); i++) {
	            var day = null;
	            if(i > firstDay) {
	                day =  {
	                    value: (i - firstDay),
	                    enabled: self.isDayEnabled(moment(self.date).date(i - firstDay).toDate())
	                };
	            }
	            arr.push(day);
	        }
	 
	        return arr;
	    };
	    
	    this.isDayEnabled = function(day) {
	        return (!this.minDate || this.minDate <= day) && 
	            (!this.maxDate || this.maxDate >= day) && 
	            (!self.dateFilter || !self.dateFilter(day));
	    };
	    
	    this.selectDate = function(dom) {
	        self.date.date(dom);
	    };
	
	    this.nextMonth = function() {
	        self.date.add(1, 'months');
	    };
	
	    this.prevMonth = function() {
	        self.date.subtract(1, 'months');
	    };
	    
	    this.updateDaysInMonth = function() {
	        self.daysInMonth = self.getDaysInMonth();
	    };
	    
	    $scope.$watch(function() { return  self.date.unix() }, function(newValue, oldValue) {
	        if(newValue && newValue !== oldValue)
	            self.updateDaysInMonth();
	    })
	    
	    self.updateDaysInMonth();
	}
	
	module.directive("mdpCalendar", ["$animate", function($animate) {
	    return {
	        restrict: 'E',
	        bindToController: {
	            "date": "=",
	            "minDate": "=",
	            "maxDate": "=",
	            "dateFilter": "="
	        },
	        template: '<div class="mdp-calendar">' +
	                    '<div layout="row" layout-align="space-between center">' +
	                        '<md-button aria-label="previous month" class="md-icon-button" ng-click="calendar.prevMonth()"><md-icon md-svg-icon="mdp-chevron-left"></md-icon></md-button>' +
	                        '<div class="mdp-calendar-monthyear" ng-show="!calendar.animating">{{ calendar.date.format("MMMM YYYY") }}</div>' +
	                        '<md-button aria-label="next month" class="md-icon-button" ng-click="calendar.nextMonth()"><md-icon md-svg-icon="mdp-chevron-right"></md-icon></md-button>' +
	                    '</div>' +
	                    '<div layout="row" layout-align="space-around center" class="mdp-calendar-week-days" ng-show="!calendar.animating">' +
	                        '<div layout layout-align="center center" ng-repeat="d in calendar.weekDays track by $index">{{ d }}</div>' +
	                    '</div>' +
	                    '<div layout="row" layout-align="start center" layout-wrap class="mdp-calendar-days" ng-class="{ \'mdp-animate-next\': calendar.animating }" ng-show="!calendar.animating" md-swipe-left="calendar.nextMonth()" md-swipe-right="calendar.prevMonth()">' +
	                        '<div layout layout-align="center center" ng-repeat-start="day in calendar.daysInMonth track by $index" ng-class="{ \'mdp-day-placeholder\': !day }">' +
	                            '<md-button class="md-icon-button md-raised" aria-label="Select day" ng-if="day" ng-class="{ \'md-accent\': calendar.date.date() == day.value }" ng-click="calendar.selectDate(day.value)" ng-disabled="!day.enabled">{{ day.value }}</md-button>' +
	                        '</div>' +
	                        '<div flex="100" ng-if="($index + 1) % 7 == 0" ng-repeat-end></div>' +
	                    '</div>' +
	                '</div>',
	        controller: ["$scope", CalendarCtrl],
	        controllerAs: "calendar",
	        link: function(scope, element, attrs, ctrl) {
	            var animElements = [
	                element[0].querySelector(".mdp-calendar-week-days"),
	                element[0].querySelector('.mdp-calendar-days'),
	                element[0].querySelector('.mdp-calendar-monthyear')
	            ].map(function(a) {
	               return angular.element(a); 
	            });
	                
	            scope.$watch(function() { return  ctrl.date.format("YYYYMM") }, function(newValue, oldValue) {
	                var direction = null;
	                
	                if(newValue > oldValue)
	                    direction = "mdp-animate-next";
	                else if(newValue < oldValue)
	                    direction = "mdp-animate-prev";
	                
	                if(direction) {
	                    for(var i in animElements) {
	                        animElements[i].addClass(direction);
	                        $animate.removeClass(animElements[i], direction);
	                    }
	                }
	            });
	        }
	    }
	}]);
	
	function formatValidator(value, format) {
	    return !value || angular.isDate(value) || moment(value, format, true).isValid();
	}
	
	function minDateValidator(value, format, minDate) {
	    var minDate = moment(minDate, "YYYY-MM-DD", true);
	    var date = angular.isDate(value) ? moment(value) :  moment(value, format, true);
	    
	    return !value || 
	            angular.isDate(value) || 
	            !minDate.isValid() || 
	            date.isSameOrAfter(minDate);
	}
	
	function maxDateValidator(value, format, maxDate) {
	    var maxDate = moment(maxDate, "YYYY-MM-DD", true);
	    var date = angular.isDate(value) ? moment(value) :  moment(value, format, true);
	    
	    return !value || 
	            angular.isDate(value) || 
	            !maxDate.isValid() || 
	            date.isSameOrBefore(maxDate);
	}
	
	function filterValidator(value, format, filter) {
	    var date = angular.isDate(value) ? moment(value) :  moment(value, format, true);
	                
	    return !value || 
	            angular.isDate(value) || 
	            !angular.isFunction(filter) || 
	            !filter(date);
	}
	
	function requiredValidator(value, ngModel) {
	    return value
	}
	
	module.directive("mdpDatePicker", ["$mdpDatePicker", "$timeout", function($mdpDatePicker, $timeout) {
	    return  {
	        restrict: 'E',
	        require: 'ngModel',
	        transclude: true,
	        template: function(element, attrs) {
	            var noFloat = angular.isDefined(attrs.mdpNoFloat),
	                placeholder = angular.isDefined(attrs.mdpPlaceholder) ? attrs.mdpPlaceholder : "",
	                openOnClick = angular.isDefined(attrs.mdpOpenOnClick) ? true : false;
	            
	            return '<div layout layout-align="start start">' +
	                    '<md-button' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + ' class="md-icon-button" ng-click="showPicker($event)">' +
	                        '<md-icon md-svg-icon="mdp-event"></md-icon>' +
	                    '</md-button>' +
	                    '<md-input-container' + (noFloat ? ' md-no-float' : '') + ' md-is-error="isError()">' +
	                        '<input type="{{ ::type }}"' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + ' aria-label="' + placeholder + '" placeholder="' + placeholder + '"' + (openOnClick ? ' ng-click="showPicker($event)" ' : '') + ' />' +
	                    '</md-input-container>' +
	                '</div>';
	        },
	        scope: {
	            "minDate": "=mdpMinDate",
	            "maxDate": "=mdpMaxDate",
	            "dateFilter": "=mdpDateFilter",
	            "dateFormat": "@mdpFormat",
	            "placeholder": "@mdpPlaceholder",
	            "noFloat": "=mdpNoFloat",
	            "openOnClick": "=mdpOpenOnClick",
	            "disabled": "=?mdpDisabled"
	        },
	        link: {
	            pre: function(scope, element, attrs, ngModel, $transclude) {
	                
	            },
	            post: function(scope, element, attrs, ngModel, $transclude) {
	                var inputElement = angular.element(element[0].querySelector('input')),
	                    inputContainer = angular.element(element[0].querySelector('md-input-container')),
	                    inputContainerCtrl = inputContainer.controller("mdInputContainer");
	                    
	                $transclude(function(clone) {
	                   inputContainer.append(clone); 
	                });  
	                
	                var messages = angular.element(inputContainer[0].querySelector("[ng-messages]"));
	                
	                scope.type = scope.dateFormat ? "text" : "date"
	                scope.dateFormat = scope.dateFormat || "YYYY-MM-DD";
	                scope.model = ngModel;
	                
	                scope.isError = function() {
	                    return !ngModel.$pristine && !!ngModel.$invalid;
	                };
	                
	                // update input element if model has changed
	                ngModel.$formatters.unshift(function(value) {
	                    var date = angular.isDate(value) && moment(value);
	                    if(date && date.isValid()) 
	                        updateInputElement(date.format(scope.dateFormat));
	                    else
	                        updateInputElement(null);
	                });
	                
	                ngModel.$validators.format = function(modelValue, viewValue) {
	                    return formatValidator(viewValue, scope.dateFormat);
	                };
	                
	                ngModel.$validators.minDate = function(modelValue, viewValue) {
	                    return minDateValidator(viewValue, scope.dateFormat, scope.minDate);
	                };
	                
	                ngModel.$validators.maxDate = function(modelValue, viewValue) {
	                    return maxDateValidator(viewValue, scope.dateFormat, scope.maxDate);
	                };
	                
	                ngModel.$validators.filter = function(modelValue, viewValue) {
	                    return filterValidator(viewValue, scope.dateFormat, scope.dateFilter);
	                };
	                
	                ngModel.$validators.required = function(modelValue, viewValue) {
	                    return angular.isUndefined(attrs.required) || !ngModel.$isEmpty(modelValue) || !ngModel.$isEmpty(viewValue);
	                };
	                
	                ngModel.$parsers.unshift(function(value) {
	                    var parsed = moment(value, scope.dateFormat, true);
	                    if(parsed.isValid()) {
	                        if(angular.isDate(ngModel.$modelValue)) {
	                            var originalModel = moment(ngModel.$modelValue);
	                            originalModel.year(parsed.year());
	                            originalModel.month(parsed.month());
	                            originalModel.date(parsed.date());
	                            
	                            parsed = originalModel;
	                        }
	                        return parsed.toDate(); 
	                    } else
	                        return null;
	                });
	                
	                // update input element value
	                function updateInputElement(value) {
	                    inputElement[0].value = value;
	                    inputContainerCtrl.setHasValue(!ngModel.$isEmpty(value));
	                }
	                
	                function updateDate(date) {
	                    var value = moment(date, angular.isDate(date) ? null : scope.dateFormat, true),
	                        strValue = value.format(scope.dateFormat);
	    
	                    if(value.isValid()) {
	                        updateInputElement(strValue);
	                        ngModel.$setViewValue(strValue);
	                    } else {
	                        updateInputElement(date);
	                        ngModel.$setViewValue(date);
	                    }
	                    
	                    if(!ngModel.$pristine && 
	                        messages.hasClass("md-auto-hide") && 
	                        inputContainer.hasClass("md-input-invalid")) messages.removeClass("md-auto-hide");
	    
	                    ngModel.$render();
	                }
	                    
	                scope.showPicker = function(ev) {
	                    $mdpDatePicker(ngModel.$modelValue, {
	                	    minDate: scope.minDate, 
	                	    maxDate: scope.maxDate,
	                	    dateFilter: scope.dateFilter,
	                	    targetEvent: ev
	            	    }).then(updateDate);
	                };
	                
	                function onInputElementEvents(event) {
	                    if(event.target.value !== ngModel.$viewVaue)
	                        updateDate(event.target.value);
	                }
	                
	                inputElement.on("reset input blur", onInputElementEvents);
	                
	                scope.$on("$destroy", function() {
	                    inputElement.off("reset input blur", onInputElementEvents);
	                });
	            }
	        }
	    };
	}]);
	
	
	module.directive("mdpDatePicker", ["$mdpDatePicker", "$timeout", function($mdpDatePicker, $timeout) {
	    return  {
	        restrict: 'A',
	        require: 'ngModel',
	        scope: {
	            "minDate": "@min",
	            "maxDate": "@max",
	            "dateFilter": "=mdpDateFilter",
	            "dateFormat": "@mdpFormat",
	        },
	        link: function(scope, element, attrs, ngModel, $transclude) {
	            scope.dateFormat = scope.dateFormat || "YYYY-MM-DD";
	            
	            ngModel.$validators.format = function(modelValue, viewValue) {
	                return formatValidator(viewValue, scope.format);
	            };
	            
	            ngModel.$validators.minDate = function(modelValue, viewValue) {
	                return minDateValidator(viewValue, scope.format, scope.minDate);
	            };
	            
	            ngModel.$validators.maxDate = function(modelValue, viewValue) {
	                return maxDateValidator(viewValue, scope.format, scope.maxDate);
	            };
	            
	            ngModel.$validators.filter = function(modelValue, viewValue) {
	                return filterValidator(viewValue, scope.format, scope.dateFilter);
	            };
	            
	            function showPicker(ev) {
	                $mdpDatePicker(ngModel.$modelValue, {
	            	    minDate: scope.minDate, 
	            	    maxDate: scope.maxDate,
	            	    dateFilter: scope.dateFilter,
	            	    targetEvent: ev
	        	    }).then(function(time) {
	                    ngModel.$setViewValue(moment(time).format(scope.format));
	                    ngModel.$render();
	                });
	            };
	            
	            element.on("click", showPicker);
	            
	            scope.$on("$destroy", function() {
	                element.off("click", showPicker);
	            });
	        }
	    }
	}]);
	/* global moment, angular */
	
	function TimePickerCtrl($scope, $mdDialog, time, autoSwitch, $mdMedia) {
		var self = this;
	    this.VIEW_HOURS = 1;
	    this.VIEW_MINUTES = 2;
	    this.currentView = this.VIEW_HOURS;
	    this.time = moment(time);
	    this.autoSwitch = !!autoSwitch;
	    
	    this.clockHours = parseInt(this.time.format("h"));
	    this.clockMinutes = parseInt(this.time.minutes());
	    
		$scope.$mdMedia = $mdMedia;
		
		this.switchView = function() {
		    self.currentView = self.currentView == self.VIEW_HOURS ? self.VIEW_MINUTES : self.VIEW_HOURS;
		};
	    
		this.setAM = function() {
	        if(self.time.hours() >= 12)
	            self.time.hour(self.time.hour() - 12);
		};
	    
	    this.setPM = function() {
	        if(self.time.hours() < 12)
	            self.time.hour(self.time.hour() + 12);
		};
	    
	    this.cancel = function() {
	        $mdDialog.cancel();
	    };
	
	    this.confirm = function() {
	        $mdDialog.hide(this.time.toDate());
	    };
	}
	
	function ClockCtrl($scope) {
	    var TYPE_HOURS = "hours";
	    var TYPE_MINUTES = "minutes";
	    var self = this;
	    
	    this.STEP_DEG = 360 / 12;
	    this.steps = [];
	    
	    this.CLOCK_TYPES = {
	        "hours": {
	            range: 12,
	        },
	        "minutes": {
	            range: 60,
	        }
	    }
	    
	    this.getPointerStyle = function() {
	        var divider = 1;
	        switch(self.type) {
	            case TYPE_HOURS:
	                divider = 12;
	                break;
	            case TYPE_MINUTES:
	                divider = 60;
	                break;
	        }  
	        var degrees = Math.round(self.selected * (360 / divider)) - 180;
	        return { 
	            "-webkit-transform": "rotate(" + degrees + "deg)",
	            "-ms-transform": "rotate(" + degrees + "deg)",
	            "transform": "rotate(" + degrees + "deg)"
	        }
	    };
	    
	    this.setTimeByDeg = function(deg) {
	        deg = deg >= 360 ? 0 : deg;
	        var divider = 0;
	        switch(self.type) {
	            case TYPE_HOURS:
	                divider = 12;
	                break;
	            case TYPE_MINUTES:
	                divider = 60;
	                break;
	        }  
	        
	        self.setTime(
	            Math.round(divider / 360 * deg)
	        );
	    };
	    
	    this.setTime = function(time, type) {
	        this.selected = time;
	        
	        switch(self.type) {
	            case TYPE_HOURS:
	                if(self.time.format("A") == "PM") time += 12;
	                this.time.hours(time);
	                break;
	            case TYPE_MINUTES:
	                if(time > 59) time -= 60;
	                this.time.minutes(time);
	                break;
	        }
	        
	    };
	    
	    this.init = function() {
	        self.type = self.type || "hours";
	        switch(self.type) {
	            case TYPE_HOURS:
	                for(var i = 1; i <= 12; i++)
	                    self.steps.push(i);
	                self.selected = self.time.hours() || 0;
	                if(self.selected > 12) self.selected -= 12;
	                    
	                break;
	            case TYPE_MINUTES:
	                for(var i = 5; i <= 55; i+=5)
	                    self.steps.push(i);
	                self.steps.push(0);
	                self.selected = self.time.minutes() || 0;
	                
	                break;
	        }
	    };
	    
	    this.init();
	}
	
	module.directive("mdpClock", ["$animate", "$timeout", function($animate, $timeout) {
	    return {
	        restrict: 'E',
	        bindToController: {
	            'type': '@?',
	            'time': '=',
	            'autoSwitch': '=?'
	        },
	        replace: true,
	        template: '<div class="mdp-clock">' +
	                        '<div class="mdp-clock-container">' +
	                            '<md-toolbar class="mdp-clock-center md-primary"></md-toolbar>' +
	                            '<md-toolbar ng-style="clock.getPointerStyle()" class="mdp-pointer md-primary">' +
	                                '<span class="mdp-clock-selected md-button md-raised md-primary"></span>' +
	                            '</md-toolbar>' +
	                            '<md-button ng-class="{ \'md-primary\': clock.selected == step }" class="md-icon-button md-raised mdp-clock-deg{{ ::(clock.STEP_DEG * ($index + 1)) }}" ng-repeat="step in clock.steps" ng-click="clock.setTime(step)">{{ step }}</md-button>' +
	                        '</div>' +
	                    '</div>',
	        controller: ["$scope", ClockCtrl],
	        controllerAs: "clock",
	        link: function(scope, element, attrs, ctrl) {
	            var pointer = angular.element(element[0].querySelector(".mdp-pointer")),
	                timepickerCtrl = scope.$parent.timepicker;
	            
	            var onEvent = function(event) {
	                var containerCoords = event.currentTarget.getClientRects()[0];
	                var x = ((event.currentTarget.offsetWidth / 2) - (event.pageX - containerCoords.left)),
	                    y = ((event.pageY - containerCoords.top) - (event.currentTarget.offsetHeight / 2));
	
	                var deg = Math.round((Math.atan2(x, y) * (180 / Math.PI)));
	                $timeout(function() {
	                    ctrl.setTimeByDeg(deg + 180);
	                    if(ctrl.autoSwitch && ["mouseup", "click"].indexOf(event.type) !== -1 && timepickerCtrl) timepickerCtrl.switchView();
	                });
	            }; 
	            
	            element.on("mousedown", function() {
	               element.on("mousemove", onEvent);
	            });
	            
	            element.on("mouseup", function(e) {
	                element.off("mousemove");
	            });
	            
	            element.on("click", onEvent);
	            scope.$on("$destroy", function() {
	                element.off("click", onEvent);
	                element.off("mousemove", onEvent); 
	            });
	        }
	    }
	}]);
	
	module.provider("$mdpTimePicker", function() {
	    var LABEL_OK = "OK",
	        LABEL_CANCEL = "Cancel";
	        
	    this.setOKButtonLabel = function(label) {
	        LABEL_OK = label;
	    };
	    
	    this.setCancelButtonLabel = function(label) {
	        LABEL_CANCEL = label;
	    };
	    
	    this.$get = ["$mdDialog", function($mdDialog) {
	        var timePicker = function(time, options) {
	            if(!angular.isDate(time)) time = Date.now();
	            if (!angular.isObject(options)) options = {};
	    
	            return $mdDialog.show({
	                controller:  ['$scope', '$mdDialog', 'time', 'autoSwitch', '$mdMedia', TimePickerCtrl],
	                controllerAs: 'timepicker',
	                clickOutsideToClose: true,
	                template: '<md-dialog aria-label="" class="mdp-timepicker" ng-class="{ \'portrait\': !$mdMedia(\'gt-xs\') }">' +
	                            '<md-dialog-content layout-gt-xs="row" layout-wrap>' +
	                                '<md-toolbar layout-gt-xs="column" layout-xs="row" layout-align="center center" flex class="mdp-timepicker-time md-hue-1 md-primary">' +
	                                    '<div class="mdp-timepicker-selected-time">' +
	                                        '<span ng-class="{ \'active\': timepicker.currentView == timepicker.VIEW_HOURS }" ng-click="timepicker.currentView = timepicker.VIEW_HOURS">{{ timepicker.time.format("h") }}</span>:' + 
	                                        '<span ng-class="{ \'active\': timepicker.currentView == timepicker.VIEW_MINUTES }" ng-click="timepicker.currentView = timepicker.VIEW_MINUTES">{{ timepicker.time.format("mm") }}</span>' +
	                                    '</div>' +
	                                    '<div layout="column" class="mdp-timepicker-selected-ampm">' + 
	                                        '<span ng-click="timepicker.setAM()" ng-class="{ \'active\': timepicker.time.hours() < 12 }">AM</span>' +
	                                        '<span ng-click="timepicker.setPM()" ng-class="{ \'active\': timepicker.time.hours() >= 12 }">PM</span>' +
	                                    '</div>' + 
	                                '</md-toolbar>' +
	                                '<div>' +
	                                    '<div class="mdp-clock-switch-container" ng-switch="timepicker.currentView" layout layout-align="center center">' +
		                                    '<mdp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" type="hours" ng-switch-when="1"></mdp-clock>' +
		                                    '<mdp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" type="minutes" ng-switch-when="2"></mdp-clock>' +
	                                    '</div>' +
	                                    
	                                    '<md-dialog-actions layout="row">' +
		                                	'<span flex></span>' +
	                                        '<md-button ng-click="timepicker.cancel()" aria-label="' + LABEL_CANCEL + '">' + LABEL_CANCEL + '</md-button>' +
	                                        '<md-button ng-click="timepicker.confirm()" class="md-primary" aria-label="' + LABEL_OK + '">' + LABEL_OK + '</md-button>' +
	                                    '</md-dialog-actions>' +
	                                '</div>' +
	                            '</md-dialog-content>' +
	                        '</md-dialog>',
	                targetEvent: options.targetEvent,
	                locals: {
	                    time: time,
	                    autoSwitch: options.autoSwitch
	                },
	                skipHide: true
	            });
	        };
	    
	        return timePicker;
	    }];
	});
	
	module.directive("mdpTimePicker", ["$mdpTimePicker", "$timeout", function($mdpTimePicker, $timeout) {
	    return  {
	        restrict: 'E',
	        require: 'ngModel',
	        transclude: true,
	        template: function(element, attrs) {
	            var noFloat = angular.isDefined(attrs.mdpNoFloat),
	                placeholder = angular.isDefined(attrs.mdpPlaceholder) ? attrs.mdpPlaceholder : "",
	                openOnClick = angular.isDefined(attrs.mdpOpenOnClick) ? true : false;
	            
	            return '<div layout layout-align="start start">' +
	                    '<md-button class="md-icon-button" ng-click="showPicker($event)"' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + '>' +
	                        '<md-icon md-svg-icon="mdp-access-time"></md-icon>' +
	                    '</md-button>' +
	                    '<md-input-container' + (noFloat ? ' md-no-float' : '') + ' md-is-error="isError()">' +
	                        '<input type="{{ ::type }}"' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + ' aria-label="' + placeholder + '" placeholder="' + placeholder + '"' + (openOnClick ? ' ng-click="showPicker($event)" ' : '') + ' />' +
	                    '</md-input-container>' +
	                '</div>';
	        },
	        scope: {
	            "timeFormat": "@mdpFormat",
	            "placeholder": "@mdpPlaceholder",
	            "autoSwitch": "=?mdpAutoSwitch",
	            "disabled": "=?mdpDisabled"
	        },
	        link: function(scope, element, attrs, ngModel, $transclude) {
	            var inputElement = angular.element(element[0].querySelector('input')),
	                inputContainer = angular.element(element[0].querySelector('md-input-container')),
	                inputContainerCtrl = inputContainer.controller("mdInputContainer");
	                
	            $transclude(function(clone) {
	               inputContainer.append(clone); 
	            });
	            
	            var messages = angular.element(inputContainer[0].querySelector("[ng-messages]"));
	            
	            scope.type = scope.timeFormat ? "text" : "time"
	            scope.timeFormat = scope.timeFormat || "HH:mm";
	            scope.autoSwitch = scope.autoSwitch || false;
	            
	            scope.$watch(function() { return ngModel.$error }, function(newValue, oldValue) {
	                inputContainerCtrl.setInvalid(!ngModel.$pristine && !!Object.keys(ngModel.$error).length);
	            }, true);
	            
	            // update input element if model has changed
	            ngModel.$formatters.unshift(function(value) {
	                var time = angular.isDate(value) && moment(value);
	                if(time && time.isValid()) 
	                    updateInputElement(time.format(scope.timeFormat));
	                else
	                    updateInputElement(null);
	            });
	            
	            ngModel.$validators.format = function(modelValue, viewValue) {
	                return !viewValue || angular.isDate(viewValue) || moment(viewValue, scope.timeFormat, true).isValid();
	            };
	            
	            ngModel.$validators.required = function(modelValue, viewValue) {
	                return angular.isUndefined(attrs.required) || !ngModel.$isEmpty(modelValue) || !ngModel.$isEmpty(viewValue);
	            };
	            
	            ngModel.$parsers.unshift(function(value) {
	                var parsed = moment(value, scope.timeFormat, true);
	                if(parsed.isValid()) {
	                    if(angular.isDate(ngModel.$modelValue)) {
	                        var originalModel = moment(ngModel.$modelValue);
	                        originalModel.minutes(parsed.minutes());
	                        originalModel.hours(parsed.hours());
	                        originalModel.seconds(parsed.seconds());
	                        
	                        parsed = originalModel;
	                    }
	                    return parsed.toDate(); 
	                } else
	                    return null;
	            });
	            
	            // update input element value
	            function updateInputElement(value) {
	                inputElement[0].value = value;
	                inputContainerCtrl.setHasValue(!ngModel.$isEmpty(value));
	            }
	            
	            function updateTime(time) {
	                var value = moment(time, angular.isDate(time) ? null : scope.timeFormat, true),
	                    strValue = value.format(scope.timeFormat);
	
	                if(value.isValid()) {
	                    updateInputElement(strValue);
	                    ngModel.$setViewValue(strValue);
	                } else {
	                    updateInputElement(time);
	                    ngModel.$setViewValue(time);
	                }
	                
	                if(!ngModel.$pristine && 
	                    messages.hasClass("md-auto-hide") && 
	                    inputContainer.hasClass("md-input-invalid")) messages.removeClass("md-auto-hide");
	                
	                ngModel.$render();
	            }
	                
	            scope.showPicker = function(ev) {
	                $mdpTimePicker(ngModel.$modelValue, {
	                    targetEvent: ev,
	                    autoSwitch: scope.autoSwitch
	                }).then(function(time) {
	                    updateTime(time, true);
	                });
	            };
	            
	            function onInputElementEvents(event) {
	                if(event.target.value !== ngModel.$viewVaue)
	                    updateTime(event.target.value);
	            }
	            
	            inputElement.on("reset input blur", onInputElementEvents);
	            
	            scope.$on("$destroy", function() {
	                inputElement.off("reset input blur", onInputElementEvents);
	            })
	        }
	    };
	}]);
	
	module.directive("mdpTimePicker", ["$mdpTimePicker", "$timeout", function($mdpTimePicker, $timeout) {
	    return  {
	        restrict: 'A',
	        require: 'ngModel',
	        scope: {
	            "timeFormat": "@mdpFormat",
	            "autoSwitch": "=?mdpAutoSwitch",
	        },
	        link: function(scope, element, attrs, ngModel, $transclude) {
	            scope.format = scope.format || "HH:mm";
	            function showPicker(ev) {
	                $mdpTimePicker(ngModel.$modelValue, {
	                    targetEvent: ev,
	                    autoSwitch: scope.autoSwitch
	                }).then(function(time) {
	                    ngModel.$setViewValue(moment(time).format(scope.format));
	                    ngModel.$render();
	                });
	            };
	            
	            element.on("click", showPicker);
	            
	            scope.$on("$destroy", function() {
	                element.off("click", showPicker);
	            });
	        }
	    }
	}]);
	
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	// Should already be required, here for clarity
	__webpack_require__(48);
	
	// Load Angular and dependent libs
	__webpack_require__(121);
	__webpack_require__(264);
	
	// Now load Angular Material
	__webpack_require__(80);
	
	__webpack_require__ (1121);
	
	module.exports = 'mdPickers';

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	/*
	 * Generated by PEG.js 0.10.0.
	 *
	 * http://pegjs.org/
	 */
	
	"use strict";
	
	function peg$subclass(child, parent) {
	  function ctor() { this.constructor = child; }
	  ctor.prototype = parent.prototype;
	  child.prototype = new ctor();
	}
	
	function peg$SyntaxError(message, expected, found, location) {
	  this.message  = message;
	  this.expected = expected;
	  this.found    = found;
	  this.location = location;
	  this.name     = "SyntaxError";
	
	  if (typeof Error.captureStackTrace === "function") {
	    Error.captureStackTrace(this, peg$SyntaxError);
	  }
	}
	
	peg$subclass(peg$SyntaxError, Error);
	
	peg$SyntaxError.buildMessage = function(expected, found) {
	  var DESCRIBE_EXPECTATION_FNS = {
	        literal: function(expectation) {
	          return "\"" + literalEscape(expectation.text) + "\"";
	        },
	
	        "class": function(expectation) {
	          var escapedParts = "",
	              i;
	
	          for (i = 0; i < expectation.parts.length; i++) {
	            escapedParts += expectation.parts[i] instanceof Array
	              ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1])
	              : classEscape(expectation.parts[i]);
	          }
	
	          return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
	        },
	
	        any: function(expectation) {
	          return "any character";
	        },
	
	        end: function(expectation) {
	          return "end of input";
	        },
	
	        other: function(expectation) {
	          return expectation.description;
	        }
	      };
	
	  function hex(ch) {
	    return ch.charCodeAt(0).toString(16).toUpperCase();
	  }
	
	  function literalEscape(s) {
	    return s
	      .replace(/\\/g, '\\\\')
	      .replace(/"/g,  '\\"')
	      .replace(/\0/g, '\\0')
	      .replace(/\t/g, '\\t')
	      .replace(/\n/g, '\\n')
	      .replace(/\r/g, '\\r')
	      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
	      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
	  }
	
	  function classEscape(s) {
	    return s
	      .replace(/\\/g, '\\\\')
	      .replace(/\]/g, '\\]')
	      .replace(/\^/g, '\\^')
	      .replace(/-/g,  '\\-')
	      .replace(/\0/g, '\\0')
	      .replace(/\t/g, '\\t')
	      .replace(/\n/g, '\\n')
	      .replace(/\r/g, '\\r')
	      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
	      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
	  }
	
	  function describeExpectation(expectation) {
	    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
	  }
	
	  function describeExpected(expected) {
	    var descriptions = new Array(expected.length),
	        i, j;
	
	    for (i = 0; i < expected.length; i++) {
	      descriptions[i] = describeExpectation(expected[i]);
	    }
	
	    descriptions.sort();
	
	    if (descriptions.length > 0) {
	      for (i = 1, j = 1; i < descriptions.length; i++) {
	        if (descriptions[i - 1] !== descriptions[i]) {
	          descriptions[j] = descriptions[i];
	          j++;
	        }
	      }
	      descriptions.length = j;
	    }
	
	    switch (descriptions.length) {
	      case 1:
	        return descriptions[0];
	
	      case 2:
	        return descriptions[0] + " or " + descriptions[1];
	
	      default:
	        return descriptions.slice(0, -1).join(", ")
	          + ", or "
	          + descriptions[descriptions.length - 1];
	    }
	  }
	
	  function describeFound(found) {
	    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
	  }
	
	  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
	};
	
	function peg$parse(input, options) {
	  options = options !== void 0 ? options : {};
	
	  var peg$FAILED = {},
	
	      peg$startRuleFunctions = { start: peg$parsestart },
	      peg$startRuleFunction  = peg$parsestart,
	
	      peg$c0 = "#",
	      peg$c1 = peg$literalExpectation("#", false),
	      peg$c2 = function() { return { type: 'octothorpe' }; },
	      peg$c3 = function(str) { return str.join(''); },
	      peg$c4 = "{",
	      peg$c5 = peg$literalExpectation("{", false),
	      peg$c6 = "}",
	      peg$c7 = peg$literalExpectation("}", false),
	      peg$c8 = function(arg) {
	          return {
	            type: 'argument',
	            arg: arg
	          };
	        },
	      peg$c9 = ",",
	      peg$c10 = peg$literalExpectation(",", false),
	      peg$c11 = "select",
	      peg$c12 = peg$literalExpectation("select", false),
	      peg$c13 = function(arg, cases) {
	          return {
	            type: 'select',
	            arg: arg,
	            cases: cases
	          };
	        },
	      peg$c14 = "plural",
	      peg$c15 = peg$literalExpectation("plural", false),
	      peg$c16 = "selectordinal",
	      peg$c17 = peg$literalExpectation("selectordinal", false),
	      peg$c18 = function(arg, type, offset, cases) {
	          var ls = ((type === 'selectordinal') ? options.ordinal : options.cardinal)
	                   || ['zero', 'one', 'two', 'few', 'many', 'other'];
	          if (ls && ls.length) cases.forEach(function(c) {
	            if (isNaN(c.key) && ls.indexOf(c.key) < 0) throw new Error(
	              'Invalid key `' + c.key + '` for argument `' + arg + '`.' +
	              ' Valid ' + type + ' keys for this locale are `' + ls.join('`, `') +
	              '`, and explicit keys like `=0`.');
	          });
	          return {
	            type: type,
	            arg: arg,
	            offset: offset || 0,
	            cases: cases
	          };
	        },
	      peg$c19 = function(arg, key, params) {
	          return {
	            type: 'function',
	            arg: arg,
	            key: key,
	            params: params
	          };
	        },
	      peg$c20 = /^[0-9a-zA-Z$_]/,
	      peg$c21 = peg$classExpectation([["0", "9"], ["a", "z"], ["A", "Z"], "$", "_"], false, false),
	      peg$c22 = /^[^ \t\n\r,.+={}]/,
	      peg$c23 = peg$classExpectation([" ", "\t", "\n", "\r", ",", ".", "+", "=", "{", "}"], true, false),
	      peg$c24 = function(key, tokens) { return { key: key, tokens: tokens }; },
	      peg$c25 = function(tokens) { return tokens; },
	      peg$c26 = "offset",
	      peg$c27 = peg$literalExpectation("offset", false),
	      peg$c28 = ":",
	      peg$c29 = peg$literalExpectation(":", false),
	      peg$c30 = function(d) { return d; },
	      peg$c31 = "=",
	      peg$c32 = peg$literalExpectation("=", false),
	      peg$c33 = function(p) { return options.strictFunctionParams; },
	      peg$c34 = function(p) { return p; },
	      peg$c35 = function(p) { return p.replace(/^[ \t\n\r]*|[ \t\n\r]*$/g, ''); },
	      peg$c36 = "''",
	      peg$c37 = peg$literalExpectation("''", false),
	      peg$c38 = function() { return "'"; },
	      peg$c39 = /^[^']/,
	      peg$c40 = peg$classExpectation(["'"], true, false),
	      peg$c41 = "'{",
	      peg$c42 = peg$literalExpectation("'{", false),
	      peg$c43 = "'",
	      peg$c44 = peg$literalExpectation("'", false),
	      peg$c45 = function(str) { return '\u007B'+str.join(''); },
	      peg$c46 = "'}",
	      peg$c47 = peg$literalExpectation("'}", false),
	      peg$c48 = function(str) { return '\u007D'+str.join(''); },
	      peg$c49 = /^[^{}#\\\0-\x08\x0E-\x1F\x7F]/,
	      peg$c50 = peg$classExpectation(["{", "}", "#", "\\", ["\0", "\b"], ["\x0E", "\x1F"], "\x7F"], true, false),
	      peg$c51 = "\\\\",
	      peg$c52 = peg$literalExpectation("\\\\", false),
	      peg$c53 = function() { return '\\'; },
	      peg$c54 = "\\#",
	      peg$c55 = peg$literalExpectation("\\#", false),
	      peg$c56 = function() { return '#'; },
	      peg$c57 = "\\{",
	      peg$c58 = peg$literalExpectation("\\{", false),
	      peg$c59 = function() { return '\u007B'; },
	      peg$c60 = "\\}",
	      peg$c61 = peg$literalExpectation("\\}", false),
	      peg$c62 = function() { return '\u007D'; },
	      peg$c63 = "\\u",
	      peg$c64 = peg$literalExpectation("\\u", false),
	      peg$c65 = function(h1, h2, h3, h4) {
	            return String.fromCharCode(parseInt('0x' + h1 + h2 + h3 + h4));
	          },
	      peg$c66 = /^[^',}]/,
	      peg$c67 = peg$classExpectation(["'", ",", "}"], true, false),
	      peg$c68 = /^[^'}]/,
	      peg$c69 = peg$classExpectation(["'", "}"], true, false),
	      peg$c70 = /^[0-9]/,
	      peg$c71 = peg$classExpectation([["0", "9"]], false, false),
	      peg$c72 = /^[0-9a-fA-F]/,
	      peg$c73 = peg$classExpectation([["0", "9"], ["a", "f"], ["A", "F"]], false, false),
	      peg$c74 = /^[ \t\n\r]/,
	      peg$c75 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false),
	
	      peg$currPos          = 0,
	      peg$savedPos         = 0,
	      peg$posDetailsCache  = [{ line: 1, column: 1 }],
	      peg$maxFailPos       = 0,
	      peg$maxFailExpected  = [],
	      peg$silentFails      = 0,
	
	      peg$result;
	
	  if ("startRule" in options) {
	    if (!(options.startRule in peg$startRuleFunctions)) {
	      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	    }
	
	    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	  }
	
	  function text() {
	    return input.substring(peg$savedPos, peg$currPos);
	  }
	
	  function location() {
	    return peg$computeLocation(peg$savedPos, peg$currPos);
	  }
	
	  function expected(description, location) {
	    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)
	
	    throw peg$buildStructuredError(
	      [peg$otherExpectation(description)],
	      input.substring(peg$savedPos, peg$currPos),
	      location
	    );
	  }
	
	  function error(message, location) {
	    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)
	
	    throw peg$buildSimpleError(message, location);
	  }
	
	  function peg$literalExpectation(text, ignoreCase) {
	    return { type: "literal", text: text, ignoreCase: ignoreCase };
	  }
	
	  function peg$classExpectation(parts, inverted, ignoreCase) {
	    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
	  }
	
	  function peg$anyExpectation() {
	    return { type: "any" };
	  }
	
	  function peg$endExpectation() {
	    return { type: "end" };
	  }
	
	  function peg$otherExpectation(description) {
	    return { type: "other", description: description };
	  }
	
	  function peg$computePosDetails(pos) {
	    var details = peg$posDetailsCache[pos], p;
	
	    if (details) {
	      return details;
	    } else {
	      p = pos - 1;
	      while (!peg$posDetailsCache[p]) {
	        p--;
	      }
	
	      details = peg$posDetailsCache[p];
	      details = {
	        line:   details.line,
	        column: details.column
	      };
	
	      while (p < pos) {
	        if (input.charCodeAt(p) === 10) {
	          details.line++;
	          details.column = 1;
	        } else {
	          details.column++;
	        }
	
	        p++;
	      }
	
	      peg$posDetailsCache[pos] = details;
	      return details;
	    }
	  }
	
	  function peg$computeLocation(startPos, endPos) {
	    var startPosDetails = peg$computePosDetails(startPos),
	        endPosDetails   = peg$computePosDetails(endPos);
	
	    return {
	      start: {
	        offset: startPos,
	        line:   startPosDetails.line,
	        column: startPosDetails.column
	      },
	      end: {
	        offset: endPos,
	        line:   endPosDetails.line,
	        column: endPosDetails.column
	      }
	    };
	  }
	
	  function peg$fail(expected) {
	    if (peg$currPos < peg$maxFailPos) { return; }
	
	    if (peg$currPos > peg$maxFailPos) {
	      peg$maxFailPos = peg$currPos;
	      peg$maxFailExpected = [];
	    }
	
	    peg$maxFailExpected.push(expected);
	  }
	
	  function peg$buildSimpleError(message, location) {
	    return new peg$SyntaxError(message, null, null, location);
	  }
	
	  function peg$buildStructuredError(expected, found, location) {
	    return new peg$SyntaxError(
	      peg$SyntaxError.buildMessage(expected, found),
	      expected,
	      found,
	      location
	    );
	  }
	
	  function peg$parsestart() {
	    var s0, s1;
	
	    s0 = [];
	    s1 = peg$parsetoken();
	    while (s1 !== peg$FAILED) {
	      s0.push(s1);
	      s1 = peg$parsetoken();
	    }
	
	    return s0;
	  }
	
	  function peg$parsetoken() {
	    var s0, s1, s2;
	
	    s0 = peg$parseargument();
	    if (s0 === peg$FAILED) {
	      s0 = peg$parseselect();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseplural();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parsefunction();
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.charCodeAt(peg$currPos) === 35) {
	              s1 = peg$c0;
	              peg$currPos++;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c1); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c2();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              s1 = [];
	              s2 = peg$parsechar();
	              if (s2 !== peg$FAILED) {
	                while (s2 !== peg$FAILED) {
	                  s1.push(s2);
	                  s2 = peg$parsechar();
	                }
	              } else {
	                s1 = peg$FAILED;
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c3(s1);
	              }
	              s0 = s1;
	            }
	          }
	        }
	      }
	    }
	
	    return s0;
	  }
	
	  function peg$parseargument() {
	    var s0, s1, s2, s3, s4, s5;
	
	    s0 = peg$currPos;
	    if (input.charCodeAt(peg$currPos) === 123) {
	      s1 = peg$c4;
	      peg$currPos++;
	    } else {
	      s1 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c5); }
	    }
	    if (s1 !== peg$FAILED) {
	      s2 = peg$parse_();
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parseid();
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parse_();
	          if (s4 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 125) {
	              s5 = peg$c6;
	              peg$currPos++;
	            } else {
	              s5 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c7); }
	            }
	            if (s5 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c8(s3);
	              s0 = s1;
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parseselect() {
	    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
	
	    s0 = peg$currPos;
	    if (input.charCodeAt(peg$currPos) === 123) {
	      s1 = peg$c4;
	      peg$currPos++;
	    } else {
	      s1 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c5); }
	    }
	    if (s1 !== peg$FAILED) {
	      s2 = peg$parse_();
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parseid();
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parse_();
	          if (s4 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 44) {
	              s5 = peg$c9;
	              peg$currPos++;
	            } else {
	              s5 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c10); }
	            }
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parse_();
	              if (s6 !== peg$FAILED) {
	                if (input.substr(peg$currPos, 6) === peg$c11) {
	                  s7 = peg$c11;
	                  peg$currPos += 6;
	                } else {
	                  s7 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c12); }
	                }
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parse_();
	                  if (s8 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 44) {
	                      s9 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s9 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s9 !== peg$FAILED) {
	                      s10 = peg$parse_();
	                      if (s10 !== peg$FAILED) {
	                        s11 = [];
	                        s12 = peg$parseselectCase();
	                        if (s12 !== peg$FAILED) {
	                          while (s12 !== peg$FAILED) {
	                            s11.push(s12);
	                            s12 = peg$parseselectCase();
	                          }
	                        } else {
	                          s11 = peg$FAILED;
	                        }
	                        if (s11 !== peg$FAILED) {
	                          s12 = peg$parse_();
	                          if (s12 !== peg$FAILED) {
	                            if (input.charCodeAt(peg$currPos) === 125) {
	                              s13 = peg$c6;
	                              peg$currPos++;
	                            } else {
	                              s13 = peg$FAILED;
	                              if (peg$silentFails === 0) { peg$fail(peg$c7); }
	                            }
	                            if (s13 !== peg$FAILED) {
	                              peg$savedPos = s0;
	                              s1 = peg$c13(s3, s11);
	                              s0 = s1;
	                            } else {
	                              peg$currPos = s0;
	                              s0 = peg$FAILED;
	                            }
	                          } else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                          }
	                        } else {
	                          peg$currPos = s0;
	                          s0 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parseplural() {
	    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14;
	
	    s0 = peg$currPos;
	    if (input.charCodeAt(peg$currPos) === 123) {
	      s1 = peg$c4;
	      peg$currPos++;
	    } else {
	      s1 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c5); }
	    }
	    if (s1 !== peg$FAILED) {
	      s2 = peg$parse_();
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parseid();
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parse_();
	          if (s4 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 44) {
	              s5 = peg$c9;
	              peg$currPos++;
	            } else {
	              s5 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c10); }
	            }
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parse_();
	              if (s6 !== peg$FAILED) {
	                if (input.substr(peg$currPos, 6) === peg$c14) {
	                  s7 = peg$c14;
	                  peg$currPos += 6;
	                } else {
	                  s7 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c15); }
	                }
	                if (s7 === peg$FAILED) {
	                  if (input.substr(peg$currPos, 13) === peg$c16) {
	                    s7 = peg$c16;
	                    peg$currPos += 13;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c17); }
	                  }
	                }
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parse_();
	                  if (s8 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 44) {
	                      s9 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s9 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s9 !== peg$FAILED) {
	                      s10 = peg$parse_();
	                      if (s10 !== peg$FAILED) {
	                        s11 = peg$parseoffset();
	                        if (s11 === peg$FAILED) {
	                          s11 = null;
	                        }
	                        if (s11 !== peg$FAILED) {
	                          s12 = [];
	                          s13 = peg$parsepluralCase();
	                          if (s13 !== peg$FAILED) {
	                            while (s13 !== peg$FAILED) {
	                              s12.push(s13);
	                              s13 = peg$parsepluralCase();
	                            }
	                          } else {
	                            s12 = peg$FAILED;
	                          }
	                          if (s12 !== peg$FAILED) {
	                            s13 = peg$parse_();
	                            if (s13 !== peg$FAILED) {
	                              if (input.charCodeAt(peg$currPos) === 125) {
	                                s14 = peg$c6;
	                                peg$currPos++;
	                              } else {
	                                s14 = peg$FAILED;
	                                if (peg$silentFails === 0) { peg$fail(peg$c7); }
	                              }
	                              if (s14 !== peg$FAILED) {
	                                peg$savedPos = s0;
	                                s1 = peg$c18(s3, s7, s11, s12);
	                                s0 = s1;
	                              } else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                              }
	                            } else {
	                              peg$currPos = s0;
	                              s0 = peg$FAILED;
	                            }
	                          } else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                          }
	                        } else {
	                          peg$currPos = s0;
	                          s0 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parsefunction() {
	    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
	
	    s0 = peg$currPos;
	    if (input.charCodeAt(peg$currPos) === 123) {
	      s1 = peg$c4;
	      peg$currPos++;
	    } else {
	      s1 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c5); }
	    }
	    if (s1 !== peg$FAILED) {
	      s2 = peg$parse_();
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parseid();
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parse_();
	          if (s4 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 44) {
	              s5 = peg$c9;
	              peg$currPos++;
	            } else {
	              s5 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c10); }
	            }
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parse_();
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parseid();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parse_();
	                  if (s8 !== peg$FAILED) {
	                    s9 = peg$parsefunctionParams();
	                    if (s9 !== peg$FAILED) {
	                      if (input.charCodeAt(peg$currPos) === 125) {
	                        s10 = peg$c6;
	                        peg$currPos++;
	                      } else {
	                        s10 = peg$FAILED;
	                        if (peg$silentFails === 0) { peg$fail(peg$c7); }
	                      }
	                      if (s10 !== peg$FAILED) {
	                        peg$savedPos = s0;
	                        s1 = peg$c19(s3, s7, s9);
	                        s0 = s1;
	                      } else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parseid() {
	    var s0, s1, s2, s3, s4;
	
	    s0 = peg$currPos;
	    s1 = peg$currPos;
	    if (peg$c20.test(input.charAt(peg$currPos))) {
	      s2 = input.charAt(peg$currPos);
	      peg$currPos++;
	    } else {
	      s2 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c21); }
	    }
	    if (s2 !== peg$FAILED) {
	      s3 = [];
	      if (peg$c22.test(input.charAt(peg$currPos))) {
	        s4 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s4 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      while (s4 !== peg$FAILED) {
	        s3.push(s4);
	        if (peg$c22.test(input.charAt(peg$currPos))) {
	          s4 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s4 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c23); }
	        }
	      }
	      if (s3 !== peg$FAILED) {
	        s2 = [s2, s3];
	        s1 = s2;
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s1;
	      s1 = peg$FAILED;
	    }
	    if (s1 !== peg$FAILED) {
	      s0 = input.substring(s0, peg$currPos);
	    } else {
	      s0 = s1;
	    }
	
	    return s0;
	  }
	
	  function peg$parseparamDefault() {
	    var s0, s1, s2;
	
	    s0 = peg$currPos;
	    s1 = [];
	    s2 = peg$parseparamcharsDefault();
	    if (s2 !== peg$FAILED) {
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parseparamcharsDefault();
	      }
	    } else {
	      s1 = peg$FAILED;
	    }
	    if (s1 !== peg$FAILED) {
	      peg$savedPos = s0;
	      s1 = peg$c3(s1);
	    }
	    s0 = s1;
	
	    return s0;
	  }
	
	  function peg$parseparamStrict() {
	    var s0, s1, s2;
	
	    s0 = peg$currPos;
	    s1 = [];
	    s2 = peg$parseparamcharsStrict();
	    if (s2 !== peg$FAILED) {
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parseparamcharsStrict();
	      }
	    } else {
	      s1 = peg$FAILED;
	    }
	    if (s1 !== peg$FAILED) {
	      peg$savedPos = s0;
	      s1 = peg$c3(s1);
	    }
	    s0 = s1;
	
	    return s0;
	  }
	
	  function peg$parseselectCase() {
	    var s0, s1, s2, s3, s4;
	
	    s0 = peg$currPos;
	    s1 = peg$parse_();
	    if (s1 !== peg$FAILED) {
	      s2 = peg$parseid();
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parse_();
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parsecaseTokens();
	          if (s4 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c24(s2, s4);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parsepluralCase() {
	    var s0, s1, s2, s3, s4;
	
	    s0 = peg$currPos;
	    s1 = peg$parse_();
	    if (s1 !== peg$FAILED) {
	      s2 = peg$parsepluralKey();
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parse_();
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parsecaseTokens();
	          if (s4 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c24(s2, s4);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parsecaseTokens() {
	    var s0, s1, s2, s3, s4, s5;
	
	    s0 = peg$currPos;
	    if (input.charCodeAt(peg$currPos) === 123) {
	      s1 = peg$c4;
	      peg$currPos++;
	    } else {
	      s1 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c5); }
	    }
	    if (s1 !== peg$FAILED) {
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$currPos;
	        peg$silentFails++;
	        if (input.charCodeAt(peg$currPos) === 123) {
	          s5 = peg$c4;
	          peg$currPos++;
	        } else {
	          s5 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c5); }
	        }
	        peg$silentFails--;
	        if (s5 !== peg$FAILED) {
	          peg$currPos = s4;
	          s4 = void 0;
	        } else {
	          s4 = peg$FAILED;
	        }
	        if (s4 !== peg$FAILED) {
	          s3 = [s3, s4];
	          s2 = s3;
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 === peg$FAILED) {
	        s2 = null;
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = [];
	        s4 = peg$parsetoken();
	        while (s4 !== peg$FAILED) {
	          s3.push(s4);
	          s4 = peg$parsetoken();
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parse_();
	          if (s4 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 125) {
	              s5 = peg$c6;
	              peg$currPos++;
	            } else {
	              s5 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c7); }
	            }
	            if (s5 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c25(s3);
	              s0 = s1;
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parseoffset() {
	    var s0, s1, s2, s3, s4, s5, s6, s7;
	
	    s0 = peg$currPos;
	    s1 = peg$parse_();
	    if (s1 !== peg$FAILED) {
	      if (input.substr(peg$currPos, 6) === peg$c26) {
	        s2 = peg$c26;
	        peg$currPos += 6;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c27); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parse_();
	        if (s3 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 58) {
	            s4 = peg$c28;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c29); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsedigits();
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  peg$savedPos = s0;
	                  s1 = peg$c30(s6);
	                  s0 = s1;
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parsepluralKey() {
	    var s0, s1, s2;
	
	    s0 = peg$parseid();
	    if (s0 === peg$FAILED) {
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s1 = peg$c31;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parsedigits();
	        if (s2 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c30(s2);
	          s0 = s1;
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    }
	
	    return s0;
	  }
	
	  function peg$parsefunctionParams() {
	    var s0, s1, s2;
	
	    s0 = peg$currPos;
	    s1 = [];
	    s2 = peg$parsefunctionParamsDefault();
	    while (s2 !== peg$FAILED) {
	      s1.push(s2);
	      s2 = peg$parsefunctionParamsDefault();
	    }
	    if (s1 !== peg$FAILED) {
	      peg$savedPos = peg$currPos;
	      s2 = peg$c33(s1);
	      if (s2) {
	        s2 = peg$FAILED;
	      } else {
	        s2 = void 0;
	      }
	      if (s2 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c34(s1);
	        s0 = s1;
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	    if (s0 === peg$FAILED) {
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsefunctionParamsStrict();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsefunctionParamsStrict();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = peg$currPos;
	        s2 = peg$c33(s1);
	        if (s2) {
	          s2 = void 0;
	        } else {
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c34(s1);
	          s0 = s1;
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    }
	
	    return s0;
	  }
	
	  function peg$parsefunctionParamsStrict() {
	    var s0, s1, s2, s3;
	
	    s0 = peg$currPos;
	    s1 = peg$parse_();
	    if (s1 !== peg$FAILED) {
	      if (input.charCodeAt(peg$currPos) === 44) {
	        s2 = peg$c9;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c10); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parseparamStrict();
	        if (s3 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c34(s3);
	          s0 = s1;
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parsefunctionParamsDefault() {
	    var s0, s1, s2, s3, s4, s5;
	
	    s0 = peg$currPos;
	    s1 = peg$parse_();
	    if (s1 !== peg$FAILED) {
	      if (input.charCodeAt(peg$currPos) === 44) {
	        s2 = peg$c9;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c10); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parse_();
	        if (s3 !== peg$FAILED) {
	          s4 = peg$parseparamDefault();
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c35(s4);
	              s0 = s1;
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	
	    return s0;
	  }
	
	  function peg$parsedoubleapos() {
	    var s0, s1;
	
	    s0 = peg$currPos;
	    if (input.substr(peg$currPos, 2) === peg$c36) {
	      s1 = peg$c36;
	      peg$currPos += 2;
	    } else {
	      s1 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c37); }
	    }
	    if (s1 !== peg$FAILED) {
	      peg$savedPos = s0;
	      s1 = peg$c38();
	    }
	    s0 = s1;
	
	    return s0;
	  }
	
	  function peg$parseinapos() {
	    var s0, s1, s2;
	
	    s0 = peg$parsedoubleapos();
	    if (s0 === peg$FAILED) {
	      s0 = peg$currPos;
	      s1 = [];
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s2 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          if (peg$c39.test(input.charAt(peg$currPos))) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c40); }
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	    }
	
	    return s0;
	  }
	
	  function peg$parsequotedCurly() {
	    var s0, s1, s2, s3;
	
	    s0 = peg$currPos;
	    if (input.substr(peg$currPos, 2) === peg$c41) {
	      s1 = peg$c41;
	      peg$currPos += 2;
	    } else {
	      s1 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c42); }
	    }
	    if (s1 !== peg$FAILED) {
	      s2 = [];
	      s3 = peg$parseinapos();
	      while (s3 !== peg$FAILED) {
	        s2.push(s3);
	        s3 = peg$parseinapos();
	      }
	      if (s2 !== peg$FAILED) {
	        if (input.charCodeAt(peg$currPos) === 39) {
	          s3 = peg$c43;
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c44); }
	        }
	        if (s3 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c45(s2);
	          s0 = s1;
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    } else {
	      peg$currPos = s0;
	      s0 = peg$FAILED;
	    }
	    if (s0 === peg$FAILED) {
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 2) === peg$c46) {
	        s1 = peg$c46;
	        peg$currPos += 2;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c47); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = [];
	        s3 = peg$parseinapos();
	        while (s3 !== peg$FAILED) {
	          s2.push(s3);
	          s3 = peg$parseinapos();
	        }
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 39) {
	            s3 = peg$c43;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c44); }
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c48(s2);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	    }
	
	    return s0;
	  }
	
	  function peg$parsequotedFunctionParams() {
	    var s0;
	
	    s0 = peg$parsequotedCurly();
	    if (s0 === peg$FAILED) {
	      if (input.charCodeAt(peg$currPos) === 39) {
	        s0 = peg$c43;
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c44); }
	      }
	    }
	
	    return s0;
	  }
	
	  function peg$parsechar() {
	    var s0, s1, s2, s3, s4, s5;
	
	    if (peg$c49.test(input.charAt(peg$currPos))) {
	      s0 = input.charAt(peg$currPos);
	      peg$currPos++;
	    } else {
	      s0 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c50); }
	    }
	    if (s0 === peg$FAILED) {
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 2) === peg$c51) {
	        s1 = peg$c51;
	        peg$currPos += 2;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c52); }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c53();
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c54) {
	          s1 = peg$c54;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c55); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c56();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c57) {
	            s1 = peg$c57;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c58); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c59();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c60) {
	              s1 = peg$c60;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c61); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c62();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c63) {
	                s1 = peg$c63;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c64); }
	              }
	              if (s1 !== peg$FAILED) {
	                s2 = peg$parsehexDigit();
	                if (s2 !== peg$FAILED) {
	                  s3 = peg$parsehexDigit();
	                  if (s3 !== peg$FAILED) {
	                    s4 = peg$parsehexDigit();
	                    if (s4 !== peg$FAILED) {
	                      s5 = peg$parsehexDigit();
	                      if (s5 !== peg$FAILED) {
	                        peg$savedPos = s0;
	                        s1 = peg$c65(s2, s3, s4, s5);
	                        s0 = s1;
	                      } else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            }
	          }
	        }
	      }
	    }
	
	    return s0;
	  }
	
	  function peg$parseparamcharsCommon() {
	    var s0;
	
	    s0 = peg$parsedoubleapos();
	    if (s0 === peg$FAILED) {
	      s0 = peg$parsequotedFunctionParams();
	    }
	
	    return s0;
	  }
	
	  function peg$parseparamcharsDefault() {
	    var s0, s1, s2;
	
	    s0 = peg$parseparamcharsCommon();
	    if (s0 === peg$FAILED) {
	      s0 = peg$currPos;
	      s1 = [];
	      if (peg$c66.test(input.charAt(peg$currPos))) {
	        s2 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c67); }
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          if (peg$c66.test(input.charAt(peg$currPos))) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c67); }
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	    }
	
	    return s0;
	  }
	
	  function peg$parseparamcharsStrict() {
	    var s0, s1, s2;
	
	    s0 = peg$parseparamcharsCommon();
	    if (s0 === peg$FAILED) {
	      s0 = peg$currPos;
	      s1 = [];
	      if (peg$c68.test(input.charAt(peg$currPos))) {
	        s2 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c69); }
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          if (peg$c68.test(input.charAt(peg$currPos))) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c69); }
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	    }
	
	    return s0;
	  }
	
	  function peg$parsedigits() {
	    var s0, s1, s2;
	
	    s0 = peg$currPos;
	    s1 = [];
	    if (peg$c70.test(input.charAt(peg$currPos))) {
	      s2 = input.charAt(peg$currPos);
	      peg$currPos++;
	    } else {
	      s2 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c71); }
	    }
	    if (s2 !== peg$FAILED) {
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        if (peg$c70.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c71); }
	        }
	      }
	    } else {
	      s1 = peg$FAILED;
	    }
	    if (s1 !== peg$FAILED) {
	      s0 = input.substring(s0, peg$currPos);
	    } else {
	      s0 = s1;
	    }
	
	    return s0;
	  }
	
	  function peg$parsehexDigit() {
	    var s0;
	
	    if (peg$c72.test(input.charAt(peg$currPos))) {
	      s0 = input.charAt(peg$currPos);
	      peg$currPos++;
	    } else {
	      s0 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c73); }
	    }
	
	    return s0;
	  }
	
	  function peg$parse_() {
	    var s0, s1, s2;
	
	    s0 = peg$currPos;
	    s1 = [];
	    if (peg$c74.test(input.charAt(peg$currPos))) {
	      s2 = input.charAt(peg$currPos);
	      peg$currPos++;
	    } else {
	      s2 = peg$FAILED;
	      if (peg$silentFails === 0) { peg$fail(peg$c75); }
	    }
	    while (s2 !== peg$FAILED) {
	      s1.push(s2);
	      if (peg$c74.test(input.charAt(peg$currPos))) {
	        s2 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c75); }
	      }
	    }
	    if (s1 !== peg$FAILED) {
	      s0 = input.substring(s0, peg$currPos);
	    } else {
	      s0 = s1;
	    }
	
	    return s0;
	  }
	
	  peg$result = peg$startRuleFunction();
	
	  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	    return peg$result;
	  } else {
	    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	      peg$fail(peg$endExpectation());
	    }
	
	    throw peg$buildStructuredError(
	      peg$maxFailExpected,
	      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
	      peg$maxFailPos < input.length
	        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
	    );
	  }
	}
	
	module.exports = {
	  SyntaxError: peg$SyntaxError,
	  parse:       peg$parse
	};


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	/** @file messageformat.js - ICU PluralFormat + SelectFormat for JavaScript
	 *
	 * @author Alex Sexton - @SlexAxton, Eemeli Aro
	 * @version 1.0.2
	 * @copyright 2012-2016 Alex Sexton, Eemeli Aro, and Contributors
	 * @license To use or fork, MIT. To contribute back, Dojo CLA
	 */
	
	var Compiler = __webpack_require__(380);
	var Runtime = __webpack_require__(1125);
	
	
	/** Utility getter/wrapper for pluralization functions from
	 *  {@link http://github.com/eemeli/make-plural.js make-plural}
	 *
	 * @private
	 */
	function getPluralFunc(locale, noPluralKeyChecks) {
	  var plurals = __webpack_require__(996);
	  var pluralCategories = __webpack_require__(995);
	  for (var l = locale; l; l = l.replace(/[-_]?[^-_]*$/, '')) {
	    var pf = plurals[l];
	    if (pf) {
	      var pc = noPluralKeyChecks ? { cardinal: [], ordinal: [] } : (pluralCategories[l] || {});
	      var fn = function() { return pf.apply(this, arguments); };
	      fn.toString = function() { return pf.toString(); };
	      fn.cardinal = pc.cardinal;
	      fn.ordinal = pc.ordinal;
	      return fn;
	    }
	  }
	  throw new Error('Localisation function not found for locale ' + JSON.stringify(locale));
	}
	
	
	/** Create a new message formatter
	 *
	 *  If `locale` is not set, calls to `compile()` will fetch the default locale
	 *  each time. A string `locale` will create a single-locale MessageFormat
	 *  instance, with pluralisation rules fetched from the Unicode CLDR using
	 *  {@link http://github.com/eemeli/make-plural.js make-plural}.
	 *
	 *  Using an array of strings as `locale` will create a MessageFormat object
	 *  with multi-language support, with pluralisation rules fetched as above. To
	 *  select which to use, use the second parameter of `compile()`, or use message
	 *  keys corresponding to your locales.
	 *
	 *  Using an object `locale` with all properties of type `function` allows for
	 *  the use of custom/externally defined pluralisation rules.
	 *
	 * @class
	 * @param {string|string[]|Object.<string,function>} [locale] - The locale(s) to use
	 */
	function MessageFormat(locale) {
	  this.pluralFuncs = {};
	  if (locale) {
	    if (typeof locale == 'string') {
	      this.pluralFuncs[locale] = getPluralFunc(locale);
	    } else if (Array.isArray(locale)) {
	      locale.forEach(function(lc) { this.pluralFuncs[lc] = getPluralFunc(lc); }, this);
	    } else if (typeof locale == 'object') {
	      for (var lc in locale) if (locale.hasOwnProperty(lc)) {
	        if (typeof locale[lc] != 'function') throw new Error('Expected function value for locale ' + JSON.stringify(lc));
	        this.pluralFuncs[lc] = locale[lc];
	      }
	    }
	  }
	  this.fmt = {};
	  this.runtime = new Runtime(this);
	}
	
	
	/** The default locale
	 *
	 *  Read by `compile()` when no locale has been previously set
	 *
	 * @memberof MessageFormat
	 * @default 'en'
	 */
	MessageFormat.defaultLocale = 'en';
	
	
	/** Escape special characaters
	 *
	 *  Prefix the characters `#`, `{`, `}` and `\` in the input string with a `\`.
	 *  This will allow those characters to not be considered as MessageFormat
	 *  control characters.
	 *
	 * @param {string} str - The input string
	 * @returns {string} The escaped string
	 */
	MessageFormat.escape = function(str) {
	  return str.replace(/[#{}\\]/g, '\\$&');
	}
	
	
	/** Default number formatting functions in the style of ICU's
	 *  {@link http://icu-project.org/apiref/icu4j/com/ibm/icu/text/MessageFormat.html simpleArg syntax}
	 *  implemented using the
	 *  {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl Intl}
	 *  object defined by ECMA-402.
	 *
	 *  **Note**: Intl is not defined in default Node until 0.11.15 / 0.12.0, so
	 *  earlier versions require a {@link https://www.npmjs.com/package/intl polyfill}.
	 *  Therefore {@link MessageFormat.intlSupport} needs to be true for these default
	 *  functions to be available for inclusion in the output.
	 *
	 * @see MessageFormat#setIntlSupport
	 *
	 * @namespace
	 */
	MessageFormat.formatters = {
	
	
	  /** Represent a number as an integer, percent or currency value
	   *
	   *  Available in MessageFormat strings as `{VAR, number, integer|percent|currency}`.
	   *  Internally, calls Intl.NumberFormat with appropriate parameters. `currency` will
	   *  default to USD; to change, set `MessageFormat#currency` to the appropriate
	   *  three-letter currency code.
	   *
	   * @param {number} value - The value to operate on
	   * @param {string} type - One of `'integer'`, `'percent'` , or `currency`
	   *
	   * @example
	   * var mf = new MessageFormat('en').setIntlSupport(true);
	   * mf.currency = 'EUR';  // needs to be set before first compile() call
	   *
	   * mf.compile('{N} is almost {N, number, integer}')({ N: 3.14 })
	   * // '3.14 is almost 3'
	   *
	   * mf.compile('{P, number, percent} complete')({ P: 0.99 })
	   * // '99% complete'
	   *
	   * mf.compile('The total is {V, number, currency}.')({ V: 5.5 })
	   * // 'The total is €5.50.'
	   */
	  number: function(self) {
	    return new Function("v,lc,p",
	      "return new Intl.NumberFormat(lc,\n" +
	      "    p=='integer' ? {maximumFractionDigits:0}\n" +
	      "  : p=='percent' ? {style:'percent'}\n" +
	      "  : p=='currency' ? {style:'currency', currency:'" + (self.currency || 'USD') + "', minimumFractionDigits:2, maximumFractionDigits:2}\n" +
	      "  : {}).format(v)"
	    );
	  },
	
	
	  /** Represent a date as a short/default/long/full string
	   *
	   * The input value needs to be in a form that the
	   * {@link https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Date Date object}
	   * can process using its single-argument form, `new Date(value)`.
	   *
	   * @param {number|string} value - Either a Unix epoch time in milliseconds, or a string value representing a date
	   * @param {string} [type='default'] - One of `'short'`, `'default'`, `'long'` , or `full`
	   *
	   * @example
	   * var mf = new MessageFormat(['en', 'fi']).setIntlSupport(true);
	   *
	   * mf.compile('Today is {T, date}')({ T: Date.now() })
	   * // 'Today is Feb 21, 2016'
	   *
	   * mf.compile('Tänään on {T, date}', 'fi')({ T: Date.now() })
	   * // 'Tänään on 21. helmikuuta 2016'
	   *
	   * mf.compile('Unix time started on {T, date, full}')({ T: 0 })
	   * // 'Unix time started on Thursday, January 1, 1970'
	   *
	   * var cf = mf.compile('{sys} became operational on {d0, date, short}');
	   * cf({ sys: 'HAL 9000', d0: '12 January 1999' })
	   * // 'HAL 9000 became operational on 1/12/1999'
	   */
	  date: function(v,lc,p) {
	    var o = {day:'numeric', month:'short', year:'numeric'};
	    switch (p) {
	      case 'full': o.weekday = 'long';
	      case 'long': o.month = 'long'; break;
	      case 'short': o.month = 'numeric';
	    }
	    return (new Date(v)).toLocaleDateString(lc, o)
	  },
	
	
	  /** Represent a time as a short/default/long string
	   *
	   * The input value needs to be in a form that the
	   * {@link https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Date Date object}
	   * can process using its single-argument form, `new Date(value)`.
	   *
	   * @param {number|string} value - Either a Unix epoch time in milliseconds, or a string value representing a date
	   * @param {string} [type='default'] - One of `'short'`, `'default'`, `'long'` , or `full`
	   *
	   * @example
	   * var mf = new MessageFormat(['en', 'fi']).setIntlSupport(true);
	   *
	   * mf.compile('The time is now {T, time}')({ T: Date.now() })
	   * // 'The time is now 11:26:35 PM'
	   *
	   * mf.compile('Kello on nyt {T, time}', 'fi')({ T: Date.now() })
	   * // 'Kello on nyt 23.26.35'
	   *
	   * var cf = mf.compile('The Eagle landed at {T, time, full} on {T, date, full}');
	   * cf({ T: '1969-07-20 20:17:40 UTC' })
	   * // 'The Eagle landed at 10:17:40 PM GMT+2 on Sunday, July 20, 1969'
	   */
	  time: function(v,lc,p) {
	    var o = {second:'numeric', minute:'numeric', hour:'numeric'};
	    switch (p) {
	      case 'full': case 'long': o.timeZoneName = 'short'; break;
	      case 'short': delete o.second;
	    }
	    return (new Date(v)).toLocaleTimeString(lc, o)
	  }
	};
	
	
	/** Add custom formatter functions to this MessageFormat instance
	 *
	 *  The general syntax for calling a formatting function in MessageFormat is
	 *  `{var, fn[, args]*}`, where `var` is the variable that will be set by the
	 *  user code, `fn` determines the formatting function, and `args` is an
	 *  optional comma-separated list of additional arguments.
	 *
	 *  In JavaScript, each formatting function is called with three parameters;
	 *  the variable value `v`, the current locale `lc`, and (if set) `args` as a
	 *  single string, or an array of strings. Formatting functions should not have
	 *  side effects.
	 *
	 * @see MessageFormat.formatters
	 *
	 * @memberof MessageFormat
	 * @param {Object.<string,function>} fmt - A map of formatting functions
	 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
	 *
	 * @example
	 * var mf = new MessageFormat('en-GB');
	 * mf.addFormatters({
	 *   upcase: function(v) { return v.toUpperCase(); },
	 *   locale: function(v, lc) { return lc; },
	 *   prop: function(v, lc, p) { return v[p] }
	 * });
	 *
	 * mf.compile('This is {VAR, upcase}.')({ VAR: 'big' })
	 * // 'This is BIG.'
	 *
	 * mf.compile('The current locale is {_, locale}.')({ _: '' })
	 * // 'The current locale is en-GB.'
	 *
	 * mf.compile('Answer: {obj, prop, a}')({ obj: {q: 3, a: 42} })
	 * // 'Answer: 42'
	 */
	MessageFormat.prototype.addFormatters = function(fmt) {
	  for (var name in fmt) if (fmt.hasOwnProperty(name)) {
	    this.fmt[name] = fmt[name];
	  }
	  return this;
	};
	
	
	/** Disable the validation of plural & selectordinal keys
	 *
	 *  Previous versions of messageformat.js allowed the use of plural &
	 *  selectordinal statements with any keys; now we throw an error when a
	 *  statement uses a non-numerical key that will never be matched as a
	 *  pluralization category for the current locale.
	 *
	 *  Use this method to disable the validation and allow usage as previously.
	 *  To re-enable, you'll need to create a new MessageFormat instance.
	 *
	 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
	 *
	 * @example
	 * var mf = new MessageFormat('en');
	 * var msg = '{X, plural, zero{no answers} one{an answer} other{# answers}}';
	 *
	 * mf.compile(msg);
	 * // Error: Invalid key `zero` for argument `X`. Valid plural keys for this
	 * //        locale are `one`, `other`, and explicit keys like `=0`.
	 *
	 * mf.disablePluralKeyChecks();
	 * mf.compile(msg)({ X: 0 });
	 * // '0 answers'
	 */
	MessageFormat.prototype.disablePluralKeyChecks = function() {
	  this.noPluralKeyChecks = true;
	  for (var lc in this.pluralFuncs) if (this.pluralFuncs.hasOwnProperty(lc)) {
	    this.pluralFuncs[lc].cardinal = [];
	    this.pluralFuncs[lc].ordinal = [];
	  }
	  return this;
	};
	
	
	/** Enable or disable the addition of Unicode control characters to all input
	 *  to preserve the integrity of the output when mixing LTR and RTL text.
	 *
	 * @see http://cldr.unicode.org/development/development-process/design-proposals/bidi-handling-of-structured-text
	 *
	 * @memberof MessageFormat
	 * @param {boolean} [enable=true]
	 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
	 *
	 * @example
	 * // upper case stands for RTL characters, output is shown as rendered
	 * var mf = new MessageFormat('en');
	 *
	 * mf.compile('{0} >> {1} >> {2}')(['first', 'SECOND', 'THIRD']);
	 * // 'first >> THIRD << SECOND'
	 *
	 * mf.setBiDiSupport(true);
	 * mf.compile('{0} >> {1} >> {2}')(['first', 'SECOND', 'THIRD']);
	 * // 'first >> SECOND >> THIRD'
	 */
	MessageFormat.prototype.setBiDiSupport = function(enable) {
	    this.bidiSupport = !!enable || (typeof enable == 'undefined');
	    return this;
	};
	
	
	/** Enable or disable support for the default formatters, which require the
	 *  `Intl` object. Note that this can't be autodetected, as the environment
	 *  in which the formatted text is compiled into Javascript functions is not
	 *  necessarily the same environment in which they will get executed.
	 *
	 * @see MessageFormat.formatters
	 *
	 * @memberof MessageFormat
	 * @param {boolean} [enable=true]
	 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
	 */
	MessageFormat.prototype.setIntlSupport = function(enable) {
	    this.intlSupport = !!enable || (typeof enable == 'undefined');
	    return this;
	};
	
	
	/** According to the ICU MessageFormat spec, a `#` character directly inside a
	 *  `plural` or `selectordinal` statement should be replaced by the number
	 *  matching the surrounding statement. By default, messageformat.js will
	 *  replace `#` signs with the value of the nearest surrounding `plural` or
	 *  `selectordinal` statement.
	 *
	 *  Set this to true to follow the stricter ICU MessageFormat spec, and to
	 *  throw a runtime error if `#` is used with non-numeric input.
	 *
	 * @memberof MessageFormat
	 * @param {boolean} [enable=true]
	 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
	 *
	 * @example
	 * var mf = new MessageFormat('en');
	 *
	 * var cookieMsg = '#: {X, plural, =0{no cookies} one{a cookie} other{# cookies}}';
	 * mf.compile(cookieMsg)({ X: 3 });
	 * // '#: 3 cookies'
	 *
	 * var pastryMsg = '{X, plural, one{{P, select, cookie{a cookie} other{a pie}}} other{{P, select, cookie{# cookies} other{# pies}}}}';
	 * mf.compile(pastryMsg)({ X: 3, P: 'pie' });
	 * // '3 pies'
	 *
	 * mf.setStrictNumberSign(true);
	 * mf.compile(pastryMsg)({ X: 3, P: 'pie' });
	 * // '# pies'
	 */
	MessageFormat.prototype.setStrictNumberSign = function(enable) {
	    this.strictNumberSign = !!enable || (typeof enable == 'undefined');
	    this.runtime.setStrictNumber(this.strictNumberSign);
	    return this;
	};
	
	
	/** Compile messages into storable functions
	 *
	 *  If `messages` is a single string including ICU MessageFormat declarations,
	 *  the result of `compile()` is a function taking a single Object parameter
	 *  `d` representing each of the input's defined variables.
	 *
	 *  If `messages` is a hierarchical structure of such strings, the output of
	 *  `compile()` will match that structure, with each string replaced by its
	 *  corresponding JavaScript function.
	 *
	 *  If the input `messages` -- and therefore the output -- of `compile()` is an
	 *  object, the output object will have a `toString(global)` method that may be
	 *  used to store or cache the compiled functions to disk, for later inclusion
	 *  in any JS environment, without a local MessageFormat instance required. Its
	 *  `global` parameters sets the name (if any) of the resulting global variable,
	 *  with special handling for `exports`, `module.exports`, and `export default`.
	 *  If `global` does not contain a `.`, the output defaults to an UMD pattern.
	 *
	 *  If `locale` is not set, the first locale set in the object's constructor
	 *  will be used by default; using a key at any depth of `messages` that is a
	 *  declared locale will set its child elements to use that locale.
	 *
	 *  If `locale` is set, it is used for all messages. If the constructor
	 *  declared any locales, `locale` needs to be one of them.
	 *
	 * @memberof MessageFormat
	 * @param {string|Object} messages - The input message(s) to be compiled, in ICU MessageFormat
	 * @param {string} [locale] - A locale to use for the messages
	 * @returns {function|Object} The first match found for the given locale(s)
	 *
	 * @example
	 * var mf = new MessageFormat('en');
	 * var cf = mf.compile('A {TYPE} example.');
	 *
	 * cf({ TYPE: 'simple' })
	 * // 'A simple example.'
	 *
	 * @example
	 * var mf = new MessageFormat(['en', 'fi']);
	 * var cf = mf.compile({
	 *   en: { a: 'A {TYPE} example.',
	 *         b: 'This is the {COUNT, selectordinal, one{#st} two{#nd} few{#rd} other{#th}} example.' },
	 *   fi: { a: '{TYPE} esimerkki.',
	 *         b: 'Tämä on {COUNT, selectordinal, other{#.}} esimerkki.' }
	 * });
	 *
	 * cf.en.b({ COUNT: 2 })
	 * // 'This is the 2nd example.'
	 *
	 * cf.fi.b({ COUNT: 2 })
	 * // 'Tämä on 2. esimerkki.'
	 *
	 * @example
	 * var fs = require('fs');
	 * var mf = new MessageFormat('en').setIntlSupport();
	 * var msgSet = {
	 *   a: 'A {TYPE} example.',
	 *   b: 'This has {COUNT, plural, one{one member} other{# members}}.',
	 *   c: 'We have {P, number, percent} code coverage.'
	 * };
	 * var cfStr = mf.compile(msgSet).toString('module.exports');
	 * fs.writeFileSync('messages.js', cfStr);
	 * ...
	 * var messages = require('./messages');
	 *
	 * messages.a({ TYPE: 'more complex' })
	 * // 'A more complex example.'
	 *
	 * messages.b({ COUNT: 3 })
	 * // 'This has 3 members.'
	 */
	MessageFormat.prototype.compile = function(messages, locale) {
	  function _stringify(obj, level) {
	    if (!level) level = 0;
	    if (typeof obj != 'object') return obj;
	    var o = [], indent = '';
	    for (var i = 0; i < level; ++i) indent += '  ';
	    for (var k in obj) o.push('\n' + indent + '  ' + Compiler.propname(k) + ': ' + _stringify(obj[k], level + 1));
	    return '{' + o.join(',') + '\n' + indent + '}';
	  }
	
	  var pf;
	  if (Object.keys(this.pluralFuncs).length == 0) {
	    if (!locale) locale = MessageFormat.defaultLocale;
	    pf = {};
	    pf[locale] = getPluralFunc(locale, this.noPluralKeyChecks);
	  } else if (locale) {
	    pf = {};
	    pf[locale] = this.pluralFuncs[locale];
	    if (!pf[locale]) throw new Error('Locale ' + JSON.stringify(locale) + 'not found in ' + JSON.stringify(this.pluralFuncs) + '!');
	  } else {
	    pf = this.pluralFuncs;
	    locale = Object.keys(pf)[0];
	  }
	
	  var compiler = new Compiler(this);
	  var obj = compiler.compile(messages, locale, pf);
	
	  if (typeof messages != 'object') {
	    var fn = new Function(
	        'number, plural, select, fmt', Compiler.funcname(locale),
	        'return ' + obj);
	    var rt = this.runtime;
	    return fn(rt.number, rt.plural, rt.select, this.fmt, pf[locale]);
	  }
	
	  var rtStr = this.runtime.toString(pf, compiler) + '\n';
	  var objStr = _stringify(obj);
	  var result = new Function(rtStr + 'return ' + objStr)();
	  if (result.hasOwnProperty('toString')) throw new Error('The top-level message key `toString` is reserved');
	
	  result.toString = function(global) {
	    switch (global || '') {
	      case 'exports':
	        var o = [];
	        for (var k in obj) o.push(Compiler.propname(k, 'exports') + ' = ' + _stringify(obj[k]));
	        return rtStr + o.join(';\n');
	      case 'module.exports':
	        return rtStr + 'module.exports = ' + objStr;
	      case 'export default':
	        return rtStr +  'export default ' + objStr;
	      case '':
	        return rtStr + 'return ' + objStr;
	      default:
	        if (global.indexOf('.') > -1) return rtStr + global + ' = ' + objStr;
	        return rtStr + [
	          '(function (root, G) {',
	          '  if (typeof define === "function" && define.amd) { define(G); }',
	          '  else if (typeof exports === "object") { module.exports = G; }',
	          '  else { ' + Compiler.propname(global, 'root') + ' = G; }',
	          '})(this, ' + objStr + ');'
	        ].join('\n');
	    }
	  }
	  return result;
	}
	
	
	module.exports = MessageFormat;


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	var Compiler = __webpack_require__(380);
	
	
	/** A set of utility functions that are called by the compiled Javascript
	 *  functions, these are included locally in the output of {@link
	 *  MessageFormat#compile compile()}.
	 *
	 * @class
	 * @param {MessageFormat} mf - A MessageFormat instance
	 */
	function Runtime(mf) {
	  this.mf = mf;
	  this.setStrictNumber(mf.strictNumberSign);
	}
	
	module.exports = Runtime;
	
	
	/** Utility function for `#` in plural rules
	 *
	 *  Will throw an Error if `value` has a non-numeric value and `offset` is
	 *  non-zero or {@link MessageFormat#setStrictNumberSign} is set.
	 *
	 * @function Runtime#number
	 * @param {number} value - The value to operate on
	 * @param {string} name - The name of the argument, used for error reporting
	 * @param {number} [offset=0] - An optional offset, set by the surrounding context
	 * @returns {number|string} The result of applying the offset to the input value
	 */
	function defaultNumber(value, name, offset) {
	  if (!offset) return value;
	  if (isNaN(value)) throw new Error('Can\'t apply offset:' + offset + ' to argument `' + name +
	                                    '` with non-numerical value ' + JSON.stringify(value) + '.');
	  return value - offset;
	}
	
	
	/** @private */
	function strictNumber(value, name, offset) {
	  if (isNaN(value)) throw new Error('Argument `' + name + '` has non-numerical value ' + JSON.stringify(value) + '.');
	  return value - (offset || 0);
	}
	
	
	/** Set how strictly the {@link number} method parses its input.
	 *
	 *  According to the ICU MessageFormat spec, `#` can only be used to replace a
	 *  number input of a `plural` statement. By default, messageformat.js does not
	 *  throw a runtime error if you use non-numeric argument with a `plural` rule,
	 *  unless rule also includes a non-zero `offset`.
	 *
	 *  This is called by {@link MessageFormat#setStrictNumberSign} to follow the
	 *  stricter ICU MessageFormat spec.
	 *
	 * @param {boolean} [enable=false]
	 */
	Runtime.prototype.setStrictNumber = function(enable) {
	  this.number = enable ? strictNumber : defaultNumber;
	}
	
	
	/** Utility function for `{N, plural|selectordinal, ...}`
	 *
	 * @param {number} value - The key to use to find a pluralization rule
	 * @param {number} offset - An offset to apply to `value`
	 * @param {function} lcfunc - A locale function from `pluralFuncs`
	 * @param {Object.<string,string>} data - The object from which results are looked up
	 * @param {?boolean} isOrdinal - If true, use ordinal rather than cardinal rules
	 * @returns {string} The result of the pluralization
	 */
	Runtime.prototype.plural = function(value, offset, lcfunc, data, isOrdinal) {
	  if ({}.hasOwnProperty.call(data, value)) return data[value];
	  if (offset) value -= offset;
	  var key = lcfunc(value, isOrdinal);
	  if (key in data) return data[key];
	  return data.other;
	}
	
	
	/** Utility function for `{N, select, ...}`
	 *
	 * @param {number} value - The key to use to find a selection
	 * @param {Object.<string,string>} data - The object from which results are looked up
	 * @returns {string} The result of the select statement
	 */
	Runtime.prototype.select = function(value, data) {
	  if ({}.hasOwnProperty.call(data, value)) return data[value];
	  return data.other;
	}
	
	
	/** @private */
	Runtime.prototype.toString = function(pluralFuncs, compiler) {
	  function _stringify(o, level) {
	    if (typeof o != 'object') {
	      var funcStr = o.toString().replace(/^(function )\w*/, '$1');
	      var indent = /([ \t]*)\S.*$/.exec(funcStr);
	      return indent ? funcStr.replace(new RegExp('^' + indent[1], 'mg'), '') : funcStr;
	    }
	    var s = [];
	    for (var i in o) {
	      if (level == 0) s.push('var ' + i + ' = ' + _stringify(o[i], level + 1) + ';\n');
	      else s.push(Compiler.propname(i) + ': ' + _stringify(o[i], level + 1));
	    }
	    if (level == 0) return s.join('');
	    if (s.length == 0) return '{}';
	    var indent = '  '; while (--level) indent += '  ';
	    return '{\n' + s.join(',\n').replace(/^/gm, indent) + '\n}';
	  }
	
	  var obj = {};
	  Object.keys(compiler.locales).forEach(function(lc) { obj[Compiler.funcname(lc)] = pluralFuncs[lc]; });
	  Object.keys(compiler.runtime).forEach(function(fn) { obj[fn] = this[fn]; }, this);
	  var fmtKeys = Object.keys(compiler.formatters);
	  var fmt = this.mf.fmt;
	  if (fmtKeys.length) obj.fmt = fmtKeys.reduce(function(o, key) { o[key] = fmt[key]; return o; }, {});
	  return _stringify(obj, 0);
	}


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 381,
		"./af.js": 381,
		"./ar": 388,
		"./ar-dz": 382,
		"./ar-dz.js": 382,
		"./ar-kw": 383,
		"./ar-kw.js": 383,
		"./ar-ly": 384,
		"./ar-ly.js": 384,
		"./ar-ma": 385,
		"./ar-ma.js": 385,
		"./ar-sa": 386,
		"./ar-sa.js": 386,
		"./ar-tn": 387,
		"./ar-tn.js": 387,
		"./ar.js": 388,
		"./az": 389,
		"./az.js": 389,
		"./be": 390,
		"./be.js": 390,
		"./bg": 391,
		"./bg.js": 391,
		"./bm": 392,
		"./bm.js": 392,
		"./bn": 393,
		"./bn.js": 393,
		"./bo": 394,
		"./bo.js": 394,
		"./br": 395,
		"./br.js": 395,
		"./bs": 396,
		"./bs.js": 396,
		"./ca": 397,
		"./ca.js": 397,
		"./cs": 398,
		"./cs.js": 398,
		"./cv": 399,
		"./cv.js": 399,
		"./cy": 400,
		"./cy.js": 400,
		"./da": 401,
		"./da.js": 401,
		"./de": 404,
		"./de-at": 402,
		"./de-at.js": 402,
		"./de-ch": 403,
		"./de-ch.js": 403,
		"./de.js": 404,
		"./dv": 405,
		"./dv.js": 405,
		"./el": 406,
		"./el.js": 406,
		"./en-au": 407,
		"./en-au.js": 407,
		"./en-ca": 408,
		"./en-ca.js": 408,
		"./en-gb": 409,
		"./en-gb.js": 409,
		"./en-ie": 410,
		"./en-ie.js": 410,
		"./en-il": 411,
		"./en-il.js": 411,
		"./en-nz": 412,
		"./en-nz.js": 412,
		"./eo": 413,
		"./eo.js": 413,
		"./es": 416,
		"./es-do": 414,
		"./es-do.js": 414,
		"./es-us": 415,
		"./es-us.js": 415,
		"./es.js": 416,
		"./et": 417,
		"./et.js": 417,
		"./eu": 418,
		"./eu.js": 418,
		"./fa": 419,
		"./fa.js": 419,
		"./fi": 420,
		"./fi.js": 420,
		"./fo": 421,
		"./fo.js": 421,
		"./fr": 424,
		"./fr-ca": 422,
		"./fr-ca.js": 422,
		"./fr-ch": 423,
		"./fr-ch.js": 423,
		"./fr.js": 424,
		"./fy": 425,
		"./fy.js": 425,
		"./gd": 426,
		"./gd.js": 426,
		"./gl": 427,
		"./gl.js": 427,
		"./gom-latn": 428,
		"./gom-latn.js": 428,
		"./gu": 429,
		"./gu.js": 429,
		"./he": 430,
		"./he.js": 430,
		"./hi": 431,
		"./hi.js": 431,
		"./hr": 432,
		"./hr.js": 432,
		"./hu": 433,
		"./hu.js": 433,
		"./hy-am": 434,
		"./hy-am.js": 434,
		"./id": 435,
		"./id.js": 435,
		"./is": 436,
		"./is.js": 436,
		"./it": 437,
		"./it.js": 437,
		"./ja": 438,
		"./ja.js": 438,
		"./jv": 439,
		"./jv.js": 439,
		"./ka": 440,
		"./ka.js": 440,
		"./kk": 441,
		"./kk.js": 441,
		"./km": 442,
		"./km.js": 442,
		"./kn": 443,
		"./kn.js": 443,
		"./ko": 444,
		"./ko.js": 444,
		"./ky": 445,
		"./ky.js": 445,
		"./lb": 446,
		"./lb.js": 446,
		"./lo": 447,
		"./lo.js": 447,
		"./lt": 448,
		"./lt.js": 448,
		"./lv": 449,
		"./lv.js": 449,
		"./me": 450,
		"./me.js": 450,
		"./mi": 451,
		"./mi.js": 451,
		"./mk": 452,
		"./mk.js": 452,
		"./ml": 453,
		"./ml.js": 453,
		"./mn": 454,
		"./mn.js": 454,
		"./mr": 455,
		"./mr.js": 455,
		"./ms": 457,
		"./ms-my": 456,
		"./ms-my.js": 456,
		"./ms.js": 457,
		"./mt": 458,
		"./mt.js": 458,
		"./my": 459,
		"./my.js": 459,
		"./nb": 460,
		"./nb.js": 460,
		"./ne": 461,
		"./ne.js": 461,
		"./nl": 463,
		"./nl-be": 462,
		"./nl-be.js": 462,
		"./nl.js": 463,
		"./nn": 464,
		"./nn.js": 464,
		"./pa-in": 465,
		"./pa-in.js": 465,
		"./pl": 466,
		"./pl.js": 466,
		"./pt": 468,
		"./pt-br": 467,
		"./pt-br.js": 467,
		"./pt.js": 468,
		"./ro": 469,
		"./ro.js": 469,
		"./ru": 470,
		"./ru.js": 470,
		"./sd": 471,
		"./sd.js": 471,
		"./se": 472,
		"./se.js": 472,
		"./si": 473,
		"./si.js": 473,
		"./sk": 474,
		"./sk.js": 474,
		"./sl": 475,
		"./sl.js": 475,
		"./sq": 476,
		"./sq.js": 476,
		"./sr": 478,
		"./sr-cyrl": 477,
		"./sr-cyrl.js": 477,
		"./sr.js": 478,
		"./ss": 479,
		"./ss.js": 479,
		"./sv": 480,
		"./sv.js": 480,
		"./sw": 481,
		"./sw.js": 481,
		"./ta": 482,
		"./ta.js": 482,
		"./te": 483,
		"./te.js": 483,
		"./tet": 484,
		"./tet.js": 484,
		"./tg": 485,
		"./tg.js": 485,
		"./th": 486,
		"./th.js": 486,
		"./tl-ph": 487,
		"./tl-ph.js": 487,
		"./tlh": 488,
		"./tlh.js": 488,
		"./tr": 489,
		"./tr.js": 489,
		"./tzl": 490,
		"./tzl.js": 490,
		"./tzm": 492,
		"./tzm-latn": 491,
		"./tzm-latn.js": 491,
		"./tzm.js": 492,
		"./ug-cn": 493,
		"./ug-cn.js": 493,
		"./uk": 494,
		"./uk.js": 494,
		"./ur": 495,
		"./ur.js": 495,
		"./uz": 497,
		"./uz-latn": 496,
		"./uz-latn.js": 496,
		"./uz.js": 497,
		"./vi": 498,
		"./vi.js": 498,
		"./x-pseudo": 499,
		"./x-pseudo.js": 499,
		"./yo": 500,
		"./yo.js": 500,
		"./zh-cn": 501,
		"./zh-cn.js": 501,
		"./zh-hk": 502,
		"./zh-hk.js": 502,
		"./zh-tw": 503,
		"./zh-tw.js": 503
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1126;


/***/ }),
/* 1127 */
/***/ (function(module, exports) {

	'use strict';
	
	AdminController.$inject = ["adminService", "toast", "$scope", "$rootScope", "$state", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AdminController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AdminController(adminService, toast, $scope, $rootScope, $state, $translate) {
	
	    var vm = this;
	    vm.save = save;
	    vm.sendTestMail = sendTestMail;
	    vm.smtpProtocols = 'smtp smtps'.split(' ').map(function (protocol) {
	        return protocol;
	    });
	
	    $translate('admin.test-mail-sent').then(function (translation) {
	        vm.testMailSent = translation;
	    }, function (translationId) {
	        vm.testMailSent = translationId;
	    });
	
	    loadSettings();
	
	    function loadSettings() {
	        adminService.getAdminSettings($state.$current.data.key).then(function success(settings) {
	            vm.settings = settings;
	        });
	    }
	
	    function save() {
	        adminService.saveAdminSettings(vm.settings).then(function success(settings) {
	            vm.settings = settings;
	            vm.settingsForm.$setPristine();
	        });
	    }
	
	    function sendTestMail() {
	        adminService.sendTestMail(vm.settings).then(function success() {
	            toast.showSuccess($translate.instant('admin.test-mail-sent'));
	        });
	    }
	}

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AdminRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AdminRoutes;
	
	var _generalSettingsTpl = __webpack_require__(1371);
	
	var _generalSettingsTpl2 = _interopRequireDefault(_generalSettingsTpl);
	
	var _outgoingMailSettingsTpl = __webpack_require__(1372);
	
	var _outgoingMailSettingsTpl2 = _interopRequireDefault(_outgoingMailSettingsTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function AdminRoutes($stateProvider) {
	    $stateProvider.state('home.settings', {
	        url: '/settings',
	        module: 'private',
	        auth: ['SYS_ADMIN'],
	        redirectTo: 'home.settings.general',
	        ncyBreadcrumb: {
	            label: '{"icon": "settings", "label": "admin.system-settings"}'
	        }
	    }).state('home.settings.general', {
	        url: '/general',
	        module: 'private',
	        auth: ['SYS_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _generalSettingsTpl2.default,
	                controllerAs: 'vm',
	                controller: 'AdminController'
	            }
	        },
	        data: {
	            key: 'general',
	            pageTitle: 'admin.general-settings'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "settings_applications", "label": "admin.general"}'
	        }
	    }).state('home.settings.outgoing-mail', {
	        url: '/outgoing-mail',
	        module: 'private',
	        auth: ['SYS_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _outgoingMailSettingsTpl2.default,
	                controllerAs: 'vm',
	                controller: 'AdminController'
	            }
	        },
	        data: {
	            key: 'mail',
	            pageTitle: 'admin.outgoing-mail-settings'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "mail", "label": "admin.outgoing-mail"}'
	        }
	    });
	}

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularMaterial = __webpack_require__(80);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularMessages = __webpack_require__(164);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _admin = __webpack_require__(1135);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _confirmOnExit = __webpack_require__(229);
	
	var _confirmOnExit2 = _interopRequireDefault(_confirmOnExit);
	
	var _toast = __webpack_require__(75);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _admin3 = __webpack_require__(1128);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	var _admin5 = __webpack_require__(1127);
	
	var _admin6 = _interopRequireDefault(_admin5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.admin', [_angularUiRouter2.default, _angularMaterial2.default, _angularMessages2.default, _admin2.default, _confirmOnExit2.default, _toast2.default]).config(_admin4.default).controller('AdminController', _admin6.default).name;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AlarmDetailsDialogController.$inject = ["$mdDialog", "$filter", "$translate", "types", "alarmService", "alarmId", "allowAcknowledgment", "allowClear", "displayDetails", "showingCallback"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AlarmDetailsDialogController;
	
	__webpack_require__(33);
	
	__webpack_require__(51);
	
	__webpack_require__(61);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	__webpack_require__(741);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var js_beautify = _jsBeautify2.default.js;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function AlarmDetailsDialogController($mdDialog, $filter, $translate, types, alarmService, alarmId, allowAcknowledgment, allowClear, displayDetails, showingCallback) {
	
	    var vm = this;
	
	    vm.alarmId = alarmId;
	    vm.allowAcknowledgment = allowAcknowledgment;
	    vm.allowClear = allowClear;
	    vm.displayDetails = displayDetails;
	    vm.types = types;
	    vm.alarm = null;
	
	    vm.alarmUpdated = false;
	
	    showingCallback.onShowing = function (scope, element) {
	        if (vm.displayDetails) {
	            updateEditorSize(element);
	        }
	    };
	
	    vm.alarmDetailsOptions = {
	        useWrapMode: false,
	        mode: 'json',
	        showGutter: false,
	        showPrintMargin: false,
	        theme: 'github',
	        advanced: {
	            enableSnippets: false,
	            enableBasicAutocompletion: false,
	            enableLiveAutocompletion: false
	        },
	        onLoad: function onLoad(_ace) {
	            vm.editor = _ace;
	        }
	    };
	
	    vm.close = close;
	    vm.acknowledge = acknowledge;
	    vm.clear = clear;
	
	    loadAlarm();
	
	    function updateEditorSize(element) {
	        var newWidth = 600;
	        var newHeight = 200;
	        angular.element('#tb-alarm-details', element).height(newHeight.toString() + "px").width(newWidth.toString() + "px");
	        vm.editor.resize();
	    }
	
	    function loadAlarm() {
	        alarmService.getAlarmInfo(vm.alarmId).then(function success(alarm) {
	            vm.alarm = alarm;
	            loadAlarmFields();
	        }, function fail() {
	            vm.alarm = null;
	        });
	    }
	
	    function loadAlarmFields() {
	        vm.createdTime = $filter('date')(vm.alarm.createdTime, 'yyyy-MM-dd HH:mm:ss');
	        vm.startTime = null;
	        if (vm.alarm.startTs) {
	            vm.startTime = $filter('date')(vm.alarm.startTs, 'yyyy-MM-dd HH:mm:ss');
	        }
	        vm.endTime = null;
	        if (vm.alarm.endTs) {
	            vm.endTime = $filter('date')(vm.alarm.endTs, 'yyyy-MM-dd HH:mm:ss');
	        }
	        vm.ackTime = null;
	        if (vm.alarm.ackTs) {
	            vm.ackTime = $filter('date')(vm.alarm.ackTs, 'yyyy-MM-dd HH:mm:ss');
	        }
	        vm.clearTime = null;
	        if (vm.alarm.clearTs) {
	            vm.clearTime = $filter('date')(vm.alarm.clearTs, 'yyyy-MM-dd HH:mm:ss');
	        }
	
	        vm.alarmSeverity = $translate.instant(types.alarmSeverity[vm.alarm.severity].name);
	
	        vm.alarmStatus = $translate.instant('alarm.display-status.' + vm.alarm.status);
	
	        vm.alarmDetails = null;
	        if (vm.alarm.details) {
	            vm.alarmDetails = angular.toJson(vm.alarm.details);
	            vm.alarmDetails = js_beautify(vm.alarmDetails, { indent_size: 4 });
	        }
	    }
	
	    function acknowledge() {
	        alarmService.ackAlarm(vm.alarmId).then(function success() {
	            vm.alarmUpdated = true;
	            loadAlarm();
	        });
	    }
	
	    function clear() {
	        alarmService.clearAlarm(vm.alarmId).then(function success() {
	            vm.alarmUpdated = true;
	            loadAlarm();
	        });
	    }
	
	    function close() {
	        $mdDialog.hide(vm.alarmUpdated ? vm.alarm : null);
	    }
	}

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	AlarmHeaderDirective.$inject = ["$compile", "$templateCache"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AlarmHeaderDirective;
	
	var _alarmHeaderTpl = __webpack_require__(1373);
	
	var _alarmHeaderTpl2 = _interopRequireDefault(_alarmHeaderTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function AlarmHeaderDirective($compile, $templateCache) {
	
	    var linker = function linker(scope, element) {
	
	        var template = $templateCache.get(_alarmHeaderTpl2.default);
	        element.html(template);
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "A",
	        replace: false,
	        link: linker,
	        scope: false
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AlarmRowDirective.$inject = ["$compile", "$templateCache", "types", "$mdDialog", "$document"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AlarmRowDirective;
	
	var _alarmDetailsDialogTpl = __webpack_require__(517);
	
	var _alarmDetailsDialogTpl2 = _interopRequireDefault(_alarmDetailsDialogTpl);
	
	var _alarmRowTpl = __webpack_require__(1374);
	
	var _alarmRowTpl2 = _interopRequireDefault(_alarmRowTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function AlarmRowDirective($compile, $templateCache, types, $mdDialog, $document) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        var template = $templateCache.get(_alarmRowTpl2.default);
	        element.html(template);
	
	        scope.alarm = attrs.alarm;
	        scope.types = types;
	
	        scope.showAlarmDetails = function ($event) {
	            var onShowingCallback = {
	                onShowing: function onShowing() {}
	            };
	            $mdDialog.show({
	                controller: 'AlarmDetailsDialogController',
	                controllerAs: 'vm',
	                templateUrl: _alarmDetailsDialogTpl2.default,
	                locals: {
	                    alarmId: scope.alarm.id.id,
	                    allowAcknowledgment: true,
	                    allowClear: true,
	                    displayDetails: true,
	                    showingCallback: onShowingCallback
	                },
	                parent: angular.element($document[0].body),
	                targetEvent: $event,
	                fullscreen: true,
	                skipHide: true,
	                onShowing: function onShowing(scope, element) {
	                    onShowingCallback.onShowing(scope, element);
	                }
	            }).then(function (alarm) {
	                if (alarm) {
	                    scope.alarm = alarm;
	                }
	            });
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "A",
	        replace: false,
	        link: linker,
	        scope: false
	    };
	}

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AlarmTableDirective.$inject = ["$compile", "$templateCache", "$rootScope", "types", "alarmService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AlarmTableDirective;
	
	__webpack_require__(742);
	
	var _alarmTableTpl = __webpack_require__(1375);
	
	var _alarmTableTpl2 = _interopRequireDefault(_alarmTableTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function AlarmTableDirective($compile, $templateCache, $rootScope, types, alarmService) {
	
	    var linker = function linker(scope, element) {
	
	        var template = $templateCache.get(_alarmTableTpl2.default);
	
	        element.html(template);
	
	        scope.types = types;
	
	        scope.alarmSearchStatus = types.alarmSearchStatus.any;
	
	        var pageSize = 20;
	        var startTime = 0;
	        var endTime = 0;
	
	        scope.timewindow = {
	            history: {
	                timewindowMs: 24 * 60 * 60 * 1000 // 1 day
	            }
	        };
	
	        scope.topIndex = 0;
	
	        scope.theAlarms = {
	            getItemAtIndex: function getItemAtIndex(index) {
	                if (index > scope.alarms.data.length) {
	                    scope.theAlarms.fetchMoreItems_(index);
	                    return null;
	                }
	                var item = scope.alarms.data[index];
	                if (item) {
	                    item.indexNumber = index + 1;
	                }
	                return item;
	            },
	
	            getLength: function getLength() {
	                if (scope.alarms.hasNext) {
	                    return scope.alarms.data.length + scope.alarms.nextPageLink.limit;
	                } else {
	                    return scope.alarms.data.length;
	                }
	            },
	
	            fetchMoreItems_: function fetchMoreItems_() {
	                if (scope.alarms.hasNext && !scope.alarms.pending) {
	                    if (scope.entityType && scope.entityId && scope.alarmSearchStatus) {
	                        var promise = alarmService.getAlarms(scope.entityType, scope.entityId, scope.alarms.nextPageLink, scope.alarmSearchStatus, null, true, false);
	                        if (promise) {
	                            scope.alarms.pending = true;
	                            promise.then(function success(alarms) {
	                                scope.alarms.data = scope.alarms.data.concat(alarms.data);
	                                scope.alarms.nextPageLink = alarms.nextPageLink;
	                                scope.alarms.hasNext = alarms.hasNext;
	                                if (scope.alarms.hasNext) {
	                                    scope.alarms.nextPageLink.limit = pageSize;
	                                }
	                                scope.alarms.pending = false;
	                            }, function fail() {
	                                scope.alarms.hasNext = false;
	                                scope.alarms.pending = false;
	                            });
	                        } else {
	                            scope.alarms.hasNext = false;
	                        }
	                    } else {
	                        scope.alarms.hasNext = false;
	                    }
	                }
	            }
	        };
	
	        scope.reload = reload;
	
	        scope.$watch("entityId", function (newVal, prevVal) {
	            if (newVal && !angular.equals(newVal, prevVal)) {
	                resetFilter();
	                reload();
	            }
	        });
	
	        function destroyWatchers() {
	            if (scope.alarmSearchStatusWatchHandle) {
	                scope.alarmSearchStatusWatchHandle();
	                scope.alarmSearchStatusWatchHandle = null;
	            }
	            if (scope.timewindowWatchHandle) {
	                scope.timewindowWatchHandle();
	                scope.timewindowWatchHandle = null;
	            }
	        }
	
	        function initWatchers() {
	            scope.alarmSearchStatusWatchHandle = scope.$watch("alarmSearchStatus", function (newVal, prevVal) {
	                if (newVal && !angular.equals(newVal, prevVal)) {
	                    reload();
	                }
	            });
	            scope.timewindowWatchHandle = scope.$watch("timewindow", function (newVal, prevVal) {
	                if (newVal && !angular.equals(newVal, prevVal)) {
	                    reload();
	                }
	            }, true);
	        }
	
	        function resetFilter() {
	            destroyWatchers();
	            scope.timewindow = {
	                history: {
	                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
	                }
	            };
	            scope.alarmSearchStatus = types.alarmSearchStatus.any;
	            initWatchers();
	        }
	
	        function updateTimeWindowRange() {
	            if (scope.timewindow.history.timewindowMs) {
	                var currentTime = new Date().getTime();
	                startTime = currentTime - scope.timewindow.history.timewindowMs;
	                endTime = currentTime;
	            } else {
	                startTime = scope.timewindow.history.fixedTimewindow.startTimeMs;
	                endTime = scope.timewindow.history.fixedTimewindow.endTimeMs;
	            }
	        }
	
	        function reload() {
	            scope.topIndex = 0;
	            scope.selected = [];
	            updateTimeWindowRange();
	            scope.alarms = {
	                data: [],
	                nextPageLink: {
	                    limit: pageSize,
	                    startTime: startTime,
	                    endTime: endTime
	                },
	                hasNext: true,
	                pending: false
	            };
	            scope.theAlarms.getItemAtIndex(pageSize);
	        }
	
	        scope.noData = function () {
	            return scope.alarms.data.length == 0 && !scope.alarms.hasNext;
	        };
	
	        scope.hasData = function () {
	            return scope.alarms.data.length > 0;
	        };
	
	        scope.loading = function () {
	            return $rootScope.loading;
	        };
	
	        scope.hasScroll = function () {
	            var repeatContainer = scope.repeatContainer[0];
	            if (repeatContainer) {
	                var scrollElement = repeatContainer.children[0];
	                if (scrollElement) {
	                    return scrollElement.scrollHeight > scrollElement.clientHeight;
	                }
	            }
	            return false;
	        };
	
	        reload();
	
	        initWatchers();
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            entityType: '=',
	            entityId: '='
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alarmDetailsDialog = __webpack_require__(1130);
	
	var _alarmDetailsDialog2 = _interopRequireDefault(_alarmDetailsDialog);
	
	var _alarmHeader = __webpack_require__(1131);
	
	var _alarmHeader2 = _interopRequireDefault(_alarmHeader);
	
	var _alarmRow = __webpack_require__(1132);
	
	var _alarmRow2 = _interopRequireDefault(_alarmRow);
	
	var _alarmTable = __webpack_require__(1133);
	
	var _alarmTable2 = _interopRequireDefault(_alarmTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.alarm', []).controller('AlarmDetailsDialogController', _alarmDetailsDialog2.default).directive('tbAlarmHeader', _alarmHeader2.default).directive('tbAlarmRow', _alarmRow2.default).directive('tbAlarmTable', _alarmTable2.default).name;

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	'use strict';
	
	AdminService.$inject = ["$http", "$q"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.admin', []).factory('adminService', AdminService).name;
	
	/*@ngInject*/
	
	function AdminService($http, $q) {
	
	    var service = {
	        getAdminSettings: getAdminSettings,
	        saveAdminSettings: saveAdminSettings,
	        sendTestMail: sendTestMail,
	        checkUpdates: checkUpdates
	    };
	
	    return service;
	
	    function getAdminSettings(key) {
	        var deferred = $q.defer();
	        var url = '/api/admin/settings/' + key;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveAdminSettings(settings) {
	        var deferred = $q.defer();
	        var url = '/api/admin/settings';
	        $http.post(url, settings).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function sendTestMail(settings) {
	        var deferred = $q.defer();
	        var url = '/api/admin/settings/testMail';
	        $http.post(url, settings).then(function success() {
	            deferred.resolve();
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function checkUpdates() {
	        var deferred = $q.defer();
	        var url = '/api/admin/updates';
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	'use strict';
	
	AlarmService.$inject = ["$http", "$q", "$interval", "$filter", "$timeout", "utils", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.alarm', []).factory('alarmService', AlarmService).name;
	
	/*@ngInject*/
	
	function AlarmService($http, $q, $interval, $filter, $timeout, utils, types) {
	
	    var alarmSourceListeners = {};
	
	    var simulatedAlarm = {
	        createdTime: new Date().getTime(),
	        startTs: new Date().getTime(),
	        endTs: 0,
	        ackTs: 0,
	        clearTs: 0,
	        originatorName: 'Simulated',
	        originator: {
	            entityType: "DEVICE",
	            id: "1"
	        },
	        type: 'TEMPERATURE',
	        severity: "MAJOR",
	        status: types.alarmStatus.activeUnack,
	        details: {
	            message: "Temperature is high!"
	        }
	    };
	
	    var service = {
	        getAlarm: getAlarm,
	        getAlarmInfo: getAlarmInfo,
	        saveAlarm: saveAlarm,
	        ackAlarm: ackAlarm,
	        clearAlarm: clearAlarm,
	        getAlarms: getAlarms,
	        getHighestAlarmSeverity: getHighestAlarmSeverity,
	        pollAlarms: pollAlarms,
	        cancelPollAlarms: cancelPollAlarms,
	        subscribeForAlarms: subscribeForAlarms,
	        unsubscribeFromAlarms: unsubscribeFromAlarms
	    };
	
	    return service;
	
	    function getAlarm(alarmId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/alarm/' + alarmId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getAlarmInfo(alarmId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/alarm/info/' + alarmId;
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveAlarm(alarm, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/alarm';
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.post(url, alarm, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function ackAlarm(alarmId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/alarm/' + alarmId + '/ack';
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.post(url, null, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function clearAlarm(alarmId, ignoreErrors, config) {
	        var deferred = $q.defer();
	        var url = '/api/alarm/' + alarmId + '/clear';
	        if (!config) {
	            config = {};
	        }
	        config = Object.assign(config, { ignoreErrors: ignoreErrors });
	        $http.post(url, null, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getAlarms(entityType, entityId, pageLink, alarmSearchStatus, alarmStatus, fetchOriginator, ascOrder, config) {
	        var deferred = $q.defer();
	        var url = '/api/alarm/' + entityType + '/' + entityId + '?limit=' + pageLink.limit;
	
	        if (angular.isDefined(pageLink.startTime) && pageLink.startTime != null) {
	            url += '&startTime=' + pageLink.startTime;
	        }
	        if (angular.isDefined(pageLink.endTime) && pageLink.endTime != null) {
	            url += '&endTime=' + pageLink.endTime;
	        }
	        if (angular.isDefined(pageLink.idOffset) && pageLink.idOffset != null) {
	            url += '&offset=' + pageLink.idOffset;
	        }
	        if (alarmSearchStatus) {
	            url += '&searchStatus=' + alarmSearchStatus;
	        }
	        if (alarmStatus) {
	            url += '&status=' + alarmStatus;
	        }
	        if (fetchOriginator) {
	            url += '&fetchOriginator=' + (fetchOriginator === true ? 'true' : 'false');
	        }
	        if (angular.isDefined(ascOrder) && ascOrder != null) {
	            url += '&ascOrder=' + (ascOrder ? 'true' : 'false');
	        }
	
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getHighestAlarmSeverity(entityType, entityId, alarmSearchStatus, alarmStatus, config) {
	        var deferred = $q.defer();
	        var url = '/api/alarm/highestSeverity/' + entityType + '/' + entityId;
	
	        if (alarmSearchStatus) {
	            url += '?searchStatus=' + alarmSearchStatus;
	        } else if (alarmStatus) {
	            url += '?status=' + alarmStatus;
	        }
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function fetchAlarms(alarmsQuery, pageLink, deferred, alarmsList) {
	        getAlarms(alarmsQuery.entityType, alarmsQuery.entityId, pageLink, alarmsQuery.alarmSearchStatus, alarmsQuery.alarmStatus, alarmsQuery.fetchOriginator, false, { ignoreLoading: true }).then(function success(alarms) {
	            if (!alarmsList) {
	                alarmsList = [];
	            }
	            alarmsList = alarmsList.concat(alarms.data);
	            if (alarms.hasNext && !alarmsQuery.limit) {
	                fetchAlarms(alarmsQuery, alarms.nextPageLink, deferred, alarmsList);
	            } else {
	                alarmsList = $filter('orderBy')(alarmsList, ['-createdTime']);
	                deferred.resolve(alarmsList);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	    }
	
	    function getAlarmsByQuery(alarmsQuery) {
	        var deferred = $q.defer();
	        var time = Date.now();
	        var pageLink;
	        if (alarmsQuery.limit) {
	            pageLink = {
	                limit: alarmsQuery.limit
	            };
	        } else if (alarmsQuery.interval) {
	            pageLink = {
	                limit: 100,
	                startTime: time - alarmsQuery.interval
	            };
	        } else if (alarmsQuery.startTime) {
	            pageLink = {
	                limit: 100,
	                startTime: Math.round(alarmsQuery.startTime)
	            };
	            if (alarmsQuery.endTime) {
	                pageLink.endTime = Math.round(alarmsQuery.endTime);
	            }
	        }
	
	        fetchAlarms(alarmsQuery, pageLink, deferred);
	        return deferred.promise;
	    }
	
	    function onPollAlarms(alarmsQuery) {
	        getAlarmsByQuery(alarmsQuery).then(function success(alarms) {
	            alarmsQuery.onAlarms(alarms);
	        }, function fail() {});
	    }
	
	    function pollAlarms(entityType, entityId, alarmStatus, interval, limit, pollingInterval, onAlarms) {
	        var alarmsQuery = {
	            entityType: entityType,
	            entityId: entityId,
	            alarmSearchStatus: null,
	            alarmStatus: alarmStatus,
	            fetchOriginator: false,
	            interval: interval,
	            limit: limit,
	            onAlarms: onAlarms
	        };
	        onPollAlarms(alarmsQuery);
	        return $interval(onPollAlarms, pollingInterval, 0, false, alarmsQuery);
	    }
	
	    function cancelPollAlarms(pollPromise) {
	        if (angular.isDefined(pollPromise)) {
	            $interval.cancel(pollPromise);
	        }
	    }
	
	    function subscribeForAlarms(alarmSourceListener) {
	        alarmSourceListener.id = utils.guid();
	        alarmSourceListeners[alarmSourceListener.id] = alarmSourceListener;
	        var alarmSource = alarmSourceListener.alarmSource;
	        if (alarmSource.type == types.datasourceType.function) {
	            $timeout(function () {
	                alarmSourceListener.alarmsUpdated([simulatedAlarm], false);
	            });
	        } else if (alarmSource.entityType && alarmSource.entityId) {
	            var pollingInterval = alarmSourceListener.alarmsPollingInterval;
	            alarmSourceListener.alarmsQuery = {
	                entityType: alarmSource.entityType,
	                entityId: alarmSource.entityId,
	                alarmSearchStatus: alarmSourceListener.alarmSearchStatus,
	                alarmStatus: null
	            };
	            var originatorKeys = $filter('filter')(alarmSource.dataKeys, { name: 'originator' });
	            if (originatorKeys && originatorKeys.length) {
	                alarmSourceListener.alarmsQuery.fetchOriginator = true;
	            }
	            var subscriptionTimewindow = alarmSourceListener.subscriptionTimewindow;
	            if (subscriptionTimewindow.realtimeWindowMs) {
	                alarmSourceListener.alarmsQuery.startTime = subscriptionTimewindow.startTs;
	            } else {
	                alarmSourceListener.alarmsQuery.startTime = subscriptionTimewindow.fixedWindow.startTimeMs;
	                alarmSourceListener.alarmsQuery.endTime = subscriptionTimewindow.fixedWindow.endTimeMs;
	            }
	            alarmSourceListener.alarmsQuery.onAlarms = function (alarms) {
	                if (subscriptionTimewindow.realtimeWindowMs) {
	                    var now = Date.now();
	                    if (alarmSourceListener.lastUpdateTs) {
	                        var interval = now - alarmSourceListener.lastUpdateTs;
	                        alarmSourceListener.alarmsQuery.startTime += interval;
	                    }
	                    alarmSourceListener.lastUpdateTs = now;
	                }
	                alarmSourceListener.alarmsUpdated(alarms, false);
	            };
	            onPollAlarms(alarmSourceListener.alarmsQuery);
	            alarmSourceListener.pollPromise = $interval(onPollAlarms, pollingInterval, 0, false, alarmSourceListener.alarmsQuery);
	        }
	    }
	
	    function unsubscribeFromAlarms(alarmSourceListener) {
	        if (alarmSourceListener && alarmSourceListener.id) {
	            if (alarmSourceListener.pollPromise) {
	                $interval.cancel(alarmSourceListener.pollPromise);
	                alarmSourceListener.pollPromise = null;
	            }
	            delete alarmSourceListeners[alarmSourceListener.id];
	        }
	    }
	}

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	'use strict';
	
	AttributeService.$inject = ["$http", "$q", "$filter", "types", "telemetryWebsocketService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.attribute', []).factory('attributeService', AttributeService).name;
	
	/*@ngInject*/
	
	function AttributeService($http, $q, $filter, types, telemetryWebsocketService) {
	
	    var entityAttributesSubscriptionMap = {};
	
	    var service = {
	        getEntityKeys: getEntityKeys,
	        getEntityTimeseriesValues: getEntityTimeseriesValues,
	        getEntityAttributesValues: getEntityAttributesValues,
	        getEntityAttributes: getEntityAttributes,
	        subscribeForEntityAttributes: subscribeForEntityAttributes,
	        unsubscribeForEntityAttributes: unsubscribeForEntityAttributes,
	        saveEntityAttributes: saveEntityAttributes,
	        deleteEntityAttributes: deleteEntityAttributes
	    };
	
	    return service;
	
	    function getEntityKeys(entityType, entityId, query, type, config) {
	        var deferred = $q.defer();
	        var url = '/api/plugins/telemetry/' + entityType + '/' + entityId + '/keys/';
	        if (type === types.dataKeyType.timeseries) {
	            url += 'timeseries';
	        } else if (type === types.dataKeyType.attribute) {
	            url += 'attributes';
	        }
	        $http.get(url, config).then(function success(response) {
	            var result = [];
	            if (response.data) {
	                if (query) {
	                    var dataKeys = response.data;
	                    var lowercaseQuery = angular.lowercase(query);
	                    for (var i = 0; i < dataKeys.length; i++) {
	                        if (angular.lowercase(dataKeys[i]).indexOf(lowercaseQuery) === 0) {
	                            result.push(dataKeys[i]);
	                        }
	                    }
	                } else {
	                    result = response.data;
	                }
	            }
	            deferred.resolve(result);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function getEntityTimeseriesValues(entityType, entityId, keys, startTs, endTs, limit) {
	        var deferred = $q.defer();
	        var url = '/api/plugins/telemetry/' + entityType + '/' + entityId + '/values/timeseries';
	        url += '?keys=' + keys;
	        url += '&startTs=' + startTs;
	        url += '&endTs=' + endTs;
	        if (angular.isDefined(limit)) {
	            url += '&limit=' + limit;
	        }
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function getEntityAttributesValues(entityType, entityId, attributeScope, keys, config) {
	        var deferred = $q.defer();
	        var url = '/api/plugins/telemetry/' + entityType + '/' + entityId + '/values/attributes/' + attributeScope;
	        if (keys && keys.length) {
	            url += '?keys=' + keys;
	        }
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function processAttributes(attributes, query, deferred, successCallback, update, apply) {
	        attributes = $filter('orderBy')(attributes, query.order);
	        if (query.search != null) {
	            attributes = $filter('filter')(attributes, { key: query.search });
	        }
	        var responseData = {
	            count: attributes.length
	        };
	        var startIndex = query.limit * (query.page - 1);
	        responseData.data = attributes.slice(startIndex, startIndex + query.limit);
	        successCallback(responseData, update, apply);
	        if (deferred) {
	            deferred.resolve();
	        }
	    }
	
	    function getEntityAttributes(entityType, entityId, attributeScope, query, successCallback, config) {
	        var deferred = $q.defer();
	        var subscriptionId = entityType + entityId + attributeScope;
	        var eas = entityAttributesSubscriptionMap[subscriptionId];
	        if (eas) {
	            if (eas.attributes) {
	                processAttributes(eas.attributes, query, deferred, successCallback);
	                eas.subscriptionCallback = function (attributes) {
	                    processAttributes(attributes, query, null, successCallback, true, true);
	                };
	            } else {
	                eas.subscriptionCallback = function (attributes) {
	                    processAttributes(attributes, query, deferred, successCallback, false, true);
	                    eas.subscriptionCallback = function (attributes) {
	                        processAttributes(attributes, query, null, successCallback, true, true);
	                    };
	                };
	            }
	        } else {
	            var url = '/api/plugins/telemetry/' + entityType + '/' + entityId + '/values/attributes/' + attributeScope;
	            $http.get(url, config).then(function success(response) {
	                processAttributes(response.data, query, deferred, successCallback);
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return deferred;
	    }
	
	    function onSubscriptionData(data, subscriptionId) {
	        var entityAttributesSubscription = entityAttributesSubscriptionMap[subscriptionId];
	        if (entityAttributesSubscription) {
	            if (!entityAttributesSubscription.attributes) {
	                entityAttributesSubscription.attributes = [];
	                entityAttributesSubscription.keys = {};
	            }
	            var attributes = entityAttributesSubscription.attributes;
	            var keys = entityAttributesSubscription.keys;
	            for (var key in data) {
	                var index = keys[key];
	                var attribute;
	                if (index > -1) {
	                    attribute = attributes[index];
	                } else {
	                    attribute = {
	                        key: key
	                    };
	                    index = attributes.push(attribute) - 1;
	                    keys[key] = index;
	                }
	                var attrData = data[key][0];
	                attribute.lastUpdateTs = attrData[0];
	                attribute.value = attrData[1];
	            }
	            if (entityAttributesSubscription.subscriptionCallback) {
	                entityAttributesSubscription.subscriptionCallback(attributes);
	            }
	        }
	    }
	
	    function subscribeForEntityAttributes(entityType, entityId, attributeScope) {
	        var subscriptionId = entityType + entityId + attributeScope;
	        var entityAttributesSubscription = entityAttributesSubscriptionMap[subscriptionId];
	        if (!entityAttributesSubscription) {
	            var subscriptionCommand = {
	                entityType: entityType,
	                entityId: entityId,
	                scope: attributeScope
	            };
	
	            var type = attributeScope === types.latestTelemetry.value ? types.dataKeyType.timeseries : types.dataKeyType.attribute;
	
	            var subscriber = {
	                subscriptionCommands: [subscriptionCommand],
	                type: type,
	                onData: function onData(data) {
	                    if (data.data) {
	                        onSubscriptionData(data.data, subscriptionId);
	                    }
	                }
	            };
	            entityAttributesSubscription = {
	                subscriber: subscriber,
	                attributes: null
	            };
	            entityAttributesSubscriptionMap[subscriptionId] = entityAttributesSubscription;
	            telemetryWebsocketService.subscribe(subscriber);
	        }
	        return subscriptionId;
	    }
	
	    function unsubscribeForEntityAttributes(subscriptionId) {
	        var entityAttributesSubscription = entityAttributesSubscriptionMap[subscriptionId];
	        if (entityAttributesSubscription) {
	            telemetryWebsocketService.unsubscribe(entityAttributesSubscription.subscriber);
	            delete entityAttributesSubscriptionMap[subscriptionId];
	        }
	    }
	
	    function saveEntityAttributes(entityType, entityId, attributeScope, attributes) {
	        var deferred = $q.defer();
	        var attributesData = {};
	        var deleteAttributes = [];
	        for (var a = 0; a < attributes.length; a++) {
	            if (angular.isDefined(attributes[a].value) && attributes[a].value !== null) {
	                attributesData[attributes[a].key] = attributes[a].value;
	            } else {
	                deleteAttributes.push(attributes[a]);
	            }
	        }
	        var deleteEntityAttributesPromise;
	        if (deleteAttributes.length) {
	            deleteEntityAttributesPromise = deleteEntityAttributes(entityType, entityId, attributeScope, deleteAttributes);
	        }
	        if (Object.keys(attributesData).length) {
	            var url = '/api/plugins/telemetry/' + entityType + '/' + entityId + '/' + attributeScope;
	            $http.post(url, attributesData).then(function success(response) {
	                if (deleteEntityAttributesPromise) {
	                    deleteEntityAttributesPromise.then(function success() {
	                        deferred.resolve(response.data);
	                    }, function fail() {
	                        deferred.reject();
	                    });
	                } else {
	                    deferred.resolve(response.data);
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	        } else if (deleteEntityAttributesPromise) {
	            deleteEntityAttributesPromise.then(function success() {
	                deferred.resolve();
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            deferred.resolve();
	        }
	        return deferred.promise;
	    }
	
	    function deleteEntityAttributes(entityType, entityId, attributeScope, attributes) {
	        var deferred = $q.defer();
	        var keys = '';
	        for (var i = 0; i < attributes.length; i++) {
	            if (i > 0) {
	                keys += ',';
	            }
	            keys += attributes[i].key;
	        }
	        var url = '/api/plugins/telemetry/' + entityType + '/' + entityId + '/' + attributeScope + '?keys=' + keys;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	'use strict';
	
	AuditLogService.$inject = ["$http", "$q"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.auditLog', []).factory('auditLogService', AuditLogService).name;
	
	/*@ngInject*/
	
	function AuditLogService($http, $q) {
	
	    var service = {
	        getAuditLogsByEntityId: getAuditLogsByEntityId,
	        getAuditLogsByUserId: getAuditLogsByUserId,
	        getAuditLogsByCustomerId: getAuditLogsByCustomerId,
	        getAuditLogs: getAuditLogs
	    };
	
	    return service;
	
	    function getAuditLogsByEntityId(entityType, entityId, pageLink) {
	        var deferred = $q.defer();
	        var url = '/api/audit/logs/entity/' + entityType + '/' + entityId + '?limit=' + pageLink.limit;
	
	        if (angular.isDefined(pageLink.startTime) && pageLink.startTime != null) {
	            url += '&startTime=' + pageLink.startTime;
	        }
	        if (angular.isDefined(pageLink.endTime) && pageLink.endTime != null) {
	            url += '&endTime=' + pageLink.endTime;
	        }
	        if (angular.isDefined(pageLink.idOffset) && pageLink.idOffset != null) {
	            url += '&offset=' + pageLink.idOffset;
	        }
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getAuditLogsByUserId(userId, pageLink) {
	        var deferred = $q.defer();
	        var url = '/api/audit/logs/user/' + userId + '?limit=' + pageLink.limit;
	
	        if (angular.isDefined(pageLink.startTime) && pageLink.startTime != null) {
	            url += '&startTime=' + pageLink.startTime;
	        }
	        if (angular.isDefined(pageLink.endTime) && pageLink.endTime != null) {
	            url += '&endTime=' + pageLink.endTime;
	        }
	        if (angular.isDefined(pageLink.idOffset) && pageLink.idOffset != null) {
	            url += '&offset=' + pageLink.idOffset;
	        }
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getAuditLogsByCustomerId(customerId, pageLink) {
	        var deferred = $q.defer();
	        var url = '/api/audit/logs/customer/' + customerId + '?limit=' + pageLink.limit;
	
	        if (angular.isDefined(pageLink.startTime) && pageLink.startTime != null) {
	            url += '&startTime=' + pageLink.startTime;
	        }
	        if (angular.isDefined(pageLink.endTime) && pageLink.endTime != null) {
	            url += '&endTime=' + pageLink.endTime;
	        }
	        if (angular.isDefined(pageLink.idOffset) && pageLink.idOffset != null) {
	            url += '&offset=' + pageLink.idOffset;
	        }
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getAuditLogs(pageLink) {
	        var deferred = $q.defer();
	        var url = '/api/audit/logs?limit=' + pageLink.limit;
	
	        if (angular.isDefined(pageLink.startTime) && pageLink.startTime != null) {
	            url += '&startTime=' + pageLink.startTime;
	        }
	        if (angular.isDefined(pageLink.endTime) && pageLink.endTime != null) {
	            url += '&endTime=' + pageLink.endTime;
	        }
	        if (angular.isDefined(pageLink.idOffset) && pageLink.idOffset != null) {
	            url += '&offset=' + pageLink.idOffset;
	        }
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	'use strict';
	
	ComponentDescriptorService.$inject = ["$http", "$q"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.componentDescriptor', []).factory('componentDescriptorService', ComponentDescriptorService).name;
	
	/*@ngInject*/
	
	function ComponentDescriptorService($http, $q) {
	
	    var componentsByType = {};
	    var componentsByClazz = {};
	    var actionsByPlugin = {};
	
	    var service = {
	        getComponentDescriptorsByType: getComponentDescriptorsByType,
	        getComponentDescriptorByClazz: getComponentDescriptorByClazz,
	        getPluginActionsByPluginClazz: getPluginActionsByPluginClazz,
	        getComponentDescriptorsByTypes: getComponentDescriptorsByTypes
	    };
	
	    return service;
	
	    function getComponentDescriptorsByType(componentType) {
	        var deferred = $q.defer();
	        if (componentsByType[componentType]) {
	            deferred.resolve(componentsByType[componentType]);
	        } else {
	            var url = '/api/components/' + componentType;
	            $http.get(url, null).then(function success(response) {
	                componentsByType[componentType] = response.data;
	                for (var i = 0; i < componentsByType[componentType].length; i++) {
	                    var component = componentsByType[componentType][i];
	                    componentsByClazz[component.clazz] = component;
	                }
	                deferred.resolve(componentsByType[componentType]);
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	
	    function getComponentDescriptorsByTypes(componentTypes) {
	        var deferred = $q.defer();
	        var result = [];
	        for (var i = componentTypes.length - 1; i >= 0; i--) {
	            var componentType = componentTypes[i];
	            if (componentsByType[componentType]) {
	                result = result.concat(componentsByType[componentType]);
	                componentTypes.splice(i, 1);
	            }
	        }
	        if (!componentTypes.length) {
	            deferred.resolve(result);
	        } else {
	            var url = '/api/components?componentTypes=' + componentTypes.join(',');
	            $http.get(url, null).then(function success(response) {
	                var components = response.data;
	                for (var i = 0; i < components.length; i++) {
	                    var component = components[i];
	                    var componentsList = componentsByType[component.type];
	                    if (!componentsList) {
	                        componentsList = [];
	                        componentsByType[component.type] = componentsList;
	                    }
	                    componentsList.push(component);
	                    componentsByClazz[component.clazz] = component;
	                }
	                result = result.concat(components);
	                deferred.resolve(components);
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	
	    function getComponentDescriptorByClazz(componentDescriptorClazz) {
	        var deferred = $q.defer();
	        if (componentsByClazz[componentDescriptorClazz]) {
	            deferred.resolve(componentsByClazz[componentDescriptorClazz]);
	        } else {
	            var url = '/api/component/' + componentDescriptorClazz;
	            $http.get(url, null).then(function success(response) {
	                componentsByClazz[componentDescriptorClazz] = response.data;
	                deferred.resolve(componentsByClazz[componentDescriptorClazz]);
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	
	    function getPluginActionsByPluginClazz(pluginClazz) {
	        var deferred = $q.defer();
	        if (actionsByPlugin[pluginClazz]) {
	            deferred.resolve(actionsByPlugin[pluginClazz]);
	        } else {
	            var url = '/api/components/actions/' + pluginClazz;
	            $http.get(url, null).then(function success(response) {
	                actionsByPlugin[pluginClazz] = response.data;
	                deferred.resolve(actionsByPlugin[pluginClazz]);
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	}

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DataAggregator = function () {
	    function DataAggregator(onDataCb, tsKeyNames, startTs, limit, aggregationType, timeWindow, interval, stateData, types, $timeout, $filter) {
	        _classCallCheck(this, DataAggregator);
	
	        this.onDataCb = onDataCb;
	        this.tsKeyNames = tsKeyNames;
	        this.dataBuffer = {};
	        for (var k = 0; k < tsKeyNames.length; k++) {
	            this.dataBuffer[tsKeyNames[k]] = [];
	        }
	        this.startTs = startTs;
	        this.aggregationType = aggregationType;
	        this.types = types;
	        this.$timeout = $timeout;
	        this.$filter = $filter;
	        this.dataReceived = false;
	        this.resetPending = false;
	        this.noAggregation = aggregationType === types.aggregation.none.value;
	        this.limit = limit;
	        this.timeWindow = timeWindow;
	        this.interval = interval;
	        this.stateData = stateData;
	        if (this.stateData) {
	            this.lastPrevKvPairData = {};
	        }
	        this.aggregationTimeout = Math.max(this.interval, 1000);
	        switch (aggregationType) {
	            case types.aggregation.min.value:
	                this.aggFunction = min;
	                break;
	            case types.aggregation.max.value:
	                this.aggFunction = max;
	                break;
	            case types.aggregation.avg.value:
	                this.aggFunction = avg;
	                break;
	            case types.aggregation.sum.value:
	                this.aggFunction = sum;
	                break;
	            case types.aggregation.count.value:
	                this.aggFunction = count;
	                break;
	            case types.aggregation.none.value:
	                this.aggFunction = none;
	                break;
	            default:
	                this.aggFunction = avg;
	        }
	    }
	
	    _createClass(DataAggregator, [{
	        key: 'reset',
	        value: function reset(startTs, timeWindow, interval) {
	            if (this.intervalTimeoutHandle) {
	                this.$timeout.cancel(this.intervalTimeoutHandle);
	                this.intervalTimeoutHandle = null;
	            }
	            this.intervalScheduledTime = currentTime();
	            this.startTs = startTs;
	            this.timeWindow = timeWindow;
	            this.interval = interval;
	            this.endTs = this.startTs + this.timeWindow;
	            this.elapsed = 0;
	            this.aggregationTimeout = Math.max(this.interval, 1000);
	            this.resetPending = true;
	            var self = this;
	            this.intervalTimeoutHandle = this.$timeout(function () {
	                self.onInterval();
	            }, this.aggregationTimeout, false);
	        }
	    }, {
	        key: 'onData',
	        value: function onData(data, update, history, apply) {
	            if (!this.dataReceived || this.resetPending) {
	                var updateIntervalScheduledTime = true;
	                if (!this.dataReceived) {
	                    this.elapsed = 0;
	                    this.dataReceived = true;
	                    this.endTs = this.startTs + this.timeWindow;
	                }
	                if (this.resetPending) {
	                    this.resetPending = false;
	                    updateIntervalScheduledTime = false;
	                }
	                if (update) {
	                    this.aggregationMap = {};
	                    updateAggregatedData(this.aggregationMap, this.aggregationType === this.types.aggregation.count.value, this.noAggregation, this.aggFunction, data.data, this.interval, this.startTs);
	                } else {
	                    this.aggregationMap = processAggregatedData(data.data, this.aggregationType === this.types.aggregation.count.value, this.noAggregation);
	                }
	                if (updateIntervalScheduledTime) {
	                    this.intervalScheduledTime = currentTime();
	                }
	                this.onInterval(history, apply);
	            } else {
	                updateAggregatedData(this.aggregationMap, this.aggregationType === this.types.aggregation.count.value, this.noAggregation, this.aggFunction, data.data, this.interval, this.startTs);
	                if (history) {
	                    this.intervalScheduledTime = currentTime();
	                    this.onInterval(history, apply);
	                }
	            }
	        }
	    }, {
	        key: 'onInterval',
	        value: function onInterval(history, apply) {
	            var now = currentTime();
	            this.elapsed += now - this.intervalScheduledTime;
	            this.intervalScheduledTime = now;
	            if (this.intervalTimeoutHandle) {
	                this.$timeout.cancel(this.intervalTimeoutHandle);
	                this.intervalTimeoutHandle = null;
	            }
	            if (!history) {
	                var delta = Math.floor(this.elapsed / this.interval);
	                if (delta || !this.data) {
	                    this.startTs += delta * this.interval;
	                    this.endTs += delta * this.interval;
	                    this.data = this.updateData();
	                    this.elapsed = this.elapsed - delta * this.interval;
	                }
	            } else {
	                this.data = this.updateData();
	            }
	            if (this.onDataCb) {
	                this.onDataCb(this.data, apply);
	            }
	
	            var self = this;
	            if (!history) {
	                this.intervalTimeoutHandle = this.$timeout(function () {
	                    self.onInterval();
	                }, this.aggregationTimeout, false);
	            }
	        }
	    }, {
	        key: 'updateData',
	        value: function updateData() {
	            for (var k = 0; k < this.tsKeyNames.length; k++) {
	                this.dataBuffer[this.tsKeyNames[k]] = [];
	            }
	            for (var key in this.aggregationMap) {
	                var aggKeyData = this.aggregationMap[key];
	                var keyData = this.dataBuffer[key];
	                for (var aggTimestamp in aggKeyData) {
	                    if (aggTimestamp <= this.startTs) {
	                        if (this.stateData && (!this.lastPrevKvPairData[key] || this.lastPrevKvPairData[key][0] < aggTimestamp)) {
	                            this.lastPrevKvPairData[key] = [Number(aggTimestamp), aggKeyData[aggTimestamp].aggValue];
	                        }
	                        delete aggKeyData[aggTimestamp];
	                    } else if (aggTimestamp <= this.endTs) {
	                        var aggData = aggKeyData[aggTimestamp];
	                        var kvPair = [Number(aggTimestamp), aggData.aggValue];
	                        keyData.push(kvPair);
	                    }
	                }
	                keyData = this.$filter('orderBy')(keyData, '+this[0]');
	                if (this.stateData) {
	                    this.updateStateBounds(keyData, angular.copy(this.lastPrevKvPairData[key]));
	                }
	                if (keyData.length > this.limit) {
	                    keyData = keyData.slice(keyData.length - this.limit);
	                }
	                this.dataBuffer[key] = keyData;
	            }
	            return this.dataBuffer;
	        }
	    }, {
	        key: 'updateStateBounds',
	        value: function updateStateBounds(keyData, lastPrevKvPair) {
	            if (lastPrevKvPair) {
	                lastPrevKvPair[0] = this.startTs;
	            }
	            var firstKvPair;
	            if (!keyData.length) {
	                if (lastPrevKvPair) {
	                    firstKvPair = lastPrevKvPair;
	                    keyData.push(firstKvPair);
	                }
	            } else {
	                firstKvPair = keyData[0];
	            }
	            if (firstKvPair && firstKvPair[0] > this.startTs) {
	                if (lastPrevKvPair) {
	                    keyData.unshift(lastPrevKvPair);
	                }
	            }
	            if (keyData.length) {
	                var lastKvPair = keyData[keyData.length - 1];
	                if (lastKvPair[0] < this.endTs) {
	                    lastKvPair = angular.copy(lastKvPair);
	                    lastKvPair[0] = this.endTs;
	                    keyData.push(lastKvPair);
	                }
	            }
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            if (this.intervalTimeoutHandle) {
	                this.$timeout.cancel(this.intervalTimeoutHandle);
	                this.intervalTimeoutHandle = null;
	            }
	            this.aggregationMap = null;
	        }
	    }]);
	
	    return DataAggregator;
	}();
	
	/* eslint-disable */
	
	
	exports.default = DataAggregator;
	function currentTime() {
	    return window.performance && window.performance.now ? window.performance.now() : Date.now();
	}
	/* eslint-enable */
	
	function processAggregatedData(data, isCount, noAggregation) {
	    var aggregationMap = {};
	    for (var key in data) {
	        var aggKeyData = aggregationMap[key];
	        if (!aggKeyData) {
	            aggKeyData = {};
	            aggregationMap[key] = aggKeyData;
	        }
	        var keyData = data[key];
	        for (var i = 0; i < keyData.length; i++) {
	            var kvPair = keyData[i];
	            var timestamp = kvPair[0];
	            var value = convertValue(kvPair[1], noAggregation);
	            var aggKey = timestamp;
	            var aggData = {
	                count: isCount ? value : 1,
	                sum: value,
	                aggValue: value
	            };
	            aggKeyData[aggKey] = aggData;
	        }
	    }
	    return aggregationMap;
	}
	
	function updateAggregatedData(aggregationMap, isCount, noAggregation, aggFunction, data, interval, startTs) {
	    for (var key in data) {
	        var aggKeyData = aggregationMap[key];
	        if (!aggKeyData) {
	            aggKeyData = {};
	            aggregationMap[key] = aggKeyData;
	        }
	        var keyData = data[key];
	        for (var i = 0; i < keyData.length; i++) {
	            var kvPair = keyData[i];
	            var timestamp = kvPair[0];
	            var value = convertValue(kvPair[1], noAggregation);
	            var aggTimestamp = noAggregation ? timestamp : startTs + Math.floor((timestamp - startTs) / interval) * interval + interval / 2;
	            var aggData = aggKeyData[aggTimestamp];
	            if (!aggData) {
	                aggData = {
	                    count: 1,
	                    sum: value,
	                    aggValue: isCount ? 1 : value
	                };
	                aggKeyData[aggTimestamp] = aggData;
	            } else {
	                aggFunction(aggData, value);
	            }
	        }
	    }
	}
	
	function convertValue(value, noAggregation) {
	    if (!noAggregation || value && isNumeric(value)) {
	        return Number(value);
	    } else {
	        return value;
	    }
	}
	
	function isNumeric(value) {
	    return value - parseFloat(value) + 1 >= 0;
	}
	
	function avg(aggData, value) {
	    aggData.count++;
	    aggData.sum += value;
	    aggData.aggValue = aggData.sum / aggData.count;
	}
	
	function min(aggData, value) {
	    aggData.aggValue = Math.min(aggData.aggValue, value);
	}
	
	function max(aggData, value) {
	    aggData.aggValue = Math.max(aggData.aggValue, value);
	}
	
	function sum(aggData, value) {
	    aggData.aggValue = aggData.aggValue + value;
	}
	
	function count(aggData) {
	    aggData.count++;
	    aggData.aggValue = aggData.count;
	}
	
	function none(aggData, value) {
	    aggData.aggValue = value;
	}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DatasourceService.$inject = ["$timeout", "$filter", "$log", "telemetryWebsocketService", "types", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _device = __webpack_require__(146);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _telemetryWebsocket = __webpack_require__(1147);
	
	var _telemetryWebsocket2 = _interopRequireDefault(_telemetryWebsocket);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _utils = __webpack_require__(90);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _dataAggregator = __webpack_require__(1140);
	
	var _dataAggregator2 = _interopRequireDefault(_dataAggregator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.api.datasource', [_device2.default, _telemetryWebsocket2.default, _types2.default, _utils2.default]).factory('datasourceService', DatasourceService).name; /*
	                                                                                                                                                                                                          * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                          *
	                                                                                                                                                                                                          * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                          * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                          * You may obtain a copy of the License at
	                                                                                                                                                                                                          *
	                                                                                                                                                                                                          *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                          *
	                                                                                                                                                                                                          * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                          * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                          * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                          * See the License for the specific language governing permissions and
	                                                                                                                                                                                                          * limitations under the License.
	                                                                                                                                                                                                          */
	
	var YEAR = 1000 * 60 * 60 * 24 * 365;
	
	/*@ngInject*/
	function DatasourceService($timeout, $filter, $log, telemetryWebsocketService, types, utils) {
	
	    var subscriptions = {};
	
	    var service = {
	        subscribeToDatasource: subscribeToDatasource,
	        unsubscribeFromDatasource: unsubscribeFromDatasource
	    };
	
	    return service;
	
	    function subscribeToDatasource(listener) {
	        var datasource = listener.datasource;
	
	        if (datasource.type === types.datasourceType.entity && (!listener.entityId || !listener.entityType)) {
	            return;
	        }
	
	        var subscriptionDataKeys = [];
	        for (var d = 0; d < datasource.dataKeys.length; d++) {
	            var dataKey = datasource.dataKeys[d];
	            var subscriptionDataKey = {
	                name: dataKey.name,
	                type: dataKey.type,
	                funcBody: dataKey.funcBody,
	                postFuncBody: dataKey.postFuncBody
	            };
	            subscriptionDataKeys.push(subscriptionDataKey);
	        }
	
	        var datasourceSubscription = {
	            datasourceType: datasource.type,
	            dataKeys: subscriptionDataKeys,
	            type: listener.subscriptionType
	        };
	
	        if (listener.subscriptionType === types.widgetType.timeseries.value) {
	            datasourceSubscription.subscriptionTimewindow = angular.copy(listener.subscriptionTimewindow);
	        }
	        if (datasourceSubscription.datasourceType === types.datasourceType.entity) {
	            datasourceSubscription.entityType = listener.entityType;
	            datasourceSubscription.entityId = listener.entityId;
	        }
	
	        listener.datasourceSubscriptionKey = utils.objectHashCode(datasourceSubscription);
	        var subscription;
	        if (subscriptions[listener.datasourceSubscriptionKey]) {
	            subscription = subscriptions[listener.datasourceSubscriptionKey];
	            subscription.syncListener(listener);
	        } else {
	            subscription = new DatasourceSubscription(datasourceSubscription, telemetryWebsocketService, $timeout, $filter, $log, types, utils);
	            subscriptions[listener.datasourceSubscriptionKey] = subscription;
	            subscription.start();
	        }
	        subscription.addListener(listener);
	    }
	
	    function unsubscribeFromDatasource(listener) {
	        if (listener.datasourceSubscriptionKey) {
	            if (subscriptions[listener.datasourceSubscriptionKey]) {
	                var subscription = subscriptions[listener.datasourceSubscriptionKey];
	                subscription.removeListener(listener);
	                if (!subscription.hasListeners()) {
	                    subscription.unsubscribe();
	                    delete subscriptions[listener.datasourceSubscriptionKey];
	                }
	            }
	            listener.datasourceSubscriptionKey = null;
	        }
	    }
	}
	
	function DatasourceSubscription(datasourceSubscription, telemetryWebsocketService, $timeout, $filter, $log, types, utils) {
	
	    var listeners = [];
	    var datasourceType = datasourceSubscription.datasourceType;
	    var datasourceData = {};
	    var dataKeys = {};
	    var subscribers = [];
	    var history = datasourceSubscription.subscriptionTimewindow && datasourceSubscription.subscriptionTimewindow.fixedWindow;
	    var realtime = datasourceSubscription.subscriptionTimewindow && datasourceSubscription.subscriptionTimewindow.realtimeWindowMs;
	    var timer;
	    var frequency;
	    var tickElapsed = 0;
	    var tickScheduledTime = 0;
	    var dataAggregator;
	
	    var subscription = {
	        addListener: addListener,
	        hasListeners: hasListeners,
	        removeListener: removeListener,
	        syncListener: syncListener,
	        start: start,
	        unsubscribe: unsubscribe
	    };
	
	    initializeSubscription();
	
	    return subscription;
	
	    function initializeSubscription() {
	        for (var i = 0; i < datasourceSubscription.dataKeys.length; i++) {
	            var dataKey = angular.copy(datasourceSubscription.dataKeys[i]);
	            dataKey.index = i;
	            var key;
	            if (datasourceType === types.datasourceType.function) {
	                if (!dataKey.func) {
	                    dataKey.func = new Function("time", "prevValue", dataKey.funcBody);
	                }
	            } else {
	                if (dataKey.postFuncBody && !dataKey.postFunc) {
	                    dataKey.postFunc = new Function("time", "value", "prevValue", dataKey.postFuncBody);
	                }
	            }
	            if (datasourceType === types.datasourceType.entity || datasourceSubscription.type === types.widgetType.timeseries.value) {
	                if (datasourceType === types.datasourceType.function) {
	                    key = dataKey.name + '_' + dataKey.index + '_' + dataKey.type;
	                } else {
	                    key = dataKey.name + '_' + dataKey.type;
	                }
	                var dataKeysList = dataKeys[key];
	                if (!dataKeysList) {
	                    dataKeysList = [];
	                    dataKeys[key] = dataKeysList;
	                }
	                var index = dataKeysList.push(dataKey) - 1;
	                datasourceData[key + '_' + index] = {
	                    data: []
	                };
	            } else {
	                key = utils.objectHashCode(dataKey);
	                datasourceData[key] = {
	                    data: []
	                };
	                dataKeys[key] = dataKey;
	            }
	            dataKey.key = key;
	        }
	        if (datasourceType === types.datasourceType.function) {
	            frequency = 1000;
	            if (datasourceSubscription.type === types.widgetType.timeseries.value) {
	                frequency = Math.min(datasourceSubscription.subscriptionTimewindow.aggregation.interval, 5000);
	            }
	        }
	    }
	
	    function addListener(listener) {
	        listeners.push(listener);
	        if (history) {
	            start();
	        }
	    }
	
	    function hasListeners() {
	        return listeners.length > 0;
	    }
	
	    function removeListener(listener) {
	        listeners.splice(listeners.indexOf(listener), 1);
	    }
	
	    function syncListener(listener) {
	        var key;
	        var dataKey;
	        if (datasourceType === types.datasourceType.entity || datasourceSubscription.type === types.widgetType.timeseries.value) {
	            for (key in dataKeys) {
	                var dataKeysList = dataKeys[key];
	                for (var i = 0; i < dataKeysList.length; i++) {
	                    dataKey = dataKeysList[i];
	                    var datasourceKey = key + '_' + i;
	                    listener.dataUpdated(datasourceData[datasourceKey], listener.datasourceIndex, dataKey.index, false);
	                }
	            }
	        } else {
	            for (key in dataKeys) {
	                dataKey = dataKeys[key];
	                listener.dataUpdated(datasourceData[key], listener.datasourceIndex, dataKey.index, false);
	            }
	        }
	    }
	
	    function start() {
	        if (history && !hasListeners()) {
	            return;
	        }
	        var subsTw = datasourceSubscription.subscriptionTimewindow;
	        var tsKeyNames = [];
	        var dataKey;
	
	        if (datasourceType === types.datasourceType.entity) {
	
	            //send subscribe command
	
	            var tsKeys = '';
	            var attrKeys = '';
	
	            for (var key in dataKeys) {
	                var dataKeysList = dataKeys[key];
	                dataKey = dataKeysList[0];
	                if (dataKey.type === types.dataKeyType.timeseries) {
	                    if (tsKeys.length > 0) {
	                        tsKeys += ',';
	                    }
	                    tsKeys += dataKey.name;
	                    tsKeyNames.push(dataKey.name);
	                } else if (dataKey.type === types.dataKeyType.attribute) {
	                    if (attrKeys.length > 0) {
	                        attrKeys += ',';
	                    }
	                    attrKeys += dataKey.name;
	                }
	            }
	
	            if (tsKeys.length > 0) {
	
	                var subscriber;
	
	                if (history) {
	
	                    var historyCommand = {
	                        entityType: datasourceSubscription.entityType,
	                        entityId: datasourceSubscription.entityId,
	                        keys: tsKeys,
	                        startTs: subsTw.fixedWindow.startTimeMs,
	                        endTs: subsTw.fixedWindow.endTimeMs,
	                        interval: subsTw.aggregation.interval,
	                        limit: subsTw.aggregation.limit,
	                        agg: subsTw.aggregation.type
	                    };
	
	                    subscriber = {
	                        historyCommands: [historyCommand],
	                        type: types.dataKeyType.timeseries,
	                        subsTw: subsTw
	                    };
	
	                    if (subsTw.aggregation.stateData) {
	                        subscriber.firstStateHistoryCommand = createFirstStateHistoryCommand(subsTw.fixedWindow.startTimeMs, tsKeys);
	                        subscriber.historyCommands.push(subscriber.firstStateHistoryCommand);
	                    }
	
	                    subscriber.onData = function (data, subscriptionId) {
	                        if (this.subsTw.aggregation.stateData && this.firstStateHistoryCommand && this.firstStateHistoryCommand.cmdId == subscriptionId) {
	                            if (this.data) {
	                                onStateHistoryData(data, this.data, this.subsTw.aggregation.limit, subsTw.fixedWindow.startTimeMs, this.subsTw.fixedWindow.endTimeMs, function (data) {
	                                    _onData(data.data, types.dataKeyType.timeseries, true);
	                                });
	                            } else {
	                                this.firstStateData = data;
	                            }
	                        } else {
	                            if (this.subsTw.aggregation.stateData) {
	                                if (this.firstStateData) {
	                                    onStateHistoryData(this.firstStateData, data, this.subsTw.aggregation.limit, this.subsTw.fixedWindow.startTimeMs, this.subsTw.fixedWindow.endTimeMs, function (data) {
	                                        _onData(data.data, types.dataKeyType.timeseries, true);
	                                    });
	                                } else {
	                                    this.data = data;
	                                }
	                            } else {
	                                for (key in data.data) {
	                                    var keyData = data.data[key];
	                                    data.data[key] = $filter('orderBy')(keyData, '+this[0]');
	                                }
	                                _onData(data.data, types.dataKeyType.timeseries, true);
	                            }
	                        }
	                    };
	                    subscriber.onReconnected = function () {};
	                    telemetryWebsocketService.subscribe(subscriber);
	                    subscribers.push(subscriber);
	                } else {
	
	                    var subscriptionCommand = {
	                        entityType: datasourceSubscription.entityType,
	                        entityId: datasourceSubscription.entityId,
	                        keys: tsKeys
	                    };
	
	                    subscriber = {
	                        subscriptionCommands: [subscriptionCommand],
	                        type: types.dataKeyType.timeseries
	                    };
	
	                    if (datasourceSubscription.type === types.widgetType.timeseries.value) {
	                        subscriber.subsTw = subsTw;
	                        updateRealtimeSubscriptionCommand(subscriptionCommand, subsTw);
	
	                        if (subsTw.aggregation.stateData) {
	                            subscriber.firstStateSubscriptionCommand = createFirstStateHistoryCommand(subsTw.startTs, tsKeys);
	                            subscriber.historyCommands = [subscriber.firstStateSubscriptionCommand];
	                        }
	                        dataAggregator = createRealtimeDataAggregator(subsTw, tsKeyNames, types.dataKeyType.timeseries);
	                        subscriber.onData = function (data, subscriptionId) {
	                            if (this.subsTw.aggregation.stateData && this.firstStateSubscriptionCommand && this.firstStateSubscriptionCommand.cmdId == subscriptionId) {
	                                if (this.data) {
	                                    onStateHistoryData(data, this.data, this.subsTw.aggregation.limit, this.subsTw.startTs, this.subsTw.startTs + this.subsTw.aggregation.timeWindow, function (data) {
	                                        dataAggregator.onData(data, false, false, true);
	                                    });
	                                    this.stateDataReceived = true;
	                                } else {
	                                    this.firstStateData = data;
	                                }
	                            } else {
	                                if (this.subsTw.aggregation.stateData && !this.stateDataReceived) {
	                                    if (this.firstStateData) {
	                                        onStateHistoryData(this.firstStateData, data, this.subsTw.aggregation.limit, this.subsTw.startTs, this.subsTw.startTs + this.subsTw.aggregation.timeWindow, function (data) {
	                                            dataAggregator.onData(data, false, false, true);
	                                        });
	                                        this.stateDataReceived = true;
	                                    } else {
	                                        this.data = data;
	                                    }
	                                } else {
	                                    dataAggregator.onData(data, false, false, true);
	                                }
	                            }
	                        };
	                        subscriber.onReconnected = function () {
	                            var newSubsTw = null;
	                            for (var i2 = 0; i2 < listeners.length; i2++) {
	                                var listener = listeners[i2];
	                                if (!newSubsTw) {
	                                    newSubsTw = listener.updateRealtimeSubscription();
	                                } else {
	                                    listener.setRealtimeSubscription(newSubsTw);
	                                }
	                            }
	                            this.subsTw = newSubsTw;
	                            this.firstStateData = null;
	                            this.data = null;
	                            this.stateDataReceived = false;
	                            updateRealtimeSubscriptionCommand(this.subscriptionCommands[0], this.subsTw);
	                            if (this.subsTw.aggregation.stateData) {
	                                updateFirstStateHistoryCommand(this.firstStateSubscriptionCommand, this.subsTw.startTs);
	                            }
	                            dataAggregator.reset(newSubsTw.startTs, newSubsTw.aggregation.timeWindow, newSubsTw.aggregation.interval);
	                        };
	                    } else {
	                        subscriber.onReconnected = function () {};
	                        subscriber.onData = function (data) {
	                            if (data.data) {
	                                _onData(data.data, types.dataKeyType.timeseries, true);
	                            }
	                        };
	                    }
	
	                    telemetryWebsocketService.subscribe(subscriber);
	                    subscribers.push(subscriber);
	                }
	            }
	
	            if (attrKeys.length > 0) {
	
	                var attrsSubscriptionCommand = {
	                    entityType: datasourceSubscription.entityType,
	                    entityId: datasourceSubscription.entityId,
	                    keys: attrKeys
	                };
	
	                subscriber = {
	                    subscriptionCommands: [attrsSubscriptionCommand],
	                    type: types.dataKeyType.attribute,
	                    onData: function onData(data) {
	                        if (data.data) {
	                            _onData(data.data, types.dataKeyType.attribute, true);
	                        }
	                    },
	                    onReconnected: function onReconnected() {}
	                };
	
	                telemetryWebsocketService.subscribe(subscriber);
	                subscribers.push(subscriber);
	            }
	        } else if (datasourceType === types.datasourceType.function) {
	            if (datasourceSubscription.type === types.widgetType.timeseries.value) {
	                for (key in dataKeys) {
	                    var dataKeyList = dataKeys[key];
	                    for (var index = 0; index < dataKeyList.length; index++) {
	                        dataKey = dataKeyList[index];
	                        tsKeyNames.push(dataKey.name + '_' + dataKey.index);
	                    }
	                }
	                dataAggregator = createRealtimeDataAggregator(subsTw, tsKeyNames, types.dataKeyType.function);
	            }
	            tickScheduledTime = currentTime();
	            if (history) {
	                onTick(false);
	            } else {
	                timer = $timeout(function () {
	                    onTick(true);
	                }, 0, false);
	            }
	        }
	    }
	
	    function createFirstStateHistoryCommand(startTs, tsKeys) {
	        return {
	            entityType: datasourceSubscription.entityType,
	            entityId: datasourceSubscription.entityId,
	            keys: tsKeys,
	            startTs: startTs - YEAR,
	            endTs: startTs,
	            interval: 1000,
	            limit: 1,
	            agg: types.aggregation.none.value
	        };
	    }
	
	    function updateFirstStateHistoryCommand(stateHistoryCommand, startTs) {
	        stateHistoryCommand.startTs = startTs - YEAR;
	        stateHistoryCommand.endTs = startTs;
	    }
	
	    function onStateHistoryData(firstStateData, data, limit, startTs, endTs, onData) {
	        for (var key in data.data) {
	            var keyData = data.data[key];
	            data.data[key] = $filter('orderBy')(keyData, '+this[0]');
	            keyData = data.data[key];
	            if (keyData.length < limit) {
	                var firstStateKeyData = firstStateData.data[key];
	                if (firstStateKeyData.length) {
	                    var firstStateDataTsKv = firstStateKeyData[0];
	                    firstStateDataTsKv[0] = startTs;
	                    firstStateKeyData = [[startTs, firstStateKeyData[0][1]]];
	                    keyData.unshift(firstStateDataTsKv);
	                }
	            }
	            if (keyData.length) {
	                var lastTsKv = angular.copy(keyData[keyData.length - 1]);
	                lastTsKv[0] = endTs;
	                keyData.push(lastTsKv);
	            }
	        }
	        onData(data);
	    }
	
	    function createRealtimeDataAggregator(subsTw, tsKeyNames, dataKeyType) {
	        return new _dataAggregator2.default(function (data, apply) {
	            _onData(data, dataKeyType, apply);
	        }, tsKeyNames, subsTw.startTs, subsTw.aggregation.limit, subsTw.aggregation.type, subsTw.aggregation.timeWindow, subsTw.aggregation.interval, subsTw.aggregation.stateData, types, $timeout, $filter);
	    }
	
	    function updateRealtimeSubscriptionCommand(subscriptionCommand, subsTw) {
	        subscriptionCommand.startTs = subsTw.startTs;
	        subscriptionCommand.timeWindow = subsTw.aggregation.timeWindow;
	        subscriptionCommand.interval = subsTw.aggregation.interval;
	        subscriptionCommand.limit = subsTw.aggregation.limit;
	        subscriptionCommand.agg = subsTw.aggregation.type;
	    }
	
	    function unsubscribe() {
	        if (timer) {
	            $timeout.cancel(timer);
	            timer = null;
	        }
	        if (datasourceType === types.datasourceType.entity) {
	            for (var i = 0; i < subscribers.length; i++) {
	                var subscriber = subscribers[i];
	                telemetryWebsocketService.unsubscribe(subscriber);
	                if (subscriber.onDestroy) {
	                    subscriber.onDestroy();
	                }
	            }
	            subscribers.length = 0;
	        }
	        if (dataAggregator) {
	            dataAggregator.destroy();
	            dataAggregator = null;
	        }
	    }
	
	    function generateSeries(dataKey, index, startTime, endTime) {
	        var data = [];
	        var prevSeries;
	        var datasourceDataKey = dataKey.key + '_' + index;
	        var datasourceKeyData = datasourceData[datasourceDataKey].data;
	        if (datasourceKeyData.length > 0) {
	            prevSeries = datasourceKeyData[datasourceKeyData.length - 1];
	        } else {
	            prevSeries = [0, 0];
	        }
	        for (var time = startTime; time <= endTime && (timer || history); time += frequency) {
	            var series = [];
	            series.push(time);
	            var value = dataKey.func(time, prevSeries[1]);
	            series.push(value);
	            data.push(series);
	            prevSeries = series;
	        }
	        if (data.length > 0) {
	            dataKey.lastUpdateTime = data[data.length - 1][0];
	        }
	        return data;
	    }
	
	    function generateLatest(dataKey, apply) {
	        var prevSeries;
	        var datasourceKeyData = datasourceData[dataKey.key].data;
	        if (datasourceKeyData.length > 0) {
	            prevSeries = datasourceKeyData[datasourceKeyData.length - 1];
	        } else {
	            prevSeries = [0, 0];
	        }
	        var series = [];
	        var time = new Date().getTime();
	        series.push(time);
	        var value = dataKey.func(time, prevSeries[1]);
	        series.push(value);
	        datasourceData[dataKey.key].data = [series];
	        for (var i = 0; i < listeners.length; i++) {
	            var listener = listeners[i];
	            listener.dataUpdated(datasourceData[dataKey.key], listener.datasourceIndex, dataKey.index, apply);
	        }
	    }
	
	    /* eslint-disable */
	    function currentTime() {
	        return window.performance && window.performance.now ? window.performance.now() : Date.now();
	    }
	    /* eslint-enable */
	
	    function onTick(apply) {
	
	        var now = currentTime();
	        tickElapsed += now - tickScheduledTime;
	        tickScheduledTime = now;
	
	        if (timer) {
	            $timeout.cancel(timer);
	        }
	
	        var key;
	        if (datasourceSubscription.type === types.widgetType.timeseries.value) {
	            var startTime;
	            var endTime;
	            var delta;
	            var generatedData = {
	                data: {}
	            };
	            if (!history) {
	                delta = Math.floor(tickElapsed / frequency);
	            }
	            var deltaElapsed = history ? frequency : delta * frequency;
	            tickElapsed = tickElapsed - deltaElapsed;
	            for (key in dataKeys) {
	                var dataKeyList = dataKeys[key];
	                for (var index = 0; index < dataKeyList.length && (timer || history); index++) {
	                    var dataKey = dataKeyList[index];
	                    if (!startTime) {
	                        if (realtime) {
	                            if (dataKey.lastUpdateTime) {
	                                startTime = dataKey.lastUpdateTime + frequency;
	                                endTime = dataKey.lastUpdateTime + deltaElapsed;
	                            } else {
	                                startTime = datasourceSubscription.subscriptionTimewindow.startTs;
	                                endTime = startTime + datasourceSubscription.subscriptionTimewindow.realtimeWindowMs + frequency;
	                                if (datasourceSubscription.subscriptionTimewindow.aggregation.type == types.aggregation.none.value) {
	                                    var time = endTime - frequency * datasourceSubscription.subscriptionTimewindow.aggregation.limit;
	                                    startTime = Math.max(time, startTime);
	                                }
	                            }
	                        } else {
	                            startTime = datasourceSubscription.subscriptionTimewindow.fixedWindow.startTimeMs;
	                            endTime = datasourceSubscription.subscriptionTimewindow.fixedWindow.endTimeMs;
	                        }
	                    }
	                    var data = generateSeries(dataKey, index, startTime, endTime);
	                    generatedData.data[dataKey.name + '_' + dataKey.index] = data;
	                }
	            }
	            if (dataAggregator) {
	                dataAggregator.onData(generatedData, true, history, apply);
	            }
	        } else if (datasourceSubscription.type === types.widgetType.latest.value) {
	            for (key in dataKeys) {
	                generateLatest(dataKeys[key], apply);
	            }
	        }
	
	        if (!history) {
	            timer = $timeout(function () {
	                onTick(true);
	            }, frequency, false);
	        }
	    }
	
	    function isNumeric(val) {
	        return val - parseFloat(val) + 1 >= 0;
	    }
	
	    function convertValue(val) {
	        if (val && isNumeric(val)) {
	            return Number(val);
	        } else {
	            return val;
	        }
	    }
	
	    function _onData(sourceData, type, apply) {
	        for (var keyName in sourceData) {
	            var keyData = sourceData[keyName];
	            var key = keyName + '_' + type;
	            var dataKeyList = dataKeys[key];
	            for (var keyIndex = 0; dataKeyList && keyIndex < dataKeyList.length; keyIndex++) {
	                var datasourceKey = key + "_" + keyIndex;
	                if (datasourceData[datasourceKey].data) {
	                    var dataKey = dataKeyList[keyIndex];
	                    var data = [];
	                    var prevSeries;
	                    var datasourceKeyData;
	                    var update = false;
	                    if (realtime) {
	                        datasourceKeyData = [];
	                    } else {
	                        datasourceKeyData = datasourceData[datasourceKey].data;
	                    }
	                    if (datasourceKeyData.length > 0) {
	                        prevSeries = datasourceKeyData[datasourceKeyData.length - 1];
	                    } else {
	                        prevSeries = [0, 0];
	                    }
	                    if (datasourceSubscription.type === types.widgetType.timeseries.value) {
	                        var series, time, value;
	                        for (var i = 0; i < keyData.length; i++) {
	                            series = keyData[i];
	                            time = series[0];
	                            value = convertValue(series[1]);
	                            if (dataKey.postFunc) {
	                                value = dataKey.postFunc(time, value, prevSeries[1]);
	                            }
	                            series = [time, value];
	                            data.push(series);
	                            prevSeries = series;
	                        }
	                        update = true;
	                    } else if (datasourceSubscription.type === types.widgetType.latest.value) {
	                        if (keyData.length > 0) {
	                            series = keyData[0];
	                            time = series[0];
	                            value = convertValue(series[1]);
	                            if (dataKey.postFunc) {
	                                value = dataKey.postFunc(time, value, prevSeries[1]);
	                            }
	                            series = [time, value];
	                            data.push(series);
	                        }
	                        update = true;
	                    }
	                    if (update) {
	                        datasourceData[datasourceKey].data = data;
	                        for (var i2 = 0; i2 < listeners.length; i2++) {
	                            var listener = listeners[i2];
	                            if (angular.isFunction(listener)) continue;
	                            listener.dataUpdated(datasourceData[datasourceKey], listener.datasourceIndex, dataKey.index, apply);
	                        }
	                    }
	                }
	            }
	        }
	    }
	}

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

	'use strict';
	
	EntityRelationService.$inject = ["$http", "$q"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.entityRelation', []).factory('entityRelationService', EntityRelationService).name;
	
	/*@ngInject*/
	
	function EntityRelationService($http, $q) {
	
	    var service = {
	        saveRelation: saveRelation,
	        deleteRelation: deleteRelation,
	        deleteRelations: deleteRelations,
	        getRelation: getRelation,
	        findByFrom: findByFrom,
	        findInfoByFrom: findInfoByFrom,
	        findByFromAndType: findByFromAndType,
	        findByTo: findByTo,
	        findInfoByTo: findInfoByTo,
	        findByToAndType: findByToAndType,
	        findByQuery: findByQuery,
	        findInfoByQuery: findInfoByQuery
	    };
	
	    return service;
	
	    function saveRelation(relation) {
	        var deferred = $q.defer();
	        var url = '/api/relation';
	        $http.post(url, relation).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteRelation(fromId, fromType, relationType, toId, toType) {
	        var deferred = $q.defer();
	        var url = '/api/relation?fromId=' + fromId;
	        url += '&fromType=' + fromType;
	        url += '&relationType=' + relationType;
	        url += '&toId=' + toId;
	        url += '&toType=' + toType;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteRelations(entityId, entityType) {
	        var deferred = $q.defer();
	        var url = '/api/relations?entityId=' + entityId;
	        url += '&entityType=' + entityType;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getRelation(fromId, fromType, relationType, toId, toType) {
	        var deferred = $q.defer();
	        var url = '/api/relation?fromId=' + fromId;
	        url += '&fromType=' + fromType;
	        url += '&relationType=' + relationType;
	        url += '&toId=' + toId;
	        url += '&toType=' + toType;
	        $http.get(url).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function findByFrom(fromId, fromType) {
	        var deferred = $q.defer();
	        var url = '/api/relations?fromId=' + fromId;
	        url += '&fromType=' + fromType;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function findInfoByFrom(fromId, fromType) {
	        var deferred = $q.defer();
	        var url = '/api/relations/info?fromId=' + fromId;
	        url += '&fromType=' + fromType;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function findByFromAndType(fromId, fromType, relationType) {
	        var deferred = $q.defer();
	        var url = '/api/relations?fromId=' + fromId;
	        url += '&fromType=' + fromType;
	        url += '&relationType=' + relationType;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function findByTo(toId, toType) {
	        var deferred = $q.defer();
	        var url = '/api/relations?toId=' + toId;
	        url += '&toType=' + toType;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function findInfoByTo(toId, toType) {
	        var deferred = $q.defer();
	        var url = '/api/relations/info?toId=' + toId;
	        url += '&toType=' + toType;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function findByToAndType(toId, toType, relationType) {
	        var deferred = $q.defer();
	        var url = '/api/relations?toId=' + toId;
	        url += '&toType=' + toType;
	        url += '&relationType=' + relationType;
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function findByQuery(query) {
	        var deferred = $q.defer();
	        var url = '/api/relations';
	        $http.post(url, query).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function findInfoByQuery(query, config) {
	        var deferred = $q.defer();
	        var url = '/api/relations/info';
	        $http.post(url, query, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityService.$inject = ["$http", "$q", "$filter", "$translate", "$log", "userService", "deviceService", "assetService", "tenantService", "customerService", "ruleChainService", "dashboardService", "entityRelationService", "attributeService", "entityViewService", "types", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.api.entity', [_types2.default]).factory('entityService', EntityService).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function EntityService($http, $q, $filter, $translate, $log, userService, deviceService, assetService, tenantService, customerService, ruleChainService, dashboardService, entityRelationService, attributeService, entityViewService, types, utils) {
	    var service = {
	        getEntity: getEntity,
	        getEntities: getEntities,
	        getEntitiesByNameFilter: getEntitiesByNameFilter,
	        resolveAlias: resolveAlias,
	        resolveAliasFilter: resolveAliasFilter,
	        checkEntityAlias: checkEntityAlias,
	        filterAliasByEntityTypes: filterAliasByEntityTypes,
	        getAliasFilterTypesByEntityTypes: getAliasFilterTypesByEntityTypes,
	        prepareAllowedEntityTypesList: prepareAllowedEntityTypesList,
	        getEntityKeys: getEntityKeys,
	        createDatasourcesFromSubscriptionsInfo: createDatasourcesFromSubscriptionsInfo,
	        createAlarmSourceFromSubscriptionInfo: createAlarmSourceFromSubscriptionInfo,
	        getRelatedEntities: getRelatedEntities,
	        saveRelatedEntity: saveRelatedEntity,
	        getRelatedEntity: getRelatedEntity,
	        deleteRelatedEntity: deleteRelatedEntity,
	        moveEntity: moveEntity,
	        copyEntity: copyEntity
	    };
	
	    return service;
	
	    function getEntityPromise(entityType, entityId, config) {
	        var promise;
	        switch (entityType) {
	            case types.entityType.device:
	                promise = deviceService.getDevice(entityId, true, config);
	                break;
	            case types.entityType.asset:
	                promise = assetService.getAsset(entityId, true, config);
	                break;
	            case types.entityType.entityView:
	                promise = entityViewService.getEntityView(entityId, true, config);
	                break;
	            case types.entityType.tenant:
	                promise = tenantService.getTenant(entityId, config);
	                break;
	            case types.entityType.customer:
	                promise = customerService.getCustomer(entityId, config);
	                break;
	            case types.entityType.dashboard:
	                promise = dashboardService.getDashboardInfo(entityId, config);
	                break;
	            case types.entityType.user:
	                promise = userService.getUser(entityId, true, config);
	                break;
	            case types.entityType.rulechain:
	                promise = ruleChainService.getRuleChain(entityId, config);
	                break;
	            case types.entityType.alarm:
	                $log.error('Get Alarm Entity is not implemented!');
	                break;
	        }
	        return promise;
	    }
	
	    function getEntity(entityType, entityId, config) {
	        var deferred = $q.defer();
	        var promise = getEntityPromise(entityType, entityId, config);
	        if (promise) {
	            promise.then(function success(result) {
	                deferred.resolve(result);
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            deferred.reject();
	        }
	        return deferred.promise;
	    }
	
	    function getEntitiesByIdsPromise(fetchEntityFunction, entityIds) {
	        var tasks = [];
	        var deferred = $q.defer();
	        for (var i = 0; i < entityIds.length; i++) {
	            tasks.push(fetchEntityFunction(entityIds[i]));
	        }
	        $q.all(tasks).then(function success(entities) {
	            if (entities) {
	                entities.sort(function (entity1, entity2) {
	                    var id1 = entity1.id.id;
	                    var id2 = entity2.id.id;
	                    var index1 = entityIds.indexOf(id1);
	                    var index2 = entityIds.indexOf(id2);
	                    return index1 - index2;
	                });
	                deferred.resolve(entities);
	            } else {
	                deferred.resolve([]);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getEntitiesPromise(entityType, entityIds, config) {
	        var promise;
	        switch (entityType) {
	            case types.entityType.device:
	                promise = deviceService.getDevices(entityIds, config);
	                break;
	            case types.entityType.asset:
	                promise = assetService.getAssets(entityIds, config);
	                break;
	            case types.entityType.entityView:
	                promise = getEntitiesByIdsPromise(function (id) {
	                    return entityViewService.getEntityView(id, config);
	                }, entityIds);
	                break;
	            case types.entityType.tenant:
	                promise = getEntitiesByIdsPromise(function (id) {
	                    return tenantService.getTenant(id, config);
	                }, entityIds);
	                break;
	            case types.entityType.customer:
	                promise = getEntitiesByIdsPromise(function (id) {
	                    return customerService.getCustomer(id, config);
	                }, entityIds);
	                break;
	            case types.entityType.dashboard:
	                promise = getEntitiesByIdsPromise(function (id) {
	                    return dashboardService.getDashboardInfo(id, config);
	                }, entityIds);
	                break;
	            case types.entityType.user:
	                promise = getEntitiesByIdsPromise(function (id) {
	                    return userService.getUser(id, true, config);
	                }, entityIds);
	                break;
	            case types.entityType.alarm:
	                $log.error('Get Alarm Entity is not implemented!');
	                break;
	        }
	        return promise;
	    }
	
	    function getEntities(entityType, entityIds, config) {
	        var deferred = $q.defer();
	        var promise = getEntitiesPromise(entityType, entityIds, config);
	        if (promise) {
	            promise.then(function success(result) {
	                deferred.resolve(result);
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            deferred.reject();
	        }
	        return deferred.promise;
	    }
	
	    function getSingleTenantByPageLinkPromise(pageLink, config) {
	        var user = userService.getCurrentUser();
	        var tenantId = user.tenantId;
	        var deferred = $q.defer();
	        tenantService.getTenant(tenantId, config).then(function success(tenant) {
	            var tenantName = tenant.name;
	            var result = {
	                data: [],
	                nextPageLink: pageLink,
	                hasNext: false
	            };
	            if (tenantName.toLowerCase().startsWith(pageLink.textSearch)) {
	                result.data.push(tenant);
	            }
	            deferred.resolve(result);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getSingleCustomerByPageLinkPromise(pageLink, config) {
	        var user = userService.getCurrentUser();
	        var customerId = user.customerId;
	        var deferred = $q.defer();
	        customerService.getCustomer(customerId, config).then(function success(customer) {
	            var customerName = customer.name;
	            var result = {
	                data: [],
	                nextPageLink: pageLink,
	                hasNext: false
	            };
	            if (customerName.toLowerCase().startsWith(pageLink.textSearch)) {
	                result.data.push(customer);
	            }
	            deferred.resolve(result);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getEntitiesByPageLinkPromise(entityType, pageLink, config, subType) {
	        var promise;
	        var user = userService.getCurrentUser();
	        var customerId = user.customerId;
	        switch (entityType) {
	            case types.entityType.device:
	                if (user.authority === 'CUSTOMER_USER') {
	                    promise = deviceService.getCustomerDevices(customerId, pageLink, false, config, subType);
	                } else {
	                    promise = deviceService.getTenantDevices(pageLink, false, config, subType);
	                }
	                break;
	            case types.entityType.asset:
	                if (user.authority === 'CUSTOMER_USER') {
	                    promise = assetService.getCustomerAssets(customerId, pageLink, false, config, subType);
	                } else {
	                    promise = assetService.getTenantAssets(pageLink, false, config, subType);
	                }
	                break;
	            case types.entityType.entityView:
	                if (user.authority === 'CUSTOMER_USER') {
	                    promise = entityViewService.getCustomerEntityViews(customerId, pageLink, false, config, subType);
	                } else {
	                    promise = entityViewService.getTenantEntityViews(pageLink, false, config, subType);
	                }
	                break;
	            case types.entityType.tenant:
	                if (user.authority === 'TENANT_ADMIN') {
	                    promise = getSingleTenantByPageLinkPromise(pageLink, config);
	                } else {
	                    promise = tenantService.getTenants(pageLink, config);
	                }
	                break;
	            case types.entityType.customer:
	                if (user.authority === 'CUSTOMER_USER') {
	                    promise = getSingleCustomerByPageLinkPromise(pageLink, config);
	                } else {
	                    promise = customerService.getCustomers(pageLink, config);
	                }
	                break;
	            case types.entityType.rulechain:
	                promise = ruleChainService.getRuleChains(pageLink, config);
	                break;
	            case types.entityType.dashboard:
	                if (user.authority === 'CUSTOMER_USER') {
	                    promise = dashboardService.getCustomerDashboards(customerId, pageLink, config);
	                } else {
	                    promise = dashboardService.getTenantDashboards(pageLink, config);
	                }
	                break;
	            case types.entityType.user:
	                $log.error('Get User Entities is not implemented!');
	                break;
	            case types.entityType.alarm:
	                $log.error('Get Alarm Entities is not implemented!');
	                break;
	        }
	        return promise;
	    }
	
	    function getEntitiesByPageLink(entityType, pageLink, config, subType, data, deferred) {
	        var promise = getEntitiesByPageLinkPromise(entityType, pageLink, config, subType);
	        if (promise) {
	            promise.then(function success(result) {
	                data = data.concat(result.data);
	                if (result.hasNext) {
	                    pageLink = result.nextPageLink;
	                    getEntitiesByPageLink(entityType, pageLink, config, subType, data, deferred);
	                } else {
	                    if (data && data.length > 0) {
	                        deferred.resolve(data);
	                    } else {
	                        deferred.resolve(null);
	                    }
	                }
	            }, function fail() {
	                deferred.resolve(null);
	            });
	        } else {
	            deferred.resolve(null);
	        }
	    }
	
	    function getEntitiesByNameFilter(entityType, entityNameFilter, limit, config, subType) {
	        var deferred = $q.defer();
	        var pageLink = { limit: limit, textSearch: entityNameFilter };
	        if (limit == -1) {
	            // all
	            var data = [];
	            pageLink.limit = 100;
	            getEntitiesByPageLink(entityType, pageLink, config, subType, data, deferred);
	        } else {
	            var promise = getEntitiesByPageLinkPromise(entityType, pageLink, config, subType);
	            if (promise) {
	                promise.then(function success(result) {
	                    if (result.data && result.data.length > 0) {
	                        deferred.resolve(result.data);
	                    } else {
	                        deferred.resolve(null);
	                    }
	                }, function fail() {
	                    deferred.resolve(null);
	                });
	            } else {
	                deferred.resolve(null);
	            }
	        }
	        return deferred.promise;
	    }
	
	    function entityToEntityInfo(entity) {
	        return { name: entity.name, entityType: entity.id.entityType, id: entity.id.id, entityDescription: entity.additionalInfo ? entity.additionalInfo.description : "" };
	    }
	
	    function entityRelationInfoToEntityInfo(entityRelationInfo, direction) {
	        var entityId = direction == types.entitySearchDirection.from ? entityRelationInfo.to : entityRelationInfo.from;
	        var name = direction == types.entitySearchDirection.from ? entityRelationInfo.toName : entityRelationInfo.fromName;
	        return {
	            name: name,
	            entityType: entityId.entityType,
	            id: entityId.id
	        };
	    }
	
	    function entitiesToEntitiesInfo(entities) {
	        var entitiesInfo = [];
	        if (entities) {
	            for (var d = 0; d < entities.length; d++) {
	                entitiesInfo.push(entityToEntityInfo(entities[d]));
	            }
	        }
	        return entitiesInfo;
	    }
	
	    function entityRelationInfosToEntitiesInfo(entityRelations, direction) {
	        var entitiesInfo = [];
	        if (entityRelations) {
	            for (var d = 0; d < entityRelations.length; d++) {
	                entitiesInfo.push(entityRelationInfoToEntityInfo(entityRelations[d], direction));
	            }
	        }
	        return entitiesInfo;
	    }
	
	    function resolveAlias(entityAlias, stateParams) {
	        var deferred = $q.defer();
	        var filter = entityAlias.filter;
	        resolveAliasFilter(filter, stateParams, -1, false).then(function (result) {
	            var aliasInfo = {
	                alias: entityAlias.alias,
	                stateEntity: result.stateEntity,
	                entityParamName: result.entityParamName,
	                resolveMultiple: filter.resolveMultiple
	            };
	            aliasInfo.resolvedEntities = result.entities;
	            aliasInfo.currentEntity = null;
	            if (aliasInfo.resolvedEntities.length) {
	                aliasInfo.currentEntity = aliasInfo.resolvedEntities[0];
	            }
	            deferred.resolve(aliasInfo);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function resolveAliasEntityId(entityType, id) {
	        var entityId = {
	            entityType: entityType,
	            id: id
	        };
	        if (entityType == types.aliasEntityType.current_customer) {
	            var user = userService.getCurrentUser();
	            entityId.entityType = types.entityType.customer;
	            if (user.authority === 'CUSTOMER_USER') {
	                entityId.id = user.customerId;
	            }
	        }
	        return entityId;
	    }
	
	    function getStateEntityId(filter, stateParams) {
	        var entityId = null;
	        if (stateParams) {
	            if (filter.stateEntityParamName && filter.stateEntityParamName.length) {
	                if (stateParams[filter.stateEntityParamName]) {
	                    entityId = stateParams[filter.stateEntityParamName].entityId;
	                }
	            } else {
	                entityId = stateParams.entityId;
	            }
	        }
	        if (!entityId) {
	            entityId = filter.defaultStateEntity;
	        }
	        if (entityId) {
	            entityId = resolveAliasEntityId(entityId.entityType, entityId.id);
	        }
	        return entityId;
	    }
	
	    function resolveAliasFilter(filter, stateParams, maxItems, failOnEmpty) {
	        var deferred = $q.defer();
	        var result = {
	            entities: [],
	            stateEntity: false
	        };
	        if (filter.stateEntityParamName && filter.stateEntityParamName.length) {
	            result.entityParamName = filter.stateEntityParamName;
	        }
	        var stateEntityId = getStateEntityId(filter, stateParams);
	        switch (filter.type) {
	            case types.aliasFilterType.singleEntity.value:
	                var aliasEntityId = resolveAliasEntityId(filter.singleEntity.entityType, filter.singleEntity.id);
	                getEntity(aliasEntityId.entityType, aliasEntityId.id, { ignoreLoading: true }).then(function success(entity) {
	                    result.entities = entitiesToEntitiesInfo([entity]);
	                    deferred.resolve(result);
	                }, function fail() {
	                    deferred.reject();
	                });
	                break;
	            case types.aliasFilterType.entityList.value:
	                getEntities(filter.entityType, filter.entityList, { ignoreLoading: true }).then(function success(entities) {
	                    if (entities && entities.length || !failOnEmpty) {
	                        result.entities = entitiesToEntitiesInfo(entities);
	                        deferred.resolve(result);
	                    } else {
	                        deferred.reject();
	                    }
	                }, function fail() {
	                    deferred.reject();
	                });
	                break;
	            case types.aliasFilterType.entityName.value:
	                getEntitiesByNameFilter(filter.entityType, filter.entityNameFilter, maxItems, { ignoreLoading: true }).then(function success(entities) {
	                    if (entities && entities.length || !failOnEmpty) {
	                        result.entities = entitiesToEntitiesInfo(entities);
	                        deferred.resolve(result);
	                    } else {
	                        deferred.reject();
	                    }
	                }, function fail() {
	                    deferred.reject();
	                });
	                break;
	            case types.aliasFilterType.stateEntity.value:
	                result.stateEntity = true;
	                if (stateEntityId) {
	                    getEntity(stateEntityId.entityType, stateEntityId.id, { ignoreLoading: true }).then(function success(entity) {
	                        result.entities = entitiesToEntitiesInfo([entity]);
	                        deferred.resolve(result);
	                    }, function fail() {
	                        deferred.resolve(result);
	                    });
	                } else {
	                    deferred.resolve(result);
	                }
	                break;
	            case types.aliasFilterType.assetType.value:
	                getEntitiesByNameFilter(types.entityType.asset, filter.assetNameFilter, maxItems, { ignoreLoading: true }, filter.assetType).then(function success(entities) {
	                    if (entities && entities.length || !failOnEmpty) {
	                        result.entities = entitiesToEntitiesInfo(entities);
	                        deferred.resolve(result);
	                    } else {
	                        deferred.reject();
	                    }
	                }, function fail() {
	                    deferred.reject();
	                });
	                break;
	            case types.aliasFilterType.deviceType.value:
	                getEntitiesByNameFilter(types.entityType.device, filter.deviceNameFilter, maxItems, { ignoreLoading: true }, filter.deviceType).then(function success(entities) {
	                    if (entities && entities.length || !failOnEmpty) {
	                        result.entities = entitiesToEntitiesInfo(entities);
	                        deferred.resolve(result);
	                    } else {
	                        deferred.reject();
	                    }
	                }, function fail() {
	                    deferred.reject();
	                });
	                break;
	            case types.aliasFilterType.entityViewType.value:
	                getEntitiesByNameFilter(types.entityType.entityView, filter.entityViewNameFilter, maxItems, { ignoreLoading: true }, filter.entityViewType).then(function success(entities) {
	                    if (entities && entities.length || !failOnEmpty) {
	                        result.entities = entitiesToEntitiesInfo(entities);
	                        deferred.resolve(result);
	                    } else {
	                        deferred.reject();
	                    }
	                }, function fail() {
	                    deferred.reject();
	                });
	                break;
	            case types.aliasFilterType.relationsQuery.value:
	                result.stateEntity = filter.rootStateEntity;
	                var rootEntityType;
	                var rootEntityId;
	                if (result.stateEntity && stateEntityId) {
	                    rootEntityType = stateEntityId.entityType;
	                    rootEntityId = stateEntityId.id;
	                } else if (!result.stateEntity) {
	                    rootEntityType = filter.rootEntity.entityType;
	                    rootEntityId = filter.rootEntity.id;
	                }
	                if (rootEntityType && rootEntityId) {
	                    var relationQueryRootEntityId = resolveAliasEntityId(rootEntityType, rootEntityId);
	                    var searchQuery = {
	                        parameters: {
	                            rootId: relationQueryRootEntityId.id,
	                            rootType: relationQueryRootEntityId.entityType,
	                            direction: filter.direction
	                        },
	                        filters: filter.filters
	                    };
	                    searchQuery.parameters.maxLevel = filter.maxLevel && filter.maxLevel > 0 ? filter.maxLevel : -1;
	                    entityRelationService.findInfoByQuery(searchQuery, { ignoreLoading: true }).then(function success(allRelations) {
	                        if (allRelations && allRelations.length || !failOnEmpty) {
	                            if (angular.isDefined(maxItems) && maxItems > 0 && allRelations) {
	                                var limit = Math.min(allRelations.length, maxItems);
	                                allRelations.length = limit;
	                            }
	                            result.entities = entityRelationInfosToEntitiesInfo(allRelations, filter.direction);
	                            deferred.resolve(result);
	                        } else {
	                            deferred.reject();
	                        }
	                    }, function fail() {
	                        deferred.reject();
	                    });
	                } else {
	                    deferred.resolve(result);
	                }
	                break;
	            case types.aliasFilterType.assetSearchQuery.value:
	            case types.aliasFilterType.deviceSearchQuery.value:
	            case types.aliasFilterType.entityViewSearchQuery.value:
	                result.stateEntity = filter.rootStateEntity;
	                if (result.stateEntity && stateEntityId) {
	                    rootEntityType = stateEntityId.entityType;
	                    rootEntityId = stateEntityId.id;
	                } else if (!result.stateEntity) {
	                    rootEntityType = filter.rootEntity.entityType;
	                    rootEntityId = filter.rootEntity.id;
	                }
	                if (rootEntityType && rootEntityId) {
	                    var searchQueryRootEntityId = resolveAliasEntityId(rootEntityType, rootEntityId);
	                    searchQuery = {
	                        parameters: {
	                            rootId: searchQueryRootEntityId.id,
	                            rootType: searchQueryRootEntityId.entityType,
	                            direction: filter.direction
	                        },
	                        relationType: filter.relationType
	                    };
	                    searchQuery.parameters.maxLevel = filter.maxLevel && filter.maxLevel > 0 ? filter.maxLevel : -1;
	                    var findByQueryPromise;
	                    if (filter.type == types.aliasFilterType.assetSearchQuery.value) {
	                        searchQuery.assetTypes = filter.assetTypes;
	                        findByQueryPromise = assetService.findByQuery(searchQuery, false, { ignoreLoading: true });
	                    } else if (filter.type == types.aliasFilterType.deviceSearchQuery.value) {
	                        searchQuery.deviceTypes = filter.deviceTypes;
	                        findByQueryPromise = deviceService.findByQuery(searchQuery, false, { ignoreLoading: true });
	                    } else if (filter.type == types.aliasFilterType.entityViewSearchQuery.value) {
	                        searchQuery.entityViewTypes = filter.entityViewTypes;
	                        findByQueryPromise = entityViewService.findByQuery(searchQuery, false, { ignoreLoading: true });
	                    }
	                    findByQueryPromise.then(function success(entities) {
	                        if (entities && entities.length || !failOnEmpty) {
	                            if (angular.isDefined(maxItems) && maxItems > 0 && entities) {
	                                var limit = Math.min(entities.length, maxItems);
	                                entities.length = limit;
	                            }
	                            result.entities = entitiesToEntitiesInfo(entities);
	                            deferred.resolve(result);
	                        } else {
	                            deferred.reject();
	                        }
	                    }, function fail() {
	                        deferred.reject();
	                    });
	                } else {
	                    deferred.resolve(result);
	                }
	                break;
	        }
	        return deferred.promise;
	    }
	
	    function filterAliasByEntityTypes(entityAlias, entityTypes) {
	        var filter = entityAlias.filter;
	        if (filterAliasFilterTypeByEntityTypes(filter.type, entityTypes)) {
	            switch (filter.type) {
	                case types.aliasFilterType.singleEntity.value:
	                    return entityTypes.indexOf(filter.singleEntity.entityType) > -1 ? true : false;
	                case types.aliasFilterType.entityList.value:
	                    return entityTypes.indexOf(filter.entityType) > -1 ? true : false;
	                case types.aliasFilterType.entityName.value:
	                    return entityTypes.indexOf(filter.entityType) > -1 ? true : false;
	                case types.aliasFilterType.stateEntity.value:
	                    return true;
	                case types.aliasFilterType.assetType.value:
	                    return entityTypes.indexOf(types.entityType.asset) > -1 ? true : false;
	                case types.aliasFilterType.deviceType.value:
	                    return entityTypes.indexOf(types.entityType.device) > -1 ? true : false;
	                case types.aliasFilterType.entityViewType.value:
	                    return entityTypes.indexOf(types.entityType.entityView) > -1 ? true : false;
	                case types.aliasFilterType.relationsQuery.value:
	                    if (filter.filters && filter.filters.length) {
	                        var match = false;
	                        for (var f = 0; f < filter.filters.length; f++) {
	                            var relationFilter = filter.filters[f];
	                            if (relationFilter.entityTypes && relationFilter.entityTypes.length) {
	                                for (var et = 0; et < relationFilter.entityTypes.length; et++) {
	                                    if (entityTypes.indexOf(relationFilter.entityTypes[et]) > -1) {
	                                        match = true;
	                                        break;
	                                    }
	                                }
	                            } else {
	                                match = true;
	                                break;
	                            }
	                        }
	                        return match;
	                    } else {
	                        return true;
	                    }
	                case types.aliasFilterType.assetSearchQuery.value:
	                    return entityTypes.indexOf(types.entityType.asset) > -1 ? true : false;
	                case types.aliasFilterType.deviceSearchQuery.value:
	                    return entityTypes.indexOf(types.entityType.device) > -1 ? true : false;
	                case types.aliasFilterType.entityViewSearchQuery.value:
	                    return entityTypes.indexOf(types.entityType.entityView) > -1 ? true : false;
	            }
	        }
	        return false;
	    }
	
	    function filterAliasFilterTypeByEntityType(aliasFilterType, entityType) {
	        switch (aliasFilterType) {
	            case types.aliasFilterType.singleEntity.value:
	                return true;
	            case types.aliasFilterType.entityList.value:
	                return true;
	            case types.aliasFilterType.entityName.value:
	                return true;
	            case types.aliasFilterType.stateEntity.value:
	                return true;
	            case types.aliasFilterType.assetType.value:
	                return entityType === types.entityType.asset;
	            case types.aliasFilterType.deviceType.value:
	                return entityType === types.entityType.device;
	            case types.aliasFilterType.entityViewType.value:
	                return entityType === types.entityType.entityView;
	            case types.aliasFilterType.relationsQuery.value:
	                return true;
	            case types.aliasFilterType.assetSearchQuery.value:
	                return entityType === types.entityType.asset;
	            case types.aliasFilterType.deviceSearchQuery.value:
	                return entityType === types.entityType.device;
	            case types.aliasFilterType.entityViewSearchQuery.value:
	                return entityType === types.entityType.entityView;
	        }
	        return false;
	    }
	
	    function filterAliasFilterTypeByEntityTypes(aliasFilterType, entityTypes) {
	        if (!entityTypes || !entityTypes.length) {
	            return true;
	        }
	        var valid = false;
	        entityTypes.forEach(function (entityType) {
	            valid = valid || filterAliasFilterTypeByEntityType(aliasFilterType, entityType);
	        });
	        return valid;
	    }
	
	    function getAliasFilterTypesByEntityTypes(entityTypes) {
	        var allAliasFilterTypes = types.aliasFilterType;
	        if (!entityTypes || !entityTypes.length) {
	            return allAliasFilterTypes;
	        }
	        var result = {};
	        for (var type in allAliasFilterTypes) {
	            var aliasFilterType = allAliasFilterTypes[type];
	            if (filterAliasFilterTypeByEntityTypes(aliasFilterType.value, entityTypes)) {
	                result[type] = aliasFilterType;
	            }
	        }
	        return result;
	    }
	
	    function prepareAllowedEntityTypesList(allowedEntityTypes, useAliasEntityTypes) {
	        var authority = userService.getAuthority();
	        var entityTypes = {};
	        switch (authority) {
	            case 'SYS_ADMIN':
	                entityTypes.tenant = types.entityType.tenant;
	                break;
	            case 'TENANT_ADMIN':
	                entityTypes.device = types.entityType.device;
	                entityTypes.asset = types.entityType.asset;
	                entityTypes.entityView = types.entityType.entityView;
	                entityTypes.tenant = types.entityType.tenant;
	                entityTypes.customer = types.entityType.customer;
	                entityTypes.dashboard = types.entityType.dashboard;
	                if (useAliasEntityTypes) {
	                    entityTypes.current_customer = types.aliasEntityType.current_customer;
	                }
	                break;
	            case 'CUSTOMER_USER':
	                entityTypes.device = types.entityType.device;
	                entityTypes.asset = types.entityType.asset;
	                entityTypes.entityView = types.entityType.entityView;
	                entityTypes.customer = types.entityType.customer;
	                entityTypes.dashboard = types.entityType.dashboard;
	                if (useAliasEntityTypes) {
	                    entityTypes.current_customer = types.aliasEntityType.current_customer;
	                }
	                break;
	        }
	
	        if (allowedEntityTypes) {
	            for (var entityType in entityTypes) {
	                if (allowedEntityTypes.indexOf(entityTypes[entityType]) === -1) {
	                    delete entityTypes[entityType];
	                }
	            }
	        }
	        return entityTypes;
	    }
	
	    function checkEntityAlias(entityAlias) {
	        var deferred = $q.defer();
	        resolveAliasFilter(entityAlias.filter, null, 1, true).then(function success(result) {
	            if (result.stateEntity) {
	                deferred.resolve(true);
	            } else {
	                var entities = result.entities;
	                if (entities && entities.length) {
	                    deferred.resolve(true);
	                } else {
	                    deferred.resolve(false);
	                }
	            }
	        }, function fail() {
	            deferred.resolve(false);
	        });
	        return deferred.promise;
	    }
	
	    function getEntityKeys(entityType, entityId, query, type, config) {
	        var deferred = $q.defer();
	        var url = '/api/plugins/telemetry/' + entityType + '/' + entityId + '/keys/';
	        if (type === types.dataKeyType.timeseries) {
	            url += 'timeseries';
	        } else if (type === types.dataKeyType.attribute) {
	            url += 'attributes';
	        }
	        $http.get(url, config).then(function success(response) {
	            var result = [];
	            if (response.data) {
	                if (query) {
	                    var dataKeys = response.data;
	                    var lowercaseQuery = angular.lowercase(query);
	                    for (var i = 0; i < dataKeys.length; i++) {
	                        if (angular.lowercase(dataKeys[i]).indexOf(lowercaseQuery) === 0) {
	                            result.push(dataKeys[i]);
	                        }
	                    }
	                } else {
	                    result = response.data;
	                }
	            }
	            deferred.resolve(result);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function createDatasourcesFromSubscriptionsInfo(subscriptionsInfo) {
	        var deferred = $q.defer();
	        var datasources = [];
	        processSubscriptionsInfo(0, subscriptionsInfo, datasources, deferred);
	        return deferred.promise;
	    }
	
	    function createAlarmSourceFromSubscriptionInfo(subscriptionInfo) {
	        var deferred = $q.defer();
	        var datasources = [];
	        if (subscriptionInfo.entityId && subscriptionInfo.entityType) {
	            getEntity(subscriptionInfo.entityType, subscriptionInfo.entityId, { ignoreLoading: true }).then(function success(entity) {
	                createDatasourceFromSubscription(subscriptionInfo, datasources, entity);
	                var alarmSource = datasources[0];
	                deferred.resolve(alarmSource);
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            deferred.reject();
	        }
	        return deferred.promise;
	    }
	
	    function processSubscriptionsInfo(index, subscriptionsInfo, datasources, deferred) {
	        if (index < subscriptionsInfo.length) {
	            var subscriptionInfo = validateSubscriptionInfo(subscriptionsInfo[index]);
	            if (subscriptionInfo.type === types.datasourceType.entity) {
	                if (subscriptionInfo.entityId) {
	                    if (subscriptionInfo.entityName) {
	                        var entity = {
	                            id: { id: subscriptionInfo.entityId, entityType: subscriptionInfo.entityType },
	                            name: subscriptionInfo.entityName
	                        };
	                        createDatasourceFromSubscription(subscriptionInfo, datasources, entity);
	                        index++;
	                        processSubscriptionsInfo(index, subscriptionsInfo, datasources, deferred);
	                    } else {
	                        getEntity(subscriptionInfo.entityType, subscriptionInfo.entityId, { ignoreLoading: true }).then(function success(entity) {
	                            createDatasourceFromSubscription(subscriptionInfo, datasources, entity);
	                            index++;
	                            processSubscriptionsInfo(index, subscriptionsInfo, datasources, deferred);
	                        }, function fail() {
	                            index++;
	                            processSubscriptionsInfo(index, subscriptionsInfo, datasources, deferred);
	                        });
	                    }
	                } else if (subscriptionInfo.entityName || subscriptionInfo.entityNamePrefix || subscriptionInfo.entityIds) {
	                    var promise;
	                    if (subscriptionInfo.entityName) {
	                        promise = getEntitiesByNameFilter(subscriptionInfo.entityType, subscriptionInfo.entityName, 1, { ignoreLoading: true });
	                    } else if (subscriptionInfo.entityNamePrefix) {
	                        promise = getEntitiesByNameFilter(subscriptionInfo.entityType, subscriptionInfo.entityNamePrefix, 100, { ignoreLoading: true });
	                    } else if (subscriptionInfo.entityIds) {
	                        promise = getEntities(subscriptionInfo.entityType, subscriptionInfo.entityIds, { ignoreLoading: true });
	                    }
	                    promise.then(function success(entities) {
	                        if (entities && entities.length > 0) {
	                            for (var i = 0; i < entities.length; i++) {
	                                var entity = entities[i];
	                                createDatasourceFromSubscription(subscriptionInfo, datasources, entity);
	                            }
	                        }
	                        index++;
	                        processSubscriptionsInfo(index, subscriptionsInfo, datasources, deferred);
	                    }, function fail() {
	                        index++;
	                        processSubscriptionsInfo(index, subscriptionsInfo, datasources, deferred);
	                    });
	                } else {
	                    index++;
	                    processSubscriptionsInfo(index, subscriptionsInfo, datasources, deferred);
	                }
	            } else if (subscriptionInfo.type === types.datasourceType.function) {
	                createDatasourceFromSubscription(subscriptionInfo, datasources);
	                index++;
	                processSubscriptionsInfo(index, subscriptionsInfo, datasources, deferred);
	            }
	        } else {
	            deferred.resolve(datasources);
	        }
	    }
	
	    function validateSubscriptionInfo(subscriptionInfo) {
	        if (subscriptionInfo.type === 'device') {
	            subscriptionInfo.type = types.datasourceType.entity;
	            subscriptionInfo.entityType = types.entityType.device;
	            if (subscriptionInfo.deviceId) {
	                subscriptionInfo.entityId = subscriptionInfo.deviceId;
	            } else if (subscriptionInfo.deviceName) {
	                subscriptionInfo.entityName = subscriptionInfo.deviceName;
	            } else if (subscriptionInfo.deviceNamePrefix) {
	                subscriptionInfo.entityNamePrefix = subscriptionInfo.deviceNamePrefix;
	            } else if (subscriptionInfo.deviceIds) {
	                subscriptionInfo.entityIds = subscriptionInfo.deviceIds;
	            }
	        }
	        return subscriptionInfo;
	    }
	
	    function createDatasourceFromSubscription(subscriptionInfo, datasources, entity) {
	        var datasource;
	        if (subscriptionInfo.type === types.datasourceType.entity) {
	            datasource = {
	                type: subscriptionInfo.type,
	                entityName: entity.name ? entity.name : entity.title,
	                name: entity.name ? entity.name : entity.title,
	                entityType: subscriptionInfo.entityType,
	                entityId: entity.id.id,
	                dataKeys: []
	            };
	        } else if (subscriptionInfo.type === types.datasourceType.function) {
	            datasource = {
	                type: subscriptionInfo.type,
	                name: subscriptionInfo.name || types.datasourceType.function,
	                dataKeys: []
	            };
	        }
	        datasources.push(datasource);
	        if (subscriptionInfo.timeseries) {
	            createDatasourceKeys(subscriptionInfo.timeseries, types.dataKeyType.timeseries, datasource, datasources);
	        }
	        if (subscriptionInfo.attributes) {
	            createDatasourceKeys(subscriptionInfo.attributes, types.dataKeyType.attribute, datasource, datasources);
	        }
	        if (subscriptionInfo.functions) {
	            createDatasourceKeys(subscriptionInfo.functions, types.dataKeyType.function, datasource, datasources);
	        }
	        if (subscriptionInfo.alarmFields) {
	            createDatasourceKeys(subscriptionInfo.alarmFields, types.dataKeyType.alarm, datasource, datasources);
	        }
	    }
	
	    function createDatasourceKeys(keyInfos, type, datasource, datasources) {
	        for (var i = 0; i < keyInfos.length; i++) {
	            var keyInfo = keyInfos[i];
	            var dataKey = utils.createKey(keyInfo, type, datasources);
	            datasource.dataKeys.push(dataKey);
	        }
	    }
	
	    function getRelatedEntities(rootEntityId, entityType, entitySubTypes, maxLevel, keys, typeTranslatePrefix, relationType, direction) {
	        var deferred = $q.defer();
	
	        var entitySearchQuery = constructRelatedEntitiesSearchQuery(rootEntityId, entityType, entitySubTypes, maxLevel, relationType, direction);
	        if (!entitySearchQuery) {
	            deferred.reject();
	        } else {
	            var findByQueryPromise;
	            if (entityType == types.entityType.asset) {
	                findByQueryPromise = assetService.findByQuery(entitySearchQuery, true, { ignoreLoading: true });
	            } else if (entityType == types.entityType.device) {
	                findByQueryPromise = deviceService.findByQuery(entitySearchQuery, true, { ignoreLoading: true });
	            }
	            findByQueryPromise.then(function success(entities) {
	                var entitiesTasks = [];
	                for (var i = 0; i < entities.length; i++) {
	                    var entity = entities[i];
	                    var entityPromise = constructEntity(entity, keys, typeTranslatePrefix);
	                    entitiesTasks.push(entityPromise);
	                }
	                $q.all(entitiesTasks).then(function success(entities) {
	                    deferred.resolve(entities);
	                }, function fail() {
	                    deferred.reject();
	                });
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	
	    function saveRelatedEntity(relatedEntity, parentEntityId, keys, relation, direction) {
	        var deferred = $q.defer();
	        if (!direction) {
	            direction = types.entitySearchDirection.from;
	        }
	        if (relatedEntity.id.id) {
	            updateRelatedEntity(relatedEntity, keys, deferred, relation, direction);
	        } else {
	            addRelatedEntity(relatedEntity, parentEntityId, keys, deferred, relation, direction);
	        }
	        return deferred.promise;
	    }
	
	    function getRelatedEntity(entityId, keys, typeTranslatePrefix) {
	        var deferred = $q.defer();
	        getEntityPromise(entityId.entityType, entityId.id, { ignoreLoading: true }).then(function success(entity) {
	            constructEntity(entity, keys, typeTranslatePrefix).then(function success(relatedEntity) {
	                deferred.resolve(relatedEntity);
	            }, function fail() {
	                deferred.reject();
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteEntityPromise(entityId) {
	        if (entityId.entityType == types.entityType.asset) {
	            return assetService.deleteAsset(entityId.id);
	        } else if (entityId.entityType == types.entityType.device) {
	            return deviceService.deleteDevice(entityId.id);
	        } else if (entityId.entityType == types.entityType.entityView) {
	            return entityViewService.deleteEntityView(entityId.id);
	        }
	    }
	
	    function deleteRelatedEntity(entityId, deleteRelatedEntityTypes) {
	        var deferred = $q.defer();
	        if (deleteRelatedEntityTypes) {
	            var deleteRelatedEntitiesTasks = [];
	            entityRelationService.findByFrom(entityId.id, entityId.entityType).then(function success(entityRelations) {
	                for (var i = 0; i < entityRelations.length; i++) {
	                    var entityRelation = entityRelations[i];
	                    var relationEntityId = entityRelation.to;
	                    if (deleteRelatedEntityTypes.length == 0 || deleteRelatedEntityTypes.indexOf(relationEntityId.entityType) > -1) {
	                        var deleteRelatedEntityPromise = deleteRelatedEntity(relationEntityId, deleteRelatedEntityTypes);
	                        deleteRelatedEntitiesTasks.push(deleteRelatedEntityPromise);
	                    }
	                }
	                deleteRelatedEntitiesTasks.push(deleteEntityPromise(entityId));
	                $q.all(deleteRelatedEntitiesTasks).then(function success() {
	                    deferred.resolve();
	                }, function fail() {
	                    deferred.reject();
	                });
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            deleteEntityPromise(entityId).then(function success() {
	                deferred.resolve();
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	
	    function moveEntity(entityId, prevParentId, targetParentId) {
	        var deferred = $q.defer();
	        entityRelationService.deleteRelation(prevParentId.id, prevParentId.entityType, types.entityRelationType.contains, entityId.id, entityId.entityType).then(function success() {
	            var relation = {
	                from: targetParentId,
	                to: entityId,
	                type: types.entityRelationType.contains
	            };
	            entityRelationService.saveRelation(relation).then(function success() {
	                deferred.resolve();
	            }, function fail() {
	                deferred.reject();
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function copyEntity(entity, targetParentId, keys) {
	        var deferred = $q.defer();
	        if (!entity.id && !entity.id.id) {
	            deferred.reject();
	        } else {
	            getRelatedEntity(entity.id, keys).then(function success(relatedEntity) {
	                delete relatedEntity.id.id;
	                relatedEntity.name = entity.name;
	                saveRelatedEntity(relatedEntity, targetParentId, keys).then(function success(savedEntity) {
	                    deferred.resolve(savedEntity);
	                }, function fail() {
	                    deferred.reject();
	                });
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	
	    function saveEntityPromise(entity) {
	        var entityType = entity.id.entityType;
	        if (!entity.id.id) {
	            delete entity.id;
	        }
	        if (entityType == types.entityType.asset) {
	            return assetService.saveAsset(entity);
	        } else if (entityType == types.entityType.device) {
	            return deviceService.saveDevice(entity);
	        } else if (entityType == types.entityType.entityView) {
	            return entityViewService.saveEntityView(entity);
	        }
	    }
	
	    function addRelatedEntity(relatedEntity, parentEntityId, keys, deferred, relation, direction) {
	        var entity = {};
	        entity.id = relatedEntity.id;
	        entity.name = relatedEntity.name;
	        entity.type = relatedEntity.type;
	        saveEntityPromise(entity).then(function success(entity) {
	            relatedEntity.id = entity.id;
	            if (!relation) {
	                relation = {
	                    type: types.entityRelationType.contains
	                };
	            }
	
	            if (direction == types.entitySearchDirection.from) {
	                relation.from = parentEntityId;
	                relation.to = relatedEntity.id;
	            } else {
	                relation.from = relatedEntity.id;
	                relation.to = parentEntityId;
	            }
	
	            entityRelationService.saveRelation(relation).then(function success() {
	                updateEntity(entity, relatedEntity, keys, deferred, relation);
	            }, function fail() {
	                deferred.reject();
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	    }
	
	    function updateRelatedEntity(relatedEntity, keys, deferred, relation, direction) {
	        getEntityPromise(relatedEntity.id.entityType, relatedEntity.id.id, { ignoreLoading: true }).then(function success(entity) {
	            if (relation) {
	                if (direction == types.entitySearchDirection.from) {
	                    relation.to = relatedEntity.id;
	                } else {
	                    relation.from = relatedEntity.id;
	                }
	                entityRelationService.saveRelation(relation).then(function success() {
	                    updateEntity(entity, relatedEntity, keys, deferred);
	                }, function fail() {
	                    deferred.reject();
	                });
	            } else {
	                updateEntity(entity, relatedEntity, keys, deferred);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	    }
	
	    function updateEntity(entity, relatedEntity, keys, deferred) {
	        if (!angular.equals(entity.name, relatedEntity.name) || !angular.equals(entity.type, relatedEntity.type)) {
	            entity.name = relatedEntity.name;
	            entity.type = relatedEntity.type;
	            saveEntityPromise(entity).then(function success(entity) {
	                updateEntityAttributes(entity, relatedEntity, keys, deferred);
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            updateEntityAttributes(entity, relatedEntity, keys, deferred);
	        }
	    }
	
	    function updateEntityAttributes(entity, relatedEntity, keys, deferred) {
	        var attributes = [];
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            attributes.push({ key: key, value: relatedEntity[key] });
	        }
	        attributeService.saveEntityAttributes(entity.id.entityType, entity.id.id, types.attributesScope.server.value, attributes).then(function success() {
	            deferred.resolve(relatedEntity);
	        }, function fail() {
	            deferred.reject();
	        });
	    }
	
	    function constructRelatedEntitiesSearchQuery(rootEntityId, entityType, entitySubTypes, maxLevel, relationType, direction) {
	
	        var searchQuery = {
	            parameters: {
	                rootId: rootEntityId.id,
	                rootType: rootEntityId.entityType,
	                direction: direction
	            },
	            relationType: relationType
	        };
	        if (!direction) {
	            searchQuery.parameters.direction = types.entitySearchDirection.from;
	        }
	        if (!relationType) {
	            searchQuery.relationType = types.entityRelationType.contains;
	        }
	
	        if (maxLevel) {
	            searchQuery.parameters.maxLevel = maxLevel;
	        } else {
	            searchQuery.parameters.maxLevel = 1;
	        }
	
	        if (entityType == types.entityType.asset) {
	            searchQuery.assetTypes = entitySubTypes;
	        } else if (entityType == types.entityType.device) {
	            searchQuery.deviceTypes = entitySubTypes;
	        } else if (entityType == types.entityType.entityView) {
	            searchQuery.entityViewTypes = entitySubTypes;
	        } else {
	            return null; //Not supported
	        }
	
	        return searchQuery;
	    }
	
	    function constructEntity(entity, keys, typeTranslatePrefix) {
	        var deferred = $q.defer();
	        if (typeTranslatePrefix) {
	            entity.typeName = $translate.instant(typeTranslatePrefix + '.' + entity.type);
	        } else {
	            entity.typeName = entity.type;
	        }
	        attributeService.getEntityAttributesValues(entity.id.entityType, entity.id.id, types.attributesScope.server.value, keys.join(','), { ignoreLoading: true }).then(function success(attributes) {
	            if (attributes && attributes.length > 0) {
	                for (var i = 0; i < keys.length; i++) {
	                    var key = keys[i];
	                    entity[key] = getAttributeValue(attributes, key);
	                }
	            }
	            deferred.resolve(entity);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getAttributeValue(attributes, key) {
	        var foundAttributes = $filter('filter')(attributes, { key: key }, true);
	        if (foundAttributes.length > 0) {
	            return foundAttributes[0].value;
	        } else {
	            return null;
	        }
	    }
	}

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	'use strict';
	
	EventService.$inject = ["$http", "$q"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.event', []).factory('eventService', EventService).name;
	
	/*@ngInject*/
	
	function EventService($http, $q) {
	
	    var service = {
	        getEvents: getEvents
	    };
	
	    return service;
	
	    function getEvents(entityType, entityId, eventType, tenantId, pageLink) {
	        var deferred = $q.defer();
	        var url = '/api/events/' + entityType + '/' + entityId + '/' + eventType + '?tenantId=' + tenantId + '&limit=' + pageLink.limit;
	
	        if (angular.isDefined(pageLink.startTime) && pageLink.startTime != null) {
	            url += '&startTime=' + pageLink.startTime;
	        }
	        if (angular.isDefined(pageLink.endTime) && pageLink.endTime != null) {
	            url += '&endTime=' + pageLink.endTime;
	        }
	        if (angular.isDefined(pageLink.idOffset) && pageLink.idOffset != null) {
	            url += '&offset=' + pageLink.idOffset;
	        }
	        $http.get(url, null).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	'use strict';
	
	RuleChainService.$inject = ["$http", "$q", "$filter", "$ocLazyLoad", "$translate", "types", "componentDescriptorService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.ruleChain', []).factory('ruleChainService', RuleChainService).name;
	
	/*@ngInject*/
	
	function RuleChainService($http, $q, $filter, $ocLazyLoad, $translate, types, componentDescriptorService) {
	
	    var ruleNodeComponents = null;
	
	    var service = {
	        getRuleChains: getRuleChains,
	        getRuleChain: getRuleChain,
	        saveRuleChain: saveRuleChain,
	        setRootRuleChain: setRootRuleChain,
	        deleteRuleChain: deleteRuleChain,
	        getRuleChainMetaData: getRuleChainMetaData,
	        saveRuleChainMetaData: saveRuleChainMetaData,
	        getRuleNodeComponents: getRuleNodeComponents,
	        getRuleNodeComponentByClazz: getRuleNodeComponentByClazz,
	        getRuleNodeSupportedLinks: getRuleNodeSupportedLinks,
	        ruleNodeAllowCustomLinks: ruleNodeAllowCustomLinks,
	        resolveTargetRuleChains: resolveTargetRuleChains,
	        testScript: testScript,
	        getLatestRuleNodeDebugInput: getLatestRuleNodeDebugInput
	    };
	
	    return service;
	
	    function getRuleChains(pageLink, config) {
	        var deferred = $q.defer();
	        var url = '/api/ruleChains?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getRuleChain(ruleChainId, config) {
	        var deferred = $q.defer();
	        var url = '/api/ruleChain/' + ruleChainId;
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveRuleChain(ruleChain) {
	        var deferred = $q.defer();
	        var url = '/api/ruleChain';
	        $http.post(url, ruleChain).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function setRootRuleChain(ruleChainId) {
	        var deferred = $q.defer();
	        var url = '/api/ruleChain/' + ruleChainId + '/root';
	        $http.post(url).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function deleteRuleChain(ruleChainId) {
	        var deferred = $q.defer();
	        var url = '/api/ruleChain/' + ruleChainId;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getRuleChainMetaData(ruleChainId, config) {
	        var deferred = $q.defer();
	        var url = '/api/ruleChain/' + ruleChainId + '/metadata';
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveRuleChainMetaData(ruleChainMetaData) {
	        var deferred = $q.defer();
	        var url = '/api/ruleChain/metadata';
	        $http.post(url, ruleChainMetaData).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getRuleNodeSupportedLinks(component) {
	        var relationTypes = component.configurationDescriptor.nodeDefinition.relationTypes;
	        var linkLabels = {};
	        for (var i = 0; i < relationTypes.length; i++) {
	            var label = relationTypes[i];
	            linkLabels[label] = {
	                name: label,
	                value: label
	            };
	        }
	        return linkLabels;
	    }
	
	    function ruleNodeAllowCustomLinks(component) {
	        return component.configurationDescriptor.nodeDefinition.customRelations;
	    }
	
	    function getRuleNodeComponents() {
	        var deferred = $q.defer();
	        if (ruleNodeComponents) {
	            deferred.resolve(ruleNodeComponents);
	        } else {
	            loadRuleNodeComponents().then(function (components) {
	                resolveRuleNodeComponentsUiResources(components).then(function (components) {
	                    ruleNodeComponents = components;
	                    ruleNodeComponents.push(types.ruleChainNodeComponent);
	                    ruleNodeComponents.sort(function (comp1, comp2) {
	                        var result = comp1.type.localeCompare(comp2.type);
	                        if (result == 0) {
	                            result = comp1.name.localeCompare(comp2.name);
	                        }
	                        return result;
	                    });
	                    deferred.resolve(ruleNodeComponents);
	                }, function () {
	                    deferred.reject();
	                });
	            }, function () {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	
	    function resolveRuleNodeComponentsUiResources(components) {
	        var deferred = $q.defer();
	        var tasks = [];
	        for (var i = 0; i < components.length; i++) {
	            var component = components[i];
	            tasks.push(resolveRuleNodeComponentUiResources(component));
	        }
	        $q.all(tasks).then(function (components) {
	            deferred.resolve(components);
	        }, function () {
	            deferred.resolve(components);
	        });
	        return deferred.promise;
	    }
	
	    function resolveRuleNodeComponentUiResources(component) {
	        var deferred = $q.defer();
	        var uiResources = component.configurationDescriptor.nodeDefinition.uiResources;
	        if (uiResources && uiResources.length) {
	            var tasks = [];
	            for (var i = 0; i < uiResources.length; i++) {
	                var uiResource = uiResources[i];
	                tasks.push($ocLazyLoad.load(uiResource));
	            }
	            $q.all(tasks).then(function () {
	                deferred.resolve(component);
	            }, function () {
	                component.configurationDescriptor.nodeDefinition.uiResourceLoadError = $translate.instant('rulenode.ui-resources-load-error');
	                deferred.resolve(component);
	            });
	        } else {
	            deferred.resolve(component);
	        }
	        return deferred.promise;
	    }
	
	    function getRuleNodeComponentByClazz(clazz) {
	        var res = $filter('filter')(ruleNodeComponents, { clazz: clazz }, true);
	        if (res && res.length) {
	            return res[0];
	        }
	        var unknownComponent = angular.copy(types.unknownNodeComponent);
	        unknownComponent.clazz = clazz;
	        unknownComponent.configurationDescriptor.nodeDefinition.details = "Unknown Rule Node class: " + clazz;
	        return unknownComponent;
	    }
	
	    function resolveTargetRuleChains(ruleChainConnections) {
	        var deferred = $q.defer();
	        if (ruleChainConnections && ruleChainConnections.length) {
	            var tasks = [];
	            for (var i = 0; i < ruleChainConnections.length; i++) {
	                tasks.push(resolveRuleChain(ruleChainConnections[i].targetRuleChainId.id));
	            }
	            $q.all(tasks).then(function (ruleChains) {
	                var ruleChainsMap = {};
	                for (var i = 0; i < ruleChains.length; i++) {
	                    ruleChainsMap[ruleChains[i].id.id] = ruleChains[i];
	                }
	                deferred.resolve(ruleChainsMap);
	            }, function () {
	                deferred.reject();
	            });
	        } else {
	            deferred.resolve({});
	        }
	        return deferred.promise;
	    }
	
	    function resolveRuleChain(ruleChainId) {
	        var deferred = $q.defer();
	        getRuleChain(ruleChainId, { ignoreErrors: true }).then(function (ruleChain) {
	            deferred.resolve(ruleChain);
	        }, function () {
	            deferred.resolve({
	                id: { id: ruleChainId, entityType: types.entityType.rulechain }
	            });
	        });
	        return deferred.promise;
	    }
	
	    function loadRuleNodeComponents() {
	        return componentDescriptorService.getComponentDescriptorsByTypes(types.ruleNodeTypeComponentTypes);
	    }
	
	    function testScript(inputParams) {
	        var deferred = $q.defer();
	        var url = '/api/ruleChain/testScript';
	        $http.post(url, inputParams).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getLatestRuleNodeDebugInput(ruleNodeId) {
	        var deferred = $q.defer();
	        var url = '/api/ruleNode/' + ruleNodeId + '/debugIn';
	        $http.get(url).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*
	     options = {
	         type,
	         targetDeviceAliasIds,  // RPC
	         targetDeviceIds,       // RPC
	         datasources,
	         timeWindowConfig,
	         useDashboardTimewindow,
	         legendConfig,
	         decimals,
	         units,
	         callbacks
	    }
	 */
	
	var Subscription = function () {
	    function Subscription(subscriptionContext, options) {
	        _classCallCheck(this, Subscription);
	
	        this.ctx = subscriptionContext;
	        this.type = options.type;
	        this.callbacks = options.callbacks;
	        this.id = this.ctx.utils.guid();
	        this.cafs = {};
	        this.registrations = [];
	
	        var subscription = this;
	        var deferred = this.ctx.$q.defer();
	
	        if (this.type === this.ctx.types.widgetType.rpc.value) {
	            this.callbacks.rpcStateChanged = this.callbacks.rpcStateChanged || function () {};
	            this.callbacks.onRpcSuccess = this.callbacks.onRpcSuccess || function () {};
	            this.callbacks.onRpcFailed = this.callbacks.onRpcFailed || function () {};
	            this.callbacks.onRpcErrorCleared = this.callbacks.onRpcErrorCleared || function () {};
	
	            this.targetDeviceAliasIds = options.targetDeviceAliasIds;
	            this.targetDeviceIds = options.targetDeviceIds;
	
	            this.targetDeviceAliasId = null;
	            this.targetDeviceId = null;
	
	            this.rpcRejection = null;
	            this.rpcErrorText = null;
	            this.rpcEnabled = false;
	            this.executingRpcRequest = false;
	            this.executingPromises = [];
	            this.initRpc().then(function () {
	                deferred.resolve(subscription);
	            });
	        } else if (this.type === this.ctx.types.widgetType.alarm.value) {
	            this.callbacks.onDataUpdated = this.callbacks.onDataUpdated || function () {};
	            this.callbacks.onDataUpdateError = this.callbacks.onDataUpdateError || function () {};
	            this.callbacks.dataLoading = this.callbacks.dataLoading || function () {};
	            this.callbacks.timeWindowUpdated = this.callbacks.timeWindowUpdated || function () {};
	            this.alarmSource = options.alarmSource;
	
	            this.alarmSearchStatus = angular.isDefined(options.alarmSearchStatus) ? options.alarmSearchStatus : this.ctx.types.alarmSearchStatus.any;
	            this.alarmsPollingInterval = angular.isDefined(options.alarmsPollingInterval) ? options.alarmsPollingInterval : 5000;
	
	            this.alarmSourceListener = null;
	            this.alarms = [];
	
	            this.originalTimewindow = null;
	            this.timeWindow = {};
	            this.useDashboardTimewindow = options.useDashboardTimewindow;
	
	            if (this.useDashboardTimewindow) {
	                this.timeWindowConfig = angular.copy(options.dashboardTimewindow);
	            } else {
	                this.timeWindowConfig = angular.copy(options.timeWindowConfig);
	            }
	
	            this.subscriptionTimewindow = null;
	
	            this.loadingData = false;
	            this.displayLegend = false;
	            this.initAlarmSubscription().then(function success() {
	                deferred.resolve(subscription);
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            this.callbacks.onDataUpdated = this.callbacks.onDataUpdated || function () {};
	            this.callbacks.onDataUpdateError = this.callbacks.onDataUpdateError || function () {};
	            this.callbacks.dataLoading = this.callbacks.dataLoading || function () {};
	            this.callbacks.legendDataUpdated = this.callbacks.legendDataUpdated || function () {};
	            this.callbacks.timeWindowUpdated = this.callbacks.timeWindowUpdated || function () {};
	
	            this.datasources = this.ctx.utils.validateDatasources(options.datasources);
	            this.datasourceListeners = [];
	
	            /*
	             *   data = array of datasourceData
	             *   datasourceData = {
	             *   			tbDatasource,
	             *   			dataKey,     { name, config }
	             *   			data = array of [time, value]
	             *   }
	             */
	            this.data = [];
	            this.hiddenData = [];
	            this.originalTimewindow = null;
	            this.timeWindow = {};
	            this.useDashboardTimewindow = options.useDashboardTimewindow;
	            this.stateData = options.stateData;
	            if (this.useDashboardTimewindow) {
	                this.timeWindowConfig = angular.copy(options.dashboardTimewindow);
	            } else {
	                this.timeWindowConfig = angular.copy(options.timeWindowConfig);
	            }
	
	            this.subscriptionTimewindow = null;
	
	            this.units = options.units || '';
	            this.decimals = angular.isDefined(options.decimals) ? options.decimals : 2;
	
	            this.loadingData = false;
	
	            if (options.legendConfig) {
	                this.legendConfig = options.legendConfig;
	                this.legendData = {
	                    keys: [],
	                    data: []
	                };
	                this.displayLegend = true;
	            } else {
	                this.displayLegend = false;
	            }
	            this.caulculateLegendData = this.displayLegend && this.type === this.ctx.types.widgetType.timeseries.value && (this.legendConfig.showMin === true || this.legendConfig.showMax === true || this.legendConfig.showAvg === true || this.legendConfig.showTotal === true);
	            this.initDataSubscription().then(function success() {
	                deferred.resolve(subscription);
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	
	        return deferred.promise;
	    }
	
	    _createClass(Subscription, [{
	        key: 'getFirstEntityInfo',
	        value: function getFirstEntityInfo() {
	            var entityId;
	            var entityName;
	            if (this.type === this.ctx.types.widgetType.rpc.value) {
	                if (this.targetDeviceId) {
	                    entityId = {
	                        entityType: this.ctx.entityType.device,
	                        id: this.targetDeviceId
	                    };
	                    entityName = this.targetDeviceName;
	                }
	            } else if (this.type == this.ctx.types.widgetType.alarm.value) {
	                if (this.alarmSource && this.alarmSource.entityType && this.alarmSource.entityId) {
	                    entityId = {
	                        entityType: this.alarmSource.entityType,
	                        id: this.alarmSource.entityId
	                    };
	                    entityName = this.alarmSource.entityName;
	                }
	            } else {
	                for (var i = 0; i < this.datasources.length; i++) {
	                    var datasource = this.datasources[i];
	                    if (datasource && datasource.entityType && datasource.entityId) {
	                        entityId = {
	                            entityType: datasource.entityType,
	                            id: datasource.entityId
	                        };
	                        entityName = datasource.entityName;
	                        break;
	                    }
	                }
	            }
	            if (entityId) {
	                return {
	                    entityId: entityId,
	                    entityName: entityName
	                };
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: 'loadStDiff',
	        value: function loadStDiff() {
	            var _this = this;
	
	            var deferred = this.ctx.$q.defer();
	            if (this.ctx.getStDiff && this.timeWindow) {
	                this.ctx.getStDiff().then(function (stDiff) {
	                    _this.timeWindow.stDiff = stDiff;
	                    deferred.resolve();
	                }, function () {
	                    _this.timeWindow.stDiff = 0;
	                    deferred.resolve();
	                });
	            } else {
	                if (this.timeWindow) {
	                    this.timeWindow.stDiff = 0;
	                }
	                deferred.resolve();
	            }
	            return deferred.promise;
	        }
	    }, {
	        key: 'initAlarmSubscription',
	        value: function initAlarmSubscription() {
	            var deferred = this.ctx.$q.defer();
	            var subscription = this;
	            this.loadStDiff().then(function () {
	                if (!subscription.ctx.aliasController) {
	                    subscription.configureAlarmsData();
	                    deferred.resolve();
	                } else {
	                    subscription.ctx.aliasController.resolveAlarmSource(subscription.alarmSource).then(function success(alarmSource) {
	                        subscription.alarmSource = alarmSource;
	                        subscription.configureAlarmsData();
	                        deferred.resolve();
	                    }, function fail() {
	                        deferred.reject();
	                    });
	                }
	            });
	            return deferred.promise;
	        }
	    }, {
	        key: 'configureAlarmsData',
	        value: function configureAlarmsData() {
	            var subscription = this;
	            var registration;
	            if (this.useDashboardTimewindow) {
	                registration = this.ctx.$scope.$on('dashboardTimewindowChanged', function (event, newDashboardTimewindow) {
	                    if (!angular.equals(subscription.timeWindowConfig, newDashboardTimewindow) && newDashboardTimewindow) {
	                        subscription.timeWindowConfig = angular.copy(newDashboardTimewindow);
	                        subscription.update();
	                    }
	                });
	                this.registrations.push(registration);
	            } else {
	                this.startWatchingTimewindow();
	            }
	            registration = this.ctx.$scope.$watch(function () {
	                return subscription.alarmSearchStatus;
	            }, function (newAlarmSearchStatus, prevAlarmSearchStatus) {
	                if (!angular.equals(newAlarmSearchStatus, prevAlarmSearchStatus)) {
	                    subscription.update();
	                }
	            }, true);
	            this.registrations.push(registration);
	        }
	    }, {
	        key: 'initDataSubscription',
	        value: function initDataSubscription() {
	            var deferred = this.ctx.$q.defer();
	            var subscription = this;
	            this.loadStDiff().then(function () {
	                if (!subscription.ctx.aliasController) {
	                    subscription.configureData();
	                    deferred.resolve();
	                } else {
	                    subscription.ctx.aliasController.resolveDatasources(subscription.datasources).then(function success(datasources) {
	                        subscription.datasources = datasources;
	                        subscription.configureData();
	                        deferred.resolve();
	                    }, function fail() {
	                        deferred.reject();
	                    });
	                }
	            });
	            return deferred.promise;
	        }
	    }, {
	        key: 'configureData',
	        value: function configureData() {
	            var dataIndex = 0;
	            for (var i = 0; i < this.datasources.length; i++) {
	                var datasource = this.datasources[i];
	                for (var a = 0; a < datasource.dataKeys.length; a++) {
	                    var dataKey = datasource.dataKeys[a];
	                    dataKey.hidden = false;
	                    dataKey.pattern = angular.copy(dataKey.label);
	                    var datasourceData = {
	                        datasource: datasource,
	                        dataKey: dataKey,
	                        data: []
	                    };
	                    this.data.push(datasourceData);
	                    this.hiddenData.push({ data: [] });
	                    if (this.displayLegend) {
	                        var legendKey = {
	                            dataKey: dataKey,
	                            dataIndex: dataIndex++
	                        };
	                        this.legendData.keys.push(legendKey);
	                        var legendKeyData = {
	                            min: null,
	                            max: null,
	                            avg: null,
	                            total: null,
	                            hidden: false
	                        };
	                        this.legendData.data.push(legendKeyData);
	                    }
	                }
	            }
	
	            var subscription = this;
	            var registration;
	
	            if (this.displayLegend) {
	                this.legendData.keys = this.ctx.$filter('orderBy')(this.legendData.keys, '+label');
	                registration = this.ctx.$scope.$watch(function () {
	                    return subscription.legendData.keys;
	                }, function (newValue, oldValue) {
	                    for (var i = 0; i < newValue.length; i++) {
	                        if (newValue[i].dataKey.hidden != oldValue[i].dataKey.hidden) {
	                            subscription.updateDataVisibility(i);
	                        }
	                    }
	                }, true);
	                this.registrations.push(registration);
	            }
	
	            if (this.type === this.ctx.types.widgetType.timeseries.value) {
	                if (this.useDashboardTimewindow) {
	                    registration = this.ctx.$scope.$on('dashboardTimewindowChanged', function (event, newDashboardTimewindow) {
	                        if (!angular.equals(subscription.timeWindowConfig, newDashboardTimewindow) && newDashboardTimewindow) {
	                            subscription.timeWindowConfig = angular.copy(newDashboardTimewindow);
	                            subscription.update();
	                        }
	                    });
	                    this.registrations.push(registration);
	                } else {
	                    this.startWatchingTimewindow();
	                }
	            }
	        }
	    }, {
	        key: 'resetData',
	        value: function resetData() {
	            for (var i = 0; i < this.data.length; i++) {
	                this.data[i].data = [];
	                this.hiddenData[i].data = [];
	                if (this.displayLegend) {
	                    this.legendData.data[i].min = null;
	                    this.legendData.data[i].max = null;
	                    this.legendData.data[i].avg = null;
	                    this.legendData.data[i].total = null;
	                    this.legendData.data[i].hidden = false;
	                }
	            }
	            this.onDataUpdated();
	        }
	    }, {
	        key: 'startWatchingTimewindow',
	        value: function startWatchingTimewindow() {
	            var subscription = this;
	            this.timeWindowWatchRegistration = this.ctx.$scope.$watch(function () {
	                return subscription.timeWindowConfig;
	            }, function (newTimewindow, prevTimewindow) {
	                if (!angular.equals(newTimewindow, prevTimewindow)) {
	                    subscription.update();
	                }
	            }, true);
	            this.registrations.push(this.timeWindowWatchRegistration);
	        }
	    }, {
	        key: 'stopWatchingTimewindow',
	        value: function stopWatchingTimewindow() {
	            if (this.timeWindowWatchRegistration) {
	                this.timeWindowWatchRegistration();
	                var index = this.registrations.indexOf(this.timeWindowWatchRegistration);
	                if (index > -1) {
	                    this.registrations.splice(index, 1);
	                }
	            }
	        }
	    }, {
	        key: 'initRpc',
	        value: function initRpc() {
	            var deferred = this.ctx.$q.defer();
	            if (this.targetDeviceAliasIds && this.targetDeviceAliasIds.length > 0) {
	                this.targetDeviceAliasId = this.targetDeviceAliasIds[0];
	                var subscription = this;
	                this.ctx.aliasController.getAliasInfo(this.targetDeviceAliasId).then(function success(aliasInfo) {
	                    if (aliasInfo.currentEntity && aliasInfo.currentEntity.entityType == subscription.ctx.types.entityType.device) {
	                        subscription.targetDeviceId = aliasInfo.currentEntity.id;
	                        subscription.targetDeviceName = aliasInfo.currentEntity.name;
	                        if (subscription.targetDeviceId) {
	                            subscription.rpcEnabled = true;
	                        } else {
	                            subscription.rpcEnabled = subscription.ctx.$scope.widgetEditMode ? true : false;
	                        }
	                        subscription.callbacks.rpcStateChanged(subscription);
	                        deferred.resolve();
	                    } else {
	                        subscription.rpcEnabled = false;
	                        subscription.callbacks.rpcStateChanged(subscription);
	                        deferred.resolve();
	                    }
	                }, function fail() {
	                    subscription.rpcEnabled = false;
	                    subscription.callbacks.rpcStateChanged(subscription);
	                    deferred.resolve();
	                });
	            } else {
	                if (this.targetDeviceIds && this.targetDeviceIds.length > 0) {
	                    this.targetDeviceId = this.targetDeviceIds[0];
	                }
	                if (this.targetDeviceId) {
	                    this.rpcEnabled = true;
	                } else {
	                    this.rpcEnabled = this.ctx.$scope.widgetEditMode ? true : false;
	                }
	                this.callbacks.rpcStateChanged(this);
	                deferred.resolve();
	            }
	            return deferred.promise;
	        }
	    }, {
	        key: 'clearRpcError',
	        value: function clearRpcError() {
	            this.rpcRejection = null;
	            this.rpcErrorText = null;
	            this.callbacks.onRpcErrorCleared(this);
	        }
	    }, {
	        key: 'sendOneWayCommand',
	        value: function sendOneWayCommand(method, params, timeout) {
	            return this.sendCommand(true, method, params, timeout);
	        }
	    }, {
	        key: 'sendTwoWayCommand',
	        value: function sendTwoWayCommand(method, params, timeout) {
	            return this.sendCommand(false, method, params, timeout);
	        }
	    }, {
	        key: 'sendCommand',
	        value: function sendCommand(oneWayElseTwoWay, method, params, timeout) {
	            if (!this.rpcEnabled) {
	                return this.ctx.$q.reject();
	            }
	
	            if (this.rpcRejection && this.rpcRejection.status !== 408) {
	                this.rpcRejection = null;
	                this.rpcErrorText = null;
	                this.callbacks.onRpcErrorCleared(this);
	            }
	
	            var subscription = this;
	
	            var requestBody = {
	                method: method,
	                params: params
	            };
	
	            if (timeout && timeout > 0) {
	                requestBody.timeout = timeout;
	            }
	
	            var deferred = this.ctx.$q.defer();
	            this.executingRpcRequest = true;
	            this.callbacks.rpcStateChanged(this);
	            if (this.ctx.$scope.widgetEditMode) {
	                this.ctx.$timeout(function () {
	                    subscription.executingRpcRequest = false;
	                    subscription.callbacks.rpcStateChanged(subscription);
	                    if (oneWayElseTwoWay) {
	                        deferred.resolve();
	                    } else {
	                        deferred.resolve(requestBody);
	                    }
	                }, 500);
	            } else {
	                this.executingPromises.push(deferred.promise);
	                var targetSendFunction = oneWayElseTwoWay ? this.ctx.deviceService.sendOneWayRpcCommand : this.ctx.deviceService.sendTwoWayRpcCommand;
	                targetSendFunction(this.targetDeviceId, requestBody).then(function success(responseBody) {
	                    subscription.rpcRejection = null;
	                    subscription.rpcErrorText = null;
	                    var index = subscription.executingPromises.indexOf(deferred.promise);
	                    if (index >= 0) {
	                        subscription.executingPromises.splice(index, 1);
	                    }
	                    subscription.executingRpcRequest = subscription.executingPromises.length > 0;
	                    subscription.callbacks.onRpcSuccess(subscription);
	                    deferred.resolve(responseBody);
	                }, function fail(rejection) {
	                    var index = subscription.executingPromises.indexOf(deferred.promise);
	                    if (index >= 0) {
	                        subscription.executingPromises.splice(index, 1);
	                    }
	                    subscription.executingRpcRequest = subscription.executingPromises.length > 0;
	                    subscription.callbacks.rpcStateChanged(subscription);
	                    if (!subscription.executingRpcRequest || rejection.status === 408) {
	                        subscription.rpcRejection = rejection;
	                        if (rejection.status === 408) {
	                            subscription.rpcErrorText = 'Device is offline.';
	                        } else {
	                            subscription.rpcErrorText = 'Error : ' + rejection.status + ' - ' + rejection.statusText;
	                            if (rejection.data && rejection.data.length > 0) {
	                                subscription.rpcErrorText += '</br>';
	                                subscription.rpcErrorText += rejection.data;
	                            }
	                        }
	                        subscription.callbacks.onRpcFailed(subscription);
	                    }
	                    deferred.reject(rejection);
	                });
	            }
	            return deferred.promise;
	        }
	    }, {
	        key: 'updateDataVisibility',
	        value: function updateDataVisibility(index) {
	            var hidden = this.legendData.keys[index].dataKey.hidden;
	            if (hidden) {
	                this.hiddenData[index].data = this.data[index].data;
	                this.data[index].data = [];
	            } else {
	                this.data[index].data = this.hiddenData[index].data;
	                this.hiddenData[index].data = [];
	            }
	            this.onDataUpdated();
	        }
	    }, {
	        key: 'onAliasesChanged',
	        value: function onAliasesChanged(aliasIds) {
	            if (this.type === this.ctx.types.widgetType.rpc.value) {
	                return this.checkRpcTarget(aliasIds);
	            } else if (this.type === this.ctx.types.widgetType.alarm.value) {
	                return this.checkAlarmSource(aliasIds);
	            } else {
	                return this.checkSubscriptions(aliasIds);
	            }
	        }
	    }, {
	        key: 'onDataUpdated',
	        value: function onDataUpdated(apply) {
	            if (this.cafs['dataUpdated']) {
	                this.cafs['dataUpdated']();
	                this.cafs['dataUpdated'] = null;
	            }
	            var subscription = this;
	            this.cafs['dataUpdated'] = this.ctx.tbRaf(function () {
	                try {
	                    subscription.callbacks.onDataUpdated(subscription, apply);
	                } catch (e) {
	                    subscription.callbacks.onDataUpdateError(subscription, e);
	                }
	            });
	            if (apply) {
	                this.ctx.$scope.$digest();
	            }
	        }
	    }, {
	        key: 'updateTimewindowConfig',
	        value: function updateTimewindowConfig(newTimewindow) {
	            this.timeWindowConfig = newTimewindow;
	        }
	    }, {
	        key: 'onResetTimewindow',
	        value: function onResetTimewindow() {
	            if (this.useDashboardTimewindow) {
	                this.ctx.dashboardTimewindowApi.onResetTimewindow();
	            } else {
	                if (this.originalTimewindow) {
	                    this.stopWatchingTimewindow();
	                    this.timeWindowConfig = angular.copy(this.originalTimewindow);
	                    this.originalTimewindow = null;
	                    this.callbacks.timeWindowUpdated(this, this.timeWindowConfig);
	                    this.update();
	                    this.startWatchingTimewindow();
	                }
	            }
	        }
	    }, {
	        key: 'onUpdateTimewindow',
	        value: function onUpdateTimewindow(startTimeMs, endTimeMs) {
	            if (this.useDashboardTimewindow) {
	                this.ctx.dashboardTimewindowApi.onUpdateTimewindow(startTimeMs, endTimeMs);
	            } else {
	                this.stopWatchingTimewindow();
	                if (!this.originalTimewindow) {
	                    this.originalTimewindow = angular.copy(this.timeWindowConfig);
	                }
	                this.timeWindowConfig = this.ctx.timeService.toHistoryTimewindow(this.timeWindowConfig, startTimeMs, endTimeMs);
	                this.callbacks.timeWindowUpdated(this, this.timeWindowConfig);
	                this.update();
	                this.startWatchingTimewindow();
	            }
	        }
	    }, {
	        key: 'notifyDataLoading',
	        value: function notifyDataLoading() {
	            this.loadingData = true;
	            this.callbacks.dataLoading(this);
	        }
	    }, {
	        key: 'notifyDataLoaded',
	        value: function notifyDataLoaded() {
	            this.loadingData = false;
	            this.callbacks.dataLoading(this);
	        }
	    }, {
	        key: 'updateTimewindow',
	        value: function updateTimewindow() {
	            this.timeWindow.interval = this.subscriptionTimewindow.aggregation.interval || 1000;
	            if (this.subscriptionTimewindow.realtimeWindowMs) {
	                this.timeWindow.maxTime = new Date().getTime() + this.timeWindow.stDiff;
	                this.timeWindow.minTime = this.timeWindow.maxTime - this.subscriptionTimewindow.realtimeWindowMs;
	            } else if (this.subscriptionTimewindow.fixedWindow) {
	                this.timeWindow.maxTime = this.subscriptionTimewindow.fixedWindow.endTimeMs;
	                this.timeWindow.minTime = this.subscriptionTimewindow.fixedWindow.startTimeMs;
	            }
	        }
	    }, {
	        key: 'updateRealtimeSubscription',
	        value: function updateRealtimeSubscription(subscriptionTimewindow) {
	            if (subscriptionTimewindow) {
	                this.subscriptionTimewindow = subscriptionTimewindow;
	            } else {
	                this.subscriptionTimewindow = this.ctx.timeService.createSubscriptionTimewindow(this.timeWindowConfig, this.timeWindow.stDiff, this.stateData);
	            }
	            this.updateTimewindow();
	            return this.subscriptionTimewindow;
	        }
	    }, {
	        key: 'dataUpdated',
	        value: function dataUpdated(sourceData, datasourceIndex, dataKeyIndex, apply) {
	            this.notifyDataLoaded();
	            var update = true;
	            var currentData;
	            if (this.displayLegend && this.legendData.keys[datasourceIndex + dataKeyIndex].dataKey.hidden) {
	                currentData = this.hiddenData[datasourceIndex + dataKeyIndex];
	            } else {
	                currentData = this.data[datasourceIndex + dataKeyIndex];
	            }
	            if (this.type === this.ctx.types.widgetType.latest.value) {
	                var prevData = currentData.data;
	                if (!sourceData.data.length) {
	                    update = false;
	                } else if (prevData && prevData[0] && prevData[0].length > 1 && sourceData.data.length > 0) {
	                    var prevTs = prevData[0][0];
	                    var prevValue = prevData[0][1];
	                    if (prevTs === sourceData.data[0][0] && prevValue === sourceData.data[0][1]) {
	                        update = false;
	                    }
	                }
	            }
	            if (update) {
	                if (this.subscriptionTimewindow && this.subscriptionTimewindow.realtimeWindowMs) {
	                    this.updateTimewindow();
	                }
	                currentData.data = sourceData.data;
	                if (this.caulculateLegendData) {
	                    this.updateLegend(datasourceIndex + dataKeyIndex, sourceData.data, apply);
	                }
	                this.onDataUpdated(apply);
	            }
	        }
	    }, {
	        key: 'alarmsUpdated',
	        value: function alarmsUpdated(alarms, apply) {
	            this.notifyDataLoaded();
	            var updated = !this.alarms || !angular.equals(this.alarms, alarms);
	            this.alarms = alarms;
	            if (this.subscriptionTimewindow && this.subscriptionTimewindow.realtimeWindowMs) {
	                this.updateTimewindow();
	            }
	            if (updated) {
	                this.onDataUpdated(apply);
	            }
	        }
	    }, {
	        key: 'updateLegend',
	        value: function updateLegend(dataIndex, data, apply) {
	            var dataKey = this.legendData.keys[dataIndex].dataKey;
	            var decimals = angular.isDefined(dataKey.decimals) ? dataKey.decimals : this.decimals;
	            var units = dataKey.units && dataKey.units.length ? dataKey.units : this.units;
	            var legendKeyData = this.legendData.data[dataIndex];
	            if (this.legendConfig.showMin) {
	                legendKeyData.min = this.ctx.widgetUtils.formatValue(calculateMin(data), decimals, units);
	            }
	            if (this.legendConfig.showMax) {
	                legendKeyData.max = this.ctx.widgetUtils.formatValue(calculateMax(data), decimals, units);
	            }
	            if (this.legendConfig.showAvg) {
	                legendKeyData.avg = this.ctx.widgetUtils.formatValue(calculateAvg(data), decimals, units);
	            }
	            if (this.legendConfig.showTotal) {
	                legendKeyData.total = this.ctx.widgetUtils.formatValue(calculateTotal(data), decimals, units);
	            }
	            this.callbacks.legendDataUpdated(this, apply !== false);
	        }
	    }, {
	        key: 'update',
	        value: function update() {
	            this.unsubscribe();
	            this.subscribe();
	        }
	    }, {
	        key: 'subscribe',
	        value: function subscribe() {
	            if (this.type === this.ctx.types.widgetType.rpc.value) {
	                return;
	            }
	            if (this.type === this.ctx.types.widgetType.alarm.value) {
	                this.alarmsSubscribe();
	            } else {
	                this.notifyDataLoading();
	                if (this.type === this.ctx.types.widgetType.timeseries.value && this.timeWindowConfig) {
	                    this.updateRealtimeSubscription();
	                    if (this.subscriptionTimewindow.fixedWindow) {
	                        this.onDataUpdated();
	                    }
	                }
	                var index = 0;
	                for (var i = 0; i < this.datasources.length; i++) {
	                    var datasource = this.datasources[i];
	                    if (angular.isFunction(datasource)) continue;
	
	                    var subscription = this;
	
	                    var listener = {
	                        subscriptionType: this.type,
	                        subscriptionTimewindow: this.subscriptionTimewindow,
	                        datasource: datasource,
	                        entityType: datasource.entityType,
	                        entityId: datasource.entityId,
	                        dataUpdated: function dataUpdated(data, datasourceIndex, dataKeyIndex, apply) {
	                            subscription.dataUpdated(data, datasourceIndex, dataKeyIndex, apply);
	                        },
	                        updateRealtimeSubscription: function updateRealtimeSubscription() {
	                            this.subscriptionTimewindow = subscription.updateRealtimeSubscription();
	                            return this.subscriptionTimewindow;
	                        },
	                        setRealtimeSubscription: function setRealtimeSubscription(subscriptionTimewindow) {
	                            subscription.updateRealtimeSubscription(angular.copy(subscriptionTimewindow));
	                        },
	                        datasourceIndex: index
	                    };
	
	                    for (var a = 0; a < datasource.dataKeys.length; a++) {
	                        this.data[index + a].data = [];
	                    }
	
	                    index += datasource.dataKeys.length;
	
	                    this.datasourceListeners.push(listener);
	
	                    if (datasource.dataKeys.length) {
	                        this.ctx.datasourceService.subscribeToDatasource(listener);
	                    }
	
	                    var forceUpdate = false;
	                    if (datasource.unresolvedStateEntity || !datasource.dataKeys.length || datasource.type === this.ctx.types.datasourceType.entity && !datasource.entityId) {
	                        forceUpdate = true;
	                    }
	
	                    if (forceUpdate) {
	                        this.notifyDataLoaded();
	                        this.onDataUpdated();
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'alarmsSubscribe',
	        value: function alarmsSubscribe() {
	            this.notifyDataLoading();
	            if (this.timeWindowConfig) {
	                this.updateRealtimeSubscription();
	                if (this.subscriptionTimewindow.fixedWindow) {
	                    this.onDataUpdated();
	                }
	            }
	            var subscription = this;
	            this.alarmSourceListener = {
	                subscriptionTimewindow: this.subscriptionTimewindow,
	                alarmSource: this.alarmSource,
	                alarmSearchStatus: this.alarmSearchStatus,
	                alarmsPollingInterval: this.alarmsPollingInterval,
	                alarmsUpdated: function alarmsUpdated(alarms, apply) {
	                    subscription.alarmsUpdated(alarms, apply);
	                }
	            };
	            this.alarms = null;
	
	            this.ctx.alarmService.subscribeForAlarms(this.alarmSourceListener);
	
	            var forceUpdate = false;
	            if (this.alarmSource.unresolvedStateEntity || this.alarmSource.type === this.ctx.types.datasourceType.entity && !this.alarmSource.entityId) {
	                forceUpdate = true;
	            }
	
	            if (forceUpdate) {
	                this.notifyDataLoaded();
	                this.onDataUpdated();
	            }
	        }
	    }, {
	        key: 'unsubscribe',
	        value: function unsubscribe() {
	            if (this.type !== this.ctx.types.widgetType.rpc.value) {
	                if (this.type == this.ctx.types.widgetType.alarm.value) {
	                    this.alarmsUnsubscribe();
	                } else {
	                    for (var i = 0; i < this.datasourceListeners.length; i++) {
	                        var listener = this.datasourceListeners[i];
	                        this.ctx.datasourceService.unsubscribeFromDatasource(listener);
	                    }
	                    this.datasourceListeners = [];
	                    this.resetData();
	                }
	            }
	        }
	    }, {
	        key: 'alarmsUnsubscribe',
	        value: function alarmsUnsubscribe() {
	            if (this.alarmSourceListener) {
	                this.ctx.alarmService.unsubscribeFromAlarms(this.alarmSourceListener);
	                this.alarmSourceListener = null;
	            }
	        }
	    }, {
	        key: 'checkRpcTarget',
	        value: function checkRpcTarget(aliasIds) {
	            if (aliasIds.indexOf(this.targetDeviceAliasId) > -1) {
	                return true;
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'checkAlarmSource',
	        value: function checkAlarmSource(aliasIds) {
	            if (this.alarmSource && this.alarmSource.entityAliasId) {
	                return aliasIds.indexOf(this.alarmSource.entityAliasId) > -1;
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'checkSubscriptions',
	        value: function checkSubscriptions(aliasIds) {
	            var subscriptionsChanged = false;
	            for (var i = 0; i < this.datasourceListeners.length; i++) {
	                var listener = this.datasourceListeners[i];
	                if (listener.datasource.entityAliasId) {
	                    if (aliasIds.indexOf(listener.datasource.entityAliasId) > -1) {
	                        subscriptionsChanged = true;
	                        break;
	                    }
	                }
	            }
	            return subscriptionsChanged;
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.unsubscribe();
	            for (var cafId in this.cafs) {
	                if (this.cafs[cafId]) {
	                    this.cafs[cafId]();
	                    this.cafs[cafId] = null;
	                }
	            }
	            this.registrations.forEach(function (registration) {
	                registration();
	            });
	            this.registrations = [];
	        }
	    }]);
	
	    return Subscription;
	}();
	
	exports.default = Subscription;
	
	
	function calculateMin(data) {
	    if (data.length > 0) {
	        var result = Number(data[0][1]);
	        for (var i = 1; i < data.length; i++) {
	            result = Math.min(result, Number(data[i][1]));
	        }
	        return result;
	    } else {
	        return null;
	    }
	}
	
	function calculateMax(data) {
	    if (data.length > 0) {
	        var result = Number(data[0][1]);
	        for (var i = 1; i < data.length; i++) {
	            result = Math.max(result, Number(data[i][1]));
	        }
	        return result;
	    } else {
	        return null;
	    }
	}
	
	function calculateAvg(data) {
	    if (data.length > 0) {
	        return calculateTotal(data) / data.length;
	    } else {
	        return null;
	    }
	}
	
	function calculateTotal(data) {
	    if (data.length > 0) {
	        var result = 0;
	        for (var i = 0; i < data.length; i++) {
	            result += Number(data[i][1]);
	        }
	        return result;
	    } else {
	        return null;
	    }
	}

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	TelemetryWebsocketService.$inject = ["$rootScope", "$websocket", "$timeout", "$window", "types", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(268);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.telemetryWebsocket', [_types2.default]).factory('telemetryWebsocketService', TelemetryWebsocketService).name;
	
	
	var RECONNECT_INTERVAL = 2000;
	var WS_IDLE_TIMEOUT = 90000;
	
	var MAX_PUBLISH_COMMANDS = 10;
	
	/*@ngInject*/
	function TelemetryWebsocketService($rootScope, $websocket, $timeout, $window, types, userService) {
	
	    var isOpening = false,
	        isOpened = false,
	        isActive = false,
	        isReconnect = false,
	        reconnectSubscribers = [],
	        lastCmdId = 0,
	        subscribers = {},
	        subscribersCount = 0,
	        commands = {},
	        cmdsWrapper = {
	        tsSubCmds: [],
	        historyCmds: [],
	        attrSubCmds: []
	    },
	        telemetryUri,
	        dataStream,
	        location = $window.location,
	        socketCloseTimer,
	        reconnectTimer;
	
	    var port = location.port;
	    if (location.protocol === "https:") {
	        if (!port) {
	            port = "443";
	        }
	        telemetryUri = "wss:";
	    } else {
	        if (!port) {
	            port = "80";
	        }
	        telemetryUri = "ws:";
	    }
	    telemetryUri += "//" + location.hostname + ":" + port;
	    telemetryUri += "/api/ws/plugins/telemetry";
	
	    var service = {
	        subscribe: subscribe,
	        unsubscribe: unsubscribe
	    };
	
	    $rootScope.telemetryWsLogoutHandle = $rootScope.$on('unauthenticated', function (event, doLogout) {
	        if (doLogout) {
	            reset(true);
	        }
	    });
	
	    return service;
	
	    function publishCommands() {
	        while (isOpened && hasCommands()) {
	            dataStream.send(preparePublishCommands()).then(function () {
	                checkToClose();
	            });
	        }
	        tryOpenSocket();
	    }
	
	    function hasCommands() {
	        return cmdsWrapper.tsSubCmds.length > 0 || cmdsWrapper.historyCmds.length > 0 || cmdsWrapper.attrSubCmds.length > 0;
	    }
	
	    function preparePublishCommands() {
	        var preparedWrapper = {};
	        var leftCount = MAX_PUBLISH_COMMANDS;
	        preparedWrapper.tsSubCmds = popCmds(cmdsWrapper.tsSubCmds, leftCount);
	        leftCount -= preparedWrapper.tsSubCmds.length;
	        preparedWrapper.historyCmds = popCmds(cmdsWrapper.historyCmds, leftCount);
	        leftCount -= preparedWrapper.historyCmds.length;
	        preparedWrapper.attrSubCmds = popCmds(cmdsWrapper.attrSubCmds, leftCount);
	        return preparedWrapper;
	    }
	
	    function popCmds(cmds, leftCount) {
	        var toPublish = Math.min(cmds.length, leftCount);
	        if (toPublish > 0) {
	            return cmds.splice(0, toPublish);
	        } else {
	            return [];
	        }
	    }
	
	    function onError() /*message*/{
	        isOpening = false;
	    }
	
	    function onOpen() {
	        isOpening = false;
	        isOpened = true;
	        if (reconnectTimer) {
	            $timeout.cancel(reconnectTimer);
	            reconnectTimer = null;
	        }
	        if (isReconnect) {
	            isReconnect = false;
	            for (var r = 0; r < reconnectSubscribers.length; r++) {
	                var reconnectSubscriber = reconnectSubscribers[r];
	                if (reconnectSubscriber.onReconnected) {
	                    reconnectSubscriber.onReconnected();
	                }
	                subscribe(reconnectSubscriber);
	            }
	            reconnectSubscribers = [];
	        } else {
	            publishCommands();
	        }
	    }
	
	    function onClose() {
	        isOpening = false;
	        isOpened = false;
	        if (isActive) {
	            if (!isReconnect) {
	                reconnectSubscribers = [];
	                for (var id in subscribers) {
	                    var subscriber = subscribers[id];
	                    if (reconnectSubscribers.indexOf(subscriber) === -1) {
	                        reconnectSubscribers.push(subscriber);
	                    }
	                }
	                reset(false);
	                isReconnect = true;
	            }
	            if (reconnectTimer) {
	                $timeout.cancel(reconnectTimer);
	            }
	            reconnectTimer = $timeout(tryOpenSocket, RECONNECT_INTERVAL, false);
	        }
	    }
	
	    function onMessage(message) {
	        if (message.data) {
	            var data = angular.fromJson(message.data);
	            if (data.subscriptionId) {
	                var subscriber = subscribers[data.subscriptionId];
	                if (subscriber && data) {
	                    var keys = fetchKeys(data.subscriptionId);
	                    if (!data.data) {
	                        data.data = {};
	                    }
	                    for (var k = 0; k < keys.length; k++) {
	                        var key = keys[k];
	                        if (!data.data[key]) {
	                            data.data[key] = [];
	                        }
	                    }
	                    subscriber.onData(data, data.subscriptionId);
	                }
	            }
	        }
	        checkToClose();
	    }
	
	    function fetchKeys(subscriptionId) {
	        var command = commands[subscriptionId];
	        if (command && command.keys && command.keys.length > 0) {
	            return command.keys.split(",");
	        } else {
	            return [];
	        }
	    }
	
	    function nextCmdId() {
	        lastCmdId++;
	        return lastCmdId;
	    }
	
	    function subscribe(subscriber) {
	        isActive = true;
	        var cmdId;
	        if (angular.isDefined(subscriber.subscriptionCommands)) {
	            for (var i = 0; i < subscriber.subscriptionCommands.length; i++) {
	                var subscriptionCommand = subscriber.subscriptionCommands[i];
	                cmdId = nextCmdId();
	                subscribers[cmdId] = subscriber;
	                subscriptionCommand.cmdId = cmdId;
	                commands[cmdId] = subscriptionCommand;
	                if (subscriber.type === types.dataKeyType.timeseries) {
	                    cmdsWrapper.tsSubCmds.push(subscriptionCommand);
	                } else if (subscriber.type === types.dataKeyType.attribute) {
	                    cmdsWrapper.attrSubCmds.push(subscriptionCommand);
	                }
	            }
	        }
	        if (angular.isDefined(subscriber.historyCommands)) {
	            for (i = 0; i < subscriber.historyCommands.length; i++) {
	                var historyCommand = subscriber.historyCommands[i];
	                cmdId = nextCmdId();
	                subscribers[cmdId] = subscriber;
	                historyCommand.cmdId = cmdId;
	                commands[cmdId] = historyCommand;
	                cmdsWrapper.historyCmds.push(historyCommand);
	            }
	        }
	        subscribersCount++;
	        publishCommands();
	    }
	
	    function unsubscribe(subscriber) {
	        if (isActive) {
	            var cmdId = null;
	            if (subscriber.subscriptionCommands) {
	                for (var i = 0; i < subscriber.subscriptionCommands.length; i++) {
	                    var subscriptionCommand = subscriber.subscriptionCommands[i];
	                    subscriptionCommand.unsubscribe = true;
	                    if (subscriber.type === types.dataKeyType.timeseries) {
	                        cmdsWrapper.tsSubCmds.push(subscriptionCommand);
	                    } else if (subscriber.type === types.dataKeyType.attribute) {
	                        cmdsWrapper.attrSubCmds.push(subscriptionCommand);
	                    }
	                    cmdId = subscriptionCommand.cmdId;
	                    if (cmdId) {
	                        if (subscribers[cmdId]) {
	                            delete subscribers[cmdId];
	                        }
	                        if (commands[cmdId]) {
	                            delete commands[cmdId];
	                        }
	                    }
	                }
	            }
	            if (subscriber.historyCommands) {
	                for (i = 0; i < subscriber.historyCommands.length; i++) {
	                    var historyCommand = subscriber.historyCommands[i];
	                    cmdId = historyCommand.cmdId;
	                    if (cmdId) {
	                        if (subscribers[cmdId]) {
	                            delete subscribers[cmdId];
	                        }
	                        if (commands[cmdId]) {
	                            delete commands[cmdId];
	                        }
	                    }
	                }
	            }
	            var index = reconnectSubscribers.indexOf(subscriber);
	            if (index > -1) {
	                reconnectSubscribers.splice(index, 1);
	            }
	            subscribersCount--;
	            publishCommands();
	        }
	    }
	
	    function checkToClose() {
	        if (subscribersCount === 0 && isOpened) {
	            if (!socketCloseTimer) {
	                socketCloseTimer = $timeout(closeSocket, WS_IDLE_TIMEOUT, false);
	            }
	        }
	    }
	
	    function tryOpenSocket() {
	        if (isActive) {
	            if (!isOpened && !isOpening) {
	                isOpening = true;
	                if (userService.isJwtTokenValid()) {
	                    openSocket(userService.getJwtToken());
	                } else {
	                    userService.refreshJwtToken().then(function success() {
	                        openSocket(userService.getJwtToken());
	                    }, function fail() {
	                        isOpening = false;
	                        $rootScope.$broadcast('unauthenticated');
	                    });
	                }
	            }
	            if (socketCloseTimer) {
	                $timeout.cancel(socketCloseTimer);
	                socketCloseTimer = null;
	            }
	        }
	    }
	
	    function openSocket(token) {
	        dataStream = $websocket(telemetryUri + '?token=' + token);
	        dataStream.onError(onError);
	        dataStream.onOpen(onOpen);
	        dataStream.onClose(onClose);
	        dataStream.onMessage(onMessage, { autoApply: false });
	    }
	
	    function closeSocket() {
	        isActive = false;
	        if (isOpened) {
	            dataStream.close();
	        }
	    }
	
	    function reset(close) {
	        if (socketCloseTimer) {
	            $timeout.cancel(socketCloseTimer);
	            socketCloseTimer = null;
	        }
	        lastCmdId = 0;
	        subscribers = {};
	        subscribersCount = 0;
	        commands = {};
	        cmdsWrapper.tsSubCmds = [];
	        cmdsWrapper.historyCmds = [];
	        cmdsWrapper.attrSubCmds = [];
	        if (close) {
	            closeSocket();
	        }
	    }
	}

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	'use strict';
	
	TenantService.$inject = ["$http", "$q"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.tenant', []).factory('tenantService', TenantService).name;
	
	/*@ngInject*/
	
	function TenantService($http, $q) {
	
	    var service = {
	        deleteTenant: deleteTenant,
	        getTenant: getTenant,
	        getTenants: getTenants,
	        saveTenant: saveTenant
	    };
	
	    return service;
	
	    function getTenants(pageLink, config) {
	        var deferred = $q.defer();
	        var url = '/api/tenants?limit=' + pageLink.limit;
	        if (angular.isDefined(pageLink.textSearch)) {
	            url += '&textSearch=' + pageLink.textSearch;
	        }
	        if (angular.isDefined(pageLink.idOffset)) {
	            url += '&idOffset=' + pageLink.idOffset;
	        }
	        if (angular.isDefined(pageLink.textOffset)) {
	            url += '&textOffset=' + pageLink.textOffset;
	        }
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function getTenant(tenantId, config) {
	        var deferred = $q.defer();
	        var url = '/api/tenant/' + tenantId;
	        $http.get(url, config).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function saveTenant(tenant) {
	        var deferred = $q.defer();
	        var url = '/api/tenant';
	        $http.post(url, tenant).then(function success(response) {
	            deferred.resolve(response.data);
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	
	    function deleteTenant(tenantId) {
	        var deferred = $q.defer();
	        var url = '/api/tenant/' + tenantId;
	        $http.delete(url).then(function success() {
	            deferred.resolve();
	        }, function fail(response) {
	            deferred.reject(response.data);
	        });
	        return deferred.promise;
	    }
	}

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	'use strict';
	
	TimeService.$inject = ["$translate", "$http", "$q", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.api.time', []).factory('timeService', TimeService).name;
	
	
	var SECOND = 1000;
	var MINUTE = 60 * SECOND;
	var HOUR = 60 * MINUTE;
	var DAY = 24 * HOUR;
	
	var MIN_INTERVAL = SECOND;
	var MAX_INTERVAL = 365 * 20 * DAY;
	
	var MIN_LIMIT = 10;
	//const AVG_LIMIT = 200;
	//const MAX_LIMIT = 500;
	
	/*@ngInject*/
	function TimeService($translate, $http, $q, types) {
	
	    var predefIntervals;
	    var maxDatapointsLimit;
	
	    var service = {
	        loadMaxDatapointsLimit: loadMaxDatapointsLimit,
	        minIntervalLimit: minIntervalLimit,
	        maxIntervalLimit: maxIntervalLimit,
	        boundMinInterval: boundMinInterval,
	        boundMaxInterval: boundMaxInterval,
	        getIntervals: getIntervals,
	        matchesExistingInterval: matchesExistingInterval,
	        boundToPredefinedInterval: boundToPredefinedInterval,
	        defaultTimewindow: defaultTimewindow,
	        toHistoryTimewindow: toHistoryTimewindow,
	        createSubscriptionTimewindow: createSubscriptionTimewindow,
	        getMaxDatapointsLimit: function getMaxDatapointsLimit() {
	            return maxDatapointsLimit;
	        },
	        getMinDatapointsLimit: function getMinDatapointsLimit() {
	            return MIN_LIMIT;
	        }
	    };
	
	    return service;
	
	    function loadMaxDatapointsLimit() {
	        var deferred = $q.defer();
	        var url = '/api/dashboard/maxDatapointsLimit';
	        $http.get(url, { ignoreLoading: true }).then(function success(response) {
	            maxDatapointsLimit = response.data;
	            if (!maxDatapointsLimit || maxDatapointsLimit <= MIN_LIMIT) {
	                maxDatapointsLimit = MIN_LIMIT + 1;
	            }
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function minIntervalLimit(timewindow) {
	        var min = timewindow / 500;
	        return boundMinInterval(min);
	    }
	
	    function avgInterval(timewindow) {
	        var avg = timewindow / 200;
	        return boundMinInterval(avg);
	    }
	
	    function maxIntervalLimit(timewindow) {
	        var max = timewindow / MIN_LIMIT;
	        return boundMaxInterval(max);
	    }
	
	    function boundMinInterval(min) {
	        return toBound(min, MIN_INTERVAL, MAX_INTERVAL, MIN_INTERVAL);
	    }
	
	    function boundMaxInterval(max) {
	        return toBound(max, MIN_INTERVAL, MAX_INTERVAL, MAX_INTERVAL);
	    }
	
	    function toBound(value, min, max, defValue) {
	        if (angular.isDefined(value)) {
	            value = Math.max(value, min);
	            value = Math.min(value, max);
	            return value;
	        } else {
	            return defValue;
	        }
	    }
	
	    function getIntervals(min, max) {
	        min = boundMinInterval(min);
	        max = boundMaxInterval(max);
	        var intervals = [];
	        initPredefIntervals();
	        for (var i in predefIntervals) {
	            var interval = predefIntervals[i];
	            if (interval.value >= min && interval.value <= max) {
	                intervals.push(interval);
	            }
	        }
	        return intervals;
	    }
	
	    function initPredefIntervals() {
	        if (!predefIntervals) {
	            predefIntervals = [{
	                name: $translate.instant('timeinterval.seconds-interval', { seconds: 1 }, 'messageformat'),
	                value: 1 * SECOND
	            }, {
	                name: $translate.instant('timeinterval.seconds-interval', { seconds: 5 }, 'messageformat'),
	                value: 5 * SECOND
	            }, {
	                name: $translate.instant('timeinterval.seconds-interval', { seconds: 10 }, 'messageformat'),
	                value: 10 * SECOND
	            }, {
	                name: $translate.instant('timeinterval.seconds-interval', { seconds: 15 }, 'messageformat'),
	                value: 15 * SECOND
	            }, {
	                name: $translate.instant('timeinterval.seconds-interval', { seconds: 30 }, 'messageformat'),
	                value: 30 * SECOND
	            }, {
	                name: $translate.instant('timeinterval.minutes-interval', { minutes: 1 }, 'messageformat'),
	                value: 1 * MINUTE
	            }, {
	                name: $translate.instant('timeinterval.minutes-interval', { minutes: 2 }, 'messageformat'),
	                value: 2 * MINUTE
	            }, {
	                name: $translate.instant('timeinterval.minutes-interval', { minutes: 5 }, 'messageformat'),
	                value: 5 * MINUTE
	            }, {
	                name: $translate.instant('timeinterval.minutes-interval', { minutes: 10 }, 'messageformat'),
	                value: 10 * MINUTE
	            }, {
	                name: $translate.instant('timeinterval.minutes-interval', { minutes: 15 }, 'messageformat'),
	                value: 15 * MINUTE
	            }, {
	                name: $translate.instant('timeinterval.minutes-interval', { minutes: 30 }, 'messageformat'),
	                value: 30 * MINUTE
	            }, {
	                name: $translate.instant('timeinterval.hours-interval', { hours: 1 }, 'messageformat'),
	                value: 1 * HOUR
	            }, {
	                name: $translate.instant('timeinterval.hours-interval', { hours: 2 }, 'messageformat'),
	                value: 2 * HOUR
	            }, {
	                name: $translate.instant('timeinterval.hours-interval', { hours: 5 }, 'messageformat'),
	                value: 5 * HOUR
	            }, {
	                name: $translate.instant('timeinterval.hours-interval', { hours: 10 }, 'messageformat'),
	                value: 10 * HOUR
	            }, {
	                name: $translate.instant('timeinterval.hours-interval', { hours: 12 }, 'messageformat'),
	                value: 12 * HOUR
	            }, {
	                name: $translate.instant('timeinterval.days-interval', { days: 1 }, 'messageformat'),
	                value: 1 * DAY
	            }, {
	                name: $translate.instant('timeinterval.days-interval', { days: 7 }, 'messageformat'),
	                value: 7 * DAY
	            }, {
	                name: $translate.instant('timeinterval.days-interval', { days: 30 }, 'messageformat'),
	                value: 30 * DAY
	            }];
	        }
	    }
	
	    function matchesExistingInterval(min, max, intervalMs) {
	        var intervals = getIntervals(min, max);
	        for (var i in intervals) {
	            var interval = intervals[i];
	            if (intervalMs === interval.value) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function boundToPredefinedInterval(min, max, intervalMs) {
	        var intervals = getIntervals(min, max);
	        var minDelta = MAX_INTERVAL;
	        var boundedInterval = intervalMs || min;
	        var matchedInterval;
	        for (var i in intervals) {
	            var interval = intervals[i];
	            var delta = Math.abs(interval.value - boundedInterval);
	            if (delta < minDelta) {
	                matchedInterval = interval;
	                minDelta = delta;
	            }
	        }
	        boundedInterval = matchedInterval.value;
	        return boundedInterval;
	    }
	
	    function defaultTimewindow() {
	        var currentTime = new Date().getTime();
	        var timewindow = {
	            displayValue: "",
	            selectedTab: 0,
	            realtime: {
	                interval: SECOND,
	                timewindowMs: MINUTE // 1 min by default
	            },
	            history: {
	                historyType: 0,
	                interval: SECOND,
	                timewindowMs: MINUTE, // 1 min by default
	                fixedTimewindow: {
	                    startTimeMs: currentTime - DAY, // 1 day by default
	                    endTimeMs: currentTime
	                }
	            },
	            aggregation: {
	                type: types.aggregation.avg.value,
	                limit: Math.floor(maxDatapointsLimit / 2)
	            }
	        };
	        return timewindow;
	    }
	
	    function toHistoryTimewindow(timewindow, startTimeMs, endTimeMs) {
	
	        var interval = 0;
	        if (timewindow.history) {
	            interval = timewindow.history.interval;
	        } else if (timewindow.realtime) {
	            interval = timewindow.realtime.interval;
	        }
	
	        var aggType;
	        var limit;
	        if (timewindow.aggregation) {
	            aggType = timewindow.aggregation.type || types.aggregation.avg.value;
	            limit = timewindow.aggregation.limit || maxDatapointsLimit;
	        } else {
	            aggType = types.aggregation.avg.value;
	            limit = maxDatapointsLimit;
	        }
	
	        var historyTimewindow = {
	            history: {
	                fixedTimewindow: {
	                    startTimeMs: startTimeMs,
	                    endTimeMs: endTimeMs
	                },
	                interval: boundIntervalToTimewindow(endTimeMs - startTimeMs, interval, types.aggregation.avg.value)
	            },
	            aggregation: {
	                type: aggType,
	                limit: limit
	            }
	        };
	
	        return historyTimewindow;
	    }
	
	    function createSubscriptionTimewindow(timewindow, stDiff, stateData) {
	
	        var subscriptionTimewindow = {
	            fixedWindow: null,
	            realtimeWindowMs: null,
	            aggregation: {
	                interval: SECOND,
	                limit: maxDatapointsLimit,
	                type: types.aggregation.avg.value
	            }
	        };
	        var aggTimewindow = 0;
	        if (stateData) {
	            subscriptionTimewindow.aggregation = {
	                interval: SECOND,
	                limit: maxDatapointsLimit,
	                type: types.aggregation.none.value,
	                stateData: true
	            };
	        } else {
	            subscriptionTimewindow.aggregation = {
	                interval: SECOND,
	                limit: maxDatapointsLimit,
	                type: types.aggregation.avg.value
	            };
	        }
	
	        if (angular.isDefined(timewindow.aggregation) && !stateData) {
	            subscriptionTimewindow.aggregation = {
	                type: timewindow.aggregation.type || types.aggregation.avg.value,
	                limit: timewindow.aggregation.limit || maxDatapointsLimit
	            };
	        }
	        if (angular.isDefined(timewindow.realtime)) {
	            subscriptionTimewindow.realtimeWindowMs = timewindow.realtime.timewindowMs;
	            subscriptionTimewindow.aggregation.interval = boundIntervalToTimewindow(subscriptionTimewindow.realtimeWindowMs, timewindow.realtime.interval, subscriptionTimewindow.aggregation.type);
	            subscriptionTimewindow.startTs = new Date().getTime() + stDiff - subscriptionTimewindow.realtimeWindowMs;
	            var startDiff = subscriptionTimewindow.startTs % subscriptionTimewindow.aggregation.interval;
	            aggTimewindow = subscriptionTimewindow.realtimeWindowMs;
	            if (startDiff) {
	                subscriptionTimewindow.startTs -= startDiff;
	                aggTimewindow += subscriptionTimewindow.aggregation.interval;
	            }
	        } else if (angular.isDefined(timewindow.history)) {
	            if (angular.isDefined(timewindow.history.timewindowMs)) {
	                var currentTime = new Date().getTime();
	                subscriptionTimewindow.fixedWindow = {
	                    startTimeMs: currentTime - timewindow.history.timewindowMs,
	                    endTimeMs: currentTime
	                };
	                aggTimewindow = timewindow.history.timewindowMs;
	            } else {
	                subscriptionTimewindow.fixedWindow = {
	                    startTimeMs: timewindow.history.fixedTimewindow.startTimeMs,
	                    endTimeMs: timewindow.history.fixedTimewindow.endTimeMs
	                };
	                aggTimewindow = subscriptionTimewindow.fixedWindow.endTimeMs - subscriptionTimewindow.fixedWindow.startTimeMs;
	            }
	            subscriptionTimewindow.startTs = subscriptionTimewindow.fixedWindow.startTimeMs;
	            subscriptionTimewindow.aggregation.interval = boundIntervalToTimewindow(aggTimewindow, timewindow.history.interval, subscriptionTimewindow.aggregation.type);
	        }
	        var aggregation = subscriptionTimewindow.aggregation;
	        aggregation.timeWindow = aggTimewindow;
	        if (aggregation.type !== types.aggregation.none.value) {
	            aggregation.limit = Math.ceil(aggTimewindow / subscriptionTimewindow.aggregation.interval);
	        }
	        return subscriptionTimewindow;
	    }
	
	    function boundIntervalToTimewindow(timewindow, intervalMs, aggType) {
	        if (aggType === types.aggregation.none.value) {
	            return SECOND;
	        } else {
	            var min = minIntervalLimit(timewindow);
	            var max = maxIntervalLimit(timewindow);
	            if (intervalMs) {
	                return toBound(intervalMs, min, max, intervalMs);
	            } else {
	                return boundToPredefinedInterval(min, max, avgInterval(timewindow));
	            }
	        }
	    }
	}

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AppConfig.$inject = ["$provide", "$urlRouterProvider", "$locationProvider", "$mdIconProvider", "$mdThemingProvider", "$httpProvider", "$translateProvider", "storeProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AppConfig;
	
	var _reactTapEventPlugin = __webpack_require__(1668);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _url = __webpack_require__(512);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _mdi = __webpack_require__(1717);
	
	var _mdi2 = _interopRequireDefault(_mdi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	var PRIMARY_BACKGROUND_COLOR = "#305680"; //#2856b6";//"#3f51b5";
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var SECONDARY_BACKGROUND_COLOR = "#527dad";
	var HUE3_COLOR = "#a7c1de";
	
	/*@ngInject*/
	function AppConfig($provide, $urlRouterProvider, $locationProvider, $mdIconProvider, $mdThemingProvider, $httpProvider, $translateProvider, storeProvider) {
	
	    (0, _reactTapEventPlugin2.default)();
	    $locationProvider.html5Mode(true);
	    $urlRouterProvider.otherwise(_url2.default);
	    storeProvider.setCaching(false);
	
	    $translateProvider.useSanitizeValueStrategy(null).useMissingTranslationHandler('tbMissingTranslationHandler').addInterpolation('$translateMessageFormatInterpolation').useStaticFilesLoader({
	        files: [{
	            prefix: (/static/) + 'locale/locale.constant-', //eslint-disable-line
	            suffix: '.json'
	        }]
	    }).registerAvailableLanguageKeys((["en_US","es_ES","fr_FR","it_IT","ja_JA","ko_KR","pt_BR","ru_RU","zh_CN"]), getLanguageAliases((["en_US","es_ES","fr_FR","it_IT","ja_JA","ko_KR","pt_BR","ru_RU","zh_CN"]))) //eslint-disable-line
	    .fallbackLanguage('en_US') // must be before determinePreferredLanguage   
	    .uniformLanguageTag('java') // must be before determinePreferredLanguage
	    .determinePreferredLanguage();
	
	    $httpProvider.interceptors.push('globalInterceptor');
	
	    $provide.decorator("$exceptionHandler", ['$delegate', '$injector', function ($delegate /*, $injector*/) {
	        return function (exception, cause) {
	            /*            var rootScope = $injector.get("$rootScope");
	                        var $window = $injector.get("$window");
	                        var utils = $injector.get("utils");
	                        if (rootScope.widgetEditMode) {
	                            var parentScope = $window.parent.angular.element($window.frameElement).scope();
	                            var data = utils.parseException(exception);
	                            parentScope.$emit('widgetException', data);
	                            parentScope.$apply();
	                        }*/
	            $delegate(exception, cause);
	        };
	    }]);
	
	    $mdIconProvider.iconSet('mdi', _mdi2.default);
	
	    configureTheme();
	
	    function blueGrayTheme() {
	        var tbPrimaryPalette = $mdThemingProvider.extendPalette('blue-grey');
	        var tbAccentPalette = $mdThemingProvider.extendPalette('orange', {
	            'contrastDefaultColor': 'light'
	        });
	
	        $mdThemingProvider.definePalette('tb-primary', tbPrimaryPalette);
	        $mdThemingProvider.definePalette('tb-accent', tbAccentPalette);
	
	        $mdThemingProvider.theme('default').primaryPalette('tb-primary').accentPalette('tb-accent');
	
	        $mdThemingProvider.theme('tb-dark').primaryPalette('tb-primary').accentPalette('tb-accent').backgroundPalette('tb-primary').dark();
	    }
	
	    function indigoTheme() {
	        var tbPrimaryPalette = $mdThemingProvider.extendPalette('indigo', {
	            '500': PRIMARY_BACKGROUND_COLOR,
	            '600': SECONDARY_BACKGROUND_COLOR,
	            'A100': HUE3_COLOR
	        });
	
	        var tbAccentPalette = $mdThemingProvider.extendPalette('deep-orange');
	
	        $mdThemingProvider.definePalette('tb-primary', tbPrimaryPalette);
	        $mdThemingProvider.definePalette('tb-accent', tbAccentPalette);
	
	        var tbDarkPrimaryPalette = $mdThemingProvider.extendPalette('tb-primary', {
	            '500': '#9fa8da'
	        });
	
	        var tbDarkPrimaryBackgroundPalette = $mdThemingProvider.extendPalette('tb-primary', {
	            '800': PRIMARY_BACKGROUND_COLOR
	        });
	
	        $mdThemingProvider.definePalette('tb-dark-primary', tbDarkPrimaryPalette);
	        $mdThemingProvider.definePalette('tb-dark-primary-background', tbDarkPrimaryBackgroundPalette);
	
	        $mdThemingProvider.theme('default').primaryPalette('tb-primary').accentPalette('tb-accent');
	
	        $mdThemingProvider.theme('tb-dark').primaryPalette('tb-dark-primary').accentPalette('tb-accent').backgroundPalette('tb-dark-primary-background').dark();
	    }
	
	    function configureTheme() {
	
	        var theme = 'indigo';
	
	        if (theme === 'blueGray') {
	            blueGrayTheme();
	        } else {
	            indigoTheme();
	        }
	
	        $mdThemingProvider.setDefaultTheme('default');
	        //$mdThemingProvider.alwaysWatchTheme(true);
	    }
	
	    function getLanguageAliases(supportedLangs) {
	        var aliases = {};
	
	        supportedLangs.sort().forEach(function (item, index, array) {
	            if (item.length === 2) {
	                aliases[item] = item;
	                aliases[item + '_*'] = item;
	            } else {
	                var key = item.slice(0, 2);
	                if (index === 0 || key !== array[index - 1].slice(0, 2)) {
	                    aliases[key] = item;
	                    aliases[key + '_*'] = item;
	                } else {
	                    aliases[item] = item;
	                }
	            }
	        });
	
	        return aliases;
	    }
	}

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1289);
	
	__webpack_require__(729);
	
	var _angular = __webpack_require__(48);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularMaterial = __webpack_require__(80);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularMaterialIcons = __webpack_require__(606);
	
	var _angularMaterialIcons2 = _interopRequireDefault(_angularMaterialIcons);
	
	var _angularCookies = __webpack_require__(594);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularSocialshare = __webpack_require__(611);
	
	var _angularSocialshare2 = _interopRequireDefault(_angularSocialshare);
	
	__webpack_require__(620);
	
	__webpack_require__(617);
	
	__webpack_require__(619);
	
	__webpack_require__(618);
	
	__webpack_require__(615);
	
	__webpack_require__(616);
	
	__webpack_require__(226);
	
	var _mdPickers = __webpack_require__(1122);
	
	var _mdPickers2 = _interopRequireDefault(_mdPickers);
	
	var _angularSanitize = __webpack_require__(265);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _vAccordion = __webpack_require__(1723);
	
	var _vAccordion2 = _interopRequireDefault(_vAccordion);
	
	var _angularAnimate = __webpack_require__(121);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	__webpack_require__(268);
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularJwt = __webpack_require__(600);
	
	var _angularJwt2 = _interopRequireDefault(_angularJwt);
	
	__webpack_require__(595);
	
	var _angularMaterialDataTable = __webpack_require__(602);
	
	var _angularMaterialDataTable2 = _interopRequireDefault(_angularMaterialDataTable);
	
	__webpack_require__(604);
	
	var _angularTouch = __webpack_require__(614);
	
	var _angularTouch2 = _interopRequireDefault(_angularTouch);
	
	__webpack_require__(592);
	
	__webpack_require__(663);
	
	__webpack_require__(1366);
	
	__webpack_require__(1);
	
	__webpack_require__(14);
	
	__webpack_require__(1086);
	
	__webpack_require__(118);
	
	var _ngreact = __webpack_require__(1370);
	
	var _ngreact2 = _interopRequireDefault(_ngreact);
	
	__webpack_require__(263);
	
	__webpack_require__(1365);
	
	var _translateHandler = __webpack_require__(1302);
	
	var _translateHandler2 = _interopRequireDefault(_translateHandler);
	
	var _login = __webpack_require__(1304);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _datakeyConfigDialog = __webpack_require__(230);
	
	var _datakeyConfigDialog2 = _interopRequireDefault(_datakeyConfigDialog);
	
	var _menu = __webpack_require__(148);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _raf = __webpack_require__(1167);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _utils = __webpack_require__(90);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _dashboardUtils = __webpack_require__(1166);
	
	var _dashboardUtils2 = _interopRequireDefault(_dashboardUtils);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _time = __webpack_require__(1149);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _keyboardShortcut = __webpack_require__(1183);
	
	var _keyboardShortcut2 = _interopRequireDefault(_keyboardShortcut);
	
	var _help = __webpack_require__(1285);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _toast = __webpack_require__(75);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _clipboard = __webpack_require__(1325);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _layout = __webpack_require__(1300);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _login3 = __webpack_require__(113);
	
	var _login4 = _interopRequireDefault(_login3);
	
	var _device = __webpack_require__(146);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _entityView = __webpack_require__(505);
	
	var _entityView2 = _interopRequireDefault(_entityView);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _entityRelation = __webpack_require__(1142);
	
	var _entityRelation2 = _interopRequireDefault(_entityRelation);
	
	var _asset = __webpack_require__(504);
	
	var _asset2 = _interopRequireDefault(_asset);
	
	var _attribute = __webpack_require__(1137);
	
	var _attribute2 = _interopRequireDefault(_attribute);
	
	var _entity = __webpack_require__(1143);
	
	var _entity2 = _interopRequireDefault(_entity);
	
	var _alarm = __webpack_require__(1136);
	
	var _alarm2 = _interopRequireDefault(_alarm);
	
	var _auditLog = __webpack_require__(1138);
	
	var _auditLog2 = _interopRequireDefault(_auditLog);
	
	var _componentDescriptor = __webpack_require__(1139);
	
	var _componentDescriptor2 = _interopRequireDefault(_componentDescriptor);
	
	var _ruleChain = __webpack_require__(1145);
	
	var _ruleChain2 = _interopRequireDefault(_ruleChain);
	
	__webpack_require__(835);
	
	__webpack_require__(736);
	
	__webpack_require__(735);
	
	__webpack_require__(734);
	
	__webpack_require__(731);
	
	__webpack_require__(836);
	
	__webpack_require__(738);
	
	__webpack_require__(739);
	
	__webpack_require__(732);
	
	__webpack_require__(730);
	
	__webpack_require__(733);
	
	__webpack_require__(740);
	
	__webpack_require__(831);
	
	var _app = __webpack_require__(1150);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _globalInterceptor = __webpack_require__(1283);
	
	var _globalInterceptor2 = _interopRequireDefault(_globalInterceptor);
	
	var _app3 = __webpack_require__(1152);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('thingsboard', [_angularMaterial2.default, _angularMaterialIcons2.default, _angularCookies2.default, _angularSocialshare2.default, 'pascalprecht.translate', 'mdColorPicker', _mdPickers2.default, _angularSanitize2.default, _vAccordion2.default, _angularAnimate2.default, 'ngWebSocket', _angularJwt2.default, 'dndLists', _angularMaterialDataTable2.default, 'material.components.expansionPanels', _angularTouch2.default, 'angular-carousel', 'ngclipboard', _ngreact2.default.name, 'flow', 'flowchart', _translateHandler2.default, _login2.default, _datakeyConfigDialog2.default, _menu2.default, _raf2.default, _utils2.default, _dashboardUtils2.default, _types2.default, _time2.default, _keyboardShortcut2.default, _help2.default, _toast2.default, _clipboard2.default, _layout2.default, _login4.default, _device2.default, _entityView2.default, _user2.default, _entityRelation2.default, _asset2.default, _attribute2.default, _entity2.default, _alarm2.default, _auditLog2.default, _componentDescriptor2.default, _ruleChain2.default, _angularUiRouter2.default]).config(_app2.default).factory('globalInterceptor', _globalInterceptor2.default).run(_app4.default); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AppRun.$inject = ["$rootScope", "$window", "$injector", "$location", "$log", "$state", "$mdDialog", "$filter", "loginService", "userService", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AppRun;
	
	var _ngFlowStandalone = __webpack_require__(263);
	
	var _ngFlowStandalone2 = _interopRequireDefault(_ngFlowStandalone);
	
	var _url = __webpack_require__(512);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function AppRun($rootScope, $window, $injector, $location, $log, $state, $mdDialog, $filter, loginService, userService, $translate) {
	
	    $window.Flow = _ngFlowStandalone2.default;
	    var frame = null;
	    try {
	        frame = $window.frameElement;
	    } catch (e) {
	        // ie11 fix
	    }
	
	    var unauthorizedDialog = null;
	    var forbiddenDialog = null;
	
	    $rootScope.iframeMode = false;
	
	    if (frame) {
	        $rootScope.iframeMode = true;
	        var dataWidgetAttr = angular.element(frame).attr('data-widget');
	        if (dataWidgetAttr) {
	            $rootScope.editWidgetInfo = angular.fromJson(dataWidgetAttr);
	            $rootScope.widgetEditMode = true;
	        }
	    }
	
	    initWatchers();
	
	    function initWatchers() {
	        $rootScope.unauthenticatedHandle = $rootScope.$on('unauthenticated', function (event, doLogout) {
	            if (doLogout) {
	                $state.go('login');
	            } else {
	                (0, _url2.default)($injector, $location);
	            }
	        });
	
	        $rootScope.authenticatedHandle = $rootScope.$on('authenticated', function () {
	            (0, _url2.default)($injector, $location);
	        });
	
	        $rootScope.forbiddenHandle = $rootScope.$on('forbidden', function () {
	            showForbiddenDialog();
	        });
	
	        $rootScope.stateChangeStartHandle = $rootScope.$on('$stateChangeStart', function (evt, to, params) {
	
	            function waitForUserLoaded() {
	                if ($rootScope.userLoadedHandle) {
	                    $rootScope.userLoadedHandle();
	                }
	                $rootScope.userLoadedHandle = $rootScope.$on('userLoaded', function () {
	                    $rootScope.userLoadedHandle();
	                    $state.go(to.name, params);
	                });
	            }
	
	            function reloadUserFromPublicId() {
	                userService.setUserFromJwtToken(null, null, false);
	                waitForUserLoaded();
	                userService.reloadUser();
	            }
	
	            var locationSearch = $location.search();
	            var publicId = locationSearch.publicId;
	            var activateToken = locationSearch.activateToken;
	
	            if (to.url === '/createPassword?activateToken' && activateToken && activateToken.length) {
	                userService.setUserFromJwtToken(null, null, false);
	            }
	
	            if (userService.isUserLoaded() === true) {
	                if (userService.isAuthenticated()) {
	                    if (userService.isPublic()) {
	                        if (userService.parsePublicId() !== publicId) {
	                            evt.preventDefault();
	                            if (publicId && publicId.length > 0) {
	                                reloadUserFromPublicId();
	                            } else {
	                                userService.logout();
	                            }
	                            return;
	                        }
	                    }
	                    if (userService.forceDefaultPlace(to, params)) {
	                        evt.preventDefault();
	                        gotoDefaultPlace(params);
	                    } else {
	                        var authority = userService.getAuthority();
	                        if (to.module === 'public') {
	                            evt.preventDefault();
	                            gotoDefaultPlace(params);
	                        } else if (angular.isDefined(to.auth) && to.auth.indexOf(authority) === -1) {
	                            evt.preventDefault();
	                            showForbiddenDialog();
	                        } else if (to.redirectTo) {
	                            evt.preventDefault();
	                            $state.go(to.redirectTo, params);
	                        } else if (to.name === 'home.dashboards.dashboard' && $rootScope.forceFullscreen) {
	                            evt.preventDefault();
	                            $state.go('dashboard', params);
	                        }
	                    }
	                } else {
	                    if (publicId && publicId.length > 0) {
	                        evt.preventDefault();
	                        reloadUserFromPublicId();
	                    } else if (to.module === 'private') {
	                        evt.preventDefault();
	                        if (to.url === '/home' || to.url === '/') {
	                            $state.go('login', params);
	                        } else {
	                            showUnauthorizedDialog();
	                        }
	                    }
	                }
	            } else {
	                evt.preventDefault();
	                waitForUserLoaded();
	            }
	        });
	
	        $rootScope.pageTitle = 'ThingsBoard';
	
	        $rootScope.stateChangeSuccessHandle = $rootScope.$on('$stateChangeSuccess', function (evt, to, params) {
	            if (userService.isPublic() && to.name === 'dashboard') {
	                $location.search('publicId', userService.getPublicId());
	                userService.updateLastPublicDashboardId(params.dashboardId);
	            }
	            if (angular.isDefined(to.data.pageTitle)) {
	                $translate(to.data.pageTitle).then(function (translation) {
	                    $rootScope.pageTitle = 'ThingsBoard | ' + translation;
	                }, function (translationId) {
	                    $rootScope.pageTitle = 'ThingsBoard | ' + translationId;
	                });
	            }
	        });
	    }
	
	    function gotoDefaultPlace(params) {
	        userService.gotoDefaultPlace(params);
	    }
	
	    function showUnauthorizedDialog() {
	        if (unauthorizedDialog === null) {
	            $translate(['access.unauthorized-access', 'access.unauthorized-access-text', 'access.unauthorized', 'action.cancel', 'action.sign-in']).then(function (translations) {
	                if (unauthorizedDialog === null) {
	                    unauthorizedDialog = $mdDialog.confirm().title(translations['access.unauthorized-access']).textContent(translations['access.unauthorized-access-text']).ariaLabel(translations['access.unauthorized']).cancel(translations['action.cancel']).ok(translations['action.sign-in']);
	                    $mdDialog.show(unauthorizedDialog).then(function () {
	                        unauthorizedDialog = null;
	                        $state.go('login');
	                    }, function () {
	                        unauthorizedDialog = null;
	                    });
	                }
	            });
	        }
	    }
	
	    function showForbiddenDialog() {
	        if (forbiddenDialog === null) {
	            $translate(['access.access-forbidden', 'access.access-forbidden-text', 'access.access-forbidden', 'action.cancel', 'action.sign-in']).then(function (translations) {
	                if (forbiddenDialog === null) {
	                    forbiddenDialog = $mdDialog.confirm().title(translations['access.access-forbidden']).htmlContent(translations['access.access-forbidden-text']).ariaLabel(translations['access.access-forbidden']).cancel(translations['action.cancel']).ok(translations['action.sign-in']);
	                    $mdDialog.show(forbiddenDialog).then(function () {
	                        forbiddenDialog = null;
	                        userService.logout();
	                    }, function () {
	                        forbiddenDialog = null;
	                    });
	                }
	            });
	        }
	    }
	}

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	'use strict';
	
	AddAssetsToCustomerController.$inject = ["assetService", "$mdDialog", "$q", "customerId", "assets"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AddAssetsToCustomerController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AddAssetsToCustomerController(assetService, $mdDialog, $q, customerId, assets) {
	
	    var vm = this;
	
	    vm.assets = assets;
	    vm.searchText = '';
	
	    vm.assign = assign;
	    vm.cancel = cancel;
	    vm.hasData = hasData;
	    vm.noData = noData;
	    vm.searchAssetTextUpdated = searchAssetTextUpdated;
	    vm.toggleAssetSelection = toggleAssetSelection;
	
	    vm.theAssets = {
	        getItemAtIndex: function getItemAtIndex(index) {
	            if (index > vm.assets.data.length) {
	                vm.theAssets.fetchMoreItems_(index);
	                return null;
	            }
	            var item = vm.assets.data[index];
	            if (item) {
	                item.indexNumber = index + 1;
	            }
	            return item;
	        },
	
	        getLength: function getLength() {
	            if (vm.assets.hasNext) {
	                return vm.assets.data.length + vm.assets.nextPageLink.limit;
	            } else {
	                return vm.assets.data.length;
	            }
	        },
	
	        fetchMoreItems_: function fetchMoreItems_() {
	            if (vm.assets.hasNext && !vm.assets.pending) {
	                vm.assets.pending = true;
	                assetService.getTenantAssets(vm.assets.nextPageLink, false).then(function success(assets) {
	                    vm.assets.data = vm.assets.data.concat(assets.data);
	                    vm.assets.nextPageLink = assets.nextPageLink;
	                    vm.assets.hasNext = assets.hasNext;
	                    if (vm.assets.hasNext) {
	                        vm.assets.nextPageLink.limit = vm.assets.pageSize;
	                    }
	                    vm.assets.pending = false;
	                }, function fail() {
	                    vm.assets.hasNext = false;
	                    vm.assets.pending = false;
	                });
	            }
	        }
	    };
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function assign() {
	        var tasks = [];
	        for (var assetId in vm.assets.selections) {
	            tasks.push(assetService.assignAssetToCustomer(customerId, assetId));
	        }
	        $q.all(tasks).then(function () {
	            $mdDialog.hide();
	        });
	    }
	
	    function noData() {
	        return vm.assets.data.length == 0 && !vm.assets.hasNext;
	    }
	
	    function hasData() {
	        return vm.assets.data.length > 0;
	    }
	
	    function toggleAssetSelection($event, asset) {
	        $event.stopPropagation();
	        var selected = angular.isDefined(asset.selected) && asset.selected;
	        asset.selected = !selected;
	        if (asset.selected) {
	            vm.assets.selections[asset.id.id] = true;
	            vm.assets.selectedCount++;
	        } else {
	            delete vm.assets.selections[asset.id.id];
	            vm.assets.selectedCount--;
	        }
	    }
	
	    function searchAssetTextUpdated() {
	        vm.assets = {
	            pageSize: vm.assets.pageSize,
	            data: [],
	            nextPageLink: {
	                limit: vm.assets.pageSize,
	                textSearch: vm.searchText
	            },
	            selections: {},
	            selectedCount: 0,
	            hasNext: true,
	            pending: false
	        };
	    }
	}

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AssetCardController.$inject = ["types"];
	AssetController.$inject = ["$rootScope", "userService", "assetService", "customerService", "$state", "$stateParams", "$document", "$mdDialog", "$q", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AssetCardController = AssetCardController;
	exports.AssetController = AssetController;
	
	var _addAssetTpl = __webpack_require__(1376);
	
	var _addAssetTpl2 = _interopRequireDefault(_addAssetTpl);
	
	var _assetCardTpl = __webpack_require__(1378);
	
	var _assetCardTpl2 = _interopRequireDefault(_assetCardTpl);
	
	var _assignToCustomerTpl = __webpack_require__(1381);
	
	var _assignToCustomerTpl2 = _interopRequireDefault(_assignToCustomerTpl);
	
	var _addAssetsToCustomerTpl = __webpack_require__(1377);
	
	var _addAssetsToCustomerTpl2 = _interopRequireDefault(_addAssetsToCustomerTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function AssetCardController(types) {
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.isAssignedToCustomer = function () {
	        if (vm.item && vm.item.customerId && vm.parentCtl.assetsScope === 'tenant' && vm.item.customerId.id != vm.types.id.nullUid && !vm.item.assignedCustomer.isPublic) {
	            return true;
	        }
	        return false;
	    };
	
	    vm.isPublic = function () {
	        if (vm.item && vm.item.assignedCustomer && vm.parentCtl.assetsScope === 'tenant' && vm.item.assignedCustomer.isPublic) {
	            return true;
	        }
	        return false;
	    };
	}
	
	/*@ngInject*/
	function AssetController($rootScope, userService, assetService, customerService, $state, $stateParams, $document, $mdDialog, $q, $translate, types) {
	
	    var customerId = $stateParams.customerId;
	
	    var assetActionsList = [];
	
	    var assetGroupActionsList = [];
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.assetGridConfig = {
	        deleteItemTitleFunc: deleteAssetTitle,
	        deleteItemContentFunc: deleteAssetText,
	        deleteItemsTitleFunc: deleteAssetsTitle,
	        deleteItemsActionTitleFunc: deleteAssetsActionTitle,
	        deleteItemsContentFunc: deleteAssetsText,
	
	        saveItemFunc: saveAsset,
	
	        getItemTitleFunc: getAssetTitle,
	
	        itemCardController: 'AssetCardController',
	        itemCardTemplateUrl: _assetCardTpl2.default,
	        parentCtl: vm,
	
	        actionsList: assetActionsList,
	        groupActionsList: assetGroupActionsList,
	
	        onGridInited: gridInited,
	
	        addItemTemplateUrl: _addAssetTpl2.default,
	
	        addItemText: function addItemText() {
	            return $translate.instant('asset.add-asset-text');
	        },
	        noItemsText: function noItemsText() {
	            return $translate.instant('asset.no-assets-text');
	        },
	        itemDetailsText: function itemDetailsText() {
	            return $translate.instant('asset.asset-details');
	        },
	        isDetailsReadOnly: isCustomerUser,
	        isSelectionEnabled: function isSelectionEnabled() {
	            return !isCustomerUser();
	        }
	    };
	
	    if (angular.isDefined($stateParams.items) && $stateParams.items !== null) {
	        vm.assetGridConfig.items = $stateParams.items;
	    }
	
	    if (angular.isDefined($stateParams.topIndex) && $stateParams.topIndex > 0) {
	        vm.assetGridConfig.topIndex = $stateParams.topIndex;
	    }
	
	    vm.assetsScope = $state.$current.data.assetsType;
	
	    vm.assignToCustomer = assignToCustomer;
	    vm.makePublic = makePublic;
	    vm.unassignFromCustomer = unassignFromCustomer;
	
	    initController();
	
	    function initController() {
	        var fetchAssetsFunction = null;
	        var deleteAssetFunction = null;
	        var refreshAssetsParamsFunction = null;
	
	        var user = userService.getCurrentUser();
	
	        if (user.authority === 'CUSTOMER_USER') {
	            vm.assetsScope = 'customer_user';
	            customerId = user.customerId;
	        }
	        if (customerId) {
	            vm.customerAssetsTitle = $translate.instant('customer.assets');
	            customerService.getShortCustomerInfo(customerId).then(function success(info) {
	                if (info.isPublic) {
	                    vm.customerAssetsTitle = $translate.instant('customer.public-assets');
	                }
	            });
	        }
	
	        if (vm.assetsScope === 'tenant') {
	            fetchAssetsFunction = function fetchAssetsFunction(pageLink, assetType) {
	                return assetService.getTenantAssets(pageLink, true, null, assetType);
	            };
	            deleteAssetFunction = function deleteAssetFunction(assetId) {
	                return assetService.deleteAsset(assetId);
	            };
	            refreshAssetsParamsFunction = function refreshAssetsParamsFunction() {
	                return { "topIndex": vm.topIndex };
	            };
	
	            assetActionsList.push({
	                onAction: function onAction($event, item) {
	                    makePublic($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('action.share');
	                },
	                details: function details() {
	                    return $translate.instant('asset.make-public');
	                },
	                icon: "share",
	                isEnabled: function isEnabled(asset) {
	                    return asset && (!asset.customerId || asset.customerId.id === types.id.nullUid);
	                }
	            });
	
	            assetActionsList.push({
	                onAction: function onAction($event, item) {
	                    assignToCustomer($event, [item.id.id]);
	                },
	                name: function name() {
	                    return $translate.instant('action.assign');
	                },
	                details: function details() {
	                    return $translate.instant('asset.assign-to-customer');
	                },
	                icon: "assignment_ind",
	                isEnabled: function isEnabled(asset) {
	                    return asset && (!asset.customerId || asset.customerId.id === types.id.nullUid);
	                }
	            });
	
	            assetActionsList.push({
	                onAction: function onAction($event, item) {
	                    unassignFromCustomer($event, item, false);
	                },
	                name: function name() {
	                    return $translate.instant('action.unassign');
	                },
	                details: function details() {
	                    return $translate.instant('asset.unassign-from-customer');
	                },
	                icon: "assignment_return",
	                isEnabled: function isEnabled(asset) {
	                    return asset && asset.customerId && asset.customerId.id !== types.id.nullUid && !asset.assignedCustomer.isPublic;
	                }
	            });
	
	            assetActionsList.push({
	                onAction: function onAction($event, item) {
	                    unassignFromCustomer($event, item, true);
	                },
	                name: function name() {
	                    return $translate.instant('action.make-private');
	                },
	                details: function details() {
	                    return $translate.instant('asset.make-private');
	                },
	                icon: "reply",
	                isEnabled: function isEnabled(asset) {
	                    return asset && asset.customerId && asset.customerId.id !== types.id.nullUid && asset.assignedCustomer.isPublic;
	                }
	            });
	
	            assetActionsList.push({
	                onAction: function onAction($event, item) {
	                    vm.grid.deleteItem($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('action.delete');
	                },
	                details: function details() {
	                    return $translate.instant('asset.delete');
	                },
	                icon: "delete"
	            });
	
	            assetGroupActionsList.push({
	                onAction: function onAction($event, items) {
	                    assignAssetsToCustomer($event, items);
	                },
	                name: function name() {
	                    return $translate.instant('asset.assign-assets');
	                },
	                details: function details(selectedCount) {
	                    return $translate.instant('asset.assign-assets-text', { count: selectedCount }, "messageformat");
	                },
	                icon: "assignment_ind"
	            });
	
	            assetGroupActionsList.push({
	                onAction: function onAction($event) {
	                    vm.grid.deleteItems($event);
	                },
	                name: function name() {
	                    return $translate.instant('asset.delete-assets');
	                },
	                details: deleteAssetsActionTitle,
	                icon: "delete"
	            });
	        } else if (vm.assetsScope === 'customer' || vm.assetsScope === 'customer_user') {
	            fetchAssetsFunction = function fetchAssetsFunction(pageLink, assetType) {
	                return assetService.getCustomerAssets(customerId, pageLink, true, null, assetType);
	            };
	            deleteAssetFunction = function deleteAssetFunction(assetId) {
	                return assetService.unassignAssetFromCustomer(assetId);
	            };
	            refreshAssetsParamsFunction = function refreshAssetsParamsFunction() {
	                return { "customerId": customerId, "topIndex": vm.topIndex };
	            };
	
	            if (vm.assetsScope === 'customer') {
	                assetActionsList.push({
	                    onAction: function onAction($event, item) {
	                        unassignFromCustomer($event, item, false);
	                    },
	                    name: function name() {
	                        return $translate.instant('action.unassign');
	                    },
	                    details: function details() {
	                        return $translate.instant('asset.unassign-from-customer');
	                    },
	                    icon: "assignment_return",
	                    isEnabled: function isEnabled(asset) {
	                        return asset && !asset.assignedCustomer.isPublic;
	                    }
	                });
	                assetActionsList.push({
	                    onAction: function onAction($event, item) {
	                        unassignFromCustomer($event, item, true);
	                    },
	                    name: function name() {
	                        return $translate.instant('action.make-private');
	                    },
	                    details: function details() {
	                        return $translate.instant('asset.make-private');
	                    },
	                    icon: "reply",
	                    isEnabled: function isEnabled(asset) {
	                        return asset && asset.assignedCustomer.isPublic;
	                    }
	                });
	
	                assetGroupActionsList.push({
	                    onAction: function onAction($event, items) {
	                        unassignAssetsFromCustomer($event, items);
	                    },
	                    name: function name() {
	                        return $translate.instant('asset.unassign-assets');
	                    },
	                    details: function details(selectedCount) {
	                        return $translate.instant('asset.unassign-assets-action-title', { count: selectedCount }, "messageformat");
	                    },
	                    icon: "assignment_return"
	                });
	
	                vm.assetGridConfig.addItemAction = {
	                    onAction: function onAction($event) {
	                        addAssetsToCustomer($event);
	                    },
	                    name: function name() {
	                        return $translate.instant('asset.assign-assets');
	                    },
	                    details: function details() {
	                        return $translate.instant('asset.assign-new-asset');
	                    },
	                    icon: "add"
	                };
	            } else if (vm.assetsScope === 'customer_user') {
	                vm.assetGridConfig.addItemAction = {};
	            }
	        }
	
	        vm.assetGridConfig.refreshParamsFunc = refreshAssetsParamsFunction;
	        vm.assetGridConfig.fetchItemsFunc = fetchAssetsFunction;
	        vm.assetGridConfig.deleteItemFunc = deleteAssetFunction;
	    }
	
	    function deleteAssetTitle(asset) {
	        return $translate.instant('asset.delete-asset-title', { assetName: asset.name });
	    }
	
	    function deleteAssetText() {
	        return $translate.instant('asset.delete-asset-text');
	    }
	
	    function deleteAssetsTitle(selectedCount) {
	        return $translate.instant('asset.delete-assets-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteAssetsActionTitle(selectedCount) {
	        return $translate.instant('asset.delete-assets-action-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteAssetsText() {
	        return $translate.instant('asset.delete-assets-text');
	    }
	
	    function gridInited(grid) {
	        vm.grid = grid;
	    }
	
	    function getAssetTitle(asset) {
	        return asset ? asset.name : '';
	    }
	
	    function saveAsset(asset) {
	        var deferred = $q.defer();
	        assetService.saveAsset(asset).then(function success(savedAsset) {
	            $rootScope.$broadcast('assetSaved');
	            var assets = [savedAsset];
	            customerService.applyAssignedCustomersInfo(assets).then(function success(items) {
	                if (items && items.length == 1) {
	                    deferred.resolve(items[0]);
	                } else {
	                    deferred.reject();
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function isCustomerUser() {
	        return vm.assetsScope === 'customer_user';
	    }
	
	    function assignToCustomer($event, assetIds) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var pageSize = 10;
	        customerService.getCustomers({ limit: pageSize, textSearch: '' }).then(function success(_customers) {
	            var customers = {
	                pageSize: pageSize,
	                data: _customers.data,
	                nextPageLink: _customers.nextPageLink,
	                selection: null,
	                hasNext: _customers.hasNext,
	                pending: false
	            };
	            if (customers.hasNext) {
	                customers.nextPageLink.limit = pageSize;
	            }
	            $mdDialog.show({
	                controller: 'AssignAssetToCustomerController',
	                controllerAs: 'vm',
	                templateUrl: _assignToCustomerTpl2.default,
	                locals: { assetIds: assetIds, customers: customers },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: $event
	            }).then(function () {
	                vm.grid.refreshList();
	            }, function () {});
	        }, function fail() {});
	    }
	
	    function addAssetsToCustomer($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var pageSize = 10;
	        assetService.getTenantAssets({ limit: pageSize, textSearch: '' }, false).then(function success(_assets) {
	            var assets = {
	                pageSize: pageSize,
	                data: _assets.data,
	                nextPageLink: _assets.nextPageLink,
	                selections: {},
	                selectedCount: 0,
	                hasNext: _assets.hasNext,
	                pending: false
	            };
	            if (assets.hasNext) {
	                assets.nextPageLink.limit = pageSize;
	            }
	            $mdDialog.show({
	                controller: 'AddAssetsToCustomerController',
	                controllerAs: 'vm',
	                templateUrl: _addAssetsToCustomerTpl2.default,
	                locals: { customerId: customerId, assets: assets },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: $event
	            }).then(function () {
	                vm.grid.refreshList();
	            }, function () {});
	        }, function fail() {});
	    }
	
	    function assignAssetsToCustomer($event, items) {
	        var assetIds = [];
	        for (var id in items.selections) {
	            assetIds.push(id);
	        }
	        assignToCustomer($event, assetIds);
	    }
	
	    function unassignFromCustomer($event, asset, isPublic) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var title;
	        var content;
	        var label;
	        if (isPublic) {
	            title = $translate.instant('asset.make-private-asset-title', { assetName: asset.name });
	            content = $translate.instant('asset.make-private-asset-text');
	            label = $translate.instant('asset.make-private');
	        } else {
	            title = $translate.instant('asset.unassign-asset-title', { assetName: asset.name });
	            content = $translate.instant('asset.unassign-asset-text');
	            label = $translate.instant('asset.unassign-asset');
	        }
	        var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(label).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            assetService.unassignAssetFromCustomer(asset.id.id).then(function success() {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function unassignAssetsFromCustomer($event, items) {
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('asset.unassign-assets-title', { count: items.selectedCount }, 'messageformat')).htmlContent($translate.instant('asset.unassign-assets-text')).ariaLabel($translate.instant('asset.unassign-asset')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            var tasks = [];
	            for (var id in items.selections) {
	                tasks.push(assetService.unassignAssetFromCustomer(id));
	            }
	            $q.all(tasks).then(function () {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function makePublic($event, asset) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('asset.make-public-asset-title', { assetName: asset.name })).htmlContent($translate.instant('asset.make-public-asset-text')).ariaLabel($translate.instant('asset.make-public')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            assetService.makeAssetPublic(asset.id.id).then(function success() {
	                vm.grid.refreshList();
	            });
	        });
	    }
	}

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AssetDirective.$inject = ["$compile", "$templateCache", "toast", "$translate", "types", "assetService", "customerService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AssetDirective;
	
	var _assetFieldsetTpl = __webpack_require__(1379);
	
	var _assetFieldsetTpl2 = _interopRequireDefault(_assetFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function AssetDirective($compile, $templateCache, toast, $translate, types, assetService, customerService) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_assetFieldsetTpl2.default);
	        element.html(template);
	
	        scope.types = types;
	        scope.isAssignedToCustomer = false;
	        scope.isPublic = false;
	        scope.assignedCustomer = null;
	
	        scope.$watch('asset', function (newVal) {
	            if (newVal) {
	                if (scope.asset.customerId && scope.asset.customerId.id !== types.id.nullUid) {
	                    scope.isAssignedToCustomer = true;
	                    customerService.getShortCustomerInfo(scope.asset.customerId.id).then(function success(customer) {
	                        scope.assignedCustomer = customer;
	                        scope.isPublic = customer.isPublic;
	                    });
	                } else {
	                    scope.isAssignedToCustomer = false;
	                    scope.isPublic = false;
	                    scope.assignedCustomer = null;
	                }
	            }
	        });
	
	        scope.onAssetIdCopied = function () {
	            toast.showSuccess($translate.instant('asset.idCopiedMessage'), 750, angular.element(element).parent().parent(), 'bottom left');
	        };
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            asset: '=',
	            isEdit: '=',
	            assetScope: '=',
	            theForm: '=',
	            onAssignToCustomer: '&',
	            onMakePublic: '&',
	            onUnassignFromCustomer: '&',
	            onDeleteAsset: '&'
	        }
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AssetRoutes.$inject = ["$stateProvider", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AssetRoutes;
	
	var _assetsTpl = __webpack_require__(1380);
	
	var _assetsTpl2 = _interopRequireDefault(_assetsTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function AssetRoutes($stateProvider, types) {
	    $stateProvider.state('home.assets', {
	        url: '/assets',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "content@home": {
	                templateUrl: _assetsTpl2.default,
	                controller: 'AssetController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            assetsType: 'tenant',
	            searchEnabled: true,
	            searchByEntitySubtype: true,
	            searchEntityType: types.entityType.asset,
	            pageTitle: 'asset.assets'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "domain", "label": "asset.assets"}'
	        }
	    }).state('home.customers.assets', {
	        url: '/:customerId/assets',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _assetsTpl2.default,
	                controllerAs: 'vm',
	                controller: 'AssetController'
	            }
	        },
	        data: {
	            assetsType: 'customer',
	            searchEnabled: true,
	            searchByEntitySubtype: true,
	            searchEntityType: types.entityType.asset,
	            pageTitle: 'customer.assets'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "domain", "label": "{{ vm.customerAssetsTitle }}", "translate": "false"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	'use strict';
	
	AssignAssetToCustomerController.$inject = ["customerService", "assetService", "$mdDialog", "$q", "assetIds", "customers"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AssignAssetToCustomerController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AssignAssetToCustomerController(customerService, assetService, $mdDialog, $q, assetIds, customers) {
	
	    var vm = this;
	
	    vm.customers = customers;
	    vm.searchText = '';
	
	    vm.assign = assign;
	    vm.cancel = cancel;
	    vm.isCustomerSelected = isCustomerSelected;
	    vm.hasData = hasData;
	    vm.noData = noData;
	    vm.searchCustomerTextUpdated = searchCustomerTextUpdated;
	    vm.toggleCustomerSelection = toggleCustomerSelection;
	
	    vm.theCustomers = {
	        getItemAtIndex: function getItemAtIndex(index) {
	            if (index > vm.customers.data.length) {
	                vm.theCustomers.fetchMoreItems_(index);
	                return null;
	            }
	            var item = vm.customers.data[index];
	            if (item) {
	                item.indexNumber = index + 1;
	            }
	            return item;
	        },
	
	        getLength: function getLength() {
	            if (vm.customers.hasNext) {
	                return vm.customers.data.length + vm.customers.nextPageLink.limit;
	            } else {
	                return vm.customers.data.length;
	            }
	        },
	
	        fetchMoreItems_: function fetchMoreItems_() {
	            if (vm.customers.hasNext && !vm.customers.pending) {
	                vm.customers.pending = true;
	                customerService.getCustomers(vm.customers.nextPageLink).then(function success(customers) {
	                    vm.customers.data = vm.customers.data.concat(customers.data);
	                    vm.customers.nextPageLink = customers.nextPageLink;
	                    vm.customers.hasNext = customers.hasNext;
	                    if (vm.customers.hasNext) {
	                        vm.customers.nextPageLink.limit = vm.customers.pageSize;
	                    }
	                    vm.customers.pending = false;
	                }, function fail() {
	                    vm.customers.hasNext = false;
	                    vm.customers.pending = false;
	                });
	            }
	        }
	    };
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function assign() {
	        var tasks = [];
	        for (var i = 0; i < assetIds.length; i++) {
	            tasks.push(assetService.assignAssetToCustomer(vm.customers.selection.id.id, assetIds[i]));
	        }
	        $q.all(tasks).then(function () {
	            $mdDialog.hide();
	        });
	    }
	
	    function noData() {
	        return vm.customers.data.length == 0 && !vm.customers.hasNext;
	    }
	
	    function hasData() {
	        return vm.customers.data.length > 0;
	    }
	
	    function toggleCustomerSelection($event, customer) {
	        $event.stopPropagation();
	        if (vm.isCustomerSelected(customer)) {
	            vm.customers.selection = null;
	        } else {
	            vm.customers.selection = customer;
	        }
	    }
	
	    function isCustomerSelected(customer) {
	        return vm.customers.selection != null && customer && customer.id.id === vm.customers.selection.id.id;
	    }
	
	    function searchCustomerTextUpdated() {
	        vm.customers = {
	            pageSize: vm.customers.pageSize,
	            data: [],
	            nextPageLink: {
	                limit: vm.customers.pageSize,
	                textSearch: vm.searchText
	            },
	            selection: null,
	            hasNext: true,
	            pending: false
	        };
	    }
	}

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _grid = __webpack_require__(74);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _asset = __webpack_require__(504);
	
	var _asset2 = _interopRequireDefault(_asset);
	
	var _customer = __webpack_require__(112);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _asset3 = __webpack_require__(1156);
	
	var _asset4 = _interopRequireDefault(_asset3);
	
	var _asset5 = __webpack_require__(1154);
	
	var _assignToCustomer = __webpack_require__(1157);
	
	var _assignToCustomer2 = _interopRequireDefault(_assignToCustomer);
	
	var _addAssetsToCustomer = __webpack_require__(1153);
	
	var _addAssetsToCustomer2 = _interopRequireDefault(_addAssetsToCustomer);
	
	var _asset6 = __webpack_require__(1155);
	
	var _asset7 = _interopRequireDefault(_asset6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.asset', [_angularUiRouter2.default, _grid2.default, _user2.default, _asset2.default, _customer2.default]).config(_asset4.default).controller('AssetController', _asset5.AssetController).controller('AssetCardController', _asset5.AssetCardController).controller('AssignAssetToCustomerController', _assignToCustomer2.default).controller('AddAssetsToCustomerController', _addAssetsToCustomer2.default).directive('tbAsset', _asset7.default).name;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuditLogDetailsDialogController.$inject = ["$mdDialog", "types", "auditLog", "showingCallback"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AuditLogDetailsDialogController;
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(33);
	
	__webpack_require__(277);
	
	__webpack_require__(61);
	
	__webpack_require__(743);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	function AuditLogDetailsDialogController($mdDialog, types, auditLog, showingCallback) {
	
	    var vm = this;
	
	    showingCallback.onShowing = function (scope, element) {
	        updateEditorSize(element, vm.actionData, 'tb-audit-log-action-data');
	        vm.actionDataEditor.resize();
	        if (vm.displayFailureDetails) {
	            updateEditorSize(element, vm.actionFailureDetails, 'tb-audit-log-failure-details');
	            vm.failureDetailsEditor.resize();
	        }
	    };
	
	    vm.types = types;
	    vm.auditLog = auditLog;
	    vm.displayFailureDetails = auditLog.actionStatus == types.auditLogActionStatus.FAILURE.value;
	    vm.actionData = auditLog.actionDataText;
	    vm.actionFailureDetails = auditLog.actionFailureDetails;
	
	    vm.actionDataContentOptions = {
	        useWrapMode: false,
	        mode: 'java',
	        showGutter: false,
	        showPrintMargin: false,
	        theme: 'github',
	        advanced: {
	            enableSnippets: false,
	            enableBasicAutocompletion: false,
	            enableLiveAutocompletion: false
	        },
	        onLoad: function onLoad(_ace) {
	            vm.actionDataEditor = _ace;
	        }
	    };
	
	    vm.failureDetailsContentOptions = {
	        useWrapMode: false,
	        mode: 'java',
	        showGutter: false,
	        showPrintMargin: false,
	        theme: 'github',
	        advanced: {
	            enableSnippets: false,
	            enableBasicAutocompletion: false,
	            enableLiveAutocompletion: false
	        },
	        onLoad: function onLoad(_ace) {
	            vm.failureDetailsEditor = _ace;
	        }
	    };
	
	    function updateEditorSize(element, content, editorId) {
	        var newHeight = 200;
	        var newWidth = 600;
	        if (content && content.length > 0) {
	            var lines = content.split('\n');
	            newHeight = 16 * lines.length + 16;
	            var maxLineLength = 0;
	            for (var i in lines) {
	                var line = lines[i].replace(/\t/g, '    ').replace(/\n/g, '');
	                var lineLength = line.length;
	                maxLineLength = Math.max(maxLineLength, lineLength);
	            }
	            newWidth = 8 * maxLineLength + 16;
	        }
	        (0, _jquery2.default)('#' + editorId, element).height(newHeight.toString() + "px").css('min-height', newHeight.toString() + "px").width(newWidth.toString() + "px");
	    }
	
	    vm.close = close;
	
	    function close() {
	        $mdDialog.hide();
	    }
	}
	
	/* eslint-enable angular/angularelement */
	
	
	/* eslint-disable angular/angularelement */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	AuditLogHeaderDirective.$inject = ["$compile", "$templateCache", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AuditLogHeaderDirective;
	
	var _auditLogHeaderTpl = __webpack_require__(1383);
	
	var _auditLogHeaderTpl2 = _interopRequireDefault(_auditLogHeaderTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function AuditLogHeaderDirective($compile, $templateCache, types) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        var template = $templateCache.get(_auditLogHeaderTpl2.default);
	        element.html(template);
	        scope.auditLogMode = attrs.auditLogMode;
	        scope.types = types;
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "A",
	        replace: false,
	        link: linker,
	        scope: false
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuditLogRowDirective.$inject = ["$compile", "$templateCache", "types", "$mdDialog", "$document"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AuditLogRowDirective;
	
	var _auditLogDetailsDialogTpl = __webpack_require__(1382);
	
	var _auditLogDetailsDialogTpl2 = _interopRequireDefault(_auditLogDetailsDialogTpl);
	
	var _auditLogRowTpl = __webpack_require__(1384);
	
	var _auditLogRowTpl2 = _interopRequireDefault(_auditLogRowTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function AuditLogRowDirective($compile, $templateCache, types, $mdDialog, $document) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        var template = $templateCache.get(_auditLogRowTpl2.default);
	        element.html(template);
	
	        scope.auditLog = attrs.auditLog;
	        scope.auditLogMode = attrs.auditLogMode;
	        scope.types = types;
	
	        scope.showAuditLogDetails = function ($event) {
	            var onShowingCallback = {
	                onShowing: function onShowing() {}
	            };
	            $mdDialog.show({
	                controller: 'AuditLogDetailsDialogController',
	                controllerAs: 'vm',
	                templateUrl: _auditLogDetailsDialogTpl2.default,
	                locals: {
	                    auditLog: scope.auditLog,
	                    showingCallback: onShowingCallback
	                },
	                parent: angular.element($document[0].body),
	                targetEvent: $event,
	                fullscreen: true,
	                skipHide: true,
	                onShowing: function onShowing(scope, element) {
	                    onShowingCallback.onShowing(scope, element);
	                }
	            });
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "A",
	        replace: false,
	        link: linker,
	        scope: false
	    };
	}

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuditLogTableDirective.$inject = ["$compile", "$templateCache", "$rootScope", "$filter", "$translate", "types", "auditLogService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AuditLogTableDirective;
	
	__webpack_require__(744);
	
	var _auditLogTableTpl = __webpack_require__(1385);
	
	var _auditLogTableTpl2 = _interopRequireDefault(_auditLogTableTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function AuditLogTableDirective($compile, $templateCache, $rootScope, $filter, $translate, types, auditLogService) {
	
	    var linker = function linker(scope, element) {
	
	        var template = $templateCache.get(_auditLogTableTpl2.default);
	
	        element.html(template);
	
	        scope.types = types;
	
	        var pageSize = 20;
	        var startTime = 0;
	        var endTime = 0;
	
	        scope.timewindow = {
	            history: {
	                timewindowMs: 24 * 60 * 60 * 1000 // 1 day
	            }
	        };
	
	        scope.topIndex = 0;
	        scope.searchText = '';
	
	        scope.theAuditLogs = {
	            getItemAtIndex: function getItemAtIndex(index) {
	                if (index > scope.auditLogs.filtered.length) {
	                    scope.theAuditLogs.fetchMoreItems_(index);
	                    return null;
	                }
	                return scope.auditLogs.filtered[index];
	            },
	
	            getLength: function getLength() {
	                if (scope.auditLogs.hasNext) {
	                    return scope.auditLogs.filtered.length + scope.auditLogs.nextPageLink.limit;
	                } else {
	                    return scope.auditLogs.filtered.length;
	                }
	            },
	
	            fetchMoreItems_: function fetchMoreItems_() {
	                if (scope.auditLogs.hasNext && !scope.auditLogs.pending) {
	                    var promise = getAuditLogsPromise(scope.auditLogs.nextPageLink);
	                    if (promise) {
	                        scope.auditLogs.pending = true;
	                        promise.then(function success(auditLogs) {
	                            scope.auditLogs.data = scope.auditLogs.data.concat(prepareAuditLogsData(auditLogs.data));
	                            scope.auditLogs.filtered = $filter('filter')(scope.auditLogs.data, { $: scope.searchText });
	                            scope.auditLogs.nextPageLink = auditLogs.nextPageLink;
	                            scope.auditLogs.hasNext = auditLogs.hasNext;
	                            if (scope.auditLogs.hasNext) {
	                                scope.auditLogs.nextPageLink.limit = pageSize;
	                            }
	                            scope.auditLogs.pending = false;
	                        }, function fail() {
	                            scope.auditLogs.hasNext = false;
	                            scope.auditLogs.pending = false;
	                        });
	                    } else {
	                        scope.auditLogs.hasNext = false;
	                    }
	                }
	            }
	        };
	
	        function prepareAuditLogsData(data) {
	            data.forEach(function (auditLog) {
	                auditLog.entityTypeText = $translate.instant(types.entityTypeTranslations[auditLog.entityId.entityType].type);
	                auditLog.actionTypeText = $translate.instant(types.auditLogActionType[auditLog.actionType].name);
	                auditLog.actionStatusText = $translate.instant(types.auditLogActionStatus[auditLog.actionStatus].name);
	                auditLog.actionDataText = auditLog.actionData ? angular.toJson(auditLog.actionData, true) : '';
	            });
	            return data;
	        }
	
	        scope.$watch("entityId", function (newVal, prevVal) {
	            if (newVal && !angular.equals(newVal, prevVal)) {
	                resetFilter();
	                scope.reload();
	            }
	        });
	
	        scope.$watch("userId", function (newVal, prevVal) {
	            if (newVal && !angular.equals(newVal, prevVal)) {
	                resetFilter();
	                scope.reload();
	            }
	        });
	
	        scope.$watch("customerId", function (newVal, prevVal) {
	            if (newVal && !angular.equals(newVal, prevVal)) {
	                resetFilter();
	                scope.reload();
	            }
	        });
	
	        function getAuditLogsPromise(pageLink) {
	            switch (scope.auditLogMode) {
	                case types.auditLogMode.tenant:
	                    return auditLogService.getAuditLogs(pageLink);
	                case types.auditLogMode.entity:
	                    if (scope.entityType && scope.entityId) {
	                        return auditLogService.getAuditLogsByEntityId(scope.entityType, scope.entityId, pageLink);
	                    } else {
	                        return null;
	                    }
	                case types.auditLogMode.user:
	                    if (scope.userId) {
	                        return auditLogService.getAuditLogsByUserId(scope.userId, pageLink);
	                    } else {
	                        return null;
	                    }
	                case types.auditLogMode.customer:
	                    if (scope.customerId) {
	                        return auditLogService.getAuditLogsByCustomerId(scope.customerId, pageLink);
	                    } else {
	                        return null;
	                    }
	            }
	        }
	
	        function destroyWatchers() {
	            if (scope.timewindowWatchHandle) {
	                scope.timewindowWatchHandle();
	                scope.timewindowWatchHandle = null;
	            }
	            if (scope.searchTextWatchHandle) {
	                scope.searchTextWatchHandle();
	                scope.searchTextWatchHandle = null;
	            }
	        }
	
	        function initWatchers() {
	            scope.timewindowWatchHandle = scope.$watch("timewindow", function (newVal, prevVal) {
	                if (newVal && !angular.equals(newVal, prevVal)) {
	                    scope.reload();
	                }
	            }, true);
	
	            scope.searchTextWatchHandle = scope.$watch("searchText", function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    scope.searchTextUpdated();
	                }
	            }, true);
	        }
	
	        function resetFilter() {
	            destroyWatchers();
	            scope.timewindow = {
	                history: {
	                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
	                }
	            };
	            scope.searchText = '';
	            initWatchers();
	        }
	
	        function updateTimeWindowRange() {
	            if (scope.timewindow.history.timewindowMs) {
	                var currentTime = new Date().getTime();
	                startTime = currentTime - scope.timewindow.history.timewindowMs;
	                endTime = currentTime;
	            } else {
	                startTime = scope.timewindow.history.fixedTimewindow.startTimeMs;
	                endTime = scope.timewindow.history.fixedTimewindow.endTimeMs;
	            }
	        }
	
	        scope.reload = function () {
	            scope.topIndex = 0;
	            updateTimeWindowRange();
	            scope.auditLogs = {
	                data: [],
	                filtered: [],
	                nextPageLink: {
	                    limit: pageSize,
	                    startTime: startTime,
	                    endTime: endTime
	                },
	                hasNext: true,
	                pending: false
	            };
	            scope.theAuditLogs.getItemAtIndex(pageSize);
	        };
	
	        scope.searchTextUpdated = function () {
	            scope.auditLogs.filtered = $filter('filter')(scope.auditLogs.data, { $: scope.searchText });
	            scope.theAuditLogs.getItemAtIndex(pageSize);
	        };
	
	        scope.noData = function () {
	            return scope.auditLogs.data.length == 0 && !scope.auditLogs.hasNext;
	        };
	
	        scope.hasData = function () {
	            return scope.auditLogs.data.length > 0;
	        };
	
	        scope.loading = function () {
	            return $rootScope.loading;
	        };
	
	        scope.hasScroll = function () {
	            var repeatContainer = scope.repeatContainer[0];
	            if (repeatContainer) {
	                var scrollElement = repeatContainer.children[0];
	                if (scrollElement) {
	                    return scrollElement.scrollHeight > scrollElement.clientHeight;
	                }
	            }
	            return false;
	        };
	
	        scope.reload();
	
	        initWatchers();
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            entityType: '=?',
	            entityId: '=?',
	            userId: '=?',
	            customerId: '=?',
	            auditLogMode: '@',
	            pageMode: '@?'
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuditLogRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AuditLogRoutes;
	
	var _auditLogsTpl = __webpack_require__(1386);
	
	var _auditLogsTpl2 = _interopRequireDefault(_auditLogsTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function AuditLogRoutes($stateProvider) {
	    $stateProvider.state('home.auditLogs', {
	        url: '/auditLogs',
	        module: 'private',
	        auth: ['TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _auditLogsTpl2.default,
	                controller: 'AuditLogsController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            searchEnabled: false,
	            pageTitle: 'audit-log.audit-logs'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "track_changes", "label": "audit-log.audit-logs"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

	"use strict";
	
	AuditLogsController.$inject = ["types"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AuditLogsController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AuditLogsController(types) {
	
	  var vm = this;
	
	  vm.types = types;
	}

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auditLog = __webpack_require__(1163);
	
	var _auditLog2 = _interopRequireDefault(_auditLog);
	
	var _auditLogs = __webpack_require__(1164);
	
	var _auditLogs2 = _interopRequireDefault(_auditLogs);
	
	var _auditLogDetailsDialog = __webpack_require__(1159);
	
	var _auditLogDetailsDialog2 = _interopRequireDefault(_auditLogDetailsDialog);
	
	var _auditLogHeader = __webpack_require__(1160);
	
	var _auditLogHeader2 = _interopRequireDefault(_auditLogHeader);
	
	var _auditLogRow = __webpack_require__(1161);
	
	var _auditLogRow2 = _interopRequireDefault(_auditLogRow);
	
	var _auditLogTable = __webpack_require__(1162);
	
	var _auditLogTable2 = _interopRequireDefault(_auditLogTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.auditLog', []).config(_auditLog2.default).controller('AuditLogsController', _auditLogs2.default).controller('AuditLogDetailsDialogController', _auditLogDetailsDialog2.default).directive('tbAuditLogHeader', _auditLogHeader2.default).directive('tbAuditLogRow', _auditLogRow2.default).directive('tbAuditLogTable', _auditLogTable2.default).name;

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	'use strict';
	
	DashboardUtils.$inject = ["types", "utils", "timeService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.dashboardUtils', []).factory('dashboardUtils', DashboardUtils).name;
	
	/*@ngInject*/
	
	function DashboardUtils(types, utils, timeService) {
	
	    var service = {
	        validateAndUpdateDashboard: validateAndUpdateDashboard,
	        validateAndUpdateWidget: validateAndUpdateWidget,
	        getRootStateId: getRootStateId,
	        createSingleWidgetDashboard: createSingleWidgetDashboard,
	        createSingleEntityFilter: createSingleEntityFilter,
	        getStateLayoutsData: getStateLayoutsData,
	        createDefaultState: createDefaultState,
	        createDefaultLayoutData: createDefaultLayoutData,
	        setLayouts: setLayouts,
	        updateLayoutSettings: updateLayoutSettings,
	        addWidgetToLayout: addWidgetToLayout,
	        removeWidgetFromLayout: removeWidgetFromLayout,
	        isSingleLayoutDashboard: isSingleLayoutDashboard,
	        removeUnusedWidgets: removeUnusedWidgets,
	        getWidgetsArray: getWidgetsArray
	    };
	
	    return service;
	
	    function validateAndUpdateEntityAliases(configuration, datasourcesByAliasId, targetDevicesByAliasId) {
	        var aliasId, entityAlias;
	        if (angular.isUndefined(configuration.entityAliases)) {
	            configuration.entityAliases = {};
	            if (configuration.deviceAliases) {
	                var deviceAliases = configuration.deviceAliases;
	                for (aliasId in deviceAliases) {
	                    var deviceAlias = deviceAliases[aliasId];
	                    entityAlias = validateAndUpdateDeviceAlias(aliasId, deviceAlias, datasourcesByAliasId, targetDevicesByAliasId);
	                    configuration.entityAliases[entityAlias.id] = entityAlias;
	                }
	                delete configuration.deviceAliases;
	            }
	        } else {
	            var entityAliases = configuration.entityAliases;
	            for (aliasId in entityAliases) {
	                entityAlias = entityAliases[aliasId];
	                entityAlias = validateAndUpdateEntityAlias(aliasId, entityAlias, datasourcesByAliasId, targetDevicesByAliasId);
	                if (aliasId != entityAlias.id) {
	                    delete entityAliases[aliasId];
	                }
	                entityAliases[entityAlias.id] = entityAlias;
	            }
	        }
	        return configuration;
	    }
	
	    function validateAliasId(aliasId, datasourcesByAliasId, targetDevicesByAliasId) {
	        if (!aliasId || !angular.isString(aliasId) || aliasId.length != 36) {
	            var newAliasId = utils.guid();
	            var aliasDatasources = datasourcesByAliasId[aliasId];
	            if (aliasDatasources) {
	                aliasDatasources.forEach(function (datasource) {
	                    datasource.entityAliasId = newAliasId;
	                });
	            }
	            var targetDeviceAliasIdsList = targetDevicesByAliasId[aliasId];
	            if (targetDeviceAliasIdsList) {
	                targetDeviceAliasIdsList.forEach(function (targetDeviceAliasIds) {
	                    targetDeviceAliasIds[0] = newAliasId;
	                });
	            }
	            return newAliasId;
	        } else {
	            return aliasId;
	        }
	    }
	
	    function validateAndUpdateDeviceAlias(aliasId, deviceAlias, datasourcesByAliasId, targetDevicesByAliasId) {
	        aliasId = validateAliasId(aliasId, datasourcesByAliasId, targetDevicesByAliasId);
	        var alias = deviceAlias.alias;
	        var entityAlias = {
	            id: aliasId,
	            alias: alias,
	            filter: {
	                type: null,
	                entityType: types.entityType.device,
	                resolveMultiple: false
	            }
	        };
	        if (deviceAlias.deviceFilter) {
	            entityAlias.filter.type = deviceAlias.deviceFilter.useFilter ? types.aliasFilterType.entityName.value : types.aliasFilterType.entityList.value;
	            if (entityAlias.filter.type == types.aliasFilterType.entityList.value) {
	                entityAlias.filter.entityList = deviceAlias.deviceFilter.deviceList;
	            } else {
	                entityAlias.filter.entityNameFilter = deviceAlias.deviceFilter.deviceNameFilter;
	            }
	        } else {
	            entityAlias.filter.type = types.aliasFilterType.entityList.value;
	            entityAlias.filter.entityList = [deviceAlias.deviceId];
	        }
	        return entityAlias;
	    }
	
	    function validateAndUpdateEntityAlias(aliasId, entityAlias, datasourcesByAliasId, targetDevicesByAliasId) {
	        entityAlias.id = validateAliasId(aliasId, datasourcesByAliasId, targetDevicesByAliasId);
	        if (!entityAlias.filter) {
	            entityAlias.filter = {
	                type: entityAlias.entityFilter.useFilter ? types.aliasFilterType.entityName.value : types.aliasFilterType.entityList.value,
	                entityType: entityAlias.entityType,
	                resolveMultiple: false
	            };
	            if (entityAlias.filter.type == types.aliasFilterType.entityList.value) {
	                entityAlias.filter.entityList = entityAlias.entityFilter.entityList;
	            } else {
	                entityAlias.filter.entityNameFilter = entityAlias.entityFilter.entityNameFilter;
	            }
	            delete entityAlias.entityType;
	            delete entityAlias.entityFilter;
	        }
	        return entityAlias;
	    }
	
	    function validateAndUpdateWidget(widget) {
	        if (!widget.config) {
	            widget.config = {};
	        }
	        if (!widget.config.datasources) {
	            widget.config.datasources = [];
	        }
	        widget.config.datasources.forEach(function (datasource) {
	            if (datasource.type === 'device') {
	                datasource.type = types.datasourceType.entity;
	            }
	            if (datasource.deviceAliasId) {
	                datasource.entityAliasId = datasource.deviceAliasId;
	                delete datasource.deviceAliasId;
	            }
	        });
	        //TODO: Temp workaround
	        if (widget.isSystemType && widget.bundleAlias == 'charts' && widget.typeAlias == 'timeseries') {
	            widget.typeAlias = 'basic_timeseries';
	        }
	        return widget;
	    }
	
	    function createDefaultLayoutData() {
	        return {
	            widgets: {},
	            gridSettings: {
	                backgroundColor: '#eeeeee',
	                color: 'rgba(0,0,0,0.870588)',
	                columns: 24,
	                margins: [10, 10],
	                backgroundSizeMode: '100%'
	            }
	        };
	    }
	
	    function createDefaultLayouts() {
	        return {
	            'main': createDefaultLayoutData()
	        };
	    }
	
	    function createDefaultState(name, root) {
	        return {
	            name: name,
	            root: root,
	            layouts: createDefaultLayouts()
	        };
	    }
	
	    function validateAndUpdateDashboard(dashboard) {
	        if (!dashboard.configuration) {
	            dashboard.configuration = {};
	        }
	        if (angular.isUndefined(dashboard.configuration.widgets)) {
	            dashboard.configuration.widgets = {};
	        } else if (angular.isArray(dashboard.configuration.widgets)) {
	            var widgetsMap = {};
	            dashboard.configuration.widgets.forEach(function (widget) {
	                if (!widget.id) {
	                    widget.id = utils.guid();
	                }
	                widgetsMap[widget.id] = widget;
	            });
	            dashboard.configuration.widgets = widgetsMap;
	        }
	        for (var id in dashboard.configuration.widgets) {
	            var widget = dashboard.configuration.widgets[id];
	            dashboard.configuration.widgets[id] = validateAndUpdateWidget(widget);
	        }
	        if (angular.isUndefined(dashboard.configuration.states)) {
	            dashboard.configuration.states = {
	                'default': createDefaultState(dashboard.title, true)
	            };
	
	            var mainLayout = dashboard.configuration.states['default'].layouts['main'];
	            for (id in dashboard.configuration.widgets) {
	                widget = dashboard.configuration.widgets[id];
	                mainLayout.widgets[id] = {
	                    sizeX: widget.sizeX,
	                    sizeY: widget.sizeY,
	                    row: widget.row,
	                    col: widget.col
	                };
	                if (angular.isDefined(widget.config.mobileHeight)) {
	                    mainLayout.widgets[id].mobileHeight = widget.config.mobileHeight;
	                }
	                if (angular.isDefined(widget.config.mobileOrder)) {
	                    mainLayout.widgets[id].mobileOrder = widget.config.mobileOrder;
	                }
	            }
	        } else {
	            var states = dashboard.configuration.states;
	            var rootFound = false;
	            for (var stateId in states) {
	                var state = states[stateId];
	                if (angular.isUndefined(state.root)) {
	                    state.root = false;
	                } else if (state.root) {
	                    rootFound = true;
	                }
	            }
	            if (!rootFound) {
	                var firstStateId = Object.keys(states)[0];
	                states[firstStateId].root = true;
	            }
	        }
	
	        var datasourcesByAliasId = {};
	        var targetDevicesByAliasId = {};
	        for (var widgetId in dashboard.configuration.widgets) {
	            widget = dashboard.configuration.widgets[widgetId];
	            widget.config.datasources.forEach(function (datasource) {
	                if (datasource.entityAliasId) {
	                    var aliasId = datasource.entityAliasId;
	                    var aliasDatasources = datasourcesByAliasId[aliasId];
	                    if (!aliasDatasources) {
	                        aliasDatasources = [];
	                        datasourcesByAliasId[aliasId] = aliasDatasources;
	                    }
	                    aliasDatasources.push(datasource);
	                }
	            });
	            if (widget.config.targetDeviceAliasIds && widget.config.targetDeviceAliasIds.length) {
	                var aliasId = widget.config.targetDeviceAliasIds[0];
	                var targetDeviceAliasIdsList = targetDevicesByAliasId[aliasId];
	                if (!targetDeviceAliasIdsList) {
	                    targetDeviceAliasIdsList = [];
	                    targetDevicesByAliasId[aliasId] = targetDeviceAliasIdsList;
	                }
	                targetDeviceAliasIdsList.push(widget.config.targetDeviceAliasIds);
	            }
	        }
	
	        dashboard.configuration = validateAndUpdateEntityAliases(dashboard.configuration, datasourcesByAliasId, targetDevicesByAliasId);
	
	        if (angular.isUndefined(dashboard.configuration.timewindow)) {
	            dashboard.configuration.timewindow = timeService.defaultTimewindow();
	        }
	        if (angular.isUndefined(dashboard.configuration.settings)) {
	            dashboard.configuration.settings = {};
	            dashboard.configuration.settings.stateControllerId = 'entity';
	            dashboard.configuration.settings.showTitle = false;
	            dashboard.configuration.settings.showDashboardsSelect = true;
	            dashboard.configuration.settings.showEntitiesSelect = true;
	            dashboard.configuration.settings.showDashboardTimewindow = true;
	            dashboard.configuration.settings.showDashboardExport = true;
	            dashboard.configuration.settings.toolbarAlwaysOpen = true;
	        } else {
	            if (angular.isUndefined(dashboard.configuration.settings.stateControllerId)) {
	                dashboard.configuration.settings.stateControllerId = 'entity';
	            }
	        }
	        if (angular.isDefined(dashboard.configuration.gridSettings)) {
	            var gridSettings = dashboard.configuration.gridSettings;
	            if (angular.isDefined(gridSettings.showTitle)) {
	                dashboard.configuration.settings.showTitle = gridSettings.showTitle;
	                delete gridSettings.showTitle;
	            }
	            if (angular.isDefined(gridSettings.titleColor)) {
	                dashboard.configuration.settings.titleColor = gridSettings.titleColor;
	                delete gridSettings.titleColor;
	            }
	            if (angular.isDefined(gridSettings.showDevicesSelect)) {
	                dashboard.configuration.settings.showEntitiesSelect = gridSettings.showDevicesSelect;
	                delete gridSettings.showDevicesSelect;
	            }
	            if (angular.isDefined(gridSettings.showEntitiesSelect)) {
	                dashboard.configuration.settings.showEntitiesSelect = gridSettings.showEntitiesSelect;
	                delete gridSettings.showEntitiesSelect;
	            }
	            if (angular.isDefined(gridSettings.showDashboardTimewindow)) {
	                dashboard.configuration.settings.showDashboardTimewindow = gridSettings.showDashboardTimewindow;
	                delete gridSettings.showDashboardTimewindow;
	            }
	            if (angular.isDefined(gridSettings.showDashboardExport)) {
	                dashboard.configuration.settings.showDashboardExport = gridSettings.showDashboardExport;
	                delete gridSettings.showDashboardExport;
	            }
	            dashboard.configuration.states['default'].layouts['main'].gridSettings = gridSettings;
	            delete dashboard.configuration.gridSettings;
	        }
	        return dashboard;
	    }
	
	    function getRootStateId(states) {
	        for (var stateId in states) {
	            var state = states[stateId];
	            if (state.root) {
	                return stateId;
	            }
	        }
	        return Object.keys(states)[0];
	    }
	
	    function createSingleWidgetDashboard(widget) {
	        if (!widget.id) {
	            widget.id = utils.guid();
	        }
	        var dashboard = {};
	        dashboard = validateAndUpdateDashboard(dashboard);
	        dashboard.configuration.widgets[widget.id] = widget;
	        dashboard.configuration.states['default'].layouts['main'].widgets[widget.id] = {
	            sizeX: widget.sizeX,
	            sizeY: widget.sizeY,
	            row: widget.row,
	            col: widget.col
	        };
	        return dashboard;
	    }
	
	    function createSingleEntityFilter(entityType, entityId) {
	        return {
	            type: types.aliasFilterType.singleEntity.value,
	            singleEntity: { entityType: entityType, id: entityId },
	            resolveMultiple: false
	        };
	    }
	
	    function getStateLayoutsData(dashboard, targetState) {
	        var dashboardConfiguration = dashboard.configuration;
	        var states = dashboardConfiguration.states;
	        var state = states[targetState];
	        if (state) {
	            var allWidgets = dashboardConfiguration.widgets;
	            var result = {};
	            for (var l in state.layouts) {
	                var layout = state.layouts[l];
	                if (layout) {
	                    result[l] = {
	                        widgets: [],
	                        widgetLayouts: {},
	                        gridSettings: {}
	                    };
	                    for (var id in layout.widgets) {
	                        result[l].widgets.push(allWidgets[id]);
	                    }
	                    result[l].widgetLayouts = layout.widgets;
	                    result[l].gridSettings = layout.gridSettings;
	                }
	            }
	            return result;
	        } else {
	            return null;
	        }
	    }
	
	    function setLayouts(dashboard, targetState, newLayouts) {
	        var dashboardConfiguration = dashboard.configuration;
	        var states = dashboardConfiguration.states;
	        var state = states[targetState];
	        var addedCount = 0;
	        var removedCount = 0;
	        for (var l in state.layouts) {
	            if (!newLayouts[l]) {
	                removedCount++;
	            }
	        }
	        for (l in newLayouts) {
	            if (!state.layouts[l]) {
	                addedCount++;
	            }
	        }
	        state.layouts = newLayouts;
	        var layoutsCount = Object.keys(state.layouts).length;
	        var newColumns;
	        if (addedCount) {
	            for (l in state.layouts) {
	                newColumns = state.layouts[l].gridSettings.columns * (layoutsCount - addedCount) / layoutsCount;
	                state.layouts[l].gridSettings.columns = newColumns;
	            }
	        }
	        if (removedCount) {
	            for (l in state.layouts) {
	                newColumns = state.layouts[l].gridSettings.columns * (layoutsCount + removedCount) / layoutsCount;
	                state.layouts[l].gridSettings.columns = newColumns;
	            }
	        }
	        removeUnusedWidgets(dashboard);
	    }
	
	    function updateLayoutSettings(layout, gridSettings) {
	        var prevGridSettings = layout.gridSettings;
	        var prevColumns = prevGridSettings ? prevGridSettings.columns : 24;
	        var ratio = gridSettings.columns / prevColumns;
	        layout.gridSettings = gridSettings;
	        var maxRow = 0;
	        for (var w in layout.widgets) {
	            var widget = layout.widgets[w];
	            maxRow = Math.max(maxRow, widget.row + widget.sizeY);
	        }
	        var newMaxRow = Math.round(maxRow * ratio);
	        for (w in layout.widgets) {
	            widget = layout.widgets[w];
	            if (widget.row + widget.sizeY == maxRow) {
	                widget.row = Math.round(widget.row * ratio);
	                widget.sizeY = newMaxRow - widget.row;
	            } else {
	                widget.row = Math.round(widget.row * ratio);
	                widget.sizeY = Math.round(widget.sizeY * ratio);
	            }
	            widget.sizeX = Math.round(widget.sizeX * ratio);
	            widget.col = Math.round(widget.col * ratio);
	            if (widget.col + widget.sizeX > gridSettings.columns) {
	                widget.sizeX = gridSettings.columns - widget.col;
	            }
	        }
	    }
	
	    function addWidgetToLayout(dashboard, targetState, targetLayout, widget, originalColumns, originalSize, row, column) {
	        var dashboardConfiguration = dashboard.configuration;
	        var states = dashboardConfiguration.states;
	        var state = states[targetState];
	        var layout = state.layouts[targetLayout];
	        var layoutCount = Object.keys(state.layouts).length;
	        if (!widget.id) {
	            widget.id = utils.guid();
	        }
	        if (!dashboardConfiguration.widgets[widget.id]) {
	            dashboardConfiguration.widgets[widget.id] = widget;
	        }
	        var widgetLayout = {
	            sizeX: originalSize ? originalSize.sizeX : widget.sizeX,
	            sizeY: originalSize ? originalSize.sizeY : widget.sizeY,
	            mobileOrder: widget.config.mobileOrder,
	            mobileHeight: widget.config.mobileHeight
	        };
	
	        if (angular.isUndefined(originalColumns)) {
	            originalColumns = 24;
	        }
	
	        var gridSettings = layout.gridSettings;
	        var columns = 24;
	        if (gridSettings && gridSettings.columns) {
	            columns = gridSettings.columns;
	        }
	
	        columns = columns * layoutCount;
	
	        if (columns != originalColumns) {
	            var ratio = columns / originalColumns;
	            widgetLayout.sizeX *= ratio;
	            widgetLayout.sizeY *= ratio;
	        }
	
	        if (row > -1 && column > -1) {
	            widgetLayout.row = row;
	            widgetLayout.col = column;
	        } else {
	            row = 0;
	            for (var w in layout.widgets) {
	                var existingLayout = layout.widgets[w];
	                var wRow = existingLayout.row ? existingLayout.row : 0;
	                var wSizeY = existingLayout.sizeY ? existingLayout.sizeY : 1;
	                var bottom = wRow + wSizeY;
	                row = Math.max(row, bottom);
	            }
	            widgetLayout.row = row;
	            widgetLayout.col = 0;
	        }
	
	        layout.widgets[widget.id] = widgetLayout;
	    }
	
	    function removeWidgetFromLayout(dashboard, targetState, targetLayout, widgetId) {
	        var dashboardConfiguration = dashboard.configuration;
	        var states = dashboardConfiguration.states;
	        var state = states[targetState];
	        var layout = state.layouts[targetLayout];
	        delete layout.widgets[widgetId];
	        removeUnusedWidgets(dashboard);
	    }
	
	    function isSingleLayoutDashboard(dashboard) {
	        var dashboardConfiguration = dashboard.configuration;
	        var states = dashboardConfiguration.states;
	        var stateKeys = Object.keys(states);
	        if (stateKeys.length === 1) {
	            var state = states[stateKeys[0]];
	            var layouts = state.layouts;
	            var layoutKeys = Object.keys(layouts);
	            if (layoutKeys.length === 1) {
	                return {
	                    state: stateKeys[0],
	                    layout: layoutKeys[0]
	                };
	            }
	        }
	        return null;
	    }
	
	    function removeUnusedWidgets(dashboard) {
	        var dashboardConfiguration = dashboard.configuration;
	        var states = dashboardConfiguration.states;
	        var widgets = dashboardConfiguration.widgets;
	        for (var widgetId in widgets) {
	            var found = false;
	            for (var s in states) {
	                var state = states[s];
	                for (var l in state.layouts) {
	                    var layout = state.layouts[l];
	                    if (layout.widgets[widgetId]) {
	                        found = true;
	                        break;
	                    }
	                }
	            }
	            if (!found) {
	                delete dashboardConfiguration.widgets[widgetId];
	            }
	        }
	    }
	
	    function getWidgetsArray(dashboard) {
	        var widgetsArray = [];
	        var dashboardConfiguration = dashboard.configuration;
	        var widgets = dashboardConfiguration.widgets;
	        for (var widgetId in widgets) {
	            var widget = widgets[widgetId];
	            widgetsArray.push(widget);
	        }
	        return widgetsArray;
	    }
	}

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.raf', []).provider('tbRaf', TbRAFProvider).name;
	
	
	function TbRAFProvider() {
	    /*@ngInject*/
	    this.$get = ["$window", "$timeout", function ($window, $timeout) {
	        var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame;
	
	        var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;
	
	        var rafSupported = !!requestAnimationFrame;
	        var raf = rafSupported ? function (fn) {
	            var id = requestAnimationFrame(fn);
	            return function () {
	                cancelAnimationFrame(id);
	            };
	        } : function (fn) {
	            var timer = $timeout(fn, 16.66, false);
	            return function () {
	                $timeout.cancel(timer);
	            };
	        };
	
	        raf.supported = rafSupported;
	
	        return raf;
	    }];
	    this.$get.$inject = ["$window", "$timeout"];
	}

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.utf8Encode = utf8Encode;
	exports.utf8Decode = utf8Decode;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function utf8Encode(str) {
	    var result;
	
	    if (angular.isUndefined(Uint8Array)) {
	        // eslint-disable-line no-undef
	        result = utf8ToBytes(str);
	    } else {
	        result = new Uint8Array(utf8ToBytes(str)); // eslint-disable-line no-undef
	    }
	
	    return result;
	}
	
	function utf8Decode(bytes) {
	    return utf8Slice(bytes, 0, bytes.length);
	}
	
	function utf8Slice(buf, start, end) {
	    var res = '';
	    var tmp = '';
	    end = Math.min(buf.length, end || Infinity);
	    start = start || 0;
	
	    for (var i = start; i < end; i++) {
	        if (buf[i] <= 0x7F) {
	            res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i]);
	            tmp = '';
	        } else {
	            tmp += '%' + buf[i].toString(16);
	        }
	    }
	
	    return res + decodeUtf8Char(tmp);
	}
	
	function decodeUtf8Char(str) {
	    try {
	        return decodeURIComponent(str);
	    } catch (err) {
	        return String.fromCharCode(0xFFFD); // UTF 8 invalid char
	    }
	}
	
	function utf8ToBytes(string, units) {
	    units = units || Infinity;
	    var codePoint;
	    var length = string.length;
	    var leadSurrogate = null;
	    var bytes = [];
	    var i = 0;
	
	    for (; i < length; i++) {
	        codePoint = string.charCodeAt(i);
	
	        // is surrogate component
	        if (codePoint > 0xD7FF && codePoint < 0xE000) {
	            // last char was a lead
	            if (leadSurrogate) {
	                // 2 leads in a row
	                if (codePoint < 0xDC00) {
	                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	                    leadSurrogate = codePoint;
	                    continue;
	                } else {
	                    // valid surrogate pair
	                    codePoint = leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00 | 0x10000;
	                    leadSurrogate = null;
	                }
	            } else {
	                // no lead yet
	
	                if (codePoint > 0xDBFF) {
	                    // unexpected trail
	                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	                    continue;
	                } else if (i + 1 === length) {
	                    // unpaired lead
	                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	                    continue;
	                } else {
	                    // valid lead
	                    leadSurrogate = codePoint;
	                    continue;
	                }
	            }
	        } else if (leadSurrogate) {
	            // valid bmp char, but last char was a lead
	            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	            leadSurrogate = null;
	        }
	
	        // encode utf8
	        if (codePoint < 0x80) {
	            if ((units -= 1) < 0) break;
	            bytes.push(codePoint);
	        } else if (codePoint < 0x800) {
	            if ((units -= 2) < 0) break;
	            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
	        } else if (codePoint < 0x10000) {
	            if ((units -= 3) < 0) break;
	            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	        } else if (codePoint < 0x200000) {
	            if ((units -= 4) < 0) break;
	            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	        } else {
	            throw new Error('Invalid code point');
	        }
	    }
	
	    return bytes;
	}

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CircularProgress.$inject = ["$compile"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.directives.circularProgress', []).directive('tbCircularProgress', CircularProgress).name;
	
	/* eslint-disable angular/angularelement */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function CircularProgress($compile) {
	
	    var linker = function linker(scope, element) {
	
	        var circularProgressElement = angular.element('<md-progress-circular style="margin: auto;" md-mode="indeterminate" md-diameter="20"></md-progress-circular>');
	
	        $compile(circularProgressElement)(scope);
	
	        var children = null;
	        var cssWidth = element.prop('style')['width'];
	        var width = null;
	        if (!cssWidth) {
	            (0, _jquery2.default)(element).css('width', width + 'px');
	        }
	
	        scope.$watch('circularProgress', function (newCircularProgress, prevCircularProgress) {
	            if (newCircularProgress != prevCircularProgress) {
	                if (newCircularProgress) {
	                    if (!cssWidth) {
	                        (0, _jquery2.default)(element).css('width', '');
	                        width = element.prop('offsetWidth');
	                        (0, _jquery2.default)(element).css('width', width + 'px');
	                    }
	                    children = (0, _jquery2.default)(element).children();
	                    (0, _jquery2.default)(element).empty();
	                    (0, _jquery2.default)(element).append((0, _jquery2.default)(circularProgressElement));
	                } else {
	                    (0, _jquery2.default)(element).empty();
	                    (0, _jquery2.default)(element).append(children);
	                    if (cssWidth) {
	                        (0, _jquery2.default)(element).css('width', cssWidth);
	                    } else {
	                        (0, _jquery2.default)(element).css('width', '');
	                    }
	                }
	            }
	        });
	    };
	
	    return {
	        restrict: "A",
	        link: linker,
	        scope: {
	            circularProgress: "=tbCircularProgress"
	        }
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DashboardAutocomplete.$inject = ["$compile", "$templateCache", "$q", "dashboardService", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(745);
	
	var _dashboard = __webpack_require__(228);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _dashboardAutocompleteTpl = __webpack_require__(1388);
	
	var _dashboardAutocompleteTpl2 = _interopRequireDefault(_dashboardAutocompleteTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.dashboardAutocomplete', [_dashboard2.default, _user2.default]).directive('tbDashboardAutocomplete', DashboardAutocomplete).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function DashboardAutocomplete($compile, $templateCache, $q, dashboardService, userService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_dashboardAutocompleteTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	        scope.dashboard = null;
	        scope.dashboardSearchText = '';
	
	        scope.fetchDashboards = function (searchText) {
	            var pageLink = { limit: 50, textSearch: searchText };
	
	            var deferred = $q.defer();
	
	            var promise;
	            if (scope.dashboardsScope === 'customer' || userService.getAuthority() === 'CUSTOMER_USER') {
	                if (scope.customerId) {
	                    promise = dashboardService.getCustomerDashboards(scope.customerId, pageLink, { ignoreLoading: true });
	                } else {
	                    promise = $q.when({ data: [] });
	                }
	            } else {
	                if (userService.getAuthority() === 'SYS_ADMIN') {
	                    if (scope.tenantId) {
	                        promise = dashboardService.getTenantDashboardsByTenantId(scope.tenantId, pageLink, { ignoreLoading: true });
	                    } else {
	                        promise = $q.when({ data: [] });
	                    }
	                } else {
	                    promise = dashboardService.getTenantDashboards(pageLink, { ignoreLoading: true });
	                }
	            }
	
	            promise.then(function success(result) {
	                deferred.resolve(result.data);
	            }, function fail() {
	                deferred.reject();
	            });
	
	            return deferred.promise;
	        };
	
	        scope.dashboardSearchTextChanged = function () {};
	
	        scope.updateView = function () {
	            if (!scope.disabled) {
	                ngModelCtrl.$setViewValue(scope.dashboard ? scope.dashboard.id.id : null);
	            }
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                dashboardService.getDashboardInfo(ngModelCtrl.$viewValue).then(function success(dashboard) {
	                    scope.dashboard = dashboard;
	                    startWatchers();
	                }, function fail() {
	                    scope.dashboard = null;
	                    scope.updateView();
	                    startWatchers();
	                });
	            } else {
	                scope.dashboard = null;
	                startWatchers();
	            }
	        };
	
	        function startWatchers() {
	            scope.$watch('dashboard', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    scope.updateView();
	                }
	            });
	            scope.$watch('disabled', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    scope.updateView();
	                }
	            });
	        }
	
	        if (scope.selectFirstDashboard) {
	            var pageLink = { limit: 1, textSearch: '' };
	            scope.dashboardFetchFunction(pageLink).then(function success(result) {
	                var dashboards = result.data;
	                if (dashboards.length > 0) {
	                    scope.dashboard = dashboards[0];
	                    scope.updateView();
	                }
	            }, function fail() {});
	        }
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            dashboardsScope: '@',
	            tenantId: '=',
	            customerId: '=',
	            theForm: '=?',
	            tbRequired: '=?',
	            disabled: '=ngDisabled',
	            selectFirstDashboard: '='
	        }
	    };
	}

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

	"use strict";
	
	DashboardSelectPanelController.$inject = ["mdPanelRef", "$scope", "$filter", "dashboards", "dashboardId", "onDashboardSelected"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DashboardSelectPanelController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function DashboardSelectPanelController(mdPanelRef, $scope, $filter, dashboards, dashboardId, onDashboardSelected) {
	
	    var vm = this;
	    vm._mdPanelRef = mdPanelRef;
	    vm.dashboards = dashboards;
	    vm.dashboardId = dashboardId;
	
	    vm.dashboardSelected = dashboardSelected;
	
	    function dashboardSelected(dashboardId) {
	        if (onDashboardSelected) {
	            onDashboardSelected(dashboardId);
	        }
	    }
	}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	DashboardSelect.$inject = ["$compile", "$templateCache", "$q", "$mdMedia", "$mdPanel", "$document", "types", "dashboardService", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(746);
	
	var _dashboard = __webpack_require__(228);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _dashboardSelectTpl = __webpack_require__(1390);
	
	var _dashboardSelectTpl2 = _interopRequireDefault(_dashboardSelectTpl);
	
	var _dashboardSelectPanelTpl = __webpack_require__(1389);
	
	var _dashboardSelectPanelTpl2 = _interopRequireDefault(_dashboardSelectPanelTpl);
	
	var _dashboardSelectPanel = __webpack_require__(1171);
	
	var _dashboardSelectPanel2 = _interopRequireDefault(_dashboardSelectPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.dashboardSelect', [_dashboard2.default, _user2.default]).directive('tbDashboardSelect', DashboardSelect).controller('DashboardSelectPanelController', _dashboardSelectPanel2.default).name;
	
	/*@ngInject*/
	
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function DashboardSelect($compile, $templateCache, $q, $mdMedia, $mdPanel, $document, types, dashboardService, userService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_dashboardSelectTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	        scope.dashboardId = null;
	
	        var pageLink = { limit: 100 };
	
	        var promise;
	        if (scope.dashboardsScope === 'customer' || userService.getAuthority() === 'CUSTOMER_USER') {
	            if (scope.customerId && scope.customerId != types.id.nullUid) {
	                promise = dashboardService.getCustomerDashboards(scope.customerId, pageLink, { ignoreLoading: true });
	            } else {
	                promise = $q.when({ data: [] });
	            }
	        } else {
	            promise = dashboardService.getTenantDashboards(pageLink, { ignoreLoading: true });
	        }
	
	        promise.then(function success(result) {
	            scope.dashboards = result.data;
	        }, function fail() {
	            scope.dashboards = [];
	        });
	
	        scope.updateView = function () {
	            ngModelCtrl.$setViewValue(scope.dashboardId);
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                scope.dashboardId = ngModelCtrl.$viewValue;
	            } else {
	                scope.dashboardId = null;
	            }
	        };
	
	        scope.$watch('dashboardId', function () {
	            scope.updateView();
	        });
	
	        scope.openDashboardSelectPanel = function (event) {
	            if (scope.disabled) {
	                return;
	            }
	            var position;
	            var panelHeight = $mdMedia('min-height: 350px') ? 250 : 150;
	            var panelWidth = 300;
	            var offset = element[0].getBoundingClientRect();
	            var bottomY = offset.bottom - $(window).scrollTop(); //eslint-disable-line
	            var leftX = offset.left - $(window).scrollLeft(); //eslint-disable-line
	            var yPosition;
	            var xPosition;
	            if (bottomY + panelHeight > $(window).height()) {
	                //eslint-disable-line
	                yPosition = $mdPanel.yPosition.ABOVE;
	            } else {
	                yPosition = $mdPanel.yPosition.BELOW;
	            }
	            if (leftX + panelWidth > $(window).width()) {
	                //eslint-disable-line
	                xPosition = $mdPanel.xPosition.CENTER;
	            } else {
	                xPosition = $mdPanel.xPosition.ALIGN_START;
	            }
	            position = $mdPanel.newPanelPosition().relativeTo(element).addPanelPosition(xPosition, yPosition);
	            var config = {
	                attachTo: angular.element($document[0].body),
	                controller: 'DashboardSelectPanelController',
	                controllerAs: 'vm',
	                templateUrl: _dashboardSelectPanelTpl2.default,
	                panelClass: 'tb-dashboard-select-panel',
	                position: position,
	                fullscreen: false,
	                locals: {
	                    dashboards: scope.dashboards,
	                    dashboardId: scope.dashboardId,
	                    onDashboardSelected: function onDashboardSelected(dashboardId) {
	                        if (scope.panelRef) {
	                            scope.panelRef.close();
	                        }
	                        scope.dashboardId = dashboardId;
	                    }
	                },
	                openFrom: event,
	                clickOutsideToClose: true,
	                escapeToClose: true,
	                focusOnOpen: false
	            };
	            $mdPanel.open(config).then(function (result) {
	                scope.panelRef = result;
	            });
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            dashboardsScope: '@',
	            customerId: '=',
	            tbRequired: '=?',
	            disabled: '=ngDisabled'
	        }
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DatakeyConfig.$inject = ["$compile", "$templateCache", "$q", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(748);
	
	var _jsonForm = __webpack_require__(232);
	
	var _jsonForm2 = _interopRequireDefault(_jsonForm);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _jsFunc = __webpack_require__(1180);
	
	var _jsFunc2 = _interopRequireDefault(_jsFunc);
	
	var _datakeyConfigTpl = __webpack_require__(1392);
	
	var _datakeyConfigTpl2 = _interopRequireDefault(_datakeyConfigTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.directives.datakeyConfig', [_types2.default, _jsFunc2.default, _jsonForm2.default]).directive('tbDatakeyConfig', DatakeyConfig).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function DatakeyConfig($compile, $templateCache, $q, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_datakeyConfigTpl2.default);
	
	        if (scope.datakeySettingsSchema.schema) {
	            scope.dataKeySchema = scope.datakeySettingsSchema.schema;
	            scope.dataKeyForm = scope.datakeySettingsSchema.form || ['*'];
	            template = '<md-tabs md-border-bottom class="tb-datakey-config">\n' + '<md-tab label="{{\'datakey.settings\' | translate}}">\n' + template + '</md-tab>\n' + '<md-tab label="{{\'datakey.advanced\' | translate}}">\n' + '<md-content class="md-padding" layout="column">\n' + '<div style="overflow: auto;">\n' + '<ng-form name="ngform" ' + 'layout="column" ' + 'layout-padding>' + '<tb-json-form schema="dataKeySchema"' + 'form="dataKeyForm"' + 'model="model.settings"' + 'form-control="ngform">' + '</tb-json-form>' + '</ng-form>\n' + '</div>\n' + '</md-content>\n' + '</md-tab>\n' + '</md-tabs>';
	        }
	
	        element.html(template);
	
	        scope.types = types;
	
	        scope.alarmFields = [];
	        for (var alarmField in types.alarmFields) {
	            scope.alarmFields.push(alarmField);
	        }
	
	        scope.selectedKey = null;
	        scope.keySearchText = null;
	        scope.usePostProcessing = false;
	
	        scope.functions = {};
	
	        ngModelCtrl.$render = function () {
	            scope.model = {};
	            if (ngModelCtrl.$viewValue) {
	                scope.model.type = ngModelCtrl.$viewValue.type;
	                scope.model.name = ngModelCtrl.$viewValue.name;
	                scope.model.label = ngModelCtrl.$viewValue.label;
	                scope.model.color = ngModelCtrl.$viewValue.color;
	                scope.model.units = ngModelCtrl.$viewValue.units;
	                scope.model.decimals = ngModelCtrl.$viewValue.decimals;
	                scope.model.funcBody = ngModelCtrl.$viewValue.funcBody;
	                scope.model.postFuncBody = ngModelCtrl.$viewValue.postFuncBody;
	                scope.model.usePostProcessing = scope.model.postFuncBody ? true : false;
	                scope.model.settings = ngModelCtrl.$viewValue.settings;
	            }
	        };
	
	        scope.$watch('model', function (newVal, oldVal) {
	            if (newVal.usePostProcessing != oldVal.usePostProcessing) {
	                if (scope.model.usePostProcessing && !scope.model.postFuncBody) {
	                    scope.model.postFuncBody = "return value;";
	                } else if (!scope.model.usePostProcessing && scope.model.postFuncBody) {
	                    delete scope.model.postFuncBody;
	                }
	            }
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                value.type = scope.model.type;
	                value.name = scope.model.name;
	                value.label = scope.model.label;
	                value.color = scope.model.color;
	                value.units = scope.model.units;
	                value.decimals = scope.model.decimals;
	                value.funcBody = scope.model.funcBody;
	                if (!scope.model.postFuncBody) {
	                    delete value.postFuncBody;
	                } else {
	                    value.postFuncBody = scope.model.postFuncBody;
	                }
	                ngModelCtrl.$setViewValue(value);
	            }
	        }, true);
	
	        scope.keysSearch = function (searchText) {
	            if (scope.model.type === types.dataKeyType.alarm) {
	                var dataKeys = searchText ? scope.alarmFields.filter(scope.createFilterForDataKey(searchText)) : scope.alarmFields;
	                dataKeys.push(searchText);
	                return dataKeys;
	            } else {
	                if (scope.entityAlias) {
	                    var deferred = $q.defer();
	                    scope.fetchEntityKeys({
	                        entityAliasId: scope.entityAlias.id,
	                        query: searchText,
	                        type: scope.model.type
	                    }).then(function (keys) {
	                        keys.push(searchText);
	                        deferred.resolve(keys);
	                    }, function (e) {
	                        deferred.reject(e);
	                    });
	                    return deferred.promise;
	                } else {
	                    return $q.when([]);
	                }
	            }
	        };
	
	        scope.createFilterForDataKey = function (query) {
	            var lowercaseQuery = angular.lowercase(query);
	            return function filterFn(dataKey) {
	                return angular.lowercase(dataKey).indexOf(lowercaseQuery) === 0;
	            };
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: 'E',
	        require: '^ngModel',
	        scope: {
	            entityAlias: '=',
	            fetchEntityKeys: '&',
	            datakeySettingsSchema: '='
	        },
	        link: linker
	    };
	}

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DatasourceEntity.$inject = ["$compile", "$templateCache", "$q", "$mdDialog", "$window", "$document", "$mdColorPicker", "$mdConstant", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(749);
	
	__webpack_require__(226);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _datakeyConfigDialog = __webpack_require__(230);
	
	var _datakeyConfigDialog2 = _interopRequireDefault(_datakeyConfigDialog);
	
	var _truncate = __webpack_require__(1202);
	
	var _truncate2 = _interopRequireDefault(_truncate);
	
	var _datasourceEntityTpl = __webpack_require__(1393);
	
	var _datasourceEntityTpl2 = _interopRequireDefault(_datasourceEntityTpl);
	
	var _datakeyConfigDialogTpl = __webpack_require__(518);
	
	var _datakeyConfigDialogTpl2 = _interopRequireDefault(_datakeyConfigDialogTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable angular/angularelement */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.directives.datasourceEntity', [_truncate2.default, _types2.default, _datakeyConfigDialog2.default]).directive('tbDatasourceEntity', DatasourceEntity).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function DatasourceEntity($compile, $templateCache, $q, $mdDialog, $window, $document, $mdColorPicker, $mdConstant, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_datasourceEntityTpl2.default);
	        element.html(template);
	
	        scope.ngModelCtrl = ngModelCtrl;
	        scope.types = types;
	
	        scope.alarmFields = [];
	        for (var alarmField in types.alarmFields) {
	            scope.alarmFields.push(alarmField);
	        }
	
	        scope.selectedTimeseriesDataKey = null;
	        scope.timeseriesDataKeySearchText = null;
	
	        scope.selectedAttributeDataKey = null;
	        scope.attributeDataKeySearchText = null;
	
	        scope.selectedAlarmDataKey = null;
	        scope.alarmDataKeySearchText = null;
	
	        scope.updateValidity = function () {
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                var dataValid = angular.isDefined(value) && value != null;
	                ngModelCtrl.$setValidity('entityData', dataValid);
	                if (dataValid) {
	                    ngModelCtrl.$setValidity('entityAlias', angular.isDefined(value.entityAliasId) && value.entityAliasId != null);
	                    if (scope.optDataKeys) {
	                        ngModelCtrl.$setValidity('entityKeys', true);
	                    } else {
	                        ngModelCtrl.$setValidity('entityKeys', angular.isDefined(value.dataKeys) && value.dataKeys != null && value.dataKeys.length > 0);
	                    }
	                }
	            }
	        };
	
	        scope.$watch('entityAlias', function () {
	            if (ngModelCtrl.$viewValue) {
	                if (scope.entityAlias) {
	                    ngModelCtrl.$viewValue.entityAliasId = scope.entityAlias.id;
	                } else {
	                    ngModelCtrl.$viewValue.entityAliasId = null;
	                }
	                scope.updateValidity();
	                scope.selectedEntityAliasChange();
	            }
	        });
	
	        scope.$watch('timeseriesDataKeys', function () {
	            updateDataKeys();
	        }, true);
	
	        scope.$watch('attributeDataKeys', function () {
	            updateDataKeys();
	        }, true);
	
	        scope.$watch('alarmDataKeys', function () {
	            updateDataKeys();
	        }, true);
	
	        function updateDataKeys() {
	            if (ngModelCtrl.$viewValue) {
	                var dataKeys = [];
	                dataKeys = dataKeys.concat(scope.timeseriesDataKeys);
	                dataKeys = dataKeys.concat(scope.attributeDataKeys);
	                dataKeys = dataKeys.concat(scope.alarmDataKeys);
	                ngModelCtrl.$viewValue.dataKeys = dataKeys;
	                scope.updateValidity();
	            }
	        }
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                var entityAliasId = ngModelCtrl.$viewValue.entityAliasId;
	                var entityAliases = scope.aliasController.getEntityAliases();
	                if (entityAliases[entityAliasId]) {
	                    scope.entityAlias = entityAliases[entityAliasId];
	                } else {
	                    scope.entityAlias = null;
	                }
	                var timeseriesDataKeys = [];
	                var attributeDataKeys = [];
	                var alarmDataKeys = [];
	                for (var d in ngModelCtrl.$viewValue.dataKeys) {
	                    var dataKey = ngModelCtrl.$viewValue.dataKeys[d];
	                    if (dataKey.type === types.dataKeyType.timeseries) {
	                        timeseriesDataKeys.push(dataKey);
	                    } else if (dataKey.type === types.dataKeyType.attribute) {
	                        attributeDataKeys.push(dataKey);
	                    } else if (dataKey.type === types.dataKeyType.alarm) {
	                        alarmDataKeys.push(dataKey);
	                    }
	                }
	                scope.timeseriesDataKeys = timeseriesDataKeys;
	                scope.attributeDataKeys = attributeDataKeys;
	                scope.alarmDataKeys = alarmDataKeys;
	            }
	        };
	
	        scope.textIsNotEmpty = function (text) {
	            return text && text != null && text.length > 0 ? true : false;
	        };
	
	        scope.selectedEntityAliasChange = function () {
	            if (!scope.timeseriesDataKeySearchText || scope.timeseriesDataKeySearchText === '') {
	                scope.timeseriesDataKeySearchText = scope.timeseriesDataKeySearchText === '' ? null : '';
	            }
	            if (!scope.attributeDataKeySearchText || scope.attributeDataKeySearchText === '') {
	                scope.attributeDataKeySearchText = scope.attributeDataKeySearchText === '' ? null : '';
	            }
	            if (!scope.alarmDataKeySearchText || scope.alarmDataKeySearchText === '') {
	                scope.alarmDataKeySearchText = scope.alarmDataKeySearchText === '' ? null : '';
	            }
	        };
	
	        scope.transformTimeseriesDataKeyChip = function (chip) {
	            if (scope.maxDataKeys > 0 && ngModelCtrl.$viewValue.dataKeys.length >= scope.maxDataKeys) {
	                return null;
	            } else {
	                return scope.generateDataKey({ chip: chip, type: types.dataKeyType.timeseries });
	            }
	        };
	
	        scope.transformAttributeDataKeyChip = function (chip) {
	            if (scope.maxDataKeys > 0 && ngModelCtrl.$viewValue.dataKeys.length >= scope.maxDataKeys) {
	                return null;
	            } else {
	                return scope.generateDataKey({ chip: chip, type: types.dataKeyType.attribute });
	            }
	        };
	
	        scope.transformAlarmDataKeyChip = function (chip) {
	            return scope.generateDataKey({ chip: chip, type: types.dataKeyType.alarm });
	        };
	
	        scope.showColorPicker = function (event, dataKey) {
	            $mdColorPicker.show({
	                value: dataKey.color,
	                defaultValue: '#fff',
	                random: _tinycolor2.default.random(),
	                clickOutsideToClose: false,
	                hasBackdrop: false,
	                skipHide: true,
	                preserveScope: false,
	
	                mdColorAlphaChannel: true,
	                mdColorSpectrum: true,
	                mdColorSliders: true,
	                mdColorGenericPalette: false,
	                mdColorMaterialPalette: true,
	                mdColorHistory: false,
	                mdColorDefaultTab: 2,
	
	                $event: event
	
	            }).then(function (color) {
	                dataKey.color = color;
	                ngModelCtrl.$setDirty();
	            });
	        };
	
	        scope.editDataKey = function (event, dataKey, index) {
	
	            $mdDialog.show({
	                controller: 'DatakeyConfigDialogController',
	                controllerAs: 'vm',
	                templateUrl: _datakeyConfigDialogTpl2.default,
	                locals: {
	                    dataKey: angular.copy(dataKey),
	                    dataKeySettingsSchema: scope.datakeySettingsSchema,
	                    entityAlias: scope.entityAlias,
	                    aliasController: scope.aliasController
	                },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: event,
	                skipHide: true,
	                onComplete: function onComplete() {
	                    var w = angular.element($window);
	                    w.triggerHandler('resize');
	                }
	            }).then(function (dataKey) {
	                if (dataKey.type === types.dataKeyType.timeseries) {
	                    scope.timeseriesDataKeys[index] = dataKey;
	                } else if (dataKey.type === types.dataKeyType.attribute) {
	                    scope.attributeDataKeys[index] = dataKey;
	                } else if (dataKey.type === types.dataKeyType.alarm) {
	                    scope.alarmDataKeys[index] = dataKey;
	                }
	                ngModelCtrl.$setDirty();
	            }, function () {});
	        };
	
	        scope.dataKeysSearch = function (searchText, type) {
	            if (scope.widgetType == types.widgetType.alarm.value) {
	                var dataKeys = searchText ? scope.alarmFields.filter(scope.createFilterForDataKey(searchText)) : scope.alarmFields;
	                return dataKeys;
	            } else {
	                if (scope.entityAlias) {
	                    var deferred = $q.defer();
	                    scope.fetchEntityKeys({ entityAliasId: scope.entityAlias.id, query: searchText, type: type }).then(function (dataKeys) {
	                        deferred.resolve(dataKeys);
	                    }, function (e) {
	                        deferred.reject(e);
	                    });
	                    return deferred.promise;
	                } else {
	                    return $q.when([]);
	                }
	            }
	        };
	
	        scope.createFilterForDataKey = function (query) {
	            var lowercaseQuery = angular.lowercase(query);
	            return function filterFn(dataKey) {
	                return angular.lowercase(dataKey).indexOf(lowercaseQuery) === 0;
	            };
	        };
	
	        scope.createKey = function (event, chipsId) {
	            var chipsChild = (0, _jquery2.default)(chipsId, element)[0].firstElementChild;
	            var el = angular.element(chipsChild);
	            var chipBuffer = el.scope().$mdChipsCtrl.getChipBuffer();
	            event.preventDefault();
	            event.stopPropagation();
	            el.scope().$mdChipsCtrl.appendChip(chipBuffer.trim());
	            el.scope().$mdChipsCtrl.resetChipBuffer();
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            widgetType: '=',
	            maxDataKeys: '=',
	            optDataKeys: '=',
	            aliasController: '=',
	            datakeySettingsSchema: '=',
	            generateDataKey: '&',
	            fetchEntityKeys: '&',
	            onCreateEntityAlias: '&'
	        },
	        link: linker
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DatasourceFunc.$inject = ["$compile", "$templateCache", "$mdDialog", "$window", "$document", "$mdColorPicker", "types", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(750);
	
	__webpack_require__(226);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _utils = __webpack_require__(90);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _datakeyConfigDialog = __webpack_require__(230);
	
	var _datakeyConfigDialog2 = _interopRequireDefault(_datakeyConfigDialog);
	
	var _datasourceFuncTpl = __webpack_require__(1394);
	
	var _datasourceFuncTpl2 = _interopRequireDefault(_datasourceFuncTpl);
	
	var _datakeyConfigDialogTpl = __webpack_require__(518);
	
	var _datakeyConfigDialogTpl2 = _interopRequireDefault(_datakeyConfigDialogTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable angular/angularelement */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.directives.datasourceFunc', [_types2.default, _utils2.default, _datakeyConfigDialog2.default]).directive('tbDatasourceFunc', DatasourceFunc).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function DatasourceFunc($compile, $templateCache, $mdDialog, $window, $document, $mdColorPicker, types, utils) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_datasourceFuncTpl2.default);
	        element.html(template);
	
	        scope.ngModelCtrl = ngModelCtrl;
	        scope.types = types;
	
	        scope.functionTypes = utils.getPredefinedFunctionsList();
	        scope.alarmFields = [];
	        for (var alarmField in types.alarmFields) {
	            scope.alarmFields.push(alarmField);
	        }
	
	        scope.selectedDataKey = null;
	        scope.dataKeySearchText = null;
	
	        scope.selectedAlarmDataKey = null;
	        scope.alarmDataKeySearchText = null;
	
	        scope.updateValidity = function () {
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                var dataValid = angular.isDefined(value) && value != null;
	                ngModelCtrl.$setValidity('deviceData', dataValid);
	                if (dataValid) {
	                    if (scope.optDataKeys) {
	                        ngModelCtrl.$setValidity('datasourceKeys', true);
	                    } else {
	                        ngModelCtrl.$setValidity('datasourceKeys', angular.isDefined(value.dataKeys) && value.dataKeys != null && value.dataKeys.length > 0);
	                    }
	                }
	            }
	        };
	
	        scope.$watch('funcDataKeys', function () {
	            updateDataKeys();
	        }, true);
	
	        scope.$watch('alarmDataKeys', function () {
	            updateDataKeys();
	        }, true);
	
	        function updateDataKeys() {
	            if (ngModelCtrl.$viewValue) {
	                var dataKeys = [];
	                dataKeys = dataKeys.concat(scope.funcDataKeys);
	                dataKeys = dataKeys.concat(scope.alarmDataKeys);
	                ngModelCtrl.$viewValue.dataKeys = dataKeys;
	                scope.updateValidity();
	            }
	        }
	
	        scope.$watch('datasourceName', function () {
	            if (ngModelCtrl.$viewValue) {
	                ngModelCtrl.$viewValue.name = scope.datasourceName;
	                scope.updateValidity();
	            }
	        });
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                var funcDataKeys = [];
	                var alarmDataKeys = [];
	                if (ngModelCtrl.$viewValue.dataKeys) {
	                    for (var d = 0; d < ngModelCtrl.$viewValue.dataKeys.length; d++) {
	                        var dataKey = ngModelCtrl.$viewValue.dataKeys[d];
	                        if (dataKey.type === types.dataKeyType.function) {
	                            funcDataKeys.push(dataKey);
	                        } else if (dataKey.type === types.dataKeyType.alarm) {
	                            alarmDataKeys.push(dataKey);
	                        }
	                    }
	                }
	                scope.funcDataKeys = funcDataKeys;
	                scope.alarmDataKeys = alarmDataKeys;
	                scope.datasourceName = ngModelCtrl.$viewValue.name;
	            }
	        };
	
	        scope.transformFuncDataKeyChip = function (chip) {
	            if (scope.maxDataKeys > 0 && ngModelCtrl.$viewValue.dataKeys.length >= scope.maxDataKeys) {
	                return null;
	            } else {
	                return scope.generateDataKey({ chip: chip, type: types.dataKeyType.function });
	            }
	        };
	
	        scope.transformAlarmDataKeyChip = function (chip) {
	            return scope.generateDataKey({ chip: chip, type: types.dataKeyType.alarm });
	        };
	
	        scope.showColorPicker = function (event, dataKey) {
	            $mdColorPicker.show({
	                value: dataKey.color,
	                defaultValue: '#fff',
	                random: _tinycolor2.default.random(),
	                clickOutsideToClose: false,
	                hasBackdrop: false,
	                skipHide: true,
	                preserveScope: false,
	
	                mdColorAlphaChannel: true,
	                mdColorSpectrum: true,
	                mdColorSliders: true,
	                mdColorGenericPalette: false,
	                mdColorMaterialPalette: true,
	                mdColorHistory: false,
	                mdColorDefaultTab: 2,
	
	                $event: event
	
	            }).then(function (color) {
	                dataKey.color = color;
	                ngModelCtrl.$setDirty();
	            });
	        };
	
	        scope.editDataKey = function (event, dataKey, index) {
	
	            $mdDialog.show({
	                controller: 'DatakeyConfigDialogController',
	                controllerAs: 'vm',
	                templateUrl: _datakeyConfigDialogTpl2.default,
	                locals: {
	                    dataKey: angular.copy(dataKey),
	                    dataKeySettingsSchema: scope.datakeySettingsSchema,
	                    entityAlias: null,
	                    aliasController: null
	                },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: event,
	                skipHide: true,
	                onComplete: function onComplete() {
	                    var w = angular.element($window);
	                    w.triggerHandler('resize');
	                }
	            }).then(function (dataKey) {
	                if (dataKey.type === types.dataKeyType.function) {
	                    scope.funcDataKeys[index] = dataKey;
	                } else if (dataKey.type === types.dataKeyType.alarm) {
	                    scope.alarmDataKeys[index] = dataKey;
	                }
	                ngModelCtrl.$setDirty();
	            }, function () {});
	        };
	
	        scope.textIsNotEmpty = function (text) {
	            return text && text != null && text.length > 0 ? true : false;
	        };
	
	        scope.dataKeysSearch = function (dataKeySearchText) {
	            var targetKeys = scope.widgetType == types.widgetType.alarm.value ? scope.alarmFields : scope.functionTypes;
	            var dataKeys = dataKeySearchText ? targetKeys.filter(scope.createFilterForDataKey(dataKeySearchText)) : targetKeys;
	            return dataKeys;
	        };
	
	        scope.createFilterForDataKey = function (query) {
	            var lowercaseQuery = angular.lowercase(query);
	            return function filterFn(dataKey) {
	                return angular.lowercase(dataKey).indexOf(lowercaseQuery) === 0;
	            };
	        };
	
	        scope.createKey = function (event, chipsId) {
	            var chipsChild = (0, _jquery2.default)(chipsId, element)[0].firstElementChild;
	            var el = angular.element(chipsChild);
	            var chipBuffer = el.scope().$mdChipsCtrl.getChipBuffer();
	            event.preventDefault();
	            event.stopPropagation();
	            el.scope().$mdChipsCtrl.appendChip(chipBuffer.trim());
	            el.scope().$mdChipsCtrl.resetChipBuffer();
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            widgetType: '=',
	            maxDataKeys: '=',
	            optDataKeys: '=',
	            generateDataKey: '&',
	            datakeySettingsSchema: '='
	        },
	        link: linker
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Datasource.$inject = ["$compile", "$templateCache", "utils", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(751);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _datasourceFunc = __webpack_require__(1175);
	
	var _datasourceFunc2 = _interopRequireDefault(_datasourceFunc);
	
	var _datasourceEntity = __webpack_require__(1174);
	
	var _datasourceEntity2 = _interopRequireDefault(_datasourceEntity);
	
	var _datasourceTpl = __webpack_require__(1395);
	
	var _datasourceTpl2 = _interopRequireDefault(_datasourceTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.directives.datasource', [_types2.default, _datasourceFunc2.default, _datasourceEntity2.default]).directive('tbDatasource', Datasource).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function Datasource($compile, $templateCache, utils, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_datasourceTpl2.default);
	        element.html(template);
	
	        scope.types = types;
	
	        if (scope.functionsOnly) {
	            scope.datasourceTypes = [types.datasourceType.function];
	        } else {
	            scope.datasourceTypes = [types.datasourceType.entity, types.datasourceType.function];
	        }
	
	        scope.updateView = function () {
	            if (!scope.model.dataKeys) {
	                scope.model.dataKeys = [];
	            }
	            ngModelCtrl.$setViewValue(scope.model);
	        };
	
	        scope.$watch('model.type', function (newType, prevType) {
	            if (newType && prevType && newType != prevType) {
	                if (scope.widgetType == types.widgetType.alarm.value) {
	                    scope.model.dataKeys = utils.getDefaultAlarmDataKeys();
	                } else {
	                    scope.model.dataKeys = [];
	                }
	            }
	        });
	
	        scope.$watch('model', function () {
	            scope.updateView();
	        }, true);
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                scope.model = ngModelCtrl.$viewValue;
	            } else {
	                scope.model = {};
	            }
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            aliasController: '=',
	            maxDataKeys: '=',
	            optDataKeys: '=',
	            widgetType: '=',
	            functionsOnly: '=',
	            datakeySettingsSchema: '=',
	            generateDataKey: '&',
	            fetchEntityKeys: '&',
	            onCreateEntityAlias: '&'
	        },
	        link: linker
	    };
	}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DatetimePeriod.$inject = ["$compile", "$templateCache"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(752);
	
	var _datetimePeriodTpl = __webpack_require__(1396);
	
	var _datetimePeriodTpl2 = _interopRequireDefault(_datetimePeriodTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.datetimePeriod', []).directive('tbDatetimePeriod', DatetimePeriod).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function DatetimePeriod($compile, $templateCache) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_datetimePeriodTpl2.default);
	        element.html(template);
	
	        ngModelCtrl.$render = function () {
	            var date = new Date();
	            scope.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
	            scope.endDate = date;
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                scope.startDate = new Date(value.startTimeMs);
	                scope.endDate = new Date(value.endTimeMs);
	            }
	        };
	
	        scope.updateMinMaxDates = function () {
	            scope.maxStartDate = angular.copy(new Date(scope.endDate.getTime() - 1000));
	            scope.minEndDate = angular.copy(new Date(scope.startDate.getTime() + 1000));
	            scope.maxEndDate = new Date();
	        };
	
	        scope.updateView = function () {
	            var value = null;
	            if (scope.startDate && scope.endDate) {
	                value = {
	                    startTimeMs: scope.startDate.getTime(),
	                    endTimeMs: scope.endDate.getTime()
	                };
	                ngModelCtrl.$setValidity('datetimePeriod', true);
	            } else {
	                ngModelCtrl.$setValidity('datetimePeriod', !scope.required);
	            }
	            ngModelCtrl.$setViewValue(value);
	        };
	
	        scope.$watch('required', function () {
	            scope.updateView();
	        });
	
	        scope.$watch('startDate', function (newDate) {
	            if (newDate) {
	                if (newDate.getTime() > scope.maxStartDate) {
	                    scope.startDate = angular.copy(scope.maxStartDate);
	                }
	                scope.updateMinMaxDates();
	            }
	            scope.updateView();
	        });
	
	        scope.$watch('endDate', function (newDate) {
	            if (newDate) {
	                if (newDate.getTime() < scope.minEndDate) {
	                    scope.endDate = angular.copy(scope.minEndDate);
	                } else if (newDate.getTime() > scope.maxEndDate) {
	                    scope.endDate = angular.copy(scope.maxEndDate);
	                }
	                scope.updateMinMaxDates();
	            }
	            scope.updateView();
	        });
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            required: '=ngRequired'
	        },
	        link: linker
	    };
	}

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityAliasSelect.$inject = ["$compile", "$templateCache", "$mdConstant", "entityService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(754);
	
	var _entityAliasSelectTpl = __webpack_require__(1398);
	
	var _entityAliasSelectTpl2 = _interopRequireDefault(_entityAliasSelectTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable angular/angularelement */
	
	exports.default = angular.module('thingsboard.directives.entityAliasSelect', []).directive('tbEntityAliasSelect', EntityAliasSelect).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function EntityAliasSelect($compile, $templateCache, $mdConstant, entityService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_entityAliasSelectTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	
	        scope.ngModelCtrl = ngModelCtrl;
	        scope.entityAliasList = [];
	        scope.entityAlias = null;
	
	        scope.updateValidity = function () {
	            var value = ngModelCtrl.$viewValue;
	            var valid = angular.isDefined(value) && value != null || !scope.tbRequired;
	            ngModelCtrl.$setValidity('entityAlias', valid);
	        };
	
	        scope.$watch('aliasController', function () {
	            scope.entityAliasList = [];
	            var entityAliases = scope.aliasController.getEntityAliases();
	            for (var aliasId in entityAliases) {
	                if (scope.allowedEntityTypes) {
	                    if (!entityService.filterAliasByEntityTypes(entityAliases[aliasId], scope.allowedEntityTypes)) {
	                        continue;
	                    }
	                }
	                scope.entityAliasList.push(entityAliases[aliasId]);
	            }
	        });
	
	        scope.$watch('entityAlias', function () {
	            scope.updateView();
	        });
	
	        scope.entityAliasSearch = function (entityAliasSearchText) {
	            return entityAliasSearchText ? scope.entityAliasList.filter(scope.createFilterForEntityAlias(entityAliasSearchText)) : scope.entityAliasList;
	        };
	
	        scope.createFilterForEntityAlias = function (query) {
	            var lowercaseQuery = angular.lowercase(query);
	            return function filterFn(entityAlias) {
	                return angular.lowercase(entityAlias.alias).indexOf(lowercaseQuery) === 0;
	            };
	        };
	
	        scope.updateView = function () {
	            ngModelCtrl.$setViewValue(scope.entityAlias);
	            scope.updateValidity();
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                scope.entityAlias = ngModelCtrl.$viewValue;
	            }
	        };
	
	        scope.textIsNotEmpty = function (text) {
	            return text && text != null && text.length > 0 ? true : false;
	        };
	
	        scope.entityAliasEnter = function ($event) {
	            if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
	                $event.preventDefault();
	                if (!scope.entityAlias) {
	                    var found = scope.entityAliasSearch(scope.entityAliasSearchText);
	                    found = found.length > 0;
	                    if (!found) {
	                        scope.createEntityAlias($event, scope.entityAliasSearchText);
	                    }
	                }
	            }
	        };
	
	        scope.createEntityAlias = function (event, alias) {
	            var autoChild = (0, _jquery2.default)('#entity-autocomplete', element)[0].firstElementChild;
	            var el = angular.element(autoChild);
	            el.scope().$mdAutocompleteCtrl.hidden = true;
	            el.scope().$mdAutocompleteCtrl.hasNotFound = false;
	            event.preventDefault();
	            var promise = scope.onCreateEntityAlias({ event: event, alias: alias, allowedEntityTypes: scope.allowedEntityTypes });
	            if (promise) {
	                promise.then(function success(newAlias) {
	                    el.scope().$mdAutocompleteCtrl.hasNotFound = true;
	                    if (newAlias) {
	                        scope.entityAliasList.push(newAlias);
	                        scope.entityAlias = newAlias;
	                    }
	                }, function fail() {
	                    el.scope().$mdAutocompleteCtrl.hasNotFound = true;
	                });
	            } else {
	                el.scope().$mdAutocompleteCtrl.hasNotFound = true;
	            }
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            tbRequired: '=?',
	            aliasController: '=',
	            allowedEntityTypes: '=?',
	            onCreateEntityAlias: '&'
	        }
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	'use strict';
	
	OnFinishRender.$inject = ["$timeout"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.finishRender', []).directive('tbOnFinishRender', OnFinishRender).name;
	
	/*@ngInject*/
	
	function OnFinishRender($timeout) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attr) {
	            if (scope.$last === true) {
	                $timeout(function () {
	                    scope.$emit(attr.tbOnFinishRender);
	                });
	            }
	        }
	    };
	}

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	JsFunc.$inject = ["$compile", "$templateCache", "toast", "utils", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                               * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                               * limitations under the License.
	                                                                                                                                                                                                                                                                               */
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/* eslint-enable import/no-unresolved, import/default */
	
	__webpack_require__(757);
	
	var _brace = __webpack_require__(168);
	
	var _brace2 = _interopRequireDefault(_brace);
	
	__webpack_require__(33);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _toast = __webpack_require__(75);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _utils = __webpack_require__(90);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _expandFullscreen = __webpack_require__(231);
	
	var _expandFullscreen2 = _interopRequireDefault(_expandFullscreen);
	
	var _aceEditorFix = __webpack_require__(114);
	
	var _aceEditorFix2 = _interopRequireDefault(_aceEditorFix);
	
	var _jsFuncTpl = __webpack_require__(1400);
	
	var _jsFuncTpl2 = _interopRequireDefault(_jsFuncTpl);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var js_beautify = _jsBeautify2.default.js;
	
	/* eslint-disable angular/angularelement */
	
	exports.default = angular.module('thingsboard.directives.jsFunc', [_toast2.default, _utils2.default, _expandFullscreen2.default]).directive('tbJsFunc', JsFunc).name;
	
	/*@ngInject*/
	
	function JsFunc($compile, $templateCache, toast, utils, $translate) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_jsFuncTpl2.default);
	        element.html(template);
	
	        scope.functionName = attrs.functionName;
	        scope.functionArgs = scope.$eval(attrs.functionArgs);
	        scope.validationArgs = scope.$eval(attrs.validationArgs);
	        scope.resultType = attrs.resultType;
	        if (!scope.resultType || scope.resultType.length === 0) {
	            scope.resultType = "nocheck";
	        }
	
	        scope.validationTriggerArg = attrs.validationTriggerArg;
	
	        scope.functionValid = true;
	
	        var Range = _brace2.default.acequire("ace/range").Range;
	        scope.js_editor;
	        scope.errorMarkers = [];
	
	        scope.functionArgsString = '';
	        for (var i = 0; i < scope.functionArgs.length; i++) {
	            if (scope.functionArgsString.length > 0) {
	                scope.functionArgsString += ', ';
	            }
	            scope.functionArgsString += scope.functionArgs[i];
	        }
	
	        scope.onFullscreenChanged = function () {
	            updateEditorSize();
	        };
	
	        scope.beautifyJs = function () {
	            var res = js_beautify(scope.functionBody, { indent_size: 4, wrap_line_length: 60 });
	            scope.functionBody = res;
	        };
	
	        function updateEditorSize() {
	            if (scope.js_editor) {
	                scope.js_editor.resize();
	                scope.js_editor.renderer.updateFull();
	            }
	        }
	
	        scope.jsEditorOptions = {
	            useWrapMode: true,
	            mode: 'javascript',
	            advanced: {
	                enableSnippets: true,
	                enableBasicAutocompletion: true,
	                enableLiveAutocompletion: true
	            },
	            onLoad: function onLoad(_ace) {
	                scope.js_editor = _ace;
	                scope.js_editor.session.on("change", function () {
	                    scope.cleanupJsErrors();
	                });
	                (0, _aceEditorFix2.default)(_ace);
	            }
	        };
	
	        scope.cleanupJsErrors = function () {
	            toast.hide();
	            for (var i = 0; i < scope.errorMarkers.length; i++) {
	                scope.js_editor.session.removeMarker(scope.errorMarkers[i]);
	            }
	            scope.errorMarkers = [];
	            if (scope.errorAnnotationId && scope.errorAnnotationId > -1) {
	                var annotations = scope.js_editor.session.getAnnotations();
	                annotations.splice(scope.errorAnnotationId, 1);
	                scope.js_editor.session.setAnnotations(annotations);
	                scope.errorAnnotationId = -1;
	            }
	        };
	
	        scope.updateValidity = function () {
	            ngModelCtrl.$setValidity('functionBody', scope.functionValid);
	        };
	
	        scope.$watch('functionBody', function (newFunctionBody, oldFunctionBody) {
	            ngModelCtrl.$setViewValue(scope.functionBody);
	            if (!angular.equals(newFunctionBody, oldFunctionBody)) {
	                scope.functionValid = true;
	            }
	            scope.updateValidity();
	        });
	
	        ngModelCtrl.$render = function () {
	            scope.functionBody = ngModelCtrl.$viewValue;
	        };
	
	        scope.showError = function (error) {
	            var toastParent = (0, _jquery2.default)('#tb-javascript-panel', element);
	            var dialogContent = toastParent.closest('md-dialog-content');
	            if (dialogContent.length > 0) {
	                toastParent = dialogContent;
	            }
	            toast.showError(error, toastParent, 'bottom left');
	        };
	
	        scope.validate = function () {
	            try {
	                var toValidate = new Function(scope.functionArgsString, scope.functionBody);
	                if (scope.noValidate) {
	                    return true;
	                }
	                var res;
	                var validationError;
	                for (var i = 0; i < scope.validationArgs.length; i++) {
	                    try {
	                        res = toValidate.apply(this, scope.validationArgs[i]);
	                        validationError = null;
	                        break;
	                    } catch (e) {
	                        validationError = e;
	                    }
	                }
	                if (validationError) {
	                    throw validationError;
	                }
	                if (scope.resultType != 'nocheck') {
	                    if (scope.resultType === 'any') {
	                        if (angular.isUndefined(res)) {
	                            scope.showError($translate.instant('js-func.no-return-error'));
	                            return false;
	                        }
	                    } else {
	                        var resType = typeof res === 'undefined' ? 'undefined' : _typeof(res);
	                        if (resType != scope.resultType) {
	                            scope.showError($translate.instant('js-func.return-type-mismatch', { type: scope.resultType }));
	                            return false;
	                        }
	                    }
	                }
	                return true;
	            } catch (e) {
	                var details = utils.parseException(e);
	                var errorInfo = 'Error:';
	                if (details.name) {
	                    errorInfo += ' ' + details.name + ':';
	                }
	                if (details.message) {
	                    errorInfo += ' ' + details.message;
	                }
	                if (details.lineNumber) {
	                    errorInfo += '<br>Line ' + details.lineNumber;
	                    if (details.columnNumber) {
	                        errorInfo += ' column ' + details.columnNumber;
	                    }
	                    errorInfo += ' of script.';
	                }
	                scope.showError(errorInfo);
	                if (scope.js_editor && details.lineNumber) {
	                    var line = details.lineNumber - 1;
	                    var column = 0;
	                    if (details.columnNumber) {
	                        column = details.columnNumber;
	                    }
	
	                    var errorMarkerId = scope.js_editor.session.addMarker(new Range(line, 0, line, Infinity), "ace_active-line", "screenLine");
	                    scope.errorMarkers.push(errorMarkerId);
	                    var annotations = scope.js_editor.session.getAnnotations();
	                    var errorAnnotation = {
	                        row: line,
	                        column: column,
	                        text: details.message,
	                        type: "error"
	                    };
	                    scope.errorAnnotationId = annotations.push(errorAnnotation) - 1;
	                    scope.js_editor.session.setAnnotations(annotations);
	                }
	                return false;
	            }
	        };
	
	        scope.$on('form-submit', function (event, args) {
	            if (!args || scope.validationTriggerArg && scope.validationTriggerArg == args) {
	                scope.validationArgs = scope.$eval(attrs.validationArgs);
	                scope.cleanupJsErrors();
	                scope.functionValid = true;
	                scope.updateValidity();
	                scope.functionValid = scope.validate();
	                scope.updateValidity();
	            }
	        });
	
	        scope.$on('update-ace-editor-size', function () {
	            updateEditorSize();
	        });
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            disabled: '=ngDisabled',
	            noValidate: '=?',
	            fillHeight: '=?'
	        },
	        link: linker
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	JsonContent.$inject = ["$compile", "$templateCache", "toast", "types", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(758);
	
	__webpack_require__(33);
	
	__webpack_require__(51);
	
	__webpack_require__(648);
	
	__webpack_require__(169);
	
	__webpack_require__(279);
	
	var _aceEditorFix = __webpack_require__(114);
	
	var _aceEditorFix2 = _interopRequireDefault(_aceEditorFix);
	
	var _jsonContentTpl = __webpack_require__(1401);
	
	var _jsonContentTpl2 = _interopRequireDefault(_jsonContentTpl);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/no-unresolved, import/default */
	
	var js_beautify = _jsBeautify2.default.js;
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.jsonContent', []).directive('tbJsonContent', JsonContent).name;
	
	/*@ngInject*/
	
	function JsonContent($compile, $templateCache, toast, types, utils) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_jsonContentTpl2.default);
	        element.html(template);
	
	        scope.label = attrs.label;
	
	        scope.validationTriggerArg = attrs.validationTriggerArg;
	
	        scope.contentValid = true;
	
	        scope.json_editor;
	
	        scope.onFullscreenChanged = function () {
	            updateEditorSize();
	        };
	
	        scope.beautifyJson = function () {
	            var res = js_beautify(scope.contentBody, { indent_size: 4, wrap_line_length: 60 });
	            scope.contentBody = res;
	        };
	
	        function updateEditorSize() {
	            if (scope.json_editor) {
	                scope.json_editor.resize();
	                scope.json_editor.renderer.updateFull();
	            }
	        }
	
	        var mode;
	        if (scope.contentType) {
	            mode = types.contentType[scope.contentType].code;
	        } else {
	            mode = 'text';
	        }
	
	        scope.jsonEditorOptions = {
	            useWrapMode: true,
	            mode: mode,
	            advanced: {
	                enableSnippets: true,
	                enableBasicAutocompletion: true,
	                enableLiveAutocompletion: true
	            },
	            onLoad: function onLoad(_ace) {
	                scope.json_editor = _ace;
	                scope.json_editor.session.on("change", function () {
	                    scope.cleanupJsonErrors();
	                });
	                (0, _aceEditorFix2.default)(_ace);
	            }
	        };
	
	        scope.$watch('contentType', function () {
	            var mode;
	            if (scope.contentType) {
	                mode = types.contentType[scope.contentType].code;
	            } else {
	                mode = 'text';
	            }
	            if (scope.json_editor) {
	                scope.json_editor.session.setMode('ace/mode/' + mode);
	            }
	        });
	
	        scope.cleanupJsonErrors = function () {
	            toast.hide();
	        };
	
	        scope.updateValidity = function () {
	            ngModelCtrl.$setValidity('contentBody', scope.contentValid);
	        };
	
	        scope.$watch('contentBody', function (newContent, oldContent) {
	            ngModelCtrl.$setViewValue(scope.contentBody);
	            if (!angular.equals(newContent, oldContent)) {
	                scope.contentValid = true;
	            }
	            scope.updateValidity();
	        });
	
	        ngModelCtrl.$render = function () {
	            scope.contentBody = ngModelCtrl.$viewValue;
	        };
	
	        scope.showError = function (error) {
	            var toastParent = angular.element('#tb-json-panel', element);
	            toast.showError(error, toastParent, 'bottom left');
	        };
	
	        scope.validate = function () {
	            try {
	                if (scope.validateContent) {
	                    if (scope.contentType == types.contentType.JSON.value) {
	                        angular.fromJson(scope.contentBody);
	                    }
	                }
	                return true;
	            } catch (e) {
	                var details = utils.parseException(e);
	                var errorInfo = 'Error:';
	                if (details.name) {
	                    errorInfo += ' ' + details.name + ':';
	                }
	                if (details.message) {
	                    errorInfo += ' ' + details.message;
	                }
	                scope.showError(errorInfo);
	                return false;
	            }
	        };
	
	        scope.$on('form-submit', function (event, args) {
	            if (!scope.readonly) {
	                if (!args || scope.validationTriggerArg && scope.validationTriggerArg == args) {
	                    scope.cleanupJsonErrors();
	                    scope.contentValid = true;
	                    scope.updateValidity();
	                    scope.contentValid = scope.validate();
	                    scope.updateValidity();
	                }
	            }
	        });
	
	        scope.$on('update-ace-editor-size', function () {
	            updateEditorSize();
	        });
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            contentType: '=',
	            validateContent: '=?',
	            readonly: '=ngReadonly',
	            fillHeight: '=?'
	        },
	        link: linker
	    };
	}

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	JsonObjectEdit.$inject = ["$compile", "$templateCache", "$document", "toast", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(760);
	
	__webpack_require__(33);
	
	__webpack_require__(51);
	
	__webpack_require__(169);
	
	var _aceEditorFix = __webpack_require__(114);
	
	var _aceEditorFix2 = _interopRequireDefault(_aceEditorFix);
	
	var _jsonObjectEditTpl = __webpack_require__(1403);
	
	var _jsonObjectEditTpl2 = _interopRequireDefault(_jsonObjectEditTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.jsonObjectEdit', []).directive('tbJsonObjectEdit', JsonObjectEdit).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function JsonObjectEdit($compile, $templateCache, $document, toast, utils) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_jsonObjectEditTpl2.default);
	        element.html(template);
	
	        scope.label = attrs.label;
	
	        scope.objectValid = true;
	        scope.validationError = '';
	
	        scope.json_editor;
	
	        scope.onFullscreenChanged = function () {
	            updateEditorSize();
	        };
	
	        function updateEditorSize() {
	            if (scope.json_editor) {
	                scope.json_editor.resize();
	                scope.json_editor.renderer.updateFull();
	            }
	        }
	
	        scope.jsonEditorOptions = {
	            useWrapMode: true,
	            mode: 'json',
	            advanced: {
	                enableSnippets: true,
	                enableBasicAutocompletion: true,
	                enableLiveAutocompletion: true
	            },
	            onLoad: function onLoad(_ace) {
	                scope.json_editor = _ace;
	                scope.json_editor.session.on("change", function () {
	                    scope.cleanupJsonErrors();
	                });
	                (0, _aceEditorFix2.default)(_ace);
	            }
	        };
	
	        scope.cleanupJsonErrors = function () {
	            toast.hide();
	        };
	
	        scope.updateValidity = function () {
	            ngModelCtrl.$setValidity('objectValid', scope.objectValid);
	        };
	
	        scope.$watch('contentBody', function (newVal, prevVal) {
	            if (!angular.equals(newVal, prevVal)) {
	                var object = scope.validate();
	                if (scope.objectValid) {
	                    if (object == null) {
	                        scope.object = null;
	                    } else {
	                        if (scope.object == null) {
	                            scope.object = {};
	                        }
	                        Object.keys(scope.object).forEach(function (key) {
	                            delete scope.object[key];
	                        });
	                        Object.keys(object).forEach(function (key) {
	                            scope.object[key] = object[key];
	                        });
	                    }
	                    ngModelCtrl.$setViewValue(scope.object);
	                }
	                scope.updateValidity();
	            }
	        });
	
	        ngModelCtrl.$render = function () {
	            scope.object = ngModelCtrl.$viewValue;
	            var content = '';
	            try {
	                if (scope.object) {
	                    content = angular.toJson(scope.object, true);
	                }
	            } catch (e) {
	                //
	            }
	            scope.contentBody = content;
	        };
	
	        scope.showError = function (error) {
	            var toastParent = angular.element('#tb-json-panel', element);
	            toast.showError(error, toastParent, 'bottom left');
	        };
	
	        scope.validate = function () {
	            if (!scope.contentBody || !scope.contentBody.length) {
	                if (scope.required) {
	                    scope.validationError = 'Json object is required.';
	                    scope.objectValid = false;
	                } else {
	                    scope.validationError = '';
	                    scope.objectValid = true;
	                }
	                return null;
	            } else {
	                try {
	                    var object = angular.fromJson(scope.contentBody);
	                    scope.validationError = '';
	                    scope.objectValid = true;
	                    return object;
	                } catch (e) {
	                    var details = utils.parseException(e);
	                    var errorInfo = 'Error:';
	                    if (details.name) {
	                        errorInfo += ' ' + details.name + ':';
	                    }
	                    if (details.message) {
	                        errorInfo += ' ' + details.message;
	                    }
	                    scope.validationError = errorInfo;
	                    scope.objectValid = false;
	                    return null;
	                }
	            }
	        };
	
	        scope.$on('form-submit', function () {
	            if (!scope.readonly) {
	                scope.cleanupJsonErrors();
	                if (!scope.objectValid) {
	                    scope.showError(scope.validationError);
	                }
	            }
	        });
	
	        scope.$on('update-ace-editor-size', function () {
	            updateEditorSize();
	        });
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            required: '=ngRequired',
	            readonly: '=ngReadonly',
	            fillHeight: '=?'
	        },
	        link: linker
	    };
	}

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	'use strict';
	
	KeyboardShortcut.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.filters.keyboardShortcut', []).filter('keyboardShortcut', KeyboardShortcut).name;
	
	/*@ngInject*/
	
	function KeyboardShortcut($window) {
	    return function (str) {
	        if (!str) return;
	        var keys = str.split('-');
	        var isOSX = /Mac OS X/.test($window.navigator.userAgent);
	
	        var seperator = !isOSX || keys.length > 2 ? '+' : '';
	
	        var abbreviations = {
	            M: isOSX ? '⌘' : 'Ctrl',
	            A: isOSX ? 'Option' : 'Alt',
	            S: 'Shift'
	        };
	
	        return keys.map(function (key, index) {
	            var last = index == keys.length - 1;
	            return last ? key : abbreviations[key];
	        }).join(seperator);
	    };
	}

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	KeyValMapController.$inject = ["$scope", "$mdUtil"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(761);
	
	var _kvMapTpl = __webpack_require__(1404);
	
	var _kvMapTpl2 = _interopRequireDefault(_kvMapTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.keyValMap', []).directive('tbKeyValMap', KeyValMap).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function KeyValMap() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            disabled: '=ngDisabled',
	            titleText: '@?',
	            keyPlaceholderText: '@?',
	            valuePlaceholderText: '@?',
	            noDataText: '@?',
	            keyValMap: '='
	        },
	        controller: KeyValMapController,
	        controllerAs: 'vm',
	        templateUrl: _kvMapTpl2.default
	    };
	}
	
	/*@ngInject*/
	function KeyValMapController($scope, $mdUtil) {
	
	    var vm = this;
	
	    vm.kvList = [];
	
	    vm.removeKeyVal = removeKeyVal;
	    vm.addKeyVal = addKeyVal;
	
	    $scope.$watch('vm.keyValMap', function () {
	        stopWatchKvList();
	        vm.kvList.length = 0;
	        if (vm.keyValMap) {
	            for (var property in vm.keyValMap) {
	                if (vm.keyValMap.hasOwnProperty(property)) {
	                    vm.kvList.push({
	                        key: property + '',
	                        value: vm.keyValMap[property]
	                    });
	                }
	            }
	        }
	        $mdUtil.nextTick(function () {
	            watchKvList();
	        });
	    });
	
	    function watchKvList() {
	        $scope.kvListWatcher = $scope.$watch('vm.kvList', function () {
	            if (!vm.keyValMap) {
	                return;
	            }
	            for (var property in vm.keyValMap) {
	                if (vm.keyValMap.hasOwnProperty(property)) {
	                    delete vm.keyValMap[property];
	                }
	            }
	            for (var i = 0; i < vm.kvList.length; i++) {
	                var entry = vm.kvList[i];
	                vm.keyValMap[entry.key] = entry.value;
	            }
	        }, true);
	    }
	
	    function stopWatchKvList() {
	        if ($scope.kvListWatcher) {
	            $scope.kvListWatcher();
	            $scope.kvListWatcher = null;
	        }
	    }
	
	    function removeKeyVal(index) {
	        if (index > -1) {
	            vm.kvList.splice(index, 1);
	        }
	    }
	
	    function addKeyVal() {
	        if (!vm.kvList) {
	            vm.kvList = [];
	        }
	        vm.kvList.push({
	            key: '',
	            value: ''
	        });
	    }
	}

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	LedLight.$inject = ["$compile"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _raphael = __webpack_require__(1564);
	
	var _raphael2 = _interopRequireDefault(_raphael);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable angular/angularelement */
	
	exports.default = angular.module('thingsboard.directives.ledLight', []).directive('tbLedLight', LedLight).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function LedLight($compile) {
	
	    var linker = function linker(scope, element) {
	        scope.offOpacity = scope.offOpacity || "0.4";
	        scope.glowColor = (0, _tinycolor2.default)(scope.colorOn).lighten().toHexString();
	
	        scope.$watch('tbEnabled', function () {
	            scope.draw();
	        });
	
	        scope.$watch('size', function () {
	            scope.update();
	        });
	
	        scope.draw = function () {
	            if (scope.tbEnabled) {
	                scope.circleElement.attr("fill", scope.colorOn);
	                scope.circleElement.attr("stroke", scope.colorOn);
	                scope.circleElement.attr("opacity", "1");
	
	                if (scope.circleElement.theGlow) {
	                    scope.circleElement.theGlow.remove();
	                }
	
	                scope.circleElement.theGlow = scope.circleElement.glow({
	                    color: scope.glowColor,
	                    width: scope.radius + scope.glowSize,
	                    opacity: 0.8,
	                    fill: true
	                });
	            } else {
	                if (scope.circleElement.theGlow) {
	                    scope.circleElement.theGlow.remove();
	                }
	
	                /*scope.circleElement.theGlow = scope.circleElement.glow(
	                 {
	                 color: scope.glowColor,
	                 width: scope.radius + scope.glowSize,
	                 opacity: 0.4,
	                 fill: true
	                 });*/
	
	                scope.circleElement.attr("fill", scope.colorOff);
	                scope.circleElement.attr("stroke", scope.colorOff);
	                scope.circleElement.attr("opacity", scope.offOpacity);
	            }
	        };
	
	        scope.update = function () {
	            scope.size = scope.size || 50;
	            scope.canvasSize = scope.size;
	            scope.radius = scope.canvasSize / 4;
	            scope.glowSize = scope.radius / 5;
	
	            var template = '<div id="canvas_container" style="width: ' + scope.size + 'px; height: ' + scope.size + 'px;"></div>';
	            element.html(template);
	            $compile(element.contents())(scope);
	            scope.paper = new _raphael2.default((0, _jquery2.default)('#canvas_container', element)[0], scope.canvasSize, scope.canvasSize);
	            var center = scope.canvasSize / 2;
	            scope.circleElement = scope.paper.circle(center, center, scope.radius);
	            scope.draw();
	        };
	
	        scope.update();
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            size: '=?',
	            colorOn: '=',
	            colorOff: '=',
	            offOpacity: '=?',
	            //glowColor: '=',
	            tbEnabled: '='
	        }
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

	'use strict';
	
	LegendConfigPanelController.$inject = ["mdPanelRef", "$scope", "types", "legendConfig", "onLegendConfigUpdate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = LegendConfigPanelController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function LegendConfigPanelController(mdPanelRef, $scope, types, legendConfig, onLegendConfigUpdate) {
	
	    var vm = this;
	    vm._mdPanelRef = mdPanelRef;
	    vm.legendConfig = legendConfig;
	    vm.onLegendConfigUpdate = onLegendConfigUpdate;
	    vm.positions = types.position;
	
	    vm._mdPanelRef.config.onOpenComplete = function () {
	        $scope.theForm.$setPristine();
	    };
	
	    $scope.$watch('vm.legendConfig', function () {
	        if (onLegendConfigUpdate) {
	            onLegendConfigUpdate(vm.legendConfig);
	        }
	    }, true);
	}

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	LegendConfig.$inject = ["$compile", "$templateCache", "types", "$mdPanel", "$document"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(762);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _legendConfigButtonTpl = __webpack_require__(1405);
	
	var _legendConfigButtonTpl2 = _interopRequireDefault(_legendConfigButtonTpl);
	
	var _legendConfigPanelTpl = __webpack_require__(1406);
	
	var _legendConfigPanelTpl2 = _interopRequireDefault(_legendConfigPanelTpl);
	
	var _legendConfigPanel = __webpack_require__(1186);
	
	var _legendConfigPanel2 = _interopRequireDefault(_legendConfigPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.directives.legendConfig', []).controller('LegendConfigPanelController', _legendConfigPanel2.default).directive('tbLegendConfig', LegendConfig).name;
	
	/* eslint-disable angular/angularelement */
	/*@ngInject*/
	
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function LegendConfig($compile, $templateCache, types, $mdPanel, $document) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        /* tbLegendConfig (ng-model)
	         * {
	         * 	  position: types.position.bottom.value,
	         * 	  showMin: false,
	         * 	  showMax: false,
	         * 	  showAvg: true,
	         * 	  showTotal: false
	         * }
	         */
	
	        var template = $templateCache.get(_legendConfigButtonTpl2.default);
	        element.html(template);
	
	        scope.openEditMode = function (event) {
	            if (scope.disabled) {
	                return;
	            }
	            var position;
	            var panelHeight = 220;
	            var panelWidth = 220;
	            var offset = element[0].getBoundingClientRect();
	            var bottomY = offset.bottom - (0, _jquery2.default)(window).scrollTop(); //eslint-disable-line
	            var leftX = offset.left - (0, _jquery2.default)(window).scrollLeft(); //eslint-disable-line
	            var yPosition;
	            var xPosition;
	            if (bottomY + panelHeight > (0, _jquery2.default)(window).height()) {
	                //eslint-disable-line
	                yPosition = $mdPanel.yPosition.ABOVE;
	            } else {
	                yPosition = $mdPanel.yPosition.BELOW;
	            }
	            if (leftX + panelWidth > (0, _jquery2.default)(window).width()) {
	                //eslint-disable-line
	                xPosition = $mdPanel.xPosition.ALIGN_END;
	            } else {
	                xPosition = $mdPanel.xPosition.ALIGN_START;
	            }
	            position = $mdPanel.newPanelPosition().relativeTo(element).addPanelPosition(xPosition, yPosition);
	            var config = {
	                attachTo: angular.element($document[0].body),
	                controller: 'LegendConfigPanelController',
	                controllerAs: 'vm',
	                templateUrl: _legendConfigPanelTpl2.default,
	                panelClass: 'tb-legend-config-panel',
	                position: position,
	                fullscreen: false,
	                locals: {
	                    'legendConfig': angular.copy(scope.model),
	                    'onLegendConfigUpdate': function onLegendConfigUpdate(legendConfig) {
	                        scope.model = legendConfig;
	                        scope.updateView();
	                    }
	                },
	                openFrom: event,
	                clickOutsideToClose: true,
	                escapeToClose: true,
	                focusOnOpen: false
	            };
	            $mdPanel.open(config);
	        };
	
	        scope.updateView = function () {
	            var value = {};
	            var model = scope.model;
	            value.position = model.position;
	            value.showMin = model.showMin;
	            value.showMax = model.showMax;
	            value.showAvg = model.showAvg;
	            value.showTotal = model.showTotal;
	            ngModelCtrl.$setViewValue(value);
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                if (!scope.model) {
	                    scope.model = {};
	                }
	                var model = scope.model;
	                model.position = value.position || types.position.bottom.value;
	                model.showMin = angular.isDefined(value.showMin) ? value.showMin : false;
	                model.showMax = angular.isDefined(value.showMax) ? value.showMax : false;
	                model.showAvg = angular.isDefined(value.showAvg) ? value.showAvg : true;
	                model.showTotal = angular.isDefined(value.showTotal) ? value.showTotal : false;
	            } else {
	                scope.model = {
	                    position: types.position.bottom.value,
	                    showMin: false,
	                    showMax: false,
	                    showAvg: true,
	                    showTotal: false
	                };
	            }
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            disabled: '=ngDisabled'
	        },
	        link: linker
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Legend.$inject = ["$compile", "$templateCache", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(763);
	
	var _legendTpl = __webpack_require__(1407);
	
	var _legendTpl2 = _interopRequireDefault(_legendTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.legend', []).directive('tbLegend', Legend).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function Legend($compile, $templateCache, types) {
	
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_legendTpl2.default);
	        element.html(template);
	
	        scope.displayHeader = function () {
	            return scope.legendConfig.showMin === true || scope.legendConfig.showMax === true || scope.legendConfig.showAvg === true || scope.legendConfig.showTotal === true;
	        };
	
	        scope.isHorizontal = scope.legendConfig.position === types.position.bottom.value || scope.legendConfig.position === types.position.top.value;
	
	        scope.toggleHideData = function (index) {
	            scope.legendData.keys[index].dataKey.hidden = !scope.legendData.keys[index].dataKey.hidden;
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    /*    scope.legendData = {
	     keys: [],
	     data: []
	      key: {
	       dataKey: dataKey,
	       dataIndex: 0
	     }
	     data: {
	       min: null,
	       max: null,
	       avg: null,
	       total: null
	     }
	     };*/
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            legendConfig: '=',
	            legendData: '='
	        }
	    };
	}

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	MaterialIconSelect.$inject = ["$compile", "$templateCache", "$document", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(764);
	
	var _materialIconsDialog = __webpack_require__(1190);
	
	var _materialIconsDialog2 = _interopRequireDefault(_materialIconsDialog);
	
	var _materialIconSelectTpl = __webpack_require__(1408);
	
	var _materialIconSelectTpl2 = _interopRequireDefault(_materialIconSelectTpl);
	
	var _materialIconsDialogTpl = __webpack_require__(1409);
	
	var _materialIconsDialogTpl2 = _interopRequireDefault(_materialIconsDialogTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.materialIconSelect', []).controller('MaterialIconsDialogController', _materialIconsDialog2.default).directive('tbMaterialIconSelect', MaterialIconSelect).name;
	
	/*@ngInject*/
	
	function MaterialIconSelect($compile, $templateCache, $document, $mdDialog) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_materialIconSelectTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	        scope.icon = null;
	
	        scope.updateView = function () {
	            ngModelCtrl.$setViewValue(scope.icon);
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                scope.icon = ngModelCtrl.$viewValue;
	            }
	            if (!scope.icon || !scope.icon.length) {
	                scope.icon = 'more_horiz';
	            }
	        };
	
	        scope.$watch('icon', function () {
	            scope.updateView();
	        });
	
	        scope.openIconDialog = function ($event) {
	            if ($event) {
	                $event.stopPropagation();
	            }
	            $mdDialog.show({
	                controller: 'MaterialIconsDialogController',
	                controllerAs: 'vm',
	                templateUrl: _materialIconsDialogTpl2.default,
	                parent: angular.element($document[0].body),
	                locals: { icon: scope.icon },
	                skipHide: true,
	                fullscreen: true,
	                targetEvent: $event
	            }).then(function (icon) {
	                scope.icon = icon;
	            });
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            tbRequired: '=?'
	        }
	    };
	}

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	MaterialIconsDialogController.$inject = ["$scope", "$mdDialog", "$timeout", "utils", "icon"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = MaterialIconsDialogController;
	
	__webpack_require__(765);
	
	/*@ngInject*/
	function MaterialIconsDialogController($scope, $mdDialog, $timeout, utils, icon) {
	
	    var vm = this;
	
	    vm.selectedIcon = icon;
	
	    vm.showAll = false;
	    vm.loadingIcons = false;
	
	    $scope.$watch('vm.showAll', function (showAll) {
	        if (showAll) {
	            vm.loadingIcons = true;
	            $timeout(function () {
	                utils.getMaterialIcons().then(function success(icons) {
	                    vm.icons = icons;
	                });
	            });
	        } else {
	            vm.icons = utils.getCommonMaterialIcons();
	        }
	    });
	
	    $scope.$on('iconsLoadFinished', function () {
	        vm.loadingIcons = false;
	    });
	
	    vm.cancel = cancel;
	    vm.selectIcon = selectIcon;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function selectIcon($event, icon) {
	        vm.selectedIcon = icon;
	        $mdDialog.hide(vm.selectedIcon);
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	MenuLink.$inject = ["$compile", "$templateCache", "menu"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(766);
	
	var _menu = __webpack_require__(148);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _menuLinkTpl = __webpack_require__(1410);
	
	var _menuLinkTpl2 = _interopRequireDefault(_menuLinkTpl);
	
	var _menuToggleTpl = __webpack_require__(1411);
	
	var _menuToggleTpl2 = _interopRequireDefault(_menuToggleTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.menuLink', [_menu2.default]).directive('tbMenuLink', MenuLink).filter('nospace', NoSpace).name;
	
	/*@ngInject*/
	
	function MenuLink($compile, $templateCache, menu) {
	
	    var linker = function linker(scope, element) {
	        var template;
	
	        if (scope.section.type === 'link') {
	            template = $templateCache.get(_menuLinkTpl2.default);
	        } else {
	            template = $templateCache.get(_menuToggleTpl2.default);
	
	            var parentNode = element[0].parentNode.parentNode.parentNode;
	            if (parentNode.classList.contains('parent-list-item')) {
	                var heading = parentNode.querySelector('h2');
	                element[0].firstChild.setAttribute('aria-describedby', heading.id);
	            }
	
	            scope.sectionActive = function () {
	                return menu.sectionActive(scope.section);
	            };
	
	            scope.sectionHeight = function () {
	                return menu.sectionHeight(scope.section);
	            };
	        }
	
	        element.html(template);
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            section: '='
	        }
	    };
	}
	
	function NoSpace() {
	    return function (value) {
	        return !value ? '' : value.replace(/ /g, '');
	    };
	}

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.mousepointMenu', []).directive('tbMousepointMenu', MousepointMenu).name;
	
	/*@ngInject*/
	
	function MousepointMenu() {
	
	    var linker = function linker($scope, $element, $attrs, RightClickContextMenu) {
	
	        $scope.$mdOpenMousepointMenu = function ($event) {
	            RightClickContextMenu.offsets = function () {
	                var offset = $element.offset();
	                var x = $event.pageX - offset.left;
	                var y = $event.pageY - offset.top;
	                if ($attrs.tbOffsetX) {
	                    x += Number($attrs.tbOffsetX);
	                }
	                if ($attrs.tbOffsetY) {
	                    y += Number($attrs.tbOffsetY);
	                }
	                var offsets = {
	                    left: x,
	                    top: y
	                };
	                return offsets;
	            };
	            RightClickContextMenu.open($event);
	        };
	
	        $scope.$mdCloseMousepointMenu = function () {
	            RightClickContextMenu.close();
	        };
	    };
	
	    return {
	        restrict: "A",
	        link: linker,
	        require: 'mdMenu'
	    };
	}

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	NoAnimate.$inject = ["$animate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularAnimate = __webpack_require__(121);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.directives.noAnimate', [_angularAnimate2.default]).directive('tbNoAnimate', NoAnimate).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function NoAnimate($animate) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            $animate.enabled(element, false);
	            scope.$watch(function () {
	                $animate.enabled(element, false);
	            });
	        }
	    };
	}

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _colors = __webpack_require__(144);
	
	var _colorManipulator = __webpack_require__(55);
	
	var _spacing = __webpack_require__(378);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRIMARY_BACKGROUND_COLOR = "#305680"; //"#3f51b5";
	
	/*var blueGrayPalette = {
	    primary1Color: blueGrey500,
	    primary2Color: blueGrey700,
	    primary3Color: blueGrey100,
	    accent1Color: orange500,
	    accent2Color: grey100,
	    accent3Color: grey500,
	    textColor: grey900,
	    secondaryTextColor: grey600,
	    alternateTextColor: white,
	    canvasColor: white,
	    borderColor: grey400,
	    disabledColor: fade(darkBlack, 0.3),
	    pickerHeaderColor: cyan500,
	    clockCircleColor: fade(darkBlack, 0.07),
	    shadowColor: fullBlack,
	};*/
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var indigoPalette = {
	    primary1Color: PRIMARY_BACKGROUND_COLOR,
	    primary2Color: _colors.indigo700,
	    primary3Color: _colors.indigo100,
	    accent1Color: _colors.deepOrange500,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.grey900,
	    secondaryTextColor: _colors.grey600,
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey400,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	};
	
	exports.default = {
	    spacing: _spacing2.default,
	    fontFamily: 'Roboto, \'Helvetica Neue\', sans-serif',
	    palette: indigoPalette
	};

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RelatedEntityAutocomplete.$inject = ["$compile", "$templateCache", "$q", "$filter", "entityService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(771);
	
	var _relatedEntityAutocompleteTpl = __webpack_require__(1412);
	
	var _relatedEntityAutocompleteTpl2 = _interopRequireDefault(_relatedEntityAutocompleteTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.relatedEntityAutocomplete', []).directive('tbRelatedEntityAutocomplete', RelatedEntityAutocomplete).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function RelatedEntityAutocomplete($compile, $templateCache, $q, $filter, entityService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_relatedEntityAutocompleteTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	        scope.entity = null;
	        scope.entitySearchText = '';
	
	        scope.allEntities = null;
	
	        scope.fetchEntities = function (searchText) {
	            var deferred = $q.defer();
	            if (!scope.allEntities) {
	                entityService.getRelatedEntities(scope.rootEntityId, scope.entityType, scope.entitySubtypes, -1, []).then(function success(entities) {
	                    if (scope.excludeEntityIds && scope.excludeEntityIds.length) {
	                        var filteredEntities = [];
	                        entities.forEach(function (entity) {
	                            if (scope.excludeEntityIds.indexOf(entity.id.id) == -1) {
	                                filteredEntities.push(entity);
	                            }
	                        });
	                        entities = filteredEntities;
	                    }
	                    scope.allEntities = entities;
	                    filterEntities(searchText, deferred);
	                }, function fail() {
	                    deferred.reject();
	                });
	            } else {
	                filterEntities(searchText, deferred);
	            }
	            return deferred.promise;
	        };
	
	        function filterEntities(searchText, deferred) {
	            var result = $filter('filter')(scope.allEntities, { name: searchText });
	            deferred.resolve(result);
	        }
	
	        scope.entitySearchTextChanged = function () {};
	
	        scope.updateView = function () {
	            if (!scope.disabled) {
	                ngModelCtrl.$setViewValue(scope.entity ? scope.entity.id : null);
	            }
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                entityService.getRelatedEntity(ngModelCtrl.$viewValue).then(function success(entity) {
	                    scope.entity = entity;
	                }, function fail() {
	                    scope.entity = null;
	                });
	            } else {
	                scope.entity = null;
	            }
	        };
	
	        scope.$watch('entity', function () {
	            scope.updateView();
	        });
	
	        scope.$watch('disabled', function () {
	            scope.updateView();
	        });
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            rootEntityId: '=',
	            entityType: '=',
	            entitySubtypes: '=',
	            excludeEntityIds: '=?',
	            theForm: '=?',
	            tbRequired: '=?',
	            disabled: '=ngDisabled',
	            placeholderText: '@',
	            notFoundText: '@',
	            requiredText: '@'
	        }
	    };
	}

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.scopeElement', []).directive('tbScopeElement', ScopeElement).name;
	
	/*@ngInject*/
	
	function ScopeElement() {
	    var directiveDefinitionObject = {
	        restrict: "A",
	        compile: function compile() {
	            return {
	                pre: function preLink(scope, iElement, iAttrs) {
	                    scope[iAttrs.tbScopeElement] = iElement;
	                }
	            };
	        }
	    };
	    return directiveDefinitionObject;
	}

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	SideMenu.$inject = ["$compile", "$templateCache", "menu"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(772);
	
	var _menu = __webpack_require__(148);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _menuLink = __webpack_require__(1191);
	
	var _menuLink2 = _interopRequireDefault(_menuLink);
	
	var _sideMenuTpl = __webpack_require__(1413);
	
	var _sideMenuTpl2 = _interopRequireDefault(_sideMenuTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.sideMenu', [_menu2.default, _menuLink2.default]).directive('tbSideMenu', SideMenu).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function SideMenu($compile, $templateCache, menu) {
	
	    var linker = function linker(scope, element) {
	
	        scope.sections = menu.getSections();
	
	        var template = $templateCache.get(_sideMenuTpl2.default);
	
	        element.html(template);
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {}
	    };
	}

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	SocialsharePanelController.$inject = ["utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _socialsharePanelTpl = __webpack_require__(1414);
	
	var _socialsharePanelTpl2 = _interopRequireDefault(_socialsharePanelTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.directives.socialsharePanel', []).directive('tbSocialSharePanel', SocialsharePanel).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function SocialsharePanel() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            shareTitle: '@',
	            shareText: '@',
	            shareLink: '@',
	            shareHashTags: '@'
	        },
	        controller: SocialsharePanelController,
	        controllerAs: 'vm',
	        templateUrl: _socialsharePanelTpl2.default
	    };
	}
	
	/*@ngInject*/
	function SocialsharePanelController(utils) {
	
	    var vm = this;
	
	    vm.isShareLinkLocal = function () {
	        if (vm.shareLink && vm.shareLink.length > 0) {
	            return utils.isLocalUrl(vm.shareLink);
	        } else {
	            return true;
	        }
	    };
	}

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	
	var tbEventDirectives = {};
	
	angular.forEach('click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave contextmenu keydown keyup keypress submit focus blur copy cut paste'.split(' '), function (eventName) {
	    var directiveName = directiveNormalize('tb-' + eventName);
	    tbEventDirectives[directiveName] = ['$parse', '$rootScope', function ($parse) {
	        return {
	            restrict: 'A',
	            compile: function compile($element, attr) {
	                var fn = $parse(attr[directiveName], /* interceptorFn */null, /* expensiveChecks */true);
	                return function ngEventHandler(scope, element) {
	                    element.on(eventName, function (event) {
	                        var callback = function callback() {
	                            fn(scope, { $event: event });
	                        };
	                        callback();
	                    });
	                };
	            }
	        };
	    }];
	});
	
	exports.default = angular.module('thingsboard.directives.event', []).directive(tbEventDirectives).name;
	
	
	function camelCase(name) {
	    return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
	        return offset ? letter.toUpperCase() : letter;
	    }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	function directiveNormalize(name) {
	    return camelCase(name.replace(PREFIX_REGEXP, ''));
	}

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Timeinterval.$inject = ["$compile", "$templateCache", "timeService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(773);
	
	var _timeintervalTpl = __webpack_require__(1415);
	
	var _timeintervalTpl2 = _interopRequireDefault(_timeintervalTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.timeinterval', []).directive('tbTimeinterval', Timeinterval).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function Timeinterval($compile, $templateCache, timeService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_timeintervalTpl2.default);
	        element.html(template);
	
	        scope.rendered = false;
	        scope.days = 0;
	        scope.hours = 0;
	        scope.mins = 1;
	        scope.secs = 0;
	
	        scope.advanced = false;
	
	        scope.boundInterval = function () {
	            var min = timeService.boundMinInterval(scope.min);
	            var max = timeService.boundMaxInterval(scope.max);
	            scope.intervals = timeService.getIntervals(scope.min, scope.max);
	            if (scope.rendered) {
	                var newIntervalMs = ngModelCtrl.$viewValue;
	                if (newIntervalMs < min) {
	                    newIntervalMs = min;
	                } else if (newIntervalMs > max) {
	                    newIntervalMs = max;
	                }
	                if (!scope.advanced) {
	                    newIntervalMs = timeService.boundToPredefinedInterval(min, max, newIntervalMs);
	                }
	                if (newIntervalMs !== ngModelCtrl.$viewValue) {
	                    scope.setIntervalMs(newIntervalMs);
	                    scope.updateView();
	                }
	            }
	        };
	
	        scope.setIntervalMs = function (intervalMs) {
	            if (!scope.advanced) {
	                scope.intervalMs = intervalMs;
	            }
	            var intervalSeconds = Math.floor(intervalMs / 1000);
	            scope.days = Math.floor(intervalSeconds / 86400);
	            scope.hours = Math.floor(intervalSeconds % 86400 / 3600);
	            scope.mins = Math.floor(intervalSeconds % 86400 % 3600 / 60);
	            scope.secs = intervalSeconds % 60;
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                var intervalMs = ngModelCtrl.$viewValue;
	                if (!scope.rendered) {
	                    scope.advanced = !timeService.matchesExistingInterval(scope.min, scope.max, intervalMs);
	                }
	                scope.setIntervalMs(intervalMs);
	            }
	            scope.rendered = true;
	        };
	
	        function calculateIntervalMs() {
	            return (scope.days * 86400 + scope.hours * 3600 + scope.mins * 60 + scope.secs) * 1000;
	        }
	
	        scope.updateView = function () {
	            if (!scope.rendered) {
	                return;
	            }
	            var value = null;
	            var intervalMs;
	            if (!scope.advanced) {
	                intervalMs = scope.intervalMs;
	                if (!intervalMs || isNaN(intervalMs)) {
	                    intervalMs = calculateIntervalMs();
	                }
	            } else {
	                intervalMs = calculateIntervalMs();
	            }
	            if (!isNaN(intervalMs) && intervalMs > 0) {
	                value = intervalMs;
	                ngModelCtrl.$setValidity('tb-timeinterval', true);
	            } else {
	                ngModelCtrl.$setValidity('tb-timeinterval', !scope.required);
	            }
	            ngModelCtrl.$setViewValue(value);
	            scope.boundInterval();
	        };
	
	        scope.$watch('required', function (newRequired, prevRequired) {
	            if (angular.isDefined(newRequired) && newRequired !== prevRequired) {
	                scope.updateView();
	            }
	        });
	
	        scope.$watch('min', function (newMin, prevMin) {
	            if (angular.isDefined(newMin) && newMin !== prevMin) {
	                scope.updateView();
	            }
	        });
	
	        scope.$watch('max', function (newMax, prevMax) {
	            if (angular.isDefined(newMax) && newMax !== prevMax) {
	                scope.updateView();
	            }
	        });
	
	        scope.$watch('intervalMs', function (newIntervalMs, prevIntervalMs) {
	            if (angular.isDefined(newIntervalMs) && newIntervalMs !== prevIntervalMs) {
	                scope.updateView();
	            }
	        });
	
	        scope.$watch('advanced', function (newAdvanced, prevAdvanced) {
	            if (angular.isDefined(newAdvanced) && newAdvanced !== prevAdvanced) {
	                if (!scope.advanced) {
	                    scope.intervalMs = calculateIntervalMs();
	                } else {
	                    var intervalMs = scope.intervalMs;
	                    if (!intervalMs || isNaN(intervalMs)) {
	                        intervalMs = calculateIntervalMs();
	                    }
	                    scope.setIntervalMs(intervalMs);
	                }
	                scope.updateView();
	            }
	        });
	
	        scope.$watch('secs', function (newSecs) {
	            if (angular.isUndefined(newSecs)) {
	                return;
	            }
	            if (newSecs < 0) {
	                if (scope.days + scope.hours + scope.mins > 0) {
	                    scope.secs = newSecs + 60;
	                    scope.mins--;
	                } else {
	                    scope.secs = 0;
	                }
	            } else if (newSecs >= 60) {
	                scope.secs = newSecs - 60;
	                scope.mins++;
	            }
	            scope.updateView();
	        });
	
	        scope.$watch('mins', function (newMins) {
	            if (angular.isUndefined(newMins)) {
	                return;
	            }
	            if (newMins < 0) {
	                if (scope.days + scope.hours > 0) {
	                    scope.mins = newMins + 60;
	                    scope.hours--;
	                } else {
	                    scope.mins = 0;
	                }
	            } else if (newMins >= 60) {
	                scope.mins = newMins - 60;
	                scope.hours++;
	            }
	            scope.updateView();
	        });
	
	        scope.$watch('hours', function (newHours) {
	            if (angular.isUndefined(newHours)) {
	                return;
	            }
	            if (newHours < 0) {
	                if (scope.days > 0) {
	                    scope.hours = newHours + 24;
	                    scope.days--;
	                } else {
	                    scope.hours = 0;
	                }
	            } else if (newHours >= 24) {
	                scope.hours = newHours - 24;
	                scope.days++;
	            }
	            scope.updateView();
	        });
	
	        scope.$watch('days', function (newDays) {
	            if (angular.isUndefined(newDays)) {
	                return;
	            }
	            if (newDays < 0) {
	                scope.days = 0;
	            }
	            scope.updateView();
	        });
	
	        scope.boundInterval();
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            required: '=ngRequired',
	            min: '=?',
	            max: '=?',
	            predefinedName: '=?'
	        },
	        link: linker
	    };
	}

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	'use strict';
	
	TimewindowPanelController.$inject = ["mdPanelRef", "$scope", "timeService", "types", "timewindow", "historyOnly", "aggregation", "onTimewindowUpdate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = TimewindowPanelController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function TimewindowPanelController(mdPanelRef, $scope, timeService, types, timewindow, historyOnly, aggregation, onTimewindowUpdate) {
	
	    var vm = this;
	
	    vm._mdPanelRef = mdPanelRef;
	    vm.timewindow = timewindow;
	    vm.historyOnly = historyOnly;
	    vm.aggregation = aggregation;
	    vm.onTimewindowUpdate = onTimewindowUpdate;
	    vm.aggregationTypes = types.aggregation;
	    vm.showLimit = showLimit;
	    vm.showRealtimeAggInterval = showRealtimeAggInterval;
	    vm.showHistoryAggInterval = showHistoryAggInterval;
	    vm.minRealtimeAggInterval = minRealtimeAggInterval;
	    vm.maxRealtimeAggInterval = maxRealtimeAggInterval;
	    vm.minHistoryAggInterval = minHistoryAggInterval;
	    vm.maxHistoryAggInterval = maxHistoryAggInterval;
	    vm.minDatapointsLimit = minDatapointsLimit;
	    vm.maxDatapointsLimit = maxDatapointsLimit;
	
	    if (vm.historyOnly) {
	        vm.timewindow.selectedTab = 1;
	    }
	
	    vm._mdPanelRef.config.onOpenComplete = function () {
	        $scope.theForm.$setPristine();
	    };
	
	    $scope.$watch('vm.timewindow.selectedTab', function (newSelection, prevSelection) {
	        if (newSelection !== prevSelection) {
	            $scope.theForm.$setDirty();
	        }
	    });
	
	    vm.cancel = function () {
	        vm._mdPanelRef && vm._mdPanelRef.close();
	    };
	
	    vm.update = function () {
	        vm._mdPanelRef && vm._mdPanelRef.close().then(function () {
	            vm.onTimewindowUpdate && vm.onTimewindowUpdate(vm.timewindow);
	        });
	    };
	
	    function showLimit() {
	        return vm.timewindow.aggregation.type === vm.aggregationTypes.none.value;
	    }
	
	    function showRealtimeAggInterval() {
	        return vm.timewindow.aggregation.type !== vm.aggregationTypes.none.value && vm.timewindow.selectedTab === 0;
	    }
	
	    function showHistoryAggInterval() {
	        return vm.timewindow.aggregation.type !== vm.aggregationTypes.none.value && vm.timewindow.selectedTab === 1;
	    }
	
	    function minRealtimeAggInterval() {
	        return timeService.minIntervalLimit(vm.timewindow.realtime.timewindowMs);
	    }
	
	    function maxRealtimeAggInterval() {
	        return timeService.maxIntervalLimit(vm.timewindow.realtime.timewindowMs);
	    }
	
	    function minHistoryAggInterval() {
	        return timeService.minIntervalLimit(currentHistoryTimewindow());
	    }
	
	    function maxHistoryAggInterval() {
	        return timeService.maxIntervalLimit(currentHistoryTimewindow());
	    }
	
	    function minDatapointsLimit() {
	        return timeService.getMinDatapointsLimit();
	    }
	
	    function maxDatapointsLimit() {
	        return timeService.getMaxDatapointsLimit();
	    }
	
	    function currentHistoryTimewindow() {
	        if (vm.timewindow.history.historyType === 0) {
	            return vm.timewindow.history.timewindowMs;
	        } else {
	            return vm.timewindow.history.fixedTimewindow.endTimeMs - vm.timewindow.history.fixedTimewindow.startTimeMs;
	        }
	    }
	}

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.filters.truncate', []).filter('truncate', Truncate).name;
	
	/*@ngInject*/
	
	function Truncate() {
	    return function (value, wordwise, max, tail) {
	        if (!value) return '';
	
	        max = parseInt(max, 10);
	        if (!max) return value;
	        if (value.length <= max) return value;
	
	        value = value.substr(0, max);
	        if (wordwise) {
	            var lastspace = value.lastIndexOf(' ');
	            if (lastspace != -1) {
	                //Also remove . and , so its gives a cleaner result.
	                if (value.charAt(lastspace - 1) == '.' || value.charAt(lastspace - 1) == ',') {
	                    lastspace = lastspace - 1;
	                }
	                value = value.substr(0, lastspace);
	            }
	        }
	
	        return value + (tail || ' …');
	    };
	}

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ManageWidgetActionsController.$inject = ["$rootScope", "$scope", "$document", "$mdDialog", "$q", "$filter", "$translate", "$timeout", "utils", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(775);
	
	var _materialIconSelect = __webpack_require__(1189);
	
	var _materialIconSelect2 = _interopRequireDefault(_materialIconSelect);
	
	var _widgetActionDialog = __webpack_require__(1204);
	
	var _widgetActionDialog2 = _interopRequireDefault(_widgetActionDialog);
	
	var _manageWidgetActionsTpl = __webpack_require__(1419);
	
	var _manageWidgetActionsTpl2 = _interopRequireDefault(_manageWidgetActionsTpl);
	
	var _widgetActionDialogTpl = __webpack_require__(1420);
	
	var _widgetActionDialogTpl2 = _interopRequireDefault(_widgetActionDialogTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.directives.widgetActions', [_materialIconSelect2.default]).controller('WidgetActionDialogController', _widgetActionDialog2.default).directive('tbManageWidgetActions', ManageWidgetActions).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Created by igor on 6/20/17.
	 */
	/*
	 * Copyright © 2016-2017 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function ManageWidgetActions() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            actionSources: '=',
	            widgetActions: '=',
	            fetchDashboardStates: '&'
	        },
	        controller: ManageWidgetActionsController,
	        controllerAs: 'vm',
	        templateUrl: _manageWidgetActionsTpl2.default
	    };
	}
	
	/* eslint-disable angular/angularelement */
	
	/*@ngInject*/
	function ManageWidgetActionsController($rootScope, $scope, $document, $mdDialog, $q, $filter, $translate, $timeout, utils, types) {
	
	    var vm = this;
	
	    vm.allActions = [];
	
	    vm.actions = [];
	    vm.actionsCount = 0;
	
	    vm.query = {
	        order: 'actionSourceName',
	        limit: 10,
	        page: 1,
	        search: null
	    };
	
	    vm.enterFilterMode = enterFilterMode;
	    vm.exitFilterMode = exitFilterMode;
	    vm.onReorder = onReorder;
	    vm.onPaginate = onPaginate;
	    vm.addAction = addAction;
	    vm.editAction = editAction;
	    vm.deleteAction = deleteAction;
	
	    $timeout(function () {
	        $scope.manageWidgetActionsForm.querySearchInput.$pristine = false;
	    });
	
	    $scope.$watch('vm.widgetActions', function () {
	        if (vm.widgetActions) {
	            reloadActions();
	        }
	    });
	
	    $scope.$watch("vm.query.search", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
	            updateActions();
	        }
	    });
	
	    function enterFilterMode(event) {
	        var $button = angular.element(event.currentTarget);
	        var $toolbarsContainer = $button.closest('.toolbarsContainer');
	
	        vm.query.search = '';
	
	        $timeout(function () {
	            $toolbarsContainer.find('.searchInput').focus();
	        });
	    }
	
	    function exitFilterMode() {
	        vm.query.search = null;
	        updateActions();
	    }
	
	    function onReorder() {
	        updateActions();
	    }
	
	    function onPaginate() {
	        updateActions();
	    }
	
	    function addAction($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        openWidgetActionDialog($event, null, true);
	    }
	
	    function editAction($event, action) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        openWidgetActionDialog($event, action, false);
	    }
	
	    function deleteAction($event, action) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (action) {
	            var title = $translate.instant('widget-config.delete-action-title');
	            var content = $translate.instant('widget-config.delete-action-text', { actionName: action.name });
	            var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(title).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	
	            confirm._options.skipHide = true;
	            confirm._options.fullscreen = true;
	
	            $mdDialog.show(confirm).then(function () {
	                var index = getActionIndex(action.id, vm.allActions);
	                if (index > -1) {
	                    vm.allActions.splice(index, 1);
	                }
	                var targetActions = vm.widgetActions[action.actionSourceId];
	                index = getActionIndex(action.id, targetActions);
	                if (index > -1) {
	                    targetActions.splice(index, 1);
	                }
	                $scope.manageWidgetActionsForm.$setDirty();
	                updateActions();
	            });
	        }
	    }
	
	    function openWidgetActionDialog($event, action, isAdd) {
	        var prevActionId = null;
	        if (!isAdd) {
	            prevActionId = action.id;
	        }
	        var availableActionSources = {};
	        for (var id in vm.actionSources) {
	            var actionSource = vm.actionSources[id];
	            if (actionSource.multiple) {
	                availableActionSources[id] = actionSource;
	            } else {
	                if (!isAdd && action.actionSourceId == id) {
	                    availableActionSources[id] = actionSource;
	                } else {
	                    var result = $filter('filter')(vm.allActions, { actionSourceId: id });
	                    if (!result || !result.length) {
	                        availableActionSources[id] = actionSource;
	                    }
	                }
	            }
	        }
	        $mdDialog.show({
	            controller: 'WidgetActionDialogController',
	            controllerAs: 'vm',
	            templateUrl: _widgetActionDialogTpl2.default,
	            parent: angular.element($document[0].body),
	            locals: { isAdd: isAdd, fetchDashboardStates: vm.fetchDashboardStates,
	                actionSources: availableActionSources, widgetActions: vm.widgetActions,
	                action: angular.copy(action) },
	            skipHide: true,
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (action) {
	            saveAction(action, prevActionId);
	            updateActions();
	        });
	    }
	
	    function getActionIndex(id, actions) {
	        var result = $filter('filter')(actions, { id: id }, true);
	        if (result && result.length) {
	            return actions.indexOf(result[0]);
	        }
	        return -1;
	    }
	
	    function saveAction(action, prevActionId) {
	        var actionSourceName = vm.actionSources[action.actionSourceId].name;
	        action.actionSourceName = utils.customTranslation(actionSourceName, actionSourceName);
	        action.typeName = $translate.instant(types.widgetActionTypes[action.type].name);
	        var actionSourceId = action.actionSourceId;
	        var widgetAction = angular.copy(action);
	        delete widgetAction.actionSourceId;
	        delete widgetAction.actionSourceName;
	        delete widgetAction.typeName;
	        var targetActions = vm.widgetActions[actionSourceId];
	        if (!targetActions) {
	            targetActions = [];
	            vm.widgetActions[actionSourceId] = targetActions;
	        }
	        if (prevActionId) {
	            var indexInTarget = getActionIndex(prevActionId, targetActions);
	            var indexInAllActions = getActionIndex(prevActionId, vm.allActions);
	            if (indexInTarget > -1) {
	                targetActions[indexInTarget] = widgetAction;
	            } else if (indexInAllActions > -1) {
	                var prevActionSourceId = vm.allActions[indexInAllActions].actionSourceId;
	                var index = getActionIndex(prevActionId, vm.widgetActions[prevActionSourceId]);
	                vm.widgetActions[prevActionSourceId].splice(index, 1);
	                targetActions.push(widgetAction);
	            }
	            if (indexInAllActions > -1) {
	                vm.allActions[indexInAllActions] = action;
	            }
	        } else {
	            vm.allActions.push(action);
	            targetActions.push(widgetAction);
	        }
	        $scope.manageWidgetActionsForm.$setDirty();
	    }
	
	    function reloadActions() {
	        vm.allActions = [];
	        vm.actions = [];
	        vm.actionsCount = 0;
	
	        for (var actionSourceId in vm.widgetActions) {
	            var actionSource = vm.actionSources[actionSourceId];
	            var actionSourceActions = vm.widgetActions[actionSourceId];
	            for (var i = 0; i < actionSourceActions.length; i++) {
	                var actionSourceAction = actionSourceActions[i];
	                var action = angular.copy(actionSourceAction);
	                action.actionSourceId = actionSourceId;
	                action.actionSourceName = utils.customTranslation(actionSource.name, actionSource.name);
	                action.typeName = $translate.instant(types.widgetActionTypes[actionSourceAction.type].name);
	                vm.allActions.push(action);
	            }
	        }
	
	        updateActions();
	    }
	
	    function updateActions() {
	        var result = $filter('orderBy')(vm.allActions, vm.query.order);
	        if (vm.query.search != null) {
	            result = $filter('filter')(result, { $: vm.query.search });
	        }
	        vm.actionsCount = result.length;
	        var startIndex = vm.query.limit * (vm.query.page - 1);
	        vm.actions = result.slice(startIndex, startIndex + vm.query.limit);
	    }
	}

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

	"use strict";
	
	WidgetActionDialogController.$inject = ["$scope", "$mdDialog", "$filter", "$q", "dashboardService", "dashboardUtils", "types", "utils", "isAdd", "fetchDashboardStates", "actionSources", "widgetActions", "action"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WidgetActionDialogController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function WidgetActionDialogController($scope, $mdDialog, $filter, $q, dashboardService, dashboardUtils, types, utils, isAdd, fetchDashboardStates, actionSources, widgetActions, action) {
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.isAdd = isAdd;
	    vm.fetchDashboardStates = fetchDashboardStates;
	    vm.actionSources = actionSources;
	    vm.widgetActions = widgetActions;
	
	    vm.targetDashboardStateSearchText = '';
	
	    vm.selectedDashboardStateIds = [];
	
	    if (vm.isAdd) {
	        vm.action = {
	            id: utils.guid()
	        };
	    } else {
	        vm.action = action;
	    }
	
	    vm.actionSourceName = actionSourceName;
	
	    vm.targetDashboardStateSearchTextChanged = function () {};
	
	    vm.dashboardStateSearch = dashboardStateSearch;
	    vm.cancel = cancel;
	    vm.save = save;
	
	    $scope.$watch("vm.action.name", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.action.name != null) {
	            checkActionName();
	        }
	    });
	
	    $scope.$watch("vm.action.actionSourceId", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.action.actionSourceId != null) {
	            checkActionName();
	        }
	    });
	
	    $scope.$watch("vm.action.targetDashboardId", function () {
	        vm.selectedDashboardStateIds = [];
	        if (vm.action.targetDashboardId) {
	            dashboardService.getDashboard(vm.action.targetDashboardId).then(function success(dashboard) {
	                dashboard = dashboardUtils.validateAndUpdateDashboard(dashboard);
	                var states = dashboard.configuration.states;
	                vm.selectedDashboardStateIds = Object.keys(states);
	            });
	        }
	    });
	
	    $scope.$watch('vm.action.type', function (newType) {
	        if (newType) {
	            switch (newType) {
	                case vm.types.widgetActionTypes.openDashboardState.value:
	                case vm.types.widgetActionTypes.updateDashboardState.value:
	                case vm.types.widgetActionTypes.openDashboard.value:
	                    if (angular.isUndefined(vm.action.setEntityId)) {
	                        vm.action.setEntityId = true;
	                    }
	                    break;
	            }
	        }
	    });
	
	    function checkActionName() {
	        var actionNameIsUnique = true;
	        if (vm.action.actionSourceId && vm.action.name) {
	            var sourceActions = vm.widgetActions[vm.action.actionSourceId];
	            if (sourceActions) {
	                var result = $filter('filter')(sourceActions, { name: vm.action.name }, true);
	                if (result && result.length && result[0].id !== vm.action.id) {
	                    actionNameIsUnique = false;
	                }
	            }
	        }
	        $scope.theForm.name.$setValidity('actionNameNotUnique', actionNameIsUnique);
	    }
	
	    function actionSourceName(actionSource) {
	        if (actionSource) {
	            return utils.customTranslation(actionSource.name, actionSource.name);
	        } else {
	            return '';
	        }
	    }
	
	    function dashboardStateSearch(query) {
	        if (vm.action.type == vm.types.widgetActionTypes.openDashboard.value) {
	            var deferred = $q.defer();
	            var result = query ? vm.selectedDashboardStateIds.filter(createFilterForDashboardState(query)) : vm.selectedDashboardStateIds;
	            if (result && result.length) {
	                deferred.resolve(result);
	            } else {
	                deferred.resolve([query]);
	            }
	            return deferred.promise;
	        } else {
	            return vm.fetchDashboardStates({ query: query });
	        }
	    }
	
	    function createFilterForDashboardState(query) {
	        var lowercaseQuery = angular.lowercase(query);
	        return function filterFn(stateId) {
	            return angular.lowercase(stateId).indexOf(lowercaseQuery) === 0;
	        };
	    }
	
	    function cleanupAction(action) {
	        var result = {};
	        result.id = action.id;
	        result.actionSourceId = action.actionSourceId;
	        result.name = action.name;
	        result.icon = action.icon;
	        result.type = action.type;
	        switch (action.type) {
	            case vm.types.widgetActionTypes.openDashboardState.value:
	            case vm.types.widgetActionTypes.updateDashboardState.value:
	                result.targetDashboardStateId = action.targetDashboardStateId;
	                result.openRightLayout = action.openRightLayout;
	                result.setEntityId = action.setEntityId;
	                result.stateEntityParamName = action.stateEntityParamName;
	                break;
	            case vm.types.widgetActionTypes.openDashboard.value:
	                result.targetDashboardId = action.targetDashboardId;
	                result.targetDashboardStateId = action.targetDashboardStateId;
	                result.setEntityId = action.setEntityId;
	                result.stateEntityParamName = action.stateEntityParamName;
	                break;
	            case vm.types.widgetActionTypes.custom.value:
	                result.customFunction = action.customFunction;
	                break;
	        }
	        return result;
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function save() {
	        $scope.theForm.$setPristine();
	        $mdDialog.hide(cleanupAction(vm.action));
	    }
	}

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WidgetConfig.$inject = ["$compile", "$templateCache", "$rootScope", "$translate", "$timeout", "types", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _utils = __webpack_require__(90);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _entityAliasSelect = __webpack_require__(1178);
	
	var _entityAliasSelect2 = _interopRequireDefault(_entityAliasSelect);
	
	var _datasource = __webpack_require__(1176);
	
	var _datasource2 = _interopRequireDefault(_datasource);
	
	var _timewindow = __webpack_require__(510);
	
	var _timewindow2 = _interopRequireDefault(_timewindow);
	
	var _legendConfig = __webpack_require__(1187);
	
	var _legendConfig2 = _interopRequireDefault(_legendConfig);
	
	var _jsonForm = __webpack_require__(232);
	
	var _jsonForm2 = _interopRequireDefault(_jsonForm);
	
	var _manageWidgetActions = __webpack_require__(1203);
	
	var _manageWidgetActions2 = _interopRequireDefault(_manageWidgetActions);
	
	__webpack_require__(267);
	
	var _aceEditorFix = __webpack_require__(114);
	
	var _aceEditorFix2 = _interopRequireDefault(_aceEditorFix);
	
	__webpack_require__(776);
	
	var _widgetConfigTpl = __webpack_require__(1421);
	
	var _widgetConfigTpl2 = _interopRequireDefault(_widgetConfigTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable angular/angularelement */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.widgetConfig', [_types2.default, _utils2.default, _jsonForm2.default, _entityAliasSelect2.default, _datasource2.default, _timewindow2.default, _legendConfig2.default, _manageWidgetActions2.default, 'ui.ace']).directive('tbWidgetConfig', WidgetConfig).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function WidgetConfig($compile, $templateCache, $rootScope, $translate, $timeout, types, utils) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_widgetConfigTpl2.default);
	
	        element.html(template);
	
	        scope.types = types;
	        scope.widgetEditMode = $rootScope.widgetEditMode;
	
	        scope.emptySettingsSchema = {
	            type: "object",
	            properties: {}
	        };
	        scope.defaultSettingsForm = ['*'];
	
	        scope.styleEditorOptions = {
	            useWrapMode: true,
	            mode: 'json',
	            advanced: {
	                enableSnippets: true,
	                enableBasicAutocompletion: true,
	                enableLiveAutocompletion: true
	            },
	            onLoad: function onLoad(_ace) {
	                (0, _aceEditorFix2.default)(_ace);
	            }
	        };
	
	        if (angular.isUndefined(scope.forceExpandDatasources)) {
	            scope.forceExpandDatasources = false;
	        }
	
	        if (angular.isUndefined(scope.isDataEnabled)) {
	            scope.isDataEnabled = true;
	        }
	
	        scope.currentSettingsSchema = {};
	        scope.currentSettings = angular.copy(scope.emptySettingsSchema);
	
	        scope.targetDeviceAlias = {
	            value: null
	        };
	
	        scope.alarmSource = {
	            value: null
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                var config = ngModelCtrl.$viewValue.config;
	                var layout = ngModelCtrl.$viewValue.layout;
	                if (config) {
	                    scope.selectedTab = 0;
	                    scope.title = config.title;
	                    scope.showTitle = config.showTitle;
	                    scope.dropShadow = angular.isDefined(config.dropShadow) ? config.dropShadow : true;
	                    scope.enableFullscreen = angular.isDefined(config.enableFullscreen) ? config.enableFullscreen : true;
	                    scope.backgroundColor = config.backgroundColor;
	                    scope.color = config.color;
	                    scope.padding = config.padding;
	                    scope.margin = config.margin;
	                    scope.widgetStyle = angular.toJson(angular.isDefined(config.widgetStyle) ? config.widgetStyle : {}, true);
	                    scope.titleStyle = angular.toJson(angular.isDefined(config.titleStyle) ? config.titleStyle : {
	                        fontSize: '16px',
	                        fontWeight: 400
	                    }, true);
	                    scope.units = config.units;
	                    scope.decimals = config.decimals;
	                    scope.useDashboardTimewindow = angular.isDefined(config.useDashboardTimewindow) ? config.useDashboardTimewindow : true;
	                    scope.timewindow = config.timewindow;
	                    scope.showLegend = angular.isDefined(config.showLegend) ? config.showLegend : scope.widgetType === types.widgetType.timeseries.value;
	                    scope.legendConfig = config.legendConfig;
	                    scope.actions = config.actions;
	                    if (!scope.actions) {
	                        scope.actions = {};
	                    }
	                    if (scope.widgetType !== types.widgetType.rpc.value && scope.widgetType !== types.widgetType.alarm.value && scope.widgetType !== types.widgetType.static.value && scope.isDataEnabled) {
	                        if (scope.datasources) {
	                            scope.datasources.splice(0, scope.datasources.length);
	                        } else {
	                            scope.datasources = [];
	                        }
	                        if (config.datasources) {
	                            for (var i = 0; i < config.datasources.length; i++) {
	                                scope.datasources.push({ value: config.datasources[i] });
	                            }
	                        }
	                    } else if (scope.widgetType === types.widgetType.rpc.value && scope.isDataEnabled) {
	                        if (config.targetDeviceAliasIds && config.targetDeviceAliasIds.length > 0) {
	                            var aliasId = config.targetDeviceAliasIds[0];
	                            var entityAliases = scope.aliasController.getEntityAliases();
	                            if (entityAliases[aliasId]) {
	                                scope.targetDeviceAlias.value = entityAliases[aliasId];
	                            } else {
	                                scope.targetDeviceAlias.value = null;
	                            }
	                        } else {
	                            scope.targetDeviceAlias.value = null;
	                        }
	                    } else if (scope.widgetType === types.widgetType.alarm.value && scope.isDataEnabled) {
	                        scope.alarmSearchStatus = angular.isDefined(config.alarmSearchStatus) ? config.alarmSearchStatus : types.alarmSearchStatus.any;
	                        scope.alarmsPollingInterval = angular.isDefined(config.alarmsPollingInterval) ? config.alarmsPollingInterval : 5;
	                        if (config.alarmSource) {
	                            scope.alarmSource.value = config.alarmSource;
	                        } else {
	                            scope.alarmSource.value = null;
	                        }
	                    }
	
	                    scope.settings = config.settings;
	
	                    scope.updateSchemaForm();
	                }
	                if (layout) {
	                    scope.mobileOrder = layout.mobileOrder;
	                    scope.mobileHeight = layout.mobileHeight;
	                }
	            }
	        };
	
	        scope.displayAdvanced = function () {
	            return scope.widgetSettingsSchema && scope.widgetSettingsSchema.schema;
	        };
	
	        scope.updateSchemaForm = function () {
	            if (scope.widgetSettingsSchema && scope.widgetSettingsSchema.schema) {
	                scope.currentSettingsSchema = scope.widgetSettingsSchema.schema;
	                scope.currentSettingsForm = scope.widgetSettingsSchema.form || angular.copy(scope.defaultSettingsForm);
	                scope.currentSettings = scope.settings;
	            } else {
	                scope.currentSettingsForm = angular.copy(scope.defaultSettingsForm);
	                scope.currentSettingsSchema = angular.copy(scope.emptySettingsSchema);
	                scope.currentSettings = {};
	            }
	        };
	
	        scope.updateValidity = function () {
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                var config = value.config;
	                if (config) {
	                    var valid;
	                    if (scope.widgetType === types.widgetType.rpc.value && scope.isDataEnabled) {
	                        valid = config && config.targetDeviceAliasIds && config.targetDeviceAliasIds.length > 0;
	                        ngModelCtrl.$setValidity('targetDeviceAliasIds', valid);
	                    } else if (scope.widgetType === types.widgetType.alarm.value && scope.isDataEnabled) {
	                        valid = config && config.alarmSource;
	                        ngModelCtrl.$setValidity('alarmSource', valid);
	                    } else if (scope.widgetType !== types.widgetType.static.value && scope.isDataEnabled) {
	                        valid = config && config.datasources && config.datasources.length > 0;
	                        ngModelCtrl.$setValidity('datasources', valid);
	                    }
	                    try {
	                        angular.fromJson(scope.widgetStyle);
	                        ngModelCtrl.$setValidity('widgetStyle', true);
	                    } catch (e) {
	                        ngModelCtrl.$setValidity('widgetStyle', false);
	                    }
	                    try {
	                        angular.fromJson(scope.titleStyle);
	                        ngModelCtrl.$setValidity('titleStyle', true);
	                    } catch (e) {
	                        ngModelCtrl.$setValidity('titleStyle', false);
	                    }
	                }
	            }
	        };
	
	        scope.$watch('title + showTitle + dropShadow + enableFullscreen + backgroundColor + color + ' + 'padding + margin + widgetStyle + titleStyle + mobileOrder + mobileHeight + units + decimals + useDashboardTimewindow + ' + 'alarmSearchStatus + alarmsPollingInterval + showLegend', function () {
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                if (value.config) {
	                    var config = value.config;
	                    config.title = scope.title;
	                    config.showTitle = scope.showTitle;
	                    config.dropShadow = scope.dropShadow;
	                    config.enableFullscreen = scope.enableFullscreen;
	                    config.backgroundColor = scope.backgroundColor;
	                    config.color = scope.color;
	                    config.padding = scope.padding;
	                    config.margin = scope.margin;
	                    try {
	                        config.widgetStyle = angular.fromJson(scope.widgetStyle);
	                    } catch (e) {
	                        config.widgetStyle = {};
	                    }
	                    try {
	                        config.titleStyle = angular.fromJson(scope.titleStyle);
	                    } catch (e) {
	                        config.titleStyle = {};
	                    }
	                    config.units = scope.units;
	                    config.decimals = scope.decimals;
	                    config.useDashboardTimewindow = scope.useDashboardTimewindow;
	                    config.alarmSearchStatus = scope.alarmSearchStatus;
	                    config.alarmsPollingInterval = scope.alarmsPollingInterval;
	                    config.showLegend = scope.showLegend;
	                }
	                if (value.layout) {
	                    var layout = value.layout;
	                    layout.mobileOrder = angular.isNumber(scope.mobileOrder) ? scope.mobileOrder : undefined;
	                    layout.mobileHeight = scope.mobileHeight;
	                }
	                ngModelCtrl.$setViewValue(value);
	                scope.updateValidity();
	            }
	        });
	
	        scope.$watch('currentSettings', function () {
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                if (value.config) {
	                    value.config.settings = scope.currentSettings;
	                    ngModelCtrl.$setViewValue(value);
	                }
	            }
	        }, true);
	
	        scope.$watch('timewindow', function () {
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                if (value.config) {
	                    value.config.timewindow = scope.timewindow;
	                    ngModelCtrl.$setViewValue(value);
	                }
	            }
	        }, true);
	
	        scope.$watch('legendConfig', function () {
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                if (value.config) {
	                    value.config.legendConfig = scope.legendConfig;
	                    ngModelCtrl.$setViewValue(value);
	                }
	            }
	        }, true);
	
	        scope.$watch('datasources', function () {
	            if (ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.config && scope.widgetType !== types.widgetType.rpc.value && scope.widgetType !== types.widgetType.alarm.value && scope.widgetType !== types.widgetType.static.value && scope.isDataEnabled) {
	                var value = ngModelCtrl.$viewValue;
	                var config = value.config;
	                if (config.datasources) {
	                    config.datasources.splice(0, config.datasources.length);
	                } else {
	                    config.datasources = [];
	                }
	                if (scope.datasources) {
	                    for (var i = 0; i < scope.datasources.length; i++) {
	                        config.datasources.push(scope.datasources[i].value);
	                    }
	                }
	                ngModelCtrl.$setViewValue(value);
	                scope.updateValidity();
	            }
	        }, true);
	
	        scope.$watch('targetDeviceAlias.value', function () {
	            if (ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.config && scope.widgetType === types.widgetType.rpc.value && scope.isDataEnabled) {
	                var value = ngModelCtrl.$viewValue;
	                var config = value.config;
	                if (scope.targetDeviceAlias.value) {
	                    config.targetDeviceAliasIds = [scope.targetDeviceAlias.value.id];
	                } else {
	                    config.targetDeviceAliasIds = [];
	                }
	                ngModelCtrl.$setViewValue(value);
	                scope.updateValidity();
	            }
	        });
	
	        scope.$watch('alarmSource.value', function () {
	            if (ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.config && scope.widgetType === types.widgetType.alarm.value && scope.isDataEnabled) {
	                var value = ngModelCtrl.$viewValue;
	                var config = value.config;
	                if (scope.alarmSource.value) {
	                    config.alarmSource = scope.alarmSource.value;
	                } else {
	                    config.alarmSource = null;
	                }
	                ngModelCtrl.$setViewValue(value);
	                scope.updateValidity();
	            }
	        });
	
	        scope.$watch('actions', function () {
	            if (ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.config) {
	                var value = ngModelCtrl.$viewValue;
	                var config = value.config;
	                config.actions = scope.actions;
	                ngModelCtrl.$setViewValue(value);
	                scope.updateValidity();
	                /*if (scope.theForm) {
	                    scope.theForm.$setDirty();
	                }*/
	            }
	        }, true);
	
	        scope.addDatasource = function () {
	            var newDatasource;
	            if (scope.functionsOnly) {
	                newDatasource = angular.copy(utils.getDefaultDatasource(scope.datakeySettingsSchema.schema));
	                newDatasource.dataKeys = [scope.generateDataKey('Sin', types.dataKeyType.function)];
	            } else {
	                newDatasource = { type: types.datasourceType.entity,
	                    dataKeys: []
	                };
	            }
	            var datasource = { value: newDatasource };
	            scope.datasources.push(datasource);
	            if (scope.theForm) {
	                scope.theForm.$setDirty();
	            }
	        };
	
	        scope.removeDatasource = function ($event, datasource) {
	            var index = scope.datasources.indexOf(datasource);
	            if (index > -1) {
	                scope.datasources.splice(index, 1);
	                if (scope.theForm) {
	                    scope.theForm.$setDirty();
	                }
	            }
	        };
	
	        scope.generateDataKey = function (chip, type) {
	
	            if (angular.isObject(chip)) {
	                chip._hash = Math.random();
	                return chip;
	            }
	
	            var label = chip;
	            if (type === types.dataKeyType.alarm) {
	                var alarmField = types.alarmFields[chip];
	                if (alarmField) {
	                    label = $translate.instant(alarmField.name) + '';
	                }
	            }
	            label = scope.genNextLabel(label);
	
	            var result = {
	                name: chip,
	                type: type,
	                label: label,
	                color: scope.genNextColor(),
	                settings: {},
	                _hash: Math.random()
	            };
	
	            if (type === types.dataKeyType.function) {
	                result.name = 'f(x)';
	                result.funcBody = utils.getPredefinedFunctionBody(chip);
	                if (!result.funcBody) {
	                    result.funcBody = "return prevValue + 1;";
	                }
	            }
	
	            if (angular.isDefined(scope.datakeySettingsSchema.schema)) {
	                result.settings = utils.generateObjectFromJsonSchema(scope.datakeySettingsSchema.schema);
	            }
	
	            return result;
	        };
	
	        scope.genNextLabel = function (name) {
	            var label = name;
	            var value = ngModelCtrl.$viewValue;
	            var i = 1;
	            var matches = false;
	            do {
	                matches = false;
	                var datasources = scope.widgetType == types.widgetType.alarm.value ? [value.config.alarmSource] : value.config.datasources;
	                if (datasources) {
	                    for (var d = 0; d < datasources.length; d++) {
	                        var datasource = datasources[d];
	                        if (datasource && datasource.dataKeys) {
	                            for (var k = 0; k < datasource.dataKeys.length; k++) {
	                                var dataKey = datasource.dataKeys[k];
	                                if (dataKey.label === label) {
	                                    i++;
	                                    label = name + ' ' + i;
	                                    matches = true;
	                                }
	                            }
	                        }
	                    }
	                }
	            } while (matches);
	            return label;
	        };
	
	        scope.genNextColor = function () {
	            var i = 0;
	            var value = ngModelCtrl.$viewValue;
	            var datasources = scope.widgetType == types.widgetType.alarm.value ? [value.config.alarmSource] : value.config.datasources;
	            if (datasources) {
	                for (var d = 0; d < datasources.length; d++) {
	                    var datasource = datasources[d];
	                    if (datasource && datasource.dataKeys) {
	                        i += datasource.dataKeys.length;
	                    }
	                }
	            }
	            return utils.getMaterialColor(i);
	        };
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            forceExpandDatasources: '=?',
	            isDataEnabled: '=?',
	            widgetType: '=',
	            typeParameters: '=',
	            actionSources: '=',
	            widgetSettingsSchema: '=',
	            datakeySettingsSchema: '=',
	            aliasController: '=',
	            functionsOnly: '=',
	            fetchEntityKeys: '&',
	            fetchDashboardStates: '&',
	            onCreateEntityAlias: '&',
	            theForm: '='
	        },
	        link: linker
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WidgetController.$inject = ["$scope", "$state", "$timeout", "$window", "$element", "$q", "$log", "$injector", "$filter", "$compile", "tbRaf", "types", "utils", "timeService", "datasourceService", "alarmService", "entityService", "dashboardService", "deviceService", "visibleRect", "isEdit", "isMobile", "dashboardTimewindow", "dashboardTimewindowApi", "dashboard", "widget", "aliasController", "stateController", "widgetInfo", "widgetType"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WidgetController;
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(194);
	
	var _subscription = __webpack_require__(1146);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable angular/angularelement */
	
	/*@ngInject*/
	function WidgetController($scope, $state, $timeout, $window, $element, $q, $log, $injector, $filter, $compile, tbRaf, types, utils, timeService, datasourceService, alarmService, entityService, dashboardService, deviceService, visibleRect, isEdit, isMobile, dashboardTimewindow, dashboardTimewindowApi, dashboard, widget, aliasController, stateController, widgetInfo, widgetType) {
	
	    var vm = this;
	
	    $scope.$timeout = $timeout;
	    $scope.$q = $q;
	    $scope.$injector = $injector;
	    $scope.tbRaf = tbRaf;
	
	    $scope.rpcRejection = null;
	    $scope.rpcErrorText = null;
	    $scope.rpcEnabled = false;
	    $scope.executingRpcRequest = false;
	
	    vm.dashboardTimewindow = dashboardTimewindow;
	
	    var gridsterItemInited = false;
	    var subscriptionInited = false;
	    var widgetSizeDetected = false;
	
	    var cafs = {};
	
	    var actionDescriptorsBySourceId = {};
	    if (widget.config.actions) {
	        for (var actionSourceId in widget.config.actions) {
	            var descriptors = widget.config.actions[actionSourceId];
	            var actionDescriptors = [];
	            descriptors.forEach(function (descriptor) {
	                var actionDescriptor = angular.copy(descriptor);
	                actionDescriptor.displayName = utils.customTranslation(descriptor.name, descriptor.name);
	                actionDescriptors.push(actionDescriptor);
	            });
	            actionDescriptorsBySourceId[actionSourceId] = actionDescriptors;
	        }
	    }
	
	    var widgetContext = {
	        inited: false,
	        $container: null,
	        $containerParent: null,
	        width: 0,
	        height: 0,
	        hideTitlePanel: false,
	        isEdit: isEdit,
	        isMobile: isMobile,
	        dashboard: dashboard,
	        widgetConfig: widget.config,
	        settings: widget.config.settings,
	        units: widget.config.units || '',
	        decimals: angular.isDefined(widget.config.decimals) ? widget.config.decimals : 2,
	        subscriptions: {},
	        defaultSubscription: null,
	        dashboardTimewindow: dashboardTimewindow,
	        timewindowFunctions: {
	            onUpdateTimewindow: function onUpdateTimewindow(startTimeMs, endTimeMs) {
	                if (widgetContext.defaultSubscription) {
	                    widgetContext.defaultSubscription.onUpdateTimewindow(startTimeMs, endTimeMs);
	                }
	            },
	            onResetTimewindow: function onResetTimewindow() {
	                if (widgetContext.defaultSubscription) {
	                    widgetContext.defaultSubscription.onResetTimewindow();
	                }
	            }
	        },
	        subscriptionApi: {
	            createSubscription: function createSubscription(options, subscribe) {
	                return _createSubscription(options, subscribe);
	            },
	            createSubscriptionFromInfo: function createSubscriptionFromInfo(type, subscriptionsInfo, options, useDefaultComponents, subscribe) {
	                return _createSubscriptionFromInfo(type, subscriptionsInfo, options, useDefaultComponents, subscribe);
	            },
	            removeSubscription: function removeSubscription(id) {
	                var subscription = widgetContext.subscriptions[id];
	                if (subscription) {
	                    subscription.destroy();
	                    delete widgetContext.subscriptions[id];
	                }
	            }
	        },
	        controlApi: {
	            sendOneWayCommand: function sendOneWayCommand(method, params, timeout) {
	                if (widgetContext.defaultSubscription) {
	                    return widgetContext.defaultSubscription.sendOneWayCommand(method, params, timeout);
	                }
	                return null;
	            },
	            sendTwoWayCommand: function sendTwoWayCommand(method, params, timeout) {
	                if (widgetContext.defaultSubscription) {
	                    return widgetContext.defaultSubscription.sendTwoWayCommand(method, params, timeout);
	                }
	                return null;
	            }
	        },
	        utils: {
	            formatValue: formatValue
	        },
	        actionsApi: {
	            actionDescriptorsBySourceId: actionDescriptorsBySourceId,
	            getActionDescriptors: getActionDescriptors,
	            handleWidgetAction: handleWidgetAction
	        },
	        stateController: stateController,
	        aliasController: aliasController
	    };
	
	    widgetContext.customHeaderActions = [];
	    var headerActionsDescriptors = getActionDescriptors(types.widgetActionSources.headerButton.value);
	    for (var i = 0; i < headerActionsDescriptors.length; i++) {
	        var descriptor = headerActionsDescriptors[i];
	        var headerAction = {};
	        headerAction.name = descriptor.name;
	        headerAction.displayName = descriptor.displayName;
	        headerAction.icon = descriptor.icon;
	        headerAction.descriptor = descriptor;
	        headerAction.onAction = function ($event) {
	            var entityInfo = getFirstEntityInfo();
	            var entityId = entityInfo ? entityInfo.entityId : null;
	            var entityName = entityInfo ? entityInfo.entityName : null;
	            handleWidgetAction($event, this.descriptor, entityId, entityName);
	        };
	        widgetContext.customHeaderActions.push(headerAction);
	    }
	
	    var subscriptionContext = {
	        $scope: $scope,
	        $q: $q,
	        $filter: $filter,
	        $timeout: $timeout,
	        tbRaf: tbRaf,
	        timeService: timeService,
	        deviceService: deviceService,
	        datasourceService: datasourceService,
	        alarmService: alarmService,
	        utils: utils,
	        widgetUtils: widgetContext.utils,
	        dashboardTimewindowApi: dashboardTimewindowApi,
	        types: types,
	        getStDiff: dashboardService.getServerTimeDiff,
	        aliasController: aliasController
	    };
	
	    widget.$ctx = function () {
	        return widgetContext;
	    };
	
	    var widgetTypeInstance;
	
	    vm.typeParameters = widgetInfo.typeParameters;
	
	    try {
	        widgetTypeInstance = new widgetType(widgetContext);
	    } catch (e) {
	        handleWidgetException(e);
	        widgetTypeInstance = {};
	    }
	    if (!widgetTypeInstance.onInit) {
	        widgetTypeInstance.onInit = function () {};
	    }
	    if (!widgetTypeInstance.onDataUpdated) {
	        widgetTypeInstance.onDataUpdated = function () {};
	    }
	    if (!widgetTypeInstance.onResize) {
	        widgetTypeInstance.onResize = function () {};
	    }
	    if (!widgetTypeInstance.onEditModeChanged) {
	        widgetTypeInstance.onEditModeChanged = function () {};
	    }
	    if (!widgetTypeInstance.onMobileModeChanged) {
	        widgetTypeInstance.onMobileModeChanged = function () {};
	    }
	    if (!widgetTypeInstance.onDestroy) {
	        widgetTypeInstance.onDestroy = function () {};
	    }
	
	    //TODO: widgets visibility
	
	    //var bounds = {top: 0, left: 0, bottom: 0, right: 0};
	    /*var visible = false;*/
	    /*vm.visibleRectChanged = visibleRectChanged;
	     function visibleRectChanged(newVisibleRect) {
	        visibleRect = newVisibleRect;
	        updateVisibility();
	    }*/
	
	    $scope.clearRpcError = function () {
	        if (widgetContext.defaultSubscription) {
	            widgetContext.defaultSubscription.clearRpcError();
	        }
	    };
	
	    vm.gridsterItemInitialized = gridsterItemInitialized;
	
	    initialize().then(function () {
	        onInit();
	    });
	
	    function _createSubscriptionFromInfo(type, subscriptionsInfo, options, useDefaultComponents, subscribe) {
	        var deferred = $q.defer();
	        options.type = type;
	
	        if (useDefaultComponents) {
	            defaultComponentsOptions(options);
	        } else {
	            if (!options.timeWindowConfig) {
	                options.useDashboardTimewindow = true;
	            }
	        }
	
	        var createDatasourcesPromise;
	        if (options.type == types.widgetType.alarm.value) {
	            createDatasourcesPromise = entityService.createAlarmSourceFromSubscriptionInfo(subscriptionsInfo);
	        } else {
	            createDatasourcesPromise = entityService.createDatasourcesFromSubscriptionsInfo(subscriptionsInfo);
	        }
	
	        createDatasourcesPromise.then(function (result) {
	            if (options.type == types.widgetType.alarm.value) {
	                options.alarmSource = result;
	            } else {
	                options.datasources = result;
	            }
	            _createSubscription(options, subscribe).then(function success(subscription) {
	                if (useDefaultComponents) {
	                    defaultSubscriptionOptions(subscription, options);
	                }
	                deferred.resolve(subscription);
	            }, function fail() {
	                deferred.reject();
	            });
	        });
	        return deferred.promise;
	    }
	
	    function _createSubscription(options, subscribe) {
	        var deferred = $q.defer();
	        options.dashboardTimewindow = vm.dashboardTimewindow;
	        new _subscription2.default(subscriptionContext, options).then(function success(subscription) {
	            widgetContext.subscriptions[subscription.id] = subscription;
	            if (subscribe) {
	                subscription.subscribe();
	            }
	            deferred.resolve(subscription);
	        }, function fail() {
	            deferred.reject();
	        });
	
	        return deferred.promise;
	    }
	
	    function defaultComponentsOptions(options) {
	        options.useDashboardTimewindow = angular.isDefined(widget.config.useDashboardTimewindow) ? widget.config.useDashboardTimewindow : true;
	
	        options.timeWindowConfig = options.useDashboardTimewindow ? vm.dashboardTimewindow : widget.config.timewindow;
	        options.legendConfig = null;
	
	        if ($scope.displayLegend) {
	            options.legendConfig = $scope.legendConfig;
	        }
	        options.decimals = widgetContext.decimals;
	        options.units = widgetContext.units;
	
	        options.callbacks = {
	            onDataUpdated: function onDataUpdated() {
	                widgetTypeInstance.onDataUpdated();
	            },
	            onDataUpdateError: function onDataUpdateError(subscription, e) {
	                handleWidgetException(e);
	            },
	            dataLoading: function dataLoading(subscription) {
	                if ($scope.loadingData !== subscription.loadingData) {
	                    $scope.loadingData = subscription.loadingData;
	                }
	            },
	            legendDataUpdated: function legendDataUpdated(subscription, apply) {
	                if (apply) {
	                    $scope.$digest();
	                }
	            },
	            timeWindowUpdated: function timeWindowUpdated(subscription, timeWindowConfig) {
	                widget.config.timewindow = timeWindowConfig;
	                $scope.$apply();
	            }
	        };
	    }
	
	    function defaultSubscriptionOptions(subscription, options) {
	        if (!options.useDashboardTimewindow) {
	            $scope.$watch(function () {
	                return widget.config.timewindow;
	            }, function (newTimewindow, prevTimewindow) {
	                if (!angular.equals(newTimewindow, prevTimewindow)) {
	                    subscription.updateTimewindowConfig(widget.config.timewindow);
	                }
	            });
	        }
	        if ($scope.displayLegend) {
	            $scope.legendData = subscription.legendData;
	        }
	    }
	
	    function createDefaultSubscription() {
	        var options;
	        var deferred = $q.defer();
	        if (widget.type !== types.widgetType.rpc.value && widget.type !== types.widgetType.static.value) {
	            options = {
	                type: widget.type,
	                stateData: vm.typeParameters.stateData
	            };
	            if (widget.type == types.widgetType.alarm.value) {
	                options.alarmSource = angular.copy(widget.config.alarmSource);
	                options.alarmSearchStatus = angular.isDefined(widget.config.alarmSearchStatus) ? widget.config.alarmSearchStatus : types.alarmSearchStatus.any;
	                options.alarmsPollingInterval = angular.isDefined(widget.config.alarmsPollingInterval) ? widget.config.alarmsPollingInterval * 1000 : 5000;
	            } else {
	                options.datasources = angular.copy(widget.config.datasources);
	            }
	
	            defaultComponentsOptions(options);
	
	            _createSubscription(options).then(function success(subscription) {
	                defaultSubscriptionOptions(subscription, options);
	
	                // backward compatibility
	
	                widgetContext.datasources = subscription.datasources;
	                widgetContext.data = subscription.data;
	                widgetContext.hiddenData = subscription.hiddenData;
	                widgetContext.timeWindow = subscription.timeWindow;
	                widgetContext.defaultSubscription = subscription;
	                deferred.resolve();
	            }, function fail() {
	                deferred.reject();
	            });
	        } else if (widget.type === types.widgetType.rpc.value) {
	            $scope.loadingData = false;
	            options = {
	                type: widget.type,
	                targetDeviceAliasIds: widget.config.targetDeviceAliasIds
	            };
	            options.callbacks = {
	                rpcStateChanged: function rpcStateChanged(subscription) {
	                    $scope.rpcEnabled = subscription.rpcEnabled;
	                    $scope.executingRpcRequest = subscription.executingRpcRequest;
	                },
	                onRpcSuccess: function onRpcSuccess(subscription) {
	                    $scope.executingRpcRequest = subscription.executingRpcRequest;
	                    $scope.rpcErrorText = subscription.rpcErrorText;
	                    $scope.rpcRejection = subscription.rpcRejection;
	                },
	                onRpcFailed: function onRpcFailed(subscription) {
	                    $scope.executingRpcRequest = subscription.executingRpcRequest;
	                    $scope.rpcErrorText = subscription.rpcErrorText;
	                    $scope.rpcRejection = subscription.rpcRejection;
	                },
	                onRpcErrorCleared: function onRpcErrorCleared() {
	                    $scope.rpcErrorText = null;
	                    $scope.rpcRejection = null;
	                }
	            };
	            _createSubscription(options).then(function success(subscription) {
	                widgetContext.defaultSubscription = subscription;
	                deferred.resolve();
	            }, function fail() {
	                deferred.reject();
	            });
	        } else if (widget.type === types.widgetType.static.value) {
	            $scope.loadingData = false;
	            deferred.resolve();
	        } else {
	            deferred.resolve();
	        }
	        return deferred.promise;
	    }
	
	    function getActionDescriptors(actionSourceId) {
	        var result = widgetContext.actionsApi.actionDescriptorsBySourceId[actionSourceId];
	        if (!result) {
	            result = [];
	        }
	        return result;
	    }
	
	    function updateEntityParams(params, targetEntityParamName, targetEntityId, entityName) {
	        if (targetEntityId) {
	            var targetEntityParams;
	            if (targetEntityParamName && targetEntityParamName.length) {
	                targetEntityParams = params[targetEntityParamName];
	                if (!targetEntityParams) {
	                    targetEntityParams = {};
	                    params[targetEntityParamName] = targetEntityParams;
	                }
	            } else {
	                targetEntityParams = params;
	            }
	            targetEntityParams.entityId = targetEntityId;
	            if (entityName) {
	                targetEntityParams.entityName = entityName;
	            }
	        }
	    }
	
	    function handleWidgetAction($event, descriptor, entityId, entityName, additionalParams) {
	        var type = descriptor.type;
	        var targetEntityParamName = descriptor.stateEntityParamName;
	        var targetEntityId;
	        if (descriptor.setEntityId) {
	            targetEntityId = entityId;
	        }
	        switch (type) {
	            case types.widgetActionTypes.openDashboardState.value:
	            case types.widgetActionTypes.updateDashboardState.value:
	                var targetDashboardStateId = descriptor.targetDashboardStateId;
	                var params = angular.copy(widgetContext.stateController.getStateParams());
	                if (!params) {
	                    params = {};
	                }
	                updateEntityParams(params, targetEntityParamName, targetEntityId, entityName);
	                if (type == types.widgetActionTypes.openDashboardState.value) {
	                    widgetContext.stateController.openState(targetDashboardStateId, params, descriptor.openRightLayout);
	                } else {
	                    widgetContext.stateController.updateState(targetDashboardStateId, params, descriptor.openRightLayout);
	                }
	                break;
	            case types.widgetActionTypes.openDashboard.value:
	                var targetDashboardId = descriptor.targetDashboardId;
	                targetDashboardStateId = descriptor.targetDashboardStateId;
	                var stateObject = {};
	                stateObject.params = {};
	                updateEntityParams(stateObject.params, targetEntityParamName, targetEntityId, entityName);
	                if (targetDashboardStateId) {
	                    stateObject.id = targetDashboardStateId;
	                }
	                var stateParams = {
	                    dashboardId: targetDashboardId,
	                    state: utils.objToBase64([stateObject])
	                };
	                if ($state.current.name === 'dashboard') {
	                    $state.go('dashboard', stateParams);
	                } else {
	                    $state.go('home.dashboards.dashboard', stateParams);
	                }
	                break;
	            case types.widgetActionTypes.custom.value:
	                var customFunction = descriptor.customFunction;
	                if (angular.isDefined(customFunction) && customFunction.length > 0) {
	                    try {
	                        if (!additionalParams) {
	                            additionalParams = {};
	                        }
	                        var customActionFunction = new Function('$event', 'widgetContext', 'entityId', 'entityName', 'additionalParams', customFunction);
	                        customActionFunction($event, widgetContext, entityId, entityName, additionalParams);
	                    } catch (e) {
	                        //
	                    }
	                }
	                break;
	        }
	    }
	
	    function getFirstEntityInfo() {
	        var entityInfo;
	        for (var id in widgetContext.subscriptions) {
	            var subscription = widgetContext.subscriptions[id];
	            entityInfo = subscription.getFirstEntityInfo();
	            if (entityInfo) {
	                break;
	            }
	        }
	        return entityInfo;
	    }
	
	    function configureWidgetElement() {
	
	        $scope.displayLegend = angular.isDefined(widget.config.showLegend) ? widget.config.showLegend : widget.type === types.widgetType.timeseries.value;
	
	        if ($scope.displayLegend) {
	            $scope.legendConfig = widget.config.legendConfig || {
	                position: types.position.bottom.value,
	                showMin: false,
	                showMax: false,
	                showAvg: widget.type === types.widgetType.timeseries.value,
	                showTotal: false
	            };
	            $scope.legendData = {
	                keys: [],
	                data: []
	            };
	        }
	
	        var html = '<div class="tb-absolute-fill tb-widget-error" ng-if="widgetErrorData">' + '<span>Widget Error: {{ widgetErrorData.name + ": " + widgetErrorData.message}}</span>' + '</div>' + '<div class="tb-absolute-fill tb-widget-loading" ng-show="loadingData" layout="column" layout-align="center center">' + '<md-progress-circular md-mode="indeterminate" ng-disabled="!loadingData" class="md-accent" md-diameter="40"></md-progress-circular>' + '</div>';
	
	        var containerHtml = '<div id="container">' + widgetInfo.templateHtml + '</div>';
	        if ($scope.displayLegend) {
	            var layoutType;
	            if ($scope.legendConfig.position === types.position.top.value || $scope.legendConfig.position === types.position.bottom.value) {
	                layoutType = 'column';
	            } else {
	                layoutType = 'row';
	            }
	
	            var legendStyle;
	            switch ($scope.legendConfig.position) {
	                case types.position.top.value:
	                    legendStyle = 'padding-bottom: 8px; max-height: 50%; overflow-y: auto;';
	                    break;
	                case types.position.bottom.value:
	                    legendStyle = 'padding-top: 8px; max-height: 50%; overflow-y: auto;';
	                    break;
	                case types.position.left.value:
	                    legendStyle = 'padding-right: 0px; max-width: 50%; overflow-y: auto;';
	                    break;
	                case types.position.right.value:
	                    legendStyle = 'padding-left: 0px; max-width: 50%; overflow-y: auto;';
	                    break;
	            }
	
	            var legendHtml = '<tb-legend style="' + legendStyle + '" legend-config="legendConfig" legend-data="legendData"></tb-legend>';
	            containerHtml = '<div flex id="widget-container">' + containerHtml + '</div>';
	            html += '<div class="tb-absolute-fill" layout="' + layoutType + '">';
	            if ($scope.legendConfig.position === types.position.top.value || $scope.legendConfig.position === types.position.left.value) {
	                html += legendHtml;
	                html += containerHtml;
	            } else {
	                html += containerHtml;
	                html += legendHtml;
	            }
	            html += '</div>';
	        } else {
	            html += containerHtml;
	        }
	
	        //TODO:
	        /*if (progressElement) {
	         progressScope.$destroy();
	         progressScope = null;
	          progressElement.remove();
	         progressElement = null;
	         }*/
	
	        $element.html(html);
	
	        var containerElement = $scope.displayLegend ? angular.element($element[0].querySelector('#widget-container')) : $element;
	        widgetContext.$container = (0, _jquery2.default)('#container', containerElement);
	        widgetContext.$containerParent = (0, _jquery2.default)(containerElement);
	
	        if (widgetSizeDetected) {
	            widgetContext.$container.css('height', widgetContext.height + 'px');
	            widgetContext.$container.css('width', widgetContext.width + 'px');
	        }
	
	        widgetContext.$scope = $scope.$new();
	
	        $compile($element.contents())(widgetContext.$scope);
	
	        addResizeListener(widgetContext.$containerParent[0], onResize); // eslint-disable-line no-undef
	    }
	
	    function destroyWidgetElement() {
	        removeResizeListener(widgetContext.$containerParent[0], onResize); // eslint-disable-line no-undef
	        $element.html('');
	        if (widgetContext.$scope) {
	            widgetContext.$scope.$destroy();
	        }
	        widgetContext.$container = null;
	        widgetContext.$containerParent = null;
	    }
	
	    function initialize() {
	
	        $scope.$on('toggleDashboardEditMode', function (event, isEdit) {
	            onEditModeChanged(isEdit);
	        });
	
	        $scope.$watch(function () {
	            return widget.row + ',' + widget.col + ',' + widget.config.mobileOrder;
	        }, function () {
	            //updateBounds();
	            $scope.$emit("widgetPositionChanged", widget);
	        });
	
	        $scope.$on('gridster-item-resized', function (event, item) {
	            if (!widgetContext.isMobile) {
	                widget.sizeX = item.sizeX;
	                widget.sizeY = item.sizeY;
	            }
	        });
	
	        $scope.$on('mobileModeChanged', function (event, newIsMobile) {
	            onMobileModeChanged(newIsMobile);
	        });
	
	        $scope.$on('entityAliasesChanged', function (event, aliasIds) {
	            var subscriptionChanged = false;
	            for (var id in widgetContext.subscriptions) {
	                var subscription = widgetContext.subscriptions[id];
	                subscriptionChanged = subscriptionChanged || subscription.onAliasesChanged(aliasIds);
	            }
	            if (subscriptionChanged && !vm.typeParameters.useCustomDatasources) {
	                reInit();
	            }
	        });
	
	        $scope.$on('dashboardTimewindowChanged', function (event, newDashboardTimewindow) {
	            vm.dashboardTimewindow = newDashboardTimewindow;
	            widgetContext.dashboardTimewindow = newDashboardTimewindow;
	        });
	
	        $scope.$on("$destroy", function () {
	            onDestroy();
	        });
	
	        configureWidgetElement();
	        var deferred = $q.defer();
	        if (!vm.typeParameters.useCustomDatasources) {
	            createDefaultSubscription().then(function success() {
	                subscriptionInited = true;
	                deferred.resolve();
	            }, function fail() {
	                subscriptionInited = true;
	                deferred.reject();
	            });
	        } else {
	            $scope.loadingData = false;
	            subscriptionInited = true;
	            deferred.resolve();
	        }
	        return deferred.promise;
	    }
	
	    function reInit() {
	        onDestroy();
	        configureWidgetElement();
	        if (!vm.typeParameters.useCustomDatasources) {
	            createDefaultSubscription().then(function success() {
	                subscriptionInited = true;
	                onInit();
	            }, function fail() {
	                subscriptionInited = true;
	                onInit();
	            });
	        } else {
	            subscriptionInited = true;
	            onInit();
	        }
	    }
	
	    function handleWidgetException(e) {
	        $log.error(e);
	        $scope.widgetErrorData = utils.processWidgetException(e);
	    }
	
	    function isReady() {
	        return subscriptionInited && gridsterItemInited && widgetSizeDetected;
	    }
	
	    function onInit(skipSizeCheck) {
	        if (!widgetContext.$containerParent) {
	            return;
	        }
	        if (!skipSizeCheck) {
	            checkSize();
	        }
	        if (!widgetContext.inited && isReady()) {
	            widgetContext.inited = true;
	            try {
	                widgetTypeInstance.onInit();
	            } catch (e) {
	                handleWidgetException(e);
	            }
	            if (!vm.typeParameters.useCustomDatasources && widgetContext.defaultSubscription) {
	                widgetContext.defaultSubscription.subscribe();
	            }
	        }
	    }
	
	    function checkSize() {
	        var width = widgetContext.$containerParent.width();
	        var height = widgetContext.$containerParent.height();
	        var sizeChanged = false;
	
	        if (!widgetContext.width || widgetContext.width != width || !widgetContext.height || widgetContext.height != height) {
	            if (width > 0 && height > 0) {
	                widgetContext.$container.css('height', height + 'px');
	                widgetContext.$container.css('width', width + 'px');
	                widgetContext.width = width;
	                widgetContext.height = height;
	                sizeChanged = true;
	                widgetSizeDetected = true;
	            }
	        }
	        return sizeChanged;
	    }
	
	    function onResize() {
	        if (checkSize()) {
	            if (widgetContext.inited) {
	                if (cafs['resize']) {
	                    cafs['resize']();
	                    cafs['resize'] = null;
	                }
	                cafs['resize'] = tbRaf(function () {
	                    try {
	                        widgetTypeInstance.onResize();
	                    } catch (e) {
	                        handleWidgetException(e);
	                    }
	                });
	            } else {
	                onInit(true);
	            }
	        }
	    }
	
	    function gridsterItemInitialized(item) {
	        if (item && item.gridster) {
	            gridsterItemInited = true;
	            onInit();
	            // gridsterItemElement = $(item.$element);
	            //updateVisibility();
	        }
	    }
	
	    function onEditModeChanged(isEdit) {
	        if (widgetContext.isEdit != isEdit) {
	            widgetContext.isEdit = isEdit;
	            if (widgetContext.inited) {
	                if (cafs['editMode']) {
	                    cafs['editMode']();
	                    cafs['editMode'] = null;
	                }
	                cafs['editMode'] = tbRaf(function () {
	                    try {
	                        widgetTypeInstance.onEditModeChanged();
	                    } catch (e) {
	                        handleWidgetException(e);
	                    }
	                });
	            }
	        }
	    }
	
	    function onMobileModeChanged(isMobile) {
	        if (widgetContext.isMobile != isMobile) {
	            widgetContext.isMobile = isMobile;
	            if (widgetContext.inited) {
	                if (cafs['mobileMode']) {
	                    cafs['mobileMode']();
	                    cafs['mobileMode'] = null;
	                }
	                cafs['mobileMode'] = tbRaf(function () {
	                    try {
	                        widgetTypeInstance.onMobileModeChanged();
	                    } catch (e) {
	                        handleWidgetException(e);
	                    }
	                });
	            }
	        }
	    }
	
	    function isNumeric(val) {
	        return val - parseFloat(val) + 1 >= 0;
	    }
	
	    function formatValue(value, dec, units, showZeroDecimals) {
	        if (angular.isDefined(value) && value !== null && isNumeric(value)) {
	            var formatted = Number(value);
	            if (angular.isDefined(dec)) {
	                formatted = formatted.toFixed(dec);
	            }
	            if (!showZeroDecimals) {
	                formatted = formatted * 1;
	            }
	            formatted = formatted.toString();
	            if (angular.isDefined(units) && units.length > 0) {
	                formatted += ' ' + units;
	            }
	            return formatted;
	        } else {
	            return value;
	        }
	    }
	
	    function onDestroy() {
	        for (var id in widgetContext.subscriptions) {
	            var subscription = widgetContext.subscriptions[id];
	            subscription.destroy();
	        }
	        subscriptionInited = false;
	        widgetContext.subscriptions = {};
	        if (widgetContext.inited) {
	            widgetContext.inited = false;
	            for (var cafId in cafs) {
	                if (cafs[cafId]) {
	                    cafs[cafId]();
	                    cafs[cafId] = null;
	                }
	            }
	            try {
	                widgetTypeInstance.onDestroy();
	            } catch (e) {
	                handleWidgetException(e);
	            }
	        }
	        destroyWidgetElement();
	    }
	
	    //TODO: widgets visibility
	    /*function updateVisibility(forceRedraw) {
	        if (visibleRect) {
	            forceRedraw = forceRedraw || visibleRect.containerResized;
	            var newVisible = false;
	            if (visibleRect.isMobile && gridsterItemElement) {
	                var topPx = gridsterItemElement.position().top;
	                var bottomPx = topPx + widget.sizeY * visibleRect.curRowHeight;
	                newVisible = !(topPx > visibleRect.bottomPx ||
	                bottomPx < visibleRect.topPx);
	            } else {
	                newVisible = !(bounds.left > visibleRect.right ||
	                bounds.right < visibleRect.left ||
	                bounds.top > visibleRect.bottom ||
	                bounds.bottom < visibleRect.top);
	            }
	            if (visible != newVisible) {
	                visible = newVisible;
	                if (visible) {
	                    onRedraw(50);
	                }
	            } else if (forceRedraw && visible) {
	                onRedraw(50);
	            }
	        }
	    }*/
	
	    /*    function updateBounds() {
	            bounds = {
	                top: widget.row,
	                left: widget.col,
	                bottom: widget.row + widget.sizeY,
	                right: widget.col + widget.sizeX
	            };
	            updateVisibility(true);
	            onRedraw();
	        }*/
	}
	
	/* eslint-enable angular/angularelement */
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Widget.$inject = ["$controller", "widgetService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(777);
	
	var _legend = __webpack_require__(1188);
	
	var _legend2 = _interopRequireDefault(_legend);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _datasource = __webpack_require__(1141);
	
	var _datasource2 = _interopRequireDefault(_datasource);
	
	var _widget = __webpack_require__(1206);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.directives.widget', [_legend2.default, _types2.default, _datasource2.default]).controller('WidgetController', _widget2.default).directive('tbWidget', Widget).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function Widget($controller, widgetService) {
	    return {
	        scope: true,
	        link: function link(scope, elem, attrs) {
	
	            var locals = scope.$eval(attrs.locals);
	            var widget = locals.widget;
	
	            var widgetController;
	            var gridsterItem;
	
	            //TODO: widgets visibility
	            /*scope.$on('visibleRectChanged', function (event, newVisibleRect) {
	                locals.visibleRect = newVisibleRect;
	                if (widgetController) {
	                    widgetController.visibleRectChanged(newVisibleRect);
	                }
	            });*/
	
	            scope.$on('gridster-item-initialized', function (event, item) {
	                gridsterItem = item;
	                if (widgetController) {
	                    widgetController.gridsterItemInitialized(gridsterItem);
	                }
	            });
	
	            //TODO:
	            //elem.html('<div id="progress-cover" flex layout="column" layout-align="center center" style="height: 100%;">' +
	            //          '     <md-progress-circular md-mode="indeterminate" class="md-accent md-hue-2" md-diameter="120"></md-progress-circular>' +
	            //          '</div>');
	
	            //var progressElement = angular.element(elem[0].querySelector('#progress-cover'));
	            //var progressScope = scope.$new();
	            //$compile(elem.contents())(progressScope);
	
	            widgetService.getWidgetInfo(widget.bundleAlias, widget.typeAlias, widget.isSystemType).then(function (widgetInfo) {
	                loadFromWidgetInfo(widgetInfo);
	            });
	
	            function loadFromWidgetInfo(widgetInfo) {
	
	                scope.loadingData = true;
	
	                elem.addClass("tb-widget");
	
	                var widgetNamespace = "widget-type-" + (widget.isSystemType ? 'sys-' : '') + widget.bundleAlias + '-' + widget.typeAlias;
	
	                elem.addClass(widgetNamespace);
	
	                var widgetType = widgetService.getWidgetTypeFunction(widget.bundleAlias, widget.typeAlias, widget.isSystemType);
	
	                angular.extend(locals, { $scope: scope, $element: elem, widgetInfo: widgetInfo, widgetType: widgetType });
	
	                widgetController = $controller('WidgetController', locals);
	
	                if (gridsterItem) {
	                    widgetController.gridsterItemInitialized(gridsterItem);
	                }
	            }
	        }
	    };
	}

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WidgetsBundleSelect.$inject = ["$compile", "$templateCache", "widgetService", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(778);
	
	var _widget = __webpack_require__(147);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	var _widgetsBundleSelectTpl = __webpack_require__(1422);
	
	var _widgetsBundleSelectTpl2 = _interopRequireDefault(_widgetsBundleSelectTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.directives.widgetsBundleSelect', [_widget2.default]).directive('tbWidgetsBundleSelect', WidgetsBundleSelect).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function WidgetsBundleSelect($compile, $templateCache, widgetService, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_widgetsBundleSelectTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	        scope.widgetsBundle = null;
	        scope.widgetsBundles = [];
	
	        var widgetsBundleFetchFunction = widgetService.getAllWidgetsBundles;
	        if (angular.isDefined(scope.bundlesScope)) {
	            if (scope.bundlesScope === 'system') {
	                widgetsBundleFetchFunction = widgetService.getSystemWidgetsBundles;
	            } else if (scope.bundlesScope === 'tenant') {
	                widgetsBundleFetchFunction = widgetService.getTenantWidgetsBundles;
	            }
	        }
	
	        widgetsBundleFetchFunction({ ignoreLoading: true }).then(function success(widgetsBundles) {
	            scope.widgetsBundles = widgetsBundles;
	            if (scope.selectFirstBundle) {
	                if (widgetsBundles.length > 0) {
	                    scope.widgetsBundle = widgetsBundles[0];
	                }
	            } else if (angular.isDefined(scope.selectBundleAlias)) {
	                selectWidgetsBundleByAlias(scope.selectBundleAlias);
	            }
	        }, function fail() {});
	
	        function selectWidgetsBundleByAlias(alias) {
	            if (scope.widgetsBundles && alias) {
	                for (var w in scope.widgetsBundles) {
	                    var widgetsBundle = scope.widgetsBundles[w];
	                    if (widgetsBundle.alias === alias) {
	                        scope.widgetsBundle = widgetsBundle;
	                        break;
	                    }
	                }
	            }
	        }
	
	        scope.isSystem = function (item) {
	            return item && item.tenantId.id === types.id.nullUid;
	        };
	
	        scope.updateView = function () {
	            ngModelCtrl.$setViewValue(scope.widgetsBundle);
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                scope.widgetsBundle = ngModelCtrl.$viewValue;
	            }
	        };
	
	        scope.$watch('widgetsBundle', function () {
	            scope.updateView();
	        });
	
	        scope.$watch('selectBundleAlias', function (newVal, prevVal) {
	            if (newVal !== prevVal) {
	                selectWidgetsBundleByAlias(scope.selectBundleAlias);
	            }
	        });
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            bundlesScope: '@',
	            theForm: '=?',
	            tbRequired: '=?',
	            selectFirstBundle: '=',
	            selectBundleAlias: '=?'
	        }
	    };
	}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CustomerController.$inject = ["customerService", "$state", "$stateParams", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = CustomerController;
	
	var _addCustomerTpl = __webpack_require__(1423);
	
	var _addCustomerTpl2 = _interopRequireDefault(_addCustomerTpl);
	
	var _customerCardTpl = __webpack_require__(1424);
	
	var _customerCardTpl2 = _interopRequireDefault(_customerCardTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function CustomerController(customerService, $state, $stateParams, $translate, types) {
	
	    var customerActionsList = [{
	        onAction: function onAction($event, item) {
	            openCustomerUsers($event, item);
	        },
	        name: function name() {
	            return $translate.instant('user.users');
	        },
	        details: function details() {
	            return $translate.instant('customer.manage-customer-users');
	        },
	        icon: "account_circle",
	        isEnabled: function isEnabled(customer) {
	            return customer && (!customer.additionalInfo || !customer.additionalInfo.isPublic);
	        }
	    }, {
	        onAction: function onAction($event, item) {
	            openCustomerAssets($event, item);
	        },
	        name: function name() {
	            return $translate.instant('asset.assets');
	        },
	        details: function details(customer) {
	            if (customer && customer.additionalInfo && customer.additionalInfo.isPublic) {
	                return $translate.instant('customer.manage-public-assets');
	            } else {
	                return $translate.instant('customer.manage-customer-assets');
	            }
	        },
	        icon: "domain"
	    }, {
	        onAction: function onAction($event, item) {
	            openCustomerDevices($event, item);
	        },
	        name: function name() {
	            return $translate.instant('device.devices');
	        },
	        details: function details(customer) {
	            if (customer && customer.additionalInfo && customer.additionalInfo.isPublic) {
	                return $translate.instant('customer.manage-public-devices');
	            } else {
	                return $translate.instant('customer.manage-customer-devices');
	            }
	        },
	        icon: "devices_other"
	    }, {
	        onAction: function onAction($event, item) {
	            openCustomerDashboards($event, item);
	        },
	        name: function name() {
	            return $translate.instant('dashboard.dashboards');
	        },
	        details: function details(customer) {
	            if (customer && customer.additionalInfo && customer.additionalInfo.isPublic) {
	                return $translate.instant('customer.manage-public-dashboards');
	            } else {
	                return $translate.instant('customer.manage-customer-dashboards');
	            }
	        },
	        icon: "dashboard"
	    }, {
	        onAction: function onAction($event, item) {
	            vm.grid.deleteItem($event, item);
	        },
	        name: function name() {
	            return $translate.instant('action.delete');
	        },
	        details: function details() {
	            return $translate.instant('customer.delete');
	        },
	        icon: "delete",
	        isEnabled: function isEnabled(customer) {
	            return customer && (!customer.additionalInfo || !customer.additionalInfo.isPublic);
	        }
	    }];
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.customerGridConfig = {
	
	        refreshParamsFunc: null,
	
	        deleteItemTitleFunc: deleteCustomerTitle,
	        deleteItemContentFunc: deleteCustomerText,
	        deleteItemsTitleFunc: deleteCustomersTitle,
	        deleteItemsActionTitleFunc: deleteCustomersActionTitle,
	        deleteItemsContentFunc: deleteCustomersText,
	
	        fetchItemsFunc: fetchCustomers,
	        saveItemFunc: saveCustomer,
	        deleteItemFunc: deleteCustomer,
	
	        getItemTitleFunc: getCustomerTitle,
	
	        itemCardTemplateUrl: _customerCardTpl2.default,
	
	        actionsList: customerActionsList,
	
	        onGridInited: gridInited,
	
	        addItemTemplateUrl: _addCustomerTpl2.default,
	
	        addItemText: function addItemText() {
	            return $translate.instant('customer.add-customer-text');
	        },
	        noItemsText: function noItemsText() {
	            return $translate.instant('customer.no-customers-text');
	        },
	        itemDetailsText: function itemDetailsText(customer) {
	            if (customer && (!customer.additionalInfo || !customer.additionalInfo.isPublic)) {
	                return $translate.instant('customer.customer-details');
	            } else {
	                return '';
	            }
	        },
	        isSelectionEnabled: function isSelectionEnabled(customer) {
	            return customer && (!customer.additionalInfo || !customer.additionalInfo.isPublic);
	        },
	        isDetailsReadOnly: function isDetailsReadOnly(customer) {
	            return customer && customer.additionalInfo && customer.additionalInfo.isPublic;
	        }
	    };
	
	    if (angular.isDefined($stateParams.items) && $stateParams.items !== null) {
	        vm.customerGridConfig.items = $stateParams.items;
	    }
	
	    if (angular.isDefined($stateParams.topIndex) && $stateParams.topIndex > 0) {
	        vm.customerGridConfig.topIndex = $stateParams.topIndex;
	    }
	
	    vm.openCustomerUsers = openCustomerUsers;
	    vm.openCustomerAssets = openCustomerAssets;
	    vm.openCustomerDevices = openCustomerDevices;
	    vm.openCustomerDashboards = openCustomerDashboards;
	
	    function deleteCustomerTitle(customer) {
	        return $translate.instant('customer.delete-customer-title', { customerTitle: customer.title });
	    }
	
	    function deleteCustomerText() {
	        return $translate.instant('customer.delete-customer-text');
	    }
	
	    function deleteCustomersTitle(selectedCount) {
	        return $translate.instant('customer.delete-customers-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteCustomersActionTitle(selectedCount) {
	        return $translate.instant('customer.delete-customers-action-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteCustomersText() {
	        return $translate.instant('customer.delete-customers-text');
	    }
	
	    function gridInited(grid) {
	        vm.grid = grid;
	    }
	
	    function fetchCustomers(pageLink) {
	        return customerService.getCustomers(pageLink);
	    }
	
	    function saveCustomer(customer) {
	        return customerService.saveCustomer(customer);
	    }
	
	    function deleteCustomer(customerId) {
	        return customerService.deleteCustomer(customerId);
	    }
	
	    function getCustomerTitle(customer) {
	        return customer ? customer.title : '';
	    }
	
	    function openCustomerUsers($event, customer) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        $state.go('home.customers.users', { customerId: customer.id.id });
	    }
	
	    function openCustomerAssets($event, customer) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        $state.go('home.customers.assets', { customerId: customer.id.id });
	    }
	
	    function openCustomerDevices($event, customer) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        $state.go('home.customers.devices', { customerId: customer.id.id });
	    }
	
	    function openCustomerDashboards($event, customer) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        $state.go('home.customers.dashboards', { customerId: customer.id.id });
	    }
	}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CustomerDirective.$inject = ["$compile", "$templateCache", "$translate", "toast"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = CustomerDirective;
	
	var _customerFieldsetTpl = __webpack_require__(1425);
	
	var _customerFieldsetTpl2 = _interopRequireDefault(_customerFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function CustomerDirective($compile, $templateCache, $translate, toast) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_customerFieldsetTpl2.default);
	        element.html(template);
	
	        scope.isPublic = false;
	
	        scope.onCustomerIdCopied = function () {
	            toast.showSuccess($translate.instant('customer.idCopiedMessage'), 750, angular.element(element).parent().parent(), 'bottom left');
	        };
	
	        scope.$watch('customer', function (newVal) {
	            if (newVal) {
	                if (scope.customer.additionalInfo) {
	                    scope.isPublic = scope.customer.additionalInfo.isPublic;
	                } else {
	                    scope.isPublic = false;
	                }
	            }
	        });
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            customer: '=',
	            isEdit: '=',
	            theForm: '=',
	            onManageUsers: '&',
	            onManageAssets: '&',
	            onManageDevices: '&',
	            onManageDashboards: '&',
	            onDeleteCustomer: '&'
	        }
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CustomerRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = CustomerRoutes;
	
	var _customersTpl = __webpack_require__(1426);
	
	var _customersTpl2 = _interopRequireDefault(_customersTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function CustomerRoutes($stateProvider) {
	
	    $stateProvider.state('home.customers', {
	        url: '/customers',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _customersTpl2.default,
	                controllerAs: 'vm',
	                controller: 'CustomerController'
	            }
	        },
	        data: {
	            searchEnabled: true,
	            pageTitle: 'customer.customers'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "supervisor_account", "label": "customer.customers"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _customer = __webpack_require__(112);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _grid = __webpack_require__(74);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _contact = __webpack_require__(507);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _contactShort = __webpack_require__(506);
	
	var _contactShort2 = _interopRequireDefault(_contactShort);
	
	var _customer3 = __webpack_require__(1211);
	
	var _customer4 = _interopRequireDefault(_customer3);
	
	var _customer5 = __webpack_require__(1209);
	
	var _customer6 = _interopRequireDefault(_customer5);
	
	var _customer7 = __webpack_require__(1210);
	
	var _customer8 = _interopRequireDefault(_customer7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.customer', [_angularUiRouter2.default, _customer2.default, _grid2.default, _contact2.default, _contactShort2.default]).config(_customer4.default).controller('CustomerController', _customer6.default).directive('tbCustomer', _customer8.default).name;

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

	'use strict';
	
	AddDashboardsToCustomerController.$inject = ["dashboardService", "$mdDialog", "$q", "customerId", "dashboards"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AddDashboardsToCustomerController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AddDashboardsToCustomerController(dashboardService, $mdDialog, $q, customerId, dashboards) {
	
	    var vm = this;
	
	    vm.dashboards = dashboards;
	    vm.searchText = '';
	
	    vm.assign = assign;
	    vm.cancel = cancel;
	    vm.hasData = hasData;
	    vm.noData = noData;
	    vm.searchDashboardTextUpdated = searchDashboardTextUpdated;
	    vm.toggleDashboardSelection = toggleDashboardSelection;
	
	    vm.theDashboards = {
	        getItemAtIndex: function getItemAtIndex(index) {
	            if (index > vm.dashboards.data.length) {
	                vm.theDashboards.fetchMoreItems_(index);
	                return null;
	            }
	            var item = vm.dashboards.data[index];
	            if (item) {
	                item.indexNumber = index + 1;
	            }
	            return item;
	        },
	
	        getLength: function getLength() {
	            if (vm.dashboards.hasNext) {
	                return vm.dashboards.data.length + vm.dashboards.nextPageLink.limit;
	            } else {
	                return vm.dashboards.data.length;
	            }
	        },
	
	        fetchMoreItems_: function fetchMoreItems_() {
	            if (vm.dashboards.hasNext && !vm.dashboards.pending) {
	                vm.dashboards.pending = true;
	                dashboardService.getTenantDashboards(vm.dashboards.nextPageLink).then(function success(dashboards) {
	                    vm.dashboards.data = vm.dashboards.data.concat(dashboards.data);
	                    vm.dashboards.nextPageLink = dashboards.nextPageLink;
	                    vm.dashboards.hasNext = dashboards.hasNext;
	                    if (vm.dashboards.hasNext) {
	                        vm.dashboards.nextPageLink.limit = vm.dashboards.pageSize;
	                    }
	                    vm.dashboards.pending = false;
	                }, function fail() {
	                    vm.dashboards.hasNext = false;
	                    vm.dashboards.pending = false;
	                });
	            }
	        }
	    };
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function assign() {
	        var tasks = [];
	        for (var dashboardId in vm.dashboards.selections) {
	            tasks.push(dashboardService.assignDashboardToCustomer(customerId, dashboardId));
	        }
	        $q.all(tasks).then(function () {
	            $mdDialog.hide();
	        });
	    }
	
	    function noData() {
	        return vm.dashboards.data.length == 0 && !vm.dashboards.hasNext;
	    }
	
	    function hasData() {
	        return vm.dashboards.data.length > 0;
	    }
	
	    function toggleDashboardSelection($event, dashboard) {
	        $event.stopPropagation();
	        var selected = angular.isDefined(dashboard.selected) && dashboard.selected;
	        dashboard.selected = !selected;
	        if (dashboard.selected) {
	            vm.dashboards.selections[dashboard.id.id] = true;
	            vm.dashboards.selectedCount++;
	        } else {
	            delete vm.dashboards.selections[dashboard.id.id];
	            vm.dashboards.selectedCount--;
	        }
	    }
	
	    function searchDashboardTextUpdated() {
	        vm.dashboards = {
	            pageSize: vm.dashboards.pageSize,
	            data: [],
	            nextPageLink: {
	                limit: vm.dashboards.pageSize,
	                textSearch: vm.searchText
	            },
	            selections: {},
	            selectedCount: 0,
	            hasNext: true,
	            pending: false
	        };
	    }
	}

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AddWidgetController.$inject = ["$scope", "widgetService", "entityService", "$mdDialog", "$q", "$document", "types", "dashboard", "aliasController", "widget", "widgetInfo"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AddWidgetController;
	
	var _entityAliasDialogTpl = __webpack_require__(233);
	
	var _entityAliasDialogTpl2 = _interopRequireDefault(_entityAliasDialogTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function AddWidgetController($scope, widgetService, entityService, $mdDialog, $q, $document, types, dashboard, aliasController, widget, widgetInfo) {
	
	    var vm = this;
	
	    vm.dashboard = dashboard;
	    vm.aliasController = aliasController;
	    vm.widget = widget;
	    vm.widgetInfo = widgetInfo;
	
	    vm.functionsOnly = false;
	
	    vm.helpLinkIdForWidgetType = helpLinkIdForWidgetType;
	    vm.add = add;
	    vm.cancel = cancel;
	    vm.fetchEntityKeys = fetchEntityKeys;
	    vm.fetchDashboardStates = fetchDashboardStates;
	    vm.createEntityAlias = createEntityAlias;
	
	    vm.widgetConfig = {
	        config: vm.widget.config,
	        layout: {}
	    };
	
	    vm.widgetConfig.layout.mobileOrder = vm.widget.config.mobileOrder;
	    vm.widgetConfig.layout.mobileHeight = vm.widget.config.mobileHeight;
	
	    var settingsSchema = vm.widgetInfo.typeSettingsSchema || widgetInfo.settingsSchema;
	    var dataKeySettingsSchema = vm.widgetInfo.typeDataKeySettingsSchema || widgetInfo.dataKeySettingsSchema;
	
	    if (!settingsSchema || settingsSchema === '') {
	        vm.settingsSchema = {};
	    } else {
	        vm.settingsSchema = angular.fromJson(settingsSchema);
	    }
	    if (!dataKeySettingsSchema || dataKeySettingsSchema === '') {
	        vm.dataKeySettingsSchema = {};
	    } else {
	        vm.dataKeySettingsSchema = angular.fromJson(dataKeySettingsSchema);
	    }
	
	    function helpLinkIdForWidgetType() {
	        var link = 'widgetsConfig';
	        if (vm.widget && vm.widget.type) {
	            switch (vm.widget.type) {
	                case types.widgetType.timeseries.value:
	                    {
	                        link = 'widgetsConfigTimeseries';
	                        break;
	                    }
	                case types.widgetType.latest.value:
	                    {
	                        link = 'widgetsConfigLatest';
	                        break;
	                    }
	                case types.widgetType.rpc.value:
	                    {
	                        link = 'widgetsConfigRpc';
	                        break;
	                    }
	                case types.widgetType.alarm.value:
	                    {
	                        link = 'widgetsConfigAlarm';
	                        break;
	                    }
	                case types.widgetType.static.value:
	                    {
	                        link = 'widgetsConfigStatic';
	                        break;
	                    }
	            }
	        }
	        return link;
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function add() {
	        if ($scope.theForm.$valid) {
	            $scope.theForm.$setPristine();
	            vm.widget.config = vm.widgetConfig.config;
	            vm.widget.config.mobileOrder = vm.widgetConfig.layout.mobileOrder;
	            vm.widget.config.mobileHeight = vm.widgetConfig.layout.mobileHeight;
	            $mdDialog.hide({ widget: vm.widget });
	        }
	    }
	
	    function fetchEntityKeys(entityAliasId, query, type) {
	        var deferred = $q.defer();
	        vm.aliasController.getAliasInfo(entityAliasId).then(function success(aliasInfo) {
	            var entity = aliasInfo.currentEntity;
	            if (entity) {
	                entityService.getEntityKeys(entity.entityType, entity.id, query, type, { ignoreLoading: true }).then(function success(keys) {
	                    deferred.resolve(keys);
	                }, function fail() {
	                    deferred.resolve([]);
	                });
	            } else {
	                deferred.resolve([]);
	            }
	        }, function fail() {
	            deferred.resolve([]);
	        });
	        return deferred.promise;
	    }
	
	    function fetchDashboardStates(query) {
	        var deferred = $q.defer();
	        var stateIds = Object.keys(vm.dashboard.configuration.states);
	        var result = query ? stateIds.filter(createFilterForDashboardState(query)) : stateIds;
	        if (result && result.length) {
	            deferred.resolve(result);
	        } else {
	            deferred.resolve([query]);
	        }
	        return deferred.promise;
	    }
	
	    function createFilterForDashboardState(query) {
	        var lowercaseQuery = angular.lowercase(query);
	        return function filterFn(stateId) {
	            return angular.lowercase(stateId).indexOf(lowercaseQuery) === 0;
	        };
	    }
	
	    function createEntityAlias(event, alias, allowedEntityTypes) {
	
	        var deferred = $q.defer();
	        var singleEntityAlias = { id: null, alias: alias, filter: {} };
	
	        $mdDialog.show({
	            controller: 'EntityAliasDialogController',
	            controllerAs: 'vm',
	            templateUrl: _entityAliasDialogTpl2.default,
	            locals: {
	                isAdd: true,
	                allowedEntityTypes: allowedEntityTypes,
	                entityAliases: vm.dashboard.configuration.entityAliases,
	                alias: singleEntityAlias
	            },
	            parent: angular.element($document[0].body),
	            fullscreen: true,
	            skipHide: true,
	            targetEvent: event
	        }).then(function (singleEntityAlias) {
	            vm.dashboard.configuration.entityAliases[singleEntityAlias.id] = singleEntityAlias;
	            vm.aliasController.updateEntityAliases(vm.dashboard.configuration.entityAliases);
	            deferred.resolve(singleEntityAlias);
	        }, function () {
	            deferred.reject();
	        });
	
	        return deferred.promise;
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DashboardSettingsController.$inject = ["$scope", "$mdDialog", "statesControllerService", "settings", "gridSettings"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DashboardSettingsController;
	
	__webpack_require__(780);
	
	/*@ngInject*/
	function DashboardSettingsController($scope, $mdDialog, statesControllerService, settings, gridSettings) {
	
	    var vm = this;
	
	    vm.cancel = cancel;
	    vm.save = save;
	    vm.imageAdded = imageAdded;
	    vm.clearImage = clearImage;
	
	    vm.stateControllerIdChanged = stateControllerIdChanged;
	
	    vm.settings = settings;
	    vm.gridSettings = gridSettings;
	    vm.stateControllers = statesControllerService.getStateControllers();
	
	    if (vm.settings) {
	        if (angular.isUndefined(vm.settings.stateControllerId)) {
	            vm.settings.stateControllerId = 'entity';
	        }
	
	        if (angular.isUndefined(vm.settings.showTitle)) {
	            vm.settings.showTitle = false;
	        }
	
	        if (angular.isUndefined(vm.settings.titleColor)) {
	            vm.settings.titleColor = 'rgba(0,0,0,0.870588)';
	        }
	
	        if (angular.isUndefined(vm.settings.showDashboardsSelect)) {
	            vm.settings.showDashboardsSelect = true;
	        }
	
	        if (angular.isUndefined(vm.settings.showEntitiesSelect)) {
	            vm.settings.showEntitiesSelect = true;
	        }
	
	        if (angular.isUndefined(vm.settings.showDashboardTimewindow)) {
	            vm.settings.showDashboardTimewindow = true;
	        }
	
	        if (angular.isUndefined(vm.settings.showDashboardExport)) {
	            vm.settings.showDashboardExport = true;
	        }
	
	        if (angular.isUndefined(vm.settings.toolbarAlwaysOpen)) {
	            vm.settings.toolbarAlwaysOpen = true;
	        }
	    }
	
	    if (vm.gridSettings) {
	        vm.gridSettings.backgroundColor = vm.gridSettings.backgroundColor || 'rgba(0,0,0,0)';
	        vm.gridSettings.color = vm.gridSettings.color || 'rgba(0,0,0,0.870588)';
	        vm.gridSettings.columns = vm.gridSettings.columns || 24;
	        vm.gridSettings.margins = vm.gridSettings.margins || [10, 10];
	        vm.gridSettings.autoFillHeight = angular.isDefined(vm.gridSettings.autoFillHeight) ? vm.gridSettings.autoFillHeight : false;
	        vm.gridSettings.mobileAutoFillHeight = angular.isDefined(vm.gridSettings.mobileAutoFillHeight) ? vm.gridSettings.mobileAutoFillHeight : false;
	        vm.gridSettings.mobileRowHeight = angular.isDefined(vm.gridSettings.mobileRowHeight) ? vm.gridSettings.mobileRowHeight : 70;
	        vm.hMargin = vm.gridSettings.margins[0];
	        vm.vMargin = vm.gridSettings.margins[1];
	        vm.gridSettings.backgroundSizeMode = vm.gridSettings.backgroundSizeMode || '100%';
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function imageAdded($file) {
	        var reader = new FileReader();
	        reader.onload = function (event) {
	            $scope.$apply(function () {
	                if (event.target.result && event.target.result.startsWith('data:image/')) {
	                    $scope.theForm.$setDirty();
	                    vm.gridSettings.backgroundImageUrl = event.target.result;
	                }
	            });
	        };
	        reader.readAsDataURL($file.file);
	    }
	
	    function clearImage() {
	        $scope.theForm.$setDirty();
	        vm.gridSettings.backgroundImageUrl = null;
	    }
	
	    function stateControllerIdChanged() {
	        if (vm.settings.stateControllerId != 'default') {
	            vm.settings.toolbarAlwaysOpen = true;
	        }
	    }
	
	    function save() {
	        $scope.theForm.$setPristine();
	        if (vm.gridSettings) {
	            vm.gridSettings.margins = [vm.hMargin, vm.vMargin];
	        }
	        $mdDialog.hide({
	            settings: vm.settings,
	            gridSettings: vm.gridSettings
	        });
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DashboardToolbarController.$inject = ["$scope", "$element", "$timeout", "mdFabToolbarAnimation"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DashboardToolbar;
	
	__webpack_require__(781);
	
	__webpack_require__(194);
	
	var _dashboardToolbarTpl = __webpack_require__(1432);
	
	var _dashboardToolbarTpl2 = _interopRequireDefault(_dashboardToolbarTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function DashboardToolbar() {
	    return {
	        restrict: "E",
	        scope: true,
	        transclude: true,
	        bindToController: {
	            toolbarOpened: '=',
	            forceFullscreen: '=',
	            onTriggerClick: '&'
	        },
	        controller: DashboardToolbarController,
	        controllerAs: 'vm',
	        templateUrl: _dashboardToolbarTpl2.default
	    };
	}
	
	/* eslint-disable angular/angularelement */
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function DashboardToolbarController($scope, $element, $timeout, mdFabToolbarAnimation) {
	
	    var vm = this;
	
	    vm.mdFabToolbarElement = angular.element($element[0].querySelector('md-fab-toolbar'));
	
	    function initElements() {
	        $timeout(function () {
	            vm.mdFabBackgroundElement = angular.element(vm.mdFabToolbarElement[0].querySelector('.md-fab-toolbar-background'));
	            vm.mdFabTriggerElement = angular.element(vm.mdFabToolbarElement[0].querySelector('md-fab-trigger button'));
	            if (!vm.mdFabBackgroundElement || !vm.mdFabBackgroundElement[0]) {
	                initElements();
	            } else {
	                triggerFabResize();
	            }
	        });
	    }
	
	    addResizeListener(vm.mdFabToolbarElement[0], triggerFabResize); // eslint-disable-line no-undef
	
	    $scope.$on("$destroy", function () {
	        removeResizeListener(vm.mdFabToolbarElement[0], triggerFabResize); // eslint-disable-line no-undef
	    });
	
	    initElements();
	
	    function triggerFabResize() {
	        if (!vm.mdFabBackgroundElement || !vm.mdFabBackgroundElement[0]) {
	            return;
	        }
	        var ctrl = vm.mdFabToolbarElement.controller('mdFabToolbar');
	        if (ctrl.isOpen) {
	            if (!vm.mdFabBackgroundElement[0].offsetWidth) {
	                mdFabToolbarAnimation.addClass(vm.mdFabToolbarElement, 'md-is-open', function () {});
	            } else {
	                var color = window.getComputedStyle(vm.mdFabTriggerElement[0]).getPropertyValue('background-color'); //eslint-disable-line
	
	                var width = vm.mdFabToolbarElement[0].offsetWidth;
	                var scale = 2 * (width / vm.mdFabTriggerElement[0].offsetWidth);
	                vm.mdFabBackgroundElement[0].style.backgroundColor = color;
	                vm.mdFabBackgroundElement[0].style.borderRadius = width + 'px';
	
	                var transform = vm.mdFabBackgroundElement[0].style.transform;
	                var targetTransform = 'scale(' + scale + ')';
	                if (!transform || !angular.equals(transform, targetTransform)) {
	                    vm.mdFabBackgroundElement[0].style.transform = targetTransform;
	                }
	            }
	        }
	    }
	}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DashboardController.$inject = ["types", "utils", "dashboardUtils", "widgetService", "userService", "dashboardService", "timeService", "entityService", "itembuffer", "importExport", "hotkeys", "$window", "$rootScope", "$scope", "$element", "$state", "$stateParams", "$mdDialog", "$mdMedia", "$timeout", "$document", "$q", "$translate", "$filter"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DashboardController;
	
	var _entityAliasesTpl = __webpack_require__(522);
	
	var _entityAliasesTpl2 = _interopRequireDefault(_entityAliasesTpl);
	
	var _dashboardSettingsTpl = __webpack_require__(519);
	
	var _dashboardSettingsTpl2 = _interopRequireDefault(_dashboardSettingsTpl);
	
	var _manageDashboardLayoutsTpl = __webpack_require__(1436);
	
	var _manageDashboardLayoutsTpl2 = _interopRequireDefault(_manageDashboardLayoutsTpl);
	
	var _manageDashboardStatesTpl = __webpack_require__(1442);
	
	var _manageDashboardStatesTpl2 = _interopRequireDefault(_manageDashboardStatesTpl);
	
	var _addWidgetTpl = __webpack_require__(1429);
	
	var _addWidgetTpl2 = _interopRequireDefault(_addWidgetTpl);
	
	var _selectTargetLayoutTpl = __webpack_require__(521);
	
	var _selectTargetLayoutTpl2 = _interopRequireDefault(_selectTargetLayoutTpl);
	
	var _aliasController = __webpack_require__(227);
	
	var _aliasController2 = _interopRequireDefault(_aliasController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	function DashboardController(types, utils, dashboardUtils, widgetService, userService, dashboardService, timeService, entityService, itembuffer, importExport, hotkeys, $window, $rootScope, $scope, $element, $state, $stateParams, $mdDialog, $mdMedia, $timeout, $document, $q, $translate, $filter) {
	
	    var vm = this;
	
	    vm.user = userService.getCurrentUser();
	    vm.dashboard = null;
	    vm.editingWidget = null;
	    vm.editingWidgetLayout = null;
	    vm.editingWidgetOriginal = null;
	    vm.editingWidgetLayoutOriginal = null;
	    vm.editingWidgetSubtitle = null;
	    vm.forceDashboardMobileMode = false;
	    vm.isAddingWidget = false;
	    vm.isEdit = false;
	    vm.isEditingWidget = false;
	    vm.latestWidgetTypes = [];
	    vm.timeseriesWidgetTypes = [];
	    vm.rpcWidgetTypes = [];
	    vm.alarmWidgetTypes = [];
	    vm.staticWidgetTypes = [];
	    vm.widgetEditMode = $state.$current.data.widgetEditMode;
	    vm.iframeMode = $rootScope.iframeMode;
	
	    vm.isToolbarOpened = false;
	
	    vm.thingsboardVersion = ("2.1.3"); //eslint-disable-line
	
	    vm.currentDashboardId = $stateParams.dashboardId;
	    if ($stateParams.customerId) {
	        vm.currentCustomerId = $stateParams.customerId;
	        vm.currentDashboardScope = 'customer';
	    } else {
	        vm.currentDashboardScope = vm.user.authority === 'TENANT_ADMIN' ? 'tenant' : 'customer';
	        vm.currentCustomerId = vm.user.customerId;
	    }
	
	    Object.defineProperty(vm, 'toolbarOpened', {
	        get: function get() {
	            return !vm.widgetEditMode && (toolbarAlwaysOpen() || vm.isToolbarOpened || vm.isEdit || vm.showRightLayoutSwitch());
	        },
	        set: function set() {}
	    });
	
	    Object.defineProperty(vm, 'rightLayoutOpened', {
	        get: function get() {
	            return !vm.isMobile || vm.isRightLayoutOpened;
	        },
	        set: function set() {}
	    });
	
	    vm.layouts = {
	        main: {
	            show: false,
	            layoutCtx: {
	                id: 'main',
	                widgets: [],
	                widgetLayouts: {},
	                gridSettings: {},
	                ignoreLoading: false
	            }
	        },
	        right: {
	            show: false,
	            layoutCtx: {
	                id: 'right',
	                widgets: [],
	                widgetLayouts: {},
	                gridSettings: {},
	                ignoreLoading: false
	            }
	        }
	    };
	
	    vm.openToolbar = function () {
	        $timeout(function () {
	            vm.isToolbarOpened = true;
	        });
	    };
	
	    vm.closeToolbar = function () {
	        $timeout(function () {
	            vm.isToolbarOpened = false;
	        });
	    };
	
	    vm.showCloseToolbar = function () {
	        return !vm.toolbarAlwaysOpen() && !vm.isEdit && !vm.showRightLayoutSwitch();
	    };
	
	    vm.toolbarAlwaysOpen = toolbarAlwaysOpen;
	
	    vm.showRightLayoutSwitch = function () {
	        return vm.isMobile && vm.layouts.right.show;
	    };
	
	    vm.toggleLayouts = function () {
	        vm.isRightLayoutOpened = !vm.isRightLayoutOpened;
	    };
	
	    vm.openRightLayout = function () {
	        vm.isRightLayoutOpened = true;
	    };
	
	    vm.isRightLayoutOpened = false;
	    vm.isMobile = !$mdMedia('gt-sm');
	
	    $scope.$watch(function () {
	        return $mdMedia('gt-sm');
	    }, function (isGtSm) {
	        vm.isMobile = !isGtSm;
	    });
	
	    vm.mainLayoutWidth = function () {
	        if (vm.isEditingWidget && vm.editingLayoutCtx.id === 'main') {
	            return '100%';
	        } else {
	            return vm.layouts.right.show && !vm.isMobile ? '50%' : '100%';
	        }
	    };
	
	    vm.mainLayoutHeight = function () {
	        if (!vm.isEditingWidget || vm.editingLayoutCtx.id === 'main') {
	            return '100%';
	        } else {
	            return '0px';
	        }
	    };
	
	    vm.rightLayoutWidth = function () {
	        if (vm.isEditingWidget && vm.editingLayoutCtx.id === 'right') {
	            return '100%';
	        } else {
	            return vm.isMobile ? '100%' : '50%';
	        }
	    };
	
	    vm.rightLayoutHeight = function () {
	        if (!vm.isEditingWidget || vm.editingLayoutCtx.id === 'right') {
	            return '100%';
	        } else {
	            return '0px';
	        }
	    };
	
	    vm.addWidget = addWidget;
	    vm.addWidgetFromType = addWidgetFromType;
	    vm.exportDashboard = exportDashboard;
	    vm.importWidget = importWidget;
	    vm.isPublicUser = isPublicUser;
	    vm.isTenantAdmin = isTenantAdmin;
	    vm.isSystemAdmin = isSystemAdmin;
	    vm.dashboardConfigurationError = dashboardConfigurationError;
	    vm.showDashboardToolbar = showDashboardToolbar;
	    vm.onAddWidgetClosed = onAddWidgetClosed;
	    vm.onEditWidgetClosed = onEditWidgetClosed;
	    vm.openDashboardState = openDashboardState;
	    vm.openEntityAliases = openEntityAliases;
	    vm.openDashboardSettings = openDashboardSettings;
	    vm.manageDashboardLayouts = manageDashboardLayouts;
	    vm.manageDashboardStates = manageDashboardStates;
	    vm.saveDashboard = saveDashboard;
	    vm.saveWidget = saveWidget;
	    vm.toggleDashboardEditMode = toggleDashboardEditMode;
	    vm.onRevertWidgetEdit = onRevertWidgetEdit;
	    vm.helpLinkIdForWidgetType = helpLinkIdForWidgetType;
	    vm.displayTitle = displayTitle;
	    vm.displayExport = displayExport;
	    vm.displayDashboardTimewindow = displayDashboardTimewindow;
	    vm.displayDashboardsSelect = displayDashboardsSelect;
	    vm.displayEntitiesSelect = displayEntitiesSelect;
	    vm.hideFullscreenButton = hideFullscreenButton;
	
	    vm.widgetsBundle;
	
	    vm.dashboardCtx = {
	        state: null,
	        stateController: {
	            openRightLayout: function openRightLayout() {
	                vm.openRightLayout();
	            }
	        },
	        onAddWidget: function onAddWidget(event, layoutCtx) {
	            addWidget(event, layoutCtx);
	        },
	        onEditWidget: function onEditWidget(event, layoutCtx, widget) {
	            editWidget(event, layoutCtx, widget);
	        },
	        onExportWidget: function onExportWidget(event, layoutCtx, widget) {
	            exportWidget(event, layoutCtx, widget);
	        },
	        onWidgetMouseDown: function onWidgetMouseDown(event, layoutCtx, widget) {
	            widgetMouseDown(event, layoutCtx, widget);
	        },
	        onWidgetClicked: function onWidgetClicked(event, layoutCtx, widget) {
	            widgetClicked(event, layoutCtx, widget);
	        },
	        prepareDashboardContextMenu: function prepareDashboardContextMenu(layoutCtx) {
	            return _prepareDashboardContextMenu(layoutCtx);
	        },
	        prepareWidgetContextMenu: function prepareWidgetContextMenu(layoutCtx, widget) {
	            return _prepareWidgetContextMenu(layoutCtx, widget);
	        },
	        onRemoveWidget: function onRemoveWidget(event, layoutCtx, widget) {
	            removeWidget(event, layoutCtx, widget);
	        },
	        copyWidget: function copyWidget($event, layoutCtx, widget) {
	            _copyWidget($event, layoutCtx, widget);
	        },
	        copyWidgetReference: function copyWidgetReference($event, layoutCtx, widget) {
	            _copyWidgetReference($event, layoutCtx, widget);
	        },
	        pasteWidget: function pasteWidget($event, layoutCtx, pos) {
	            _pasteWidget($event, layoutCtx, pos);
	        },
	        pasteWidgetReference: function pasteWidgetReference($event, layoutCtx, pos) {
	            _pasteWidgetReference($event, layoutCtx, pos);
	        }
	    };
	
	    $scope.$watch('vm.widgetsBundle', function (newVal, prevVal) {
	        if (newVal !== prevVal && !vm.widgetEditMode) {
	            loadWidgetLibrary();
	        }
	    });
	
	    $scope.$watch('vm.currentDashboardId', function (newVal, prevVal) {
	        if (newVal !== prevVal && !vm.widgetEditMode) {
	            if (vm.currentDashboardScope === 'customer' && vm.user.authority === 'TENANT_ADMIN') {
	                $state.go('home.customers.dashboards.dashboard', {
	                    customerId: vm.currentCustomerId,
	                    dashboardId: vm.currentDashboardId
	                });
	            } else {
	                if ($state.current.name === 'dashboard') {
	                    $state.go('dashboard', { dashboardId: vm.currentDashboardId });
	                } else {
	                    $state.go('home.dashboards.dashboard', { dashboardId: vm.currentDashboardId });
	                }
	            }
	        }
	    });
	
	    $scope.$on("$destroy", function () {
	        vm.dashboardCtx.stateController.cleanupPreservedStates();
	    });
	
	    loadDashboard();
	
	    function loadWidgetLibrary() {
	        vm.latestWidgetTypes = [];
	        vm.timeseriesWidgetTypes = [];
	        vm.rpcWidgetTypes = [];
	        vm.alarmWidgetTypes = [];
	        vm.staticWidgetTypes = [];
	        if (vm.widgetsBundle) {
	            var bundleAlias = vm.widgetsBundle.alias;
	            var isSystem = vm.widgetsBundle.tenantId.id === types.id.nullUid;
	
	            widgetService.getBundleWidgetTypes(bundleAlias, isSystem).then(function (widgetTypes) {
	
	                widgetTypes = $filter('orderBy')(widgetTypes, ['-createdTime']);
	
	                var top = 0;
	
	                if (widgetTypes.length > 0) {
	                    loadNext(0);
	                }
	
	                function loadNextOrComplete(i) {
	                    i++;
	                    if (i < widgetTypes.length) {
	                        loadNext(i);
	                    }
	                }
	
	                function loadNext(i) {
	                    var widgetType = widgetTypes[i];
	                    var widgetTypeInfo = widgetService.toWidgetInfo(widgetType);
	                    var widget = {
	                        isSystemType: isSystem,
	                        bundleAlias: bundleAlias,
	                        typeAlias: widgetTypeInfo.alias,
	                        type: widgetTypeInfo.type,
	                        title: widgetTypeInfo.widgetName,
	                        sizeX: widgetTypeInfo.sizeX,
	                        sizeY: widgetTypeInfo.sizeY,
	                        row: top,
	                        col: 0,
	                        config: angular.fromJson(widgetTypeInfo.defaultConfig)
	                    };
	                    widget.config.title = widgetTypeInfo.widgetName;
	                    if (widgetTypeInfo.type === types.widgetType.timeseries.value) {
	                        vm.timeseriesWidgetTypes.push(widget);
	                    } else if (widgetTypeInfo.type === types.widgetType.latest.value) {
	                        vm.latestWidgetTypes.push(widget);
	                    } else if (widgetTypeInfo.type === types.widgetType.rpc.value) {
	                        vm.rpcWidgetTypes.push(widget);
	                    } else if (widgetTypeInfo.type === types.widgetType.alarm.value) {
	                        vm.alarmWidgetTypes.push(widget);
	                    } else if (widgetTypeInfo.type === types.widgetType.static.value) {
	                        vm.staticWidgetTypes.push(widget);
	                    }
	                    top += widget.sizeY;
	                    loadNextOrComplete(i);
	                }
	            });
	        }
	    }
	
	    function loadDashboard() {
	        if (vm.widgetEditMode) {
	            var widget = {
	                isSystemType: true,
	                bundleAlias: 'customWidgetBundle',
	                typeAlias: 'customWidget',
	                type: $rootScope.editWidgetInfo.type,
	                title: 'My widget',
	                sizeX: $rootScope.editWidgetInfo.sizeX * 2,
	                sizeY: $rootScope.editWidgetInfo.sizeY * 2,
	                row: 2,
	                col: 4,
	                config: angular.fromJson($rootScope.editWidgetInfo.defaultConfig)
	            };
	            widget.config.title = widget.config.title || $rootScope.editWidgetInfo.widgetName;
	
	            vm.dashboard = dashboardUtils.createSingleWidgetDashboard(widget);
	            vm.dashboardConfiguration = vm.dashboard.configuration;
	            vm.dashboardCtx.dashboard = vm.dashboard;
	            vm.dashboardCtx.dashboardTimewindow = vm.dashboardConfiguration.timewindow;
	            vm.dashboardCtx.aliasController = new _aliasController2.default($scope, $q, $filter, utils, types, entityService, vm.dashboardCtx.stateController, vm.dashboardConfiguration.entityAliases);
	            var parentScope = $window.parent.angular.element($window.frameElement).scope();
	            parentScope.$root.$broadcast('widgetEditModeInited');
	            parentScope.$root.$apply();
	        } else {
	            dashboardService.getDashboard($stateParams.dashboardId).then(function success(dashboard) {
	                vm.dashboard = dashboardUtils.validateAndUpdateDashboard(dashboard);
	                vm.dashboardConfiguration = vm.dashboard.configuration;
	                vm.dashboardCtx.dashboard = vm.dashboard;
	                vm.dashboardCtx.dashboardTimewindow = vm.dashboardConfiguration.timewindow;
	                vm.dashboardCtx.aliasController = new _aliasController2.default($scope, $q, $filter, utils, types, entityService, vm.dashboardCtx.stateController, vm.dashboardConfiguration.entityAliases);
	            }, function fail() {
	                vm.configurationError = true;
	            });
	        }
	    }
	
	    function openDashboardState(state, openRightLayout) {
	        var layoutsData = dashboardUtils.getStateLayoutsData(vm.dashboard, state);
	        if (layoutsData) {
	            vm.dashboardCtx.state = state;
	            vm.dashboardCtx.aliasController.dashboardStateChanged();
	            var layoutVisibilityChanged = false;
	            for (var l in vm.layouts) {
	                var layout = vm.layouts[l];
	                var showLayout;
	                if (layoutsData[l]) {
	                    showLayout = true;
	                } else {
	                    showLayout = false;
	                }
	                if (layout.show != showLayout) {
	                    layout.show = showLayout;
	                    layoutVisibilityChanged = !vm.isMobile;
	                }
	            }
	            vm.isRightLayoutOpened = openRightLayout ? true : false;
	            updateLayouts(layoutVisibilityChanged);
	        }
	
	        function updateLayouts(layoutVisibilityChanged) {
	            for (l in vm.layouts) {
	                layout = vm.layouts[l];
	                if (layoutsData[l]) {
	                    var layoutInfo = layoutsData[l];
	                    if (layout.layoutCtx.id === 'main') {
	                        layout.layoutCtx.ctrl.setResizing(layoutVisibilityChanged);
	                    }
	                    updateLayout(layout, layoutInfo.widgets, layoutInfo.widgetLayouts, layoutInfo.gridSettings);
	                } else {
	                    updateLayout(layout, [], {}, null);
	                }
	            }
	        }
	    }
	
	    function updateLayout(layout, widgets, widgetLayouts, gridSettings) {
	        if (gridSettings) {
	            layout.layoutCtx.gridSettings = gridSettings;
	        }
	        layout.layoutCtx.widgets = widgets;
	        layout.layoutCtx.widgetLayouts = widgetLayouts;
	        if (layout.show && layout.layoutCtx.ctrl) {
	            layout.layoutCtx.ctrl.reload();
	        }
	        layout.layoutCtx.ignoreLoading = true;
	    }
	
	    function isPublicUser() {
	        return vm.user.isPublic === true;
	    }
	
	    function isTenantAdmin() {
	        return vm.user.authority === 'TENANT_ADMIN';
	    }
	
	    function isSystemAdmin() {
	        return vm.user.authority === 'SYS_ADMIN';
	    }
	
	    function dashboardConfigurationError() {
	        return vm.configurationError;
	    }
	
	    function showDashboardToolbar() {
	        return true;
	    }
	
	    function openEntityAliases($event) {
	        $mdDialog.show({
	            controller: 'EntityAliasesController',
	            controllerAs: 'vm',
	            templateUrl: _entityAliasesTpl2.default,
	            locals: {
	                config: {
	                    entityAliases: angular.copy(vm.dashboard.configuration.entityAliases),
	                    widgets: dashboardUtils.getWidgetsArray(vm.dashboard),
	                    isSingleEntityAlias: false,
	                    singleEntityAlias: null
	                }
	            },
	            parent: angular.element($document[0].body),
	            skipHide: true,
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (entityAliases) {
	            vm.dashboard.configuration.entityAliases = entityAliases;
	            entityAliasesUpdated();
	        }, function () {});
	    }
	
	    function openDashboardSettings($event) {
	        var gridSettings = null;
	        var layoutKeys = dashboardUtils.isSingleLayoutDashboard(vm.dashboard);
	        if (layoutKeys) {
	            gridSettings = angular.copy(vm.dashboard.configuration.states[layoutKeys.state].layouts[layoutKeys.layout].gridSettings);
	        }
	        $mdDialog.show({
	            controller: 'DashboardSettingsController',
	            controllerAs: 'vm',
	            templateUrl: _dashboardSettingsTpl2.default,
	            locals: {
	                settings: angular.copy(vm.dashboard.configuration.settings),
	                gridSettings: gridSettings
	            },
	            parent: angular.element($document[0].body),
	            skipHide: true,
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (data) {
	            vm.dashboard.configuration.settings = data.settings;
	            var gridSettings = data.gridSettings;
	            if (gridSettings) {
	                updateLayoutGrid(layoutKeys, gridSettings);
	            }
	        }, function () {});
	    }
	
	    function manageDashboardLayouts($event) {
	        $mdDialog.show({
	            controller: 'ManageDashboardLayoutsController',
	            controllerAs: 'vm',
	            templateUrl: _manageDashboardLayoutsTpl2.default,
	            locals: {
	                layouts: angular.copy(vm.dashboard.configuration.states[vm.dashboardCtx.state].layouts)
	            },
	            parent: angular.element($document[0].body),
	            skipHide: true,
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (layouts) {
	            updateLayouts(layouts);
	        }, function () {});
	    }
	
	    function manageDashboardStates($event) {
	        var dashboardConfiguration = vm.dashboard.configuration;
	        var states = angular.copy(dashboardConfiguration.states);
	
	        $mdDialog.show({
	            controller: 'ManageDashboardStatesController',
	            controllerAs: 'vm',
	            templateUrl: _manageDashboardStatesTpl2.default,
	            locals: {
	                states: states
	            },
	            parent: angular.element($document[0].body),
	            skipHide: true,
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (states) {
	            updateStates(states);
	        }, function () {});
	    }
	
	    function updateLayoutGrid(layoutKeys, gridSettings) {
	        var layout = vm.dashboard.configuration.states[layoutKeys.state].layouts[layoutKeys.layout];
	        var layoutCtx = vm.layouts[layoutKeys.layout];
	        layoutCtx.widgets = [];
	        dashboardUtils.updateLayoutSettings(layout, gridSettings);
	        var layoutsData = dashboardUtils.getStateLayoutsData(vm.dashboard, layoutKeys.state);
	        layoutCtx.widgets = layoutsData[layoutKeys.layout].widgets;
	    }
	
	    function updateLayouts(layouts) {
	        dashboardUtils.setLayouts(vm.dashboard, vm.dashboardCtx.state, layouts);
	        openDashboardState(vm.dashboardCtx.state);
	    }
	
	    function updateStates(states) {
	        vm.dashboard.configuration.states = states;
	        dashboardUtils.removeUnusedWidgets(vm.dashboard);
	        var targetState = vm.dashboardCtx.state;
	        if (!vm.dashboard.configuration.states[targetState]) {
	            targetState = dashboardUtils.getRootStateId(vm.dashboardConfiguration.states);
	        }
	        openDashboardState(targetState);
	    }
	
	    function editWidget($event, layoutCtx, widget) {
	        $event.stopPropagation();
	        if (vm.editingWidgetOriginal === widget) {
	            $timeout(onEditWidgetClosed());
	        } else {
	            var transition = !vm.forceDashboardMobileMode;
	            vm.editingWidgetOriginal = widget;
	            vm.editingWidgetLayoutOriginal = layoutCtx.widgetLayouts[widget.id];
	            vm.editingWidget = angular.copy(vm.editingWidgetOriginal);
	            vm.editingWidgetLayout = angular.copy(vm.editingWidgetLayoutOriginal);
	            vm.editingLayoutCtx = layoutCtx;
	            vm.editingWidgetSubtitle = widgetService.getInstantWidgetInfo(vm.editingWidget).widgetName;
	            vm.forceDashboardMobileMode = true;
	            vm.isEditingWidget = true;
	            if (layoutCtx) {
	                var delayOffset = transition ? 350 : 0;
	                var delay = transition ? 400 : 300;
	                $timeout(function () {
	                    layoutCtx.ctrl.highlightWidget(vm.editingWidgetOriginal, delay);
	                }, delayOffset, false);
	            }
	        }
	    }
	    function exportDashboard($event) {
	        $event.stopPropagation();
	        importExport.exportDashboard(vm.currentDashboardId);
	    }
	
	    function exportWidget($event, layoutCtx, widget) {
	        $event.stopPropagation();
	        importExport.exportWidget(vm.dashboard, vm.dashboardCtx.state, layoutCtx.id, widget);
	    }
	
	    function importWidget($event) {
	        $event.stopPropagation();
	        importExport.importWidget($event, vm.dashboard, vm.dashboardCtx.state, selectTargetLayout, entityAliasesUpdated).then(function success(importData) {
	            var widget = importData.widget;
	            var layoutId = importData.layoutId;
	            vm.layouts[layoutId].layoutCtx.widgets.push(widget);
	        });
	    }
	
	    function widgetMouseDown($event, layoutCtx, widget) {
	        if (vm.isEdit && !vm.isEditingWidget) {
	            layoutCtx.ctrl.selectWidget(widget, 0);
	        }
	    }
	
	    function widgetClicked($event, layoutCtx, widget) {
	        if (vm.isEditingWidget) {
	            editWidget($event, layoutCtx, widget);
	        }
	    }
	
	    function _prepareDashboardContextMenu(layoutCtx) {
	        var dashboardContextActions = [];
	        if (vm.isEdit && !vm.isEditingWidget && !vm.widgetEditMode) {
	            dashboardContextActions.push({
	                action: openDashboardSettings,
	                enabled: true,
	                value: "dashboard.settings",
	                icon: "settings"
	            });
	            dashboardContextActions.push({
	                action: openEntityAliases,
	                enabled: true,
	                value: "entity.aliases",
	                icon: "devices_other"
	            });
	            dashboardContextActions.push({
	                action: function action($event) {
	                    layoutCtx.ctrl.pasteWidget($event);
	                },
	                enabled: itembuffer.hasWidget(),
	                value: "action.paste",
	                icon: "content_paste",
	                shortcut: "M-V"
	            });
	            dashboardContextActions.push({
	                action: function action($event) {
	                    layoutCtx.ctrl.pasteWidgetReference($event);
	                },
	                enabled: itembuffer.canPasteWidgetReference(vm.dashboard, vm.dashboardCtx.state, layoutCtx.id),
	                value: "action.paste-reference",
	                icon: "content_paste",
	                shortcut: "M-I"
	            });
	        }
	        return dashboardContextActions;
	    }
	
	    function _prepareWidgetContextMenu(layoutCtx) {
	        var widgetContextActions = [];
	        if (vm.isEdit && !vm.isEditingWidget) {
	            widgetContextActions.push({
	                action: function action(event, widget) {
	                    editWidget(event, layoutCtx, widget);
	                },
	                enabled: true,
	                value: "action.edit",
	                icon: "edit"
	            });
	            if (!vm.widgetEditMode) {
	                widgetContextActions.push({
	                    action: function action(event, widget) {
	                        _copyWidget(event, layoutCtx, widget);
	                    },
	                    enabled: true,
	                    value: "action.copy",
	                    icon: "content_copy",
	                    shortcut: "M-C"
	                });
	                widgetContextActions.push({
	                    action: function action(event, widget) {
	                        _copyWidgetReference(event, layoutCtx, widget);
	                    },
	                    enabled: true,
	                    value: "action.copy-reference",
	                    icon: "content_copy",
	                    shortcut: "M-R"
	                });
	                widgetContextActions.push({
	                    action: function action(event, widget) {
	                        removeWidget(event, layoutCtx, widget);
	                    },
	                    enabled: true,
	                    value: "action.delete",
	                    icon: "clear",
	                    shortcut: "M-X"
	                });
	            }
	        }
	        return widgetContextActions;
	    }
	
	    function _copyWidget($event, layoutCtx, widget) {
	        itembuffer.copyWidget(vm.dashboard, vm.dashboardCtx.state, layoutCtx.id, widget);
	    }
	
	    function _copyWidgetReference($event, layoutCtx, widget) {
	        itembuffer.copyWidgetReference(vm.dashboard, vm.dashboardCtx.state, layoutCtx.id, widget);
	    }
	
	    function helpLinkIdForWidgetType() {
	        var link = 'widgetsConfig';
	        if (vm.editingWidget && vm.editingWidget.type) {
	            switch (vm.editingWidget.type) {
	                case types.widgetType.timeseries.value:
	                    {
	                        link = 'widgetsConfigTimeseries';
	                        break;
	                    }
	                case types.widgetType.latest.value:
	                    {
	                        link = 'widgetsConfigLatest';
	                        break;
	                    }
	                case types.widgetType.rpc.value:
	                    {
	                        link = 'widgetsConfigRpc';
	                        break;
	                    }
	                case types.widgetType.alarm.value:
	                    {
	                        link = 'widgetsConfigAlarm';
	                        break;
	                    }
	                case types.widgetType.static.value:
	                    {
	                        link = 'widgetsConfigStatic';
	                        break;
	                    }
	            }
	        }
	        return link;
	    }
	
	    function toolbarAlwaysOpen() {
	        if (vm.dashboard && vm.dashboard.configuration.settings && angular.isDefined(vm.dashboard.configuration.settings.toolbarAlwaysOpen)) {
	            return vm.dashboard.configuration.settings.toolbarAlwaysOpen;
	        } else {
	            return true;
	        }
	    }
	
	    function displayTitle() {
	        if (vm.dashboard && vm.dashboard.configuration.settings && angular.isDefined(vm.dashboard.configuration.settings.showTitle)) {
	            return vm.dashboard.configuration.settings.showTitle;
	        } else {
	            return false;
	        }
	    }
	
	    function displayExport() {
	        if (vm.dashboard && vm.dashboard.configuration.settings && angular.isDefined(vm.dashboard.configuration.settings.showDashboardExport)) {
	            return vm.dashboard.configuration.settings.showDashboardExport;
	        } else {
	            return true;
	        }
	    }
	
	    function displayDashboardTimewindow() {
	        if (vm.dashboard && vm.dashboard.configuration.settings && angular.isDefined(vm.dashboard.configuration.settings.showDashboardTimewindow)) {
	            return vm.dashboard.configuration.settings.showDashboardTimewindow;
	        } else {
	            return true;
	        }
	    }
	
	    function displayDashboardsSelect() {
	        if (vm.dashboard && vm.dashboard.configuration.settings && angular.isDefined(vm.dashboard.configuration.settings.showDashboardsSelect)) {
	            return vm.dashboard.configuration.settings.showDashboardsSelect;
	        } else {
	            return true;
	        }
	    }
	
	    function displayEntitiesSelect() {
	        if (vm.dashboard && vm.dashboard.configuration.settings && angular.isDefined(vm.dashboard.configuration.settings.showEntitiesSelect)) {
	            return vm.dashboard.configuration.settings.showEntitiesSelect;
	        } else {
	            return true;
	        }
	    }
	
	    function hideFullscreenButton() {
	        return vm.widgetEditMode || vm.iframeMode || $rootScope.forceFullscreen || $state.current.name === 'dashboard';
	    }
	
	    function onRevertWidgetEdit(widgetForm) {
	        if (widgetForm.$dirty) {
	            widgetForm.$setPristine();
	            vm.editingWidget = angular.copy(vm.editingWidgetOriginal);
	            vm.editingWidgetLayout = angular.copy(vm.editingWidgetLayoutOriginal);
	        }
	    }
	
	    function saveWidget(widgetForm) {
	        widgetForm.$setPristine();
	        var widget = angular.copy(vm.editingWidget);
	        var widgetLayout = angular.copy(vm.editingWidgetLayout);
	        var id = vm.editingWidgetOriginal.id;
	        var index = vm.editingLayoutCtx.widgets.indexOf(vm.editingWidgetOriginal);
	        vm.dashboardConfiguration.widgets[id] = widget;
	        vm.editingWidgetOriginal = widget;
	        vm.editingWidgetLayoutOriginal = widgetLayout;
	        vm.editingLayoutCtx.widgets[index] = widget;
	        vm.editingLayoutCtx.widgetLayouts[widget.id] = widgetLayout;
	        vm.editingLayoutCtx.ctrl.highlightWidget(vm.editingWidgetOriginal, 0);
	    }
	
	    function onEditWidgetClosed() {
	        vm.editingWidgetOriginal = null;
	        vm.editingWidget = null;
	        vm.editingWidgetLayoutOriginal = null;
	        vm.editingWidgetLayout = null;
	        vm.editingLayoutCtx = null;
	        vm.editingWidgetSubtitle = null;
	        vm.isEditingWidget = false;
	        resetHighlight();
	        vm.forceDashboardMobileMode = false;
	    }
	
	    function addWidget(event, layoutCtx) {
	        loadWidgetLibrary();
	        vm.isAddingWidget = true;
	        vm.addingLayoutCtx = layoutCtx;
	    }
	
	    function onAddWidgetClosed() {
	        vm.timeseriesWidgetTypes = [];
	        vm.latestWidgetTypes = [];
	        vm.rpcWidgetTypes = [];
	        vm.alarmWidgetTypes = [];
	        vm.staticWidgetTypes = [];
	    }
	
	    function selectTargetLayout($event) {
	        var deferred = $q.defer();
	        var layouts = vm.dashboardConfiguration.states[vm.dashboardCtx.state].layouts;
	        var layoutIds = Object.keys(layouts);
	        if (layoutIds.length > 1) {
	            $mdDialog.show({
	                controller: 'SelectTargetLayoutController',
	                controllerAs: 'vm',
	                templateUrl: _selectTargetLayoutTpl2.default,
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                skipHide: true,
	                targetEvent: $event
	            }).then(function success(layoutId) {
	                deferred.resolve(layoutId);
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            deferred.resolve(layoutIds[0]);
	        }
	        return deferred.promise;
	    }
	
	    function addWidgetFromType(event, widget) {
	        vm.onAddWidgetClosed();
	        vm.isAddingWidget = false;
	        widgetService.getWidgetInfo(widget.bundleAlias, widget.typeAlias, widget.isSystemType).then(function (widgetTypeInfo) {
	            var config = angular.fromJson(widgetTypeInfo.defaultConfig);
	            config.title = 'New ' + widgetTypeInfo.widgetName;
	            config.datasources = [];
	            var newWidget = {
	                isSystemType: widget.isSystemType,
	                bundleAlias: widget.bundleAlias,
	                typeAlias: widgetTypeInfo.alias,
	                type: widgetTypeInfo.type,
	                title: 'New widget',
	                sizeX: widgetTypeInfo.sizeX,
	                sizeY: widgetTypeInfo.sizeY,
	                config: config
	            };
	
	            function addWidgetToLayout(widget, layoutId) {
	                dashboardUtils.addWidgetToLayout(vm.dashboard, vm.dashboardCtx.state, layoutId, widget);
	                vm.layouts[layoutId].layoutCtx.widgets.push(widget);
	            }
	
	            function addWidget(widget) {
	                if (vm.addingLayoutCtx) {
	                    addWidgetToLayout(widget, vm.addingLayoutCtx.id);
	                    vm.addingLayoutCtx = null;
	                } else {
	                    selectTargetLayout(event).then(function success(layoutId) {
	                        addWidgetToLayout(widget, layoutId);
	                    });
	                }
	            }
	
	            if (widgetTypeInfo.typeParameters.useCustomDatasources) {
	                addWidget(newWidget);
	            } else {
	                $mdDialog.show({
	                    controller: 'AddWidgetController',
	                    controllerAs: 'vm',
	                    templateUrl: _addWidgetTpl2.default,
	                    locals: {
	                        dashboard: vm.dashboard,
	                        aliasController: vm.dashboardCtx.aliasController,
	                        widget: newWidget,
	                        widgetInfo: widgetTypeInfo
	                    },
	                    parent: angular.element($document[0].body),
	                    fullscreen: true,
	                    skipHide: true,
	                    targetEvent: event,
	                    onComplete: function onComplete() {
	                        var w = angular.element($window);
	                        w.triggerHandler('resize');
	                    }
	                }).then(function (result) {
	                    var widget = result.widget;
	                    addWidget(widget);
	                }, function () {});
	            }
	        });
	    }
	
	    function removeWidget(event, layoutCtx, widget) {
	        var title = widget.config.title;
	        if (!title || title.length === 0) {
	            title = widgetService.getInstantWidgetInfo(widget).widgetName;
	        }
	        var confirm = $mdDialog.confirm().targetEvent(event).title($translate.instant('widget.remove-widget-title', { widgetTitle: title })).htmlContent($translate.instant('widget.remove-widget-text')).ariaLabel($translate.instant('widget.remove')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            var index = layoutCtx.widgets.indexOf(widget);
	            if (index > -1) {
	                layoutCtx.widgets.splice(index, 1);
	                dashboardUtils.removeWidgetFromLayout(vm.dashboard, vm.dashboardCtx.state, layoutCtx.id, widget.id);
	            }
	        });
	    }
	
	    function _pasteWidget(event, layoutCtx, pos) {
	        itembuffer.pasteWidget(vm.dashboard, vm.dashboardCtx.state, layoutCtx.id, pos, entityAliasesUpdated).then(function (widget) {
	            if (widget) {
	                layoutCtx.widgets.push(widget);
	            }
	        });
	    }
	
	    function _pasteWidgetReference(event, layoutCtx, pos) {
	        itembuffer.pasteWidgetReference(vm.dashboard, vm.dashboardCtx.state, layoutCtx.id, pos).then(function (widget) {
	            if (widget) {
	                layoutCtx.widgets.push(widget);
	            }
	        });
	    }
	
	    function setEditMode(isEdit, revert) {
	        vm.isEdit = isEdit;
	        if (vm.isEdit) {
	            vm.dashboardCtx.stateController.preserveState();
	            vm.prevDashboard = angular.copy(vm.dashboard);
	        } else {
	            if (vm.widgetEditMode) {
	                if (revert) {
	                    vm.dashboard = vm.prevDashboard;
	                }
	            } else {
	                resetHighlight();
	                if (revert) {
	                    vm.dashboard = vm.prevDashboard;
	                    vm.dashboardConfiguration = vm.dashboard.configuration;
	                    vm.dashboardCtx.dashboardTimewindow = vm.dashboardConfiguration.timewindow;
	                    entityAliasesUpdated();
	                } else {
	                    vm.dashboard.configuration.timewindow = vm.dashboardCtx.dashboardTimewindow;
	                }
	            }
	        }
	    }
	
	    function resetHighlight() {
	        for (var l in vm.layouts) {
	            if (vm.layouts[l].layoutCtx) {
	                if (vm.layouts[l].layoutCtx.ctrl) {
	                    vm.layouts[l].layoutCtx.ctrl.resetHighlight();
	                }
	            }
	        }
	    }
	
	    function toggleDashboardEditMode() {
	        setEditMode(!vm.isEdit, true);
	    }
	
	    function saveDashboard() {
	        setEditMode(false, false);
	        notifyDashboardUpdated();
	    }
	
	    /*    function showAliasesResolutionError(error) {
	            var alert = $mdDialog.alert()
	                .parent(angular.element($document[0].body))
	                .clickOutsideToClose(true)
	                .title($translate.instant('dashboard.alias-resolution-error-title'))
	                .htmlContent($translate.instant(error))
	                .ariaLabel($translate.instant('dashboard.alias-resolution-error-title'))
	                .ok($translate.instant('action.close'))
	            alert._options.skipHide = true;
	            alert._options.fullscreen = true;
	    
	            $mdDialog.show(alert);
	        }*/
	
	    function entityAliasesUpdated() {
	        vm.dashboardCtx.aliasController.updateEntityAliases(vm.dashboard.configuration.entityAliases);
	    }
	
	    function notifyDashboardUpdated() {
	        if (vm.widgetEditMode) {
	            var parentScope = $window.parent.angular.element($window.frameElement).scope();
	            var widget = vm.layouts.main.layoutCtx.widgets[0];
	            var layout = vm.layouts.main.layoutCtx.widgetLayouts[widget.id];
	            widget.sizeX = layout.sizeX;
	            widget.sizeY = layout.sizeY;
	            parentScope.$root.$broadcast('widgetEditUpdated', widget);
	            parentScope.$root.$apply();
	        } else {
	            dashboardService.saveDashboard(vm.dashboard);
	        }
	    }
	}
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DashboardDirective.$inject = ["$compile", "$templateCache", "$translate", "types", "toast", "dashboardService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DashboardDirective;
	
	var _dashboardFieldsetTpl = __webpack_require__(1431);
	
	var _dashboardFieldsetTpl2 = _interopRequireDefault(_dashboardFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function DashboardDirective($compile, $templateCache, $translate, types, toast, dashboardService) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_dashboardFieldsetTpl2.default);
	        element.html(template);
	        scope.publicLink = null;
	        scope.$watch('dashboard', function (newVal) {
	            if (newVal) {
	                if (scope.dashboard.publicCustomerId) {
	                    scope.publicLink = dashboardService.getPublicDashboardLink(scope.dashboard);
	                } else {
	                    scope.publicLink = null;
	                }
	            }
	        });
	
	        scope.onPublicLinkCopied = function () {
	            toast.showSuccess($translate.instant('dashboard.public-link-copied-message'), 750, angular.element(element).parent().parent(), 'bottom left');
	        };
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            dashboard: '=',
	            isEdit: '=',
	            customerId: '=',
	            dashboardScope: '=',
	            theForm: '=',
	            onMakePublic: '&',
	            onMakePrivate: '&',
	            onManageAssignedCustomers: '&',
	            onUnassignFromCustomer: '&',
	            onExportDashboard: '&',
	            onDeleteDashboard: '&'
	        }
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DashboardRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DashboardRoutes;
	
	var _dashboardsTpl = __webpack_require__(1433);
	
	var _dashboardsTpl2 = _interopRequireDefault(_dashboardsTpl);
	
	var _dashboardTpl = __webpack_require__(520);
	
	var _dashboardTpl2 = _interopRequireDefault(_dashboardTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function DashboardRoutes($stateProvider) {
	    $stateProvider.state('home.dashboards', {
	        url: '/dashboards',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "content@home": {
	                templateUrl: _dashboardsTpl2.default,
	                controller: 'DashboardsController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            dashboardsType: 'tenant',
	            searchEnabled: true,
	            pageTitle: 'dashboard.dashboards'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "dashboard", "label": "dashboard.dashboards"}'
	        }
	    }).state('home.customers.dashboards', {
	        url: '/:customerId/dashboards',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _dashboardsTpl2.default,
	                controllerAs: 'vm',
	                controller: 'DashboardsController'
	            }
	        },
	        data: {
	            dashboardsType: 'customer',
	            searchEnabled: true,
	            pageTitle: 'customer.dashboards'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "dashboard", "label": "{{ vm.customerDashboardsTitle }}", "translate": "false"}'
	        }
	    }).state('home.dashboards.dashboard', {
	        url: '/:dashboardId?state',
	        reloadOnSearch: false,
	        module: 'private',
	        auth: ['TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "content@home": {
	                templateUrl: _dashboardTpl2.default,
	                controller: 'DashboardController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            widgetEditMode: false,
	            searchEnabled: false,
	            pageTitle: 'dashboard.dashboard'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "dashboard", "label": "{{ vm.dashboard.title }}", "translate": "false"}'
	        }
	    }).state('dashboard', {
	        url: '/dashboard/:dashboardId?state',
	        reloadOnSearch: false,
	        module: 'private',
	        auth: ['TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "@": {
	                templateUrl: _dashboardTpl2.default,
	                controller: 'DashboardController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            widgetEditMode: false,
	            searchEnabled: false,
	            pageTitle: 'dashboard.dashboard'
	        }
	    }).state('home.customers.dashboards.dashboard', {
	        url: '/:dashboardId?state',
	        reloadOnSearch: false,
	        module: 'private',
	        auth: ['TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "content@home": {
	                templateUrl: _dashboardTpl2.default,
	                controller: 'DashboardController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            searchEnabled: false,
	            pageTitle: 'customer.dashboard'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "dashboard", "label": "customer.dashboard"}'
	        }
	    });
	}

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	MakeDashboardPublicDialogController.$inject = ["$mdDialog", "$translate", "toast", "dashboardService", "dashboard"];
	DashboardCardController.$inject = ["types"];
	DashboardsController.$inject = ["userService", "dashboardService", "customerService", "importExport", "types", "$state", "$stateParams", "$mdDialog", "$document", "$q", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MakeDashboardPublicDialogController = MakeDashboardPublicDialogController;
	exports.DashboardCardController = DashboardCardController;
	exports.DashboardsController = DashboardsController;
	
	var _addDashboardTpl = __webpack_require__(1427);
	
	var _addDashboardTpl2 = _interopRequireDefault(_addDashboardTpl);
	
	var _dashboardCardTpl = __webpack_require__(1430);
	
	var _dashboardCardTpl2 = _interopRequireDefault(_dashboardCardTpl);
	
	var _addDashboardsToCustomerTpl = __webpack_require__(1428);
	
	var _addDashboardsToCustomerTpl2 = _interopRequireDefault(_addDashboardsToCustomerTpl);
	
	var _makeDashboardPublicDialogTpl = __webpack_require__(1437);
	
	var _makeDashboardPublicDialogTpl2 = _interopRequireDefault(_makeDashboardPublicDialogTpl);
	
	var _manageAssignedCustomersTpl = __webpack_require__(1438);
	
	var _manageAssignedCustomersTpl2 = _interopRequireDefault(_manageAssignedCustomersTpl);
	
	__webpack_require__(779);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function MakeDashboardPublicDialogController($mdDialog, $translate, toast, dashboardService, dashboard) {
	
	    var vm = this;
	
	    vm.dashboard = dashboard;
	    vm.publicLink = dashboardService.getPublicDashboardLink(dashboard);
	
	    vm.onPublicLinkCopied = onPublicLinkCopied;
	    vm.close = close;
	
	    function onPublicLinkCopied() {
	        toast.showSuccess($translate.instant('dashboard.public-link-copied-message'), 750, angular.element('#make-dialog-public-content'), 'bottom left');
	    }
	
	    function close() {
	        $mdDialog.hide();
	    }
	}
	
	/*@ngInject*/
	
	
	/* eslint-enable import/no-unresolved, import/default */
	
	function DashboardCardController(types) {
	
	    var vm = this;
	    vm.types = types;
	}
	
	/*@ngInject*/
	function DashboardsController(userService, dashboardService, customerService, importExport, types, $state, $stateParams, $mdDialog, $document, $q, $translate) {
	
	    var customerId = $stateParams.customerId;
	
	    var dashboardActionsList = [{
	        onAction: function onAction($event, item) {
	            vm.grid.openItem($event, item);
	        },
	        name: function name() {
	            return $translate.instant('dashboard.details');
	        },
	        details: function details() {
	            return $translate.instant('dashboard.dashboard-details');
	        },
	        icon: "edit"
	    }];
	
	    var dashboardGroupActionsList = [];
	
	    var vm = this;
	    vm.types = types;
	
	    vm.dashboardGridConfig = {
	        deleteItemTitleFunc: deleteDashboardTitle,
	        deleteItemContentFunc: deleteDashboardText,
	        deleteItemsTitleFunc: deleteDashboardsTitle,
	        deleteItemsActionTitleFunc: deleteDashboardsActionTitle,
	        deleteItemsContentFunc: deleteDashboardsText,
	
	        loadItemDetailsFunc: loadDashboard,
	
	        saveItemFunc: saveDashboard,
	
	        clickItemFunc: openDashboard,
	
	        getItemTitleFunc: getDashboardTitle,
	        itemCardController: 'DashboardCardController',
	        itemCardTemplateUrl: _dashboardCardTpl2.default,
	        parentCtl: vm,
	
	        actionsList: dashboardActionsList,
	        groupActionsList: dashboardGroupActionsList,
	
	        onGridInited: gridInited,
	
	        addItemTemplateUrl: _addDashboardTpl2.default,
	
	        addItemText: function addItemText() {
	            return $translate.instant('dashboard.add-dashboard-text');
	        },
	        noItemsText: function noItemsText() {
	            return $translate.instant('dashboard.no-dashboards-text');
	        },
	        itemDetailsText: function itemDetailsText() {
	            return $translate.instant('dashboard.dashboard-details');
	        },
	        isDetailsReadOnly: function isDetailsReadOnly() {
	            return vm.dashboardsScope === 'customer_user';
	        },
	        isSelectionEnabled: function isSelectionEnabled() {
	            return !(vm.dashboardsScope === 'customer_user');
	        }
	    };
	
	    if (angular.isDefined($stateParams.items) && $stateParams.items !== null) {
	        vm.dashboardGridConfig.items = $stateParams.items;
	    }
	
	    if (angular.isDefined($stateParams.topIndex) && $stateParams.topIndex > 0) {
	        vm.dashboardGridConfig.topIndex = $stateParams.topIndex;
	    }
	
	    vm.dashboardsScope = $state.$current.data.dashboardsType;
	
	    vm.makePublic = makePublic;
	    vm.makePrivate = makePrivate;
	    vm.manageAssignedCustomers = manageAssignedCustomers;
	    vm.unassignFromCustomer = unassignFromCustomer;
	    vm.exportDashboard = exportDashboard;
	
	    initController();
	
	    function initController() {
	        var fetchDashboardsFunction = null;
	        var deleteDashboardFunction = null;
	        var refreshDashboardsParamsFunction = null;
	
	        var user = userService.getCurrentUser();
	
	        if (user.authority === 'CUSTOMER_USER') {
	            vm.dashboardsScope = 'customer_user';
	            customerId = user.customerId;
	        }
	
	        if (customerId) {
	            vm.customerId = customerId;
	            vm.customerDashboardsTitle = $translate.instant('customer.dashboards');
	            customerService.getShortCustomerInfo(customerId).then(function success(info) {
	                if (info.isPublic) {
	                    vm.customerDashboardsTitle = $translate.instant('customer.public-dashboards');
	                }
	            });
	        }
	
	        if (vm.dashboardsScope === 'tenant') {
	            fetchDashboardsFunction = function fetchDashboardsFunction(pageLink) {
	                return dashboardService.getTenantDashboards(pageLink);
	            };
	            deleteDashboardFunction = function deleteDashboardFunction(dashboardId) {
	                return dashboardService.deleteDashboard(dashboardId);
	            };
	            refreshDashboardsParamsFunction = function refreshDashboardsParamsFunction() {
	                return { "topIndex": vm.topIndex };
	            };
	
	            dashboardActionsList.push({
	                onAction: function onAction($event, item) {
	                    exportDashboard($event, item);
	                },
	                name: function name() {
	                    $translate.instant('action.export');
	                },
	                details: function details() {
	                    return $translate.instant('dashboard.export');
	                },
	                icon: "file_download"
	            });
	
	            dashboardActionsList.push({
	                onAction: function onAction($event, item) {
	                    makePublic($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('action.share');
	                },
	                details: function details() {
	                    return $translate.instant('dashboard.make-public');
	                },
	                icon: "share",
	                isEnabled: function isEnabled(dashboard) {
	                    return dashboard && !dashboard.publicCustomerId;
	                }
	            });
	            dashboardActionsList.push({
	                onAction: function onAction($event, item) {
	                    makePrivate($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('action.make-private');
	                },
	                details: function details() {
	                    return $translate.instant('dashboard.make-private');
	                },
	                icon: "reply",
	                isEnabled: function isEnabled(dashboard) {
	                    return dashboard && dashboard.publicCustomerId;
	                }
	            });
	            dashboardActionsList.push({
	                onAction: function onAction($event, item) {
	                    manageAssignedCustomers($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('action.assign');
	                },
	                details: function details() {
	                    return $translate.instant('dashboard.manage-assigned-customers');
	                },
	                icon: "assignment_ind",
	                isEnabled: function isEnabled(dashboard) {
	                    return dashboard;
	                }
	            });
	
	            /*dashboardActionsList.push({
	                    onAction: function ($event, item) {
	                        assignToCustomer($event, [ item.id.id ]);
	                    },
	                    name: function() { return $translate.instant('action.assign') },
	                    details: function() { return $translate.instant('dashboard.assign-to-customer') },
	                    icon: "assignment_ind",
	                    isEnabled: function(dashboard) {
	                        return dashboard && (!dashboard.customerId || dashboard.customerId.id === types.id.nullUid);
	                    }
	                });*/
	            /*dashboardActionsList.push({
	                    onAction: function ($event, item) {
	                        unassignFromCustomer($event, item, false);
	                    },
	                    name: function() { return $translate.instant('action.unassign') },
	                    details: function() { return $translate.instant('dashboard.unassign-from-customer') },
	                    icon: "assignment_return",
	                    isEnabled: function(dashboard) {
	                        return dashboard && dashboard.customerId && dashboard.customerId.id !== types.id.nullUid && !dashboard.assignedCustomer.isPublic;
	                    }
	                });*/
	
	            dashboardActionsList.push({
	                onAction: function onAction($event, item) {
	                    vm.grid.deleteItem($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('action.delete');
	                },
	                details: function details() {
	                    return $translate.instant('dashboard.delete');
	                },
	                icon: "delete"
	            });
	
	            dashboardGroupActionsList.push({
	                onAction: function onAction($event, items) {
	                    assignDashboardsToCustomers($event, items);
	                },
	                name: function name() {
	                    return $translate.instant('dashboard.assign-dashboards');
	                },
	                details: function details(selectedCount) {
	                    return $translate.instant('dashboard.assign-dashboards-text', { count: selectedCount }, "messageformat");
	                },
	                icon: "assignment_ind"
	            });
	            dashboardGroupActionsList.push({
	                onAction: function onAction($event, items) {
	                    unassignDashboardsFromCustomers($event, items);
	                },
	                name: function name() {
	                    return $translate.instant('dashboard.unassign-dashboards');
	                },
	                details: function details(selectedCount) {
	                    return $translate.instant('dashboard.unassign-dashboards-action-text', { count: selectedCount }, "messageformat");
	                },
	                icon: "assignment_return" });
	
	            dashboardGroupActionsList.push({
	                onAction: function onAction($event) {
	                    vm.grid.deleteItems($event);
	                },
	                name: function name() {
	                    return $translate.instant('dashboard.delete-dashboards');
	                },
	                details: deleteDashboardsActionTitle,
	                icon: "delete"
	            });
	
	            vm.dashboardGridConfig.addItemActions = [];
	            vm.dashboardGridConfig.addItemActions.push({
	                onAction: function onAction($event) {
	                    vm.grid.addItem($event);
	                },
	                name: function name() {
	                    return $translate.instant('action.create');
	                },
	                details: function details() {
	                    return $translate.instant('dashboard.create-new-dashboard');
	                },
	                icon: "insert_drive_file"
	            });
	            vm.dashboardGridConfig.addItemActions.push({
	                onAction: function onAction($event) {
	                    importExport.importDashboard($event).then(function () {
	                        vm.grid.refreshList();
	                    });
	                },
	                name: function name() {
	                    return $translate.instant('action.import');
	                },
	                details: function details() {
	                    return $translate.instant('dashboard.import');
	                },
	                icon: "file_upload"
	            });
	        } else if (vm.dashboardsScope === 'customer' || vm.dashboardsScope === 'customer_user') {
	            fetchDashboardsFunction = function fetchDashboardsFunction(pageLink) {
	                return dashboardService.getCustomerDashboards(customerId, pageLink);
	            };
	            deleteDashboardFunction = function deleteDashboardFunction(dashboardId) {
	                return dashboardService.unassignDashboardFromCustomer(customerId, dashboardId);
	            };
	            refreshDashboardsParamsFunction = function refreshDashboardsParamsFunction() {
	                return { "customerId": customerId, "topIndex": vm.topIndex };
	            };
	
	            if (vm.dashboardsScope === 'customer') {
	                dashboardActionsList.push({
	                    onAction: function onAction($event, item) {
	                        exportDashboard($event, item);
	                    },
	                    name: function name() {
	                        $translate.instant('action.export');
	                    },
	                    details: function details() {
	                        return $translate.instant('dashboard.export');
	                    },
	                    icon: "file_download"
	                });
	
	                dashboardActionsList.push({
	                    onAction: function onAction($event, item) {
	                        makePrivate($event, item);
	                    },
	                    name: function name() {
	                        return $translate.instant('action.make-private');
	                    },
	                    details: function details() {
	                        return $translate.instant('dashboard.make-private');
	                    },
	                    icon: "reply",
	                    isEnabled: function isEnabled(dashboard) {
	                        return dashboard && customerId == dashboard.publicCustomerId;
	                    }
	                });
	
	                dashboardActionsList.push({
	                    onAction: function onAction($event, item) {
	                        unassignFromCustomer($event, item, customerId);
	                    },
	                    name: function name() {
	                        return $translate.instant('action.unassign');
	                    },
	                    details: function details() {
	                        return $translate.instant('dashboard.unassign-from-customer');
	                    },
	                    icon: "assignment_return",
	                    isEnabled: function isEnabled(dashboard) {
	                        return dashboard && customerId != dashboard.publicCustomerId;
	                    }
	                });
	
	                dashboardGroupActionsList.push({
	                    onAction: function onAction($event, items) {
	                        unassignDashboardsFromCustomer($event, items, customerId);
	                    },
	                    name: function name() {
	                        return $translate.instant('dashboard.unassign-dashboards');
	                    },
	                    details: function details(selectedCount) {
	                        return $translate.instant('dashboard.unassign-dashboards-action-title', { count: selectedCount }, "messageformat");
	                    },
	                    icon: "assignment_return"
	                });
	
	                vm.dashboardGridConfig.addItemAction = {
	                    onAction: function onAction($event) {
	                        addDashboardsToCustomer($event);
	                    },
	                    name: function name() {
	                        return $translate.instant('dashboard.assign-dashboards');
	                    },
	                    details: function details() {
	                        return $translate.instant('dashboard.assign-new-dashboard');
	                    },
	                    icon: "add"
	                };
	            } else if (vm.dashboardsScope === 'customer_user') {
	                vm.dashboardGridConfig.addItemAction = {};
	            }
	        }
	
	        vm.dashboardGridConfig.refreshParamsFunc = refreshDashboardsParamsFunction;
	        vm.dashboardGridConfig.fetchItemsFunc = fetchDashboardsFunction;
	        vm.dashboardGridConfig.deleteItemFunc = deleteDashboardFunction;
	    }
	
	    function deleteDashboardTitle(dashboard) {
	        return $translate.instant('dashboard.delete-dashboard-title', { dashboardTitle: dashboard.title });
	    }
	
	    function deleteDashboardText() {
	        return $translate.instant('dashboard.delete-dashboard-text');
	    }
	
	    function deleteDashboardsTitle(selectedCount) {
	        return $translate.instant('dashboard.delete-dashboards-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteDashboardsActionTitle(selectedCount) {
	        return $translate.instant('dashboard.delete-dashboards-action-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteDashboardsText() {
	        return $translate.instant('dashboard.delete-dashboards-text');
	    }
	
	    function gridInited(grid) {
	        vm.grid = grid;
	    }
	
	    function getDashboardTitle(dashboard) {
	        return dashboard ? dashboard.title : '';
	    }
	
	    function loadDashboard(dashboard) {
	        return dashboardService.getDashboard(dashboard.id.id);
	    }
	
	    function saveDashboard(dashboard) {
	        var deferred = $q.defer();
	        dashboardService.saveDashboard(dashboard).then(function success(savedDashboard) {
	            var dashboards = [savedDashboard];
	            customerService.applyAssignedCustomersInfo(dashboards).then(function success(items) {
	                if (items && items.length == 1) {
	                    deferred.resolve(items[0]);
	                } else {
	                    deferred.reject();
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function manageAssignedCustomers($event, dashboard) {
	        showManageAssignedCustomersDialog($event, [dashboard.id.id], 'manage', dashboard.assignedCustomersIds);
	    }
	
	    function assignDashboardsToCustomers($event, items) {
	        var dashboardIds = [];
	        for (var id in items.selections) {
	            dashboardIds.push(id);
	        }
	        showManageAssignedCustomersDialog($event, dashboardIds, 'assign');
	    }
	
	    function unassignDashboardsFromCustomers($event, items) {
	        var dashboardIds = [];
	        for (var id in items.selections) {
	            dashboardIds.push(id);
	        }
	        showManageAssignedCustomersDialog($event, dashboardIds, 'unassign');
	    }
	
	    function showManageAssignedCustomersDialog($event, dashboardIds, actionType, assignedCustomers) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        $mdDialog.show({
	            controller: 'ManageAssignedCustomersController',
	            controllerAs: 'vm',
	            templateUrl: _manageAssignedCustomersTpl2.default,
	            locals: { actionType: actionType, dashboardIds: dashboardIds, assignedCustomers: assignedCustomers },
	            parent: angular.element($document[0].body),
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function () {
	            vm.grid.refreshList();
	        }, function () {});
	    }
	
	    function addDashboardsToCustomer($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var pageSize = 10;
	        dashboardService.getTenantDashboards({ limit: pageSize, textSearch: '' }).then(function success(_dashboards) {
	            var dashboards = {
	                pageSize: pageSize,
	                data: _dashboards.data,
	                nextPageLink: _dashboards.nextPageLink,
	                selections: {},
	                selectedCount: 0,
	                hasNext: _dashboards.hasNext,
	                pending: false
	            };
	            if (dashboards.hasNext) {
	                dashboards.nextPageLink.limit = pageSize;
	            }
	            $mdDialog.show({
	                controller: 'AddDashboardsToCustomerController',
	                controllerAs: 'vm',
	                templateUrl: _addDashboardsToCustomerTpl2.default,
	                locals: { customerId: customerId, dashboards: dashboards },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: $event
	            }).then(function () {
	                vm.grid.refreshList();
	            }, function () {});
	        }, function fail() {});
	    }
	
	    function unassignFromCustomer($event, dashboard, customerId) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var title = $translate.instant('dashboard.unassign-dashboard-title', { dashboardTitle: dashboard.title });
	        var content = $translate.instant('dashboard.unassign-dashboard-text');
	        var label = $translate.instant('dashboard.unassign-dashboard');
	        var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(label).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            dashboardService.unassignDashboardFromCustomer(customerId, dashboard.id.id).then(function success() {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function makePublic($event, dashboard) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        dashboardService.makeDashboardPublic(dashboard.id.id).then(function success(dashboard) {
	            $mdDialog.show({
	                controller: 'MakeDashboardPublicDialogController',
	                controllerAs: 'vm',
	                templateUrl: _makeDashboardPublicDialogTpl2.default,
	                locals: { dashboard: dashboard },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: $event
	            }).then(function () {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function makePrivate($event, dashboard) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var title = $translate.instant('dashboard.make-private-dashboard-title', { dashboardTitle: dashboard.title });
	        var content = $translate.instant('dashboard.make-private-dashboard-text');
	        var label = $translate.instant('dashboard.make-private-dashboard');
	        var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(label).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            dashboardService.makeDashboardPrivate(dashboard.id.id).then(function success() {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function exportDashboard($event, dashboard) {
	        $event.stopPropagation();
	        importExport.exportDashboard(dashboard.id.id);
	    }
	
	    function unassignDashboardsFromCustomer($event, items, customerId) {
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('dashboard.unassign-dashboards-title', { count: items.selectedCount }, 'messageformat')).htmlContent($translate.instant('dashboard.unassign-dashboards-text')).ariaLabel($translate.instant('dashboard.unassign-dashboards')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            var tasks = [];
	            for (var id in items.selections) {
	                tasks.push(dashboardService.unassignDashboardFromCustomer(customerId, id));
	            }
	            $q.all(tasks).then(function () {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function openDashboard($event, dashboard) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.dashboardsScope === 'customer') {
	            $state.go('home.customers.dashboards.dashboard', {
	                customerId: customerId,
	                dashboardId: dashboard.id.id
	            });
	        } else {
	            $state.go('home.dashboards.dashboard', { dashboardId: dashboard.id.id });
	        }
	    }
	}

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EditWidgetDirective.$inject = ["$compile", "$templateCache", "types", "widgetService", "entityService", "$q", "$document", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EditWidgetDirective;
	
	var _entityAliasDialogTpl = __webpack_require__(233);
	
	var _entityAliasDialogTpl2 = _interopRequireDefault(_entityAliasDialogTpl);
	
	var _editWidgetTpl = __webpack_require__(1434);
	
	var _editWidgetTpl2 = _interopRequireDefault(_editWidgetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function EditWidgetDirective($compile, $templateCache, types, widgetService, entityService, $q, $document, $mdDialog) {
	
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_editWidgetTpl2.default);
	        element.html(template);
	
	        scope.$watch('widget', function () {
	            if (scope.widget) {
	                widgetService.getWidgetInfo(scope.widget.bundleAlias, scope.widget.typeAlias, scope.widget.isSystemType).then(function (widgetInfo) {
	                    scope.$applyAsync(function (scope) {
	                        scope.widgetConfig = {
	                            config: scope.widget.config,
	                            layout: scope.widgetLayout
	                        };
	                        var settingsSchema = widgetInfo.typeSettingsSchema || widgetInfo.settingsSchema;
	                        var dataKeySettingsSchema = widgetInfo.typeDataKeySettingsSchema || widgetInfo.dataKeySettingsSchema;
	                        scope.typeParameters = widgetInfo.typeParameters;
	                        scope.actionSources = widgetInfo.actionSources;
	                        scope.isDataEnabled = !widgetInfo.typeParameters.useCustomDatasources;
	                        if (!settingsSchema || settingsSchema === '') {
	                            scope.settingsSchema = {};
	                        } else {
	                            scope.settingsSchema = angular.fromJson(settingsSchema);
	                        }
	                        if (!dataKeySettingsSchema || dataKeySettingsSchema === '') {
	                            scope.dataKeySettingsSchema = {};
	                        } else {
	                            scope.dataKeySettingsSchema = angular.fromJson(dataKeySettingsSchema);
	                        }
	
	                        scope.functionsOnly = scope.dashboard ? false : true;
	
	                        scope.theForm.$setPristine();
	                    });
	                });
	            }
	        });
	
	        scope.$watch('widgetLayout', function () {
	            if (scope.widgetLayout && scope.widgetConfig) {
	                scope.widgetConfig.layout = scope.widgetLayout;
	            }
	        });
	
	        scope.fetchEntityKeys = function (entityAliasId, query, type) {
	            var deferred = $q.defer();
	            scope.aliasController.getAliasInfo(entityAliasId).then(function success(aliasInfo) {
	                var entity = aliasInfo.currentEntity;
	                if (entity) {
	                    entityService.getEntityKeys(entity.entityType, entity.id, query, type, { ignoreLoading: true }).then(function success(keys) {
	                        deferred.resolve(keys);
	                    }, function fail() {
	                        deferred.resolve([]);
	                    });
	                } else {
	                    deferred.resolve([]);
	                }
	            }, function fail() {
	                deferred.resolve([]);
	            });
	            return deferred.promise;
	        };
	
	        scope.fetchDashboardStates = function (query) {
	            var deferred = $q.defer();
	            var stateIds = Object.keys(scope.dashboard.configuration.states);
	            var result = query ? stateIds.filter(createFilterForDashboardState(query)) : stateIds;
	            if (result && result.length) {
	                deferred.resolve(result);
	            } else {
	                deferred.resolve([query]);
	            }
	            return deferred.promise;
	        };
	
	        function createFilterForDashboardState(query) {
	            var lowercaseQuery = angular.lowercase(query);
	            return function filterFn(stateId) {
	                return angular.lowercase(stateId).indexOf(lowercaseQuery) === 0;
	            };
	        }
	
	        scope.createEntityAlias = function (event, alias, allowedEntityTypes) {
	
	            var deferred = $q.defer();
	            var singleEntityAlias = { id: null, alias: alias, filter: {} };
	
	            $mdDialog.show({
	                controller: 'EntityAliasDialogController',
	                controllerAs: 'vm',
	                templateUrl: _entityAliasDialogTpl2.default,
	                locals: {
	                    isAdd: true,
	                    allowedEntityTypes: allowedEntityTypes,
	                    entityAliases: scope.dashboard.configuration.entityAliases,
	                    alias: singleEntityAlias
	                },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                skipHide: true,
	                targetEvent: event
	            }).then(function (singleEntityAlias) {
	                scope.dashboard.configuration.entityAliases[singleEntityAlias.id] = singleEntityAlias;
	                scope.aliasController.updateEntityAliases(scope.dashboard.configuration.entityAliases);
	                deferred.resolve(singleEntityAlias);
	            }, function () {
	                deferred.reject();
	            });
	
	            return deferred.promise;
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            dashboard: '=',
	            aliasController: '=',
	            widgetEditMode: '=',
	            widget: '=',
	            widgetLayout: '=',
	            theForm: '='
	        }
	    };
	}

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(782);
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _grid = __webpack_require__(74);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _widget = __webpack_require__(147);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _dashboard = __webpack_require__(228);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _customer = __webpack_require__(112);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _detailsSidenav = __webpack_require__(509);
	
	var _detailsSidenav2 = _interopRequireDefault(_detailsSidenav);
	
	var _widgetConfig = __webpack_require__(1205);
	
	var _widgetConfig2 = _interopRequireDefault(_widgetConfig);
	
	var _dashboardSelect = __webpack_require__(1172);
	
	var _dashboardSelect2 = _interopRequireDefault(_dashboardSelect);
	
	var _relatedEntityAutocomplete = __webpack_require__(1195);
	
	var _relatedEntityAutocomplete2 = _interopRequireDefault(_relatedEntityAutocomplete);
	
	var _dashboard3 = __webpack_require__(508);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	var _expandFullscreen = __webpack_require__(231);
	
	var _expandFullscreen2 = _interopRequireDefault(_expandFullscreen);
	
	var _widgetsBundleSelect = __webpack_require__(1208);
	
	var _widgetsBundleSelect2 = _interopRequireDefault(_widgetsBundleSelect);
	
	var _socialsharePanel = __webpack_require__(1198);
	
	var _socialsharePanel2 = _interopRequireDefault(_socialsharePanel);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _itemBuffer = __webpack_require__(1326);
	
	var _itemBuffer2 = _interopRequireDefault(_itemBuffer);
	
	var _importExport = __webpack_require__(1292);
	
	var _importExport2 = _interopRequireDefault(_importExport);
	
	var _layouts = __webpack_require__(1224);
	
	var _layouts2 = _interopRequireDefault(_layouts);
	
	var _states = __webpack_require__(1231);
	
	var _states2 = _interopRequireDefault(_states);
	
	var _dashboard5 = __webpack_require__(1219);
	
	var _dashboard6 = _interopRequireDefault(_dashboard5);
	
	var _dashboards = __webpack_require__(1220);
	
	var _dashboard7 = __webpack_require__(1217);
	
	var _dashboard8 = _interopRequireDefault(_dashboard7);
	
	var _dashboardSettings = __webpack_require__(1215);
	
	var _dashboardSettings2 = _interopRequireDefault(_dashboardSettings);
	
	var _addDashboardsToCustomer = __webpack_require__(1213);
	
	var _addDashboardsToCustomer2 = _interopRequireDefault(_addDashboardsToCustomer);
	
	var _manageAssignedCustomers = __webpack_require__(1227);
	
	var _manageAssignedCustomers2 = _interopRequireDefault(_manageAssignedCustomers);
	
	var _addWidget = __webpack_require__(1214);
	
	var _addWidget2 = _interopRequireDefault(_addWidget);
	
	var _dashboard9 = __webpack_require__(1218);
	
	var _dashboard10 = _interopRequireDefault(_dashboard9);
	
	var _editWidget = __webpack_require__(1221);
	
	var _editWidget2 = _interopRequireDefault(_editWidget);
	
	var _dashboardToolbar = __webpack_require__(1216);
	
	var _dashboardToolbar2 = _interopRequireDefault(_dashboardToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.dashboard', [_angularUiRouter2.default, _types2.default, _itemBuffer2.default, _importExport2.default, _grid2.default, _widget2.default, _user2.default, _dashboard2.default, _customer2.default, _detailsSidenav2.default, _widgetConfig2.default, _dashboardSelect2.default, _relatedEntityAutocomplete2.default, _dashboard4.default, _expandFullscreen2.default, _widgetsBundleSelect2.default, _socialsharePanel2.default, _layouts2.default, _states2.default]).config(_dashboard6.default).controller('DashboardsController', _dashboards.DashboardsController).controller('DashboardCardController', _dashboards.DashboardCardController).controller('MakeDashboardPublicDialogController', _dashboards.MakeDashboardPublicDialogController).controller('DashboardController', _dashboard8.default).controller('DashboardSettingsController', _dashboardSettings2.default).controller('AddDashboardsToCustomerController', _addDashboardsToCustomer2.default).controller('ManageAssignedCustomersController', _manageAssignedCustomers2.default).controller('AddWidgetController', _addWidget2.default).directive('tbDashboardDetails', _dashboard10.default).directive('tbEditWidget', _editWidget2.default).directive('tbDashboardToolbar', _dashboardToolbar2.default).name;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DashboardLayoutController.$inject = ["$scope", "$rootScope", "$translate", "$window", "hotkeys", "itembuffer"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DashboardLayout;
	
	var _dashboardLayoutTpl = __webpack_require__(1435);
	
	var _dashboardLayoutTpl2 = _interopRequireDefault(_dashboardLayoutTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function DashboardLayout() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            layoutCtx: '=',
	            dashboardCtx: '=',
	            isEdit: '=',
	            isMobile: '=',
	            widgetEditMode: '='
	        },
	        controller: DashboardLayoutController,
	        controllerAs: 'vm',
	        templateUrl: _dashboardLayoutTpl2.default
	    };
	}
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function DashboardLayoutController($scope, $rootScope, $translate, $window, hotkeys, itembuffer) {
	
	    var vm = this;
	
	    vm.noData = noData;
	    vm.addWidget = addWidget;
	    vm.editWidget = editWidget;
	    vm.exportWidget = exportWidget;
	    vm.widgetMouseDown = widgetMouseDown;
	    vm.widgetClicked = widgetClicked;
	    vm.prepareDashboardContextMenu = prepareDashboardContextMenu;
	    vm.prepareWidgetContextMenu = prepareWidgetContextMenu;
	    vm.removeWidget = removeWidget;
	    vm.pasteWidget = pasteWidget;
	    vm.pasteWidgetReference = pasteWidgetReference;
	    vm.dashboardInited = dashboardInited;
	    vm.dashboardInitFailed = dashboardInitFailed;
	
	    vm.reload = function () {
	        if (vm.dashboardContainer) {
	            vm.dashboardContainer.reload();
	        }
	    };
	
	    vm.setResizing = function (resizing) {
	        if (vm.dashboardContainer) {
	            vm.dashboardContainer.isResizing = resizing;
	        }
	    };
	
	    vm.resetHighlight = function () {
	        if (vm.dashboardContainer) {
	            vm.dashboardContainer.resetHighlight();
	        }
	    };
	
	    vm.highlightWidget = function (widget, delay) {
	        if (vm.dashboardContainer) {
	            vm.dashboardContainer.highlightWidget(widget, delay);
	        }
	    };
	
	    vm.selectWidget = function (widget, delay) {
	        if (vm.dashboardContainer) {
	            vm.dashboardContainer.selectWidget(widget, delay);
	        }
	    };
	
	    vm.dashboardInitComplete = false;
	
	    initHotKeys();
	
	    $scope.$on('$destroy', function () {
	        vm.dashboardContainer = null;
	    });
	
	    $scope.$watch('vm.layoutCtx', function () {
	        if (vm.layoutCtx) {
	            vm.layoutCtx.ctrl = vm;
	        }
	    });
	
	    function noData() {
	        return vm.dashboardInitComplete && vm.layoutCtx && vm.layoutCtx.widgets && vm.layoutCtx.widgets.length == 0;
	    }
	
	    function addWidget($event) {
	        if (vm.dashboardCtx.onAddWidget) {
	            vm.dashboardCtx.onAddWidget($event, vm.layoutCtx);
	        }
	    }
	
	    function editWidget($event, widget) {
	        if (vm.dashboardCtx.onEditWidget) {
	            vm.dashboardCtx.onEditWidget($event, vm.layoutCtx, widget);
	        }
	    }
	
	    function exportWidget($event, widget) {
	        if (vm.dashboardCtx.onExportWidget) {
	            vm.dashboardCtx.onExportWidget($event, vm.layoutCtx, widget);
	        }
	    }
	
	    function widgetMouseDown($event, widget) {
	        if (vm.dashboardCtx.onWidgetMouseDown) {
	            vm.dashboardCtx.onWidgetMouseDown($event, vm.layoutCtx, widget);
	        }
	    }
	
	    function widgetClicked($event, widget) {
	        if (vm.dashboardCtx.onWidgetClicked) {
	            vm.dashboardCtx.onWidgetClicked($event, vm.layoutCtx, widget);
	        }
	    }
	
	    function prepareDashboardContextMenu() {
	        if (vm.dashboardCtx.prepareDashboardContextMenu) {
	            return vm.dashboardCtx.prepareDashboardContextMenu(vm.layoutCtx);
	        }
	    }
	
	    function prepareWidgetContextMenu(widget) {
	        if (vm.dashboardCtx.prepareWidgetContextMenu) {
	            return vm.dashboardCtx.prepareWidgetContextMenu(vm.layoutCtx, widget);
	        }
	    }
	
	    function removeWidget($event, widget) {
	        if (vm.dashboardCtx.onRemoveWidget) {
	            vm.dashboardCtx.onRemoveWidget($event, vm.layoutCtx, widget);
	        }
	    }
	
	    function dashboardInitFailed() {
	        var parentScope = $window.parent.angular.element($window.frameElement).scope();
	        parentScope.$emit('widgetEditModeInited');
	        parentScope.$apply();
	        vm.dashboardInitComplete = true;
	    }
	
	    function dashboardInited(dashboardContainer) {
	        vm.dashboardContainer = dashboardContainer;
	        vm.dashboardInitComplete = true;
	    }
	
	    function isHotKeyAllowed(event) {
	        var target = event.target || event.srcElement;
	        var scope = angular.element(target).scope();
	        return scope && scope.$parent !== $rootScope;
	    }
	
	    function initHotKeys() {
	        $translate(['action.copy', 'action.paste', 'action.delete']).then(function (translations) {
	            hotkeys.bindTo($scope).add({
	                combo: 'ctrl+c',
	                description: translations['action.copy'],
	                callback: function callback(event) {
	                    if (isHotKeyAllowed(event) && vm.isEdit && !vm.isEditingWidget && !vm.widgetEditMode) {
	                        var widget = vm.dashboardContainer.getSelectedWidget();
	                        if (widget) {
	                            event.preventDefault();
	                            copyWidget(event, widget);
	                        }
	                    }
	                }
	            }).add({
	                combo: 'ctrl+r',
	                description: translations['action.copy-reference'],
	                callback: function callback(event) {
	                    if (isHotKeyAllowed(event) && vm.isEdit && !vm.isEditingWidget && !vm.widgetEditMode) {
	                        var widget = vm.dashboardContainer.getSelectedWidget();
	                        if (widget) {
	                            event.preventDefault();
	                            copyWidgetReference(event, widget);
	                        }
	                    }
	                }
	            }).add({
	                combo: 'ctrl+v',
	                description: translations['action.paste'],
	                callback: function callback(event) {
	                    if (isHotKeyAllowed(event) && vm.isEdit && !vm.isEditingWidget && !vm.widgetEditMode) {
	                        if (itembuffer.hasWidget()) {
	                            event.preventDefault();
	                            pasteWidget(event);
	                        }
	                    }
	                }
	            }).add({
	                combo: 'ctrl+i',
	                description: translations['action.paste-reference'],
	                callback: function callback(event) {
	                    if (isHotKeyAllowed(event) && vm.isEdit && !vm.isEditingWidget && !vm.widgetEditMode) {
	                        if (itembuffer.canPasteWidgetReference(vm.dashboardCtx.dashboard, vm.dashboardCtx.state, vm.layoutCtx.id)) {
	                            event.preventDefault();
	                            pasteWidgetReference(event);
	                        }
	                    }
	                }
	            }).add({
	                combo: 'ctrl+x',
	                description: translations['action.delete'],
	                callback: function callback(event) {
	                    if (isHotKeyAllowed(event) && vm.isEdit && !vm.isEditingWidget && !vm.widgetEditMode) {
	                        var widget = vm.dashboardContainer.getSelectedWidget();
	                        if (widget) {
	                            event.preventDefault();
	                            vm.dashboardCtx.onRemoveWidget(event, vm.layoutCtx, widget);
	                        }
	                    }
	                }
	            });
	        });
	    }
	
	    function copyWidget($event, widget) {
	        if (vm.dashboardCtx.copyWidget) {
	            vm.dashboardCtx.copyWidget($event, vm.layoutCtx, widget);
	        }
	    }
	
	    function copyWidgetReference($event, widget) {
	        if (vm.dashboardCtx.copyWidgetReference) {
	            vm.dashboardCtx.copyWidgetReference($event, vm.layoutCtx, widget);
	        }
	    }
	
	    function pasteWidget($event) {
	        var pos = vm.dashboardContainer.getEventGridPosition($event);
	        if (vm.dashboardCtx.pasteWidget) {
	            vm.dashboardCtx.pasteWidget($event, vm.layoutCtx, pos);
	        }
	    }
	
	    function pasteWidgetReference($event) {
	        var pos = vm.dashboardContainer.getEventGridPosition($event);
	        if (vm.dashboardCtx.pasteWidgetReference) {
	            vm.dashboardCtx.pasteWidgetReference($event, vm.layoutCtx, pos);
	        }
	    }
	}

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _manageDashboardLayouts = __webpack_require__(1225);
	
	var _manageDashboardLayouts2 = _interopRequireDefault(_manageDashboardLayouts);
	
	var _selectTargetLayout = __webpack_require__(1226);
	
	var _selectTargetLayout2 = _interopRequireDefault(_selectTargetLayout);
	
	var _dashboardLayout = __webpack_require__(1223);
	
	var _dashboardLayout2 = _interopRequireDefault(_dashboardLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.dashboard.layouts', []).controller('ManageDashboardLayoutsController', _manageDashboardLayouts2.default).controller('SelectTargetLayoutController', _selectTargetLayout2.default).directive('tbDashboardLayout', _dashboardLayout2.default).name; /*
	                                                                                                                                                                                                                                                                                                 * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                                                                 * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                 * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                 * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                                                                 *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                                                                 * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                 * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                 * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                 * limitations under the License.
	                                                                                                                                                                                                                                                                                                 */

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ManageDashboardLayoutsController.$inject = ["$scope", "$mdDialog", "$document", "dashboardUtils", "layouts"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ManageDashboardLayoutsController;
	
	var _dashboardSettingsTpl = __webpack_require__(519);
	
	var _dashboardSettingsTpl2 = _interopRequireDefault(_dashboardSettingsTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function ManageDashboardLayoutsController($scope, $mdDialog, $document, dashboardUtils, layouts) {
	
	    var vm = this;
	
	    vm.openLayoutSettings = openLayoutSettings;
	    vm.cancel = cancel;
	    vm.save = save;
	
	    vm.layouts = layouts;
	    vm.displayLayouts = {
	        main: angular.isDefined(vm.layouts.main),
	        right: angular.isDefined(vm.layouts.right)
	    };
	
	    for (var l in vm.displayLayouts) {
	        if (!vm.layouts[l]) {
	            vm.layouts[l] = dashboardUtils.createDefaultLayoutData();
	        }
	    }
	
	    function openLayoutSettings($event, layoutId) {
	        var gridSettings = angular.copy(vm.layouts[layoutId].gridSettings);
	        $mdDialog.show({
	            controller: 'DashboardSettingsController',
	            controllerAs: 'vm',
	            templateUrl: _dashboardSettingsTpl2.default,
	            locals: {
	                settings: null,
	                gridSettings: gridSettings
	            },
	            parent: angular.element($document[0].body),
	            skipHide: true,
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (data) {
	            var gridSettings = data.gridSettings;
	            if (gridSettings) {
	                dashboardUtils.updateLayoutSettings(vm.layouts[layoutId], gridSettings);
	            }
	            $scope.theForm.$setDirty();
	        }, function () {});
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function save() {
	        $scope.theForm.$setPristine();
	        for (var l in vm.displayLayouts) {
	            if (!vm.displayLayouts[l]) {
	                if (vm.layouts[l]) {
	                    delete vm.layouts[l];
	                }
	            }
	        }
	        $mdDialog.hide(vm.layouts);
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	"use strict";
	
	SelectTargetLayoutController.$inject = ["$scope", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SelectTargetLayoutController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function SelectTargetLayoutController($scope, $mdDialog) {
	
	    var vm = this;
	
	    vm.cancel = cancel;
	    vm.selectLayout = selectLayout;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function selectLayout($event, layoutId) {
	        $scope.theForm.$setPristine();
	        $mdDialog.hide(layoutId);
	    }
	}

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	'use strict';
	
	ManageAssignedCustomersController.$inject = ["$mdDialog", "$q", "types", "dashboardService", "actionType", "dashboardIds", "assignedCustomers"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ManageAssignedCustomersController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function ManageAssignedCustomersController($mdDialog, $q, types, dashboardService, actionType, dashboardIds, assignedCustomers) {
	
	    var vm = this;
	
	    vm.types = types;
	    vm.actionType = actionType;
	    vm.dashboardIds = dashboardIds;
	    vm.assignedCustomers = assignedCustomers;
	    if (actionType != 'manage') {
	        vm.assignedCustomers = [];
	    }
	
	    if (actionType == 'manage') {
	        vm.titleText = 'dashboard.manage-assigned-customers';
	        vm.labelText = 'dashboard.assigned-customers';
	        vm.actionName = 'action.update';
	    } else if (actionType == 'assign') {
	        vm.titleText = 'dashboard.assign-to-customers';
	        vm.labelText = 'dashboard.assign-to-customers-text';
	        vm.actionName = 'action.assign';
	    } else if (actionType == 'unassign') {
	        vm.titleText = 'dashboard.unassign-from-customers';
	        vm.labelText = 'dashboard.unassign-from-customers-text';
	        vm.actionName = 'action.unassign';
	    }
	
	    vm.submit = submit;
	    vm.cancel = cancel;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function submit() {
	        var tasks = [];
	        for (var i = 0; i < vm.dashboardIds.length; i++) {
	            var dashboardId = vm.dashboardIds[i];
	            var promise;
	            if (vm.actionType == 'manage') {
	                promise = dashboardService.updateDashboardCustomers(dashboardId, vm.assignedCustomers);
	            } else if (vm.actionType == 'assign') {
	                promise = dashboardService.addDashboardCustomers(dashboardId, vm.assignedCustomers);
	            } else if (vm.actionType == 'unassign') {
	                promise = dashboardService.removeDashboardCustomers(dashboardId, vm.assignedCustomers);
	            }
	            tasks.push(promise);
	        }
	        $q.all(tasks).then(function () {
	            $mdDialog.hide();
	        });
	    }
	}

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	'use strict';
	
	DashboardStateDialogController.$inject = ["$scope", "$mdDialog", "$filter", "dashboardUtils", "isAdd", "allStates", "state"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DashboardStateDialogController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function DashboardStateDialogController($scope, $mdDialog, $filter, dashboardUtils, isAdd, allStates, state) {
	
	    var vm = this;
	
	    vm.isAdd = isAdd;
	    vm.allStates = allStates;
	    vm.state = state;
	
	    vm.stateIdTouched = false;
	
	    if (vm.isAdd) {
	        vm.state = dashboardUtils.createDefaultState('', false);
	        vm.state.id = '';
	        vm.prevStateId = '';
	    } else {
	        vm.state = state;
	        vm.prevStateId = vm.state.id;
	    }
	
	    vm.cancel = cancel;
	    vm.save = save;
	
	    $scope.$watch("vm.state.name", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.state.name != null) {
	            checkStateName();
	        }
	    });
	
	    $scope.$watch("vm.state.id", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.state.id != null) {
	            checkStateId();
	        }
	    });
	
	    function checkStateName() {
	        if (!vm.stateIdTouched && vm.isAdd) {
	            vm.state.id = vm.state.name.toLowerCase().replace(/\W/g, "_");
	        }
	    }
	
	    function checkStateId() {
	        var result = $filter('filter')(vm.allStates, { id: vm.state.id }, true);
	        if (result && result.length && result[0].id !== vm.prevStateId) {
	            $scope.theForm.stateId.$setValidity('stateExists', false);
	        } else {
	            $scope.theForm.stateId.$setValidity('stateExists', true);
	        }
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function save() {
	        $scope.theForm.$setPristine();
	        vm.state.id = vm.state.id.trim();
	        $mdDialog.hide(vm.state);
	    }
	}

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DefaultStateController.$inject = ["$scope", "$timeout", "$location", "$state", "$stateParams", "utils", "types", "dashboardUtils", "preservedState"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DefaultStateController;
	
	__webpack_require__(783);
	
	/*@ngInject*/
	function DefaultStateController($scope, $timeout, $location, $state, $stateParams, utils, types, dashboardUtils, preservedState) {
	
	    var vm = this;
	
	    vm.inited = false;
	
	    vm.skipStateChange = false;
	
	    vm.openState = openState;
	    vm.updateState = updateState;
	    vm.resetState = resetState;
	    vm.getStateObject = getStateObject;
	    vm.navigatePrevState = navigatePrevState;
	    vm.getStateId = getStateId;
	    vm.getStateIndex = getStateIndex;
	    vm.getStateIdAtIndex = getStateIdAtIndex;
	    vm.getStateParams = getStateParams;
	    vm.getStateParamsByStateId = getStateParamsByStateId;
	    vm.getEntityId = getEntityId;
	
	    vm.getStateName = getStateName;
	
	    vm.displayStateSelection = displayStateSelection;
	
	    function openState(id, params, openRightLayout) {
	        if (vm.states && vm.states[id]) {
	            if (!params) {
	                params = {};
	            }
	            var newState = {
	                id: id,
	                params: params
	                //append new state
	            };vm.stateObject[0] = newState;
	            gotoState(vm.stateObject[0].id, true, openRightLayout);
	            vm.skipStateChange = true;
	        }
	    }
	
	    function updateState(id, params, openRightLayout) {
	        if (!id) {
	            id = getStateId();
	        }
	        if (vm.states && vm.states[id]) {
	            if (!params) {
	                params = {};
	            }
	            var newState = {
	                id: id,
	                params: params
	                //replace with new state
	            };vm.stateObject[0] = newState;
	            gotoState(vm.stateObject[0].id, true, openRightLayout);
	            vm.skipStateChange = true;
	        }
	    }
	
	    function resetState() {
	        var rootStateId = dashboardUtils.getRootStateId(vm.states);
	        vm.stateObject = [{ id: rootStateId, params: {} }];
	        gotoState(rootStateId, true);
	    }
	
	    function getStateObject() {
	        return vm.stateObject;
	    }
	
	    function navigatePrevState(index) {
	        if (index < vm.stateObject.length - 1) {
	            vm.stateObject.splice(index + 1, vm.stateObject.length - index - 1);
	            gotoState(vm.stateObject[vm.stateObject.length - 1].id, true);
	            vm.skipStateChange = true;
	        }
	    }
	
	    function getStateId() {
	        if (vm.stateObject && vm.stateObject.length) {
	            return vm.stateObject[vm.stateObject.length - 1].id;
	        } else {
	            return '';
	        }
	    }
	
	    function getStateIndex() {
	        if (vm.stateObject && vm.stateObject.length) {
	            return vm.stateObject.length - 1;
	        } else {
	            return -1;
	        }
	    }
	
	    function getStateIdAtIndex(index) {
	        if (vm.stateObject && vm.stateObject[index]) {
	            return vm.stateObject[index].id;
	        } else {
	            return '';
	        }
	    }
	
	    function getStateParams() {
	        if (vm.stateObject && vm.stateObject.length) {
	            return vm.stateObject[vm.stateObject.length - 1].params;
	        } else {
	            return {};
	        }
	    }
	
	    function getStateParamsByStateId(stateId) {
	        var stateObj = getStateObjById(stateId);
	        if (stateObj) {
	            return stateObj.params;
	        } else {
	            return null;
	        }
	    }
	
	    function getEntityId() {
	        return null;
	    }
	
	    function getStateObjById(id) {
	        for (var i = 0; i < vm.stateObject.length; i++) {
	            if (vm.stateObject[i].id === id) {
	                return vm.stateObject[i];
	            }
	        }
	        return null;
	    }
	
	    function getStateName(id, state) {
	        return utils.customTranslation(state.name, id);
	    }
	
	    function parseState(stateBase64) {
	        var result;
	        if (stateBase64) {
	            try {
	                result = utils.base64toObj(stateBase64);
	            } catch (e) {
	                result = [{ id: null, params: {} }];
	            }
	        }
	        if (!result) {
	            result = [];
	        }
	        if (!result.length) {
	            result[0] = { id: null, params: {} };
	        } else if (result.length > 1) {
	            var newResult = [];
	            newResult.push(result[result.length - 1]);
	            result = newResult;
	        }
	
	        var rootStateId = dashboardUtils.getRootStateId(vm.states);
	        if (!result[0].id) {
	            result[0].id = rootStateId;
	        }
	        if (!vm.states[result[0].id]) {
	            result[0].id = rootStateId;
	        }
	        var i = result.length;
	        while (i--) {
	            if (!result[i].id || !vm.states[result[i].id]) {
	                result.splice(i, 1);
	            }
	        }
	        return result;
	    }
	
	    $scope.$watch('vm.states', function () {
	        if (vm.states) {
	            if (!vm.inited) {
	                vm.inited = true;
	                init();
	            }
	        }
	    });
	
	    function displayStateSelection() {
	        return vm.states && Object.keys(vm.states).length > 1;
	    }
	
	    function init() {
	        if (preservedState) {
	            vm.stateObject = preservedState;
	            gotoState(vm.stateObject[0].id, true);
	        } else {
	            var initialState = $stateParams.state;
	            vm.stateObject = parseState(initialState);
	            gotoState(vm.stateObject[0].id, false);
	        }
	
	        $timeout(function () {
	            $scope.$watchCollection(function () {
	                return $state.params;
	            }, function () {
	                var currentState = $state.params.state;
	                vm.stateObject = parseState(currentState);
	            });
	
	            $scope.$watch('vm.dashboardCtrl.dashboardCtx.state', function () {
	                if (vm.stateObject[0].id !== vm.dashboardCtrl.dashboardCtx.state) {
	                    vm.stateObject[0].id = vm.dashboardCtrl.dashboardCtx.state;
	                    updateLocation();
	                    vm.skipStateChange = true;
	                }
	            });
	            $scope.$watch('vm.stateObject', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal) && newVal) {
	                    if (vm.skipStateChange) {
	                        vm.skipStateChange = false;
	                    } else {
	                        gotoState(vm.stateObject[0].id, true);
	                    }
	                }
	            }, true);
	        });
	    }
	
	    function gotoState(stateId, update, openRightLayout) {
	        if (vm.dashboardCtrl.dashboardCtx.state != stateId) {
	            vm.dashboardCtrl.openDashboardState(stateId, openRightLayout);
	            if (update) {
	                updateLocation();
	            }
	        }
	    }
	
	    function updateLocation() {
	        if (vm.stateObject[0].id) {
	            $location.search('state', utils.objToBase64(vm.stateObject));
	        }
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityStateController.$inject = ["$scope", "$timeout", "$location", "$state", "$stateParams", "$q", "$translate", "utils", "types", "dashboardUtils", "entityService", "preservedState"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityStateController;
	
	__webpack_require__(784);
	
	/*@ngInject*/
	function EntityStateController($scope, $timeout, $location, $state, $stateParams, $q, $translate, utils, types, dashboardUtils, entityService, preservedState) {
	
	    var vm = this;
	
	    vm.inited = false;
	
	    vm.skipStateChange = false;
	
	    vm.openState = openState;
	    vm.updateState = updateState;
	    vm.resetState = resetState;
	    vm.getStateObject = getStateObject;
	    vm.navigatePrevState = navigatePrevState;
	    vm.getStateId = getStateId;
	    vm.getStateIndex = getStateIndex;
	    vm.getStateIdAtIndex = getStateIdAtIndex;
	    vm.getStateParams = getStateParams;
	    vm.getStateParamsByStateId = getStateParamsByStateId;
	    vm.getEntityId = getEntityId;
	
	    vm.getStateName = getStateName;
	
	    vm.selectedStateIndex = -1;
	
	    function openState(id, params, openRightLayout) {
	        if (vm.states && vm.states[id]) {
	            resolveEntity(params).then(function success(entityName) {
	                params.entityName = entityName;
	                var newState = {
	                    id: id,
	                    params: params
	                    //append new state
	                };vm.stateObject.push(newState);
	                vm.selectedStateIndex = vm.stateObject.length - 1;
	                gotoState(vm.stateObject[vm.stateObject.length - 1].id, true, openRightLayout);
	                vm.skipStateChange = true;
	            });
	        }
	    }
	
	    function updateState(id, params, openRightLayout) {
	        if (!id) {
	            id = getStateId();
	        }
	        if (vm.states && vm.states[id]) {
	            resolveEntity(params).then(function success(entityName) {
	                params.entityName = entityName;
	                var newState = {
	                    id: id,
	                    params: params
	                    //replace with new state
	                };vm.stateObject[vm.stateObject.length - 1] = newState;
	                gotoState(vm.stateObject[vm.stateObject.length - 1].id, true, openRightLayout);
	                vm.skipStateChange = true;
	            });
	        }
	    }
	
	    function resetState() {
	        var rootStateId = dashboardUtils.getRootStateId(vm.states);
	        vm.stateObject = [{ id: rootStateId, params: {} }];
	        gotoState(rootStateId, true);
	    }
	
	    function getStateObject() {
	        return vm.stateObject;
	    }
	
	    function navigatePrevState(index) {
	        if (index < vm.stateObject.length - 1) {
	            vm.stateObject.splice(index + 1, vm.stateObject.length - index - 1);
	            vm.selectedStateIndex = vm.stateObject.length - 1;
	            gotoState(vm.stateObject[vm.stateObject.length - 1].id, true);
	            vm.skipStateChange = true;
	        }
	    }
	
	    function getStateId() {
	        if (vm.stateObject && vm.stateObject.length) {
	            return vm.stateObject[vm.stateObject.length - 1].id;
	        } else {
	            return '';
	        }
	    }
	
	    function getStateIndex() {
	        if (vm.stateObject && vm.stateObject.length) {
	            return vm.stateObject.length - 1;
	        } else {
	            return -1;
	        }
	    }
	
	    function getStateIdAtIndex(index) {
	        if (vm.stateObject && vm.stateObject[index]) {
	            return vm.stateObject[index].id;
	        } else {
	            return '';
	        }
	    }
	
	    function getStateParams() {
	        if (vm.stateObject && vm.stateObject.length) {
	            return vm.stateObject[vm.stateObject.length - 1].params;
	        } else {
	            return {};
	        }
	    }
	
	    function getStateParamsByStateId(stateId) {
	        var stateObj = getStateObjById(stateId);
	        if (stateObj) {
	            return stateObj.params;
	        } else {
	            return null;
	        }
	    }
	
	    function getEntityId(entityParamName) {
	        var stateParams = getStateParams();
	        if (!entityParamName || !entityParamName.length) {
	            return stateParams.entityId;
	        } else if (stateParams[entityParamName]) {
	            return stateParams[entityParamName].entityId;
	        }
	        return null;
	    }
	
	    function getStateObjById(id) {
	        for (var i = 0; i < vm.stateObject.length; i++) {
	            if (vm.stateObject[i].id === id) {
	                return vm.stateObject[i];
	            }
	        }
	        return null;
	    }
	
	    function getStateName(index) {
	        var result = '';
	        if (vm.stateObject[index]) {
	            var stateName = vm.states[vm.stateObject[index].id].name;
	            stateName = utils.customTranslation(stateName, stateName);
	            var params = vm.stateObject[index].params;
	            var entityName = params && params.entityName ? params.entityName : '';
	            result = utils.insertVariable(stateName, 'entityName', entityName);
	            for (var prop in params) {
	                if (params[prop] && params[prop].entityName) {
	                    result = utils.insertVariable(result, prop + ':entityName', params[prop].entityName);
	                }
	            }
	        }
	        return result;
	    }
	
	    function resolveEntity(params) {
	        var deferred = $q.defer();
	        if (params && params.entityId && params.entityId.id && params.entityId.entityType) {
	            if (params.entityName && params.entityName.length) {
	                deferred.resolve(params.entityName);
	            } else {
	                entityService.getEntity(params.entityId.entityType, params.entityId.id, {
	                    ignoreLoading: true,
	                    ignoreErrors: true
	                }).then(function success(entity) {
	                    var entityName = entity.name;
	                    deferred.resolve(entityName);
	                }, function fail() {
	                    deferred.reject();
	                });
	            }
	        } else {
	            deferred.resolve('');
	        }
	        return deferred.promise;
	    }
	
	    function parseState(stateBase64) {
	        var result;
	        if (stateBase64) {
	            try {
	                result = utils.base64toObj(stateBase64);
	            } catch (e) {
	                result = [{ id: null, params: {} }];
	            }
	        }
	        if (!result) {
	            result = [];
	        }
	        if (!result.length) {
	            result[0] = { id: null, params: {} };
	        }
	        var rootStateId = dashboardUtils.getRootStateId(vm.states);
	        if (!result[0].id) {
	            result[0].id = rootStateId;
	        }
	        if (!vm.states[result[0].id]) {
	            result[0].id = rootStateId;
	        }
	        var i = result.length;
	        while (i--) {
	            if (!result[i].id || !vm.states[result[i].id]) {
	                result.splice(i, 1);
	            }
	        }
	        return result;
	    }
	
	    $scope.$watch('vm.states', function () {
	        if (vm.states) {
	            if (!vm.inited) {
	                vm.inited = true;
	                init();
	            }
	        }
	    });
	
	    function init() {
	        if (preservedState) {
	            vm.stateObject = preservedState;
	            vm.selectedStateIndex = vm.stateObject.length - 1;
	            gotoState(vm.stateObject[vm.stateObject.length - 1].id, true);
	        } else {
	            var initialState = $stateParams.state;
	            vm.stateObject = parseState(initialState);
	            vm.selectedStateIndex = vm.stateObject.length - 1;
	            gotoState(vm.stateObject[vm.stateObject.length - 1].id, false);
	        }
	
	        $timeout(function () {
	            $scope.$watchCollection(function () {
	                return $state.params;
	            }, function () {
	                var currentState = $state.params.state;
	                vm.stateObject = parseState(currentState);
	            });
	
	            $scope.$watch('vm.dashboardCtrl.dashboardCtx.state', function () {
	                if (vm.stateObject[vm.stateObject.length - 1].id !== vm.dashboardCtrl.dashboardCtx.state) {
	                    vm.stateObject[vm.stateObject.length - 1].id = vm.dashboardCtrl.dashboardCtx.state;
	                    updateLocation();
	                    vm.skipStateChange = true;
	                }
	            });
	
	            $scope.$watch('vm.stateObject', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal) && newVal) {
	                    if (vm.skipStateChange) {
	                        vm.skipStateChange = false;
	                    } else {
	                        vm.selectedStateIndex = vm.stateObject.length - 1;
	                        gotoState(vm.stateObject[vm.stateObject.length - 1].id, true);
	                    }
	                }
	            }, true);
	
	            if (vm.dashboardCtrl.isMobile) {
	                watchSelectedStateIndex();
	            }
	
	            $scope.$watch('vm.dashboardCtrl.isMobile', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    if (vm.dashboardCtrl.isMobile) {
	                        watchSelectedStateIndex();
	                    } else {
	                        stopWatchSelectedStateIndex();
	                    }
	                }
	            });
	        });
	    }
	
	    function stopWatchSelectedStateIndex() {
	        if (vm.selectedStateIndexWatcher) {
	            vm.selectedStateIndexWatcher();
	            vm.selectedStateIndexWatcher = null;
	        }
	    }
	
	    function watchSelectedStateIndex() {
	        vm.selectedStateIndexWatcher = $scope.$watch('vm.selectedStateIndex', function (newVal, prevVal) {
	            if (!angular.equals(newVal, prevVal)) {
	                navigatePrevState(vm.selectedStateIndex);
	            }
	        });
	    }
	
	    function gotoState(stateId, update, openRightLayout) {
	        vm.dashboardCtrl.openDashboardState(stateId, openRightLayout);
	        if (update) {
	            updateLocation();
	        }
	    }
	
	    function updateLocation() {
	        if (vm.stateObject[vm.stateObject.length - 1].id) {
	            if (isDefaultState()) {
	                $location.search('state', null);
	            } else {
	                $location.search('state', utils.objToBase64(vm.stateObject));
	            }
	        }
	    }
	
	    function isDefaultState() {
	        if (vm.stateObject.length == 1) {
	            var state = vm.stateObject[0];
	            var rootStateId = dashboardUtils.getRootStateId(vm.states);
	            if (state.id == rootStateId && (!state.params || isEmpty(state.params))) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function isEmpty(map) {
	        for (var key in map) {
	            return !map.hasOwnProperty(key);
	        }
	        return true;
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _manageDashboardStates = __webpack_require__(1232);
	
	var _manageDashboardStates2 = _interopRequireDefault(_manageDashboardStates);
	
	var _dashboardStateDialog = __webpack_require__(1228);
	
	var _dashboardStateDialog2 = _interopRequireDefault(_dashboardStateDialog);
	
	var _selectTargetState = __webpack_require__(1233);
	
	var _selectTargetState2 = _interopRequireDefault(_selectTargetState);
	
	var _statesComponent = __webpack_require__(1234);
	
	var _statesComponent2 = _interopRequireDefault(_statesComponent);
	
	var _statesController = __webpack_require__(1235);
	
	var _statesController2 = _interopRequireDefault(_statesController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.dashboard.states', []).controller('ManageDashboardStatesController', _manageDashboardStates2.default).controller('DashboardStateDialogController', _dashboardStateDialog2.default).controller('SelectTargetStateController', _selectTargetState2.default).directive('tbStatesComponent', _statesComponent2.default).factory('statesControllerService', _statesController2.default).name; /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                        * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                        *
	                                                                                                                                                                                                                                                                                                                                                                                                                                        * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                        * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                        * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                        *
	                                                                                                                                                                                                                                                                                                                                                                                                                                        *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                        *
	                                                                                                                                                                                                                                                                                                                                                                                                                                        * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                        * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                        * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                        * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                        * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                        */

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ManageDashboardStatesController.$inject = ["$scope", "$mdDialog", "$filter", "$document", "$translate", "states"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ManageDashboardStatesController;
	
	__webpack_require__(785);
	
	var _dashboardStateDialogTpl = __webpack_require__(1439);
	
	var _dashboardStateDialogTpl2 = _interopRequireDefault(_dashboardStateDialogTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function ManageDashboardStatesController($scope, $mdDialog, $filter, $document, $translate, states) {
	
	    var vm = this;
	
	    vm.allStates = [];
	    for (var id in states) {
	        var state = states[id];
	        state.id = id;
	        vm.allStates.push(state);
	    }
	
	    vm.states = [];
	    vm.statesCount = 0;
	
	    vm.query = {
	        order: 'name',
	        limit: 5,
	        page: 1,
	        search: null
	    };
	
	    vm.enterFilterMode = enterFilterMode;
	    vm.exitFilterMode = exitFilterMode;
	    vm.onReorder = onReorder;
	    vm.onPaginate = onPaginate;
	    vm.addState = addState;
	    vm.editState = editState;
	    vm.deleteState = deleteState;
	
	    vm.cancel = cancel;
	    vm.save = save;
	
	    $scope.$watch("vm.query.search", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
	            updateStates();
	        }
	    });
	
	    updateStates();
	
	    function updateStates() {
	        var result = $filter('orderBy')(vm.allStates, vm.query.order);
	        if (vm.query.search != null) {
	            result = $filter('filter')(result, { $: vm.query.search });
	        }
	        vm.statesCount = result.length;
	        var startIndex = vm.query.limit * (vm.query.page - 1);
	        vm.states = result.slice(startIndex, startIndex + vm.query.limit);
	    }
	
	    function enterFilterMode() {
	        vm.query.search = '';
	    }
	
	    function exitFilterMode() {
	        vm.query.search = null;
	        updateStates();
	    }
	
	    function onReorder() {
	        updateStates();
	    }
	
	    function onPaginate() {
	        updateStates();
	    }
	
	    function addState($event) {
	        openStateDialog($event, null, true);
	    }
	
	    function editState($event, alertRule) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        openStateDialog($event, alertRule, false);
	    }
	
	    function openStateDialog($event, state, isAdd) {
	        var prevStateId = null;
	        if (!isAdd) {
	            prevStateId = state.id;
	        }
	        $mdDialog.show({
	            controller: 'DashboardStateDialogController',
	            controllerAs: 'vm',
	            templateUrl: _dashboardStateDialogTpl2.default,
	            parent: angular.element($document[0].body),
	            locals: { isAdd: isAdd, allStates: vm.allStates, state: angular.copy(state) },
	            skipHide: true,
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (state) {
	            saveState(state, prevStateId);
	            updateStates();
	        });
	    }
	
	    function getStateIndex(id) {
	        var result = $filter('filter')(vm.allStates, { id: id }, true);
	        if (result && result.length) {
	            return vm.allStates.indexOf(result[0]);
	        }
	        return -1;
	    }
	
	    function saveState(state, prevStateId) {
	        if (prevStateId) {
	            var index = getStateIndex(prevStateId);
	            if (index > -1) {
	                vm.allStates[index] = state;
	            }
	        } else {
	            vm.allStates.push(state);
	        }
	        if (state.root) {
	            for (var i = 0; i < vm.allStates.length; i++) {
	                var otherState = vm.allStates[i];
	                if (otherState.id !== state.id) {
	                    otherState.root = false;
	                }
	            }
	        }
	        $scope.theForm.$setDirty();
	    }
	
	    function deleteState($event, state) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (state) {
	            var title = $translate.instant('dashboard.delete-state-title');
	            var content = $translate.instant('dashboard.delete-state-text', { stateName: state.name });
	            var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(title).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	
	            confirm._options.skipHide = true;
	            confirm._options.fullscreen = true;
	
	            $mdDialog.show(confirm).then(function () {
	                var index = getStateIndex(state.id);
	                if (index > -1) {
	                    vm.allStates.splice(index, 1);
	                }
	                $scope.theForm.$setDirty();
	                updateStates();
	            });
	        }
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function save() {
	        $scope.theForm.$setPristine();
	        var savedStates = {};
	        for (var i = 0; i < vm.allStates.length; i++) {
	            var state = vm.allStates[i];
	            var id = state.id;
	            delete state.id;
	            savedStates[id] = state;
	        }
	        $mdDialog.hide(savedStates);
	    }
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

	"use strict";
	
	SelectTargetStateController.$inject = ["$scope", "$mdDialog", "dashboardUtils", "states"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SelectTargetStateController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function SelectTargetStateController($scope, $mdDialog, dashboardUtils, states) {
	
	    var vm = this;
	    vm.states = states;
	    vm.stateId = dashboardUtils.getRootStateId(vm.states);
	
	    vm.cancel = cancel;
	    vm.save = save;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function save() {
	        $scope.theForm.$setPristine();
	        $mdDialog.hide(vm.stateId);
	    }
	}

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	'use strict';
	
	StatesComponent.$inject = ["$compile", "$templateCache", "$controller", "statesControllerService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = StatesComponent;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function StatesComponent($compile, $templateCache, $controller, statesControllerService) {
	
	    var linker = function linker(scope, element) {
	
	        function destroyStateController() {
	            if (scope.statesController && angular.isFunction(scope.statesController.$onDestroy)) {
	                scope.statesController.$onDestroy();
	            }
	        }
	
	        function init() {
	
	            var stateController = scope.dashboardCtrl.dashboardCtx.stateController;
	
	            stateController.openState = function (id, params, openRightLayout) {
	                if (scope.statesController) {
	                    scope.statesController.openState(id, params, openRightLayout);
	                }
	            };
	
	            stateController.updateState = function (id, params, openRightLayout) {
	                if (scope.statesController) {
	                    scope.statesController.updateState(id, params, openRightLayout);
	                }
	            };
	
	            stateController.resetState = function () {
	                if (scope.statesController) {
	                    scope.statesController.resetState();
	                }
	            };
	
	            stateController.preserveState = function () {
	                if (scope.statesController) {
	                    var state = scope.statesController.getStateObject();
	                    statesControllerService.preserveStateControllerState(scope.statesControllerId, state);
	                }
	            };
	
	            stateController.cleanupPreservedStates = function () {
	                statesControllerService.cleanupPreservedStates();
	            };
	
	            stateController.navigatePrevState = function (index) {
	                if (scope.statesController) {
	                    scope.statesController.navigatePrevState(index);
	                }
	            };
	
	            stateController.getStateId = function () {
	                if (scope.statesController) {
	                    return scope.statesController.getStateId();
	                } else {
	                    return '';
	                }
	            };
	
	            stateController.getStateIndex = function () {
	                if (scope.statesController) {
	                    return scope.statesController.getStateIndex();
	                } else {
	                    return -1;
	                }
	            };
	
	            stateController.getStateIdAtIndex = function (index) {
	                if (scope.statesController) {
	                    return scope.statesController.getStateIdAtIndex(index);
	                } else {
	                    return '';
	                }
	            };
	
	            stateController.getStateParams = function () {
	                if (scope.statesController) {
	                    return scope.statesController.getStateParams();
	                } else {
	                    return {};
	                }
	            };
	
	            stateController.getStateParamsByStateId = function (id) {
	                if (scope.statesController) {
	                    return scope.statesController.getStateParamsByStateId(id);
	                } else {
	                    return null;
	                }
	            };
	
	            stateController.getEntityId = function (entityParamName) {
	                if (scope.statesController) {
	                    return scope.statesController.getEntityId(entityParamName);
	                } else {
	                    return null;
	                }
	            };
	        }
	
	        scope.$on('$destroy', function callOnDestroyHook() {
	            destroyStateController();
	        });
	
	        scope.$watch('scope.dashboardCtrl', function () {
	            if (scope.dashboardCtrl.dashboardCtx) {
	                init();
	            }
	        });
	
	        scope.$watch('statesControllerId', function (newValue) {
	            if (newValue) {
	                if (scope.statesController) {
	                    destroyStateController();
	                }
	                var statesControllerInfo = statesControllerService.getStateController(scope.statesControllerId);
	                if (!statesControllerInfo) {
	                    //fallback to default
	                    statesControllerInfo = statesControllerService.getStateController('default');
	                }
	                var template = $templateCache.get(statesControllerInfo.templateUrl);
	                element.html(template);
	
	                var preservedState = statesControllerService.withdrawStateControllerState(scope.statesControllerId);
	
	                var locals = {
	                    preservedState: preservedState
	                };
	                angular.extend(locals, { $scope: scope, $element: element });
	                var controller = $controller(statesControllerInfo.controller, locals, true, 'vm');
	                controller.instance = controller();
	                scope.statesController = controller.instance;
	                scope.statesController.dashboardCtrl = scope.dashboardCtrl;
	                scope.statesController.states = scope.states;
	                $compile(element.contents())(scope);
	            }
	        });
	
	        scope.$watch('states', function () {
	            if (scope.statesController) {
	                scope.statesController.states = scope.states;
	            }
	        });
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            statesControllerId: '=',
	            dashboardCtrl: '=',
	            states: '='
	        }
	    };
	}

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = StatesControllerService;
	
	var _defaultStateControllerTpl = __webpack_require__(1440);
	
	var _defaultStateControllerTpl2 = _interopRequireDefault(_defaultStateControllerTpl);
	
	var _entityStateControllerTpl = __webpack_require__(1441);
	
	var _entityStateControllerTpl2 = _interopRequireDefault(_entityStateControllerTpl);
	
	var _defaultStateController = __webpack_require__(1229);
	
	var _defaultStateController2 = _interopRequireDefault(_defaultStateController);
	
	var _entityStateController = __webpack_require__(1230);
	
	var _entityStateController2 = _interopRequireDefault(_entityStateController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function StatesControllerService() {
	
	    var statesControllers = {};
	    statesControllers['default'] = {
	        controller: _defaultStateController2.default,
	        templateUrl: _defaultStateControllerTpl2.default
	    };
	    statesControllers['entity'] = {
	        controller: _entityStateController2.default,
	        templateUrl: _entityStateControllerTpl2.default
	    };
	
	    var service = {
	        registerStatesController: registerStatesController,
	        getStateControllers: getStateControllers,
	        getStateController: getStateController,
	        preserveStateControllerState: preserveStateControllerState,
	        withdrawStateControllerState: withdrawStateControllerState,
	        cleanupPreservedStates: cleanupPreservedStates
	    };
	
	    return service;
	
	    function registerStatesController(id, stateControllerInfo) {
	        statesControllers[id] = stateControllerInfo;
	    }
	
	    function getStateControllers() {
	        return statesControllers;
	    }
	
	    function getStateController(id) {
	        return statesControllers[id];
	    }
	
	    function preserveStateControllerState(id, state) {
	        statesControllers[id].state = angular.copy(state);
	    }
	
	    function withdrawStateControllerState(id) {
	        var state = statesControllers[id].state;
	        statesControllers[id].state = null;
	        return state;
	    }
	
	    function cleanupPreservedStates() {
	        for (var id in statesControllers) {
	            statesControllers[id].state = null;
	        }
	    }
	}

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	'use strict';
	
	AddDevicesToCustomerController.$inject = ["deviceService", "$mdDialog", "$q", "customerId", "devices"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AddDevicesToCustomerController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AddDevicesToCustomerController(deviceService, $mdDialog, $q, customerId, devices) {
	
	    var vm = this;
	
	    vm.devices = devices;
	    vm.searchText = '';
	
	    vm.assign = assign;
	    vm.cancel = cancel;
	    vm.hasData = hasData;
	    vm.noData = noData;
	    vm.searchDeviceTextUpdated = searchDeviceTextUpdated;
	    vm.toggleDeviceSelection = toggleDeviceSelection;
	
	    vm.theDevices = {
	        getItemAtIndex: function getItemAtIndex(index) {
	            if (index > vm.devices.data.length) {
	                vm.theDevices.fetchMoreItems_(index);
	                return null;
	            }
	            var item = vm.devices.data[index];
	            if (item) {
	                item.indexNumber = index + 1;
	            }
	            return item;
	        },
	
	        getLength: function getLength() {
	            if (vm.devices.hasNext) {
	                return vm.devices.data.length + vm.devices.nextPageLink.limit;
	            } else {
	                return vm.devices.data.length;
	            }
	        },
	
	        fetchMoreItems_: function fetchMoreItems_() {
	            if (vm.devices.hasNext && !vm.devices.pending) {
	                vm.devices.pending = true;
	                deviceService.getTenantDevices(vm.devices.nextPageLink, false).then(function success(devices) {
	                    vm.devices.data = vm.devices.data.concat(devices.data);
	                    vm.devices.nextPageLink = devices.nextPageLink;
	                    vm.devices.hasNext = devices.hasNext;
	                    if (vm.devices.hasNext) {
	                        vm.devices.nextPageLink.limit = vm.devices.pageSize;
	                    }
	                    vm.devices.pending = false;
	                }, function fail() {
	                    vm.devices.hasNext = false;
	                    vm.devices.pending = false;
	                });
	            }
	        }
	    };
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function assign() {
	        var tasks = [];
	        for (var deviceId in vm.devices.selections) {
	            tasks.push(deviceService.assignDeviceToCustomer(customerId, deviceId));
	        }
	        $q.all(tasks).then(function () {
	            $mdDialog.hide();
	        });
	    }
	
	    function noData() {
	        return vm.devices.data.length == 0 && !vm.devices.hasNext;
	    }
	
	    function hasData() {
	        return vm.devices.data.length > 0;
	    }
	
	    function toggleDeviceSelection($event, device) {
	        $event.stopPropagation();
	        var selected = angular.isDefined(device.selected) && device.selected;
	        device.selected = !selected;
	        if (device.selected) {
	            vm.devices.selections[device.id.id] = true;
	            vm.devices.selectedCount++;
	        } else {
	            delete vm.devices.selections[device.id.id];
	            vm.devices.selectedCount--;
	        }
	    }
	
	    function searchDeviceTextUpdated() {
	        vm.devices = {
	            pageSize: vm.devices.pageSize,
	            data: [],
	            nextPageLink: {
	                limit: vm.devices.pageSize,
	                textSearch: vm.searchText
	            },
	            selections: {},
	            selectedCount: 0,
	            hasNext: true,
	            pending: false
	        };
	    }
	}

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

	'use strict';
	
	AssignDeviceToCustomerController.$inject = ["customerService", "deviceService", "$mdDialog", "$q", "deviceIds", "customers"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AssignDeviceToCustomerController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AssignDeviceToCustomerController(customerService, deviceService, $mdDialog, $q, deviceIds, customers) {
	
	    var vm = this;
	
	    vm.customers = customers;
	    vm.searchText = '';
	
	    vm.assign = assign;
	    vm.cancel = cancel;
	    vm.isCustomerSelected = isCustomerSelected;
	    vm.hasData = hasData;
	    vm.noData = noData;
	    vm.searchCustomerTextUpdated = searchCustomerTextUpdated;
	    vm.toggleCustomerSelection = toggleCustomerSelection;
	
	    vm.theCustomers = {
	        getItemAtIndex: function getItemAtIndex(index) {
	            if (index > vm.customers.data.length) {
	                vm.theCustomers.fetchMoreItems_(index);
	                return null;
	            }
	            var item = vm.customers.data[index];
	            if (item) {
	                item.indexNumber = index + 1;
	            }
	            return item;
	        },
	
	        getLength: function getLength() {
	            if (vm.customers.hasNext) {
	                return vm.customers.data.length + vm.customers.nextPageLink.limit;
	            } else {
	                return vm.customers.data.length;
	            }
	        },
	
	        fetchMoreItems_: function fetchMoreItems_() {
	            if (vm.customers.hasNext && !vm.customers.pending) {
	                vm.customers.pending = true;
	                customerService.getCustomers(vm.customers.nextPageLink).then(function success(customers) {
	                    vm.customers.data = vm.customers.data.concat(customers.data);
	                    vm.customers.nextPageLink = customers.nextPageLink;
	                    vm.customers.hasNext = customers.hasNext;
	                    if (vm.customers.hasNext) {
	                        vm.customers.nextPageLink.limit = vm.customers.pageSize;
	                    }
	                    vm.customers.pending = false;
	                }, function fail() {
	                    vm.customers.hasNext = false;
	                    vm.customers.pending = false;
	                });
	            }
	        }
	    };
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function assign() {
	        var tasks = [];
	        for (var i = 0; i < deviceIds.length; i++) {
	            tasks.push(deviceService.assignDeviceToCustomer(vm.customers.selection.id.id, deviceIds[i]));
	        }
	        $q.all(tasks).then(function () {
	            $mdDialog.hide();
	        });
	    }
	
	    function noData() {
	        return vm.customers.data.length == 0 && !vm.customers.hasNext;
	    }
	
	    function hasData() {
	        return vm.customers.data.length > 0;
	    }
	
	    function toggleCustomerSelection($event, customer) {
	        $event.stopPropagation();
	        if (vm.isCustomerSelected(customer)) {
	            vm.customers.selection = null;
	        } else {
	            vm.customers.selection = customer;
	        }
	    }
	
	    function isCustomerSelected(customer) {
	        return vm.customers.selection != null && customer && customer.id.id === vm.customers.selection.id.id;
	    }
	
	    function searchCustomerTextUpdated() {
	        vm.customers = {
	            pageSize: vm.customers.pageSize,
	            data: [],
	            nextPageLink: {
	                limit: vm.customers.pageSize,
	                textSearch: vm.searchText
	            },
	            selection: null,
	            hasNext: true,
	            pending: false
	        };
	    }
	}

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	'use strict';
	
	ManageDeviceCredentialsController.$inject = ["deviceService", "$scope", "$mdDialog", "deviceId", "isReadOnly"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ManageDeviceCredentialsController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function ManageDeviceCredentialsController(deviceService, $scope, $mdDialog, deviceId, isReadOnly) {
	
	    var vm = this;
	
	    vm.credentialsTypes = [{
	        name: 'Access token',
	        value: 'ACCESS_TOKEN'
	    }, {
	        name: 'X.509 Certificate',
	        value: 'X509_CERTIFICATE'
	    }];
	
	    vm.deviceCredentials = {};
	    vm.isReadOnly = isReadOnly;
	
	    vm.valid = valid;
	    vm.cancel = cancel;
	    vm.save = save;
	    vm.clear = clear;
	
	    loadDeviceCredentials();
	
	    function loadDeviceCredentials() {
	        deviceService.getDeviceCredentials(deviceId).then(function success(deviceCredentials) {
	            vm.deviceCredentials = deviceCredentials;
	        });
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function valid() {
	        return vm.deviceCredentials && (vm.deviceCredentials.credentialsType === 'ACCESS_TOKEN' && vm.deviceCredentials.credentialsId && vm.deviceCredentials.credentialsId.length > 0 || vm.deviceCredentials.credentialsType === 'X509_CERTIFICATE' && vm.deviceCredentials.credentialsValue && vm.deviceCredentials.credentialsValue.length > 0);
	    }
	
	    function clear() {
	        vm.deviceCredentials.credentialsId = null;
	        vm.deviceCredentials.credentialsValue = null;
	    }
	
	    function save() {
	        deviceService.saveDeviceCredentials(vm.deviceCredentials).then(function success(deviceCredentials) {
	            vm.deviceCredentials = deviceCredentials;
	            $scope.theForm.$setPristine();
	            $mdDialog.hide();
	        });
	    }
	}

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DeviceCardController.$inject = ["types"];
	DeviceController.$inject = ["$rootScope", "userService", "deviceService", "customerService", "$state", "$stateParams", "$document", "$mdDialog", "$q", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DeviceCardController = DeviceCardController;
	exports.DeviceController = DeviceController;
	
	var _addDeviceTpl = __webpack_require__(1444);
	
	var _addDeviceTpl2 = _interopRequireDefault(_addDeviceTpl);
	
	var _deviceCardTpl = __webpack_require__(1447);
	
	var _deviceCardTpl2 = _interopRequireDefault(_deviceCardTpl);
	
	var _assignToCustomerTpl = __webpack_require__(1446);
	
	var _assignToCustomerTpl2 = _interopRequireDefault(_assignToCustomerTpl);
	
	var _addDevicesToCustomerTpl = __webpack_require__(1445);
	
	var _addDevicesToCustomerTpl2 = _interopRequireDefault(_addDevicesToCustomerTpl);
	
	var _deviceCredentialsTpl = __webpack_require__(1448);
	
	var _deviceCredentialsTpl2 = _interopRequireDefault(_deviceCredentialsTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function DeviceCardController(types) {
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.isAssignedToCustomer = function () {
	        if (vm.item && vm.item.customerId && vm.parentCtl.devicesScope === 'tenant' && vm.item.customerId.id != vm.types.id.nullUid && !vm.item.assignedCustomer.isPublic) {
	            return true;
	        }
	        return false;
	    };
	
	    vm.isPublic = function () {
	        if (vm.item && vm.item.assignedCustomer && vm.parentCtl.devicesScope === 'tenant' && vm.item.assignedCustomer.isPublic) {
	            return true;
	        }
	        return false;
	    };
	}
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function DeviceController($rootScope, userService, deviceService, customerService, $state, $stateParams, $document, $mdDialog, $q, $translate, types) {
	
	    var customerId = $stateParams.customerId;
	
	    var deviceActionsList = [];
	
	    var deviceGroupActionsList = [];
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.deviceGridConfig = {
	        deleteItemTitleFunc: deleteDeviceTitle,
	        deleteItemContentFunc: deleteDeviceText,
	        deleteItemsTitleFunc: deleteDevicesTitle,
	        deleteItemsActionTitleFunc: deleteDevicesActionTitle,
	        deleteItemsContentFunc: deleteDevicesText,
	
	        saveItemFunc: saveDevice,
	
	        getItemTitleFunc: getDeviceTitle,
	
	        itemCardController: 'DeviceCardController',
	        itemCardTemplateUrl: _deviceCardTpl2.default,
	        parentCtl: vm,
	
	        actionsList: deviceActionsList,
	        groupActionsList: deviceGroupActionsList,
	
	        onGridInited: gridInited,
	
	        addItemTemplateUrl: _addDeviceTpl2.default,
	
	        addItemText: function addItemText() {
	            return $translate.instant('device.add-device-text');
	        },
	        noItemsText: function noItemsText() {
	            return $translate.instant('device.no-devices-text');
	        },
	        itemDetailsText: function itemDetailsText() {
	            return $translate.instant('device.device-details');
	        },
	        isDetailsReadOnly: isCustomerUser,
	        isSelectionEnabled: function isSelectionEnabled() {
	            return !isCustomerUser();
	        }
	    };
	
	    if (angular.isDefined($stateParams.items) && $stateParams.items !== null) {
	        vm.deviceGridConfig.items = $stateParams.items;
	    }
	
	    if (angular.isDefined($stateParams.topIndex) && $stateParams.topIndex > 0) {
	        vm.deviceGridConfig.topIndex = $stateParams.topIndex;
	    }
	
	    vm.devicesScope = $state.$current.data.devicesType;
	
	    vm.assignToCustomer = assignToCustomer;
	    vm.makePublic = makePublic;
	    vm.unassignFromCustomer = unassignFromCustomer;
	    vm.manageCredentials = manageCredentials;
	
	    initController();
	
	    function initController() {
	        var fetchDevicesFunction = null;
	        var deleteDeviceFunction = null;
	        var refreshDevicesParamsFunction = null;
	
	        var user = userService.getCurrentUser();
	
	        if (user.authority === 'CUSTOMER_USER') {
	            vm.devicesScope = 'customer_user';
	            customerId = user.customerId;
	        }
	        if (customerId) {
	            vm.customerDevicesTitle = $translate.instant('customer.devices');
	            customerService.getShortCustomerInfo(customerId).then(function success(info) {
	                if (info.isPublic) {
	                    vm.customerDevicesTitle = $translate.instant('customer.public-devices');
	                }
	            });
	        }
	
	        if (vm.devicesScope === 'tenant') {
	            fetchDevicesFunction = function fetchDevicesFunction(pageLink, deviceType) {
	                return deviceService.getTenantDevices(pageLink, true, null, deviceType);
	            };
	            deleteDeviceFunction = function deleteDeviceFunction(deviceId) {
	                return deviceService.deleteDevice(deviceId);
	            };
	            refreshDevicesParamsFunction = function refreshDevicesParamsFunction() {
	                return { "topIndex": vm.topIndex };
	            };
	
	            deviceActionsList.push({
	                onAction: function onAction($event, item) {
	                    makePublic($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('action.share');
	                },
	                details: function details() {
	                    return $translate.instant('device.make-public');
	                },
	                icon: "share",
	                isEnabled: function isEnabled(device) {
	                    return device && (!device.customerId || device.customerId.id === types.id.nullUid);
	                }
	            });
	
	            deviceActionsList.push({
	                onAction: function onAction($event, item) {
	                    assignToCustomer($event, [item.id.id]);
	                },
	                name: function name() {
	                    return $translate.instant('action.assign');
	                },
	                details: function details() {
	                    return $translate.instant('device.assign-to-customer');
	                },
	                icon: "assignment_ind",
	                isEnabled: function isEnabled(device) {
	                    return device && (!device.customerId || device.customerId.id === types.id.nullUid);
	                }
	            });
	
	            deviceActionsList.push({
	                onAction: function onAction($event, item) {
	                    unassignFromCustomer($event, item, false);
	                },
	                name: function name() {
	                    return $translate.instant('action.unassign');
	                },
	                details: function details() {
	                    return $translate.instant('device.unassign-from-customer');
	                },
	                icon: "assignment_return",
	                isEnabled: function isEnabled(device) {
	                    return device && device.customerId && device.customerId.id !== types.id.nullUid && !device.assignedCustomer.isPublic;
	                }
	            });
	
	            deviceActionsList.push({
	                onAction: function onAction($event, item) {
	                    unassignFromCustomer($event, item, true);
	                },
	                name: function name() {
	                    return $translate.instant('action.make-private');
	                },
	                details: function details() {
	                    return $translate.instant('device.make-private');
	                },
	                icon: "reply",
	                isEnabled: function isEnabled(device) {
	                    return device && device.customerId && device.customerId.id !== types.id.nullUid && device.assignedCustomer.isPublic;
	                }
	            });
	
	            deviceActionsList.push({
	                onAction: function onAction($event, item) {
	                    manageCredentials($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('device.credentials');
	                },
	                details: function details() {
	                    return $translate.instant('device.manage-credentials');
	                },
	                icon: "security"
	            });
	
	            deviceActionsList.push({
	                onAction: function onAction($event, item) {
	                    vm.grid.deleteItem($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('action.delete');
	                },
	                details: function details() {
	                    return $translate.instant('device.delete');
	                },
	                icon: "delete"
	            });
	
	            deviceGroupActionsList.push({
	                onAction: function onAction($event, items) {
	                    assignDevicesToCustomer($event, items);
	                },
	                name: function name() {
	                    return $translate.instant('device.assign-devices');
	                },
	                details: function details(selectedCount) {
	                    return $translate.instant('device.assign-devices-text', { count: selectedCount }, "messageformat");
	                },
	                icon: "assignment_ind"
	            });
	
	            deviceGroupActionsList.push({
	                onAction: function onAction($event) {
	                    vm.grid.deleteItems($event);
	                },
	                name: function name() {
	                    return $translate.instant('device.delete-devices');
	                },
	                details: deleteDevicesActionTitle,
	                icon: "delete"
	            });
	        } else if (vm.devicesScope === 'customer' || vm.devicesScope === 'customer_user') {
	            fetchDevicesFunction = function fetchDevicesFunction(pageLink, deviceType) {
	                return deviceService.getCustomerDevices(customerId, pageLink, true, null, deviceType);
	            };
	            deleteDeviceFunction = function deleteDeviceFunction(deviceId) {
	                return deviceService.unassignDeviceFromCustomer(deviceId);
	            };
	            refreshDevicesParamsFunction = function refreshDevicesParamsFunction() {
	                return { "customerId": customerId, "topIndex": vm.topIndex };
	            };
	
	            if (vm.devicesScope === 'customer') {
	                deviceActionsList.push({
	                    onAction: function onAction($event, item) {
	                        unassignFromCustomer($event, item, false);
	                    },
	                    name: function name() {
	                        return $translate.instant('action.unassign');
	                    },
	                    details: function details() {
	                        return $translate.instant('device.unassign-from-customer');
	                    },
	                    icon: "assignment_return",
	                    isEnabled: function isEnabled(device) {
	                        return device && !device.assignedCustomer.isPublic;
	                    }
	                });
	                deviceActionsList.push({
	                    onAction: function onAction($event, item) {
	                        unassignFromCustomer($event, item, true);
	                    },
	                    name: function name() {
	                        return $translate.instant('action.make-private');
	                    },
	                    details: function details() {
	                        return $translate.instant('device.make-private');
	                    },
	                    icon: "reply",
	                    isEnabled: function isEnabled(device) {
	                        return device && device.assignedCustomer.isPublic;
	                    }
	                });
	
	                deviceActionsList.push({
	                    onAction: function onAction($event, item) {
	                        manageCredentials($event, item);
	                    },
	                    name: function name() {
	                        return $translate.instant('device.credentials');
	                    },
	                    details: function details() {
	                        return $translate.instant('device.manage-credentials');
	                    },
	                    icon: "security"
	                });
	
	                deviceGroupActionsList.push({
	                    onAction: function onAction($event, items) {
	                        unassignDevicesFromCustomer($event, items);
	                    },
	                    name: function name() {
	                        return $translate.instant('device.unassign-devices');
	                    },
	                    details: function details(selectedCount) {
	                        return $translate.instant('device.unassign-devices-action-title', { count: selectedCount }, "messageformat");
	                    },
	                    icon: "assignment_return"
	                });
	
	                vm.deviceGridConfig.addItemAction = {
	                    onAction: function onAction($event) {
	                        addDevicesToCustomer($event);
	                    },
	                    name: function name() {
	                        return $translate.instant('device.assign-devices');
	                    },
	                    details: function details() {
	                        return $translate.instant('device.assign-new-device');
	                    },
	                    icon: "add"
	                };
	            } else if (vm.devicesScope === 'customer_user') {
	                deviceActionsList.push({
	                    onAction: function onAction($event, item) {
	                        manageCredentials($event, item);
	                    },
	                    name: function name() {
	                        return $translate.instant('device.credentials');
	                    },
	                    details: function details() {
	                        return $translate.instant('device.view-credentials');
	                    },
	                    icon: "security"
	                });
	
	                vm.deviceGridConfig.addItemAction = {};
	            }
	        }
	
	        vm.deviceGridConfig.refreshParamsFunc = refreshDevicesParamsFunction;
	        vm.deviceGridConfig.fetchItemsFunc = fetchDevicesFunction;
	        vm.deviceGridConfig.deleteItemFunc = deleteDeviceFunction;
	    }
	
	    function deleteDeviceTitle(device) {
	        return $translate.instant('device.delete-device-title', { deviceName: device.name });
	    }
	
	    function deleteDeviceText() {
	        return $translate.instant('device.delete-device-text');
	    }
	
	    function deleteDevicesTitle(selectedCount) {
	        return $translate.instant('device.delete-devices-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteDevicesActionTitle(selectedCount) {
	        return $translate.instant('device.delete-devices-action-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteDevicesText() {
	        return $translate.instant('device.delete-devices-text');
	    }
	
	    function gridInited(grid) {
	        vm.grid = grid;
	    }
	
	    function getDeviceTitle(device) {
	        return device ? device.name : '';
	    }
	
	    function saveDevice(device) {
	        var deferred = $q.defer();
	        deviceService.saveDevice(device).then(function success(savedDevice) {
	            $rootScope.$broadcast('deviceSaved');
	            var devices = [savedDevice];
	            customerService.applyAssignedCustomersInfo(devices).then(function success(items) {
	                if (items && items.length == 1) {
	                    deferred.resolve(items[0]);
	                } else {
	                    deferred.reject();
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function isCustomerUser() {
	        return vm.devicesScope === 'customer_user';
	    }
	
	    function assignToCustomer($event, deviceIds) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var pageSize = 10;
	        customerService.getCustomers({ limit: pageSize, textSearch: '' }).then(function success(_customers) {
	            var customers = {
	                pageSize: pageSize,
	                data: _customers.data,
	                nextPageLink: _customers.nextPageLink,
	                selection: null,
	                hasNext: _customers.hasNext,
	                pending: false
	            };
	            if (customers.hasNext) {
	                customers.nextPageLink.limit = pageSize;
	            }
	            $mdDialog.show({
	                controller: 'AssignDeviceToCustomerController',
	                controllerAs: 'vm',
	                templateUrl: _assignToCustomerTpl2.default,
	                locals: { deviceIds: deviceIds, customers: customers },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: $event
	            }).then(function () {
	                vm.grid.refreshList();
	            }, function () {});
	        }, function fail() {});
	    }
	
	    function addDevicesToCustomer($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var pageSize = 10;
	        deviceService.getTenantDevices({ limit: pageSize, textSearch: '' }, false).then(function success(_devices) {
	            var devices = {
	                pageSize: pageSize,
	                data: _devices.data,
	                nextPageLink: _devices.nextPageLink,
	                selections: {},
	                selectedCount: 0,
	                hasNext: _devices.hasNext,
	                pending: false
	            };
	            if (devices.hasNext) {
	                devices.nextPageLink.limit = pageSize;
	            }
	            $mdDialog.show({
	                controller: 'AddDevicesToCustomerController',
	                controllerAs: 'vm',
	                templateUrl: _addDevicesToCustomerTpl2.default,
	                locals: { customerId: customerId, devices: devices },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: $event
	            }).then(function () {
	                vm.grid.refreshList();
	            }, function () {});
	        }, function fail() {});
	    }
	
	    function assignDevicesToCustomer($event, items) {
	        var deviceIds = [];
	        for (var id in items.selections) {
	            deviceIds.push(id);
	        }
	        assignToCustomer($event, deviceIds);
	    }
	
	    function unassignFromCustomer($event, device, isPublic) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var title;
	        var content;
	        var label;
	        if (isPublic) {
	            title = $translate.instant('device.make-private-device-title', { deviceName: device.name });
	            content = $translate.instant('device.make-private-device-text');
	            label = $translate.instant('device.make-private');
	        } else {
	            title = $translate.instant('device.unassign-device-title', { deviceName: device.name });
	            content = $translate.instant('device.unassign-device-text');
	            label = $translate.instant('device.unassign-device');
	        }
	        var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(label).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            deviceService.unassignDeviceFromCustomer(device.id.id).then(function success() {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function unassignDevicesFromCustomer($event, items) {
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('device.unassign-devices-title', { count: items.selectedCount }, 'messageformat')).htmlContent($translate.instant('device.unassign-devices-text')).ariaLabel($translate.instant('device.unassign-device')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            var tasks = [];
	            for (var id in items.selections) {
	                tasks.push(deviceService.unassignDeviceFromCustomer(id));
	            }
	            $q.all(tasks).then(function () {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function makePublic($event, device) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('device.make-public-device-title', { deviceName: device.name })).htmlContent($translate.instant('device.make-public-device-text')).ariaLabel($translate.instant('device.make-public')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            deviceService.makeDevicePublic(device.id.id).then(function success() {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function manageCredentials($event, device) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        $mdDialog.show({
	            controller: 'ManageDeviceCredentialsController',
	            controllerAs: 'vm',
	            templateUrl: _deviceCredentialsTpl2.default,
	            locals: { deviceId: device.id.id, isReadOnly: isCustomerUser() },
	            parent: angular.element($document[0].body),
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function () {}, function () {});
	    }
	}

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DeviceDirective.$inject = ["$compile", "$templateCache", "toast", "$translate", "types", "clipboardService", "deviceService", "customerService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DeviceDirective;
	
	var _deviceFieldsetTpl = __webpack_require__(1449);
	
	var _deviceFieldsetTpl2 = _interopRequireDefault(_deviceFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function DeviceDirective($compile, $templateCache, toast, $translate, types, clipboardService, deviceService, customerService) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_deviceFieldsetTpl2.default);
	        element.html(template);
	
	        scope.types = types;
	        scope.isAssignedToCustomer = false;
	        scope.isPublic = false;
	        scope.assignedCustomer = null;
	
	        scope.$watch('device', function (newVal) {
	            if (newVal) {
	                if (scope.device.customerId && scope.device.customerId.id !== types.id.nullUid) {
	                    scope.isAssignedToCustomer = true;
	                    customerService.getShortCustomerInfo(scope.device.customerId.id).then(function success(customer) {
	                        scope.assignedCustomer = customer;
	                        scope.isPublic = customer.isPublic;
	                    });
	                } else {
	                    scope.isAssignedToCustomer = false;
	                    scope.isPublic = false;
	                    scope.assignedCustomer = null;
	                }
	            }
	        });
	
	        scope.onDeviceIdCopied = function () {
	            toast.showSuccess($translate.instant('device.idCopiedMessage'), 750, angular.element(element).parent().parent(), 'bottom left');
	        };
	
	        scope.copyAccessToken = function (e) {
	            var trigger = e.delegateTarget || e.currentTarget;
	            if (scope.device.id) {
	                deviceService.getDeviceCredentials(scope.device.id.id, true).then(function success(credentials) {
	                    var credentialsId = credentials.credentialsId;
	                    clipboardService.copyToClipboard(trigger, credentialsId).then(function () {
	                        toast.showSuccess($translate.instant('device.accessTokenCopiedMessage'), 750, angular.element(element).parent().parent(), 'bottom left');
	                    });
	                });
	            }
	        };
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            device: '=',
	            isEdit: '=',
	            deviceScope: '=',
	            theForm: '=',
	            onAssignToCustomer: '&',
	            onMakePublic: '&',
	            onUnassignFromCustomer: '&',
	            onManageCredentials: '&',
	            onDeleteDevice: '&'
	        }
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DeviceRoutes.$inject = ["$stateProvider", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DeviceRoutes;
	
	var _devicesTpl = __webpack_require__(1450);
	
	var _devicesTpl2 = _interopRequireDefault(_devicesTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function DeviceRoutes($stateProvider, types) {
	    $stateProvider.state('home.devices', {
	        url: '/devices',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "content@home": {
	                templateUrl: _devicesTpl2.default,
	                controller: 'DeviceController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            devicesType: 'tenant',
	            searchEnabled: true,
	            searchByEntitySubtype: true,
	            searchEntityType: types.entityType.device,
	            pageTitle: 'device.devices'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "devices_other", "label": "device.devices"}'
	        }
	    }).state('home.customers.devices', {
	        url: '/:customerId/devices',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _devicesTpl2.default,
	                controllerAs: 'vm',
	                controller: 'DeviceController'
	            }
	        },
	        data: {
	            devicesType: 'customer',
	            searchEnabled: true,
	            searchByEntitySubtype: true,
	            searchEntityType: types.entityType.device,
	            pageTitle: 'customer.devices'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "devices_other", "label": "{{ vm.customerDevicesTitle }}", "translate": "false"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _grid = __webpack_require__(74);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _device = __webpack_require__(146);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _customer = __webpack_require__(112);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _device3 = __webpack_require__(1241);
	
	var _device4 = _interopRequireDefault(_device3);
	
	var _device5 = __webpack_require__(1239);
	
	var _assignToCustomer = __webpack_require__(1237);
	
	var _assignToCustomer2 = _interopRequireDefault(_assignToCustomer);
	
	var _addDevicesToCustomer = __webpack_require__(1236);
	
	var _addDevicesToCustomer2 = _interopRequireDefault(_addDevicesToCustomer);
	
	var _deviceCredentials = __webpack_require__(1238);
	
	var _deviceCredentials2 = _interopRequireDefault(_deviceCredentials);
	
	var _device6 = __webpack_require__(1240);
	
	var _device7 = _interopRequireDefault(_device6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.device', [_angularUiRouter2.default, _grid2.default, _user2.default, _device2.default, _customer2.default]).config(_device4.default).controller('DeviceController', _device5.DeviceController).controller('DeviceCardController', _device5.DeviceCardController).controller('AssignDeviceToCustomerController', _assignToCustomer2.default).controller('AddDevicesToCustomerController', _addDevicesToCustomer2.default).controller('ManageDeviceCredentialsController', _deviceCredentials2.default).directive('tbDevice', _device7.default).name; /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

	'use strict';
	
	AddEntityViewsToCustomerController.$inject = ["entityViewService", "$mdDialog", "$q", "customerId", "entityViews"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AddEntityViewsToCustomerController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AddEntityViewsToCustomerController(entityViewService, $mdDialog, $q, customerId, entityViews) {
	
	    var vm = this;
	
	    vm.entityViews = entityViews;
	    vm.searchText = '';
	
	    vm.assign = assign;
	    vm.cancel = cancel;
	    vm.hasData = hasData;
	    vm.noData = noData;
	    vm.searchEntityViewTextUpdated = searchEntityViewTextUpdated;
	    vm.toggleEntityViewSelection = toggleEntityViewSelection;
	
	    vm.theEntityViews = {
	        getItemAtIndex: function getItemAtIndex(index) {
	            if (index > vm.entityViews.data.length) {
	                vm.theEntityViews.fetchMoreItems_(index);
	                return null;
	            }
	            var item = vm.entityViews.data[index];
	            if (item) {
	                item.indexNumber = index + 1;
	            }
	            return item;
	        },
	
	        getLength: function getLength() {
	            if (vm.entityViews.hasNext) {
	                return vm.entityViews.data.length + vm.entityViews.nextPageLink.limit;
	            } else {
	                return vm.entityViews.data.length;
	            }
	        },
	
	        fetchMoreItems_: function fetchMoreItems_() {
	            if (vm.entityViews.hasNext && !vm.entityViews.pending) {
	                vm.entityViews.pending = true;
	                entityViewService.getTenantEntityViews(vm.entityViews.nextPageLink, false).then(function success(entityViews) {
	                    vm.entityViews.data = vm.entityViews.data.concat(entityViews.data);
	                    vm.entityViews.nextPageLink = entityViews.nextPageLink;
	                    vm.entityViews.hasNext = entityViews.hasNext;
	                    if (vm.entityViews.hasNext) {
	                        vm.entityViews.nextPageLink.limit = vm.entityViews.pageSize;
	                    }
	                    vm.entityViews.pending = false;
	                }, function fail() {
	                    vm.entityViews.hasNext = false;
	                    vm.entityViews.pending = false;
	                });
	            }
	        }
	    };
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function assign() {
	        var tasks = [];
	        for (var entityViewId in vm.entityViews.selections) {
	            tasks.push(entityViewService.assignEntityViewToCustomer(customerId, entityViewId));
	        }
	        $q.all(tasks).then(function () {
	            $mdDialog.hide();
	        });
	    }
	
	    function noData() {
	        return vm.entityViews.data.length == 0 && !vm.entityViews.hasNext;
	    }
	
	    function hasData() {
	        return vm.entityViews.data.length > 0;
	    }
	
	    function toggleEntityViewSelection($event, entityView) {
	        $event.stopPropagation();
	        var selected = angular.isDefined(entityView.selected) && entityView.selected;
	        entityView.selected = !selected;
	        if (entityView.selected) {
	            vm.entityViews.selections[entityView.id.id] = true;
	            vm.entityViews.selectedCount++;
	        } else {
	            delete vm.entityViews.selections[entityView.id.id];
	            vm.entityViews.selectedCount--;
	        }
	    }
	
	    function searchEntityViewTextUpdated() {
	        vm.entityViews = {
	            pageSize: vm.entityViews.pageSize,
	            data: [],
	            nextPageLink: {
	                limit: vm.entityViews.pageSize,
	                textSearch: vm.searchText
	            },
	            selections: {},
	            selectedCount: 0,
	            hasNext: true,
	            pending: false
	        };
	    }
	}

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	'use strict';
	
	AssignEntityViewToCustomerController.$inject = ["customerService", "entityViewService", "$mdDialog", "$q", "entityViewIds", "customers"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AssignEntityViewToCustomerController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AssignEntityViewToCustomerController(customerService, entityViewService, $mdDialog, $q, entityViewIds, customers) {
	
	    var vm = this;
	
	    vm.customers = customers;
	    vm.searchText = '';
	
	    vm.assign = assign;
	    vm.cancel = cancel;
	    vm.isCustomerSelected = isCustomerSelected;
	    vm.hasData = hasData;
	    vm.noData = noData;
	    vm.searchCustomerTextUpdated = searchCustomerTextUpdated;
	    vm.toggleCustomerSelection = toggleCustomerSelection;
	
	    vm.theCustomers = {
	        getItemAtIndex: function getItemAtIndex(index) {
	            if (index > vm.customers.data.length) {
	                vm.theCustomers.fetchMoreItems_(index);
	                return null;
	            }
	            var item = vm.customers.data[index];
	            if (item) {
	                item.indexNumber = index + 1;
	            }
	            return item;
	        },
	
	        getLength: function getLength() {
	            if (vm.customers.hasNext) {
	                return vm.customers.data.length + vm.customers.nextPageLink.limit;
	            } else {
	                return vm.customers.data.length;
	            }
	        },
	
	        fetchMoreItems_: function fetchMoreItems_() {
	            if (vm.customers.hasNext && !vm.customers.pending) {
	                vm.customers.pending = true;
	                customerService.getCustomers(vm.customers.nextPageLink).then(function success(customers) {
	                    vm.customers.data = vm.customers.data.concat(customers.data);
	                    vm.customers.nextPageLink = customers.nextPageLink;
	                    vm.customers.hasNext = customers.hasNext;
	                    if (vm.customers.hasNext) {
	                        vm.customers.nextPageLink.limit = vm.customers.pageSize;
	                    }
	                    vm.customers.pending = false;
	                }, function fail() {
	                    vm.customers.hasNext = false;
	                    vm.customers.pending = false;
	                });
	            }
	        }
	    };
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function assign() {
	        var tasks = [];
	        for (var i = 0; i < entityViewIds.length; i++) {
	            tasks.push(entityViewService.assignEntityViewToCustomer(vm.customers.selection.id.id, entityViewIds[i]));
	        }
	        $q.all(tasks).then(function () {
	            $mdDialog.hide();
	        });
	    }
	
	    function noData() {
	        return vm.customers.data.length == 0 && !vm.customers.hasNext;
	    }
	
	    function hasData() {
	        return vm.customers.data.length > 0;
	    }
	
	    function toggleCustomerSelection($event, customer) {
	        $event.stopPropagation();
	        if (vm.isCustomerSelected(customer)) {
	            vm.customers.selection = null;
	        } else {
	            vm.customers.selection = customer;
	        }
	    }
	
	    function isCustomerSelected(customer) {
	        return vm.customers.selection != null && customer && customer.id.id === vm.customers.selection.id.id;
	    }
	
	    function searchCustomerTextUpdated() {
	        vm.customers = {
	            pageSize: vm.customers.pageSize,
	            data: [],
	            nextPageLink: {
	                limit: vm.customers.pageSize,
	                textSearch: vm.searchText
	            },
	            selection: null,
	            hasNext: true,
	            pending: false
	        };
	    }
	}

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityViewCardController.$inject = ["types"];
	EntityViewController.$inject = ["$rootScope", "userService", "entityViewService", "customerService", "$state", "$stateParams", "$document", "$mdDialog", "$q", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EntityViewCardController = EntityViewCardController;
	exports.EntityViewController = EntityViewController;
	
	var _addEntityViewTpl = __webpack_require__(1451);
	
	var _addEntityViewTpl2 = _interopRequireDefault(_addEntityViewTpl);
	
	var _entityViewCardTpl = __webpack_require__(1454);
	
	var _entityViewCardTpl2 = _interopRequireDefault(_entityViewCardTpl);
	
	var _assignToCustomerTpl = __webpack_require__(1453);
	
	var _assignToCustomerTpl2 = _interopRequireDefault(_assignToCustomerTpl);
	
	var _addEntityViewsToCustomerTpl = __webpack_require__(1452);
	
	var _addEntityViewsToCustomerTpl2 = _interopRequireDefault(_addEntityViewsToCustomerTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function EntityViewCardController(types) {
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.isAssignedToCustomer = function () {
	        if (vm.item && vm.item.customerId && vm.parentCtl.entityViewsScope === 'tenant' && vm.item.customerId.id != vm.types.id.nullUid && !vm.item.assignedCustomer.isPublic) {
	            return true;
	        }
	        return false;
	    };
	
	    vm.isPublic = function () {
	        if (vm.item && vm.item.assignedCustomer && vm.parentCtl.entityViewsScope === 'tenant' && vm.item.assignedCustomer.isPublic) {
	            return true;
	        }
	        return false;
	    };
	}
	
	/*@ngInject*/
	function EntityViewController($rootScope, userService, entityViewService, customerService, $state, $stateParams, $document, $mdDialog, $q, $translate, types) {
	
	    var customerId = $stateParams.customerId;
	
	    var entityViewActionsList = [];
	
	    var entityViewGroupActionsList = [];
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.entityViewGridConfig = {
	        deleteItemTitleFunc: deleteEntityViewTitle,
	        deleteItemContentFunc: deleteEntityViewText,
	        deleteItemsTitleFunc: deleteEntityViewsTitle,
	        deleteItemsActionTitleFunc: deleteEntityViewsActionTitle,
	        deleteItemsContentFunc: deleteEntityViewsText,
	
	        saveItemFunc: saveEntityView,
	
	        getItemTitleFunc: getEntityViewTitle,
	
	        itemCardController: 'EntityViewCardController',
	        itemCardTemplateUrl: _entityViewCardTpl2.default,
	        parentCtl: vm,
	
	        actionsList: entityViewActionsList,
	        groupActionsList: entityViewGroupActionsList,
	
	        onGridInited: gridInited,
	
	        addItemTemplateUrl: _addEntityViewTpl2.default,
	
	        addItemText: function addItemText() {
	            return $translate.instant('entity-view.add-entity-view-text');
	        },
	        noItemsText: function noItemsText() {
	            return $translate.instant('entity-view.no-entity-views-text');
	        },
	        itemDetailsText: function itemDetailsText() {
	            return $translate.instant('entity-view.entity-view-details');
	        },
	        isDetailsReadOnly: isCustomerUser,
	        isSelectionEnabled: function isSelectionEnabled() {
	            return !isCustomerUser();
	        }
	    };
	
	    if (angular.isDefined($stateParams.items) && $stateParams.items !== null) {
	        vm.entityViewGridConfig.items = $stateParams.items;
	    }
	
	    if (angular.isDefined($stateParams.topIndex) && $stateParams.topIndex > 0) {
	        vm.entityViewGridConfig.topIndex = $stateParams.topIndex;
	    }
	
	    vm.entityViewsScope = $state.$current.data.entityViewsType;
	
	    vm.assignToCustomer = assignToCustomer;
	    vm.makePublic = makePublic;
	    vm.unassignFromCustomer = unassignFromCustomer;
	
	    initController();
	
	    function initController() {
	        var fetchEntityViewsFunction = null;
	        var deleteEntityViewFunction = null;
	        var refreshEntityViewsParamsFunction = null;
	
	        var user = userService.getCurrentUser();
	
	        if (user.authority === 'CUSTOMER_USER') {
	            vm.entityViewsScope = 'customer_user';
	            customerId = user.customerId;
	        }
	        if (customerId) {
	            vm.customerEntityViewsTitle = $translate.instant('customer.entity-views');
	            customerService.getShortCustomerInfo(customerId).then(function success(info) {
	                if (info.isPublic) {
	                    vm.customerEntityViewsTitle = $translate.instant('customer.public-entity-views');
	                }
	            });
	        }
	
	        if (vm.entityViewsScope === 'tenant') {
	            fetchEntityViewsFunction = function fetchEntityViewsFunction(pageLink, entityViewType) {
	                return entityViewService.getTenantEntityViews(pageLink, true, null, entityViewType);
	            };
	            deleteEntityViewFunction = function deleteEntityViewFunction(entityViewId) {
	                return entityViewService.deleteEntityView(entityViewId);
	            };
	            refreshEntityViewsParamsFunction = function refreshEntityViewsParamsFunction() {
	                return { "topIndex": vm.topIndex };
	            };
	
	            entityViewActionsList.push({
	                onAction: function onAction($event, item) {
	                    assignToCustomer($event, [item.id.id]);
	                },
	                name: function name() {
	                    return $translate.instant('action.assign');
	                },
	                details: function details() {
	                    return $translate.instant('entity-view.assign-to-customer');
	                },
	                icon: "assignment_ind",
	                isEnabled: function isEnabled(entityView) {
	                    return entityView && (!entityView.customerId || entityView.customerId.id === types.id.nullUid);
	                }
	            });
	
	            entityViewActionsList.push({
	                onAction: function onAction($event, item) {
	                    unassignFromCustomer($event, item, false);
	                },
	                name: function name() {
	                    return $translate.instant('action.unassign');
	                },
	                details: function details() {
	                    return $translate.instant('entity-view.unassign-from-customer');
	                },
	                icon: "assignment_return",
	                isEnabled: function isEnabled(entityView) {
	                    return entityView && entityView.customerId && entityView.customerId.id !== types.id.nullUid && !entityView.assignedCustomer.isPublic;
	                }
	            });
	
	            entityViewActionsList.push({
	                onAction: function onAction($event, item) {
	                    unassignFromCustomer($event, item, true);
	                },
	                name: function name() {
	                    return $translate.instant('action.make-private');
	                },
	                details: function details() {
	                    return $translate.instant('entity-view.make-private');
	                },
	                icon: "reply",
	                isEnabled: function isEnabled(entityView) {
	                    return entityView && entityView.customerId && entityView.customerId.id !== types.id.nullUid && entityView.assignedCustomer.isPublic;
	                }
	            });
	
	            entityViewActionsList.push({
	                onAction: function onAction($event, item) {
	                    vm.grid.deleteItem($event, item);
	                },
	                name: function name() {
	                    return $translate.instant('action.delete');
	                },
	                details: function details() {
	                    return $translate.instant('entity-view.delete');
	                },
	                icon: "delete"
	            });
	
	            entityViewGroupActionsList.push({
	                onAction: function onAction($event, items) {
	                    assignEntityViewsToCustomer($event, items);
	                },
	                name: function name() {
	                    return $translate.instant('entity-view.assign-entity-views');
	                },
	                details: function details(selectedCount) {
	                    return $translate.instant('entity-view.assign-entity-views-text', { count: selectedCount }, "messageformat");
	                },
	                icon: "assignment_ind"
	            });
	
	            entityViewGroupActionsList.push({
	                onAction: function onAction($event) {
	                    vm.grid.deleteItems($event);
	                },
	                name: function name() {
	                    return $translate.instant('entity-view.delete-entity-views');
	                },
	                details: deleteEntityViewsActionTitle,
	                icon: "delete"
	            });
	        } else if (vm.entityViewsScope === 'customer' || vm.entityViewsScope === 'customer_user') {
	            fetchEntityViewsFunction = function fetchEntityViewsFunction(pageLink, entityViewType) {
	                return entityViewService.getCustomerEntityViews(customerId, pageLink, true, null, entityViewType);
	            };
	            deleteEntityViewFunction = function deleteEntityViewFunction(entityViewId) {
	                return entityViewService.unassignEntityViewFromCustomer(entityViewId);
	            };
	            refreshEntityViewsParamsFunction = function refreshEntityViewsParamsFunction() {
	                return { "customerId": customerId, "topIndex": vm.topIndex };
	            };
	
	            if (vm.entityViewsScope === 'customer') {
	                entityViewActionsList.push({
	                    onAction: function onAction($event, item) {
	                        unassignFromCustomer($event, item, false);
	                    },
	                    name: function name() {
	                        return $translate.instant('action.unassign');
	                    },
	                    details: function details() {
	                        return $translate.instant('entity-view.unassign-from-customer');
	                    },
	                    icon: "assignment_return",
	                    isEnabled: function isEnabled(entityView) {
	                        return entityView && !entityView.assignedCustomer.isPublic;
	                    }
	                });
	
	                entityViewGroupActionsList.push({
	                    onAction: function onAction($event, items) {
	                        unassignEntityViewsFromCustomer($event, items);
	                    },
	                    name: function name() {
	                        return $translate.instant('entity-view.unassign-entity-views');
	                    },
	                    details: function details(selectedCount) {
	                        return $translate.instant('entity-view.unassign-entity-views-action-title', { count: selectedCount }, "messageformat");
	                    },
	                    icon: "assignment_return"
	                });
	
	                vm.entityViewGridConfig.addItemAction = {
	                    onAction: function onAction($event) {
	                        addEntityViewsToCustomer($event);
	                    },
	                    name: function name() {
	                        return $translate.instant('entity-view.assign-entity-views');
	                    },
	                    details: function details() {
	                        return $translate.instant('entity-view.assign-new-entity-view');
	                    },
	                    icon: "add"
	                };
	            } else if (vm.entityViewsScope === 'customer_user') {
	                vm.entityViewGridConfig.addItemAction = {};
	            }
	        }
	
	        vm.entityViewGridConfig.refreshParamsFunc = refreshEntityViewsParamsFunction;
	        vm.entityViewGridConfig.fetchItemsFunc = fetchEntityViewsFunction;
	        vm.entityViewGridConfig.deleteItemFunc = deleteEntityViewFunction;
	    }
	
	    function deleteEntityViewTitle(entityView) {
	        return $translate.instant('entity-view.delete-entity-view-title', { entityViewName: entityView.name });
	    }
	
	    function deleteEntityViewText() {
	        return $translate.instant('entity-view.delete-entity-view-text');
	    }
	
	    function deleteEntityViewsTitle(selectedCount) {
	        return $translate.instant('entity-view.delete-entity-views-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteEntityViewsActionTitle(selectedCount) {
	        return $translate.instant('entity-view.delete-entity-views-action-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteEntityViewsText() {
	        return $translate.instant('entity-view.delete-entity-views-text');
	    }
	
	    function gridInited(grid) {
	        vm.grid = grid;
	    }
	
	    function getEntityViewTitle(entityView) {
	        return entityView ? entityView.name : '';
	    }
	
	    function saveEntityView(entityView) {
	        var deferred = $q.defer();
	        entityViewService.saveEntityView(entityView).then(function success(savedEntityView) {
	            $rootScope.$broadcast('entityViewSaved');
	            var entityViews = [savedEntityView];
	            customerService.applyAssignedCustomersInfo(entityViews).then(function success(items) {
	                if (items && items.length == 1) {
	                    deferred.resolve(items[0]);
	                } else {
	                    deferred.reject();
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function isCustomerUser() {
	        return vm.entityViewsScope === 'customer_user';
	    }
	
	    function assignToCustomer($event, entityViewIds) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var pageSize = 10;
	        customerService.getCustomers({ limit: pageSize, textSearch: '' }).then(function success(_customers) {
	            var customers = {
	                pageSize: pageSize,
	                data: _customers.data,
	                nextPageLink: _customers.nextPageLink,
	                selection: null,
	                hasNext: _customers.hasNext,
	                pending: false
	            };
	            if (customers.hasNext) {
	                customers.nextPageLink.limit = pageSize;
	            }
	            $mdDialog.show({
	                controller: 'AssignEntityViewToCustomerController',
	                controllerAs: 'vm',
	                templateUrl: _assignToCustomerTpl2.default,
	                locals: { entityViewIds: entityViewIds, customers: customers },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: $event
	            }).then(function () {
	                vm.grid.refreshList();
	            }, function () {});
	        }, function fail() {});
	    }
	
	    function addEntityViewsToCustomer($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var pageSize = 10;
	        entityViewService.getTenantEntityViews({ limit: pageSize, textSearch: '' }, false).then(function success(_entityViews) {
	            var entityViews = {
	                pageSize: pageSize,
	                data: _entityViews.data,
	                nextPageLink: _entityViews.nextPageLink,
	                selections: {},
	                selectedCount: 0,
	                hasNext: _entityViews.hasNext,
	                pending: false
	            };
	            if (entityViews.hasNext) {
	                entityViews.nextPageLink.limit = pageSize;
	            }
	            $mdDialog.show({
	                controller: 'AddEntityViewsToCustomerController',
	                controllerAs: 'vm',
	                templateUrl: _addEntityViewsToCustomerTpl2.default,
	                locals: { customerId: customerId, entityViews: entityViews },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: $event
	            }).then(function () {
	                vm.grid.refreshList();
	            }, function () {});
	        }, function fail() {});
	    }
	
	    function assignEntityViewsToCustomer($event, items) {
	        var entityViewIds = [];
	        for (var id in items.selections) {
	            entityViewIds.push(id);
	        }
	        assignToCustomer($event, entityViewIds);
	    }
	
	    function unassignFromCustomer($event, entityView, isPublic) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var title;
	        var content;
	        var label;
	        if (isPublic) {
	            title = $translate.instant('entity-view.make-private-entity-view-title', { entityViewName: entityView.name });
	            content = $translate.instant('entity-view.make-private-entity-view-text');
	            label = $translate.instant('entity-view.make-private');
	        } else {
	            title = $translate.instant('entity-view.unassign-entity-view-title', { entityViewName: entityView.name });
	            content = $translate.instant('entity-view.unassign-entity-view-text');
	            label = $translate.instant('entity-view.unassign-entity-view');
	        }
	        var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(label).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            entityViewService.unassignEntityViewFromCustomer(entityView.id.id).then(function success() {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function unassignEntityViewsFromCustomer($event, items) {
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('entity-view.unassign-entity-views-title', { count: items.selectedCount }, 'messageformat')).htmlContent($translate.instant('entity-view.unassign-entity-views-text')).ariaLabel($translate.instant('entity-view.unassign-entity-view')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            var tasks = [];
	            for (var id in items.selections) {
	                tasks.push(entityViewService.unassignEntityViewFromCustomer(id));
	            }
	            $q.all(tasks).then(function () {
	                vm.grid.refreshList();
	            });
	        });
	    }
	
	    function makePublic($event, entityView) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('entity-view.make-public-entity-view-title', { entityViewName: entityView.name })).htmlContent($translate.instant('entity-view.make-public-entity-view-text')).ariaLabel($translate.instant('entity-view.make-public')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            entityViewService.makeEntityViewPublic(entityView.id.id).then(function success() {
	                vm.grid.refreshList();
	            });
	        });
	    }
	}

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityViewDirective.$inject = ["$q", "$compile", "$templateCache", "$filter", "toast", "$translate", "$mdConstant", "$mdExpansionPanel", "types", "clipboardService", "entityViewService", "customerService", "entityService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityViewDirective;
	
	__webpack_require__(786);
	
	var _entityViewFieldsetTpl = __webpack_require__(1455);
	
	var _entityViewFieldsetTpl2 = _interopRequireDefault(_entityViewFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function EntityViewDirective($q, $compile, $templateCache, $filter, toast, $translate, $mdConstant, $mdExpansionPanel, types, clipboardService, entityViewService, customerService, entityService) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_entityViewFieldsetTpl2.default);
	        element.html(template);
	
	        scope.attributesPanelId = (Math.random() * 1000).toFixed(0);
	        scope.timeseriesPanelId = (Math.random() * 1000).toFixed(0);
	        scope.$mdExpansionPanel = $mdExpansionPanel;
	
	        scope.types = types;
	        scope.isAssignedToCustomer = false;
	        scope.isPublic = false;
	        scope.assignedCustomer = null;
	
	        scope.allowedEntityTypes = [types.entityType.device, types.entityType.asset];
	
	        var semicolon = 186;
	        scope.separatorKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, semicolon];
	
	        scope.$watch('entityView', function (newVal) {
	            if (newVal) {
	                if (scope.entityView.customerId && scope.entityView.customerId.id !== types.id.nullUid) {
	                    scope.isAssignedToCustomer = true;
	                    customerService.getShortCustomerInfo(scope.entityView.customerId.id).then(function success(customer) {
	                        scope.assignedCustomer = customer;
	                        scope.isPublic = customer.isPublic;
	                    });
	                } else {
	                    scope.isAssignedToCustomer = false;
	                    scope.isPublic = false;
	                    scope.assignedCustomer = null;
	                }
	                if (scope.entityView.startTimeMs > 0) {
	                    scope.startTimeMs = new Date(scope.entityView.startTimeMs);
	                } else {
	                    scope.startTimeMs = null;
	                }
	                if (scope.entityView.endTimeMs > 0) {
	                    scope.endTimeMs = new Date(scope.entityView.endTimeMs);
	                } else {
	                    scope.endTimeMs = null;
	                }
	                if (!scope.entityView.keys) {
	                    scope.entityView.keys = {};
	                    scope.entityView.keys.timeseries = [];
	                    scope.entityView.keys.attributes = {};
	                    scope.entityView.keys.attributes.ss = [];
	                    scope.entityView.keys.attributes.cs = [];
	                    scope.entityView.keys.attributes.sh = [];
	                }
	            }
	        });
	
	        scope.dataKeysSearch = function (searchText, type) {
	            var deferred = $q.defer();
	            entityService.getEntityKeys(scope.entityView.entityId.entityType, scope.entityView.entityId.id, searchText, type, { ignoreLoading: true }).then(function success(keys) {
	                deferred.resolve(keys);
	            }, function fail() {
	                deferred.resolve([]);
	            });
	            return deferred.promise;
	        };
	
	        scope.$watch('startTimeMs', function (newDate) {
	            if (newDate) {
	                if (newDate.getTime() > scope.maxStartTimeMs) {
	                    scope.startTimeMs = angular.copy(scope.maxStartTimeMs);
	                }
	                updateMinMaxDates();
	            }
	        });
	
	        scope.$watch('endTimeMs', function (newDate) {
	            if (newDate) {
	                if (newDate.getTime() < scope.minEndTimeMs) {
	                    scope.endTimeMs = angular.copy(scope.minEndTimeMs);
	                }
	                updateMinMaxDates();
	            }
	        });
	
	        function updateMinMaxDates() {
	            if (scope.endTimeMs) {
	                scope.maxStartTimeMs = angular.copy(new Date(scope.endTimeMs.getTime()));
	                scope.entityView.endTimeMs = scope.endTimeMs.getTime();
	            }
	            if (scope.startTimeMs) {
	                scope.minEndTimeMs = angular.copy(new Date(scope.startTimeMs.getTime()));
	                scope.entityView.startTimeMs = scope.startTimeMs.getTime();
	            }
	        }
	
	        scope.onEntityViewIdCopied = function () {
	            toast.showSuccess($translate.instant('entity-view.idCopiedMessage'), 750, angular.element(element).parent().parent(), 'bottom left');
	        };
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            entityView: '=',
	            isEdit: '=',
	            entityViewScope: '=',
	            theForm: '=',
	            onAssignToCustomer: '&',
	            onMakePublic: '&',
	            onUnassignFromCustomer: '&',
	            onDeleteEntityView: '&'
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityViewRoutes.$inject = ["$stateProvider", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityViewRoutes;
	
	var _entityViewsTpl = __webpack_require__(1456);
	
	var _entityViewsTpl2 = _interopRequireDefault(_entityViewsTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function EntityViewRoutes($stateProvider, types) {
	    $stateProvider.state('home.entityViews', {
	        url: '/entityViews',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "content@home": {
	                templateUrl: _entityViewsTpl2.default,
	                controller: 'EntityViewController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            entityViewsType: 'tenant',
	            searchEnabled: true,
	            searchByEntitySubtype: true,
	            searchEntityType: types.entityType.entityView,
	            pageTitle: 'entity-view.entity-views'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "view_quilt", "label": "entity-view.entity-views"}'
	        }
	    }).state('home.customers.entityViews', {
	        url: '/:customerId/entityViews',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _entityViewsTpl2.default,
	                controllerAs: 'vm',
	                controller: 'EntityViewController'
	            }
	        },
	        data: {
	            entityViewsType: 'customer',
	            searchEnabled: true,
	            searchByEntitySubtype: true,
	            searchEntityType: types.entityType.entityView,
	            pageTitle: 'customer.entity-views'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "view_quilt", "label": "{{ vm.customerEntityViewsTitle }}", "translate": "false"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _grid = __webpack_require__(74);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _entityView = __webpack_require__(505);
	
	var _entityView2 = _interopRequireDefault(_entityView);
	
	var _customer = __webpack_require__(112);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _entityView3 = __webpack_require__(1247);
	
	var _entityView4 = _interopRequireDefault(_entityView3);
	
	var _entityView5 = __webpack_require__(1245);
	
	var _assignToCustomer = __webpack_require__(1244);
	
	var _assignToCustomer2 = _interopRequireDefault(_assignToCustomer);
	
	var _addEntityViewsToCustomer = __webpack_require__(1243);
	
	var _addEntityViewsToCustomer2 = _interopRequireDefault(_addEntityViewsToCustomer);
	
	var _entityView6 = __webpack_require__(1246);
	
	var _entityView7 = _interopRequireDefault(_entityView6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.entityView', [_angularUiRouter2.default, _grid2.default, _user2.default, _entityView2.default, _customer2.default]).config(_entityView4.default).controller('EntityViewController', _entityView5.EntityViewController).controller('EntityViewCardController', _entityView5.EntityViewCardController).controller('AssignEntityViewToCustomerController', _assignToCustomer2.default).controller('AddEntityViewsToCustomerController', _addEntityViewsToCustomer2.default).directive('tbEntityView', _entityView7.default).name;

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	'use strict';
	
	AliasesEntitySelectPanelController.$inject = ["mdPanelRef", "$scope", "$filter", "types", "aliasController", "onEntityAliasesUpdate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AliasesEntitySelectPanelController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AliasesEntitySelectPanelController(mdPanelRef, $scope, $filter, types, aliasController, onEntityAliasesUpdate) {
	
	    var vm = this;
	    vm._mdPanelRef = mdPanelRef;
	    vm.aliasController = aliasController;
	    vm.onEntityAliasesUpdate = onEntityAliasesUpdate;
	    vm.entityAliases = {};
	    vm.entityAliasesInfo = {};
	
	    vm.currentAliasEntityChanged = currentAliasEntityChanged;
	
	    var allEntityAliases = vm.aliasController.getEntityAliases();
	    for (var aliasId in allEntityAliases) {
	        var aliasInfo = vm.aliasController.getInstantAliasInfo(aliasId);
	        if (aliasInfo && !aliasInfo.resolveMultiple && aliasInfo.currentEntity && aliasInfo.resolvedEntities.length > 1) {
	            vm.entityAliasesInfo[aliasId] = angular.copy(aliasInfo);
	            vm.entityAliasesInfo[aliasId].selectedId = aliasInfo.currentEntity.id;
	        }
	    }
	
	    function currentAliasEntityChanged(aliasId, selectedId) {
	        var resolvedEntities = vm.entityAliasesInfo[aliasId].resolvedEntities;
	        var selected = $filter('filter')(resolvedEntities, { id: selectedId });
	        if (selected && selected.length) {
	            vm.aliasController.updateCurrentAliasEntity(aliasId, selected[0]);
	            if (onEntityAliasesUpdate) {
	                onEntityAliasesUpdate();
	            }
	        }
	    }
	}

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AliasesEntitySelectDirective.$inject = ["$compile", "$templateCache", "$mdMedia", "types", "$mdPanel", "$document", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AliasesEntitySelectDirective;
	
	__webpack_require__(787);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _aliasesEntitySelectButtonTpl = __webpack_require__(1457);
	
	var _aliasesEntitySelectButtonTpl2 = _interopRequireDefault(_aliasesEntitySelectButtonTpl);
	
	var _aliasesEntitySelectPanelTpl = __webpack_require__(1458);
	
	var _aliasesEntitySelectPanelTpl2 = _interopRequireDefault(_aliasesEntitySelectPanelTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable angular/angularelement */
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function AliasesEntitySelectDirective($compile, $templateCache, $mdMedia, types, $mdPanel, $document, $translate) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        /* tbAliasesEntitySelect (ng-model)
	         * {
	         *    "aliasId": {
	         *        alias: alias,
	         *        entityType: entityType,
	         *        entityId: entityId
	         *    }
	         * }
	         */
	
	        var template = $templateCache.get(_aliasesEntitySelectButtonTpl2.default);
	
	        scope.tooltipDirection = angular.isDefined(attrs.tooltipDirection) ? attrs.tooltipDirection : 'top';
	
	        element.html(template);
	
	        scope.openEditMode = function (event) {
	            if (scope.disabled) {
	                return;
	            }
	            var position;
	            var panelHeight = $mdMedia('min-height: 350px') ? 250 : 150;
	            var panelWidth = 300;
	            var offset = element[0].getBoundingClientRect();
	            var bottomY = offset.bottom - (0, _jquery2.default)(window).scrollTop(); //eslint-disable-line
	            var leftX = offset.left - (0, _jquery2.default)(window).scrollLeft(); //eslint-disable-line
	            var yPosition;
	            var xPosition;
	            if (bottomY + panelHeight > (0, _jquery2.default)(window).height()) {
	                //eslint-disable-line
	                yPosition = $mdPanel.yPosition.ABOVE;
	            } else {
	                yPosition = $mdPanel.yPosition.BELOW;
	            }
	            if (leftX + panelWidth > (0, _jquery2.default)(window).width()) {
	                //eslint-disable-line
	                xPosition = $mdPanel.xPosition.CENTER;
	            } else {
	                xPosition = $mdPanel.xPosition.ALIGN_START;
	            }
	            position = $mdPanel.newPanelPosition().relativeTo(element).addPanelPosition(xPosition, yPosition);
	            var config = {
	                attachTo: angular.element($document[0].body),
	                controller: 'AliasesEntitySelectPanelController',
	                controllerAs: 'vm',
	                templateUrl: _aliasesEntitySelectPanelTpl2.default,
	                panelClass: 'tb-aliases-entity-select-panel',
	                position: position,
	                fullscreen: false,
	                locals: {
	                    'aliasController': scope.aliasController,
	                    'onEntityAliasesUpdate': function onEntityAliasesUpdate() {
	                        scope.updateView();
	                    }
	                },
	                openFrom: event,
	                clickOutsideToClose: true,
	                escapeToClose: true,
	                focusOnOpen: false
	            };
	            $mdPanel.open(config);
	        };
	
	        scope.$on('entityAliasesChanged', function () {
	            scope.updateView();
	        });
	
	        scope.$on('entityAliasResolved', function () {
	            scope.updateView();
	        });
	
	        scope.updateView = function () {
	            updateDisplayValue();
	        };
	
	        function updateDisplayValue() {
	            var displayValue;
	            var singleValue = true;
	            var currentAliasId;
	            var entityAliases = scope.aliasController.getEntityAliases();
	            for (var aliasId in entityAliases) {
	                var entityAlias = entityAliases[aliasId];
	                if (!entityAlias.filter.resolveMultiple) {
	                    var resolvedAlias = scope.aliasController.getInstantAliasInfo(aliasId);
	                    if (resolvedAlias && resolvedAlias.currentEntity) {
	                        if (!currentAliasId) {
	                            currentAliasId = aliasId;
	                        } else {
	                            singleValue = false;
	                            break;
	                        }
	                    }
	                }
	            }
	            if (singleValue && currentAliasId) {
	                var aliasInfo = scope.aliasController.getInstantAliasInfo(currentAliasId);
	                displayValue = aliasInfo.currentEntity.name;
	            } else {
	                displayValue = $translate.instant('entity.entities');
	            }
	            scope.displayValue = displayValue;
	        }
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        scope: {
	            aliasController: '='
	        },
	        link: linker
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityAliasDialogController.$inject = ["$scope", "$mdDialog", "$q", "$filter", "utils", "entityService", "types", "isAdd", "allowedEntityTypes", "entityAliases", "alias"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityAliasDialogController;
	
	__webpack_require__(788);
	
	/*@ngInject*/
	function EntityAliasDialogController($scope, $mdDialog, $q, $filter, utils, entityService, types, isAdd, allowedEntityTypes, entityAliases, alias) {
	
	    var vm = this;
	
	    vm.types = types;
	    vm.isAdd = isAdd;
	    vm.allowedEntityTypes = allowedEntityTypes;
	    if (angular.isArray(entityAliases)) {
	        vm.entityAliases = entityAliases;
	    } else {
	        vm.entityAliases = [];
	        for (var aliasId in entityAliases) {
	            vm.entityAliases.push(entityAliases[aliasId]);
	        }
	    }
	    if (vm.isAdd && !alias) {
	        vm.alias = {
	            alias: '',
	            filter: {
	                resolveMultiple: false
	            }
	        };
	    } else {
	        vm.alias = alias;
	    }
	
	    vm.cancel = cancel;
	    vm.save = save;
	
	    $scope.$watch('vm.alias.alias', function (newAlias) {
	        if (newAlias) {
	            var valid = true;
	            var result = $filter('filter')(vm.entityAliases, { alias: newAlias }, true);
	            if (result && result.length) {
	                if (vm.isAdd || vm.alias.id != result[0].id) {
	                    valid = false;
	                }
	            }
	            $scope.theForm.aliasName.$setValidity('duplicateAliasName', valid);
	        }
	    });
	
	    $scope.$watch('theForm.$pristine', function () {
	        if ($scope.theForm && !$scope.theForm.$pristine) {
	            $scope.theForm.$setValidity('entityFilter', true);
	        }
	    });
	
	    function validate() {
	        var deferred = $q.defer();
	        var validationResult = {
	            entity: null,
	            stateEntity: false
	        };
	        entityService.resolveAliasFilter(vm.alias.filter, null, 1, true).then(function success(result) {
	            validationResult.stateEntity = result.stateEntity;
	            var entities = result.entities;
	            if (entities.length) {
	                validationResult.entity = entities[0];
	            }
	            deferred.resolve(validationResult);
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function save() {
	        $scope.theForm.$setPristine();
	        validate().then(function success() {
	            if (vm.isAdd) {
	                vm.alias.id = utils.guid();
	            }
	            $mdDialog.hide(vm.alias);
	        }, function fail() {
	            $scope.theForm.$setValidity('entityFilter', false);
	        });
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityAliasesController.$inject = ["utils", "entityService", "toast", "$scope", "$mdDialog", "$document", "$q", "$translate", "types", "config"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityAliasesController;
	
	__webpack_require__(789);
	
	var _entityAliasDialogTpl = __webpack_require__(233);
	
	var _entityAliasDialogTpl2 = _interopRequireDefault(_entityAliasDialogTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function EntityAliasesController(utils, entityService, toast, $scope, $mdDialog, $document, $q, $translate, types, config) {
	
	    var vm = this;
	
	    vm.types = types;
	    vm.entityAliases = [];
	    vm.title = config.customTitle ? config.customTitle : 'entity.aliases';
	    vm.disableAdd = config.disableAdd;
	    vm.aliasToWidgetsMap = {};
	    vm.allowedEntityTypes = config.allowedEntityTypes;
	
	    vm.addAlias = addAlias;
	    vm.editAlias = editAlias;
	    vm.removeAlias = removeAlias;
	
	    vm.cancel = cancel;
	    vm.save = save;
	
	    initController();
	
	    function initController() {
	        var aliasId;
	        if (config.widgets) {
	            var widgetsTitleList, widget;
	            if (config.isSingleWidget && config.widgets.length == 1) {
	                widget = config.widgets[0];
	                widgetsTitleList = [widget.config.title];
	                for (aliasId in config.entityAliases) {
	                    vm.aliasToWidgetsMap[aliasId] = widgetsTitleList;
	                }
	            } else {
	                for (var w in config.widgets) {
	                    widget = config.widgets[w];
	                    if (widget.type === types.widgetType.rpc.value) {
	                        if (widget.config.targetDeviceAliasIds && widget.config.targetDeviceAliasIds.length > 0) {
	                            var targetDeviceAliasId = widget.config.targetDeviceAliasIds[0];
	                            widgetsTitleList = vm.aliasToWidgetsMap[targetDeviceAliasId];
	                            if (!widgetsTitleList) {
	                                widgetsTitleList = [];
	                                vm.aliasToWidgetsMap[targetDeviceAliasId] = widgetsTitleList;
	                            }
	                            widgetsTitleList.push(widget.config.title);
	                        }
	                    } else {
	                        var datasources = utils.validateDatasources(widget.config.datasources);
	                        for (var i = 0; i < datasources.length; i++) {
	                            var datasource = datasources[i];
	                            if (datasource.type === types.datasourceType.entity && datasource.entityAliasId) {
	                                widgetsTitleList = vm.aliasToWidgetsMap[datasource.entityAliasId];
	                                if (!widgetsTitleList) {
	                                    widgetsTitleList = [];
	                                    vm.aliasToWidgetsMap[datasource.entityAliasId] = widgetsTitleList;
	                                }
	                                widgetsTitleList.push(widget.config.title);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        for (aliasId in config.entityAliases) {
	            var entityAlias = config.entityAliases[aliasId];
	            var filter = entityAlias.filter;
	            if (!filter) {
	                filter = {
	                    resolveMultiple: false
	                };
	            }
	            if (!filter.resolveMultiple) {
	                filter.resolveMultiple = false;
	            }
	            var result = { id: aliasId, alias: entityAlias.alias, filter: filter };
	            vm.entityAliases.push(result);
	        }
	    }
	
	    function addAlias($event) {
	        openAliasDialog($event);
	    }
	
	    function editAlias($event, entityAlias) {
	        openAliasDialog($event, entityAlias);
	    }
	
	    function openAliasDialog($event, entityAlias) {
	        var isAdd = entityAlias ? false : true;
	        var aliasIndex;
	        if (!isAdd) {
	            aliasIndex = vm.entityAliases.indexOf(entityAlias);
	        }
	        $mdDialog.show({
	            controller: 'EntityAliasDialogController',
	            controllerAs: 'vm',
	            templateUrl: _entityAliasDialogTpl2.default,
	            locals: {
	                isAdd: isAdd,
	                allowedEntityTypes: vm.allowedEntityTypes,
	                entityAliases: vm.entityAliases,
	                alias: isAdd ? null : angular.copy(entityAlias)
	            },
	            parent: angular.element($document[0].body),
	            fullscreen: true,
	            skipHide: true,
	            targetEvent: $event
	        }).then(function (alias) {
	            if (isAdd) {
	                vm.entityAliases.push(alias);
	            } else {
	                vm.entityAliases[aliasIndex] = alias;
	            }
	            if ($scope.theForm) {
	                $scope.theForm.$setDirty();
	            }
	        }, function () {});
	    }
	
	    function removeAlias($event, entityAlias) {
	        var index = vm.entityAliases.indexOf(entityAlias);
	        if (index > -1) {
	            var widgetsTitleList = vm.aliasToWidgetsMap[entityAlias.id];
	            if (widgetsTitleList) {
	                var widgetsListHtml = '';
	                for (var t in widgetsTitleList) {
	                    widgetsListHtml += '<br/>\'' + widgetsTitleList[t] + '\'';
	                }
	                var alert = $mdDialog.alert().parent(angular.element($document[0].body)).clickOutsideToClose(true).title($translate.instant('entity.unable-delete-entity-alias-title')).htmlContent($translate.instant('entity.unable-delete-entity-alias-text', { entityAlias: entityAlias.alias, widgetsList: widgetsListHtml })).ariaLabel($translate.instant('entity.unable-delete-entity-alias-title')).ok($translate.instant('action.close')).targetEvent($event);
	                alert._options.skipHide = true;
	                alert._options.fullscreen = true;
	
	                $mdDialog.show(alert);
	            } else {
	                vm.entityAliases.splice(index, 1);
	                if ($scope.theForm) {
	                    $scope.theForm.$setDirty();
	                }
	            }
	        }
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function save() {
	
	        var entityAliases = {};
	        var uniqueAliasList = {};
	
	        var valid = true;
	        var message, aliasId, alias, filter;
	
	        for (var i = 0; i < vm.entityAliases.length; i++) {
	            aliasId = vm.entityAliases[i].id;
	            alias = vm.entityAliases[i].alias;
	            filter = vm.entityAliases[i].filter;
	            if (uniqueAliasList[alias]) {
	                valid = false;
	                message = $translate.instant('entity.duplicate-alias-error', { alias: alias });
	                break;
	            } else if (!filter || !filter.type) {
	                valid = false;
	                message = $translate.instant('entity.missing-entity-filter-error', { alias: alias });
	                break;
	            } else {
	                uniqueAliasList[alias] = alias;
	                entityAliases[aliasId] = { id: aliasId, alias: alias, filter: filter };
	            }
	        }
	        if (valid) {
	            $scope.theForm.$setPristine();
	            $mdDialog.hide(entityAliases);
	        } else {
	            toast.showError(message);
	        }
	    }
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	'use strict';
	
	AddAttributeDialogController.$inject = ["$scope", "$mdDialog", "types", "attributeService", "entityType", "entityId", "attributeScope"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AddAttributeDialogController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function AddAttributeDialogController($scope, $mdDialog, types, attributeService, entityType, entityId, attributeScope) {
	
	    var vm = this;
	
	    vm.attribute = {};
	
	    vm.valueTypes = types.valueType;
	
	    vm.valueType = types.valueType.string;
	
	    vm.add = add;
	    vm.cancel = cancel;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function add() {
	        $scope.theForm.$setPristine();
	        attributeService.saveEntityAttributes(entityType, entityId, attributeScope, [vm.attribute]).then(function success() {
	            $mdDialog.hide();
	        });
	    }
	
	    $scope.$watch('vm.valueType', function () {
	        if (vm.valueType === types.valueType.boolean) {
	            vm.attribute.value = false;
	        } else {
	            vm.attribute.value = null;
	        }
	    });
	}

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AddWidgetToDashboardDialogController.$inject = ["$scope", "$mdDialog", "$state", "$q", "$document", "dashboardUtils", "utils", "types", "itembuffer", "dashboardService", "entityId", "entityType", "entityName", "widget"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AddWidgetToDashboardDialogController;
	
	var _selectTargetStateTpl = __webpack_require__(1443);
	
	var _selectTargetStateTpl2 = _interopRequireDefault(_selectTargetStateTpl);
	
	var _selectTargetLayoutTpl = __webpack_require__(521);
	
	var _selectTargetLayoutTpl2 = _interopRequireDefault(_selectTargetLayoutTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function AddWidgetToDashboardDialogController($scope, $mdDialog, $state, $q, $document, dashboardUtils, utils, types, itembuffer, dashboardService, entityId, entityType, entityName, widget) {
	
	    var vm = this;
	
	    vm.widget = widget;
	    vm.dashboardId = null;
	    vm.addToDashboardType = 0;
	    vm.newDashboard = {};
	    vm.openDashboard = false;
	
	    vm.add = add;
	    vm.cancel = cancel;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function selectTargetState($event, dashboard) {
	        var deferred = $q.defer();
	        var states = dashboard.configuration.states;
	        var stateIds = Object.keys(states);
	        if (stateIds.length > 1) {
	            $mdDialog.show({
	                controller: 'SelectTargetStateController',
	                controllerAs: 'vm',
	                templateUrl: _selectTargetStateTpl2.default,
	                parent: angular.element($document[0].body),
	                locals: {
	                    states: states
	                },
	                fullscreen: true,
	                skipHide: true,
	                targetEvent: $event
	            }).then(function success(stateId) {
	                deferred.resolve(stateId);
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            deferred.resolve(stateIds[0]);
	        }
	        return deferred.promise;
	    }
	
	    function selectTargetLayout($event, dashboard, targetState) {
	        var deferred = $q.defer();
	        var layouts = dashboard.configuration.states[targetState].layouts;
	        var layoutIds = Object.keys(layouts);
	        if (layoutIds.length > 1) {
	            $mdDialog.show({
	                controller: 'SelectTargetLayoutController',
	                controllerAs: 'vm',
	                templateUrl: _selectTargetLayoutTpl2.default,
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                skipHide: true,
	                targetEvent: $event
	            }).then(function success(layoutId) {
	                deferred.resolve(layoutId);
	            }, function fail() {
	                deferred.reject();
	            });
	        } else {
	            deferred.resolve(layoutIds[0]);
	        }
	        return deferred.promise;
	    }
	
	    function add($event) {
	        if (vm.addToDashboardType === 0) {
	            dashboardService.getDashboard(vm.dashboardId).then(function success(dashboard) {
	                dashboard = dashboardUtils.validateAndUpdateDashboard(dashboard);
	                selectTargetState($event, dashboard).then(function (targetState) {
	                    selectTargetLayout($event, dashboard, targetState).then(function (targetLayout) {
	                        addWidgetToDashboard(dashboard, targetState, targetLayout);
	                    });
	                });
	            }, function fail() {});
	        } else {
	            addWidgetToDashboard(vm.newDashboard, 'default', 'main');
	        }
	    }
	
	    function addWidgetToDashboard(theDashboard, targetState, targetLayout) {
	        var aliasesInfo = {
	            datasourceAliases: {},
	            targetDeviceAliases: {}
	        };
	        aliasesInfo.datasourceAliases[0] = {
	            alias: entityName,
	            filter: dashboardUtils.createSingleEntityFilter(entityType, entityId)
	        };
	        itembuffer.addWidgetToDashboard(theDashboard, targetState, targetLayout, vm.widget, aliasesInfo, null, 48, null, -1, -1).then(function (theDashboard) {
	            dashboardService.saveDashboard(theDashboard).then(function success(dashboard) {
	                $scope.theForm.$setPristine();
	                $mdDialog.hide();
	                if (vm.openDashboard) {
	                    var stateParams = {
	                        dashboardId: dashboard.id.id
	                    };
	                    var stateIds = Object.keys(dashboard.configuration.states);
	                    var stateIndex = stateIds.indexOf(targetState);
	                    if (stateIndex > 0) {
	                        stateParams.state = utils.objToBase64([{ id: targetState, params: {} }]);
	                    }
	                    $state.go('home.dashboards.dashboard', stateParams);
	                }
	            });
	        });
	    }
	}

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AttributeTableDirective.$inject = ["$compile", "$templateCache", "$rootScope", "$q", "$mdEditDialog", "$mdDialog", "$mdUtil", "$document", "$translate", "$filter", "$timeout", "utils", "types", "dashboardUtils", "entityService", "attributeService", "widgetService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AttributeTableDirective;
	
	__webpack_require__(190);
	
	__webpack_require__(790);
	
	var _attributeTableTpl = __webpack_require__(1461);
	
	var _attributeTableTpl2 = _interopRequireDefault(_attributeTableTpl);
	
	var _addAttributeDialogTpl = __webpack_require__(1459);
	
	var _addAttributeDialogTpl2 = _interopRequireDefault(_addAttributeDialogTpl);
	
	var _addWidgetToDashboardDialogTpl = __webpack_require__(1460);
	
	var _addWidgetToDashboardDialogTpl2 = _interopRequireDefault(_addWidgetToDashboardDialogTpl);
	
	var _editAttributeValueTpl = __webpack_require__(1462);
	
	var _editAttributeValueTpl2 = _interopRequireDefault(_editAttributeValueTpl);
	
	var _editAttributeValue = __webpack_require__(1256);
	
	var _editAttributeValue2 = _interopRequireDefault(_editAttributeValue);
	
	var _aliasController = __webpack_require__(227);
	
	var _aliasController2 = _interopRequireDefault(_aliasController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function AttributeTableDirective($compile, $templateCache, $rootScope, $q, $mdEditDialog, $mdDialog, $mdUtil, $document, $translate, $filter, $timeout, utils, types, dashboardUtils, entityService, attributeService, widgetService) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        var template = $templateCache.get(_attributeTableTpl2.default);
	
	        element.html(template);
	
	        var getAttributeScopeByValue = function getAttributeScopeByValue(attributeScopeValue) {
	            if (scope.types.latestTelemetry.value === attributeScopeValue) {
	                return scope.types.latestTelemetry;
	            }
	            for (var attrScope in scope.attributeScopes) {
	                if (scope.attributeScopes[attrScope].value === attributeScopeValue) {
	                    return scope.attributeScopes[attrScope];
	                }
	            }
	        };
	
	        scope.types = types;
	
	        scope.entityType = attrs.entityType;
	
	        if (scope.entityType === types.entityType.device || scope.entityType === types.entityType.entityView) {
	            scope.attributeScopes = types.attributesScope;
	            scope.attributeScopeSelectionReadonly = false;
	        } else {
	            scope.attributeScopes = {};
	            scope.attributeScopes.server = types.attributesScope.server;
	            scope.attributeScopeSelectionReadonly = true;
	        }
	
	        scope.attributeScope = getAttributeScopeByValue(attrs.defaultAttributeScope);
	
	        if (scope.entityType != types.entityType.device) {
	            if (scope.attributeScope != types.latestTelemetry) {
	                scope.attributeScope = scope.attributeScopes.server;
	            }
	        }
	
	        scope.attributes = {
	            count: 0,
	            data: []
	        };
	
	        scope.selectedAttributes = [];
	        scope.mode = 'default'; // 'widget'
	        scope.subscriptionId = null;
	
	        scope.query = {
	            order: 'key',
	            limit: 5,
	            page: 1,
	            search: null
	        };
	
	        scope.$watch("entityId", function (newVal) {
	            if (newVal) {
	                scope.resetFilter();
	                scope.getEntityAttributes(false, true);
	            }
	        });
	
	        scope.$watch("attributeScope", function (newVal, prevVal) {
	            if (newVal && !angular.equals(newVal, prevVal)) {
	                scope.mode = 'default';
	                scope.query.search = null;
	                scope.selectedAttributes = [];
	                scope.getEntityAttributes(false, true);
	            }
	        });
	
	        scope.resetFilter = function () {
	            scope.mode = 'default';
	            scope.query.search = null;
	            scope.selectedAttributes = [];
	            scope.attributeScope = getAttributeScopeByValue(attrs.defaultAttributeScope);
	        };
	
	        scope.enterFilterMode = function (event) {
	            var $button = angular.element(event.currentTarget);
	            var $toolbarsContainer = $button.closest('.toolbarsContainer');
	
	            scope.query.search = '';
	
	            $timeout(function () {
	                $toolbarsContainer.find('.searchInput').focus();
	            });
	        };
	
	        scope.exitFilterMode = function () {
	            scope.query.search = null;
	            scope.getEntityAttributes();
	        };
	
	        scope.$watch("query.search", function (newVal, prevVal) {
	            if (!angular.equals(newVal, prevVal) && scope.query.search != null) {
	                scope.getEntityAttributes();
	            }
	        });
	
	        function success(attributes, update, apply) {
	            scope.attributes = attributes;
	            if (!update) {
	                scope.selectedAttributes = [];
	            }
	            if (apply) {
	                scope.$digest();
	            }
	        }
	
	        scope.onReorder = function () {
	            scope.getEntityAttributes(false, false);
	        };
	
	        scope.onPaginate = function () {
	            scope.getEntityAttributes(false, false);
	        };
	
	        scope.getEntityAttributes = function (forceUpdate, reset) {
	            if (scope.attributesDeferred) {
	                scope.attributesDeferred.resolve();
	            }
	            if (scope.entityId && scope.entityType && scope.attributeScope) {
	                if (reset) {
	                    scope.attributes = {
	                        count: 0,
	                        data: []
	                    };
	                }
	                scope.checkSubscription();
	                scope.attributesDeferred = attributeService.getEntityAttributes(scope.entityType, scope.entityId, scope.attributeScope.value, scope.query, function (attributes, update, apply) {
	                    success(attributes, update || forceUpdate, apply);
	                });
	            } else {
	                var deferred = $q.defer();
	                scope.attributesDeferred = deferred;
	                success({
	                    count: 0,
	                    data: []
	                });
	                deferred.resolve();
	            }
	        };
	
	        scope.checkSubscription = function () {
	            var newSubscriptionId = null;
	            if (scope.entityId && scope.entityType && scope.attributeScope.clientSide && scope.mode != 'widget') {
	                newSubscriptionId = attributeService.subscribeForEntityAttributes(scope.entityType, scope.entityId, scope.attributeScope.value);
	            }
	            if (scope.subscriptionId && scope.subscriptionId != newSubscriptionId) {
	                attributeService.unsubscribeForEntityAttributes(scope.subscriptionId);
	            }
	            scope.subscriptionId = newSubscriptionId;
	        };
	
	        scope.$on('$destroy', function () {
	            if (scope.subscriptionId) {
	                attributeService.unsubscribeForEntityAttributes(scope.subscriptionId);
	            }
	        });
	
	        scope.editAttribute = function ($event, attribute) {
	            if (!scope.attributeScope.clientSide) {
	                $event.stopPropagation();
	                $mdEditDialog.show({
	                    controller: _editAttributeValue2.default,
	                    templateUrl: _editAttributeValueTpl2.default,
	                    locals: { attributeValue: attribute.value,
	                        save: function save(model) {
	                            var updatedAttribute = angular.copy(attribute);
	                            updatedAttribute.value = model.value;
	                            attributeService.saveEntityAttributes(scope.entityType, scope.entityId, scope.attributeScope.value, [updatedAttribute]).then(function success() {
	                                scope.getEntityAttributes();
	                            });
	                        } },
	                    targetEvent: $event
	                });
	            }
	        };
	
	        scope.addAttribute = function ($event) {
	            if (!scope.attributeScope.clientSide) {
	                $event.stopPropagation();
	                $mdDialog.show({
	                    controller: 'AddAttributeDialogController',
	                    controllerAs: 'vm',
	                    templateUrl: _addAttributeDialogTpl2.default,
	                    parent: angular.element($document[0].body),
	                    locals: { entityType: scope.entityType, entityId: scope.entityId, attributeScope: scope.attributeScope.value },
	                    fullscreen: true,
	                    targetEvent: $event
	                }).then(function () {
	                    scope.getEntityAttributes();
	                });
	            }
	        };
	
	        scope.deleteAttributes = function ($event) {
	            if (!scope.attributeScope.clientSide) {
	                $event.stopPropagation();
	                var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('attribute.delete-attributes-title', { count: scope.selectedAttributes.length }, 'messageformat')).htmlContent($translate.instant('attribute.delete-attributes-text')).ariaLabel($translate.instant('attribute.delete-attributes')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	                $mdDialog.show(confirm).then(function () {
	                    attributeService.deleteEntityAttributes(scope.entityType, scope.entityId, scope.attributeScope.value, scope.selectedAttributes).then(function success() {
	                        scope.selectedAttributes = [];
	                        scope.getEntityAttributes();
	                    });
	                });
	            }
	        };
	
	        scope.nextWidget = function () {
	            $mdUtil.nextTick(function () {
	                if (scope.widgetsCarousel.index < scope.widgetsList.length - 1) {
	                    scope.widgetsCarousel.index++;
	                }
	            });
	        };
	
	        scope.prevWidget = function () {
	            $mdUtil.nextTick(function () {
	                if (scope.widgetsCarousel.index > 0) {
	                    scope.widgetsCarousel.index--;
	                }
	            });
	        };
	
	        scope.enterWidgetMode = function () {
	
	            if (scope.widgetsIndexWatch) {
	                scope.widgetsIndexWatch();
	                scope.widgetsIndexWatch = null;
	            }
	
	            if (scope.widgetsBundleWatch) {
	                scope.widgetsBundleWatch();
	                scope.widgetsBundleWatch = null;
	            }
	
	            scope.mode = 'widget';
	            scope.checkSubscription();
	            scope.widgetsList = [];
	            scope.widgetsListCache = [];
	            scope.widgetsLoaded = false;
	            scope.widgetsCarousel = {
	                index: 0
	            };
	            scope.widgetsBundle = null;
	            scope.firstBundle = true;
	            scope.selectedWidgetsBundleAlias = types.systemBundleAlias.cards;
	
	            var entityAlias = {
	                id: utils.guid(),
	                alias: scope.entityName,
	                filter: dashboardUtils.createSingleEntityFilter(scope.entityType, scope.entityId)
	            };
	            var entitiAliases = {};
	            entitiAliases[entityAlias.id] = entityAlias;
	
	            var stateController = {
	                getStateParams: function getStateParams() {
	                    return {};
	                }
	            };
	            scope.aliasController = new _aliasController2.default(scope, $q, $filter, utils, types, entityService, stateController, entitiAliases);
	
	            var dataKeyType = scope.attributeScope === types.latestTelemetry ? types.dataKeyType.timeseries : types.dataKeyType.attribute;
	
	            var datasource = {
	                type: types.datasourceType.entity,
	                entityAliasId: entityAlias.id,
	                dataKeys: []
	            };
	            var i = 0;
	            for (var attr = 0; attr < scope.selectedAttributes.length; attr++) {
	                var attribute = scope.selectedAttributes[attr];
	                var dataKey = {
	                    name: attribute.key,
	                    label: attribute.key,
	                    type: dataKeyType,
	                    color: utils.getMaterialColor(i),
	                    settings: {},
	                    _hash: Math.random()
	                };
	                datasource.dataKeys.push(dataKey);
	                i++;
	            }
	
	            scope.widgetsIndexWatch = scope.$watch('widgetsCarousel.index', function (newVal, prevVal) {
	                if (scope.mode === 'widget' && newVal != prevVal) {
	                    var index = scope.widgetsCarousel.index;
	                    for (var i = 0; i < scope.widgetsList.length; i++) {
	                        scope.widgetsList[i].splice(0, scope.widgetsList[i].length);
	                        if (i === index) {
	                            scope.widgetsList[i].push(scope.widgetsListCache[i][0]);
	                        }
	                    }
	                }
	            });
	
	            scope.widgetsBundleWatch = scope.$watch('widgetsBundle', function (newVal, prevVal) {
	                if (scope.mode === 'widget' && (scope.firstBundle === true || newVal != prevVal)) {
	                    scope.widgetsList = [];
	                    scope.widgetsListCache = [];
	                    scope.widgetsCarousel.index = 0;
	                    scope.firstBundle = false;
	                    if (scope.widgetsBundle) {
	                        scope.widgetsLoaded = false;
	                        var bundleAlias = scope.widgetsBundle.alias;
	                        var isSystem = scope.widgetsBundle.tenantId.id === types.id.nullUid;
	                        widgetService.getBundleWidgetTypes(scope.widgetsBundle.alias, isSystem).then(function success(widgetTypes) {
	
	                            widgetTypes = $filter('orderBy')(widgetTypes, ['-descriptor.type', '-createdTime']);
	
	                            for (var i = 0; i < widgetTypes.length; i++) {
	                                var widgetType = widgetTypes[i];
	                                var widgetInfo = widgetService.toWidgetInfo(widgetType);
	                                if (widgetInfo.type !== types.widgetType.static.value) {
	                                    var sizeX = widgetInfo.sizeX * 2;
	                                    var sizeY = widgetInfo.sizeY * 2;
	                                    var col = Math.floor(Math.max(0, (20 - sizeX) / 2));
	                                    var widget = {
	                                        isSystemType: isSystem,
	                                        bundleAlias: bundleAlias,
	                                        typeAlias: widgetInfo.alias,
	                                        type: widgetInfo.type,
	                                        title: widgetInfo.widgetName,
	                                        sizeX: sizeX,
	                                        sizeY: sizeY,
	                                        row: 0,
	                                        col: col,
	                                        config: angular.fromJson(widgetInfo.defaultConfig)
	                                    };
	
	                                    widget.config.title = widgetInfo.widgetName;
	                                    widget.config.datasources = [datasource];
	                                    var length;
	                                    if (scope.attributeScope === types.latestTelemetry && widgetInfo.type !== types.widgetType.rpc.value) {
	                                        length = scope.widgetsListCache.push([widget]);
	                                        scope.widgetsList.push(length === 1 ? [widget] : []);
	                                    } else if (widgetInfo.type === types.widgetType.latest.value) {
	                                        length = scope.widgetsListCache.push([widget]);
	                                        scope.widgetsList.push(length === 1 ? [widget] : []);
	                                    }
	                                }
	                            }
	                            scope.widgetsLoaded = true;
	                        });
	                    }
	                }
	            });
	        };
	
	        scope.exitWidgetMode = function () {
	            if (scope.widgetsBundleWatch) {
	                scope.widgetsBundleWatch();
	                scope.widgetsBundleWatch = null;
	            }
	            if (scope.widgetsIndexWatch) {
	                scope.widgetsIndexWatch();
	                scope.widgetsIndexWatch = null;
	            }
	            scope.selectedWidgetsBundleAlias = null;
	            scope.mode = 'default';
	            scope.getEntityAttributes(true);
	        };
	
	        scope.addWidgetToDashboard = function ($event) {
	            if (scope.mode === 'widget' && scope.widgetsListCache.length > 0) {
	                var widget = scope.widgetsListCache[scope.widgetsCarousel.index][0];
	                $event.stopPropagation();
	                $mdDialog.show({
	                    controller: 'AddWidgetToDashboardDialogController',
	                    controllerAs: 'vm',
	                    templateUrl: _addWidgetToDashboardDialogTpl2.default,
	                    parent: angular.element($document[0].body),
	                    locals: { entityId: scope.entityId, entityType: scope.entityType, entityName: scope.entityName, widget: angular.copy(widget) },
	                    fullscreen: true,
	                    targetEvent: $event
	                }).then(function () {});
	            }
	        };
	
	        scope.loading = function () {
	            return $rootScope.loading;
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            entityId: '=',
	            entityName: '=',
	            disableAttributeScopeSelection: '@?'
	        }
	    };
	}

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	'use strict';
	
	EditAttributeValueController.$inject = ["$scope", "$q", "$element", "types", "attributeValue", "save"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EditAttributeValueController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function EditAttributeValueController($scope, $q, $element, types, attributeValue, save) {
	
	    $scope.valueTypes = types.valueType;
	
	    $scope.model = {};
	
	    $scope.model.value = attributeValue;
	
	    if ($scope.model.value === true || $scope.model.value === false) {
	        $scope.valueType = types.valueType.boolean;
	    } else if (angular.isNumber($scope.model.value)) {
	        if ($scope.model.value.toString().indexOf('.') == -1) {
	            $scope.valueType = types.valueType.integer;
	        } else {
	            $scope.valueType = types.valueType.double;
	        }
	    } else {
	        $scope.valueType = types.valueType.string;
	    }
	
	    $scope.submit = submit;
	    $scope.dismiss = dismiss;
	
	    function dismiss() {
	        $element.remove();
	    }
	
	    function update() {
	        if ($scope.editDialog.$invalid) {
	            return $q.reject();
	        }
	
	        if (angular.isFunction(save)) {
	            return $q.when(save($scope.model));
	        }
	
	        return $q.resolve();
	    }
	
	    function submit() {
	        update().then(function () {
	            $scope.dismiss();
	        });
	    }
	
	    $scope.$watch('valueType', function (newVal, prevVal) {
	        if (newVal != prevVal) {
	            if ($scope.valueType === types.valueType.boolean) {
	                $scope.model.value = false;
	            } else {
	                $scope.model.value = null;
	            }
	        }
	    });
	}

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityAutocomplete.$inject = ["$compile", "$templateCache", "$q", "$filter", "entityService", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityAutocomplete;
	
	__webpack_require__(791);
	
	var _entityAutocompleteTpl = __webpack_require__(1463);
	
	var _entityAutocompleteTpl2 = _interopRequireDefault(_entityAutocompleteTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function EntityAutocomplete($compile, $templateCache, $q, $filter, entityService, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_entityAutocompleteTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	        scope.entity = null;
	        scope.entitySearchText = '';
	
	        scope.fetchEntities = function (searchText) {
	            var deferred = $q.defer();
	            var limit = 50;
	            if (scope.excludeEntityIds && scope.excludeEntityIds.length) {
	                limit += scope.excludeEntityIds.length;
	            }
	            var targetType = scope.entityType;
	            if (targetType == types.aliasEntityType.current_customer) {
	                targetType = types.entityType.customer;
	            }
	
	            entityService.getEntitiesByNameFilter(targetType, searchText, limit, { ignoreLoading: true }, scope.entitySubtype).then(function success(result) {
	                if (result) {
	                    if (scope.excludeEntityIds && scope.excludeEntityIds.length) {
	                        var entities = [];
	                        result.forEach(function (entity) {
	                            if (scope.excludeEntityIds.indexOf(entity.id.id) == -1) {
	                                entities.push(entity);
	                            }
	                        });
	                        deferred.resolve(entities);
	                    } else {
	                        deferred.resolve(result);
	                    }
	                } else {
	                    deferred.resolve([]);
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	            return deferred.promise;
	        };
	
	        scope.entitySearchTextChanged = function () {};
	
	        scope.updateView = function () {
	            if (!scope.disabled) {
	                ngModelCtrl.$setViewValue(scope.entity ? scope.entity.id.id : null);
	            }
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                var targetType = scope.entityType;
	                if (targetType == types.aliasEntityType.current_customer) {
	                    targetType = types.entityType.customer;
	                }
	                entityService.getEntity(targetType, ngModelCtrl.$viewValue).then(function success(entity) {
	                    scope.entity = entity;
	                }, function fail() {
	                    scope.entity = null;
	                });
	            } else {
	                scope.entity = null;
	            }
	        };
	
	        scope.$watch('entityType', function () {
	            load();
	        });
	
	        scope.$watch('entitySubtype', function () {
	            if (scope.entity && scope.entity.type != scope.entitySubtype) {
	                scope.entity = null;
	                scope.updateView();
	            }
	        });
	
	        scope.$watch('entity', function (newVal, prevVal) {
	            if (!angular.equals(newVal, prevVal)) {
	                scope.updateView();
	            }
	        });
	
	        scope.$watch('disabled', function (newVal, prevVal) {
	            if (!angular.equals(newVal, prevVal)) {
	                scope.updateView();
	            }
	        });
	
	        function load() {
	            switch (scope.entityType) {
	                case types.entityType.asset:
	                    scope.selectEntityText = 'asset.select-asset';
	                    scope.entityText = 'asset.asset';
	                    scope.noEntitiesMatchingText = 'asset.no-assets-matching';
	                    scope.entityRequiredText = 'asset.asset-required';
	                    break;
	                case types.entityType.device:
	                    scope.selectEntityText = 'device.select-device';
	                    scope.entityText = 'device.device';
	                    scope.noEntitiesMatchingText = 'device.no-devices-matching';
	                    scope.entityRequiredText = 'device.device-required';
	                    break;
	                case types.entityType.entityView:
	                    scope.selectEntityText = 'entity-view.select-entity-view';
	                    scope.entityText = 'entity-view.entity-view';
	                    scope.noEntitiesMatchingText = 'entity-view.no-entity-views-matching';
	                    scope.entityRequiredText = 'entity-view.entity-view-required';
	                    break;
	                case types.entityType.rulechain:
	                    scope.selectEntityText = 'rulechain.select-rulechain';
	                    scope.entityText = 'rulechain.rulechain';
	                    scope.noEntitiesMatchingText = 'rulechain.no-rulechains-matching';
	                    scope.entityRequiredText = 'rulechain.rulechain-required';
	                    break;
	                case types.entityType.tenant:
	                    scope.selectEntityText = 'tenant.select-tenant';
	                    scope.entityText = 'tenant.tenant';
	                    scope.noEntitiesMatchingText = 'tenant.no-tenants-matching';
	                    scope.entityRequiredText = 'tenant.tenant-required';
	                    break;
	                case types.entityType.customer:
	                    scope.selectEntityText = 'customer.select-customer';
	                    scope.entityText = 'customer.customer';
	                    scope.noEntitiesMatchingText = 'customer.no-customers-matching';
	                    scope.entityRequiredText = 'customer.customer-required';
	                    break;
	                case types.entityType.user:
	                    scope.selectEntityText = 'user.select-user';
	                    scope.entityText = 'user.user';
	                    scope.noEntitiesMatchingText = 'user.no-users-matching';
	                    scope.entityRequiredText = 'user.user-required';
	                    break;
	                case types.entityType.dashboard:
	                    scope.selectEntityText = 'dashboard.select-dashboard';
	                    scope.entityText = 'dashboard.dashboard';
	                    scope.noEntitiesMatchingText = 'dashboard.no-dashboards-matching';
	                    scope.entityRequiredText = 'dashboard.dashboard-required';
	                    break;
	                case types.entityType.alarm:
	                    scope.selectEntityText = 'alarm.select-alarm';
	                    scope.entityText = 'alarm.alarm';
	                    scope.noEntitiesMatchingText = 'alarm.no-alarms-matching';
	                    scope.entityRequiredText = 'alarm.alarm-required';
	                    break;
	                case types.aliasEntityType.current_customer:
	                    scope.selectEntityText = 'customer.select-default-customer';
	                    scope.entityText = 'customer.default-customer';
	                    scope.noEntitiesMatchingText = 'customer.no-customers-matching';
	                    scope.entityRequiredText = 'customer.default-customer-required';
	                    break;
	            }
	            if (scope.entity && scope.entity.id.entityType != scope.entityType) {
	                scope.entity = null;
	                scope.updateView();
	            }
	        }
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            theForm: '=?',
	            tbRequired: '=?',
	            disabled: '=ngDisabled',
	            entityType: '=',
	            entitySubtype: '=?',
	            excludeEntityIds: '=?'
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityFilterViewDirective.$inject = ["$compile", "$templateCache", "$q", "$document", "$mdDialog", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityFilterViewDirective;
	
	var _entityFilterViewTpl = __webpack_require__(1464);
	
	var _entityFilterViewTpl2 = _interopRequireDefault(_entityFilterViewTpl);
	
	__webpack_require__(792);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function EntityFilterViewDirective($compile, $templateCache, $q, $document, $mdDialog, $translate, types /*, entityService*/) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_entityFilterViewTpl2.default);
	        element.html(template);
	
	        scope.ngModelCtrl = ngModelCtrl;
	        scope.types = types;
	        scope.filterDisplayValue = '';
	
	        scope.$watch('filter', function () {
	            scope.updateDisplayValue();
	        });
	
	        scope.updateDisplayValue = function () {
	            if (scope.filter && scope.filter.type) {
	                var entityType;
	                var prefix;
	                switch (scope.filter.type) {
	                    case types.aliasFilterType.singleEntity.value:
	                        entityType = scope.filter.singleEntity.entityType;
	                        scope.filterDisplayValue = $translate.instant(types.entityTypeTranslations[entityType].list, { count: 1 }, 'messageformat');
	                        break;
	                    case types.aliasFilterType.entityList.value:
	                        entityType = scope.filter.entityType;
	                        var count = scope.filter.entityList.length;
	                        scope.filterDisplayValue = $translate.instant(types.entityTypeTranslations[entityType].list, { count: count }, 'messageformat');
	                        break;
	                    case types.aliasFilterType.entityName.value:
	                        entityType = scope.filter.entityType;
	                        prefix = scope.filter.entityNameFilter;
	                        scope.filterDisplayValue = $translate.instant(types.entityTypeTranslations[entityType].nameStartsWith, { prefix: prefix });
	                        break;
	                    case types.aliasFilterType.stateEntity.value:
	                        scope.filterDisplayValue = $translate.instant('alias.filter-type-state-entity-description');
	                        break;
	                    case types.aliasFilterType.assetType.value:
	                        var assetType = scope.filter.assetType;
	                        prefix = scope.filter.assetNameFilter;
	                        if (prefix && prefix.length) {
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-asset-type-and-name-description', { assetType: assetType, prefix: prefix });
	                        } else {
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-asset-type-description', { assetType: assetType });
	                        }
	                        break;
	                    case types.aliasFilterType.deviceType.value:
	                        var deviceType = scope.filter.deviceType;
	                        prefix = scope.filter.deviceNameFilter;
	                        if (prefix && prefix.length) {
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-device-type-and-name-description', { deviceType: deviceType, prefix: prefix });
	                        } else {
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-device-type-description', { deviceType: deviceType });
	                        }
	                        break;
	                    case types.aliasFilterType.entityViewType.value:
	                        var entityViewType = scope.filter.entityViewType;
	                        prefix = scope.filter.entityViewNameFilter;
	                        if (prefix && prefix.length) {
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-entity-view-type-and-name-description', { entityViewType: entityViewType, prefix: prefix });
	                        } else {
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-entity-view-type-description', { entityViewType: entityViewType });
	                        }
	                        break;
	                    case types.aliasFilterType.relationsQuery.value:
	                        var rootEntityText;
	                        var directionText;
	                        var allEntitiesText = $translate.instant('alias.all-entities');
	                        var anyRelationText = $translate.instant('alias.any-relation');
	                        if (scope.filter.rootStateEntity) {
	                            rootEntityText = $translate.instant('alias.state-entity');
	                        } else {
	                            rootEntityText = $translate.instant(types.entityTypeTranslations[scope.filter.rootEntity.entityType].type);
	                        }
	                        directionText = $translate.instant('relation.direction-type.' + scope.filter.direction);
	                        var relationFilters = scope.filter.filters;
	                        if (relationFilters && relationFilters.length) {
	                            var relationFiltersDisplayValues = [];
	                            relationFilters.forEach(function (relationFilter) {
	                                var entitiesText;
	                                if (relationFilter.entityTypes && relationFilter.entityTypes.length) {
	                                    var entitiesNamesList = [];
	                                    relationFilter.entityTypes.forEach(function (entityType) {
	                                        entitiesNamesList.push($translate.instant(types.entityTypeTranslations[entityType].typePlural));
	                                    });
	                                    entitiesText = entitiesNamesList.join(', ');
	                                } else {
	                                    entitiesText = allEntitiesText;
	                                }
	                                var relationTypeText;
	                                if (relationFilter.relationType && relationFilter.relationType.length) {
	                                    relationTypeText = "'" + relationFilter.relationType + "'";
	                                } else {
	                                    relationTypeText = anyRelationText;
	                                }
	                                var relationFilterDisplayValue = $translate.instant('alias.filter-type-relations-query-description', {
	                                    entities: entitiesText,
	                                    relationType: relationTypeText,
	                                    direction: directionText,
	                                    rootEntity: rootEntityText
	                                });
	                                relationFiltersDisplayValues.push(relationFilterDisplayValue);
	                            });
	                            scope.filterDisplayValue = relationFiltersDisplayValues.join(', ');
	                        } else {
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-relations-query-description', {
	                                entities: allEntitiesText,
	                                relationType: anyRelationText,
	                                direction: directionText,
	                                rootEntity: rootEntityText
	                            });
	                        }
	                        break;
	                    case types.aliasFilterType.assetSearchQuery.value:
	                    case types.aliasFilterType.deviceSearchQuery.value:
	                    case types.aliasFilterType.entityViewSearchQuery.value:
	                        allEntitiesText = $translate.instant('alias.all-entities');
	                        anyRelationText = $translate.instant('alias.any-relation');
	                        if (scope.filter.rootStateEntity) {
	                            rootEntityText = $translate.instant('alias.state-entity');
	                        } else {
	                            rootEntityText = $translate.instant(types.entityTypeTranslations[scope.filter.rootEntity.entityType].type);
	                        }
	                        directionText = $translate.instant('relation.direction-type.' + scope.filter.direction);
	                        var relationTypeText;
	                        if (scope.filter.relationType && scope.filter.relationType.length) {
	                            relationTypeText = "'" + scope.filter.relationType + "'";
	                        } else {
	                            relationTypeText = anyRelationText;
	                        }
	
	                        var translationValues = {
	                            relationType: relationTypeText,
	                            direction: directionText,
	                            rootEntity: rootEntityText
	                        };
	
	                        if (scope.filter.type == types.aliasFilterType.assetSearchQuery.value) {
	                            var assetTypesQuoted = [];
	                            scope.filter.assetTypes.forEach(function (assetType) {
	                                assetTypesQuoted.push("'" + assetType + "'");
	                            });
	                            var assetTypesText = assetTypesQuoted.join(', ');
	                            translationValues.assetTypes = assetTypesText;
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-asset-search-query-description', translationValues);
	                        } else if (scope.filter.type == types.aliasFilterType.deviceSearchQuery.value) {
	                            var deviceTypesQuoted = [];
	                            scope.filter.deviceTypes.forEach(function (deviceType) {
	                                deviceTypesQuoted.push("'" + deviceType + "'");
	                            });
	                            var deviceTypesText = deviceTypesQuoted.join(', ');
	                            translationValues.deviceTypes = deviceTypesText;
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-device-search-query-description', translationValues);
	                        } else if (scope.filter.type == types.aliasFilterType.entityViewSearchQuery.value) {
	                            var entityViewTypesQuoted = [];
	                            scope.filter.entityViewTypes.forEach(function (entityViewType) {
	                                entityViewTypesQuoted.push("'" + entityViewType + "'");
	                            });
	                            var entityViewTypesText = entityViewTypesQuoted.join(', ');
	                            translationValues.entityViewTypes = entityViewTypesText;
	                            scope.filterDisplayValue = $translate.instant('alias.filter-type-entity-view-search-query-description', translationValues);
	                        }
	                        break;
	                    default:
	                        scope.filterDisplayValue = scope.filter.type;
	                        break;
	                }
	            } else {
	                scope.filterDisplayValue = '';
	            }
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                scope.filter = ngModelCtrl.$viewValue;
	            } else {
	                scope.filter = null;
	            }
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: true
	    };
	}
	
	/* eslint-enable import/no-unresolved, import/default */

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityFilterDirective.$inject = ["$compile", "$templateCache", "$q", "$document", "$mdDialog", "types", "entityService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityFilterDirective;
	
	var _entityFilterTpl = __webpack_require__(1465);
	
	var _entityFilterTpl2 = _interopRequireDefault(_entityFilterTpl);
	
	__webpack_require__(793);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function EntityFilterDirective($compile, $templateCache, $q, $document, $mdDialog, types, entityService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_entityFilterTpl2.default);
	        element.html(template);
	
	        scope.ngModelCtrl = ngModelCtrl;
	        scope.types = types;
	        scope.aliasFilterTypes = entityService.getAliasFilterTypesByEntityTypes(scope.allowedEntityTypes);
	
	        scope.$watch('filter.type', function (newType, prevType) {
	            if (newType && newType != prevType) {
	                updateFilter();
	            }
	        });
	
	        function updateFilter() {
	            var filter = {};
	            filter.type = scope.filter.type;
	            filter.resolveMultiple = true;
	            switch (filter.type) {
	                case types.aliasFilterType.singleEntity.value:
	                    filter.singleEntity = null;
	                    filter.resolveMultiple = false;
	                    break;
	                case types.aliasFilterType.entityList.value:
	                    filter.entityType = null;
	                    filter.entityList = [];
	                    break;
	                case types.aliasFilterType.entityName.value:
	                    filter.entityType = null;
	                    filter.entityNameFilter = '';
	                    break;
	                case types.aliasFilterType.stateEntity.value:
	                    filter.stateEntityParamName = null;
	                    filter.defaultStateEntity = null;
	                    filter.resolveMultiple = false;
	                    break;
	                case types.aliasFilterType.assetType.value:
	                    filter.assetType = null;
	                    filter.assetNameFilter = '';
	                    break;
	                case types.aliasFilterType.deviceType.value:
	                    filter.deviceType = null;
	                    filter.deviceNameFilter = '';
	                    break;
	                case types.aliasFilterType.entityViewType.value:
	                    filter.entityViewType = null;
	                    filter.entityViewNameFilter = '';
	                    break;
	                case types.aliasFilterType.relationsQuery.value:
	                case types.aliasFilterType.assetSearchQuery.value:
	                case types.aliasFilterType.deviceSearchQuery.value:
	                case types.aliasFilterType.entityViewSearchQuery.value:
	                    filter.rootStateEntity = false;
	                    filter.stateEntityParamName = null;
	                    filter.defaultStateEntity = null;
	                    filter.rootEntity = null;
	                    filter.direction = types.entitySearchDirection.from;
	                    filter.maxLevel = 1;
	                    if (filter.type === types.aliasFilterType.relationsQuery.value) {
	                        filter.filters = [];
	                    } else if (filter.type === types.aliasFilterType.assetSearchQuery.value) {
	                        filter.relationType = null;
	                        filter.assetTypes = [];
	                    } else if (filter.type === types.aliasFilterType.deviceSearchQuery.value) {
	                        filter.relationType = null;
	                        filter.deviceTypes = [];
	                    } else if (filter.type === types.aliasFilterType.entityViewSearchQuery.value) {
	                        filter.relationType = null;
	                        filter.entityViewTypes = [];
	                    }
	                    break;
	            }
	            scope.filter = filter;
	        }
	
	        scope.$watch('filter', function () {
	            scope.updateView();
	        });
	
	        scope.updateView = function () {
	            ngModelCtrl.$setViewValue(scope.filter);
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                scope.filter = ngModelCtrl.$viewValue;
	            } else {
	                scope.filter = {
	                    type: null,
	                    resolveMultiple: false
	                };
	            }
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            theForm: '=',
	            allowedEntityTypes: '=?'
	        }
	    };
	}
	
	/* eslint-enable import/no-unresolved, import/default */

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityListDirective.$inject = ["$compile", "$templateCache", "$q", "$mdUtil", "entityService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityListDirective;
	
	var _entityListTpl = __webpack_require__(1466);
	
	var _entityListTpl2 = _interopRequireDefault(_entityListTpl);
	
	__webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function EntityListDirective($compile, $templateCache, $q, $mdUtil, entityService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_entityListTpl2.default);
	        element.html(template);
	
	        scope.ngModelCtrl = ngModelCtrl;
	
	        scope.$watch('tbRequired', function () {
	            scope.updateValidity();
	        });
	
	        scope.fetchEntities = function (searchText, limit) {
	            var deferred = $q.defer();
	            entityService.getEntitiesByNameFilter(scope.entityType, searchText, limit, { ignoreLoading: true }).then(function success(result) {
	                if (result) {
	                    deferred.resolve(result);
	                } else {
	                    deferred.resolve([]);
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	            return deferred.promise;
	        };
	
	        scope.updateValidity = function () {
	            var value = ngModelCtrl.$viewValue;
	            var valid = !scope.tbRequired || value && value.length > 0;
	            ngModelCtrl.$setValidity('entityList', valid);
	        };
	
	        ngModelCtrl.$render = function () {
	            destroyWatchers();
	            var value = ngModelCtrl.$viewValue;
	            scope.entityList = [];
	            if (value && value.length > 0) {
	                entityService.getEntities(scope.entityType, value).then(function (entities) {
	                    scope.entityList = entities;
	                    initWatchers();
	                });
	            } else {
	                initWatchers();
	            }
	        };
	
	        function initWatchers() {
	            scope.entityTypeDeregistration = scope.$watch('entityType', function (newEntityType, prevEntityType) {
	                if (!angular.equals(newEntityType, prevEntityType)) {
	                    scope.entityList = [];
	                }
	            });
	            scope.entityListDeregistration = scope.$watch('entityList', function () {
	                var ids = [];
	                if (scope.entityList && scope.entityList.length > 0) {
	                    for (var i = 0; i < scope.entityList.length; i++) {
	                        ids.push(scope.entityList[i].id.id);
	                    }
	                }
	                var value = ngModelCtrl.$viewValue;
	                if (!angular.equals(ids, value)) {
	                    ngModelCtrl.$setViewValue(ids);
	                }
	                scope.updateValidity();
	            }, true);
	        }
	
	        function destroyWatchers() {
	            if (scope.entityTypeDeregistration) {
	                scope.entityTypeDeregistration();
	                scope.entityTypeDeregistration = null;
	            }
	            if (scope.entityListDeregistration) {
	                scope.entityListDeregistration();
	                scope.entityListDeregistration = null;
	            }
	        }
	
	        $compile(element.contents())(scope);
	
	        $mdUtil.nextTick(function () {
	            var inputElement = angular.element('input', element);
	            inputElement.on('blur', function () {
	                scope.inputTouched = true;
	            });
	        });
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            disabled: '=ngDisabled',
	            tbRequired: '=?',
	            entityType: '='
	        }
	    };
	}
	
	/* eslint-enable import/no-unresolved, import/default */

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntitySelect.$inject = ["$compile", "$templateCache", "entityService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntitySelect;
	
	__webpack_require__(795);
	
	var _entitySelectTpl = __webpack_require__(1467);
	
	var _entitySelectTpl2 = _interopRequireDefault(_entitySelectTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function EntitySelect($compile, $templateCache, entityService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_entitySelectTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	
	        var entityTypes = entityService.prepareAllowedEntityTypesList(scope.allowedEntityTypes, scope.useAliasEntityTypes);
	
	        var entityTypeKeys = Object.keys(entityTypes);
	
	        if (entityTypeKeys.length === 1) {
	            scope.displayEntityTypeSelect = false;
	            scope.defaultEntityType = entityTypes[entityTypeKeys[0]];
	        } else {
	            scope.displayEntityTypeSelect = true;
	        }
	
	        scope.model = {
	            entityType: scope.defaultEntityType
	        };
	
	        scope.updateView = function () {
	            if (!scope.disabled) {
	                var value = ngModelCtrl.$viewValue;
	                if (scope.model && scope.model.entityType && scope.model.entityId) {
	                    if (!value) {
	                        value = {};
	                    }
	                    value.entityType = scope.model.entityType;
	                    value.id = scope.model.entityId;
	                    ngModelCtrl.$setViewValue(value);
	                } else {
	                    ngModelCtrl.$setViewValue(null);
	                }
	            }
	        };
	
	        ngModelCtrl.$render = function () {
	            destroyWatchers();
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                scope.model.entityType = value.entityType;
	                scope.model.entityId = value.id;
	            } else {
	                scope.model.entityType = scope.defaultEntityType;
	                scope.model.entityId = null;
	            }
	            initWatchers();
	        };
	
	        function initWatchers() {
	            scope.entityTypeDeregistration = scope.$watch('model.entityType', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    scope.updateView();
	                }
	            });
	
	            scope.entityIdDeregistration = scope.$watch('model.entityId', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    scope.updateView();
	                }
	            });
	
	            scope.disabledDeregistration = scope.$watch('disabled', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    scope.updateView();
	                }
	            });
	        }
	
	        function destroyWatchers() {
	            if (scope.entityTypeDeregistration) {
	                scope.entityTypeDeregistration();
	                scope.entityTypeDeregistration = null;
	            }
	            if (scope.entityIdDeregistration) {
	                scope.entityIdDeregistration();
	                scope.entityIdDeregistration = null;
	            }
	            if (scope.disabledDeregistration) {
	                scope.disabledDeregistration();
	                scope.disabledDeregistration = null;
	            }
	        }
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            theForm: '=?',
	            tbRequired: '=?',
	            disabled: '=ngDisabled',
	            allowedEntityTypes: "=?",
	            useAliasEntityTypes: "=?"
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntitySubtypeAutocomplete.$inject = ["$compile", "$templateCache", "$q", "$filter", "assetService", "deviceService", "entityViewService", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntitySubtypeAutocomplete;
	
	__webpack_require__(796);
	
	var _entitySubtypeAutocompleteTpl = __webpack_require__(1468);
	
	var _entitySubtypeAutocompleteTpl2 = _interopRequireDefault(_entitySubtypeAutocompleteTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function EntitySubtypeAutocomplete($compile, $templateCache, $q, $filter, assetService, deviceService, entityViewService, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_entitySubtypeAutocompleteTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	        scope.subType = null;
	        scope.subTypeSearchText = '';
	        scope.entitySubtypes = null;
	
	        var comparator = function comparator(actual, expected) {
	            if (angular.isUndefined(actual)) {
	                return false;
	            }
	            if (actual === null || expected === null) {
	                return actual === expected;
	            }
	            return actual.indexOf(expected) !== -1;
	        };
	
	        scope.fetchSubTypes = function (searchText) {
	            var deferred = $q.defer();
	            loadSubTypes().then(function success(subTypes) {
	                var result = $filter('filter')(subTypes, { '$': searchText }, comparator);
	                if (result && result.length) {
	                    deferred.resolve(result);
	                } else {
	                    deferred.resolve([searchText]);
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	            return deferred.promise;
	        };
	
	        scope.subTypeSearchTextChanged = function () {};
	
	        scope.updateView = function () {
	            if (!scope.disabled) {
	                ngModelCtrl.$setViewValue(scope.subType);
	            }
	        };
	
	        ngModelCtrl.$render = function () {
	            scope.subType = ngModelCtrl.$viewValue;
	        };
	
	        scope.$watch('entityType', function () {
	            load();
	        });
	
	        scope.$watch('subType', function (newValue, prevValue) {
	            if (!angular.equals(newValue, prevValue)) {
	                scope.updateView();
	            }
	        });
	
	        scope.$watch('disabled', function () {
	            scope.updateView();
	        });
	
	        function loadSubTypes() {
	            var deferred = $q.defer();
	            if (!scope.entitySubtypes) {
	                var entitySubtypesPromise;
	                if (scope.entityType == types.entityType.asset) {
	                    entitySubtypesPromise = assetService.getAssetTypes({ ignoreLoading: true });
	                } else if (scope.entityType == types.entityType.device) {
	                    entitySubtypesPromise = deviceService.getDeviceTypes({ ignoreLoading: true });
	                } else if (scope.entityType == types.entityType.entityView) {
	                    entitySubtypesPromise = entityViewService.getEntityViewTypes({ ignoreLoading: true });
	                }
	                if (entitySubtypesPromise) {
	                    entitySubtypesPromise.then(function success(types) {
	                        scope.entitySubtypes = [];
	                        types.forEach(function (type) {
	                            scope.entitySubtypes.push(type.type);
	                        });
	                        deferred.resolve(scope.entitySubtypes);
	                    }, function fail() {
	                        deferred.reject();
	                    });
	                } else {
	                    deferred.reject();
	                }
	            } else {
	                deferred.resolve(scope.entitySubtypes);
	            }
	            return deferred.promise;
	        }
	
	        function load() {
	            if (scope.entityType == types.entityType.asset) {
	                scope.selectEntitySubtypeText = 'asset.select-asset-type';
	                scope.entitySubtypeText = 'asset.asset-type';
	                scope.entitySubtypeRequiredText = 'asset.asset-type-required';
	                scope.$on('assetSaved', function () {
	                    scope.entitySubtypes = null;
	                });
	            } else if (scope.entityType == types.entityType.device) {
	                scope.selectEntitySubtypeText = 'device.select-device-type';
	                scope.entitySubtypeText = 'device.device-type';
	                scope.entitySubtypeRequiredText = 'device.device-type-required';
	                scope.$on('deviceSaved', function () {
	                    scope.entitySubtypes = null;
	                });
	            } else if (scope.entityType == types.entityType.entityView) {
	                scope.selectEntitySubtypeText = 'entity-view.select-entity-view-type';
	                scope.entitySubtypeText = 'entity-view.entity-view-type';
	                scope.entitySubtypeRequiredText = 'entity-view.entity-view-type-required';
	                scope.$on('entityViewSaved', function () {
	                    scope.entitySubtypes = null;
	                });
	            }
	        }
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            theForm: '=?',
	            tbRequired: '=?',
	            disabled: '=ngDisabled',
	            entityType: "="
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntitySubtypeListDirective.$inject = ["$compile", "$templateCache", "$q", "$mdUtil", "$translate", "$filter", "types", "assetService", "deviceService", "entityViewService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntitySubtypeListDirective;
	
	var _entitySubtypeListTpl = __webpack_require__(1469);
	
	var _entitySubtypeListTpl2 = _interopRequireDefault(_entitySubtypeListTpl);
	
	__webpack_require__(797);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function EntitySubtypeListDirective($compile, $templateCache, $q, $mdUtil, $translate, $filter, types, assetService, deviceService, entityViewService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_entitySubtypeListTpl2.default);
	        element.html(template);
	
	        scope.ngModelCtrl = ngModelCtrl;
	
	        scope.entitySubtypesList = [];
	        scope.entitySubtypes = null;
	
	        if (scope.entityType == types.entityType.asset) {
	            scope.placeholder = scope.tbRequired ? $translate.instant('asset.enter-asset-type') : $translate.instant('asset.any-asset');
	            scope.secondaryPlaceholder = '+' + $translate.instant('asset.asset-type');
	            scope.noSubtypesMathingText = 'asset.no-asset-types-matching';
	            scope.subtypeListEmptyText = 'asset.asset-type-list-empty';
	        } else if (scope.entityType == types.entityType.device) {
	            scope.placeholder = scope.tbRequired ? $translate.instant('device.enter-device-type') : $translate.instant('device.any-device');
	            scope.secondaryPlaceholder = '+' + $translate.instant('device.device-type');
	            scope.noSubtypesMathingText = 'device.no-device-types-matching';
	            scope.subtypeListEmptyText = 'device.device-type-list-empty';
	        } else if (scope.entityType == types.entityType.entityView) {
	            scope.placeholder = scope.tbRequired ? $translate.instant('entity-view.enter-entity-view-type') : $translate.instant('entity-view.any-entity-view');
	            scope.secondaryPlaceholder = '+' + $translate.instant('entity-view.entity-view-type');
	            scope.noSubtypesMathingText = 'entity-view.no-entity-view-types-matching';
	            scope.subtypeListEmptyText = 'entity-view.entity-view-type-list-empty';
	        }
	
	        scope.$watch('tbRequired', function () {
	            scope.updateValidity();
	        });
	
	        scope.fetchEntitySubtypes = function (searchText) {
	            var deferred = $q.defer();
	            loadSubTypes().then(function success(subTypes) {
	                var result = $filter('filter')(subTypes, { '$': searchText });
	                if (result && result.length) {
	                    deferred.resolve(result);
	                } else {
	                    deferred.resolve([searchText]);
	                }
	            }, function fail() {
	                deferred.reject();
	            });
	            return deferred.promise;
	        };
	
	        scope.updateValidity = function () {
	            var value = ngModelCtrl.$viewValue;
	            var valid = !scope.tbRequired || value && value.length > 0;
	            ngModelCtrl.$setValidity('entitySubtypesList', valid);
	        };
	
	        ngModelCtrl.$render = function () {
	            scope.entitySubtypesList = ngModelCtrl.$viewValue;
	            if (!scope.entitySubtypesList) {
	                scope.entitySubtypesList = [];
	            }
	        };
	
	        scope.$watch('entitySubtypesList', function () {
	            ngModelCtrl.$setViewValue(scope.entitySubtypesList);
	            scope.updateValidity();
	        }, true);
	
	        function loadSubTypes() {
	            var deferred = $q.defer();
	            if (!scope.entitySubtypes) {
	                var entitySubtypesPromise;
	                if (scope.entityType == types.entityType.asset) {
	                    entitySubtypesPromise = assetService.getAssetTypes({ ignoreLoading: true });
	                } else if (scope.entityType == types.entityType.device) {
	                    entitySubtypesPromise = deviceService.getDeviceTypes({ ignoreLoading: true });
	                } else if (scope.entityType == types.entityType.entityView) {
	                    entitySubtypesPromise = entityViewService.getEntityViewTypes({ ignoreLoading: true });
	                }
	                if (entitySubtypesPromise) {
	                    entitySubtypesPromise.then(function success(types) {
	                        scope.entitySubtypes = [];
	                        types.forEach(function (type) {
	                            scope.entitySubtypes.push(type.type);
	                        });
	                        deferred.resolve(scope.entitySubtypes);
	                    }, function fail() {
	                        deferred.reject();
	                    });
	                } else {
	                    deferred.reject();
	                }
	            } else {
	                deferred.resolve(scope.entitySubtypes);
	            }
	            return deferred.promise;
	        }
	
	        $compile(element.contents())(scope);
	
	        $mdUtil.nextTick(function () {
	            var inputElement = angular.element('input', element);
	            inputElement.on('blur', function () {
	                scope.inputTouched = true;
	            });
	        });
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            disabled: '=ngDisabled',
	            tbRequired: '=?',
	            entityType: "="
	        }
	    };
	}
	
	/* eslint-enable import/no-unresolved, import/default */

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntitySubtypeSelect.$inject = ["$compile", "$templateCache", "$translate", "assetService", "deviceService", "entityViewService", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntitySubtypeSelect;
	
	__webpack_require__(798);
	
	var _entitySubtypeSelectTpl = __webpack_require__(1470);
	
	var _entitySubtypeSelectTpl2 = _interopRequireDefault(_entitySubtypeSelectTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function EntitySubtypeSelect($compile, $templateCache, $translate, assetService, deviceService, entityViewService, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_entitySubtypeSelectTpl2.default);
	        element.html(template);
	
	        if (angular.isDefined(attrs.hideLabel)) {
	            scope.showLabel = false;
	        } else {
	            scope.showLabel = true;
	        }
	
	        scope.ngModelCtrl = ngModelCtrl;
	
	        scope.entitySubtypes = [];
	
	        scope.subTypeName = function (subType) {
	            if (subType && subType.length) {
	                if (scope.typeTranslatePrefix) {
	                    return $translate.instant(scope.typeTranslatePrefix + '.' + subType);
	                } else {
	                    return subType;
	                }
	            } else {
	                return $translate.instant('entity.all-subtypes');
	            }
	        };
	
	        scope.$watch('entityType', function () {
	            load();
	        });
	
	        scope.$watch('entitySubtype', function (newValue, prevValue) {
	            if (!angular.equals(newValue, prevValue)) {
	                scope.updateView();
	            }
	        });
	
	        scope.updateView = function () {
	            ngModelCtrl.$setViewValue(scope.entitySubtype);
	        };
	
	        ngModelCtrl.$render = function () {
	            scope.entitySubtype = ngModelCtrl.$viewValue;
	        };
	
	        function loadSubTypes() {
	            scope.entitySubtypes = [];
	            var entitySubtypesPromise;
	            if (scope.entityType == types.entityType.asset) {
	                entitySubtypesPromise = assetService.getAssetTypes({ ignoreLoading: true });
	            } else if (scope.entityType == types.entityType.device) {
	                entitySubtypesPromise = deviceService.getDeviceTypes({ ignoreLoading: true });
	            } else if (scope.entityType == types.entityType.entityView) {
	                entitySubtypesPromise = entityViewService.getEntityViewTypes({ ignoreLoading: true });
	            }
	            if (entitySubtypesPromise) {
	                entitySubtypesPromise.then(function success(types) {
	                    scope.entitySubtypes.push('');
	                    types.forEach(function (type) {
	                        scope.entitySubtypes.push(type.type);
	                    });
	                    if (scope.entitySubtypes.indexOf(scope.entitySubtype) == -1) {
	                        scope.entitySubtype = '';
	                    }
	                }, function fail() {});
	            }
	        }
	
	        function load() {
	            if (scope.entityType == types.entityType.asset) {
	                scope.entitySubtypeTitle = 'asset.asset-type';
	                scope.entitySubtypeRequiredText = 'asset.asset-type-required';
	            } else if (scope.entityType == types.entityType.device) {
	                scope.entitySubtypeTitle = 'device.device-type';
	                scope.entitySubtypeRequiredText = 'device.device-type-required';
	            } else if (scope.entityType == types.entityType.entityView) {
	                scope.entitySubtypeTitle = 'entity-view.entity-view-type';
	                scope.entitySubtypeRequiredText = 'entity-view.entity-view-type-required';
	            }
	            scope.entitySubtypes.length = 0;
	            if (scope.entitySubtypesList && scope.entitySubtypesList.length) {
	                scope.entitySubtypesList.forEach(function (subType) {
	                    scope.entitySubtypes.push(subType);
	                });
	            } else {
	                loadSubTypes();
	                if (scope.entityType == types.entityType.asset) {
	                    scope.$on('assetSaved', function () {
	                        loadSubTypes();
	                    });
	                } else if (scope.entityType == types.entityType.device) {
	                    scope.$on('deviceSaved', function () {
	                        loadSubTypes();
	                    });
	                } else if (scope.entityType == types.entityType.entityView) {
	                    scope.$on('entityViewSaved', function () {
	                        loadSubTypes();
	                    });
	                }
	            }
	        }
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            theForm: '=?',
	            entityType: "=",
	            entitySubtypesList: "=?",
	            typeTranslatePrefix: "@?"
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityTypeListDirective.$inject = ["$compile", "$templateCache", "$q", "$mdUtil", "$translate", "$filter", "types", "entityService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityTypeListDirective;
	
	var _entityTypeListTpl = __webpack_require__(1471);
	
	var _entityTypeListTpl2 = _interopRequireDefault(_entityTypeListTpl);
	
	__webpack_require__(799);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function EntityTypeListDirective($compile, $templateCache, $q, $mdUtil, $translate, $filter, types, entityService) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_entityTypeListTpl2.default);
	        element.html(template);
	
	        scope.ngModelCtrl = ngModelCtrl;
	
	        scope.placeholder = scope.tbRequired ? $translate.instant('entity.enter-entity-type') : $translate.instant('entity.any-entity');
	        scope.secondaryPlaceholder = '+' + $translate.instant('entity.entity-type');
	
	        var entityTypes;
	
	        if (scope.ignoreAuthorityFilter && scope.allowedEntityTypes && scope.allowedEntityTypes.length) {
	            entityTypes = {};
	            scope.allowedEntityTypes.forEach(function (entityTypeValue) {
	                var entityType = entityTypeFromValue(entityTypeValue);
	                if (entityType) {
	                    entityTypes[entityType] = entityTypeValue;
	                }
	            });
	        } else {
	            entityTypes = entityService.prepareAllowedEntityTypesList(scope.allowedEntityTypes);
	        }
	
	        function entityTypeFromValue(entityTypeValue) {
	            for (var entityType in types.entityType) {
	                if (types.entityType[entityType] === entityTypeValue) {
	                    return entityType;
	                }
	            }
	            return null;
	        }
	
	        scope.entityTypesList = [];
	        for (var type in entityTypes) {
	            var entityTypeInfo = {};
	            entityTypeInfo.value = entityTypes[type];
	            entityTypeInfo.name = $translate.instant(types.entityTypeTranslations[entityTypeInfo.value].type) + '';
	            scope.entityTypesList.push(entityTypeInfo);
	        }
	
	        scope.$watch('tbRequired', function () {
	            scope.updateValidity();
	        });
	
	        scope.fetchEntityTypes = function (searchText) {
	            var deferred = $q.defer();
	            var entityTypes = $filter('filter')(scope.entityTypesList, { name: searchText });
	            deferred.resolve(entityTypes);
	            return deferred.promise;
	        };
	
	        scope.updateValidity = function () {
	            var value = ngModelCtrl.$viewValue;
	            var valid = !scope.tbRequired || value && value.length > 0;
	            ngModelCtrl.$setValidity('entityTypeList', valid);
	        };
	
	        ngModelCtrl.$render = function () {
	            if (scope.entityTypeListWatch) {
	                scope.entityTypeListWatch();
	                scope.entityTypeListWatch = null;
	            }
	            var entityTypeList = [];
	            var value = ngModelCtrl.$viewValue;
	            if (value && value.length) {
	                value.forEach(function (type) {
	                    var entityTypeInfo = {};
	                    entityTypeInfo.value = type;
	                    entityTypeInfo.name = $translate.instant(types.entityTypeTranslations[entityTypeInfo.value].type) + '';
	                    entityTypeList.push(entityTypeInfo);
	                });
	            }
	            scope.entityTypeList = entityTypeList;
	            scope.entityTypeListWatch = scope.$watch('entityTypeList', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    updateEntityTypeList();
	                }
	            }, true);
	        };
	
	        function updateEntityTypeList() {
	            var values = ngModelCtrl.$viewValue;
	            if (!values) {
	                values = [];
	                ngModelCtrl.$setViewValue(values);
	            } else {
	                values.length = 0;
	            }
	            if (scope.entityTypeList && scope.entityTypeList.length) {
	                scope.entityTypeList.forEach(function (entityType) {
	                    values.push(entityType.value);
	                });
	            }
	            scope.updateValidity();
	        }
	
	        $compile(element.contents())(scope);
	
	        $mdUtil.nextTick(function () {
	            var inputElement = angular.element('input', element);
	            inputElement.on('blur', function () {
	                scope.inputTouched = true;
	            });
	        });
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            disabled: '=ngDisabled',
	            tbRequired: '=?',
	            allowedEntityTypes: '=?',
	            ignoreAuthorityFilter: '=?'
	        }
	    };
	}
	
	/* eslint-enable import/no-unresolved, import/default */

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntityTypeSelect.$inject = ["$compile", "$templateCache", "utils", "entityService", "userService", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EntityTypeSelect;
	
	__webpack_require__(800);
	
	var _entityTypeSelectTpl = __webpack_require__(1472);
	
	var _entityTypeSelectTpl2 = _interopRequireDefault(_entityTypeSelectTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function EntityTypeSelect($compile, $templateCache, utils, entityService, userService, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_entityTypeSelectTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	
	        if (angular.isDefined(attrs.hideLabel)) {
	            scope.showLabel = false;
	        } else {
	            scope.showLabel = true;
	        }
	
	        scope.ngModelCtrl = ngModelCtrl;
	
	        scope.entityTypes = entityService.prepareAllowedEntityTypesList(scope.allowedEntityTypes, scope.useAliasEntityTypes);
	
	        scope.typeName = function (type) {
	            return type ? types.entityTypeTranslations[type].type : '';
	        };
	
	        scope.updateValidity = function () {
	            var value = ngModelCtrl.$viewValue;
	            var valid = angular.isDefined(value) && value != null;
	            ngModelCtrl.$setValidity('entityType', valid);
	        };
	
	        scope.$watch('entityType', function (newValue, prevValue) {
	            if (!angular.equals(newValue, prevValue)) {
	                scope.updateView();
	            }
	        });
	
	        scope.updateView = function () {
	            ngModelCtrl.$setViewValue(scope.entityType);
	            scope.updateValidity();
	        };
	
	        ngModelCtrl.$render = function () {
	            if (ngModelCtrl.$viewValue) {
	                scope.entityType = ngModelCtrl.$viewValue;
	            }
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            theForm: '=?',
	            tbRequired: '=?',
	            disabled: '=ngDisabled',
	            allowedEntityTypes: "=?",
	            useAliasEntityTypes: "=?"
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entityAliases = __webpack_require__(1252);
	
	var _entityAliases2 = _interopRequireDefault(_entityAliases);
	
	var _entityAliasDialog = __webpack_require__(1251);
	
	var _entityAliasDialog2 = _interopRequireDefault(_entityAliasDialog);
	
	var _entityTypeSelect = __webpack_require__(1266);
	
	var _entityTypeSelect2 = _interopRequireDefault(_entityTypeSelect);
	
	var _entityTypeList = __webpack_require__(1265);
	
	var _entityTypeList2 = _interopRequireDefault(_entityTypeList);
	
	var _entitySubtypeList = __webpack_require__(1263);
	
	var _entitySubtypeList2 = _interopRequireDefault(_entitySubtypeList);
	
	var _entitySubtypeSelect = __webpack_require__(1264);
	
	var _entitySubtypeSelect2 = _interopRequireDefault(_entitySubtypeSelect);
	
	var _entitySubtypeAutocomplete = __webpack_require__(1262);
	
	var _entitySubtypeAutocomplete2 = _interopRequireDefault(_entitySubtypeAutocomplete);
	
	var _entityAutocomplete = __webpack_require__(1257);
	
	var _entityAutocomplete2 = _interopRequireDefault(_entityAutocomplete);
	
	var _entityList = __webpack_require__(1260);
	
	var _entityList2 = _interopRequireDefault(_entityList);
	
	var _entitySelect = __webpack_require__(1261);
	
	var _entitySelect2 = _interopRequireDefault(_entitySelect);
	
	var _entityFilter = __webpack_require__(1259);
	
	var _entityFilter2 = _interopRequireDefault(_entityFilter);
	
	var _entityFilterView = __webpack_require__(1258);
	
	var _entityFilterView2 = _interopRequireDefault(_entityFilterView);
	
	var _aliasesEntitySelectPanel = __webpack_require__(1249);
	
	var _aliasesEntitySelectPanel2 = _interopRequireDefault(_aliasesEntitySelectPanel);
	
	var _aliasesEntitySelect = __webpack_require__(1250);
	
	var _aliasesEntitySelect2 = _interopRequireDefault(_aliasesEntitySelect);
	
	var _addAttributeDialog = __webpack_require__(1253);
	
	var _addAttributeDialog2 = _interopRequireDefault(_addAttributeDialog);
	
	var _addWidgetToDashboardDialog = __webpack_require__(1254);
	
	var _addWidgetToDashboardDialog2 = _interopRequireDefault(_addWidgetToDashboardDialog);
	
	var _attributeTable = __webpack_require__(1255);
	
	var _attributeTable2 = _interopRequireDefault(_attributeTable);
	
	var _relationFilters = __webpack_require__(1269);
	
	var _relationFilters2 = _interopRequireDefault(_relationFilters);
	
	var _relationTable = __webpack_require__(1270);
	
	var _relationTable2 = _interopRequireDefault(_relationTable);
	
	var _relationTypeAutocomplete = __webpack_require__(1271);
	
	var _relationTypeAutocomplete2 = _interopRequireDefault(_relationTypeAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.entity', []).controller('EntityAliasesController', _entityAliases2.default).controller('EntityAliasDialogController', _entityAliasDialog2.default).controller('AliasesEntitySelectPanelController', _aliasesEntitySelectPanel2.default).controller('AddAttributeDialogController', _addAttributeDialog2.default).controller('AddWidgetToDashboardDialogController', _addWidgetToDashboardDialog2.default).directive('tbEntityTypeSelect', _entityTypeSelect2.default).directive('tbEntityTypeList', _entityTypeList2.default).directive('tbEntitySubtypeList', _entitySubtypeList2.default).directive('tbEntitySubtypeSelect', _entitySubtypeSelect2.default).directive('tbEntitySubtypeAutocomplete', _entitySubtypeAutocomplete2.default).directive('tbEntityAutocomplete', _entityAutocomplete2.default).directive('tbEntityList', _entityList2.default).directive('tbEntitySelect', _entitySelect2.default).directive('tbEntityFilter', _entityFilter2.default).directive('tbEntityFilterView', _entityFilterView2.default).directive('tbAliasesEntitySelect', _aliasesEntitySelect2.default).directive('tbAttributeTable', _attributeTable2.default).directive('tbRelationFilters', _relationFilters2.default).directive('tbRelationTable', _relationTable2.default).directive('tbRelationTypeAutocomplete', _relationTypeAutocomplete2.default).name;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RelationDialogController.$inject = ["$scope", "$mdDialog", "types", "entityRelationService", "isAdd", "direction", "relation", "showingCallback"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RelationDialogController;
	
	__webpack_require__(33);
	
	__webpack_require__(51);
	
	__webpack_require__(61);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	__webpack_require__(801);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var js_beautify = _jsBeautify2.default.js;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function RelationDialogController($scope, $mdDialog, types, entityRelationService, isAdd, direction, relation, showingCallback) {
	
	    var vm = this;
	
	    vm.types = types;
	    vm.isAdd = isAdd;
	    vm.direction = direction;
	
	    showingCallback.onShowing = function (scope, element) {
	        updateEditorSize(element);
	    };
	
	    vm.relationAdditionalInfoOptions = {
	        useWrapMode: false,
	        mode: 'json',
	        showGutter: false,
	        showPrintMargin: false,
	        theme: 'github',
	        advanced: {
	            enableSnippets: false,
	            enableBasicAutocompletion: false,
	            enableLiveAutocompletion: false
	        },
	        onLoad: function onLoad(_ace) {
	            vm.editor = _ace;
	        }
	    };
	
	    vm.relation = relation;
	    if (vm.isAdd) {
	        vm.relation.type = types.entityRelationType.contains;
	        vm.targetEntityId = {};
	    } else {
	        if (vm.direction == vm.types.entitySearchDirection.from) {
	            vm.targetEntityId = vm.relation.to;
	        } else {
	            vm.targetEntityId = vm.relation.from;
	        }
	    }
	
	    vm.save = save;
	    vm.cancel = cancel;
	
	    vm.additionalInfo = '';
	
	    if (vm.relation.additionalInfo) {
	        vm.additionalInfo = angular.toJson(vm.relation.additionalInfo);
	        vm.additionalInfo = js_beautify(vm.additionalInfo, { indent_size: 4 });
	    }
	
	    $scope.$watch('vm.additionalInfo', function () {
	        $scope.theForm.$setValidity("additionalInfo", true);
	    });
	
	    function updateEditorSize(element) {
	        var newHeight = 200;
	        angular.element('#tb-relation-additional-info', element).height(newHeight.toString() + "px");
	        vm.editor.resize();
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function save() {
	        if (vm.isAdd) {
	            if (vm.direction == vm.types.entitySearchDirection.from) {
	                vm.relation.to = vm.targetEntityId;
	            } else {
	                vm.relation.from = vm.targetEntityId;
	            }
	        }
	        $scope.theForm.$setPristine();
	
	        var valid = true;
	        if (vm.additionalInfo && vm.additionalInfo.length) {
	            try {
	                vm.relation.additionalInfo = angular.fromJson(vm.additionalInfo);
	            } catch (e) {
	                valid = false;
	            }
	        } else {
	            vm.relation.additionalInfo = null;
	        }
	
	        $scope.theForm.$setValidity("additionalInfo", valid);
	
	        if (valid) {
	            entityRelationService.saveRelation(vm.relation).then(function success() {
	                $mdDialog.hide();
	            });
	        }
	    }
	}

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RelationFilters.$inject = ["$compile", "$templateCache"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RelationFilters;
	
	__webpack_require__(802);
	
	var _relationFiltersTpl = __webpack_require__(1474);
	
	var _relationFiltersTpl2 = _interopRequireDefault(_relationFiltersTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function RelationFilters($compile, $templateCache) {
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            allowedEntityTypes: '=?'
	        },
	        link: linker
	    };
	
	    function linker(scope, element, attrs, ngModelCtrl) {
	
	        var template = $templateCache.get(_relationFiltersTpl2.default);
	        element.html(template);
	
	        scope.relationFilters = [];
	
	        scope.addFilter = addFilter;
	        scope.removeFilter = removeFilter;
	
	        ngModelCtrl.$render = function () {
	            if (scope.relationFiltersWatch) {
	                scope.relationFiltersWatch();
	                scope.relationFiltersWatch = null;
	            }
	            if (ngModelCtrl.$viewValue) {
	                var value = ngModelCtrl.$viewValue;
	                scope.relationFilters.length = 0;
	                value.forEach(function (filter) {
	                    scope.relationFilters.push(filter);
	                });
	            }
	            scope.relationFiltersWatch = scope.$watch('relationFilters', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    updateValue();
	                }
	            }, true);
	        };
	
	        function addFilter() {
	            var filter = {
	                relationType: null,
	                entityTypes: []
	            };
	            scope.relationFilters.push(filter);
	        }
	
	        function removeFilter($event, filter) {
	            var index = scope.relationFilters.indexOf(filter);
	            if (index > -1) {
	                scope.relationFilters.splice(index, 1);
	            }
	        }
	
	        function updateValue() {
	            var value = ngModelCtrl.$viewValue;
	            if (!value) {
	                value = [];
	                ngModelCtrl.$setViewValue(value);
	            } else {
	                value.length = 0;
	            }
	            scope.relationFilters.forEach(function (filter) {
	                value.push(filter);
	            });
	        }
	        $compile(element.contents())(scope);
	    }
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RelationTableController.$inject = ["$scope", "$q", "$mdDialog", "$document", "$translate", "$filter", "$timeout", "utils", "types", "entityRelationService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RelationTable;
	
	__webpack_require__(190);
	
	__webpack_require__(803);
	
	var _relationTableTpl = __webpack_require__(1475);
	
	var _relationTableTpl2 = _interopRequireDefault(_relationTableTpl);
	
	var _relationDialogTpl = __webpack_require__(1473);
	
	var _relationDialogTpl2 = _interopRequireDefault(_relationDialogTpl);
	
	var _relationDialog = __webpack_require__(1268);
	
	var _relationDialog2 = _interopRequireDefault(_relationDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	function RelationTable() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            entityId: '=',
	            entityType: '@'
	        },
	        controller: RelationTableController,
	        controllerAs: 'vm',
	        templateUrl: _relationTableTpl2.default
	    };
	}
	
	/*@ngInject*/
	
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function RelationTableController($scope, $q, $mdDialog, $document, $translate, $filter, $timeout, utils, types, entityRelationService) {
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.direction = vm.types.entitySearchDirection.from;
	
	    vm.relations = [];
	    vm.relationsCount = 0;
	    vm.allRelations = [];
	    vm.selectedRelations = [];
	
	    vm.query = {
	        order: 'type',
	        limit: 5,
	        page: 1,
	        search: null
	    };
	
	    vm.enterFilterMode = enterFilterMode;
	    vm.exitFilterMode = exitFilterMode;
	    vm.onReorder = onReorder;
	    vm.onPaginate = onPaginate;
	    vm.addRelation = addRelation;
	    vm.editRelation = editRelation;
	    vm.deleteRelation = deleteRelation;
	    vm.deleteRelations = deleteRelations;
	    vm.reloadRelations = reloadRelations;
	    vm.updateRelations = updateRelations;
	
	    $scope.$watch("vm.entityId", function (newVal, prevVal) {
	        if (newVal && !angular.equals(newVal, prevVal)) {
	            reloadRelations();
	        }
	    });
	
	    $scope.$watch("vm.direction", function (newVal, prevVal) {
	        if (newVal && !angular.equals(newVal, prevVal)) {
	            reloadRelations();
	        }
	    });
	
	    $scope.$watch("vm.query.search", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
	            updateRelations();
	        }
	    });
	
	    function enterFilterMode(event) {
	        var $button = angular.element(event.currentTarget);
	        var $toolbarsContainer = $button.closest('.toolbarsContainer');
	
	        vm.query.search = '';
	
	        $timeout(function () {
	            $toolbarsContainer.find('.searchInput').focus();
	        });
	    }
	
	    function exitFilterMode() {
	        vm.query.search = null;
	        updateRelations();
	    }
	
	    function onReorder() {
	        updateRelations();
	    }
	
	    function onPaginate() {
	        updateRelations();
	    }
	
	    function addRelation($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        openRelationDialog($event);
	    }
	
	    function editRelation($event, relation) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        openRelationDialog($event, relation);
	    }
	
	    function openRelationDialog($event, relation) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var isAdd = false;
	        if (!relation) {
	            isAdd = true;
	            var entityId = {
	                id: vm.entityId,
	                entityType: vm.entityType
	            };
	            relation = {};
	            if (vm.direction == vm.types.entitySearchDirection.from) {
	                relation.from = entityId;
	            } else {
	                relation.to = entityId;
	            }
	        }
	        var onShowingCallback = {
	            onShowing: function onShowing() {}
	        };
	        $mdDialog.show({
	            controller: _relationDialog2.default,
	            controllerAs: 'vm',
	            templateUrl: _relationDialogTpl2.default,
	            parent: angular.element($document[0].body),
	            locals: { isAdd: isAdd,
	                direction: vm.direction,
	                relation: relation,
	                showingCallback: onShowingCallback },
	            targetEvent: $event,
	            fullscreen: true,
	            skipHide: true,
	            onShowing: function onShowing(scope, element) {
	                onShowingCallback.onShowing(scope, element);
	            }
	        }).then(function () {
	            reloadRelations();
	        }, function () {});
	    }
	
	    function deleteRelation($event, relation) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (relation) {
	            var title;
	            var content;
	            if (vm.direction == vm.types.entitySearchDirection.from) {
	                title = $translate.instant('relation.delete-to-relation-title', { entityName: relation.toName });
	                content = $translate.instant('relation.delete-to-relation-text', { entityName: relation.toName });
	            } else {
	                title = $translate.instant('relation.delete-from-relation-title', { entityName: relation.fromName });
	                content = $translate.instant('relation.delete-from-relation-text', { entityName: relation.fromName });
	            }
	
	            var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(title).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	            $mdDialog.show(confirm).then(function () {
	                entityRelationService.deleteRelation(relation.from.id, relation.from.entityType, relation.type, relation.to.id, relation.to.entityType).then(function success() {
	                    reloadRelations();
	                });
	            });
	        }
	    }
	
	    function deleteRelations($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.selectedRelations && vm.selectedRelations.length > 0) {
	            var title;
	            var content;
	            if (vm.direction == vm.types.entitySearchDirection.from) {
	                title = $translate.instant('relation.delete-to-relations-title', { count: vm.selectedRelations.length }, 'messageformat');
	                content = $translate.instant('relation.delete-to-relations-text');
	            } else {
	                title = $translate.instant('relation.delete-from-relations-title', { count: vm.selectedRelations.length }, 'messageformat');
	                content = $translate.instant('relation.delete-from-relations-text');
	            }
	            var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(title).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	            $mdDialog.show(confirm).then(function () {
	                var tasks = [];
	                for (var i = 0; i < vm.selectedRelations.length; i++) {
	                    var relation = vm.selectedRelations[i];
	                    tasks.push(entityRelationService.deleteRelation(relation.from.id, relation.from.entityType, relation.type, relation.to.id, relation.to.entityType));
	                }
	                $q.all(tasks).then(function () {
	                    reloadRelations();
	                });
	            });
	        }
	    }
	
	    function reloadRelations() {
	        vm.allRelations.length = 0;
	        vm.relations.length = 0;
	        vm.relationsPromise;
	        if (vm.direction == vm.types.entitySearchDirection.from) {
	            vm.relationsPromise = entityRelationService.findInfoByFrom(vm.entityId, vm.entityType);
	        } else {
	            vm.relationsPromise = entityRelationService.findInfoByTo(vm.entityId, vm.entityType);
	        }
	        vm.relationsPromise.then(function success(allRelations) {
	            allRelations.forEach(function (relation) {
	                if (vm.direction == vm.types.entitySearchDirection.from) {
	                    relation.toEntityTypeName = $translate.instant(types.entityTypeTranslations[relation.to.entityType].type);
	                } else {
	                    relation.fromEntityTypeName = $translate.instant(types.entityTypeTranslations[relation.from.entityType].type);
	                }
	            });
	            vm.allRelations = allRelations;
	            vm.selectedRelations = [];
	            vm.updateRelations();
	            vm.relationsPromise = null;
	        }, function fail() {
	            vm.allRelations = [];
	            vm.selectedRelations = [];
	            vm.updateRelations();
	            vm.relationsPromise = null;
	        });
	    }
	
	    function updateRelations() {
	        vm.selectedRelations = [];
	        var result = $filter('orderBy')(vm.allRelations, vm.query.order);
	        if (vm.query.search != null) {
	            result = $filter('filter')(result, { $: vm.query.search });
	        }
	        vm.relationsCount = result.length;
	        var startIndex = vm.query.limit * (vm.query.page - 1);
	        vm.relations = result.slice(startIndex, startIndex + vm.query.limit);
	    }
	}

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RelationTypeAutocomplete.$inject = ["$compile", "$templateCache", "$q", "$filter", "assetService", "deviceService", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RelationTypeAutocomplete;
	
	__webpack_require__(804);
	
	var _relationTypeAutocompleteTpl = __webpack_require__(1476);
	
	var _relationTypeAutocompleteTpl2 = _interopRequireDefault(_relationTypeAutocompleteTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function RelationTypeAutocomplete($compile, $templateCache, $q, $filter, assetService, deviceService, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_relationTypeAutocompleteTpl2.default);
	        element.html(template);
	
	        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
	        scope.hideLabel = angular.isDefined(attrs.hideLabel) ? true : false;
	
	        scope.relationType = null;
	        scope.relationTypeSearchText = '';
	        scope.relationTypes = [];
	        for (var type in types.entityRelationType) {
	            scope.relationTypes.push(types.entityRelationType[type]);
	        }
	
	        scope.fetchRelationTypes = function (searchText) {
	            var deferred = $q.defer();
	            var result = $filter('filter')(scope.relationTypes, { '$': searchText });
	            if (result && result.length) {
	                deferred.resolve(result);
	            } else {
	                deferred.resolve([searchText]);
	            }
	            return deferred.promise;
	        };
	
	        scope.relationTypeSearchTextChanged = function () {};
	
	        scope.updateView = function () {
	            if (!scope.disabled) {
	                ngModelCtrl.$setViewValue(scope.relationType);
	            }
	        };
	
	        ngModelCtrl.$render = function () {
	            scope.relationType = ngModelCtrl.$viewValue;
	        };
	
	        scope.$watch('relationType', function (newValue, prevValue) {
	            if (!angular.equals(newValue, prevValue)) {
	                scope.updateView();
	            }
	        });
	
	        scope.$watch('disabled', function () {
	            scope.updateView();
	        });
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            theForm: '=?',
	            tbRequired: '=?',
	            disabled: '=ngDisabled'
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EventContentDialogController.$inject = ["$mdDialog", "types", "content", "contentType", "title", "showingCallback"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EventContentDialogController;
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(33);
	
	__webpack_require__(277);
	
	__webpack_require__(61);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable angular/angularelement */
	
	var js_beautify = _jsBeautify2.default.js;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function EventContentDialogController($mdDialog, types, content, contentType, title, showingCallback) {
	
	    var vm = this;
	
	    showingCallback.onShowing = function (scope, element) {
	        updateEditorSize(element);
	    };
	
	    vm.content = content;
	    vm.title = title;
	
	    var mode;
	    if (contentType) {
	        mode = types.contentType[contentType].code;
	        if (contentType == types.contentType.JSON.value && vm.content) {
	            vm.content = js_beautify(vm.content, { indent_size: 4 });
	        }
	    } else {
	        mode = 'java';
	    }
	
	    vm.contentOptions = {
	        useWrapMode: false,
	        mode: mode,
	        showGutter: false,
	        showPrintMargin: false,
	        theme: 'github',
	        advanced: {
	            enableSnippets: false,
	            enableBasicAutocompletion: false,
	            enableLiveAutocompletion: false
	        },
	        onLoad: function onLoad(_ace) {
	            vm.editor = _ace;
	        }
	    };
	
	    function updateEditorSize(element) {
	        var newHeight = 400;
	        var newWidth = 600;
	        if (vm.content && vm.content.length > 0) {
	            var lines = vm.content.split('\n');
	            newHeight = 16 * lines.length + 16;
	            var maxLineLength = 0;
	            for (var i = 0; i < lines.length; i++) {
	                var line = lines[i].replace(/\t/g, '    ').replace(/\n/g, '');
	                var lineLength = line.length;
	                maxLineLength = Math.max(maxLineLength, lineLength);
	            }
	            newWidth = 8 * maxLineLength + 16;
	        }
	        (0, _jquery2.default)('#tb-event-content', element).height(newHeight.toString() + "px").width(newWidth.toString() + "px");
	        vm.editor.resize();
	    }
	
	    vm.close = close;
	
	    function close() {
	        $mdDialog.hide();
	    }
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EventHeaderDirective.$inject = ["$compile", "$templateCache", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EventHeaderDirective;
	
	var _eventHeaderLcEventTpl = __webpack_require__(1480);
	
	var _eventHeaderLcEventTpl2 = _interopRequireDefault(_eventHeaderLcEventTpl);
	
	var _eventHeaderStatsTpl = __webpack_require__(1481);
	
	var _eventHeaderStatsTpl2 = _interopRequireDefault(_eventHeaderStatsTpl);
	
	var _eventHeaderErrorTpl = __webpack_require__(1479);
	
	var _eventHeaderErrorTpl2 = _interopRequireDefault(_eventHeaderErrorTpl);
	
	var _eventHeaderDebugRulenodeTpl = __webpack_require__(1478);
	
	var _eventHeaderDebugRulenodeTpl2 = _interopRequireDefault(_eventHeaderDebugRulenodeTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function EventHeaderDirective($compile, $templateCache, types) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        var getTemplate = function getTemplate(eventType) {
	            var template = '';
	            switch (eventType) {
	                case types.eventType.lcEvent.value:
	                    template = _eventHeaderLcEventTpl2.default;
	                    break;
	                case types.eventType.stats.value:
	                    template = _eventHeaderStatsTpl2.default;
	                    break;
	                case types.eventType.error.value:
	                    template = _eventHeaderErrorTpl2.default;
	                    break;
	                case types.debugEventType.debugRuleNode.value:
	                    template = _eventHeaderDebugRulenodeTpl2.default;
	                    break;
	                case types.debugEventType.debugRuleChain.value:
	                    template = _eventHeaderDebugRulenodeTpl2.default;
	                    break;
	            }
	            return $templateCache.get(template);
	        };
	
	        scope.loadTemplate = function () {
	            element.html(getTemplate(attrs.eventType));
	            $compile(element.contents())(scope);
	        };
	
	        attrs.$observe('eventType', function () {
	            scope.loadTemplate();
	        });
	    };
	
	    return {
	        restrict: "A",
	        replace: false,
	        link: linker,
	        scope: false
	    };
	}

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EventRowDirective.$inject = ["$compile", "$templateCache", "$mdDialog", "$document", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EventRowDirective;
	
	var _eventContentDialogTpl = __webpack_require__(1477);
	
	var _eventContentDialogTpl2 = _interopRequireDefault(_eventContentDialogTpl);
	
	var _eventRowLcEventTpl = __webpack_require__(1484);
	
	var _eventRowLcEventTpl2 = _interopRequireDefault(_eventRowLcEventTpl);
	
	var _eventRowStatsTpl = __webpack_require__(1485);
	
	var _eventRowStatsTpl2 = _interopRequireDefault(_eventRowStatsTpl);
	
	var _eventRowErrorTpl = __webpack_require__(1483);
	
	var _eventRowErrorTpl2 = _interopRequireDefault(_eventRowErrorTpl);
	
	var _eventRowDebugRulenodeTpl = __webpack_require__(1482);
	
	var _eventRowDebugRulenodeTpl2 = _interopRequireDefault(_eventRowDebugRulenodeTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function EventRowDirective($compile, $templateCache, $mdDialog, $document, types) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        var getTemplate = function getTemplate(eventType) {
	            var template = '';
	            switch (eventType) {
	                case types.eventType.lcEvent.value:
	                    template = _eventRowLcEventTpl2.default;
	                    break;
	                case types.eventType.stats.value:
	                    template = _eventRowStatsTpl2.default;
	                    break;
	                case types.eventType.error.value:
	                    template = _eventRowErrorTpl2.default;
	                    break;
	                case types.debugEventType.debugRuleNode.value:
	                    template = _eventRowDebugRulenodeTpl2.default;
	                    break;
	                case types.debugEventType.debugRuleChain.value:
	                    template = _eventRowDebugRulenodeTpl2.default;
	                    break;
	            }
	            return $templateCache.get(template);
	        };
	
	        scope.loadTemplate = function () {
	            element.html(getTemplate(attrs.eventType));
	            $compile(element.contents())(scope);
	        };
	
	        attrs.$observe('eventType', function () {
	            scope.loadTemplate();
	        });
	
	        scope.types = types;
	
	        scope.event = attrs.event;
	
	        scope.showContent = function ($event, content, title, contentType) {
	            var onShowingCallback = {
	                onShowing: function onShowing() {}
	            };
	            if (!contentType) {
	                contentType = null;
	            }
	            $mdDialog.show({
	                controller: 'EventContentDialogController',
	                controllerAs: 'vm',
	                templateUrl: _eventContentDialogTpl2.default,
	                locals: { content: content, title: title, contentType: contentType, showingCallback: onShowingCallback },
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: $event,
	                skipHide: true,
	                onShowing: function onShowing(scope, element) {
	                    onShowingCallback.onShowing(scope, element);
	                }
	            });
	        };
	
	        scope.checkTooltip = function ($event) {
	            var el = $event.target;
	            var $el = angular.element(el);
	            if (el.offsetWidth < el.scrollWidth && !$el.attr('title')) {
	                $el.attr('title', $el.text());
	            }
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "A",
	        replace: false,
	        link: linker,
	        scope: false
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EventTableDirective.$inject = ["$compile", "$templateCache", "$rootScope", "types", "eventService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EventTableDirective;
	
	__webpack_require__(805);
	
	var _eventTableTpl = __webpack_require__(1486);
	
	var _eventTableTpl2 = _interopRequireDefault(_eventTableTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function EventTableDirective($compile, $templateCache, $rootScope, types, eventService) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        var template = $templateCache.get(_eventTableTpl2.default);
	
	        element.html(template);
	
	        if (attrs.disabledEventTypes) {
	            var disabledEventTypes = attrs.disabledEventTypes.split(',');
	            scope.eventTypes = {};
	            for (var type in types.eventType) {
	                var eventType = types.eventType[type];
	                var enabled = true;
	                for (var i = 0; i < disabledEventTypes.length; i++) {
	                    if (eventType.value === disabledEventTypes[i]) {
	                        enabled = false;
	                        break;
	                    }
	                }
	                if (enabled) {
	                    scope.eventTypes[type] = eventType;
	                }
	            }
	        } else {
	            scope.eventTypes = angular.copy(types.eventType);
	        }
	
	        if (attrs.debugEventTypes) {
	            var debugEventTypes = attrs.debugEventTypes.split(',');
	            for (i = 0; i < debugEventTypes.length; i++) {
	                for (type in types.debugEventType) {
	                    eventType = types.debugEventType[type];
	                    if (eventType.value === debugEventTypes[i]) {
	                        scope.eventTypes[type] = eventType;
	                    }
	                }
	            }
	        }
	
	        scope.eventType = attrs.defaultEventType;
	
	        var pageSize = 20;
	        var startTime = 0;
	        var endTime = 0;
	
	        scope.timewindow = {
	            history: {
	                timewindowMs: 24 * 60 * 60 * 1000 // 1 day
	            }
	        };
	
	        scope.topIndex = 0;
	
	        scope.theEvents = {
	            getItemAtIndex: function getItemAtIndex(index) {
	                if (index > scope.events.data.length) {
	                    scope.theEvents.fetchMoreItems_(index);
	                    return null;
	                }
	                var item = scope.events.data[index];
	                if (item) {
	                    item.indexNumber = index + 1;
	                }
	                return item;
	            },
	
	            getLength: function getLength() {
	                if (scope.events.hasNext) {
	                    return scope.events.data.length + scope.events.nextPageLink.limit;
	                } else {
	                    return scope.events.data.length;
	                }
	            },
	
	            fetchMoreItems_: function fetchMoreItems_() {
	                if (scope.events.hasNext && !scope.events.pending) {
	                    if (scope.entityType && scope.entityId && scope.eventType && scope.tenantId) {
	                        var promise = eventService.getEvents(scope.entityType, scope.entityId, scope.eventType, scope.tenantId, scope.events.nextPageLink);
	                        if (promise) {
	                            scope.events.pending = true;
	                            promise.then(function success(events) {
	                                scope.events.data = scope.events.data.concat(events.data);
	                                scope.events.nextPageLink = events.nextPageLink;
	                                scope.events.hasNext = events.hasNext;
	                                if (scope.events.hasNext) {
	                                    scope.events.nextPageLink.limit = pageSize;
	                                }
	                                scope.events.pending = false;
	                            }, function fail() {
	                                scope.events.hasNext = false;
	                                scope.events.pending = false;
	                            });
	                        } else {
	                            scope.events.hasNext = false;
	                        }
	                    } else {
	                        scope.events.hasNext = false;
	                    }
	                }
	            }
	        };
	
	        scope.$watch("entityId", function (newVal, prevVal) {
	            if (newVal && !angular.equals(newVal, prevVal)) {
	                scope.resetFilter();
	                scope.reload();
	            }
	        });
	
	        scope.$watch("eventType", function (newVal, prevVal) {
	            if (newVal && !angular.equals(newVal, prevVal)) {
	                scope.reload();
	            }
	        });
	
	        scope.$watch("timewindow", function (newVal, prevVal) {
	            if (newVal && !angular.equals(newVal, prevVal)) {
	                scope.reload();
	            }
	        }, true);
	
	        scope.resetFilter = function () {
	            scope.timewindow = {
	                history: {
	                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
	                }
	            };
	            scope.eventType = attrs.defaultEventType;
	        };
	
	        scope.updateTimeWindowRange = function () {
	            if (scope.timewindow.history.timewindowMs) {
	                var currentTime = new Date().getTime();
	                startTime = currentTime - scope.timewindow.history.timewindowMs;
	                endTime = currentTime;
	            } else {
	                startTime = scope.timewindow.history.fixedTimewindow.startTimeMs;
	                endTime = scope.timewindow.history.fixedTimewindow.endTimeMs;
	            }
	        };
	
	        scope.reload = function () {
	            scope.topIndex = 0;
	            scope.selected = [];
	            scope.updateTimeWindowRange();
	            scope.events = {
	                data: [],
	                nextPageLink: {
	                    limit: pageSize,
	                    startTime: startTime,
	                    endTime: endTime
	                },
	                hasNext: true,
	                pending: false
	            };
	            scope.theEvents.getItemAtIndex(pageSize);
	        };
	
	        scope.noData = function () {
	            return scope.events.data.length == 0 && !scope.events.hasNext;
	        };
	
	        scope.hasData = function () {
	            return scope.events.data.length > 0;
	        };
	
	        scope.loading = function () {
	            return $rootScope.loading;
	        };
	
	        scope.hasScroll = function () {
	            var repeatContainer = scope.repeatContainer[0];
	            if (repeatContainer) {
	                var scrollElement = repeatContainer.children[0];
	                if (scrollElement) {
	                    return scrollElement.scrollHeight > scrollElement.clientHeight;
	                }
	            }
	            return false;
	        };
	
	        scope.reload();
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            entityType: '=',
	            entityId: '=',
	            tenantId: '='
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _event = __webpack_require__(1144);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _eventContentDialog = __webpack_require__(1272);
	
	var _eventContentDialog2 = _interopRequireDefault(_eventContentDialog);
	
	var _eventHeader = __webpack_require__(1273);
	
	var _eventHeader2 = _interopRequireDefault(_eventHeader);
	
	var _eventRow = __webpack_require__(1274);
	
	var _eventRow2 = _interopRequireDefault(_eventRow);
	
	var _eventTable = __webpack_require__(1275);
	
	var _eventTable2 = _interopRequireDefault(_eventTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.event', [_event2.default]).controller('EventContentDialogController', _eventContentDialog2.default).directive('tbEventHeader', _eventHeader2.default).directive('tbEventRow', _eventRow2.default).directive('tbEventTable', _eventTable2.default).name; /*
	                                                                                                                                                                                                                                                                                                       * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                       *
	                                                                                                                                                                                                                                                                                                       * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                       * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                       * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                       *
	                                                                                                                                                                                                                                                                                                       *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                       *
	                                                                                                                                                                                                                                                                                                       * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                       * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                       * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                       * limitations under the License.
	                                                                                                                                                                                                                                                                                                       */

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ExtensionTableController.$inject = ["$scope", "$filter", "$document", "$translate", "$timeout", "$mdDialog", "types", "attributeService", "telemetryWebsocketService", "importExport"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ExtensionTableDirective;
	
	__webpack_require__(190);
	
	__webpack_require__(806);
	
	var _extensionTableTpl = __webpack_require__(1488);
	
	var _extensionTableTpl2 = _interopRequireDefault(_extensionTableTpl);
	
	var _extensionDialogTpl = __webpack_require__(1487);
	
	var _extensionDialogTpl2 = _interopRequireDefault(_extensionDialogTpl);
	
	var _extensionDialog = __webpack_require__(511);
	
	var _extensionDialog2 = _interopRequireDefault(_extensionDialog);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function ExtensionTableDirective() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            entityId: '=',
	            entityType: '@',
	            inWidget: '@?',
	            ctx: '=?',
	            entityName: '='
	        },
	        controller: ExtensionTableController,
	        controllerAs: 'vm',
	        templateUrl: _extensionTableTpl2.default
	    };
	}
	
	/*@ngInject*/
	function ExtensionTableController($scope, $filter, $document, $translate, $timeout, $mdDialog, types, attributeService, telemetryWebsocketService, importExport) {
	
	    var vm = this;
	
	    vm.extensions = [];
	    vm.allExtensions = [];
	    vm.selectedExtensions = [];
	    vm.extensionsCount = 0;
	
	    vm.query = {
	        order: 'id',
	        limit: 5,
	        page: 1,
	        search: null
	    };
	
	    vm.enterFilterMode = enterFilterMode;
	    vm.exitFilterMode = exitFilterMode;
	    vm.onReorder = onReorder;
	    vm.onPaginate = onPaginate;
	    vm.addExtension = addExtension;
	    vm.editExtension = editExtension;
	    vm.deleteExtension = deleteExtension;
	    vm.deleteExtensions = deleteExtensions;
	    vm.reloadExtensions = reloadExtensions;
	    vm.updateExtensions = updateExtensions;
	
	    $scope.$watch("vm.entityId", function (newVal) {
	        if (newVal) {
	            if ($scope.subscriber) {
	                telemetryWebsocketService.unsubscribe($scope.subscriber);
	                $scope.subscriber = null;
	            }
	
	            vm.subscribed = false;
	            vm.syncLastTime = $translate.instant('extension.sync.not-available');
	
	            subscribeForClientAttributes();
	
	            reloadExtensions();
	        }
	    });
	
	    $scope.$on('$destroy', function () {
	        if ($scope.subscriber) {
	            telemetryWebsocketService.unsubscribe($scope.subscriber);
	            $scope.subscriber = null;
	        }
	    });
	
	    $scope.$watch("vm.query.search", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
	            updateExtensions();
	        }
	    });
	
	    $scope.$watch('vm.selectedExtensions.length', function (newLength) {
	        var selectionMode = newLength ? true : false;
	        if (vm.ctx) {
	            if (selectionMode) {
	                vm.ctx.hideTitlePanel = true;
	                $scope.$emit("selectedExtensions", true);
	            } else if (vm.query.search == null) {
	                vm.ctx.hideTitlePanel = false;
	                $scope.$emit("selectedExtensions", false);
	            }
	        }
	    });
	
	    $scope.$on("showSearch", function ($event, source) {
	        if (source.entityId == vm.entityId) {
	            enterFilterMode();
	            $scope.$emit("filterMode", true);
	        }
	    });
	    $scope.$on("refreshExtensions", function ($event, source) {
	        if (source.entityId == vm.entityId) {
	            reloadExtensions();
	        }
	    });
	    $scope.$on("addExtension", function ($event, source) {
	        if (source.entityId == vm.entityId) {
	            addExtension();
	        }
	    });
	    $scope.$on("exportExtensions", function ($event, source) {
	        if (source.entityId == vm.entityId) {
	            vm.exportExtensions(source.entityName);
	        }
	    });
	    $scope.$on("importExtensions", function ($event, source) {
	        if (source.entityId == vm.entityId) {
	            vm.importExtensions();
	        }
	    });
	
	    function enterFilterMode(event) {
	        var $button = angular.element(event.currentTarget);
	        var $toolbarsContainer = $button.closest('.toolbarsContainer');
	
	        vm.query.search = '';
	        if (vm.inWidget) {
	            vm.ctx.hideTitlePanel = true;
	        }
	        $timeout(function () {
	            $toolbarsContainer.find('.searchInput').focus();
	        });
	    }
	
	    function exitFilterMode() {
	        vm.query.search = null;
	        updateExtensions();
	        if (vm.inWidget) {
	            vm.ctx.hideTitlePanel = false;
	            $scope.$emit("filterMode", false);
	        }
	    }
	
	    function onReorder() {
	        updateExtensions();
	    }
	
	    function onPaginate() {
	        updateExtensions();
	    }
	
	    function addExtension($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        openExtensionDialog($event);
	    }
	
	    function editExtension($event, extension) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        openExtensionDialog($event, extension);
	    }
	
	    function openExtensionDialog($event, extension) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var isAdd = false;
	        if (!extension) {
	            isAdd = true;
	        }
	        $mdDialog.show({
	            controller: _extensionDialog2.default,
	            controllerAs: 'vm',
	            templateUrl: _extensionDialogTpl2.default,
	            parent: angular.element($document[0].body),
	            locals: {
	                isAdd: isAdd,
	                allExtensions: vm.allExtensions,
	                entityId: vm.entityId,
	                entityType: vm.entityType,
	                extension: extension
	            },
	            bindToController: true,
	            targetEvent: $event,
	            fullscreen: true,
	            skipHide: true
	        }).then(function () {
	            reloadExtensions();
	        }, function () {});
	    }
	
	    function deleteExtension($event, extension) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (extension) {
	            var title = $translate.instant('extension.delete-extension-title', { extensionId: extension.id });
	            var content = $translate.instant('extension.delete-extension-text');
	
	            var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(title).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	            $mdDialog.show(confirm).then(function () {
	                var editedExtensions = vm.allExtensions.filter(function (ext) {
	                    return ext.id !== extension.id;
	                });
	                var editedValue = angular.toJson(editedExtensions);
	                attributeService.saveEntityAttributes(vm.entityType, vm.entityId, types.attributesScope.shared.value, [{ key: "configuration", value: editedValue }]).then(function success() {
	                    reloadExtensions();
	                });
	            });
	        }
	    }
	
	    function deleteExtensions($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.selectedExtensions && vm.selectedExtensions.length > 0) {
	            var title = $translate.instant('extension.delete-extensions-title', { count: vm.selectedExtensions.length }, 'messageformat');
	            var content = $translate.instant('extension.delete-extensions-text');
	
	            var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(title).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	            $mdDialog.show(confirm).then(function () {
	                var editedExtensions = angular.copy(vm.allExtensions);
	                for (var i = 0; i < vm.selectedExtensions.length; i++) {
	                    editedExtensions = editedExtensions.filter(function (ext) {
	                        return ext.id !== vm.selectedExtensions[i].id;
	                    });
	                }
	                var editedValue = angular.toJson(editedExtensions);
	                attributeService.saveEntityAttributes(vm.entityType, vm.entityId, types.attributesScope.shared.value, [{ key: "configuration", value: editedValue }]).then(function success() {
	                    reloadExtensions();
	                });
	            });
	        }
	    }
	
	    function reloadExtensions() {
	        vm.subscribed = false;
	        vm.allExtensions.length = 0;
	        vm.extensions.length = 0;
	        vm.extensionsPromise = attributeService.getEntityAttributesValues(vm.entityType, vm.entityId, types.attributesScope.shared.value, ["configuration"]);
	        vm.extensionsPromise.then(function success(data) {
	            if (data.length) {
	                vm.allExtensions = angular.fromJson(data[0].value);
	            } else {
	                vm.allExtensions = [];
	            }
	
	            vm.selectedExtensions = [];
	            updateExtensions();
	            vm.extensionsPromise = null;
	        }, function fail() {
	            vm.extensions = [];
	            vm.selectedExtensions = [];
	            updateExtensions();
	            vm.extensionsPromise = null;
	        });
	    }
	
	    function updateExtensions() {
	        vm.selectedExtensions = [];
	        var result = $filter('orderBy')(vm.allExtensions, vm.query.order);
	        if (vm.query.search != null) {
	            result = $filter('filter')(result, function (extension) {
	                if (!vm.query.search || extension.id.indexOf(vm.query.search) != -1 || extension.type.indexOf(vm.query.search) != -1) {
	                    return true;
	                }
	                return false;
	            });
	        }
	        vm.extensionsCount = result.length;
	        var startIndex = vm.query.limit * (vm.query.page - 1);
	        vm.extensions = result.slice(startIndex, startIndex + vm.query.limit);
	
	        vm.extensionsJSON = angular.toJson(vm.extensions);
	        checkForSync();
	    }
	
	    function subscribeForClientAttributes() {
	        if (!vm.subscribed) {
	            if (vm.entityId && vm.entityType) {
	                $scope.subscriber = {
	                    subscriptionCommands: [{
	                        entityType: vm.entityType,
	                        entityId: vm.entityId,
	                        scope: 'CLIENT_SCOPE'
	                    }],
	                    type: 'attribute',
	                    onData: function onData(data) {
	                        if (data.data) {
	                            onSubscriptionData(data.data);
	                        }
	                        vm.subscribed = true;
	                    }
	                };
	                telemetryWebsocketService.subscribe($scope.subscriber);
	            }
	        }
	    }
	    function onSubscriptionData(data) {
	
	        if (_jquery2.default.isEmptyObject(data)) {
	            vm.appliedConfiguration = undefined;
	        } else {
	            if (data.appliedConfiguration && data.appliedConfiguration[0] && data.appliedConfiguration[0][1]) {
	                vm.appliedConfiguration = data.appliedConfiguration[0][1];
	            }
	        }
	
	        updateExtensions();
	        $scope.$digest();
	    }
	
	    function checkForSync() {
	        if (vm.appliedConfiguration && vm.extensionsJSON && vm.appliedConfiguration === vm.extensionsJSON) {
	            vm.syncStatus = $translate.instant('extension.sync.sync');
	            vm.syncLastTime = formatDate();
	            $scope.isSync = true;
	        } else {
	            vm.syncStatus = $translate.instant('extension.sync.not-sync');
	
	            $scope.isSync = false;
	        }
	    }
	
	    function formatDate(date) {
	        var d = void 0;
	        if (date) {
	            d = date;
	        } else {
	            d = new Date();
	        }
	
	        d = d.getFullYear() + '/' + addZero(d.getMonth() + 1) + '/' + addZero(d.getDate()) + ' ' + addZero(d.getHours()) + ':' + addZero(d.getMinutes()) + ':' + addZero(d.getSeconds());
	        return d;
	
	        function addZero(num) {
	            if (angular.isNumber(num) && num < 10 || angular.isString(num) && num.length === 1) {
	                num = '0' + num;
	            }
	            return num;
	        }
	    }
	
	    vm.importExtensions = function ($event) {
	        importExport.importExtension($event, { "entityType": vm.entityType, "entityId": vm.entityId, "successFunc": reloadExtensions });
	    };
	    vm.exportExtensions = function (widgetSourceEntityName) {
	        if (vm.inWidget) {
	            importExport.exportToPc(vm.extensionsJSON, widgetSourceEntityName + '_configuration.json');
	        } else {
	            importExport.exportToPc(vm.extensionsJSON, vm.entityName + '_configuration.json');
	        }
	    };
	
	    /*change function for widget implementing, like vm.exportExtensions*/
	    vm.exportExtension = function ($event, extension) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        importExport.exportToPc(extension, vm.entityName + '_' + extension.id + '_configuration.json');
	    };
	}

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ExtensionFormHttpDirective.$inject = ["$compile", "$templateCache", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ExtensionFormHttpDirective;
	
	__webpack_require__(33);
	
	__webpack_require__(51);
	
	__webpack_require__(61);
	
	__webpack_require__(128);
	
	var _extensionFormHttpTpl = __webpack_require__(1489);
	
	var _extensionFormHttpTpl2 = _interopRequireDefault(_extensionFormHttpTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function ExtensionFormHttpDirective($compile, $templateCache, $translate, types) {
	
	    var linker = function linker(scope, element) {
	
	        var template = $templateCache.get(_extensionFormHttpTpl2.default);
	        element.html(template);
	
	        scope.types = types;
	        scope.theForm = scope.$parent.theForm;
	
	        scope.extensionCustomTransformerOptions = {
	            useWrapMode: false,
	            mode: 'json',
	            showGutter: true,
	            showPrintMargin: true,
	            theme: 'github',
	            advanced: {
	                enableSnippets: true,
	                enableBasicAutocompletion: true,
	                enableLiveAutocompletion: true
	            },
	            onLoad: function onLoad(_ace) {
	                _ace.$blockScrolling = 1;
	            }
	        };
	
	        scope.addConverterConfig = function () {
	            var newConverterConfig = { converterId: "", converters: [] };
	            scope.converterConfigs.push(newConverterConfig);
	
	            scope.converterConfigs[scope.converterConfigs.length - 1].converters = [];
	            scope.addConverter(scope.converterConfigs[scope.converterConfigs.length - 1].converters);
	        };
	
	        scope.removeConverterConfig = function (config) {
	            var index = scope.converterConfigs.indexOf(config);
	            if (index > -1) {
	                scope.converterConfigs.splice(index, 1);
	            }
	        };
	
	        scope.addConverter = function (converters) {
	            var newConverter = {
	                deviceNameJsonExpression: "",
	                deviceTypeJsonExpression: "",
	                attributes: [],
	                timeseries: []
	            };
	            converters.push(newConverter);
	        };
	
	        scope.removeConverter = function (converter, converters) {
	            var index = converters.indexOf(converter);
	            if (index > -1) {
	                converters.splice(index, 1);
	            }
	        };
	
	        scope.addAttribute = function (attributes) {
	            var newAttribute = { type: "", key: "", value: "" };
	            attributes.push(newAttribute);
	        };
	
	        scope.removeAttribute = function (attribute, attributes) {
	            var index = attributes.indexOf(attribute);
	            if (index > -1) {
	                attributes.splice(index, 1);
	            }
	        };
	
	        if (scope.isAdd) {
	            scope.converterConfigs = scope.config.converterConfigurations;
	            scope.addConverterConfig();
	        } else {
	            scope.converterConfigs = scope.config.converterConfigurations;
	        }
	
	        scope.transformerTypeChange = function (attribute) {
	            attribute.transformer = "";
	        };
	
	        scope.validateTransformer = function (model, editorName) {
	            if (model && model.length) {
	                try {
	                    angular.fromJson(model);
	                    scope.theForm[editorName].$setValidity('transformerJSON', true);
	                } catch (e) {
	                    scope.theForm[editorName].$setValidity('transformerJSON', false);
	                }
	            }
	        };
	
	        scope.collapseValidation = function (index, id) {
	            var invalidState = angular.element('#' + id + ':has(.ng-invalid)');
	            if (invalidState.length) {
	                invalidState.addClass('inner-invalid');
	            }
	        };
	
	        scope.expandValidation = function (index, id) {
	            var invalidState = angular.element('#' + id);
	            invalidState.removeClass('inner-invalid');
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "A",
	        link: linker,
	        scope: {
	            config: "=",
	            isAdd: "="
	        }
	    };
	}
	
	/* eslint-disable angular/log */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ExtensionFormModbusDirective.$inject = ["$compile", "$templateCache", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ExtensionFormModbusDirective;
	
	__webpack_require__(33);
	
	__webpack_require__(51);
	
	__webpack_require__(61);
	
	__webpack_require__(128);
	
	var _extensionFormModbusTpl = __webpack_require__(1490);
	
	var _extensionFormModbusTpl2 = _interopRequireDefault(_extensionFormModbusTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function ExtensionFormModbusDirective($compile, $templateCache, $translate, types) {
	
	    var linker = function linker(scope, element) {
	
	        function Server() {
	            this.transport = {
	                "type": "tcp",
	                "host": "localhost",
	                "port": 502,
	                "timeout": 3000
	            };
	            this.devices = [];
	        }
	
	        function Device() {
	            this.unitId = 1;
	            this.deviceName = "";
	            this.attributesPollPeriod = 1000;
	            this.timeseriesPollPeriod = 1000;
	            this.attributes = [];
	            this.timeseries = [];
	        }
	
	        function Tag(globalPollPeriod) {
	            this.tag = "";
	            this.type = "long";
	            this.pollPeriod = globalPollPeriod;
	            this.functionCode = 3;
	            this.address = 0;
	            this.registerCount = 1;
	            this.bit = 0;
	            this.byteOrder = "BIG";
	        }
	
	        var template = $templateCache.get(_extensionFormModbusTpl2.default);
	        element.html(template);
	
	        scope.types = types;
	        scope.theForm = scope.$parent.theForm;
	
	        if (!scope.configuration.servers.length) {
	            scope.configuration.servers.push(new Server());
	        }
	
	        scope.addServer = function (serversList) {
	            serversList.push(new Server());
	            scope.theForm.$setDirty();
	        };
	
	        scope.addDevice = function (deviceList) {
	            deviceList.push(new Device());
	            scope.theForm.$setDirty();
	        };
	
	        scope.addNewAttribute = function (device) {
	            device.attributes.push(new Tag(device.attributesPollPeriod));
	            scope.theForm.$setDirty();
	        };
	
	        scope.addNewTimeseries = function (device) {
	            device.timeseries.push(new Tag(device.timeseriesPollPeriod));
	            scope.theForm.$setDirty();
	        };
	
	        scope.removeItem = function (item, itemList) {
	            var index = itemList.indexOf(item);
	            if (index > -1) {
	                itemList.splice(index, 1);
	            }
	            scope.theForm.$setDirty();
	        };
	
	        scope.onTransportChanged = function (server) {
	            var type = server.transport.type;
	
	            server.transport = {};
	            server.transport.type = type;
	            server.transport.timeout = 3000;
	
	            scope.theForm.$setDirty();
	        };
	
	        $compile(element.contents())(scope);
	
	        scope.collapseValidation = function (index, id) {
	            var invalidState = angular.element('#' + id + ':has(.ng-invalid)');
	            if (invalidState.length) {
	                invalidState.addClass('inner-invalid');
	            }
	        };
	
	        scope.expandValidation = function (index, id) {
	            var invalidState = angular.element('#' + id);
	            invalidState.removeClass('inner-invalid');
	        };
	    };
	
	    return {
	        restrict: "A",
	        link: linker,
	        scope: {
	            configuration: "=",
	            isAdd: "="
	        }
	    };
	}
	
	/* eslint-disable angular/log */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ExtensionFormHttpDirective.$inject = ["$compile", "$templateCache", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ExtensionFormHttpDirective;
	
	__webpack_require__(128);
	
	var _extensionFormMqttTpl = __webpack_require__(1491);
	
	var _extensionFormMqttTpl2 = _interopRequireDefault(_extensionFormMqttTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function ExtensionFormHttpDirective($compile, $templateCache, $translate, types) {
	
	    var linker = function linker(scope, element) {
	
	        var template = $templateCache.get(_extensionFormMqttTpl2.default);
	        element.html(template);
	
	        scope.types = types;
	        scope.theForm = scope.$parent.theForm;
	
	        scope.deviceNameExpressions = {
	            deviceNameJsonExpression: "extension.converter-json",
	            deviceNameTopicExpression: "extension.topic"
	        };
	        scope.deviceTypeExpressions = {
	            deviceTypeJsonExpression: "extension.converter-json",
	            deviceTypeTopicExpression: "extension.topic"
	        };
	        scope.attributeKeyExpressions = {
	            attributeKeyJsonExpression: "extension.converter-json",
	            attributeKeyTopicExpression: "extension.topic"
	        };
	        scope.requestIdExpressions = {
	            requestIdJsonExpression: "extension.converter-json",
	            requestIdTopicExpression: "extension.topic"
	        };
	
	        scope.extensionCustomConverterOptions = {
	            useWrapMode: false,
	            mode: 'json',
	            showGutter: true,
	            showPrintMargin: true,
	            theme: 'github',
	            advanced: {
	                enableSnippets: true,
	                enableBasicAutocompletion: true,
	                enableLiveAutocompletion: true
	            },
	            onLoad: function onLoad(_ace) {
	                _ace.$blockScrolling = 1;
	            }
	        };
	
	        scope.updateValidity = function () {
	            if (scope.brokers.length) {
	                for (var i = 0; i < scope.brokers.length; i++) {
	                    if (scope.brokers[i].credentials.type == scope.types.mqttCredentialTypes.pem.value) {
	                        if (!(scope.brokers[i].credentials.caCert && scope.brokers[i].credentials.privateKey && scope.brokers[i].credentials.cert)) {
	                            scope.theForm.$setValidity('cert.PEM', false);
	                            break;
	                        } else {
	                            scope.theForm.$setValidity('cert.PEM', true);
	                        }
	                    }
	                }
	            }
	        };
	
	        scope.$watch('brokers', function () {
	            scope.updateValidity();
	        }, true);
	
	        scope.addBroker = function () {
	            var newBroker = {
	                host: "localhost",
	                port: 1882,
	                ssl: false,
	                retryInterval: 3000,
	                credentials: { type: "anonymous" },
	                mapping: [],
	                connectRequests: [],
	                disconnectRequests: [],
	                attributeRequests: [],
	                attributeUpdates: [],
	                serverSideRpc: []
	            };
	            scope.brokers.push(newBroker);
	        };
	
	        scope.removeBroker = function (broker) {
	            var index = scope.brokers.indexOf(broker);
	            if (index > -1) {
	                scope.brokers.splice(index, 1);
	            }
	        };
	
	        if (scope.isAdd) {
	            scope.brokers = [];
	            scope.config.brokers = scope.brokers;
	            scope.addBroker();
	        } else {
	            scope.brokers = scope.config.brokers;
	        }
	
	        scope.addMap = function (mapping) {
	            var newMap = { topicFilter: "sensors", converter: { attributes: [], timeseries: [] } };
	
	            mapping.push(newMap);
	        };
	
	        scope.removeMap = function (map, mapping) {
	            var index = mapping.indexOf(map);
	            if (index > -1) {
	                mapping.splice(index, 1);
	            }
	        };
	
	        scope.addAttribute = function (attributes) {
	            var newAttribute = { type: "", key: "", value: "" };
	            attributes.push(newAttribute);
	        };
	
	        scope.removeAttribute = function (attribute, attributes) {
	            var index = attributes.indexOf(attribute);
	            if (index > -1) {
	                attributes.splice(index, 1);
	            }
	        };
	
	        scope.addConnectRequest = function (requests, type) {
	            var newRequest = {};
	            if (type == "connect") {
	                newRequest.topicFilter = "sensors/connect";
	            } else {
	                newRequest.topicFilter = "sensors/disconnect";
	            }
	            requests.push(newRequest);
	        };
	
	        scope.addAttributeRequest = function (requests) {
	            var newRequest = {
	                topicFilter: "sensors/attributes",
	                clientScope: false,
	                responseTopicExpression: "sensors/${deviceName}/attributes/${responseId}",
	                valueExpression: "${attributeValue}"
	            };
	            requests.push(newRequest);
	        };
	
	        scope.addAttributeUpdate = function (updates) {
	            var newUpdate = {
	                deviceNameFilter: ".*",
	                attributeFilter: ".*",
	                topicExpression: "sensor/${deviceName}/${attributeKey}",
	                valueExpression: "{\"${attributeKey}\":\"${attributeValue}\"}"
	            };
	            updates.push(newUpdate);
	        };
	
	        scope.addServerSideRpc = function (rpcRequests) {
	            var newRpc = {
	                deviceNameFilter: ".*",
	                methodFilter: "echo",
	                requestTopicExpression: "sensor/${deviceName}/request/${methodName}/${requestId}",
	                responseTopicExpression: "sensor/${deviceName}/response/${methodName}/${requestId}",
	                responseTimeout: 10000,
	                valueExpression: "${params}"
	            };
	            rpcRequests.push(newRpc);
	        };
	
	        scope.changeCredentials = function (broker) {
	            var type = broker.credentials.type;
	            broker.credentials = {};
	            broker.credentials.type = type;
	        };
	
	        scope.changeConverterType = function (map) {
	            if (map.converterType == "custom") {
	                map.converter = "";
	            }
	            if (map.converterType == "json") {
	                map.converter = { attributes: [], timeseries: [] };
	            }
	        };
	
	        scope.changeNameExpression = function (element, type) {
	            if (element.nameExp == "deviceNameJsonExpression") {
	                if (element.deviceNameTopicExpression) {
	                    delete element.deviceNameTopicExpression;
	                }
	                if (type) {
	                    element.deviceNameJsonExpression = "${$.serialNumber}";
	                }
	            }
	            if (element.nameExp == "deviceNameTopicExpression") {
	                if (element.deviceNameJsonExpression) {
	                    delete element.deviceNameJsonExpression;
	                }
	                if (type && type == "connect") {
	                    element.deviceNameTopicExpression = "(?<=sensor\\/)(.*?)(?=\\/connect)";
	                }
	                if (type && type == "disconnect") {
	                    element.deviceNameTopicExpression = "(?<=sensor\\/)(.*?)(?=\\/disconnect)";
	                }
	                if (type && type == "attribute") {
	                    element.deviceNameTopicExpression = "(?<=sensors\\/)(.*?)(?=\\/attributes)";
	                }
	            }
	        };
	
	        scope.changeTypeExpression = function (converter) {
	            if (converter.typeExp == "deviceTypeJsonExpression") {
	                if (converter.deviceTypeTopicExpression) {
	                    delete converter.deviceTypeTopicExpression;
	                }
	            }
	            if (converter.typeExp == "deviceTypeTopicExpression") {
	                if (converter.deviceTypeJsonExpression) {
	                    delete converter.deviceTypeJsonExpression;
	                }
	            }
	        };
	
	        scope.changeAttrKeyExpression = function (request) {
	            if (request.attrKey == "attributeKeyJsonExpression") {
	                if (request.attributeKeyTopicExpression) {
	                    delete request.attributeKeyTopicExpression;
	                }
	                request.attributeKeyJsonExpression = "${$.key}";
	            }
	            if (request.attrKey == "attributeKeyTopicExpression") {
	                if (request.attributeKeyJsonExpression) {
	                    delete request.attributeKeyJsonExpression;
	                }
	                request.attributeKeyTopicExpression = "(?<=attributes\\/)(.*?)(?=\\/request)";
	            }
	        };
	
	        scope.changeRequestIdExpression = function (request) {
	            if (request.requestId == "requestIdJsonExpression") {
	                if (request.requestIdTopicExpression) {
	                    delete request.requestIdTopicExpression;
	                }
	                request.requestIdJsonExpression = "${$.requestId}";
	            }
	            if (request.requestId == "requestIdTopicExpression") {
	                if (request.requestIdJsonExpression) {
	                    delete request.requestIdJsonExpression;
	                }
	                request.requestIdTopicExpression = "(?<=request\\/)(.*?)($)";
	            }
	        };
	
	        scope.validateCustomConverter = function (model, editorName) {
	            if (model && model.length) {
	                try {
	                    angular.fromJson(model);
	                    scope.theForm[editorName].$setValidity('converterJSON', true);
	                } catch (e) {
	                    scope.theForm[editorName].$setValidity('converterJSON', false);
	                }
	            }
	        };
	
	        scope.fileAdded = function ($file, broker, fileType) {
	            var reader = new FileReader();
	            reader.onload = function (event) {
	                scope.$apply(function () {
	                    if (event.target.result) {
	                        scope.theForm.$setDirty();
	                        var addedFile = event.target.result;
	                        if (addedFile && addedFile.length > 0) {
	                            if (fileType == "caCert") {
	                                broker.credentials.caCertFileName = $file.name;
	                                broker.credentials.caCert = addedFile.replace(/^data.*base64,/, "");
	                            }
	                            if (fileType == "privateKey") {
	                                broker.credentials.privateKeyFileName = $file.name;
	                                broker.credentials.privateKey = addedFile.replace(/^data.*base64,/, "");
	                            }
	                            if (fileType == "Cert") {
	                                broker.credentials.certFileName = $file.name;
	                                broker.credentials.cert = addedFile.replace(/^data.*base64,/, "");
	                            }
	                        }
	                    }
	                });
	            };
	            reader.readAsDataURL($file.file);
	        };
	
	        scope.clearFile = function (broker, fileType) {
	            scope.theForm.$setDirty();
	            if (fileType == "caCert") {
	                broker.credentials.caCertFileName = null;
	                broker.credentials.caCert = null;
	            }
	            if (fileType == "privateKey") {
	                broker.credentials.privateKeyFileName = null;
	                broker.credentials.privateKey = null;
	            }
	            if (fileType == "Cert") {
	                broker.credentials.certFileName = null;
	                broker.credentials.cert = null;
	            }
	        };
	
	        scope.collapseValidation = function (index, id) {
	            var invalidState = angular.element('#' + id + ':has(.ng-invalid)');
	            if (invalidState.length) {
	                invalidState.addClass('inner-invalid');
	            }
	        };
	
	        scope.expandValidation = function (index, id) {
	            var invalidState = angular.element('#' + id);
	            invalidState.removeClass('inner-invalid');
	        };
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "A",
	        link: linker,
	        scope: {
	            config: "=",
	            isAdd: "="
	        }
	    };
	}
	
	/* eslint-disable angular/log */

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ExtensionFormOpcDirective.$inject = ["$compile", "$templateCache", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ExtensionFormOpcDirective;
	
	__webpack_require__(33);
	
	__webpack_require__(51);
	
	__webpack_require__(61);
	
	__webpack_require__(128);
	
	var _extensionFormOpcTpl = __webpack_require__(1492);
	
	var _extensionFormOpcTpl2 = _interopRequireDefault(_extensionFormOpcTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function ExtensionFormOpcDirective($compile, $templateCache, $translate, types) {
	
	    var linker = function linker(scope, element) {
	
	        function Server() {
	            this.applicationName = "Thingsboard OPC-UA client";
	            this.applicationUri = "";
	            this.host = "localhost";
	            this.port = 49320;
	            this.scanPeriodInSeconds = 10;
	            this.timeoutInMillis = 5000;
	            this.security = "Basic128Rsa15";
	            this.identity = {
	                "type": "anonymous"
	            };
	            this.keystore = {
	                "type": "PKCS12",
	                "location": "example.pfx",
	                "password": "secret",
	                "alias": "gateway",
	                "keyPassword": "secret"
	            };
	            this.mapping = [];
	        }
	
	        function Map() {
	            this.deviceNodePattern = "Channel1\\.Device\\d+$";
	            this.deviceNamePattern = "Device ${_System._DeviceId}";
	            this.attributes = [];
	            this.timeseries = [];
	        }
	
	        function Attribute() {
	            this.key = "Tag1";
	            this.type = "string";
	            this.value = "${Tag1}";
	        }
	
	        function Timeseries() {
	            this.key = "Tag2";
	            this.type = "long";
	            this.value = "${Tag2}";
	        }
	
	        var template = $templateCache.get(_extensionFormOpcTpl2.default);
	        element.html(template);
	
	        scope.types = types;
	        scope.theForm = scope.$parent.theForm;
	
	        if (!scope.configuration.servers.length) {
	            scope.configuration.servers.push(new Server());
	        }
	
	        scope.addServer = function (serversList) {
	            serversList.push(new Server());
	            // scope.addMap(serversList[serversList.length-1].mapping);
	
	            scope.theForm.$setDirty();
	        };
	
	        scope.addMap = function (mappingList) {
	            mappingList.push(new Map());
	            scope.theForm.$setDirty();
	        };
	
	        scope.addNewAttribute = function (attributesList) {
	            attributesList.push(new Attribute());
	            scope.theForm.$setDirty();
	        };
	
	        scope.addNewTimeseries = function (timeseriesList) {
	            timeseriesList.push(new Timeseries());
	            scope.theForm.$setDirty();
	        };
	
	        scope.removeItem = function (item, itemList) {
	            var index = itemList.indexOf(item);
	            if (index > -1) {
	                itemList.splice(index, 1);
	            }
	            scope.theForm.$setDirty();
	        };
	
	        $compile(element.contents())(scope);
	
	        scope.fileAdded = function ($file, model, options) {
	            var reader = new FileReader();
	            reader.onload = function (event) {
	                scope.$apply(function () {
	                    if (event.target.result) {
	                        scope.theForm.$setDirty();
	                        var addedFile = event.target.result;
	
	                        if (addedFile && addedFile.length > 0) {
	                            model[options.location] = $file.name;
	                            model[options.fileContent] = addedFile.replace(/^data.*base64,/, "");
	                        }
	                    }
	                });
	            };
	            reader.readAsDataURL($file.file);
	        };
	
	        scope.clearFile = function (model, options) {
	            scope.theForm.$setDirty();
	
	            model[options.location] = null;
	            model[options.fileContent] = null;
	        };
	
	        scope.collapseValidation = function (index, id) {
	            var invalidState = angular.element('#' + id + ':has(.ng-invalid)');
	            if (invalidState.length) {
	                invalidState.addClass('inner-invalid');
	            }
	        };
	
	        scope.expandValidation = function (index, id) {
	            var invalidState = angular.element('#' + id);
	            invalidState.removeClass('inner-invalid');
	        };
	    };
	
	    return {
	        restrict: "A",
	        link: linker,
	        scope: {
	            configuration: "=",
	            isAdd: "="
	        }
	    };
	}
	
	/* eslint-disable angular/log */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extensionTable = __webpack_require__(1277);
	
	var _extensionTable2 = _interopRequireDefault(_extensionTable);
	
	var _extensionFormHttp = __webpack_require__(1278);
	
	var _extensionFormHttp2 = _interopRequireDefault(_extensionFormHttp);
	
	var _extensionFormMqtt = __webpack_require__(1280);
	
	var _extensionFormMqtt2 = _interopRequireDefault(_extensionFormMqtt);
	
	var _extensionFormOpc = __webpack_require__(1281);
	
	var _extensionFormOpc2 = _interopRequireDefault(_extensionFormOpc);
	
	var _extensionFormModbus = __webpack_require__(1279);
	
	var _extensionFormModbus2 = _interopRequireDefault(_extensionFormModbus);
	
	var _extensionDialog = __webpack_require__(511);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.extension', []).directive('tbExtensionTable', _extensionTable2.default).directive('tbExtensionFormHttp', _extensionFormHttp2.default).directive('tbExtensionFormMqtt', _extensionFormMqtt2.default).directive('tbExtensionFormOpc', _extensionFormOpc2.default).directive('tbExtensionFormModbus', _extensionFormModbus2.default).directive('parseToNull', _extensionDialog.ParseToNull).name;

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

	'use strict';
	
	GlobalInterceptor.$inject = ["$rootScope", "$q", "$injector"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = GlobalInterceptor;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function GlobalInterceptor($rootScope, $q, $injector) {
	
	    var toast;
	    var translate;
	    var userService;
	    var types;
	    var http;
	
	    var internalUrlPrefixes = ['/api/auth/token', '/api/plugins/rpc'];
	
	    var service = {
	        request: request,
	        requestError: requestError,
	        response: response,
	        responseError: responseError
	    };
	
	    return service;
	
	    function getToast() {
	        if (!toast) {
	            toast = $injector.get("toast");
	        }
	        return toast;
	    }
	
	    function getTranslate() {
	        if (!translate) {
	            translate = $injector.get("$translate");
	        }
	        return translate;
	    }
	
	    function getUserService() {
	        if (!userService) {
	            userService = $injector.get("userService");
	        }
	        return userService;
	    }
	
	    function getTypes() {
	        if (!types) {
	            types = $injector.get("types");
	        }
	        return types;
	    }
	
	    function getHttp() {
	        if (!http) {
	            http = $injector.get("$http");
	        }
	        return http;
	    }
	
	    function rejectionErrorCode(rejection) {
	        if (rejection && rejection.data && rejection.data.errorCode) {
	            return rejection.data.errorCode;
	        } else {
	            return undefined;
	        }
	    }
	
	    function isTokenBasedAuthEntryPoint(url) {
	        return url.startsWith('/api/') && !url.startsWith(getTypes().entryPoints.login) && !url.startsWith(getTypes().entryPoints.tokenRefresh) && !url.startsWith(getTypes().entryPoints.nonTokenBased);
	    }
	
	    function refreshTokenAndRetry(request) {
	        return getUserService().refreshJwtToken().then(function success() {
	            getUserService().updateAuthorizationHeader(request.config.headers);
	            return getHttp()(request.config);
	        }, function fail(message) {
	            $rootScope.$broadcast('unauthenticated');
	            request.status = 401;
	            request.data = {};
	            request.data.message = message || getTranslate().instant('access.unauthorized');
	            return $q.reject(request);
	        });
	    }
	
	    function isInternalUrlPrefix(url) {
	        for (var index in internalUrlPrefixes) {
	            if (url.startsWith(internalUrlPrefixes[index])) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function request(config) {
	        var rejected = false;
	        if (config.url.startsWith('/api/')) {
	            var isLoading = !isInternalUrlPrefix(config.url);
	            updateLoadingState(config, isLoading);
	            if (isTokenBasedAuthEntryPoint(config.url)) {
	                if (!getUserService().updateAuthorizationHeader(config.headers) && !getUserService().refreshTokenPending()) {
	                    updateLoadingState(config, false);
	                    rejected = true;
	                    getUserService().clearJwtToken(false);
	                    return $q.reject({ data: { message: getTranslate().instant('access.unauthorized') }, status: 401, config: config });
	                } else if (!getUserService().isJwtTokenValid()) {
	                    return $q.reject({ refreshTokenPending: true, config: config });
	                }
	            }
	        }
	        if (!rejected) {
	            return config;
	        }
	    }
	
	    function requestError(rejection) {
	        if (rejection.config.url.startsWith('/api/')) {
	            updateLoadingState(rejection.config, false);
	        }
	        return $q.reject(rejection);
	    }
	
	    function response(response) {
	        if (response.config.url.startsWith('/api/')) {
	            updateLoadingState(response.config, false);
	        }
	        return response;
	    }
	
	    function responseError(rejection) {
	        if (rejection.config.url.startsWith('/api/')) {
	            updateLoadingState(rejection.config, false);
	        }
	        var unhandled = false;
	        var ignoreErrors = rejection.config.ignoreErrors;
	        if (rejection.refreshTokenPending || rejection.status === 401) {
	            var errorCode = rejectionErrorCode(rejection);
	            if (rejection.refreshTokenPending || errorCode && errorCode === getTypes().serverErrorCode.jwtTokenExpired) {
	                return refreshTokenAndRetry(rejection);
	            } else {
	                unhandled = true;
	            }
	        } else if (rejection.status === 403) {
	            if (!ignoreErrors) {
	                $rootScope.$broadcast('forbidden');
	            }
	        } else if (rejection.status === 0 || rejection.status === -1) {
	            getToast().showError(getTranslate().instant('error.unable-to-connect'));
	        } else if (!rejection.config.url.startsWith('/api/plugins/rpc')) {
	            if (rejection.status === 404) {
	                if (!ignoreErrors) {
	                    getToast().showError(rejection.config.method + ": " + rejection.config.url + "<br/>" + rejection.status + ": " + rejection.statusText);
	                }
	            } else {
	                unhandled = true;
	            }
	        }
	
	        if (unhandled && !ignoreErrors) {
	            if (rejection.data && !rejection.data.message) {
	                getToast().showError(rejection.data);
	            } else if (rejection.data && rejection.data.message) {
	                getToast().showError(rejection.data.message);
	            } else {
	                getToast().showError(getTranslate().instant('error.unhandled-error-code', { errorCode: rejection.status }));
	            }
	        }
	        return $q.reject(rejection);
	    }
	
	    function updateLoadingState(config, isLoading) {
	        if (!config || angular.isUndefined(config.ignoreLoading) || !config.ignoreLoading) {
	            $rootScope.loading = isLoading;
	        }
	    }
	}

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var ruleNodeClazzHelpLinkMap = {
	    'org.thingsboard.rule.engine.filter.TbCheckRelationNode': 'ruleNodeCheckRelation',
	    'org.thingsboard.rule.engine.filter.TbJsFilterNode': 'ruleNodeJsFilter',
	    'org.thingsboard.rule.engine.filter.TbJsSwitchNode': 'ruleNodeJsSwitch',
	    'org.thingsboard.rule.engine.filter.TbMsgTypeFilterNode': 'ruleNodeMessageTypeFilter',
	    'org.thingsboard.rule.engine.filter.TbMsgTypeSwitchNode': 'ruleNodeMessageTypeSwitch',
	    'org.thingsboard.rule.engine.filter.TbOriginatorTypeFilterNode': 'ruleNodeOriginatorTypeFilter',
	    'org.thingsboard.rule.engine.filter.TbOriginatorTypeSwitchNode': 'ruleNodeOriginatorTypeSwitch',
	    'org.thingsboard.rule.engine.metadata.TbGetAttributesNode': 'ruleNodeOriginatorAttributes',
	    'org.thingsboard.rule.engine.metadata.TbGetOriginatorFieldsNode': 'ruleNodeOriginatorFields',
	    'org.thingsboard.rule.engine.metadata.TbGetCustomerAttributeNode': 'ruleNodeCustomerAttributes',
	    'org.thingsboard.rule.engine.metadata.TbGetDeviceAttrNode': 'ruleNodeDeviceAttributes',
	    'org.thingsboard.rule.engine.metadata.TbGetRelatedAttributeNode': 'ruleNodeRelatedAttributes',
	    'org.thingsboard.rule.engine.metadata.TbGetTenantAttributeNode': 'ruleNodeTenantAttributes',
	    'org.thingsboard.rule.engine.transform.TbChangeOriginatorNode': 'ruleNodeChangeOriginator',
	    'org.thingsboard.rule.engine.transform.TbTransformMsgNode': 'ruleNodeTransformMsg',
	    'org.thingsboard.rule.engine.mail.TbMsgToEmailNode': 'ruleNodeMsgToEmail',
	    'org.thingsboard.rule.engine.action.TbClearAlarmNode': 'ruleNodeClearAlarm',
	    'org.thingsboard.rule.engine.action.TbCreateAlarmNode': 'ruleNodeCreateAlarm',
	    'org.thingsboard.rule.engine.delay.TbMsgDelayNode': 'ruleNodeMsgDelay',
	    'org.thingsboard.rule.engine.debug.TbMsgGeneratorNode': 'ruleNodeMsgGenerator',
	    'org.thingsboard.rule.engine.action.TbLogNode': 'ruleNodeLog',
	    'org.thingsboard.rule.engine.rpc.TbSendRPCReplyNode': 'ruleNodeRpcCallReply',
	    'org.thingsboard.rule.engine.rpc.TbSendRPCRequestNode': 'ruleNodeRpcCallRequest',
	    'org.thingsboard.rule.engine.telemetry.TbMsgAttributesNode': 'ruleNodeSaveAttributes',
	    'org.thingsboard.rule.engine.telemetry.TbMsgTimeseriesNode': 'ruleNodeSaveTimeseries',
	    'tb.internal.RuleChain': 'ruleNodeRuleChain',
	    'org.thingsboard.rule.engine.aws.sns.TbSnsNode': 'ruleNodeAwsSns',
	    'org.thingsboard.rule.engine.aws.sqs.TbSqsNode': 'ruleNodeAwsSqs',
	    'org.thingsboard.rule.engine.kafka.TbKafkaNode': 'ruleNodeKafka',
	    'org.thingsboard.rule.engine.mqtt.TbMqttNode': 'ruleNodeMqtt',
	    'org.thingsboard.rule.engine.rabbitmq.TbRabbitMqNode': 'ruleNodeRabbitMq',
	    'org.thingsboard.rule.engine.rest.TbRestApiCallNode': 'ruleNodeRestApiCall',
	    'org.thingsboard.rule.engine.mail.TbSendEmailNode': 'ruleNodeSendEmail'
	};
	
	var helpBaseUrl = "https://thingsboard.io";
	
	exports.default = angular.module('thingsboard.help', []).constant('helpLinks', {
	    linksMap: {
	        outgoingMailSettings: helpBaseUrl + "/docs/user-guide/ui/mail-settings",
	        ruleEngine: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/overview/",
	        ruleNodeCheckRelation: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/filter-nodes/#check-relation-filter-node",
	        ruleNodeJsFilter: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/filter-nodes/#script-filter-node",
	        ruleNodeJsSwitch: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/filter-nodes/#switch-node",
	        ruleNodeMessageTypeFilter: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/filter-nodes/#message-type-filter-node",
	        ruleNodeMessageTypeSwitch: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/filter-nodes/#message-type-switch-node",
	        ruleNodeOriginatorTypeFilter: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/filter-nodes/#originator-type-filter-node",
	        ruleNodeOriginatorTypeSwitch: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/filter-nodes/#originator-type-switch-node",
	        ruleNodeOriginatorAttributes: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/enrichment-nodes/#originator-attributes",
	        ruleNodeOriginatorFields: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/enrichment-nodes/#originator-fields",
	        ruleNodeCustomerAttributes: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/enrichment-nodes/#customer-attributes",
	        ruleNodeDeviceAttributes: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/enrichment-nodes/#device-attributes",
	        ruleNodeRelatedAttributes: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/enrichment-nodes/#related-attributes",
	        ruleNodeTenantAttributes: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/enrichment-nodes/#tenant-attributes",
	        ruleNodeChangeOriginator: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/transformation-nodes/#change-originator",
	        ruleNodeTransformMsg: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/transformation-nodes/#script-transformation-node",
	        ruleNodeMsgToEmail: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/transformation-nodes/#to-email-node",
	        ruleNodeClearAlarm: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/action-nodes/#clear-alarm-node",
	        ruleNodeCreateAlarm: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/action-nodes/#create-alarm-node",
	        ruleNodeMsgDelay: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/action-nodes/#delay-node",
	        ruleNodeMsgGenerator: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/action-nodes/#generator-node",
	        ruleNodeLog: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/action-nodes/#log-node",
	        ruleNodeRpcCallReply: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/action-nodes/#rpc-call-reply-node",
	        ruleNodeRpcCallRequest: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/action-nodes/#rpc-call-request-node",
	        ruleNodeSaveAttributes: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/action-nodes/#save-attributes-node",
	        ruleNodeSaveTimeseries: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/action-nodes/#save-timeseries-node",
	        ruleNodeRuleChain: helpBaseUrl + "/docs/user-guide/ui/rule-chains/",
	        ruleNodeAwsSns: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/external-nodes/#aws-sns-node",
	        ruleNodeAwsSqs: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/external-nodes/#aws-sqs-node",
	        ruleNodeKafka: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/external-nodes/#kafka-node",
	        ruleNodeMqtt: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/external-nodes/#mqtt-node",
	        ruleNodeRabbitMq: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/external-nodes/#rabbitmq-node",
	        ruleNodeRestApiCall: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/external-nodes/#rest-api-call-node",
	        ruleNodeSendEmail: helpBaseUrl + "/docs/user-guide/rule-engine-2-0/external-nodes/#send-email-node",
	        rulechains: helpBaseUrl + "/docs/user-guide/ui/rule-chains/",
	        tenants: helpBaseUrl + "/docs/user-guide/ui/tenants",
	        customers: helpBaseUrl + "/docs/user-guide/ui/customers",
	        assets: helpBaseUrl + "/docs/user-guide/ui/assets",
	        devices: helpBaseUrl + "/docs/user-guide/ui/devices",
	        entityViews: helpBaseUrl + "/docs/user-guide/ui/entity-views",
	        dashboards: helpBaseUrl + "/docs/user-guide/ui/dashboards",
	        users: helpBaseUrl + "/docs/user-guide/ui/users",
	        widgetsBundles: helpBaseUrl + "/docs/user-guide/ui/widget-library#bundles",
	        widgetsConfig: helpBaseUrl + "/docs/user-guide/ui/dashboards#widget-configuration",
	        widgetsConfigTimeseries: helpBaseUrl + "/docs/user-guide/ui/dashboards#timeseries",
	        widgetsConfigLatest: helpBaseUrl + "/docs/user-guide/ui/dashboards#latest",
	        widgetsConfigRpc: helpBaseUrl + "/docs/user-guide/ui/dashboards#rpc",
	        widgetsConfigAlarm: helpBaseUrl + "/docs/user-guide/ui/dashboards#alarm",
	        widgetsConfigStatic: helpBaseUrl + "/docs/user-guide/ui/dashboards#static"
	    },
	    getRuleNodeLink: function getRuleNodeLink(ruleNode) {
	        if (ruleNode && ruleNode.component) {
	            if (ruleNode.component.configurationDescriptor && ruleNode.component.configurationDescriptor.nodeDefinition && ruleNode.component.configurationDescriptor.nodeDefinition.docUrl) {
	                return ruleNode.component.configurationDescriptor.nodeDefinition.docUrl;
	            } else if (ruleNode.component.clazz) {
	                if (ruleNodeClazzHelpLinkMap[ruleNode.component.clazz]) {
	                    return ruleNodeClazzHelpLinkMap[ruleNode.component.clazz];
	                }
	            }
	        }
	        return 'ruleEngine';
	    }
	}).name;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Help.$inject = ["$compile", "$window", "helpLinks"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(807);
	
	var _helpLinks = __webpack_require__(1284);
	
	var _helpLinks2 = _interopRequireDefault(_helpLinks);
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.directives.help', [_helpLinks2.default]).directive('tbHelp', Help).name;
	
	/* eslint-disable angular/angularelement */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function Help($compile, $window, helpLinks) {
	
	    var linker = function linker(scope, element, attrs) {
	
	        scope.gotoHelpPage = function ($event) {
	            if ($event) {
	                $event.stopPropagation();
	            }
	            var helpUrl = helpLinks.linksMap[scope.helpLinkId];
	            if (!helpUrl && scope.helpLinkId && (scope.helpLinkId.startsWith('http://') || scope.helpLinkId.startsWith('https://'))) {
	                helpUrl = scope.helpLinkId;
	            }
	            if (helpUrl) {
	                $window.open(helpUrl, '_blank');
	            }
	        };
	
	        var html = '<md-tooltip md-direction="top">' + '{{\'help.goto-help-page\' | translate}}' + '</md-tooltip>' + '<md-icon class="material-icons">' + 'help' + '</md-icon>';
	
	        var helpButton = angular.element('<md-button class="tb-help-button-style tb-help-button-pos md-icon-button" ' + 'ng-click="gotoHelpPage($event)">' + html + '</md-button>');
	
	        if (attrs.helpContainerId) {
	            var helpContainer = (0, _jquery2.default)('#' + attrs.helpContainerId, element)[0];
	            helpContainer = angular.element(helpContainer);
	            helpContainer.append(helpButton);
	            $compile(helpContainer.contents())(scope);
	        } else {
	            $compile(helpButton)(scope);
	            element.append(helpButton);
	        }
	    };
	
	    return {
	        restrict: "A",
	        link: linker,
	        scope: {
	            helpLinkId: "=tbHelp"
	        }
	    };
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	HomeLinksController.$inject = ["$scope", "$mdMedia", "menu"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = HomeLinksController;
	
	__webpack_require__(808);
	
	/*@ngInject*/
	function HomeLinksController($scope, $mdMedia, menu) {
	
	    var vm = this;
	
	    vm.sectionColspan = sectionColspan;
	
	    $scope.$watch(function () {
	        return $mdMedia('lg');
	    }, function () {
	        updateColumnCount();
	    });
	
	    $scope.$watch(function () {
	        return $mdMedia('gt-lg');
	    }, function () {
	        updateColumnCount();
	    });
	
	    updateColumnCount();
	
	    vm.model = menu.getHomeSections();
	
	    function updateColumnCount() {
	        vm.cols = 2;
	        if ($mdMedia('lg')) {
	            vm.cols = 3;
	        }
	        if ($mdMedia('gt-lg')) {
	            vm.cols = 4;
	        }
	    }
	
	    function sectionColspan(section) {
	        var colspan = vm.cols;
	        if (section && section.places && section.places.length <= colspan) {
	            colspan = section.places.length;
	        }
	        return colspan;
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	HomeLinksRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = HomeLinksRoutes;
	
	var _homeLinksTpl = __webpack_require__(1493);
	
	var _homeLinksTpl2 = _interopRequireDefault(_homeLinksTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function HomeLinksRoutes($stateProvider) {
	
	    $stateProvider.state('home.links', {
	        url: '/home',
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "content@home": {
	                templateUrl: _homeLinksTpl2.default,
	                controllerAs: 'vm',
	                controller: 'HomeLinksController'
	            }
	        },
	        data: {
	            pageTitle: 'home.home'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "home", "label": "home.home"}',
	            icon: 'home'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _homeLinks = __webpack_require__(1287);
	
	var _homeLinks2 = _interopRequireDefault(_homeLinks);
	
	var _homeLinks3 = __webpack_require__(1286);
	
	var _homeLinks4 = _interopRequireDefault(_homeLinks3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.homeLinks', [_angularUiRouter2.default]).config(_homeLinks2.default).controller('HomeLinksController', _homeLinks4.default).name; /*
	                                                                                                                                                                                 * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                 *
	                                                                                                                                                                                 * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                 * you may not use this file except in compliance with the License.
	                                                                                                                                                                                 * You may obtain a copy of the License at
	                                                                                                                                                                                 *
	                                                                                                                                                                                 *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                 *
	                                                                                                                                                                                 * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                 * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                 * See the License for the specific language governing permissions and
	                                                                                                                                                                                 * limitations under the License.
	                                                                                                                                                                                 */

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	(function () {
	    if (!String.prototype.startsWith) {
	        String.prototype.startsWith = function (searchString, position) {
	            position = position || 0;
	            return this.indexOf(searchString, position) === position;
	        };
	    }
	    if (!String.prototype.endsWith) {
	        String.prototype.endsWith = function (suffix) {
	            return this.indexOf(suffix, this.length - suffix.length) !== -1;
	        };
	    }
	    if (!String.prototype.repeat) {
	        String.prototype.repeat = function (count) {
	            if (this == null) {
	                throw TypeError();
	            }
	            var string = String(this);
	            // `ToInteger`
	            var n = count ? Number(count) : 0;
	            if (n != n) {
	                // better `isNaN`
	                n = 0;
	            }
	            // Account for out-of-bounds indices
	            if (n < 0 || n == Infinity) {
	                throw RangeError();
	            }
	            var result = '';
	            while (n) {
	                if (n % 2 == 1) {
	                    result += string;
	                }
	                if (n > 1) {
	                    string += string;
	                }
	                n >>= 1;
	            }
	            return result;
	        };
	    }
	
	    (function (arr) {
	        arr.forEach(function (item) {
	            if (item.hasOwnProperty('remove')) {
	                return;
	            }
	            Object.defineProperty(item, 'remove', {
	                configurable: true,
	                enumerable: true,
	                writable: true,
	                value: function remove() {
	                    if (this.parentNode !== null) this.parentNode.removeChild(this);
	                }
	            });
	        });
	    })([Element.prototype, CharacterData.prototype, DocumentType.prototype]); //eslint-disable-line
	})();

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ImportDialogController.$inject = ["$scope", "$mdDialog", "toast", "importTitle", "importFileLabel"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ImportDialogController;
	
	__webpack_require__(809);
	
	/*@ngInject*/
	function ImportDialogController($scope, $mdDialog, toast, importTitle, importFileLabel) {
	
	    var vm = this;
	
	    vm.cancel = cancel;
	    vm.importFromJson = importFromJson;
	    vm.fileAdded = fileAdded;
	    vm.clearFile = clearFile;
	
	    vm.importTitle = importTitle;
	    vm.importFileLabel = importFileLabel;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function fileAdded($file) {
	        if ($file.getExtension() === 'json') {
	            var reader = new FileReader();
	            reader.onload = function (event) {
	                $scope.$apply(function () {
	                    if (event.target.result) {
	                        $scope.theForm.$setDirty();
	                        var importJson = event.target.result;
	                        if (importJson && importJson.length > 0) {
	                            try {
	                                vm.importData = angular.fromJson(importJson);
	                                vm.fileName = $file.name;
	                            } catch (err) {
	                                vm.fileName = null;
	                                toast.showError(err.message);
	                            }
	                        }
	                    }
	                });
	            };
	            reader.readAsText($file.file);
	        }
	    }
	
	    function clearFile() {
	        $scope.theForm.$setDirty();
	        vm.fileName = null;
	        vm.importData = null;
	    }
	
	    function importFromJson() {
	        $scope.theForm.$setPristine();
	        $mdDialog.hide(vm.importData);
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ImportExport.$inject = ["$log", "$translate", "$q", "$mdDialog", "$document", "$http", "itembuffer", "utils", "types", "dashboardUtils", "entityService", "dashboardService", "ruleChainService", "widgetService", "toast", "attributeService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ImportExport;
	
	var _importDialogTpl = __webpack_require__(1494);
	
	var _importDialogTpl2 = _interopRequireDefault(_importDialogTpl);
	
	var _entityAliasesTpl = __webpack_require__(522);
	
	var _entityAliasesTpl2 = _interopRequireDefault(_entityAliasesTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable no-undef, angular/window-service, angular/document-service */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function ImportExport($log, $translate, $q, $mdDialog, $document, $http, itembuffer, utils, types, dashboardUtils, entityService, dashboardService, ruleChainService, widgetService, toast, attributeService) {
	
	    var service = {
	        exportDashboard: exportDashboard,
	        importDashboard: importDashboard,
	        exportWidget: exportWidget,
	        importWidget: importWidget,
	        exportRuleChain: exportRuleChain,
	        importRuleChain: importRuleChain,
	        exportWidgetType: exportWidgetType,
	        importWidgetType: importWidgetType,
	        exportWidgetsBundle: exportWidgetsBundle,
	        importWidgetsBundle: importWidgetsBundle,
	        exportExtension: exportExtension,
	        importExtension: importExtension,
	        exportToPc: exportToPc
	    };
	
	    return service;
	
	    // Widgets bundle functions
	
	    function exportWidgetsBundle(widgetsBundleId) {
	        widgetService.getWidgetsBundle(widgetsBundleId).then(function success(widgetsBundle) {
	            var bundleAlias = widgetsBundle.alias;
	            var isSystem = widgetsBundle.tenantId.id === types.id.nullUid;
	            widgetService.getBundleWidgetTypes(bundleAlias, isSystem).then(function success(widgetTypes) {
	                prepareExport(widgetsBundle);
	                var widgetsBundleItem = {
	                    widgetsBundle: prepareExport(widgetsBundle),
	                    widgetTypes: []
	                };
	                for (var t in widgetTypes) {
	                    var widgetType = widgetTypes[t];
	                    if (angular.isDefined(widgetType.bundleAlias)) {
	                        delete widgetType.bundleAlias;
	                    }
	                    widgetsBundleItem.widgetTypes.push(prepareExport(widgetType));
	                }
	                var name = widgetsBundle.title;
	                name = name.toLowerCase().replace(/\W/g, "_");
	                exportToPc(widgetsBundleItem, name + '.json');
	            }, function fail(rejection) {
	                var message = rejection;
	                if (!message) {
	                    message = $translate.instant('error.unknown-error');
	                }
	                toast.showError($translate.instant('widgets-bundle.export-failed-error', { error: message }));
	            });
	        }, function fail(rejection) {
	            var message = rejection;
	            if (!message) {
	                message = $translate.instant('error.unknown-error');
	            }
	            toast.showError($translate.instant('widgets-bundle.export-failed-error', { error: message }));
	        });
	    }
	
	    function importNextWidgetType(widgetTypes, bundleAlias, index, deferred) {
	        if (!widgetTypes || widgetTypes.length <= index) {
	            deferred.resolve();
	        } else {
	            var widgetType = widgetTypes[index];
	            widgetType.bundleAlias = bundleAlias;
	            widgetService.saveImportedWidgetType(widgetType).then(function success() {
	                index++;
	                importNextWidgetType(widgetTypes, bundleAlias, index, deferred);
	            }, function fail() {
	                deferred.reject();
	            });
	        }
	    }
	
	    function importWidgetsBundle($event) {
	        var deferred = $q.defer();
	        openImportDialog($event, 'widgets-bundle.import', 'widgets-bundle.widgets-bundle-file').then(function success(widgetsBundleItem) {
	            if (!validateImportedWidgetsBundle(widgetsBundleItem)) {
	                toast.showError($translate.instant('widgets-bundle.invalid-widgets-bundle-file-error'));
	                deferred.reject();
	            } else {
	                var widgetsBundle = widgetsBundleItem.widgetsBundle;
	                widgetService.saveWidgetsBundle(widgetsBundle).then(function success(savedWidgetsBundle) {
	                    var bundleAlias = savedWidgetsBundle.alias;
	                    var widgetTypes = widgetsBundleItem.widgetTypes;
	                    importNextWidgetType(widgetTypes, bundleAlias, 0, deferred);
	                }, function fail() {
	                    deferred.reject();
	                });
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function validateImportedWidgetsBundle(widgetsBundleItem) {
	        if (angular.isUndefined(widgetsBundleItem.widgetsBundle)) {
	            return false;
	        }
	        if (angular.isUndefined(widgetsBundleItem.widgetTypes)) {
	            return false;
	        }
	        var widgetsBundle = widgetsBundleItem.widgetsBundle;
	        if (angular.isUndefined(widgetsBundle.title)) {
	            return false;
	        }
	        var widgetTypes = widgetsBundleItem.widgetTypes;
	        for (var t in widgetTypes) {
	            var widgetType = widgetTypes[t];
	            if (!validateImportedWidgetType(widgetType)) {
	                return false;
	            }
	        }
	
	        return true;
	    }
	
	    // Widget type functions
	
	    function exportWidgetType(widgetTypeId) {
	        widgetService.getWidgetTypeById(widgetTypeId).then(function success(widgetType) {
	            if (angular.isDefined(widgetType.bundleAlias)) {
	                delete widgetType.bundleAlias;
	            }
	            var name = widgetType.name;
	            name = name.toLowerCase().replace(/\W/g, "_");
	            exportToPc(prepareExport(widgetType), name + '.json');
	        }, function fail(rejection) {
	            var message = rejection;
	            if (!message) {
	                message = $translate.instant('error.unknown-error');
	            }
	            toast.showError($translate.instant('widget-type.export-failed-error', { error: message }));
	        });
	    }
	
	    function importWidgetType($event, bundleAlias) {
	        var deferred = $q.defer();
	        openImportDialog($event, 'widget-type.import', 'widget-type.widget-type-file').then(function success(widgetType) {
	            if (!validateImportedWidgetType(widgetType)) {
	                toast.showError($translate.instant('widget-type.invalid-widget-type-file-error'));
	                deferred.reject();
	            } else {
	                widgetType.bundleAlias = bundleAlias;
	                widgetService.saveImportedWidgetType(widgetType).then(function success() {
	                    deferred.resolve();
	                }, function fail() {
	                    deferred.reject();
	                });
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function validateImportedWidgetType(widgetType) {
	        if (angular.isUndefined(widgetType.name) || angular.isUndefined(widgetType.descriptor)) {
	            return false;
	        }
	        return true;
	    }
	
	    // Rule chain functions
	
	    function exportRuleChain(ruleChainId) {
	        ruleChainService.getRuleChain(ruleChainId).then(function (ruleChain) {
	            ruleChainService.getRuleChainMetaData(ruleChainId).then(function (ruleChainMetaData) {
	                var ruleChainExport = {
	                    ruleChain: prepareRuleChain(ruleChain),
	                    metadata: prepareRuleChainMetaData(ruleChainMetaData)
	                };
	                var name = ruleChain.name;
	                name = name.toLowerCase().replace(/\W/g, "_");
	                exportToPc(ruleChainExport, name + '.json');
	            }, function (rejection) {
	                processExportRuleChainRejection(rejection);
	            });
	        }, function (rejection) {
	            processExportRuleChainRejection(rejection);
	        });
	    }
	
	    function prepareRuleChain(ruleChain) {
	        ruleChain = prepareExport(ruleChain);
	        if (ruleChain.firstRuleNodeId) {
	            ruleChain.firstRuleNodeId = null;
	        }
	        ruleChain.root = false;
	        return ruleChain;
	    }
	
	    function prepareRuleChainMetaData(ruleChainMetaData) {
	        delete ruleChainMetaData.ruleChainId;
	        for (var i = 0; i < ruleChainMetaData.nodes.length; i++) {
	            var node = ruleChainMetaData.nodes[i];
	            delete node.ruleChainId;
	            ruleChainMetaData.nodes[i] = prepareExport(node);
	        }
	        return ruleChainMetaData;
	    }
	
	    function processExportRuleChainRejection(rejection) {
	        var message = rejection;
	        if (!message) {
	            message = $translate.instant('error.unknown-error');
	        }
	        toast.showError($translate.instant('rulechain.export-failed-error', { error: message }));
	    }
	
	    function importRuleChain($event) {
	        var deferred = $q.defer();
	        openImportDialog($event, 'rulechain.import', 'rulechain.rulechain-file').then(function success(ruleChainImport) {
	            if (!validateImportedRuleChain(ruleChainImport)) {
	                toast.showError($translate.instant('rulechain.invalid-rulechain-file-error'));
	                deferred.reject();
	            } else {
	                deferred.resolve(ruleChainImport);
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function validateImportedRuleChain(ruleChainImport) {
	        if (angular.isUndefined(ruleChainImport.ruleChain)) {
	            return false;
	        }
	        if (angular.isUndefined(ruleChainImport.metadata)) {
	            return false;
	        }
	        if (angular.isUndefined(ruleChainImport.ruleChain.name)) {
	            return false;
	        }
	        return true;
	    }
	
	    // Widget functions
	
	    function exportWidget(dashboard, sourceState, sourceLayout, widget) {
	        var widgetItem = itembuffer.prepareWidgetItem(dashboard, sourceState, sourceLayout, widget);
	        var name = widgetItem.widget.config.title;
	        name = name.toLowerCase().replace(/\W/g, "_");
	        exportToPc(prepareExport(widgetItem), name + '.json');
	    }
	
	    function prepareAliasesInfo(aliasesInfo) {
	        var datasourceAliases = aliasesInfo.datasourceAliases;
	        var targetDeviceAliases = aliasesInfo.targetDeviceAliases;
	        var datasourceIndex;
	        if (datasourceAliases || targetDeviceAliases) {
	            if (datasourceAliases) {
	                for (datasourceIndex in datasourceAliases) {
	                    datasourceAliases[datasourceIndex] = prepareEntityAlias(datasourceAliases[datasourceIndex]);
	                }
	            }
	            if (targetDeviceAliases) {
	                for (datasourceIndex in targetDeviceAliases) {
	                    targetDeviceAliases[datasourceIndex] = prepareEntityAlias(targetDeviceAliases[datasourceIndex]);
	                }
	            }
	        }
	        return aliasesInfo;
	    }
	
	    function prepareEntityAlias(aliasInfo) {
	        var alias;
	        var filter;
	        if (aliasInfo.deviceId) {
	            alias = aliasInfo.aliasName;
	            filter = {
	                type: types.aliasFilterType.entityList.value,
	                entityType: types.entityType.device,
	                entityList: [aliasInfo.deviceId],
	                resolveMultiple: false
	            };
	        } else if (aliasInfo.deviceFilter) {
	            alias = aliasInfo.aliasName;
	            filter = {
	                type: aliasInfo.deviceFilter.useFilter ? types.aliasFilterType.entityName.value : types.aliasFilterType.entityList.value,
	                entityType: types.entityType.device,
	                resolveMultiple: false
	            };
	            if (filter.type == types.aliasFilterType.entityList.value) {
	                filter.entityList = aliasInfo.deviceFilter.deviceList;
	            } else {
	                filter.entityNameFilter = aliasInfo.deviceFilter.deviceNameFilter;
	            }
	        } else if (aliasInfo.entityFilter) {
	            alias = aliasInfo.aliasName;
	            filter = {
	                type: aliasInfo.entityFilter.useFilter ? types.aliasFilterType.entityName.value : types.aliasFilterType.entityList.value,
	                entityType: aliasInfo.entityType,
	                resolveMultiple: false
	            };
	            if (filter.type == types.aliasFilterType.entityList.value) {
	                filter.entityList = aliasInfo.entityFilter.entityList;
	            } else {
	                filter.entityNameFilter = aliasInfo.entityFilter.entityNameFilter;
	            }
	        } else {
	            alias = aliasInfo.alias;
	            filter = aliasInfo.filter;
	        }
	        return {
	            alias: alias,
	            filter: filter
	        };
	    }
	
	    function importWidget($event, dashboard, targetState, targetLayoutFunction, onAliasesUpdateFunction) {
	        var deferred = $q.defer();
	        openImportDialog($event, 'dashboard.import-widget', 'dashboard.widget-file').then(function success(widgetItem) {
	            if (!validateImportedWidget(widgetItem)) {
	                toast.showError($translate.instant('dashboard.invalid-widget-file-error'));
	                deferred.reject();
	            } else {
	                var widget = widgetItem.widget;
	                widget = dashboardUtils.validateAndUpdateWidget(widget);
	                var aliasesInfo = prepareAliasesInfo(widgetItem.aliasesInfo);
	                var originalColumns = widgetItem.originalColumns;
	                var originalSize = widgetItem.originalSize;
	
	                var datasourceAliases = aliasesInfo.datasourceAliases;
	                var targetDeviceAliases = aliasesInfo.targetDeviceAliases;
	                if (datasourceAliases || targetDeviceAliases) {
	                    var entityAliases = {};
	                    var datasourceAliasesMap = {};
	                    var targetDeviceAliasesMap = {};
	                    var aliasId;
	                    var datasourceIndex;
	                    if (datasourceAliases) {
	                        for (datasourceIndex in datasourceAliases) {
	                            aliasId = utils.guid();
	                            datasourceAliasesMap[aliasId] = datasourceIndex;
	                            entityAliases[aliasId] = datasourceAliases[datasourceIndex];
	                            entityAliases[aliasId].id = aliasId;
	                        }
	                    }
	                    if (targetDeviceAliases) {
	                        for (datasourceIndex in targetDeviceAliases) {
	                            aliasId = utils.guid();
	                            targetDeviceAliasesMap[aliasId] = datasourceIndex;
	                            entityAliases[aliasId] = targetDeviceAliases[datasourceIndex];
	                            entityAliases[aliasId].id = aliasId;
	                        }
	                    }
	
	                    var aliasIds = Object.keys(entityAliases);
	                    if (aliasIds.length > 0) {
	                        processEntityAliases(entityAliases, aliasIds).then(function (missingEntityAliases) {
	                            if (Object.keys(missingEntityAliases).length > 0) {
	                                editMissingAliases($event, [widget], true, 'dashboard.widget-import-missing-aliases-title', missingEntityAliases).then(function success(updatedEntityAliases) {
	                                    for (var aliasId in updatedEntityAliases) {
	                                        var entityAlias = updatedEntityAliases[aliasId];
	                                        var datasourceIndex;
	                                        if (datasourceAliasesMap[aliasId]) {
	                                            datasourceIndex = datasourceAliasesMap[aliasId];
	                                            datasourceAliases[datasourceIndex] = entityAlias;
	                                        } else if (targetDeviceAliasesMap[aliasId]) {
	                                            datasourceIndex = targetDeviceAliasesMap[aliasId];
	                                            targetDeviceAliases[datasourceIndex] = entityAlias;
	                                        }
	                                    }
	                                    addImportedWidget(dashboard, targetState, targetLayoutFunction, $event, widget, aliasesInfo, onAliasesUpdateFunction, originalColumns, originalSize, deferred);
	                                }, function fail() {
	                                    deferred.reject();
	                                });
	                            } else {
	                                addImportedWidget(dashboard, targetState, targetLayoutFunction, $event, widget, aliasesInfo, onAliasesUpdateFunction, originalColumns, originalSize, deferred);
	                            }
	                        });
	                    } else {
	                        addImportedWidget(dashboard, targetState, targetLayoutFunction, $event, widget, aliasesInfo, onAliasesUpdateFunction, originalColumns, originalSize, deferred);
	                    }
	                } else {
	                    addImportedWidget(dashboard, targetState, targetLayoutFunction, $event, widget, aliasesInfo, onAliasesUpdateFunction, originalColumns, originalSize, deferred);
	                }
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function validateImportedWidget(widgetItem) {
	        if (angular.isUndefined(widgetItem.widget) || angular.isUndefined(widgetItem.aliasesInfo) || angular.isUndefined(widgetItem.originalColumns)) {
	            return false;
	        }
	        var widget = widgetItem.widget;
	        if (angular.isUndefined(widget.isSystemType) || angular.isUndefined(widget.bundleAlias) || angular.isUndefined(widget.typeAlias) || angular.isUndefined(widget.type)) {
	            return false;
	        }
	        return true;
	    }
	
	    function addImportedWidget(dashboard, targetState, targetLayoutFunction, event, widget, aliasesInfo, onAliasesUpdateFunction, originalColumns, originalSize, deferred) {
	        targetLayoutFunction(event).then(function success(targetLayout) {
	            itembuffer.addWidgetToDashboard(dashboard, targetState, targetLayout, widget, aliasesInfo, onAliasesUpdateFunction, originalColumns, originalSize, -1, -1).then(function () {
	                deferred.resolve({
	                    widget: widget,
	                    layoutId: targetLayout
	                });
	            });
	        }, function fail() {
	            deferred.reject();
	        });
	    }
	
	    // Dashboard functions
	
	    function exportDashboard(dashboardId) {
	        dashboardService.getDashboard(dashboardId).then(function success(dashboard) {
	            var name = dashboard.title;
	            name = name.toLowerCase().replace(/\W/g, "_");
	            exportToPc(prepareDashboardExport(dashboard), name + '.json');
	        }, function fail(rejection) {
	            var message = rejection;
	            if (!message) {
	                message = $translate.instant('error.unknown-error');
	            }
	            toast.showError($translate.instant('dashboard.export-failed-error', { error: message }));
	        });
	    }
	
	    function prepareDashboardExport(dashboard) {
	        dashboard = prepareExport(dashboard);
	        delete dashboard.assignedCustomers;
	        delete dashboard.publicCustomerId;
	        delete dashboard.assignedCustomersText;
	        delete dashboard.assignedCustomersIds;
	        return dashboard;
	    }
	
	    function importDashboard($event) {
	        var deferred = $q.defer();
	        openImportDialog($event, 'dashboard.import', 'dashboard.dashboard-file').then(function success(dashboard) {
	            if (!validateImportedDashboard(dashboard)) {
	                toast.showError($translate.instant('dashboard.invalid-dashboard-file-error'));
	                deferred.reject();
	            } else {
	                dashboard = dashboardUtils.validateAndUpdateDashboard(dashboard);
	                var entityAliases = dashboard.configuration.entityAliases;
	                if (entityAliases) {
	                    var aliasIds = Object.keys(entityAliases);
	                    if (aliasIds.length > 0) {
	                        processEntityAliases(entityAliases, aliasIds).then(function (missingEntityAliases) {
	                            if (Object.keys(missingEntityAliases).length > 0) {
	                                editMissingAliases($event, dashboard.configuration.widgets, false, 'dashboard.dashboard-import-missing-aliases-title', missingEntityAliases).then(function success(updatedEntityAliases) {
	                                    for (var aliasId in updatedEntityAliases) {
	                                        entityAliases[aliasId] = updatedEntityAliases[aliasId];
	                                    }
	                                    saveImportedDashboard(dashboard, deferred);
	                                }, function fail() {
	                                    deferred.reject();
	                                });
	                            } else {
	                                saveImportedDashboard(dashboard, deferred);
	                            }
	                        });
	                    } else {
	                        saveImportedDashboard(dashboard, deferred);
	                    }
	                } else {
	                    saveImportedDashboard(dashboard, deferred);
	                }
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function saveImportedDashboard(dashboard, deferred) {
	        dashboardService.saveDashboard(dashboard).then(function success() {
	            deferred.resolve();
	        }, function fail() {
	            deferred.reject();
	        });
	    }
	
	    function validateImportedDashboard(dashboard) {
	        if (angular.isUndefined(dashboard.title) || angular.isUndefined(dashboard.configuration)) {
	            return false;
	        }
	        return true;
	    }
	
	    function exportExtension(extensionId) {
	
	        getExtension(extensionId).then(function success(extension) {
	            var name = extension.title;
	            name = name.toLowerCase().replace(/\W/g, "_");
	            exportToPc(prepareExport(extension), name + '.json');
	        }, function fail(rejection) {
	            var message = rejection;
	            if (!message) {
	                message = $translate.instant('error.unknown-error');
	            }
	            toast.showError($translate.instant('extension.export-failed-error', { error: message }));
	        });
	
	        function getExtension(extensionId) {
	            var deferred = $q.defer();
	            var url = '/api/plugins/telemetry/DEVICE/' + extensionId;
	            $http.get(url, null).then(function success(response) {
	                deferred.resolve(response.data);
	            }, function fail() {
	                deferred.reject();
	            });
	            return deferred.promise;
	        }
	    }
	
	    function importExtension($event, options) {
	        var deferred = $q.defer();
	        openImportDialog($event, 'extension.import-extensions', 'extension.file').then(function success(extension) {
	            if (!validateImportedExtension(extension)) {
	                toast.showError($translate.instant('extension.invalid-file-error'));
	                deferred.reject();
	            } else {
	                attributeService.saveEntityAttributes(options.entityType, options.entityId, types.attributesScope.shared.value, [{
	                    key: "configuration",
	                    value: angular.toJson(extension)
	                }]).then(function success() {
	                    options.successFunc();
	                });
	            }
	        }, function fail() {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function validateImportedExtension(configuration) {
	        if (configuration.length) {
	            for (var i = 0; i < configuration.length; i++) {
	                if (angular.isUndefined(configuration[i].configuration) || angular.isUndefined(configuration[i].id) || angular.isUndefined(configuration[i].type)) {
	                    return false;
	                }
	            }
	        } else {
	            return false;
	        }
	        return true;
	    }
	
	    function processEntityAliases(entityAliases, aliasIds) {
	        var deferred = $q.defer();
	        var missingEntityAliases = {};
	        var index = -1;
	        checkNextEntityAliasOrComplete(index, aliasIds, entityAliases, missingEntityAliases, deferred);
	        return deferred.promise;
	    }
	
	    function checkNextEntityAliasOrComplete(index, aliasIds, entityAliases, missingEntityAliases, deferred) {
	        index++;
	        if (index == aliasIds.length) {
	            deferred.resolve(missingEntityAliases);
	        } else {
	            checkEntityAlias(index, aliasIds, entityAliases, missingEntityAliases, deferred);
	        }
	    }
	
	    function checkEntityAlias(index, aliasIds, entityAliases, missingEntityAliases, deferred) {
	        var aliasId = aliasIds[index];
	        var entityAlias = entityAliases[aliasId];
	        entityService.checkEntityAlias(entityAlias).then(function (result) {
	            if (result) {
	                checkNextEntityAliasOrComplete(index, aliasIds, entityAliases, missingEntityAliases, deferred);
	            } else {
	                var missingEntityAlias = angular.copy(entityAlias);
	                missingEntityAlias.filter = null;
	                missingEntityAliases[aliasId] = missingEntityAlias;
	                checkNextEntityAliasOrComplete(index, aliasIds, entityAliases, missingEntityAliases, deferred);
	            }
	        });
	    }
	
	    function editMissingAliases($event, widgets, isSingleWidget, customTitle, missingEntityAliases) {
	        var deferred = $q.defer();
	        $mdDialog.show({
	            controller: 'EntityAliasesController',
	            controllerAs: 'vm',
	            templateUrl: _entityAliasesTpl2.default,
	            locals: {
	                config: {
	                    entityAliases: missingEntityAliases,
	                    widgets: widgets,
	                    isSingleWidget: isSingleWidget,
	                    customTitle: customTitle,
	                    disableAdd: true
	                }
	            },
	            parent: angular.element($document[0].body),
	            skipHide: true,
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (updatedEntityAliases) {
	            deferred.resolve(updatedEntityAliases);
	        }, function () {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    // Common functions
	
	    function prepareExport(data) {
	        var exportedData = angular.copy(data);
	        if (angular.isDefined(exportedData.id)) {
	            delete exportedData.id;
	        }
	        if (angular.isDefined(exportedData.createdTime)) {
	            delete exportedData.createdTime;
	        }
	        if (angular.isDefined(exportedData.tenantId)) {
	            delete exportedData.tenantId;
	        }
	        if (angular.isDefined(exportedData.customerId)) {
	            delete exportedData.customerId;
	        }
	        return exportedData;
	    }
	
	    function exportToPc(data, filename) {
	        if (!data) {
	            $log.error('No data');
	            return;
	        }
	
	        if (!filename) {
	            filename = 'download.json';
	        }
	
	        if (angular.isObject(data)) {
	            data = angular.toJson(data, 2);
	        }
	
	        var blob = new Blob([data], { type: 'text/json' });
	
	        // FOR IE:
	
	        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	            window.navigator.msSaveOrOpenBlob(blob, filename);
	        } else {
	            var e = document.createEvent('MouseEvents'),
	                a = document.createElement('a');
	
	            a.download = filename;
	            a.href = window.URL.createObjectURL(blob);
	            a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
	            e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	            a.dispatchEvent(e);
	        }
	    }
	
	    function openImportDialog($event, importTitle, importFileLabel) {
	        var deferred = $q.defer();
	        $mdDialog.show({
	            controller: 'ImportDialogController',
	            controllerAs: 'vm',
	            templateUrl: _importDialogTpl2.default,
	            locals: {
	                importTitle: importTitle,
	                importFileLabel: importFileLabel
	            },
	            parent: angular.element($document[0].body),
	            skipHide: true,
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (importData) {
	            deferred.resolve(importData);
	        }, function () {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	}
	
	/* eslint-enable no-undef, angular/window-service, angular/document-service */

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _importExport = __webpack_require__(1291);
	
	var _importExport2 = _interopRequireDefault(_importExport);
	
	var _importDialog = __webpack_require__(1290);
	
	var _importDialog2 = _interopRequireDefault(_importDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.importexport', []).factory('importExport', _importExport2.default).controller('ImportDialogController', _importDialog2.default).name;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularMaterial = __webpack_require__(80);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularMessages = __webpack_require__(164);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _jsonForm = __webpack_require__(232);
	
	var _jsonForm2 = _interopRequireDefault(_jsonForm);
	
	var _jsonform = __webpack_require__(1295);
	
	var _jsonform2 = _interopRequireDefault(_jsonform);
	
	var _jsonform3 = __webpack_require__(1294);
	
	var _jsonform4 = _interopRequireDefault(_jsonform3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.jsonform', [_angularUiRouter2.default, _angularMaterial2.default, _angularMessages2.default, _jsonForm2.default]).config(_jsonform2.default).controller('JsonFormController', _jsonform4.default).name;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	JsonFormController.$inject = ["$scope"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = JsonFormController;
	
	__webpack_require__(810);
	
	/*@ngInject*/
	function JsonFormController($scope /*, $rootScope, $log*/) {
	
	    var vm = this;
	
	    vm.pretty = pretty;
	    vm.resetModel = resetModel;
	    vm.itParses = true;
	    vm.itParsesForm = true;
	
	    vm.formJson = "[   \n" + "    {\n" + "        \"key\": \"name\",\n" + "\t\"type\": \"text\"        \n" + "    },\n" + "    {\n" + "\t\"key\": \"name2\",\n" + "\t\"type\": \"color\"\n" + "    },\n" + "    {\n" + "\t\"key\": \"name3\",\n" + "\t\"type\": \"javascript\"\n" + "    },    \n" + "\t\"name4\"\n" + "]";
	    vm.schemaJson = "{\n" + "    \"type\": \"object\",\n" + "    \"title\": \"Comment\",\n" + "    \"properties\": {\n" + "        \"name\": {\n" + "            \"title\": \"Name 1\",\n" + "            \"type\": \"string\"\n" + "         },\n" + "        \"name2\": {\n" + "            \"title\": \"Name 2\",\n" + "            \"type\": \"string\"\n" + "         },\n" + "        \"name3\": {\n" + "            \"title\": \"Name 3\",\n" + "            \"type\": \"string\"\n" + "         },\n" + "        \"name4\": {\n" + "            \"title\": \"Name 4\",\n" + "            \"type\": \"number\"\n" + "         }\n" + "     },\n" + "     \"required\": [\n" + "         \"name1\", \"name2\", \"name3\", \"name4\"\n" + "     ]\n" + "}";
	    /*        '{\n'+
	        '    "type": "object",\n'+
	        '    "title": "Comment",\n'+
	        '    "properties": {\n'+
	        '        "name": {\n'+
	        '            "title": "Name",\n'+
	        '            "type": "string"\n'+
	        '         }\n'+
	        '     },\n'+
	        '     "required": [\n'+
	        '         "name"\n'+
	        '     ]\n'+
	        '}';*/
	
	    vm.schema = angular.fromJson(vm.schemaJson);
	    vm.form = angular.fromJson(vm.formJson);
	    vm.model = { name: '#ccc' };
	
	    $scope.$watch('vm.schemaJson', function (val, old) {
	        if (val && val !== old) {
	            try {
	                vm.schema = angular.fromJson(vm.schemaJson);
	                vm.itParses = true;
	            } catch (e) {
	                vm.itParses = false;
	            }
	        }
	    });
	
	    $scope.$watch('vm.formJson', function (val, old) {
	        if (val && val !== old) {
	            try {
	                vm.form = angular.fromJson(vm.formJson);
	                vm.itParsesForm = true;
	            } catch (e) {
	                vm.itParsesForm = false;
	            }
	        }
	    });
	
	    function pretty() {
	        return angular.isString(vm.model) ? vm.model : angular.toJson(vm.model, true);
	    }
	
	    function resetModel() {
	        $scope.ngform.$setPristine();
	        vm.model = { name: 'New hello world!' };
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	JsonFormRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = JsonFormRoutes;
	
	var _jsonformTpl = __webpack_require__(1495);
	
	var _jsonformTpl2 = _interopRequireDefault(_jsonformTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function JsonFormRoutes($stateProvider) {
	    $stateProvider.state('home.jsonform', {
	        url: '/jsonform',
	        module: 'private',
	        auth: ['SYS_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _jsonformTpl2.default,
	                controllerAs: 'vm',
	                controller: 'JsonFormController'
	            }
	        },
	        data: {
	            key: 'general',
	            pageTitle: 'admin.general-settings'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "settings", "label": "admin.system-settings"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = BreadcrumbIcon;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function BreadcrumbIcon() {
	    return function (bLabel) {
	        var labelObj = angular.fromJson(bLabel);
	        if (angular.isDefined(labelObj.icon)) {
	            return labelObj.icon;
	        }
	        return null;
	    };
	}

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	'use strict';
	
	BreadcrumbLabel.$inject = ["$translate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = BreadcrumbLabel;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function BreadcrumbLabel($translate) {
	    var labels = {};
	
	    var breadcrumbLabel = function breadcrumbLabel(bLabel) {
	
	        var labelObj;
	        labelObj = angular.fromJson(bLabel);
	        if (labelObj) {
	            var translate = !(labelObj.translate && labelObj.translate === 'false');
	            var key = translate ? $translate.use() : 'orig';
	            if (!labels[labelObj.label]) {
	                labels[labelObj.label] = {};
	            }
	            if (!labels[labelObj.label][key]) {
	                labels[labelObj.label][key] = labelObj.label;
	                if (translate) {
	                    $translate([labelObj.label]).then(function (translations) {
	                        labels[labelObj.label][key] = translations[labelObj.label];
	                    });
	                }
	            }
	            return labels[labelObj.label][key];
	        } else {
	            return '';
	        }
	    };
	
	    breadcrumbLabel.$stateful = true;
	
	    return breadcrumbLabel;
	}

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	HomeController.$inject = ["types", "loginService", "userService", "deviceService", "Fullscreen", "$scope", "$element", "$rootScope", "$document", "$state", "$window", "$log", "$mdMedia", "$animate", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = HomeController;
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _logo_title_white = __webpack_require__(579);
	
	var _logo_title_white2 = _interopRequireDefault(_logo_title_white);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable angular/angularelement */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function HomeController(types, loginService, userService, deviceService, Fullscreen, $scope, $element, $rootScope, $document, $state, $window, $log, $mdMedia, $animate, $timeout) {
	
	    var siteSideNav = (0, _jquery2.default)('.tb-site-sidenav', $element);
	
	    var vm = this;
	
	    vm.Fullscreen = Fullscreen;
	    vm.logoSvg = _logo_title_white2.default;
	
	    if (angular.isUndefined($rootScope.searchConfig)) {
	        $rootScope.searchConfig = {
	            searchEnabled: false,
	            searchByEntitySubtype: false,
	            searchEntityType: null,
	            showSearch: false,
	            searchText: "",
	            searchEntitySubtype: ""
	        };
	    }
	
	    vm.isShowSidenav = false;
	    vm.isLockSidenav = false;
	
	    vm.displaySearchMode = displaySearchMode;
	    vm.displayEntitySubtypeSearch = displayEntitySubtypeSearch;
	    vm.openSidenav = openSidenav;
	    vm.goBack = goBack;
	    vm.searchTextUpdated = searchTextUpdated;
	    vm.sidenavClicked = sidenavClicked;
	    vm.toggleFullscreen = toggleFullscreen;
	    vm.openSearch = openSearch;
	    vm.closeSearch = closeSearch;
	
	    $scope.$on('$stateChangeSuccess', function (evt, to, toParams, from) {
	        watchEntitySubtype(false);
	        if (angular.isDefined(to.data.searchEnabled)) {
	            $scope.searchConfig.searchEnabled = to.data.searchEnabled;
	            $scope.searchConfig.searchByEntitySubtype = to.data.searchByEntitySubtype;
	            $scope.searchConfig.searchEntityType = to.data.searchEntityType;
	            if ($scope.searchConfig.searchEnabled === false || to.name !== from.name) {
	                $scope.searchConfig.showSearch = false;
	                $scope.searchConfig.searchText = "";
	                $scope.searchConfig.searchEntitySubtype = "";
	            }
	        } else {
	            $scope.searchConfig.searchEnabled = false;
	            $scope.searchConfig.searchByEntitySubtype = false;
	            $scope.searchConfig.searchEntityType = null;
	            $scope.searchConfig.showSearch = false;
	            $scope.searchConfig.searchText = "";
	            $scope.searchConfig.searchEntitySubtype = "";
	        }
	        watchEntitySubtype($scope.searchConfig.searchByEntitySubtype);
	    });
	
	    vm.isGtSm = $mdMedia('gt-sm');
	    if (vm.isGtSm) {
	        vm.isLockSidenav = true;
	        $animate.enabled(siteSideNav, false);
	    }
	
	    $scope.$watch(function () {
	        return $mdMedia('gt-sm');
	    }, function (isGtSm) {
	        vm.isGtSm = isGtSm;
	        vm.isLockSidenav = isGtSm;
	        vm.isShowSidenav = isGtSm;
	        if (!isGtSm) {
	            $timeout(function () {
	                $animate.enabled(siteSideNav, true);
	            }, 0, false);
	        } else {
	            $animate.enabled(siteSideNav, false);
	        }
	    });
	
	    function watchEntitySubtype(enableWatch) {
	        if ($scope.entitySubtypeWatch) {
	            $scope.entitySubtypeWatch();
	        }
	        if (enableWatch) {
	            $scope.entitySubtypeWatch = $scope.$watch('searchConfig.searchEntitySubtype', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    $scope.$broadcast('searchEntitySubtypeUpdated');
	                }
	            });
	        }
	    }
	
	    function displaySearchMode() {
	        return $scope.searchConfig.searchEnabled && $scope.searchConfig.showSearch;
	    }
	
	    function displayEntitySubtypeSearch() {
	        return $scope.searchConfig.searchByEntitySubtype && vm.isGtSm;
	    }
	
	    function toggleFullscreen() {
	        if (Fullscreen.isEnabled()) {
	            Fullscreen.cancel();
	        } else {
	            Fullscreen.all();
	        }
	    }
	
	    function openSearch() {
	        if ($scope.searchConfig.searchEnabled) {
	            $scope.searchConfig.showSearch = true;
	            $timeout(function () {
	                angular.element('#tb-search-text-input', $element).focus();
	            });
	        }
	    }
	
	    function closeSearch() {
	        if ($scope.searchConfig.searchEnabled) {
	            $scope.searchConfig.showSearch = false;
	            if ($scope.searchConfig.searchText.length) {
	                $scope.searchConfig.searchText = '';
	                searchTextUpdated();
	            }
	        }
	    }
	
	    function searchTextUpdated() {
	        $scope.$broadcast('searchTextUpdated');
	    }
	
	    function openSidenav() {
	        vm.isShowSidenav = true;
	    }
	
	    function goBack() {
	        $window.history.back();
	    }
	
	    function closeSidenav() {
	        vm.isShowSidenav = false;
	    }
	
	    function sidenavClicked() {
	        if (!vm.isLockSidenav) {
	            closeSidenav();
	        }
	    }
	}
	
	/* eslint-enable angular/angularelement */
	
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	HomeRoutes.$inject = ["$stateProvider", "$breadcrumbProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = HomeRoutes;
	
	var _breadcrumbTpl = __webpack_require__(1496);
	
	var _breadcrumbTpl2 = _interopRequireDefault(_breadcrumbTpl);
	
	var _homeTpl = __webpack_require__(1497);
	
	var _homeTpl2 = _interopRequireDefault(_homeTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function HomeRoutes($stateProvider, $breadcrumbProvider) {
	
	    $breadcrumbProvider.setOptions({
	        prefixStateName: 'home',
	        templateUrl: _breadcrumbTpl2.default
	    });
	
	    $stateProvider.state('home', {
	        url: '',
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "@": {
	                controller: 'HomeController',
	                controllerAs: 'vm',
	                templateUrl: _homeTpl2.default
	            }
	        },
	        data: {
	            pageTitle: 'home.home'
	        },
	        ncyBreadcrumb: {
	            skip: true
	        }
	    });
	}

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(811);
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularSanitize = __webpack_require__(265);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularFullscreen = __webpack_require__(596);
	
	var _angularFullscreen2 = _interopRequireDefault(_angularFullscreen);
	
	__webpack_require__(591);
	
	var _menu = __webpack_require__(148);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _device = __webpack_require__(146);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _login = __webpack_require__(113);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _noAnimate = __webpack_require__(1193);
	
	var _noAnimate2 = _interopRequireDefault(_noAnimate);
	
	var _finishRender = __webpack_require__(1179);
	
	var _finishRender2 = _interopRequireDefault(_finishRender);
	
	var _sideMenu = __webpack_require__(1197);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _dashboardAutocomplete = __webpack_require__(1170);
	
	var _dashboardAutocomplete2 = _interopRequireDefault(_dashboardAutocomplete);
	
	var _kvMap = __webpack_require__(1184);
	
	var _kvMap2 = _interopRequireDefault(_kvMap);
	
	var _jsonObjectEdit = __webpack_require__(1182);
	
	var _jsonObjectEdit2 = _interopRequireDefault(_jsonObjectEdit);
	
	var _jsonContent = __webpack_require__(1181);
	
	var _jsonContent2 = _interopRequireDefault(_jsonContent);
	
	var _userMenu = __webpack_require__(1301);
	
	var _userMenu2 = _interopRequireDefault(_userMenu);
	
	var _entity = __webpack_require__(1267);
	
	var _entity2 = _interopRequireDefault(_entity);
	
	var _event = __webpack_require__(1276);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _alarm = __webpack_require__(1134);
	
	var _alarm2 = _interopRequireDefault(_alarm);
	
	var _audit = __webpack_require__(1165);
	
	var _audit2 = _interopRequireDefault(_audit);
	
	var _extension = __webpack_require__(1282);
	
	var _extension2 = _interopRequireDefault(_extension);
	
	var _tenant = __webpack_require__(1329);
	
	var _tenant2 = _interopRequireDefault(_tenant);
	
	var _customer = __webpack_require__(1212);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _user3 = __webpack_require__(1335);
	
	var _user4 = _interopRequireDefault(_user3);
	
	var _home = __webpack_require__(1288);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _admin = __webpack_require__(1129);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _profile = __webpack_require__(1310);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _asset = __webpack_require__(1158);
	
	var _asset2 = _interopRequireDefault(_asset);
	
	var _device3 = __webpack_require__(1242);
	
	var _device4 = _interopRequireDefault(_device3);
	
	var _entityView = __webpack_require__(1248);
	
	var _entityView2 = _interopRequireDefault(_entityView);
	
	var _widget = __webpack_require__(1339);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	var _dashboard = __webpack_require__(1222);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _rulechain = __webpack_require__(1313);
	
	var _rulechain2 = _interopRequireDefault(_rulechain);
	
	var _jsonform = __webpack_require__(1293);
	
	var _jsonform2 = _interopRequireDefault(_jsonform);
	
	var _home3 = __webpack_require__(1299);
	
	var _home4 = _interopRequireDefault(_home3);
	
	var _home5 = __webpack_require__(1298);
	
	var _home6 = _interopRequireDefault(_home5);
	
	var _breadcrumbLabel = __webpack_require__(1297);
	
	var _breadcrumbLabel2 = _interopRequireDefault(_breadcrumbLabel);
	
	var _breadcrumbIcon = __webpack_require__(1296);
	
	var _breadcrumbIcon2 = _interopRequireDefault(_breadcrumbIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.home', [_angularUiRouter2.default, _angularSanitize2.default, _angularFullscreen2.default.name, 'ncy-angular-breadcrumb', _menu2.default, _home2.default, _userMenu2.default, _entity2.default, _event2.default, _alarm2.default, _audit2.default, _extension2.default, _tenant2.default, _customer2.default, _user4.default, _admin2.default, _profile2.default, _asset2.default, _device4.default, _entityView2.default, _widget2.default, _dashboard2.default, _rulechain2.default, _jsonform2.default, _device2.default, _login2.default, _user2.default, _noAnimate2.default, _finishRender2.default, _sideMenu2.default, _dashboardAutocomplete2.default, _kvMap2.default, _jsonObjectEdit2.default, _jsonContent2.default]).config(_home4.default).controller('HomeController', _home6.default).filter('breadcrumbLabel', _breadcrumbLabel2.default).filter('breadcrumbIcon', _breadcrumbIcon2.default).name; /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    */

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UserMenuController.$inject = ["$scope", "userService", "$translate", "$state"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(812);
	
	var _userMenuTpl = __webpack_require__(1498);
	
	var _userMenuTpl2 = _interopRequireDefault(_userMenuTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.directives.usermenu', []).directive('tbUserMenu', UserMenu).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function UserMenu() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            displayUserInfo: '='
	        },
	        controller: UserMenuController,
	        controllerAs: 'vm',
	        templateUrl: _userMenuTpl2.default
	    };
	}
	
	/*@ngInject*/
	function UserMenuController($scope, userService, $translate, $state) {
	
	    var vm = this;
	
	    var dashboardUser = userService.getCurrentUser();
	
	    vm.authorityName = authorityName;
	    vm.logout = logout;
	    vm.openProfile = openProfile;
	    vm.userDisplayName = userDisplayName;
	
	    function authorityName() {
	        var name = "user.anonymous";
	        if (dashboardUser) {
	            var authority = dashboardUser.authority;
	            if (authority === 'SYS_ADMIN') {
	                name = 'user.sys-admin';
	            } else if (authority === 'TENANT_ADMIN') {
	                name = 'user.tenant-admin';
	            } else if (authority === 'CUSTOMER_USER') {
	                name = 'user.customer';
	            }
	        }
	        return $translate.instant(name);
	    }
	
	    function userDisplayName() {
	        var name = "";
	        if (dashboardUser) {
	            if (dashboardUser.firstName && dashboardUser.firstName.length > 0 || dashboardUser.lastName && dashboardUser.lastName.length > 0) {
	                if (dashboardUser.firstName) {
	                    name += dashboardUser.firstName;
	                }
	                if (dashboardUser.lastName) {
	                    if (name.length > 0) {
	                        name += " ";
	                    }
	                    name += dashboardUser.lastName;
	                }
	            } else {
	                name = dashboardUser.email;
	            }
	        }
	        return name;
	    }
	
	    function openProfile() {
	        $state.go('home.profile');
	    }
	
	    function logout() {
	        userService.logout();
	    }
	}

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

	'use strict';
	
	ThingsboardMissingTranslateHandler.$inject = ["$log", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.locale', []).factory('tbMissingTranslationHandler', ThingsboardMissingTranslateHandler).name;
	
	/*@ngInject*/
	
	function ThingsboardMissingTranslateHandler($log, types) {
	
	    return function (translationId) {
	        if (translationId && !translationId.startsWith(types.translate.customTranslationsPrefix)) {
	            $log.warn('Translation for ' + translationId + ' doesn\'t exist');
	        }
	    };
	}

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

	'use strict';
	
	CreatePasswordController.$inject = ["$stateParams", "$translate", "toast", "loginService", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = CreatePasswordController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function CreatePasswordController($stateParams, $translate, toast, loginService, userService) {
	    var vm = this;
	
	    vm.password = '';
	    vm.password2 = '';
	
	    vm.createPassword = createPassword;
	
	    function createPassword() {
	        if (vm.password !== vm.password2) {
	            toast.showError($translate.instant('login.passwords-mismatch-error'));
	        } else {
	            loginService.activate($stateParams.activateToken, vm.password).then(function success(response) {
	                var token = response.data.token;
	                var refreshToken = response.data.refreshToken;
	                userService.setUserFromJwtToken(token, refreshToken, true);
	            }, function fail() {});
	        }
	    }
	}

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(813);
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _login = __webpack_require__(113);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _toast = __webpack_require__(75);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _login3 = __webpack_require__(1306);
	
	var _login4 = _interopRequireDefault(_login3);
	
	var _login5 = __webpack_require__(1305);
	
	var _login6 = _interopRequireDefault(_login5);
	
	var _resetPasswordRequest = __webpack_require__(1307);
	
	var _resetPasswordRequest2 = _interopRequireDefault(_resetPasswordRequest);
	
	var _resetPassword = __webpack_require__(1308);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _createPassword = __webpack_require__(1303);
	
	var _createPassword2 = _interopRequireDefault(_createPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.login', [_angularUiRouter2.default, _login2.default, _user2.default, _toast2.default]).config(_login4.default).controller('LoginController', _login6.default).controller('ResetPasswordRequestController', _resetPasswordRequest2.default).controller('ResetPasswordController', _resetPassword2.default).controller('CreatePasswordController', _createPassword2.default).name;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	LoginController.$inject = ["toast", "loginService", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = LoginController;
	
	var _logo_title_white = __webpack_require__(579);
	
	var _logo_title_white2 = _interopRequireDefault(_logo_title_white);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function LoginController(toast, loginService, userService /*, $rootScope, $log, $translate*/) {
	    var vm = this;
	
	    vm.logoSvg = _logo_title_white2.default;
	
	    vm.user = {
	        name: '',
	        password: ''
	    };
	
	    vm.login = login;
	
	    function doLogin() {
	        loginService.login(vm.user).then(function success(response) {
	            var token = response.data.token;
	            var refreshToken = response.data.refreshToken;
	            userService.setUserFromJwtToken(token, refreshToken, true);
	        }, function fail() /*response*/{
	            /*if (response && response.data && response.data.message) {
	                toast.showError(response.data.message);
	            } else if (response && response.statusText) {
	                toast.showError(response.statusText);
	            } else {
	                toast.showError($translate.instant('error.unknown-error'));
	            }*/
	        });
	    }
	
	    function login() {
	        doLogin();
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	LoginRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = LoginRoutes;
	
	var _loginTpl = __webpack_require__(1500);
	
	var _loginTpl2 = _interopRequireDefault(_loginTpl);
	
	var _resetPasswordTpl = __webpack_require__(1502);
	
	var _resetPasswordTpl2 = _interopRequireDefault(_resetPasswordTpl);
	
	var _resetPasswordRequestTpl = __webpack_require__(1501);
	
	var _resetPasswordRequestTpl2 = _interopRequireDefault(_resetPasswordRequestTpl);
	
	var _createPasswordTpl = __webpack_require__(1499);
	
	var _createPasswordTpl2 = _interopRequireDefault(_createPasswordTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function LoginRoutes($stateProvider) {
	    $stateProvider.state('login', {
	        url: '/login',
	        module: 'public',
	        views: {
	            "@": {
	                controller: 'LoginController',
	                controllerAs: 'vm',
	                templateUrl: _loginTpl2.default
	            }
	        },
	        data: {
	            pageTitle: 'login.login'
	        }
	    }).state('login.resetPasswordRequest', {
	        url: '/resetPasswordRequest',
	        module: 'public',
	        views: {
	            "@": {
	                controller: 'ResetPasswordRequestController',
	                controllerAs: 'vm',
	                templateUrl: _resetPasswordRequestTpl2.default
	            }
	        },
	        data: {
	            pageTitle: 'login.request-password-reset'
	        }
	    }).state('login.resetPassword', {
	        url: '/resetPassword?resetToken',
	        module: 'public',
	        views: {
	            "@": {
	                controller: 'ResetPasswordController',
	                controllerAs: 'vm',
	                templateUrl: _resetPasswordTpl2.default
	            }
	        },
	        data: {
	            pageTitle: 'login.reset-password'
	        }
	    }).state('login.createPassword', {
	        url: '/createPassword?activateToken',
	        module: 'public',
	        views: {
	            "@": {
	                controller: 'CreatePasswordController',
	                controllerAs: 'vm',
	                templateUrl: _createPasswordTpl2.default
	            }
	        },
	        data: {
	            pageTitle: 'login.create-password'
	        }
	    });
	}

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	'use strict';
	
	ResetPasswordRequestController.$inject = ["$translate", "toast", "loginService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ResetPasswordRequestController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function ResetPasswordRequestController($translate, toast, loginService) {
	    var vm = this;
	
	    vm.email = '';
	
	    vm.sendResetPasswordLink = sendResetPasswordLink;
	
	    function sendResetPasswordLink() {
	        loginService.sendResetPasswordLink(vm.email).then(function success() {
	            toast.showSuccess($translate.instant('login.password-link-sent-message'));
	        }, function fail() {});
	    }
	}

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	'use strict';
	
	ResetPasswordController.$inject = ["$stateParams", "$translate", "toast", "loginService", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ResetPasswordController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function ResetPasswordController($stateParams, $translate, toast, loginService, userService) {
	    var vm = this;
	
	    vm.newPassword = '';
	    vm.newPassword2 = '';
	
	    vm.resetPassword = resetPassword;
	
	    function resetPassword() {
	        if (vm.newPassword !== vm.newPassword2) {
	            toast.showError($translate.instant('login.passwords-mismatch-error'));
	        } else {
	            loginService.resetPassword($stateParams.resetToken, vm.newPassword).then(function success(response) {
	                var token = response.data.token;
	                var refreshToken = response.data.refreshToken;
	                userService.setUserFromJwtToken(token, refreshToken, true);
	            }, function fail() {});
	        }
	    }
	}

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	'use strict';
	
	ChangePasswordController.$inject = ["$scope", "$translate", "toast", "$mdDialog", "loginService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ChangePasswordController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function ChangePasswordController($scope, $translate, toast, $mdDialog, loginService) {
	    var vm = this;
	
	    vm.currentPassword = '';
	    vm.newPassword = '';
	    vm.newPassword2 = '';
	
	    vm.cancel = cancel;
	    vm.changePassword = changePassword;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function changePassword() {
	        if (vm.newPassword !== vm.newPassword2) {
	            toast.showError($translate.instant('login.passwords-mismatch-error'));
	        } else {
	            loginService.changePassword(vm.currentPassword, vm.newPassword).then(function success() {
	                $scope.theForm.$setPristine();
	                $mdDialog.hide();
	            });
	        }
	    }
	}

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularMaterial = __webpack_require__(80);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularMessages = __webpack_require__(164);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _login = __webpack_require__(113);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _confirmOnExit = __webpack_require__(229);
	
	var _confirmOnExit2 = _interopRequireDefault(_confirmOnExit);
	
	var _profile = __webpack_require__(1312);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _profile3 = __webpack_require__(1311);
	
	var _profile4 = _interopRequireDefault(_profile3);
	
	var _changePassword = __webpack_require__(1309);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.profile', [_angularUiRouter2.default, _angularMaterial2.default, _angularMessages2.default, _user2.default, _login2.default, _confirmOnExit2.default]).config(_profile2.default).controller('ProfileController', _profile4.default).controller('ChangePasswordController', _changePassword2.default).name; /*
	                                                                                                                                                                                                                                                                                                                                                          * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                          * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                          * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                          * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                          *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                          * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                          * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                          * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                          * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                          * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                          */

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ProfileController.$inject = ["userService", "$scope", "$document", "$mdDialog", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ProfileController;
	
	var _changePasswordTpl = __webpack_require__(1503);
	
	var _changePasswordTpl2 = _interopRequireDefault(_changePasswordTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function ProfileController(userService, $scope, $document, $mdDialog, $translate) {
	    var vm = this;
	
	    vm.profileUser = {};
	    vm.save = save;
	    vm.changePassword = changePassword;
	    vm.languageList = (["en_US","es_ES","fr_FR","it_IT","ja_JA","ko_KR","pt_BR","ru_RU","zh_CN"]); //eslint-disable-line
	
	    loadProfile();
	
	    function loadProfile() {
	        userService.getUser(userService.getCurrentUser().userId).then(function success(user) {
	            vm.profileUser = user;
	            if (!vm.profileUser.additionalInfo) {
	                vm.profileUser.additionalInfo = {};
	            }
	            if (!vm.profileUser.additionalInfo.lang) {
	                vm.profileUser.additionalInfo.lang = $translate.use();
	            }
	        });
	    }
	
	    function save() {
	        userService.saveUser(vm.profileUser).then(function success(user) {
	            $translate.use(vm.profileUser.additionalInfo.lang);
	            vm.profileUser = user;
	            $scope.theForm.$setPristine();
	        });
	    }
	
	    function changePassword($event) {
	        $mdDialog.show({
	            controller: 'ChangePasswordController',
	            controllerAs: 'vm',
	            templateUrl: _changePasswordTpl2.default,
	            parent: angular.element($document[0].body),
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function () {}, function () {});
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ProfileRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ProfileRoutes;
	
	var _profileTpl = __webpack_require__(1504);
	
	var _profileTpl2 = _interopRequireDefault(_profileTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function ProfileRoutes($stateProvider) {
	
	    $stateProvider.state('home.profile', {
	        url: '/profile',
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN', 'CUSTOMER_USER'],
	        views: {
	            "content@home": {
	                templateUrl: _profileTpl2.default,
	                controllerAs: 'vm',
	                controller: 'ProfileController'
	            }
	        },
	        data: {
	            pageTitle: 'profile.profile'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "account_circle", "label": "profile.profile"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rulechain = __webpack_require__(1318);
	
	var _rulechain2 = _interopRequireDefault(_rulechain);
	
	var _rulechains = __webpack_require__(1319);
	
	var _rulechains2 = _interopRequireDefault(_rulechains);
	
	var _rulechain3 = __webpack_require__(1316);
	
	var _nodeScriptTest = __webpack_require__(1323);
	
	var _nodeScriptTest2 = _interopRequireDefault(_nodeScriptTest);
	
	var _rulechain4 = __webpack_require__(1317);
	
	var _rulechain5 = _interopRequireDefault(_rulechain4);
	
	var _rulenodeDefinedConfig = __webpack_require__(1321);
	
	var _rulenodeDefinedConfig2 = _interopRequireDefault(_rulenodeDefinedConfig);
	
	var _rulenodeConfig = __webpack_require__(1320);
	
	var _rulenodeConfig2 = _interopRequireDefault(_rulenodeConfig);
	
	var _rulenode = __webpack_require__(1322);
	
	var _rulenode2 = _interopRequireDefault(_rulenode);
	
	var _link = __webpack_require__(1314);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _messageTypeAutocomplete = __webpack_require__(1315);
	
	var _messageTypeAutocomplete2 = _interopRequireDefault(_messageTypeAutocomplete);
	
	var _nodeScriptTest3 = __webpack_require__(1324);
	
	var _nodeScriptTest4 = _interopRequireDefault(_nodeScriptTest3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.ruleChain', []).config(_rulechain2.default).controller('RuleChainsController', _rulechains2.default).controller('RuleChainController', _rulechain3.RuleChainController).controller('AddRuleNodeController', _rulechain3.AddRuleNodeController).controller('AddRuleNodeLinkController', _rulechain3.AddRuleNodeLinkController).controller('NodeScriptTestController', _nodeScriptTest2.default).directive('tbRuleChain', _rulechain5.default).directive('tbRuleNodeDefinedConfig', _rulenodeDefinedConfig2.default).directive('tbRuleNodeConfig', _rulenodeConfig2.default).directive('tbRuleNode', _rulenode2.default).directive('tbRuleNodeLink', _link2.default).directive('tbMessageTypeAutocomplete', _messageTypeAutocomplete2.default).factory('ruleNodeScriptTest', _nodeScriptTest4.default).name; /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	LinkDirective.$inject = ["$compile", "$templateCache", "$filter"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = LinkDirective;
	
	__webpack_require__(814);
	
	var _linkFieldsetTpl = __webpack_require__(1508);
	
	var _linkFieldsetTpl2 = _interopRequireDefault(_linkFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function LinkDirective($compile, $templateCache, $filter) {
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_linkFieldsetTpl2.default);
	        element.html(template);
	
	        scope.selectedLabel = null;
	        scope.labelSearchText = null;
	
	        scope.ngModelCtrl = ngModelCtrl;
	
	        var labelsList = [];
	
	        scope.transformLinkLabelChip = function (chip) {
	            var res = $filter('filter')(labelsList, { name: chip }, true);
	            var result;
	            if (res && res.length) {
	                result = angular.copy(res[0]);
	            } else {
	                result = {
	                    name: chip,
	                    value: chip
	                };
	            }
	            return result;
	        };
	
	        scope.labelsSearch = function (searchText) {
	            var labels = searchText ? $filter('filter')(labelsList, { name: searchText }) : labelsList;
	            return labels.map(function (label) {
	                return label.name;
	            });
	        };
	
	        scope.createLinkLabel = function (event, chipsId) {
	            var chipsChild = angular.element(chipsId, element)[0].firstElementChild;
	            var el = angular.element(chipsChild);
	            var chipBuffer = el.scope().$mdChipsCtrl.getChipBuffer();
	            event.preventDefault();
	            event.stopPropagation();
	            el.scope().$mdChipsCtrl.appendChip(chipBuffer.trim());
	            el.scope().$mdChipsCtrl.resetChipBuffer();
	        };
	
	        ngModelCtrl.$render = function () {
	            labelsList.length = 0;
	            for (var label in scope.allowedLabels) {
	                var linkLabel = {
	                    name: scope.allowedLabels[label].name,
	                    value: scope.allowedLabels[label].value
	                };
	                labelsList.push(linkLabel);
	            }
	
	            var link = ngModelCtrl.$viewValue;
	            var labels = [];
	            if (link && link.labels) {
	                for (var i = 0; i < link.labels.length; i++) {
	                    label = link.labels[i];
	                    if (scope.allowedLabels[label]) {
	                        labels.push(angular.copy(scope.allowedLabels[label]));
	                    } else {
	                        labels.push({
	                            name: label,
	                            value: label
	                        });
	                    }
	                }
	            }
	            scope.labels = labels;
	            scope.$watch('labels', function (newVal, prevVal) {
	                if (!angular.equals(newVal, prevVal)) {
	                    updateLabels();
	                }
	            }, true);
	        };
	
	        function updateLabels() {
	            if (ngModelCtrl.$viewValue) {
	                var labels = [];
	                for (var i = 0; i < scope.labels.length; i++) {
	                    labels.push(scope.labels[i].value);
	                }
	                ngModelCtrl.$viewValue.labels = labels;
	                ngModelCtrl.$viewValue.label = labels.join(' / ');
	                updateValidity();
	            }
	        }
	
	        function updateValidity() {
	            var valid = ngModelCtrl.$viewValue.labels && ngModelCtrl.$viewValue.labels.length ? true : false;
	            ngModelCtrl.$setValidity('linkLabels', valid);
	        }
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            allowedLabels: '=',
	            allowCustom: '=',
	            isEdit: '=',
	            isReadOnly: '='
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	MessageTypeAutocomplete.$inject = ["$compile", "$templateCache", "$q", "$filter", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = MessageTypeAutocomplete;
	
	__webpack_require__(815);
	
	var _messageTypeAutocompleteTpl = __webpack_require__(1509);
	
	var _messageTypeAutocompleteTpl2 = _interopRequireDefault(_messageTypeAutocompleteTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function MessageTypeAutocomplete($compile, $templateCache, $q, $filter, types) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_messageTypeAutocompleteTpl2.default);
	        element.html(template);
	
	        var messageTypeList = [];
	        for (var t in types.messageType) {
	            var type = types.messageType[t];
	            messageTypeList.push(type);
	        }
	
	        scope.messageType = null;
	        scope.messageTypeSearchText = '';
	
	        scope.fetchMessageTypes = function (searchText) {
	            var deferred = $q.defer();
	            var result = $filter('filter')(messageTypeList, { 'name': searchText });
	            if (result && result.length) {
	                deferred.resolve(result);
	            } else {
	                deferred.resolve([{ name: searchText, value: searchText }]);
	            }
	            return deferred.promise;
	        };
	
	        scope.messageTypeSearchTextChanged = function () {};
	
	        scope.updateView = function () {
	            if (!scope.disabled) {
	                var value = null;
	                if (scope.messageType) {
	                    value = scope.messageType.value;
	                }
	                ngModelCtrl.$setViewValue(value);
	            }
	        };
	
	        ngModelCtrl.$render = function () {
	            var value = ngModelCtrl.$viewValue;
	            if (value) {
	                var result = $filter('filter')(messageTypeList, { 'value': value }, true);
	                if (result && result.length) {
	                    scope.messageType = result[0];
	                } else {
	                    scope.messageType = {
	                        name: value,
	                        value: value
	                    };
	                }
	            } else {
	                scope.messageType = null;
	            }
	        };
	
	        scope.$watch('messageType', function (newValue, prevValue) {
	            if (!angular.equals(newValue, prevValue)) {
	                scope.updateView();
	            }
	        });
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        link: linker,
	        scope: {
	            theForm: '=?',
	            disabled: '=ngDisabled',
	            required: '=ngRequired'
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RuleChainController.$inject = ["$state", "$scope", "$compile", "$q", "$mdUtil", "$timeout", "$mdExpansionPanel", "$window", "$document", "$mdDialog", "$filter", "$translate", "hotkeys", "types", "ruleChainService", "itembuffer", "Modelfactory", "flowchartConstants", "ruleChain", "ruleChainMetaData", "ruleNodeComponents", "helpLinks"];
	AddRuleNodeController.$inject = ["$scope", "$mdDialog", "ruleNode", "ruleChainId", "helpLinks"];
	AddRuleNodeLinkController.$inject = ["$scope", "$mdDialog", "link", "labels", "allowCustomLabels", "helpLinks"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RuleChainController = RuleChainController;
	exports.AddRuleNodeController = AddRuleNodeController;
	exports.AddRuleNodeLinkController = AddRuleNodeLinkController;
	
	__webpack_require__(816);
	
	__webpack_require__(834);
	
	__webpack_require__(1714);
	
	__webpack_require__(833);
	
	var _addRulenodeTpl = __webpack_require__(1507);
	
	var _addRulenodeTpl2 = _interopRequireDefault(_addRulenodeTpl);
	
	var _addLinkTpl = __webpack_require__(1505);
	
	var _addLinkTpl2 = _interopRequireDefault(_addLinkTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function RuleChainController($state, $scope, $compile, $q, $mdUtil, $timeout, $mdExpansionPanel, $window, $document, $mdDialog, $filter, $translate, hotkeys, types, ruleChainService, itembuffer, Modelfactory, flowchartConstants, ruleChain, ruleChainMetaData, ruleNodeComponents, helpLinks) {
	
	    var vm = this;
	
	    vm.$mdExpansionPanel = $mdExpansionPanel;
	    vm.types = types;
	
	    if ($state.current.data.import && !ruleChain) {
	        $state.go('home.ruleChains');
	        return;
	    }
	
	    vm.isImport = $state.current.data.import;
	    vm.isConfirmOnExit = false;
	
	    $scope.$watch(function () {
	        return vm.isDirty || vm.isImport;
	    }, function (val) {
	        vm.isConfirmOnExit = val;
	    });
	
	    vm.errorTooltips = {};
	
	    vm.isFullscreen = false;
	
	    vm.editingRuleNode = null;
	    vm.isEditingRuleNode = false;
	
	    vm.editingRuleNodeLink = null;
	    vm.isEditingRuleNodeLink = false;
	
	    vm.isLibraryOpen = true;
	    vm.enableHotKeys = true;
	
	    Object.defineProperty(vm, 'isLibraryOpenReadonly', {
	        get: function get() {
	            return vm.isLibraryOpen;
	        },
	        set: function set() {}
	    });
	
	    vm.ruleNodeSearch = '';
	
	    vm.ruleChain = ruleChain;
	    vm.ruleChainMetaData = ruleChainMetaData;
	
	    vm.canvasControl = {};
	
	    vm.ruleChainModel = {
	        nodes: [],
	        edges: []
	    };
	
	    vm.ruleNodeTypesModel = {};
	    vm.ruleNodeTypesCanvasControl = {};
	    vm.ruleChainLibraryLoaded = false;
	    for (var type in types.ruleNodeType) {
	        if (!types.ruleNodeType[type].special) {
	            vm.ruleNodeTypesModel[type] = {
	                model: {
	                    nodes: [],
	                    edges: []
	                },
	                selectedObjects: []
	            };
	            vm.ruleNodeTypesCanvasControl[type] = {};
	        }
	    }
	
	    vm.selectedObjects = [];
	
	    vm.modelservice = Modelfactory(vm.ruleChainModel, vm.selectedObjects);
	
	    vm.saveRuleChain = saveRuleChain;
	    vm.revertRuleChain = revertRuleChain;
	
	    vm.objectsSelected = objectsSelected;
	    vm.deleteSelected = deleteSelected;
	
	    vm.triggerResize = triggerResize;
	
	    vm.openRuleChainContextMenu = openRuleChainContextMenu;
	
	    vm.helpLinkIdForRuleNodeType = helpLinkIdForRuleNodeType;
	
	    initHotKeys();
	
	    function openRuleChainContextMenu($event, $mdOpenMousepointMenu) {
	        if (vm.canvasControl.modelservice && !$event.ctrlKey && !$event.metaKey) {
	            var x = $event.clientX;
	            var y = $event.clientY;
	            var item = vm.canvasControl.modelservice.getItemInfoAtPoint(x, y);
	            vm.contextInfo = prepareContextMenu(item);
	            if (vm.contextInfo.items && vm.contextInfo.items.length > 0) {
	                vm.contextMenuEvent = $event;
	                $mdOpenMousepointMenu($event);
	                return false;
	            }
	        }
	    }
	
	    function prepareContextMenu(item) {
	        if (objectsSelected() || !item.node && !item.edge) {
	            return prepareRuleChainContextMenu();
	        } else if (item.node) {
	            return prepareRuleNodeContextMenu(item.node);
	        } else if (item.edge) {
	            return prepareEdgeContextMenu(item.edge);
	        }
	    }
	
	    function prepareRuleChainContextMenu() {
	        var contextInfo = {
	            headerClass: 'tb-rulechain',
	            icon: 'settings_ethernet',
	            title: vm.ruleChain.name,
	            subtitle: $translate.instant('rulechain.rulechain')
	        };
	        contextInfo.items = [];
	        if (vm.modelservice.nodes.getSelectedNodes().length) {
	            contextInfo.items.push({
	                action: function action() {
	                    copyRuleNodes();
	                },
	                enabled: true,
	                value: "rulenode.copy-selected",
	                icon: "content_copy",
	                shortcut: "M-C"
	            });
	        }
	        contextInfo.items.push({
	            action: function action($event) {
	                pasteRuleNodes($event);
	            },
	            enabled: itembuffer.hasRuleNodes(),
	            value: "action.paste",
	            icon: "content_paste",
	            shortcut: "M-V"
	        });
	        contextInfo.items.push({
	            divider: true
	        });
	        if (objectsSelected()) {
	            contextInfo.items.push({
	                action: function action() {
	                    vm.modelservice.deselectAll();
	                },
	                enabled: true,
	                value: "rulenode.deselect-all",
	                icon: "tab_unselected",
	                shortcut: "Esc"
	            });
	            contextInfo.items.push({
	                action: function action() {
	                    vm.modelservice.deleteSelected();
	                },
	                enabled: true,
	                value: "rulenode.delete-selected",
	                icon: "clear",
	                shortcut: "Del"
	            });
	        } else {
	            contextInfo.items.push({
	                action: function action() {
	                    vm.modelservice.selectAll();
	                },
	                enabled: true,
	                value: "rulenode.select-all",
	                icon: "select_all",
	                shortcut: "M-A"
	            });
	        }
	        contextInfo.items.push({
	            divider: true
	        });
	        contextInfo.items.push({
	            action: function action() {
	                vm.saveRuleChain();
	            },
	            enabled: !(vm.isInvalid || !vm.isDirty && !vm.isImport),
	            value: "action.apply-changes",
	            icon: "done",
	            shortcut: "M-S"
	        });
	        contextInfo.items.push({
	            action: function action() {
	                vm.revertRuleChain();
	            },
	            enabled: vm.isDirty,
	            value: "action.decline-changes",
	            icon: "close",
	            shortcut: "M-Z"
	        });
	        return contextInfo;
	    }
	
	    function prepareRuleNodeContextMenu(node) {
	        var contextInfo = {
	            headerClass: node.nodeClass,
	            icon: node.icon,
	            iconUrl: node.iconUrl,
	            title: node.name,
	            subtitle: node.component.name
	        };
	        contextInfo.items = [];
	        if (!node.readonly) {
	            contextInfo.items.push({
	                action: function action() {
	                    openNodeDetails(node);
	                },
	                enabled: true,
	                value: "rulenode.details",
	                icon: "menu"
	            });
	            contextInfo.items.push({
	                action: function action() {
	                    copyNode(node);
	                },
	                enabled: true,
	                value: "action.copy",
	                icon: "content_copy"
	            });
	            contextInfo.items.push({
	                action: function action() {
	                    vm.canvasControl.modelservice.nodes.delete(node);
	                },
	                enabled: true,
	                value: "action.delete",
	                icon: "clear",
	                shortcut: "M-X"
	            });
	        }
	        return contextInfo;
	    }
	
	    function prepareEdgeContextMenu(edge) {
	        var contextInfo = {
	            headerClass: 'tb-link',
	            icon: 'trending_flat',
	            title: edge.label,
	            subtitle: $translate.instant('rulenode.link')
	        };
	        contextInfo.items = [];
	        var sourceNode = vm.modelservice.nodes.getNodeByConnectorId(edge.source);
	        if (sourceNode.component.type != types.ruleNodeType.INPUT.value) {
	            contextInfo.items.push({
	                action: function action() {
	                    openLinkDetails(edge);
	                },
	                enabled: true,
	                value: "rulenode.details",
	                icon: "menu"
	            });
	        }
	        contextInfo.items.push({
	            action: function action() {
	                vm.canvasControl.modelservice.edges.delete(edge);
	            },
	            enabled: true,
	            value: "action.delete",
	            icon: "clear",
	            shortcut: "M-X"
	        });
	        return contextInfo;
	    }
	
	    function initHotKeys() {
	        hotkeys.bindTo($scope).add({
	            combo: 'ctrl+a',
	            description: $translate.instant('rulenode.select-all-objects'),
	            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	            callback: function callback(event) {
	                if (vm.enableHotKeys) {
	                    event.preventDefault();
	                    vm.modelservice.selectAll();
	                }
	            }
	        }).add({
	            combo: 'ctrl+c',
	            description: $translate.instant('rulenode.copy-selected'),
	            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	            callback: function callback(event) {
	                if (vm.enableHotKeys) {
	                    event.preventDefault();
	                    copyRuleNodes();
	                }
	            }
	        }).add({
	            combo: 'ctrl+v',
	            description: $translate.instant('action.paste'),
	            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	            callback: function callback(event) {
	                if (vm.enableHotKeys) {
	                    event.preventDefault();
	                    if (itembuffer.hasRuleNodes()) {
	                        pasteRuleNodes();
	                    }
	                }
	            }
	        }).add({
	            combo: 'esc',
	            description: $translate.instant('rulenode.deselect-all-objects'),
	            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	            callback: function callback(event) {
	                if (vm.enableHotKeys) {
	                    event.preventDefault();
	                    event.stopPropagation();
	                    vm.modelservice.deselectAll();
	                }
	            }
	        }).add({
	            combo: 'ctrl+s',
	            description: $translate.instant('action.apply'),
	            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	            callback: function callback(event) {
	                if (vm.enableHotKeys) {
	                    event.preventDefault();
	                    vm.saveRuleChain();
	                }
	            }
	        }).add({
	            combo: 'ctrl+z',
	            description: $translate.instant('action.decline-changes'),
	            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	            callback: function callback(event) {
	                if (vm.enableHotKeys) {
	                    event.preventDefault();
	                    vm.revertRuleChain();
	                }
	            }
	        }).add({
	            combo: 'del',
	            description: $translate.instant('rulenode.delete-selected-objects'),
	            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	            callback: function callback(event) {
	                if (vm.enableHotKeys) {
	                    event.preventDefault();
	                    vm.modelservice.deleteSelected();
	                }
	            }
	        });
	    }
	
	    vm.onEditRuleNodeClosed = function () {
	        vm.editingRuleNode = null;
	    };
	
	    vm.onEditRuleNodeLinkClosed = function () {
	        vm.editingRuleNodeLink = null;
	    };
	
	    vm.saveRuleNode = function (theForm) {
	        $scope.$broadcast('form-submit');
	        if (theForm.$valid) {
	            theForm.$setPristine();
	            if (vm.editingRuleNode.error) {
	                delete vm.editingRuleNode.error;
	            }
	            vm.ruleChainModel.nodes[vm.editingRuleNodeIndex] = vm.editingRuleNode;
	            vm.editingRuleNode = angular.copy(vm.editingRuleNode);
	            updateRuleNodesHighlight();
	        }
	    };
	
	    vm.saveRuleNodeLink = function (theForm) {
	        theForm.$setPristine();
	        vm.ruleChainModel.edges[vm.editingRuleNodeLinkIndex] = vm.editingRuleNodeLink;
	        vm.editingRuleNodeLink = angular.copy(vm.editingRuleNodeLink);
	    };
	
	    vm.onRevertRuleNodeEdit = function (theForm) {
	        theForm.$setPristine();
	        var node = vm.ruleChainModel.nodes[vm.editingRuleNodeIndex];
	        vm.editingRuleNode = angular.copy(node);
	    };
	
	    vm.onRevertRuleNodeLinkEdit = function (theForm) {
	        theForm.$setPristine();
	        var edge = vm.ruleChainModel.edges[vm.editingRuleNodeLinkIndex];
	        vm.editingRuleNodeLink = angular.copy(edge);
	    };
	
	    vm.nodeLibCallbacks = {
	        nodeCallbacks: {
	            'mouseEnter': function mouseEnter(event, node) {
	                displayLibNodeDescriptionTooltip(event, node);
	            },
	            'mouseLeave': function mouseLeave() {
	                destroyTooltips();
	            },
	            'mouseDown': function mouseDown() {
	                destroyTooltips();
	            }
	        }
	    };
	
	    vm.typeHeaderMouseEnter = function (event, typeId) {
	        var ruleNodeType = types.ruleNodeType[typeId];
	        displayTooltip(event, '<div class="tb-rule-node-tooltip tb-lib-tooltip">' + '<div id="tb-node-content" layout="column">' + '<div class="tb-node-title">' + $translate.instant(ruleNodeType.name) + '</div>' + '<div class="tb-node-details">' + $translate.instant(ruleNodeType.details) + '</div>' + '</div>' + '</div>');
	    };
	
	    vm.destroyTooltips = destroyTooltips;
	
	    function helpLinkIdForRuleNodeType() {
	        return helpLinks.getRuleNodeLink(vm.editingRuleNode);
	    }
	
	    function destroyTooltips() {
	        if (vm.tooltipTimeout) {
	            $timeout.cancel(vm.tooltipTimeout);
	            vm.tooltipTimeout = null;
	        }
	        var instances = angular.element.tooltipster.instances();
	        instances.forEach(function (instance) {
	            if (!instance.isErrorTooltip) {
	                instance.destroy();
	            }
	        });
	    }
	
	    function displayLibNodeDescriptionTooltip(event, node) {
	        displayTooltip(event, '<div class="tb-rule-node-tooltip tb-lib-tooltip">' + '<div id="tb-node-content" layout="column">' + '<div class="tb-node-title">' + node.component.name + '</div>' + '<div class="tb-node-description">' + node.component.configurationDescriptor.nodeDefinition.description + '</div>' + '<div class="tb-node-details">' + node.component.configurationDescriptor.nodeDefinition.details + '</div>' + '</div>' + '</div>');
	    }
	
	    function displayNodeDescriptionTooltip(event, node) {
	        if (!vm.errorTooltips[node.id]) {
	            var name, desc, details;
	            if (node.component.type == vm.types.ruleNodeType.INPUT.value) {
	                name = $translate.instant(vm.types.ruleNodeType.INPUT.name) + '';
	                desc = $translate.instant(vm.types.ruleNodeType.INPUT.details) + '';
	            } else {
	                name = node.name;
	                desc = $translate.instant(vm.types.ruleNodeType[node.component.type].name) + ' - ' + node.component.name;
	                if (node.additionalInfo) {
	                    details = node.additionalInfo.description;
	                }
	            }
	            var tooltipContent = '<div class="tb-rule-node-tooltip">' + '<div id="tb-node-content" layout="column">' + '<div class="tb-node-title">' + name + '</div>' + '<div class="tb-node-description">' + desc + '</div>';
	            if (details) {
	                tooltipContent += '<div class="tb-node-details">' + details + '</div>';
	            }
	            tooltipContent += '</div>' + '</div>';
	            displayTooltip(event, tooltipContent);
	        }
	    }
	
	    function displayTooltip(event, content) {
	        destroyTooltips();
	        vm.tooltipTimeout = $timeout(function () {
	            var element = angular.element(event.target);
	            element.tooltipster({
	                theme: 'tooltipster-shadow',
	                delay: 100,
	                trigger: 'custom',
	                triggerOpen: {
	                    click: false,
	                    tap: false
	                },
	                triggerClose: {
	                    click: true,
	                    tap: true,
	                    scroll: true
	                },
	                side: 'right',
	                trackOrigin: true
	            });
	            var contentElement = angular.element(content);
	            $compile(contentElement)($scope);
	            var tooltip = element.tooltipster('instance');
	            tooltip.content(contentElement);
	            tooltip.open();
	        }, 500);
	    }
	
	    function updateNodeErrorTooltip(node) {
	        if (node.error) {
	            var element = angular.element('#' + node.id);
	            var tooltip = vm.errorTooltips[node.id];
	            if (!tooltip || !element.hasClass("tooltipstered")) {
	                element.tooltipster({
	                    theme: 'tooltipster-shadow',
	                    delay: 0,
	                    animationDuration: 0,
	                    trigger: 'custom',
	                    triggerOpen: {
	                        click: false,
	                        tap: false
	                    },
	                    triggerClose: {
	                        click: false,
	                        tap: false,
	                        scroll: false
	                    },
	                    side: 'top',
	                    trackOrigin: true
	                });
	                var content = '<div class="tb-rule-node-error-tooltip">' + '<div id="tooltip-content" layout="column">' + '<div class="tb-node-details">' + node.error + '</div>' + '</div>' + '</div>';
	                var contentElement = angular.element(content);
	                $compile(contentElement)($scope);
	                tooltip = element.tooltipster('instance');
	                tooltip.isErrorTooltip = true;
	                tooltip.content(contentElement);
	                vm.errorTooltips[node.id] = tooltip;
	            }
	            $mdUtil.nextTick(function () {
	                tooltip.open();
	            });
	        } else {
	            if (vm.errorTooltips[node.id]) {
	                tooltip = vm.errorTooltips[node.id];
	                tooltip.destroy();
	                delete vm.errorTooltips[node.id];
	            }
	        }
	    }
	
	    function updateErrorTooltips(hide) {
	        for (var nodeId in vm.errorTooltips) {
	            var tooltip = vm.errorTooltips[nodeId];
	            if (hide) {
	                tooltip.close();
	            } else {
	                tooltip.open();
	            }
	        }
	    }
	
	    $scope.$watch(function () {
	        return vm.isEditingRuleNode || vm.isEditingRuleNodeLink;
	    }, function (val) {
	        vm.enableHotKeys = !val;
	        updateErrorTooltips(val);
	    });
	
	    vm.editCallbacks = {
	        edgeDoubleClick: function edgeDoubleClick(event, edge) {
	            openLinkDetails(edge);
	        },
	        edgeEdit: function edgeEdit(event, edge) {
	            openLinkDetails(edge);
	        },
	        nodeCallbacks: {
	            'doubleClick': function doubleClick(event, node) {
	                openNodeDetails(node);
	            },
	            'nodeEdit': function nodeEdit(event, node) {
	                openNodeDetails(node);
	            },
	            'mouseEnter': function mouseEnter(event, node) {
	                displayNodeDescriptionTooltip(event, node);
	            },
	            'mouseLeave': function mouseLeave() {
	                destroyTooltips();
	            },
	            'mouseDown': function mouseDown() {
	                destroyTooltips();
	            }
	        },
	        isValidEdge: function isValidEdge(source, destination) {
	            return source.type === flowchartConstants.rightConnectorType && destination.type === flowchartConstants.leftConnectorType;
	        },
	        createEdge: function createEdge(event, edge) {
	            var deferred = $q.defer();
	            var sourceNode = vm.modelservice.nodes.getNodeByConnectorId(edge.source);
	            if (sourceNode.component.type == types.ruleNodeType.INPUT.value) {
	                var destNode = vm.modelservice.nodes.getNodeByConnectorId(edge.destination);
	                if (destNode.component.type == types.ruleNodeType.RULE_CHAIN.value) {
	                    deferred.reject();
	                } else {
	                    var res = $filter('filter')(vm.ruleChainModel.edges, { source: vm.inputConnectorId }, true);
	                    if (res && res.length) {
	                        vm.modelservice.edges.delete(res[0]);
	                    }
	                    deferred.resolve(edge);
	                }
	            } else {
	                if (edge.label) {
	                    if (!edge.labels) {
	                        edge.labels = edge.label.split(' / ');
	                    }
	                    deferred.resolve(edge);
	                } else {
	                    var labels = ruleChainService.getRuleNodeSupportedLinks(sourceNode.component);
	                    var allowCustomLabels = ruleChainService.ruleNodeAllowCustomLinks(sourceNode.component);
	                    vm.enableHotKeys = false;
	                    addRuleNodeLink(event, edge, labels, allowCustomLabels).then(function (link) {
	                        deferred.resolve(link);
	                        vm.enableHotKeys = true;
	                    }, function () {
	                        deferred.reject();
	                        vm.enableHotKeys = true;
	                    });
	                }
	            }
	            return deferred.promise;
	        },
	        dropNode: function dropNode(event, node) {
	            addRuleNode(event, node);
	        }
	    };
	
	    function openNodeDetails(node) {
	        if (node.component.type != types.ruleNodeType.INPUT.value) {
	            vm.isEditingRuleNodeLink = false;
	            vm.editingRuleNodeLink = null;
	            vm.isEditingRuleNode = true;
	            vm.editingRuleNodeIndex = vm.ruleChainModel.nodes.indexOf(node);
	            vm.editingRuleNode = angular.copy(node);
	            $mdUtil.nextTick(function () {
	                if (vm.ruleNodeForm) {
	                    vm.ruleNodeForm.$setPristine();
	                }
	            });
	        }
	    }
	
	    function openLinkDetails(edge) {
	        var sourceNode = vm.modelservice.nodes.getNodeByConnectorId(edge.source);
	        if (sourceNode.component.type != types.ruleNodeType.INPUT.value) {
	            vm.isEditingRuleNode = false;
	            vm.editingRuleNode = null;
	            vm.editingRuleNodeLinkLabels = ruleChainService.getRuleNodeSupportedLinks(sourceNode.component);
	            vm.editingRuleNodeAllowCustomLabels = ruleChainService.ruleNodeAllowCustomLinks(sourceNode.component);
	            vm.isEditingRuleNodeLink = true;
	            vm.editingRuleNodeLinkIndex = vm.ruleChainModel.edges.indexOf(edge);
	            vm.editingRuleNodeLink = angular.copy(edge);
	            $mdUtil.nextTick(function () {
	                if (vm.ruleNodeLinkForm) {
	                    vm.ruleNodeLinkForm.$setPristine();
	                }
	            });
	        }
	    }
	
	    function copyNode(node) {
	        itembuffer.copyRuleNodes([node], []);
	    }
	
	    function copyRuleNodes() {
	        var nodes = vm.modelservice.nodes.getSelectedNodes();
	        var edges = vm.modelservice.edges.getSelectedEdges();
	        var connections = [];
	        for (var i = 0; i < edges.length; i++) {
	            var edge = edges[i];
	            var sourceNode = vm.modelservice.nodes.getNodeByConnectorId(edge.source);
	            var destNode = vm.modelservice.nodes.getNodeByConnectorId(edge.destination);
	            var isInputSource = sourceNode.component.type == types.ruleNodeType.INPUT.value;
	            var fromIndex = nodes.indexOf(sourceNode);
	            var toIndex = nodes.indexOf(destNode);
	            if ((isInputSource || fromIndex > -1) && toIndex > -1) {
	                var connection = {
	                    isInputSource: isInputSource,
	                    fromIndex: fromIndex,
	                    toIndex: toIndex,
	                    label: edge.label,
	                    labels: edge.labels
	                };
	                connections.push(connection);
	            }
	        }
	        itembuffer.copyRuleNodes(nodes, connections);
	    }
	
	    function pasteRuleNodes(event) {
	        var canvas = angular.element(vm.canvasControl.modelservice.getCanvasHtmlElement());
	        var x, y;
	        if (event) {
	            var offset = canvas.offset();
	            x = Math.round(event.clientX - offset.left);
	            y = Math.round(event.clientY - offset.top);
	        } else {
	            var scrollParent = canvas.parent();
	            var scrollTop = scrollParent.scrollTop();
	            var scrollLeft = scrollParent.scrollLeft();
	            x = scrollLeft + scrollParent.width() / 2;
	            y = scrollTop + scrollParent.height() / 2;
	        }
	        var ruleNodes = itembuffer.pasteRuleNodes(x, y, event);
	        if (ruleNodes) {
	            vm.modelservice.deselectAll();
	            var nodes = [];
	            for (var i = 0; i < ruleNodes.nodes.length; i++) {
	                var node = ruleNodes.nodes[i];
	                node.id = 'rule-chain-node-' + vm.nextNodeID++;
	                var component = node.component;
	                if (component.configurationDescriptor.nodeDefinition.inEnabled) {
	                    node.connectors.push({
	                        type: flowchartConstants.leftConnectorType,
	                        id: vm.nextConnectorID++
	                    });
	                }
	                if (component.configurationDescriptor.nodeDefinition.outEnabled) {
	                    node.connectors.push({
	                        type: flowchartConstants.rightConnectorType,
	                        id: vm.nextConnectorID++
	                    });
	                }
	                nodes.push(node);
	                vm.ruleChainModel.nodes.push(node);
	                vm.modelservice.nodes.select(node);
	            }
	            for (i = 0; i < ruleNodes.connections.length; i++) {
	                var connection = ruleNodes.connections[i];
	                var sourceNode = nodes[connection.fromIndex];
	                var destNode = nodes[connection.toIndex];
	                if ((connection.isInputSource || sourceNode) && destNode) {
	                    var source, destination;
	                    if (connection.isInputSource) {
	                        source = vm.inputConnectorId;
	                    } else {
	                        var sourceConnectors = vm.modelservice.nodes.getConnectorsByType(sourceNode, flowchartConstants.rightConnectorType);
	                        if (sourceConnectors && sourceConnectors.length) {
	                            source = sourceConnectors[0].id;
	                        }
	                    }
	                    var destConnectors = vm.modelservice.nodes.getConnectorsByType(destNode, flowchartConstants.leftConnectorType);
	                    if (destConnectors && destConnectors.length) {
	                        destination = destConnectors[0].id;
	                    }
	                    if (source && destination) {
	                        var edge = {
	                            source: source,
	                            destination: destination,
	                            label: connection.label,
	                            labels: connection.labels
	                        };
	                        vm.ruleChainModel.edges.push(edge);
	                        vm.modelservice.edges.select(edge);
	                    }
	                }
	            }
	
	            if (vm.canvasControl.adjustCanvasSize) {
	                vm.canvasControl.adjustCanvasSize();
	            }
	
	            updateRuleNodesHighlight();
	
	            validate();
	        }
	    }
	
	    loadRuleChainLibrary(ruleNodeComponents, true);
	
	    $scope.$watch('vm.ruleNodeSearch', function (newVal, oldVal) {
	        if (!angular.equals(newVal, oldVal)) {
	            var res = $filter('filter')(ruleNodeComponents, { name: vm.ruleNodeSearch });
	            loadRuleChainLibrary(res);
	        }
	    });
	
	    $scope.$on('searchTextUpdated', function () {
	        updateRuleNodesHighlight();
	    });
	
	    function loadRuleChainLibrary(ruleNodeComponents, loadRuleChain) {
	        for (var componentType in vm.ruleNodeTypesModel) {
	            vm.ruleNodeTypesModel[componentType].model.nodes.length = 0;
	        }
	        for (var i = 0; i < ruleNodeComponents.length; i++) {
	            var ruleNodeComponent = ruleNodeComponents[i];
	            componentType = ruleNodeComponent.type;
	            var model = vm.ruleNodeTypesModel[componentType].model;
	            var icon = vm.types.ruleNodeType[componentType].icon;
	            var iconUrl = null;
	            if (ruleNodeComponent.configurationDescriptor.nodeDefinition.icon) {
	                icon = ruleNodeComponent.configurationDescriptor.nodeDefinition.icon;
	            }
	            if (ruleNodeComponent.configurationDescriptor.nodeDefinition.iconUrl) {
	                iconUrl = ruleNodeComponent.configurationDescriptor.nodeDefinition.iconUrl;
	            }
	            var node = {
	                id: 'node-lib-' + componentType + '-' + model.nodes.length,
	                component: ruleNodeComponent,
	                name: '',
	                nodeClass: vm.types.ruleNodeType[componentType].nodeClass,
	                icon: icon,
	                iconUrl: iconUrl,
	                x: 30,
	                y: 10 + 50 * model.nodes.length,
	                connectors: []
	            };
	            if (ruleNodeComponent.configurationDescriptor.nodeDefinition.inEnabled) {
	                node.connectors.push({
	                    type: flowchartConstants.leftConnectorType,
	                    id: model.nodes.length * 2
	                });
	            }
	            if (ruleNodeComponent.configurationDescriptor.nodeDefinition.outEnabled) {
	                node.connectors.push({
	                    type: flowchartConstants.rightConnectorType,
	                    id: model.nodes.length * 2 + 1
	                });
	            }
	            model.nodes.push(node);
	        }
	        vm.ruleChainLibraryLoaded = true;
	        if (loadRuleChain) {
	            prepareRuleChain();
	        }
	        $mdUtil.nextTick(function () {
	            for (componentType in vm.ruleNodeTypesCanvasControl) {
	                if (vm.ruleNodeTypesCanvasControl[componentType].adjustCanvasSize) {
	                    vm.ruleNodeTypesCanvasControl[componentType].adjustCanvasSize(true);
	                }
	            }
	            for (componentType in vm.ruleNodeTypesModel) {
	                var panel = vm.$mdExpansionPanel(componentType);
	                if (panel) {
	                    if (!vm.ruleNodeTypesModel[componentType].model.nodes.length) {
	                        panel.collapse();
	                    } else {
	                        panel.expand();
	                    }
	                }
	            }
	        });
	    }
	
	    function prepareRuleChain() {
	
	        if (vm.ruleChainWatch) {
	            vm.ruleChainWatch();
	            vm.ruleChainWatch = null;
	        }
	
	        vm.nextNodeID = 1;
	        vm.nextConnectorID = 1;
	
	        vm.selectedObjects.length = 0;
	        vm.ruleChainModel.nodes.length = 0;
	        vm.ruleChainModel.edges.length = 0;
	
	        vm.inputConnectorId = vm.nextConnectorID++;
	
	        vm.ruleChainModel.nodes.push({
	            id: 'rule-chain-node-' + vm.nextNodeID++,
	            component: types.inputNodeComponent,
	            name: "",
	            nodeClass: types.ruleNodeType.INPUT.nodeClass,
	            icon: types.ruleNodeType.INPUT.icon,
	            readonly: true,
	            x: 50,
	            y: 150,
	            connectors: [{
	                type: flowchartConstants.rightConnectorType,
	                id: vm.inputConnectorId
	            }]
	
	        });
	        ruleChainService.resolveTargetRuleChains(vm.ruleChainMetaData.ruleChainConnections).then(function (ruleChainsMap) {
	            createRuleChainModel(ruleChainsMap);
	        });
	    }
	
	    function createRuleChainModel(ruleChainsMap) {
	        var nodes = [];
	        for (var i = 0; i < vm.ruleChainMetaData.nodes.length; i++) {
	            var ruleNode = vm.ruleChainMetaData.nodes[i];
	            var component = ruleChainService.getRuleNodeComponentByClazz(ruleNode.type);
	            if (component) {
	                var icon = vm.types.ruleNodeType[component.type].icon;
	                var iconUrl = null;
	                if (component.configurationDescriptor.nodeDefinition.icon) {
	                    icon = component.configurationDescriptor.nodeDefinition.icon;
	                }
	                if (component.configurationDescriptor.nodeDefinition.iconUrl) {
	                    iconUrl = component.configurationDescriptor.nodeDefinition.iconUrl;
	                }
	                var node = {
	                    id: 'rule-chain-node-' + vm.nextNodeID++,
	                    ruleNodeId: ruleNode.id,
	                    additionalInfo: ruleNode.additionalInfo,
	                    configuration: ruleNode.configuration,
	                    debugMode: ruleNode.debugMode,
	                    x: Math.round(ruleNode.additionalInfo.layoutX),
	                    y: Math.round(ruleNode.additionalInfo.layoutY),
	                    component: component,
	                    name: ruleNode.name,
	                    nodeClass: vm.types.ruleNodeType[component.type].nodeClass,
	                    icon: icon,
	                    iconUrl: iconUrl,
	                    connectors: []
	                };
	                if (component.configurationDescriptor.nodeDefinition.inEnabled) {
	                    node.connectors.push({
	                        type: flowchartConstants.leftConnectorType,
	                        id: vm.nextConnectorID++
	                    });
	                }
	                if (component.configurationDescriptor.nodeDefinition.outEnabled) {
	                    node.connectors.push({
	                        type: flowchartConstants.rightConnectorType,
	                        id: vm.nextConnectorID++
	                    });
	                }
	                nodes.push(node);
	                vm.ruleChainModel.nodes.push(node);
	            }
	        }
	
	        if (vm.ruleChainMetaData.firstNodeIndex > -1) {
	            var destNode = nodes[vm.ruleChainMetaData.firstNodeIndex];
	            if (destNode) {
	                var connectors = vm.modelservice.nodes.getConnectorsByType(destNode, flowchartConstants.leftConnectorType);
	                if (connectors && connectors.length) {
	                    var edge = {
	                        source: vm.inputConnectorId,
	                        destination: connectors[0].id
	                    };
	                    vm.ruleChainModel.edges.push(edge);
	                }
	            }
	        }
	
	        if (vm.ruleChainMetaData.connections) {
	            var edgeMap = {};
	            for (i = 0; i < vm.ruleChainMetaData.connections.length; i++) {
	                var connection = vm.ruleChainMetaData.connections[i];
	                var sourceNode = nodes[connection.fromIndex];
	                destNode = nodes[connection.toIndex];
	                if (sourceNode && destNode) {
	                    var sourceConnectors = vm.modelservice.nodes.getConnectorsByType(sourceNode, flowchartConstants.rightConnectorType);
	                    var destConnectors = vm.modelservice.nodes.getConnectorsByType(destNode, flowchartConstants.leftConnectorType);
	                    if (sourceConnectors && sourceConnectors.length && destConnectors && destConnectors.length) {
	                        var sourceId = sourceConnectors[0].id;
	                        var destId = destConnectors[0].id;
	                        var edgeKey = sourceId + '_' + destId;
	                        edge = edgeMap[edgeKey];
	                        if (!edge) {
	                            edge = {
	                                source: sourceId,
	                                destination: destId,
	                                label: connection.type,
	                                labels: [connection.type]
	                            };
	                            edgeMap[edgeKey] = edge;
	                            vm.ruleChainModel.edges.push(edge);
	                        } else {
	                            edge.label += ' / ' + connection.type;
	                            edge.labels.push(connection.type);
	                        }
	                    }
	                }
	            }
	        }
	
	        if (vm.ruleChainMetaData.ruleChainConnections) {
	            var ruleChainNodesMap = {};
	            var ruleChainEdgeMap = {};
	            for (i = 0; i < vm.ruleChainMetaData.ruleChainConnections.length; i++) {
	                var ruleChainConnection = vm.ruleChainMetaData.ruleChainConnections[i];
	                var ruleChain = ruleChainsMap[ruleChainConnection.targetRuleChainId.id];
	                if (ruleChainConnection.additionalInfo && ruleChainConnection.additionalInfo.ruleChainNodeId) {
	                    var ruleChainNode = ruleChainNodesMap[ruleChainConnection.additionalInfo.ruleChainNodeId];
	                    if (!ruleChainNode) {
	                        ruleChainNode = {
	                            id: 'rule-chain-node-' + vm.nextNodeID++,
	                            additionalInfo: ruleChainConnection.additionalInfo,
	                            x: Math.round(ruleChainConnection.additionalInfo.layoutX),
	                            y: Math.round(ruleChainConnection.additionalInfo.layoutY),
	                            component: types.ruleChainNodeComponent,
	                            nodeClass: vm.types.ruleNodeType.RULE_CHAIN.nodeClass,
	                            icon: vm.types.ruleNodeType.RULE_CHAIN.icon,
	                            connectors: [{
	                                type: flowchartConstants.leftConnectorType,
	                                id: vm.nextConnectorID++
	                            }]
	                        };
	                        if (ruleChain.name) {
	                            ruleChainNode.name = ruleChain.name;
	                            ruleChainNode.targetRuleChainId = ruleChainConnection.targetRuleChainId.id;
	                        } else {
	                            ruleChainNode.name = "Unresolved";
	                            ruleChainNode.targetRuleChainId = null;
	                            ruleChainNode.error = $translate.instant('rulenode.invalid-target-rulechain');
	                        }
	                        ruleChainNodesMap[ruleChainConnection.additionalInfo.ruleChainNodeId] = ruleChainNode;
	                        vm.ruleChainModel.nodes.push(ruleChainNode);
	                    }
	                    sourceNode = nodes[ruleChainConnection.fromIndex];
	                    if (sourceNode) {
	                        connectors = vm.modelservice.nodes.getConnectorsByType(sourceNode, flowchartConstants.rightConnectorType);
	                        if (connectors && connectors.length) {
	                            sourceId = connectors[0].id;
	                            destId = ruleChainNode.connectors[0].id;
	                            edgeKey = sourceId + '_' + destId;
	                            var ruleChainEdge = ruleChainEdgeMap[edgeKey];
	                            if (!ruleChainEdge) {
	                                ruleChainEdge = {
	                                    source: sourceId,
	                                    destination: destId,
	                                    label: ruleChainConnection.type,
	                                    labels: [ruleChainConnection.type]
	                                };
	                                ruleChainEdgeMap[edgeKey] = ruleChainEdge;
	                                vm.ruleChainModel.edges.push(ruleChainEdge);
	                            } else {
	                                ruleChainEdge.label += ' / ' + ruleChainConnection.type;
	                                ruleChainEdge.labels.push(ruleChainConnection.type);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        if (vm.canvasControl.adjustCanvasSize) {
	            vm.canvasControl.adjustCanvasSize(true);
	        }
	
	        vm.isDirty = false;
	
	        updateRuleNodesHighlight();
	
	        validate();
	
	        $mdUtil.nextTick(function () {
	            vm.ruleChainWatch = $scope.$watch('vm.ruleChainModel', function (newVal, oldVal) {
	                if (!angular.equals(newVal, oldVal)) {
	                    validate();
	                    if (!vm.isDirty) {
	                        vm.isDirty = true;
	                    }
	                }
	            }, true);
	        });
	    }
	
	    function updateRuleNodesHighlight() {
	        for (var i = 0; i < vm.ruleChainModel.nodes.length; i++) {
	            vm.ruleChainModel.nodes[i].highlighted = false;
	        }
	        if ($scope.searchConfig.searchText) {
	            var res = $filter('filter')(vm.ruleChainModel.nodes, { name: $scope.searchConfig.searchText });
	            if (res) {
	                for (i = 0; i < res.length; i++) {
	                    res[i].highlighted = true;
	                }
	            }
	        }
	    }
	
	    function validate() {
	        $mdUtil.nextTick(function () {
	            vm.isInvalid = false;
	            for (var i = 0; i < vm.ruleChainModel.nodes.length; i++) {
	                if (vm.ruleChainModel.nodes[i].error) {
	                    vm.isInvalid = true;
	                }
	                updateNodeErrorTooltip(vm.ruleChainModel.nodes[i]);
	            }
	        });
	    }
	
	    function saveRuleChain() {
	        var saveRuleChainPromise;
	        if (vm.isImport) {
	            saveRuleChainPromise = ruleChainService.saveRuleChain(vm.ruleChain);
	        } else {
	            saveRuleChainPromise = $q.when(vm.ruleChain);
	        }
	        saveRuleChainPromise.then(function (ruleChain) {
	            vm.ruleChain = ruleChain;
	            var ruleChainMetaData = {
	                ruleChainId: vm.ruleChain.id,
	                nodes: [],
	                connections: [],
	                ruleChainConnections: []
	            };
	
	            var nodes = [];
	
	            for (var i = 0; i < vm.ruleChainModel.nodes.length; i++) {
	                var node = vm.ruleChainModel.nodes[i];
	                if (node.component.type != types.ruleNodeType.INPUT.value && node.component.type != types.ruleNodeType.RULE_CHAIN.value) {
	                    var ruleNode = {};
	                    if (node.ruleNodeId) {
	                        ruleNode.id = node.ruleNodeId;
	                    }
	                    ruleNode.type = node.component.clazz;
	                    ruleNode.name = node.name;
	                    ruleNode.configuration = node.configuration;
	                    ruleNode.additionalInfo = node.additionalInfo;
	                    ruleNode.debugMode = node.debugMode;
	                    if (!ruleNode.additionalInfo) {
	                        ruleNode.additionalInfo = {};
	                    }
	                    ruleNode.additionalInfo.layoutX = Math.round(node.x);
	                    ruleNode.additionalInfo.layoutY = Math.round(node.y);
	                    ruleChainMetaData.nodes.push(ruleNode);
	                    nodes.push(node);
	                }
	            }
	            var res = $filter('filter')(vm.ruleChainModel.edges, { source: vm.inputConnectorId }, true);
	            if (res && res.length) {
	                var firstNodeEdge = res[0];
	                var firstNode = vm.modelservice.nodes.getNodeByConnectorId(firstNodeEdge.destination);
	                ruleChainMetaData.firstNodeIndex = nodes.indexOf(firstNode);
	            }
	            for (i = 0; i < vm.ruleChainModel.edges.length; i++) {
	                var edge = vm.ruleChainModel.edges[i];
	                var sourceNode = vm.modelservice.nodes.getNodeByConnectorId(edge.source);
	                var destNode = vm.modelservice.nodes.getNodeByConnectorId(edge.destination);
	                if (sourceNode.component.type != types.ruleNodeType.INPUT.value) {
	                    var fromIndex = nodes.indexOf(sourceNode);
	                    if (destNode.component.type == types.ruleNodeType.RULE_CHAIN.value) {
	                        var ruleChainConnection = {
	                            fromIndex: fromIndex,
	                            targetRuleChainId: { entityType: vm.types.entityType.rulechain, id: destNode.targetRuleChainId },
	                            additionalInfo: destNode.additionalInfo
	                        };
	                        if (!ruleChainConnection.additionalInfo) {
	                            ruleChainConnection.additionalInfo = {};
	                        }
	                        ruleChainConnection.additionalInfo.layoutX = Math.round(destNode.x);
	                        ruleChainConnection.additionalInfo.layoutY = Math.round(destNode.y);
	                        ruleChainConnection.additionalInfo.ruleChainNodeId = destNode.id;
	                        for (var rcIndex = 0; rcIndex < edge.labels.length; rcIndex++) {
	                            var newRuleChainConnection = angular.copy(ruleChainConnection);
	                            newRuleChainConnection.type = edge.labels[rcIndex];
	                            ruleChainMetaData.ruleChainConnections.push(newRuleChainConnection);
	                        }
	                    } else {
	                        var toIndex = nodes.indexOf(destNode);
	                        var nodeConnection = {
	                            fromIndex: fromIndex,
	                            toIndex: toIndex
	                        };
	                        for (var cIndex = 0; cIndex < edge.labels.length; cIndex++) {
	                            var newNodeConnection = angular.copy(nodeConnection);
	                            newNodeConnection.type = edge.labels[cIndex];
	                            ruleChainMetaData.connections.push(newNodeConnection);
	                        }
	                    }
	                }
	            }
	            ruleChainService.saveRuleChainMetaData(ruleChainMetaData).then(function (ruleChainMetaData) {
	                vm.ruleChainMetaData = ruleChainMetaData;
	                if (vm.isImport) {
	                    vm.isDirty = false;
	                    vm.isImport = false;
	                    $mdUtil.nextTick(function () {
	                        $state.go('home.ruleChains.ruleChain', { ruleChainId: vm.ruleChain.id.id });
	                    });
	                } else {
	                    prepareRuleChain();
	                }
	            });
	        });
	    }
	
	    function revertRuleChain() {
	        prepareRuleChain();
	    }
	
	    function addRuleNode($event, ruleNode) {
	
	        ruleNode.configuration = angular.copy(ruleNode.component.configurationDescriptor.nodeDefinition.defaultConfiguration);
	
	        var ruleChainId = vm.ruleChain.id ? vm.ruleChain.id.id : null;
	
	        vm.enableHotKeys = false;
	
	        $mdDialog.show({
	            controller: 'AddRuleNodeController',
	            controllerAs: 'vm',
	            templateUrl: _addRulenodeTpl2.default,
	            parent: angular.element($document[0].body),
	            locals: { ruleNode: ruleNode, ruleChainId: ruleChainId },
	            fullscreen: true,
	            targetEvent: $event
	        }).then(function (ruleNode) {
	            ruleNode.id = 'rule-chain-node-' + vm.nextNodeID++;
	            ruleNode.connectors = [];
	            if (ruleNode.component.configurationDescriptor.nodeDefinition.inEnabled) {
	                ruleNode.connectors.push({
	                    id: vm.nextConnectorID++,
	                    type: flowchartConstants.leftConnectorType
	                });
	            }
	            if (ruleNode.component.configurationDescriptor.nodeDefinition.outEnabled) {
	                ruleNode.connectors.push({
	                    id: vm.nextConnectorID++,
	                    type: flowchartConstants.rightConnectorType
	                });
	            }
	            vm.ruleChainModel.nodes.push(ruleNode);
	            updateRuleNodesHighlight();
	            vm.enableHotKeys = true;
	        }, function () {
	            vm.enableHotKeys = true;
	        });
	    }
	
	    function addRuleNodeLink($event, link, labels, allowCustomLabels) {
	        return $mdDialog.show({
	            controller: 'AddRuleNodeLinkController',
	            controllerAs: 'vm',
	            templateUrl: _addLinkTpl2.default,
	            parent: angular.element($document[0].body),
	            locals: { link: link, labels: labels, allowCustomLabels: allowCustomLabels },
	            fullscreen: true,
	            targetEvent: $event
	        });
	    }
	
	    function objectsSelected() {
	        return vm.modelservice.nodes.getSelectedNodes().length > 0 || vm.modelservice.edges.getSelectedEdges().length > 0;
	    }
	
	    function deleteSelected() {
	        vm.modelservice.deleteSelected();
	    }
	
	    function triggerResize() {
	        var w = angular.element($window);
	        w.triggerHandler('resize');
	    }
	}
	
	/*@ngInject*/
	function AddRuleNodeController($scope, $mdDialog, ruleNode, ruleChainId, helpLinks) {
	
	    var vm = this;
	
	    vm.helpLinks = helpLinks;
	    vm.ruleNode = ruleNode;
	    vm.ruleChainId = ruleChainId;
	
	    vm.add = add;
	    vm.cancel = cancel;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function add() {
	        $scope.theForm.$setPristine();
	        $mdDialog.hide(vm.ruleNode);
	    }
	}
	
	/*@ngInject*/
	function AddRuleNodeLinkController($scope, $mdDialog, link, labels, allowCustomLabels, helpLinks) {
	
	    var vm = this;
	
	    vm.helpLinks = helpLinks;
	    vm.link = link;
	    vm.labels = labels;
	    vm.allowCustomLabels = allowCustomLabels;
	
	    vm.add = add;
	    vm.cancel = cancel;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function add() {
	        $scope.theForm.$setPristine();
	        $mdDialog.hide(vm.link);
	    }
	}

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RuleChainDirective.$inject = ["$compile", "$templateCache", "$mdDialog", "$document", "$q", "$translate", "types", "toast"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RuleChainDirective;
	
	var _rulechainFieldsetTpl = __webpack_require__(1511);
	
	var _rulechainFieldsetTpl2 = _interopRequireDefault(_rulechainFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function RuleChainDirective($compile, $templateCache, $mdDialog, $document, $q, $translate, types, toast) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_rulechainFieldsetTpl2.default);
	        element.html(template);
	
	        scope.onRuleChainIdCopied = function () {
	            toast.showSuccess($translate.instant('rulechain.idCopiedMessage'), 750, angular.element(element).parent().parent(), 'bottom left');
	        };
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            ruleChain: '=',
	            isEdit: '=',
	            isReadOnly: '=',
	            theForm: '=',
	            onSetRootRuleChain: '&',
	            onExportRuleChain: '&',
	            onDeleteRuleChain: '&'
	        }
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RuleChainRoutes.$inject = ["$stateProvider", "NodeTemplatePathProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RuleChainRoutes;
	
	var _rulenodeTpl = __webpack_require__(1516);
	
	var _rulenodeTpl2 = _interopRequireDefault(_rulenodeTpl);
	
	var _rulechainsTpl = __webpack_require__(1513);
	
	var _rulechainsTpl2 = _interopRequireDefault(_rulechainsTpl);
	
	var _rulechainTpl = __webpack_require__(1512);
	
	var _rulechainTpl2 = _interopRequireDefault(_rulechainTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function RuleChainRoutes($stateProvider, NodeTemplatePathProvider) {
	
	    NodeTemplatePathProvider.setTemplatePath(_rulenodeTpl2.default);
	
	    $stateProvider.state('home.ruleChains', {
	        url: '/ruleChains',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _rulechainsTpl2.default,
	                controllerAs: 'vm',
	                controller: 'RuleChainsController'
	            }
	        },
	        data: {
	            searchEnabled: true,
	            pageTitle: 'rulechain.rulechains'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "settings_ethernet", "label": "rulechain.rulechains"}'
	        }
	    }).state('home.ruleChains.ruleChain', {
	        url: '/:ruleChainId',
	        reloadOnSearch: false,
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _rulechainTpl2.default,
	                controller: 'RuleChainController',
	                controllerAs: 'vm'
	            }
	        },
	        resolve: {
	            ruleChain:
	            /*@ngInject*/
	            ["$stateParams", "ruleChainService", function ruleChain($stateParams, ruleChainService) {
	                return ruleChainService.getRuleChain($stateParams.ruleChainId);
	            }],
	            ruleChainMetaData:
	            /*@ngInject*/
	            ["$stateParams", "ruleChainService", function ruleChainMetaData($stateParams, ruleChainService) {
	                return ruleChainService.getRuleChainMetaData($stateParams.ruleChainId);
	            }],
	            ruleNodeComponents:
	            /*@ngInject*/
	            ["$stateParams", "ruleChainService", function ruleNodeComponents($stateParams, ruleChainService) {
	                return ruleChainService.getRuleNodeComponents();
	            }]
	        },
	        data: {
	            import: false,
	            searchEnabled: true,
	            pageTitle: 'rulechain.rulechain'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "settings_ethernet", "label": "{{ vm.ruleChain.name + (vm.ruleChain.root ? (\' (\' + (\'rulechain.root\' | translate) + \')\') : \'\') }}", "translate": "false"}'
	        }
	    }).state('home.ruleChains.importRuleChain', {
	        url: '/ruleChain/import',
	        reloadOnSearch: false,
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _rulechainTpl2.default,
	                controller: 'RuleChainController',
	                controllerAs: 'vm'
	            }
	        },
	        params: {
	            ruleChainImport: {}
	        },
	        resolve: {
	            ruleChain:
	            /*@ngInject*/
	            ["$stateParams", function ruleChain($stateParams) {
	                return $stateParams.ruleChainImport.ruleChain;
	            }],
	            ruleChainMetaData:
	            /*@ngInject*/
	            ["$stateParams", function ruleChainMetaData($stateParams) {
	                return $stateParams.ruleChainImport.metadata;
	            }],
	            ruleNodeComponents:
	            /*@ngInject*/
	            ["$stateParams", "ruleChainService", function ruleNodeComponents($stateParams, ruleChainService) {
	                return ruleChainService.getRuleNodeComponents();
	            }]
	        },
	        data: {
	            import: true,
	            searchEnabled: true,
	            pageTitle: 'rulechain.rulechain'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "settings_ethernet", "label": "{{ (\'rulechain.import\' | translate) + \': \'+ vm.ruleChain.name }}", "translate": "false"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RuleChainsController.$inject = ["ruleChainService", "userService", "importExport", "$state", "$stateParams", "$filter", "$translate", "$mdDialog", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RuleChainsController;
	
	var _addRulechainTpl = __webpack_require__(1506);
	
	var _addRulechainTpl2 = _interopRequireDefault(_addRulechainTpl);
	
	var _rulechainCardTpl = __webpack_require__(1510);
	
	var _rulechainCardTpl2 = _interopRequireDefault(_rulechainCardTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function RuleChainsController(ruleChainService, userService, importExport, $state, $stateParams, $filter, $translate, $mdDialog, types) {
	
	    var ruleChainActionsList = [{
	        onAction: function onAction($event, item) {
	            vm.grid.openItem($event, item);
	        },
	        name: function name() {
	            return $translate.instant('rulechain.details');
	        },
	        details: function details() {
	            return $translate.instant('rulechain.rulechain-details');
	        },
	        icon: "edit"
	    }, {
	        onAction: function onAction($event, item) {
	            exportRuleChain($event, item);
	        },
	        name: function name() {
	            $translate.instant('action.export');
	        },
	        details: function details() {
	            return $translate.instant('rulechain.export');
	        },
	        icon: "file_download"
	    }, {
	        onAction: function onAction($event, item) {
	            setRootRuleChain($event, item);
	        },
	        name: function name() {
	            return $translate.instant('rulechain.set-root');
	        },
	        details: function details() {
	            return $translate.instant('rulechain.set-root');
	        },
	        icon: "flag",
	        isEnabled: isNonRootRuleChain
	    }, {
	        onAction: function onAction($event, item) {
	            vm.grid.deleteItem($event, item);
	        },
	        name: function name() {
	            return $translate.instant('action.delete');
	        },
	        details: function details() {
	            return $translate.instant('rulechain.delete');
	        },
	        icon: "delete",
	        isEnabled: isNonRootRuleChain
	    }];
	
	    var ruleChainAddItemActionsList = [{
	        onAction: function onAction($event) {
	            vm.grid.addItem($event);
	        },
	        name: function name() {
	            return $translate.instant('action.create');
	        },
	        details: function details() {
	            return $translate.instant('rulechain.create-new-rulechain');
	        },
	        icon: "insert_drive_file"
	    }, {
	        onAction: function onAction($event) {
	            importExport.importRuleChain($event).then(function (ruleChainImport) {
	                $state.go('home.ruleChains.importRuleChain', { ruleChainImport: ruleChainImport });
	            });
	        },
	        name: function name() {
	            return $translate.instant('action.import');
	        },
	        details: function details() {
	            return $translate.instant('rulechain.import');
	        },
	        icon: "file_upload"
	    }];
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.ruleChainGridConfig = {
	
	        refreshParamsFunc: null,
	
	        deleteItemTitleFunc: deleteRuleChainTitle,
	        deleteItemContentFunc: deleteRuleChainText,
	        deleteItemsTitleFunc: deleteRuleChainsTitle,
	        deleteItemsActionTitleFunc: deleteRuleChainsActionTitle,
	        deleteItemsContentFunc: deleteRuleChainsText,
	
	        fetchItemsFunc: fetchRuleChains,
	        saveItemFunc: saveRuleChain,
	        clickItemFunc: openRuleChain,
	        deleteItemFunc: deleteRuleChain,
	
	        getItemTitleFunc: getRuleChainTitle,
	        itemCardTemplateUrl: _rulechainCardTpl2.default,
	        parentCtl: vm,
	
	        actionsList: ruleChainActionsList,
	        addItemActions: ruleChainAddItemActionsList,
	
	        onGridInited: gridInited,
	
	        addItemTemplateUrl: _addRulechainTpl2.default,
	
	        addItemText: function addItemText() {
	            return $translate.instant('rulechain.add-rulechain-text');
	        },
	        noItemsText: function noItemsText() {
	            return $translate.instant('rulechain.no-rulechains-text');
	        },
	        itemDetailsText: function itemDetailsText() {
	            return $translate.instant('rulechain.rulechain-details');
	        },
	        isSelectionEnabled: isNonRootRuleChain
	    };
	
	    if (angular.isDefined($stateParams.items) && $stateParams.items !== null) {
	        vm.ruleChainGridConfig.items = $stateParams.items;
	    }
	
	    if (angular.isDefined($stateParams.topIndex) && $stateParams.topIndex > 0) {
	        vm.ruleChainGridConfig.topIndex = $stateParams.topIndex;
	    }
	
	    vm.isRootRuleChain = isRootRuleChain;
	    vm.isNonRootRuleChain = isNonRootRuleChain;
	
	    vm.exportRuleChain = exportRuleChain;
	    vm.setRootRuleChain = setRootRuleChain;
	
	    function deleteRuleChainTitle(ruleChain) {
	        return $translate.instant('rulechain.delete-rulechain-title', { ruleChainName: ruleChain.name });
	    }
	
	    function deleteRuleChainText() {
	        return $translate.instant('rulechain.delete-rulechain-text');
	    }
	
	    function deleteRuleChainsTitle(selectedCount) {
	        return $translate.instant('rulechain.delete-rulechains-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteRuleChainsActionTitle(selectedCount) {
	        return $translate.instant('rulechain.delete-rulechains-action-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteRuleChainsText() {
	        return $translate.instant('rulechain.delete-rulechains-text');
	    }
	
	    function gridInited(grid) {
	        vm.grid = grid;
	    }
	
	    function fetchRuleChains(pageLink) {
	        return ruleChainService.getRuleChains(pageLink);
	    }
	
	    function saveRuleChain(ruleChain) {
	        return ruleChainService.saveRuleChain(ruleChain);
	    }
	
	    function openRuleChain($event, ruleChain) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        $state.go('home.ruleChains.ruleChain', { ruleChainId: ruleChain.id.id });
	    }
	
	    function deleteRuleChain(ruleChainId) {
	        return ruleChainService.deleteRuleChain(ruleChainId);
	    }
	
	    function getRuleChainTitle(ruleChain) {
	        return ruleChain ? ruleChain.name : '';
	    }
	
	    function isRootRuleChain(ruleChain) {
	        return ruleChain && ruleChain.root;
	    }
	
	    function isNonRootRuleChain(ruleChain) {
	        return ruleChain && !ruleChain.root;
	    }
	
	    function exportRuleChain($event, ruleChain) {
	        $event.stopPropagation();
	        importExport.exportRuleChain(ruleChain.id.id);
	    }
	
	    function setRootRuleChain($event, ruleChain) {
	        $event.stopPropagation();
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('rulechain.set-root-rulechain-title', { ruleChainName: ruleChain.name })).htmlContent($translate.instant('rulechain.set-root-rulechain-text')).ariaLabel($translate.instant('rulechain.set-root')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            ruleChainService.setRootRuleChain(ruleChain.id.id).then(function () {
	                vm.grid.refreshList();
	            });
	        });
	    }
	}

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RuleNodeConfigDirective.$inject = ["$compile", "$templateCache", "$injector", "$translate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RuleNodeConfigDirective;
	
	var _rulenodeConfigTpl = __webpack_require__(1514);
	
	var _rulenodeConfigTpl2 = _interopRequireDefault(_rulenodeConfigTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function RuleNodeConfigDirective($compile, $templateCache, $injector, $translate) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	        var template = $templateCache.get(_rulenodeConfigTpl2.default);
	        element.html(template);
	
	        scope.$watch('configuration', function (newVal, prevVal) {
	            if (!angular.equals(newVal, prevVal)) {
	                ngModelCtrl.$setViewValue(scope.configuration);
	            }
	        });
	
	        ngModelCtrl.$render = function () {
	            scope.configuration = ngModelCtrl.$viewValue;
	        };
	
	        scope.useDefinedDirective = function () {
	            return scope.nodeDefinition && scope.nodeDefinition.configDirective && !scope.definedDirectiveError;
	        };
	
	        scope.$watch('nodeDefinition', function () {
	            if (scope.nodeDefinition) {
	                validateDefinedDirective();
	            }
	        });
	
	        function validateDefinedDirective() {
	            if (scope.nodeDefinition.uiResourceLoadError && scope.nodeDefinition.uiResourceLoadError.length) {
	                scope.definedDirectiveError = scope.nodeDefinition.uiResourceLoadError;
	            } else {
	                var definedDirective = scope.nodeDefinition.configDirective;
	                if (definedDirective && definedDirective.length) {
	                    if (!$injector.has(definedDirective + 'Directive')) {
	                        scope.definedDirectiveError = $translate.instant('rulenode.directive-is-not-loaded', { directiveName: definedDirective });
	                    }
	                }
	            }
	        }
	
	        $compile(element.contents())(scope);
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            ruleNodeId: '=',
	            nodeDefinition: '=',
	            required: '=ngRequired',
	            readonly: '=ngReadonly'
	        },
	        link: linker
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	'use strict';
	
	RuleNodeDefinedConfigDirective.$inject = ["$compile"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RuleNodeDefinedConfigDirective;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	/*@ngInject*/
	function RuleNodeDefinedConfigDirective($compile) {
	
	    var linker = function linker(scope, element, attrs, ngModelCtrl) {
	
	        attrs.$observe('ruleNodeDirective', function () {
	            loadTemplate();
	        });
	
	        scope.$watch('configuration', function (newVal, prevVal) {
	            if (!angular.equals(newVal, prevVal)) {
	                ngModelCtrl.$setViewValue(scope.configuration);
	            }
	        });
	
	        ngModelCtrl.$render = function () {
	            scope.configuration = ngModelCtrl.$viewValue;
	        };
	
	        function loadTemplate() {
	            if (scope.ruleNodeConfigScope) {
	                scope.ruleNodeConfigScope.$destroy();
	            }
	            var directive = snake_case(attrs.ruleNodeDirective, '-');
	            var template = '<' + directive + ' rule-node-id="ruleNodeId" ng-model="configuration" ng-required="required" ng-readonly="readonly"></' + directive + '>';
	            element.html(template);
	            scope.ruleNodeConfigScope = scope.$new();
	            $compile(element.contents())(scope.ruleNodeConfigScope);
	        }
	
	        function snake_case(name, separator) {
	            separator = separator || '_';
	            return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
	                return (pos ? separator : '') + letter.toLowerCase();
	            });
	        }
	    };
	
	    return {
	        restrict: "E",
	        require: "^ngModel",
	        scope: {
	            ruleNodeId: '=',
	            required: '=ngRequired',
	            readonly: '=ngReadonly'
	        },
	        link: linker
	    };
	}

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RuleNodeDirective.$inject = ["$compile", "$templateCache", "ruleChainService", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RuleNodeDirective;
	
	__webpack_require__(817);
	
	var _rulenodeFieldsetTpl = __webpack_require__(1515);
	
	var _rulenodeFieldsetTpl2 = _interopRequireDefault(_rulenodeFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function RuleNodeDirective($compile, $templateCache, ruleChainService, types) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_rulenodeFieldsetTpl2.default);
	        element.html(template);
	
	        scope.types = types;
	
	        scope.params = {
	            targetRuleChainId: null
	        };
	
	        scope.$watch('ruleNode', function () {
	            if (scope.ruleNode && scope.ruleNode.component.type == types.ruleNodeType.RULE_CHAIN.value) {
	                scope.params.targetRuleChainId = scope.ruleNode.targetRuleChainId;
	                watchTargetRuleChain();
	            } else {
	                if (scope.targetRuleChainWatch) {
	                    scope.targetRuleChainWatch();
	                    scope.targetRuleChainWatch = null;
	                }
	            }
	        });
	
	        function watchTargetRuleChain() {
	            scope.targetRuleChainWatch = scope.$watch('params.targetRuleChainId', function (targetRuleChainId) {
	                if (scope.ruleNode.targetRuleChainId != targetRuleChainId) {
	                    scope.ruleNode.targetRuleChainId = targetRuleChainId;
	                    if (targetRuleChainId) {
	                        ruleChainService.getRuleChain(targetRuleChainId).then(function (ruleChain) {
	                            scope.ruleNode.name = ruleChain.name;
	                        });
	                    } else {
	                        scope.ruleNode.name = "";
	                    }
	                }
	            });
	        }
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            ruleChainId: '=',
	            ruleNode: '=',
	            isEdit: '=',
	            isReadOnly: '=',
	            theForm: '=',
	            onDeleteRuleNode: '&'
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	NodeScriptTestController.$inject = ["$scope", "$mdDialog", "$window", "$document", "$timeout", "$q", "$mdUtil", "$translate", "toast", "types", "utils", "ruleChainService", "onShowingCallback", "msg", "msgType", "metadata", "functionTitle", "inputParams"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = NodeScriptTestController;
	
	__webpack_require__(818);
	
	var _split = __webpack_require__(574);
	
	var _split2 = _interopRequireDefault(_split);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var js_beautify = _jsBeautify2.default.js;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function NodeScriptTestController($scope, $mdDialog, $window, $document, $timeout, $q, $mdUtil, $translate, toast, types, utils, ruleChainService, onShowingCallback, msg, msgType, metadata, functionTitle, inputParams) {
	
	    var vm = this;
	
	    vm.types = types;
	    vm.functionTitle = functionTitle;
	    vm.inputParams = inputParams;
	    vm.inputParams.msg = js_beautify(angular.toJson(msg), { indent_size: 4 });
	    vm.inputParams.metadata = metadata;
	    vm.inputParams.msgType = msgType;
	
	    vm.output = '';
	
	    vm.test = test;
	    vm.save = save;
	    vm.cancel = cancel;
	
	    $scope.$watch('theForm.metadataForm.$dirty', function (newVal) {
	        if (newVal) {
	            toast.hide();
	        }
	    });
	
	    onShowingCallback.onShowed = function () {
	        vm.nodeScriptTestDialogElement = angular.element('.tb-node-script-test-dialog');
	        var w = vm.nodeScriptTestDialogElement.width();
	        if (w > 0) {
	            initSplitLayout();
	        } else {
	            $scope.$watch(function () {
	                return vm.nodeScriptTestDialogElement[0].offsetWidth || parseInt(vm.nodeScriptTestDialogElement.css('width'), 10);
	            }, function (newSize) {
	                if (newSize > 0) {
	                    initSplitLayout();
	                }
	            });
	        }
	    };
	
	    function onDividerDrag() {
	        $scope.$broadcast('update-ace-editor-size');
	    }
	
	    function initSplitLayout() {
	        if (!vm.layoutInited) {
	            (0, _split2.default)([angular.element('#top_panel', vm.nodeScriptTestDialogElement)[0], angular.element('#bottom_panel', vm.nodeScriptTestDialogElement)[0]], {
	                sizes: [35, 65],
	                gutterSize: 8,
	                cursor: 'row-resize',
	                direction: 'vertical',
	                onDrag: function onDrag() {
	                    onDividerDrag();
	                }
	            });
	
	            (0, _split2.default)([angular.element('#top_left_panel', vm.nodeScriptTestDialogElement)[0], angular.element('#top_right_panel', vm.nodeScriptTestDialogElement)[0]], {
	                sizes: [50, 50],
	                gutterSize: 8,
	                cursor: 'col-resize',
	                onDrag: function onDrag() {
	                    onDividerDrag();
	                }
	            });
	
	            (0, _split2.default)([angular.element('#bottom_left_panel', vm.nodeScriptTestDialogElement)[0], angular.element('#bottom_right_panel', vm.nodeScriptTestDialogElement)[0]], {
	                sizes: [50, 50],
	                gutterSize: 8,
	                cursor: 'col-resize',
	                onDrag: function onDrag() {
	                    onDividerDrag();
	                }
	            });
	
	            onDividerDrag();
	
	            $scope.$applyAsync(function () {
	                vm.layoutInited = true;
	                var w = angular.element($window);
	                $timeout(function () {
	                    w.triggerHandler('resize');
	                });
	            });
	        }
	    }
	
	    function test() {
	        testNodeScript().then(function (output) {
	            vm.output = js_beautify(output, { indent_size: 4 });
	        });
	    }
	
	    function checkInputParamErrors() {
	        $scope.theForm.metadataForm.$setPristine();
	        $scope.$broadcast('form-submit', 'validatePayload');
	        if (!$scope.theForm.payloadForm.$valid) {
	            return false;
	        } else if (!$scope.theForm.metadataForm.$valid) {
	            showMetadataError($translate.instant('rulenode.metadata-required'));
	            return false;
	        }
	        return true;
	    }
	
	    function showMetadataError(error) {
	        var toastParent = angular.element('#metadata-panel', vm.nodeScriptTestDialogElement);
	        toast.showError(error, toastParent, 'bottom left');
	    }
	
	    function testNodeScript() {
	        var deferred = $q.defer();
	        if (checkInputParamErrors()) {
	            $mdUtil.nextTick(function () {
	                ruleChainService.testScript(vm.inputParams).then(function (result) {
	                    if (result.error) {
	                        toast.showError(result.error);
	                        deferred.reject();
	                    } else {
	                        deferred.resolve(result.output);
	                    }
	                }, function () {
	                    deferred.reject();
	                });
	            });
	        } else {
	            deferred.reject();
	        }
	        return deferred.promise;
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function save() {
	        testNodeScript().then(function () {
	            $scope.theForm.funcBodyForm.$setPristine();
	            $mdDialog.hide(vm.inputParams.script);
	        });
	    }
	}

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	NodeScriptTest.$inject = ["$q", "$mdDialog", "$document", "ruleChainService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = NodeScriptTest;
	
	var _nodeScriptTestTpl = __webpack_require__(1517);
	
	var _nodeScriptTestTpl2 = _interopRequireDefault(_nodeScriptTestTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function NodeScriptTest($q, $mdDialog, $document, ruleChainService) {
	
	    var service = {
	        testNodeScript: testNodeScript
	    };
	
	    return service;
	
	    function testNodeScript($event, script, scriptType, functionTitle, functionName, argNames, ruleNodeId) {
	        var deferred = $q.defer();
	        if ($event) {
	            $event.stopPropagation();
	        }
	
	        var msg, metadata, msgType;
	        if (ruleNodeId) {
	            ruleChainService.getLatestRuleNodeDebugInput(ruleNodeId).then(function (debugIn) {
	                if (debugIn) {
	                    if (debugIn.data) {
	                        msg = angular.fromJson(debugIn.data);
	                    }
	                    if (debugIn.metadata) {
	                        metadata = angular.fromJson(debugIn.metadata);
	                    }
	                    msgType = debugIn.msgType;
	                }
	                openTestScriptDialog($event, script, scriptType, functionTitle, functionName, argNames, msg, metadata, msgType).then(function (script) {
	                    deferred.resolve(script);
	                }, function () {
	                    deferred.reject();
	                });
	            }, function () {
	                deferred.reject();
	            });
	        } else {
	            openTestScriptDialog($event, script, scriptType, functionTitle, functionName, argNames).then(function (script) {
	                deferred.resolve(script);
	            }, function () {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    }
	
	    function openTestScriptDialog($event, script, scriptType, functionTitle, functionName, argNames, msg, metadata, msgType) {
	        var deferred = $q.defer();
	        if (!msg) {
	            msg = {
	                temperature: 22.4,
	                humidity: 78
	            };
	        }
	        if (!metadata) {
	            metadata = {
	                deviceType: "default",
	                deviceName: "Test Device",
	                ts: new Date().getTime() + ""
	            };
	        }
	        if (!msgType) {
	            msgType = "POST_TELEMETRY_REQUEST";
	        }
	
	        var onShowingCallback = {
	            onShowed: function onShowed() {}
	        };
	
	        var inputParams = {
	            script: script,
	            scriptType: scriptType,
	            functionName: functionName,
	            argNames: argNames
	        };
	
	        $mdDialog.show({
	            controller: 'NodeScriptTestController',
	            controllerAs: 'vm',
	            templateUrl: _nodeScriptTestTpl2.default,
	            parent: angular.element($document[0].body),
	            locals: {
	                msg: msg,
	                metadata: metadata,
	                msgType: msgType,
	                functionTitle: functionTitle,
	                inputParams: inputParams,
	                onShowingCallback: onShowingCallback
	            },
	            fullscreen: true,
	            skipHide: true,
	            targetEvent: $event,
	            onComplete: function onComplete() {
	                onShowingCallback.onShowed();
	            }
	        }).then(function (script) {
	            deferred.resolve(script);
	        }, function () {
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

	'use strict';
	
	ClipboardService.$inject = ["$q"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.clipboard', []).factory('clipboardService', ClipboardService).name;
	
	/*@ngInject*/
	
	function ClipboardService($q) {
	
	    var fakeHandler, fakeHandlerCallback, fakeElem;
	
	    var service = {
	        copyToClipboard: copyToClipboard
	    };
	
	    return service;
	
	    /* eslint-disable */
	    function copyToClipboard(trigger, text) {
	        var deferred = $q.defer();
	        var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
	        removeFake();
	        fakeHandlerCallback = function fakeHandlerCallback() {
	            return removeFake();
	        };
	        fakeHandler = document.body.addEventListener('click', fakeHandlerCallback) || true;
	        fakeElem = document.createElement('textarea');
	        fakeElem.style.fontSize = '12pt';
	        fakeElem.style.border = '0';
	        fakeElem.style.padding = '0';
	        fakeElem.style.margin = '0';
	        fakeElem.style.position = 'absolute';
	        fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	        var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	        fakeElem.style.top = yPosition + 'px';
	        fakeElem.setAttribute('readonly', '');
	        fakeElem.value = text;
	        document.body.appendChild(fakeElem);
	        var selectedText = select(fakeElem);
	
	        var succeeded = void 0;
	        try {
	            succeeded = document.execCommand('copy');
	        } catch (err) {
	            succeeded = false;
	        }
	        if (trigger) {
	            trigger.focus();
	        }
	        window.getSelection().removeAllRanges();
	        removeFake();
	        if (succeeded) {
	            deferred.resolve(selectedText);
	        } else {
	            deferred.reject();
	        }
	        return deferred.promise;
	    }
	
	    function removeFake() {
	        if (fakeHandler) {
	            document.body.removeEventListener('click', fakeHandlerCallback);
	            fakeHandler = null;
	            fakeHandlerCallback = null;
	        }
	        if (fakeElem) {
	            document.body.removeChild(fakeElem);
	            fakeElem = null;
	        }
	    }
	
	    function select(element) {
	        var selectedText;
	
	        if (element.nodeName === 'SELECT') {
	            element.focus();
	
	            selectedText = element.value;
	        } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	            var isReadOnly = element.hasAttribute('readonly');
	
	            if (!isReadOnly) {
	                element.setAttribute('readonly', '');
	            }
	
	            element.select();
	            element.setSelectionRange(0, element.value.length);
	
	            if (!isReadOnly) {
	                element.removeAttribute('readonly');
	            }
	
	            selectedText = element.value;
	        } else {
	            if (element.hasAttribute('contenteditable')) {
	                element.focus();
	            }
	
	            var selection = window.getSelection();
	            var range = document.createRange();
	
	            range.selectNodeContents(element);
	            selection.removeAllRanges();
	            selection.addRange(range);
	
	            selectedText = selection.toString();
	        }
	
	        return selectedText;
	    }
	
	    /* eslint-enable */
	}

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ItemBuffer.$inject = ["$q", "bufferStore", "types", "utils", "dashboardUtils", "ruleChainService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularStorage = __webpack_require__(266);
	
	var _angularStorage2 = _interopRequireDefault(_angularStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.itembuffer', [_angularStorage2.default]).factory('itembuffer', ItemBuffer).factory('bufferStore', ["store", function (store) {
	    var newStore = store.getNamespacedStore('tbBufferStore', null, null, false);
	    return newStore;
	}]).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function ItemBuffer($q, bufferStore, types, utils, dashboardUtils, ruleChainService) {
	
	    var WIDGET_ITEM = "widget_item";
	    var WIDGET_REFERENCE = "widget_reference";
	    var RULE_NODES = "rule_nodes";
	
	    var service = {
	        prepareWidgetItem: prepareWidgetItem,
	        copyWidget: copyWidget,
	        copyWidgetReference: copyWidgetReference,
	        hasWidget: hasWidget,
	        canPasteWidgetReference: canPasteWidgetReference,
	        pasteWidget: pasteWidget,
	        pasteWidgetReference: pasteWidgetReference,
	        addWidgetToDashboard: addWidgetToDashboard,
	        copyRuleNodes: copyRuleNodes,
	        hasRuleNodes: hasRuleNodes,
	        pasteRuleNodes: pasteRuleNodes
	    };
	
	    return service;
	
	    /**
	     aliasesInfo {
	        datasourceAliases: {
	            datasourceIndex: {
	                alias: "...",
	                filter: "..."
	            }
	        }
	        targetDeviceAliases: {
	            targetDeviceAliasIndex: {
	                alias: "...",
	                filter: "..."
	            }
	        }
	        ....
	     }
	    **/
	
	    function prepareAliasInfo(entityAlias) {
	        return {
	            alias: entityAlias.alias,
	            filter: entityAlias.filter
	        };
	    }
	
	    function getOriginalColumns(dashboard, sourceState, sourceLayout) {
	        var originalColumns = 24;
	        var gridSettings = null;
	        var state = dashboard.configuration.states[sourceState];
	        var layoutCount = Object.keys(state.layouts).length;
	        if (state) {
	            var layout = state.layouts[sourceLayout];
	            if (layout) {
	                gridSettings = layout.gridSettings;
	            }
	        }
	        if (gridSettings && gridSettings.columns) {
	            originalColumns = gridSettings.columns;
	        }
	        originalColumns = originalColumns * layoutCount;
	        return originalColumns;
	    }
	
	    function getOriginalSize(dashboard, sourceState, sourceLayout, widget) {
	        var layout = dashboard.configuration.states[sourceState].layouts[sourceLayout];
	        var widgetLayout = layout.widgets[widget.id];
	        return {
	            sizeX: widgetLayout.sizeX,
	            sizeY: widgetLayout.sizeY
	        };
	    }
	
	    function prepareWidgetItem(dashboard, sourceState, sourceLayout, widget) {
	        var aliasesInfo = {
	            datasourceAliases: {},
	            targetDeviceAliases: {}
	        };
	        var originalColumns = getOriginalColumns(dashboard, sourceState, sourceLayout);
	        var originalSize = getOriginalSize(dashboard, sourceState, sourceLayout, widget);
	        if (widget.config && dashboard.configuration && dashboard.configuration.entityAliases) {
	            var entityAlias;
	            if (widget.config.datasources) {
	                for (var i = 0; i < widget.config.datasources.length; i++) {
	                    var datasource = widget.config.datasources[i];
	                    if (datasource.type === types.datasourceType.entity && datasource.entityAliasId) {
	                        entityAlias = dashboard.configuration.entityAliases[datasource.entityAliasId];
	                        if (entityAlias) {
	                            aliasesInfo.datasourceAliases[i] = prepareAliasInfo(entityAlias);
	                        }
	                    }
	                }
	            }
	            if (widget.config.targetDeviceAliasIds) {
	                for (i = 0; i < widget.config.targetDeviceAliasIds.length; i++) {
	                    var targetDeviceAliasId = widget.config.targetDeviceAliasIds[i];
	                    if (targetDeviceAliasId) {
	                        entityAlias = dashboard.configuration.entityAliases[targetDeviceAliasId];
	                        if (entityAlias) {
	                            aliasesInfo.targetDeviceAliases[i] = prepareAliasInfo(entityAlias);
	                        }
	                    }
	                }
	            }
	        }
	        return {
	            widget: widget,
	            aliasesInfo: aliasesInfo,
	            originalSize: originalSize,
	            originalColumns: originalColumns
	        };
	    }
	
	    function prepareWidgetReference(dashboard, sourceState, sourceLayout, widget) {
	        var originalColumns = getOriginalColumns(dashboard, sourceState, sourceLayout);
	        var originalSize = getOriginalSize(dashboard, sourceState, sourceLayout, widget);
	
	        return {
	            dashboardId: dashboard.id.id,
	            sourceState: sourceState,
	            sourceLayout: sourceLayout,
	            widgetId: widget.id,
	            originalSize: originalSize,
	            originalColumns: originalColumns
	        };
	    }
	
	    function copyRuleNodes(nodes, connections) {
	        var ruleNodes = {
	            nodes: [],
	            connections: []
	        };
	        var top = -1,
	            left = -1,
	            bottom = -1,
	            right = -1;
	        for (var i = 0; i < nodes.length; i++) {
	            var origNode = nodes[i];
	            var node = {
	                additionalInfo: origNode.additionalInfo,
	                configuration: origNode.configuration,
	                debugMode: origNode.debugMode,
	                x: origNode.x,
	                y: origNode.y,
	                name: origNode.name,
	                componentClazz: origNode.component.clazz
	            };
	            if (origNode.targetRuleChainId) {
	                node.targetRuleChainId = origNode.targetRuleChainId;
	            }
	            if (origNode.error) {
	                node.error = origNode.error;
	            }
	            ruleNodes.nodes.push(node);
	            if (i == 0) {
	                top = node.y;
	                left = node.x;
	                bottom = node.y + 50;
	                right = node.x + 170;
	            } else {
	                top = Math.min(top, node.y);
	                left = Math.min(left, node.x);
	                bottom = Math.max(bottom, node.y + 50);
	                right = Math.max(right, node.x + 170);
	            }
	        }
	        ruleNodes.originX = left + (right - left) / 2;
	        ruleNodes.originY = top + (bottom - top) / 2;
	        for (i = 0; i < connections.length; i++) {
	            var connection = connections[i];
	            ruleNodes.connections.push(connection);
	        }
	        bufferStore.set(RULE_NODES, angular.toJson(ruleNodes));
	    }
	
	    function hasRuleNodes() {
	        return bufferStore.get(RULE_NODES);
	    }
	
	    function pasteRuleNodes(x, y) {
	        var ruleNodesJson = bufferStore.get(RULE_NODES);
	        if (ruleNodesJson) {
	            var ruleNodes = angular.fromJson(ruleNodesJson);
	            var deltaX = x - ruleNodes.originX;
	            var deltaY = y - ruleNodes.originY;
	            for (var i = 0; i < ruleNodes.nodes.length; i++) {
	                var node = ruleNodes.nodes[i];
	                var component = ruleChainService.getRuleNodeComponentByClazz(node.componentClazz);
	                if (component) {
	                    var icon = types.ruleNodeType[component.type].icon;
	                    var iconUrl = null;
	                    if (component.configurationDescriptor.nodeDefinition.icon) {
	                        icon = component.configurationDescriptor.nodeDefinition.icon;
	                    }
	                    if (component.configurationDescriptor.nodeDefinition.iconUrl) {
	                        iconUrl = component.configurationDescriptor.nodeDefinition.iconUrl;
	                    }
	                    delete node.componentClazz;
	                    node.component = component;
	                    node.nodeClass = types.ruleNodeType[component.type].nodeClass;
	                    node.icon = icon;
	                    node.iconUrl = iconUrl;
	                    node.connectors = [];
	                    node.x = Math.round(node.x + deltaX);
	                    node.y = Math.round(node.y + deltaY);
	                } else {
	                    return null;
	                }
	            }
	            return ruleNodes;
	        }
	        return null;
	    }
	
	    function copyWidget(dashboard, sourceState, sourceLayout, widget) {
	        var widgetItem = prepareWidgetItem(dashboard, sourceState, sourceLayout, widget);
	        bufferStore.set(WIDGET_ITEM, angular.toJson(widgetItem));
	    }
	
	    function copyWidgetReference(dashboard, sourceState, sourceLayout, widget) {
	        var widgetReference = prepareWidgetReference(dashboard, sourceState, sourceLayout, widget);
	        bufferStore.set(WIDGET_REFERENCE, angular.toJson(widgetReference));
	    }
	
	    function hasWidget() {
	        return bufferStore.get(WIDGET_ITEM);
	    }
	
	    function canPasteWidgetReference(dashboard, state, layout) {
	        var widgetReferenceJson = bufferStore.get(WIDGET_REFERENCE);
	        if (widgetReferenceJson) {
	            var widgetReference = angular.fromJson(widgetReferenceJson);
	            if (widgetReference.dashboardId === dashboard.id.id) {
	                if ((widgetReference.sourceState != state || widgetReference.sourceLayout != layout) && dashboard.configuration.widgets[widgetReference.widgetId]) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }
	
	    function pasteWidgetReference(targetDashboard, targetState, targetLayout, position) {
	        var deferred = $q.defer();
	        var widgetReferenceJson = bufferStore.get(WIDGET_REFERENCE);
	        if (widgetReferenceJson) {
	            var widgetReference = angular.fromJson(widgetReferenceJson);
	            var widget = targetDashboard.configuration.widgets[widgetReference.widgetId];
	            if (widget) {
	                var originalColumns = widgetReference.originalColumns;
	                var originalSize = widgetReference.originalSize;
	                var targetRow = -1;
	                var targetColumn = -1;
	                if (position) {
	                    targetRow = position.row;
	                    targetColumn = position.column;
	                }
	                addWidgetToDashboard(targetDashboard, targetState, targetLayout, widget, null, null, originalColumns, originalSize, targetRow, targetColumn).then(function () {
	                    deferred.resolve(widget);
	                });
	            } else {
	                deferred.reject();
	            }
	        } else {
	            deferred.reject();
	        }
	        return deferred.promise;
	    }
	
	    function pasteWidget(targetDashboard, targetState, targetLayout, position, onAliasesUpdateFunction) {
	        var deferred = $q.defer();
	        var widgetItemJson = bufferStore.get(WIDGET_ITEM);
	        if (widgetItemJson) {
	            var widgetItem = angular.fromJson(widgetItemJson);
	            var widget = widgetItem.widget;
	            var aliasesInfo = widgetItem.aliasesInfo;
	            var originalColumns = widgetItem.originalColumns;
	            var originalSize = widgetItem.originalSize;
	            var targetRow = -1;
	            var targetColumn = -1;
	            if (position) {
	                targetRow = position.row;
	                targetColumn = position.column;
	            }
	            widget.id = utils.guid();
	            addWidgetToDashboard(targetDashboard, targetState, targetLayout, widget, aliasesInfo, onAliasesUpdateFunction, originalColumns, originalSize, targetRow, targetColumn).then(function () {
	                deferred.resolve(widget);
	            });
	        } else {
	            deferred.reject();
	        }
	        return deferred.promise;
	    }
	
	    function addWidgetToDashboard(dashboard, targetState, targetLayout, widget, aliasesInfo, onAliasesUpdateFunction, originalColumns, originalSize, row, column) {
	        var deferred = $q.defer();
	        var theDashboard;
	        if (dashboard) {
	            theDashboard = dashboard;
	        } else {
	            theDashboard = {};
	        }
	
	        theDashboard = dashboardUtils.validateAndUpdateDashboard(theDashboard);
	
	        var callAliasUpdateFunction = false;
	        if (aliasesInfo) {
	            var newEntityAliases = updateAliases(theDashboard, widget, aliasesInfo);
	            var aliasesUpdated = !angular.equals(newEntityAliases, theDashboard.configuration.entityAliases);
	            if (aliasesUpdated) {
	                theDashboard.configuration.entityAliases = newEntityAliases;
	                if (onAliasesUpdateFunction) {
	                    callAliasUpdateFunction = true;
	                }
	            }
	        }
	        dashboardUtils.addWidgetToLayout(theDashboard, targetState, targetLayout, widget, originalColumns, originalSize, row, column);
	        if (callAliasUpdateFunction) {
	            onAliasesUpdateFunction();
	        }
	        deferred.resolve(theDashboard);
	        return deferred.promise;
	    }
	
	    function updateAliases(dashboard, widget, aliasesInfo) {
	        var entityAliases = angular.copy(dashboard.configuration.entityAliases);
	        var aliasInfo;
	        var newAliasId;
	        for (var datasourceIndex in aliasesInfo.datasourceAliases) {
	            aliasInfo = aliasesInfo.datasourceAliases[datasourceIndex];
	            newAliasId = getEntityAliasId(entityAliases, aliasInfo);
	            widget.config.datasources[datasourceIndex].entityAliasId = newAliasId;
	        }
	        for (var targetDeviceAliasIndex in aliasesInfo.targetDeviceAliases) {
	            aliasInfo = aliasesInfo.targetDeviceAliases[targetDeviceAliasIndex];
	            newAliasId = getEntityAliasId(entityAliases, aliasInfo);
	            widget.config.targetDeviceAliasIds[targetDeviceAliasIndex] = newAliasId;
	        }
	        return entityAliases;
	    }
	
	    function isEntityAliasEqual(alias1, alias2) {
	        return angular.equals(alias1.filter, alias2.filter);
	    }
	
	    function getEntityAliasId(entityAliases, aliasInfo) {
	        var newAliasId;
	        for (var aliasId in entityAliases) {
	            if (isEntityAliasEqual(entityAliases[aliasId], aliasInfo)) {
	                newAliasId = aliasId;
	                break;
	            }
	        }
	        if (!newAliasId) {
	            var newAliasName = createEntityAliasName(entityAliases, aliasInfo.alias);
	            newAliasId = utils.guid();
	            entityAliases[newAliasId] = { id: newAliasId, alias: newAliasName, filter: aliasInfo.filter };
	        }
	        return newAliasId;
	    }
	
	    function createEntityAliasName(entityAliases, alias) {
	        var c = 0;
	        var newAlias = angular.copy(alias);
	        var unique = false;
	        while (!unique) {
	            unique = true;
	            for (var entAliasId in entityAliases) {
	                var entAlias = entityAliases[entAliasId];
	                if (newAlias === entAlias.alias) {
	                    c++;
	                    newAlias = alias + c;
	                    unique = false;
	                }
	            }
	        }
	        return newAlias;
	    }
	}

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	"use strict";
	
	ToastController.$inject = ["$mdToast", "message"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ToastController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function ToastController($mdToast, message) {
	    var vm = this;
	    vm.message = message;
	
	    vm.closeToast = closeToast;
	
	    function closeToast() {
	        $mdToast.hide();
	    }
	}

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Toast.$inject = ["$mdToast", "$document"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Toast;
	
	var _infoToastTpl = __webpack_require__(1519);
	
	var _infoToastTpl2 = _interopRequireDefault(_infoToastTpl);
	
	var _successToastTpl = __webpack_require__(1520);
	
	var _successToastTpl2 = _interopRequireDefault(_successToastTpl);
	
	var _errorToastTpl = __webpack_require__(1518);
	
	var _errorToastTpl2 = _interopRequireDefault(_errorToastTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function Toast($mdToast, $document) {
	
	    var showing = false;
	
	    var service = {
	        showInfo: showInfo,
	        showSuccess: showSuccess,
	        showError: showError,
	        hide: hide
	    };
	
	    return service;
	
	    function showInfo(infoMessage, delay, toastParent, position) {
	        showMessage(_infoToastTpl2.default, infoMessage, delay, toastParent, position);
	    }
	
	    function showSuccess(successMessage, delay, toastParent, position) {
	        showMessage(_successToastTpl2.default, successMessage, delay, toastParent, position);
	    }
	
	    function showMessage(templateUrl, message, delay, toastParent, position) {
	        if (!toastParent) {
	            toastParent = angular.element($document[0].getElementById('toast-parent'));
	        }
	        if (!position) {
	            position = 'top left';
	        }
	        $mdToast.show({
	            hideDelay: delay || 0,
	            position: position,
	            controller: 'ToastController',
	            controllerAs: 'vm',
	            templateUrl: templateUrl,
	            locals: { message: message },
	            parent: toastParent
	        });
	    }
	
	    function showError(errorMessage, toastParent, position) {
	        if (!showing) {
	            if (!toastParent) {
	                toastParent = angular.element($document[0].getElementById('toast-parent'));
	            }
	            if (!position) {
	                position = 'top left';
	            }
	            showing = true;
	            $mdToast.show({
	                hideDelay: 0,
	                position: position,
	                controller: 'ToastController',
	                controllerAs: 'vm',
	                templateUrl: _errorToastTpl2.default,
	                locals: { message: errorMessage },
	                parent: toastParent
	            }).then(function hide() {
	                showing = false;
	            }, function cancel() {
	                showing = false;
	            });
	        }
	    }
	
	    function hide() {
	        if (showing) {
	            $mdToast.hide();
	        }
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _grid = __webpack_require__(74);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _tenant = __webpack_require__(1148);
	
	var _tenant2 = _interopRequireDefault(_tenant);
	
	var _contact = __webpack_require__(507);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _contactShort = __webpack_require__(506);
	
	var _contactShort2 = _interopRequireDefault(_contactShort);
	
	var _tenant3 = __webpack_require__(1332);
	
	var _tenant4 = _interopRequireDefault(_tenant3);
	
	var _tenant5 = __webpack_require__(1330);
	
	var _tenant6 = _interopRequireDefault(_tenant5);
	
	var _tenant7 = __webpack_require__(1331);
	
	var _tenant8 = _interopRequireDefault(_tenant7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.tenant', [_angularUiRouter2.default, _grid2.default, _tenant2.default, _contact2.default, _contactShort2.default]).config(_tenant4.default).controller('TenantController', _tenant6.default).directive('tbTenant', _tenant8.default).name;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	TenantController.$inject = ["tenantService", "$state", "$stateParams", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = TenantController;
	
	var _addTenantTpl = __webpack_require__(1521);
	
	var _addTenantTpl2 = _interopRequireDefault(_addTenantTpl);
	
	var _tenantCardTpl = __webpack_require__(1522);
	
	var _tenantCardTpl2 = _interopRequireDefault(_tenantCardTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function TenantController(tenantService, $state, $stateParams, $translate, types) {
	
	    var tenantActionsList = [{
	        onAction: function onAction($event, item) {
	            openTenantUsers($event, item);
	        },
	        name: function name() {
	            return $translate.instant('tenant.admins');
	        },
	        details: function details() {
	            return $translate.instant('tenant.manage-tenant-admins');
	        },
	        icon: "account_circle"
	    }, {
	        onAction: function onAction($event, item) {
	            vm.grid.deleteItem($event, item);
	        },
	        name: function name() {
	            return $translate.instant('action.delete');
	        },
	        details: function details() {
	            return $translate.instant('tenant.delete');
	        },
	        icon: "delete"
	    }];
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.tenantGridConfig = {
	
	        refreshParamsFunc: null,
	
	        deleteItemTitleFunc: deleteTenantTitle,
	        deleteItemContentFunc: deleteTenantText,
	        deleteItemsTitleFunc: deleteTenantsTitle,
	        deleteItemsActionTitleFunc: deleteTenantsActionTitle,
	        deleteItemsContentFunc: deleteTenantsText,
	
	        fetchItemsFunc: fetchTenants,
	        saveItemFunc: saveTenant,
	        deleteItemFunc: deleteTenant,
	
	        getItemTitleFunc: getTenantTitle,
	
	        itemCardTemplateUrl: _tenantCardTpl2.default,
	
	        actionsList: tenantActionsList,
	
	        onGridInited: gridInited,
	
	        addItemTemplateUrl: _addTenantTpl2.default,
	
	        addItemText: function addItemText() {
	            return $translate.instant('tenant.add-tenant-text');
	        },
	        noItemsText: function noItemsText() {
	            return $translate.instant('tenant.no-tenants-text');
	        },
	        itemDetailsText: function itemDetailsText() {
	            return $translate.instant('tenant.tenant-details');
	        }
	    };
	
	    if (angular.isDefined($stateParams.items) && $stateParams.items !== null) {
	        vm.tenantGridConfig.items = $stateParams.items;
	    }
	
	    if (angular.isDefined($stateParams.topIndex) && $stateParams.topIndex > 0) {
	        vm.tenantGridConfig.topIndex = $stateParams.topIndex;
	    }
	
	    vm.openTenantUsers = openTenantUsers;
	
	    function deleteTenantTitle(tenant) {
	        return $translate.instant('tenant.delete-tenant-title', { tenantTitle: tenant.title });
	    }
	
	    function deleteTenantText() {
	        return $translate.instant('tenant.delete-tenant-text');
	    }
	
	    function deleteTenantsTitle(selectedCount) {
	        return $translate.instant('tenant.delete-tenants-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteTenantsActionTitle(selectedCount) {
	        return $translate.instant('tenant.delete-tenants-action-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteTenantsText() {
	        return $translate.instant('tenant.delete-tenants-text');
	    }
	
	    function gridInited(grid) {
	        vm.grid = grid;
	    }
	
	    function fetchTenants(pageLink) {
	        return tenantService.getTenants(pageLink);
	    }
	
	    function saveTenant(tenant) {
	        return tenantService.saveTenant(tenant);
	    }
	
	    function deleteTenant(tenantId) {
	        return tenantService.deleteTenant(tenantId);
	    }
	
	    function getTenantTitle(tenant) {
	        return tenant ? tenant.title : '';
	    }
	
	    function openTenantUsers($event, tenant) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        $state.go('home.tenants.users', { tenantId: tenant.id.id });
	    }
	}

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	TenantDirective.$inject = ["$compile", "$templateCache", "$translate", "toast"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = TenantDirective;
	
	var _tenantFieldsetTpl = __webpack_require__(1523);
	
	var _tenantFieldsetTpl2 = _interopRequireDefault(_tenantFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function TenantDirective($compile, $templateCache, $translate, toast) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_tenantFieldsetTpl2.default);
	        element.html(template);
	
	        scope.onTenantIdCopied = function () {
	            toast.showSuccess($translate.instant('tenant.idCopiedMessage'), 750, angular.element(element).parent().parent(), 'bottom left');
	        };
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            tenant: '=',
	            isEdit: '=',
	            theForm: '=',
	            onManageUsers: '&',
	            onDeleteTenant: '&'
	        }
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	TenantRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = TenantRoutes;
	
	var _tenantsTpl = __webpack_require__(1524);
	
	var _tenantsTpl2 = _interopRequireDefault(_tenantsTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function TenantRoutes($stateProvider) {
	
	    $stateProvider.state('home.tenants', {
	        url: '/tenants',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['SYS_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _tenantsTpl2.default,
	                controllerAs: 'vm',
	                controller: 'TenantController'
	            }
	        },
	        data: {
	            searchEnabled: true,
	            pageTitle: 'tenant.tenants'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "supervisor_account", "label": "tenant.tenants"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	'use strict';
	
	ActivationLinkDialogController.$inject = ["$mdDialog", "$translate", "toast", "activationLink"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ActivationLinkDialogController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function ActivationLinkDialogController($mdDialog, $translate, toast, activationLink) {
	
	    var vm = this;
	
	    vm.activationLink = activationLink;
	
	    vm.onActivationLinkCopied = onActivationLinkCopied;
	    vm.close = close;
	
	    function onActivationLinkCopied() {
	        toast.showSuccess($translate.instant('user.activation-link-copied-message'), 750, angular.element('#activation-link-dialog-content'), 'bottom left');
	    }
	
	    function close() {
	        $mdDialog.hide();
	    }
	}

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AddUserController.$inject = ["$scope", "$mdDialog", "$state", "$stateParams", "$document", "$q", "types", "userService", "saveItemFunction", "helpLinks"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AddUserController;
	
	var _activationLinkDialogTpl = __webpack_require__(523);
	
	var _activationLinkDialogTpl2 = _interopRequireDefault(_activationLinkDialogTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function AddUserController($scope, $mdDialog, $state, $stateParams, $document, $q, types, userService, saveItemFunction, helpLinks) {
	
	    var vm = this;
	
	    var tenantId = $stateParams.tenantId;
	    var customerId = $stateParams.customerId;
	    var usersType = $state.$current.data.usersType;
	
	    vm.helpLinks = helpLinks;
	    vm.item = {};
	
	    vm.activationMethods = [{
	        value: 'displayActivationLink',
	        name: 'user.display-activation-link'
	    }, {
	        value: 'sendActivationMail',
	        name: 'user.send-activation-mail'
	    }];
	
	    vm.userActivationMethod = 'displayActivationLink';
	
	    vm.add = add;
	    vm.cancel = cancel;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function add($event) {
	        var sendActivationMail = false;
	        if (vm.userActivationMethod == 'sendActivationMail') {
	            sendActivationMail = true;
	        }
	        if (usersType === 'tenant') {
	            vm.item.authority = "TENANT_ADMIN";
	            vm.item.tenantId = {
	                entityType: types.entityType.tenant,
	                id: tenantId
	            };
	        } else if (usersType === 'customer') {
	            vm.item.authority = "CUSTOMER_USER";
	            vm.item.customerId = {
	                entityType: types.entityType.customer,
	                id: customerId
	            };
	        }
	        userService.saveUser(vm.item, sendActivationMail).then(function success(item) {
	            vm.item = item;
	            $scope.theForm.$setPristine();
	            if (vm.userActivationMethod == 'displayActivationLink') {
	                userService.getActivationLink(vm.item.id.id).then(function success(activationLink) {
	                    displayActivationLink($event, activationLink).then(function () {
	                        $mdDialog.hide();
	                    });
	                });
	            } else {
	                $mdDialog.hide();
	            }
	        });
	    }
	
	    function displayActivationLink($event, activationLink) {
	        var deferred = $q.defer();
	        $mdDialog.show({
	            controller: 'ActivationLinkDialogController',
	            controllerAs: 'vm',
	            templateUrl: _activationLinkDialogTpl2.default,
	            locals: {
	                activationLink: activationLink
	            },
	            parent: angular.element($document[0].body),
	            fullscreen: true,
	            skipHide: true,
	            targetEvent: $event
	        }).then(function () {
	            deferred.resolve();
	        });
	        return deferred.promise;
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _grid = __webpack_require__(74);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _toast = __webpack_require__(75);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _user3 = __webpack_require__(1338);
	
	var _user4 = _interopRequireDefault(_user3);
	
	var _user5 = __webpack_require__(1336);
	
	var _user6 = _interopRequireDefault(_user5);
	
	var _addUser = __webpack_require__(1334);
	
	var _addUser2 = _interopRequireDefault(_addUser);
	
	var _activationLink = __webpack_require__(1333);
	
	var _activationLink2 = _interopRequireDefault(_activationLink);
	
	var _user7 = __webpack_require__(1337);
	
	var _user8 = _interopRequireDefault(_user7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.user', [_angularUiRouter2.default, _grid2.default, _user2.default, _toast2.default]).config(_user4.default).controller('UserController', _user6.default).controller('AddUserController', _addUser2.default).controller('ActivationLinkDialogController', _activationLink2.default).directive('tbUser', _user8.default).name; /*
	                                                                                                                                                                                                                                                                                                                                                                            * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                            *
	                                                                                                                                                                                                                                                                                                                                                                            * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                            * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                            * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                            *
	                                                                                                                                                                                                                                                                                                                                                                            *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                            *
	                                                                                                                                                                                                                                                                                                                                                                            * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                            * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                            * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                            * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                            * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                            */

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UserController.$inject = ["userService", "toast", "$scope", "$mdDialog", "$document", "$controller", "$state", "$stateParams", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = UserController;
	
	var _addUserTpl = __webpack_require__(1525);
	
	var _addUserTpl2 = _interopRequireDefault(_addUserTpl);
	
	var _userCardTpl = __webpack_require__(1526);
	
	var _userCardTpl2 = _interopRequireDefault(_userCardTpl);
	
	var _activationLinkDialogTpl = __webpack_require__(523);
	
	var _activationLinkDialogTpl2 = _interopRequireDefault(_activationLinkDialogTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function UserController(userService, toast, $scope, $mdDialog, $document, $controller, $state, $stateParams, $translate, types) {
	
	    var tenantId = $stateParams.tenantId;
	    var customerId = $stateParams.customerId;
	    var usersType = $state.$current.data.usersType;
	
	    var userActionsList = [{
	        onAction: function onAction($event, item) {
	            loginAsUser(item);
	        },
	        name: function name() {
	            return $translate.instant('login.login');
	        },
	        details: function details() {
	            return $translate.instant(usersType === 'tenant' ? 'user.login-as-tenant-admin' : 'user.login-as-customer-user');
	        },
	        icon: "login",
	        isEnabled: function isEnabled() {
	            return userService.isUserTokenAccessEnabled();
	        }
	    }, {
	        onAction: function onAction($event, item) {
	            vm.grid.deleteItem($event, item);
	        },
	        name: function name() {
	            return $translate.instant('action.delete');
	        },
	        details: function details() {
	            return $translate.instant('user.delete');
	        },
	        icon: "delete"
	    }];
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.userGridConfig = {
	        deleteItemTitleFunc: deleteUserTitle,
	        deleteItemContentFunc: deleteUserText,
	        deleteItemsTitleFunc: deleteUsersTitle,
	        deleteItemsActionTitleFunc: deleteUsersActionTitle,
	        deleteItemsContentFunc: deleteUsersText,
	
	        deleteItemFunc: deleteUser,
	
	        getItemTitleFunc: getUserTitle,
	        itemCardTemplateUrl: _userCardTpl2.default,
	
	        actionsList: userActionsList,
	
	        onGridInited: gridInited,
	
	        addItemTemplateUrl: _addUserTpl2.default,
	        addItemController: 'AddUserController',
	
	        addItemText: function addItemText() {
	            return $translate.instant('user.add-user-text');
	        },
	        noItemsText: function noItemsText() {
	            return $translate.instant('user.no-users-text');
	        },
	        itemDetailsText: function itemDetailsText() {
	            return $translate.instant('user.user-details');
	        }
	    };
	
	    if (angular.isDefined($stateParams.items) && $stateParams.items !== null) {
	        vm.userGridConfig.items = $stateParams.items;
	    }
	
	    if (angular.isDefined($stateParams.topIndex) && $stateParams.topIndex > 0) {
	        vm.userGridConfig.topIndex = $stateParams.topIndex;
	    }
	
	    vm.displayActivationLink = displayActivationLink;
	    vm.resendActivation = resendActivation;
	    vm.loginAsUser = loginAsUser;
	
	    initController();
	
	    function initController() {
	        var fetchUsersFunction = null;
	        var saveUserFunction = null;
	        var refreshUsersParamsFunction = null;
	
	        if (usersType === 'tenant') {
	            fetchUsersFunction = function fetchUsersFunction(pageLink) {
	                return userService.getTenantAdmins(tenantId, pageLink);
	            };
	            saveUserFunction = function saveUserFunction(user) {
	                user.authority = "TENANT_ADMIN";
	                user.tenantId = {
	                    entityType: types.entityType.tenant,
	                    id: tenantId
	                };
	                return userService.saveUser(user);
	            };
	            refreshUsersParamsFunction = function refreshUsersParamsFunction() {
	                return { "tenantId": tenantId, "topIndex": vm.topIndex };
	            };
	        } else if (usersType === 'customer') {
	            fetchUsersFunction = function fetchUsersFunction(pageLink) {
	                return userService.getCustomerUsers(customerId, pageLink);
	            };
	            saveUserFunction = function saveUserFunction(user) {
	                user.authority = "CUSTOMER_USER";
	                user.customerId = {
	                    entityType: types.entityType.customer,
	                    id: customerId
	                };
	                return userService.saveUser(user);
	            };
	            refreshUsersParamsFunction = function refreshUsersParamsFunction() {
	                return { "customerId": customerId, "topIndex": vm.topIndex };
	            };
	        }
	
	        vm.userGridConfig.refreshParamsFunc = refreshUsersParamsFunction;
	        vm.userGridConfig.fetchItemsFunc = fetchUsersFunction;
	        vm.userGridConfig.saveItemFunc = saveUserFunction;
	    }
	
	    function deleteUserTitle(user) {
	        return $translate.instant('user.delete-user-title', { userEmail: user.email });
	    }
	
	    function deleteUserText() {
	        return $translate.instant('user.delete-user-text');
	    }
	
	    function deleteUsersTitle(selectedCount) {
	        return $translate.instant('user.delete-users-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteUsersActionTitle(selectedCount) {
	        return $translate.instant('user.delete-users-action-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteUsersText() {
	        return $translate.instant('user.delete-users-text');
	    }
	
	    function gridInited(grid) {
	        vm.grid = grid;
	    }
	
	    function getUserTitle(user) {
	        return user ? user.email : '';
	    }
	
	    function deleteUser(userId) {
	        return userService.deleteUser(userId);
	    }
	
	    function displayActivationLink(event, user) {
	        userService.getActivationLink(user.id.id).then(function success(activationLink) {
	            openActivationLinkDialog(event, activationLink);
	        });
	    }
	
	    function openActivationLinkDialog(event, activationLink) {
	        $mdDialog.show({
	            controller: 'ActivationLinkDialogController',
	            controllerAs: 'vm',
	            templateUrl: _activationLinkDialogTpl2.default,
	            locals: {
	                activationLink: activationLink
	            },
	            parent: angular.element($document[0].body),
	            fullscreen: true,
	            skipHide: true,
	            targetEvent: event
	        });
	    }
	
	    function resendActivation(user) {
	        userService.sendActivationEmail(user.email).then(function success() {
	            toast.showSuccess($translate.instant('user.activation-email-sent-message'));
	        });
	    }
	
	    function loginAsUser(user) {
	        userService.loginAsUser(user.id.id);
	    }
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UserDirective.$inject = ["$compile", "$templateCache", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = UserDirective;
	
	__webpack_require__(820);
	
	var _userFieldsetTpl = __webpack_require__(1527);
	
	var _userFieldsetTpl2 = _interopRequireDefault(_userFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function UserDirective($compile, $templateCache, userService) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_userFieldsetTpl2.default);
	        element.html(template);
	
	        scope.isTenantAdmin = function () {
	            return scope.user && scope.user.authority === 'TENANT_ADMIN';
	        };
	
	        scope.isCustomerUser = function () {
	            return scope.user && scope.user.authority === 'CUSTOMER_USER';
	        };
	
	        scope.loginAsUserEnabled = userService.isUserTokenAccessEnabled();
	
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            user: '=',
	            isEdit: '=',
	            theForm: '=',
	            onDisplayActivationLink: '&',
	            onResendActivation: '&',
	            onLoginAsUser: '&',
	            onDeleteUser: '&'
	        }
	    };
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UserRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = UserRoutes;
	
	var _usersTpl = __webpack_require__(1528);
	
	var _usersTpl2 = _interopRequireDefault(_usersTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function UserRoutes($stateProvider) {
	
	    $stateProvider.state('home.tenants.users', {
	        url: '/:tenantId/users',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['SYS_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _usersTpl2.default,
	                controllerAs: 'vm',
	                controller: 'UserController'
	            }
	        },
	        data: {
	            usersType: 'tenant',
	            searchEnabled: true,
	            pageTitle: 'user.tenant-admins'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "account_circle", "label": "user.tenant-admins"}'
	        }
	    }).state('home.customers.users', {
	        url: '/:customerId/users',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _usersTpl2.default,
	                controllerAs: 'vm',
	                controller: 'UserController'
	            }
	        },
	        data: {
	            usersType: 'customer',
	            searchEnabled: true,
	            pageTitle: 'user.customer-users'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "account_circle", "label": "user.customer-users"}'
	        }
	    });
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(830);
	
	__webpack_require__(598);
	
	__webpack_require__(267);
	
	var _angularUiRouter = __webpack_require__(26);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _widget = __webpack_require__(147);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	var _types = __webpack_require__(23);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _toast = __webpack_require__(75);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _confirmOnExit = __webpack_require__(229);
	
	var _confirmOnExit2 = _interopRequireDefault(_confirmOnExit);
	
	var _dashboard = __webpack_require__(508);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _expandFullscreen = __webpack_require__(231);
	
	var _expandFullscreen2 = _interopRequireDefault(_expandFullscreen);
	
	var _circularProgress = __webpack_require__(1169);
	
	var _circularProgress2 = _interopRequireDefault(_circularProgress);
	
	var _widgetLibrary = __webpack_require__(1362);
	
	var _widgetLibrary2 = _interopRequireDefault(_widgetLibrary);
	
	var _widgetLibrary3 = __webpack_require__(1361);
	
	var _widgetLibrary4 = _interopRequireDefault(_widgetLibrary3);
	
	var _selectWidgetType = __webpack_require__(1359);
	
	var _selectWidgetType2 = _interopRequireDefault(_selectWidgetType);
	
	var _widgetEditor = __webpack_require__(1360);
	
	var _widgetEditor2 = _interopRequireDefault(_widgetEditor);
	
	var _widgetsBundle = __webpack_require__(1363);
	
	var _widgetsBundle2 = _interopRequireDefault(_widgetsBundle);
	
	var _widgetsBundle3 = __webpack_require__(1364);
	
	var _widgetsBundle4 = _interopRequireDefault(_widgetsBundle3);
	
	var _saveWidgetTypeAs = __webpack_require__(1358);
	
	var _saveWidgetTypeAs2 = _interopRequireDefault(_saveWidgetTypeAs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('thingsboard.widget-library', [_angularUiRouter2.default, _widget2.default, _user2.default, _types2.default, _toast2.default, _confirmOnExit2.default, _dashboard2.default, _expandFullscreen2.default, _circularProgress2.default, 'cfp.hotkeys', 'ui.ace']).config(_widgetLibrary2.default).controller('WidgetLibraryController', _widgetLibrary4.default).controller('SelectWidgetTypeController', _selectWidgetType2.default).controller('WidgetEditorController', _widgetEditor2.default).controller('WidgetsBundleController', _widgetsBundle2.default).controller('SaveWidgetTypeAsController', _saveWidgetTypeAs2.default).directive('tbWidgetsBundle', _widgetsBundle4.default).name; /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 */

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AlarmsTableWidgetController.$inject = ["$element", "$scope", "$filter", "$mdMedia", "$mdDialog", "$mdPanel", "$document", "$translate", "$q", "$timeout", "alarmService", "utils", "types"];
	DisplayColumnsPanelController.$inject = ["columns"];
	AlarmStatusFilterPanelController.$inject = ["subscription", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(822);
	
	__webpack_require__(311);
	
	__webpack_require__(821);
	
	var _alarmsTableWidgetTpl = __webpack_require__(1531);
	
	var _alarmsTableWidgetTpl2 = _interopRequireDefault(_alarmsTableWidgetTpl);
	
	var _alarmDetailsDialogTpl = __webpack_require__(517);
	
	var _alarmDetailsDialogTpl2 = _interopRequireDefault(_alarmDetailsDialogTpl);
	
	var _displayColumnsPanelTpl = __webpack_require__(524);
	
	var _displayColumnsPanelTpl2 = _interopRequireDefault(_displayColumnsPanelTpl);
	
	var _alarmStatusFilterPanelTpl = __webpack_require__(1530);
	
	var _alarmStatusFilterPanelTpl2 = _interopRequireDefault(_alarmStatusFilterPanelTpl);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _css = __webpack_require__(149);
	
	var _css2 = _interopRequireDefault(_css);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.widgets.alarmsTableWidget', []).directive('tbAlarmsTableWidget', AlarmsTableWidget).name;
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function AlarmsTableWidget() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            tableId: '=',
	            ctx: '='
	        },
	        controller: AlarmsTableWidgetController,
	        controllerAs: 'vm',
	        templateUrl: _alarmsTableWidgetTpl2.default
	    };
	}
	
	/*@ngInject*/
	function AlarmsTableWidgetController($element, $scope, $filter, $mdMedia, $mdDialog, $mdPanel, $document, $translate, $q, $timeout, alarmService, utils, types) {
	    var vm = this;
	
	    vm.stylesInfo = {};
	    vm.contentsInfo = {};
	    vm.columnWidth = {};
	
	    vm.showData = true;
	    vm.hasData = false;
	
	    vm.alarms = [];
	    vm.alarmsCount = 0;
	    vm.selectedAlarms = [];
	
	    vm.alarmSource = null;
	    vm.alarmSearchStatus = null;
	    vm.allAlarms = [];
	
	    vm.currentAlarm = null;
	
	    vm.enableSelection = true;
	    vm.displayDetails = true;
	    vm.allowAcknowledgment = true;
	    vm.allowClear = true;
	    vm.actionCellDescriptors = [];
	    vm.displayPagination = true;
	    vm.defaultPageSize = 10;
	    vm.defaultSortOrder = '-' + types.alarmFields.createdTime.value;
	
	    vm.query = {
	        order: vm.defaultSortOrder,
	        limit: vm.defaultPageSize,
	        page: 1,
	        search: null
	    };
	
	    vm.searchAction = {
	        name: 'action.search',
	        show: true,
	        onAction: function onAction() {
	            vm.enterFilterMode();
	        },
	        icon: 'search'
	    };
	
	    vm.enterFilterMode = enterFilterMode;
	    vm.exitFilterMode = exitFilterMode;
	    vm.onReorder = onReorder;
	    vm.onPaginate = onPaginate;
	    vm.onRowClick = onRowClick;
	    vm.onActionButtonClick = onActionButtonClick;
	    vm.actionEnabled = actionEnabled;
	    vm.isCurrent = isCurrent;
	    vm.openAlarmDetails = openAlarmDetails;
	    vm.ackAlarms = ackAlarms;
	    vm.ackAlarm = ackAlarm;
	    vm.clearAlarms = clearAlarms;
	    vm.clearAlarm = clearAlarm;
	
	    vm.cellStyle = cellStyle;
	    vm.cellContent = cellContent;
	
	    vm.editAlarmStatusFilter = editAlarmStatusFilter;
	    vm.editColumnsToDisplay = editColumnsToDisplay;
	
	    $scope.$watch('vm.ctx', function () {
	        if (vm.ctx) {
	            vm.settings = vm.ctx.settings;
	            vm.widgetConfig = vm.ctx.widgetConfig;
	            vm.subscription = vm.ctx.defaultSubscription;
	            vm.alarmSource = vm.subscription.alarmSource;
	            initializeConfig();
	            updateAlarmSource();
	        }
	    });
	
	    $scope.$watch("vm.query.search", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
	            updateAlarms();
	        }
	    });
	
	    $scope.$on('alarms-table-data-updated', function (event, tableId) {
	        if (vm.tableId == tableId) {
	            if (vm.subscription) {
	                vm.allAlarms = vm.subscription.alarms || [];
	                updateAlarms(true);
	                $scope.$digest();
	            }
	        }
	    });
	
	    $scope.$watch(function () {
	        return $mdMedia('gt-xs');
	    }, function (isGtXs) {
	        vm.isGtXs = isGtXs;
	    });
	
	    $scope.$watch(function () {
	        return $mdMedia('gt-md');
	    }, function (isGtMd) {
	        vm.isGtMd = isGtMd;
	        if (vm.isGtMd) {
	            vm.limitOptions = [vm.defaultPageSize, vm.defaultPageSize * 2, vm.defaultPageSize * 3];
	        } else {
	            vm.limitOptions = null;
	        }
	    });
	
	    $scope.$watch('vm.selectedAlarms.length', function (newLength) {
	        var selectionMode = newLength ? true : false;
	        if (vm.ctx) {
	            if (selectionMode) {
	                vm.ctx.hideTitlePanel = true;
	            } else if (vm.query.search == null) {
	                vm.ctx.hideTitlePanel = false;
	            }
	        }
	    });
	
	    function initializeConfig() {
	
	        vm.ctx.widgetActions = [vm.searchAction];
	
	        vm.displayDetails = angular.isDefined(vm.settings.displayDetails) ? vm.settings.displayDetails : true;
	        vm.allowAcknowledgment = angular.isDefined(vm.settings.allowAcknowledgment) ? vm.settings.allowAcknowledgment : true;
	        vm.allowClear = angular.isDefined(vm.settings.allowClear) ? vm.settings.allowClear : true;
	
	        if (vm.displayDetails) {
	            vm.actionCellDescriptors.push({
	                displayName: $translate.instant('alarm.details'),
	                icon: 'more_horiz',
	                details: true
	            });
	        }
	
	        if (vm.allowAcknowledgment) {
	            vm.actionCellDescriptors.push({
	                displayName: $translate.instant('alarm.acknowledge'),
	                icon: 'done',
	                acknowledge: true
	            });
	        }
	
	        if (vm.allowClear) {
	            vm.actionCellDescriptors.push({
	                displayName: $translate.instant('alarm.clear'),
	                icon: 'clear',
	                clear: true
	            });
	        }
	
	        vm.actionCellDescriptors = vm.actionCellDescriptors.concat(vm.ctx.actionsApi.getActionDescriptors('actionCellButton'));
	
	        if (vm.settings.alarmsTitle && vm.settings.alarmsTitle.length) {
	            vm.alarmsTitle = utils.customTranslation(vm.settings.alarmsTitle, vm.settings.alarmsTitle);
	        } else {
	            vm.alarmsTitle = $translate.instant('alarm.alarms');
	        }
	
	        vm.ctx.widgetTitle = vm.alarmsTitle;
	
	        vm.enableSelection = angular.isDefined(vm.settings.enableSelection) ? vm.settings.enableSelection : true;
	        vm.searchAction.show = angular.isDefined(vm.settings.enableSearch) ? vm.settings.enableSearch : true;
	        if (!vm.allowAcknowledgment && !vm.allowClear) {
	            vm.enableSelection = false;
	        }
	
	        vm.displayPagination = angular.isDefined(vm.settings.displayPagination) ? vm.settings.displayPagination : true;
	
	        var pageSize = vm.settings.defaultPageSize;
	        if (angular.isDefined(pageSize) && angular.isNumber(pageSize) && pageSize > 0) {
	            vm.defaultPageSize = pageSize;
	        }
	
	        if (vm.settings.defaultSortOrder && vm.settings.defaultSortOrder.length) {
	            vm.defaultSortOrder = vm.settings.defaultSortOrder;
	        }
	
	        vm.query.order = vm.defaultSortOrder;
	        vm.query.limit = vm.defaultPageSize;
	        if (vm.isGtMd) {
	            vm.limitOptions = [vm.defaultPageSize, vm.defaultPageSize * 2, vm.defaultPageSize * 3];
	        } else {
	            vm.limitOptions = null;
	        }
	
	        var origColor = vm.widgetConfig.color || 'rgba(0, 0, 0, 0.87)';
	        var defaultColor = (0, _tinycolor2.default)(origColor);
	        var mdDark = defaultColor.setAlpha(0.87).toRgbString();
	        var mdDarkSecondary = defaultColor.setAlpha(0.54).toRgbString();
	        var mdDarkDisabled = defaultColor.setAlpha(0.26).toRgbString();
	        //var mdDarkIcon = mdDarkSecondary;
	        var mdDarkDivider = defaultColor.setAlpha(0.12).toRgbString();
	
	        var cssString = 'table.md-table th.md-column {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + 'table.md-table th.md-column.md-checkbox-column md-checkbox:not(.md-checked) .md-icon {\n' + 'border-color: ' + mdDarkSecondary + ';\n' + '}\n' + 'table.md-table th.md-column md-icon.md-sort-icon {\n' + 'color: ' + mdDarkDisabled + ';\n' + '}\n' + 'table.md-table th.md-column.md-active, table.md-table th.md-column.md-active md-icon {\n' + 'color: ' + mdDark + ';\n' + '}\n' + 'table.md-table td.md-cell {\n' + 'color: ' + mdDark + ';\n' + 'border-top: 1px ' + mdDarkDivider + ' solid;\n' + '}\n' + 'table.md-table td.md-cell.md-checkbox-cell md-checkbox:not(.md-checked) .md-icon {\n' + 'border-color: ' + mdDarkSecondary + ';\n' + '}\n' + 'table.md-table td.md-cell.tb-action-cell button.md-icon-button md-icon {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + 'table.md-table td.md-cell.md-placeholder {\n' + 'color: ' + mdDarkDisabled + ';\n' + '}\n' + 'table.md-table td.md-cell md-select > .md-select-value > span.md-select-icon {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + '.md-table-pagination {\n' + 'color: ' + mdDarkSecondary + ';\n' + 'border-top: 1px ' + mdDarkDivider + ' solid;\n' + '}\n' + '.md-table-pagination .buttons md-icon {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + '.md-table-pagination md-select:not([disabled]):focus .md-select-value {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}';
	
	        var cssParser = new _css2.default();
	        cssParser.testMode = false;
	        var namespace = 'ts-table-' + hashCode(cssString);
	        cssParser.cssPreviewNamespace = namespace;
	        cssParser.createStyleElement(namespace, cssString);
	        $element.addClass(namespace);
	
	        function hashCode(str) {
	            var hash = 0;
	            var i, char;
	            if (str.length === 0) return hash;
	            for (i = 0; i < str.length; i++) {
	                char = str.charCodeAt(i);
	                hash = (hash << 5) - hash + char;
	                hash = hash & hash;
	            }
	            return hash;
	        }
	    }
	
	    function enterFilterMode() {
	        vm.query.search = '';
	        vm.ctx.hideTitlePanel = true;
	        $timeout(function () {
	            angular.element(vm.ctx.$container).find('.searchInput').focus();
	        });
	    }
	
	    function exitFilterMode() {
	        vm.query.search = null;
	        updateAlarms();
	        vm.ctx.hideTitlePanel = false;
	    }
	
	    function onReorder() {
	        updateAlarms();
	    }
	
	    function onPaginate() {
	        updateAlarms();
	    }
	
	    function onRowClick($event, alarm) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.currentAlarm != alarm) {
	            vm.currentAlarm = alarm;
	        }
	        var descriptors = vm.ctx.actionsApi.getActionDescriptors('rowClick');
	        if (descriptors.length) {
	            var entityId;
	            var entityName;
	            if (vm.currentAlarm && vm.currentAlarm.originator) {
	                entityId = vm.currentAlarm.originator;
	                entityName = vm.currentAlarm.originatorName;
	            }
	            vm.ctx.actionsApi.handleWidgetAction($event, descriptors[0], entityId, entityName, { alarm: alarm });
	        }
	    }
	
	    function onActionButtonClick($event, alarm, actionDescriptor) {
	        if (actionDescriptor.details) {
	            vm.openAlarmDetails($event, alarm);
	        } else if (actionDescriptor.acknowledge) {
	            vm.ackAlarm($event, alarm);
	        } else if (actionDescriptor.clear) {
	            vm.clearAlarm($event, alarm);
	        } else {
	            if ($event) {
	                $event.stopPropagation();
	            }
	            var entityId;
	            var entityName;
	            if (alarm && alarm.originator) {
	                entityId = alarm.originator;
	                entityName = alarm.originatorName;
	            }
	            vm.ctx.actionsApi.handleWidgetAction($event, actionDescriptor, entityId, entityName, { alarm: alarm });
	        }
	    }
	
	    function actionEnabled(alarm, actionDescriptor) {
	        if (actionDescriptor.acknowledge) {
	            return alarm.status == types.alarmStatus.activeUnack || alarm.status == types.alarmStatus.clearedUnack;
	        } else if (actionDescriptor.clear) {
	            return alarm.status == types.alarmStatus.activeAck || alarm.status == types.alarmStatus.activeUnack;
	        }
	        return true;
	    }
	
	    function isCurrent(alarm) {
	        return vm.currentAlarm && alarm && vm.currentAlarm.id && alarm.id && vm.currentAlarm.id.id === alarm.id.id;
	    }
	
	    function openAlarmDetails($event, alarm) {
	        if (alarm && alarm.id) {
	            var onShowingCallback = {
	                onShowing: function onShowing() {}
	            };
	            $mdDialog.show({
	                controller: 'AlarmDetailsDialogController',
	                controllerAs: 'vm',
	                templateUrl: _alarmDetailsDialogTpl2.default,
	                locals: {
	                    alarmId: alarm.id.id,
	                    allowAcknowledgment: vm.allowAcknowledgment,
	                    allowClear: vm.allowClear,
	                    displayDetails: true,
	                    showingCallback: onShowingCallback
	                },
	                parent: angular.element($document[0].body),
	                targetEvent: $event,
	                fullscreen: true,
	                skipHide: true,
	                onShowing: function onShowing(scope, element) {
	                    onShowingCallback.onShowing(scope, element);
	                }
	            }).then(function (alarm) {
	                if (alarm) {
	                    vm.subscription.update();
	                }
	            });
	        }
	    }
	
	    function ackAlarms($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.selectedAlarms && vm.selectedAlarms.length > 0) {
	            var title = $translate.instant('alarm.aknowledge-alarms-title', { count: vm.selectedAlarms.length }, 'messageformat');
	            var content = $translate.instant('alarm.aknowledge-alarms-text', { count: vm.selectedAlarms.length }, 'messageformat');
	            var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(title).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	            $mdDialog.show(confirm).then(function () {
	                var tasks = [];
	                for (var i = 0; i < vm.selectedAlarms.length; i++) {
	                    var alarm = vm.selectedAlarms[i];
	                    if (alarm.id) {
	                        tasks.push(alarmService.ackAlarm(alarm.id.id));
	                    }
	                }
	                if (tasks.length) {
	                    $q.all(tasks).then(function () {
	                        vm.selectedAlarms = [];
	                        vm.subscription.update();
	                    });
	                }
	            });
	        }
	    }
	
	    function ackAlarm($event, alarm) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('alarm.aknowledge-alarm-title')).htmlContent($translate.instant('alarm.aknowledge-alarm-text')).ariaLabel($translate.instant('alarm.acknowledge')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            alarmService.ackAlarm(alarm.id.id).then(function () {
	                vm.selectedAlarms = [];
	                vm.subscription.update();
	            });
	        });
	    }
	
	    function clearAlarms($event) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.selectedAlarms && vm.selectedAlarms.length > 0) {
	            var title = $translate.instant('alarm.clear-alarms-title', { count: vm.selectedAlarms.length }, 'messageformat');
	            var content = $translate.instant('alarm.clear-alarms-text', { count: vm.selectedAlarms.length }, 'messageformat');
	            var confirm = $mdDialog.confirm().targetEvent($event).title(title).htmlContent(content).ariaLabel(title).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	            $mdDialog.show(confirm).then(function () {
	                var tasks = [];
	                for (var i = 0; i < vm.selectedAlarms.length; i++) {
	                    var alarm = vm.selectedAlarms[i];
	                    if (alarm.id) {
	                        tasks.push(alarmService.clearAlarm(alarm.id.id));
	                    }
	                }
	                if (tasks.length) {
	                    $q.all(tasks).then(function () {
	                        vm.selectedAlarms = [];
	                        vm.subscription.update();
	                    });
	                }
	            });
	        }
	    }
	
	    function clearAlarm($event, alarm) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var confirm = $mdDialog.confirm().targetEvent($event).title($translate.instant('alarm.clear-alarm-title')).htmlContent($translate.instant('alarm.clear-alarm-text')).ariaLabel($translate.instant('alarm.clear')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            alarmService.clearAlarm(alarm.id.id).then(function () {
	                vm.selectedAlarms = [];
	                vm.subscription.update();
	            });
	        });
	    }
	
	    function updateAlarms(preserveSelections) {
	        if (!preserveSelections) {
	            vm.selectedAlarms = [];
	        }
	        var result = $filter('orderBy')(vm.allAlarms, vm.query.order);
	        if (vm.query.search != null) {
	            result = $filter('filter')(result, { $: vm.query.search });
	        }
	        vm.alarmsCount = result.length;
	
	        if (vm.displayPagination) {
	            var startIndex = vm.query.limit * (vm.query.page - 1);
	            vm.alarms = result.slice(startIndex, startIndex + vm.query.limit);
	        } else {
	            vm.alarms = result;
	        }
	
	        if (preserveSelections) {
	            var newSelectedAlarms = [];
	            if (vm.selectedAlarms && vm.selectedAlarms.length) {
	                var i = vm.selectedAlarms.length;
	                while (i--) {
	                    var selectedAlarm = vm.selectedAlarms[i];
	                    if (selectedAlarm.id) {
	                        result = $filter('filter')(vm.alarms, { id: { id: selectedAlarm.id.id } });
	                        if (result && result.length) {
	                            newSelectedAlarms.push(result[0]);
	                        }
	                    }
	                }
	            }
	            vm.selectedAlarms = newSelectedAlarms;
	        }
	    }
	
	    function cellStyle(alarm, key) {
	        var style = {};
	        if (alarm && key) {
	            var styleInfo = vm.stylesInfo[key.label];
	            var value = getAlarmValue(alarm, key);
	            if (styleInfo.useCellStyleFunction && styleInfo.cellStyleFunction) {
	                try {
	                    style = styleInfo.cellStyleFunction(value);
	                } catch (e) {
	                    style = {};
	                }
	            } else {
	                style = defaultStyle(key, value);
	            }
	        }
	        if (!style.width) {
	            var columnWidth = vm.columnWidth[key.label];
	            style.width = columnWidth;
	        }
	        return style;
	    }
	
	    function cellContent(alarm, key) {
	        var strContent = '';
	        if (alarm && key) {
	            var contentInfo = vm.contentsInfo[key.label];
	            var value = getAlarmValue(alarm, key);
	            if (contentInfo.useCellContentFunction && contentInfo.cellContentFunction) {
	                if (angular.isDefined(value)) {
	                    strContent = '' + value;
	                }
	                var content = strContent;
	                try {
	                    content = contentInfo.cellContentFunction(value, alarm, $filter);
	                } catch (e) {
	                    content = strContent;
	                }
	            } else {
	                content = defaultContent(key, value);
	            }
	            return content;
	        } else {
	            return strContent;
	        }
	    }
	
	    function defaultContent(key, value) {
	        if (angular.isDefined(value)) {
	            var alarmField = types.alarmFields[key.name];
	            if (alarmField) {
	                if (alarmField.time) {
	                    return $filter('date')(value, 'yyyy-MM-dd HH:mm:ss');
	                } else if (alarmField.value == types.alarmFields.severity.value) {
	                    return $translate.instant(types.alarmSeverity[value].name);
	                } else if (alarmField.value == types.alarmFields.status.value) {
	                    return $translate.instant('alarm.display-status.' + value);
	                } else if (alarmField.value == types.alarmFields.originatorType.value) {
	                    return $translate.instant(types.entityTypeTranslations[value].type);
	                } else {
	                    return value;
	                }
	            } else {
	                return value;
	            }
	        } else {
	            return '';
	        }
	    }
	    function defaultStyle(key, value) {
	        if (angular.isDefined(value)) {
	            var alarmField = types.alarmFields[key.name];
	            if (alarmField) {
	                if (alarmField.value == types.alarmFields.severity.value) {
	                    return {
	                        fontWeight: 'bold',
	                        color: types.alarmSeverity[value].color
	                    };
	                } else {
	                    return {};
	                }
	            } else {
	                return {};
	            }
	        } else {
	            return {};
	        }
	    }
	
	    var getDescendantProp = function getDescendantProp(obj, path) {
	        return path.split('.').reduce(function (acc, part) {
	            return acc && acc[part];
	        }, obj);
	    };
	
	    function getAlarmValue(alarm, key) {
	        var alarmField = types.alarmFields[key.name];
	        if (alarmField) {
	            return getDescendantProp(alarm, alarmField.value);
	        } else {
	            return getDescendantProp(alarm, key.name);
	        }
	    }
	
	    function editAlarmStatusFilter($event) {
	        var element = angular.element($event.target);
	        var position = $mdPanel.newPanelPosition().relativeTo(element).addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);
	        var config = {
	            attachTo: angular.element($document[0].body),
	            controller: AlarmStatusFilterPanelController,
	            controllerAs: 'vm',
	            templateUrl: _alarmStatusFilterPanelTpl2.default,
	            panelClass: 'tb-alarm-status-filter-panel',
	            position: position,
	            fullscreen: false,
	            locals: {
	                'subscription': vm.subscription
	            },
	            openFrom: $event,
	            clickOutsideToClose: true,
	            escapeToClose: true,
	            focusOnOpen: false
	        };
	        $mdPanel.open(config);
	    }
	
	    function editColumnsToDisplay($event) {
	        var element = angular.element($event.target);
	        var position = $mdPanel.newPanelPosition().relativeTo(element).addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);
	        var config = {
	            attachTo: angular.element($document[0].body),
	            controller: DisplayColumnsPanelController,
	            controllerAs: 'vm',
	            templateUrl: _displayColumnsPanelTpl2.default,
	            panelClass: 'tb-display-columns-panel',
	            position: position,
	            fullscreen: false,
	            locals: {
	                'columns': vm.alarmSource.dataKeys
	            },
	            openFrom: $event,
	            clickOutsideToClose: true,
	            escapeToClose: true,
	            focusOnOpen: false
	        };
	        $mdPanel.open(config);
	    }
	
	    function updateAlarmSource() {
	
	        vm.ctx.widgetTitle = utils.createLabelFromDatasource(vm.alarmSource, vm.alarmsTitle);
	
	        vm.stylesInfo = {};
	        vm.contentsInfo = {};
	        vm.columnWidth = {};
	
	        for (var d = 0; d < vm.alarmSource.dataKeys.length; d++) {
	            var dataKey = vm.alarmSource.dataKeys[d];
	
	            dataKey.title = utils.customTranslation(dataKey.label, dataKey.label);
	            dataKey.display = true;
	
	            var keySettings = dataKey.settings;
	
	            var cellStyleFunction = null;
	            var useCellStyleFunction = false;
	
	            if (keySettings.useCellStyleFunction === true) {
	                if (angular.isDefined(keySettings.cellStyleFunction) && keySettings.cellStyleFunction.length > 0) {
	                    try {
	                        cellStyleFunction = new Function('value', keySettings.cellStyleFunction);
	                        useCellStyleFunction = true;
	                    } catch (e) {
	                        cellStyleFunction = null;
	                        useCellStyleFunction = false;
	                    }
	                }
	            }
	
	            vm.stylesInfo[dataKey.label] = {
	                useCellStyleFunction: useCellStyleFunction,
	                cellStyleFunction: cellStyleFunction
	            };
	
	            var cellContentFunction = null;
	            var useCellContentFunction = false;
	
	            if (keySettings.useCellContentFunction === true) {
	                if (angular.isDefined(keySettings.cellContentFunction) && keySettings.cellContentFunction.length > 0) {
	                    try {
	                        cellContentFunction = new Function('value, alarm, filter', keySettings.cellContentFunction);
	                        useCellContentFunction = true;
	                    } catch (e) {
	                        cellContentFunction = null;
	                        useCellContentFunction = false;
	                    }
	                }
	            }
	
	            vm.contentsInfo[dataKey.label] = {
	                useCellContentFunction: useCellContentFunction,
	                cellContentFunction: cellContentFunction
	            };
	
	            var columnWidth = angular.isDefined(keySettings.columnWidth) ? keySettings.columnWidth : '0px';
	            vm.columnWidth[dataKey.label] = columnWidth;
	        }
	    }
	}
	
	/*@ngInject*/
	function DisplayColumnsPanelController(columns) {
	    //eslint-disable-line
	
	    var vm = this;
	    vm.columns = columns;
	}
	
	/*@ngInject*/
	function AlarmStatusFilterPanelController(subscription, types) {
	    //eslint-disable-line
	
	    var vm = this;
	    vm.types = types;
	    vm.subscription = subscription;
	}

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _canvasGauges = __webpack_require__(100);
	
	var _canvasGauges2 = _interopRequireDefault(_canvasGauges);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*import tinycolor from 'tinycolor2';*/
	
	/* eslint-disable angular/angularelement */
	
	var TbAnalogueCompass = function () {
	    function TbAnalogueCompass(ctx, canvasId) {
	        _classCallCheck(this, TbAnalogueCompass);
	
	        this.ctx = ctx;
	
	        _canvasGauges2.default.performance = window.performance; // eslint-disable-line no-undef, angular/window-service
	
	        var gaugeElement = (0, _jquery2.default)('#' + canvasId, ctx.$container);
	
	        var settings = ctx.settings;
	        var majorTicks = settings.majorTicks && settings.majorTicks.length > 0 ? angular.copy(settings.majorTicks) : ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
	        majorTicks.push(majorTicks[0]);
	
	        function getFontFamily(fontSettings) {
	            var family = fontSettings && fontSettings.family ? fontSettings.family : 'Roboto';
	            if (family === 'RobotoDraft') {
	                family = 'Roboto';
	            }
	            return family;
	        }
	
	        var gaugeData = {
	
	            renderTo: gaugeElement[0],
	
	            // Generic options
	            minValue: 0,
	            maxValue: 360,
	            majorTicks: majorTicks,
	            minorTicks: settings.minorTicks || 22,
	            ticksAngle: 360,
	            startAngle: 180,
	            strokeTicks: settings.showStrokeTicks || false,
	            highlights: false,
	            valueBox: false,
	
	            //needle
	            needleCircleSize: settings.needleCircleSize || 15,
	            needleType: 'line',
	            needleStart: 75,
	            needleEnd: 99,
	            needleWidth: 3,
	            needleCircleOuter: false,
	
	            //borders
	            borders: settings.showBorder || false,
	            borderInnerWidth: 0,
	            borderMiddleWidth: 0,
	            borderOuterWidth: settings.borderOuterWidth || 10,
	            borderShadowWidth: 0,
	
	            //colors
	            colorPlate: settings.colorPlate || '#222',
	            colorMajorTicks: settings.colorMajorTicks || '#f5f5f5',
	            colorMinorTicks: settings.colorMinorTicks || '#ddd',
	            colorNeedle: settings.colorNeedle || '#f08080',
	            colorNeedleEnd: settings.colorNeedle || '#f08080',
	            colorNeedleCircleInner: settings.colorNeedleCircle || '#e8e8e8',
	            colorNeedleCircleInnerEnd: settings.colorNeedleCircle || '#e8e8e8',
	            colorBorderOuter: settings.colorBorder || '#ccc',
	            colorBorderOuterEnd: settings.colorBorder || '#ccc',
	            colorNeedleShadowDown: "#222",
	
	            //fonts
	            fontNumbers: getFontFamily(settings.majorTickFont),
	            fontNumbersSize: settings.majorTickFont && settings.majorTickFont.size ? settings.majorTickFont.size : 20,
	            fontNumbersStyle: settings.majorTickFont && settings.majorTickFont.style ? settings.majorTickFont.style : 'normal',
	            fontNumbersWeight: settings.majorTickFont && settings.majorTickFont.weight ? settings.majorTickFont.weight : '500',
	            colorNumbers: settings.majorTickFont && settings.majorTickFont.color ? settings.majorTickFont.color : '#ccc',
	
	            //animations
	            animation: settings.animation !== false && !ctx.isMobile,
	            animationDuration: angular.isDefined(settings.animationDuration) && settings.animationDuration !== null ? settings.animationDuration : 500,
	            animationRule: settings.animationRule || 'cycle',
	            animationTarget: settings.animationTarget || 'needle'
	        };
	        this.gauge = new _canvasGauges2.default.RadialGauge(gaugeData).draw();
	    }
	
	    _createClass(TbAnalogueCompass, [{
	        key: 'update',
	        value: function update() {
	            if (this.ctx.data.length > 0) {
	                var cellData = this.ctx.data[0];
	                if (cellData.data.length > 0) {
	                    var tvPair = cellData.data[cellData.data.length - 1];
	                    var value = tvPair[1];
	                    if (value !== this.gauge.value) {
	                        this.gauge.value = value;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'mobileModeChanged',
	        value: function mobileModeChanged() {
	            var animation = this.ctx.settings.animation !== false && !this.ctx.isMobile;
	            this.gauge.update({ animation: animation });
	        }
	    }, {
	        key: 'resize',
	        value: function resize() {
	            this.gauge.update({ width: this.ctx.width, height: this.ctx.height });
	        }
	    }], [{
	        key: 'settingsSchema',
	        get: function get() {
	            return {
	                "schema": {
	                    "type": "object",
	                    "title": "Settings",
	                    "properties": {
	                        "majorTicks": {
	                            "title": "Major ticks names",
	                            "type": "array",
	                            "items": {
	                                "title": "Tick name",
	                                "type": "string"
	                            }
	                        },
	                        "minorTicks": {
	                            "title": "Minor ticks count",
	                            "type": "number",
	                            "default": 22
	                        },
	                        "showStrokeTicks": {
	                            "title": "Show ticks stroke",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "needleCircleSize": {
	                            "title": "Needle circle size",
	                            "type": "number",
	                            "default": 15
	                        },
	                        "showBorder": {
	                            "title": "Show border",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "borderOuterWidth": {
	                            "title": "Border width",
	                            "type": "number",
	                            "default": 10
	                        },
	                        "colorPlate": {
	                            "title": "Plate color",
	                            "type": "string",
	                            "default": "#222"
	                        },
	                        "colorMajorTicks": {
	                            "title": "Major ticks color",
	                            "type": "string",
	                            "default": "#f5f5f5"
	                        },
	                        "colorMinorTicks": {
	                            "title": "Minor ticks color",
	                            "type": "string",
	                            "default": "#ddd"
	                        },
	                        "colorNeedle": {
	                            "title": "Needle color",
	                            "type": "string",
	                            "default": "#f08080"
	                        },
	                        "colorNeedleCircle": {
	                            "title": "Needle circle color",
	                            "type": "string",
	                            "default": "#e8e8e8"
	                        },
	                        "colorBorder": {
	                            "title": "Border color",
	                            "type": "string",
	                            "default": "#ccc"
	                        },
	                        "majorTickFont": {
	                            "title": "Major tick font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 20
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": "#ccc"
	                                }
	                            }
	                        },
	                        "animation": {
	                            "title": "Enable animation",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "animationDuration": {
	                            "title": "Animation duration",
	                            "type": "number",
	                            "default": 500
	                        },
	                        "animationRule": {
	                            "title": "Animation rule",
	                            "type": "string",
	                            "default": "cycle"
	                        },
	                        "animationTarget": {
	                            "title": "Animation target",
	                            "type": "string",
	                            "default": "needle"
	                        }
	                    },
	                    "required": []
	                },
	                "form": [{
	                    "key": "majorTicks",
	                    "items": ["majorTicks[]"]
	                }, "minorTicks", "showStrokeTicks", "needleCircleSize", "showBorder", "borderOuterWidth", {
	                    "key": "colorPlate",
	                    "type": "color"
	                }, {
	                    "key": "colorMajorTicks",
	                    "type": "color"
	                }, {
	                    "key": "colorMinorTicks",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedle",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedleCircle",
	                    "type": "color"
	                }, {
	                    "key": "colorBorder",
	                    "type": "color"
	                }, {
	                    "key": "majorTickFont",
	                    "items": ["majorTickFont.family", "majorTickFont.size", {
	                        "key": "majorTickFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "majorTickFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "majorTickFont.color",
	                        "type": "color"
	                    }]
	                }, "animation", "animationDuration", {
	                    "key": "animationRule",
	                    "type": "rc-select",
	                    "multiple": false,
	                    "items": [{
	                        "value": "linear",
	                        "label": "Linear"
	                    }, {
	                        "value": "quad",
	                        "label": "Quad"
	                    }, {
	                        "value": "quint",
	                        "label": "Quint"
	                    }, {
	                        "value": "cycle",
	                        "label": "Cycle"
	                    }, {
	                        "value": "bounce",
	                        "label": "Bounce"
	                    }, {
	                        "value": "elastic",
	                        "label": "Elastic"
	                    }, {
	                        "value": "dequad",
	                        "label": "Dequad"
	                    }, {
	                        "value": "dequint",
	                        "label": "Dequint"
	                    }, {
	                        "value": "decycle",
	                        "label": "Decycle"
	                    }, {
	                        "value": "debounce",
	                        "label": "Debounce"
	                    }, {
	                        "value": "delastic",
	                        "label": "Delastic"
	                    }]
	                }, {
	                    "key": "animationTarget",
	                    "type": "rc-select",
	                    "multiple": false,
	                    "items": [{
	                        "value": "needle",
	                        "label": "Needle"
	                    }, {
	                        "value": "plate",
	                        "label": "Plate"
	                    }]
	                }]
	            };
	        }
	    }]);
	
	    return TbAnalogueCompass;
	}();
	
	/* eslint-enable angular/angularelement */
	
	
	exports.default = TbAnalogueCompass;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _canvasGauges = __webpack_require__(100);
	
	var _canvasGauges2 = _interopRequireDefault(_canvasGauges);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable angular/angularelement */
	var TbAnalogueLinearGauge = function () {
	    function TbAnalogueLinearGauge(ctx, canvasId) {
	        _classCallCheck(this, TbAnalogueLinearGauge);
	
	        this.ctx = ctx;
	
	        _canvasGauges2.default.performance = window.performance; // eslint-disable-line no-undef, angular/window-service
	
	        var gaugeElement = (0, _jquery2.default)('#' + canvasId, ctx.$container);
	
	        var settings = ctx.settings;
	
	        var minValue = settings.minValue || 0;
	        var maxValue = settings.maxValue || 100;
	
	        var dataKey = ctx.data[0].dataKey;
	        var keyColor = settings.defaultColor || dataKey.color;
	
	        var majorTicksCount = settings.majorTicksCount || 10;
	        var total = maxValue - minValue;
	        var step = total / majorTicksCount;
	
	        var valueInt = settings.valueInt || 3;
	
	        var valueDec = getValueDec(settings);
	
	        step = parseFloat(parseFloat(step).toFixed(valueDec));
	
	        var majorTicks = [];
	        var highlights = [];
	        var tick = minValue;
	
	        while (tick <= maxValue) {
	            majorTicks.push(tick);
	            var nextTick = tick + step;
	            nextTick = parseFloat(parseFloat(nextTick).toFixed(valueDec));
	            if (tick < maxValue) {
	                var highlightColor = (0, _tinycolor2.default)(keyColor);
	                var percent = (tick - minValue) / total;
	                highlightColor.setAlpha(percent);
	                var highlight = {
	                    from: tick,
	                    to: nextTick,
	                    color: highlightColor.toRgbString()
	                };
	                highlights.push(highlight);
	            }
	            tick = nextTick;
	        }
	
	        var colorNumbers = (0, _tinycolor2.default)(keyColor).darken(20).toRgbString();
	        var barStrokeColor = (0, _tinycolor2.default)(keyColor).darken().setAlpha(0.6).toRgbString();
	
	        var progressColorStart = (0, _tinycolor2.default)(keyColor).setAlpha(0.05).toRgbString();
	        var progressColorEnd = (0, _tinycolor2.default)(keyColor).darken().toRgbString();
	
	        function getUnits(settings) {
	            var dataKey;
	            if (ctx.data && ctx.data[0]) {
	                dataKey = ctx.data[0].dataKey;
	            }
	            if (dataKey && dataKey.units && dataKey.units.length) {
	                return dataKey.units;
	            } else {
	                return angular.isDefined(settings.units) && settings.units.length > 0 ? settings.units : ctx.units;
	            }
	        }
	
	        function getValueDec(settings) {
	            var dataKey;
	            if (ctx.data && ctx.data[0]) {
	                dataKey = ctx.data[0].dataKey;
	            }
	            if (dataKey && angular.isDefined(dataKey.decimals)) {
	                return dataKey.decimals;
	            } else {
	                return angular.isDefined(settings.valueDec) && settings.valueDec !== null ? settings.valueDec : ctx.decimals;
	            }
	        }
	
	        function getFontFamily(fontSettings) {
	            var family = fontSettings && fontSettings.family ? fontSettings.family : 'Roboto';
	            if (family === 'RobotoDraft') {
	                family = 'Roboto';
	            }
	            return family;
	        }
	
	        var gaugeData = {
	
	            renderTo: gaugeElement[0],
	
	            /* Generic options */
	
	            minValue: minValue,
	            maxValue: maxValue,
	            majorTicks: majorTicks,
	            minorTicks: settings.minorTicks || 2,
	            units: getUnits(settings),
	            title: settings.showUnitTitle !== false ? settings.unitTitle && settings.unitTitle.length > 0 ? settings.unitTitle : dataKey.label : '',
	
	            borders: settings.showBorder === true,
	            borderShadowWidth: settings.showBorder === true ? 3 : 0,
	            borderOuterWidth: settings.showBorder === true ? 3 : 0,
	            borderMiddleWidth: settings.showBorder === true ? 3 : 0,
	            borderInnerWidth: settings.showBorder === true ? 3 : 0,
	
	            // borders
	
	            // number formats
	            valueInt: valueInt,
	            valueDec: valueDec,
	            majorTicksInt: 1,
	            majorTicksDec: 0,
	
	            valueBox: settings.valueBox !== false,
	            valueBoxStroke: 5,
	            valueBoxWidth: 0,
	            valueText: '',
	            valueTextShadow: true,
	            valueBoxBorderRadius: 2.5,
	
	            //highlights
	            highlights: settings.highlights && settings.highlights.length > 0 ? settings.highlights : highlights,
	            highlightsWidth: angular.isDefined(settings.highlightsWidth) && settings.highlightsWidth !== null ? settings.highlightsWidth : 10,
	
	            //fonts
	            fontNumbers: getFontFamily(settings.numbersFont),
	            fontTitle: getFontFamily(settings.titleFont),
	            fontUnits: getFontFamily(settings.unitsFont),
	            fontValue: getFontFamily(settings.valueFont),
	
	            fontNumbersSize: settings.numbersFont && settings.numbersFont.size ? settings.numbersFont.size : 18,
	            fontTitleSize: settings.titleFont && settings.titleFont.size ? settings.titleFont.size : 24,
	            fontUnitsSize: settings.unitsFont && settings.unitsFont.size ? settings.unitsFont.size : 22,
	            fontValueSize: settings.valueFont && settings.valueFont.size ? settings.valueFont.size : 40,
	
	            fontNumbersStyle: settings.numbersFont && settings.numbersFont.style ? settings.numbersFont.style : 'normal',
	            fontTitleStyle: settings.titleFont && settings.titleFont.style ? settings.titleFont.style : 'normal',
	            fontUnitsStyle: settings.unitsFont && settings.unitsFont.style ? settings.unitsFont.style : 'normal',
	            fontValueStyle: settings.valueFont && settings.valueFont.style ? settings.valueFont.style : 'normal',
	
	            fontNumbersWeight: settings.numbersFont && settings.numbersFont.weight ? settings.numbersFont.weight : '500',
	            fontTitleWeight: settings.titleFont && settings.titleFont.weight ? settings.titleFont.weight : '500',
	            fontUnitsWeight: settings.unitsFont && settings.unitsFont.weight ? settings.unitsFont.weight : '500',
	            fontValueWeight: settings.valueFont && settings.valueFont.weight ? settings.valueFont.weight : '500',
	
	            colorNumbers: settings.numbersFont && settings.numbersFont.color ? settings.numbersFont.color : colorNumbers,
	            colorTitle: settings.titleFont && settings.titleFont.color ? settings.titleFont.color : '#888',
	            colorUnits: settings.unitsFont && settings.unitsFont.color ? settings.unitsFont.color : '#888',
	            colorValueText: settings.valueFont && settings.valueFont.color ? settings.valueFont.color : '#444',
	            colorValueTextShadow: settings.valueFont && settings.valueFont.shadowColor ? settings.valueFont.shadowColor : 'rgba(0,0,0,0.3)',
	
	            //colors
	            colorPlate: settings.colorPlate || '#fff',
	            colorMajorTicks: settings.colorMajorTicks || '#444',
	            colorMinorTicks: settings.colorMinorTicks || '#666',
	            colorNeedle: settings.colorNeedle || keyColor,
	            colorNeedleEnd: settings.colorNeedleEnd || keyColor,
	
	            colorValueBoxRect: settings.colorValueBoxRect || '#888',
	            colorValueBoxRectEnd: settings.colorValueBoxRectEnd || '#666',
	            colorValueBoxBackground: settings.colorValueBoxBackground || '#babab2',
	            colorValueBoxShadow: settings.colorValueBoxShadow || 'rgba(0,0,0,1)',
	            colorNeedleShadowUp: settings.colorNeedleShadowUp || 'rgba(2,255,255,0.2)',
	            colorNeedleShadowDown: settings.colorNeedleShadowDown || 'rgba(188,143,143,0.45)',
	
	            // animations
	            animation: settings.animation !== false && !ctx.isMobile,
	            animationDuration: angular.isDefined(settings.animationDuration) && settings.animationDuration !== null ? settings.animationDuration : 500,
	            animationRule: settings.animationRule || 'cycle',
	
	            /* Linear gauge specific */
	
	            barStrokeWidth: angular.isDefined(settings.barStrokeWidth) && settings.barStrokeWidth !== null ? settings.barStrokeWidth : 2.5,
	            colorBarStroke: settings.colorBarStroke || barStrokeColor,
	            colorBar: settings.colorBar || "#fff",
	            colorBarEnd: settings.colorBarEnd || "#ddd",
	            colorBarProgress: settings.colorBarProgress || progressColorStart,
	            colorBarProgressEnd: settings.colorBarProgressEnd || progressColorEnd
	        };
	        this.gauge = new _canvasGauges2.default.LinearGauge(gaugeData).draw();
	    }
	
	    _createClass(TbAnalogueLinearGauge, [{
	        key: 'update',
	        value: function update() {
	            if (this.ctx.data.length > 0) {
	                var cellData = this.ctx.data[0];
	                if (cellData.data.length > 0) {
	                    var tvPair = cellData.data[cellData.data.length - 1];
	                    var value = tvPair[1];
	                    if (value !== this.gauge.value) {
	                        this.gauge.value = value;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'mobileModeChanged',
	        value: function mobileModeChanged() {
	            var animation = this.ctx.settings.animation !== false && !this.ctx.isMobile;
	            this.gauge.update({ animation: animation });
	        }
	    }, {
	        key: 'resize',
	        value: function resize() {
	            this.gauge.update({ width: this.ctx.width, height: this.ctx.height });
	        }
	    }], [{
	        key: 'settingsSchema',
	        get: function get() {
	            return {
	                "schema": {
	                    "type": "object",
	                    "title": "Settings",
	                    "properties": {
	                        "minValue": {
	                            "title": "Minimum value",
	                            "type": "number",
	                            "default": 0
	                        },
	                        "maxValue": {
	                            "title": "Maximum value",
	                            "type": "number",
	                            "default": 100
	                        },
	                        "unitTitle": {
	                            "title": "Unit title",
	                            "type": "string",
	                            "default": null
	                        },
	                        "showUnitTitle": {
	                            "title": "Show unit title",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "majorTicksCount": {
	                            "title": "Major ticks count",
	                            "type": "number",
	                            "default": null
	                        },
	                        "minorTicks": {
	                            "title": "Minor ticks count",
	                            "type": "number",
	                            "default": 2
	                        },
	                        "valueBox": {
	                            "title": "Show value box",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "valueInt": {
	                            "title": "Digits count for integer part of value",
	                            "type": "number",
	                            "default": 3
	                        },
	                        "defaultColor": {
	                            "title": "Default color",
	                            "type": "string",
	                            "default": null
	                        },
	                        "colorPlate": {
	                            "title": "Plate color",
	                            "type": "string",
	                            "default": "#fff"
	                        },
	                        "colorMajorTicks": {
	                            "title": "Major ticks color",
	                            "type": "string",
	                            "default": "#444"
	                        },
	                        "colorMinorTicks": {
	                            "title": "Minor ticks color",
	                            "type": "string",
	                            "default": "#666"
	                        },
	                        "colorNeedle": {
	                            "title": "Needle color",
	                            "type": "string",
	                            "default": null
	                        },
	                        "colorNeedleEnd": {
	                            "title": "Needle color - end gradient",
	                            "type": "string",
	                            "default": null
	                        },
	                        "colorNeedleShadowUp": {
	                            "title": "Upper half of the needle shadow color",
	                            "type": "string",
	                            "default": "rgba(2,255,255,0.2)"
	                        },
	                        "colorNeedleShadowDown": {
	                            "title": "Drop shadow needle color.",
	                            "type": "string",
	                            "default": "rgba(188,143,143,0.45)"
	                        },
	                        "colorValueBoxRect": {
	                            "title": "Value box rectangle stroke color",
	                            "type": "string",
	                            "default": "#888"
	                        },
	                        "colorValueBoxRectEnd": {
	                            "title": "Value box rectangle stroke color - end gradient",
	                            "type": "string",
	                            "default": "#666"
	                        },
	                        "colorValueBoxBackground": {
	                            "title": "Value box background color",
	                            "type": "string",
	                            "default": "#babab2"
	                        },
	                        "colorValueBoxShadow": {
	                            "title": "Value box shadow color",
	                            "type": "string",
	                            "default": "rgba(0,0,0,1)"
	                        },
	                        "highlights": {
	                            "title": "Highlights",
	                            "type": "array",
	                            "items": {
	                                "title": "Highlight",
	                                "type": "object",
	                                "properties": {
	                                    "from": {
	                                        "title": "From",
	                                        "type": "number"
	                                    },
	                                    "to": {
	                                        "title": "To",
	                                        "type": "number"
	                                    },
	                                    "color": {
	                                        "title": "Color",
	                                        "type": "string"
	                                    }
	                                }
	                            }
	                        },
	                        "highlightsWidth": {
	                            "title": "Highlights width",
	                            "type": "number",
	                            "default": 15
	                        },
	                        "showBorder": {
	                            "title": "Show border",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "numbersFont": {
	                            "title": "Tick numbers font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 18
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": null
	                                }
	                            }
	                        },
	                        "titleFont": {
	                            "title": "Title text font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 24
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": "#888"
	                                }
	                            }
	                        },
	                        "unitsFont": {
	                            "title": "Units text font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 22
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": "#888"
	                                }
	                            }
	                        },
	                        "valueFont": {
	                            "title": "Value text font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 40
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": "#444"
	                                },
	                                "shadowColor": {
	                                    "title": "Shadow color",
	                                    "type": "string",
	                                    "default": "rgba(0,0,0,0.3)"
	                                }
	                            }
	                        },
	                        "animation": {
	                            "title": "Enable animation",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "animationDuration": {
	                            "title": "Animation duration",
	                            "type": "number",
	                            "default": 500
	                        },
	                        "animationRule": {
	                            "title": "Animation rule",
	                            "type": "string",
	                            "default": "cycle"
	                        },
	                        "barStrokeWidth": {
	                            "title": "Bar stroke width",
	                            "type": "number",
	                            "default": 2.5
	                        },
	                        "colorBarStroke": {
	                            "title": "Bar stroke color",
	                            "type": "string",
	                            "default": null
	                        },
	                        "colorBar": {
	                            "title": "Bar background color",
	                            "type": "string",
	                            "default": "#fff"
	                        },
	                        "colorBarEnd": {
	                            "title": "Bar background color - end gradient",
	                            "type": "string",
	                            "default": "#ddd"
	                        },
	                        "colorBarProgress": {
	                            "title": "Progress bar color",
	                            "type": "string",
	                            "default": null
	                        },
	                        "colorBarProgressEnd": {
	                            "title": "Progress bar color - end gradient",
	                            "type": "string",
	                            "default": null
	                        }
	
	                    },
	                    "required": []
	                },
	                "form": ["barStrokeWidth", {
	                    "key": "colorBarStroke",
	                    "type": "color"
	                }, {
	                    "key": "colorBar",
	                    "type": "color"
	                }, {
	                    "key": "colorBarEnd",
	                    "type": "color"
	                }, {
	                    "key": "colorBarProgress",
	                    "type": "color"
	                }, {
	                    "key": "colorBarProgressEnd",
	                    "type": "color"
	                }, "minValue", "maxValue", "unitTitle", "showUnitTitle", "majorTicksCount", "minorTicks", "valueBox", "valueInt", {
	                    "key": "defaultColor",
	                    "type": "color"
	                }, {
	                    "key": "colorPlate",
	                    "type": "color"
	                }, {
	                    "key": "colorMajorTicks",
	                    "type": "color"
	                }, {
	                    "key": "colorMinorTicks",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedle",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedleEnd",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedleShadowUp",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedleShadowDown",
	                    "type": "color"
	                }, {
	                    "key": "colorValueBoxRect",
	                    "type": "color"
	                }, {
	                    "key": "colorValueBoxRectEnd",
	                    "type": "color"
	                }, {
	                    "key": "colorValueBoxBackground",
	                    "type": "color"
	                }, {
	                    "key": "colorValueBoxShadow",
	                    "type": "color"
	                }, {
	                    "key": "highlights",
	                    "items": ["highlights[].from", "highlights[].to", {
	                        "key": "highlights[].color",
	                        "type": "color"
	                    }]
	                }, "highlightsWidth", "showBorder", {
	                    "key": "numbersFont",
	                    "items": ["numbersFont.family", "numbersFont.size", {
	                        "key": "numbersFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "numbersFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "numbersFont.color",
	                        "type": "color"
	                    }]
	                }, {
	                    "key": "titleFont",
	                    "items": ["titleFont.family", "titleFont.size", {
	                        "key": "titleFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "titleFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "titleFont.color",
	                        "type": "color"
	                    }]
	                }, {
	                    "key": "unitsFont",
	                    "items": ["unitsFont.family", "unitsFont.size", {
	                        "key": "unitsFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "unitsFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "unitsFont.color",
	                        "type": "color"
	                    }]
	                }, {
	                    "key": "valueFont",
	                    "items": ["valueFont.family", "valueFont.size", {
	                        "key": "valueFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "valueFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "valueFont.color",
	                        "type": "color"
	                    }, {
	                        "key": "valueFont.shadowColor",
	                        "type": "color"
	                    }]
	                }, "animation", "animationDuration", {
	                    "key": "animationRule",
	                    "type": "rc-select",
	                    "multiple": false,
	                    "items": [{
	                        "value": "linear",
	                        "label": "Linear"
	                    }, {
	                        "value": "quad",
	                        "label": "Quad"
	                    }, {
	                        "value": "quint",
	                        "label": "Quint"
	                    }, {
	                        "value": "cycle",
	                        "label": "Cycle"
	                    }, {
	                        "value": "bounce",
	                        "label": "Bounce"
	                    }, {
	                        "value": "elastic",
	                        "label": "Elastic"
	                    }, {
	                        "value": "dequad",
	                        "label": "Dequad"
	                    }, {
	                        "value": "dequint",
	                        "label": "Dequint"
	                    }, {
	                        "value": "decycle",
	                        "label": "Decycle"
	                    }, {
	                        "value": "debounce",
	                        "label": "Debounce"
	                    }, {
	                        "value": "delastic",
	                        "label": "Delastic"
	                    }]
	                }]
	            };
	        }
	    }]);
	
	    return TbAnalogueLinearGauge;
	}();
	
	/* eslint-enable angular/angularelement */
	
	
	exports.default = TbAnalogueLinearGauge;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _canvasGauges = __webpack_require__(100);
	
	var _canvasGauges2 = _interopRequireDefault(_canvasGauges);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable angular/angularelement */
	
	var TbAnalogueRadialGauge = function () {
	    function TbAnalogueRadialGauge(ctx, canvasId) {
	        _classCallCheck(this, TbAnalogueRadialGauge);
	
	        this.ctx = ctx;
	
	        _canvasGauges2.default.performance = window.performance; // eslint-disable-line no-undef, angular/window-service
	
	        var gaugeElement = (0, _jquery2.default)('#' + canvasId, ctx.$container);
	
	        var settings = ctx.settings;
	
	        var minValue = settings.minValue || 0;
	        var maxValue = settings.maxValue || 100;
	
	        var dataKey = ctx.data[0].dataKey;
	        var keyColor = settings.defaultColor || dataKey.color;
	
	        var majorTicksCount = settings.majorTicksCount || 10;
	        var total = maxValue - minValue;
	        var step = total / majorTicksCount;
	
	        var valueInt = settings.valueInt || 3;
	
	        var valueDec = getValueDec(settings);
	
	        step = parseFloat(parseFloat(step).toFixed(valueDec));
	
	        var majorTicks = [];
	        var highlights = [];
	        var tick = minValue;
	
	        while (tick <= maxValue) {
	            majorTicks.push(tick);
	            var nextTick = tick + step;
	            nextTick = parseFloat(parseFloat(nextTick).toFixed(valueDec));
	            if (tick < maxValue) {
	                var highlightColor = (0, _tinycolor2.default)(keyColor);
	                var percent = (tick - minValue) / total;
	                highlightColor.setAlpha(percent);
	                var highlight = {
	                    from: tick,
	                    to: nextTick,
	                    color: highlightColor.toRgbString()
	                };
	                highlights.push(highlight);
	            }
	            tick = nextTick;
	        }
	
	        var colorNumbers = (0, _tinycolor2.default)(keyColor).darken(20).toRgbString();
	
	        function getUnits(settings) {
	            var dataKey;
	            if (ctx.data && ctx.data[0]) {
	                dataKey = ctx.data[0].dataKey;
	            }
	            if (dataKey && dataKey.units && dataKey.units.length) {
	                return dataKey.units;
	            } else {
	                return angular.isDefined(settings.units) && settings.units.length > 0 ? settings.units : ctx.units;
	            }
	        }
	
	        function getValueDec(settings) {
	            var dataKey;
	            if (ctx.data && ctx.data[0]) {
	                dataKey = ctx.data[0].dataKey;
	            }
	            if (dataKey && angular.isDefined(dataKey.decimals)) {
	                return dataKey.decimals;
	            } else {
	                return angular.isDefined(settings.valueDec) && settings.valueDec !== null ? settings.valueDec : ctx.decimals;
	            }
	        }
	
	        function getFontFamily(fontSettings) {
	            var family = fontSettings && fontSettings.family ? fontSettings.family : 'Roboto';
	            if (family === 'RobotoDraft') {
	                family = 'Roboto';
	            }
	            return family;
	        }
	
	        var gaugeData = {
	
	            renderTo: gaugeElement[0],
	
	            /* Generic options */
	
	            minValue: minValue,
	            maxValue: maxValue,
	            majorTicks: majorTicks,
	            minorTicks: settings.minorTicks || 2,
	            units: getUnits(settings),
	            title: settings.showUnitTitle !== false ? settings.unitTitle && settings.unitTitle.length > 0 ? settings.unitTitle : dataKey.label : '',
	
	            borders: settings.showBorder !== false,
	            borderShadowWidth: settings.showBorder !== false ? 3 : 0,
	
	            // borders
	            //borderOuterWidth: (settings.showBorder !== false) ? 3 : 0,
	            //borderMiddleWidth: (settings.showBorder !== false) ? 3 : 0,
	            //borderInnerWidth: (settings.showBorder !== false) ? 3 : 0,
	            //borderShadowWidth: (settings.showBorder !== false) ? 3 : 0,
	
	            // number formats
	            valueInt: valueInt,
	            valueDec: valueDec,
	            majorTicksInt: 1,
	            majorTicksDec: 0,
	
	            valueBox: settings.valueBox !== false,
	            valueBoxStroke: 5,
	            valueBoxWidth: 0,
	            valueText: '',
	            valueTextShadow: true,
	            valueBoxBorderRadius: 2.5,
	
	            //highlights
	            highlights: settings.highlights && settings.highlights.length > 0 ? settings.highlights : highlights,
	            highlightsWidth: angular.isDefined(settings.highlightsWidth) && settings.highlightsWidth !== null ? settings.highlightsWidth : 15,
	
	            //fonts
	            fontNumbers: getFontFamily(settings.numbersFont),
	            fontTitle: getFontFamily(settings.titleFont),
	            fontUnits: getFontFamily(settings.unitsFont),
	            fontValue: getFontFamily(settings.valueFont),
	
	            fontNumbersSize: settings.numbersFont && settings.numbersFont.size ? settings.numbersFont.size : 18,
	            fontTitleSize: settings.titleFont && settings.titleFont.size ? settings.titleFont.size : 24,
	            fontUnitsSize: settings.unitsFont && settings.unitsFont.size ? settings.unitsFont.size : 22,
	            fontValueSize: settings.valueFont && settings.valueFont.size ? settings.valueFont.size : 40,
	
	            fontNumbersStyle: settings.numbersFont && settings.numbersFont.style ? settings.numbersFont.style : 'normal',
	            fontTitleStyle: settings.titleFont && settings.titleFont.style ? settings.titleFont.style : 'normal',
	            fontUnitsStyle: settings.unitsFont && settings.unitsFont.style ? settings.unitsFont.style : 'normal',
	            fontValueStyle: settings.valueFont && settings.valueFont.style ? settings.valueFont.style : 'normal',
	
	            fontNumbersWeight: settings.numbersFont && settings.numbersFont.weight ? settings.numbersFont.weight : '500',
	            fontTitleWeight: settings.titleFont && settings.titleFont.weight ? settings.titleFont.weight : '500',
	            fontUnitsWeight: settings.unitsFont && settings.unitsFont.weight ? settings.unitsFont.weight : '500',
	            fontValueWeight: settings.valueFont && settings.valueFont.weight ? settings.valueFont.weight : '500',
	
	            colorNumbers: settings.numbersFont && settings.numbersFont.color ? settings.numbersFont.color : colorNumbers,
	            colorTitle: settings.titleFont && settings.titleFont.color ? settings.titleFont.color : '#888',
	            colorUnits: settings.unitsFont && settings.unitsFont.color ? settings.unitsFont.color : '#888',
	            colorValueText: settings.valueFont && settings.valueFont.color ? settings.valueFont.color : '#444',
	            colorValueTextShadow: settings.valueFont && settings.valueFont.shadowColor ? settings.valueFont.shadowColor : 'rgba(0,0,0,0.3)',
	
	            //colors
	            colorPlate: settings.colorPlate || '#fff',
	            colorMajorTicks: settings.colorMajorTicks || '#444',
	            colorMinorTicks: settings.colorMinorTicks || '#666',
	            colorNeedle: settings.colorNeedle || keyColor,
	            colorNeedleEnd: settings.colorNeedleEnd || keyColor,
	
	            colorValueBoxRect: settings.colorValueBoxRect || '#888',
	            colorValueBoxRectEnd: settings.colorValueBoxRectEnd || '#666',
	            colorValueBoxBackground: settings.colorValueBoxBackground || '#babab2',
	            colorValueBoxShadow: settings.colorValueBoxShadow || 'rgba(0,0,0,1)',
	            colorNeedleShadowUp: settings.colorNeedleShadowUp || 'rgba(2,255,255,0.2)',
	            colorNeedleShadowDown: settings.colorNeedleShadowDown || 'rgba(188,143,143,0.45)',
	
	            // animations
	            animation: settings.animation !== false && !ctx.isMobile,
	            animationDuration: angular.isDefined(settings.animationDuration) && settings.animationDuration !== null ? settings.animationDuration : 500,
	            animationRule: settings.animationRule || 'cycle',
	
	            /* Radial gauge specific */
	
	            ticksAngle: settings.ticksAngle || 270,
	            startAngle: settings.startAngle || 45,
	
	            // colors
	
	            colorNeedleCircleOuter: '#f0f0f0',
	            colorNeedleCircleOuterEnd: '#ccc',
	            colorNeedleCircleInner: '#e8e8e8', //tinycolor(keyColor).lighten(30).toRgbString(),//'#e8e8e8',
	            colorNeedleCircleInnerEnd: '#f5f5f5',
	
	            // needle
	            needleCircleSize: settings.needleCircleSize || 10,
	            needleCircleInner: true,
	            needleCircleOuter: true,
	
	            // custom animations
	            animationTarget: 'needle' // 'needle' or 'plate'
	
	        };
	        this.gauge = new _canvasGauges2.default.RadialGauge(gaugeData).draw();
	    }
	
	    _createClass(TbAnalogueRadialGauge, [{
	        key: 'update',
	        value: function update() {
	            if (this.ctx.data.length > 0) {
	                var cellData = this.ctx.data[0];
	                if (cellData.data.length > 0) {
	                    var tvPair = cellData.data[cellData.data.length - 1];
	                    var value = tvPair[1];
	                    if (value !== this.gauge.value) {
	                        this.gauge.value = value;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'mobileModeChanged',
	        value: function mobileModeChanged() {
	            var animation = this.ctx.settings.animation !== false && !this.ctx.isMobile;
	            this.gauge.update({ animation: animation });
	        }
	    }, {
	        key: 'resize',
	        value: function resize() {
	            this.gauge.update({ width: this.ctx.width, height: this.ctx.height });
	        }
	    }], [{
	        key: 'settingsSchema',
	        get: function get() {
	            return {
	                "schema": {
	                    "type": "object",
	                    "title": "Settings",
	                    "properties": {
	                        "minValue": {
	                            "title": "Minimum value",
	                            "type": "number",
	                            "default": 0
	                        },
	                        "maxValue": {
	                            "title": "Maximum value",
	                            "type": "number",
	                            "default": 100
	                        },
	                        "unitTitle": {
	                            "title": "Unit title",
	                            "type": "string",
	                            "default": null
	                        },
	                        "showUnitTitle": {
	                            "title": "Show unit title",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "majorTicksCount": {
	                            "title": "Major ticks count",
	                            "type": "number",
	                            "default": null
	                        },
	                        "minorTicks": {
	                            "title": "Minor ticks count",
	                            "type": "number",
	                            "default": 2
	                        },
	                        "valueBox": {
	                            "title": "Show value box",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "valueInt": {
	                            "title": "Digits count for integer part of value",
	                            "type": "number",
	                            "default": 3
	                        },
	                        "defaultColor": {
	                            "title": "Default color",
	                            "type": "string",
	                            "default": null
	                        },
	                        "colorPlate": {
	                            "title": "Plate color",
	                            "type": "string",
	                            "default": "#fff"
	                        },
	                        "colorMajorTicks": {
	                            "title": "Major ticks color",
	                            "type": "string",
	                            "default": "#444"
	                        },
	                        "colorMinorTicks": {
	                            "title": "Minor ticks color",
	                            "type": "string",
	                            "default": "#666"
	                        },
	                        "colorNeedle": {
	                            "title": "Needle color",
	                            "type": "string",
	                            "default": null
	                        },
	                        "colorNeedleEnd": {
	                            "title": "Needle color - end gradient",
	                            "type": "string",
	                            "default": null
	                        },
	                        "colorNeedleShadowUp": {
	                            "title": "Upper half of the needle shadow color",
	                            "type": "string",
	                            "default": "rgba(2,255,255,0.2)"
	                        },
	                        "colorNeedleShadowDown": {
	                            "title": "Drop shadow needle color.",
	                            "type": "string",
	                            "default": "rgba(188,143,143,0.45)"
	                        },
	                        "colorValueBoxRect": {
	                            "title": "Value box rectangle stroke color",
	                            "type": "string",
	                            "default": "#888"
	                        },
	                        "colorValueBoxRectEnd": {
	                            "title": "Value box rectangle stroke color - end gradient",
	                            "type": "string",
	                            "default": "#666"
	                        },
	                        "colorValueBoxBackground": {
	                            "title": "Value box background color",
	                            "type": "string",
	                            "default": "#babab2"
	                        },
	                        "colorValueBoxShadow": {
	                            "title": "Value box shadow color",
	                            "type": "string",
	                            "default": "rgba(0,0,0,1)"
	                        },
	                        "highlights": {
	                            "title": "Highlights",
	                            "type": "array",
	                            "items": {
	                                "title": "Highlight",
	                                "type": "object",
	                                "properties": {
	                                    "from": {
	                                        "title": "From",
	                                        "type": "number"
	                                    },
	                                    "to": {
	                                        "title": "To",
	                                        "type": "number"
	                                    },
	                                    "color": {
	                                        "title": "Color",
	                                        "type": "string"
	                                    }
	                                }
	                            }
	                        },
	                        "highlightsWidth": {
	                            "title": "Highlights width",
	                            "type": "number",
	                            "default": 15
	                        },
	                        "showBorder": {
	                            "title": "Show border",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "numbersFont": {
	                            "title": "Tick numbers font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 18
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": null
	                                }
	                            }
	                        },
	                        "titleFont": {
	                            "title": "Title text font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 24
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": "#888"
	                                }
	                            }
	                        },
	                        "unitsFont": {
	                            "title": "Units text font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 22
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": "#888"
	                                }
	                            }
	                        },
	                        "valueFont": {
	                            "title": "Value text font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 40
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": "#444"
	                                },
	                                "shadowColor": {
	                                    "title": "Shadow color",
	                                    "type": "string",
	                                    "default": "rgba(0,0,0,0.3)"
	                                }
	                            }
	                        },
	                        "animation": {
	                            "title": "Enable animation",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "animationDuration": {
	                            "title": "Animation duration",
	                            "type": "number",
	                            "default": 500
	                        },
	                        "animationRule": {
	                            "title": "Animation rule",
	                            "type": "string",
	                            "default": "cycle"
	                        },
	                        "startAngle": {
	                            "title": "Start ticks angle",
	                            "type": "number",
	                            "default": 45
	                        },
	                        "ticksAngle": {
	                            "title": "Ticks angle",
	                            "type": "number",
	                            "default": 270
	                        },
	                        "needleCircleSize": {
	                            "title": "Needle circle size",
	                            "type": "number",
	                            "default": 10
	                        }
	                    },
	                    "required": []
	                },
	                "form": ["startAngle", "ticksAngle", "needleCircleSize", "minValue", "maxValue", "unitTitle", "showUnitTitle", "majorTicksCount", "minorTicks", "valueBox", "valueInt", {
	                    "key": "defaultColor",
	                    "type": "color"
	                }, {
	                    "key": "colorPlate",
	                    "type": "color"
	                }, {
	                    "key": "colorMajorTicks",
	                    "type": "color"
	                }, {
	                    "key": "colorMinorTicks",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedle",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedleEnd",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedleShadowUp",
	                    "type": "color"
	                }, {
	                    "key": "colorNeedleShadowDown",
	                    "type": "color"
	                }, {
	                    "key": "colorValueBoxRect",
	                    "type": "color"
	                }, {
	                    "key": "colorValueBoxRectEnd",
	                    "type": "color"
	                }, {
	                    "key": "colorValueBoxBackground",
	                    "type": "color"
	                }, {
	                    "key": "colorValueBoxShadow",
	                    "type": "color"
	                }, {
	                    "key": "highlights",
	                    "items": ["highlights[].from", "highlights[].to", {
	                        "key": "highlights[].color",
	                        "type": "color"
	                    }]
	                }, "highlightsWidth", "showBorder", {
	                    "key": "numbersFont",
	                    "items": ["numbersFont.family", "numbersFont.size", {
	                        "key": "numbersFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "numbersFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "numbersFont.color",
	                        "type": "color"
	                    }]
	                }, {
	                    "key": "titleFont",
	                    "items": ["titleFont.family", "titleFont.size", {
	                        "key": "titleFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "titleFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "titleFont.color",
	                        "type": "color"
	                    }]
	                }, {
	                    "key": "unitsFont",
	                    "items": ["unitsFont.family", "unitsFont.size", {
	                        "key": "unitsFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "unitsFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "unitsFont.color",
	                        "type": "color"
	                    }]
	                }, {
	                    "key": "valueFont",
	                    "items": ["valueFont.family", "valueFont.size", {
	                        "key": "valueFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "valueFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "valueFont.color",
	                        "type": "color"
	                    }, {
	                        "key": "valueFont.shadowColor",
	                        "type": "color"
	                    }]
	                }, "animation", "animationDuration", {
	                    "key": "animationRule",
	                    "type": "rc-select",
	                    "multiple": false,
	                    "items": [{
	                        "value": "linear",
	                        "label": "Linear"
	                    }, {
	                        "value": "quad",
	                        "label": "Quad"
	                    }, {
	                        "value": "quint",
	                        "label": "Quint"
	                    }, {
	                        "value": "cycle",
	                        "label": "Cycle"
	                    }, {
	                        "value": "bounce",
	                        "label": "Bounce"
	                    }, {
	                        "value": "elastic",
	                        "label": "Elastic"
	                    }, {
	                        "value": "dequad",
	                        "label": "Dequad"
	                    }, {
	                        "value": "dequint",
	                        "label": "Dequint"
	                    }, {
	                        "value": "decycle",
	                        "label": "Decycle"
	                    }, {
	                        "value": "debounce",
	                        "label": "Debounce"
	                    }, {
	                        "value": "delastic",
	                        "label": "Delastic"
	                    }]
	                }]
	            };
	        }
	    }]);
	
	    return TbAnalogueRadialGauge;
	}();
	
	/* eslint-enable angular/angularelement */
	
	
	exports.default = TbAnalogueRadialGauge;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _canvasGauges = __webpack_require__(100);
	
	var _canvasGauges2 = _interopRequireDefault(_canvasGauges);
	
	var _CanvasDigitalGauge = __webpack_require__(513);
	
	var _CanvasDigitalGauge2 = _interopRequireDefault(_CanvasDigitalGauge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable angular/angularelement */
	var TbCanvasDigitalGauge = function () {
	    function TbCanvasDigitalGauge(ctx, canvasId) {
	        _classCallCheck(this, TbCanvasDigitalGauge);
	
	        this.ctx = ctx;
	
	        _canvasGauges2.default.performance = window.performance; // eslint-disable-line no-undef, angular/window-service
	
	        var gaugeElement = (0, _jquery2.default)('#' + canvasId, ctx.$container);
	        var settings = ctx.settings;
	
	        this.localSettings = {};
	        this.localSettings.minValue = settings.minValue || 0;
	        this.localSettings.maxValue = settings.maxValue || 100;
	        this.localSettings.gaugeType = settings.gaugeType || 'arc';
	        this.localSettings.neonGlowBrightness = settings.neonGlowBrightness || 0;
	        this.localSettings.dashThickness = settings.dashThickness || 0;
	        this.localSettings.roundedLineCap = settings.roundedLineCap === true;
	
	        var dataKey = ctx.data[0].dataKey;
	        var keyColor = settings.defaultColor || dataKey.color;
	
	        this.localSettings.unitTitle = settings.showUnitTitle === true ? settings.unitTitle && settings.unitTitle.length > 0 ? settings.unitTitle : dataKey.label : '';
	
	        this.localSettings.showTimestamp = settings.showTimestamp == true ? true : false;
	        this.localSettings.timestampFormat = settings.timestampFormat && settings.timestampFormat.length ? settings.timestampFormat : 'yyyy-MM-dd HH:mm:ss';
	
	        this.localSettings.gaugeWidthScale = settings.gaugeWidthScale || 0.75;
	        this.localSettings.gaugeColor = settings.gaugeColor || (0, _tinycolor2.default)(keyColor).setAlpha(0.2).toRgbString();
	
	        if (!settings.levelColors || settings.levelColors.length <= 0) {
	            this.localSettings.levelColors = [keyColor];
	        } else {
	            this.localSettings.levelColors = settings.levelColors.slice();
	        }
	
	        this.localSettings.decimals = angular.isDefined(dataKey.decimals) ? dataKey.decimals : angular.isDefined(settings.decimals) && settings.decimals !== null ? settings.decimals : ctx.decimals;
	
	        this.localSettings.units = dataKey.units && dataKey.units.length ? dataKey.units : angular.isDefined(settings.units) && settings.units.length > 0 ? settings.units : ctx.units;
	
	        this.localSettings.hideValue = settings.showValue !== true;
	        this.localSettings.hideMinMax = settings.showMinMax !== true;
	
	        this.localSettings.title = settings.showTitle === true ? settings.title && settings.title.length > 0 ? settings.title : dataKey.label : '';
	
	        if (!this.localSettings.unitTitle && this.localSettings.showTimestamp) {
	            this.localSettings.unitTitle = ' ';
	        }
	
	        this.localSettings.titleFont = {};
	        var settingsTitleFont = settings.titleFont;
	        if (!settingsTitleFont) {
	            settingsTitleFont = {};
	        }
	
	        function getFontFamily(fontSettings) {
	            var family = fontSettings && fontSettings.family ? fontSettings.family : 'Roboto';
	            if (family === 'RobotoDraft') {
	                family = 'Roboto';
	            }
	            return family;
	        }
	
	        this.localSettings.titleFont.family = getFontFamily(settingsTitleFont);
	        this.localSettings.titleFont.size = settingsTitleFont.size ? settingsTitleFont.size : 12;
	        this.localSettings.titleFont.style = settingsTitleFont.style ? settingsTitleFont.style : 'normal';
	        this.localSettings.titleFont.weight = settingsTitleFont.weight ? settingsTitleFont.weight : '500';
	        this.localSettings.titleFont.color = settingsTitleFont.color ? settingsTitleFont.color : keyColor;
	
	        this.localSettings.valueFont = {};
	        var settingsValueFont = settings.valueFont;
	        if (!settingsValueFont) {
	            settingsValueFont = {};
	        }
	
	        this.localSettings.valueFont.family = getFontFamily(settingsValueFont);
	        this.localSettings.valueFont.size = settingsValueFont.size ? settingsValueFont.size : 18;
	        this.localSettings.valueFont.style = settingsValueFont.style ? settingsValueFont.style : 'normal';
	        this.localSettings.valueFont.weight = settingsValueFont.weight ? settingsValueFont.weight : '500';
	        this.localSettings.valueFont.color = settingsValueFont.color ? settingsValueFont.color : keyColor;
	
	        this.localSettings.minMaxFont = {};
	        var settingsMinMaxFont = settings.minMaxFont;
	        if (!settingsMinMaxFont) {
	            settingsMinMaxFont = {};
	        }
	
	        this.localSettings.minMaxFont.family = getFontFamily(settingsMinMaxFont);
	        this.localSettings.minMaxFont.size = settingsMinMaxFont.size ? settingsMinMaxFont.size : 10;
	        this.localSettings.minMaxFont.style = settingsMinMaxFont.style ? settingsMinMaxFont.style : 'normal';
	        this.localSettings.minMaxFont.weight = settingsMinMaxFont.weight ? settingsMinMaxFont.weight : '500';
	        this.localSettings.minMaxFont.color = settingsMinMaxFont.color ? settingsMinMaxFont.color : keyColor;
	
	        this.localSettings.labelFont = {};
	        var settingsLabelFont = settings.labelFont;
	        if (!settingsLabelFont) {
	            settingsLabelFont = {};
	        }
	
	        this.localSettings.labelFont.family = getFontFamily(settingsLabelFont);
	        this.localSettings.labelFont.size = settingsLabelFont.size ? settingsLabelFont.size : 8;
	        this.localSettings.labelFont.style = settingsLabelFont.style ? settingsLabelFont.style : 'normal';
	        this.localSettings.labelFont.weight = settingsLabelFont.weight ? settingsLabelFont.weight : '500';
	        this.localSettings.labelFont.color = settingsLabelFont.color ? settingsLabelFont.color : keyColor;
	
	        var gaugeData = {
	
	            renderTo: gaugeElement[0],
	
	            gaugeWidthScale: this.localSettings.gaugeWidthScale,
	            gaugeColor: this.localSettings.gaugeColor,
	            levelColors: this.localSettings.levelColors,
	
	            title: this.localSettings.title,
	
	            fontTitleSize: this.localSettings.titleFont.size,
	            fontTitleStyle: this.localSettings.titleFont.style,
	            fontTitleWeight: this.localSettings.titleFont.weight,
	            colorTitle: this.localSettings.titleFont.color,
	            fontTitle: this.localSettings.titleFont.family,
	
	            fontValueSize: this.localSettings.valueFont.size,
	            fontValueStyle: this.localSettings.valueFont.style,
	            fontValueWeight: this.localSettings.valueFont.weight,
	            colorValue: this.localSettings.valueFont.color,
	            fontValue: this.localSettings.valueFont.family,
	
	            fontMinMaxSize: this.localSettings.minMaxFont.size,
	            fontMinMaxStyle: this.localSettings.minMaxFont.style,
	            fontMinMaxWeight: this.localSettings.minMaxFont.weight,
	            colorMinMax: this.localSettings.minMaxFont.color,
	            fontMinMax: this.localSettings.minMaxFont.family,
	
	            fontLabelSize: this.localSettings.labelFont.size,
	            fontLabelStyle: this.localSettings.labelFont.style,
	            fontLabelWeight: this.localSettings.labelFont.weight,
	            colorLabel: this.localSettings.labelFont.color,
	            fontLabel: this.localSettings.labelFont.family,
	
	            minValue: this.localSettings.minValue,
	            maxValue: this.localSettings.maxValue,
	            gaugeType: this.localSettings.gaugeType,
	            dashThickness: this.localSettings.dashThickness,
	            roundedLineCap: this.localSettings.roundedLineCap,
	
	            symbol: this.localSettings.units,
	            label: this.localSettings.unitTitle,
	            showTimestamp: this.localSettings.showTimestamp,
	            hideValue: this.localSettings.hideValue,
	            hideMinMax: this.localSettings.hideMinMax,
	
	            valueDec: this.localSettings.decimals,
	
	            neonGlowBrightness: this.localSettings.neonGlowBrightness,
	
	            // animations
	            animation: settings.animation !== false && !ctx.isMobile,
	            animationDuration: angular.isDefined(settings.animationDuration) && settings.animationDuration !== null ? settings.animationDuration : 500,
	            animationRule: settings.animationRule || 'linear',
	
	            isMobile: ctx.isMobile
	
	        };
	
	        this.gauge = new _CanvasDigitalGauge2.default(gaugeData).draw();
	    }
	
	    _createClass(TbCanvasDigitalGauge, [{
	        key: 'update',
	        value: function update() {
	            if (this.ctx.data.length > 0) {
	                var cellData = this.ctx.data[0];
	                if (cellData.data.length > 0) {
	                    var tvPair = cellData.data[cellData.data.length - 1];
	                    var timestamp;
	                    if (this.localSettings.showTimestamp) {
	                        timestamp = tvPair[0];
	                        var filter = this.ctx.$scope.$injector.get('$filter');
	                        var timestampDisplayValue = filter('date')(timestamp, this.localSettings.timestampFormat);
	                        this.gauge.options.label = timestampDisplayValue;
	                    }
	                    var value = tvPair[1];
	                    if (value !== this.gauge.value) {
	                        this.gauge.value = value;
	                        this.gauge._value = value;
	                    } else if (this.localSettings.showTimestamp && this.gauge.timestamp != timestamp) {
	                        this.gauge.timestamp = timestamp;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'mobileModeChanged',
	        value: function mobileModeChanged() {
	            var animation = this.ctx.settings.animation !== false && !this.ctx.isMobile;
	            this.gauge.update({ animation: animation, isMobile: this.ctx.isMobile });
	        }
	    }, {
	        key: 'resize',
	        value: function resize() {
	            this.gauge.update({ width: this.ctx.width, height: this.ctx.height });
	        }
	    }], [{
	        key: 'settingsSchema',
	        get: function get() {
	            return {
	                "schema": {
	                    "type": "object",
	                    "title": "Settings",
	                    "properties": {
	                        "minValue": {
	                            "title": "Minimum value",
	                            "type": "number",
	                            "default": 0
	                        },
	                        "maxValue": {
	                            "title": "Maximum value",
	                            "type": "number",
	                            "default": 100
	                        },
	                        "gaugeType": {
	                            "title": "Gauge type",
	                            "type": "string",
	                            "default": "arc"
	                        },
	                        "donutStartAngle": {
	                            "title": "Angle to start from when in donut mode",
	                            "type": "number",
	                            "default": 90
	                        },
	                        "neonGlowBrightness": {
	                            "title": "Neon glow effect brightness, (0-100), 0 - disable effect",
	                            "type": "number",
	                            "default": 0
	                        },
	                        "dashThickness": {
	                            "title": "Thickness of the stripes, 0 - no stripes",
	                            "type": "number",
	                            "default": 0
	                        },
	                        "roundedLineCap": {
	                            "title": "Display rounded line cap",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "title": {
	                            "title": "Gauge title",
	                            "type": "string",
	                            "default": null
	                        },
	                        "showTitle": {
	                            "title": "Show gauge title",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "unitTitle": {
	                            "title": "Unit title",
	                            "type": "string",
	                            "default": null
	                        },
	                        "showUnitTitle": {
	                            "title": "Show unit title",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "showTimestamp": {
	                            "title": "Show value timestamp",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "timestampFormat": {
	                            "title": "Timestamp format",
	                            "type": "string",
	                            "default": "yyyy-MM-dd HH:mm:ss"
	                        },
	                        "showValue": {
	                            "title": "Show value text",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "showMinMax": {
	                            "title": "Show min and max values",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "gaugeWidthScale": {
	                            "title": "Width of the gauge element",
	                            "type": "number",
	                            "default": 0.75
	                        },
	                        "defaultColor": {
	                            "title": "Default color",
	                            "type": "string",
	                            "default": null
	                        },
	                        "gaugeColor": {
	                            "title": "Background color of the gauge element",
	                            "type": "string",
	                            "default": null
	                        },
	                        "levelColors": {
	                            "title": "Colors of indicator, from lower to upper",
	                            "type": "array",
	                            "items": {
	                                "title": "Color",
	                                "type": "string"
	                            }
	                        },
	                        "animation": {
	                            "title": "Enable animation",
	                            "type": "boolean",
	                            "default": true
	                        },
	                        "animationDuration": {
	                            "title": "Animation duration",
	                            "type": "number",
	                            "default": 500
	                        },
	                        "animationRule": {
	                            "title": "Animation rule",
	                            "type": "string",
	                            "default": "linear"
	                        },
	                        "titleFont": {
	                            "title": "Gauge title font",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 12
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": null
	                                }
	                            }
	                        },
	                        "labelFont": {
	                            "title": "Font of label showing under value",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 8
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": null
	                                }
	                            }
	                        },
	                        "valueFont": {
	                            "title": "Font of label showing current value",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 18
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": null
	                                }
	                            }
	                        },
	                        "minMaxFont": {
	                            "title": "Font of minimum and maximum labels",
	                            "type": "object",
	                            "properties": {
	                                "family": {
	                                    "title": "Font family",
	                                    "type": "string",
	                                    "default": "Roboto"
	                                },
	                                "size": {
	                                    "title": "Size",
	                                    "type": "number",
	                                    "default": 10
	                                },
	                                "style": {
	                                    "title": "Style",
	                                    "type": "string",
	                                    "default": "normal"
	                                },
	                                "weight": {
	                                    "title": "Weight",
	                                    "type": "string",
	                                    "default": "500"
	                                },
	                                "color": {
	                                    "title": "color",
	                                    "type": "string",
	                                    "default": null
	                                }
	                            }
	                        }
	                    }
	                },
	                "form": ["minValue", "maxValue", {
	                    "key": "gaugeType",
	                    "type": "rc-select",
	                    "multiple": false,
	                    "items": [{
	                        "value": "arc",
	                        "label": "Arc"
	                    }, {
	                        "value": "donut",
	                        "label": "Donut"
	                    }, {
	                        "value": "horizontalBar",
	                        "label": "Horizontal bar"
	                    }, {
	                        "value": "verticalBar",
	                        "label": "Vertical bar"
	                    }]
	                }, "donutStartAngle", "neonGlowBrightness", "dashThickness", "roundedLineCap", "title", "showTitle", "unitTitle", "showUnitTitle", "showTimestamp", "timestampFormat", "showValue", "showMinMax", "gaugeWidthScale", {
	                    "key": "defaultColor",
	                    "type": "color"
	                }, {
	                    "key": "gaugeColor",
	                    "type": "color"
	                }, {
	                    "key": "levelColors",
	                    "items": [{
	                        "key": "levelColors[]",
	                        "type": "color"
	                    }]
	                }, "animation", "animationDuration", {
	                    "key": "animationRule",
	                    "type": "rc-select",
	                    "multiple": false,
	                    "items": [{
	                        "value": "linear",
	                        "label": "Linear"
	                    }, {
	                        "value": "quad",
	                        "label": "Quad"
	                    }, {
	                        "value": "quint",
	                        "label": "Quint"
	                    }, {
	                        "value": "cycle",
	                        "label": "Cycle"
	                    }, {
	                        "value": "bounce",
	                        "label": "Bounce"
	                    }, {
	                        "value": "elastic",
	                        "label": "Elastic"
	                    }, {
	                        "value": "dequad",
	                        "label": "Dequad"
	                    }, {
	                        "value": "dequint",
	                        "label": "Dequint"
	                    }, {
	                        "value": "decycle",
	                        "label": "Decycle"
	                    }, {
	                        "value": "debounce",
	                        "label": "Debounce"
	                    }, {
	                        "value": "delastic",
	                        "label": "Delastic"
	                    }]
	                }, {
	                    "key": "titleFont",
	                    "items": ["titleFont.family", "titleFont.size", {
	                        "key": "titleFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "titleFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "titleFont.color",
	                        "type": "color"
	                    }]
	                }, {
	                    "key": "labelFont",
	                    "items": ["labelFont.family", "labelFont.size", {
	                        "key": "labelFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "labelFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "labelFont.color",
	                        "type": "color"
	                    }]
	                }, {
	                    "key": "valueFont",
	                    "items": ["valueFont.family", "valueFont.size", {
	                        "key": "valueFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "valueFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "valueFont.color",
	                        "type": "color"
	                    }]
	                }, {
	                    "key": "minMaxFont",
	                    "items": ["minMaxFont.family", "minMaxFont.size", {
	                        "key": "minMaxFont.style",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "italic",
	                            "label": "Italic"
	                        }, {
	                            "value": "oblique",
	                            "label": "Oblique"
	                        }]
	                    }, {
	                        "key": "minMaxFont.weight",
	                        "type": "rc-select",
	                        "multiple": false,
	                        "items": [{
	                            "value": "normal",
	                            "label": "Normal"
	                        }, {
	                            "value": "bold",
	                            "label": "Bold"
	                        }, {
	                            "value": "bolder",
	                            "label": "Bolder"
	                        }, {
	                            "value": "lighter",
	                            "label": "Lighter"
	                        }, {
	                            "value": "100",
	                            "label": "100"
	                        }, {
	                            "value": "200",
	                            "label": "200"
	                        }, {
	                            "value": "300",
	                            "label": "300"
	                        }, {
	                            "value": "400",
	                            "label": "400"
	                        }, {
	                            "value": "500",
	                            "label": "500"
	                        }, {
	                            "value": "600",
	                            "label": "600"
	                        }, {
	                            "value": "700",
	                            "label": "800"
	                        }, {
	                            "value": "800",
	                            "label": "800"
	                        }, {
	                            "value": "900",
	                            "label": "900"
	                        }]
	                    }, {
	                        "key": "minMaxFont.color",
	                        "type": "color"
	                    }]
	                }]
	            };
	        }
	    }]);
	
	    return TbCanvasDigitalGauge;
	}();
	/* eslint-enable angular/angularelement */
	
	
	exports.default = TbCanvasDigitalGauge;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EntitiesTableWidgetController.$inject = ["$element", "$scope", "$filter", "$mdMedia", "$mdPanel", "$document", "$translate", "$timeout", "utils", "types"];
	DisplayColumnsPanelController.$inject = ["columns"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(823);
	
	__webpack_require__(311);
	
	var _entitiesTableWidgetTpl = __webpack_require__(1532);
	
	var _entitiesTableWidgetTpl2 = _interopRequireDefault(_entitiesTableWidgetTpl);
	
	var _displayColumnsPanelTpl = __webpack_require__(524);
	
	var _displayColumnsPanelTpl2 = _interopRequireDefault(_displayColumnsPanelTpl);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _css = __webpack_require__(149);
	
	var _css2 = _interopRequireDefault(_css);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.widgets.entitiesTableWidget', []).directive('tbEntitiesTableWidget', EntitiesTableWidget).name;
	
	/*@ngInject*/
	
	//import entityDetailsDialogTemplate from './entitiy-details-dialog.tpl.html';
	
	function EntitiesTableWidget() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            tableId: '=',
	            ctx: '='
	        },
	        controller: EntitiesTableWidgetController,
	        controllerAs: 'vm',
	        templateUrl: _entitiesTableWidgetTpl2.default
	    };
	}
	
	/*@ngInject*/
	function EntitiesTableWidgetController($element, $scope, $filter, $mdMedia, $mdPanel, $document, $translate, $timeout, utils, types) {
	    var vm = this;
	
	    vm.stylesInfo = {};
	    vm.contentsInfo = {};
	    vm.columnWidth = {};
	
	    vm.showData = true;
	    vm.hasData = false;
	
	    vm.entities = [];
	    vm.entitiesCount = 0;
	
	    vm.datasources = null;
	    vm.allEntities = null;
	
	    vm.currentEntity = null;
	
	    vm.displayEntityName = true;
	    vm.entityNameColumnTitle = '';
	    vm.displayEntityType = true;
	    vm.actionCellDescriptors = [];
	    vm.displayPagination = true;
	    vm.defaultPageSize = 10;
	    vm.defaultSortOrder = 'entityName';
	
	    vm.query = {
	        order: vm.defaultSortOrder,
	        limit: vm.defaultPageSize,
	        page: 1,
	        search: null
	    };
	
	    vm.searchAction = {
	        name: 'action.search',
	        show: true,
	        onAction: function onAction() {
	            vm.enterFilterMode();
	        },
	        icon: 'search'
	    };
	
	    vm.enterFilterMode = enterFilterMode;
	    vm.exitFilterMode = exitFilterMode;
	    vm.onReorder = onReorder;
	    vm.onPaginate = onPaginate;
	    vm.onRowClick = onRowClick;
	    vm.onActionButtonClick = onActionButtonClick;
	    vm.isCurrent = isCurrent;
	
	    vm.cellStyle = cellStyle;
	    vm.cellContent = cellContent;
	
	    vm.editColumnsToDisplay = editColumnsToDisplay;
	
	    $scope.$watch('vm.ctx', function () {
	        if (vm.ctx && vm.ctx.defaultSubscription) {
	            vm.settings = vm.ctx.settings;
	            vm.widgetConfig = vm.ctx.widgetConfig;
	            vm.subscription = vm.ctx.defaultSubscription;
	            vm.datasources = vm.subscription.datasources;
	            initializeConfig();
	            updateDatasources();
	            updateEntities();
	        }
	    });
	
	    $scope.$watch("vm.query.search", function (newVal, prevVal) {
	        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
	            updateEntities();
	        }
	    });
	
	    $scope.$on('entities-table-data-updated', function (event, tableId) {
	        if (vm.tableId == tableId) {
	            if (vm.subscription) {
	                updateEntitiesData(vm.subscription.data);
	                updateEntities();
	                $scope.$digest();
	            }
	        }
	    });
	
	    $scope.$watch(function () {
	        return $mdMedia('gt-xs');
	    }, function (isGtXs) {
	        vm.isGtXs = isGtXs;
	    });
	
	    $scope.$watch(function () {
	        return $mdMedia('gt-md');
	    }, function (isGtMd) {
	        vm.isGtMd = isGtMd;
	        if (vm.isGtMd) {
	            vm.limitOptions = [vm.defaultPageSize, vm.defaultPageSize * 2, vm.defaultPageSize * 3];
	        } else {
	            vm.limitOptions = null;
	        }
	    });
	
	    function initializeConfig() {
	
	        vm.ctx.widgetActions = [vm.searchAction];
	
	        vm.actionCellDescriptors = vm.ctx.actionsApi.getActionDescriptors('actionCellButton');
	
	        if (vm.settings.entitiesTitle && vm.settings.entitiesTitle.length) {
	            vm.entitiesTitle = utils.customTranslation(vm.settings.entitiesTitle, vm.settings.entitiesTitle);
	        } else {
	            vm.entitiesTitle = $translate.instant('entity.entities');
	        }
	
	        vm.ctx.widgetTitle = vm.entitiesTitle;
	
	        vm.searchAction.show = angular.isDefined(vm.settings.enableSearch) ? vm.settings.enableSearch : true;
	        vm.displayEntityName = angular.isDefined(vm.settings.displayEntityName) ? vm.settings.displayEntityName : true;
	
	        if (vm.settings.entityNameColumnTitle && vm.settings.entityNameColumnTitle.length) {
	            vm.entityNameColumnTitle = utils.customTranslation(vm.settings.entityNameColumnTitle, vm.settings.entityNameColumnTitle);
	        } else {
	            vm.entityNameColumnTitle = $translate.instant('entity.entity-name');
	        }
	
	        vm.displayEntityType = angular.isDefined(vm.settings.displayEntityType) ? vm.settings.displayEntityType : true;
	        vm.displayPagination = angular.isDefined(vm.settings.displayPagination) ? vm.settings.displayPagination : true;
	
	        var pageSize = vm.settings.defaultPageSize;
	        if (angular.isDefined(pageSize) && angular.isNumber(pageSize) && pageSize > 0) {
	            vm.defaultPageSize = pageSize;
	        }
	
	        if (vm.settings.defaultSortOrder && vm.settings.defaultSortOrder.length) {
	            vm.defaultSortOrder = vm.settings.defaultSortOrder;
	        }
	
	        vm.query.order = vm.defaultSortOrder;
	        vm.query.limit = vm.defaultPageSize;
	        if (vm.isGtMd) {
	            vm.limitOptions = [vm.defaultPageSize, vm.defaultPageSize * 2, vm.defaultPageSize * 3];
	        } else {
	            vm.limitOptions = null;
	        }
	
	        var origColor = vm.widgetConfig.color || 'rgba(0, 0, 0, 0.87)';
	        var defaultColor = (0, _tinycolor2.default)(origColor);
	        var mdDark = defaultColor.setAlpha(0.87).toRgbString();
	        var mdDarkSecondary = defaultColor.setAlpha(0.54).toRgbString();
	        var mdDarkDisabled = defaultColor.setAlpha(0.26).toRgbString();
	        //var mdDarkIcon = mdDarkSecondary;
	        var mdDarkDivider = defaultColor.setAlpha(0.12).toRgbString();
	
	        //md-icon.md-default-theme, md-icon {
	
	        var cssString = 'table.md-table th.md-column {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + 'table.md-table th.md-column.md-checkbox-column md-checkbox:not(.md-checked) .md-icon {\n' + 'border-color: ' + mdDarkSecondary + ';\n' + '}\n' + 'table.md-table th.md-column md-icon.md-sort-icon {\n' + 'color: ' + mdDarkDisabled + ';\n' + '}\n' + 'table.md-table th.md-column.md-active, table.md-table th.md-column.md-active md-icon {\n' + 'color: ' + mdDark + ';\n' + '}\n' + 'table.md-table td.md-cell {\n' + 'color: ' + mdDark + ';\n' + 'border-top: 1px ' + mdDarkDivider + ' solid;\n' + '}\n' + 'table.md-table td.md-cell.md-checkbox-cell md-checkbox:not(.md-checked) .md-icon {\n' + 'border-color: ' + mdDarkSecondary + ';\n' + '}\n' + 'table.md-table td.md-cell.tb-action-cell button.md-icon-button md-icon {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + 'table.md-table td.md-cell.md-placeholder {\n' + 'color: ' + mdDarkDisabled + ';\n' + '}\n' + 'table.md-table td.md-cell md-select > .md-select-value > span.md-select-icon {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + '.md-table-pagination {\n' + 'color: ' + mdDarkSecondary + ';\n' + 'border-top: 1px ' + mdDarkDivider + ' solid;\n' + '}\n' + '.md-table-pagination .buttons md-icon {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + '.md-table-pagination md-select:not([disabled]):focus .md-select-value {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}';
	
	        var cssParser = new _css2.default();
	        cssParser.testMode = false;
	        var namespace = 'entities-table-' + hashCode(cssString);
	        cssParser.cssPreviewNamespace = namespace;
	        cssParser.createStyleElement(namespace, cssString);
	        $element.addClass(namespace);
	
	        function hashCode(str) {
	            var hash = 0;
	            var i, char;
	            if (str.length === 0) return hash;
	            for (i = 0; i < str.length; i++) {
	                char = str.charCodeAt(i);
	                hash = (hash << 5) - hash + char;
	                hash = hash & hash;
	            }
	            return hash;
	        }
	    }
	
	    function enterFilterMode() {
	        vm.query.search = '';
	        vm.ctx.hideTitlePanel = true;
	        $timeout(function () {
	            angular.element(vm.ctx.$container).find('.searchInput').focus();
	        });
	    }
	
	    function exitFilterMode() {
	        vm.query.search = null;
	        updateEntities();
	        vm.ctx.hideTitlePanel = false;
	    }
	
	    function onReorder() {
	        updateEntities();
	    }
	
	    function onPaginate() {
	        updateEntities();
	    }
	
	    function onRowClick($event, entity) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        if (vm.currentEntity != entity) {
	            vm.currentEntity = entity;
	        }
	        var descriptors = vm.ctx.actionsApi.getActionDescriptors('rowClick');
	        if (descriptors.length) {
	            var entityId;
	            var entityName;
	            if (vm.currentEntity) {
	                entityId = vm.currentEntity.id;
	                entityName = vm.currentEntity.entityName;
	            }
	            vm.ctx.actionsApi.handleWidgetAction($event, descriptors[0], entityId, entityName);
	        }
	    }
	
	    function onActionButtonClick($event, entity, actionDescriptor) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        var entityId;
	        var entityName;
	        if (entity) {
	            entityId = entity.id;
	            entityName = entity.entityName;
	        }
	        vm.ctx.actionsApi.handleWidgetAction($event, actionDescriptor, entityId, entityName);
	    }
	
	    function isCurrent(entity) {
	        return vm.currentEntity && entity && vm.currentEntity.id && entity.id && vm.currentEntity.id.id === entity.id.id;
	    }
	
	    function updateEntities() {
	        var result = $filter('orderBy')(vm.allEntities, vm.query.order);
	        if (vm.query.search != null) {
	            result = $filter('filter')(result, { $: vm.query.search });
	        }
	        vm.entitiesCount = result.length;
	
	        if (vm.displayPagination) {
	            var startIndex = vm.query.limit * (vm.query.page - 1);
	            vm.entities = result.slice(startIndex, startIndex + vm.query.limit);
	        } else {
	            vm.entities = result;
	        }
	    }
	
	    function cellStyle(entity, key) {
	        var style = {};
	        if (entity && key) {
	            var styleInfo = vm.stylesInfo[key.label];
	            var value = getEntityValue(entity, key);
	            if (styleInfo.useCellStyleFunction && styleInfo.cellStyleFunction) {
	                try {
	                    style = styleInfo.cellStyleFunction(value);
	                } catch (e) {
	                    style = {};
	                }
	            } else {
	                style = defaultStyle(key, value);
	            }
	        }
	        if (!style.width) {
	            var columnWidth = vm.columnWidth[key.label];
	            if (columnWidth !== "0px") {
	                style.width = columnWidth;
	            } else {
	                style.width = "auto";
	            }
	        }
	        return style;
	    }
	
	    function cellContent(entity, key) {
	        var strContent = '';
	        if (entity && key) {
	            var contentInfo = vm.contentsInfo[key.label];
	            var value = getEntityValue(entity, key);
	            if (contentInfo.useCellContentFunction && contentInfo.cellContentFunction) {
	                if (angular.isDefined(value)) {
	                    strContent = '' + value;
	                }
	                var content = strContent;
	                try {
	                    content = contentInfo.cellContentFunction(value, entity, $filter);
	                } catch (e) {
	                    content = strContent;
	                }
	            } else {
	                var decimals = contentInfo.decimals || contentInfo.decimals === 0 ? contentInfo.decimals : vm.widgetConfig.decimals;
	                var units = contentInfo.units || vm.widgetConfig.units;
	                content = vm.ctx.utils.formatValue(value, decimals, units, true);
	            }
	            return content;
	        } else {
	            return strContent;
	        }
	    }
	
	    function defaultStyle() /*key, value*/{
	        return {};
	    }
	
	    var getDescendantProp = function getDescendantProp(obj, path) {
	        return path.split('.').reduce(function (acc, part) {
	            return acc && acc[part];
	        }, obj);
	    };
	
	    function getEntityValue(entity, key) {
	        return getDescendantProp(entity, key.name);
	    }
	
	    function updateEntitiesData(data) {
	        if (vm.allEntities) {
	            for (var i = 0; i < vm.allEntities.length; i++) {
	                var entity = vm.allEntities[i];
	                for (var a = 0; a < vm.dataKeys.length; a++) {
	                    var dataKey = vm.dataKeys[a];
	                    var index = i * vm.dataKeys.length + a;
	                    var keyData = data[index].data;
	                    if (keyData && keyData.length && keyData[0].length > 1) {
	                        var value = keyData[0][1];
	                        entity[dataKey.name] = value;
	                    } else {
	                        entity[dataKey.name] = '';
	                    }
	                }
	            }
	        }
	    }
	
	    function editColumnsToDisplay($event) {
	        var element = angular.element($event.target);
	        var position = $mdPanel.newPanelPosition().relativeTo(element).addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);
	        var config = {
	            attachTo: angular.element($document[0].body),
	            controller: DisplayColumnsPanelController,
	            controllerAs: 'vm',
	            templateUrl: _displayColumnsPanelTpl2.default,
	            panelClass: 'tb-display-columns-panel',
	            position: position,
	            fullscreen: false,
	            locals: {
	                'columns': vm.columns
	            },
	            openFrom: $event,
	            clickOutsideToClose: true,
	            escapeToClose: true,
	            focusOnOpen: false
	        };
	        $mdPanel.open(config);
	    }
	
	    function updateDatasources() {
	
	        vm.stylesInfo = {};
	        vm.contentsInfo = {};
	        vm.columnWidth = {};
	        vm.dataKeys = [];
	        vm.columns = [];
	        vm.allEntities = [];
	
	        var datasource;
	        var dataKey;
	
	        datasource = vm.datasources[0];
	
	        vm.ctx.widgetTitle = utils.createLabelFromDatasource(datasource, vm.entitiesTitle);
	
	        if (vm.displayEntityName) {
	            vm.columns.push({
	                name: 'entityName',
	                label: 'entityName',
	                title: vm.entityNameColumnTitle,
	                display: true
	            });
	            vm.contentsInfo['entityName'] = {
	                useCellContentFunction: false
	            };
	            vm.stylesInfo['entityName'] = {
	                useCellStyleFunction: false
	            };
	            vm.columnWidth['entityName'] = '0px';
	        }
	
	        if (vm.displayEntityType) {
	            vm.columns.push({
	                name: 'entityType',
	                label: 'entityType',
	                title: $translate.instant('entity.entity-type'),
	                display: true
	            });
	            vm.contentsInfo['entityType'] = {
	                useCellContentFunction: false
	            };
	            vm.stylesInfo['entityType'] = {
	                useCellStyleFunction: false
	            };
	            vm.columnWidth['entityType'] = '0px';
	        }
	
	        for (var d = 0; d < datasource.dataKeys.length; d++) {
	            dataKey = angular.copy(datasource.dataKeys[d]);
	            if (dataKey.type == types.dataKeyType.function) {
	                dataKey.name = dataKey.label;
	            }
	            vm.dataKeys.push(dataKey);
	
	            dataKey.title = utils.customTranslation(dataKey.label, dataKey.label);
	
	            var keySettings = dataKey.settings;
	
	            var cellStyleFunction = null;
	            var useCellStyleFunction = false;
	
	            if (keySettings.useCellStyleFunction === true) {
	                if (angular.isDefined(keySettings.cellStyleFunction) && keySettings.cellStyleFunction.length > 0) {
	                    try {
	                        cellStyleFunction = new Function('value', keySettings.cellStyleFunction);
	                        useCellStyleFunction = true;
	                    } catch (e) {
	                        cellStyleFunction = null;
	                        useCellStyleFunction = false;
	                    }
	                }
	            }
	
	            vm.stylesInfo[dataKey.label] = {
	                useCellStyleFunction: useCellStyleFunction,
	                cellStyleFunction: cellStyleFunction
	            };
	
	            var cellContentFunction = null;
	            var useCellContentFunction = false;
	
	            if (keySettings.useCellContentFunction === true) {
	                if (angular.isDefined(keySettings.cellContentFunction) && keySettings.cellContentFunction.length > 0) {
	                    try {
	                        cellContentFunction = new Function('value, entity, filter', keySettings.cellContentFunction);
	                        useCellContentFunction = true;
	                    } catch (e) {
	                        cellContentFunction = null;
	                        useCellContentFunction = false;
	                    }
	                }
	            }
	
	            vm.contentsInfo[dataKey.label] = {
	                useCellContentFunction: useCellContentFunction,
	                cellContentFunction: cellContentFunction,
	                units: dataKey.units,
	                decimals: dataKey.decimals
	            };
	
	            var columnWidth = angular.isDefined(keySettings.columnWidth) ? keySettings.columnWidth : '0px';
	            vm.columnWidth[dataKey.label] = columnWidth;
	
	            dataKey.display = true;
	            vm.columns.push(dataKey);
	        }
	
	        for (var i = 0; i < vm.datasources.length; i++) {
	            datasource = vm.datasources[i];
	            if (datasource.type == types.datasourceType.entity && !datasource.entityId) {
	                continue;
	            }
	            var entity = {
	                id: {}
	            };
	            entity.entityName = datasource.entityName;
	            if (datasource.entityId) {
	                entity.id.id = datasource.entityId;
	            }
	            if (datasource.entityType) {
	                entity.id.entityType = datasource.entityType;
	                entity.entityType = $translate.instant(types.entityTypeTranslations[datasource.entityType].type) + '';
	            } else {
	                entity.entityType = '';
	            }
	            for (d = 0; d < vm.dataKeys.length; d++) {
	                dataKey = vm.dataKeys[d];
	                entity[dataKey.name] = '';
	            }
	            vm.allEntities.push(entity);
	        }
	    }
	}
	
	/*@ngInject*/
	function DisplayColumnsPanelController(columns) {
	    //eslint-disable-line
	
	    var vm = this;
	    vm.columns = columns;
	}

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ExtensionsTableWidgetController.$inject = ["$scope", "$translate", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(824);
	
	var _extensionsTableWidgetTpl = __webpack_require__(1533);
	
	var _extensionsTableWidgetTpl2 = _interopRequireDefault(_extensionsTableWidgetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.widgets.extensionsTableWidget', []).directive('tbExtensionsTableWidget', ExtensionsTableWidget).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function ExtensionsTableWidget() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            ctx: '='
	        },
	        controller: ExtensionsTableWidgetController,
	        controllerAs: 'vm',
	        templateUrl: _extensionsTableWidgetTpl2.default
	    };
	}
	
	/*@ngInject*/
	function ExtensionsTableWidgetController($scope, $translate, utils) {
	    var vm = this;
	
	    vm.datasources = null;
	    vm.tabsHidden = false;
	
	    $scope.$watch('vm.ctx', function () {
	        if (vm.ctx && vm.ctx.defaultSubscription) {
	            vm.settings = vm.ctx.settings;
	            vm.subscription = vm.ctx.defaultSubscription;
	            vm.datasources = vm.subscription.datasources;
	            initializeConfig();
	            updateDatasources();
	        }
	    });
	
	    function initializeConfig() {
	
	        if (vm.settings.extensionsTitle && vm.settings.extensionsTitle.length) {
	            vm.extensionsTitle = utils.customTranslation(vm.settings.extensionsTitle, vm.settings.extensionsTitle);
	        } else {
	            vm.extensionsTitle = $translate.instant('extension.extensions');
	        }
	        vm.ctx.widgetTitle = vm.extensionsTitle;
	
	        vm.ctx.widgetActions = [vm.importExtensionsAction, vm.exportExtensionsAction, vm.addAction, vm.searchAction, vm.refreshAction];
	    }
	
	    function updateDatasources() {
	
	        var datasource = vm.datasources[0];
	        vm.selectedSource = vm.datasources[0];
	        vm.ctx.widgetTitle = utils.createLabelFromDatasource(datasource, vm.extensionsTitle);
	    }
	
	    vm.changeSelectedSource = function (source) {
	        vm.selectedSource = source;
	    };
	
	    vm.searchAction = {
	        name: "action.search",
	        show: true,
	        onAction: function onAction() {
	            $scope.$broadcast("showSearch", vm.selectedSource);
	        },
	        icon: "search"
	    };
	
	    vm.refreshAction = {
	        name: "action.refresh",
	        show: true,
	        onAction: function onAction() {
	            $scope.$broadcast("refreshExtensions", vm.selectedSource);
	        },
	        icon: "refresh"
	    };
	
	    vm.addAction = {
	        name: "action.add",
	        show: true,
	        onAction: function onAction() {
	            $scope.$broadcast("addExtension", vm.selectedSource);
	        },
	        icon: "add"
	    };
	
	    vm.exportExtensionsAction = {
	        name: "extension.export-extensions-configuration",
	        show: true,
	        onAction: function onAction() {
	            $scope.$broadcast("exportExtensions", vm.selectedSource);
	        },
	        icon: "file_download"
	    };
	
	    vm.importExtensionsAction = {
	        name: "extension.import-extensions-configuration",
	        show: true,
	        onAction: function onAction() {
	            $scope.$broadcast("importExtensions", vm.selectedSource);
	        },
	        icon: "file_upload"
	    };
	
	    $scope.$on("filterMode", function ($event, mode) {
	        vm.tabsHidden = mode;
	    });
	
	    $scope.$on("selectedExtensions", function ($event, mode) {
	        vm.tabsHidden = mode;
	    });
	}

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(852);
	
	__webpack_require__(853);
	
	__webpack_require__(858);
	
	__webpack_require__(856);
	
	__webpack_require__(855);
	
	__webpack_require__(854);
	
	__webpack_require__(857);
	
	__webpack_require__(851);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable angular/angularelement */
	var TbFlot = function () {
	    function TbFlot(ctx, chartType) {
	        _classCallCheck(this, TbFlot);
	
	        this.ctx = ctx;
	        this.chartType = chartType || 'line';
	        var settings = ctx.settings;
	
	        ctx.tooltip = (0, _jquery2.default)('#flot-series-tooltip');
	        if (ctx.tooltip.length === 0) {
	            ctx.tooltip = (0, _jquery2.default)("<div id='flot-series-tooltip' class='flot-mouse-value'></div>");
	            ctx.tooltip.css({
	                fontSize: "12px",
	                fontFamily: "Roboto",
	                fontWeight: "300",
	                lineHeight: "18px",
	                opacity: "1",
	                backgroundColor: "rgba(0,0,0,0.7)",
	                color: "#D9DADB",
	                position: "absolute",
	                display: "none",
	                zIndex: "100",
	                padding: "4px 10px",
	                borderRadius: "4px"
	            }).appendTo("body");
	        }
	
	        var tbFlot = this;
	
	        function seriesInfoDiv(label, color, value, units, trackDecimals, active, percent, valueFormatFunction) {
	            var divElement = (0, _jquery2.default)('<div></div>');
	            divElement.css({
	                display: "flex",
	                alignItems: "center",
	                justifyContent: "flex-start"
	            });
	            var lineSpan = (0, _jquery2.default)('<span></span>');
	            lineSpan.css({
	                backgroundColor: color,
	                width: "20px",
	                height: "3px",
	                display: "inline-block",
	                verticalAlign: "middle",
	                marginRight: "5px"
	            });
	            divElement.append(lineSpan);
	            var labelSpan = (0, _jquery2.default)('<span>' + label + ':</span>');
	            labelSpan.css({
	                marginRight: "10px"
	            });
	            if (active) {
	                labelSpan.css({
	                    color: "#FFF",
	                    fontWeight: "700"
	                });
	            }
	            divElement.append(labelSpan);
	            var valueContent;
	            if (valueFormatFunction) {
	                valueContent = valueFormatFunction(value);
	            } else {
	                valueContent = tbFlot.ctx.utils.formatValue(value, trackDecimals, units);
	            }
	            if (angular.isNumber(percent)) {
	                valueContent += ' (' + Math.round(percent) + ' %)';
	            }
	            var valueSpan = (0, _jquery2.default)('<span>' + valueContent + '</span>');
	            valueSpan.css({
	                marginLeft: "auto",
	                fontWeight: "700"
	            });
	            if (active) {
	                valueSpan.css({
	                    color: "#FFF"
	                });
	            }
	            divElement.append(valueSpan);
	
	            return divElement;
	        }
	
	        function seriesInfoDivFromInfo(seriesHoverInfo, seriesIndex) {
	            var units = seriesHoverInfo.units && seriesHoverInfo.units.length ? seriesHoverInfo.units : tbFlot.ctx.trackUnits;
	            var decimals = angular.isDefined(seriesHoverInfo.decimals) ? seriesHoverInfo.decimals : tbFlot.ctx.trackDecimals;
	            var divElement = seriesInfoDiv(seriesHoverInfo.label, seriesHoverInfo.color, seriesHoverInfo.value, units, decimals, seriesHoverInfo.index === seriesIndex, null, seriesHoverInfo.tooltipValueFormatFunction);
	            return divElement.prop('outerHTML');
	        }
	
	        if (this.chartType === 'pie') {
	            ctx.tooltipFormatter = function (item) {
	                var units = item.series.dataKey.units && item.series.dataKey.units.length ? item.series.dataKey.units : tbFlot.ctx.trackUnits;
	                var decimals = angular.isDefined(item.series.dataKey.decimals) ? item.series.dataKey.decimals : tbFlot.ctx.trackDecimals;
	                var divElement = seriesInfoDiv(item.series.dataKey.label, item.series.dataKey.color, item.datapoint[1][0][1], units, decimals, true, item.series.percent, item.series.dataKey.tooltipValueFormatFunction);
	                return divElement.prop('outerHTML');
	            };
	        } else {
	            ctx.tooltipFormatter = function (hoverInfo, seriesIndex) {
	                var content = '';
	                var timestamp = parseInt(hoverInfo.time);
	                var date = (0, _moment2.default)(timestamp).format('YYYY-MM-DD HH:mm:ss');
	                var dateDiv = (0, _jquery2.default)('<div>' + date + '</div>');
	                dateDiv.css({
	                    display: "flex",
	                    alignItems: "center",
	                    justifyContent: "center",
	                    padding: "4px",
	                    fontWeight: "700"
	                });
	                content += dateDiv.prop('outerHTML');
	                if (tbFlot.ctx.tooltipIndividual) {
	                    var seriesHoverInfo = hoverInfo.seriesHover[seriesIndex];
	                    if (seriesHoverInfo) {
	                        content += seriesInfoDivFromInfo(seriesHoverInfo, seriesIndex);
	                    }
	                } else {
	                    var seriesDiv = (0, _jquery2.default)('<div></div>');
	                    seriesDiv.css({
	                        display: "flex",
	                        flexDirection: "row"
	                    });
	                    var maxRows = 15;
	                    var columns = Math.ceil(hoverInfo.seriesHover.length / maxRows);
	                    var columnsContent = '';
	                    for (var c = 0; c < columns; c++) {
	                        var columnDiv = (0, _jquery2.default)('<div></div>');
	                        columnDiv.css({
	                            display: "flex",
	                            flexDirection: "column"
	                        });
	                        var columnContent = '';
	                        for (var i = c * maxRows; i < (c + 1) * maxRows; i++) {
	                            if (i == hoverInfo.seriesHover.length) {
	                                break;
	                            }
	                            seriesHoverInfo = hoverInfo.seriesHover[i];
	                            columnContent += seriesInfoDivFromInfo(seriesHoverInfo, seriesIndex);
	                        }
	                        columnDiv.html(columnContent);
	                        if (c > 0) {
	                            columnsContent += '<span style="width: 20px;"></span>';
	                        }
	                        columnsContent += columnDiv.prop('outerHTML');
	                    }
	                    seriesDiv.html(columnsContent);
	                    content += seriesDiv.prop('outerHTML');
	                }
	                return content;
	            };
	        }
	
	        ctx.trackDecimals = ctx.decimals;
	
	        ctx.trackUnits = ctx.units;
	
	        ctx.tooltipIndividual = this.chartType === 'pie' || (angular.isDefined(settings.tooltipIndividual) ? settings.tooltipIndividual : false);
	        ctx.tooltipCumulative = angular.isDefined(settings.tooltipCumulative) ? settings.tooltipCumulative : false;
	
	        var font = {
	            color: settings.fontColor || "#545454",
	            size: settings.fontSize || 10,
	            family: "Roboto"
	        };
	
	        var options = {
	            title: null,
	            subtitle: null,
	            shadowSize: angular.isDefined(settings.shadowSize) ? settings.shadowSize : 4,
	            HtmlText: false,
	            grid: {
	                hoverable: true,
	                mouseActiveRadius: 10,
	                autoHighlight: ctx.tooltipIndividual === true
	            },
	            selection: { mode: ctx.isMobile ? null : 'x' },
	            legend: {
	                show: false
	            }
	        };
	
	        if (this.chartType === 'line' || this.chartType === 'bar' || this.chartType === 'state') {
	            options.xaxis = {
	                mode: 'time',
	                timezone: 'browser',
	                font: angular.copy(font),
	                labelFont: angular.copy(font)
	            };
	            this.yaxis = {
	                font: angular.copy(font),
	                labelFont: angular.copy(font)
	            };
	            if (settings.xaxis) {
	                if (settings.xaxis.showLabels === false) {
	                    options.xaxis.tickFormatter = function () {
	                        return '';
	                    };
	                }
	                options.xaxis.font.color = settings.xaxis.color || options.xaxis.font.color;
	                options.xaxis.label = settings.xaxis.title || null;
	                options.xaxis.labelFont.color = options.xaxis.font.color;
	                options.xaxis.labelFont.size = options.xaxis.font.size + 2;
	                options.xaxis.labelFont.weight = "bold";
	            }
	
	            ctx.yAxisTickFormatter = function (value /*, axis*/) {
	                if (settings.yaxis && settings.yaxis.showLabels === false) {
	                    return '';
	                }
	                if (this.ticksFormatterFunction) {
	                    return this.ticksFormatterFunction(value);
	                }
	
	                var factor = this.tickDecimals ? Math.pow(10, this.tickDecimals) : 1,
	                    formatted = "" + Math.round(value * factor) / factor;
	                if (this.tickDecimals != null) {
	                    var decimal = formatted.indexOf("."),
	                        precision = decimal === -1 ? 0 : formatted.length - decimal - 1;
	
	                    if (precision < this.tickDecimals) {
	                        formatted = (precision ? formatted : formatted + ".") + ("" + factor).substr(1, this.tickDecimals - precision);
	                    }
	                }
	                if (this.tickUnits) {
	                    formatted += ' ' + this.tickUnits;
	                }
	
	                return formatted;
	            };
	
	            this.yaxis.tickFormatter = ctx.yAxisTickFormatter;
	
	            if (settings.yaxis) {
	                this.yaxis.font.color = settings.yaxis.color || this.yaxis.font.color;
	                this.yaxis.min = angular.isDefined(settings.yaxis.min) ? settings.yaxis.min : null;
	                this.yaxis.max = angular.isDefined(settings.yaxis.max) ? settings.yaxis.max : null;
	                this.yaxis.label = settings.yaxis.title || null;
	                this.yaxis.labelFont.color = this.yaxis.font.color;
	                this.yaxis.labelFont.size = this.yaxis.font.size + 2;
	                this.yaxis.labelFont.weight = "bold";
	                if (angular.isNumber(settings.yaxis.tickSize)) {
	                    this.yaxis.tickSize = settings.yaxis.tickSize;
	                } else {
	                    this.yaxis.tickSize = null;
	                }
	                if (angular.isNumber(settings.yaxis.tickDecimals)) {
	                    this.yaxis.tickDecimals = settings.yaxis.tickDecimals;
	                } else {
	                    this.yaxis.tickDecimals = null;
	                }
	                if (settings.yaxis.ticksFormatter && settings.yaxis.ticksFormatter.length) {
	                    try {
	                        this.yaxis.ticksFormatterFunction = new Function('value', settings.yaxis.ticksFormatter);
	                    } catch (e) {
	                        this.yaxis.ticksFormatterFunction = null;
	                    }
	                }
	            }
	
	            options.grid.borderWidth = 1;
	            options.grid.color = settings.fontColor || "#545454";
	
	            if (settings.grid) {
	                options.grid.color = settings.grid.color || "#545454";
	                options.grid.backgroundColor = settings.grid.backgroundColor || null;
	                options.grid.tickColor = settings.grid.tickColor || "#DDDDDD";
	                options.grid.borderWidth = angular.isDefined(settings.grid.outlineWidth) ? settings.grid.outlineWidth : 1;
	                if (settings.grid.verticalLines === false) {
	                    options.xaxis.tickLength = 0;
	                }
	                if (settings.grid.horizontalLines === false) {
	                    this.yaxis.tickLength = 0;
	                }
	                if (angular.isDefined(settings.grid.margin)) {
	                    options.grid.margin = settings.grid.margin;
	                }
	                if (angular.isDefined(settings.grid.minBorderMargin)) {
	                    options.grid.minBorderMargin = settings.grid.minBorderMargin;
	                }
	            }
	
	            options.crosshair = {
	                mode: 'x'
	            };
	
	            options.series = {
	                stack: settings.stack === true
	            };
	
	            if (this.chartType === 'line' && settings.smoothLines) {
	                options.series.curvedLines = {
	                    active: true,
	                    monotonicFit: true
	                };
	            }
	
	            if (this.chartType === 'bar') {
	                options.series.lines = {
	                    show: false,
	                    fill: false,
	                    steps: false
	                };
	                options.series.bars = {
	                    show: true,
	                    lineWidth: 0,
	                    fill: 0.9
	                };
	                ctx.defaultBarWidth = settings.defaultBarWidth || 600;
	            }
	
	            if (this.chartType === 'state') {
	                options.series.lines = {
	                    steps: true,
	                    show: true
	                };
	            }
	        } else if (this.chartType === 'pie') {
	            options.series = {
	                pie: {
	                    show: true,
	                    label: {
	                        show: settings.showLabels === true
	                    },
	                    radius: settings.radius || 1,
	                    innerRadius: settings.innerRadius || 0,
	                    stroke: {
	                        color: '#fff',
	                        width: 0
	                    },
	                    tilt: settings.tilt || 1,
	                    shadow: {
	                        left: 5,
	                        top: 15,
	                        alpha: 0.02
	                    }
	                }
	            };
	            if (settings.stroke) {
	                options.series.pie.stroke.color = settings.stroke.color || '#fff';
	                options.series.pie.stroke.width = settings.stroke.width || 0;
	            }
	
	            if (options.series.pie.label.show) {
	                options.series.pie.label.formatter = function (label, series) {
	                    return "<div class='pie-label'>" + series.dataKey.label + "<br/>" + Math.round(series.percent) + "%</div>";
	                };
	                options.series.pie.label.radius = 3 / 4;
	                options.series.pie.label.background = {
	                    opacity: 0.8
	                };
	            }
	        }
	
	        //Experimental
	        this.ctx.animatedPie = settings.animatedPie === true;
	
	        this.options = options;
	
	        if (this.ctx.defaultSubscription) {
	            this.init(this.ctx.$container, this.ctx.defaultSubscription);
	        }
	    }
	
	    _createClass(TbFlot, [{
	        key: 'init',
	        value: function init($element, subscription) {
	            this.subscription = subscription;
	            this.$element = $element;
	            var colors = [];
	            this.yaxes = [];
	            var yaxesMap = {};
	
	            var tooltipValueFormatFunction = null;
	            if (this.ctx.settings.tooltipValueFormatter && this.ctx.settings.tooltipValueFormatter.length) {
	                try {
	                    tooltipValueFormatFunction = new Function('value', this.ctx.settings.tooltipValueFormatter);
	                } catch (e) {
	                    tooltipValueFormatFunction = null;
	                }
	            }
	
	            for (var i = 0; i < this.subscription.data.length; i++) {
	                var series = this.subscription.data[i];
	                colors.push(series.dataKey.color);
	                var keySettings = series.dataKey.settings;
	                series.dataKey.tooltipValueFormatFunction = tooltipValueFormatFunction;
	                if (keySettings.tooltipValueFormatter && keySettings.tooltipValueFormatter.length) {
	                    try {
	                        series.dataKey.tooltipValueFormatFunction = new Function('value', keySettings.tooltipValueFormatter);
	                    } catch (e) {
	                        series.dataKey.tooltipValueFormatFunction = tooltipValueFormatFunction;
	                    }
	                }
	                series.lines = {
	                    fill: keySettings.fillLines === true
	                };
	                if (this.chartType === 'line' || this.chartType === 'state') {
	                    series.lines.show = keySettings.showLines !== false;
	                } else {
	                    series.lines.show = keySettings.showLines === true;
	                }
	
	                if (angular.isDefined(keySettings.lineWidth)) {
	                    series.lines.lineWidth = keySettings.lineWidth;
	                }
	
	                series.points = {
	                    show: false,
	                    radius: 8
	                };
	                if (keySettings.showPoints === true) {
	                    series.points.show = true;
	                    series.points.lineWidth = 5;
	                    series.points.radius = 3;
	                }
	
	                if (this.chartType === 'line' && this.ctx.settings.smoothLines && !series.points.show) {
	                    series.curvedLines = {
	                        apply: true
	                    };
	                }
	
	                var lineColor = (0, _tinycolor2.default)(series.dataKey.color);
	                lineColor.setAlpha(.75);
	
	                series.highlightColor = lineColor.toRgbString();
	
	                if (this.yaxis) {
	                    var units = series.dataKey.units && series.dataKey.units.length ? series.dataKey.units : this.ctx.trackUnits;
	                    var yaxis;
	                    if (keySettings.showSeparateAxis) {
	                        yaxis = this.createYAxis(keySettings, units);
	                        this.yaxes.push(yaxis);
	                    } else {
	                        yaxis = yaxesMap[units];
	                        if (!yaxis) {
	                            yaxis = this.createYAxis(keySettings, units);
	                            yaxesMap[units] = yaxis;
	                            this.yaxes.push(yaxis);
	                        }
	                    }
	                    series.yaxisIndex = this.yaxes.indexOf(yaxis);
	                    series.yaxis = series.yaxisIndex + 1;
	                    yaxis.keysInfo[i] = { hidden: false };
	                    yaxis.hidden = false;
	                }
	            }
	
	            this.options.colors = colors;
	            this.options.yaxes = angular.copy(this.yaxes);
	            if (this.chartType === 'line' || this.chartType === 'bar' || this.chartType === 'state') {
	                if (this.chartType === 'bar') {
	                    if (this.subscription.timeWindowConfig.aggregation && this.subscription.timeWindowConfig.aggregation.type === 'NONE') {
	                        this.options.series.bars.barWidth = this.ctx.defaultBarWidth;
	                    } else {
	                        this.options.series.bars.barWidth = this.subscription.timeWindow.interval * 0.6;
	                    }
	                }
	                this.options.xaxis.min = this.subscription.timeWindow.minTime;
	                this.options.xaxis.max = this.subscription.timeWindow.maxTime;
	            }
	
	            this.checkMouseEvents();
	
	            if (this.ctx.plot) {
	                this.ctx.plot.destroy();
	            }
	            if (this.chartType === 'pie' && this.ctx.animatedPie) {
	                this.ctx.pieDataAnimationDuration = 250;
	                this.pieData = angular.copy(this.subscription.data);
	                this.ctx.pieRenderedData = [];
	                this.ctx.pieTargetData = [];
	                for (i = 0; i < this.subscription.data.length; i++) {
	                    this.ctx.pieTargetData[i] = this.subscription.data[i].data && this.subscription.data[i].data[0] ? this.subscription.data[i].data[0][1] : 0;
	                }
	                this.pieDataRendered();
	            }
	            this.ctx.plotInited = true;
	            this.createPlot();
	        }
	    }, {
	        key: 'createYAxis',
	        value: function createYAxis(keySettings, units) {
	            var yaxis = angular.copy(this.yaxis);
	            var tickDecimals, tickSize;
	
	            var label = keySettings.axisTitle && keySettings.axisTitle.length ? keySettings.axisTitle : yaxis.label;
	            if (angular.isNumber(keySettings.axisTickDecimals)) {
	                tickDecimals = keySettings.axisTickDecimals;
	            } else {
	                tickDecimals = yaxis.tickDecimals;
	            }
	            if (angular.isNumber(keySettings.axisTickSize)) {
	                tickSize = keySettings.axisTickSize;
	            } else {
	                tickSize = yaxis.tickSize;
	            }
	            var position = keySettings.axisPosition && keySettings.axisPosition.length ? keySettings.axisPosition : "left";
	
	            var min = angular.isDefined(keySettings.axisMin) ? keySettings.axisMin : yaxis.min;
	            var max = angular.isDefined(keySettings.axisMax) ? keySettings.axisMax : yaxis.max;
	
	            yaxis.label = label;
	            yaxis.min = min;
	            yaxis.max = max;
	            yaxis.tickUnits = units;
	            yaxis.tickDecimals = tickDecimals;
	            yaxis.tickSize = tickSize;
	            yaxis.alignTicksWithAxis = position == "right" ? 1 : null;
	            yaxis.position = position;
	
	            yaxis.keysInfo = [];
	
	            if (keySettings.axisTicksFormatter && keySettings.axisTicksFormatter.length) {
	                try {
	                    yaxis.ticksFormatterFunction = new Function('value', keySettings.axisTicksFormatter);
	                } catch (e) {
	                    yaxis.ticksFormatterFunction = this.yaxis.ticksFormatterFunction;
	                }
	            }
	            return yaxis;
	        }
	    }, {
	        key: 'update',
	        value: function update() {
	            if (this.updateTimeoutHandle) {
	                this.ctx.$scope.$timeout.cancel(this.updateTimeoutHandle);
	                this.updateTimeoutHandle = null;
	            }
	            if (this.subscription) {
	                if (!this.isMouseInteraction && this.ctx.plot) {
	                    if (this.chartType === 'line' || this.chartType === 'bar' || this.chartType === 'state') {
	
	                        var axisVisibilityChanged = false;
	                        if (this.yaxis) {
	                            for (var i = 0; i < this.subscription.data.length; i++) {
	                                var series = this.subscription.data[i];
	                                var yaxisIndex = series.yaxisIndex;
	                                if (this.yaxes[yaxisIndex].keysInfo[i].hidden != series.dataKey.hidden) {
	                                    this.yaxes[yaxisIndex].keysInfo[i].hidden = series.dataKey.hidden;
	                                    axisVisibilityChanged = true;
	                                }
	                            }
	                            if (axisVisibilityChanged) {
	                                this.options.yaxes.length = 0;
	                                for (var y = 0; y < this.yaxes.length; y++) {
	                                    var yaxis = this.yaxes[y];
	                                    var hidden = true;
	                                    for (var k = 0; k < yaxis.keysInfo.length; k++) {
	                                        if (yaxis.keysInfo[k]) {
	                                            hidden = hidden && yaxis.keysInfo[k].hidden;
	                                        }
	                                    }
	                                    yaxis.hidden = hidden;
	                                    var newIndex = 1;
	                                    if (!yaxis.hidden) {
	                                        this.options.yaxes.push(yaxis);
	                                        newIndex = this.options.yaxes.length;
	                                    }
	                                    for (k = 0; k < yaxis.keysInfo.length; k++) {
	                                        if (yaxis.keysInfo[k]) {
	                                            this.subscription.data[k].yaxis = newIndex;
	                                        }
	                                    }
	                                }
	                                this.options.yaxis = {
	                                    show: this.options.yaxes.length ? true : false
	                                };
	                            }
	                        }
	
	                        this.options.xaxis.min = this.subscription.timeWindow.minTime;
	                        this.options.xaxis.max = this.subscription.timeWindow.maxTime;
	                        if (this.chartType === 'bar') {
	                            if (this.subscription.timeWindowConfig.aggregation && this.subscription.timeWindowConfig.aggregation.type === 'NONE') {
	                                this.options.series.bars.barWidth = this.ctx.defaultBarWidth;
	                            } else {
	                                this.options.series.bars.barWidth = this.subscription.timeWindow.interval * 0.6;
	                            }
	                        }
	
	                        if (axisVisibilityChanged) {
	                            this.redrawPlot();
	                        } else {
	                            this.ctx.plot.getOptions().xaxes[0].min = this.subscription.timeWindow.minTime;
	                            this.ctx.plot.getOptions().xaxes[0].max = this.subscription.timeWindow.maxTime;
	                            if (this.chartType === 'bar') {
	                                if (this.subscription.timeWindowConfig.aggregation && this.subscription.timeWindowConfig.aggregation.type === 'NONE') {
	                                    this.ctx.plot.getOptions().series.bars.barWidth = this.ctx.defaultBarWidth;
	                                } else {
	                                    this.ctx.plot.getOptions().series.bars.barWidth = this.subscription.timeWindow.interval * 0.6;
	                                }
	                            }
	                            this.updateData();
	                        }
	                    } else if (this.chartType === 'pie') {
	                        if (this.ctx.animatedPie) {
	                            this.nextPieDataAnimation(true);
	                        } else {
	                            this.updateData();
	                        }
	                    }
	                } else if (this.isMouseInteraction && this.ctx.plot) {
	                    var tbFlot = this;
	                    this.updateTimeoutHandle = this.ctx.$scope.$timeout(function () {
	                        tbFlot.update();
	                    }, 30, false);
	                }
	            }
	        }
	    }, {
	        key: 'updateData',
	        value: function updateData() {
	            this.ctx.plot.setData(this.subscription.data);
	            if (this.chartType !== 'pie') {
	                this.ctx.plot.setupGrid();
	            }
	            this.ctx.plot.draw();
	        }
	    }, {
	        key: 'resize',
	        value: function resize() {
	            if (this.resizeTimeoutHandle) {
	                this.ctx.$scope.$timeout.cancel(this.resizeTimeoutHandle);
	                this.resizeTimeoutHandle = null;
	            }
	            if (this.ctx.plot && this.ctx.plotInited) {
	                var width = this.$element.width();
	                var height = this.$element.height();
	                if (width && height) {
	                    this.ctx.plot.resize();
	                    if (this.chartType !== 'pie') {
	                        this.ctx.plot.setupGrid();
	                    }
	                    this.ctx.plot.draw();
	                } else {
	                    var tbFlot = this;
	                    this.resizeTimeoutHandle = this.ctx.$scope.$timeout(function () {
	                        tbFlot.resize();
	                    }, 30, false);
	                }
	            }
	        }
	    }, {
	        key: 'redrawPlot',
	        value: function redrawPlot() {
	            if (this.ctx.plot && this.ctx.plotInited) {
	                this.ctx.plot.destroy();
	                this.ctx.plot = null;
	                this.createPlot();
	            }
	        }
	    }, {
	        key: 'createPlot',
	        value: function createPlot() {
	            if (this.createPlotTimeoutHandle) {
	                this.ctx.$scope.$timeout.cancel(this.createPlotTimeoutHandle);
	                this.createPlotTimeoutHandle = null;
	            }
	            if (this.ctx.plotInited && !this.ctx.plot) {
	                var width = this.$element.width();
	                var height = this.$element.height();
	                if (width && height) {
	                    if (this.chartType === 'pie' && this.ctx.animatedPie) {
	                        this.ctx.plot = _jquery2.default.plot(this.$element, this.pieData, this.options);
	                    } else {
	                        this.ctx.plot = _jquery2.default.plot(this.$element, this.subscription.data, this.options);
	                    }
	                } else {
	                    var tbFlot = this;
	                    this.createPlotTimeoutHandle = this.ctx.$scope.$timeout(function () {
	                        tbFlot.createPlot();
	                    }, 30, false);
	                }
	            }
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.cleanup();
	            if (this.ctx.plot) {
	                this.ctx.plot.destroy();
	                this.ctx.plot = null;
	                this.ctx.plotInited = false;
	            }
	        }
	    }, {
	        key: 'cleanup',
	        value: function cleanup() {
	            if (this.updateTimeoutHandle) {
	                this.ctx.$scope.$timeout.cancel(this.updateTimeoutHandle);
	                this.updateTimeoutHandle = null;
	            }
	            if (this.createPlotTimeoutHandle) {
	                this.ctx.$scope.$timeout.cancel(this.createPlotTimeoutHandle);
	                this.createPlotTimeoutHandle = null;
	            }
	            if (this.resizeTimeoutHandle) {
	                this.ctx.$scope.$timeout.cancel(this.resizeTimeoutHandle);
	                this.resizeTimeoutHandle = null;
	            }
	        }
	    }, {
	        key: 'checkMouseEvents',
	        value: function checkMouseEvents() {
	            var enabled = !this.ctx.isMobile && !this.ctx.isEdit;
	            if (angular.isUndefined(this.mouseEventsEnabled) || this.mouseEventsEnabled != enabled) {
	                this.mouseEventsEnabled = enabled;
	                if (this.$element) {
	                    if (enabled) {
	                        this.enableMouseEvents();
	                    } else {
	                        this.disableMouseEvents();
	                    }
	                    this.redrawPlot();
	                }
	            }
	        }
	    }, {
	        key: 'enableMouseEvents',
	        value: function enableMouseEvents() {
	            this.$element.css('pointer-events', '');
	            this.$element.addClass('mouse-events');
	            this.options.selection = { mode: 'x' };
	
	            var tbFlot = this;
	
	            if (!this.flotHoverHandler) {
	                this.flotHoverHandler = function (event, pos, item) {
	                    if (!tbFlot.ctx.plot) {
	                        return;
	                    }
	                    if (!tbFlot.ctx.tooltipIndividual || item) {
	
	                        var multipleModeTooltip = !tbFlot.ctx.tooltipIndividual;
	
	                        if (multipleModeTooltip) {
	                            tbFlot.ctx.plot.unhighlight();
	                        }
	
	                        var pageX = pos.pageX;
	                        var pageY = pos.pageY;
	
	                        var tooltipHtml;
	
	                        if (tbFlot.chartType === 'pie') {
	                            tooltipHtml = tbFlot.ctx.tooltipFormatter(item);
	                        } else {
	                            var hoverInfo = tbFlot.getHoverInfo(tbFlot.ctx.plot.getData(), pos);
	                            if (angular.isNumber(hoverInfo.time)) {
	                                hoverInfo.seriesHover.sort(function (a, b) {
	                                    return b.value - a.value;
	                                });
	                                tooltipHtml = tbFlot.ctx.tooltipFormatter(hoverInfo, item ? item.seriesIndex : -1);
	                            }
	                        }
	
	                        if (tooltipHtml) {
	                            tbFlot.ctx.tooltip.html(tooltipHtml).css({ top: pageY + 5, left: 0 }).fadeIn(200);
	
	                            var windowWidth = (0, _jquery2.default)(window).width(); //eslint-disable-line
	                            var tooltipWidth = tbFlot.ctx.tooltip.width();
	                            var left = pageX + 5;
	                            if (windowWidth - pageX < tooltipWidth + 50) {
	                                left = pageX - tooltipWidth - 10;
	                            }
	                            tbFlot.ctx.tooltip.css({
	                                left: left
	                            });
	
	                            if (multipleModeTooltip) {
	                                for (var i = 0; i < hoverInfo.seriesHover.length; i++) {
	                                    var seriesHoverInfo = hoverInfo.seriesHover[i];
	                                    tbFlot.ctx.plot.highlight(seriesHoverInfo.index, seriesHoverInfo.hoverIndex);
	                                }
	                            }
	                        }
	                    } else {
	                        tbFlot.ctx.tooltip.stop(true);
	                        tbFlot.ctx.tooltip.hide();
	                        tbFlot.ctx.plot.unhighlight();
	                    }
	                };
	                this.$element.bind('plothover', this.flotHoverHandler);
	            }
	
	            if (!this.flotSelectHandler) {
	                this.flotSelectHandler = function (event, ranges) {
	                    if (!tbFlot.ctx.plot) {
	                        return;
	                    }
	                    tbFlot.ctx.plot.clearSelection();
	                    tbFlot.subscription.onUpdateTimewindow(ranges.xaxis.from, ranges.xaxis.to);
	                };
	                this.$element.bind('plotselected', this.flotSelectHandler);
	            }
	            if (!this.dblclickHandler) {
	                this.dblclickHandler = function () {
	                    tbFlot.subscription.onResetTimewindow();
	                };
	                this.$element.bind('dblclick', this.dblclickHandler);
	            }
	            if (!this.mousedownHandler) {
	                this.mousedownHandler = function () {
	                    tbFlot.isMouseInteraction = true;
	                };
	                this.$element.bind('mousedown', this.mousedownHandler);
	            }
	            if (!this.mouseupHandler) {
	                this.mouseupHandler = function () {
	                    tbFlot.isMouseInteraction = false;
	                };
	                this.$element.bind('mouseup', this.mouseupHandler);
	            }
	            if (!this.mouseleaveHandler) {
	                this.mouseleaveHandler = function () {
	                    if (!tbFlot.ctx.plot) {
	                        return;
	                    }
	                    tbFlot.ctx.tooltip.stop(true);
	                    tbFlot.ctx.tooltip.hide();
	                    tbFlot.ctx.plot.unhighlight();
	                    tbFlot.isMouseInteraction = false;
	                };
	                this.$element.bind('mouseleave', this.mouseleaveHandler);
	            }
	        }
	    }, {
	        key: 'disableMouseEvents',
	        value: function disableMouseEvents() {
	            this.$element.css('pointer-events', 'none');
	            this.$element.removeClass('mouse-events');
	            this.options.selection = { mode: null };
	
	            if (this.flotHoverHandler) {
	                this.$element.unbind('plothover', this.flotHoverHandler);
	                this.flotHoverHandler = null;
	            }
	
	            if (this.flotSelectHandler) {
	                this.$element.unbind('plotselected', this.flotSelectHandler);
	                this.flotSelectHandler = null;
	            }
	            if (this.dblclickHandler) {
	                this.$element.unbind('dblclick', this.dblclickHandler);
	                this.dblclickHandler = null;
	            }
	            if (this.mousedownHandler) {
	                this.$element.unbind('mousedown', this.mousedownHandler);
	                this.mousedownHandler = null;
	            }
	            if (this.mouseupHandler) {
	                this.$element.unbind('mouseup', this.mouseupHandler);
	                this.mouseupHandler = null;
	            }
	            if (this.mouseleaveHandler) {
	                this.$element.unbind('mouseleave', this.mouseleaveHandler);
	                this.mouseleaveHandler = null;
	            }
	        }
	    }, {
	        key: 'findHoverIndexFromData',
	        value: function findHoverIndexFromData(posX, series) {
	            var lower = 0;
	            var upper = series.data.length - 1;
	            var middle;
	            var index = null;
	            while (index === null) {
	                if (lower > upper) {
	                    return Math.max(upper, 0);
	                }
	                middle = Math.floor((lower + upper) / 2);
	                if (series.data[middle][0] === posX) {
	                    return middle;
	                } else if (series.data[middle][0] < posX) {
	                    lower = middle + 1;
	                } else {
	                    upper = middle - 1;
	                }
	            }
	        }
	    }, {
	        key: 'findHoverIndexFromDataPoints',
	        value: function findHoverIndexFromDataPoints(posX, series, last) {
	            var ps = series.datapoints.pointsize;
	            var initial = last * ps;
	            var len = series.datapoints.points.length;
	            for (var j = initial; j < len; j += ps) {
	                if (!series.lines.steps && series.datapoints.points[initial] != null && series.datapoints.points[j] == null || series.datapoints.points[j] > posX) {
	                    return Math.max(j - ps, 0) / ps;
	                }
	            }
	            return j / ps - 1;
	        }
	    }, {
	        key: 'getHoverInfo',
	        value: function getHoverInfo(seriesList, pos) {
	            var i, series, value, hoverIndex, hoverDistance, pointTime, minDistance, minTime;
	            var last_value = 0;
	            var results = {
	                seriesHover: []
	            };
	            for (i = 0; i < seriesList.length; i++) {
	                series = seriesList[i];
	                hoverIndex = this.findHoverIndexFromData(pos.x, series);
	                if (series.data[hoverIndex] && series.data[hoverIndex][0]) {
	                    hoverDistance = pos.x - series.data[hoverIndex][0];
	                    pointTime = series.data[hoverIndex][0];
	
	                    if (!minDistance || hoverDistance >= 0 && (hoverDistance < minDistance || minDistance < 0) || hoverDistance < 0 && hoverDistance > minDistance) {
	                        minDistance = hoverDistance;
	                        minTime = pointTime;
	                    }
	                    if (series.stack) {
	                        if (this.ctx.tooltipIndividual || !this.ctx.tooltipCumulative) {
	                            value = series.data[hoverIndex][1];
	                        } else {
	                            last_value += series.data[hoverIndex][1];
	                            value = last_value;
	                        }
	                    } else {
	                        value = series.data[hoverIndex][1];
	                    }
	
	                    if (series.stack || series.curvedLines && series.curvedLines.apply) {
	                        hoverIndex = this.findHoverIndexFromDataPoints(pos.x, series, hoverIndex);
	                    }
	                    results.seriesHover.push({
	                        value: value,
	                        hoverIndex: hoverIndex,
	                        color: series.dataKey.color,
	                        label: series.dataKey.label,
	                        units: series.dataKey.units,
	                        decimals: series.dataKey.decimals,
	                        tooltipValueFormatFunction: series.dataKey.tooltipValueFormatFunction,
	                        time: pointTime,
	                        distance: hoverDistance,
	                        index: i
	                    });
	                }
	            }
	            results.time = minTime;
	            return results;
	        }
	    }, {
	        key: 'pieDataRendered',
	        value: function pieDataRendered() {
	            for (var i = 0; i < this.ctx.pieTargetData.length; i++) {
	                var value = this.ctx.pieTargetData[i] ? this.ctx.pieTargetData[i] : 0;
	                this.ctx.pieRenderedData[i] = value;
	                if (!this.pieData[i].data[0]) {
	                    this.pieData[i].data[0] = [0, 0];
	                }
	                this.pieData[i].data[0][1] = value;
	            }
	        }
	    }, {
	        key: 'nextPieDataAnimation',
	        value: function nextPieDataAnimation(start) {
	            if (start) {
	                this.finishPieDataAnimation();
	                this.ctx.pieAnimationStartTime = this.ctx.pieAnimationLastTime = Date.now();
	                for (var i = 0; i < this.subscription.data.length; i++) {
	                    this.ctx.pieTargetData[i] = this.subscription.data[i].data && this.subscription.data[i].data[0] ? this.subscription.data[i].data[0][1] : 0;
	                }
	            }
	            if (this.ctx.pieAnimationCaf) {
	                this.ctx.pieAnimationCaf();
	                this.ctx.pieAnimationCaf = null;
	            }
	            var self = this;
	            this.ctx.pieAnimationCaf = this.ctx.$scope.tbRaf(function () {
	                self.onPieDataAnimation();
	            });
	        }
	    }, {
	        key: 'onPieDataAnimation',
	        value: function onPieDataAnimation() {
	            var time = Date.now();
	            var elapsed = time - this.ctx.pieAnimationLastTime; //this.ctx.pieAnimationStartTime;
	            var progress = (time - this.ctx.pieAnimationStartTime) / this.ctx.pieDataAnimationDuration;
	            if (progress >= 1) {
	                this.finishPieDataAnimation();
	            } else {
	                if (elapsed >= 40) {
	                    for (var i = 0; i < this.ctx.pieTargetData.length; i++) {
	                        var prevValue = this.ctx.pieRenderedData[i];
	                        var targetValue = this.ctx.pieTargetData[i];
	                        var value = prevValue + (targetValue - prevValue) * progress;
	                        if (!this.pieData[i].data[0]) {
	                            this.pieData[i].data[0] = [0, 0];
	                        }
	                        this.pieData[i].data[0][1] = value;
	                    }
	                    this.ctx.plot.setData(this.pieData);
	                    this.ctx.plot.draw();
	                    this.ctx.pieAnimationLastTime = time;
	                }
	                this.nextPieDataAnimation(false);
	            }
	        }
	    }, {
	        key: 'finishPieDataAnimation',
	        value: function finishPieDataAnimation() {
	            this.pieDataRendered();
	            this.ctx.plot.setData(this.pieData);
	            this.ctx.plot.draw();
	        }
	    }], [{
	        key: 'settingsSchema',
	        value: function settingsSchema(chartType) {
	
	            var schema = {
	                "schema": {
	                    "type": "object",
	                    "title": "Settings",
	                    "properties": {}
	                }
	            };
	
	            var properties = schema["schema"]["properties"];
	            properties["stack"] = {
	                "title": "Stacking",
	                "type": "boolean",
	                "default": false
	            };
	            if (chartType === 'graph') {
	                properties["smoothLines"] = {
	                    "title": "Display smooth (curved) lines",
	                    "type": "boolean",
	                    "default": false
	                };
	            }
	            if (chartType === 'bar') {
	                properties["defaultBarWidth"] = {
	                    "title": "Default bar width for non-aggregated data (milliseconds)",
	                    "type": "number",
	                    "default": 600
	                };
	            }
	            properties["shadowSize"] = {
	                "title": "Shadow size",
	                "type": "number",
	                "default": 4
	            };
	            properties["fontColor"] = {
	                "title": "Font color",
	                "type": "string",
	                "default": "#545454"
	            };
	            properties["fontSize"] = {
	                "title": "Font size",
	                "type": "number",
	                "default": 10
	            };
	            properties["tooltipIndividual"] = {
	                "title": "Hover individual points",
	                "type": "boolean",
	                "default": false
	            };
	            properties["tooltipCumulative"] = {
	                "title": "Show cumulative values in stacking mode",
	                "type": "boolean",
	                "default": false
	            };
	            properties["tooltipValueFormatter"] = {
	                "title": "Tooltip value format function, f(value)",
	                "type": "string",
	                "default": ""
	            };
	
	            properties["grid"] = {
	                "title": "Grid settings",
	                "type": "object",
	                "properties": {
	                    "color": {
	                        "title": "Primary color",
	                        "type": "string",
	                        "default": "#545454"
	                    },
	                    "backgroundColor": {
	                        "title": "Background color",
	                        "type": "string",
	                        "default": null
	                    },
	                    "tickColor": {
	                        "title": "Ticks color",
	                        "type": "string",
	                        "default": "#DDDDDD"
	                    },
	                    "outlineWidth": {
	                        "title": "Grid outline/border width (px)",
	                        "type": "number",
	                        "default": 1
	                    },
	                    "verticalLines": {
	                        "title": "Show vertical lines",
	                        "type": "boolean",
	                        "default": true
	                    },
	                    "horizontalLines": {
	                        "title": "Show horizontal lines",
	                        "type": "boolean",
	                        "default": true
	                    }
	                }
	            };
	
	            properties["xaxis"] = {
	                "title": "X axis settings",
	                "type": "object",
	                "properties": {
	                    "showLabels": {
	                        "title": "Show labels",
	                        "type": "boolean",
	                        "default": true
	                    },
	                    "title": {
	                        "title": "Axis title",
	                        "type": "string",
	                        "default": null
	                    },
	                    "titleAngle": {
	                        "title": "Axis title's angle in degrees",
	                        "type": "number",
	                        "default": 0
	                    },
	                    "color": {
	                        "title": "Ticks color",
	                        "type": "string",
	                        "default": null
	                    }
	                }
	            };
	
	            properties["yaxis"] = {
	                "title": "Y axis settings",
	                "type": "object",
	                "properties": {
	                    "min": {
	                        "title": "Minimum value on the scale",
	                        "type": "number",
	                        "default": null
	                    },
	                    "max": {
	                        "title": "Maximum value on the scale",
	                        "type": "number",
	                        "default": null
	                    },
	                    "showLabels": {
	                        "title": "Show labels",
	                        "type": "boolean",
	                        "default": true
	                    },
	                    "title": {
	                        "title": "Axis title",
	                        "type": "string",
	                        "default": null
	                    },
	                    "titleAngle": {
	                        "title": "Axis title's angle in degrees",
	                        "type": "number",
	                        "default": 0
	                    },
	                    "color": {
	                        "title": "Ticks color",
	                        "type": "string",
	                        "default": null
	                    },
	                    "ticksFormatter": {
	                        "title": "Ticks formatter function, f(value)",
	                        "type": "string",
	                        "default": ""
	                    },
	                    "tickDecimals": {
	                        "title": "The number of decimals to display",
	                        "type": "number",
	                        "default": 0
	                    },
	                    "tickSize": {
	                        "title": "Step size between ticks",
	                        "type": "number",
	                        "default": null
	                    }
	                }
	            };
	
	            schema["schema"]["required"] = [];
	            schema["form"] = ["stack"];
	            if (chartType === 'graph') {
	                schema["form"].push("smoothLines");
	            }
	            if (chartType === 'bar') {
	                schema["form"].push("defaultBarWidth");
	            }
	            schema["form"].push("shadowSize");
	            schema["form"].push({
	                "key": "fontColor",
	                "type": "color"
	            });
	            schema["form"].push("fontSize");
	            schema["form"].push("tooltipIndividual");
	            schema["form"].push("tooltipCumulative");
	            schema["form"].push({
	                "key": "tooltipValueFormatter",
	                "type": "javascript"
	            });
	            schema["form"].push({
	                "key": "grid",
	                "items": [{
	                    "key": "grid.color",
	                    "type": "color"
	                }, {
	                    "key": "grid.backgroundColor",
	                    "type": "color"
	                }, {
	                    "key": "grid.tickColor",
	                    "type": "color"
	                }, "grid.outlineWidth", "grid.verticalLines", "grid.horizontalLines"]
	            });
	            schema["form"].push({
	                "key": "xaxis",
	                "items": ["xaxis.showLabels", "xaxis.title", "xaxis.titleAngle", {
	                    "key": "xaxis.color",
	                    "type": "color"
	                }]
	            });
	            schema["form"].push({
	                "key": "yaxis",
	                "items": ["yaxis.min", "yaxis.max", "yaxis.tickDecimals", "yaxis.tickSize", "yaxis.showLabels", "yaxis.title", "yaxis.titleAngle", {
	                    "key": "yaxis.color",
	                    "type": "color"
	                }, {
	                    "key": "yaxis.ticksFormatter",
	                    "type": "javascript"
	                }]
	            });
	            return schema;
	        }
	    }, {
	        key: 'datakeySettingsSchema',
	        value: function datakeySettingsSchema(defaultShowLines) {
	            return {
	                "schema": {
	                    "type": "object",
	                    "title": "DataKeySettings",
	                    "properties": {
	                        "showLines": {
	                            "title": "Show lines",
	                            "type": "boolean",
	                            "default": defaultShowLines
	                        },
	                        "fillLines": {
	                            "title": "Fill lines",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "showPoints": {
	                            "title": "Show points",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "tooltipValueFormatter": {
	                            "title": "Tooltip value format function, f(value)",
	                            "type": "string",
	                            "default": ""
	                        },
	                        "showSeparateAxis": {
	                            "title": "Show separate axis",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "axisMin": {
	                            "title": "Minimum value on the axis scale",
	                            "type": "number",
	                            "default": null
	                        },
	                        "axisMax": {
	                            "title": "Maximum value on the axis scale",
	                            "type": "number",
	                            "default": null
	                        },
	                        "axisTitle": {
	                            "title": "Axis title",
	                            "type": "string",
	                            "default": ""
	                        },
	                        "axisTickDecimals": {
	                            "title": "Axis tick number of digits after floating point",
	                            "type": "number",
	                            "default": null
	                        },
	                        "axisTickSize": {
	                            "title": "Axis step size between ticks",
	                            "type": "number",
	                            "default": null
	                        },
	                        "axisPosition": {
	                            "title": "Axis position",
	                            "type": "string",
	                            "default": "left"
	                        },
	                        "axisTicksFormatter": {
	                            "title": "Ticks formatter function, f(value)",
	                            "type": "string",
	                            "default": ""
	                        }
	                    },
	                    "required": ["showLines", "fillLines", "showPoints"]
	                },
	                "form": ["showLines", "fillLines", "showPoints", {
	                    "key": "tooltipValueFormatter",
	                    "type": "javascript"
	                }, "showSeparateAxis", "axisMin", "axisMax", "axisTitle", "axisTickDecimals", "axisTickSize", {
	                    "key": "axisPosition",
	                    "type": "rc-select",
	                    "multiple": false,
	                    "items": [{
	                        "value": "left",
	                        "label": "Left"
	                    }, {
	                        "value": "right",
	                        "label": "Right"
	                    }]
	                }, {
	                    "key": "axisTicksFormatter",
	                    "type": "javascript"
	                }]
	            };
	        }
	    }, {
	        key: 'pieSettingsSchema',
	        get: function get() {
	            return {
	                "schema": {
	                    "type": "object",
	                    "title": "Settings",
	                    "properties": {
	                        "radius": {
	                            "title": "Radius",
	                            "type": "number",
	                            "default": 1
	                        },
	                        "innerRadius": {
	                            "title": "Inner radius",
	                            "type": "number",
	                            "default": 0
	                        },
	                        "tilt": {
	                            "title": "Tilt",
	                            "type": "number",
	                            "default": 1
	                        },
	                        "animatedPie": {
	                            "title": "Enable pie animation (experimental)",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "stroke": {
	                            "title": "Stroke",
	                            "type": "object",
	                            "properties": {
	                                "color": {
	                                    "title": "Color",
	                                    "type": "string",
	                                    "default": ""
	                                },
	                                "width": {
	                                    "title": "Width (pixels)",
	                                    "type": "number",
	                                    "default": 0
	                                }
	                            }
	                        },
	                        "showLabels": {
	                            "title": "Show labels",
	                            "type": "boolean",
	                            "default": false
	                        },
	                        "fontColor": {
	                            "title": "Font color",
	                            "type": "string",
	                            "default": "#545454"
	                        },
	                        "fontSize": {
	                            "title": "Font size",
	                            "type": "number",
	                            "default": 10
	                        }
	                    },
	                    "required": []
	                },
	                "form": ["radius", "innerRadius", "animatedPie", "tilt", {
	                    "key": "stroke",
	                    "items": [{
	                        "key": "stroke.color",
	                        "type": "color"
	                    }, "stroke.width"]
	                }, "showLabels", {
	                    "key": "fontColor",
	                    "type": "color"
	                }, "fontSize"]
	            };
	        }
	    }, {
	        key: 'pieDatakeySettingsSchema',
	        get: function get() {
	            return {};
	        }
	    }]);
	
	    return TbFlot;
	}();
	
	/* eslint-enable angular/angularelement */
	
	
	exports.default = TbFlot;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	__webpack_require__(310);
	
	var _leaflet = __webpack_require__(197);
	
	var L = _interopRequireWildcard(_leaflet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var maxZoom = 4;
	
	var TbImageMap = function () {
	    function TbImageMap(ctx, $containerElement, utils, initCallback, imageUrl, posFunction, imageEntityAlias, imageUrlAttribute) {
	        _classCallCheck(this, TbImageMap);
	
	        this.ctx = ctx;
	        this.utils = utils;
	        this.tooltips = [];
	
	        this.$containerElement = $containerElement;
	        this.$containerElement.css('background', '#fff');
	
	        this.aspect = 0;
	        this.width = 0;
	        this.height = 0;
	        this.markers = [];
	        this.initCallback = initCallback;
	
	        if (angular.isDefined(posFunction) && posFunction.length > 0) {
	            try {
	                this.posFunction = new Function('origXPos, origYPos', posFunction);
	            } catch (e) {
	                this.posFunction = null;
	            }
	        }
	        if (!this.posFunction) {
	            this.posFunction = function (origXPos, origYPos) {
	                return { x: origXPos, y: origYPos };
	            };
	        }
	
	        if (!this.subscribeForImageAttribute(imageEntityAlias, imageUrlAttribute)) {
	            this.loadImage(imageUrl, initCallback);
	        }
	    }
	
	    _createClass(TbImageMap, [{
	        key: 'subscribeForImageAttribute',
	        value: function subscribeForImageAttribute(imageEntityAlias, imageUrlAttribute) {
	            if (!imageEntityAlias || !imageEntityAlias.length || !imageUrlAttribute || !imageUrlAttribute.length) {
	                return false;
	            }
	            var entityAliasId = this.ctx.aliasController.getEntityAliasId(imageEntityAlias);
	            if (!entityAliasId) {
	                return false;
	            }
	            var types = this.ctx.$scope.$injector.get('types');
	            var datasources = [{
	                type: types.datasourceType.entity,
	                name: imageEntityAlias,
	                aliasName: imageEntityAlias,
	                entityAliasId: entityAliasId,
	                dataKeys: [{
	                    type: types.dataKeyType.attribute,
	                    name: imageUrlAttribute,
	                    label: imageUrlAttribute,
	                    settings: {},
	                    _hash: Math.random()
	                }]
	            }];
	            var imageMap = this;
	            var imageUrlSubscriptionOptions = {
	                datasources: datasources,
	                useDashboardTimewindow: false,
	                type: types.widgetType.latest.value,
	                callbacks: {
	                    onDataUpdated: function onDataUpdated(subscription, apply) {
	                        imageMap.imageUrlDataUpdated(subscription, apply);
	                    }
	                }
	            };
	            this.ctx.subscriptionApi.createSubscription(imageUrlSubscriptionOptions, true).then(function (subscription) {
	                imageMap.imageUrlSubscription = subscription;
	            });
	            return true;
	        }
	    }, {
	        key: 'imageUrlDataUpdated',
	        value: function imageUrlDataUpdated(subscription, apply) {
	            var data = subscription.data;
	            if (data.length) {
	                var keyData = data[0];
	                if (keyData && keyData.data && keyData.data[0]) {
	                    var attrValue = keyData.data[0][1];
	                    if (attrValue && attrValue.length) {
	                        this.loadImage(attrValue, this.aspect > 0 ? null : this.initCallback, true);
	                    }
	                }
	            }
	            if (apply) {
	                this.ctx.$scope.$digest();
	            }
	        }
	    }, {
	        key: 'loadImage',
	        value: function loadImage(imageUrl, initCallback, updateImage) {
	            if (!imageUrl) {
	                imageUrl = 'data:image/svg+xml;base64,PHN2ZyBpZD0ic3ZnMiIgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMTAwIiB3aWR0aD0iMTAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPgogPGcgaWQ9ImxheWVyMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtOTUyLjM2KSI+CiAgPHJlY3QgaWQ9InJlY3Q0Njg0IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBoZWlnaHQ9Ijk5LjAxIiB3aWR0aD0iOTkuMDEiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiB5PSI5NTIuODYiIHg9Ii40OTUwNSIgc3Ryb2tlLXdpZHRoPSIuOTkwMTAiIGZpbGw9IiNlZWUiLz4KICA8dGV4dCBpZD0idGV4dDQ2ODYiIHN0eWxlPSJ3b3JkLXNwYWNpbmc6MHB4O2xldHRlci1zcGFjaW5nOjBweDt0ZXh0LWFuY2hvcjptaWRkbGU7dGV4dC1hbGlnbjpjZW50ZXIiIGZvbnQtd2VpZ2h0PSJib2xkIiB4bWw6c3BhY2U9InByZXNlcnZlIiBmb250LXNpemU9IjEwcHgiIGxpbmUtaGVpZ2h0PSIxMjUlIiB5PSI5NzAuNzI4MDkiIHg9IjQ5LjM5NjQ3NyIgZm9udC1mYW1pbHk9IlJvYm90byIgZmlsbD0iIzY2NjY2NiI+PHRzcGFuIGlkPSJ0c3BhbjQ2OTAiIHg9IjUwLjY0NjQ3NyIgeT0iOTcwLjcyODA5Ij5JbWFnZSBiYWNrZ3JvdW5kIDwvdHNwYW4+PHRzcGFuIGlkPSJ0c3BhbjQ2OTIiIHg9IjQ5LjM5NjQ3NyIgeT0iOTgzLjIyODA5Ij5pcyBub3QgY29uZmlndXJlZDwvdHNwYW4+PC90ZXh0PgogIDxyZWN0IGlkPSJyZWN0NDY5NCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgaGVpZ2h0PSIxOS4zNiIgd2lkdGg9IjY5LjM2IiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgeT0iOTkyLjY4IiB4PSIxNS4zMiIgc3Ryb2tlLXdpZHRoPSIuNjM5ODYiIGZpbGw9Im5vbmUiLz4KIDwvZz4KPC9zdmc+Cg==';
	            }
	            this.imageUrl = imageUrl;
	            var imageMap = this;
	            this.utils.loadImageAspect(imageUrl).then(function (aspect) {
	                imageMap.aspect = aspect;
	                imageMap.onresize(updateImage);
	                if (initCallback) {
	                    setTimeout(initCallback, 0); //eslint-disable-line
	                }
	            });
	        }
	    }, {
	        key: 'onresize',
	        value: function onresize(updateImage) {
	            if (this.aspect > 0) {
	                var width = this.$containerElement.width();
	                if (width > 0) {
	                    var height = width / this.aspect;
	                    var imageMapHeight = this.$containerElement.height();
	                    if (imageMapHeight > 0 && height > imageMapHeight) {
	                        height = imageMapHeight;
	                        width = height * this.aspect;
	                    }
	                    width *= maxZoom;
	                    var prevWidth = this.width;
	                    var prevHeight = this.height;
	                    if (this.width !== width) {
	                        this.width = width;
	                        this.height = width / this.aspect;
	                        if (!this.map) {
	                            this.initMap(updateImage);
	                        } else {
	                            var lastCenterPos = this.latLngToPoint(this.map.getCenter());
	                            lastCenterPos.x /= prevWidth;
	                            lastCenterPos.y /= prevHeight;
	                            this.updateBounds(updateImage, lastCenterPos);
	                            this.map.invalidateSize(true);
	                            this.updateMarkers();
	                        }
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'initMap',
	        value: function initMap(updateImage) {
	            if (!this.map && this.aspect > 0) {
	                var center = this.pointToLatLng(this.width / 2, this.height / 2);
	                this.map = L.map(this.$containerElement[0], {
	                    minZoom: 1,
	                    maxZoom: maxZoom,
	                    center: center,
	                    zoom: 1,
	                    crs: L.CRS.Simple,
	                    attributionControl: false
	                });
	                this.updateBounds(updateImage);
	                this.updateMarkers();
	            }
	        }
	    }, {
	        key: 'pointToLatLng',
	        value: function pointToLatLng(x, y) {
	            return L.CRS.Simple.pointToLatLng({ x: x, y: y }, maxZoom - 1);
	        }
	    }, {
	        key: 'latLngToPoint',
	        value: function latLngToPoint(latLng) {
	            return L.CRS.Simple.latLngToPoint(latLng, maxZoom - 1);
	        }
	    }, {
	        key: 'inited',
	        value: function inited() {
	            return angular.isDefined(this.map);
	        }
	    }, {
	        key: 'updateBounds',
	        value: function updateBounds(updateImage, lastCenterPos) {
	            var _this = this;
	
	            var w = this.width;
	            var h = this.height;
	            var southWest = this.pointToLatLng(0, h);
	            var northEast = this.pointToLatLng(w, 0);
	            var bounds = new L.LatLngBounds(southWest, northEast);
	
	            if (updateImage && this.imageOverlay) {
	                this.imageOverlay.remove();
	                this.imageOverlay = null;
	            }
	
	            if (this.imageOverlay) {
	                this.imageOverlay.setBounds(bounds);
	            } else {
	                this.imageOverlay = L.imageOverlay(this.imageUrl, bounds).addTo(this.map);
	            }
	            var padding = 200 * maxZoom;
	            southWest = this.pointToLatLng(-padding, h + padding);
	            northEast = this.pointToLatLng(w + padding, -padding);
	            var maxBounds = new L.LatLngBounds(southWest, northEast);
	            this.map.setMaxBounds(maxBounds);
	            if (lastCenterPos) {
	                lastCenterPos.x *= w;
	                lastCenterPos.y *= h;
	                var center = this.pointToLatLng(lastCenterPos.x, lastCenterPos.y);
	                this.ctx.$scope.$injector.get('$mdUtil').nextTick(function () {
	                    _this.map.panTo(center, { animate: false });
	                });
	            }
	        }
	    }, {
	        key: 'updateMarkerLabel',
	        value: function updateMarkerLabel(marker, settings) {
	            marker.unbindTooltip();
	            marker.bindTooltip('<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>', { className: 'tb-marker-label', permanent: true, direction: 'top', offset: marker.tooltipOffset });
	        }
	    }, {
	        key: 'updateMarkerColor',
	        value: function updateMarkerColor(marker, color) {
	            this.createDefaultMarkerIcon(marker, color, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	            });
	        }
	    }, {
	        key: 'updateMarkerIcon',
	        value: function updateMarkerIcon(marker, settings) {
	            this.createMarkerIcon(marker, settings, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	                if (settings.showLabel) {
	                    marker.unbindTooltip();
	                    marker.tooltipOffset = [0, -iconInfo.size[1] * marker.offsetY + 10];
	                    marker.bindTooltip('<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>', { className: 'tb-marker-label', permanent: true, direction: 'top', offset: marker.tooltipOffset });
	                }
	            });
	        }
	    }, {
	        key: 'createMarkerIcon',
	        value: function createMarkerIcon(marker, settings, onMarkerIconReady) {
	            var currentImage = settings.currentImage;
	            var opMap = this;
	            if (currentImage && currentImage.url) {
	                this.utils.loadImageAspect(currentImage.url).then(function (aspect) {
	                    if (aspect) {
	                        var width;
	                        var height;
	                        if (aspect > 1) {
	                            width = currentImage.size;
	                            height = currentImage.size / aspect;
	                        } else {
	                            width = currentImage.size * aspect;
	                            height = currentImage.size;
	                        }
	                        var icon = L.icon({
	                            iconUrl: currentImage.url,
	                            iconSize: [width, height],
	                            iconAnchor: [marker.offsetX * width, marker.offsetY * height],
	                            popupAnchor: [0, -height]
	                        });
	                        var iconInfo = {
	                            size: [width, height],
	                            icon: icon
	                        };
	                        onMarkerIconReady(iconInfo);
	                    } else {
	                        opMap.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
	                    }
	                });
	            } else {
	                this.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
	            }
	        }
	    }, {
	        key: 'createDefaultMarkerIcon',
	        value: function createDefaultMarkerIcon(marker, color, onMarkerIconReady) {
	            var pinColor = color.substr(1);
	            var icon = L.icon({
	                iconUrl: 'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|' + pinColor,
	                iconSize: [21, 34],
	                iconAnchor: [21 * marker.offsetX, 34 * marker.offsetY],
	                popupAnchor: [0, -34],
	                shadowUrl: 'https://chart.apis.google.com/chart?chst=d_map_pin_shadow',
	                shadowSize: [40, 37],
	                shadowAnchor: [12, 35]
	            });
	            var iconInfo = {
	                size: [21, 34],
	                icon: icon
	            };
	            onMarkerIconReady(iconInfo);
	        }
	    }, {
	        key: 'createMarker',
	        value: function createMarker(position, settings, onClickListener, markerArgs) {
	            var pos = this.posFunction(position.x, position.y);
	            var x = pos.x * this.width;
	            var y = pos.y * this.height;
	            var location = this.pointToLatLng(x, y);
	            var marker = L.marker(location, {}); //.addTo(this.map);
	            marker.position = position;
	            marker.offsetX = settings.markerOffsetX;
	            marker.offsetY = settings.markerOffsetY;
	            var opMap = this;
	            this.createMarkerIcon(marker, settings, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	                if (settings.showLabel) {
	                    marker.tooltipOffset = [0, -iconInfo.size[1] * marker.offsetY + 10];
	                    marker.bindTooltip('<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>', { className: 'tb-marker-label', permanent: true, direction: 'top', offset: marker.tooltipOffset });
	                }
	                marker.addTo(opMap.map);
	            });
	
	            if (settings.displayTooltip) {
	                this.createTooltip(marker, settings.tooltipPattern, settings.tooltipReplaceInfo, settings.autocloseTooltip, markerArgs);
	            }
	
	            if (onClickListener) {
	                marker.on('click', onClickListener);
	            }
	            this.markers.push(marker);
	            return marker;
	        }
	    }, {
	        key: 'updateMarkers',
	        value: function updateMarkers() {
	            var _this2 = this;
	
	            this.markers.forEach(function (marker) {
	                _this2.updateMarkerLocation(marker);
	            });
	        }
	    }, {
	        key: 'updateMarkerLocation',
	        value: function updateMarkerLocation(marker) {
	            this.setMarkerPosition(marker, marker.position);
	        }
	    }, {
	        key: 'removeMarker',
	        value: function removeMarker(marker) {
	            this.map.removeLayer(marker);
	            var index = this.markers.indexOf(marker);
	            if (index > -1) {
	                marker.pinElement.remove();
	                this.markers.splice(index, 1);
	            }
	        }
	    }, {
	        key: 'createTooltip',
	        value: function createTooltip(marker, pattern, replaceInfo, autoClose, markerArgs) {
	            var popup = L.popup();
	            popup.setContent('');
	            marker.bindPopup(popup, { autoClose: autoClose, closeOnClick: false });
	            this.tooltips.push({
	                markerArgs: markerArgs,
	                popup: popup,
	                pattern: pattern,
	                replaceInfo: replaceInfo
	            });
	        }
	    }, {
	        key: 'updatePolylineColor',
	        value: function updatePolylineColor() /*polyline, settings, color*/{}
	    }, {
	        key: 'createPolyline',
	        value: function createPolyline() /*locations, settings*/{}
	    }, {
	        key: 'removePolyline',
	        value: function removePolyline() /*polyline*/{}
	    }, {
	        key: 'fitBounds',
	        value: function fitBounds() {}
	    }, {
	        key: 'createLatLng',
	        value: function createLatLng(x, y) {
	            return new Position(x, y);
	        }
	    }, {
	        key: 'extendBoundsWithMarker',
	        value: function extendBoundsWithMarker() {}
	    }, {
	        key: 'getMarkerPosition',
	        value: function getMarkerPosition(marker) {
	            return marker.position;
	        }
	    }, {
	        key: 'setMarkerPosition',
	        value: function setMarkerPosition(marker, position) {
	            marker.position = position;
	            var pos = this.posFunction(position.x, position.y);
	            var x = pos.x * this.width;
	            var y = pos.y * this.height;
	            var location = this.pointToLatLng(x, y);
	            marker.setLatLng(location);
	        }
	    }, {
	        key: 'getPolylineLatLngs',
	        value: function getPolylineLatLngs() /*polyline*/{}
	    }, {
	        key: 'setPolylineLatLngs',
	        value: function setPolylineLatLngs() /*polyline, latLngs*/{}
	    }, {
	        key: 'createBounds',
	        value: function createBounds() {
	            return {};
	        }
	    }, {
	        key: 'extendBounds',
	        value: function extendBounds() {}
	    }, {
	        key: 'invalidateSize',
	        value: function invalidateSize() {
	            this.onresize();
	        }
	    }, {
	        key: 'getTooltips',
	        value: function getTooltips() {
	            return this.tooltips;
	        }
	    }]);
	
	    return TbImageMap;
	}();
	
	exports.default = TbImageMap;
	
	var Position = function () {
	    function Position(x, y) {
	        _classCallCheck(this, Position);
	
	        this.x = x;
	        this.y = y;
	    }
	
	    _createClass(Position, [{
	        key: 'equals',
	        value: function equals(loc) {
	            return loc && loc.x == this.x && loc.y == this.y;
	        }
	    }]);
	
	    return Position;
	}();

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _googleMap = __webpack_require__(514);
	
	var _googleMap2 = _interopRequireDefault(_googleMap);
	
	var _openstreetMap = __webpack_require__(515);
	
	var _openstreetMap2 = _interopRequireDefault(_openstreetMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function procesTooltipPattern(tbMap, pattern, datasources, dsIndex) {
	    var match = tbMap.varsRegex.exec(pattern);
	    var replaceInfo = {};
	    replaceInfo.variables = [];
	    while (match !== null) {
	        var variableInfo = {};
	        variableInfo.dataKeyIndex = -1;
	        var variable = match[0];
	        var label = match[1];
	        var valDec = 2;
	        var splitVals = label.split(':');
	        if (splitVals.length > 1) {
	            label = splitVals[0];
	            valDec = parseFloat(splitVals[1]);
	        }
	        variableInfo.variable = variable;
	        variableInfo.valDec = valDec;
	
	        if (label.startsWith('#')) {
	            var keyIndexStr = label.substring(1);
	            var n = Math.floor(Number(keyIndexStr));
	            if (String(n) === keyIndexStr && n >= 0) {
	                variableInfo.dataKeyIndex = n;
	            }
	        }
	        if (variableInfo.dataKeyIndex === -1) {
	            var offset = 0;
	            for (var i = 0; i < datasources.length; i++) {
	                var datasource = datasources[i];
	                if (angular.isUndefined(dsIndex) || dsIndex == i) {
	                    for (var k = 0; k < datasource.dataKeys.length; k++) {
	                        var dataKey = datasource.dataKeys[k];
	                        if (dataKey.label === label) {
	                            variableInfo.dataKeyIndex = offset + k;
	                            break;
	                        }
	                    }
	                }
	                offset += datasource.dataKeys.length;
	            }
	        }
	        replaceInfo.variables.push(variableInfo);
	        match = tbMap.varsRegex.exec(pattern);
	    }
	    return replaceInfo;
	}
	
	var TbMapWidget = function () {
	    function TbMapWidget(mapProvider, drawRoutes, ctx, useDynamicLocations, $element) {
	        _classCallCheck(this, TbMapWidget);
	
	        var tbMap = this;
	        this.ctx = ctx;
	        if (!$element) {
	            $element = ctx.$container;
	        }
	        this.utils = ctx.$scope.$injector.get('utils');
	        this.drawRoutes = drawRoutes;
	        this.markers = [];
	        if (this.drawRoutes) {
	            this.polylines = [];
	        }
	        this.locationsSettings = [];
	        this.varsRegex = /\$\{([^\}]*)\}/g;
	
	        var settings = ctx.settings;
	
	        this.callbacks = {};
	        this.callbacks.onLocationClick = function () {};
	
	        if (settings.defaultZoomLevel) {
	            if (settings.defaultZoomLevel > 0 && settings.defaultZoomLevel < 21) {
	                this.defaultZoomLevel = Math.floor(settings.defaultZoomLevel);
	            }
	        }
	
	        this.dontFitMapBounds = settings.fitMapBounds === false;
	
	        if (!useDynamicLocations) {
	            this.subscription = this.ctx.defaultSubscription;
	            this.configureLocationsFromSettings();
	        }
	
	        var minZoomLevel = this.drawRoutes ? 18 : 15;
	
	        var initCallback = function initCallback() {
	            tbMap.update();
	            tbMap.resize();
	        };
	
	        if (mapProvider === 'google-map') {
	            this.map = new _googleMap2.default($element, this.utils, initCallback, this.defaultZoomLevel, this.dontFitMapBounds, minZoomLevel, settings.gmApiKey, settings.gmDefaultMapType);
	        } else if (mapProvider === 'openstreet-map') {
	            this.map = new _openstreetMap2.default($element, this.utils, initCallback, this.defaultZoomLevel, this.dontFitMapBounds, minZoomLevel);
	        }
	    }
	
	    _createClass(TbMapWidget, [{
	        key: 'setCallbacks',
	        value: function setCallbacks(callbacks) {
	            Object.assign(this.callbacks, callbacks);
	        }
	    }, {
	        key: 'clearLocations',
	        value: function clearLocations() {
	            if (this.locations) {
	                var tbMap = this;
	                this.locations.forEach(function (location) {
	                    if (location.marker) {
	                        tbMap.map.removeMarker(location.marker);
	                    }
	                    if (location.polyline) {
	                        tbMap.map.removePolyline(location.polyline);
	                    }
	                });
	                this.locations = null;
	                this.markers = [];
	                if (this.drawRoutes) {
	                    this.polylines = [];
	                }
	            }
	        }
	    }, {
	        key: 'configureLocationsFromSubscription',
	        value: function configureLocationsFromSubscription(subscription, subscriptionLocationSettings) {
	            this.subscription = subscription;
	            this.clearLocations();
	            this.locationsSettings = [];
	            var latKeyName = subscriptionLocationSettings.latKeyName;
	            var lngKeyName = subscriptionLocationSettings.lngKeyName;
	            var index = 0;
	            for (var i = 0; i < subscription.datasources.length; i++) {
	                var datasource = subscription.datasources[i];
	                var dataKeys = datasource.dataKeys;
	                var latKeyIndex = -1;
	                var lngKeyIndex = -1;
	                var localLatKeyName = latKeyName;
	                var localLngKeyName = lngKeyName;
	                for (var k = 0; k < dataKeys.length; k++) {
	                    var dataKey = dataKeys[k];
	                    if (dataKey.name === latKeyName) {
	                        latKeyIndex = index;
	                        localLatKeyName = localLatKeyName + index;
	                        dataKey.locationAttrName = localLatKeyName;
	                    } else if (dataKey.name === lngKeyName) {
	                        lngKeyIndex = index;
	                        localLngKeyName = localLngKeyName + index;
	                        dataKey.locationAttrName = localLngKeyName;
	                    }
	                    if (latKeyIndex > -1 && lngKeyIndex > -1) {
	                        var locationsSettings = {
	                            latKeyName: localLatKeyName,
	                            lngKeyName: localLngKeyName,
	                            showLabel: subscriptionLocationSettings.showLabel !== false,
	                            displayTooltip: subscriptionLocationSettings.displayTooltip !== false,
	                            label: datasource.name,
	                            labelText: datasource.name,
	                            labelColor: subscriptionLocationSettings.labelColor || this.ctx.widgetConfig.color || '#000000',
	                            color: "#FE7569",
	                            useColorFunction: false,
	                            colorFunction: null,
	                            markerImage: null,
	                            markerImageSize: 34,
	                            useMarkerImage: false,
	                            useMarkerImageFunction: false,
	                            markerImageFunction: null,
	                            markerImages: [],
	                            tooltipPattern: subscriptionLocationSettings.tooltipPattern || "<b>Latitude:</b> ${latitude:7}<br/><b>Longitude:</b> ${longitude:7}"
	                        };
	
	                        locationsSettings.tooltipReplaceInfo = procesTooltipPattern(this, locationsSettings.tooltipPattern, this.subscription.datasources, i);
	
	                        locationsSettings.useColorFunction = subscriptionLocationSettings.useColorFunction === true;
	                        if (angular.isDefined(subscriptionLocationSettings.colorFunction) && subscriptionLocationSettings.colorFunction.length > 0) {
	                            try {
	                                locationsSettings.colorFunction = new Function('data, dsData, dsIndex', subscriptionLocationSettings.colorFunction);
	                            } catch (e) {
	                                locationsSettings.colorFunction = null;
	                            }
	                        }
	
	                        this.locationsSettings.push(locationsSettings);
	                        latKeyIndex = -1;
	                        lngKeyIndex = -1;
	                    }
	                    index++;
	                }
	            }
	        }
	    }, {
	        key: 'configureLocationsFromSettings',
	        value: function configureLocationsFromSettings() {
	            var configuredLocationsSettings = this.drawRoutes ? this.ctx.settings.routesSettings : this.ctx.settings.markersSettings;
	            if (!configuredLocationsSettings) {
	                configuredLocationsSettings = [];
	            }
	
	            for (var i = 0; i < configuredLocationsSettings.length; i++) {
	                this.locationsSettings[i] = {
	                    latKeyName: "lat",
	                    lngKeyName: "lng",
	                    showLabel: true,
	                    displayTooltip: true,
	                    label: "",
	                    labelText: "",
	                    labelColor: this.ctx.widgetConfig.color || '#000000',
	                    color: "#FE7569",
	                    useColorFunction: false,
	                    colorFunction: null,
	                    markerImage: null,
	                    markerImageSize: 34,
	                    useMarkerImage: false,
	                    useMarkerImageFunction: false,
	                    markerImageFunction: null,
	                    markerImages: [],
	                    tooltipPattern: "<b>Latitude:</b> ${lat:7}<br/><b>Longitude:</b> ${lng:7}"
	                };
	
	                if (this.drawRoutes) {
	                    this.locationsSettings[i].strokeWeight = 2;
	                    this.locationsSettings[i].strokeOpacity = 1.0;
	                }
	
	                if (configuredLocationsSettings[i]) {
	                    this.locationsSettings[i].latKeyName = configuredLocationsSettings[i].latKeyName || this.locationsSettings[i].latKeyName;
	                    this.locationsSettings[i].lngKeyName = configuredLocationsSettings[i].lngKeyName || this.locationsSettings[i].lngKeyName;
	
	                    this.locationsSettings[i].tooltipPattern = configuredLocationsSettings[i].tooltipPattern || "<b>Latitude:</b> ${" + this.locationsSettings[i].latKeyName + ":7}<br/><b>Longitude:</b> ${" + this.locationsSettings[i].lngKeyName + ":7}";
	
	                    this.locationsSettings[i].tooltipReplaceInfo = procesTooltipPattern(this, this.locationsSettings[i].tooltipPattern, this.subscription.datasources);
	
	                    this.locationsSettings[i].showLabel = configuredLocationsSettings[i].showLabel !== false;
	                    this.locationsSettings[i].label = configuredLocationsSettings[i].label || this.locationsSettings[i].label;
	                    this.locationsSettings[i].labelText = this.locationsSettings[i].label;
	                    this.locationsSettings[i].color = configuredLocationsSettings[i].color ? (0, _tinycolor2.default)(configuredLocationsSettings[i].color).toHexString() : this.locationsSettings[i].color;
	
	                    this.locationsSettings[i].useColorFunction = configuredLocationsSettings[i].useColorFunction === true;
	                    if (angular.isDefined(configuredLocationsSettings[i].colorFunction) && configuredLocationsSettings[i].colorFunction.length > 0) {
	                        try {
	                            this.locationsSettings[i].colorFunction = new Function('data, dsData, dsIndex', configuredLocationsSettings[i].colorFunction);
	                        } catch (e) {
	                            this.locationsSettings[i].colorFunction = null;
	                        }
	                    }
	
	                    this.locationsSettings[i].useMarkerImageFunction = configuredLocationsSettings[i].useMarkerImageFunction === true;
	                    if (angular.isDefined(configuredLocationsSettings[i].markerImageFunction) && configuredLocationsSettings[i].markerImageFunction.length > 0) {
	                        try {
	                            this.locationsSettings[i].markerImageFunction = new Function('data, images, dsData, dsIndex', configuredLocationsSettings[i].markerImageFunction);
	                        } catch (e) {
	                            this.locationsSettings[i].markerImageFunction = null;
	                        }
	                    }
	
	                    this.locationsSettings[i].markerImages = configuredLocationsSettings[i].markerImages || [];
	
	                    if (!this.locationsSettings[i].useMarkerImageFunction && angular.isDefined(configuredLocationsSettings[i].markerImage) && configuredLocationsSettings[i].markerImage.length > 0) {
	                        this.locationsSettings[i].useMarkerImage = true;
	                        var url = this.ctx.settings.markerImage;
	                        var size = this.ctx.settings.markerImageSize || 34;
	                        this.locationsSettings[i].currentImage = {
	                            url: url,
	                            size: size
	                        };
	                    }
	
	                    if (this.drawRoutes) {
	                        this.locationsSettings[i].strokeWeight = configuredLocationsSettings[i].strokeWeight || this.locationsSettings[i].strokeWeight;
	                        this.locationsSettings[i].strokeOpacity = angular.isDefined(configuredLocationsSettings[i].strokeOpacity) ? configuredLocationsSettings[i].strokeOpacity : this.locationsSettings[i].strokeOpacity;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'update',
	        value: function update() {
	
	            var tbMap = this;
	
	            function isNumber(n) {
	                return !isNaN(parseFloat(n)) && isFinite(n);
	            }
	
	            function padValue(val, dec, int) {
	                var i = 0;
	                var s, strVal, n;
	
	                val = parseFloat(val);
	                n = val < 0;
	                val = Math.abs(val);
	
	                if (dec > 0) {
	                    strVal = val.toFixed(dec).toString().split('.');
	                    s = int - strVal[0].length;
	
	                    for (; i < s; ++i) {
	                        strVal[0] = '0' + strVal[0];
	                    }
	
	                    strVal = (n ? '-' : '') + strVal[0] + '.' + strVal[1];
	                } else {
	                    strVal = Math.round(val).toString();
	                    s = int - strVal.length;
	
	                    for (; i < s; ++i) {
	                        strVal = '0' + strVal;
	                    }
	
	                    strVal = (n ? '-' : '') + strVal;
	                }
	
	                return strVal;
	            }
	
	            function arraysEqual(a, b) {
	                if (a === b) return true;
	                if (a === null || b === null) return false;
	                if (a.length != b.length) return false;
	
	                for (var i = 0; i < a.length; ++i) {
	                    if (!a[i].equals(b[i])) return false;
	                }
	                return true;
	            }
	
	            function calculateLocationColor(location, dataMap) {
	                if (location.settings.useColorFunction && location.settings.colorFunction) {
	                    var color = '#FE7569';
	                    try {
	                        color = location.settings.colorFunction(dataMap.dataMap, dataMap.dsDataMap, location.dsIndex);
	                    } catch (e) {
	                        color = '#FE7569';
	                    }
	                    return (0, _tinycolor2.default)(color).toHexString();
	                } else {
	                    return location.settings.color;
	                }
	            }
	
	            function updateLocationColor(location, dataMap) {
	                var color = calculateLocationColor(location, dataMap);
	                if (!location.settings.calculatedColor || location.settings.calculatedColor !== color) {
	                    if (!location.settings.useMarkerImage && !location.settings.useMarkerImageFunction) {
	                        tbMap.map.updateMarkerColor(location.marker, color);
	                    }
	                    if (location.polyline) {
	                        tbMap.map.updatePolylineColor(location.polyline, location.settings, color);
	                    }
	                    location.settings.calculatedColor = color;
	                }
	            }
	
	            function calculateLocationMarkerImage(location, dataMap) {
	                if (location.settings.useMarkerImageFunction && location.settings.markerImageFunction) {
	                    var image = null;
	                    try {
	                        image = location.settings.markerImageFunction(dataMap.dataMap, location.settings.markerImages, dataMap.dsDataMap, location.dsIndex);
	                    } catch (e) {
	                        image = null;
	                    }
	                    return image;
	                } else {
	                    return null;
	                }
	            }
	
	            function updateLocationMarkerIcon(location, dataMap) {
	                var image = calculateLocationMarkerImage(location, dataMap);
	                if (image && (!location.settings.currentImage || !angular.equals(location.settings.currentImage, image))) {
	                    location.settings.currentImage = image;
	                    tbMap.map.updateMarkerIcon(location.marker, location.settings);
	                }
	            }
	
	            function updateLocationStyle(location, dataMap) {
	                updateLocationColor(location, dataMap);
	                updateLocationMarkerIcon(location, dataMap);
	            }
	
	            function createOrUpdateLocationMarker(location, markerLocation, dataMap) {
	                var changed = false;
	                if (!location.marker) {
	                    var image = calculateLocationMarkerImage(location, dataMap);
	                    if (image && (!location.settings.currentImage || !angular.equals(location.settings.currentImage, image))) {
	                        location.settings.currentImage = image;
	                    }
	                    location.marker = tbMap.map.createMarker(markerLocation, location.settings, function () {
	                        tbMap.callbacks.onLocationClick(location);
	                    });
	                    tbMap.markers.push(location.marker);
	                    changed = true;
	                } else {
	                    var prevPosition = tbMap.map.getMarkerPosition(location.marker);
	                    if (!prevPosition.equals(markerLocation)) {
	                        tbMap.map.setMarkerPosition(location.marker, markerLocation);
	                        changed = true;
	                    }
	                }
	                return changed;
	            }
	
	            function updateLocation(location, data, dataMap) {
	                var locationChanged = false;
	                if (location.latIndex > -1 && location.lngIndex > -1) {
	                    var latData = data[location.latIndex].data;
	                    var lngData = data[location.lngIndex].data;
	                    var lat, lng, latLng;
	                    if (latData.length > 0 && lngData.length > 0) {
	                        if (tbMap.drawRoutes) {
	                            // Create or update route
	                            var latLngs = [];
	                            for (var i = 0; i < latData.length; i++) {
	                                lat = latData[i][1];
	                                lng = lngData[i][1];
	                                latLng = tbMap.map.createLatLng(lat, lng);
	                                if (i == 0 || !latLngs[latLngs.length - 1].equals(latLng)) {
	                                    latLngs.push(latLng);
	                                }
	                            }
	                            if (latLngs.length > 0) {
	                                var markerLocation = latLngs[latLngs.length - 1];
	                                createOrUpdateLocationMarker(location, markerLocation, dataMap);
	                            }
	                            if (!location.polyline) {
	                                location.polyline = tbMap.map.createPolyline(latLngs, location.settings);
	                                tbMap.polylines.push(location.polyline);
	                                locationChanged = true;
	                            } else {
	                                var prevPath = tbMap.map.getPolylineLatLngs(location.polyline);
	                                if (!prevPath || !arraysEqual(prevPath, latLngs)) {
	                                    tbMap.map.setPolylineLatLngs(location.polyline, latLngs);
	                                    locationChanged = true;
	                                }
	                            }
	                        } else {
	                            // Create or update marker
	                            lat = latData[latData.length - 1][1];
	                            lng = lngData[lngData.length - 1][1];
	                            latLng = tbMap.map.createLatLng(lat, lng);
	                            if (createOrUpdateLocationMarker(location, latLng, dataMap)) {
	                                locationChanged = true;
	                            }
	                        }
	                        updateLocationStyle(location, dataMap);
	                    }
	                }
	                return locationChanged;
	            }
	
	            function toLabelValueMap(data, datasources) {
	                var dataMap = {};
	                var dsDataMap = [];
	                for (var d = 0; d < datasources.length; d++) {
	                    dsDataMap[d] = {};
	                }
	                for (var i = 0; i < data.length; i++) {
	                    var dataKey = data[i].dataKey;
	                    var label = dataKey.label;
	                    var keyData = data[i].data;
	                    var val = null;
	                    if (keyData.length > 0) {
	                        val = keyData[keyData.length - 1][1];
	                    }
	                    dataMap[label] = val;
	                    var dsIndex = datasources.indexOf(data[i].datasource);
	                    dsDataMap[dsIndex][label] = val;
	                }
	                return {
	                    dataMap: dataMap,
	                    dsDataMap: dsDataMap
	                };
	            }
	
	            function loadLocations(data, datasources) {
	                var bounds = tbMap.map.createBounds();
	                tbMap.locations = [];
	                var dataMap = toLabelValueMap(data, datasources);
	                for (var l = 0; l < tbMap.locationsSettings.length; l++) {
	                    var locationSettings = tbMap.locationsSettings[l];
	                    var latIndex = -1;
	                    var lngIndex = -1;
	                    for (var i = 0; i < data.length; i++) {
	                        var dataKey = data[i].dataKey;
	                        var nameToCheck;
	                        if (dataKey.locationAttrName) {
	                            nameToCheck = dataKey.locationAttrName;
	                        } else {
	                            nameToCheck = dataKey.label;
	                        }
	                        if (nameToCheck === locationSettings.latKeyName) {
	                            latIndex = i;
	                        } else if (nameToCheck === locationSettings.lngKeyName) {
	                            lngIndex = i;
	                        }
	                    }
	                    if (latIndex > -1 && lngIndex > -1) {
	                        var ds = data[latIndex].datasource;
	                        var dsIndex = datasources.indexOf(ds);
	                        var location = {
	                            latIndex: latIndex,
	                            lngIndex: lngIndex,
	                            dsIndex: dsIndex,
	                            settings: locationSettings
	                        };
	                        tbMap.locations.push(location);
	                        updateLocation(location, data, dataMap);
	                        if (location.polyline) {
	                            tbMap.map.extendBounds(bounds, location.polyline);
	                        } else if (location.marker) {
	                            tbMap.map.extendBoundsWithMarker(bounds, location.marker);
	                        }
	                    }
	                }
	                tbMap.map.fitBounds(bounds);
	            }
	
	            function updateLocations(data, datasources) {
	                var locationsChanged = false;
	                var bounds = tbMap.map.createBounds();
	                var dataMap = toLabelValueMap(data, datasources);
	                for (var p = 0; p < tbMap.locations.length; p++) {
	                    var location = tbMap.locations[p];
	                    locationsChanged |= updateLocation(location, data, dataMap);
	                    if (location.polyline) {
	                        tbMap.map.extendBounds(bounds, location.polyline);
	                    } else if (location.marker) {
	                        tbMap.map.extendBoundsWithMarker(bounds, location.marker);
	                    }
	                }
	                if (locationsChanged) {
	                    tbMap.map.fitBounds(bounds);
	                }
	            }
	
	            if (this.map && this.map.inited() && this.subscription) {
	                if (this.subscription.data) {
	                    if (!this.locations) {
	                        loadLocations(this.subscription.data, this.subscription.datasources);
	                    } else {
	                        updateLocations(this.subscription.data, this.subscription.datasources);
	                    }
	                    var tooltips = this.map.getTooltips();
	                    for (var t = 0; t < tooltips.length; t++) {
	                        var tooltip = tooltips[t];
	                        var text = tooltip.pattern;
	                        var replaceInfo = tooltip.replaceInfo;
	                        for (var v = 0; v < replaceInfo.variables.length; v++) {
	                            var variableInfo = replaceInfo.variables[v];
	                            var txtVal = '';
	                            if (variableInfo.dataKeyIndex > -1 && this.subscription.data[variableInfo.dataKeyIndex]) {
	                                var varData = this.subscription.data[variableInfo.dataKeyIndex].data;
	                                if (varData.length > 0) {
	                                    var val = varData[varData.length - 1][1];
	                                    if (isNumber(val)) {
	                                        txtVal = padValue(val, variableInfo.valDec, 0);
	                                    } else {
	                                        txtVal = val;
	                                    }
	                                }
	                            }
	                            text = text.split(variableInfo.variable).join(txtVal);
	                        }
	                        tooltip.popup.setContent(text);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'resize',
	        value: function resize() {
	            if (this.map && this.map.inited()) {
	                this.map.invalidateSize();
	                if (this.locations && this.locations.length > 0) {
	                    var bounds = this.map.createBounds();
	                    for (var m = 0; m < this.markers.length; m++) {
	                        this.map.extendBoundsWithMarker(bounds, this.markers[m]);
	                    }
	                    if (this.polylines) {
	                        for (var p = 0; p < this.polylines.length; p++) {
	                            this.map.extendBounds(bounds, this.polylines[p]);
	                        }
	                    }
	                    this.map.fitBounds(bounds);
	                }
	            }
	        }
	    }]);
	
	    return TbMapWidget;
	}();
	
	exports.default = TbMapWidget;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _googleMap = __webpack_require__(514);
	
	var _googleMap2 = _interopRequireDefault(_googleMap);
	
	var _openstreetMap = __webpack_require__(515);
	
	var _openstreetMap2 = _interopRequireDefault(_openstreetMap);
	
	var _imageMap = __webpack_require__(1348);
	
	var _imageMap2 = _interopRequireDefault(_imageMap);
	
	var _tencentMap = __webpack_require__(1356);
	
	var _tencentMap2 = _interopRequireDefault(_tencentMap);
	
	var _widgetUtils = __webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TbMapWidgetV2 = function () {
	    function TbMapWidgetV2(mapProvider, drawRoutes, ctx, useDynamicLocations, $element) {
	        _classCallCheck(this, TbMapWidgetV2);
	
	        var tbMap = this;
	        this.ctx = ctx;
	        this.mapProvider = mapProvider;
	        if (!$element) {
	            $element = ctx.$container;
	        }
	        this.utils = ctx.$scope.$injector.get('utils');
	        this.drawRoutes = drawRoutes;
	        this.markers = [];
	        if (this.drawRoutes) {
	            this.polylines = [];
	        }
	
	        this.locationSettings = {};
	
	        var settings = ctx.settings;
	
	        this.callbacks = {};
	        this.callbacks.onLocationClick = function () {};
	
	        if (settings.defaultZoomLevel) {
	            if (settings.defaultZoomLevel > 0 && settings.defaultZoomLevel < 21) {
	                this.defaultZoomLevel = Math.floor(settings.defaultZoomLevel);
	            }
	        }
	
	        this.dontFitMapBounds = settings.fitMapBounds === false;
	
	        if (!useDynamicLocations) {
	            this.subscription = this.ctx.defaultSubscription;
	        }
	
	        this.configureLocationsSettings();
	
	        var minZoomLevel = this.drawRoutes ? 18 : 15;
	
	        var initCallback = function initCallback() {
	            tbMap.update();
	            tbMap.resize();
	        };
	
	        this.ctx.$scope.onTooltipAction = function (event, actionName, dsIndex) {
	            tbMap.onTooltipAction(event, actionName, dsIndex);
	        };
	        this.tooltipActionsMap = {};
	        var descriptors = this.ctx.actionsApi.getActionDescriptors('tooltipAction');
	        descriptors.forEach(function (descriptor) {
	            tbMap.tooltipActionsMap[descriptor.name] = descriptor;
	        });
	
	        if (mapProvider === 'google-map') {
	            this.map = new _googleMap2.default($element, this.utils, initCallback, this.defaultZoomLevel, this.dontFitMapBounds, minZoomLevel, settings.gmApiKey, settings.gmDefaultMapType);
	        } else if (mapProvider === 'openstreet-map') {
	            this.map = new _openstreetMap2.default($element, this.utils, initCallback, this.defaultZoomLevel, this.dontFitMapBounds, minZoomLevel, settings.mapProvider);
	        } else if (mapProvider === 'image-map') {
	            this.map = new _imageMap2.default(this.ctx, $element, this.utils, initCallback, settings.mapImageUrl, settings.posFunction, settings.imageEntityAlias, settings.imageUrlAttribute);
	        } else if (mapProvider === 'tencent-map') {
	            this.map = new _tencentMap2.default($element, this.utils, initCallback, this.defaultZoomLevel, this.dontFitMapBounds, minZoomLevel, settings.tmApiKey, settings.tmDefaultMapType);
	        }
	    }
	
	    _createClass(TbMapWidgetV2, [{
	        key: 'setCallbacks',
	        value: function setCallbacks(callbacks) {
	            Object.assign(this.callbacks, callbacks);
	        }
	    }, {
	        key: 'clearLocations',
	        value: function clearLocations() {
	            if (this.locations) {
	                var tbMap = this;
	                this.locations.forEach(function (location) {
	                    if (location.marker) {
	                        tbMap.map.removeMarker(location.marker);
	                    }
	                    if (location.polyline) {
	                        tbMap.map.removePolyline(location.polyline);
	                    }
	                });
	                this.locations = null;
	                this.markers = [];
	                if (this.drawRoutes) {
	                    this.polylines = [];
	                }
	            }
	        }
	    }, {
	        key: 'setSubscription',
	        value: function setSubscription(subscription) {
	            this.subscription = subscription;
	            this.clearLocations();
	        }
	    }, {
	        key: 'configureLocationsSettings',
	        value: function configureLocationsSettings() {
	
	            if (this.mapProvider == 'image-map') {
	                this.locationSettings.latKeyName = this.ctx.settings.xPosKeyName || 'xPos';
	                this.locationSettings.lngKeyName = this.ctx.settings.yPosKeyName || 'yPos';
	                this.locationSettings.markerOffsetX = angular.isDefined(this.ctx.settings.markerOffsetX) ? this.ctx.settings.markerOffsetX : 0.5;
	                this.locationSettings.markerOffsetY = angular.isDefined(this.ctx.settings.markerOffsetY) ? this.ctx.settings.markerOffsetY : 1;
	            } else {
	                this.locationSettings.latKeyName = this.ctx.settings.latKeyName || 'latitude';
	                this.locationSettings.lngKeyName = this.ctx.settings.lngKeyName || 'longitude';
	            }
	
	            this.locationSettings.tooltipPattern = this.ctx.settings.tooltipPattern || "<b>${entityName}</b><br/><br/><b>Latitude:</b> ${" + this.locationSettings.latKeyName + ":7}<br/><b>Longitude:</b> ${" + this.locationSettings.lngKeyName + ":7}";
	
	            this.locationSettings.showLabel = this.ctx.settings.showLabel !== false;
	            this.locationSettings.displayTooltip = this.ctx.settings.showTooltip !== false;
	            this.locationSettings.autocloseTooltip = this.ctx.settings.autocloseTooltip !== false;
	            this.locationSettings.labelColor = this.ctx.widgetConfig.color || '#000000', this.locationSettings.label = this.ctx.settings.label || "${entityName}";
	            this.locationSettings.color = this.ctx.settings.color ? (0, _tinycolor2.default)(this.ctx.settings.color).toHexString() : "#FE7569";
	
	            this.locationSettings.useColorFunction = this.ctx.settings.useColorFunction === true;
	            if (angular.isDefined(this.ctx.settings.colorFunction) && this.ctx.settings.colorFunction.length > 0) {
	                try {
	                    this.locationSettings.colorFunction = new Function('data, dsData, dsIndex', this.ctx.settings.colorFunction);
	                } catch (e) {
	                    this.locationSettings.colorFunction = null;
	                }
	            }
	
	            this.locationSettings.useMarkerImageFunction = this.ctx.settings.useMarkerImageFunction === true;
	            if (angular.isDefined(this.ctx.settings.markerImageFunction) && this.ctx.settings.markerImageFunction.length > 0) {
	                try {
	                    this.locationSettings.markerImageFunction = new Function('data, images, dsData, dsIndex', this.ctx.settings.markerImageFunction);
	                } catch (e) {
	                    this.locationSettings.markerImageFunction = null;
	                }
	            }
	
	            this.locationSettings.markerImages = this.ctx.settings.markerImages || [];
	
	            if (!this.locationSettings.useMarkerImageFunction && angular.isDefined(this.ctx.settings.markerImage) && this.ctx.settings.markerImage.length > 0) {
	                this.locationSettings.useMarkerImage = true;
	                var url = this.ctx.settings.markerImage;
	                var size = this.ctx.settings.markerImageSize || 34;
	                this.locationSettings.currentImage = {
	                    url: url,
	                    size: size
	                };
	            }
	
	            if (this.drawRoutes) {
	                this.locationSettings.strokeWeight = this.ctx.settings.strokeWeight || 2;
	                this.locationSettings.strokeOpacity = this.ctx.settings.strokeOpacity || 1.0;
	            }
	        }
	    }, {
	        key: 'onTooltipAction',
	        value: function onTooltipAction(event, actionName, dsIndex) {
	            var descriptor = this.tooltipActionsMap[actionName];
	            if (descriptor) {
	                var datasource = this.subscription.datasources[dsIndex];
	                var entityId = {};
	                entityId.id = datasource.entityId;
	                entityId.entityType = datasource.entityType;
	                var entityName = datasource.entityName;
	                this.ctx.actionsApi.handleWidgetAction(event, descriptor, entityId, entityName);
	            }
	        }
	    }, {
	        key: 'update',
	        value: function update() {
	
	            var tbMap = this;
	
	            function updateLocationLabel(location) {
	                if (location.settings.showLabel && location.settings.labelReplaceInfo.variables.length) {
	                    location.settings.labelText = (0, _widgetUtils.fillPattern)(location.settings.label, location.settings.labelReplaceInfo, tbMap.subscription.data);
	                    tbMap.map.updateMarkerLabel(location.marker, location.settings);
	                }
	            }
	
	            function calculateLocationColor(location, dataMap) {
	                if (location.settings.useColorFunction && location.settings.colorFunction) {
	                    var color;
	                    try {
	                        color = location.settings.colorFunction(dataMap.dataMap, dataMap.dsDataMap, location.dsIndex);
	                    } catch (e) {/**/}
	                    if (!color) {
	                        color = '#FE7569';
	                    }
	                    return (0, _tinycolor2.default)(color).toHexString();
	                } else {
	                    return location.settings.color;
	                }
	            }
	
	            function updateLocationColor(location, color, image) {
	                if (!location.settings.calculatedColor || location.settings.calculatedColor !== color) {
	                    if (!location.settings.useMarkerImage && !image) {
	                        tbMap.map.updateMarkerColor(location.marker, color);
	                    }
	                    if (location.polyline) {
	                        tbMap.map.updatePolylineColor(location.polyline, location.settings, color);
	                    }
	                    location.settings.calculatedColor = color;
	                }
	            }
	
	            function calculateLocationMarkerImage(location, dataMap) {
	                if (location.settings.useMarkerImageFunction && location.settings.markerImageFunction) {
	                    var image = null;
	                    try {
	                        image = location.settings.markerImageFunction(dataMap.dataMap, location.settings.markerImages, dataMap.dsDataMap, location.dsIndex);
	                    } catch (e) {
	                        image = null;
	                    }
	                    return image;
	                } else {
	                    return null;
	                }
	            }
	
	            function updateLocationMarkerIcon(location, image) {
	                if (image && (!location.settings.currentImage || !angular.equals(location.settings.currentImage, image))) {
	                    location.settings.currentImage = image;
	                    tbMap.map.updateMarkerIcon(location.marker, location.settings);
	                }
	            }
	
	            function updateLocationStyle(location, dataMap) {
	                updateLocationLabel(location);
	                var color = calculateLocationColor(location, dataMap);
	                var image = calculateLocationMarkerImage(location, dataMap);
	                updateLocationColor(location, color, image);
	                updateLocationMarkerIcon(location, image);
	            }
	
	            function createOrUpdateLocationMarker(location, markerLocation, dataMap) {
	                var changed = false;
	                if (!location.marker) {
	                    var image = calculateLocationMarkerImage(location, dataMap);
	                    if (image && (!location.settings.currentImage || !angular.equals(location.settings.currentImage, image))) {
	                        location.settings.currentImage = image;
	                    }
	                    location.marker = tbMap.map.createMarker(markerLocation, location.settings, function (event) {
	                        tbMap.callbacks.onLocationClick(location);
	                        locationRowClick(event, location);
	                    }, [location.dsIndex]);
	                    tbMap.markers.push(location.marker);
	                    changed = true;
	                } else {
	                    var prevPosition = tbMap.map.getMarkerPosition(location.marker);
	                    if (!prevPosition.equals(markerLocation)) {
	                        tbMap.map.setMarkerPosition(location.marker, markerLocation);
	                        changed = true;
	                    }
	                }
	                return changed;
	            }
	
	            function locationRowClick($event, location) {
	                var descriptors = tbMap.ctx.actionsApi.getActionDescriptors('markerClick');
	                if (descriptors.length) {
	                    var datasource = tbMap.subscription.datasources[location.dsIndex];
	                    var entityId = {};
	                    entityId.id = datasource.entityId;
	                    entityId.entityType = datasource.entityType;
	                    var entityName = datasource.entityName;
	                    tbMap.ctx.actionsApi.handleWidgetAction($event, descriptors[0], entityId, entityName);
	                }
	            }
	
	            function updateLocation(location, data, dataMap) {
	                var locationChanged = false;
	                if (location.latIndex > -1 && location.lngIndex > -1) {
	                    var latData = data[location.latIndex].data;
	                    var lngData = data[location.lngIndex].data;
	                    var lat, lng, latLng;
	                    if (latData.length > 0 && lngData.length > 0) {
	                        if (tbMap.drawRoutes) {
	                            // Create or update route
	                            var latLngs = [];
	                            for (var i = 0; i < latData.length; i++) {
	                                lat = latData[i][1];
	                                lng = lngData[i][1];
	                                if (angular.isDefined(lat) && lat != null && angular.isDefined(lng) && lng != null) {
	                                    latLng = tbMap.map.createLatLng(lat, lng);
	                                    if (i == 0 || !latLngs[latLngs.length - 1].equals(latLng)) {
	                                        latLngs.push(latLng);
	                                    }
	                                }
	                            }
	                            if (latLngs.length > 0) {
	                                var markerLocation = latLngs[latLngs.length - 1];
	                                createOrUpdateLocationMarker(location, markerLocation, dataMap);
	                            }
	                            if (!location.polyline) {
	                                location.polyline = tbMap.map.createPolyline(latLngs, location.settings);
	                                tbMap.polylines.push(location.polyline);
	                                locationChanged = true;
	                            } else {
	                                var prevPath = tbMap.map.getPolylineLatLngs(location.polyline);
	                                if (!prevPath || !(0, _widgetUtils.arraysEqual)(prevPath, latLngs)) {
	                                    tbMap.map.setPolylineLatLngs(location.polyline, latLngs);
	                                    locationChanged = true;
	                                }
	                            }
	                        } else {
	                            // Create or update marker
	                            lat = latData[latData.length - 1][1];
	                            lng = lngData[lngData.length - 1][1];
	                            if (angular.isDefined(lat) && lat != null && angular.isDefined(lng) && lng != null) {
	                                latLng = tbMap.map.createLatLng(lat, lng);
	                                if (createOrUpdateLocationMarker(location, latLng, dataMap)) {
	                                    locationChanged = true;
	                                }
	                            }
	                        }
	                        if (location.marker) {
	                            updateLocationStyle(location, dataMap);
	                        }
	                    }
	                }
	                return locationChanged;
	            }
	
	            function loadLocations(data, datasources) {
	                var bounds = tbMap.map.createBounds();
	                tbMap.locations = [];
	                var dataMap = (0, _widgetUtils.toLabelValueMap)(data, datasources);
	                var currentDatasource = null;
	                var currentDatasourceIndex = -1;
	                var latIndex = -1;
	                var lngIndex = -1;
	
	                for (var i = 0; i < data.length; i++) {
	                    var dataKeyData = data[i];
	                    var dataKey = dataKeyData.dataKey;
	                    if (dataKeyData.datasource != currentDatasource) {
	                        currentDatasource = dataKeyData.datasource;
	                        currentDatasourceIndex++;
	                        latIndex = -1;
	                        lngIndex = -1;
	                    }
	                    var nameToCheck;
	                    if (dataKey.locationAttrName) {
	                        nameToCheck = dataKey.locationAttrName;
	                    } else {
	                        nameToCheck = dataKey.label;
	                    }
	                    if (nameToCheck === tbMap.locationSettings.latKeyName) {
	                        latIndex = i;
	                    } else if (nameToCheck === tbMap.locationSettings.lngKeyName) {
	                        lngIndex = i;
	                    }
	                    if (latIndex > -1 && lngIndex > -1) {
	                        var location = {
	                            latIndex: latIndex,
	                            lngIndex: lngIndex,
	                            dsIndex: currentDatasourceIndex,
	                            settings: angular.copy(tbMap.locationSettings)
	                        };
	                        if (location.settings.showLabel) {
	                            location.settings.label = tbMap.utils.createLabelFromDatasource(currentDatasource, location.settings.label);
	                            location.settings.labelReplaceInfo = (0, _widgetUtils.processPattern)(location.settings.label, datasources, currentDatasourceIndex);
	                            location.settings.labelText = location.settings.label;
	                        }
	                        if (location.settings.displayTooltip) {
	                            location.settings.tooltipPattern = tbMap.utils.createLabelFromDatasource(currentDatasource, location.settings.tooltipPattern);
	                            location.settings.tooltipReplaceInfo = (0, _widgetUtils.processPattern)(location.settings.tooltipPattern, datasources, currentDatasourceIndex);
	                        }
	
	                        tbMap.locations.push(location);
	                        updateLocation(location, data, dataMap);
	                        if (location.polyline) {
	                            tbMap.map.extendBounds(bounds, location.polyline);
	                        } else if (location.marker) {
	                            tbMap.map.extendBoundsWithMarker(bounds, location.marker);
	                        }
	                        latIndex = -1;
	                        lngIndex = -1;
	                    }
	                }
	                tbMap.map.fitBounds(bounds);
	            }
	
	            function updateLocations(data, datasources) {
	                var locationsChanged = false;
	                var bounds = tbMap.map.createBounds();
	                var dataMap = (0, _widgetUtils.toLabelValueMap)(data, datasources);
	                for (var p = 0; p < tbMap.locations.length; p++) {
	                    var location = tbMap.locations[p];
	                    locationsChanged |= updateLocation(location, data, dataMap);
	                    if (location.polyline) {
	                        tbMap.map.extendBounds(bounds, location.polyline);
	                    } else if (location.marker) {
	                        tbMap.map.extendBoundsWithMarker(bounds, location.marker);
	                    }
	                }
	                if (locationsChanged) {
	                    tbMap.map.fitBounds(bounds);
	                }
	            }
	
	            if (this.map && this.map.inited() && this.subscription) {
	                if (this.subscription.data) {
	                    if (!this.locations) {
	                        loadLocations(this.subscription.data, this.subscription.datasources);
	                    } else {
	                        updateLocations(this.subscription.data, this.subscription.datasources);
	                    }
	                    var tooltips = this.map.getTooltips();
	                    for (var t = 0; t < tooltips.length; t++) {
	                        var tooltip = tooltips[t];
	                        var text = (0, _widgetUtils.fillPattern)(tooltip.pattern, tooltip.replaceInfo, this.subscription.data);
	                        text = (0, _widgetUtils.fillPatternWithActions)(text, 'onTooltipAction', tooltip.markerArgs);
	                        tooltip.popup.setContent(text);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'resize',
	        value: function resize() {
	            if (this.map && this.map.inited()) {
	                this.map.invalidateSize();
	                if (this.locations && this.locations.length > 0) {
	                    var bounds = this.map.createBounds();
	                    for (var m = 0; m < this.markers.length; m++) {
	                        this.map.extendBoundsWithMarker(bounds, this.markers[m]);
	                    }
	                    if (this.polylines) {
	                        for (var p = 0; p < this.polylines.length; p++) {
	                            this.map.extendBounds(bounds, this.polylines[p]);
	                        }
	                    }
	                    this.map.fitBounds(bounds);
	                }
	            }
	        }
	    }], [{
	        key: 'settingsSchema',
	        value: function settingsSchema(mapProvider, drawRoutes) {
	            var schema;
	            if (mapProvider === 'google-map') {
	                schema = angular.copy(googleMapSettingsSchema);
	            } else if (mapProvider === 'openstreet-map') {
	                schema = angular.copy(openstreetMapSettingsSchema);
	            } else if (mapProvider === 'image-map') {
	                return imageMapSettingsSchema;
	            } else if (mapProvider === 'tencent-map') {
	                schema = angular.copy(tencentMapSettingsSchema);
	            }
	            angular.merge(schema.schema.properties, commonMapSettingsSchema.schema.properties);
	            schema.schema.required = schema.schema.required.concat(commonMapSettingsSchema.schema.required);
	            schema.form = schema.form.concat(commonMapSettingsSchema.form);
	            if (drawRoutes) {
	                angular.merge(schema.schema.properties, routeMapSettingsSchema.schema.properties);
	                schema.schema.required = schema.schema.required.concat(routeMapSettingsSchema.schema.required);
	                schema.form = schema.form.concat(routeMapSettingsSchema.form);
	            }
	            return schema;
	        }
	    }, {
	        key: 'dataKeySettingsSchema',
	        value: function dataKeySettingsSchema() /*mapProvider*/{
	            return {};
	        }
	    }, {
	        key: 'actionSources',
	        value: function actionSources() {
	            return {
	                'markerClick': {
	                    name: 'widget-action.marker-click',
	                    multiple: false
	                },
	                'tooltipAction': {
	                    name: 'widget-action.tooltip-tag-action',
	                    multiple: true
	                }
	            };
	        }
	    }]);
	
	    return TbMapWidgetV2;
	}();
	
	exports.default = TbMapWidgetV2;
	
	
	var googleMapSettingsSchema = {
	    "schema": {
	        "title": "Google Map Configuration",
	        "type": "object",
	        "properties": {
	            "gmApiKey": {
	                "title": "Google Maps API Key",
	                "type": "string"
	            },
	            "gmDefaultMapType": {
	                "title": "Default map type",
	                "type": "string",
	                "default": "roadmap"
	            }
	        },
	        "required": ["gmApiKey"]
	    },
	    "form": ["gmApiKey", {
	        "key": "gmDefaultMapType",
	        "type": "rc-select",
	        "multiple": false,
	        "items": [{
	            "value": "roadmap",
	            "label": "Roadmap"
	        }, {
	            "value": "satellite",
	            "label": "Satellite"
	        }, {
	            "value": "hybrid",
	            "label": "Hybrid"
	        }, {
	            "value": "terrain",
	            "label": "Terrain"
	        }]
	    }]
	};
	
	var tencentMapSettingsSchema = {
	    "schema": {
	        "title": "Tencent Map Configuration",
	        "type": "object",
	        "properties": {
	            "tmApiKey": {
	                "title": "Tencent Maps API Key",
	                "type": "string"
	            },
	            "tmDefaultMapType": {
	                "title": "Default map type",
	                "type": "string",
	                "default": "roadmap"
	            }
	        },
	        "required": ["tmApiKey"]
	    },
	    "form": ["tmApiKey", {
	        "key": "tmDefaultMapType",
	        "type": "rc-select",
	        "multiple": false,
	        "items": [{
	            "value": "roadmap",
	            "label": "Roadmap"
	        }, {
	            "value": "satellite",
	            "label": "Satellite"
	        }, {
	            "value": "hybrid",
	            "label": "Hybrid"
	        }]
	    }]
	};
	
	var openstreetMapSettingsSchema = {
	    "schema": {
	        "title": "Openstreet Map Configuration",
	        "type": "object",
	        "properties": {
	            "mapProvider": {
	                "title": "Map provider",
	                "type": "string",
	                "default": "OpenStreetMap.Mapnik"
	            }
	        },
	        "required": []
	    },
	    "form": [{
	        "key": "mapProvider",
	        "type": "rc-select",
	        "multiple": false,
	        "items": [{
	            "value": "OpenStreetMap.Mapnik",
	            "label": "OpenStreetMap.Mapnik (Default)"
	        }, {
	            "value": "OpenStreetMap.BlackAndWhite",
	            "label": "OpenStreetMap.BlackAndWhite"
	        }, {
	            "value": "OpenStreetMap.HOT",
	            "label": "OpenStreetMap.HOT"
	        }, {
	            "value": "Esri.WorldStreetMap",
	            "label": "Esri.WorldStreetMap"
	        }, {
	            "value": "Esri.WorldTopoMap",
	            "label": "Esri.WorldTopoMap"
	        }, {
	            "value": "CartoDB.Positron",
	            "label": "CartoDB.Positron"
	        }, {
	            "value": "CartoDB.DarkMatter",
	            "label": "CartoDB.DarkMatter"
	        }]
	    }]
	};
	
	var commonMapSettingsSchema = {
	    "schema": {
	        "title": "Map Configuration",
	        "type": "object",
	        "properties": {
	            "defaultZoomLevel": {
	                "title": "Default map zoom level (1 - 20)",
	                "type": "number"
	            },
	            "fitMapBounds": {
	                "title": "Fit map bounds to cover all markers",
	                "type": "boolean",
	                "default": true
	            },
	            "latKeyName": {
	                "title": "Latitude key name",
	                "type": "string",
	                "default": "latitude"
	            },
	            "lngKeyName": {
	                "title": "Longitude key name",
	                "type": "string",
	                "default": "longitude"
	            },
	            "showLabel": {
	                "title": "Show label",
	                "type": "boolean",
	                "default": true
	            },
	            "label": {
	                "title": "Label (pattern examples: '${entityName}', '${entityName}: (Text ${keyName} units.)' )",
	                "type": "string",
	                "default": "${entityName}"
	            },
	            "showTooltip": {
	                "title": "Show tooltip",
	                "type": "boolean",
	                "default": true
	            },
	            "autocloseTooltip": {
	                "title": "Auto-close tooltips",
	                "type": "boolean",
	                "default": true
	            },
	            "tooltipPattern": {
	                "title": "Tooltip (for ex. 'Text ${keyName} units.' or <link-act name='my-action'>Link text</link-act>')",
	                "type": "string",
	                "default": "<b>${entityName}</b><br/><br/><b>Latitude:</b> ${latitude:7}<br/><b>Longitude:</b> ${longitude:7}"
	            },
	            "color": {
	                "title": "Color",
	                "type": "string"
	            },
	            "useColorFunction": {
	                "title": "Use color function",
	                "type": "boolean",
	                "default": false
	            },
	            "colorFunction": {
	                "title": "Color function: f(data, dsData, dsIndex)",
	                "type": "string"
	            },
	            "markerImage": {
	                "title": "Custom marker image",
	                "type": "string"
	            },
	            "markerImageSize": {
	                "title": "Custom marker image size (px)",
	                "type": "number",
	                "default": 34
	            },
	            "useMarkerImageFunction": {
	                "title": "Use marker image function",
	                "type": "boolean",
	                "default": false
	            },
	            "markerImageFunction": {
	                "title": "Marker image function: f(data, images, dsData, dsIndex)",
	                "type": "string"
	            },
	            "markerImages": {
	                "title": "Marker images",
	                "type": "array",
	                "items": {
	                    "title": "Marker image",
	                    "type": "string"
	                }
	            }
	        },
	        "required": []
	    },
	    "form": ["defaultZoomLevel", "fitMapBounds", "latKeyName", "lngKeyName", "showLabel", "label", "showTooltip", "autocloseTooltip", {
	        "key": "tooltipPattern",
	        "type": "textarea"
	    }, {
	        "key": "color",
	        "type": "color"
	    }, "useColorFunction", {
	        "key": "colorFunction",
	        "type": "javascript"
	    }, {
	        "key": "markerImage",
	        "type": "image"
	    }, "markerImageSize", "useMarkerImageFunction", {
	        "key": "markerImageFunction",
	        "type": "javascript"
	    }, {
	        "key": "markerImages",
	        "items": [{
	            "key": "markerImages[]",
	            "type": "image"
	        }]
	    }]
	};
	
	var routeMapSettingsSchema = {
	    "schema": {
	        "title": "Route Map Configuration",
	        "type": "object",
	        "properties": {
	            "strokeWeight": {
	                "title": "Stroke weight",
	                "type": "number",
	                "default": 2
	            },
	            "strokeOpacity": {
	                "title": "Stroke opacity",
	                "type": "number",
	                "default": 1.0
	            }
	        },
	        "required": []
	    },
	    "form": ["strokeWeight", "strokeOpacity"]
	};
	
	var imageMapSettingsSchema = {
	    "schema": {
	        "title": "Image Map Configuration",
	        "type": "object",
	        "properties": {
	            "mapImageUrl": {
	                "title": "Image map background",
	                "type": "string",
	                "default": "data:image/svg+xml;base64,PHN2ZyBpZD0ic3ZnMiIgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMTAwIiB3aWR0aD0iMTAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPgogPGcgaWQ9ImxheWVyMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtOTUyLjM2KSI+CiAgPHJlY3QgaWQ9InJlY3Q0Njg0IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBoZWlnaHQ9Ijk5LjAxIiB3aWR0aD0iOTkuMDEiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiB5PSI5NTIuODYiIHg9Ii40OTUwNSIgc3Ryb2tlLXdpZHRoPSIuOTkwMTAiIGZpbGw9IiNlZWUiLz4KICA8dGV4dCBpZD0idGV4dDQ2ODYiIHN0eWxlPSJ3b3JkLXNwYWNpbmc6MHB4O2xldHRlci1zcGFjaW5nOjBweDt0ZXh0LWFuY2hvcjptaWRkbGU7dGV4dC1hbGlnbjpjZW50ZXIiIGZvbnQtd2VpZ2h0PSJib2xkIiB4bWw6c3BhY2U9InByZXNlcnZlIiBmb250LXNpemU9IjEwcHgiIGxpbmUtaGVpZ2h0PSIxMjUlIiB5PSI5NzAuNzI4MDkiIHg9IjQ5LjM5NjQ3NyIgZm9udC1mYW1pbHk9IlJvYm90byIgZmlsbD0iIzY2NjY2NiI+PHRzcGFuIGlkPSJ0c3BhbjQ2OTAiIHg9IjUwLjY0NjQ3NyIgeT0iOTcwLjcyODA5Ij5JbWFnZSBiYWNrZ3JvdW5kIDwvdHNwYW4+PHRzcGFuIGlkPSJ0c3BhbjQ2OTIiIHg9IjQ5LjM5NjQ3NyIgeT0iOTgzLjIyODA5Ij5pcyBub3QgY29uZmlndXJlZDwvdHNwYW4+PC90ZXh0PgogIDxyZWN0IGlkPSJyZWN0NDY5NCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgaGVpZ2h0PSIxOS4zNiIgd2lkdGg9IjY5LjM2IiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgeT0iOTkyLjY4IiB4PSIxNS4zMiIgc3Ryb2tlLXdpZHRoPSIuNjM5ODYiIGZpbGw9Im5vbmUiLz4KIDwvZz4KPC9zdmc+Cg=="
	            },
	            "imageEntityAlias": {
	                "title": "Image URL source entity alias",
	                "type": "string",
	                "default": ""
	            },
	            "imageUrlAttribute": {
	                "title": "Image URL source entity attribute",
	                "type": "string",
	                "default": ""
	            },
	            "xPosKeyName": {
	                "title": "X position key name",
	                "type": "string",
	                "default": "xPos"
	            },
	            "yPosKeyName": {
	                "title": "Y position key name",
	                "type": "string",
	                "default": "yPos"
	            },
	            "showLabel": {
	                "title": "Show label",
	                "type": "boolean",
	                "default": true
	            },
	            "label": {
	                "title": "Label (pattern examples: '${entityName}', '${entityName}: (Text ${keyName} units.)' )",
	                "type": "string",
	                "default": "${entityName}"
	            },
	            "showTooltip": {
	                "title": "Show tooltip",
	                "type": "boolean",
	                "default": true
	            },
	            "autocloseTooltip": {
	                "title": "Auto-close tooltips",
	                "type": "boolean",
	                "default": true
	            },
	            "tooltipPattern": {
	                "title": "Tooltip (for ex. 'Text ${keyName} units.' or <link-act name='my-action'>Link text</link-act>')",
	                "type": "string",
	                "default": "<b>${entityName}</b><br/><br/><b>X Pos:</b> ${xPos:2}<br/><b>Y Pos:</b> ${yPos:2}"
	            },
	            "color": {
	                "title": "Color",
	                "type": "string"
	            },
	            "posFunction": {
	                "title": "Position conversion function: f(origXPos, origYPos), should return x,y coordinates as double from 0 to 1 each",
	                "type": "string",
	                "default": "return {x: origXPos, y: origYPos};"
	            },
	            "markerOffsetX": {
	                "title": "Marker X offset relative to position",
	                "type": "number",
	                "default": 0.5
	            },
	            "markerOffsetY": {
	                "title": "Marker Y offset relative to position",
	                "type": "number",
	                "default": 1
	            },
	            "useColorFunction": {
	                "title": "Use color function",
	                "type": "boolean",
	                "default": false
	            },
	            "colorFunction": {
	                "title": "Color function: f(data, dsData, dsIndex)",
	                "type": "string"
	            },
	            "markerImage": {
	                "title": "Custom marker image",
	                "type": "string"
	            },
	            "markerImageSize": {
	                "title": "Custom marker image size (px)",
	                "type": "number",
	                "default": 34
	            },
	            "useMarkerImageFunction": {
	                "title": "Use marker image function",
	                "type": "boolean",
	                "default": false
	            },
	            "markerImageFunction": {
	                "title": "Marker image function: f(data, images, dsData, dsIndex)",
	                "type": "string"
	            },
	            "markerImages": {
	                "title": "Marker images",
	                "type": "array",
	                "items": {
	                    "title": "Marker image",
	                    "type": "string"
	                }
	            }
	        },
	        "required": []
	    },
	    "form": [{
	        "key": "mapImageUrl",
	        "type": "image"
	    }, "imageEntityAlias", "imageUrlAttribute", "xPosKeyName", "yPosKeyName", "showLabel", "label", "showTooltip", "autocloseTooltip", {
	        "key": "tooltipPattern",
	        "type": "textarea"
	    }, {
	        "key": "color",
	        "type": "color"
	    }, {
	        "key": "posFunction",
	        "type": "javascript"
	    }, "markerOffsetX", "markerOffsetY", "useColorFunction", {
	        "key": "colorFunction",
	        "type": "javascript"
	    }, {
	        "key": "markerImage",
	        "type": "image"
	    }, "markerImageSize", "useMarkerImageFunction", {
	        "key": "markerImageFunction",
	        "type": "javascript"
	    }, {
	        "key": "markerImages",
	        "items": [{
	            "key": "markerImages[]",
	            "type": "image"
	        }]
	    }]
	};

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _knob = __webpack_require__(1352);
	
	var _knob2 = _interopRequireDefault(_knob);
	
	var _switch = __webpack_require__(1355);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _roundSwitch = __webpack_require__(1354);
	
	var _roundSwitch2 = _interopRequireDefault(_roundSwitch);
	
	var _ledIndicator = __webpack_require__(1353);
	
	var _ledIndicator2 = _interopRequireDefault(_ledIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.widgets.rpc', [_knob2.default, _switch2.default, _roundSwitch2.default, _ledIndicator2.default]).name;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	KnobController.$inject = ["$element", "$scope", "$document"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(825);
	
	var _CanvasDigitalGauge = __webpack_require__(513);
	
	var _CanvasDigitalGauge2 = _interopRequireDefault(_CanvasDigitalGauge);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _widgetUtils = __webpack_require__(516);
	
	var _knobTpl = __webpack_require__(1534);
	
	var _knobTpl2 = _interopRequireDefault(_knobTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.widgets.rpc.knob', []).directive('tbKnob', Knob).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function Knob() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            ctx: '='
	        },
	        controller: KnobController,
	        controllerAs: 'vm',
	        templateUrl: _knobTpl2.default
	    };
	}
	
	/*@ngInject*/
	function KnobController($element, $scope, $document) {
	    var vm = this;
	
	    vm.value = 0;
	    vm.error = '';
	
	    var knob = angular.element('.knob', $element),
	        knobContainer = angular.element('#knob-container', $element),
	        knobTopPointerContainer = knob.find('.top-pointer-container'),
	        knobTopPointer = knob.find('.top-pointer'),
	        knobValueContainer = knob.find('.value-container'),
	        knobValue = knob.find('.knob-value'),
	        knobErrorContainer = knob.find('.error-container'),
	        knobError = knob.find('.knob-error'),
	        knobTitleContainer = knob.find('.title-container'),
	        knobTitle = knob.find('.knob-title'),
	        knobMinmaxContainer = knob.find('.minmax-container'),
	        minmaxLabel = knob.find('.minmax-label'),
	        textMeasure = knob.find('#text-measure'),
	        startDeg = -1,
	        currentDeg = 0,
	        rotation = 0,
	        lastDeg = 0,
	        moving = false;
	
	    var minDeg = -45;
	    var maxDeg = 225;
	
	    var canvasBarElement = angular.element('#canvasBar', $element);
	
	    var levelColors = ['#19ff4b', '#ffff19', '#ff3232'];
	
	    var canvasBar;
	
	    $scope.$watch('vm.ctx', function () {
	        if (vm.ctx) {
	            init();
	        }
	    });
	
	    function init() {
	
	        vm.minValue = angular.isDefined(vm.ctx.settings.minValue) ? vm.ctx.settings.minValue : 0;
	        vm.maxValue = angular.isDefined(vm.ctx.settings.maxValue) ? vm.ctx.settings.maxValue : 100;
	        vm.title = angular.isDefined(vm.ctx.settings.title) ? vm.ctx.settings.title : '';
	
	        var canvasBarData = {
	            renderTo: canvasBarElement[0],
	            hideValue: true,
	            neonGlowBrightness: 0,
	            gaugeWidthScale: 0.4,
	            gaugeColor: 'rgba(0, 0, 0, 0)',
	            levelColors: levelColors,
	            minValue: vm.minValue,
	            maxValue: vm.maxValue,
	            gaugeType: 'donut',
	            dashThickness: 2,
	            donutStartAngle: 3 / 4 * Math.PI,
	            donutEndAngle: 9 / 4 * Math.PI,
	            animation: false
	        };
	
	        canvasBar = new _CanvasDigitalGauge2.default(canvasBarData).draw();
	
	        knob.on('click', function (e) {
	            if (moving) {
	                moving = false;
	                return false;
	            }
	            e.preventDefault();
	
	            var offset = knob.offset();
	            var center = {
	                y: offset.top + knob.height() / 2,
	                x: offset.left + knob.width() / 2
	            };
	            var a,
	                b,
	                deg,
	                rad2deg = 180 / Math.PI;
	
	            e = e.originalEvent.touches ? e.originalEvent.touches[0] : e;
	
	            a = center.y - e.pageY;
	            b = center.x - e.pageX;
	            deg = Math.atan2(a, b) * rad2deg;
	            if (deg < 0) {
	                deg = 360 + deg;
	            }
	            if (deg > maxDeg) {
	                if (deg - 360 > minDeg) {
	                    deg = deg - 360;
	                } else {
	                    return false;
	                }
	            }
	            currentDeg = deg;
	            lastDeg = deg;
	            knobTopPointerContainer.css('transform', 'rotate(' + currentDeg + 'deg)');
	            turn(degreeToRatio(currentDeg));
	            rotation = currentDeg;
	            startDeg = -1;
	        });
	
	        knob.on('mousedown touchstart', function (e) {
	            e.preventDefault();
	            var offset = knob.offset();
	            var center = {
	                y: offset.top + knob.height() / 2,
	                x: offset.left + knob.width() / 2
	            };
	
	            var a,
	                b,
	                deg,
	                tmp,
	                rad2deg = 180 / Math.PI;
	
	            knob.on('mousemove.rem touchmove.rem', function (e) {
	                moving = true;
	                e = e.originalEvent.touches ? e.originalEvent.touches[0] : e;
	
	                a = center.y - e.pageY;
	                b = center.x - e.pageX;
	                deg = Math.atan2(a, b) * rad2deg;
	                if (deg < 0) {
	                    deg = 360 + deg;
	                }
	
	                if (startDeg == -1) {
	                    startDeg = deg;
	                }
	
	                tmp = Math.floor(deg - startDeg + rotation);
	
	                if (tmp < 0) {
	                    tmp = 360 + tmp;
	                } else if (tmp > 359) {
	                    tmp = tmp % 360;
	                }
	
	                if (tmp > maxDeg) {
	                    if (tmp - 360 > minDeg) {
	                        tmp = tmp - 360;
	                    } else {
	                        var deltaMax = Math.abs(maxDeg - lastDeg);
	                        var deltaMin = Math.abs(minDeg - lastDeg);
	                        if (deltaMax < deltaMin) {
	                            tmp = maxDeg;
	                        } else {
	                            tmp = minDeg;
	                        }
	                    }
	                }
	                if (Math.abs(tmp - lastDeg) > 180) {
	                    startDeg = deg;
	                    rotation = currentDeg;
	                    return false;
	                }
	
	                currentDeg = tmp;
	                lastDeg = tmp;
	
	                knobTopPointerContainer.css('transform', 'rotate(' + currentDeg + 'deg)');
	                turn(degreeToRatio(currentDeg));
	            });
	
	            $document.on('mouseup.rem  touchend.rem', function () {
	                knob.off('.rem');
	                $document.off('.rem');
	                rotation = currentDeg;
	                startDeg = -1;
	            });
	        });
	        vm.ctx.resize = resize;
	        resize();
	        var initialValue = angular.isDefined(vm.ctx.settings.initialValue) ? vm.ctx.settings.initialValue : vm.minValue;
	        setValue(initialValue);
	
	        var subscription = vm.ctx.defaultSubscription;
	        var rpcEnabled = subscription.rpcEnabled;
	
	        vm.isSimulated = $scope.widgetEditMode;
	
	        vm.requestTimeout = 500;
	        if (vm.ctx.settings.requestTimeout) {
	            vm.requestTimeout = vm.ctx.settings.requestTimeout;
	        }
	        vm.getValueMethod = 'getValue';
	        if (vm.ctx.settings.getValueMethod && vm.ctx.settings.getValueMethod.length) {
	            vm.getValueMethod = vm.ctx.settings.getValueMethod;
	        }
	        vm.setValueMethod = 'setValue';
	        if (vm.ctx.settings.setValueMethod && vm.ctx.settings.setValueMethod.length) {
	            vm.setValueMethod = vm.ctx.settings.setValueMethod;
	        }
	        if (!rpcEnabled) {
	            onError('Target device is not set!');
	        } else {
	            if (!vm.isSimulated) {
	                rpcRequestValue();
	            }
	        }
	    }
	
	    function ratioToDegree(ratio) {
	        return minDeg + ratio * (maxDeg - minDeg);
	    }
	
	    function degreeToRatio(degree) {
	        return (degree - minDeg) / (maxDeg - minDeg);
	    }
	
	    function resize() {
	        var width = knobContainer.width();
	        var height = knobContainer.height();
	        var size = Math.min(width, height);
	        knob.css({ width: size, height: size });
	        canvasBar.update({ width: size, height: size });
	        setFontSize(knobTitle, vm.title, knobTitleContainer.height(), knobTitleContainer.width());
	        setFontSize(knobError, vm.error, knobErrorContainer.height(), knobErrorContainer.width());
	        var minmaxHeight = knobMinmaxContainer.height();
	        minmaxLabel.css({ 'fontSize': minmaxHeight + 'px', 'lineHeight': minmaxHeight + 'px' });
	        checkValueSize();
	    }
	
	    function turn(ratio) {
	        var value = (vm.minValue + (vm.maxValue - vm.minValue) * ratio).toFixed(vm.ctx.decimals);
	        if (canvasBar.value != value) {
	            canvasBar.value = value;
	        }
	        updateColor(canvasBar.getValueColor());
	        onValue(value);
	    }
	
	    function setValue(value) {
	        var ratio = (value - vm.minValue) / (vm.maxValue - vm.minValue);
	        rotation = lastDeg = currentDeg = ratioToDegree(ratio);
	        knobTopPointerContainer.css('transform', 'rotate(' + currentDeg + 'deg)');
	        if (canvasBar.value != value) {
	            canvasBar.value = value;
	        }
	        updateColor(canvasBar.getValueColor());
	        vm.value = formatValue(value);
	        checkValueSize();
	    }
	
	    function updateColor(color) {
	        var glowColor = (0, _tinycolor2.default)(color).brighten(30).toHexString();
	        knobValue.css({ 'color': glowColor });
	        var textShadow = color + ' 1px 1px 10px, ' + glowColor + ' 1px 1px 10px';
	        knobValue.css({ 'textShadow': textShadow });
	        knobTopPointer.css({ 'backgroundColor': glowColor });
	        var boxShadow = 'inset 1px 0 2px #040404, 1px 1px 8px 2px ' + glowColor;
	        knobTopPointer.css({ 'boxShadow': boxShadow });
	    }
	
	    function onValue(value) {
	        $scope.$applyAsync(function () {
	            vm.value = formatValue(value);
	            checkValueSize();
	            rpcUpdateValue(value);
	        });
	    }
	
	    function onError(error) {
	        $scope.$applyAsync(function () {
	            vm.error = error;
	            setFontSize(knobError, vm.error, knobErrorContainer.height(), knobErrorContainer.width());
	        });
	    }
	
	    function formatValue(value) {
	        return vm.ctx.utils.formatValue(value, vm.ctx.decimals, vm.ctx.units, true);
	    }
	
	    function checkValueSize() {
	        var fontSize = knobValueContainer.height() / 3.3;
	        var containerWidth = knobValueContainer.width();
	        setFontSize(knobValue, vm.value, fontSize, containerWidth);
	    }
	
	    function setFontSize(element, text, fontSize, maxWidth) {
	        var textWidth = measureTextWidth(text, fontSize);
	        while (textWidth > maxWidth) {
	            fontSize--;
	            textWidth = measureTextWidth(text, fontSize);
	        }
	        element.css({ 'fontSize': fontSize + 'px', 'lineHeight': fontSize + 'px' });
	    }
	
	    function measureTextWidth(text, fontSize) {
	        textMeasure.css({ 'fontSize': fontSize + 'px', 'lineHeight': fontSize + 'px' });
	        textMeasure.text(text);
	        return textMeasure.width();
	    }
	
	    function rpcRequestValue() {
	        vm.error = '';
	        vm.ctx.controlApi.sendTwoWayCommand(vm.getValueMethod, null, vm.requestTimeout).then(function (responseBody) {
	            if ((0, _widgetUtils.isNumber)(responseBody)) {
	                var numValue = Number(responseBody).toFixed(vm.ctx.decimals);
	                setValue(numValue);
	            } else {
	                var errorText = 'Unable to parse response: ' + responseBody;
	                onError(errorText);
	            }
	        }, function () {
	            var errorText = vm.ctx.defaultSubscription.rpcErrorText;
	            onError(errorText);
	        });
	    }
	
	    function rpcUpdateValue(value) {
	        if (vm.executingUpdateValue) {
	            vm.scheduledValue = value;
	            return;
	        } else {
	            vm.scheduledValue = null;
	            vm.rpcValue = value;
	            vm.executingUpdateValue = true;
	        }
	        vm.error = '';
	        vm.ctx.controlApi.sendOneWayCommand(vm.setValueMethod, value, vm.requestTimeout).then(function () {
	            vm.executingUpdateValue = false;
	            if (vm.scheduledValue != null && vm.scheduledValue != vm.rpcValue) {
	                rpcUpdateValue(vm.scheduledValue);
	            }
	        }, function () {
	            vm.executingUpdateValue = false;
	            var errorText = vm.ctx.defaultSubscription.rpcErrorText;
	            onError(errorText);
	        });
	    }
	}

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	LedIndicatorController.$inject = ["$element", "$scope", "$timeout", "utils", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(826);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _ledIndicatorTpl = __webpack_require__(1535);
	
	var _ledIndicatorTpl2 = _interopRequireDefault(_ledIndicatorTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	exports.default = angular.module('thingsboard.widgets.rpc.ledIndicator', []).directive('tbLedIndicator', LedIndicator).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function LedIndicator() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            ctx: '='
	        },
	        controller: LedIndicatorController,
	        controllerAs: 'vm',
	        templateUrl: _ledIndicatorTpl2.default
	    };
	}
	
	/*@ngInject*/
	function LedIndicatorController($element, $scope, $timeout, utils, types) {
	    var vm = this;
	
	    vm.showTitle = false;
	    vm.value = false;
	    vm.error = '';
	
	    var checkStatusPollingInterval = 10000;
	
	    vm.subscriptionOptions = {
	        callbacks: {
	            onDataUpdated: onDataUpdated,
	            onDataUpdateError: onDataUpdateError,
	            dataLoading: function dataLoading() {}
	        }
	    };
	
	    var led = angular.element('.led', $element),
	        ledContainer = angular.element('#led-container', $element),
	        textMeasure = angular.element('#text-measure', $element),
	        ledTitleContainer = angular.element('.title-container', $element),
	        ledTitle = angular.element('.led-title', $element),
	        ledErrorContainer = angular.element('.error-container', $element),
	        ledError = angular.element('.led-error', $element);
	
	    $scope.$watch('vm.ctx', function () {
	        if (vm.ctx) {
	            init();
	        }
	    });
	
	    $scope.$on('$destroy', function () {
	        vm.destroyed = true;
	        if (vm.checkStatusTimeoutHandle) {
	            $timeout.cancel(vm.checkStatusTimeoutHandle);
	        }
	        if (vm.subscription) {
	            vm.ctx.subscriptionApi.removeSubscription(vm.subscription.id);
	        }
	    });
	
	    resize();
	
	    function init() {
	
	        vm.title = angular.isDefined(vm.ctx.settings.title) ? vm.ctx.settings.title : '';
	        vm.showTitle = vm.title && vm.title.length ? true : false;
	
	        var origColor = angular.isDefined(vm.ctx.settings.ledColor) ? vm.ctx.settings.ledColor : 'green';
	
	        vm.valueAttribute = angular.isDefined(vm.ctx.settings.valueAttribute) ? vm.ctx.settings.valueAttribute : 'value';
	
	        vm.ledColor = (0, _tinycolor2.default)(origColor).brighten(30).toHexString();
	        vm.ledMiddleColor = (0, _tinycolor2.default)(origColor).toHexString();
	        vm.disabledColor = (0, _tinycolor2.default)(origColor).darken(40).toHexString();
	        vm.disabledMiddleColor = (0, _tinycolor2.default)(origColor).darken(60).toHexString();
	
	        vm.ctx.resize = resize;
	        $scope.$applyAsync(function () {
	            resize();
	        });
	        var initialValue = angular.isDefined(vm.ctx.settings.initialValue) ? vm.ctx.settings.initialValue : false;
	        setValue(initialValue, true);
	
	        var subscription = vm.ctx.defaultSubscription;
	        var rpcEnabled = subscription.rpcEnabled;
	
	        vm.isSimulated = $scope.widgetEditMode;
	
	        vm.requestTimeout = 500;
	        if (vm.ctx.settings.requestTimeout) {
	            vm.requestTimeout = vm.ctx.settings.requestTimeout;
	        }
	        vm.retrieveValueMethod = 'attribute';
	        if (vm.ctx.settings.retrieveValueMethod && vm.ctx.settings.retrieveValueMethod.length) {
	            vm.retrieveValueMethod = vm.ctx.settings.retrieveValueMethod;
	        }
	
	        vm.parseValueFunction = function (data) {
	            return data ? true : false;
	        };
	        if (vm.ctx.settings.parseValueFunction && vm.ctx.settings.parseValueFunction.length) {
	            try {
	                vm.parseValueFunction = new Function('data', vm.ctx.settings.parseValueFunction);
	            } catch (e) {
	                vm.parseValueFunction = function (data) {
	                    return data ? true : false;
	                };
	            }
	        }
	
	        vm.performCheckStatus = vm.ctx.settings.performCheckStatus != false;
	        if (vm.performCheckStatus) {
	            vm.checkStatusMethod = 'checkStatus';
	            if (vm.ctx.settings.checkStatusMethod && vm.ctx.settings.checkStatusMethod.length) {
	                vm.checkStatusMethod = vm.ctx.settings.checkStatusMethod;
	            }
	        }
	        if (!rpcEnabled) {
	            onError('Target device is not set!');
	        } else {
	            if (!vm.isSimulated) {
	                if (vm.performCheckStatus) {
	                    rpcCheckStatus();
	                } else {
	                    subscribeForValue();
	                }
	            }
	        }
	    }
	
	    function resize() {
	        var width = ledContainer.width();
	        var height = ledContainer.height();
	        var size = Math.min(width, height);
	
	        led.css({ width: size, height: size });
	
	        if (vm.showTitle) {
	            setFontSize(ledTitle, vm.title, ledTitleContainer.height() * 2 / 3, ledTitleContainer.width());
	        }
	        setFontSize(ledError, vm.error, ledErrorContainer.height(), ledErrorContainer.width());
	    }
	
	    function setValue(value, forceUpdate) {
	        if (vm.value != value || forceUpdate) {
	            vm.value = value;
	            updateColor();
	        }
	    }
	
	    function updateColor() {
	        var color = vm.value ? vm.ledColor : vm.disabledColor;
	        var middleColor = vm.value ? vm.ledMiddleColor : vm.disabledMiddleColor;
	        var boxShadow = '#000 0 -1px 6px 1px, inset ' + middleColor + ' 0 -1px 8px, ' + color + ' 0 3px 11px';
	        led.css({ 'backgroundColor': color });
	        led.css({ 'boxShadow': boxShadow });
	        if (vm.value) {
	            led.removeClass('disabled');
	        } else {
	            led.addClass('disabled');
	        }
	    }
	
	    function onError(error) {
	        $scope.$applyAsync(function () {
	            vm.error = error;
	            setFontSize(ledError, vm.error, ledErrorContainer.height(), ledErrorContainer.width());
	        });
	    }
	
	    function setFontSize(element, text, fontSize, maxWidth) {
	        var textWidth = measureTextWidth(text, fontSize);
	        while (textWidth > maxWidth) {
	            fontSize--;
	            textWidth = measureTextWidth(text, fontSize);
	        }
	        element.css({ 'fontSize': fontSize + 'px', 'lineHeight': fontSize + 'px' });
	    }
	
	    function measureTextWidth(text, fontSize) {
	        textMeasure.css({ 'fontSize': fontSize + 'px', 'lineHeight': fontSize + 'px' });
	        textMeasure.text(text);
	        return textMeasure.width();
	    }
	
	    function rpcCheckStatus() {
	        if (vm.destroyed) {
	            return;
	        }
	        vm.error = '';
	        vm.ctx.controlApi.sendTwoWayCommand(vm.checkStatusMethod, null, vm.requestTimeout).then(function (responseBody) {
	            var status = responseBody ? true : false;
	            if (status) {
	                if (vm.checkStatusTimeoutHandle) {
	                    $timeout.cancel(vm.checkStatusTimeoutHandle);
	                    vm.checkStatusTimeoutHandle = null;
	                }
	                subscribeForValue();
	            } else {
	                var errorText = 'Unknown device status!';
	                onError(errorText);
	                if (vm.checkStatusTimeoutHandle) {
	                    $timeout.cancel(vm.checkStatusTimeoutHandle);
	                }
	                vm.checkStatusTimeoutHandle = $timeout(rpcCheckStatus, checkStatusPollingInterval);
	            }
	        }, function () {
	            var errorText = vm.ctx.defaultSubscription.rpcErrorText;
	            onError(errorText);
	            if (vm.checkStatusTimeoutHandle) {
	                $timeout.cancel(vm.checkStatusTimeoutHandle);
	            }
	            vm.checkStatusTimeoutHandle = $timeout(rpcCheckStatus, checkStatusPollingInterval);
	        });
	    }
	
	    function subscribeForValue() {
	        var subscriptionsInfo = [{
	            type: types.datasourceType.entity,
	            entityType: types.entityType.device,
	            entityId: vm.ctx.defaultSubscription.targetDeviceId
	        }];
	
	        if (vm.retrieveValueMethod == 'attribute') {
	            subscriptionsInfo[0].attributes = [{ name: vm.valueAttribute }];
	        } else {
	            subscriptionsInfo[0].timeseries = [{ name: vm.valueAttribute }];
	        }
	
	        vm.ctx.subscriptionApi.createSubscriptionFromInfo(types.widgetType.latest.value, subscriptionsInfo, vm.subscriptionOptions, false, true).then(function (subscription) {
	            vm.subscription = subscription;
	        });
	    }
	
	    function onDataUpdated(subscription, apply) {
	        var value = false;
	        var data = subscription.data;
	        if (data.length) {
	            var keyData = data[0];
	            if (keyData && keyData.data && keyData.data[0]) {
	                var attrValue = keyData.data[0][1];
	                if (attrValue) {
	                    var parsed = null;
	                    try {
	                        parsed = vm.parseValueFunction(angular.fromJson(attrValue));
	                    } catch (e) {/**/}
	                    value = parsed ? true : false;
	                }
	            }
	        }
	        setValue(value);
	        if (apply) {
	            $scope.$digest();
	        }
	    }
	
	    function onDataUpdateError(subscription, e) {
	        var exceptionData = utils.parseException(e);
	        var errorText = exceptionData.name;
	        if (exceptionData.message) {
	            errorText += ': ' + exceptionData.message;
	        }
	        onError(errorText);
	    }
	}

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RoundSwitchController.$inject = ["$element", "$scope", "utils", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(827);
	
	var _roundSwitchTpl = __webpack_require__(1536);
	
	var _roundSwitchTpl2 = _interopRequireDefault(_roundSwitchTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.widgets.rpc.roundSwitch', []).directive('tbRoundSwitch', RoundSwitch).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function RoundSwitch() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            ctx: '='
	        },
	        controller: RoundSwitchController,
	        controllerAs: 'vm',
	        templateUrl: _roundSwitchTpl2.default
	    };
	}
	
	/*@ngInject*/
	function RoundSwitchController($element, $scope, utils, types) {
	    var vm = this;
	
	    vm.showTitle = false;
	    vm.value = false;
	    vm.error = '';
	
	    vm.checkboxId = 'onoff-' + utils.guid();
	
	    var switchElement = angular.element('.switch', $element),
	        switchContainer = angular.element('#switch-container', $element),
	        onoff = angular.element('input', $element),
	        textMeasure = angular.element('#text-measure', $element),
	        switchTitleContainer = angular.element('.title-container', $element),
	        switchTitle = angular.element('.switch-title', $element),
	        switchErrorContainer = angular.element('.error-container', $element),
	        switchError = angular.element('.switch-error', $element);
	
	    onoff.bind('change', function () {
	        vm.value = onoff.prop('checked') === false;
	        onValue();
	    });
	
	    vm.valueSubscription = null;
	
	    $scope.$watch('vm.ctx', function () {
	        if (vm.ctx) {
	            init();
	        }
	    });
	
	    $scope.$on('$destroy', function () {
	        if (vm.valueSubscription) {
	            vm.ctx.subscriptionApi.removeSubscription(vm.valueSubscription.id);
	        }
	    });
	
	    resize();
	
	    function init() {
	
	        vm.title = angular.isDefined(vm.ctx.settings.title) ? vm.ctx.settings.title : '';
	        vm.showTitle = vm.title && vm.title.length ? true : false;
	        vm.ctx.resize = resize;
	        $scope.$applyAsync(function () {
	            resize();
	        });
	        var initialValue = angular.isDefined(vm.ctx.settings.initialValue) ? vm.ctx.settings.initialValue : false;
	        setValue(initialValue);
	
	        var subscription = vm.ctx.defaultSubscription;
	        var rpcEnabled = subscription.rpcEnabled;
	
	        vm.isSimulated = $scope.widgetEditMode;
	
	        vm.requestTimeout = 500;
	        if (vm.ctx.settings.requestTimeout) {
	            vm.requestTimeout = vm.ctx.settings.requestTimeout;
	        }
	
	        vm.retrieveValueMethod = 'rpc';
	        if (vm.ctx.settings.retrieveValueMethod && vm.ctx.settings.retrieveValueMethod.length) {
	            vm.retrieveValueMethod = vm.ctx.settings.retrieveValueMethod;
	        }
	
	        vm.valueKey = 'value';
	        if (vm.ctx.settings.valueKey && vm.ctx.settings.valueKey.length) {
	            vm.valueKey = vm.ctx.settings.valueKey;
	        }
	
	        vm.parseValueFunction = function (data) {
	            return data ? true : false;
	        };
	        if (vm.ctx.settings.parseValueFunction && vm.ctx.settings.parseValueFunction.length) {
	            try {
	                vm.parseValueFunction = new Function('data', vm.ctx.settings.parseValueFunction);
	            } catch (e) {
	                vm.parseValueFunction = function (data) {
	                    return data ? true : false;
	                };
	            }
	        }
	
	        vm.convertValueFunction = function (value) {
	            return value;
	        };
	        if (vm.ctx.settings.convertValueFunction && vm.ctx.settings.convertValueFunction.length) {
	            try {
	                vm.convertValueFunction = new Function('value', vm.ctx.settings.convertValueFunction);
	            } catch (e) {
	                vm.convertValueFunction = function (value) {
	                    return value;
	                };
	            }
	        }
	
	        vm.getValueMethod = 'getValue';
	        if (vm.ctx.settings.getValueMethod && vm.ctx.settings.getValueMethod.length) {
	            vm.getValueMethod = vm.ctx.settings.getValueMethod;
	        }
	        vm.setValueMethod = 'setValue';
	        if (vm.ctx.settings.setValueMethod && vm.ctx.settings.setValueMethod.length) {
	            vm.setValueMethod = vm.ctx.settings.setValueMethod;
	        }
	        if (!rpcEnabled) {
	            onError('Target device is not set!');
	        } else {
	            if (!vm.isSimulated) {
	                if (vm.retrieveValueMethod == 'rpc') {
	                    rpcRequestValue();
	                } else if (vm.retrieveValueMethod == 'attribute' || vm.retrieveValueMethod == 'timeseries') {
	                    subscribeForValue();
	                }
	            }
	        }
	    }
	
	    function resize() {
	        var width = switchContainer.width();
	        var height = switchContainer.height();
	        var size = Math.min(width, height);
	        var scale = size / 260;
	        switchElement.css({
	            '-webkit-transform': 'scale(' + scale + ')',
	            '-moz-transform': 'scale(' + scale + ')',
	            '-ms-transform': 'scale(' + scale + ')',
	            '-o-transform': 'scale(' + scale + ')',
	            transform: 'scale(' + scale + ')'
	        });
	        if (vm.showTitle) {
	            setFontSize(switchTitle, vm.title, switchTitleContainer.height() * 2 / 3, switchTitleContainer.width());
	        }
	        setFontSize(switchError, vm.error, switchErrorContainer.height(), switchErrorContainer.width());
	    }
	
	    function subscribeForValue() {
	        var valueSubscriptionInfo = [{
	            type: types.datasourceType.entity,
	            entityType: types.entityType.device,
	            entityId: vm.ctx.defaultSubscription.targetDeviceId
	        }];
	        if (vm.retrieveValueMethod == 'attribute') {
	            valueSubscriptionInfo[0].attributes = [{ name: vm.valueKey }];
	        } else {
	            valueSubscriptionInfo[0].timeseries = [{ name: vm.valueKey }];
	        }
	        var subscriptionOptions = {
	            callbacks: {
	                onDataUpdated: onDataUpdated,
	                onDataUpdateError: onDataUpdateError
	            }
	        };
	        vm.ctx.subscriptionApi.createSubscriptionFromInfo(types.widgetType.latest.value, valueSubscriptionInfo, subscriptionOptions, false, true).then(function (subscription) {
	            vm.valueSubscription = subscription;
	        });
	    }
	
	    function onDataUpdated(subscription, apply) {
	        var value = false;
	        var data = subscription.data;
	        if (data.length) {
	            var keyData = data[0];
	            if (keyData && keyData.data && keyData.data[0]) {
	                var attrValue = keyData.data[0][1];
	                if (attrValue) {
	                    var parsed = null;
	                    try {
	                        parsed = vm.parseValueFunction(angular.fromJson(attrValue));
	                    } catch (e) {/**/}
	                    value = parsed ? true : false;
	                }
	            }
	        }
	        setValue(value);
	        if (apply) {
	            $scope.$digest();
	        }
	    }
	
	    function onDataUpdateError(subscription, e) {
	        var exceptionData = utils.parseException(e);
	        var errorText = exceptionData.name;
	        if (exceptionData.message) {
	            errorText += ': ' + exceptionData.message;
	        }
	        onError(errorText);
	    }
	
	    function setValue(value) {
	        vm.value = value ? true : false;
	        onoff.prop('checked', !vm.value);
	    }
	
	    function onValue() {
	        rpcUpdateValue(vm.value);
	    }
	
	    function onError(error) {
	        $scope.$applyAsync(function () {
	            vm.error = error;
	            setFontSize(switchError, vm.error, switchErrorContainer.height(), switchErrorContainer.width());
	        });
	    }
	
	    function setFontSize(element, text, fontSize, maxWidth) {
	        var textWidth = measureTextWidth(text, fontSize);
	        while (textWidth > maxWidth) {
	            fontSize--;
	            textWidth = measureTextWidth(text, fontSize);
	        }
	        element.css({ 'fontSize': fontSize + 'px', 'lineHeight': fontSize + 'px' });
	    }
	
	    function measureTextWidth(text, fontSize) {
	        textMeasure.css({ 'fontSize': fontSize + 'px', 'lineHeight': fontSize + 'px' });
	        textMeasure.text(text);
	        return textMeasure.width();
	    }
	
	    function rpcRequestValue() {
	        vm.error = '';
	        vm.ctx.controlApi.sendTwoWayCommand(vm.getValueMethod, null, vm.requestTimeout).then(function (responseBody) {
	            setValue(vm.parseValueFunction(responseBody));
	        }, function () {
	            var errorText = vm.ctx.defaultSubscription.rpcErrorText;
	            onError(errorText);
	        });
	    }
	
	    function rpcUpdateValue(value) {
	        if (vm.executingUpdateValue) {
	            vm.scheduledValue = value;
	            return;
	        } else {
	            vm.scheduledValue = null;
	            vm.rpcValue = value;
	            vm.executingUpdateValue = true;
	        }
	        vm.error = '';
	        vm.ctx.controlApi.sendOneWayCommand(vm.setValueMethod, vm.convertValueFunction(value), vm.requestTimeout).then(function () {
	            vm.executingUpdateValue = false;
	            if (vm.scheduledValue != null && vm.scheduledValue != vm.rpcValue) {
	                rpcUpdateValue(vm.scheduledValue);
	            }
	        }, function () {
	            vm.executingUpdateValue = false;
	            var errorText = vm.ctx.defaultSubscription.rpcErrorText;
	            onError(errorText);
	        });
	    }
	}

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	SwitchController.$inject = ["$element", "$scope", "types", "utils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(828);
	
	var _switchTpl = __webpack_require__(1537);
	
	var _switchTpl2 = _interopRequireDefault(_switchTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.widgets.rpc.switch', []).directive('tbSwitch', Switch).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function Switch() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            ctx: '='
	        },
	        controller: SwitchController,
	        controllerAs: 'vm',
	        templateUrl: _switchTpl2.default
	    };
	}
	
	/*@ngInject*/
	function SwitchController($element, $scope, types, utils) {
	    var vm = this;
	
	    vm.showTitle = false;
	    vm.value = false;
	    vm.error = '';
	
	    var switchElement = angular.element('.switch', $element),
	        switchContainer = angular.element('#switch-container', $element),
	        mdSwitch = angular.element('md-switch', switchElement),
	        onoffContainer = angular.element('.onoff-container', $element),
	        onLabel = angular.element('.on-label', $element),
	        offLabel = angular.element('.off-label', $element),
	        switchTitleContainer = angular.element('.title-container', $element),
	        switchTitle = angular.element('.switch-title', $element),
	        textMeasure = angular.element('#text-measure', $element),
	        switchErrorContainer = angular.element('.error-container', $element),
	        switchError = angular.element('.switch-error', $element);
	
	    vm.onValue = onValue;
	
	    vm.valueSubscription = null;
	
	    $scope.$watch('vm.ctx', function () {
	        if (vm.ctx) {
	            init();
	        }
	    });
	
	    $scope.$on('$destroy', function () {
	        if (vm.valueSubscription) {
	            vm.ctx.subscriptionApi.removeSubscription(vm.valueSubscription.id);
	        }
	    });
	
	    function init() {
	
	        vm.title = angular.isDefined(vm.ctx.settings.title) ? vm.ctx.settings.title : '';
	        vm.showTitle = vm.title && vm.title.length ? true : false;
	        vm.showOnOffLabels = angular.isDefined(vm.ctx.settings.showOnOffLabels) ? vm.ctx.settings.showOnOffLabels : true;
	        vm.ctx.resize = resize;
	        $scope.$applyAsync(function () {
	            resize();
	        });
	        var initialValue = angular.isDefined(vm.ctx.settings.initialValue) ? vm.ctx.settings.initialValue : false;
	        setValue(initialValue);
	
	        var subscription = vm.ctx.defaultSubscription;
	        var rpcEnabled = subscription.rpcEnabled;
	
	        vm.isSimulated = $scope.widgetEditMode;
	
	        vm.requestTimeout = 500;
	        if (vm.ctx.settings.requestTimeout) {
	            vm.requestTimeout = vm.ctx.settings.requestTimeout;
	        }
	
	        vm.retrieveValueMethod = 'rpc';
	        if (vm.ctx.settings.retrieveValueMethod && vm.ctx.settings.retrieveValueMethod.length) {
	            vm.retrieveValueMethod = vm.ctx.settings.retrieveValueMethod;
	        }
	
	        vm.valueKey = 'value';
	        if (vm.ctx.settings.valueKey && vm.ctx.settings.valueKey.length) {
	            vm.valueKey = vm.ctx.settings.valueKey;
	        }
	
	        vm.parseValueFunction = function (data) {
	            return data ? true : false;
	        };
	        if (vm.ctx.settings.parseValueFunction && vm.ctx.settings.parseValueFunction.length) {
	            try {
	                vm.parseValueFunction = new Function('data', vm.ctx.settings.parseValueFunction);
	            } catch (e) {
	                vm.parseValueFunction = function (data) {
	                    return data ? true : false;
	                };
	            }
	        }
	
	        vm.convertValueFunction = function (value) {
	            return value;
	        };
	        if (vm.ctx.settings.convertValueFunction && vm.ctx.settings.convertValueFunction.length) {
	            try {
	                vm.convertValueFunction = new Function('value', vm.ctx.settings.convertValueFunction);
	            } catch (e) {
	                vm.convertValueFunction = function (value) {
	                    return value;
	                };
	            }
	        }
	
	        vm.getValueMethod = 'getValue';
	        if (vm.ctx.settings.getValueMethod && vm.ctx.settings.getValueMethod.length) {
	            vm.getValueMethod = vm.ctx.settings.getValueMethod;
	        }
	        vm.setValueMethod = 'setValue';
	        if (vm.ctx.settings.setValueMethod && vm.ctx.settings.setValueMethod.length) {
	            vm.setValueMethod = vm.ctx.settings.setValueMethod;
	        }
	        if (!rpcEnabled) {
	            onError('Target device is not set!');
	        } else {
	            if (!vm.isSimulated) {
	                if (vm.retrieveValueMethod == 'rpc') {
	                    rpcRequestValue();
	                } else if (vm.retrieveValueMethod == 'attribute' || vm.retrieveValueMethod == 'timeseries') {
	                    subscribeForValue();
	                }
	            }
	        }
	    }
	
	    var switchAspectRation = 2.7893;
	
	    function resize() {
	        var width = switchContainer.width();
	        var height;
	        if (vm.showOnOffLabels) {
	            height = switchContainer.height() * 2 / 3;
	        } else {
	            height = switchContainer.height();
	        }
	        var ratio = width / height;
	        if (ratio > switchAspectRation) {
	            width = height * switchAspectRation;
	        } else {
	            height = width / switchAspectRation;
	        }
	        switchElement.css({ width: width, height: height });
	        mdSwitch.css('height', height + 'px');
	        mdSwitch.css('width', width + 'px');
	        mdSwitch.css('min-width', width + 'px');
	        angular.element('.md-container', mdSwitch).css('height', height + 'px');
	        angular.element('.md-container', mdSwitch).css('width', width + 'px');
	
	        if (vm.showTitle) {
	            setFontSize(switchTitle, vm.title, switchTitleContainer.height() * 2 / 3, switchTitleContainer.width());
	        }
	
	        if (vm.showOnOffLabels) {
	            onoffContainer.css({ width: width, height: switchContainer.height() / 3 });
	            setFontSize(onLabel, 'OFF', onoffContainer.height(), onoffContainer.width() / 2);
	            setFontSize(offLabel, 'OFF', onoffContainer.height(), onoffContainer.width() / 2);
	        }
	
	        setFontSize(switchError, vm.error, switchErrorContainer.height(), switchErrorContainer.width());
	    }
	
	    function subscribeForValue() {
	        var valueSubscriptionInfo = [{
	            type: types.datasourceType.entity,
	            entityType: types.entityType.device,
	            entityId: vm.ctx.defaultSubscription.targetDeviceId
	        }];
	        if (vm.retrieveValueMethod == 'attribute') {
	            valueSubscriptionInfo[0].attributes = [{ name: vm.valueKey }];
	        } else {
	            valueSubscriptionInfo[0].timeseries = [{ name: vm.valueKey }];
	        }
	        var subscriptionOptions = {
	            callbacks: {
	                onDataUpdated: onDataUpdated,
	                onDataUpdateError: onDataUpdateError
	            }
	        };
	        vm.ctx.subscriptionApi.createSubscriptionFromInfo(types.widgetType.latest.value, valueSubscriptionInfo, subscriptionOptions, false, true).then(function (subscription) {
	            vm.valueSubscription = subscription;
	        });
	    }
	
	    function onDataUpdated(subscription, apply) {
	        var value = false;
	        var data = subscription.data;
	        if (data.length) {
	            var keyData = data[0];
	            if (keyData && keyData.data && keyData.data[0]) {
	                var attrValue = keyData.data[0][1];
	                if (attrValue) {
	                    var parsed = null;
	                    try {
	                        parsed = vm.parseValueFunction(angular.fromJson(attrValue));
	                    } catch (e) {/**/}
	                    value = parsed ? true : false;
	                }
	            }
	        }
	        setValue(value);
	        if (apply) {
	            $scope.$digest();
	        }
	    }
	
	    function onDataUpdateError(subscription, e) {
	        var exceptionData = utils.parseException(e);
	        var errorText = exceptionData.name;
	        if (exceptionData.message) {
	            errorText += ': ' + exceptionData.message;
	        }
	        onError(errorText);
	    }
	
	    function setValue(value) {
	        vm.value = value ? true : false;
	    }
	
	    function onValue() {
	        rpcUpdateValue(vm.value);
	    }
	
	    function onError(error) {
	        $scope.$applyAsync(function () {
	            vm.error = error;
	            setFontSize(switchError, vm.error, switchErrorContainer.height(), switchErrorContainer.width());
	        });
	    }
	
	    function setFontSize(element, text, fontSize, maxWidth) {
	        var textWidth = measureTextWidth(text, fontSize);
	        while (textWidth > maxWidth) {
	            fontSize--;
	            textWidth = measureTextWidth(text, fontSize);
	        }
	        element.css({ 'fontSize': fontSize + 'px', 'lineHeight': fontSize + 'px' });
	    }
	
	    function measureTextWidth(text, fontSize) {
	        textMeasure.css({ 'fontSize': fontSize + 'px', 'lineHeight': fontSize + 'px' });
	        textMeasure.text(text);
	        return textMeasure.width();
	    }
	
	    function rpcRequestValue() {
	        vm.error = '';
	        vm.ctx.controlApi.sendTwoWayCommand(vm.getValueMethod, null, vm.requestTimeout).then(function (responseBody) {
	            setValue(vm.parseValueFunction(responseBody));
	        }, function () {
	            var errorText = vm.ctx.defaultSubscription.rpcErrorText;
	            onError(errorText);
	        });
	    }
	
	    function rpcUpdateValue(value) {
	        if (vm.executingUpdateValue) {
	            vm.scheduledValue = value;
	            return;
	        } else {
	            vm.scheduledValue = null;
	            vm.rpcValue = value;
	            vm.executingUpdateValue = true;
	        }
	        vm.error = '';
	        vm.ctx.controlApi.sendOneWayCommand(vm.setValueMethod, vm.convertValueFunction(value), vm.requestTimeout).then(function () {
	            vm.executingUpdateValue = false;
	            if (vm.scheduledValue != null && vm.scheduledValue != vm.rpcValue) {
	                rpcUpdateValue(vm.scheduledValue);
	            }
	        }, function () {
	            vm.executingUpdateValue = false;
	            var errorText = vm.ctx.defaultSubscription.rpcErrorText;
	            onError(errorText);
	        });
	    }
	}

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var tmGlobals = {
	    loadingTmId: null,
	    tmApiKeys: {}
	};
	
	var TbTencentMap = function () {
	    function TbTencentMap($containerElement, utils, initCallback, defaultZoomLevel, dontFitMapBounds, minZoomLevel, tmApiKey, tmDefaultMapType) {
	        _classCallCheck(this, TbTencentMap);
	
	        var tbMap = this;
	        this.utils = utils;
	        this.defaultZoomLevel = defaultZoomLevel;
	        this.dontFitMapBounds = dontFitMapBounds;
	        this.minZoomLevel = minZoomLevel;
	        this.tooltips = [];
	        this.defaultMapType = tmDefaultMapType;
	
	        function clearGlobalId() {
	            if (tmGlobals.loadingTmId && tmGlobals.loadingTmId === tbMap.mapId) {
	                tmGlobals.loadingTmId = null;
	            }
	        }
	
	        function displayError(message) {
	            $containerElement.html( // eslint-disable-line angular/angularelement
	            "<div class='error'>" + message + "</div>");
	        }
	
	        function initTencentMap() {
	            tbMap.map = new qq.maps.Map($containerElement[0], { // eslint-disable-line no-undef
	                scrollwheel: true,
	                mapTypeId: getTencentMapTypeId(tbMap.defaultMapType),
	                zoom: tbMap.defaultZoomLevel || 8
	            });
	
	            if (initCallback) {
	                initCallback();
	            }
	        }
	
	        /* eslint-disable no-undef */
	
	        function getTencentMapTypeId(mapType) {
	            var mapTypeId = qq.maps.MapTypeId.ROADMAP;
	            if (mapType) {
	                if (mapType === 'hybrid') {
	                    mapTypeId = qq.maps.MapTypeId.HYBRID;
	                } else if (mapType === 'satellite') {
	                    mapTypeId = qq.maps.MapTypeId.SATELLITE;
	                } else if (mapType === 'terrain') {
	                    mapTypeId = qq.maps.MapTypeId.ROADMAP;
	                }
	            }
	            return mapTypeId;
	        }
	
	        /* eslint-enable no-undef */
	
	        this.mapId = '' + Math.random().toString(36).substr(2, 9);
	        this.apiKey = tmApiKey || '84d6d83e0e51e481e50454ccbe8986b';
	
	        window.tm_authFailure = function () {
	            // eslint-disable-line no-undef, angular/window-service
	            if (tmGlobals.loadingTmId && tmGlobals.loadingTmId === tbMap.mapId) {
	                tmGlobals.loadingTmId = null;
	                tmGlobals.tmApiKeys[tbMap.apiKey].error = 'Unable to authentificate for tencent Map API.</br>Please check your API key.';
	                displayError(tmGlobals.tmApiKeys[tbMap.apiKey].error);
	            }
	        };
	
	        this.initMapFunctionName = 'initTencentMap_' + this.mapId;
	
	        window[this.initMapFunctionName] = function () {
	            // eslint-disable-line no-undef, angular/window-service
	            tmGlobals.tmApiKeys[tbMap.apiKey].loaded = true;
	            initTencentMap();
	            for (var p = 0; p < tmGlobals.tmApiKeys[tbMap.apiKey].pendingInits.length; p++) {
	                var pendingInit = tmGlobals.tmApiKeys[tbMap.apiKey].pendingInits[p];
	                pendingInit();
	            }
	            tmGlobals.tmApiKeys[tbMap.apiKey].pendingInits = [];
	        };
	        if (this.apiKey && this.apiKey.length > 0) {
	            if (tmGlobals.tmApiKeys[this.apiKey]) {
	                if (tmGlobals.tmApiKeys[this.apiKey].error) {
	                    displayError(tmGlobals.tmApiKeys[this.apiKey].error);
	                } else if (tmGlobals.tmApiKeys[this.apiKey].loaded) {
	                    initTencentMap();
	                } else {
	                    tmGlobals.tmApiKeys[this.apiKey].pendingInits.push(initTencentMap);
	                }
	            } else {
	                tmGlobals.tmApiKeys[this.apiKey] = {
	                    loaded: false,
	                    pendingInits: []
	                };
	                var tencentMapScriptRes = 'https://map.qq.com/api/js?v=2.exp&key=' + this.apiKey + '&callback=' + this.initMapFunctionName;
	
	                tmGlobals.loadingTmId = this.mapId;
	                lazyLoad.load({ type: 'js', path: tencentMapScriptRes }).then( // eslint-disable-line no-undef
	                function success() {
	                    setTimeout(clearGlobalId, 2000); // eslint-disable-line no-undef, angular/timeout-service
	                }, function fail(e) {
	                    clearGlobalId();
	                    tmGlobals.tmApiKeys[tbMap.apiKey].error = 'tencent map api load failed!</br>' + e;
	                    displayError(tmGlobals.tmApiKeys[tbMap.apiKey].error);
	                });
	            }
	        } else {
	            displayError('No tencent Map Api Key provided!');
	        }
	    }
	
	    _createClass(TbTencentMap, [{
	        key: "inited",
	        value: function inited() {
	            return angular.isDefined(this.map);
	        }
	    }, {
	        key: "createMarkerLabelStyle",
	        value: function createMarkerLabelStyle(settings) {
	            return {
	                width: "200px",
	                textAlign: "center",
	                color: settings.labelColor,
	                background: "none",
	                border: "none",
	                fontSize: "12px",
	                fontFamily: "\"Helvetica Neue\", Arial, Helvetica, sans-serif",
	                fontWeight: "bold"
	            };
	        }
	
	        /* eslint-disable no-undef,no-unused-vars*/
	
	    }, {
	        key: "updateMarkerLabel",
	        value: function updateMarkerLabel(marker, settings) {
	            if (marker.label) {
	                marker.label.setContent(settings.labelText);
	                marker.label.setStyle(this.createMarkerLabelStyle(settings));
	            }
	        }
	        /* eslint-enable no-undef,no-unused-vars */
	
	        /* eslint-disable no-undef,no-unused-vars */
	
	    }, {
	        key: "updateMarkerColor",
	        value: function updateMarkerColor(marker, color) {
	            this.createDefaultMarkerIcon(marker, color, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	            });
	        }
	        /* eslint-enable no-undef,,no-unused-vars */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "updateMarkerIcon",
	        value: function updateMarkerIcon(marker, settings) {
	            this.createMarkerIcon(marker, settings, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	                if (marker.label) {
	                    marker.label.setOffset(new qq.maps.Size(-100, -iconInfo.size[1] - 20));
	                }
	            });
	        }
	        /* eslint-disable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createMarkerIcon",
	        value: function createMarkerIcon(marker, settings, onMarkerIconReady) {
	            var currentImage = settings.currentImage;
	            var tMap = this;
	            if (currentImage && currentImage.url) {
	                this.utils.loadImageAspect(currentImage.url).then(function (aspect) {
	                    if (aspect) {
	                        var width;
	                        var height;
	                        if (aspect > 1) {
	                            width = currentImage.size;
	                            height = currentImage.size / aspect;
	                        } else {
	                            width = currentImage.size * aspect;
	                            height = currentImage.size;
	                        }
	                        var icon = new qq.maps.MarkerImage(currentImage.url, new qq.maps.Size(width, height), new qq.maps.Point(0, 0), new qq.maps.Point(width / 2, height), new qq.maps.Size(width, height));
	                        var iconInfo = {
	                            size: [width, height],
	                            icon: icon
	                        };
	                        onMarkerIconReady(iconInfo);
	                    } else {
	                        tMap.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
	                    }
	                });
	            } else {
	                this.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
	            }
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createDefaultMarkerIcon",
	        value: function createDefaultMarkerIcon(marker, color, onMarkerIconReady) {
	            var pinColor = color.substr(1);
	            var icon = new qq.maps.MarkerImage("https://chart.apis.google.com/chart?chst=d_map_pin_letter_withshadow&chld=%E2%80%A2|" + pinColor, new qq.maps.Size(40, 37), new qq.maps.Point(0, 0), new qq.maps.Point(10, 37));
	            var iconInfo = {
	                size: [40, 37],
	                icon: icon
	            };
	            onMarkerIconReady(iconInfo);
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createMarker",
	        value: function createMarker(location, settings, onClickListener, markerArgs) {
	            var marker = new qq.maps.Marker({
	                position: location
	            });
	            var tMap = this;
	            this.createMarkerIcon(marker, settings, function (iconInfo) {
	                marker.setIcon(iconInfo.icon);
	                marker.setMap(tMap.map);
	                if (settings.showLabel) {
	                    marker.label = new qq.maps.Label({
	                        clickable: false,
	                        content: settings.labelText,
	                        offset: new qq.maps.Size(-100, -iconInfo.size[1] - 20),
	                        style: tMap.createMarkerLabelStyle(settings),
	                        visible: true,
	                        position: location,
	                        map: tMap.map,
	                        zIndex: 1000
	                    });
	                }
	            });
	
	            if (settings.displayTooltip) {
	                this.createTooltip(marker, settings.tooltipPattern, settings.tooltipReplaceInfo, settings.autocloseTooltip, markerArgs);
	            }
	
	            if (onClickListener) {
	                qq.maps.event.addListener(marker, 'click', onClickListener);
	            }
	
	            return marker;
	        }
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "removeMarker",
	        value: function removeMarker(marker) {
	            marker.setMap(null);
	            if (marker.label) {
	                marker.label.setMap(null);
	            }
	        }
	
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createTooltip",
	        value: function createTooltip(marker, pattern, replaceInfo, autoClose, markerArgs) {
	            var popup = new qq.maps.InfoWindow({
	                map: this.map
	            });
	            var map = this;
	            qq.maps.event.addListener(marker, 'click', function () {
	                if (autoClose) {
	                    map.tooltips.forEach(function (tooltip) {
	                        tooltip.popup.close();
	                    });
	                }
	                popup.open();
	                popup.setPosition(marker);
	            });
	            this.tooltips.push({
	                markerArgs: markerArgs,
	                popup: popup,
	                pattern: pattern,
	                replaceInfo: replaceInfo
	            });
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "updatePolylineColor",
	        value: function updatePolylineColor(polyline, settings, color) {
	            var options = {
	                path: polyline.getPath(),
	                strokeColor: color,
	                strokeOpacity: settings.strokeOpacity,
	                strokeWeight: settings.strokeWeight,
	                map: this.map
	            };
	            polyline.setOptions(options);
	        }
	        /* eslint-enable no-undef */
	
	        /* eslint-disable no-undef */
	
	    }, {
	        key: "createPolyline",
	        value: function createPolyline(locations, settings) {
	            var polyline = new qq.maps.Polyline({
	                path: locations,
	                strokeColor: settings.color,
	                strokeOpacity: settings.strokeOpacity,
	                strokeWeight: settings.strokeWeight,
	                map: this.map
	            });
	
	            return polyline;
	        }
	        /* eslint-enable no-undef */
	
	    }, {
	        key: "removePolyline",
	        value: function removePolyline(polyline) {
	            polyline.setMap(null);
	        }
	
	        /* eslint-disable no-undef ,no-unused-vars*/
	
	    }, {
	        key: "fitBounds",
	        value: function fitBounds(bounds) {
	            if (this.dontFitMapBounds && this.defaultZoomLevel) {
	                this.map.setZoom(this.defaultZoomLevel);
	                this.map.setCenter(bounds.getCenter());
	            } else {
	                var tbMap = this;
	                qq.maps.event.addListenerOnce(this.map, 'bounds_changed', function () {
	                    // eslint-disable-line no-undef
	                    if (!tbMap.defaultZoomLevel && tbMap.map.getZoom() > tbMap.minZoomLevel) {
	                        tbMap.map.setZoom(tbMap.minZoomLevel);
	                    }
	                });
	                this.map.fitBounds(bounds);
	            }
	        }
	        /* eslint-enable no-undef,no-unused-vars */
	
	    }, {
	        key: "createLatLng",
	        value: function createLatLng(lat, lng) {
	            return new qq.maps.LatLng(lat, lng); // eslint-disable-line no-undef
	        }
	    }, {
	        key: "extendBoundsWithMarker",
	        value: function extendBoundsWithMarker(bounds, marker) {
	            bounds.extend(marker.getPosition());
	        }
	    }, {
	        key: "getMarkerPosition",
	        value: function getMarkerPosition(marker) {
	            return marker.getPosition();
	        }
	    }, {
	        key: "setMarkerPosition",
	        value: function setMarkerPosition(marker, latLng) {
	            marker.setPosition(latLng);
	            if (marker.label) {
	                marker.label.setPosition(latLng);
	            }
	        }
	    }, {
	        key: "getPolylineLatLngs",
	        value: function getPolylineLatLngs(polyline) {
	            return polyline.getPath().getArray();
	        }
	    }, {
	        key: "setPolylineLatLngs",
	        value: function setPolylineLatLngs(polyline, latLngs) {
	            polyline.setPath(latLngs);
	        }
	    }, {
	        key: "createBounds",
	        value: function createBounds() {
	            return new qq.maps.LatLngBounds(); // eslint-disable-line no-undef
	        }
	    }, {
	        key: "extendBounds",
	        value: function extendBounds(bounds, polyline) {
	            if (polyline && polyline.getPath()) {
	                var locations = polyline.getPath();
	                for (var i = 0; i < locations.getLength(); i++) {
	                    bounds.extend(locations.getAt(i));
	                }
	            }
	        }
	    }, {
	        key: "invalidateSize",
	        value: function invalidateSize() {
	            qq.maps.event.trigger(this.map, "resize"); // eslint-disable-line no-undef
	        }
	    }, {
	        key: "getTooltips",
	        value: function getTooltips() {
	            return this.tooltips;
	        }
	    }]);
	
	    return TbTencentMap;
	}();
	
	exports.default = TbTencentMap;

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	TimeseriesTableWidgetController.$inject = ["$element", "$scope", "$filter", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(829);
	
	var _timeseriesTableWidgetTpl = __webpack_require__(1538);
	
	var _timeseriesTableWidgetTpl2 = _interopRequireDefault(_timeseriesTableWidgetTpl);
	
	var _tinycolor = __webpack_require__(21);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _css = __webpack_require__(149);
	
	var _css2 = _interopRequireDefault(_css);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	exports.default = angular.module('thingsboard.widgets.timeseriesTableWidget', []).directive('tbTimeseriesTableWidget', TimeseriesTableWidget).name;
	
	/*@ngInject*/
	
	
	/* eslint-disable import/no-unresolved, import/default */
	
	function TimeseriesTableWidget() {
	    return {
	        restrict: "E",
	        scope: true,
	        bindToController: {
	            tableId: '=',
	            ctx: '='
	        },
	        controller: TimeseriesTableWidgetController,
	        controllerAs: 'vm',
	        templateUrl: _timeseriesTableWidgetTpl2.default
	    };
	}
	
	/*@ngInject*/
	function TimeseriesTableWidgetController($element, $scope, $filter, $timeout) {
	    var vm = this;
	    var dateFormatFilter = 'yyyy-MM-dd HH:mm:ss';
	
	    vm.sources = [];
	    vm.sourceIndex = 0;
	    vm.defaultPageSize = 10;
	    vm.defaultSortOrder = '-0';
	    vm.query = {
	        "search": null
	    };
	
	    vm.enterFilterMode = enterFilterMode;
	    vm.exitFilterMode = exitFilterMode;
	
	    function enterFilterMode() {
	        vm.query.search = '';
	        vm.ctx.hideTitlePanel = true;
	        $timeout(function () {
	            angular.element(vm.ctx.$container).find('.searchInput').focus();
	        });
	    }
	
	    function exitFilterMode() {
	        vm.query.search = null;
	        vm.ctx.hideTitlePanel = false;
	    }
	
	    vm.searchAction = {
	        name: 'action.search',
	        show: true,
	        onAction: function onAction() {
	            vm.enterFilterMode();
	        },
	        icon: 'search'
	    };
	
	    $scope.$watch('vm.ctx', function () {
	        if (vm.ctx) {
	            vm.settings = vm.ctx.settings;
	            vm.widgetConfig = vm.ctx.widgetConfig;
	            vm.data = vm.ctx.data;
	            vm.datasources = vm.ctx.datasources;
	            initialize();
	        }
	    });
	
	    function initialize() {
	        vm.ctx.widgetActions = [vm.searchAction];
	        vm.showTimestamp = vm.settings.showTimestamp !== false;
	        var origColor = vm.widgetConfig.color || 'rgba(0, 0, 0, 0.87)';
	        var defaultColor = (0, _tinycolor2.default)(origColor);
	        var mdDark = defaultColor.setAlpha(0.87).toRgbString();
	        var mdDarkSecondary = defaultColor.setAlpha(0.54).toRgbString();
	        var mdDarkDisabled = defaultColor.setAlpha(0.26).toRgbString();
	        //var mdDarkIcon = mdDarkSecondary;
	        var mdDarkDivider = defaultColor.setAlpha(0.12).toRgbString();
	
	        var cssString = 'table.md-table th.md-column {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + 'table.md-table th.md-column md-icon.md-sort-icon {\n' + 'color: ' + mdDarkDisabled + ';\n' + '}\n' + 'table.md-table th.md-column.md-active, table.md-table th.md-column.md-active md-icon {\n' + 'color: ' + mdDark + ';\n' + '}\n' + 'table.md-table td.md-cell {\n' + 'color: ' + mdDark + ';\n' + 'border-top: 1px ' + mdDarkDivider + ' solid;\n' + '}\n' + 'table.md-table td.md-cell.md-placeholder {\n' + 'color: ' + mdDarkDisabled + ';\n' + '}\n' + 'table.md-table td.md-cell md-select > .md-select-value > span.md-select-icon {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + '.md-table-pagination {\n' + 'color: ' + mdDarkSecondary + ';\n' + 'border-top: 1px ' + mdDarkDivider + ' solid;\n' + '}\n' + '.md-table-pagination .buttons md-icon {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}\n' + '.md-table-pagination md-select:not([disabled]):focus .md-select-value {\n' + 'color: ' + mdDarkSecondary + ';\n' + '}';
	
	        var cssParser = new _css2.default();
	        cssParser.testMode = false;
	        var namespace = 'ts-table-' + hashCode(cssString);
	        cssParser.cssPreviewNamespace = namespace;
	        cssParser.createStyleElement(namespace, cssString);
	        $element.addClass(namespace);
	
	        vm.displayPagination = angular.isDefined(vm.settings.displayPagination) ? vm.settings.displayPagination : true;
	
	        function hashCode(str) {
	            var hash = 0;
	            var i, char;
	            if (str.length === 0) return hash;
	            for (i = 0; i < str.length; i++) {
	                char = str.charCodeAt(i);
	                hash = (hash << 5) - hash + char;
	                hash = hash & hash;
	            }
	            return hash;
	        }
	        updateDatasources();
	    }
	
	    $scope.$on('timeseries-table-data-updated', function (event, tableId) {
	        if (vm.tableId == tableId) {
	            dataUpdated();
	        }
	    });
	
	    function dataUpdated() {
	        for (var s = 0; s < vm.sources.length; s++) {
	            var source = vm.sources[s];
	            source.rawData = vm.data.slice(source.keyStartIndex, source.keyEndIndex);
	        }
	        updateSourceData(vm.sources[vm.sourceIndex]);
	        $scope.$digest();
	    }
	
	    vm.onPaginate = function (source) {
	        updatePage(source);
	    };
	
	    vm.onReorder = function (source) {
	        reorder(source);
	        updatePage(source);
	    };
	
	    vm.cellStyle = function (source, index, value) {
	        var style = {};
	        if (index > 0) {
	            var styleInfo = source.ts.stylesInfo[index - 1];
	            if (styleInfo.useCellStyleFunction && styleInfo.cellStyleFunction) {
	                try {
	                    style = styleInfo.cellStyleFunction(value);
	                } catch (e) {
	                    style = {};
	                }
	            }
	        }
	        return style;
	    };
	
	    vm.cellContent = function (source, index, row, value) {
	        if (index === 0) {
	            return $filter('date')(value, dateFormatFilter);
	        } else {
	            var strContent = '';
	            if (angular.isDefined(value)) {
	                strContent = '' + value;
	            }
	            var content = strContent;
	            var contentInfo = source.ts.contentsInfo[index - 1];
	            if (contentInfo.useCellContentFunction && contentInfo.cellContentFunction) {
	                try {
	                    var rowData = source.ts.rowDataTemplate;
	                    rowData['Timestamp'] = row[0];
	                    for (var h = 0; h < source.ts.header.length; h++) {
	                        var headerInfo = source.ts.header[h];
	                        rowData[headerInfo.dataKey.name] = row[headerInfo.index];
	                    }
	                    content = contentInfo.cellContentFunction(value, rowData, $filter);
	                } catch (e) {
	                    content = strContent;
	                }
	            } else {
	                var decimals = contentInfo.decimals || contentInfo.decimals === 0 ? contentInfo.decimals : vm.widgetConfig.decimals;
	                var units = contentInfo.units || vm.widgetConfig.units;
	                content = vm.ctx.utils.formatValue(value, decimals, units, true);
	            }
	            return content;
	        }
	    };
	
	    $scope.$watch('vm.sourceIndex', function (newIndex, oldIndex) {
	        if (newIndex != oldIndex) {
	            updateSourceData(vm.sources[vm.sourceIndex]);
	        }
	    });
	
	    function updateDatasources() {
	        vm.sources = [];
	        vm.sourceIndex = 0;
	        var keyOffset = 0;
	        if (vm.datasources) {
	            for (var ds = 0; ds < vm.datasources.length; ds++) {
	                var source = {};
	                var datasource = vm.datasources[ds];
	                source.keyStartIndex = keyOffset;
	                keyOffset += datasource.dataKeys.length;
	                source.keyEndIndex = keyOffset;
	                source.datasource = datasource;
	                source.data = [];
	                source.rawData = [];
	                source.query = {
	                    limit: vm.settings.defaultPageSize || 10,
	                    page: 1,
	                    order: '-0'
	                };
	                source.ts = {
	                    header: [],
	                    count: 0,
	                    data: [],
	                    stylesInfo: [],
	                    contentsInfo: [],
	                    rowDataTemplate: {}
	                };
	                source.ts.rowDataTemplate['Timestamp'] = null;
	                for (var a = 0; a < datasource.dataKeys.length; a++) {
	                    var dataKey = datasource.dataKeys[a];
	                    var keySettings = dataKey.settings;
	                    source.ts.header.push({
	                        index: a + 1,
	                        dataKey: dataKey
	                    });
	                    source.ts.rowDataTemplate[dataKey.label] = null;
	
	                    var cellStyleFunction = null;
	                    var useCellStyleFunction = false;
	
	                    if (keySettings.useCellStyleFunction === true) {
	                        if (angular.isDefined(keySettings.cellStyleFunction) && keySettings.cellStyleFunction.length > 0) {
	                            try {
	                                cellStyleFunction = new Function('value', keySettings.cellStyleFunction);
	                                useCellStyleFunction = true;
	                            } catch (e) {
	                                cellStyleFunction = null;
	                                useCellStyleFunction = false;
	                            }
	                        }
	                    }
	
	                    source.ts.stylesInfo.push({
	                        useCellStyleFunction: useCellStyleFunction,
	                        cellStyleFunction: cellStyleFunction
	                    });
	
	                    var cellContentFunction = null;
	                    var useCellContentFunction = false;
	
	                    if (keySettings.useCellContentFunction === true) {
	                        if (angular.isDefined(keySettings.cellContentFunction) && keySettings.cellContentFunction.length > 0) {
	                            try {
	                                cellContentFunction = new Function('value, rowData, filter', keySettings.cellContentFunction);
	                                useCellContentFunction = true;
	                            } catch (e) {
	                                cellContentFunction = null;
	                                useCellContentFunction = false;
	                            }
	                        }
	                    }
	
	                    source.ts.contentsInfo.push({
	                        useCellContentFunction: useCellContentFunction,
	                        cellContentFunction: cellContentFunction,
	                        units: dataKey.units,
	                        decimals: dataKey.decimals
	                    });
	                }
	                vm.sources.push(source);
	            }
	        }
	    }
	
	    function updatePage(source) {
	        var startIndex = source.query.limit * (source.query.page - 1);
	        source.ts.data = source.data.slice(startIndex, startIndex + source.query.limit);
	    }
	
	    function reorder(source) {
	        var searchRegExp = new RegExp(vm.query.search);
	
	        source.data = $filter('orderBy')(source.data, source.query.order);
	        if (vm.query.search !== null) {
	            source.data = source.data.filter(function (item) {
	                for (var i = 0; i < item.length; i++) {
	                    if (vm.showTimestamp) {
	                        if (i === 0) {
	                            if (searchRegExp.test($filter('date')(item[i], dateFormatFilter))) {
	                                return true;
	                            }
	                        } else {
	                            if (searchRegExp.test(item[i])) {
	                                return true;
	                            }
	                        }
	                    } else {
	                        if (searchRegExp.test(item[i])) {
	                            return true;
	                        }
	                    }
	                }
	            });
	        }
	    }
	
	    function convertData(data) {
	        var rowsMap = {};
	        for (var d = 0; d < data.length; d++) {
	            var columnData = data[d].data;
	            for (var i = 0; i < columnData.length; i++) {
	                var cellData = columnData[i];
	                var timestamp = cellData[0];
	                var row = rowsMap[timestamp];
	                if (!row) {
	                    row = [];
	                    row[0] = timestamp;
	                    for (var c = 0; c < data.length; c++) {
	                        row[c + 1] = undefined;
	                    }
	                    rowsMap[timestamp] = row;
	                }
	                row[d + 1] = cellData[1];
	            }
	        }
	        var rows = [];
	        for (var t in rowsMap) {
	            rows.push(rowsMap[t]);
	        }
	        return rows;
	    }
	
	    function updateSourceData(source) {
	        source.data = convertData(source.rawData);
	        source.ts.count = source.data.length;
	        reorder(source);
	        updatePage(source);
	    }
	}

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	'use strict';
	
	SaveWidgetTypeAsController.$inject = ["$mdDialog", "$q", "userService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SaveWidgetTypeAsController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function SaveWidgetTypeAsController($mdDialog, $q, userService) {
	
	    var vm = this;
	
	    vm.saveAs = saveAs;
	    vm.cancel = cancel;
	
	    vm.widgetName;
	    vm.widgetsBundle;
	
	    vm.bundlesScope = 'system';
	
	    if (userService.getAuthority() === 'TENANT_ADMIN') {
	        vm.bundlesScope = 'tenant';
	    }
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function saveAs() {
	        $mdDialog.hide({ widgetName: vm.widgetName, bundleId: vm.widgetsBundle.id.id, bundleAlias: vm.widgetsBundle.alias });
	    }
	}

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	"use strict";
	
	SelectWidgetTypeController.$inject = ["$mdDialog", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SelectWidgetTypeController;
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*@ngInject*/
	function SelectWidgetTypeController($mdDialog, types) {
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.cancel = cancel;
	    vm.typeSelected = typeSelected;
	
	    function cancel() {
	        $mdDialog.cancel();
	    }
	
	    function typeSelected(widgetType) {
	        $mdDialog.hide(widgetType);
	    }
	}

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WidgetEditorController.$inject = ["widgetService", "userService", "types", "toast", "hotkeys", "$element", "$rootScope", "$scope", "$state", "$stateParams", "$timeout", "$window", "$document", "$translate", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WidgetEditorController;
	
	var _jquery = __webpack_require__(12);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _brace = __webpack_require__(168);
	
	var _brace2 = _interopRequireDefault(_brace);
	
	__webpack_require__(33);
	
	__webpack_require__(278);
	
	__webpack_require__(276);
	
	__webpack_require__(275);
	
	__webpack_require__(51);
	
	__webpack_require__(651);
	
	__webpack_require__(279);
	
	__webpack_require__(650);
	
	__webpack_require__(649);
	
	__webpack_require__(169);
	
	var _saveWidgetTypeAsTpl = __webpack_require__(1539);
	
	var _saveWidgetTypeAsTpl2 = _interopRequireDefault(_saveWidgetTypeAsTpl);
	
	var _split = __webpack_require__(574);
	
	var _split2 = _interopRequireDefault(_split);
	
	var _jsBeautify = __webpack_require__(34);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	var js_beautify = _jsBeautify2.default.js;
	
	/* eslint-disable import/no-unresolved, import/default */
	
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var html_beautify = _jsBeautify2.default.html;
	var css_beautify = _jsBeautify2.default.css;
	
	/* eslint-disable angular/angularelement */
	
	/*@ngInject*/
	function WidgetEditorController(widgetService, userService, types, toast, hotkeys, $element, $rootScope, $scope, $state, $stateParams, $timeout, $window, $document, $translate, $mdDialog) {
	
	    var Range = _brace2.default.acequire("ace/range").Range;
	    var ace_editors = [];
	    var js_editor;
	    var iframe = (0, _jquery2.default)('iframe', $element);
	    var gotError = false;
	    var errorMarkers = [];
	    var errorAnnotationId = -1;
	    var elem = (0, _jquery2.default)($element);
	
	    var widgetsBundleId = $stateParams.widgetsBundleId;
	
	    var vm = this;
	
	    vm.widgetsBundle;
	    vm.isDirty = false;
	    vm.fullscreen = false;
	    vm.widgetType = null;
	    vm.widget = null;
	    vm.origWidget = null;
	    vm.widgetTypes = types.widgetType;
	    vm.iframeWidgetEditModeInited = false;
	    vm.layoutInited = false;
	    vm.htmlEditorOptions = {
	        useWrapMode: true,
	        mode: 'html',
	        advanced: {
	            enableSnippets: true,
	            enableBasicAutocompletion: true,
	            enableLiveAutocompletion: true
	        },
	        onLoad: function onLoad(_ace) {
	            ace_editors.push(_ace);
	        }
	    };
	    vm.cssEditorOptions = {
	        useWrapMode: true,
	        mode: 'css',
	        advanced: {
	            enableSnippets: true,
	            enableBasicAutocompletion: true,
	            enableLiveAutocompletion: true
	        },
	        onLoad: function onLoad(_ace) {
	            ace_editors.push(_ace);
	        }
	    };
	    vm.jsonSettingsEditorOptions = {
	        useWrapMode: true,
	        mode: 'json',
	        advanced: {
	            enableSnippets: true,
	            enableBasicAutocompletion: true,
	            enableLiveAutocompletion: true
	        },
	        onLoad: function onLoad(_ace) {
	            ace_editors.push(_ace);
	        }
	    };
	    vm.dataKeyJsonSettingsEditorOptions = {
	        useWrapMode: true,
	        mode: 'json',
	        advanced: {
	            enableSnippets: true,
	            enableBasicAutocompletion: true,
	            enableLiveAutocompletion: true
	        },
	        onLoad: function onLoad(_ace) {
	            ace_editors.push(_ace);
	        }
	    };
	    vm.jsEditorOptions = {
	        useWrapMode: true,
	        mode: 'javascript',
	        advanced: {
	            enableSnippets: true,
	            enableBasicAutocompletion: true,
	            enableLiveAutocompletion: true
	        },
	        onLoad: function onLoad(_ace) {
	            ace_editors.push(_ace);
	            js_editor = _ace;
	            js_editor.session.on("change", function () {
	                cleanupJsErrors();
	            });
	        }
	    };
	
	    vm.addResource = addResource;
	    vm.applyWidgetScript = applyWidgetScript;
	    vm.beautifyCss = beautifyCss;
	    vm.beautifyDataKeyJson = beautifyDataKeyJson;
	    vm.beautifyHtml = beautifyHtml;
	    vm.beautifyJs = beautifyJs;
	    vm.beautifyJson = beautifyJson;
	    vm.removeResource = removeResource;
	    vm.undoDisabled = undoDisabled;
	    vm.undoWidget = undoWidget;
	    vm.saveDisabled = saveDisabled;
	    vm.saveWidget = saveWidget;
	    vm.saveAsDisabled = saveAsDisabled;
	    vm.saveWidgetAs = saveWidgetAs;
	    vm.toggleFullscreen = toggleFullscreen;
	    vm.isReadOnly = isReadOnly;
	
	    initWidgetEditor();
	
	    function initWidgetEditor() {
	
	        $rootScope.loading = true;
	
	        widgetService.getWidgetsBundle(widgetsBundleId).then(function success(widgetsBundle) {
	            vm.widgetsBundle = widgetsBundle;
	            if ($stateParams.widgetTypeId) {
	                widgetService.getWidgetTypeById($stateParams.widgetTypeId).then(function success(widgetType) {
	                    setWidgetType(widgetType);
	                    widgetTypeLoaded();
	                }, function fail() {
	                    toast.showError($translate.instant('widget.widget-type-load-failed-error'));
	                    widgetTypeLoaded();
	                });
	            } else {
	                var type = $stateParams.widgetType;
	                if (!type) {
	                    type = types.widgetType.timeseries.value;
	                }
	                widgetService.getWidgetTemplate(type).then(function success(widgetTemplate) {
	                    vm.widget = angular.copy(widgetTemplate);
	                    vm.widget.widgetName = null;
	                    vm.origWidget = angular.copy(vm.widget);
	                    vm.isDirty = true;
	                    widgetTypeLoaded();
	                }, function fail() {
	                    toast.showError($translate.instant('widget.widget-template-load-failed-error'));
	                    widgetTypeLoaded();
	                });
	            }
	        }, function fail() {
	            toast.showError($translate.instant('widget.widget-type-load-failed-error'));
	            widgetTypeLoaded();
	        });
	    }
	
	    function setWidgetType(widgetType) {
	        vm.widgetType = widgetType;
	        vm.widget = widgetService.toWidgetInfo(vm.widgetType);
	        var config = angular.fromJson(vm.widget.defaultConfig);
	        vm.widget.defaultConfig = angular.toJson(config);
	        vm.origWidget = angular.copy(vm.widget);
	        vm.isDirty = false;
	    }
	
	    function widgetTypeLoaded() {
	        initHotKeys();
	
	        initWatchers();
	
	        angular.element($document[0]).ready(function () {
	            var w = elem.width();
	            if (w > 0) {
	                initSplitLayout();
	            } else {
	                $scope.$watch(function () {
	                    return elem[0].offsetWidth || parseInt(elem.css('width'), 10);
	                }, function (newSize) {
	                    if (newSize > 0) {
	                        initSplitLayout();
	                    }
	                });
	            }
	        });
	
	        iframe.attr('data-widget', angular.toJson(vm.widget));
	        iframe.attr('src', '/widget-editor');
	    }
	
	    function undoDisabled() {
	        return $scope.loading || !vm.isDirty || !vm.iframeWidgetEditModeInited || vm.saveWidgetPending || vm.saveWidgetAsPending;
	    }
	
	    function saveDisabled() {
	        return vm.isReadOnly() || $scope.loading || !vm.isDirty || !vm.iframeWidgetEditModeInited || vm.saveWidgetPending || vm.saveWidgetAsPending;
	    }
	
	    function saveAsDisabled() {
	        return $scope.loading || !vm.iframeWidgetEditModeInited || vm.saveWidgetPending || vm.saveWidgetAsPending;
	    }
	
	    function initHotKeys() {
	        $translate(['widget.undo', 'widget.save', 'widget.saveAs', 'widget.toggle-fullscreen', 'widget.run']).then(function (translations) {
	            hotkeys.bindTo($scope).add({
	                combo: 'ctrl+q',
	                description: translations['widget.undo'],
	                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	                callback: function callback(event) {
	                    if (!undoDisabled()) {
	                        event.preventDefault();
	                        undoWidget();
	                    }
	                }
	            }).add({
	                combo: 'ctrl+s',
	                description: translations['widget.save'],
	                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	                callback: function callback(event) {
	                    if (!saveDisabled()) {
	                        event.preventDefault();
	                        saveWidget();
	                    }
	                }
	            }).add({
	                combo: 'shift+ctrl+s',
	                description: translations['widget.saveAs'],
	                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	                callback: function callback(event) {
	                    if (!saveAsDisabled()) {
	                        event.preventDefault();
	                        saveWidgetAs();
	                    }
	                }
	            }).add({
	                combo: 'shift+ctrl+f',
	                description: translations['widget.toggle-fullscreen'],
	                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	                callback: function callback(event) {
	                    event.preventDefault();
	                    toggleFullscreen();
	                }
	            }).add({
	                combo: 'ctrl+enter',
	                description: translations['widget.run'],
	                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	                callback: function callback(event) {
	                    event.preventDefault();
	                    applyWidgetScript();
	                }
	            });
	        });
	    }
	
	    function initWatchWidget() {
	        $scope.widgetWatcher = $scope.$watch('vm.widget', function (newVal, oldVal) {
	            if (!angular.equals(newVal, oldVal)) {
	                vm.isDirty = true;
	            }
	        }, true);
	    }
	
	    function initWatchers() {
	        initWatchWidget();
	
	        $scope.$watch('vm.widget.type', function (newVal, oldVal) {
	            if (!angular.equals(newVal, oldVal)) {
	                var config = angular.fromJson(vm.widget.defaultConfig);
	                if (vm.widget.type !== types.widgetType.rpc.value && vm.widget.type !== types.widgetType.alarm.value) {
	                    if (config.targetDeviceAliases) {
	                        delete config.targetDeviceAliases;
	                    }
	                    if (config.alarmSource) {
	                        delete config.alarmSource;
	                    }
	                    if (!config.datasources) {
	                        config.datasources = [];
	                    }
	                    if (!config.timewindow) {
	                        config.timewindow = {
	                            realtime: {
	                                timewindowMs: 60000
	                            }
	                        };
	                    }
	                    for (var i = 0; i < config.datasources.length; i++) {
	                        var datasource = config.datasources[i];
	                        datasource.type = vm.widget.type;
	                    }
	                } else if (vm.widget.type == types.widgetType.rpc.value) {
	                    if (config.datasources) {
	                        delete config.datasources;
	                    }
	                    if (config.alarmSource) {
	                        delete config.alarmSource;
	                    }
	                    if (config.timewindow) {
	                        delete config.timewindow;
	                    }
	                    if (!config.targetDeviceAliases) {
	                        config.targetDeviceAliases = [];
	                    }
	                } else {
	                    // alarm
	                    if (config.datasources) {
	                        delete config.datasources;
	                    }
	                    if (config.targetDeviceAliases) {
	                        delete config.targetDeviceAliases;
	                    }
	                    if (!config.alarmSource) {
	                        config.alarmSource = {};
	                        config.alarmSource.type = vm.widget.type;
	                    }
	                    if (!config.timewindow) {
	                        config.timewindow = {
	                            realtime: {
	                                timewindowMs: 24 * 60 * 60 * 1000
	                            }
	                        };
	                    }
	                }
	                vm.widget.defaultConfig = angular.toJson(config);
	            }
	        });
	
	        $scope.$on('widgetEditModeInited', function () {
	            vm.iframeWidgetEditModeInited = true;
	            if (vm.saveWidgetPending || vm.saveWidgetAsPending) {
	                if (!vm.saveWidgetTimeout) {
	                    vm.saveWidgetTimeout = $timeout(function () {
	                        if (!gotError) {
	                            if (vm.saveWidgetPending) {
	                                commitSaveWidget();
	                            } else if (vm.saveWidgetAsPending) {
	                                commitSaveWidgetAs();
	                            }
	                        } else {
	                            toast.showError($translate.instant('widget.unable-to-save-widget-error'));
	                            vm.saveWidgetPending = false;
	                            vm.saveWidgetAsPending = false;
	                            initWatchWidget();
	                        }
	                        vm.saveWidgetTimeout = undefined;
	                    }, 1500);
	                }
	            }
	        });
	
	        $scope.$on('widgetEditUpdated', function (event, widget) {
	            vm.widget.sizeX = widget.sizeX / 2;
	            vm.widget.sizeY = widget.sizeY / 2;
	            vm.widget.defaultConfig = angular.toJson(widget.config);
	            iframe.attr('data-widget', angular.toJson(vm.widget));
	        });
	
	        $scope.$on('widgetException', function (event, details) {
	            if (!gotError) {
	                gotError = true;
	                var errorInfo = 'Error:';
	                if (details.name) {
	                    errorInfo += ' ' + details.name + ':';
	                }
	                if (details.message) {
	                    errorInfo += ' ' + details.message;
	                }
	                if (details.lineNumber) {
	                    errorInfo += '<br>Line ' + details.lineNumber;
	                    if (details.columnNumber) {
	                        errorInfo += ' column ' + details.columnNumber;
	                    }
	                    errorInfo += ' of script.';
	                }
	                if (!vm.saveWidgetPending && !vm.saveWidgetAsPending) {
	                    toast.showError(errorInfo, (0, _jquery2.default)('#javascript_panel', $element)[0]);
	                }
	                if (js_editor && details.lineNumber) {
	                    var line = details.lineNumber - 1;
	                    var column = 0;
	                    if (details.columnNumber) {
	                        column = details.columnNumber;
	                    }
	
	                    var errorMarkerId = js_editor.session.addMarker(new Range(line, 0, line, Infinity), "ace_active-line", "screenLine");
	                    errorMarkers.push(errorMarkerId);
	                    var annotations = js_editor.session.getAnnotations();
	                    var errorAnnotation = {
	                        row: line,
	                        column: column,
	                        text: details.message,
	                        type: "error"
	                    };
	                    errorAnnotationId = annotations.push(errorAnnotation) - 1;
	                    js_editor.session.setAnnotations(annotations);
	                }
	            }
	        });
	    }
	
	    function cleanupJsErrors() {
	        toast.hide();
	        for (var i = 0; i < errorMarkers.length; i++) {
	            js_editor.session.removeMarker(errorMarkers[i]);
	        }
	        errorMarkers = [];
	        if (errorAnnotationId && errorAnnotationId > -1) {
	            var annotations = js_editor.session.getAnnotations();
	            annotations.splice(errorAnnotationId, 1);
	            js_editor.session.setAnnotations(annotations);
	            errorAnnotationId = -1;
	        }
	    }
	
	    function onDividerDrag() {
	        for (var i = 0; i < ace_editors.length; i++) {
	            var ace = ace_editors[i];
	            ace.resize();
	            ace.renderer.updateFull();
	        }
	    }
	
	    function initSplitLayout() {
	        if (!vm.layoutInited) {
	            (0, _split2.default)([(0, _jquery2.default)('#top_panel', $element)[0], (0, _jquery2.default)('#bottom_panel', $element)[0]], {
	                sizes: [35, 65],
	                gutterSize: 8,
	                cursor: 'row-resize',
	                direction: 'vertical',
	                onDrag: function onDrag() {
	                    onDividerDrag();
	                }
	            });
	
	            (0, _split2.default)([(0, _jquery2.default)('#top_left_panel', $element)[0], (0, _jquery2.default)('#top_right_panel', $element)[0]], {
	                sizes: [50, 50],
	                gutterSize: 8,
	                cursor: 'col-resize',
	                onDrag: function onDrag() {
	                    onDividerDrag();
	                }
	            });
	
	            (0, _split2.default)([(0, _jquery2.default)('#javascript_panel', $element)[0], (0, _jquery2.default)('#frame_panel', $element)[0]], {
	                sizes: [50, 50],
	                gutterSize: 8,
	                cursor: 'col-resize',
	                onDrag: function onDrag() {
	                    onDividerDrag();
	                }
	            });
	
	            onDividerDrag();
	
	            $scope.$applyAsync(function () {
	                vm.layoutInited = true;
	                $rootScope.loading = false;
	                var w = angular.element($window);
	                $timeout(function () {
	                    w.triggerHandler('resize');
	                });
	            });
	        }
	    }
	
	    function removeResource(index) {
	        if (index > -1) {
	            vm.widget.resources.splice(index, 1);
	        }
	    }
	
	    function addResource() {
	        vm.widget.resources.push({ url: '' });
	    }
	
	    function applyWidgetScript() {
	        cleanupJsErrors();
	        gotError = false;
	        vm.iframeWidgetEditModeInited = false;
	        var config = angular.fromJson(vm.widget.defaultConfig);
	        config.title = vm.widget.widgetName;
	        vm.widget.defaultConfig = angular.toJson(config);
	        iframe.attr('data-widget', angular.toJson(vm.widget));
	        iframe[0].contentWindow.location.reload(true);
	    }
	
	    function toggleFullscreen() {
	        vm.fullscreen = !vm.fullscreen;
	    }
	
	    function isReadOnly() {
	        if (userService.getAuthority() === 'TENANT_ADMIN') {
	            return !vm.widgetsBundle || vm.widgetsBundle.tenantId.id === types.id.nullUid;
	        } else {
	            return userService.getAuthority() != 'SYS_ADMIN';
	        }
	    }
	
	    function undoWidget() {
	        if ($scope.widgetWatcher) {
	            $scope.widgetWatcher();
	        }
	        vm.widget = angular.copy(vm.origWidget);
	        vm.isDirty = false;
	        initWatchWidget();
	        applyWidgetScript();
	    }
	
	    function saveWidget() {
	        if (!vm.widget.widgetName) {
	            toast.showError($translate.instant('widget.missing-widget-title-error'));
	        } else {
	            $scope.widgetWatcher();
	            vm.saveWidgetPending = true;
	            applyWidgetScript();
	        }
	    }
	
	    function saveWidgetAs($event) {
	        $scope.widgetWatcher();
	        vm.saveWidgetAsPending = true;
	        vm.saveWidgetAsEvent = $event;
	        applyWidgetScript();
	    }
	
	    function commitSaveWidget() {
	        var id = vm.widgetType && vm.widgetType.id ? vm.widgetType.id : undefined;
	        widgetService.saveWidgetType(vm.widget, id, vm.widgetsBundle.alias).then(function success(widgetType) {
	            setWidgetType(widgetType);
	            vm.saveWidgetPending = false;
	            initWatchWidget();
	            toast.showSuccess($translate.instant('widget.widget-saved'), 500);
	        }, function fail() {
	            vm.saveWidgetPending = false;
	            initWatchWidget();
	        });
	    }
	
	    function commitSaveWidgetAs() {
	        $mdDialog.show({
	            controller: 'SaveWidgetTypeAsController',
	            controllerAs: 'vm',
	            templateUrl: _saveWidgetTypeAsTpl2.default,
	            parent: angular.element($document[0].body),
	            fullscreen: true,
	            targetEvent: vm.saveWidgetAsEvent
	        }).then(function (saveWidgetAsData) {
	            vm.widget.widgetName = saveWidgetAsData.widgetName;
	            vm.widget.alias = undefined;
	            var config = angular.fromJson(vm.widget.defaultConfig);
	            config.title = vm.widget.widgetName;
	            vm.widget.defaultConfig = angular.toJson(config);
	
	            vm.saveWidgetAsPending = false;
	            vm.isDirty = false;
	            initWatchWidget();
	            widgetService.saveWidgetType(vm.widget, undefined, saveWidgetAsData.bundleAlias).then(function success(widgetType) {
	                $state.go('home.widgets-bundles.widget-types.widget-type', { widgetsBundleId: saveWidgetAsData.bundleId, widgetTypeId: widgetType.id.id });
	            }, function fail() {
	                vm.saveWidgetAsPending = false;
	                initWatchWidget();
	            });
	        }, function () {
	            vm.saveWidgetAsPending = false;
	            initWatchWidget();
	        });
	    }
	
	    function beautifyJs() {
	        var res = js_beautify(vm.widget.controllerScript, { indent_size: 4, wrap_line_length: 60 });
	        vm.widget.controllerScript = res;
	    }
	
	    function beautifyHtml() {
	        var res = html_beautify(vm.widget.templateHtml, { indent_size: 4, wrap_line_length: 60 });
	        vm.widget.templateHtml = res;
	    }
	
	    function beautifyCss() {
	        var res = css_beautify(vm.widget.templateCss, { indent_size: 4 });
	        vm.widget.templateCss = res;
	    }
	
	    function beautifyJson() {
	        var res = js_beautify(vm.widget.settingsSchema, { indent_size: 4 });
	        vm.widget.settingsSchema = res;
	    }
	
	    function beautifyDataKeyJson() {
	        var res = js_beautify(vm.widget.dataKeySettingsSchema, { indent_size: 4 });
	        vm.widget.dataKeySettingsSchema = res;
	    }
	}
	
	/* eslint-enable angular/angularelement */

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WidgetLibraryController.$inject = ["$scope", "$rootScope", "$q", "widgetService", "userService", "importExport", "$state", "$stateParams", "$document", "$mdDialog", "$translate", "$filter", "utils", "types", "entityService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WidgetLibraryController;
	
	var _aliasController = __webpack_require__(227);
	
	var _aliasController2 = _interopRequireDefault(_aliasController);
	
	var _selectWidgetTypeTpl = __webpack_require__(1540);
	
	var _selectWidgetTypeTpl2 = _interopRequireDefault(_selectWidgetTypeTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function WidgetLibraryController($scope, $rootScope, $q, widgetService, userService, importExport, $state, $stateParams, $document, $mdDialog, $translate, $filter, utils, types, entityService) {
	
	    var vm = this;
	
	    var widgetsBundleId = $stateParams.widgetsBundleId;
	
	    vm.widgetsBundle;
	    vm.widgetTypes = [];
	    vm.dashboardInitComplete = false;
	
	    var stateController = {
	        getStateParams: function getStateParams() {
	            return {};
	        }
	    };
	    vm.aliasController = new _aliasController2.default($scope, $q, $filter, utils, types, entityService, stateController, {});
	
	    vm.noData = noData;
	    vm.dashboardInited = dashboardInited;
	    vm.dashboardInitFailed = dashboardInitFailed;
	    vm.addWidgetType = addWidgetType;
	    vm.openWidgetType = openWidgetType;
	    vm.exportWidgetType = exportWidgetType;
	    vm.importWidgetType = importWidgetType;
	    vm.removeWidgetType = removeWidgetType;
	    vm.loadWidgetLibrary = loadWidgetLibrary;
	    vm.addWidgetType = addWidgetType;
	    vm.isReadOnly = isReadOnly;
	
	    function loadWidgetLibrary() {
	        var deferred = $q.defer();
	        $rootScope.loading = true;
	        widgetService.getWidgetsBundle(widgetsBundleId).then(function success(widgetsBundle) {
	            vm.widgetsBundle = widgetsBundle;
	            if (vm.widgetsBundle) {
	                var bundleAlias = vm.widgetsBundle.alias;
	                var isSystem = vm.widgetsBundle.tenantId.id === types.id.nullUid;
	
	                widgetService.getBundleWidgetTypes(bundleAlias, isSystem).then(function (widgetTypes) {
	
	                    widgetTypes = $filter('orderBy')(widgetTypes, ['-descriptor.type', '-createdTime']);
	
	                    var top = 0;
	                    var lastTop = [0, 0, 0];
	                    var col = 0;
	                    var column = 0;
	
	                    if (widgetTypes.length > 0) {
	                        loadNext(0);
	                    } else {
	                        $rootScope.loading = false;
	                        deferred.resolve();
	                    }
	
	                    function loadNextOrComplete(i) {
	                        i++;
	                        if (i < widgetTypes.length) {
	                            loadNext(i);
	                        } else {
	                            $rootScope.loading = false;
	                            deferred.resolve();
	                        }
	                    }
	
	                    function loadNext(i) {
	                        var widgetType = widgetTypes[i];
	                        $scope.$applyAsync(function () {
	                            var widgetTypeInfo = widgetService.toWidgetInfo(widgetType);
	                            var sizeX = 8;
	                            var sizeY = Math.floor(widgetTypeInfo.sizeY);
	                            var widget = {
	                                typeId: widgetType.id,
	                                isSystemType: isSystem,
	                                bundleAlias: bundleAlias,
	                                typeAlias: widgetTypeInfo.alias,
	                                type: widgetTypeInfo.type,
	                                title: widgetTypeInfo.widgetName,
	                                sizeX: sizeX,
	                                sizeY: sizeY,
	                                row: top,
	                                col: col,
	                                config: angular.fromJson(widgetTypeInfo.defaultConfig)
	                            };
	                            widget.config.title = widgetTypeInfo.widgetName;
	                            vm.widgetTypes.push(widget);
	                            top += sizeY;
	                            if (top > lastTop[column] + 10) {
	                                lastTop[column] = top;
	                                column++;
	                                if (column > 2) {
	                                    column = 0;
	                                }
	                                top = lastTop[column];
	                                col = column * 8;
	                            }
	                            loadNextOrComplete(i);
	                        });
	                    }
	                });
	            } else {
	                $rootScope.loading = false;
	                deferred.resolve();
	            }
	        }, function fail() {
	            $rootScope.loading = false;
	            deferred.reject();
	        });
	        return deferred.promise;
	    }
	
	    function noData() {
	        return vm.dashboardInitComplete && vm.widgetTypes.length == 0;
	    }
	
	    function dashboardInitFailed() {
	        vm.dashboardInitComplete = true;
	    }
	
	    function dashboardInited() {
	        vm.dashboardInitComplete = true;
	    }
	
	    function addWidgetType($event) {
	        vm.openWidgetType($event);
	    }
	
	    function isReadOnly() {
	        if (userService.getAuthority() === 'TENANT_ADMIN') {
	            return !vm.widgetsBundle || vm.widgetsBundle.tenantId.id === types.id.nullUid;
	        } else {
	            return userService.getAuthority() != 'SYS_ADMIN';
	        }
	    }
	
	    function openWidgetType(event, widget) {
	        if (event) {
	            event.stopPropagation();
	        }
	        if (widget) {
	            $state.go('home.widgets-bundles.widget-types.widget-type', { widgetTypeId: widget.typeId.id });
	        } else {
	            $mdDialog.show({
	                controller: 'SelectWidgetTypeController',
	                controllerAs: 'vm',
	                templateUrl: _selectWidgetTypeTpl2.default,
	                parent: angular.element($document[0].body),
	                fullscreen: true,
	                targetEvent: event
	            }).then(function (widgetType) {
	                $state.go('home.widgets-bundles.widget-types.widget-type', { widgetType: widgetType });
	            }, function () {});
	        }
	    }
	
	    function exportWidgetType(event, widget) {
	        event.stopPropagation();
	        importExport.exportWidgetType(widget.typeId.id);
	    }
	
	    function importWidgetType($event) {
	        $event.stopPropagation();
	        importExport.importWidgetType($event, vm.widgetsBundle.alias).then(function success() {
	            $state.go($state.current, $state.params, { reload: true });
	        }, function fail() {});
	    }
	
	    function removeWidgetType(event, widget) {
	        var confirm = $mdDialog.confirm().targetEvent(event).title($translate.instant('widget.remove-widget-type-title', { widgetName: widget.config.title })).htmlContent($translate.instant('widget.remove-widget-type-text')).ariaLabel($translate.instant('widget.remove-widget-type')).cancel($translate.instant('action.no')).ok($translate.instant('action.yes'));
	        $mdDialog.show(confirm).then(function () {
	            widgetService.deleteWidgetType(widget.bundleAlias, widget.typeAlias, widget.isSystemType).then(function success() {
	                vm.widgetTypes.splice(vm.widgetTypes.indexOf(widget), 1);
	            }, function fail() {});
	        });
	    }
	}
	
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WidgetLibraryRoutes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WidgetLibraryRoutes;
	
	var _widgetLibraryTpl = __webpack_require__(1542);
	
	var _widgetLibraryTpl2 = _interopRequireDefault(_widgetLibraryTpl);
	
	var _widgetEditorTpl = __webpack_require__(1541);
	
	var _widgetEditorTpl2 = _interopRequireDefault(_widgetEditorTpl);
	
	var _dashboardTpl = __webpack_require__(520);
	
	var _dashboardTpl2 = _interopRequireDefault(_dashboardTpl);
	
	var _widgetsBundlesTpl = __webpack_require__(1545);
	
	var _widgetsBundlesTpl2 = _interopRequireDefault(_widgetsBundlesTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function WidgetLibraryRoutes($stateProvider) {
	    $stateProvider.state('home.widgets-bundles', {
	        url: '/widgets-bundles',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _widgetsBundlesTpl2.default,
	                controller: 'WidgetsBundleController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            searchEnabled: true,
	            pageTitle: 'widgets-bundle.widgets-bundles'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "now_widgets", "label": "widgets-bundle.widgets-bundles"}'
	        }
	    }).state('home.widgets-bundles.widget-types', {
	        url: '/:widgetsBundleId/widgetTypes',
	        params: { 'topIndex': 0 },
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _widgetLibraryTpl2.default,
	                controller: 'WidgetLibraryController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            searchEnabled: false,
	            pageTitle: 'widget.widget-library'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "now_widgets", "label": "{{ vm.widgetsBundle.title }}", "translate": "false"}'
	        }
	    }).state('home.widgets-bundles.widget-types.widget-type', {
	        url: '/:widgetTypeId',
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
	        views: {
	            "content@home": {
	                templateUrl: _widgetEditorTpl2.default,
	                controller: 'WidgetEditorController',
	                controllerAs: 'vm'
	            }
	        },
	        params: {
	            widgetType: null
	        },
	        data: {
	            searchEnabled: false,
	            pageTitle: 'widget.editor'
	        },
	        ncyBreadcrumb: {
	            label: '{"icon": "insert_chart", "label": "{{ vm.widget.widgetName }}", "translate": "false"}'
	        }
	    }).state('widgetEditor', {
	        url: '/widget-editor',
	        module: 'private',
	        auth: ['SYS_ADMIN', 'TENANT_ADMIN'],
	        views: {
	            "@": {
	                templateUrl: _dashboardTpl2.default,
	                controller: 'DashboardController',
	                controllerAs: 'vm'
	            }
	        },
	        data: {
	            widgetEditMode: true,
	            searchEnabled: false,
	            pageTitle: 'widget.editor'
	        }
	    });
	}

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WidgetsBundleController.$inject = ["widgetService", "userService", "importExport", "$state", "$stateParams", "$filter", "$translate", "types"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WidgetsBundleController;
	
	var _addWidgetsBundleTpl = __webpack_require__(1529);
	
	var _addWidgetsBundleTpl2 = _interopRequireDefault(_addWidgetsBundleTpl);
	
	var _widgetsBundleCardTpl = __webpack_require__(1543);
	
	var _widgetsBundleCardTpl2 = _interopRequireDefault(_widgetsBundleCardTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	/*
	 * Copyright © 2016-2018 The Thingsboard Authors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-disable import/no-unresolved, import/default */
	
	function WidgetsBundleController(widgetService, userService, importExport, $state, $stateParams, $filter, $translate, types) {
	
	    var widgetsBundleActionsList = [{
	        onAction: function onAction($event, item) {
	            exportWidgetsBundle($event, item);
	        },
	        name: function name() {
	            $translate.instant('action.export');
	        },
	        details: function details() {
	            return $translate.instant('widgets-bundle.export');
	        },
	        icon: "file_download"
	    }, {
	        onAction: function onAction($event, item) {
	            vm.grid.openItem($event, item);
	        },
	        name: function name() {
	            return $translate.instant('widgets-bundle.details');
	        },
	        details: function details() {
	            return $translate.instant('widgets-bundle.widgets-bundle-details');
	        },
	        icon: "edit"
	    }, {
	        onAction: function onAction($event, item) {
	            vm.grid.deleteItem($event, item);
	        },
	        name: function name() {
	            return $translate.instant('action.delete');
	        },
	        details: function details() {
	            return $translate.instant('widgets-bundle.delete');
	        },
	        icon: "delete",
	        isEnabled: isWidgetsBundleEditable
	    }];
	
	    var widgetsBundleAddItemActionsList = [{
	        onAction: function onAction($event) {
	            vm.grid.addItem($event);
	        },
	        name: function name() {
	            return $translate.instant('action.create');
	        },
	        details: function details() {
	            return $translate.instant('widgets-bundle.create-new-widgets-bundle');
	        },
	        icon: "insert_drive_file"
	    }, {
	        onAction: function onAction($event) {
	            importExport.importWidgetsBundle($event).then(function () {
	                vm.grid.refreshList();
	            });
	        },
	        name: function name() {
	            return $translate.instant('action.import');
	        },
	        details: function details() {
	            return $translate.instant('widgets-bundle.import');
	        },
	        icon: "file_upload"
	    }];
	
	    var vm = this;
	
	    vm.types = types;
	
	    vm.widgetsBundleGridConfig = {
	
	        refreshParamsFunc: null,
	
	        deleteItemTitleFunc: deleteWidgetsBundleTitle,
	        deleteItemContentFunc: deleteWidgetsBundleText,
	        deleteItemsTitleFunc: deleteWidgetsBundlesTitle,
	        deleteItemsActionTitleFunc: deleteWidgetsBundlesActionTitle,
	        deleteItemsContentFunc: deleteWidgetsBundlesText,
	
	        fetchItemsFunc: fetchWidgetsBundles,
	        saveItemFunc: saveWidgetsBundle,
	        clickItemFunc: openWidgetsBundle,
	        deleteItemFunc: deleteWidgetsBundle,
	
	        getItemTitleFunc: getWidgetsBundleTitle,
	        itemCardTemplateUrl: _widgetsBundleCardTpl2.default,
	        parentCtl: vm,
	
	        actionsList: widgetsBundleActionsList,
	        addItemActions: widgetsBundleAddItemActionsList,
	
	        onGridInited: gridInited,
	
	        addItemTemplateUrl: _addWidgetsBundleTpl2.default,
	
	        addItemText: function addItemText() {
	            return $translate.instant('widgets-bundle.add-widgets-bundle-text');
	        },
	        noItemsText: function noItemsText() {
	            return $translate.instant('widgets-bundle.no-widgets-bundles-text');
	        },
	        itemDetailsText: function itemDetailsText() {
	            return $translate.instant('widgets-bundle.widgets-bundle-details');
	        },
	        isSelectionEnabled: isWidgetsBundleEditable,
	        isDetailsReadOnly: function isDetailsReadOnly(widgetsBundle) {
	            return !isWidgetsBundleEditable(widgetsBundle);
	        }
	
	    };
	
	    if (angular.isDefined($stateParams.items) && $stateParams.items !== null) {
	        vm.widgetsBundleGridConfig.items = $stateParams.items;
	    }
	
	    if (angular.isDefined($stateParams.topIndex) && $stateParams.topIndex > 0) {
	        vm.widgetsBundleGridConfig.topIndex = $stateParams.topIndex;
	    }
	
	    vm.exportWidgetsBundle = exportWidgetsBundle;
	
	    function deleteWidgetsBundleTitle(widgetsBundle) {
	        return $translate.instant('widgets-bundle.delete-widgets-bundle-title', { widgetsBundleTitle: widgetsBundle.title });
	    }
	
	    function deleteWidgetsBundleText() {
	        return $translate.instant('widgets-bundle.delete-widgets-bundle-text');
	    }
	
	    function deleteWidgetsBundlesTitle(selectedCount) {
	        return $translate.instant('widgets-bundle.delete-widgets-bundles-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteWidgetsBundlesActionTitle(selectedCount) {
	        return $translate.instant('widgets-bundle.delete-widgets-bundles-action-title', { count: selectedCount }, 'messageformat');
	    }
	
	    function deleteWidgetsBundlesText() {
	        return $translate.instant('widgets-bundle.delete-widgets-bundles-text');
	    }
	
	    function gridInited(grid) {
	        vm.grid = grid;
	    }
	
	    function fetchWidgetsBundles(pageLink) {
	        return widgetService.getAllWidgetsBundlesByPageLink(pageLink);
	    }
	
	    function saveWidgetsBundle(widgetsBundle) {
	        return widgetService.saveWidgetsBundle(widgetsBundle);
	    }
	
	    function deleteWidgetsBundle(widgetsBundleId) {
	        return widgetService.deleteWidgetsBundle(widgetsBundleId);
	    }
	
	    function getWidgetsBundleTitle(widgetsBundle) {
	        return widgetsBundle ? widgetsBundle.title : '';
	    }
	
	    function isWidgetsBundleEditable(widgetsBundle) {
	        if (userService.getAuthority() === 'TENANT_ADMIN') {
	            return widgetsBundle && widgetsBundle.tenantId.id != types.id.nullUid;
	        } else {
	            return userService.getAuthority() === 'SYS_ADMIN';
	        }
	    }
	
	    function exportWidgetsBundle($event, widgetsBundle) {
	        $event.stopPropagation();
	        importExport.exportWidgetsBundle(widgetsBundle.id.id);
	    }
	
	    function openWidgetsBundle($event, widgetsBundle) {
	        if ($event) {
	            $event.stopPropagation();
	        }
	        $state.go('home.widgets-bundles.widget-types', { widgetsBundleId: widgetsBundle.id.id });
	    }
	}

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	WidgetsBundleDirective.$inject = ["$compile", "$templateCache"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WidgetsBundleDirective;
	
	var _widgetsBundleFieldsetTpl = __webpack_require__(1544);
	
	var _widgetsBundleFieldsetTpl2 = _interopRequireDefault(_widgetsBundleFieldsetTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/default */
	
	/*@ngInject*/
	function WidgetsBundleDirective($compile, $templateCache) {
	    var linker = function linker(scope, element) {
	        var template = $templateCache.get(_widgetsBundleFieldsetTpl2.default);
	        element.html(template);
	        $compile(element.contents())(scope);
	    };
	    return {
	        restrict: "E",
	        link: linker,
	        scope: {
	            widgetsBundle: '=',
	            isEdit: '=',
	            isReadOnly: '=',
	            theForm: '=',
	            onExportWidgetsBundle: '&',
	            onDeleteWidgetsBundle: '&'
	        }
	    };
	} /*
	   * Copyright © 2016-2018 The Thingsboard Authors
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	/* eslint-disable import/no-unresolved, import/default */

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	if (!Function.prototype.bind) {
	  Function.prototype.bind = function (oThis) {
	    if (typeof this !== "function") {
	      // closest thing possible to the ECMAScript 5 internal IsCallable function
	      throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
	    }
	
	    var aArgs = Array.prototype.slice.call(arguments, 1), 
	        fToBind = this, 
	        fNOP = function () {},
	        fBound = function () {
	          return fToBind.apply(this instanceof fNOP && oThis
	                                 ? this
	                                 : oThis,
	                               aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	    fNOP.prototype = this.prototype;
	    fBound.prototype = new fNOP();
	
	    return fBound;
	  };
	}
	(function() {
	
	  'use strict';
	
	  angular
	    .module('flowchart', ['flowchart-templates']);
	
	}());
	
	(function() {
	
	  'use strict';
	
	  /**
	   *
	   * @returns {Function}
	   * @constructor
	   */
	  function Topsortservice() {
	    /**
	     * @returns An array of node ids as string. ['idOfFirstNode', 'idOfSecondNode', ...]. Tbis is not exactly the best way to return ids, but until now there is no need for a better return.
	     */
	    return function(graph) {
	
	      // Build adjacent list with incoming and outgoing edges.
	      var adjacentList = {};
	      angular.forEach(graph.nodes, function(node) {
	        adjacentList[node.id] = {incoming: 0, outgoing: []};
	      });
	      angular.forEach(graph.edges, function(edge) {
	        var sourceNode = graph.nodes.filter(function(node) {
	          return node.connectors.some(function(connector) {
	            return connector.id === edge.source;
	          })
	        })[0];
	        var destinationNode = graph.nodes.filter(function(node) {
	          return node.connectors.some(function(connector) {
	            return connector.id === edge.destination;
	          })
	        })[0];
	
	        adjacentList[sourceNode.id].outgoing.push(destinationNode.id);
	        adjacentList[destinationNode.id].incoming++;
	      });
	
	      var orderedNodes = [];
	      var sourceNodes = [];
	      angular.forEach(adjacentList, function(edges, node) {
	        if (edges.incoming === 0) {
	          sourceNodes.push(node);
	        }
	      });
	      while (sourceNodes.length !== 0) {
	        var sourceNode = sourceNodes.pop();
	        for (var i = 0; i < adjacentList[sourceNode].outgoing.length; i++) {
	          var destinationNode = adjacentList[sourceNode].outgoing[i];
	          adjacentList[destinationNode].incoming--;
	          if (adjacentList[destinationNode].incoming === 0) {
	            sourceNodes.push('' + destinationNode);
	          }
	          adjacentList[sourceNode].outgoing.splice(i, 1);
	          i--;
	        }
	        orderedNodes.push(sourceNode);
	      }
	
	      var hasEdges = false;
	      angular.forEach(adjacentList, function(edges) {
	        if (edges.incoming !== 0) {
	          hasEdges = true;
	        }
	      });
	      if (hasEdges) {
	        return null;
	      } else {
	        return orderedNodes;
	      }
	
	    }
	  }
	
	  angular.module('flowchart')
	    .factory('Topsortservice', Topsortservice);
	})();
	
	(function() {
	
	  'use strict';
	
	  function Rectangleselectfactory() {
	
	    return function(modelservice, applyFunction) {
	
	      var rectangleSelectService = {
	      };
	
	      var selectRect = {
	        x1: 0,
	        x2: 0,
	        y1: 0,
	        y2: 0
	      };
	
	      function updateSelectRect() {
	        var x3 = Math.min(selectRect.x1,selectRect.x2);
	        var x4 = Math.max(selectRect.x1,selectRect.x2);
	        var y3 = Math.min(selectRect.y1,selectRect.y2);
	        var y4 = Math.max(selectRect.y1,selectRect.y2);
	        rectangleSelectService.selectElement.style.left = x3 + 'px';
	        rectangleSelectService.selectElement.style.top = y3 + 'px';
	        rectangleSelectService.selectElement.style.width = x4 - x3 + 'px';
	        rectangleSelectService.selectElement.style.height = y4 - y3 + 'px';
	      }
	
	      function selectObjects(rectBox) {
	        applyFunction(function() {
	          modelservice.selectAllInRect(rectBox);
	        });
	      }
	
	      rectangleSelectService.setRectangleSelectHtmlElement = function(element) {
	        rectangleSelectService.selectElement = element;
	      };
	
	      rectangleSelectService.mousedown = function(e) {
	        if (modelservice.isEditable() && !e.ctrlKey && !e.metaKey && e.button === 0) {
	          rectangleSelectService.selectElement.hidden = 0;
	          var offset = angular.element(modelservice.getCanvasHtmlElement()).offset();
	          selectRect.x1 = Math.round(e.clientX - offset.left);
	          selectRect.y1 = Math.round(e.clientY - offset.top);
	          updateSelectRect();
	        }
	      };
	      rectangleSelectService.mousemove = function(e) {
	        if (modelservice.isEditable() && !e.ctrlKey && !e.metaKey && e.button === 0) {
	          var offset = angular.element(modelservice.getCanvasHtmlElement()).offset();
	          selectRect.x2 = Math.round(e.clientX - offset.left);
	          selectRect.y2 = Math.round(e.clientY - offset.top);
	          updateSelectRect();
	        }
	      };
	      rectangleSelectService.mouseup = function (e) {
	        if (modelservice.isEditable() && !e.ctrlKey && !e.metaKey && e.button === 0) {
	          var rectBox = rectangleSelectService.selectElement.getBoundingClientRect();
	          rectBox.parentOffset = angular.element(modelservice.getCanvasHtmlElement()).offset();
	          rectangleSelectService.selectElement.hidden = 1;
	          selectObjects(rectBox);
	        }
	      };
	
	      return rectangleSelectService;
	    }
	
	  }
	
	  angular
	    .module('flowchart')
	    .factory('Rectangleselectfactory', Rectangleselectfactory);
	
	}());
	
	(function() {
	
	  'use strict';
	
	  function Nodedraggingfactory(flowchartConstants) {
	
	    var nodeDropScope = {};
	    nodeDropScope.dropElement = null;
	
	    return function(modelservice, nodeDraggingScope, applyFunction, automaticResize, dragAnimation) {
	
	      nodeDraggingScope.shadowDragStarted = false;
	      nodeDraggingScope.dropElement = null;
	
	      var dragOffsets = [];
	      var draggedElements = [];
	      nodeDraggingScope.draggedNodes = [];
	      nodeDraggingScope.shadowElements = [];
	
	      var destinationHtmlElements = [];
	      var oldDisplayStyles = [];
	
	      function getCoordinate(coordinate, max) {
	        coordinate = Math.max(coordinate, 0);
	        coordinate = Math.min(coordinate, max);
	        return coordinate;
	      }
	      function getXCoordinate(x) {
	        return getCoordinate(x, modelservice.getCanvasHtmlElement().offsetWidth);
	      }
	      function getYCoordinate(y) {
	        return getCoordinate(y, modelservice.getCanvasHtmlElement().offsetHeight);
	      }
	      function resizeCanvas(draggedNode, nodeElement) {
	        if (automaticResize && !modelservice.isDropSource()) {
	          var canvasElement = modelservice.getCanvasHtmlElement();
	          if (canvasElement.offsetWidth < draggedNode.x + nodeElement.offsetWidth + flowchartConstants.canvasResizeThreshold) {
	            canvasElement.style.width = canvasElement.offsetWidth + flowchartConstants.canvasResizeStep + 'px';
	          }
	          if (canvasElement.offsetHeight < draggedNode.y + nodeElement.offsetHeight + flowchartConstants.canvasResizeThreshold) {
	            canvasElement.style.height = canvasElement.offsetHeight + flowchartConstants.canvasResizeStep + 'px';
	          }
	        }
	      }
	      return {
	        dragstart: function(node) {
	          return function(event) {
	            if (node.readonly) {
	              return;
	            }
	            dragOffsets.length = 0;
	            draggedElements.length = 0;
	            nodeDraggingScope.draggedNodes.length = 0;
	            nodeDraggingScope.shadowElements.length = 0;
	            destinationHtmlElements.length = 0;
	            oldDisplayStyles.length = 0;
	
	            var elements = [];
	            var nodes = [];
	            if (modelservice.nodes.isSelected(node)) {
	              var selectedNodes = modelservice.nodes.getSelectedNodes();
	              for (var i=0;i<selectedNodes.length;i++) {
	                var selectedNode = selectedNodes[i];
	                var element = angular.element(modelservice.nodes.getHtmlElement(selectedNode.id));
	                elements.push(element);
	                nodes.push(selectedNode);
	              }
	            } else {
	              elements.push(angular.element(event.target));
	              nodes.push(node);
	            }
	            var offsetsX = [];
	            var offsetsY = [];
	            for (var i=0;i<elements.length;i++) {
	              var element = elements[i];
	              offsetsX.push(parseInt(element.css('left')) - event.clientX);
	              offsetsY.push(parseInt(element.css('top')) - event.clientY);
	            }
	            if (modelservice.isDropSource()) {
	              if (nodeDropScope.dropElement) {
	                nodeDropScope.dropElement.parentNode.removeChild(nodeDropScope.dropElement);
	                nodeDropScope.dropElement = null;
	              }
	              nodeDropScope.dropElement = elements[0][0].cloneNode(true);
	
	              var offset = angular.element(modelservice.getCanvasHtmlElement()).offset();
	
	              nodeDropScope.dropElement.offsetInfo = {
	                offsetX: Math.round(offsetsX[0] + offset.left),
	                offsetY: Math.round(offsetsY[0] + offset.top)
	              };
	              nodeDropScope.dropElement.style.position = 'absolute';
	              nodeDropScope.dropElement.style.pointerEvents = 'none';
	              nodeDropScope.dropElement.style.zIndex = '9999';
	
	              document.body.appendChild(nodeDropScope.dropElement);
	
	              var dropNodeInfo = {
	                node: node,
	                dropTargetId: modelservice.getDropTargetId(),
	                offsetX: Math.round(offsetsX[0] + offset.left),
	                offsetY: Math.round(offsetsY[0] + offset.top)
	              };
	              event.originalEvent.dataTransfer.setData('text', angular.toJson(dropNodeInfo));
	
	              if (event.originalEvent.dataTransfer.setDragImage) {
	                //var invisibleDiv = angular.element('<div></div>')[0]; // This divs stays invisible, because it is not in the dom.
	                //event.originalEvent.dataTransfer.setDragImage(invisibleDiv, 0, 0);
	                event.originalEvent.dataTransfer.setDragImage(modelservice.getDragImage(), 0, 0);
	              } else {
	                destinationHtmlElements.push(event.target);
	                oldDisplayStyles.push(event.target.style.display);
	                event.target.style.display = 'none';
	                nodeDraggingScope.shadowDragStarted = true;
	              }
	              return;
	            }
	            //modelservice.deselectAll();
	            //modelservice.nodes.select(node);
	            nodeDraggingScope.draggedNodes = nodes;
	            for (var i=0;i<elements.length;i++) {
	              draggedElements.push(elements[i][0]);
	              dragOffsets.push(
	                {
	                  x: offsetsX[i],
	                  y: offsetsY[i]
	                }
	              );
	            }
	
	            if (dragAnimation == flowchartConstants.dragAnimationShadow) {
	              for (var i=0;i<draggedElements.length;i++) {
	                var dragOffset = dragOffsets[i];
	                var draggedNode = nodeDraggingScope.draggedNodes[i];
	                var shadowElement = angular.element('<div style="position: absolute; opacity: 0.7; top: '+ getYCoordinate(dragOffset.y + event.clientY) +'px; left: '+ getXCoordinate(dragOffset.x + event.clientX) +'px; "><div class="innerNode"><p style="padding: 0 15px;">'+ draggedNode.name +'</p> </div></div>');
	                var targetInnerNode = angular.element(draggedElements[i]).children()[0];
	                shadowElement.children()[0].style.backgroundColor = targetInnerNode.style.backgroundColor;
	                nodeDraggingScope.shadowElements.push(shadowElement);
	                modelservice.getCanvasHtmlElement().appendChild(nodeDraggingScope.shadowElements[i][0]);
	              }
	            }
	
	            event.originalEvent.dataTransfer.setData('text', 'Just to support firefox');
	            if (event.originalEvent.dataTransfer.setDragImage) {
	              //var invisibleDiv = angular.element('<div></div>')[0]; // This divs stays invisible, because it is not in the dom.
	              //event.originalEvent.dataTransfer.setDragImage(invisibleDiv, 0, 0);
	              event.originalEvent.dataTransfer.setDragImage(modelservice.getDragImage(), 0, 0);
	            } else {
	              for (var i=0;i<draggedElements.length;i++) {
	                destinationHtmlElements.push(draggedElements[i]);
	                oldDisplayStyles.push(destinationHtmlElements[i].style.display);
	                destinationHtmlElements[i].style.display = 'none'; // Internetexplorer does not support setDragImage, but it takes an screenshot, from the draggedelement and uses it as dragimage.
	              }
	              // Since angular redraws the element in the next dragover call, display: none never gets visible to the user.
	              if (dragAnimation == flowchartConstants.dragAnimationShadow) {
	                // IE Drag Fix
	                nodeDraggingScope.shadowDragStarted = true;
	              }
	            }
	          };
	        },
	
	        drop: function(event) {
	          if (modelservice.isDropSource()) {
	            event.preventDefault();
	            return false;
	          }
	          var dropNode = null;
	          var infoText = event.originalEvent.dataTransfer.getData('text');
	          if (infoText) {
	            var dropNodeInfo = null;
	            try {
	                dropNodeInfo = angular.fromJson(infoText);
	            } catch (e) {}
	            if (dropNodeInfo && dropNodeInfo.dropTargetId) {
	              if (modelservice.getCanvasHtmlElement().id &&
	                modelservice.getCanvasHtmlElement().id == dropNodeInfo.dropTargetId) {
	                dropNode = dropNodeInfo.node;
	                var offset = angular.element(modelservice.getCanvasHtmlElement()).offset();
	                var x = event.clientX - offset.left;
	                var y = event.clientY - offset.top;
	                dropNode.x = Math.round(getXCoordinate(dropNodeInfo.offsetX + x));
	                dropNode.y = Math.round(getYCoordinate(dropNodeInfo.offsetY + y));
	              }
	             }
	          }
	          if (dropNode) {
	              modelservice.dropNode(event, dropNode);
	              event.preventDefault();
	              return false;
	          } else if (nodeDraggingScope.draggedNodes.length) {
	            return applyFunction(function() {
	              for (var i=0;i<nodeDraggingScope.draggedNodes.length;i++) {
	                var draggedNode = nodeDraggingScope.draggedNodes[i];
	                var dragOffset = dragOffsets[i];
	                draggedNode.x = Math.round(getXCoordinate(dragOffset.x + event.clientX));
	                draggedNode.y = Math.round(getYCoordinate(dragOffset.y + event.clientY));
	              }
	              event.preventDefault();
	              return false;
	            })
	          }
	        },
	        dragover: function(event) {
	          if (nodeDropScope.dropElement) {
	              var offsetInfo = nodeDropScope.dropElement.offsetInfo;
	              nodeDropScope.dropElement.style.left = (offsetInfo.offsetX + event.clientX) + 'px';
	              nodeDropScope.dropElement.style.top = (offsetInfo.offsetY + event.clientY) + 'px';
	              if(nodeDraggingScope.shadowDragStarted) {
	                applyFunction(function() {
	                  destinationHtmlElements[0].style.display = oldDisplayStyles[0];
	                  nodeDraggingScope.shadowDragStarted = false;
	                });
	              }
	              event.preventDefault();
	              return;
	          }
	          if (modelservice.isDropSource()) {
	            event.preventDefault();
	            return;
	          }
	          if (!nodeDraggingScope.draggedNodes.length) {
	            event.preventDefault();
	            return;
	          }
	          if (dragAnimation == flowchartConstants.dragAnimationRepaint) {
	            if (nodeDraggingScope.draggedNodes.length) {
	              return applyFunction(function() {
	                for (var i=0;i<nodeDraggingScope.draggedNodes.length;i++) {
	                  var draggedNode = nodeDraggingScope.draggedNodes[i];
	                  var dragOffset = dragOffsets[i];
	                  draggedNode.x = getXCoordinate(dragOffset.x + event.clientX);
	                  draggedNode.y = getYCoordinate(dragOffset.y + event.clientY);
	                  resizeCanvas(draggedNode, draggedElements[i]);
	                }
	                event.preventDefault();
	                return false;
	              });
	            }
	          } else if (dragAnimation == flowchartConstants.dragAnimationShadow) {
	            if (nodeDraggingScope.draggedNodes.length) {
	              if(nodeDraggingScope.shadowDragStarted) {
	                applyFunction(function() {
	                  for (var i=0;i<nodeDraggingScope.draggedNodes.length;i++) {
	                    destinationHtmlElements[i].style.display = oldDisplayStyles[i];
	                  }
	                  nodeDraggingScope.shadowDragStarted = false;
	                });
	              }
	              for (var i=0;i<nodeDraggingScope.draggedNodes.length;i++) {
	                var draggedNode = nodeDraggingScope.draggedNodes[i];
	                var dragOffset = dragOffsets[i];
	                nodeDraggingScope.shadowElements[i].css('left', getXCoordinate(dragOffset.x + event.clientX) + 'px');
	                nodeDraggingScope.shadowElements[i].css('top', getYCoordinate(dragOffset.y + event.clientY) + 'px');
	                resizeCanvas(draggedNode, draggedElements[i]);
	              }
	              event.preventDefault();
	            }
	          }
	        },
	
	        dragend: function(event) {
	          applyFunction(function() {
	            if (nodeDropScope.dropElement) {
	              nodeDropScope.dropElement.parentNode.removeChild(nodeDropScope.dropElement);
	              nodeDropScope.dropElement = null;
	            }
	            if (modelservice.isDropSource()) {
	              return;
	            }
	            if (nodeDraggingScope.shadowElements.length) {
	              for (var i=0;i<nodeDraggingScope.draggedNodes.length;i++) {
	                var draggedNode = nodeDraggingScope.draggedNodes[i];
	                var shadowElement = nodeDraggingScope.shadowElements[i];
	                draggedNode.x = parseInt(shadowElement.css('left').replace('px', ''));
	                draggedNode.y = parseInt(shadowElement.css('top').replace('px', ''));
	                modelservice.getCanvasHtmlElement().removeChild(shadowElement[0]);
	              }
	              nodeDraggingScope.shadowElements.length = 0;
	            }
	
	            if (nodeDraggingScope.draggedNodes.length) {
	              nodeDraggingScope.draggedNodes.length = 0;
	              draggedElements.length = 0;
	              dragOffsets.length = 0;
	            }
	          });
	        }
	      };
	    };
	  }
	  Nodedraggingfactory.$inject = ["flowchartConstants"];
	
	  angular
	    .module('flowchart')
	    .factory('Nodedraggingfactory', Nodedraggingfactory);
	
	}());
	
	(function() {
	
	  'use strict';
	
	  angular
	    .module('flowchart')
	    .provider('NodeTemplatePath', NodeTemplatePath);
	
	  function NodeTemplatePath() {
	    var templatePath = "flowchart/node.html";
	
	    this.setTemplatePath = setTemplatePath;
	    this.$get = NodeTemplatePath;
	
	    function setTemplatePath(path) {
	      templatePath = path;
	    }
	
	    function NodeTemplatePath() {
	      return templatePath;
	    }
	  }
	
	}());
	
	(function() {
	
	  'use strict';
	
	  function fcNode(flowchartConstants, NodeTemplatePath) {
	    return {
	      restrict: 'E',
	      templateUrl: function() {
	        return NodeTemplatePath;
	      },
	      replace: true,
	      scope: {
	        fcCallbacks: '=callbacks',
	        callbacks: '=userNodeCallbacks',
	        node: '=',
	        selected: '=',
	        edit: '=',
	        underMouse: '=',
	        mouseOverConnector: '=',
	        modelservice: '=',
	        draggedNode: '='
	      },
	      link: function(scope, element) {
	        scope.flowchartConstants = flowchartConstants;
	        element.on('mousedown', function(e){e.stopPropagation();});
	        if (!scope.node.readonly) {
	          element.attr('draggable', 'true');
	          element.on('dragstart', scope.fcCallbacks.nodeDragstart(scope.node));
	          element.on('dragend', scope.fcCallbacks.nodeDragend);
	          element.on('click', scope.fcCallbacks.nodeClicked(scope.node));
	          element.on('mouseover', scope.fcCallbacks.nodeMouseOver(scope.node));
	          element.on('mouseout', scope.fcCallbacks.nodeMouseOut(scope.node));
	        }
	
	        element.addClass(flowchartConstants.nodeClass);
	
	        function myToggleClass(clazz, set) {
	          if (set) {
	            element.addClass(clazz);
	          } else {
	            element.removeClass(clazz);
	          }
	        }
	
	        scope.$watch('selected', function(value) {
	          myToggleClass(flowchartConstants.selectedClass, value);
	        });
	        scope.$watch('edit', function(value) {
	          myToggleClass(flowchartConstants.editClass, value);
	        });
	        scope.$watch('underMouse', function(value) {
	          myToggleClass(flowchartConstants.hoverClass, value);
	        });
	        scope.$watch('draggedNode', function(value) {
	          myToggleClass(flowchartConstants.draggingClass, value===scope.node);
	        });
	
	        scope.modelservice.nodes.setHtmlElement(scope.node.id, element[0]);
	      }
	    };
	  }
	  fcNode.$inject = ["flowchartConstants", "NodeTemplatePath"];
	
	  angular.module('flowchart').directive('fcNode', fcNode);
	}());
	
	(function() {
	
	  'use strict';
	
	  function Mouseoverfactory() {
	    return function(mouseoverscope, applyFunction) {
	      var mouseoverservice = {};
	
	      mouseoverscope.connector = null;
	      mouseoverscope.edge = null;
	      mouseoverscope.node = null;
	
	      mouseoverservice.nodeMouseOver = function(node) {
	        return function(event) {
	          return applyFunction(function() {
	            mouseoverscope.node = node;
	          });
	        };
	      };
	
	      mouseoverservice.nodeMouseOut = function(node) {
	        return function(event) {
	          return applyFunction(function() {
	            mouseoverscope.node = null;
	          });
	        };
	      };
	
	      mouseoverservice.connectorMouseEnter = function(connector) {
	        return function(event) {
	          return applyFunction(function() {
	            mouseoverscope.connector = connector;
	          });
	        };
	      };
	
	      mouseoverservice.connectorMouseLeave = function(connector) {
	        return function(event) {
	          return applyFunction(function() {
	            mouseoverscope.connector = null
	          });
	        };
	      };
	
	      mouseoverservice.edgeMouseEnter = function(event, edge) {
	        mouseoverscope.edge = edge;
	      };
	
	      mouseoverservice.edgeMouseLeave = function(event, egde) {
	        mouseoverscope.edge = null;
	      };
	
	      return mouseoverservice;
	    };
	  }
	
	  angular.module('flowchart')
	    .factory('Mouseoverfactory', Mouseoverfactory);
	}());
	
	
	(function() {
	
	  'use strict';
	
	  function Modelvalidation(Topsortservice, flowchartConstants) {
	
	    function ModelvalidationError(message) {
	      this.message = message;
	    }
	    ModelvalidationError.prototype = new Error;
	    ModelvalidationError.prototype.name = 'ModelvalidationError';
	    ModelvalidationError.prototype.constructor = ModelvalidationError;
	    this.ModelvalidationError = ModelvalidationError;
	
	    this.validateModel = function(model) {
	      this.validateNodes(model.nodes);
	      this._validateEdges(model.edges, model.nodes);
	      return model;
	    };
	
	    this.validateNodes = function(nodes) {
	      var that = this;
	
	      var ids = [];
	      angular.forEach(nodes, function(node) {
	        that.validateNode(node);
	        if (ids.indexOf(node.id) !== -1) {
	          throw new ModelvalidationError('Id not unique.');
	        }
	        ids.push(node.id);
	      });
	
	      var connectorIds = [];
	      angular.forEach(nodes, function(node) {
	        angular.forEach(node.connectors, function(connector) {
	          if (connectorIds.indexOf(connector.id) !== -1) {
	            throw new ModelvalidationError('Id not unique.');
	          }
	          connectorIds.push(connector.id);
	        });
	      });
	      return nodes;
	    };
	
	    this.validateNode = function(node) {
	      var that = this;
	      if (node.id === undefined) {
	        throw new ModelvalidationError('Id not valid.');
	      }
	      if (typeof node.name !== 'string') {
	        throw new ModelvalidationError('Name not valid.');
	      }
	      if (typeof node.x !== 'number' || node.x < 0 || Math.round(node.x) !== node.x) {
	        throw new ModelvalidationError('Coordinates not valid.')
	      }
	      if (typeof node.y !== 'number' || node.y < 0 || Math.round(node.y) !== node.y) {
	        throw new ModelvalidationError('Coordinates not valid.')
	      }
	      if (!Array.isArray(node.connectors)) {
	        throw new ModelvalidationError('Connectors not valid.');
	      }
	      angular.forEach(node.connectors, function(connector) {
	        that.validateConnector(connector);
	      });
	      return node;
	    };
	
	    this._validateEdges = function(edges, nodes) {
	      var that = this;
	
	      angular.forEach(edges, function(edge) {
	        that._validateEdge(edge, nodes);
	      });
	      angular.forEach(edges, function(edge1, index1) {
	        angular.forEach(edges, function(edge2, index2) {
	          if (index1 !== index2) {
	            if ((edge1.source === edge2.source && edge1.destination === edge2.destination) || (edge1.source === edge2.destination && edge1.destination === edge2.source)) {
	              throw new ModelvalidationError('Duplicated edge.')
	            }
	          }
	        });
	      });
	
	      if (Topsortservice({nodes: nodes, edges: edges}) === null) {
	        throw new ModelvalidationError('Graph has a circle.');
	      }
	
	      return edges;
	    };
	
	    this.validateEdges = function(edges, nodes) {
	      this.validateNodes(nodes);
	      return this._validateEdges(edges, nodes);
	    };
	
	    this._validateEdge = function(edge, nodes) {
	      if (edge.source === undefined) {
	        throw new ModelvalidationError('Source not valid.');
	      }
	      if (edge.destination === undefined) {
	        throw new ModelvalidationError('Destination not valid.');
	      }
	
	      if (edge.source === edge.destination) {
	        throw new ModelvalidationError('Edge with same source and destination connectors.');
	      }
	      var sourceNode = nodes.filter(function(node) {return node.connectors.some(function(connector) {return connector.id === edge.source})})[0];
	      if (sourceNode === undefined) {
	        throw new ModelvalidationError('Source not valid.');
	      }
	      var destinationNode = nodes.filter(function(node) {return node.connectors.some(function(connector) {return connector.id === edge.destination})})[0];
	      if (destinationNode === undefined) {
	        throw new ModelvalidationError('Destination not valid.');
	      }
	      if (sourceNode === destinationNode) {
	        throw new ModelvalidationError('Edge with same source and destination nodes.');
	      }
	      return edge;
	    };
	
	    this.validateEdge = function(edge, nodes) {
	      this.validateNodes(nodes);
	      return this._validateEdge(edge, nodes);
	    };
	
	    this.validateConnector = function(connector) {
	      if (connector.id === undefined) {
	        throw new ModelvalidationError('Id not valid.');
	      }
	      if (connector.type === undefined || connector.type === null || typeof connector.type !== 'string') {
	        throw new ModelvalidationError('Type not valid.');
	      }
	      return connector;
	    };
	
	  }
	  Modelvalidation.$inject = ["Topsortservice", "flowchartConstants"];
	
	  angular.module('flowchart')
	    .service('Modelvalidation', Modelvalidation);
	
	}());
	
	(function() {
	
	  'use strict';
	
	  function Modelfactory($q, Modelvalidation) {
	
	    return function innerModelfactory(model, selectedObjects, dropNode, createEdge, edgeAddedCallback, nodeRemovedCallback, edgeRemovedCallback) {
	      Modelvalidation.validateModel(model);
	      var modelservice = {
	        selectedObjects: selectedObjects
	      };
	
	      modelservice.connectorsHtmlElements = {};
	      modelservice.nodesHtmlElements = {};
	      modelservice.canvasHtmlElement = null;
	      modelservice.dragImage = null;
	      modelservice.svgHtmlElement = null;
	
	      modelservice.dropNode = dropNode || angular.noop;
	      modelservice.createEdge = createEdge || function() { return $q.when({ label: "label" })};
	      modelservice.edgeAddedCallback = edgeAddedCallback || angular.noop;
	      modelservice.nodeRemovedCallback = nodeRemovedCallback || angular.noop;
	      modelservice.edgeRemovedCallback = edgeRemovedCallback || angular.noop;
	
	      function selectObject(object) {
	        if (modelservice.isEditable()) {
	          if (modelservice.selectedObjects.indexOf(object) === -1) {
	            modelservice.selectedObjects.push(object);
	          }
	        }
	      }
	
	      function deselectObject(object) {
	        if (modelservice.isEditable()) {
	          var index = modelservice.selectedObjects.indexOf(object);
	          if (index === -1) {
	            throw new Error('Tried to deselect an unselected object');
	          }
	          modelservice.selectedObjects.splice(index, 1);
	        }
	      }
	
	      function toggleSelectedObject(object) {
	        if (isSelectedObject(object)) {
	          deselectObject(object);
	        } else {
	          selectObject(object);
	        }
	      }
	
	      function isSelectedObject(object) {
	        return modelservice.selectedObjects.indexOf(object) !== -1;
	      }
	
	      function isEditObject(object) {
	        return modelservice.selectedObjects.length === 1 &&
	          modelservice.selectedObjects.indexOf(object) !== -1;
	      }
	
	      modelservice.connectors = {
	
	        getConnector: function(connectorId) {
	          for(var i=0; i<model.nodes.length; i++) {
	            for(var j=0; j<model.nodes[i].connectors.length; j++) {
	              if(model.nodes[i].connectors[j].id == connectorId) {
	                return model.nodes[i].connectors[j];
	              }
	            }
	          }
	        },
	
	        setHtmlElement: function(connectorId, element) {
	          modelservice.connectorsHtmlElements[connectorId] = element;
	        },
	
	        getHtmlElement: function(connectorId) {
	          return modelservice.connectorsHtmlElements[connectorId];
	        },
	
	        _getCoords: function(connectorId, centered) {
	          var element = this.getHtmlElement(connectorId);
	          var canvas = modelservice.getCanvasHtmlElement();
	          if (element === null || element === undefined || canvas === null) {
	            return {x: 0, y: 0};
	          }
	          var connectorElementBox = element.getBoundingClientRect();
	          var canvasElementBox = canvas.getBoundingClientRect();
	
	
	          var coords = {
	            x: connectorElementBox.left - canvasElementBox.left,
	            y: connectorElementBox.top - canvasElementBox.top
	          };
	          if (centered) {
	            coords = {
	              x: Math.round(coords.x + element.offsetWidth / 2),
	              y: Math.round(coords.y + element.offsetHeight / 2)
	            };
	          }
	          return coords;
	        },
	
	        getCoord: function(connectorId) {
	          return this._getCoords(connectorId, false);
	        },
	
	        getCenteredCoord: function(connectorId) {
	          return this._getCoords(connectorId, true);
	        }
	
	      };
	
	      modelservice.nodes = {
	        getConnectorsByType: function(node, type) {
	          return node.connectors.filter(function(connector) {
	            return connector.type === type
	          });
	        },
	
	        select: selectObject,
	        deselect: deselectObject,
	        toggleSelected: toggleSelectedObject,
	        isSelected: isSelectedObject,
	        isEdit: isEditObject,
	
	        _addConnector: function(node, connector) {
	          node.connectors.push(connector);
	          try {
	            Modelvalidation.validateNode(node);
	          } catch (error) {
	            node.connectors.splice(node.connectors.indexOf(connector), 1);
	            throw error;
	          }
	        },
	
	        delete: function(node) {
	
	          if (this.isSelected(node)) {
	            this.deselect(node);
	          }
	          var index = model.nodes.indexOf(node);
	          if (index === -1) {
	            if (node === undefined) {
	              throw new Error('Passed undefined');
	            }
	            throw new Error('Tried to delete not existing node')
	          }
	
	          var connectorIds = this.getConnectorIds(node);
	          for (var i = 0; i < model.edges.length; i++) {
	            var edge = model.edges[i];
	            if (connectorIds.indexOf(edge.source) !== -1 || connectorIds.indexOf(edge.destination) !== -1) {
	              modelservice.edges.delete(edge);
	              i--;
	            }
	          }
	          model.nodes.splice(index, 1);
	          modelservice.nodeRemovedCallback(node);
	        },
	
	        getSelectedNodes: function() {
	          return model.nodes.filter(function(node) {
	            return modelservice.nodes.isSelected(node)
	          });
	        },
	
	        handleClicked: function(node, ctrlKey) {
	          if (ctrlKey) {
	            modelservice.nodes.toggleSelected(node);
	          } else {
	            modelservice.deselectAll();
	            modelservice.nodes.select(node);
	          }
	        },
	
	        setHtmlElement: function(nodeId, element) {
	          modelservice.nodesHtmlElements[nodeId] = element;
	        },
	
	        getHtmlElement: function(nodeId) {
	          return modelservice.nodesHtmlElements[nodeId];
	        },
	
	        _addNode: function(node) {
	          try {
	            model.nodes.push(node);
	            Modelvalidation.validateNodes(model.nodes);
	          } catch(error) {
	            model.nodes.splice(model.nodes.indexOf(node), 1);
	            throw error;
	          }
	        },
	
	        getConnectorIds: function(node) {
	          return node.connectors.map(function(connector) {
	            return connector.id
	          });
	        },
	
	        getNodeByConnectorId: function(connectorId) {
	          for (var i = 0; i < model.nodes.length; i++) {
	            var node = model.nodes[i];
	            var connectorIds = this.getConnectorIds(node);
	            if (connectorIds.indexOf(connectorId) > -1) {
	              return node;
	            }
	          }
	          return null;
	        }
	
	      };
	
	      modelservice.edges = {
	
	        sourceCoord: function(edge) {
	          return modelservice.connectors.getCenteredCoord(edge.source, edge.source);
	        },
	
	        destCoord: function(edge) {
	          return modelservice.connectors.getCenteredCoord(edge.destination);
	        },
	
	        select: selectObject,
	        deselect: deselectObject,
	        toggleSelected: toggleSelectedObject,
	        isSelected: isSelectedObject,
	        isEdit: isEditObject,
	
	        delete: function
	          (edge) {
	          var index = model.edges.indexOf(edge);
	          if (index === -1) {
	            throw new Error('Tried to delete not existing edge')
	          }
	          if (this.isSelected(edge)) {
	            this.deselect(edge)
	          }
	          model.edges.splice(index, 1);
	          modelservice.edgeRemovedCallback(edge);
	        },
	
	        getSelectedEdges: function() {
	          return model.edges.filter(function(edge) {
	            return modelservice.edges.isSelected(edge)
	          });
	        },
	
	        handleEdgeMouseClick: function(edge, ctrlKey) {
	          if (ctrlKey) {
	            modelservice.edges.toggleSelected(edge);
	          } else {
	            modelservice.deselectAll();
	            modelservice.edges.select(edge);
	          }
	        },
	
	        putEdge: function(edge) {
	          model.edges.push(edge);
	        },
	
	        _addEdge: function(event, sourceConnector, destConnector, label) {
	          Modelvalidation.validateConnector(sourceConnector);
	          Modelvalidation.validateConnector(destConnector);
	          var edge = {};
	          edge.source = sourceConnector.id;
	          edge.destination = destConnector.id;
	          edge.label = label;
	          Modelvalidation.validateEdges(model.edges.concat([edge]), model.nodes);
	          modelservice.createEdge(event, edge).then(
	            function (edge) {
	              model.edges.push(edge);
	              modelservice.edgeAddedCallback(edge);
	            }
	          );
	        }
	      };
	
	      function inRectBox(x, y, rectBox) {
	        return x >= rectBox.left && x <= rectBox.right &&
	            y >= rectBox.top && y <= rectBox.bottom;
	      }
	
	      modelservice.getItemInfoAtPoint = function(x,y) {
	        return {
	            node: modelservice.getNodeAtPoint(x,y),
	            edge: modelservice.getEdgeAtPoint(x,y)
	        };
	      };
	
	      modelservice.getNodeAtPoint = function(x,y) {
	        for (var i=0;i<model.nodes.length;i++) {
	          var node = model.nodes[i];
	          var element = modelservice.nodes.getHtmlElement(node.id);
	          var nodeElementBox = element.getBoundingClientRect();
	          if (x >= nodeElementBox.left && x <= nodeElementBox.right
	                && y >= nodeElementBox.top && y <= nodeElementBox.bottom) {
	            return node;
	          }
	        }
	        return null;
	      };
	
	      modelservice.getEdgeAtPoint = function(x,y) {
	        var element = document.elementFromPoint(x, y);
	        var id = element.id;
	        var edgeIndex = -1;
	        if (id) {
	          if (id.startsWith("fc-edge-path-")) {
	            edgeIndex = Number(id.substring("fc-edge-path-".length));
	          } else if (id.startsWith("fc-edge-label-")) {
	            edgeIndex = Number(id.substring("fc-edge-label-".length));
	          }
	        }
	        if (edgeIndex > -1) {
	          return model.edges[edgeIndex];
	        }
	        return null;
	      };
	
	      modelservice.selectAllInRect = function(rectBox) {
	        angular.forEach(model.nodes, function(value) {
	          var element = modelservice.nodes.getHtmlElement(value.id);
	          var nodeElementBox = element.getBoundingClientRect();
	          if (!value.readonly) {
	            var x = nodeElementBox.left + nodeElementBox.width/2;
	            var y = nodeElementBox.top + nodeElementBox.height/2;
	            if (inRectBox(x, y, rectBox)) {
	              modelservice.nodes.select(value);
	            } else {
	              if (modelservice.nodes.isSelected(value)) {
	                modelservice.nodes.deselect(value);
	              }
	            }
	          }
	        });
	        angular.forEach(model.edges, function(value) {
	          var start = modelservice.edges.sourceCoord(value);
	          var end = modelservice.edges.destCoord(value);
	          var x = (start.x + end.x)/2 + rectBox.parentOffset.left;
	          var y = (start.y + end.y)/2 + rectBox.parentOffset.top;
	          if (inRectBox(x, y, rectBox)) {
	            modelservice.edges.select(value);
	          } else {
	            if (modelservice.edges.isSelected(value)) {
	              modelservice.edges.deselect(value);
	            }
	          }
	        });
	      };
	
	      modelservice.selectAll = function() {
	        angular.forEach(model.nodes, function(value) {
	          if (!value.readonly) {
	            modelservice.nodes.select(value);
	          }
	        });
	        angular.forEach(model.edges, function(value) {
	          modelservice.edges.select(value);
	        });
	      };
	
	      modelservice.deselectAll = function() {
	        modelservice.selectedObjects.splice(0, modelservice.selectedObjects.length);
	      };
	
	      modelservice.deleteSelected = function() {
	        var edgesToDelete = modelservice.edges.getSelectedEdges();
	        angular.forEach(edgesToDelete, function(edge) {
	          modelservice.edges.delete(edge);
	        });
	        var nodesToDelete = modelservice.nodes.getSelectedNodes();
	        angular.forEach(nodesToDelete, function(node) {
	          modelservice.nodes.delete(node);
	        });
	      };
	
	      modelservice.setDropTargetId = function(dropTargetId) {
	        modelservice.dropTargetId = dropTargetId;
	      };
	
	      modelservice.getDropTargetId = function() {
	        return modelservice.dropTargetId;
	      };
	
	      modelservice.isDropSource = function() {
	        return modelservice.dropTargetId;
	      };
	
	      modelservice.isEditable = function() {
	        return !modelservice.dropTargetId;
	      };
	
	      modelservice.setCanvasHtmlElement = function(element) {
	        modelservice.canvasHtmlElement = element;
	      };
	
	      modelservice.getCanvasHtmlElement = function() {
	        return modelservice.canvasHtmlElement;
	      };
	
	      modelservice.getDragImage = function() {
	        if (!modelservice.dragImage) {
	          modelservice.dragImage = new Image();
	          modelservice.dragImage.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
	          modelservice.dragImage.style.visibility = 'hidden';
	        }
	        return modelservice.dragImage;
	      };
	
	      modelservice.setSvgHtmlElement = function(element) {
	        modelservice.svgHtmlElement = element;
	      };
	
	      modelservice.getSvgHtmlElement = function() {
	        return modelservice.svgHtmlElement;
	      };
	
	      modelservice.registerCallbacks = function (edgeAddedCallback, nodeRemovedCallback, edgeRemovedCallback) {
	        modelservice.edgeAddedCallback = edgeAddedCallback;
	        modelservice.nodeRemovedCallback = nodeRemovedCallback;
	        modelservice.edgeRemovedCallback = edgeRemovedCallback;
	      };
	
	      return modelservice;
	    }
	
	  }
	  Modelfactory.$inject = ["$q", "Modelvalidation"];
	
	  angular.module('flowchart')
	    .service('Modelfactory', Modelfactory);
	
	})();
	
	(function() {
	
	  'use strict';
	
	  function fcMagnet(flowchartConstants) {
	    return {
	      restrict: 'AE',
	      link: function(scope, element) {
	        element.addClass(flowchartConstants.magnetClass);
	
	        element.on('dragover', scope.fcCallbacks.edgeDragoverMagnet(scope.connector));
	        element.on('dragleave', scope.fcCallbacks.edgeDragleaveMagnet);
	        element.on('drop', scope.fcCallbacks.edgeDrop(scope.connector));
	        element.on('dragend', scope.fcCallbacks.edgeDragend);
	      }
	    }
	  }
	  fcMagnet.$inject = ["flowchartConstants"];
	
	  angular.module('flowchart')
	    .directive('fcMagnet', fcMagnet);
	}());
	
	(function() {
	
	  'use strict';
	
	  var constants = {
	    htmlPrefix: 'fc',
	    leftConnectorType: 'leftConnector',
	    rightConnectorType: 'rightConnector',
	    curvedStyle: 'curved',
	    lineStyle: 'line',
	    dragAnimationRepaint: 'repaint',
	    dragAnimationShadow: 'shadow'
	  };
	  constants.canvasClass = constants.htmlPrefix + '-canvas';
	  constants.selectedClass = constants.htmlPrefix + '-selected';
	  constants.editClass = constants.htmlPrefix + '-edit';
	  constants.activeClass = constants.htmlPrefix + '-active';
	  constants.hoverClass = constants.htmlPrefix + '-hover';
	  constants.draggingClass = constants.htmlPrefix + '-dragging';
	  constants.edgeClass = constants.htmlPrefix + '-edge';
	  constants.edgeLabelClass = constants.htmlPrefix + '-edge-label';
	  constants.connectorClass = constants.htmlPrefix + '-connector';
	  constants.magnetClass = constants.htmlPrefix + '-magnet';
	  constants.nodeClass = constants.htmlPrefix + '-node';
	  constants.nodeOverlayClass = constants.htmlPrefix + '-node-overlay';
	  constants.leftConnectorClass = constants.htmlPrefix + '-' + constants.leftConnectorType + 's';
	  constants.rightConnectorClass = constants.htmlPrefix + '-' + constants.rightConnectorType + 's';
	  constants.canvasResizeThreshold = 200;
	  constants.canvasResizeStep = 200;
	
	  angular
	    .module('flowchart')
	    .constant('flowchartConstants', constants);
	
	}());
	
	(function() {
	
	  'use strict';
	
	  function Edgedrawingservice(flowchartConstants) {
	    function computeEdgeTangentOffset(pt1, pt2) {
	        return (pt2.y - pt1.y) / 2;
	    }
	
	    function computeEdgeSourceTangent(pt1, pt2) {
	      return {
	        x: pt1.x,
	        y: pt1.y + computeEdgeTangentOffset(pt1, pt2)
	      };
	    }
	
	    function computeEdgeDestinationTangent(pt1, pt2) {
	      return {
	        x: pt2.x,
	        y: pt2.y - computeEdgeTangentOffset(pt1, pt2)
	      };
	    }
	
	    this.getEdgeDAttribute = function(pt1, pt2, style) {
	      var dAddribute = 'M ' + pt1.x + ', ' + pt1.y + ' ';
	      if (style === flowchartConstants.curvedStyle) {
	        var sourceTangent = computeEdgeSourceTangent(pt1, pt2);
	        var destinationTangent = computeEdgeDestinationTangent(pt1, pt2);
	        dAddribute += 'C ' + sourceTangent.x + ', ' + sourceTangent.y + ' ' + (destinationTangent.x-50) + ', ' + destinationTangent.y + ' ' + pt2.x + ', ' + pt2.y;
	      } else {
	        dAddribute += 'L ' + pt2.x + ', ' + pt2.y;
	      }
	      return dAddribute;
	    };
	
	    this.getEdgeCenter = function(pt1, pt2) {
	      return {
	          x: (pt1.x + pt2.x)/2,
	          y: (pt1.y + pt2.y)/2
	      };
	    }
	  }
	  Edgedrawingservice.$inject = ["flowchartConstants"];
	
	  angular
	    .module('flowchart')
	    .service('Edgedrawingservice', Edgedrawingservice);
	
	}());
	
	(function() {
	
	  'use strict';
	
	  function Edgedraggingfactory(Modelvalidation, flowchartConstants, Edgedrawingservice) {
	    function factory(modelservice, model, edgeDragging, isValidEdgeCallback, applyFunction, dragAnimation, edgeStyle) {
	      if (isValidEdgeCallback === null) {
	        isValidEdgeCallback = function() {
	          return true;
	        };
	      }
	
	      var edgedraggingService = {};
	
	      var draggedEdgeSource = null;
	      var dragOffset = {};
	
	      edgeDragging.isDragging = false;
	      edgeDragging.dragPoint1 = null;
	      edgeDragging.dragPoint2 = null;
	      edgeDragging.shadowDragStarted = false;
	
	      var destinationHtmlElement = null;
	      var oldDisplayStyle = "";
	
	      edgedraggingService.dragstart = function(connector) {
	        return function(event) {
	
	          if (connector.type == flowchartConstants.leftConnectorType) {
	            for (var i = 0; i < model.edges.length; i++) {
	              if (model.edges[i].destination == connector.id) {
	                var swapConnector = modelservice.connectors.getConnector(model.edges[i].source);
	                var dragLabel = model.edges[i].label;
	                var prevEdge = model.edges[i];
	                applyFunction(function() {
	                  modelservice.edges.delete(model.edges[i]);
	                });
	                break;
	              }
	            }
	          }
	
	          edgeDragging.isDragging = true;
	
	          if (swapConnector != undefined) {
	            draggedEdgeSource = swapConnector;
	            edgeDragging.dragPoint1 = modelservice.connectors.getCenteredCoord(swapConnector.id);
	            edgeDragging.dragLabel = dragLabel;
	            edgeDragging.prevEdge = prevEdge;
	          } else {
	            draggedEdgeSource = connector;
	            edgeDragging.dragPoint1 = modelservice.connectors.getCenteredCoord(connector.id);
	          }
	
	          var canvas = modelservice.getCanvasHtmlElement();
	          if (!canvas) {
	            throw new Error('No canvas while edgedraggingService found.');
	          }
	          dragOffset.x = -canvas.getBoundingClientRect().left;
	          dragOffset.y = -canvas.getBoundingClientRect().top;
	
	          edgeDragging.dragPoint2 = {
	            x: event.clientX + dragOffset.x,
	            y: event.clientY + dragOffset.y
	          };
	
	          event.originalEvent.dataTransfer.setData('Text', 'Just to support firefox');
	          if (event.originalEvent.dataTransfer.setDragImage) {
	            //var invisibleDiv = angular.element('<div></div>')[0]; // This divs stays invisible, because it is not in the dom.
	            //event.originalEvent.dataTransfer.setDragImage(invisibleDiv, 0, 0);
	            event.originalEvent.dataTransfer.setDragImage(modelservice.getDragImage(), 0, 0);
	          } else {
	            destinationHtmlElement = event.target;
	            oldDisplayStyle = destinationHtmlElement.style.display;
	            event.target.style.display = 'none'; // Internetexplorer does not support setDragImage, but it takes an screenshot, from the draggedelement and uses it as dragimage.
	            // Since angular redraws the element in the next dragover call, display: none never gets visible to the user.
	
	            if (dragAnimation == flowchartConstants.dragAnimationShadow) {
	              // IE Drag Fix
	              edgeDragging.shadowDragStarted = true;
	            }
	          }
	
	          if (dragAnimation == flowchartConstants.dragAnimationShadow) {
	            if (edgeDragging.gElement == undefined) {
	              //set shadow elements once
	              // IE Support
	              edgeDragging.gElement = angular.element(document.querySelectorAll('.shadow-svg-class'));
	              edgeDragging.pathElement = angular.element(document.querySelectorAll('.shadow-svg-class')).find('path');
	              edgeDragging.circleElement = angular.element(document.querySelectorAll('.shadow-svg-class')).find('circle');
	            }
	
	            edgeDragging.gElement.css('display', 'block');
	            edgeDragging.pathElement.attr('d', Edgedrawingservice.getEdgeDAttribute(edgeDragging.dragPoint1, edgeDragging.dragPoint2, edgeStyle));
	            edgeDragging.circleElement.attr('cx', edgeDragging.dragPoint2.x);
	            edgeDragging.circleElement.attr('cy', edgeDragging.dragPoint2.y);
	          }
	          event.stopPropagation();
	        };
	      };
	
	      edgedraggingService.dragover = function(event) {
	
	        if (edgeDragging.isDragging) {
	          if (!edgeDragging.magnetActive && dragAnimation == flowchartConstants.dragAnimationShadow) {
	            if (destinationHtmlElement !== null) {
	              destinationHtmlElement.style.display = oldDisplayStyle;
	            }
	
	            if (edgeDragging.shadowDragStarted) {
	              applyFunction(function() {
	                edgeDragging.shadowDragStarted = false;
	              });
	            }
	
	            edgeDragging.dragPoint2 = {
	              x: event.clientX + dragOffset.x,
	              y: event.clientY + dragOffset.y
	            };
	
	            edgeDragging.pathElement.attr('d', Edgedrawingservice.getEdgeDAttribute(edgeDragging.dragPoint1, edgeDragging.dragPoint2, edgeStyle));
	            edgeDragging.circleElement.attr('cx', edgeDragging.dragPoint2.x);
	            edgeDragging.circleElement.attr('cy', edgeDragging.dragPoint2.y);
	
	          } else if (dragAnimation == flowchartConstants.dragAnimationRepaint) {
	            return applyFunction(function () {
	
	              if (destinationHtmlElement !== null) {
	                destinationHtmlElement.style.display = oldDisplayStyle;
	              }
	
	              edgeDragging.dragPoint2 = {
	                x: event.clientX + dragOffset.x,
	                y: event.clientY + dragOffset.y
	              };
	            });
	          }
	        }
	      };
	
	      edgedraggingService.dragoverConnector = function(connector) {
	        return function(event) {
	
	          if (edgeDragging.isDragging) {
	            edgedraggingService.dragover(event);
	            try {
	              Modelvalidation.validateEdges(model.edges.concat([{
	                source: draggedEdgeSource.id,
	                destination: connector.id
	              }]), model.nodes);
	            } catch (error) {
	              if (error instanceof Modelvalidation.ModelvalidationError) {
	                return true;
	              } else {
	                throw error;
	              }
	            }
	            if (isValidEdgeCallback(draggedEdgeSource, connector)) {
	              event.preventDefault();
	              event.stopPropagation();
	              return false;
	            }
	          }
	        };
	      };
	
	      edgedraggingService.dragleaveMagnet = function (event) {
	          edgeDragging.magnetActive = false;
	      };
	
	      edgedraggingService.dragoverMagnet = function(connector) {
	        return function(event) {
	          if (edgeDragging.isDragging) {
	            edgedraggingService.dragover(event);
	              try {
	              Modelvalidation.validateEdges(model.edges.concat([{
	                source: draggedEdgeSource.id,
	                destination: connector.id
	              }]), model.nodes);
	            } catch (error) {
	              if (error instanceof Modelvalidation.ModelvalidationError) {
	                return true;
	              } else {
	                throw error;
	              }
	            }
	            if (isValidEdgeCallback(draggedEdgeSource, connector)) {
	              if (dragAnimation == flowchartConstants.dragAnimationShadow) {
	
	                edgeDragging.magnetActive = true;
	
	                edgeDragging.dragPoint2 = modelservice.connectors.getCenteredCoord(connector.id);
	                edgeDragging.pathElement.attr('d', Edgedrawingservice.getEdgeDAttribute(edgeDragging.dragPoint1, edgeDragging.dragPoint2, edgeStyle));
	                edgeDragging.circleElement.attr('cx', edgeDragging.dragPoint2.x);
	                edgeDragging.circleElement.attr('cy', edgeDragging.dragPoint2.y);
	
	                event.preventDefault();
	                event.stopPropagation();
	                return false;
	
	              } else if (dragAnimation == flowchartConstants.dragAnimationRepaint) {
	                return applyFunction(function() {
	                  edgeDragging.dragPoint2 = modelservice.connectors.getCenteredCoord(connector.id);
	                  event.preventDefault();
	                  event.stopPropagation();
	                  return false;
	                });
	              }
	            }
	          }
	
	        }
	      };
	
	      edgedraggingService.dragend = function(event) {
	        if (edgeDragging.isDragging) {
	          edgeDragging.isDragging = false;
	          edgeDragging.dragPoint1 = null;
	          edgeDragging.dragPoint2 = null;
	          edgeDragging.dragLabel = null;
	          event.stopPropagation();
	
	          if (dragAnimation == flowchartConstants.dragAnimationShadow) {
	            edgeDragging.gElement.css('display', 'none');
	          }
	          if (edgeDragging.prevEdge) {
	            var edge = edgeDragging.prevEdge;
	            edgeDragging.prevEdge = null;
	            applyFunction(function() {
	              modelservice.edges.putEdge(edge);
	            });
	          }
	        }
	      };
	
	      edgedraggingService.drop = function(targetConnector) {
	        return function(event) {
	          if (edgeDragging.isDragging) {
	            try {
	              Modelvalidation.validateEdges(model.edges.concat([{
	                source: draggedEdgeSource.id,
	                destination: targetConnector.id
	              }]), model.nodes);
	            } catch (error) {
	              if (error instanceof Modelvalidation.ModelvalidationError) {
	                return true;
	              } else {
	                throw error;
	              }
	            }
	
	            if (isValidEdgeCallback(draggedEdgeSource, targetConnector)) {
	              edgeDragging.prevEdge = null;
	              modelservice.edges._addEdge(event, draggedEdgeSource, targetConnector, edgeDragging.dragLabel);
	              event.stopPropagation();
	              event.preventDefault();
	              return false;
	            }
	          }
	        }
	      };
	      return edgedraggingService;
	    }
	
	    return factory;
	  }
	  Edgedraggingfactory.$inject = ["Modelvalidation", "flowchartConstants", "Edgedrawingservice"];
	
	  angular.module('flowchart')
	    .factory('Edgedraggingfactory', Edgedraggingfactory);
	
	}());
	
	(function() {
	
	  'use strict';
	
	  function fcConnector(flowchartConstants) {
	    return {
	      restrict: 'A',
	      link: function(scope, element) {
	        if (scope.modelservice.isEditable()) {
	          element.attr('draggable', 'true');
	
	          element.on('dragover', scope.fcCallbacks.edgeDragoverConnector);
	          element.on('drop', scope.fcCallbacks.edgeDrop(scope.connector));
	          element.on('dragend', scope.fcCallbacks.edgeDragend);
	          element.on('dragstart', scope.fcCallbacks.edgeDragstart(scope.connector));
	          element.on('mouseenter', scope.fcCallbacks.connectorMouseEnter(scope.connector));
	          element.on('mouseleave', scope.fcCallbacks.connectorMouseLeave(scope.connector));
	          scope.$watch('mouseOverConnector', function(value) {
	            if (value === scope.connector) {
	              element.addClass(flowchartConstants.hoverClass);
	            } else {
	              element.removeClass(flowchartConstants.hoverClass);
	            }
	          });
	        }
	        element.addClass(flowchartConstants.connectorClass);
	
	        scope.modelservice.connectors.setHtmlElement(scope.connector.id, element[0]);
	      }
	    };
	  }
	  fcConnector.$inject = ["flowchartConstants"];
	
	  angular
	    .module('flowchart')
	    .directive('fcConnector', fcConnector);
	
	}());
	
	(function() {
	
	  'use strict';
	
	  function CanvasFactory($rootScope) {
	
	    return function innerCanvasFactory() {
	
	      var canvasService = {
	      };
	
	      canvasService.setCanvasHtmlElement = function(element) {
	        canvasService.canvasHtmlElement = element;
	      };
	
	      canvasService.getCanvasHtmlElement = function() {
	        return canvasService.canvasHtmlElement;
	      };
	
	      canvasService.dragover = function(scope, callback) {
	        var handler = $rootScope.$on('notifying-dragover-event', callback);
	        scope.$on('$destroy', handler);
	      };
	
	      canvasService._notifyDragover = function(event) {
	        $rootScope.$emit('notifying-dragover-event', event);
	      };
	
	      canvasService.drop = function(scope, callback) {
	        var handler = $rootScope.$on('notifying-drop-event', callback);
	        scope.$on('$destroy', handler);
	      };
	
	      canvasService._notifyDrop = function(event) {
	        $rootScope.$emit('notifying-drop-event', event);
	      };
	
	      return canvasService;
	    };
	
	
	  }
	  CanvasFactory.$inject = ["$rootScope"];
	
	  angular.module('flowchart')
	      .service('FlowchartCanvasFactory', CanvasFactory);
	
	}());
	
	(function() {
	
	  'use strict';
	
	  function fcCanvas(flowchartConstants) {
	    return {
	      restrict: 'E',
	      templateUrl: "flowchart/canvas.html",
	      replace: true,
	      scope: {
	        model: "=",
	        selectedObjects: "=",
	        edgeStyle: '@',
	        userCallbacks: '=?callbacks',
	        automaticResize: '=?',
	        dragAnimation: '=?',
	        nodeWidth: '=?',
	        nodeHeight: '=?',
	        dropTargetId: '=?',
	        control: '=?'
	      },
	      controller: 'canvasController',
	      link: function(scope, element) {
	        function adjustCanvasSize(fit) {
	          if (scope.model) {
	            var maxX = 0;
	            var maxY = 0;
	            angular.forEach(scope.model.nodes, function (node, key) {
	              maxX = Math.max(node.x + scope.nodeWidth, maxX);
	              maxY = Math.max(node.y + scope.nodeHeight, maxY);
	            });
	            var width, height;
	            if (fit) {
	              width = maxX;
	              height = maxY;
	            } else {
	              width = Math.max(maxX, element.prop('offsetWidth'));
	              height = Math.max(maxY, element.prop('offsetHeight'));
	            }
	            element.css('width', width + 'px');
	            element.css('height', height + 'px');
	          }
	        }
	        if (!scope.dropTargetId && scope.edgeStyle !== flowchartConstants.curvedStyle && scope.edgeStyle !== flowchartConstants.lineStyle) {
	          throw new Error('edgeStyle not supported.');
	        }
	        scope.nodeHeight = scope.nodeHeight || 200;
	        scope.nodeWidth = scope.nodeWidth || 200;
	        scope.dragAnimation = scope.dragAnimation || 'repaint';
	
	        scope.flowchartConstants = flowchartConstants;
	        element.addClass(flowchartConstants.canvasClass);
	        element.on('dragover', scope.dragover);
	        element.on('drop', scope.drop);
	        element.on('mousedown', scope.mousedown);
	        element.on('mousemove', scope.mousemove);
	        element.on('mouseup', scope.mouseup);
	
	        scope.$watch('model', adjustCanvasSize);
	
	        scope.internalControl = scope.control || {};
	        scope.internalControl.adjustCanvasSize = adjustCanvasSize;
	        scope.internalControl.modelservice = scope.modelservice;
	
	        scope.canvasservice.setCanvasHtmlElement(element[0]);
	        scope.modelservice.setCanvasHtmlElement(element[0]);
	        scope.modelservice.setSvgHtmlElement(element[0].querySelector('svg'));
	        scope.rectangleselectservice.setRectangleSelectHtmlElement(element[0].querySelector('#select-rectangle'));
	        if (scope.dropTargetId) {
	          scope.modelservice.setDropTargetId(scope.dropTargetId);
	        }
	      }
	    };
	  }
	  fcCanvas.$inject = ["flowchartConstants"];
	
	  angular
	    .module('flowchart')
	    .directive('fcCanvas', fcCanvas);
	
	}());
	
	
	(function() {
	
	  'use strict';
	
	  function canvasController($scope, Mouseoverfactory, Nodedraggingfactory, FlowchartCanvasFactory, Modelfactory, Edgedraggingfactory, Edgedrawingservice, Rectangleselectfactory) {
	
	    $scope.dragAnimation = angular.isDefined($scope.dragAnimation) ? $scope.dragAnimation : 'repaint';
	
	    $scope.userCallbacks = $scope.userCallbacks || {};
	    $scope.automaticResize = $scope.automaticResize || false;
	    angular.forEach($scope.userCallbacks, function(callback, key) {
	      if (!angular.isFunction(callback) && key !== 'nodeCallbacks') {
	        throw new Error('All callbacks should be functions.');
	      }
	    });
	
	    $scope.arrowDefId = 'arrow-' + Math.random();
	
	    $scope.canvasservice = FlowchartCanvasFactory();
	
	    $scope.modelservice = Modelfactory($scope.model, $scope.selectedObjects, $scope.userCallbacks.dropNode, $scope.userCallbacks.createEdge, $scope.userCallbacks.edgeAdded || angular.noop, $scope.userCallbacks.nodeRemoved || angular.noop,  $scope.userCallbacks.edgeRemoved || angular.noop);
	
	    $scope.nodeDragging = {};
	    var nodedraggingservice = Nodedraggingfactory($scope.modelservice, $scope.nodeDragging, $scope.$apply.bind($scope), $scope.automaticResize, $scope.dragAnimation);
	
	    $scope.edgeDragging = {};
	    var edgedraggingservice = Edgedraggingfactory($scope.modelservice, $scope.model, $scope.edgeDragging, $scope.userCallbacks.isValidEdge || null, $scope.$apply.bind($scope), $scope.dragAnimation, $scope.edgeStyle);
	
	    $scope.mouseOver = {};
	    var mouseoverservice = Mouseoverfactory($scope.mouseOver, $scope.$apply.bind($scope));
	
	    $scope.rectangleselectservice = Rectangleselectfactory($scope.modelservice, $scope.$apply.bind($scope));
	
	    $scope.edgeMouseEnter = mouseoverservice.edgeMouseEnter;
	    $scope.edgeMouseLeave = mouseoverservice.edgeMouseLeave;
	
	    //$scope.canvasClick = function(e) {
	    //  $scope.modelservice.deselectAll();
	    //};
	
	    $scope.drop = function(event) {
	      nodedraggingservice.drop(event);
	      $scope.canvasservice._notifyDrop(event);
	    };
	
	    $scope.dragover = function(event) {
	      nodedraggingservice.dragover(event);
	      edgedraggingservice.dragover(event);
	      $scope.canvasservice._notifyDragover(event);
	    };
	
	    $scope.mousedown = function(event) {
	      $scope.rectangleselectservice.mousedown(event);
	    };
	
	    $scope.mousemove = function(event) {
	      $scope.rectangleselectservice.mousemove(event);
	    };
	
	    $scope.mouseup = function(event) {
	      $scope.rectangleselectservice.mouseup(event);
	    };
	
	    $scope.edgeMouseDown = function(event, edge) {
	      event.stopPropagation();
	    };
	
	    $scope.edgeClick = function(event, edge) {
	      $scope.modelservice.edges.handleEdgeMouseClick(edge, event.ctrlKey);
	      // Don't let the chart handle the mouse down.
	      event.stopPropagation();
	      event.preventDefault();
	    };
	
	    $scope.edgeRemove = function(event, edge) {
	      $scope.modelservice.edges.delete(edge);
	      event.stopPropagation();
	      event.preventDefault();
	    };
	
	    $scope.edgeDoubleClick = $scope.userCallbacks.edgeDoubleClick || angular.noop;
	    $scope.edgeMouseOver = $scope.userCallbacks.edgeMouseOver || angular.noop;
	    $scope.edgeEdit = $scope.userCallbacks.edgeEdit || angular.noop;
	
	    $scope.userNodeCallbacks = $scope.userCallbacks.nodeCallbacks;
	    $scope.callbacks = {
	      nodeDragstart: nodedraggingservice.dragstart,
	      nodeDragend: nodedraggingservice.dragend,
	      edgeDragstart: edgedraggingservice.dragstart,
	      edgeDragend: edgedraggingservice.dragend,
	      edgeDrop: edgedraggingservice.drop,
	      edgeDragoverConnector: edgedraggingservice.dragoverConnector,
	      edgeDragoverMagnet: edgedraggingservice.dragoverMagnet,
	      edgeDragleaveMagnet: edgedraggingservice.dragleaveMagnet,
	      nodeMouseOver: mouseoverservice.nodeMouseOver,
	      nodeMouseOut: mouseoverservice.nodeMouseOut,
	      connectorMouseEnter: mouseoverservice.connectorMouseEnter,
	      connectorMouseLeave: mouseoverservice.connectorMouseLeave,
	      nodeClicked: function(node) {
	        return function(event) {
	          $scope.modelservice.nodes.handleClicked(node, event.ctrlKey);
	          $scope.$apply();
	
	          // Don't let the chart handle the mouse down.
	          event.stopPropagation();
	          event.preventDefault();
	        }
	      }
	    };
	
	    $scope.getEdgeDAttribute = Edgedrawingservice.getEdgeDAttribute;
	    $scope.getEdgeCenter = Edgedrawingservice.getEdgeCenter;
	
	  }
	  canvasController.$inject = ["$scope", "Mouseoverfactory", "Nodedraggingfactory", "FlowchartCanvasFactory", "Modelfactory", "Edgedraggingfactory", "Edgedrawingservice", "Rectangleselectfactory"];
	
	  angular
	    .module('flowchart')
	    .controller('canvasController', canvasController);
	
	}());
	
	
	
	(function(module) {
	try {
	  module = angular.module('flowchart-templates');
	} catch (e) {
	  module = angular.module('flowchart-templates', []);
	}
	module.run(['$templateCache', function($templateCache) {
	  $templateCache.put('flowchart/canvas.html',
	    '<div ng-click="canvasClick($event)">\n' +
	    '  <svg>\n' +
	    '    <defs>\n' +
	    '      <marker class="fc-arrow-marker" ng-attr-id="{{arrowDefId}}" markerWidth="5" markerHeight="5" viewBox="-6 -6 12 12" refX="10" refY="0" markerUnits="strokeWidth" orient="auto">\n' +
	    '        <polygon points="-2,0 -5,5 5,0 -5,-5" stroke="gray" fill="gray" stroke-width="1px"/>\n' +
	    '      </marker>\n' +
	    '      <marker class="fc-arrow-marker-selected" ng-attr-id="{{arrowDefId}}-selected" markerWidth="5" markerHeight="5" viewBox="-6 -6 12 12" refX="10" refY="0" markerUnits="strokeWidth" orient="auto">\n' +
	    '        <polygon points="-2,0 -5,5 5,0 -5,-5" stroke="red" fill="red" stroke-width="1px"/>\n' +
	    '      </marker>\n' +
	    '    </defs>\n' +
	    '    <g ng-repeat="edge in model.edges">\n' +
	    '      <path\n' +
	    '        ng-attr-id="{{\'fc-edge-path-\'+$index}}"\n' +
	    '        ng-mousedown="edgeMouseDown($event, edge)"\n' +
	    '        ng-click="edgeClick($event, edge)"\n' +
	    '        ng-dblclick="edgeDoubleClick($event, edge)"\n' +
	    '        ng-mouseover="edgeMouseOver($event, edge)"\n' +
	    '        ng-mouseenter="edgeMouseEnter($event, edge)"\n' +
	    '        ng-mouseleave="edgeMouseLeave($event, edge)"\n' +
	    '        ng-attr-class="{{(modelservice.edges.isSelected(edge) && flowchartConstants.selectedClass + \' \' + flowchartConstants.edgeClass) || edge == mouseOver.edge && flowchartConstants.hoverClass + \' \' + flowchartConstants.edgeClass || edge.active && flowchartConstants.activeClass + \' \' + flowchartConstants.edgeClass || flowchartConstants.edgeClass}}"\n' +
	    '        ng-attr-d="{{getEdgeDAttribute(modelservice.edges.sourceCoord(edge), modelservice.edges.destCoord(edge), edgeStyle)}}"\n' +
	    '        ng-attr-marker-end="url(#{{modelservice.edges.isSelected(edge) ? arrowDefId+\'-selected\' : arrowDefId}})"></path>\n' +
	    '    </g>\n' +
	    '    <g ng-if="dragAnimation == flowchartConstants.dragAnimationRepaint && edgeDragging.isDragging">\n' +
	    '\n' +
	    '      <path class="{{ flowchartConstants.edgeClass }} {{ flowchartConstants.draggingClass }}"\n' +
	    '            ng-attr-d="{{getEdgeDAttribute(edgeDragging.dragPoint1, edgeDragging.dragPoint2, edgeStyle)}}"></path>\n' +
	    '      <circle class="edge-endpoint" r="4" ng-attr-cx="{{edgeDragging.dragPoint2.x}}"\n' +
	    '              ng-attr-cy="{{edgeDragging.dragPoint2.y}}"></circle>\n' +
	    '\n' +
	    '    </g>\n' +
	    '    <g ng-if="dragAnimation == flowchartConstants.dragAnimationShadow" class="shadow-svg-class {{ flowchartConstants.edgeClass }} {{ flowchartConstants.draggingClass }}" style="display:none">\n' +
	    '      <path d=""></path>\n' +
	    '      <circle class="edge-endpoint" r="4"></circle>\n' +
	    '    </g>\n' +
	    '  </svg>\n' +
	    '  <fc-node selected="modelservice.nodes.isSelected(node)"\n' +
	    '           edit="modelservice.nodes.isEdit(node)"\n' +
	    '           under-mouse="node === mouseOver.node"\n' +
	    '           node="node"\n' +
	    '           mouse-over-connector="mouseOver.connector"\n' +
	    '           modelservice="modelservice"\n' +
	    '           dragged-node="nodeDragging.draggedNode"\n' +
	    '           callbacks="callbacks"\n' +
	    '           user-node-callbacks="userNodeCallbacks"\n' +
	    '           ng-repeat="node in model.nodes"></fc-node>\n' +
	    '  <div ng-if="dragAnimation == flowchartConstants.dragAnimationRepaint && edgeDragging.isDragging"\n' +
	    '    ng-attr-class="{{\'fc-noselect \' + flowchartConstants.edgeLabelClass}}"\n' +
	    '    ng-style="{ top: (getEdgeCenter(edgeDragging.dragPoint1, edgeDragging.dragPoint2).y)+\'px\',\n' +
	    '                left: (getEdgeCenter(edgeDragging.dragPoint1, edgeDragging.dragPoint2).x)+\'px\'}">\n' +
	    '    <div class="fc-edge-label-text">\n' +
	    '      <span ng-attr-id="{{\'fc-edge-label-dragging\'}}" ng-if="edgeDragging.dragLabel">{{edgeDragging.dragLabel}}</span>\n' +
	    '    </div>\n' +
	    '  </div>\n' +
	    '  <div ng-mousedown="edgeMouseDown($event, edge)"\n' +
	    '       ng-click="edgeClick($event, edge)"\n' +
	    '       ng-dblclick="edgeDoubleClick($event, edge)"\n' +
	    '       ng-mouseover="edgeMouseOver($event, edge)"\n' +
	    '       ng-mouseenter="edgeMouseEnter($event, edge)"\n' +
	    '       ng-mouseleave="edgeMouseLeave($event, edge)"\n' +
	    '       ng-attr-class="{{\'fc-noselect \' + ((modelservice.edges.isEdit(edge) && flowchartConstants.editClass + \' \' + flowchartConstants.edgeLabelClass) || (modelservice.edges.isSelected(edge) && flowchartConstants.selectedClass + \' \' + flowchartConstants.edgeLabelClass) || edge == mouseOver.edge && flowchartConstants.hoverClass + \' \' + flowchartConstants.edgeLabelClass || edge.active && flowchartConstants.activeClass + flowchartConstants.edgeLabelClass || flowchartConstants.edgeLabelClass)}}"\n' +
	    '       ng-style="{ top: (getEdgeCenter(modelservice.edges.sourceCoord(edge), modelservice.edges.destCoord(edge)).y)+\'px\',\n' +
	    '                   left: (getEdgeCenter(modelservice.edges.sourceCoord(edge), modelservice.edges.destCoord(edge)).x)+\'px\'}"\n' +
	    '       ng-repeat="edge in model.edges">\n' +
	    '    <div class="fc-edge-label-text">\n' +
	    '      <div ng-if="modelservice.isEditable()" class="fc-noselect fc-nodeedit" ng-click="edgeEdit($event, edge)">\n' +
	    '        <i class="fa fa-pencil" aria-hidden="true"></i>\n' +
	    '      </div>\n' +
	    '      <div ng-if="modelservice.isEditable()" class="fc-noselect fc-nodedelete" ng-click="edgeRemove($event, edge)">\n' +
	    '        &times;\n' +
	    '      </div>\n' +
	    '      <span ng-attr-id="{{\'fc-edge-label-\'+$index}}" ng-if="edge.label">{{edge.label}}</span>\n' +
	    '    </div>\n' +
	    '  </div>\n' +
	    '  <div id="select-rectangle" class="fc-select-rectangle" hidden></div>\n' +
	    '</div>\n' +
	    '');
	}]);
	})();
	
	(function(module) {
	try {
	  module = angular.module('flowchart-templates');
	} catch (e) {
	  module = angular.module('flowchart-templates', []);
	}
	module.run(['$templateCache', function($templateCache) {
	  $templateCache.put('flowchart/node.html',
	    '<div\n' +
	    '  id="{{node.id}}"\n' +
	    '  ng-attr-style="position: absolute; top: {{ node.y }}px; left: {{ node.x }}px;"\n' +
	    '  ng-dblclick="callbacks.doubleClick($event)">\n' +
	    '  <div class="{{flowchartConstants.nodeOverlayClass}}"></div>\n' +
	    '  <div class="innerNode">\n' +
	    '    <p>{{ node.name }}</p>\n' +
	    '\n' +
	    '    <div class="{{flowchartConstants.leftConnectorClass}}">\n' +
	    '      <div fc-magnet\n' +
	    '           ng-repeat="connector in modelservice.nodes.getConnectorsByType(node, flowchartConstants.leftConnectorType)">\n' +
	    '        <div fc-connector></div>\n' +
	    '      </div>\n' +
	    '    </div>\n' +
	    '    <div class="{{flowchartConstants.rightConnectorClass}}">\n' +
	    '      <div fc-magnet\n' +
	    '           ng-repeat="connector in modelservice.nodes.getConnectorsByType(node, flowchartConstants.rightConnectorType)">\n' +
	    '        <div fc-connector></div>\n' +
	    '      </div>\n' +
	    '    </div>\n' +
	    '  </div>\n' +
	    '  <div ng-if="modelservice.isEditable() && !node.readonly" class="fc-nodeedit" ng-click="callbacks.nodeEdit($event, node)">\n' +
	    '    <i class="fa fa-pencil" aria-hidden="true"></i>\n' +
	    '  </div>\n' +
	    '  <div ng-if="modelservice.isEditable() && !node.readonly" class="fc-nodedelete" ng-click="modelservice.nodes.delete(node)">\n' +
	    '    &times;\n' +
	    '  </div>\n' +
	    '</div>\n' +
	    '');
	}]);
	})();
	
	(function(module) {
	try {
	  module = angular.module('flowchart-templates');
	} catch (e) {
	  module = angular.module('flowchart-templates', []);
	}
	module.run(['$templateCache', function($templateCache) {
	  $templateCache.put('flowchart/onedatanode.html',
	    '<div\n' +
	    '  id="{{node.id}}"\n' +
	    '  ng-attr-style="position: absolute; top: {{ node.y }}px; left: {{ node.x }}px; background: {{ node.color }}; border-color: {{node.borderColor}}">\n' +
	    '  <p>{{ node.name }}</p>\n' +
	    '\n' +
	    '  <div class="{{flowchartConstants.leftConnectorClass}}">\n' +
	    '    <div fc-connector\n' +
	    '         ng-repeat="connector in modelservice.nodes.getConnectorsByType(node, flowchartConstants.leftConnectorType)"></div>\n' +
	    '  </div>\n' +
	    '  <div class="{{flowchartConstants.rightConnectorClass}}">\n' +
	    '    <div fc-connector\n' +
	    '         ng-repeat="connector in modelservice.nodes.getConnectorsByType(node, flowchartConstants.rightConnectorType)"></div>\n' +
	    '  </div>\n' +
	    '</div>\n' +
	    '');
	}]);
	})();


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	/*! ngclipboard - v1.1.1 - 2016-02-26
	* https://github.com/sachinchoolur/ngclipboard
	* Copyright (c) 2016 Sachin; Licensed MIT */
	(function() {
	    'use strict';
	    var MODULE_NAME = 'ngclipboard';
	    var angular, Clipboard;
	    
	    // Check for CommonJS support
	    if (typeof module === 'object' && module.exports) {
	      angular = __webpack_require__(48);
	      Clipboard = __webpack_require__(1368);
	      module.exports = MODULE_NAME;
	    } else {
	      angular = window.angular;
	      Clipboard = window.Clipboard;
	    }
	
	    angular.module(MODULE_NAME, []).directive('ngclipboard', function() {
	        return {
	            restrict: 'A',
	            scope: {
	                ngclipboardSuccess: '&',
	                ngclipboardError: '&'
	            },
	            link: function(scope, element) {
	                var clipboard = new Clipboard(element[0]);
	
	                clipboard.on('success', function(e) {
	                  scope.$apply(function () {
	                    scope.ngclipboardSuccess({
	                      e: e
	                    });
	                  });
	                });
	
	                clipboard.on('error', function(e) {
	                  scope.$apply(function () {
	                    scope.ngclipboardError({
	                      e: e
	                    });
	                  });
	                });
	
	            }
	        };
	    });
	}());


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(573)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('select'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.select);
	        global.clipboardAction = mod.exports;
	    }
	})(this, function (module, _select) {
	    'use strict';
	
	    var _select2 = _interopRequireDefault(_select);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    var ClipboardAction = function () {
	        /**
	         * @param {Object} options
	         */
	        function ClipboardAction(options) {
	            _classCallCheck(this, ClipboardAction);
	
	            this.resolveOptions(options);
	            this.initSelection();
	        }
	
	        /**
	         * Defines base properties passed from constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(ClipboardAction, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = options.action;
	                this.emitter = options.emitter;
	                this.target = options.target;
	                this.text = options.text;
	                this.trigger = options.trigger;
	
	                this.selectedText = '';
	            }
	        }, {
	            key: 'initSelection',
	            value: function initSelection() {
	                if (this.text) {
	                    this.selectFake();
	                } else if (this.target) {
	                    this.selectTarget();
	                }
	            }
	        }, {
	            key: 'selectFake',
	            value: function selectFake() {
	                var _this = this;
	
	                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
	
	                this.removeFake();
	
	                this.fakeHandlerCallback = function () {
	                    return _this.removeFake();
	                };
	                this.fakeHandler = document.body.addEventListener('click', this.fakeHandlerCallback) || true;
	
	                this.fakeElem = document.createElement('textarea');
	                // Prevent zooming on iOS
	                this.fakeElem.style.fontSize = '12pt';
	                // Reset box model
	                this.fakeElem.style.border = '0';
	                this.fakeElem.style.padding = '0';
	                this.fakeElem.style.margin = '0';
	                // Move element out of screen horizontally
	                this.fakeElem.style.position = 'absolute';
	                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	                // Move element to the same position vertically
	                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	                this.fakeElem.addEventListener('focus', window.scrollTo(0, yPosition));
	                this.fakeElem.style.top = yPosition + 'px';
	
	                this.fakeElem.setAttribute('readonly', '');
	                this.fakeElem.value = this.text;
	
	                document.body.appendChild(this.fakeElem);
	
	                this.selectedText = (0, _select2.default)(this.fakeElem);
	                this.copyText();
	            }
	        }, {
	            key: 'removeFake',
	            value: function removeFake() {
	                if (this.fakeHandler) {
	                    document.body.removeEventListener('click', this.fakeHandlerCallback);
	                    this.fakeHandler = null;
	                    this.fakeHandlerCallback = null;
	                }
	
	                if (this.fakeElem) {
	                    document.body.removeChild(this.fakeElem);
	                    this.fakeElem = null;
	                }
	            }
	        }, {
	            key: 'selectTarget',
	            value: function selectTarget() {
	                this.selectedText = (0, _select2.default)(this.target);
	                this.copyText();
	            }
	        }, {
	            key: 'copyText',
	            value: function copyText() {
	                var succeeded = void 0;
	
	                try {
	                    succeeded = document.execCommand(this.action);
	                } catch (err) {
	                    succeeded = false;
	                }
	
	                this.handleResult(succeeded);
	            }
	        }, {
	            key: 'handleResult',
	            value: function handleResult(succeeded) {
	                this.emitter.emit(succeeded ? 'success' : 'error', {
	                    action: this.action,
	                    text: this.selectedText,
	                    trigger: this.trigger,
	                    clearSelection: this.clearSelection.bind(this)
	                });
	            }
	        }, {
	            key: 'clearSelection',
	            value: function clearSelection() {
	                if (this.target) {
	                    this.target.blur();
	                }
	
	                window.getSelection().removeAllRanges();
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.removeFake();
	            }
	        }, {
	            key: 'action',
	            set: function set() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
	
	                this._action = action;
	
	                if (this._action !== 'copy' && this._action !== 'cut') {
	                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
	                }
	            },
	            get: function get() {
	                return this._action;
	            }
	        }, {
	            key: 'target',
	            set: function set(target) {
	                if (target !== undefined) {
	                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
	                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
	                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	                        }
	
	                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	                        }
	
	                        this._target = target;
	                    } else {
	                        throw new Error('Invalid "target" value, use a valid Element');
	                    }
	                }
	            },
	            get: function get() {
	                return this._target;
	            }
	        }]);
	
	        return ClipboardAction;
	    }();
	
	    module.exports = ClipboardAction;
	});

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1367), __webpack_require__(1369), __webpack_require__(315)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
	        global.clipboard = mod.exports;
	    }
	})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
	    'use strict';
	
	    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);
	
	    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);
	
	    var _goodListener2 = _interopRequireDefault(_goodListener);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var Clipboard = function (_Emitter) {
	        _inherits(Clipboard, _Emitter);
	
	        /**
	         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	         * @param {Object} options
	         */
	        function Clipboard(trigger, options) {
	            _classCallCheck(this, Clipboard);
	
	            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
	
	            _this.resolveOptions(options);
	            _this.listenClick(trigger);
	            return _this;
	        }
	
	        /**
	         * Defines if attributes would be resolved using internal setter functions
	         * or custom functions that were passed in the constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(Clipboard, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	            }
	        }, {
	            key: 'listenClick',
	            value: function listenClick(trigger) {
	                var _this2 = this;
	
	                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
	                    return _this2.onClick(e);
	                });
	            }
	        }, {
	            key: 'onClick',
	            value: function onClick(e) {
	                var trigger = e.delegateTarget || e.currentTarget;
	
	                if (this.clipboardAction) {
	                    this.clipboardAction = null;
	                }
	
	                this.clipboardAction = new _clipboardAction2.default({
	                    action: this.action(trigger),
	                    target: this.target(trigger),
	                    text: this.text(trigger),
	                    trigger: trigger,
	                    emitter: this
	                });
	            }
	        }, {
	            key: 'defaultAction',
	            value: function defaultAction(trigger) {
	                return getAttributeValue('action', trigger);
	            }
	        }, {
	            key: 'defaultTarget',
	            value: function defaultTarget(trigger) {
	                var selector = getAttributeValue('target', trigger);
	
	                if (selector) {
	                    return document.querySelector(selector);
	                }
	            }
	        }, {
	            key: 'defaultText',
	            value: function defaultText(trigger) {
	                return getAttributeValue('text', trigger);
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.listener.destroy();
	
	                if (this.clipboardAction) {
	                    this.clipboardAction.destroy();
	                    this.clipboardAction = null;
	                }
	            }
	        }]);
	
	        return Clipboard;
	    }(_tinyEmitter2.default);
	
	    /**
	     * Helper function to retrieve attribute value.
	     * @param {String} suffix
	     * @param {Element} element
	     */
	    function getAttributeValue(suffix, element) {
	        var attribute = 'data-clipboard-' + suffix;
	
	        if (!element.hasAttribute(attribute)) {
	            return;
	        }
	
	        return element.getAttribute(attribute);
	    }
	
	    module.exports = Clipboard;
	});

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// # ngReact
	// ### Use React Components inside of your Angular applications
	//
	// Composed of
	// - reactComponent (generic directive for delegating off to React Components)
	// - reactDirective (factory for creating specific directives that correspond to reactComponent directives)
	
	
	(function (root, factory) {
	  if (typeof module !== 'undefined' && module.exports) {
	    // CommonJS
	    module.exports = factory(__webpack_require__(1), __webpack_require__(14), __webpack_require__(48));
	  } else if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(14), __webpack_require__(48)], __WEBPACK_AMD_DEFINE_RESULT__ = function (react, reactDOM, angular) {
	      return (root.ngReact = factory(react, reactDOM, angular));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Global Variables
	    root.ngReact = factory(root.React, root.ReactDOM, root.angular);
	  }
	}(this, function ngReact(React, ReactDOM, angular) {
	  'use strict';
	
	  // get a react component from name (components can be an angular injectable e.g. value, factory or
	  // available on window
	  function getReactComponent( name, $injector ) {
	    // if name is a function assume it is component and return it
	    if (angular.isFunction(name)) {
	      return name;
	    }
	
	    // a React component name must be specified
	    if (!name) {
	      throw new Error('ReactComponent name attribute must be specified');
	    }
	
	    // ensure the specified React component is accessible, and fail fast if it's not
	    var reactComponent;
	    try {
	      reactComponent = $injector.get(name);
	    } catch(e) { }
	
	    if (!reactComponent) {
	      try {
	        reactComponent = name.split('.').reduce(function(current, namePart) {
	          return current[namePart];
	        }, window);
	      } catch (e) { }
	    }
	
	    if (!reactComponent) {
	      throw Error('Cannot find react component ' + name);
	    }
	
	    return reactComponent;
	  }
	
	  // wraps a function with scope.$apply, if already applied just return
	  function applied(fn, scope) {
	    if (fn.wrappedInApply) {
	      return fn;
	    }
	    var wrapped = function() {
	      var args = arguments;
	      var phase = scope.$root.$$phase;
	        if (phase === "$apply" || phase === "$digest") {
	          return fn.apply(null, args);
	        } else {
	          return scope.$apply(function() {
	            return fn.apply( null, args );
	          });
	        }
	    };
	    wrapped.wrappedInApply = true;
	    return wrapped;
	  }
	
	  // wraps all functions on obj in scope.$apply
	  function applyFunctions(obj, scope) {
	    return Object.keys(obj || {}).reduce(function(prev, key) {
	      var value = obj[key];
	      // wrap functions in a function that ensures they are scope.$applied
	      // ensures that when function is called from a React component
	      // the Angular digest cycle is run
	      prev[key] = angular.isFunction(value) ? applied(value, scope) : value;
	      return prev;
	    }, {});
	  }
	
	  /**
	   *
	   * @param watchDepth (value of HTML watch-depth attribute)
	   * @param scope (angular scope)
	   *
	   * Uses the watchDepth attribute to determine how to watch props on scope.
	   * If watchDepth attribute is NOT reference or collection, watchDepth defaults to deep watching by value
	   */
	  function watchProps (watchDepth, scope, watchExpressions, listener){
	    if (watchDepth === 'collection' && angular.isFunction(scope.$watchCollection)) {
	      watchExpressions.forEach(function(expr){
	        scope.$watchCollection(expr, listener);
	      });
	    }
	    else if (watchDepth === 'reference') {
	      if (angular.isFunction(scope.$watchGroup)) {
	        scope.$watchGroup(watchExpressions, listener);
	      }
	      else {
	        watchExpressions.forEach(function(expr){
	          scope.$watch(expr, listener);
	        });
	      }
	    }
	    else {
	      //default watchDepth to value if not reference or collection
	      watchExpressions.forEach(function(expr){
	        scope.$watch(expr, listener, true);
	      });
	    }
	  }
	
	  // render React component, with scope[attrs.props] being passed in as the component props
	  function renderComponent(component, props, scope, elem) {
	    scope.$evalAsync(function() {
	      ReactDOM.render(React.createElement(component, props), elem[0]);
	    });
	  }
	
	  // # reactComponent
	  // Directive that allows React components to be used in Angular templates.
	  //
	  // Usage:
	  //     <react-component name="Hello" props="name"/>
	  //
	  // This requires that there exists an injectable or globally available 'Hello' React component.
	  // The 'props' attribute is optional and is passed to the component.
	  //
	  // The following would would create and register the component:
	  //
	  //     /** @jsx React.DOM */
	  //     var module = angular.module('ace.react.components');
	  //     module.value('Hello', React.createClass({
	  //         render: function() {
	  //             return <div>Hello {this.props.name}</div>;
	  //         }
	  //     }));
	  //
	  var reactComponent = function($injector) {
	    return {
	      restrict: 'E',
	      replace: true,
	      link: function(scope, elem, attrs) {
	        var reactComponent = getReactComponent(attrs.name, $injector);
	
	        var renderMyComponent = function() {
	          var scopeProps = scope.$eval(attrs.props);
	          var props = applyFunctions(scopeProps, scope);
	
	          renderComponent(reactComponent, props, scope, elem);
	        };
	
	        // If there are props, re-render when they change
	        attrs.props ?
	            watchProps(attrs.watchDepth, scope, [attrs.props], renderMyComponent) :
	          renderMyComponent();
	
	        // cleanup when scope is destroyed
	        scope.$on('$destroy', function() {
	          if (!attrs.onScopeDestroy) {
	            ReactDOM.unmountComponentAtNode(elem[0]);
	          } else {
	            scope.$eval(attrs.onScopeDestroy, {
	              unmountComponent: ReactDOM.unmountComponentAtNode.bind(this, elem[0])
	            });
	          }
	        });
	      }
	    };
	  };
	
	  // # reactDirective
	  // Factory function to create directives for React components.
	  //
	  // With a component like this:
	  //
	  //     /** @jsx React.DOM */
	  //     var module = angular.module('ace.react.components');
	  //     module.value('Hello', React.createClass({
	  //         render: function() {
	  //             return <div>Hello {this.props.name}</div>;
	  //         }
	  //     }));
	  //
	  // A directive can be created and registered with:
	  //
	  //     module.directive('hello', function(reactDirective) {
	  //         return reactDirective('Hello', ['name']);
	  //     });
	  //
	  // Where the first argument is the injectable or globally accessible name of the React component
	  // and the second argument is an array of property names to be watched and passed to the React component
	  // as props.
	  //
	  // This directive can then be used like this:
	  //
	  //     <hello name="name"/>
	  //
	  var reactDirective = function($injector) {
	    return function(reactComponentName, propNames, conf, injectableProps) {
	      var directive = {
	        restrict: 'E',
	        replace: true,
	        link: function(scope, elem, attrs) {
	          var reactComponent = getReactComponent(reactComponentName, $injector);
	
	          // if propNames is not defined, fall back to use the React component's propTypes if present
	          propNames = propNames || Object.keys(reactComponent.propTypes || {});
	
	          // for each of the properties, get their scope value and set it to scope.props
	          var renderMyComponent = function() {
	            var props = {};
	            propNames.forEach(function(propName) {
	              props[propName] = scope.$eval(attrs[propName]);
	            });
	            props = applyFunctions(props, scope);
	            props = angular.extend({}, props, injectableProps);
	            renderComponent(reactComponent, props, scope, elem);
	          };
	
	          // watch each property name and trigger an update whenever something changes,
	          // to update scope.props with new values
	          var propExpressions = propNames.map(function(k){
	            return attrs[k];
	          });
	
	          watchProps(attrs.watchDepth, scope, propExpressions, renderMyComponent);
	
	          renderMyComponent();
	
	          // cleanup when scope is destroyed
	          scope.$on('$destroy', function() {
	            if (!attrs.onScopeDestroy) {
	              ReactDOM.unmountComponentAtNode(elem[0]);
	            } else {
	              scope.$eval(attrs.onScopeDestroy, {
	                unmountComponent: ReactDOM.unmountComponentAtNode.bind(this, elem[0])
	              });
	            }
	          });
	        }
	      };
	      return angular.extend(directive, conf);
	    };
	  };
	
	  // create the end module without any dependencies, including reactComponent and reactDirective
	  return angular.module('react', [])
	    .directive('reactComponent', ['$injector', reactComponent])
	    .factory('reactDirective', ['$injector', reactDirective]);
	}));


/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	var path = 'admin/general-settings.tpl.html';
	var html = " <div layout=row width=100% layout-wrap> <md-card flex-gt-sm=60 flex=100 style=height:100%> <md-card-title> <md-card-title-text> <span translate class=md-headline>admin.general-settings</span> </md-card-title-text> </md-card-title> <md-progress-linear md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-card-content> <form name=vm.settingsForm ng-submit=vm.save() tb-confirm-on-exit confirm-form=vm.settingsForm> <fieldset ng-disabled=$root.loading> <md-input-container class=md-block> <label translate>admin.base-url</label> <input required name=baseUrl ng-model=vm.settings.jsonValue.baseUrl> <div ng-messages=vm.settingsForm.baseUrl.$error> <div translate ng-message=required>admin.base-url-required</div> </div> </md-input-container> <div layout=row layout-align=\"end center\" width=100% layout-wrap> <md-button ng-disabled=\"$root.loading || vm.settingsForm.$invalid || !vm.settingsForm.$dirty\" type=submit class=\"md-raised md-primary\">{{'action.save' | translate}}</md-button> </div> </fieldset> </form> </md-card-content> </md-card> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	var path = 'admin/outgoing-mail-settings.tpl.html';
	var html = " <div layout=row width=100% layout-wrap tb-help=\"'outgoingMailSettings'\" help-container-id=help-container> <md-card flex-gt-sm=60 flex=100 style=height:100%> <md-card-title> <md-card-title-text layout=row> <span translate class=md-headline>admin.outgoing-mail-settings</span> <span flex></span> <div id=help-container></div> </md-card-title-text> </md-card-title> <md-progress-linear md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-card-content> <form name=vm.settingsForm ng-submit=vm.save() tb-confirm-on-exit confirm-form=vm.settingsForm> <fieldset ng-disabled=$root.loading> <md-input-container class=md-block> <label translate>admin.mail-from</label> <input required name=mailFrom ng-model=vm.settings.jsonValue.mailFrom> <div ng-messages=vm.settingsForm.mailFrom.$error> <div translate ng-message=required>admin.mail-from-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>admin.smtp-protocol</label> <md-select ng-disabled=$root.loading ng-model=vm.settings.jsonValue.smtpProtocol> <md-option ng-repeat=\"smtpProtocol in vm.smtpProtocols\" value={{smtpProtocol}}> {{smtpProtocol.toUpperCase()}} </md-option> </md-select> </md-input-container> <div layout-gt-sm=row> <md-input-container class=md-block flex=100 flex-gt-sm=60> <label translate>admin.smtp-host</label> <input required name=smtpHost ng-model=vm.settings.jsonValue.smtpHost placeholder=localhost> <div ng-messages=vm.settingsForm.smtpHost.$error> <div translate ng-message=required>admin.smtp-host-required</div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=40> <label translate>admin.smtp-port</label> <input required name=smtpPort ng-model=vm.settings.jsonValue.smtpPort placeholder=25 ng-pattern=/^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/ md-maxlength=5> <div ng-messages=vm.settingsForm.smtpPort.$error role=alert multiple=multiple> <div translate ng-message=required>admin.smtp-port-required</div> <div translate ng-message=pattern>admin.smtp-port-invalid</div> <div translate ng-message=md-maxlength>admin.smtp-port-invalid</div> </div> </md-input-container> </div> <md-input-container class=md-block> <label translate>admin.timeout-msec</label> <input required name=timeout ng-model=vm.settings.jsonValue.timeout placeholder=10000 ng-pattern=/^[0-9]{1,6}$/ md-maxlength=6> <div ng-messages=vm.settingsForm.timeout.$error role=alert multiple=multiple> <div translate ng-message=required>admin.timeout-required</div> <div translate ng-message=pattern>admin.timeout-invalid</div> <div translate ng-message=md-maxlength>admin.timeout-invalid</div> </div> </md-input-container> <md-checkbox ng-disabled=$root.loading ng-true-value=\"'true'\" ng-false-value=\"'false'\" aria-label=\"{{ 'admin.enable-tls' | translate }}\" ng-model=vm.settings.jsonValue.enableTls>{{ 'admin.enable-tls' | translate }}</md-checkbox> <md-input-container class=md-block> <label translate>common.username</label> <input name=username placeholder=\"{{ 'common.enter-username' | translate }}\" ng-model=vm.settings.jsonValue.username> </md-input-container> <md-input-container class=md-block> <label translate>common.password</label> <input name=password placeholder=\"{{ 'common.enter-password' | translate }}\" type=password ng-model=vm.settings.jsonValue.password> </md-input-container> <div layout=row layout-align=\"end center\" width=100% layout-wrap> <md-button ng-disabled=\"$root.loading || vm.settingsForm.$invalid\" ng-click=vm.sendTestMail() class=md-raised>{{'admin.send-test-mail' | translate}}</md-button> <md-button ng-disabled=\"$root.loading || vm.settingsForm.$invalid || !vm.settingsForm.$dirty\" type=submit class=\"md-raised md-primary\">{{'action.save' | translate}}</md-button> </div> </fieldset> </form> </md-card-content> </md-card> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

	var path = 'alarm/alarm-header.tpl.html';
	var html = " <div translate class=tb-cell flex=30>alarm.created-time</div> <div translate class=tb-cell flex=15>alarm.originator</div> <div translate class=tb-cell flex=20>alarm.type</div> <div translate class=tb-cell flex=15>alarm.severity</div> <div translate class=tb-cell flex=20>alarm.status</div> <div translate class=tb-cell flex=15>alarm.details</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	var path = 'alarm/alarm-row.tpl.html';
	var html = " <div class=tb-cell flex=30>{{alarm.createdTime | date : 'yyyy-MM-dd HH:mm:ss'}}</div> <div class=tb-cell flex=15>{{alarm.originatorName}}</div> <div class=tb-cell flex=20>{{alarm.type}}</div> <div class=\"tb-cell tb-severity\" flex=15 ng-class=types.alarmSeverity[alarm.severity].class> {{ alarm ? (types.alarmSeverity[alarm.severity].name | translate) : '' }} </div> <div class=tb-cell flex=20>{{ alarm ? (('alarm.display-status.' + alarm.status) | translate) : '' }}</div> <div class=tb-cell flex=15> <md-button class=\"md-icon-button md-primary\" ng-click=showAlarmDetails($event) aria-label=\"{{ 'action.view' | translate }}\"> <md-tooltip md-direction=top> {{ 'alarm.details' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.view' | translate }}\" class=material-icons> more_horiz </md-icon> </md-button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	var path = 'alarm/alarm-table.tpl.html';
	var html = " <md-content flex class=\"md-padding tb-absolute-fill\" layout=column> <section layout=row> <md-input-container class=md-block style=width:200px> <label translate>alarm.alarm-status</label> <md-select ng-model=alarmSearchStatus ng-disabled=$root.loading> <md-option ng-repeat=\"searchStatus in types.alarmSearchStatus\" ng-value=searchStatus> {{ ('alarm.search-status.' + searchStatus) | translate }} </md-option> </md-select> </md-input-container> <tb-timewindow flex ng-model=timewindow history-only as-button=true></tb-timewindow> <md-button ng-disabled=$root.loading class=md-icon-button ng-click=reload()> <md-icon>refresh</md-icon> <md-tooltip md-direction=top> {{ 'action.refresh' | translate }} </md-tooltip> </md-button> </section> <div flex layout=column class=\"tb-alarm-container md-whiteframe-z1\"> <md-list flex layout=column class=tb-alarm-table> <md-list class=\"tb-row tb-header\" layout=row layout-align=\"start center\" tb-alarm-header> </md-list> <md-progress-linear style=max-height:0 md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <md-divider></md-divider> <span translate layout-align=\"center center\" style=margin-top:25px class=tb-prompt ng-show=noData()>alarm.no-alarms-prompt</span> <md-virtual-repeat-container ng-show=hasData() flex md-top-index=topIndex tb-scope-element=repeatContainer> <md-list-item md-virtual-repeat=\"alarm in theAlarms\" md-on-demand flex ng-style=\"hasScroll() ? {'margin-right':'-15px'} : {}\"> <md-list class=tb-row flex layout=row layout-align=\"start center\" tb-alarm-row alarm={{alarm}}> </md-list> <md-divider flex></md-divider> </md-list-item> </md-virtual-repeat-container> </md-list> </div> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	var path = 'asset/add-asset.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'asset.add' | translate }}\" tb-help=\"'assets'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>asset.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-asset asset=vm.item is-edit=true the-form=theForm></tb-asset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	var path = 'asset/add-assets-to-customer.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'asset.assign-to-customer' | translate }}\"> <form name=theForm ng-submit=vm.assign()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>asset.assign-asset-to-customer</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset> <span translate>asset.assign-asset-to-customer-text</span> <md-input-container class=md-block style=margin-bottom:0> <label>&nbsp;</label> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons> search </md-icon> <input id=asset-search autofocus ng-model=vm.searchText ng-change=vm.searchAssetTextUpdated() placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <div style=min-height:150px> <span translate layout-align=\"center center\" style=text-transform:uppercase;display:flex;height:150px class=md-subhead ng-show=vm.noData()>asset.no-assets-text</span> <md-virtual-repeat-container ng-show=vm.hasData() tb-scope-element=repeatContainer md-top-index=vm.topIndex flex style=min-height:150px;width:100%> <md-list> <md-list-item md-virtual-repeat=\"asset in vm.theAssets\" md-on-demand class=repeated-item flex> <md-checkbox ng-click=\"vm.toggleAssetSelection($event, asset)\" aria-label=\"{{ 'item.selected' | translate }}\" ng-checked=asset.selected></md-checkbox> <span> {{ asset.name }} </span> </md-list-item> </md-list> </md-virtual-repeat-container> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || vm.assets.selectedCount == 0\" type=submit class=\"md-raised md-primary\"> {{ 'action.assign' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	var path = 'asset/asset-card.tpl.html';
	var html = " <div flex layout=column style=margin-top:-10px> <div style=text-transform:uppercase;padding-bottom:10px>{{vm.item.type}}</div> <div class=tb-small ng-show=vm.isAssignedToCustomer()>{{'asset.assignedToCustomer' | translate}} '{{vm.item.assignedCustomer.title}}'</div> <div class=tb-small ng-show=vm.isPublic()>{{'asset.public' | translate}}</div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	var path = 'asset/asset-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onMakePublic({event: $event})\" ng-show=\"!isEdit && assetScope === 'tenant' && !isAssignedToCustomer && !isPublic\" class=\"md-raised md-primary\">{{ 'asset.make-public' | translate }}</md-button> <md-button ng-click=\"onAssignToCustomer({event: $event})\" ng-show=\"!isEdit && assetScope === 'tenant' && !isAssignedToCustomer\" class=\"md-raised md-primary\">{{ 'asset.assign-to-customer' | translate }}</md-button> <md-button ng-click=\"onUnassignFromCustomer({event: $event, isPublic: isPublic})\" ng-show=\"!isEdit && (assetScope === 'customer' || assetScope === 'tenant') && isAssignedToCustomer\" class=\"md-raised md-primary\">{{ isPublic ? 'asset.make-private' : 'asset.unassign-from-customer' | translate }}</md-button> <md-button ng-click=\"onDeleteAsset({event: $event})\" ng-show=\"!isEdit && assetScope === 'tenant'\" class=\"md-raised md-primary\">{{ 'asset.delete' | translate }}</md-button> <div layout=row> <md-button ngclipboard data-clipboard-action=copy ngclipboard-success=onAssetIdCopied(e) data-clipboard-text={{asset.id.id}} ng-show=!isEdit class=md-raised> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <span translate>asset.copyId</span> </md-button> </div> <md-content class=md-padding layout=column> <md-input-container class=md-block ng-show=\"!isEdit && isAssignedToCustomer && !isPublic && assetScope === 'tenant'\"> <label translate>asset.assignedToCustomer</label> <input ng-model=assignedCustomer.title disabled=disabled> </md-input-container> <div class=tb-small style=padding-bottom:10px;padding-left:2px ng-show=\"!isEdit && isPublic && (assetScope === 'customer' || assetScope === 'tenant')\"> {{ 'asset.asset-public' | translate }} </div> <fieldset ng-disabled=\"$root.loading || !isEdit\"> <md-input-container class=md-block> <label translate>asset.name</label> <input required name=name ng-model=asset.name> <div ng-messages=theForm.name.$error> <div translate ng-message=required>asset.name-required</div> </div> </md-input-container> <tb-entity-subtype-autocomplete ng-disabled=\"$root.loading || !isEdit\" tb-required=true the-form=theForm ng-model=asset.type entity-type=types.entityType.asset> </tb-entity-subtype-autocomplete> <md-input-container class=md-block> <label translate>asset.description</label> <textarea ng-model=asset.additionalInfo.description rows=2></textarea> </md-input-container> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	var path = 'asset/assets.tpl.html';
	var html = " <tb-grid grid-configuration=vm.assetGridConfig> <details-buttons tb-help=\"'assets'\" help-container-id=help-container> <div id=help-container></div> </details-buttons> <md-tabs ng-class=\"{'tb-headless': vm.grid.detailsConfig.isDetailsEditMode}\" id=tabs md-border-bottom flex class=tb-absolute-fill> <md-tab label=\"{{ 'asset.details' | translate }}\"> <tb-asset asset=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode asset-scope=vm.assetsScope the-form=vm.grid.detailsForm on-assign-to-customer=\"vm.assignToCustomer(event, [ vm.grid.detailsConfig.currentItem.id.id ])\" on-make-public=\"vm.makePublic(event, vm.grid.detailsConfig.currentItem)\" on-unassign-from-customer=\"vm.unassignFromCustomer(event, vm.grid.detailsConfig.currentItem, isPublic)\" on-delete-asset=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"></tb-asset> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.attributes' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.asset}} entity-name=vm.grid.operatingItem().name default-attribute-scope={{vm.types.attributesScope.server.value}}> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.latest-telemetry' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.asset}} entity-name=vm.grid.operatingItem().name default-attribute-scope={{vm.types.latestTelemetry.value}} disable-attribute-scope-selection=true> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'alarm.alarms' | translate }}\"> <tb-alarm-table flex entity-type=vm.types.entityType.asset entity-id=vm.grid.operatingItem().id.id> </tb-alarm-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'asset.events' | translate }}\"> <tb-event-table flex entity-type=vm.types.entityType.asset entity-id=vm.grid.operatingItem().id.id tenant-id=vm.grid.operatingItem().tenantId.id default-event-type={{vm.types.eventType.error.value}}> </tb-event-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'relation.relations' | translate }}\"> <tb-relation-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.asset}}> </tb-relation-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.grid.isTenantAdmin()\" md-on-select=vm.grid.triggerResize() label=\"{{ 'audit-log.audit-logs' | translate }}\"> <tb-audit-log-table flex entity-type=vm.types.entityType.asset entity-id=vm.grid.operatingItem().id.id audit-log-mode={{vm.types.auditLogMode.entity}}> </tb-audit-log-table> </md-tab> </md-tabs></tb-grid> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	var path = 'asset/assign-to-customer.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'asset.assign-asset-to-customer' | translate }}\"> <form name=theForm ng-submit=vm.assign()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>asset.assign-asset-to-customer</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset> <span translate>asset.assign-to-customer-text</span> <md-input-container class=md-block style=margin-bottom:0> <label>&nbsp;</label> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons> search </md-icon> <input id=customer-search autofocus ng-model=vm.searchText ng-change=vm.searchCustomerTextUpdated() placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <div style=min-height:150px> <span translate layout-align=\"center center\" style=text-transform:uppercase;display:flex;height:150px class=md-subhead ng-show=vm.noData()>customer.no-customers-text</span> <md-virtual-repeat-container ng-show=vm.hasData() tb-scope-element=repeatContainer md-top-index=vm.topIndex flex style=min-height:150px;width:100%> <md-list> <md-list-item md-virtual-repeat=\"customer in vm.theCustomers\" md-on-demand class=repeated-item flex> <md-checkbox ng-click=\"vm.toggleCustomerSelection($event, customer)\" aria-label=\"{{ 'item.selected' | translate }}\" ng-checked=vm.isCustomerSelected(customer)></md-checkbox> <span> {{ customer.title }} </span> </md-list-item> </md-list> </md-virtual-repeat-container> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || vm.customers.selection==null\" type=submit class=\"md-raised md-primary\"> {{ 'action.assign' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	var path = 'audit/audit-log-details-dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'audit-log.audit-log-details' | translate }}\"> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>audit-log.audit-log-details</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.close()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content layout=column> <label translate class=\"tb-title no-padding\">audit-log.action-data</label> <div flex id=tb-audit-log-action-data readonly=readonly ui-ace=vm.actionDataContentOptions ng-model=vm.actionData> </div> <span style=height:30px></span> <label ng-show=vm.displayFailureDetails translate class=\"tb-title no-padding\">audit-log.failure-details</label> <div ng-show=vm.displayFailureDetails flex id=tb-audit-log-failure-details readonly=readonly ui-ace=vm.failureDetailsContentOptions ng-model=vm.actionFailureDetails> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=$root.loading ng-click=vm.close() style=margin-right:20px>{{ 'action.close' | translate }} </md-button> </md-dialog-actions> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	var path = 'audit/audit-log-header.tpl.html';
	var html = " <div translate class=tb-cell flex=30>audit-log.timestamp</div> <div ng-if=\"auditLogMode != types.auditLogMode.entity\" translate class=tb-cell flex=10>audit-log.entity-type</div> <div ng-if=\"auditLogMode != types.auditLogMode.entity\" translate class=tb-cell flex=30>audit-log.entity-name</div> <div ng-if=\"auditLogMode != types.auditLogMode.user\" translate class=tb-cell flex=30>audit-log.user</div> <div translate class=tb-cell flex=15>audit-log.type</div> <div translate class=tb-cell flex=15>audit-log.status</div> <div translate class=tb-cell flex=10>audit-log.details</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	var path = 'audit/audit-log-row.tpl.html';
	var html = " <div class=tb-cell flex=30>{{ auditLog.createdTime | date : 'yyyy-MM-dd HH:mm:ss' }}</div> <div ng-if=\"auditLogMode != types.auditLogMode.entity\" class=tb-cell flex=10>{{ auditLog.entityTypeText }}</div> <div ng-if=\"auditLogMode != types.auditLogMode.entity\" class=tb-cell flex=30>{{ auditLog.entityName }}</div> <div ng-if=\"auditLogMode != types.auditLogMode.user\" class=tb-cell flex=30>{{ auditLog.userName }}</div> <div class=tb-cell flex=15>{{ auditLog.actionTypeText }}</div> <div class=tb-cell flex=15>{{ auditLog.actionStatusText }}</div> <div class=tb-cell flex=10> <md-button class=\"md-icon-button md-primary\" ng-click=showAuditLogDetails($event) aria-label=\"{{ 'action.view' | translate }}\"> <md-tooltip md-direction=top> {{ 'audit-log.details' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.view' | translate }}\" class=material-icons> more_horiz </md-icon> </md-button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	var path = 'audit/audit-log-table.tpl.html';
	var html = " <md-content flex class=\"md-padding tb-absolute-fill\" layout=column> <div flex layout=column class=tb-audit-logs ng-class=\"{'md-whiteframe-z1': pageMode}\"> <div layout=column layout-gt-sm=row layout-align-gt-sm=\"start center\" class=tb-audit-log-toolbar ng-class=\"{'md-padding': pageMode, 'tb-audit-log-margin-18px': !pageMode}\"> <tb-timewindow ng-model=timewindow history-only as-button=true></tb-timewindow> <div flex layout=row layout-align=\"start center\"> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=top> {{'audit-log.search' | translate}} </md-tooltip> </md-button> <md-input-container flex class=tb-audit-log-search-input> <label>&nbsp;</label> <input ng-model=searchText placeholder=\"{{'audit-log.search' | translate}}\"> </md-input-container> <md-button ng-disabled=$root.loading class=md-icon-button aria-label=Close ng-click=\"searchText = ''\"> <md-icon aria-label=Close class=material-icons>close</md-icon> <md-tooltip md-direction=top> {{ 'audit-log.clear-search' | translate }} </md-tooltip> </md-button> <md-button ng-disabled=$root.loading class=md-icon-button ng-click=reload()> <md-icon>refresh</md-icon> <md-tooltip md-direction=top> {{ 'action.refresh' | translate }} </md-tooltip> </md-button> </div> </div> <div flex layout=column class=tb-audit-log-container ng-class=\"{'md-whiteframe-z1': !pageMode}\"> <md-list flex layout=column class=tb-audit-log-table ng-class=\"{'tb-audit-log-table-full': pageMode}\"> <md-list class=\"tb-row tb-header\" layout=row layout-align=\"start center\" tb-audit-log-header audit-log-mode={{auditLogMode}}> </md-list> <md-progress-linear style=max-height:0 md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <md-divider></md-divider> <span translate layout-align=\"center center\" style=margin-top:25px class=tb-prompt ng-show=noData()>audit-log.no-audit-logs-prompt</span> <md-virtual-repeat-container ng-show=hasData() flex md-top-index=topIndex tb-scope-element=repeatContainer> <md-list-item md-virtual-repeat=\"auditLog in theAuditLogs\" md-on-demand flex ng-style=\"hasScroll() ? {'margin-right':'-15px'} : {}\"> <md-list class=tb-row flex layout=row layout-align=\"start center\" tb-audit-log-row audit-log-mode={{auditLogMode}} audit-log={{auditLog}}> </md-list> <md-divider flex></md-divider> </md-list-item> </md-virtual-repeat-container> </md-list> </div> </div> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	var path = 'audit/audit-logs.tpl.html';
	var html = " <tb-audit-log-table class=md-whiteframe-z1 flex audit-log-mode={{vm.types.auditLogMode.tenant}} page-mode=true> </tb-audit-log-table> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	var path = 'components/contact.tpl.html';
	var html = " <md-input-container class=md-block> <label translate>contact.country</label> <md-select ng-disabled=!isEdit name=country ng-model=contact.country> <md-option ng-repeat=\"country in countries\" value={{country}}> {{country}} </md-option> </md-select> </md-input-container> <div layout-gt-sm=row> <md-input-container class=md-block> <label translate>contact.city</label> <input name=city ng-model=contact.city> </md-input-container> <md-input-container class=md-block> <label translate>contact.state</label> <input name=state ng-model=contact.state> </md-input-container> <md-input-container class=md-block> <label translate>contact.postal-code</label> <input name=zip ng-model=contact.zip ng-pattern=postalCodePatterns[contact.country]> <div ng-messages=theForm.zip.$error role=alert multiple=multiple> <div translate ng-message=pattern>contact.postal-code-invalid</div> </div> </md-input-container> </div> <md-input-container class=md-block> <label translate>contact.address</label> <input name=address ng-model=contact.address> </md-input-container> <md-input-container class=md-block> <label translate>contact.address2</label> <input name=address2 ng-model=contact.address2> </md-input-container> <md-input-container class=md-block> <label translate>contact.phone</label> <input name=phone ng-model=contact.phone> </md-input-container> <md-input-container class=md-block> <label translate>contact.email</label> <input name=email type=text ng-pattern='/^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\_\\-0-9]+\\.)+[a-zA-Z]{2,}))$/' ng-model=contact.email> </md-input-container> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	var path = 'components/dashboard-autocomplete.tpl.html';
	var html = " <md-autocomplete ng-required=tbRequired ng-disabled=disabled md-input-name=dashboard ng-model=dashboard md-selected-item=dashboard md-search-text=dashboardSearchText md-search-text-change=dashboardSearchTextChanged() md-items=\"item in fetchDashboards(dashboardSearchText)\" md-item-text=item.title md-min-length=0 placeholder=\"{{ 'dashboard.select-dashboard' | translate }}\" md-menu-class=tb-dashboard-autocomplete> <md-item-template> <div class=tb-dashboard-item> <span md-highlight-text=dashboardSearchText md-highlight-flags=^i>{{item.title}}</span> </div> </md-item-template> <md-not-found> <div class=tb-not-found> <span translate translate-values=\"{ entity: dashboardSearchText }\">dashboard.no-dashboards-matching</span> </div> </md-not-found> <div ng-messages=theForm.dashboard.$error> <div translate ng-message=required>dashboard.dashboard-required</div> </div> </md-autocomplete> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	var path = 'components/dashboard-select-panel.tpl.html';
	var html = " <md-content flex layout=column> <section flex layout=column> <md-content flex class=md-padding layout=column> <md-input-container flex> <label>{{ 'dashboard.select-dashboard' | translate }}</label> <md-select ng-model=vm.dashboardId ng-change=vm.dashboardSelected(vm.dashboardId)> <md-option ng-repeat=\"dashboard in vm.dashboards\" ng-value=dashboard.id.id> {{dashboard.title}} </md-option> </md-select> </md-input-container> </md-content> </section> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	var path = 'components/dashboard-select.tpl.html';
	var html = " <md-select hide-xs hide-sm hide-md ng-required=tbRequired ng-disabled=disabled ng-model=dashboardId aria-label=\"{{ 'dashboard.dashboard' | translate }}\"> <md-option ng-repeat=\"dashboard in dashboards\" ng-value=dashboard.id.id> {{dashboard.title}} </md-option> </md-select> <section hide-gt-md class=tb-dashboard-select> <md-button class=md-icon-button aria-label=\"{{ 'dashboard.select-dashboard' | translate }}\" ng-click=openDashboardSelectPanel($event)> <md-tooltip md-direction={{tooltipDirection}}> {{ 'dashboard.select-dashboard' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'dashboard.select-dashboard' | translate }}\" class=material-icons>dashboards</md-icon> </md-button> </section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	var path = 'components/dashboard.tpl.html';
	var html = " <md-content flex layout=column class=tb-progress-cover layout-align=\"center center\" ng-style=vm.dashboardStyle ng-show=\"((vm.loading() || vm.dashboardLoading) && !vm.isEdit) || vm.isResizing\"> <md-progress-circular md-mode=indeterminate ng-disabled=\"(!vm.loading() && !vm.dashboardLoading || vm.isEdit) && !vm.isResizing\" class=md-warn md-diameter=100> </md-progress-circular> </md-content> <md-menu md-position-mode=\"target target\" tb-mousepoint-menu> <md-content id=gridster-parent class=tb-dashboard-content flex layout-wrap ng-click=\"\" ng-style=\"{'overflowY': vm.isAutofillHeight() ? 'hidden' : 'auto'}\" tb-contextmenu=\"vm.openDashboardContextMenu($event, $mdOpenMousepointMenu)\"> <div ng-class=vm.dashboardClass id=gridster-background style=height:auto;min-height:100%;display:inline> <div id=gridster-child gridster=vm.gridsterOpts> <ul> <li gridster-item=vm.widgetItemMap class=tb-noselect ng-repeat=\"widget in vm.widgets\"> <md-menu md-position-mode=\"target target\" tb-mousepoint-menu> <div tb-expand-fullscreen fullscreen-background-style=vm.dashboardStyle expand-button-id=expand-button expand-button-size=20 on-fullscreen-changed=\"vm.onWidgetFullscreenChanged(expanded, widget)\" layout=column class=tb-widget ng-class=\"{'tb-highlighted': vm.isHighlighted(widget),\n\t\t\t\t\t\t\t\t\t\t           'tb-not-highlighted': vm.isNotHighlighted(widget),\n\t\t\t\t\t\t\t\t\t\t           'md-whiteframe-4dp': vm.dropWidgetShadow(widget),\n\t\t\t\t\t\t\t\t\t\t           'tb-has-timewindow': vm.hasTimewindow(widget)}\" tb-mousedown=\"vm.widgetMouseDown($event, widget)\" ng-click=\"vm.widgetClicked($event, widget)\" tb-contextmenu=\"vm.openWidgetContextMenu($event, widget, $mdOpenMousepointMenu)\" ng-style=vm.widgetStyle(widget)> <div class=tb-widget-title layout=column layout-align=\"center start\" ng-show=vm.showWidgetTitlePanel(widget)> <div ng-if=vm.hasWidgetTitleTemplate(widget) ng-include=vm.widgetTitleTemplate(widget)></div> <span ng-show=vm.showWidgetTitle(widget) ng-style=vm.widgetTitleStyle(widget) class=md-subhead>{{vm.widgetTitle(widget)}}</span> <tb-timewindow aggregation={{vm.hasAggregation(widget)}} ng-if=vm.hasTimewindow(widget) ng-model=widget.config.timewindow></tb-timewindow> </div> <div class=tb-widget-actions layout=row layout-align=\"start center\" ng-show=vm.showWidgetActions(widget) tb-mousedown=$event.stopPropagation()> <md-button ng-repeat=\"action in vm.customWidgetHeaderActions(widget)\" aria-label={{action.displayName}} ng-show=!vm.isEdit ng-click=action.onAction($event) class=md-icon-button> <md-tooltip md-direction=\"{{vm.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{action.displayName}} </md-tooltip> <ng-md-icon size=20 icon={{action.icon}}></ng-md-icon> </md-button> <md-button ng-repeat=\"action in vm.widgetActions(widget)\" aria-label=\"{{ action.name | translate }}\" ng-show=\"!vm.isEdit && action.show\" ng-click=action.onAction($event) class=md-icon-button> <md-tooltip md-direction=\"{{vm.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{ action.name | translate }} </md-tooltip> <ng-md-icon size=20 icon={{action.icon}}></ng-md-icon> </md-button> <md-button id=expand-button ng-show=\"!vm.isEdit && vm.enableWidgetFullscreen(widget)\" aria-label=\"{{ 'fullscreen.fullscreen' | translate }}\" class=md-icon-button></md-button> <md-button ng-show=\"vm.isEditActionEnabled && !vm.isWidgetExpanded\" ng-disabled=vm.loading() class=md-icon-button ng-click=\"vm.editWidget($event, widget)\" aria-label=\"{{ 'widget.edit' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget.edit' | translate }} </md-tooltip> <ng-md-icon size=20 icon=edit></ng-md-icon> </md-button> <md-button ng-show=\"vm.isExportActionEnabled && !vm.isWidgetExpanded\" ng-disabled=vm.loading() class=md-icon-button ng-click=\"vm.exportWidget($event, widget)\" aria-label=\"{{ 'widget.export' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget.export' | translate }} </md-tooltip> <ng-md-icon size=20 icon=file_download></ng-md-icon> </md-button> <md-button ng-show=\"vm.isRemoveActionEnabled && !vm.isWidgetExpanded\" ng-disabled=vm.loading() class=md-icon-button ng-click=\"vm.removeWidget($event, widget)\" aria-label=\"{{ 'widget.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget.remove' | translate }} </md-tooltip> <ng-md-icon size=20 icon=close></ng-md-icon> </md-button> </div> <div flex layout=column class=tb-widget-content> <div flex tb-widget locals=\"{ visibleRect: vm.visibleRect,\n\t\t\t\t\t\t\t\t\t\t widget: widget,\n\t\t\t\t\t\t\t\t\t\t aliasController: vm.aliasController,\n\t\t\t\t\t\t\t\t\t\t stateController: vm.stateController,\n\t\t\t\t\t\t\t\t\t\t isEdit: vm.isEdit,\n\t\t\t\t\t\t\t\t\t\t isMobile: vm.isMobileSize,\n\t\t\t\t\t\t\t\t\t\t dashboardTimewindow: vm.dashboardTimewindow,\n\t\t\t\t\t\t\t\t\t\t dashboardTimewindowApi: vm.dashboardTimewindowApi,\n\t\t\t\t\t\t\t\t\t\t dashboard: vm }\"> </div> </div> </div> <md-menu-content id=menu width=4 ng-mouseleave=$mdCloseMousepointMenu()> <md-menu-item ng-repeat=\"item in vm.widgetContextMenuItems\"> <md-button ng-disabled=!item.enabled ng-click=\"item.action(vm.widgetContextMenuEvent, widget)\"> <span ng-if=item.shortcut class=tb-alt-text> {{ item.shortcut | keyboardShortcut }}</span> <md-icon ng-if=item.icon md-menu-align-target aria-label=\"{{ item.value | translate }}\" class=material-icons>{{item.icon}}</md-icon> <span translate>{{item.value}}</span> </md-button> </md-menu-item> </md-menu-content> </md-menu> </li> </ul> </div> </div> </md-content> <md-menu-content id=menu width=4 ng-mouseleave=$mdCloseMousepointMenu()> <md-menu-item ng-repeat=\"item in vm.contextMenuItems\"> <md-button ng-disabled=!item.enabled ng-click=item.action(vm.contextMenuEvent)> <span ng-if=item.shortcut class=tb-alt-text> {{ item.shortcut | keyboardShortcut }}</span> <md-icon ng-if=item.icon md-menu-align-target aria-label=\"{{ item.value | translate }}\" class=material-icons>{{item.icon}}</md-icon> <span translate>{{item.value}}</span> </md-button> </md-menu-item> </md-menu-content> </md-menu>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	var path = 'components/datakey-config.tpl.html';
	var html = " <md-content class=md-padding layout=column> <md-autocomplete ng-if=\"model.type === types.dataKeyType.timeseries ||\n    \t\t\t\t\t\tmodel.type === types.dataKeyType.attribute ||\n    \t\t\t\t\t\tmodel.type === types.dataKeyType.alarm\" style=padding-bottom:8px ng-required=true md-no-cache=true id=key ng-model=model.name md-selected-item=model.name md-search-text=keySearchText md-items=\"item in keysSearch(keySearchText)\" md-item-text=item md-min-length=0 placeholder=\"{{ 'entity.key-name' | translate }}\" md-floating-label=\"{{ 'entity.key' | translate }}\"> <span md-highlight-text=keySearchText md-highlight-flags=^i>{{item}}</span> </md-autocomplete> <div layout=row layout-align=\"start center\"> <md-input-container flex class=md-block> <label translate>datakey.label</label> <input ng-required=true name=label ng-model=model.label> </md-input-container> <div flex md-color-picker ng-required=true ng-model=model.color label=\"{{ 'datakey.color' | translate }}\" icon=format_color_fill default=#999 md-color-clear-button=false open-on-input=true md-color-generic-palette=false md-color-history=false> </div> </div> <div layout=row layout-align=\"start center\" ng-if=\"model.type !== types.dataKeyType.alarm\"> <md-input-container flex> <label translate>datakey.units</label> <input name=units ng-model=model.units> </md-input-container> <md-input-container flex> <label translate>datakey.decimals</label> <input name=decimals ng-model=model.decimals type=number min=0 max=15 step=1 ng-pattern=/^\\d*$/ > </md-input-container> </div> <section layout=column ng-if=\"model.type === types.dataKeyType.function\"> <span translate>datakey.data-generation-func</span> <br> <tb-js-func ng-model=model.funcBody function-args=\"{{ ['time', 'prevValue'] }}\" validation-args=\"{{ [[1, 1],[1, '1']] }}\" result-type=any> </tb-js-func> </section> <section layout=column ng-if=\"model.type === types.dataKeyType.timeseries || model.type === types.dataKeyType.attribute\"> <md-checkbox ng-model=model.usePostProcessing aria-label=\"{{ 'datakey.use-data-post-processing-func' | translate }}\"> {{ 'datakey.use-data-post-processing-func' | translate }} </md-checkbox> <tb-js-func ng-if=model.usePostProcessing ng-model=model.postFuncBody function-args=\"{{ ['time', 'value', 'prevValue'] }}\" validation-args=\"{{ [[1, 1, 1],[1, '1', '1']] }}\" result-type=any> </tb-js-func> </section> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	var path = 'components/datasource-entity.tpl.html';
	var html = " <section flex layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <tb-entity-alias-select tb-required=true alias-controller=aliasController ng-model=entityAlias on-create-entity-alias=\"onCreateEntityAlias({event: event, alias: alias})\"> </tb-entity-alias-select> <section flex layout=column> <section flex layout=column layout-align=center style=padding-left:4px> <md-chips flex ng-if=\"widgetType != types.widgetType.alarm.value\" id=timeseries_datakey_chips ng-required=true ng-model=timeseriesDataKeys md-autocomplete-snap md-transform-chip=transformTimeseriesDataKeyChip($chip) md-require-match=false> <md-autocomplete md-no-cache=true id=timeseries_datakey md-selected-item=selectedTimeseriesDataKey md-search-text=timeseriesDataKeySearchText md-items=\"item in dataKeysSearch(timeseriesDataKeySearchText, types.dataKeyType.timeseries)\" md-item-text=item.name md-min-length=0 placeholder=\"{{'datakey.timeseries' | translate }}\" md-menu-class=tb-timeseries-datakey-autocomplete> <span md-highlight-text=timeseriesDataKeySearchText md-highlight-flags=^i>{{item}}</span> <md-not-found> <div class=tb-not-found> <div class=tb-no-entries ng-if=!textIsNotEmpty(timeseriesDataKeySearchText)> <span translate>entity.no-keys-found</span> </div> <div ng-if=textIsNotEmpty(timeseriesDataKeySearchText)> <span translate translate-values='{ key: \"{{timeseriesDataKeySearchText | truncate:true:6:&apos;...&apos;}}\" }'>entity.no-key-matching</span> <span> <a translate ng-click=\"createKey($event, '#timeseries_datakey_chips')\">entity.create-new-key</a> </span> </div> </div> </md-not-found> </md-autocomplete> <md-chip-template> <div layout=row layout-align=\"start center\" class=tb-attribute-chip> <div class=tb-color-preview ng-click=\"showColorPicker($event, $chip, $index)\" style=margin-right:5px> <div class=tb-color-result ng-style=\"{background: $chip.color}\"></div> </div> <div layout=row> <div class=tb-chip-label> {{$chip.label}} </div> <div class=tb-chip-separator>: </div> <div class=tb-chip-label> <strong ng-if=!$chip.postFuncBody>{{$chip.name}}</strong> <strong ng-if=$chip.postFuncBody>f({{$chip.name}})</strong> </div> </div> <md-button ng-click=\"editDataKey($event, $chip, $index)\" class=\"md-icon-button tb-md-32\"> <md-icon aria-label=edit class=\"material-icons tb-md-20\">edit</md-icon> </md-button> </div> </md-chip-template> </md-chips> <md-chips flex ng-if=\"widgetType === types.widgetType.latest.value\" id=attribute_datakey_chips ng-required=true ng-model=attributeDataKeys md-autocomplete-snap md-transform-chip=transformAttributeDataKeyChip($chip) md-require-match=false> <md-autocomplete md-no-cache=true id=attribute_datakey md-selected-item=selectedAttributeDataKey md-search-text=attributeDataKeySearchText md-items=\"item in dataKeysSearch(attributeDataKeySearchText, types.dataKeyType.attribute)\" md-item-text=item.name md-min-length=0 placeholder=\"{{'datakey.attributes' | translate }}\" md-menu-class=tb-attribute-datakey-autocomplete> <span md-highlight-text=attributeDataKeySearchText md-highlight-flags=^i>{{item}}</span> <md-not-found> <div class=tb-not-found> <div class=tb-no-entries ng-if=!textIsNotEmpty(attributeDataKeySearchText)> <span translate>entity.no-keys-found</span> </div> <div ng-if=textIsNotEmpty(attributeDataKeySearchText)> <span translate translate-values='{ key: \"{{attributeDataKeySearchText | truncate:true:6:&apos;...&apos;}}\" }'>entity.no-key-matching</span> <span> <a translate ng-click=\"createKey($event, '#attribute_datakey_chips')\">entity.create-new-key</a> </span> </div> </div> </md-not-found> </md-autocomplete> <md-chip-template> <div layout=row layout-align=\"start center\" class=tb-attribute-chip> <div class=tb-color-preview ng-click=\"showColorPicker($event, $chip, $index)\" style=margin-right:5px> <div class=tb-color-result ng-style=\"{background: $chip.color}\"></div> </div> <div layout=row> <div class=tb-chip-label> {{$chip.label}} </div> <div class=tb-chip-separator>: </div> <div class=tb-chip-label> <strong ng-if=!$chip.postFuncBody>{{$chip.name}}</strong> <strong ng-if=$chip.postFuncBody>f({{$chip.name}})</strong> </div> </div> <md-button ng-click=\"editDataKey($event, $chip, $index)\" class=\"md-icon-button tb-md-32\"> <md-icon aria-label=edit class=\"material-icons tb-md-20\">edit</md-icon> </md-button> </div> </md-chip-template> </md-chips> <md-chips flex ng-if=\"widgetType == types.widgetType.alarm.value\" id=alarm_datakey_chips ng-required=true ng-model=alarmDataKeys md-autocomplete-snap md-transform-chip=transformAlarmDataKeyChip($chip) md-require-match=false> <md-autocomplete md-no-cache=true id=alarm_datakey md-selected-item=selectedAlarmDataKey md-search-text=alarmDataKeySearchText md-items=\"item in dataKeysSearch(alarmDataKeySearchText, types.dataKeyType.alarm)\" md-item-text=item.name md-min-length=0 placeholder=\"{{'datakey.alarm' | translate }}\" md-menu-class=tb-alarm-datakey-autocomplete> <span md-highlight-text=alarmDataKeySearchText md-highlight-flags=^i>{{item}}</span> <md-not-found> <div class=tb-not-found> <div class=tb-no-entries ng-if=!textIsNotEmpty(alarmDataKeySearchText)> <span translate>entity.no-keys-found</span> </div> <div ng-if=textIsNotEmpty(alarmDataKeySearchText)> <span translate translate-values='{ key: \"{{alarmDataKeySearchText | truncate:true:6:&apos;...&apos;}}\" }'>entity.no-key-matching</span> <span> <a translate ng-click=\"createKey($event, '#alarm_datakey_chips')\">entity.create-new-key</a> </span> </div> </div> </md-not-found> </md-autocomplete> <md-chip-template> <div layout=row layout-align=\"start center\" class=tb-attribute-chip> <div class=tb-color-preview ng-click=\"showColorPicker($event, $chip, $index)\" style=margin-right:5px> <div class=tb-color-result ng-style=\"{background: $chip.color}\"></div> </div> <div layout=row> <div class=tb-chip-label> {{$chip.label}} </div> <div class=tb-chip-separator>: </div> <div class=tb-chip-label> <strong ng-if=!$chip.postFuncBody>{{$chip.name}}</strong> <strong ng-if=$chip.postFuncBody>f({{$chip.name}})</strong> </div> </div> <md-button ng-click=\"editDataKey($event, $chip, $index)\" class=\"md-icon-button tb-md-32\"> <md-icon aria-label=edit class=\"material-icons tb-md-20\">edit</md-icon> </md-button> </div> </md-chip-template> </md-chips> </section> <div class=tb-error-messages ng-messages=ngModelCtrl.$error role=alert> <div translate ng-message=entityKeys ng-if=\"widgetType === types.widgetType.timeseries.value\" class=tb-error-message>datakey.timeseries-required</div> <div translate ng-message=entityKeys ng-if=\"widgetType === types.widgetType.latest.value\" class=tb-error-message>datakey.timeseries-or-attributes-required</div> <div translate ng-message=entityKeys ng-if=\"widgetType === types.widgetType.alarm.value\" class=tb-error-message>datakey.alarm-fields-required</div> </div> <div class=md-caption style=color:rgba(0,0,0,.57) ng-if=\"maxDataKeys > -1\" translate=datakey.maximum-timeseries-or-attributes translate-values=\"{count: maxDataKeys}\" translate-interpolation=messageformat></div> </section> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	var path = 'components/datasource-func.tpl.html';
	var html = " <section class=tb-datasource-func flex layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <md-input-container ng-show=\"widgetType != types.widgetType.alarm.value\" class=tb-datasource-name md-no-float style=min-width:200px> <input name=datasourceName placeholder=\"{{ 'datasource.name' | translate }}\" ng-model=datasourceName aria-label=\"{{ 'datasource.name' | translate }}\"> </md-input-container> <section flex layout=column style=padding-left:4px> <md-chips flex ng-if=\"widgetType != types.widgetType.alarm.value\" id=function_datakey_chips ng-required=true ng-model=funcDataKeys md-autocomplete-snap md-transform-chip=transformFuncDataKeyChip($chip) md-require-match=false> <md-autocomplete md-no-cache=false id=dataKey md-selected-item=selectedDataKey md-search-text=dataKeySearchText md-items=\"item in dataKeysSearch(dataKeySearchText)\" md-item-text=item.name md-min-length=0 placeholder=\"{{ 'datakey.function-types' | translate }}\" md-menu-class=tb-func-datakey-autocomplete> <span md-highlight-text=dataKeySearchText md-highlight-flags=^i>{{item}}</span> <md-not-found> <div class=tb-not-found> <div class=tb-no-entries ng-if=!textIsNotEmpty(dataKeySearchText)> <span translate>device.no-keys-found</span> </div> <div ng-if=textIsNotEmpty(dataKeySearchText)> <span translate translate-values='{ key: \"{{dataKeySearchText | truncate:true:6:&apos;...&apos;}}\" }'>entity.no-key-matching</span> <span> <a translate ng-click=\"createKey($event, '#function_datakey_chips')\">entity.create-new-key</a> </span> </div> </div> </md-not-found> </md-autocomplete> <md-chip-template> <div layout=row layout-align=\"start center\" class=tb-attribute-chip> <div class=tb-color-preview ng-click=\"showColorPicker($event, $chip, $index)\" style=margin-right:5px> <div class=tb-color-result ng-style=\"{background: $chip.color}\"></div> </div> <div layout=row> <div class=tb-chip-label> {{$chip.label}} </div> <div class=tb-chip-separator>: </div> <div class=tb-chip-label> <strong>{{$chip.name}}</strong> </div> </div> <md-button ng-click=\"editDataKey($event, $chip, $index)\" class=\"md-icon-button tb-md-32\"> <md-icon aria-label=edit class=\"material-icons tb-md-20\">edit</md-icon> </md-button> </div> </md-chip-template> </md-chips> <md-chips flex ng-if=\"widgetType == types.widgetType.alarm.value\" id=alarm_datakey_chips ng-required=true ng-model=alarmDataKeys md-autocomplete-snap md-transform-chip=transformAlarmDataKeyChip($chip) md-require-match=false> <md-autocomplete md-no-cache=true id=alarm_datakey md-selected-item=selectedAlarmDataKey md-search-text=alarmDataKeySearchText md-items=\"item in dataKeysSearch(alarmDataKeySearchText, types.dataKeyType.alarm)\" md-item-text=item.name md-min-length=0 placeholder=\"{{'datakey.alarm' | translate }}\" md-menu-class=tb-alarm-datakey-autocomplete> <span md-highlight-text=alarmDataKeySearchText md-highlight-flags=^i>{{item}}</span> <md-not-found> <div class=tb-not-found> <div class=tb-no-entries ng-if=!textIsNotEmpty(alarmDataKeySearchText)> <span translate>entity.no-keys-found</span> </div> <div ng-if=textIsNotEmpty(alarmDataKeySearchText)> <span translate translate-values='{ key: \"{{alarmDataKeySearchText | truncate:true:6:&apos;...&apos;}}\" }'>entity.no-key-matching</span> <span> <a translate ng-click=\"createKey($event, '#alarm_datakey_chips')\">entity.create-new-key</a> </span> </div> </div> </md-not-found> </md-autocomplete> <md-chip-template> <div layout=row layout-align=\"start center\" class=tb-attribute-chip> <div class=tb-color-preview ng-click=\"showColorPicker($event, $chip, $index)\" style=margin-right:5px> <div class=tb-color-result ng-style=\"{background: $chip.color}\"></div> </div> <div layout=row> <div class=tb-chip-label> {{$chip.label}} </div> <div class=tb-chip-separator>: </div> <div class=tb-chip-label> <strong ng-if=!$chip.postFuncBody>{{$chip.name}}</strong> <strong ng-if=$chip.postFuncBody>f({{$chip.name}})</strong> </div> </div> <md-button ng-click=\"editDataKey($event, $chip, $index)\" class=\"md-icon-button tb-md-32\"> <md-icon aria-label=edit class=\"material-icons tb-md-20\">edit</md-icon> </md-button> </div> </md-chip-template> </md-chips> <div class=tb-error-messages ng-messages=ngModelCtrl.$error role=alert> <div translate ng-message=datasourceKeys ng-if=\"widgetType !== types.widgetType.alarm.value\" class=tb-error-message>datakey.function-types-required</div> <div translate ng-message=datasourceKeys ng-if=\"widgetType === types.widgetType.alarm.value\" class=tb-error-message>datakey.alarm-fields-required</div> </div> <div class=md-caption style=color:rgba(0,0,0,.57) ng-if=\"maxDataKeys > -1\" translate=datakey.maximum-function-types translate-values=\"{count: maxDataKeys}\" translate-interpolation=messageformat></div> </section> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	var path = 'components/datasource.tpl.html';
	var html = " <section flex layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\" class=tb-datasource> <md-input-container style=min-width:110px> <md-select placeholder=\"{{ 'datasource.type' | translate }}\" required id=datasourceType ng-model=model.type> <md-option ng-repeat=\"datasourceType in datasourceTypes\" value={{datasourceType}}> {{ datasourceType | translate }} </md-option> </md-select> </md-input-container> <section flex class=datasource ng-switch on=model.type> <tb-datasource-func flex ng-switch-default ng-model=model max-data-keys=maxDataKeys opt-data-keys=optDataKeys datakey-settings-schema=datakeySettingsSchema ng-required=\"model.type === types.datasourceType.function\" widget-type=widgetType generate-data-key=\"generateDataKey({chip: chip, type: type})\"> </tb-datasource-func> <tb-datasource-entity flex ng-model=model max-data-keys=maxDataKeys opt-data-keys=optDataKeys datakey-settings-schema=datakeySettingsSchema ng-switch-when=entity ng-required=\"model.type === types.datasourceType.entity\" widget-type=widgetType alias-controller=aliasController generate-data-key=\"generateDataKey({chip: chip, type: type})\" fetch-entity-keys=\"fetchEntityKeys({entityAliasId: entityAliasId, query: query, type: type})\" on-create-entity-alias=\"onCreateEntityAlias({event: event, alias: alias})\"> </tb-datasource-entity> </section> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	var path = 'components/datetime-period.tpl.html';
	var html = " <section layout=column layout-align=\"start start\"> <section layout=row layout-align=\"start start\"> <mdp-date-picker ng-model=startDate mdp-placeholder=\"{{ 'datetime.date-from' | translate }}\"></mdp-date-picker> <mdp-time-picker ng-model=startDate mdp-placeholder=\"{{ 'datetime.time-from' | translate }}\" mdp-auto-switch=true></mdp-time-picker> </section> <section layout=row layout-align=\"start start\"> <mdp-date-picker ng-model=endDate mdp-placeholder=\"{{ 'datetime.date-to' | translate }}\"></mdp-date-picker> <mdp-time-picker ng-model=endDate mdp-placeholder=\"{{ 'datetime.time-to' | translate }}\" mdp-auto-switch=true></mdp-time-picker> </section> </section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	var path = 'components/details-sidenav.tpl.html';
	var html = " <md-sidenav class=\"md-sidenav-right md-whiteframe-4dp tb-sidenav-details\" md-disable-backdrop md-is-open=isOpen md-component-id=right layout=column> <header> <md-toolbar class=md-theme-light ng-style=\"{'height':headerHeightPx+'px'}\"> <div class=md-toolbar-tools layout=row> <div flex class=md-toolbar-tools layout=column layout-align=\"start start\"> <span class=tb-details-title>{{headerTitle}}</span> <span class=tb-details-subtitle>{{headerSubtitle}}</span> <span style=width:100% ng-transclude=headerPane></span> </div> <div ng-transclude=detailsButtons></div> <md-button class=md-icon-button ng-click=closeDetails()> <md-icon aria-label=close class=material-icons>close</md-icon> </md-button> </div> <section ng-if=!isReadOnly layout=row layout-wrap class=\"tb-header-buttons md-fab\"> <md-button ng-show=isEdit ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" class=\"tb-btn-header md-accent md-hue-2 md-fab md-fab-bottom-right\" aria-label=\"{{ 'action.apply' | translate }}\" ng-click=detailsApply()> <md-tooltip md-direction=top> {{ 'action.apply-changes' | translate }} </md-tooltip> <ng-md-icon icon=done></ng-md-icon> </md-button> <md-button ng-disabled=\"$root.loading || (isAlwaysEdit && !theForm.$dirty)\" class=\"tb-btn-header md-accent md-hue-2 md-fab md-fab-bottom-right\" aria-label=\"{{ 'details.edit-mode' | translate }}\" ng-click=toggleDetailsEditMode()> <md-tooltip md-direction=top> {{ (isAlwaysEdit ? 'action.decline-changes' : 'details.toggle-edit-mode') | translate }} </md-tooltip> <ng-md-icon icon=\"{{isEdit ? 'close' : 'edit'}}\" options='{\"easing\": \"circ-in-out\", \"duration\": 375, \"rotation\": \"none\"}'></ng-md-icon> </md-button> </section> </md-toolbar> </header> <md-content flex> <div ng-transclude></div> </md-content> </md-sidenav>\t";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	var path = 'components/entity-alias-select.tpl.html';
	var html = " <section layout=column> <md-autocomplete id=entity-autocomplete md-input-name=entity_alias ng-required=tbRequired md-no-cache=true ng-model=entityAlias md-selected-item=entityAlias md-search-text=entityAliasSearchText md-items=\"item in entityAliasSearch(entityAliasSearchText)\" md-item-text=item.alias tb-keydown=entityAliasEnter($event) tb-keypress=entityAliasEnter($event) md-min-length=0 placeholder=\"{{ 'entity.entity-alias' | translate }}\" md-menu-class=tb-entity-alias-autocomplete> <md-item-template> <span md-highlight-text=entityAliasSearchText md-highlight-flags=^i>{{item.alias}}</span> </md-item-template> <md-not-found> <div class=tb-not-found> <div class=tb-no-entries ng-if=!textIsNotEmpty(entityAliasSearchText)> <span translate>entity.no-aliases-found</span> </div> <div ng-if=textIsNotEmpty(entityAliasSearchText)> <span translate translate-values='{ alias: \"{{entityAliasSearchText | truncate:true:6:&apos;...&apos;}}\" }'>entity.no-alias-matching</span> <span> <a translate ng-click=\"createEntityAlias($event, entityAliasSearchText)\">entity.create-new-alias</a> </span> </div> </div> </md-not-found> </md-autocomplete> <div class=tb-error-messages ng-messages=ngModelCtrl.$error role=alert> <div translate ng-message=entityAlias class=tb-error-message>entity.alias-required</div> </div> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	var path = 'components/grid.tpl.html';
	var html = " <span layout-align=\"center center\" style=text-transform:uppercase;display:flex class=\"md-headline tb-absolute-fill\" ng-show=vm.noData()>{{vm.noItemsText()}}</span> <section layout=row flex style=height:100% flex layout-wrap> <div layout=column style=height:100% flex layout-wrap> <md-virtual-repeat-container ng-show=vm.hasData() tb-scope-element=repeatContainer id=tb-vertical-container md-top-index=vm.topIndex flex> <div class=md-padding layout=column> <section layout=row md-virtual-repeat=\"rowItem in vm.itemRows\" md-on-demand md-item-size=vm.itemHeight> <div flex ng-repeat=\"n in [] | range:vm.columns\" ng-style=\"{'height':vm.itemHeight+'px'}\" ng-if=rowItem[n]> <md-card ng-class=\"{'tb-current-item': vm.isCurrentItem(rowItem[n])}\" class=\"repeated-item tb-card-item\" ng-style=\"{'height':(vm.itemHeight-16)+'px','cursor':'pointer'}\" ng-click=\"vm.clickItemFunc($event, rowItem[n])\"> <section layout=row layout-wrap> <md-card-title layout=row> <section layout=column layout-wrap> <md-checkbox ng-if=vm.isSelectionEnabled(rowItem[n]) ng-click=\"vm.toggleItemSelection($event, rowItem[n])\" layout-align=\"start start\" aria-label=\"{{ 'item.selected' | translate }}\" ng-checked=rowItem[n].selected> </md-checkbox> <span flex></span> </section> <md-card-title-text> <span class=md-headline>{{vm.getItemTitleFunc(rowItem[n])}}</span> </md-card-title-text> </md-card-title> </section> <md-card-content flex> <tb-grid-card-content flex grid-ctl=vm parent-ctl=vm.parentCtl item-controller=vm.itemCardController item-template=vm.itemCardTemplate item=rowItem[n]></tb-grid-card-content> </md-card-content> <md-card-actions layout=row layout-align=\"end end\"> <md-button ng-if=action.isEnabled(rowItem[n]) ng-disabled=$root.loading class=\"md-icon-button md-primary\" ng-repeat=\"action in vm.actionsList\" ng-click=\"action.onAction($event, rowItem[n])\" aria-label=\"{{ action.name() }}\"> <md-tooltip md-direction=top> {{ action.details( rowItem[n] ) }} </md-tooltip> <ng-md-icon icon={{action.icon}}></ng-md-icon> </md-button> </md-card-actions> </md-card> </div> <div flex ng-repeat=\"n in [] | range:vm.columns\" ng-style=\"{'height':vm.itemHeight+'px'}\" ng-if=!rowItem[n]> </div> </section> </div> </md-virtual-repeat-container> </div> <tb-details-sidenav header-title={{vm.getItemTitleFunc(vm.operatingItem())}} header-subtitle={{vm.itemDetailsText(vm.operatingItem())}} is-read-only=vm.isDetailsReadOnly(vm.operatingItem()) is-open=vm.detailsConfig.isDetailsOpen is-edit=vm.detailsConfig.isDetailsEditMode on-close-details=vm.onCloseDetails() on-toggle-details-edit-mode=vm.onToggleDetailsEditMode(vm.detailsForm) on-apply-details=vm.saveItem(vm.detailsForm) the-form=vm.detailsForm> <details-buttons> <div ng-transclude=detailsButtons></div> </details-buttons> <form name=vm.detailsForm> <div ng-transclude></div> </form> </tb-details-sidenav> </section> <section layout=row layout-wrap class=\"tb-footer-buttons md-fab\" layout-align=\"start end\"> <md-button ng-disabled=$root.loading ng-show=\"vm.items.selectedCount > 0\" class=\"tb-btn-footer md-accent md-hue-2 md-fab\" ng-repeat=\"groupAction in vm.groupActionsList\" ng-click=\"groupAction.onAction($event, vm.items)\" aria-label=\"{{ groupAction.name() }}\"> <md-tooltip md-direction=top> {{ groupAction.details(vm.items.selectedCount) }} </md-tooltip> <ng-md-icon icon={{groupAction.icon}}></ng-md-icon> </md-button> <md-button ng-disabled=$root.loading ng-show=\"vm.topIndex > 0\" class=\"tb-btn-footer md-primary md-hue-1 md-fab\" ng-click=vm.moveToTop() aria-label=\"{{'grid.scroll-to-top' | translate}}\"> <md-tooltip md-direction=top> {{'grid.scroll-to-top' | translate}} </md-tooltip> <ng-md-icon icon=arrow_drop_up></ng-md-icon> </md-button> <md-button ng-disabled=$root.loading ng-if=\"vm.addItemAction.name() && vm.addItemActions.length == 0\" class=\"tb-btn-footer md-accent md-hue-2 md-fab\" ng-click=vm.addItemAction.onAction($event) aria-label=\"{{ vm.addItemAction.name() }}\"> <md-tooltip md-direction=top> {{ vm.addItemAction.details() }} </md-tooltip> <ng-md-icon icon=\"{{ vm.addItemAction.icon }}\"></ng-md-icon> </md-button> <md-fab-speed-dial ng-disabled=$root.loading ng-if=\"vm.addItemAction.name() && vm.addItemActions.length > 0\" md-open=vm.addItemActionsOpen class=md-scale md-direction=up ng-if=vm.addItemAction.name()> <md-fab-trigger> <md-button ng-disabled=$root.loading class=\"tb-btn-footer md-accent md-hue-2 md-fab\" aria-label=\"{{ vm.addItemAction.name() }}\"> <md-tooltip md-direction=top> {{ vm.addItemAction.details() }} </md-tooltip> <ng-md-icon icon=\"{{ vm.addItemAction.icon }}\"></ng-md-icon> </md-button> </md-fab-trigger> <md-fab-actions> <md-button ng-disabled=$root.loading class=\"md-accent md-hue-2 md-fab\" ng-repeat=\"addItemAction in vm.addItemActions\" ng-click=addItemAction.onAction($event) aria-label=\"{{ addItemAction.name() }}\"> <md-tooltip md-direction=top> {{ addItemAction.details() }} </md-tooltip> <ng-md-icon icon={{addItemAction.icon}}></ng-md-icon> </md-button> </md-fab-actions> </md-fab-speed-dial> </section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	var path = 'components/js-func.tpl.html';
	var html = " <div style=background:#fff ng-class=\"{'tb-disabled': disabled, 'fill-height': fillHeight}\" tb-expand-fullscreen fullscreen-zindex=100 expand-button-id=expand-button on-fullscreen-changed=onFullscreenChanged()> <div layout=row layout-align=\"start center\" style=height:40px class=tb-js-func-toolbar> <label class=\"tb-title no-padding\">function {{ functionName }}({{ functionArgsString }}) {</label> <span flex></span> <md-button ng-if=!disabled class=tidy aria-label=\"{{ 'js-func.tidy' | translate }}\" ng-click=beautifyJs()>{{ 'js-func.tidy' | translate }} </md-button> <div id=expand-button layout=column aria-label=Fullscreen class=\"md-button md-icon-button tb-md-32 tb-fullscreen-button-style\"></div> </div> <div id=tb-javascript-panel class=tb-js-func-panel> <div id=tb-javascript-input ng-class=\"{'fill-height': fillHeight}\" ui-ace=jsEditorOptions ng-readonly=disabled ng-model=functionBody> </div> </div> <div layout=row layout-align=\"start center\" style=height:40px> <label class=\"tb-title no-padding\">}</label> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	var path = 'components/json-content.tpl.html';
	var html = " <div style=background:#fff ng-class=\"{'fill-height': fillHeight}\" tb-expand-fullscreen fullscreen-zindex=100 expand-button-id=expand-button on-fullscreen-changed=onFullscreenChanged() layout=column> <div layout=row layout-align=\"start center\" style=height:40px class=tb-json-content-toolbar> <label class=\"tb-title no-padding\">{{ label }}</label> <span flex></span> <md-button ng-if=!readonly class=tidy aria-label=\"{{ 'js-func.tidy' | translate }}\" ng-click=beautifyJson()>{{ 'js-func.tidy' | translate }} </md-button> <md-button id=expand-button aria-label=Fullscreen class=\"md-icon-button tb-md-32 tb-fullscreen-button-style\"></md-button> </div> <div flex id=tb-json-panel class=tb-json-content-panel layout=column> <div flex id=tb-json-input ng-class=\"{'fill-height': fillHeight}\" ng-readonly=readonly ui-ace=jsonEditorOptions ng-model=contentBody> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	var path = 'components/json-form.tpl.html';
	var html = " <react-component name=ReactSchemaForm props=formProps watch-depth=value></react-component>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	var path = 'components/json-object-edit.tpl.html';
	var html = " <div style=background:#fff ng-class=\"{'fill-height': fillHeight}\" tb-expand-fullscreen fullscreen-zindex=100 expand-button-id=expand-button on-fullscreen-changed=onFullscreenChanged() layout=column> <div layout=row layout-align=\"start center\"> <label class=\"tb-title no-padding\" ng-class=\"{'tb-required': required,\n                          'tb-readonly': readonly,\n                          'tb-error': !objectValid}\">{{ label }}</label> <span flex></span> <md-button id=expand-button aria-label=Fullscreen class=\"md-icon-button tb-md-32 tb-fullscreen-button-style\"></md-button> </div> <div flex id=tb-json-panel class=tb-json-object-panel layout=column> <div flex id=tb-json-input ng-class=\"{'fill-height': fillHeight}\" ng-readonly=readonly ui-ace=jsonEditorOptions ng-model=contentBody> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	var path = 'components/kv-map.tpl.html';
	var html = " <section layout=column class=tb-kv-map> <label translate class=\"tb-title no-padding\">{{ vm.titleText }}</label> <div layout=row ng-repeat=\"keyVal in vm.kvList track by $index\" style=max-height:40px layout-align=\"start center\"> <md-input-container flex md-no-float class=md-block style=\"margin:10px 0 0 0;max-height:40px\"> <input placeholder=\"{{ (vm.keyPlaceholderText ? vm.keyPlaceholderText : 'key-val.key') | translate }}\" ng-disabled=vm.disabled ng-required=true name=key ng-model=keyVal.key> </md-input-container> <md-input-container flex md-no-float class=md-block style=\"margin:10px 0 0 0;max-height:40px\"> <input placeholder=\"{{ (vm.valuePlaceholderText ? vm.valuePlaceholderText : 'key-val.value') | translate }}\" ng-disabled=vm.disabled ng-required=true name=value ng-model=keyVal.value> </md-input-container> <md-button ng-show=!vm.disabled ng-disabled=$root.loading class=\"md-icon-button md-primary\" ng-click=vm.removeKeyVal($index) aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'key-val.remove-entry' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.delete' | translate }}\" class=material-icons> close </md-icon> </md-button> </div> <span ng-show=!vm.kvList.length layout-align=\"center center\" ng-class=\"{'disabled': vm.disabled}\" class=no-data-found translate>{{vm.noDataText ? vm.noDataText : 'key-val.no-data'}}</span> <div> <md-button ng-show=!vm.disabled ng-disabled=$root.loading class=\"md-primary md-raised\" ng-click=vm.addKeyVal() aria-label=\"{{ 'action.add' | translate }}\"> <md-tooltip md-direction=top> {{ 'key-val.add-entry' | translate }} </md-tooltip> <span translate>action.add</span> </md-button> </div> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	var path = 'components/legend-config-button.tpl.html';
	var html = " <md-button ng-disabled=disabled class=\"md-raised md-primary\" ng-click=openEditMode($event)> <ng-md-icon icon=toc></ng-md-icon> <span translate>legend.settings</span> </md-button> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	var path = 'components/legend-config-panel.tpl.html';
	var html = " <form name=theForm ng-submit=vm.update()> <fieldset ng-disabled=$root.loading> <md-content style=height:100% flex layout=column> <section layout=column> <md-content class=md-padding layout=column> <md-input-container> <label translate>legend.position</label> <md-select ng-model=vm.legendConfig.position style=min-width:150px> <md-option ng-repeat=\"pos in vm.positions\" ng-value=pos.value> {{pos.name | translate}} </md-option> </md-select> </md-input-container> <md-checkbox flex aria-label=\"{{ 'legend.show-min' | translate }}\" ng-model=vm.legendConfig.showMin>{{ 'legend.show-min' | translate }} </md-checkbox> <md-checkbox flex aria-label=\"{{ 'legend.show-max' | translate }}\" ng-model=vm.legendConfig.showMax>{{ 'legend.show-max' | translate }} </md-checkbox> <md-checkbox flex aria-label=\"{{ 'legend.show-avg' | translate }}\" ng-model=vm.legendConfig.showAvg>{{ 'legend.show-avg' | translate }} </md-checkbox> <md-checkbox flex aria-label=\"{{ 'legend.show-total' | translate }}\" ng-model=vm.legendConfig.showTotal>{{ 'legend.show-total' | translate }} </md-checkbox> </md-content> </section> </md-content> </fieldset> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	var path = 'components/legend.tpl.html';
	var html = " <table class=tb-legend> <thead> <tr class=tb-legend-header> <th colspan=2></th> <th ng-if=\"legendConfig.showMin === true\">{{ 'legend.min' | translate }}</th> <th ng-if=\"legendConfig.showMax === true\">{{ 'legend.max' | translate }}</th> <th ng-if=\"legendConfig.showAvg === true\">{{ 'legend.avg' | translate }}</th> <th ng-if=\"legendConfig.showTotal === true\">{{ 'legend.total' | translate }}</th> </tr> </thead> <tbody> <tr class=tb-legend-keys ng-repeat=\"legendKey in legendData.keys\"> <td><span class=tb-legend-line ng-style=\"{backgroundColor: legendKey.dataKey.color}\"></span></td> <td class=tb-legend-label ng-click=toggleHideData(legendKey.dataIndex) ng-class=\"{ 'tb-hidden-label': legendData.keys[legendKey.dataIndex].dataKey.hidden, 'tb-horizontal': isHorizontal }\"> {{ legendKey.dataKey.label }} </td> <td class=tb-legend-value ng-if=\"legendConfig.showMin === true\">{{ legendData.data[legendKey.dataIndex].min }}</td> <td class=tb-legend-value ng-if=\"legendConfig.showMax === true\">{{ legendData.data[legendKey.dataIndex].max }}</td> <td class=tb-legend-value ng-if=\"legendConfig.showAvg === true\">{{ legendData.data[legendKey.dataIndex].avg }}</td> <td class=tb-legend-value ng-if=\"legendConfig.showTotal === true\">{{ legendData.data[legendKey.dataIndex].total }}</td> </tr> </tbody> </table> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	var path = 'components/material-icon-select.tpl.html';
	var html = " <div class=tb-material-icon-select layout=row> <md-icon class=material-icons ng-click=openIconDialog($event)>{{icon}}</md-icon> <md-input-container flex> <label translate>icon.icon</label> <input ng-mousedown=openIconDialog($event) ng-model=icon> </md-input-container> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	var path = 'components/material-icons-dialog.tpl.html';
	var html = " <md-dialog class=tb-material-icons-dialog aria-label=\"{{'icon.material-icons' | translate }}\" style=min-width:600px> <form> <md-toolbar> <div class=md-toolbar-tools> <h2>{{ 'icon.select-icon' | translate }}</h2> <span flex></span> <section layout=row layout-align=\"start center\"> <md-switch ng-model=vm.showAll aria-label=\"{{ 'icon.show-all' | translate }}\"> </md-switch> <label translate>icon.show-all</label> </section> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'action.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <div class=\"tb-absolute-fill tb-icons-load\" ng-show=vm.loadingIcons layout=column layout-align=\"center center\"> <md-progress-circular md-mode=indeterminate ng-disabled=!vm.loadingIcons class=md-accent md-diameter=40></md-progress-circular> </div> <md-dialog-content> <div class=md-dialog-content> <md-content class=md-padding layout=column> <fieldset ng-disabled=$root.loading> <md-button ng-class=\"{'md-primary md-raised': icon == vm.selectedIcon}\" class=\"tb-select-icon-button md-icon-button\" ng-repeat=\"icon in vm.icons\" ng-click=\"vm.selectIcon($event, icon)\" tb-on-finish-render=iconsLoadFinished> <md-icon class=material-icons>{{icon}}</md-icon> <md-tooltip md-direction=bottom> {{ icon }} </md-tooltip> </md-button> </fieldset> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=$root.loading ng-click=vm.cancel()> {{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	var path = 'components/menu-link.tpl.html';
	var html = " <md-button ui-sref-active-eq=tb-active ui-sref={{section.state}}> <md-icon ng-show=\"section.icon != null\" aria-label={{section.icon}} class=material-icons>{{section.icon}}</md-icon> {{section.name | translate}} </md-button>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	var path = 'components/menu-toggle.tpl.html';
	var html = " <md-button ui-sref-active-eq=tb-active ui-sref={{section.state}} class=md-button-toggle aria-controls=\"docs-menu-{{section.name | nospace}}\" layout=row aria-expanded={{sectionActive()}}> <md-icon ng-show=\"section.icon != null\" aria-label={{section.icon}} class=material-icons>{{section.icon}}</md-icon> <span flex>{{section.name | translate}}</span> <span aria-hidden=true class=\"pull-right fa fa-chevron-down md-toggle-icon\" ng-class=\"{'tb-toggled' : sectionActive()}\"></span> </md-button> <ul id=\"docs-menu-{{section.name | nospace}}\" class=tb-menu-toggle-list ng-style=\"{height: sectionHeight()}\"> <li ng-repeat=\"page in section.pages\"> <tb-menu-link section=page></tb-menu-link> </li> </ul> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

	var path = 'components/related-entity-autocomplete.tpl.html';
	var html = " <md-autocomplete ng-required=tbRequired ng-disabled=disabled md-input-name=entity ng-model=entity md-selected-item=entity md-search-text=entitySearchText md-search-text-change=entitySearchTextChanged() md-items=\"item in fetchEntities(entitySearchText)\" md-item-text=item.name md-min-length=0 md-floating-label=\"{{ placeholderText | translate }}\" md-menu-class=tb-related-entity-autocomplete> <md-item-template> <div class=tb-entity-item> <span md-highlight-text=entitySearchText md-highlight-flags=^i>{{item.name}}</span> </div> </md-item-template> <md-not-found> <div class=tb-not-found> <span>{{ notFoundText | translate:{entity: entitySearchText} }}</span> </div> </md-not-found> <div ng-messages=theForm.entity.$error> <div ng-message=required>{{ requiredText | translate }}</div> </div> </md-autocomplete> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

	var path = 'components/side-menu.tpl.html';
	var html = " <ul flex layout=column layout-align=\"start stretch\" class=tb-side-menu> <li ng-repeat=\"section in sections\" class=parent-list-item ng-class=\"{'parentActive' : isOpen(section)}\"> <tb-menu-link section=section></tb-menu-link> </li> </ul>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

	var path = 'components/socialshare-panel.tpl.html';
	var html = " <div layout=row ng-show=!vm.isShareLinkLocal()> <md-button class=\"md-icon-button md-raised md-primary\" socialshare socialshare-provider=facebook socialshare-title=\"{{ vm.shareTitle }}\" socialshare-text=\"{{ vm.shareText }}\" socialshare-url=\"{{ vm.shareLink }}\"> <ng-md-icon icon=facebook aria-label=Facebook></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.share-via' | translate:{provider:'Facebook'} }} </md-tooltip> </md-button> <md-button class=\"md-icon-button md-raised md-primary\" socialshare socialshare-provider=twitter socialshare-text=\"{{ vm.shareTitle }}\" socialshare-hashtags=\"{{ vm.shareHashTags }}\" socialshare-url=\"{{ vm.shareLink }}\"> <ng-md-icon icon=twitter aria-label=Twitter></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.share-via' | translate:{provider:'Twitter'} }} </md-tooltip> </md-button> <md-button class=\"md-icon-button md-raised md-primary\" socialshare socialshare-provider=linkedin socialshare-text=\"{{ vm.shareTitle }}\" socialshare-url=\"{{ vm.shareLink }}\"> <ng-md-icon icon=linkedin aria-label=Linkedin></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.share-via' | translate:{provider:'Linkedin'} }} </md-tooltip> </md-button> <md-button class=\"md-icon-button md-raised md-primary\" socialshare socialshare-provider=reddit socialshare-text=\"{{ vm.shareTitle }}\" socialshare-url=\"{{ vm.shareLink }}\"> <md-icon md-svg-icon=mdi:reddit aria-label=Reddit></md-icon> <md-tooltip md-direction=top> {{ 'action.share-via' | translate:{provider:'Reddit'} }} </md-tooltip> </md-button> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	var path = 'components/timeinterval.tpl.html';
	var html = " <section layout=row> <section layout=column flex ng-show=advanced> <label class=tb-small translate>{{ predefinedName }}</label> <section layout=row layout-align=\"start start\" flex> <md-input-container> <label translate>timeinterval.days</label> <input type=number ng-model=days step=1 aria-label=\"{{ 'timeinterval.days' | translate }}\"> </md-input-container> <md-input-container> <label translate>timeinterval.hours</label> <input type=number ng-model=hours step=1 aria-label=\"{{ 'timeinterval.hours' | translate }}\"> </md-input-container> <md-input-container> <label translate>timeinterval.minutes</label> <input type=number ng-model=mins step=1 aria-label=\"{{ 'timeinterval.minutes' | translate }}\"> </md-input-container> <md-input-container> <label translate>timeinterval.seconds</label> <input type=number ng-model=secs step=1 aria-label=\"{{ 'timeinterval.seconds' | translate }}\"> </md-input-container> </section> </section> <section layout=row flex ng-show=!advanced> <md-input-container flex> <label translate>{{ predefinedName }}</label> <md-select ng-model=intervalMs style=min-width:150px aria-label=predefined-interval> <md-option ng-repeat=\"interval in intervals\" ng-value=interval.value> {{interval.name}} </md-option> </md-select> </md-input-container> </section> <section layout=column layout-align=\"center center\"> <label class=\"tb-small advanced-label\" translate>timeinterval.advanced</label> <md-switch class=advanced-switch ng-model=advanced aria-label=predefined-switcher> </md-switch> </section> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

	var path = 'components/timewindow-button.tpl.html';
	var html = " <md-button ng-disabled=disabled class=\"md-raised md-primary\" ng-click=openEditMode($event)> <ng-md-icon icon=query_builder></ng-md-icon> <span>{{model.displayValue}}</span> </md-button>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	var path = 'components/timewindow-panel.tpl.html';
	var html = " <form name=theForm ng-submit=vm.update()> <fieldset ng-disabled=$root.loading> <md-content style=height:100% flex layout=column> <section layout=column> <md-tabs ng-class=\"{'tb-headless': vm.historyOnly}\" md-dynamic-height md-selected=vm.timewindow.selectedTab md-border-bottom> <md-tab label=\"{{ 'timewindow.realtime' | translate }}\"> <md-content class=md-padding layout=column> <tb-timeinterval predefined-name=\"'timewindow.last'\" ng-required=\"vm.timewindow.selectedTab === 0\" ng-model=vm.timewindow.realtime.timewindowMs style=padding-top:8px></tb-timeinterval> </md-content> </md-tab> <md-tab label=\"{{ 'timewindow.history' | translate }}\"> <md-content class=md-padding layout=column style=padding-top:8px> <md-radio-group ng-model=vm.timewindow.history.historyType class=md-primary> <md-radio-button ng-value=0 aria-label=\"{{ 'timewindow.last' | translate }}\" class=\"md-primary md-align-top-left md-radio-interactive\"> <section layout=column> <tb-timeinterval predefined-name=\"'timewindow.last'\" ng-required=\"vm.timewindow.selectedTab === 1 && vm.timewindow.history.historyType === 0\" ng-show=\"vm.timewindow.history.historyType === 0\" ng-model=vm.timewindow.history.timewindowMs style=padding-top:8px></tb-timeinterval> </section> </md-radio-button> <md-radio-button ng-value=1 aria-label=\"{{ 'timewindow.time-period' | translate }}\" class=\"md-primary md-align-top-left md-radio-interactive\"> <section layout=column> <span translate>timewindow.time-period</span> <tb-datetime-period ng-required=\"vm.timewindow.selectedTab === 1 && vm.timewindow.history.historyType === 1\" ng-show=\"vm.timewindow.history.historyType === 1\" ng-model=vm.timewindow.history.fixedTimewindow style=padding-top:8px></tb-datetime-period> </section> </md-radio-button> </md-radio-group> </md-content> </md-tab> </md-tabs> <md-content ng-if=vm.aggregation class=md-padding layout=column> <md-input-container> <label translate>aggregation.function</label> <md-select ng-model=vm.timewindow.aggregation.type style=min-width:150px> <md-option ng-repeat=\"type in vm.aggregationTypes\" ng-value=type.value> {{type.name | translate}} </md-option> </md-select> </md-input-container> <md-slider-container ng-if=vm.showLimit()> <span translate>aggregation.limit</span> <md-slider flex min={{vm.minDatapointsLimit()}} max={{vm.maxDatapointsLimit()}} step=1 ng-model=vm.timewindow.aggregation.limit aria-label=limit id=limit-slider> </md-slider> <md-input-container style=max-width:80px> <input flex type=number step=1 min={{vm.minDatapointsLimit()}} max={{vm.maxDatapointsLimit()}} ng-model=vm.timewindow.aggregation.limit aria-label=limit aria-controls=limit-slider> </md-input-container> </md-slider-container> <tb-timeinterval ng-if=vm.showRealtimeAggInterval() min=vm.minRealtimeAggInterval() max=vm.maxRealtimeAggInterval() predefined-name=\"'aggregation.group-interval'\" ng-model=vm.timewindow.realtime.interval> </tb-timeinterval> <tb-timeinterval ng-if=vm.showHistoryAggInterval() min=vm.minHistoryAggInterval() max=vm.maxHistoryAggInterval() predefined-name=\"'aggregation.group-interval'\" ng-model=vm.timewindow.history.interval> </tb-timeinterval> </md-content> </section> <span flex></span> <section layout=row layout-alignment=\"start center\"> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.update' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px> {{ 'action.cancel' | translate }} </md-button> </section> </md-content> </fieldset> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	var path = 'components/timewindow.tpl.html';
	var html = " <section class=tb-timewindow layout=row layout-align=\"start center\"> <md-button ng-if=\"direction === 'left'\" ng-disabled=disabled class=\"md-icon-button tb-md-32\" aria-label=\"{{ 'timewindow.edit' | translate }}\" ng-click=openEditMode($event)> <md-tooltip md-direction={{tooltipDirection}}> {{ 'timewindow.edit' | translate }} </md-tooltip> <ng-md-icon aria-label=\"{{ 'timewindow.date-range' | translate }}\" icon=query_builder></ng-md-icon> </md-button> <span ng-hide=hideLabel() ng-click=openEditMode($event)> <md-tooltip md-direction={{tooltipDirection}}> {{ 'timewindow.edit' | translate }} </md-tooltip> {{model.displayValue}} </span> <md-button ng-if=\"direction === 'right'\" ng-disabled=disabled class=\"md-icon-button tb-md-32\" aria-label=\"{{ 'timewindow.edit' | translate }}\" ng-click=openEditMode($event)> <md-tooltip md-direction={{tooltipDirection}}> {{ 'timewindow.edit' | translate }} </md-tooltip> <ng-md-icon aria-label=\"{{ 'timewindow.date-range' | translate }}\" icon=query_builder></ng-md-icon> </md-button> </section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	var path = 'components/widget/action/manage-widget-actions.tpl.html';
	var html = " <div ng-form=manageWidgetActionsForm class=\"tb-manage-widget-actions md-whiteframe-z1 toolbarsContainer\" layout=column> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"vm.query.search === null\"> <div class=md-toolbar-tools> <span translate>widget-config.actions</span> <span flex></span> <md-button class=md-icon-button ng-click=vm.addAction($event)> <md-icon>add</md-icon> <md-tooltip md-direction=top> {{ 'widget-config.add-action' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=vm.enterFilterMode($event)> <md-icon>search</md-icon> <md-tooltip md-direction=top> {{ 'action.search' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"vm.query.search != null\"> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=top> {{ 'widget-config.search-actions' | translate }} </md-tooltip> </md-button> <md-input-container flex> <label>&nbsp;</label> <input ng-model=vm.query.search class=searchInput name=querySearchInput placeholder=\"{{ 'widget-config.search-actions' | translate }}\"> </md-input-container> <md-button class=md-icon-button aria-label=Close ng-click=vm.exitFilterMode()> <md-icon aria-label=Close class=material-icons>close</md-icon> <md-tooltip md-direction=top> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-table-container> <table md-table> <thead md-head md-order=vm.query.order md-on-reorder=vm.onReorder> <tr md-row> <th md-column md-order-by=actionSourceName><span translate>widget-config.action-source</span></th> <th md-column md-order-by=name><span translate>widget-config.action-name</span></th> <th md-column md-order-by=icon><span translate>widget-config.action-icon</span></th> <th md-column md-order-by=typeName><span translate>widget-config.action-type</span></th> <th md-column><span>&nbsp</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"action in vm.actions\"> <td md-cell>{{action.actionSourceName}}</td> <td md-cell>{{action.name}}</td> <td md-cell> <md-icon aria-label=\"{{ 'widget-config.action-icon' | translate }}\" class=material-icons>{{action.icon}}</md-icon> </td> <td md-cell>{{action.typeName}}</td> <td md-cell class=tb-action-cell> <md-button class=md-icon-button aria-label=\"{{ 'action.edit' | translate }}\" ng-click=\"vm.editAction($event, action)\"> <md-icon aria-label=\"{{ 'action.edit' | translate }}\" class=material-icons>edit</md-icon> <md-tooltip md-direction=top> {{ 'widget-config.edit-action' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button aria-label=\"{{'action.delete' | translate}}\" ng-click=\"vm.deleteAction($event, action)\"> <md-icon aria-label=Delete class=material-icons>delete</md-icon> <md-tooltip md-direction=top> {{ 'widget-config.delete-action' | translate }} </md-tooltip> </md-button> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=vm.query.limit md-limit-options=\"[10, 15, 20]\" md-page=vm.query.page md-total={{vm.actionsCount}} md-on-paginate=vm.onPaginate md-page-select> </md-table-pagination> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	var path = 'components/widget/action/widget-action-dialog.tpl.html';
	var html = " <md-dialog class=tb-widget-action-dialog aria-label=\"{{'widget-config.action' | translate }}\" style=min-width:600px> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2>{{ (vm.isAdd ? 'widget-config.add-action' : 'widget-config.edit-action') | translate }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'action.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <md-content class=md-padding layout=column> <fieldset ng-disabled=$root.loading layout=column> <md-input-container class=md-block> <label translate>widget-config.action-source</label> <md-select name=actionSource required aria-label=\"{{ 'widget-config.action-source' | translate }}\" ng-model=vm.action.actionSourceId> <md-option ng-repeat=\"(actionSourceId, actionSource) in vm.actionSources\" ng-value=actionSourceId> {{vm.actionSourceName(actionSource)}} </md-option> </md-select> <div ng-messages=theForm.actionSource.$error> <div ng-message=required translate>widget-config.action-source-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>widget-config.action-name</label> <input name=name required ng-model=vm.action.name> <div ng-messages=theForm.name.$error> <div ng-message=required translate>widget-config.action-name-required</div> <div ng-message=actionNameNotUnique translate>widget-config.action-name-not-unique</div> </div> </md-input-container> <tb-material-icon-select ng-model=vm.action.icon> </tb-material-icon-select> <md-input-container class=md-block> <label translate>widget-config.action-type</label> <md-select name=actionType required aria-label=\"{{ 'widget-config.action-type' | translate }}\" ng-model=vm.action.type> <md-option ng-repeat=\"actionType in vm.types.widgetActionTypes\" ng-value=actionType.value> {{ actionType.name | translate }} </md-option> </md-select> <div ng-messages=theForm.actionType.$error> <div ng-message=required translate>widget-config.action-type-required</div> </div> </md-input-container> <div layout=column style=padding-bottom:20px ng-if=\"vm.action.type == vm.types.widgetActionTypes.openDashboard.value\"> <div class=\"md-caption tb-required\" style=padding-left:3px;padding-bottom:10px;color:rgba(0,0,0,.57) translate>widget-action.target-dashboard</div> <tb-dashboard-autocomplete the-form=theForm tb-required=true ng-model=vm.action.targetDashboardId select-first-dashboard=false> </tb-dashboard-autocomplete> </div> <md-autocomplete ng-if=\"vm.action.type == vm.types.widgetActionTypes.openDashboardState.value ||\n                                                vm.action.type == vm.types.widgetActionTypes.updateDashboardState.value ||\n                                                vm.action.type == vm.types.widgetActionTypes.openDashboard.value\" ng-required=\"vm.action.type == vm.types.widgetActionTypes.openDashboardState.value\" md-no-cache=true md-input-name=targetDashboardState ng-model=vm.action.targetDashboardStateId md-selected-item=vm.action.targetDashboardStateId md-search-text=vm.targetDashboardStateSearchText md-search-text-change=vm.targetDashboardStateSearchTextChanged() md-items=\"item in vm.dashboardStateSearch(vm.targetDashboardStateSearchText)\" md-item-text=item md-min-length=0 md-floating-label=\"{{ 'widget-action.target-dashboard-state' | translate }}\" md-select-on-match=true> <md-item-template> <div> <span md-highlight-text=vm.targetDashboardStateSearchText md-highlight-flags=^i>{{item}}</span> </div> </md-item-template> <div ng-messages=theForm.targetDashboardState.$error> <div translate ng-message=required>widget-action.target-dashboard-state-required</div> </div> </md-autocomplete> <md-checkbox ng-if=\"vm.action.type == vm.types.widgetActionTypes.openDashboardState.value ||\n                                            vm.action.type == vm.types.widgetActionTypes.updateDashboardState.value\" flex aria-label=\"{{ 'widget-action.open-right-layout' | translate }}\" ng-model=vm.action.openRightLayout>{{ 'widget-action.open-right-layout' | translate }} </md-checkbox> <div flex layout=column ng-if=\"vm.action.type == vm.types.widgetActionTypes.openDashboardState.value ||\n                                                vm.action.type == vm.types.widgetActionTypes.updateDashboardState.value ||\n                                                vm.action.type == vm.types.widgetActionTypes.openDashboard.value\"> <md-checkbox flex aria-label=\"{{ 'widget-action.set-entity-from-widget' | translate }}\" ng-model=vm.action.setEntityId>{{ 'widget-action.set-entity-from-widget' | translate }} </md-checkbox> <md-input-container ng-if=vm.action.setEntityId class=md-block> <label translate>alias.state-entity-parameter-name</label> <input name=stateEntityParamName placeholder=\"{{ 'alias.default-entity-parameter-name' | translate }}\" ng-model=vm.action.stateEntityParamName aria-label=\"{{ 'alias.state-entity-parameter-name' | translate }}\"> </md-input-container> </div> <tb-js-func ng-if=\"vm.action.type == vm.types.widgetActionTypes.custom.value\" ng-model=vm.action.customFunction function-args=\"{{ ['$event', 'widgetContext', 'entityId', 'entityName', 'additionalParams'] }}\" validation-args=\"{{ [] }}\"> </tb-js-func> </fieldset> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ (vm.isAdd ? 'action.add' : 'action.save') | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px> {{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	var path = 'components/widget/widget-config.tpl.html';
	var html = " <md-tabs ng-class=\"{'tb-headless': (widgetType === types.widgetType.static.value && !displayAdvanced())}\" id=tabs md-border-bottom flex class=\"tb-widget-config tb-absolute-fill\" md-selected=selectedTab> <md-tab label=\"{{ 'widget-config.data' | translate }}\" ng-show=\"widgetType !== types.widgetType.static.value\"> <md-content class=md-padding layout=column> <div ng-show=\"widgetType === types.widgetType.timeseries.value || widgetType === types.widgetType.alarm.value\" layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <md-checkbox flex aria-label=\"{{ 'widget-config.use-dashboard-timewindow' | translate }}\" ng-model=useDashboardTimewindow>{{ 'widget-config.use-dashboard-timewindow' | translate }} </md-checkbox> <section flex layout=row layout-align=\"start center\" style=margin-bottom:16px> <span ng-class=\"{'tb-disabled-label': useDashboardTimewindow}\" translate style=padding-right:8px>widget-config.timewindow</span> <tb-timewindow ng-disabled=useDashboardTimewindow as-button=true aggregation=\"{{ widgetType === types.widgetType.timeseries.value }}\" flex ng-model=timewindow></tb-timewindow> </section> </div> <div ng-show=\"widgetType === types.widgetType.alarm.value\" layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <md-input-container class=md-block flex> <label translate>alarm.alarm-status</label> <md-select ng-model=alarmSearchStatus style=padding-bottom:24px> <md-option ng-repeat=\"searchStatus in types.alarmSearchStatus\" ng-value=searchStatus> {{ ('alarm.search-status.' + searchStatus) | translate }} </md-option> </md-select> </md-input-container> <md-input-container flex class=md-block> <label translate>alarm.polling-interval</label> <input ng-required=\"widgetType === types.widgetType.alarm.value\" type=number step=1 min=1 name=alarmsPollingInterval ng-model=alarmsPollingInterval> <div ng-messages=theForm.alarmsPollingInterval.$error multiple=multiple md-auto-hide=false> <div ng-message=required translate>alarm.polling-interval-required</div> <div ng-message=min translate>alarm.min-polling-interval-message</div> </div> </md-input-container> </div> <v-accordion id=datasources-accordion control=datasourcesAccordion class=vAccordion--default ng-show=\"widgetType !== types.widgetType.rpc.value\n                         && widgetType !== types.widgetType.alarm.value\n                         && widgetType !== types.widgetType.static.value\n                         && isDataEnabled\"> <v-pane id=datasources-pane expanded=true> <v-pane-header> <div layout=column> <div>{{ 'widget-config.datasources' | translate }}</div> <div class=md-caption style=color:rgba(0,0,0,.57) ng-if=\"typeParameters.maxDatasources > -1\" translate=widget-config.maximum-datasources translate-values=\"{count: typeParameters.maxDatasources}\" translate-interpolation=messageformat></div> </div> </v-pane-header> <v-pane-content> <div ng-if=\"datasources.length === 0\"> <span translate layout-align=\"center center\" class=tb-prompt>datasource.add-datasource-prompt</span> </div> <div ng-if=\"datasources.length > 0\"> <div flex layout=row layout-align=\"start center\"> <span flex=5></span> <div flex layout=row layout-align=\"start center\" style=\"padding:0 0 0 10px;margin:5px\"> <span translate style=min-width:110px>widget-config.datasource-type</span> <span hide show-gt-sm translate flex style=padding-left:10px>widget-config.datasource-parameters</span> <span style=min-width:40px></span> </div> </div> <div style=overflow:auto;padding-bottom:15px> <div flex layout=row layout-align=\"start center\" ng-repeat=\"datasource in datasources\"> <span flex=5>{{$index + 1}}.</span> <div class=md-whiteframe-4dp flex layout=row layout-align=\"start center\" style=\"padding:0 0 0 10px;margin:5px\"> <tb-datasource flex ng-model=datasource.value widget-type=widgetType max-data-keys=typeParameters.maxDataKeys opt-data-keys=typeParameters.dataKeysOptional alias-controller=aliasController functions-only=functionsOnly datakey-settings-schema=datakeySettingsSchema generate-data-key=generateDataKey(chip,type) fetch-entity-keys=\"fetchEntityKeys({entityAliasId: entityAliasId, query: query, type: type})\" on-create-entity-alias=\"onCreateEntityAlias({event: event, alias: alias})\"></tb-datasource> <md-button ng-disabled=$root.loading class=\"md-icon-button md-primary\" style=min-width:40px ng-click=\"removeDatasource($event, datasource)\" aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget-config.remove-datasource' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.delete' | translate }}\" class=material-icons> close </md-icon> </md-button> </div> </div> </div> </div> <div flex layout=row layout-align=\"start center\"> <md-button ng-show=\"typeParameters.maxDatasources == -1 || datasources.length < typeParameters.maxDatasources\" ng-disabled=$root.loading class=\"md-primary md-raised\" ng-click=addDatasource($event) aria-label=\"{{ 'action.add' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget-config.add-datasource' | translate }} </md-tooltip> <md-icon class=material-icons>add</md-icon> <span translate>action.add</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=target-devices-accordion control=targetDevicesAccordion class=vAccordion--default ng-show=\"widgetType === types.widgetType.rpc.value && isDataEnabled\"> <v-pane id=target-devices-pane expanded=true> <v-pane-header> {{ 'widget-config.target-device' | translate }} </v-pane-header> <v-pane-content style=\"padding:0 5px\"> <tb-entity-alias-select flex tb-required=\"widgetType === types.widgetType.rpc.value && !widgetEditMode\" alias-controller=aliasController allowed-entity-types=[types.entityType.device] ng-model=targetDeviceAlias.value on-create-entity-alias=\"onCreateEntityAlias({event: event, alias: alias, allowedEntityTypes: allowedEntityTypes})\"> </tb-entity-alias-select> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=alarm-source-accordion control=alarmSourceAccordion class=vAccordion--default ng-if=\"widgetType === types.widgetType.alarm.value && isDataEnabled\"> <v-pane id=alarm-source-pane expanded=true> <v-pane-header> {{ 'widget-config.alarm-source' | translate }} </v-pane-header> <v-pane-content style=\"padding:0 5px\"> <tb-datasource flex ng-model=alarmSource.value widget-type=widgetType functions-only=functionsOnly alias-controller=aliasController datakey-settings-schema=datakeySettingsSchema generate-data-key=generateDataKey(chip,type) on-create-entity-alias=\"onCreateEntityAlias({event: event, alias: alias})\"></tb-datasource> </v-pane-content> </v-pane> </v-accordion> </md-content> </md-tab> <md-tab label=\"{{ 'widget-config.settings' | translate }}\"> <div id=settings-tab> <md-content class=md-padding layout=column> <span translate>widget-config.general-settings</span> <div layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <md-input-container flex class=md-block> <label translate>widget-config.title</label> <input name=title ng-model=title> </md-input-container> <div flex ng-show=showTitle> <label translate>widget-config.title-style</label> <div ui-ace=styleEditorOptions ng-model=titleStyle ng-style=\"{ minHeight: '100px' }\"> </div> </div> </div> <div layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <div layout=row layout-padding> <md-checkbox aria-label=\"{{ 'widget-config.display-title' | translate }}\" ng-model=showTitle>{{ 'widget-config.display-title' | translate }} </md-checkbox> </div> <div layout=row layout-padding> <md-checkbox aria-label=\"{{ 'widget-config.drop-shadow' | translate }}\" ng-model=dropShadow>{{ 'widget-config.drop-shadow' | translate }} </md-checkbox> </div> <div layout=row layout-padding> <md-checkbox aria-label=\"{{ 'widget-config.enable-fullscreen' | translate }}\" ng-model=enableFullscreen>{{ 'widget-config.enable-fullscreen' | translate }} </md-checkbox> </div> <div flex> <label translate>widget-config.widget-style</label> <div ui-ace=styleEditorOptions ng-model=widgetStyle ng-style=\"{ minHeight: '100px' }\"> </div> </div> </div> <div layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <div flex md-color-picker ng-model=backgroundColor label=\"{{ 'widget-config.background-color' | translate }}\" icon=format_color_fill default=#fff md-color-clear-button=false open-on-input=true md-color-generic-palette=false md-color-history=false></div> <div flex md-color-picker ng-model=color label=\"{{ 'widget-config.text-color' | translate }}\" icon=format_color_fill default=\"rgba(0, 0, 0, 0.87)\" md-color-clear-button=false open-on-input=true md-color-generic-palette=false md-color-history=false></div> <md-input-container flex> <label translate>widget-config.padding</label> <input ng-model=padding> </md-input-container> <md-input-container flex> <label translate>widget-config.margin</label> <input ng-model=margin> </md-input-container> </div> <div layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <md-input-container flex> <label translate>widget-config.units</label> <input name=units ng-model=units> </md-input-container> <md-input-container flex> <label translate>widget-config.decimals</label> <input ng-model=decimals type=number min=0 max=15 step=1 ng-pattern=/^\\d*$/ > </md-input-container> </div> <div ng-show=\"widgetType === types.widgetType.timeseries.value ||\n                              widgetType === types.widgetType.latest.value\" layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <md-checkbox flex aria-label=\"{{ 'widget-config.display-legend' | translate }}\" ng-model=showLegend>{{ 'widget-config.display-legend' | translate }} </md-checkbox> <section flex layout=row layout-align=\"start center\" style=margin-bottom:16px> <tb-legend-config ng-disabled=!showLegend flex ng-model=legendConfig></tb-legend-config> </section> </div> <span translate>widget-config.mobile-mode-settings</span> <div layout=column layout-align=center layout-gt-sm=row layout-align-gt-sm=\"start center\"> <md-input-container flex> <label translate>widget-config.order</label> <input ng-model=mobileOrder type=number step=1 ng-pattern=/^-?[0-9]+$/ > </md-input-container> <md-input-container flex> <label translate>widget-config.height</label> <input ng-model=mobileHeight min=1 max=10 type=number step=1 ng-pattern=/^\\d*$/ > </md-input-container> </div> </md-content> </div> </md-tab> <md-tab ng-if=displayAdvanced() label=\"{{ 'widget-config.advanced' | translate }}\"> <md-content flex class=\"md-padding tb-advanced-widget-config\" layout=column> <ng-form flex name=ngform layout=column layout-padding> <tb-json-form flex schema=currentSettingsSchema form=currentSettingsForm model=currentSettings form-control=ngform> </tb-json-form> </ng-form> </md-content> </md-tab> <md-tab label=\"{{ 'widget-config.actions' | translate }}\"> <md-content class=md-padding layout=column> <tb-manage-widget-actions action-sources=actionSources widget-actions=actions fetch-dashboard-states=\"fetchDashboardStates({query: query})\"> </tb-manage-widget-actions> </md-content> </md-tab> </md-tabs> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	var path = 'components/widgets-bundle-select.tpl.html';
	var html = " <md-select ng-required=tbRequired ng-model=widgetsBundle md-container-class=tb-widgets-bundle-select placeholder=\"{{ 'widget.select-widgets-bundle' | translate }}\" class=md-no-underline> <md-option ng-repeat=\"item in widgetsBundles\" ng-value=item> <div class=tb-bundle-item> <span>{{item.title}}</span> <span translate class=tb-bundle-system ng-if=isSystem(item)>widgets-bundle.system</span> </div> </md-option> </md-select> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	var path = 'customer/add-customer.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'customer.add' | translate }}\" tb-help=\"'customers'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>customer.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-customer customer=vm.item is-edit=true the-form=theForm></tb-customer> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	var path = 'customer/customer-card.tpl.html';
	var html = " <div ng-show=\"item && (!item.additionalInfo || !item.additionalInfo.isPublic)\" class=tb-uppercase>{{ item | contactShort }}</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	var path = 'customer/customer-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onManageUsers({event: $event})\" ng-show=\"!isEdit && !isPublic\" class=\"md-raised md-primary\">{{ 'customer.manage-users' | translate }}</md-button> <md-button ng-click=\"onManageAssets({event: $event})\" ng-show=\"!isEdit && !isPublic\" class=\"md-raised md-primary\">{{ 'customer.manage-assets' | translate }}</md-button> <md-button ng-click=\"onManageDevices({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ 'customer.manage-devices' | translate }}</md-button> <md-button ng-click=\"onManageDashboards({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ 'customer.manage-dashboards' | translate }}</md-button> <md-button ng-click=\"onDeleteCustomer({event: $event})\" ng-show=\"!isEdit && !isPublic\" class=\"md-raised md-primary\">{{ 'customer.delete' | translate }}</md-button> <div layout=row> <md-button ngclipboard data-clipboard-action=copy ngclipboard-success=onCustomerIdCopied(e) data-clipboard-text={{customer.id.id}} ng-show=!isEdit class=md-raised> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <span translate>customer.copyId</span> </md-button> </div> <md-content class=md-padding layout=column> <fieldset ng-show=!isPublic ng-disabled=\"$root.loading || !isEdit\"> <md-input-container class=md-block> <label translate>customer.title</label> <input required name=title ng-model=customer.title> <div ng-messages=theForm.title.$error> <div translate ng-message=required>customer.title-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>customer.description</label> <textarea ng-model=customer.additionalInfo.description rows=2></textarea> </md-input-container> <tb-contact contact=customer the-form=theForm is-edit=isEdit></tb-contact> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	var path = 'customer/customers.tpl.html';
	var html = " <tb-grid grid-configuration=vm.customerGridConfig> <details-buttons tb-help=\"'customers'\" help-container-id=help-container> <div id=help-container></div> </details-buttons> <md-tabs ng-class=\"{'tb-headless': vm.grid.detailsConfig.isDetailsEditMode}\" id=tabs md-border-bottom flex class=tb-absolute-fill> <md-tab label=\"{{ 'customer.details' | translate }}\"> <tb-customer customer=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode the-form=vm.grid.detailsForm on-manage-users=\"vm.openCustomerUsers(event, vm.grid.detailsConfig.currentItem)\" on-manage-assets=\"vm.openCustomerAssets(event, vm.grid.detailsConfig.currentItem)\" on-manage-devices=\"vm.openCustomerDevices(event, vm.grid.detailsConfig.currentItem)\" on-manage-dashboards=\"vm.openCustomerDashboards(event, vm.grid.detailsConfig.currentItem)\" on-delete-customer=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"></tb-customer> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.attributes' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.customer}} entity-name=vm.grid.operatingItem().title default-attribute-scope={{vm.types.attributesScope.server.value}}> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.latest-telemetry' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.customer}} entity-name=vm.grid.operatingItem().title default-attribute-scope={{vm.types.latestTelemetry.value}} disable-attribute-scope-selection=true> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'alarm.alarms' | translate }}\"> <tb-alarm-table flex entity-type=vm.types.entityType.customer entity-id=vm.grid.operatingItem().id.id> </tb-alarm-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'customer.events' | translate }}\"> <tb-event-table flex entity-type=vm.types.entityType.customer entity-id=vm.grid.operatingItem().id.id tenant-id=vm.grid.operatingItem().tenantId.id default-event-type={{vm.types.eventType.error.value}}> </tb-event-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'relation.relations' | translate }}\"> <tb-relation-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.customer}}> </tb-relation-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.grid.isTenantAdmin()\" md-on-select=vm.grid.triggerResize() label=\"{{ 'audit-log.audit-logs' | translate }}\"> <tb-audit-log-table flex customer-id=vm.grid.operatingItem().id.id audit-log-mode={{vm.types.auditLogMode.customer}}> </tb-audit-log-table> </md-tab> </md-tabs> </tb-grid> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	var path = 'dashboard/add-dashboard.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'dashboard.add' | translate }}\" tb-help=\"'dashboards'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>dashboard.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-dashboard-details dashboard=vm.item is-edit=true the-form=theForm></tb-dashboard-details> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	var path = 'dashboard/add-dashboards-to-customer.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'dashboard.assign-dashboard-to-customer' | translate }}\"> <form name=theForm ng-submit=vm.assign()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>dashboard.assign-dashboard-to-customer</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset> <span translate>dashboard.assign-dashboard-to-customer-text</span> <md-input-container class=md-block style=margin-bottom:0> <label>&nbsp;</label> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons> search </md-icon> <input id=dashboard-search autofocus ng-model=vm.searchText ng-change=vm.searchDashboardTextUpdated() placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <div style=min-height:150px> <span translate layout-align=\"center center\" style=text-transform:uppercase;display:flex;height:150px class=md-subhead ng-show=vm.noData()>dashboard.no-dashboards-text</span> <md-virtual-repeat-container ng-show=vm.hasData() tb-scope-element=repeatContainer md-top-index=vm.topIndex flex style=min-height:150px;width:100%> <md-list> <md-list-item md-virtual-repeat=\"dashboard in vm.theDashboards\" md-on-demand class=repeated-item flex> <md-checkbox ng-click=\"vm.toggleDashboardSelection($event, dashboard)\" aria-label=\"{{ 'item.selected' | translate }}\" ng-checked=dashboard.selected></md-checkbox> <span> {{ dashboard.title }} </span> </md-list-item> </md-list> </md-virtual-repeat-container> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || vm.dashboards.selectedCount == 0\" type=submit class=\"md-raised md-primary\"> {{ 'action.assign' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	var path = 'dashboard/add-widget.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'widget.add' | translate }}\" style=width:900px tb-help=vm.helpLinkIdForWidgetType() help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>widget.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content style=padding-top:0> <fieldset ng-disabled=$root.loading style=position:relative;height:600px> <tb-widget-config widget-type=vm.widget.type type-parameters=vm.widgetInfo.typeParameters action-sources=vm.widgetInfo.actionSources force-expand-datasources=true ng-model=vm.widgetConfig widget-settings-schema=vm.settingsSchema datakey-settings-schema=vm.dataKeySettingsSchema alias-controller=vm.aliasController functions-only=vm.functionsOnly fetch-entity-keys=\"vm.fetchEntityKeys(entityAliasId, query, type)\" fetch-dashboard-states=vm.fetchDashboardStates(query) on-create-entity-alias=\"vm.createEntityAlias(event, alias, allowedEntityTypes)\" the-form=theForm></tb-widget-config> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	var path = 'dashboard/dashboard-card.tpl.html';
	var html = " <div class=\"tb-small tb-dashboard-assigned-customers\" ng-show=\"vm.parentCtl.dashboardsScope === 'tenant' && vm.item.assignedCustomersText\">{{'dashboard.assignedToCustomers' | translate}}: '{{vm.item.assignedCustomersText}}'</div> <div class=tb-small ng-show=\"vm.parentCtl.dashboardsScope === 'tenant' && vm.item.publicCustomerId\">{{'dashboard.public' | translate}}</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	var path = 'dashboard/dashboard-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onExportDashboard({event: $event})\" ng-show=\"!isEdit && dashboardScope === 'tenant'\" class=\"md-raised md-primary\">{{ 'dashboard.export' | translate }}</md-button> <md-button ng-click=\"onMakePublic({event: $event})\" ng-show=\"!isEdit && dashboardScope === 'tenant' && !dashboard.publicCustomerId\" class=\"md-raised md-primary\">{{ 'dashboard.make-public' | translate }}</md-button> <md-button ng-click=\"onMakePrivate({event: $event})\" ng-show=\"!isEdit && ((dashboardScope === 'tenant' && dashboard.publicCustomerId ||\n\t\t   \t\t\t\t\t\tdashboardScope === 'customer' && customerId == dashboard.publicCustomerId))\" class=\"md-raised md-primary\">{{ 'dashboard.make-private' | translate }}</md-button> <md-button ng-click=\"onManageAssignedCustomers({event: $event})\" ng-show=\"!isEdit && dashboardScope === 'tenant'\" class=\"md-raised md-primary\">{{ 'dashboard.manage-assigned-customers' | translate }}</md-button> <md-button ng-click=\"onUnassignFromCustomer({event: $event})\" ng-show=\"!isEdit && dashboardScope === 'customer' && customerId != dashboard.publicCustomerId\" class=\"md-raised md-primary\">{{ 'dashboard.unassign-from-customer' | translate }}</md-button> <md-button ng-click=\"onDeleteDashboard({event: $event})\" ng-show=\"!isEdit && dashboardScope === 'tenant'\" class=\"md-raised md-primary\">{{ 'dashboard.delete' | translate }}</md-button> <md-content class=md-padding layout=column> <md-input-container class=md-block ng-show=\"!isEdit && dashboard.assignedCustomersText && dashboardScope === 'tenant'\"> <label translate>dashboard.assignedToCustomers</label> <input ng-model=dashboard.assignedCustomersText disabled=disabled> </md-input-container> <div layout=column ng-show=\"!isEdit && ((dashboardScope === 'tenant' && dashboard.publicCustomerId ||\n\t\t   \t\t\t\t\t\t               dashboardScope === 'customer' && customerId == dashboard.publicCustomerId))\"> <tb-social-share-panel style=padding-bottom:10px share-title=\"{{ 'dashboard.socialshare-title' | translate:{dashboardTitle: dashboard.title} }}\" share-text=\"{{ 'dashboard.socialshare-text' | translate:{dashboardTitle: dashboard.title} }}\" share-link=\"{{ publicLink }}\" share-hash-tags=\"thingsboard, iot\"> </tb-social-share-panel> <div layout=row> <md-input-container class=md-block flex> <label translate>dashboard.public-link</label> <input ng-model=publicLink disabled=disabled> </md-input-container> <md-button class=md-icon-button style=margin-top:14px ngclipboard data-clipboard-text=\"{{ publicLink }}\" ngclipboard-success=onPublicLinkCopied(e)> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <md-tooltip md-direction=top> {{ 'dashboard.copy-public-link' | translate }} </md-tooltip> </md-button> </div> </div> <fieldset ng-disabled=\"$root.loading || !isEdit\"> <md-input-container class=md-block> <label translate>dashboard.title</label> <input required name=title ng-model=dashboard.title> <div ng-messages=theForm.title.$error> <div translate ng-message=required>dashboard.title-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>dashboard.description</label> <textarea ng-model=dashboard.configuration.description rows=2></textarea> </md-input-container> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	var path = 'dashboard/dashboard-toolbar.tpl.html';
	var html = " <md-fab-toolbar md-open=vm.toolbarOpened md-direction=left ng-class=\"{'is-fullscreen': vm.forceFullscreen, 'md-whiteframe-z1': vm.forceFullscreen && vm.toolbarOpened }\"> <md-fab-trigger class=align-with-text> <md-button aria-label=menu class=\"md-fab md-primary\" ng-click=vm.onTriggerClick()> <md-tooltip ng-show=!vm.toolbarOpened md-direction=bottom> {{ 'dashboard.open-toolbar' | translate }} </md-tooltip> <md-icon aria-label=dashboard-toolbar class=material-icons>more_horiz</md-icon> </md-button> </md-fab-trigger> <md-toolbar> <md-fab-actions class=md-toolbar-tools> <div ng-transclude></div> </md-fab-actions> </md-toolbar> </md-fab-toolbar> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	var path = 'dashboard/dashboards.tpl.html';
	var html = " <tb-grid grid-configuration=vm.dashboardGridConfig> <details-buttons tb-help=\"'dashboards'\" help-container-id=help-container> <div id=help-container></div> </details-buttons> <md-tabs ng-class=\"{'tb-headless': vm.grid.detailsConfig.isDetailsEditMode}\" id=tabs md-border-bottom flex class=tb-absolute-fill> <md-tab label=\"{{ 'dashboard.details' | translate }}\"> <tb-dashboard-details dashboard=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode dashboard-scope=vm.dashboardsScope customer-id=vm.customerId the-form=vm.grid.detailsForm on-make-public=\"vm.makePublic(event, vm.grid.detailsConfig.currentItem)\" on-make-private=\"vm.makePrivate(event, vm.grid.detailsConfig.currentItem)\" on-manage-assigned-customers=\"vm.manageAssignedCustomers(event, vm.grid.detailsConfig.currentItem)\" on-unassign-from-customer=\"vm.unassignFromCustomer(event, vm.grid.detailsConfig.currentItem, vm.customerId)\" on-export-dashboard=\"vm.exportDashboard(event, vm.grid.detailsConfig.currentItem)\" on-delete-dashboard=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"></tb-dashboard-details> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.grid.isTenantAdmin()\" md-on-select=vm.grid.triggerResize() label=\"{{ 'audit-log.audit-logs' | translate }}\"> <tb-audit-log-table flex entity-type=vm.types.entityType.dashboard entity-id=vm.grid.operatingItem().id.id audit-log-mode={{vm.types.auditLogMode.entity}}> </tb-audit-log-table> </md-tab> </md-tabs> </tb-grid> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	var path = 'dashboard/edit-widget.tpl.html';
	var html = " <fieldset ng-disabled=$root.loading> <tb-widget-config widget-type=widget.type type-parameters=typeParameters action-sources=actionSources ng-model=widgetConfig is-data-enabled=isDataEnabled widget-settings-schema=settingsSchema datakey-settings-schema=dataKeySettingsSchema alias-controller=aliasController functions-only=widgetEditMode fetch-entity-keys=\"fetchEntityKeys(entityAliasId, query, type)\" fetch-dashboard-states=fetchDashboardStates(query) on-create-entity-alias=\"createEntityAlias(event, alias, allowedEntityTypes)\" the-form=theForm></tb-widget-config> </fieldset> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	var path = 'dashboard/layouts/dashboard-layout.tpl.html';
	var html = " <md-content style=position:relative;width:100%;height:100% ng-style=\"{'background-color': vm.layoutCtx.gridSettings.backgroundColor,\n                    'background-image': 'url('+vm.layoutCtx.gridSettings.backgroundImageUrl+')',\n                    'background-repeat': 'no-repeat',\n                    'background-attachment': 'scroll',\n                    'background-size': vm.layoutCtx.gridSettings.backgroundSizeMode || '100%',\n                    'background-position': '0% 0%'}\"> <section ng-show=\"!$root.loading && vm.noData()\" layout-align=\"center center\" ng-style=\"{'color': vm.layoutCtx.gridSettings.color}\" style=text-transform:uppercase;display:flex;z-index:1;pointer-events:none class=\"md-headline tb-absolute-fill\"> <span translate ng-if=!vm.isEdit> dashboard.no-widgets </span> <md-button ng-if=\"vm.isEdit && !vm.widgetEditMode\" class=tb-add-new-widget ng-click=\"vm.addWidget({event: $event})\"> <md-icon aria-label=\"{{ 'action.add' | translate }}\" class=\"material-icons tb-md-96\">add</md-icon> {{ 'dashboard.add-widget' | translate }} </md-button> </section> <tb-dashboard dashboard-style=\"{'background-color': vm.layoutCtx.gridSettings.backgroundColor,\n                            'background-image': 'url('+vm.layoutCtx.gridSettings.backgroundImageUrl+')',\n                            'background-repeat': 'no-repeat',\n                            'background-attachment': 'scroll',\n                            'background-size': vm.layoutCtx.gridSettings.backgroundSizeMode || '100%',\n                            'background-position': '0% 0%'}\" widgets=vm.layoutCtx.widgets widget-layouts=vm.layoutCtx.widgetLayouts columns=vm.layoutCtx.gridSettings.columns margins=vm.layoutCtx.gridSettings.margins alias-controller=vm.dashboardCtx.aliasController state-controller=vm.dashboardCtx.stateController dashboard-timewindow=vm.dashboardCtx.dashboardTimewindow is-edit=vm.isEdit autofill-height=\"vm.layoutCtx.gridSettings.autoFillHeight && !vm.isEdit\" mobile-autofill-height=\"vm.layoutCtx.gridSettings.mobileAutoFillHeight && !vm.isEdit\" mobile-row-height=vm.layoutCtx.gridSettings.mobileRowHeight is-mobile=vm.isMobile is-mobile-disabled=vm.widgetEditMode is-edit-action-enabled=vm.isEdit is-export-action-enabled=\"vm.isEdit && !vm.widgetEditMode\" is-remove-action-enabled=\"vm.isEdit && !vm.widgetEditMode\" on-edit-widget=\"vm.editWidget(event, widget)\" on-export-widget=\"vm.exportWidget(event, widget)\" on-widget-mouse-down=\"vm.widgetMouseDown(event, widget)\" on-widget-clicked=\"vm.widgetClicked(event, widget)\" prepare-dashboard-context-menu=vm.prepareDashboardContextMenu() prepare-widget-context-menu=vm.prepareWidgetContextMenu(widget) on-remove-widget=\"vm.removeWidget(event, widget)\" on-init=vm.dashboardInited(dashboard) on-init-failed=vm.dashboardInitFailed(e) ignore-loading=vm.layoutCtx.ignoreLoading> </tb-dashboard> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	var path = 'dashboard/layouts/manage-dashboard-layouts.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'layout.manage' | translate }}\"> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{ 'layout.manage' }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=$root.loading> <div layout=row layout-align=\"start center\"> <md-checkbox ng-disabled=true flex aria-label=\"{{ 'layout.main' | translate }}\" ng-model=vm.displayLayouts.main>{{ 'layout.main' | translate }} </md-checkbox> <md-checkbox flex aria-label=\"{{ 'layout.right' | translate }}\" ng-model=vm.displayLayouts.right>{{ 'layout.right' | translate }} </md-checkbox> </div> <div layout=row layout-align=\"start center\"> <md-button flex ng-show=vm.displayLayouts.main class=\"tb-layout-button md-raised md-primary\" layout=column ng-click=\"vm.openLayoutSettings($event, 'main')\"> <span translate>layout.main</span> </md-button> <md-button flex ng-show=vm.displayLayouts.right class=\"tb-layout-button md-raised md-primary\" layout=column ng-click=\"vm.openLayoutSettings($event, 'right')\"> <span translate>layout.right</span> </md-button> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || !theForm.$dirty || !theForm.$valid\" type=submit class=\"md-raised md-primary\"> {{ 'action.save' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	var path = 'dashboard/make-dashboard-public-dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'dashboard.make-public' | translate }}\" style=min-width:400px> <form> <md-toolbar> <div class=md-toolbar-tools> <h2 translate=dashboard.public-dashboard-title></h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.close()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div id=make-dialog-public-content class=md-dialog-content> <md-content class=md-padding layout=column> <span translate=dashboard.public-dashboard-text translate-values=\"{dashboardTitle: vm.dashboard.title, publicLink: vm.publicLink}\"></span> <div layout=row layout-align=\"start center\"> <pre class=tb-highlight flex><code>{{ vm.publicLink }}</code></pre> <md-button class=md-icon-button ngclipboard data-clipboard-text=\"{{ vm.publicLink }}\" ngclipboard-success=vm.onPublicLinkCopied(e)> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <md-tooltip md-direction=top> {{ 'dashboard.copy-public-link' | translate }} </md-tooltip> </md-button> </div> <div class=tb-notice translate>dashboard.public-dashboard-notice</div> <tb-social-share-panel style=padding-top:15px share-title=\"{{ 'dashboard.socialshare-title' | translate:{dashboardTitle:vm.dashboard.title} }}\" share-text=\"{{ 'dashboard.socialshare-text' | translate:{dashboardTitle:vm.dashboard.title} }}\" share-link=\"{{ vm.publicLink }}\" share-hash-tags=\"thingsboard, iot\"> </tb-social-share-panel> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-click=vm.close()>{{ 'action.ok' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	var path = 'dashboard/manage-assigned-customers.tpl.html';
	var html = " <md-dialog aria-label=\"{{ vm.titleText | translate }}\" style=width:600px> <form name=theForm ng-submit=vm.submit()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{vm.titleText}}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset> <span translate>{{vm.labelText}}</span> <tb-entity-list ng-disabled=$root.loading ng-model=vm.assignedCustomers entity-type=vm.types.entityType.customer></tb-entity-list> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || !theForm.$dirty || !theForm.$valid\" type=submit class=\"md-raised md-primary\"> {{ vm.actionName | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	var path = 'dashboard/states/dashboard-state-dialog.tpl.html';
	var html = " <md-dialog class=dashboard-state aria-label=\"{{'dashboard.state' | translate }}\" style=min-width:600px> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2>{{ (vm.isAdd ? 'dashboard.add-state' : 'dashboard.edit-state') | translate }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'action.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <md-content class=md-padding layout=column> <fieldset ng-disabled=$root.loading> <md-input-container class=md-block> <label translate>dashboard.state-name</label> <input name=name required ng-model=vm.state.name> <div ng-messages=theForm.name.$error> <div ng-message=required translate>dashboard.state-name-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>dashboard.state-id</label> <input name=stateId required ng-model=vm.state.id ng-change=\"vm.stateIdTouched = true\"> <div ng-messages=theForm.stateId.$error> <div ng-message=required translate>dashboard.state-id-required</div> <div ng-message=stateExists translate>dashboard.state-id-exists</div> </div> </md-input-container> <md-checkbox flex aria-label=\"{{ 'dashboard.is-root-state' | translate }}\" ng-model=vm.state.root>{{ 'dashboard.is-root-state' | translate }} </md-checkbox> </fieldset> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ (vm.isAdd ? 'action.add' : 'action.save') | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px> {{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	var path = 'dashboard/states/default-state-controller.tpl.html';
	var html = " <md-select class=default-state-controller ng-show=vm.displayStateSelection() aria-label=\"{{ 'dashboard.state' | translate }}\" ng-model=vm.stateObject[0].id> <md-option ng-repeat=\"(stateId, state) in vm.states\" ng-value=stateId> {{vm.getStateName(stateId, state)}} </md-option> </md-select> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	var path = 'dashboard/states/entity-state-controller.tpl.html';
	var html = " <div class=entity-state-controller layout=row layout-align=\"start center\"> <div ng-if=\"!vm.dashboardCtrl.isMobile || vm.stateObject.length===1\" layout=row layout-align=\"start center\"> <span ng-repeat=\"state in vm.stateObject track by $index\" class=state-entry ng-style=\"{fontWeight: $last ? 'bold' : 'normal',\n                         cursor: $last ? 'default' : 'pointer'}\" ng-click=vm.navigatePrevState($index)> {{vm.getStateName($index)}} <span class=state-divider ng-hide=$last> > </span> </span> </div> <md-select ng-if=\"vm.dashboardCtrl.isMobile && vm.stateObject.length > 1\" aria-label=\"{{ 'dashboard.state' | translate }}\" ng-model=vm.selectedStateIndex> <md-option ng-repeat=\"state in vm.stateObject track by $index\" ng-value=$index> {{vm.getStateName($index)}} </md-option> </md-select> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	var path = 'dashboard/states/manage-dashboard-states.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'dashboard.manage-states' | translate }}\" style=min-width:600px> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{ 'dashboard.manage-states' }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=$root.loading> <div class=manage-dashboard-states layout=column> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"vm.query.search === null\"> <div class=md-toolbar-tools> <span translate>dashboard.states</span> <span flex></span> <md-button class=md-icon-button ng-click=vm.addState($event)> <md-icon>add</md-icon> <md-tooltip md-direction=top> {{ 'dashboard.add-state' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=vm.enterFilterMode()> <md-icon>search</md-icon> <md-tooltip md-direction=top> {{ 'action.search' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"vm.query.search != null\"> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=top> {{ 'dashboard.search-states' | translate }} </md-tooltip> </md-button> <md-input-container flex> <label>&nbsp;</label> <input ng-model=vm.query.search placeholder=\"{{ 'dashboard.search-states' | translate }}\"> </md-input-container> <md-button class=md-icon-button aria-label=Close ng-click=vm.exitFilterMode()> <md-icon aria-label=Close class=material-icons>close</md-icon> <md-tooltip md-direction=top> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-table-container> <table md-table> <thead md-head md-order=vm.query.order md-on-reorder=vm.onReorder> <tr md-row> <th md-column md-order-by=name><span translate>dashboard.state-name</span></th> <th md-column md-order-by=id><span translate>dashboard.state-id</span></th> <th md-column md-order-by=root><span translate>dashboard.is-root-state</span></th> <th md-column><span>&nbsp</span></th> </tr> </thead> <tbody md-body> <tr md-row md-select=state ng-disabled=state.root md-select-id=id md-auto-select ng-repeat=\"state in vm.states\"> <td md-cell>{{state.name}}</td> <td md-cell>{{state.id}}</td> <td md-cell> <md-checkbox aria-label=\"{{'dashboard.is-root-state' | translate }}\" disabled=disabled ng-model=state.root> </md-checkbox> </td> <td md-cell class=tb-action-cell> <md-button class=md-icon-button aria-label=\"{{ 'action.edit' | translate }}\" ng-click=\"vm.editState($event, state)\"> <md-icon aria-label=\"{{ 'action.edit' | translate }}\" class=material-icons>edit</md-icon> <md-tooltip md-direction=top> {{ 'dashboard.edit-state' | translate }} </md-tooltip> </md-button> <md-button ng-show=!state.root class=md-icon-button aria-label=Delete ng-click=\"vm.deleteState($event, state)\"> <md-icon aria-label=Delete class=material-icons>delete</md-icon> <md-tooltip md-direction=top> {{ 'dashboard.delete-state' | translate }} </md-tooltip> </md-button> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=vm.query.limit md-limit-options=\"[5, 10, 15]\" md-page=vm.query.page md-total={{vm.statesCount}} md-on-paginate=vm.onPaginate md-page-select> </md-table-pagination> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || !theForm.$dirty || !theForm.$valid\" type=submit class=\"md-raised md-primary\"> {{ 'action.save' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	var path = 'dashboard/states/select-target-state.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'dashboard.select-state' | translate }}\"> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{ 'dashboard.select-state' }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=$root.loading> <md-select required aria-label=\"{{ 'dashboard.state' | translate }}\" ng-model=vm.stateId> <md-option ng-repeat=\"(stateId, state) in vm.states\" ng-value=stateId> {{state.name}} </md-option> </md-select> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || !theForm.$valid\" type=submit class=\"md-raised md-primary\"> {{ 'action.select' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	var path = 'device/add-device.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'device.add' | translate }}\" tb-help=\"'devices'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>device.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-device device=vm.item is-edit=true the-form=theForm></tb-device> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	var path = 'device/add-devices-to-customer.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'device.assign-to-customer' | translate }}\"> <form name=theForm ng-submit=vm.assign()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>device.assign-device-to-customer</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset> <span translate>device.assign-device-to-customer-text</span> <md-input-container class=md-block style=margin-bottom:0> <label>&nbsp;</label> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons> search </md-icon> <input id=device-search autofocus ng-model=vm.searchText ng-change=vm.searchDeviceTextUpdated() placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <div style=min-height:150px> <span translate layout-align=\"center center\" style=text-transform:uppercase;display:flex;height:150px class=md-subhead ng-show=vm.noData()>device.no-devices-text</span> <md-virtual-repeat-container ng-show=vm.hasData() tb-scope-element=repeatContainer md-top-index=vm.topIndex flex style=min-height:150px;width:100%> <md-list> <md-list-item md-virtual-repeat=\"device in vm.theDevices\" md-on-demand class=repeated-item flex> <md-checkbox ng-click=\"vm.toggleDeviceSelection($event, device)\" aria-label=\"{{ 'item.selected' | translate }}\" ng-checked=device.selected></md-checkbox> <span> {{ device.name }} </span> </md-list-item> </md-list> </md-virtual-repeat-container> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || vm.devices.selectedCount == 0\" type=submit class=\"md-raised md-primary\"> {{ 'action.assign' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	var path = 'device/assign-to-customer.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'device.assign-device-to-customer' | translate }}\"> <form name=theForm ng-submit=vm.assign()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>device.assign-device-to-customer</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset> <span translate>device.assign-to-customer-text</span> <md-input-container class=md-block style=margin-bottom:0> <label>&nbsp;</label> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons> search </md-icon> <input id=customer-search autofocus ng-model=vm.searchText ng-change=vm.searchCustomerTextUpdated() placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <div style=min-height:150px> <span translate layout-align=\"center center\" style=text-transform:uppercase;display:flex;height:150px class=md-subhead ng-show=vm.noData()>customer.no-customers-text</span> <md-virtual-repeat-container ng-show=vm.hasData() tb-scope-element=repeatContainer md-top-index=vm.topIndex flex style=min-height:150px;width:100%> <md-list> <md-list-item md-virtual-repeat=\"customer in vm.theCustomers\" md-on-demand class=repeated-item flex> <md-checkbox ng-click=\"vm.toggleCustomerSelection($event, customer)\" aria-label=\"{{ 'item.selected' | translate }}\" ng-checked=vm.isCustomerSelected(customer)></md-checkbox> <span> {{ customer.title }} </span> </md-list-item> </md-list> </md-virtual-repeat-container> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || vm.customers.selection==null\" type=submit class=\"md-raised md-primary\"> {{ 'action.assign' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	var path = 'device/device-card.tpl.html';
	var html = " <div flex layout=column style=margin-top:-10px> <div style=text-transform:uppercase;padding-bottom:5px>{{vm.item.type}}</div> <div class=tb-card-description>{{vm.item.additionalInfo.description}}</div> <div style=padding-top:5px class=tb-small ng-show=vm.isAssignedToCustomer()>{{'device.assignedToCustomer' | translate}} '{{vm.item.assignedCustomer.title}}'</div> <div style=padding-top:5px class=tb-small ng-show=vm.isPublic()>{{'device.public' | translate}}</div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	var path = 'device/device-credentials.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'device.device-credentials' | translate }}\"> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>device.device-credentials</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=\"$root.loading || vm.isReadOnly\"> <md-input-container class=md-block> <label translate>device.credentials-type</label> <md-select ng-disabled=\"$root.loading || vm.isReadOnly\" ng-model=vm.deviceCredentials.credentialsType ng-change=vm.clear()> <md-option ng-repeat=\"credentialsType in vm.credentialsTypes\" value={{credentialsType.value}}> {{credentialsType.name}} </md-option> </md-select> </md-input-container> <md-input-container class=md-block ng-if=\"vm.deviceCredentials.credentialsType === 'ACCESS_TOKEN'\"> <label translate>device.access-token</label> <input required name=accessToken ng-model=vm.deviceCredentials.credentialsId md-maxlength=20 ng-pattern=/^.{1,20}$/ > <div ng-messages=theForm.accessToken.$error> <div translate ng-message=required>device.access-token-required</div> <div translate ng-message=pattern>device.access-token-invalid</div> </div> </md-input-container> <md-input-container class=md-block ng-if=\"vm.deviceCredentials.credentialsType === 'X509_CERTIFICATE'\"> <label translate>device.rsa-key</label> <textarea required name=rsaKey ng-model=vm.deviceCredentials.credentialsValue cols=15 rows=5></textarea> <div ng-messages=theForm.rsaKey.$error> <div translate ng-message=required>device.rsa-key-required</div> </div> </md-input-container> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-if=!vm.isReadOnly ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty || !vm.valid()\" type=submit class=\"md-raised md-primary\"> {{ 'action.save' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ (vm.isReadOnly ? 'action.close' : 'action.cancel') | translate }}</md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	var path = 'device/device-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onMakePublic({event: $event})\" ng-show=\"!isEdit && deviceScope === 'tenant' && !isAssignedToCustomer && !isPublic\" class=\"md-raised md-primary\">{{ 'device.make-public' | translate }}</md-button> <md-button ng-click=\"onAssignToCustomer({event: $event})\" ng-show=\"!isEdit && deviceScope === 'tenant' && !isAssignedToCustomer\" class=\"md-raised md-primary\">{{ 'device.assign-to-customer' | translate }}</md-button> <md-button ng-click=\"onUnassignFromCustomer({event: $event, isPublic: isPublic})\" ng-show=\"!isEdit && (deviceScope === 'customer' || deviceScope === 'tenant') && isAssignedToCustomer\" class=\"md-raised md-primary\">{{ isPublic ? 'device.make-private' : 'device.unassign-from-customer' | translate }}</md-button> <md-button ng-click=\"onManageCredentials({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ (deviceScope === 'customer_user' ? 'device.view-credentials' : 'device.manage-credentials') | translate }}</md-button> <md-button ng-click=\"onDeleteDevice({event: $event})\" ng-show=\"!isEdit && deviceScope === 'tenant'\" class=\"md-raised md-primary\">{{ 'device.delete' | translate }}</md-button> <div layout=row> <md-button ngclipboard data-clipboard-action=copy ngclipboard-success=onDeviceIdCopied(e) data-clipboard-text={{device.id.id}} ng-show=!isEdit class=md-raised> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <span translate>device.copyId</span> </md-button> <md-button ng-show=!isEdit class=md-raised ng-click=copyAccessToken($event)> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <span translate>device.copyAccessToken</span> </md-button> </div> <md-content class=md-padding layout=column> <md-input-container class=md-block ng-show=\"!isEdit && isAssignedToCustomer && !isPublic && deviceScope === 'tenant'\"> <label translate>device.assignedToCustomer</label> <input ng-model=assignedCustomer.title disabled=disabled> </md-input-container> <div class=tb-small style=padding-bottom:10px;padding-left:2px ng-show=\"!isEdit && isPublic && (deviceScope === 'customer' || deviceScope === 'tenant')\"> {{ 'device.device-public' | translate }} </div> <fieldset ng-disabled=\"$root.loading || !isEdit\"> <md-input-container class=md-block> <label translate>device.name</label> <input required name=name ng-model=device.name> <div ng-messages=theForm.name.$error> <div translate ng-message=required>device.name-required</div> </div> </md-input-container> <tb-entity-subtype-autocomplete ng-disabled=\"$root.loading || !isEdit\" tb-required=true the-form=theForm ng-model=device.type entity-type=types.entityType.device> </tb-entity-subtype-autocomplete> <md-input-container class=md-block> <md-checkbox ng-disabled=\"$root.loading || !isEdit\" flex aria-label=\"{{ 'device.is-gateway' | translate }}\" ng-model=device.additionalInfo.gateway>{{ 'device.is-gateway' | translate }} </md-checkbox> </md-input-container> <md-input-container class=md-block> <label translate>device.description</label> <textarea ng-model=device.additionalInfo.description rows=2></textarea> </md-input-container> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	var path = 'device/devices.tpl.html';
	var html = " <tb-grid grid-configuration=vm.deviceGridConfig> <details-buttons tb-help=\"'devices'\" help-container-id=help-container> <div id=help-container></div> </details-buttons> <md-tabs ng-class=\"{'tb-headless': vm.grid.detailsConfig.isDetailsEditMode}\" id=tabs md-border-bottom flex class=tb-absolute-fill> <md-tab label=\"{{ 'device.details' | translate }}\"> <tb-device device=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode device-scope=vm.devicesScope the-form=vm.grid.detailsForm on-assign-to-customer=\"vm.assignToCustomer(event, [ vm.grid.detailsConfig.currentItem.id.id ])\" on-make-public=\"vm.makePublic(event, vm.grid.detailsConfig.currentItem)\" on-unassign-from-customer=\"vm.unassignFromCustomer(event, vm.grid.detailsConfig.currentItem, isPublic)\" on-manage-credentials=\"vm.manageCredentials(event, vm.grid.detailsConfig.currentItem)\" on-delete-device=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"></tb-device> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.attributes' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.device}} entity-name=vm.grid.operatingItem().name default-attribute-scope={{vm.types.attributesScope.client.value}}> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.latest-telemetry' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.device}} entity-name=vm.grid.operatingItem().name default-attribute-scope={{vm.types.latestTelemetry.value}} disable-attribute-scope-selection=true> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'alarm.alarms' | translate }}\"> <tb-alarm-table flex entity-type=vm.types.entityType.device entity-id=vm.grid.operatingItem().id.id> </tb-alarm-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'device.events' | translate }}\"> <tb-event-table flex entity-type=vm.types.entityType.device entity-id=vm.grid.operatingItem().id.id tenant-id=vm.grid.operatingItem().tenantId.id default-event-type={{vm.types.eventType.error.value}}> </tb-event-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'relation.relations' | translate }}\"> <tb-relation-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.device}}> </tb-relation-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.grid.operatingItem().additionalInfo.gateway\" md-on-select=vm.grid.triggerResize() label=\"{{ 'extension.extensions' | translate }}\"> <tb-extension-table flex entity-id=vm.grid.operatingItem().id.id entity-name=vm.grid.operatingItem().name entity-type={{vm.types.entityType.device}}> </tb-extension-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.grid.isTenantAdmin()\" md-on-select=vm.grid.triggerResize() label=\"{{ 'audit-log.audit-logs' | translate }}\"> <tb-audit-log-table flex entity-type=vm.types.entityType.device entity-id=vm.grid.operatingItem().id.id audit-log-mode={{vm.types.auditLogMode.entity}}> </tb-audit-log-table> </md-tab> </md-tabs></tb-grid> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	var path = 'entity-view/add-entity-view.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'entity-view.add' | translate }}\" style=width:800px tb-help=\"'entityViews'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>entity-view.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-entity-view entity-view=vm.item is-edit=true the-form=theForm></tb-entity-view> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	var path = 'entity-view/add-entity-views-to-customer.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'entity-view.assign-to-customer' | translate }}\"> <form name=theForm ng-submit=vm.assign()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>entity-view.assign-entity-view-to-customer</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset> <span translate>entity-view.assign-entity-view-to-customer-text</span> <md-input-container class=md-block style=margin-bottom:0> <label>&nbsp;</label> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons> search </md-icon> <input id=entity-view-search autofocus ng-model=vm.searchText ng-change=vm.searchEntityViewTextUpdated() placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <div style=min-height:150px> <span translate layout-align=\"center center\" style=text-transform:uppercase;display:flex;height:150px class=md-subhead ng-show=vm.noData()>entity-view.no-entity-views-text</span> <md-virtual-repeat-container ng-show=vm.hasData() tb-scope-element=repeatContainer md-top-index=vm.topIndex flex style=min-height:150px;width:100%> <md-list> <md-list-item md-virtual-repeat=\"entityView in vm.theEntityViews\" md-on-demand class=repeated-item flex> <md-checkbox ng-click=\"vm.toggleEntityViewSelection($event, entityView)\" aria-label=\"{{ 'item.selected' | translate }}\" ng-checked=entityView.selected></md-checkbox> <span> {{ entityView.name }} </span> </md-list-item> </md-list> </md-virtual-repeat-container> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || vm.entityViews.selectedCount == 0\" type=submit class=\"md-raised md-primary\"> {{ 'action.assign' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	var path = 'entity-view/assign-to-customer.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'entity-view.assign-entity-view-to-customer' | translate }}\"> <form name=theForm ng-submit=vm.assign()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>entity-view.assign-entity-view-to-customer</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset> <span translate>entity-view.assign-to-customer-text</span> <md-input-container class=md-block style=margin-bottom:0> <label>&nbsp;</label> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons> search </md-icon> <input id=customer-search autofocus ng-model=vm.searchText ng-change=vm.searchCustomerTextUpdated() placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <div style=min-height:150px> <span translate layout-align=\"center center\" style=text-transform:uppercase;display:flex;height:150px class=md-subhead ng-show=vm.noData()>customer.no-customers-text</span> <md-virtual-repeat-container ng-show=vm.hasData() tb-scope-element=repeatContainer md-top-index=vm.topIndex flex style=min-height:150px;width:100%> <md-list> <md-list-item md-virtual-repeat=\"customer in vm.theCustomers\" md-on-demand class=repeated-item flex> <md-checkbox ng-click=\"vm.toggleCustomerSelection($event, customer)\" aria-label=\"{{ 'item.selected' | translate }}\" ng-checked=vm.isCustomerSelected(customer)></md-checkbox> <span> {{ customer.title }} </span> </md-list-item> </md-list> </md-virtual-repeat-container> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || vm.customers.selection==null\" type=submit class=\"md-raised md-primary\"> {{ 'action.assign' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	var path = 'entity-view/entity-view-card.tpl.html';
	var html = " <div flex layout=column style=margin-top:-10px> <div style=text-transform:uppercase;padding-bottom:5px>{{vm.item.type}}</div> <div class=tb-card-description>{{vm.item.additionalInfo.description}}</div> <div style=padding-top:5px class=tb-small ng-show=vm.isAssignedToCustomer()>{{'entity-view.assignedToCustomer' | translate}} '{{vm.item.assignedCustomer.title}}'</div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	var path = 'entity-view/entity-view-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onMakePublic({event: $event})\" ng-show=\"!isEdit && entityViewScope === 'tenant' && !isAssignedToCustomer && !isPublic\" class=\"md-raised md-primary\">{{ 'entity-view.make-public' | translate }}</md-button> <md-button ng-click=\"onAssignToCustomer({event: $event})\" ng-show=\"!isEdit && entityViewScope === 'tenant' && !isAssignedToCustomer\" class=\"md-raised md-primary\">{{ 'entity-view.assign-to-customer' | translate }}</md-button> <md-button ng-click=\"onUnassignFromCustomer({event: $event})\" ng-show=\"!isEdit && (entityViewScope === 'customer' || entityViewScope === 'tenant') && isAssignedToCustomer\" class=\"md-raised md-primary\">{{'entity-view.unassign-from-customer' | translate }}</md-button> <md-button ng-click=\"onDeleteEntityView({event: $event})\" ng-show=\"!isEdit && entityViewScope === 'tenant'\" class=\"md-raised md-primary\">{{ 'entity-view.delete' | translate }}</md-button> <div layout=row> <md-button ngclipboard data-clipboard-action=copy ngclipboard-success=onEntityViewIdCopied(e) data-clipboard-text={{entityView.id.id}} ng-show=!isEdit class=md-raised> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <span translate>entity-view.copyId</span> </md-button> </div> <md-content class=md-padding layout=column> <md-input-container class=md-block ng-show=\"!isEdit && isAssignedToCustomer && entityViewScope === 'tenant'\"> <label translate>entity-view.assignedToCustomer</label> <input ng-model=assignedCustomer.title disabled=disabled> </md-input-container> <fieldset ng-disabled=\"$root.loading || !isEdit\"> <md-input-container class=md-block> <label translate>entity-view.name</label> <input required name=name ng-model=entityView.name> <div ng-messages=theForm.name.$error> <div translate ng-message=required>entity-view.name-required</div> </div> </md-input-container> <tb-entity-subtype-autocomplete ng-disabled=\"$root.loading || !isEdit\" tb-required=true the-form=theForm ng-model=entityView.type entity-type=types.entityType.entityView> </tb-entity-subtype-autocomplete> <section layout=column> <label translate class=\"tb-title no-padding\">entity-view.target-entity</label> <tb-entity-select flex ng-disabled=!isEdit the-form=theForm tb-required=true allowed-entity-types=allowedEntityTypes ng-model=entityView.entityId> </tb-entity-select> </section> <md-expansion-panel-group class=tb-entity-view-panel-group ng-class=\"{'disabled': $root.loading || !isEdit}\" auto-expand=true multiple=true md-component-id=attributesPanelGroup> <md-expansion-panel md-component-id={{attributesPanelId}}> <md-expansion-panel-collapsed> <div class=tb-panel-title>{{ 'entity-view.attributes-propagation' | translate }}</div> <span flex></span> <md-expansion-panel-icon></md-expansion-panel-icon> </md-expansion-panel-collapsed> <md-expansion-panel-expanded> <md-expansion-panel-header ng-click=$mdExpansionPanel(attributesPanelId).collapse()> <div class=tb-panel-title>{{ 'entity-view.attributes-propagation' | translate }}</div> <span flex></span> <md-expansion-panel-icon></md-expansion-panel-icon> </md-expansion-panel-header> <md-expansion-panel-content> <div translate class=tb-hint>entity-view.attributes-propagation-hint</div> <label translate class=\"tb-title no-padding\">entity-view.client-attributes</label> <md-chips style=padding-bottom:15px ng-required=false readonly=!isEdit ng-model=entityView.keys.attributes.cs placeholder=\"{{'entity-view.client-attributes-placeholder' | translate}}\" md-separator-keys=separatorKeys> <md-autocomplete md-no-cache=true id=ca_datakey md-selected-item=selectedAttributeDataKey md-search-text=attributeDataKeySearchText md-items=\"item in dataKeysSearch(attributeDataKeySearchText, types.dataKeyType.attribute)\" md-item-text=item.name md-min-length=0 placeholder=\"{{'entity-view.client-attributes-placeholder' | translate }}\" md-menu-class=tb-attribute-datakey-autocomplete> <span md-highlight-text=attributeDataKeySearchText md-highlight-flags=^i>{{item}}</span> </md-autocomplete> </md-chips> <label translate class=\"tb-title no-padding\">entity-view.shared-attributes</label> <md-chips style=padding-bottom:15px ng-required=false readonly=!isEdit ng-model=entityView.keys.attributes.sh placeholder=\"{{'entity-view.shared-attributes-placeholder' | translate}}\" md-separator-keys=separatorKeys> <md-autocomplete md-no-cache=true id=sh_datakey md-selected-item=selectedAttributeDataKey md-search-text=attributeDataKeySearchText md-items=\"item in dataKeysSearch(attributeDataKeySearchText, types.dataKeyType.attribute)\" md-item-text=item.name md-min-length=0 placeholder=\"{{'entity-view.server-attributes-placeholder' | translate }}\" md-menu-class=tb-attribute-datakey-autocomplete> <span md-highlight-text=attributeDataKeySearchText md-highlight-flags=^i>{{item}}</span> </md-autocomplete> </md-chips> <label translate class=\"tb-title no-padding\">entity-view.server-attributes</label> <md-chips style=padding-bottom:15px ng-required=false readonly=!isEdit ng-model=entityView.keys.attributes.ss placeholder=\"{{'entity-view.server-attributes-placeholder' | translate}}\" md-separator-keys=separatorKeys> <md-autocomplete md-no-cache=true id=ss_datakey md-selected-item=selectedAttributeDataKey md-search-text=attributeDataKeySearchText md-items=\"item in dataKeysSearch(attributeDataKeySearchText, types.dataKeyType.attribute)\" md-item-text=item.name md-min-length=0 placeholder=\"{{'entity-view.server-attributes-placeholder' | translate }}\" md-menu-class=tb-attribute-datakey-autocomplete> <span md-highlight-text=attributeDataKeySearchText md-highlight-flags=^i>{{item}}</span> </md-autocomplete> </md-chips> </md-expansion-panel-content> </md-expansion-panel-expanded> </md-expansion-panel> <md-expansion-panel md-component-id={{timeseriesPanelId}}> <md-expansion-panel-collapsed> <div class=tb-panel-title>{{ 'entity-view.timeseries-data' | translate }}</div> <span flex></span> <md-expansion-panel-icon></md-expansion-panel-icon> </md-expansion-panel-collapsed> <md-expansion-panel-expanded> <md-expansion-panel-header ng-click=$mdExpansionPanel(timeseriesPanelId).collapse()> <div class=tb-panel-title>{{ 'entity-view.timeseries-data' | translate }}</div> <span flex></span> <md-expansion-panel-icon></md-expansion-panel-icon> </md-expansion-panel-header> <md-expansion-panel-content> <div translate class=tb-hint>entity-view.timeseries-data-hint</div> <label translate class=\"tb-title no-padding\">entity-view.timeseries</label> <md-chips ng-required=false readonly=!isEdit ng-model=entityView.keys.timeseries placeholder=\"{{'entity-view.timeseries-placeholder' | translate}}\" md-separator-keys=separatorKeys> <md-autocomplete md-no-cache=true id=timeseries_datakey md-selected-item=selectedTimeseriesDataKey md-search-text=timeseriesDataKeySearchText md-items=\"item in dataKeysSearch(timeseriesDataKeySearchText, types.dataKeyType.timeseries)\" md-item-text=item.name md-min-length=0 placeholder=\"{{'entity-view.timeseries-placeholder' | translate }}\" md-menu-class=tb-timeseries-datakey-autocomplete> <span md-highlight-text=timeseriesDataKeySearchText md-highlight-flags=^i>{{item}}</span> </md-autocomplete> </md-chips> </md-expansion-panel-content> </md-expansion-panel-expanded> </md-expansion-panel> </md-expansion-panel-group> <section layout=row layout-align=\"start start\"> <mdp-date-picker ng-model=startTimeMs mdp-max-date=maxStartTimeMs mdp-placeholder=\"{{ 'entity-view.start-date' | translate }}\"></mdp-date-picker> <mdp-time-picker ng-model=startTimeMs mdp-max-date=maxStartTimeMs mdp-placeholder=\"{{ 'entity-view.start-ts' | translate }}\" mdp-auto-switch=true></mdp-time-picker> </section> <section layout=row layout-align=\"start start\"> <mdp-date-picker ng-model=endTimeMs mdp-min-date=minEndTimeMs mdp-placeholder=\"{{ 'entity-view.end-date' | translate }}\"></mdp-date-picker> <mdp-time-picker ng-model=endTimeMs mdp-min-date=minEndTimeMs mdp-placeholder=\"{{ 'entity-view.end-ts' | translate }}\" mdp-auto-switch=true></mdp-time-picker> </section> <md-input-container class=md-block> <label translate>entity-view.description</label> <textarea ng-model=entityView.additionalInfo.description rows=2></textarea> </md-input-container> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	var path = 'entity-view/entity-views.tpl.html';
	var html = " <tb-grid grid-configuration=vm.entityViewGridConfig> <details-buttons tb-help=\"'entityViews'\" help-container-id=help-container> <div id=help-container></div> </details-buttons> <md-tabs ng-class=\"{'tb-headless': vm.grid.detailsConfig.isDetailsEditMode}\" id=tabs md-border-bottom flex class=tb-absolute-fill> <md-tab label=\"{{ 'entity-view.details' | translate }}\"> <tb-entity-view entity-view=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode entity-view-scope=vm.entityViewsScope the-form=vm.grid.detailsForm on-assign-to-customer=\"vm.assignToCustomer(event, [ vm.grid.detailsConfig.currentItem.id.id ])\" on-make-public=\"vm.makePublic(event, vm.grid.detailsConfig.currentItem)\" on-unassign-from-customer=\"vm.unassignFromCustomer(event, vm.grid.detailsConfig.currentItem, isPublic)\" on-delete-entity-view=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"></tb-entity-view> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.attributes' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.entityView}} entity-name=vm.grid.operatingItem().name default-attribute-scope={{vm.types.attributesScope.client.value}}> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.latest-telemetry' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.entityView}} entity-name=vm.grid.operatingItem().name default-attribute-scope={{vm.types.latestTelemetry.value}} disable-attribute-scope-selection=true> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'alarm.alarms' | translate }}\"> <tb-alarm-table flex entity-type=vm.types.entityType.entityView entity-id=vm.grid.operatingItem().id.id> </tb-alarm-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'entity-view.events' | translate }}\"> <tb-event-table flex entity-type=vm.types.entityType.entityView entity-id=vm.grid.operatingItem().id.id tenant-id=vm.grid.operatingItem().tenantId.id default-event-type={{vm.types.eventType.error.value}}> </tb-event-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'relation.relations' | translate }}\"> <tb-relation-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.entityView}}> </tb-relation-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.grid.isTenantAdmin()\" md-on-select=vm.grid.triggerResize() label=\"{{ 'audit-log.audit-logs' | translate }}\"> <tb-audit-log-table flex entity-type=vm.types.entityType.entityView entity-id=vm.grid.operatingItem().id.id audit-log-mode={{vm.types.auditLogMode.entity}}> </tb-audit-log-table> </md-tab> </md-tabs></tb-grid> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	var path = 'entity/alias/aliases-entity-select-button.tpl.html';
	var html = " <section class=tb-aliases-entity-select layout=row layout-align=\"start center\"> <md-button class=md-icon-button aria-label=\"{{ 'entity.select-entities' | translate }}\" ng-click=openEditMode($event)> <md-tooltip md-direction={{tooltipDirection}}> {{ 'entity.select-entities' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'entity.select-entities' | translate }}\" class=material-icons>devices_other</md-icon> </md-button> <span hide-xs hide-sm hide-md ng-click=openEditMode($event)> <md-tooltip md-direction={{tooltipDirection}}> {{ 'entity.select-entities' | translate }} </md-tooltip> {{displayValue}} </span> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	var path = 'entity/alias/aliases-entity-select-panel.tpl.html';
	var html = " <md-content flex layout=column> <section flex layout=column> <md-content flex class=md-padding layout=column> <div flex layout=row ng-repeat=\"(aliasId, entityAliasInfo) in vm.entityAliasesInfo\"> <md-input-container flex> <label>{{entityAliasInfo.alias}}</label> <md-select ng-model=entityAliasInfo.selectedId ng-change=\"vm.currentAliasEntityChanged(aliasId, entityAliasInfo.selectedId)\"> <md-option ng-repeat=\"resolvedEntity in entityAliasInfo.resolvedEntities\" ng-value=resolvedEntity.id> {{resolvedEntity.name}} </md-option> </md-select> </md-input-container> </div> </md-content> </section> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	var path = 'entity/attribute/add-attribute-dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'attribute.add' | translate }}\" style=min-width:400px> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>attribute.add</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <md-content class=md-padding layout=column> <fieldset ng-disabled=$root.loading> <md-input-container class=md-block> <label translate>attribute.key</label> <input required name=key ng-model=vm.attribute.key> <div ng-messages=theForm.key.$error> <div translate ng-message=required>attribute.key-required</div> </div> </md-input-container> <section layout=row> <md-input-container flex=40 class=md-block style=width:200px> <label translate>value.type</label> <md-select ng-model=vm.valueType ng-disabled=$root.loading> <md-option ng-repeat=\"type in vm.valueTypes\" ng-value=type> <md-icon md-svg-icon=\"{{ type.icon }}\"></md-icon> <span>{{type.name | translate}}</span> </md-option> </md-select> </md-input-container> <md-input-container ng-if=\"vm.valueType===vm.valueTypes.string\" flex=60 class=md-block> <label translate>value.string-value</label> <input required name=value ng-model=vm.attribute.value> <div ng-messages=theForm.value.$error> <div translate ng-message=required>attribute.value-required</div> </div> </md-input-container> <md-input-container ng-if=\"vm.valueType===vm.valueTypes.integer\" flex=60 class=md-block> <label translate>value.integer-value</label> <input required name=value type=number step=1 ng-pattern=/^-?[0-9]+$/ ng-model=vm.attribute.value> <div ng-messages=theForm.value.$error> <div translate ng-message=required>attribute.value-required</div> <div translate ng-message=pattern>value.invalid-integer-value</div> </div> </md-input-container> <md-input-container ng-if=\"vm.valueType===vm.valueTypes.double\" flex=60 class=md-block> <label translate>value.double-value</label> <input required name=value type=number step=any ng-model=vm.attribute.value> <div ng-messages=theForm.value.$error> <div translate ng-message=required>attribute.value-required</div> </div> </md-input-container> <div layout=column layout-align=center flex=60 ng-if=\"vm.valueType===vm.valueTypes.boolean\"> <md-checkbox ng-model=vm.attribute.value style=margin-bottom:0> {{ (vm.attribute.value ? 'value.true' : 'value.false') | translate }} </md-checkbox> </div> </section> </fieldset> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	var path = 'entity/attribute/add-widget-to-dashboard-dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'attribute.add-widget-to-dashboard' | translate }}\" style=min-width:400px> <form name=theForm ng-submit=vm.add($event)> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>attribute.add-widget-to-dashboard</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <md-content class=md-padding layout=column> <fieldset ng-disabled=$root.loading> <md-radio-group ng-model=vm.addToDashboardType class=md-primary> <md-radio-button flex ng-value=0 class=\"md-primary md-align-top-left md-radio-interactive\"> <section flex layout=column style=width:300px> <span translate style=padding-bottom:10px>dashboard.select-existing</span> <tb-dashboard-autocomplete the-form=theForm ng-disabled=\"$root.loading || vm.addToDashboardType != 0\" tb-required=\"vm.addToDashboardType === 0\" ng-model=vm.dashboardId select-first-dashboard=false> </tb-dashboard-autocomplete> </section> </md-radio-button> <md-radio-button flex ng-value=1 class=\"md-primary md-align-top-left md-radio-interactive\"> <section flex layout=column style=width:300px> <span translate>dashboard.create-new</span> <md-input-container class=md-block> <label translate>dashboard.new-dashboard-title</label> <input ng-required=\"vm.addToDashboardType === 1\" name=title ng-model=vm.newDashboard.title> <div ng-messages=theForm.title.$error> <div translate ng-message=required>dashboard.title-required</div> </div> </md-input-container> </section> </md-radio-button> </md-radio-group> </fieldset> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-checkbox ng-model=vm.openDashboard aria-label=\"{{ 'dashboard.open-dashboard' | translate }}\" style=margin-bottom:0;padding-right:20px> {{ 'dashboard.open-dashboard' | translate }} </md-checkbox> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	var path = 'entity/attribute/attribute-table.tpl.html';
	var html = " <md-content flex class=\"md-padding tb-absolute-fill\" layout=column> <section ng-show=!disableAttributeScopeSelection> <md-input-container class=md-block style=width:200px> <label translate>attribute.attributes-scope</label> <md-select ng-model=attributeScope ng-disabled=\"$root.loading || attributeScopeSelectionReadonly\"> <md-option ng-repeat=\"scope in attributeScopes\" ng-value=scope> {{scope.name | translate}} </md-option> </md-select> </md-input-container> </section> <div class=\"md-whiteframe-z1 toolbarsContainer\" ng-class=\"{flex: mode==='widget'}\"> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"mode==='default'\n                                                                 && !selectedAttributes.length\n                                                                 && query.search === null\"> <div class=md-toolbar-tools> <span translate>{{ attributeScope.name }}</span> <span flex></span> <md-button ng-show=!attributeScope.clientSide class=md-icon-button ng-click=addAttribute($event)> <md-icon>add</md-icon> <md-tooltip md-direction=top> {{ 'action.add' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=enterFilterMode($event)> <md-icon>search</md-icon> <md-tooltip md-direction=top> {{ 'action.search' | translate }} </md-tooltip> </md-button> <md-button ng-show=!attributeScope.clientSide class=md-icon-button ng-click=getEntityAttributes()> <md-icon>refresh</md-icon> <md-tooltip md-direction=top> {{ 'action.refresh' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"mode==='default'\n                                                                 && !selectedAttributes.length\n                                                                 && query.search != null\"> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=top> {{ 'action.search' | translate }} </md-tooltip> </md-button> <md-input-container flex> <label>&nbsp;</label> <input ng-model=query.search class=searchInput placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <md-button class=md-icon-button aria-label=\"{{ 'action.back' | translate }}\" ng-click=exitFilterMode()> <md-icon aria-label=\"{{ 'action.close' | translate }}\" class=material-icons>close</md-icon> <md-tooltip md-direction=top> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"mode==='default' && selectedAttributes.length\"> <div class=md-toolbar-tools> <span translate=\"{{attributeScope === types.latestTelemetry\n                                    ? 'attribute.selected-telemetry'\n                                    : 'attribute.selected-attributes'}}\" translate-values=\"{count: selectedAttributes.length}\" translate-interpolation=messageformat></span> <span flex></span> <md-button ng-show=!attributeScope.clientSide class=md-icon-button ng-click=deleteAttributes($event)> <md-icon>delete</md-icon> <md-tooltip md-direction=top> {{ 'action.delete' | translate }} </md-tooltip> </md-button> <md-button class=\"md-accent md-hue-2 md-raised\" ng-click=enterWidgetMode()> <md-tooltip md-direction=top> {{ 'attribute.show-on-widget' | translate }} </md-tooltip> <md-icon>now_widgets</md-icon> <span translate>attribute.show-on-widget</span> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"mode==='widget'\"> <div class=md-toolbar-tools> <div flex layout=row layout-align=start> <span class=tb-details-subtitle>{{ 'widgets-bundle.current' | translate }}</span> <tb-widgets-bundle-select flex-offset=5 flex ng-model=widgetsBundle select-first-bundle=false select-bundle-alias=selectedWidgetsBundleAlias> </tb-widgets-bundle-select> </div> <md-button ng-show=\"widgetsList.length > 0\" class=\"md-accent md-hue-2 md-raised\" ng-click=addWidgetToDashboard($event)> <md-tooltip md-direction=top> {{ 'attribute.add-to-dashboard' | translate }} </md-tooltip> <md-icon>dashboard</md-icon> <span translate>attribute.add-to-dashboard</span> </md-button> <md-button class=md-icon-button aria-label=\"{{ 'action.back' | translate }}\" ng-click=exitWidgetMode()> <md-icon aria-label=\"{{ 'action.close' | translate }}\" class=material-icons>close</md-icon> <md-tooltip md-direction=top> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-table-container ng-show=\"mode!='widget'\"> <table class=tb-attribute-table md-table md-row-select multiple=\"\" ng-model=selectedAttributes md-progress=attributesDeferred.promise> <thead md-head md-order=query.order md-on-reorder=onReorder> <tr md-row> <th md-column md-order-by=lastUpdateTs><span translate>attribute.last-update-time</span></th> <th md-column md-order-by=key><span translate>attribute.key</span></th> <th md-column><span translate>attribute.value</span></th> </tr> </thead> <tbody md-body> <tr md-row md-select=attribute md-select-id=key md-auto-select ng-repeat=\"attribute in attributes.data\"> <td md-cell>{{attribute.lastUpdateTs | date : 'yyyy-MM-dd HH:mm:ss'}}</td> <td md-cell>{{attribute.key}}</td> <td md-cell class=tb-value-cell ng-click=\"editAttribute($event, attribute)\"> <span>{{attribute.value}}</span> <span ng-show=!attributeScope.clientSide><ng-md-icon size=16 icon=edit></ng-md-icon></span> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination ng-show=\"mode!='widget'\" md-limit=query.limit md-limit-options=\"[5, 10, 15]\" md-page=query.page md-total={{attributes.count}} md-on-paginate=onPaginate md-page-select> </md-table-pagination> <ul flex rn-carousel ng-if=\"mode==='widget'\" class=widgets-carousel rn-carousel-index=widgetsCarousel.index rn-carousel-buffered rn-carousel-transition=fadeAndSlide rn-swipe-disabled=true> <li ng-repeat=\"widgets in widgetsList\"> <tb-dashboard alias-controller=aliasController widgets=widgets columns=20 is-edit=false is-mobile-disabled=true is-edit-action-enabled=false is-remove-action-enabled=false> </tb-dashboard> </li> <span translate ng-if=\"widgetsLoaded &&\n                                   widgetsList.length === 0 &&\n                                   widgetsBundle\" layout-align=\"center center\" style=text-transform:uppercase;display:flex class=\"md-headline tb-absolute-fill\">widgets-bundle.empty</span> <span translate ng-if=!widgetsBundle layout-align=\"center center\" style=text-transform:uppercase;display:flex class=\"md-headline tb-absolute-fill\">widget.select-widgets-bundle</span> <div ng-show=\"widgetsList.length > 1\" style=position:absolute;left:0;height:100% layout=column layout-align=center> <md-button ng-show=\"widgetsCarousel.index > 0\" class=md-icon-button ng-click=prevWidget()> <md-icon>navigate_before</md-icon> <md-tooltip md-direction=top> {{ 'attribute.prev-widget' | translate }} </md-tooltip> </md-button> </div> <div ng-show=\"widgetsList.length > 1\" style=position:absolute;right:0;height:100% layout=column layout-align=center> <md-button ng-show=\"widgetsCarousel.index < widgetsList.length-1\" class=md-icon-button ng-click=nextWidget()> <md-icon>navigate_next</md-icon> <md-tooltip md-direction=top> {{ 'attribute.next-widget' | translate }} </md-tooltip> </md-button> </div> <div style=position:absolute;bottom:0;width:100%;font-size:24px layout=row layout-align=center> <div rn-carousel-indicators ng-if=\"widgetsList.length > 1\" slides=widgetsList rn-carousel-index=widgetsCarousel.index> </div> </div> </ul> </div> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	var path = 'entity/attribute/edit-attribute-value.tpl.html';
	var html = " <md-edit-dialog> <form name=editDialog ng-submit=submit()> <div layout=column class=md-content style=width:400px> <fieldset> <section layout=row> <md-input-container flex=40 class=md-block> <label translate>value.type</label> <md-select ng-model=valueType> <md-option ng-repeat=\"type in valueTypes\" ng-value=type> <md-icon md-svg-icon=\"{{ type.icon }}\"></md-icon> <span>{{type.name | translate}}</span> </md-option> </md-select> </md-input-container> <md-input-container ng-if=\"valueType===valueTypes.string\" flex=60 class=md-block> <label translate>value.string-value</label> <input required name=value ng-model=model.value> <div ng-messages=editDialog.value.$error> <div translate ng-message=required>attribute.value-required</div> </div> </md-input-container> <md-input-container ng-if=\"valueType===valueTypes.integer\" flex=60 class=md-block> <label translate>value.integer-value</label> <input required name=value type=number step=1 ng-pattern=/^-?[0-9]+$/ ng-model=model.value> <div ng-messages=editDialog.value.$error> <div translate ng-message=required>attribute.value-required</div> <div translate ng-message=pattern>value.invalid-integer-value</div> </div> </md-input-container> <md-input-container ng-if=\"valueType===valueTypes.double\" flex=60 class=md-block> <label translate>value.double-value</label> <input required name=value type=number step=any ng-model=model.value> <div ng-messages=editDialog.value.$error> <div translate ng-message=required>attribute.value-required</div> </div> </md-input-container> <div layout=column layout-align=center flex=60 ng-if=\"valueType===valueTypes.boolean\"> <md-checkbox ng-model=model.value style=margin-bottom:0> {{ (model.value ? 'value.true' : 'value.false') | translate }} </md-checkbox> </div> </section> </fieldset> </div> <div layout=row layout-align=end class=md-actions> <md-button ng-click=dismiss()>{{ 'action.cancel' | translate }} </md-button> <md-button ng-disabled=\"editDialog.$invalid || !editDialog.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.update' | translate }} </md-button> </div> </form> </md-edit-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	var path = 'entity/entity-autocomplete.tpl.html';
	var html = " <md-autocomplete ng-required=tbRequired ng-disabled=disabled md-no-cache=true md-input-name=entity ng-model=entity md-selected-item=entity md-search-text=entitySearchText md-search-text-change=entitySearchTextChanged() md-items=\"item in fetchEntities(entitySearchText)\" md-item-text=item.name md-min-length=0 md-floating-label=\"{{ entityText | translate }}\" md-select-on-match=true md-menu-class=tb-entity-autocomplete> <md-item-template> <div class=tb-entity-item> <span md-highlight-text=entitySearchText md-highlight-flags=^i>{{item.name}}</span> </div> </md-item-template> <md-not-found> <div class=tb-not-found> <span translate translate-values=\"{ entity: entitySearchText }\">{{ noEntitiesMatchingText }}</span> </div> </md-not-found> <div ng-messages=theForm.entity.$error> <div translate ng-message=required>{{ entityRequiredText }}</div> </div> </md-autocomplete> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	var path = 'entity/entity-filter-view.tpl.html';
	var html = " <div layout=column class=tb-entity-filter-view> <div ng-if=\"!filter || !filter.type\" class=entity-filter-empty translate>alias.no-entity-filter-specified</div> <div ng-if=\"filter && filter.type\" layout=column> <div class=entity-filter-value>{{ filterDisplayValue }}</div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	var path = 'entity/entity-filter.tpl.html';
	var html = " <div layout=column class=tb-entity-filter> <md-input-container class=md-block> <label>{{ 'alias.filter-type' | translate }}</label> <md-select required name=filterType ng-model=filter.type aria-label=\"{{ 'alias.filter-type' | translate }}\"> <md-option ng-repeat=\"type in aliasFilterTypes\" ng-value=type.value> {{type.name | translate}} </md-option> </md-select> <div ng-messages=theForm.filterType.$error> <div ng-message=required translate>alias.filter-type-required</div> </div> </md-input-container> <section layout=column ng-if=\"filter.type == types.aliasFilterType.singleEntity.value\" id=singleEntityFilter> <tb-entity-select flex the-form=theForm tb-required=true use-alias-entity-types=true ng-model=filter.singleEntity> </tb-entity-select> </section> <section layout=column ng-if=\"filter.type == types.aliasFilterType.entityList.value\" id=entityListFilter> <tb-entity-type-select ng-model=filter.entityType the-form=theForm tb-required=true allowed-entity-types=allowedEntityTypes> </tb-entity-type-select> <tb-entity-list ng-model=filter.entityList tb-required=true entity-type=filter.entityType> </tb-entity-list> </section> <section flex layout=column ng-if=\"filter.type == types.aliasFilterType.entityName.value\" id=entityNameFilter> <tb-entity-type-select ng-model=filter.entityType the-form=theForm tb-required=true allowed-entity-types=allowedEntityTypes> </tb-entity-type-select> <md-input-container class=md-block> <label translate>entity.name-starts-with</label> <input required name=entityNameFilter ng-model=filter.entityNameFilter aria-label=\"{{ 'entity.name-starts-with' | translate }}\"> <div ng-messages=theForm.entityNameFilter.$error> <div ng-message=required translate>entity.entity-name-filter-required</div> </div> </md-input-container> </section> <section layout=column ng-if=\"filter.type == types.aliasFilterType.stateEntity.value\" id=stateEntityFilter> <md-input-container class=md-block> <label translate>alias.state-entity-parameter-name</label> <input name=stateEntityParamName placeholder=\"{{ 'alias.default-entity-parameter-name' | translate }}\" ng-model=filter.stateEntityParamName aria-label=\"{{ 'alias.state-entity-parameter-name' | translate }}\"> </md-input-container> <div layout=column> <label class=tb-small>{{ 'alias.default-state-entity' | translate }}</label> <tb-entity-select flex the-form=theForm tb-required=false use-alias-entity-types=true ng-model=filter.defaultStateEntity> </tb-entity-select> </div> </section> <section layout=column ng-if=\"filter.type == types.aliasFilterType.assetType.value\" id=assetTypeFilter> <tb-entity-subtype-autocomplete tb-required=true the-form=theForm ng-model=filter.assetType entity-type=types.entityType.asset> </tb-entity-subtype-autocomplete> <md-input-container class=md-block> <label translate>asset.name-starts-with</label> <input name=assetNameFilter ng-model=filter.assetNameFilter aria-label=\"{{ 'asset.name-starts-with' | translate }}\"> </md-input-container> </section> <section layout=column ng-if=\"filter.type == types.aliasFilterType.deviceType.value\" id=deviceTypeFilter> <tb-entity-subtype-autocomplete tb-required=true the-form=theForm ng-model=filter.deviceType entity-type=types.entityType.device> </tb-entity-subtype-autocomplete> <md-input-container class=md-block> <label translate>device.name-starts-with</label> <input name=deviceNameFilter ng-model=filter.deviceNameFilter aria-label=\"{{ 'device.name-starts-with' | translate }}\"> </md-input-container> </section> <section layout=column ng-if=\"filter.type == types.aliasFilterType.entityViewType.value\" id=entityViewTypeFilter> <tb-entity-subtype-autocomplete tb-required=true the-form=theForm ng-model=filter.entityViewType entity-type=types.entityType.entityView> </tb-entity-subtype-autocomplete> <md-input-container class=md-block> <label translate>entity-view.name-starts-with</label> <input name=entityViewNameFilter ng-model=filter.entityViewNameFilter aria-label=\"{{ 'entity-view.name-starts-with' | translate }}\"> </md-input-container> </section> <section layout=column ng-if=\"filter.type == types.aliasFilterType.relationsQuery.value\" id=relationsQueryFilter> <label class=tb-small>{{ 'alias.root-entity' | translate }}</label> <section class=tb-root-state-entity-switch layout=row layout-align=\"start center\" style=padding-left:0> <md-switch class=root-state-entity-switch ng-model=filter.rootStateEntity aria-label=\"{{ 'alias.root-state-entity' | translate }}\"> </md-switch> <label class=\"tb-small root-state-entity-label\" translate>alias.root-state-entity</label> </section> <div flex layout=row ng-if=!filter.rootStateEntity> <tb-entity-select flex the-form=theForm tb-required=!filter.rootStateEntity ng-disabled=filter.rootStateEntity use-alias-entity-types=true ng-model=filter.rootEntity> </tb-entity-select> </div> <div flex layout=row ng-if=filter.rootStateEntity> <md-input-container class=md-block style=margin-top:32px> <label translate>alias.state-entity-parameter-name</label> <input name=stateEntityParamName placeholder=\"{{ 'alias.default-entity-parameter-name' | translate }}\" ng-model=filter.stateEntityParamName aria-label=\"{{ 'alias.state-entity-parameter-name' | translate }}\"> </md-input-container> <div flex layout=column> <label class=tb-small>{{ 'alias.default-state-entity' | translate }}</label> <tb-entity-select flex the-form=theForm tb-required=false use-alias-entity-types=true ng-model=filter.defaultStateEntity> </tb-entity-select> </div> </div> <div flex layout=row> <md-input-container class=md-block style=min-width:100px> <label translate>relation.direction</label> <md-select required ng-model=filter.direction> <md-option ng-repeat=\"direction in types.entitySearchDirection\" ng-value=direction> {{ ('relation.search-direction.' + direction) | translate}} </md-option> </md-select> </md-input-container> <md-input-container flex class=md-block> <label translate>alias.max-relation-level</label> <input name=maxRelationLevel type=number min=1 step=1 placeholder=\"{{ 'alias.unlimited-level' | translate }}\" ng-model=filter.maxLevel aria-label=\"{{ 'alias.max-relation-level' | translate }}\"> </md-input-container> </div> <div class=md-caption style=padding-bottom:10px;color:rgba(0,0,0,.57) translate>relation.relation-filters</div> <tb-relation-filters ng-model=filter.filters allowed-entity-types=allowedEntityTypes> </tb-relation-filters> </section> <section layout=column ng-if=\"filter.type == types.aliasFilterType.assetSearchQuery.value\" id=assetSearchQueryFilter> <label class=tb-small>{{ 'alias.root-entity' | translate }}</label> <section class=tb-root-state-entity-switch layout=row layout-align=\"start center\" style=padding-left:0> <md-switch class=root-state-entity-switch ng-model=filter.rootStateEntity aria-label=\"{{ 'alias.root-state-entity' | translate }}\"> </md-switch> <label class=\"tb-small root-state-entity-label\" translate>alias.root-state-entity</label> </section> <div flex layout=row ng-if=!filter.rootStateEntity> <tb-entity-select flex the-form=theForm tb-required=!filter.rootStateEntity ng-disabled=filter.rootStateEntity use-alias-entity-types=true ng-model=filter.rootEntity> </tb-entity-select> </div> <div flex layout=row ng-if=filter.rootStateEntity> <md-input-container class=md-block style=margin-top:32px> <label translate>alias.state-entity-parameter-name</label> <input name=stateEntityParamName placeholder=\"{{ 'alias.default-entity-parameter-name' | translate }}\" ng-model=filter.stateEntityParamName aria-label=\"{{ 'alias.state-entity-parameter-name' | translate }}\"> </md-input-container> <div flex layout=column> <label class=tb-small>{{ 'alias.default-state-entity' | translate }}</label> <tb-entity-select flex the-form=theForm tb-required=false use-alias-entity-types=true ng-model=filter.defaultStateEntity> </tb-entity-select> </div> </div> <div flex layout=row> <md-input-container class=md-block style=min-width:100px> <label translate>relation.direction</label> <md-select required ng-model=filter.direction> <md-option ng-repeat=\"direction in types.entitySearchDirection\" ng-value=direction> {{ ('relation.search-direction.' + direction) | translate}} </md-option> </md-select> </md-input-container> <md-input-container flex class=md-block> <label translate>alias.max-relation-level</label> <input name=maxRelationLevel type=number min=1 step=1 placeholder=\"{{ 'alias.unlimited-level' | translate }}\" ng-model=filter.maxLevel aria-label=\"{{ 'alias.max-relation-level' | translate }}\"> </md-input-container> </div> <div class=md-caption style=color:rgba(0,0,0,.57) translate>relation.relation-type</div> <tb-relation-type-autocomplete flex hide-label the-form=theForm ng-model=filter.relationType tb-required=false> </tb-relation-type-autocomplete> <div class=\"md-caption tb-required\" style=color:rgba(0,0,0,.57) translate>asset.asset-types</div> <tb-entity-subtype-list tb-required=true entity-type=types.entityType.asset ng-model=filter.assetTypes> </tb-entity-subtype-list> </section> <section layout=column ng-if=\"filter.type == types.aliasFilterType.deviceSearchQuery.value\" id=deviceSearchQueryFilter> <label class=tb-small>{{ 'alias.root-entity' | translate }}</label> <section class=tb-root-state-entity-switch layout=row layout-align=\"start center\" style=padding-left:0> <md-switch class=root-state-entity-switch ng-model=filter.rootStateEntity aria-label=\"{{ 'alias.root-state-entity' | translate }}\"> </md-switch> <label class=\"tb-small root-state-entity-label\" translate>alias.root-state-entity</label> </section> <div flex layout=row ng-if=!filter.rootStateEntity> <tb-entity-select flex the-form=theForm tb-required=!filter.rootStateEntity ng-disabled=filter.rootStateEntity use-alias-entity-types=true ng-model=filter.rootEntity> </tb-entity-select> </div> <div flex layout=row ng-if=filter.rootStateEntity> <md-input-container class=md-block style=margin-top:32px> <label translate>alias.state-entity-parameter-name</label> <input name=stateEntityParamName placeholder=\"{{ 'alias.default-entity-parameter-name' | translate }}\" ng-model=filter.stateEntityParamName aria-label=\"{{ 'alias.state-entity-parameter-name' | translate }}\"> </md-input-container> <div flex layout=column> <label class=tb-small>{{ 'alias.default-state-entity' | translate }}</label> <tb-entity-select flex the-form=theForm tb-required=false use-alias-entity-types=true ng-model=filter.defaultStateEntity> </tb-entity-select> </div> </div> <div flex layout=row> <md-input-container class=md-block style=min-width:100px> <label translate>relation.direction</label> <md-select required ng-model=filter.direction> <md-option ng-repeat=\"direction in types.entitySearchDirection\" ng-value=direction> {{ ('relation.search-direction.' + direction) | translate}} </md-option> </md-select> </md-input-container> <md-input-container flex class=md-block> <label translate>alias.max-relation-level</label> <input name=maxRelationLevel type=number min=1 step=1 placeholder=\"{{ 'alias.unlimited-level' | translate }}\" ng-model=filter.maxLevel aria-label=\"{{ 'alias.max-relation-level' | translate }}\"> </md-input-container> </div> <div class=md-caption style=color:rgba(0,0,0,.57) translate>relation.relation-type</div> <tb-relation-type-autocomplete flex hide-label the-form=theForm ng-model=filter.relationType tb-required=false> </tb-relation-type-autocomplete> <div class=\"md-caption tb-required\" style=color:rgba(0,0,0,.57) translate>device.device-types</div> <tb-entity-subtype-list tb-required=true entity-type=types.entityType.device ng-model=filter.deviceTypes> </tb-entity-subtype-list> </section> <section layout=column ng-if=\"filter.type == types.aliasFilterType.entityViewSearchQuery.value\" id=entityViewSearchQueryFilter> <label class=tb-small>{{ 'alias.root-entity' | translate }}</label> <section class=tb-root-state-entity-switch layout=row layout-align=\"start center\" style=padding-left:0> <md-switch class=root-state-entity-switch ng-model=filter.rootStateEntity aria-label=\"{{ 'alias.root-state-entity' | translate }}\"> </md-switch> <label class=\"tb-small root-state-entity-label\" translate>alias.root-state-entity</label> </section> <div flex layout=row ng-if=!filter.rootStateEntity> <tb-entity-select flex the-form=theForm tb-required=!filter.rootStateEntity ng-disabled=filter.rootStateEntity use-alias-entity-types=true ng-model=filter.rootEntity> </tb-entity-select> </div> <div flex layout=row ng-if=filter.rootStateEntity> <md-input-container class=md-block style=margin-top:32px> <label translate>alias.state-entity-parameter-name</label> <input name=stateEntityParamName placeholder=\"{{ 'alias.default-entity-parameter-name' | translate }}\" ng-model=filter.stateEntityParamName aria-label=\"{{ 'alias.state-entity-parameter-name' | translate }}\"> </md-input-container> <div flex layout=column> <label class=tb-small>{{ 'alias.default-state-entity' | translate }}</label> <tb-entity-select flex the-form=theForm tb-required=false use-alias-entity-types=true ng-model=filter.defaultStateEntity> </tb-entity-select> </div> </div> <div flex layout=row> <md-input-container class=md-block style=min-width:100px> <label translate>relation.direction</label> <md-select required ng-model=filter.direction> <md-option ng-repeat=\"direction in types.entitySearchDirection\" ng-value=direction> {{ ('relation.search-direction.' + direction) | translate}} </md-option> </md-select> </md-input-container> <md-input-container flex class=md-block> <label translate>alias.max-relation-level</label> <input name=maxRelationLevel type=number min=1 step=1 placeholder=\"{{ 'alias.unlimited-level' | translate }}\" ng-model=filter.maxLevel aria-label=\"{{ 'alias.max-relation-level' | translate }}\"> </md-input-container> </div> <div class=md-caption style=color:rgba(0,0,0,.57) translate>relation.relation-type</div> <tb-relation-type-autocomplete flex hide-label the-form=theForm ng-model=filter.relationType tb-required=false> </tb-relation-type-autocomplete> <div class=\"md-caption tb-required\" style=color:rgba(0,0,0,.57) translate>entity-view.entity-view-types</div> <tb-entity-subtype-list tb-required=true entity-type=types.entityType.entityView ng-model=filter.entityViewTypes> </tb-entity-subtype-list> </section> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	var path = 'entity/entity-list.tpl.html';
	var html = " <section flex layout=column class=tb-entity-list> <md-chips flex readonly=disabled id=entity_list_chips ng-required=tbRequired ng-model=entityList md-autocomplete-snap md-require-match=true> <md-autocomplete md-no-cache=true id=entity md-selected-item=selectedEntity md-search-text=entitySearchText md-items=\"item in fetchEntities(entitySearchText, 10)\" md-item-text=item.name md-min-length=0 placeholder=\"{{ 'entity.entity-list' | translate }}\"> <md-item-template> <span md-highlight-text=entitySearchText md-highlight-flags=^i>{{item.name}}</span> </md-item-template> <md-not-found> <span translate translate-values=\"{ entity: entitySearchText }\">entity.no-entities-matching</span> </md-not-found> </md-autocomplete> <md-chip-template> <span> <strong>{{$chip.name}}</strong> </span> </md-chip-template> </md-chips> <div class=tb-error-messages ng-messages=ngModelCtrl.$error ng-if=inputTouched role=alert> <div translate ng-message=entityList class=tb-error-message>entity.entity-list-empty</div> </div> </section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	var path = 'entity/entity-select.tpl.html';
	var html = " <div layout=row class=tb-entity-select> <tb-entity-type-select style=min-width:100px ng-if=displayEntityTypeSelect the-form=theForm ng-disabled=disabled tb-required=tbRequired use-alias-entity-types=useAliasEntityTypes allowed-entity-types=allowedEntityTypes ng-model=model.entityType> </tb-entity-type-select> <tb-entity-autocomplete flex ng-if=model.entityType the-form=theForm ng-disabled=disabled tb-required=tbRequired entity-type=model.entityType ng-model=model.entityId> </tb-entity-autocomplete> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	var path = 'entity/entity-subtype-autocomplete.tpl.html';
	var html = " <md-autocomplete ng-required=tbRequired ng-disabled=disabled md-no-cache=true md-input-name=subType ng-model=subType md-selected-item=subType md-search-text=subTypeSearchText md-search-text-change=subTypeSearchTextChanged() md-items=\"item in fetchSubTypes(subTypeSearchText)\" md-item-text=item md-min-length=0 placeholder=\"{{ selectEntitySubtypeText | translate }}\" md-floating-label=\"{{ entitySubtypeText | translate }}\" md-select-on-match=true md-menu-class=tb-entity-subtype-autocomplete> <md-item-template> <div class=tb-entity-subtype-item> <span md-highlight-text=subTypeSearchText md-highlight-flags=^i>{{item}}</span> </div> </md-item-template> <div ng-messages=theForm.subType.$error> <div translate ng-message=required>{{ entitySubtypeRequiredText }}</div> </div> </md-autocomplete> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

	var path = 'entity/entity-subtype-list.tpl.html';
	var html = " <section flex layout=column class=tb-entity-subtype-list> <md-chips flex readonly=disabled id=entity_subtype_list_chips ng-required=tbRequired ng-model=entitySubtypesList placeholder={{placeholder}} secondary-placeholder={{secondaryPlaceholder}} md-autocomplete-snap md-require-match=false> <md-autocomplete md-no-cache=true id=entitySubtype md-selected-item=selectedEntitySubtype md-search-text=entitySubtypeSearchText md-items=\"item in fetchEntitySubtypes(entitySubtypeSearchText)\" md-item-text=item md-min-length=0 placeholder=\"{{ (!entitySubtypesList || !entitySubtypesList.length) ? placeholder : secondaryPlaceholder }}\"> <md-item-template> <span md-highlight-text=entitySubtypeSearchText md-highlight-flags=^i>{{item}}</span> </md-item-template> <md-not-found> <span translate translate-values=\"{ entitySubtype: entitySubtypeSearchText }\">{{noSubtypesMathingText}}</span> </md-not-found> </md-autocomplete> <md-chip-template> <span> <strong>{{$chip}}</strong> </span> </md-chip-template> </md-chips> <div class=tb-error-messages ng-messages=ngModelCtrl.$error ng-if=\"inputTouched && tbRequired\" role=alert> <div translate ng-message=entitySubtypesList class=tb-error-message>{{subtypeListEmptyText}}</div> </div> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	var path = 'entity/entity-subtype-select.tpl.html';
	var html = " <md-input-container> <label ng-if=showLabel>{{ entitySubtypeTitle | translate }}</label> <md-select name=subType ng-model=entitySubtype class=tb-entity-subtype-select aria-label=\"{{ entitySubtypeTitle | translate }}\"> <md-option ng-repeat=\"subType in entitySubtypes\" ng-value=subType> {{ subTypeName(subType) }} </md-option> </md-select> <div ng-messages=theForm.subType.$error> <div ng-message=required translate>{{ entitySubtypeRequiredText }}</div> </div> </md-input-container> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	var path = 'entity/entity-type-list.tpl.html';
	var html = " <section flex layout=column class=tb-entity-type-list> <md-chips readonly=disabled id=entity_type_list_chips ng-required=tbRequired ng-model=entityTypeList placeholder={{placeholder}} secondary-placeholder={{secondaryPlaceholder}} md-autocomplete-snap md-require-match=true> <md-autocomplete md-no-cache=true id=entityType md-selected-item=selectedEntityType md-search-text=entityTypeSearchText md-items=\"item in fetchEntityTypes(entityTypeSearchText)\" md-item-text=item.name md-min-length=0 placeholder=\"{{ (!entityTypeList || !entityTypeList.length) ? placeholder : secondaryPlaceholder }}\"> <md-item-template> <span md-highlight-text=entityTypeSearchText md-highlight-flags=^i>{{item.name}}</span> </md-item-template> <md-not-found> <span translate translate-values=\"{ entityType: entityTypeSearchText }\">entity.no-entity-types-matching</span> </md-not-found> </md-autocomplete> <md-chip-template> <span> <strong>{{$chip.name}}</strong> </span> </md-chip-template> </md-chips> <div class=tb-error-messages ng-messages=ngModelCtrl.$error ng-if=\"inputTouched && tbRequired\" role=alert> <div translate ng-message=entityTypeList class=tb-error-message>entity.entity-type-list-empty</div> </div> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	var path = 'entity/entity-type-select.tpl.html';
	var html = " <md-input-container> <label ng-if=showLabel>{{ 'entity.type' | translate }}</label> <md-select ng-required=tbRequired ng-disabled=disabled name=entityType ng-model=entityType class=tb-entity-type-select aria-label=\"{{ 'entity.type' | translate }}\"> <md-option ng-repeat=\"type in entityTypes\" ng-value=type> {{typeName(type) | translate}} </md-option> </md-select> <div ng-messages=theForm.entityType.$error> <div ng-message=required translate>entity.type-required</div> </div> </md-input-container> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	var path = 'entity/relation/relation-dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ (vm.isAdd ? 'relation.add' : 'relation.edit' ) | translate }}\" style=min-width:600px> <form name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{ vm.isAdd ? 'relation.add' : 'relation.edit'}}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <md-content class=md-padding layout=column> <fieldset ng-disabled=$root.loading> <tb-relation-type-autocomplete ng-disabled=!vm.isAdd ng-model=vm.relation.type tb-required=true ng-disabled=$root.loading> </tb-relation-type-autocomplete> <small>{{(vm.direction == vm.types.entitySearchDirection.from ? 'relation.to-entity' : 'relation.from-entity') | translate}}</small> <tb-entity-select flex ng-disabled=!vm.isAdd the-form=theForm tb-required=true ng-model=vm.targetEntityId> </tb-entity-select> <div class=md-caption style=padding-left:3px;padding-bottom:10px;color:rgba(0,0,0,.57) translate>relation.additional-info</div> <div flex class=tb-relation-additional-info-panel layout=column> <div flex id=tb-relation-additional-info ui-ace=vm.relationAdditionalInfoOptions ng-model=vm.additionalInfo> </div> </div> <div class=tb-error-messages ng-messages=theForm.$error role=alert> <div translate ng-message=additionalInfo class=tb-error-message>relation.invalid-additional-info</div> </div> </fieldset> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ (vm.isAdd ? 'action.add' : 'action.save') | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	var path = 'entity/relation/relation-filters.tpl.html';
	var html = " <div class=tb-relation-filters> <div class=header ng-show=relationFilters.length> <div layout=row layout-align=\"start center\"> <span class=cell style=width:200px;min-width:200px translate>relation.type</span> <span class=cell flex translate>entity.entity-types</span> <span class=cell style=width:40px;min-width:40px>&nbsp</span> </div> </div> <div class=body ng-show=relationFilters.length> <div class=row ng-form name=relationFilterForm flex layout=row layout-align=\"start center\" ng-repeat=\"filter in relationFilters track by $index\"> <div class=md-whiteframe-1dp flex layout=row layout-align=\"start center\"> <tb-relation-type-autocomplete class=cell style=width:200px;min-width:200px hide-label the-form=relationFilterForm ng-model=filter.relationType tb-required=false> </tb-relation-type-autocomplete> <tb-entity-type-list class=cell flex ng-model=filter.entityTypes allowed-entity-types=allowedEntityTypes tb-required=false> </tb-entity-type-list> <md-button ng-disabled=$root.loading class=\"md-icon-button md-primary\" style=width:40px;min-width:40px ng-click=\"removeFilter($event, filter)\" aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'relation.remove-relation-filter' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.remove' | translate }}\" class=material-icons> close </md-icon> </md-button> </div> </div> </div> <div class=any-filter ng-show=!relationFilters.length> <span layout-align=\"center center\" class=tb-prompt translate>relation.any-relation</span> </div> <div> <md-button ng-disabled=$root.loading class=\"md-primary md-raised\" ng-click=addFilter($event) aria-label=\"{{ 'action.add' | translate }}\"> <md-tooltip md-direction=top> {{ 'relation.add-relation-filter' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.add' | translate }}\" class=material-icons> add </md-icon> {{ 'action.add' | translate }} </md-button> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	var path = 'entity/relation/relation-table.tpl.html';
	var html = " <md-content flex class=\"md-padding tb-absolute-fill tb-relation-table tb-data-table\" layout=column> <section layout=row> <md-input-container class=md-block style=width:200px> <label translate>relation.direction</label> <md-select ng-model=vm.direction ng-disabled=$root.loading> <md-option ng-repeat=\"direction in vm.types.entitySearchDirection\" ng-value=direction> {{ ('relation.search-direction.' + direction) | translate}} </md-option> </md-select> </md-input-container> </section> <div layout=column class=\"md-whiteframe-z1 toolbarsContainer\"> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"!vm.selectedRelations.length\n                                                                 && vm.query.search === null\"> <div class=md-toolbar-tools> <span>{{(vm.direction == vm.types.entitySearchDirection.from ? 'relation.from-relations' : 'relation.to-relations') | translate}}</span> <span flex></span> <md-button class=md-icon-button ng-click=vm.addRelation($event)> <md-icon>add</md-icon> <md-tooltip md-direction=top> {{ 'action.add' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=vm.enterFilterMode($event)> <md-icon>search</md-icon> <md-tooltip md-direction=top> {{ 'action.search' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=vm.reloadRelations()> <md-icon>refresh</md-icon> <md-tooltip md-direction=top> {{ 'action.refresh' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"!vm.selectedRelations.length\n                                                                 && vm.query.search != null\"> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=top> {{ 'action.search' | translate }} </md-tooltip> </md-button> <md-input-container flex> <label>&nbsp;</label> <input ng-model=vm.query.search class=searchInput placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <md-button class=md-icon-button aria-label=\"{{ 'action.back' | translate }}\" ng-click=vm.exitFilterMode()> <md-icon aria-label=\"{{ 'action.close' | translate }}\" class=material-icons>close</md-icon> <md-tooltip md-direction=top> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar alternate\" ng-show=vm.selectedRelations.length> <div class=md-toolbar-tools> <span translate translate-values=\"{count: vm.selectedRelations.length}\" translate-interpolation=messageformat>relation.selected-relations</span> <span flex></span> <md-button class=md-icon-button ng-click=vm.deleteRelations($event)> <md-icon>delete</md-icon> <md-tooltip md-direction=top> {{ 'action.delete' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-table-container> <table md-table md-row-select multiple=\"\" ng-model=vm.selectedRelations md-progress=vm.relationsDeferred.promise> <thead md-head md-order=vm.query.order md-on-reorder=vm.onReorder> <tr md-row> <th md-column md-order-by=type><span translate>relation.type</span></th> <th md-column ng-if=\"vm.direction == vm.types.entitySearchDirection.from\" md-order-by=toEntityTypeName><span translate>relation.to-entity-type</span></th> <th md-column ng-if=\"vm.direction == vm.types.entitySearchDirection.to\" md-order-by=fromEntityTypeName><span translate>relation.from-entity-type</span></th> <th md-column ng-if=\"vm.direction == vm.types.entitySearchDirection.from\" md-order-by=toName><span translate>relation.to-entity-name</span></th> <th md-column ng-if=\"vm.direction == vm.types.entitySearchDirection.to\" md-order-by=fromName><span translate>relation.from-entity-name</span></th> <th md-column><span>&nbsp</span></th> </tr> </thead> <tbody md-body> <tr md-row md-select=relation md-select-id=relation md-auto-select ng-repeat=\"relation in vm.relations\"> <td md-cell>{{ relation.type }}</td> <td md-cell ng-if=\"vm.direction == vm.types.entitySearchDirection.from\">{{ relation.toEntityTypeName }}</td> <td md-cell ng-if=\"vm.direction == vm.types.entitySearchDirection.to\">{{ relation.fromEntityTypeName }}</td> <td md-cell ng-if=\"vm.direction == vm.types.entitySearchDirection.from\">{{ relation.toName }}</td> <td md-cell ng-if=\"vm.direction == vm.types.entitySearchDirection.to\">{{ relation.fromName }}</td> <td md-cell class=tb-action-cell> <md-button class=md-icon-button aria-label=\"{{ 'action.edit' | translate }}\" ng-click=\"vm.editRelation($event, relation)\"> <md-icon aria-label=\"{{ 'action.edit' | translate }}\" class=material-icons>edit</md-icon> <md-tooltip md-direction=top> {{ 'relation.edit' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button aria-label=\"{{ 'action.delete' | translate }}\" ng-click=\"vm.deleteRelation($event, relation)\"> <md-icon aria-label=\"{{ 'action.delete' | translate }}\" class=material-icons>delete</md-icon> <md-tooltip md-direction=top> {{ 'relation.delete' | translate }} </md-tooltip> </md-button> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=vm.query.limit md-limit-options=\"[5, 10, 15]\" md-page=vm.query.page md-total={{vm.relationsCount}} md-on-paginate=vm.onPaginate md-page-select> </md-table-pagination> </div> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	var path = 'entity/relation/relation-type-autocomplete.tpl.html';
	var html = " <md-autocomplete ng-required=tbRequired ng-disabled=disabled md-no-cache=true md-input-name=relationType ng-model=relationType md-selected-item=relationType md-search-text=relationTypeSearchText md-search-text-change=relationTypeSearchTextChanged() md-items=\"item in fetchRelationTypes(relationTypeSearchText)\" md-item-text=item md-min-length=0 md-floating-label=\"{{ tbRequired  ? ('relation.relation-type' | translate) : ( !relationType ? ('relation.any-relation-type' | translate) : ' ') }}\" md-select-on-match=true md-menu-class=tb-relation-type-autocomplete> <md-item-template> <div class=tb-relation-type-item> <span md-highlight-text=relationTypeSearchText md-highlight-flags=^i>{{item}}</span> </div> </md-item-template> <div ng-messages=theForm.relationType.$error> <div translate ng-message=required>relation.relation-type-required</div> </div> </md-autocomplete> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	var path = 'event/event-content-dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ vm.title | translate }}\"> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{ vm.title }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.close()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content> <div flex id=tb-event-content readonly=readonly ui-ace=vm.contentOptions ng-model=vm.content> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=$root.loading ng-click=vm.close() style=margin-right:20px>{{ 'action.close' | translate }} </md-button> </md-dialog-actions> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	var path = 'event/event-header-debug-rulenode.tpl.html';
	var html = " <div hide-xs hide-sm translate class=tb-cell flex=25>event.event-time</div> <div translate class=tb-cell flex=20>event.server</div> <div translate class=tb-cell flex=10>event.type</div> <div translate class=tb-cell flex=15>event.entity</div> <div translate class=tb-cell flex=20>event.message-id</div> <div translate class=tb-cell flex=20>event.message-type</div> <div translate class=tb-cell flex=15>event.relation-type</div> <div translate class=tb-cell flex=10>event.data</div> <div translate class=tb-cell flex=10>event.metadata</div> <div translate class=tb-cell flex=10>event.error</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	var path = 'event/event-header-error.tpl.html';
	var html = " <div translate class=tb-cell flex=30>event.event-time</div> <div translate class=tb-cell flex=20>event.server</div> <div translate class=tb-cell flex=20>event.method</div> <div translate class=tb-cell flex=20>event.error</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	var path = 'event/event-header-lc-event.tpl.html';
	var html = " <div translate class=tb-cell flex=30>event.event-time</div> <div translate class=tb-cell flex=20>event.server</div> <div translate class=tb-cell flex=20>event.event</div> <div translate class=tb-cell flex=20>event.status</div> <div translate class=tb-cell flex=20>event.error</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	var path = 'event/event-header-stats.tpl.html';
	var html = " <div translate class=tb-cell flex>event.event-time</div> <div translate class=tb-cell flex>event.server</div> <div translate class=\"tb-cell tb-number\" flex>event.messages-processed</div> <div translate class=\"tb-cell tb-number\" flex>event.errors-occurred</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	var path = 'event/event-row-debug-rulenode.tpl.html';
	var html = " <div hide-xs hide-sm class=tb-cell flex=25>{{event.createdTime | date : 'yyyy-MM-dd HH:mm:ss'}}</div> <div class=tb-cell flex=20>{{event.body.server}}</div> <div class=tb-cell flex=10>{{event.body.type}}</div> <div class=tb-cell flex=15>{{event.body.entityName}}</div> <div class=\"tb-cell tb-nowrap\" flex=20 ng-mouseenter=checkTooltip($event)>{{event.body.msgId}}</div> <div class=tb-cell flex=20 ng-mouseenter=checkTooltip($event)>{{event.body.msgType}}</div> <div class=tb-cell flex=15>{{event.body.relationType}}</div> <div class=tb-cell flex=10> <md-button ng-if=event.body.data class=\"md-icon-button md-primary\" ng-click=\"showContent($event, event.body.data, 'event.data', event.body.dataType)\" aria-label=\"{{ 'action.view' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.view' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.view' | translate }}\" class=material-icons> more_horiz </md-icon> </md-button> </div> <div class=tb-cell flex=10> <md-button ng-if=event.body.metadata class=\"md-icon-button md-primary\" ng-click=\"showContent($event, event.body.metadata, 'event.metadata', 'JSON')\" aria-label=\"{{ 'action.view' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.view' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.view' | translate }}\" class=material-icons> more_horiz </md-icon> </md-button> </div> <div class=tb-cell flex=10> <md-button ng-if=event.body.error class=\"md-icon-button md-primary\" ng-click=\"showContent($event, event.body.error, 'event.error')\" aria-label=\"{{ 'action.view' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.view' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.view' | translate }}\" class=material-icons> more_horiz </md-icon> </md-button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	var path = 'event/event-row-error.tpl.html';
	var html = " <div class=tb-cell flex=30>{{event.createdTime | date : 'yyyy-MM-dd HH:mm:ss'}}</div> <div class=tb-cell flex=20>{{event.body.server}}</div> <div class=tb-cell flex=20>{{event.body.method}}</div> <div class=tb-cell flex=20> <md-button ng-if=event.body.error class=\"md-icon-button md-primary\" ng-click=\"showContent($event, event.body.error, 'event.error')\" aria-label=\"{{ 'action.view' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.view' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.view' | translate }}\" class=material-icons> more_horiz </md-icon> </md-button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

	var path = 'event/event-row-lc-event.tpl.html';
	var html = " <div class=tb-cell flex=30>{{event.createdTime | date : 'yyyy-MM-dd HH:mm:ss'}}</div> <div class=tb-cell flex=20>{{event.body.server}}</div> <div class=tb-cell flex=20>{{event.body.event}}</div> <div translate class=tb-cell flex=20>{{event.body.success ? 'event.success' : 'event.failed'}}</div> <div class=tb-cell flex=20> <md-button ng-if=event.body.error class=\"md-icon-button md-primary\" ng-click=\"showContent($event, event.body.error, 'event.error')\" aria-label=\"{{ 'action.view' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.view' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.view' | translate }}\" class=material-icons> more_horiz </md-icon> </md-button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	var path = 'event/event-row-stats.tpl.html';
	var html = " <div class=tb-cell flex>{{event.createdTime | date : 'yyyy-MM-dd HH:mm:ss'}}</div> <div class=tb-cell flex>{{event.body.server}}</div> <div class=\"tb-cell tb-number\" flex>{{event.body.messagesProcessed}}</div> <div class=\"tb-cell tb-number\" flex>{{event.body.errorsOccurred}}</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	var path = 'event/event-table.tpl.html';
	var html = " <md-content flex class=\"md-padding tb-absolute-fill\" layout=column> <section layout=row> <md-input-container class=md-block style=width:200px> <label translate>event.event-type</label> <md-select ng-model=eventType ng-disabled=$root.loading> <md-option ng-repeat=\"type in eventTypes\" ng-value=type.value> {{type.name | translate}} </md-option> </md-select> </md-input-container> <tb-timewindow flex ng-model=timewindow history-only as-button=true></tb-timewindow> <md-button ng-disabled=$root.loading class=md-icon-button ng-click=reload()> <md-icon>refresh</md-icon> <md-tooltip md-direction=top> {{ 'action.refresh' | translate }} </md-tooltip> </md-button> </section> <md-list flex layout=column class=\"md-whiteframe-z1 tb-event-table\"> <md-list class=\"tb-row tb-header\" layout=row layout-align=\"start center\" tb-event-header event-type={{eventType}}> </md-list> <md-progress-linear style=max-height:0 md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <md-divider></md-divider> <span translate layout-align=\"center center\" style=margin-top:25px class=tb-prompt ng-show=noData()>event.no-events-prompt</span> <md-virtual-repeat-container ng-show=hasData() flex md-top-index=topIndex tb-scope-element=repeatContainer> <md-list-item md-virtual-repeat=\"event in theEvents\" md-on-demand flex ng-style=\"hasScroll() ? {'margin-right':'-15px'} : {}\"> <md-list class=tb-row flex layout=row layout-align=\"start center\" tb-event-row event-type={{eventType}} event={{event}}> </md-list> <md-divider flex></md-divider> </md-list-item> </md-virtual-repeat-container> </md-list> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

	var path = 'extension/extension-dialog.tpl.html';
	var html = " <md-dialog class=extensionDialog aria-label=\"{{ (vm.isAdd ? 'extension.add' : 'extension.edit' ) | translate }}\"> <form name=theForm ng-submit=vm.save() novalidate> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{ vm.isAdd ? 'extension.add' : 'extension.edit'}}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <md-content class=md-padding layout=column> <fieldset ng-disabled=$root.loading> <section flex layout=row> <md-input-container flex=60 class=md-block md-is-error=\"theForm.extensionId.$touched && theForm.extensionId.$invalid\"> <label translate>extension.extension-id</label> <input required name=extensionId ng-model=vm.extension.id ng-change=vm.validateId()> <div ng-messages=theForm.extensionId.$error> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=uniqueIdValidation>extension.unique-id-required</div> </div> </md-input-container> <md-input-container flex=40 class=md-block md-is-error=\"theForm.extensionType.$touched && theForm.extensionType.$invalid\"> <label translate>extension.extension-type</label> <md-select ng-disabled=!vm.isAdd required name=extensionType ng-change=vm.extensionTypeChange() ng-model=vm.extension.type> <md-option ng-repeat=\"(key,value) in vm.types.extensionType\" ng-value=value> {{value}} </md-option> </md-select> <div ng-messages=theForm.extensionType.$error> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <div tb-extension-form-http config=vm.extension.configuration is-add=vm.isAdd ng-if=\"vm.extension.type && vm.extension.type == vm.types.extensionType.http\"></div> <div tb-extension-form-mqtt config=vm.extension.configuration is-add=vm.isAdd ng-if=\"vm.extension.type && vm.extension.type == vm.types.extensionType.mqtt\"></div> <div tb-extension-form-opc configuration=vm.extension.configuration ng-if=\"vm.extension.type && vm.extension.type == vm.types.extensionType.opc\"></div> <div tb-extension-form-modbus configuration=vm.extension.configuration ng-if=\"vm.extension.type && vm.extension.type == vm.types.extensionType.modbus\"></div> </fieldset> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button type=submit class=\"md-raised md-primary\"> {{ (vm.isAdd ? 'action.add' : 'action.save') | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	var path = 'extension/extension-table.tpl.html';
	var html = " <md-content flex class=\"md-padding tb-absolute-fill tb-data-table extension-table\" layout=column> <div layout=column class=\"md-whiteframe-z1 toolbarsContainer\" ng-class=\"{'tb-absolute-fill' : vm.inWidget}\"> <md-toolbar ng-if=!vm.inWidget class=\"md-table-toolbar md-default\" ng-show=\"!vm.selectedExtensions.length\n                                                                                      && vm.query.search === null\"> <div class=md-toolbar-tools> <span translate>{{ 'extension.extensions' }}</span> <span flex></span> <md-button class=md-icon-button ng-click=vm.importExtensions($event)> <md-icon>file_upload</md-icon> <md-tooltip md-direction=top> {{ 'extension.import-extensions-configuration' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=vm.exportExtensions()> <md-icon>file_download</md-icon> <md-tooltip md-direction=top> {{ 'extension.export-extensions-configuration' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=vm.addExtension($event)> <md-icon>add</md-icon> <md-tooltip md-direction=top> {{ 'action.add' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=vm.enterFilterMode($event)> <md-icon>search</md-icon> <md-tooltip md-direction=top> {{ 'action.search' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=vm.reloadExtensions()> <md-icon>refresh</md-icon> <md-tooltip md-direction=top> {{ 'action.refresh' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"!vm.selectedExtensions.length\n                                                                 && vm.query.search != null\" ng-class=\"{'toolbar-widget' : vm.inWidget}\"> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=top> {{ 'action.search' | translate }} </md-tooltip> </md-button> <md-input-container flex> <label>&nbsp;</label> <input ng-model=vm.query.search class=searchInput placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> <md-button class=md-icon-button aria-label=\"{{ 'action.back' | translate }}\" ng-click=vm.exitFilterMode()> <md-icon aria-label=\"{{ 'action.close' | translate }}\" class=material-icons>close</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar alternate\" ng-show=vm.selectedExtensions.length ng-class=\"{'toolbar-widget' : vm.inWidget}\"> <div class=md-toolbar-tools> <span translate translate-values=\"{count: vm.selectedExtensions.length}\" translate-interpolation=messageformat>extension.selected-extensions</span> <span flex></span> <md-button class=md-icon-button ng-click=vm.deleteExtensions($event)> <md-icon>delete</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{ 'action.delete' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <div class=md-padding flex layout=row ng-class=\"{'sync-widget' : vm.inWidget}\"> <md-input-container flex=50 class=md-block> <label translate>extension.sync.status</label> <input ng-model=vm.syncStatus ng-class=\"{'extension__syncStatus--green':isSync, 'extension__syncStatus--red':!isSync}\" disabled=disabled> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.sync.last-sync-time</label> <input ng-model=vm.syncLastTime class=extension__syncStatus--black disabled=disabled> </md-input-container> </div> <md-table-container flex> <table md-table md-row-select multiple=\"\" ng-model=vm.selectedExtensions md-progress=vm.extensionsDeferred.promise> <thead md-head md-order=vm.query.order md-on-reorder=vm.onReorder> <tr md-row> <th md-column md-order-by=id><span translate>extension.id</span></th> <th md-column md-order-by=type><span translate>extension.type</span></th> <th md-column><span>&nbsp</span></th> </tr> </thead> <tbody md-body> <tr md-row md-select=extension md-select-id=extension md-auto-select ng-repeat=\"extension in vm.extensions\"> <td md-cell>{{ extension.id }}</td> <td md-cell>{{ extension.type }}</td> <td md-cell class=tb-action-cell> <md-button class=md-icon-button aria-label=\"{{ 'action.edit' | translate }}\" ng-click=\"vm.editExtension($event, extension)\"> <md-icon aria-label=\"{{ 'action.edit' | translate }}\" class=material-icons>edit</md-icon> <md-tooltip md-direction=top> {{ 'extension.edit' | translate }} </md-tooltip> </md-button> <md-button class=md-icon-button aria-label=\"{{ 'action.delete' | translate }}\" ng-click=\"vm.deleteExtension($event, extension)\"> <md-icon aria-label=\"{{ 'action.delete' | translate }}\" class=material-icons>delete</md-icon> <md-tooltip md-direction=top> {{ 'extension.delete' | translate }} </md-tooltip> </md-button> </td> </tr> </tbody> </table> <md-divider ng-if=vm.inWidget></md-divider> </md-table-container> <md-table-pagination md-limit=vm.query.limit md-limit-options=\"[5, 10, 15]\" md-page=vm.query.page md-total={{vm.extensionsCount}} md-on-paginate=vm.onPaginate md-page-select> </md-table-pagination> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	var path = 'extension/extensions-forms/extension-form-http.tpl.html';
	var html = " <md-card class=\"extension-form extension-http\"> <md-card-title> <md-card-title-text> <span translate class=md-headline>extension.configuration</span> </md-card-title-text> </md-card-title> <md-card-content> <v-accordion id=http-converter-configs-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=http-converters-pane expanded=true> <v-pane-header> {{ 'extension.converter-configurations' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"converterConfigs.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(configIndex, config) in converterConfigs\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=removeConverterConfig(config) ng-hide=\"converterConfigs.length < 2\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <md-input-container class=md-block md-is-error=\"theForm['httpConverterId_' + configIndex].$touched && theForm['httpConverterId_' + configIndex].$invalid\"> <label translate>extension.converter-id</label> <input required name=httpConverterId_{{configIndex}} ng-model=config.converterId> <div ng-messages=\"theForm['httpConverterId_' + configIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>extension.token</label> <input name=httpToken ng-model=config.token parse-to-null> </md-input-container> <v-accordion id=http-converters-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=http-converters-pane_{{configIndex}} expanded=true> <v-pane-header> {{ 'extension.converters' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"config.converters.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(converterIndex,converter) in config.converters\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeConverter(converter, config.converters)\" ng-hide=\"config.converters.length < 2\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <md-input-container class=md-block md-is-error=\"theForm['httpDeviceNameExp_' + configIndex + converterIndex].$touched && theForm['httpDeviceNameExp_' + configIndex + converterIndex].$invalid\"> <label translate>extension.device-name-expression</label> <input required name=httpDeviceNameExp_{{configIndex}}{{converterIndex}} ng-model=converter.deviceNameJsonExpression> <div ng-messages=\"theForm['httpDeviceNameExp_' + configIndex + converterIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container class=md-block md-is-error=\"theForm['httpDeviceTypeExp_' + configIndex + converterIndex].$touched && theForm['httpDeviceTypeExp_' + configIndex + converterIndex].$invalid\"> <label translate>extension.device-type-expression</label> <input required name=httpDeviceTypeExp_{{configIndex}}{{converterIndex}} ng-model=converter.deviceTypeJsonExpression> <div ng-messages=\"theForm['httpDeviceTypeExp_' + configIndex + converterIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <v-accordion id=http-attributes-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=http-attributes-pane_{{configIndex}}{{converterIndex}}> <v-pane-header> {{ 'extension.attributes' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"converter.attributes.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(attributeIndex, attribute) in converter.attributes\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeAttribute(attribute, converter.attributes)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=60 class=md-block md-is-error=\"theForm['httpAttributeKey_' + configIndex + converterIndex + attributeIndex].$touched && theForm['httpAttributeKey_' + configIndex + converterIndex + attributeIndex].$invalid\"> <label translate>extension.key</label> <input required name=httpAttributeKey_{{configIndex}}{{converterIndex}}{{attributeIndex}} ng-model=attribute.key> <div ng-messages=\"theForm['httpAttributeKey_' + configIndex + converterIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=40 class=md-block md-is-error=\"theForm['httpAttributeType_' + configIndex + converterIndex + attributeIndex].$touched && theForm['httpAttributeType_' + configIndex + converterIndex + attributeIndex].$invalid\"> <label translate>extension.type</label> <md-select required name=httpAttributeType_{{configIndex}}{{converterIndex}}{{attributeIndex}} ng-model=attribute.type> <md-option ng-repeat=\"(attrType, attrTypeValue) in types.extensionValueType\" ng-value=attrType> {{attrTypeValue | translate}} </md-option> </md-select> <div ng-messages=\"theForm['httpAttributeType_' + configIndex + converterIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=60 class=md-block md-is-error=\"theForm['httpAttributeValue_' + configIndex + converterIndex + attributeIndex].$touched && theForm['httpAttributeValue_' + configIndex + converterIndex + attributeIndex].$invalid\"> <label translate>extension.value</label> <input required name=httpAttributeValue_{{configIndex}}{{converterIndex}}{{attributeIndex}} ng-model=attribute.value> <div ng-messages=\"theForm['httpAttributeValue_' + configIndex + converterIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=40 class=md-block> <label translate>extension.transformer</label> <md-select name=httpAttributeTransformer ng-model=attribute.transformerType ng-change=transformerTypeChange(attribute)> <md-option ng-repeat=\"(transformerType, value) in types.extensionTransformerType\" ng-value=transformerType> {{value | translate}} </md-option> </md-select> </md-input-container> </section> <div ng-if='attribute.transformerType == \"custom\"'> <div class=md-caption style=padding-left:3px;padding-bottom:10px;color:rgba(0,0,0,.57) translate>extension.transformer-json</div> <div flex class=tb-extension-custom-transformer-panel> <div flex class=tb-extension-custom-transformer ui-ace=extensionCustomTransformerOptions ng-model=attribute.transformer name=attributeCustomTransformer_{{configIndex}}{{converterIndex}}{{attributeIndex}} ng-change='validateTransformer(attribute.transformer,\"attributeCustomTransformer_\" + configIndex + converterIndex + attributeIndex)' required> </div> </div> <div class=tb-error-messages ng-messages=\"theForm['attributeCustomTransformer_' + configIndex + converterIndex + attributeIndex].$error\" role=alert> <div ng-message=required class=tb-error-message translate>extension.json-required</div> <div ng-message=transformerJSON class=tb-error-message translate>extension.json-parse</div> </div> </div> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addAttribute(converter.attributes) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-attribute</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=http-timeseries-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=http-timeseries-pane_{{configIndex}}{{converterIndex}}> <v-pane-header> {{ 'extension.timeseries' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"converter.timeseries.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(timeseriesIndex, timeseries) in converter.timeseries\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeAttribute(timeseries, converter.timeseries)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=60 class=md-block md-is-error=\"theForm['httpTimeseriesKey_' + configIndex + converterIndex + timeseriesIndex].$touched && theForm['httpTimeseriesKey_' + configIndex + converterIndex + timeseriesIndex].$invalid\"> <label translate>extension.key</label> <input required name=httpTimeseriesKey_{{configIndex}}{{converterIndex}}{{timeseriesIndex}} ng-model=timeseries.key> <div ng-messages=\"theForm['httpTimeseriesKey_' + configIndex + converterIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=40 class=md-block md-is-error=\"theForm['httpTimeseriesType_' + configIndex + converterIndex + timeseriesIndex].$touched && theForm['httpTimeseriesType_' + configIndex + converterIndex + timeseriesIndex].$invalid\"> <label translate>extension.type</label> <md-select required name=httpTimeseriesType_{{configIndex}}{{converterIndex}}{{timeseriesIndex}} ng-model=timeseries.type> <md-option ng-repeat=\"(attrType, attrTypeValue) in types.extensionValueType\" ng-value=attrType> {{attrTypeValue | translate}} </md-option> </md-select> <div ng-messages=\"theForm['httpTimeseriesType_' + configIndex + converterIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=60 class=md-block md-is-error=\"theForm['httpTimeseriesValue_' + configIndex + converterIndex + timeseriesIndex].$touched && theForm['httpTimeseriesValue_' + configIndex + converterIndex + timeseriesIndex].$invalid\"> <label translate>extension.value</label> <input required name=httpTimeseriesValue_{{configIndex}}{{converterIndex}}{{timeseriesIndex}} ng-model=timeseries.value> <div ng-messages=\"theForm['httpTimeseriesValue_' + configIndex + converterIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=40 class=md-block> <label translate>extension.transformer</label> <md-select name=httpTimeseriesTransformer ng-model=timeseries.transformerType ng-change=transformerTypeChange(timeseries)> <md-option ng-repeat=\"(transformerType, value) in types.extensionTransformerType\" ng-value=transformerType> {{value | translate}} </md-option> </md-select> </md-input-container> </section> <div ng-if='timeseries.transformerType == \"custom\"'> <div class=md-caption style=padding-left:3px;padding-bottom:10px;color:rgba(0,0,0,.57) translate>extension.transformer-json</div> <div flex class=tb-extension-custom-transformer-panel> <div flex class=tb-extension-custom-transformer ui-ace=extensionCustomTransformerOptions ng-model=timeseries.transformer name=timeseriesCustomTransformer_{{configIndex}}{{converterIndex}}{{timeseriesIndex}} ng-change='validateTransformer(timeseries.transformer,\"timeseriesCustomTransformer_\" + configIndex + converterIndex + timeseriesIndex)' required> </div> </div> <div class=tb-error-messages ng-messages=\"theForm['timeseriesCustomTransformer_' + configIndex + converterIndex + timeseriesIndex].$error\" role=alert> <div ng-message=required class=tb-error-message translate>extension.json-required</div> <div ng-message=transformerJSON class=tb-error-message translate>extension.json-parse</div> </div> </div> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addAttribute(converter.timeseries) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-timeseries</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addConverter(config.converters) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-converter</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addConverterConfig() aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-config</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

	var path = 'extension/extensions-forms/extension-form-modbus.tpl.html';
	var html = " <md-card class=\"extension-form extension-modbus\"> <md-card-title> <md-card-title-text> <span translate class=md-headline>extension.configuration</span> </md-card-title-text> </md-card-title> <md-card-content> <v-accordion id=modbus-server-configs-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=modbus-servers-pane expanded=true> <v-pane-header> {{ 'extension.modbus-server' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"configuration.servers.length === 0\"> <span translate layout-align=\"center center\" class=tb-prompt>extension.modbus-add-server-prompt</span> </div> <div ng-if=\"configuration.servers.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(serverIndex, server) in configuration.servers\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeItem(server, configuration.servers)\" ng-hide=\"configuration.servers.length < 2\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <div layout=row> <md-input-container flex=50 class=\"md-block tb-container-for-select\"> <label translate>extension.modbus-transport</label> <md-select required name=transportType_{{serverIndex}} ng-model=server.transport.type ng-change=onTransportChanged(server)> <md-option ng-value=transportType ng-repeat=\"(transportType, transportValue) in types.extensionModbusTransports\"><span ng-bind=transportValue></span></md-option> </md-select> <div ng-messages=\"theForm['transportType_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </div> <div layout=row ng-if=\"server.transport.type == 'tcp' || server.transport.type == 'udp'\"> <md-input-container flex=33 class=md-block> <label translate>extension.host</label> <input required name=transportHost_{{serverIndex}} ng-model=server.transport.host> <div ng-messages=\"theForm['transportHost_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=33 class=md-block> <label translate>extension.port</label> <input type=number required name=transportPort_{{serverIndex}} ng-model=server.transport.port min=1 max=65535> <div ng-messages=\"theForm['transportPort_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.port-range</div> <div translate ng-message=max>extension.port-range</div> </div> </md-input-container> <md-input-container flex=33 class=md-block> <label translate>extension.timeout</label> <input type=number required name=transportTimeout_{{serverIndex}} ng-model=server.transport.timeout> <div ng-messages=\"theForm['transportTimeout_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </div> <div ng-if=\"server.transport.type == 'rtu'\"> <div layout=row> <md-input-container flex=70 class=md-block> <label translate>extension.modbus-port-name</label> <input required name=transportPortName_{{serverIndex}} ng-model=server.transport.portName> <div ng-messages=\"theForm['transportPortName_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=30 class=md-block> <label translate>extension.timeout</label> <input type=number required name=transportTimeout_{{serverIndex}} ng-model=server.transport.timeout> <div ng-messages=\"theForm['transportTimeout_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </div> <div layout=row> <md-input-container flex=50 class=\"md-block tb-container-for-select\"> <label translate>extension.modbus-encoding</label> <md-select required name=transportEncoding_{{serverIndex}} ng-model=server.transport.encoding> <md-option ng-value=encodingType ng-repeat=\"(encodingType, encodingValue) in types.extensionModbusRtuEncodings\"><span ng-bind=encodingValue></span></md-option> </md-select> <div ng-messages=\"theForm['transportEncoding_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=\"md-block tb-container-for-select\"> <label translate>extension.modbus-parity</label> <md-select name=transportParity_{{serverIndex}} ng-model=server.transport.parity> <md-option ng-repeat=\"(parityKey, parityValue) in types.extensionModbusRtuParities\" ng-value=parityValue> {{parityValue}} </md-option> </md-select> <div ng-messages=\"theForm['transportParity_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </div> <div layout=row> <md-input-container flex=33 class=md-block> <label translate>extension.modbus-baudrate</label> <input type=number required name=transportBaudRate_{{serverIndex}} ng-model=server.transport.baudRate> <div ng-messages=\"theForm['transportBaudRate_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=33 class=md-block> <label translate>extension.modbus-databits</label> <input type=number required name=transportDataBits_{{serverIndex}} ng-model=server.transport.dataBits min=7 max=8> <div ng-messages=\"theForm['transportDataBits_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.modbus-databits-range</div> <div translate ng-message=max>extension.modbus-databits-range</div> </div> </md-input-container> <md-input-container flex=33 class=md-block> <label translate>extension.modbus-stopbits</label> <input type=number required name=transportStopBits_{{serverIndex}} ng-model=server.transport.stopBits min=1 max=2> <div ng-messages=\"theForm['transportStopBits_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.modbus-stopbits-range</div> <div translate ng-message=max>extension.modbus-stopbits-range</div> </div> </md-input-container> </div> </div> <v-accordion id=modbus-mapping-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=modbus-mapping-pane_{{serverIndex}}> <v-pane-header> {{ 'extension.mapping' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"server.devices.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(deviceIndex, device) in server.devices\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeItem(device, server.devices)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <div flex layout=row> <md-input-container flex=80 class=md-block> <label translate>extension.modbus-device-name</label> <input required name=deviceName_{{serverIndex}}{{deviceIndex}} ng-model=device.deviceName> <div ng-messages=\"theForm['deviceName_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=20 class=md-block> <label translate>extension.modbus-unit-id</label> <input type=number required name=unitId_{{serverIndex}}{{deviceIndex}} ng-model=device.unitId min=1 max=247> <div ng-messages=\"theForm['unitId_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.modbus-unit-id-range</div> <div translate ng-message=max>extension.modbus-unit-id-range</div> </div> </md-input-container> </div> <div flex layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.modbus-attributes-poll-period</label> <input type=number required name=attributesPollPeriod_{{serverIndex}}{{deviceIndex}} ng-model=device.attributesPollPeriod min=1> <div ng-messages=\"theForm['attributesPollPeriod_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.modbus-poll-period-range</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.modbus-timeseries-poll-period</label> <input type=number required name=timeseriesPollPeriod_{{serverIndex}}{{deviceIndex}} ng-model=device.timeseriesPollPeriod min=1> <div ng-messages=\"theForm['timeseriesPollPeriod_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.modbus-poll-period-range</div> </div> </md-input-container> </div> <v-accordion id=modbus-attributes-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=modbus-attributes-pane_{{serverIndex}}{{deviceIndex}}> <v-pane-header> {{ 'extension.attributes' | translate }} </v-pane-header> <v-pane-content> <div ng-show=\"device.attributes.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(attributeIndex, attribute) in device.attributes\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeItem(attribute, device.attributes)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.modbus-tag</label> <input required name=modbusAttributeTag_{{serverIndex}}{{deviceIndex}}{{attributeIndex}} ng-model=attribute.tag> <div ng-messages=\"theForm['modbusAttributeTag_' + serverIndex + deviceIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=30 class=\"md-block tb-container-for-select\"> <label translate>extension.type</label> <md-select required name=modbusAttributeType_{{serverIndex}}{{deviceIndex}}{{attributeIndex}} ng-model=attribute.type> <md-option ng-repeat=\"(attrType, attrTypeValue) in types.extensionValueType\" ng-value=attrType> {{attrTypeValue | translate}} </md-option> </md-select> <div ng-messages=\"theForm['modbusAttributeType_' + serverIndex + deviceIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=20 class=md-block> <label translate>extension.modbus-poll-period</label> <input type=number name=pollPeriod_{{serverIndex}}{{deviceIndex}} ng-model=attribute.pollPeriod min=1> <div ng-messages=\"theForm['pollPeriod_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=min>extension.modbus-poll-period-range</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=50 class=\"md-block tb-container-for-select\"> <label translate>extension.type</label> <md-select required name=modbusAttributeFunctionCode_{{serverIndex}}{{deviceIndex}}{{attributeIndex}} ng-model=attribute.functionCode> <md-option ng-repeat=\"(functionCode, functionName) in types.extensionModbusFunctionCodes\" ng-value=functionCode> {{functionName}} </md-option> </md-select> <div ng-messages=\"theForm['modbusAttributeFunctionCode_' + serverIndex + deviceIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.modbus-register-address</label> <input type=number required name=address_{{serverIndex}}{{deviceIndex}} ng-model=attribute.address min=0 max=65535> <div ng-messages=\"theForm['address_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.modbus-register-address-range</div> <div translate ng-message=max>extension.modbus-register-address-range</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=50 class=md-block ng-if=\"attribute.type != 'boolean'\"> <label translate>extension.modbus-register-count</label> <input type=number name=registerCount_{{serverIndex}}{{deviceIndex}} ng-model=attribute.registerCount min=1> <div ng-messages=\"theForm['registerCount_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=min>extension.modbus-register-count-range</div> </div> </md-input-container> <md-input-container flex=50 class=md-block ng-if=\"attribute.type == 'boolean' && attribute.functionCode >= 3\"> <label translate>extension.modbus-register-bit-index</label> <input type=number required name=bit_{{serverIndex}}{{deviceIndex}} ng-model=attribute.bit min=0 max=15> <div ng-messages=\"theForm['bit_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.modbus-register-bit-index-range</div> <div translate ng-message=max>extension.modbus-register-bit-index-range</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=100 class=md-block ng-if=\"attribute.functionCode >= 3\"> <label translate>extension.modbus-byte-order</label> <input required name=modbusByteOrder_{{serverIndex}}{{deviceIndex}}{{attributeIndex}} ng-model=attribute.byteOrder> <div ng-messages=\"theForm['modbusByteOrder_' + serverIndex + deviceIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addNewAttribute(device) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-attribute</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=modbus-timeseries-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=modbus-timeseries-pane_{{serverIndex}}{{deviceIndex}}> <v-pane-header> {{ 'extension.timeseries' | translate }} </v-pane-header> <v-pane-content> <div ng-show=\"device.timeseries.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(timeseriesIndex, timeserie) in device.timeseries\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeItem(timeserie, device.timeseries)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.modbus-tag</label> <input required name=modbusTimeserieTag_{{serverIndex}}{{deviceIndex}}{{timeseriesIndex}} ng-model=timeserie.tag> <div ng-messages=\"theForm['modbusTimeserieTag_' + serverIndex + deviceIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=30 class=\"md-block tb-container-for-select\"> <label translate>extension.type</label> <md-select required name=modbusTimeserieType_{{serverIndex}}{{deviceIndex}}{{timeseriesIndex}} ng-model=timeserie.type> <md-option ng-repeat=\"(attrType, attrTypeValue) in types.extensionValueType\" ng-value=attrType> {{attrTypeValue | translate}} </md-option> </md-select> <div ng-messages=\"theForm['modbusTimeserieType_' + serverIndex + deviceIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=20 class=md-block> <label translate>extension.modbus-poll-period</label> <input type=number name=pollPeriod_{{serverIndex}}{{deviceIndex}} ng-model=timeserie.pollPeriod min=1> <div ng-messages=\"theForm['pollPeriod_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=min>extension.modbus-poll-period-range</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=50 class=\"md-block tb-container-for-select\"> <label translate>extension.type</label> <md-select required name=modbusTimeserieFunctionCode_{{serverIndex}}{{deviceIndex}}{{timeseriesIndex}} ng-model=timeserie.functionCode> <md-option ng-repeat=\"(functionCode, functionName) in types.extensionModbusFunctionCodes\" ng-value=functionCode> {{functionName}} </md-option> </md-select> <div ng-messages=\"theForm['modbusTimeserieFunctionCode_' + serverIndex + deviceIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.modbus-register-address</label> <input type=number required name=address_{{serverIndex}}{{deviceIndex}} ng-model=timeserie.address min=0 max=65535> <div ng-messages=\"theForm['address_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.modbus-register-address-range</div> <div translate ng-message=max>extension.modbus-register-address-range</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=50 class=md-block ng-if=\"timeserie.type != 'boolean'\"> <label translate>extension.modbus-register-count</label> <input type=number name=registerCount_{{serverIndex}}{{deviceIndex}} ng-model=timeserie.registerCount min=1> <div ng-messages=\"theForm['registerCount_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=min>extension.modbus-register-count-range</div> </div> </md-input-container> <md-input-container flex=50 class=md-block ng-if=\"timeserie.type == 'boolean' && timeserie.functionCode >= 3\"> <label translate>extension.modbus-register-bit-index</label> <input type=number required name=bit_{{serverIndex}}{{deviceIndex}} ng-model=timeserie.bit min=0 max=15> <div ng-messages=\"theForm['bit_' + serverIndex + deviceIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.modbus-register-bit-index-range</div> <div translate ng-message=max>extension.modbus-register-bit-index-range</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=100 class=md-block ng-if=\"timeserie.functionCode >= 3\"> <label translate>extension.modbus-byte-order</label> <input required name=modbusByteOrder_{{serverIndex}}{{deviceIndex}}{{timeseriesIndex}} ng-model=timeserie.byteOrder> <div ng-messages=\"theForm['modbusByteOrder_' + serverIndex + deviceIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addNewTimeseries(device) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-timeseries</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addDevice(server.devices) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-device</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> </li> </ol> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addServer(configuration.servers) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.modbus-add-server</span> </md-button> </div> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	var path = 'extension/extensions-forms/extension-form-mqtt.tpl.html';
	var html = " <md-card class=\"extension-form extension-mqtt\"> <md-card-title name=testValid> <md-card-title-text> <span translate class=md-headline>extension.configuration</span> </md-card-title-text> </md-card-title> <md-card-content> <v-accordion id=mqtt-brokers-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=mqtt-brokers-pane expanded=true> <v-pane-header> {{ 'extension.brokers' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"brokers.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(brokerIndex,broker) in brokers\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=removeBroker(broker) ng-hide=\"brokers.length < 2\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=40 class=md-block> <label translate>extension.port</label> <input required type=number min=1 max=65535 name=mqttPort_{{brokerIndex}} ng-model=broker.port> <div ng-messages=\"theForm['mqttPort_' + brokerIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.port-range</div> <div translate ng-message=max>extension.port-range</div> </div> </md-input-container> <md-input-container flex=60 class=md-block> <label translate>extension.host</label> <input required name=mqttHost_{{brokerIndex}} ng-model=broker.host> <div ng-messages=\"theForm['mqttHost_' + brokerIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=40 class=md-block> <label translate>extension.retry-interval</label> <input required type=number name=mqttRetryInterval_{{brokerIndex}} ng-model=broker.retryInterval> <div ng-messages=\"theForm['mqttRetryInterval_' + brokerIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.credentials</label> <md-select required name=mqttCredentials_{{brokerIndex}} ng-model=broker.credentials.type ng-change=changeCredentials(broker)> <md-option ng-repeat=\"(credentialsType, credentialsValue) in types.mqttCredentialTypes\" ng-value=credentialsValue.value> {{credentialsValue.name | translate}} </md-option> </md-select> </md-input-container> <md-input-container flex=10 class=md-block> <md-checkbox flex aria-label=\"{{ 'extension.ssl' | translate }}\" ng-model=broker.ssl>{{ 'extension.ssl' | translate }} </md-checkbox> </md-input-container> </section> <section flex layout=row ng-if='broker.credentials.type == \"basic\"'> <md-input-container flex=40 class=md-block md-is-error=\"theForm['mqttUsername_' + brokerIndex].$touched && theForm['mqttUsername_' + brokerIndex].$invalid\"> <label translate>extension.username</label> <input required name=mqttUsername_{{brokerIndex}} ng-model=broker.credentials.username> <div ng-messages=\"theForm['mqttUsername_' + brokerIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=60 class=md-block md-is-error=\"theForm['mqttPassword_' + brokerIndex].$touched && theForm['mqttPassword_' + brokerIndex].$invalid\"> <label translate>extension.password</label> <input required name=mqttPassword_{{brokerIndex}} ng-model=broker.credentials.password> <div ng-messages=\"theForm['mqttPassword_' + brokerIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=column ng-if='broker.credentials.type == \"cert.PEM\"' class=dropdown-section> <div class=tb-container ng-class=\"broker.credentials.caCertFileName ? 'ng-valid' : 'ng-invalid'\"> <label class=tb-label translate>extension.ca-cert</label> <div flow-init={singleFile:true} flow-file-added='fileAdded($file, broker, \"caCert\")' class=tb-file-select-container> <div class=tb-file-clear-container> <md-button ng-click='clearFile(broker, \"caCert\")' class=\"tb-file-clear-btn md-icon-button md-primary\" aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.remove' | translate }}\" class=material-icons>close</md-icon> </md-button> </div> <div class=\"alert tb-flow-drop\" flow-drop> <label for=caCertSelect_{{brokerIndex}} translate>extension.drop-file</label> <input class=file-input flow-btn flow-attrs=\"{accept:'.pem'}\" id=caCertSelect_{{brokerIndex}}> </div> </div> </div> <div class=dropdown-messages> <div ng-if=!broker.credentials.caCertFileName class=tb-error-message translate>extension.no-file</div> <div ng-if=broker.credentials.caCertFileName>{{broker.credentials.caCertFileName}}</div> </div> <div class=tb-container ng-class=\"broker.credentials.privateKeyFileName ? 'ng-valid' : 'ng-invalid'\"> <label class=tb-label translate>extension.private-key</label> <div flow-init={singleFile:true} flow-file-added='fileAdded($file, broker, \"privateKey\")' class=tb-file-select-container> <div class=tb-file-clear-container> <md-button ng-click='clearFile(broker, \"privateKey\")' class=\"tb-file-clear-btn md-icon-button md-primary\" aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.remove' | translate }}\" class=material-icons>close</md-icon> </md-button> </div> <div class=\"alert tb-flow-drop\" flow-drop> <label for=privateKeySelect_{{brokerIndex}} translate>extension.drop-file</label> <input class=file-input flow-btn flow-attrs=\"{accept:'.pem'}\" id=privateKeySelect_{{brokerIndex}}> </div> </div> </div> <div class=dropdown-messages> <div ng-if=!broker.credentials.privateKeyFileName class=tb-error-message translate>extension.no-file</div> <div ng-if=broker.credentials.privateKeyFileName>{{broker.credentials.privateKeyFileName}}</div> </div> <div class=tb-container ng-class=\"broker.credentials.certFileName ? 'ng-valid' : 'ng-invalid'\"> <label class=tb-label translate>extension.cert</label> <div flow-init={singleFile:true} flow-file-added='fileAdded($file, broker, \"Cert\")' class=tb-file-select-container> <div class=tb-file-clear-container> <md-button ng-click='clearFile(broker, \"Cert\")' class=\"tb-file-clear-btn md-icon-button md-primary\" aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.remove' | translate }}\" class=material-icons>close</md-icon> </md-button> </div> <div class=\"alert tb-flow-drop\" flow-drop> <label for=CertSelect_{{brokerIndex}} translate>extension.drop-file</label> <input class=file-input flow-btn flow-attrs=\"{accept:'.pem'}\" id=CertSelect_{{brokerIndex}}> </div> </div> </div> <div class=dropdown-messages> <div ng-if=!broker.credentials.certFileName class=tb-error-message translate>extension.no-file</div> <div ng-if=broker.credentials.certFileName>{{broker.credentials.certFileName}}</div> </div> </section> <v-accordion id=mqtt-mapping-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=mqtt-mapping-pane_{{brokerIndex}}> <v-pane-header> {{ 'extension.mapping' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"broker.mapping.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(mapIndex,map) in broker.mapping\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeMap(map, broker.mapping)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=40 class=md-block md-is-error=\"theForm['mqttConverterType_' + brokerIndex + mapIndex].$touched && theForm['mqttConverterType_' + brokerIndex + mapIndex].$invalid\"> <label translate>extension.converter-type</label> <md-select required name=mqttConverterType_{{brokerIndex}}{{mapIndex}} ng-model=map.converterType ng-change=changeConverterType(map)> <md-option ng-repeat=\"(converterType, value) in types.mqttConverterTypes\" ng-value=converterType> {{value | translate}} </md-option> </md-select> <div ng-messages=\"theForm['mqttConverterType_' + brokerIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=60 class=md-block> <label translate>extension.topic-filter</label> <input required name=mqttTopicFilter_{{brokerIndex}}{{mapIndex}} ng-model=map.topicFilter> <div ng-messages=\"theForm['mqttTopicFilter_' + brokerIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <div ng-if='map.converterType ==\"json\"' ng-init=\"map.converter.type = 'json'\"> <section flex layout=row> <md-input-container flex=40 class=md-block md-is-error=\"theForm['mqttDeviceNameExpression_' + brokerIndex + mapIndex].$touched && theForm['mqttDeviceNameExpression_' + brokerIndex + mapIndex].$invalid\"> <label translate>extension.device-name-expression</label> <md-select required name=mqttDeviceNameExpression_{{brokerIndex}}{{mapIndex}} ng-model=map.converter.nameExp ng-change=changeNameExpression(map.converter)> <md-option ng-repeat=\"(key, value) in deviceNameExpressions\" ng-value=key> {{value | translate}} </md-option> </md-select> <div ng-messages=\"theForm['mqttDeviceNameExpression_' + brokerIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"map.converter.nameExp == 'deviceNameJsonExpression'\" flex=60 class=md-block md-is-error=\"theForm['mqttJsonNameExp_' + brokerIndex + mapIndex].$touched && theForm['mqttJsonNameExp_' + brokerIndex + mapIndex].$invalid\"> <label translate>extension.json-name-expression</label> <input required name=mqttJsonNameExp_{{brokerIndex}}{{mapIndex}} ng-model=map.converter.deviceNameJsonExpression> <div ng-messages=\"theForm['mqttJsonNameExp_' + brokerIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"map.converter.nameExp == 'deviceNameTopicExpression'\" flex=60 class=md-block md-is-error=\"theForm['mqttTopicNameExp_' + brokerIndex + mapIndex].$touched && theForm['mqttTopicNameExp_' + brokerIndex + mapIndex].$invalid\"> <label translate>extension.topic-name-expression</label> <input required name=mqttTopicNameExp_{{brokerIndex}}{{mapIndex}} ng-model=map.converter.deviceNameTopicExpression> <div ng-messages=\"theForm['mqttTopicNameExp_' + brokerIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=40 class=md-block md-is-error=\"theForm['mqttDeviceTypeExpression_' + brokerIndex + mapIndex].$touched && theForm['mqttDeviceTypeExpression_' + brokerIndex + mapIndex].$invalid\"> <label translate>extension.device-type-expression</label> <md-select required name=mqttDeviceTypeExpression_{{brokerIndex}}{{mapIndex}} ng-model=map.converter.typeExp ng-change=changeTypeExpression(map.converter)> <md-option ng-repeat=\"(key, value) in deviceTypeExpressions\" ng-value=key> {{value | translate}} </md-option> </md-select> <div ng-messages=\"theForm['mqttDeviceTypeExpression_' + brokerIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"map.converter.typeExp == 'deviceTypeJsonExpression'\" flex=60 class=md-block md-is-error=\"theForm['mqttJsonTypeExp_' + brokerIndex + mapIndex].$touched && theForm['mqttJsonTypeExp_' + brokerIndex + mapIndex].$invalid\"> <label translate>extension.json-type-expression</label> <input required name=mqttJsonTypeExp_{{brokerIndex}}{{mapIndex}} ng-model=map.converter.deviceTypeJsonExpression> <div ng-messages=\"theForm['mqttJsonTypeExp_' + brokerIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"map.converter.typeExp == 'deviceTypeTopicExpression'\" flex=60 class=md-block md-is-error=\"theForm['mqttTopicTypeExp_' + brokerIndex + mapIndex].$touched && theForm['mqttTopicTypeExp_' + brokerIndex + mapIndex].$invalid\"> <label translate>extension.topic-type-expression</label> <input required name=mqttTopicTypeExp_{{brokerIndex}}{{mapIndex}} ng-model=map.converter.deviceTypeTopicExpression> <div ng-messages=\"theForm['mqttTopicTypeExp_' + brokerIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=40 class=md-block> <label translate>extension.timeout</label> <input type=number name=mqttTimeout_{{brokerIndex}}{{mapIndex}} ng-model=map.converter.timeout parse-to-null> </md-input-container> <md-input-container flex=60 class=md-block md-is-error=\"theForm['mqttFilterExpression' + brokerIndex + mapIndex].$touched && theForm['mqttFilterExpression' + brokerIndex + mapIndex].$invalid\"> <label translate>extension.filter-expression</label> <input required name=mqttFilterExpression{{brokerIndex}}{{mapIndex}} ng-model=map.converter.filterExpression> <div ng-messages=\"theForm['mqttFilterExpression' + brokerIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> </div> <div ng-if='map.converterType == \"custom\"'> <div class=md-caption style=padding-left:3px;padding-bottom:10px;color:rgba(0,0,0,.57) translate>extension.transformer-json</div> <div flex class=tb-extension-custom-transformer-panel> <div flex class=tb-extension-custom-transformer ui-ace=extensionCustomConverterOptions ng-model=map.converter name=mqttCustomConverter_{{brokerIndex}}{{mapIndex}} ng-change='validateCustomConverter(map.converter, \"mqttCustomConverter_\" + brokerIndex + mapIndex)' required> </div> </div> <div class=tb-error-messages ng-messages=\"theForm['mqttCustomConverter_' + brokerIndex + mapIndex].$error\" role=alert> <div ng-message=required class=tb-error-message translate>extension.converter-json-required</div> <div ng-message=converterJSON class=tb-error-message translate>extension.converter-json-parse</div> </div> </div> <v-accordion ng-if='map.converterType ==\"json\"' id=mqtt-attributes-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=mqtt-attributes-pane_{{brokerIndex}}{{mapIndex}}> <v-pane-header> {{ 'extension.attributes' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"map.converter.attributes.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(attributeIndex, attribute) in map.converter.attributes\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeAttribute(attribute, map.converter.attributes)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=60 class=md-block md-is-error=\"theForm['mqttAttributeKey_' + brokerIndex + mapIndex + attributeIndex].$touched && theForm['mqttAttributeKey_' + brokerIndex + mapIndex + attributeIndex].$invalid\"> <label translate>extension.key</label> <input required name=mqttAttributeKey_{{brokerIndex}}{{mapIndex}}{{attributeIndex}} ng-model=attribute.key> <div ng-messages=\"theForm['mqttAttributeKey_' + brokerIndex + mapIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=40 class=md-block md-is-error=\"theForm['mqttAttributeType_' + brokerIndex + mapIndex + attributeIndex].$touched && theForm['mqttAttributeType_' + brokerIndex + mapIndex + attributeIndex].$invalid\"> <label translate>extension.type</label> <md-select required name=mqttAttributeType_{{brokerIndex}}{{mapIndex}}{{attributeIndex}} ng-model=attribute.type> <md-option ng-repeat=\"(attrType, attrTypeValue) in types.extensionValueType\" ng-value=attrType> {{attrTypeValue | translate}} </md-option> </md-select> <div ng-messages=\"theForm['mqttAttributeType_' + brokerIndex + mapIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <md-input-container class=md-block md-is-error=\"theForm['mqttAttributeValue_' + brokerIndex + mapIndex + attributeIndex].$touched && theForm['mqttAttributeValue_' + brokerIndex + mapIndex + attributeIndex].$invalid\"> <label translate>extension.value</label> <input required name=mqttAttributeValue_{{brokerIndex}}{{mapIndex}}{{attributeIndex}} ng-model=attribute.value> <div ng-messages=\"theForm['mqttAttributeValue_' + brokerIndex + mapIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addAttribute(map.converter.attributes) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-attribute</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion ng-if='map.converterType ==\"json\"' id=mqtt-timeseries-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=mqtt-timeseries-pane_{{brokerIndex}}{{mapIndex}}> <v-pane-header> {{ 'extension.timeseries' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"map.converter.timeseries.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(timeseriesIndex, timeseries) in map.converter.timeseries\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeAttribute(timeseries, map.converter.timeseries)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=60 class=md-block md-is-error=\"theForm['mqttTimeseriesKey_' + brokerIndex + mapIndex + timeseriesIndex].$touched && theForm['mqttTimeseriesKey_' + brokerIndex + mapIndex + timeseriesIndex].$invalid\"> <label translate>extension.key</label> <input required name=mqttTimeseriesKey_{{brokerIndex}}{{mapIndex}}{{timeseriesIndex}} ng-model=timeseries.key> <div ng-messages=\"theForm['mqttTimeseriesKey_' + brokerIndex + mapIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=40 class=md-block md-is-error=\"theForm['mqttTimeseriesType_' + brokerIndex + mapIndex + timeseriesIndex].$touched && theForm['mqttTimeseriesType_' + brokerIndex + mapIndex + timeseriesIndex].$invalid\"> <label translate>extension.type</label> <md-select required name=mqttTimeseriesType_{{brokerIndex}}{{mapIndex}}{{timeseriesIndex}} ng-model=timeseries.type> <md-option ng-repeat=\"(attrType, attrTypeValue) in types.extensionValueType\" ng-value=attrType> {{attrTypeValue | translate}} </md-option> </md-select> <div ng-messages=\"theForm['mqttTimeseriesType_' + brokerIndex + mapIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <md-input-container class=md-block md-is-error=\"theForm['mqttTimeseriesValue_' + brokerIndex + mapIndex + timeseriesIndex].$touched && theForm['mqttTimeseriesValue_' + brokerIndex + mapIndex + timeseriesIndex].$invalid\"> <label translate>extension.value</label> <input required name=mqttTimeseriesValue_{{brokerIndex}}{{mapIndex}}{{timeseriesIndex}} ng-model=timeseries.value> <div ng-messages=\"theForm['mqttTimeseriesValue_' + brokerIndex + mapIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addAttribute(map.converter.timeseries) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-timeseries</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addMap(broker.mapping) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-map</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=mqtt-connect-requests-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=mqtt-connect-requests-pane_{{brokerIndex}}> <v-pane-header> {{ 'extension.connect-requests' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"broker.connectRequests.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(connectRequestIndex, connectRequest) in broker.connectRequests\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeAttribute(connectRequest, broker.connectRequests)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <md-input-container class=md-block> <label translate>extension.topic-filter</label> <input required name=conRequestTopicFilter_{{brokerIndex}}{{connectRequestIndex}} ng-model=connectRequest.topicFilter> <div ng-messages=\"theForm['conRequestTopicFilter_' + brokerIndex + connectRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <section flex layout=row> <md-input-container flex=40 class=md-block md-is-error=\"theForm['connectDeviceNameExpression_' + brokerIndex + connectRequestIndex].$touched && theForm['connectDeviceNameExpression_' + brokerIndex + connectRequestIndex].$invalid\"> <label translate>extension.device-name-expression</label> <md-select required name=connectDeviceNameExpression_{{brokerIndex}}{{connectRequestIndex}} ng-model=connectRequest.nameExp ng-change=\"changeNameExpression(connectRequest, 'connect')\"> <md-option ng-repeat=\"(key, value) in deviceNameExpressions\" ng-value=key> {{value | translate}} </md-option> </md-select> <div ng-messages=\"theForm['connectDeviceNameExpression_' + brokerIndex + connectRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"connectRequest.nameExp == 'deviceNameJsonExpression'\" flex=60 class=md-block> <label translate>extension.json-name-expression</label> <input required name=connectJsonNameExp_{{brokerIndex}}{{connectRequestIndex}} ng-model=connectRequest.deviceNameJsonExpression> <div ng-messages=\"theForm['connectJsonNameExp_' + brokerIndex + connectRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"connectRequest.nameExp == 'deviceNameTopicExpression'\" flex=60 class=md-block> <label translate>extension.topic-name-expression</label> <input required name=connectTopicNameExp_{{brokerIndex}}{{connectRequestIndex}} ng-model=connectRequest.deviceNameTopicExpression> <div ng-messages=\"theForm['connectTopicNameExp_' + brokerIndex + connectRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click='addConnectRequest(broker.connectRequests, \"connect\")' aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-connect-request</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=mqtt-disconnect-requests-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=mqtt-disconnect-requests-pane_{{brokerIndex}}> <v-pane-header> {{ 'extension.disconnect-requests' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"broker.disconnectRequests.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(disconnectRequestIndex, disconnectRequest) in broker.disconnectRequests\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeAttribute(disconnectRequest, broker.disconnectRequests)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <md-input-container class=md-block> <label translate>extension.topic-filter</label> <input required name=disconRequestTopicFilter_{{brokerIndex}}{{disconnectRequestIndex}} ng-model=disconnectRequest.topicFilter> <div ng-messages=\"theForm['disconRequestTopicFilter_' + brokerIndex + disconnectRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <section flex layout=row> <md-input-container flex=40 class=md-block md-is-error=\"theForm['disconnectDeviceNameExpression_' + brokerIndex + disconnectRequestIndex].$touched && theForm['disconnectDeviceNameExpression_' + brokerIndex + disconnectRequestIndex].$invalid\"> <label translate>extension.device-name-expression</label> <md-select required name=disconnectDeviceNameExpression_{{brokerIndex}}{{disconnectRequestIndex}} ng-model=disconnectRequest.nameExp ng-change=\"changeNameExpression(disconnectRequest, 'disconnect')\"> <md-option ng-repeat=\"(key, value) in deviceNameExpressions\" ng-value=key> {{value | translate}} </md-option> </md-select> <div ng-messages=\"theForm['disconnectDeviceNameExpression_' + brokerIndex + disconnectRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"disconnectRequest.nameExp == 'deviceNameJsonExpression'\" flex=60 class=md-block> <label translate>extension.json-name-expression</label> <input required name=disconnectJsonNameExp_{{brokerIndex}}{{disconnectRequestIndex}} ng-model=disconnectRequest.deviceNameJsonExpression> <div ng-messages=\"theForm['disconnectJsonNameExp_' + brokerIndex + disconnectRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"disconnectRequest.nameExp == 'deviceNameTopicExpression'\" flex=60 class=md-block> <label translate>extension.topic-name-expression</label> <input required name=disconnectTopicNameExp_{{brokerIndex}}{{disconnectRequestIndex}} ng-model=disconnectRequest.deviceNameTopicExpression> <div ng-messages=\"theForm['disconnectTopicNameExp_' + brokerIndex + disconnectRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click='addConnectRequest(broker.disconnectRequests, \"disconnect\")' aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-disconnect-request</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=mqtt-attribute-requests-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=mqtt-attribute-requests-pane_{{brokerIndex}}> <v-pane-header> {{ 'extension.attribute-requests' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"broker.attributeRequests.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(attributeRequestIndex, attributeRequest) in broker.attributeRequests\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeAttribute(attributeRequest, broker.attributeRequests)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=80 class=md-block> <label translate>extension.topic-filter</label> <input required name=attributeRequestTopicFilter_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.topicFilter> <div ng-messages=\"theForm['attributeRequestTopicFilter_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=20 class=md-block> <md-checkbox flex aria-label=\"{{ 'extension.client-scope' | translate }}\" ng-model=attributeRequest.clientScope>{{ 'extension.client-scope' | translate }} </md-checkbox> </md-input-container> </section> <section flex layout=row> <md-input-container flex=40 class=md-block md-is-error=\"theForm['attrRequestDeviceNameExpression_' + brokerIndex + attributeRequestIndex].$touched && theForm['attrRequestDeviceNameExpression_' + brokerIndex + attributeRequestIndex].$invalid\"> <label translate>extension.device-name-expression</label> <md-select required name=attrRequestDeviceNameExpression_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.nameExp ng-change=\"changeNameExpression(attributeRequest, 'attribute')\"> <md-option ng-repeat=\"(key, value) in deviceNameExpressions\" ng-value=key> {{value | translate}} </md-option> </md-select> <div ng-messages=\"theForm['attrRequestDeviceNameExpression_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"attributeRequest.nameExp == 'deviceNameJsonExpression'\" flex=60 class=md-block> <label translate>extension.json-name-expression</label> <input required name=attrRequestJsonNameExp_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.deviceNameJsonExpression> <div ng-messages=\"theForm['attrRequestJsonNameExp_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"attributeRequest.nameExp == 'deviceNameTopicExpression'\" flex=60 class=md-block> <label translate>extension.topic-name-expression</label> <input required name=attrRequestTopicNameExp_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.deviceNameTopicExpression> <div ng-messages=\"theForm['attrRequestTopicNameExp_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=40 class=md-block md-is-error=\"theForm['attrRequestAttributeKeyExpression_' + brokerIndex + attributeRequestIndex].$touched && theForm['attrRequestAttributeKeyExpression_' + brokerIndex + attributeRequestIndex].$invalid\"> <label translate>extension.attribute-key-expression</label> <md-select required name=attrRequestAttributeKeyExpression_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.attrKey ng-change=changeAttrKeyExpression(attributeRequest)> <md-option ng-repeat=\"(key, value) in attributeKeyExpressions\" ng-value=key> {{value | translate}} </md-option> </md-select> <div ng-messages=\"theForm['attrRequestAttributeKeyExpression_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"attributeRequest.attrKey == 'attributeKeyJsonExpression'\" flex=60 class=md-block> <label translate>extension.attr-json-key-expression</label> <input required name=attrRequestJsonKeyExp_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.attributeKeyJsonExpression> <div ng-messages=\"theForm['attrRequestJsonKeyExp_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"attributeRequest.attrKey == 'attributeKeyTopicExpression'\" flex=60 class=md-block> <label translate>extension.attr-topic-key-expression</label> <input required name=attrRequestTopicKeyExp_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.attributeKeyTopicExpression> <div ng-messages=\"theForm['attrRequestTopicKeyExp_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=40 class=md-block md-is-error=\"theForm['attrRequestIdExpression_' + brokerIndex + attributeRequestIndex].$touched && theForm['attrRequestIdExpression_' + brokerIndex + attributeRequestIndex].$invalid\"> <label translate>extension.request-id-expression</label> <md-select required name=attrRequestIdExpression_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.requestId ng-change=changeRequestIdExpression(attributeRequest)> <md-option ng-repeat=\"(key, value) in requestIdExpressions\" ng-value=key> {{value | translate}} </md-option> </md-select> <div ng-messages=\"theForm['attrRequestIdExpression_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"attributeRequest.requestId == 'requestIdJsonExpression'\" flex=60 class=md-block> <label translate>extension.request-id-json-expression</label> <input required name=attrRequestJsonIdExp_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.requestIdJsonExpression> <div ng-messages=\"theForm['attrRequestJsonIdExp_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container ng-if=\"attributeRequest.requestId == 'requestIdTopicExpression'\" flex=60 class=md-block> <label translate>extension.request-id-topic-expression</label> <input required name=attrRequestTopicIdExp_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.requestIdTopicExpression> <div ng-messages=\"theForm['attrRequestTopicIdExp_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <md-input-container class=md-block> <label translate>extension.response-topic-expression</label> <input required name=attributeRequestResponseTopicExp_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.responseTopicExpression> <div ng-messages=\"theForm['attributeRequestResponseTopicExp_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>extension.value-expression</label> <input required name=attributeRequestValueExp_{{brokerIndex}}{{attributeRequestIndex}} ng-model=attributeRequest.valueExpression> <div ng-messages=\"theForm['attributeRequestValueExp_' + brokerIndex + attributeRequestIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addAttributeRequest(broker.attributeRequests) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-attribute-request</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=mqtt-attribute-updates-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=mqtt-attribute-updates-pane_{{brokerIndex}}> <v-pane-header> {{ 'extension.attribute-updates' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"broker.attributeUpdates.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(attributeUpdateIndex, attributeUpdate) in broker.attributeUpdates\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeAttribute(attributeUpdate, broker.attributeUpdates)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.device-name-filter</label> <input required name=attributeUpdateDeviceNameFilter_{{brokerIndex}}{{attributeUpdateIndex}} ng-model=attributeUpdate.deviceNameFilter> <div ng-messages=\"theForm['attributeUpdateDeviceNameFilter_' + brokerIndex + attributeUpdateIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.attribute-filter</label> <input required name=attributeUpdateAttributeFilter_{{brokerIndex}}{{attributeUpdateIndex}} ng-model=attributeUpdate.attributeFilter> <div ng-messages=\"theForm['attributeUpdateAttributeFilter_' + brokerIndex + attributeUpdateIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <md-input-container class=md-block> <label translate>extension.topic-expression</label> <input required name=attributeUpdateTopicExp_{{brokerIndex}}{{attributeUpdateIndex}} ng-model=attributeUpdate.topicExpression> <div ng-messages=\"theForm['attributeUpdateTopicExp_' + brokerIndex + attributeUpdateIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>extension.value-expression</label> <input required name=attributeUpdateValueExp_{{brokerIndex}}{{attributeUpdateIndex}} ng-model=attributeUpdate.valueExpression> <div ng-messages=\"theForm['attributeUpdateValueExp_' + brokerIndex + attributeUpdateIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addAttributeUpdate(broker.attributeUpdates) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-attribute-update</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=mqtt-server-side-rpc-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=mqtt-server-side-rpc-pane_{{brokerIndex}}> <v-pane-header> {{ 'extension.server-side-rpc' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"broker.serverSideRpc.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(rpcIndex, rpc) in broker.serverSideRpc\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeAttribute(rpc, broker.serverSideRpc)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.device-name-filter</label> <input required name=serverSideRpcDeviceNameFilter_{{brokerIndex}}{{rpcIndex}} ng-model=rpc.deviceNameFilter> <div ng-messages=\"theForm['serverSideRpcDeviceNameFilter_' + brokerIndex + rpcIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.method-filter</label> <input required name=serverSideRpcMethodFilter_{{brokerIndex}}{{rpcIndex}} ng-model=rpc.methodFilter> <div ng-messages=\"theForm['serverSideRpcMethodFilter_' + brokerIndex + rpcIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <md-input-container class=md-block> <label translate>extension.request-topic-expression</label> <input required name=serverSideRpcRequestTopicExp_{{brokerIndex}}{{rpcIndex}} ng-model=rpc.requestTopicExpression> <div ng-messages=\"theForm['serverSideRpcRequestTopicExp_' + brokerIndex + rpcIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>extension.response-topic-expression</label> <input name=serverSideRpcResponseTopicExp_{{brokerIndex}}{{rpcIndex}} ng-model=rpc.responseTopicExpression parse-to-null> </md-input-container> <section flex layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.response-timeout</label> <input type=number name=serverSideRpcResponseTimeout_{{brokerIndex}}{{rpcIndex}} ng-model=rpc.responseTimeout parse-to-null> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.value-expression</label> <input required name=serverSideRpcValueExp_{{brokerIndex}}{{rpcIndex}} ng-model=rpc.valueExpression> <div ng-messages=\"theForm['serverSideRpcValueExp_' + brokerIndex + rpcIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addServerSideRpc(broker.serverSideRpc) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-server-side-rpc-request</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addBroker() aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-broker</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	var path = 'extension/extensions-forms/extension-form-opc.tpl.html';
	var html = " <md-card class=\"extension-form extension-opc\"> <md-card-title> <md-card-title-text> <span translate class=md-headline>extension.configuration</span> </md-card-title-text> </md-card-title> <md-card-content> <v-accordion id=opc-server-configs-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=opc-servers-pane expanded=true> <v-pane-header> {{ 'extension.opc-server' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"configuration.servers.length === 0\"> <span translate layout-align=\"center center\" class=tb-prompt>extension.opc-add-server-prompt</span> </div> <div ng-if=\"configuration.servers.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(serverIndex, server) in configuration.servers\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeItem(server, configuration.servers)\" ng-hide=\"configuration.servers.length < 2\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <div layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.opc-application-name</label> <input required name=applicationName_{{serverIndex}} ng-model=server.applicationName> <div ng-messages=\"theForm['applicationName_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block md-is-error=\"theForm['applicationUri_' + serverIndex].$touched && theForm['applicationUri_' + serverIndex].$invalid\"> <label translate>extension.opc-application-uri</label> <input name=applicationUri_{{serverIndex}} ng-model=server.applicationUri> </md-input-container> </div> <div layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.host</label> <input required name=host_{{serverIndex}} ng-model=server.host> <div ng-messages=\"theForm['host_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.port</label> <input type=number required name=port_{{serverIndex}} ng-model=server.port min=1 max=65535> <div ng-messages=\"theForm['port_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> <div translate ng-message=min>extension.port-range</div> <div translate ng-message=max>extension.port-range</div> </div> </md-input-container> </div> <div layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.opc-scan-period-in-seconds</label> <input type=number required name=scanPeriodInSeconds_{{serverIndex}} ng-model=server.scanPeriodInSeconds> <div ng-messages=\"theForm['scanPeriodInSeconds_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.timeout</label> <input type=number required name=timeoutInMillis_{{serverIndex}} ng-model=server.timeoutInMillis> <div ng-messages=\"theForm['timeoutInMillis_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </div> <div layout=row> <md-input-container flex=50 class=\"md-block tb-container-for-select\"> <label translate>extension.opc-security</label> <md-select required name=securityType_{{serverIndex}} ng-model=server.security> <md-option ng-value=securityType ng-repeat=\"(securityType, securityValue) in types.extensionOpcSecurityTypes\"><span ng-bind=::securityValue></span></md-option> </md-select> <div ng-messages=\"theForm['securityType_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=\"md-block tb-container-for-select\"> <label translate>extension.opc-identity</label> <md-select required name=identityType_{{serverIndex}} ng-model=server.identity.type> <md-option ng-value=identityType ng-repeat=\"(identityType, identityValue) in types.extensionIdentityType\"><span ng-bind=\"identityValue | translate\"></span></md-option> </md-select> <div ng-messages=\"theForm['identityType_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </div> <div ng-if=\"server.identity.type != 'username'\"> <span class=\"\" ng-init=\"server.identity = {'type':'anonymous'}\"></span> </div> <div layout=row ng-if=\"server.identity.type == 'username'\"> <md-input-container flex=50 class=md-block md-is-error=\"theForm['identityUsername_' + serverIndex].$touched && theForm['identityUsername_' + serverIndex].$invalid\"> <label translate>extension.username</label> <input required name=identityUsername_{{serverIndex}} ng-model=server.identity.username> <div ng-messages=\"theForm['identityUsername_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block md-is-error=\"theForm['identityPassword_' + serverIndex].$touched && theForm['identityPassword_' + serverIndex].$invalid\"> <label translate>extension.password</label> <input required name=identityPassword_{{serverIndex}} ng-model=server.identity.password> <div ng-messages=\"theForm['identityPassword_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </div> <v-accordion id=opc-keystore-accordion class=vAccordion--default ng-if=\"server.security != 'None'\" onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=opc-keystore-pane__{{serverIndex}} expanded=true> <v-pane-header> {{ 'extension.opc-keystore' | translate }} </v-pane-header> <v-pane-content> <md-input-container class=\"md-block tb-container-for-select\"> <label translate>extension.opc-keystore-type</label> <md-select required name=keystoreType_{{serverIndex}} ng-model=server.keystore.type> <md-option ng-value=keystoreType ng-repeat=\"(keystoreType, keystoreValue) in types.extensionKeystoreType\"><span ng-bind=::keystoreValue></span></md-option> </md-select> <div ng-messages=\"theForm['keystoreType_'+serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <section class=dropdown-section> <div class=tb-container ng-class=\"{'ng-invalid':!server.keystore.fileContent}\"> <span ng-init='fieldsToFill = {\"location\":\"location\", \"fileContent\":\"fileContent\"}'></span> <label class=tb-label translate>extension.opc-keystore-location</label> <div flow-init={singleFile:true} flow-file-added=\"fileAdded($file, server.keystore, fieldsToFill)\" class=tb-file-select-container> <div class=tb-file-clear-container> <md-button ng-click=\"clearFile(server.keystore, fieldsToFill)\" class=\"tb-file-clear-btn md-icon-button md-primary\" aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.remove' | translate }}\" class=material-icons>close</md-icon> </md-button> </div> <div class=\"alert tb-flow-drop\" flow-drop> <label for=dropFileKeystore_{{serverIndex}} translate>extension.drop-file</label> <input flow-attrs=\"{accept:'.pfx,.p12'}\" type=file class=file-input flow-btn id=dropFileKeystore_{{serverIndex}} name=keystoreFile ng-model=server.keystore.fileContent> </div> </div> </div> <div class=dropdown-messages> <div ng-if=!server.keystore[fieldsToFill.location] class=tb-error-message translate>extension.no-file</div> <div ng-if=server.keystore[fieldsToFill.location]>{{server.keystore[fieldsToFill.location]}}</div> </div> </section> <div flex layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.opc-keystore-password</label> <input required name=keystorePassword_{{serverIndex}} ng-model=server.keystore.password> <div ng-messages=\"theForm['keystorePassword_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.opc-keystore-alias</label> <input required name=keystoreAlias_{{serverIndex}} ng-model=server.keystore.alias> <div ng-messages=\"theForm['keystoreAlias_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </div> <md-input-container class=md-block> <label translate>extension.opc-keystore-key-password</label> <input required name=keystoreKeyPassword_{{serverIndex}} ng-model=server.keystore.keyPassword> <div ng-messages=\"theForm['keystoreKeyPassword_' + serverIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=opc-mapping-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=opc-mapping-pane_{{serverIndex}}> <v-pane-header> {{ 'extension.mapping' | translate }} </v-pane-header> <v-pane-content> <div ng-if=\"server.mapping.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(mapIndex, map) in server.mapping\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeItem(map, server.mapping)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <div flex layout=row> <md-input-container flex=50 class=md-block> <label translate>extension.opc-device-node-pattern</label> <input required name=deviceNodePattern_{{serverIndex}}{{mapIndex}} ng-model=map.deviceNodePattern> <div ng-messages=\"theForm['deviceNodePattern_' + serverIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=50 class=md-block> <label translate>extension.opc-device-name-pattern</label> <input required name=deviceNamePattern_{{serverIndex}}{{mapIndex}} ng-model=map.deviceNamePattern> <div ng-messages=\"theForm['deviceNamePattern_' + serverIndex + mapIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </div> <v-accordion id=opc-attributes-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=opc-attributes-pane_{{serverIndex}}{{mapIndex}}> <v-pane-header> {{ 'extension.attributes' | translate }} </v-pane-header> <v-pane-content> <div ng-show=\"map.attributes.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(attributeIndex, attribute) in map.attributes\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeItem(attribute, map.attributes)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=60 class=md-block> <label translate>extension.key</label> <input required name=opcAttributeKey_{{serverIndex}}{{mapIndex}}{{attributeIndex}} ng-model=attribute.key> <div ng-messages=\"theForm['opcAttributeKey_' + serverIndex + mapIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=40 class=\"md-block tb-container-for-select\"> <label translate>extension.type</label> <md-select required name=opcAttributeType_{{serverIndex}}{{mapIndex}}{{attributeIndex}} ng-model=attribute.type> <md-option ng-repeat=\"(attrType, attrTypeValue) in types.extensionValueType\" ng-value=attrType> {{attrTypeValue | translate}} </md-option> </md-select> <div ng-messages=\"theForm['opcAttributeType_' + serverIndex + mapIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=100 class=md-block> <label translate>extension.value</label> <input required name=opcAttributeValue_{{serverIndex}}{{mapIndex}}{{attributeIndex}} ng-model=attribute.value> <div ng-messages=\"theForm['opcAttributeValue_' + serverIndex + mapIndex + attributeIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addNewAttribute(map.attributes) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-attribute</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> <v-accordion id=opc-timeseries-accordion class=vAccordion--default onexpand=expandValidation(index,id) oncollapse=collapseValidation(index,id)> <v-pane id=opc-timeseries-pane_{{serverIndex}}{{mapIndex}}> <v-pane-header> {{ 'extension.timeseries' | translate }} </v-pane-header> <v-pane-content> <div ng-show=\"map.timeseries.length > 0\"> <ol class=list-group> <li class=list-group-item ng-repeat=\"(timeseriesIndex, timeseries) in map.timeseries\"> <md-button aria-label=\"{{ 'action.remove' | translate }}\" class=md-icon-button ng-click=\"removeItem(timeseries, map.timeseries)\"> <ng-md-icon icon=close aria-label=\"{{ 'action.remove' | translate }}\"></ng-md-icon> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> </md-button> <md-card> <md-card-content> <section flex layout=row> <md-input-container flex=60 class=md-block> <label translate>extension.key</label> <input required name=opcTimeseriesKey_{{serverIndex}}{{mapIndex}}{{timeseriesIndex}} ng-model=timeseries.key> <div ng-messages=\"theForm['opcTimeseriesKey_' + serverIndex + mapIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> <md-input-container flex=40 class=\"md-block tb-container-for-select\"> <label translate>extension.type</label> <md-select required name=opcTimeseriesType_{{serverIndex}}{{mapIndex}}{{timeseriesIndex}} ng-model=timeseries.type> <md-option ng-repeat=\"(attrType, attrTypeValue) in types.extensionValueType\" ng-value=attrType> {{attrTypeValue | translate}} </md-option> </md-select> <div ng-messages=\"theForm['opcTimeseriesType_' + serverIndex + mapIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> <section flex layout=row> <md-input-container flex=100 class=md-block> <label translate>extension.value</label> <input required name=opcTimeseriesValue_{{serverIndex}}{{mapIndex}}{{timeseriesIndex}} ng-model=timeseries.value> <div ng-messages=\"theForm['opcTimeseriesValue_' + serverIndex + mapIndex + timeseriesIndex].$error\"> <div translate ng-message=required>extension.field-required</div> </div> </md-input-container> </section> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addNewAttribute(map.timeseries) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-timeseries</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> </li> </ol> </div> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addMap(server.mapping) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.add-map</span> </md-button> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card> </li> </ol> <div flex layout=row layout-align=\"start center\"> <md-button class=\"md-primary md-raised\" ng-click=addServer(configuration.servers) aria-label=\"{{ 'action.add' | translate }}\"> <md-icon class=material-icons>add</md-icon> <span translate>extension.opc-add-server</span> </md-button> </div> </div> </v-pane-content> </v-pane> </v-accordion> </md-card-content> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	var path = 'home/home-links.tpl.html';
	var html = " <md-grid-list class=tb-home-links md-cols={{vm.cols}} md-row-height=280px> <md-grid-tile md-colspan=2 md-colspan-gt-sm={{vm.sectionColspan(section)}} ng-repeat=\"section in vm.model\"> <md-card style=width:100%> <md-card-title> <md-card-title-text> <span translate class=md-headline>{{ section.name }}</span> </md-card-title-text> </md-card-title> <md-card-content> <md-grid-list md-row-height=170px md-cols={{section.places.length}} md-cols-gt-md={{section.places.length}}> <md-grid-tile class=card-tile ng-repeat=\"place in section.places\"> <md-button class=\"tb-card-button md-raised md-primary\" layout=column ui-sref={{place.state}}> <md-icon class=\"material-icons tb-md-96\" aria-label={{place.icon}}>{{place.icon}}</md-icon> <span translate>{{place.name}}</span> </md-button> </md-grid-tile> </md-grid-list> </md-card-content> </md-card> </md-grid-tile> </md-grid-list>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	var path = 'import-export/import-dialog.tpl.html';
	var html = " <md-dialog aria-label=\"{{ vm.importTitle | translate }}\"> <form name=theForm ng-submit=vm.importFromJson()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>{{ vm.importTitle }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=$root.loading> <div layout=column layout-padding> <div class=tb-container> <label class=tb-label translate>{{ vm.importFileLabel }}</label> <div flow-init={singleFile:true} flow-file-added=\"vm.fileAdded( $file )\" class=tb-file-select-container> <div class=tb-file-clear-container> <md-button ng-click=vm.clearFile() class=\"tb-file-clear-btn md-icon-button md-primary\" aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'action.remove' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.remove' | translate }}\" class=material-icons> close </md-icon> </md-button> </div> <div class=\"alert tb-flow-drop\" flow-drop> <label for=select translate>import.drop-file</label> <input class=file-input flow-btn flow-attrs=\"{accept:'.json,application/json'}\" id=select> </div> </div> </div> <div> <div ng-show=!vm.fileName translate>import.no-file</div> <div ng-show=vm.fileName>{{ vm.fileName }}</div> </div> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || !theForm.$dirty || !theForm.$valid || !vm.importData\" type=submit class=\"md-raised md-primary\"> {{ 'action.import' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	var path = 'jsonform/jsonform.tpl.html';
	var html = " <md-content layout=row layout-margin style=background-color:#fff> <div layout=column flex=45> <h3>The Generated Form</h3> <form name=ngform layout=column layout-padding> <tb-json-form schema=vm.schema form=vm.form model=vm.model readonly=\"vm.isFormReadonly === 'true'\" form-control=ngform> </tb-json-form> </form> <md-checkbox ng-true-value=\"'true'\" ng-false-value=\"'false'\" ng-model=vm.isFormReadonly>Readonly</md-checkbox> <div flex layout=column> <div ng-show=ngform.$valid><em>Form is valid</em></div> <div ng-show=ngform.$invalid><em>Form is not valid</em></div> <div ng-show=ngform.$dirty><em>Form is dirty</em></div> <h3>Model</h3> <md-button ng-click=vm.resetModel()>Reset model</md-button> <pre>{{vm.pretty()}}</pre> </div> </div> <div layout=column flex> <h3>Form</h3> <div ui-ace=\"{ mode:'json'}\" ng-class=\"{red: !vm.itParsesForm}\" ng-model=vm.formJson class=\"form-control form\"></div> <h3>Schema</h3> <div ui-ace=\"{ mode:'json'}\" ng-class=\"{red: !vm.itParses}\" ng-model=vm.schemaJson class=\"form-control schema\"></div> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	var path = 'layout/breadcrumb.tpl.html';
	var html = " <div flex class=tb-breadcrumb layout=row> <h1 flex hide-gt-sm>{{ steps[steps.length-1].ncyBreadcrumbLabel | breadcrumbLabel }}</h1> <span hide-xs hide-sm ng-repeat=\"step in steps\" ng-switch=\"$last || !!step.abstract\"> <a ng-switch-when=false href={{step.ncyBreadcrumbLink}}> <md-icon ng-show=\"step.ncyBreadcrumbLabel | breadcrumbIcon\" class=material-icons aria-label=\"{{step.ncyBreadcrumbLabel | breadcrumbIcon}}\"> {{step.ncyBreadcrumbLabel | breadcrumbIcon}} </md-icon> {{step.ncyBreadcrumbLabel | breadcrumbLabel}} </a> <span ng-switch-when=true> <md-icon ng-show=\"step.ncyBreadcrumbLabel | breadcrumbIcon\" class=material-icons aria-label=\"{{step.ncyBreadcrumbLabel | breadcrumbIcon}}\"> {{step.ncyBreadcrumbLabel | breadcrumbIcon}} </md-icon> {{step.ncyBreadcrumbLabel | breadcrumbLabel}}</span> <span class=divider ng-hide=$last> > </span> </span> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	var path = 'layout/home.tpl.html';
	var html = " <md-sidenav class=\"tb-site-sidenav md-sidenav-left md-whiteframe-z2\" ng-show=!forceFullscreen hide-print=\"\" md-component-id=left aria-label=\"Toggle Nav\" ng-click=vm.sidenavClicked() md-is-open=vm.isShowSidenav md-is-locked-open=vm.isLockSidenav layout=column> <header class=tb-nav-header> <md-toolbar class=tb-nav-header-toolbar> <div flex layout=row class=\"md-toolbar-tools inset\"> <md-icon md-svg-src={{vm.logoSvg}} aria-label=logo class=tb-logo-title></md-icon> </div> </md-toolbar> </header> <md-toolbar flex class=tb-side-menu-toolbar role=navigation> <tb-side-menu></tb-side-menu> </md-toolbar> </md-sidenav> <div flex layout=column tabindex=-1 role=main> <md-toolbar class=\"md-whiteframe-z1 tb-primary-toolbar\"> <div layout=row flex class=md-toolbar-tools> <md-button id=main hide-gt-sm ng-show=!forceFullscreen class=md-icon-button ng-click=vm.openSidenav() aria-label=\"{{ 'home.menu' | translate }}\" ng-class=\"{'tb-invisible': vm.displaySearchMode()}\"> <md-icon aria-label=\"{{ 'home.menu' | translate }}\" class=material-icons>menu</md-icon> </md-button> <md-button ng-show=forceFullscreen class=md-icon-button aria-label=\"{{ 'action.back' | translate }}\" ng-click=vm.goBack() ng-class=\"{'tb-invisible': vm.displaySearchMode()}\"> <md-icon aria-label=\"{{ 'action.back' | translate }}\" class=material-icons>arrow_back</md-icon> </md-button> <md-button class=md-icon-button aria-label=\"{{ 'action.back' | translate }}\" ng-click=vm.closeSearch() ng-class=\"{'tb-invisible': !vm.displaySearchMode()}\"> <md-icon aria-label=\"{{ 'action.back' | translate }}\" class=material-icons>arrow_back</md-icon> </md-button> <div flex layout=row ng-show=!vm.displaySearchMode() tb-no-animate class=md-toolbar-tools> <span ng-cloak ncy-breadcrumb></span> </div> <div layout=row ng-show=vm.displaySearchMode() md-theme=tb-dark flex> <div class=tb-entity-subtype-search layout=row layout-align=\"start center\" ng-if=vm.displayEntitySubtypeSearch()> <tb-entity-subtype-select entity-type=searchConfig.searchEntityType ng-model=searchConfig.searchEntitySubtype> </tb-entity-subtype-select> </div> <md-input-container ng-class=\"{'tb-entity-search': vm.displayEntitySubtypeSearch()}\" flex> <label>&nbsp;</label> <input id=tb-search-text-input ng-model=searchConfig.searchText ng-change=vm.searchTextUpdated() placeholder=\"{{ 'common.enter-search' | translate }}\"> </md-input-container> </div> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\" ng-show=searchConfig.searchEnabled ng-click=vm.openSearch()> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> </md-button> <md-button ng-show=!vm.displaySearchMode() hide-xs hide-sm class=md-icon-button ng-click=vm.toggleFullscreen() aria-label=\"{{ 'fullscreen.toggle' | translate }}\"> <ng-md-icon icon=\"{{vm.Fullscreen.isEnabled() ? 'fullscreen_exit' : 'fullscreen'}}\" options='{\"easing\": \"circ-in-out\", \"duration\": 375, \"rotation\": \"none\"}'></ng-md-icon> </md-button> <tb-user-menu display-user-info=!vm.displaySearchMode()> </tb-user-menu> </div> </md-toolbar> <md-progress-linear class=md-warn style=z-index:10;max-height:0;width:100% md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <div flex layout=column id=toast-parent style=position:relative> <md-content ng-cloak flex layout=column class=page-content ui-view name=content></md-content> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	var path = 'layout/user-menu.tpl.html';
	var html = " <section layout=row> <div hide-xs hide-sm hide-md ng-show=vm.displayUserInfo class=tb-user-info layout=row> <md-icon aria-label=\"{{ 'home.avatar' | translate }}\" class=\"material-icons tb-mini-avatar\">account_circle</md-icon> <div layout=column> <span class=tb-user-display-name>{{vm.userDisplayName()}}</span> <span class=tb-user-authority>{{vm.authorityName()}}</span> </div> </div> <md-menu md-position-mode=\"target-right target\"> <md-button class=md-icon-button aria-label=\"{{ 'home.open-user-menu' | translate }}\" ng-click=$mdOpenMenu($event)> <md-icon md-menu-origin aria-label=\"{{ 'home.open-user-menu' | translate }}\" class=material-icons>more_vert</md-icon> </md-button> <md-menu-content width=4> <md-menu-item> <md-button ng-click=vm.openProfile()> <md-icon md-menu-align-target aria-label=\"{{ 'home.profile' | translate }}\" class=material-icons>account_circle</md-icon> <span translate>home.profile</span> </md-button> </md-menu-item> <md-menu-item> <md-button ng-click=vm.logout()> <md-icon md-menu-align-target aria-label=\"{{ 'home.logout' | translate }}\" class=material-icons>exit_to_app</md-icon> <span translate>home.logout</span> </md-button> </md-menu-item> </md-menu-content> </md-menu> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	var path = 'login/create-password.tpl.html';
	var html = " <md-content layout=row layout-align=\"center center\" style=width:100%> <md-card flex=initial class=tb-login-card md-theme=tb-dark> <md-card-title> <md-card-title-text> <span translate class=md-headline>login.create-password</span> </md-card-title-text> </md-card-title> <md-progress-linear class=md-warn style=z-index:1;max-height:5px;width:inherit;position:absolute md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <md-card-content> <form class=create-password-form ng-submit=vm.createPassword()> <div layout=column layout-padding=\"\" id=toast-parent> <span style=height:50px></span> <md-input-container class=md-block> <label translate>common.password</label> <md-icon aria-label=\"{{ 'common.password' | translate }}\" class=material-icons> lock </md-icon> <input id=password-input type=password ng-model=vm.password> </md-input-container> <md-input-container class=md-block> <label translate>login.password-again</label> <md-icon aria-label=\"{{ 'login.password-again' | translate }}\" class=material-icons> lock </md-icon> <input id=password-input2 type=password ng-model=vm.password2> </md-input-container> <div layout=column layout-gt-sm=row layout-padding=\"\" layout-align=\"start center\" layout-align-gt-sm=\"center start\"> <md-button class=\"md-raised md-accent\" type=submit>{{ 'login.create-password' | translate }} </md-button> <md-button class=md-raised ui-sref=login>{{ 'action.cancel' | translate }}</md-button> </div> </div> </form> </md-card-content> </md-card> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	var path = 'login/login.tpl.html';
	var html = " <md-content layout=row layout-align=\"center center\" style=width:100%> <md-card flex=initial class=tb-login-card md-theme=tb-dark> <md-card-title> <img src={{vm.logoSvg}} aria-label=logo class=tb-login-logo> </md-card-title> <md-progress-linear class=md-warn style=z-index:1;max-height:0;width:inherit md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <md-card-content> <form class=login-form ng-submit=vm.login()> <div layout=column layout-padding=\"\" id=toast-parent> <span style=height:50px></span> <md-input-container class=md-block> <label translate>login.username</label> <md-icon aria-label=\"{{ 'login.username' | translate }}\" class=material-icons> email </md-icon> <input id=username-input type=email autofocus ng-model=vm.user.name> </md-input-container> <md-input-container class=md-block> <label translate>common.password</label> <md-icon aria-label=\"{{ 'common.password' | translate }}\" class=material-icons> lock </md-icon> <input id=password-input type=password ng-model=vm.user.password> </md-input-container> <div layout-gt-sm=column layout-align=\"space-between stretch\"> <div layout-gt-sm=column layout-align=\"space-between end\"> <md-button ui-sref=login.resetPasswordRequest>{{ 'login.forgot-password' | translate }} </md-button> </div> </div> <md-button class=md-raised type=submit>{{ 'login.login' | translate }}</md-button> </div> </form> </md-card-content> </md-card> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	var path = 'login/reset-password-request.tpl.html';
	var html = " <md-content layout=row layout-align=\"center center\" style=width:100%> <md-card flex=initial class=tb-login-card md-theme=tb-dark> <md-card-title> <md-card-title-text> <span translate class=md-headline>login.request-password-reset</span> </md-card-title-text> </md-card-title> <md-progress-linear class=md-warn style=z-index:1;max-height:5px;width:inherit;position:absolute md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <md-card-content> <form class=request-password-reset-form ng-submit=vm.sendResetPasswordLink()> <div layout=column layout-padding=\"\" id=toast-parent> <span style=height:50px></span> <md-input-container class=md-block> <label translate>login.email</label> <md-icon aria-label=\"{{ 'login.email' | translate }}\" class=material-icons> email </md-icon> <input id=email-input type=email autofocus ng-model=vm.email> </md-input-container> <div layout=column layout-gt-sm=row layout-padding=\"\" layout-align=\"start center\" layout-align-gt-sm=\"center start\"> <md-button class=\"md-raised md-accent\" type=submit>{{ 'login.request-password-reset' | translate }} </md-button> <md-button class=md-raised ui-sref=login>{{ 'action.cancel' | translate }}</md-button> </div> </div> </form> </md-card-content> </md-card> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	var path = 'login/reset-password.tpl.html';
	var html = " <md-content layout=row layout-align=\"center center\" style=width:100%> <md-card flex=initial class=tb-login-card md-theme=tb-dark> <md-card-title> <md-card-title-text> <span translate class=md-headline>login.password-reset</span> </md-card-title-text> </md-card-title> <md-progress-linear class=md-warn style=z-index:1;max-height:5px;width:inherit;position:absolute md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <md-card-content> <form class=password-reset-form ng-submit=vm.resetPassword()> <div layout=column layout-padding=\"\" id=toast-parent> <span style=height:50px></span> <md-input-container class=md-block> <label translate>login.new-password</label> <md-icon aria-label=\"{{ 'login.new-password' | translate }}\" class=material-icons> lock </md-icon> <input id=password-input type=password ng-model=vm.newPassword> </md-input-container> <md-input-container class=md-block> <label translate>login.new-password-again</label> <md-icon aria-label=\"{{ 'login.new-password-again' | translate }}\" class=material-icons> lock </md-icon> <input id=password-input2 type=password ng-model=vm.newPassword2> </md-input-container> <div layout=column layout-gt-sm=row layout-padding=\"\" layout-align=\"start center\" layout-align-gt-sm=\"center start\"> <md-button class=\"md-raised md-accent\" type=submit>{{ 'login.reset-password' | translate }} </md-button> <md-button class=md-raised ui-sref=login>{{ 'action.cancel' | translate }}</md-button> </div> </div> </form> </md-card-content> </md-card> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	var path = 'profile/change-password.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'profile.change-password' | translate }}\"> <form name=theForm ng-submit=vm.changePassword()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>profile.change-password</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <md-input-container class=md-block> <label translate>profile.current-password</label> <md-icon aria-label=\"{{ 'profile.current-password' | translate }}\" class=material-icons> lock </md-icon> <input id=current-password-input type=password ng-model=vm.currentPassword> </md-input-container> <md-input-container class=md-block> <label translate>login.new-password</label> <md-icon aria-label=\"{{ 'login.new-password' | translate }}\" class=material-icons> lock </md-icon> <input id=password-input type=password ng-model=vm.newPassword> </md-input-container> <md-input-container class=md-block> <label translate>login.new-password-again</label> <md-icon aria-label=\"{{ 'login.new-password-again' | translate }}\" class=material-icons> lock </md-icon> <input id=password-input2 type=password ng-model=vm.newPassword2> </md-input-container> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid\" type=submit class=\"md-raised md-primary\"> {{ 'profile.change-password' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	var path = 'profile/profile.tpl.html';
	var html = " <div layout=row width=100% layout-wrap> <md-card flex-gt-sm=60 flex=100 style=height:100%> <md-card-title> <md-card-title-text> <span translate class=md-headline>profile.profile</span> <span style=opacity:.7>{{ vm.profileUser.email }}</span> </md-card-title-text> </md-card-title> <md-progress-linear md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-card-content> <form name=theForm ng-submit=vm.save() tb-confirm-on-exit confirm-form=theForm> <fieldset ng-disabled=$root.loading> <md-input-container class=md-block> <label translate>user.email</label> <input name=email type=email ng-model=vm.profileUser.email> </md-input-container> <md-input-container class=md-block> <label translate>user.first-name</label> <input name=firstName ng-model=vm.profileUser.firstName> </md-input-container> <md-input-container class=md-block> <label translate>user.last-name</label> <input name=lastName ng-model=vm.profileUser.lastName> </md-input-container> <md-input-container class=md-block> <label translate>language.language</label> <md-select name=language ng-model=vm.profileUser.additionalInfo.lang> <md-option ng-repeat=\"lang in vm.languageList\" ng-value=lang> {{ lang ? ('language.locales.' + lang | translate) : ''}} </md-option> </md-select> </md-input-container> <md-button ng-disabled=$root.loading ng-click=vm.changePassword($event) class=\"md-raised md-primary\">{{ 'profile.change-password' | translate }} </md-button> <div layout=row layout-align=\"end center\" width=100% layout-wrap> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\">{{ 'action.save' | translate }} </md-button> </div> </fieldset> </form> </md-card-content> </md-card> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	var path = 'rulechain/add-link.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'rulenode.add-link' | translate }}\" tb-help=\"'ruleEngine'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>rulenode.add-link</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-rule-node-link ng-model=vm.link allowed-labels=vm.labels is-edit=true allow-custom=vm.allowCustomLabels></tb-rule-node-link> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	var path = 'rulechain/add-rulechain.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'rulechain.add' | translate }}\" tb-help=\"'rulechains'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>rulechain.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-rule-chain rule-chain=vm.item is-edit=true the-form=theForm></tb-rule-chain> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	var path = 'rulechain/add-rulenode.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'rulenode.add' | translate }}\" tb-help=vm.helpLinks.getRuleNodeLink(vm.ruleNode) help-container-id=help-container style=min-width:650px> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>rulenode.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-rule-node rule-node=vm.ruleNode rule-chain-id=vm.ruleChainId is-edit=true the-form=theForm></tb-rule-node> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	var path = 'rulechain/link-fieldset.tpl.html';
	var html = " <md-content class=\"md-padding tb-link\" layout=column> <fieldset ng-disabled=\"$root.loading || !isEdit || isReadOnly\"> <label translate class=\"tb-title no-padding\" ng-class=\"{'tb-required': required}\">rulenode.link-labels</label> <md-chips id=link_label_chips ng-required=true readonly=\"$root.loading || !isEdit || isReadOnly\" ng-model=labels md-autocomplete-snap md-transform-chip=transformLinkLabelChip($chip) md-require-match=!allowCustom> <md-autocomplete id=link_label md-no-cache=true md-selected-item=selectedLabel md-search-text=labelSearchText md-items=\"item in labelsSearch(labelSearchText)\" md-item-text=item.name md-min-length=0 placeholder=\"{{'rulenode.link-label' | translate }}\" md-menu-class=tb-link-label-autocomplete> <span md-highlight-text=labelSearchText md-highlight-flags=^i>{{item}}</span> <md-not-found> <div class=tb-not-found> <div class=tb-no-entries ng-if=\"!labelSearchText || !labelSearchText.length\"> <span translate>rulenode.no-link-labels-found</span> </div> <div ng-if=\"labelSearchText && labelSearchText.length\"> <span translate translate-values='{ label: \"{{labelSearchText | truncate:true:6:&apos;...&apos;}}\" }'>rulenode.no-link-label-matching</span> <span ng-if=allowCustom> <a translate ng-click=\"createLinkLabel($event, '#link_label_chips')\">rulenode.create-new-link-label</a> </span> </div> </div> </md-not-found> </md-autocomplete> <md-chip-template> <span>{{$chip.name}}</span> </md-chip-template> </md-chips> <div class=tb-error-messages ng-messages=ngModelCtrl.$error role=alert> <div translate ng-message=linkLabels class=tb-error-message>rulenode.link-labels-required</div> </div> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	var path = 'rulechain/message-type-autocomplete.tpl.html';
	var html = " <md-autocomplete ng-required=required ng-disabled=disabled md-no-cache=true md-input-name=messageType ng-model=messageType md-selected-item=messageType md-search-text=messageTypeSearchText md-search-text-change=messageTypeSearchTextChanged() md-items=\"item in fetchMessageTypes(messageTypeSearchText)\" md-item-text=item.name md-min-length=0 placeholder=\"{{ 'rulenode.select-message-type' | translate }}\" md-floating-label=\"{{ 'rulenode.message-type' | translate }}\" md-select-on-match=false md-menu-class=tb-message-type-autocomplete> <md-item-template> <div class=tb-message-type-item> <span md-highlight-text=messageTypeSearchText md-highlight-flags=^i>{{item.name}}</span> </div> </md-item-template> <div ng-messages=theForm.messageType.$error> <div translate ng-message=required>rulenode.message-type-required</div> </div> </md-autocomplete> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	var path = 'rulechain/rulechain-card.tpl.html';
	var html = " <div ng-if=\"item && item.root\" translate>rulechain.root</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	var path = 'rulechain/rulechain-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onExportRuleChain({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ 'rulechain.export' | translate }}</md-button> <md-button ng-click=\"onSetRootRuleChain({event: $event})\" ng-show=\"!isEdit && !ruleChain.root\" class=\"md-raised md-primary\">{{ 'rulechain.set-root' | translate }}</md-button> <md-button ng-click=\"onDeleteRuleChain({event: $event})\" ng-show=\"!isEdit && !ruleChain.root\" class=\"md-raised md-primary\">{{ 'rulechain.delete' | translate }}</md-button> <div layout=row> <md-button ngclipboard data-clipboard-action=copy ngclipboard-success=onRuleChainIdCopied(e) data-clipboard-text={{ruleChain.id.id}} ng-show=!isEdit class=md-raised> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <span translate>rulechain.copyId</span> </md-button> </div> <md-content class=\"md-padding tb-rulechain-fieldset\" layout=column> <fieldset ng-disabled=\"$root.loading || !isEdit || isReadOnly\"> <md-input-container class=md-block> <label translate>rulechain.name</label> <input required name=name ng-model=ruleChain.name> <div ng-messages=theForm.name.$error> <div translate ng-message=required>rulechain.name-required</div> </div> </md-input-container> <md-input-container class=md-block> <md-checkbox ng-disabled=\"$root.loading || !isEdit\" aria-label=\"{{ 'rulechain.debug-mode' | translate }}\" ng-model=ruleChain.debugMode>{{ 'rulechain.debug-mode' | translate }} </md-checkbox> </md-input-container> <md-input-container class=md-block> <label translate>rulechain.description</label> <textarea ng-model=ruleChain.additionalInfo.description rows=2></textarea> </md-input-container> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	var path = 'rulechain/rulechain.tpl.html';
	var html = " <md-content flex tb-expand-fullscreen tb-confirm-on-exit is-dirty=vm.isConfirmOnExit expand-tooltip-direction=bottom layout=column class=tb-rulechain ng-keydown=vm.keyDown($event) ng-keyup=vm.keyUp($event) on-fullscreen-changed=\"vm.isFullscreen = expanded\"> <section class=tb-rulechain-container flex layout=column> <div class=tb-rulechain-layout flex layout=row> <section layout=row layout-wrap class=\"tb-header-buttons md-fab tb-library-open\"> <md-button ng-show=!vm.isLibraryOpen class=\"tb-btn-header tb-btn-open-library md-primary md-fab md-fab-top-left\" aria-label=\"{{ 'rulenode.open-node-library' | translate }}\" ng-click=\"vm.isLibraryOpen = true\"> <md-tooltip md-direction=\"{{vm.isFullscreen ? 'bottom' : 'top'}}\"> {{ 'rulenode.open-node-library' | translate }} </md-tooltip> <ng-md-icon icon=menu></ng-md-icon> </md-button> </section> <md-sidenav class=\"tb-rulechain-library md-sidenav-left md-whiteframe-4dp\" md-disable-backdrop md-is-locked-open=vm.isLibraryOpenReadonly md-is-open=vm.isLibraryOpenReadonly md-component-id=rulechain-library-sidenav layout=column> <md-toolbar> <div class=md-toolbar-tools> <md-button class=\"md-icon-button tb-small\" aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=\"{{vm.isFullscreen ? 'bottom' : 'top'}}\"> {{'rulenode.search' | translate}} </md-tooltip> </md-button> <div layout=row md-theme=tb-dark flex> <md-input-container flex> <label>&nbsp;</label> <input ng-model=vm.ruleNodeSearch placeholder=\"{{'rulenode.search' | translate}}\"> </md-input-container> </div> <md-button class=\"md-icon-button tb-small\" aria-label=Close ng-show=vm.ruleNodeSearch ng-click=\"vm.ruleNodeSearch = ''\"> <md-icon aria-label=Close class=material-icons>close</md-icon> <md-tooltip md-direction=\"{{vm.isFullscreen ? 'bottom' : 'top'}}\"> {{ 'action.clear-search' | translate }} </md-tooltip> </md-button> <md-button class=\"md-icon-button tb-small\" aria-label=Close ng-click=\"vm.isLibraryOpen = false\"> <md-icon aria-label=Close class=material-icons>chevron_left</md-icon> <md-tooltip md-direction=\"{{vm.isFullscreen ? 'bottom' : 'top'}}\"> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-expansion-panel-group flex ng-if=vm.ruleChainLibraryLoaded class=tb-rulechain-library-panel-group md-component-id=libraryPanelGroup auto-expand=true multiple=multiple> <md-expansion-panel md-component-id={{typeId}} id={{typeId}} ng-repeat=\"(typeId, typeModel) in vm.ruleNodeTypesModel\"> <md-expansion-panel-collapsed ng-mouseenter=\"vm.typeHeaderMouseEnter($event, typeId)\" ng-mouseleave=vm.destroyTooltips()> <md-icon aria-label=node-type-icon class=material-icons style=margin-right:8px>{{vm.types.ruleNodeType[typeId].icon}}</md-icon> <div class=tb-panel-title translate>{{vm.types.ruleNodeType[typeId].name}}</div> <md-expansion-panel-icon></md-expansion-panel-icon> </md-expansion-panel-collapsed> <md-expansion-panel-expanded> <md-expansion-panel-header ng-mouseenter=\"vm.typeHeaderMouseEnter($event, typeId)\" ng-mouseleave=vm.destroyTooltips() ng-click=vm.$mdExpansionPanel(typeId).collapse()> <md-icon aria-label=node-type-icon class=material-icons style=margin-right:8px>{{vm.types.ruleNodeType[typeId].icon}}</md-icon> <div class=tb-panel-title translate>{{vm.types.ruleNodeType[typeId].name}}</div> <md-expansion-panel-icon></md-expansion-panel-icon> </md-expansion-panel-header> <md-expansion-panel-content> <fc-canvas id=tb-rulechain-{{typeId}} model=vm.ruleNodeTypesModel[typeId].model selected-objects=vm.ruleNodeTypesModel[typeId].selectedObjects automatic-resize=false callbacks=vm.nodeLibCallbacks node-width=170 node-height=50 control=vm.ruleNodeTypesCanvasControl[typeId] drop-target-id=\"'tb-rulchain-canvas'\"></fc-canvas> </md-expansion-panel-content> </md-expansion-panel-expanded> </md-expansion-panel> </md-expansion-panel-group> </md-sidenav> <md-menu flex style=position:relative md-position-mode=\"target target\" tb-offset-x=-20 tb-offset-y=-45 tb-mousepoint-menu> <div class=\"tb-absolute-fill tb-rulechain-graph\" ng-click=\"\" tb-contextmenu=\"vm.openRuleChainContextMenu($event, $mdOpenMousepointMenu)\"> <fc-canvas id=tb-rulchain-canvas model=vm.ruleChainModel selected-objects=vm.selectedObjects edge-style=curved node-width=170 node-height=50 automatic-resize=true control=vm.canvasControl callbacks=vm.editCallbacks> </fc-canvas> </div> <md-menu-content id=tb-rule-chain-context-menu width=4 ng-mouseleave=$mdCloseMousepointMenu()> <div class=\"tb-context-menu-header {{vm.contextInfo.headerClass}}\"> <md-icon ng-if=!vm.contextInfo.iconUrl aria-label=node-type-icon class=material-icons>{{vm.contextInfo.icon}}</md-icon> <md-icon ng-if=vm.contextInfo.iconUrl aria-label=node-type-icon md-svg-icon={{vm.contextInfo.iconUrl}}></md-icon> <div flex> <div class=tb-context-menu-title>{{vm.contextInfo.title}}</div> <div class=tb-context-menu-subtitle>{{vm.contextInfo.subtitle}}</div> </div> </div> <div ng-repeat=\"item in vm.contextInfo.items\"> <md-divider ng-if=item.divider></md-divider> <md-menu-item ng-if=!item.divider> <md-button ng-disabled=!item.enabled ng-click=item.action(vm.contextMenuEvent)> <span ng-if=item.shortcut class=tb-alt-text> {{ item.shortcut | keyboardShortcut }}</span> <md-icon ng-if=item.icon md-menu-align-target aria-label=\"{{ item.value | translate }}\" class=material-icons>{{item.icon}}</md-icon> <span translate>{{item.value}}</span> </md-button> </md-menu-item> </div> </md-menu-content> </md-menu> </div> <tb-details-sidenav class=tb-rulenode-details-sidenav header-title={{vm.editingRuleNode.name}} header-subtitle=\"{{(vm.types.ruleNodeType[vm.editingRuleNode.component.type].name | translate)\n                            + ' - ' + vm.editingRuleNode.component.name}}\" is-read-only=\"vm.selectedRuleNodeTabIndex > 0\" is-open=vm.isEditingRuleNode tb-enable-backdrop is-always-edit=true on-close-details=vm.onEditRuleNodeClosed() on-toggle-details-edit-mode=vm.onRevertRuleNodeEdit(vm.ruleNodeForm) on-apply-details=vm.saveRuleNode(vm.ruleNodeForm) the-form=vm.ruleNodeForm> <details-buttons tb-help=vm.helpLinkIdForRuleNodeType() help-container-id=help-container> <div id=help-container></div> </details-buttons> <md-tabs md-selected=vm.selectedRuleNodeTabIndex id=ruleNodeTabs md-border-bottom flex class=tb-absolute-fill ng-if=vm.isEditingRuleNode> <md-tab label=\"{{ 'rulenode.details' | translate }}\"> <form name=vm.ruleNodeForm> <tb-rule-node rule-node=vm.editingRuleNode rule-chain-id=vm.ruleChain.id.id is-edit=true is-read-only=false on-delete-rule-node=\"vm.deleteRuleNode(event, vm.editingRuleNode)\" the-form=vm.ruleNodeForm> </tb-rule-node> </form> </md-tab> <md-tab ng-if=\"vm.isEditingRuleNode && vm.editingRuleNode.ruleNodeId\" md-on-select=vm.triggerResize() label=\"{{ 'rulenode.events' | translate }}\"> <tb-event-table flex entity-type=vm.types.entityType.rulenode entity-id=vm.editingRuleNode.ruleNodeId.id tenant-id=vm.ruleChain.tenantId.id debug-event-types={{vm.types.debugEventType.debugRuleNode.value}} default-event-type={{vm.types.debugEventType.debugRuleNode.value}}> </tb-event-table> </md-tab> <md-tab label=\"{{ 'rulenode.help' | translate }}\"> <div class=tb-rule-node-help> <div id=tb-node-content class=md-padding layout=column> <div class=tb-node-title>{{vm.editingRuleNode.component.name}}</div> <div>&nbsp;</div> <div class=tb-node-description>{{vm.editingRuleNode.component.configurationDescriptor.nodeDefinition.description}}</div> <div>&nbsp;</div> <div class=tb-node-details ng-bind-html=vm.editingRuleNode.component.configurationDescriptor.nodeDefinition.details></div> </div> </div> </md-tab> </md-tabs> </tb-details-sidenav> <tb-details-sidenav class=tb-rulenode-link-details-sidenav header-title={{vm.editingRuleNodeLink.label}} header-subtitle=\"{{'rulenode.link-details' | translate}}\" is-read-only=false is-open=vm.isEditingRuleNodeLink tb-enable-backdrop is-always-edit=true on-close-details=vm.onEditRuleNodeLinkClosed() on-toggle-details-edit-mode=vm.onRevertRuleNodeLinkEdit(vm.ruleNodeLinkForm) on-apply-details=vm.saveRuleNodeLink(vm.ruleNodeLinkForm) the-form=vm.ruleNodeLinkForm> <details-buttons tb-help=\"'ruleEngine'\" help-container-id=link-help-container> <div id=link-help-container></div> </details-buttons> <form name=vm.ruleNodeLinkForm ng-if=vm.isEditingRuleNodeLink> <tb-rule-node-link ng-model=vm.editingRuleNodeLink allowed-labels=vm.editingRuleNodeLinkLabels allow-custom=vm.editingRuleNodeAllowCustomLabels is-edit=true is-read-only=false> </tb-rule-node-link> </form> </tb-details-sidenav> </section> <section layout=row layout-wrap class=\"tb-footer-buttons md-fab\" layout-align=\"start end\"> <md-button ng-disabled=$root.loading ng-show=vm.objectsSelected() class=\"tb-btn-footer md-accent md-hue-2 md-fab\" ng-click=vm.deleteSelected() aria-label=\"{{ 'action.delete' | translate }}\"> <md-tooltip md-direction=top> {{ 'rulenode.delete-selected-objects' | translate }} </md-tooltip> <ng-md-icon icon=delete></ng-md-icon> </md-button> <md-button ng-disabled=\"$root.loading  || vm.isInvalid || (!vm.isDirty && !vm.isImport)\" class=\"tb-btn-footer md-accent md-hue-2 md-fab\" aria-label=\"{{ 'action.apply' | translate }}\" ng-click=vm.saveRuleChain()> <md-tooltip md-direction=top> {{ 'action.apply-changes' | translate }} </md-tooltip> <ng-md-icon icon=done></ng-md-icon> </md-button> <md-button ng-disabled=\"$root.loading || !vm.isDirty\" class=\"tb-btn-footer md-accent md-hue-2 md-fab\" aria-label=\"{{ 'action.decline-changes' | translate }}\" ng-click=vm.revertRuleChain()> <md-tooltip md-direction=top> {{ 'action.decline-changes' | translate }} </md-tooltip> <ng-md-icon icon=close></ng-md-icon> </md-button> </section> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	var path = 'rulechain/rulechains.tpl.html';
	var html = " <tb-grid grid-configuration=vm.ruleChainGridConfig> <details-buttons tb-help=\"'rulechains'\" help-container-id=help-container> <div id=help-container></div> </details-buttons> <md-tabs ng-class=\"{'tb-headless': (vm.grid.detailsConfig.isDetailsEditMode || !vm.isRuleChainEditable(vm.grid.operatingItem()))}\" id=tabs md-border-bottom flex class=tb-absolute-fill> <md-tab label=\"{{ 'rulechain.details' | translate }}\"> <tb-rule-chain rule-chain=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode is-read-only=vm.grid.isDetailsReadOnly(vm.grid.operatingItem()) the-form=vm.grid.detailsForm on-set-root-rule-chain=\"vm.setRootRuleChain(event, vm.grid.detailsConfig.currentItem)\" on-export-rule-chain=\"vm.exportRuleChain(event, vm.grid.detailsConfig.currentItem)\" on-delete-rule-chain=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"> </tb-rule-chain> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.isRuleChainEditable(vm.grid.operatingItem())\" md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.attributes' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.rulechain}} entity-name=vm.grid.operatingItem().name default-attribute-scope={{vm.types.attributesScope.server.value}}> </tb-attribute-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.isRuleChainEditable(vm.grid.operatingItem())\" md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.latest-telemetry' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.rulechain}} entity-name=vm.grid.operatingItem().name default-attribute-scope={{vm.types.latestTelemetry.value}} disable-attribute-scope-selection=true> </tb-attribute-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.isRuleChainEditable(vm.grid.operatingItem())\" md-on-select=vm.grid.triggerResize() label=\"{{ 'alarm.alarms' | translate }}\"> <tb-alarm-table flex entity-type=vm.types.entityType.rulechain entity-id=vm.grid.operatingItem().id.id> </tb-alarm-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.isRuleChainEditable(vm.grid.operatingItem())\" md-on-select=vm.grid.triggerResize() label=\"{{ 'rulechain.events' | translate }}\"> <tb-event-table flex entity-type=vm.types.entityType.rulechain entity-id=vm.grid.operatingItem().id.id tenant-id=vm.grid.operatingItem().tenantId.id debug-event-types={{vm.types.debugEventType.debugRuleChain.value}} default-event-type={{vm.types.debugEventType.debugRuleChain.value}}> </tb-event-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.isRuleChainEditable(vm.grid.operatingItem())\" md-on-select=vm.grid.triggerResize() label=\"{{ 'relation.relations' | translate }}\"> <tb-relation-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.rulechain}}> </tb-relation-table> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.isRuleChainEditable(vm.grid.operatingItem()) && vm.grid.isTenantAdmin()\" md-on-select=vm.grid.triggerResize() label=\"{{ 'audit-log.audit-logs' | translate }}\"> <tb-audit-log-table flex entity-type=vm.types.entityType.rulechain entity-id=vm.grid.operatingItem().id.id audit-log-mode={{vm.types.auditLogMode.entity}}> </tb-audit-log-table> </md-tab> </md-tabs> </tb-grid> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	var path = 'rulechain/rulenode-config.tpl.html';
	var html = " <tb-rule-node-defined-config ng-if=useDefinedDirective() rule-node-id=ruleNodeId ng-model=configuration rule-node-directive={{nodeDefinition.configDirective}} ng-required=required ng-readonly=readonly> </tb-rule-node-defined-config> <div class=tb-rulenode-directive-error ng-if=definedDirectiveError>{{definedDirectiveError}}</div> <tb-json-object-edit ng-if=!useDefinedDirective() class=tb-rule-node-configuration-json ng-model=configuration label=\"{{ 'rulenode.configuration' | translate }}\" ng-required=required fill-height=true> </tb-json-object-edit> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	var path = 'rulechain/rulenode-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onDeleteRuleNode({event: $event})\" ng-show=\"!isEdit && !isReadOnly\" class=\"md-raised md-primary\">{{ 'rulenode.delete' | translate }}</md-button> <md-content class=\"md-padding tb-rulenode\" layout=column> <fieldset ng-disabled=\"$root.loading || !isEdit || isReadOnly\"> <section ng-if=\"ruleNode.component.type != types.ruleNodeType.RULE_CHAIN.value\"> <section layout=column layout-gt-sm=row> <md-input-container flex class=md-block> <label translate>rulenode.name</label> <input required name=name ng-model=ruleNode.name> <div ng-messages=theForm.name.$error> <div translate ng-message=required>rulenode.name-required</div> </div> </md-input-container> <md-input-container class=md-block> <md-checkbox ng-disabled=\"$root.loading || !isEdit\" aria-label=\"{{ 'rulenode.debug-mode' | translate }}\" ng-model=ruleNode.debugMode>{{ 'rulenode.debug-mode' | translate }} </md-checkbox> </md-input-container> </section> <tb-rule-node-config ng-model=ruleNode.configuration rule-node-id=ruleNode.ruleNodeId.id ng-required=true node-definition=ruleNode.component.configurationDescriptor.nodeDefinition ng-readonly=\"$root.loading || !isEdit || isReadOnly\"> </tb-rule-node-config> <md-input-container class=md-block> <label translate>rulenode.description</label> <textarea ng-model=ruleNode.additionalInfo.description rows=2></textarea> </md-input-container> </section> <section ng-if=\"ruleNode.component.type == types.ruleNodeType.RULE_CHAIN.value\"> <tb-entity-autocomplete the-form=theForm ng-disabled=\"$root.loading || !isEdit || isReadOnly\" tb-required=true exclude-entity-ids=[ruleChainId] entity-type=types.entityType.rulechain ng-model=params.targetRuleChainId> </tb-entity-autocomplete> <md-input-container class=md-block> <label translate>rulenode.description</label> <textarea ng-model=ruleNode.additionalInfo.description rows=2></textarea> </md-input-container> </section> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	var path = 'rulechain/rulenode.tpl.html';
	var html = " <div id={{node.id}} ng-attr-style=\"position: absolute; top: {{ node.y }}px; left: {{ node.x }}px;\" ng-dblclick=\"callbacks.doubleClick($event, node)\" ng-mousedown=\"callbacks.mouseDown($event, node)\" ng-mouseenter=\"callbacks.mouseEnter($event, node)\" ng-mouseleave=\"callbacks.mouseLeave($event, node)\"> <div class={{flowchartConstants.nodeOverlayClass}}></div> <div class=\"tb-rule-node {{node.nodeClass}}\" ng-class=\"{'tb-rule-node-highlighted' : node.highlighted, 'tb-rule-node-invalid': node.error }\"> <md-icon ng-if=!node.iconUrl aria-label=node-type-icon flex=15 class=material-icons>{{node.icon}}</md-icon> <md-icon ng-if=node.iconUrl aria-label=node-type-icon flex=15 md-svg-icon={{node.iconUrl}}></md-icon> <div layout=column flex=85 layout-align=center> <span class=tb-node-type>{{ node.component.name }}</span> <span class=tb-node-title ng-if=node.name>{{ node.name }}</span> </div> <div class={{flowchartConstants.leftConnectorClass}}> <div fc-magnet ng-repeat=\"connector in modelservice.nodes.getConnectorsByType(node, flowchartConstants.leftConnectorType)\"> <div fc-connector></div> </div> </div> <div class={{flowchartConstants.rightConnectorClass}}> <div fc-magnet ng-repeat=\"connector in modelservice.nodes.getConnectorsByType(node, flowchartConstants.rightConnectorType)\"> <div fc-connector></div> </div> </div> </div> <div ng-if=\"modelservice.isEditable() && !node.readonly\" class=fc-nodeedit ng-click=\"callbacks.nodeEdit($event, node)\"> <i class=\"fa fa-pencil\" aria-hidden=true></i> </div> <div ng-if=\"modelservice.isEditable() && !node.readonly\" class=fc-nodedelete ng-click=modelservice.nodes.delete(node)> &times; </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	var path = 'rulechain/script/node-script-test.tpl.html';
	var html = " <md-dialog class=tb-node-script-test-dialog aria-label=\"{{ 'rulenode.test-script-function' | translate }}\" style=width:800px> <form flex name=theForm ng-submit=vm.save()> <md-toolbar> <div class=md-toolbar-tools> <h2>{{ 'rulenode.test-script-function' | translate }}</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-dialog-content flex style=position:relative> <div class=tb-absolute-fill> <div id=top_panel class=\"tb-split tb-split-vertical\"> <div id=top_left_panel class=\"tb-split tb-content\"> <div class=tb-resize-container> <div class=tb-editor-area-title-panel> <label translate>rulenode.message</label> </div> <ng-form name=payloadForm> <div layout=column style=height:100%> <div layout=row> <tb-message-type-autocomplete style=margin-bottom:0;min-width:300px ng-required=true ng-model=vm.inputParams.msgType the-form=payloadForm> </tb-message-type-autocomplete> </div> <tb-json-content flex ng-model=vm.inputParams.msg label=\"{{ 'rulenode.message' | translate }}\" content-type=vm.types.contentType.JSON.value validate-content=true validation-trigger-arg=validatePayload fill-height=true> </tb-json-content> </div> </ng-form> </div> </div> <div id=top_right_panel class=\"tb-split tb-content\"> <div class=tb-resize-container id=metadata-panel> <div class=tb-editor-area-title-panel> <label translate>rulenode.metadata</label> </div> <ng-form name=metadataForm> <tb-key-val-map title-text=rulenode.metadata ng-disabled=$root.loading key-val-map=vm.inputParams.metadata></tb-key-val-map> </ng-form> </div> </div> </div> <div id=bottom_panel class=\"tb-split tb-split-vertical\"> <div id=bottom_left_panel class=\"tb-split tb-content\"> <div class=tb-resize-container> <div class=\"tb-editor-area-title-panel tb-js-function\"> <label>{{ vm.functionTitle }}</label> </div> <ng-form name=funcBodyForm> <tb-js-func id=funcBodyInput ng-model=vm.inputParams.script function-name={{vm.inputParams.functionName}} function-args=\"{{ vm.inputParams.argNames }}\" validation-args=\"{{ [[vm.inputParams.msg, vm.inputParams.metadata, vm.inputParams.msgType]] }}\" validation-trigger-arg=validateFuncBody result-type=object fill-height=true> </tb-js-func> </ng-form> </div> </div> <div id=bottom_right_panel class=\"tb-split tb-content\"> <div class=tb-resize-container> <div class=tb-editor-area-title-panel> <label translate>rulenode.output</label> </div> <tb-json-content ng-model=vm.output label=\"{{ 'rulenode.output' | translate }}\" content-type=vm.types.contentType.JSON.value validate-content=false ng-readonly=true fill-height=true> </tb-json-content>generateReport </div> </div> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-disabled=\"$root.loading || theForm.$invalid\" ng-click=vm.test() class=\"md-raised md-primary\"> {{ 'rulenode.test' | translate }} </md-button> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.funcBodyForm.$invalid || !theForm.funcBodyForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.save' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	var path = 'services/error-toast.tpl.html';
	var html = " <md-toast class=tb-error-toast> <div class=md-toast-content> <div class=md-toast-text ng-bind-html=vm.message></div> <md-button ng-click=vm.closeToast()> {{ 'action.close' | translate }} </md-button> </div> </md-toast> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	var path = 'services/info-toast.tpl.html';
	var html = " <md-toast class=tb-info-toast> <div class=md-toast-content> <div class=md-toast-text ng-bind-html=vm.message></div> <md-button class=\"md-action md-highlight md-accent\" ng-click=vm.closeToast()> {{ 'action.close' | translate }} </md-button> </div> </md-toast> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	var path = 'services/success-toast.tpl.html';
	var html = " <md-toast class=tb-success-toast> <div class=md-toast-content> <div class=md-toast-text ng-bind-html=vm.message></div> <md-button ng-click=vm.closeToast()> {{ 'action.close' | translate }} </md-button> </div> </md-toast> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	var path = 'tenant/add-tenant.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'tenant.add' | translate }}\" tb-help=\"'tenants'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>tenant.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-tenant tenant=vm.item is-edit=true the-form=theForm></tb-tenant> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	var path = 'tenant/tenant-card.tpl.html';
	var html = " <div class=tb-uppercase>{{ item | contactShort }}</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	var path = 'tenant/tenant-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onManageUsers({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ 'tenant.manage-tenant-admins' | translate }}</md-button> <md-button ng-click=\"onDeleteTenant({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ 'tenant.delete' | translate }}</md-button> <div layout=row> <md-button ngclipboard data-clipboard-action=copy ngclipboard-success=onTenantIdCopied(e) data-clipboard-text={{tenant.id.id}} ng-show=!isEdit class=md-raised> <md-icon md-svg-icon=mdi:clipboard-arrow-left></md-icon> <span translate>tenant.copyId</span> </md-button> </div> <md-content class=md-padding layout=column> <fieldset ng-disabled=\"$root.loading || !isEdit\"> <md-input-container class=md-block> <label translate>tenant.title</label> <input required name=title ng-model=tenant.title> <div ng-messages=theForm.title.$error> <div translate ng-message=required>tenant.title-required</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>tenant.description</label> <textarea ng-model=tenant.additionalInfo.description rows=2></textarea> </md-input-container> <tb-contact contact=tenant the-form=theForm is-edit=isEdit></tb-contact> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	var path = 'tenant/tenants.tpl.html';
	var html = " <tb-grid grid-configuration=vm.tenantGridConfig> <details-buttons tb-help=\"'tenants'\" help-container-id=help-container> <div id=help-container></div> </details-buttons> <md-tabs ng-class=\"{'tb-headless': vm.grid.detailsConfig.isDetailsEditMode}\" id=tabs md-border-bottom flex class=tb-absolute-fill> <md-tab label=\"{{ 'tenant.details' | translate }}\"> <tb-tenant tenant=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode the-form=vm.grid.detailsForm on-manage-users=\"vm.openTenantUsers(event, vm.grid.detailsConfig.currentItem)\" on-delete-tenant=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"></tb-tenant> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.attributes' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.tenant}} entity-name=vm.grid.operatingItem().title default-attribute-scope={{vm.types.attributesScope.server.value}}> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'attribute.latest-telemetry' | translate }}\"> <tb-attribute-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.tenant}} entity-name=vm.grid.operatingItem().title default-attribute-scope={{vm.types.latestTelemetry.value}} disable-attribute-scope-selection=true> </tb-attribute-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'alarm.alarms' | translate }}\"> <tb-alarm-table flex entity-type=vm.types.entityType.tenant entity-id=vm.grid.operatingItem().id.id> </tb-alarm-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'tenant.events' | translate }}\"> <tb-event-table flex entity-type=vm.types.entityType.tenant entity-id=vm.grid.operatingItem().id.id tenant-id=vm.types.id.nullUid default-event-type={{vm.types.eventType.error.value}}> </tb-event-table> </md-tab> <md-tab ng-if=!vm.grid.detailsConfig.isDetailsEditMode md-on-select=vm.grid.triggerResize() label=\"{{ 'relation.relations' | translate }}\"> <tb-relation-table flex entity-id=vm.grid.operatingItem().id.id entity-type={{vm.types.entityType.tenant}}> </tb-relation-table> </md-tab> </md-tabs> </tb-grid> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	var path = 'user/add-user.tpl.html';
	var html = " <md-dialog style=width:600px aria-label=\"{{ 'user.add' | translate }}\" tb-help=\"'users'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add($event)> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>user.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-user user=vm.item is-edit=true the-form=theForm></tb-user> <md-input-container class=md-block> <label translate>user.activation-method</label> <md-select aria-label=\"{{ 'user.activation-method' | translate }}\" ng-model=vm.userActivationMethod> <md-option ng-repeat=\"activationMethod in vm.activationMethods\" ng-value=activationMethod.value> {{activationMethod.name | translate}} </md-option> </md-select> </md-input-container> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }}</md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	var path = 'user/user-card.tpl.html';
	var html = " <div class=tb-uppercase>{{item ? ( ( item.firstName ? item.firstName : '' ) + ' ' + ( item.lastName ? item.lastName : '') ) : ''}}</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	var path = 'user/user-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onDisplayActivationLink({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ 'user.display-activation-link' | translate }} </md-button> <md-button ng-click=\"onResendActivation({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ 'user.resend-activation' | translate }} </md-button> <md-button ng-click=\"onLoginAsUser({event: $event})\" ng-show=\"!isEdit && loginAsUserEnabled\" class=\"md-raised md-primary\">{{ (isTenantAdmin() ? 'user.login-as-tenant-admin' : 'user.login-as-customer-user') | translate }} </md-button> <md-button ng-click=\"onDeleteUser({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ 'user.delete' | translate }} </md-button> <md-content class=md-padding layout=column> <fieldset ng-disabled=\"$root.loading || !isEdit\"> <md-input-container class=md-block> <label translate>user.email</label> <input required name=email ng-pattern='/^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\_\\-0-9]+\\.)+[a-zA-Z]{2,}))$/' ng-model=user.email> <div ng-messages=theForm.email.$error> <div translate ng-message=required>user.email-required</div> <div translate ng-message=pattern>user.invalid-email-format</div> </div> </md-input-container> <md-input-container class=md-block> <label translate>user.first-name</label> <input name=firstname ng-model=user.firstName> </md-input-container> <md-input-container class=md-block> <label translate>user.last-name</label> <input name=lastname ng-model=user.lastName> </md-input-container> <md-input-container class=md-block> <label translate>user.description</label> <textarea ng-model=user.additionalInfo.description rows=2></textarea> </md-input-container> <section class=tb-default-dashboard flex layout=column ng-if=user.id> <span class=tb-default-dashboard-label ng-class=\"{'tb-disabled-label': $root.loading || !isEdit}\" translate>user.default-dashboard</span> <section flex layout=column layout-gt-sm=row> <tb-dashboard-autocomplete ng-if=isTenantAdmin() flex ng-disabled=\"$root.loading || !isEdit\" the-form=theForm ng-model=user.additionalInfo.defaultDashboardId tenant-id=user.tenantId.id select-first-dashboard=false> </tb-dashboard-autocomplete> <tb-dashboard-autocomplete ng-if=isCustomerUser() flex ng-disabled=\"$root.loading || !isEdit\" the-form=theForm ng-model=user.additionalInfo.defaultDashboardId dashboards-scope=customer customer-id=user.customerId.id select-first-dashboard=false> </tb-dashboard-autocomplete> <md-checkbox ng-disabled=\"$root.loading || !isEdit\" flex aria-label=\"{{ 'user.always-fullscreen' | translate }}\" ng-model=user.additionalInfo.defaultDashboardFullscreen>{{ 'user.always-fullscreen' | translate }} </md-checkbox> </section> </section> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	var path = 'user/users.tpl.html';
	var html = " <tb-grid grid-configuration=vm.userGridConfig> <details-buttons tb-help=\"'users'\" help-container-id=help-container> <div id=help-container></div> </details-buttons> <md-tabs ng-class=\"{'tb-headless': vm.grid.detailsConfig.isDetailsEditMode}\" id=tabs md-border-bottom flex class=tb-absolute-fill> <md-tab label=\"{{ 'user.details' | translate }}\"> <tb-user user=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode the-form=vm.grid.detailsForm on-display-activation-link=\"vm.displayActivationLink(event, vm.grid.detailsConfig.currentItem)\" on-resend-activation=vm.resendActivation(vm.grid.detailsConfig.currentItem) on-login-as-user=vm.loginAsUser(vm.grid.detailsConfig.currentItem) on-delete-user=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"></tb-user> </md-tab> <md-tab ng-if=\"!vm.grid.detailsConfig.isDetailsEditMode && vm.grid.isTenantAdmin()\" md-on-select=vm.grid.triggerResize() label=\"{{ 'audit-log.audit-logs' | translate }}\"> <tb-audit-log-table flex user-id=vm.grid.operatingItem().id.id audit-log-mode={{vm.types.auditLogMode.user}}> </tb-audit-log-table> </md-tab> </md-tabs> </tb-grid> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	var path = 'widget/add-widgets-bundle.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'widgets-bundle.add' | translate }}\" tb-help=\"'widgetsBundles'\" help-container-id=help-container> <form name=theForm ng-submit=vm.add()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>widgets-bundle.add</h2> <span flex></span> <div id=help-container></div> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <tb-widgets-bundle widgets-bundle=vm.item is-edit=true the-form=theForm></tb-widgets-bundle> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid || !theForm.$dirty\" type=submit class=\"md-raised md-primary\"> {{ 'action.add' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	var path = 'widget/lib/alarm-status-filter-panel.tpl.html';
	var html = " <md-content style=height:100% flex layout=column class=md-padding> <label class=tb-title translate>alarm.alarm-status-filter</label> <md-radio-group ng-model=vm.subscription.alarmSearchStatus class=md-primary> <md-radio-button ng-value=searchStatus aria-label=\"{{ ('alarm.search-status.' + searchStatus) | translate }}\" class=\"md-primary md-align-top-left md-radio-interactive\" ng-repeat=\"searchStatus in vm.types.alarmSearchStatus\"> {{ ('alarm.search-status.' + searchStatus) | translate }} </md-radio-button> </md-radio-group> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	var path = 'widget/lib/alarms-table-widget.tpl.html';
	var html = " <div class=\"tb-absolute-fill tb-alarms-table tb-data-table\" layout=column> <div ng-show=vm.showData flex class=tb-absolute-fill layout=column> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"!vm.selectedAlarms.length &&\n                                                                  vm.query.search != null\"> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{'alarm.search' | translate}} </md-tooltip> </md-button> <md-input-container flex> <label>&nbsp;</label> <input ng-model=vm.query.search class=searchInput placeholder=\"{{'alarm.search' | translate}}\"> </md-input-container> <md-button class=md-icon-button aria-label=Close ng-click=vm.exitFilterMode()> <md-icon aria-label=Close class=material-icons>close</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-toolbar class=\"md-table-toolbar alternate\" ng-show=vm.selectedAlarms.length> <div class=md-toolbar-tools> <span translate=alarm.selected-alarms translate-values=\"{count: vm.selectedAlarms.length}\" translate-interpolation=messageformat></span> <span flex></span> <md-button ng-if=vm.allowAcknowledgment class=md-icon-button ng-click=vm.ackAlarms($event)> <md-icon>done</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{ 'alarm.acknowledge' | translate }} </md-tooltip> </md-button> <md-button ng-if=vm.allowClear class=md-icon-button ng-click=vm.clearAlarms($event)> <md-icon>clear</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{ 'alarm.clear' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-table-container flex> <table md-table md-row-select=vm.enableSelection multiple=\"\" ng-model=vm.selectedAlarms> <thead md-head md-order=vm.query.order md-on-reorder=vm.onReorder> <tr md-row> <th ng-if=key.display md-column md-order-by=\"{{ key.name }}\" ng-repeat=\"key in vm.alarmSource.dataKeys\"><span>{{ key.title }}</span></th> <th md-column class=tb-action-cell layout=row layout-align=\"end center\"> <md-button class=md-icon-button aria-label=\"{{'alarm.alarm-status-filter' | translate}}\" ng-click=vm.editAlarmStatusFilter($event)> <md-icon aria-label=\"{{'alarm.alarm-status-filter' | translate}}\" class=material-icons>filter_list </md-icon> <md-tooltip md-direction=top> {{'alarm.alarm-status-filter' | translate}} </md-tooltip> </md-button> <md-button class=md-icon-button aria-label=\"{{'entity.columns-to-display' | translate}}\" ng-click=vm.editColumnsToDisplay($event)> <md-icon aria-label=\"{{'entity.columns-to-display' | translate}}\" class=material-icons>view_column </md-icon> <md-tooltip md-direction=top> {{'entity.columns-to-display' | translate}} </md-tooltip> </md-button> </th> </tr> </thead> <tbody md-body> <tr ng-show=vm.alarms.length md-row md-select=alarm md-select-id=id.id md-auto-select=false ng-repeat=\"alarm in vm.alarms\" ng-click=\"vm.onRowClick($event, alarm)\" ng-class=\"{'tb-current': vm.isCurrent(alarm)}\"> <td ng-if=key.display md-cell flex ng-repeat=\"key in vm.alarmSource.dataKeys\" ng-style=\"vm.cellStyle(alarm, key)\" ng-bind-html=\"vm.cellContent(alarm, key)\"> </td> <td md-cell class=tb-action-cell ng-style=\"{minWidth: vm.actionCellDescriptors.length*36+'px',\n                                   maxWidth: vm.actionCellDescriptors.length*36+'px',\n                                   width: vm.actionCellDescriptors.length*36+'px'}\"> <md-button class=md-icon-button ng-repeat=\"actionDescriptor in vm.actionCellDescriptors\" ng-disabled=\"!vm.actionEnabled(alarm, actionDescriptor)\" aria-label=\"{{ actionDescriptor.displayName }}\" ng-click=\"vm.onActionButtonClick($event, alarm, actionDescriptor)\" ng-disabled=$root.loading> <md-icon aria-label=\"{{ actionDescriptor.displayName }}\" class=material-icons>{{actionDescriptor.icon}}</md-icon> <md-tooltip md-direction=top> {{ actionDescriptor.displayName }} </md-tooltip> </md-button> </td> </tr> </tbody> </table> <md-divider></md-divider> <span ng-show=!vm.alarms.length layout-align=\"center center\" class=no-data-found translate>alarm.no-alarms-prompt</span> </md-table-container> <md-table-pagination ng-if=vm.displayPagination md-boundary-links md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.alarmsCount}} md-on-paginate=vm.onPaginate md-page-select=vm.isGtMd> </md-table-pagination> </div> <span ng-show=!vm.showData layout-align=\"center center\" style=text-transform:uppercase;display:flex class=tb-absolute-fill translate>alarm.no-data</span> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	var path = 'widget/lib/entities-table-widget.tpl.html';
	var html = " <div class=\"tb-absolute-fill tb-entities-table tb-data-table\" layout=column> <div ng-show=vm.showData flex class=tb-absolute-fill layout=column> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"vm.query.search != null\"> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{'entity.search' | translate}} </md-tooltip> </md-button> <md-input-container flex> <label>&nbsp;</label> <input ng-model=vm.query.search class=searchInput placeholder=\"{{'entity.search' | translate}}\"> </md-input-container> <md-button class=md-icon-button aria-label=Close ng-click=vm.exitFilterMode()> <md-icon aria-label=Close class=material-icons>close</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-table-container flex> <table md-table> <thead md-head md-order=vm.query.order md-on-reorder=vm.onReorder> <tr md-row> <th ng-if=column.display md-column md-order-by=\"{{ column.name }}\" ng-repeat=\"column in vm.columns\"><span>{{ column.title }}</span></th> <th md-column class=tb-action-cell layout=row layout-align=\"end center\"> <md-button class=md-icon-button aria-label=\"{{'entity.columns-to-display' | translate}}\" ng-click=vm.editColumnsToDisplay($event)> <md-icon aria-label=\"{{'entity.columns-to-display' | translate}}\" class=material-icons>view_column </md-icon> <md-tooltip md-direction=top> {{'entity.columns-to-display' | translate}} </md-tooltip> </md-button> </th> </tr> </thead> <tbody md-body> <tr ng-show=vm.entities.length md-row md-select=entity md-select-id=id.id md-auto-select=false ng-repeat=\"entity in vm.entities\" ng-click=\"vm.onRowClick($event, entity)\" ng-class=\"{'tb-current': vm.isCurrent(entity)}\"> <td ng-if=column.display md-cell flex ng-repeat=\"column in vm.columns\" ng-style=\"vm.cellStyle(entity, column)\" ng-bind-html=\"vm.cellContent(entity, column)\"> </td> <td md-cell class=tb-action-cell ng-style=\"{minWidth: vm.actionCellDescriptors.length*36+'px',\n                                   maxWidth: vm.actionCellDescriptors.length*36+'px',\n                                   width: vm.actionCellDescriptors.length*36+'px'}\"> <md-button class=md-icon-button ng-repeat=\"actionDescriptor in vm.actionCellDescriptors\" aria-label=\"{{ actionDescriptor.displayName }}\" ng-click=\"vm.onActionButtonClick($event, entity, actionDescriptor)\" ng-disabled=$root.loading> <md-icon aria-label=\"{{ actionDescriptor.displayName }}\" class=material-icons>{{actionDescriptor.icon}}</md-icon> <md-tooltip md-direction=top> {{ actionDescriptor.displayName }} </md-tooltip> </md-button> </td> </tr> </tbody> </table> <md-divider></md-divider> <span ng-show=!vm.entities.length layout-align=\"center center\" class=no-data-found translate>entity.no-entities-prompt</span> </md-table-container> <md-table-pagination ng-if=vm.displayPagination md-boundary-links md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.entitiesCount}} md-on-paginate=vm.onPaginate md-page-select=vm.isGtMd> </md-table-pagination> </div> <span ng-show=!vm.showData layout-align=\"center center\" style=text-transform:uppercase;display:flex class=tb-absolute-fill translate>entity.no-data</span> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	var path = 'widget/lib/extensions-table-widget.tpl.html';
	var html = " <md-tabs id=tabs md-border-bottom flex class=tb-absolute-fill ng-class=\"{'hide-tabs-menu': vm.datasources.length == 1 || vm.tabsHidden}\"> <md-tab ng-repeat=\"source in vm.datasources\" label=\"{{ source.name }}\" md-on-select=vm.changeSelectedSource(source)> <tb-extension-table flex entity-id=source.entityId entity-type={{source.entityType}} in-widget=true ctx=vm.ctx> </tb-extension-table> </md-tab> </md-tabs>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	var path = 'widget/lib/rpc/knob.tpl.html';
	var html = " <div class=tb-knob layout=column ng-style=\"{'pointerEvents': vm.ctx.isEdit ? 'none' : 'all'}\"> <div id=knob-container flex layout=column layout-align=\"center center\"> <div class=knob> <div class=value-container layout=row layout-align=\"center center\"> <span class=knob-value>{{ vm.value }}</span> </div> <div class=canvas-background></div> <canvas id=canvasBar></canvas> <div class=top-pointer-container> <div class=top-pointer></div> </div> <div class=top></div> <div class=error-container ng-style=\"{'background': vm.error.length ? 'rgba(255,255,255,0.25)' : 'none'}\" layout=row layout-align=\"center center\"> <span class=knob-error>{{ vm.error }}</span> </div> <div class=title-container layout=row layout-align=\"center center\"> <span class=knob-title>{{ vm.title }}</span> </div> <div class=minmax-container layout=row layout-align=\"start center\"> <span class=minmax-label>min</span> <span flex></span> <span class=minmax-label>max</span> </div> <div id=text-measure></div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	var path = 'widget/lib/rpc/led-indicator.tpl.html';
	var html = " <div class=tb-led-indicator layout=column> <div flex=20 class=title-container layout=row layout-align=\"center center\" ng-show=vm.showTitle> <span class=led-title>{{vm.title}}</span> </div> <div flex=\"{{vm.showTitle ? 80 : 100}}\" ng-style=\"{paddingTop: vm.showTitle ? '5px': '10px'}\" id=led-container layout=column layout-align=\"center center\"> <div class=led> </div> </div> <div class=error-container ng-style=\"{'background': vm.error.length ? 'rgba(255,255,255,0.25)' : 'none'}\" layout=row layout-align=\"center center\"> <span class=led-error>{{ vm.error }}</span> </div> <div id=text-measure></div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	var path = 'widget/lib/rpc/round-switch.tpl.html';
	var html = " <div class=tb-round-switch layout=column ng-style=\"{'pointerEvents': vm.ctx.isEdit ? 'none' : 'all'}\"> <div flex=20 class=title-container layout=row layout-align=\"center center\" ng-show=vm.showTitle> <span class=switch-title>{{vm.title}}</span> </div> <div flex=\"{{vm.showTitle ? 80 : 100}}\" ng-style=\"{paddingTop: vm.showTitle ? '5px': '10px'}\" id=switch-container layout=column layout-align=\"center center\"> <div class=switch> <input type=checkbox id={{vm.checkboxId}} name=onoff> <div class=back> <label class=but for={{vm.checkboxId}}> <span class=on>I</span> <span class=off>0</span> </label> </div> </div> </div> <div class=error-container ng-style=\"{'background': vm.error.length ? 'rgba(255,255,255,0.25)' : 'none'}\" layout=row layout-align=\"center center\"> <span class=switch-error>{{ vm.error }}</span> </div> <div id=text-measure></div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	var path = 'widget/lib/rpc/switch.tpl.html';
	var html = " <div class=tb-switch layout=column ng-style=\"{'pointerEvents': vm.ctx.isEdit ? 'none' : 'all'}\"> <div class=error-container ng-style=\"{'background': vm.error.length ? 'rgba(255,255,255,0.25)' : 'none'}\" layout=row layout-align=\"center center\"> <span class=switch-error>{{ vm.error }}</span> </div> <div flex=30 class=title-container layout=row layout-align=\"center center\" ng-show=vm.showTitle> <span class=switch-title>{{vm.title}}</span> </div> <div flex=\"{{vm.showTitle ? 70 : 100}}\" id=switch-container layout=column layout-align=\"center center\"> <div class=switch> <md-switch md-no-ink aria-label=\"Switch control\" ng-model=vm.value ng-change=vm.onValue()> </md-switch> </div> <div class=onoff-container layout=row layout-align=\"center start\" ng-show=vm.showOnOffLabels> <span flex class=off-label ng-show=!vm.value style=text-align:center>OFF</span> <span flex ng-show=vm.value></span> <span flex class=on-label ng-show=vm.value style=text-align:center>ON</span> <span flex ng-show=!vm.value></span> </div> </div> <div id=text-measure></div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	var path = 'widget/lib/timeseries-table-widget.tpl.html';
	var html = " <div class=\"tb-absolute-fill tb-entities-table tb-data-table timeseriesWidget\" layout=column> <div flex class=tb-absolute-fill layout=column> <md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"vm.query.search !== null\"> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=\"{{ 'action.search' | translate }}\"> <md-icon aria-label=\"{{ 'action.search' | translate }}\" class=material-icons>search</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{'entity.search' | translate}} </md-tooltip> </md-button> <md-input-container flex> <label>&nbsp;</label> <input ng-model=vm.query.search class=searchInput placeholder=\"{{'widget.search-data' | translate}}\" md-autofocus> </md-input-container> <md-button class=md-icon-button aria-label=Close ng-click=vm.exitFilterMode()> <md-icon aria-label=Close class=material-icons>close</md-icon> <md-tooltip md-direction=\"{{vm.ctx.dashboard.isWidgetExpanded ? 'bottom' : 'top'}}\"> {{ 'action.close' | translate }} </md-tooltip> </md-button> </div> </md-toolbar> <md-tabs flex md-selected=vm.sourceIndex ng-class=\"{'tb-headless': vm.sources.length === 1}\" id=tabs md-border-bottom flex> <md-tab ng-repeat=\"source in vm.sources\" label=\"{{ source.datasource.name }}\"> <md-table-container class=flex> <table md-table> <thead md-head md-order=source.query.order md-on-reorder=vm.onReorder(source)> <tr md-row> <th ng-show=vm.showTimestamp md-column md-order-by=0> <span>Timestamp</span> </th> <th md-column md-order-by=\"{{ h.index }}\" ng-repeat=\"h in source.ts.header\"> <span>{{ h.dataKey.label }}</span> </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"row in source.ts.data track by $index\"> <td ng-show=\"$index > 0 || ($index === 0 && vm.showTimestamp)\" md-cell ng-repeat=\"d in row track by $index\" ng-style=\"vm.cellStyle(source, $index, d)\" ng-bind-html=\"vm.cellContent(source, $index, row, d)\"></td> </tr> </tbody> </table> <md-divider></md-divider> <span ng-show=!vm.sources[vm.sourceIndex].data.length layout-align=\"center center\" class=no-data-found translate>widget.no-data-found</span> </md-table-container> </md-tab> </md-tabs> <md-table-pagination ng-if=vm.displayPagination md-limit=vm.sources[vm.sourceIndex].query.limit md-limit-options=vm.limitOptions md-page=vm.sources[vm.sourceIndex].query.page md-total={{vm.sources[vm.sourceIndex].data.length}} md-on-paginate=vm.onPaginate(vm.sources[vm.sourceIndex]) md-page-select> </md-table-pagination> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	var path = 'widget/save-widget-type-as.tpl.html';
	var html = " <md-dialog aria-label=\"{{ 'widget.save-widget-type-as' | translate }}\"> <form name=theForm ng-submit=vm.saveAs()> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>widget.save-widget-type-as</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset> <span translate>widget.save-widget-type-as-text</span> <md-input-container class=md-block> <label translate>widget.title</label> <input required name=title ng-model=vm.widgetName> <div ng-messages=theForm.title.$error> <div translate ng-message=required>widget.title-required</div> </div> </md-input-container> <tb-widgets-bundle-select flex ng-model=vm.widgetsBundle tb-required=true bundles-scope={{vm.bundlesScope}}> </tb-widgets-bundle-select> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=\"$root.loading || theForm.$invalid\" type=submit class=\"md-raised md-primary\"> {{ 'action.saveAs' | translate }} </md-button> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	var path = 'widget/select-widget-type.tpl.html';
	var html = " <md-dialog style=width:800px aria-label=\"{{ 'widget.select-widget-type' | translate }}\"> <form name=theForm> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>widget.select-widget-type</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.cancel()> <ng-md-icon icon=close aria-label=\"{{ 'dialog.close' | translate }}\"></ng-md-icon> </md-button> </div> </md-toolbar> <md-progress-linear class=md-warn md-mode=indeterminate ng-disabled=!$root.loading ng-show=$root.loading></md-progress-linear> <span style=min-height:5px flex=\"\" ng-show=!$root.loading></span> <md-dialog-content> <div class=md-dialog-content> <fieldset ng-disabled=$root.loading> <div layout=column layout-gt-sm=row layout-align=\"center center\"> <md-button class=\"tb-card-button md-raised md-primary\" layout=column ng-click=vm.typeSelected(vm.types.widgetType.timeseries.value)> <md-icon class=\"material-icons tb-md-96\" aria-label=\"{{ vm.types.widgetType.timeseries.name | translate }}\"> timeline </md-icon> <span translate>{{vm.types.widgetType.timeseries.name}}</span> </md-button> <md-button class=\"tb-card-button md-raised md-primary\" layout=column ng-click=vm.typeSelected(vm.types.widgetType.latest.value)> <md-icon class=\"material-icons tb-md-96\" aria-label=\"{{ vm.types.widgetType.latest.name | translate }}\">track_changes </md-icon> <span translate>{{vm.types.widgetType.latest.name}}</span> </md-button> <md-button class=\"tb-card-button md-raised md-primary\" layout=column ng-click=vm.typeSelected(vm.types.widgetType.rpc.value)> <md-icon class=\"material-icons tb-md-96\" aria-label=\"{{ vm.types.widgetType.rpc.name | translate }}\" md-svg-icon=mdi:developer-board> </md-icon> <span translate>{{vm.types.widgetType.rpc.name}}</span> </md-button> <md-button class=\"tb-card-button md-raised md-primary\" layout=column ng-click=vm.typeSelected(vm.types.widgetType.alarm.value)> <md-icon class=\"material-icons tb-md-96\" aria-label=\"{{ vm.types.widgetType.alarm.name | translate }}\">error </md-icon> <span translate>{{vm.types.widgetType.alarm.name}}</span> </md-button> <md-button class=\"tb-card-button md-raised md-primary\" layout=column ng-click=vm.typeSelected(vm.types.widgetType.static.value)> <md-icon class=\"material-icons tb-md-96\" aria-label=\"{{ vm.types.widgetType.static.name | translate }}\">font_download </md-icon> <span translate>{{vm.types.widgetType.static.name}}</span> </md-button> </div> </fieldset> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-disabled=$root.loading ng-click=vm.cancel() style=margin-right:20px>{{ 'action.cancel' | translate }} </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	var path = 'widget/widget-editor.tpl.html';
	var html = " <div flex layout=column tb-confirm-on-exit is-dirty=vm.isDirty> <div flex layout=column tb-expand-fullscreen=vm.fullscreen hide-expand-button=true> <md-toolbar class=\"md-whiteframe-z1 tb-edit-toolbar md-hue-3\"> <div flex class=md-toolbar-tools> <md-input-container> <label>&nbsp;</label> <input ng-disabled=vm.isReadOnly() ng-model=vm.widget.widgetName placeholder=\"{{ 'widget.title' | translate }}\"> </md-input-container> <md-input-container> <md-select ng-disabled=vm.isReadOnly() placeholder=\"{{ 'widget.type' | translate }}\" required id=widgetType ng-model=vm.widget.type> <md-option ng-repeat=\"type in vm.widgetTypes\" value={{type.value}}> {{ type.name | translate }} </md-option> </md-select> </md-input-container> <span flex=\"\"></span> <md-button hide-xs hide-sm aria-label=\"{{ 'widget.run' | translate }}\" ng-disabled=!vm.iframeWidgetEditModeInited ng-click=vm.applyWidgetScript()> <md-tooltip md-direction=bottom> {{ 'widget.run' | translate }} (CTRL + Return) </md-tooltip> <md-icon aria-label=\"{{ 'action.run' | translate }}\">play_arrow</md-icon> <span translate>action.run</span> </md-button> <md-button hide-xs hide-sm ng-disabled=vm.undoDisabled() class=md-raised aria-label=\"{{ 'widget.undo' | translate }}\" ng-click=vm.undoWidget()> <md-tooltip md-direction=bottom> {{ 'widget.undo' | translate }} (CTRL + Q) </md-tooltip> <md-icon aria-label=\"{{ 'action.undo' | translate }}\">undo</md-icon> <span translate>action.undo</span> </md-button> <md-button ng-if=!vm.isReadOnly() hide-xs hide-sm ng-disabled=vm.saveDisabled() class=md-raised aria-label=\"{{ 'widget.save' | translate }}\" ng-click=vm.saveWidget() tb-circular-progress=vm.saveWidgetPending> <md-tooltip md-direction=bottom> {{ 'widget.save' | translate }} (CTRL + S) </md-tooltip> <md-icon aria-label=\"{{ 'action.save' | translate }}\">save</md-icon> <span translate>action.save</span> </md-button> <md-button hide-xs hide-sm ng-disabled=vm.saveAsDisabled() class=md-raised aria-label=\"{{ 'widget.saveAs' | translate }}\" ng-click=vm.saveWidgetAs($event) tb-circular-progress=vm.saveWidgetAsPending> <md-tooltip md-direction=bottom> {{ 'widget.saveAs' | translate }} (Shift + CTRL + S) </md-tooltip> <md-icon aria-label=\"{{ 'action.saveAs' | translate }}\">save</md-icon> <span translate>action.saveAs</span> </md-button> <md-button hide-xs hide-sm aria-label=\"{{ 'widget.toggle-fullscreen' | translate }}\" ng-click=vm.toggleFullscreen()> <md-tooltip md-direction=bottom> {{ 'widget.toggle-fullscreen' | translate }} (Shift + CTRL + F) </md-tooltip> <md-icon ng-show=!vm.fullscreen aria-label=\"{{ 'widget.toggle-fullscreen' | translate }}\"> fullscreen </md-icon> <md-icon ng-show=vm.fullscreen aria-label=\"{{ 'widget.toggle-fullscreen' | translate }}\"> fullscreen_exit </md-icon> <span translate hide-xs hide-sm>widget.toggle-fullscreen</span> </md-button> <md-menu hide-gt-sm md-position-mode=\"target-right target\"> <md-button class=md-icon-button aria-label=\"{{ 'home.open-user-menu' | translate }}\" ng-click=$mdOpenMenu($event)> <md-icon md-menu-origin aria-label=\"{{ 'home.open-user-menu' | translate }}\" class=material-icons>more_vert</md-icon> </md-button> <md-menu-content width=4> <md-menu-item> <md-button ng-disabled=!vm.iframeWidgetEditModeInited ng-click=vm.applyWidgetScript()> <md-icon md-menu-align-target aria-label=\"{{ 'action.run' | translate }}\" class=material-icons>play_arrow</md-icon> <span translate>action.run</span> </md-button> </md-menu-item> <md-menu-item> <md-button ng-disabled=vm.undoDisabled() ng-click=vm.undoWidget()> <md-icon md-menu-align-target aria-label=\"{{ 'action.undo' | translate }}\" class=material-icons>undo</md-icon> <span translate>action.undo</span> </md-button> </md-menu-item> <md-menu-item ng-if=!vm.isReadOnly()> <md-button ng-disabled=vm.saveDisabled() ng-click=vm.saveWidget()> <md-icon md-menu-align-target aria-label=\"{{ 'action.save' | translate }}\" class=material-icons>save</md-icon> <span translate>action.save</span> </md-button> </md-menu-item> <md-menu-item> <md-button ng-disabled=vm.saveAsDisabled() ng-click=vm.saveWidgetAs($event)> <md-icon md-menu-align-target aria-label=\"{{ 'action.saveAs' | translate }}\" class=material-icons>save</md-icon> <span translate>action.saveAs</span> </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> </md-toolbar> <div flex style=position:relative> <div class=\"tb-editor tb-absolute-fill\" style=\"\"> <div id=top_panel class=\"tb-split tb-split-vertical\"> <div id=top_left_panel class=\"tb-split tb-content\"> <md-tabs md-selected=1 md-dynamic-height md-border-bottom style=width:100%;height:100%> <md-tab label=\"{{ 'widget.resources' | translate }}\" style=width:100%;height:100%> <div class=tb-resize-container style=background-color:#fff> <div class=md-padding> <div flex layout=row ng-repeat=\"resource in vm.widget.resources track by $index\" style=max-height:40px layout-align=\"start center\"> <md-input-container flex md-no-float class=md-block style=\"margin:10px 0 0 0;max-height:40px\"> <input placeholder=\"{{ 'widget.resource-url' | translate }}\" ng-required=true name=resource ng-model=resource.url> </md-input-container> <md-button ng-disabled=$root.loading class=\"md-icon-button md-primary\" ng-click=vm.removeResource($index) aria-label=\"{{ 'action.remove' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget.remove-resource' | translate }} </md-tooltip> <md-icon aria-label=\"{{ 'action.delete' | translate }}\" class=material-icons> close </md-icon> </md-button> </div> <div> <md-button ng-disabled=$root.loading class=\"md-primary md-raised\" ng-click=vm.addResource() aria-label=\"{{ 'action.add' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget.add-resource' | translate }} </md-tooltip> <span translate>action.add</span> </md-button> </div> </div> </div> </md-tab> <md-tab label=\"{{ 'widget.html' | translate }}\" style=width:100%;height:100%> <div class=tb-resize-container tb-expand-fullscreen expand-button-id=expand-button> <div class=tb-editor-area-title-panel> <md-button aria-label=\"{{ 'widget.tidy' | translate }}\" ng-click=vm.beautifyHtml()>{{ 'widget.tidy' | translate }} </md-button> <md-button id=expand-button aria-label=\"{{ 'fullscreen.fullscreen' | translate }}\" class=\"md-icon-button tb-md-32\"></md-button> </div> <div id=html_input ui-ace=vm.htmlEditorOptions ng-model=vm.widget.templateHtml></div> </div> </md-tab> <md-tab label=\"{{ 'widget.css' | translate }}\" style=width:100%;height:100%> <div class=tb-resize-container tb-expand-fullscreen expand-button-id=expand-button> <div class=tb-editor-area-title-panel> <md-button aria-label=\"{{ 'widget.tidy' | translate }}\" ng-click=vm.beautifyCss()>{{ 'widget.tidy' | translate }} </md-button> <md-button id=expand-button aria-label=\"{{ 'fullscreen.fullscreen' | translate }}\" class=\"md-icon-button tb-md-32\"></md-button> </div> <div id=css_input ui-ace=vm.cssEditorOptions ng-model=vm.widget.templateCss></div> </div> </md-tab> </md-tabs> </div> <div id=top_right_panel class=\"tb-split tb-content\"> <md-tabs md-dynamic-height md-border-bottom style=width:100%;height:100%> <md-tab label=\"{{ 'widget.settings-schema' | translate }}\" style=width:100%;height:100%> <div class=tb-resize-container tb-expand-fullscreen expand-button-id=expand-button> <div class=tb-editor-area-title-panel> <md-button aria-label=\"{{ 'widget.tidy' | translate }}\" ng-click=vm.beautifyJson()>{{ 'widget.tidy' | translate }} </md-button> <md-button id=expand-button aria-label=\"{{ 'fullscreen.fullscreen' | translate }}\" class=\"md-icon-button tb-md-32\"></md-button> </div> <div id=settings_json_input ui-ace=vm.jsonSettingsEditorOptions ng-model=vm.widget.settingsSchema></div> </div> </md-tab> <md-tab label=\"{{ 'widget.datakey-settings-schema' | translate }}\" style=width:100%;height:100%> <div class=tb-resize-container tb-expand-fullscreen expand-button-id=expand-button> <div class=tb-editor-area-title-panel> <md-button aria-label=\"{{ 'widget.tidy' | translate }}\" ng-click=vm.beautifyDataKeyJson()>{{ 'widget.tidy' | translate }} </md-button> <md-button id=expand-button aria-label=\"{{ 'fullscreen.fullscreen' | translate }}\" class=\"md-icon-button tb-md-32\"></md-button> </div> <div id=settings_json_input ui-ace=vm.dataKeyJsonSettingsEditorOptions ng-model=vm.widget.dataKeySettingsSchema></div> </div> </md-tab> </md-tabs> </div> </div> <div id=bottom_panel class=\"tb-split tb-split-vertical\"> <div id=javascript_panel class=\"tb-split tb-content\"> <div class=tb-resize-container tb-expand-fullscreen expand-button-id=expand-button> <div class=tb-editor-area-title-panel> <label translate for=javascript_input>widget.javascript</label> <md-button aria-label=\"{{ 'widget.tidy' | translate }}\" ng-click=vm.beautifyJs()>{{ 'widget.tidy' | translate }} </md-button> <md-button id=expand-button aria-label=\"{{ 'fullscreen.fullscreen' | translate }}\" class=\"md-icon-button tb-md-32\"></md-button> </div> <div id=javascript_input ui-ace=vm.jsEditorOptions ng-model=vm.widget.controllerScript></div> </div> </div> <div id=frame_panel class=\"tb-split tb-content\" style=overflow-y:hidden;position:relative> <md-content flex layout=column class=tb-progress-cover layout-align=\"center center\" ng-show=!vm.iframeWidgetEditModeInited> <md-progress-circular ng-disabled=vm.iframeWidgetEditModeInited md-mode=indeterminate class=md-warn md-diameter=100></md-progress-circular> </md-content> <div tb-expand-fullscreen expand-button-id=expand-button style=width:100%;height:100%> <iframe frameborder=0 height=100% width=100%></iframe> <md-button id=expand-button aria-label=Fullscreen class=\"md-icon-button tb-fullscreen-button-style\" style=position:absolute;top:10px;left:10px;bottom:initial></md-button> </div> </div> </div> </div> </div> </div> <md-content flex layout=column class=tb-progress-cover layout-align=\"center center\" ng-show=!vm.layoutInited> <md-progress-circular md-mode=indeterminate ng-disabled=vm.layoutInited class=md-warn md-diameter=100></md-progress-circular> </md-content> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	var path = 'widget/widget-library.tpl.html';
	var html = " <section ng-show=\"!$root.loading && vm.noData()\" layout-align=\"center center\" style=text-transform:uppercase;display:flex;z-index:1 class=\"md-headline tb-absolute-fill\"> <md-button ng-if=!vm.isReadOnly() class=tb-add-new-widget ng-click=vm.addWidgetType($event)> <md-icon aria-label=\"{{ 'action.add' | translate }}\" class=\"material-icons tb-md-96\">add</md-icon> {{ 'widget.add-widget-type' | translate }} </md-button> <span translate ng-if=vm.isReadOnly() layout-align=\"center center\" style=text-transform:uppercase;display:flex class=\"md-headline tb-absolute-fill\">widgets-bundle.empty</span> </section> <tb-dashboard alias-controller=vm.aliasController widgets=vm.widgetTypes is-edit=false is-edit-action-enabled=true is-export-action-enabled=true is-remove-action-enabled=!vm.isReadOnly() on-edit-widget=\"vm.openWidgetType(event, widget)\" on-export-widget=\"vm.exportWidgetType(event, widget)\" on-remove-widget=\"vm.removeWidgetType(event, widget)\" load-widgets=vm.loadWidgetLibrary() on-init=vm.dashboardInited(dashboard) on-init-failed=vm.dashboardInitFailed(e)> </tb-dashboard> <section layout=row layout-wrap class=\"tb-footer-buttons md-fab\"> <md-fab-speed-dial ng-disabled=$root.loading ng-show=!vm.isReadOnly() md-open=vm.addItemActionsOpen class=md-scale md-direction=up> <md-fab-trigger> <md-button ng-disabled=$root.loading class=\"tb-btn-footer md-accent md-hue-2 md-fab\" aria-label=\"{{ 'widget.add-widget-type' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget.add-widget-type' | translate }} </md-tooltip> <ng-md-icon icon=add></ng-md-icon> </md-button> </md-fab-trigger> <md-fab-actions> <md-button ng-disabled=$root.loading class=\"tmd-accent md-hue-2 md-fab\" ng-click=vm.addWidgetType($event) aria-label=\"{{ 'action.create' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget-type.create-new-widget-type' | translate }} </md-tooltip> <ng-md-icon icon=insert_drive_file></ng-md-icon> </md-button> <md-button ng-disabled=$root.loading class=\"tmd-accent md-hue-2 md-fab\" ng-click=vm.importWidgetType($event) aria-label=\"{{ 'action.import' | translate }}\"> <md-tooltip md-direction=top> {{ 'widget-type.import' | translate }} </md-tooltip> <ng-md-icon icon=file_upload></ng-md-icon> </md-button> </md-fab-actions> </md-fab-speed-dial> </section> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	var path = 'widget/widgets-bundle-card.tpl.html';
	var html = " <div class=tb-uppercase ng-if=\"item && parentCtl.types.id.nullUid === item.tenantId.id\" translate>widgets-bundle.system</div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	var path = 'widget/widgets-bundle-fieldset.tpl.html';
	var html = " <md-button ng-click=\"onExportWidgetsBundle({event: $event})\" ng-show=!isEdit class=\"md-raised md-primary\">{{ 'widgets-bundle.export' | translate }}</md-button> <md-button ng-click=\"onDeleteWidgetsBundle({event: $event})\" ng-show=\"!isEdit && !isReadOnly\" class=\"md-raised md-primary\">{{ 'widgets-bundle.delete' | translate }}</md-button> <md-content class=md-padding layout=column> <fieldset ng-disabled=\"$root.loading || !isEdit\"> <md-input-container class=md-block> <label translate>widgets-bundle.title</label> <input required name=title ng-model=widgetsBundle.title> <div ng-messages=theForm.title.$error> <div translate ng-message=required>widgets-bundle.title-required</div> </div> </md-input-container> </fieldset> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	var path = 'widget/widgets-bundles.tpl.html';
	var html = " <tb-grid grid-configuration=vm.widgetsBundleGridConfig> <tb-widgets-bundle widgets-bundle=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode is-read-only=vm.grid.isDetailsReadOnly(vm.grid.operatingItem()) the-form=vm.grid.detailsForm on-export-widgets-bundle=\"vm.exportWidgetsBundle(event, vm.grid.detailsConfig.currentItem)\" on-delete-widgets-bundle=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"> </tb-widgets-bundle> </tb-grid> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	;!function(undefined) {
	
		var ObjectPath = {
			parse: function(str){
				if(typeof str !== 'string'){
					throw new TypeError('ObjectPath.parse must be passed a string');
				}
	
				var i = 0;
				var parts = [];
				var d, b, q, c;
				while (i < str.length){
					d = str.indexOf('.', i);
					b = str.indexOf('[', i);
	
					// we've reached the end
					if (d === -1 && b === -1){
						parts.push(str.slice(i, str.length));
						i = str.length;
					}
	
					// dots
					else if (b === -1 || (d !== -1 && d < b)) {
						parts.push(str.slice(i, d));
						i = d + 1;
					}
	
					// brackets
					else {
						if (b > i){
							parts.push(str.slice(i, b));
							i = b;
						}
						q = str.slice(b+1, b+2);
						if (q !== '"' && q !=='\'') {
							c = str.indexOf(']', b);
							if (c === -1) c = str.length;
							parts.push(str.slice(i + 1, c));
							i = (str.slice(c + 1, c + 2) === '.') ? c + 2 : c + 1;
						} else {
							c = str.indexOf(q+']', b);
							if (c === -1) c = str.length;
							while (str.slice(c - 1, c) === '\\' && b < str.length){
								b++;
								c = str.indexOf(q+']', b);
							}
							parts.push(str.slice(i + 2, c).replace(new RegExp('\\'+q,'g'), q));
							i = (str.slice(c + 2, c + 3) === '.') ? c + 3 : c + 2;
						}
					}
				}
				return parts;
			},
	
			// root === true : auto calculate root; must be dot-notation friendly
			// root String : the string to use as root
			stringify: function(arr, quote){
	
				if(!Array.isArray(arr))
					arr = [arr.toString()];
	
				quote = quote === '"' ? '"' : '\'';
	
				return arr.map(function(n){ return '[' + quote + (n.toString()).replace(new RegExp(quote, 'g'), '\\' + quote) + quote + ']'; }).join('');
			},
	
			normalize: function(data, quote){
				return ObjectPath.stringify(Array.isArray(data) ? data : ObjectPath.parse(data), quote);
			},
	
			// Angular
			registerModule: function(angular) {
				angular.module('ObjectPath', []).provider('ObjectPath', function(){
					this.parse = ObjectPath.parse;
					this.stringify = ObjectPath.stringify;
					this.normalize = ObjectPath.normalize;
					this.$get = function(){
						return ObjectPath;
					};
				});
			}
		};
	
		// AMD
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return {ObjectPath: ObjectPath};
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
		// CommonJS
		else if (typeof exports === 'object') {
			exports.ObjectPath = ObjectPath;
		}
	
		// Browser global
		else {
			window.ObjectPath = ObjectPath;
		}
		
	}();

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
	 * oclazyload - Load modules on demand (lazy load) with angularJS
	 * @version v1.0.10
	 * @link https://github.com/ocombe/ocLazyLoad
	 * @license MIT
	 * @author Olivier Combe <olivier.combe@gmail.com>
	 */
	(function (angular, window) {
	    'use strict';
	
	    var regModules = ['ng', 'oc.lazyLoad'],
	        regInvokes = {},
	        regConfigs = [],
	        modulesToLoad = [],
	        // modules to load from angular.module or other sources
	    realModules = [],
	        // real modules called from angular.module
	    recordDeclarations = [],
	        broadcast = angular.noop,
	        runBlocks = {},
	        justLoaded = [];
	
	    var ocLazyLoad = angular.module('oc.lazyLoad', ['ng']);
	
	    ocLazyLoad.provider('$ocLazyLoad', ["$controllerProvider", "$provide", "$compileProvider", "$filterProvider", "$injector", "$animateProvider", function ($controllerProvider, $provide, $compileProvider, $filterProvider, $injector, $animateProvider) {
	        var modules = {},
	            providers = {
	            $controllerProvider: $controllerProvider,
	            $compileProvider: $compileProvider,
	            $filterProvider: $filterProvider,
	            $provide: $provide, // other things (constant, decorator, provider, factory, service)
	            $injector: $injector,
	            $animateProvider: $animateProvider
	        },
	            debug = false,
	            events = false,
	            moduleCache = [],
	            modulePromises = {};
	
	        moduleCache.push = function (value) {
	            if (this.indexOf(value) === -1) {
	                Array.prototype.push.apply(this, arguments);
	            }
	        };
	
	        this.config = function (config) {
	            // If we want to define modules configs
	            if (angular.isDefined(config.modules)) {
	                if (angular.isArray(config.modules)) {
	                    angular.forEach(config.modules, function (moduleConfig) {
	                        modules[moduleConfig.name] = moduleConfig;
	                    });
	                } else {
	                    modules[config.modules.name] = config.modules;
	                }
	            }
	
	            if (angular.isDefined(config.debug)) {
	                debug = config.debug;
	            }
	
	            if (angular.isDefined(config.events)) {
	                events = config.events;
	            }
	        };
	
	        /**
	         * Get the list of existing registered modules
	         * @param element
	         */
	        this._init = function _init(element) {
	            // this is probably useless now because we override angular.bootstrap
	            if (modulesToLoad.length === 0) {
	                var elements = [element],
	                    names = ['ng:app', 'ng-app', 'x-ng-app', 'data-ng-app'],
	                    NG_APP_CLASS_REGEXP = /\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,
	                    append = function append(elm) {
	                    return elm && elements.push(elm);
	                };
	
	                angular.forEach(names, function (name) {
	                    names[name] = true;
	                    append(document.getElementById(name));
	                    name = name.replace(':', '\\:');
	                    if (typeof element[0] !== 'undefined' && element[0].querySelectorAll) {
	                        angular.forEach(element[0].querySelectorAll('.' + name), append);
	                        angular.forEach(element[0].querySelectorAll('.' + name + '\\:'), append);
	                        angular.forEach(element[0].querySelectorAll('[' + name + ']'), append);
	                    }
	                });
	
	                angular.forEach(elements, function (elm) {
	                    if (modulesToLoad.length === 0) {
	                        var className = ' ' + element.className + ' ';
	                        var match = NG_APP_CLASS_REGEXP.exec(className);
	                        if (match) {
	                            modulesToLoad.push((match[2] || '').replace(/\s+/g, ','));
	                        } else {
	                            angular.forEach(elm.attributes, function (attr) {
	                                if (modulesToLoad.length === 0 && names[attr.name]) {
	                                    modulesToLoad.push(attr.value);
	                                }
	                            });
	                        }
	                    }
	                });
	            }
	
	            if (modulesToLoad.length === 0 && !((window.jasmine || window.mocha) && angular.isDefined(angular.mock))) {
	                console.error('No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.');
	            }
	
	            var addReg = function addReg(moduleName) {
	                if (regModules.indexOf(moduleName) === -1) {
	                    // register existing modules
	                    regModules.push(moduleName);
	                    var mainModule = angular.module(moduleName);
	
	                    // register existing components (directives, services, ...)
	                    _invokeQueue(null, mainModule._invokeQueue, moduleName);
	                    _invokeQueue(null, mainModule._configBlocks, moduleName); // angular 1.3+
	
	                    angular.forEach(mainModule.requires, addReg);
	                }
	            };
	
	            angular.forEach(modulesToLoad, function (moduleName) {
	                addReg(moduleName);
	            });
	
	            modulesToLoad = []; // reset for next bootstrap
	            recordDeclarations.pop(); // wait for the next lazy load
	        };
	
	        /**
	         * Like JSON.stringify but that doesn't throw on circular references
	         * @param obj
	         */
	        var stringify = function stringify(obj) {
	            try {
	                return JSON.stringify(obj);
	            } catch (e) {
	                var cache = [];
	                return JSON.stringify(obj, function (key, value) {
	                    if (angular.isObject(value) && value !== null) {
	                        if (cache.indexOf(value) !== -1) {
	                            // Circular reference found, discard key
	                            return;
	                        }
	                        // Store value in our collection
	                        cache.push(value);
	                    }
	                    return value;
	                });
	            }
	        };
	
	        var hashCode = function hashCode(str) {
	            var hash = 0,
	                i,
	                chr,
	                len;
	            if (str.length == 0) {
	                return hash;
	            }
	            for (i = 0, len = str.length; i < len; i++) {
	                chr = str.charCodeAt(i);
	                hash = (hash << 5) - hash + chr;
	                hash |= 0; // Convert to 32bit integer
	            }
	            return hash;
	        };
	
	        function _register(providers, registerModules, params) {
	            if (registerModules) {
	                var k,
	                    moduleName,
	                    moduleFn,
	                    tempRunBlocks = [];
	                for (k = registerModules.length - 1; k >= 0; k--) {
	                    moduleName = registerModules[k];
	                    if (!angular.isString(moduleName)) {
	                        moduleName = getModuleName(moduleName);
	                    }
	                    if (!moduleName || justLoaded.indexOf(moduleName) !== -1 || modules[moduleName] && realModules.indexOf(moduleName) === -1) {
	                        continue;
	                    }
	                    // new if not registered
	                    var newModule = regModules.indexOf(moduleName) === -1;
	                    moduleFn = ngModuleFct(moduleName);
	                    if (newModule) {
	                        regModules.push(moduleName);
	                        _register(providers, moduleFn.requires, params);
	                    }
	                    if (moduleFn._runBlocks.length > 0) {
	                        // new run blocks detected! Replace the old ones (if existing)
	                        runBlocks[moduleName] = [];
	                        while (moduleFn._runBlocks.length > 0) {
	                            runBlocks[moduleName].push(moduleFn._runBlocks.shift());
	                        }
	                    }
	                    if (angular.isDefined(runBlocks[moduleName]) && (newModule || params.rerun)) {
	                        tempRunBlocks = tempRunBlocks.concat(runBlocks[moduleName]);
	                    }
	                    _invokeQueue(providers, moduleFn._invokeQueue, moduleName, params.reconfig);
	                    _invokeQueue(providers, moduleFn._configBlocks, moduleName, params.reconfig); // angular 1.3+
	                    broadcast(newModule ? 'ocLazyLoad.moduleLoaded' : 'ocLazyLoad.moduleReloaded', moduleName);
	                    registerModules.pop();
	                    justLoaded.push(moduleName);
	                }
	                // execute the run blocks at the end
	                var instanceInjector = providers.getInstanceInjector();
	                angular.forEach(tempRunBlocks, function (fn) {
	                    instanceInjector.invoke(fn);
	                });
	            }
	        }
	
	        function _registerInvokeList(args, moduleName) {
	            var invokeList = args[2][0],
	                type = args[1],
	                newInvoke = false;
	            if (angular.isUndefined(regInvokes[moduleName])) {
	                regInvokes[moduleName] = {};
	            }
	            if (angular.isUndefined(regInvokes[moduleName][type])) {
	                regInvokes[moduleName][type] = {};
	            }
	            var onInvoke = function onInvoke(invokeName, invoke) {
	                if (!regInvokes[moduleName][type].hasOwnProperty(invokeName)) {
	                    regInvokes[moduleName][type][invokeName] = [];
	                }
	                if (checkHashes(invoke, regInvokes[moduleName][type][invokeName])) {
	                    newInvoke = true;
	                    regInvokes[moduleName][type][invokeName].push(invoke);
	                    broadcast('ocLazyLoad.componentLoaded', [moduleName, type, invokeName]);
	                }
	            };
	
	            function checkHashes(potentialNew, invokes) {
	                var isNew = true,
	                    newHash;
	                if (invokes.length) {
	                    newHash = signature(potentialNew);
	                    angular.forEach(invokes, function (invoke) {
	                        isNew = isNew && signature(invoke) !== newHash;
	                    });
	                }
	                return isNew;
	            }
	
	            function signature(data) {
	                if (angular.isArray(data)) {
	                    // arrays are objects, we need to test for it first
	                    return hashCode(data.toString());
	                } else if (angular.isObject(data)) {
	                    // constants & values for example
	                    return hashCode(stringify(data));
	                } else {
	                    if (angular.isDefined(data) && data !== null) {
	                        return hashCode(data.toString());
	                    } else {
	                        // null & undefined constants
	                        return data;
	                    }
	                }
	            }
	
	            if (angular.isString(invokeList)) {
	                onInvoke(invokeList, args[2][1]);
	            } else if (angular.isObject(invokeList)) {
	                angular.forEach(invokeList, function (invoke, key) {
	                    if (angular.isString(invoke)) {
	                        // decorators for example
	                        onInvoke(invoke, invokeList[1]);
	                    } else {
	                        // components registered as object lists {"componentName": function() {}}
	                        onInvoke(key, invoke);
	                    }
	                });
	            } else {
	                return false;
	            }
	            return newInvoke;
	        }
	
	        function _invokeQueue(providers, queue, moduleName, reconfig) {
	            if (!queue) {
	                return;
	            }
	
	            var i, len, args, provider;
	            for (i = 0, len = queue.length; i < len; i++) {
	                args = queue[i];
	                if (angular.isArray(args)) {
	                    if (providers !== null) {
	                        if (providers.hasOwnProperty(args[0])) {
	                            provider = providers[args[0]];
	                        } else {
	                            throw new Error('unsupported provider ' + args[0]);
	                        }
	                    }
	                    var isNew = _registerInvokeList(args, moduleName);
	                    if (args[1] !== 'invoke') {
	                        if (isNew && angular.isDefined(provider)) {
	                            provider[args[1]].apply(provider, args[2]);
	                        }
	                    } else {
	                        // config block
	                        var callInvoke = function callInvoke(fct) {
	                            var invoked = regConfigs.indexOf(moduleName + '-' + fct);
	                            if (invoked === -1 || reconfig) {
	                                if (invoked === -1) {
	                                    regConfigs.push(moduleName + '-' + fct);
	                                }
	                                if (angular.isDefined(provider)) {
	                                    provider[args[1]].apply(provider, args[2]);
	                                }
	                            }
	                        };
	                        if (angular.isFunction(args[2][0])) {
	                            callInvoke(args[2][0]);
	                        } else if (angular.isArray(args[2][0])) {
	                            for (var j = 0, jlen = args[2][0].length; j < jlen; j++) {
	                                if (angular.isFunction(args[2][0][j])) {
	                                    callInvoke(args[2][0][j]);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        function getModuleName(module) {
	            var moduleName = null;
	            if (angular.isString(module)) {
	                moduleName = module;
	            } else if (angular.isObject(module) && module.hasOwnProperty('name') && angular.isString(module.name)) {
	                moduleName = module.name;
	            }
	            return moduleName;
	        }
	
	        function moduleExists(moduleName) {
	            if (!angular.isString(moduleName)) {
	                return false;
	            }
	            try {
	                return ngModuleFct(moduleName);
	            } catch (e) {
	                if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
	                    return false;
	                }
	            }
	        }
	
	        this.$get = ["$log", "$rootElement", "$rootScope", "$cacheFactory", "$q", function ($log, $rootElement, $rootScope, $cacheFactory, $q) {
	            var instanceInjector,
	                filesCache = $cacheFactory('ocLazyLoad');
	
	            if (!debug) {
	                $log = {};
	                $log['error'] = angular.noop;
	                $log['warn'] = angular.noop;
	                $log['info'] = angular.noop;
	            }
	
	            // Make this lazy because when $get() is called the instance injector hasn't been assigned to the rootElement yet
	            providers.getInstanceInjector = function () {
	                return instanceInjector ? instanceInjector : instanceInjector = $rootElement.data('$injector') || angular.injector();
	            };
	
	            broadcast = function broadcast(eventName, params) {
	                if (events) {
	                    $rootScope.$broadcast(eventName, params);
	                }
	                if (debug) {
	                    $log.info(eventName, params);
	                }
	            };
	
	            function reject(e) {
	                var deferred = $q.defer();
	                $log.error(e.message);
	                deferred.reject(e);
	                return deferred.promise;
	            }
	
	            return {
	                _broadcast: broadcast,
	
	                _$log: $log,
	
	                /**
	                 * Returns the files cache used by the loaders to store the files currently loading
	                 * @returns {*}
	                 */
	                _getFilesCache: function getFilesCache() {
	                    return filesCache;
	                },
	
	                /**
	                 * Let the service know that it should monitor angular.module because files are loading
	                 * @param watch boolean
	                 */
	                toggleWatch: function toggleWatch(watch) {
	                    if (watch) {
	                        recordDeclarations.push(true);
	                    } else {
	                        recordDeclarations.pop();
	                    }
	                },
	
	                /**
	                 * Let you get a module config object
	                 * @param moduleName String the name of the module
	                 * @returns {*}
	                 */
	                getModuleConfig: function getModuleConfig(moduleName) {
	                    if (!angular.isString(moduleName)) {
	                        throw new Error('You need to give the name of the module to get');
	                    }
	                    if (!modules[moduleName]) {
	                        return null;
	                    }
	                    return angular.copy(modules[moduleName]);
	                },
	
	                /**
	                 * Let you define a module config object
	                 * @param moduleConfig Object the module config object
	                 * @returns {*}
	                 */
	                setModuleConfig: function setModuleConfig(moduleConfig) {
	                    if (!angular.isObject(moduleConfig)) {
	                        throw new Error('You need to give the module config object to set');
	                    }
	                    modules[moduleConfig.name] = moduleConfig;
	                    return moduleConfig;
	                },
	
	                /**
	                 * Returns the list of loaded modules
	                 * @returns {string[]}
	                 */
	                getModules: function getModules() {
	                    return regModules;
	                },
	
	                /**
	                 * Let you check if a module has been loaded into Angular or not
	                 * @param modulesNames String/Object a module name, or a list of module names
	                 * @returns {boolean}
	                 */
	                isLoaded: function isLoaded(modulesNames) {
	                    var moduleLoaded = function moduleLoaded(module) {
	                        var isLoaded = regModules.indexOf(module) > -1;
	                        if (!isLoaded) {
	                            isLoaded = !!moduleExists(module);
	                        }
	                        return isLoaded;
	                    };
	                    if (angular.isString(modulesNames)) {
	                        modulesNames = [modulesNames];
	                    }
	                    if (angular.isArray(modulesNames)) {
	                        var i, len;
	                        for (i = 0, len = modulesNames.length; i < len; i++) {
	                            if (!moduleLoaded(modulesNames[i])) {
	                                return false;
	                            }
	                        }
	                        return true;
	                    } else {
	                        throw new Error('You need to define the module(s) name(s)');
	                    }
	                },
	
	                /**
	                 * Given a module, return its name
	                 * @param module
	                 * @returns {String}
	                 */
	                _getModuleName: getModuleName,
	
	                /**
	                 * Returns a module if it exists
	                 * @param moduleName
	                 * @returns {module}
	                 */
	                _getModule: function getModule(moduleName) {
	                    try {
	                        return ngModuleFct(moduleName);
	                    } catch (e) {
	                        // this error message really suxx
	                        if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
	                            e.message = 'The module "' + stringify(moduleName) + '" that you are trying to load does not exist. ' + e.message;
	                        }
	                        throw e;
	                    }
	                },
	
	                /**
	                 * Check if a module exists and returns it if it does
	                 * @param moduleName
	                 * @returns {boolean}
	                 */
	                moduleExists: moduleExists,
	
	                /**
	                 * Load the dependencies, and might try to load new files depending on the config
	                 * @param moduleName (String or Array of Strings)
	                 * @param localParams
	                 * @returns {*}
	                 * @private
	                 */
	                _loadDependencies: function _loadDependencies(moduleName, localParams) {
	                    var loadedModule,
	                        requires,
	                        diff,
	                        promisesList = [],
	                        self = this;
	
	                    moduleName = self._getModuleName(moduleName);
	
	                    if (moduleName === null) {
	                        return $q.when();
	                    } else {
	                        try {
	                            loadedModule = self._getModule(moduleName);
	                        } catch (e) {
	                            return reject(e);
	                        }
	                        // get unloaded requires
	                        requires = self.getRequires(loadedModule);
	                    }
	
	                    angular.forEach(requires, function (requireEntry) {
	                        // If no configuration is provided, try and find one from a previous load.
	                        // If there isn't one, bail and let the normal flow run
	                        if (angular.isString(requireEntry)) {
	                            var config = self.getModuleConfig(requireEntry);
	                            if (config === null) {
	                                moduleCache.push(requireEntry); // We don't know about this module, but something else might, so push it anyway.
	                                return;
	                            }
	                            requireEntry = config;
	                            // ignore the name because it's probably not a real module name
	                            config.name = undefined;
	                        }
	
	                        // Check if this dependency has been loaded previously
	                        if (self.moduleExists(requireEntry.name)) {
	                            // compare against the already loaded module to see if the new definition adds any new files
	                            diff = requireEntry.files.filter(function (n) {
	                                return self.getModuleConfig(requireEntry.name).files.indexOf(n) < 0;
	                            });
	
	                            // If the module was redefined, advise via the console
	                            if (diff.length !== 0) {
	                                self._$log.warn('Module "', moduleName, '" attempted to redefine configuration for dependency. "', requireEntry.name, '"\n Additional Files Loaded:', diff);
	                            }
	
	                            // Push everything to the file loader, it will weed out the duplicates.
	                            if (angular.isDefined(self.filesLoader)) {
	                                // if a files loader is defined
	                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
	                                    return self._loadDependencies(requireEntry);
	                                }));
	                            } else {
	                                return reject(new Error('Error: New dependencies need to be loaded from external files (' + requireEntry.files + '), but no loader has been defined.'));
	                            }
	                            return;
	                        } else if (angular.isArray(requireEntry)) {
	                            var files = [];
	                            angular.forEach(requireEntry, function (entry) {
	                                // let's check if the entry is a file name or a config name
	                                var config = self.getModuleConfig(entry);
	                                if (config === null) {
	                                    files.push(entry);
	                                } else if (config.files) {
	                                    files = files.concat(config.files);
	                                }
	                            });
	                            if (files.length > 0) {
	                                requireEntry = {
	                                    files: files
	                                };
	                            }
	                        } else if (angular.isObject(requireEntry)) {
	                            if (requireEntry.hasOwnProperty('name') && requireEntry['name']) {
	                                // The dependency doesn't exist in the module cache and is a new configuration, so store and push it.
	                                self.setModuleConfig(requireEntry);
	                                moduleCache.push(requireEntry['name']);
	                            }
	                        }
	
	                        // Check if the dependency has any files that need to be loaded. If there are, push a new promise to the promise list.
	                        if (angular.isDefined(requireEntry.files) && requireEntry.files.length !== 0) {
	                            if (angular.isDefined(self.filesLoader)) {
	                                // if a files loader is defined
	                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
	                                    return self._loadDependencies(requireEntry);
	                                }));
	                            } else {
	                                return reject(new Error('Error: the module "' + requireEntry.name + '" is defined in external files (' + requireEntry.files + '), but no loader has been defined.'));
	                            }
	                        }
	                    });
	
	                    // Create a wrapper promise to watch the promise list and resolve it once everything is done.
	                    return $q.all(promisesList);
	                },
	
	                /**
	                 * Inject new modules into Angular
	                 * @param moduleName
	                 * @param localParams
	                 * @param real
	                 */
	                inject: function inject(moduleName) {
	                    var localParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	                    var real = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	                    var self = this,
	                        deferred = $q.defer();
	                    if (angular.isDefined(moduleName) && moduleName !== null) {
	                        if (angular.isArray(moduleName)) {
	                            var promisesList = [];
	                            angular.forEach(moduleName, function (module) {
	                                promisesList.push(self.inject(module, localParams, real));
	                            });
	                            return $q.all(promisesList);
	                        } else {
	                            self._addToLoadList(self._getModuleName(moduleName), true, real);
	                        }
	                    }
	                    if (modulesToLoad.length > 0) {
	                        var res = modulesToLoad.slice(); // clean copy
	                        var loadNext = function loadNext(moduleName) {
	                            moduleCache.push(moduleName);
	                            modulePromises[moduleName] = deferred.promise;
	                            self._loadDependencies(moduleName, localParams).then(function success() {
	                                try {
	                                    justLoaded = [];
	                                    _register(providers, moduleCache, localParams);
	                                } catch (e) {
	                                    self._$log.error(e.message);
	                                    deferred.reject(e);
	                                    return;
	                                }
	
	                                if (modulesToLoad.length > 0) {
	                                    loadNext(modulesToLoad.shift()); // load the next in list
	                                } else {
	                                        deferred.resolve(res); // everything has been loaded, resolve
	                                    }
	                            }, function error(err) {
	                                deferred.reject(err);
	                            });
	                        };
	
	                        // load the first in list
	                        loadNext(modulesToLoad.shift());
	                    } else if (localParams && localParams.name && modulePromises[localParams.name]) {
	                        return modulePromises[localParams.name];
	                    } else {
	                        deferred.resolve();
	                    }
	                    return deferred.promise;
	                },
	
	                /**
	                 * Get the list of required modules/services/... for this module
	                 * @param module
	                 * @returns {Array}
	                 */
	                getRequires: function getRequires(module) {
	                    var requires = [];
	                    angular.forEach(module.requires, function (requireModule) {
	                        if (regModules.indexOf(requireModule) === -1) {
	                            requires.push(requireModule);
	                        }
	                    });
	                    return requires;
	                },
	
	                /**
	                 * Invoke the new modules & component by their providers
	                 * @param providers
	                 * @param queue
	                 * @param moduleName
	                 * @param reconfig
	                 * @private
	                 */
	                _invokeQueue: _invokeQueue,
	
	                /**
	                 * Check if a module has been invoked and registers it if not
	                 * @param args
	                 * @param moduleName
	                 * @returns {boolean} is new
	                 */
	                _registerInvokeList: _registerInvokeList,
	
	                /**
	                 * Register a new module and loads it, executing the run/config blocks if needed
	                 * @param providers
	                 * @param registerModules
	                 * @param params
	                 * @private
	                 */
	                _register: _register,
	
	                /**
	                 * Add a module name to the list of modules that will be loaded in the next inject
	                 * @param name
	                 * @param force
	                 * @private
	                 */
	                _addToLoadList: _addToLoadList,
	
	                /**
	                 * Unregister modules (you shouldn't have to use this)
	                 * @param modules
	                 */
	                _unregister: function _unregister(modules) {
	                    if (angular.isDefined(modules)) {
	                        if (angular.isArray(modules)) {
	                            angular.forEach(modules, function (module) {
	                                regInvokes[module] = undefined;
	                            });
	                        }
	                    }
	                }
	            };
	        }];
	
	        // Let's get the list of loaded modules & components
	        this._init(angular.element(window.document));
	    }]);
	
	    var bootstrapFct = angular.bootstrap;
	    angular.bootstrap = function (element, modules, config) {
	        // Clean state from previous bootstrap
	        regModules = ['ng', 'oc.lazyLoad'];
	        regInvokes = {};
	        regConfigs = [];
	        modulesToLoad = [];
	        realModules = [];
	        recordDeclarations = [];
	        broadcast = angular.noop;
	        runBlocks = {};
	        justLoaded = [];
	        // we use slice to make a clean copy
	        angular.forEach(modules.slice(), function (module) {
	            _addToLoadList(module, true, true);
	        });
	        return bootstrapFct(element, modules, config);
	    };
	
	    var _addToLoadList = function _addToLoadList(name, force, real) {
	        if ((recordDeclarations.length > 0 || force) && angular.isString(name) && modulesToLoad.indexOf(name) === -1) {
	            modulesToLoad.push(name);
	            if (real) {
	                realModules.push(name);
	            }
	        }
	    };
	
	    var ngModuleFct = angular.module;
	    angular.module = function (name, requires, configFn) {
	        _addToLoadList(name, false, true);
	        return ngModuleFct(name, requires, configFn);
	    };
	
	    // CommonJS package manager support:
	    if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
	        module.exports = 'oc.lazyLoad';
	    }
	})(angular, window);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').directive('ocLazyLoad', ["$ocLazyLoad", "$compile", "$animate", "$parse", "$timeout", function ($ocLazyLoad, $compile, $animate, $parse, $timeout) {
	        return {
	            restrict: 'A',
	            terminal: true,
	            priority: 1000,
	            compile: function compile(element, attrs) {
	                // we store the content and remove it before compilation
	                var content = element[0].innerHTML;
	                element.html('');
	
	                return function ($scope, $element, $attr) {
	                    var model = $parse($attr.ocLazyLoad);
	                    $scope.$watch(function () {
	                        return model($scope) || $attr.ocLazyLoad; // it can be a module name (string), an object, an array, or a scope reference to any of this
	                    }, function (moduleName) {
	                        if (angular.isDefined(moduleName)) {
	                            $ocLazyLoad.load(moduleName).then(function () {
	                                // Attach element contents to DOM and then compile them.
	                                // This prevents an issue where IE invalidates saved element objects (HTMLCollections)
	                                // of the compiled contents when attaching to the parent DOM.
	                                $animate.enter(content, $element);
	                                // get the new content & compile it
	                                $compile($element.contents())($scope);
	                            });
	                        }
	                    }, true);
	                };
	            }
	        };
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", "$window", "$interval", function ($delegate, $q, $window, $interval) {
	            var uaCssChecked = false,
	                useCssLoadPatch = false,
	                anchor = $window.document.getElementsByTagName('head')[0] || $window.document.getElementsByTagName('body')[0];
	
	            /**
	             * Load a js/css file
	             * @param type
	             * @param path
	             * @param params
	             * @returns promise
	             */
	            $delegate.buildElement = function buildElement(type, path, params) {
	                var deferred = $q.defer(),
	                    el,
	                    loaded,
	                    filesCache = $delegate._getFilesCache(),
	                    cacheBuster = function cacheBuster(url) {
	                    var dc = new Date().getTime();
	                    if (url.indexOf('?') >= 0) {
	                        if (url.substring(0, url.length - 1) === '&') {
	                            return url + '_dc=' + dc;
	                        }
	                        return url + '&_dc=' + dc;
	                    } else {
	                        return url + '?_dc=' + dc;
	                    }
	                };
	
	                // Store the promise early so the file load can be detected by other parallel lazy loads
	                // (ie: multiple routes on one page) a 'true' value isn't sufficient
	                // as it causes false positive load results.
	                if (angular.isUndefined(filesCache.get(path))) {
	                    filesCache.put(path, deferred.promise);
	                }
	
	                // Switch in case more content types are added later
	                switch (type) {
	                    case 'css':
	                        el = $window.document.createElement('link');
	                        el.type = 'text/css';
	                        el.rel = 'stylesheet';
	                        el.href = params.cache === false ? cacheBuster(path) : path;
	                        break;
	                    case 'js':
	                        el = $window.document.createElement('script');
	                        el.src = params.cache === false ? cacheBuster(path) : path;
	                        break;
	                    default:
	                        filesCache.remove(path);
	                        deferred.reject(new Error('Requested type "' + type + '" is not known. Could not inject "' + path + '"'));
	                        break;
	                }
	                el.onload = el['onreadystatechange'] = function (e) {
	                    if (el['readyState'] && !/^c|loade/.test(el['readyState']) || loaded) return;
	                    el.onload = el['onreadystatechange'] = null;
	                    loaded = 1;
	                    $delegate._broadcast('ocLazyLoad.fileLoaded', path);
	                    deferred.resolve(el);
	                };
	                el.onerror = function () {
	                    filesCache.remove(path);
	                    deferred.reject(new Error('Unable to load ' + path));
	                };
	                el.async = params.serie ? 0 : 1;
	
	                var insertBeforeElem = anchor.lastChild;
	                if (params.insertBefore) {
	                    var element = angular.element(angular.isDefined(__webpack_provided_window_dot_jQuery) ? params.insertBefore : document.querySelector(params.insertBefore));
	                    if (element && element.length > 0) {
	                        insertBeforeElem = element[0];
	                    }
	                }
	                insertBeforeElem.parentNode.insertBefore(el, insertBeforeElem);
	
	                /*
	                 The event load or readystatechange doesn't fire in:
	                 - PhantomJS 1.9 (headless webkit browser)
	                 - iOS < 6       (default mobile browser)
	                 - Android < 4.4 (default mobile browser)
	                 - Safari < 6    (desktop browser)
	                 */
	                if (type == 'css') {
	                    if (!uaCssChecked) {
	                        var ua = $window.navigator.userAgent.toLowerCase();
	
	                        if (ua.indexOf('phantomjs/1.9') > -1) {
	                            // PhantomJS ~1.9
	                            useCssLoadPatch = true;
	                        } else if (/iP(hone|od|ad)/.test($window.navigator.platform)) {
	                            // iOS < 6
	                            var v = $window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
	                            var iOSVersion = parseFloat([parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)].join('.'));
	                            useCssLoadPatch = iOSVersion < 6;
	                        } else if (ua.indexOf('android') > -1) {
	                            // Android < 4.4
	                            var androidVersion = parseFloat(ua.slice(ua.indexOf('android') + 8));
	                            useCssLoadPatch = androidVersion < 4.4;
	                        } else if (ua.indexOf('safari') > -1) {
	                            // Safari < 6
	                            var versionMatch = ua.match(/version\/([\.\d]+)/i);
	                            useCssLoadPatch = versionMatch && versionMatch[1] && parseFloat(versionMatch[1]) < 6;
	                        }
	                    }
	
	                    if (useCssLoadPatch) {
	                        var tries = 1000; // * 20 = 20000 miliseconds
	                        var interval = $interval(function () {
	                            try {
	                                el.sheet.cssRules;
	                                $interval.cancel(interval);
	                                el.onload();
	                            } catch (e) {
	                                if (--tries <= 0) {
	                                    el.onerror();
	                                }
	                            }
	                        }, 20);
	                    }
	                }
	
	                return deferred.promise;
	            };
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
	            /**
	             * The function that loads new files
	             * @param config
	             * @param params
	             * @returns {*}
	             */
	            $delegate.filesLoader = function filesLoader(config) {
	                var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	                var cssFiles = [],
	                    templatesFiles = [],
	                    jsFiles = [],
	                    promises = [],
	                    cachePromise = null,
	                    filesCache = $delegate._getFilesCache();
	
	                $delegate.toggleWatch(true); // start watching angular.module calls
	
	                angular.extend(params, config);
	
	                var pushFile = function pushFile(path) {
	                    var file_type = null,
	                        m;
	                    if (angular.isObject(path)) {
	                        file_type = path.type;
	                        path = path.path;
	                    }
	                    cachePromise = filesCache.get(path);
	                    if (angular.isUndefined(cachePromise) || params.cache === false) {
	
	                        // always check for requirejs syntax just in case
	                        if ((m = /^(css|less|html|htm|js)?(?=!)/.exec(path)) !== null) {
	                            // Detect file type using preceding type declaration (ala requireJS)
	                            file_type = m[1];
	                            path = path.substr(m[1].length + 1, path.length); // Strip the type from the path
	                        }
	
	                        if (!file_type) {
	                            if ((m = /[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(path)) !== null) {
	                                // Detect file type via file extension
	                                file_type = m[1];
	                            } else if (!$delegate.jsLoader.hasOwnProperty('ocLazyLoadLoader') && $delegate.jsLoader.hasOwnProperty('requirejs')) {
	                                // requirejs
	                                file_type = 'js';
	                            } else {
	                                $delegate._$log.error('File type could not be determined. ' + path);
	                                return;
	                            }
	                        }
	
	                        if ((file_type === 'css' || file_type === 'less') && cssFiles.indexOf(path) === -1) {
	                            cssFiles.push(path);
	                        } else if ((file_type === 'html' || file_type === 'htm') && templatesFiles.indexOf(path) === -1) {
	                            templatesFiles.push(path);
	                        } else if (file_type === 'js' || jsFiles.indexOf(path) === -1) {
	                            jsFiles.push(path);
	                        } else {
	                            $delegate._$log.error('File type is not valid. ' + path);
	                        }
	                    } else if (cachePromise) {
	                        promises.push(cachePromise);
	                    }
	                };
	
	                if (params.serie) {
	                    pushFile(params.files.shift());
	                } else {
	                    angular.forEach(params.files, function (path) {
	                        pushFile(path);
	                    });
	                }
	
	                if (cssFiles.length > 0) {
	                    var cssDeferred = $q.defer();
	                    $delegate.cssLoader(cssFiles, function (err) {
	                        if (angular.isDefined(err) && $delegate.cssLoader.hasOwnProperty('ocLazyLoadLoader')) {
	                            $delegate._$log.error(err);
	                            cssDeferred.reject(err);
	                        } else {
	                            cssDeferred.resolve();
	                        }
	                    }, params);
	                    promises.push(cssDeferred.promise);
	                }
	
	                if (templatesFiles.length > 0) {
	                    var templatesDeferred = $q.defer();
	                    $delegate.templatesLoader(templatesFiles, function (err) {
	                        if (angular.isDefined(err) && $delegate.templatesLoader.hasOwnProperty('ocLazyLoadLoader')) {
	                            $delegate._$log.error(err);
	                            templatesDeferred.reject(err);
	                        } else {
	                            templatesDeferred.resolve();
	                        }
	                    }, params);
	                    promises.push(templatesDeferred.promise);
	                }
	
	                if (jsFiles.length > 0) {
	                    var jsDeferred = $q.defer();
	                    $delegate.jsLoader(jsFiles, function (err) {
	                        if (angular.isDefined(err) && ($delegate.jsLoader.hasOwnProperty("ocLazyLoadLoader") || $delegate.jsLoader.hasOwnProperty("requirejs"))) {
	                            $delegate._$log.error(err);
	                            jsDeferred.reject(err);
	                        } else {
	                            jsDeferred.resolve();
	                        }
	                    }, params);
	                    promises.push(jsDeferred.promise);
	                }
	
	                if (promises.length === 0) {
	                    var deferred = $q.defer(),
	                        err = "Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";
	                    $delegate._$log.error(err);
	                    deferred.reject(err);
	                    return deferred.promise;
	                } else if (params.serie && params.files.length > 0) {
	                    return $q.all(promises).then(function () {
	                        return $delegate.filesLoader(config, params);
	                    });
	                } else {
	                    return $q.all(promises)['finally'](function (res) {
	                        $delegate.toggleWatch(false); // stop watching angular.module calls
	                        return res;
	                    });
	                }
	            };
	
	            /**
	             * Load a module or a list of modules into Angular
	             * @param module Mixed the name of a predefined module config object, or a module config object, or an array of either
	             * @param params Object optional parameters
	             * @returns promise
	             */
	            $delegate.load = function (originalModule) {
	                var originalParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	                var self = this,
	                    config = null,
	                    deferredList = [],
	                    deferred = $q.defer(),
	                    errText;
	
	                // clean copy
	                var module = angular.copy(originalModule);
	                var params = angular.copy(originalParams);
	
	                // If module is an array, break it down
	                if (angular.isArray(module)) {
	                    // Resubmit each entry as a single module
	                    angular.forEach(module, function (m) {
	                        deferredList.push(self.load(m, params));
	                    });
	
	                    // Resolve the promise once everything has loaded
	                    $q.all(deferredList).then(function (res) {
	                        deferred.resolve(res);
	                    }, function (err) {
	                        deferred.reject(err);
	                    });
	
	                    return deferred.promise;
	                }
	
	                // Get or Set a configuration depending on what was passed in
	                if (angular.isString(module)) {
	                    config = self.getModuleConfig(module);
	                    if (!config) {
	                        config = {
	                            files: [module]
	                        };
	                    }
	                } else if (angular.isObject(module)) {
	                    // case {type: 'js', path: lazyLoadUrl + 'testModule.fakejs'}
	                    if (angular.isDefined(module.path) && angular.isDefined(module.type)) {
	                        config = {
	                            files: [module]
	                        };
	                    } else {
	                        config = self.setModuleConfig(module);
	                    }
	                }
	
	                if (config === null) {
	                    var moduleName = self._getModuleName(module);
	                    errText = 'Module "' + (moduleName || 'unknown') + '" is not configured, cannot load.';
	                    $delegate._$log.error(errText);
	                    deferred.reject(new Error(errText));
	                    return deferred.promise;
	                } else {
	                    // deprecated
	                    if (angular.isDefined(config.template)) {
	                        if (angular.isUndefined(config.files)) {
	                            config.files = [];
	                        }
	                        if (angular.isString(config.template)) {
	                            config.files.push(config.template);
	                        } else if (angular.isArray(config.template)) {
	                            config.files.concat(config.template);
	                        }
	                    }
	                }
	
	                var localParams = angular.extend({}, params, config);
	
	                // if someone used an external loader and called the load function with just the module name
	                if (angular.isUndefined(config.files) && angular.isDefined(config.name) && $delegate.moduleExists(config.name)) {
	                    return $delegate.inject(config.name, localParams, true);
	                }
	
	                $delegate.filesLoader(config, localParams).then(function () {
	                    $delegate.inject(null, localParams).then(function (res) {
	                        deferred.resolve(res);
	                    }, function (err) {
	                        deferred.reject(err);
	                    });
	                }, function (err) {
	                    deferred.reject(err);
	                });
	
	                return deferred.promise;
	            };
	
	            // return the patched service
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
	            /**
	             * cssLoader function
	             * @type Function
	             * @param paths array list of css files to load
	             * @param callback to call when everything is loaded. We use a callback and not a promise
	             * @param params object config parameters
	             * because the user can overwrite cssLoader and it will probably not use promises :(
	             */
	            $delegate.cssLoader = function (paths, callback, params) {
	                var promises = [];
	                angular.forEach(paths, function (path) {
	                    promises.push($delegate.buildElement('css', path, params));
	                });
	                $q.all(promises).then(function () {
	                    callback();
	                }, function (err) {
	                    callback(err);
	                });
	            };
	            $delegate.cssLoader.ocLazyLoadLoader = true;
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
	            /**
	             * jsLoader function
	             * @type Function
	             * @param paths array list of js files to load
	             * @param callback to call when everything is loaded. We use a callback and not a promise
	             * @param params object config parameters
	             * because the user can overwrite jsLoader and it will probably not use promises :(
	             */
	            $delegate.jsLoader = function (paths, callback, params) {
	                var promises = [];
	                angular.forEach(paths, function (path) {
	                    promises.push($delegate.buildElement('js', path, params));
	                });
	                $q.all(promises).then(function () {
	                    callback();
	                }, function (err) {
	                    callback(err);
	                });
	            };
	            $delegate.jsLoader.ocLazyLoadLoader = true;
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$templateCache", "$q", "$http", function ($delegate, $templateCache, $q, $http) {
	            /**
	             * templatesLoader function
	             * @type Function
	             * @param paths array list of css files to load
	             * @param callback to call when everything is loaded. We use a callback and not a promise
	             * @param params object config parameters for $http
	             * because the user can overwrite templatesLoader and it will probably not use promises :(
	             */
	            $delegate.templatesLoader = function (paths, callback, params) {
	                var promises = [],
	                    filesCache = $delegate._getFilesCache();
	
	                angular.forEach(paths, function (url) {
	                    var deferred = $q.defer();
	                    promises.push(deferred.promise);
	                    $http.get(url, params).then(function (response) {
	                        var data = response.data;
	                        if (angular.isString(data) && data.length > 0) {
	                            angular.forEach(angular.element(data), function (node) {
	                                if (node.nodeName === 'SCRIPT' && node.type === 'text/ng-template') {
	                                    $templateCache.put(node.id, node.innerHTML);
	                                }
	                            });
	                        }
	                        if (angular.isUndefined(filesCache.get(url))) {
	                            filesCache.put(url, true);
	                        }
	                        deferred.resolve();
	                    })['catch'](function (response) {
	                        deferred.reject(new Error('Unable to load template file "' + url + '": ' + response.data));
	                    });
	                });
	                return $q.all(promises).then(function () {
	                    callback();
	                }, function (err) {
	                    callback(err);
	                });
	            };
	            $delegate.templatesLoader.ocLazyLoadLoader = true;
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	// Array.indexOf polyfill for IE8
	if (!Array.prototype.indexOf) {
	        Array.prototype.indexOf = function (searchElement, fromIndex) {
	                var k;
	
	                // 1. Let O be the result of calling ToObject passing
	                //    the this value as the argument.
	                if (this == null) {
	                        throw new TypeError('"this" is null or not defined');
	                }
	
	                var O = Object(this);
	
	                // 2. Let lenValue be the result of calling the Get
	                //    internal method of O with the argument "length".
	                // 3. Let len be ToUint32(lenValue).
	                var len = O.length >>> 0;
	
	                // 4. If len is 0, return -1.
	                if (len === 0) {
	                        return -1;
	                }
	
	                // 5. If argument fromIndex was passed let n be
	                //    ToInteger(fromIndex); else let n be 0.
	                var n = +fromIndex || 0;
	
	                if (Math.abs(n) === Infinity) {
	                        n = 0;
	                }
	
	                // 6. If n >= len, return -1.
	                if (n >= len) {
	                        return -1;
	                }
	
	                // 7. If n >= 0, then Let k be n.
	                // 8. Else, n<0, Let k be len - abs(n).
	                //    If k is less than 0, then let k be 0.
	                k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
	
	                // 9. Repeat, while k < len
	                while (k < len) {
	                        // a. Let Pk be ToString(k).
	                        //   This is implicit for LHS operands of the in operator
	                        // b. Let kPresent be the result of calling the
	                        //    HasProperty internal method of O with argument Pk.
	                        //   This step can be combined with c
	                        // c. If kPresent is true, then
	                        //    i.  Let elementK be the result of calling the Get
	                        //        internal method of O with the argument ToString(k).
	                        //   ii.  Let same be the result of applying the
	                        //        Strict Equality Comparison Algorithm to
	                        //        searchElement and elementK.
	                        //  iii.  If same is true, return k.
	                        if (k in O && O[k] === searchElement) {
	                                return k;
	                        }
	                        k++;
	                }
	                return -1;
	        };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	'use strict';
	
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils   = __webpack_require__(150);
	var trees   = __webpack_require__(1553);
	var adler32 = __webpack_require__(528);
	var crc32   = __webpack_require__(529);
	var msg     = __webpack_require__(530);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils         = __webpack_require__(150);
	var adler32       = __webpack_require__(528);
	var crc32         = __webpack_require__(529);
	var inflate_fast  = __webpack_require__(1550);
	var inflate_table = __webpack_require__(1552);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(150);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(150);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          )
	
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(532);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var assign = __webpack_require__(18);
	
	var ReactPropTypesSecret = __webpack_require__(532);
	var checkPropTypes = __webpack_require__(1557);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(1560);
	exports.encode = exports.stringify = __webpack_require__(1561);


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1556)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {!function t(e,r){ true?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.Raphael=r():e.Raphael=r()}(this,function(){return function(t){function e(i){if(r[i])return r[i].exports;var n=r[i]={exports:{},id:i,loaded:!1};return t[i].call(n.exports,n,n.exports,e),n.loaded=!0,n.exports}var r={};return e.m=t,e.c=r,e.p="",e(0)}([function(t,e,r){var i,n;i=[r(1),r(3),r(4)],n=function(t){return t}.apply(e,i),!(void 0!==n&&(t.exports=n))},function(t,e,r){var i,n;i=[r(2)],n=function(t){function e(r){if(e.is(r,"function"))return w?r():t.on("raphael.DOMload",r);if(e.is(r,Q))return e._engine.create[z](e,r.splice(0,3+e.is(r[0],$))).add(r);var i=Array.prototype.slice.call(arguments,0);if(e.is(i[i.length-1],"function")){var n=i.pop();return w?n.call(e._engine.create[z](e,i)):t.on("raphael.DOMload",function(){n.call(e._engine.create[z](e,i))})}return e._engine.create[z](e,arguments)}function r(t){if("function"==typeof t||Object(t)!==t)return t;var e=new t.constructor;for(var i in t)t[A](i)&&(e[i]=r(t[i]));return e}function i(t,e){for(var r=0,i=t.length;r<i;r++)if(t[r]===e)return t.push(t.splice(r,1)[0])}function n(t,e,r){function n(){var a=Array.prototype.slice.call(arguments,0),s=a.join("␀"),o=n.cache=n.cache||{},l=n.count=n.count||[];return o[A](s)?(i(l,s),r?r(o[s]):o[s]):(l.length>=1e3&&delete o[l.shift()],l.push(s),o[s]=t[z](e,a),r?r(o[s]):o[s])}return n}function a(){return this.hex}function s(t,e){for(var r=[],i=0,n=t.length;n-2*!e>i;i+=2){var a=[{x:+t[i-2],y:+t[i-1]},{x:+t[i],y:+t[i+1]},{x:+t[i+2],y:+t[i+3]},{x:+t[i+4],y:+t[i+5]}];e?i?n-4==i?a[3]={x:+t[0],y:+t[1]}:n-2==i&&(a[2]={x:+t[0],y:+t[1]},a[3]={x:+t[2],y:+t[3]}):a[0]={x:+t[n-2],y:+t[n-1]}:n-4==i?a[3]=a[2]:i||(a[0]={x:+t[i],y:+t[i+1]}),r.push(["C",(-a[0].x+6*a[1].x+a[2].x)/6,(-a[0].y+6*a[1].y+a[2].y)/6,(a[1].x+6*a[2].x-a[3].x)/6,(a[1].y+6*a[2].y-a[3].y)/6,a[2].x,a[2].y])}return r}function o(t,e,r,i,n){var a=-3*e+9*r-9*i+3*n,s=t*a+6*e-12*r+6*i;return t*s-3*e+3*r}function l(t,e,r,i,n,a,s,l,h){null==h&&(h=1),h=h>1?1:h<0?0:h;for(var u=h/2,c=12,f=[-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],p=[.2491,.2491,.2335,.2335,.2032,.2032,.1601,.1601,.1069,.1069,.0472,.0472],d=0,g=0;g<c;g++){var v=u*f[g]+u,x=o(v,t,r,n,s),y=o(v,e,i,a,l),m=x*x+y*y;d+=p[g]*Y.sqrt(m)}return u*d}function h(t,e,r,i,n,a,s,o,h){if(!(h<0||l(t,e,r,i,n,a,s,o)<h)){var u=1,c=u/2,f=u-c,p,d=.01;for(p=l(t,e,r,i,n,a,s,o,f);H(p-h)>d;)c/=2,f+=(p<h?1:-1)*c,p=l(t,e,r,i,n,a,s,o,f);return f}}function u(t,e,r,i,n,a,s,o){if(!(W(t,r)<G(n,s)||G(t,r)>W(n,s)||W(e,i)<G(a,o)||G(e,i)>W(a,o))){var l=(t*i-e*r)*(n-s)-(t-r)*(n*o-a*s),h=(t*i-e*r)*(a-o)-(e-i)*(n*o-a*s),u=(t-r)*(a-o)-(e-i)*(n-s);if(u){var c=l/u,f=h/u,p=+c.toFixed(2),d=+f.toFixed(2);if(!(p<+G(t,r).toFixed(2)||p>+W(t,r).toFixed(2)||p<+G(n,s).toFixed(2)||p>+W(n,s).toFixed(2)||d<+G(e,i).toFixed(2)||d>+W(e,i).toFixed(2)||d<+G(a,o).toFixed(2)||d>+W(a,o).toFixed(2)))return{x:c,y:f}}}}function c(t,e){return p(t,e)}function f(t,e){return p(t,e,1)}function p(t,r,i){var n=e.bezierBBox(t),a=e.bezierBBox(r);if(!e.isBBoxIntersect(n,a))return i?0:[];for(var s=l.apply(0,t),o=l.apply(0,r),h=W(~~(s/5),1),c=W(~~(o/5),1),f=[],p=[],d={},g=i?0:[],v=0;v<h+1;v++){var x=e.findDotsAtSegment.apply(e,t.concat(v/h));f.push({x:x.x,y:x.y,t:v/h})}for(v=0;v<c+1;v++)x=e.findDotsAtSegment.apply(e,r.concat(v/c)),p.push({x:x.x,y:x.y,t:v/c});for(v=0;v<h;v++)for(var y=0;y<c;y++){var m=f[v],b=f[v+1],_=p[y],w=p[y+1],k=H(b.x-m.x)<.001?"y":"x",B=H(w.x-_.x)<.001?"y":"x",C=u(m.x,m.y,b.x,b.y,_.x,_.y,w.x,w.y);if(C){if(d[C.x.toFixed(4)]==C.y.toFixed(4))continue;d[C.x.toFixed(4)]=C.y.toFixed(4);var S=m.t+H((C[k]-m[k])/(b[k]-m[k]))*(b.t-m.t),A=_.t+H((C[B]-_[B])/(w[B]-_[B]))*(w.t-_.t);S>=0&&S<=1.001&&A>=0&&A<=1.001&&(i?g++:g.push({x:C.x,y:C.y,t1:G(S,1),t2:G(A,1)}))}}return g}function d(t,r,i){t=e._path2curve(t),r=e._path2curve(r);for(var n,a,s,o,l,h,u,c,f,d,g=i?0:[],v=0,x=t.length;v<x;v++){var y=t[v];if("M"==y[0])n=l=y[1],a=h=y[2];else{"C"==y[0]?(f=[n,a].concat(y.slice(1)),n=f[6],a=f[7]):(f=[n,a,n,a,l,h,l,h],n=l,a=h);for(var m=0,b=r.length;m<b;m++){var _=r[m];if("M"==_[0])s=u=_[1],o=c=_[2];else{"C"==_[0]?(d=[s,o].concat(_.slice(1)),s=d[6],o=d[7]):(d=[s,o,s,o,u,c,u,c],s=u,o=c);var w=p(f,d,i);if(i)g+=w;else{for(var k=0,B=w.length;k<B;k++)w[k].segment1=v,w[k].segment2=m,w[k].bez1=f,w[k].bez2=d;g=g.concat(w)}}}}}return g}function g(t,e,r,i,n,a){null!=t?(this.a=+t,this.b=+e,this.c=+r,this.d=+i,this.e=+n,this.f=+a):(this.a=1,this.b=0,this.c=0,this.d=1,this.e=0,this.f=0)}function v(){return this.x+j+this.y}function x(){return this.x+j+this.y+j+this.width+" × "+this.height}function y(t,e,r,i,n,a){function s(t){return((c*t+u)*t+h)*t}function o(t,e){var r=l(t,e);return((d*r+p)*r+f)*r}function l(t,e){var r,i,n,a,o,l;for(n=t,l=0;l<8;l++){if(a=s(n)-t,H(a)<e)return n;if(o=(3*c*n+2*u)*n+h,H(o)<1e-6)break;n-=a/o}if(r=0,i=1,n=t,n<r)return r;if(n>i)return i;for(;r<i;){if(a=s(n),H(a-t)<e)return n;t>a?r=n:i=n,n=(i-r)/2+r}return n}var h=3*e,u=3*(i-e)-h,c=1-h-u,f=3*r,p=3*(n-r)-f,d=1-f-p;return o(t,1/(200*a))}function m(t,e){var r=[],i={};if(this.ms=e,this.times=1,t){for(var n in t)t[A](n)&&(i[ht(n)]=t[n],r.push(ht(n)));r.sort(Bt)}this.anim=i,this.top=r[r.length-1],this.percents=r}function b(r,i,n,a,s,o){n=ht(n);var l,h,u,c=[],f,p,d,v=r.ms,x={},m={},b={};if(a)for(w=0,B=Ee.length;w<B;w++){var _=Ee[w];if(_.el.id==i.id&&_.anim==r){_.percent!=n?(Ee.splice(w,1),u=1):h=_,i.attr(_.totalOrigin);break}}else a=+m;for(var w=0,B=r.percents.length;w<B;w++){if(r.percents[w]==n||r.percents[w]>a*r.top){n=r.percents[w],p=r.percents[w-1]||0,v=v/r.top*(n-p),f=r.percents[w+1],l=r.anim[n];break}a&&i.attr(r.anim[r.percents[w]])}if(l){if(h)h.initstatus=a,h.start=new Date-h.ms*a;else{for(var C in l)if(l[A](C)&&(pt[A](C)||i.paper.customAttributes[A](C)))switch(x[C]=i.attr(C),null==x[C]&&(x[C]=ft[C]),m[C]=l[C],pt[C]){case $:b[C]=(m[C]-x[C])/v;break;case"colour":x[C]=e.getRGB(x[C]);var S=e.getRGB(m[C]);b[C]={r:(S.r-x[C].r)/v,g:(S.g-x[C].g)/v,b:(S.b-x[C].b)/v};break;case"path":var T=Qt(x[C],m[C]),E=T[1];for(x[C]=T[0],b[C]=[],w=0,B=x[C].length;w<B;w++){b[C][w]=[0];for(var M=1,N=x[C][w].length;M<N;M++)b[C][w][M]=(E[w][M]-x[C][w][M])/v}break;case"transform":var L=i._,z=le(L[C],m[C]);if(z)for(x[C]=z.from,m[C]=z.to,b[C]=[],b[C].real=!0,w=0,B=x[C].length;w<B;w++)for(b[C][w]=[x[C][w][0]],M=1,N=x[C][w].length;M<N;M++)b[C][w][M]=(m[C][w][M]-x[C][w][M])/v;else{var F=i.matrix||new g,R={_:{transform:L.transform},getBBox:function(){return i.getBBox(1)}};x[C]=[F.a,F.b,F.c,F.d,F.e,F.f],se(R,m[C]),m[C]=R._.transform,b[C]=[(R.matrix.a-F.a)/v,(R.matrix.b-F.b)/v,(R.matrix.c-F.c)/v,(R.matrix.d-F.d)/v,(R.matrix.e-F.e)/v,(R.matrix.f-F.f)/v]}break;case"csv":var j=I(l[C])[q](k),D=I(x[C])[q](k);if("clip-rect"==C)for(x[C]=D,b[C]=[],w=D.length;w--;)b[C][w]=(j[w]-x[C][w])/v;m[C]=j;break;default:for(j=[][P](l[C]),D=[][P](x[C]),b[C]=[],w=i.paper.customAttributes[C].length;w--;)b[C][w]=((j[w]||0)-(D[w]||0))/v}var V=l.easing,O=e.easing_formulas[V];if(!O)if(O=I(V).match(st),O&&5==O.length){var Y=O;O=function(t){return y(t,+Y[1],+Y[2],+Y[3],+Y[4],v)}}else O=St;if(d=l.start||r.start||+new Date,_={anim:r,percent:n,timestamp:d,start:d+(r.del||0),status:0,initstatus:a||0,stop:!1,ms:v,easing:O,from:x,diff:b,to:m,el:i,callback:l.callback,prev:p,next:f,repeat:o||r.times,origin:i.attr(),totalOrigin:s},Ee.push(_),a&&!h&&!u&&(_.stop=!0,_.start=new Date-v*a,1==Ee.length))return Ne();u&&(_.start=new Date-_.ms*a),1==Ee.length&&Me(Ne)}t("raphael.anim.start."+i.id,i,r)}}function _(t){for(var e=0;e<Ee.length;e++)Ee[e].el.paper==t&&Ee.splice(e--,1)}e.version="2.2.0",e.eve=t;var w,k=/[, ]+/,B={circle:1,rect:1,path:1,ellipse:1,text:1,image:1},C=/\{(\d+)\}/g,S="prototype",A="hasOwnProperty",T={doc:document,win:window},E={was:Object.prototype[A].call(T.win,"Raphael"),is:T.win.Raphael},M=function(){this.ca=this.customAttributes={}},N,L="appendChild",z="apply",P="concat",F="ontouchstart"in T.win||T.win.DocumentTouch&&T.doc instanceof DocumentTouch,R="",j=" ",I=String,q="split",D="click dblclick mousedown mousemove mouseout mouseover mouseup touchstart touchmove touchend touchcancel"[q](j),V={mousedown:"touchstart",mousemove:"touchmove",mouseup:"touchend"},O=I.prototype.toLowerCase,Y=Math,W=Y.max,G=Y.min,H=Y.abs,X=Y.pow,U=Y.PI,$="number",Z="string",Q="array",J="toString",K="fill",tt=Object.prototype.toString,et={},rt="push",it=e._ISURL=/^url\(['"]?(.+?)['"]?\)$/i,nt=/^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i,at={NaN:1,Infinity:1,"-Infinity":1},st=/^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,ot=Y.round,lt="setAttribute",ht=parseFloat,ut=parseInt,ct=I.prototype.toUpperCase,ft=e._availableAttrs={"arrow-end":"none","arrow-start":"none",blur:0,"clip-rect":"0 0 1e9 1e9",cursor:"default",cx:0,cy:0,fill:"#fff","fill-opacity":1,font:'10px "Arial"',"font-family":'"Arial"',"font-size":"10","font-style":"normal","font-weight":400,gradient:0,height:0,href:"http://raphaeljs.com/","letter-spacing":0,opacity:1,path:"M0,0",r:0,rx:0,ry:0,src:"",stroke:"#000","stroke-dasharray":"","stroke-linecap":"butt","stroke-linejoin":"butt","stroke-miterlimit":0,"stroke-opacity":1,"stroke-width":1,target:"_blank","text-anchor":"middle",title:"Raphael",transform:"",width:0,x:0,y:0,"class":""},pt=e._availableAnimAttrs={blur:$,"clip-rect":"csv",cx:$,cy:$,fill:"colour","fill-opacity":$,"font-size":$,height:$,opacity:$,path:"path",r:$,rx:$,ry:$,stroke:"colour","stroke-opacity":$,"stroke-width":$,transform:"transform",width:$,x:$,y:$},dt=/[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]/g,gt=/[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/,vt={hs:1,rg:1},xt=/,?([achlmqrstvxz]),?/gi,yt=/([achlmrqstvz])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/gi,mt=/([rstm])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/gi,bt=/(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/gi,_t=e._radial_gradient=/^r(?:\(([^,]+?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*([^\)]+?)\))?/,wt={},kt=function(t,e){return t.key-e.key},Bt=function(t,e){return ht(t)-ht(e)},Ct=function(){},St=function(t){return t},At=e._rectPath=function(t,e,r,i,n){return n?[["M",t+n,e],["l",r-2*n,0],["a",n,n,0,0,1,n,n],["l",0,i-2*n],["a",n,n,0,0,1,-n,n],["l",2*n-r,0],["a",n,n,0,0,1,-n,-n],["l",0,2*n-i],["a",n,n,0,0,1,n,-n],["z"]]:[["M",t,e],["l",r,0],["l",0,i],["l",-r,0],["z"]]},Tt=function(t,e,r,i){return null==i&&(i=r),[["M",t,e],["m",0,-i],["a",r,i,0,1,1,0,2*i],["a",r,i,0,1,1,0,-2*i],["z"]]},Et=e._getPath={path:function(t){return t.attr("path")},circle:function(t){var e=t.attrs;return Tt(e.cx,e.cy,e.r)},ellipse:function(t){var e=t.attrs;return Tt(e.cx,e.cy,e.rx,e.ry)},rect:function(t){var e=t.attrs;return At(e.x,e.y,e.width,e.height,e.r)},image:function(t){var e=t.attrs;return At(e.x,e.y,e.width,e.height)},text:function(t){var e=t._getBBox();return At(e.x,e.y,e.width,e.height)},set:function(t){var e=t._getBBox();return At(e.x,e.y,e.width,e.height)}},Mt=e.mapPath=function(t,e){if(!e)return t;var r,i,n,a,s,o,l;for(t=Qt(t),n=0,s=t.length;n<s;n++)for(l=t[n],a=1,o=l.length;a<o;a+=2)r=e.x(l[a],l[a+1]),i=e.y(l[a],l[a+1]),l[a]=r,l[a+1]=i;return t};if(e._g=T,e.type=T.win.SVGAngle||T.doc.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1")?"SVG":"VML","VML"==e.type){var Nt=T.doc.createElement("div"),Lt;if(Nt.innerHTML='<v:shape adj="1"/>',Lt=Nt.firstChild,Lt.style.behavior="url(#default#VML)",!Lt||"object"!=typeof Lt.adj)return e.type=R;Nt=null}e.svg=!(e.vml="VML"==e.type),e._Paper=M,e.fn=N=M.prototype=e.prototype,e._id=0,e.is=function(t,e){return e=O.call(e),"finite"==e?!at[A](+t):"array"==e?t instanceof Array:"null"==e&&null===t||e==typeof t&&null!==t||"object"==e&&t===Object(t)||"array"==e&&Array.isArray&&Array.isArray(t)||tt.call(t).slice(8,-1).toLowerCase()==e},e.angle=function(t,r,i,n,a,s){if(null==a){var o=t-i,l=r-n;return o||l?(180+180*Y.atan2(-l,-o)/U+360)%360:0}return e.angle(t,r,a,s)-e.angle(i,n,a,s)},e.rad=function(t){return t%360*U/180},e.deg=function(t){return Math.round(180*t/U%360*1e3)/1e3},e.snapTo=function(t,r,i){if(i=e.is(i,"finite")?i:10,e.is(t,Q)){for(var n=t.length;n--;)if(H(t[n]-r)<=i)return t[n]}else{t=+t;var a=r%t;if(a<i)return r-a;if(a>t-i)return r-a+t}return r};var zt=e.createUUID=function(t,e){return function(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(t,e).toUpperCase()}}(/[xy]/g,function(t){var e=16*Y.random()|0,r="x"==t?e:3&e|8;return r.toString(16)});e.setWindow=function(r){t("raphael.setWindow",e,T.win,r),T.win=r,T.doc=T.win.document,e._engine.initWin&&e._engine.initWin(T.win)};var Pt=function(t){if(e.vml){var r=/^\s+|\s+$/g,i;try{var a=new ActiveXObject("htmlfile");a.write("<body>"),a.close(),i=a.body}catch(s){i=createPopup().document.body}var o=i.createTextRange();Pt=n(function(t){try{i.style.color=I(t).replace(r,R);var e=o.queryCommandValue("ForeColor");return e=(255&e)<<16|65280&e|(16711680&e)>>>16,"#"+("000000"+e.toString(16)).slice(-6)}catch(n){return"none"}})}else{var l=T.doc.createElement("i");l.title="Raphaël Colour Picker",l.style.display="none",T.doc.body.appendChild(l),Pt=n(function(t){return l.style.color=t,T.doc.defaultView.getComputedStyle(l,R).getPropertyValue("color")})}return Pt(t)},Ft=function(){return"hsb("+[this.h,this.s,this.b]+")"},Rt=function(){return"hsl("+[this.h,this.s,this.l]+")"},jt=function(){return this.hex},It=function(t,r,i){if(null==r&&e.is(t,"object")&&"r"in t&&"g"in t&&"b"in t&&(i=t.b,r=t.g,t=t.r),null==r&&e.is(t,Z)){var n=e.getRGB(t);t=n.r,r=n.g,i=n.b}return(t>1||r>1||i>1)&&(t/=255,r/=255,i/=255),[t,r,i]},qt=function(t,r,i,n){t*=255,r*=255,i*=255;var a={r:t,g:r,b:i,hex:e.rgb(t,r,i),toString:jt};return e.is(n,"finite")&&(a.opacity=n),a};e.color=function(t){var r;return e.is(t,"object")&&"h"in t&&"s"in t&&"b"in t?(r=e.hsb2rgb(t),t.r=r.r,t.g=r.g,t.b=r.b,t.hex=r.hex):e.is(t,"object")&&"h"in t&&"s"in t&&"l"in t?(r=e.hsl2rgb(t),t.r=r.r,t.g=r.g,t.b=r.b,t.hex=r.hex):(e.is(t,"string")&&(t=e.getRGB(t)),e.is(t,"object")&&"r"in t&&"g"in t&&"b"in t?(r=e.rgb2hsl(t),t.h=r.h,t.s=r.s,t.l=r.l,r=e.rgb2hsb(t),t.v=r.b):(t={hex:"none"},t.r=t.g=t.b=t.h=t.s=t.v=t.l=-1)),t.toString=jt,t},e.hsb2rgb=function(t,e,r,i){this.is(t,"object")&&"h"in t&&"s"in t&&"b"in t&&(r=t.b,e=t.s,i=t.o,t=t.h),t*=360;var n,a,s,o,l;return t=t%360/60,l=r*e,o=l*(1-H(t%2-1)),n=a=s=r-l,t=~~t,n+=[l,o,0,0,o,l][t],a+=[o,l,l,o,0,0][t],s+=[0,0,o,l,l,o][t],qt(n,a,s,i)},e.hsl2rgb=function(t,e,r,i){this.is(t,"object")&&"h"in t&&"s"in t&&"l"in t&&(r=t.l,e=t.s,t=t.h),(t>1||e>1||r>1)&&(t/=360,e/=100,r/=100),t*=360;var n,a,s,o,l;return t=t%360/60,l=2*e*(r<.5?r:1-r),o=l*(1-H(t%2-1)),n=a=s=r-l/2,t=~~t,n+=[l,o,0,0,o,l][t],a+=[o,l,l,o,0,0][t],s+=[0,0,o,l,l,o][t],qt(n,a,s,i)},e.rgb2hsb=function(t,e,r){r=It(t,e,r),t=r[0],e=r[1],r=r[2];var i,n,a,s;return a=W(t,e,r),s=a-G(t,e,r),i=0==s?null:a==t?(e-r)/s:a==e?(r-t)/s+2:(t-e)/s+4,i=(i+360)%6*60/360,n=0==s?0:s/a,{h:i,s:n,b:a,toString:Ft}},e.rgb2hsl=function(t,e,r){r=It(t,e,r),t=r[0],e=r[1],r=r[2];var i,n,a,s,o,l;return s=W(t,e,r),o=G(t,e,r),l=s-o,i=0==l?null:s==t?(e-r)/l:s==e?(r-t)/l+2:(t-e)/l+4,i=(i+360)%6*60/360,a=(s+o)/2,n=0==l?0:a<.5?l/(2*a):l/(2-2*a),{h:i,s:n,l:a,toString:Rt}},e._path2string=function(){return this.join(",").replace(xt,"$1")};var Dt=e._preload=function(t,e){var r=T.doc.createElement("img");r.style.cssText="position:absolute;left:-9999em;top:-9999em",r.onload=function(){e.call(this),this.onload=null,T.doc.body.removeChild(this)},r.onerror=function(){T.doc.body.removeChild(this)},T.doc.body.appendChild(r),r.src=t};e.getRGB=n(function(t){if(!t||(t=I(t)).indexOf("-")+1)return{r:-1,g:-1,b:-1,hex:"none",error:1,toString:a};if("none"==t)return{r:-1,g:-1,b:-1,hex:"none",toString:a};!(vt[A](t.toLowerCase().substring(0,2))||"#"==t.charAt())&&(t=Pt(t));var r,i,n,s,o,l,h,u=t.match(nt);return u?(u[2]&&(s=ut(u[2].substring(5),16),n=ut(u[2].substring(3,5),16),i=ut(u[2].substring(1,3),16)),u[3]&&(s=ut((l=u[3].charAt(3))+l,16),n=ut((l=u[3].charAt(2))+l,16),i=ut((l=u[3].charAt(1))+l,16)),u[4]&&(h=u[4][q](gt),i=ht(h[0]),"%"==h[0].slice(-1)&&(i*=2.55),n=ht(h[1]),"%"==h[1].slice(-1)&&(n*=2.55),s=ht(h[2]),"%"==h[2].slice(-1)&&(s*=2.55),"rgba"==u[1].toLowerCase().slice(0,4)&&(o=ht(h[3])),h[3]&&"%"==h[3].slice(-1)&&(o/=100)),u[5]?(h=u[5][q](gt),i=ht(h[0]),"%"==h[0].slice(-1)&&(i*=2.55),n=ht(h[1]),"%"==h[1].slice(-1)&&(n*=2.55),s=ht(h[2]),"%"==h[2].slice(-1)&&(s*=2.55),("deg"==h[0].slice(-3)||"°"==h[0].slice(-1))&&(i/=360),"hsba"==u[1].toLowerCase().slice(0,4)&&(o=ht(h[3])),h[3]&&"%"==h[3].slice(-1)&&(o/=100),e.hsb2rgb(i,n,s,o)):u[6]?(h=u[6][q](gt),i=ht(h[0]),"%"==h[0].slice(-1)&&(i*=2.55),n=ht(h[1]),"%"==h[1].slice(-1)&&(n*=2.55),s=ht(h[2]),"%"==h[2].slice(-1)&&(s*=2.55),("deg"==h[0].slice(-3)||"°"==h[0].slice(-1))&&(i/=360),"hsla"==u[1].toLowerCase().slice(0,4)&&(o=ht(h[3])),h[3]&&"%"==h[3].slice(-1)&&(o/=100),e.hsl2rgb(i,n,s,o)):(u={r:i,g:n,b:s,toString:a},u.hex="#"+(16777216|s|n<<8|i<<16).toString(16).slice(1),e.is(o,"finite")&&(u.opacity=o),u)):{r:-1,g:-1,b:-1,hex:"none",error:1,toString:a}},e),e.hsb=n(function(t,r,i){return e.hsb2rgb(t,r,i).hex}),e.hsl=n(function(t,r,i){return e.hsl2rgb(t,r,i).hex}),e.rgb=n(function(t,e,r){function i(t){return t+.5|0}return"#"+(16777216|i(r)|i(e)<<8|i(t)<<16).toString(16).slice(1)}),e.getColor=function(t){var e=this.getColor.start=this.getColor.start||{h:0,s:1,b:t||.75},r=this.hsb2rgb(e.h,e.s,e.b);return e.h+=.075,e.h>1&&(e.h=0,e.s-=.2,e.s<=0&&(this.getColor.start={h:0,s:1,b:e.b})),r.hex},e.getColor.reset=function(){delete this.start},e.parsePathString=function(t){if(!t)return null;var r=Vt(t);if(r.arr)return Yt(r.arr);var i={a:7,c:6,h:1,l:2,m:2,r:4,q:4,s:4,t:2,v:1,z:0},n=[];return e.is(t,Q)&&e.is(t[0],Q)&&(n=Yt(t)),n.length||I(t).replace(yt,function(t,e,r){var a=[],s=e.toLowerCase();if(r.replace(bt,function(t,e){e&&a.push(+e)}),"m"==s&&a.length>2&&(n.push([e][P](a.splice(0,2))),s="l",e="m"==e?"l":"L"),"r"==s)n.push([e][P](a));else for(;a.length>=i[s]&&(n.push([e][P](a.splice(0,i[s]))),i[s]););}),n.toString=e._path2string,r.arr=Yt(n),n},e.parseTransformString=n(function(t){if(!t)return null;var r={r:3,s:4,t:2,m:6},i=[];return e.is(t,Q)&&e.is(t[0],Q)&&(i=Yt(t)),i.length||I(t).replace(mt,function(t,e,r){var n=[],a=O.call(e);r.replace(bt,function(t,e){e&&n.push(+e)}),i.push([e][P](n))}),i.toString=e._path2string,i});var Vt=function(t){var e=Vt.ps=Vt.ps||{};return e[t]?e[t].sleep=100:e[t]={sleep:100},setTimeout(function(){for(var r in e)e[A](r)&&r!=t&&(e[r].sleep--,!e[r].sleep&&delete e[r])}),e[t]};e.findDotsAtSegment=function(t,e,r,i,n,a,s,o,l){var h=1-l,u=X(h,3),c=X(h,2),f=l*l,p=f*l,d=u*t+3*c*l*r+3*h*l*l*n+p*s,g=u*e+3*c*l*i+3*h*l*l*a+p*o,v=t+2*l*(r-t)+f*(n-2*r+t),x=e+2*l*(i-e)+f*(a-2*i+e),y=r+2*l*(n-r)+f*(s-2*n+r),m=i+2*l*(a-i)+f*(o-2*a+i),b=h*t+l*r,_=h*e+l*i,w=h*n+l*s,k=h*a+l*o,B=90-180*Y.atan2(v-y,x-m)/U;return(v>y||x<m)&&(B+=180),{x:d,y:g,m:{x:v,y:x},n:{x:y,y:m},start:{x:b,y:_},end:{x:w,y:k},alpha:B}},e.bezierBBox=function(t,r,i,n,a,s,o,l){e.is(t,"array")||(t=[t,r,i,n,a,s,o,l]);var h=Zt.apply(null,t);return{x:h.min.x,y:h.min.y,x2:h.max.x,y2:h.max.y,width:h.max.x-h.min.x,height:h.max.y-h.min.y}},e.isPointInsideBBox=function(t,e,r){return e>=t.x&&e<=t.x2&&r>=t.y&&r<=t.y2},e.isBBoxIntersect=function(t,r){var i=e.isPointInsideBBox;return i(r,t.x,t.y)||i(r,t.x2,t.y)||i(r,t.x,t.y2)||i(r,t.x2,t.y2)||i(t,r.x,r.y)||i(t,r.x2,r.y)||i(t,r.x,r.y2)||i(t,r.x2,r.y2)||(t.x<r.x2&&t.x>r.x||r.x<t.x2&&r.x>t.x)&&(t.y<r.y2&&t.y>r.y||r.y<t.y2&&r.y>t.y)},e.pathIntersection=function(t,e){return d(t,e)},e.pathIntersectionNumber=function(t,e){return d(t,e,1)},e.isPointInsidePath=function(t,r,i){var n=e.pathBBox(t);return e.isPointInsideBBox(n,r,i)&&d(t,[["M",r,i],["H",n.x2+10]],1)%2==1},e._removedFactory=function(e){return function(){t("raphael.log",null,"Raphaël: you are calling to method “"+e+"” of removed object",e)}};var Ot=e.pathBBox=function(t){var e=Vt(t);if(e.bbox)return r(e.bbox);if(!t)return{x:0,y:0,width:0,height:0,x2:0,y2:0};t=Qt(t);for(var i=0,n=0,a=[],s=[],o,l=0,h=t.length;l<h;l++)if(o=t[l],"M"==o[0])i=o[1],n=o[2],a.push(i),s.push(n);else{var u=Zt(i,n,o[1],o[2],o[3],o[4],o[5],o[6]);a=a[P](u.min.x,u.max.x),s=s[P](u.min.y,u.max.y),i=o[5],n=o[6]}var c=G[z](0,a),f=G[z](0,s),p=W[z](0,a),d=W[z](0,s),g=p-c,v=d-f,x={x:c,y:f,x2:p,y2:d,width:g,height:v,cx:c+g/2,cy:f+v/2};return e.bbox=r(x),x},Yt=function(t){var i=r(t);return i.toString=e._path2string,i},Wt=e._pathToRelative=function(t){var r=Vt(t);if(r.rel)return Yt(r.rel);e.is(t,Q)&&e.is(t&&t[0],Q)||(t=e.parsePathString(t));var i=[],n=0,a=0,s=0,o=0,l=0;"M"==t[0][0]&&(n=t[0][1],a=t[0][2],s=n,o=a,l++,i.push(["M",n,a]));for(var h=l,u=t.length;h<u;h++){var c=i[h]=[],f=t[h];if(f[0]!=O.call(f[0]))switch(c[0]=O.call(f[0]),c[0]){case"a":c[1]=f[1],c[2]=f[2],c[3]=f[3],c[4]=f[4],c[5]=f[5],c[6]=+(f[6]-n).toFixed(3),c[7]=+(f[7]-a).toFixed(3);break;case"v":c[1]=+(f[1]-a).toFixed(3);break;case"m":s=f[1],o=f[2];default:for(var p=1,d=f.length;p<d;p++)c[p]=+(f[p]-(p%2?n:a)).toFixed(3)}else{c=i[h]=[],"m"==f[0]&&(s=f[1]+n,o=f[2]+a);for(var g=0,v=f.length;g<v;g++)i[h][g]=f[g]}var x=i[h].length;switch(i[h][0]){case"z":n=s,a=o;break;case"h":n+=+i[h][x-1];break;case"v":a+=+i[h][x-1];break;default:n+=+i[h][x-2],a+=+i[h][x-1]}}return i.toString=e._path2string,r.rel=Yt(i),i},Gt=e._pathToAbsolute=function(t){var r=Vt(t);if(r.abs)return Yt(r.abs);if(e.is(t,Q)&&e.is(t&&t[0],Q)||(t=e.parsePathString(t)),!t||!t.length)return[["M",0,0]];var i=[],n=0,a=0,o=0,l=0,h=0;"M"==t[0][0]&&(n=+t[0][1],a=+t[0][2],o=n,l=a,h++,i[0]=["M",n,a]);for(var u=3==t.length&&"M"==t[0][0]&&"R"==t[1][0].toUpperCase()&&"Z"==t[2][0].toUpperCase(),c,f,p=h,d=t.length;p<d;p++){if(i.push(c=[]),f=t[p],f[0]!=ct.call(f[0]))switch(c[0]=ct.call(f[0]),c[0]){case"A":c[1]=f[1],c[2]=f[2],c[3]=f[3],c[4]=f[4],c[5]=f[5],c[6]=+(f[6]+n),c[7]=+(f[7]+a);break;case"V":c[1]=+f[1]+a;break;case"H":c[1]=+f[1]+n;break;case"R":for(var g=[n,a][P](f.slice(1)),v=2,x=g.length;v<x;v++)g[v]=+g[v]+n,g[++v]=+g[v]+a;i.pop(),i=i[P](s(g,u));break;case"M":o=+f[1]+n,l=+f[2]+a;default:for(v=1,x=f.length;v<x;v++)c[v]=+f[v]+(v%2?n:a)}else if("R"==f[0])g=[n,a][P](f.slice(1)),i.pop(),i=i[P](s(g,u)),c=["R"][P](f.slice(-2));else for(var y=0,m=f.length;y<m;y++)c[y]=f[y];switch(c[0]){case"Z":n=o,a=l;break;case"H":n=c[1];break;case"V":a=c[1];break;case"M":o=c[c.length-2],l=c[c.length-1];default:n=c[c.length-2],a=c[c.length-1]}}return i.toString=e._path2string,r.abs=Yt(i),i},Ht=function(t,e,r,i){return[t,e,r,i,r,i]},Xt=function(t,e,r,i,n,a){var s=1/3,o=2/3;return[s*t+o*r,s*e+o*i,s*n+o*r,s*a+o*i,n,a]},Ut=function(t,e,r,i,a,s,o,l,h,u){var c=120*U/180,f=U/180*(+a||0),p=[],d,g=n(function(t,e,r){var i=t*Y.cos(r)-e*Y.sin(r),n=t*Y.sin(r)+e*Y.cos(r);return{x:i,y:n}});if(u)S=u[0],A=u[1],B=u[2],C=u[3];else{d=g(t,e,-f),t=d.x,e=d.y,d=g(l,h,-f),l=d.x,h=d.y;var v=Y.cos(U/180*a),x=Y.sin(U/180*a),y=(t-l)/2,m=(e-h)/2,b=y*y/(r*r)+m*m/(i*i);b>1&&(b=Y.sqrt(b),r=b*r,i=b*i);var _=r*r,w=i*i,k=(s==o?-1:1)*Y.sqrt(H((_*w-_*m*m-w*y*y)/(_*m*m+w*y*y))),B=k*r*m/i+(t+l)/2,C=k*-i*y/r+(e+h)/2,S=Y.asin(((e-C)/i).toFixed(9)),A=Y.asin(((h-C)/i).toFixed(9));S=t<B?U-S:S,A=l<B?U-A:A,S<0&&(S=2*U+S),A<0&&(A=2*U+A),o&&S>A&&(S-=2*U),!o&&A>S&&(A-=2*U)}var T=A-S;if(H(T)>c){var E=A,M=l,N=h;A=S+c*(o&&A>S?1:-1),l=B+r*Y.cos(A),h=C+i*Y.sin(A),p=Ut(l,h,r,i,a,0,o,M,N,[A,E,B,C])}T=A-S;var L=Y.cos(S),z=Y.sin(S),F=Y.cos(A),R=Y.sin(A),j=Y.tan(T/4),I=4/3*r*j,D=4/3*i*j,V=[t,e],O=[t+I*z,e-D*L],W=[l+I*R,h-D*F],G=[l,h];if(O[0]=2*V[0]-O[0],O[1]=2*V[1]-O[1],u)return[O,W,G][P](p);p=[O,W,G][P](p).join()[q](",");for(var X=[],$=0,Z=p.length;$<Z;$++)X[$]=$%2?g(p[$-1],p[$],f).y:g(p[$],p[$+1],f).x;return X},$t=function(t,e,r,i,n,a,s,o,l){var h=1-l;return{x:X(h,3)*t+3*X(h,2)*l*r+3*h*l*l*n+X(l,3)*s,y:X(h,3)*e+3*X(h,2)*l*i+3*h*l*l*a+X(l,3)*o}},Zt=n(function(t,e,r,i,n,a,s,o){var l=n-2*r+t-(s-2*n+r),h=2*(r-t)-2*(n-r),u=t-r,c=(-h+Y.sqrt(h*h-4*l*u))/2/l,f=(-h-Y.sqrt(h*h-4*l*u))/2/l,p=[e,o],d=[t,s],g;return H(c)>"1e12"&&(c=.5),H(f)>"1e12"&&(f=.5),c>0&&c<1&&(g=$t(t,e,r,i,n,a,s,o,c),d.push(g.x),p.push(g.y)),f>0&&f<1&&(g=$t(t,e,r,i,n,a,s,o,f),d.push(g.x),p.push(g.y)),l=a-2*i+e-(o-2*a+i),h=2*(i-e)-2*(a-i),u=e-i,c=(-h+Y.sqrt(h*h-4*l*u))/2/l,f=(-h-Y.sqrt(h*h-4*l*u))/2/l,H(c)>"1e12"&&(c=.5),H(f)>"1e12"&&(f=.5),c>0&&c<1&&(g=$t(t,e,r,i,n,a,s,o,c),d.push(g.x),p.push(g.y)),f>0&&f<1&&(g=$t(t,e,r,i,n,a,s,o,f),d.push(g.x),p.push(g.y)),{min:{x:G[z](0,d),y:G[z](0,p)},max:{x:W[z](0,d),y:W[z](0,p)}}}),Qt=e._path2curve=n(function(t,e){var r=!e&&Vt(t);if(!e&&r.curve)return Yt(r.curve);for(var i=Gt(t),n=e&&Gt(e),a={x:0,y:0,bx:0,by:0,X:0,Y:0,qx:null,qy:null},s={x:0,y:0,bx:0,by:0,X:0,Y:0,qx:null,qy:null},o=(function(t,e,r){var i,n,a={T:1,Q:1};if(!t)return["C",e.x,e.y,e.x,e.y,e.x,e.y];switch(!(t[0]in a)&&(e.qx=e.qy=null),t[0]){case"M":e.X=t[1],e.Y=t[2];break;case"A":t=["C"][P](Ut[z](0,[e.x,e.y][P](t.slice(1))));break;case"S":"C"==r||"S"==r?(i=2*e.x-e.bx,n=2*e.y-e.by):(i=e.x,n=e.y),t=["C",i,n][P](t.slice(1));break;case"T":"Q"==r||"T"==r?(e.qx=2*e.x-e.qx,e.qy=2*e.y-e.qy):(e.qx=e.x,e.qy=e.y),t=["C"][P](Xt(e.x,e.y,e.qx,e.qy,t[1],t[2]));break;case"Q":e.qx=t[1],e.qy=t[2],t=["C"][P](Xt(e.x,e.y,t[1],t[2],t[3],t[4]));break;case"L":t=["C"][P](Ht(e.x,e.y,t[1],t[2]));break;case"H":t=["C"][P](Ht(e.x,e.y,t[1],e.y));break;case"V":t=["C"][P](Ht(e.x,e.y,e.x,t[1]));break;case"Z":t=["C"][P](Ht(e.x,e.y,e.X,e.Y))}return t}),l=function(t,e){if(t[e].length>7){t[e].shift();for(var r=t[e];r.length;)u[e]="A",n&&(c[e]="A"),t.splice(e++,0,["C"][P](r.splice(0,6)));t.splice(e,1),g=W(i.length,n&&n.length||0)}},h=function(t,e,r,a,s){t&&e&&"M"==t[s][0]&&"M"!=e[s][0]&&(e.splice(s,0,["M",a.x,a.y]),r.bx=0,r.by=0,r.x=t[s][1],r.y=t[s][2],g=W(i.length,n&&n.length||0))},u=[],c=[],f="",p="",d=0,g=W(i.length,n&&n.length||0);d<g;d++){i[d]&&(f=i[d][0]),"C"!=f&&(u[d]=f,d&&(p=u[d-1])),i[d]=o(i[d],a,p),"A"!=u[d]&&"C"==f&&(u[d]="C"),l(i,d),n&&(n[d]&&(f=n[d][0]),"C"!=f&&(c[d]=f,d&&(p=c[d-1])),n[d]=o(n[d],s,p),"A"!=c[d]&&"C"==f&&(c[d]="C"),l(n,d)),h(i,n,a,s,d),h(n,i,s,a,d);var v=i[d],x=n&&n[d],y=v.length,m=n&&x.length;a.x=v[y-2],a.y=v[y-1],a.bx=ht(v[y-4])||a.x,a.by=ht(v[y-3])||a.y,s.bx=n&&(ht(x[m-4])||s.x),s.by=n&&(ht(x[m-3])||s.y),s.x=n&&x[m-2],s.y=n&&x[m-1]}return n||(r.curve=Yt(i)),n?[i,n]:i},null,Yt),Jt=e._parseDots=n(function(t){for(var r=[],i=0,n=t.length;i<n;i++){var a={},s=t[i].match(/^([^:]*):?([\d\.]*)/);if(a.color=e.getRGB(s[1]),a.color.error)return null;a.opacity=a.color.opacity,a.color=a.color.hex,s[2]&&(a.offset=s[2]+"%"),r.push(a)}for(i=1,n=r.length-1;i<n;i++)if(!r[i].offset){for(var o=ht(r[i-1].offset||0),l=0,h=i+1;h<n;h++)if(r[h].offset){l=r[h].offset;break}l||(l=100,h=n),l=ht(l);for(var u=(l-o)/(h-i+1);i<h;i++)o+=u,r[i].offset=o+"%"}return r}),Kt=e._tear=function(t,e){t==e.top&&(e.top=t.prev),t==e.bottom&&(e.bottom=t.next),t.next&&(t.next.prev=t.prev),t.prev&&(t.prev.next=t.next)},te=e._tofront=function(t,e){e.top!==t&&(Kt(t,e),t.next=null,t.prev=e.top,e.top.next=t,e.top=t)},ee=e._toback=function(t,e){e.bottom!==t&&(Kt(t,e),t.next=e.bottom,t.prev=null,e.bottom.prev=t,e.bottom=t)},re=e._insertafter=function(t,e,r){Kt(t,r),e==r.top&&(r.top=t),e.next&&(e.next.prev=t),t.next=e.next,t.prev=e,e.next=t},ie=e._insertbefore=function(t,e,r){Kt(t,r),e==r.bottom&&(r.bottom=t),e.prev&&(e.prev.next=t),t.prev=e.prev,e.prev=t,t.next=e},ne=e.toMatrix=function(t,e){var r=Ot(t),i={_:{transform:R},getBBox:function(){return r}};return se(i,e),i.matrix},ae=e.transformPath=function(t,e){return Mt(t,ne(t,e))},se=e._extractTransform=function(t,r){if(null==r)return t._.transform;r=I(r).replace(/\.{3}|\u2026/g,t._.transform||R);var i=e.parseTransformString(r),n=0,a=0,s=0,o=1,l=1,h=t._,u=new g;if(h.transform=i||[],i)for(var c=0,f=i.length;c<f;c++){var p=i[c],d=p.length,v=I(p[0]).toLowerCase(),x=p[0]!=v,y=x?u.invert():0,m,b,_,w,k;"t"==v&&3==d?x?(m=y.x(0,0),b=y.y(0,0),_=y.x(p[1],p[2]),w=y.y(p[1],p[2]),u.translate(_-m,w-b)):u.translate(p[1],p[2]):"r"==v?2==d?(k=k||t.getBBox(1),u.rotate(p[1],k.x+k.width/2,k.y+k.height/2),n+=p[1]):4==d&&(x?(_=y.x(p[2],p[3]),w=y.y(p[2],p[3]),u.rotate(p[1],_,w)):u.rotate(p[1],p[2],p[3]),n+=p[1]):"s"==v?2==d||3==d?(k=k||t.getBBox(1),u.scale(p[1],p[d-1],k.x+k.width/2,k.y+k.height/2),o*=p[1],l*=p[d-1]):5==d&&(x?(_=y.x(p[3],p[4]),w=y.y(p[3],p[4]),u.scale(p[1],p[2],_,w)):u.scale(p[1],p[2],p[3],p[4]),o*=p[1],l*=p[2]):"m"==v&&7==d&&u.add(p[1],p[2],p[3],p[4],p[5],p[6]),h.dirtyT=1,t.matrix=u}t.matrix=u,h.sx=o,h.sy=l,h.deg=n,h.dx=a=u.e,h.dy=s=u.f,1==o&&1==l&&!n&&h.bbox?(h.bbox.x+=+a,h.bbox.y+=+s):h.dirtyT=1},oe=function(t){var e=t[0];switch(e.toLowerCase()){case"t":return[e,0,0];case"m":return[e,1,0,0,1,0,0];case"r":return 4==t.length?[e,0,t[2],t[3]]:[e,0];case"s":return 5==t.length?[e,1,1,t[3],t[4]]:3==t.length?[e,1,1]:[e,1]}},le=e._equaliseTransform=function(t,r){r=I(r).replace(/\.{3}|\u2026/g,t),t=e.parseTransformString(t)||[],r=e.parseTransformString(r)||[];for(var i=W(t.length,r.length),n=[],a=[],s=0,o,l,h,u;s<i;s++){if(h=t[s]||oe(r[s]),u=r[s]||oe(h),h[0]!=u[0]||"r"==h[0].toLowerCase()&&(h[2]!=u[2]||h[3]!=u[3])||"s"==h[0].toLowerCase()&&(h[3]!=u[3]||h[4]!=u[4]))return;for(n[s]=[],a[s]=[],o=0,l=W(h.length,u.length);o<l;o++)o in h&&(n[s][o]=h[o]),o in u&&(a[s][o]=u[o])}return{from:n,to:a}};e._getContainer=function(t,r,i,n){var a;if(a=null!=n||e.is(t,"object")?t:T.doc.getElementById(t),null!=a)return a.tagName?null==r?{container:a,width:a.style.pixelWidth||a.offsetWidth,height:a.style.pixelHeight||a.offsetHeight}:{container:a,width:r,height:i}:{container:1,x:t,y:r,width:i,height:n}},e.pathToRelative=Wt,e._engine={},e.path2curve=Qt,e.matrix=function(t,e,r,i,n,a){return new g(t,e,r,i,n,a)},function(t){function r(t){return t[0]*t[0]+t[1]*t[1]}function i(t){var e=Y.sqrt(r(t));t[0]&&(t[0]/=e),t[1]&&(t[1]/=e)}t.add=function(t,e,r,i,n,a){var s=[[],[],[]],o=[[this.a,this.c,this.e],[this.b,this.d,this.f],[0,0,1]],l=[[t,r,n],[e,i,a],[0,0,1]],h,u,c,f;for(t&&t instanceof g&&(l=[[t.a,t.c,t.e],[t.b,t.d,t.f],[0,0,1]]),h=0;h<3;h++)for(u=0;u<3;u++){for(f=0,c=0;c<3;c++)f+=o[h][c]*l[c][u];s[h][u]=f}this.a=s[0][0],this.b=s[1][0],this.c=s[0][1],this.d=s[1][1],this.e=s[0][2],this.f=s[1][2]},t.invert=function(){var t=this,e=t.a*t.d-t.b*t.c;return new g(t.d/e,-t.b/e,-t.c/e,t.a/e,(t.c*t.f-t.d*t.e)/e,(t.b*t.e-t.a*t.f)/e)},t.clone=function(){return new g(this.a,this.b,this.c,this.d,this.e,this.f)},t.translate=function(t,e){
	this.add(1,0,0,1,t,e)},t.scale=function(t,e,r,i){null==e&&(e=t),(r||i)&&this.add(1,0,0,1,r,i),this.add(t,0,0,e,0,0),(r||i)&&this.add(1,0,0,1,-r,-i)},t.rotate=function(t,r,i){t=e.rad(t),r=r||0,i=i||0;var n=+Y.cos(t).toFixed(9),a=+Y.sin(t).toFixed(9);this.add(n,a,-a,n,r,i),this.add(1,0,0,1,-r,-i)},t.x=function(t,e){return t*this.a+e*this.c+this.e},t.y=function(t,e){return t*this.b+e*this.d+this.f},t.get=function(t){return+this[I.fromCharCode(97+t)].toFixed(4)},t.toString=function(){return e.svg?"matrix("+[this.get(0),this.get(1),this.get(2),this.get(3),this.get(4),this.get(5)].join()+")":[this.get(0),this.get(2),this.get(1),this.get(3),0,0].join()},t.toFilter=function(){return"progid:DXImageTransform.Microsoft.Matrix(M11="+this.get(0)+", M12="+this.get(2)+", M21="+this.get(1)+", M22="+this.get(3)+", Dx="+this.get(4)+", Dy="+this.get(5)+", sizingmethod='auto expand')"},t.offset=function(){return[this.e.toFixed(4),this.f.toFixed(4)]},t.split=function(){var t={};t.dx=this.e,t.dy=this.f;var n=[[this.a,this.c],[this.b,this.d]];t.scalex=Y.sqrt(r(n[0])),i(n[0]),t.shear=n[0][0]*n[1][0]+n[0][1]*n[1][1],n[1]=[n[1][0]-n[0][0]*t.shear,n[1][1]-n[0][1]*t.shear],t.scaley=Y.sqrt(r(n[1])),i(n[1]),t.shear/=t.scaley;var a=-n[0][1],s=n[1][1];return s<0?(t.rotate=e.deg(Y.acos(s)),a<0&&(t.rotate=360-t.rotate)):t.rotate=e.deg(Y.asin(a)),t.isSimple=!(+t.shear.toFixed(9)||t.scalex.toFixed(9)!=t.scaley.toFixed(9)&&t.rotate),t.isSuperSimple=!+t.shear.toFixed(9)&&t.scalex.toFixed(9)==t.scaley.toFixed(9)&&!t.rotate,t.noRotation=!+t.shear.toFixed(9)&&!t.rotate,t},t.toTransformString=function(t){var e=t||this[q]();return e.isSimple?(e.scalex=+e.scalex.toFixed(4),e.scaley=+e.scaley.toFixed(4),e.rotate=+e.rotate.toFixed(4),(e.dx||e.dy?"t"+[e.dx,e.dy]:R)+(1!=e.scalex||1!=e.scaley?"s"+[e.scalex,e.scaley,0,0]:R)+(e.rotate?"r"+[e.rotate,0,0]:R)):"m"+[this.get(0),this.get(1),this.get(2),this.get(3),this.get(4),this.get(5)]}}(g.prototype);for(var he=function(){this.returnValue=!1},ue=function(){return this.originalEvent.preventDefault()},ce=function(){this.cancelBubble=!0},fe=function(){return this.originalEvent.stopPropagation()},pe=function(t){var e=T.doc.documentElement.scrollTop||T.doc.body.scrollTop,r=T.doc.documentElement.scrollLeft||T.doc.body.scrollLeft;return{x:t.clientX+r,y:t.clientY+e}},de=function(){return T.doc.addEventListener?function(t,e,r,i){var n=function(t){var e=pe(t);return r.call(i,t,e.x,e.y)};if(t.addEventListener(e,n,!1),F&&V[e]){var a=function(e){for(var n=pe(e),a=e,s=0,o=e.targetTouches&&e.targetTouches.length;s<o;s++)if(e.targetTouches[s].target==t){e=e.targetTouches[s],e.originalEvent=a,e.preventDefault=ue,e.stopPropagation=fe;break}return r.call(i,e,n.x,n.y)};t.addEventListener(V[e],a,!1)}return function(){return t.removeEventListener(e,n,!1),F&&V[e]&&t.removeEventListener(V[e],a,!1),!0}}:T.doc.attachEvent?function(t,e,r,i){var n=function(t){t=t||T.win.event;var e=T.doc.documentElement.scrollTop||T.doc.body.scrollTop,n=T.doc.documentElement.scrollLeft||T.doc.body.scrollLeft,a=t.clientX+n,s=t.clientY+e;return t.preventDefault=t.preventDefault||he,t.stopPropagation=t.stopPropagation||ce,r.call(i,t,a,s)};t.attachEvent("on"+e,n);var a=function(){return t.detachEvent("on"+e,n),!0};return a}:void 0}(),ge=[],ve=function(e){for(var r=e.clientX,i=e.clientY,n=T.doc.documentElement.scrollTop||T.doc.body.scrollTop,a=T.doc.documentElement.scrollLeft||T.doc.body.scrollLeft,s,o=ge.length;o--;){if(s=ge[o],F&&e.touches){for(var l=e.touches.length,h;l--;)if(h=e.touches[l],h.identifier==s.el._drag.id){r=h.clientX,i=h.clientY,(e.originalEvent?e.originalEvent:e).preventDefault();break}}else e.preventDefault();var u=s.el.node,c,f=u.nextSibling,p=u.parentNode,d=u.style.display;T.win.opera&&p.removeChild(u),u.style.display="none",c=s.el.paper.getElementByPoint(r,i),u.style.display=d,T.win.opera&&(f?p.insertBefore(u,f):p.appendChild(u)),c&&t("raphael.drag.over."+s.el.id,s.el,c),r+=a,i+=n,t("raphael.drag.move."+s.el.id,s.move_scope||s.el,r-s.el._drag.x,i-s.el._drag.y,r,i,e)}},xe=function(r){e.unmousemove(ve).unmouseup(xe);for(var i=ge.length,n;i--;)n=ge[i],n.el._drag={},t("raphael.drag.end."+n.el.id,n.end_scope||n.start_scope||n.move_scope||n.el,r);ge=[]},ye=e.el={},me=D.length;me--;)!function(t){e[t]=ye[t]=function(r,i){return e.is(r,"function")&&(this.events=this.events||[],this.events.push({name:t,f:r,unbind:de(this.shape||this.node||T.doc,t,r,i||this)})),this},e["un"+t]=ye["un"+t]=function(r){for(var i=this.events||[],n=i.length;n--;)i[n].name!=t||!e.is(r,"undefined")&&i[n].f!=r||(i[n].unbind(),i.splice(n,1),!i.length&&delete this.events);return this}}(D[me]);ye.data=function(r,i){var n=wt[this.id]=wt[this.id]||{};if(0==arguments.length)return n;if(1==arguments.length){if(e.is(r,"object")){for(var a in r)r[A](a)&&this.data(a,r[a]);return this}return t("raphael.data.get."+this.id,this,n[r],r),n[r]}return n[r]=i,t("raphael.data.set."+this.id,this,i,r),this},ye.removeData=function(t){return null==t?wt[this.id]={}:wt[this.id]&&delete wt[this.id][t],this},ye.getData=function(){return r(wt[this.id]||{})},ye.hover=function(t,e,r,i){return this.mouseover(t,r).mouseout(e,i||r)},ye.unhover=function(t,e){return this.unmouseover(t).unmouseout(e)};var be=[];ye.drag=function(r,i,n,a,s,o){function l(l){(l.originalEvent||l).preventDefault();var h=l.clientX,u=l.clientY,c=T.doc.documentElement.scrollTop||T.doc.body.scrollTop,f=T.doc.documentElement.scrollLeft||T.doc.body.scrollLeft;if(this._drag.id=l.identifier,F&&l.touches)for(var p=l.touches.length,d;p--;)if(d=l.touches[p],this._drag.id=d.identifier,d.identifier==this._drag.id){h=d.clientX,u=d.clientY;break}this._drag.x=h+f,this._drag.y=u+c,!ge.length&&e.mousemove(ve).mouseup(xe),ge.push({el:this,move_scope:a,start_scope:s,end_scope:o}),i&&t.on("raphael.drag.start."+this.id,i),r&&t.on("raphael.drag.move."+this.id,r),n&&t.on("raphael.drag.end."+this.id,n),t("raphael.drag.start."+this.id,s||a||this,l.clientX+f,l.clientY+c,l)}return this._drag={},be.push({el:this,start:l}),this.mousedown(l),this},ye.onDragOver=function(e){e?t.on("raphael.drag.over."+this.id,e):t.unbind("raphael.drag.over."+this.id)},ye.undrag=function(){for(var r=be.length;r--;)be[r].el==this&&(this.unmousedown(be[r].start),be.splice(r,1),t.unbind("raphael.drag.*."+this.id));!be.length&&e.unmousemove(ve).unmouseup(xe),ge=[]},N.circle=function(t,r,i){var n=e._engine.circle(this,t||0,r||0,i||0);return this.__set__&&this.__set__.push(n),n},N.rect=function(t,r,i,n,a){var s=e._engine.rect(this,t||0,r||0,i||0,n||0,a||0);return this.__set__&&this.__set__.push(s),s},N.ellipse=function(t,r,i,n){var a=e._engine.ellipse(this,t||0,r||0,i||0,n||0);return this.__set__&&this.__set__.push(a),a},N.path=function(t){t&&!e.is(t,Z)&&!e.is(t[0],Q)&&(t+=R);var r=e._engine.path(e.format[z](e,arguments),this);return this.__set__&&this.__set__.push(r),r},N.image=function(t,r,i,n,a){var s=e._engine.image(this,t||"about:blank",r||0,i||0,n||0,a||0);return this.__set__&&this.__set__.push(s),s},N.text=function(t,r,i){var n=e._engine.text(this,t||0,r||0,I(i));return this.__set__&&this.__set__.push(n),n},N.set=function(t){!e.is(t,"array")&&(t=Array.prototype.splice.call(arguments,0,arguments.length));var r=new ze(t);return this.__set__&&this.__set__.push(r),r.paper=this,r.type="set",r},N.setStart=function(t){this.__set__=t||this.set()},N.setFinish=function(t){var e=this.__set__;return delete this.__set__,e},N.getSize=function(){var t=this.canvas.parentNode;return{width:t.offsetWidth,height:t.offsetHeight}},N.setSize=function(t,r){return e._engine.setSize.call(this,t,r)},N.setViewBox=function(t,r,i,n,a){return e._engine.setViewBox.call(this,t,r,i,n,a)},N.top=N.bottom=null,N.raphael=e;var _e=function(t){var e=t.getBoundingClientRect(),r=t.ownerDocument,i=r.body,n=r.documentElement,a=n.clientTop||i.clientTop||0,s=n.clientLeft||i.clientLeft||0,o=e.top+(T.win.pageYOffset||n.scrollTop||i.scrollTop)-a,l=e.left+(T.win.pageXOffset||n.scrollLeft||i.scrollLeft)-s;return{y:o,x:l}};N.getElementByPoint=function(t,e){var r=this,i=r.canvas,n=T.doc.elementFromPoint(t,e);if(T.win.opera&&"svg"==n.tagName){var a=_e(i),s=i.createSVGRect();s.x=t-a.x,s.y=e-a.y,s.width=s.height=1;var o=i.getIntersectionList(s,null);o.length&&(n=o[o.length-1])}if(!n)return null;for(;n.parentNode&&n!=i.parentNode&&!n.raphael;)n=n.parentNode;return n==r.canvas.parentNode&&(n=i),n=n&&n.raphael?r.getById(n.raphaelid):null},N.getElementsByBBox=function(t){var r=this.set();return this.forEach(function(i){e.isBBoxIntersect(i.getBBox(),t)&&r.push(i)}),r},N.getById=function(t){for(var e=this.bottom;e;){if(e.id==t)return e;e=e.next}return null},N.forEach=function(t,e){for(var r=this.bottom;r;){if(t.call(e,r)===!1)return this;r=r.next}return this},N.getElementsByPoint=function(t,e){var r=this.set();return this.forEach(function(i){i.isPointInside(t,e)&&r.push(i)}),r},ye.isPointInside=function(t,r){var i=this.realPath=Et[this.type](this);return this.attr("transform")&&this.attr("transform").length&&(i=e.transformPath(i,this.attr("transform"))),e.isPointInsidePath(i,t,r)},ye.getBBox=function(t){if(this.removed)return{};var e=this._;return t?(!e.dirty&&e.bboxwt||(this.realPath=Et[this.type](this),e.bboxwt=Ot(this.realPath),e.bboxwt.toString=x,e.dirty=0),e.bboxwt):((e.dirty||e.dirtyT||!e.bbox)&&(!e.dirty&&this.realPath||(e.bboxwt=0,this.realPath=Et[this.type](this)),e.bbox=Ot(Mt(this.realPath,this.matrix)),e.bbox.toString=x,e.dirty=e.dirtyT=0),e.bbox)},ye.clone=function(){if(this.removed)return null;var t=this.paper[this.type]().attr(this.attr());return this.__set__&&this.__set__.push(t),t},ye.glow=function(t){if("text"==this.type)return null;t=t||{};var e={width:(t.width||10)+(+this.attr("stroke-width")||1),fill:t.fill||!1,opacity:null==t.opacity?.5:t.opacity,offsetx:t.offsetx||0,offsety:t.offsety||0,color:t.color||"#000"},r=e.width/2,i=this.paper,n=i.set(),a=this.realPath||Et[this.type](this);a=this.matrix?Mt(a,this.matrix):a;for(var s=1;s<r+1;s++)n.push(i.path(a).attr({stroke:e.color,fill:e.fill?e.color:"none","stroke-linejoin":"round","stroke-linecap":"round","stroke-width":+(e.width/r*s).toFixed(3),opacity:+(e.opacity/r).toFixed(3)}));return n.insertBefore(this).translate(e.offsetx,e.offsety)};var we={},ke=function(t,r,i,n,a,s,o,u,c){return null==c?l(t,r,i,n,a,s,o,u):e.findDotsAtSegment(t,r,i,n,a,s,o,u,h(t,r,i,n,a,s,o,u,c))},Be=function(t,r){return function(i,n,a){i=Qt(i);for(var s,o,l,h,u="",c={},f,p=0,d=0,g=i.length;d<g;d++){if(l=i[d],"M"==l[0])s=+l[1],o=+l[2];else{if(h=ke(s,o,l[1],l[2],l[3],l[4],l[5],l[6]),p+h>n){if(r&&!c.start){if(f=ke(s,o,l[1],l[2],l[3],l[4],l[5],l[6],n-p),u+=["C"+f.start.x,f.start.y,f.m.x,f.m.y,f.x,f.y],a)return u;c.start=u,u=["M"+f.x,f.y+"C"+f.n.x,f.n.y,f.end.x,f.end.y,l[5],l[6]].join(),p+=h,s=+l[5],o=+l[6];continue}if(!t&&!r)return f=ke(s,o,l[1],l[2],l[3],l[4],l[5],l[6],n-p),{x:f.x,y:f.y,alpha:f.alpha}}p+=h,s=+l[5],o=+l[6]}u+=l.shift()+l}return c.end=u,f=t?p:r?c:e.findDotsAtSegment(s,o,l[0],l[1],l[2],l[3],l[4],l[5],1),f.alpha&&(f={x:f.x,y:f.y,alpha:f.alpha}),f}},Ce=Be(1),Se=Be(),Ae=Be(0,1);e.getTotalLength=Ce,e.getPointAtLength=Se,e.getSubpath=function(t,e,r){if(this.getTotalLength(t)-r<1e-6)return Ae(t,e).end;var i=Ae(t,r,1);return e?Ae(i,e).end:i},ye.getTotalLength=function(){var t=this.getPath();if(t)return this.node.getTotalLength?this.node.getTotalLength():Ce(t)},ye.getPointAtLength=function(t){var e=this.getPath();if(e)return Se(e,t)},ye.getPath=function(){var t,r=e._getPath[this.type];if("text"!=this.type&&"set"!=this.type)return r&&(t=r(this)),t},ye.getSubpath=function(t,r){var i=this.getPath();if(i)return e.getSubpath(i,t,r)};var Te=e.easing_formulas={linear:function(t){return t},"<":function(t){return X(t,1.7)},">":function(t){return X(t,.48)},"<>":function(t){var e=.48-t/1.04,r=Y.sqrt(.1734+e*e),i=r-e,n=X(H(i),1/3)*(i<0?-1:1),a=-r-e,s=X(H(a),1/3)*(a<0?-1:1),o=n+s+.5;return 3*(1-o)*o*o+o*o*o},backIn:function(t){var e=1.70158;return t*t*((e+1)*t-e)},backOut:function(t){t-=1;var e=1.70158;return t*t*((e+1)*t+e)+1},elastic:function(t){return t==!!t?t:X(2,-10*t)*Y.sin((t-.075)*(2*U)/.3)+1},bounce:function(t){var e=7.5625,r=2.75,i;return t<1/r?i=e*t*t:t<2/r?(t-=1.5/r,i=e*t*t+.75):t<2.5/r?(t-=2.25/r,i=e*t*t+.9375):(t-=2.625/r,i=e*t*t+.984375),i}};Te.easeIn=Te["ease-in"]=Te["<"],Te.easeOut=Te["ease-out"]=Te[">"],Te.easeInOut=Te["ease-in-out"]=Te["<>"],Te["back-in"]=Te.backIn,Te["back-out"]=Te.backOut;var Ee=[],Me=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(t){setTimeout(t,16)},Ne=function(){for(var r=+new Date,i=0;i<Ee.length;i++){var n=Ee[i];if(!n.el.removed&&!n.paused){var a=r-n.start,s=n.ms,o=n.easing,l=n.from,h=n.diff,u=n.to,c=n.t,f=n.el,p={},d,g={},v;if(n.initstatus?(a=(n.initstatus*n.anim.top-n.prev)/(n.percent-n.prev)*s,n.status=n.initstatus,delete n.initstatus,n.stop&&Ee.splice(i--,1)):n.status=(n.prev+(n.percent-n.prev)*(a/s))/n.anim.top,!(a<0))if(a<s){var x=o(a/s);for(var y in l)if(l[A](y)){switch(pt[y]){case $:d=+l[y]+x*s*h[y];break;case"colour":d="rgb("+[Le(ot(l[y].r+x*s*h[y].r)),Le(ot(l[y].g+x*s*h[y].g)),Le(ot(l[y].b+x*s*h[y].b))].join(",")+")";break;case"path":d=[];for(var m=0,_=l[y].length;m<_;m++){d[m]=[l[y][m][0]];for(var w=1,k=l[y][m].length;w<k;w++)d[m][w]=+l[y][m][w]+x*s*h[y][m][w];d[m]=d[m].join(j)}d=d.join(j);break;case"transform":if(h[y].real)for(d=[],m=0,_=l[y].length;m<_;m++)for(d[m]=[l[y][m][0]],w=1,k=l[y][m].length;w<k;w++)d[m][w]=l[y][m][w]+x*s*h[y][m][w];else{var B=function(t){return+l[y][t]+x*s*h[y][t]};d=[["m",B(0),B(1),B(2),B(3),B(4),B(5)]]}break;case"csv":if("clip-rect"==y)for(d=[],m=4;m--;)d[m]=+l[y][m]+x*s*h[y][m];break;default:var C=[][P](l[y]);for(d=[],m=f.paper.customAttributes[y].length;m--;)d[m]=+C[m]+x*s*h[y][m]}p[y]=d}f.attr(p),function(e,r,i){setTimeout(function(){t("raphael.anim.frame."+e,r,i)})}(f.id,f,n.anim)}else{if(function(r,i,n){setTimeout(function(){t("raphael.anim.frame."+i.id,i,n),t("raphael.anim.finish."+i.id,i,n),e.is(r,"function")&&r.call(i)})}(n.callback,f,n.anim),f.attr(u),Ee.splice(i--,1),n.repeat>1&&!n.next){for(v in u)u[A](v)&&(g[v]=n.totalOrigin[v]);n.el.attr(g),b(n.anim,n.el,n.anim.percents[0],null,n.totalOrigin,n.repeat-1)}n.next&&!n.stop&&b(n.anim,n.el,n.next,null,n.totalOrigin,n.repeat)}}}Ee.length&&Me(Ne)},Le=function(t){return t>255?255:t<0?0:t};ye.animateWith=function(t,r,i,n,a,s){var o=this;if(o.removed)return s&&s.call(o),o;var l=i instanceof m?i:e.animation(i,n,a,s),h,u;b(l,o,l.percents[0],null,o.attr());for(var c=0,f=Ee.length;c<f;c++)if(Ee[c].anim==r&&Ee[c].el==t){Ee[f-1].start=Ee[c].start;break}return o},ye.onAnimation=function(e){return e?t.on("raphael.anim.frame."+this.id,e):t.unbind("raphael.anim.frame."+this.id),this},m.prototype.delay=function(t){var e=new m(this.anim,this.ms);return e.times=this.times,e.del=+t||0,e},m.prototype.repeat=function(t){var e=new m(this.anim,this.ms);return e.del=this.del,e.times=Y.floor(W(t,0))||1,e},e.animation=function(t,r,i,n){if(t instanceof m)return t;!e.is(i,"function")&&i||(n=n||i||null,i=null),t=Object(t),r=+r||0;var a={},s,o;for(o in t)t[A](o)&&ht(o)!=o&&ht(o)+"%"!=o&&(s=!0,a[o]=t[o]);if(s)return i&&(a.easing=i),n&&(a.callback=n),new m({100:a},r);if(n){var l=0;for(var h in t){var u=ut(h);t[A](h)&&u>l&&(l=u)}l+="%",!t[l].callback&&(t[l].callback=n)}return new m(t,r)},ye.animate=function(t,r,i,n){var a=this;if(a.removed)return n&&n.call(a),a;var s=t instanceof m?t:e.animation(t,r,i,n);return b(s,a,s.percents[0],null,a.attr()),a},ye.setTime=function(t,e){return t&&null!=e&&this.status(t,G(e,t.ms)/t.ms),this},ye.status=function(t,e){var r=[],i=0,n,a;if(null!=e)return b(t,this,-1,G(e,1)),this;for(n=Ee.length;i<n;i++)if(a=Ee[i],a.el.id==this.id&&(!t||a.anim==t)){if(t)return a.status;r.push({anim:a.anim,status:a.status})}return t?0:r},ye.pause=function(e){for(var r=0;r<Ee.length;r++)Ee[r].el.id!=this.id||e&&Ee[r].anim!=e||t("raphael.anim.pause."+this.id,this,Ee[r].anim)!==!1&&(Ee[r].paused=!0);return this},ye.resume=function(e){for(var r=0;r<Ee.length;r++)if(Ee[r].el.id==this.id&&(!e||Ee[r].anim==e)){var i=Ee[r];t("raphael.anim.resume."+this.id,this,i.anim)!==!1&&(delete i.paused,this.status(i.anim,i.status))}return this},ye.stop=function(e){for(var r=0;r<Ee.length;r++)Ee[r].el.id!=this.id||e&&Ee[r].anim!=e||t("raphael.anim.stop."+this.id,this,Ee[r].anim)!==!1&&Ee.splice(r--,1);return this},t.on("raphael.remove",_),t.on("raphael.clear",_),ye.toString=function(){return"Raphaël’s object"};var ze=function(t){if(this.items=[],this.length=0,this.type="set",t)for(var e=0,r=t.length;e<r;e++)!t[e]||t[e].constructor!=ye.constructor&&t[e].constructor!=ze||(this[this.items.length]=this.items[this.items.length]=t[e],this.length++)},Pe=ze.prototype;Pe.push=function(){for(var t,e,r=0,i=arguments.length;r<i;r++)t=arguments[r],!t||t.constructor!=ye.constructor&&t.constructor!=ze||(e=this.items.length,this[e]=this.items[e]=t,this.length++);return this},Pe.pop=function(){return this.length&&delete this[this.length--],this.items.pop()},Pe.forEach=function(t,e){for(var r=0,i=this.items.length;r<i;r++)if(t.call(e,this.items[r],r)===!1)return this;return this};for(var Fe in ye)ye[A](Fe)&&(Pe[Fe]=function(t){return function(){var e=arguments;return this.forEach(function(r){r[t][z](r,e)})}}(Fe));return Pe.attr=function(t,r){if(t&&e.is(t,Q)&&e.is(t[0],"object"))for(var i=0,n=t.length;i<n;i++)this.items[i].attr(t[i]);else for(var a=0,s=this.items.length;a<s;a++)this.items[a].attr(t,r);return this},Pe.clear=function(){for(;this.length;)this.pop()},Pe.splice=function(t,e,r){t=t<0?W(this.length+t,0):t,e=W(0,G(this.length-t,e));var i=[],n=[],a=[],s;for(s=2;s<arguments.length;s++)a.push(arguments[s]);for(s=0;s<e;s++)n.push(this[t+s]);for(;s<this.length-t;s++)i.push(this[t+s]);var o=a.length;for(s=0;s<o+i.length;s++)this.items[t+s]=this[t+s]=s<o?a[s]:i[s-o];for(s=this.items.length=this.length-=e-o;this[s];)delete this[s++];return new ze(n)},Pe.exclude=function(t){for(var e=0,r=this.length;e<r;e++)if(this[e]==t)return this.splice(e,1),!0},Pe.animate=function(t,r,i,n){(e.is(i,"function")||!i)&&(n=i||null);var a=this.items.length,s=a,o,l=this,h;if(!a)return this;n&&(h=function(){!--a&&n.call(l)}),i=e.is(i,Z)?i:h;var u=e.animation(t,r,i,h);for(o=this.items[--s].animate(u);s--;)this.items[s]&&!this.items[s].removed&&this.items[s].animateWith(o,u,u),this.items[s]&&!this.items[s].removed||a--;return this},Pe.insertAfter=function(t){for(var e=this.items.length;e--;)this.items[e].insertAfter(t);return this},Pe.getBBox=function(){for(var t=[],e=[],r=[],i=[],n=this.items.length;n--;)if(!this.items[n].removed){var a=this.items[n].getBBox();t.push(a.x),e.push(a.y),r.push(a.x+a.width),i.push(a.y+a.height)}return t=G[z](0,t),e=G[z](0,e),r=W[z](0,r),i=W[z](0,i),{x:t,y:e,x2:r,y2:i,width:r-t,height:i-e}},Pe.clone=function(t){t=this.paper.set();for(var e=0,r=this.items.length;e<r;e++)t.push(this.items[e].clone());return t},Pe.toString=function(){return"Raphaël‘s set"},Pe.glow=function(t){var e=this.paper.set();return this.forEach(function(r,i){var n=r.glow(t);null!=n&&n.forEach(function(t,r){e.push(t)})}),e},Pe.isPointInside=function(t,e){var r=!1;return this.forEach(function(i){if(i.isPointInside(t,e))return r=!0,!1}),r},e.registerFont=function(t){if(!t.face)return t;this.fonts=this.fonts||{};var e={w:t.w,face:{},glyphs:{}},r=t.face["font-family"];for(var i in t.face)t.face[A](i)&&(e.face[i]=t.face[i]);if(this.fonts[r]?this.fonts[r].push(e):this.fonts[r]=[e],!t.svg){e.face["units-per-em"]=ut(t.face["units-per-em"],10);for(var n in t.glyphs)if(t.glyphs[A](n)){var a=t.glyphs[n];if(e.glyphs[n]={w:a.w,k:{},d:a.d&&"M"+a.d.replace(/[mlcxtrv]/g,function(t){return{l:"L",c:"C",x:"z",t:"m",r:"l",v:"c"}[t]||"M"})+"z"},a.k)for(var s in a.k)a[A](s)&&(e.glyphs[n].k[s]=a.k[s])}}return t},N.getFont=function(t,r,i,n){if(n=n||"normal",i=i||"normal",r=+r||{normal:400,bold:700,lighter:300,bolder:800}[r]||400,e.fonts){var a=e.fonts[t];if(!a){var s=new RegExp("(^|\\s)"+t.replace(/[^\w\d\s+!~.:_-]/g,R)+"(\\s|$)","i");for(var o in e.fonts)if(e.fonts[A](o)&&s.test(o)){a=e.fonts[o];break}}var l;if(a)for(var h=0,u=a.length;h<u&&(l=a[h],l.face["font-weight"]!=r||l.face["font-style"]!=i&&l.face["font-style"]||l.face["font-stretch"]!=n);h++);return l}},N.print=function(t,r,i,n,a,s,o,l){s=s||"middle",o=W(G(o||0,1),-1),l=W(G(l||1,3),1);var h=I(i)[q](R),u=0,c=0,f=R,p;if(e.is(n,"string")&&(n=this.getFont(n)),n){p=(a||16)/n.face["units-per-em"];for(var d=n.face.bbox[q](k),g=+d[0],v=d[3]-d[1],x=0,y=+d[1]+("baseline"==s?v+ +n.face.descent:v/2),m=0,b=h.length;m<b;m++){if("\n"==h[m])u=0,w=0,c=0,x+=v*l;else{var _=c&&n.glyphs[h[m-1]]||{},w=n.glyphs[h[m]];u+=c?(_.w||n.w)+(_.k&&_.k[h[m]]||0)+n.w*o:0,c=1}w&&w.d&&(f+=e.transformPath(w.d,["t",u*p,x*p,"s",p,p,g,y,"t",(t-g)/p,(r-y)/p]))}}return this.path(f).attr({fill:"#000",stroke:"none"})},N.add=function(t){if(e.is(t,"array"))for(var r=this.set(),i=0,n=t.length,a;i<n;i++)a=t[i]||{},B[A](a.type)&&r.push(this[a.type]().attr(a));return r},e.format=function(t,r){var i=e.is(r,Q)?[0][P](r):arguments;return t&&e.is(t,Z)&&i.length-1&&(t=t.replace(C,function(t,e){return null==i[++e]?R:i[e]})),t||R},e.fullfill=function(){var t=/\{([^\}]+)\}/g,e=/(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g,r=function(t,r,i){var n=i;return r.replace(e,function(t,e,r,i,a){e=e||i,n&&(e in n&&(n=n[e]),"function"==typeof n&&a&&(n=n()))}),n=(null==n||n==i?t:n)+""};return function(e,i){return String(e).replace(t,function(t,e){return r(t,e,i)})}}(),e.ninja=function(){if(E.was)T.win.Raphael=E.is;else{window.Raphael=void 0;try{delete window.Raphael}catch(t){}}return e},e.st=Pe,t.on("raphael.DOMload",function(){w=!0}),function(t,r,i){function n(){/in/.test(t.readyState)?setTimeout(n,9):e.eve("raphael.DOMload")}null==t.readyState&&t.addEventListener&&(t.addEventListener(r,i=function(){t.removeEventListener(r,i,!1),t.readyState="complete"},!1),t.readyState="loading"),n()}(document,"DOMContentLoaded"),e}.apply(e,i),!(void 0!==n&&(t.exports=n))},function(t,e,r){var i,n;!function(r){var a="0.5.0",s="hasOwnProperty",o=/[\.\/]/,l=/\s*,\s*/,h="*",u=function(){},c=function(t,e){return t-e},f,p,d={n:{}},g=function(){for(var t=0,e=this.length;t<e;t++)if("undefined"!=typeof this[t])return this[t]},v=function(){for(var t=this.length;--t;)if("undefined"!=typeof this[t])return this[t]},x=Object.prototype.toString,y=String,m=Array.isArray||function(t){return t instanceof Array||"[object Array]"==x.call(t)};eve=function(t,e){var r=d,i=p,n=Array.prototype.slice.call(arguments,2),a=eve.listeners(t),s=0,o=!1,l,h=[],u={},x=[],y=f,m=[];x.firstDefined=g,x.lastDefined=v,f=t,p=0;for(var b=0,_=a.length;b<_;b++)"zIndex"in a[b]&&(h.push(a[b].zIndex),a[b].zIndex<0&&(u[a[b].zIndex]=a[b]));for(h.sort(c);h[s]<0;)if(l=u[h[s++]],x.push(l.apply(e,n)),p)return p=i,x;for(b=0;b<_;b++)if(l=a[b],"zIndex"in l)if(l.zIndex==h[s]){if(x.push(l.apply(e,n)),p)break;do if(s++,l=u[h[s]],l&&x.push(l.apply(e,n)),p)break;while(l)}else u[l.zIndex]=l;else if(x.push(l.apply(e,n)),p)break;return p=i,f=y,x},eve._events=d,eve.listeners=function(t){var e=m(t)?t:t.split(o),r=d,i,n,a,s,l,u,c,f,p=[r],g=[];for(s=0,l=e.length;s<l;s++){for(f=[],u=0,c=p.length;u<c;u++)for(r=p[u].n,n=[r[e[s]],r[h]],a=2;a--;)i=n[a],i&&(f.push(i),g=g.concat(i.f||[]));p=f}return g},eve.separator=function(t){t?(t=y(t).replace(/(?=[\.\^\]\[\-])/g,"\\"),t="["+t+"]",o=new RegExp(t)):o=/[\.\/]/},eve.on=function(t,e){if("function"!=typeof e)return function(){};for(var r=m(t)?m(t[0])?t:[t]:y(t).split(l),i=0,n=r.length;i<n;i++)!function(t){for(var r=m(t)?t:y(t).split(o),i=d,n,a=0,s=r.length;a<s;a++)i=i.n,i=i.hasOwnProperty(r[a])&&i[r[a]]||(i[r[a]]={n:{}});for(i.f=i.f||[],a=0,s=i.f.length;a<s;a++)if(i.f[a]==e){n=!0;break}!n&&i.f.push(e)}(r[i]);return function(t){+t==+t&&(e.zIndex=+t)}},eve.f=function(t){var e=[].slice.call(arguments,1);return function(){eve.apply(null,[t,null].concat(e).concat([].slice.call(arguments,0)))}},eve.stop=function(){p=1},eve.nt=function(t){var e=m(f)?f.join("."):f;return t?new RegExp("(?:\\.|\\/|^)"+t+"(?:\\.|\\/|$)").test(e):e},eve.nts=function(){return m(f)?f:f.split(o)},eve.off=eve.unbind=function(t,e){if(!t)return void(eve._events=d={n:{}});var r=m(t)?m(t[0])?t:[t]:y(t).split(l);if(r.length>1)for(var i=0,n=r.length;i<n;i++)eve.off(r[i],e);else{r=m(t)?t:y(t).split(o);var a,u,c,i,n,f,p,g=[d];for(i=0,n=r.length;i<n;i++)for(f=0;f<g.length;f+=c.length-2){if(c=[f,1],a=g[f].n,r[i]!=h)a[r[i]]&&c.push(a[r[i]]);else for(u in a)a[s](u)&&c.push(a[u]);g.splice.apply(g,c)}for(i=0,n=g.length;i<n;i++)for(a=g[i];a.n;){if(e){if(a.f){for(f=0,p=a.f.length;f<p;f++)if(a.f[f]==e){a.f.splice(f,1);break}!a.f.length&&delete a.f}for(u in a.n)if(a.n[s](u)&&a.n[u].f){var v=a.n[u].f;for(f=0,p=v.length;f<p;f++)if(v[f]==e){v.splice(f,1);break}!v.length&&delete a.n[u].f}}else{delete a.f;for(u in a.n)a.n[s](u)&&a.n[u].f&&delete a.n[u].f}a=a.n}}},eve.once=function(t,e){var r=function(){return eve.off(t,r),e.apply(this,arguments)};return eve.on(t,r)},eve.version=a,eve.toString=function(){return"You are running Eve "+a},"undefined"!=typeof t&&t.exports?t.exports=eve:(i=[],n=function(){return eve}.apply(e,i),!(void 0!==n&&(t.exports=n)))}(this)},function(t,e,r){var i,n;i=[r(1)],n=function(t){if(!t||t.svg){var e="hasOwnProperty",r=String,i=parseFloat,n=parseInt,a=Math,s=a.max,o=a.abs,l=a.pow,h=/[, ]+/,u=t.eve,c="",f=" ",p="http://www.w3.org/1999/xlink",d={block:"M5,0 0,2.5 5,5z",classic:"M5,0 0,2.5 5,5 3.5,3 3.5,2z",diamond:"M2.5,0 5,2.5 2.5,5 0,2.5z",open:"M6,1 1,3.5 6,6",oval:"M2.5,0A2.5,2.5,0,0,1,2.5,5 2.5,2.5,0,0,1,2.5,0z"},g={};t.toString=function(){return"Your browser supports SVG.\nYou are running Raphaël "+this.version};var v=function(i,n){if(n){"string"==typeof i&&(i=v(i));for(var a in n)n[e](a)&&("xlink:"==a.substring(0,6)?i.setAttributeNS(p,a.substring(6),r(n[a])):i.setAttribute(a,r(n[a])))}else i=t._g.doc.createElementNS("http://www.w3.org/2000/svg",i),i.style&&(i.style.webkitTapHighlightColor="rgba(0,0,0,0)");return i},x=function(e,n){var h="linear",u=e.id+n,f=.5,p=.5,d=e.node,g=e.paper,x=d.style,y=t._g.doc.getElementById(u);if(!y){if(n=r(n).replace(t._radial_gradient,function(t,e,r){if(h="radial",e&&r){f=i(e),p=i(r);var n=2*(p>.5)-1;l(f-.5,2)+l(p-.5,2)>.25&&(p=a.sqrt(.25-l(f-.5,2))*n+.5)&&.5!=p&&(p=p.toFixed(5)-1e-5*n)}return c}),n=n.split(/\s*\-\s*/),"linear"==h){var b=n.shift();if(b=-i(b),isNaN(b))return null;var _=[0,0,a.cos(t.rad(b)),a.sin(t.rad(b))],w=1/(s(o(_[2]),o(_[3]))||1);_[2]*=w,_[3]*=w,_[2]<0&&(_[0]=-_[2],_[2]=0),_[3]<0&&(_[1]=-_[3],_[3]=0)}var k=t._parseDots(n);if(!k)return null;if(u=u.replace(/[\(\)\s,\xb0#]/g,"_"),e.gradient&&u!=e.gradient.id&&(g.defs.removeChild(e.gradient),delete e.gradient),!e.gradient){y=v(h+"Gradient",{id:u}),e.gradient=y,v(y,"radial"==h?{fx:f,fy:p}:{x1:_[0],y1:_[1],x2:_[2],y2:_[3],gradientTransform:e.matrix.invert()}),g.defs.appendChild(y);for(var B=0,C=k.length;B<C;B++)y.appendChild(v("stop",{offset:k[B].offset?k[B].offset:B?"100%":"0%","stop-color":k[B].color||"#fff","stop-opacity":isFinite(k[B].opacity)?k[B].opacity:1}))}}return v(d,{fill:m(u),opacity:1,"fill-opacity":1}),x.fill=c,x.opacity=1,x.fillOpacity=1,1},y=function(){var t=document.documentMode;return t&&(9===t||10===t)},m=function(t){if(y())return"url('#"+t+"')";var e=document.location,r=e.protocol+"//"+e.host+e.pathname+e.search;return"url('"+r+"#"+t+"')"},b=function(t){var e=t.getBBox(1);v(t.pattern,{patternTransform:t.matrix.invert()+" translate("+e.x+","+e.y+")"})},_=function(i,n,a){if("path"==i.type){for(var s=r(n).toLowerCase().split("-"),o=i.paper,l=a?"end":"start",h=i.node,u=i.attrs,f=u["stroke-width"],p=s.length,x="classic",y,m,b,_,w,k=3,B=3,C=5;p--;)switch(s[p]){case"block":case"classic":case"oval":case"diamond":case"open":case"none":x=s[p];break;case"wide":B=5;break;case"narrow":B=2;break;case"long":k=5;break;case"short":k=2}if("open"==x?(k+=2,B+=2,C+=2,b=1,_=a?4:1,w={fill:"none",stroke:u.stroke}):(_=b=k/2,w={fill:u.stroke,stroke:"none"}),i._.arrows?a?(i._.arrows.endPath&&g[i._.arrows.endPath]--,i._.arrows.endMarker&&g[i._.arrows.endMarker]--):(i._.arrows.startPath&&g[i._.arrows.startPath]--,i._.arrows.startMarker&&g[i._.arrows.startMarker]--):i._.arrows={},"none"!=x){var S="raphael-marker-"+x,A="raphael-marker-"+l+x+k+B+"-obj"+i.id;t._g.doc.getElementById(S)?g[S]++:(o.defs.appendChild(v(v("path"),{"stroke-linecap":"round",d:d[x],id:S})),g[S]=1);var T=t._g.doc.getElementById(A),E;T?(g[A]++,E=T.getElementsByTagName("use")[0]):(T=v(v("marker"),{id:A,markerHeight:B,markerWidth:k,orient:"auto",refX:_,refY:B/2}),E=v(v("use"),{"xlink:href":"#"+S,transform:(a?"rotate(180 "+k/2+" "+B/2+") ":c)+"scale("+k/C+","+B/C+")","stroke-width":(1/((k/C+B/C)/2)).toFixed(4)}),T.appendChild(E),o.defs.appendChild(T),g[A]=1),v(E,w);var M=b*("diamond"!=x&&"oval"!=x);a?(y=i._.arrows.startdx*f||0,m=t.getTotalLength(u.path)-M*f):(y=M*f,m=t.getTotalLength(u.path)-(i._.arrows.enddx*f||0)),w={},w["marker-"+l]="url(#"+A+")",(m||y)&&(w.d=t.getSubpath(u.path,y,m)),v(h,w),i._.arrows[l+"Path"]=S,i._.arrows[l+"Marker"]=A,i._.arrows[l+"dx"]=M,i._.arrows[l+"Type"]=x,i._.arrows[l+"String"]=n}else a?(y=i._.arrows.startdx*f||0,m=t.getTotalLength(u.path)-y):(y=0,m=t.getTotalLength(u.path)-(i._.arrows.enddx*f||0)),i._.arrows[l+"Path"]&&v(h,{d:t.getSubpath(u.path,y,m)}),delete i._.arrows[l+"Path"],delete i._.arrows[l+"Marker"],delete i._.arrows[l+"dx"],delete i._.arrows[l+"Type"],delete i._.arrows[l+"String"];for(w in g)if(g[e](w)&&!g[w]){var N=t._g.doc.getElementById(w);N&&N.parentNode.removeChild(N)}}},w={"-":[3,1],".":[1,1],"-.":[3,1,1,1],"-..":[3,1,1,1,1,1],". ":[1,3],"- ":[4,3],"--":[8,3],"- .":[4,3,1,3],"--.":[8,3,1,3],"--..":[8,3,1,3,1,3]},k=function(t,e,i){if(e=w[r(e).toLowerCase()]){for(var n=t.attrs["stroke-width"]||"1",a={round:n,square:n,butt:0}[t.attrs["stroke-linecap"]||i["stroke-linecap"]]||0,s=[],o=e.length;o--;)s[o]=e[o]*n+(o%2?1:-1)*a;v(t.node,{"stroke-dasharray":s.join(",")})}else v(t.node,{"stroke-dasharray":"none"})},B=function(i,a){var l=i.node,u=i.attrs,f=l.style.visibility;l.style.visibility="hidden";for(var d in a)if(a[e](d)){if(!t._availableAttrs[e](d))continue;var g=a[d];switch(u[d]=g,d){case"blur":i.blur(g);break;case"title":var y=l.getElementsByTagName("title");if(y.length&&(y=y[0]))y.firstChild.nodeValue=g;else{y=v("title");var m=t._g.doc.createTextNode(g);y.appendChild(m),l.appendChild(y)}break;case"href":case"target":var w=l.parentNode;if("a"!=w.tagName.toLowerCase()){var B=v("a");w.insertBefore(B,l),B.appendChild(l),w=B}"target"==d?w.setAttributeNS(p,"show","blank"==g?"new":g):w.setAttributeNS(p,d,g);break;case"cursor":l.style.cursor=g;break;case"transform":i.transform(g);break;case"arrow-start":_(i,g);break;case"arrow-end":_(i,g,1);break;case"clip-rect":var C=r(g).split(h);if(4==C.length){i.clip&&i.clip.parentNode.parentNode.removeChild(i.clip.parentNode);var A=v("clipPath"),T=v("rect");A.id=t.createUUID(),v(T,{x:C[0],y:C[1],width:C[2],height:C[3]}),A.appendChild(T),i.paper.defs.appendChild(A),v(l,{"clip-path":"url(#"+A.id+")"}),i.clip=T}if(!g){var E=l.getAttribute("clip-path");if(E){var M=t._g.doc.getElementById(E.replace(/(^url\(#|\)$)/g,c));M&&M.parentNode.removeChild(M),v(l,{"clip-path":c}),delete i.clip}}break;case"path":"path"==i.type&&(v(l,{d:g?u.path=t._pathToAbsolute(g):"M0,0"}),i._.dirty=1,i._.arrows&&("startString"in i._.arrows&&_(i,i._.arrows.startString),"endString"in i._.arrows&&_(i,i._.arrows.endString,1)));break;case"width":if(l.setAttribute(d,g),i._.dirty=1,!u.fx)break;d="x",g=u.x;case"x":u.fx&&(g=-u.x-(u.width||0));case"rx":if("rx"==d&&"rect"==i.type)break;case"cx":l.setAttribute(d,g),i.pattern&&b(i),i._.dirty=1;break;case"height":if(l.setAttribute(d,g),i._.dirty=1,!u.fy)break;d="y",g=u.y;case"y":u.fy&&(g=-u.y-(u.height||0));case"ry":if("ry"==d&&"rect"==i.type)break;case"cy":l.setAttribute(d,g),i.pattern&&b(i),i._.dirty=1;break;case"r":"rect"==i.type?v(l,{rx:g,ry:g}):l.setAttribute(d,g),i._.dirty=1;break;case"src":"image"==i.type&&l.setAttributeNS(p,"href",g);break;case"stroke-width":1==i._.sx&&1==i._.sy||(g/=s(o(i._.sx),o(i._.sy))||1),l.setAttribute(d,g),u["stroke-dasharray"]&&k(i,u["stroke-dasharray"],a),
	i._.arrows&&("startString"in i._.arrows&&_(i,i._.arrows.startString),"endString"in i._.arrows&&_(i,i._.arrows.endString,1));break;case"stroke-dasharray":k(i,g,a);break;case"fill":var N=r(g).match(t._ISURL);if(N){A=v("pattern");var L=v("image");A.id=t.createUUID(),v(A,{x:0,y:0,patternUnits:"userSpaceOnUse",height:1,width:1}),v(L,{x:0,y:0,"xlink:href":N[1]}),A.appendChild(L),function(e){t._preload(N[1],function(){var t=this.offsetWidth,r=this.offsetHeight;v(e,{width:t,height:r}),v(L,{width:t,height:r})})}(A),i.paper.defs.appendChild(A),v(l,{fill:"url(#"+A.id+")"}),i.pattern=A,i.pattern&&b(i);break}var z=t.getRGB(g);if(z.error){if(("circle"==i.type||"ellipse"==i.type||"r"!=r(g).charAt())&&x(i,g)){if("opacity"in u||"fill-opacity"in u){var P=t._g.doc.getElementById(l.getAttribute("fill").replace(/^url\(#|\)$/g,c));if(P){var F=P.getElementsByTagName("stop");v(F[F.length-1],{"stop-opacity":("opacity"in u?u.opacity:1)*("fill-opacity"in u?u["fill-opacity"]:1)})}}u.gradient=g,u.fill="none";break}}else delete a.gradient,delete u.gradient,!t.is(u.opacity,"undefined")&&t.is(a.opacity,"undefined")&&v(l,{opacity:u.opacity}),!t.is(u["fill-opacity"],"undefined")&&t.is(a["fill-opacity"],"undefined")&&v(l,{"fill-opacity":u["fill-opacity"]});z[e]("opacity")&&v(l,{"fill-opacity":z.opacity>1?z.opacity/100:z.opacity});case"stroke":z=t.getRGB(g),l.setAttribute(d,z.hex),"stroke"==d&&z[e]("opacity")&&v(l,{"stroke-opacity":z.opacity>1?z.opacity/100:z.opacity}),"stroke"==d&&i._.arrows&&("startString"in i._.arrows&&_(i,i._.arrows.startString),"endString"in i._.arrows&&_(i,i._.arrows.endString,1));break;case"gradient":("circle"==i.type||"ellipse"==i.type||"r"!=r(g).charAt())&&x(i,g);break;case"opacity":u.gradient&&!u[e]("stroke-opacity")&&v(l,{"stroke-opacity":g>1?g/100:g});case"fill-opacity":if(u.gradient){P=t._g.doc.getElementById(l.getAttribute("fill").replace(/^url\(#|\)$/g,c)),P&&(F=P.getElementsByTagName("stop"),v(F[F.length-1],{"stop-opacity":g}));break}default:"font-size"==d&&(g=n(g,10)+"px");var R=d.replace(/(\-.)/g,function(t){return t.substring(1).toUpperCase()});l.style[R]=g,i._.dirty=1,l.setAttribute(d,g)}}S(i,a),l.style.visibility=f},C=1.2,S=function(i,a){if("text"==i.type&&(a[e]("text")||a[e]("font")||a[e]("font-size")||a[e]("x")||a[e]("y"))){var s=i.attrs,o=i.node,l=o.firstChild?n(t._g.doc.defaultView.getComputedStyle(o.firstChild,c).getPropertyValue("font-size"),10):10;if(a[e]("text")){for(s.text=a.text;o.firstChild;)o.removeChild(o.firstChild);for(var h=r(a.text).split("\n"),u=[],f,p=0,d=h.length;p<d;p++)f=v("tspan"),p&&v(f,{dy:l*C,x:s.x}),f.appendChild(t._g.doc.createTextNode(h[p])),o.appendChild(f),u[p]=f}else for(u=o.getElementsByTagName("tspan"),p=0,d=u.length;p<d;p++)p?v(u[p],{dy:l*C,x:s.x}):v(u[0],{dy:0});v(o,{x:s.x,y:s.y}),i._.dirty=1;var g=i._getBBox(),x=s.y-(g.y+g.height/2);x&&t.is(x,"finite")&&v(u[0],{dy:x})}},A=function(t){return t.parentNode&&"a"===t.parentNode.tagName.toLowerCase()?t.parentNode:t},T=function(e,r){function i(){return("0000"+(Math.random()*Math.pow(36,5)<<0).toString(36)).slice(-5)}var n=0,a=0;this[0]=this.node=e,e.raphael=!0,this.id=i(),e.raphaelid=this.id,this.matrix=t.matrix(),this.realPath=null,this.paper=r,this.attrs=this.attrs||{},this._={transform:[],sx:1,sy:1,deg:0,dx:0,dy:0,dirty:1},!r.bottom&&(r.bottom=this),this.prev=r.top,r.top&&(r.top.next=this),r.top=this,this.next=null},E=t.el;T.prototype=E,E.constructor=T,t._engine.path=function(t,e){var r=v("path");e.canvas&&e.canvas.appendChild(r);var i=new T(r,e);return i.type="path",B(i,{fill:"none",stroke:"#000",path:t}),i},E.rotate=function(t,e,n){if(this.removed)return this;if(t=r(t).split(h),t.length-1&&(e=i(t[1]),n=i(t[2])),t=i(t[0]),null==n&&(e=n),null==e||null==n){var a=this.getBBox(1);e=a.x+a.width/2,n=a.y+a.height/2}return this.transform(this._.transform.concat([["r",t,e,n]])),this},E.scale=function(t,e,n,a){if(this.removed)return this;if(t=r(t).split(h),t.length-1&&(e=i(t[1]),n=i(t[2]),a=i(t[3])),t=i(t[0]),null==e&&(e=t),null==a&&(n=a),null==n||null==a)var s=this.getBBox(1);return n=null==n?s.x+s.width/2:n,a=null==a?s.y+s.height/2:a,this.transform(this._.transform.concat([["s",t,e,n,a]])),this},E.translate=function(t,e){return this.removed?this:(t=r(t).split(h),t.length-1&&(e=i(t[1])),t=i(t[0])||0,e=+e||0,this.transform(this._.transform.concat([["t",t,e]])),this)},E.transform=function(r){var i=this._;if(null==r)return i.transform;if(t._extractTransform(this,r),this.clip&&v(this.clip,{transform:this.matrix.invert()}),this.pattern&&b(this),this.node&&v(this.node,{transform:this.matrix}),1!=i.sx||1!=i.sy){var n=this.attrs[e]("stroke-width")?this.attrs["stroke-width"]:1;this.attr({"stroke-width":n})}return this},E.hide=function(){return this.removed||(this.node.style.display="none"),this},E.show=function(){return this.removed||(this.node.style.display=""),this},E.remove=function(){var e=A(this.node);if(!this.removed&&e.parentNode){var r=this.paper;r.__set__&&r.__set__.exclude(this),u.unbind("raphael.*.*."+this.id),this.gradient&&r.defs.removeChild(this.gradient),t._tear(this,r),e.parentNode.removeChild(e),this.removeData();for(var i in this)this[i]="function"==typeof this[i]?t._removedFactory(i):null;this.removed=!0}},E._getBBox=function(){if("none"==this.node.style.display){this.show();var t=!0}var e=!1,r;this.paper.canvas.parentElement?r=this.paper.canvas.parentElement.style:this.paper.canvas.parentNode&&(r=this.paper.canvas.parentNode.style),r&&"none"==r.display&&(e=!0,r.display="");var i={};try{i=this.node.getBBox()}catch(n){i={x:this.node.clientLeft,y:this.node.clientTop,width:this.node.clientWidth,height:this.node.clientHeight}}finally{i=i||{},e&&(r.display="none")}return t&&this.hide(),i},E.attr=function(r,i){if(this.removed)return this;if(null==r){var n={};for(var a in this.attrs)this.attrs[e](a)&&(n[a]=this.attrs[a]);return n.gradient&&"none"==n.fill&&(n.fill=n.gradient)&&delete n.gradient,n.transform=this._.transform,n}if(null==i&&t.is(r,"string")){if("fill"==r&&"none"==this.attrs.fill&&this.attrs.gradient)return this.attrs.gradient;if("transform"==r)return this._.transform;for(var s=r.split(h),o={},l=0,c=s.length;l<c;l++)r=s[l],r in this.attrs?o[r]=this.attrs[r]:t.is(this.paper.customAttributes[r],"function")?o[r]=this.paper.customAttributes[r].def:o[r]=t._availableAttrs[r];return c-1?o:o[s[0]]}if(null==i&&t.is(r,"array")){for(o={},l=0,c=r.length;l<c;l++)o[r[l]]=this.attr(r[l]);return o}if(null!=i){var f={};f[r]=i}else null!=r&&t.is(r,"object")&&(f=r);for(var p in f)u("raphael.attr."+p+"."+this.id,this,f[p]);for(p in this.paper.customAttributes)if(this.paper.customAttributes[e](p)&&f[e](p)&&t.is(this.paper.customAttributes[p],"function")){var d=this.paper.customAttributes[p].apply(this,[].concat(f[p]));this.attrs[p]=f[p];for(var g in d)d[e](g)&&(f[g]=d[g])}return B(this,f),this},E.toFront=function(){if(this.removed)return this;var e=A(this.node);e.parentNode.appendChild(e);var r=this.paper;return r.top!=this&&t._tofront(this,r),this},E.toBack=function(){if(this.removed)return this;var e=A(this.node),r=e.parentNode;r.insertBefore(e,r.firstChild),t._toback(this,this.paper);var i=this.paper;return this},E.insertAfter=function(e){if(this.removed||!e)return this;var r=A(this.node),i=A(e.node||e[e.length-1].node);return i.nextSibling?i.parentNode.insertBefore(r,i.nextSibling):i.parentNode.appendChild(r),t._insertafter(this,e,this.paper),this},E.insertBefore=function(e){if(this.removed||!e)return this;var r=A(this.node),i=A(e.node||e[0].node);return i.parentNode.insertBefore(r,i),t._insertbefore(this,e,this.paper),this},E.blur=function(e){var r=this;if(0!==+e){var i=v("filter"),n=v("feGaussianBlur");r.attrs.blur=e,i.id=t.createUUID(),v(n,{stdDeviation:+e||1.5}),i.appendChild(n),r.paper.defs.appendChild(i),r._blur=i,v(r.node,{filter:"url(#"+i.id+")"})}else r._blur&&(r._blur.parentNode.removeChild(r._blur),delete r._blur,delete r.attrs.blur),r.node.removeAttribute("filter");return r},t._engine.circle=function(t,e,r,i){var n=v("circle");t.canvas&&t.canvas.appendChild(n);var a=new T(n,t);return a.attrs={cx:e,cy:r,r:i,fill:"none",stroke:"#000"},a.type="circle",v(n,a.attrs),a},t._engine.rect=function(t,e,r,i,n,a){var s=v("rect");t.canvas&&t.canvas.appendChild(s);var o=new T(s,t);return o.attrs={x:e,y:r,width:i,height:n,rx:a||0,ry:a||0,fill:"none",stroke:"#000"},o.type="rect",v(s,o.attrs),o},t._engine.ellipse=function(t,e,r,i,n){var a=v("ellipse");t.canvas&&t.canvas.appendChild(a);var s=new T(a,t);return s.attrs={cx:e,cy:r,rx:i,ry:n,fill:"none",stroke:"#000"},s.type="ellipse",v(a,s.attrs),s},t._engine.image=function(t,e,r,i,n,a){var s=v("image");v(s,{x:r,y:i,width:n,height:a,preserveAspectRatio:"none"}),s.setAttributeNS(p,"href",e),t.canvas&&t.canvas.appendChild(s);var o=new T(s,t);return o.attrs={x:r,y:i,width:n,height:a,src:e},o.type="image",o},t._engine.text=function(e,r,i,n){var a=v("text");e.canvas&&e.canvas.appendChild(a);var s=new T(a,e);return s.attrs={x:r,y:i,"text-anchor":"middle",text:n,"font-family":t._availableAttrs["font-family"],"font-size":t._availableAttrs["font-size"],stroke:"none",fill:"#000"},s.type="text",B(s,s.attrs),s},t._engine.setSize=function(t,e){return this.width=t||this.width,this.height=e||this.height,this.canvas.setAttribute("width",this.width),this.canvas.setAttribute("height",this.height),this._viewBox&&this.setViewBox.apply(this,this._viewBox),this},t._engine.create=function(){var e=t._getContainer.apply(0,arguments),r=e&&e.container,i=e.x,n=e.y,a=e.width,s=e.height;if(!r)throw new Error("SVG container not found.");var o=v("svg"),l="overflow:hidden;",h;return i=i||0,n=n||0,a=a||512,s=s||342,v(o,{height:s,version:1.1,width:a,xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}),1==r?(o.style.cssText=l+"position:absolute;left:"+i+"px;top:"+n+"px",t._g.doc.body.appendChild(o),h=1):(o.style.cssText=l+"position:relative",r.firstChild?r.insertBefore(o,r.firstChild):r.appendChild(o)),r=new t._Paper,r.width=a,r.height=s,r.canvas=o,r.clear(),r._left=r._top=0,h&&(r.renderfix=function(){}),r.renderfix(),r},t._engine.setViewBox=function(t,e,r,i,n){u("raphael.setViewBox",this,this._viewBox,[t,e,r,i,n]);var a=this.getSize(),o=s(r/a.width,i/a.height),l=this.top,h=n?"xMidYMid meet":"xMinYMin",c,p;for(null==t?(this._vbSize&&(o=1),delete this._vbSize,c="0 0 "+this.width+f+this.height):(this._vbSize=o,c=t+f+e+f+r+f+i),v(this.canvas,{viewBox:c,preserveAspectRatio:h});o&&l;)p="stroke-width"in l.attrs?l.attrs["stroke-width"]:1,l.attr({"stroke-width":p}),l._.dirty=1,l._.dirtyT=1,l=l.prev;return this._viewBox=[t,e,r,i,!!n],this},t.prototype.renderfix=function(){var t=this.canvas,e=t.style,r;try{r=t.getScreenCTM()||t.createSVGMatrix()}catch(i){r=t.createSVGMatrix()}var n=-r.e%1,a=-r.f%1;(n||a)&&(n&&(this._left=(this._left+n)%1,e.left=this._left+"px"),a&&(this._top=(this._top+a)%1,e.top=this._top+"px"))},t.prototype.clear=function(){t.eve("raphael.clear",this);for(var e=this.canvas;e.firstChild;)e.removeChild(e.firstChild);this.bottom=this.top=null,(this.desc=v("desc")).appendChild(t._g.doc.createTextNode("Created with Raphaël "+t.version)),e.appendChild(this.desc),e.appendChild(this.defs=v("defs"))},t.prototype.remove=function(){u("raphael.remove",this),this.canvas.parentNode&&this.canvas.parentNode.removeChild(this.canvas);for(var e in this)this[e]="function"==typeof this[e]?t._removedFactory(e):null};var M=t.st;for(var N in E)E[e](N)&&!M[e](N)&&(M[N]=function(t){return function(){var e=arguments;return this.forEach(function(r){r[t].apply(r,e)})}}(N))}}.apply(e,i),!(void 0!==n&&(t.exports=n))},function(t,e,r){var i,n;i=[r(1)],n=function(t){if(!t||t.vml){var e="hasOwnProperty",r=String,i=parseFloat,n=Math,a=n.round,s=n.max,o=n.min,l=n.abs,h="fill",u=/[, ]+/,c=t.eve,f=" progid:DXImageTransform.Microsoft",p=" ",d="",g={M:"m",L:"l",C:"c",Z:"x",m:"t",l:"r",c:"v",z:"x"},v=/([clmz]),?([^clmz]*)/gi,x=/ progid:\S+Blur\([^\)]+\)/g,y=/-?[^,\s-]+/g,m="position:absolute;left:0;top:0;width:1px;height:1px;behavior:url(#default#VML)",b=21600,_={path:1,rect:1,image:1},w={circle:1,ellipse:1},k=function(e){var i=/[ahqstv]/gi,n=t._pathToAbsolute;if(r(e).match(i)&&(n=t._path2curve),i=/[clmz]/g,n==t._pathToAbsolute&&!r(e).match(i)){var s=r(e).replace(v,function(t,e,r){var i=[],n="m"==e.toLowerCase(),s=g[e];return r.replace(y,function(t){n&&2==i.length&&(s+=i+g["m"==e?"l":"L"],i=[]),i.push(a(t*b))}),s+i});return s}var o=n(e),l,h;s=[];for(var u=0,c=o.length;u<c;u++){l=o[u],h=o[u][0].toLowerCase(),"z"==h&&(h="x");for(var f=1,x=l.length;f<x;f++)h+=a(l[f]*b)+(f!=x-1?",":d);s.push(h)}return s.join(p)},B=function(e,r,i){var n=t.matrix();return n.rotate(-e,.5,.5),{dx:n.x(r,i),dy:n.y(r,i)}},C=function(t,e,r,i,n,a){var s=t._,o=t.matrix,u=s.fillpos,c=t.node,f=c.style,d=1,g="",v,x=b/e,y=b/r;if(f.visibility="hidden",e&&r){if(c.coordsize=l(x)+p+l(y),f.rotation=a*(e*r<0?-1:1),a){var m=B(a,i,n);i=m.dx,n=m.dy}if(e<0&&(g+="x"),r<0&&(g+=" y")&&(d=-1),f.flip=g,c.coordorigin=i*-x+p+n*-y,u||s.fillsize){var _=c.getElementsByTagName(h);_=_&&_[0],c.removeChild(_),u&&(m=B(a,o.x(u[0],u[1]),o.y(u[0],u[1])),_.position=m.dx*d+p+m.dy*d),s.fillsize&&(_.size=s.fillsize[0]*l(e)+p+s.fillsize[1]*l(r)),c.appendChild(_)}f.visibility="visible"}};t.toString=function(){return"Your browser doesn’t support SVG. Falling down to VML.\nYou are running Raphaël "+this.version};var S=function(t,e,i){for(var n=r(e).toLowerCase().split("-"),a=i?"end":"start",s=n.length,o="classic",l="medium",h="medium";s--;)switch(n[s]){case"block":case"classic":case"oval":case"diamond":case"open":case"none":o=n[s];break;case"wide":case"narrow":h=n[s];break;case"long":case"short":l=n[s]}var u=t.node.getElementsByTagName("stroke")[0];u[a+"arrow"]=o,u[a+"arrowlength"]=l,u[a+"arrowwidth"]=h},A=function(n,l){n.attrs=n.attrs||{};var c=n.node,f=n.attrs,g=c.style,v,x=_[n.type]&&(l.x!=f.x||l.y!=f.y||l.width!=f.width||l.height!=f.height||l.cx!=f.cx||l.cy!=f.cy||l.rx!=f.rx||l.ry!=f.ry||l.r!=f.r),y=w[n.type]&&(f.cx!=l.cx||f.cy!=l.cy||f.r!=l.r||f.rx!=l.rx||f.ry!=l.ry),m=n;for(var B in l)l[e](B)&&(f[B]=l[B]);if(x&&(f.path=t._getPath[n.type](n),n._.dirty=1),l.href&&(c.href=l.href),l.title&&(c.title=l.title),l.target&&(c.target=l.target),l.cursor&&(g.cursor=l.cursor),"blur"in l&&n.blur(l.blur),(l.path&&"path"==n.type||x)&&(c.path=k(~r(f.path).toLowerCase().indexOf("r")?t._pathToAbsolute(f.path):f.path),n._.dirty=1,"image"==n.type&&(n._.fillpos=[f.x,f.y],n._.fillsize=[f.width,f.height],C(n,1,1,0,0,0))),"transform"in l&&n.transform(l.transform),y){var A=+f.cx,E=+f.cy,M=+f.rx||+f.r||0,L=+f.ry||+f.r||0;c.path=t.format("ar{0},{1},{2},{3},{4},{1},{4},{1}x",a((A-M)*b),a((E-L)*b),a((A+M)*b),a((E+L)*b),a(A*b)),n._.dirty=1}if("clip-rect"in l){var z=r(l["clip-rect"]).split(u);if(4==z.length){z[2]=+z[2]+ +z[0],z[3]=+z[3]+ +z[1];var P=c.clipRect||t._g.doc.createElement("div"),F=P.style;F.clip=t.format("rect({1}px {2}px {3}px {0}px)",z),c.clipRect||(F.position="absolute",F.top=0,F.left=0,F.width=n.paper.width+"px",F.height=n.paper.height+"px",c.parentNode.insertBefore(P,c),P.appendChild(c),c.clipRect=P)}l["clip-rect"]||c.clipRect&&(c.clipRect.style.clip="auto")}if(n.textpath){var R=n.textpath.style;l.font&&(R.font=l.font),l["font-family"]&&(R.fontFamily='"'+l["font-family"].split(",")[0].replace(/^['"]+|['"]+$/g,d)+'"'),l["font-size"]&&(R.fontSize=l["font-size"]),l["font-weight"]&&(R.fontWeight=l["font-weight"]),l["font-style"]&&(R.fontStyle=l["font-style"])}if("arrow-start"in l&&S(m,l["arrow-start"]),"arrow-end"in l&&S(m,l["arrow-end"],1),null!=l.opacity||null!=l.fill||null!=l.src||null!=l.stroke||null!=l["stroke-width"]||null!=l["stroke-opacity"]||null!=l["fill-opacity"]||null!=l["stroke-dasharray"]||null!=l["stroke-miterlimit"]||null!=l["stroke-linejoin"]||null!=l["stroke-linecap"]){var j=c.getElementsByTagName(h),I=!1;if(j=j&&j[0],!j&&(I=j=N(h)),"image"==n.type&&l.src&&(j.src=l.src),l.fill&&(j.on=!0),null!=j.on&&"none"!=l.fill&&null!==l.fill||(j.on=!1),j.on&&l.fill){var q=r(l.fill).match(t._ISURL);if(q){j.parentNode==c&&c.removeChild(j),j.rotate=!0,j.src=q[1],j.type="tile";var D=n.getBBox(1);j.position=D.x+p+D.y,n._.fillpos=[D.x,D.y],t._preload(q[1],function(){n._.fillsize=[this.offsetWidth,this.offsetHeight]})}else j.color=t.getRGB(l.fill).hex,j.src=d,j.type="solid",t.getRGB(l.fill).error&&(m.type in{circle:1,ellipse:1}||"r"!=r(l.fill).charAt())&&T(m,l.fill,j)&&(f.fill="none",f.gradient=l.fill,j.rotate=!1)}if("fill-opacity"in l||"opacity"in l){var V=((+f["fill-opacity"]+1||2)-1)*((+f.opacity+1||2)-1)*((+t.getRGB(l.fill).o+1||2)-1);V=o(s(V,0),1),j.opacity=V,j.src&&(j.color="none")}c.appendChild(j);var O=c.getElementsByTagName("stroke")&&c.getElementsByTagName("stroke")[0],Y=!1;!O&&(Y=O=N("stroke")),(l.stroke&&"none"!=l.stroke||l["stroke-width"]||null!=l["stroke-opacity"]||l["stroke-dasharray"]||l["stroke-miterlimit"]||l["stroke-linejoin"]||l["stroke-linecap"])&&(O.on=!0),("none"==l.stroke||null===l.stroke||null==O.on||0==l.stroke||0==l["stroke-width"])&&(O.on=!1);var W=t.getRGB(l.stroke);O.on&&l.stroke&&(O.color=W.hex),V=((+f["stroke-opacity"]+1||2)-1)*((+f.opacity+1||2)-1)*((+W.o+1||2)-1);var G=.75*(i(l["stroke-width"])||1);if(V=o(s(V,0),1),null==l["stroke-width"]&&(G=f["stroke-width"]),l["stroke-width"]&&(O.weight=G),G&&G<1&&(V*=G)&&(O.weight=1),O.opacity=V,l["stroke-linejoin"]&&(O.joinstyle=l["stroke-linejoin"]||"miter"),O.miterlimit=l["stroke-miterlimit"]||8,l["stroke-linecap"]&&(O.endcap="butt"==l["stroke-linecap"]?"flat":"square"==l["stroke-linecap"]?"square":"round"),"stroke-dasharray"in l){var H={"-":"shortdash",".":"shortdot","-.":"shortdashdot","-..":"shortdashdotdot",". ":"dot","- ":"dash","--":"longdash","- .":"dashdot","--.":"longdashdot","--..":"longdashdotdot"};O.dashstyle=H[e](l["stroke-dasharray"])?H[l["stroke-dasharray"]]:d}Y&&c.appendChild(O)}if("text"==m.type){m.paper.canvas.style.display=d;var X=m.paper.span,U=100,$=f.font&&f.font.match(/\d+(?:\.\d*)?(?=px)/);g=X.style,f.font&&(g.font=f.font),f["font-family"]&&(g.fontFamily=f["font-family"]),f["font-weight"]&&(g.fontWeight=f["font-weight"]),f["font-style"]&&(g.fontStyle=f["font-style"]),$=i(f["font-size"]||$&&$[0])||10,g.fontSize=$*U+"px",m.textpath.string&&(X.innerHTML=r(m.textpath.string).replace(/</g,"&#60;").replace(/&/g,"&#38;").replace(/\n/g,"<br>"));var Z=X.getBoundingClientRect();m.W=f.w=(Z.right-Z.left)/U,m.H=f.h=(Z.bottom-Z.top)/U,m.X=f.x,m.Y=f.y+m.H/2,("x"in l||"y"in l)&&(m.path.v=t.format("m{0},{1}l{2},{1}",a(f.x*b),a(f.y*b),a(f.x*b)+1));for(var Q=["x","y","text","font","font-family","font-weight","font-style","font-size"],J=0,K=Q.length;J<K;J++)if(Q[J]in l){m._.dirty=1;break}switch(f["text-anchor"]){case"start":m.textpath.style["v-text-align"]="left",m.bbx=m.W/2;break;case"end":m.textpath.style["v-text-align"]="right",m.bbx=-m.W/2;break;default:m.textpath.style["v-text-align"]="center",m.bbx=0}m.textpath.style["v-text-kern"]=!0}},T=function(e,a,s){e.attrs=e.attrs||{};var o=e.attrs,l=Math.pow,h,u,c="linear",f=".5 .5";if(e.attrs.gradient=a,a=r(a).replace(t._radial_gradient,function(t,e,r){return c="radial",e&&r&&(e=i(e),r=i(r),l(e-.5,2)+l(r-.5,2)>.25&&(r=n.sqrt(.25-l(e-.5,2))*(2*(r>.5)-1)+.5),f=e+p+r),d}),a=a.split(/\s*\-\s*/),"linear"==c){var g=a.shift();if(g=-i(g),isNaN(g))return null}var v=t._parseDots(a);if(!v)return null;if(e=e.shape||e.node,v.length){e.removeChild(s),s.on=!0,s.method="none",s.color=v[0].color,s.color2=v[v.length-1].color;for(var x=[],y=0,m=v.length;y<m;y++)v[y].offset&&x.push(v[y].offset+p+v[y].color);s.colors=x.length?x.join():"0% "+s.color,"radial"==c?(s.type="gradientTitle",s.focus="100%",s.focussize="0 0",s.focusposition=f,s.angle=0):(s.type="gradient",s.angle=(270-g)%360),e.appendChild(s)}return 1},E=function(e,r){this[0]=this.node=e,e.raphael=!0,this.id=t._oid++,e.raphaelid=this.id,this.X=0,this.Y=0,this.attrs={},this.paper=r,this.matrix=t.matrix(),this._={transform:[],sx:1,sy:1,dx:0,dy:0,deg:0,dirty:1,dirtyT:1},!r.bottom&&(r.bottom=this),this.prev=r.top,r.top&&(r.top.next=this),r.top=this,this.next=null},M=t.el;E.prototype=M,M.constructor=E,M.transform=function(e){if(null==e)return this._.transform;var i=this.paper._viewBoxShift,n=i?"s"+[i.scale,i.scale]+"-1-1t"+[i.dx,i.dy]:d,a;i&&(a=e=r(e).replace(/\.{3}|\u2026/g,this._.transform||d)),t._extractTransform(this,n+e);var s=this.matrix.clone(),o=this.skew,l=this.node,h,u=~r(this.attrs.fill).indexOf("-"),c=!r(this.attrs.fill).indexOf("url(");if(s.translate(1,1),c||u||"image"==this.type)if(o.matrix="1 0 0 1",o.offset="0 0",h=s.split(),u&&h.noRotation||!h.isSimple){l.style.filter=s.toFilter();var f=this.getBBox(),g=this.getBBox(1),v=f.x-g.x,x=f.y-g.y;l.coordorigin=v*-b+p+x*-b,C(this,1,1,v,x,0)}else l.style.filter=d,C(this,h.scalex,h.scaley,h.dx,h.dy,h.rotate);else l.style.filter=d,o.matrix=r(s),o.offset=s.offset();return null!==a&&(this._.transform=a,t._extractTransform(this,a)),this},M.rotate=function(t,e,n){if(this.removed)return this;if(null!=t){if(t=r(t).split(u),t.length-1&&(e=i(t[1]),n=i(t[2])),t=i(t[0]),null==n&&(e=n),null==e||null==n){var a=this.getBBox(1);e=a.x+a.width/2,n=a.y+a.height/2}return this._.dirtyT=1,this.transform(this._.transform.concat([["r",t,e,n]])),this}},M.translate=function(t,e){return this.removed?this:(t=r(t).split(u),t.length-1&&(e=i(t[1])),t=i(t[0])||0,e=+e||0,this._.bbox&&(this._.bbox.x+=t,this._.bbox.y+=e),this.transform(this._.transform.concat([["t",t,e]])),this)},M.scale=function(t,e,n,a){if(this.removed)return this;if(t=r(t).split(u),t.length-1&&(e=i(t[1]),n=i(t[2]),a=i(t[3]),isNaN(n)&&(n=null),isNaN(a)&&(a=null)),t=i(t[0]),null==e&&(e=t),null==a&&(n=a),null==n||null==a)var s=this.getBBox(1);return n=null==n?s.x+s.width/2:n,a=null==a?s.y+s.height/2:a,this.transform(this._.transform.concat([["s",t,e,n,a]])),this._.dirtyT=1,this},M.hide=function(){return!this.removed&&(this.node.style.display="none"),this},M.show=function(){return!this.removed&&(this.node.style.display=d),this},M.auxGetBBox=t.el.getBBox,M.getBBox=function(){var t=this.auxGetBBox();if(this.paper&&this.paper._viewBoxShift){var e={},r=1/this.paper._viewBoxShift.scale;return e.x=t.x-this.paper._viewBoxShift.dx,e.x*=r,e.y=t.y-this.paper._viewBoxShift.dy,e.y*=r,e.width=t.width*r,e.height=t.height*r,e.x2=e.x+e.width,e.y2=e.y+e.height,e}return t},M._getBBox=function(){return this.removed?{}:{x:this.X+(this.bbx||0)-this.W/2,y:this.Y-this.H,width:this.W,height:this.H}},M.remove=function(){if(!this.removed&&this.node.parentNode){this.paper.__set__&&this.paper.__set__.exclude(this),t.eve.unbind("raphael.*.*."+this.id),t._tear(this,this.paper),this.node.parentNode.removeChild(this.node),this.shape&&this.shape.parentNode.removeChild(this.shape);for(var e in this)this[e]="function"==typeof this[e]?t._removedFactory(e):null;this.removed=!0}},M.attr=function(r,i){if(this.removed)return this;if(null==r){var n={};for(var a in this.attrs)this.attrs[e](a)&&(n[a]=this.attrs[a]);return n.gradient&&"none"==n.fill&&(n.fill=n.gradient)&&delete n.gradient,n.transform=this._.transform,n}if(null==i&&t.is(r,"string")){if(r==h&&"none"==this.attrs.fill&&this.attrs.gradient)return this.attrs.gradient;for(var s=r.split(u),o={},l=0,f=s.length;l<f;l++)r=s[l],r in this.attrs?o[r]=this.attrs[r]:t.is(this.paper.customAttributes[r],"function")?o[r]=this.paper.customAttributes[r].def:o[r]=t._availableAttrs[r];return f-1?o:o[s[0]]}if(this.attrs&&null==i&&t.is(r,"array")){for(o={},l=0,f=r.length;l<f;l++)o[r[l]]=this.attr(r[l]);return o}var p;null!=i&&(p={},p[r]=i),null==i&&t.is(r,"object")&&(p=r);for(var d in p)c("raphael.attr."+d+"."+this.id,this,p[d]);if(p){for(d in this.paper.customAttributes)if(this.paper.customAttributes[e](d)&&p[e](d)&&t.is(this.paper.customAttributes[d],"function")){var g=this.paper.customAttributes[d].apply(this,[].concat(p[d]));this.attrs[d]=p[d];for(var v in g)g[e](v)&&(p[v]=g[v])}p.text&&"text"==this.type&&(this.textpath.string=p.text),A(this,p)}return this},M.toFront=function(){return!this.removed&&this.node.parentNode.appendChild(this.node),this.paper&&this.paper.top!=this&&t._tofront(this,this.paper),this},M.toBack=function(){return this.removed?this:(this.node.parentNode.firstChild!=this.node&&(this.node.parentNode.insertBefore(this.node,this.node.parentNode.firstChild),t._toback(this,this.paper)),this)},M.insertAfter=function(e){return this.removed?this:(e.constructor==t.st.constructor&&(e=e[e.length-1]),e.node.nextSibling?e.node.parentNode.insertBefore(this.node,e.node.nextSibling):e.node.parentNode.appendChild(this.node),t._insertafter(this,e,this.paper),this)},M.insertBefore=function(e){return this.removed?this:(e.constructor==t.st.constructor&&(e=e[0]),e.node.parentNode.insertBefore(this.node,e.node),t._insertbefore(this,e,this.paper),this)},M.blur=function(e){var r=this.node.runtimeStyle,i=r.filter;return i=i.replace(x,d),0!==+e?(this.attrs.blur=e,r.filter=i+p+f+".Blur(pixelradius="+(+e||1.5)+")",r.margin=t.format("-{0}px 0 0 -{0}px",a(+e||1.5))):(r.filter=i,r.margin=0,delete this.attrs.blur),this},t._engine.path=function(t,e){var r=N("shape");r.style.cssText=m,r.coordsize=b+p+b,r.coordorigin=e.coordorigin;var i=new E(r,e),n={fill:"none",stroke:"#000"};t&&(n.path=t),i.type="path",i.path=[],i.Path=d,A(i,n),e.canvas&&e.canvas.appendChild(r);var a=N("skew");return a.on=!0,r.appendChild(a),i.skew=a,i.transform(d),i},t._engine.rect=function(e,r,i,n,a,s){var o=t._rectPath(r,i,n,a,s),l=e.path(o),h=l.attrs;return l.X=h.x=r,l.Y=h.y=i,l.W=h.width=n,l.H=h.height=a,h.r=s,h.path=o,l.type="rect",l},t._engine.ellipse=function(t,e,r,i,n){var a=t.path(),s=a.attrs;return a.X=e-i,a.Y=r-n,a.W=2*i,a.H=2*n,a.type="ellipse",A(a,{cx:e,cy:r,rx:i,ry:n}),a},t._engine.circle=function(t,e,r,i){var n=t.path(),a=n.attrs;return n.X=e-i,n.Y=r-i,n.W=n.H=2*i,n.type="circle",A(n,{cx:e,cy:r,r:i}),n},t._engine.image=function(e,r,i,n,a,s){var o=t._rectPath(i,n,a,s),l=e.path(o).attr({stroke:"none"}),u=l.attrs,c=l.node,f=c.getElementsByTagName(h)[0];return u.src=r,l.X=u.x=i,l.Y=u.y=n,l.W=u.width=a,l.H=u.height=s,u.path=o,l.type="image",f.parentNode==c&&c.removeChild(f),f.rotate=!0,f.src=r,f.type="tile",l._.fillpos=[i,n],l._.fillsize=[a,s],c.appendChild(f),C(l,1,1,0,0,0),l},t._engine.text=function(e,i,n,s){var o=N("shape"),l=N("path"),h=N("textpath");i=i||0,n=n||0,s=s||"",l.v=t.format("m{0},{1}l{2},{1}",a(i*b),a(n*b),a(i*b)+1),l.textpathok=!0,h.string=r(s),h.on=!0,o.style.cssText=m,o.coordsize=b+p+b,o.coordorigin="0 0";var u=new E(o,e),c={fill:"#000",stroke:"none",font:t._availableAttrs.font,text:s};u.shape=o,u.path=l,u.textpath=h,u.type="text",u.attrs.text=r(s),u.attrs.x=i,u.attrs.y=n,u.attrs.w=1,u.attrs.h=1,A(u,c),o.appendChild(h),o.appendChild(l),e.canvas.appendChild(o);var f=N("skew");return f.on=!0,o.appendChild(f),u.skew=f,u.transform(d),u},t._engine.setSize=function(e,r){var i=this.canvas.style;return this.width=e,this.height=r,e==+e&&(e+="px"),r==+r&&(r+="px"),i.width=e,i.height=r,i.clip="rect(0 "+e+" "+r+" 0)",this._viewBox&&t._engine.setViewBox.apply(this,this._viewBox),this},t._engine.setViewBox=function(e,r,i,n,a){t.eve("raphael.setViewBox",this,this._viewBox,[e,r,i,n,a]);var s=this.getSize(),o=s.width,l=s.height,h,u;return a&&(h=l/n,u=o/i,i*h<o&&(e-=(o-i*h)/2/h),n*u<l&&(r-=(l-n*u)/2/u)),this._viewBox=[e,r,i,n,!!a],this._viewBoxShift={dx:-e,dy:-r,scale:s},this.forEach(function(t){t.transform("...")}),this};var N;t._engine.initWin=function(t){var e=t.document;e.styleSheets.length<31?e.createStyleSheet().addRule(".rvml","behavior:url(#default#VML)"):e.styleSheets[0].addRule(".rvml","behavior:url(#default#VML)");try{!e.namespaces.rvml&&e.namespaces.add("rvml","urn:schemas-microsoft-com:vml"),N=function(t){return e.createElement("<rvml:"+t+' class="rvml">')}}catch(r){N=function(t){return e.createElement("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="rvml">')}}},t._engine.initWin(t._g.win),t._engine.create=function(){var e=t._getContainer.apply(0,arguments),r=e.container,i=e.height,n,a=e.width,s=e.x,o=e.y;if(!r)throw new Error("VML container not found.");var l=new t._Paper,h=l.canvas=t._g.doc.createElement("div"),u=h.style;return s=s||0,o=o||0,a=a||512,i=i||342,l.width=a,l.height=i,a==+a&&(a+="px"),i==+i&&(i+="px"),l.coordsize=1e3*b+p+1e3*b,l.coordorigin="0 0",l.span=t._g.doc.createElement("span"),l.span.style.cssText="position:absolute;left:-9999em;top:-9999em;padding:0;margin:0;line-height:1;",h.appendChild(l.span),u.cssText=t.format("top:0;left:0;width:{0};height:{1};display:inline-block;position:relative;clip:rect(0 {0} {1} 0);overflow:hidden",a,i),1==r?(t._g.doc.body.appendChild(h),u.left=s+"px",u.top=o+"px",u.position="absolute"):r.firstChild?r.insertBefore(h,r.firstChild):r.appendChild(h),l.renderfix=function(){},l},t.prototype.clear=function(){t.eve("raphael.clear",this),this.canvas.innerHTML=d,this.span=t._g.doc.createElement("span"),this.span.style.cssText="position:absolute;left:-9999em;top:-9999em;padding:0;margin:0;line-height:1;display:inline;",this.canvas.appendChild(this.span),this.bottom=this.top=null},t.prototype.remove=function(){t.eve("raphael.remove",this),this.canvas.parentNode.removeChild(this.canvas);for(var e in this)this[e]="function"==typeof this[e]?t._removedFactory(e):null;return!0};var L=t.st;for(var z in M)M[e](z)&&!L[e](z)&&(L[z]=function(t){return function(){var e=arguments;return this.forEach(function(r){r[t].apply(r,e)})}}(z))}}.apply(e,i),!(void 0!==n&&(t.exports=n))}])});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	module.exports = "3d_rotation e84d\nac_unit eb3b\naccess_alarm e190\naccess_alarms e191\naccess_time e192\naccessibility e84e\naccessible e914\naccount_balance e84f\naccount_balance_wallet e850\naccount_box e851\naccount_circle e853\nadb e60e\nadd e145\nadd_a_photo e439\nadd_alarm e193\nadd_alert e003\nadd_box e146\nadd_circle e147\nadd_circle_outline e148\nadd_location e567\nadd_shopping_cart e854\nadd_to_photos e39d\nadd_to_queue e05c\nadjust e39e\nairline_seat_flat e630\nairline_seat_flat_angled e631\nairline_seat_individual_suite e632\nairline_seat_legroom_extra e633\nairline_seat_legroom_normal e634\nairline_seat_legroom_reduced e635\nairline_seat_recline_extra e636\nairline_seat_recline_normal e637\nairplanemode_active e195\nairplanemode_inactive e194\nairplay e055\nairport_shuttle eb3c\nalarm e855\nalarm_add e856\nalarm_off e857\nalarm_on e858\nalbum e019\nall_inclusive eb3d\nall_out e90b\nandroid e859\nannouncement e85a\napps e5c3\narchive e149\narrow_back e5c4\narrow_downward e5db\narrow_drop_down e5c5\narrow_drop_down_circle e5c6\narrow_drop_up e5c7\narrow_forward e5c8\narrow_upward e5d8\nart_track e060\naspect_ratio e85b\nassessment e85c\nassignment e85d\nassignment_ind e85e\nassignment_late e85f\nassignment_return e860\nassignment_returned e861\nassignment_turned_in e862\nassistant e39f\nassistant_photo e3a0\nattach_file e226\nattach_money e227\nattachment e2bc\naudiotrack e3a1\nautorenew e863\nav_timer e01b\nbackspace e14a\nbackup e864\nbattery_alert e19c\nbattery_charging_full e1a3\nbattery_full e1a4\nbattery_std e1a5\nbattery_unknown e1a6\nbeach_access eb3e\nbeenhere e52d\nblock e14b\nbluetooth e1a7\nbluetooth_audio e60f\nbluetooth_connected e1a8\nbluetooth_disabled e1a9\nbluetooth_searching e1aa\nblur_circular e3a2\nblur_linear e3a3\nblur_off e3a4\nblur_on e3a5\nbook e865\nbookmark e866\nbookmark_border e867\nborder_all e228\nborder_bottom e229\nborder_clear e22a\nborder_color e22b\nborder_horizontal e22c\nborder_inner e22d\nborder_left e22e\nborder_outer e22f\nborder_right e230\nborder_style e231\nborder_top e232\nborder_vertical e233\nbranding_watermark e06b\nbrightness_1 e3a6\nbrightness_2 e3a7\nbrightness_3 e3a8\nbrightness_4 e3a9\nbrightness_5 e3aa\nbrightness_6 e3ab\nbrightness_7 e3ac\nbrightness_auto e1ab\nbrightness_high e1ac\nbrightness_low e1ad\nbrightness_medium e1ae\nbroken_image e3ad\nbrush e3ae\nbubble_chart e6dd\nbug_report e868\nbuild e869\nburst_mode e43c\nbusiness e0af\nbusiness_center eb3f\ncached e86a\ncake e7e9\ncall e0b0\ncall_end e0b1\ncall_made e0b2\ncall_merge e0b3\ncall_missed e0b4\ncall_missed_outgoing e0e4\ncall_received e0b5\ncall_split e0b6\ncall_to_action e06c\ncamera e3af\ncamera_alt e3b0\ncamera_enhance e8fc\ncamera_front e3b1\ncamera_rear e3b2\ncamera_roll e3b3\ncancel e5c9\ncard_giftcard e8f6\ncard_membership e8f7\ncard_travel e8f8\ncasino eb40\ncast e307\ncast_connected e308\ncenter_focus_strong e3b4\ncenter_focus_weak e3b5\nchange_history e86b\nchat e0b7\nchat_bubble e0ca\nchat_bubble_outline e0cb\ncheck e5ca\ncheck_box e834\ncheck_box_outline_blank e835\ncheck_circle e86c\nchevron_left e5cb\nchevron_right e5cc\nchild_care eb41\nchild_friendly eb42\nchrome_reader_mode e86d\nclass e86e\nclear e14c\nclear_all e0b8\nclose e5cd\nclosed_caption e01c\ncloud e2bd\ncloud_circle e2be\ncloud_done e2bf\ncloud_download e2c0\ncloud_off e2c1\ncloud_queue e2c2\ncloud_upload e2c3\ncode e86f\ncollections e3b6\ncollections_bookmark e431\ncolor_lens e3b7\ncolorize e3b8\ncomment e0b9\ncompare e3b9\ncompare_arrows e915\ncomputer e30a\nconfirmation_number e638\ncontact_mail e0d0\ncontact_phone e0cf\ncontacts e0ba\ncontent_copy e14d\ncontent_cut e14e\ncontent_paste e14f\ncontrol_point e3ba\ncontrol_point_duplicate e3bb\ncopyright e90c\ncreate e150\ncreate_new_folder e2cc\ncredit_card e870\ncrop e3be\ncrop_16_9 e3bc\ncrop_3_2 e3bd\ncrop_5_4 e3bf\ncrop_7_5 e3c0\ncrop_din e3c1\ncrop_free e3c2\ncrop_landscape e3c3\ncrop_original e3c4\ncrop_portrait e3c5\ncrop_rotate e437\ncrop_square e3c6\ndashboard e871\ndata_usage e1af\ndate_range e916\ndehaze e3c7\ndelete e872\ndelete_forever e92b\ndelete_sweep e16c\ndescription e873\ndesktop_mac e30b\ndesktop_windows e30c\ndetails e3c8\ndeveloper_board e30d\ndeveloper_mode e1b0\ndevice_hub e335\ndevices e1b1\ndevices_other e337\ndialer_sip e0bb\ndialpad e0bc\ndirections e52e\ndirections_bike e52f\ndirections_boat e532\ndirections_bus e530\ndirections_car e531\ndirections_railway e534\ndirections_run e566\ndirections_subway e533\ndirections_transit e535\ndirections_walk e536\ndisc_full e610\ndns e875\ndo_not_disturb e612\ndo_not_disturb_alt e611\ndo_not_disturb_off e643\ndo_not_disturb_on e644\ndock e30e\ndomain e7ee\ndone e876\ndone_all e877\ndonut_large e917\ndonut_small e918\ndrafts e151\ndrag_handle e25d\ndrive_eta e613\ndvr e1b2\nedit e3c9\nedit_location e568\neject e8fb\nemail e0be\nenhanced_encryption e63f\nequalizer e01d\nerror e000\nerror_outline e001\neuro_symbol e926\nev_station e56d\nevent e878\nevent_available e614\nevent_busy e615\nevent_note e616\nevent_seat e903\nexit_to_app e879\nexpand_less e5ce\nexpand_more e5cf\nexplicit e01e\nexplore e87a\nexposure e3ca\nexposure_neg_1 e3cb\nexposure_neg_2 e3cc\nexposure_plus_1 e3cd\nexposure_plus_2 e3ce\nexposure_zero e3cf\nextension e87b\nface e87c\nfast_forward e01f\nfast_rewind e020\nfavorite e87d\nfavorite_border e87e\nfeatured_play_list e06d\nfeatured_video e06e\nfeedback e87f\nfiber_dvr e05d\nfiber_manual_record e061\nfiber_new e05e\nfiber_pin e06a\nfiber_smart_record e062\nfile_download e2c4\nfile_upload e2c6\nfilter e3d3\nfilter_1 e3d0\nfilter_2 e3d1\nfilter_3 e3d2\nfilter_4 e3d4\nfilter_5 e3d5\nfilter_6 e3d6\nfilter_7 e3d7\nfilter_8 e3d8\nfilter_9 e3d9\nfilter_9_plus e3da\nfilter_b_and_w e3db\nfilter_center_focus e3dc\nfilter_drama e3dd\nfilter_frames e3de\nfilter_hdr e3df\nfilter_list e152\nfilter_none e3e0\nfilter_tilt_shift e3e2\nfilter_vintage e3e3\nfind_in_page e880\nfind_replace e881\nfingerprint e90d\nfirst_page e5dc\nfitness_center eb43\nflag e153\nflare e3e4\nflash_auto e3e5\nflash_off e3e6\nflash_on e3e7\nflight e539\nflight_land e904\nflight_takeoff e905\nflip e3e8\nflip_to_back e882\nflip_to_front e883\nfolder e2c7\nfolder_open e2c8\nfolder_shared e2c9\nfolder_special e617\nfont_download e167\nformat_align_center e234\nformat_align_justify e235\nformat_align_left e236\nformat_align_right e237\nformat_bold e238\nformat_clear e239\nformat_color_fill e23a\nformat_color_reset e23b\nformat_color_text e23c\nformat_indent_decrease e23d\nformat_indent_increase e23e\nformat_italic e23f\nformat_line_spacing e240\nformat_list_bulleted e241\nformat_list_numbered e242\nformat_paint e243\nformat_quote e244\nformat_shapes e25e\nformat_size e245\nformat_strikethrough e246\nformat_textdirection_l_to_r e247\nformat_textdirection_r_to_l e248\nformat_underlined e249\nforum e0bf\nforward e154\nforward_10 e056\nforward_30 e057\nforward_5 e058\nfree_breakfast eb44\nfullscreen e5d0\nfullscreen_exit e5d1\nfunctions e24a\ng_translate e927\ngamepad e30f\ngames e021\ngavel e90e\ngesture e155\nget_app e884\ngif e908\ngolf_course eb45\ngps_fixed e1b3\ngps_not_fixed e1b4\ngps_off e1b5\ngrade e885\ngradient e3e9\ngrain e3ea\ngraphic_eq e1b8\ngrid_off e3eb\ngrid_on e3ec\ngroup e7ef\ngroup_add e7f0\ngroup_work e886\nhd e052\nhdr_off e3ed\nhdr_on e3ee\nhdr_strong e3f1\nhdr_weak e3f2\nheadset e310\nheadset_mic e311\nhealing e3f3\nhearing e023\nhelp e887\nhelp_outline e8fd\nhigh_quality e024\nhighlight e25f\nhighlight_off e888\nhistory e889\nhome e88a\nhot_tub eb46\nhotel e53a\nhourglass_empty e88b\nhourglass_full e88c\nhttp e902\nhttps e88d\nimage e3f4\nimage_aspect_ratio e3f5\nimport_contacts e0e0\nimport_export e0c3\nimportant_devices e912\ninbox e156\nindeterminate_check_box e909\ninfo e88e\ninfo_outline e88f\ninput e890\ninsert_chart e24b\ninsert_comment e24c\ninsert_drive_file e24d\ninsert_emoticon e24e\ninsert_invitation e24f\ninsert_link e250\ninsert_photo e251\ninvert_colors e891\ninvert_colors_off e0c4\niso e3f6\nkeyboard e312\nkeyboard_arrow_down e313\nkeyboard_arrow_left e314\nkeyboard_arrow_right e315\nkeyboard_arrow_up e316\nkeyboard_backspace e317\nkeyboard_capslock e318\nkeyboard_hide e31a\nkeyboard_return e31b\nkeyboard_tab e31c\nkeyboard_voice e31d\nkitchen eb47\nlabel e892\nlabel_outline e893\nlandscape e3f7\nlanguage e894\nlaptop e31e\nlaptop_chromebook e31f\nlaptop_mac e320\nlaptop_windows e321\nlast_page e5dd\nlaunch e895\nlayers e53b\nlayers_clear e53c\nleak_add e3f8\nleak_remove e3f9\nlens e3fa\nlibrary_add e02e\nlibrary_books e02f\nlibrary_music e030\nlightbulb_outline e90f\nline_style e919\nline_weight e91a\nlinear_scale e260\nlink e157\nlinked_camera e438\nlist e896\nlive_help e0c6\nlive_tv e639\nlocal_activity e53f\nlocal_airport e53d\nlocal_atm e53e\nlocal_bar e540\nlocal_cafe e541\nlocal_car_wash e542\nlocal_convenience_store e543\nlocal_dining e556\nlocal_drink e544\nlocal_florist e545\nlocal_gas_station e546\nlocal_grocery_store e547\nlocal_hospital e548\nlocal_hotel e549\nlocal_laundry_service e54a\nlocal_library e54b\nlocal_mall e54c\nlocal_movies e54d\nlocal_offer e54e\nlocal_parking e54f\nlocal_pharmacy e550\nlocal_phone e551\nlocal_pizza e552\nlocal_play e553\nlocal_post_office e554\nlocal_printshop e555\nlocal_see e557\nlocal_shipping e558\nlocal_taxi e559\nlocation_city e7f1\nlocation_disabled e1b6\nlocation_off e0c7\nlocation_on e0c8\nlocation_searching e1b7\nlock e897\nlock_open e898\nlock_outline e899\nlooks e3fc\nlooks_3 e3fb\nlooks_4 e3fd\nlooks_5 e3fe\nlooks_6 e3ff\nlooks_one e400\nlooks_two e401\nloop e028\nloupe e402\nlow_priority e16d\nloyalty e89a\nmail e158\nmail_outline e0e1\nmap e55b\nmarkunread e159\nmarkunread_mailbox e89b\nmemory e322\nmenu e5d2\nmerge_type e252\nmessage e0c9\nmic e029\nmic_none e02a\nmic_off e02b\nmms e618\nmode_comment e253\nmode_edit e254\nmonetization_on e263\nmoney_off e25c\nmonochrome_photos e403\nmood e7f2\nmood_bad e7f3\nmore e619\nmore_horiz e5d3\nmore_vert e5d4\nmotorcycle e91b\nmouse e323\nmove_to_inbox e168\nmovie e02c\nmovie_creation e404\nmovie_filter e43a\nmultiline_chart e6df\nmusic_note e405\nmusic_video e063\nmy_location e55c\nnature e406\nnature_people e407\nnavigate_before e408\nnavigate_next e409\nnavigation e55d\nnear_me e569\nnetwork_cell e1b9\nnetwork_check e640\nnetwork_locked e61a\nnetwork_wifi e1ba\nnew_releases e031\nnext_week e16a\nnfc e1bb\nno_encryption e641\nno_sim e0cc\nnot_interested e033\nnote e06f\nnote_add e89c\nnotifications e7f4\nnotifications_active e7f7\nnotifications_none e7f5\nnotifications_off e7f6\nnotifications_paused e7f8\noffline_pin e90a\nondemand_video e63a\nopacity e91c\nopen_in_browser e89d\nopen_in_new e89e\nopen_with e89f\npages e7f9\npageview e8a0\npalette e40a\npan_tool e925\npanorama e40b\npanorama_fish_eye e40c\npanorama_horizontal e40d\npanorama_vertical e40e\npanorama_wide_angle e40f\nparty_mode e7fa\npause e034\npause_circle_filled e035\npause_circle_outline e036\npayment e8a1\npeople e7fb\npeople_outline e7fc\nperm_camera_mic e8a2\nperm_contact_calendar e8a3\nperm_data_setting e8a4\nperm_device_information e8a5\nperm_identity e8a6\nperm_media e8a7\nperm_phone_msg e8a8\nperm_scan_wifi e8a9\nperson e7fd\nperson_add e7fe\nperson_outline e7ff\nperson_pin e55a\nperson_pin_circle e56a\npersonal_video e63b\npets e91d\nphone e0cd\nphone_android e324\nphone_bluetooth_speaker e61b\nphone_forwarded e61c\nphone_in_talk e61d\nphone_iphone e325\nphone_locked e61e\nphone_missed e61f\nphone_paused e620\nphonelink e326\nphonelink_erase e0db\nphonelink_lock e0dc\nphonelink_off e327\nphonelink_ring e0dd\nphonelink_setup e0de\nphoto e410\nphoto_album e411\nphoto_camera e412\nphoto_filter e43b\nphoto_library e413\nphoto_size_select_actual e432\nphoto_size_select_large e433\nphoto_size_select_small e434\npicture_as_pdf e415\npicture_in_picture e8aa\npicture_in_picture_alt e911\npie_chart e6c4\npie_chart_outlined e6c5\npin_drop e55e\nplace e55f\nplay_arrow e037\nplay_circle_filled e038\nplay_circle_outline e039\nplay_for_work e906\nplaylist_add e03b\nplaylist_add_check e065\nplaylist_play e05f\nplus_one e800\npoll e801\npolymer e8ab\npool eb48\nportable_wifi_off e0ce\nportrait e416\npower e63c\npower_input e336\npower_settings_new e8ac\npregnant_woman e91e\npresent_to_all e0df\nprint e8ad\npriority_high e645\npublic e80b\npublish e255\nquery_builder e8ae\nquestion_answer e8af\nqueue e03c\nqueue_music e03d\nqueue_play_next e066\nradio e03e\nradio_button_checked e837\nradio_button_unchecked e836\nrate_review e560\nreceipt e8b0\nrecent_actors e03f\nrecord_voice_over e91f\nredeem e8b1\nredo e15a\nrefresh e5d5\nremove e15b\nremove_circle e15c\nremove_circle_outline e15d\nremove_from_queue e067\nremove_red_eye e417\nremove_shopping_cart e928\nreorder e8fe\nrepeat e040\nrepeat_one e041\nreplay e042\nreplay_10 e059\nreplay_30 e05a\nreplay_5 e05b\nreply e15e\nreply_all e15f\nreport e160\nreport_problem e8b2\nrestaurant e56c\nrestaurant_menu e561\nrestore e8b3\nrestore_page e929\nring_volume e0d1\nroom e8b4\nroom_service eb49\nrotate_90_degrees_ccw e418\nrotate_left e419\nrotate_right e41a\nrounded_corner e920\nrouter e328\nrowing e921\nrss_feed e0e5\nrv_hookup e642\nsatellite e562\nsave e161\nscanner e329\nschedule e8b5\nschool e80c\nscreen_lock_landscape e1be\nscreen_lock_portrait e1bf\nscreen_lock_rotation e1c0\nscreen_rotation e1c1\nscreen_share e0e2\nsd_card e623\nsd_storage e1c2\nsearch e8b6\nsecurity e32a\nselect_all e162\nsend e163\nsentiment_dissatisfied e811\nsentiment_neutral e812\nsentiment_satisfied e813\nsentiment_very_dissatisfied e814\nsentiment_very_satisfied e815\nsettings e8b8\nsettings_applications e8b9\nsettings_backup_restore e8ba\nsettings_bluetooth e8bb\nsettings_brightness e8bd\nsettings_cell e8bc\nsettings_ethernet e8be\nsettings_input_antenna e8bf\nsettings_input_component e8c0\nsettings_input_composite e8c1\nsettings_input_hdmi e8c2\nsettings_input_svideo e8c3\nsettings_overscan e8c4\nsettings_phone e8c5\nsettings_power e8c6\nsettings_remote e8c7\nsettings_system_daydream e1c3\nsettings_voice e8c8\nshare e80d\nshop e8c9\nshop_two e8ca\nshopping_basket e8cb\nshopping_cart e8cc\nshort_text e261\nshow_chart e6e1\nshuffle e043\nsignal_cellular_4_bar e1c8\nsignal_cellular_connected_no_internet_4_bar e1cd\nsignal_cellular_no_sim e1ce\nsignal_cellular_null e1cf\nsignal_cellular_off e1d0\nsignal_wifi_4_bar e1d8\nsignal_wifi_4_bar_lock e1d9\nsignal_wifi_off e1da\nsim_card e32b\nsim_card_alert e624\nskip_next e044\nskip_previous e045\nslideshow e41b\nslow_motion_video e068\nsmartphone e32c\nsmoke_free eb4a\nsmoking_rooms eb4b\nsms e625\nsms_failed e626\nsnooze e046\nsort e164\nsort_by_alpha e053\nspa eb4c\nspace_bar e256\nspeaker e32d\nspeaker_group e32e\nspeaker_notes e8cd\nspeaker_notes_off e92a\nspeaker_phone e0d2\nspellcheck e8ce\nstar e838\nstar_border e83a\nstar_half e839\nstars e8d0\nstay_current_landscape e0d3\nstay_current_portrait e0d4\nstay_primary_landscape e0d5\nstay_primary_portrait e0d6\nstop e047\nstop_screen_share e0e3\nstorage e1db\nstore e8d1\nstore_mall_directory e563\nstraighten e41c\nstreetview e56e\nstrikethrough_s e257\nstyle e41d\nsubdirectory_arrow_left e5d9\nsubdirectory_arrow_right e5da\nsubject e8d2\nsubscriptions e064\nsubtitles e048\nsubway e56f\nsupervisor_account e8d3\nsurround_sound e049\nswap_calls e0d7\nswap_horiz e8d4\nswap_vert e8d5\nswap_vertical_circle e8d6\nswitch_camera e41e\nswitch_video e41f\nsync e627\nsync_disabled e628\nsync_problem e629\nsystem_update e62a\nsystem_update_alt e8d7\ntab e8d8\ntab_unselected e8d9\ntablet e32f\ntablet_android e330\ntablet_mac e331\ntag_faces e420\ntap_and_play e62b\nterrain e564\ntext_fields e262\ntext_format e165\ntextsms e0d8\ntexture e421\ntheaters e8da\nthumb_down e8db\nthumb_up e8dc\nthumbs_up_down e8dd\ntime_to_leave e62c\ntimelapse e422\ntimeline e922\ntimer e425\ntimer_10 e423\ntimer_3 e424\ntimer_off e426\ntitle e264\ntoc e8de\ntoday e8df\ntoll e8e0\ntonality e427\ntouch_app e913\ntoys e332\ntrack_changes e8e1\ntraffic e565\ntrain e570\ntram e571\ntransfer_within_a_station e572\ntransform e428\ntranslate e8e2\ntrending_down e8e3\ntrending_flat e8e4\ntrending_up e8e5\ntune e429\nturned_in e8e6\nturned_in_not e8e7\ntv e333\nunarchive e169\nundo e166\nunfold_less e5d6\nunfold_more e5d7\nupdate e923\nusb e1e0\nverified_user e8e8\nvertical_align_bottom e258\nvertical_align_center e259\nvertical_align_top e25a\nvibration e62d\nvideo_call e070\nvideo_label e071\nvideo_library e04a\nvideocam e04b\nvideocam_off e04c\nvideogame_asset e338\nview_agenda e8e9\nview_array e8ea\nview_carousel e8eb\nview_column e8ec\nview_comfy e42a\nview_compact e42b\nview_day e8ed\nview_headline e8ee\nview_list e8ef\nview_module e8f0\nview_quilt e8f1\nview_stream e8f2\nview_week e8f3\nvignette e435\nvisibility e8f4\nvisibility_off e8f5\nvoice_chat e62e\nvoicemail e0d9\nvolume_down e04d\nvolume_mute e04e\nvolume_off e04f\nvolume_up e050\nvpn_key e0da\nvpn_lock e62f\nwallpaper e1bc\nwarning e002\nwatch e334\nwatch_later e924\nwb_auto e42c\nwb_cloudy e42d\nwb_incandescent e42e\nwb_iridescent e436\nwb_sunny e430\nwc e63d\nweb e051\nweb_asset e069\nweekend e16b\nwhatshot e80e\nwidgets e1bd\nwifi e63e\nwifi_lock e1e1\nwifi_tethering e1e2\nwork e8f9\nwrap_text e25b\nyoutube_searched_for e8fa\nzoom_in e8ff\nzoom_out e900\nzoom_out_map e56b\n"

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(724);
	
	var _addEventListener = __webpack_require__(236);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _util = __webpack_require__(1568);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElement(func) {
	  if (typeof func !== 'function' || !func) return null;
	  return func();
	}
	
	function getPoint(point) {
	  if (typeof point !== 'object' || !point) return null;
	  return point;
	}
	
	var Align = function (_Component) {
	  (0, _inherits3['default'])(Align, _Component);
	
	  function Align() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Align);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          target = _this$props.target,
	          align = _this$props.align,
	          onAlign = _this$props.onAlign;
	
	      if (!disabled && target) {
	        var source = _reactDom2['default'].findDOMNode(_this);
	
	        var result = void 0;
	        var element = getElement(target);
	        var point = getPoint(target);
	
	        if (element) {
	          result = (0, _domAlign.alignElement)(source, element, align);
	        } else if (point) {
	          result = (0, _domAlign.alignPoint)(source, point, align);
	        }
	
	        if (onAlign) {
	          onAlign(source, result);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Align.prototype.componentDidMount = function componentDidMount() {
	    var props = this.props;
	    // if parent ref not attached .... use document.getElementById
	    this.forceAlign();
	    if (!props.disabled && props.monitorWindowResize) {
	      this.startMonitorWindowResize();
	    }
	  };
	
	  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var reAlign = false;
	    var props = this.props;
	
	    if (!props.disabled) {
	      var source = _reactDom2['default'].findDOMNode(this);
	      var sourceRect = source ? source.getBoundingClientRect() : null;
	
	      if (prevProps.disabled) {
	        reAlign = true;
	      } else {
	        var lastElement = getElement(prevProps.target);
	        var currentElement = getElement(props.target);
	        var lastPoint = getPoint(prevProps.target);
	        var currentPoint = getPoint(props.target);
	
	        if ((0, _util.isWindow)(lastElement) && (0, _util.isWindow)(currentElement)) {
	          // Skip if is window
	          reAlign = false;
	        } else if (lastElement !== currentElement || // Element change
	        lastElement && !currentElement && currentPoint || // Change from element to point
	        lastPoint && currentPoint && currentElement || // Change from point to element
	        currentPoint && !(0, _util.isSamePoint)(lastPoint, currentPoint)) {
	          reAlign = true;
	        }
	
	        // If source element size changed
	        var preRect = this.sourceRect || {};
	        if (!reAlign && source && (preRect.width !== sourceRect.width || preRect.height !== sourceRect.height)) {
	          reAlign = true;
	        }
	      }
	
	      this.sourceRect = sourceRect;
	    }
	
	    if (reAlign) {
	      this.forceAlign();
	    }
	
	    if (props.monitorWindowResize && !props.disabled) {
	      this.startMonitorWindowResize();
	    } else {
	      this.stopMonitorWindowResize();
	    }
	  };
	
	  Align.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.stopMonitorWindowResize();
	  };
	
	  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
	    if (!this.resizeHandler) {
	      this.bufferMonitor = (0, _util.buffer)(this.forceAlign, this.props.monitorBufferTime);
	      this.resizeHandler = (0, _addEventListener2['default'])(window, 'resize', this.bufferMonitor);
	    }
	  };
	
	  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
	    if (this.resizeHandler) {
	      this.bufferMonitor.clear();
	      this.resizeHandler.remove();
	      this.resizeHandler = null;
	    }
	  };
	
	  Align.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        childrenProps = _props.childrenProps,
	        children = _props.children;
	
	    var child = _react2['default'].Children.only(children);
	    if (childrenProps) {
	      var newProps = {};
	      var propList = Object.keys(childrenProps);
	      propList.forEach(function (prop) {
	        newProps[prop] = _this2.props[childrenProps[prop]];
	      });
	
	      return _react2['default'].cloneElement(child, newProps);
	    }
	    return child;
	  };
	
	  return Align;
	}(_react.Component);
	
	Align.propTypes = {
	  childrenProps: _propTypes2['default'].object,
	  align: _propTypes2['default'].object.isRequired,
	  target: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].shape({
	    clientX: _propTypes2['default'].number,
	    clientY: _propTypes2['default'].number,
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })]),
	  onAlign: _propTypes2['default'].func,
	  monitorBufferTime: _propTypes2['default'].number,
	  monitorWindowResize: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any
	};
	Align.defaultProps = {
	  target: function target() {
	    return window;
	  },
	  monitorBufferTime: 50,
	  monitorWindowResize: false,
	  disabled: false
	};
	exports['default'] = Align;
	module.exports = exports['default'];

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Align = __webpack_require__(1566);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Align2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.buffer = buffer;
	exports.isSamePoint = isSamePoint;
	exports.isWindow = isWindow;
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;
	
	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }
	
	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }
	
	  return false;
	}
	
	function isWindow(obj) {
	  return obj && typeof obj === 'object' && obj.window === obj;
	}

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(715);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(533);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.genCSSMotion = genCSSMotion;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(1662);
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _raf = __webpack_require__(1563);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _motion = __webpack_require__(1572);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var STATUS_NONE = 'none';
	var STATUS_APPEAR = 'appear';
	var STATUS_ENTER = 'enter';
	var STATUS_LEAVE = 'leave';
	
	/**
	 * `transitionSupport` is used for none transition test case.
	 * Default we use browser transition event support check.
	 */
	function genCSSMotion(transitionSupport) {
	  function isSupportTransition(props) {
	    return !!(props.motionName && transitionSupport);
	  }
	
	  var CSSMotion = function (_React$Component) {
	    (0, _inherits3['default'])(CSSMotion, _React$Component);
	
	    function CSSMotion() {
	      (0, _classCallCheck3['default'])(this, CSSMotion);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));
	
	      _this.onDomUpdate = function () {
	        var _this$state = _this.state,
	            status = _this$state.status,
	            newStatus = _this$state.newStatus;
	        var _this$props = _this.props,
	            onAppearStart = _this$props.onAppearStart,
	            onEnterStart = _this$props.onEnterStart,
	            onLeaveStart = _this$props.onLeaveStart,
	            onAppearActive = _this$props.onAppearActive,
	            onEnterActive = _this$props.onEnterActive,
	            onLeaveActive = _this$props.onLeaveActive,
	            motionAppear = _this$props.motionAppear,
	            motionEnter = _this$props.motionEnter,
	            motionLeave = _this$props.motionLeave;
	
	
	        if (!isSupportTransition(_this.props)) {
	          return;
	        }
	
	        // Event injection
	        var $ele = _reactDom2['default'].findDOMNode(_this);
	        if (_this.$ele !== $ele) {
	          _this.removeEventListener(_this.$ele);
	          _this.addEventListener($ele);
	          _this.$ele = $ele;
	        }
	
	        // Init status
	        if (newStatus && status === STATUS_APPEAR && motionAppear) {
	          _this.updateStatus(onAppearStart, null, null, function () {
	            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
	          });
	        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
	          _this.updateStatus(onEnterStart, null, null, function () {
	            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
	          });
	        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
	          _this.updateStatus(onLeaveStart, null, null, function () {
	            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
	          });
	        }
	      };
	
	      _this.onMotionEnd = function (event) {
	        var _this$state2 = _this.state,
	            status = _this$state2.status,
	            statusActive = _this$state2.statusActive;
	        var _this$props2 = _this.props,
	            onAppearEnd = _this$props2.onAppearEnd,
	            onEnterEnd = _this$props2.onEnterEnd,
	            onLeaveEnd = _this$props2.onLeaveEnd;
	
	        if (status === STATUS_APPEAR && statusActive) {
	          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_ENTER && statusActive) {
	          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_LEAVE && statusActive) {
	          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
	        }
	      };
	
	      _this.addEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.addEventListener(_motion.transitionEndName, _this.onMotionEnd);
	        $ele.addEventListener(_motion.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.removeEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.removeEventListener(_motion.transitionEndName, _this.onMotionEnd);
	        $ele.removeEventListener(_motion.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
	        var statusStyle = styleFunc ? styleFunc(_reactDom2['default'].findDOMNode(_this), event) : null;
	
	        if (statusStyle === false || _this._destroyed) return;
	
	        var nextStep = void 0;
	        if (callback) {
	          nextStep = function nextStep() {
	            _this.nextFrame(callback);
	          };
	        }
	
	        _this.setState((0, _extends3['default'])({
	          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
	          newStatus: false
	        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
	      };
	
	      _this.updateActiveStatus = function (styleFunc, currentStatus) {
	        // `setState` use `postMessage` to trigger at the end of frame.
	        // Let's use requestAnimationFrame to update new state in next frame.
	        _this.nextFrame(function () {
	          var status = _this.state.status;
	
	          if (status !== currentStatus) return;
	
	          _this.updateStatus(styleFunc, { statusActive: true });
	        });
	      };
	
	      _this.nextFrame = function (func) {
	        _this.cancelNextFrame();
	        _this.raf = (0, _raf2['default'])(func);
	      };
	
	      _this.cancelNextFrame = function () {
	        if (_this.raf) {
	          _raf2['default'].cancel(_this.raf);
	          _this.raf = null;
	        }
	      };
	
	      _this.state = {
	        status: STATUS_NONE,
	        statusActive: false,
	        newStatus: false,
	        statusStyle: null
	      };
	      _this.$ele = null;
	      _this.raf = null;
	      return _this;
	    }
	
	    (0, _createClass3['default'])(CSSMotion, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._destroyed = true;
	        this.removeEventListener(this.$ele);
	        this.cancelNextFrame();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classNames;
	
	        var _state = this.state,
	            status = _state.status,
	            statusActive = _state.statusActive,
	            statusStyle = _state.statusStyle;
	        var _props = this.props,
	            children = _props.children,
	            motionName = _props.motionName,
	            visible = _props.visible,
	            removeOnLeave = _props.removeOnLeave;
	
	
	        if (!children) return null;
	
	        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
	          return visible || !removeOnLeave ? children({}) : null;
	        }
	
	        return children({
	          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status), status !== STATUS_NONE), (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status + '-active'), status !== STATUS_NONE && statusActive), (0, _defineProperty3['default'])(_classNames, motionName, typeof motionName === 'string'), _classNames)),
	          style: statusStyle
	        });
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(props, _ref) {
	        var prevProps = _ref.prevProps;
	
	        if (!isSupportTransition(props)) return {};
	
	        var visible = props.visible,
	            motionAppear = props.motionAppear,
	            motionEnter = props.motionEnter,
	            motionLeave = props.motionLeave,
	            motionLeaveImmediately = props.motionLeaveImmediately;
	
	        var newState = {
	          prevProps: props
	        };
	
	        // Appear
	        if (!prevProps && visible && motionAppear) {
	          newState.status = STATUS_APPEAR;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Enter
	        if (prevProps && !prevProps.visible && visible && motionEnter) {
	          newState.status = STATUS_ENTER;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Leave
	        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
	          newState.status = STATUS_LEAVE;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        return newState;
	      }
	    }]);
	    return CSSMotion;
	  }(_react2['default'].Component);
	
	  CSSMotion.propTypes = {
	    visible: _propTypes2['default'].bool,
	    children: _propTypes2['default'].func,
	    motionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    motionAppear: _propTypes2['default'].bool,
	    motionEnter: _propTypes2['default'].bool,
	    motionLeave: _propTypes2['default'].bool,
	    motionLeaveImmediately: _propTypes2['default'].bool, // Trigger leave motion immediately
	    removeOnLeave: _propTypes2['default'].bool,
	    onAppearStart: _propTypes2['default'].func,
	    onAppearActive: _propTypes2['default'].func,
	    onAppearEnd: _propTypes2['default'].func,
	    onEnterStart: _propTypes2['default'].func,
	    onEnterActive: _propTypes2['default'].func,
	    onEnterEnd: _propTypes2['default'].func,
	    onLeaveStart: _propTypes2['default'].func,
	    onLeaveActive: _propTypes2['default'].func,
	    onLeaveEnd: _propTypes2['default'].func
	  };
	  CSSMotion.defaultProps = {
	    visible: true,
	    motionEnter: true,
	    motionAppear: true,
	    motionLeave: true,
	    removeOnLeave: true
	  };
	
	
	  (0, _reactLifecyclesCompat.polyfill)(CSSMotion);
	
	  return CSSMotion;
	}
	
	exports['default'] = genCSSMotion(_motion.supportTransition);

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVendorPrefixes = getVendorPrefixes;
	exports.getVendorPrefixedEventName = getVendorPrefixedEventName;
	exports.getTransitionName = getTransitionName;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// ================= Transition =================
	// Event wrapper. Copy from react source code
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	function getVendorPrefixes(domSupport, win) {
	  var prefixes = {
	    animationend: makePrefixMap('Animation', 'AnimationEnd'),
	    transitionend: makePrefixMap('Transition', 'TransitionEnd')
	  };
	
	  if (domSupport) {
	    if (!('AnimationEvent' in win)) {
	      delete prefixes.animationend.animation;
	    }
	
	    if (!('TransitionEvent' in win)) {
	      delete prefixes.transitionend.transition;
	    }
	  }
	
	  return prefixes;
	}
	
	var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});
	
	var style = {};
	
	if (canUseDOM) {
	  style = document.createElement('div').style;
	}
	
	var prefixedEventNames = {};
	
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  if (prefixMap) {
	    var stylePropList = Object.keys(prefixMap);
	    var len = stylePropList.length;
	    for (var i = 0; i < len; i += 1) {
	      var styleProp = stylePropList[i];
	      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
	        prefixedEventNames[eventName] = prefixMap[styleProp];
	        return prefixedEventNames[eventName];
	      }
	    }
	  }
	
	  return '';
	}
	
	var animationEndName = exports.animationEndName = getVendorPrefixedEventName('animationend');
	var transitionEndName = exports.transitionEndName = getVendorPrefixedEventName('transitionend');
	var supportTransition = exports.supportTransition = !!(animationEndName && transitionEndName);
	
	function getTransitionName(transitionName, transitionType) {
	  if (!transitionName) return null;
	
	  if (typeof transitionName === 'object') {
	    var type = transitionType.replace(/-\w/g, function (match) {
	      return match[1].toUpperCase();
	    });
	    return transitionName[type];
	  }
	
	  return transitionName + '-' + transitionType;
	}

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(65);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DOMWrap = (0, _createReactClass2['default'])({
	  displayName: 'DOMWrap',
	
	  propTypes: {
	    tag: _propTypes2['default'].string,
	    hiddenClassName: _propTypes2['default'].string,
	    visible: _propTypes2['default'].bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      tag: 'div'
	    };
	  },
	  render: function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	    if (!props.visible) {
	      props.className = props.className || '';
	      props.className += ' ' + props.hiddenClassName;
	    }
	    var Tag = props.tag;
	    delete props.tag;
	    delete props.hiddenClassName;
	    delete props.visible;
	    return _react2['default'].createElement(Tag, props);
	  }
	});
	
	exports['default'] = DOMWrap;
	module.exports = exports['default'];

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(65);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Divider = (0, _createReactClass2['default'])({
	  displayName: 'Divider',
	
	  propTypes: {
	    disabled: _propTypes2['default'].bool,
	    className: _propTypes2['default'].string,
	    rootPrefixCls: _propTypes2['default'].string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: true
	    };
	  },
	  render: function render() {
	    var _props = this.props,
	        _props$className = _props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        rootPrefixCls = _props.rootPrefixCls;
	
	    return _react2['default'].createElement('li', { className: className + ' ' + rootPrefixCls + '-item-divider' });
	  }
	});
	
	exports['default'] = Divider;
	module.exports = exports['default'];

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(65);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _MenuMixin = __webpack_require__(534);
	
	var _MenuMixin2 = _interopRequireDefault(_MenuMixin);
	
	var _util = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// import React from 'react';
	var Menu = (0, _createReactClass2['default'])({
	  displayName: 'Menu',
	
	  propTypes: {
	    openSubMenuOnMouseEnter: _propTypes2['default'].bool,
	    closeSubMenuOnMouseLeave: _propTypes2['default'].bool,
	    selectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    defaultSelectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    defaultOpenKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    openKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    mode: _propTypes2['default'].string,
	    onClick: _propTypes2['default'].func,
	    onSelect: _propTypes2['default'].func,
	    onDeselect: _propTypes2['default'].func,
	    onDestroy: _propTypes2['default'].func,
	    openTransitionName: _propTypes2['default'].string,
	    openAnimation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    level: _propTypes2['default'].number,
	    eventKey: _propTypes2['default'].string,
	    selectable: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any
	  },
	
	  mixins: [_MenuMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      openSubMenuOnMouseEnter: true,
	      closeSubMenuOnMouseLeave: true,
	      selectable: true,
	      onClick: _util.noop,
	      onSelect: _util.noop,
	      onOpenChange: _util.noop,
	      onDeselect: _util.noop,
	      defaultSelectedKeys: [],
	      defaultOpenKeys: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var selectedKeys = props.defaultSelectedKeys;
	    var openKeys = props.defaultOpenKeys;
	    if ('selectedKeys' in props) {
	      selectedKeys = props.selectedKeys || [];
	    }
	    if ('openKeys' in props) {
	      openKeys = props.openKeys || [];
	    }
	    return {
	      selectedKeys: selectedKeys,
	      openKeys: openKeys
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var props = {};
	    if ('selectedKeys' in nextProps) {
	      props.selectedKeys = nextProps.selectedKeys || [];
	    }
	    if ('openKeys' in nextProps) {
	      props.openKeys = nextProps.openKeys || [];
	    }
	    this.setState(props);
	  },
	  onDestroy: function onDestroy(key) {
	    var state = this.state;
	    var props = this.props;
	    var selectedKeys = state.selectedKeys;
	    var openKeys = state.openKeys;
	    var index = selectedKeys.indexOf(key);
	    if (!('selectedKeys' in props) && index !== -1) {
	      selectedKeys.splice(index, 1);
	    }
	    index = openKeys.indexOf(key);
	    if (!('openKeys' in props) && index !== -1) {
	      openKeys.splice(index, 1);
	    }
	  },
	  onItemHover: function onItemHover(e) {
	    var item = e.item;
	    var _props = this.props,
	        mode = _props.mode,
	        closeSubMenuOnMouseLeave = _props.closeSubMenuOnMouseLeave;
	    var _e$openChanges = e.openChanges,
	        openChanges = _e$openChanges === undefined ? [] : _e$openChanges;
	    // special for top sub menu
	
	    if (mode !== 'inline' && !closeSubMenuOnMouseLeave && item.isSubMenu) {
	      var activeKey = this.state.activeKey;
	      var activeItem = this.getFlatInstanceArray().filter(function (c) {
	        return c && c.props.eventKey === activeKey;
	      })[0];
	      if (activeItem && activeItem.props.open) {
	        openChanges = openChanges.concat({
	          key: item.props.eventKey,
	          item: item,
	          originalEvent: e,
	          open: true
	        });
	      }
	    }
	    openChanges = openChanges.concat(this.getOpenChangesOnItemHover(e));
	    if (openChanges.length) {
	      this.onOpenChange(openChanges);
	    }
	  },
	  onSelect: function onSelect(selectInfo) {
	    var props = this.props;
	    if (props.selectable) {
	      // root menu
	      var selectedKeys = this.state.selectedKeys;
	      var selectedKey = selectInfo.key;
	      if (props.multiple) {
	        selectedKeys = selectedKeys.concat([selectedKey]);
	      } else {
	        selectedKeys = [selectedKey];
	      }
	      if (!('selectedKeys' in props)) {
	        this.setState({
	          selectedKeys: selectedKeys
	        });
	      }
	      props.onSelect((0, _extends3['default'])({}, selectInfo, {
	        selectedKeys: selectedKeys
	      }));
	    }
	  },
	  onClick: function onClick(e) {
	    this.props.onClick(e);
	  },
	  onOpenChange: function onOpenChange(e_) {
	    var props = this.props;
	    var openKeys = this.state.openKeys.concat();
	    var changed = false;
	    var processSingle = function processSingle(e) {
	      var oneChanged = false;
	      if (e.open) {
	        oneChanged = openKeys.indexOf(e.key) === -1;
	        if (oneChanged) {
	          openKeys.push(e.key);
	        }
	      } else {
	        var index = openKeys.indexOf(e.key);
	        oneChanged = index !== -1;
	        if (oneChanged) {
	          openKeys.splice(index, 1);
	        }
	      }
	      changed = changed || oneChanged;
	    };
	    if (Array.isArray(e_)) {
	      // batch change call
	      e_.forEach(processSingle);
	    } else {
	      processSingle(e_);
	    }
	    if (changed) {
	      if (!('openKeys' in this.props)) {
	        this.setState({ openKeys: openKeys });
	      }
	      props.onOpenChange(openKeys);
	    }
	  },
	  onDeselect: function onDeselect(selectInfo) {
	    var props = this.props;
	    if (props.selectable) {
	      var selectedKeys = this.state.selectedKeys.concat();
	      var selectedKey = selectInfo.key;
	      var index = selectedKeys.indexOf(selectedKey);
	      if (index !== -1) {
	        selectedKeys.splice(index, 1);
	      }
	      if (!('selectedKeys' in props)) {
	        this.setState({
	          selectedKeys: selectedKeys
	        });
	      }
	      props.onDeselect((0, _extends3['default'])({}, selectInfo, {
	        selectedKeys: selectedKeys
	      }));
	    }
	  },
	  getOpenTransitionName: function getOpenTransitionName() {
	    var props = this.props;
	    var transitionName = props.openTransitionName;
	    var animationName = props.openAnimation;
	    if (!transitionName && typeof animationName === 'string') {
	      transitionName = props.prefixCls + '-open-' + animationName;
	    }
	    return transitionName;
	  },
	  isInlineMode: function isInlineMode() {
	    return this.props.mode === 'inline';
	  },
	  lastOpenSubMenu: function lastOpenSubMenu() {
	    var lastOpen = [];
	    var openKeys = this.state.openKeys;
	
	    if (openKeys.length) {
	      lastOpen = this.getFlatInstanceArray().filter(function (c) {
	        return c && openKeys.indexOf(c.props.eventKey) !== -1;
	      });
	    }
	    return lastOpen[0];
	  },
	  renderMenuItem: function renderMenuItem(c, i, subIndex) {
	    if (!c) {
	      return null;
	    }
	    var state = this.state;
	    var extraProps = {
	      openKeys: state.openKeys,
	      selectedKeys: state.selectedKeys,
	      openSubMenuOnMouseEnter: this.props.openSubMenuOnMouseEnter
	    };
	    return this.renderCommonMenuItem(c, i, subIndex, extraProps);
	  },
	  render: function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	    props.className += ' ' + props.prefixCls + '-root';
	    return this.renderRoot(props);
	  }
	});
	
	exports['default'] = Menu;
	module.exports = exports['default'];

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(65);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _KeyCode = __webpack_require__(115);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _util = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint react/no-is-mounted:0 */
	
	var MenuItem = (0, _createReactClass2['default'])({
	  displayName: 'MenuItem',
	
	  propTypes: {
	    rootPrefixCls: _propTypes2['default'].string,
	    eventKey: _propTypes2['default'].string,
	    active: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any,
	    selectedKeys: _propTypes2['default'].array,
	    disabled: _propTypes2['default'].bool,
	    title: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func,
	    onClick: _propTypes2['default'].func,
	    onDeselect: _propTypes2['default'].func,
	    parentMenu: _propTypes2['default'].object,
	    onItemHover: _propTypes2['default'].func,
	    onDestroy: _propTypes2['default'].func,
	    onMouseEnter: _propTypes2['default'].func,
	    onMouseLeave: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: _util.noop,
	      onMouseEnter: _util.noop,
	      onMouseLeave: _util.noop
	    };
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var props = this.props;
	    if (props.onDestroy) {
	      props.onDestroy(props.eventKey);
	    }
	    if (props.parentMenu.menuItemInstance === this) {
	      this.clearMenuItemMouseLeaveTimer();
	    }
	  },
	  onKeyDown: function onKeyDown(e) {
	    var keyCode = e.keyCode;
	    if (keyCode === _KeyCode2['default'].ENTER) {
	      this.onClick(e);
	      return true;
	    }
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    var _this = this;
	
	    var props = this.props;
	    var eventKey = props.eventKey,
	        parentMenu = props.parentMenu;
	
	    parentMenu.menuItemInstance = this;
	    parentMenu.menuItemMouseLeaveFn = function () {
	      if (props.active) {
	        props.onItemHover({
	          key: eventKey,
	          item: _this,
	          hover: false,
	          domEvent: e,
	          trigger: 'mouseleave'
	        });
	      }
	    };
	    parentMenu.menuItemMouseLeaveTimer = setTimeout(parentMenu.menuItemMouseLeaveFn, 30);
	    props.onMouseLeave({
	      key: eventKey,
	      domEvent: e
	    });
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    var props = this.props;
	    var eventKey = props.eventKey,
	        parentMenu = props.parentMenu;
	
	    this.clearMenuItemMouseLeaveTimer();
	    if (parentMenu.subMenuInstance) {
	      parentMenu.subMenuInstance.clearSubMenuTimers();
	    }
	    props.onItemHover({
	      key: eventKey,
	      item: this,
	      hover: true,
	      domEvent: e,
	      trigger: 'mouseenter'
	    });
	    props.onMouseEnter({
	      key: eventKey,
	      domEvent: e
	    });
	  },
	  onClick: function onClick(e) {
	    var props = this.props;
	    var selected = this.isSelected();
	    var eventKey = props.eventKey;
	    var info = {
	      key: eventKey,
	      keyPath: [eventKey],
	      item: this,
	      domEvent: e
	    };
	    props.onClick(info);
	    if (props.multiple) {
	      if (selected) {
	        props.onDeselect(info);
	      } else {
	        props.onSelect(info);
	      }
	    } else if (!selected) {
	      props.onSelect(info);
	    }
	  },
	  getPrefixCls: function getPrefixCls() {
	    return this.props.rootPrefixCls + '-item';
	  },
	  getActiveClassName: function getActiveClassName() {
	    return this.getPrefixCls() + '-active';
	  },
	  getSelectedClassName: function getSelectedClassName() {
	    return this.getPrefixCls() + '-selected';
	  },
	  getDisabledClassName: function getDisabledClassName() {
	    return this.getPrefixCls() + '-disabled';
	  },
	  clearMenuItemMouseLeaveTimer: function clearMenuItemMouseLeaveTimer() {
	    var props = this.props;
	    var parentMenu = props.parentMenu;
	    if (parentMenu.menuItemMouseLeaveTimer) {
	      clearTimeout(parentMenu.menuItemMouseLeaveTimer);
	      parentMenu.menuItemMouseLeaveTimer = null;
	      parentMenu.menuItemMouseLeaveFn = null;
	    }
	  },
	  isSelected: function isSelected() {
	    return this.props.selectedKeys.indexOf(this.props.eventKey) !== -1;
	  },
	  render: function render() {
	    var props = this.props;
	    var selected = this.isSelected();
	    var classes = {};
	    classes[this.getActiveClassName()] = !props.disabled && props.active;
	    classes[this.getSelectedClassName()] = selected;
	    classes[this.getDisabledClassName()] = props.disabled;
	    classes[this.getPrefixCls()] = true;
	    classes[props.className] = !!props.className;
	    var attrs = (0, _extends3['default'])({}, props.attribute, {
	      title: props.title,
	      className: (0, _classnames2['default'])(classes),
	      role: 'menuitem',
	      'aria-selected': selected,
	      'aria-disabled': props.disabled
	    });
	    var mouseEvent = {};
	    if (!props.disabled) {
	      mouseEvent = {
	        onClick: this.onClick,
	        onMouseLeave: this.onMouseLeave,
	        onMouseEnter: this.onMouseEnter
	      };
	    }
	    var style = (0, _extends3['default'])({}, props.style);
	    if (props.mode === 'inline') {
	      style.paddingLeft = props.inlineIndent * props.level;
	    }
	    return _react2['default'].createElement(
	      'li',
	      (0, _extends3['default'])({
	        style: style
	      }, attrs, mouseEvent),
	      props.children
	    );
	  }
	});
	
	MenuItem.isMenuItem = 1;
	
	exports['default'] = MenuItem;
	module.exports = exports['default'];

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(65);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MenuItemGroup = (0, _createReactClass2['default'])({
	  displayName: 'MenuItemGroup',
	
	  propTypes: {
	    renderMenuItem: _propTypes2['default'].func,
	    index: _propTypes2['default'].number,
	    className: _propTypes2['default'].string,
	    rootPrefixCls: _propTypes2['default'].string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: true
	    };
	  },
	  renderInnerMenuItem: function renderInnerMenuItem(item, subIndex) {
	    var _props = this.props,
	        renderMenuItem = _props.renderMenuItem,
	        index = _props.index;
	
	    return renderMenuItem(item, index, subIndex);
	  },
	  render: function render() {
	    var props = this.props;
	    var _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        rootPrefixCls = props.rootPrefixCls;
	
	    var titleClassName = rootPrefixCls + '-item-group-title';
	    var listClassName = rootPrefixCls + '-item-group-list';
	    return _react2['default'].createElement(
	      'li',
	      { className: className + ' ' + rootPrefixCls + '-item-group' },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: titleClassName,
	          title: typeof props.title === 'string' ? props.title : undefined
	        },
	        props.title
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: listClassName },
	        _react2['default'].Children.map(props.children, this.renderInnerMenuItem)
	      )
	    );
	  }
	});
	
	MenuItemGroup.isMenuItemGroup = true;
	
	exports['default'] = MenuItemGroup;
	module.exports = exports['default'];

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(65);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _SubPopupMenu = __webpack_require__(1580);
	
	var _SubPopupMenu2 = _interopRequireDefault(_SubPopupMenu);
	
	var _KeyCode = __webpack_require__(115);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _util = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var guid = 0;
	
	/* eslint react/no-is-mounted:0 */
	
	var SubMenu = (0, _createReactClass2['default'])({
	  displayName: 'SubMenu',
	
	  propTypes: {
	    parentMenu: _propTypes2['default'].object,
	    title: _propTypes2['default'].node,
	    children: _propTypes2['default'].any,
	    selectedKeys: _propTypes2['default'].array,
	    openKeys: _propTypes2['default'].array,
	    onClick: _propTypes2['default'].func,
	    onOpenChange: _propTypes2['default'].func,
	    rootPrefixCls: _propTypes2['default'].string,
	    eventKey: _propTypes2['default'].string,
	    multiple: _propTypes2['default'].bool,
	    active: _propTypes2['default'].bool,
	    onSelect: _propTypes2['default'].func,
	    closeSubMenuOnMouseLeave: _propTypes2['default'].bool,
	    openSubMenuOnMouseEnter: _propTypes2['default'].bool,
	    onDeselect: _propTypes2['default'].func,
	    onDestroy: _propTypes2['default'].func,
	    onItemHover: _propTypes2['default'].func,
	    onMouseEnter: _propTypes2['default'].func,
	    onMouseLeave: _propTypes2['default'].func,
	    onTitleMouseEnter: _propTypes2['default'].func,
	    onTitleMouseLeave: _propTypes2['default'].func,
	    onTitleClick: _propTypes2['default'].func
	  },
	
	  mixins: [__webpack_require__(1579)],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onMouseEnter: _util.noop,
	      onMouseLeave: _util.noop,
	      onTitleMouseEnter: _util.noop,
	      onTitleMouseLeave: _util.noop,
	      onTitleClick: _util.noop,
	      title: ''
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.isSubMenu = 1;
	    return {
	      defaultActiveFirst: false
	    };
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props = this.props,
	        onDestroy = _props.onDestroy,
	        eventKey = _props.eventKey,
	        parentMenu = _props.parentMenu;
	
	    if (onDestroy) {
	      onDestroy(eventKey);
	    }
	    if (parentMenu.subMenuInstance === this) {
	      this.clearSubMenuTimers();
	    }
	  },
	  onDestroy: function onDestroy(key) {
	    this.props.onDestroy(key);
	  },
	  onKeyDown: function onKeyDown(e) {
	    var keyCode = e.keyCode;
	    var menu = this.menuInstance;
	    var isOpen = this.isOpen();
	
	    if (keyCode === _KeyCode2['default'].ENTER) {
	      this.onTitleClick(e);
	      this.setState({
	        defaultActiveFirst: true
	      });
	      return true;
	    }
	
	    if (keyCode === _KeyCode2['default'].RIGHT) {
	      if (isOpen) {
	        menu.onKeyDown(e);
	      } else {
	        this.triggerOpenChange(true);
	        this.setState({
	          defaultActiveFirst: true
	        });
	      }
	      return true;
	    }
	    if (keyCode === _KeyCode2['default'].LEFT) {
	      var handled = void 0;
	      if (isOpen) {
	        handled = menu.onKeyDown(e);
	      } else {
	        return undefined;
	      }
	      if (!handled) {
	        this.triggerOpenChange(false);
	        handled = true;
	      }
	      return handled;
	    }
	
	    if (isOpen && (keyCode === _KeyCode2['default'].UP || keyCode === _KeyCode2['default'].DOWN)) {
	      return menu.onKeyDown(e);
	    }
	  },
	  onOpenChange: function onOpenChange(e) {
	    this.props.onOpenChange(e);
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    var props = this.props;
	    this.clearSubMenuLeaveTimer();
	    props.onMouseEnter({
	      key: props.eventKey,
	      domEvent: e
	    });
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    var _this = this;
	
	    var props = this.props;
	    var parentMenu = props.parentMenu,
	        eventKey = props.eventKey;
	
	    parentMenu.subMenuInstance = this;
	    parentMenu.subMenuLeaveFn = function () {
	      // leave whole sub tree
	      // still active
	      if (props.mode !== 'inline') {
	        var isOpen = _this.isOpen();
	        if (isOpen && props.closeSubMenuOnMouseLeave && props.active) {
	          props.onItemHover({
	            key: eventKey,
	            item: _this,
	            hover: false,
	            trigger: 'mouseleave',
	            openChanges: [{
	              key: eventKey,
	              item: _this,
	              trigger: 'mouseleave',
	              open: false
	            }]
	          });
	        } else {
	          if (props.active) {
	            props.onItemHover({
	              key: eventKey,
	              item: _this,
	              hover: false,
	              trigger: 'mouseleave'
	            });
	          }
	          if (isOpen && props.closeSubMenuOnMouseLeave) {
	            _this.triggerOpenChange(false);
	          }
	        }
	      }
	      // trigger mouseleave
	      props.onMouseLeave({
	        key: eventKey,
	        domEvent: e
	      });
	    };
	    // prevent popup menu and submenu gap
	    parentMenu.subMenuLeaveTimer = setTimeout(parentMenu.subMenuLeaveFn, 100);
	  },
	  onTitleMouseEnter: function onTitleMouseEnter(domEvent) {
	    var props = this.props;
	    var parentMenu = props.parentMenu,
	        key = props.eventKey;
	
	    var item = this;
	    this.clearSubMenuTitleLeaveTimer();
	    if (parentMenu.menuItemInstance) {
	      parentMenu.menuItemInstance.clearMenuItemMouseLeaveTimer();
	    }
	    var openChanges = [];
	    if (props.openSubMenuOnMouseEnter) {
	      openChanges.push({
	        key: key,
	        item: item,
	        trigger: 'mouseenter',
	        open: true
	      });
	    }
	    props.onItemHover({
	      key: key,
	      item: item,
	      hover: true,
	      trigger: 'mouseenter',
	      openChanges: openChanges
	    });
	    this.setState({
	      defaultActiveFirst: false
	    });
	    props.onTitleMouseEnter({
	      key: key,
	      domEvent: domEvent
	    });
	  },
	  onTitleMouseLeave: function onTitleMouseLeave(e) {
	    var _this2 = this;
	
	    var props = this.props;
	    var parentMenu = props.parentMenu,
	        eventKey = props.eventKey;
	
	    parentMenu.subMenuInstance = this;
	    parentMenu.subMenuTitleLeaveFn = function () {
	      // leave whole sub tree
	      // still active
	      if (props.mode === 'inline' && props.active) {
	        props.onItemHover({
	          key: eventKey,
	          item: _this2,
	          hover: false,
	          trigger: 'mouseleave'
	        });
	      }
	      props.onTitleMouseLeave({
	        key: props.eventKey,
	        domEvent: e
	      });
	    };
	    parentMenu.subMenuTitleLeaveTimer = setTimeout(parentMenu.subMenuTitleLeaveFn, 100);
	  },
	  onTitleClick: function onTitleClick(e) {
	    var props = this.props;
	
	    props.onTitleClick({
	      key: props.eventKey,
	      domEvent: e
	    });
	    if (props.openSubMenuOnMouseEnter) {
	      return;
	    }
	    this.triggerOpenChange(!this.isOpen(), 'click');
	    this.setState({
	      defaultActiveFirst: false
	    });
	  },
	  onSubMenuClick: function onSubMenuClick(info) {
	    this.props.onClick(this.addKeyPath(info));
	  },
	  onSelect: function onSelect(info) {
	    this.props.onSelect(info);
	  },
	  onDeselect: function onDeselect(info) {
	    this.props.onDeselect(info);
	  },
	  getPrefixCls: function getPrefixCls() {
	    return this.props.rootPrefixCls + '-submenu';
	  },
	  getActiveClassName: function getActiveClassName() {
	    return this.getPrefixCls() + '-active';
	  },
	  getDisabledClassName: function getDisabledClassName() {
	    return this.getPrefixCls() + '-disabled';
	  },
	  getSelectedClassName: function getSelectedClassName() {
	    return this.getPrefixCls() + '-selected';
	  },
	  getOpenClassName: function getOpenClassName() {
	    return this.props.rootPrefixCls + '-submenu-open';
	  },
	  saveMenuInstance: function saveMenuInstance(c) {
	    this.menuInstance = c;
	  },
	  addKeyPath: function addKeyPath(info) {
	    return (0, _extends3['default'])({}, info, {
	      keyPath: (info.keyPath || []).concat(this.props.eventKey)
	    });
	  },
	  triggerOpenChange: function triggerOpenChange(open, type) {
	    var key = this.props.eventKey;
	    this.onOpenChange({
	      key: key,
	      item: this,
	      trigger: type,
	      open: open
	    });
	  },
	  clearSubMenuTimers: function clearSubMenuTimers() {
	    this.clearSubMenuLeaveTimer();
	    this.clearSubMenuTitleLeaveTimer();
	  },
	  clearSubMenuTitleLeaveTimer: function clearSubMenuTitleLeaveTimer() {
	    var parentMenu = this.props.parentMenu;
	    if (parentMenu.subMenuTitleLeaveTimer) {
	      clearTimeout(parentMenu.subMenuTitleLeaveTimer);
	      parentMenu.subMenuTitleLeaveTimer = null;
	      parentMenu.subMenuTitleLeaveFn = null;
	    }
	  },
	  clearSubMenuLeaveTimer: function clearSubMenuLeaveTimer() {
	    var parentMenu = this.props.parentMenu;
	    if (parentMenu.subMenuLeaveTimer) {
	      clearTimeout(parentMenu.subMenuLeaveTimer);
	      parentMenu.subMenuLeaveTimer = null;
	      parentMenu.subMenuLeaveFn = null;
	    }
	  },
	  isChildrenSelected: function isChildrenSelected() {
	    var ret = { find: false };
	    (0, _util.loopMenuItemRecusively)(this.props.children, this.props.selectedKeys, ret);
	    return ret.find;
	  },
	  isOpen: function isOpen() {
	    return this.props.openKeys.indexOf(this.props.eventKey) !== -1;
	  },
	  renderChildren: function renderChildren(children) {
	    var props = this.props;
	    var baseProps = {
	      mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
	      visible: this.isOpen(),
	      level: props.level + 1,
	      inlineIndent: props.inlineIndent,
	      focusable: false,
	      onClick: this.onSubMenuClick,
	      onSelect: this.onSelect,
	      onDeselect: this.onDeselect,
	      onDestroy: this.onDestroy,
	      selectedKeys: props.selectedKeys,
	      eventKey: props.eventKey + '-menu-',
	      openKeys: props.openKeys,
	      openTransitionName: props.openTransitionName,
	      openAnimation: props.openAnimation,
	      onOpenChange: this.onOpenChange,
	      closeSubMenuOnMouseLeave: props.closeSubMenuOnMouseLeave,
	      defaultActiveFirst: this.state.defaultActiveFirst,
	      multiple: props.multiple,
	      prefixCls: props.rootPrefixCls,
	      id: this._menuId,
	      ref: this.saveMenuInstance
	    };
	    return _react2['default'].createElement(
	      _SubPopupMenu2['default'],
	      baseProps,
	      children
	    );
	  },
	  render: function render() {
	    var _classes;
	
	    var isOpen = this.isOpen();
	    this.haveOpen = this.haveOpen || isOpen;
	    var props = this.props;
	    var prefixCls = this.getPrefixCls();
	    var classes = (_classes = {}, (0, _defineProperty3['default'])(_classes, props.className, !!props.className), (0, _defineProperty3['default'])(_classes, prefixCls + '-' + props.mode, 1), _classes);
	
	    classes[this.getOpenClassName()] = isOpen;
	    classes[this.getActiveClassName()] = props.active;
	    classes[this.getDisabledClassName()] = props.disabled;
	    classes[this.getSelectedClassName()] = this.isChildrenSelected();
	
	    if (!this._menuId) {
	      if (props.eventKey) {
	        this._menuId = props.eventKey + '$Menu';
	      } else {
	        this._menuId = '$__$' + ++guid + '$Menu';
	      }
	    }
	
	    classes[prefixCls] = true;
	    classes[prefixCls + '-' + props.mode] = 1;
	    var mouseEvents = {};
	    var titleClickEvents = {};
	    var titleMouseEvents = {};
	    if (!props.disabled) {
	      mouseEvents = {
	        onMouseLeave: this.onMouseLeave,
	        onMouseEnter: this.onMouseEnter
	      };
	      titleClickEvents = {
	        onClick: this.onTitleClick
	      };
	      // only works in title, not outer li
	      titleMouseEvents = {
	        onMouseEnter: this.onTitleMouseEnter,
	        onMouseLeave: this.onTitleMouseLeave
	      };
	    }
	    var style = {};
	    if (props.mode === 'inline') {
	      style.paddingLeft = props.inlineIndent * props.level;
	    }
	    return _react2['default'].createElement(
	      'li',
	      (0, _extends3['default'])({ className: (0, _classnames2['default'])(classes) }, mouseEvents, { style: props.style }),
	      _react2['default'].createElement(
	        'div',
	        (0, _extends3['default'])({
	          style: style,
	          className: prefixCls + '-title'
	        }, titleMouseEvents, titleClickEvents, {
	          'aria-expanded': isOpen,
	          'aria-owns': this._menuId,
	          'aria-haspopup': 'true',
	          title: typeof props.title === 'string' ? props.title : undefined
	        }),
	        props.title,
	        _react2['default'].createElement('i', { className: prefixCls + '-arrow' })
	      ),
	      this.renderChildren(props.children)
	    );
	  }
	});
	
	SubMenu.isSubMenu = 1;
	
	exports['default'] = SubMenu;
	module.exports = exports['default'];

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _KeyCode = __webpack_require__(115);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _addEventListener = __webpack_require__(236);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _contains = __webpack_require__(539);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.mode !== 'inline') {
	      if (this.props.open) {
	        this.bindRootCloseHandlers();
	      } else {
	        this.unbindRootCloseHandlers();
	      }
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (e.keyCode === _KeyCode2['default'].ESC) {
	      this.props.onItemHover({
	        key: this.props.eventKey,
	        item: this,
	        hover: false
	      });
	    }
	  },
	  handleDocumentClick: function handleDocumentClick(e) {
	    // If the click originated from within this component
	    // don't do anything.
	    if ((0, _contains2['default'])(_reactDom2['default'].findDOMNode(this), e.target)) {
	      return;
	    }
	    var props = this.props;
	    props.onItemHover({
	      hover: false,
	      item: this,
	      key: this.props.eventKey
	    });
	    this.triggerOpenChange(false);
	  },
	  bindRootCloseHandlers: function bindRootCloseHandlers() {
	    if (!this._onDocumentClickListener) {
	      this._onDocumentClickListener = (0, _addEventListener2['default'])(document, 'click', this.handleDocumentClick);
	      this._onDocumentKeyupListener = (0, _addEventListener2['default'])(document, 'keyup', this.handleDocumentKeyUp);
	    }
	  },
	  unbindRootCloseHandlers: function unbindRootCloseHandlers() {
	    if (this._onDocumentClickListener) {
	      this._onDocumentClickListener.remove();
	      this._onDocumentClickListener = null;
	    }
	
	    if (this._onDocumentKeyupListener) {
	      this._onDocumentKeyupListener.remove();
	      this._onDocumentKeyupListener = null;
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.unbindRootCloseHandlers();
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(50);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(65);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _MenuMixin = __webpack_require__(534);
	
	var _MenuMixin2 = _interopRequireDefault(_MenuMixin);
	
	var _rcAnimate = __webpack_require__(234);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SubPopupMenu = (0, _createReactClass2['default'])({
	  displayName: 'SubPopupMenu',
	
	  propTypes: {
	    onSelect: _propTypes2['default'].func,
	    onClick: _propTypes2['default'].func,
	    onDeselect: _propTypes2['default'].func,
	    onOpenChange: _propTypes2['default'].func,
	    onDestroy: _propTypes2['default'].func,
	    openTransitionName: _propTypes2['default'].string,
	    openAnimation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    openKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    closeSubMenuOnMouseLeave: _propTypes2['default'].bool,
	    visible: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any
	  },
	
	  mixins: [_MenuMixin2['default']],
	
	  onDeselect: function onDeselect(selectInfo) {
	    this.props.onDeselect(selectInfo);
	  },
	  onSelect: function onSelect(selectInfo) {
	    this.props.onSelect(selectInfo);
	  },
	  onClick: function onClick(e) {
	    this.props.onClick(e);
	  },
	  onOpenChange: function onOpenChange(e) {
	    this.props.onOpenChange(e);
	  },
	  onDestroy: function onDestroy(key) {
	    this.props.onDestroy(key);
	  },
	  onItemHover: function onItemHover(e) {
	    var _e$openChanges = e.openChanges,
	        openChanges = _e$openChanges === undefined ? [] : _e$openChanges;
	
	    openChanges = openChanges.concat(this.getOpenChangesOnItemHover(e));
	    if (openChanges.length) {
	      this.onOpenChange(openChanges);
	    }
	  },
	  getOpenTransitionName: function getOpenTransitionName() {
	    return this.props.openTransitionName;
	  },
	  renderMenuItem: function renderMenuItem(c, i, subIndex) {
	    if (!c) {
	      return null;
	    }
	    var props = this.props;
	    var extraProps = {
	      openKeys: props.openKeys,
	      selectedKeys: props.selectedKeys,
	      openSubMenuOnMouseEnter: true
	    };
	    return this.renderCommonMenuItem(c, i, subIndex, extraProps);
	  },
	  render: function render() {
	    var renderFirst = this.renderFirst;
	    this.renderFirst = 1;
	    this.haveOpened = this.haveOpened || this.props.visible;
	    if (!this.haveOpened) {
	      return null;
	    }
	    var transitionAppear = true;
	    if (!renderFirst && this.props.visible) {
	      transitionAppear = false;
	    }
	    var props = (0, _extends3['default'])({}, this.props);
	    props.className += ' ' + props.prefixCls + '-sub';
	    var animProps = {};
	    if (props.openTransitionName) {
	      animProps.transitionName = props.openTransitionName;
	    } else if ((0, _typeof3['default'])(props.openAnimation) === 'object') {
	      animProps.animation = (0, _extends3['default'])({}, props.openAnimation);
	      if (!transitionAppear) {
	        delete animProps.animation.appear;
	      }
	    }
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      (0, _extends3['default'])({}, animProps, {
	        showProp: 'visible',
	        component: '',
	        transitionAppear: transitionAppear
	      }),
	      this.renderRoot(props)
	    );
	  }
	});
	
	exports['default'] = SubPopupMenu;
	module.exports = exports['default'];

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _toArray = __webpack_require__(1590);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _rcMenu = __webpack_require__(535);
	
	var _rcMenu2 = _interopRequireDefault(_rcMenu);
	
	var _domScrollIntoView = __webpack_require__(309);
	
	var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);
	
	var _util = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.scrollActiveItemToView = function () {
	      // scroll into view
	      var itemComponent = (0, _reactDom.findDOMNode)(_this.firstActiveItem);
	      var props = _this.props;
	
	      if (itemComponent) {
	        var scrollIntoViewOpts = {
	          onlyScrollIfNeeded: true
	        };
	        if ((!props.value || props.value.length === 0) && props.firstActiveValue) {
	          scrollIntoViewOpts.alignWithTop = true;
	        }
	
	        (0, _domScrollIntoView2['default'])(itemComponent, (0, _reactDom.findDOMNode)(_this.refs.menu), scrollIntoViewOpts);
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(DropdownMenu, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.lastInputValue = this.props.inputValue;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollActiveItemToView();
	      this.lastVisible = this.props.visible;
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      if (!nextProps.visible) {
	        this.lastVisible = false;
	      }
	      // freeze when hide
	      return nextProps.visible;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var props = this.props;
	      if (!prevProps.visible && props.visible) {
	        this.scrollActiveItemToView();
	      }
	      this.lastVisible = props.visible;
	      this.lastInputValue = props.inputValue;
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var _this2 = this;
	
	      var props = this.props;
	      var menuItems = props.menuItems,
	          defaultActiveFirstOption = props.defaultActiveFirstOption,
	          value = props.value,
	          prefixCls = props.prefixCls,
	          multiple = props.multiple,
	          onMenuSelect = props.onMenuSelect,
	          inputValue = props.inputValue,
	          firstActiveValue = props.firstActiveValue;
	
	      if (menuItems && menuItems.length) {
	        var menuProps = {};
	        if (multiple) {
	          menuProps.onDeselect = props.onMenuDeselect;
	          menuProps.onSelect = onMenuSelect;
	        } else {
	          menuProps.onClick = onMenuSelect;
	        }
	
	        var selectedKeys = (0, _util.getSelectKeys)(menuItems, value);
	        var activeKeyProps = {};
	
	        var clonedMenuItems = menuItems;
	        if (selectedKeys.length || firstActiveValue) {
	          if (props.visible && !this.lastVisible) {
	            activeKeyProps.activeKey = selectedKeys[0] || firstActiveValue;
	          }
	          var foundFirst = false;
	          // set firstActiveItem via cloning menus
	          // for scroll into view
	          var clone = function clone(item) {
	            if (!foundFirst && selectedKeys.indexOf(item.key) !== -1 || !foundFirst && !selectedKeys.length && firstActiveValue.indexOf(item.key) !== -1) {
	              foundFirst = true;
	              return (0, _react.cloneElement)(item, {
	                ref: function ref(_ref2) {
	                  _this2.firstActiveItem = _ref2;
	                }
	              });
	            }
	            return item;
	          };
	
	          clonedMenuItems = menuItems.map(function (item) {
	            if (item.type.isMenuItemGroup) {
	              var children = (0, _toArray2['default'])(item.props.children).map(clone);
	              return (0, _react.cloneElement)(item, {}, children);
	            }
	            return clone(item);
	          });
	        }
	
	        // clear activeKey when inputValue change
	        var lastValue = value && value[value.length - 1];
	        if (inputValue !== this.lastInputValue && (!lastValue || !lastValue.backfill)) {
	          activeKeyProps.activeKey = '';
	        }
	
	        return _react2['default'].createElement(
	          _rcMenu2['default'],
	          (0, _extends3['default'])({
	            ref: 'menu',
	            style: this.props.dropdownMenuStyle,
	            defaultActiveFirst: defaultActiveFirstOption
	          }, activeKeyProps, {
	            multiple: multiple,
	            focusable: false
	          }, menuProps, {
	            selectedKeys: selectedKeys,
	            prefixCls: prefixCls + '-menu'
	          }),
	          clonedMenuItems
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderMenu = this.renderMenu();
	      return renderMenu ? _react2['default'].createElement(
	        'div',
	        {
	          style: { overflow: 'auto' },
	          onFocus: this.props.onPopupFocus,
	          onMouseDown: _util.preventDefaultEvent
	        },
	        renderMenu
	      ) : null;
	    }
	  }]);
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = {
	  defaultActiveFirstOption: _propTypes2['default'].bool,
	  value: _propTypes2['default'].any,
	  dropdownMenuStyle: _propTypes2['default'].object,
	  multiple: _propTypes2['default'].bool,
	  onPopupFocus: _propTypes2['default'].func,
	  onMenuDeSelect: _propTypes2['default'].func,
	  onMenuSelect: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  menuItems: _propTypes2['default'].any,
	  inputValue: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool
	};
	exports['default'] = DropdownMenu;
	
	
	DropdownMenu.displayName = 'DropdownMenu';
	module.exports = exports['default'];

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var OptGroup = function (_React$Component) {
	  (0, _inherits3['default'])(OptGroup, _React$Component);
	
	  function OptGroup() {
	    (0, _classCallCheck3['default'])(this, OptGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, (OptGroup.__proto__ || Object.getPrototypeOf(OptGroup)).apply(this, arguments));
	  }
	
	  return OptGroup;
	}(_react2['default'].Component);
	
	OptGroup.isSelectOptGroup = true;
	exports['default'] = OptGroup;
	module.exports = exports['default'];

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Option = function (_React$Component) {
	  (0, _inherits3['default'])(Option, _React$Component);
	
	  function Option() {
	    (0, _classCallCheck3['default'])(this, Option);
	    return (0, _possibleConstructorReturn3['default'])(this, (Option.__proto__ || Object.getPrototypeOf(Option)).apply(this, arguments));
	  }
	
	  return Option;
	}(_react2['default'].Component);
	
	Option.propTypes = {
	  value: _propTypes2['default'].string
	};
	Option.isSelectOption = true;
	exports['default'] = Option;
	module.exports = exports['default'];

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _KeyCode = __webpack_require__(115);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _classnames2 = __webpack_require__(52);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _rcAnimate = __webpack_require__(234);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _componentClasses = __webpack_require__(288);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	var _util = __webpack_require__(235);
	
	var _SelectTrigger = __webpack_require__(1585);
	
	var _SelectTrigger2 = _interopRequireDefault(_SelectTrigger);
	
	var _PropTypes = __webpack_require__(536);
	
	var _rcMenu = __webpack_require__(535);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {} /* eslint func-names: 0 */
	
	
	function saveRef(name, component) {
	  this[name] = component;
	}
	
	function chaining() {
	  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    // eslint-disable-line
	    for (var i = 0; i < fns.length; i++) {
	      if (fns[i] && typeof fns[i] === 'function') {
	        fns[i].apply(this, args);
	      }
	    }
	  };
	}
	
	var Select = function (_React$Component) {
	  (0, _inherits3['default'])(Select, _React$Component);
	
	  function Select(props) {
	    (0, _classCallCheck3['default'])(this, Select);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var value = [];
	    if ('value' in props) {
	      value = (0, _util.toArray)(props.value);
	    } else {
	      value = (0, _util.toArray)(props.defaultValue);
	    }
	    value = _this.addLabelToValue(props, value);
	    value = _this.addTitleToValue(props, value);
	    var inputValue = '';
	    if (props.combobox) {
	      inputValue = value.length ? _this.getLabelFromProps(props, value[0].key) : '';
	    }
	    _this.saveInputRef = saveRef.bind(_this, 'inputInstance');
	    _this.saveInputMirrorRef = saveRef.bind(_this, 'inputMirrorInstance');
	    var open = props.open;
	    if (open === undefined) {
	      open = props.defaultOpen;
	    }
	    _this.state = {
	      value: value,
	      inputValue: inputValue,
	      open: open
	    };
	    _this.adjustOpenState();
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Select, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.props = nextProps;
	      this.state = nextState;
	      this.adjustOpenState();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if ((0, _util.isMultipleOrTags)(this.props)) {
	        var inputNode = this.getInputDOMNode();
	        var mirrorNode = this.getInputMirrorDOMNode();
	        if (inputNode.value) {
	          inputNode.style.width = '';
	          inputNode.style.width = mirrorNode.clientWidth + 'px';
	        } else {
	          inputNode.style.width = '';
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearFocusTime();
	      this.clearBlurTime();
	      this.clearAdjustTimer();
	      if (this.dropdownContainer) {
	        _reactDom2['default'].unmountComponentAtNode(this.dropdownContainer);
	        document.body.removeChild(this.dropdownContainer);
	        this.dropdownContainer = null;
	      }
	    }
	
	    // combobox ignore
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _rootCls;
	
	      var props = this.props;
	      var multiple = (0, _util.isMultipleOrTags)(props);
	      var state = this.state;
	      var className = props.className,
	          disabled = props.disabled,
	          allowClear = props.allowClear,
	          prefixCls = props.prefixCls;
	
	      var ctrlNode = this.renderTopControlNode();
	      var extraSelectionProps = {};
	      var open = this.state.open;
	
	      var options = this._options;
	      if (!(0, _util.isMultipleOrTagsOrCombobox)(props)) {
	        extraSelectionProps = {
	          onKeyDown: this.onKeyDown,
	          tabIndex: 0
	        };
	      }
	      var rootCls = (_rootCls = {}, (0, _defineProperty3['default'])(_rootCls, className, !!className), (0, _defineProperty3['default'])(_rootCls, prefixCls, 1), (0, _defineProperty3['default'])(_rootCls, prefixCls + '-open', open), (0, _defineProperty3['default'])(_rootCls, prefixCls + '-focused', open || !!this._focused), (0, _defineProperty3['default'])(_rootCls, prefixCls + '-combobox', (0, _util.isCombobox)(props)), (0, _defineProperty3['default'])(_rootCls, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_rootCls, prefixCls + '-enabled', !disabled), (0, _defineProperty3['default'])(_rootCls, prefixCls + '-allow-clear', !!props.allowClear), _rootCls);
	      var clearStyle = (0, _extends3['default'])({}, _util.UNSELECTABLE_STYLE, {
	        display: 'none'
	      });
	      if (state.inputValue || state.value.length) {
	        clearStyle.display = 'block';
	      }
	      var clear = _react2['default'].createElement('span', (0, _extends3['default'])({
	        key: 'clear',
	        onMouseDown: _util.preventDefaultEvent,
	        style: clearStyle
	      }, _util.UNSELECTABLE_ATTRIBUTE, {
	        className: prefixCls + '-selection__clear',
	        onClick: this.onClearSelection
	      }));
	      return _react2['default'].createElement(
	        _SelectTrigger2['default'],
	        {
	          onPopupFocus: this.onPopupFocus,
	          dropdownAlign: props.dropdownAlign,
	          dropdownClassName: props.dropdownClassName,
	          dropdownMatchSelectWidth: props.dropdownMatchSelectWidth,
	          defaultActiveFirstOption: props.defaultActiveFirstOption,
	          dropdownMenuStyle: props.dropdownMenuStyle,
	          transitionName: props.transitionName,
	          animation: props.animation,
	          prefixCls: props.prefixCls,
	          dropdownStyle: props.dropdownStyle,
	          combobox: props.combobox,
	          showSearch: props.showSearch,
	          options: options,
	          multiple: multiple,
	          disabled: disabled,
	          visible: open,
	          inputValue: state.inputValue,
	          value: state.value,
	          firstActiveValue: props.firstActiveValue,
	          onDropdownVisibleChange: this.onDropdownVisibleChange,
	          getPopupContainer: props.getPopupContainer,
	          onMenuSelect: this.onMenuSelect,
	          onMenuDeselect: this.onMenuDeselect,
	          ref: 'trigger'
	        },
	        _react2['default'].createElement(
	          'div',
	          {
	            style: props.style,
	            ref: 'root',
	            onBlur: this.onOuterBlur,
	            onFocus: this.onOuterFocus,
	            className: (0, _classnames3['default'])(rootCls)
	          },
	          _react2['default'].createElement(
	            'div',
	            (0, _extends3['default'])({
	              ref: 'selection',
	              key: 'selection',
	              className: prefixCls + '-selection\n            ' + prefixCls + '-selection--' + (multiple ? 'multiple' : 'single'),
	              role: 'combobox',
	              'aria-autocomplete': 'list',
	              'aria-haspopup': 'true',
	              'aria-expanded': open
	            }, extraSelectionProps),
	            ctrlNode,
	            allowClear ? clear : null,
	            multiple || !props.showArrow ? null : _react2['default'].createElement(
	              'span',
	              (0, _extends3['default'])({
	                key: 'arrow',
	                className: prefixCls + '-arrow',
	                style: _util.UNSELECTABLE_STYLE
	              }, _util.UNSELECTABLE_ATTRIBUTE, {
	                onClick: this.onArrowClick
	              }),
	              _react2['default'].createElement('b', null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Select;
	}(_react2['default'].Component);
	
	Select.propTypes = _PropTypes.SelectPropTypes;
	Select.defaultProps = {
	  prefixCls: 'rc-select',
	  defaultOpen: false,
	  labelInValue: false,
	  defaultActiveFirstOption: true,
	  showSearch: true,
	  allowClear: false,
	  placeholder: '',
	  onChange: noop,
	  onFocus: noop,
	  onBlur: noop,
	  onSelect: noop,
	  onSearch: noop,
	  onDeselect: noop,
	  showArrow: true,
	  dropdownMatchSelectWidth: true,
	  dropdownStyle: {},
	  dropdownMenuStyle: {},
	  optionFilterProp: 'value',
	  optionLabelProp: 'value',
	  notFoundContent: 'Not Found',
	  backfill: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.componentWillReceiveProps = function (nextProps) {
	    if ('value' in nextProps) {
	      var value = (0, _util.toArray)(nextProps.value);
	      value = _this2.addLabelToValue(nextProps, value);
	      value = _this2.addTitleToValue(nextProps, value);
	      _this2.setState({
	        value: value
	      });
	      if (nextProps.combobox) {
	        _this2.setState({
	          inputValue: value.length ? _this2.getLabelFromProps(nextProps, value[0].key) : ''
	        });
	      }
	    }
	  };
	
	  this.onInputChange = function (event) {
	    var tokenSeparators = _this2.props.tokenSeparators;
	
	    var val = event.target.value;
	    if ((0, _util.isMultipleOrTags)(_this2.props) && tokenSeparators && (0, _util.includesSeparators)(val, tokenSeparators)) {
	      var nextValue = _this2.tokenize(val);
	      _this2.fireChange(nextValue);
	      _this2.setOpenState(false, true);
	      _this2.setInputValue('', false);
	      return;
	    }
	    _this2.setInputValue(val);
	    _this2.setState({
	      open: true
	    });
	    if ((0, _util.isCombobox)(_this2.props)) {
	      _this2.fireChange([{
	        key: val
	      }]);
	    }
	  };
	
	  this.onDropdownVisibleChange = function (open) {
	    if (open && !_this2._focused) {
	      _this2.clearBlurTime();
	      _this2.timeoutFocus();
	      _this2._focused = true;
	      _this2.updateFocusClassName();
	    }
	    _this2.setOpenState(open);
	  };
	
	  this.onKeyDown = function (event) {
	    var props = _this2.props;
	    if (props.disabled) {
	      return;
	    }
	    var keyCode = event.keyCode;
	    if (_this2.state.open && !_this2.getInputDOMNode()) {
	      _this2.onInputKeyDown(event);
	    } else if (keyCode === _KeyCode2['default'].ENTER || keyCode === _KeyCode2['default'].DOWN) {
	      _this2.setOpenState(true);
	      event.preventDefault();
	    }
	  };
	
	  this.onInputKeyDown = function (event) {
	    var props = _this2.props;
	    if (props.disabled) {
	      return;
	    }
	    var state = _this2.state;
	    var keyCode = event.keyCode;
	    if ((0, _util.isMultipleOrTags)(props) && !event.target.value && keyCode === _KeyCode2['default'].BACKSPACE) {
	      event.preventDefault();
	      var value = state.value;
	
	      if (value.length) {
	        _this2.removeSelected(value[value.length - 1].key);
	      }
	      return;
	    }
	    if (keyCode === _KeyCode2['default'].DOWN) {
	      if (!state.open) {
	        _this2.openIfHasChildren();
	        event.preventDefault();
	        event.stopPropagation();
	        return;
	      }
	    } else if (keyCode === _KeyCode2['default'].ESC) {
	      if (state.open) {
	        _this2.setOpenState(false);
	        event.preventDefault();
	        event.stopPropagation();
	      }
	      return;
	    }
	
	    if (state.open) {
	      var menu = _this2.refs.trigger.getInnerMenu();
	      if (menu && menu.onKeyDown(event, _this2.handleBackfill)) {
	        event.preventDefault();
	        event.stopPropagation();
	      }
	    }
	  };
	
	  this.onMenuSelect = function (_ref) {
	    var item = _ref.item;
	
	    var value = _this2.state.value;
	    var props = _this2.props;
	    var selectedValue = (0, _util.getValuePropValue)(item);
	    var selectedLabel = _this2.getLabelFromOption(item);
	    var lastValue = value[value.length - 1];
	    var event = selectedValue;
	    if (props.labelInValue) {
	      event = {
	        key: event,
	        label: selectedLabel
	      };
	    }
	    props.onSelect(event, item);
	    var selectedTitle = item.props.title;
	    if ((0, _util.isMultipleOrTags)(props)) {
	      if ((0, _util.findIndexInValueByKey)(value, selectedValue) !== -1) {
	        return;
	      }
	      value = value.concat([{
	        key: selectedValue,
	        label: selectedLabel,
	        title: selectedTitle
	      }]);
	    } else {
	      if ((0, _util.isCombobox)(props)) {
	        _this2.skipAdjustOpen = true;
	        _this2.clearAdjustTimer();
	        _this2.skipAdjustOpenTimer = setTimeout(function () {
	          _this2.skipAdjustOpen = false;
	        }, 0);
	      }
	      if (lastValue && lastValue.key === selectedValue && !lastValue.backfill) {
	        _this2.setOpenState(false, true);
	        return;
	      }
	      value = [{
	        key: selectedValue,
	        label: selectedLabel,
	        title: selectedTitle
	      }];
	      _this2.setOpenState(false, true);
	    }
	    _this2.fireChange(value);
	    var inputValue = void 0;
	    if ((0, _util.isCombobox)(props)) {
	      inputValue = (0, _util.getPropValue)(item, props.optionLabelProp);
	    } else {
	      inputValue = '';
	    }
	    _this2.setInputValue(inputValue, false);
	  };
	
	  this.onMenuDeselect = function (_ref2) {
	    var item = _ref2.item,
	        domEvent = _ref2.domEvent;
	
	    if (domEvent.type === 'click') {
	      _this2.removeSelected((0, _util.getValuePropValue)(item));
	    }
	    _this2.setInputValue('', false);
	  };
	
	  this.onArrowClick = function (e) {
	    e.stopPropagation();
	    if (!_this2.props.disabled) {
	      _this2.setOpenState(!_this2.state.open, !_this2.state.open);
	    }
	  };
	
	  this.onPlaceholderClick = function () {
	    if (_this2.getInputDOMNode()) {
	      _this2.getInputDOMNode().focus();
	    }
	  };
	
	  this.onOuterFocus = function (e) {
	    if (_this2.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	    _this2.clearBlurTime();
	    if (!(0, _util.isMultipleOrTagsOrCombobox)(_this2.props) && e.target === _this2.getInputDOMNode()) {
	      return;
	    }
	    if (_this2._focused) {
	      return;
	    }
	    _this2._focused = true;
	    _this2.updateFocusClassName();
	    _this2.timeoutFocus();
	  };
	
	  this.onPopupFocus = function () {
	    // fix ie scrollbar, focus element again
	    _this2.maybeFocus(true, true);
	  };
	
	  this.onOuterBlur = function (e) {
	    if (_this2.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	    _this2.blurTimer = setTimeout(function () {
	      _this2._focused = false;
	      _this2.updateFocusClassName();
	      var props = _this2.props;
	      var value = _this2.state.value;
	      var inputValue = _this2.state.inputValue;
	
	      if ((0, _util.isSingleMode)(props) && props.showSearch && inputValue && props.defaultActiveFirstOption) {
	        var options = _this2._options || [];
	        if (options.length) {
	          var firstOption = (0, _util.findFirstMenuItem)(options);
	          if (firstOption) {
	            value = [{
	              key: firstOption.key,
	              label: _this2.getLabelFromOption(firstOption)
	            }];
	            _this2.fireChange(value);
	          }
	        }
	      } else if ((0, _util.isMultipleOrTags)(props) && inputValue) {
	        // why not use setState?
	        _this2.state.inputValue = _this2.getInputDOMNode().value = '';
	      }
	      props.onBlur(_this2.getVLForOnChange(value));
	      _this2.setOpenState(false);
	    }, 10);
	  };
	
	  this.onClearSelection = function (event) {
	    var props = _this2.props;
	    var state = _this2.state;
	    if (props.disabled) {
	      return;
	    }
	    var inputValue = state.inputValue,
	        value = state.value;
	
	    event.stopPropagation();
	    if (inputValue || value.length) {
	      if (value.length) {
	        _this2.fireChange([]);
	      }
	      _this2.setOpenState(false, true);
	      if (inputValue) {
	        _this2.setInputValue('');
	      }
	    }
	  };
	
	  this.onChoiceAnimationLeave = function () {
	    _this2.refs.trigger.refs.trigger.forcePopupAlign();
	  };
	
	  this.getLabelBySingleValue = function (children, value) {
	    if (value === undefined) {
	      return null;
	    }
	    var label = null;
	    _react2['default'].Children.forEach(children, function (child) {
	      if (!child) {
	        return;
	      }
	      if (child.type.isSelectOptGroup) {
	        var maybe = _this2.getLabelBySingleValue(child.props.children, value);
	        if (maybe !== null) {
	          label = maybe;
	        }
	      } else if ((0, _util.getValuePropValue)(child) === value) {
	        label = _this2.getLabelFromOption(child);
	      }
	    });
	    return label;
	  };
	
	  this.getValueByLabel = function (children, label) {
	    if (label === undefined) {
	      return null;
	    }
	    var value = null;
	    _react2['default'].Children.forEach(children, function (child) {
	      if (!child) {
	        return;
	      }
	      if (child.type.isSelectOptGroup) {
	        var maybe = _this2.getValueByLabel(child.props.children, label);
	        if (maybe !== null) {
	          value = maybe;
	        }
	      } else if ((0, _util.toArray)(_this2.getLabelFromOption(child)).join('') === label) {
	        value = (0, _util.getValuePropValue)(child);
	      }
	    });
	    return value;
	  };
	
	  this.getLabelFromOption = function (child) {
	    return (0, _util.getPropValue)(child, _this2.props.optionLabelProp);
	  };
	
	  this.getLabelFromProps = function (props, value) {
	    return _this2.getLabelByValue(props.children, value);
	  };
	
	  this.getVLForOnChange = function (vls_) {
	    var vls = vls_;
	    if (vls !== undefined) {
	      if (!_this2.props.labelInValue) {
	        vls = vls.map(function (v) {
	          return v.key;
	        });
	      } else {
	        vls = vls.map(function (vl) {
	          return { key: vl.key, label: vl.label };
	        });
	      }
	      return (0, _util.isMultipleOrTags)(_this2.props) ? vls : vls[0];
	    }
	    return vls;
	  };
	
	  this.getLabelByValue = function (children, value) {
	    var label = _this2.getLabelBySingleValue(children, value);
	    if (label === null) {
	      return value;
	    }
	    return label;
	  };
	
	  this.getDropdownContainer = function () {
	    if (!_this2.dropdownContainer) {
	      _this2.dropdownContainer = document.createElement('div');
	      document.body.appendChild(_this2.dropdownContainer);
	    }
	    return _this2.dropdownContainer;
	  };
	
	  this.getPlaceholderElement = function () {
	    var props = _this2.props,
	        state = _this2.state;
	
	    var hidden = false;
	    if (state.inputValue) {
	      hidden = true;
	    }
	    if (state.value.length) {
	      hidden = true;
	    }
	    if ((0, _util.isCombobox)(props) && state.value.length === 1 && !state.value[0].key) {
	      hidden = false;
	    }
	    var placeholder = props.placeholder;
	    if (placeholder) {
	      return _react2['default'].createElement(
	        'div',
	        (0, _extends3['default'])({
	          onMouseDown: _util.preventDefaultEvent,
	          style: (0, _extends3['default'])({
	            display: hidden ? 'none' : 'block'
	          }, _util.UNSELECTABLE_STYLE)
	        }, _util.UNSELECTABLE_ATTRIBUTE, {
	          onClick: _this2.onPlaceholderClick,
	          className: props.prefixCls + '-selection__placeholder'
	        }),
	        placeholder
	      );
	    }
	    return null;
	  };
	
	  this.getInputElement = function () {
	    var props = _this2.props;
	    var inputElement = props.getInputElement ? props.getInputElement() : _react2['default'].createElement('input', { id: props.id, autoComplete: 'off' });
	    var inputCls = (0, _classnames3['default'])(inputElement.props.className, (0, _defineProperty3['default'])({}, props.prefixCls + '-search__field', true));
	    // https://github.com/ant-design/ant-design/issues/4992#issuecomment-281542159
	    // Add space to the end of the inputValue as the width measurement tolerance
	    return _react2['default'].createElement(
	      'div',
	      { className: props.prefixCls + '-search__field__wrap' },
	      _react2['default'].cloneElement(inputElement, {
	        ref: _this2.saveInputRef,
	        onChange: _this2.onInputChange,
	        onKeyDown: chaining(_this2.onInputKeyDown, inputElement.props.onKeyDown),
	        value: _this2.state.inputValue,
	        disabled: props.disabled,
	        className: inputCls
	      }),
	      _react2['default'].createElement(
	        'span',
	        {
	          ref: _this2.saveInputMirrorRef,
	          className: props.prefixCls + '-search__field__mirror'
	        },
	        _this2.state.inputValue,
	        '\xA0'
	      )
	    );
	  };
	
	  this.getInputDOMNode = function () {
	    return _this2.topCtrlNode ? _this2.topCtrlNode.querySelector('input,textarea,div[contentEditable]') : _this2.inputInstance;
	  };
	
	  this.getInputMirrorDOMNode = function () {
	    return _this2.inputMirrorInstance;
	  };
	
	  this.getPopupDOMNode = function () {
	    return _this2.refs.trigger.getPopupDOMNode();
	  };
	
	  this.getPopupMenuComponent = function () {
	    return _this2.refs.trigger.getInnerMenu();
	  };
	
	  this.setOpenState = function (open, needFocus) {
	    var props = _this2.props,
	        state = _this2.state;
	
	    if (state.open === open) {
	      _this2.maybeFocus(open, needFocus);
	      return;
	    }
	    var nextState = {
	      open: open
	    };
	    // clear search input value when open is false in singleMode.
	    if (!open && (0, _util.isSingleMode)(props) && props.showSearch) {
	      _this2.setInputValue('', false);
	    }
	    if (!open) {
	      _this2.maybeFocus(open, needFocus);
	    }
	    _this2.setState(nextState, function () {
	      if (open) {
	        _this2.maybeFocus(open, needFocus);
	      }
	    });
	  };
	
	  this.setInputValue = function (inputValue) {
	    var fireSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (inputValue !== _this2.state.inputValue) {
	      _this2.setState({
	        inputValue: inputValue
	      });
	      if (fireSearch) {
	        _this2.props.onSearch(inputValue);
	      }
	    }
	  };
	
	  this.handleBackfill = function (item) {
	    if (!_this2.props.backfill || !((0, _util.isSingleMode)(_this2.props) || (0, _util.isCombobox)(_this2.props))) {
	      return;
	    }
	
	    var key = (0, _util.getValuePropValue)(item);
	    var label = _this2.getLabelFromOption(item);
	    var backfillValue = {
	      key: key,
	      label: label,
	      backfill: true
	    };
	
	    if ((0, _util.isCombobox)(_this2.props)) {
	      _this2.setInputValue(key, false);
	    }
	
	    _this2.setState({
	      value: [backfillValue]
	    });
	  };
	
	  this.filterOption = function (input, child) {
	    var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _util.defaultFilterFn;
	    var value = _this2.state.value;
	
	    var lastValue = value[value.length - 1];
	    if (!input || lastValue && lastValue.backfill) {
	      return true;
	    }
	    var filterFn = _this2.props.filterOption;
	    if ('filterOption' in _this2.props) {
	      if (_this2.props.filterOption === true) {
	        filterFn = defaultFilter;
	      }
	    } else {
	      filterFn = defaultFilter;
	    }
	
	    if (!filterFn) {
	      return true;
	    } else if (child.props.disabled) {
	      return false;
	    } else if (typeof filterFn === 'function') {
	      return filterFn.call(_this2, input, child);
	    }
	    return true;
	  };
	
	  this.timeoutFocus = function () {
	    if (_this2.focusTimer) {
	      _this2.clearFocusTime();
	    }
	    _this2.focusTimer = setTimeout(function () {
	      _this2.props.onFocus();
	    }, 10);
	  };
	
	  this.clearFocusTime = function () {
	    if (_this2.focusTimer) {
	      clearTimeout(_this2.focusTimer);
	      _this2.focusTimer = null;
	    }
	  };
	
	  this.clearBlurTime = function () {
	    if (_this2.blurTimer) {
	      clearTimeout(_this2.blurTimer);
	      _this2.blurTimer = null;
	    }
	  };
	
	  this.clearAdjustTimer = function () {
	    if (_this2.skipAdjustOpenTimer) {
	      clearTimeout(_this2.skipAdjustOpenTimer);
	      _this2.skipAdjustOpenTimer = null;
	    }
	  };
	
	  this.updateFocusClassName = function () {
	    var refs = _this2.refs,
	        props = _this2.props;
	    // avoid setState and its side effect
	
	    if (_this2._focused) {
	      (0, _componentClasses2['default'])(refs.root).add(props.prefixCls + '-focused');
	    } else {
	      (0, _componentClasses2['default'])(refs.root).remove(props.prefixCls + '-focused');
	    }
	  };
	
	  this.maybeFocus = function (open, needFocus) {
	    if (needFocus || open) {
	      var input = _this2.getInputDOMNode();
	      var _document = document,
	          activeElement = _document.activeElement;
	
	      if (input && (open || (0, _util.isMultipleOrTagsOrCombobox)(_this2.props))) {
	        if (activeElement !== input) {
	          input.focus();
	          _this2._focused = true;
	        }
	      } else {
	        var selection = _this2.refs.selection;
	        if (activeElement !== selection) {
	          selection.focus();
	          _this2._focused = true;
	        }
	      }
	    }
	  };
	
	  this.addLabelToValue = function (props, value_) {
	    var value = value_;
	    if (props.labelInValue) {
	      value.forEach(function (v) {
	        v.label = v.label || _this2.getLabelFromProps(props, v.key);
	      });
	    } else {
	      value = value.map(function (v) {
	        return {
	          key: v,
	          label: _this2.getLabelFromProps(props, v)
	        };
	      });
	    }
	    return value;
	  };
	
	  this.addTitleToValue = function (props, values) {
	    var nextValues = values;
	    var keys = values.map(function (v) {
	      return v.key;
	    });
	    _react2['default'].Children.forEach(props.children, function (child) {
	      if (!child) {
	        return;
	      }
	      if (child.type.isSelectOptGroup) {
	        nextValues = _this2.addTitleToValue(child.props, nextValues);
	      } else {
	        var value = (0, _util.getValuePropValue)(child);
	        var valueIndex = keys.indexOf(value);
	        if (valueIndex > -1) {
	          nextValues[valueIndex].title = child.props.title;
	        }
	      }
	    });
	    return nextValues;
	  };
	
	  this.removeSelected = function (selectedKey) {
	    var props = _this2.props;
	    if (props.disabled || _this2.isChildDisabled(selectedKey)) {
	      return;
	    }
	    var label = void 0;
	    var value = _this2.state.value.filter(function (singleValue) {
	      if (singleValue.key === selectedKey) {
	        label = singleValue.label;
	      }
	      return singleValue.key !== selectedKey;
	    });
	    var canMultiple = (0, _util.isMultipleOrTags)(props);
	
	    if (canMultiple) {
	      var event = selectedKey;
	      if (props.labelInValue) {
	        event = {
	          key: selectedKey,
	          label: label
	        };
	      }
	      props.onDeselect(event);
	    }
	    _this2.fireChange(value);
	  };
	
	  this.openIfHasChildren = function () {
	    var props = _this2.props;
	    if (_react2['default'].Children.count(props.children) || (0, _util.isSingleMode)(props)) {
	      _this2.setOpenState(true);
	    }
	  };
	
	  this.fireChange = function (value) {
	    var props = _this2.props;
	    if (!('value' in props)) {
	      _this2.setState({
	        value: value
	      });
	    }
	    props.onChange(_this2.getVLForOnChange(value));
	  };
	
	  this.isChildDisabled = function (key) {
	    return (0, _util.toArray)(_this2.props.children).some(function (child) {
	      var childValue = (0, _util.getValuePropValue)(child);
	      return childValue === key && child.props && child.props.disabled;
	    });
	  };
	
	  this.tokenize = function (string) {
	    var _props = _this2.props,
	        multiple = _props.multiple,
	        tokenSeparators = _props.tokenSeparators,
	        children = _props.children;
	
	    var nextValue = _this2.state.value;
	    (0, _util.splitBySeparators)(string, tokenSeparators).forEach(function (label) {
	      var selectedValue = { key: label, label: label };
	      if ((0, _util.findIndexInValueByLabel)(nextValue, label) === -1) {
	        if (multiple) {
	          var value = _this2.getValueByLabel(children, label);
	          if (value) {
	            selectedValue.key = value;
	            nextValue = nextValue.concat(selectedValue);
	          }
	        } else {
	          nextValue = nextValue.concat(selectedValue);
	        }
	      }
	    });
	    return nextValue;
	  };
	
	  this.adjustOpenState = function () {
	    if (_this2.skipAdjustOpen) {
	      return;
	    }
	    var open = _this2.state.open;
	
	    var options = [];
	    // If hidden menu due to no options, then it should be calculated again
	    if (open || _this2.hiddenForNoOptions) {
	      options = _this2.renderFilterOptions();
	    }
	    _this2._options = options;
	
	    if ((0, _util.isMultipleOrTagsOrCombobox)(_this2.props) || !_this2.props.showSearch) {
	      if (open && !options.length) {
	        open = false;
	        _this2.hiddenForNoOptions = true;
	      }
	      // Keep menu open if there are options and hidden for no options before
	      if (_this2.hiddenForNoOptions && options.length) {
	        open = true;
	        _this2.hiddenForNoOptions = false;
	      }
	    }
	    _this2.state.open = open;
	  };
	
	  this.renderFilterOptions = function (inputValue) {
	    return _this2.renderFilterOptionsFromChildren(_this2.props.children, true, inputValue);
	  };
	
	  this.renderFilterOptionsFromChildren = function (children, showNotFound, iv) {
	    var sel = [];
	    var props = _this2.props;
	    var inputValue = iv === undefined ? _this2.state.inputValue : iv;
	    var childrenKeys = [];
	    var tags = props.tags;
	    _react2['default'].Children.forEach(children, function (child) {
	      if (!child) {
	        return;
	      }
	      if (child.type.isSelectOptGroup) {
	        var innerItems = _this2.renderFilterOptionsFromChildren(child.props.children, false);
	        if (innerItems.length) {
	          var label = child.props.label;
	          var key = child.key;
	          if (!key && typeof label === 'string') {
	            key = label;
	          } else if (!label && key) {
	            label = key;
	          }
	          sel.push(_react2['default'].createElement(
	            _rcMenu.ItemGroup,
	            { key: key, title: label },
	            innerItems
	          ));
	        }
	        return;
	      }
	
	      (0, _warning2['default'])(child.type.isSelectOption, 'the children of `Select` should be `Select.Option` or `Select.OptGroup`, ' + ('instead of `' + (child.type.name || child.type.displayName || child.type) + '`.'));
	
	      var childValue = (0, _util.getValuePropValue)(child);
	      if (_this2.filterOption(inputValue, child)) {
	        sel.push(_react2['default'].createElement(_rcMenu.Item, (0, _extends3['default'])({
	          style: _util.UNSELECTABLE_STYLE,
	          attribute: _util.UNSELECTABLE_ATTRIBUTE,
	          value: childValue,
	          key: childValue
	        }, child.props)));
	      }
	      if (tags && !child.props.disabled) {
	        childrenKeys.push(childValue);
	      }
	    });
	    if (tags) {
	      // tags value must be string
	      var value = _this2.state.value || [];
	      value = value.filter(function (singleValue) {
	        return childrenKeys.indexOf(singleValue.key) === -1 && (!inputValue || String(singleValue.key).indexOf(String(inputValue)) > -1);
	      });
	      sel = sel.concat(value.map(function (singleValue) {
	        var key = singleValue.key;
	        return _react2['default'].createElement(
	          _rcMenu.Item,
	          {
	            style: _util.UNSELECTABLE_STYLE,
	            attribute: _util.UNSELECTABLE_ATTRIBUTE,
	            value: key,
	            key: key
	          },
	          key
	        );
	      }));
	      if (inputValue) {
	        var notFindInputItem = sel.every(function (option) {
	          // this.filterOption return true has two meaning,
	          // 1, some one exists after filtering
	          // 2, filterOption is set to false
	          // condition 2 does not mean the option has same value with inputValue
	          var filterFn = function filterFn() {
	            return (0, _util.getValuePropValue)(option) === inputValue;
	          };
	          if (_this2.props.filterOption !== false) {
	            return !_this2.filterOption.call(_this2, inputValue, option, filterFn);
	          }
	          return !filterFn();
	        });
	        if (notFindInputItem) {
	          sel.unshift(_react2['default'].createElement(
	            _rcMenu.Item,
	            {
	              style: _util.UNSELECTABLE_STYLE,
	              attribute: _util.UNSELECTABLE_ATTRIBUTE,
	              value: inputValue,
	              key: inputValue
	            },
	            inputValue
	          ));
	        }
	      }
	    }
	    if (!sel.length && showNotFound && props.notFoundContent) {
	      sel = [_react2['default'].createElement(
	        _rcMenu.Item,
	        {
	          style: _util.UNSELECTABLE_STYLE,
	          attribute: _util.UNSELECTABLE_ATTRIBUTE,
	          disabled: true,
	          value: 'NOT_FOUND',
	          key: 'NOT_FOUND'
	        },
	        props.notFoundContent
	      )];
	    }
	    return sel;
	  };
	
	  this.renderTopControlNode = function () {
	    var _state = _this2.state,
	        value = _state.value,
	        open = _state.open,
	        inputValue = _state.inputValue;
	
	    var props = _this2.props;
	    var choiceTransitionName = props.choiceTransitionName,
	        prefixCls = props.prefixCls,
	        maxTagTextLength = props.maxTagTextLength,
	        showSearch = props.showSearch;
	
	    var className = prefixCls + '-selection__rendered';
	    // search input is inside topControlNode in single, multiple & combobox. 2016/04/13
	    var innerNode = null;
	    if ((0, _util.isSingleMode)(props)) {
	      var selectedValue = null;
	      if (value.length) {
	        var showSelectedValue = false;
	        var opacity = 1;
	        if (!showSearch) {
	          showSelectedValue = true;
	        } else {
	          if (open) {
	            showSelectedValue = !inputValue;
	            if (showSelectedValue) {
	              opacity = 0.4;
	            }
	          } else {
	            showSelectedValue = true;
	          }
	        }
	        var singleValue = value[0];
	        selectedValue = _react2['default'].createElement(
	          'div',
	          {
	            key: 'value',
	            className: prefixCls + '-selection-selected-value',
	            title: singleValue.title || singleValue.label,
	            style: {
	              display: showSelectedValue ? 'block' : 'none',
	              opacity: opacity
	            }
	          },
	          value[0].label
	        );
	      }
	      if (!showSearch) {
	        innerNode = [selectedValue];
	      } else {
	        innerNode = [selectedValue, _react2['default'].createElement(
	          'div',
	          {
	            className: prefixCls + '-search ' + prefixCls + '-search--inline',
	            key: 'input',
	            style: {
	              display: open ? 'block' : 'none'
	            }
	          },
	          _this2.getInputElement()
	        )];
	      }
	    } else {
	      var selectedValueNodes = [];
	      if ((0, _util.isMultipleOrTags)(props)) {
	        selectedValueNodes = value.map(function (singleValue) {
	          var content = singleValue.label;
	          var title = singleValue.title || content;
	          if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
	            content = content.slice(0, maxTagTextLength) + '...';
	          }
	          var disabled = _this2.isChildDisabled(singleValue.key);
	          var choiceClassName = disabled ? prefixCls + '-selection__choice ' + prefixCls + '-selection__choice__disabled' : prefixCls + '-selection__choice';
	          return _react2['default'].createElement(
	            'li',
	            (0, _extends3['default'])({
	              style: _util.UNSELECTABLE_STYLE
	            }, _util.UNSELECTABLE_ATTRIBUTE, {
	              onMouseDown: _util.preventDefaultEvent,
	              className: choiceClassName,
	              key: singleValue.key,
	              title: title
	            }),
	            _react2['default'].createElement(
	              'div',
	              { className: prefixCls + '-selection__choice__content' },
	              content
	            ),
	            disabled ? null : _react2['default'].createElement('span', {
	              className: prefixCls + '-selection__choice__remove',
	              onClick: _this2.removeSelected.bind(_this2, singleValue.key)
	            })
	          );
	        });
	      }
	      selectedValueNodes.push(_react2['default'].createElement(
	        'li',
	        {
	          className: prefixCls + '-search ' + prefixCls + '-search--inline',
	          key: '__input'
	        },
	        _this2.getInputElement()
	      ));
	
	      if ((0, _util.isMultipleOrTags)(props) && choiceTransitionName) {
	        innerNode = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            onLeave: _this2.onChoiceAnimationLeave,
	            component: 'ul',
	            transitionName: choiceTransitionName
	          },
	          selectedValueNodes
	        );
	      } else {
	        innerNode = _react2['default'].createElement(
	          'ul',
	          null,
	          selectedValueNodes
	        );
	      }
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: className, ref: function ref(node) {
	          return _this2.topCtrlNode = node;
	        } },
	      _this2.getPlaceholderElement(),
	      innerNode
	    );
	  };
	};
	
	exports['default'] = Select;
	
	
	Select.displayName = 'Select';
	module.exports = exports['default'];

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _rcTrigger = __webpack_require__(1589);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(52);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DropdownMenu = __webpack_require__(1581);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _util = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_rcTrigger2['default'].displayName = 'Trigger';
	
	var BUILT_IN_PLACEMENTS = {
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  }
	};
	
	var SelectTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(SelectTrigger, _React$Component);
	
	  function SelectTrigger() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, SelectTrigger);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = SelectTrigger.__proto__ || Object.getPrototypeOf(SelectTrigger)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      dropdownWidth: null
	    }, _this.setDropdownWidth = function () {
	      var width = _reactDom2['default'].findDOMNode(_this).offsetWidth;
	      if (width !== _this.state.dropdownWidth) {
	        _this.setState({ dropdownWidth: width });
	      }
	    }, _this.getInnerMenu = function () {
	      return _this.popupMenu && _this.popupMenu.refs.menu;
	    }, _this.getPopupDOMNode = function () {
	      return _this.refs.trigger.getPopupDomNode();
	    }, _this.getDropdownElement = function (newProps) {
	      var props = _this.props;
	      return _react2['default'].createElement(_DropdownMenu2['default'], (0, _extends3['default'])({
	        ref: _this.saveMenu
	      }, newProps, {
	        prefixCls: _this.getDropdownPrefixCls(),
	        onMenuSelect: props.onMenuSelect,
	        onMenuDeselect: props.onMenuDeselect,
	        value: props.value,
	        firstActiveValue: props.firstActiveValue,
	        defaultActiveFirstOption: props.defaultActiveFirstOption,
	        dropdownMenuStyle: props.dropdownMenuStyle
	      }));
	    }, _this.getDropdownTransitionName = function () {
	      var props = _this.props;
	      var transitionName = props.transitionName;
	      if (!transitionName && props.animation) {
	        transitionName = _this.getDropdownPrefixCls() + '-' + props.animation;
	      }
	      return transitionName;
	    }, _this.getDropdownPrefixCls = function () {
	      return _this.props.prefixCls + '-dropdown';
	    }, _this.saveMenu = function (menu) {
	      _this.popupMenu = menu;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(SelectTrigger, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setDropdownWidth();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setDropdownWidth();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _popupClassName;
	
	      var _props = this.props,
	          onPopupFocus = _props.onPopupFocus,
	          props = (0, _objectWithoutProperties3['default'])(_props, ['onPopupFocus']);
	      var multiple = props.multiple,
	          visible = props.visible,
	          inputValue = props.inputValue,
	          dropdownAlign = props.dropdownAlign,
	          disabled = props.disabled,
	          showSearch = props.showSearch,
	          dropdownClassName = props.dropdownClassName,
	          dropdownStyle = props.dropdownStyle,
	          dropdownMatchSelectWidth = props.dropdownMatchSelectWidth;
	
	      var dropdownPrefixCls = this.getDropdownPrefixCls();
	      var popupClassName = (_popupClassName = {}, (0, _defineProperty3['default'])(_popupClassName, dropdownClassName, !!dropdownClassName), (0, _defineProperty3['default'])(_popupClassName, dropdownPrefixCls + '--' + (multiple ? 'multiple' : 'single'), 1), _popupClassName);
	      var popupElement = this.getDropdownElement({
	        menuItems: props.options,
	        onPopupFocus: onPopupFocus,
	        multiple: multiple,
	        inputValue: inputValue,
	        visible: visible
	      });
	      var hideAction = void 0;
	      if (disabled) {
	        hideAction = [];
	      } else if ((0, _util.isSingleMode)(props) && !showSearch) {
	        hideAction = ['click'];
	      } else {
	        hideAction = ['blur'];
	      }
	      var popupStyle = (0, _extends3['default'])({}, dropdownStyle);
	      var widthProp = dropdownMatchSelectWidth ? 'width' : 'minWidth';
	      if (this.state.dropdownWidth) {
	        popupStyle[widthProp] = this.state.dropdownWidth + 'px';
	      }
	
	      return _react2['default'].createElement(
	        _rcTrigger2['default'],
	        (0, _extends3['default'])({}, props, {
	          showAction: disabled ? [] : ['click'],
	          hideAction: hideAction,
	          ref: 'trigger',
	          popupPlacement: 'bottomLeft',
	          builtinPlacements: BUILT_IN_PLACEMENTS,
	          prefixCls: dropdownPrefixCls,
	          popupTransitionName: this.getDropdownTransitionName(),
	          onPopupVisibleChange: props.onDropdownVisibleChange,
	          popup: popupElement,
	          popupAlign: dropdownAlign,
	          popupVisible: visible,
	          getPopupContainer: props.getPopupContainer,
	          popupClassName: (0, _classnames2['default'])(popupClassName),
	          popupStyle: popupStyle
	        }),
	        props.children
	      );
	    }
	  }]);
	  return SelectTrigger;
	}(_react2['default'].Component);
	
	SelectTrigger.propTypes = {
	  onPopupFocus: _propTypes2['default'].func,
	  dropdownMatchSelectWidth: _propTypes2['default'].bool,
	  dropdownAlign: _propTypes2['default'].object,
	  visible: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  showSearch: _propTypes2['default'].bool,
	  dropdownClassName: _propTypes2['default'].string,
	  multiple: _propTypes2['default'].bool,
	  inputValue: _propTypes2['default'].string,
	  filterOption: _propTypes2['default'].any,
	  options: _propTypes2['default'].any,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  children: _propTypes2['default'].any
	};
	exports['default'] = SelectTrigger;
	
	
	SelectTrigger.displayName = 'SelectTrigger';
	module.exports = exports['default'];

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectPropTypes = exports.OptGroup = exports.Option = undefined;
	
	var _Select = __webpack_require__(1584);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Option = __webpack_require__(1583);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _PropTypes = __webpack_require__(536);
	
	var _OptGroup = __webpack_require__(1582);
	
	var _OptGroup2 = _interopRequireDefault(_OptGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Select2['default'].Option = _Option2['default'];
	_Select2['default'].OptGroup = _OptGroup2['default'];
	exports.Option = _Option2['default'];
	exports.OptGroup = _OptGroup2['default'];
	exports.SelectPropTypes = _PropTypes.SelectPropTypes;
	exports['default'] = _Select2['default'];

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(1567);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(234);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(1588);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(537);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Popup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.rootNode = this.getPopupDomNode();
	    }
	  }, {
	    key: 'getPopupDomNode',
	    value: function getPopupDomNode() {
	      return _reactDom2['default'].findDOMNode(this.popupInstance);
	    }
	  }, {
	    key: 'getMaskTransitionName',
	    value: function getMaskTransitionName() {
	      var props = this.props;
	      var transitionName = props.maskTransitionName;
	      var animation = props.maskAnimation;
	      if (!transitionName && animation) {
	        transitionName = props.prefixCls + '-' + animation;
	      }
	      return transitionName;
	    }
	  }, {
	    key: 'getTransitionName',
	    value: function getTransitionName() {
	      var props = this.props;
	      var transitionName = props.transitionName;
	      if (!transitionName && props.animation) {
	        transitionName = props.prefixCls + '-' + props.animation;
	      }
	      return transitionName;
	    }
	  }, {
	    key: 'getClassName',
	    value: function getClassName(currentAlignClassName) {
	      return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	    }
	  }, {
	    key: 'getPopupElement',
	    value: function getPopupElement() {
	      var savePopupRef = this.savePopupRef,
	          props = this.props;
	      var align = props.align,
	          style = props.style,
	          visible = props.visible,
	          prefixCls = props.prefixCls,
	          destroyPopupOnHide = props.destroyPopupOnHide;
	
	      var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
	      var hiddenClassName = prefixCls + '-hidden';
	      if (!visible) {
	        this.currentAlignClassName = null;
	      }
	      var newStyle = (0, _extends3['default'])({}, style, this.getZIndexStyle());
	      var popupInnerProps = {
	        className: className,
	        prefixCls: prefixCls,
	        ref: savePopupRef,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        style: newStyle
	      };
	      if (destroyPopupOnHide) {
	        return _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            component: '',
	            exclusive: true,
	            transitionAppear: true,
	            transitionName: this.getTransitionName()
	          },
	          visible ? _react2['default'].createElement(
	            _rcAlign2['default'],
	            {
	              target: this.getTarget,
	              key: 'popup',
	              ref: this.saveAlignRef,
	              monitorWindowResize: true,
	              align: align,
	              onAlign: this.onAlign
	            },
	            _react2['default'].createElement(
	              _PopupInner2['default'],
	              (0, _extends3['default'])({
	                visible: true
	              }, popupInnerProps),
	              props.children
	            )
	          ) : null
	        );
	      }
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName(),
	          showProp: 'xVisible'
	        },
	        _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getTarget,
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            xVisible: visible,
	            childrenProps: { visible: 'xVisible' },
	            disabled: !visible,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              hiddenClassName: hiddenClassName
	            }, popupInnerProps),
	            props.children
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getZIndexStyle',
	    value: function getZIndexStyle() {
	      var style = {};
	      var props = this.props;
	      if (props.zIndex !== undefined) {
	        style.zIndex = props.zIndex;
	      }
	      return style;
	    }
	  }, {
	    key: 'getMaskElement',
	    value: function getMaskElement() {
	      var props = this.props;
	      var maskElement = void 0;
	      if (props.mask) {
	        var maskTransition = this.getMaskTransitionName();
	        maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	          style: this.getZIndexStyle(),
	          key: 'mask',
	          className: props.prefixCls + '-mask',
	          hiddenClassName: props.prefixCls + '-mask-hidden',
	          visible: props.visible
	        });
	        if (maskTransition) {
	          maskElement = _react2['default'].createElement(
	            _rcAnimate2['default'],
	            {
	              key: 'mask',
	              showProp: 'visible',
	              transitionAppear: true,
	              component: '',
	              transitionName: maskTransition
	            },
	            maskElement
	          );
	        }
	      }
	      return maskElement;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        this.getMaskElement(),
	        this.getPopupElement()
	      );
	    }
	  }]);
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  onMouseEnter: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseLeave: _propTypes2['default'].func
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this2.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this2.currentAlignClassName !== currentAlignClassName) {
	      _this2.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this2.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.getTarget = function () {
	    return _this2.props.getRootDomNode();
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(537);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, (PopupInner.__proto__ || Object.getPrototypeOf(PopupInner)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(PopupInner, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var className = props.className;
	      if (!props.visible) {
	        className += ' ' + props.hiddenClassName;
	      }
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: className,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave,
	          style: props.style
	        },
	        _react2['default'].createElement(
	          _LazyRenderBox2['default'],
	          { className: props.prefixCls + '-content', visible: props.visible },
	          props.children
	        )
	      );
	    }
	  }]);
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _createReactClass = __webpack_require__(65);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _contains = __webpack_require__(539);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(236);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _Popup = __webpack_require__(1587);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _utils = __webpack_require__(538);
	
	var _getContainerRenderMixin = __webpack_require__(1592);
	
	var _getContainerRenderMixin2 = _interopRequireDefault(_getContainerRenderMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var isMobile = typeof navigator !== 'undefined' && !!navigator.userAgent.match(/(Android|iPhone|iPad|iPod|iOS|UCWEB)/i);
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];
	
	var Trigger = (0, _createReactClass2['default'])({
	  displayName: 'Trigger',
	  propTypes: {
	    children: _propTypes2['default'].any,
	    action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	    showAction: _propTypes2['default'].any,
	    hideAction: _propTypes2['default'].any,
	    getPopupClassNameFromAlign: _propTypes2['default'].any,
	    onPopupVisibleChange: _propTypes2['default'].func,
	    afterPopupVisibleChange: _propTypes2['default'].func,
	    popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	    popupStyle: _propTypes2['default'].object,
	    prefixCls: _propTypes2['default'].string,
	    popupClassName: _propTypes2['default'].string,
	    popupPlacement: _propTypes2['default'].string,
	    builtinPlacements: _propTypes2['default'].object,
	    popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    popupAnimation: _propTypes2['default'].any,
	    mouseEnterDelay: _propTypes2['default'].number,
	    mouseLeaveDelay: _propTypes2['default'].number,
	    zIndex: _propTypes2['default'].number,
	    focusDelay: _propTypes2['default'].number,
	    blurDelay: _propTypes2['default'].number,
	    getPopupContainer: _propTypes2['default'].func,
	    getDocument: _propTypes2['default'].func,
	    destroyPopupOnHide: _propTypes2['default'].bool,
	    mask: _propTypes2['default'].bool,
	    maskClosable: _propTypes2['default'].bool,
	    onPopupAlign: _propTypes2['default'].func,
	    popupAlign: _propTypes2['default'].object,
	    popupVisible: _propTypes2['default'].bool,
	    maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    maskAnimation: _propTypes2['default'].string
	  },
	
	  mixins: [(0, _getContainerRenderMixin2['default'])({
	    autoMount: false,
	
	    isVisible: function isVisible(instance) {
	      return instance.state.popupVisible;
	    },
	    getContainer: function getContainer(instance) {
	      var props = instance.props;
	
	      var popupContainer = document.createElement('div');
	      // Make sure default popup container will never cause scrollbar appearing
	      // https://github.com/react-component/trigger/issues/41
	      popupContainer.style.position = 'absolute';
	      popupContainer.style.top = '0';
	      popupContainer.style.left = '0';
	      popupContainer.style.width = '100%';
	      var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(instance)) : props.getDocument().body;
	      mountNode.appendChild(popupContainer);
	      return popupContainer;
	    }
	  })],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-trigger-popup',
	      getPopupClassNameFromAlign: returnEmptyString,
	      getDocument: returnDocument,
	      onPopupVisibleChange: noop,
	      afterPopupVisibleChange: noop,
	      onPopupAlign: noop,
	      popupClassName: '',
	      mouseEnterDelay: 0,
	      mouseLeaveDelay: 0.1,
	      focusDelay: 0,
	      blurDelay: 0.15,
	      popupStyle: {},
	      destroyPopupOnHide: false,
	      popupAlign: {},
	      defaultPopupVisible: false,
	      mask: false,
	      maskClosable: true,
	      action: [],
	      showAction: [],
	      hideAction: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	    return {
	      popupVisible: popupVisible
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var popupVisible = _ref.popupVisible;
	
	    if (popupVisible !== undefined) {
	      this.setState({
	        popupVisible: popupVisible
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    this.renderComponent(null, function () {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    });
	
	    // We must listen to `mousedown`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && this.isClickToHide()) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      // `isMobile` fix: mask clicked will cause below element events triggered
	      // https://github.com/ant-design/ant-design-mobile/issues/1909
	      // https://github.com/ant-design/ant-design-mobile/issues/1928
	      if (!this.touchOutsideHandler && isMobile) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'click', this.onDocumentClick);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    this.fireEvents('onMouseEnter', e);
	    this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    this.fireEvents('onMouseLeave', e);
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onPopupMouseEnter: function onPopupMouseEnter() {
	    this.clearDelayTimer();
	  },
	  onPopupMouseLeave: function onPopupMouseLeave(e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && this._component && this._component.getPopupDomNode && (0, _contains2['default'])(this._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onFocus: function onFocus(e) {
	    this.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    this.clearDelayTimer();
	    if (this.isFocusToShow()) {
	      this.focusTime = Date.now();
	      this.delaySetPopupVisible(true, this.props.focusDelay);
	    }
	  },
	  onMouseDown: function onMouseDown(e) {
	    this.fireEvents('onMouseDown', e);
	    this.preClickTime = Date.now();
	  },
	  onTouchStart: function onTouchStart(e) {
	    this.fireEvents('onTouchStart', e);
	    this.preTouchTime = Date.now();
	  },
	  onBlur: function onBlur(e) {
	    this.fireEvents('onBlur', e);
	    this.clearDelayTimer();
	    if (this.isBlurToHide()) {
	      this.delaySetPopupVisible(false, this.props.blurDelay);
	    }
	  },
	  onClick: function onClick(event) {
	    this.fireEvents('onClick', event);
	    // focus will trigger click
	    if (this.focusTime) {
	      var preTime = void 0;
	      if (this.preClickTime && this.preTouchTime) {
	        preTime = Math.min(this.preClickTime, this.preTouchTime);
	      } else if (this.preClickTime) {
	        preTime = this.preClickTime;
	      } else if (this.preTouchTime) {
	        preTime = this.preTouchTime;
	      }
	      if (Math.abs(preTime - this.focusTime) < 20) {
	        return;
	      }
	      this.focusTime = 0;
	    }
	    this.preClickTime = 0;
	    this.preTouchTime = 0;
	    event.preventDefault();
	    var nextVisible = !this.state.popupVisible;
	    if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
	      this.setPopupVisible(!this.state.popupVisible);
	    }
	  },
	  onDocumentClick: function onDocumentClick(event) {
	    if (this.props.mask && !this.props.maskClosable) {
	      return;
	    }
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(this);
	    var popupNode = this.getPopupDomNode();
	    if (!(0, _contains2['default'])(root, target) && !(0, _contains2['default'])(popupNode, target)) {
	      this.close();
	    }
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  },
	  getRootDomNode: function getRootDomNode() {
	    return (0, _reactDom.findDOMNode)(this);
	  },
	  getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
	    var className = [];
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        builtinPlacements = props.builtinPlacements,
	        prefixCls = props.prefixCls;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getPopupClassNameFromAlign)(builtinPlacements, prefixCls, align));
	    }
	    if (props.getPopupClassNameFromAlign) {
	      className.push(props.getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  },
	  getPopupAlign: function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  },
	  getComponent: function getComponent() {
	    var props = this.props,
	        state = this.state;
	
	    var mouseProps = {};
	    if (this.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = this.onPopupMouseEnter;
	    }
	    if (this.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = this.onPopupMouseLeave;
	    }
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: props.prefixCls,
	        destroyPopupOnHide: props.destroyPopupOnHide,
	        visible: state.popupVisible,
	        className: props.popupClassName,
	        action: props.action,
	        align: this.getPopupAlign(),
	        onAlign: props.onPopupAlign,
	        animation: props.popupAnimation,
	        getClassNameFromAlign: this.getPopupClassNameFromAlign
	      }, mouseProps, {
	        getRootDomNode: this.getRootDomNode,
	        style: props.popupStyle,
	        mask: props.mask,
	        zIndex: props.zIndex,
	        transitionName: props.popupTransitionName,
	        maskAnimation: props.maskAnimation,
	        maskTransitionName: props.maskTransitionName
	      }),
	      typeof props.popup === 'function' ? props.popup() : props.popup
	    );
	  },
	  setPopupVisible: function setPopupVisible(popupVisible) {
	    this.clearDelayTimer();
	    if (this.state.popupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({
	          popupVisible: popupVisible
	        });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	  },
	  delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible);
	    }
	  },
	  clearDelayTimer: function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  },
	  clearOutsideHandler: function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  },
	  createTwoChains: function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  },
	  isClickToShow: function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  },
	  isClickToHide: function isClickToHide() {
	    var _props2 = this.props,
	        action = _props2.action,
	        hideAction = _props2.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  },
	  isMouseEnterToShow: function isMouseEnterToShow() {
	    var _props3 = this.props,
	        action = _props3.action,
	        showAction = _props3.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  },
	  isMouseLeaveToHide: function isMouseLeaveToHide() {
	    var _props4 = this.props,
	        action = _props4.action,
	        hideAction = _props4.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  },
	  isFocusToShow: function isFocusToShow() {
	    var _props5 = this.props,
	        action = _props5.action,
	        showAction = _props5.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  },
	  isBlurToHide: function isBlurToHide() {
	    var _props6 = this.props,
	        action = _props6.action,
	        hideAction = _props6.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  },
	  forcePopupAlign: function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  },
	  fireEvents: function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  },
	  close: function close() {
	    this.setPopupVisible(false);
	  },
	  render: function render() {
	    var props = this.props;
	    var children = props.children;
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = {};
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    return _react2['default'].cloneElement(child, newChildProps);
	  }
	});
	
	exports['default'] = Trigger;
	module.exports = exports['default'];

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toArray;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArray(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (c) {
	    ret.push(c);
	  });
	  return ret;
	}
	module.exports = exports['default'];

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createChainedFunction;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  var args = [].slice.call(arguments, 0);
	  if (args.length === 1) {
	    return args[0];
	  }
	
	  return function chainedFunction() {
	    for (var i = 0; i < args.length; i++) {
	      if (args[i] && args[i].apply) {
	        args[i].apply(this, arguments);
	      }
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports['default'] = getContainerRenderMixin;
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function defaultGetContainer() {
	  var container = document.createElement('div');
	  document.body.appendChild(container);
	  return container;
	}
	
	function getContainerRenderMixin(config) {
	  var _config$autoMount = config.autoMount,
	      autoMount = _config$autoMount === undefined ? true : _config$autoMount,
	      _config$autoDestroy = config.autoDestroy,
	      autoDestroy = _config$autoDestroy === undefined ? true : _config$autoDestroy,
	      isVisible = config.isVisible,
	      isForceRender = config.isForceRender,
	      getComponent = config.getComponent,
	      _config$getContainer = config.getContainer,
	      getContainer = _config$getContainer === undefined ? defaultGetContainer : _config$getContainer;
	
	
	  var mixin = void 0;
	
	  function _renderComponent(instance, componentArg, ready) {
	    if (!isVisible || instance._component || isVisible(instance) || isForceRender && isForceRender(instance)) {
	      if (!instance._container) {
	        instance._container = getContainer(instance);
	      }
	      var component = void 0;
	      if (instance.getComponent) {
	        component = instance.getComponent(componentArg);
	      } else {
	        component = getComponent(instance, componentArg);
	      }
	      _reactDom2['default'].unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
	        instance._component = this;
	        if (ready) {
	          ready.call(this);
	        }
	      });
	    }
	  }
	
	  if (autoMount) {
	    mixin = (0, _extends3['default'])({}, mixin, {
	      componentDidMount: function componentDidMount() {
	        _renderComponent(this);
	      },
	      componentDidUpdate: function componentDidUpdate() {
	        _renderComponent(this);
	      }
	    });
	  }
	
	  if (!autoMount || !autoDestroy) {
	    mixin = (0, _extends3['default'])({}, mixin, {
	      renderComponent: function renderComponent(componentArg, ready) {
	        _renderComponent(this, componentArg, ready);
	      }
	    });
	  }
	
	  function _removeContainer(instance) {
	    if (instance._container) {
	      var container = instance._container;
	      _reactDom2['default'].unmountComponentAtNode(container);
	      container.parentNode.removeChild(container);
	      instance._container = null;
	    }
	  }
	
	  if (autoDestroy) {
	    mixin = (0, _extends3['default'])({}, mixin, {
	      componentWillUnmount: function componentWillUnmount() {
	        _removeContainer(this);
	      }
	    });
	  } else {
	    mixin = (0, _extends3['default'])({}, mixin, {
	      removeContainer: function removeContainer() {
	        _removeContainer(this);
	      }
	    });
	  }
	
	  return mixin;
	}
	module.exports = exports['default'];

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _brace = __webpack_require__(168);
	
	var _brace2 = _interopRequireDefault(_brace);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(892);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ace$acequire = _brace2.default.acequire('ace/range'),
	    Range = _ace$acequire.Range;
	
	var editorOptions = ['minLines', 'maxLines', 'readOnly', 'highlightActiveLine', 'tabSize', 'enableBasicAutocompletion', 'enableLiveAutocompletion', 'enableSnippets'];
	
	var ReactAce = function (_Component) {
	  _inherits(ReactAce, _Component);
	
	  function ReactAce(props) {
	    _classCallCheck(this, ReactAce);
	
	    var _this = _possibleConstructorReturn(this, (ReactAce.__proto__ || Object.getPrototypeOf(ReactAce)).call(this, props));
	
	    ['onChange', 'onFocus', 'onBlur', 'onCopy', 'onPaste', 'onSelectionChange', 'onScroll', 'handleOptions', 'updateRef'].forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  _createClass(ReactAce, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          onBeforeLoad = _props.onBeforeLoad,
	          mode = _props.mode,
	          focus = _props.focus,
	          theme = _props.theme,
	          fontSize = _props.fontSize,
	          value = _props.value,
	          defaultValue = _props.defaultValue,
	          cursorStart = _props.cursorStart,
	          showGutter = _props.showGutter,
	          wrapEnabled = _props.wrapEnabled,
	          showPrintMargin = _props.showPrintMargin,
	          _props$scrollMargin = _props.scrollMargin,
	          scrollMargin = _props$scrollMargin === undefined ? [0, 0, 0, 0] : _props$scrollMargin,
	          keyboardHandler = _props.keyboardHandler,
	          onLoad = _props.onLoad,
	          commands = _props.commands,
	          annotations = _props.annotations,
	          markers = _props.markers;
	
	
	      this.editor = _brace2.default.edit(this.refEditor);
	
	      if (onBeforeLoad) {
	        onBeforeLoad(_brace2.default);
	      }
	
	      var editorProps = Object.keys(this.props.editorProps);
	      for (var i = 0; i < editorProps.length; i++) {
	        this.editor[editorProps[i]] = this.props.editorProps[editorProps[i]];
	      }
	
	      this.editor.renderer.setScrollMargin(scrollMargin[0], scrollMargin[1], scrollMargin[2], scrollMargin[3]);
	      this.editor.getSession().setMode('ace/mode/' + mode);
	      this.editor.setTheme('ace/theme/' + theme);
	      this.editor.setFontSize(fontSize);
	      this.editor.setValue(defaultValue === undefined ? value : defaultValue, cursorStart);
	      this.editor.renderer.setShowGutter(showGutter);
	      this.editor.getSession().setUseWrapMode(wrapEnabled);
	      this.editor.setShowPrintMargin(showPrintMargin);
	      this.editor.on('focus', this.onFocus);
	      this.editor.on('blur', this.onBlur);
	      this.editor.on('copy', this.onCopy);
	      this.editor.on('paste', this.onPaste);
	      this.editor.on('change', this.onChange);
	      this.editor.getSession().selection.on('changeSelection', this.onSelectionChange);
	      this.editor.session.on('changeScrollTop', this.onScroll);
	      this.handleOptions(this.props);
	      this.editor.getSession().setAnnotations(annotations || []);
	      if (markers && markers.length > 0) {
	        this.handleMarkers(markers);
	      }
	
	      // get a list of possible options to avoid 'misspelled option errors'
	      var availableOptions = this.editor.$options;
	      for (var _i = 0; _i < editorOptions.length; _i++) {
	        var option = editorOptions[_i];
	        if (availableOptions.hasOwnProperty(option)) {
	          this.editor.setOption(option, this.props[option]);
	        }
	      }
	
	      if (Array.isArray(commands)) {
	        commands.forEach(function (command) {
	          _this2.editor.commands.addCommand(command);
	        });
	      }
	
	      if (keyboardHandler) {
	        this.editor.setKeyboardHandler('ace/keyboard/' + keyboardHandler);
	      }
	
	      if (className) {
	        this.refEditor.className += ' ' + className;
	      }
	
	      if (focus) {
	        this.editor.focus();
	      }
	
	      if (onLoad) {
	        onLoad(this.editor);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var oldProps = this.props;
	
	      for (var i = 0; i < editorOptions.length; i++) {
	        var option = editorOptions[i];
	        if (nextProps[option] !== oldProps[option]) {
	          this.editor.setOption(option, nextProps[option]);
	        }
	      }
	
	      if (nextProps.className !== oldProps.className) {
	        var appliedClasses = this.refEditor.className;
	        var appliedClassesArray = appliedClasses.trim().split(' ');
	        var oldClassesArray = oldProps.className.trim().split(' ');
	        oldClassesArray.forEach(function (oldClass) {
	          var index = appliedClassesArray.indexOf(oldClass);
	          appliedClassesArray.splice(index, 1);
	        });
	        this.refEditor.className = ' ' + nextProps.className + ' ' + appliedClassesArray.join(' ');
	      }
	
	      if (nextProps.mode !== oldProps.mode) {
	        this.editor.getSession().setMode('ace/mode/' + nextProps.mode);
	      }
	      if (nextProps.theme !== oldProps.theme) {
	        this.editor.setTheme('ace/theme/' + nextProps.theme);
	      }
	      if (nextProps.keyboardHandler !== oldProps.keyboardHandler) {
	        if (nextProps.keyboardHandler) {
	          this.editor.setKeyboardHandler('ace/keyboard/' + nextProps.keyboardHandler);
	        } else {
	          this.editor.setKeyboardHandler(null);
	        }
	      }
	      if (nextProps.fontSize !== oldProps.fontSize) {
	        this.editor.setFontSize(nextProps.fontSize);
	      }
	      if (nextProps.wrapEnabled !== oldProps.wrapEnabled) {
	        this.editor.getSession().setUseWrapMode(nextProps.wrapEnabled);
	      }
	      if (nextProps.showPrintMargin !== oldProps.showPrintMargin) {
	        this.editor.setShowPrintMargin(nextProps.showPrintMargin);
	      }
	      if (nextProps.showGutter !== oldProps.showGutter) {
	        this.editor.renderer.setShowGutter(nextProps.showGutter);
	      }
	      if (!(0, _lodash2.default)(nextProps.setOptions, oldProps.setOptions)) {
	        this.handleOptions(nextProps);
	      }
	      if (!(0, _lodash2.default)(nextProps.annotations, oldProps.annotations)) {
	        this.editor.getSession().setAnnotations(nextProps.annotations || []);
	      }
	      if (!(0, _lodash2.default)(nextProps.markers, oldProps.markers) && nextProps.markers && nextProps.markers.length > 0) {
	        this.handleMarkers(nextProps.markers);
	      }
	
	      // this doesn't look like it works at all....
	      if (!(0, _lodash2.default)(nextProps.scrollMargin, oldProps.scrollMargin)) {
	        this.handleScrollMargins(nextProps.scrollMargin);
	      }
	      if (this.editor && this.editor.getValue() !== nextProps.value) {
	        // editor.setValue is a synchronous function call, change event is emitted before setValue return.
	        this.silent = true;
	        var pos = this.editor.session.selection.toJSON();
	        this.editor.setValue(nextProps.value, nextProps.cursorStart);
	        this.editor.session.selection.fromJSON(pos);
	        this.silent = false;
	      }
	
	      if (nextProps.focus && !oldProps.focus) {
	        this.editor.focus();
	      }
	      if (nextProps.height !== this.props.height || nextProps.width !== this.props.width) {
	        this.editor.resize();
	      }
	    }
	  }, {
	    key: 'handleScrollMargins',
	    value: function handleScrollMargins() {
	      var margins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, 0, 0, 0];
	
	      this.editor.renderer.setScrollMargins(margins[0], margins[1], margins[2], margins[3]);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.editor.destroy();
	      this.editor = null;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      if (this.props.onChange && !this.silent) {
	        var value = this.editor.getValue();
	        this.props.onChange(value, event);
	      }
	    }
	  }, {
	    key: 'onSelectionChange',
	    value: function onSelectionChange(event) {
	      if (this.props.onSelectionChange) {
	        var value = this.editor.getSelection();
	        this.props.onSelectionChange(value, event);
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus() {
	      if (this.props.onFocus) {
	        this.props.onFocus();
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      if (this.props.onBlur) {
	        this.props.onBlur();
	      }
	    }
	  }, {
	    key: 'onCopy',
	    value: function onCopy(text) {
	      if (this.props.onCopy) {
	        this.props.onCopy(text);
	      }
	    }
	  }, {
	    key: 'onPaste',
	    value: function onPaste(text) {
	      if (this.props.onPaste) {
	        this.props.onPaste(text);
	      }
	    }
	  }, {
	    key: 'onScroll',
	    value: function onScroll() {
	      if (this.props.onScroll) {
	        this.props.onScroll(this.editor);
	      }
	    }
	  }, {
	    key: 'handleOptions',
	    value: function handleOptions(props) {
	      var setOptions = Object.keys(props.setOptions);
	      for (var y = 0; y < setOptions.length; y++) {
	        this.editor.setOption(setOptions[y], props.setOptions[setOptions[y]]);
	      }
	    }
	  }, {
	    key: 'handleMarkers',
	    value: function handleMarkers(markers) {
	      var _this3 = this;
	
	      // remove foreground markers
	      var currentMarkers = this.editor.getSession().getMarkers(true);
	      for (var i in currentMarkers) {
	        if (currentMarkers.hasOwnProperty(i)) {
	          this.editor.getSession().removeMarker(currentMarkers[i].id);
	        }
	      }
	      // remove background markers
	      currentMarkers = this.editor.getSession().getMarkers(false);
	      for (var _i2 in currentMarkers) {
	        if (currentMarkers.hasOwnProperty(_i2)) {
	          this.editor.getSession().removeMarker(currentMarkers[_i2].id);
	        }
	      }
	      // add new markers
	      markers.forEach(function (_ref) {
	        var startRow = _ref.startRow,
	            startCol = _ref.startCol,
	            endRow = _ref.endRow,
	            endCol = _ref.endCol,
	            className = _ref.className,
	            type = _ref.type,
	            _ref$inFront = _ref.inFront,
	            inFront = _ref$inFront === undefined ? false : _ref$inFront;
	
	        var range = new Range(startRow, startCol, endRow, endCol);
	        _this3.editor.getSession().addMarker(range, className, type, inFront);
	      });
	    }
	  }, {
	    key: 'updateRef',
	    value: function updateRef(item) {
	      this.refEditor = item;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          name = _props2.name,
	          width = _props2.width,
	          height = _props2.height,
	          style = _props2.style;
	
	      var divStyle = _extends({ width: width, height: height }, style);
	      return _react2.default.createElement('div', { ref: this.updateRef,
	        id: name,
	        style: divStyle
	      });
	    }
	  }]);
	
	  return ReactAce;
	}(_react.Component);
	
	exports.default = ReactAce;
	
	
	ReactAce.propTypes = {
	  mode: _propTypes2.default.string,
	  focus: _propTypes2.default.bool,
	  theme: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  height: _propTypes2.default.string,
	  width: _propTypes2.default.string,
	  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  showGutter: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  onCopy: _propTypes2.default.func,
	  onPaste: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onScroll: _propTypes2.default.func,
	  value: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func,
	  onSelectionChange: _propTypes2.default.func,
	  onBeforeLoad: _propTypes2.default.func,
	  minLines: _propTypes2.default.number,
	  maxLines: _propTypes2.default.number,
	  readOnly: _propTypes2.default.bool,
	  highlightActiveLine: _propTypes2.default.bool,
	  tabSize: _propTypes2.default.number,
	  showPrintMargin: _propTypes2.default.bool,
	  cursorStart: _propTypes2.default.number,
	  editorProps: _propTypes2.default.object,
	  setOptions: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  scrollMargin: _propTypes2.default.array,
	  annotations: _propTypes2.default.array,
	  markers: _propTypes2.default.array,
	  keyboardHandler: _propTypes2.default.string,
	  wrapEnabled: _propTypes2.default.bool,
	  enableBasicAutocompletion: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
	  enableLiveAutocompletion: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
	  commands: _propTypes2.default.array
	};
	
	ReactAce.defaultProps = {
	  name: 'brace-editor',
	  focus: false,
	  mode: '',
	  theme: '',
	  height: '500px',
	  width: '500px',
	  value: '',
	  fontSize: 12,
	  showGutter: true,
	  onChange: null,
	  onPaste: null,
	  onLoad: null,
	  onScroll: null,
	  minLines: null,
	  maxLines: null,
	  readOnly: false,
	  highlightActiveLine: true,
	  showPrintMargin: true,
	  tabSize: 4,
	  cursorStart: 1,
	  editorProps: {},
	  style: {},
	  scrollMargin: [0, 0, 0, 0],
	  setOptions: {},
	  wrapEnabled: false,
	  enableBasicAutocompletion: false,
	  enableLiveAutocompletion: false
	};

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var REACT_ELEMENT_TYPE =
	  (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) ||
	  0xeac7;
	
	var emptyFunction = __webpack_require__(38);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	var didWarnAboutMaps = false;
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	function getIteratorFn(maybeIterable) {
	  var iteratorFn =
	    maybeIterable &&
	    ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
	      maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function(match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (
	    children === null ||
	    type === 'string' ||
	    type === 'number' ||
	    // The following is inlined from ReactElement. This means we can optimize
	    // some checks. React Fiber also inlines this logic for similar purposes.
	    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
	  ) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
	    );
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      if (false) {
	        // Warn about using Maps as children
	        if (iteratorFn === children.entries) {
	          warning(
	            didWarnAboutMaps,
	            'Using Maps as children is unsupported and will likely yield ' +
	              'unexpected results. Convert it to a sequence/iterable of keyed ' +
	              'ReactElements instead.'
	          );
	          didWarnAboutMaps = true;
	        }
	      }
	
	      var iterator = iteratorFn.call(children);
	      var step;
	      var ii = 0;
	      while (!(step = iterator.next()).done) {
	        child = step.value;
	        nextName = nextNamePrefix + getComponentKey(child, ii++);
	        subtreeCount += traverseAllChildrenImpl(
	          child,
	          nextName,
	          callback,
	          traverseContext
	        );
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum =
	          ' If you meant to render a collection of children, use an array ' +
	          'instead or wrap the object using createFragment(object) from the ' +
	          'React add-ons.';
	      }
	      var childrenString = '' + children;
	      invariant(
	        false,
	        'Objects are not valid as a React child (found: %s).%s',
	        childrenString === '[object Object]'
	          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
	          : childrenString,
	        addendum
	      );
	    }
	  }
	
	  return subtreeCount;
	}
	
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	function cloneAndReplaceKey(oldElement, newKey) {
	  return React.cloneElement(
	    oldElement,
	    {key: newKey},
	    oldElement.props !== undefined ? oldElement.props.children : undefined
	  );
	}
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  );
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function() {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(
	      mappedChild,
	      result,
	      childKey,
	      emptyFunction.thatReturnsArgument
	    );
	  } else if (mappedChild != null) {
	    if (React.isValidElement(mappedChild)) {
	      mappedChild = cloneAndReplaceKey(
	        mappedChild,
	        // Keep both the (mapped) and old keys if they differ, just as
	        // traverseAllChildren used to do for objects as children
	        keyPrefix +
	          (mappedChild.key && (!child || child.key !== mappedChild.key)
	            ? escapeUserProvidedKey(mappedChild.key) + '/'
	            : '') +
	          childKey
	      );
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(
	    array,
	    escapedPrefix,
	    func,
	    context
	  );
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	function createReactFragment(object) {
	  if (typeof object !== 'object' || !object || Array.isArray(object)) {
	    warning(
	      false,
	      'React.addons.createFragment only accepts a single object. Got: %s',
	      object
	    );
	    return object;
	  }
	  if (React.isValidElement(object)) {
	    warning(
	      false,
	      'React.addons.createFragment does not accept a ReactElement ' +
	        'without a wrapper object.'
	    );
	    return object;
	  }
	
	  invariant(
	    object.nodeType !== 1,
	    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
	      'elements are not valid children of React components.'
	  );
	
	  var result = [];
	
	  for (var key in object) {
	    if (false) {
	      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	        warning(
	          false,
	          'React.addons.createFragment(...): Child objects should have ' +
	            'non-numeric keys so ordering is preserved.'
	        );
	        warnedAboutNumeric = true;
	      }
	    }
	    mapIntoWithKeyPrefixInternal(
	      object[key],
	      result,
	      key,
	      emptyFunction.thatReturnsArgument
	    );
	  }
	
	  return result;
	}
	
	module.exports = createReactFragment;


/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(20);
	
	var focusNode = __webpack_require__(313);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(94);
	var ExecutionEnvironment = __webpack_require__(29);
	var FallbackCompositionState = __webpack_require__(1604);
	var SyntheticCompositionEvent = __webpack_require__(1641);
	var SyntheticInputEvent = __webpack_require__(1644);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(540);
	var ExecutionEnvironment = __webpack_require__(29);
	var ReactInstrumentation = __webpack_require__(43);
	
	var camelizeStyleName = __webpack_require__(839);
	var dangerousStyleValue = __webpack_require__(1650);
	var hyphenateStyleName = __webpack_require__(846);
	var memoizeStringOnly = __webpack_require__(850);
	var warning = __webpack_require__(16);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(93);
	var EventPropagators = __webpack_require__(94);
	var ExecutionEnvironment = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(46);
	var SyntheticEvent = __webpack_require__(56);
	
	var inputValueTracking = __webpack_require__(555);
	var getEventTarget = __webpack_require__(249);
	var isEventSupported = __webpack_require__(250);
	var isTextInputElement = __webpack_require__(557);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var DOMLazyTree = __webpack_require__(91);
	var ExecutionEnvironment = __webpack_require__(29);
	
	var createNodesFromMarkup = __webpack_require__(842);
	var emptyFunction = __webpack_require__(38);
	var invariant = __webpack_require__(11);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(94);
	var ReactDOMComponentTree = __webpack_require__(20);
	var SyntheticMouseEvent = __webpack_require__(155);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = {
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	};
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes
	};
	
	module.exports = EventConstants;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(76);
	
	var getTextContentAccessor = __webpack_require__(554);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(92);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(95);
	
	var instantiateReactComponent = __webpack_require__(556);
	var KeyEscapeUtils = __webpack_require__(240);
	var shouldUpdateReactComponent = __webpack_require__(251);
	var traverseAllChildren = __webpack_require__(559);
	var warning = __webpack_require__(16);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(562);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(237);
	var ReactDOMIDOperations = __webpack_require__(1614);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var React = __webpack_require__(97);
	var ReactComponentEnvironment = __webpack_require__(242);
	var ReactCurrentOwner = __webpack_require__(59);
	var ReactErrorUtils = __webpack_require__(243);
	var ReactInstanceMap = __webpack_require__(117);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactNodeTypes = __webpack_require__(550);
	var ReactReconciler = __webpack_require__(95);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(129);
	var invariant = __webpack_require__(11);
	var shallowEqual = __webpack_require__(105);
	var shouldUpdateReactComponent = __webpack_require__(251);
	var warning = __webpack_require__(16);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDefaultInjection = __webpack_require__(1622);
	var ReactMount = __webpack_require__(549);
	var ReactReconciler = __webpack_require__(95);
	var ReactUpdates = __webpack_require__(46);
	var ReactVersion = __webpack_require__(1635);
	
	var findDOMNode = __webpack_require__(1651);
	var getHostComponentFromComposite = __webpack_require__(553);
	var renderSubtreeIntoContainer = __webpack_require__(1658);
	var warning = __webpack_require__(16);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var AutoFocusUtils = __webpack_require__(1596);
	var CSSPropertyOperations = __webpack_require__(1598);
	var DOMLazyTree = __webpack_require__(91);
	var DOMNamespaces = __webpack_require__(238);
	var DOMProperty = __webpack_require__(92);
	var DOMPropertyOperations = __webpack_require__(542);
	var EventPluginHub = __webpack_require__(93);
	var EventPluginRegistry = __webpack_require__(239);
	var ReactBrowserEventEmitter = __webpack_require__(154);
	var ReactDOMComponentFlags = __webpack_require__(543);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMInput = __webpack_require__(1615);
	var ReactDOMOption = __webpack_require__(1616);
	var ReactDOMSelect = __webpack_require__(544);
	var ReactDOMTextarea = __webpack_require__(1619);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactMultiChild = __webpack_require__(1628);
	var ReactServerRenderingTransaction = __webpack_require__(1633);
	
	var emptyFunction = __webpack_require__(38);
	var escapeTextContentForBrowser = __webpack_require__(157);
	var invariant = __webpack_require__(11);
	var isEventSupported = __webpack_require__(250);
	var shallowEqual = __webpack_require__(105);
	var inputValueTracking = __webpack_require__(555);
	var validateDOMNesting = __webpack_require__(252);
	var warning = __webpack_require__(16);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(252);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var DOMLazyTree = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(20);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(237);
	var ReactDOMComponentTree = __webpack_require__(20);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var DOMPropertyOperations = __webpack_require__(542);
	var LinkedValueUtils = __webpack_require__(241);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(46);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var React = __webpack_require__(97);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMSelect = __webpack_require__(544);
	
	var warning = __webpack_require__(16);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	var getNodeForCharacterOffset = __webpack_require__(1655);
	var getTextContentAccessor = __webpack_require__(554);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var DOMChildrenOperations = __webpack_require__(237);
	var DOMLazyTree = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(20);
	
	var escapeTextContentForBrowser = __webpack_require__(157);
	var invariant = __webpack_require__(11);
	var validateDOMNesting = __webpack_require__(252);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var LinkedValueUtils = __webpack_require__(241);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(46);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactUpdates = __webpack_require__(46);
	var Transaction = __webpack_require__(156);
	
	var emptyFunction = __webpack_require__(38);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1595);
	var BeforeInputEventPlugin = __webpack_require__(1597);
	var ChangeEventPlugin = __webpack_require__(1599);
	var DefaultEventPluginOrder = __webpack_require__(1601);
	var EnterLeaveEventPlugin = __webpack_require__(1602);
	var HTMLDOMPropertyConfig = __webpack_require__(1605);
	var ReactComponentBrowserEnvironment = __webpack_require__(1607);
	var ReactDOMComponent = __webpack_require__(1610);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMEmptyComponent = __webpack_require__(1612);
	var ReactDOMTreeTraversal = __webpack_require__(1620);
	var ReactDOMTextComponent = __webpack_require__(1618);
	var ReactDefaultBatchingStrategy = __webpack_require__(1621);
	var ReactEventListener = __webpack_require__(1625);
	var ReactInjection = __webpack_require__(1626);
	var ReactReconcileTransaction = __webpack_require__(1631);
	var SVGDOMPropertyConfig = __webpack_require__(1636);
	var SelectEventPlugin = __webpack_require__(1637);
	var SimpleEventPlugin = __webpack_require__(1638);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 1623 */
563,
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(93);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var EventListener = __webpack_require__(312);
	var ExecutionEnvironment = __webpack_require__(29);
	var PooledClass = __webpack_require__(76);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(46);
	
	var getEventTarget = __webpack_require__(249);
	var getUnboundedScrollPosition = __webpack_require__(844);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(92);
	var EventPluginHub = __webpack_require__(93);
	var EventPluginUtils = __webpack_require__(153);
	var ReactComponentEnvironment = __webpack_require__(242);
	var ReactEmptyComponent = __webpack_require__(545);
	var ReactBrowserEventEmitter = __webpack_require__(154);
	var ReactHostComponent = __webpack_require__(547);
	var ReactUpdates = __webpack_require__(46);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1649);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactComponentEnvironment = __webpack_require__(242);
	var ReactInstanceMap = __webpack_require__(117);
	var ReactInstrumentation = __webpack_require__(43);
	
	var ReactCurrentOwner = __webpack_require__(59);
	var ReactReconciler = __webpack_require__(95);
	var ReactChildReconciler = __webpack_require__(1606);
	
	var emptyFunction = __webpack_require__(38);
	var flattenChildren = __webpack_require__(1652);
	var invariant = __webpack_require__(11);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var CallbackQueue = __webpack_require__(541);
	var PooledClass = __webpack_require__(76);
	var ReactBrowserEventEmitter = __webpack_require__(154);
	var ReactInputSelection = __webpack_require__(548);
	var ReactInstrumentation = __webpack_require__(43);
	var Transaction = __webpack_require__(156);
	var ReactUpdateQueue = __webpack_require__(244);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1629);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(76);
	var Transaction = __webpack_require__(156);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactServerUpdateQueue = __webpack_require__(1634);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(244);
	
	var warning = __webpack_require__(16);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(94);
	var ExecutionEnvironment = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInputSelection = __webpack_require__(548);
	var SyntheticEvent = __webpack_require__(56);
	
	var getActiveElement = __webpack_require__(314);
	var isTextInputElement = __webpack_require__(557);
	var shallowEqual = __webpack_require__(105);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var EventListener = __webpack_require__(312);
	var EventPropagators = __webpack_require__(94);
	var ReactDOMComponentTree = __webpack_require__(20);
	var SyntheticAnimationEvent = __webpack_require__(1639);
	var SyntheticClipboardEvent = __webpack_require__(1640);
	var SyntheticEvent = __webpack_require__(56);
	var SyntheticFocusEvent = __webpack_require__(1643);
	var SyntheticKeyboardEvent = __webpack_require__(1645);
	var SyntheticMouseEvent = __webpack_require__(155);
	var SyntheticDragEvent = __webpack_require__(1642);
	var SyntheticTouchEvent = __webpack_require__(1646);
	var SyntheticTransitionEvent = __webpack_require__(1647);
	var SyntheticUIEvent = __webpack_require__(96);
	var SyntheticWheelEvent = __webpack_require__(1648);
	
	var emptyFunction = __webpack_require__(38);
	var getEventCharCode = __webpack_require__(247);
	var invariant = __webpack_require__(11);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(155);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(96);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(96);
	
	var getEventCharCode = __webpack_require__(247);
	var getEventKey = __webpack_require__(1653);
	var getEventModifierState = __webpack_require__(248);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(96);
	
	var getEventModifierState = __webpack_require__(248);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(155);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(540);
	var warning = __webpack_require__(16);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(59);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInstanceMap = __webpack_require__(117);
	
	var getHostComponentFromComposite = __webpack_require__(553);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(240);
	var traverseAllChildren = __webpack_require__(559);
	var warning = __webpack_require__(16);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(562);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(247);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(29);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(157);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(549);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(19));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else if(typeof exports === 'object')
			exports["Dropzone"] = factory(require("react"), require("prop-types"));
		else
			root["Dropzone"] = factory(root["react"], root["prop-types"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _attrAccept = __webpack_require__(4);
		
		var _attrAccept2 = _interopRequireDefault(_attrAccept);
		
		var _getDataTransferItems = __webpack_require__(5);
		
		var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
		
		var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
		
		function fileAccepted(file, accept) {
		  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
		  // that MIME type will always be accepted
		  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
		}
		
		var Dropzone = function (_React$Component) {
		  _inherits(Dropzone, _React$Component);
		
		  _createClass(Dropzone, null, [{
		    key: 'onDocumentDragOver',
		    value: function onDocumentDragOver(evt) {
		      // allow the entire document to be a drag target
		      evt.preventDefault();
		    }
		  }]);
		
		  function Dropzone(props, context) {
		    _classCallCheck(this, Dropzone);
		
		    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
		
		    _this.renderChildren = function (children, isDragActive, isDragReject) {
		      if (typeof children === 'function') {
		        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
		      }
		      return children;
		    };
		
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
		    _this.onDragStart = _this.onDragStart.bind(_this);
		    _this.onDragEnter = _this.onDragEnter.bind(_this);
		    _this.onDragLeave = _this.onDragLeave.bind(_this);
		    _this.onDragOver = _this.onDragOver.bind(_this);
		    _this.onDrop = _this.onDrop.bind(_this);
		    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
		    _this.setRef = _this.setRef.bind(_this);
		    _this.setRefs = _this.setRefs.bind(_this);
		    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
		    _this.isFileDialogActive = false;
		    _this.state = {
		      draggedFiles: [],
		      acceptedFiles: [],
		      rejectedFiles: []
		    };
		    return _this;
		  }
		
		  _createClass(Dropzone, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      this.dragTargets = [];
		
		      if (preventDropOnDocument) {
		        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
		        document.addEventListener('drop', this.onDocumentDrop, false);
		      }
		      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
		      // Tried implementing addEventListener, but didn't work out
		      document.body.onfocus = this.onFileDialogCancel;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      if (preventDropOnDocument) {
		        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
		        document.removeEventListener('drop', this.onDocumentDrop);
		      }
		      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
		      // Can be replaced with removeEventListener, if addEventListener works
		      document.body.onfocus = null;
		    }
		  }, {
		    key: 'onDocumentDrop',
		    value: function onDocumentDrop(evt) {
		      if (this.node.contains(evt.target)) {
		        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
		        return;
		      }
		      evt.preventDefault();
		      this.dragTargets = [];
		    }
		  }, {
		    key: 'onDragStart',
		    value: function onDragStart(evt) {
		      if (this.props.onDragStart) {
		        this.props.onDragStart.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragEnter',
		    value: function onDragEnter(evt) {
		      evt.preventDefault();
		
		      // Count the dropzone and any children that are entered.
		      if (this.dragTargets.indexOf(evt.target) === -1) {
		        this.dragTargets.push(evt.target);
		      }
		
		      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
		
		      if (this.props.onDragEnter) {
		        this.props.onDragEnter.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragOver',
		    value: function onDragOver(evt) {
		      // eslint-disable-line class-methods-use-this
		      evt.preventDefault();
		      evt.stopPropagation();
		      try {
		        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
		      } catch (err) {
		        // continue regardless of error
		      }
		
		      if (this.props.onDragOver) {
		        this.props.onDragOver.call(this, evt);
		      }
		      return false;
		    }
		  }, {
		    key: 'onDragLeave',
		    value: function onDragLeave(evt) {
		      var _this2 = this;
		
		      evt.preventDefault();
		
		      // Only deactivate once the dropzone and all children have been left.
		      this.dragTargets = this.dragTargets.filter(function (el) {
		        return el !== evt.target && _this2.node.contains(el);
		      });
		      if (this.dragTargets.length > 0) {
		        return;
		      }
		
		      // Clear dragging files state
		      this.setState({ draggedFiles: [] });
		
		      if (this.props.onDragLeave) {
		        this.props.onDragLeave.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDrop',
		    value: function onDrop(evt) {
		      var _this3 = this;
		
		      var _props = this.props,
		          onDrop = _props.onDrop,
		          onDropAccepted = _props.onDropAccepted,
		          onDropRejected = _props.onDropRejected,
		          multiple = _props.multiple,
		          disablePreview = _props.disablePreview,
		          accept = _props.accept;
		
		      var fileList = (0, _getDataTransferItems2.default)(evt);
		      var acceptedFiles = [];
		      var rejectedFiles = [];
		
		      // Stop default browser behavior
		      evt.preventDefault();
		
		      // Reset the counter along with the drag on a drop.
		      this.dragTargets = [];
		      this.isFileDialogActive = false;
		
		      fileList.forEach(function (file) {
		        if (!disablePreview) {
		          try {
		            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
		          } catch (err) {
		            if (process.env.NODE_ENV !== 'production') {
		              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
		            }
		          }
		        }
		
		        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
		          acceptedFiles.push(file);
		        } else {
		          rejectedFiles.push(file);
		        }
		      });
		
		      if (!multiple) {
		        // if not in multi mode add any extra accepted files to rejected.
		        // This will allow end users to easily ignore a multi file drop in "single" mode.
		        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
		      }
		
		      if (onDrop) {
		        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
		      }
		
		      if (rejectedFiles.length > 0 && onDropRejected) {
		        onDropRejected.call(this, rejectedFiles, evt);
		      }
		
		      if (acceptedFiles.length > 0 && onDropAccepted) {
		        onDropAccepted.call(this, acceptedFiles, evt);
		      }
		
		      // Clear files value
		      this.draggedFiles = null;
		
		      // Reset drag state
		      this.setState({
		        draggedFiles: [],
		        acceptedFiles: acceptedFiles,
		        rejectedFiles: rejectedFiles
		      });
		    }
		  }, {
		    key: 'onClick',
		    value: function onClick(evt) {
		      var _props2 = this.props,
		          onClick = _props2.onClick,
		          disableClick = _props2.disableClick;
		
		      if (!disableClick) {
		        evt.stopPropagation();
		
		        if (onClick) {
		          onClick.call(this, evt);
		        }
		
		        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
		        // this is so react can handle state changes in the onClick prop above above
		        // see: https://github.com/okonet/react-dropzone/issues/450
		        setTimeout(this.open.bind(this), 0);
		      }
		    }
		  }, {
		    key: 'onInputElementClick',
		    value: function onInputElementClick(evt) {
		      evt.stopPropagation();
		      if (this.props.inputProps && this.props.inputProps.onClick) {
		        this.props.inputProps.onClick();
		      }
		    }
		  }, {
		    key: 'onFileDialogCancel',
		    value: function onFileDialogCancel() {
		      // timeout will not recognize context of this method
		      var onFileDialogCancel = this.props.onFileDialogCancel;
		      var fileInputEl = this.fileInputEl;
		      var isFileDialogActive = this.isFileDialogActive;
		      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
		      // is opened in the browser
		
		      if (onFileDialogCancel && isFileDialogActive) {
		        setTimeout(function () {
		          // Returns an object as FileList
		          var FileList = fileInputEl.files;
		          if (!FileList.length) {
		            isFileDialogActive = false;
		            onFileDialogCancel();
		          }
		        }, 300);
		      }
		    }
		  }, {
		    key: 'setRef',
		    value: function setRef(ref) {
		      this.node = ref;
		    }
		  }, {
		    key: 'setRefs',
		    value: function setRefs(ref) {
		      this.fileInputEl = ref;
		    }
		  }, {
		    key: 'fileMatchSize',
		    value: function fileMatchSize(file) {
		      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
		    }
		  }, {
		    key: 'allFilesAccepted',
		    value: function allFilesAccepted(files) {
		      var _this4 = this;
		
		      return files.every(function (file) {
		        return fileAccepted(file, _this4.props.accept);
		      });
		    }
		
		    /**
		     * Open system file upload dialog.
		     *
		     * @public
		     */
		
		  }, {
		    key: 'open',
		    value: function open() {
		      this.isFileDialogActive = true;
		      this.fileInputEl.value = null;
		      this.fileInputEl.click();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props3 = this.props,
		          accept = _props3.accept,
		          activeClassName = _props3.activeClassName,
		          inputProps = _props3.inputProps,
		          multiple = _props3.multiple,
		          name = _props3.name,
		          rejectClassName = _props3.rejectClassName,
		          children = _props3.children,
		          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
		
		      var activeStyle = rest.activeStyle,
		          className = rest.className,
		          rejectStyle = rest.rejectStyle,
		          style = rest.style,
		          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
		
		      var draggedFiles = this.state.draggedFiles;
		
		      var filesCount = draggedFiles.length;
		      var isMultipleAllowed = multiple || filesCount <= 1;
		      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
		      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
		
		      className = className || '';
		
		      if (isDragActive && activeClassName) {
		        className += ' ' + activeClassName;
		      }
		      if (isDragReject && rejectClassName) {
		        className += ' ' + rejectClassName;
		      }
		
		      if (!className && !style && !activeStyle && !rejectStyle) {
		        style = {
		          width: 200,
		          height: 200,
		          borderWidth: 2,
		          borderColor: '#666',
		          borderStyle: 'dashed',
		          borderRadius: 5
		        };
		        activeStyle = {
		          borderStyle: 'solid',
		          borderColor: '#6c6',
		          backgroundColor: '#eee'
		        };
		        rejectStyle = {
		          borderStyle: 'solid',
		          borderColor: '#c66',
		          backgroundColor: '#eee'
		        };
		      }
		
		      var appliedStyle = void 0;
		      if (activeStyle && isDragActive) {
		        appliedStyle = _extends({}, style, activeStyle);
		      } else if (rejectStyle && isDragReject) {
		        appliedStyle = _extends({}, style, rejectStyle);
		      } else {
		        appliedStyle = _extends({}, style);
		      }
		
		      var inputAttributes = {
		        accept: accept,
		        type: 'file',
		        style: { display: 'none' },
		        multiple: supportMultiple && multiple,
		        ref: this.setRefs,
		        onChange: this.onDrop
		      };
		
		      if (name && name.length) {
		        inputAttributes.name = name;
		      }
		
		      // Remove custom properties before passing them to the wrapper div element
		      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
		      var divProps = _extends({}, props);
		      customProps.forEach(function (prop) {
		        return delete divProps[prop];
		      });
		
		      return _react2.default.createElement(
		        'div',
		        _extends({
		          className: className,
		          style: appliedStyle
		        }, divProps /* expand user provided props first so event handlers are never overridden */, {
		          onClick: this.onClick,
		          onDragStart: this.onDragStart,
		          onDragEnter: this.onDragEnter,
		          onDragOver: this.onDragOver,
		          onDragLeave: this.onDragLeave,
		          onDrop: this.onDrop,
		          ref: this.setRef
		        }),
		        this.renderChildren(children, isDragActive, isDragReject),
		        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
		      );
		    }
		  }]);
		
		  return Dropzone;
		}(_react2.default.Component);
		
		Dropzone.propTypes = {
		  /**
		   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
		   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
		   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
		   * Windows. In some cases there might not be a mime type set at all.
		   * See: https://github.com/okonet/react-dropzone/issues/276
		   */
		  accept: _propTypes2.default.string,
		
		  /**
		   * Contents of the dropzone
		   */
		  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
		
		  /**
		   * Disallow clicking on the dropzone container to open file dialog
		   */
		  disableClick: _propTypes2.default.bool,
		
		  /**
		   * Enable/disable preview generation
		   */
		  disablePreview: _propTypes2.default.bool,
		
		  /**
		   * If false, allow dropped items to take over the current browser window
		   */
		  preventDropOnDocument: _propTypes2.default.bool,
		
		  /**
		   * Pass additional attributes to the `<input type="file"/>` tag
		   */
		  inputProps: _propTypes2.default.object,
		
		  /**
		   * Allow dropping multiple files
		   */
		  multiple: _propTypes2.default.bool,
		
		  /**
		   * `name` attribute for the input tag
		   */
		  name: _propTypes2.default.string,
		
		  /**
		   * Maximum file size
		   */
		  maxSize: _propTypes2.default.number,
		
		  /**
		   * Minimum file size
		   */
		  minSize: _propTypes2.default.number,
		
		  /**
		   * className
		   */
		  className: _propTypes2.default.string,
		
		  /**
		   * className for accepted state
		   */
		  activeClassName: _propTypes2.default.string,
		
		  /**
		   * className for rejected state
		   */
		  rejectClassName: _propTypes2.default.string,
		
		  /**
		   * CSS styles to apply
		   */
		  style: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be accepted
		   */
		  activeStyle: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be rejected
		   */
		  rejectStyle: _propTypes2.default.object,
		
		  /**
		   * onClick callback
		   * @param {Event} event
		   */
		  onClick: _propTypes2.default.func,
		
		  /**
		   * onDrop callback
		   */
		  onDrop: _propTypes2.default.func,
		
		  /**
		   * onDropAccepted callback
		   */
		  onDropAccepted: _propTypes2.default.func,
		
		  /**
		   * onDropRejected callback
		   */
		  onDropRejected: _propTypes2.default.func,
		
		  /**
		   * onDragStart callback
		   */
		  onDragStart: _propTypes2.default.func,
		
		  /**
		   * onDragEnter callback
		   */
		  onDragEnter: _propTypes2.default.func,
		
		  /**
		   * onDragOver callback
		   */
		  onDragOver: _propTypes2.default.func,
		
		  /**
		   * onDragLeave callback
		   */
		  onDragLeave: _propTypes2.default.func,
		
		  /**
		   * Provide a callback on clicking the cancel button of the file dialog
		   */
		  onFileDialogCancel: _propTypes2.default.func
		};
		
		Dropzone.defaultProps = {
		  preventDropOnDocument: true,
		  disablePreview: false,
		  disableClick: false,
		  multiple: true,
		  maxSize: Infinity,
		  minSize: 0
		};
		
		exports.default = Dropzone;
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
		
		process.listeners = function (name) { return [] }
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getDataTransferFiles;
		function getDataTransferFiles(event) {
		  var dataTransferItemsList = [];
		  if (event.dataTransfer) {
		    var dt = event.dataTransfer;
		    if (dt.files && dt.files.length) {
		      dataTransferItemsList = dt.files;
		    } else if (dt.items && dt.items.length) {
		      // During the drag even the dataTransfer.files is null
		      // but Chrome implements some drag store, which is accesible via dataTransfer.items
		      dataTransferItemsList = dt.items;
		    }
		  } else if (event.target && event.target.files) {
		    dataTransferItemsList = event.target.files;
		  }
		  // Convert from DataTransferItemsList to the native Array
		  return Array.prototype.slice.call(dataTransferItemsList);
		}
		module.exports = exports["default"];
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(165);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = defineProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function defineProperty(o, p, attr) {
	  return (0, _defineProperty2.default)(o, p, attr);
	}

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;
	
	var _defineProperty = __webpack_require__(1660);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
	var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;
	
	// IE8+ Support
	var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
	var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (e) {} // eslint-disable-line no-empty
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(77);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _Number = __webpack_require__(255);
	
	var _Number2 = _interopRequireDefault(_Number);
	
	var _Text = __webpack_require__(256);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextArea = __webpack_require__(257);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	var _Select = __webpack_require__(161);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Radios = __webpack_require__(160);
	
	var _Radios2 = _interopRequireDefault(_Radios);
	
	var _Date = __webpack_require__(254);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	var _Checkbox = __webpack_require__(253);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Help = __webpack_require__(159);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _ComposedComponent = __webpack_require__(58);
	
	var _ComposedComponent2 = _interopRequireDefault(_ComposedComponent);
	
	var _RaisedButton = __webpack_require__(142);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _lodash = __webpack_require__(87);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SchemaForm = __webpack_require__(560);
	
	var _SchemaForm2 = _interopRequireDefault(_SchemaForm);
	
	var _IconButton = __webpack_require__(45);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 11/09/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Array = function (_React$Component) {
	    _inherits(Array, _React$Component);
	
	    function Array(props) {
	        _classCallCheck(this, Array);
	
	        var _this = _possibleConstructorReturn(this, (Array.__proto__ || Object.getPrototypeOf(Array)).call(this, props));
	
	        _this.onAppend = _this.onAppend.bind(_this);
	        _this.onDelete = _this.onDelete.bind(_this);
	        // we have the model here for the entire form, get the model for this array only
	        // and add to the state. if is empty, add an entry by calling onAppend directly.
	        _this.state = {
	            model: _utils2.default.selectOrSet(_this.props.form.key, _this.props.model) || []
	        };
	        //console.log('constructor', this.props.form.key, this.props.model, this.state.model);
	        return _this;
	    }
	
	    _createClass(Array, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.model && nextProps.form && nextProps.form.key) {
	                this.setState({
	                    model: _utils2.default.selectOrSet(nextProps.form.key, nextProps.model) || []
	                });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Always start with one empty form unless configured otherwise.
	            if (this.props.form.startEmpty !== true && this.state.model.length === 0) {
	                this.onAppend();
	            }
	        }
	    }, {
	        key: 'onAppend',
	        value: function onAppend() {
	            //console.log('onAppend is called this.state.model', this.state.model);
	            var empty;
	            if (this.props.form && this.props.form.schema && this.props.form.schema.items) {
	                var items = this.props.form.schema.items;
	                if (items.type && items.type.indexOf('object') !== -1) {
	                    empty = {};
	
	                    // Check for possible defaults
	                    if (!this.props.options || this.props.options.setSchemaDefaults !== false) {
	                        empty = typeof items['default'] !== 'undefined' ? items['default'] : empty;
	
	                        // Check for defaults further down in the schema.
	                        // If the default instance sets the new array item to something falsy, i.e. null
	                        // then there is no need to go further down.
	                        if (empty) {
	                            _utils2.default.traverseSchema(items, function (prop, path) {
	                                if (typeof prop['default'] !== 'undefined') {
	                                    _utils2.default.selectOrSet(path, empty, prop['default']);
	                                }
	                            });
	                        }
	                    }
	                } else if (items.type && items.type.indexOf('array') !== -1) {
	                    empty = [];
	                    if (!this.props.options || this.props.options.setSchemaDefaults !== false) {
	                        empty = items['default'] || empty;
	                    }
	                } else {
	                    // No type? could still have defaults.
	                    if (!this.props.options || this.props.options.setSchemaDefaults !== false) {
	                        empty = items['default'] || empty;
	                    }
	                }
	            }
	            var newModel = this.state.model;
	            newModel.push(empty);
	            this.setState({
	                model: newModel
	            });
	            this.props.onChangeValidate(this.state.model);
	            //console.log('After append this.state.model', newModel);
	        }
	    }, {
	        key: 'onDelete',
	        value: function onDelete(index) {
	            //console.log('onDelete is called', index);
	            var newModel = this.state.model;
	            newModel.splice(index, 1);
	            this.setState({
	                model: newModel
	            });
	            this.props.onChangeValidate(this.state.model);
	        }
	    }, {
	        key: 'setIndex',
	        value: function setIndex(index) {
	            return function (form) {
	                if (form.key) {
	                    form.key[form.key.indexOf('')] = index;
	                }
	            };
	        }
	    }, {
	        key: 'copyWithIndex',
	        value: function copyWithIndex(form, index) {
	            var copy = _lodash2.default.cloneDeep(form);
	            copy.arrayIndex = index;
	            _utils2.default.traverseForm(copy, this.setIndex(index));
	            return copy;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            //console.log('Array.render', this.props.form.items, this.props.model, this.state.model);
	            var arrays = [];
	            var fields = [];
	            var model = this.state.model;
	            var items = this.props.form.items;
	            //console.log('fields', fields);
	            for (var i = 0; i < model.length; i++) {
	                var boundOnDelete = this.onDelete.bind(this, i);
	                var forms = this.props.form.items.map(function (form, index) {
	                    var copy = this.copyWithIndex(form, i);
	                    return this.props.builder(copy, this.props.model, index, this.props.onChange, this.props.mapper, this.props.builder);
	                }.bind(this));
	                //console.log('forms', i, forms);
	                arrays.push(_react2.default.createElement(
	                    'li',
	                    { key: i, className: 'list-group-item' },
	                    _react2.default.createElement(
	                        _IconButton2.default,
	                        { iconClassName: 'material-icons', tooltip: 'Remove', onTouchTap: boundOnDelete },
	                        'clear'
	                    ),
	                    forms
	                ));
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'control-lable' },
	                        this.props.form.title
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        { className: 'list-group' },
	                        arrays
	                    )
	                ),
	                _react2.default.createElement(_RaisedButton2.default, { label: this.props.form.add || 'Add', secondary: true, onTouchTap: this.onAppend })
	            );
	        }
	    }]);
	
	    return Array;
	}(_react2.default.Component);
	
	var _default = (0, _ComposedComponent2.default)(Array);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(Array, 'Array', 'src/Array.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/Array.js');
	}();
	
	;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(77);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _Number = __webpack_require__(255);
	
	var _Number2 = _interopRequireDefault(_Number);
	
	var _Text = __webpack_require__(256);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextArea = __webpack_require__(257);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	var _Select = __webpack_require__(161);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Radios = __webpack_require__(160);
	
	var _Radios2 = _interopRequireDefault(_Radios);
	
	var _Date = __webpack_require__(254);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	var _Checkbox = __webpack_require__(253);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Help = __webpack_require__(159);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _RaisedButton = __webpack_require__(142);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _lodash = __webpack_require__(87);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by steve on 11/09/15.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var FieldSet = function (_React$Component) {
	    _inherits(FieldSet, _React$Component);
	
	    function FieldSet() {
	        _classCallCheck(this, FieldSet);
	
	        return _possibleConstructorReturn(this, (FieldSet.__proto__ || Object.getPrototypeOf(FieldSet)).apply(this, arguments));
	    }
	
	    _createClass(FieldSet, [{
	        key: 'render',
	        value: function render() {
	            //console.log('FieldSet.render', this.props);
	            // now render all the items in the fieldset
	            var forms = this.props.form.items.map(function (form, index) {
	                return this.props.builder(form, this.props.model, index, this.props.onChange, this.props.mapper, this.props.builder);
	            }.bind(this));
	
	            return _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                    'legend',
	                    null,
	                    this.props.form.title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    forms
	                )
	            );
	        }
	    }]);
	
	    return FieldSet;
	}(_react2.default.Component);
	
	var _default = FieldSet;
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(FieldSet, 'FieldSet', 'src/FieldSet.js');
	
	    __REACT_HOT_LOADER__.register(_default, 'default', 'src/FieldSet.js');
	}();
	
	;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(1603);
	var EventPluginUtils = __webpack_require__(153);
	var EventPropagators = __webpack_require__(94);
	var SyntheticUIEvent = __webpack_require__(96);
	var TouchEventUtils = __webpack_require__(1666);
	var ViewportMetrics = __webpack_require__(245);
	
	var keyOf = __webpack_require__(849);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    'topTouchCancel',
	    'topTouchEnd',
	    'topTouchStart',
	    'topTouchMove'
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  'topTouchStart',
	  'topTouchCancel',
	  'topTouchEnd',
	  'topTouchMove',
	];
	
	var dependencies = [
	  'topMouseDown',
	  'topMouseMove',
	  'topMouseUp',
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ }),
/* 1666 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(11);
	var defaultClickRejectionStrategy = __webpack_require__(1667);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(93).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(1665)(shouldRejectClick)
	  });
	};


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(661);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1670);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 1671 */
240,
/* 1672 */
[1742, 119],
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1672);
	var ReactElement = __webpack_require__(98);
	
	var emptyFunction = __webpack_require__(38);
	var traverseAllChildren = __webpack_require__(1682);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(98);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(98),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(531);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 1676 */
1635,
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(561),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(98),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(564);
	var factory = __webpack_require__(303);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1678 */
1654,
/* 1679 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(119);
	
	var ReactElement = __webpack_require__(98);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(119);
	
	var ReactCurrentOwner = __webpack_require__(59);
	var REACT_ELEMENT_TYPE = __webpack_require__(563);
	
	var getIteratorFn = __webpack_require__(1678);
	var invariant = __webpack_require__(11);
	var KeyEscapeUtils = __webpack_require__(1671);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoprefix = undefined;
	
	var _forOwn2 = __webpack_require__(209);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transforms = {
	  borderRadius: function borderRadius(value) {
	    return {
	      msBorderRadius: value,
	      MozBorderRadius: value,
	      OBorderRadius: value,
	      WebkitBorderRadius: value,
	      borderRadius: value
	    };
	  },
	  boxShadow: function boxShadow(value) {
	    return {
	      msBoxShadow: value,
	      MozBoxShadow: value,
	      OBoxShadow: value,
	      WebkitBoxShadow: value,
	      boxShadow: value
	    };
	  },
	  userSelect: function userSelect(value) {
	    return {
	      WebkitTouchCallout: value,
	      KhtmlUserSelect: value,
	      MozUserSelect: value,
	      msUserSelect: value,
	      WebkitUserSelect: value,
	      userSelect: value
	    };
	  },
	
	  flex: function flex(value) {
	    return {
	      WebkitBoxFlex: value,
	      MozBoxFlex: value,
	      WebkitFlex: value,
	      msFlex: value,
	      flex: value
	    };
	  },
	  flexBasis: function flexBasis(value) {
	    return {
	      WebkitFlexBasis: value,
	      flexBasis: value
	    };
	  },
	  justifyContent: function justifyContent(value) {
	    return {
	      WebkitJustifyContent: value,
	      justifyContent: value
	    };
	  },
	
	  transition: function transition(value) {
	    return {
	      msTransition: value,
	      MozTransition: value,
	      OTransition: value,
	      WebkitTransition: value,
	      transition: value
	    };
	  },
	
	  transform: function transform(value) {
	    return {
	      msTransform: value,
	      MozTransform: value,
	      OTransform: value,
	      WebkitTransform: value,
	      transform: value
	    };
	  },
	  absolute: function absolute(value) {
	    var direction = value && value.split(' ');
	    return {
	      position: 'absolute',
	      top: direction && direction[0],
	      right: direction && direction[1],
	      bottom: direction && direction[2],
	      left: direction && direction[3]
	    };
	  },
	  extend: function extend(name, otherElementStyles) {
	    var otherStyle = otherElementStyles[name];
	    if (otherStyle) {
	      return otherStyle;
	    }
	    return {
	      'extend': name
	    };
	  }
	};
	
	var autoprefix = exports.autoprefix = function autoprefix(elements) {
	  var prefixed = {};
	  (0, _forOwn3.default)(elements, function (styles, element) {
	    var expanded = {};
	    (0, _forOwn3.default)(styles, function (value, key) {
	      var transform = transforms[key];
	      if (transform) {
	        expanded = _extends({}, expanded, transform(value));
	      } else {
	        expanded[key] = value;
	      }
	    });
	    prefixed[element] = expanded;
	  });
	  return prefixed;
	};
	
	exports.default = autoprefix;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.active = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var active = exports.active = function active(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Active, _React$Component);
	
	    function Active() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Active);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
	        return _this.setState({ active: true });
	      }, _this.handleMouseUp = function () {
	        return _this.setState({ active: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Active;
	  }(_react2.default.Component);
	};
	
	exports.default = active;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hover = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hover = exports.hover = function hover(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Hover, _React$Component);
	
	    function Hover() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Hover);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
	        return _this.setState({ hover: true });
	      }, _this.handleMouseOut = function () {
	        return _this.setState({ hover: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Hover;
	  }(_react2.default.Component);
	};
	
	exports.default = hover;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flattenNames = undefined;
	
	var _isString2 = __webpack_require__(989);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _forOwn2 = __webpack_require__(209);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _isPlainObject2 = __webpack_require__(987);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _map2 = __webpack_require__(990);
	
	var _map3 = _interopRequireDefault(_map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenNames = exports.flattenNames = function flattenNames() {
	  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var names = [];
	
	  (0, _map3.default)(things, function (thing) {
	    if (Array.isArray(thing)) {
	      flattenNames(thing).map(function (name) {
	        return names.push(name);
	      });
	    } else if ((0, _isPlainObject3.default)(thing)) {
	      (0, _forOwn3.default)(thing, function (value, key) {
	        value === true && names.push(key);
	        names.push(key + '-' + value);
	      });
	    } else if ((0, _isString3.default)(thing)) {
	      names.push(thing);
	    }
	  });
	
	  return names;
	};
	
	exports.default = flattenNames;

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loopable = function loopable(i, length) {
	  var props = {};
	  var setProp = function setProp(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    props[name] = value;
	  };
	
	  i === 0 && setProp('first-child');
	  i === length - 1 && setProp('last-child');
	  (i === 0 || i % 2 === 0) && setProp('even');
	  Math.abs(i % 2) === 1 && setProp('odd');
	  setProp('nth-child', i);
	
	  return props;
	};
	
	exports.default = loopable;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeClasses = undefined;
	
	var _forOwn2 = __webpack_require__(209);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _cloneDeep2 = __webpack_require__(983);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
	  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
	  activeNames.map(function (name) {
	    var toMerge = classes[name];
	    if (toMerge) {
	      (0, _forOwn3.default)(toMerge, function (value, key) {
	        if (!styles[key]) {
	          styles[key] = {};
	        }
	
	        styles[key] = _extends({}, styles[key], toMerge[key]);
	      });
	    }
	
	    return name;
	  });
	  return styles;
	};
	
	exports.default = mergeClasses;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(78);


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(568);
	
	/*<replacement>*/
	var util = __webpack_require__(104);
	util.inherits = __webpack_require__(30);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(162).Buffer;
	var util = __webpack_require__(1740);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(120).PassThrough


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(258);


/***/ }),
/* 1694 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(1699);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(1697);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(1696);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && (("production") === 'production' || !Component.propTypes));
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(572);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(1695);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1701);


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(269);
	
	/**
	 * Structure for storing keywords.
	 *
	 * @typedef {Object.<String,Boolean>} KeywordsHash
	 */
	
	/**
	 * ECMAScript dialects.
	 *
	 * @const
	 * @type {Object.<String,Number|String>} - keys as readable names and values as versions
	 */
	var DIALECTS = {
	    es3: 3,
	    es5: 5,
	    es2015: 6,
	    es7: 7,
	
	    // aliases
	    es6: 6,
	    'default': 5,
	    next: 6
	};
	
	/**
	 * ECMAScript reserved words.
	 *
	 * @type {Object.<String,KeywordsHash>}
	 */
	var KEYWORDS = exports.KEYWORDS = {};
	
	/**
	 * Check word for being an reserved word.
	 *
	 * @param {String} word - word to check
	 * @param {String|Number} [dialect] - dialect or version
	 * @param {Boolean} [strict] - strict mode
	 * @returns {?Boolean}
	 */
	exports.check = function check(word, dialect, strict) {
	    dialect = dialect || DIALECTS.default;
	    var version = DIALECTS[dialect] || dialect;
	
	    if (strict && version >= 5) {
	        version += '-strict';
	    }
	
	    assert(KEYWORDS[version], 'Unknown dialect');
	
	    return KEYWORDS[version].hasOwnProperty(word);
	};
	
	/**
	 * Reserved Words for ES3
	 *
	 * ECMA-262 3rd: 7.5.1
	 * http://www.ecma-international.org/publications/files/ECMA-ST-ARCH/ECMA-262,%203rd%20edition,%20December%201999.pdf
	 *
	 * @type {KeywordsHash}
	 */
	KEYWORDS['3'] = _hash(
	    // Keyword, ECMA-262 3rd: 7.5.2
	    'break    else       new     var',
	    'case     finally    return  void',
	    'catch    for        switch  while',
	    'continue function   this    with',
	    'default  if         throw',
	    'delete   in         try',
	    'do       instanceof typeof',
	    // FutureReservedWord, ECMA-262 3rd 7.5.3
	    'abstract enum       int        short',
	    'boolean  export     interface  static',
	    'byte     extends    long       super',
	    'char     final      native     synchronized',
	    'class    float      package    throws',
	    'const    goto       private    transient',
	    'debugger implements protected  volatile',
	    'double   import     public',
	    // NullLiteral & BooleanLiteral
	    'null true false'
	);
	
	/**
	 * Reserved Words for ES5.
	 *
	 * http://es5.github.io/#x7.6.1
	 *
	 * @type {KeywordsHash}
	 */
	KEYWORDS['5'] = _hash(
	    // Keyword
	    'break    do       instanceof typeof',
	    'case     else     new        var',
	    'catch    finally  return     void',
	    'continue for      switch     while',
	    'debugger function this       with',
	    'default  if       throw',
	    'delete   in       try',
	    // FutureReservedWord
	    'class enum extends super',
	    'const export import',
	    // NullLiteral & BooleanLiteral
	    'null true false'
	);
	
	/**
	 * Reserved Words for ES5 in strict mode.
	 *
	 * @type {KeywordsHash}
	 */
	KEYWORDS['5-strict'] = _hash(
	    KEYWORDS['5'],
	    // FutureReservedWord, strict mode. http://es5.github.io/#x7.6.1.2
	    'implements let     private   public yield',
	    'interface  package protected static'
	);
	
	/**
	 * Reserved Words for ES6.
	 *
	 * 11.6.2
	 * http://www.ecma-international.org/ecma-262/6.0/index.html#sec-reserved-words
	 *
	 * @type {KeywordsHash}
	 */
	KEYWORDS['6'] = _hash(
	    // Keywords, ES6 11.6.2.1, http://www.ecma-international.org/ecma-262/6.0/index.html#sec-keywords
	    'break    do       in         typeof',
	    'case     else     instanceof var',
	    'catch    export   new        void',
	    'class    extends  return     while',
	    'const    finally  super      with',
	    'continue for      switch     yield',
	    'debugger function this',
	    'default  if       throw',
	    'delete   import   try',
	    // Future Reserved Words, ES6 11.6.2.2
	    // http://www.ecma-international.org/ecma-262/6.0/index.html#sec-future-reserved-words
	    'enum await',
	    // NullLiteral & BooleanLiteral
	    'null true false'
	);
	
	/**
	 * Reserved Words for ES6 in strict mode.
	 *
	 * @type {KeywordsHash}
	 */
	KEYWORDS['6-strict'] = _hash(
	    KEYWORDS['6'],
	    // Keywords, ES6 11.6.2.1
	    'let static',
	    // Future Reserved Words, ES6 11.6.2.2
	    'implements package protected',
	    'interface private public'
	);
	
	/**
	 * Generates hash from strings
	 *
	 * @private
	 * @param {...String|KeywordsHash} keywords - Space-delimited string or previous result of _hash
	 * @return {KeywordsHash} - Object with keywords in keys and true in values
	 */
	function _hash() {
	    var set = Array.prototype.map.call(arguments, function(v) {
	        return typeof v === 'string' ? v : Object.keys(v).join(' ');
	    }).join(' ');
	
	    return set.split(/\s+/)
	        .reduce(function(res, keyword) {
	            res[keyword] = true;
	            return res;
	        }, {});
	}


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1704);


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * This module is intended to be executed both on client side and server side.
	 * No error should be thrown. (soft error handling)
	 */
	
	(function () {
		var root = {};
		// Dependencies --------------------------------------------------------------
		root.async = ( true) ? __webpack_require__(625) : window.async;
		if (typeof root.async !== 'object') {
			throw new Error('Module async is required (https://github.com/caolan/async)');
		}
		var async = root.async;
	
		function _extend(origin, add) {
			if (!add || typeof add !== 'object') {
				return origin;
			}
			var keys = Object.keys(add);
			var i = keys.length;
			while (i--) {
				origin[keys[i]] = add[keys[i]];
			}
			return origin;
		}
	
		function _merge() {
			var ret = {};
			var args = Array.prototype.slice.call(arguments);
			var keys = null;
			var i = null;
	
			args.forEach(function (arg) {
				if (arg && arg.constructor === Object) {
					keys = Object.keys(arg);
					i = keys.length;
					while (i--) {
						ret[keys[i]] = arg[keys[i]];
					}
				}
			});
			return ret;
		}
	
		// Customisable class (Base class) -------------------------------------------
		// Use with operation "new" to extend Validation and Sanitization themselves,
		// not their prototype. In other words, constructor shall be call to extend
		// those functions, instead of being in their constructor, like this:
		//		_extend(Validation, new Customisable);
	
		function Customisable() {
			this.custom = {};
	
			this.extend = function (custom) {
				return _extend(this.custom, custom);
			};
	
			this.reset = function () {
				this.custom = {};
			};
	
			this.remove = function (fields) {
				if (!_typeIs.array(fields)) {
					fields = [fields];
				}
				fields.forEach(function (field) {
					delete this.custom[field];
				}, this);
			};
		}
	
		// Inspection class (Base class) ---------------------------------------------
		// Use to extend Validation and Sanitization prototypes. Inspection
		// constructor shall be called in derived class constructor.
	
		function Inspection(schema, custom) {
			var _stack = ['@'];
	
			this._schema = schema;
			this._custom = {};
			if (custom != null) {
				for (var key in custom) {
					if (custom.hasOwnProperty(key)){
						this._custom['$' + key] = custom[key];
					}
				}
			}
	
			this._getDepth = function () {
				return _stack.length;
			};
	
			this._dumpStack = function () {
				return _stack.map(function (i) {return i.replace(/^\[/g, '\u001b\u001c\u001d\u001e');})
				.join('.').replace(/\.\u001b\u001c\u001d\u001e/g, '[');
			};
	
			this._deeperObject = function (name) {
				_stack.push((/^[a-z$_][a-z0-9$_]*$/i).test(name) ? name : '["' + name + '"]');
				return this;
			};
	
			this._deeperArray = function (i) {
				_stack.push('[' + i + ']');
				return this;
			};
	
			this._back = function () {
				_stack.pop();
				return this;
			};
		}
		// Simple types --------------------------------------------------------------
		// If the property is not defined or is not in this list:
		var _typeIs = {
			"function": function (element) {
				return typeof element === 'function';
			},
			"string": function (element) {
				return typeof element === 'string';
			},
			"number": function (element) {
				return typeof element === 'number' && !isNaN(element);
			},
			"integer": function (element) {
				return typeof element === 'number' && element % 1 === 0;
			},
			"NaN": function (element) {
				return typeof element === 'number' && isNaN(element);
			},
			"boolean": function (element) {
				return typeof element === 'boolean';
			},
			"null": function (element) {
				return element === null;
			},
			"date": function (element) {
				return element != null && element instanceof Date;
			},
			"object": function (element) {
				return element != null && element.constructor === Object;
			},
			"array": function (element) {
				return element != null && element.constructor === Array;
			},
			"any": function (element) {
				return true;
			}
		};
	
		function _simpleType(type, candidate) {
			if (typeof type == 'function') {
				return candidate instanceof type;
			}
			type = type in _typeIs ? type : 'any';
			return _typeIs[type](candidate);
		}
	
		function _realType(candidate) {
			for (var i in _typeIs) {
				if (_simpleType(i, candidate)) {
					if (i !== 'any') { return i; }
					return 'an instance of ' + candidate.constructor.name;
				}
			}
		}
	
		function getIndexes(a, value) {
			var indexes = [];
			var i = a.indexOf(value);
	
			while (i !== -1) {
				indexes.push(i);
				i = a.indexOf(value, i + 1);
			}
			return indexes;
		}
	
		// Available formats ---------------------------------------------------------
		var _formats = {
			'void': /^$/,
			'url': /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)?(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
			'date-time': /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z?|(-|\+)\d{2}:\d{2})$/,
			'date': /^\d{4}-\d{2}-\d{2}$/,
			'coolDateTime': /^\d{4}(-|\/)\d{2}(-|\/)\d{2}(T| )\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/,
			'time': /^\d{2}\:\d{2}\:\d{2}$/,
			'color': /^#([0-9a-f])+$/i,
			'email': /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
			'numeric': /^[0-9]+$/,
			'integer': /^\-?[0-9]+$/,
			'decimal': /^\-?[0-9]*\.?[0-9]+$/,
			'alpha': /^[a-z]+$/i,
			'alphaNumeric': /^[a-z0-9]+$/i,
			'alphaDash': /^[a-z0-9_-]+$/i,
			'javascript': /^[a-z_\$][a-z0-9_\$]*$/i,
			'upperString': /^[A-Z ]*$/,
			'lowerString': /^[a-z ]*$/
		};
	
	// Validation ------------------------------------------------------------------
		var _validationAttribut = {
			optional: function (schema, candidate) {
				var opt = typeof schema.optional === 'boolean' ? schema.optional : (schema.optional === 'true'); // Default is false
	
				if (opt === true) {
					return;
				}
				if (typeof candidate === 'undefined') {
					this.report('is missing and not optional', null, 'optional');
				}
			},
			type: function (schema, candidate) {
				// return because optional function already handle this case
				if (typeof candidate === 'undefined' || (typeof schema.type !== 'string' && !(schema.type instanceof Array) && typeof schema.type !== 'function')) {
					return;
				}
				var types = _typeIs.array(schema.type) ? schema.type : [schema.type];
				var typeIsValid = types.some(function (type) {
					return _simpleType(type, candidate);
				});
				if (!typeIsValid) {
					types = types.map(function (t) {return typeof t === 'function' ? 'and instance of ' + t.name : t; });
					this.report('must be ' + types.join(' or ') + ', but is ' + _realType(candidate), null, 'type');
				}
			},
			uniqueness: function (schema, candidate) {
				if (typeof schema.uniqueness === 'string') { schema.uniqueness = (schema.uniqueness === 'true'); }
				if (typeof schema.uniqueness !== 'boolean' || schema.uniqueness === false || (!_typeIs.array(candidate) && typeof candidate !== 'string')) {
					return;
				}
				var reported = [];
				for (var i = 0; i < candidate.length; i++) {
					if (reported.indexOf(candidate[i]) >= 0) {
						continue;
					}
					var indexes = getIndexes(candidate, candidate[i]);
					if (indexes.length > 1) {
						reported.push(candidate[i]);
						this.report('has value [' + candidate[i] + '] more than once at indexes [' + indexes.join(', ') + ']', null, 'uniqueness');
					}
				}
			},
			pattern: function (schema, candidate) {
				var self = this;
				var regexs = schema.pattern;
				if (typeof candidate !== 'string') {
					return;
				}
				var matches = false;
				if (!_typeIs.array(regexs)) {
					regexs = [regexs];
				}
				regexs.forEach(function (regex) {
					if (typeof regex === 'string' && regex in _formats) {
						regex = _formats[regex];
					}
					if (regex instanceof RegExp) {
						if (regex.test(candidate)) {
							matches = true;
						}
					}
				});
				if (!matches) {
					self.report('must match [' + regexs.join(' or ') + '], but is equal to "' + candidate + '"', null, 'pattern');
				}
			},
			validDate: function (schema, candidate) {
				if (String(schema.validDate) === 'true' && candidate instanceof Date && isNaN(candidate.getTime())) {
					this.report('must be a valid date', null, 'validDate');
				}
			},
			minLength: function (schema, candidate) {
				if (typeof candidate !== 'string' && !_typeIs.array(candidate)) {
					return;
				}
				var minLength = Number(schema.minLength);
				if (isNaN(minLength)) {
					return;
				}
				if (candidate.length < minLength) {
					this.report('must be longer than ' + minLength + ' elements, but it has ' + candidate.length, null, 'minLength');
				}
			},
			maxLength: function (schema, candidate) {
				if (typeof candidate !== 'string' && !_typeIs.array(candidate)) {
					return;
				}
				var maxLength = Number(schema.maxLength);
				if (isNaN(maxLength)) {
					return;
				}
				if (candidate.length > maxLength) {
					this.report('must be shorter than ' + maxLength + ' elements, but it has ' + candidate.length, null, 'maxLength');
				}
			},
			exactLength: function (schema, candidate) {
				if (typeof candidate !== 'string' && !_typeIs.array(candidate)) {
					return;
				}
				var exactLength = Number(schema.exactLength);
				if (isNaN(exactLength)) {
					return;
				}
				if (candidate.length !== exactLength) {
					this.report('must have exactly ' + exactLength + ' elements, but it have ' + candidate.length, null, 'exactLength');
				}
			},
			lt: function (schema, candidate) {
				var limit = Number(schema.lt);
				if (typeof candidate !== 'number' || isNaN(limit)) {
					return;
				}
				if (candidate >= limit) {
					this.report('must be less than ' + limit + ', but is equal to "' + candidate + '"', null, 'lt');
				}
			},
			lte: function (schema, candidate) {
				var limit = Number(schema.lte);
				if (typeof candidate !== 'number' || isNaN(limit)) {
					return;
				}
				if (candidate > limit) {
					this.report('must be less than or equal to ' + limit + ', but is equal to "' + candidate + '"', null, 'lte');
				}
			},
			gt: function (schema, candidate) {
				var limit = Number(schema.gt);
				if (typeof candidate !== 'number' || isNaN(limit)) {
					return;
				}
				if (candidate <= limit) {
					this.report('must be greater than ' + limit + ', but is equal to "' + candidate + '"', null, 'gt');
				}
			},
			gte: function (schema, candidate) {
				var limit = Number(schema.gte);
				if (typeof candidate !== 'number' || isNaN(limit)) {
					return;
				}
				if (candidate < limit) {
					this.report('must be greater than or equal to ' + limit + ', but is equal to "' + candidate + '"', null, 'gte');
				}
			},
			eq: function (schema, candidate) {
				if (typeof candidate !== 'number' && typeof candidate !== 'string' && typeof candidate !== 'boolean') {
					return;
				}
				var limit = schema.eq;
				if (typeof limit !== 'number' && typeof limit !== 'string' && typeof limit !== 'boolean' && !_typeIs.array(limit)) {
					return;
				}
				if (_typeIs.array(limit)) {
					for (var i = 0; i < limit.length; i++) {
						if (candidate === limit[i]) {
							return;
						}
					}
					this.report('must be equal to [' + limit.map(function (l) {
						return '"' + l + '"';
					}).join(' or ') + '], but is equal to "' + candidate + '"', null, 'eq');
				}
				else {
					if (candidate !== limit) {
						this.report('must be equal to "' + limit + '", but is equal to "' + candidate + '"', null, 'eq');
					}
				}
			},
			ne: function (schema, candidate) {
				if (typeof candidate !== 'number' && typeof candidate !== 'string') {
					return;
				}
				var limit = schema.ne;
				if (typeof limit !== 'number' && typeof limit !== 'string' && !_typeIs.array(limit)) {
					return;
				}
				if (_typeIs.array(limit)) {
					for (var i = 0; i < limit.length; i++) {
						if (candidate === limit[i]) {
							this.report('must not be equal to "' + limit[i] + '"', null, 'ne');
							return;
						}
					}
				}
				else {
					if (candidate === limit) {
						this.report('must not be equal to "' + limit + '"', null, 'ne');
					}
				}
			},
			someKeys: function (schema, candidat) {
				var _keys = schema.someKeys;
				if (!_typeIs.object(candidat)) {
					return;
				}
				var valid = _keys.some(function (action) {
					return (action in candidat);
				});
				if (!valid) {
					this.report('must have at least key ' + _keys.map(function (i) {
						return '"' + i + '"';
					}).join(' or '), null, 'someKeys');
				}
			},
			strict: function (schema, candidate) {
				if (typeof schema.strict === 'string') { schema.strict = (schema.strict === 'true'); }
				if (schema.strict !== true || !_typeIs.object(candidate) || !_typeIs.object(schema.properties)) {
					return;
				}
				var self = this;
				if (typeof schema.properties['*'] === 'undefined') {
					var intruder = Object.keys(candidate).filter(function (key) {
						return (typeof schema.properties[key] === 'undefined');
					});
					if (intruder.length > 0) {
						var msg = 'should not contains ' + (intruder.length > 1 ? 'properties' : 'property') +
							' [' + intruder.map(function (i) { return '"' + i + '"'; }).join(', ') + ']';
						self.report(msg, null, 'strict');
					}
				}
			},
			exec: function (schema, candidate, callback) {
				var self = this;
	
				if (typeof callback === 'function') {
					return this.asyncExec(schema, candidate, callback);
				}
				(_typeIs.array(schema.exec) ? schema.exec : [schema.exec]).forEach(function (exec) {
					if (typeof exec === 'function') {
						exec.call(self, schema, candidate);
					}
				});
			},
			properties: function (schema, candidate, callback) {
				if (typeof callback === 'function') {
					return this.asyncProperties(schema, candidate, callback);
				}
				if (!(schema.properties instanceof Object) || !(candidate instanceof Object)) {
					return;
				}
				var properties = schema.properties,
						i;
				if (properties['*'] != null) {
					for (i in candidate) {
						if (i in properties) {
							continue;
						}
						this._deeperObject(i);
						this._validate(properties['*'], candidate[i]);
						this._back();
					}
				}
				for (i in properties) {
					if (i === '*') {
						continue;
					}
					this._deeperObject(i);
					this._validate(properties[i], candidate[i]);
					this._back();
				}
			},
			items: function (schema, candidate, callback) {
				if (typeof callback === 'function') {
					return this.asyncItems(schema, candidate, callback);
				}
				if (!(schema.items instanceof Object) || !(candidate instanceof Object)) {
					return;
				}
				var items = schema.items;
				var i, l;
				// If provided schema is an array
				// then call validate for each case
				// else it is an Object
				// then call validate for each key
				if (_typeIs.array(items) && _typeIs.array(candidate)) {
					for (i = 0, l = items.length; i < l; i++) {
						this._deeperArray(i);
						this._validate(items[i], candidate[i]);
						this._back();
					}
				}
				else {
					for (var key in candidate) {
						if (candidate.hasOwnProperty(key)){
							this._deeperArray(key);
							this._validate(items, candidate[key]);
							this._back();
						}
	
					}
				}
			}
		};
	
		var _asyncValidationAttribut = {
			asyncExec: function (schema, candidate, callback) {
				var self = this;
				async.eachSeries(_typeIs.array(schema.exec) ? schema.exec : [schema.exec], function (exec, done) {
					if (typeof exec === 'function') {
						if (exec.length > 2) {
							return exec.call(self, schema, candidate, done);
						}
						exec.call(self, schema, candidate);
					}
					async.nextTick(done);
				}, callback);
			},
			asyncProperties: function (schema, candidate, callback) {
				if (!(schema.properties instanceof Object) || !_typeIs.object(candidate)) {
					return callback();
				}
				var self = this;
				var properties = schema.properties;
				async.series([
					function (next) {
						if (properties['*'] == null) {
							return next();
						}
						async.eachSeries(Object.keys(candidate), function (i, done) {
							if (i in properties) {
								return async.nextTick(done);
							}
							self._deeperObject(i);
							self._asyncValidate(properties['*'], candidate[i], function (err) {
								self._back();
								done(err);
							});
						}, next);
					},
					function (next) {
						async.eachSeries(Object.keys(properties), function (i, done) {
							if (i === '*') {
								return async.nextTick(done);
							}
							self._deeperObject(i);
							self._asyncValidate(properties[i], candidate[i], function (err) {
								self._back();
								done(err);
							});
						}, next);
					}
				], callback);
			},
			asyncItems: function (schema, candidate, callback) {
				if (!(schema.items instanceof Object) || !(candidate instanceof Object)) {
					return callback();
				}
				var self = this;
				var items = schema.items;
				var i, l;
	
				if (_typeIs.array(items) && _typeIs.array(candidate)) {
					async.timesSeries(items.length, function (i, done) {
						self._deeperArray(i);
						self._asyncValidate(items[i], candidate[i], function (err, res) {
							self._back();
							done(err, res);
						});
						self._back();
					}, callback);
				}
				else {
					async.eachSeries(Object.keys(candidate), function (key, done) {
						self._deeperArray(key);
						self._asyncValidate(items, candidate[key], function (err, res) {
							self._back();
							done(err, res);
						});
					}, callback);
				}
			}
		};
	
		// Validation Class ----------------------------------------------------------
		// inherits from Inspection class (actually we just call Inspection
		// constructor with the new context, because its prototype is empty
		function Validation(schema, custom) {
			Inspection.prototype.constructor.call(this, schema, _merge(Validation.custom, custom));
			var _error = [];
	
			this._basicFields = Object.keys(_validationAttribut);
			this._customFields = Object.keys(this._custom);
			this.origin = null;
	
			this.report = function (message, code, reason) {
				var newErr = {
					code: code || this.userCode || null,
					reason: reason || 'unknown',
					message: this.userError || message || 'is invalid',
					property: this.userAlias ? (this.userAlias + ' (' + this._dumpStack() + ')') : this._dumpStack()
				};
				_error.push(newErr);
				return this;
			};
	
			this.result = function () {
				return {
					error: _error,
					valid: _error.length === 0,
					format: function () {
						if (this.valid === true) {
							return 'Candidate is valid';
						}
						return this.error.map(function (i) {
							return 'Property ' + i.property + ': ' + i.message;
						}).join('\n');
					}
				};
			};
		}
	
		_extend(Validation.prototype, _validationAttribut);
		_extend(Validation.prototype, _asyncValidationAttribut);
		_extend(Validation, new Customisable());
	
		Validation.prototype.validate = function (candidate, callback) {
			this.origin = candidate;
			if (typeof callback === 'function') {
				var self = this;
				return async.nextTick(function () {
					self._asyncValidate(self._schema, candidate, function (err) {
						self.origin = null;
						callback(err, self.result());
					});
				});
			}
			return this._validate(this._schema, candidate).result();
		};
	
		Validation.prototype._validate = function (schema, candidate, callback) {
			this.userCode = schema.code || null;
			this.userError = schema.error || null;
			this.userAlias = schema.alias || null;
			this._basicFields.forEach(function (i) {
				if ((i in schema || i === 'optional') && typeof this[i] === 'function') {
					this[i](schema, candidate);
				}
			}, this);
			this._customFields.forEach(function (i) {
				if (i in schema && typeof this._custom[i] === 'function') {
					this._custom[i].call(this, schema, candidate);
				}
			}, this);
			return this;
		};
	
		Validation.prototype._asyncValidate = function (schema, candidate, callback) {
			var self = this;
			this.userCode = schema.code || null;
			this.userError = schema.error || null;
			this.userAlias = schema.alias || null;
	
			async.series([
				function (next) {
					async.eachSeries(Object.keys(_validationAttribut), function (i, done) {
						async.nextTick(function () {
							if ((i in schema || i === 'optional') && typeof self[i] === 'function') {
								if (self[i].length > 2) {
									return self[i](schema, candidate, done);
								}
								self[i](schema, candidate);
							}
							done();
						});
					}, next);
				},
				function (next) {
					async.eachSeries(Object.keys(self._custom), function (i, done) {
						async.nextTick(function () {
							if (i in schema && typeof self._custom[i] === 'function') {
								if (self._custom[i].length > 2) {
									return self._custom[i].call(self, schema, candidate, done);
								}
								self._custom[i].call(self, schema, candidate);
							}
							done();
						});
					}, next);
				}
			], callback);
		};
	
	// Sanitization ----------------------------------------------------------------
		// functions called by _sanitization.type method.
		var _forceType = {
			number: function (post, schema) {
				var n;
				if (typeof post === 'number') {
					return post;
				}
				else if (post === '') {
					if (typeof schema.def !== 'undefined')
						return schema.def;
					return null;
				}
				else if (typeof post === 'string') {
					n = parseFloat(post.replace(/,/g, '.').replace(/ /g, ''));
					if (typeof n === 'number') {
						return n;
					}
				}
				else if (post instanceof Date) {
					return +post;
				}
				return null;
			},
			integer: function (post, schema) {
				var n;
				if (typeof post === 'number' && post % 1 === 0) {
					return post;
				}
				else if (post === '') {
					if (typeof schema.def !== 'undefined')
						return schema.def;
					return null;
				}
				else if (typeof post === 'string') {
					n = parseInt(post.replace(/ /g, ''), 10);
					if (typeof n === 'number') {
						return n;
					}
				}
				else if (typeof post === 'number') {
					return parseInt(post, 10);
				}
				else if (typeof post === 'boolean') {
					if (post) { return 1; }
					return 0;
				}
				else if (post instanceof Date) {
					return +post;
				}
				return null;
			},
			string: function (post, schema) {
				if (typeof post === 'boolean' || typeof post === 'number' || post instanceof Date) {
					return post.toString();
				}
				else if (_typeIs.array(post)) {
					// If user authorize array and strings...
					if (schema.items || schema.properties)
						return post;
					return post.join(String(schema.joinWith || ','));
				}
				else if (post instanceof Object) {
					// If user authorize objects ans strings...
					if (schema.items || schema.properties)
						return post;
					return JSON.stringify(post);
				}
				else if (typeof post === 'string' && post.length) {
					return post;
				}
				return null;
			},
			date: function (post, schema) {
				if (post instanceof Date) {
					return post;
				}
				else {
					var d = new Date(post);
					if (!isNaN(d.getTime())) { // if valid date
						return d;
					}
				}
				return null;
			},
			boolean: function (post, schema) {
				if (typeof post === 'undefined') return null;
				if (typeof post === 'string' && post.toLowerCase() === 'false') return false;
				return !!post;
			},
			object: function (post, schema) {
				if (typeof post !== 'string' || _typeIs.object(post)) {
					return post;
				}
				try {
					return JSON.parse(post);
				}
				catch (e) {
					return null;
				}
			},
			array: function (post, schema) {
				if (_typeIs.array(post))
					return post;
				if (typeof post === 'undefined')
					return null;
				if (typeof post === 'string') {
					if (post.substring(0,1) === '[' && post.slice(-1) === ']') {
						try {
							return JSON.parse(post);
						}
						catch (e) {
							return null;
						}
					}
					return post.split(String(schema.splitWith || ','));
	
				}
				if (!_typeIs.array(post))
					return [ post ];
				return null;
			}
		};
	
		var _applyRules = {
			upper: function (post) {
				return post.toUpperCase();
			},
			lower: function (post) {
				return post.toLowerCase();
			},
			title: function (post) {
				// Fix by seb (replace \w\S* by \S* => exemple : coucou ça va)
				return post.replace(/\S*/g, function (txt) {
					return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
				});
			},
			capitalize: function (post) {
				return post.charAt(0).toUpperCase() + post.substr(1).toLowerCase();
			},
			ucfirst: function (post) {
				return post.charAt(0).toUpperCase() + post.substr(1);
			},
			trim: function (post) {
				return post.trim();
			}
		};
	
		// Every function return the future value of each property. Therefore you
		// have to return post even if you do not change its value
		var _sanitizationAttribut = {
			strict: function (schema, post) {
				if (typeof schema.strict === 'string') { schema.strict = (schema.strict === 'true'); }
				if (schema.strict !== true)
					return post;
				if (!_typeIs.object(schema.properties))
					return post;
				if (!_typeIs.object(post))
					return post;
				var that = this;
				Object.keys(post).forEach(function (key) {
					if (!(key in schema.properties)) {
						delete post[key];
					}
				});
				return post;
			},
			optional: function (schema, post) {
				var opt = typeof schema.optional === 'boolean' ? schema.optional : (schema.optional !== 'false'); // Default: true
				if (opt === true) {
					return post;
				}
				if (typeof post !== 'undefined') {
					return post;
				}
				this.report();
				if (schema.def === Date) {
					return new Date();
				}
				return schema.def;
			},
			type: function (schema, post) {
				// if (_typeIs['object'](post) || _typeIs.array(post)) {
				// 	return post;
				// }
				if (typeof schema.type !== 'string' || typeof _forceType[schema.type] !== 'function') {
					return post;
				}
				var n;
				var opt = typeof schema.optional === 'boolean' ? schema.optional : true;
				if (typeof _forceType[schema.type] === 'function') {
					n = _forceType[schema.type](post, schema);
					if ((n === null && !opt) || (!n && isNaN(n)) || (n === null && schema.type === 'string')) {
						n = schema.def;
					}
				}
				else if (!opt) {
					n = schema.def;
				}
				if ((n != null || (typeof schema.def !== 'undefined' && schema.def === n)) && n !== post) {
					this.report();
					return n;
				}
				return post;
			},
			rules: function (schema, post) {
				var rules = schema.rules;
				if (typeof post !== 'string' || (typeof rules !== 'string' && !_typeIs.array(rules))) {
					return post;
				}
				var modified = false;
				(_typeIs.array(rules) ? rules : [rules]).forEach(function (rule) {
					if (typeof _applyRules[rule] === 'function') {
						post = _applyRules[rule](post);
						modified = true;
					}
				});
				if (modified) {
					this.report();
				}
				return post;
			},
			min: function (schema, post) {
				var postTest = Number(post);
				if (isNaN(postTest)) {
					return post;
				}
				var min = Number(schema.min);
				if (isNaN(min)) {
					return post;
				}
				if (postTest < min) {
					this.report();
					return min;
				}
				return post;
			},
			max: function (schema, post) {
				var postTest = Number(post);
				if (isNaN(postTest)) {
					return post;
				}
				var max = Number(schema.max);
				if (isNaN(max)) {
					return post;
				}
				if (postTest > max) {
					this.report();
					return max;
				}
				return post;
			},
			minLength: function (schema, post) {
				var limit = Number(schema.minLength);
				if (typeof post !== 'string' || isNaN(limit) || limit < 0) {
					return post;
				}
				var str = '';
				var gap = limit - post.length;
				if (gap > 0) {
					for (var i = 0; i < gap; i++) {
						str += '-';
					}
					this.report();
					return post + str;
				}
				return post;
			},
			maxLength: function (schema, post) {
				var limit = Number(schema.maxLength);
				if (typeof post !== 'string' || isNaN(limit) || limit < 0) {
					return post;
				}
				if (post.length > limit) {
					this.report();
					return post.slice(0, limit);
				}
				return post;
			},
			properties: function (schema, post, callback) {
				if (typeof callback === 'function') {
					return this.asyncProperties(schema, post, callback);
				}
				if (!post || typeof post !== 'object') {
					return post;
				}
				var properties = schema.properties;
				var tmp;
				var i;
				if (typeof properties['*'] !== 'undefined') {
					for (i in post) {
						if (i in properties) {
							continue;
						}
						this._deeperObject(i);
						tmp = this._sanitize(schema.properties['*'], post[i]);
						if (typeof tmp !== 'undefined') {
							post[i]= tmp;
						}
						this._back();
					}
				}
				for (i in schema.properties) {
					if (i !== '*') {
						this._deeperObject(i);
						tmp = this._sanitize(schema.properties[i], post[i]);
						if (typeof tmp !== 'undefined') {
							post[i]= tmp;
						}
						this._back();
					}
				}
				return post;
			},
			items: function (schema, post, callback) {
				if (typeof callback === 'function') {
					return this.asyncItems(schema, post, callback);
				}
				if (!(schema.items instanceof Object) || !(post instanceof Object)) {
					return post;
				}
				var i;
				if (_typeIs.array(schema.items) && _typeIs.array(post)) {
					var minLength = schema.items.length < post.length ? schema.items.length : post.length;
					for (i = 0; i < minLength; i++) {
						this._deeperArray(i);
						post[i] = this._sanitize(schema.items[i], post[i]);
						this._back();
					}
				}
				else {
					for (i in post) {
						if(post.hasOwnProperty(i)){
							this._deeperArray(i);
							post[i] = this._sanitize(schema.items, post[i]);
							this._back();
						}
					}
				}
				return post;
			},
			exec: function (schema, post, callback) {
				if (typeof callback === 'function') {
					return this.asyncExec(schema, post, callback);
				}
				var execs = _typeIs.array(schema.exec) ? schema.exec : [schema.exec];
	
				execs.forEach(function (exec) {
					if (typeof exec === 'function') {
						post = exec.call(this, schema, post);
					}
				}, this);
				return post;
			}
		};
	
		var _asyncSanitizationAttribut = {
			asyncExec: function (schema, post, callback) {
				var self = this;
				var execs = _typeIs.array(schema.exec) ? schema.exec : [schema.exec];
	
				async.eachSeries(execs, function (exec, done) {
					if (typeof exec === 'function') {
						if (exec.length > 2) {
							return exec.call(self, schema, post, function (err, res) {
								if (err) {
									return done(err);
								}
								post = res;
								done();
							});
						}
						post = exec.call(self, schema, post);
					}
					done();
				}, function (err) {
					callback(err, post);
				});
			},
			asyncProperties: function (schema, post, callback) {
				if (!post || typeof post !== 'object') {
					return callback(null, post);
				}
				var self = this;
				var properties = schema.properties;
	
				async.series([
					function (next) {
						if (properties['*'] == null) {
							return next();
						}
						var globing = properties['*'];
						async.eachSeries(Object.keys(post), function (i, next) {
							if (i in properties) {
								return next();
							}
							self._deeperObject(i);
							self._asyncSanitize(globing, post[i], function (err, res) {
								if (err) { /* Error can safely be ignored here */ }
								if (typeof res !== 'undefined') {
									post[i] = res;
								}
								self._back();
								next();
							});
						}, next);
					},
					function (next) {
						async.eachSeries(Object.keys(properties), function (i, next) {
							if (i === '*') {
								return next();
							}
							self._deeperObject(i);
							self._asyncSanitize(properties[i], post[i], function (err, res) {
								if (err) {
									return next(err);
								}
								if (typeof res !== 'undefined') {
									post[i] = res;
								}
								self._back();
								next();
							});
						}, next);
					}
				], function (err) {
					return callback(err, post);
				});
			},
			asyncItems: function (schema, post, callback) {
				if (!(schema.items instanceof Object) || !(post instanceof Object)) {
					return callback(null, post);
				}
				var self = this;
				var items = schema.items;
				if (_typeIs.array(items) && _typeIs.array(post)) {
					var minLength = items.length < post.length ? items.length : post.length;
					async.timesSeries(minLength, function (i, next) {
						self._deeperArray(i);
						self._asyncSanitize(items[i], post[i], function (err, res) {
							if (err) {
								return next(err);
							}
							post[i] = res;
							self._back();
							next();
						});
					}, function (err) {
						callback(err, post);
					});
				}
				else {
					async.eachSeries(Object.keys(post), function (key, next) {
						self._deeperArray(key);
						self._asyncSanitize(items, post[key], function (err, res) {
							if (err) {
								return next();
							}
							post[key] = res;
							self._back();
							next();
						});
					}, function (err) {
						callback(err, post);
					});
				}
				return post;
			}
		};
	
		// Sanitization Class --------------------------------------------------------
		// inherits from Inspection class (actually we just call Inspection
		// constructor with the new context, because its prototype is empty
		function Sanitization(schema, custom) {
			Inspection.prototype.constructor.call(this, schema, _merge(Sanitization.custom, custom));
			var _reporting = [];
	
			this._basicFields = Object.keys(_sanitizationAttribut);
			this._customFields = Object.keys(this._custom);
			this.origin = null;
	
			this.report = function (message) {
				var newNot = {
						message: message || 'was sanitized',
						property: this.userAlias ? (this.userAlias + ' (' + this._dumpStack() + ')') : this._dumpStack()
				};
				if (!_reporting.some(function (e) { return e.property === newNot.property; })) {
					_reporting.push(newNot);
				}
			};
	
			this.result = function (data) {
				return {
					data: data,
					reporting: _reporting,
					format: function () {
						return this.reporting.map(function (i) {
							return 'Property ' + i.property + ' ' + i.message;
						}).join('\n');
					}
				};
			};
		}
	
		_extend(Sanitization.prototype, _sanitizationAttribut);
		_extend(Sanitization.prototype, _asyncSanitizationAttribut);
		_extend(Sanitization, new Customisable());
	
	
		Sanitization.prototype.sanitize = function (post, callback) {
			this.origin = post;
			if (typeof callback === 'function') {
				var self = this;
				return this._asyncSanitize(this._schema, post, function (err, data) {
					self.origin = null;
					callback(err, self.result(data));
				});
			}
			var data = this._sanitize(this._schema, post);
			this.origin = null;
			return this.result(data);
		};
	
		Sanitization.prototype._sanitize = function (schema, post) {
			this.userAlias = schema.alias || null;
			this._basicFields.forEach(function (i) {
				if ((i in schema || i === 'optional') && typeof this[i] === 'function') {
					post = this[i](schema, post);
				}
			}, this);
			this._customFields.forEach(function (i) {
				if (i in schema && typeof this._custom[i] === 'function') {
					post = this._custom[i].call(this, schema, post);
				}
			}, this);
			return post;
		};
	
		Sanitization.prototype._asyncSanitize = function (schema, post, callback) {
			var self = this;
			this.userAlias = schema.alias || null;
	
			async.waterfall([
				function (next) {
					async.reduce(self._basicFields, post, function (value, i, next) {
						async.nextTick(function () {
							if ((i in schema || i === 'optional') && typeof self[i] === 'function') {
								if (self[i].length > 2) {
									return self[i](schema, value, next);
								}
								value = self[i](schema, value);
							}
							next(null, value);
						});
					}, next);
				},
				function (inter, next) {
					async.reduce(self._customFields, inter, function (value, i, next) {
						async.nextTick(function () {
							if (i in schema && typeof self._custom[i] === 'function') {
								if (self._custom[i].length > 2) {
									return self._custom[i].call(self, schema, value, next);
								}
								value = self._custom[i].call(self, schema, value);
							}
							next(null, value);
						});
					}, next);
				}
			], callback);
		};
	
		// ---------------------------------------------------------------------------
	
		var INT_MIN = -2147483648;
		var INT_MAX = 2147483647;
	
		var _rand = {
			int: function (min, max) {
				return min + (0 | Math.random() * (max - min + 1));
			},
			float: function (min, max) {
				return (Math.random() * (max - min) + min);
			},
			bool: function () {
				return (Math.random() > 0.5);
			},
			char: function (min, max) {
				return String.fromCharCode(this.int(min, max));
			},
			fromList: function (list) {
				return list[this.int(0, list.length - 1)];
			}
		};
	
		var _formatSample = {
			'date-time': function () {
				return new Date().toISOString();
			},
			'date': function () {
				return new Date().toISOString().replace(/T.*$/, '');
			},
			'time': function () {
				return new Date().toLocaleTimeString({}, { hour12: false });
			},
			'color': function (min, max) {
				var s = '#';
				if (min < 1) {
					min = 1;
				}
				for (var i = 0, l = _rand.int(min, max); i < l; i++) {
					s += _rand.fromList('0123456789abcdefABCDEF');
				}
				return s;
			},
			'numeric': function () {
				return '' + _rand.int(0, INT_MAX);
			},
			'integer': function () {
				if (_rand.bool() === true) {
					return '-' + this.numeric();
				}
				return this.numeric();
			},
			'decimal': function () {
				return this.integer() + '.' + this.numeric();
			},
			'alpha': function (min, max) {
				var s = '';
				if (min < 1) {
					min = 1;
				}
				for (var i = 0, l = _rand.int(min, max); i < l; i++) {
					s += _rand.fromList('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
				}
				return s;
			},
			'alphaNumeric': function (min, max) {
				var s = '';
				if (min < 1) {
					min = 1;
				}
				for (var i = 0, l = _rand.int(min, max); i < l; i++) {
					s += _rand.fromList('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789');
				}
				return s;
			},
			'alphaDash': function (min, max) {
				var s = '';
				if (min < 1) {
					min = 1;
				}
				for (var i = 0, l = _rand.int(min, max); i < l; i++) {
					s += _rand.fromList('_-abcdefghijklmnopqrstuvwxyz_-ABCDEFGHIJKLMNOPQRSTUVWXYZ_-0123456789_-');
				}
				return s;
			},
			'javascript': function (min, max) {
				var s = _rand.fromList('_$abcdefghijklmnopqrstuvwxyz_$ABCDEFGHIJKLMNOPQRSTUVWXYZ_$');
				for (var i = 0, l = _rand.int(min, max - 1); i < l; i++) {
					s += _rand.fromList('_$abcdefghijklmnopqrstuvwxyz_$ABCDEFGHIJKLMNOPQRSTUVWXYZ_$0123456789_$');
				}
				return s;
			}
		};
	
		function _getLimits(schema) {
			var min = INT_MIN;
			var max = INT_MAX;
	
			if (schema.gte != null) {
				min = schema.gte;
			}
			else if (schema.gt != null) {
				min = schema.gt + 1;
			}
			if (schema.lte != null) {
				max = schema.lte;
			}
			else if (schema.lt != null) {
				max = schema.lt - 1;
			}
			return { min: min, max: max };
		}
	
		var _typeGenerator = {
			string: function (schema) {
				if (schema.eq != null) {
					return schema.eq;
				}
				var s = '';
				var minLength = schema.minLength != null ? schema.minLength : 0;
				var maxLength = schema.maxLength != null ? schema.maxLength : 32;
				if (typeof schema.pattern === 'string' && typeof _formatSample[schema.pattern] === 'function') {
					return _formatSample[schema.pattern](minLength, maxLength);
				}
	
				var l = schema.exactLength != null ? schema.exactLength : _rand.int(minLength, maxLength);
				for (var i = 0; i < l; i++) {
					s += _rand.char(32, 126);
				}
				return s;
			},
			number: function (schema) {
				if (schema.eq != null) {
					return schema.eq;
				}
				var limit = _getLimits(schema);
				var n = _rand.float(limit.min, limit.max);
				if (schema.ne != null) {
					var ne = _typeIs.array(schema.ne) ? schema.ne : [schema.ne];
					while (ne.indexOf(n) !== -1) {
						n = _rand.float(limit.min, limit.max);
					}
				}
				return n;
			},
			integer: function (schema) {
				if (schema.eq != null) {
					return schema.eq;
				}
				var limit = _getLimits(schema);
				var n = _rand.int(limit.min, limit.max);
				if (schema.ne != null) {
					var ne = _typeIs.array(schema.ne) ? schema.ne : [schema.ne];
					while (ne.indexOf(n) !== -1) {
						n = _rand.int(limit.min, limit.max);
					}
				}
				return n;
			},
			boolean: function (schema) {
				if (schema.eq != null) {
					return schema.eq;
				}
				return _rand.bool();
			},
			"null": function (schema) {
				return null;
			},
			date: function (schema) {
				if (schema.eq != null) {
					return schema.eq;
				}
				return new Date();
			},
			object: function (schema) {
				var o = {};
				var prop = schema.properties || {};
	
				for (var key in prop) {
					if (prop.hasOwnProperty(key)){
						if (prop[key].optional === true && _rand.bool() === true) {
							continue;
						}
						if (key !== '*') {
							o[key] = this.generate(prop[key]);
						}
						else {
							var rk = '__random_key_';
							var randomKey = rk + 0;
							var n = _rand.int(1, 9);
							for (var i = 1; i <= n; i++) {
								if (!(randomKey in prop)) {
									o[randomKey] = this.generate(prop[key]);
								}
								randomKey = rk + i;
							}
						}
					}
				}
				return o;
			},
			array: function (schema) {
				var self = this;
				var items = schema.items || {};
				var minLength = schema.minLength != null ? schema.minLength : 0;
				var maxLength = schema.maxLength != null ? schema.maxLength : 16;
				var type;
				var candidate;
				var size;
				var i;
	
				if (_typeIs.array(items)) {
					size = items.length;
					if (schema.exactLength != null) {
						size = schema.exactLength;
					}
					else if (size < minLength) {
						size = minLength;
					}
					else if (size > maxLength) {
						size = maxLength;
					}
					candidate = new Array(size);
					type = null;
					for (i = 0; i < size; i++) {
						type = items[i].type || 'any';
						if (_typeIs.array(type)) {
							type = type[_rand.int(0, type.length - 1)];
						}
						candidate[i] = self[type](items[i]);
					}
				}
				else {
					size = schema.exactLength != null ? schema.exactLength : _rand.int(minLength, maxLength);
					candidate = new Array(size);
					type = items.type || 'any';
					if (_typeIs.array(type)) {
						type = type[_rand.int(0, type.length - 1)];
					}
					for (i = 0; i < size; i++) {
						candidate[i] = self[type](items);
					}
				}
				return candidate;
			},
			any: function (schema) {
				var fields = Object.keys(_typeGenerator);
				var i = fields[_rand.int(0, fields.length - 2)];
				return this[i](schema);
			}
		};
	
		// CandidateGenerator Class (Singleton) --------------------------------------
		function CandidateGenerator() {
			// Maybe extends Inspection class too ?
		}
	
		_extend(CandidateGenerator.prototype, _typeGenerator);
	
		var _instance = null;
		CandidateGenerator.instance = function () {
			if (!(_instance instanceof CandidateGenerator)) {
				_instance = new CandidateGenerator();
			}
			return _instance;
		};
	
		CandidateGenerator.prototype.generate = function (schema) {
			var type = schema.type || 'any';
			if (_typeIs.array(type)) {
				type = type[_rand.int(0, type.length - 1)];
			}
			return this[type](schema);
		};
	
	// Exports ---------------------------------------------------------------------
		var SchemaInspector = {};
	
		// if server-side (node.js) else client-side
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = SchemaInspector;
		}
		else {
			window.SchemaInspector = SchemaInspector;
		}
	
		SchemaInspector.newSanitization = function (schema, custom) {
			return new Sanitization(schema, custom);
		};
	
		SchemaInspector.newValidation = function (schema, custom) {
			return new Validation(schema, custom);
		};
	
		SchemaInspector.Validation = Validation;
		SchemaInspector.Sanitization = Sanitization;
	
		SchemaInspector.sanitize = function (schema, post, custom, callback) {
			if (arguments.length === 3 && typeof custom === 'function') {
				callback = custom;
				custom = null;
			}
			return new Sanitization(schema, custom).sanitize(post, callback);
		};
	
		SchemaInspector.validate = function (schema, candidate, custom, callback) {
			if (arguments.length === 3 && typeof custom === 'function') {
				callback = custom;
				custom = null;
			}
			return new Validation(schema, custom).validate(candidate, callback);
		};
	
		SchemaInspector.generate = function (schema, n) {
			if (typeof n === 'number') {
				var r = new Array(n);
				for (var i = 0; i < n; i++) {
					r[i] = CandidateGenerator.instance().generate(schema);
				}
				return r;
			}
			return CandidateGenerator.instance().generate(schema);
		};
	})();


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(28)))

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(174).Buffer
	var Hash   = __webpack_require__(1706)(Buffer)
	
	exports.sha1 = __webpack_require__(1708)(Buffer, Hash)
	exports.sha256 = __webpack_require__(1709)(Buffer, Hash)
	exports.sha512 = __webpack_require__(1710)(Buffer, Hash)


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(36).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(36).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(36).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {var capability = __webpack_require__(576)
	var inherits = __webpack_require__(30)
	var response = __webpack_require__(577)
	var stream = __webpack_require__(120)
	var toArrayBuffer = __webpack_require__(1713)
	
	var IncomingMessage = response.IncomingMessage
	var rStates = response.readyStates
	
	function decideMode (preferBinary, useFetch) {
		if (capability.fetch && useFetch) {
			return 'fetch'
		} else if (capability.mozchunkedarraybuffer) {
			return 'moz-chunked-arraybuffer'
		} else if (capability.msstream) {
			return 'ms-stream'
		} else if (capability.arraybuffer && preferBinary) {
			return 'arraybuffer'
		} else if (capability.vbArray && preferBinary) {
			return 'text:vbarray'
		} else {
			return 'text'
		}
	}
	
	var ClientRequest = module.exports = function (opts) {
		var self = this
		stream.Writable.call(self)
	
		self._opts = opts
		self._body = []
		self._headers = {}
		if (opts.auth)
			self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'))
		Object.keys(opts.headers).forEach(function (name) {
			self.setHeader(name, opts.headers[name])
		})
	
		var preferBinary
		var useFetch = true
		if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
			// If the use of XHR should be preferred. Not typically needed.
			useFetch = false
			preferBinary = true
		} else if (opts.mode === 'prefer-streaming') {
			// If streaming is a high priority but binary compatibility and
			// the accuracy of the 'content-type' header aren't
			preferBinary = false
		} else if (opts.mode === 'allow-wrong-content-type') {
			// If streaming is more important than preserving the 'content-type' header
			preferBinary = !capability.overrideMimeType
		} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
			// Use binary if text streaming may corrupt data or the content-type header, or for speed
			preferBinary = true
		} else {
			throw new Error('Invalid value for opts.mode')
		}
		self._mode = decideMode(preferBinary, useFetch)
		self._fetchTimer = null
	
		self.on('finish', function () {
			self._onFinish()
		})
	}
	
	inherits(ClientRequest, stream.Writable)
	
	ClientRequest.prototype.setHeader = function (name, value) {
		var self = this
		var lowerName = name.toLowerCase()
		// This check is not necessary, but it prevents warnings from browsers about setting unsafe
		// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
		// http-browserify did it, so I will too.
		if (unsafeHeaders.indexOf(lowerName) !== -1)
			return
	
		self._headers[lowerName] = {
			name: name,
			value: value
		}
	}
	
	ClientRequest.prototype.getHeader = function (name) {
		var header = this._headers[name.toLowerCase()]
		if (header)
			return header.value
		return null
	}
	
	ClientRequest.prototype.removeHeader = function (name) {
		var self = this
		delete self._headers[name.toLowerCase()]
	}
	
	ClientRequest.prototype._onFinish = function () {
		var self = this
	
		if (self._destroyed)
			return
		var opts = self._opts
	
		var headersObj = self._headers
		var body = null
		if (opts.method !== 'GET' && opts.method !== 'HEAD') {
			if (capability.arraybuffer) {
				body = toArrayBuffer(Buffer.concat(self._body))
			} else if (capability.blobConstructor) {
				body = new global.Blob(self._body.map(function (buffer) {
					return toArrayBuffer(buffer)
				}), {
					type: (headersObj['content-type'] || {}).value || ''
				})
			} else {
				// get utf8 string
				body = Buffer.concat(self._body).toString()
			}
		}
	
		// create flattened list of headers
		var headersList = []
		Object.keys(headersObj).forEach(function (keyName) {
			var name = headersObj[keyName].name
			var value = headersObj[keyName].value
			if (Array.isArray(value)) {
				value.forEach(function (v) {
					headersList.push([name, v])
				})
			} else {
				headersList.push([name, value])
			}
		})
	
		if (self._mode === 'fetch') {
			var signal = null
			var fetchTimer = null
			if (capability.abortController) {
				var controller = new AbortController()
				signal = controller.signal
				self._fetchAbortController = controller
	
				if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
					self._fetchTimer = global.setTimeout(function () {
						self.emit('requestTimeout')
						if (self._fetchAbortController)
							self._fetchAbortController.abort()
					}, opts.requestTimeout)
				}
			}
	
			global.fetch(self._opts.url, {
				method: self._opts.method,
				headers: headersList,
				body: body || undefined,
				mode: 'cors',
				credentials: opts.withCredentials ? 'include' : 'same-origin',
				signal: signal
			}).then(function (response) {
				self._fetchResponse = response
				self._connect()
			}, function (reason) {
				global.clearTimeout(self._fetchTimer)
				if (!self._destroyed)
					self.emit('error', reason)
			})
		} else {
			var xhr = self._xhr = new global.XMLHttpRequest()
			try {
				xhr.open(self._opts.method, self._opts.url, true)
			} catch (err) {
				process.nextTick(function () {
					self.emit('error', err)
				})
				return
			}
	
			// Can't set responseType on really old browsers
			if ('responseType' in xhr)
				xhr.responseType = self._mode.split(':')[0]
	
			if ('withCredentials' in xhr)
				xhr.withCredentials = !!opts.withCredentials
	
			if (self._mode === 'text' && 'overrideMimeType' in xhr)
				xhr.overrideMimeType('text/plain; charset=x-user-defined')
	
			if ('requestTimeout' in opts) {
				xhr.timeout = opts.requestTimeout
				xhr.ontimeout = function () {
					self.emit('requestTimeout')
				}
			}
	
			headersList.forEach(function (header) {
				xhr.setRequestHeader(header[0], header[1])
			})
	
			self._response = null
			xhr.onreadystatechange = function () {
				switch (xhr.readyState) {
					case rStates.LOADING:
					case rStates.DONE:
						self._onXHRProgress()
						break
				}
			}
			// Necessary for streaming in Firefox, since xhr.response is ONLY defined
			// in onprogress, not in onreadystatechange with xhr.readyState = 3
			if (self._mode === 'moz-chunked-arraybuffer') {
				xhr.onprogress = function () {
					self._onXHRProgress()
				}
			}
	
			xhr.onerror = function () {
				if (self._destroyed)
					return
				self.emit('error', new Error('XHR error'))
			}
	
			try {
				xhr.send(body)
			} catch (err) {
				process.nextTick(function () {
					self.emit('error', err)
				})
				return
			}
		}
	}
	
	/**
	 * Checks if xhr.status is readable and non-zero, indicating no error.
	 * Even though the spec says it should be available in readyState 3,
	 * accessing it throws an exception in IE8
	 */
	function statusValid (xhr) {
		try {
			var status = xhr.status
			return (status !== null && status !== 0)
		} catch (e) {
			return false
		}
	}
	
	ClientRequest.prototype._onXHRProgress = function () {
		var self = this
	
		if (!statusValid(self._xhr) || self._destroyed)
			return
	
		if (!self._response)
			self._connect()
	
		self._response._onXHRProgress()
	}
	
	ClientRequest.prototype._connect = function () {
		var self = this
	
		if (self._destroyed)
			return
	
		self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._fetchTimer)
		self._response.on('error', function(err) {
			self.emit('error', err)
		})
	
		self.emit('response', self._response)
	}
	
	ClientRequest.prototype._write = function (chunk, encoding, cb) {
		var self = this
	
		self._body.push(chunk)
		cb()
	}
	
	ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
		var self = this
		self._destroyed = true
		global.clearTimeout(self._fetchTimer)
		if (self._response)
			self._response._destroyed = true
		if (self._xhr)
			self._xhr.abort()
		else if (self._fetchAbortController)
			self._fetchAbortController.abort()
	}
	
	ClientRequest.prototype.end = function (data, encoding, cb) {
		var self = this
		if (typeof data === 'function') {
			cb = data
			data = undefined
		}
	
		stream.Writable.prototype.end.call(self, data, encoding, cb)
	}
	
	ClientRequest.prototype.flushHeaders = function () {}
	ClientRequest.prototype.setTimeout = function () {}
	ClientRequest.prototype.setNoDelay = function () {}
	ClientRequest.prototype.setSocketKeepAlive = function () {}
	
	// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
	var unsafeHeaders = [
		'accept-charset',
		'accept-encoding',
		'access-control-request-headers',
		'access-control-request-method',
		'connection',
		'content-length',
		'cookie',
		'cookie2',
		'date',
		'dnt',
		'expect',
		'host',
		'keep-alive',
		'origin',
		'referer',
		'te',
		'trailer',
		'transfer-encoding',
		'upgrade',
		'via'
	]
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer, (function() { return this; }()), __webpack_require__(28)))

/***/ }),
/* 1712 */
1369,
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(174).Buffer
	
	module.exports = function (buf) {
		// If the buffer is backed by a Uint8Array, a faster version will work
		if (buf instanceof Uint8Array) {
			// If the buffer isn't a subarray, return the underlying ArrayBuffer
			if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
				return buf.buffer
			} else if (typeof buf.buffer.slice === 'function') {
				// Otherwise we need to get a proper copy
				return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength)
			}
		}
	
		if (Buffer.isBuffer(buf)) {
			// This is the slow version that will work with any Buffer
			// implementation (even in old browsers)
			var arrayCopy = new Uint8Array(buf.length)
			var len = buf.length
			for (var i = 0; i < len; i++) {
				arrayCopy[i] = buf[i]
			}
			return arrayCopy.buffer
		} else {
			throw new Error('Argument must be a Buffer')
		}
	}


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tooltipster v4.2.6 */!function(a,b){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function(a){return b(a)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){function b(a){this.$container,this.constraints=null,this.__$tooltip,this.__init(a)}function c(b,c){var d=!0;return a.each(b,function(a,e){return void 0===c[a]||b[a]!==c[a]?(d=!1,!1):void 0}),d}function d(b){var c=b.attr("id"),d=c?h.window.document.getElementById(c):null;return d?d===b[0]:a.contains(h.window.document.body,b[0])}function e(){if(!g)return!1;var a=g.document.body||g.document.documentElement,b=a.style,c="transition",d=["Moz","Webkit","Khtml","O","ms"];if("string"==typeof b[c])return!0;c=c.charAt(0).toUpperCase()+c.substr(1);for(var e=0;e<d.length;e++)if("string"==typeof b[d[e]+c])return!0;return!1}var f={animation:"fade",animationDuration:350,content:null,contentAsHTML:!1,contentCloning:!1,debug:!0,delay:300,delayTouch:[300,500],functionInit:null,functionBefore:null,functionReady:null,functionAfter:null,functionFormat:null,IEmin:6,interactive:!1,multiple:!1,parent:null,plugins:["sideTip"],repositionOnScroll:!1,restoration:"none",selfDestruction:!0,theme:[],timer:0,trackerInterval:500,trackOrigin:!1,trackTooltip:!1,trigger:"hover",triggerClose:{click:!1,mouseleave:!1,originClick:!1,scroll:!1,tap:!1,touchleave:!1},triggerOpen:{click:!1,mouseenter:!1,tap:!1,touchstart:!1},updateAnimation:"rotate",zIndex:9999999},g="undefined"!=typeof window?window:null,h={hasTouchCapability:!(!g||!("ontouchstart"in g||g.DocumentTouch&&g.document instanceof g.DocumentTouch||g.navigator.maxTouchPoints)),hasTransitions:e(),IE:!1,semVer:"4.2.6",window:g},i=function(){this.__$emitterPrivate=a({}),this.__$emitterPublic=a({}),this.__instancesLatestArr=[],this.__plugins={},this._env=h};i.prototype={__bridge:function(b,c,d){if(!c[d]){var e=function(){};e.prototype=b;var g=new e;g.__init&&g.__init(c),a.each(b,function(a,b){0!=a.indexOf("__")&&(c[a]?f.debug&&console.log("The "+a+" method of the "+d+" plugin conflicts with another plugin or native methods"):(c[a]=function(){return g[a].apply(g,Array.prototype.slice.apply(arguments))},c[a].bridged=g))}),c[d]=g}return this},__setWindow:function(a){return h.window=a,this},_getRuler:function(a){return new b(a)},_off:function(){return this.__$emitterPrivate.off.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_on:function(){return this.__$emitterPrivate.on.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_one:function(){return this.__$emitterPrivate.one.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_plugin:function(b){var c=this;if("string"==typeof b){var d=b,e=null;return d.indexOf(".")>0?e=c.__plugins[d]:a.each(c.__plugins,function(a,b){return b.name.substring(b.name.length-d.length-1)=="."+d?(e=b,!1):void 0}),e}if(b.name.indexOf(".")<0)throw new Error("Plugins must be namespaced");return c.__plugins[b.name]=b,b.core&&c.__bridge(b.core,c,b.name),this},_trigger:function(){var a=Array.prototype.slice.apply(arguments);return"string"==typeof a[0]&&(a[0]={type:a[0]}),this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate,a),this.__$emitterPublic.trigger.apply(this.__$emitterPublic,a),this},instances:function(b){var c=[],d=b||".tooltipstered";return a(d).each(function(){var b=a(this),d=b.data("tooltipster-ns");d&&a.each(d,function(a,d){c.push(b.data(d))})}),c},instancesLatest:function(){return this.__instancesLatestArr},off:function(){return this.__$emitterPublic.off.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},on:function(){return this.__$emitterPublic.on.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},one:function(){return this.__$emitterPublic.one.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},origins:function(b){var c=b?b+" ":"";return a(c+".tooltipstered").toArray()},setDefaults:function(b){return a.extend(f,b),this},triggerHandler:function(){return this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this}},a.tooltipster=new i,a.Tooltipster=function(b,c){this.__callbacks={close:[],open:[]},this.__closingTime,this.__Content,this.__contentBcr,this.__destroyed=!1,this.__$emitterPrivate=a({}),this.__$emitterPublic=a({}),this.__enabled=!0,this.__garbageCollector,this.__Geometry,this.__lastPosition,this.__namespace="tooltipster-"+Math.round(1e6*Math.random()),this.__options,this.__$originParents,this.__pointerIsOverOrigin=!1,this.__previousThemes=[],this.__state="closed",this.__timeouts={close:[],open:null},this.__touchEvents=[],this.__tracker=null,this._$origin,this._$tooltip,this.__init(b,c)},a.Tooltipster.prototype={__init:function(b,c){var d=this;if(d._$origin=a(b),d.__options=a.extend(!0,{},f,c),d.__optionsFormat(),!h.IE||h.IE>=d.__options.IEmin){var e=null;if(void 0===d._$origin.data("tooltipster-initialTitle")&&(e=d._$origin.attr("title"),void 0===e&&(e=null),d._$origin.data("tooltipster-initialTitle",e)),null!==d.__options.content)d.__contentSet(d.__options.content);else{var g,i=d._$origin.attr("data-tooltip-content");i&&(g=a(i)),g&&g[0]?d.__contentSet(g.first()):d.__contentSet(e)}d._$origin.removeAttr("title").addClass("tooltipstered"),d.__prepareOrigin(),d.__prepareGC(),a.each(d.__options.plugins,function(a,b){d._plug(b)}),h.hasTouchCapability&&a(h.window.document.body).on("touchmove."+d.__namespace+"-triggerOpen",function(a){d._touchRecordEvent(a)}),d._on("created",function(){d.__prepareTooltip()})._on("repositioned",function(a){d.__lastPosition=a.position})}else d.__options.disabled=!0},__contentInsert:function(){var a=this,b=a._$tooltip.find(".tooltipster-content"),c=a.__Content,d=function(a){c=a};return a._trigger({type:"format",content:a.__Content,format:d}),a.__options.functionFormat&&(c=a.__options.functionFormat.call(a,a,{origin:a._$origin[0]},a.__Content)),"string"!=typeof c||a.__options.contentAsHTML?b.empty().append(c):b.text(c),a},__contentSet:function(b){return b instanceof a&&this.__options.contentCloning&&(b=b.clone(!0)),this.__Content=b,this._trigger({type:"updated",content:b}),this},__destroyError:function(){throw new Error("This tooltip has been destroyed and cannot execute your method call.")},__geometry:function(){var b=this,c=b._$origin,d=b._$origin.is("area");if(d){var e=b._$origin.parent().attr("name");c=a('img[usemap="#'+e+'"]')}var f=c[0].getBoundingClientRect(),g=a(h.window.document),i=a(h.window),j=c,k={available:{document:null,window:null},document:{size:{height:g.height(),width:g.width()}},window:{scroll:{left:h.window.scrollX||h.window.document.documentElement.scrollLeft,top:h.window.scrollY||h.window.document.documentElement.scrollTop},size:{height:i.height(),width:i.width()}},origin:{fixedLineage:!1,offset:{},size:{height:f.bottom-f.top,width:f.right-f.left},usemapImage:d?c[0]:null,windowOffset:{bottom:f.bottom,left:f.left,right:f.right,top:f.top}}};if(d){var l=b._$origin.attr("shape"),m=b._$origin.attr("coords");if(m&&(m=m.split(","),a.map(m,function(a,b){m[b]=parseInt(a)})),"default"!=l)switch(l){case"circle":var n=m[0],o=m[1],p=m[2],q=o-p,r=n-p;k.origin.size.height=2*p,k.origin.size.width=k.origin.size.height,k.origin.windowOffset.left+=r,k.origin.windowOffset.top+=q;break;case"rect":var s=m[0],t=m[1],u=m[2],v=m[3];k.origin.size.height=v-t,k.origin.size.width=u-s,k.origin.windowOffset.left+=s,k.origin.windowOffset.top+=t;break;case"poly":for(var w=0,x=0,y=0,z=0,A="even",B=0;B<m.length;B++){var C=m[B];"even"==A?(C>y&&(y=C,0===B&&(w=y)),w>C&&(w=C),A="odd"):(C>z&&(z=C,1==B&&(x=z)),x>C&&(x=C),A="even")}k.origin.size.height=z-x,k.origin.size.width=y-w,k.origin.windowOffset.left+=w,k.origin.windowOffset.top+=x}}var D=function(a){k.origin.size.height=a.height,k.origin.windowOffset.left=a.left,k.origin.windowOffset.top=a.top,k.origin.size.width=a.width};for(b._trigger({type:"geometry",edit:D,geometry:{height:k.origin.size.height,left:k.origin.windowOffset.left,top:k.origin.windowOffset.top,width:k.origin.size.width}}),k.origin.windowOffset.right=k.origin.windowOffset.left+k.origin.size.width,k.origin.windowOffset.bottom=k.origin.windowOffset.top+k.origin.size.height,k.origin.offset.left=k.origin.windowOffset.left+k.window.scroll.left,k.origin.offset.top=k.origin.windowOffset.top+k.window.scroll.top,k.origin.offset.bottom=k.origin.offset.top+k.origin.size.height,k.origin.offset.right=k.origin.offset.left+k.origin.size.width,k.available.document={bottom:{height:k.document.size.height-k.origin.offset.bottom,width:k.document.size.width},left:{height:k.document.size.height,width:k.origin.offset.left},right:{height:k.document.size.height,width:k.document.size.width-k.origin.offset.right},top:{height:k.origin.offset.top,width:k.document.size.width}},k.available.window={bottom:{height:Math.max(k.window.size.height-Math.max(k.origin.windowOffset.bottom,0),0),width:k.window.size.width},left:{height:k.window.size.height,width:Math.max(k.origin.windowOffset.left,0)},right:{height:k.window.size.height,width:Math.max(k.window.size.width-Math.max(k.origin.windowOffset.right,0),0)},top:{height:Math.max(k.origin.windowOffset.top,0),width:k.window.size.width}};"html"!=j[0].tagName.toLowerCase();){if("fixed"==j.css("position")){k.origin.fixedLineage=!0;break}j=j.parent()}return k},__optionsFormat:function(){return"number"==typeof this.__options.animationDuration&&(this.__options.animationDuration=[this.__options.animationDuration,this.__options.animationDuration]),"number"==typeof this.__options.delay&&(this.__options.delay=[this.__options.delay,this.__options.delay]),"number"==typeof this.__options.delayTouch&&(this.__options.delayTouch=[this.__options.delayTouch,this.__options.delayTouch]),"string"==typeof this.__options.theme&&(this.__options.theme=[this.__options.theme]),null===this.__options.parent?this.__options.parent=a(h.window.document.body):"string"==typeof this.__options.parent&&(this.__options.parent=a(this.__options.parent)),"hover"==this.__options.trigger?(this.__options.triggerOpen={mouseenter:!0,touchstart:!0},this.__options.triggerClose={mouseleave:!0,originClick:!0,touchleave:!0}):"click"==this.__options.trigger&&(this.__options.triggerOpen={click:!0,tap:!0},this.__options.triggerClose={click:!0,tap:!0}),this._trigger("options"),this},__prepareGC:function(){var b=this;return b.__options.selfDestruction?b.__garbageCollector=setInterval(function(){var c=(new Date).getTime();b.__touchEvents=a.grep(b.__touchEvents,function(a,b){return c-a.time>6e4}),d(b._$origin)||b.close(function(){b.destroy()})},2e4):clearInterval(b.__garbageCollector),b},__prepareOrigin:function(){var a=this;if(a._$origin.off("."+a.__namespace+"-triggerOpen"),h.hasTouchCapability&&a._$origin.on("touchstart."+a.__namespace+"-triggerOpen touchend."+a.__namespace+"-triggerOpen touchcancel."+a.__namespace+"-triggerOpen",function(b){a._touchRecordEvent(b)}),a.__options.triggerOpen.click||a.__options.triggerOpen.tap&&h.hasTouchCapability){var b="";a.__options.triggerOpen.click&&(b+="click."+a.__namespace+"-triggerOpen "),a.__options.triggerOpen.tap&&h.hasTouchCapability&&(b+="touchend."+a.__namespace+"-triggerOpen"),a._$origin.on(b,function(b){a._touchIsMeaningfulEvent(b)&&a._open(b)})}if(a.__options.triggerOpen.mouseenter||a.__options.triggerOpen.touchstart&&h.hasTouchCapability){var b="";a.__options.triggerOpen.mouseenter&&(b+="mouseenter."+a.__namespace+"-triggerOpen "),a.__options.triggerOpen.touchstart&&h.hasTouchCapability&&(b+="touchstart."+a.__namespace+"-triggerOpen"),a._$origin.on(b,function(b){!a._touchIsTouchEvent(b)&&a._touchIsEmulatedEvent(b)||(a.__pointerIsOverOrigin=!0,a._openShortly(b))})}if(a.__options.triggerClose.mouseleave||a.__options.triggerClose.touchleave&&h.hasTouchCapability){var b="";a.__options.triggerClose.mouseleave&&(b+="mouseleave."+a.__namespace+"-triggerOpen "),a.__options.triggerClose.touchleave&&h.hasTouchCapability&&(b+="touchend."+a.__namespace+"-triggerOpen touchcancel."+a.__namespace+"-triggerOpen"),a._$origin.on(b,function(b){a._touchIsMeaningfulEvent(b)&&(a.__pointerIsOverOrigin=!1)})}return a},__prepareTooltip:function(){var b=this,c=b.__options.interactive?"auto":"";return b._$tooltip.attr("id",b.__namespace).css({"pointer-events":c,zIndex:b.__options.zIndex}),a.each(b.__previousThemes,function(a,c){b._$tooltip.removeClass(c)}),a.each(b.__options.theme,function(a,c){b._$tooltip.addClass(c)}),b.__previousThemes=a.merge([],b.__options.theme),b},__scrollHandler:function(b){var c=this;if(c.__options.triggerClose.scroll)c._close(b);else if(d(c._$origin)&&d(c._$tooltip)){var e=null;if(b.target===h.window.document)c.__Geometry.origin.fixedLineage||c.__options.repositionOnScroll&&c.reposition(b);else{e=c.__geometry();var f=!1;if("fixed"!=c._$origin.css("position")&&c.__$originParents.each(function(b,c){var d=a(c),g=d.css("overflow-x"),h=d.css("overflow-y");if("visible"!=g||"visible"!=h){var i=c.getBoundingClientRect();if("visible"!=g&&(e.origin.windowOffset.left<i.left||e.origin.windowOffset.right>i.right))return f=!0,!1;if("visible"!=h&&(e.origin.windowOffset.top<i.top||e.origin.windowOffset.bottom>i.bottom))return f=!0,!1}return"fixed"==d.css("position")?!1:void 0}),f)c._$tooltip.css("visibility","hidden");else if(c._$tooltip.css("visibility","visible"),c.__options.repositionOnScroll)c.reposition(b);else{var g=e.origin.offset.left-c.__Geometry.origin.offset.left,i=e.origin.offset.top-c.__Geometry.origin.offset.top;c._$tooltip.css({left:c.__lastPosition.coord.left+g,top:c.__lastPosition.coord.top+i})}}c._trigger({type:"scroll",event:b,geo:e})}return c},__stateSet:function(a){return this.__state=a,this._trigger({type:"state",state:a}),this},__timeoutsClear:function(){return clearTimeout(this.__timeouts.open),this.__timeouts.open=null,a.each(this.__timeouts.close,function(a,b){clearTimeout(b)}),this.__timeouts.close=[],this},__trackerStart:function(){var a=this,b=a._$tooltip.find(".tooltipster-content");return a.__options.trackTooltip&&(a.__contentBcr=b[0].getBoundingClientRect()),a.__tracker=setInterval(function(){if(d(a._$origin)&&d(a._$tooltip)){if(a.__options.trackOrigin){var e=a.__geometry(),f=!1;c(e.origin.size,a.__Geometry.origin.size)&&(a.__Geometry.origin.fixedLineage?c(e.origin.windowOffset,a.__Geometry.origin.windowOffset)&&(f=!0):c(e.origin.offset,a.__Geometry.origin.offset)&&(f=!0)),f||(a.__options.triggerClose.mouseleave?a._close():a.reposition())}if(a.__options.trackTooltip){var g=b[0].getBoundingClientRect();g.height===a.__contentBcr.height&&g.width===a.__contentBcr.width||(a.reposition(),a.__contentBcr=g)}}else a._close()},a.__options.trackerInterval),a},_close:function(b,c,d){var e=this,f=!0;if(e._trigger({type:"close",event:b,stop:function(){f=!1}}),f||d){c&&e.__callbacks.close.push(c),e.__callbacks.open=[],e.__timeoutsClear();var g=function(){a.each(e.__callbacks.close,function(a,c){c.call(e,e,{event:b,origin:e._$origin[0]})}),e.__callbacks.close=[]};if("closed"!=e.__state){var i=!0,j=new Date,k=j.getTime(),l=k+e.__options.animationDuration[1];if("disappearing"==e.__state&&l>e.__closingTime&&e.__options.animationDuration[1]>0&&(i=!1),i){e.__closingTime=l,"disappearing"!=e.__state&&e.__stateSet("disappearing");var m=function(){clearInterval(e.__tracker),e._trigger({type:"closing",event:b}),e._$tooltip.off("."+e.__namespace+"-triggerClose").removeClass("tooltipster-dying"),a(h.window).off("."+e.__namespace+"-triggerClose"),e.__$originParents.each(function(b,c){a(c).off("scroll."+e.__namespace+"-triggerClose")}),e.__$originParents=null,a(h.window.document.body).off("."+e.__namespace+"-triggerClose"),e._$origin.off("."+e.__namespace+"-triggerClose"),e._off("dismissable"),e.__stateSet("closed"),e._trigger({type:"after",event:b}),e.__options.functionAfter&&e.__options.functionAfter.call(e,e,{event:b,origin:e._$origin[0]}),g()};h.hasTransitions?(e._$tooltip.css({"-moz-animation-duration":e.__options.animationDuration[1]+"ms","-ms-animation-duration":e.__options.animationDuration[1]+"ms","-o-animation-duration":e.__options.animationDuration[1]+"ms","-webkit-animation-duration":e.__options.animationDuration[1]+"ms","animation-duration":e.__options.animationDuration[1]+"ms","transition-duration":e.__options.animationDuration[1]+"ms"}),e._$tooltip.clearQueue().removeClass("tooltipster-show").addClass("tooltipster-dying"),e.__options.animationDuration[1]>0&&e._$tooltip.delay(e.__options.animationDuration[1]),e._$tooltip.queue(m)):e._$tooltip.stop().fadeOut(e.__options.animationDuration[1],m)}}else g()}return e},_off:function(){return this.__$emitterPrivate.off.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_on:function(){return this.__$emitterPrivate.on.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_one:function(){return this.__$emitterPrivate.one.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_open:function(b,c){var e=this;if(!e.__destroying&&d(e._$origin)&&e.__enabled){var f=!0;if("closed"==e.__state&&(e._trigger({type:"before",event:b,stop:function(){f=!1}}),f&&e.__options.functionBefore&&(f=e.__options.functionBefore.call(e,e,{event:b,origin:e._$origin[0]}))),f!==!1&&null!==e.__Content){c&&e.__callbacks.open.push(c),e.__callbacks.close=[],e.__timeoutsClear();var g,i=function(){"stable"!=e.__state&&e.__stateSet("stable"),a.each(e.__callbacks.open,function(a,b){b.call(e,e,{origin:e._$origin[0],tooltip:e._$tooltip[0]})}),e.__callbacks.open=[]};if("closed"!==e.__state)g=0,"disappearing"===e.__state?(e.__stateSet("appearing"),h.hasTransitions?(e._$tooltip.clearQueue().removeClass("tooltipster-dying").addClass("tooltipster-show"),e.__options.animationDuration[0]>0&&e._$tooltip.delay(e.__options.animationDuration[0]),e._$tooltip.queue(i)):e._$tooltip.stop().fadeIn(i)):"stable"==e.__state&&i();else{if(e.__stateSet("appearing"),g=e.__options.animationDuration[0],e.__contentInsert(),e.reposition(b,!0),h.hasTransitions?(e._$tooltip.addClass("tooltipster-"+e.__options.animation).addClass("tooltipster-initial").css({"-moz-animation-duration":e.__options.animationDuration[0]+"ms","-ms-animation-duration":e.__options.animationDuration[0]+"ms","-o-animation-duration":e.__options.animationDuration[0]+"ms","-webkit-animation-duration":e.__options.animationDuration[0]+"ms","animation-duration":e.__options.animationDuration[0]+"ms","transition-duration":e.__options.animationDuration[0]+"ms"}),setTimeout(function(){"closed"!=e.__state&&(e._$tooltip.addClass("tooltipster-show").removeClass("tooltipster-initial"),e.__options.animationDuration[0]>0&&e._$tooltip.delay(e.__options.animationDuration[0]),e._$tooltip.queue(i))},0)):e._$tooltip.css("display","none").fadeIn(e.__options.animationDuration[0],i),e.__trackerStart(),a(h.window).on("resize."+e.__namespace+"-triggerClose",function(b){var c=a(document.activeElement);(c.is("input")||c.is("textarea"))&&a.contains(e._$tooltip[0],c[0])||e.reposition(b)}).on("scroll."+e.__namespace+"-triggerClose",function(a){e.__scrollHandler(a)}),e.__$originParents=e._$origin.parents(),e.__$originParents.each(function(b,c){a(c).on("scroll."+e.__namespace+"-triggerClose",function(a){e.__scrollHandler(a)})}),e.__options.triggerClose.mouseleave||e.__options.triggerClose.touchleave&&h.hasTouchCapability){e._on("dismissable",function(a){a.dismissable?a.delay?(m=setTimeout(function(){e._close(a.event)},a.delay),e.__timeouts.close.push(m)):e._close(a):clearTimeout(m)});var j=e._$origin,k="",l="",m=null;e.__options.interactive&&(j=j.add(e._$tooltip)),e.__options.triggerClose.mouseleave&&(k+="mouseenter."+e.__namespace+"-triggerClose ",l+="mouseleave."+e.__namespace+"-triggerClose "),e.__options.triggerClose.touchleave&&h.hasTouchCapability&&(k+="touchstart."+e.__namespace+"-triggerClose",l+="touchend."+e.__namespace+"-triggerClose touchcancel."+e.__namespace+"-triggerClose"),j.on(l,function(a){if(e._touchIsTouchEvent(a)||!e._touchIsEmulatedEvent(a)){var b="mouseleave"==a.type?e.__options.delay:e.__options.delayTouch;e._trigger({delay:b[1],dismissable:!0,event:a,type:"dismissable"})}}).on(k,function(a){!e._touchIsTouchEvent(a)&&e._touchIsEmulatedEvent(a)||e._trigger({dismissable:!1,event:a,type:"dismissable"})})}e.__options.triggerClose.originClick&&e._$origin.on("click."+e.__namespace+"-triggerClose",function(a){e._touchIsTouchEvent(a)||e._touchIsEmulatedEvent(a)||e._close(a)}),(e.__options.triggerClose.click||e.__options.triggerClose.tap&&h.hasTouchCapability)&&setTimeout(function(){if("closed"!=e.__state){var b="",c=a(h.window.document.body);e.__options.triggerClose.click&&(b+="click."+e.__namespace+"-triggerClose "),e.__options.triggerClose.tap&&h.hasTouchCapability&&(b+="touchend."+e.__namespace+"-triggerClose"),c.on(b,function(b){e._touchIsMeaningfulEvent(b)&&(e._touchRecordEvent(b),e.__options.interactive&&a.contains(e._$tooltip[0],b.target)||e._close(b))}),e.__options.triggerClose.tap&&h.hasTouchCapability&&c.on("touchstart."+e.__namespace+"-triggerClose",function(a){e._touchRecordEvent(a)})}},0),e._trigger("ready"),e.__options.functionReady&&e.__options.functionReady.call(e,e,{origin:e._$origin[0],tooltip:e._$tooltip[0]})}if(e.__options.timer>0){var m=setTimeout(function(){e._close()},e.__options.timer+g);e.__timeouts.close.push(m)}}}return e},_openShortly:function(a){var b=this,c=!0;if("stable"!=b.__state&&"appearing"!=b.__state&&!b.__timeouts.open&&(b._trigger({type:"start",event:a,stop:function(){c=!1}}),c)){var d=0==a.type.indexOf("touch")?b.__options.delayTouch:b.__options.delay;d[0]?b.__timeouts.open=setTimeout(function(){b.__timeouts.open=null,b.__pointerIsOverOrigin&&b._touchIsMeaningfulEvent(a)?(b._trigger("startend"),b._open(a)):b._trigger("startcancel")},d[0]):(b._trigger("startend"),b._open(a))}return b},_optionsExtract:function(b,c){var d=this,e=a.extend(!0,{},c),f=d.__options[b];return f||(f={},a.each(c,function(a,b){var c=d.__options[a];void 0!==c&&(f[a]=c)})),a.each(e,function(b,c){void 0!==f[b]&&("object"!=typeof c||c instanceof Array||null==c||"object"!=typeof f[b]||f[b]instanceof Array||null==f[b]?e[b]=f[b]:a.extend(e[b],f[b]))}),e},_plug:function(b){var c=a.tooltipster._plugin(b);if(!c)throw new Error('The "'+b+'" plugin is not defined');return c.instance&&a.tooltipster.__bridge(c.instance,this,c.name),this},_touchIsEmulatedEvent:function(a){for(var b=!1,c=(new Date).getTime(),d=this.__touchEvents.length-1;d>=0;d--){var e=this.__touchEvents[d];if(!(c-e.time<500))break;e.target===a.target&&(b=!0)}return b},_touchIsMeaningfulEvent:function(a){return this._touchIsTouchEvent(a)&&!this._touchSwiped(a.target)||!this._touchIsTouchEvent(a)&&!this._touchIsEmulatedEvent(a)},_touchIsTouchEvent:function(a){return 0==a.type.indexOf("touch")},_touchRecordEvent:function(a){return this._touchIsTouchEvent(a)&&(a.time=(new Date).getTime(),this.__touchEvents.push(a)),this},_touchSwiped:function(a){for(var b=!1,c=this.__touchEvents.length-1;c>=0;c--){var d=this.__touchEvents[c];if("touchmove"==d.type){b=!0;break}if("touchstart"==d.type&&a===d.target)break}return b},_trigger:function(){var b=Array.prototype.slice.apply(arguments);return"string"==typeof b[0]&&(b[0]={type:b[0]}),b[0].instance=this,b[0].origin=this._$origin?this._$origin[0]:null,b[0].tooltip=this._$tooltip?this._$tooltip[0]:null,this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate,b),a.tooltipster._trigger.apply(a.tooltipster,b),this.__$emitterPublic.trigger.apply(this.__$emitterPublic,b),this},_unplug:function(b){var c=this;if(c[b]){var d=a.tooltipster._plugin(b);d.instance&&a.each(d.instance,function(a,d){c[a]&&c[a].bridged===c[b]&&delete c[a]}),c[b].__destroy&&c[b].__destroy(),delete c[b]}return c},close:function(a){return this.__destroyed?this.__destroyError():this._close(null,a),this},content:function(a){var b=this;if(void 0===a)return b.__Content;if(b.__destroyed)b.__destroyError();else if(b.__contentSet(a),null!==b.__Content){if("closed"!==b.__state&&(b.__contentInsert(),b.reposition(),b.__options.updateAnimation))if(h.hasTransitions){var c=b.__options.updateAnimation;b._$tooltip.addClass("tooltipster-update-"+c),setTimeout(function(){"closed"!=b.__state&&b._$tooltip.removeClass("tooltipster-update-"+c)},1e3)}else b._$tooltip.fadeTo(200,.5,function(){"closed"!=b.__state&&b._$tooltip.fadeTo(200,1)})}else b._close();return b},destroy:function(){var b=this;if(b.__destroyed)b.__destroyError();else{"closed"!=b.__state?b.option("animationDuration",0)._close(null,null,!0):b.__timeoutsClear(),b._trigger("destroy"),b.__destroyed=!0,b._$origin.removeData(b.__namespace).off("."+b.__namespace+"-triggerOpen"),a(h.window.document.body).off("."+b.__namespace+"-triggerOpen");var c=b._$origin.data("tooltipster-ns");if(c)if(1===c.length){var d=null;"previous"==b.__options.restoration?d=b._$origin.data("tooltipster-initialTitle"):"current"==b.__options.restoration&&(d="string"==typeof b.__Content?b.__Content:a("<div></div>").append(b.__Content).html()),d&&b._$origin.attr("title",d),b._$origin.removeClass("tooltipstered"),b._$origin.removeData("tooltipster-ns").removeData("tooltipster-initialTitle")}else c=a.grep(c,function(a,c){return a!==b.__namespace}),b._$origin.data("tooltipster-ns",c);b._trigger("destroyed"),b._off(),b.off(),b.__Content=null,b.__$emitterPrivate=null,b.__$emitterPublic=null,b.__options.parent=null,b._$origin=null,b._$tooltip=null,a.tooltipster.__instancesLatestArr=a.grep(a.tooltipster.__instancesLatestArr,function(a,c){return b!==a}),clearInterval(b.__garbageCollector)}return b},disable:function(){return this.__destroyed?(this.__destroyError(),this):(this._close(),this.__enabled=!1,this)},elementOrigin:function(){return this.__destroyed?void this.__destroyError():this._$origin[0]},elementTooltip:function(){return this._$tooltip?this._$tooltip[0]:null},enable:function(){return this.__enabled=!0,this},hide:function(a){return this.close(a)},instance:function(){return this},off:function(){return this.__destroyed||this.__$emitterPublic.off.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},on:function(){return this.__destroyed?this.__destroyError():this.__$emitterPublic.on.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},one:function(){return this.__destroyed?this.__destroyError():this.__$emitterPublic.one.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},open:function(a){return this.__destroyed?this.__destroyError():this._open(null,a),this},option:function(b,c){return void 0===c?this.__options[b]:(this.__destroyed?this.__destroyError():(this.__options[b]=c,this.__optionsFormat(),a.inArray(b,["trigger","triggerClose","triggerOpen"])>=0&&this.__prepareOrigin(),"selfDestruction"===b&&this.__prepareGC()),this)},reposition:function(a,b){var c=this;return c.__destroyed?c.__destroyError():"closed"!=c.__state&&d(c._$origin)&&(b||d(c._$tooltip))&&(b||c._$tooltip.detach(),c.__Geometry=c.__geometry(),c._trigger({type:"reposition",event:a,helper:{geo:c.__Geometry}})),c},show:function(a){return this.open(a)},status:function(){return{destroyed:this.__destroyed,enabled:this.__enabled,open:"closed"!==this.__state,state:this.__state}},triggerHandler:function(){return this.__destroyed?this.__destroyError():this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this}},a.fn.tooltipster=function(){var b=Array.prototype.slice.apply(arguments),c="You are using a single HTML element as content for several tooltips. You probably want to set the contentCloning option to TRUE.";if(0===this.length)return this;if("string"==typeof b[0]){var d="#*$~&";return this.each(function(){var e=a(this).data("tooltipster-ns"),f=e?a(this).data(e[0]):null;if(!f)throw new Error("You called Tooltipster's \""+b[0]+'" method on an uninitialized element');if("function"!=typeof f[b[0]])throw new Error('Unknown method "'+b[0]+'"');this.length>1&&"content"==b[0]&&(b[1]instanceof a||"object"==typeof b[1]&&null!=b[1]&&b[1].tagName)&&!f.__options.contentCloning&&f.__options.debug&&console.log(c);var g=f[b[0]](b[1],b[2]);return g!==f||"instance"===b[0]?(d=g,!1):void 0}),"#*$~&"!==d?d:this}a.tooltipster.__instancesLatestArr=[];var e=b[0]&&void 0!==b[0].multiple,g=e&&b[0].multiple||!e&&f.multiple,h=b[0]&&void 0!==b[0].content,i=h&&b[0].content||!h&&f.content,j=b[0]&&void 0!==b[0].contentCloning,k=j&&b[0].contentCloning||!j&&f.contentCloning,l=b[0]&&void 0!==b[0].debug,m=l&&b[0].debug||!l&&f.debug;return this.length>1&&(i instanceof a||"object"==typeof i&&null!=i&&i.tagName)&&!k&&m&&console.log(c),this.each(function(){var c=!1,d=a(this),e=d.data("tooltipster-ns"),f=null;e?g?c=!0:m&&(console.log("Tooltipster: one or more tooltips are already attached to the element below. Ignoring."),console.log(this)):c=!0,c&&(f=new a.Tooltipster(this,b[0]),e||(e=[]),e.push(f.__namespace),d.data("tooltipster-ns",e),d.data(f.__namespace,f),f.__options.functionInit&&f.__options.functionInit.call(f,f,{origin:this}),f._trigger("init")),a.tooltipster.__instancesLatestArr.push(f)}),this},b.prototype={__init:function(b){this.__$tooltip=b,this.__$tooltip.css({left:0,overflow:"hidden",position:"absolute",top:0}).find(".tooltipster-content").css("overflow","auto"),this.$container=a('<div class="tooltipster-ruler"></div>').append(this.__$tooltip).appendTo(h.window.document.body)},__forceRedraw:function(){var a=this.__$tooltip.parent();this.__$tooltip.detach(),this.__$tooltip.appendTo(a)},constrain:function(a,b){return this.constraints={width:a,height:b},this.__$tooltip.css({display:"block",height:"",overflow:"auto",width:a}),this},destroy:function(){this.__$tooltip.detach().find(".tooltipster-content").css({display:"",overflow:""}),this.$container.remove()},free:function(){return this.constraints=null,this.__$tooltip.css({display:"",height:"",overflow:"visible",width:""}),this},measure:function(){this.__forceRedraw();var a=this.__$tooltip[0].getBoundingClientRect(),b={size:{height:a.height||a.bottom-a.top,width:a.width||a.right-a.left}};if(this.constraints){var c=this.__$tooltip.find(".tooltipster-content"),d=this.__$tooltip.outerHeight(),e=c[0].getBoundingClientRect(),f={height:d<=this.constraints.height,width:a.width<=this.constraints.width&&e.width>=c[0].scrollWidth-1};b.fits=f.height&&f.width}return h.IE&&h.IE<=11&&b.size.width!==h.window.document.documentElement.clientWidth&&(b.size.width=Math.ceil(b.size.width)+1),b}};var j=navigator.userAgent.toLowerCase();-1!=j.indexOf("msie")?h.IE=parseInt(j.split("msie")[1]):-1!==j.toLowerCase().indexOf("trident")&&-1!==j.indexOf(" rv:11")?h.IE=11:-1!=j.toLowerCase().indexOf("edge/")&&(h.IE=parseInt(j.toLowerCase().split("edge/")[1]));var k="tooltipster.sideTip";return a.tooltipster._plugin({name:k,instance:{__defaults:function(){return{arrow:!0,distance:6,functionPosition:null,maxWidth:null,minIntersection:16,minWidth:0,position:null,side:"top",viewportAware:!0}},__init:function(a){var b=this;b.__instance=a,b.__namespace="tooltipster-sideTip-"+Math.round(1e6*Math.random()),b.__previousState="closed",b.__options,b.__optionsFormat(),b.__instance._on("state."+b.__namespace,function(a){"closed"==a.state?b.__close():"appearing"==a.state&&"closed"==b.__previousState&&b.__create(),b.__previousState=a.state}),b.__instance._on("options."+b.__namespace,function(){b.__optionsFormat()}),b.__instance._on("reposition."+b.__namespace,function(a){b.__reposition(a.event,a.helper)})},__close:function(){this.__instance.content()instanceof a&&this.__instance.content().detach(),this.__instance._$tooltip.remove(),this.__instance._$tooltip=null},__create:function(){var b=a('<div class="tooltipster-base tooltipster-sidetip"><div class="tooltipster-box"><div class="tooltipster-content"></div></div><div class="tooltipster-arrow"><div class="tooltipster-arrow-uncropped"><div class="tooltipster-arrow-border"></div><div class="tooltipster-arrow-background"></div></div></div></div>');this.__options.arrow||b.find(".tooltipster-box").css("margin",0).end().find(".tooltipster-arrow").hide(),this.__options.minWidth&&b.css("min-width",this.__options.minWidth+"px"),this.__options.maxWidth&&b.css("max-width",this.__options.maxWidth+"px"),
	this.__instance._$tooltip=b,this.__instance._trigger("created")},__destroy:function(){this.__instance._off("."+self.__namespace)},__optionsFormat:function(){var b=this;if(b.__options=b.__instance._optionsExtract(k,b.__defaults()),b.__options.position&&(b.__options.side=b.__options.position),"object"!=typeof b.__options.distance&&(b.__options.distance=[b.__options.distance]),b.__options.distance.length<4&&(void 0===b.__options.distance[1]&&(b.__options.distance[1]=b.__options.distance[0]),void 0===b.__options.distance[2]&&(b.__options.distance[2]=b.__options.distance[0]),void 0===b.__options.distance[3]&&(b.__options.distance[3]=b.__options.distance[1]),b.__options.distance={top:b.__options.distance[0],right:b.__options.distance[1],bottom:b.__options.distance[2],left:b.__options.distance[3]}),"string"==typeof b.__options.side){var c={top:"bottom",right:"left",bottom:"top",left:"right"};b.__options.side=[b.__options.side,c[b.__options.side]],"left"==b.__options.side[0]||"right"==b.__options.side[0]?b.__options.side.push("top","bottom"):b.__options.side.push("right","left")}6===a.tooltipster._env.IE&&b.__options.arrow!==!0&&(b.__options.arrow=!1)},__reposition:function(b,c){var d,e=this,f=e.__targetFind(c),g=[];e.__instance._$tooltip.detach();var h=e.__instance._$tooltip.clone(),i=a.tooltipster._getRuler(h),j=!1,k=e.__instance.option("animation");switch(k&&h.removeClass("tooltipster-"+k),a.each(["window","document"],function(d,k){var l=null;if(e.__instance._trigger({container:k,helper:c,satisfied:j,takeTest:function(a){l=a},results:g,type:"positionTest"}),1==l||0!=l&&0==j&&("window"!=k||e.__options.viewportAware))for(var d=0;d<e.__options.side.length;d++){var m={horizontal:0,vertical:0},n=e.__options.side[d];"top"==n||"bottom"==n?m.vertical=e.__options.distance[n]:m.horizontal=e.__options.distance[n],e.__sideChange(h,n),a.each(["natural","constrained"],function(a,d){if(l=null,e.__instance._trigger({container:k,event:b,helper:c,mode:d,results:g,satisfied:j,side:n,takeTest:function(a){l=a},type:"positionTest"}),1==l||0!=l&&0==j){var h={container:k,distance:m,fits:null,mode:d,outerSize:null,side:n,size:null,target:f[n],whole:null},o="natural"==d?i.free():i.constrain(c.geo.available[k][n].width-m.horizontal,c.geo.available[k][n].height-m.vertical),p=o.measure();if(h.size=p.size,h.outerSize={height:p.size.height+m.vertical,width:p.size.width+m.horizontal},"natural"==d?c.geo.available[k][n].width>=h.outerSize.width&&c.geo.available[k][n].height>=h.outerSize.height?h.fits=!0:h.fits=!1:h.fits=p.fits,"window"==k&&(h.fits?"top"==n||"bottom"==n?h.whole=c.geo.origin.windowOffset.right>=e.__options.minIntersection&&c.geo.window.size.width-c.geo.origin.windowOffset.left>=e.__options.minIntersection:h.whole=c.geo.origin.windowOffset.bottom>=e.__options.minIntersection&&c.geo.window.size.height-c.geo.origin.windowOffset.top>=e.__options.minIntersection:h.whole=!1),g.push(h),h.whole)j=!0;else if("natural"==h.mode&&(h.fits||h.size.width<=c.geo.available[k][n].width))return!1}})}}),e.__instance._trigger({edit:function(a){g=a},event:b,helper:c,results:g,type:"positionTested"}),g.sort(function(a,b){if(a.whole&&!b.whole)return-1;if(!a.whole&&b.whole)return 1;if(a.whole&&b.whole){var c=e.__options.side.indexOf(a.side),d=e.__options.side.indexOf(b.side);return d>c?-1:c>d?1:"natural"==a.mode?-1:1}if(a.fits&&!b.fits)return-1;if(!a.fits&&b.fits)return 1;if(a.fits&&b.fits){var c=e.__options.side.indexOf(a.side),d=e.__options.side.indexOf(b.side);return d>c?-1:c>d?1:"natural"==a.mode?-1:1}return"document"==a.container&&"bottom"==a.side&&"natural"==a.mode?-1:1}),d=g[0],d.coord={},d.side){case"left":case"right":d.coord.top=Math.floor(d.target-d.size.height/2);break;case"bottom":case"top":d.coord.left=Math.floor(d.target-d.size.width/2)}switch(d.side){case"left":d.coord.left=c.geo.origin.windowOffset.left-d.outerSize.width;break;case"right":d.coord.left=c.geo.origin.windowOffset.right+d.distance.horizontal;break;case"top":d.coord.top=c.geo.origin.windowOffset.top-d.outerSize.height;break;case"bottom":d.coord.top=c.geo.origin.windowOffset.bottom+d.distance.vertical}"window"==d.container?"top"==d.side||"bottom"==d.side?d.coord.left<0?c.geo.origin.windowOffset.right-this.__options.minIntersection>=0?d.coord.left=0:d.coord.left=c.geo.origin.windowOffset.right-this.__options.minIntersection-1:d.coord.left>c.geo.window.size.width-d.size.width&&(c.geo.origin.windowOffset.left+this.__options.minIntersection<=c.geo.window.size.width?d.coord.left=c.geo.window.size.width-d.size.width:d.coord.left=c.geo.origin.windowOffset.left+this.__options.minIntersection+1-d.size.width):d.coord.top<0?c.geo.origin.windowOffset.bottom-this.__options.minIntersection>=0?d.coord.top=0:d.coord.top=c.geo.origin.windowOffset.bottom-this.__options.minIntersection-1:d.coord.top>c.geo.window.size.height-d.size.height&&(c.geo.origin.windowOffset.top+this.__options.minIntersection<=c.geo.window.size.height?d.coord.top=c.geo.window.size.height-d.size.height:d.coord.top=c.geo.origin.windowOffset.top+this.__options.minIntersection+1-d.size.height):(d.coord.left>c.geo.window.size.width-d.size.width&&(d.coord.left=c.geo.window.size.width-d.size.width),d.coord.left<0&&(d.coord.left=0)),e.__sideChange(h,d.side),c.tooltipClone=h[0],c.tooltipParent=e.__instance.option("parent").parent[0],c.mode=d.mode,c.whole=d.whole,c.origin=e.__instance._$origin[0],c.tooltip=e.__instance._$tooltip[0],delete d.container,delete d.fits,delete d.mode,delete d.outerSize,delete d.whole,d.distance=d.distance.horizontal||d.distance.vertical;var l=a.extend(!0,{},d);if(e.__instance._trigger({edit:function(a){d=a},event:b,helper:c,position:l,type:"position"}),e.__options.functionPosition){var m=e.__options.functionPosition.call(e,e.__instance,c,l);m&&(d=m)}i.destroy();var n,o;"top"==d.side||"bottom"==d.side?(n={prop:"left",val:d.target-d.coord.left},o=d.size.width-this.__options.minIntersection):(n={prop:"top",val:d.target-d.coord.top},o=d.size.height-this.__options.minIntersection),n.val<this.__options.minIntersection?n.val=this.__options.minIntersection:n.val>o&&(n.val=o);var p;p=c.geo.origin.fixedLineage?c.geo.origin.windowOffset:{left:c.geo.origin.windowOffset.left+c.geo.window.scroll.left,top:c.geo.origin.windowOffset.top+c.geo.window.scroll.top},d.coord={left:p.left+(d.coord.left-c.geo.origin.windowOffset.left),top:p.top+(d.coord.top-c.geo.origin.windowOffset.top)},e.__sideChange(e.__instance._$tooltip,d.side),c.geo.origin.fixedLineage?e.__instance._$tooltip.css("position","fixed"):e.__instance._$tooltip.css("position",""),e.__instance._$tooltip.css({left:d.coord.left,top:d.coord.top,height:d.size.height,width:d.size.width}).find(".tooltipster-arrow").css({left:"",top:""}).css(n.prop,n.val),e.__instance._$tooltip.appendTo(e.__instance.option("parent")),e.__instance._trigger({type:"repositioned",event:b,position:d})},__sideChange:function(a,b){a.removeClass("tooltipster-bottom").removeClass("tooltipster-left").removeClass("tooltipster-right").removeClass("tooltipster-top").addClass("tooltipster-"+b)},__targetFind:function(a){var b={},c=this.__instance._$origin[0].getClientRects();if(c.length>1){var d=this.__instance._$origin.css("opacity");1==d&&(this.__instance._$origin.css("opacity",.99),c=this.__instance._$origin[0].getClientRects(),this.__instance._$origin.css("opacity",1))}if(c.length<2)b.top=Math.floor(a.geo.origin.windowOffset.left+a.geo.origin.size.width/2),b.bottom=b.top,b.left=Math.floor(a.geo.origin.windowOffset.top+a.geo.origin.size.height/2),b.right=b.left;else{var e=c[0];b.top=Math.floor(e.left+(e.right-e.left)/2),e=c.length>2?c[Math.ceil(c.length/2)-1]:c[0],b.right=Math.floor(e.top+(e.bottom-e.top)/2),e=c[c.length-1],b.bottom=Math.floor(e.left+(e.right-e.left)/2),e=c.length>2?c[Math.ceil((c.length+1)/2)-1]:c[c.length-1],b.left=Math.floor(e.top+(e.bottom-e.top)/2)}return b}}}),a});

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	Author: Geraint Luff and others
	Year: 2013
	
	This code is released into the "public domain" by its author(s).  Anybody may use, alter and distribute the code without restriction.  The author makes no guarantees, and takes no liability of any kind for use of this code.
	
	If you find a bug or make an improvement, it would be courteous to let the author know, but it is not compulsory.
	*/
	(function (global, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module.exports){
	    // CommonJS. Define export.
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.tv4 = factory();
	  }
	}(this, function () {
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FObject%2Fkeys
	if (!Object.keys) {
		Object.keys = (function () {
			var hasOwnProperty = Object.prototype.hasOwnProperty,
				hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
				dontEnums = [
					'toString',
					'toLocaleString',
					'valueOf',
					'hasOwnProperty',
					'isPrototypeOf',
					'propertyIsEnumerable',
					'constructor'
				],
				dontEnumsLength = dontEnums.length;
	
			return function (obj) {
				if (typeof obj !== 'object' && typeof obj !== 'function' || obj === null) {
					throw new TypeError('Object.keys called on non-object');
				}
	
				var result = [];
	
				for (var prop in obj) {
					if (hasOwnProperty.call(obj, prop)) {
						result.push(prop);
					}
				}
	
				if (hasDontEnumBug) {
					for (var i=0; i < dontEnumsLength; i++) {
						if (hasOwnProperty.call(obj, dontEnums[i])) {
							result.push(dontEnums[i]);
						}
					}
				}
				return result;
			};
		})();
	}
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
	if (!Object.create) {
		Object.create = (function(){
			function F(){}
	
			return function(o){
				if (arguments.length !== 1) {
					throw new Error('Object.create implementation only accepts one parameter.');
				}
				F.prototype = o;
				return new F();
			};
		})();
	}
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FisArray
	if(!Array.isArray) {
		Array.isArray = function (vArg) {
			return Object.prototype.toString.call(vArg) === "[object Array]";
		};
	}
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FindexOf
	if (!Array.prototype.indexOf) {
		Array.prototype.indexOf = function (searchElement /*, fromIndex */ ) {
			if (this === null) {
				throw new TypeError();
			}
			var t = Object(this);
			var len = t.length >>> 0;
	
			if (len === 0) {
				return -1;
			}
			var n = 0;
			if (arguments.length > 1) {
				n = Number(arguments[1]);
				if (n !== n) { // shortcut for verifying if it's NaN
					n = 0;
				} else if (n !== 0 && n !== Infinity && n !== -Infinity) {
					n = (n > 0 || -1) * Math.floor(Math.abs(n));
				}
			}
			if (n >= len) {
				return -1;
			}
			var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
			for (; k < len; k++) {
				if (k in t && t[k] === searchElement) {
					return k;
				}
			}
			return -1;
		};
	}
	
	// Grungey Object.isFrozen hack
	if (!Object.isFrozen) {
		Object.isFrozen = function (obj) {
			var key = "tv4_test_frozen_key";
			while (obj.hasOwnProperty(key)) {
				key += Math.random();
			}
			try {
				obj[key] = true;
				delete obj[key];
				return false;
			} catch (e) {
				return true;
			}
		};
	}
	// Based on: https://github.com/geraintluff/uri-templates, but with all the de-substitution stuff removed
	
	var uriTemplateGlobalModifiers = {
		"+": true,
		"#": true,
		".": true,
		"/": true,
		";": true,
		"?": true,
		"&": true
	};
	var uriTemplateSuffices = {
		"*": true
	};
	
	function notReallyPercentEncode(string) {
		return encodeURI(string).replace(/%25[0-9][0-9]/g, function (doubleEncoded) {
			return "%" + doubleEncoded.substring(3);
		});
	}
	
	function uriTemplateSubstitution(spec) {
		var modifier = "";
		if (uriTemplateGlobalModifiers[spec.charAt(0)]) {
			modifier = spec.charAt(0);
			spec = spec.substring(1);
		}
		var separator = "";
		var prefix = "";
		var shouldEscape = true;
		var showVariables = false;
		var trimEmptyString = false;
		if (modifier === '+') {
			shouldEscape = false;
		} else if (modifier === ".") {
			prefix = ".";
			separator = ".";
		} else if (modifier === "/") {
			prefix = "/";
			separator = "/";
		} else if (modifier === '#') {
			prefix = "#";
			shouldEscape = false;
		} else if (modifier === ';') {
			prefix = ";";
			separator = ";";
			showVariables = true;
			trimEmptyString = true;
		} else if (modifier === '?') {
			prefix = "?";
			separator = "&";
			showVariables = true;
		} else if (modifier === '&') {
			prefix = "&";
			separator = "&";
			showVariables = true;
		}
	
		var varNames = [];
		var varList = spec.split(",");
		var varSpecs = [];
		var varSpecMap = {};
		for (var i = 0; i < varList.length; i++) {
			var varName = varList[i];
			var truncate = null;
			if (varName.indexOf(":") !== -1) {
				var parts = varName.split(":");
				varName = parts[0];
				truncate = parseInt(parts[1], 10);
			}
			var suffices = {};
			while (uriTemplateSuffices[varName.charAt(varName.length - 1)]) {
				suffices[varName.charAt(varName.length - 1)] = true;
				varName = varName.substring(0, varName.length - 1);
			}
			var varSpec = {
				truncate: truncate,
				name: varName,
				suffices: suffices
			};
			varSpecs.push(varSpec);
			varSpecMap[varName] = varSpec;
			varNames.push(varName);
		}
		var subFunction = function (valueFunction) {
			var result = "";
			var startIndex = 0;
			for (var i = 0; i < varSpecs.length; i++) {
				var varSpec = varSpecs[i];
				var value = valueFunction(varSpec.name);
				if (value === null || value === undefined || (Array.isArray(value) && value.length === 0) || (typeof value === 'object' && Object.keys(value).length === 0)) {
					startIndex++;
					continue;
				}
				if (i === startIndex) {
					result += prefix;
				} else {
					result += (separator || ",");
				}
				if (Array.isArray(value)) {
					if (showVariables) {
						result += varSpec.name + "=";
					}
					for (var j = 0; j < value.length; j++) {
						if (j > 0) {
							result += varSpec.suffices['*'] ? (separator || ",") : ",";
							if (varSpec.suffices['*'] && showVariables) {
								result += varSpec.name + "=";
							}
						}
						result += shouldEscape ? encodeURIComponent(value[j]).replace(/!/g, "%21") : notReallyPercentEncode(value[j]);
					}
				} else if (typeof value === "object") {
					if (showVariables && !varSpec.suffices['*']) {
						result += varSpec.name + "=";
					}
					var first = true;
					for (var key in value) {
						if (!first) {
							result += varSpec.suffices['*'] ? (separator || ",") : ",";
						}
						first = false;
						result += shouldEscape ? encodeURIComponent(key).replace(/!/g, "%21") : notReallyPercentEncode(key);
						result += varSpec.suffices['*'] ? '=' : ",";
						result += shouldEscape ? encodeURIComponent(value[key]).replace(/!/g, "%21") : notReallyPercentEncode(value[key]);
					}
				} else {
					if (showVariables) {
						result += varSpec.name;
						if (!trimEmptyString || value !== "") {
							result += "=";
						}
					}
					if (varSpec.truncate != null) {
						value = value.substring(0, varSpec.truncate);
					}
					result += shouldEscape ? encodeURIComponent(value).replace(/!/g, "%21"): notReallyPercentEncode(value);
				}
			}
			return result;
		};
		subFunction.varNames = varNames;
		return {
			prefix: prefix,
			substitution: subFunction
		};
	}
	
	function UriTemplate(template) {
		if (!(this instanceof UriTemplate)) {
			return new UriTemplate(template);
		}
		var parts = template.split("{");
		var textParts = [parts.shift()];
		var prefixes = [];
		var substitutions = [];
		var varNames = [];
		while (parts.length > 0) {
			var part = parts.shift();
			var spec = part.split("}")[0];
			var remainder = part.substring(spec.length + 1);
			var funcs = uriTemplateSubstitution(spec);
			substitutions.push(funcs.substitution);
			prefixes.push(funcs.prefix);
			textParts.push(remainder);
			varNames = varNames.concat(funcs.substitution.varNames);
		}
		this.fill = function (valueFunction) {
			var result = textParts[0];
			for (var i = 0; i < substitutions.length; i++) {
				var substitution = substitutions[i];
				result += substitution(valueFunction);
				result += textParts[i + 1];
			}
			return result;
		};
		this.varNames = varNames;
		this.template = template;
	}
	UriTemplate.prototype = {
		toString: function () {
			return this.template;
		},
		fillFromObject: function (obj) {
			return this.fill(function (varName) {
				return obj[varName];
			});
		}
	};
	var ValidatorContext = function ValidatorContext(parent, collectMultiple, errorReporter, checkRecursive, trackUnknownProperties) {
		this.missing = [];
		this.missingMap = {};
		this.formatValidators = parent ? Object.create(parent.formatValidators) : {};
		this.schemas = parent ? Object.create(parent.schemas) : {};
		this.collectMultiple = collectMultiple;
		this.errors = [];
		this.handleError = collectMultiple ? this.collectError : this.returnError;
		if (checkRecursive) {
			this.checkRecursive = true;
			this.scanned = [];
			this.scannedFrozen = [];
			this.scannedFrozenSchemas = [];
			this.scannedFrozenValidationErrors = [];
			this.validatedSchemasKey = 'tv4_validation_id';
			this.validationErrorsKey = 'tv4_validation_errors_id';
		}
		if (trackUnknownProperties) {
			this.trackUnknownProperties = true;
			this.knownPropertyPaths = {};
			this.unknownPropertyPaths = {};
		}
		this.errorReporter = errorReporter || defaultErrorReporter('en');
		if (typeof this.errorReporter === 'string') {
			throw new Error('debug');
		}
		this.definedKeywords = {};
		if (parent) {
			for (var key in parent.definedKeywords) {
				this.definedKeywords[key] = parent.definedKeywords[key].slice(0);
			}
		}
	};
	ValidatorContext.prototype.defineKeyword = function (keyword, keywordFunction) {
		this.definedKeywords[keyword] = this.definedKeywords[keyword] || [];
		this.definedKeywords[keyword].push(keywordFunction);
	};
	ValidatorContext.prototype.createError = function (code, messageParams, dataPath, schemaPath, subErrors, data, schema) {
		var error = new ValidationError(code, messageParams, dataPath, schemaPath, subErrors);
		error.message = this.errorReporter(error, data, schema);
		return error;
	};
	ValidatorContext.prototype.returnError = function (error) {
		return error;
	};
	ValidatorContext.prototype.collectError = function (error) {
		if (error) {
			this.errors.push(error);
		}
		return null;
	};
	ValidatorContext.prototype.prefixErrors = function (startIndex, dataPath, schemaPath) {
		for (var i = startIndex; i < this.errors.length; i++) {
			this.errors[i] = this.errors[i].prefixWith(dataPath, schemaPath);
		}
		return this;
	};
	ValidatorContext.prototype.banUnknownProperties = function (data, schema) {
		for (var unknownPath in this.unknownPropertyPaths) {
			var error = this.createError(ErrorCodes.UNKNOWN_PROPERTY, {path: unknownPath}, unknownPath, "", null, data, schema);
			var result = this.handleError(error);
			if (result) {
				return result;
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.addFormat = function (format, validator) {
		if (typeof format === 'object') {
			for (var key in format) {
				this.addFormat(key, format[key]);
			}
			return this;
		}
		this.formatValidators[format] = validator;
	};
	ValidatorContext.prototype.resolveRefs = function (schema, urlHistory) {
		if (schema['$ref'] !== undefined) {
			urlHistory = urlHistory || {};
			if (urlHistory[schema['$ref']]) {
				return this.createError(ErrorCodes.CIRCULAR_REFERENCE, {urls: Object.keys(urlHistory).join(', ')}, '', '', null, undefined, schema);
			}
			urlHistory[schema['$ref']] = true;
			schema = this.getSchema(schema['$ref'], urlHistory);
		}
		return schema;
	};
	ValidatorContext.prototype.getSchema = function (url, urlHistory) {
		var schema;
		if (this.schemas[url] !== undefined) {
			schema = this.schemas[url];
			return this.resolveRefs(schema, urlHistory);
		}
		var baseUrl = url;
		var fragment = "";
		if (url.indexOf('#') !== -1) {
			fragment = url.substring(url.indexOf("#") + 1);
			baseUrl = url.substring(0, url.indexOf("#"));
		}
		if (typeof this.schemas[baseUrl] === 'object') {
			schema = this.schemas[baseUrl];
			var pointerPath = decodeURIComponent(fragment);
			if (pointerPath === "") {
				return this.resolveRefs(schema, urlHistory);
			} else if (pointerPath.charAt(0) !== "/") {
				return undefined;
			}
			var parts = pointerPath.split("/").slice(1);
			for (var i = 0; i < parts.length; i++) {
				var component = parts[i].replace(/~1/g, "/").replace(/~0/g, "~");
				if (schema[component] === undefined) {
					schema = undefined;
					break;
				}
				schema = schema[component];
			}
			if (schema !== undefined) {
				return this.resolveRefs(schema, urlHistory);
			}
		}
		if (this.missing[baseUrl] === undefined) {
			this.missing.push(baseUrl);
			this.missing[baseUrl] = baseUrl;
			this.missingMap[baseUrl] = baseUrl;
		}
	};
	ValidatorContext.prototype.searchSchemas = function (schema, url) {
		if (Array.isArray(schema)) {
			for (var i = 0; i < schema.length; i++) {
				this.searchSchemas(schema[i], url);
			}
		} else if (schema && typeof schema === "object") {
			if (typeof schema.id === "string") {
				if (isTrustedUrl(url, schema.id)) {
					if (this.schemas[schema.id] === undefined) {
						this.schemas[schema.id] = schema;
					}
				}
			}
			for (var key in schema) {
				if (key !== "enum") {
					if (typeof schema[key] === "object") {
						this.searchSchemas(schema[key], url);
					} else if (key === "$ref") {
						var uri = getDocumentUri(schema[key]);
						if (uri && this.schemas[uri] === undefined && this.missingMap[uri] === undefined) {
							this.missingMap[uri] = uri;
						}
					}
				}
			}
		}
	};
	ValidatorContext.prototype.addSchema = function (url, schema) {
		//overload
		if (typeof url !== 'string' || typeof schema === 'undefined') {
			if (typeof url === 'object' && typeof url.id === 'string') {
				schema = url;
				url = schema.id;
			}
			else {
				return;
			}
		}
		if (url === getDocumentUri(url) + "#") {
			// Remove empty fragment
			url = getDocumentUri(url);
		}
		this.schemas[url] = schema;
		delete this.missingMap[url];
		normSchema(schema, url);
		this.searchSchemas(schema, url);
	};
	
	ValidatorContext.prototype.getSchemaMap = function () {
		var map = {};
		for (var key in this.schemas) {
			map[key] = this.schemas[key];
		}
		return map;
	};
	
	ValidatorContext.prototype.getSchemaUris = function (filterRegExp) {
		var list = [];
		for (var key in this.schemas) {
			if (!filterRegExp || filterRegExp.test(key)) {
				list.push(key);
			}
		}
		return list;
	};
	
	ValidatorContext.prototype.getMissingUris = function (filterRegExp) {
		var list = [];
		for (var key in this.missingMap) {
			if (!filterRegExp || filterRegExp.test(key)) {
				list.push(key);
			}
		}
		return list;
	};
	
	ValidatorContext.prototype.dropSchemas = function () {
		this.schemas = {};
		this.reset();
	};
	ValidatorContext.prototype.reset = function () {
		this.missing = [];
		this.missingMap = {};
		this.errors = [];
	};
	
	ValidatorContext.prototype.validateAll = function (data, schema, dataPathParts, schemaPathParts, dataPointerPath) {
		var topLevel;
		schema = this.resolveRefs(schema);
		if (!schema) {
			return null;
		} else if (schema instanceof ValidationError) {
			this.errors.push(schema);
			return schema;
		}
	
		var startErrorCount = this.errors.length;
		var frozenIndex, scannedFrozenSchemaIndex = null, scannedSchemasIndex = null;
		if (this.checkRecursive && data && typeof data === 'object') {
			topLevel = !this.scanned.length;
			if (data[this.validatedSchemasKey]) {
				var schemaIndex = data[this.validatedSchemasKey].indexOf(schema);
				if (schemaIndex !== -1) {
					this.errors = this.errors.concat(data[this.validationErrorsKey][schemaIndex]);
					return null;
				}
			}
			if (Object.isFrozen(data)) {
				frozenIndex = this.scannedFrozen.indexOf(data);
				if (frozenIndex !== -1) {
					var frozenSchemaIndex = this.scannedFrozenSchemas[frozenIndex].indexOf(schema);
					if (frozenSchemaIndex !== -1) {
						this.errors = this.errors.concat(this.scannedFrozenValidationErrors[frozenIndex][frozenSchemaIndex]);
						return null;
					}
				}
			}
			this.scanned.push(data);
			if (Object.isFrozen(data)) {
				if (frozenIndex === -1) {
					frozenIndex = this.scannedFrozen.length;
					this.scannedFrozen.push(data);
					this.scannedFrozenSchemas.push([]);
				}
				scannedFrozenSchemaIndex = this.scannedFrozenSchemas[frozenIndex].length;
				this.scannedFrozenSchemas[frozenIndex][scannedFrozenSchemaIndex] = schema;
				this.scannedFrozenValidationErrors[frozenIndex][scannedFrozenSchemaIndex] = [];
			} else {
				if (!data[this.validatedSchemasKey]) {
					try {
						Object.defineProperty(data, this.validatedSchemasKey, {
							value: [],
							configurable: true
						});
						Object.defineProperty(data, this.validationErrorsKey, {
							value: [],
							configurable: true
						});
					} catch (e) {
						//IE 7/8 workaround
						data[this.validatedSchemasKey] = [];
						data[this.validationErrorsKey] = [];
					}
				}
				scannedSchemasIndex = data[this.validatedSchemasKey].length;
				data[this.validatedSchemasKey][scannedSchemasIndex] = schema;
				data[this.validationErrorsKey][scannedSchemasIndex] = [];
			}
		}
	
		var errorCount = this.errors.length;
		var error = this.validateBasic(data, schema, dataPointerPath)
			|| this.validateNumeric(data, schema, dataPointerPath)
			|| this.validateString(data, schema, dataPointerPath)
			|| this.validateArray(data, schema, dataPointerPath)
			|| this.validateObject(data, schema, dataPointerPath)
			|| this.validateCombinations(data, schema, dataPointerPath)
			|| this.validateHypermedia(data, schema, dataPointerPath)
			|| this.validateFormat(data, schema, dataPointerPath)
			|| this.validateDefinedKeywords(data, schema, dataPointerPath)
			|| null;
	
		if (topLevel) {
			while (this.scanned.length) {
				var item = this.scanned.pop();
				delete item[this.validatedSchemasKey];
			}
			this.scannedFrozen = [];
			this.scannedFrozenSchemas = [];
		}
	
		if (error || errorCount !== this.errors.length) {
			while ((dataPathParts && dataPathParts.length) || (schemaPathParts && schemaPathParts.length)) {
				var dataPart = (dataPathParts && dataPathParts.length) ? "" + dataPathParts.pop() : null;
				var schemaPart = (schemaPathParts && schemaPathParts.length) ? "" + schemaPathParts.pop() : null;
				if (error) {
					error = error.prefixWith(dataPart, schemaPart);
				}
				this.prefixErrors(errorCount, dataPart, schemaPart);
			}
		}
	
		if (scannedFrozenSchemaIndex !== null) {
			this.scannedFrozenValidationErrors[frozenIndex][scannedFrozenSchemaIndex] = this.errors.slice(startErrorCount);
		} else if (scannedSchemasIndex !== null) {
			data[this.validationErrorsKey][scannedSchemasIndex] = this.errors.slice(startErrorCount);
		}
	
		return this.handleError(error);
	};
	ValidatorContext.prototype.validateFormat = function (data, schema) {
		if (typeof schema.format !== 'string' || !this.formatValidators[schema.format]) {
			return null;
		}
		var errorMessage = this.formatValidators[schema.format].call(null, data, schema);
		if (typeof errorMessage === 'string' || typeof errorMessage === 'number') {
			return this.createError(ErrorCodes.FORMAT_CUSTOM, {message: errorMessage}, '', '/format', null, data, schema);
		} else if (errorMessage && typeof errorMessage === 'object') {
			return this.createError(ErrorCodes.FORMAT_CUSTOM, {message: errorMessage.message || "?"}, errorMessage.dataPath || '', errorMessage.schemaPath || "/format", null, data, schema);
		}
		return null;
	};
	ValidatorContext.prototype.validateDefinedKeywords = function (data, schema, dataPointerPath) {
		for (var key in this.definedKeywords) {
			if (typeof schema[key] === 'undefined') {
				continue;
			}
			var validationFunctions = this.definedKeywords[key];
			for (var i = 0; i < validationFunctions.length; i++) {
				var func = validationFunctions[i];
				var result = func(data, schema[key], schema, dataPointerPath);
				if (typeof result === 'string' || typeof result === 'number') {
					return this.createError(ErrorCodes.KEYWORD_CUSTOM, {key: key, message: result}, '', '', null, data, schema).prefixWith(null, key);
				} else if (result && typeof result === 'object') {
					var code = result.code;
					if (typeof code === 'string') {
						if (!ErrorCodes[code]) {
							throw new Error('Undefined error code (use defineError): ' + code);
						}
						code = ErrorCodes[code];
					} else if (typeof code !== 'number') {
						code = ErrorCodes.KEYWORD_CUSTOM;
					}
					var messageParams = (typeof result.message === 'object') ? result.message : {key: key, message: result.message || "?"};
					var schemaPath = result.schemaPath || ("/" + key.replace(/~/g, '~0').replace(/\//g, '~1'));
					return this.createError(code, messageParams, result.dataPath || null, schemaPath, null, data, schema);
				}
			}
		}
		return null;
	};
	
	function recursiveCompare(A, B) {
		if (A === B) {
			return true;
		}
		if (A && B && typeof A === "object" && typeof B === "object") {
			if (Array.isArray(A) !== Array.isArray(B)) {
				return false;
			} else if (Array.isArray(A)) {
				if (A.length !== B.length) {
					return false;
				}
				for (var i = 0; i < A.length; i++) {
					if (!recursiveCompare(A[i], B[i])) {
						return false;
					}
				}
			} else {
				var key;
				for (key in A) {
					if (B[key] === undefined && A[key] !== undefined) {
						return false;
					}
				}
				for (key in B) {
					if (A[key] === undefined && B[key] !== undefined) {
						return false;
					}
				}
				for (key in A) {
					if (!recursiveCompare(A[key], B[key])) {
						return false;
					}
				}
			}
			return true;
		}
		return false;
	}
	
	ValidatorContext.prototype.validateBasic = function validateBasic(data, schema, dataPointerPath) {
		var error;
		if (error = this.validateType(data, schema, dataPointerPath)) {
			return error.prefixWith(null, "type");
		}
		if (error = this.validateEnum(data, schema, dataPointerPath)) {
			return error.prefixWith(null, "type");
		}
		return null;
	};
	
	ValidatorContext.prototype.validateType = function validateType(data, schema) {
		if (schema.type === undefined) {
			return null;
		}
		var dataType = typeof data;
		if (data === null) {
			dataType = "null";
		} else if (Array.isArray(data)) {
			dataType = "array";
		}
		var allowedTypes = schema.type;
		if (!Array.isArray(allowedTypes)) {
			allowedTypes = [allowedTypes];
		}
	
		for (var i = 0; i < allowedTypes.length; i++) {
			var type = allowedTypes[i];
			if (type === dataType || (type === "integer" && dataType === "number" && (data % 1 === 0))) {
				return null;
			}
		}
		return this.createError(ErrorCodes.INVALID_TYPE, {type: dataType, expected: allowedTypes.join("/")}, '', '', null, data, schema);
	};
	
	ValidatorContext.prototype.validateEnum = function validateEnum(data, schema) {
		if (schema["enum"] === undefined) {
			return null;
		}
		for (var i = 0; i < schema["enum"].length; i++) {
			var enumVal = schema["enum"][i];
			if (recursiveCompare(data, enumVal)) {
				return null;
			}
		}
		return this.createError(ErrorCodes.ENUM_MISMATCH, {value: (typeof JSON !== 'undefined') ? JSON.stringify(data) : data}, '', '', null, data, schema);
	};
	
	ValidatorContext.prototype.validateNumeric = function validateNumeric(data, schema, dataPointerPath) {
		return this.validateMultipleOf(data, schema, dataPointerPath)
			|| this.validateMinMax(data, schema, dataPointerPath)
			|| this.validateNaN(data, schema, dataPointerPath)
			|| null;
	};
	
	var CLOSE_ENOUGH_LOW = Math.pow(2, -51);
	var CLOSE_ENOUGH_HIGH = 1 - CLOSE_ENOUGH_LOW;
	ValidatorContext.prototype.validateMultipleOf = function validateMultipleOf(data, schema) {
		var multipleOf = schema.multipleOf || schema.divisibleBy;
		if (multipleOf === undefined) {
			return null;
		}
		if (typeof data === "number") {
			var remainder = (data/multipleOf)%1;
			if (remainder >= CLOSE_ENOUGH_LOW && remainder < CLOSE_ENOUGH_HIGH) {
				return this.createError(ErrorCodes.NUMBER_MULTIPLE_OF, {value: data, multipleOf: multipleOf}, '', '', null, data, schema);
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateMinMax = function validateMinMax(data, schema) {
		if (typeof data !== "number") {
			return null;
		}
		if (schema.minimum !== undefined) {
			if (data < schema.minimum) {
				return this.createError(ErrorCodes.NUMBER_MINIMUM, {value: data, minimum: schema.minimum}, '', '/minimum', null, data, schema);
			}
			if (schema.exclusiveMinimum && data === schema.minimum) {
				return this.createError(ErrorCodes.NUMBER_MINIMUM_EXCLUSIVE, {value: data, minimum: schema.minimum}, '', '/exclusiveMinimum', null, data, schema);
			}
		}
		if (schema.maximum !== undefined) {
			if (data > schema.maximum) {
				return this.createError(ErrorCodes.NUMBER_MAXIMUM, {value: data, maximum: schema.maximum}, '', '/maximum', null, data, schema);
			}
			if (schema.exclusiveMaximum && data === schema.maximum) {
				return this.createError(ErrorCodes.NUMBER_MAXIMUM_EXCLUSIVE, {value: data, maximum: schema.maximum}, '', '/exclusiveMaximum', null, data, schema);
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateNaN = function validateNaN(data, schema) {
		if (typeof data !== "number") {
			return null;
		}
		if (isNaN(data) === true || data === Infinity || data === -Infinity) {
			return this.createError(ErrorCodes.NUMBER_NOT_A_NUMBER, {value: data}, '', '/type', null, data, schema);
		}
		return null;
	};
	
	ValidatorContext.prototype.validateString = function validateString(data, schema, dataPointerPath) {
		return this.validateStringLength(data, schema, dataPointerPath)
			|| this.validateStringPattern(data, schema, dataPointerPath)
			|| null;
	};
	
	ValidatorContext.prototype.validateStringLength = function validateStringLength(data, schema) {
		if (typeof data !== "string") {
			return null;
		}
		if (schema.minLength !== undefined) {
			if (data.length < schema.minLength) {
				return this.createError(ErrorCodes.STRING_LENGTH_SHORT, {length: data.length, minimum: schema.minLength}, '', '/minLength', null, data, schema);
			}
		}
		if (schema.maxLength !== undefined) {
			if (data.length > schema.maxLength) {
				return this.createError(ErrorCodes.STRING_LENGTH_LONG, {length: data.length, maximum: schema.maxLength}, '', '/maxLength', null, data, schema);
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateStringPattern = function validateStringPattern(data, schema) {
		if (typeof data !== "string" || (typeof schema.pattern !== "string" && !(schema.pattern instanceof RegExp))) {
			return null;
		}
		var regexp;
		if (schema.pattern instanceof RegExp) {
		  regexp = schema.pattern;
		}
		else {
		  var body, flags = '';
		  // Check for regular expression literals
		  // @see http://www.ecma-international.org/ecma-262/5.1/#sec-7.8.5
		  var literal = schema.pattern.match(/^\/(.+)\/([img]*)$/);
		  if (literal) {
		    body = literal[1];
		    flags = literal[2];
		  }
		  else {
		    body = schema.pattern;
		  }
		  regexp = new RegExp(body, flags);
		}
		if (!regexp.test(data)) {
			return this.createError(ErrorCodes.STRING_PATTERN, {pattern: schema.pattern}, '', '/pattern', null, data, schema);
		}
		return null;
	};
	
	ValidatorContext.prototype.validateArray = function validateArray(data, schema, dataPointerPath) {
		if (!Array.isArray(data)) {
			return null;
		}
		return this.validateArrayLength(data, schema, dataPointerPath)
			|| this.validateArrayUniqueItems(data, schema, dataPointerPath)
			|| this.validateArrayItems(data, schema, dataPointerPath)
			|| null;
	};
	
	ValidatorContext.prototype.validateArrayLength = function validateArrayLength(data, schema) {
		var error;
		if (schema.minItems !== undefined) {
			if (data.length < schema.minItems) {
				error = this.createError(ErrorCodes.ARRAY_LENGTH_SHORT, {length: data.length, minimum: schema.minItems}, '', '/minItems', null, data, schema);
				if (this.handleError(error)) {
					return error;
				}
			}
		}
		if (schema.maxItems !== undefined) {
			if (data.length > schema.maxItems) {
				error = this.createError(ErrorCodes.ARRAY_LENGTH_LONG, {length: data.length, maximum: schema.maxItems}, '', '/maxItems', null, data, schema);
				if (this.handleError(error)) {
					return error;
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateArrayUniqueItems = function validateArrayUniqueItems(data, schema) {
		if (schema.uniqueItems) {
			for (var i = 0; i < data.length; i++) {
				for (var j = i + 1; j < data.length; j++) {
					if (recursiveCompare(data[i], data[j])) {
						var error = this.createError(ErrorCodes.ARRAY_UNIQUE, {match1: i, match2: j}, '', '/uniqueItems', null, data, schema);
						if (this.handleError(error)) {
							return error;
						}
					}
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateArrayItems = function validateArrayItems(data, schema, dataPointerPath) {
		if (schema.items === undefined) {
			return null;
		}
		var error, i;
		if (Array.isArray(schema.items)) {
			for (i = 0; i < data.length; i++) {
				if (i < schema.items.length) {
					if (error = this.validateAll(data[i], schema.items[i], [i], ["items", i], dataPointerPath + "/" + i)) {
						return error;
					}
				} else if (schema.additionalItems !== undefined) {
					if (typeof schema.additionalItems === "boolean") {
						if (!schema.additionalItems) {
							error = (this.createError(ErrorCodes.ARRAY_ADDITIONAL_ITEMS, {}, '/' + i, '/additionalItems', null, data, schema));
							if (this.handleError(error)) {
								return error;
							}
						}
					} else if (error = this.validateAll(data[i], schema.additionalItems, [i], ["additionalItems"], dataPointerPath + "/" + i)) {
						return error;
					}
				}
			}
		} else {
			for (i = 0; i < data.length; i++) {
				if (error = this.validateAll(data[i], schema.items, [i], ["items"], dataPointerPath + "/" + i)) {
					return error;
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateObject = function validateObject(data, schema, dataPointerPath) {
		if (typeof data !== "object" || data === null || Array.isArray(data)) {
			return null;
		}
		return this.validateObjectMinMaxProperties(data, schema, dataPointerPath)
			|| this.validateObjectRequiredProperties(data, schema, dataPointerPath)
			|| this.validateObjectProperties(data, schema, dataPointerPath)
			|| this.validateObjectDependencies(data, schema, dataPointerPath)
			|| null;
	};
	
	ValidatorContext.prototype.validateObjectMinMaxProperties = function validateObjectMinMaxProperties(data, schema) {
		var keys = Object.keys(data);
		var error;
		if (schema.minProperties !== undefined) {
			if (keys.length < schema.minProperties) {
				error = this.createError(ErrorCodes.OBJECT_PROPERTIES_MINIMUM, {propertyCount: keys.length, minimum: schema.minProperties}, '', '/minProperties', null, data, schema);
				if (this.handleError(error)) {
					return error;
				}
			}
		}
		if (schema.maxProperties !== undefined) {
			if (keys.length > schema.maxProperties) {
				error = this.createError(ErrorCodes.OBJECT_PROPERTIES_MAXIMUM, {propertyCount: keys.length, maximum: schema.maxProperties}, '', '/maxProperties', null, data, schema);
				if (this.handleError(error)) {
					return error;
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateObjectRequiredProperties = function validateObjectRequiredProperties(data, schema) {
		if (schema.required !== undefined) {
			for (var i = 0; i < schema.required.length; i++) {
				var key = schema.required[i];
				if (data[key] === undefined) {
					var error = this.createError(ErrorCodes.OBJECT_REQUIRED, {key: key}, '', '/required/' + i, null, data, schema);
					if (this.handleError(error)) {
						return error;
					}
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateObjectProperties = function validateObjectProperties(data, schema, dataPointerPath) {
		var error;
		for (var key in data) {
			var keyPointerPath = dataPointerPath + "/" + key.replace(/~/g, '~0').replace(/\//g, '~1');
			var foundMatch = false;
			if (schema.properties !== undefined && schema.properties[key] !== undefined) {
				foundMatch = true;
				if (error = this.validateAll(data[key], schema.properties[key], [key], ["properties", key], keyPointerPath)) {
					return error;
				}
			}
			if (schema.patternProperties !== undefined) {
				for (var patternKey in schema.patternProperties) {
					var regexp = new RegExp(patternKey);
					if (regexp.test(key)) {
						foundMatch = true;
						if (error = this.validateAll(data[key], schema.patternProperties[patternKey], [key], ["patternProperties", patternKey], keyPointerPath)) {
							return error;
						}
					}
				}
			}
			if (!foundMatch) {
				if (schema.additionalProperties !== undefined) {
					if (this.trackUnknownProperties) {
						this.knownPropertyPaths[keyPointerPath] = true;
						delete this.unknownPropertyPaths[keyPointerPath];
					}
					if (typeof schema.additionalProperties === "boolean") {
						if (!schema.additionalProperties) {
							error = this.createError(ErrorCodes.OBJECT_ADDITIONAL_PROPERTIES, {key: key}, '', '/additionalProperties', null, data, schema).prefixWith(key, null);
							if (this.handleError(error)) {
								return error;
							}
						}
					} else {
						if (error = this.validateAll(data[key], schema.additionalProperties, [key], ["additionalProperties"], keyPointerPath)) {
							return error;
						}
					}
				} else if (this.trackUnknownProperties && !this.knownPropertyPaths[keyPointerPath]) {
					this.unknownPropertyPaths[keyPointerPath] = true;
				}
			} else if (this.trackUnknownProperties) {
				this.knownPropertyPaths[keyPointerPath] = true;
				delete this.unknownPropertyPaths[keyPointerPath];
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateObjectDependencies = function validateObjectDependencies(data, schema, dataPointerPath) {
		var error;
		if (schema.dependencies !== undefined) {
			for (var depKey in schema.dependencies) {
				if (data[depKey] !== undefined) {
					var dep = schema.dependencies[depKey];
					if (typeof dep === "string") {
						if (data[dep] === undefined) {
							error = this.createError(ErrorCodes.OBJECT_DEPENDENCY_KEY, {key: depKey, missing: dep}, '', '', null, data, schema).prefixWith(null, depKey).prefixWith(null, "dependencies");
							if (this.handleError(error)) {
								return error;
							}
						}
					} else if (Array.isArray(dep)) {
						for (var i = 0; i < dep.length; i++) {
							var requiredKey = dep[i];
							if (data[requiredKey] === undefined) {
								error = this.createError(ErrorCodes.OBJECT_DEPENDENCY_KEY, {key: depKey, missing: requiredKey}, '', '/' + i, null, data, schema).prefixWith(null, depKey).prefixWith(null, "dependencies");
								if (this.handleError(error)) {
									return error;
								}
							}
						}
					} else {
						if (error = this.validateAll(data, dep, [], ["dependencies", depKey], dataPointerPath)) {
							return error;
						}
					}
				}
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateCombinations = function validateCombinations(data, schema, dataPointerPath) {
		return this.validateAllOf(data, schema, dataPointerPath)
			|| this.validateAnyOf(data, schema, dataPointerPath)
			|| this.validateOneOf(data, schema, dataPointerPath)
			|| this.validateNot(data, schema, dataPointerPath)
			|| null;
	};
	
	ValidatorContext.prototype.validateAllOf = function validateAllOf(data, schema, dataPointerPath) {
		if (schema.allOf === undefined) {
			return null;
		}
		var error;
		for (var i = 0; i < schema.allOf.length; i++) {
			var subSchema = schema.allOf[i];
			if (error = this.validateAll(data, subSchema, [], ["allOf", i], dataPointerPath)) {
				return error;
			}
		}
		return null;
	};
	
	ValidatorContext.prototype.validateAnyOf = function validateAnyOf(data, schema, dataPointerPath) {
		if (schema.anyOf === undefined) {
			return null;
		}
		var errors = [];
		var startErrorCount = this.errors.length;
		var oldUnknownPropertyPaths, oldKnownPropertyPaths;
		if (this.trackUnknownProperties) {
			oldUnknownPropertyPaths = this.unknownPropertyPaths;
			oldKnownPropertyPaths = this.knownPropertyPaths;
		}
		var errorAtEnd = true;
		for (var i = 0; i < schema.anyOf.length; i++) {
			if (this.trackUnknownProperties) {
				this.unknownPropertyPaths = {};
				this.knownPropertyPaths = {};
			}
			var subSchema = schema.anyOf[i];
	
			var errorCount = this.errors.length;
			var error = this.validateAll(data, subSchema, [], ["anyOf", i], dataPointerPath);
	
			if (error === null && errorCount === this.errors.length) {
				this.errors = this.errors.slice(0, startErrorCount);
	
				if (this.trackUnknownProperties) {
					for (var knownKey in this.knownPropertyPaths) {
						oldKnownPropertyPaths[knownKey] = true;
						delete oldUnknownPropertyPaths[knownKey];
					}
					for (var unknownKey in this.unknownPropertyPaths) {
						if (!oldKnownPropertyPaths[unknownKey]) {
							oldUnknownPropertyPaths[unknownKey] = true;
						}
					}
					// We need to continue looping so we catch all the property definitions, but we don't want to return an error
					errorAtEnd = false;
					continue;
				}
	
				return null;
			}
			if (error) {
				errors.push(error.prefixWith(null, "" + i).prefixWith(null, "anyOf"));
			}
		}
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = oldUnknownPropertyPaths;
			this.knownPropertyPaths = oldKnownPropertyPaths;
		}
		if (errorAtEnd) {
			errors = errors.concat(this.errors.slice(startErrorCount));
			this.errors = this.errors.slice(0, startErrorCount);
			return this.createError(ErrorCodes.ANY_OF_MISSING, {}, "", "/anyOf", errors, data, schema);
		}
	};
	
	ValidatorContext.prototype.validateOneOf = function validateOneOf(data, schema, dataPointerPath) {
		if (schema.oneOf === undefined) {
			return null;
		}
		var validIndex = null;
		var errors = [];
		var startErrorCount = this.errors.length;
		var oldUnknownPropertyPaths, oldKnownPropertyPaths;
		if (this.trackUnknownProperties) {
			oldUnknownPropertyPaths = this.unknownPropertyPaths;
			oldKnownPropertyPaths = this.knownPropertyPaths;
		}
		for (var i = 0; i < schema.oneOf.length; i++) {
			if (this.trackUnknownProperties) {
				this.unknownPropertyPaths = {};
				this.knownPropertyPaths = {};
			}
			var subSchema = schema.oneOf[i];
	
			var errorCount = this.errors.length;
			var error = this.validateAll(data, subSchema, [], ["oneOf", i], dataPointerPath);
	
			if (error === null && errorCount === this.errors.length) {
				if (validIndex === null) {
					validIndex = i;
				} else {
					this.errors = this.errors.slice(0, startErrorCount);
					return this.createError(ErrorCodes.ONE_OF_MULTIPLE, {index1: validIndex, index2: i}, "", "/oneOf", null, data, schema);
				}
				if (this.trackUnknownProperties) {
					for (var knownKey in this.knownPropertyPaths) {
						oldKnownPropertyPaths[knownKey] = true;
						delete oldUnknownPropertyPaths[knownKey];
					}
					for (var unknownKey in this.unknownPropertyPaths) {
						if (!oldKnownPropertyPaths[unknownKey]) {
							oldUnknownPropertyPaths[unknownKey] = true;
						}
					}
				}
			} else if (error) {
				errors.push(error);
			}
		}
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = oldUnknownPropertyPaths;
			this.knownPropertyPaths = oldKnownPropertyPaths;
		}
		if (validIndex === null) {
			errors = errors.concat(this.errors.slice(startErrorCount));
			this.errors = this.errors.slice(0, startErrorCount);
			return this.createError(ErrorCodes.ONE_OF_MISSING, {}, "", "/oneOf", errors, data, schema);
		} else {
			this.errors = this.errors.slice(0, startErrorCount);
		}
		return null;
	};
	
	ValidatorContext.prototype.validateNot = function validateNot(data, schema, dataPointerPath) {
		if (schema.not === undefined) {
			return null;
		}
		var oldErrorCount = this.errors.length;
		var oldUnknownPropertyPaths, oldKnownPropertyPaths;
		if (this.trackUnknownProperties) {
			oldUnknownPropertyPaths = this.unknownPropertyPaths;
			oldKnownPropertyPaths = this.knownPropertyPaths;
			this.unknownPropertyPaths = {};
			this.knownPropertyPaths = {};
		}
		var error = this.validateAll(data, schema.not, null, null, dataPointerPath);
		var notErrors = this.errors.slice(oldErrorCount);
		this.errors = this.errors.slice(0, oldErrorCount);
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = oldUnknownPropertyPaths;
			this.knownPropertyPaths = oldKnownPropertyPaths;
		}
		if (error === null && notErrors.length === 0) {
			return this.createError(ErrorCodes.NOT_PASSED, {}, "", "/not", null, data, schema);
		}
		return null;
	};
	
	ValidatorContext.prototype.validateHypermedia = function validateCombinations(data, schema, dataPointerPath) {
		if (!schema.links) {
			return null;
		}
		var error;
		for (var i = 0; i < schema.links.length; i++) {
			var ldo = schema.links[i];
			if (ldo.rel === "describedby") {
				var template = new UriTemplate(ldo.href);
				var allPresent = true;
				for (var j = 0; j < template.varNames.length; j++) {
					if (!(template.varNames[j] in data)) {
						allPresent = false;
						break;
					}
				}
				if (allPresent) {
					var schemaUrl = template.fillFromObject(data);
					var subSchema = {"$ref": schemaUrl};
					if (error = this.validateAll(data, subSchema, [], ["links", i], dataPointerPath)) {
						return error;
					}
				}
			}
		}
	};
	
	// parseURI() and resolveUrl() are from https://gist.github.com/1088850
	//   -  released as public domain by author ("Yaffle") - see comments on gist
	
	function parseURI(url) {
		var m = String(url).replace(/^\s+|\s+$/g, '').match(/^([^:\/?#]+:)?(\/\/(?:[^:@]*(?::[^:@]*)?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);
		// authority = '//' + user + ':' + pass '@' + hostname + ':' port
		return (m ? {
			href     : m[0] || '',
			protocol : m[1] || '',
			authority: m[2] || '',
			host     : m[3] || '',
			hostname : m[4] || '',
			port     : m[5] || '',
			pathname : m[6] || '',
			search   : m[7] || '',
			hash     : m[8] || ''
		} : null);
	}
	
	function resolveUrl(base, href) {// RFC 3986
	
		function removeDotSegments(input) {
			var output = [];
			input.replace(/^(\.\.?(\/|$))+/, '')
				.replace(/\/(\.(\/|$))+/g, '/')
				.replace(/\/\.\.$/, '/../')
				.replace(/\/?[^\/]*/g, function (p) {
					if (p === '/..') {
						output.pop();
					} else {
						output.push(p);
					}
			});
			return output.join('').replace(/^\//, input.charAt(0) === '/' ? '/' : '');
		}
	
		href = parseURI(href || '');
		base = parseURI(base || '');
	
		return !href || !base ? null : (href.protocol || base.protocol) +
			(href.protocol || href.authority ? href.authority : base.authority) +
			removeDotSegments(href.protocol || href.authority || href.pathname.charAt(0) === '/' ? href.pathname : (href.pathname ? ((base.authority && !base.pathname ? '/' : '') + base.pathname.slice(0, base.pathname.lastIndexOf('/') + 1) + href.pathname) : base.pathname)) +
			(href.protocol || href.authority || href.pathname ? href.search : (href.search || base.search)) +
			href.hash;
	}
	
	function getDocumentUri(uri) {
		return uri.split('#')[0];
	}
	function normSchema(schema, baseUri) {
		if (schema && typeof schema === "object") {
			if (baseUri === undefined) {
				baseUri = schema.id;
			} else if (typeof schema.id === "string") {
				baseUri = resolveUrl(baseUri, schema.id);
				schema.id = baseUri;
			}
			if (Array.isArray(schema)) {
				for (var i = 0; i < schema.length; i++) {
					normSchema(schema[i], baseUri);
				}
			} else {
				if (typeof schema['$ref'] === "string") {
					schema['$ref'] = resolveUrl(baseUri, schema['$ref']);
				}
				for (var key in schema) {
					if (key !== "enum") {
						normSchema(schema[key], baseUri);
					}
				}
			}
		}
	}
	
	function defaultErrorReporter(language) {
		language = language || 'en';
	
		var errorMessages = languages[language];
	
		return function (error) {
			var messageTemplate = errorMessages[error.code] || ErrorMessagesDefault[error.code];
			if (typeof messageTemplate !== 'string') {
				return "Unknown error code " + error.code + ": " + JSON.stringify(error.messageParams);
			}
			var messageParams = error.params;
			// Adapted from Crockford's supplant()
			return messageTemplate.replace(/\{([^{}]*)\}/g, function (whole, varName) {
				var subValue = messageParams[varName];
				return typeof subValue === 'string' || typeof subValue === 'number' ? subValue : whole;
			});
		};
	}
	
	var ErrorCodes = {
		INVALID_TYPE: 0,
		ENUM_MISMATCH: 1,
		ANY_OF_MISSING: 10,
		ONE_OF_MISSING: 11,
		ONE_OF_MULTIPLE: 12,
		NOT_PASSED: 13,
		// Numeric errors
		NUMBER_MULTIPLE_OF: 100,
		NUMBER_MINIMUM: 101,
		NUMBER_MINIMUM_EXCLUSIVE: 102,
		NUMBER_MAXIMUM: 103,
		NUMBER_MAXIMUM_EXCLUSIVE: 104,
		NUMBER_NOT_A_NUMBER: 105,
		// String errors
		STRING_LENGTH_SHORT: 200,
		STRING_LENGTH_LONG: 201,
		STRING_PATTERN: 202,
		// Object errors
		OBJECT_PROPERTIES_MINIMUM: 300,
		OBJECT_PROPERTIES_MAXIMUM: 301,
		OBJECT_REQUIRED: 302,
		OBJECT_ADDITIONAL_PROPERTIES: 303,
		OBJECT_DEPENDENCY_KEY: 304,
		// Array errors
		ARRAY_LENGTH_SHORT: 400,
		ARRAY_LENGTH_LONG: 401,
		ARRAY_UNIQUE: 402,
		ARRAY_ADDITIONAL_ITEMS: 403,
		// Custom/user-defined errors
		FORMAT_CUSTOM: 500,
		KEYWORD_CUSTOM: 501,
		// Schema structure
		CIRCULAR_REFERENCE: 600,
		// Non-standard validation options
		UNKNOWN_PROPERTY: 1000
	};
	var ErrorCodeLookup = {};
	for (var key in ErrorCodes) {
		ErrorCodeLookup[ErrorCodes[key]] = key;
	}
	var ErrorMessagesDefault = {
		INVALID_TYPE: "Invalid type: {type} (expected {expected})",
		ENUM_MISMATCH: "No enum match for: {value}",
		ANY_OF_MISSING: "Data does not match any schemas from \"anyOf\"",
		ONE_OF_MISSING: "Data does not match any schemas from \"oneOf\"",
		ONE_OF_MULTIPLE: "Data is valid against more than one schema from \"oneOf\": indices {index1} and {index2}",
		NOT_PASSED: "Data matches schema from \"not\"",
		// Numeric errors
		NUMBER_MULTIPLE_OF: "Value {value} is not a multiple of {multipleOf}",
		NUMBER_MINIMUM: "Value {value} is less than minimum {minimum}",
		NUMBER_MINIMUM_EXCLUSIVE: "Value {value} is equal to exclusive minimum {minimum}",
		NUMBER_MAXIMUM: "Value {value} is greater than maximum {maximum}",
		NUMBER_MAXIMUM_EXCLUSIVE: "Value {value} is equal to exclusive maximum {maximum}",
		NUMBER_NOT_A_NUMBER: "Value {value} is not a valid number",
		// String errors
		STRING_LENGTH_SHORT: "String is too short ({length} chars), minimum {minimum}",
		STRING_LENGTH_LONG: "String is too long ({length} chars), maximum {maximum}",
		STRING_PATTERN: "String does not match pattern: {pattern}",
		// Object errors
		OBJECT_PROPERTIES_MINIMUM: "Too few properties defined ({propertyCount}), minimum {minimum}",
		OBJECT_PROPERTIES_MAXIMUM: "Too many properties defined ({propertyCount}), maximum {maximum}",
		OBJECT_REQUIRED: "Missing required property: {key}",
		OBJECT_ADDITIONAL_PROPERTIES: "Additional properties not allowed",
		OBJECT_DEPENDENCY_KEY: "Dependency failed - key must exist: {missing} (due to key: {key})",
		// Array errors
		ARRAY_LENGTH_SHORT: "Array is too short ({length}), minimum {minimum}",
		ARRAY_LENGTH_LONG: "Array is too long ({length}), maximum {maximum}",
		ARRAY_UNIQUE: "Array items are not unique (indices {match1} and {match2})",
		ARRAY_ADDITIONAL_ITEMS: "Additional items not allowed",
		// Format errors
		FORMAT_CUSTOM: "Format validation failed ({message})",
		KEYWORD_CUSTOM: "Keyword failed: {key} ({message})",
		// Schema structure
		CIRCULAR_REFERENCE: "Circular $refs: {urls}",
		// Non-standard validation options
		UNKNOWN_PROPERTY: "Unknown property (not in schema)"
	};
	
	function ValidationError(code, params, dataPath, schemaPath, subErrors) {
		Error.call(this);
		if (code === undefined) {
			throw new Error ("No error code supplied: " + schemaPath);
		}
		this.message = '';
		this.params = params;
		this.code = code;
		this.dataPath = dataPath || "";
		this.schemaPath = schemaPath || "";
		this.subErrors = subErrors || null;
	
		var err = new Error(this.message);
		this.stack = err.stack || err.stacktrace;
		if (!this.stack) {
			try {
				throw err;
			}
			catch(err) {
				this.stack = err.stack || err.stacktrace;
			}
		}
	}
	ValidationError.prototype = Object.create(Error.prototype);
	ValidationError.prototype.constructor = ValidationError;
	ValidationError.prototype.name = 'ValidationError';
	
	ValidationError.prototype.prefixWith = function (dataPrefix, schemaPrefix) {
		if (dataPrefix !== null) {
			dataPrefix = dataPrefix.replace(/~/g, "~0").replace(/\//g, "~1");
			this.dataPath = "/" + dataPrefix + this.dataPath;
		}
		if (schemaPrefix !== null) {
			schemaPrefix = schemaPrefix.replace(/~/g, "~0").replace(/\//g, "~1");
			this.schemaPath = "/" + schemaPrefix + this.schemaPath;
		}
		if (this.subErrors !== null) {
			for (var i = 0; i < this.subErrors.length; i++) {
				this.subErrors[i].prefixWith(dataPrefix, schemaPrefix);
			}
		}
		return this;
	};
	
	function isTrustedUrl(baseUrl, testUrl) {
		if(testUrl.substring(0, baseUrl.length) === baseUrl){
			var remainder = testUrl.substring(baseUrl.length);
			if ((testUrl.length > 0 && testUrl.charAt(baseUrl.length - 1) === "/")
				|| remainder.charAt(0) === "#"
				|| remainder.charAt(0) === "?") {
				return true;
			}
		}
		return false;
	}
	
	var languages = {};
	function createApi(language) {
		var globalContext = new ValidatorContext();
		var currentLanguage;
		var customErrorReporter;
		var api = {
			setErrorReporter: function (reporter) {
				if (typeof reporter === 'string') {
					return this.language(reporter);
				}
				customErrorReporter = reporter;
				return true;
			},
			addFormat: function () {
				globalContext.addFormat.apply(globalContext, arguments);
			},
			language: function (code) {
				if (!code) {
					return currentLanguage;
				}
				if (!languages[code]) {
					code = code.split('-')[0]; // fall back to base language
				}
				if (languages[code]) {
					currentLanguage = code;
					return code; // so you can tell if fall-back has happened
				}
				return false;
			},
			addLanguage: function (code, messageMap) {
				var key;
				for (key in ErrorCodes) {
					if (messageMap[key] && !messageMap[ErrorCodes[key]]) {
						messageMap[ErrorCodes[key]] = messageMap[key];
					}
				}
				var rootCode = code.split('-')[0];
				if (!languages[rootCode]) { // use for base language if not yet defined
					languages[code] = messageMap;
					languages[rootCode] = messageMap;
				} else {
					languages[code] = Object.create(languages[rootCode]);
					for (key in messageMap) {
						if (typeof languages[rootCode][key] === 'undefined') {
							languages[rootCode][key] = messageMap[key];
						}
						languages[code][key] = messageMap[key];
					}
				}
				return this;
			},
			freshApi: function (language) {
				var result = createApi();
				if (language) {
					result.language(language);
				}
				return result;
			},
			validate: function (data, schema, checkRecursive, banUnknownProperties) {
				var def = defaultErrorReporter(currentLanguage);
				var errorReporter = customErrorReporter ? function (error, data, schema) {
					return customErrorReporter(error, data, schema) || def(error, data, schema);
				} : def;
				var context = new ValidatorContext(globalContext, false, errorReporter, checkRecursive, banUnknownProperties);
				if (typeof schema === "string") {
					schema = {"$ref": schema};
				}
				context.addSchema("", schema);
				var error = context.validateAll(data, schema, null, null, "");
				if (!error && banUnknownProperties) {
					error = context.banUnknownProperties(data, schema);
				}
				this.error = error;
				this.missing = context.missing;
				this.valid = (error === null);
				return this.valid;
			},
			validateResult: function () {
				var result = {toString: function () {
					return this.valid ? 'valid' : this.error.message;
				}};
				this.validate.apply(result, arguments);
				return result;
			},
			validateMultiple: function (data, schema, checkRecursive, banUnknownProperties) {
				var def = defaultErrorReporter(currentLanguage);
				var errorReporter = customErrorReporter ? function (error, data, schema) {
					return customErrorReporter(error, data, schema) || def(error, data, schema);
				} : def;
				var context = new ValidatorContext(globalContext, true, errorReporter, checkRecursive, banUnknownProperties);
				if (typeof schema === "string") {
					schema = {"$ref": schema};
				}
				context.addSchema("", schema);
				context.validateAll(data, schema, null, null, "");
				if (banUnknownProperties) {
					context.banUnknownProperties(data, schema);
				}
				var result = {toString: function () {
					return this.valid ? 'valid' : this.error.message;
				}};
				result.errors = context.errors;
				result.missing = context.missing;
				result.valid = (result.errors.length === 0);
				return result;
			},
			addSchema: function () {
				return globalContext.addSchema.apply(globalContext, arguments);
			},
			getSchema: function () {
				return globalContext.getSchema.apply(globalContext, arguments);
			},
			getSchemaMap: function () {
				return globalContext.getSchemaMap.apply(globalContext, arguments);
			},
			getSchemaUris: function () {
				return globalContext.getSchemaUris.apply(globalContext, arguments);
			},
			getMissingUris: function () {
				return globalContext.getMissingUris.apply(globalContext, arguments);
			},
			dropSchemas: function () {
				globalContext.dropSchemas.apply(globalContext, arguments);
			},
			defineKeyword: function () {
				globalContext.defineKeyword.apply(globalContext, arguments);
			},
			defineError: function (codeName, codeNumber, defaultMessage) {
				if (typeof codeName !== 'string' || !/^[A-Z]+(_[A-Z]+)*$/.test(codeName)) {
					throw new Error('Code name must be a string in UPPER_CASE_WITH_UNDERSCORES');
				}
				if (typeof codeNumber !== 'number' || codeNumber%1 !== 0 || codeNumber < 10000) {
					throw new Error('Code number must be an integer > 10000');
				}
				if (typeof ErrorCodes[codeName] !== 'undefined') {
					throw new Error('Error already defined: ' + codeName + ' as ' + ErrorCodes[codeName]);
				}
				if (typeof ErrorCodeLookup[codeNumber] !== 'undefined') {
					throw new Error('Error code already used: ' + ErrorCodeLookup[codeNumber] + ' as ' + codeNumber);
				}
				ErrorCodes[codeName] = codeNumber;
				ErrorCodeLookup[codeNumber] = codeName;
				ErrorMessagesDefault[codeName] = ErrorMessagesDefault[codeNumber] = defaultMessage;
				for (var langCode in languages) {
					var language = languages[langCode];
					if (language[codeName]) {
						language[codeNumber] = language[codeNumber] || language[codeName];
					}
				}
			},
			reset: function () {
				globalContext.reset();
				this.error = null;
				this.missing = [];
				this.valid = true;
			},
			missing: [],
			error: null,
			valid: true,
			normSchema: normSchema,
			resolveUrl: resolveUrl,
			getDocumentUri: getDocumentUri,
			errorCodes: ErrorCodes
		};
		api.language(language || 'en');
		return api;
	}
	
	var tv4 = createApi();
	tv4.addLanguage('en-gb', ErrorMessagesDefault);
	
	//legacy property
	tv4.tv4 = tv4;
	
	return tv4; // used by _header.js to globalise.
	
	}));

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * An auto incrementing id which we can use to create "unique" Ultron instances
	 * so we can track the event emitters that are added through the Ultron
	 * interface.
	 *
	 * @type {Number}
	 * @private
	 */
	var id = 0;
	
	/**
	 * Ultron is high-intelligence robot. It gathers intelligence so it can start improving
	 * upon his rudimentary design. It will learn from your EventEmitting patterns
	 * and exterminate them.
	 *
	 * @constructor
	 * @param {EventEmitter} ee EventEmitter instance we need to wrap.
	 * @api public
	 */
	function Ultron(ee) {
	  if (!(this instanceof Ultron)) return new Ultron(ee);
	
	  this.id = id++;
	  this.ee = ee;
	}
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Functon} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @returns {Ultron}
	 * @api public
	 */
	Ultron.prototype.on = function on(event, fn, context) {
	  fn.__ultron = this.id;
	  this.ee.on(event, fn, context);
	
	  return this;
	};
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @returns {Ultron}
	 * @api public
	 */
	Ultron.prototype.once = function once(event, fn, context) {
	  fn.__ultron = this.id;
	  this.ee.once(event, fn, context);
	
	  return this;
	};
	
	/**
	 * Remove the listeners we assigned for the given event.
	 *
	 * @returns {Ultron}
	 * @api public
	 */
	Ultron.prototype.remove = function remove() {
	  var args = arguments
	    , event;
	
	  //
	  // When no event names are provided we assume that we need to clear all the
	  // events that were assigned through us.
	  //
	  if (args.length === 1 && 'string' === typeof args[0]) {
	    args = args[0].split(/[, ]+/);
	  } else if (!args.length) {
	    args = [];
	
	    for (event in this.ee._events) {
	      if (has.call(this.ee._events, event)) args.push(event);
	    }
	  }
	
	  for (var i = 0; i < args.length; i++) {
	    var listeners = this.ee.listeners(args[i]);
	
	    for (var j = 0; j < listeners.length; j++) {
	      event = listeners[j];
	
	      //
	      // Once listeners have a `listener` property that stores the real listener
	      // in the EventEmitter that ships with Node.js.
	      //
	      if (event.listener) {
	        if (event.listener.__ultron !== this.id) continue;
	        delete event.listener.__ultron;
	      } else {
	        if (event.__ultron !== this.id) continue;
	        delete event.__ultron;
	      }
	
	      this.ee.removeListener(args[i], event);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Destroy the Ultron instance, remove all listeners and release all references.
	 *
	 * @returns {Boolean}
	 * @api public
	 */
	Ultron.prototype.destroy = function destroy() {
	  if (!this.ee) return false;
	
	  this.remove();
	  this.ee = null;
	
	  return true;
	};
	
	//
	// Expose the module.
	//
	module.exports = Ultron;


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "be16a92a30c03b751abf41550fa0d648.svg";

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module), (function() { return this; }())))

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1721 */
623,
/* 1722 */
/***/ (function(module, exports) {

	/**
	 * vAccordion - AngularJS multi-level accordion component
	 * @version v1.6.0
	 * @link http://lukaszwatroba.github.io/v-accordion
	 * @author Łukasz Wątroba <l@lukaszwatroba.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function (angular) {
	'use strict';
	
	// Config
	angular.module('vAccordion.config', [])
	  .constant('accordionConfig', {
	    states: {
	      expanded: 'is-expanded'
	    },
	    expandAnimationDuration: 0.5
	  })
	  .animation('.is-expanded', [ '$animateCss', 'accordionConfig', function ($animateCss, accordionConfig) {
	    return {
	      addClass: function (element, className, done) {
	        var paneContent = angular.element(element[0].querySelector('v-pane-content')),
	            paneInner = angular.element(paneContent[0].querySelector('div'));
	
	        var height = paneInner[0].offsetHeight;
	
	        var expandAnimation = $animateCss(paneContent, {
	          easing: 'ease',
	          from: { maxHeight: '0px' },
	          to: { maxHeight: height + 'px' },
	          duration: accordionConfig.expandAnimationDuration
	        });
	
	        expandAnimation.start().done(function () {
	          paneContent.css('max-height', 'none');
	          done();
	        });
	
	        return function (isCancelled) {
	          if (isCancelled) {
	            paneContent.css('max-height', 'none');
	          }
	        };
	      },
	      removeClass: function (element, className, done) {
	        var paneContent = angular.element(element[0].querySelector('v-pane-content')),
	            paneInner = angular.element(paneContent[0].querySelector('div'));
	
	        var height = paneInner[0].offsetHeight;
	
	        var collapseAnimation = $animateCss(paneContent, {
	          easing: 'ease',
	          from: { maxHeight: height + 'px' },
	          to: { maxHeight: '0px' },
	          duration: accordionConfig.expandAnimationDuration
	        });
	
	        collapseAnimation.start().done(done);
	
	        return function (isCancelled) {
	          if (isCancelled) {
	            paneContent.css('max-height', '0px');
	          }
	        };
	      }
	    };
	  } ]);
	
	
	// Modules
	angular.module('vAccordion.directives', []);
	angular.module('vAccordion',
	  [
	    'vAccordion.config',
	    'vAccordion.directives'
	  ]);
	
	
	
	// vAccordion directive
	angular.module('vAccordion.directives')
	  .directive('vAccordion', vAccordionDirective);
	
	
	function vAccordionDirective ($timeout) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    controller: vAccordionController,
	    scope: {
	      control: '=?',
	      expandCb: '&?onexpand',
	      collapseCb: '&?oncollapse',
	      id: '@?'
	    },
	    link: {
	      pre: function (scope, iElement, iAttrs) {
	        scope.allowMultiple = (angular.isDefined(iAttrs.multiple) && (iAttrs.multiple === '' || iAttrs.multiple === 'true'));
	      },
	      post: function (scope, iElement, iAttrs, ctrl, transclude) {
	        transclude(scope.$parent.$new(), function (clone, transclusionScope) {
	          transclusionScope.$accordion = scope.internalControl;
	          if (scope.id) { transclusionScope.$accordion.id = scope.id; }
	          iElement.append(clone);
	        });
	
	        iAttrs.$set('role', 'tablist');
	
	        if (scope.allowMultiple) {
	          iAttrs.$set('aria-multiselectable', 'true');
	        }
	
	        if (angular.isDefined(scope.control)) {
	          checkCustomControlAPIMethods();
	
	          var mergedControl = angular.extend({}, scope.internalControl, scope.control);
	          scope.control = scope.internalControl = mergedControl;
	        }
	        else {
	          scope.control = scope.internalControl;
	        }
	
	        function checkCustomControlAPIMethods () {
	          var protectedApiMethods = ['toggle', 'expand', 'collapse', 'expandAll', 'collapseAll', 'hasExpandedPane'];
	
	          angular.forEach(protectedApiMethods, function (iteratedMethodName) {
	            if (scope.control[iteratedMethodName]) {
	              throw new Error('The `' + iteratedMethodName + '` method can not be overwritten');
	            }
	          });
	        }
	
	        $timeout(function () {
	          var eventName = (angular.isDefined(ctrl.getAccordionId())) ? ctrl.getAccordionId() + ':onReady' : 'vAccordion:onReady';
	          scope.$emit(eventName);
	        }, 0);
	      }
	    }
	  };
	}
	vAccordionDirective.$inject = ['$timeout'];
	
	
	// vAccordion directive controller
	function vAccordionController ($scope) {
	  var ctrl = this;
	  var isDisabled = false;
	
	  $scope.panes = [];
	
		$scope.expandCb = (angular.isFunction($scope.expandCb)) ? $scope.expandCb : angular.noop;
		$scope.collapseCb = (angular.isFunction($scope.collapseCb)) ? $scope.collapseCb : angular.noop;
	
	  ctrl.hasExpandedPane = function hasExpandedPane () {
	    var bool = false;
	
	    for (var i = 0, length = $scope.panes.length; i < length; i++) {
	      var iteratedPane = $scope.panes[i];
	
	      if (iteratedPane.isExpanded) {
	        bool = true;
	        break;
	      }
	    }
	
	    return bool;
	  };
	
	  ctrl.getPaneByIndex = function getPaneByIndex (index) {
	    var thePane;
	
	    angular.forEach($scope.panes, function (iteratedPane) {
	      if (iteratedPane.$parent && angular.isDefined(iteratedPane.$parent.$index) && iteratedPane.$parent.$index === index) {
	        thePane = iteratedPane;
	      }
	    });
	
	    return (thePane) ? thePane : $scope.panes[index];
	  };
	
	  ctrl.getPaneIndex = function getPaneIndex (pane) {
	    var theIndex;
	
	    angular.forEach($scope.panes, function (iteratedPane) {
	      if (iteratedPane.$parent && angular.isDefined(iteratedPane.$parent.$index) && iteratedPane === pane) {
	        theIndex = iteratedPane.$parent.$index;
	      }
	    });
	
	    return (angular.isDefined(theIndex)) ? theIndex : $scope.panes.indexOf(pane);
	  };
	
	  ctrl.getPaneById = function getPaneById (id) {
	    var thePane;
	
	    angular.forEach($scope.panes, function (iteratedPane) {
	      if (iteratedPane.id && iteratedPane.id === id) {
	        thePane = iteratedPane;
	      }
	    });
	
	    return thePane;
	  };
	
	  ctrl.getPaneId = function getPaneId (pane) {
	    return pane.id;
	  };
	
	  ctrl.getAccordionId = function getAccordionId () {
	    return $scope.id;
	  };
	
	
	  ctrl.disable = function disable () {
	    isDisabled = true;
	  };
	
	  ctrl.enable = function enable () {
	    isDisabled = false;
	  };
	
	  ctrl.addPane = function addPane (paneToAdd) {
	    if (!$scope.allowMultiple) {
	      if (ctrl.hasExpandedPane() && paneToAdd.isExpanded) {
	        throw new Error('The `multiple` attribute can\'t be found');
	      }
	    }
	
	    $scope.panes.push(paneToAdd);
	
	    if (paneToAdd.isExpanded) {
	      $scope.expandCb({ index: ctrl.getPaneIndex(paneToAdd), id: paneToAdd.id, pane: paneToAdd });
	    }
	  };
	
	  ctrl.focusNext = function focusNext () {
	    var length = $scope.panes.length;
	
	    for (var i = 0; i < length; i++) {
	      var iteratedPane = $scope.panes[i];
	
	      if (iteratedPane.isFocused) {
	        var paneToFocusIndex = i + 1;
	
	        if (paneToFocusIndex > $scope.panes.length - 1) {
	          paneToFocusIndex = 0;
	        }
	
	        var paneToFocus = $scope.panes[paneToFocusIndex];
	            paneToFocus.paneElement.find('v-pane-header')[0].focus();
	
	        break;
	      }
	    }
	  };
	
	  ctrl.focusPrevious = function focusPrevious () {
	    var length = $scope.panes.length;
	
	    for (var i = 0; i < length; i++) {
	      var iteratedPane = $scope.panes[i];
	
	      if (iteratedPane.isFocused) {
	        var paneToFocusIndex = i - 1;
	
	        if (paneToFocusIndex < 0) {
	          paneToFocusIndex = $scope.panes.length - 1;
	        }
	
	        var paneToFocus = $scope.panes[paneToFocusIndex];
	            paneToFocus.paneElement.find('v-pane-header')[0].focus();
	
	        break;
	      }
	    }
	  };
	
	  ctrl.toggle = function toggle (paneToToggle) {
	    if (isDisabled || !paneToToggle) { return; }
	
	    if (!$scope.allowMultiple) {
	      ctrl.collapseAll(paneToToggle);
	    }
	
	    paneToToggle.isExpanded = !paneToToggle.isExpanded;
	
	    if (paneToToggle.isExpanded) {
	      $scope.expandCb({ index: ctrl.getPaneIndex(paneToToggle), id: paneToToggle.id, pane: paneToToggle });
	    } else {
	      $scope.collapseCb({ index: ctrl.getPaneIndex(paneToToggle), id: paneToToggle.id, pane: paneToToggle });
	    }
	  };
	
	  ctrl.expand = function expand (paneToExpand) {
	    if (isDisabled || !paneToExpand) { return; }
	
	    if (!$scope.allowMultiple) {
	      ctrl.collapseAll(paneToExpand);
	    }
	
	    if (!paneToExpand.isExpanded) {
	      paneToExpand.isExpanded = true;
	      $scope.expandCb({ index: ctrl.getPaneIndex(paneToExpand), id: paneToExpand.id, pane: paneToExpand });
	    }
	  };
	
	  ctrl.collapse = function collapse (paneToCollapse) {
	    if (isDisabled || !paneToCollapse) { return; }
	
	    if (paneToCollapse.isExpanded) {
	      paneToCollapse.isExpanded = false;
	      $scope.collapseCb({ index: ctrl.getPaneIndex(paneToCollapse), id: paneToCollapse.id, pane: paneToCollapse });
	    }
	  };
	
	  ctrl.expandAll = function expandAll () {
	    if (isDisabled) { return; }
	
	    if ($scope.allowMultiple) {
	      angular.forEach($scope.panes, function (iteratedPane) {
	        ctrl.expand(iteratedPane);
	      });
	    } else {
	      throw new Error('The `multiple` attribute can\'t be found');
	    }
	  };
	
	  ctrl.collapseAll = function collapseAll (exceptionalPane) {
	    if (isDisabled) { return; }
	
	    angular.forEach($scope.panes, function (iteratedPane) {
	      if (iteratedPane !== exceptionalPane) {
	        ctrl.collapse(iteratedPane);
	      }
	    });
	  };
	
	  // API
	  $scope.internalControl = {
	    toggle: function toggle (indexOrId) {
	      if (angular.isString(indexOrId)) {
	        ctrl.toggle( ctrl.getPaneById(indexOrId) );
	      } else {
	        ctrl.toggle( ctrl.getPaneByIndex(indexOrId) );
	      }
	    },
	    expand: function expand (indexOrId) {
	      if (angular.isString(indexOrId)) {
	        ctrl.expand( ctrl.getPaneById(indexOrId) );
	      } else {
	        ctrl.expand( ctrl.getPaneByIndex(indexOrId) );
	      }
	    },
	    collapse: function collapse (indexOrId) {
	      if (angular.isString(indexOrId)) {
	        ctrl.collapse( ctrl.getPaneById(indexOrId) );
	      } else {
	        ctrl.collapse( ctrl.getPaneByIndex(indexOrId) );
	      }
	    },
	    expandAll: ctrl.expandAll,
	    collapseAll: ctrl.collapseAll,
	    hasExpandedPane: ctrl.hasExpandedPane
	  };
	}
	vAccordionController.$inject = ['$scope'];
	
	
	
	// vPane directive
	angular.module('vAccordion.directives')
	  .directive('vPane', vPaneDirective);
	
	
	function vPaneDirective ($timeout, $animate, accordionConfig) {
	  return {
	    restrict: 'E',
	    require: '^vAccordion',
	    transclude: true,
	    controller: vPaneController,
	    scope: {
	      isExpanded: '=?expanded',
	      isDisabled: '=?ngDisabled',
	      id: '@?'
	    },
	    link: function (scope, iElement, iAttrs, accordionCtrl, transclude) {
	      transclude(scope.$parent.$new(), function (clone, transclusionScope) {
	        transclusionScope.$pane = scope.internalControl;
	        if (scope.id) { transclusionScope.$pane.id = scope.id; }
	        iElement.append(clone);
	      });
	
	      if (!angular.isDefined(scope.isExpanded)) {
	        scope.isExpanded = (angular.isDefined(iAttrs.expanded) && (iAttrs.expanded === ''));
	      }
	
	      if (angular.isDefined(iAttrs.disabled)) {
	        scope.isDisabled = true;
	      }
	
	      var states = accordionConfig.states;
	
	      var paneHeader = iElement.find('v-pane-header'),
	          paneContent = iElement.find('v-pane-content'),
	          paneInner = paneContent.find('div');
	
	      var accordionId = accordionCtrl.getAccordionId();
	
	      if (!paneHeader[0]) {
	        throw new Error('The `v-pane-header` directive can\'t be found');
	      }
	
	      if (!paneContent[0]) {
	        throw new Error('The `v-pane-content` directive can\'t be found');
	      }
	
	      scope.paneElement = iElement;
	      scope.paneContentElement = paneContent;
	      scope.paneInnerElement = paneInner;
	
	      scope.accordionCtrl = accordionCtrl;
	
	      accordionCtrl.addPane(scope);
	
	      function emitEvent (eventName) {
	        eventName = (angular.isDefined(accordionId)) ? accordionId + ':' + eventName : 'vAccordion:' + eventName;
	        scope.$emit(eventName);
	      }
	
	      function expand () {
	        accordionCtrl.disable();
	
	        paneContent.attr('aria-hidden', 'false');
	
	        paneHeader.attr({
	          'aria-selected': 'true',
	          'aria-expanded': 'true'
	        });
	
	        emitEvent('onExpand');
	
	        $animate
	          .addClass(iElement, states.expanded)
	          .then(function () {
	            accordionCtrl.enable();
	            emitEvent('onExpandAnimationEnd');
	          });
	      }
	
	      function collapse () {
	        accordionCtrl.disable();
	
	        paneContent.attr('aria-hidden', 'true');
	
	        paneHeader.attr({
	          'aria-selected': 'false',
	          'aria-expanded': 'false'
	        });
	
	        emitEvent('onCollapse');
	
	        $animate
	          .removeClass(iElement, states.expanded)
	          .then(function () {
	            accordionCtrl.enable();
	            emitEvent('onCollapseAnimationEnd');
	          });
	      }
	
	      scope.$evalAsync(function () {
	        if (scope.isExpanded) {
	          iElement.addClass(states.expanded);
	          paneContent
	            .css('max-height', 'none')
	            .attr('aria-hidden', 'false');
	
	          paneHeader.attr({
	            'aria-selected': 'true',
	            'aria-expanded': 'true'
	          });
	        } else {
	          paneContent
	            .css('max-height', '0px')
	            .attr('aria-hidden', 'true');
	
	          paneHeader.attr({
	            'aria-selected': 'false',
	            'aria-expanded': 'false'
	          });
	        }
	      });
	
	      scope.$watch('isExpanded', function (newValue, oldValue) {
	        if (newValue === oldValue) { return true; }
	        if (newValue) { expand(); }
	        else { collapse(); }
	      });
	    }
	  };
	}
	vPaneDirective.$inject = ['$timeout', '$animate', 'accordionConfig'];
	
	
	// vPane directive controller
	function vPaneController ($scope) {
	  var ctrl = this;
	
	  ctrl.isExpanded = function isExpanded () {
	    return $scope.isExpanded;
	  };
	
	  ctrl.toggle = function toggle () {
	    if (!$scope.isAnimating && !$scope.isDisabled) {
	      $scope.accordionCtrl.toggle($scope);
	    }
	  };
	
	  ctrl.expand = function expand () {
	    if (!$scope.isAnimating && !$scope.isDisabled) {
	      $scope.accordionCtrl.expand($scope);
	    }
	  };
	
	  ctrl.collapse = function collapse () {
	    if (!$scope.isAnimating && !$scope.isDisabled) {
	      $scope.accordionCtrl.collapse($scope);
	    }
	  };
	
	  ctrl.focusPane = function focusPane () {
	    $scope.isFocused = true;
	  };
	
	  ctrl.blurPane = function blurPane () {
	    $scope.isFocused = false;
	  };
	
	  $scope.internalControl = {
	    toggle: ctrl.toggle,
	    expand: ctrl.expand,
	    collapse: ctrl.collapse,
	    isExpanded: ctrl.isExpanded
	  };
	}
	vPaneController.$inject = ['$scope'];
	
	
	
	// vPaneContent directive
	angular.module('vAccordion.directives')
	  .directive('vPaneContent', vPaneContentDirective);
	
	
	function vPaneContentDirective () {
	  return {
	    restrict: 'E',
	    require: '^vPane',
	    transclude: true,
	    template: '<div ng-transclude></div>',
	    scope: {},
	    link: function (scope, iElement, iAttrs) {
	      iAttrs.$set('role', 'tabpanel');
	      iAttrs.$set('aria-hidden', 'true');
	    }
	  };
	}
	
	
	
	// vPaneHeader directive
	angular.module('vAccordion.directives')
	  .directive('vPaneHeader', vPaneHeaderDirective);
	
	
	function vPaneHeaderDirective () {
	  return {
	    restrict: 'E',
	    require: ['^vPane', '^vAccordion'],
	    transclude: true,
	    template: '<div ng-transclude></div>',
	    scope: {},
	    link: function (scope, iElement, iAttrs, ctrls) {
	      iAttrs.$set('role', 'tab');
	      iAttrs.$set('tabindex', '0');
	
	      var paneCtrl = ctrls[0],
	          accordionCtrl = ctrls[1];
	
	      var isInactive = angular.isDefined(iAttrs.inactive);
	
	      function onClick () {
	        if (isInactive) { return false; }
	        scope.$apply(function () { paneCtrl.toggle(); });
	      }
	
	      function onKeydown (event) {
	        if (event.keyCode === 32  || event.keyCode === 13) {
	          scope.$apply(function () { paneCtrl.toggle(); });
	          event.preventDefault();
	        } else if (event.keyCode === 39 || event.keyCode === 40) {
	          scope.$apply(function () { accordionCtrl.focusNext(); });
	          event.preventDefault();
	        } else if (event.keyCode === 37 || event.keyCode === 38) {
	          scope.$apply(function () { accordionCtrl.focusPrevious(); });
	          event.preventDefault();
	        }
	      }
	
	      function onFocus () {
	        paneCtrl.focusPane();
	      }
	
	      function onBlur () {
	        paneCtrl.blurPane();
	      }
	
	      iElement[0].onfocus = onFocus;
	      iElement[0].onblur = onBlur;
	      iElement.bind('click', onClick);
	      iElement.bind('keydown', onKeydown);
	
	      scope.$on('$destroy', function () {
	        iElement.unbind('click', onClick);
	        iElement.unbind('keydown', onKeydown);
	        iElement[0].onfocus = null;
	        iElement[0].onblur = null;
	      });
	    }
	  };
	}
	
	})(angular);

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1722);
	module.exports = 'vAccordion';


/***/ }),
/* 1724 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = get_blob()
	
	function get_blob() {
	  if(global.Blob) {
	    try {
	      new Blob(['asdf'], {type: 'text/plain'})
	      return Blob
	    } catch(err) {}
	  }
	
	  var Builder = global.WebKitBlobBuilder ||
	                global.MozBlobBuilder ||
	                global.MSBlobBuilder
	
	  return function(parts, bag) {
	    var builder = new Builder
	      , endings = bag.endings
	      , type = bag.type
	
	    if(endings) for(var i = 0, len = parts.length; i < len; ++i) {
	      builder.append(parts[i], endings)
	    } else for(var i = 0, len = parts.length; i < len; ++i) {
	      builder.append(parts[i])
	    }
	
	    return type ? builder.getBlob(type) : builder.getBlob()
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	module.exports = [
	    [ 0x0300, 0x036F ], [ 0x0483, 0x0486 ], [ 0x0488, 0x0489 ],
	    [ 0x0591, 0x05BD ], [ 0x05BF, 0x05BF ], [ 0x05C1, 0x05C2 ],
	    [ 0x05C4, 0x05C5 ], [ 0x05C7, 0x05C7 ], [ 0x0600, 0x0603 ],
	    [ 0x0610, 0x0615 ], [ 0x064B, 0x065E ], [ 0x0670, 0x0670 ],
	    [ 0x06D6, 0x06E4 ], [ 0x06E7, 0x06E8 ], [ 0x06EA, 0x06ED ],
	    [ 0x070F, 0x070F ], [ 0x0711, 0x0711 ], [ 0x0730, 0x074A ],
	    [ 0x07A6, 0x07B0 ], [ 0x07EB, 0x07F3 ], [ 0x0901, 0x0902 ],
	    [ 0x093C, 0x093C ], [ 0x0941, 0x0948 ], [ 0x094D, 0x094D ],
	    [ 0x0951, 0x0954 ], [ 0x0962, 0x0963 ], [ 0x0981, 0x0981 ],
	    [ 0x09BC, 0x09BC ], [ 0x09C1, 0x09C4 ], [ 0x09CD, 0x09CD ],
	    [ 0x09E2, 0x09E3 ], [ 0x0A01, 0x0A02 ], [ 0x0A3C, 0x0A3C ],
	    [ 0x0A41, 0x0A42 ], [ 0x0A47, 0x0A48 ], [ 0x0A4B, 0x0A4D ],
	    [ 0x0A70, 0x0A71 ], [ 0x0A81, 0x0A82 ], [ 0x0ABC, 0x0ABC ],
	    [ 0x0AC1, 0x0AC5 ], [ 0x0AC7, 0x0AC8 ], [ 0x0ACD, 0x0ACD ],
	    [ 0x0AE2, 0x0AE3 ], [ 0x0B01, 0x0B01 ], [ 0x0B3C, 0x0B3C ],
	    [ 0x0B3F, 0x0B3F ], [ 0x0B41, 0x0B43 ], [ 0x0B4D, 0x0B4D ],
	    [ 0x0B56, 0x0B56 ], [ 0x0B82, 0x0B82 ], [ 0x0BC0, 0x0BC0 ],
	    [ 0x0BCD, 0x0BCD ], [ 0x0C3E, 0x0C40 ], [ 0x0C46, 0x0C48 ],
	    [ 0x0C4A, 0x0C4D ], [ 0x0C55, 0x0C56 ], [ 0x0CBC, 0x0CBC ],
	    [ 0x0CBF, 0x0CBF ], [ 0x0CC6, 0x0CC6 ], [ 0x0CCC, 0x0CCD ],
	    [ 0x0CE2, 0x0CE3 ], [ 0x0D41, 0x0D43 ], [ 0x0D4D, 0x0D4D ],
	    [ 0x0DCA, 0x0DCA ], [ 0x0DD2, 0x0DD4 ], [ 0x0DD6, 0x0DD6 ],
	    [ 0x0E31, 0x0E31 ], [ 0x0E34, 0x0E3A ], [ 0x0E47, 0x0E4E ],
	    [ 0x0EB1, 0x0EB1 ], [ 0x0EB4, 0x0EB9 ], [ 0x0EBB, 0x0EBC ],
	    [ 0x0EC8, 0x0ECD ], [ 0x0F18, 0x0F19 ], [ 0x0F35, 0x0F35 ],
	    [ 0x0F37, 0x0F37 ], [ 0x0F39, 0x0F39 ], [ 0x0F71, 0x0F7E ],
	    [ 0x0F80, 0x0F84 ], [ 0x0F86, 0x0F87 ], [ 0x0F90, 0x0F97 ],
	    [ 0x0F99, 0x0FBC ], [ 0x0FC6, 0x0FC6 ], [ 0x102D, 0x1030 ],
	    [ 0x1032, 0x1032 ], [ 0x1036, 0x1037 ], [ 0x1039, 0x1039 ],
	    [ 0x1058, 0x1059 ], [ 0x1160, 0x11FF ], [ 0x135F, 0x135F ],
	    [ 0x1712, 0x1714 ], [ 0x1732, 0x1734 ], [ 0x1752, 0x1753 ],
	    [ 0x1772, 0x1773 ], [ 0x17B4, 0x17B5 ], [ 0x17B7, 0x17BD ],
	    [ 0x17C6, 0x17C6 ], [ 0x17C9, 0x17D3 ], [ 0x17DD, 0x17DD ],
	    [ 0x180B, 0x180D ], [ 0x18A9, 0x18A9 ], [ 0x1920, 0x1922 ],
	    [ 0x1927, 0x1928 ], [ 0x1932, 0x1932 ], [ 0x1939, 0x193B ],
	    [ 0x1A17, 0x1A18 ], [ 0x1B00, 0x1B03 ], [ 0x1B34, 0x1B34 ],
	    [ 0x1B36, 0x1B3A ], [ 0x1B3C, 0x1B3C ], [ 0x1B42, 0x1B42 ],
	    [ 0x1B6B, 0x1B73 ], [ 0x1DC0, 0x1DCA ], [ 0x1DFE, 0x1DFF ],
	    [ 0x200B, 0x200F ], [ 0x202A, 0x202E ], [ 0x2060, 0x2063 ],
	    [ 0x206A, 0x206F ], [ 0x20D0, 0x20EF ], [ 0x302A, 0x302F ],
	    [ 0x3099, 0x309A ], [ 0xA806, 0xA806 ], [ 0xA80B, 0xA80B ],
	    [ 0xA825, 0xA826 ], [ 0xFB1E, 0xFB1E ], [ 0xFE00, 0xFE0F ],
	    [ 0xFE20, 0xFE23 ], [ 0xFEFF, 0xFEFF ], [ 0xFFF9, 0xFFFB ],
	    [ 0x10A01, 0x10A03 ], [ 0x10A05, 0x10A06 ], [ 0x10A0C, 0x10A0F ],
	    [ 0x10A38, 0x10A3A ], [ 0x10A3F, 0x10A3F ], [ 0x1D167, 0x1D169 ],
	    [ 0x1D173, 0x1D182 ], [ 0x1D185, 0x1D18B ], [ 0x1D1AA, 0x1D1AD ],
	    [ 0x1D242, 0x1D244 ], [ 0xE0001, 0xE0001 ], [ 0xE0020, 0xE007F ],
	    [ 0xE0100, 0xE01EF ]
	]


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	var defaults = __webpack_require__(716)
	var combining = __webpack_require__(1725)
	
	var DEFAULTS = {
	  nul: 0,
	  control: 0
	}
	
	module.exports = function wcwidth(str) {
	  return wcswidth(str, DEFAULTS)
	}
	
	module.exports.config = function(opts) {
	  opts = defaults(opts || {}, DEFAULTS)
	  return function wcwidth(str) {
	    return wcswidth(str, opts)
	  }
	}
	
	/*
	 *  The following functions define the column width of an ISO 10646
	 *  character as follows:
	 *  - The null character (U+0000) has a column width of 0.
	 *  - Other C0/C1 control characters and DEL will lead to a return value
	 *    of -1.
	 *  - Non-spacing and enclosing combining characters (general category
	 *    code Mn or Me in the
	 *    Unicode database) have a column width of 0.
	 *  - SOFT HYPHEN (U+00AD) has a column width of 1.
	 *  - Other format characters (general category code Cf in the Unicode
	 *    database) and ZERO WIDTH
	 *    SPACE (U+200B) have a column width of 0.
	 *  - Hangul Jamo medial vowels and final consonants (U+1160-U+11FF)
	 *    have a column width of 0.
	 *  - Spacing characters in the East Asian Wide (W) or East Asian
	 *    Full-width (F) category as
	 *    defined in Unicode Technical Report #11 have a column width of 2.
	 *  - All remaining characters (including all printable ISO 8859-1 and
	 *    WGL4 characters, Unicode control characters, etc.) have a column
	 *    width of 1.
	 *  This implementation assumes that characters are encoded in ISO 10646.
	*/
	
	function wcswidth(str, opts) {
	  if (typeof str !== 'string') return wcwidth(str, opts)
	
	  var s = 0
	  for (var i = 0; i < str.length; i++) {
	    var n = wcwidth(str.charCodeAt(i), opts)
	    if (n < 0) return -1
	    s += n
	  }
	
	  return s
	}
	
	function wcwidth(ucs, opts) {
	  // test for 8-bit control characters
	  if (ucs === 0) return opts.nul
	  if (ucs < 32 || (ucs >= 0x7f && ucs < 0xa0)) return opts.control
	
	  // binary search in table of non-spacing characters
	  if (bisearch(ucs)) return 0
	
	  // if we arrive here, ucs is not a combining or C0/C1 control character
	  return 1 +
	      (ucs >= 0x1100 &&
	       (ucs <= 0x115f ||                       // Hangul Jamo init. consonants
	        ucs == 0x2329 || ucs == 0x232a ||
	        (ucs >= 0x2e80 && ucs <= 0xa4cf &&
	         ucs != 0x303f) ||                     // CJK ... Yi
	        (ucs >= 0xac00 && ucs <= 0xd7a3) ||    // Hangul Syllables
	        (ucs >= 0xf900 && ucs <= 0xfaff) ||    // CJK Compatibility Ideographs
	        (ucs >= 0xfe10 && ucs <= 0xfe19) ||    // Vertical forms
	        (ucs >= 0xfe30 && ucs <= 0xfe6f) ||    // CJK Compatibility Forms
	        (ucs >= 0xff00 && ucs <= 0xff60) ||    // Fullwidth Forms
	        (ucs >= 0xffe0 && ucs <= 0xffe6) ||
	        (ucs >= 0x20000 && ucs <= 0x2fffd) ||
	        (ucs >= 0x30000 && ucs <= 0x3fffd)));
	}
	
	function bisearch(ucs) {
	  var min = 0
	  var max = combining.length - 1
	  var mid
	
	  if (ucs < combining[0][0] || ucs > combining[max][1]) return false
	
	  while (max >= min) {
	    mid = Math.floor((min + max) / 2)
	    if (ucs > combining[mid][1]) min = mid + 1
	    else if (ucs < combining[mid][0]) max = mid - 1
	    else return true
	  }
	
	  return false
	}


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(837);


/***/ }),
/* 1728 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var WS = module.exports = __webpack_require__(585);
	
	WS.Server = __webpack_require__(1736);
	WS.Sender = __webpack_require__(584);
	WS.Receiver = __webpack_require__(583);
	
	/**
	 * Create a new WebSocket server.
	 *
	 * @param {Object} options Server options
	 * @param {Function} fn Optional connection listener.
	 * @returns {WS.Server}
	 * @api public
	 */
	WS.createServer = function createServer(options, fn) {
	  var server = new WS.Server(options);
	
	  if (typeof fn === 'function') {
	    server.on('connection', fn);
	  }
	
	  return server;
	};
	
	/**
	 * Create a new WebSocket connection.
	 *
	 * @param {String} address The URL/address we need to connect to.
	 * @param {Function} fn Open listener.
	 * @returns {WS}
	 * @api public
	 */
	WS.connect = WS.createConnection = function connect(address, fn) {
	  var client = new WS(address);
	
	  if (typeof fn === 'function') {
	    client.on('open', fn);
	  }
	
	  return client;
	};


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var util = __webpack_require__(36);
	
	function BufferPool(initialSize, growStrategy, shrinkStrategy) {
	  if (this instanceof BufferPool === false) {
	    throw new TypeError("Classes can't be function-called");
	  }
	
	  if (typeof initialSize === 'function') {
	    shrinkStrategy = growStrategy;
	    growStrategy = initialSize;
	    initialSize = 0;
	  }
	  else if (typeof initialSize === 'undefined') {
	    initialSize = 0;
	  }
	  this._growStrategy = (growStrategy || function(db, size) {
	    return db.used + size;
	  }).bind(null, this);
	  this._shrinkStrategy = (shrinkStrategy || function(db) {
	    return initialSize;
	  }).bind(null, this);
	  this._buffer = initialSize ? new Buffer(initialSize) : null;
	  this._offset = 0;
	  this._used = 0;
	  this._changeFactor = 0;
	  this.__defineGetter__('size', function(){
	    return this._buffer == null ? 0 : this._buffer.length;
	  });
	  this.__defineGetter__('used', function(){
	    return this._used;
	  });
	}
	
	BufferPool.prototype.get = function(length) {
	  if (this._buffer == null || this._offset + length > this._buffer.length) {
	    var newBuf = new Buffer(this._growStrategy(length));
	    this._buffer = newBuf;
	    this._offset = 0;
	  }
	  this._used += length;
	  var buf = this._buffer.slice(this._offset, this._offset + length);
	  this._offset += length;
	  return buf;
	}
	
	BufferPool.prototype.reset = function(forceNewBuffer) {
	  var len = this._shrinkStrategy();
	  if (len < this.size) this._changeFactor -= 1;
	  if (forceNewBuffer || this._changeFactor < -2) {
	    this._changeFactor = 0;
	    this._buffer = len ? new Buffer(len) : null;
	  }
	  this._offset = 0;
	  this._used = 0;
	}
	
	module.exports = BufferPool;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

	/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	exports.BufferUtil = {
	  merge: function(mergedBuffer, buffers) {
	    var offset = 0;
	    for (var i = 0, l = buffers.length; i < l; ++i) {
	      var buf = buffers[i];
	      buf.copy(mergedBuffer, offset);
	      offset += buf.length;
	    }
	  },
	  mask: function(source, mask, output, offset, length) {
	    var maskNum = mask.readUInt32LE(0, true);
	    var i = 0;
	    for (; i < length - 3; i += 4) {
	      var num = maskNum ^ source.readUInt32LE(i, true);
	      if (num < 0) num = 4294967296 + num;
	      output.writeUInt32LE(num, offset + i, true);
	    }
	    switch (length % 4) {
	      case 3: output[offset + i + 2] = source[i + 2] ^ mask[2];
	      case 2: output[offset + i + 1] = source[i + 1] ^ mask[1];
	      case 1: output[offset + i] = source[i] ^ mask[0];
	      case 0:;
	    }
	  },
	  unmask: function(data, mask) {
	    var maskNum = mask.readUInt32LE(0, true);
	    var length = data.length;
	    var i = 0;
	    for (; i < length - 3; i += 4) {
	      var num = maskNum ^ data.readUInt32LE(i, true);
	      if (num < 0) num = 4294967296 + num;
	      data.writeUInt32LE(num, i, true);
	    }
	    switch (length % 4) {
	      case 3: data[i + 2] = data[i + 2] ^ mask[2];
	      case 2: data[i + 1] = data[i + 1] ^ mask[1];
	      case 1: data[i] = data[i] ^ mask[0];
	      case 0:;
	    }
	  }
	}


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var util = __webpack_require__(36);
	
	/**
	 * State constants
	 */
	
	var EMPTY = 0
	  , BODY = 1;
	var BINARYLENGTH = 2
	  , BINARYBODY = 3;
	
	/**
	 * Hixie Receiver implementation
	 */
	
	function Receiver () {
	  if (this instanceof Receiver === false) {
	    throw new TypeError("Classes can't be function-called");
	  }
	
	  this.state = EMPTY;
	  this.buffers = [];
	  this.messageEnd = -1;
	  this.spanLength = 0;
	  this.dead = false;
	
	  this.onerror = function() {};
	  this.ontext = function() {};
	  this.onbinary = function() {};
	  this.onclose = function() {};
	  this.onping = function() {};
	  this.onpong = function() {};
	}
	
	module.exports = Receiver;
	
	/**
	 * Add new data to the parser.
	 *
	 * @api public
	 */
	
	Receiver.prototype.add = function(data) {
	  if (this.dead) return;
	  var self = this;
	  function doAdd() {
	    if (self.state === EMPTY) {
	      if (data.length == 2 && data[0] == 0xFF && data[1] == 0x00) {
	        self.reset();
	        self.onclose();
	        return;
	      }
	      if (data[0] === 0x80) {
	        self.messageEnd = 0;
	        self.state = BINARYLENGTH;
	        data = data.slice(1);
	      } else {
	
	      if (data[0] !== 0x00) {
	        self.error('payload must start with 0x00 byte', true);
	        return;
	      }
	      data = data.slice(1);
	      self.state = BODY;
	
	      }
	    }
	    if (self.state === BINARYLENGTH) {
	      var i = 0;
	      while ((i < data.length) && (data[i] & 0x80)) {
	        self.messageEnd = 128 * self.messageEnd + (data[i] & 0x7f);
	        ++i;
	      }
	      if (i < data.length) {
	        self.messageEnd = 128 * self.messageEnd + (data[i] & 0x7f);
	        self.state = BINARYBODY;
	        ++i;
	      }
	      if (i > 0)
	        data = data.slice(i);
	    }
	    if (self.state === BINARYBODY) {
	      var dataleft = self.messageEnd - self.spanLength;
	      if (data.length >= dataleft) {
	        // consume the whole buffer to finish the frame
	        self.buffers.push(data);
	        self.spanLength += dataleft;
	        self.messageEnd = dataleft;
	        return self.parse();
	      }
	      // frame's not done even if we consume it all
	      self.buffers.push(data);
	      self.spanLength += data.length;
	      return;
	    }
	    self.buffers.push(data);
	    if ((self.messageEnd = bufferIndex(data, 0xFF)) != -1) {
	      self.spanLength += self.messageEnd;
	      return self.parse();
	    }
	    else self.spanLength += data.length;
	  }
	  while(data) data = doAdd();
	};
	
	/**
	 * Releases all resources used by the receiver.
	 *
	 * @api public
	 */
	
	Receiver.prototype.cleanup = function() {
	  this.dead = true;
	  this.state = EMPTY;
	  this.buffers = [];
	};
	
	/**
	 * Process buffered data.
	 *
	 * @api public
	 */
	
	Receiver.prototype.parse = function() {
	  var output = new Buffer(this.spanLength);
	  var outputIndex = 0;
	  for (var bi = 0, bl = this.buffers.length; bi < bl - 1; ++bi) {
	    var buffer = this.buffers[bi];
	    buffer.copy(output, outputIndex);
	    outputIndex += buffer.length;
	  }
	  var lastBuffer = this.buffers[this.buffers.length - 1];
	  if (this.messageEnd > 0) lastBuffer.copy(output, outputIndex, 0, this.messageEnd);
	  if (this.state !== BODY) --this.messageEnd;
	  var tail = null;
	  if (this.messageEnd < lastBuffer.length - 1) {
	    tail = lastBuffer.slice(this.messageEnd + 1);
	  }
	  this.reset();
	  this.ontext(output.toString('utf8'));
	  return tail;
	};
	
	/**
	 * Handles an error
	 *
	 * @api private
	 */
	
	Receiver.prototype.error = function (reason, terminate) {
	  if (this.dead) return;
	  this.reset();
	  if(typeof reason == 'string'){
	    this.onerror(new Error(reason), terminate);
	  }
	  else if(reason.constructor == Error){
	    this.onerror(reason, terminate);
	  }
	  else{
	    this.onerror(new Error("An error occured"),terminate);
	  }
	  return this;
	};
	
	/**
	 * Reset parser state
	 *
	 * @api private
	 */
	
	Receiver.prototype.reset = function (reason) {
	  if (this.dead) return;
	  this.state = EMPTY;
	  this.buffers = [];
	  this.messageEnd = -1;
	  this.spanLength = 0;
	};
	
	/**
	 * Internal api
	 */
	
	function bufferIndex(buffer, byte) {
	  for (var i = 0, l = buffer.length; i < l; ++i) {
	    if (buffer[i] === byte) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var events = __webpack_require__(70)
	  , util = __webpack_require__(36)
	  , EventEmitter = events.EventEmitter;
	
	/**
	 * Hixie Sender implementation
	 */
	
	function Sender(socket) {
	  if (this instanceof Sender === false) {
	    throw new TypeError("Classes can't be function-called");
	  }
	
	  events.EventEmitter.call(this);
	
	  this.socket = socket;
	  this.continuationFrame = false;
	  this.isClosed = false;
	}
	
	module.exports = Sender;
	
	/**
	 * Inherits from EventEmitter.
	 */
	
	util.inherits(Sender, events.EventEmitter);
	
	/**
	 * Frames and writes data.
	 *
	 * @api public
	 */
	
	Sender.prototype.send = function(data, options, cb) {
	  if (this.isClosed) return;
	
	  var isString = typeof data == 'string'
	    , length = isString ? Buffer.byteLength(data) : data.length
	    , lengthbytes = (length > 127) ? 2 : 1 // assume less than 2**14 bytes
	    , writeStartMarker = this.continuationFrame == false
	    , writeEndMarker = !options || !(typeof options.fin != 'undefined' && !options.fin)
	    , buffer = new Buffer((writeStartMarker ? ((options && options.binary) ? (1 + lengthbytes) : 1) : 0) + length + ((writeEndMarker && !(options && options.binary)) ? 1 : 0))
	    , offset = writeStartMarker ? 1 : 0;
	
	  if (writeStartMarker) {
	    if (options && options.binary) {
	      buffer.write('\x80', 'binary');
	      // assume length less than 2**14 bytes
	      if (lengthbytes > 1)
	        buffer.write(String.fromCharCode(128+length/128), offset++, 'binary');
	      buffer.write(String.fromCharCode(length&0x7f), offset++, 'binary');
	    } else
	      buffer.write('\x00', 'binary');
	  }
	
	  if (isString) buffer.write(data, offset, 'utf8');
	  else data.copy(buffer, offset, 0);
	
	  if (writeEndMarker) {
	    if (options && options.binary) {
	      // sending binary, not writing end marker
	    } else
	      buffer.write('\xff', offset + length, 'binary');
	    this.continuationFrame = false;
	  }
	  else this.continuationFrame = true;
	
	  try {
	    this.socket.write(buffer, 'binary', cb);
	  } catch (e) {
	    this.error(e.toString());
	  }
	};
	
	/**
	 * Sends a close instruction to the remote party.
	 *
	 * @api public
	 */
	
	Sender.prototype.close = function(code, data, mask, cb) {
	  if (this.isClosed) return;
	  this.isClosed = true;
	  try {
	    if (this.continuationFrame) this.socket.write(new Buffer([0xff], 'binary'));
	    this.socket.write(new Buffer([0xff, 0x00]), 'binary', cb);
	  } catch (e) {
	    this.error(e.toString());
	  }
	};
	
	/**
	 * Sends a ping message to the remote party. Not available for hixie.
	 *
	 * @api public
	 */
	
	Sender.prototype.ping = function(data, options) {};
	
	/**
	 * Sends a pong message to the remote party. Not available for hixie.
	 *
	 * @api public
	 */
	
	Sender.prototype.pong = function(data, options) {};
	
	/**
	 * Handles an error
	 *
	 * @api private
	 */
	
	Sender.prototype.error = function (reason) {
	  this.emit('error', reason);
	  return this;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

	/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	exports.Validation = {
	  isValidUTF8: function(buffer) {
	    return true;
	  }
	};


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var isValidUTF8;
	
	try {
	  isValidUTF8 = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"utf-8-validate\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	} catch (e) {
	  isValidUTF8 = __webpack_require__(1734);
	}
	
	module.exports = typeof isValidUTF8 === 'object'
	  ? isValidUTF8.Validation.isValidUTF8
	  : isValidUTF8;


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * ws: a node.js websocket client
	 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
	 * MIT Licensed
	 */
	
	var util = __webpack_require__(36)
	  , events = __webpack_require__(70)
	  , http = __webpack_require__(259)
	  , crypto = __webpack_require__(189)
	  , Options = __webpack_require__(527)
	  , WebSocket = __webpack_require__(585)
	  , Extensions = __webpack_require__(582)
	  , PerMessageDeflate = __webpack_require__(163)
	  , tls = __webpack_require__(525)
	  , url = __webpack_require__(261);
	
	/**
	 * WebSocket Server implementation
	 */
	
	function WebSocketServer(options, callback) {
	  if (this instanceof WebSocketServer === false) {
	    return new WebSocketServer(options, callback);
	  }
	
	  events.EventEmitter.call(this);
	
	  options = new Options({
	    host: '0.0.0.0',
	    port: null,
	    server: null,
	    verifyClient: null,
	    handleProtocols: null,
	    path: null,
	    noServer: false,
	    disableHixie: false,
	    clientTracking: true,
	    perMessageDeflate: true,
	    maxPayload: 100 * 1024 * 1024
	  }).merge(options);
	
	  if (!options.isDefinedAndNonNull('port') && !options.isDefinedAndNonNull('server') && !options.value.noServer) {
	    throw new TypeError('`port` or a `server` must be provided');
	  }
	
	  var self = this;
	
	  if (options.isDefinedAndNonNull('port')) {
	    this._server = http.createServer(function (req, res) {
	      var body = http.STATUS_CODES[426];
	      res.writeHead(426, {
	        'Content-Length': body.length,
	        'Content-Type': 'text/plain'
	      });
	      res.end(body);
	    });
	    this._server.allowHalfOpen = false;
	    this._server.listen(options.value.port, options.value.host, callback);
	    this._closeServer = function() { if (self._server) self._server.close(); };
	  }
	  else if (options.value.server) {
	    this._server = options.value.server;
	    if (options.value.path) {
	      // take note of the path, to avoid collisions when multiple websocket servers are
	      // listening on the same http server
	      if (this._server._webSocketPaths && options.value.server._webSocketPaths[options.value.path]) {
	        throw new Error('two instances of WebSocketServer cannot listen on the same http server path');
	      }
	      if (typeof this._server._webSocketPaths !== 'object') {
	        this._server._webSocketPaths = {};
	      }
	      this._server._webSocketPaths[options.value.path] = 1;
	    }
	  }
	  if (this._server) {
	    this._onceServerListening = function() { self.emit('listening'); };
	    this._server.once('listening', this._onceServerListening);
	  }
	
	  if (typeof this._server != 'undefined') {
	    this._onServerError = function(error) { self.emit('error', error) };
	    this._server.on('error', this._onServerError);
	    this._onServerUpgrade = function(req, socket, upgradeHead) {
	      //copy upgradeHead to avoid retention of large slab buffers used in node core
	      var head = new Buffer(upgradeHead.length);
	      upgradeHead.copy(head);
	
	      self.handleUpgrade(req, socket, head, function(client) {
	        self.emit('connection'+req.url, client);
	        self.emit('connection', client);
	      });
	    };
	    this._server.on('upgrade', this._onServerUpgrade);
	  }
	
	  this.options = options.value;
	  this.path = options.value.path;
	  this.clients = [];
	}
	
	/**
	 * Inherits from EventEmitter.
	 */
	
	util.inherits(WebSocketServer, events.EventEmitter);
	
	/**
	 * Immediately shuts down the connection.
	 *
	 * @api public
	 */
	
	WebSocketServer.prototype.close = function(callback) {
	  // terminate all associated clients
	  var error = null;
	  try {
	    for (var i = 0, l = this.clients.length; i < l; ++i) {
	      this.clients[i].terminate();
	    }
	  }
	  catch (e) {
	    error = e;
	  }
	
	  // remove path descriptor, if any
	  if (this.path && this._server._webSocketPaths) {
	    delete this._server._webSocketPaths[this.path];
	    if (Object.keys(this._server._webSocketPaths).length == 0) {
	      delete this._server._webSocketPaths;
	    }
	  }
	
	  // close the http server if it was internally created
	  try {
	    if (typeof this._closeServer !== 'undefined') {
	      this._closeServer();
	    }
	  }
	  finally {
	    if (this._server) {
	      this._server.removeListener('listening', this._onceServerListening);
	      this._server.removeListener('error', this._onServerError);
	      this._server.removeListener('upgrade', this._onServerUpgrade);
	    }
	    delete this._server;
	  }
	  if(callback)
	    callback(error);
	  else if(error)
	    throw error;
	}
	
	/**
	 * Handle a HTTP Upgrade request.
	 *
	 * @api public
	 */
	
	WebSocketServer.prototype.handleUpgrade = function(req, socket, upgradeHead, cb) {
	  // check for wrong path
	  if (this.options.path) {
	    var u = url.parse(req.url);
	    if (u && u.pathname !== this.options.path) return;
	  }
	
	  if (typeof req.headers.upgrade === 'undefined' || req.headers.upgrade.toLowerCase() !== 'websocket') {
	    abortConnection(socket, 400, 'Bad Request');
	    return;
	  }
	
	  if (req.headers['sec-websocket-key1']) handleHixieUpgrade.apply(this, arguments);
	  else handleHybiUpgrade.apply(this, arguments);
	}
	
	module.exports = WebSocketServer;
	
	/**
	 * Entirely private apis,
	 * which may or may not be bound to a sepcific WebSocket instance.
	 */
	
	function handleHybiUpgrade(req, socket, upgradeHead, cb) {
	  // handle premature socket errors
	  var errorHandler = function() {
	    try { socket.destroy(); } catch (e) {}
	  }
	  socket.on('error', errorHandler);
	
	  // verify key presence
	  if (!req.headers['sec-websocket-key']) {
	    abortConnection(socket, 400, 'Bad Request');
	    return;
	  }
	
	  // verify version
	  var version = parseInt(req.headers['sec-websocket-version']);
	  if ([8, 13].indexOf(version) === -1) {
	    abortConnection(socket, 400, 'Bad Request');
	    return;
	  }
	
	  // verify protocol
	  var protocols = req.headers['sec-websocket-protocol'];
	
	  // verify client
	  var origin = version < 13 ?
	    req.headers['sec-websocket-origin'] :
	    req.headers['origin'];
	
	  // handle extensions offer
	  var extensionsOffer = Extensions.parse(req.headers['sec-websocket-extensions']);
	
	  // handler to call when the connection sequence completes
	  var self = this;
	  var completeHybiUpgrade2 = function(protocol) {
	
	    // calc key
	    var key = req.headers['sec-websocket-key'];
	    var shasum = crypto.createHash('sha1');
	    shasum.update(key + "258EAFA5-E914-47DA-95CA-C5AB0DC85B11");
	    key = shasum.digest('base64');
	
	    var headers = [
	        'HTTP/1.1 101 Switching Protocols'
	      , 'Upgrade: websocket'
	      , 'Connection: Upgrade'
	      , 'Sec-WebSocket-Accept: ' + key
	    ];
	
	    if (typeof protocol != 'undefined') {
	      headers.push('Sec-WebSocket-Protocol: ' + protocol);
	    }
	
	    var extensions = {};
	    try {
	      extensions = acceptExtensions.call(self, extensionsOffer);
	    } catch (err) {
	      abortConnection(socket, 400, 'Bad Request');
	      return;
	    }
	
	    if (Object.keys(extensions).length) {
	      var serverExtensions = {};
	      Object.keys(extensions).forEach(function(token) {
	        serverExtensions[token] = [extensions[token].params]
	      });
	      headers.push('Sec-WebSocket-Extensions: ' + Extensions.format(serverExtensions));
	    }
	
	    // allows external modification/inspection of handshake headers
	    self.emit('headers', headers);
	
	    socket.setTimeout(0);
	    socket.setNoDelay(true);
	    try {
	      socket.write(headers.concat('', '').join('\r\n'));
	    }
	    catch (e) {
	      // if the upgrade write fails, shut the connection down hard
	      try { socket.destroy(); } catch (e) {}
	      return;
	    }
	
	    var client = new WebSocket([req, socket, upgradeHead], {
	      protocolVersion: version,
	      protocol: protocol,
	      extensions: extensions,
	      maxPayload: self.options.maxPayload
	    });
	
	    if (self.options.clientTracking) {
	      self.clients.push(client);
	      client.on('close', function() {
	        var index = self.clients.indexOf(client);
	        if (index != -1) {
	          self.clients.splice(index, 1);
	        }
	      });
	    }
	
	    // signal upgrade complete
	    socket.removeListener('error', errorHandler);
	    cb(client);
	  }
	
	  // optionally call external protocol selection handler before
	  // calling completeHybiUpgrade2
	  var completeHybiUpgrade1 = function() {
	    // choose from the sub-protocols
	    if (typeof self.options.handleProtocols == 'function') {
	        var protList = (protocols || "").split(/, */);
	        var callbackCalled = false;
	        var res = self.options.handleProtocols(protList, function(result, protocol) {
	          callbackCalled = true;
	          if (!result) abortConnection(socket, 401, 'Unauthorized');
	          else completeHybiUpgrade2(protocol);
	        });
	        if (!callbackCalled) {
	            // the handleProtocols handler never called our callback
	            abortConnection(socket, 501, 'Could not process protocols');
	        }
	        return;
	    } else {
	        if (typeof protocols !== 'undefined') {
	            completeHybiUpgrade2(protocols.split(/, */)[0]);
	        }
	        else {
	            completeHybiUpgrade2();
	        }
	    }
	  }
	
	  // optionally call external client verification handler
	  if (typeof this.options.verifyClient == 'function') {
	    var info = {
	      origin: origin,
	      secure: typeof req.connection.authorized !== 'undefined' || typeof req.connection.encrypted !== 'undefined',
	      req: req
	    };
	    if (this.options.verifyClient.length == 2) {
	      this.options.verifyClient(info, function(result, code, name) {
	        if (typeof code === 'undefined') code = 401;
	        if (typeof name === 'undefined') name = http.STATUS_CODES[code];
	
	        if (!result) abortConnection(socket, code, name);
	        else completeHybiUpgrade1();
	      });
	      return;
	    }
	    else if (!this.options.verifyClient(info)) {
	      abortConnection(socket, 401, 'Unauthorized');
	      return;
	    }
	  }
	
	  completeHybiUpgrade1();
	}
	
	function handleHixieUpgrade(req, socket, upgradeHead, cb) {
	  // handle premature socket errors
	  var errorHandler = function() {
	    try { socket.destroy(); } catch (e) {}
	  }
	  socket.on('error', errorHandler);
	
	  // bail if options prevent hixie
	  if (this.options.disableHixie) {
	    abortConnection(socket, 401, 'Hixie support disabled');
	    return;
	  }
	
	  // verify key presence
	  if (!req.headers['sec-websocket-key2']) {
	    abortConnection(socket, 400, 'Bad Request');
	    return;
	  }
	
	  var origin = req.headers['origin']
	    , self = this;
	
	  // setup handshake completion to run after client has been verified
	  var onClientVerified = function() {
	    var wshost;
	    if (!req.headers['x-forwarded-host'])
	        wshost = req.headers.host;
	    else
	        wshost = req.headers['x-forwarded-host'];
	    var location = ((req.headers['x-forwarded-proto'] === 'https' || socket.encrypted) ? 'wss' : 'ws') + '://' + wshost + req.url
	      , protocol = req.headers['sec-websocket-protocol'];
	
	    // build the response header and return a Buffer
	    var buildResponseHeader = function() {
	      var headers = [
	          'HTTP/1.1 101 Switching Protocols'
	        , 'Upgrade: WebSocket'
	        , 'Connection: Upgrade'
	        , 'Sec-WebSocket-Location: ' + location
	      ];
	      if (typeof protocol != 'undefined') headers.push('Sec-WebSocket-Protocol: ' + protocol);
	      if (typeof origin != 'undefined') headers.push('Sec-WebSocket-Origin: ' + origin);
	
	      return new Buffer(headers.concat('', '').join('\r\n'));
	    };
	
	    // send handshake response before receiving the nonce
	    var handshakeResponse = function() {
	
	      socket.setTimeout(0);
	      socket.setNoDelay(true);
	
	      var headerBuffer = buildResponseHeader();
	
	      try {
	        socket.write(headerBuffer, 'binary', function(err) {
	          // remove listener if there was an error
	          if (err) socket.removeListener('data', handler);
	          return;
	        });
	      } catch (e) {
	        try { socket.destroy(); } catch (e) {}
	        return;
	      };
	    };
	
	    // handshake completion code to run once nonce has been successfully retrieved
	    var completeHandshake = function(nonce, rest, headerBuffer) {
	      // calculate key
	      var k1 = req.headers['sec-websocket-key1']
	        , k2 = req.headers['sec-websocket-key2']
	        , md5 = crypto.createHash('md5');
	
	      [k1, k2].forEach(function (k) {
	        var n = parseInt(k.replace(/[^\d]/g, ''))
	          , spaces = k.replace(/[^ ]/g, '').length;
	        if (spaces === 0 || n % spaces !== 0){
	          abortConnection(socket, 400, 'Bad Request');
	          return;
	        }
	        n /= spaces;
	        md5.update(String.fromCharCode(
	          n >> 24 & 0xFF,
	          n >> 16 & 0xFF,
	          n >> 8  & 0xFF,
	          n       & 0xFF));
	      });
	      md5.update(nonce.toString('binary'));
	
	      socket.setTimeout(0);
	      socket.setNoDelay(true);
	
	      try {
	        var hashBuffer = new Buffer(md5.digest('binary'), 'binary');
	        var handshakeBuffer = new Buffer(headerBuffer.length + hashBuffer.length);
	        headerBuffer.copy(handshakeBuffer, 0);
	        hashBuffer.copy(handshakeBuffer, headerBuffer.length);
	
	        // do a single write, which - upon success - causes a new client websocket to be setup
	        socket.write(handshakeBuffer, 'binary', function(err) {
	          if (err) return; // do not create client if an error happens
	          var client = new WebSocket([req, socket, rest], {
	            protocolVersion: 'hixie-76',
	            protocol: protocol
	          });
	          if (self.options.clientTracking) {
	            self.clients.push(client);
	            client.on('close', function() {
	              var index = self.clients.indexOf(client);
	              if (index != -1) {
	                self.clients.splice(index, 1);
	              }
	            });
	          }
	
	          // signal upgrade complete
	          socket.removeListener('error', errorHandler);
	          cb(client);
	        });
	      }
	      catch (e) {
	        try { socket.destroy(); } catch (e) {}
	        return;
	      }
	    }
	
	    // retrieve nonce
	    var nonceLength = 8;
	    if (upgradeHead && upgradeHead.length >= nonceLength) {
	      var nonce = upgradeHead.slice(0, nonceLength);
	      var rest = upgradeHead.length > nonceLength ? upgradeHead.slice(nonceLength) : null;
	      completeHandshake.call(self, nonce, rest, buildResponseHeader());
	    }
	    else {
	      // nonce not present in upgradeHead
	      var nonce = new Buffer(nonceLength);
	      upgradeHead.copy(nonce, 0);
	      var received = upgradeHead.length;
	      var rest = null;
	      var handler = function (data) {
	        var toRead = Math.min(data.length, nonceLength - received);
	        if (toRead === 0) return;
	        data.copy(nonce, received, 0, toRead);
	        received += toRead;
	        if (received == nonceLength) {
	          socket.removeListener('data', handler);
	          if (toRead < data.length) rest = data.slice(toRead);
	
	          // complete the handshake but send empty buffer for headers since they have already been sent
	          completeHandshake.call(self, nonce, rest, new Buffer(0));
	        }
	      }
	
	      // handle additional data as we receive it
	      socket.on('data', handler);
	
	      // send header response before we have the nonce to fix haproxy buffering
	      handshakeResponse();
	    }
	  }
	
	  // verify client
	  if (typeof this.options.verifyClient == 'function') {
	    var info = {
	      origin: origin,
	      secure: typeof req.connection.authorized !== 'undefined' || typeof req.connection.encrypted !== 'undefined',
	      req: req
	    };
	    if (this.options.verifyClient.length == 2) {
	      var self = this;
	      this.options.verifyClient(info, function(result, code, name) {
	        if (typeof code === 'undefined') code = 401;
	        if (typeof name === 'undefined') name = http.STATUS_CODES[code];
	
	        if (!result) abortConnection(socket, code, name);
	        else onClientVerified.apply(self);
	      });
	      return;
	    }
	    else if (!this.options.verifyClient(info)) {
	      abortConnection(socket, 401, 'Unauthorized');
	      return;
	    }
	  }
	
	  // no client verification required
	  onClientVerified();
	}
	
	function acceptExtensions(offer) {
	  var extensions = {};
	  var options = this.options.perMessageDeflate;
	  var maxPayload = this.options.maxPayload;
	  if (options && offer[PerMessageDeflate.extensionName]) {
	    var perMessageDeflate = new PerMessageDeflate(options !== true ? options : {}, true, maxPayload);
	    perMessageDeflate.accept(offer[PerMessageDeflate.extensionName]);
	    extensions[PerMessageDeflate.extensionName] = perMessageDeflate;
	  }
	  return extensions;
	}
	
	function abortConnection(socket, code, name) {
	  try {
	    var response = [
	      'HTTP/1.1 ' + code + ' ' + name,
	      'Content-type: text/html'
	    ];
	    socket.write(response.concat('', '').join('\r\n'));
	  }
	  catch (e) { /* ignore errors - we've aborted this connection */ }
	  finally {
	    // ensure that an early aborted connection is shut down completely
	    try { socket.destroy(); } catch (e) {}
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).Buffer))

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1739 */
1738,
/* 1740 */
1738,
/* 1741 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(__webpack_module_template_argument_0__);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(__webpack_module_template_argument_1__);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(28)))

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
]);


// WEBPACK FOOTER //
// bundle.190d3a0a92eaf8c59155.js